
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4c1f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4c1f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6gsYs", function(module, exports) {
parcelRequire("hZgFJ");
var $jW02B = parcelRequire("jW02B");
parcelRequire("1YqIQ");

var $ab2A8 = parcelRequire("ab2A8");
const player = document.getElementById("player");
const playButton = document.getElementById("play");
const stopButton = document.getElementById("stop");
const inspectButton = document.getElementById("inspect");
const setAttr = document.getElementById("set");
const removeAttr = document.getElementById("remove");
const attr = document.getElementById("attr");
const value = document.getElementById("value");
const logLevelSelect = document.getElementById("log_level");
const version = document.getElementById("version");
let isInspectorInitialized = false;


async function initInspector() {
    if (isInspectorInitialized) return;
    isInspectorInitialized = true;
    await Promise.resolve((parcelRequire("gRt7v")));
    await (parcelRequire("cKy8N"));
}
async function inspect() {
    await initInspector();
    if (player.engine.scenes[0].debugLayer.isVisible()) player.engine.scenes[0].debugLayer.hide();
    else await player.engine.scenes[0].debugLayer.show({
        embedMode: true,
        overlay: true,
        handleResize: true,
        enablePopup: true,
        showInspector: true,
        globalRoot: document.body
    });
}
function save() {
    const data = {};
    for(let i = 0; i < player.attributes.length; i++){
        const a = player.attributes.item(i);
        if (a && a.name !== "id") data[a.name] = a.value;
    }
    localStorage.setItem("playerdata", JSON.stringify(data));
}
function load() {
    const json = localStorage.getItem("playerdata");
    if (json) {
        const data = JSON.parse(json);
        for(const k in data)player.setAttribute(k, data[k]);
    }
}
function readParams() {
    const params = new URLSearchParams(document.location.search);
    if (params.has("url")) player.src = decodeURI(params.get("url"));
    if (params.has("pt")) player.passthroughToken = params.get("pt");
    if (params.has("mask")) player.includeMask = params.has("mask");
    if (params.has("fmp4")) player.fmp4ProtocolVersion = (0, $jW02B.FMP4ProtocolVersion)[params.get("fmp4")];
}
async function play() {
    await player.play();
}
async function stop() {
    await player.stop();
}
playButton.addEventListener("click", play);
stopButton.addEventListener("click", stop);
inspectButton.addEventListener("click", inspect);
setAttr.addEventListener("click", ()=>{
    player.setAttribute(attr.value, value.value);
});
removeAttr.addEventListener("click", ()=>{
    player.removeAttribute(attr.value);
});
logLevelSelect.addEventListener("change", ()=>{
    (0, $jW02B.Log).level = logLevelSelect.selectedIndex;
});
window.addEventListener("unload", save);
load();
readParams();
version.innerHTML = (0, $ab2A8.Version);
const m = module;
if (m.hot) m.hot.accept(()=>{
    location.reload();
});

});
parcelRegister("hZgFJ", function(module, exports) {
$parcel$export(module.exports, "FMP4ProtocolVersion", () => (parcelRequire("jW02B")).FMP4ProtocolVersion);
$parcel$export(module.exports, "Log", () => (parcelRequire("jW02B")).Log);

var $jOCUE = parcelRequire("jOCUE");

var $jW02B = parcelRequire("jW02B");
parcelRequire("3ztn0");
var $d18510eb7acc8157$var$v = Object.create;
var $d18510eb7acc8157$var$k = Object.defineProperty;
var $d18510eb7acc8157$var$I = Object.getOwnPropertyDescriptor;
var $d18510eb7acc8157$var$E = Object.getOwnPropertyNames;
var $d18510eb7acc8157$var$W = Object.getPrototypeOf, $d18510eb7acc8157$var$P = Object.prototype.hasOwnProperty;
var $d18510eb7acc8157$var$y = (s, e)=>()=>(e || s((e = {
            exports: {}
        }).exports, e), e.exports);
var $d18510eb7acc8157$var$D = (s, e, r, t)=>{
    if (e && typeof e == "object" || typeof e == "function") for (let a of $d18510eb7acc8157$var$E(e))!$d18510eb7acc8157$var$P.call(s, a) && a !== r && $d18510eb7acc8157$var$k(s, a, {
        get: ()=>e[a],
        enumerable: !(t = $d18510eb7acc8157$var$I(e, a)) || t.enumerable
    });
    return s;
};
var $d18510eb7acc8157$var$C = (s, e, r)=>(r = s != null ? $d18510eb7acc8157$var$v($d18510eb7acc8157$var$W(s)) : {}, $d18510eb7acc8157$var$D(e || !s || !s.__esModule ? $d18510eb7acc8157$var$k(r, "default", {
        value: s,
        enumerable: !0
    }) : r, s));
var $d18510eb7acc8157$var$_ = $d18510eb7acc8157$var$y((G, T)=>{
    "use strict";
    var m = class {
        constructor(){
            Object.defineProperty(this, "__listeners", {
                value: {},
                enumerable: !1,
                writable: !1
            });
        }
        emit(e, ...r) {
            if (!this.__listeners[e]) return this;
            for (let t of this.__listeners[e])t(...r);
            return this;
        }
        once(e, r) {
            let t = (...a)=>{
                this.off(e, t), r(...a);
            };
            return this.on(e, t);
        }
        on(e, r) {
            return this.__listeners[e] || (this.__listeners[e] = []), this.__listeners[e].push(r), this;
        }
        off(e, r) {
            return r ? this.__listeners[e] = this.__listeners[e].filter((t)=>t !== r) : this.__listeners[e] = [], this;
        }
    };
    T.exports = m;
});
var $d18510eb7acc8157$var$w = $d18510eb7acc8157$var$y((z, b)=>{
    "use strict";
    var x = $d18510eb7acc8157$var$_(), O = 0, R = 1, L = 1, h = class extends x {
        constructor(e){
            super(), this._messageId = 1, this._messages = new Map, this._worker = e, this._worker.onmessage = this._onMessage.bind(this), this._id = Math.ceil(Math.random() * 1e7);
        }
        terminate() {
            this._worker.terminate();
        }
        isFree() {
            return this._messages.size === 0;
        }
        jobsLength() {
            return this._messages.size;
        }
        exec(e, r = null, t = [], a) {
            return new Promise((o, i)=>{
                let g = this._messageId++;
                this._messages.set(g, [
                    o,
                    i,
                    a
                ]), this._worker.postMessage([
                    g,
                    r,
                    e
                ], t || []);
            });
        }
        postMessage(e = null, r = [], t) {
            return new Promise((a, o)=>{
                let i = this._messageId++;
                this._messages.set(i, [
                    a,
                    o,
                    t
                ]), this._worker.postMessage([
                    i,
                    e
                ], r || []);
            });
        }
        emit(e, ...r) {
            this._worker.postMessage({
                eventName: e,
                args: r
            });
        }
        _onMessage(e) {
            if (!Array.isArray(e.data) && e.data.eventName) return super.emit(e.data.eventName, ...e.data.args);
            let [r, ...t] = e.data;
            if (r === R) this._onEvent(...t);
            else if (r === O) this._onResult(...t);
            else throw new Error(`Wrong message type '${r}'`);
        }
        _onResult(e, r, t) {
            let [a, o] = this._messages.get(e);
            return this._messages.delete(e), r === L ? a(t) : o(t);
        }
        _onEvent(e, r, t) {
            let [, , a] = this._messages.get(e);
            a && a(r, t);
        }
    };
    b.exports = h;
});
var $d18510eb7acc8157$var$n = class {
    type;
    property;
    value;
    constructor(e, r, t){
        this.type = e, this.property = r, this.value = t;
    }
}, $d18510eb7acc8157$var$l = class extends $d18510eb7acc8157$var$n {
    constructor(e, r){
        super("command", e, r);
    }
}, $d18510eb7acc8157$var$d = class extends $d18510eb7acc8157$var$n {
    constructor(e, r){
        super("info", e, r);
    }
}, $d18510eb7acc8157$var$u = class {
    type = "get";
    property;
    constructor(e){
        this.property = e;
    }
}, $d18510eb7acc8157$var$c = class {
    type = "set";
    property;
    value;
    constructor(e, r){
        this.property = e, this.value = r;
    }
};
var $d18510eb7acc8157$var$S = $d18510eb7acc8157$var$C($d18510eb7acc8157$var$w(), 1), $d18510eb7acc8157$export$3b6e11c883f4a313 = class {
    _worker = null;
    _handlers = new Map;
    constructor(e){
        this._worker = new $d18510eb7acc8157$var$S.default(e);
    }
    terminate() {
        this._worker?.terminate(), this._worker = null;
    }
    async postCommand(e, r, ...t) {
        await this._worker?.postMessage(new $d18510eb7acc8157$var$l(e, r), t);
    }
    async postInfo(e, r) {
        await this._worker?.postMessage(new $d18510eb7acc8157$var$d(e, r));
    }
    async get(e) {
        return await this._worker?.postMessage(new $d18510eb7acc8157$var$u(e));
    }
    async set(e, r) {
        await this._worker?.postMessage(new $d18510eb7acc8157$var$c(e, r));
    }
    getHandler(e) {
        return (r)=>{
            if (r !== null) {
                let t = Object.keys(r), a = t.length == 2 && t.includes("payload") && t.includes("transferable");
                e(a ? r.payload : r);
            } else e(r);
        };
    }
    addInfoListener(e, r) {
        let t = this.getHandler(r);
        this._handlers.set(e, t), this._worker?.on(e, t);
    }
    removeInfoListener(e) {
        let r = this._handlers.get(e);
        r && this._worker?.off(e, r), this._handlers.delete(e);
    }
};

var $d18510eb7acc8157$export$bcac460d4cd9cb69 = class s extends (0, (/*@__PURE__*/$parcel$interopDefault($jOCUE))) {
    static _internalWorkers = new Map;
    static _workers = new Map;
    _url = "";
    _sourceObject = null;
    _playerId;
    constructor(e){
        super(), this._playerId = e;
    }
    get worker() {
        if (s._workers.has(this._playerId)) return s._workers.get(this._playerId);
        s._internalWorkers.has(this._playerId) || s._internalWorkers.set(this._playerId, new Worker((parcelRequire("8AeNp"))));
        let e = new $d18510eb7acc8157$export$3b6e11c883f4a313(s._internalWorkers.get(this._playerId));
        return s._workers.set(this._playerId, e), e;
    }
    get name() {
        return "DedicatedWorker";
    }
    get hasSourceBuffer() {
        return this.get("hasSourceBuffer", !1);
    }
    get canUpdateSourceBuffer() {
        return this.get("canUpdateSourceBuffer", !1);
    }
    get sourceObject() {
        return this._sourceObject;
    }
    get expectedBuffer() {
        return this.get("expectedBuffer", 0);
    }
    get isComplete() {
        return this.get("isComplete", !1);
    }
    get bufferMax() {
        return this.get("bufferMax", void 0);
    }
    get passthroughToken() {
        return this.get("passthroughToken", "");
    }
    set passthroughToken(e) {
        this.worker.set("passthroughToken", e);
    }
    get includeMask() {
        return this.get("includeMask", !1);
    }
    set includeMask(e) {
        this.worker.set("includeMask", e);
    }
    get fmp4ProtocolVersion() {
        return this.get("fmp4ProtocolVersion", (0, $jW02B.FMP4ProtocolVersion).V4);
    }
    set fmp4ProtocolVersion(e) {
        this.worker.set("fmp4ProtocolVersion", e);
    }
    async get(e, r) {
        return this.worker === null ? r : await this.worker.get(e);
    }
    _eventHandler = (e)=>this.handleEvent(e.event, e.data);
    _errorHandler = (e)=>this.handleError(e.error, e.message);
    _sourceChangedHandler = (e)=>{
        this._sourceObject = e, this.emit((0, $jW02B.StreamMediaSourceEvents).SOURCE_CHANGED);
    };
    createWorker() {
        this.worker.addInfoListener("handleEvent", this._eventHandler), this.worker.addInfoListener("handleError", this._errorHandler), this.worker.addInfoListener("sourceObject", this._sourceChangedHandler);
    }
    disposeWorker() {
        this.worker.removeInfoListener("handleEvent"), this.worker.removeInfoListener("handleError"), this.worker.removeInfoListener("sourceObject");
    }
    handleEvent(e, ...r) {
        this.emit(e, ...r);
    }
    handleError(e, r) {
        this.emit((0, $jW02B.StreamMediaSourceEvents).ERROR, r, e);
    }
    async setSource(e, ...r) {
        this.createWorker(), await this.worker.postCommand("setSource", {
            url: e,
            capabilityChecks: r
        }), this._url = e;
    }
    async init(e) {
        await this.worker.postCommand("init", e);
    }
    async removeSource() {
        await this.worker.postCommand("removeSource", null), this.disposeWorker();
    }
    async resetSource() {
        await this.worker.postCommand("resetSource", this._url);
    }
    async advanceSourceBuffer(e) {
        await this.worker.postCommand("advanceSourceBuffer", e);
    }
    async seek(e, r) {
        await this.worker.postCommand("seek", {
            currentTime: e,
            time: r
        });
    }
    async endOfStream() {
        await this.worker.postCommand("endOfStream", null);
    }
    async dispose() {
        this.worker.terminate(), s._workers.delete(this._playerId);
    }
    async setCrossOrigin(e) {
        await this.worker.postCommand("setCrossOrigin", e);
    }
};
(0, $jW02B.StreamMediaSourceWrapperFactory).Register({
    ctor: $d18510eb7acc8157$export$bcac460d4cd9cb69,
    isSupported: ()=>{
        if (typeof globalThis > "u" || globalThis.Worker === void 0) return !1;
        let s = navigator.userAgent || navigator.vendor;
        return /iphone/i.test(s) ? !1 : globalThis.MediaSource !== void 0 ? "canConstructInDedicatedWorker" in globalThis.MediaSource && MediaSource.canConstructInDedicatedWorker === !0 : "ManagedMediaSource" in globalThis ? "canConstructInDedicatedWorker" in globalThis.ManagedMediaSource && globalThis.ManagedMediaSource.canConstructInDedicatedWorker === !0 : !1;
    },
    name: "DedicatedWorker"
});

});
parcelRegister("jOCUE", function(module, exports) {
'use strict';
var $e6d0df1523c6d3ec$var$has = Object.prototype.hasOwnProperty, $e6d0df1523c6d3ec$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $e6d0df1523c6d3ec$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $e6d0df1523c6d3ec$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $e6d0df1523c6d3ec$var$Events().__proto__) $e6d0df1523c6d3ec$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $e6d0df1523c6d3ec$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $e6d0df1523c6d3ec$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $e6d0df1523c6d3ec$var$EE(fn, context || emitter, once), evt = $e6d0df1523c6d3ec$var$prefix ? $e6d0df1523c6d3ec$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $e6d0df1523c6d3ec$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $e6d0df1523c6d3ec$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $e6d0df1523c6d3ec$var$EventEmitter() {
    this._events = new $e6d0df1523c6d3ec$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $e6d0df1523c6d3ec$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($e6d0df1523c6d3ec$var$has.call(events, name)) names.push($e6d0df1523c6d3ec$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $e6d0df1523c6d3ec$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $e6d0df1523c6d3ec$var$prefix ? $e6d0df1523c6d3ec$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $e6d0df1523c6d3ec$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $e6d0df1523c6d3ec$var$prefix ? $e6d0df1523c6d3ec$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $e6d0df1523c6d3ec$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $e6d0df1523c6d3ec$var$prefix ? $e6d0df1523c6d3ec$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $e6d0df1523c6d3ec$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $e6d0df1523c6d3ec$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $e6d0df1523c6d3ec$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $e6d0df1523c6d3ec$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $e6d0df1523c6d3ec$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $e6d0df1523c6d3ec$var$prefix ? $e6d0df1523c6d3ec$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $e6d0df1523c6d3ec$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $e6d0df1523c6d3ec$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $e6d0df1523c6d3ec$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $e6d0df1523c6d3ec$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $e6d0df1523c6d3ec$var$prefix ? $e6d0df1523c6d3ec$var$prefix + event : event;
        if (this._events[evt]) $e6d0df1523c6d3ec$var$clearEvent(this, evt);
    } else {
        this._events = new $e6d0df1523c6d3ec$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$e6d0df1523c6d3ec$var$EventEmitter.prototype.off = $e6d0df1523c6d3ec$var$EventEmitter.prototype.removeListener;
$e6d0df1523c6d3ec$var$EventEmitter.prototype.addListener = $e6d0df1523c6d3ec$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$e6d0df1523c6d3ec$var$EventEmitter.prefixed = $e6d0df1523c6d3ec$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$e6d0df1523c6d3ec$var$EventEmitter.EventEmitter = $e6d0df1523c6d3ec$var$EventEmitter;
module.exports = $e6d0df1523c6d3ec$var$EventEmitter;

});

parcelRegister("jW02B", function(module, exports) {

$parcel$export(module.exports, "Errors", () => $e833773b1f4e7d0f$export$b8e9cd941e8016ac);
$parcel$export(module.exports, "Events", () => $e833773b1f4e7d0f$export$ada873a34909da65);
$parcel$export(module.exports, "Status", () => $e833773b1f4e7d0f$export$96e9906d6d93a972);
$parcel$export(module.exports, "BuiltInTrackTypes", () => $e833773b1f4e7d0f$export$b315772e2ea5165e);
$parcel$export(module.exports, "waitUntilAsync", () => $e833773b1f4e7d0f$export$7c9e1d487e9f2bc0);
$parcel$export(module.exports, "waitUntilCancelleableAsync", () => $e833773b1f4e7d0f$export$e11603d565eb502f);
$parcel$export(module.exports, "makePromise", () => $e833773b1f4e7d0f$export$1625492ec82002b9);
$parcel$export(module.exports, "getContentType", () => $e833773b1f4e7d0f$export$1ef77878e4e0b972);
$parcel$export(module.exports, "CapabilityCheck", () => $e833773b1f4e7d0f$export$a0dc6448a77581eb);
$parcel$export(module.exports, "CapabilitiesChecker", () => $e833773b1f4e7d0f$export$850b3343ef1018ff);
$parcel$export(module.exports, "StreamType", () => $e833773b1f4e7d0f$export$c7986f8afdb111ee);
$parcel$export(module.exports, "Log", () => $e833773b1f4e7d0f$export$ce30dbb46644d06c);
$parcel$export(module.exports, "LogInternal", () => $e833773b1f4e7d0f$export$57519a39c3119ec1);
$parcel$export(module.exports, "Mutex", () => $e833773b1f4e7d0f$export$ca12f2943758ef55);
$parcel$export(module.exports, "SlidingWindow", () => $e833773b1f4e7d0f$export$328341dfbad2f46d);
$parcel$export(module.exports, "FMP4ProtocolVersion", () => $e833773b1f4e7d0f$export$aa8676fc676da4a1);
$parcel$export(module.exports, "PlayerNodeFactory", () => $e833773b1f4e7d0f$export$f82961e691216dba);
$parcel$export(module.exports, "StreamDataSourceFactory", () => $e833773b1f4e7d0f$export$cb8dde19db6bb34a);
$parcel$export(module.exports, "Parser", () => $e833773b1f4e7d0f$export$7acfa6ed01010e37);
$parcel$export(module.exports, "isMultiVariant", () => $e833773b1f4e7d0f$export$ee6b3261831ac136);
$parcel$export(module.exports, "isRegularPlaylist", () => $e833773b1f4e7d0f$export$cb08cd3f248be4de);
$parcel$export(module.exports, "StreamMediaSourceEvents", () => $e833773b1f4e7d0f$export$c5a1576c045df4a8);
$parcel$export(module.exports, "StreamMediaSourceWrapperEvents", () => $e833773b1f4e7d0f$export$66383d53cd2ff2e0);
$parcel$export(module.exports, "StreamMediaSourceWrapper", () => $e833773b1f4e7d0f$export$c514de6cdde151fc);
$parcel$export(module.exports, "StreamMediaSourceWrapperFactory", () => $e833773b1f4e7d0f$export$d1c93d4fd30bfb17);
$parcel$export(module.exports, "TrackConfigType", () => $e833773b1f4e7d0f$export$9277330a1db15539);

var $jOCUE = parcelRequire("jOCUE");
var $e833773b1f4e7d0f$var$Ou = Object.create;
var $e833773b1f4e7d0f$var$yr = Object.defineProperty;
var $e833773b1f4e7d0f$var$Lu = Object.getOwnPropertyDescriptor;
var $e833773b1f4e7d0f$var$Nu = Object.getOwnPropertyNames;
var $e833773b1f4e7d0f$var$zu = Object.getPrototypeOf, $e833773b1f4e7d0f$var$Gu = Object.prototype.hasOwnProperty;
var $e833773b1f4e7d0f$var$v = (i, e)=>()=>(e || i((e = {
            exports: {}
        }).exports, e), e.exports);
var $e833773b1f4e7d0f$var$Vu = (i, e, t, s)=>{
    if (e && typeof e == "object" || typeof e == "function") for (let r of $e833773b1f4e7d0f$var$Nu(e))!$e833773b1f4e7d0f$var$Gu.call(i, r) && r !== t && $e833773b1f4e7d0f$var$yr(i, r, {
        get: ()=>e[r],
        enumerable: !(s = $e833773b1f4e7d0f$var$Lu(e, r)) || s.enumerable
    });
    return i;
};
var $e833773b1f4e7d0f$var$Hu = (i, e, t)=>(t = i != null ? $e833773b1f4e7d0f$var$Ou($e833773b1f4e7d0f$var$zu(i)) : {}, $e833773b1f4e7d0f$var$Vu(e || !i || !i.__esModule ? $e833773b1f4e7d0f$var$yr(t, "default", {
        value: i,
        enumerable: !0
    }) : t, i));
var $e833773b1f4e7d0f$var$te = $e833773b1f4e7d0f$var$v((sT, Bn)=>{
    "use strict";
    var Oe = function() {
        this.init = function() {
            var e = {};
            this.on = function(t, s) {
                e[t] || (e[t] = []), e[t] = e[t].concat(s);
            }, this.off = function(t, s) {
                var r;
                return e[t] ? (r = e[t].indexOf(s), e[t] = e[t].slice(), e[t].splice(r, 1), r > -1) : !1;
            }, this.trigger = function(t) {
                var s, r, n, a;
                if (s = e[t], !!s) {
                    if (arguments.length === 2) for(n = s.length, r = 0; r < n; ++r)s[r].call(this, arguments[1]);
                    else {
                        for(a = [], r = arguments.length, r = 1; r < arguments.length; ++r)a.push(arguments[r]);
                        for(n = s.length, r = 0; r < n; ++r)s[r].apply(this, a);
                    }
                }
            }, this.dispose = function() {
                e = {};
            };
        };
    };
    Oe.prototype.pipe = function(i) {
        return this.on("data", function(e) {
            i.push(e);
        }), this.on("done", function(e) {
            i.flush(e);
        }), this.on("partialdone", function(e) {
            i.partialFlush(e);
        }), this.on("endedtimeline", function(e) {
            i.endTimeline(e);
        }), this.on("reset", function(e) {
            i.reset(e);
        }), i;
    };
    Oe.prototype.push = function(i) {
        this.trigger("data", i);
    };
    Oe.prototype.flush = function(i) {
        this.trigger("done", i);
    };
    Oe.prototype.partialFlush = function(i) {
        this.trigger("partialdone", i);
    };
    Oe.prototype.endTimeline = function(i) {
        this.trigger("endedtimeline", i);
    };
    Oe.prototype.reset = function(i) {
        this.trigger("reset", i);
    };
    Bn.exports = Oe;
});
var $e833773b1f4e7d0f$var$_e = $e833773b1f4e7d0f$var$v((rT, kn)=>{
    "use strict";
    var ms = 9e4, gs, _s, oi, xs, An, Dn, Pn;
    gs = function(e) {
        return e * ms;
    };
    _s = function(e, t) {
        return e * t;
    };
    oi = function(e) {
        return e / ms;
    };
    xs = function(e, t) {
        return e / t;
    };
    An = function(e, t) {
        return gs(xs(e, t));
    };
    Dn = function(e, t) {
        return _s(oi(e), t);
    };
    Pn = function(e, t, s) {
        return oi(s ? e : e - t);
    };
    kn.exports = {
        ONE_SECOND_IN_TS: ms,
        secondsToVideoTs: gs,
        secondsToAudioTs: _s,
        videoTsToSeconds: oi,
        audioTsToSeconds: xs,
        audioTsToVideoTs: An,
        videoTsToAudioTs: Dn,
        metadataTsToSeconds: Pn
    };
});
var $e833773b1f4e7d0f$var$_t = $e833773b1f4e7d0f$var$v((nT, Fn)=>{
    "use strict";
    var lp = $e833773b1f4e7d0f$var$te(), hp = $e833773b1f4e7d0f$var$_e().ONE_SECOND_IN_TS, ui, Rn = [
        96e3,
        88200,
        64e3,
        48e3,
        44100,
        32e3,
        24e3,
        22050,
        16e3,
        12e3,
        11025,
        8e3,
        7350
    ];
    ui = function(e) {
        var t, s = 0;
        ui.prototype.init.call(this), this.skipWarn_ = function(r, n) {
            this.trigger("log", {
                level: "warn",
                message: "adts skiping bytes " + r + " to " + n + " in frame " + s + " outside syncword"
            });
        }, this.push = function(r) {
            var n = 0, a, o, u, l, h, d;
            if (e || (s = 0), r.type === "audio") {
                t && t.length ? (l = t, t = new Uint8Array(l.byteLength + r.data.byteLength), t.set(l), t.set(r.data, l.byteLength)) : t = r.data;
                for(var c; n + 7 < t.length;){
                    if (t[n] !== 255 || (t[n + 1] & 246) !== 240) {
                        typeof c != "number" && (c = n), n++;
                        continue;
                    }
                    if (typeof c == "number" && (this.skipWarn_(c, n), c = null), o = (~t[n + 1] & 1) * 2, a = (t[n + 3] & 3) << 11 | t[n + 4] << 3 | (t[n + 5] & 224) >> 5, h = ((t[n + 6] & 3) + 1) * 1024, d = h * hp / Rn[(t[n + 2] & 60) >>> 2], t.byteLength - n < a) break;
                    this.trigger("data", {
                        pts: r.pts + s * d,
                        dts: r.dts + s * d,
                        sampleCount: h,
                        audioobjecttype: (t[n + 2] >>> 6 & 3) + 1,
                        channelcount: (t[n + 2] & 1) << 2 | (t[n + 3] & 192) >>> 6,
                        samplerate: Rn[(t[n + 2] & 60) >>> 2],
                        samplingfrequencyindex: (t[n + 2] & 60) >>> 2,
                        samplesize: 16,
                        data: t.subarray(n + 7 + o, n + a)
                    }), s++, n += a;
                }
                typeof c == "number" && (this.skipWarn_(c, n), c = null), t = t.subarray(n);
            }
        }, this.flush = function() {
            s = 0, this.trigger("done");
        }, this.reset = function() {
            t = void 0, this.trigger("reset");
        }, this.endTimeline = function() {
            t = void 0, this.trigger("endedtimeline");
        };
    };
    ui.prototype = new lp;
    Fn.exports = ui;
});
var $e833773b1f4e7d0f$var$Ln = $e833773b1f4e7d0f$var$v((aT, On)=>{
    "use strict";
    var Mn;
    Mn = function(e) {
        var t = e.byteLength, s = 0, r = 0;
        this.length = function() {
            return 8 * t;
        }, this.bitsAvailable = function() {
            return 8 * t + r;
        }, this.loadWord = function() {
            var n = e.byteLength - t, a = new Uint8Array(4), o = Math.min(4, t);
            if (o === 0) throw new Error("no bytes available");
            a.set(e.subarray(n, n + o)), s = new DataView(a.buffer).getUint32(0), r = o * 8, t -= o;
        }, this.skipBits = function(n) {
            var a;
            r > n ? (s <<= n, r -= n) : (n -= r, a = Math.floor(n / 8), n -= a * 8, t -= a, this.loadWord(), s <<= n, r -= n);
        }, this.readBits = function(n) {
            var a = Math.min(r, n), o = s >>> 32 - a;
            return r -= a, r > 0 ? s <<= a : t > 0 && this.loadWord(), a = n - a, a > 0 ? o << a | this.readBits(a) : o;
        }, this.skipLeadingZeros = function() {
            var n;
            for(n = 0; n < r; ++n)if ((s & 2147483648 >>> n) !== 0) return s <<= n, r -= n, n;
            return this.loadWord(), n + this.skipLeadingZeros();
        }, this.skipUnsignedExpGolomb = function() {
            this.skipBits(1 + this.skipLeadingZeros());
        }, this.skipExpGolomb = function() {
            this.skipBits(1 + this.skipLeadingZeros());
        }, this.readUnsignedExpGolomb = function() {
            var n = this.skipLeadingZeros();
            return this.readBits(n + 1) - 1;
        }, this.readExpGolomb = function() {
            var n = this.readUnsignedExpGolomb();
            return 1 & n ? 1 + n >>> 1 : -1 * (n >>> 1);
        }, this.readBoolean = function() {
            return this.readBits(1) === 1;
        }, this.readUnsignedByte = function() {
            return this.readBits(8);
        }, this.loadWord();
    };
    On.exports = Mn;
});
var $e833773b1f4e7d0f$var$hi = $e833773b1f4e7d0f$var$v((oT, Gn)=>{
    "use strict";
    var Nn = $e833773b1f4e7d0f$var$te(), dp = $e833773b1f4e7d0f$var$Ln(), li, xt, zn;
    xt = function() {
        var e = 0, t, s;
        xt.prototype.init.call(this), this.push = function(r) {
            var n;
            s ? (n = new Uint8Array(s.byteLength + r.data.byteLength), n.set(s), n.set(r.data, s.byteLength), s = n) : s = r.data;
            for(var a = s.byteLength; e < a - 3; e++)if (s[e + 2] === 1) {
                t = e + 5;
                break;
            }
            for(; t < a;)switch(s[t]){
                case 0:
                    if (s[t - 1] !== 0) {
                        t += 2;
                        break;
                    } else if (s[t - 2] !== 0) {
                        t++;
                        break;
                    }
                    e + 3 !== t - 2 && this.trigger("data", s.subarray(e + 3, t - 2));
                    do t++;
                    while (s[t] !== 1 && t < a);
                    e = t - 2, t += 3;
                    break;
                case 1:
                    if (s[t - 1] !== 0 || s[t - 2] !== 0) {
                        t += 3;
                        break;
                    }
                    this.trigger("data", s.subarray(e + 3, t - 2)), e = t - 2, t += 3;
                    break;
                default:
                    t += 3;
                    break;
            }
            s = s.subarray(e), t -= e, e = 0;
        }, this.reset = function() {
            s = null, e = 0, this.trigger("reset");
        }, this.flush = function() {
            s && s.byteLength > 3 && this.trigger("data", s.subarray(e + 3)), s = null, e = 0, this.trigger("done");
        }, this.endTimeline = function() {
            this.flush(), this.trigger("endedtimeline");
        };
    };
    xt.prototype = new Nn;
    zn = {
        100: !0,
        110: !0,
        122: !0,
        244: !0,
        44: !0,
        83: !0,
        86: !0,
        118: !0,
        128: !0,
        138: !0,
        139: !0,
        134: !0
    };
    li = function() {
        var e = new xt, t, s, r, n, a, o, u;
        li.prototype.init.call(this), t = this, this.push = function(l) {
            l.type === "video" && (s = l.trackId, r = l.pts, n = l.dts, e.push(l));
        }, e.on("data", function(l) {
            var h = {
                trackId: s,
                pts: r,
                dts: n,
                data: l,
                nalUnitTypeCode: l[0] & 31
            };
            switch(h.nalUnitTypeCode){
                case 5:
                    h.nalUnitType = "slice_layer_without_partitioning_rbsp_idr";
                    break;
                case 6:
                    h.nalUnitType = "sei_rbsp", h.escapedRBSP = a(l.subarray(1));
                    break;
                case 7:
                    h.nalUnitType = "seq_parameter_set_rbsp", h.escapedRBSP = a(l.subarray(1)), h.config = o(h.escapedRBSP);
                    break;
                case 8:
                    h.nalUnitType = "pic_parameter_set_rbsp";
                    break;
                case 9:
                    h.nalUnitType = "access_unit_delimiter_rbsp";
                    break;
                default:
                    break;
            }
            t.trigger("data", h);
        }), e.on("done", function() {
            t.trigger("done");
        }), e.on("partialdone", function() {
            t.trigger("partialdone");
        }), e.on("reset", function() {
            t.trigger("reset");
        }), e.on("endedtimeline", function() {
            t.trigger("endedtimeline");
        }), this.flush = function() {
            e.flush();
        }, this.partialFlush = function() {
            e.partialFlush();
        }, this.reset = function() {
            e.reset();
        }, this.endTimeline = function() {
            e.endTimeline();
        }, u = function(h, d) {
            var c = 8, p = 8, f, _;
            for(f = 0; f < h; f++)p !== 0 && (_ = d.readExpGolomb(), p = (c + _ + 256) % 256), c = p === 0 ? c : p;
        }, a = function(h) {
            for(var d = h.byteLength, c = [], p = 1, f, _; p < d - 2;)h[p] === 0 && h[p + 1] === 0 && h[p + 2] === 3 ? (c.push(p + 2), p += 2) : p++;
            if (c.length === 0) return h;
            f = d - c.length, _ = new Uint8Array(f);
            var m = 0;
            for(p = 0; p < f; m++, p++)m === c[0] && (m++, c.shift()), _[p] = h[m];
            return _;
        }, o = function(h) {
            var d = 0, c = 0, p = 0, f = 0, _ = 1, m, b, S, C, j, N, P, G, R, X, w, F = [
                1,
                1
            ], xr, Pe;
            if (m = new dp(h), b = m.readUnsignedByte(), C = m.readUnsignedByte(), S = m.readUnsignedByte(), m.skipUnsignedExpGolomb(), zn[b] && (j = m.readUnsignedExpGolomb(), j === 3 && m.skipBits(1), m.skipUnsignedExpGolomb(), m.skipUnsignedExpGolomb(), m.skipBits(1), m.readBoolean())) for(w = j !== 3 ? 8 : 12, Pe = 0; Pe < w; Pe++)m.readBoolean() && (Pe < 6 ? u(16, m) : u(64, m));
            if (m.skipUnsignedExpGolomb(), N = m.readUnsignedExpGolomb(), N === 0) m.readUnsignedExpGolomb();
            else if (N === 1) for(m.skipBits(1), m.skipExpGolomb(), m.skipExpGolomb(), P = m.readUnsignedExpGolomb(), Pe = 0; Pe < P; Pe++)m.skipExpGolomb();
            if (m.skipUnsignedExpGolomb(), m.skipBits(1), G = m.readUnsignedExpGolomb(), R = m.readUnsignedExpGolomb(), X = m.readBits(1), X === 0 && m.skipBits(1), m.skipBits(1), m.readBoolean() && (d = m.readUnsignedExpGolomb(), c = m.readUnsignedExpGolomb(), p = m.readUnsignedExpGolomb(), f = m.readUnsignedExpGolomb()), m.readBoolean() && m.readBoolean()) {
                switch(xr = m.readUnsignedByte(), xr){
                    case 1:
                        F = [
                            1,
                            1
                        ];
                        break;
                    case 2:
                        F = [
                            12,
                            11
                        ];
                        break;
                    case 3:
                        F = [
                            10,
                            11
                        ];
                        break;
                    case 4:
                        F = [
                            16,
                            11
                        ];
                        break;
                    case 5:
                        F = [
                            40,
                            33
                        ];
                        break;
                    case 6:
                        F = [
                            24,
                            11
                        ];
                        break;
                    case 7:
                        F = [
                            20,
                            11
                        ];
                        break;
                    case 8:
                        F = [
                            32,
                            11
                        ];
                        break;
                    case 9:
                        F = [
                            80,
                            33
                        ];
                        break;
                    case 10:
                        F = [
                            18,
                            11
                        ];
                        break;
                    case 11:
                        F = [
                            15,
                            11
                        ];
                        break;
                    case 12:
                        F = [
                            64,
                            33
                        ];
                        break;
                    case 13:
                        F = [
                            160,
                            99
                        ];
                        break;
                    case 14:
                        F = [
                            4,
                            3
                        ];
                        break;
                    case 15:
                        F = [
                            3,
                            2
                        ];
                        break;
                    case 16:
                        F = [
                            2,
                            1
                        ];
                        break;
                    case 255:
                        F = [
                            m.readUnsignedByte() << 8 | m.readUnsignedByte(),
                            m.readUnsignedByte() << 8 | m.readUnsignedByte()
                        ];
                        break;
                }
                F && (_ = F[0] / F[1]);
            }
            return {
                profileIdc: b,
                levelIdc: S,
                profileCompatibility: C,
                width: (G + 1) * 16 - d * 2 - c * 2,
                height: (2 - X) * (R + 1) * 16 - p * 2 - f * 2,
                sarRatio: F
            };
        };
    };
    li.prototype = new Nn;
    Gn.exports = {
        H264Stream: li,
        NalByteStream: xt
    };
});
var $e833773b1f4e7d0f$var$ys = $e833773b1f4e7d0f$var$v((uT, Vn)=>{
    "use strict";
    Vn.exports = {
        Adts: $e833773b1f4e7d0f$var$_t(),
        h264: $e833773b1f4e7d0f$var$hi()
    };
});
var $e833773b1f4e7d0f$var$Le = $e833773b1f4e7d0f$var$v((lT, qn)=>{
    "use strict";
    var Hn = Math.pow(2, 32), cp = function(e) {
        var t = new DataView(e.buffer, e.byteOffset, e.byteLength), s;
        return t.getBigUint64 ? (s = t.getBigUint64(0), s < Number.MAX_SAFE_INTEGER ? Number(s) : s) : t.getUint32(0) * Hn + t.getUint32(4);
    };
    qn.exports = {
        getUint64: cp,
        MAX_UINT32: Hn
    };
});
var $e833773b1f4e7d0f$var$yt = $e833773b1f4e7d0f$var$v((hT, ba)=>{
    "use strict";
    var Wn = $e833773b1f4e7d0f$var$Le().MAX_UINT32, U, Xn, Kn, vs, $n, Qn, Zn, Jn, bs, ea, ta, ia, sa, ra, na, aa, oa, ua, la, ha, da, Ss, T, Ts, ca, fa, Yn, jn, pa, ma, ga, _a, di, xa, ya, va;
    (function() {
        var i;
        if (T = {
            avc1: [],
            avcC: [],
            btrt: [],
            dinf: [],
            dref: [],
            esds: [],
            ftyp: [],
            hdlr: [],
            mdat: [],
            mdhd: [],
            mdia: [],
            mfhd: [],
            minf: [],
            moof: [],
            moov: [],
            mp4a: [],
            mvex: [],
            mvhd: [],
            pasp: [],
            sdtp: [],
            smhd: [],
            stbl: [],
            stco: [],
            stsc: [],
            stsd: [],
            stsz: [],
            stts: [],
            styp: [],
            tfdt: [],
            tfhd: [],
            traf: [],
            trak: [],
            trun: [],
            trex: [],
            tkhd: [],
            vmhd: []
        }, !(typeof Uint8Array > "u")) {
            for(i in T)T.hasOwnProperty(i) && (T[i] = [
                i.charCodeAt(0),
                i.charCodeAt(1),
                i.charCodeAt(2),
                i.charCodeAt(3)
            ]);
            Ts = new Uint8Array([
                105,
                115,
                111,
                109
            ]), fa = new Uint8Array([
                97,
                118,
                99,
                49
            ]), ca = new Uint8Array([
                0,
                0,
                0,
                1
            ]), Yn = new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                118,
                105,
                100,
                101,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                86,
                105,
                100,
                101,
                111,
                72,
                97,
                110,
                100,
                108,
                101,
                114,
                0
            ]), jn = new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                115,
                111,
                117,
                110,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                83,
                111,
                117,
                110,
                100,
                72,
                97,
                110,
                100,
                108,
                101,
                114,
                0
            ]), pa = {
                video: Yn,
                audio: jn
            }, _a = new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                12,
                117,
                114,
                108,
                32,
                0,
                0,
                0,
                1
            ]), ga = new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]), di = new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]), xa = di, ya = new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]), va = di, ma = new Uint8Array([
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]);
        }
    })();
    U = function(e) {
        var t = [], s = 0, r, n, a;
        for(r = 1; r < arguments.length; r++)t.push(arguments[r]);
        for(r = t.length; r--;)s += t[r].byteLength;
        for(n = new Uint8Array(s + 8), a = new DataView(n.buffer, n.byteOffset, n.byteLength), a.setUint32(0, n.byteLength), n.set(e, 4), r = 0, s = 8; r < t.length; r++)n.set(t[r], s), s += t[r].byteLength;
        return n;
    };
    Xn = function() {
        return U(T.dinf, U(T.dref, _a));
    };
    Kn = function(e) {
        return U(T.esds, new Uint8Array([
            0,
            0,
            0,
            0,
            3,
            25,
            0,
            0,
            0,
            4,
            17,
            64,
            21,
            0,
            6,
            0,
            0,
            0,
            218,
            192,
            0,
            0,
            218,
            192,
            5,
            2,
            e.audioobjecttype << 3 | e.samplingfrequencyindex >>> 1,
            e.samplingfrequencyindex << 7 | e.channelcount << 3,
            6,
            1,
            2
        ]));
    };
    vs = function() {
        return U(T.ftyp, Ts, ca, Ts, fa);
    };
    aa = function(e) {
        return U(T.hdlr, pa[e]);
    };
    $n = function(e) {
        return U(T.mdat, e);
    };
    na = function(e) {
        var t = new Uint8Array([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            2,
            0,
            0,
            0,
            3,
            0,
            1,
            95,
            144,
            e.duration >>> 24 & 255,
            e.duration >>> 16 & 255,
            e.duration >>> 8 & 255,
            e.duration & 255,
            85,
            196,
            0,
            0
        ]);
        return e.samplerate && (t[12] = e.samplerate >>> 24 & 255, t[13] = e.samplerate >>> 16 & 255, t[14] = e.samplerate >>> 8 & 255, t[15] = e.samplerate & 255), U(T.mdhd, t);
    };
    ra = function(e) {
        return U(T.mdia, na(e), aa(e.type), Zn(e));
    };
    Qn = function(e) {
        return U(T.mfhd, new Uint8Array([
            0,
            0,
            0,
            0,
            (e & 4278190080) >> 24,
            (e & 16711680) >> 16,
            (e & 65280) >> 8,
            e & 255
        ]));
    };
    Zn = function(e) {
        return U(T.minf, e.type === "video" ? U(T.vmhd, ma) : U(T.smhd, ga), Xn(), ua(e));
    };
    Jn = function(e, t) {
        for(var s = [], r = t.length; r--;)s[r] = ha(t[r]);
        return U.apply(null, [
            T.moof,
            Qn(e)
        ].concat(s));
    };
    bs = function(e) {
        for(var t = e.length, s = []; t--;)s[t] = ia(e[t]);
        return U.apply(null, [
            T.moov,
            ta(4294967295)
        ].concat(s).concat(ea(e)));
    };
    ea = function(e) {
        for(var t = e.length, s = []; t--;)s[t] = da(e[t]);
        return U.apply(null, [
            T.mvex
        ].concat(s));
    };
    ta = function(e) {
        var t = new Uint8Array([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            2,
            0,
            1,
            95,
            144,
            (e & 4278190080) >> 24,
            (e & 16711680) >> 16,
            (e & 65280) >> 8,
            e & 255,
            0,
            1,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            64,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            255,
            255,
            255,
            255
        ]);
        return U(T.mvhd, t);
    };
    oa = function(e) {
        var t = e.samples || [], s = new Uint8Array(4 + t.length), r, n;
        for(n = 0; n < t.length; n++)r = t[n].flags, s[n + 4] = r.dependsOn << 4 | r.isDependedOn << 2 | r.hasRedundancy;
        return U(T.sdtp, s);
    };
    ua = function(e) {
        return U(T.stbl, la(e), U(T.stts, va), U(T.stsc, xa), U(T.stsz, ya), U(T.stco, di));
    };
    (function() {
        var i, e;
        la = function(s) {
            return U(T.stsd, new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1
            ]), s.type === "video" ? i(s) : e(s));
        }, i = function(s) {
            var r = s.sps || [], n = s.pps || [], a = [], o = [], u, l;
            for(u = 0; u < r.length; u++)a.push((r[u].byteLength & 65280) >>> 8), a.push(r[u].byteLength & 255), a = a.concat(Array.prototype.slice.call(r[u]));
            for(u = 0; u < n.length; u++)o.push((n[u].byteLength & 65280) >>> 8), o.push(n[u].byteLength & 255), o = o.concat(Array.prototype.slice.call(n[u]));
            if (l = [
                T.avc1,
                new Uint8Array([
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    (s.width & 65280) >> 8,
                    s.width & 255,
                    (s.height & 65280) >> 8,
                    s.height & 255,
                    0,
                    72,
                    0,
                    0,
                    0,
                    72,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    19,
                    118,
                    105,
                    100,
                    101,
                    111,
                    106,
                    115,
                    45,
                    99,
                    111,
                    110,
                    116,
                    114,
                    105,
                    98,
                    45,
                    104,
                    108,
                    115,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    24,
                    17,
                    17
                ]),
                U(T.avcC, new Uint8Array([
                    1,
                    s.profileIdc,
                    s.profileCompatibility,
                    s.levelIdc,
                    255
                ].concat([
                    r.length
                ], a, [
                    n.length
                ], o))),
                U(T.btrt, new Uint8Array([
                    0,
                    28,
                    156,
                    128,
                    0,
                    45,
                    198,
                    192,
                    0,
                    45,
                    198,
                    192
                ]))
            ], s.sarRatio) {
                var h = s.sarRatio[0], d = s.sarRatio[1];
                l.push(U(T.pasp, new Uint8Array([
                    (h & 4278190080) >> 24,
                    (h & 16711680) >> 16,
                    (h & 65280) >> 8,
                    h & 255,
                    (d & 4278190080) >> 24,
                    (d & 16711680) >> 16,
                    (d & 65280) >> 8,
                    d & 255
                ])));
            }
            return U.apply(null, l);
        }, e = function(s) {
            return U(T.mp4a, new Uint8Array([
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                (s.channelcount & 65280) >> 8,
                s.channelcount & 255,
                (s.samplesize & 65280) >> 8,
                s.samplesize & 255,
                0,
                0,
                0,
                0,
                (s.samplerate & 65280) >> 8,
                s.samplerate & 255,
                0,
                0
            ]), Kn(s));
        };
    })();
    sa = function(e) {
        var t = new Uint8Array([
            0,
            0,
            0,
            7,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            (e.id & 4278190080) >> 24,
            (e.id & 16711680) >> 16,
            (e.id & 65280) >> 8,
            e.id & 255,
            0,
            0,
            0,
            0,
            (e.duration & 4278190080) >> 24,
            (e.duration & 16711680) >> 16,
            (e.duration & 65280) >> 8,
            e.duration & 255,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            64,
            0,
            0,
            0,
            (e.width & 65280) >> 8,
            e.width & 255,
            0,
            0,
            (e.height & 65280) >> 8,
            e.height & 255,
            0,
            0
        ]);
        return U(T.tkhd, t);
    };
    ha = function(e) {
        var t, s, r, n, a, o, u;
        return t = U(T.tfhd, new Uint8Array([
            0,
            0,
            0,
            58,
            (e.id & 4278190080) >> 24,
            (e.id & 16711680) >> 16,
            (e.id & 65280) >> 8,
            e.id & 255,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ])), o = Math.floor(e.baseMediaDecodeTime / Wn), u = Math.floor(e.baseMediaDecodeTime % Wn), s = U(T.tfdt, new Uint8Array([
            1,
            0,
            0,
            0,
            o >>> 24 & 255,
            o >>> 16 & 255,
            o >>> 8 & 255,
            o & 255,
            u >>> 24 & 255,
            u >>> 16 & 255,
            u >>> 8 & 255,
            u & 255
        ])), a = 92, e.type === "audio" ? (r = Ss(e, a), U(T.traf, t, s, r)) : (n = oa(e), r = Ss(e, n.length + a), U(T.traf, t, s, r, n));
    };
    ia = function(e) {
        return e.duration = e.duration || 4294967295, U(T.trak, sa(e), ra(e));
    };
    da = function(e) {
        var t = new Uint8Array([
            0,
            0,
            0,
            0,
            (e.id & 4278190080) >> 24,
            (e.id & 16711680) >> 16,
            (e.id & 65280) >> 8,
            e.id & 255,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            1
        ]);
        return e.type !== "video" && (t[t.length - 1] = 0), U(T.trex, t);
    };
    (function() {
        var i, e, t;
        t = function(r, n) {
            var a = 0, o = 0, u = 0, l = 0;
            return r.length && (r[0].duration !== void 0 && (a = 1), r[0].size !== void 0 && (o = 2), r[0].flags !== void 0 && (u = 4), r[0].compositionTimeOffset !== void 0 && (l = 8)), [
                0,
                0,
                a | o | u | l,
                1,
                (r.length & 4278190080) >>> 24,
                (r.length & 16711680) >>> 16,
                (r.length & 65280) >>> 8,
                r.length & 255,
                (n & 4278190080) >>> 24,
                (n & 16711680) >>> 16,
                (n & 65280) >>> 8,
                n & 255
            ];
        }, e = function(r, n) {
            var a, o, u, l, h, d;
            for(l = r.samples || [], n += 20 + 16 * l.length, u = t(l, n), o = new Uint8Array(u.length + l.length * 16), o.set(u), a = u.length, d = 0; d < l.length; d++)h = l[d], o[a++] = (h.duration & 4278190080) >>> 24, o[a++] = (h.duration & 16711680) >>> 16, o[a++] = (h.duration & 65280) >>> 8, o[a++] = h.duration & 255, o[a++] = (h.size & 4278190080) >>> 24, o[a++] = (h.size & 16711680) >>> 16, o[a++] = (h.size & 65280) >>> 8, o[a++] = h.size & 255, o[a++] = h.flags.isLeading << 2 | h.flags.dependsOn, o[a++] = h.flags.isDependedOn << 6 | h.flags.hasRedundancy << 4 | h.flags.paddingValue << 1 | h.flags.isNonSyncSample, o[a++] = h.flags.degradationPriority & 61440, o[a++] = h.flags.degradationPriority & 15, o[a++] = (h.compositionTimeOffset & 4278190080) >>> 24, o[a++] = (h.compositionTimeOffset & 16711680) >>> 16, o[a++] = (h.compositionTimeOffset & 65280) >>> 8, o[a++] = h.compositionTimeOffset & 255;
            return U(T.trun, o);
        }, i = function(r, n) {
            var a, o, u, l, h, d;
            for(l = r.samples || [], n += 20 + 8 * l.length, u = t(l, n), a = new Uint8Array(u.length + l.length * 8), a.set(u), o = u.length, d = 0; d < l.length; d++)h = l[d], a[o++] = (h.duration & 4278190080) >>> 24, a[o++] = (h.duration & 16711680) >>> 16, a[o++] = (h.duration & 65280) >>> 8, a[o++] = h.duration & 255, a[o++] = (h.size & 4278190080) >>> 24, a[o++] = (h.size & 16711680) >>> 16, a[o++] = (h.size & 65280) >>> 8, a[o++] = h.size & 255;
            return U(T.trun, a);
        }, Ss = function(r, n) {
            return r.type === "audio" ? i(r, n) : e(r, n);
        };
    })();
    ba.exports = {
        ftyp: vs,
        mdat: $n,
        moof: Jn,
        moov: bs,
        initSegment: function(e) {
            var t = vs(), s = bs(e), r;
            return r = new Uint8Array(t.byteLength + s.byteLength), r.set(t), r.set(s, t.byteLength), r;
        }
    };
});
var $e833773b1f4e7d0f$var$vt = $e833773b1f4e7d0f$var$v((dT, Sa)=>{
    "use strict";
    var fp = function(e) {
        return e >>> 0;
    }, pp = function(e) {
        return ("00" + e.toString(16)).slice(-2);
    };
    Sa.exports = {
        toUnsigned: fp,
        toHexString: pp
    };
});
var $e833773b1f4e7d0f$var$ci = $e833773b1f4e7d0f$var$v((cT, Ta)=>{
    "use strict";
    var mp = function(e) {
        var t = "";
        return t += String.fromCharCode(e[0]), t += String.fromCharCode(e[1]), t += String.fromCharCode(e[2]), t += String.fromCharCode(e[3]), t;
    };
    Ta.exports = mp;
});
var $e833773b1f4e7d0f$var$fi = $e833773b1f4e7d0f$var$v((fT, wa)=>{
    "use strict";
    var gp = $e833773b1f4e7d0f$var$vt().toUnsigned, _p = $e833773b1f4e7d0f$var$ci(), xp = function i(e, t) {
        var s = [], r, n, a, o, u;
        if (!t.length) return null;
        for(r = 0; r < e.byteLength;)n = gp(e[r] << 24 | e[r + 1] << 16 | e[r + 2] << 8 | e[r + 3]), a = _p(e.subarray(r + 4, r + 8)), o = n > 1 ? r + n : e.byteLength, a === t[0] && (t.length === 1 ? s.push(e.subarray(r + 8, o)) : (u = i(e.subarray(r + 8, o), t.slice(1)), u.length && (s = s.concat(u)))), r = o;
        return s;
    };
    wa.exports = xp;
});
var $e833773b1f4e7d0f$var$Ea = $e833773b1f4e7d0f$var$v((pT, Ua)=>{
    "use strict";
    var yp = function(e) {
        for(var t = 0, s = String.fromCharCode(e[t]), r = ""; s !== "\0";)r += s, t++, s = String.fromCharCode(e[t]);
        return r += s, r;
    };
    Ua.exports = {
        uint8ToCString: yp
    };
});
var $e833773b1f4e7d0f$var$Ba = $e833773b1f4e7d0f$var$v((mT, Ca)=>{
    "use strict";
    var pi = $e833773b1f4e7d0f$var$Ea().uint8ToCString, vp = $e833773b1f4e7d0f$var$Le().getUint64, bp = function(e) {
        var t = 4, s = e[0], r, n, a, o, u, l, h, d;
        if (s === 0) {
            r = pi(e.subarray(t)), t += r.length, n = pi(e.subarray(t)), t += n.length;
            var c = new DataView(e.buffer);
            a = c.getUint32(t), t += 4, u = c.getUint32(t), t += 4, l = c.getUint32(t), t += 4, h = c.getUint32(t), t += 4;
        } else if (s === 1) {
            var c = new DataView(e.buffer);
            a = c.getUint32(t), t += 4, o = vp(e.subarray(t)), t += 8, l = c.getUint32(t), t += 4, h = c.getUint32(t), t += 4, r = pi(e.subarray(t)), t += r.length, n = pi(e.subarray(t)), t += n.length;
        }
        d = new Uint8Array(e.subarray(t, e.byteLength));
        var p = {
            scheme_id_uri: r,
            value: n,
            timescale: a || 1,
            presentation_time: o,
            presentation_time_delta: u,
            event_duration: l,
            id: h,
            message_data: d
        };
        return Tp(s, p) ? p : void 0;
    }, Sp = function(e, t, s, r) {
        return e || e === 0 ? e / t : r + s / t;
    }, Tp = function(e, t) {
        var s = t.scheme_id_uri !== "\0", r = e === 0 && Ia(t.presentation_time_delta) && s, n = e === 1 && Ia(t.presentation_time) && s;
        return !(e > 1) && r || n;
    }, Ia = function(e) {
        return e !== void 0 || e !== null;
    };
    Ca.exports = {
        parseEmsgBox: bp,
        scaleTime: Sp
    };
});
var $e833773b1f4e7d0f$var$mi = $e833773b1f4e7d0f$var$v((gT, Aa)=>{
    "use strict";
    var wp = function(e) {
        var t = new DataView(e.buffer, e.byteOffset, e.byteLength), s = {
            version: e[0],
            flags: new Uint8Array(e.subarray(1, 4)),
            trackId: t.getUint32(4)
        }, r = s.flags[2] & 1, n = s.flags[2] & 2, a = s.flags[2] & 8, o = s.flags[2] & 16, u = s.flags[2] & 32, l = s.flags[0] & 65536, h = s.flags[0] & 131072, d;
        return d = 8, r && (d += 4, s.baseDataOffset = t.getUint32(12), d += 4), n && (s.sampleDescriptionIndex = t.getUint32(d), d += 4), a && (s.defaultSampleDuration = t.getUint32(d), d += 4), o && (s.defaultSampleSize = t.getUint32(d), d += 4), u && (s.defaultSampleFlags = t.getUint32(d)), l && (s.durationIsEmpty = !0), !r && h && (s.baseDataOffsetIsMoof = !0), s;
    };
    Aa.exports = wp;
});
var $e833773b1f4e7d0f$var$Pa = $e833773b1f4e7d0f$var$v((_T, Da)=>{
    "use strict";
    var Up = function(e) {
        return {
            isLeading: (e[0] & 12) >>> 2,
            dependsOn: e[0] & 3,
            isDependedOn: (e[1] & 192) >>> 6,
            hasRedundancy: (e[1] & 48) >>> 4,
            paddingValue: (e[1] & 14) >>> 1,
            isNonSyncSample: e[1] & 1,
            degradationPriority: e[2] << 8 | e[3]
        };
    };
    Da.exports = Up;
});
var $e833773b1f4e7d0f$var$gi = $e833773b1f4e7d0f$var$v((xT, Ra)=>{
    "use strict";
    var ka = $e833773b1f4e7d0f$var$Pa(), Ep = function(e) {
        var t = {
            version: e[0],
            flags: new Uint8Array(e.subarray(1, 4)),
            samples: []
        }, s = new DataView(e.buffer, e.byteOffset, e.byteLength), r = t.flags[2] & 1, n = t.flags[2] & 4, a = t.flags[1] & 1, o = t.flags[1] & 2, u = t.flags[1] & 4, l = t.flags[1] & 8, h = s.getUint32(4), d = 8, c;
        for(r && (t.dataOffset = s.getInt32(d), d += 4), n && h && (c = {
            flags: ka(e.subarray(d, d + 4))
        }, d += 4, a && (c.duration = s.getUint32(d), d += 4), o && (c.size = s.getUint32(d), d += 4), l && (t.version === 1 ? c.compositionTimeOffset = s.getInt32(d) : c.compositionTimeOffset = s.getUint32(d), d += 4), t.samples.push(c), h--); h--;)c = {}, a && (c.duration = s.getUint32(d), d += 4), o && (c.size = s.getUint32(d), d += 4), u && (c.flags = ka(e.subarray(d, d + 4)), d += 4), l && (t.version === 1 ? c.compositionTimeOffset = s.getInt32(d) : c.compositionTimeOffset = s.getUint32(d), d += 4), t.samples.push(c);
        return t;
    };
    Ra.exports = Ep;
});
var $e833773b1f4e7d0f$var$_i = $e833773b1f4e7d0f$var$v((yT, Fa)=>{
    "use strict";
    var Ip = $e833773b1f4e7d0f$var$vt().toUnsigned, Cp = $e833773b1f4e7d0f$var$Le().getUint64, Bp = function(e) {
        var t = {
            version: e[0],
            flags: new Uint8Array(e.subarray(1, 4))
        };
        return t.version === 1 ? t.baseMediaDecodeTime = Cp(e.subarray(4)) : t.baseMediaDecodeTime = Ip(e[4] << 24 | e[5] << 16 | e[6] << 8 | e[7]), t;
    };
    Fa.exports = Bp;
});
var $e833773b1f4e7d0f$var$ws = $e833773b1f4e7d0f$var$v((vT, Ma)=>{
    "use strict";
    var bt;
    typeof window < "u" ? bt = window : typeof $parcel$global < "u" ? bt = $parcel$global : typeof self < "u" ? bt = self : bt = {};
    Ma.exports = bt;
});
var $e833773b1f4e7d0f$var$La = $e833773b1f4e7d0f$var$v((bT, Oa)=>{
    "use strict";
    var Ap = function(e, t, s) {
        if (!e) return -1;
        for(var r = s; r < e.length; r++)if (e[r] === t) return r;
        return -1;
    };
    Oa.exports = {
        typedArrayIndexOf: Ap
    };
});
var $e833773b1f4e7d0f$var$Us = $e833773b1f4e7d0f$var$v((ST, za)=>{
    "use strict";
    var xi = $e833773b1f4e7d0f$var$La().typedArrayIndexOf, yi = {
        Iso88591: 0,
        Utf16: 1,
        Utf16be: 2,
        Utf8: 3
    }, Na = function(e, t, s) {
        var r, n = "";
        for(r = t; r < s; r++)n += "%" + ("00" + e[r].toString(16)).slice(-2);
        return n;
    }, St = function(e, t, s) {
        return decodeURIComponent(Na(e, t, s));
    }, Tt = function(e, t, s) {
        return unescape(Na(e, t, s));
    }, wt = function(e) {
        return e[0] << 21 | e[1] << 14 | e[2] << 7 | e[3];
    }, Ut = {
        APIC: function(e) {
            var t = 1, s, r, n = "-->";
            e.data[0] === yi.Utf8 && (s = xi(e.data, 0, t), !(s < 0) && (e.mimeType = Tt(e.data, t, s), t = s + 1, e.pictureType = e.data[t], t++, r = xi(e.data, 0, t), !(r < 0) && (e.description = St(e.data, t, r), t = r + 1, e.mimeType === n ? e.url = Tt(e.data, t, e.data.length) : e.pictureData = e.data.subarray(t, e.data.length))));
        },
        "T*": function(e) {
            e.data[0] === yi.Utf8 && (e.value = St(e.data, 1, e.data.length).replace(/\0*$/, ""), e.values = e.value.split("\0"));
        },
        TXXX: function(e) {
            var t;
            e.data[0] === yi.Utf8 && (t = xi(e.data, 0, 1), t !== -1 && (e.description = St(e.data, 1, t), e.value = St(e.data, t + 1, e.data.length).replace(/\0*$/, ""), e.data = e.value));
        },
        "W*": function(e) {
            e.url = Tt(e.data, 0, e.data.length).replace(/\0.*$/, "");
        },
        WXXX: function(e) {
            var t;
            e.data[0] === yi.Utf8 && (t = xi(e.data, 0, 1), t !== -1 && (e.description = St(e.data, 1, t), e.url = Tt(e.data, t + 1, e.data.length).replace(/\0.*$/, "")));
        },
        PRIV: function(e) {
            var t;
            for(t = 0; t < e.data.length; t++)if (e.data[t] === 0) {
                e.owner = Tt(e.data, 0, t);
                break;
            }
            e.privateData = e.data.subarray(t + 1), e.data = e.privateData;
        }
    }, Dp = function(e) {
        var t, s, r = 10, n = 0, a = [];
        if (!(e.length < 10 || e[0] !== 73 || e[1] !== 68 || e[2] !== 51)) {
            n = wt(e.subarray(6, 10)), n += 10;
            var o = e[5] & 64;
            o && (r += 4, r += wt(e.subarray(10, 14)), n -= wt(e.subarray(16, 20)));
            do {
                if (t = wt(e.subarray(r + 4, r + 8)), t < 1) break;
                s = String.fromCharCode(e[r], e[r + 1], e[r + 2], e[r + 3]);
                var u = {
                    id: s,
                    data: e.subarray(r + 10, r + t + 10)
                };
                u.key = u.id, Ut[u.id] ? Ut[u.id](u) : u.id[0] === "T" ? Ut["T*"](u) : u.id[0] === "W" && Ut["W*"](u), a.push(u), r += 10, r += t;
            }while (r < n);
            return a;
        }
    };
    za.exports = {
        parseId3Frames: Dp,
        parseSyncSafeInteger: wt,
        frameParsers: Ut
    };
});
var $e833773b1f4e7d0f$var$Xa = $e833773b1f4e7d0f$var$v((TT, ja)=>{
    "use strict";
    var vi = $e833773b1f4e7d0f$var$vt().toUnsigned, Et = $e833773b1f4e7d0f$var$vt().toHexString, L = $e833773b1f4e7d0f$var$fi(), $e = $e833773b1f4e7d0f$var$ci(), Es = $e833773b1f4e7d0f$var$Ba(), Pp = $e833773b1f4e7d0f$var$mi(), kp = $e833773b1f4e7d0f$var$gi(), Rp = $e833773b1f4e7d0f$var$_i(), Fp = $e833773b1f4e7d0f$var$Le().getUint64, Ga, Va, Ha, qa, Wa, Cs, Ya, Is = $e833773b1f4e7d0f$var$ws(), Mp = $e833773b1f4e7d0f$var$Us().parseId3Frames;
    Ga = function(e) {
        var t = {}, s = L(e, [
            "moov",
            "trak"
        ]);
        return s.reduce(function(r, n) {
            var a, o, u, l, h;
            return a = L(n, [
                "tkhd"
            ])[0], !a || (o = a[0], u = o === 0 ? 12 : 20, l = vi(a[u] << 24 | a[u + 1] << 16 | a[u + 2] << 8 | a[u + 3]), h = L(n, [
                "mdia",
                "mdhd"
            ])[0], !h) ? null : (o = h[0], u = o === 0 ? 12 : 20, r[l] = vi(h[u] << 24 | h[u + 1] << 16 | h[u + 2] << 8 | h[u + 3]), r);
        }, t);
    };
    Va = function(e, t) {
        var s, r;
        s = L(t, [
            "moof",
            "traf"
        ]);
        var n = s.reduce(function(a, o) {
            var u = L(o, [
                "tfhd"
            ])[0], l = vi(u[4] << 24 | u[5] << 16 | u[6] << 8 | u[7]), h = e[l] || 9e4, d = L(o, [
                "tfdt"
            ])[0], c = new DataView(d.buffer, d.byteOffset, d.byteLength), p;
            d[0] === 1 ? p = Fp(d.subarray(4, 12)) : p = c.getUint32(4);
            var f;
            return typeof p == "bigint" ? f = p / Is.BigInt(h) : typeof p == "number" && !isNaN(p) && (f = p / h), f < Number.MAX_SAFE_INTEGER && (f = Number(f)), f < a && (a = f), a;
        }, 1 / 0);
        return typeof n == "bigint" || isFinite(n) ? n : 0;
    };
    Ha = function(e, t) {
        var s = L(t, [
            "moof",
            "traf"
        ]), r = 0, n = 0, a;
        if (s && s.length) {
            var o = L(s[0], [
                "tfhd"
            ])[0], u = L(s[0], [
                "trun"
            ])[0], l = L(s[0], [
                "tfdt"
            ])[0];
            if (o) {
                var h = Pp(o);
                a = h.trackId;
            }
            if (l) {
                var d = Rp(l);
                r = d.baseMediaDecodeTime;
            }
            if (u) {
                var c = kp(u);
                c.samples && c.samples.length && (n = c.samples[0].compositionTimeOffset || 0);
            }
        }
        var p = e[a] || 9e4;
        typeof r == "bigint" && (n = Is.BigInt(n), p = Is.BigInt(p));
        var f = (r + n) / p;
        return typeof f == "bigint" && f < Number.MAX_SAFE_INTEGER && (f = Number(f)), f;
    };
    qa = function(e) {
        var t = L(e, [
            "moov",
            "trak"
        ]), s = [];
        return t.forEach(function(r) {
            var n = L(r, [
                "mdia",
                "hdlr"
            ]), a = L(r, [
                "tkhd"
            ]);
            n.forEach(function(o, u) {
                var l = $e(o.subarray(8, 12)), h = a[u], d, c, p;
                l === "vide" && (d = new DataView(h.buffer, h.byteOffset, h.byteLength), c = d.getUint8(0), p = c === 0 ? d.getUint32(12) : d.getUint32(20), s.push(p));
            });
        }), s;
    };
    Cs = function(e) {
        var t = e[0], s = t === 0 ? 12 : 20;
        return vi(e[s] << 24 | e[s + 1] << 16 | e[s + 2] << 8 | e[s + 3]);
    };
    Wa = function(e) {
        var t = L(e, [
            "moov",
            "trak"
        ]), s = [];
        return t.forEach(function(r) {
            var n = {}, a = L(r, [
                "tkhd"
            ])[0], o, u;
            a && (o = new DataView(a.buffer, a.byteOffset, a.byteLength), u = o.getUint8(0), n.id = u === 0 ? o.getUint32(12) : o.getUint32(20));
            var l = L(r, [
                "mdia",
                "hdlr"
            ])[0];
            if (l) {
                var h = $e(l.subarray(8, 12));
                h === "vide" ? n.type = "video" : h === "soun" ? n.type = "audio" : n.type = h;
            }
            var d = L(r, [
                "mdia",
                "minf",
                "stbl",
                "stsd"
            ])[0];
            if (d) {
                var c = d.subarray(8);
                n.codec = $e(c.subarray(4, 8));
                var p = L(c, [
                    n.codec
                ])[0], f, _;
                p && (/^[asm]vc[1-9]$/i.test(n.codec) ? (f = p.subarray(78), _ = $e(f.subarray(4, 8)), _ === "avcC" && f.length > 11 ? (n.codec += ".", n.codec += Et(f[9]), n.codec += Et(f[10]), n.codec += Et(f[11])) : n.codec = "avc1.4d400d") : /^mp4[a,v]$/i.test(n.codec) ? (f = p.subarray(28), _ = $e(f.subarray(4, 8)), _ === "esds" && f.length > 20 && f[19] !== 0 ? (n.codec += "." + Et(f[19]), n.codec += "." + Et(f[20] >>> 2 & 63).replace(/^0/, "")) : n.codec = "mp4a.40.2") : n.codec = n.codec.toLowerCase());
            }
            var m = L(r, [
                "mdia",
                "mdhd"
            ])[0];
            m && (n.timescale = Cs(m)), s.push(n);
        }), s;
    };
    Ya = function(e, t) {
        t === void 0 && (t = 0);
        var s = L(e, [
            "emsg"
        ]);
        return s.map(function(r) {
            var n = Es.parseEmsgBox(new Uint8Array(r)), a = Mp(n.message_data);
            return {
                cueTime: Es.scaleTime(n.presentation_time, n.timescale, n.presentation_time_delta, t),
                duration: Es.scaleTime(n.event_duration, n.timescale),
                frames: a
            };
        });
    };
    ja.exports = {
        findBox: L,
        parseType: $e,
        timescale: Ga,
        startTime: Va,
        compositionStartTime: Ha,
        videoTrackIds: qa,
        tracks: Wa,
        getTimescaleFromMediaHeader: Cs,
        getEmsgID3: Ya
    };
});
var $e833773b1f4e7d0f$var$Bs = $e833773b1f4e7d0f$var$v((wT, $a)=>{
    "use strict";
    var Op = function(e) {
        var t, s, r = [], n = [];
        for(n.byteLength = 0, n.nalCount = 0, n.duration = 0, r.byteLength = 0, t = 0; t < e.length; t++)s = e[t], s.nalUnitType === "access_unit_delimiter_rbsp" ? (r.length && (r.duration = s.dts - r.dts, n.byteLength += r.byteLength, n.nalCount += r.length, n.duration += r.duration, n.push(r)), r = [
            s
        ], r.byteLength = s.data.byteLength, r.pts = s.pts, r.dts = s.dts) : (s.nalUnitType === "slice_layer_without_partitioning_rbsp_idr" && (r.keyFrame = !0), r.duration = s.dts - r.dts, r.byteLength += s.data.byteLength, r.push(s));
        return n.length && (!r.duration || r.duration <= 0) && (r.duration = n[n.length - 1].duration), n.byteLength += r.byteLength, n.nalCount += r.length, n.duration += r.duration, n.push(r), n;
    }, Lp = function(e) {
        var t, s, r = [], n = [];
        for(r.byteLength = 0, r.nalCount = 0, r.duration = 0, r.pts = e[0].pts, r.dts = e[0].dts, n.byteLength = 0, n.nalCount = 0, n.duration = 0, n.pts = e[0].pts, n.dts = e[0].dts, t = 0; t < e.length; t++)s = e[t], s.keyFrame ? (r.length && (n.push(r), n.byteLength += r.byteLength, n.nalCount += r.nalCount, n.duration += r.duration), r = [
            s
        ], r.nalCount = s.length, r.byteLength = s.byteLength, r.pts = s.pts, r.dts = s.dts, r.duration = s.duration) : (r.duration += s.duration, r.nalCount += s.length, r.byteLength += s.byteLength, r.push(s));
        return n.length && r.duration <= 0 && (r.duration = n[n.length - 1].duration), n.byteLength += r.byteLength, n.nalCount += r.nalCount, n.duration += r.duration, n.push(r), n;
    }, Np = function(e) {
        var t;
        return !e[0][0].keyFrame && e.length > 1 && (t = e.shift(), e.byteLength -= t.byteLength, e.nalCount -= t.nalCount, e[0][0].dts = t.dts, e[0][0].pts = t.pts, e[0][0].duration += t.duration), e;
    }, zp = function() {
        return {
            size: 0,
            flags: {
                isLeading: 0,
                dependsOn: 1,
                isDependedOn: 0,
                hasRedundancy: 0,
                degradationPriority: 0,
                isNonSyncSample: 1
            }
        };
    }, Ka = function(e, t) {
        var s = zp();
        return s.dataOffset = t, s.compositionTimeOffset = e.pts - e.dts, s.duration = e.duration, s.size = 4 * e.length, s.size += e.byteLength, e.keyFrame && (s.flags.dependsOn = 2, s.flags.isNonSyncSample = 0), s;
    }, Gp = function(e, t) {
        var s, r, n, a, o, u = t || 0, l = [];
        for(s = 0; s < e.length; s++)for(a = e[s], r = 0; r < a.length; r++)o = a[r], n = Ka(o, u), u += n.size, l.push(n);
        return l;
    }, Vp = function(e) {
        var t, s, r, n, a, o, u = 0, l = e.byteLength, h = e.nalCount, d = l + 4 * h, c = new Uint8Array(d), p = new DataView(c.buffer);
        for(t = 0; t < e.length; t++)for(n = e[t], s = 0; s < n.length; s++)for(a = n[s], r = 0; r < a.length; r++)o = a[r], p.setUint32(u, o.data.byteLength), u += 4, c.set(o.data, u), u += o.data.byteLength;
        return c;
    }, Hp = function(e, t) {
        var s, r = t || 0, n = [];
        return s = Ka(e, r), n.push(s), n;
    }, qp = function(e) {
        var t, s, r = 0, n = e.byteLength, a = e.length, o = n + 4 * a, u = new Uint8Array(o), l = new DataView(u.buffer);
        for(t = 0; t < e.length; t++)s = e[t], l.setUint32(r, s.data.byteLength), r += 4, u.set(s.data, r), r += s.data.byteLength;
        return u;
    };
    $a.exports = {
        groupNalsIntoFrames: Op,
        groupFramesIntoGops: Lp,
        extendFirstKeyFrame: Np,
        generateSampleTable: Gp,
        concatenateNalData: Vp,
        generateSampleTableForFrame: Hp,
        concatenateNalDataForFrame: qp
    };
});
var $e833773b1f4e7d0f$var$Za = $e833773b1f4e7d0f$var$v((UT, Qa)=>{
    "use strict";
    var Ie = [
        33,
        16,
        5,
        32,
        164,
        27
    ], As = [
        33,
        65,
        108,
        84,
        1,
        2,
        4,
        8,
        168,
        2,
        4,
        8,
        17,
        191,
        252
    ], A = function(e) {
        for(var t = []; e--;)t.push(0);
        return t;
    }, Wp = function(e) {
        return Object.keys(e).reduce(function(t, s) {
            return t[s] = new Uint8Array(e[s].reduce(function(r, n) {
                return r.concat(n);
            }, [])), t;
        }, {});
    }, Ds;
    Qa.exports = function() {
        if (!Ds) {
            var i = {
                96e3: [
                    Ie,
                    [
                        227,
                        64
                    ],
                    A(154),
                    [
                        56
                    ]
                ],
                88200: [
                    Ie,
                    [
                        231
                    ],
                    A(170),
                    [
                        56
                    ]
                ],
                64e3: [
                    Ie,
                    [
                        248,
                        192
                    ],
                    A(240),
                    [
                        56
                    ]
                ],
                48e3: [
                    Ie,
                    [
                        255,
                        192
                    ],
                    A(268),
                    [
                        55,
                        148,
                        128
                    ],
                    A(54),
                    [
                        112
                    ]
                ],
                44100: [
                    Ie,
                    [
                        255,
                        192
                    ],
                    A(268),
                    [
                        55,
                        163,
                        128
                    ],
                    A(84),
                    [
                        112
                    ]
                ],
                32e3: [
                    Ie,
                    [
                        255,
                        192
                    ],
                    A(268),
                    [
                        55,
                        234
                    ],
                    A(226),
                    [
                        112
                    ]
                ],
                24e3: [
                    Ie,
                    [
                        255,
                        192
                    ],
                    A(268),
                    [
                        55,
                        255,
                        128
                    ],
                    A(268),
                    [
                        111,
                        112
                    ],
                    A(126),
                    [
                        224
                    ]
                ],
                16e3: [
                    Ie,
                    [
                        255,
                        192
                    ],
                    A(268),
                    [
                        55,
                        255,
                        128
                    ],
                    A(268),
                    [
                        111,
                        255
                    ],
                    A(269),
                    [
                        223,
                        108
                    ],
                    A(195),
                    [
                        1,
                        192
                    ]
                ],
                12e3: [
                    As,
                    A(268),
                    [
                        3,
                        127,
                        248
                    ],
                    A(268),
                    [
                        6,
                        255,
                        240
                    ],
                    A(268),
                    [
                        13,
                        255,
                        224
                    ],
                    A(268),
                    [
                        27,
                        253,
                        128
                    ],
                    A(259),
                    [
                        56
                    ]
                ],
                11025: [
                    As,
                    A(268),
                    [
                        3,
                        127,
                        248
                    ],
                    A(268),
                    [
                        6,
                        255,
                        240
                    ],
                    A(268),
                    [
                        13,
                        255,
                        224
                    ],
                    A(268),
                    [
                        27,
                        255,
                        192
                    ],
                    A(268),
                    [
                        55,
                        175,
                        128
                    ],
                    A(108),
                    [
                        112
                    ]
                ],
                8e3: [
                    As,
                    A(268),
                    [
                        3,
                        121,
                        16
                    ],
                    A(47),
                    [
                        7
                    ]
                ]
            };
            Ds = Wp(i);
        }
        return Ds;
    };
});
var $e833773b1f4e7d0f$var$Ps = $e833773b1f4e7d0f$var$v((ET, Ja)=>{
    "use strict";
    var Yp = $e833773b1f4e7d0f$var$Za(), bi = $e833773b1f4e7d0f$var$_e(), jp = function(e) {
        var t, s, r = 0;
        for(t = 0; t < e.length; t++)s = e[t], r += s.data.byteLength;
        return r;
    }, Xp = function(e, t, s, r) {
        var n, a = 0, o = 0, u = 0, l = 0, h, d, c;
        if (t.length && (n = bi.audioTsToVideoTs(e.baseMediaDecodeTime, e.samplerate), a = Math.ceil(bi.ONE_SECOND_IN_TS / (e.samplerate / 1024)), s && r && (o = n - Math.max(s, r), u = Math.floor(o / a), l = u * a), !(u < 1 || l > bi.ONE_SECOND_IN_TS / 2))) {
            for(h = Yp()[e.samplerate], h || (h = t[0].data), d = 0; d < u; d++)c = t[0], t.splice(0, 0, {
                data: h,
                dts: c.dts - a,
                pts: c.pts - a
            });
            return e.baseMediaDecodeTime -= Math.floor(bi.videoTsToAudioTs(l, e.samplerate)), l;
        }
    }, Kp = function(e, t, s) {
        return t.minSegmentDts >= s ? e : (t.minSegmentDts = 1 / 0, e.filter(function(r) {
            return r.dts >= s ? (t.minSegmentDts = Math.min(t.minSegmentDts, r.dts), t.minSegmentPts = t.minSegmentDts, !0) : !1;
        }));
    }, $p = function(e) {
        var t, s, r = [];
        for(t = 0; t < e.length; t++)s = e[t], r.push({
            size: s.data.byteLength,
            duration: 1024
        });
        return r;
    }, Qp = function(e) {
        var t, s, r = 0, n = new Uint8Array(jp(e));
        for(t = 0; t < e.length; t++)s = e[t], n.set(s.data, r), r += s.data.byteLength;
        return n;
    };
    Ja.exports = {
        prefixWithSilence: Xp,
        trimAdtsFramesByEarliestDts: Kp,
        generateSampleTable: $p,
        concatenateFrameData: Qp
    };
});
var $e833773b1f4e7d0f$var$It = $e833773b1f4e7d0f$var$v((IT, eo)=>{
    "use strict";
    var Zp = $e833773b1f4e7d0f$var$_e().ONE_SECOND_IN_TS, Jp = function(e, t) {
        typeof t.pts == "number" && (e.timelineStartInfo.pts === void 0 && (e.timelineStartInfo.pts = t.pts), e.minSegmentPts === void 0 ? e.minSegmentPts = t.pts : e.minSegmentPts = Math.min(e.minSegmentPts, t.pts), e.maxSegmentPts === void 0 ? e.maxSegmentPts = t.pts : e.maxSegmentPts = Math.max(e.maxSegmentPts, t.pts)), typeof t.dts == "number" && (e.timelineStartInfo.dts === void 0 && (e.timelineStartInfo.dts = t.dts), e.minSegmentDts === void 0 ? e.minSegmentDts = t.dts : e.minSegmentDts = Math.min(e.minSegmentDts, t.dts), e.maxSegmentDts === void 0 ? e.maxSegmentDts = t.dts : e.maxSegmentDts = Math.max(e.maxSegmentDts, t.dts));
    }, em = function(e) {
        delete e.minSegmentDts, delete e.maxSegmentDts, delete e.minSegmentPts, delete e.maxSegmentPts;
    }, tm = function(e, t) {
        var s, r, n = e.minSegmentDts;
        return t || (n -= e.timelineStartInfo.dts), s = e.timelineStartInfo.baseMediaDecodeTime, s += n, s = Math.max(0, s), e.type === "audio" && (r = e.samplerate / Zp, s *= r, s = Math.floor(s)), s;
    };
    eo.exports = {
        clearDtsInfo: em,
        calculateTrackBaseMediaDecodeTime: tm,
        collectDtsInfo: Jp
    };
});
var $e833773b1f4e7d0f$var$ks = $e833773b1f4e7d0f$var$v((CT, io)=>{
    "use strict";
    var to = 4, im = 128, sm = function(e) {
        for(var t = 0, s = {
            payloadType: -1,
            payloadSize: 0
        }, r = 0, n = 0; t < e.byteLength && e[t] !== im;){
            for(; e[t] === 255;)r += 255, t++;
            for(r += e[t++]; e[t] === 255;)n += 255, t++;
            if (n += e[t++], !s.payload && r === to) {
                var a = String.fromCharCode(e[t + 3], e[t + 4], e[t + 5], e[t + 6]);
                if (a === "GA94") {
                    s.payloadType = r, s.payloadSize = n, s.payload = e.subarray(t, t + n);
                    break;
                } else s.payload = void 0;
            }
            t += n, r = 0, n = 0;
        }
        return s;
    }, rm = function(e) {
        return e.payload[0] !== 181 || (e.payload[1] << 8 | e.payload[2]) !== 49 || String.fromCharCode(e.payload[3], e.payload[4], e.payload[5], e.payload[6]) !== "GA94" || e.payload[7] !== 3 ? null : e.payload.subarray(8, e.payload.length - 1);
    }, nm = function(e, t) {
        var s = [], r, n, a, o;
        if (!(t[0] & 64)) return s;
        for(n = t[0] & 31, r = 0; r < n; r++)a = r * 3, o = {
            type: t[a + 2] & 3,
            pts: e
        }, t[a + 2] & 4 && (o.ccData = t[a + 3] << 8 | t[a + 4], s.push(o));
        return s;
    }, am = function(e) {
        for(var t = e.byteLength, s = [], r = 1, n, a; r < t - 2;)e[r] === 0 && e[r + 1] === 0 && e[r + 2] === 3 ? (s.push(r + 2), r += 2) : r++;
        if (s.length === 0) return e;
        n = t - s.length, a = new Uint8Array(n);
        var o = 0;
        for(r = 0; r < n; o++, r++)o === s[0] && (o++, s.shift()), a[r] = e[o];
        return a;
    };
    io.exports = {
        parseSei: sm,
        parseUserData: rm,
        parseCaptionPackets: nm,
        discardEmulationPreventionBytes: am,
        USER_DATA_REGISTERED_ITU_T_T35: to
    };
});
var $e833773b1f4e7d0f$var$Fs = $e833773b1f4e7d0f$var$v((BT, so)=>{
    "use strict";
    var Rs = $e833773b1f4e7d0f$var$te(), Si = $e833773b1f4e7d0f$var$ks(), ie = function i(e) {
        e = e || {}, i.prototype.init.call(this), this.parse708captions_ = typeof e.parse708captions == "boolean" ? e.parse708captions : !0, this.captionPackets_ = [], this.ccStreams_ = [
            new O(0, 0),
            new O(0, 1),
            new O(1, 0),
            new O(1, 1)
        ], this.parse708captions_ && (this.cc708Stream_ = new k({
            captionServices: e.captionServices
        })), this.reset(), this.ccStreams_.forEach(function(t) {
            t.on("data", this.trigger.bind(this, "data")), t.on("partialdone", this.trigger.bind(this, "partialdone")), t.on("done", this.trigger.bind(this, "done"));
        }, this), this.parse708captions_ && (this.cc708Stream_.on("data", this.trigger.bind(this, "data")), this.cc708Stream_.on("partialdone", this.trigger.bind(this, "partialdone")), this.cc708Stream_.on("done", this.trigger.bind(this, "done")));
    };
    ie.prototype = new Rs;
    ie.prototype.push = function(i) {
        var e, t, s;
        if (i.nalUnitType === "sei_rbsp" && (e = Si.parseSei(i.escapedRBSP), !!e.payload && e.payloadType === Si.USER_DATA_REGISTERED_ITU_T_T35 && (t = Si.parseUserData(e), !!t))) {
            if (i.dts < this.latestDts_) {
                this.ignoreNextEqualDts_ = !0;
                return;
            } else if (i.dts === this.latestDts_ && this.ignoreNextEqualDts_) {
                this.numSameDts_--, this.numSameDts_ || (this.ignoreNextEqualDts_ = !1);
                return;
            }
            s = Si.parseCaptionPackets(i.pts, t), this.captionPackets_ = this.captionPackets_.concat(s), this.latestDts_ !== i.dts && (this.numSameDts_ = 0), this.numSameDts_++, this.latestDts_ = i.dts;
        }
    };
    ie.prototype.flushCCStreams = function(i) {
        this.ccStreams_.forEach(function(e) {
            return i === "flush" ? e.flush() : e.partialFlush();
        }, this);
    };
    ie.prototype.flushStream = function(i) {
        if (!this.captionPackets_.length) {
            this.flushCCStreams(i);
            return;
        }
        this.captionPackets_.forEach(function(e, t) {
            e.presortIndex = t;
        }), this.captionPackets_.sort(function(e, t) {
            return e.pts === t.pts ? e.presortIndex - t.presortIndex : e.pts - t.pts;
        }), this.captionPackets_.forEach(function(e) {
            e.type < 2 ? this.dispatchCea608Packet(e) : this.dispatchCea708Packet(e);
        }, this), this.captionPackets_.length = 0, this.flushCCStreams(i);
    };
    ie.prototype.flush = function() {
        return this.flushStream("flush");
    };
    ie.prototype.partialFlush = function() {
        return this.flushStream("partialFlush");
    };
    ie.prototype.reset = function() {
        this.latestDts_ = null, this.ignoreNextEqualDts_ = !1, this.numSameDts_ = 0, this.activeCea608Channel_ = [
            null,
            null
        ], this.ccStreams_.forEach(function(i) {
            i.reset();
        });
    };
    ie.prototype.dispatchCea608Packet = function(i) {
        this.setsTextOrXDSActive(i) ? this.activeCea608Channel_[i.type] = null : this.setsChannel1Active(i) ? this.activeCea608Channel_[i.type] = 0 : this.setsChannel2Active(i) && (this.activeCea608Channel_[i.type] = 1), this.activeCea608Channel_[i.type] !== null && this.ccStreams_[(i.type << 1) + this.activeCea608Channel_[i.type]].push(i);
    };
    ie.prototype.setsChannel1Active = function(i) {
        return (i.ccData & 30720) === 4096;
    };
    ie.prototype.setsChannel2Active = function(i) {
        return (i.ccData & 30720) === 6144;
    };
    ie.prototype.setsTextOrXDSActive = function(i) {
        return (i.ccData & 28928) === 256 || (i.ccData & 30974) === 4138 || (i.ccData & 30974) === 6186;
    };
    ie.prototype.dispatchCea708Packet = function(i) {
        this.parse708captions_ && this.cc708Stream_.push(i);
    };
    var om = {
        127: 9834,
        4128: 32,
        4129: 160,
        4133: 8230,
        4138: 352,
        4140: 338,
        4144: 9608,
        4145: 8216,
        4146: 8217,
        4147: 8220,
        4148: 8221,
        4149: 8226,
        4153: 8482,
        4154: 353,
        4156: 339,
        4157: 8480,
        4159: 376,
        4214: 8539,
        4215: 8540,
        4216: 8541,
        4217: 8542,
        4218: 9168,
        4219: 9124,
        4220: 9123,
        4221: 9135,
        4222: 9126,
        4223: 9121,
        4256: 12600
    }, um = function(e) {
        var t = om[e] || e;
        return e & 4096 && e === t ? "" : String.fromCharCode(t);
    }, wi = function(e) {
        return 32 <= e && e <= 127 || 160 <= e && e <= 255;
    }, xe = function(e) {
        this.windowNum = e, this.reset();
    };
    xe.prototype.reset = function() {
        this.clearText(), this.pendingNewLine = !1, this.winAttr = {}, this.penAttr = {}, this.penLoc = {}, this.penColor = {}, this.visible = 0, this.rowLock = 0, this.columnLock = 0, this.priority = 0, this.relativePositioning = 0, this.anchorVertical = 0, this.anchorHorizontal = 0, this.anchorPoint = 0, this.rowCount = 1, this.virtualRowCount = this.rowCount + 1, this.columnCount = 41, this.windowStyle = 0, this.penStyle = 0;
    };
    xe.prototype.getText = function() {
        return this.rows.join(`
`);
    };
    xe.prototype.clearText = function() {
        this.rows = [
            ""
        ], this.rowIdx = 0;
    };
    xe.prototype.newLine = function(i) {
        for(this.rows.length >= this.virtualRowCount && typeof this.beforeRowOverflow == "function" && this.beforeRowOverflow(i), this.rows.length > 0 && (this.rows.push(""), this.rowIdx++); this.rows.length > this.virtualRowCount;)this.rows.shift(), this.rowIdx--;
    };
    xe.prototype.isEmpty = function() {
        return this.rows.length === 0 ? !0 : this.rows.length === 1 ? this.rows[0] === "" : !1;
    };
    xe.prototype.addText = function(i) {
        this.rows[this.rowIdx] += i;
    };
    xe.prototype.backspace = function() {
        if (!this.isEmpty()) {
            var i = this.rows[this.rowIdx];
            this.rows[this.rowIdx] = i.substr(0, i.length - 1);
        }
    };
    var Ui = function(e, t, s) {
        this.serviceNum = e, this.text = "", this.currentWindow = new xe(-1), this.windows = [], this.stream = s, typeof t == "string" && this.createTextDecoder(t);
    };
    Ui.prototype.init = function(i, e) {
        this.startPts = i;
        for(var t = 0; t < 8; t++)this.windows[t] = new xe(t), typeof e == "function" && (this.windows[t].beforeRowOverflow = e);
    };
    Ui.prototype.setCurrentWindow = function(i) {
        this.currentWindow = this.windows[i];
    };
    Ui.prototype.createTextDecoder = function(i) {
        if (typeof TextDecoder > "u") this.stream.trigger("log", {
            level: "warn",
            message: "The `encoding` option is unsupported without TextDecoder support"
        });
        else try {
            this.textDecoder_ = new TextDecoder(i);
        } catch (e) {
            this.stream.trigger("log", {
                level: "warn",
                message: "TextDecoder could not be created with " + i + " encoding. " + e
            });
        }
    };
    var k = function i(e) {
        e = e || {}, i.prototype.init.call(this);
        var t = this, s = e.captionServices || {}, r = {}, n;
        Object.keys(s).forEach(function(a) {
            n = s[a], /^SERVICE/.test(a) && (r[a] = n.encoding);
        }), this.serviceEncodings = r, this.current708Packet = null, this.services = {}, this.push = function(a) {
            a.type === 3 ? (t.new708Packet(), t.add708Bytes(a)) : (t.current708Packet === null && t.new708Packet(), t.add708Bytes(a));
        };
    };
    k.prototype = new Rs;
    k.prototype.new708Packet = function() {
        this.current708Packet !== null && this.push708Packet(), this.current708Packet = {
            data: [],
            ptsVals: []
        };
    };
    k.prototype.add708Bytes = function(i) {
        var e = i.ccData, t = e >>> 8, s = e & 255;
        this.current708Packet.ptsVals.push(i.pts), this.current708Packet.data.push(t), this.current708Packet.data.push(s);
    };
    k.prototype.push708Packet = function() {
        var i = this.current708Packet, e = i.data, t = null, s = null, r = 0, n = e[r++];
        for(i.seq = n >> 6, i.sizeCode = n & 63; r < e.length; r++)n = e[r++], t = n >> 5, s = n & 31, t === 7 && s > 0 && (n = e[r++], t = n), this.pushServiceBlock(t, r, s), s > 0 && (r += s - 1);
    };
    k.prototype.pushServiceBlock = function(i, e, t) {
        var s, r = e, n = this.current708Packet.data, a = this.services[i];
        for(a || (a = this.initService(i, r)); r < e + t && r < n.length; r++)s = n[r], wi(s) ? r = this.handleText(r, a) : s === 24 ? r = this.multiByteCharacter(r, a) : s === 16 ? r = this.extendedCommands(r, a) : 128 <= s && s <= 135 ? r = this.setCurrentWindow(r, a) : 152 <= s && s <= 159 ? r = this.defineWindow(r, a) : s === 136 ? r = this.clearWindows(r, a) : s === 140 ? r = this.deleteWindows(r, a) : s === 137 ? r = this.displayWindows(r, a) : s === 138 ? r = this.hideWindows(r, a) : s === 139 ? r = this.toggleWindows(r, a) : s === 151 ? r = this.setWindowAttributes(r, a) : s === 144 ? r = this.setPenAttributes(r, a) : s === 145 ? r = this.setPenColor(r, a) : s === 146 ? r = this.setPenLocation(r, a) : s === 143 ? a = this.reset(r, a) : s === 8 ? a.currentWindow.backspace() : s === 12 ? a.currentWindow.clearText() : s === 13 ? a.currentWindow.pendingNewLine = !0 : s === 14 ? a.currentWindow.clearText() : s === 141 && r++;
    };
    k.prototype.extendedCommands = function(i, e) {
        var t = this.current708Packet.data, s = t[++i];
        return wi(s) && (i = this.handleText(i, e, {
            isExtended: !0
        })), i;
    };
    k.prototype.getPts = function(i) {
        return this.current708Packet.ptsVals[Math.floor(i / 2)];
    };
    k.prototype.initService = function(i, e) {
        var s = "SERVICE" + i, t = this, s, r;
        return s in this.serviceEncodings && (r = this.serviceEncodings[s]), this.services[i] = new Ui(i, r, t), this.services[i].init(this.getPts(e), function(n) {
            t.flushDisplayed(n, t.services[i]);
        }), this.services[i];
    };
    k.prototype.handleText = function(i, e, t) {
        var s = t && t.isExtended, r = t && t.isMultiByte, n = this.current708Packet.data, a = s ? 4096 : 0, o = n[i], u = n[i + 1], l = e.currentWindow, h, d;
        return e.textDecoder_ && !s ? (r ? (d = [
            o,
            u
        ], i++) : d = [
            o
        ], h = e.textDecoder_.decode(new Uint8Array(d))) : h = um(a | o), l.pendingNewLine && !l.isEmpty() && l.newLine(this.getPts(i)), l.pendingNewLine = !1, l.addText(h), i;
    };
    k.prototype.multiByteCharacter = function(i, e) {
        var t = this.current708Packet.data, s = t[i + 1], r = t[i + 2];
        return wi(s) && wi(r) && (i = this.handleText(++i, e, {
            isMultiByte: !0
        })), i;
    };
    k.prototype.setCurrentWindow = function(i, e) {
        var t = this.current708Packet.data, s = t[i], r = s & 7;
        return e.setCurrentWindow(r), i;
    };
    k.prototype.defineWindow = function(i, e) {
        var t = this.current708Packet.data, s = t[i], r = s & 7;
        e.setCurrentWindow(r);
        var n = e.currentWindow;
        return s = t[++i], n.visible = (s & 32) >> 5, n.rowLock = (s & 16) >> 4, n.columnLock = (s & 8) >> 3, n.priority = s & 7, s = t[++i], n.relativePositioning = (s & 128) >> 7, n.anchorVertical = s & 127, s = t[++i], n.anchorHorizontal = s, s = t[++i], n.anchorPoint = (s & 240) >> 4, n.rowCount = s & 15, s = t[++i], n.columnCount = s & 63, s = t[++i], n.windowStyle = (s & 56) >> 3, n.penStyle = s & 7, n.virtualRowCount = n.rowCount + 1, i;
    };
    k.prototype.setWindowAttributes = function(i, e) {
        var t = this.current708Packet.data, s = t[i], r = e.currentWindow.winAttr;
        return s = t[++i], r.fillOpacity = (s & 192) >> 6, r.fillRed = (s & 48) >> 4, r.fillGreen = (s & 12) >> 2, r.fillBlue = s & 3, s = t[++i], r.borderType = (s & 192) >> 6, r.borderRed = (s & 48) >> 4, r.borderGreen = (s & 12) >> 2, r.borderBlue = s & 3, s = t[++i], r.borderType += (s & 128) >> 5, r.wordWrap = (s & 64) >> 6, r.printDirection = (s & 48) >> 4, r.scrollDirection = (s & 12) >> 2, r.justify = s & 3, s = t[++i], r.effectSpeed = (s & 240) >> 4, r.effectDirection = (s & 12) >> 2, r.displayEffect = s & 3, i;
    };
    k.prototype.flushDisplayed = function(i, e) {
        for(var t = [], s = 0; s < 8; s++)e.windows[s].visible && !e.windows[s].isEmpty() && t.push(e.windows[s].getText());
        e.endPts = i, e.text = t.join(`

`), this.pushCaption(e), e.startPts = i;
    };
    k.prototype.pushCaption = function(i) {
        i.text !== "" && (this.trigger("data", {
            startPts: i.startPts,
            endPts: i.endPts,
            text: i.text,
            stream: "cc708_" + i.serviceNum
        }), i.text = "", i.startPts = i.endPts);
    };
    k.prototype.displayWindows = function(i, e) {
        var t = this.current708Packet.data, s = t[++i], r = this.getPts(i);
        this.flushDisplayed(r, e);
        for(var n = 0; n < 8; n++)s & 1 << n && (e.windows[n].visible = 1);
        return i;
    };
    k.prototype.hideWindows = function(i, e) {
        var t = this.current708Packet.data, s = t[++i], r = this.getPts(i);
        this.flushDisplayed(r, e);
        for(var n = 0; n < 8; n++)s & 1 << n && (e.windows[n].visible = 0);
        return i;
    };
    k.prototype.toggleWindows = function(i, e) {
        var t = this.current708Packet.data, s = t[++i], r = this.getPts(i);
        this.flushDisplayed(r, e);
        for(var n = 0; n < 8; n++)s & 1 << n && (e.windows[n].visible ^= 1);
        return i;
    };
    k.prototype.clearWindows = function(i, e) {
        var t = this.current708Packet.data, s = t[++i], r = this.getPts(i);
        this.flushDisplayed(r, e);
        for(var n = 0; n < 8; n++)s & 1 << n && e.windows[n].clearText();
        return i;
    };
    k.prototype.deleteWindows = function(i, e) {
        var t = this.current708Packet.data, s = t[++i], r = this.getPts(i);
        this.flushDisplayed(r, e);
        for(var n = 0; n < 8; n++)s & 1 << n && e.windows[n].reset();
        return i;
    };
    k.prototype.setPenAttributes = function(i, e) {
        var t = this.current708Packet.data, s = t[i], r = e.currentWindow.penAttr;
        return s = t[++i], r.textTag = (s & 240) >> 4, r.offset = (s & 12) >> 2, r.penSize = s & 3, s = t[++i], r.italics = (s & 128) >> 7, r.underline = (s & 64) >> 6, r.edgeType = (s & 56) >> 3, r.fontStyle = s & 7, i;
    };
    k.prototype.setPenColor = function(i, e) {
        var t = this.current708Packet.data, s = t[i], r = e.currentWindow.penColor;
        return s = t[++i], r.fgOpacity = (s & 192) >> 6, r.fgRed = (s & 48) >> 4, r.fgGreen = (s & 12) >> 2, r.fgBlue = s & 3, s = t[++i], r.bgOpacity = (s & 192) >> 6, r.bgRed = (s & 48) >> 4, r.bgGreen = (s & 12) >> 2, r.bgBlue = s & 3, s = t[++i], r.edgeRed = (s & 48) >> 4, r.edgeGreen = (s & 12) >> 2, r.edgeBlue = s & 3, i;
    };
    k.prototype.setPenLocation = function(i, e) {
        var t = this.current708Packet.data, s = t[i], r = e.currentWindow.penLoc;
        return e.currentWindow.pendingNewLine = !0, s = t[++i], r.row = s & 15, s = t[++i], r.column = s & 63, i;
    };
    k.prototype.reset = function(i, e) {
        var t = this.getPts(i);
        return this.flushDisplayed(t, e), this.initService(e.serviceNum, i);
    };
    var lm = {
        42: 225,
        92: 233,
        94: 237,
        95: 243,
        96: 250,
        123: 231,
        124: 247,
        125: 209,
        126: 241,
        127: 9608,
        304: 174,
        305: 176,
        306: 189,
        307: 191,
        308: 8482,
        309: 162,
        310: 163,
        311: 9834,
        312: 224,
        313: 160,
        314: 232,
        315: 226,
        316: 234,
        317: 238,
        318: 244,
        319: 251,
        544: 193,
        545: 201,
        546: 211,
        547: 218,
        548: 220,
        549: 252,
        550: 8216,
        551: 161,
        552: 42,
        553: 39,
        554: 8212,
        555: 169,
        556: 8480,
        557: 8226,
        558: 8220,
        559: 8221,
        560: 192,
        561: 194,
        562: 199,
        563: 200,
        564: 202,
        565: 203,
        566: 235,
        567: 206,
        568: 207,
        569: 239,
        570: 212,
        571: 217,
        572: 249,
        573: 219,
        574: 171,
        575: 187,
        800: 195,
        801: 227,
        802: 205,
        803: 204,
        804: 236,
        805: 210,
        806: 242,
        807: 213,
        808: 245,
        809: 123,
        810: 125,
        811: 92,
        812: 94,
        813: 95,
        814: 124,
        815: 126,
        816: 196,
        817: 228,
        818: 214,
        819: 246,
        820: 223,
        821: 165,
        822: 164,
        823: 9474,
        824: 197,
        825: 229,
        826: 216,
        827: 248,
        828: 9484,
        829: 9488,
        830: 9492,
        831: 9496
    }, Ti = function(e) {
        return e === null ? "" : (e = lm[e] || e, String.fromCharCode(e));
    }, Ei = 14, hm = [
        4352,
        4384,
        4608,
        4640,
        5376,
        5408,
        5632,
        5664,
        5888,
        5920,
        4096,
        4864,
        4896,
        5120,
        5152
    ], Ne = function() {
        for(var e = [], t = Ei + 1; t--;)e.push("");
        return e;
    }, O = function i(e, t) {
        i.prototype.init.call(this), this.field_ = e || 0, this.dataChannel_ = t || 0, this.name_ = "CC" + ((this.field_ << 1 | this.dataChannel_) + 1), this.setConstants(), this.reset(), this.push = function(s) {
            var r, n, a, o, u;
            if (r = s.ccData & 32639, r === this.lastControlCode_) {
                this.lastControlCode_ = null;
                return;
            }
            if ((r & 61440) === 4096 ? this.lastControlCode_ = r : r !== this.PADDING_ && (this.lastControlCode_ = null), a = r >>> 8, o = r & 255, r !== this.PADDING_) {
                if (r === this.RESUME_CAPTION_LOADING_) this.mode_ = "popOn";
                else if (r === this.END_OF_CAPTION_) this.mode_ = "popOn", this.clearFormatting(s.pts), this.flushDisplayed(s.pts), n = this.displayed_, this.displayed_ = this.nonDisplayed_, this.nonDisplayed_ = n, this.startPts_ = s.pts;
                else if (r === this.ROLL_UP_2_ROWS_) this.rollUpRows_ = 2, this.setRollUp(s.pts);
                else if (r === this.ROLL_UP_3_ROWS_) this.rollUpRows_ = 3, this.setRollUp(s.pts);
                else if (r === this.ROLL_UP_4_ROWS_) this.rollUpRows_ = 4, this.setRollUp(s.pts);
                else if (r === this.CARRIAGE_RETURN_) this.clearFormatting(s.pts), this.flushDisplayed(s.pts), this.shiftRowsUp_(), this.startPts_ = s.pts;
                else if (r === this.BACKSPACE_) this.mode_ === "popOn" ? this.nonDisplayed_[this.row_] = this.nonDisplayed_[this.row_].slice(0, -1) : this.displayed_[this.row_] = this.displayed_[this.row_].slice(0, -1);
                else if (r === this.ERASE_DISPLAYED_MEMORY_) this.flushDisplayed(s.pts), this.displayed_ = Ne();
                else if (r === this.ERASE_NON_DISPLAYED_MEMORY_) this.nonDisplayed_ = Ne();
                else if (r === this.RESUME_DIRECT_CAPTIONING_) this.mode_ !== "paintOn" && (this.flushDisplayed(s.pts), this.displayed_ = Ne()), this.mode_ = "paintOn", this.startPts_ = s.pts;
                else if (this.isSpecialCharacter(a, o)) a = (a & 3) << 8, u = Ti(a | o), this[this.mode_](s.pts, u), this.column_++;
                else if (this.isExtCharacter(a, o)) this.mode_ === "popOn" ? this.nonDisplayed_[this.row_] = this.nonDisplayed_[this.row_].slice(0, -1) : this.displayed_[this.row_] = this.displayed_[this.row_].slice(0, -1), a = (a & 3) << 8, u = Ti(a | o), this[this.mode_](s.pts, u), this.column_++;
                else if (this.isMidRowCode(a, o)) this.clearFormatting(s.pts), this[this.mode_](s.pts, " "), this.column_++, (o & 14) === 14 && this.addFormatting(s.pts, [
                    "i"
                ]), (o & 1) === 1 && this.addFormatting(s.pts, [
                    "u"
                ]);
                else if (this.isOffsetControlCode(a, o)) this.column_ += o & 3;
                else if (this.isPAC(a, o)) {
                    var l = hm.indexOf(r & 7968);
                    this.mode_ === "rollUp" && (l - this.rollUpRows_ + 1 < 0 && (l = this.rollUpRows_ - 1), this.setRollUp(s.pts, l)), l !== this.row_ && (this.clearFormatting(s.pts), this.row_ = l), o & 1 && this.formatting_.indexOf("u") === -1 && this.addFormatting(s.pts, [
                        "u"
                    ]), (r & 16) === 16 && (this.column_ = ((r & 14) >> 1) * 4), this.isColorPAC(o) && (o & 14) === 14 && this.addFormatting(s.pts, [
                        "i"
                    ]);
                } else this.isNormalChar(a) && (o === 0 && (o = null), u = Ti(a), u += Ti(o), this[this.mode_](s.pts, u), this.column_ += u.length);
            }
        };
    };
    O.prototype = new Rs;
    O.prototype.flushDisplayed = function(i) {
        var e = this.displayed_.map(function(t, s) {
            try {
                return t.trim();
            } catch  {
                return this.trigger("log", {
                    level: "warn",
                    message: "Skipping a malformed 608 caption at index " + s + "."
                }), "";
            }
        }, this).join(`
`).replace(/^\n+|\n+$/g, "");
        e.length && this.trigger("data", {
            startPts: this.startPts_,
            endPts: i,
            text: e,
            stream: this.name_
        });
    };
    O.prototype.reset = function() {
        this.mode_ = "popOn", this.topRow_ = 0, this.startPts_ = 0, this.displayed_ = Ne(), this.nonDisplayed_ = Ne(), this.lastControlCode_ = null, this.column_ = 0, this.row_ = Ei, this.rollUpRows_ = 2, this.formatting_ = [];
    };
    O.prototype.setConstants = function() {
        this.dataChannel_ === 0 ? (this.BASE_ = 16, this.EXT_ = 17, this.CONTROL_ = (20 | this.field_) << 8, this.OFFSET_ = 23) : this.dataChannel_ === 1 && (this.BASE_ = 24, this.EXT_ = 25, this.CONTROL_ = (28 | this.field_) << 8, this.OFFSET_ = 31), this.PADDING_ = 0, this.RESUME_CAPTION_LOADING_ = this.CONTROL_ | 32, this.END_OF_CAPTION_ = this.CONTROL_ | 47, this.ROLL_UP_2_ROWS_ = this.CONTROL_ | 37, this.ROLL_UP_3_ROWS_ = this.CONTROL_ | 38, this.ROLL_UP_4_ROWS_ = this.CONTROL_ | 39, this.CARRIAGE_RETURN_ = this.CONTROL_ | 45, this.RESUME_DIRECT_CAPTIONING_ = this.CONTROL_ | 41, this.BACKSPACE_ = this.CONTROL_ | 33, this.ERASE_DISPLAYED_MEMORY_ = this.CONTROL_ | 44, this.ERASE_NON_DISPLAYED_MEMORY_ = this.CONTROL_ | 46;
    };
    O.prototype.isSpecialCharacter = function(i, e) {
        return i === this.EXT_ && e >= 48 && e <= 63;
    };
    O.prototype.isExtCharacter = function(i, e) {
        return (i === this.EXT_ + 1 || i === this.EXT_ + 2) && e >= 32 && e <= 63;
    };
    O.prototype.isMidRowCode = function(i, e) {
        return i === this.EXT_ && e >= 32 && e <= 47;
    };
    O.prototype.isOffsetControlCode = function(i, e) {
        return i === this.OFFSET_ && e >= 33 && e <= 35;
    };
    O.prototype.isPAC = function(i, e) {
        return i >= this.BASE_ && i < this.BASE_ + 8 && e >= 64 && e <= 127;
    };
    O.prototype.isColorPAC = function(i) {
        return i >= 64 && i <= 79 || i >= 96 && i <= 127;
    };
    O.prototype.isNormalChar = function(i) {
        return i >= 32 && i <= 127;
    };
    O.prototype.setRollUp = function(i, e) {
        if (this.mode_ !== "rollUp" && (this.row_ = Ei, this.mode_ = "rollUp", this.flushDisplayed(i), this.nonDisplayed_ = Ne(), this.displayed_ = Ne()), e !== void 0 && e !== this.row_) for(var t = 0; t < this.rollUpRows_; t++)this.displayed_[e - t] = this.displayed_[this.row_ - t], this.displayed_[this.row_ - t] = "";
        e === void 0 && (e = this.row_), this.topRow_ = e - this.rollUpRows_ + 1;
    };
    O.prototype.addFormatting = function(i, e) {
        this.formatting_ = this.formatting_.concat(e);
        var t = e.reduce(function(s, r) {
            return s + "<" + r + ">";
        }, "");
        this[this.mode_](i, t);
    };
    O.prototype.clearFormatting = function(i) {
        if (this.formatting_.length) {
            var e = this.formatting_.reverse().reduce(function(t, s) {
                return t + "</" + s + ">";
            }, "");
            this.formatting_ = [], this[this.mode_](i, e);
        }
    };
    O.prototype.popOn = function(i, e) {
        var t = this.nonDisplayed_[this.row_];
        t += e, this.nonDisplayed_[this.row_] = t;
    };
    O.prototype.rollUp = function(i, e) {
        var t = this.displayed_[this.row_];
        t += e, this.displayed_[this.row_] = t;
    };
    O.prototype.shiftRowsUp_ = function() {
        var i;
        for(i = 0; i < this.topRow_; i++)this.displayed_[i] = "";
        for(i = this.row_ + 1; i < Ei + 1; i++)this.displayed_[i] = "";
        for(i = this.topRow_; i < this.row_; i++)this.displayed_[i] = this.displayed_[i + 1];
        this.displayed_[this.row_] = "";
    };
    O.prototype.paintOn = function(i, e) {
        var t = this.displayed_[this.row_];
        t += e, this.displayed_[this.row_] = t;
    };
    so.exports = {
        CaptionStream: ie,
        Cea608Stream: O,
        Cea708Stream: k
    };
});
var $e833773b1f4e7d0f$var$Ct = $e833773b1f4e7d0f$var$v((AT, ro)=>{
    "use strict";
    ro.exports = {
        H264_STREAM_TYPE: 27,
        ADTS_STREAM_TYPE: 15,
        METADATA_STREAM_TYPE: 21
    };
});
var $e833773b1f4e7d0f$var$Os = $e833773b1f4e7d0f$var$v((DT, oo)=>{
    "use strict";
    var dm = $e833773b1f4e7d0f$var$te(), cm = 8589934592, fm = 4294967296, no = "shared", Ms = function(e, t) {
        var s = 1;
        for(e > t && (s = -1); Math.abs(t - e) > fm;)e += s * cm;
        return e;
    }, ao = function i(e) {
        var t, s;
        i.prototype.init.call(this), this.type_ = e || no, this.push = function(r) {
            this.type_ !== no && r.type !== this.type_ || (s === void 0 && (s = r.dts), r.dts = Ms(r.dts, s), r.pts = Ms(r.pts, s), t = r.dts, this.trigger("data", r));
        }, this.flush = function() {
            s = t, this.trigger("done");
        }, this.endTimeline = function() {
            this.flush(), this.trigger("endedtimeline");
        }, this.discontinuity = function() {
            s = void 0, t = void 0;
        }, this.reset = function() {
            this.discontinuity(), this.trigger("reset");
        };
    };
    ao.prototype = new dm;
    oo.exports = {
        TimestampRolloverStream: ao,
        handleRollover: Ms
    };
});
var $e833773b1f4e7d0f$var$lo = $e833773b1f4e7d0f$var$v((PT, uo)=>{
    "use strict";
    var pm = $e833773b1f4e7d0f$var$te(), mm = $e833773b1f4e7d0f$var$Ct(), Ce = $e833773b1f4e7d0f$var$Us(), Ii;
    Ii = function(e) {
        var t = {
            descriptor: e && e.descriptor
        }, s = 0, r = [], n = 0, a;
        if (Ii.prototype.init.call(this), this.dispatchType = mm.METADATA_STREAM_TYPE.toString(16), t.descriptor) for(a = 0; a < t.descriptor.length; a++)this.dispatchType += ("00" + t.descriptor[a].toString(16)).slice(-2);
        this.push = function(o) {
            var u, l, h, d, c, p;
            if (o.type === "timed-metadata") {
                if (o.dataAlignmentIndicator && (n = 0, r.length = 0), r.length === 0 && (o.data.length < 10 || o.data[0] !== 73 || o.data[1] !== 68 || o.data[2] !== 51)) {
                    this.trigger("log", {
                        level: "warn",
                        message: "Skipping unrecognized metadata packet"
                    });
                    return;
                }
                if (r.push(o), n += o.data.byteLength, r.length === 1 && (s = Ce.parseSyncSafeInteger(o.data.subarray(6, 10)), s += 10), !(n < s)) {
                    for(u = {
                        data: new Uint8Array(s),
                        frames: [],
                        pts: r[0].pts,
                        dts: r[0].dts
                    }, c = 0; c < s;)u.data.set(r[0].data.subarray(0, s - c), c), c += r[0].data.byteLength, n -= r[0].data.byteLength, r.shift();
                    l = 10, u.data[5] & 64 && (l += 4, l += Ce.parseSyncSafeInteger(u.data.subarray(10, 14)), s -= Ce.parseSyncSafeInteger(u.data.subarray(16, 20)));
                    do {
                        if (h = Ce.parseSyncSafeInteger(u.data.subarray(l + 4, l + 8)), h < 1) {
                            this.trigger("log", {
                                level: "warn",
                                message: "Malformed ID3 frame encountered. Skipping remaining metadata parsing."
                            });
                            break;
                        }
                        if (p = String.fromCharCode(u.data[l], u.data[l + 1], u.data[l + 2], u.data[l + 3]), d = {
                            id: p,
                            data: u.data.subarray(l + 10, l + h + 10)
                        }, d.key = d.id, Ce.frameParsers[d.id] ? Ce.frameParsers[d.id](d) : d.id[0] === "T" ? Ce.frameParsers["T*"](d) : d.id[0] === "W" && Ce.frameParsers["W*"](d), d.owner === "com.apple.streaming.transportStreamTimestamp") {
                            var f = d.data, _ = (f[3] & 1) << 30 | f[4] << 22 | f[5] << 14 | f[6] << 6 | f[7] >>> 2;
                            _ *= 4, _ += f[7] & 3, d.timeStamp = _, u.pts === void 0 && u.dts === void 0 && (u.pts = d.timeStamp, u.dts = d.timeStamp), this.trigger("timestamp", d);
                        }
                        u.frames.push(d), l += 10, l += h;
                    }while (l < s);
                    this.trigger("data", u);
                }
            }
        };
    };
    Ii.prototype = new pm;
    uo.exports = Ii;
});
var $e833773b1f4e7d0f$var$At = $e833773b1f4e7d0f$var$v((kT, co)=>{
    "use strict";
    var zs = $e833773b1f4e7d0f$var$te(), Ls = $e833773b1f4e7d0f$var$Fs(), ue = $e833773b1f4e7d0f$var$Ct(), gm = $e833773b1f4e7d0f$var$Os().TimestampRolloverStream, Bi, Bt, Ai, Qe = 188, Ns = 71;
    Bi = function() {
        var e = new Uint8Array(Qe), t = 0;
        Bi.prototype.init.call(this), this.push = function(s) {
            var r = 0, n = Qe, a;
            for(t ? (a = new Uint8Array(s.byteLength + t), a.set(e.subarray(0, t)), a.set(s, t), t = 0) : a = s; n < a.byteLength;){
                if (a[r] === Ns && a[n] === Ns) {
                    this.trigger("data", a.subarray(r, n)), r += Qe, n += Qe;
                    continue;
                }
                r++, n++;
            }
            r < a.byteLength && (e.set(a.subarray(r), 0), t = a.byteLength - r);
        }, this.flush = function() {
            t === Qe && e[0] === Ns && (this.trigger("data", e), t = 0), this.trigger("done");
        }, this.endTimeline = function() {
            this.flush(), this.trigger("endedtimeline");
        }, this.reset = function() {
            t = 0, this.trigger("reset");
        };
    };
    Bi.prototype = new zs;
    Bt = function() {
        var e, t, s, r;
        Bt.prototype.init.call(this), r = this, this.packetsWaitingForPmt = [], this.programMapTable = void 0, e = function(a, o) {
            var u = 0;
            o.payloadUnitStartIndicator && (u += a[u] + 1), o.type === "pat" ? t(a.subarray(u), o) : s(a.subarray(u), o);
        }, t = function(a, o) {
            o.section_number = a[7], o.last_section_number = a[8], r.pmtPid = (a[10] & 31) << 8 | a[11], o.pmtPid = r.pmtPid;
        }, s = function(a, o) {
            var u, l, h, d;
            if (a[5] & 1) {
                for(r.programMapTable = {
                    video: null,
                    audio: null,
                    "timed-metadata": {}
                }, u = (a[1] & 15) << 8 | a[2], l = 3 + u - 4, h = (a[10] & 15) << 8 | a[11], d = 12 + h; d < l;){
                    var c = a[d], p = (a[d + 1] & 31) << 8 | a[d + 2];
                    c === ue.H264_STREAM_TYPE && r.programMapTable.video === null ? r.programMapTable.video = p : c === ue.ADTS_STREAM_TYPE && r.programMapTable.audio === null ? r.programMapTable.audio = p : c === ue.METADATA_STREAM_TYPE && (r.programMapTable["timed-metadata"][p] = c), d += ((a[d + 3] & 15) << 8 | a[d + 4]) + 5;
                }
                o.programMapTable = r.programMapTable;
            }
        }, this.push = function(n) {
            var a = {}, o = 4;
            if (a.payloadUnitStartIndicator = !!(n[1] & 64), a.pid = n[1] & 31, a.pid <<= 8, a.pid |= n[2], (n[3] & 48) >>> 4 > 1 && (o += n[o] + 1), a.pid === 0) a.type = "pat", e(n.subarray(o), a), this.trigger("data", a);
            else if (a.pid === this.pmtPid) for(a.type = "pmt", e(n.subarray(o), a), this.trigger("data", a); this.packetsWaitingForPmt.length;)this.processPes_.apply(this, this.packetsWaitingForPmt.shift());
            else this.programMapTable === void 0 ? this.packetsWaitingForPmt.push([
                n,
                o,
                a
            ]) : this.processPes_(n, o, a);
        }, this.processPes_ = function(n, a, o) {
            o.pid === this.programMapTable.video ? o.streamType = ue.H264_STREAM_TYPE : o.pid === this.programMapTable.audio ? o.streamType = ue.ADTS_STREAM_TYPE : o.streamType = this.programMapTable["timed-metadata"][o.pid], o.type = "pes", o.data = n.subarray(a), this.trigger("data", o);
        };
    };
    Bt.prototype = new zs;
    Bt.STREAM_TYPES = {
        h264: 27,
        adts: 15
    };
    Ai = function() {
        var e = this, t = !1, s = {
            data: [],
            size: 0
        }, r = {
            data: [],
            size: 0
        }, n = {
            data: [],
            size: 0
        }, a, o = function(h, d) {
            var c, p = h[0] << 16 | h[1] << 8 | h[2];
            d.data = new Uint8Array, p === 1 && (d.packetLength = 6 + (h[4] << 8 | h[5]), d.dataAlignmentIndicator = (h[6] & 4) !== 0, c = h[7], c & 192 && (d.pts = (h[9] & 14) << 27 | (h[10] & 255) << 20 | (h[11] & 254) << 12 | (h[12] & 255) << 5 | (h[13] & 254) >>> 3, d.pts *= 4, d.pts += (h[13] & 6) >>> 1, d.dts = d.pts, c & 64 && (d.dts = (h[14] & 14) << 27 | (h[15] & 255) << 20 | (h[16] & 254) << 12 | (h[17] & 255) << 5 | (h[18] & 254) >>> 3, d.dts *= 4, d.dts += (h[18] & 6) >>> 1)), d.data = h.subarray(9 + h[8]));
        }, u = function(h, d, c) {
            var p = new Uint8Array(h.size), f = {
                type: d
            }, _ = 0, m = 0, b = !1, S;
            if (!(!h.data.length || h.size < 9)) {
                for(f.trackId = h.data[0].pid, _ = 0; _ < h.data.length; _++)S = h.data[_], p.set(S.data, m), m += S.data.byteLength;
                o(p, f), b = d === "video" || f.packetLength <= h.size, (c || b) && (h.size = 0, h.data.length = 0), b && e.trigger("data", f);
            }
        };
        Ai.prototype.init.call(this), this.push = function(l) {
            ({
                pat: function() {},
                pes: function() {
                    var d, c;
                    switch(l.streamType){
                        case ue.H264_STREAM_TYPE:
                            d = s, c = "video";
                            break;
                        case ue.ADTS_STREAM_TYPE:
                            d = r, c = "audio";
                            break;
                        case ue.METADATA_STREAM_TYPE:
                            d = n, c = "timed-metadata";
                            break;
                        default:
                            return;
                    }
                    l.payloadUnitStartIndicator && u(d, c, !0), d.data.push(l), d.size += l.data.byteLength;
                },
                pmt: function() {
                    var d = {
                        type: "metadata",
                        tracks: []
                    };
                    a = l.programMapTable, a.video !== null && d.tracks.push({
                        timelineStartInfo: {
                            baseMediaDecodeTime: 0
                        },
                        id: +a.video,
                        codec: "avc",
                        type: "video"
                    }), a.audio !== null && d.tracks.push({
                        timelineStartInfo: {
                            baseMediaDecodeTime: 0
                        },
                        id: +a.audio,
                        codec: "adts",
                        type: "audio"
                    }), t = !0, e.trigger("data", d);
                }
            })[l.type]();
        }, this.reset = function() {
            s.size = 0, s.data.length = 0, r.size = 0, r.data.length = 0, this.trigger("reset");
        }, this.flushStreams_ = function() {
            u(s, "video"), u(r, "audio"), u(n, "timed-metadata");
        }, this.flush = function() {
            if (!t && a) {
                var l = {
                    type: "metadata",
                    tracks: []
                };
                a.video !== null && l.tracks.push({
                    timelineStartInfo: {
                        baseMediaDecodeTime: 0
                    },
                    id: +a.video,
                    codec: "avc",
                    type: "video"
                }), a.audio !== null && l.tracks.push({
                    timelineStartInfo: {
                        baseMediaDecodeTime: 0
                    },
                    id: +a.audio,
                    codec: "adts",
                    type: "audio"
                }), e.trigger("data", l);
            }
            t = !1, this.flushStreams_(), this.trigger("done");
        };
    };
    Ai.prototype = new zs;
    var ho = {
        PAT_PID: 0,
        MP2T_PACKET_LENGTH: Qe,
        TransportPacketStream: Bi,
        TransportParseStream: Bt,
        ElementaryStream: Ai,
        TimestampRolloverStream: gm,
        CaptionStream: Ls.CaptionStream,
        Cea608Stream: Ls.Cea608Stream,
        Cea708Stream: Ls.Cea708Stream,
        MetadataStream: $e833773b1f4e7d0f$var$lo()
    };
    for(Ci in ue)ue.hasOwnProperty(Ci) && (ho[Ci] = ue[Ci]);
    var Ci;
    co.exports = ho;
});
var $e833773b1f4e7d0f$var$Dt = $e833773b1f4e7d0f$var$v((RT, mo)=>{
    "use strict";
    var _m = [
        96e3,
        88200,
        64e3,
        48e3,
        44100,
        32e3,
        24e3,
        22050,
        16e3,
        12e3,
        11025,
        8e3,
        7350
    ], po = function(e, t) {
        var s = e[t + 6] << 21 | e[t + 7] << 14 | e[t + 8] << 7 | e[t + 9], r = e[t + 5], n = (r & 16) >> 4;
        return s = s >= 0 ? s : 0, n ? s + 20 : s + 10;
    }, xm = function i(e, t) {
        return e.length - t < 10 || e[t] !== 73 || e[t + 1] !== 68 || e[t + 2] !== 51 ? t : (t += po(e, t), i(e, t));
    }, ym = function(e) {
        var t = xm(e, 0);
        return e.length >= t + 2 && (e[t] & 255) === 255 && (e[t + 1] & 240) === 240 && (e[t + 1] & 22) === 16;
    }, fo = function(e) {
        return e[0] << 21 | e[1] << 14 | e[2] << 7 | e[3];
    }, vm = function(e, t, s) {
        var r, n = "";
        for(r = t; r < s; r++)n += "%" + ("00" + e[r].toString(16)).slice(-2);
        return n;
    }, bm = function(e, t, s) {
        return unescape(vm(e, t, s));
    }, Sm = function(e, t) {
        var s = (e[t + 5] & 224) >> 5, r = e[t + 4] << 3, n = e[t + 3] & 6144;
        return n | r | s;
    }, Tm = function(e, t) {
        return e[t] === 73 && e[t + 1] === 68 && e[t + 2] === 51 ? "timed-metadata" : e[t] & !0 && (e[t + 1] & 240) === 240 ? "audio" : null;
    }, wm = function(e) {
        for(var t = 0; t + 5 < e.length;){
            if (e[t] !== 255 || (e[t + 1] & 246) !== 240) {
                t++;
                continue;
            }
            return _m[(e[t + 2] & 60) >>> 2];
        }
        return null;
    }, Um = function(e) {
        var t, s, r, n;
        t = 10, e[5] & 64 && (t += 4, t += fo(e.subarray(10, 14)));
        do {
            if (s = fo(e.subarray(t + 4, t + 8)), s < 1) return null;
            if (n = String.fromCharCode(e[t], e[t + 1], e[t + 2], e[t + 3]), n === "PRIV") {
                r = e.subarray(t + 10, t + s + 10);
                for(var a = 0; a < r.byteLength; a++)if (r[a] === 0) {
                    var o = bm(r, 0, a);
                    if (o === "com.apple.streaming.transportStreamTimestamp") {
                        var u = r.subarray(a + 1), l = (u[3] & 1) << 30 | u[4] << 22 | u[5] << 14 | u[6] << 6 | u[7] >>> 2;
                        return l *= 4, l += u[7] & 3, l;
                    }
                    break;
                }
            }
            t += 10, t += s;
        }while (t < e.byteLength);
        return null;
    };
    mo.exports = {
        isLikelyAacData: ym,
        parseId3TagSize: po,
        parseAdtsSize: Sm,
        parseType: Tm,
        parseSampleRate: wm,
        parseAacTimestamp: Um
    };
});
var $e833773b1f4e7d0f$var$Gs = $e833773b1f4e7d0f$var$v((FT, _o)=>{
    "use strict";
    var Em = $e833773b1f4e7d0f$var$te(), go = $e833773b1f4e7d0f$var$Dt(), Di;
    Di = function() {
        var e = new Uint8Array, t = 0;
        Di.prototype.init.call(this), this.setTimestamp = function(s) {
            t = s;
        }, this.push = function(s) {
            var r = 0, n = 0, a, o, u, l;
            for(e.length ? (l = e.length, e = new Uint8Array(s.byteLength + l), e.set(e.subarray(0, l)), e.set(s, l)) : e = s; e.length - n >= 3;){
                if (e[n] === 73 && e[n + 1] === 68 && e[n + 2] === 51) {
                    if (e.length - n < 10 || (r = go.parseId3TagSize(e, n), n + r > e.length)) break;
                    o = {
                        type: "timed-metadata",
                        data: e.subarray(n, n + r)
                    }, this.trigger("data", o), n += r;
                    continue;
                } else if ((e[n] & 255) === 255 && (e[n + 1] & 240) === 240) {
                    if (e.length - n < 7 || (r = go.parseAdtsSize(e, n), n + r > e.length)) break;
                    u = {
                        type: "audio",
                        data: e.subarray(n, n + r),
                        pts: t,
                        dts: t
                    }, this.trigger("data", u), n += r;
                    continue;
                }
                n++;
            }
            a = e.length - n, a > 0 ? e = e.subarray(n) : e = new Uint8Array;
        }, this.reset = function() {
            e = new Uint8Array, this.trigger("reset");
        }, this.endTimeline = function() {
            e = new Uint8Array, this.trigger("endedtimeline");
        };
    };
    Di.prototype = new Em;
    _o.exports = Di;
});
var $e833773b1f4e7d0f$var$Vs = $e833773b1f4e7d0f$var$v((MT, xo)=>{
    "use strict";
    var Im = [
        "audioobjecttype",
        "channelcount",
        "samplerate",
        "samplingfrequencyindex",
        "samplesize"
    ];
    xo.exports = Im;
});
var $e833773b1f4e7d0f$var$Hs = $e833773b1f4e7d0f$var$v((OT, yo)=>{
    "use strict";
    var Cm = [
        "width",
        "height",
        "profileIdc",
        "levelIdc",
        "profileCompatibility",
        "sarRatio"
    ];
    yo.exports = Cm;
});
var $e833773b1f4e7d0f$var$Mi = $e833773b1f4e7d0f$var$v((LT, To)=>{
    "use strict";
    var Fi = $e833773b1f4e7d0f$var$te(), kt = $e833773b1f4e7d0f$var$yt(), Pt = $e833773b1f4e7d0f$var$Bs(), Pi = $e833773b1f4e7d0f$var$Ps(), le = $e833773b1f4e7d0f$var$It(), ye = $e833773b1f4e7d0f$var$At(), ki = $e833773b1f4e7d0f$var$_e(), vo = $e833773b1f4e7d0f$var$_t(), Bm = $e833773b1f4e7d0f$var$hi().H264Stream, Am = $e833773b1f4e7d0f$var$Gs(), Dm = $e833773b1f4e7d0f$var$Dt().isLikelyAacData, Pm = $e833773b1f4e7d0f$var$_e().ONE_SECOND_IN_TS, qs = $e833773b1f4e7d0f$var$Vs(), Ws = $e833773b1f4e7d0f$var$Hs(), Rt, Ze, Ri, ze, km = function(e, t) {
        t.stream = e, this.trigger("log", t);
    }, bo = function(e, t) {
        for(var s = Object.keys(t), r = 0; r < s.length; r++){
            var n = s[r];
            n === "headOfPipeline" || !t[n].on || t[n].on("log", km.bind(e, n));
        }
    }, So = function(e, t) {
        var s;
        if (e.length !== t.length) return !1;
        for(s = 0; s < e.length; s++)if (e[s] !== t[s]) return !1;
        return !0;
    }, Ys = function(e, t, s, r, n, a) {
        var o = s - t, u = r - t, l = n - s;
        return {
            start: {
                dts: e,
                pts: e + o
            },
            end: {
                dts: e + u,
                pts: e + l
            },
            prependedContentDuration: a,
            baseMediaDecodeTime: e
        };
    };
    Ze = function(e, t) {
        var s = [], r, n = 0, a = 0, o = 1 / 0;
        t = t || {}, r = t.firstSequenceNumber || 0, Ze.prototype.init.call(this), this.push = function(u) {
            le.collectDtsInfo(e, u), e && qs.forEach(function(l) {
                e[l] = u[l];
            }), s.push(u);
        }, this.setEarliestDts = function(u) {
            n = u;
        }, this.setVideoBaseMediaDecodeTime = function(u) {
            o = u;
        }, this.setAudioAppendStart = function(u) {
            a = u;
        }, this.flush = function() {
            var u, l, h, d, c, p, f;
            if (s.length === 0) {
                this.trigger("done", "AudioSegmentStream");
                return;
            }
            u = Pi.trimAdtsFramesByEarliestDts(s, e, n), e.baseMediaDecodeTime = le.calculateTrackBaseMediaDecodeTime(e, t.keepOriginalTimestamps), f = Pi.prefixWithSilence(e, u, a, o), e.samples = Pi.generateSampleTable(u), h = kt.mdat(Pi.concatenateFrameData(u)), s = [], l = kt.moof(r, [
                e
            ]), d = new Uint8Array(l.byteLength + h.byteLength), r++, d.set(l), d.set(h, l.byteLength), le.clearDtsInfo(e), c = Math.ceil(Pm * 1024 / e.samplerate), u.length && (p = u.length * c, this.trigger("segmentTimingInfo", Ys(ki.audioTsToVideoTs(e.baseMediaDecodeTime, e.samplerate), u[0].dts, u[0].pts, u[0].dts + p, u[0].pts + p, f || 0)), this.trigger("timingInfo", {
                start: u[0].pts,
                end: u[0].pts + p
            })), this.trigger("data", {
                track: e,
                boxes: d
            }), this.trigger("done", "AudioSegmentStream");
        }, this.reset = function() {
            le.clearDtsInfo(e), s = [], this.trigger("reset");
        };
    };
    Ze.prototype = new Fi;
    Rt = function(e, t) {
        var s, r = [], n = [], a, o;
        t = t || {}, s = t.firstSequenceNumber || 0, Rt.prototype.init.call(this), delete e.minPTS, this.gopCache_ = [], this.push = function(u) {
            le.collectDtsInfo(e, u), u.nalUnitType === "seq_parameter_set_rbsp" && !a && (a = u.config, e.sps = [
                u.data
            ], Ws.forEach(function(l) {
                e[l] = a[l];
            }, this)), u.nalUnitType === "pic_parameter_set_rbsp" && !o && (o = u.data, e.pps = [
                u.data
            ]), r.push(u);
        }, this.flush = function() {
            for(var u, l, h, d, c, p, f = 0, _, m; r.length && r[0].nalUnitType !== "access_unit_delimiter_rbsp";)r.shift();
            if (r.length === 0) {
                this.resetStream_(), this.trigger("done", "VideoSegmentStream");
                return;
            }
            if (u = Pt.groupNalsIntoFrames(r), h = Pt.groupFramesIntoGops(u), h[0][0].keyFrame || (l = this.getGopForFusion_(r[0], e), l ? (f = l.duration, h.unshift(l), h.byteLength += l.byteLength, h.nalCount += l.nalCount, h.pts = l.pts, h.dts = l.dts, h.duration += l.duration) : h = Pt.extendFirstKeyFrame(h)), n.length) {
                var b;
                if (t.alignGopsAtEnd ? b = this.alignGopsAtEnd_(h) : b = this.alignGopsAtStart_(h), !b) {
                    this.gopCache_.unshift({
                        gop: h.pop(),
                        pps: e.pps,
                        sps: e.sps
                    }), this.gopCache_.length = Math.min(6, this.gopCache_.length), r = [], this.resetStream_(), this.trigger("done", "VideoSegmentStream");
                    return;
                }
                le.clearDtsInfo(e), h = b;
            }
            le.collectDtsInfo(e, h), e.samples = Pt.generateSampleTable(h), c = kt.mdat(Pt.concatenateNalData(h)), e.baseMediaDecodeTime = le.calculateTrackBaseMediaDecodeTime(e, t.keepOriginalTimestamps), this.trigger("processedGopsInfo", h.map(function(S) {
                return {
                    pts: S.pts,
                    dts: S.dts,
                    byteLength: S.byteLength
                };
            })), _ = h[0], m = h[h.length - 1], this.trigger("segmentTimingInfo", Ys(e.baseMediaDecodeTime, _.dts, _.pts, m.dts + m.duration, m.pts + m.duration, f)), this.trigger("timingInfo", {
                start: h[0].pts,
                end: h[h.length - 1].pts + h[h.length - 1].duration
            }), this.gopCache_.unshift({
                gop: h.pop(),
                pps: e.pps,
                sps: e.sps
            }), this.gopCache_.length = Math.min(6, this.gopCache_.length), r = [], this.trigger("baseMediaDecodeTime", e.baseMediaDecodeTime), this.trigger("timelineStartInfo", e.timelineStartInfo), d = kt.moof(s, [
                e
            ]), p = new Uint8Array(d.byteLength + c.byteLength), s++, p.set(d), p.set(c, d.byteLength), this.trigger("data", {
                track: e,
                boxes: p
            }), this.resetStream_(), this.trigger("done", "VideoSegmentStream");
        }, this.reset = function() {
            this.resetStream_(), r = [], this.gopCache_.length = 0, n.length = 0, this.trigger("reset");
        }, this.resetStream_ = function() {
            le.clearDtsInfo(e), a = void 0, o = void 0;
        }, this.getGopForFusion_ = function(u) {
            var l = 45e3, h = 1e4, d = 1 / 0, c, p, f, _, m;
            for(m = 0; m < this.gopCache_.length; m++)_ = this.gopCache_[m], f = _.gop, !(!(e.pps && So(e.pps[0], _.pps[0])) || !(e.sps && So(e.sps[0], _.sps[0]))) && (f.dts < e.timelineStartInfo.dts || (c = u.dts - f.dts - f.duration, c >= -h && c <= l && (!p || d > c) && (p = _, d = c)));
            return p ? p.gop : null;
        }, this.alignGopsAtStart_ = function(u) {
            var l, h, d, c, p, f, _, m;
            for(p = u.byteLength, f = u.nalCount, _ = u.duration, l = h = 0; l < n.length && h < u.length && (d = n[l], c = u[h], d.pts !== c.pts);){
                if (c.pts > d.pts) {
                    l++;
                    continue;
                }
                h++, p -= c.byteLength, f -= c.nalCount, _ -= c.duration;
            }
            return h === 0 ? u : h === u.length ? null : (m = u.slice(h), m.byteLength = p, m.duration = _, m.nalCount = f, m.pts = m[0].pts, m.dts = m[0].dts, m);
        }, this.alignGopsAtEnd_ = function(u) {
            var l, h, d, c, p, f;
            for(l = n.length - 1, h = u.length - 1, p = null, f = !1; l >= 0 && h >= 0;){
                if (d = n[l], c = u[h], d.pts === c.pts) {
                    f = !0;
                    break;
                }
                if (d.pts > c.pts) {
                    l--;
                    continue;
                }
                l === n.length - 1 && (p = h), h--;
            }
            if (!f && p === null) return null;
            var _;
            if (f ? _ = h : _ = p, _ === 0) return u;
            var m = u.slice(_), b = m.reduce(function(S, C) {
                return S.byteLength += C.byteLength, S.duration += C.duration, S.nalCount += C.nalCount, S;
            }, {
                byteLength: 0,
                duration: 0,
                nalCount: 0
            });
            return m.byteLength = b.byteLength, m.duration = b.duration, m.nalCount = b.nalCount, m.pts = m[0].pts, m.dts = m[0].dts, m;
        }, this.alignGopsWith = function(u) {
            n = u;
        };
    };
    Rt.prototype = new Fi;
    ze = function(e, t) {
        this.numberOfTracks = 0, this.metadataStream = t, e = e || {}, typeof e.remux < "u" ? this.remuxTracks = !!e.remux : this.remuxTracks = !0, typeof e.keepOriginalTimestamps == "boolean" ? this.keepOriginalTimestamps = e.keepOriginalTimestamps : this.keepOriginalTimestamps = !1, this.pendingTracks = [], this.videoTrack = null, this.pendingBoxes = [], this.pendingCaptions = [], this.pendingMetadata = [], this.pendingBytes = 0, this.emittedTracks = 0, ze.prototype.init.call(this), this.push = function(s) {
            if (s.text) return this.pendingCaptions.push(s);
            if (s.frames) return this.pendingMetadata.push(s);
            this.pendingTracks.push(s.track), this.pendingBytes += s.boxes.byteLength, s.track.type === "video" && (this.videoTrack = s.track, this.pendingBoxes.push(s.boxes)), s.track.type === "audio" && (this.audioTrack = s.track, this.pendingBoxes.unshift(s.boxes));
        };
    };
    ze.prototype = new Fi;
    ze.prototype.flush = function(i) {
        var e = 0, t = {
            captions: [],
            captionStreams: {},
            metadata: [],
            info: {}
        }, s, r, n, a = 0, o;
        if (this.pendingTracks.length < this.numberOfTracks) {
            if (i !== "VideoSegmentStream" && i !== "AudioSegmentStream") return;
            if (this.remuxTracks) return;
            if (this.pendingTracks.length === 0) {
                this.emittedTracks++, this.emittedTracks >= this.numberOfTracks && (this.trigger("done"), this.emittedTracks = 0);
                return;
            }
        }
        if (this.videoTrack ? (a = this.videoTrack.timelineStartInfo.pts, Ws.forEach(function(u) {
            t.info[u] = this.videoTrack[u];
        }, this)) : this.audioTrack && (a = this.audioTrack.timelineStartInfo.pts, qs.forEach(function(u) {
            t.info[u] = this.audioTrack[u];
        }, this)), this.videoTrack || this.audioTrack) {
            for(this.pendingTracks.length === 1 ? t.type = this.pendingTracks[0].type : t.type = "combined", this.emittedTracks += this.pendingTracks.length, n = kt.initSegment(this.pendingTracks), t.initSegment = new Uint8Array(n.byteLength), t.initSegment.set(n), t.data = new Uint8Array(this.pendingBytes), o = 0; o < this.pendingBoxes.length; o++)t.data.set(this.pendingBoxes[o], e), e += this.pendingBoxes[o].byteLength;
            for(o = 0; o < this.pendingCaptions.length; o++)s = this.pendingCaptions[o], s.startTime = ki.metadataTsToSeconds(s.startPts, a, this.keepOriginalTimestamps), s.endTime = ki.metadataTsToSeconds(s.endPts, a, this.keepOriginalTimestamps), t.captionStreams[s.stream] = !0, t.captions.push(s);
            for(o = 0; o < this.pendingMetadata.length; o++)r = this.pendingMetadata[o], r.cueTime = ki.metadataTsToSeconds(r.pts, a, this.keepOriginalTimestamps), t.metadata.push(r);
            for(t.metadata.dispatchType = this.metadataStream.dispatchType, this.pendingTracks.length = 0, this.videoTrack = null, this.pendingBoxes.length = 0, this.pendingCaptions.length = 0, this.pendingBytes = 0, this.pendingMetadata.length = 0, this.trigger("data", t), o = 0; o < t.captions.length; o++)s = t.captions[o], this.trigger("caption", s);
            for(o = 0; o < t.metadata.length; o++)r = t.metadata[o], this.trigger("id3Frame", r);
        }
        this.emittedTracks >= this.numberOfTracks && (this.trigger("done"), this.emittedTracks = 0);
    };
    ze.prototype.setRemux = function(i) {
        this.remuxTracks = i;
    };
    Ri = function(e) {
        var t = this, s = !0, r, n;
        Ri.prototype.init.call(this), e = e || {}, this.baseMediaDecodeTime = e.baseMediaDecodeTime || 0, this.transmuxPipeline_ = {}, this.setupAacPipeline = function() {
            var a = {};
            this.transmuxPipeline_ = a, a.type = "aac", a.metadataStream = new ye.MetadataStream, a.aacStream = new Am, a.audioTimestampRolloverStream = new ye.TimestampRolloverStream("audio"), a.timedMetadataTimestampRolloverStream = new ye.TimestampRolloverStream("timed-metadata"), a.adtsStream = new vo, a.coalesceStream = new ze(e, a.metadataStream), a.headOfPipeline = a.aacStream, a.aacStream.pipe(a.audioTimestampRolloverStream).pipe(a.adtsStream), a.aacStream.pipe(a.timedMetadataTimestampRolloverStream).pipe(a.metadataStream).pipe(a.coalesceStream), a.metadataStream.on("timestamp", function(o) {
                a.aacStream.setTimestamp(o.timeStamp);
            }), a.aacStream.on("data", function(o) {
                o.type !== "timed-metadata" && o.type !== "audio" || a.audioSegmentStream || (n = n || {
                    timelineStartInfo: {
                        baseMediaDecodeTime: t.baseMediaDecodeTime
                    },
                    codec: "adts",
                    type: "audio"
                }, a.coalesceStream.numberOfTracks++, a.audioSegmentStream = new Ze(n, e), a.audioSegmentStream.on("log", t.getLogTrigger_("audioSegmentStream")), a.audioSegmentStream.on("timingInfo", t.trigger.bind(t, "audioTimingInfo")), a.adtsStream.pipe(a.audioSegmentStream).pipe(a.coalesceStream), t.trigger("trackinfo", {
                    hasAudio: !!n,
                    hasVideo: !!r
                }));
            }), a.coalesceStream.on("data", this.trigger.bind(this, "data")), a.coalesceStream.on("done", this.trigger.bind(this, "done")), bo(this, a);
        }, this.setupTsPipeline = function() {
            var a = {};
            this.transmuxPipeline_ = a, a.type = "ts", a.metadataStream = new ye.MetadataStream, a.packetStream = new ye.TransportPacketStream, a.parseStream = new ye.TransportParseStream, a.elementaryStream = new ye.ElementaryStream, a.timestampRolloverStream = new ye.TimestampRolloverStream, a.adtsStream = new vo, a.h264Stream = new Bm, a.captionStream = new ye.CaptionStream(e), a.coalesceStream = new ze(e, a.metadataStream), a.headOfPipeline = a.packetStream, a.packetStream.pipe(a.parseStream).pipe(a.elementaryStream).pipe(a.timestampRolloverStream), a.timestampRolloverStream.pipe(a.h264Stream), a.timestampRolloverStream.pipe(a.adtsStream), a.timestampRolloverStream.pipe(a.metadataStream).pipe(a.coalesceStream), a.h264Stream.pipe(a.captionStream).pipe(a.coalesceStream), a.elementaryStream.on("data", function(o) {
                var u;
                if (o.type === "metadata") {
                    for(u = o.tracks.length; u--;)!r && o.tracks[u].type === "video" ? (r = o.tracks[u], r.timelineStartInfo.baseMediaDecodeTime = t.baseMediaDecodeTime) : !n && o.tracks[u].type === "audio" && (n = o.tracks[u], n.timelineStartInfo.baseMediaDecodeTime = t.baseMediaDecodeTime);
                    r && !a.videoSegmentStream && (a.coalesceStream.numberOfTracks++, a.videoSegmentStream = new Rt(r, e), a.videoSegmentStream.on("log", t.getLogTrigger_("videoSegmentStream")), a.videoSegmentStream.on("timelineStartInfo", function(l) {
                        n && !e.keepOriginalTimestamps && (n.timelineStartInfo = l, a.audioSegmentStream.setEarliestDts(l.dts - t.baseMediaDecodeTime));
                    }), a.videoSegmentStream.on("processedGopsInfo", t.trigger.bind(t, "gopInfo")), a.videoSegmentStream.on("segmentTimingInfo", t.trigger.bind(t, "videoSegmentTimingInfo")), a.videoSegmentStream.on("baseMediaDecodeTime", function(l) {
                        n && a.audioSegmentStream.setVideoBaseMediaDecodeTime(l);
                    }), a.videoSegmentStream.on("timingInfo", t.trigger.bind(t, "videoTimingInfo")), a.h264Stream.pipe(a.videoSegmentStream).pipe(a.coalesceStream)), n && !a.audioSegmentStream && (a.coalesceStream.numberOfTracks++, a.audioSegmentStream = new Ze(n, e), a.audioSegmentStream.on("log", t.getLogTrigger_("audioSegmentStream")), a.audioSegmentStream.on("timingInfo", t.trigger.bind(t, "audioTimingInfo")), a.audioSegmentStream.on("segmentTimingInfo", t.trigger.bind(t, "audioSegmentTimingInfo")), a.adtsStream.pipe(a.audioSegmentStream).pipe(a.coalesceStream)), t.trigger("trackinfo", {
                        hasAudio: !!n,
                        hasVideo: !!r
                    });
                }
            }), a.coalesceStream.on("data", this.trigger.bind(this, "data")), a.coalesceStream.on("id3Frame", function(o) {
                o.dispatchType = a.metadataStream.dispatchType, t.trigger("id3Frame", o);
            }), a.coalesceStream.on("caption", this.trigger.bind(this, "caption")), a.coalesceStream.on("done", this.trigger.bind(this, "done")), bo(this, a);
        }, this.setBaseMediaDecodeTime = function(a) {
            var o = this.transmuxPipeline_;
            e.keepOriginalTimestamps || (this.baseMediaDecodeTime = a), n && (n.timelineStartInfo.dts = void 0, n.timelineStartInfo.pts = void 0, le.clearDtsInfo(n), o.audioTimestampRolloverStream && o.audioTimestampRolloverStream.discontinuity()), r && (o.videoSegmentStream && (o.videoSegmentStream.gopCache_ = []), r.timelineStartInfo.dts = void 0, r.timelineStartInfo.pts = void 0, le.clearDtsInfo(r), o.captionStream.reset()), o.timestampRolloverStream && o.timestampRolloverStream.discontinuity();
        }, this.setAudioAppendStart = function(a) {
            n && this.transmuxPipeline_.audioSegmentStream.setAudioAppendStart(a);
        }, this.setRemux = function(a) {
            var o = this.transmuxPipeline_;
            e.remux = a, o && o.coalesceStream && o.coalesceStream.setRemux(a);
        }, this.alignGopsWith = function(a) {
            r && this.transmuxPipeline_.videoSegmentStream && this.transmuxPipeline_.videoSegmentStream.alignGopsWith(a);
        }, this.getLogTrigger_ = function(a) {
            var o = this;
            return function(u) {
                u.stream = a, o.trigger("log", u);
            };
        }, this.push = function(a) {
            if (s) {
                var o = Dm(a);
                o && this.transmuxPipeline_.type !== "aac" ? this.setupAacPipeline() : !o && this.transmuxPipeline_.type !== "ts" && this.setupTsPipeline(), s = !1;
            }
            this.transmuxPipeline_.headOfPipeline.push(a);
        }, this.flush = function() {
            s = !0, this.transmuxPipeline_.headOfPipeline.flush();
        }, this.endTimeline = function() {
            this.transmuxPipeline_.headOfPipeline.endTimeline();
        }, this.reset = function() {
            this.transmuxPipeline_.headOfPipeline && this.transmuxPipeline_.headOfPipeline.reset();
        }, this.resetCaptions = function() {
            this.transmuxPipeline_.captionStream && this.transmuxPipeline_.captionStream.reset();
        };
    };
    Ri.prototype = new Fi;
    To.exports = {
        Transmuxer: Ri,
        VideoSegmentStream: Rt,
        AudioSegmentStream: Ze,
        AUDIO_PROPERTIES: qs,
        VIDEO_PROPERTIES: Ws,
        generateSegmentTimingInfo: Ys
    };
});
var $e833773b1f4e7d0f$var$Eo = $e833773b1f4e7d0f$var$v((NT, Uo)=>{
    "use strict";
    var Rm = $e833773b1f4e7d0f$var$ks().discardEmulationPreventionBytes, Fm = $e833773b1f4e7d0f$var$Fs().CaptionStream, Ft = $e833773b1f4e7d0f$var$fi(), Mm = $e833773b1f4e7d0f$var$_i(), Om = $e833773b1f4e7d0f$var$gi(), Lm = $e833773b1f4e7d0f$var$mi(), wo = $e833773b1f4e7d0f$var$ws(), Nm = function(e, t) {
        for(var s = e, r = 0; r < t.length; r++){
            var n = t[r];
            if (s < n.size) return n;
            s -= n.size;
        }
        return null;
    }, zm = function(e, t, s) {
        var r = new DataView(e.buffer, e.byteOffset, e.byteLength), n = {
            logs: [],
            seiNals: []
        }, a, o, u, l;
        for(o = 0; o + 4 < e.length; o += u)if (u = r.getUint32(o), o += 4, !(u <= 0)) switch(e[o] & 31){
            case 6:
                var h = e.subarray(o + 1, o + 1 + u), d = Nm(o, t);
                if (a = {
                    nalUnitType: "sei_rbsp",
                    size: u,
                    data: h,
                    escapedRBSP: Rm(h),
                    trackId: s
                }, d) a.pts = d.pts, a.dts = d.dts, l = d;
                else if (l) a.pts = l.pts, a.dts = l.dts;
                else {
                    n.logs.push({
                        level: "warn",
                        message: "We've encountered a nal unit without data at " + o + " for trackId " + s + ". See mux.js#223."
                    });
                    break;
                }
                n.seiNals.push(a);
                break;
            default:
                break;
        }
        return n;
    }, Gm = function(e, t, s) {
        var r = t, n = s.defaultSampleDuration || 0, a = s.defaultSampleSize || 0, o = s.trackId, u = [];
        return e.forEach(function(l) {
            var h = Om(l), d = h.samples;
            d.forEach(function(c) {
                c.duration === void 0 && (c.duration = n), c.size === void 0 && (c.size = a), c.trackId = o, c.dts = r, c.compositionTimeOffset === void 0 && (c.compositionTimeOffset = 0), typeof r == "bigint" ? (c.pts = r + wo.BigInt(c.compositionTimeOffset), r += wo.BigInt(c.duration)) : (c.pts = r + c.compositionTimeOffset, r += c.duration);
            }), u = u.concat(d);
        }), u;
    }, Vm = function(e, t) {
        var s = Ft(e, [
            "moof",
            "traf"
        ]), r = Ft(e, [
            "mdat"
        ]), n = {}, a = [];
        return r.forEach(function(o, u) {
            var l = s[u];
            a.push({
                mdat: o,
                traf: l
            });
        }), a.forEach(function(o) {
            var u = o.mdat, l = o.traf, h = Ft(l, [
                "tfhd"
            ]), d = Lm(h[0]), c = d.trackId, p = Ft(l, [
                "tfdt"
            ]), f = p.length > 0 ? Mm(p[0]).baseMediaDecodeTime : 0, _ = Ft(l, [
                "trun"
            ]), m, b;
            t === c && _.length > 0 && (m = Gm(_, f, d), b = zm(u, m, c), n[c] || (n[c] = {
                seiNals: [],
                logs: []
            }), n[c].seiNals = n[c].seiNals.concat(b.seiNals), n[c].logs = n[c].logs.concat(b.logs));
        }), n;
    }, Hm = function(e, t, s) {
        var r;
        if (t === null) return null;
        r = Vm(e, t);
        var n = r[t] || {};
        return {
            seiNals: n.seiNals,
            logs: n.logs,
            timescale: s
        };
    }, qm = function() {
        var e = !1, t, s, r, n, a, o;
        this.isInitialized = function() {
            return e;
        }, this.init = function(u) {
            t = new Fm, e = !0, o = u ? u.isPartial : !1, t.on("data", function(l) {
                l.startTime = l.startPts / n, l.endTime = l.endPts / n, a.captions.push(l), a.captionStreams[l.stream] = !0;
            }), t.on("log", function(l) {
                a.logs.push(l);
            });
        }, this.isNewInit = function(u, l) {
            return u && u.length === 0 || l && typeof l == "object" && Object.keys(l).length === 0 ? !1 : r !== u[0] || n !== l[r];
        }, this.parse = function(u, l, h) {
            var d;
            if (this.isInitialized()) {
                if (!l || !h) return null;
                if (this.isNewInit(l, h)) r = l[0], n = h[r];
                else if (r === null || !n) return s.push(u), null;
            } else return null;
            for(; s.length > 0;){
                var c = s.shift();
                this.parse(c, l, h);
            }
            return d = Hm(u, r, n), d && d.logs && (a.logs = a.logs.concat(d.logs)), d === null || !d.seiNals ? a.logs.length ? {
                logs: a.logs,
                captions: [],
                captionStreams: []
            } : null : (this.pushNals(d.seiNals), this.flushStream(), a);
        }, this.pushNals = function(u) {
            if (!this.isInitialized() || !u || u.length === 0) return null;
            u.forEach(function(l) {
                t.push(l);
            });
        }, this.flushStream = function() {
            if (!this.isInitialized()) return null;
            o ? t.partialFlush() : t.flush();
        }, this.clearParsedCaptions = function() {
            a.captions = [], a.captionStreams = {}, a.logs = [];
        }, this.resetCaptionStream = function() {
            if (!this.isInitialized()) return null;
            t.reset();
        }, this.clearAllCaptions = function() {
            this.clearParsedCaptions(), this.resetCaptionStream();
        }, this.reset = function() {
            s = [], r = null, n = null, a ? this.clearParsedCaptions() : a = {
                captions: [],
                captionStreams: {},
                logs: []
            }, this.resetCaptionStream();
        }, this.reset();
    };
    Uo.exports = qm;
});
var $e833773b1f4e7d0f$var$Co = $e833773b1f4e7d0f$var$v((zT, Io)=>{
    "use strict";
    Io.exports = {
        generator: $e833773b1f4e7d0f$var$yt(),
        probe: $e833773b1f4e7d0f$var$Xa(),
        Transmuxer: $e833773b1f4e7d0f$var$Mi().Transmuxer,
        AudioSegmentStream: $e833773b1f4e7d0f$var$Mi().AudioSegmentStream,
        VideoSegmentStream: $e833773b1f4e7d0f$var$Mi().VideoSegmentStream,
        CaptionParser: $e833773b1f4e7d0f$var$Eo()
    };
});
var $e833773b1f4e7d0f$var$Oi = $e833773b1f4e7d0f$var$v((GT, Bo)=>{
    "use strict";
    var B;
    B = function(e, t) {
        var s = 0, r = 16384, n = function(d, c) {
            var p, f = d.position + c;
            f < d.bytes.byteLength || (p = new Uint8Array(f * 2), p.set(d.bytes.subarray(0, d.position), 0), d.bytes = p, d.view = new DataView(d.bytes.buffer));
        }, a = B.widthBytes || new Uint8Array(5), o = B.heightBytes || new Uint8Array(6), u = B.videocodecidBytes || new Uint8Array(12), l;
        if (!B.widthBytes) {
            for(l = 0; l < 5; l++)a[l] = "width".charCodeAt(l);
            for(l = 0; l < 6; l++)o[l] = "height".charCodeAt(l);
            for(l = 0; l < 12; l++)u[l] = "videocodecid".charCodeAt(l);
            B.widthBytes = a, B.heightBytes = o, B.videocodecidBytes = u;
        }
        switch(this.keyFrame = !1, e){
            case B.VIDEO_TAG:
                this.length = 16, r *= 6;
                break;
            case B.AUDIO_TAG:
                this.length = 13, this.keyFrame = !0;
                break;
            case B.METADATA_TAG:
                this.length = 29, this.keyFrame = !0;
                break;
            default:
                throw new Error("Unknown FLV tag type");
        }
        this.bytes = new Uint8Array(r), this.view = new DataView(this.bytes.buffer), this.bytes[0] = e, this.position = this.length, this.keyFrame = t, this.pts = 0, this.dts = 0, this.writeBytes = function(h, d, c) {
            var p = d || 0, f;
            c = c || h.byteLength, f = p + c, n(this, c), this.bytes.set(h.subarray(p, f), this.position), this.position += c, this.length = Math.max(this.length, this.position);
        }, this.writeByte = function(h) {
            n(this, 1), this.bytes[this.position] = h, this.position++, this.length = Math.max(this.length, this.position);
        }, this.writeShort = function(h) {
            n(this, 2), this.view.setUint16(this.position, h), this.position += 2, this.length = Math.max(this.length, this.position);
        }, this.negIndex = function(h) {
            return this.bytes[this.length - h];
        }, this.nalUnitSize = function() {
            return s === 0 ? 0 : this.length - (s + 4);
        }, this.startNalUnit = function() {
            if (s > 0) throw new Error("Attempted to create new NAL wihout closing the old one");
            s = this.length, this.length += 4, this.position = this.length;
        }, this.endNalUnit = function(h) {
            var d, c;
            this.length === s + 4 ? this.length -= 4 : s > 0 && (d = s + 4, c = this.length - d, this.position = s, this.view.setUint32(this.position, c), this.position = this.length, h && h.push(this.bytes.subarray(d, d + c))), s = 0;
        }, this.writeMetaDataDouble = function(h, d) {
            var c;
            if (n(this, 2 + h.length + 9), this.view.setUint16(this.position, h.length), this.position += 2, h === "width") this.bytes.set(a, this.position), this.position += 5;
            else if (h === "height") this.bytes.set(o, this.position), this.position += 6;
            else if (h === "videocodecid") this.bytes.set(u, this.position), this.position += 12;
            else for(c = 0; c < h.length; c++)this.bytes[this.position] = h.charCodeAt(c), this.position++;
            this.position++, this.view.setFloat64(this.position, d), this.position += 8, this.length = Math.max(this.length, this.position), ++s;
        }, this.writeMetaDataBoolean = function(h, d) {
            var c;
            for(n(this, 2), this.view.setUint16(this.position, h.length), this.position += 2, c = 0; c < h.length; c++)n(this, 1), this.bytes[this.position] = h.charCodeAt(c), this.position++;
            n(this, 2), this.view.setUint8(this.position, 1), this.position++, this.view.setUint8(this.position, d ? 1 : 0), this.position++, this.length = Math.max(this.length, this.position), ++s;
        }, this.finalize = function() {
            var h, d;
            switch(this.bytes[0]){
                case B.VIDEO_TAG:
                    this.bytes[11] = (this.keyFrame || t ? 16 : 32) | 7, this.bytes[12] = t ? 0 : 1, h = this.pts - this.dts, this.bytes[13] = (h & 16711680) >>> 16, this.bytes[14] = (h & 65280) >>> 8, this.bytes[15] = (h & 255) >>> 0;
                    break;
                case B.AUDIO_TAG:
                    this.bytes[11] = 175, this.bytes[12] = t ? 0 : 1;
                    break;
                case B.METADATA_TAG:
                    this.position = 11, this.view.setUint8(this.position, 2), this.position++, this.view.setUint16(this.position, 10), this.position += 2, this.bytes.set([
                        111,
                        110,
                        77,
                        101,
                        116,
                        97,
                        68,
                        97,
                        116,
                        97
                    ], this.position), this.position += 10, this.bytes[this.position] = 8, this.position++, this.view.setUint32(this.position, s), this.position = this.length, this.bytes.set([
                        0,
                        0,
                        9
                    ], this.position), this.position += 3, this.length = this.position;
                    break;
            }
            return d = this.length - 11, this.bytes[1] = (d & 16711680) >>> 16, this.bytes[2] = (d & 65280) >>> 8, this.bytes[3] = (d & 255) >>> 0, this.bytes[4] = (this.dts & 16711680) >>> 16, this.bytes[5] = (this.dts & 65280) >>> 8, this.bytes[6] = (this.dts & 255) >>> 0, this.bytes[7] = (this.dts & 4278190080) >>> 24, this.bytes[8] = 0, this.bytes[9] = 0, this.bytes[10] = 0, n(this, 4), this.view.setUint32(this.length, this.length), this.length += 4, this.position += 4, this.bytes = this.bytes.subarray(0, this.length), this.frameTime = B.frameTime(this.bytes), this;
        };
    };
    B.AUDIO_TAG = 8;
    B.VIDEO_TAG = 9;
    B.METADATA_TAG = 18;
    B.isAudioFrame = function(i) {
        return B.AUDIO_TAG === i[0];
    };
    B.isVideoFrame = function(i) {
        return B.VIDEO_TAG === i[0];
    };
    B.isMetaData = function(i) {
        return B.METADATA_TAG === i[0];
    };
    B.isKeyFrame = function(i) {
        return B.isVideoFrame(i) ? i[11] === 23 : !!(B.isAudioFrame(i) || B.isMetaData(i));
    };
    B.frameTime = function(i) {
        var e = i[4] << 16;
        return e |= i[5] << 8, e |= i[6] << 0, e |= i[7] << 24, e;
    };
    Bo.exports = B;
});
var $e833773b1f4e7d0f$var$Do = $e833773b1f4e7d0f$var$v((VT, Ao)=>{
    "use strict";
    var Wm = $e833773b1f4e7d0f$var$te(), js = function i(e) {
        this.numberOfTracks = 0, this.metadataStream = e.metadataStream, this.videoTags = [], this.audioTags = [], this.videoTrack = null, this.audioTrack = null, this.pendingCaptions = [], this.pendingMetadata = [], this.pendingTracks = 0, this.processedTracks = 0, i.prototype.init.call(this), this.push = function(t) {
            if (t.text) return this.pendingCaptions.push(t);
            if (t.frames) return this.pendingMetadata.push(t);
            t.track.type === "video" && (this.videoTrack = t.track, this.videoTags = t.tags, this.pendingTracks++), t.track.type === "audio" && (this.audioTrack = t.track, this.audioTags = t.tags, this.pendingTracks++);
        };
    };
    js.prototype = new Wm;
    js.prototype.flush = function(i) {
        var e, t, s, r, n = {
            tags: {},
            captions: [],
            captionStreams: {},
            metadata: []
        };
        if (this.pendingTracks < this.numberOfTracks) {
            if (i !== "VideoSegmentStream" && i !== "AudioSegmentStream") return;
            if (this.pendingTracks === 0 && (this.processedTracks++, this.processedTracks < this.numberOfTracks)) return;
        }
        if (this.processedTracks += this.pendingTracks, this.pendingTracks = 0, !(this.processedTracks < this.numberOfTracks)) {
            for(this.videoTrack ? r = this.videoTrack.timelineStartInfo.pts : this.audioTrack && (r = this.audioTrack.timelineStartInfo.pts), n.tags.videoTags = this.videoTags, n.tags.audioTags = this.audioTags, s = 0; s < this.pendingCaptions.length; s++)t = this.pendingCaptions[s], t.startTime = t.startPts - r, t.startTime /= 9e4, t.endTime = t.endPts - r, t.endTime /= 9e4, n.captionStreams[t.stream] = !0, n.captions.push(t);
            for(s = 0; s < this.pendingMetadata.length; s++)e = this.pendingMetadata[s], e.cueTime = e.pts - r, e.cueTime /= 9e4, n.metadata.push(e);
            n.metadata.dispatchType = this.metadataStream.dispatchType, this.videoTrack = null, this.audioTrack = null, this.videoTags = [], this.audioTags = [], this.pendingCaptions.length = 0, this.pendingMetadata.length = 0, this.pendingTracks = 0, this.processedTracks = 0, this.trigger("data", n), this.trigger("done");
        }
    };
    Ao.exports = js;
});
var $e833773b1f4e7d0f$var$ko = $e833773b1f4e7d0f$var$v((HT, Po)=>{
    "use strict";
    var Ym = function() {
        var e = this;
        this.list = [], this.push = function(t) {
            this.list.push({
                bytes: t.bytes,
                dts: t.dts,
                pts: t.pts,
                keyFrame: t.keyFrame,
                metaDataTag: t.metaDataTag
            });
        }, Object.defineProperty(this, "length", {
            get: function() {
                return e.list.length;
            }
        });
    };
    Po.exports = Ym;
});
var $e833773b1f4e7d0f$var$Lo = $e833773b1f4e7d0f$var$v((qT, Oo)=>{
    "use strict";
    var Xs = $e833773b1f4e7d0f$var$te(), re = $e833773b1f4e7d0f$var$Oi(), Be = $e833773b1f4e7d0f$var$At(), jm = $e833773b1f4e7d0f$var$_t(), Xm = $e833773b1f4e7d0f$var$hi().H264Stream, Km = $e833773b1f4e7d0f$var$Do(), Ro = $e833773b1f4e7d0f$var$ko(), Li, Ni, zi, Ks, Fo, Mo;
    Ks = function(e, t) {
        typeof t.pts == "number" && (e.timelineStartInfo.pts === void 0 ? e.timelineStartInfo.pts = t.pts : e.timelineStartInfo.pts = Math.min(e.timelineStartInfo.pts, t.pts)), typeof t.dts == "number" && (e.timelineStartInfo.dts === void 0 ? e.timelineStartInfo.dts = t.dts : e.timelineStartInfo.dts = Math.min(e.timelineStartInfo.dts, t.dts));
    };
    Fo = function(e, t) {
        var s = new re(re.METADATA_TAG);
        return s.dts = t, s.pts = t, s.writeMetaDataDouble("videocodecid", 7), s.writeMetaDataDouble("width", e.width), s.writeMetaDataDouble("height", e.height), s;
    };
    Mo = function(e, t) {
        var s, r = new re(re.VIDEO_TAG, !0);
        for(r.dts = t, r.pts = t, r.writeByte(1), r.writeByte(e.profileIdc), r.writeByte(e.profileCompatibility), r.writeByte(e.levelIdc), r.writeByte(255), r.writeByte(225), r.writeShort(e.sps[0].length), r.writeBytes(e.sps[0]), r.writeByte(e.pps.length), s = 0; s < e.pps.length; ++s)r.writeShort(e.pps[s].length), r.writeBytes(e.pps[s]);
        return r;
    };
    zi = function(e) {
        var t = [], s = [], r;
        zi.prototype.init.call(this), this.push = function(n) {
            Ks(e, n), e && (e.audioobjecttype = n.audioobjecttype, e.channelcount = n.channelcount, e.samplerate = n.samplerate, e.samplingfrequencyindex = n.samplingfrequencyindex, e.samplesize = n.samplesize, e.extraData = e.audioobjecttype << 11 | e.samplingfrequencyindex << 7 | e.channelcount << 3), n.pts = Math.round(n.pts / 90), n.dts = Math.round(n.dts / 90), t.push(n);
        }, this.flush = function() {
            var n, a, o, u = new Ro;
            if (t.length === 0) {
                this.trigger("done", "AudioSegmentStream");
                return;
            }
            for(o = -1 / 0; t.length;)n = t.shift(), s.length && n.pts >= s[0] && (o = s.shift(), this.writeMetaDataTags(u, o)), (e.extraData !== r || n.pts - o >= 1e3) && (this.writeMetaDataTags(u, n.pts), r = e.extraData, o = n.pts), a = new re(re.AUDIO_TAG), a.pts = n.pts, a.dts = n.dts, a.writeBytes(n.data), u.push(a.finalize());
            s.length = 0, r = null, this.trigger("data", {
                track: e,
                tags: u.list
            }), this.trigger("done", "AudioSegmentStream");
        }, this.writeMetaDataTags = function(n, a) {
            var o;
            o = new re(re.METADATA_TAG), o.pts = a, o.dts = a, o.writeMetaDataDouble("audiocodecid", 10), o.writeMetaDataBoolean("stereo", e.channelcount === 2), o.writeMetaDataDouble("audiosamplerate", e.samplerate), o.writeMetaDataDouble("audiosamplesize", 16), n.push(o.finalize()), o = new re(re.AUDIO_TAG, !0), o.pts = a, o.dts = a, o.view.setUint16(o.position, e.extraData), o.position += 2, o.length = Math.max(o.length, o.position), n.push(o.finalize());
        }, this.onVideoKeyFrame = function(n) {
            s.push(n);
        };
    };
    zi.prototype = new Xs;
    Ni = function(e) {
        var t = [], s, r;
        Ni.prototype.init.call(this), this.finishFrame = function(n, a) {
            if (a) {
                if (s && e && e.newMetadata && (a.keyFrame || n.length === 0)) {
                    var o = Fo(s, a.dts).finalize(), u = Mo(e, a.dts).finalize();
                    o.metaDataTag = u.metaDataTag = !0, n.push(o), n.push(u), e.newMetadata = !1, this.trigger("keyframe", a.dts);
                }
                a.endNalUnit(), n.push(a.finalize()), r = null;
            }
        }, this.push = function(n) {
            Ks(e, n), n.pts = Math.round(n.pts / 90), n.dts = Math.round(n.dts / 90), t.push(n);
        }, this.flush = function() {
            for(var n, a = new Ro; t.length && t[0].nalUnitType !== "access_unit_delimiter_rbsp";)t.shift();
            if (t.length === 0) {
                this.trigger("done", "VideoSegmentStream");
                return;
            }
            for(; t.length;)n = t.shift(), n.nalUnitType === "seq_parameter_set_rbsp" ? (e.newMetadata = !0, s = n.config, e.width = s.width, e.height = s.height, e.sps = [
                n.data
            ], e.profileIdc = s.profileIdc, e.levelIdc = s.levelIdc, e.profileCompatibility = s.profileCompatibility, r.endNalUnit()) : n.nalUnitType === "pic_parameter_set_rbsp" ? (e.newMetadata = !0, e.pps = [
                n.data
            ], r.endNalUnit()) : n.nalUnitType === "access_unit_delimiter_rbsp" ? (r && this.finishFrame(a, r), r = new re(re.VIDEO_TAG), r.pts = n.pts, r.dts = n.dts) : (n.nalUnitType === "slice_layer_without_partitioning_rbsp_idr" && (r.keyFrame = !0), r.endNalUnit()), r.startNalUnit(), r.writeBytes(n.data);
            r && this.finishFrame(a, r), this.trigger("data", {
                track: e,
                tags: a.list
            }), this.trigger("done", "VideoSegmentStream");
        };
    };
    Ni.prototype = new Xs;
    Li = function(e) {
        var t = this, s, r, n, a, o, u, l, h, d, c, p, f;
        Li.prototype.init.call(this), e = e || {}, this.metadataStream = new Be.MetadataStream, e.metadataStream = this.metadataStream, s = new Be.TransportPacketStream, r = new Be.TransportParseStream, n = new Be.ElementaryStream, a = new Be.TimestampRolloverStream("video"), o = new Be.TimestampRolloverStream("audio"), u = new Be.TimestampRolloverStream("timed-metadata"), l = new jm, h = new Xm, f = new Km(e), s.pipe(r).pipe(n), n.pipe(a).pipe(h), n.pipe(o).pipe(l), n.pipe(u).pipe(this.metadataStream).pipe(f), p = new Be.CaptionStream(e), h.pipe(p).pipe(f), n.on("data", function(_) {
            var m, b, S;
            if (_.type === "metadata") {
                for(m = _.tracks.length; m--;)_.tracks[m].type === "video" ? b = _.tracks[m] : _.tracks[m].type === "audio" && (S = _.tracks[m]);
                b && !d && (f.numberOfTracks++, d = new Ni(b), h.pipe(d).pipe(f)), S && !c && (f.numberOfTracks++, c = new zi(S), l.pipe(c).pipe(f), d && d.on("keyframe", c.onVideoKeyFrame));
            }
        }), this.push = function(_) {
            s.push(_);
        }, this.flush = function() {
            s.flush();
        }, this.resetCaptions = function() {
            p.reset();
        }, f.on("data", function(_) {
            t.trigger("data", _);
        }), f.on("done", function() {
            t.trigger("done");
        });
    };
    Li.prototype = new Xs;
    Oo.exports = Li;
});
var $e833773b1f4e7d0f$var$Go = $e833773b1f4e7d0f$var$v((WT, zo)=>{
    "use strict";
    var No = $e833773b1f4e7d0f$var$Oi(), $m = function(e, t, s) {
        var r = new Uint8Array(9), n = new DataView(r.buffer), a, o, u;
        return e = e || 0, t = t === void 0 ? !0 : t, s = s === void 0 ? !0 : s, n.setUint8(0, 70), n.setUint8(1, 76), n.setUint8(2, 86), n.setUint8(3, 1), n.setUint8(4, (t ? 4 : 0) | (s ? 1 : 0)), n.setUint32(5, r.byteLength), e <= 0 ? (o = new Uint8Array(r.byteLength + 4), o.set(r), o.set([
            0,
            0,
            0,
            0
        ], r.byteLength), o) : (a = new No(No.METADATA_TAG), a.pts = a.dts = 0, a.writeMetaDataDouble("duration", e), u = a.finalize().length, o = new Uint8Array(r.byteLength + u), o.set(r), o.set(n.byteLength, u), o);
    };
    zo.exports = $m;
});
var $e833773b1f4e7d0f$var$Ho = $e833773b1f4e7d0f$var$v((YT, Vo)=>{
    "use strict";
    Vo.exports = {
        tag: $e833773b1f4e7d0f$var$Oi(),
        Transmuxer: $e833773b1f4e7d0f$var$Lo(),
        getFlvHeader: $e833773b1f4e7d0f$var$Go()
    };
});
var $e833773b1f4e7d0f$var$Wo = $e833773b1f4e7d0f$var$v((jT, qo)=>{
    "use strict";
    qo.exports = $e833773b1f4e7d0f$var$At();
});
var $e833773b1f4e7d0f$var$Xo = $e833773b1f4e7d0f$var$v((XT, jo)=>{
    "use strict";
    var Qm = $e833773b1f4e7d0f$var$te(), $s = $e833773b1f4e7d0f$var$yt(), Gi = $e833773b1f4e7d0f$var$Ps(), Vi = $e833773b1f4e7d0f$var$It(), Zm = $e833773b1f4e7d0f$var$_e().ONE_SECOND_IN_TS, Jm = $e833773b1f4e7d0f$var$Vs(), Yo = function i(e, t) {
        var s = [], r = 0, n = 0, a = 0, o = 1 / 0, u = null, l = null;
        t = t || {}, i.prototype.init.call(this), this.push = function(h) {
            Vi.collectDtsInfo(e, h), e && Jm.forEach(function(d) {
                e[d] = h[d];
            }), s.push(h);
        }, this.setEarliestDts = function(h) {
            n = h;
        }, this.setVideoBaseMediaDecodeTime = function(h) {
            o = h;
        }, this.setAudioAppendStart = function(h) {
            a = h;
        }, this.processFrames_ = function() {
            var h, d, c, p, f;
            s.length !== 0 && (h = Gi.trimAdtsFramesByEarliestDts(s, e, n), h.length !== 0 && (e.baseMediaDecodeTime = Vi.calculateTrackBaseMediaDecodeTime(e, t.keepOriginalTimestamps), Gi.prefixWithSilence(e, h, a, o), e.samples = Gi.generateSampleTable(h), c = $s.mdat(Gi.concatenateFrameData(h)), s = [], d = $s.moof(r, [
                e
            ]), r++, e.initSegment = $s.initSegment([
                e
            ]), p = new Uint8Array(d.byteLength + c.byteLength), p.set(d), p.set(c, d.byteLength), Vi.clearDtsInfo(e), u === null && (l = u = h[0].pts), l += h.length * (Zm * 1024 / e.samplerate), f = {
                start: u
            }, this.trigger("timingInfo", f), this.trigger("data", {
                track: e,
                boxes: p
            })));
        }, this.flush = function() {
            this.processFrames_(), this.trigger("timingInfo", {
                start: u,
                end: l
            }), this.resetTiming_(), this.trigger("done", "AudioSegmentStream");
        }, this.partialFlush = function() {
            this.processFrames_(), this.trigger("partialdone", "AudioSegmentStream");
        }, this.endTimeline = function() {
            this.flush(), this.trigger("endedtimeline", "AudioSegmentStream");
        }, this.resetTiming_ = function() {
            Vi.clearDtsInfo(e), u = null, l = null;
        }, this.reset = function() {
            this.resetTiming_(), s = [], this.trigger("reset");
        };
    };
    Yo.prototype = new Qm;
    jo.exports = Yo;
});
var $e833773b1f4e7d0f$var$Qo = $e833773b1f4e7d0f$var$v((KT, $o)=>{
    "use strict";
    var eg = $e833773b1f4e7d0f$var$te(), Qs = $e833773b1f4e7d0f$var$yt(), Hi = $e833773b1f4e7d0f$var$It(), Mt = $e833773b1f4e7d0f$var$Bs(), tg = $e833773b1f4e7d0f$var$Hs(), Ko = function i(e, t) {
        var s = 0, r = [], n = [], a, o, u = null, l = null, h, d = !0;
        t = t || {}, i.prototype.init.call(this), this.push = function(c) {
            Hi.collectDtsInfo(e, c), typeof e.timelineStartInfo.dts > "u" && (e.timelineStartInfo.dts = c.dts), c.nalUnitType === "seq_parameter_set_rbsp" && !a && (a = c.config, e.sps = [
                c.data
            ], tg.forEach(function(p) {
                e[p] = a[p];
            }, this)), c.nalUnitType === "pic_parameter_set_rbsp" && !o && (o = c.data, e.pps = [
                c.data
            ]), r.push(c);
        }, this.processNals_ = function(c) {
            var p;
            for(r = n.concat(r); r.length && r[0].nalUnitType !== "access_unit_delimiter_rbsp";)r.shift();
            if (r.length !== 0) {
                var f = Mt.groupNalsIntoFrames(r);
                if (f.length) {
                    if (n = f[f.length - 1], c && (f.pop(), f.duration -= n.duration, f.nalCount -= n.length, f.byteLength -= n.byteLength), !f.length) {
                        r = [];
                        return;
                    }
                    if (this.trigger("timelineStartInfo", e.timelineStartInfo), d) {
                        if (h = Mt.groupFramesIntoGops(f), !h[0][0].keyFrame) {
                            if (h = Mt.extendFirstKeyFrame(h), !h[0][0].keyFrame) {
                                r = [].concat.apply([], f).concat(n), n = [];
                                return;
                            }
                            f = [].concat.apply([], h), f.duration = h.duration;
                        }
                        d = !1;
                    }
                    for(u === null && (u = f[0].pts, l = u), l += f.duration, this.trigger("timingInfo", {
                        start: u,
                        end: l
                    }), p = 0; p < f.length; p++){
                        var _ = f[p];
                        e.samples = Mt.generateSampleTableForFrame(_);
                        var m = Qs.mdat(Mt.concatenateNalDataForFrame(_));
                        Hi.clearDtsInfo(e), Hi.collectDtsInfo(e, _), e.baseMediaDecodeTime = Hi.calculateTrackBaseMediaDecodeTime(e, t.keepOriginalTimestamps);
                        var b = Qs.moof(s, [
                            e
                        ]);
                        s++, e.initSegment = Qs.initSegment([
                            e
                        ]);
                        var S = new Uint8Array(b.byteLength + m.byteLength);
                        S.set(b), S.set(m, b.byteLength), this.trigger("data", {
                            track: e,
                            boxes: S,
                            sequence: s,
                            videoFrameDts: _.dts,
                            videoFramePts: _.pts
                        });
                    }
                    r = [];
                }
            }
        }, this.resetTimingAndConfig_ = function() {
            a = void 0, o = void 0, u = null, l = null;
        }, this.partialFlush = function() {
            this.processNals_(!0), this.trigger("partialdone", "VideoSegmentStream");
        }, this.flush = function() {
            this.processNals_(!1), this.resetTimingAndConfig_(), this.trigger("done", "VideoSegmentStream");
        }, this.endTimeline = function() {
            this.flush(), this.trigger("endedtimeline", "VideoSegmentStream");
        }, this.reset = function() {
            this.resetTimingAndConfig_(), n = [], r = [], d = !0, this.trigger("reset");
        };
    };
    Ko.prototype = new eg;
    $o.exports = Ko;
});
var $e833773b1f4e7d0f$var$au = $e833773b1f4e7d0f$var$v(($T, nu)=>{
    "use strict";
    var tu = $e833773b1f4e7d0f$var$te(), ve = $e833773b1f4e7d0f$var$At(), Zo = $e833773b1f4e7d0f$var$ys(), iu = $e833773b1f4e7d0f$var$Xo(), ig = $e833773b1f4e7d0f$var$Qo(), Jo = $e833773b1f4e7d0f$var$It(), sg = $e833773b1f4e7d0f$var$Dt().isLikelyAacData, rg = $e833773b1f4e7d0f$var$_t(), ng = $e833773b1f4e7d0f$var$Gs(), Zs = $e833773b1f4e7d0f$var$_e(), su = function(e) {
        return e.prototype = new tu, e.prototype.init.call(e), e;
    }, ag = function(e) {
        var t = {
            type: "ts",
            tracks: {
                audio: null,
                video: null
            },
            packet: new ve.TransportPacketStream,
            parse: new ve.TransportParseStream,
            elementary: new ve.ElementaryStream,
            timestampRollover: new ve.TimestampRolloverStream,
            adts: new Zo.Adts,
            h264: new Zo.h264.H264Stream,
            captionStream: new ve.CaptionStream(e),
            metadataStream: new ve.MetadataStream
        };
        return t.headOfPipeline = t.packet, t.packet.pipe(t.parse).pipe(t.elementary).pipe(t.timestampRollover), t.timestampRollover.pipe(t.h264), t.h264.pipe(t.captionStream), t.timestampRollover.pipe(t.metadataStream), t.timestampRollover.pipe(t.adts), t.elementary.on("data", function(s) {
            if (s.type === "metadata") {
                for(var r = 0; r < s.tracks.length; r++)t.tracks[s.tracks[r].type] || (t.tracks[s.tracks[r].type] = s.tracks[r], t.tracks[s.tracks[r].type].timelineStartInfo.baseMediaDecodeTime = e.baseMediaDecodeTime);
                t.tracks.video && !t.videoSegmentStream && (t.videoSegmentStream = new ig(t.tracks.video, e), t.videoSegmentStream.on("timelineStartInfo", function(n) {
                    t.tracks.audio && !e.keepOriginalTimestamps && t.audioSegmentStream.setEarliestDts(n.dts - e.baseMediaDecodeTime);
                }), t.videoSegmentStream.on("timingInfo", t.trigger.bind(t, "videoTimingInfo")), t.videoSegmentStream.on("data", function(n) {
                    t.trigger("data", {
                        type: "video",
                        data: n
                    });
                }), t.videoSegmentStream.on("done", t.trigger.bind(t, "done")), t.videoSegmentStream.on("partialdone", t.trigger.bind(t, "partialdone")), t.videoSegmentStream.on("endedtimeline", t.trigger.bind(t, "endedtimeline")), t.h264.pipe(t.videoSegmentStream)), t.tracks.audio && !t.audioSegmentStream && (t.audioSegmentStream = new iu(t.tracks.audio, e), t.audioSegmentStream.on("data", function(n) {
                    t.trigger("data", {
                        type: "audio",
                        data: n
                    });
                }), t.audioSegmentStream.on("done", t.trigger.bind(t, "done")), t.audioSegmentStream.on("partialdone", t.trigger.bind(t, "partialdone")), t.audioSegmentStream.on("endedtimeline", t.trigger.bind(t, "endedtimeline")), t.audioSegmentStream.on("timingInfo", t.trigger.bind(t, "audioTimingInfo")), t.adts.pipe(t.audioSegmentStream)), t.trigger("trackinfo", {
                    hasAudio: !!t.tracks.audio,
                    hasVideo: !!t.tracks.video
                });
            }
        }), t.captionStream.on("data", function(s) {
            var r;
            t.tracks.video ? r = t.tracks.video.timelineStartInfo.pts || 0 : r = 0, s.startTime = Zs.metadataTsToSeconds(s.startPts, r, e.keepOriginalTimestamps), s.endTime = Zs.metadataTsToSeconds(s.endPts, r, e.keepOriginalTimestamps), t.trigger("caption", s);
        }), t = su(t), t.metadataStream.on("data", t.trigger.bind(t, "id3Frame")), t;
    }, og = function(e) {
        var t = {
            type: "aac",
            tracks: {
                audio: null
            },
            metadataStream: new ve.MetadataStream,
            aacStream: new ng,
            audioRollover: new ve.TimestampRolloverStream("audio"),
            timedMetadataRollover: new ve.TimestampRolloverStream("timed-metadata"),
            adtsStream: new rg(!0)
        };
        return t.headOfPipeline = t.aacStream, t.aacStream.pipe(t.audioRollover).pipe(t.adtsStream), t.aacStream.pipe(t.timedMetadataRollover).pipe(t.metadataStream), t.metadataStream.on("timestamp", function(s) {
            t.aacStream.setTimestamp(s.timeStamp);
        }), t.aacStream.on("data", function(s) {
            s.type !== "timed-metadata" && s.type !== "audio" || t.audioSegmentStream || (t.tracks.audio = t.tracks.audio || {
                timelineStartInfo: {
                    baseMediaDecodeTime: e.baseMediaDecodeTime
                },
                codec: "adts",
                type: "audio"
            }, t.audioSegmentStream = new iu(t.tracks.audio, e), t.audioSegmentStream.on("data", function(r) {
                t.trigger("data", {
                    type: "audio",
                    data: r
                });
            }), t.audioSegmentStream.on("partialdone", t.trigger.bind(t, "partialdone")), t.audioSegmentStream.on("done", t.trigger.bind(t, "done")), t.audioSegmentStream.on("endedtimeline", t.trigger.bind(t, "endedtimeline")), t.audioSegmentStream.on("timingInfo", t.trigger.bind(t, "audioTimingInfo")), t.adtsStream.pipe(t.audioSegmentStream), t.trigger("trackinfo", {
                hasAudio: !!t.tracks.audio,
                hasVideo: !!t.tracks.video
            }));
        }), t = su(t), t.metadataStream.on("data", t.trigger.bind(t, "id3Frame")), t;
    }, eu = function(e, t) {
        e.on("data", t.trigger.bind(t, "data")), e.on("done", t.trigger.bind(t, "done")), e.on("partialdone", t.trigger.bind(t, "partialdone")), e.on("endedtimeline", t.trigger.bind(t, "endedtimeline")), e.on("audioTimingInfo", t.trigger.bind(t, "audioTimingInfo")), e.on("videoTimingInfo", t.trigger.bind(t, "videoTimingInfo")), e.on("trackinfo", t.trigger.bind(t, "trackinfo")), e.on("id3Frame", function(s) {
            s.dispatchType = e.metadataStream.dispatchType, s.cueTime = Zs.videoTsToSeconds(s.pts), t.trigger("id3Frame", s);
        }), e.on("caption", function(s) {
            t.trigger("caption", s);
        });
    }, ru = function i(e) {
        var t = null, s = !0;
        e = e || {}, i.prototype.init.call(this), e.baseMediaDecodeTime = e.baseMediaDecodeTime || 0, this.push = function(r) {
            if (s) {
                var n = sg(r);
                n && (!t || t.type !== "aac") ? (t = og(e), eu(t, this)) : !n && (!t || t.type !== "ts") && (t = ag(e), eu(t, this)), s = !1;
            }
            t.headOfPipeline.push(r);
        }, this.flush = function() {
            t && (s = !0, t.headOfPipeline.flush());
        }, this.partialFlush = function() {
            t && t.headOfPipeline.partialFlush();
        }, this.endTimeline = function() {
            t && t.headOfPipeline.endTimeline();
        }, this.reset = function() {
            t && t.headOfPipeline.reset();
        }, this.setBaseMediaDecodeTime = function(r) {
            e.keepOriginalTimestamps || (e.baseMediaDecodeTime = r), t && (t.tracks.audio && (t.tracks.audio.timelineStartInfo.dts = void 0, t.tracks.audio.timelineStartInfo.pts = void 0, Jo.clearDtsInfo(t.tracks.audio), t.audioRollover && t.audioRollover.discontinuity()), t.tracks.video && (t.videoSegmentStream && (t.videoSegmentStream.gopCache_ = []), t.tracks.video.timelineStartInfo.dts = void 0, t.tracks.video.timelineStartInfo.pts = void 0, Jo.clearDtsInfo(t.tracks.video)), t.timestampRollover && t.timestampRollover.discontinuity());
        }, this.setRemux = function(r) {
            e.remux = r, t && t.coalesceStream && t.coalesceStream.setRemux(r);
        }, this.setAudioAppendStart = function(r) {
            !t || !t.tracks.audio || !t.audioSegmentStream || t.audioSegmentStream.setAudioAppendStart(r);
        }, this.alignGopsWith = function(r) {};
    };
    ru.prototype = new tu;
    nu.exports = ru;
});
var $e833773b1f4e7d0f$var$uu = $e833773b1f4e7d0f$var$v((QT, ou)=>{
    "use strict";
    ou.exports = {
        Transmuxer: $e833773b1f4e7d0f$var$au()
    };
});
var $e833773b1f4e7d0f$var$du = $e833773b1f4e7d0f$var$v((ZT, hu)=>{
    "use strict";
    var lu = $e833773b1f4e7d0f$var$Le().getUint64, ug = function(e) {
        var t = new DataView(e.buffer, e.byteOffset, e.byteLength), s = {
            version: e[0],
            flags: new Uint8Array(e.subarray(1, 4)),
            references: [],
            referenceId: t.getUint32(4),
            timescale: t.getUint32(8)
        }, r = 12;
        s.version === 0 ? (s.earliestPresentationTime = t.getUint32(r), s.firstOffset = t.getUint32(r + 4), r += 8) : (s.earliestPresentationTime = lu(e.subarray(r)), s.firstOffset = lu(e.subarray(r + 8)), r += 16), r += 2;
        var n = t.getUint16(r);
        for(r += 2; n > 0; r += 12, n--)s.references.push({
            referenceType: (e[r] & 128) >>> 7,
            referencedSize: t.getUint32(r) & 2147483647,
            subsegmentDuration: t.getUint32(r + 4),
            startsWithSap: !!(e[r + 8] & 128),
            sapType: (e[r + 8] & 112) >>> 4,
            sapDeltaTime: t.getUint32(r + 8) & 268435455
        });
        return s;
    };
    hu.exports = ug;
});
var $e833773b1f4e7d0f$var$mu = $e833773b1f4e7d0f$var$v((ew, pu)=>{
    "use strict";
    var fu = $e833773b1f4e7d0f$var$Le(), JT = fu.MAX_UINT32, cu = fu.getUint64, K, Js, ne = function(e) {
        return new Date(e * 1e3 - 20828448e5);
    }, Ot = $e833773b1f4e7d0f$var$ci(), lg = $e833773b1f4e7d0f$var$fi(), hg = function(e) {
        var t = new DataView(e.buffer, e.byteOffset, e.byteLength), s = [], r, n;
        for(r = 0; r + 4 < e.length; r += n){
            if (n = t.getUint32(r), r += 4, n <= 0) {
                s.push("<span style='color:red;'>MALFORMED DATA</span>");
                continue;
            }
            switch(e[r] & 31){
                case 1:
                    s.push("slice_layer_without_partitioning_rbsp");
                    break;
                case 5:
                    s.push("slice_layer_without_partitioning_rbsp_idr");
                    break;
                case 6:
                    s.push("sei_rbsp");
                    break;
                case 7:
                    s.push("seq_parameter_set_rbsp");
                    break;
                case 8:
                    s.push("pic_parameter_set_rbsp");
                    break;
                case 9:
                    s.push("access_unit_delimiter_rbsp");
                    break;
                default:
                    s.push("UNKNOWN NAL - " + e[r] & 31);
                    break;
            }
        }
        return s;
    }, Ae = {
        avc1: function(e) {
            var t = new DataView(e.buffer, e.byteOffset, e.byteLength);
            return {
                dataReferenceIndex: t.getUint16(6),
                width: t.getUint16(24),
                height: t.getUint16(26),
                horizresolution: t.getUint16(28) + t.getUint16(30) / 16,
                vertresolution: t.getUint16(32) + t.getUint16(34) / 16,
                frameCount: t.getUint16(40),
                depth: t.getUint16(74),
                config: K(e.subarray(78, e.byteLength))
            };
        },
        avcC: function(e) {
            var t = new DataView(e.buffer, e.byteOffset, e.byteLength), s = {
                configurationVersion: e[0],
                avcProfileIndication: e[1],
                profileCompatibility: e[2],
                avcLevelIndication: e[3],
                lengthSizeMinusOne: e[4] & 3,
                sps: [],
                pps: []
            }, r = e[5] & 31, n, a, o, u;
            for(o = 6, u = 0; u < r; u++)a = t.getUint16(o), o += 2, s.sps.push(new Uint8Array(e.subarray(o, o + a))), o += a;
            for(n = e[o], o++, u = 0; u < n; u++)a = t.getUint16(o), o += 2, s.pps.push(new Uint8Array(e.subarray(o, o + a))), o += a;
            return s;
        },
        btrt: function(e) {
            var t = new DataView(e.buffer, e.byteOffset, e.byteLength);
            return {
                bufferSizeDB: t.getUint32(0),
                maxBitrate: t.getUint32(4),
                avgBitrate: t.getUint32(8)
            };
        },
        edts: function(e) {
            return {
                boxes: K(e)
            };
        },
        elst: function(e) {
            var t = new DataView(e.buffer, e.byteOffset, e.byteLength), s = {
                version: t.getUint8(0),
                flags: new Uint8Array(e.subarray(1, 4)),
                edits: []
            }, r = t.getUint32(4), n;
            for(n = 8; r; r--)s.version === 0 ? (s.edits.push({
                segmentDuration: t.getUint32(n),
                mediaTime: t.getInt32(n + 4),
                mediaRate: t.getUint16(n + 8) + t.getUint16(n + 10) / 65536
            }), n += 12) : (s.edits.push({
                segmentDuration: cu(e.subarray(n)),
                mediaTime: cu(e.subarray(n + 8)),
                mediaRate: t.getUint16(n + 16) + t.getUint16(n + 18) / 65536
            }), n += 20);
            return s;
        },
        esds: function(e) {
            return {
                version: e[0],
                flags: new Uint8Array(e.subarray(1, 4)),
                esId: e[6] << 8 | e[7],
                streamPriority: e[8] & 31,
                decoderConfig: {
                    objectProfileIndication: e[11],
                    streamType: e[12] >>> 2 & 63,
                    bufferSize: e[13] << 16 | e[14] << 8 | e[15],
                    maxBitrate: e[16] << 24 | e[17] << 16 | e[18] << 8 | e[19],
                    avgBitrate: e[20] << 24 | e[21] << 16 | e[22] << 8 | e[23],
                    decoderConfigDescriptor: {
                        tag: e[24],
                        length: e[25],
                        audioObjectType: e[26] >>> 3 & 31,
                        samplingFrequencyIndex: (e[26] & 7) << 1 | e[27] >>> 7 & 1,
                        channelConfiguration: e[27] >>> 3 & 15
                    }
                }
            };
        },
        ftyp: function(e) {
            for(var t = new DataView(e.buffer, e.byteOffset, e.byteLength), s = {
                majorBrand: Ot(e.subarray(0, 4)),
                minorVersion: t.getUint32(4),
                compatibleBrands: []
            }, r = 8; r < e.byteLength;)s.compatibleBrands.push(Ot(e.subarray(r, r + 4))), r += 4;
            return s;
        },
        dinf: function(e) {
            return {
                boxes: K(e)
            };
        },
        dref: function(e) {
            return {
                version: e[0],
                flags: new Uint8Array(e.subarray(1, 4)),
                dataReferences: K(e.subarray(8))
            };
        },
        hdlr: function(e) {
            var t = new DataView(e.buffer, e.byteOffset, e.byteLength), s = {
                version: t.getUint8(0),
                flags: new Uint8Array(e.subarray(1, 4)),
                handlerType: Ot(e.subarray(8, 12)),
                name: ""
            }, r = 8;
            for(r = 24; r < e.byteLength; r++){
                if (e[r] === 0) {
                    r++;
                    break;
                }
                s.name += String.fromCharCode(e[r]);
            }
            return s.name = decodeURIComponent(escape(s.name)), s;
        },
        mdat: function(e) {
            return {
                byteLength: e.byteLength,
                nals: hg(e)
            };
        },
        mdhd: function(e) {
            var t = new DataView(e.buffer, e.byteOffset, e.byteLength), s = 4, r, n = {
                version: t.getUint8(0),
                flags: new Uint8Array(e.subarray(1, 4)),
                language: ""
            };
            return n.version === 1 ? (s += 4, n.creationTime = ne(t.getUint32(s)), s += 8, n.modificationTime = ne(t.getUint32(s)), s += 4, n.timescale = t.getUint32(s), s += 8, n.duration = t.getUint32(s)) : (n.creationTime = ne(t.getUint32(s)), s += 4, n.modificationTime = ne(t.getUint32(s)), s += 4, n.timescale = t.getUint32(s), s += 4, n.duration = t.getUint32(s)), s += 4, r = t.getUint16(s), n.language += String.fromCharCode((r >> 10) + 96), n.language += String.fromCharCode(((r & 992) >> 5) + 96), n.language += String.fromCharCode((r & 31) + 96), n;
        },
        mdia: function(e) {
            return {
                boxes: K(e)
            };
        },
        mfhd: function(e) {
            return {
                version: e[0],
                flags: new Uint8Array(e.subarray(1, 4)),
                sequenceNumber: e[4] << 24 | e[5] << 16 | e[6] << 8 | e[7]
            };
        },
        minf: function(e) {
            return {
                boxes: K(e)
            };
        },
        mp4a: function(e) {
            var t = new DataView(e.buffer, e.byteOffset, e.byteLength), s = {
                dataReferenceIndex: t.getUint16(6),
                channelcount: t.getUint16(16),
                samplesize: t.getUint16(18),
                samplerate: t.getUint16(24) + t.getUint16(26) / 65536
            };
            return e.byteLength > 28 && (s.streamDescriptor = K(e.subarray(28))[0]), s;
        },
        moof: function(e) {
            return {
                boxes: K(e)
            };
        },
        moov: function(e) {
            return {
                boxes: K(e)
            };
        },
        mvex: function(e) {
            return {
                boxes: K(e)
            };
        },
        mvhd: function(e) {
            var t = new DataView(e.buffer, e.byteOffset, e.byteLength), s = 4, r = {
                version: t.getUint8(0),
                flags: new Uint8Array(e.subarray(1, 4))
            };
            return r.version === 1 ? (s += 4, r.creationTime = ne(t.getUint32(s)), s += 8, r.modificationTime = ne(t.getUint32(s)), s += 4, r.timescale = t.getUint32(s), s += 8, r.duration = t.getUint32(s)) : (r.creationTime = ne(t.getUint32(s)), s += 4, r.modificationTime = ne(t.getUint32(s)), s += 4, r.timescale = t.getUint32(s), s += 4, r.duration = t.getUint32(s)), s += 4, r.rate = t.getUint16(s) + t.getUint16(s + 2) / 16, s += 4, r.volume = t.getUint8(s) + t.getUint8(s + 1) / 8, s += 2, s += 2, s += 8, r.matrix = new Uint32Array(e.subarray(s, s + 36)), s += 36, s += 24, r.nextTrackId = t.getUint32(s), r;
        },
        pdin: function(e) {
            var t = new DataView(e.buffer, e.byteOffset, e.byteLength);
            return {
                version: t.getUint8(0),
                flags: new Uint8Array(e.subarray(1, 4)),
                rate: t.getUint32(4),
                initialDelay: t.getUint32(8)
            };
        },
        sdtp: function(e) {
            var t = {
                version: e[0],
                flags: new Uint8Array(e.subarray(1, 4)),
                samples: []
            }, s;
            for(s = 4; s < e.byteLength; s++)t.samples.push({
                dependsOn: (e[s] & 48) >> 4,
                isDependedOn: (e[s] & 12) >> 2,
                hasRedundancy: e[s] & 3
            });
            return t;
        },
        sidx: $e833773b1f4e7d0f$var$du(),
        smhd: function(e) {
            return {
                version: e[0],
                flags: new Uint8Array(e.subarray(1, 4)),
                balance: e[4] + e[5] / 256
            };
        },
        stbl: function(e) {
            return {
                boxes: K(e)
            };
        },
        ctts: function(e) {
            var t = new DataView(e.buffer, e.byteOffset, e.byteLength), s = {
                version: t.getUint8(0),
                flags: new Uint8Array(e.subarray(1, 4)),
                compositionOffsets: []
            }, r = t.getUint32(4), n;
            for(n = 8; r; n += 8, r--)s.compositionOffsets.push({
                sampleCount: t.getUint32(n),
                sampleOffset: t[s.version === 0 ? "getUint32" : "getInt32"](n + 4)
            });
            return s;
        },
        stss: function(e) {
            var t = new DataView(e.buffer, e.byteOffset, e.byteLength), s = {
                version: t.getUint8(0),
                flags: new Uint8Array(e.subarray(1, 4)),
                syncSamples: []
            }, r = t.getUint32(4), n;
            for(n = 8; r; n += 4, r--)s.syncSamples.push(t.getUint32(n));
            return s;
        },
        stco: function(e) {
            var t = new DataView(e.buffer, e.byteOffset, e.byteLength), s = {
                version: e[0],
                flags: new Uint8Array(e.subarray(1, 4)),
                chunkOffsets: []
            }, r = t.getUint32(4), n;
            for(n = 8; r; n += 4, r--)s.chunkOffsets.push(t.getUint32(n));
            return s;
        },
        stsc: function(e) {
            var t = new DataView(e.buffer, e.byteOffset, e.byteLength), s = t.getUint32(4), r = {
                version: e[0],
                flags: new Uint8Array(e.subarray(1, 4)),
                sampleToChunks: []
            }, n;
            for(n = 8; s; n += 12, s--)r.sampleToChunks.push({
                firstChunk: t.getUint32(n),
                samplesPerChunk: t.getUint32(n + 4),
                sampleDescriptionIndex: t.getUint32(n + 8)
            });
            return r;
        },
        stsd: function(e) {
            return {
                version: e[0],
                flags: new Uint8Array(e.subarray(1, 4)),
                sampleDescriptions: K(e.subarray(8))
            };
        },
        stsz: function(e) {
            var t = new DataView(e.buffer, e.byteOffset, e.byteLength), s = {
                version: e[0],
                flags: new Uint8Array(e.subarray(1, 4)),
                sampleSize: t.getUint32(4),
                entries: []
            }, r;
            for(r = 12; r < e.byteLength; r += 4)s.entries.push(t.getUint32(r));
            return s;
        },
        stts: function(e) {
            var t = new DataView(e.buffer, e.byteOffset, e.byteLength), s = {
                version: e[0],
                flags: new Uint8Array(e.subarray(1, 4)),
                timeToSamples: []
            }, r = t.getUint32(4), n;
            for(n = 8; r; n += 8, r--)s.timeToSamples.push({
                sampleCount: t.getUint32(n),
                sampleDelta: t.getUint32(n + 4)
            });
            return s;
        },
        styp: function(e) {
            return Ae.ftyp(e);
        },
        tfdt: $e833773b1f4e7d0f$var$_i(),
        tfhd: $e833773b1f4e7d0f$var$mi(),
        tkhd: function(e) {
            var t = new DataView(e.buffer, e.byteOffset, e.byteLength), s = 4, r = {
                version: t.getUint8(0),
                flags: new Uint8Array(e.subarray(1, 4))
            };
            return r.version === 1 ? (s += 4, r.creationTime = ne(t.getUint32(s)), s += 8, r.modificationTime = ne(t.getUint32(s)), s += 4, r.trackId = t.getUint32(s), s += 4, s += 8, r.duration = t.getUint32(s)) : (r.creationTime = ne(t.getUint32(s)), s += 4, r.modificationTime = ne(t.getUint32(s)), s += 4, r.trackId = t.getUint32(s), s += 4, s += 4, r.duration = t.getUint32(s)), s += 4, s += 8, r.layer = t.getUint16(s), s += 2, r.alternateGroup = t.getUint16(s), s += 2, r.volume = t.getUint8(s) + t.getUint8(s + 1) / 8, s += 2, s += 2, r.matrix = new Uint32Array(e.subarray(s, s + 36)), s += 36, r.width = t.getUint16(s) + t.getUint16(s + 2) / 65536, s += 4, r.height = t.getUint16(s) + t.getUint16(s + 2) / 65536, r;
        },
        traf: function(e) {
            return {
                boxes: K(e)
            };
        },
        trak: function(e) {
            return {
                boxes: K(e)
            };
        },
        trex: function(e) {
            var t = new DataView(e.buffer, e.byteOffset, e.byteLength);
            return {
                version: e[0],
                flags: new Uint8Array(e.subarray(1, 4)),
                trackId: t.getUint32(4),
                defaultSampleDescriptionIndex: t.getUint32(8),
                defaultSampleDuration: t.getUint32(12),
                defaultSampleSize: t.getUint32(16),
                sampleDependsOn: e[20] & 3,
                sampleIsDependedOn: (e[21] & 192) >> 6,
                sampleHasRedundancy: (e[21] & 48) >> 4,
                samplePaddingValue: (e[21] & 14) >> 1,
                sampleIsDifferenceSample: !!(e[21] & 1),
                sampleDegradationPriority: t.getUint16(22)
            };
        },
        trun: $e833773b1f4e7d0f$var$gi(),
        "url ": function(e) {
            return {
                version: e[0],
                flags: new Uint8Array(e.subarray(1, 4))
            };
        },
        vmhd: function(e) {
            var t = new DataView(e.buffer, e.byteOffset, e.byteLength);
            return {
                version: e[0],
                flags: new Uint8Array(e.subarray(1, 4)),
                graphicsmode: t.getUint16(4),
                opcolor: new Uint16Array([
                    t.getUint16(6),
                    t.getUint16(8),
                    t.getUint16(10)
                ])
            };
        }
    };
    K = function(e) {
        for(var t = 0, s = [], r, n, a, o, u, l = new ArrayBuffer(e.length), h = new Uint8Array(l), d = 0; d < e.length; ++d)h[d] = e[d];
        for(r = new DataView(l); t < e.byteLength;)n = r.getUint32(t), a = Ot(e.subarray(t + 4, t + 8)), o = n > 1 ? t + n : e.byteLength, u = (Ae[a] || function(c) {
            return {
                data: c
            };
        })(e.subarray(t + 8, o)), u.size = n, u.type = a, s.push(u), t = o;
        return s;
    };
    Js = function(e, t) {
        var s;
        return t = t || 0, s = new Array(t * 2 + 1).join(" "), e.map(function(r, n) {
            return s + r.type + `
` + Object.keys(r).filter(function(a) {
                return a !== "type" && a !== "boxes";
            }).map(function(a) {
                var o = s + "  " + a + ": ", u = r[a];
                if (u instanceof Uint8Array || u instanceof Uint32Array) {
                    var l = Array.prototype.slice.call(new Uint8Array(u.buffer, u.byteOffset, u.byteLength)).map(function(h) {
                        return " " + ("00" + h.toString(16)).slice(-2);
                    }).join("").match(/.{1,24}/g);
                    return l ? l.length === 1 ? o + "<" + l.join("").slice(1) + ">" : o + `<
` + l.map(function(h) {
                        return s + "  " + h;
                    }).join(`
`) + `
` + s + "  >" : o + "<>";
                }
                return o + JSON.stringify(u, null, 2).split(`
`).map(function(h, d) {
                    return d === 0 ? h : s + "  " + h;
                }).join(`
`);
            }).join(`
`) + (r.boxes ? `
` + Js(r.boxes, t + 1) : "");
        }).join(`
`);
    };
    pu.exports = {
        inspect: K,
        textify: Js,
        parseType: Ot,
        findBox: lg,
        parseTraf: Ae.traf,
        parseTfdt: Ae.tfdt,
        parseHdlr: Ae.hdlr,
        parseTfhd: Ae.tfhd,
        parseTrun: Ae.trun,
        parseSidx: Ae.sidx
    };
});
var $e833773b1f4e7d0f$var$xu = $e833773b1f4e7d0f$var$v((tw, _u)=>{
    "use strict";
    var dg = {
        8: "audio",
        9: "video",
        18: "metadata"
    }, cg = function(e) {
        return "0x" + ("00" + e.toString(16)).slice(-2).toUpperCase();
    }, er = function(e) {
        for(var t = [], s; e.byteLength > 0;)s = 0, t.push(cg(e[s++])), e = e.subarray(s);
        return t.join(" ");
    }, fg = function(e, t) {
        var s = [
            "AVC Sequence Header",
            "AVC NALU",
            "AVC End-of-Sequence"
        ], r = e[1] & parseInt("01111111", 2) << 16 | e[2] << 8 | e[3];
        return t = t || {}, t.avcPacketType = s[e[0]], t.CompositionTime = e[1] & parseInt("10000000", 2) ? -r : r, e[0] === 1 ? t.nalUnitTypeRaw = er(e.subarray(4, 100)) : t.data = er(e.subarray(4)), t;
    }, pg = function(e, t) {
        var s = [
            "Unknown",
            "Keyframe (for AVC, a seekable frame)",
            "Inter frame (for AVC, a nonseekable frame)",
            "Disposable inter frame (H.263 only)",
            "Generated keyframe (reserved for server use only)",
            "Video info/command frame"
        ], r = e[0] & parseInt("00001111", 2);
        return t = t || {}, t.frameType = s[(e[0] & parseInt("11110000", 2)) >>> 4], t.codecID = r, r === 7 ? fg(e.subarray(1), t) : t;
    }, mg = function(e, t) {
        var s = [
            "AAC Sequence Header",
            "AAC Raw"
        ];
        return t = t || {}, t.aacPacketType = s[e[0]], t.data = er(e.subarray(1)), t;
    }, gg = function(e, t) {
        var s = [
            "Linear PCM, platform endian",
            "ADPCM",
            "MP3",
            "Linear PCM, little endian",
            "Nellymoser 16-kHz mono",
            "Nellymoser 8-kHz mono",
            "Nellymoser",
            "G.711 A-law logarithmic PCM",
            "G.711 mu-law logarithmic PCM",
            "reserved",
            "AAC",
            "Speex",
            "MP3 8-Khz",
            "Device-specific sound"
        ], r = [
            "5.5-kHz",
            "11-kHz",
            "22-kHz",
            "44-kHz"
        ], n = (e[0] & parseInt("11110000", 2)) >>> 4;
        return t = t || {}, t.soundFormat = s[n], t.soundRate = r[(e[0] & parseInt("00001100", 2)) >>> 2], t.soundSize = (e[0] & parseInt("00000010", 2)) >>> 1 ? "16-bit" : "8-bit", t.soundType = e[0] & parseInt("00000001", 2) ? "Stereo" : "Mono", n === 10 ? mg(e.subarray(1), t) : t;
    }, _g = function(e) {
        return {
            tagType: dg[e[0]],
            dataSize: e[1] << 16 | e[2] << 8 | e[3],
            timestamp: e[7] << 24 | e[4] << 16 | e[5] << 8 | e[6],
            streamID: e[8] << 16 | e[9] << 8 | e[10]
        };
    }, gu = function(e) {
        var t = _g(e);
        switch(e[0]){
            case 8:
                gg(e.subarray(11), t);
                break;
            case 9:
                pg(e.subarray(11), t);
                break;
            case 18:
        }
        return t;
    }, xg = function(e) {
        var t = 9, s, r = [], n;
        for(t += 4; t < e.byteLength;)s = e[t + 1] << 16, s |= e[t + 2] << 8, s |= e[t + 3], s += 11, n = e.subarray(t, t + s), r.push(gu(n)), t += s + 4;
        return r;
    }, yg = function(e) {
        return JSON.stringify(e, null, 2);
    };
    _u.exports = {
        inspectTag: gu,
        inspect: xg,
        textify: yg
    };
});
var $e833773b1f4e7d0f$var$bu = $e833773b1f4e7d0f$var$v((iw, vu)=>{
    "use strict";
    var tr = $e833773b1f4e7d0f$var$Ct(), yu = function(e) {
        var t = e[1] & 31;
        return t <<= 8, t |= e[2], t;
    }, qi = function(e) {
        return !!(e[1] & 64);
    }, Wi = function(e) {
        var t = 0;
        return (e[3] & 48) >>> 4 > 1 && (t += e[4] + 1), t;
    }, vg = function(e, t) {
        var s = yu(e);
        return s === 0 ? "pat" : s === t ? "pmt" : t ? "pes" : null;
    }, bg = function(e) {
        var t = qi(e), s = 4 + Wi(e);
        return t && (s += e[s] + 1), (e[s + 10] & 31) << 8 | e[s + 11];
    }, Sg = function(e) {
        var t = {}, s = qi(e), r = 4 + Wi(e);
        if (s && (r += e[r] + 1), !!(e[r + 5] & 1)) {
            var n, a, o;
            n = (e[r + 1] & 15) << 8 | e[r + 2], a = 3 + n - 4, o = (e[r + 10] & 15) << 8 | e[r + 11];
            for(var u = 12 + o; u < a;){
                var l = r + u;
                t[(e[l + 1] & 31) << 8 | e[l + 2]] = e[l], u += ((e[l + 3] & 15) << 8 | e[l + 4]) + 5;
            }
            return t;
        }
    }, Tg = function(e, t) {
        var s = yu(e), r = t[s];
        switch(r){
            case tr.H264_STREAM_TYPE:
                return "video";
            case tr.ADTS_STREAM_TYPE:
                return "audio";
            case tr.METADATA_STREAM_TYPE:
                return "timed-metadata";
            default:
                return null;
        }
    }, wg = function(e) {
        var t = qi(e);
        if (!t) return null;
        var s = 4 + Wi(e);
        if (s >= e.byteLength) return null;
        var r = null, n;
        return n = e[s + 7], n & 192 && (r = {}, r.pts = (e[s + 9] & 14) << 27 | (e[s + 10] & 255) << 20 | (e[s + 11] & 254) << 12 | (e[s + 12] & 255) << 5 | (e[s + 13] & 254) >>> 3, r.pts *= 4, r.pts += (e[s + 13] & 6) >>> 1, r.dts = r.pts, n & 64 && (r.dts = (e[s + 14] & 14) << 27 | (e[s + 15] & 255) << 20 | (e[s + 16] & 254) << 12 | (e[s + 17] & 255) << 5 | (e[s + 18] & 254) >>> 3, r.dts *= 4, r.dts += (e[s + 18] & 6) >>> 1)), r;
    }, ir = function(e) {
        switch(e){
            case 5:
                return "slice_layer_without_partitioning_rbsp_idr";
            case 6:
                return "sei_rbsp";
            case 7:
                return "seq_parameter_set_rbsp";
            case 8:
                return "pic_parameter_set_rbsp";
            case 9:
                return "access_unit_delimiter_rbsp";
            default:
                return null;
        }
    }, Ug = function(e) {
        for(var t = 4 + Wi(e), s = e.subarray(t), r = 0, n = 0, a = !1, o; n < s.byteLength - 3; n++)if (s[n + 2] === 1) {
            r = n + 5;
            break;
        }
        for(; r < s.byteLength;)switch(s[r]){
            case 0:
                if (s[r - 1] !== 0) {
                    r += 2;
                    break;
                } else if (s[r - 2] !== 0) {
                    r++;
                    break;
                }
                n + 3 !== r - 2 && (o = ir(s[n + 3] & 31), o === "slice_layer_without_partitioning_rbsp_idr" && (a = !0));
                do r++;
                while (s[r] !== 1 && r < s.length);
                n = r - 2, r += 3;
                break;
            case 1:
                if (s[r - 1] !== 0 || s[r - 2] !== 0) {
                    r += 3;
                    break;
                }
                o = ir(s[n + 3] & 31), o === "slice_layer_without_partitioning_rbsp_idr" && (a = !0), n = r - 2, r += 3;
                break;
            default:
                r += 3;
                break;
        }
        return s = s.subarray(n), r -= n, n = 0, s && s.byteLength > 3 && (o = ir(s[n + 3] & 31), o === "slice_layer_without_partitioning_rbsp_idr" && (a = !0)), a;
    };
    vu.exports = {
        parseType: vg,
        parsePat: bg,
        parsePmt: Sg,
        parsePayloadUnitStartIndicator: qi,
        parsePesType: Tg,
        parsePesTime: wg,
        videoPacketContainsKeyFrame: Ug
    };
});
var $e833773b1f4e7d0f$var$Uu = $e833773b1f4e7d0f$var$v((sw, wu)=>{
    "use strict";
    var Su = $e833773b1f4e7d0f$var$Ct(), Je = $e833773b1f4e7d0f$var$Os().handleRollover, D = {};
    D.ts = $e833773b1f4e7d0f$var$bu();
    D.aac = $e833773b1f4e7d0f$var$Dt();
    var Ge = $e833773b1f4e7d0f$var$_e().ONE_SECOND_IN_TS, Q = 188, ce = 71, Eg = function(e, t) {
        for(var s = 0, r = Q, n, a; r < e.byteLength;){
            if (e[s] === ce && e[r] === ce) {
                switch(n = e.subarray(s, r), a = D.ts.parseType(n, t.pid), a){
                    case "pat":
                        t.pid = D.ts.parsePat(n);
                        break;
                    case "pmt":
                        var o = D.ts.parsePmt(n);
                        t.table = t.table || {}, Object.keys(o).forEach(function(u) {
                            t.table[u] = o[u];
                        });
                        break;
                    default:
                        break;
                }
                s += Q, r += Q;
                continue;
            }
            s++, r++;
        }
    }, Tu = function(e, t, s) {
        for(var r = 0, n = Q, a, o, u, l, h, d = !1; n <= e.byteLength;){
            if (e[r] === ce && (e[n] === ce || n === e.byteLength)) {
                switch(a = e.subarray(r, n), o = D.ts.parseType(a, t.pid), o){
                    case "pes":
                        u = D.ts.parsePesType(a, t.table), l = D.ts.parsePayloadUnitStartIndicator(a), u === "audio" && l && (h = D.ts.parsePesTime(a), h && (h.type = "audio", s.audio.push(h), d = !0));
                        break;
                    default:
                        break;
                }
                if (d) break;
                r += Q, n += Q;
                continue;
            }
            r++, n++;
        }
        for(n = e.byteLength, r = n - Q, d = !1; r >= 0;){
            if (e[r] === ce && (e[n] === ce || n === e.byteLength)) {
                switch(a = e.subarray(r, n), o = D.ts.parseType(a, t.pid), o){
                    case "pes":
                        u = D.ts.parsePesType(a, t.table), l = D.ts.parsePayloadUnitStartIndicator(a), u === "audio" && l && (h = D.ts.parsePesTime(a), h && (h.type = "audio", s.audio.push(h), d = !0));
                        break;
                    default:
                        break;
                }
                if (d) break;
                r -= Q, n -= Q;
                continue;
            }
            r--, n--;
        }
    }, Ig = function(e, t, s) {
        for(var r = 0, n = Q, a, o, u, l, h, d, c, p, f = !1, _ = {
            data: [],
            size: 0
        }; n < e.byteLength;){
            if (e[r] === ce && e[n] === ce) {
                switch(a = e.subarray(r, n), o = D.ts.parseType(a, t.pid), o){
                    case "pes":
                        if (u = D.ts.parsePesType(a, t.table), l = D.ts.parsePayloadUnitStartIndicator(a), u === "video" && (l && !f && (h = D.ts.parsePesTime(a), h && (h.type = "video", s.video.push(h), f = !0)), !s.firstKeyFrame)) {
                            if (l && _.size !== 0) {
                                for(d = new Uint8Array(_.size), c = 0; _.data.length;)p = _.data.shift(), d.set(p, c), c += p.byteLength;
                                if (D.ts.videoPacketContainsKeyFrame(d)) {
                                    var m = D.ts.parsePesTime(d);
                                    m ? (s.firstKeyFrame = m, s.firstKeyFrame.type = "video") : console.warn("Failed to extract PTS/DTS from PES at first keyframe. This could be an unusual TS segment, or else mux.js did not parse your TS segment correctly. If you know your TS segments do contain PTS/DTS on keyframes please file a bug report! You can try ffprobe to double check for yourself.");
                                }
                                _.size = 0;
                            }
                            _.data.push(a), _.size += a.byteLength;
                        }
                        break;
                    default:
                        break;
                }
                if (f && s.firstKeyFrame) break;
                r += Q, n += Q;
                continue;
            }
            r++, n++;
        }
        for(n = e.byteLength, r = n - Q, f = !1; r >= 0;){
            if (e[r] === ce && e[n] === ce) {
                switch(a = e.subarray(r, n), o = D.ts.parseType(a, t.pid), o){
                    case "pes":
                        u = D.ts.parsePesType(a, t.table), l = D.ts.parsePayloadUnitStartIndicator(a), u === "video" && l && (h = D.ts.parsePesTime(a), h && (h.type = "video", s.video.push(h), f = !0));
                        break;
                    default:
                        break;
                }
                if (f) break;
                r -= Q, n -= Q;
                continue;
            }
            r--, n--;
        }
    }, Cg = function(e, t) {
        if (e.audio && e.audio.length) {
            var s = t;
            (typeof s > "u" || isNaN(s)) && (s = e.audio[0].dts), e.audio.forEach(function(a) {
                a.dts = Je(a.dts, s), a.pts = Je(a.pts, s), a.dtsTime = a.dts / Ge, a.ptsTime = a.pts / Ge;
            });
        }
        if (e.video && e.video.length) {
            var r = t;
            if ((typeof r > "u" || isNaN(r)) && (r = e.video[0].dts), e.video.forEach(function(a) {
                a.dts = Je(a.dts, r), a.pts = Je(a.pts, r), a.dtsTime = a.dts / Ge, a.ptsTime = a.pts / Ge;
            }), e.firstKeyFrame) {
                var n = e.firstKeyFrame;
                n.dts = Je(n.dts, r), n.pts = Je(n.pts, r), n.dtsTime = n.dts / Ge, n.ptsTime = n.pts / Ge;
            }
        }
    }, Bg = function(e) {
        for(var t = !1, s = 0, r = null, n = null, a = 0, o = 0, u; e.length - o >= 3;){
            var l = D.aac.parseType(e, o);
            switch(l){
                case "timed-metadata":
                    if (e.length - o < 10) {
                        t = !0;
                        break;
                    }
                    if (a = D.aac.parseId3TagSize(e, o), a > e.length) {
                        t = !0;
                        break;
                    }
                    n === null && (u = e.subarray(o, o + a), n = D.aac.parseAacTimestamp(u)), o += a;
                    break;
                case "audio":
                    if (e.length - o < 7) {
                        t = !0;
                        break;
                    }
                    if (a = D.aac.parseAdtsSize(e, o), a > e.length) {
                        t = !0;
                        break;
                    }
                    r === null && (u = e.subarray(o, o + a), r = D.aac.parseSampleRate(u)), s++, o += a;
                    break;
                default:
                    o++;
                    break;
            }
            if (t) return null;
        }
        if (r === null || n === null) return null;
        var h = Ge / r, d = {
            audio: [
                {
                    type: "audio",
                    dts: n,
                    pts: n
                },
                {
                    type: "audio",
                    dts: n + s * 1024 * h,
                    pts: n + s * 1024 * h
                }
            ]
        };
        return d;
    }, Ag = function(e) {
        var t = {
            pid: null,
            table: null
        }, s = {};
        Eg(e, t);
        for(var r in t.table)if (t.table.hasOwnProperty(r)) {
            var n = t.table[r];
            switch(n){
                case Su.H264_STREAM_TYPE:
                    s.video = [], Ig(e, t, s), s.video.length === 0 && delete s.video;
                    break;
                case Su.ADTS_STREAM_TYPE:
                    s.audio = [], Tu(e, t, s), s.audio.length === 0 && delete s.audio;
                    break;
                default:
                    break;
            }
        }
        return s;
    }, Dg = function(e, t) {
        var s = D.aac.isLikelyAacData(e), r;
        return s ? r = Bg(e) : r = Ag(e), !r || !r.audio && !r.video ? null : (Cg(r, t), r);
    };
    wu.exports = {
        inspect: Dg,
        parseAudioPes_: Tu
    };
});
var $e833773b1f4e7d0f$var$Iu = $e833773b1f4e7d0f$var$v((rw, Eu)=>{
    "use strict";
    var Yi = {
        codecs: $e833773b1f4e7d0f$var$ys(),
        mp4: $e833773b1f4e7d0f$var$Co(),
        flv: $e833773b1f4e7d0f$var$Ho(),
        mp2t: $e833773b1f4e7d0f$var$Wo(),
        partial: $e833773b1f4e7d0f$var$uu()
    };
    Yi.mp4.tools = $e833773b1f4e7d0f$var$mu();
    Yi.flv.tools = $e833773b1f4e7d0f$var$xu();
    Yi.mp2t.tools = $e833773b1f4e7d0f$var$Uu();
    Eu.exports = Yi;
});
var $e833773b1f4e7d0f$export$b8e9cd941e8016ac = ((f)=>(f.CONNECTION_ERROR = "CONNECTION_ERROR", f.CRITICAL_CONNECTION_ERROR = "CRITICAL_CONNECTION_ERROR", f.CONNECTION_CLOSED = "CONNECTION_CLOSED", f.STREAM_NOT_FOUND = "STREAM_NOT_FOUND", f.STREAM_ENDED = "STREAM_ENDED", f.CONNECTION_TIMEOUT = "CONNECTION_TIMEOUT", f.UNSUPPORTED_MEDIA_FORMAT = "UNSUPPORTED_MEDIA_FORMAT", f.BUFFER_ERROR = "BUFFER_ERROR", f.START_PLAYING = "START_PLAYING", f.START_PLAYING_NOT_ALLOWED = "START_PLAYING_NOT_ALLOWED", f.START_PLAYING_NOT_SUPPORTED = "START_PLAYING_NOT_SUPPORTED", f.WRONG_URL = "WRONG_URL", f.UNAUTHORIZED = "UNAUTHORIZED", f.UNKNOWN_ERROR = "UNKNOWN_ERROR", f))($e833773b1f4e7d0f$export$b8e9cd941e8016ac || {});
var $e833773b1f4e7d0f$export$ada873a34909da65 = ((f)=>(f.ERROR = "ERROR", f.STATUS_CHANGED = "STATUS_CHANGED", f.SCREENSHOT = "SCREENSHOT", f.TIME_UPDATE = "TIME_UPDATE", f.DURATION_CHANGE = "DURATION_CHANGE", f.STREAM_TYPE_CHANGE = "STREAM_TYPE_CHANGE", f.FRAME_READY = "FRAME_READY", f.LOADED_METADATA = "LOADED_METADATA", f.LOADED_DATA = "LOADED_DATA", f.PROGRESS = "PROGRESS", f.INVALID_PASSTHROUGH_TOKEN = "INVALID_PASSTHROUGH_TOKEN", f.ENDED = "ENDED", f.CAN_PLAY = "CAN_PLAY", f.PLAY = "PLAY", f))($e833773b1f4e7d0f$export$ada873a34909da65 || {});
var $e833773b1f4e7d0f$export$96e9906d6d93a972 = ((o)=>(o.STOPPED = "STOPPED", o.CONNECTING = "CONNECTING", o.LOOKING_FOR_START = "LOOKING_FOR_START", o.WAIT_FOR_BUFFER = "WAIT_FOR_BUFFER", o.STARTING_PLAYING = "STARTING_PLAYING", o.PLAYING = "PLAYING", o.PAUSED = "PAUSED", o))($e833773b1f4e7d0f$export$96e9906d6d93a972 || {});
var $e833773b1f4e7d0f$export$b315772e2ea5165e = ((r)=>(r.None = "none", r.Audio = "audio", r.Video = "video", r.Text = "text", r))($e833773b1f4e7d0f$export$b315772e2ea5165e || {});
async function $e833773b1f4e7d0f$var$Yu(i, e = 1e4) {
    return new Promise((t, s)=>{
        let r = performance.now() + e;
        (function n() {
            if (i()) return t();
            if (performance.now() > r) {
                s("Timeout");
                return;
            }
            setTimeout(n, 10);
        })();
    });
}
async function $e833773b1f4e7d0f$export$7c9e1d487e9f2bc0(i, e = 1e4) {
    try {
        return await $e833773b1f4e7d0f$var$Yu(i, e), !0;
    } catch  {
        return !1;
    }
}
async function $e833773b1f4e7d0f$export$e11603d565eb502f(i, e = null, t = 1e4) {
    return new Promise((s)=>{
        let r = performance.now() + t;
        (async function n() {
            if (await i()) return s(!0);
            if (e != null && e() || performance.now() > r) return s(!1);
            setTimeout(n, 10);
        })();
    });
}
function $e833773b1f4e7d0f$export$1625492ec82002b9(i) {
    return new Promise((e)=>e(i()));
}
function $e833773b1f4e7d0f$export$2ea4208e0ffe9836(i, e) {
    if (i === null) return null;
    let t = Object.getOwnPropertyDescriptor(i, e);
    return t !== void 0 ? t : $e833773b1f4e7d0f$export$2ea4208e0ffe9836(Object.getPrototypeOf(i), e);
}
async function $e833773b1f4e7d0f$export$1ef77878e4e0b972(i) {
    try {
        return (await fetch(i, {
            method: "HEAD"
        })).headers.get("content-type") ?? "";
    } catch  {
        return "";
    }
}
var $e833773b1f4e7d0f$var$Xu = Object.defineProperty, $e833773b1f4e7d0f$var$Ir = (i, e)=>{
    for(var t in e)$e833773b1f4e7d0f$var$Xu(i, t, {
        get: e[t],
        enumerable: !0
    });
}, $e833773b1f4e7d0f$var$Ji = Math.pow(2, 32), $e833773b1f4e7d0f$var$H = Math.pow(2, 32) - 1, $e833773b1f4e7d0f$var$Ku = 1, $e833773b1f4e7d0f$var$$u = 2, $e833773b1f4e7d0f$var$Qu = 4, $e833773b1f4e7d0f$var$Gt = 1, $e833773b1f4e7d0f$var$Vt = 2, $e833773b1f4e7d0f$var$Ht = 8, $e833773b1f4e7d0f$var$qt = 16, $e833773b1f4e7d0f$var$Wt = 32, $e833773b1f4e7d0f$var$vr = 131072, $e833773b1f4e7d0f$var$ot = 1, $e833773b1f4e7d0f$var$Yt = 4, $e833773b1f4e7d0f$var$ut = 256, $e833773b1f4e7d0f$var$lt = 512, $e833773b1f4e7d0f$var$ht = 1024, $e833773b1f4e7d0f$var$dt = 2048, $e833773b1f4e7d0f$var$Cr = -1, $e833773b1f4e7d0f$var$be = 0, $e833773b1f4e7d0f$var$J = 1, $e833773b1f4e7d0f$var$$ = class Br extends ArrayBuffer {
    constructor(e){
        super(e), this.fileStart = 0, this.usedBytes = 0;
    }
    static fromArrayBuffer(e, t) {
        let s = new Br(e.byteLength);
        return new Uint8Array(s).set(new Uint8Array(e)), s.fileStart = t, s;
    }
}, $e833773b1f4e7d0f$var$ns = ((i)=>(i[i.BIG_ENDIAN = 1] = "BIG_ENDIAN", i[i.LITTLE_ENDIAN = 2] = "LITTLE_ENDIAN", i))($e833773b1f4e7d0f$var$ns || {}), $e833773b1f4e7d0f$var$V = class I {
    constructor(e, t, s){
        this._byteLength = 0, this.failurePosition = 0, this._dynamicSize = 1, this._byteOffset = t || 0, e instanceof ArrayBuffer ? this.buffer = $e833773b1f4e7d0f$var$$.fromArrayBuffer(e, 0) : e instanceof DataView ? (this.dataView = e, t && (this._byteOffset += t)) : this.buffer = new $e833773b1f4e7d0f$var$$(e || 0), this.position = 0, this.endianness = s || 1;
    }
    static{
        this.ENDIANNESS = new Int8Array(new Int16Array([
            1
        ]).buffer)[0] > 0 ? 2 : 1;
    }
    getPosition() {
        return this.position;
    }
    _realloc(e) {
        if (!this._dynamicSize) return;
        let t = this._byteOffset + this.position + e, s = this._buffer.byteLength;
        if (t <= s) {
            t > this._byteLength && (this._byteLength = t);
            return;
        }
        for(s < 1 && (s = 1); t > s;)s *= 2;
        let r = new $e833773b1f4e7d0f$var$$(s), n = new Uint8Array(this._buffer);
        new Uint8Array(r, 0, n.length).set(n), this.buffer = r, this._byteLength = t;
    }
    _trimAlloc() {
        if (this._byteLength === this._buffer.byteLength) return;
        let e = new $e833773b1f4e7d0f$var$$(this._byteLength), t = new Uint8Array(e), s = new Uint8Array(this._buffer, 0, t.length);
        t.set(s), this.buffer = e;
    }
    get byteLength() {
        return this._byteLength - this._byteOffset;
    }
    get buffer() {
        return this._trimAlloc(), this._buffer;
    }
    set buffer(e) {
        this._buffer = e, this._dataView = new DataView(e, this._byteOffset), this._byteLength = e.byteLength;
    }
    get byteOffset() {
        return this._byteOffset;
    }
    set byteOffset(e) {
        this._byteOffset = e, this._dataView = new DataView(this._buffer, this._byteOffset), this._byteLength = this._buffer.byteLength;
    }
    get dataView() {
        return this._dataView;
    }
    set dataView(e) {
        this._byteOffset = e.byteOffset, this._buffer = $e833773b1f4e7d0f$var$$.fromArrayBuffer(e.buffer, 0), this._dataView = new DataView(this._buffer, this._byteOffset), this._byteLength = this._byteOffset + e.byteLength;
    }
    seek(e) {
        let t = Math.max(0, Math.min(this.byteLength, e));
        this.position = isNaN(t) || !isFinite(t) ? 0 : t;
    }
    isEof() {
        return this.position >= this._byteLength;
    }
    #e(e) {
        return Array.isArray(e) && e.length === 3 && e[0] === "[]";
    }
    mapUint8Array(e) {
        this._realloc(e * 1);
        let t = new Uint8Array(this._buffer, this.byteOffset + this.position, e);
        return this.position += e * 1, t;
    }
    readInt32Array(e, t) {
        e = e === void 0 ? this.byteLength - this.position / 4 : e;
        let s = new Int32Array(e);
        return I.memcpy(s.buffer, 0, this.buffer, this.byteOffset + this.position, e * s.BYTES_PER_ELEMENT), I.arrayToNative(s, t ?? this.endianness), this.position += s.byteLength, s;
    }
    readInt16Array(e, t) {
        e = e === void 0 ? this.byteLength - this.position / 2 : e;
        let s = new Int16Array(e);
        return I.memcpy(s.buffer, 0, this.buffer, this.byteOffset + this.position, e * s.BYTES_PER_ELEMENT), I.arrayToNative(s, t ?? this.endianness), this.position += s.byteLength, s;
    }
    readInt8Array(e) {
        e = e === void 0 ? this.byteLength - this.position : e;
        let t = new Int8Array(e);
        return I.memcpy(t.buffer, 0, this.buffer, this.byteOffset + this.position, e * t.BYTES_PER_ELEMENT), this.position += t.byteLength, t;
    }
    readUint32Array(e, t) {
        e = e === void 0 ? this.byteLength - this.position / 4 : e;
        let s = new Uint32Array(e);
        return I.memcpy(s.buffer, 0, this.buffer, this.byteOffset + this.position, e * s.BYTES_PER_ELEMENT), I.arrayToNative(s, t ?? this.endianness), this.position += s.byteLength, s;
    }
    readUint16Array(e, t) {
        e = e === void 0 ? this.byteLength - this.position / 2 : e;
        let s = new Uint16Array(e);
        return I.memcpy(s.buffer, 0, this.buffer, this.byteOffset + this.position, e * s.BYTES_PER_ELEMENT), I.arrayToNative(s, t ?? this.endianness), this.position += s.byteLength, s;
    }
    readUint8Array(e) {
        e = e === void 0 ? this.byteLength - this.position : e;
        let t = new Uint8Array(e);
        return I.memcpy(t.buffer, 0, this.buffer, this.byteOffset + this.position, e * t.BYTES_PER_ELEMENT), this.position += t.byteLength, t;
    }
    readFloat64Array(e, t) {
        e = e === void 0 ? this.byteLength - this.position / 8 : e;
        let s = new Float64Array(e);
        return I.memcpy(s.buffer, 0, this.buffer, this.byteOffset + this.position, e * s.BYTES_PER_ELEMENT), I.arrayToNative(s, t ?? this.endianness), this.position += s.byteLength, s;
    }
    readFloat32Array(e, t) {
        e = e === void 0 ? this.byteLength - this.position / 4 : e;
        let s = new Float32Array(e);
        return I.memcpy(s.buffer, 0, this.buffer, this.byteOffset + this.position, e * s.BYTES_PER_ELEMENT), I.arrayToNative(s, t ?? this.endianness), this.position += s.byteLength, s;
    }
    readInt32(e) {
        let t = this._dataView.getInt32(this.position, (e ?? this.endianness) === 2);
        return this.position += 4, t;
    }
    readInt16(e) {
        let t = this._dataView.getInt16(this.position, (e ?? this.endianness) === 2);
        return this.position += 2, t;
    }
    readInt8() {
        let e = this._dataView.getInt8(this.position);
        return this.position += 1, e;
    }
    readUint32(e) {
        let t = this._dataView.getUint32(this.position, (e ?? this.endianness) === 2);
        return this.position += 4, t;
    }
    readUint16(e) {
        let t = this._dataView.getUint16(this.position, (e ?? this.endianness) === 2);
        return this.position += 2, t;
    }
    readUint8() {
        let e = this._dataView.getUint8(this.position);
        return this.position += 1, e;
    }
    readFloat32(e) {
        let t = this._dataView.getFloat32(this.position, (e ?? this.endianness) === 2);
        return this.position += 4, t;
    }
    readFloat64(e) {
        let t = this._dataView.getFloat64(this.position, (e ?? this.endianness) === 2);
        return this.position += 8, t;
    }
    static memcpy(e, t, s, r, n) {
        let a = new Uint8Array(e, t, n), o = new Uint8Array(s, r, n);
        a.set(o);
    }
    static arrayToNative(e, t) {
        return t === I.ENDIANNESS ? e : this.flipArrayEndianness(e);
    }
    static nativeToEndian(e, t) {
        return t && I.ENDIANNESS === 2 ? e : this.flipArrayEndianness(e);
    }
    static flipArrayEndianness(e) {
        let t = new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
        for(let s = 0; s < e.byteLength; s += e.BYTES_PER_ELEMENT)for(let r = s + e.BYTES_PER_ELEMENT - 1, n = s; r > n; r--, n++){
            let a = t[n];
            t[n] = t[r], t[r] = a;
        }
        return e;
    }
    readString(e, t) {
        return t === void 0 || t === "ASCII" ? $e833773b1f4e7d0f$var$br(this.mapUint8Array(e === void 0 ? this.byteLength - this.position : e)) : new TextDecoder(t).decode(this.mapUint8Array(e));
    }
    readCString(e) {
        let t = 0, s = this.byteLength - this.position, r = new Uint8Array(this._buffer, this._byteOffset + this.position), n = e !== void 0 ? Math.min(e, s) : s;
        for(; t < n && r[t] !== 0; t++);
        let a = $e833773b1f4e7d0f$var$br(this.mapUint8Array(t));
        return e !== void 0 ? this.position += n - t : t !== s && (this.position += 1), a;
    }
    readInt64() {
        return this.readInt32() * $e833773b1f4e7d0f$var$Ji + this.readUint32();
    }
    readUint64() {
        return this.readUint32() * $e833773b1f4e7d0f$var$Ji + this.readUint32();
    }
    readUint24() {
        return (this.readUint8() << 16) + (this.readUint8() << 8) + this.readUint8();
    }
    save(e) {
        let t = new Blob([
            this.buffer
        ]);
        if (typeof window < "u" && typeof document < "u") {
            if (window.URL && URL.createObjectURL) {
                let s = window.URL.createObjectURL(t), r = document.createElement("a");
                document.body.appendChild(r), r.setAttribute("href", s), r.setAttribute("download", e), r.setAttribute("target", "_self"), r.click(), window.URL.revokeObjectURL(s), document.body.removeChild(r);
            } else throw new Error("DataStream.save: Can't create object URL.");
        }
        return t;
    }
    get dynamicSize() {
        return this._dynamicSize;
    }
    set dynamicSize(e) {
        e || this._trimAlloc(), this._dynamicSize = e;
    }
    shift(e) {
        let t = new $e833773b1f4e7d0f$var$$(this._byteLength - e), s = new Uint8Array(t), r = new Uint8Array(this._buffer, e, s.length);
        s.set(r), this.buffer = t, this.position -= e;
    }
    writeInt32Array(e, t) {
        if (this._realloc(e.length * 4), e instanceof Int32Array && this.byteOffset + this.position % e.BYTES_PER_ELEMENT === 0) I.memcpy(this._buffer, this.byteOffset + this.position, e.buffer, 0, e.byteLength), this.mapInt32Array(e.length, t);
        else for(let s = 0; s < e.length; s++)this.writeInt32(e[s], t);
    }
    writeInt16Array(e, t) {
        if (this._realloc(e.length * 2), e instanceof Int16Array && this.byteOffset + this.position % e.BYTES_PER_ELEMENT === 0) I.memcpy(this._buffer, this.byteOffset + this.position, e.buffer, 0, e.byteLength), this.mapInt16Array(e.length, t);
        else for(let s = 0; s < e.length; s++)this.writeInt16(e[s], t);
    }
    writeInt8Array(e) {
        if (this._realloc(e.length * 1), e instanceof Int8Array && this.byteOffset + this.position % e.BYTES_PER_ELEMENT === 0) I.memcpy(this._buffer, this.byteOffset + this.position, e.buffer, 0, e.byteLength), this.mapInt8Array(e.length);
        else for(let t = 0; t < e.length; t++)this.writeInt8(e[t]);
    }
    writeUint32Array(e, t) {
        if (this._realloc(e.length * 4), e instanceof Uint32Array && this.byteOffset + this.position % e.BYTES_PER_ELEMENT === 0) I.memcpy(this._buffer, this.byteOffset + this.position, e.buffer, 0, e.byteLength), this.mapUint32Array(e.length, t);
        else for(let s = 0; s < e.length; s++)this.writeUint32(e[s], t);
    }
    writeUint16Array(e, t) {
        if (this._realloc(e.length * 2), e instanceof Uint16Array && this.byteOffset + this.position % e.BYTES_PER_ELEMENT === 0) I.memcpy(this._buffer, this.byteOffset + this.position, e.buffer, 0, e.byteLength), this.mapUint16Array(e.length, t);
        else for(let s = 0; s < e.length; s++)this.writeUint16(e[s], t);
    }
    writeUint8Array(e) {
        if (this._realloc(e.length * 1), e instanceof Uint8Array && this.byteOffset + this.position % e.BYTES_PER_ELEMENT === 0) I.memcpy(this._buffer, this.byteOffset + this.position, e.buffer, 0, e.byteLength), this.mapUint8Array(e.length);
        else for(let t = 0; t < e.length; t++)this.writeUint8(e[t]);
    }
    writeFloat64Array(e, t) {
        if (this._realloc(e.length * 8), e instanceof Float64Array && this.byteOffset + this.position % e.BYTES_PER_ELEMENT === 0) I.memcpy(this._buffer, this.byteOffset + this.position, e.buffer, 0, e.byteLength), this.mapFloat64Array(e.length, t);
        else for(let s = 0; s < e.length; s++)this.writeFloat64(e[s], t);
    }
    writeFloat32Array(e, t) {
        if (this._realloc(e.length * 4), e instanceof Float32Array && this.byteOffset + this.position % e.BYTES_PER_ELEMENT === 0) I.memcpy(this._buffer, this.byteOffset + this.position, e.buffer, 0, e.byteLength), this.mapFloat32Array(e.length, t);
        else for(let s = 0; s < e.length; s++)this.writeFloat32(e[s], t);
    }
    writeInt64(e, t) {
        this._realloc(8), this._dataView.setBigInt64(this.position, BigInt(e), (t ?? this.endianness) === 2), this.position += 8;
    }
    writeInt32(e, t) {
        this._realloc(4), this._dataView.setInt32(this.position, e, (t ?? this.endianness) === 2), this.position += 4;
    }
    writeInt16(e, t) {
        this._realloc(2), this._dataView.setInt16(this.position, e, (t ?? this.endianness) === 2), this.position += 2;
    }
    writeInt8(e) {
        this._realloc(1), this._dataView.setInt8(this.position, e), this.position += 1;
    }
    writeUint32(e, t) {
        this._realloc(4), this._dataView.setUint32(this.position, e, (t ?? this.endianness) === 2), this.position += 4;
    }
    writeUint16(e, t) {
        this._realloc(2), this._dataView.setUint16(this.position, e, (t ?? this.endianness) === 2), this.position += 2;
    }
    writeUint8(e) {
        this._realloc(1), this._dataView.setUint8(this.position, e), this.position += 1;
    }
    writeFloat32(e, t) {
        this._realloc(4), this._dataView.setFloat32(this.position, e, (t ?? this.endianness) === 2), this.position += 4;
    }
    writeFloat64(e, t) {
        this._realloc(8), this._dataView.setFloat64(this.position, e, (t ?? this.endianness) === 2), this.position += 8;
    }
    writeUCS2String(e, t, s) {
        s === void 0 && (s = e.length);
        let r;
        for(r = 0; r < e.length && r < s; r++)this.writeUint16(e.charCodeAt(r), t);
        for(; r < s; r++)this.writeUint16(0);
    }
    writeString(e, t, s) {
        let r = 0;
        if (t === void 0 || t === "ASCII") {
            if (s !== void 0) {
                let n = Math.min(e.length, s);
                for(r = 0; r < n; r++)this.writeUint8(e.charCodeAt(r));
                for(; r < s; r++)this.writeUint8(0);
            } else for(r = 0; r < e.length; r++)this.writeUint8(e.charCodeAt(r));
        } else this.writeUint8Array(new TextEncoder(t).encode(e.substring(0, s)));
    }
    writeCString(e, t) {
        let s = 0;
        if (t !== void 0) {
            let r = Math.min(e.length, t);
            for(s = 0; s < r; s++)this.writeUint8(e.charCodeAt(s));
            for(; s < t; s++)this.writeUint8(0);
        } else {
            for(s = 0; s < e.length; s++)this.writeUint8(e.charCodeAt(s));
            this.writeUint8(0);
        }
    }
    writeStruct(e, t) {
        for(let s = 0; s < e.length; s++){
            let [r, n] = e[s], a = t[r];
            this.writeType(n, a, t);
        }
    }
    writeType(e, t, s) {
        if (typeof e == "function") return e(this, t);
        if (typeof e == "object" && !(e instanceof Array)) return e.set(this, t, s);
        let r, n = "ASCII", a = this.position, o = e;
        if (typeof e == "string" && /:/.test(e)) {
            let u = e.split(":");
            o = u[0], r = parseInt(u[1]);
        }
        if (typeof o == "string" && /,/.test(o)) {
            let u = o.split(",");
            o = u[0], n = u[1];
        }
        switch(o){
            case "uint8":
                this.writeUint8(t);
                break;
            case "int8":
                this.writeInt8(t);
                break;
            case "uint16":
                this.writeUint16(t, this.endianness);
                break;
            case "int16":
                this.writeInt16(t, this.endianness);
                break;
            case "uint32":
                this.writeUint32(t, this.endianness);
                break;
            case "int32":
                this.writeInt32(t, this.endianness);
                break;
            case "float32":
                this.writeFloat32(t, this.endianness);
                break;
            case "float64":
                this.writeFloat64(t, this.endianness);
                break;
            case "uint16be":
                this.writeUint16(t, 1);
                break;
            case "int16be":
                this.writeInt16(t, 1);
                break;
            case "uint32be":
                this.writeUint32(t, 1);
                break;
            case "int32be":
                this.writeInt32(t, 1);
                break;
            case "float32be":
                this.writeFloat32(t, 1);
                break;
            case "float64be":
                this.writeFloat64(t, 1);
                break;
            case "uint16le":
                this.writeUint16(t, 2);
                break;
            case "int16le":
                this.writeInt16(t, 2);
                break;
            case "uint32le":
                this.writeUint32(t, 2);
                break;
            case "int32le":
                this.writeInt32(t, 2);
                break;
            case "float32le":
                this.writeFloat32(t, 2);
                break;
            case "float64le":
                this.writeFloat64(t, 2);
                break;
            case "cstring":
                this.writeCString(t, r);
                break;
            case "string":
                this.writeString(t, n, r);
                break;
            case "u16string":
                this.writeUCS2String(t, this.endianness, r);
                break;
            case "u16stringle":
                this.writeUCS2String(t, 2, r);
                break;
            case "u16stringbe":
                this.writeUCS2String(t, 1, r);
                break;
            default:
                if (this.#e(o)) {
                    let [, u] = o;
                    for(let l = 0; l < t.length; l++)this.writeType(u, t[l]);
                    break;
                } else {
                    this.writeStruct(o, t);
                    break;
                }
        }
        r && (this.position = a, this._realloc(r), this.position = a + r);
    }
    writeUint64(e) {
        let t = Math.floor(e / $e833773b1f4e7d0f$var$Ji);
        this.writeUint32(t), this.writeUint32(e & 4294967295);
    }
    writeUint24(e) {
        this.writeUint8((e & 16711680) >> 16), this.writeUint8((e & 65280) >> 8), this.writeUint8(e & 255);
    }
    adjustUint32(e, t) {
        let s = this.position;
        this.seek(e), this.writeUint32(t), this.seek(s);
    }
    readStruct(e) {
        let t = {}, s = this.position;
        for(let r = 0; r < e.length; r += 1){
            let n = e[r][1], a = this.readType(n, t);
            if (!a) {
                this.failurePosition === 0 && (this.failurePosition = this.position), this.position = s;
                return;
            }
            t[e[r][0]] = a;
        }
        return t;
    }
    readUCS2String(e, t) {
        return String.fromCharCode.apply(void 0, this.readUint16Array(e, t));
    }
    readType(e, t) {
        if (typeof e == "function") return e(this, t);
        if (typeof e == "object" && !(e instanceof Array)) return e.get(this, t);
        if (e instanceof Array && e.length !== 3) return this.readStruct(e);
        let s, r, n = "ASCII", a = this.position, o = e;
        if (typeof o == "string" && /:/.test(o)) {
            let u = o.split(":");
            o = u[0], r = parseInt(u[1]);
        }
        if (typeof o == "string" && /,/.test(o)) {
            let u = o.split(",");
            o = u[0], n = u[1];
        }
        switch(o){
            case "uint8":
                s = this.readUint8();
                break;
            case "int8":
                s = this.readInt8();
                break;
            case "uint16":
                s = this.readUint16(this.endianness);
                break;
            case "int16":
                s = this.readInt16(this.endianness);
                break;
            case "uint32":
                s = this.readUint32(this.endianness);
                break;
            case "int32":
                s = this.readInt32(this.endianness);
                break;
            case "float32":
                s = this.readFloat32(this.endianness);
                break;
            case "float64":
                s = this.readFloat64(this.endianness);
                break;
            case "uint16be":
                s = this.readUint16(1);
                break;
            case "int16be":
                s = this.readInt16(1);
                break;
            case "uint32be":
                s = this.readUint32(1);
                break;
            case "int32be":
                s = this.readInt32(1);
                break;
            case "float32be":
                s = this.readFloat32(1);
                break;
            case "float64be":
                s = this.readFloat64(1);
                break;
            case "uint16le":
                s = this.readUint16(2);
                break;
            case "int16le":
                s = this.readInt16(2);
                break;
            case "uint32le":
                s = this.readUint32(2);
                break;
            case "int32le":
                s = this.readInt32(2);
                break;
            case "float32le":
                s = this.readFloat32(2);
                break;
            case "float64le":
                s = this.readFloat64(2);
                break;
            case "cstring":
                s = this.readCString(r);
                break;
            case "string":
                s = this.readString(r, n);
                break;
            case "u16string":
                s = this.readUCS2String(r, this.endianness);
                break;
            case "u16stringle":
                s = this.readUCS2String(r, 2);
                break;
            case "u16stringbe":
                s = this.readUCS2String(r, 1);
                break;
            default:
                if (this.#e(o)) {
                    let [, u, l] = o, h = typeof l == "function" ? l(t, this, o) : typeof l == "string" && t[l] !== void 0 ? parseInt(t[l]) : typeof l == "number" ? l : l === "*" ? void 0 : parseInt(l);
                    if (typeof u == "string") {
                        let d = u.replace(/(le|be)$/, ""), c;
                        switch(/le$/.test(u) ? c = 2 : /be$/.test(u) && (c = 1), d){
                            case "uint8":
                                s = this.readUint8Array(h);
                                break;
                            case "uint16":
                                s = this.readUint16Array(h, c);
                                break;
                            case "uint32":
                                s = this.readUint32Array(h, c);
                                break;
                            case "int8":
                                s = this.readInt8Array(h);
                                break;
                            case "int16":
                                s = this.readInt16Array(h, c);
                                break;
                            case "int32":
                                s = this.readInt32Array(h, c);
                                break;
                            case "float32":
                                s = this.readFloat32Array(h, c);
                                break;
                            case "float64":
                                s = this.readFloat64Array(h, c);
                                break;
                            case "cstring":
                            case "utf16string":
                            case "string":
                                if (h) {
                                    s = new Array(h);
                                    for(let p = 0; p < h; p++)s[p] = this.readType(u, t);
                                } else for(s = []; !this.isEof();){
                                    let p = this.readType(u, t);
                                    if (!p) break;
                                    s.push(p);
                                }
                                break;
                        }
                    } else if (h) {
                        s = new Array(h);
                        for(let d = 0; d < h; d++){
                            let c = this.readType(u, t);
                            if (!c) return;
                            s[d] = c;
                        }
                    } else for(s = [];;){
                        let d = this.position;
                        try {
                            let c = this.readType(u, t);
                            if (!c) {
                                this.position = d;
                                break;
                            }
                            s.push(c);
                        } catch  {
                            this.position = d;
                            break;
                        }
                    }
                    break;
                }
        }
        return r && (this.position = a + r), s;
    }
    mapInt32Array(e, t) {
        this._realloc(e * 4);
        let s = new Int32Array(this._buffer, this.byteOffset + this.position, e);
        return I.arrayToNative(s, t ?? this.endianness), this.position += e * 4, s;
    }
    mapInt16Array(e, t) {
        this._realloc(e * 2);
        let s = new Int16Array(this._buffer, this.byteOffset + this.position, e);
        return I.arrayToNative(s, t ?? this.endianness), this.position += e * 2, s;
    }
    mapInt8Array(e, t) {
        this._realloc(e * 1);
        let s = new Int8Array(this._buffer, this.byteOffset + this.position, e);
        return this.position += e * 1, s;
    }
    mapUint32Array(e, t) {
        this._realloc(e * 4);
        let s = new Uint32Array(this._buffer, this.byteOffset + this.position, e);
        return I.arrayToNative(s, t ?? this.endianness), this.position += e * 4, s;
    }
    mapUint16Array(e, t) {
        this._realloc(e * 2);
        let s = new Uint16Array(this._buffer, this.byteOffset + this.position, e);
        return I.arrayToNative(s, t ?? this.endianness), this.position += e * 2, s;
    }
    mapFloat64Array(e, t) {
        this._realloc(e * 8);
        let s = new Float64Array(this._buffer, this.byteOffset + this.position, e);
        return I.arrayToNative(s, t ?? this.endianness), this.position += e * 8, s;
    }
    mapFloat32Array(e, t) {
        this._realloc(e * 4);
        let s = new Float32Array(this._buffer, this.byteOffset + this.position, e);
        return I.arrayToNative(s, t ?? this.endianness), this.position += e * 4, s;
    }
};
function $e833773b1f4e7d0f$var$br(i) {
    let e = [];
    for(let t = 0; t < i.length; t++)e[t] = i[t];
    return String.fromCharCode.apply(void 0, e);
}
var $e833773b1f4e7d0f$var$Nt = new Date, $e833773b1f4e7d0f$var$jt = 4, $e833773b1f4e7d0f$var$Sr = 3, $e833773b1f4e7d0f$var$Tr = 2, $e833773b1f4e7d0f$var$wr = 1, $e833773b1f4e7d0f$var$me = $e833773b1f4e7d0f$var$jt, $e833773b1f4e7d0f$var$g = {
    setLogLevel (i) {
        i === this.debug ? $e833773b1f4e7d0f$var$me = $e833773b1f4e7d0f$var$wr : i === this.info ? $e833773b1f4e7d0f$var$me = $e833773b1f4e7d0f$var$Tr : i === this.warn ? $e833773b1f4e7d0f$var$me = $e833773b1f4e7d0f$var$Sr : (this.error, $e833773b1f4e7d0f$var$me = $e833773b1f4e7d0f$var$jt);
    },
    debug (i, e) {
        console.debug === void 0 && (console.debug = console.log), $e833773b1f4e7d0f$var$wr >= $e833773b1f4e7d0f$var$me && console.debug("[" + $e833773b1f4e7d0f$var$g.getDurationString(new Date().getTime() - $e833773b1f4e7d0f$var$Nt.getTime(), 1e3) + "]", "[" + i + "]", e);
    },
    log (i, e) {
        this.debug(i.msg);
    },
    info (i, e) {
        $e833773b1f4e7d0f$var$Tr >= $e833773b1f4e7d0f$var$me && console.info("[" + $e833773b1f4e7d0f$var$g.getDurationString(new Date().getTime() - $e833773b1f4e7d0f$var$Nt.getTime(), 1e3) + "]", "[" + i + "]", e);
    },
    warn (i, e) {
        $e833773b1f4e7d0f$var$Sr >= $e833773b1f4e7d0f$var$me && console.warn("[" + $e833773b1f4e7d0f$var$g.getDurationString(new Date().getTime() - $e833773b1f4e7d0f$var$Nt.getTime(), 1e3) + "]", "[" + i + "]", e);
    },
    error (i, e, t) {
        t?.onError ? t.onError(i, e) : $e833773b1f4e7d0f$var$jt >= $e833773b1f4e7d0f$var$me && console.error("[" + $e833773b1f4e7d0f$var$g.getDurationString(new Date().getTime() - $e833773b1f4e7d0f$var$Nt.getTime(), 1e3) + "]", "[" + i + "]", e);
    },
    getDurationString (i, e) {
        let t;
        function s(l, h) {
            let c = ("" + l).split(".");
            for(; c[0].length < h;)c[0] = "0" + c[0];
            return c.join(".");
        }
        i < 0 ? (t = !0, i = -i) : t = !1;
        let n = i / (e || 1), a = Math.floor(n / 3600);
        n -= a * 3600;
        let o = Math.floor(n / 60);
        n -= o * 60;
        let u = n * 1e3;
        return n = Math.floor(n), u -= n * 1e3, u = Math.floor(u), (t ? "-" : "") + a + ":" + s(o, 2) + ":" + s(n, 2) + "." + s(u, 3);
    },
    printRanges (i) {
        let e = i.length;
        if (e > 0) {
            let t = "";
            for(let s = 0; s < e; s++)s > 0 && (t += ","), t += "[" + $e833773b1f4e7d0f$var$g.getDurationString(i.start(s)) + "," + $e833773b1f4e7d0f$var$g.getDurationString(i.end(s)) + "]";
            return t;
        } else return "(empty)";
    }
};
function $e833773b1f4e7d0f$var$Zu(i, e) {
    $e833773b1f4e7d0f$var$g.debug("ArrayBuffer", "Trying to create a new buffer of size: " + (i.byteLength + e.byteLength));
    let t = new Uint8Array(i.byteLength + e.byteLength);
    return t.set(new Uint8Array(i), 0), t.set(new Uint8Array(e), i.byteLength), t.buffer;
}
var $e833773b1f4e7d0f$var$ct = class extends $e833773b1f4e7d0f$var$V {
    constructor(i){
        super(new ArrayBuffer, 0), this.buffers = [], this.bufferIndex = -1, i && (this.insertBuffer(i), this.bufferIndex = 0);
    }
    initialized() {
        if (this.bufferIndex > -1) return !0;
        if (this.buffers.length > 0) {
            let i = this.buffers[0];
            return i.fileStart === 0 ? (this.buffer = i, this.bufferIndex = 0, $e833773b1f4e7d0f$var$g.debug("MultiBufferStream", "Stream ready for parsing"), !0) : ($e833773b1f4e7d0f$var$g.warn("MultiBufferStream", "The first buffer should have a fileStart of 0"), this.logBufferLevel(), !1);
        } else return $e833773b1f4e7d0f$var$g.warn("MultiBufferStream", "No buffer to start parsing from"), this.logBufferLevel(), !1;
    }
    reduceBuffer(i, e, t) {
        let s = new Uint8Array(t);
        return s.set(new Uint8Array(i, e, t)), s.buffer.fileStart = i.fileStart + e, s.buffer.usedBytes = 0, s.buffer;
    }
    insertBuffer(i) {
        let e = !0, t = 0;
        for(; t < this.buffers.length; t++){
            let s = this.buffers[t];
            if (i.fileStart <= s.fileStart) {
                if (i.fileStart === s.fileStart) {
                    if (i.byteLength > s.byteLength) {
                        this.buffers.splice(t, 1), t--;
                        continue;
                    } else $e833773b1f4e7d0f$var$g.warn("MultiBufferStream", "Buffer (fileStart: " + i.fileStart + " - Length: " + i.byteLength + ") already appended, ignoring");
                } else i.fileStart + i.byteLength <= s.fileStart || (i = this.reduceBuffer(i, 0, s.fileStart - i.fileStart)), $e833773b1f4e7d0f$var$g.debug("MultiBufferStream", "Appending new buffer (fileStart: " + i.fileStart + " - Length: " + i.byteLength + ")"), this.buffers.splice(t, 0, i), t === 0 && (this.buffer = i);
                e = !1;
                break;
            } else if (i.fileStart < s.fileStart + s.byteLength) {
                let r = s.fileStart + s.byteLength - i.fileStart, n = i.byteLength - r;
                if (n > 0) i = this.reduceBuffer(i, r, n);
                else {
                    e = !1;
                    break;
                }
            }
        }
        e && ($e833773b1f4e7d0f$var$g.debug("MultiBufferStream", "Appending new buffer (fileStart: " + i.fileStart + " - Length: " + i.byteLength + ")"), this.buffers.push(i), t === 0 && (this.buffer = i));
    }
    logBufferLevel(i) {
        let e = [], t = "", s, r = 0, n = 0;
        for(let o = 0; o < this.buffers.length; o++){
            let u = this.buffers[o];
            o === 0 ? (s = {
                start: u.fileStart,
                end: u.fileStart + u.byteLength
            }, e.push(s), t += "[" + s.start + "-") : s.end === u.fileStart ? s.end = u.fileStart + u.byteLength : (s = {
                start: u.fileStart,
                end: u.fileStart + u.byteLength
            }, t += e[e.length - 1].end - 1 + "], [" + s.start + "-", e.push(s)), r += u.usedBytes, n += u.byteLength;
        }
        e.length > 0 && (t += s.end - 1 + "]");
        let a = i ? $e833773b1f4e7d0f$var$g.info : $e833773b1f4e7d0f$var$g.debug;
        this.buffers.length === 0 ? a("MultiBufferStream", "No more buffer in memory") : a("MultiBufferStream", "" + this.buffers.length + " stored buffer(s) (" + r + "/" + n + " bytes), continuous ranges: " + t);
    }
    cleanBuffers() {
        for(let i = 0; i < this.buffers.length; i++){
            let e = this.buffers[i];
            e.usedBytes === e.byteLength && ($e833773b1f4e7d0f$var$g.debug("MultiBufferStream", "Removing buffer #" + i), this.buffers.splice(i, 1), i--);
        }
    }
    mergeNextBuffer() {
        if (this.bufferIndex + 1 < this.buffers.length) {
            let i = this.buffers[this.bufferIndex + 1];
            if (i.fileStart === this.buffer.fileStart + this.buffer.byteLength) {
                let e = this.buffer.byteLength, t = this.buffer.usedBytes, s = this.buffer.fileStart;
                return this.buffers[this.bufferIndex] = $e833773b1f4e7d0f$var$Zu(this.buffer, i), this.buffer = this.buffers[this.bufferIndex], this.buffers.splice(this.bufferIndex + 1, 1), this.buffer.usedBytes = t, this.buffer.fileStart = s, $e833773b1f4e7d0f$var$g.debug("ISOFile", "Concatenating buffer for box parsing (length: " + e + "->" + this.buffer.byteLength + ")"), !0;
            } else return !1;
        } else return !1;
    }
    findPosition(i, e, t) {
        let s = -1, r = i === !0 ? 0 : this.bufferIndex;
        for(; r < this.buffers.length;){
            let a = this.buffers[r];
            if (a && a.fileStart <= e) s = r, t && (a.fileStart + a.byteLength <= e ? a.usedBytes = a.byteLength : a.usedBytes = e - a.fileStart, this.logBufferLevel());
            else break;
            r++;
        }
        if (s === -1) return -1;
        let n = this.buffers[s];
        return n.fileStart + n.byteLength >= e ? ($e833773b1f4e7d0f$var$g.debug("MultiBufferStream", "Found position in existing buffer #" + s), s) : -1;
    }
    findEndContiguousBuf(i) {
        let e = i !== void 0 ? i : this.bufferIndex, t = this.buffers[e];
        if (this.buffers.length > e + 1) for(let s = e + 1; s < this.buffers.length; s++){
            let r = this.buffers[s];
            if (r.fileStart === t.fileStart + t.byteLength) t = r;
            else break;
        }
        return t.fileStart + t.byteLength;
    }
    getEndFilePositionAfter(i) {
        let e = this.findPosition(!0, i, !1);
        return e !== -1 ? this.findEndContiguousBuf(e) : i;
    }
    addUsedBytes(i) {
        this.buffer.usedBytes += i, this.logBufferLevel();
    }
    setAllUsedBytes() {
        this.buffer.usedBytes = this.buffer.byteLength, this.logBufferLevel();
    }
    seek(i, e, t) {
        let s = this.findPosition(e, i, t);
        return s !== -1 ? (this.buffer = this.buffers[s], this.bufferIndex = s, this.position = i - this.buffer.fileStart, $e833773b1f4e7d0f$var$g.debug("MultiBufferStream", "Repositioning parser at buffer position: " + this.position), !0) : ($e833773b1f4e7d0f$var$g.debug("MultiBufferStream", "Position " + i + " not found in buffered data"), !1);
    }
    getPosition() {
        return this.bufferIndex === -1 || this.buffers[this.bufferIndex] === void 0 ? 0 : this.buffers[this.bufferIndex].fileStart + this.position;
    }
    getLength() {
        return this.byteLength;
    }
    getEndPosition() {
        return this.bufferIndex === -1 || this.buffers[this.bufferIndex] === void 0 ? 0 : this.buffers[this.bufferIndex].fileStart + this.byteLength;
    }
    getAbsoluteEndPosition() {
        if (this.buffers.length === 0) return 0;
        let i = this.buffers[this.buffers.length - 1];
        return i.fileStart + i.byteLength;
    }
}, $e833773b1f4e7d0f$var$y = class {
    constructor(i = 0){
        this.size = i;
    }
    static{
        this.registryId = Symbol.for("BoxIdentifier");
    }
    #e;
    get type() {
        return this.constructor.fourcc ?? this.#e;
    }
    set type(i) {
        this.#e = i;
    }
    addBox(i) {
        return this.boxes || (this.boxes = []), this.boxes.push(i), this[i.type + "s"] ? this[i.type + "s"].push(i) : this[i.type] = i, i;
    }
    set(i, e) {
        return this[i] = e, this;
    }
    addEntry(i, e) {
        let t = e || "entries";
        return this[t] || (this[t] = []), this[t].push(i), this;
    }
    writeHeader(i, e) {
        if (this.size += 8, (this.size > $e833773b1f4e7d0f$var$H || this.original_size === 1) && (this.size += 8), this.type === "uuid" && (this.size += 16), $e833773b1f4e7d0f$var$g.debug("BoxWriter", "Writing box " + this.type + " of size: " + this.size + " at position " + i.getPosition() + (e || "")), this.original_size === 0 ? i.writeUint32(0) : this.size > $e833773b1f4e7d0f$var$H || this.original_size === 1 ? i.writeUint32(1) : (this.sizePosition = i.getPosition(), i.writeUint32(this.size)), i.writeString(this.type, void 0, 4), this.type === "uuid") {
            let t = new Uint8Array(16);
            for(let s = 0; s < 16; s++)t[s] = parseInt(this.uuid.substring(s * 2, s * 2 + 2), 16);
            i.writeUint8Array(t);
        }
        (this.size > $e833773b1f4e7d0f$var$H || this.original_size === 1) && (this.sizePosition = i.getPosition(), i.writeUint64(this.size));
    }
    write(i) {
        if (this.type === "mdat") {
            let e = this;
            if (e.stream) {
                this.size = e.stream.getAbsoluteEndPosition(), this.writeHeader(i);
                for (let t of e.stream.buffers){
                    let s = new Uint8Array(t);
                    i.writeUint8Array(s);
                }
            } else e.data && (this.size = e.data.length, this.writeHeader(i), i.writeUint8Array(e.data));
        } else this.size = this.data ? this.data.length : 0, this.writeHeader(i), this.data && i.writeUint8Array(this.data);
    }
    printHeader(i) {
        this.size += 8, this.size > $e833773b1f4e7d0f$var$H && (this.size += 8), this.type === "uuid" && (this.size += 16), i.log(i.indent + "size:" + this.size), i.log(i.indent + "type:" + this.type);
    }
    print(i) {
        this.printHeader(i);
    }
    parse(i) {
        this.type !== "mdat" ? this.data = i.readUint8Array(this.size - this.hdr_size) : this.size === 0 ? i.seek(i.getEndPosition()) : i.seek(this.start + this.size);
    }
    parseDataAndRewind(i) {
        this.data = i.readUint8Array(this.size - this.hdr_size), i.seek(this.start + this.hdr_size);
    }
    parseLanguage(i) {
        this.language = i.readUint16();
        let e = [];
        e[0] = this.language >> 10 & 31, e[1] = this.language >> 5 & 31, e[2] = this.language & 31, this.languageString = String.fromCharCode(e[0] + 96, e[1] + 96, e[2] + 96);
    }
    computeSize(i) {
        let e = i || new $e833773b1f4e7d0f$var$ct;
        this.write(e);
    }
    isEndOfBox(i) {
        let e = i.getPosition(), t = this.start + this.size;
        return e === t;
    }
}, $e833773b1f4e7d0f$var$x = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.flags = 0, this.version = 0;
    }
    writeHeader(i) {
        this.size += 4, super.writeHeader(i, " v=" + this.version + " f=" + this.flags), i.writeUint8(this.version), i.writeUint24(this.flags);
    }
    printHeader(i) {
        this.size += 4, super.printHeader(i), i.log(i.indent + "version:" + this.version), i.log(i.indent + "flags:" + this.flags);
    }
    parseDataAndRewind(i) {
        this.parseFullHeader(i), this.data = i.readUint8Array(this.size - this.hdr_size), this.hdr_size -= 4, i.seek(this.start + this.hdr_size);
    }
    parseFullHeader(i) {
        this.version = i.readUint8(), this.flags = i.readUint24(), this.hdr_size += 4;
    }
    parse(i) {
        this.parseFullHeader(i), this.data = i.readUint8Array(this.size - this.hdr_size);
    }
}, $e833773b1f4e7d0f$var$z = class {
    constructor(i){
        this.grouping_type = i;
    }
    static{
        this.registryId = Symbol.for("SampleGroupEntryIdentifier");
    }
    write(i) {
        i.writeUint8Array(this.data);
    }
    parse(i) {
        $e833773b1f4e7d0f$var$g.warn("BoxParser", `Unknown sample group type: '${this.grouping_type}'`), this.data = i.readUint8Array(this.description_length);
    }
}, $e833773b1f4e7d0f$var$Ju = class extends $e833773b1f4e7d0f$var$x {
    parse(i) {
        this.parseFullHeader(i), this.track_group_id = i.readUint32();
    }
}, $e833773b1f4e7d0f$var$el = class extends $e833773b1f4e7d0f$var$y {
    constructor(i, e, t, s, r){
        super(e), this.box_name = t, this.hdr_size = s, this.start = r, this.type = i;
    }
    parse(i) {
        this.from_item_ID = i.readUint16();
        let e = i.readUint16();
        this.references = [];
        for(let t = 0; t < e; t++)this.references[t] = {
            to_item_ID: i.readUint16()
        };
    }
}, $e833773b1f4e7d0f$var$tl = class extends $e833773b1f4e7d0f$var$y {
    constructor(i, e, t, s, r){
        super(e), this.box_name = t, this.hdr_size = s, this.start = r, this.type = i;
    }
    parse(i) {
        this.from_item_ID = i.readUint32();
        let e = i.readUint16();
        this.references = [];
        for(let t = 0; t < e; t++)this.references[t] = {
            to_item_ID: i.readUint32()
        };
    }
}, $e833773b1f4e7d0f$var$il = class extends $e833773b1f4e7d0f$var$y {
    constructor(i, e, t, s){
        super(e), this.hdr_size = t, this.start = s, this.type = i;
    }
    parse(i) {
        this.track_ids = i.readUint32Array((this.size - this.hdr_size) / 4);
    }
    write(i) {
        this.size = this.track_ids.length * 4, this.writeHeader(i), i.writeUint32Array(this.track_ids);
    }
}, $e833773b1f4e7d0f$var$ts = [
    "boxes",
    "entries",
    "references",
    "subsamples",
    "items",
    "item_infos",
    "extents",
    "associations",
    "subsegments",
    "ranges",
    "seekLists",
    "seekPoints",
    "esd",
    "levels"
], $e833773b1f4e7d0f$var$sl = [
    "compatible_brands",
    "matrix",
    "opcolor",
    "sample_counts",
    "sample_deltas",
    "first_chunk",
    "samples_per_chunk",
    "sample_sizes",
    "chunk_offsets",
    "sample_offsets",
    "sample_description_index",
    "sample_duration"
];
function $e833773b1f4e7d0f$var$rl(i, e) {
    if (i && !e) return !1;
    let t;
    for(t in i)if (!$e833773b1f4e7d0f$var$ts.find((s)=>s === t)) {
        if (i[t] instanceof $e833773b1f4e7d0f$var$y || e[t] instanceof $e833773b1f4e7d0f$var$y) continue;
        if (typeof i[t] > "u" || typeof e[t] > "u") continue;
        if (typeof i[t] == "function" || typeof e[t] == "function") continue;
        if ("subBoxNames" in i && i.subBoxNames.indexOf(t.slice(0, 4)) > -1 || "subBoxNames" in e && e.subBoxNames.indexOf(t.slice(0, 4)) > -1) continue;
        if (t === "data" || t === "start" || t === "size" || t === "creation_time" || t === "modification_time") continue;
        if ($e833773b1f4e7d0f$var$sl.find((s)=>s === t)) continue;
        if (i[t] !== e[t]) return !1;
    }
    return !0;
}
function $e833773b1f4e7d0f$var$Ar(i, e) {
    if (!$e833773b1f4e7d0f$var$rl(i, e)) return !1;
    for(let t = 0; t < $e833773b1f4e7d0f$var$ts.length; t++){
        let s = $e833773b1f4e7d0f$var$ts[t];
        if (i[s] && e[s] && !$e833773b1f4e7d0f$var$Ar(i[s], e[s])) return !1;
    }
    return !0;
}
function $e833773b1f4e7d0f$var$as(i) {
    let e = i;
    for(; e;){
        if ("registryId" in e) return e.registryId;
        e = Object.getPrototypeOf(e);
    }
}
var $e833773b1f4e7d0f$var$nl = (i)=>{
    let e = Symbol.for("SampleGroupEntryIdentifier");
    return $e833773b1f4e7d0f$var$as(i) === e;
}, $e833773b1f4e7d0f$var$al = (i)=>{
    let e = Symbol.for("SampleEntryIdentifier");
    return $e833773b1f4e7d0f$var$as(i) === e;
}, $e833773b1f4e7d0f$var$ol = (i)=>{
    let e = Symbol.for("BoxIdentifier");
    return $e833773b1f4e7d0f$var$as(i) === e;
}, $e833773b1f4e7d0f$var$Z = {
    uuid: {},
    sampleEntry: {},
    sampleGroupEntry: {},
    box: {}
};
function $e833773b1f4e7d0f$var$ul(i) {
    let e = {
        uuid: {},
        sampleEntry: {},
        sampleGroupEntry: {},
        box: {}
    };
    for (let [t, s] of Object.entries(i)){
        if ($e833773b1f4e7d0f$var$nl(s)) {
            let r = "grouping_type" in s ? s.grouping_type : void 0;
            if (!r) throw new Error(`SampleGroupEntry class ${t} does not have a valid static grouping_type. Please ensure it is defined correctly.`);
            if (r in e.sampleGroupEntry) throw new Error(`SampleGroupEntry class ${t} has a grouping_type that is already registered. Please ensure it is unique.`);
            e.sampleGroupEntry[r] = s;
            continue;
        }
        if ($e833773b1f4e7d0f$var$al(s)) {
            let r = "fourcc" in s ? s.fourcc : void 0;
            if (!r) throw new Error(`SampleEntry class ${t} does not have a valid static fourcc. Please ensure it is defined correctly.`);
            if (r in e.sampleEntry) throw new Error(`SampleEntry class ${t} has a fourcc that is already registered. Please ensure it is unique.`);
            e.sampleEntry[r] = s;
            continue;
        }
        if ($e833773b1f4e7d0f$var$ol(s)) {
            let r = "fourcc" in s ? s.fourcc : void 0, n = "uuid" in s ? s.uuid : void 0;
            if (r === "uuid") {
                if (!n) throw new Error(`Box class ${t} has a fourcc of 'uuid' but does not have a valid uuid. Please ensure it is defined correctly.`);
                if (n in e.uuid) throw new Error(`Box class ${t} has a uuid that is already registered. Please ensure it is unique.`);
                e.uuid[n] = s;
                continue;
            }
            e.box[r] = s;
            continue;
        }
        throw new Error(`Box class ${t} does not have a valid static fourcc, uuid, or grouping_type. Please ensure it is defined correctly.`);
    }
    return $e833773b1f4e7d0f$var$Z.uuid = {
        ...e.uuid
    }, $e833773b1f4e7d0f$var$Z.sampleEntry = {
        ...e.sampleEntry
    }, $e833773b1f4e7d0f$var$Z.sampleGroupEntry = {
        ...e.sampleGroupEntry
    }, $e833773b1f4e7d0f$var$Z.box = {
        ...e.box
    }, $e833773b1f4e7d0f$var$Z;
}
var $e833773b1f4e7d0f$var$Qt = {};
function $e833773b1f4e7d0f$var$ll(i) {
    return Object.entries(i).forEach(([e, t])=>$e833773b1f4e7d0f$var$Qt[e] = t), $e833773b1f4e7d0f$var$Qt;
}
function $e833773b1f4e7d0f$var$hl(i) {
    return $e833773b1f4e7d0f$var$ke(i);
}
function $e833773b1f4e7d0f$var$ke(i) {
    let e = "";
    for(let t = 0; t < 16; t++){
        let s = i.readUint8().toString(16);
        e += s.length === 1 ? "0" + s : s;
    }
    return e;
}
function $e833773b1f4e7d0f$var$oe(i, e, t) {
    let s, r, n = i.getPosition(), a = 0, o;
    if (i.getEndPosition() - n < 8) return $e833773b1f4e7d0f$var$g.debug("BoxParser", "Not enough data in stream to parse the type and size of the box"), {
        code: $e833773b1f4e7d0f$var$be
    };
    if (t && t < 8) return $e833773b1f4e7d0f$var$g.debug("BoxParser", "Not enough bytes left in the parent box to parse a new box"), {
        code: $e833773b1f4e7d0f$var$be
    };
    let u = i.readUint32(), l = i.readString(4);
    if (l.length !== 4 || !/^[\x20-\x7E]{4}$/.test(l)) return $e833773b1f4e7d0f$var$g.error("BoxParser", `Invalid box type: '${l}'`), {
        code: $e833773b1f4e7d0f$var$Cr,
        start: n,
        type: l
    };
    let h = l;
    if ($e833773b1f4e7d0f$var$g.debug("BoxParser", "Found box of type '" + l + "' and size " + u + " at position " + n), a = 8, l === "uuid") {
        if (i.getEndPosition() - i.getPosition() < 16 || t - a < 16) return i.seek(n), $e833773b1f4e7d0f$var$g.debug("BoxParser", "Not enough bytes left in the parent box to parse a UUID box"), {
            code: $e833773b1f4e7d0f$var$be
        };
        o = $e833773b1f4e7d0f$var$hl(i), a += 16, h = o;
    }
    if (u === 1) {
        if (i.getEndPosition() - i.getPosition() < 8 || t && t - a < 8) return i.seek(n), $e833773b1f4e7d0f$var$g.warn("BoxParser", 'Not enough data in stream to parse the extended size of the "' + l + '" box'), {
            code: $e833773b1f4e7d0f$var$be
        };
        r = u, u = i.readUint64(), a += 8;
    } else if (u === 0) {
        if (t) u = t;
        else if (l !== "mdat") return $e833773b1f4e7d0f$var$g.error("BoxParser", "Unlimited box size not supported for type: '" + l + "'"), s = new $e833773b1f4e7d0f$var$y(u), s.type = l, {
            code: $e833773b1f4e7d0f$var$J,
            box: s,
            size: s.size
        };
    }
    if (u !== 0 && u < a) return $e833773b1f4e7d0f$var$g.error("BoxParser", "Box of type " + l + " has an invalid size " + u + " (too small to be a box)"), {
        code: $e833773b1f4e7d0f$var$be,
        type: l,
        size: u,
        hdr_size: a,
        start: n
    };
    if (u !== 0 && t && u > t) return $e833773b1f4e7d0f$var$g.error("BoxParser", "Box of type '" + l + "' has a size " + u + " greater than its container size " + t), {
        code: $e833773b1f4e7d0f$var$be,
        type: l,
        size: u,
        hdr_size: a,
        start: n
    };
    if (u !== 0 && n + u > i.getEndPosition()) return i.seek(n), $e833773b1f4e7d0f$var$g.info("BoxParser", "Not enough data in stream to parse the entire '" + l + "' box"), {
        code: $e833773b1f4e7d0f$var$be,
        type: l,
        size: u,
        hdr_size: a,
        start: n,
        original_size: r
    };
    if (e) return {
        code: $e833773b1f4e7d0f$var$J,
        type: l,
        size: u,
        hdr_size: a,
        start: n
    };
    l in $e833773b1f4e7d0f$var$Z.box ? s = new $e833773b1f4e7d0f$var$Z.box[l](u) : l !== "uuid" ? ($e833773b1f4e7d0f$var$g.warn("BoxParser", `Unknown box type: '${l}'`), s = new $e833773b1f4e7d0f$var$y(u), s.type = l, s.has_unparsed_data = !0) : o in $e833773b1f4e7d0f$var$Z.uuid ? s = new $e833773b1f4e7d0f$var$Z.uuid[o](u) : ($e833773b1f4e7d0f$var$g.warn("BoxParser", `Unknown UUID box type: '${o}'`), s = new $e833773b1f4e7d0f$var$y(u), s.type = l, s.uuid = o, s.has_unparsed_data = !0), s.original_size = r, s.hdr_size = a, s.start = n, s.write === $e833773b1f4e7d0f$var$y.prototype.write && s.type !== "mdat" && ($e833773b1f4e7d0f$var$g.info("BoxParser", "'" + h + "' box writing not yet implemented, keeping unparsed data in memory for later write"), s.parseDataAndRewind(i)), s.parse(i);
    let d = i.getPosition() - (s.start + s.size);
    return d < 0 ? ($e833773b1f4e7d0f$var$g.warn("BoxParser", "Parsing of box '" + h + "' did not read the entire indicated box data size (missing " + -d + " bytes), seeking forward"), i.seek(s.start + s.size)) : d > 0 && s.size !== 0 && ($e833773b1f4e7d0f$var$g.error("BoxParser", "Parsing of box '" + h + "' read " + d + " more bytes than the indicated box data size, seeking backwards"), i.seek(s.start + s.size)), {
        code: $e833773b1f4e7d0f$var$J,
        box: s,
        size: s.size
    };
}
var $e833773b1f4e7d0f$var$E = class extends $e833773b1f4e7d0f$var$y {
    write(i) {
        if (this.size = 0, this.writeHeader(i), this.boxes) for(let e = 0; e < this.boxes.length; e++)this.boxes[e] && (this.boxes[e].write(i), this.size += this.boxes[e].size);
        $e833773b1f4e7d0f$var$g.debug("BoxWriter", "Adjusting box " + this.type + " with new size " + this.size), i.adjustUint32(this.sizePosition, this.size);
    }
    print(i) {
        this.printHeader(i);
        for(let e = 0; e < this.boxes.length; e++)if (this.boxes[e]) {
            let t = i.indent;
            i.indent += " ", this.boxes[e].print(i), i.indent = t;
        }
    }
    parse(i) {
        let e;
        for(; i.getPosition() < this.start + this.size;)if (e = $e833773b1f4e7d0f$var$oe(i, !1, this.size - (i.getPosition() - this.start)), e.code === $e833773b1f4e7d0f$var$J) {
            let t = e.box;
            if (this.boxes || (this.boxes = []), this.boxes.push(t), this.subBoxNames && this.subBoxNames.indexOf(t.type) !== -1) {
                let s = this.subBoxNames[this.subBoxNames.indexOf(t.type)] + "s";
                this[s] || (this[s] = []), this[s].push(t);
            } else {
                let s = t.type !== "uuid" ? t.type : t.uuid;
                this[s] ? $e833773b1f4e7d0f$var$g.warn("ContainerBox", `Box of type ${s} already exists in container box ${this.type}.`) : this[s] = t;
            }
        } else return;
    }
}, $e833773b1f4e7d0f$var$ge = class extends $e833773b1f4e7d0f$var$E {
    constructor(i, e, t){
        super(i), this.hdr_size = e, this.start = t;
    }
    static{
        this.registryId = Symbol.for("SampleEntryIdentifier");
    }
    isVideo() {
        return !1;
    }
    isAudio() {
        return !1;
    }
    isSubtitle() {
        return !1;
    }
    isMetadata() {
        return !1;
    }
    isHint() {
        return !1;
    }
    getCodec() {
        return this.type.replace(".", "");
    }
    getWidth() {
        return "";
    }
    getHeight() {
        return "";
    }
    getChannelCount() {
        return "";
    }
    getSampleRate() {
        return "";
    }
    getSampleSize() {
        return "";
    }
    parseHeader(i) {
        i.readUint8Array(6), this.data_reference_index = i.readUint16(), this.hdr_size += 8;
    }
    parse(i) {
        this.parseHeader(i), this.data = i.readUint8Array(this.size - this.hdr_size);
    }
    parseDataAndRewind(i) {
        this.parseHeader(i), this.data = i.readUint8Array(this.size - this.hdr_size), this.hdr_size -= 8, i.seek(this.start + this.hdr_size);
    }
    parseFooter(i) {
        super.parse(i);
    }
    writeHeader(i) {
        this.size = 8, super.writeHeader(i), i.writeUint8(0), i.writeUint8(0), i.writeUint8(0), i.writeUint8(0), i.writeUint8(0), i.writeUint8(0), i.writeUint16(this.data_reference_index);
    }
    writeFooter(i) {
        if (this.boxes) for(let e = 0; e < this.boxes.length; e++)this.boxes[e].write(i), this.size += this.boxes[e].size;
        $e833773b1f4e7d0f$var$g.debug("BoxWriter", "Adjusting box " + this.type + " with new size " + this.size), i.adjustUint32(this.sizePosition, this.size);
    }
    write(i) {
        this.writeHeader(i), i.writeUint8Array(this.data), this.size += this.data.length, $e833773b1f4e7d0f$var$g.debug("BoxWriter", "Adjusting box " + this.type + " with new size " + this.size), i.adjustUint32(this.sizePosition, this.size);
    }
}, $e833773b1f4e7d0f$var$Ur = class extends $e833773b1f4e7d0f$var$ge {
}, $e833773b1f4e7d0f$var$Ye = class extends $e833773b1f4e7d0f$var$ge {
    isMetadata() {
        return !0;
    }
}, $e833773b1f4e7d0f$var$Re = class extends $e833773b1f4e7d0f$var$ge {
    isSubtitle() {
        return !0;
    }
}, $e833773b1f4e7d0f$var$dl = class extends $e833773b1f4e7d0f$var$ge {
}, $e833773b1f4e7d0f$var$M = class extends $e833773b1f4e7d0f$var$ge {
    parse(i) {
        this.parseHeader(i), i.readUint16(), i.readUint16(), i.readUint32Array(3), this.width = i.readUint16(), this.height = i.readUint16(), this.horizresolution = i.readUint32(), this.vertresolution = i.readUint32(), i.readUint32(), this.frame_count = i.readUint16();
        let e = Math.min(31, i.readUint8());
        this.compressorname = i.readString(e), e < 31 && i.readString(31 - e), this.depth = i.readUint16(), i.readUint16(), this.parseFooter(i);
    }
    isVideo() {
        return !0;
    }
    getWidth() {
        return this.width;
    }
    getHeight() {
        return this.height;
    }
    write(i) {
        this.writeHeader(i), this.size += 70, i.writeUint16(0), i.writeUint16(0), i.writeUint32(0), i.writeUint32(0), i.writeUint32(0), i.writeUint16(this.width), i.writeUint16(this.height), i.writeUint32(this.horizresolution), i.writeUint32(this.vertresolution), i.writeUint32(0), i.writeUint16(this.frame_count), i.writeUint8(Math.min(31, this.compressorname.length)), i.writeString(this.compressorname, void 0, 31), i.writeUint16(this.depth), i.writeInt16(-1), this.writeFooter(i);
    }
}, $e833773b1f4e7d0f$var$ee = class extends $e833773b1f4e7d0f$var$ge {
    parse(i) {
        this.parseHeader(i), this.version = i.readUint16(), i.readUint16(), i.readUint32(), this.channel_count = i.readUint16(), this.samplesize = i.readUint16(), i.readUint16(), i.readUint16(), this.samplerate = i.readUint32() / 65536, i.isofile?.ftyp?.major_brand.includes("qt") && (this.version === 1 ? this.extensions = i.readUint8Array(16) : this.version === 2 && (this.extensions = i.readUint8Array(36))), this.parseFooter(i);
    }
    isAudio() {
        return !0;
    }
    getChannelCount() {
        return this.channel_count;
    }
    getSampleRate() {
        return this.samplerate;
    }
    getSampleSize() {
        return this.samplesize;
    }
    write(i) {
        this.writeHeader(i), this.size += 20, i.writeUint32(0), i.writeUint32(0), i.writeUint16(this.channel_count), i.writeUint16(this.samplesize), i.writeUint16(0), i.writeUint16(0), i.writeUint32(this.samplerate << 16), this.writeFooter(i);
    }
}, $e833773b1f4e7d0f$var$os = class extends $e833773b1f4e7d0f$var$ge {
    parse(i) {
        this.parseHeader(i), this.parseFooter(i);
    }
    write(i) {
        this.writeHeader(i), this.writeFooter(i);
    }
}, $e833773b1f4e7d0f$var$Er = class extends Array {
    toString() {
        let i = "<table class='inner-table'>";
        i += "<thead><tr><th>length</th><th>nalu_data</th></tr></thead>", i += "<tbody>";
        for(let e = 0; e < this.length; e++){
            let t = this[e];
            i += "<tr>", i += "<td>" + t.length + "</td>", i += "<td>", i += t.data.reduce(function(s, r) {
                return s + r.toString(16).padStart(2, "0");
            }, "0x"), i += "</td></tr>";
        }
        return i += "</tbody></table>", i;
    }
}, $e833773b1f4e7d0f$var$Dr = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "AVCConfigurationBox";
    }
    static{
        this.fourcc = "avcC";
    }
    parse(i) {
        this.configurationVersion = i.readUint8(), this.AVCProfileIndication = i.readUint8(), this.profile_compatibility = i.readUint8(), this.AVCLevelIndication = i.readUint8(), this.lengthSizeMinusOne = i.readUint8() & 3, this.nb_SPS_nalus = i.readUint8() & 31;
        let e = this.size - this.hdr_size - 6;
        this.SPS = new $e833773b1f4e7d0f$var$Er;
        for(let t = 0; t < this.nb_SPS_nalus; t++){
            let s = i.readUint16();
            this.SPS.push({
                length: s,
                data: i.readUint8Array(s)
            }), e -= 2 + s;
        }
        this.nb_PPS_nalus = i.readUint8(), e--, this.PPS = new $e833773b1f4e7d0f$var$Er;
        for(let t = 0; t < this.nb_PPS_nalus; t++){
            let s = i.readUint16();
            this.PPS.push({
                length: s,
                data: i.readUint8Array(s)
            }), e -= 2 + s;
        }
        e > 0 && (this.ext = i.readUint8Array(e));
    }
    write(i) {
        this.size = 7;
        for(let e = 0; e < this.SPS.length; e++)this.size += 2 + this.SPS[e].length;
        for(let e = 0; e < this.PPS.length; e++)this.size += 2 + this.PPS[e].length;
        this.ext && (this.size += this.ext.length), this.writeHeader(i), i.writeUint8(this.configurationVersion), i.writeUint8(this.AVCProfileIndication), i.writeUint8(this.profile_compatibility), i.writeUint8(this.AVCLevelIndication), i.writeUint8(this.lengthSizeMinusOne + 252), i.writeUint8(this.SPS.length + 224);
        for(let e = 0; e < this.SPS.length; e++)i.writeUint16(this.SPS[e].length), i.writeUint8Array(this.SPS[e].data);
        i.writeUint8(this.PPS.length);
        for(let e = 0; e < this.PPS.length; e++)i.writeUint16(this.PPS[e].length), i.writeUint8Array(this.PPS[e].data);
        this.ext && i.writeUint8Array(this.ext);
    }
}, $e833773b1f4e7d0f$var$Xt = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "MediaDataBox";
    }
    static{
        this.fourcc = "mdat";
    }
}, $e833773b1f4e7d0f$var$cl = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "ItemDataBox";
    }
    static{
        this.fourcc = "idat";
    }
}, $e833773b1f4e7d0f$var$fl = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "FreeSpaceBox";
    }
    static{
        this.fourcc = "free";
    }
}, $e833773b1f4e7d0f$var$pl = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "FreeSpaceBox";
    }
    static{
        this.fourcc = "skip";
    }
}, $e833773b1f4e7d0f$var$Pr = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "HintMediaHeaderBox";
    }
    static{
        this.fourcc = "hmhd";
    }
}, $e833773b1f4e7d0f$var$Kt = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "NullMediaHeaderBox";
    }
    static{
        this.fourcc = "nmhd";
    }
}, $e833773b1f4e7d0f$var$ml = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "ObjectDescriptorBox";
    }
    static{
        this.fourcc = "iods";
    }
}, $e833773b1f4e7d0f$var$gl = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "XMLBox";
    }
    static{
        this.fourcc = "xml ";
    }
}, $e833773b1f4e7d0f$var$_l = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "BinaryXMLBox";
    }
    static{
        this.fourcc = "bxml";
    }
}, $e833773b1f4e7d0f$var$xl = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "ItemProtectionBox", this.sinfs = [];
    }
    static{
        this.fourcc = "ipro";
    }
    get protections() {
        return this.sinfs;
    }
}, $e833773b1f4e7d0f$var$is = class extends $e833773b1f4e7d0f$var$E {
    constructor(){
        super(...arguments), this.box_name = "MovieBox", this.traks = [], this.psshs = [], this.subBoxNames = [
            "trak",
            "pssh"
        ];
    }
    static{
        this.fourcc = "moov";
    }
}, $e833773b1f4e7d0f$var$kr = class extends $e833773b1f4e7d0f$var$E {
    constructor(){
        super(...arguments), this.box_name = "TrackBox", this.samples = [];
    }
    static{
        this.fourcc = "trak";
    }
}, $e833773b1f4e7d0f$var$yl = class extends $e833773b1f4e7d0f$var$E {
    constructor(){
        super(...arguments), this.box_name = "EditBox";
    }
    static{
        this.fourcc = "edts";
    }
}, $e833773b1f4e7d0f$var$Rr = class extends $e833773b1f4e7d0f$var$E {
    constructor(){
        super(...arguments), this.box_name = "MediaBox";
    }
    static{
        this.fourcc = "mdia";
    }
}, $e833773b1f4e7d0f$var$Fr = class extends $e833773b1f4e7d0f$var$E {
    constructor(){
        super(...arguments), this.box_name = "MediaInformationBox";
    }
    static{
        this.fourcc = "minf";
    }
}, $e833773b1f4e7d0f$var$Mr = class extends $e833773b1f4e7d0f$var$E {
    constructor(){
        super(...arguments), this.box_name = "DataInformationBox";
    }
    static{
        this.fourcc = "dinf";
    }
}, $e833773b1f4e7d0f$var$Or = class extends $e833773b1f4e7d0f$var$E {
    constructor(){
        super(...arguments), this.box_name = "SampleTableBox", this.sgpds = [], this.sbgps = [], this.subBoxNames = [
            "sgpd",
            "sbgp"
        ];
    }
    static{
        this.fourcc = "stbl";
    }
}, $e833773b1f4e7d0f$var$ss = class extends $e833773b1f4e7d0f$var$E {
    constructor(){
        super(...arguments), this.box_name = "MovieExtendsBox", this.trexs = [], this.subBoxNames = [
            "trex"
        ];
    }
    static{
        this.fourcc = "mvex";
    }
}, $e833773b1f4e7d0f$var$Lr = class extends $e833773b1f4e7d0f$var$E {
    constructor(){
        super(...arguments), this.box_name = "MovieFragmentBox", this.trafs = [], this.subBoxNames = [
            "traf"
        ];
    }
    static{
        this.fourcc = "moof";
    }
}, $e833773b1f4e7d0f$var$Nr = class extends $e833773b1f4e7d0f$var$E {
    constructor(){
        super(...arguments), this.box_name = "TrackFragmentBox", this.truns = [], this.sgpds = [], this.sbgps = [], this.subBoxNames = [
            "trun",
            "sgpd",
            "sbgp"
        ];
    }
    static{
        this.fourcc = "traf";
    }
}, $e833773b1f4e7d0f$var$vl = class extends $e833773b1f4e7d0f$var$E {
    constructor(){
        super(...arguments), this.box_name = "VTTCueBox";
    }
    static{
        this.fourcc = "vttc";
    }
}, $e833773b1f4e7d0f$var$bl = class extends $e833773b1f4e7d0f$var$E {
    constructor(){
        super(...arguments), this.box_name = "MovieFragmentRandomAccessBox", this.tfras = [], this.subBoxNames = [
            "tfra"
        ];
    }
    static{
        this.fourcc = "mfra";
    }
}, $e833773b1f4e7d0f$var$Sl = class extends $e833773b1f4e7d0f$var$E {
    constructor(){
        super(...arguments), this.box_name = "AdditionalMetadataContainerBox";
    }
    static{
        this.fourcc = "meco";
    }
}, $e833773b1f4e7d0f$var$Tl = class extends $e833773b1f4e7d0f$var$E {
    constructor(){
        super(...arguments), this.box_name = "trackhintinformation", this.subBoxNames = [
            "sdp ",
            "rtp "
        ];
    }
    static{
        this.fourcc = "hnti";
    }
}, $e833773b1f4e7d0f$var$wl = class extends $e833773b1f4e7d0f$var$E {
    constructor(){
        super(...arguments), this.box_name = "hintstatisticsbox", this.maxrs = [], this.subBoxNames = [
            "maxr"
        ];
    }
    static{
        this.fourcc = "hinf";
    }
}, $e833773b1f4e7d0f$var$Ul = class extends $e833773b1f4e7d0f$var$E {
    constructor(){
        super(...arguments), this.box_name = "SubTrackBox";
    }
    static{
        this.fourcc = "strk";
    }
}, $e833773b1f4e7d0f$var$El = class extends $e833773b1f4e7d0f$var$E {
    constructor(){
        super(...arguments), this.box_name = "SubTrackDefinitionBox";
    }
    static{
        this.fourcc = "strd";
    }
}, $e833773b1f4e7d0f$var$Il = class extends $e833773b1f4e7d0f$var$E {
    constructor(){
        super(...arguments), this.box_name = "ProtectionSchemeInfoBox";
    }
    static{
        this.fourcc = "sinf";
    }
}, $e833773b1f4e7d0f$var$Cl = class extends $e833773b1f4e7d0f$var$E {
    constructor(){
        super(...arguments), this.box_name = "RestrictedSchemeInfoBox";
    }
    static{
        this.fourcc = "rinf";
    }
}, $e833773b1f4e7d0f$var$Bl = class extends $e833773b1f4e7d0f$var$E {
    constructor(){
        super(...arguments), this.box_name = "SchemeInformationBox";
    }
    static{
        this.fourcc = "schi";
    }
}, $e833773b1f4e7d0f$var$Al = class extends $e833773b1f4e7d0f$var$E {
    constructor(){
        super(...arguments), this.box_name = "TrackGroupBox";
    }
    static{
        this.fourcc = "trgr";
    }
}, $e833773b1f4e7d0f$var$Dl = class extends $e833773b1f4e7d0f$var$E {
    constructor(){
        super(...arguments), this.box_name = "UserDataBox", this.kinds = [], this.strks = [], this.subBoxNames = [
            "kind",
            "strk"
        ];
    }
    static{
        this.fourcc = "udta";
    }
}, $e833773b1f4e7d0f$var$Pl = class extends $e833773b1f4e7d0f$var$E {
    constructor(){
        super(...arguments), this.box_name = "ItemPropertiesBox", this.ipmas = [], this.subBoxNames = [
            "ipma"
        ];
    }
    static{
        this.fourcc = "iprp";
    }
}, $e833773b1f4e7d0f$var$kl = class extends $e833773b1f4e7d0f$var$E {
    constructor(){
        super(...arguments), this.box_name = "ItemPropertyContainerBox", this.hvcCs = [], this.ispes = [], this.claps = [], this.irots = [], this.subBoxNames = [
            "hvcC",
            "ispe",
            "clap",
            "irot"
        ];
    }
    static{
        this.fourcc = "ipco";
    }
}, $e833773b1f4e7d0f$var$Rl = class extends $e833773b1f4e7d0f$var$E {
    constructor(){
        super(...arguments), this.box_name = "GroupsListBox";
    }
    static{
        this.fourcc = "grpl";
    }
}, $e833773b1f4e7d0f$var$Fl = class extends $e833773b1f4e7d0f$var$E {
    constructor(){
        super(...arguments), this.box_name = "J2KHeaderInfoBox";
    }
    static{
        this.fourcc = "j2kH";
    }
}, $e833773b1f4e7d0f$var$Ml = class extends $e833773b1f4e7d0f$var$E {
    constructor(){
        super(...arguments), this.box_name = "ExtendedTypeBox", this.tycos = [], this.subBoxNames = [
            "tyco"
        ];
    }
    static{
        this.fourcc = "etyp";
    }
}, $e833773b1f4e7d0f$var$Ol = class extends $e833773b1f4e7d0f$var$E {
    constructor(){
        super(...arguments), this.box_name = "ProjectedOmniVideoBox", this.subBoxNames = [
            "prfr"
        ];
    }
    static{
        this.fourcc = "povd";
    }
}, $e833773b1f4e7d0f$var$zr = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "DataReferenceBox";
    }
    static{
        this.fourcc = "dref";
    }
    parse(i) {
        this.parseFullHeader(i), this.entries = [];
        let e = i.readUint32();
        for(let t = 0; t < e; t++){
            let s = $e833773b1f4e7d0f$var$oe(i, !1, this.size - (i.getPosition() - this.start));
            if (s.code === $e833773b1f4e7d0f$var$J) {
                let r = s.box;
                this.entries.push(r);
            } else return;
        }
    }
    write(i) {
        this.version = 0, this.flags = 0, this.size = 4, this.writeHeader(i), i.writeUint32(this.entries.length);
        for(let e = 0; e < this.entries.length; e++)this.entries[e].write(i), this.size += this.entries[e].size;
        $e833773b1f4e7d0f$var$g.debug("BoxWriter", "Adjusting box " + this.type + " with new size " + this.size), i.adjustUint32(this.sizePosition, this.size);
    }
}, $e833773b1f4e7d0f$var$Gr = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "ExtendedLanguageBox";
    }
    static{
        this.fourcc = "elng";
    }
    parse(i) {
        this.parseFullHeader(i), this.extended_language = i.readString(this.size - this.hdr_size);
    }
    write(i) {
        this.version = 0, this.flags = 0, this.size = this.extended_language.length, this.writeHeader(i), i.writeString(this.extended_language);
    }
}, $e833773b1f4e7d0f$var$Vr = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "FileTypeBox";
    }
    static{
        this.fourcc = "ftyp";
    }
    parse(i) {
        let e = this.size - this.hdr_size;
        this.major_brand = i.readString(4), this.minor_version = i.readUint32(), e -= 8, this.compatible_brands = [];
        let t = 0;
        for(; e >= 4;)this.compatible_brands[t] = i.readString(4), e -= 4, t++;
    }
    write(i) {
        this.size = 8 + 4 * this.compatible_brands.length, this.writeHeader(i), i.writeString(this.major_brand, void 0, 4), i.writeUint32(this.minor_version);
        for(let e = 0; e < this.compatible_brands.length; e++)i.writeString(this.compatible_brands[e], void 0, 4);
    }
}, $e833773b1f4e7d0f$var$Hr = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "HandlerBox";
    }
    static{
        this.fourcc = "hdlr";
    }
    parse(i) {
        if (this.parseFullHeader(i), this.version === 0 && (i.readUint32(), this.handler = i.readString(4), i.readUint32Array(3), !this.isEndOfBox(i))) {
            let e = this.start + this.size - i.getPosition();
            this.name = i.readCString();
            let t = this.start + this.size - 1;
            i.seek(t), i.readUint8() !== 0 && e > 1 && ($e833773b1f4e7d0f$var$g.info("BoxParser", "Warning: hdlr name is not null-terminated, possibly length-prefixed string. Trimming first byte."), this.name = this.name.slice(1));
        }
    }
    write(i) {
        this.size = 20 + this.name.length + 1, this.version = 0, this.flags = 0, this.writeHeader(i), i.writeUint32(0), i.writeString(this.handler, void 0, 4), i.writeUint32Array([
            0,
            0,
            0
        ]), i.writeCString(this.name);
    }
}, $e833773b1f4e7d0f$var$qr = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "HEVCConfigurationBox";
    }
    static{
        this.fourcc = "hvcC";
    }
    parse(i) {
        this.configurationVersion = i.readUint8();
        let e = i.readUint8();
        this.general_profile_space = e >> 6, this.general_tier_flag = (e & 32) >> 5, this.general_profile_idc = e & 31, this.general_profile_compatibility = i.readUint32(), this.general_constraint_indicator = i.readUint8Array(6), this.general_level_idc = i.readUint8(), this.min_spatial_segmentation_idc = i.readUint16() & 4095, this.parallelismType = i.readUint8() & 3, this.chroma_format_idc = i.readUint8() & 3, this.bit_depth_luma_minus8 = i.readUint8() & 7, this.bit_depth_chroma_minus8 = i.readUint8() & 7, this.avgFrameRate = i.readUint16(), e = i.readUint8(), this.constantFrameRate = e >> 6, this.numTemporalLayers = (e & 13) >> 3, this.temporalIdNested = (e & 4) >> 2, this.lengthSizeMinusOne = e & 3, this.nalu_arrays = [];
        let t = i.readUint8();
        for(let s = 0; s < t; s++){
            let r = [];
            this.nalu_arrays.push(r), e = i.readUint8(), r.completeness = (e & 128) >> 7, r.nalu_type = e & 63;
            let n = i.readUint16();
            for(let a = 0; a < n; a++){
                let o = i.readUint16();
                r.push({
                    data: i.readUint8Array(o)
                });
            }
        }
    }
    write(i) {
        this.size = 23;
        for(let e = 0; e < this.nalu_arrays.length; e++){
            this.size += 3;
            for(let t = 0; t < this.nalu_arrays[e].length; t++)this.size += 2 + this.nalu_arrays[e][t].data.length;
        }
        this.writeHeader(i), i.writeUint8(this.configurationVersion), i.writeUint8((this.general_profile_space << 6) + (this.general_tier_flag << 5) + this.general_profile_idc), i.writeUint32(this.general_profile_compatibility), i.writeUint8Array(this.general_constraint_indicator), i.writeUint8(this.general_level_idc), i.writeUint16(this.min_spatial_segmentation_idc + 251658240), i.writeUint8(this.parallelismType + 252), i.writeUint8(this.chroma_format_idc + 252), i.writeUint8(this.bit_depth_luma_minus8 + 248), i.writeUint8(this.bit_depth_chroma_minus8 + 248), i.writeUint16(this.avgFrameRate), i.writeUint8((this.constantFrameRate << 6) + (this.numTemporalLayers << 3) + (this.temporalIdNested << 2) + this.lengthSizeMinusOne), i.writeUint8(this.nalu_arrays.length);
        for(let e = 0; e < this.nalu_arrays.length; e++){
            i.writeUint8((this.nalu_arrays[e].completeness << 7) + this.nalu_arrays[e].nalu_type), i.writeUint16(this.nalu_arrays[e].length);
            for(let t = 0; t < this.nalu_arrays[e].length; t++)i.writeUint16(this.nalu_arrays[e][t].data.length), i.writeUint8Array(this.nalu_arrays[e][t].data);
        }
    }
}, $e833773b1f4e7d0f$var$Wr = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "MediaHeaderBox";
    }
    static{
        this.fourcc = "mdhd";
    }
    parse(i) {
        this.parseFullHeader(i), this.version === 1 ? (this.creation_time = i.readUint64(), this.modification_time = i.readUint64(), this.timescale = i.readUint32(), this.duration = i.readUint64()) : (this.creation_time = i.readUint32(), this.modification_time = i.readUint32(), this.timescale = i.readUint32(), this.duration = i.readUint32()), this.parseLanguage(i), i.readUint16();
    }
    write(i) {
        let e = this.modification_time > $e833773b1f4e7d0f$var$H || this.creation_time > $e833773b1f4e7d0f$var$H || this.duration > $e833773b1f4e7d0f$var$H || this.version === 1;
        this.version = e ? 1 : 0, this.size = 20, this.size += e ? 12 : 0, this.flags = 0, this.writeHeader(i), e ? (i.writeUint64(this.creation_time), i.writeUint64(this.modification_time), i.writeUint32(this.timescale), i.writeUint64(this.duration)) : (i.writeUint32(this.creation_time), i.writeUint32(this.modification_time), i.writeUint32(this.timescale), i.writeUint32(this.duration)), i.writeUint16(this.language), i.writeUint16(0);
    }
}, $e833773b1f4e7d0f$var$Yr = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "MovieExtendsHeaderBox";
    }
    static{
        this.fourcc = "mehd";
    }
    parse(i) {
        this.parseFullHeader(i), this.flags & 1 && ($e833773b1f4e7d0f$var$g.warn("BoxParser", "mehd box incorrectly uses flags set to 1, converting version to 1"), this.version = 1), this.version === 1 ? this.fragment_duration = i.readUint64() : this.fragment_duration = i.readUint32();
    }
    write(i) {
        let e = this.fragment_duration > $e833773b1f4e7d0f$var$H || this.version === 1;
        this.version = e ? 1 : 0, this.size = 4, this.size += e ? 4 : 0, this.flags = 0, this.writeHeader(i), e ? i.writeUint64(this.fragment_duration) : i.writeUint32(this.fragment_duration);
    }
}, $e833773b1f4e7d0f$var$Ll = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "ItemInfoEntry";
    }
    static{
        this.fourcc = "infe";
    }
    parse(i) {
        if (this.parseFullHeader(i), (this.version === 0 || this.version === 1) && (this.item_ID = i.readUint16(), this.item_protection_index = i.readUint16(), this.item_name = i.readCString(), this.content_type = i.readCString(), this.isEndOfBox(i) || (this.content_encoding = i.readCString())), this.version === 1) {
            this.extension_type = i.readString(4), $e833773b1f4e7d0f$var$g.warn("BoxParser", "Cannot parse extension type"), i.seek(this.start + this.size);
            return;
        }
        this.version >= 2 && (this.version === 2 ? this.item_ID = i.readUint16() : this.version === 3 && (this.item_ID = i.readUint32()), this.item_protection_index = i.readUint16(), this.item_type = i.readString(4), this.item_name = i.readCString(), this.item_type === "mime" ? (this.content_type = i.readCString(), this.content_encoding = i.readCString()) : this.item_type === "uri " && (this.item_uri_type = i.readCString()));
    }
}, $e833773b1f4e7d0f$var$Nl = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "ItemInfoBox";
    }
    static{
        this.fourcc = "iinf";
    }
    parse(i) {
        this.parseFullHeader(i), this.version === 0 ? this.entry_count = i.readUint16() : this.entry_count = i.readUint32(), this.item_infos = [];
        for(let e = 0; e < this.entry_count; e++){
            let t = $e833773b1f4e7d0f$var$oe(i, !1, this.size - (i.getPosition() - this.start));
            if (t.code === $e833773b1f4e7d0f$var$J) {
                let s = t.box;
                s.type === "infe" ? this.item_infos[e] = s : $e833773b1f4e7d0f$var$g.error("BoxParser", "Expected 'infe' box, got " + t.box.type, i.isofile);
            } else return;
        }
    }
}, $e833773b1f4e7d0f$var$zl = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "ItemLocationBox";
    }
    static{
        this.fourcc = "iloc";
    }
    parse(i) {
        this.parseFullHeader(i);
        let e;
        e = i.readUint8(), this.offset_size = e >> 4 & 15, this.length_size = e & 15, e = i.readUint8(), this.base_offset_size = e >> 4 & 15, this.version === 1 || this.version === 2 ? this.index_size = e & 15 : this.index_size = 0, this.items = [];
        let t = 0;
        if (this.version < 2) t = i.readUint16();
        else if (this.version === 2) t = i.readUint32();
        else throw new Error("version of iloc box not supported");
        for(let s = 0; s < t; s++){
            let r = 0, n = 0, a = 0;
            if (this.version < 2) r = i.readUint16();
            else if (this.version === 2) r = i.readUint32();
            else throw new Error("version of iloc box not supported");
            this.version === 1 || this.version === 2 ? n = i.readUint16() & 15 : n = 0;
            let o = i.readUint16();
            switch(this.base_offset_size){
                case 0:
                    a = 0;
                    break;
                case 4:
                    a = i.readUint32();
                    break;
                case 8:
                    a = i.readUint64();
                    break;
                default:
                    throw new Error("Error reading base offset size");
            }
            let u = [], l = i.readUint16();
            for(let h = 0; h < l; h++){
                let d = 0, c = 0, p = 0;
                if (this.version === 1 || this.version === 2) switch(this.index_size){
                    case 0:
                        d = 0;
                        break;
                    case 4:
                        d = i.readUint32();
                        break;
                    case 8:
                        d = i.readUint64();
                        break;
                    default:
                        throw new Error("Error reading extent index");
                }
                switch(this.offset_size){
                    case 0:
                        c = 0;
                        break;
                    case 4:
                        c = i.readUint32();
                        break;
                    case 8:
                        c = i.readUint64();
                        break;
                    default:
                        throw new Error("Error reading extent index");
                }
                switch(this.length_size){
                    case 0:
                        p = 0;
                        break;
                    case 4:
                        p = i.readUint32();
                        break;
                    case 8:
                        p = i.readUint64();
                        break;
                    default:
                        throw new Error("Error reading extent index");
                }
                u.push({
                    extent_index: d,
                    extent_length: p,
                    extent_offset: c
                });
            }
            this.items.push({
                base_offset: a,
                construction_method: n,
                item_ID: r,
                data_reference_index: o,
                extents: u
            });
        }
    }
}, $e833773b1f4e7d0f$var$Gl = {
    auxl: "Auxiliary image item",
    base: "Pre-derived image item base",
    cdsc: "Item describes referenced item",
    dimg: "Derived image item",
    dpnd: "Item coding dependency",
    eroi: "Region",
    evir: "EVC slice",
    exbl: "Scalable image item",
    "fdl ": "File delivery",
    font: "Font item",
    iloc: "Item data location",
    mask: "Region mask",
    mint: "Data integrity",
    pred: "Predictively coded item",
    prem: "Pre-multiplied item",
    tbas: "HEVC tile track base item",
    text: "Text item",
    thmb: "Thumbnail image item"
}, $e833773b1f4e7d0f$var$Vl = class jr extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "ItemReferenceBox", this.references = [];
    }
    static{
        this.fourcc = "iref";
    }
    static{
        this.allowed_types = [
            "auxl",
            "base",
            "cdsc",
            "dimg",
            "dpnd",
            "eroi",
            "evir",
            "exbl",
            "fdl ",
            "font",
            "iloc",
            "mask",
            "mint",
            "pred",
            "prem",
            "tbas",
            "text",
            "thmb"
        ];
    }
    parse(e) {
        for(this.parseFullHeader(e), this.references = []; e.getPosition() < this.start + this.size;){
            let t = $e833773b1f4e7d0f$var$oe(e, !0, this.size - (e.getPosition() - this.start));
            if (t.code === $e833773b1f4e7d0f$var$J) {
                let s = "Unknown item reference";
                jr.allowed_types.includes(t.type) ? s = $e833773b1f4e7d0f$var$Gl[t.type] : $e833773b1f4e7d0f$var$g.warn("BoxParser", `Unknown item reference type: '${t.type}'`);
                let r = this.version === 0 ? new $e833773b1f4e7d0f$var$el(t.type, t.size, s, t.hdr_size, t.start) : new $e833773b1f4e7d0f$var$tl(t.type, t.size, s, t.hdr_size, t.start);
                r.write === $e833773b1f4e7d0f$var$y.prototype.write && r.type !== "mdat" && ($e833773b1f4e7d0f$var$g.warn("BoxParser", r.type + " box writing not yet implemented, keeping unparsed data in memory for later write"), r.parseDataAndRewind(e)), r.parse(e), this.references.push(r);
            } else return;
        }
    }
}, $e833773b1f4e7d0f$var$Hl = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "PrimaryItemBox";
    }
    static{
        this.fourcc = "pitm";
    }
    parse(i) {
        this.parseFullHeader(i), this.version === 0 ? this.item_id = i.readUint16() : this.item_id = i.readUint32();
    }
}, $e833773b1f4e7d0f$var$ql = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "MetaBox", this.isQT = !1;
    }
    static{
        this.fourcc = "meta";
    }
    parse(i) {
        let e = i.getPosition();
        if (this.size > 8) {
            switch(i.readUint32(), i.readString(4)){
                case "hdlr":
                case "mhdr":
                case "keys":
                case "ilst":
                case "ctry":
                case "lang":
                    this.isQT = !0;
                    break;
                default:
                    break;
            }
            i.seek(e);
        }
        this.isQT || this.parseFullHeader(i), $e833773b1f4e7d0f$var$E.prototype.parse.call(this, i);
    }
}, $e833773b1f4e7d0f$var$Xr = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "MovieFragmentHeaderBox";
    }
    static{
        this.fourcc = "mfhd";
    }
    parse(i) {
        this.parseFullHeader(i), this.sequence_number = i.readUint32();
    }
    write(i) {
        this.version = 0, this.flags = 0, this.size = 4, this.writeHeader(i), i.writeUint32(this.sequence_number);
    }
}, $e833773b1f4e7d0f$var$Kr = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "MovieHeaderBox";
    }
    static{
        this.fourcc = "mvhd";
    }
    parse(i) {
        this.parseFullHeader(i), this.version === 1 ? (this.creation_time = i.readUint64(), this.modification_time = i.readUint64(), this.timescale = i.readUint32(), this.duration = i.readUint64()) : (this.creation_time = i.readUint32(), this.modification_time = i.readUint32(), this.timescale = i.readUint32(), this.duration = i.readUint32()), this.rate = i.readUint32(), this.volume = i.readUint16() >> 8, i.readUint16(), i.readUint32Array(2), this.matrix = i.readInt32Array(9), i.readUint32Array(6), this.next_track_id = i.readUint32();
    }
    write(i) {
        let e = this.modification_time > $e833773b1f4e7d0f$var$H || this.creation_time > $e833773b1f4e7d0f$var$H || this.duration > $e833773b1f4e7d0f$var$H || this.version === 1;
        this.version = e ? 1 : 0, this.size = 96, this.size += e ? 12 : 0, this.flags = 0, this.writeHeader(i), e ? (i.writeUint64(this.creation_time), i.writeUint64(this.modification_time), i.writeUint32(this.timescale), i.writeUint64(this.duration)) : (i.writeUint32(this.creation_time), i.writeUint32(this.modification_time), i.writeUint32(this.timescale), i.writeUint32(this.duration)), i.writeUint32(this.rate), i.writeUint16(this.volume << 8), i.writeUint16(0), i.writeUint32(0), i.writeUint32(0), i.writeInt32Array(this.matrix), i.writeUint32(0), i.writeUint32(0), i.writeUint32(0), i.writeUint32(0), i.writeUint32(0), i.writeUint32(0), i.writeUint32(this.next_track_id);
    }
    print(i) {
        super.printHeader(i), i.log(i.indent + "creation_time: " + this.creation_time), i.log(i.indent + "modification_time: " + this.modification_time), i.log(i.indent + "timescale: " + this.timescale), i.log(i.indent + "duration: " + this.duration), i.log(i.indent + "rate: " + this.rate), i.log(i.indent + "volume: " + (this.volume >> 8)), i.log(i.indent + "matrix: " + this.matrix.join(", ")), i.log(i.indent + "next_track_id: " + this.next_track_id);
    }
}, $e833773b1f4e7d0f$var$Wl = class extends $e833773b1f4e7d0f$var$Ye {
    static{
        this.fourcc = "mett";
    }
    parse(i) {
        this.parseHeader(i), this.content_encoding = i.readCString(), this.mime_format = i.readCString(), this.parseFooter(i);
    }
}, $e833773b1f4e7d0f$var$Yl = class extends $e833773b1f4e7d0f$var$Ye {
    static{
        this.fourcc = "metx";
    }
    parse(i) {
        this.parseHeader(i), this.content_encoding = i.readCString(), this.namespace = i.readCString(), this.schema_location = i.readCString(), this.parseFooter(i);
    }
}, $e833773b1f4e7d0f$var$jl = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "AV1CodecConfigurationBox";
    }
    static{
        this.fourcc = "av1C";
    }
    parse(i) {
        let e = i.readUint8();
        if ((e >> 7 & 1) !== 1) {
            $e833773b1f4e7d0f$var$g.error("BoxParser", "av1C marker problem", i.isofile);
            return;
        }
        if (this.version = e & 127, this.version !== 1) {
            $e833773b1f4e7d0f$var$g.error("BoxParser", "av1C version " + this.version + " not supported", i.isofile);
            return;
        }
        if (e = i.readUint8(), this.seq_profile = e >> 5 & 7, this.seq_level_idx_0 = e & 31, e = i.readUint8(), this.seq_tier_0 = e >> 7 & 1, this.high_bitdepth = e >> 6 & 1, this.twelve_bit = e >> 5 & 1, this.monochrome = e >> 4 & 1, this.chroma_subsampling_x = e >> 3 & 1, this.chroma_subsampling_y = e >> 2 & 1, this.chroma_sample_position = e & 3, e = i.readUint8(), this.reserved_1 = e >> 5 & 7, this.reserved_1 !== 0) {
            $e833773b1f4e7d0f$var$g.error("BoxParser", "av1C reserved_1 parsing problem", i.isofile);
            return;
        }
        if (this.initial_presentation_delay_present = e >> 4 & 1, this.initial_presentation_delay_present === 1) this.initial_presentation_delay_minus_one = e & 15;
        else if (this.reserved_2 = e & 15, this.reserved_2 !== 0) {
            $e833773b1f4e7d0f$var$g.error("BoxParser", "av1C reserved_2 parsing problem", i.isofile);
            return;
        }
        let t = this.size - this.hdr_size - 4;
        this.configOBUs = i.readUint8Array(t);
    }
}, $e833773b1f4e7d0f$var$Xl = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "ElementaryStreamDescriptorBox";
    }
    static{
        this.fourcc = "esds";
    }
    parse(i) {
        this.parseFullHeader(i);
        let e = i.readUint8Array(this.size - this.hdr_size);
        if ("MPEG4DescriptorParser" in $e833773b1f4e7d0f$var$Qt) {
            let t = new $e833773b1f4e7d0f$var$Qt.MPEG4DescriptorParser;
            this.esd = t.parseOneDescriptor(new $e833773b1f4e7d0f$var$V(e.buffer, 0));
        }
    }
}, $e833773b1f4e7d0f$var$Kl = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "VPCodecConfigurationRecord";
    }
    static{
        this.fourcc = "vpcC";
    }
    parse(i) {
        if (this.parseFullHeader(i), this.version === 1) {
            this.profile = i.readUint8(), this.level = i.readUint8();
            let e = i.readUint8();
            this.bitDepth = e >> 4, this.chromaSubsampling = e >> 1 & 7, this.videoFullRangeFlag = e & 1, this.colourPrimaries = i.readUint8(), this.transferCharacteristics = i.readUint8(), this.matrixCoefficients = i.readUint8(), this.codecIntializationDataSize = i.readUint16(), this.codecIntializationData = i.readUint8Array(this.codecIntializationDataSize);
        } else {
            this.profile = i.readUint8(), this.level = i.readUint8();
            let e = i.readUint8();
            this.bitDepth = e >> 4 & 15, this.colorSpace = e & 15, e = i.readUint8(), this.chromaSubsampling = e >> 4 & 15, this.transferFunction = e >> 1 & 7, this.videoFullRangeFlag = e & 1, this.codecIntializationDataSize = i.readUint16(), this.codecIntializationData = i.readUint8Array(this.codecIntializationDataSize);
        }
    }
}, $e833773b1f4e7d0f$var$$l = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "VvcConfigurationBox";
    }
    static{
        this.fourcc = "vvcC";
    }
    parse(i) {
        this.parseFullHeader(i);
        let e = {
            held_bits: void 0,
            num_held_bits: 0,
            stream_read_1_bytes: function(n) {
                this.held_bits = n.readUint8(), this.num_held_bits = 8;
            },
            stream_read_2_bytes: function(n) {
                this.held_bits = n.readUint16(), this.num_held_bits = 16;
            },
            extract_bits: function(n) {
                let a = this.held_bits >> this.num_held_bits - n & (1 << n) - 1;
                return this.num_held_bits -= n, a;
            }
        };
        if (e.stream_read_1_bytes(i), e.extract_bits(5), this.lengthSizeMinusOne = e.extract_bits(2), this.ptl_present_flag = e.extract_bits(1), this.ptl_present_flag) {
            e.stream_read_2_bytes(i), this.ols_idx = e.extract_bits(9), this.num_sublayers = e.extract_bits(3), this.constant_frame_rate = e.extract_bits(2), this.chroma_format_idc = e.extract_bits(2), e.stream_read_1_bytes(i), this.bit_depth_minus8 = e.extract_bits(3), e.extract_bits(5);
            if (e.stream_read_2_bytes(i), e.extract_bits(2), this.num_bytes_constraint_info = e.extract_bits(6), this.general_profile_idc = e.extract_bits(7), this.general_tier_flag = e.extract_bits(1), this.general_level_idc = i.readUint8(), e.stream_read_1_bytes(i), this.ptl_frame_only_constraint_flag = e.extract_bits(1), this.ptl_multilayer_enabled_flag = e.extract_bits(1), this.general_constraint_info = new Uint8Array(this.num_bytes_constraint_info), this.num_bytes_constraint_info) {
                for(let n = 0; n < this.num_bytes_constraint_info - 1; n++){
                    let a = e.extract_bits(6);
                    e.stream_read_1_bytes(i);
                    let o = e.extract_bits(2);
                    this.general_constraint_info[n] = a << 2 | o;
                }
                this.general_constraint_info[this.num_bytes_constraint_info - 1] = e.extract_bits(6);
            } else e.extract_bits(6);
            if (this.num_sublayers > 1) {
                e.stream_read_1_bytes(i), this.ptl_sublayer_present_mask = 0;
                for(let n = this.num_sublayers - 2; n >= 0; --n){
                    let a = e.extract_bits(1);
                    this.ptl_sublayer_present_mask |= a << n;
                }
                for(let n = this.num_sublayers; n <= 8 && this.num_sublayers > 1; ++n)e.extract_bits(1);
                this.sublayer_level_idc = [];
                for(let n = this.num_sublayers - 2; n >= 0; --n)this.ptl_sublayer_present_mask & 1 << n && (this.sublayer_level_idc[n] = i.readUint8());
            }
            if (this.ptl_num_sub_profiles = i.readUint8(), this.general_sub_profile_idc = [], this.ptl_num_sub_profiles) for(let n = 0; n < this.ptl_num_sub_profiles; n++)this.general_sub_profile_idc.push(i.readUint32());
            this.max_picture_width = i.readUint16(), this.max_picture_height = i.readUint16(), this.avg_frame_rate = i.readUint16();
        }
        let t = 12, s = 13;
        this.nalu_arrays = [];
        let r = i.readUint8();
        for(let n = 0; n < r; n++){
            let a = [];
            this.nalu_arrays.push(a), e.stream_read_1_bytes(i), a.completeness = e.extract_bits(1), e.extract_bits(2), a.nalu_type = e.extract_bits(5);
            let o = 1;
            a.nalu_type !== s && a.nalu_type !== t && (o = i.readUint16());
            for(let u = 0; u < o; u++){
                let l = i.readUint16();
                a.push({
                    data: i.readUint8Array(l),
                    length: l
                });
            }
        }
    }
}, $e833773b1f4e7d0f$var$Ql = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "ColourInformationBox";
    }
    static{
        this.fourcc = "colr";
    }
    parse(i) {
        if (this.colour_type = i.readString(4), this.colour_type === "nclx") {
            this.colour_primaries = i.readUint16(), this.transfer_characteristics = i.readUint16(), this.matrix_coefficients = i.readUint16();
            let e = i.readUint8();
            this.full_range_flag = e >> 7;
        } else this.colour_type === "rICC" ? this.ICC_profile = i.readUint8Array(this.size - 4) : this.colour_type === "prof" && (this.ICC_profile = i.readUint8Array(this.size - 4));
    }
};
function $e833773b1f4e7d0f$var$We(i, e) {
    let t = Number(i).toString(16);
    for(e = typeof e > "u" ? 2 : e; t.length < e;)t = "0" + t;
    return t;
}
var $e833773b1f4e7d0f$var$Jt = class extends $e833773b1f4e7d0f$var$M {
    getCodec() {
        let i = super.getCodec();
        return this.avcC ? `${i}.${$e833773b1f4e7d0f$var$We(this.avcC.AVCProfileIndication)}${$e833773b1f4e7d0f$var$We(this.avcC.profile_compatibility)}${$e833773b1f4e7d0f$var$We(this.avcC.AVCLevelIndication)}` : i;
    }
}, $e833773b1f4e7d0f$var$Zl = class extends $e833773b1f4e7d0f$var$Jt {
    constructor(){
        super(...arguments), this.box_name = "AVCSampleEntry";
    }
    static{
        this.fourcc = "avc1";
    }
}, $e833773b1f4e7d0f$var$Jl = class extends $e833773b1f4e7d0f$var$Jt {
    constructor(){
        super(...arguments), this.box_name = "AVC2SampleEntry";
    }
    static{
        this.fourcc = "avc2";
    }
}, $e833773b1f4e7d0f$var$eh = class extends $e833773b1f4e7d0f$var$Jt {
    constructor(){
        super(...arguments), this.box_name = "AVCSampleEntry";
    }
    static{
        this.fourcc = "avc3";
    }
}, $e833773b1f4e7d0f$var$th = class extends $e833773b1f4e7d0f$var$Jt {
    constructor(){
        super(...arguments), this.box_name = "AVC2SampleEntry";
    }
    static{
        this.fourcc = "avc4";
    }
}, $e833773b1f4e7d0f$var$ih = class extends $e833773b1f4e7d0f$var$M {
    constructor(){
        super(...arguments), this.box_name = "AV1SampleEntry";
    }
    static{
        this.fourcc = "av01";
    }
    getCodec() {
        let i = super.getCodec(), e = this.av1C.seq_level_idx_0, t = e < 10 ? "0" + e : e, s;
        return this.av1C.seq_profile === 2 && this.av1C.high_bitdepth === 1 ? s = this.av1C.twelve_bit === 1 ? "12" : "10" : this.av1C.seq_profile <= 2 && (s = this.av1C.high_bitdepth === 1 ? "10" : "08"), i + "." + this.av1C.seq_profile + "." + t + (this.av1C.seq_tier_0 ? "H" : "M") + "." + s;
    }
}, $e833773b1f4e7d0f$var$sh = class extends $e833773b1f4e7d0f$var$M {
    static{
        this.fourcc = "dav1";
    }
}, $e833773b1f4e7d0f$var$ei = class extends $e833773b1f4e7d0f$var$M {
    getCodec() {
        let i = super.getCodec();
        if (this.hvcC) {
            switch(i += ".", this.hvcC.general_profile_space){
                case 0:
                    i += "";
                    break;
                case 1:
                    i += "A";
                    break;
                case 2:
                    i += "B";
                    break;
                case 3:
                    i += "C";
                    break;
            }
            i += this.hvcC.general_profile_idc, i += ".";
            let e = this.hvcC.general_profile_compatibility, t = 0;
            for(let n = 0; n < 32 && (t |= e & 1, n !== 31); n++)t <<= 1, e >>= 1;
            i += $e833773b1f4e7d0f$var$We(t, 0), i += ".", this.hvcC.general_tier_flag === 0 ? i += "L" : i += "H", i += this.hvcC.general_level_idc;
            let s = !1, r = "";
            for(let n = 5; n >= 0; n--)(this.hvcC.general_constraint_indicator[n] || s) && (r = "." + $e833773b1f4e7d0f$var$We(this.hvcC.general_constraint_indicator[n], 0) + r, s = !0);
            i += r;
        }
        return i;
    }
}, $e833773b1f4e7d0f$var$rh = class extends $e833773b1f4e7d0f$var$ei {
    constructor(){
        super(...arguments), this.box_name = "HEVCSampleEntry";
    }
    static{
        this.fourcc = "hvc1";
    }
}, $e833773b1f4e7d0f$var$nh = class extends $e833773b1f4e7d0f$var$ei {
    static{
        this.fourcc = "hvc2";
    }
}, $e833773b1f4e7d0f$var$ah = class extends $e833773b1f4e7d0f$var$ei {
    constructor(){
        super(...arguments), this.box_name = "HEVCSampleEntry", this.colrs = [], this.subBoxNames = [
            "colr"
        ];
    }
    static{
        this.fourcc = "hev1";
    }
}, $e833773b1f4e7d0f$var$oh = class extends $e833773b1f4e7d0f$var$ei {
    static{
        this.fourcc = "hev2";
    }
}, $e833773b1f4e7d0f$var$uh = class extends $e833773b1f4e7d0f$var$M {
    constructor(){
        super(...arguments), this.box_name = "HEVCTileSampleSampleEntry";
    }
    static{
        this.fourcc = "hvt1";
    }
}, $e833773b1f4e7d0f$var$lh = class extends $e833773b1f4e7d0f$var$M {
    constructor(){
        super(...arguments), this.box_name = "LHEVCSampleEntry";
    }
    static{
        this.fourcc = "lhe1";
    }
}, $e833773b1f4e7d0f$var$hh = class extends $e833773b1f4e7d0f$var$M {
    constructor(){
        super(...arguments), this.box_name = "LHEVCSampleEntry";
    }
    static{
        this.fourcc = "lhv1";
    }
}, $e833773b1f4e7d0f$var$dh = class extends $e833773b1f4e7d0f$var$M {
    static{
        this.fourcc = "dvh1";
    }
}, $e833773b1f4e7d0f$var$ch = class extends $e833773b1f4e7d0f$var$M {
    static{
        this.fourcc = "dvhe";
    }
}, $e833773b1f4e7d0f$var$$r = class extends $e833773b1f4e7d0f$var$M {
    getCodec() {
        let i = super.getCodec();
        if (this.vvcC) {
            i += "." + this.vvcC.general_profile_idc, this.vvcC.general_tier_flag ? i += ".H" : i += ".L", i += this.vvcC.general_level_idc;
            let e = "";
            if (this.vvcC.general_constraint_info) {
                let t = [], s = 0;
                s |= this.vvcC.ptl_frame_only_constraint_flag << 7, s |= this.vvcC.ptl_multilayer_enabled_flag << 6;
                let r;
                for(let n = 0; n < this.vvcC.general_constraint_info.length; ++n)s |= this.vvcC.general_constraint_info[n] >> 2 & 63, t.push(s), s && (r = n), s = this.vvcC.general_constraint_info[n] >> 2 & 3;
                if (r === void 0) e = ".CA";
                else {
                    e = ".C";
                    let n = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567", a = 0, o = 0;
                    for(let u = 0; u <= r; ++u)for(a = a << 8 | t[u], o += 8; o >= 5;){
                        let l = a >> o - 5 & 31;
                        e += n[l], o -= 5, a &= (1 << o) - 1;
                    }
                    o && (a <<= 5 - o, e += n[a & 31]);
                }
            }
            i += e;
        }
        return i;
    }
}, $e833773b1f4e7d0f$var$fh = class extends $e833773b1f4e7d0f$var$$r {
    constructor(){
        super(...arguments), this.box_name = "VvcSampleEntry";
    }
    static{
        this.fourcc = "vvc1";
    }
}, $e833773b1f4e7d0f$var$ph = class extends $e833773b1f4e7d0f$var$$r {
    constructor(){
        super(...arguments), this.box_name = "VvcSampleEntry";
    }
    static{
        this.fourcc = "vvi1";
    }
}, $e833773b1f4e7d0f$var$mh = class extends $e833773b1f4e7d0f$var$M {
    constructor(){
        super(...arguments), this.box_name = "VvcSampleEntry";
    }
    static{
        this.fourcc = "vvs1";
    }
}, $e833773b1f4e7d0f$var$gh = class extends $e833773b1f4e7d0f$var$M {
    constructor(){
        super(...arguments), this.box_name = "VvcNonVCLSampleEntry";
    }
    static{
        this.fourcc = "vvcN";
    }
}, $e833773b1f4e7d0f$var$Qr = class extends $e833773b1f4e7d0f$var$M {
    getCodec() {
        let i = super.getCodec(), e = this.vpcC.level;
        e === 0 && (e = "00");
        let t = this.vpcC.bitDepth;
        return t === 8 && (t = "08"), `${i}.0${this.vpcC.profile}.${e}.${t}`;
    }
}, $e833773b1f4e7d0f$var$_h = class extends $e833773b1f4e7d0f$var$Qr {
    static{
        this.fourcc = "vp08";
    }
}, $e833773b1f4e7d0f$var$xh = class extends $e833773b1f4e7d0f$var$Qr {
    static{
        this.fourcc = "vp09";
    }
}, $e833773b1f4e7d0f$var$yh = class extends $e833773b1f4e7d0f$var$M {
    static{
        this.fourcc = "avs3";
    }
}, $e833773b1f4e7d0f$var$vh = class extends $e833773b1f4e7d0f$var$M {
    constructor(){
        super(...arguments), this.box_name = "J2KSampleEntry";
    }
    static{
        this.fourcc = "j2ki";
    }
}, $e833773b1f4e7d0f$var$bh = class extends $e833773b1f4e7d0f$var$M {
    static{
        this.fourcc = "mjp2";
    }
}, $e833773b1f4e7d0f$var$Sh = class extends $e833773b1f4e7d0f$var$M {
    static{
        this.fourcc = "mjpg";
    }
}, $e833773b1f4e7d0f$var$Th = class extends $e833773b1f4e7d0f$var$M {
    constructor(){
        super(...arguments), this.box_name = "UncompressedVideoSampleEntry";
    }
    static{
        this.fourcc = "uncv";
    }
}, $e833773b1f4e7d0f$var$wh = class extends $e833773b1f4e7d0f$var$M {
    constructor(){
        super(...arguments), this.box_name = "MP4VisualSampleEntry";
    }
    static{
        this.fourcc = "mp4v";
    }
}, $e833773b1f4e7d0f$var$Uh = class extends $e833773b1f4e7d0f$var$ee {
    constructor(){
        super(...arguments), this.box_name = "MP4AudioSampleEntry";
    }
    static{
        this.fourcc = "mp4a";
    }
    getCodec() {
        let i = super.getCodec();
        if (this.esds && this.esds.esd) {
            let e = this.esds.esd.getOTI(), t = this.esds.esd.getAudioConfig();
            return i + "." + $e833773b1f4e7d0f$var$We(e) + (t ? "." + t : "");
        } else return i;
    }
}, $e833773b1f4e7d0f$var$Eh = class extends $e833773b1f4e7d0f$var$ee {
    static{
        this.fourcc = "m4ae";
    }
}, $e833773b1f4e7d0f$var$Ih = class extends $e833773b1f4e7d0f$var$ee {
    static{
        this.fourcc = "ac-3";
    }
}, $e833773b1f4e7d0f$var$Ch = class extends $e833773b1f4e7d0f$var$ee {
    static{
        this.fourcc = "ac-4";
    }
}, $e833773b1f4e7d0f$var$Bh = class extends $e833773b1f4e7d0f$var$ee {
    static{
        this.fourcc = "ec-3";
    }
}, $e833773b1f4e7d0f$var$Ah = class extends $e833773b1f4e7d0f$var$ee {
    static{
        this.fourcc = "Opus";
    }
}, $e833773b1f4e7d0f$var$Dh = class extends $e833773b1f4e7d0f$var$ee {
    static{
        this.fourcc = "mha1";
    }
}, $e833773b1f4e7d0f$var$Ph = class extends $e833773b1f4e7d0f$var$ee {
    static{
        this.fourcc = "mha2";
    }
}, $e833773b1f4e7d0f$var$kh = class extends $e833773b1f4e7d0f$var$ee {
    static{
        this.fourcc = "mhm1";
    }
}, $e833773b1f4e7d0f$var$Rh = class extends $e833773b1f4e7d0f$var$ee {
    static{
        this.fourcc = "mhm2";
    }
}, $e833773b1f4e7d0f$var$Fh = class extends $e833773b1f4e7d0f$var$ee {
    static{
        this.fourcc = "fLaC";
    }
}, $e833773b1f4e7d0f$var$Mh = class extends $e833773b1f4e7d0f$var$M {
    static{
        this.fourcc = "encv";
    }
}, $e833773b1f4e7d0f$var$Oh = class extends $e833773b1f4e7d0f$var$ee {
    static{
        this.fourcc = "enca";
    }
}, $e833773b1f4e7d0f$var$Lh = class extends $e833773b1f4e7d0f$var$Re {
    constructor(){
        super(...arguments), this.subBoxNames = [
            "sinf"
        ], this.sinfs = [];
    }
    static{
        this.fourcc = "encu";
    }
}, $e833773b1f4e7d0f$var$Nh = class extends $e833773b1f4e7d0f$var$os {
    constructor(){
        super(...arguments), this.subBoxNames = [
            "sinf"
        ], this.sinfs = [];
    }
    static{
        this.fourcc = "encs";
    }
}, $e833773b1f4e7d0f$var$zh = class extends $e833773b1f4e7d0f$var$os {
    static{
        this.fourcc = "mp4s";
    }
}, $e833773b1f4e7d0f$var$Gh = class extends $e833773b1f4e7d0f$var$dl {
    constructor(){
        super(...arguments), this.subBoxNames = [
            "sinf"
        ], this.sinfs = [];
    }
    static{
        this.fourcc = "enct";
    }
}, $e833773b1f4e7d0f$var$Vh = class extends $e833773b1f4e7d0f$var$Ye {
    constructor(){
        super(...arguments), this.subBoxNames = [
            "sinf"
        ], this.sinfs = [];
    }
    static{
        this.fourcc = "encm";
    }
}, $e833773b1f4e7d0f$var$Hh = class extends $e833773b1f4e7d0f$var$M {
    constructor(){
        super(...arguments), this.box_name = "RestrictedVideoSampleEntry";
    }
    static{
        this.fourcc = "resv";
    }
}, $e833773b1f4e7d0f$var$qh = class extends $e833773b1f4e7d0f$var$Re {
    static{
        this.fourcc = "sbtt";
    }
    parse(i) {
        this.parseHeader(i), this.content_encoding = i.readCString(), this.mime_format = i.readCString(), this.parseFooter(i);
    }
}, $e833773b1f4e7d0f$var$Zr = class extends $e833773b1f4e7d0f$var$Re {
    static{
        this.fourcc = "stpp";
    }
    parse(i) {
        this.parseHeader(i), this.namespace = i.readCString(), this.schema_location = i.readCString(), this.auxiliary_mime_types = i.readCString(), this.parseFooter(i);
    }
    write(i) {
        this.writeHeader(i), this.size += this.namespace.length + 1 + this.schema_location.length + 1 + this.auxiliary_mime_types.length + 1, i.writeCString(this.namespace), i.writeCString(this.schema_location), i.writeCString(this.auxiliary_mime_types), this.writeFooter(i);
    }
}, $e833773b1f4e7d0f$var$Wh = class extends $e833773b1f4e7d0f$var$Re {
    static{
        this.fourcc = "stxt";
    }
    parse(i) {
        this.parseHeader(i), this.content_encoding = i.readCString(), this.mime_format = i.readCString(), this.parseFooter(i);
    }
    getCodec() {
        let i = super.getCodec();
        return this.mime_format ? i + "." + this.mime_format : i;
    }
}, $e833773b1f4e7d0f$var$Yh = class extends $e833773b1f4e7d0f$var$Re {
    static{
        this.fourcc = "tx3g";
    }
    parse(i) {
        this.parseHeader(i), this.displayFlags = i.readUint32(), this.horizontal_justification = i.readInt8(), this.vertical_justification = i.readInt8(), this.bg_color_rgba = i.readUint8Array(4), this.box_record = i.readInt16Array(4), this.style_record = i.readUint8Array(12), this.parseFooter(i);
    }
}, $e833773b1f4e7d0f$var$jh = class extends $e833773b1f4e7d0f$var$Ye {
    static{
        this.fourcc = "wvtt";
    }
    parse(i) {
        this.parseHeader(i), this.parseFooter(i);
    }
}, $e833773b1f4e7d0f$var$Xh = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "SampleToGroupBox";
    }
    static{
        this.fourcc = "sbgp";
    }
    parse(i) {
        this.parseFullHeader(i), this.grouping_type = i.readString(4), this.version === 1 ? this.grouping_type_parameter = i.readUint32() : this.grouping_type_parameter = 0, this.entries = [];
        let e = i.readUint32();
        for(let t = 0; t < e; t++)this.entries.push({
            sample_count: i.readInt32(),
            group_description_index: i.readInt32()
        });
    }
    write(i) {
        this.grouping_type_parameter ? this.version = 1 : this.version = 0, this.flags = 0, this.size = 8 + 8 * this.entries.length + (this.version === 1 ? 4 : 0), this.writeHeader(i), i.writeString(this.grouping_type, void 0, 4), this.version === 1 && i.writeUint32(this.grouping_type_parameter), i.writeUint32(this.entries.length);
        for(let e = 0; e < this.entries.length; e++){
            let t = this.entries[e];
            i.writeInt32(t.sample_count), i.writeInt32(t.group_description_index);
        }
    }
}, $e833773b1f4e7d0f$var$Kh = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "SampleDependencyTypeBox";
    }
    static{
        this.fourcc = "sdtp";
    }
    parse(i) {
        this.parseFullHeader(i);
        let e = this.size - this.hdr_size;
        this.is_leading = [], this.sample_depends_on = [], this.sample_is_depended_on = [], this.sample_has_redundancy = [];
        for(let t = 0; t < e; t++){
            let s = i.readUint8();
            this.is_leading[t] = s >> 6, this.sample_depends_on[t] = s >> 4 & 3, this.sample_is_depended_on[t] = s >> 2 & 3, this.sample_has_redundancy[t] = s & 3;
        }
    }
}, $e833773b1f4e7d0f$var$$h = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "SampleGroupDescriptionBox";
    }
    static{
        this.fourcc = "sgpd";
    }
    parse(i) {
        this.parseFullHeader(i), this.grouping_type = i.readString(4), $e833773b1f4e7d0f$var$g.debug("BoxParser", "Found Sample Groups of type " + this.grouping_type), this.version === 1 ? this.default_length = i.readUint32() : this.default_length = 0, this.version >= 2 && (this.default_group_description_index = i.readUint32()), this.entries = [];
        let e = i.readUint32();
        for(let t = 0; t < e; t++){
            let s;
            this.grouping_type in $e833773b1f4e7d0f$var$Z.sampleGroupEntry ? s = new $e833773b1f4e7d0f$var$Z.sampleGroupEntry[this.grouping_type](this.grouping_type) : s = new $e833773b1f4e7d0f$var$z(this.grouping_type), this.entries.push(s), this.version === 1 ? this.default_length === 0 ? s.description_length = i.readUint32() : s.description_length = this.default_length : s.description_length = this.default_length, s.write === $e833773b1f4e7d0f$var$z.prototype.write && ($e833773b1f4e7d0f$var$g.info("BoxParser", "SampleGroup for type " + this.grouping_type + " writing not yet implemented, keeping unparsed data in memory for later write"), s.data = i.readUint8Array(s.description_length), i.seek(i.getPosition() - s.description_length)), s.parse(i);
        }
    }
    write(i) {
        this.flags = 0, this.size = 12;
        for(let e = 0; e < this.entries.length; e++){
            let t = this.entries[e];
            this.version === 1 && (this.default_length === 0 && (this.size += 4), this.size += t.data.length);
        }
        this.writeHeader(i), i.writeString(this.grouping_type, void 0, 4), this.version === 1 && i.writeUint32(this.default_length), this.version >= 2 && i.writeUint32(this.default_sample_description_index), i.writeUint32(this.entries.length);
        for(let e = 0; e < this.entries.length; e++){
            let t = this.entries[e];
            this.version === 1 && this.default_length === 0 && i.writeUint32(t.description_length), t.write(i);
        }
    }
}, $e833773b1f4e7d0f$var$Qh = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "CompressedSegmentIndexBox";
    }
    static{
        this.fourcc = "sidx";
    }
    parse(i) {
        this.parseFullHeader(i), this.reference_ID = i.readUint32(), this.timescale = i.readUint32(), this.version === 0 ? (this.earliest_presentation_time = i.readUint32(), this.first_offset = i.readUint32()) : (this.earliest_presentation_time = i.readUint64(), this.first_offset = i.readUint64()), i.readUint16(), this.references = [];
        let e = i.readUint16();
        for(let t = 0; t < e; t++){
            let s = i.readUint32(), r = i.readUint32(), n = i.readUint32();
            this.references.push({
                reference_type: s >> 31 & 1,
                referenced_size: s & 2147483647,
                subsegment_duration: r,
                starts_with_SAP: n >> 31 & 1,
                SAP_type: n >> 28 & 7,
                SAP_delta_time: n & 268435455
            });
        }
    }
    write(i) {
        let e = this.earliest_presentation_time > $e833773b1f4e7d0f$var$H || this.first_offset > $e833773b1f4e7d0f$var$H || this.version === 1;
        this.version = e ? 1 : 0, this.size = 12 + 12 * this.references.length, this.size += e ? 16 : 8, this.flags = 0, this.writeHeader(i), i.writeUint32(this.reference_ID), i.writeUint32(this.timescale), e ? (i.writeUint64(this.earliest_presentation_time), i.writeUint64(this.first_offset)) : (i.writeUint32(this.earliest_presentation_time), i.writeUint32(this.first_offset)), i.writeUint16(0), i.writeUint16(this.references.length);
        for(let t = 0; t < this.references.length; t++){
            let s = this.references[t];
            i.writeUint32(s.reference_type << 31 | s.referenced_size), i.writeUint32(s.subsegment_duration), i.writeUint32(s.starts_with_SAP << 31 | s.SAP_type << 28 | s.SAP_delta_time);
        }
    }
}, $e833773b1f4e7d0f$var$Jr = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "SoundMediaHeaderBox";
    }
    static{
        this.fourcc = "smhd";
    }
    parse(i) {
        this.parseFullHeader(i), this.balance = i.readUint16(), i.readUint16();
    }
    write(i) {
        this.version = 0, this.size = 4, this.writeHeader(i), i.writeUint16(this.balance), i.writeUint16(0);
    }
}, $e833773b1f4e7d0f$var$en = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "ChunkOffsetBox";
    }
    static{
        this.fourcc = "stco";
    }
    parse(i) {
        this.parseFullHeader(i);
        let e = i.readUint32();
        if (this.chunk_offsets = [], this.version === 0) for(let t = 0; t < e; t++)this.chunk_offsets.push(i.readUint32());
    }
    write(i) {
        this.version = 0, this.flags = 0, this.size = 4 + 4 * this.chunk_offsets.length, this.writeHeader(i), i.writeUint32(this.chunk_offsets.length), i.writeUint32Array(this.chunk_offsets);
    }
    unpack(i) {
        for(let e = 0; e < this.chunk_offsets.length; e++)i[e].offset = this.chunk_offsets[e];
    }
}, $e833773b1f4e7d0f$var$tn = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "SubtitleMediaHeaderBox";
    }
    static{
        this.fourcc = "sthd";
    }
}, $e833773b1f4e7d0f$var$sn = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "SampleToChunkBox";
    }
    static{
        this.fourcc = "stsc";
    }
    parse(i) {
        this.parseFullHeader(i);
        let e = i.readUint32();
        if (this.first_chunk = [], this.samples_per_chunk = [], this.sample_description_index = [], this.version === 0) for(let t = 0; t < e; t++)this.first_chunk.push(i.readUint32()), this.samples_per_chunk.push(i.readUint32()), this.sample_description_index.push(i.readUint32());
    }
    write(i) {
        this.version = 0, this.flags = 0, this.size = 4 + 12 * this.first_chunk.length, this.writeHeader(i), i.writeUint32(this.first_chunk.length);
        for(let e = 0; e < this.first_chunk.length; e++)i.writeUint32(this.first_chunk[e]), i.writeUint32(this.samples_per_chunk[e]), i.writeUint32(this.sample_description_index[e]);
    }
    unpack(i) {
        let e = 0, t = 0;
        for(let s = 0; s < this.first_chunk.length; s++)for(let r = 0; r < (s + 1 < this.first_chunk.length ? this.first_chunk[s + 1] : 1 / 0); r++){
            t++;
            for(let n = 0; n < this.samples_per_chunk[s]; n++){
                if (i[e]) i[e].description_index = this.sample_description_index[s], i[e].chunk_index = t;
                else return;
                e++;
            }
        }
    }
}, $e833773b1f4e7d0f$var$rn = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "SampleDescriptionBox";
    }
    static{
        this.fourcc = "stsd";
    }
    parse(i) {
        this.parseFullHeader(i), this.entries = [];
        let e = i.readUint32();
        for(let t = 1; t <= e; t++){
            let s = $e833773b1f4e7d0f$var$oe(i, !0, this.size - (i.getPosition() - this.start));
            if (s.code === $e833773b1f4e7d0f$var$J) {
                let r;
                s.type in $e833773b1f4e7d0f$var$Z.sampleEntry ? (r = new $e833773b1f4e7d0f$var$Z.sampleEntry[s.type](s.size), r.hdr_size = s.hdr_size, r.start = s.start) : ($e833773b1f4e7d0f$var$g.warn("BoxParser", `Unknown sample entry type: '${s.type}'`), r = new $e833773b1f4e7d0f$var$ge(s.size, s.hdr_size, s.start), r.type = s.type), r.write === $e833773b1f4e7d0f$var$ge.prototype.write && ($e833773b1f4e7d0f$var$g.info("BoxParser", "SampleEntry " + r.type + " box writing not yet implemented, keeping unparsed data in memory for later write"), r.parseDataAndRewind(i)), r.parse(i), this.entries.push(r);
            } else return;
        }
    }
    write(i) {
        this.version = 0, this.flags = 0, this.size = 0, this.writeHeader(i), i.writeUint32(this.entries.length), this.size += 4;
        for(let e = 0; e < this.entries.length; e++)this.entries[e].write(i), this.size += this.entries[e].size;
        $e833773b1f4e7d0f$var$g.debug("BoxWriter", "Adjusting box " + this.type + " with new size " + this.size), i.adjustUint32(this.sizePosition, this.size);
    }
}, $e833773b1f4e7d0f$var$nn = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "SampleSizeBox";
    }
    static{
        this.fourcc = "stsz";
    }
    parse(i) {
        if (this.parseFullHeader(i), this.sample_sizes = [], this.version === 0) {
            this.sample_size = i.readUint32(), this.sample_count = i.readUint32();
            for(let e = 0; e < this.sample_count; e++)this.sample_size === 0 ? this.sample_sizes.push(i.readUint32()) : this.sample_sizes[e] = this.sample_size;
        }
    }
    write(i) {
        let e = !0;
        if (this.version = 0, this.flags = 0, this.sample_sizes.length > 0) {
            let t = 0;
            for(; t + 1 < this.sample_sizes.length;)if (this.sample_sizes[t + 1] !== this.sample_sizes[0]) {
                e = !1;
                break;
            } else t++;
        } else e = !1;
        this.size = 8, e || (this.size += 4 * this.sample_sizes.length), this.writeHeader(i), e ? i.writeUint32(this.sample_sizes[0]) : i.writeUint32(0), i.writeUint32(this.sample_sizes.length), e || i.writeUint32Array(this.sample_sizes);
    }
    unpack(i) {
        for(let e = 0; e < this.sample_sizes.length; e++)i[e].size = this.sample_sizes[e];
    }
}, $e833773b1f4e7d0f$var$an = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "TimeToSampleBox", this.sample_counts = [], this.sample_deltas = [];
    }
    static{
        this.fourcc = "stts";
    }
    parse(i) {
        this.parseFullHeader(i);
        let e = i.readUint32();
        if (this.sample_counts.length = 0, this.sample_deltas.length = 0, this.version === 0) for(let t = 0; t < e; t++){
            this.sample_counts.push(i.readUint32());
            let s = i.readInt32();
            s < 0 && ($e833773b1f4e7d0f$var$g.warn("BoxParser", "File uses negative stts sample delta, using value 1 instead, sync may be lost!"), s = 1), this.sample_deltas.push(s);
        }
    }
    write(i) {
        this.version = 0, this.flags = 0, this.size = 4 + 8 * this.sample_counts.length, this.writeHeader(i), i.writeUint32(this.sample_counts.length);
        for(let e = 0; e < this.sample_counts.length; e++)i.writeUint32(this.sample_counts[e]), i.writeUint32(this.sample_deltas[e]);
    }
    unpack(i) {
        let e = 0;
        for(let t = 0; t < this.sample_counts.length; t++)for(let s = 0; s < this.sample_counts[t]; s++)e === 0 ? i[e].dts = 0 : i[e].dts = i[e - 1].dts + this.sample_deltas[t], e++;
    }
}, $e833773b1f4e7d0f$var$on = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "TrackFragmentBaseMediaDecodeTimeBox";
    }
    static{
        this.fourcc = "tfdt";
    }
    parse(i) {
        this.parseFullHeader(i), this.version === 1 ? this.baseMediaDecodeTime = i.readUint64() : this.baseMediaDecodeTime = i.readUint32();
    }
    write(i) {
        let e = this.baseMediaDecodeTime > $e833773b1f4e7d0f$var$H || this.version === 1;
        this.version = e ? 1 : 0, this.size = 4, this.size += e ? 4 : 0, this.flags = 0, this.writeHeader(i), e ? i.writeUint64(this.baseMediaDecodeTime) : i.writeUint32(this.baseMediaDecodeTime);
    }
}, $e833773b1f4e7d0f$var$un = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "TrackFragmentHeaderBox";
    }
    static{
        this.fourcc = "tfhd";
    }
    parse(i) {
        this.parseFullHeader(i);
        let e = 0;
        this.track_id = i.readUint32(), this.size - this.hdr_size > e && this.flags & $e833773b1f4e7d0f$var$Gt ? (this.base_data_offset = i.readUint64(), e += 8) : this.base_data_offset = 0, this.size - this.hdr_size > e && this.flags & $e833773b1f4e7d0f$var$Vt ? (this.default_sample_description_index = i.readUint32(), e += 4) : this.default_sample_description_index = 0, this.size - this.hdr_size > e && this.flags & $e833773b1f4e7d0f$var$Ht ? (this.default_sample_duration = i.readUint32(), e += 4) : this.default_sample_duration = 0, this.size - this.hdr_size > e && this.flags & $e833773b1f4e7d0f$var$qt ? (this.default_sample_size = i.readUint32(), e += 4) : this.default_sample_size = 0, this.size - this.hdr_size > e && this.flags & $e833773b1f4e7d0f$var$Wt ? (this.default_sample_flags = i.readUint32(), e += 4) : this.default_sample_flags = 0;
    }
    write(i) {
        this.version = 0, this.size = 4, this.flags & $e833773b1f4e7d0f$var$Gt && (this.size += 8), this.flags & $e833773b1f4e7d0f$var$Vt && (this.size += 4), this.flags & $e833773b1f4e7d0f$var$Ht && (this.size += 4), this.flags & $e833773b1f4e7d0f$var$qt && (this.size += 4), this.flags & $e833773b1f4e7d0f$var$Wt && (this.size += 4), this.writeHeader(i), i.writeUint32(this.track_id), this.flags & $e833773b1f4e7d0f$var$Gt && i.writeUint64(this.base_data_offset), this.flags & $e833773b1f4e7d0f$var$Vt && i.writeUint32(this.default_sample_description_index), this.flags & $e833773b1f4e7d0f$var$Ht && i.writeUint32(this.default_sample_duration), this.flags & $e833773b1f4e7d0f$var$qt && i.writeUint32(this.default_sample_size), this.flags & $e833773b1f4e7d0f$var$Wt && i.writeUint32(this.default_sample_flags);
    }
}, $e833773b1f4e7d0f$var$ln = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "TrackHeaderBox", this.layer = 0, this.alternate_group = 0;
    }
    static{
        this.fourcc = "tkhd";
    }
    parse(i) {
        this.parseFullHeader(i), this.version === 1 ? (this.creation_time = i.readUint64(), this.modification_time = i.readUint64(), this.track_id = i.readUint32(), i.readUint32(), this.duration = i.readUint64()) : (this.creation_time = i.readUint32(), this.modification_time = i.readUint32(), this.track_id = i.readUint32(), i.readUint32(), this.duration = i.readUint32()), i.readUint32Array(2), this.layer = i.readInt16(), this.alternate_group = i.readInt16(), this.volume = i.readInt16() >> 8, i.readUint16(), this.matrix = i.readInt32Array(9), this.width = i.readUint32(), this.height = i.readUint32();
    }
    write(i) {
        let e = this.modification_time > $e833773b1f4e7d0f$var$H || this.creation_time > $e833773b1f4e7d0f$var$H || this.duration > $e833773b1f4e7d0f$var$H || this.version === 1;
        this.version = e ? 1 : 0, this.size = 80, this.size += e ? 12 : 0, this.flags = this.flags ?? 3, this.writeHeader(i), e ? (i.writeUint64(this.creation_time), i.writeUint64(this.modification_time), i.writeUint32(this.track_id), i.writeUint32(0), i.writeUint64(this.duration)) : (i.writeUint32(this.creation_time), i.writeUint32(this.modification_time), i.writeUint32(this.track_id), i.writeUint32(0), i.writeUint32(this.duration)), i.writeUint32Array([
            0,
            0
        ]), i.writeInt16(this.layer), i.writeInt16(this.alternate_group), i.writeInt16(this.volume << 8), i.writeInt16(0), i.writeInt32Array(this.matrix), i.writeUint32(this.width), i.writeUint32(this.height);
    }
    print(i) {
        super.printHeader(i), i.log(i.indent + "creation_time: " + this.creation_time), i.log(i.indent + "modification_time: " + this.modification_time), i.log(i.indent + "track_id: " + this.track_id), i.log(i.indent + "duration: " + this.duration), i.log(i.indent + "volume: " + (this.volume >> 8)), i.log(i.indent + "matrix: " + this.matrix.join(", ")), i.log(i.indent + "layer: " + this.layer), i.log(i.indent + "alternate_group: " + this.alternate_group), i.log(i.indent + "width: " + this.width), i.log(i.indent + "height: " + this.height);
    }
}, $e833773b1f4e7d0f$var$rs = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "TrackExtendsBox";
    }
    static{
        this.fourcc = "trex";
    }
    parse(i) {
        this.parseFullHeader(i), this.track_id = i.readUint32(), this.default_sample_description_index = i.readUint32(), this.default_sample_duration = i.readUint32(), this.default_sample_size = i.readUint32(), this.default_sample_flags = i.readUint32();
    }
    write(i) {
        this.version = 0, this.flags = 0, this.size = 20, this.writeHeader(i), i.writeUint32(this.track_id), i.writeUint32(this.default_sample_description_index), i.writeUint32(this.default_sample_duration), i.writeUint32(this.default_sample_size), i.writeUint32(this.default_sample_flags);
    }
}, $e833773b1f4e7d0f$var$hn = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "TrackRunBox", this.sample_duration = [], this.sample_size = [], this.sample_flags = [], this.sample_composition_time_offset = [];
    }
    static{
        this.fourcc = "trun";
    }
    parse(i) {
        this.parseFullHeader(i);
        let e = 0;
        if (this.sample_count = i.readUint32(), e += 4, this.size - this.hdr_size > e && this.flags & $e833773b1f4e7d0f$var$ot ? (this.data_offset = i.readInt32(), e += 4) : this.data_offset = 0, this.size - this.hdr_size > e && this.flags & $e833773b1f4e7d0f$var$Yt ? (this.first_sample_flags = i.readUint32(), e += 4) : this.first_sample_flags = 0, this.sample_duration = [], this.sample_size = [], this.sample_flags = [], this.sample_composition_time_offset = [], this.size - this.hdr_size > e) for(let t = 0; t < this.sample_count; t++)this.flags & $e833773b1f4e7d0f$var$ut && (this.sample_duration[t] = i.readUint32()), this.flags & $e833773b1f4e7d0f$var$lt && (this.sample_size[t] = i.readUint32()), this.flags & $e833773b1f4e7d0f$var$ht && (this.sample_flags[t] = i.readUint32()), this.flags & $e833773b1f4e7d0f$var$dt && (this.version === 0 ? this.sample_composition_time_offset[t] = i.readUint32() : this.sample_composition_time_offset[t] = i.readInt32());
    }
    write(i) {
        this.size = 4, this.flags & $e833773b1f4e7d0f$var$ot && (this.size += 4), this.flags & $e833773b1f4e7d0f$var$Yt && (this.size += 4), this.flags & $e833773b1f4e7d0f$var$ut && (this.size += 4 * this.sample_duration.length), this.flags & $e833773b1f4e7d0f$var$lt && (this.size += 4 * this.sample_size.length), this.flags & $e833773b1f4e7d0f$var$ht && (this.size += 4 * this.sample_flags.length), this.flags & $e833773b1f4e7d0f$var$dt && (this.size += 4 * this.sample_composition_time_offset.length), this.writeHeader(i), i.writeUint32(this.sample_count), this.flags & $e833773b1f4e7d0f$var$ot && (this.data_offset_position = i.getPosition(), i.writeInt32(this.data_offset)), this.flags & $e833773b1f4e7d0f$var$Yt && i.writeUint32(this.first_sample_flags);
        for(let e = 0; e < this.sample_count; e++)this.flags & $e833773b1f4e7d0f$var$ut && i.writeUint32(this.sample_duration[e]), this.flags & $e833773b1f4e7d0f$var$lt && i.writeUint32(this.sample_size[e]), this.flags & $e833773b1f4e7d0f$var$ht && i.writeUint32(this.sample_flags[e]), this.flags & $e833773b1f4e7d0f$var$dt && (this.version === 0 ? i.writeUint32(this.sample_composition_time_offset[e]) : i.writeInt32(this.sample_composition_time_offset[e]));
    }
}, $e833773b1f4e7d0f$var$dn = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "DataEntryUrlBox";
    }
    static{
        this.fourcc = "url ";
    }
    parse(i) {
        this.parseFullHeader(i), this.flags !== 1 && (this.location = i.readCString());
    }
    write(i) {
        this.version = 0, this.location ? (this.flags = 0, this.size = this.location.length + 1) : (this.flags = 1, this.size = 0), this.writeHeader(i), this.location && i.writeCString(this.location);
    }
}, $e833773b1f4e7d0f$var$cn = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "VideoMediaHeaderBox";
    }
    static{
        this.fourcc = "vmhd";
    }
    parse(i) {
        this.parseFullHeader(i), this.graphicsmode = i.readUint16(), this.opcolor = i.readUint16Array(3);
    }
    write(i) {
        this.version = 0, this.size = 8, this.writeHeader(i), i.writeUint16(this.graphicsmode), i.writeUint16Array(this.opcolor);
    }
}, $e833773b1f4e7d0f$var$es = class {
    constructor(i, e, t){
        this.grouping_type = i, this.grouping_type_parameter = e, this.sbgp = t, this.last_sample_in_run = -1, this.entry_index = -1;
    }
}, $e833773b1f4e7d0f$var$ft = class Se {
    constructor(e, t = !0){
        this.boxes = [], this.mdats = [], this.moofs = [], this.isProgressive = !1, this.moovStartFound = !1, this.moovStartSent = !1, this.readySent = !1, this.sampleListBuilt = !1, this.fragmentedTracks = [], this.extractedTracks = [], this.isFragmentationInitialized = !1, this.sampleProcessingStarted = !1, this.nextMoofNumber = 0, this.itemListBuilt = !1, this.sidxSent = !1, this.items = [], this.entity_groups = [], this.itemsDataSize = 0, this.lastMoofIndex = 0, this.samplesDataSize = 0, this.lastBoxStartPosition = 0, this.nextParsePosition = 0, this.discardMdatData = !0, this.discardMdatData = t, e ? (this.stream = e, this.parse()) : this.stream = new $e833773b1f4e7d0f$var$ct, this.stream.isofile = this;
    }
    setSegmentOptions(e, t, s) {
        let { sizePerSegment: r = Number.MAX_SAFE_INTEGER, rapAlignement: n = !0 } = s, a = s.nbSamples ?? s.nbSamplesPerFragment ?? 1e3, o = s.nbSamplesPerFragment ?? a;
        if (a <= 0 || o <= 0 || r <= 0) {
            $e833773b1f4e7d0f$var$g.error("ISOFile", `Invalid segment options: nbSamples=${a}, nbSamplesPerFragment=${o}, sizePerSegment=${r}`);
            return;
        }
        if (a < o && ($e833773b1f4e7d0f$var$g.warn("ISOFile", `nbSamples (${a}) is less than nbSamplesPerFragment (${o}), setting nbSamples to nbSamplesPerFragment`), a = o), this.fragmentedTracks.some((l)=>l.nb_samples !== a)) {
            $e833773b1f4e7d0f$var$g.error("ISOFile", `Cannot set segment options for track ${e}: nbSamples (${a}) does not match existing tracks`);
            return;
        }
        let u = this.getTrackById(e);
        if (u) {
            let l = {
                id: e,
                user: t,
                trak: u,
                segmentStream: void 0,
                nb_samples: a,
                nb_samples_per_fragment: o,
                size_per_segment: r,
                rapAlignement: n,
                state: {
                    lastFragmentSampleNumber: 0,
                    lastSegmentSampleNumber: 0,
                    accumulatedSize: 0
                }
            };
            this.fragmentedTracks.push(l), u.nextSample = 0;
        }
        this.discardMdatData && $e833773b1f4e7d0f$var$g.warn("ISOFile", "Segmentation options set but discardMdatData is true, samples will not be segmented");
    }
    unsetSegmentOptions(e) {
        let t = -1;
        for(let s = 0; s < this.fragmentedTracks.length; s++)this.fragmentedTracks[s].id === e && (t = s);
        t > -1 && this.fragmentedTracks.splice(t, 1);
    }
    setExtractionOptions(e, t, { nbSamples: s = 1e3 } = {}) {
        let r = this.getTrackById(e);
        r && (this.extractedTracks.push({
            id: e,
            user: t,
            trak: r,
            nb_samples: s,
            samples: []
        }), r.nextSample = 0), this.discardMdatData && $e833773b1f4e7d0f$var$g.warn("ISOFile", "Extraction options set but discardMdatData is true, samples will not be extracted");
    }
    unsetExtractionOptions(e) {
        let t = -1;
        for(let s = 0; s < this.extractedTracks.length; s++)this.extractedTracks[s].id === e && (t = s);
        t > -1 && this.extractedTracks.splice(t, 1);
    }
    parse() {
        if (!(this.restoreParsePosition && !this.restoreParsePosition())) for(;;)if (this.hasIncompleteMdat && this.hasIncompleteMdat()) {
            if (this.processIncompleteMdat()) continue;
            return;
        } else {
            this.saveParsePosition && this.saveParsePosition();
            let t = $e833773b1f4e7d0f$var$oe(this.stream, !1);
            if (t.code === $e833773b1f4e7d0f$var$be) {
                if (this.processIncompleteBox) {
                    if (this.processIncompleteBox(t)) continue;
                    return;
                } else return;
            } else if (t.code === $e833773b1f4e7d0f$var$J) {
                let s = t.box;
                if (this.boxes.push(s), s.type === "uuid") this[s.uuid] !== void 0 && $e833773b1f4e7d0f$var$g.warn("ISOFile", "Duplicate Box of uuid: " + s.uuid + ", overriding previous occurrence"), this[s.uuid] = s;
                else switch(s.type){
                    case "mdat":
                        this.mdats.push(s), this.transferMdatData(s);
                        break;
                    case "moof":
                        this.moofs.push(s);
                        break;
                    case "free":
                    case "skip":
                        break;
                    case "moov":
                        this.moovStartFound = !0, this.mdats.length === 0 && (this.isProgressive = !0);
                    default:
                        this[s.type] !== void 0 ? Array.isArray(this[s.type + "s"]) ? ($e833773b1f4e7d0f$var$g.info("ISOFile", `Found multiple boxes of type ${s.type} in ISOFile, adding to array`), this[s.type + "s"].push(s)) : ($e833773b1f4e7d0f$var$g.warn("ISOFile", `Found multiple boxes of type ${s.type} but no array exists. Creating array dynamically.`), this[s.type + "s"] = [
                            this[s.type],
                            s
                        ]) : (this[s.type] = s, Array.isArray(this[s.type + "s"]) && this[s.type + "s"].push(s));
                        break;
                }
                this.updateUsedBytes && this.updateUsedBytes(s, t);
            } else if (t.code === $e833773b1f4e7d0f$var$Cr) {
                $e833773b1f4e7d0f$var$g.error("ISOFile", `Invalid data found while parsing box of type '${t.type}' at position ${t.start}. Aborting parsing.`, this);
                break;
            }
        }
    }
    checkBuffer(e) {
        if (!e) throw new Error("Buffer must be defined and non empty");
        return e.byteLength === 0 ? ($e833773b1f4e7d0f$var$g.warn("ISOFile", "Ignoring empty buffer (fileStart: " + e.fileStart + ")"), this.stream.logBufferLevel(), !1) : ($e833773b1f4e7d0f$var$g.info("ISOFile", "Processing buffer (fileStart: " + e.fileStart + ")"), e.usedBytes = 0, this.stream.insertBuffer(e), this.stream.logBufferLevel(), this.stream.initialized() ? !0 : ($e833773b1f4e7d0f$var$g.warn("ISOFile", "Not ready to start parsing"), !1));
    }
    appendBuffer(e, t) {
        let s;
        if (this.checkBuffer(e)) return this.parse(), this.moovStartFound && !this.moovStartSent && (this.moovStartSent = !0, this.onMoovStart && this.onMoovStart()), this.moov ? (this.sampleListBuilt || (this.buildSampleLists(), this.sampleListBuilt = !0), this.updateSampleLists(), this.onReady && !this.readySent && (this.readySent = !0, this.onReady(this.getInfo())), this.processSamples(t), this.nextSeekPosition ? (s = this.nextSeekPosition, this.nextSeekPosition = void 0) : s = this.nextParsePosition, this.stream.getEndFilePositionAfter && (s = this.stream.getEndFilePositionAfter(s))) : this.nextParsePosition ? s = this.nextParsePosition : s = 0, this.sidx && this.onSidx && !this.sidxSent && (this.onSidx(this.sidx), this.sidxSent = !0), this.meta && (this.flattenItemInfo && !this.itemListBuilt && (this.flattenItemInfo(), this.itemListBuilt = !0), this.processItems && this.processItems(this.onItem)), this.stream.cleanBuffers && ($e833773b1f4e7d0f$var$g.info("ISOFile", "Done processing buffer (fileStart: " + e.fileStart + ") - next buffer to fetch should have a fileStart position of " + s), this.stream.logBufferLevel(), this.stream.cleanBuffers(), this.stream.logBufferLevel(!0), $e833773b1f4e7d0f$var$g.info("ISOFile", "Sample data size in memory: " + this.getAllocatedSampleDataSize())), s;
    }
    getFragmentDuration() {
        let e = this.getBox("mvex");
        if (!e) return;
        if (e.mehd) return {
            num: e.mehd.fragment_duration,
            den: this.moov.mvhd.timescale
        };
        let t = this.getBoxes("trak", !1), s = {
            num: 0,
            den: 1
        };
        for (let r of t){
            let n = r.samples_duration, a = r.mdia.mdhd.timescale;
            n && a && n / a > s.num / s.den && (s = {
                num: n,
                den: a
            });
        }
        return s;
    }
    getInfo() {
        if (!this.moov) return {
            hasMoov: !1,
            mime: ""
        };
        let e = new Date("1904-01-01T00:00:00Z").getTime(), t = this.getBox("mvex") !== void 0, s = {
            hasMoov: !0,
            duration: this.moov.mvhd.duration,
            timescale: this.moov.mvhd.timescale,
            isFragmented: t,
            fragment_duration: this.getFragmentDuration(),
            isProgressive: this.isProgressive,
            hasIOD: this.moov.iods !== void 0,
            brands: [
                this.ftyp.major_brand
            ].concat(this.ftyp.compatible_brands),
            created: new Date(e + this.moov.mvhd.creation_time * 1e3),
            modified: new Date(e + this.moov.mvhd.modification_time * 1e3),
            tracks: [],
            audioTracks: [],
            videoTracks: [],
            subtitleTracks: [],
            metadataTracks: [],
            hintTracks: [],
            otherTracks: [],
            mime: ""
        };
        for(let r = 0; r < this.moov.traks.length; r++){
            let n = this.moov.traks[r], a = n.mdia.minf.stbl.stsd.entries[0], o = n.samples_size, u = n.mdia.mdhd.timescale, l = n.samples_duration, h = o * 8 * u / l, d = {
                samples_duration: l,
                bitrate: h,
                size: o,
                timescale: u,
                alternate_group: n.tkhd.alternate_group,
                codec: a.getCodec(),
                created: new Date(e + n.tkhd.creation_time * 1e3),
                cts_shift: n.mdia.minf.stbl.cslg,
                duration: n.mdia.mdhd.duration,
                id: n.tkhd.track_id,
                kind: n.udta && n.udta.kinds.length ? n.udta.kinds[0] : {
                    schemeURI: "",
                    value: ""
                },
                language: n.mdia.elng ? n.mdia.elng.extended_language : n.mdia.mdhd.languageString,
                layer: n.tkhd.layer,
                matrix: n.tkhd.matrix,
                modified: new Date(e + n.tkhd.modification_time * 1e3),
                movie_duration: n.tkhd.duration,
                movie_timescale: s.timescale,
                name: n.mdia.hdlr.name,
                nb_samples: n.samples.length,
                references: [],
                track_height: n.tkhd.height / 65536,
                track_width: n.tkhd.width / 65536,
                volume: n.tkhd.volume
            };
            if (s.tracks.push(d), n.tref) for(let c = 0; c < n.tref.references.length; c++)d.references.push({
                type: n.tref.references[c].type,
                track_ids: n.tref.references[c].track_ids
            });
            n.edts !== void 0 && n.edts.elst !== void 0 && (d.edits = n.edts.elst.entries), a instanceof $e833773b1f4e7d0f$var$ee ? (d.type = "audio", s.audioTracks.push(d), d.audio = {
                sample_rate: a.getSampleRate(),
                channel_count: a.getChannelCount(),
                sample_size: a.getSampleSize()
            }) : a instanceof $e833773b1f4e7d0f$var$M ? (d.type = "video", s.videoTracks.push(d), d.video = {
                width: a.getWidth(),
                height: a.getHeight()
            }) : a instanceof $e833773b1f4e7d0f$var$Re ? (d.type = "subtitles", s.subtitleTracks.push(d)) : a instanceof $e833773b1f4e7d0f$var$Ur ? (d.type = "metadata", s.hintTracks.push(d)) : a instanceof $e833773b1f4e7d0f$var$Ye ? (d.type = "metadata", s.metadataTracks.push(d)) : (d.type = "metadata", s.otherTracks.push(d));
        }
        s.videoTracks && s.videoTracks.length > 0 ? s.mime += 'video/mp4; codecs="' : s.audioTracks && s.audioTracks.length > 0 ? s.mime += 'audio/mp4; codecs="' : s.mime += 'application/mp4; codecs="';
        for(let r = 0; r < s.tracks.length; r++)r !== 0 && (s.mime += ","), s.mime += s.tracks[r].codec;
        return s.mime += '"; profiles="', s.mime += this.ftyp.compatible_brands.join(), s.mime += '"', s;
    }
    setNextSeekPositionFromSample(e) {
        e && (this.nextSeekPosition ? this.nextSeekPosition = Math.min(e.offset + e.alreadyRead, this.nextSeekPosition) : this.nextSeekPosition = e.offset + e.alreadyRead);
    }
    processSamples(e) {
        if (this.sampleProcessingStarted) {
            if (this.isFragmentationInitialized && this.onSegment !== void 0) {
                let t = new Set;
                for(; t.size < this.fragmentedTracks.length && this.fragmentedTracks.some((s)=>s.trak.nextSample < s.trak.samples.length) && this.sampleProcessingStarted;)for (let s of this.fragmentedTracks){
                    let r = s.trak;
                    if (!t.has(s.id)) {
                        let n = r.nextSample < r.samples.length ? this.getSample(r, r.nextSample) : void 0;
                        if (!n) {
                            this.setNextSeekPositionFromSample(r.samples[r.nextSample]), t.add(s.id);
                            continue;
                        }
                        s.state.accumulatedSize += n.size;
                        let a = r.nextSample + 1, o = a - s.state.lastFragmentSampleNumber > s.nb_samples_per_fragment, u = a - s.state.lastSegmentSampleNumber > s.nb_samples, l = o || a % s.nb_samples_per_fragment === 0, h = u || a % s.nb_samples === 0, d = s.state.accumulatedSize >= s.size_per_segment, c = !s.rapAlignement || n.is_sync, p = e || r.nextSample + 1 >= r.samples.length;
                        if (p && !c && $e833773b1f4e7d0f$var$g.warn("ISOFile", "Flushing track #" + s.id + " at sample #" + r.nextSample + " which is not a RAP, this may lead to playback issues"), l = l && c, h = h && c, d = d && c, l || d || p) {
                            o ? $e833773b1f4e7d0f$var$g.warn("ISOFile", "Fragment on track #" + s.id + " is overdue, creating it with samples [" + s.state.lastFragmentSampleNumber + ", " + r.nextSample + "]") : $e833773b1f4e7d0f$var$g.debug("ISOFile", "Creating media fragment on track #" + s.id + " for samples [" + s.state.lastFragmentSampleNumber + ", " + r.nextSample + "]");
                            let f = this.createFragment(s.id, s.state.lastFragmentSampleNumber, r.nextSample, s.segmentStream);
                            if (f) s.segmentStream = f, s.state.lastFragmentSampleNumber = r.nextSample + 1;
                            else {
                                t.add(s.id);
                                continue;
                            }
                        }
                        (h || d || p) && (u ? $e833773b1f4e7d0f$var$g.warn("ISOFile", "Segment on track #" + s.id + " is overdue, sending it with samples [" + Math.max(0, r.nextSample - s.nb_samples) + ", " + (r.nextSample - 1) + "]") : $e833773b1f4e7d0f$var$g.info("ISOFile", "Sending fragmented data on track #" + s.id + " for samples [" + Math.max(0, r.nextSample - s.nb_samples) + ", " + (r.nextSample - 1) + "]"), $e833773b1f4e7d0f$var$g.info("ISOFile", "Sample data size in memory: " + this.getAllocatedSampleDataSize()), this.onSegment && this.onSegment(s.id, s.user, s.segmentStream.buffer, r.nextSample + 1, e || r.nextSample + 1 >= r.samples.length), s.segmentStream = void 0, s.state.accumulatedSize = 0, s.state.lastSegmentSampleNumber = r.nextSample + 1), r.nextSample++;
                    }
                }
            }
            if (this.onSamples !== void 0) for(let t = 0; t < this.extractedTracks.length; t++){
                let s = this.extractedTracks[t], r = s.trak;
                for(; r.nextSample < r.samples.length && this.sampleProcessingStarted;){
                    $e833773b1f4e7d0f$var$g.debug("ISOFile", "Exporting on track #" + s.id + " sample #" + r.nextSample);
                    let n = this.getSample(r, r.nextSample);
                    if (n) r.nextSample++, s.samples.push(n);
                    else {
                        this.setNextSeekPositionFromSample(r.samples[r.nextSample]);
                        break;
                    }
                    if ((r.nextSample % s.nb_samples === 0 || r.nextSample >= r.samples.length) && ($e833773b1f4e7d0f$var$g.debug("ISOFile", "Sending samples on track #" + s.id + " for sample " + r.nextSample), this.onSamples && this.onSamples(s.id, s.user, s.samples), s.samples = [], s !== this.extractedTracks[t])) break;
                }
            }
        }
    }
    getBox(e) {
        let t = this.getBoxes(e, !0);
        return t.length ? t[0] : void 0;
    }
    getBoxes(e, t) {
        let s = [], r = (n)=>{
            n instanceof $e833773b1f4e7d0f$var$y && n.type && n.type === e && s.push(n);
            let a = [];
            n.boxes && a.push(...n.boxes), n.entries && a.push(...n.entries), n.item_infos && a.push(...n.item_infos), n.references && a.push(...n.references);
            for (let o of a){
                if (s.length && t) return;
                r(o);
            }
        };
        return r(this), s;
    }
    getTrackSamplesInfo(e) {
        let t = this.getTrackById(e);
        if (t) return t.samples;
    }
    getTrackSample(e, t) {
        let s = this.getTrackById(e);
        return this.getSample(s, t);
    }
    releaseUsedSamples(e, t) {
        let s = 0, r = this.getTrackById(e);
        r.lastValidSample || (r.lastValidSample = 0);
        for(let n = r.lastValidSample; n < t; n++)s += this.releaseSample(r, n);
        $e833773b1f4e7d0f$var$g.info("ISOFile", "Track #" + e + " released samples up to " + t + " (released size: " + s + ", remaining: " + this.samplesDataSize + ")"), r.lastValidSample = t;
    }
    start() {
        this.sampleProcessingStarted = !0, this.processSamples(!1);
    }
    stop() {
        this.sampleProcessingStarted = !1;
    }
    flush() {
        $e833773b1f4e7d0f$var$g.info("ISOFile", "Flushing remaining samples"), this.updateSampleLists(), this.processSamples(!0), this.stream.cleanBuffers(), this.stream.logBufferLevel(!0);
    }
    seekTrack(e, t, s) {
        let r = 0, n = 0, a;
        if (s.samples.length === 0) return $e833773b1f4e7d0f$var$g.info("ISOFile", "No sample in track, cannot seek! Using time " + $e833773b1f4e7d0f$var$g.getDurationString(0, 1) + " and offset: 0"), {
            offset: 0,
            time: 0
        };
        for(let u = 0; u < s.samples.length; u++){
            let l = s.samples[u];
            if (u === 0) n = 0, a = l.timescale;
            else if (l.cts > e * l.timescale) {
                n = u - 1;
                break;
            }
            t && l.is_sync && (r = u);
        }
        for(t && (n = r), e = s.samples[n].cts, s.nextSample = n; s.samples[n].alreadyRead === s.samples[n].size && s.samples[n + 1];)n++;
        let o = s.samples[n].offset + s.samples[n].alreadyRead;
        return $e833773b1f4e7d0f$var$g.info("ISOFile", "Seeking to " + (t ? "RAP" : "") + " sample #" + s.nextSample + " on track " + s.tkhd.track_id + ", time " + $e833773b1f4e7d0f$var$g.getDurationString(e, a) + " and offset: " + o), {
            offset: o,
            time: e / a
        };
    }
    getTrackDuration(e) {
        if (!e.samples) return 1 / 0;
        let t = e.samples[e.samples.length - 1];
        return (t.cts + t.duration) / t.timescale;
    }
    seek(e, t) {
        let s = this.moov, r = {
            offset: 1 / 0,
            time: 1 / 0
        };
        if (this.moov) {
            for(let n = 0; n < s.traks.length; n++){
                let a = s.traks[n];
                if (e > this.getTrackDuration(a)) continue;
                let o = this.seekTrack(e, t, a);
                o.offset < r.offset && (r.offset = o.offset), o.time < r.time && (r.time = o.time);
            }
            return $e833773b1f4e7d0f$var$g.info("ISOFile", "Seeking at time " + $e833773b1f4e7d0f$var$g.getDurationString(r.time, 1) + " needs a buffer with a fileStart position of " + r.offset), r.offset === 1 / 0 ? r = {
                offset: this.nextParsePosition,
                time: 0
            } : r.offset = this.stream.getEndFilePositionAfter(r.offset), $e833773b1f4e7d0f$var$g.info("ISOFile", "Adjusted seek position (after checking data already in buffer): " + r.offset), r;
        } else throw new Error("Cannot seek: moov not received!");
    }
    equal(e) {
        let t = 0;
        for(; t < this.boxes.length && t < e.boxes.length;){
            let s = this.boxes[t], r = e.boxes[t];
            if (!$e833773b1f4e7d0f$var$Ar(s, r)) return !1;
            t++;
        }
        return !0;
    }
    write(e) {
        for(let t = 0; t < this.boxes.length; t++)this.boxes[t].write(e);
    }
    createFragment(e, t, s, r) {
        let n = [];
        for(let h = t; h <= s; h++){
            let d = this.getTrackById(e), c = this.getSample(d, h);
            if (!c) {
                this.setNextSeekPositionFromSample(d.samples[h]);
                return;
            }
            n.push(c);
        }
        let a = r || new $e833773b1f4e7d0f$var$V, o = this.createMoof(n);
        o.write(a), o.trafs[0].truns[0].data_offset = o.size + 8, $e833773b1f4e7d0f$var$g.debug("MP4Box", "Adjusting data_offset with new value " + o.trafs[0].truns[0].data_offset), a.adjustUint32(o.trafs[0].truns[0].data_offset_position, o.trafs[0].truns[0].data_offset);
        let u = new $e833773b1f4e7d0f$var$Xt;
        u.stream = new $e833773b1f4e7d0f$var$ct;
        let l = 0;
        for (let h of n)if (h.data) {
            let d = $e833773b1f4e7d0f$var$$.fromArrayBuffer(h.data.buffer, l);
            u.stream.insertBuffer(d), l += h.data.byteLength;
        }
        return u.write(a), a;
    }
    static writeInitializationSegment(e, t, s) {
        $e833773b1f4e7d0f$var$g.debug("ISOFile", "Generating initialization segment");
        let r = new $e833773b1f4e7d0f$var$V;
        e.write(r);
        let n = t.addBox(new $e833773b1f4e7d0f$var$ss);
        if (s) {
            let a = n.addBox(new $e833773b1f4e7d0f$var$Yr);
            a.fragment_duration = s;
        }
        for(let a = 0; a < t.traks.length; a++){
            let o = n.addBox(new $e833773b1f4e7d0f$var$rs);
            o.track_id = t.traks[a].tkhd.track_id, o.default_sample_description_index = 1, o.default_sample_duration = t.traks[a].samples[0]?.duration ?? 0, o.default_sample_size = 0, o.default_sample_flags = 65536;
        }
        return t.write(r), r.buffer;
    }
    save(e) {
        let t = new $e833773b1f4e7d0f$var$V;
        return t.isofile = this, this.write(t), t.save(e);
    }
    getBuffer() {
        let e = new $e833773b1f4e7d0f$var$V;
        return e.isofile = this, this.write(e), e;
    }
    initializeSegmentation() {
        this.onSegment || $e833773b1f4e7d0f$var$g.warn("MP4Box", "No segmentation callback set!"), this.isFragmentationInitialized || (this.isFragmentationInitialized = !0, this.resetTables());
        let e = new $e833773b1f4e7d0f$var$is;
        e.addBox(this.moov.mvhd);
        for(let t = 0; t < this.fragmentedTracks.length; t++){
            let s = this.getTrackById(this.fragmentedTracks[t].id);
            if (!s) {
                $e833773b1f4e7d0f$var$g.warn("ISOFile", `Track with id ${this.fragmentedTracks[t].id} not found, skipping fragmentation initialization`);
                continue;
            }
            e.addBox(s);
        }
        return {
            tracks: e.traks.map((t, s)=>({
                    id: t.tkhd.track_id,
                    user: this.fragmentedTracks[s].user
                })),
            buffer: Se.writeInitializationSegment(this.ftyp, e, this.moov?.mvex?.mehd.fragment_duration)
        };
    }
    resetTables() {
        this.initial_duration = this.moov.mvhd.duration, this.moov.mvhd.duration = 0;
        for(let e = 0; e < this.moov.traks.length; e++){
            let t = this.moov.traks[e];
            t.tkhd.duration = 0, t.mdia.mdhd.duration = 0;
            let s = t.mdia.minf.stbl.stco || t.mdia.minf.stbl.co64;
            s.chunk_offsets = [];
            let r = t.mdia.minf.stbl.stsc;
            r.first_chunk = [], r.samples_per_chunk = [], r.sample_description_index = [];
            let n = t.mdia.minf.stbl.stsz || t.mdia.minf.stbl.stz2;
            n.sample_sizes = [];
            let a = t.mdia.minf.stbl.stts;
            a.sample_counts = [], a.sample_deltas = [];
            let o = t.mdia.minf.stbl.ctts;
            o && (o.sample_counts = [], o.sample_offsets = []);
            let u = t.mdia.minf.stbl.stss, l = t.mdia.minf.stbl.boxes.indexOf(u);
            l !== -1 && (t.mdia.minf.stbl.boxes[l] = void 0);
        }
    }
    static initSampleGroups(e, t, s, r, n) {
        t && (t.sample_groups_info = []), e.sample_groups_info || (e.sample_groups_info = []);
        for(let a = 0; a < s.length; a++){
            let o = s[a].grouping_type + "/" + s[a].grouping_type_parameter, u = new $e833773b1f4e7d0f$var$es(s[a].grouping_type, s[a].grouping_type_parameter, s[a]);
            t && (t.sample_groups_info[o] = u), e.sample_groups_info[o] || (e.sample_groups_info[o] = u);
            for(let l = 0; l < r.length; l++)r[l].grouping_type === s[a].grouping_type && (u.description = r[l], u.description.used = !0);
            if (n) for(let l = 0; l < n.length; l++)n[l].grouping_type === s[a].grouping_type && (u.fragment_description = n[l], u.fragment_description.used = !0, u.is_fragment = !0);
        }
        if (t) {
            if (n) {
                for(let a = 0; a < n.length; a++)if (!n[a].used && n[a].version >= 2) {
                    let o = n[a].grouping_type + "/0", u = new $e833773b1f4e7d0f$var$es(n[a].grouping_type, 0);
                    u.is_fragment = !0, t.sample_groups_info[o] || (t.sample_groups_info[o] = u);
                }
            }
        } else for(let a = 0; a < r.length; a++)if (!r[a].used && r[a].version >= 2) {
            let o = r[a].grouping_type + "/0", u = new $e833773b1f4e7d0f$var$es(r[a].grouping_type, 0);
            e.sample_groups_info[o] || (e.sample_groups_info[o] = u);
        }
    }
    static setSampleGroupProperties(e, t, s, r) {
        t.sample_groups = [];
        for(let n in r)if (t.sample_groups[n] = {
            grouping_type: r[n].grouping_type,
            grouping_type_parameter: r[n].grouping_type_parameter
        }, s >= r[n].last_sample_in_run && (r[n].last_sample_in_run < 0 && (r[n].last_sample_in_run = 0), r[n].entry_index++, r[n].entry_index <= r[n].sbgp.entries.length - 1 && (r[n].last_sample_in_run += r[n].sbgp.entries[r[n].entry_index].sample_count)), r[n].entry_index <= r[n].sbgp.entries.length - 1 ? t.sample_groups[n].group_description_index = r[n].sbgp.entries[r[n].entry_index].group_description_index : t.sample_groups[n].group_description_index = -1, t.sample_groups[n].group_description_index !== 0) {
            let a;
            if (r[n].fragment_description ? a = r[n].fragment_description : a = r[n].description, t.sample_groups[n].group_description_index > 0) {
                let o;
                t.sample_groups[n].group_description_index > 65535 ? o = (t.sample_groups[n].group_description_index >> 16) - 1 : o = t.sample_groups[n].group_description_index - 1, a && o >= 0 && (t.sample_groups[n].description = a.entries[o]);
            } else a && a.version >= 2 && a.default_group_description_index > 0 && (t.sample_groups[n].description = a.entries[a.default_group_description_index - 1]);
        }
    }
    static process_sdtp(e, t, s) {
        t && (e ? (t.is_leading = e.is_leading[s], t.depends_on = e.sample_depends_on[s], t.is_depended_on = e.sample_is_depended_on[s], t.has_redundancy = e.sample_has_redundancy[s]) : (t.is_leading = 0, t.depends_on = 0, t.is_depended_on = 0, t.has_redundancy = 0));
    }
    buildSampleLists() {
        for(let e = 0; e < this.moov.traks.length; e++)this.buildTrakSampleLists(this.moov.traks[e]);
    }
    buildTrakSampleLists(e) {
        let t, s, r, n, a, o;
        e.samples = [], e.samples_duration = 0, e.samples_size = 0;
        let u = e.mdia.minf.stbl.stco || e.mdia.minf.stbl.co64, l = e.mdia.minf.stbl.stsc, h = e.mdia.minf.stbl.stsz || e.mdia.minf.stbl.stz2, d = e.mdia.minf.stbl.stts, c = e.mdia.minf.stbl.ctts, p = e.mdia.minf.stbl.stss, f = e.mdia.minf.stbl.stsd, _ = e.mdia.minf.stbl.subs, m = e.mdia.minf.stbl.stdp, b = e.mdia.minf.stbl.sbgps, S = e.mdia.minf.stbl.sgpds, C = -1, j = -1, N = -1, P = -1, G = 0, R = 0, X = 0;
        if (Se.initSampleGroups(e, void 0, b, S), !(typeof h > "u")) {
            for(t = 0; t < h.sample_sizes.length; t++){
                let w = {
                    number: t,
                    track_id: e.tkhd.track_id,
                    timescale: e.mdia.mdhd.timescale,
                    alreadyRead: 0,
                    size: h.sample_sizes[t]
                };
                e.samples[t] = w, e.samples_size += w.size, t === 0 ? (r = 1, s = 0, w.chunk_index = r, w.chunk_run_index = s, o = l.samples_per_chunk[s], a = 0, s + 1 < l.first_chunk.length ? n = l.first_chunk[s + 1] - 1 : n = 1 / 0) : t < o ? (w.chunk_index = r, w.chunk_run_index = s) : (r++, w.chunk_index = r, a = 0, r <= n || (s++, s + 1 < l.first_chunk.length ? n = l.first_chunk[s + 1] - 1 : n = 1 / 0), w.chunk_run_index = s, o += l.samples_per_chunk[s]), w.description_index = l.sample_description_index[w.chunk_run_index] - 1, w.description = f.entries[w.description_index], w.offset = u.chunk_offsets[w.chunk_index - 1] + a, a += w.size, t > C && (j++, C < 0 && (C = 0), C += d.sample_counts[j]), t > 0 ? (e.samples[t - 1].duration = d.sample_deltas[j], e.samples_duration += e.samples[t - 1].duration, w.dts = e.samples[t - 1].dts + e.samples[t - 1].duration) : w.dts = 0, c ? (t >= N && (P++, N < 0 && (N = 0), N += c.sample_counts[P]), w.cts = e.samples[t].dts + c.sample_offsets[P]) : w.cts = w.dts, p ? (t === p.sample_numbers[G] - 1 ? (w.is_sync = !0, G++) : (w.is_sync = !1, w.degradation_priority = 0), _ && _.entries[R].sample_delta + X === t + 1 && (w.subsamples = _.entries[R].subsamples, X += _.entries[R].sample_delta, R++)) : w.is_sync = !0, Se.process_sdtp(e.mdia.minf.stbl.sdtp, w, w.number), m ? w.degradation_priority = m.priority[t] : w.degradation_priority = 0, _ && _.entries[R].sample_delta + X === t && (w.subsamples = _.entries[R].subsamples, X += _.entries[R].sample_delta), (b.length > 0 || S.length > 0) && Se.setSampleGroupProperties(e, w, t, e.sample_groups_info);
            }
            t > 0 && (e.samples[t - 1].duration = Math.max(e.mdia.mdhd.duration - e.samples[t - 1].dts, 0), e.samples_duration += e.samples[t - 1].duration);
        }
    }
    updateSampleLists() {
        let e, t, s, r, n;
        if (this.moov !== void 0) for(; this.lastMoofIndex < this.moofs.length;){
            let a = this.moofs[this.lastMoofIndex];
            if (this.lastMoofIndex++, a.type === "moof") {
                let o = a;
                for(let u = 0; u < o.trafs.length; u++){
                    let l = o.trafs[u], h = this.getTrackById(l.tfhd.track_id), d = this.getTrexById(l.tfhd.track_id);
                    l.tfhd.flags & $e833773b1f4e7d0f$var$Vt ? e = l.tfhd.default_sample_description_index : e = d ? d.default_sample_description_index : 1, l.tfhd.flags & $e833773b1f4e7d0f$var$Ht ? t = l.tfhd.default_sample_duration : t = d ? d.default_sample_duration : 0, l.tfhd.flags & $e833773b1f4e7d0f$var$qt ? s = l.tfhd.default_sample_size : s = d ? d.default_sample_size : 0, l.tfhd.flags & $e833773b1f4e7d0f$var$Wt ? r = l.tfhd.default_sample_flags : r = d ? d.default_sample_flags : 0, l.sample_number = 0, l.sbgps.length > 0 && Se.initSampleGroups(h, l, l.sbgps, h.mdia.minf.stbl.sgpds, l.sgpds);
                    for(let c = 0; c < l.truns.length; c++){
                        let p = l.truns[c];
                        for(let f = 0; f < p.sample_count; f++){
                            let _ = e - 1, m = r;
                            p.flags & $e833773b1f4e7d0f$var$ht ? m = p.sample_flags[f] : f === 0 && p.flags & $e833773b1f4e7d0f$var$Yt && (m = p.first_sample_flags);
                            let b = s;
                            p.flags & $e833773b1f4e7d0f$var$lt && (b = p.sample_size[f]), h.samples_size += b;
                            let S = t;
                            p.flags & $e833773b1f4e7d0f$var$ut && (S = p.sample_duration[f]), h.samples_duration += S;
                            let C;
                            h.first_traf_merged || f > 0 ? C = h.samples[h.samples.length - 1].dts + h.samples[h.samples.length - 1].duration : (l.tfdt ? C = l.tfdt.baseMediaDecodeTime : C = 0, h.first_traf_merged = !0);
                            let j = C;
                            p.flags & $e833773b1f4e7d0f$var$dt && (j = C + p.sample_composition_time_offset[f]);
                            let N = !!(l.tfhd.flags & $e833773b1f4e7d0f$var$Gt), P = !!(l.tfhd.flags & $e833773b1f4e7d0f$var$vr), G = !!(p.flags & $e833773b1f4e7d0f$var$ot), R = 0;
                            N ? R = l.tfhd.base_data_offset : P || c === 0 ? R = o.start : R = n;
                            let X;
                            c === 0 && f === 0 ? G ? X = R + p.data_offset : X = R : X = n, n = X + b;
                            let w = l.sample_number;
                            l.sample_number++;
                            let F = {
                                cts: j,
                                description_index: _,
                                description: h.mdia.minf.stbl.stsd.entries[_],
                                dts: C,
                                duration: S,
                                moof_number: this.lastMoofIndex,
                                number_in_traf: w,
                                number: h.samples.length,
                                offset: X,
                                size: b,
                                timescale: h.mdia.mdhd.timescale,
                                track_id: h.tkhd.track_id,
                                is_sync: !(m >> 16 & 1),
                                is_leading: m >> 26 & 3,
                                depends_on: m >> 24 & 3,
                                is_depended_on: m >> 22 & 3,
                                has_redundancy: m >> 20 & 3,
                                degradation_priority: m & 65535
                            };
                            l.first_sample_index = h.samples.length, h.samples.push(F), (l.sbgps.length > 0 || l.sgpds.length > 0 || h.mdia.minf.stbl.sbgps.length > 0 || h.mdia.minf.stbl.sgpds.length > 0) && Se.setSampleGroupProperties(h, F, F.number_in_traf, l.sample_groups_info);
                        }
                    }
                    if (l.subs) {
                        h.has_fragment_subsamples = !0;
                        let c = l.first_sample_index;
                        for(let p = 0; p < l.subs.entries.length; p++){
                            c += l.subs.entries[p].sample_delta;
                            let f = h.samples[c - 1];
                            f.subsamples = l.subs.entries[p].subsamples;
                        }
                    }
                }
            }
        }
    }
    getSample(e, t) {
        let s = e.samples[t];
        if (this.moov) {
            if (!s.data) s.data = new Uint8Array(s.size), s.alreadyRead = 0, this.samplesDataSize += s.size, $e833773b1f4e7d0f$var$g.debug("ISOFile", "Allocating sample #" + t + " on track #" + e.tkhd.track_id + " of size " + s.size + " (total: " + this.samplesDataSize + ")");
            else if (s.alreadyRead === s.size) return s;
            for(;;){
                let r = this.stream, n = r.findPosition(!0, s.offset + s.alreadyRead, !1), a, o;
                if (n > -1) a = r.buffers[n], o = a.fileStart;
                else for (let u of this.mdats){
                    if (!u.stream) {
                        $e833773b1f4e7d0f$var$g.debug("ISOFile", "mdat stream not yet fully read for #" + this.mdats.indexOf(u) + " mdat");
                        continue;
                    }
                    if (n = u.stream.findPosition(!0, s.offset + s.alreadyRead - u.start - u.hdr_size, !1), n > -1) {
                        r = u.stream, a = u.stream.buffers[n], o = u.start + u.hdr_size + a.fileStart;
                        break;
                    }
                }
                if (a) {
                    let u = a.byteLength - (s.offset + s.alreadyRead - o);
                    if (s.size - s.alreadyRead <= u) return $e833773b1f4e7d0f$var$g.debug("ISOFile", "Getting sample #" + t + " data (alreadyRead: " + s.alreadyRead + " offset: " + (s.offset + s.alreadyRead - o) + " read size: " + (s.size - s.alreadyRead) + " full size: " + s.size + ")"), $e833773b1f4e7d0f$var$V.memcpy(s.data.buffer, s.alreadyRead, a, s.offset + s.alreadyRead - o, s.size - s.alreadyRead), a.usedBytes += s.size - s.alreadyRead, r.logBufferLevel(), s.alreadyRead = s.size, s;
                    if (u === 0) return;
                    $e833773b1f4e7d0f$var$g.debug("ISOFile", "Getting sample #" + t + " partial data (alreadyRead: " + s.alreadyRead + " offset: " + (s.offset + s.alreadyRead - o) + " read size: " + u + " full size: " + s.size + ")"), $e833773b1f4e7d0f$var$V.memcpy(s.data.buffer, s.alreadyRead, a, s.offset + s.alreadyRead - o, u), s.alreadyRead += u, a.usedBytes += u, r.logBufferLevel();
                } else return;
            }
        }
    }
    releaseSample(e, t) {
        let s = e.samples[t];
        return s.data ? (this.samplesDataSize -= s.size, s.data = void 0, s.alreadyRead = 0, s.size) : 0;
    }
    getAllocatedSampleDataSize() {
        return this.samplesDataSize;
    }
    getCodecs() {
        let e = "";
        for(let t = 0; t < this.moov.traks.length; t++){
            let s = this.moov.traks[t];
            t > 0 && (e += ","), e += s.mdia.minf.stbl.stsd.entries[0].getCodec();
        }
        return e;
    }
    getTrexById(e) {
        if (!(!this.moov || !this.moov.mvex)) for(let t = 0; t < this.moov.mvex.trexs.length; t++){
            let s = this.moov.mvex.trexs[t];
            if (s.track_id === e) return s;
        }
    }
    getTrackById(e) {
        if (this.moov) for(let t = 0; t < this.moov.traks.length; t++){
            let s = this.moov.traks[t];
            if (s.tkhd.track_id === e) return s;
        }
    }
    flattenItemInfo() {
        let e = this.items, t = this.entity_groups, s = this.meta;
        if (!(!s || !s.hdlr || !s.iinf)) {
            for(let r = 0; r < s.iinf.item_infos.length; r++){
                let n = s.iinf.item_infos[r].item_ID;
                e[n] = {
                    id: n,
                    name: s.iinf.item_infos[r].item_name,
                    ref_to: [],
                    content_type: s.iinf.item_infos[r].content_type,
                    content_encoding: s.iinf.item_infos[r].content_encoding,
                    item_uri_type: s.iinf.item_infos[r].item_uri_type,
                    type: s.iinf.item_infos[r].item_type ? s.iinf.item_infos[r].item_type : "mime",
                    protection: s.iinf.item_infos[r].item_protection_index > 0 ? s.ipro.protections[s.iinf.item_infos[r].item_protection_index - 1] : void 0
                };
            }
            if (s.grpl) for(let r = 0; r < s.grpl.boxes.length; r++){
                let n = s.grpl.boxes[r];
                t[n.group_id] = {
                    id: n.group_id,
                    entity_ids: n.entity_ids,
                    type: n.type
                };
            }
            if (s.iloc) for(let r = 0; r < s.iloc.items.length; r++){
                let n = s.iloc.items[r], a = e[n.item_ID];
                n.data_reference_index !== 0 && ($e833773b1f4e7d0f$var$g.warn("Item storage with reference to other files: not supported"), a.source = s.dinf.boxes[n.data_reference_index - 1]), a.extents = [], a.size = 0;
                for(let o = 0; o < n.extents.length; o++)a.extents[o] = {
                    offset: n.extents[o].extent_offset + n.base_offset,
                    length: n.extents[o].extent_length,
                    alreadyRead: 0
                }, n.construction_method === 1 && (a.extents[o].offset += s.idat.start + s.idat.hdr_size), a.size += a.extents[o].length;
            }
            if (s.pitm && (e[s.pitm.item_id].primary = !0), s.iref) for(let r = 0; r < s.iref.references.length; r++){
                let n = s.iref.references[r];
                for(let a = 0; a < n.references.length; a++)e[n.from_item_ID].ref_to.push({
                    type: n.type,
                    id: n.references[a]
                });
            }
            if (s.iprp) for(let r = 0; r < s.iprp.ipmas.length; r++){
                let n = s.iprp.ipmas[r];
                for(let a = 0; a < n.associations.length; a++){
                    let o = n.associations[a], u = e[o.id] ?? t[o.id];
                    if (u) {
                        u.properties === void 0 && (u.properties = {
                            boxes: []
                        });
                        for(let l = 0; l < o.props.length; l++){
                            let h = o.props[l];
                            if (h.property_index > 0 && h.property_index - 1 < s.iprp.ipco.boxes.length) {
                                let d = s.iprp.ipco.boxes[h.property_index - 1];
                                u.properties[d.type] = d, u.properties.boxes.push(d);
                            }
                        }
                    }
                }
            }
        }
    }
    getItem(e) {
        if (!this.meta) return;
        let t = this.items[e];
        if (!t.data && t.size) t.data = new Uint8Array(t.size), t.alreadyRead = 0, this.itemsDataSize += t.size, $e833773b1f4e7d0f$var$g.debug("ISOFile", "Allocating item #" + e + " of size " + t.size + " (total: " + this.itemsDataSize + ")");
        else if (t.alreadyRead === t.size) return t;
        for(let s = 0; s < t.extents.length; s++){
            let r = t.extents[s];
            if (r.alreadyRead !== r.length) {
                let n = this.stream.findPosition(!0, r.offset + r.alreadyRead, !1);
                if (n > -1) {
                    let a = this.stream.buffers[n], o = a.byteLength - (r.offset + r.alreadyRead - a.fileStart);
                    if (r.length - r.alreadyRead <= o) $e833773b1f4e7d0f$var$g.debug("ISOFile", "Getting item #" + e + " extent #" + s + " data (alreadyRead: " + r.alreadyRead + " offset: " + (r.offset + r.alreadyRead - a.fileStart) + " read size: " + (r.length - r.alreadyRead) + " full extent size: " + r.length + " full item size: " + t.size + ")"), $e833773b1f4e7d0f$var$V.memcpy(t.data.buffer, t.alreadyRead, a, r.offset + r.alreadyRead - a.fileStart, r.length - r.alreadyRead), (!this.parsingMdat || this.discardMdatData) && (a.usedBytes += r.length - r.alreadyRead), this.stream.logBufferLevel(), t.alreadyRead += r.length - r.alreadyRead, r.alreadyRead = r.length;
                    else {
                        $e833773b1f4e7d0f$var$g.debug("ISOFile", "Getting item #" + e + " extent #" + s + " partial data (alreadyRead: " + r.alreadyRead + " offset: " + (r.offset + r.alreadyRead - a.fileStart) + " read size: " + o + " full extent size: " + r.length + " full item size: " + t.size + ")"), $e833773b1f4e7d0f$var$V.memcpy(t.data.buffer, t.alreadyRead, a, r.offset + r.alreadyRead - a.fileStart, o), r.alreadyRead += o, t.alreadyRead += o, (!this.parsingMdat || this.discardMdatData) && (a.usedBytes += o), this.stream.logBufferLevel();
                        return;
                    }
                } else return;
            }
        }
        if (t.alreadyRead === t.size) return t;
    }
    releaseItem(e) {
        let t = this.items[e];
        if (t.data) {
            this.itemsDataSize -= t.size, t.data = void 0, t.alreadyRead = 0;
            for(let s = 0; s < t.extents.length; s++){
                let r = t.extents[s];
                r.alreadyRead = 0;
            }
            return t.size;
        } else return 0;
    }
    processItems(e) {
        for(let t in this.items){
            let s = this.items[t];
            this.getItem(s.id), e && !s.sent && (e(s), s.sent = !0, s.data = void 0);
        }
    }
    hasItem(e) {
        for(let t in this.items){
            let s = this.items[t];
            if (s.name === e) return s.id;
        }
        return -1;
    }
    getMetaHandler() {
        if (this.meta) return this.meta.hdlr.handler;
    }
    getPrimaryItem() {
        if (this.meta && this.meta.pitm) return this.getItem(this.meta.pitm.item_id);
    }
    itemToFragmentedTrackFile({ itemId: e } = {}) {
        let t;
        if (e ? t = this.getItem(e) : t = this.getPrimaryItem(), !t) return;
        let s = new Se;
        s.discardMdatData = !1;
        let r = {
            type: t.type,
            description_boxes: t.properties.boxes
        };
        t.properties.ispe && (r.width = t.properties.ispe.image_width, r.height = t.properties.ispe.image_height);
        let n = s.addTrack(r);
        if (n) return s.addSample(n, t.data), s;
    }
    processIncompleteBox(e) {
        if (e.type === "mdat") {
            let t = new $e833773b1f4e7d0f$var$Xt(e.size);
            return this.parsingMdat = t, this.boxes.push(t), this.mdats.push(t), t.start = e.start, t.hdr_size = e.hdr_size, t.original_size = e.original_size, this.stream.addUsedBytes(t.hdr_size), this.lastBoxStartPosition = t.start + t.size, this.stream.seek(t.start + t.size, !1, this.discardMdatData) ? (this.transferMdatData(), this.parsingMdat = void 0, !0) : (this.moovStartFound ? this.nextParsePosition = this.stream.findEndContiguousBuf() : this.nextParsePosition = t.start + t.size, !1);
        } else return e.type === "moov" && (this.moovStartFound = !0, this.mdats.length === 0 && (this.isProgressive = !0)), (this.stream.mergeNextBuffer ? this.stream.mergeNextBuffer() : !1) ? (this.nextParsePosition = this.stream.getEndPosition(), !0) : (e.type ? this.moovStartFound ? this.nextParsePosition = this.stream.getEndPosition() : this.nextParsePosition = this.stream.getPosition() + e.size : this.nextParsePosition = this.stream.getEndPosition(), !1);
    }
    hasIncompleteMdat() {
        return this.parsingMdat !== void 0;
    }
    transferMdatData(e) {
        let t = e ?? this.parsingMdat;
        if (this.discardMdatData) {
            $e833773b1f4e7d0f$var$g.debug("ISOFile", "Discarding 'mdat' data, not transferring it to the mdat box stream");
            return;
        }
        if (!t) {
            $e833773b1f4e7d0f$var$g.warn("ISOFile", "Cannot transfer 'mdat' data, no mdat box is being parsed");
            return;
        }
        let s = this.stream.findPosition(!0, t.start + t.hdr_size, !1), r = this.stream.findPosition(!0, t.start + t.size, !1);
        if (s === -1 || r === -1) {
            $e833773b1f4e7d0f$var$g.warn("ISOFile", "Cannot transfer 'mdat' data, start or end buffer not found");
            return;
        }
        t.stream = new $e833773b1f4e7d0f$var$ct;
        for(let n = s; n <= r; n++){
            let a = this.stream.buffers[n], o = n === s ? t.start + t.hdr_size - a.fileStart : 0, u = n === r ? t.start + t.size - a.fileStart : a.byteLength;
            if (u > o) {
                $e833773b1f4e7d0f$var$g.debug("ISOFile", "Transferring 'mdat' data from buffer #" + n + " (" + o + " to " + u + ")");
                let l = u - o, h = new $e833773b1f4e7d0f$var$$(l), d = t.stream.getAbsoluteEndPosition();
                $e833773b1f4e7d0f$var$V.memcpy(h, 0, a, o, l), h.fileStart = d, t.stream.insertBuffer(h), a.usedBytes += l;
            }
        }
    }
    processIncompleteMdat() {
        let e = this.parsingMdat;
        return this.stream.seek(e.start + e.size, !1, this.discardMdatData) ? ($e833773b1f4e7d0f$var$g.debug("ISOFile", "Found 'mdat' end in buffered data"), this.transferMdatData(), this.parsingMdat = void 0, !0) : (this.nextParsePosition = this.stream.findEndContiguousBuf(), !1);
    }
    restoreParsePosition() {
        return this.stream.seek(this.lastBoxStartPosition, !0, this.discardMdatData);
    }
    saveParsePosition() {
        this.lastBoxStartPosition = this.stream.getPosition();
    }
    updateUsedBytes(e, t) {
        this.stream.addUsedBytes && (e.type === "mdat" ? (this.stream.addUsedBytes(e.hdr_size), this.discardMdatData && this.stream.addUsedBytes(e.size - e.hdr_size)) : this.stream.addUsedBytes(e.size));
    }
    addBox(e) {
        return $e833773b1f4e7d0f$var$y.prototype.addBox.call(this, e);
    }
    init(e = {}) {
        let t = this.addBox(new $e833773b1f4e7d0f$var$Vr);
        t.major_brand = e.brands && e.brands[0] || "iso4", t.minor_version = 0, t.compatible_brands = e.brands || [
            "iso4"
        ];
        let s = this.addBox(new $e833773b1f4e7d0f$var$is);
        s.addBox(new $e833773b1f4e7d0f$var$ss);
        let r = s.addBox(new $e833773b1f4e7d0f$var$Kr);
        return r.timescale = e.timescale || 600, r.rate = e.rate || 65536, r.creation_time = 0, r.modification_time = 0, r.duration = e.duration || 0, r.volume = e.width ? 0 : 256, r.matrix = [
            65536,
            0,
            0,
            0,
            65536,
            0,
            0,
            0,
            1073741824
        ], r.next_track_id = 1, this;
    }
    addTrack(e = {}) {
        this.moov || this.init(e);
        let t = e || {};
        t.width = t.width || 320, t.height = t.height || 320, t.id = t.id || this.moov.mvhd.next_track_id, t.type = t.type || "avc1";
        let s = this.moov.addBox(new $e833773b1f4e7d0f$var$kr);
        this.moov.mvhd.next_track_id = t.id + 1;
        let r = s.addBox(new $e833773b1f4e7d0f$var$ln);
        r.flags = $e833773b1f4e7d0f$var$Ku | $e833773b1f4e7d0f$var$$u | $e833773b1f4e7d0f$var$Qu, r.creation_time = 0, r.modification_time = 0, r.track_id = t.id, r.duration = t.duration || 0, r.layer = t.layer || 0, r.alternate_group = 0, r.volume = 1, r.matrix = [
            65536,
            0,
            0,
            0,
            65536,
            0,
            0,
            0,
            1073741824
        ], r.width = t.width << 16, r.height = t.height << 16;
        let n = s.addBox(new $e833773b1f4e7d0f$var$Rr), a = n.addBox(new $e833773b1f4e7d0f$var$Wr);
        a.creation_time = 0, a.modification_time = 0, a.timescale = t.timescale || 1, a.duration = t.media_duration || 0, a.language = t.language || "und";
        let o = n.addBox(new $e833773b1f4e7d0f$var$Hr);
        o.handler = t.hdlr || "vide", o.name = t.name || "Track created with MP4Box.js";
        let u = n.addBox(new $e833773b1f4e7d0f$var$Gr);
        u.extended_language = t.language || "fr-FR";
        let l = n.addBox(new $e833773b1f4e7d0f$var$Fr), h = $e833773b1f4e7d0f$var$Z.sampleEntry[t.type];
        if (!h) return;
        let d = new h;
        if (d.data_reference_index = 1, d instanceof $e833773b1f4e7d0f$var$M) {
            let P = d, G = l.addBox(new $e833773b1f4e7d0f$var$cn);
            G.graphicsmode = 0, G.opcolor = [
                0,
                0,
                0
            ], P.width = t.width, P.height = t.height, P.horizresolution = 4718592, P.vertresolution = 4718592, P.frame_count = 1, P.compressorname = t.type + " Compressor", P.depth = 24, t.avcDecoderConfigRecord ? P.addBox(new $e833773b1f4e7d0f$var$Dr(t.avcDecoderConfigRecord.byteLength)).parse(new $e833773b1f4e7d0f$var$V(t.avcDecoderConfigRecord)) : t.hevcDecoderConfigRecord && P.addBox(new $e833773b1f4e7d0f$var$qr(t.hevcDecoderConfigRecord.byteLength)).parse(new $e833773b1f4e7d0f$var$V(t.hevcDecoderConfigRecord));
        } else if (d instanceof $e833773b1f4e7d0f$var$ee) {
            let P = d, G = l.addBox(new $e833773b1f4e7d0f$var$Jr);
            G.balance = t.balance || 0, P.channel_count = t.channel_count || 2, P.samplesize = t.samplesize || 16, P.samplerate = t.samplerate || 65536;
        } else d instanceof $e833773b1f4e7d0f$var$Ur ? l.addBox(new $e833773b1f4e7d0f$var$Pr) : d instanceof $e833773b1f4e7d0f$var$Re ? (l.addBox(new $e833773b1f4e7d0f$var$tn), d instanceof $e833773b1f4e7d0f$var$Zr && (d.namespace = t.namespace || "nonamespace", d.schema_location = t.schema_location || "", d.auxiliary_mime_types = t.auxiliary_mime_types || "")) : d instanceof $e833773b1f4e7d0f$var$Ye ? l.addBox(new $e833773b1f4e7d0f$var$Kt) : d instanceof $e833773b1f4e7d0f$var$os ? l.addBox(new $e833773b1f4e7d0f$var$Kt) : l.addBox(new $e833773b1f4e7d0f$var$Kt);
        t.description && d.addBox.call(d, t.description), t.description_boxes && t.description_boxes.forEach(function(P) {
            d.addBox.call(d, P);
        });
        let p = l.addBox(new $e833773b1f4e7d0f$var$Mr).addBox(new $e833773b1f4e7d0f$var$zr), f = new $e833773b1f4e7d0f$var$dn;
        f.flags = 1, p.addEntry(f);
        let _ = l.addBox(new $e833773b1f4e7d0f$var$Or);
        _.addBox(new $e833773b1f4e7d0f$var$rn).addEntry(d);
        let b = _.addBox(new $e833773b1f4e7d0f$var$an);
        b.sample_counts = [], b.sample_deltas = [];
        let S = _.addBox(new $e833773b1f4e7d0f$var$sn);
        S.first_chunk = [], S.samples_per_chunk = [], S.sample_description_index = [];
        let C = _.addBox(new $e833773b1f4e7d0f$var$en);
        C.chunk_offsets = [];
        let j = _.addBox(new $e833773b1f4e7d0f$var$nn);
        j.sample_sizes = [];
        let N = this.moov.mvex.addBox(new $e833773b1f4e7d0f$var$rs);
        return N.track_id = t.id, N.default_sample_description_index = t.default_sample_description_index || 1, N.default_sample_duration = t.default_sample_duration || 0, N.default_sample_size = t.default_sample_size || 0, N.default_sample_flags = t.default_sample_flags || 0, this.buildTrakSampleLists(s), t.id;
    }
    addSample(e, t, { sample_description_index: s, duration: r = 1, cts: n = 0, dts: a = 0, is_sync: o = !1, is_leading: u = 0, depends_on: l = 0, is_depended_on: h = 0, has_redundancy: d = 0, degradation_priority: c = 0, subsamples: p, offset: f = 0 } = {}) {
        let _ = this.getTrackById(e);
        if (_ === void 0) return;
        let m = s ? s - 1 : 0, b = {
            number: _.samples.length,
            track_id: _.tkhd.track_id,
            timescale: _.mdia.mdhd.timescale,
            description_index: m,
            description: _.mdia.minf.stbl.stsd.entries[m],
            data: t,
            size: t.byteLength,
            alreadyRead: t.byteLength,
            duration: r,
            cts: n,
            dts: a,
            is_sync: o,
            is_leading: u,
            depends_on: l,
            is_depended_on: h,
            has_redundancy: d,
            degradation_priority: c,
            offset: f,
            subsamples: p
        };
        _.samples.push(b), _.samples_size += b.size, _.samples_duration += b.duration, _.first_dts === void 0 && (_.first_dts = a), this.processSamples();
        let S = this.addBox(this.createMoof([
            b
        ]));
        S.computeSize(), S.trafs[0].truns[0].data_offset = S.size + 8;
        let C = this.addBox(new $e833773b1f4e7d0f$var$Xt);
        return C.data = new Uint8Array(t), b;
    }
    createMoof(e) {
        if (e.length === 0) return;
        if (e.some((h)=>h.track_id !== e[0].track_id)) throw new Error("Cannot create moof for samples from different tracks: " + e.map((h)=>h.track_id).join(", "));
        let t = e[0].track_id, s = this.getTrackById(t);
        if (!s) throw new Error("Cannot create moof for non-existing track: " + t);
        let r = new $e833773b1f4e7d0f$var$Lr, n = r.addBox(new $e833773b1f4e7d0f$var$Xr);
        n.sequence_number = ++this.nextMoofNumber;
        let a = r.addBox(new $e833773b1f4e7d0f$var$Nr), o = a.addBox(new $e833773b1f4e7d0f$var$un);
        o.track_id = t, o.flags = $e833773b1f4e7d0f$var$vr;
        let u = a.addBox(new $e833773b1f4e7d0f$var$on);
        u.baseMediaDecodeTime = e[0].dts - (s.first_dts || 0);
        let l = a.addBox(new $e833773b1f4e7d0f$var$hn);
        l.flags = $e833773b1f4e7d0f$var$ot | $e833773b1f4e7d0f$var$ut | $e833773b1f4e7d0f$var$lt | $e833773b1f4e7d0f$var$ht | $e833773b1f4e7d0f$var$dt, l.data_offset = 0, l.first_sample_flags = 0, l.sample_count = e.length;
        for (let h of e){
            let d = 0;
            h.is_sync ? d = 33554432 : d = 65536, l.sample_duration.push(h.duration), l.sample_size.push(h.size), l.sample_flags.push(d), l.sample_composition_time_offset.push(h.cts - h.dts);
        }
        return r;
    }
    print(e) {
        e.indent = "";
        for(let t = 0; t < this.boxes.length; t++)this.boxes[t] && this.boxes[t].print(e);
    }
};
function $e833773b1f4e7d0f$var$ti(i = !1, e) {
    return new $e833773b1f4e7d0f$var$ft(e, !i);
}
var $e833773b1f4e7d0f$var$fn = {};
$e833773b1f4e7d0f$var$Ir($e833773b1f4e7d0f$var$fn, {
    Descriptor: ()=>$e833773b1f4e7d0f$var$Fe,
    ES_Descriptor: ()=>$e833773b1f4e7d0f$var$_n,
    MPEG4DescriptorParser: ()=>$e833773b1f4e7d0f$var$id
});
var $e833773b1f4e7d0f$var$pn = 3, $e833773b1f4e7d0f$var$Zt = 4, $e833773b1f4e7d0f$var$us = 5, $e833773b1f4e7d0f$var$mn = 6, $e833773b1f4e7d0f$var$Fe = class gn {
    constructor(e, t){
        this.tag = e, this.size = t, this.descs = [];
    }
    parse(e) {
        this.data = e.readUint8Array(this.size);
    }
    findDescriptor(e) {
        for(let t = 0; t < this.descs.length; t++)if (this.descs[t].tag === e) return this.descs[t];
    }
    parseOneDescriptor(e) {
        let t = 0, s = e.readUint8(), r = e.readUint8();
        for(; r & 128;)t = (t << 7) + (r & 127), r = e.readUint8();
        t = (t << 7) + (r & 127), $e833773b1f4e7d0f$var$g.debug("Descriptor", "Found " + ($e833773b1f4e7d0f$var$$t[s] || "Descriptor " + s) + ", size " + t + " at position " + e.getPosition());
        let n = $e833773b1f4e7d0f$var$$t[s] ? new $e833773b1f4e7d0f$var$td[$e833773b1f4e7d0f$var$$t[s]](t) : new gn(t);
        return n.parse(e), n;
    }
    parseRemainingDescriptors(e) {
        let t = e.getPosition();
        for(; e.getPosition() < t + this.size;){
            let s = this.parseOneDescriptor?.(e);
            this.descs.push(s);
        }
    }
}, $e833773b1f4e7d0f$var$_n = class extends $e833773b1f4e7d0f$var$Fe {
    constructor(i){
        super($e833773b1f4e7d0f$var$pn, i);
    }
    parse(i) {
        if (this.ES_ID = i.readUint16(), this.flags = i.readUint8(), this.size -= 3, this.flags & 128 ? (this.dependsOn_ES_ID = i.readUint16(), this.size -= 2) : this.dependsOn_ES_ID = 0, this.flags & 64) {
            let e = i.readUint8();
            this.URL = i.readString(e), this.size -= e + 1;
        } else this.URL = "";
        this.flags & 32 ? (this.OCR_ES_ID = i.readUint16(), this.size -= 2) : this.OCR_ES_ID = 0, this.parseRemainingDescriptors(i);
    }
    getOTI() {
        let i = this.findDescriptor($e833773b1f4e7d0f$var$Zt);
        return i ? i.oti : 0;
    }
    getAudioConfig() {
        let i = this.findDescriptor($e833773b1f4e7d0f$var$Zt);
        if (!i) return;
        let e = i.findDescriptor($e833773b1f4e7d0f$var$us);
        if (e && e.data) {
            let t = (e.data[0] & 248) >> 3;
            return t === 31 && e.data.length >= 2 && (t = 32 + ((e.data[0] & 7) << 3) + ((e.data[1] & 224) >> 5)), t;
        }
    }
}, $e833773b1f4e7d0f$var$Zh = class extends $e833773b1f4e7d0f$var$Fe {
    constructor(i){
        super($e833773b1f4e7d0f$var$Zt, i);
    }
    parse(i) {
        this.oti = i.readUint8(), this.streamType = i.readUint8(), this.upStream = (this.streamType >> 1 & 1) !== 0, this.streamType = this.streamType >>> 2, this.bufferSize = i.readUint24(), this.maxBitrate = i.readUint32(), this.avgBitrate = i.readUint32(), this.size -= 13, this.parseRemainingDescriptors(i);
    }
}, $e833773b1f4e7d0f$var$Jh = class extends $e833773b1f4e7d0f$var$Fe {
    constructor(i){
        super($e833773b1f4e7d0f$var$us, i);
    }
}, $e833773b1f4e7d0f$var$ed = class extends $e833773b1f4e7d0f$var$Fe {
    constructor(i){
        super($e833773b1f4e7d0f$var$mn, i);
    }
}, $e833773b1f4e7d0f$var$td = {
    Descriptor: $e833773b1f4e7d0f$var$Fe,
    ES_Descriptor: $e833773b1f4e7d0f$var$_n,
    DecoderConfigDescriptor: $e833773b1f4e7d0f$var$Zh,
    DecoderSpecificInfo: $e833773b1f4e7d0f$var$Jh,
    SLConfigDescriptor: $e833773b1f4e7d0f$var$ed
}, $e833773b1f4e7d0f$var$$t = {
    [$e833773b1f4e7d0f$var$pn]: "ES_Descriptor",
    [$e833773b1f4e7d0f$var$Zt]: "DecoderConfigDescriptor",
    [$e833773b1f4e7d0f$var$us]: "DecoderSpecificInfo",
    [$e833773b1f4e7d0f$var$mn]: "SLConfigDescriptor"
}, $e833773b1f4e7d0f$var$id = class {
    constructor(){
        this.parseOneDescriptor = $e833773b1f4e7d0f$var$Fe.prototype.parseOneDescriptor;
    }
    getDescriptorName(i) {
        return $e833773b1f4e7d0f$var$$t[i];
    }
}, $e833773b1f4e7d0f$var$xn = class {
    parseSample(i) {
        let e = [], t = new $e833773b1f4e7d0f$var$ct($e833773b1f4e7d0f$var$$.fromArrayBuffer(i.buffer, 0));
        for(; !t.isEof();){
            let s = $e833773b1f4e7d0f$var$oe(t, !1);
            s.code === $e833773b1f4e7d0f$var$J && s.box?.type === "vttc" && e.push(s.box);
        }
        return e;
    }
    getText(i, e, t) {
        function s(o, u) {
            let l = o.toString();
            return l.length >= u ? l : new Array(u - l.length + 1).join("0") + l;
        }
        function r(o) {
            let u = Math.floor(o / 3600), l = Math.floor((o - u * 3600) / 60), h = Math.floor(o - u * 3600 - l * 60), d = Math.floor((o - u * 3600 - l * 60 - h) * 1e3);
            return "" + s(u, 2) + ":" + s(l, 2) + ":" + s(h, 2) + "." + s(d, 3);
        }
        let n = this.parseSample(t), a = "";
        for(let o = 0; o < n.length; o++){
            let u = n[o];
            a += r(i) + " --> " + r(e) + `\r
`, a += u.payl.text;
        }
        return a;
    }
}, $e833773b1f4e7d0f$var$yn = class {
    parseSample(i) {
        let e = {
            resources: [],
            documentString: "",
            document: void 0
        }, t = new $e833773b1f4e7d0f$var$V(i.data.buffer);
        if (!i.subsamples || i.subsamples.length === 0) e.documentString = t.readString(i.data.length);
        else if (e.documentString = t.readString(i.subsamples[0].size), i.subsamples.length > 1) for(let s = 1; s < i.subsamples.length; s++)e.resources[s] = t.readUint8Array(i.subsamples[s].size);
        return typeof DOMParser < "u" && (e.document = new DOMParser().parseFromString(e.documentString, "application/xml")), e;
    }
}, $e833773b1f4e7d0f$var$vn = class {
    parseSample(i) {
        return new $e833773b1f4e7d0f$var$V(i.data.buffer).readString(i.data.length);
    }
    parseConfig(i) {
        let e = new $e833773b1f4e7d0f$var$V(i.buffer);
        return e.readUint32(), e.readCString();
    }
}, $e833773b1f4e7d0f$var$bn = class {
    parseSample(i) {
        let e = new $e833773b1f4e7d0f$var$V(i.data.buffer), t = e.readUint16();
        if (t !== 0) return e.readString(t);
    }
}, $e833773b1f4e7d0f$var$Sn = {};
$e833773b1f4e7d0f$var$Ir($e833773b1f4e7d0f$var$Sn, {
    CoLLBox: ()=>$e833773b1f4e7d0f$var$md,
    ItemContentIDPropertyBox: ()=>$e833773b1f4e7d0f$var$Wf,
    OpusSampleEntry: ()=>$e833773b1f4e7d0f$var$Ah,
    SmDmBox: ()=>$e833773b1f4e7d0f$var$Gc,
    a1lxBox: ()=>$e833773b1f4e7d0f$var$sd,
    a1opBox: ()=>$e833773b1f4e7d0f$var$rd,
    ac_3SampleEntry: ()=>$e833773b1f4e7d0f$var$Ih,
    ac_4SampleEntry: ()=>$e833773b1f4e7d0f$var$Ch,
    aebrBox: ()=>$e833773b1f4e7d0f$var$kd,
    afbrBox: ()=>$e833773b1f4e7d0f$var$Rd,
    albcBox: ()=>$e833773b1f4e7d0f$var$Fd,
    alstSampleGroupEntry: ()=>$e833773b1f4e7d0f$var$vf,
    altrBox: ()=>$e833773b1f4e7d0f$var$Md,
    auxCBox: ()=>$e833773b1f4e7d0f$var$nd,
    av01SampleEntry: ()=>$e833773b1f4e7d0f$var$ih,
    av1CBox: ()=>$e833773b1f4e7d0f$var$jl,
    avc1SampleEntry: ()=>$e833773b1f4e7d0f$var$Zl,
    avc2SampleEntry: ()=>$e833773b1f4e7d0f$var$Jl,
    avc3SampleEntry: ()=>$e833773b1f4e7d0f$var$eh,
    avc4SampleEntry: ()=>$e833773b1f4e7d0f$var$th,
    avcCBox: ()=>$e833773b1f4e7d0f$var$Dr,
    avllSampleGroupEntry: ()=>$e833773b1f4e7d0f$var$bf,
    avs3SampleEntry: ()=>$e833773b1f4e7d0f$var$yh,
    avssSampleGroupEntry: ()=>$e833773b1f4e7d0f$var$Sf,
    brstBox: ()=>$e833773b1f4e7d0f$var$Od,
    btrtBox: ()=>$e833773b1f4e7d0f$var$ad,
    bxmlBox: ()=>$e833773b1f4e7d0f$var$_l,
    ccstBox: ()=>$e833773b1f4e7d0f$var$od,
    cdefBox: ()=>$e833773b1f4e7d0f$var$ud,
    clapBox: ()=>$e833773b1f4e7d0f$var$ld,
    clefBox: ()=>$e833773b1f4e7d0f$var$Uc,
    clliBox: ()=>$e833773b1f4e7d0f$var$hd,
    cmexBox: ()=>$e833773b1f4e7d0f$var$dd,
    cminBox: ()=>$e833773b1f4e7d0f$var$cd,
    cmpdBox: ()=>$e833773b1f4e7d0f$var$fd,
    co64Box: ()=>$e833773b1f4e7d0f$var$pd,
    colrBox: ()=>$e833773b1f4e7d0f$var$Ql,
    coviBox: ()=>$e833773b1f4e7d0f$var$xd,
    cprtBox: ()=>$e833773b1f4e7d0f$var$yd,
    cschBox: ()=>$e833773b1f4e7d0f$var$vd,
    cslgBox: ()=>$e833773b1f4e7d0f$var$bd,
    cttsBox: ()=>$e833773b1f4e7d0f$var$Sd,
    dOpsBox: ()=>$e833773b1f4e7d0f$var$Bd,
    dac3Box: ()=>$e833773b1f4e7d0f$var$Td,
    dataBox: ()=>$e833773b1f4e7d0f$var$at,
    dav1SampleEntry: ()=>$e833773b1f4e7d0f$var$sh,
    dec3Box: ()=>$e833773b1f4e7d0f$var$wd,
    dfLaBox: ()=>$e833773b1f4e7d0f$var$Ud,
    dimmBox: ()=>$e833773b1f4e7d0f$var$Ed,
    dinfBox: ()=>$e833773b1f4e7d0f$var$Mr,
    dmax: ()=>$e833773b1f4e7d0f$var$Id,
    dmedBox: ()=>$e833773b1f4e7d0f$var$Cd,
    dobrBox: ()=>$e833773b1f4e7d0f$var$Ld,
    drefBox: ()=>$e833773b1f4e7d0f$var$zr,
    drepBox: ()=>$e833773b1f4e7d0f$var$Ad,
    dtrtSampleGroupEntry: ()=>$e833773b1f4e7d0f$var$Tf,
    dvh1SampleEntry: ()=>$e833773b1f4e7d0f$var$dh,
    dvheSampleEntry: ()=>$e833773b1f4e7d0f$var$ch,
    ec_3SampleEntry: ()=>$e833773b1f4e7d0f$var$Bh,
    edtsBox: ()=>$e833773b1f4e7d0f$var$yl,
    elngBox: ()=>$e833773b1f4e7d0f$var$Gr,
    elstBox: ()=>$e833773b1f4e7d0f$var$Dd,
    emsgBox: ()=>$e833773b1f4e7d0f$var$Pd,
    encaSampleEntry: ()=>$e833773b1f4e7d0f$var$Oh,
    encmSampleEntry: ()=>$e833773b1f4e7d0f$var$Vh,
    encsSampleEntry: ()=>$e833773b1f4e7d0f$var$Nh,
    enctSampleEntry: ()=>$e833773b1f4e7d0f$var$Gh,
    encuSampleEntry: ()=>$e833773b1f4e7d0f$var$Lh,
    encvSampleEntry: ()=>$e833773b1f4e7d0f$var$Mh,
    enofBox: ()=>$e833773b1f4e7d0f$var$Ic,
    eqivBox: ()=>$e833773b1f4e7d0f$var$Nd,
    esdsBox: ()=>$e833773b1f4e7d0f$var$Xl,
    etypBox: ()=>$e833773b1f4e7d0f$var$Ml,
    fLaCSampleEntry: ()=>$e833773b1f4e7d0f$var$Fh,
    favcBox: ()=>$e833773b1f4e7d0f$var$zd,
    fielBox: ()=>$e833773b1f4e7d0f$var$$d,
    fobrBox: ()=>$e833773b1f4e7d0f$var$Gd,
    freeBox: ()=>$e833773b1f4e7d0f$var$fl,
    frmaBox: ()=>$e833773b1f4e7d0f$var$Qd,
    ftypBox: ()=>$e833773b1f4e7d0f$var$Vr,
    grplBox: ()=>$e833773b1f4e7d0f$var$Rl,
    hdlrBox: ()=>$e833773b1f4e7d0f$var$Hr,
    hev1SampleEntry: ()=>$e833773b1f4e7d0f$var$ah,
    hev2SampleEntry: ()=>$e833773b1f4e7d0f$var$oh,
    hinfBox: ()=>$e833773b1f4e7d0f$var$wl,
    hmhdBox: ()=>$e833773b1f4e7d0f$var$Pr,
    hntiBox: ()=>$e833773b1f4e7d0f$var$Tl,
    hvc1SampleEntry: ()=>$e833773b1f4e7d0f$var$rh,
    hvc2SampleEntry: ()=>$e833773b1f4e7d0f$var$nh,
    hvcCBox: ()=>$e833773b1f4e7d0f$var$qr,
    hvt1SampleEntry: ()=>$e833773b1f4e7d0f$var$uh,
    iaugBox: ()=>$e833773b1f4e7d0f$var$Vd,
    idatBox: ()=>$e833773b1f4e7d0f$var$cl,
    iinfBox: ()=>$e833773b1f4e7d0f$var$Nl,
    ilocBox: ()=>$e833773b1f4e7d0f$var$zl,
    ilstBox: ()=>$e833773b1f4e7d0f$var$Cc,
    imirBox: ()=>$e833773b1f4e7d0f$var$Zd,
    infeBox: ()=>$e833773b1f4e7d0f$var$Ll,
    iodsBox: ()=>$e833773b1f4e7d0f$var$ml,
    ipcoBox: ()=>$e833773b1f4e7d0f$var$kl,
    ipmaBox: ()=>$e833773b1f4e7d0f$var$Jd,
    iproBox: ()=>$e833773b1f4e7d0f$var$xl,
    iprpBox: ()=>$e833773b1f4e7d0f$var$Pl,
    irefBox: ()=>$e833773b1f4e7d0f$var$Vl,
    irotBox: ()=>$e833773b1f4e7d0f$var$ec,
    ispeBox: ()=>$e833773b1f4e7d0f$var$tc,
    itaiBox: ()=>$e833773b1f4e7d0f$var$ic,
    j2kHBox: ()=>$e833773b1f4e7d0f$var$Fl,
    j2kiSampleEntry: ()=>$e833773b1f4e7d0f$var$vh,
    keysBox: ()=>$e833773b1f4e7d0f$var$Bc,
    kindBox: ()=>$e833773b1f4e7d0f$var$sc,
    levaBox: ()=>$e833773b1f4e7d0f$var$rc,
    lhe1SampleEntry: ()=>$e833773b1f4e7d0f$var$lh,
    lhv1SampleEntry: ()=>$e833773b1f4e7d0f$var$hh,
    lhvCBox: ()=>$e833773b1f4e7d0f$var$nc,
    lselBox: ()=>$e833773b1f4e7d0f$var$ac,
    m4aeSampleEntry: ()=>$e833773b1f4e7d0f$var$Eh,
    maxrBox: ()=>$e833773b1f4e7d0f$var$oc,
    mdatBox: ()=>$e833773b1f4e7d0f$var$Xt,
    mdcvBox: ()=>$e833773b1f4e7d0f$var$uc,
    mdhdBox: ()=>$e833773b1f4e7d0f$var$Wr,
    mdiaBox: ()=>$e833773b1f4e7d0f$var$Rr,
    mecoBox: ()=>$e833773b1f4e7d0f$var$Sl,
    mehdBox: ()=>$e833773b1f4e7d0f$var$Yr,
    metaBox: ()=>$e833773b1f4e7d0f$var$ql,
    mettSampleEntry: ()=>$e833773b1f4e7d0f$var$Wl,
    metxSampleEntry: ()=>$e833773b1f4e7d0f$var$Yl,
    mfhdBox: ()=>$e833773b1f4e7d0f$var$Xr,
    mfraBox: ()=>$e833773b1f4e7d0f$var$bl,
    mfroBox: ()=>$e833773b1f4e7d0f$var$lc,
    mha1SampleEntry: ()=>$e833773b1f4e7d0f$var$Dh,
    mha2SampleEntry: ()=>$e833773b1f4e7d0f$var$Ph,
    mhm1SampleEntry: ()=>$e833773b1f4e7d0f$var$kh,
    mhm2SampleEntry: ()=>$e833773b1f4e7d0f$var$Rh,
    minfBox: ()=>$e833773b1f4e7d0f$var$Fr,
    mjp2SampleEntry: ()=>$e833773b1f4e7d0f$var$bh,
    mjpgSampleEntry: ()=>$e833773b1f4e7d0f$var$Sh,
    moofBox: ()=>$e833773b1f4e7d0f$var$Lr,
    moovBox: ()=>$e833773b1f4e7d0f$var$is,
    mp4aSampleEntry: ()=>$e833773b1f4e7d0f$var$Uh,
    mp4sSampleEntry: ()=>$e833773b1f4e7d0f$var$zh,
    mp4vSampleEntry: ()=>$e833773b1f4e7d0f$var$wh,
    mskCBox: ()=>$e833773b1f4e7d0f$var$hc,
    msrcTrackGroupTypeBox: ()=>$e833773b1f4e7d0f$var$uf,
    mvexBox: ()=>$e833773b1f4e7d0f$var$ss,
    mvhdBox: ()=>$e833773b1f4e7d0f$var$Kr,
    mvifSampleGroupEntry: ()=>$e833773b1f4e7d0f$var$wf,
    nmhdBox: ()=>$e833773b1f4e7d0f$var$Kt,
    npckBox: ()=>$e833773b1f4e7d0f$var$dc,
    numpBox: ()=>$e833773b1f4e7d0f$var$cc,
    padbBox: ()=>$e833773b1f4e7d0f$var$pc,
    panoBox: ()=>$e833773b1f4e7d0f$var$Hd,
    paspBox: ()=>$e833773b1f4e7d0f$var$mc,
    paylBox: ()=>$e833773b1f4e7d0f$var$gc,
    paytBox: ()=>$e833773b1f4e7d0f$var$_c,
    pdinBox: ()=>$e833773b1f4e7d0f$var$xc,
    piffLsmBox: ()=>$e833773b1f4e7d0f$var$Nf,
    piffPsshBox: ()=>$e833773b1f4e7d0f$var$zf,
    piffSencBox: ()=>$e833773b1f4e7d0f$var$Gf,
    piffTencBox: ()=>$e833773b1f4e7d0f$var$Vf,
    piffTfrfBox: ()=>$e833773b1f4e7d0f$var$Hf,
    piffTfxdBox: ()=>$e833773b1f4e7d0f$var$qf,
    pitmBox: ()=>$e833773b1f4e7d0f$var$Hl,
    pixiBox: ()=>$e833773b1f4e7d0f$var$yc,
    pmaxBox: ()=>$e833773b1f4e7d0f$var$vc,
    povdBox: ()=>$e833773b1f4e7d0f$var$Ol,
    prdiBox: ()=>$e833773b1f4e7d0f$var$bc,
    prfrBox: ()=>$e833773b1f4e7d0f$var$Sc,
    prftBox: ()=>$e833773b1f4e7d0f$var$Tc,
    prgrBox: ()=>$e833773b1f4e7d0f$var$Xd,
    profBox: ()=>$e833773b1f4e7d0f$var$Ac,
    prolSampleGroupEntry: ()=>$e833773b1f4e7d0f$var$Uf,
    psshBox: ()=>$e833773b1f4e7d0f$var$wc,
    pymdBox: ()=>$e833773b1f4e7d0f$var$Kd,
    rapSampleGroupEntry: ()=>$e833773b1f4e7d0f$var$Ef,
    rashSampleGroupEntry: ()=>$e833773b1f4e7d0f$var$If,
    resvSampleEntry: ()=>$e833773b1f4e7d0f$var$Hh,
    rinfBox: ()=>$e833773b1f4e7d0f$var$Cl,
    rollSampleGroupEntry: ()=>$e833773b1f4e7d0f$var$Cf,
    rtp_Box: ()=>$e833773b1f4e7d0f$var$kc,
    saioBox: ()=>$e833773b1f4e7d0f$var$Rc,
    saizBox: ()=>$e833773b1f4e7d0f$var$Fc,
    sbgpBox: ()=>$e833773b1f4e7d0f$var$Xh,
    sbpmBox: ()=>$e833773b1f4e7d0f$var$Oc,
    sbttSampleEntry: ()=>$e833773b1f4e7d0f$var$qh,
    schiBox: ()=>$e833773b1f4e7d0f$var$Bl,
    schmBox: ()=>$e833773b1f4e7d0f$var$Lc,
    scifSampleGroupEntry: ()=>$e833773b1f4e7d0f$var$Bf,
    scnmSampleGroupEntry: ()=>$e833773b1f4e7d0f$var$Af,
    sdp_Box: ()=>$e833773b1f4e7d0f$var$Nc,
    sdtpBox: ()=>$e833773b1f4e7d0f$var$Kh,
    seigSampleGroupEntry: ()=>$e833773b1f4e7d0f$var$Df,
    sencBox: ()=>$e833773b1f4e7d0f$var$zc,
    sgpdBox: ()=>$e833773b1f4e7d0f$var$$h,
    sidxBox: ()=>$e833773b1f4e7d0f$var$Qh,
    sinfBox: ()=>$e833773b1f4e7d0f$var$Il,
    skipBox: ()=>$e833773b1f4e7d0f$var$pl,
    slidBox: ()=>$e833773b1f4e7d0f$var$qd,
    smhdBox: ()=>$e833773b1f4e7d0f$var$Jr,
    sratBox: ()=>$e833773b1f4e7d0f$var$Vc,
    ssixBox: ()=>$e833773b1f4e7d0f$var$Hc,
    stblBox: ()=>$e833773b1f4e7d0f$var$Or,
    stcoBox: ()=>$e833773b1f4e7d0f$var$en,
    stdpBox: ()=>$e833773b1f4e7d0f$var$qc,
    sterBox: ()=>$e833773b1f4e7d0f$var$Wd,
    sthdBox: ()=>$e833773b1f4e7d0f$var$tn,
    stppSampleEntry: ()=>$e833773b1f4e7d0f$var$Zr,
    strdBox: ()=>$e833773b1f4e7d0f$var$El,
    striBox: ()=>$e833773b1f4e7d0f$var$Wc,
    strkBox: ()=>$e833773b1f4e7d0f$var$Ul,
    stsaSampleGroupEntry: ()=>$e833773b1f4e7d0f$var$Pf,
    stscBox: ()=>$e833773b1f4e7d0f$var$sn,
    stsdBox: ()=>$e833773b1f4e7d0f$var$rn,
    stsgBox: ()=>$e833773b1f4e7d0f$var$Yc,
    stshBox: ()=>$e833773b1f4e7d0f$var$jc,
    stssBox: ()=>$e833773b1f4e7d0f$var$Xc,
    stszBox: ()=>$e833773b1f4e7d0f$var$nn,
    sttsBox: ()=>$e833773b1f4e7d0f$var$an,
    stviBox: ()=>$e833773b1f4e7d0f$var$Kc,
    stxtSampleEntry: ()=>$e833773b1f4e7d0f$var$Wh,
    stypBox: ()=>$e833773b1f4e7d0f$var$$c,
    stz2Box: ()=>$e833773b1f4e7d0f$var$Qc,
    subsBox: ()=>$e833773b1f4e7d0f$var$Zc,
    syncSampleGroupEntry: ()=>$e833773b1f4e7d0f$var$kf,
    taicBox: ()=>$e833773b1f4e7d0f$var$Jc,
    taptBox: ()=>$e833773b1f4e7d0f$var$Dc,
    teleSampleGroupEntry: ()=>$e833773b1f4e7d0f$var$Rf,
    tencBox: ()=>$e833773b1f4e7d0f$var$ef,
    tfdtBox: ()=>$e833773b1f4e7d0f$var$on,
    tfhdBox: ()=>$e833773b1f4e7d0f$var$un,
    tfraBox: ()=>$e833773b1f4e7d0f$var$tf,
    tkhdBox: ()=>$e833773b1f4e7d0f$var$ln,
    tmaxBox: ()=>$e833773b1f4e7d0f$var$sf,
    tminBox: ()=>$e833773b1f4e7d0f$var$rf,
    totlBox: ()=>$e833773b1f4e7d0f$var$nf,
    tpayBox: ()=>$e833773b1f4e7d0f$var$af,
    tpylBox: ()=>$e833773b1f4e7d0f$var$of,
    trafBox: ()=>$e833773b1f4e7d0f$var$Nr,
    trakBox: ()=>$e833773b1f4e7d0f$var$kr,
    trefBox: ()=>$e833773b1f4e7d0f$var$lf,
    trepBox: ()=>$e833773b1f4e7d0f$var$hf,
    trexBox: ()=>$e833773b1f4e7d0f$var$rs,
    trgrBox: ()=>$e833773b1f4e7d0f$var$Al,
    trpyBox: ()=>$e833773b1f4e7d0f$var$df,
    trunBox: ()=>$e833773b1f4e7d0f$var$hn,
    tsasSampleGroupEntry: ()=>$e833773b1f4e7d0f$var$Ff,
    tsclSampleGroupEntry: ()=>$e833773b1f4e7d0f$var$Mf,
    tselBox: ()=>$e833773b1f4e7d0f$var$cf,
    tsynBox: ()=>$e833773b1f4e7d0f$var$Yd,
    tx3gSampleEntry: ()=>$e833773b1f4e7d0f$var$Yh,
    txtcBox: ()=>$e833773b1f4e7d0f$var$ff,
    tycoBox: ()=>$e833773b1f4e7d0f$var$pf,
    udesBox: ()=>$e833773b1f4e7d0f$var$mf,
    udtaBox: ()=>$e833773b1f4e7d0f$var$Dl,
    uncCBox: ()=>$e833773b1f4e7d0f$var$gf,
    uncvSampleEntry: ()=>$e833773b1f4e7d0f$var$Th,
    urlBox: ()=>$e833773b1f4e7d0f$var$dn,
    urnBox: ()=>$e833773b1f4e7d0f$var$_f,
    viprSampleGroupEntry: ()=>$e833773b1f4e7d0f$var$Of,
    vmhdBox: ()=>$e833773b1f4e7d0f$var$cn,
    vp08SampleEntry: ()=>$e833773b1f4e7d0f$var$_h,
    vp09SampleEntry: ()=>$e833773b1f4e7d0f$var$xh,
    vpcCBox: ()=>$e833773b1f4e7d0f$var$Kl,
    vttCBox: ()=>$e833773b1f4e7d0f$var$xf,
    vttcBox: ()=>$e833773b1f4e7d0f$var$vl,
    vvc1SampleEntry: ()=>$e833773b1f4e7d0f$var$fh,
    vvcCBox: ()=>$e833773b1f4e7d0f$var$$l,
    vvcNSampleEntry: ()=>$e833773b1f4e7d0f$var$gh,
    vvi1SampleEntry: ()=>$e833773b1f4e7d0f$var$ph,
    vvnCBox: ()=>$e833773b1f4e7d0f$var$yf,
    vvs1SampleEntry: ()=>$e833773b1f4e7d0f$var$mh,
    waveBox: ()=>$e833773b1f4e7d0f$var$Pc,
    wbbrBox: ()=>$e833773b1f4e7d0f$var$jd,
    wvttSampleEntry: ()=>$e833773b1f4e7d0f$var$jh,
    xmlBox: ()=>$e833773b1f4e7d0f$var$gl
});
var $e833773b1f4e7d0f$var$sd = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "AV1LayeredImageIndexingProperty";
    }
    static{
        this.fourcc = "a1lx";
    }
    parse(i) {
        let t = ((i.readUint8() & 1) + 1) * 16;
        this.layer_size = [];
        for(let s = 0; s < 3; s++)t === 16 ? this.layer_size[s] = i.readUint16() : this.layer_size[s] = i.readUint32();
    }
}, $e833773b1f4e7d0f$var$rd = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "OperatingPointSelectorProperty";
    }
    static{
        this.fourcc = "a1op";
    }
    parse(i) {
        this.op_index = i.readUint8();
    }
}, $e833773b1f4e7d0f$var$nd = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "AuxiliaryTypeProperty";
    }
    static{
        this.fourcc = "auxC";
    }
    parse(i) {
        this.parseFullHeader(i), this.aux_type = i.readCString();
        let e = this.size - this.hdr_size - (this.aux_type.length + 1);
        this.aux_subtype = i.readUint8Array(e);
    }
}, $e833773b1f4e7d0f$var$ad = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "BitRateBox";
    }
    static{
        this.fourcc = "btrt";
    }
    parse(i) {
        this.bufferSizeDB = i.readUint32(), this.maxBitrate = i.readUint32(), this.avgBitrate = i.readUint32();
    }
}, $e833773b1f4e7d0f$var$od = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "CodingConstraintsBox";
    }
    static{
        this.fourcc = "ccst";
    }
    parse(i) {
        this.parseFullHeader(i);
        let e = i.readUint8();
        this.all_ref_pics_intra = (e & 128) === 128, this.intra_pred_used = (e & 64) === 64, this.max_ref_per_pic = (e & 63) >> 2, i.readUint24();
    }
}, $e833773b1f4e7d0f$var$ud = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "ComponentDefinitionBox";
    }
    static{
        this.fourcc = "cdef";
    }
    parse(i) {
        this.channel_count = i.readUint16(), this.channel_indexes = [], this.channel_types = [], this.channel_associations = [];
        for(let e = 0; e < this.channel_count; e++)this.channel_indexes.push(i.readUint16()), this.channel_types.push(i.readUint16()), this.channel_associations.push(i.readUint16());
    }
}, $e833773b1f4e7d0f$var$ld = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "CleanApertureBox";
    }
    static{
        this.fourcc = "clap";
    }
    parse(i) {
        this.cleanApertureWidthN = i.readUint32(), this.cleanApertureWidthD = i.readUint32(), this.cleanApertureHeightN = i.readUint32(), this.cleanApertureHeightD = i.readUint32(), this.horizOffN = i.readUint32(), this.horizOffD = i.readUint32(), this.vertOffN = i.readUint32(), this.vertOffD = i.readUint32();
    }
}, $e833773b1f4e7d0f$var$hd = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "ContentLightLevelBox";
    }
    static{
        this.fourcc = "clli";
    }
    parse(i) {
        this.max_content_light_level = i.readUint16(), this.max_pic_average_light_level = i.readUint16();
    }
}, $e833773b1f4e7d0f$var$dd = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "CameraExtrinsicMatrixProperty";
    }
    static{
        this.fourcc = "cmex";
    }
    parse(i) {
        this.flags & 1 && (this.pos_x = i.readInt32()), this.flags & 2 && (this.pos_y = i.readInt32()), this.flags & 4 && (this.pos_z = i.readInt32()), this.flags & 8 && (this.version === 0 ? this.flags & 16 ? (this.quat_x = i.readInt32(), this.quat_y = i.readInt32(), this.quat_z = i.readInt32()) : (this.quat_x = i.readInt16(), this.quat_y = i.readInt16(), this.quat_z = i.readInt16()) : this.version), this.flags & 32 && (this.id = i.readUint32());
    }
}, $e833773b1f4e7d0f$var$cd = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "CameraIntrinsicMatrixProperty";
    }
    static{
        this.fourcc = "cmin";
    }
    parse(i) {
        this.focal_length_x = i.readInt32(), this.principal_point_x = i.readInt32(), this.principal_point_y = i.readInt32(), this.flags & 1 && (this.focal_length_y = i.readInt32(), this.skew_factor = i.readInt32());
    }
}, $e833773b1f4e7d0f$var$fd = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "ComponentDefinitionBox";
    }
    static{
        this.fourcc = "cmpd";
    }
    parse(i) {
        this.component_count = i.readUint32(), this.component_types = [], this.component_type_urls = [];
        for(let e = 0; e < this.component_count; e++){
            let t = i.readUint16();
            this.component_types.push(t), t >= 32768 && this.component_type_urls.push(i.readCString());
        }
    }
}, $e833773b1f4e7d0f$var$pd = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "ChunkLargeOffsetBox";
    }
    static{
        this.fourcc = "co64";
    }
    parse(i) {
        this.parseFullHeader(i);
        let e = i.readUint32();
        if (this.chunk_offsets = [], this.version === 0) for(let t = 0; t < e; t++)this.chunk_offsets.push(i.readUint64());
    }
    write(i) {
        this.version = 0, this.flags = 0, this.size = 4 + 8 * this.chunk_offsets.length, this.writeHeader(i), i.writeUint32(this.chunk_offsets.length);
        for(let e = 0; e < this.chunk_offsets.length; e++)i.writeUint64(this.chunk_offsets[e]);
    }
}, $e833773b1f4e7d0f$var$md = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "ContentLightLevelBox";
    }
    static{
        this.fourcc = "CoLL";
    }
    parse(i) {
        this.parseFullHeader(i), this.maxCLL = i.readUint16(), this.maxFALL = i.readUint16();
    }
}, $e833773b1f4e7d0f$var$gd = class {
    toString() {
        let i = "centre_azimuth: ";
        return i += this.centre_azimuth, i += " (", i += this.centre_azimuth * 2 ** -16, i += "\xB0), centre_elevation: ", i += this.centre_elevation, i += " (", i += this.centre_elevation * 2 ** -16, i += "\xB0), centre_tilt: ", i += this.centre_tilt, i += " (", i += this.centre_tilt * 2 ** -16, i += "\xB0)", this.range_included_flag && (i += ", azimuth_range: ", i += this.azimuth_range, i += " (", i += this.azimuth_range * 2 ** -16, i += "\xB0), elevation_range: ", i += this.elevation_range, i += " (", i += this.elevation_range * 2 ** -16, i += "\xB0)"), this.interpolate_included_flag && (i += ", interpolate: ", i += this.interpolate), i;
    }
}, $e833773b1f4e7d0f$var$_d = class {
    toString() {
        let i = "";
        return this.view_idc && (i += "view_idc: ", i += this.view_idc, i += ", "), i += "sphere_region: {", i += this.sphere_region, i += "}", i;
    }
}, $e833773b1f4e7d0f$var$xd = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "CoverageInformationBox";
    }
    static{
        this.fourcc = "covi";
    }
    parse(i) {
        this.parseFullHeader(i), this.coverage_shape_type = i.readUint8();
        let e = i.readUint8(), t = i.readInt8(), s = t & 128;
        s && (this.default_view_idc = (t & 96) >> 5), this.coverage_regions = new Array;
        for(let r = 0; r < e; r++){
            let n = new $e833773b1f4e7d0f$var$_d;
            s && (n.view_idc = i.readUint8() >> 6), n.sphere_region = this.parseSphereRegion(i, !0, !0), this.coverage_regions.push(n);
        }
    }
    parseSphereRegion(i, e, t) {
        let s = new $e833773b1f4e7d0f$var$gd;
        return s.centre_azimuth = i.readInt32(), s.centre_elevation = i.readInt32(), s.centre_tilt = i.readInt32(), s.range_included_flag = e, e && (s.azimuth_range = i.readUint32(), s.elevation_range = i.readUint32()), s.interpolate_included_flag = t, t && (s.interpolate = (i.readUint8() & 128) === 128), s;
    }
}, $e833773b1f4e7d0f$var$yd = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "CopyrightBox";
    }
    static{
        this.fourcc = "cprt";
    }
    parse(i) {
        this.parseFullHeader(i), this.parseLanguage(i), this.notice = i.readCString();
    }
}, $e833773b1f4e7d0f$var$vd = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "CompatibleSchemeTypeBox";
    }
    static{
        this.fourcc = "csch";
    }
    parse(i) {
        this.parseFullHeader(i), this.scheme_type = i.readString(4), this.scheme_version = i.readUint32(), this.flags & 1 && (this.scheme_uri = i.readCString());
    }
}, $e833773b1f4e7d0f$var$nt = 2147483647, $e833773b1f4e7d0f$var$bd = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "CompositionToDecodeBox";
    }
    static{
        this.fourcc = "cslg";
    }
    parse(i) {
        this.parseFullHeader(i), this.version === 0 ? (this.compositionToDTSShift = i.readInt32(), this.leastDecodeToDisplayDelta = i.readInt32(), this.greatestDecodeToDisplayDelta = i.readInt32(), this.compositionStartTime = i.readInt32(), this.compositionEndTime = i.readInt32()) : this.version === 1 && (this.compositionToDTSShift = i.readInt64(), this.leastDecodeToDisplayDelta = i.readInt64(), this.greatestDecodeToDisplayDelta = i.readInt64(), this.compositionStartTime = i.readInt64(), this.compositionEndTime = i.readInt64());
    }
    write(i) {
        this.version = 0, (this.compositionToDTSShift > $e833773b1f4e7d0f$var$nt || this.leastDecodeToDisplayDelta > $e833773b1f4e7d0f$var$nt || this.greatestDecodeToDisplayDelta > $e833773b1f4e7d0f$var$nt || this.compositionStartTime > $e833773b1f4e7d0f$var$nt || this.compositionEndTime > $e833773b1f4e7d0f$var$nt) && (this.version = 1), this.flags = 0, this.version === 0 ? (this.size = 20, this.writeHeader(i), i.writeInt32(this.compositionToDTSShift), i.writeInt32(this.leastDecodeToDisplayDelta), i.writeInt32(this.greatestDecodeToDisplayDelta), i.writeInt32(this.compositionStartTime), i.writeInt32(this.compositionEndTime)) : this.version === 1 && (this.size = 40, this.writeHeader(i), i.writeInt64(this.compositionToDTSShift), i.writeInt64(this.leastDecodeToDisplayDelta), i.writeInt64(this.greatestDecodeToDisplayDelta), i.writeInt64(this.compositionStartTime), i.writeInt64(this.compositionEndTime));
    }
}, $e833773b1f4e7d0f$var$Sd = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "CompositionOffsetBox";
    }
    static{
        this.fourcc = "ctts";
    }
    parse(i) {
        this.parseFullHeader(i);
        let e = i.readUint32();
        if (this.sample_counts = [], this.sample_offsets = [], this.version === 0) for(let t = 0; t < e; t++){
            this.sample_counts.push(i.readUint32());
            let s = i.readInt32();
            s < 0 && $e833773b1f4e7d0f$var$g.warn("BoxParser", "ctts box uses negative values without using version 1"), this.sample_offsets.push(s);
        }
        else if (this.version === 1) for(let t = 0; t < e; t++)this.sample_counts.push(i.readUint32()), this.sample_offsets.push(i.readInt32());
    }
    write(i) {
        this.version = this.sample_offsets.some((e)=>e < 0) ? 1 : 0, this.flags = 0, this.size = 4 + 8 * this.sample_counts.length, this.writeHeader(i), i.writeUint32(this.sample_counts.length);
        for(let e = 0; e < this.sample_counts.length; e++)i.writeUint32(this.sample_counts[e]), this.version === 1 ? i.writeInt32(this.sample_offsets[e]) : i.writeUint32(this.sample_offsets[e]);
    }
    unpack(i) {
        let e = 0;
        for(let t = 0; t < this.sample_counts.length; t++)for(let s = 0; s < this.sample_counts[t]; s++)i[e].pts = i[e].dts + this.sample_offsets[t], e++;
    }
}, $e833773b1f4e7d0f$var$Td = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "AC3SpecificBox";
    }
    static{
        this.fourcc = "dac3";
    }
    parse(i) {
        let e = i.readUint8(), t = i.readUint8(), s = i.readUint8();
        this.fscod = e >> 6, this.bsid = e >> 1 & 31, this.bsmod = (e & 1) << 2 | t >> 6 & 3, this.acmod = t >> 3 & 7, this.lfeon = t >> 2 & 1, this.bit_rate_code = t & 3 | s >> 5 & 7;
    }
}, $e833773b1f4e7d0f$var$wd = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "EC3SpecificBox";
    }
    static{
        this.fourcc = "dec3";
    }
    parse(i) {
        let e = i.readUint16();
        this.data_rate = e >> 3, this.num_ind_sub = e & 7, this.ind_subs = [];
        for(let t = 0; t < this.num_ind_sub + 1; t++){
            let s = i.readUint8(), r = i.readUint8(), n = i.readUint8(), a = {
                fscod: s >> 6,
                bsid: s >> 1 & 31,
                bsmod: (s & 1) << 4 | r >> 4 & 15,
                acmod: r >> 1 & 7,
                lfeon: r & 1,
                num_dep_sub: n >> 1 & 15
            };
            this.ind_subs.push(a), a.num_dep_sub > 0 && (a.chan_loc = (n & 1) << 8 | i.readUint8());
        }
    }
}, $e833773b1f4e7d0f$var$Ud = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "FLACSpecificBox";
    }
    static{
        this.fourcc = "dfLa";
    }
    parse(i) {
        this.parseFullHeader(i);
        let e = 127, t = 128, s = [], r = [
            "STREAMINFO",
            "PADDING",
            "APPLICATION",
            "SEEKTABLE",
            "VORBIS_COMMENT",
            "CUESHEET",
            "PICTURE",
            "RESERVED"
        ], n;
        do {
            n = i.readUint8();
            let a = Math.min(n & e, r.length - 1);
            a ? i.readUint8Array(i.readUint24()) : (i.readUint8Array(13), this.samplerate = i.readUint32() >> 12, i.readUint8Array(20)), s.push(r[a]);
        }while (n & t);
        this.numMetadataBlocks = s.length + " (" + s.join(", ") + ")";
    }
}, $e833773b1f4e7d0f$var$Ed = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "hintimmediateBytesSent";
    }
    static{
        this.fourcc = "dimm";
    }
    parse(i) {
        this.bytessent = i.readUint64();
    }
}, $e833773b1f4e7d0f$var$Id = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "hintlongestpacket";
    }
    static{
        this.fourcc = "dmax";
    }
    parse(i) {
        this.time = i.readUint32();
    }
}, $e833773b1f4e7d0f$var$Cd = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "hintmediaBytesSent";
    }
    static{
        this.fourcc = "dmed";
    }
    parse(i) {
        this.bytessent = i.readUint64();
    }
}, $e833773b1f4e7d0f$var$Bd = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "OpusSpecificBox";
    }
    static{
        this.fourcc = "dOps";
    }
    parse(i) {
        if (this.Version = i.readUint8(), this.OutputChannelCount = i.readUint8(), this.PreSkip = i.readUint16(), this.InputSampleRate = i.readUint32(), this.OutputGain = i.readInt16(), this.ChannelMappingFamily = i.readUint8(), this.ChannelMappingFamily !== 0) {
            this.StreamCount = i.readUint8(), this.CoupledCount = i.readUint8(), this.ChannelMapping = [];
            for(let e = 0; e < this.OutputChannelCount; e++)this.ChannelMapping[e] = i.readUint8();
        }
    }
    write(i) {
        if (this.size = 11, this.ChannelMappingFamily !== 0 && (this.size += 2 + this.OutputChannelCount), this.writeHeader(i), i.writeUint8(this.Version), i.writeUint8(this.OutputChannelCount), i.writeUint16(this.PreSkip), i.writeUint32(this.InputSampleRate), i.writeInt16(this.OutputGain), i.writeUint8(this.ChannelMappingFamily), this.ChannelMappingFamily !== 0) {
            i.writeUint8(this.StreamCount), i.writeUint8(this.CoupledCount);
            for(let e = 0; e < this.OutputChannelCount; e++)i.writeUint8(this.ChannelMapping[e]);
        }
    }
}, $e833773b1f4e7d0f$var$Ad = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "hintrepeatedBytesSent";
    }
    static{
        this.fourcc = "drep";
    }
    parse(i) {
        this.bytessent = i.readUint64();
    }
}, $e833773b1f4e7d0f$var$Dd = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "EditListBox";
    }
    static{
        this.fourcc = "elst";
    }
    parse(i) {
        this.parseFullHeader(i), this.entries = [];
        let e = i.readUint32();
        for(let t = 0; t < e; t++){
            let s = {
                segment_duration: this.version === 1 ? i.readUint64() : i.readUint32(),
                media_time: this.version === 1 ? i.readInt64() : i.readInt32(),
                media_rate_integer: i.readInt16(),
                media_rate_fraction: i.readInt16()
            };
            this.entries.push(s);
        }
    }
    write(i) {
        let e = this.entries.some((t)=>t.segment_duration > $e833773b1f4e7d0f$var$H || t.media_time > $e833773b1f4e7d0f$var$H) || this.version === 1;
        this.version = e ? 1 : 0, this.size = 4 + 12 * this.entries.length, this.size += e ? 8 * this.entries.length : 0, this.writeHeader(i), i.writeUint32(this.entries.length);
        for(let t = 0; t < this.entries.length; t++){
            let s = this.entries[t];
            e ? (i.writeUint64(s.segment_duration), i.writeInt64(s.media_time)) : (i.writeUint32(s.segment_duration), i.writeInt32(s.media_time)), i.writeInt16(s.media_rate_integer), i.writeInt16(s.media_rate_fraction);
        }
    }
}, $e833773b1f4e7d0f$var$Pd = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "EventMessageBox";
    }
    static{
        this.fourcc = "emsg";
    }
    parse(i) {
        this.parseFullHeader(i), this.version === 1 ? (this.timescale = i.readUint32(), this.presentation_time = i.readUint64(), this.event_duration = i.readUint32(), this.id = i.readUint32(), this.scheme_id_uri = i.readCString(), this.value = i.readCString()) : (this.scheme_id_uri = i.readCString(), this.value = i.readCString(), this.timescale = i.readUint32(), this.presentation_time_delta = i.readUint32(), this.event_duration = i.readUint32(), this.id = i.readUint32());
        let e = this.size - this.hdr_size - (16 + (this.scheme_id_uri.length + 1) + (this.value.length + 1));
        this.version === 1 && (e -= 4), this.message_data = i.readUint8Array(e);
    }
    write(i) {
        this.version = 0, this.flags = 0, this.size = 16 + this.message_data.length + (this.scheme_id_uri.length + 1) + (this.value.length + 1), this.writeHeader(i), i.writeCString(this.scheme_id_uri), i.writeCString(this.value), i.writeUint32(this.timescale), i.writeUint32(this.presentation_time_delta), i.writeUint32(this.event_duration), i.writeUint32(this.id), i.writeUint8Array(this.message_data);
    }
}, $e833773b1f4e7d0f$var$W = class extends $e833773b1f4e7d0f$var$x {
    parse(i) {
        this.parseFullHeader(i), this.group_id = i.readUint32(), this.num_entities_in_group = i.readUint32(), this.entity_ids = [];
        for(let e = 0; e < this.num_entities_in_group; e++){
            let t = i.readUint32();
            this.entity_ids.push(t);
        }
    }
}, $e833773b1f4e7d0f$var$kd = class extends $e833773b1f4e7d0f$var$W {
    constructor(){
        super(...arguments), this.box_name = "Auto exposure bracketing";
    }
    static{
        this.fourcc = "aebr";
    }
}, $e833773b1f4e7d0f$var$Rd = class extends $e833773b1f4e7d0f$var$W {
    constructor(){
        super(...arguments), this.box_name = "Flash exposure information";
    }
    static{
        this.fourcc = "afbr";
    }
}, $e833773b1f4e7d0f$var$Fd = class extends $e833773b1f4e7d0f$var$W {
    constructor(){
        super(...arguments), this.box_name = "Album collection";
    }
    static{
        this.fourcc = "albc";
    }
}, $e833773b1f4e7d0f$var$Md = class extends $e833773b1f4e7d0f$var$W {
    constructor(){
        super(...arguments), this.box_name = "Alternative entity";
    }
    static{
        this.fourcc = "altr";
    }
}, $e833773b1f4e7d0f$var$Od = class extends $e833773b1f4e7d0f$var$W {
    constructor(){
        super(...arguments), this.box_name = "Burst image";
    }
    static{
        this.fourcc = "brst";
    }
}, $e833773b1f4e7d0f$var$Ld = class extends $e833773b1f4e7d0f$var$W {
    constructor(){
        super(...arguments), this.box_name = "Depth of field bracketing";
    }
    static{
        this.fourcc = "dobr";
    }
}, $e833773b1f4e7d0f$var$Nd = class extends $e833773b1f4e7d0f$var$W {
    constructor(){
        super(...arguments), this.box_name = "Equivalent entity";
    }
    static{
        this.fourcc = "eqiv";
    }
}, $e833773b1f4e7d0f$var$zd = class extends $e833773b1f4e7d0f$var$W {
    constructor(){
        super(...arguments), this.box_name = "Favorites collection";
    }
    static{
        this.fourcc = "favc";
    }
}, $e833773b1f4e7d0f$var$Gd = class extends $e833773b1f4e7d0f$var$W {
    constructor(){
        super(...arguments), this.box_name = "Focus bracketing";
    }
    static{
        this.fourcc = "fobr";
    }
}, $e833773b1f4e7d0f$var$Vd = class extends $e833773b1f4e7d0f$var$W {
    constructor(){
        super(...arguments), this.box_name = "Image item with an audio track";
    }
    static{
        this.fourcc = "iaug";
    }
}, $e833773b1f4e7d0f$var$Hd = class extends $e833773b1f4e7d0f$var$W {
    constructor(){
        super(...arguments), this.box_name = "Panorama";
    }
    static{
        this.fourcc = "pano";
    }
}, $e833773b1f4e7d0f$var$qd = class extends $e833773b1f4e7d0f$var$W {
    constructor(){
        super(...arguments), this.box_name = "Slideshow";
    }
    static{
        this.fourcc = "slid";
    }
}, $e833773b1f4e7d0f$var$Wd = class extends $e833773b1f4e7d0f$var$W {
    constructor(){
        super(...arguments), this.box_name = "Stereo";
    }
    static{
        this.fourcc = "ster";
    }
}, $e833773b1f4e7d0f$var$Yd = class extends $e833773b1f4e7d0f$var$W {
    constructor(){
        super(...arguments), this.box_name = "Time-synchronized capture";
    }
    static{
        this.fourcc = "tsyn";
    }
}, $e833773b1f4e7d0f$var$jd = class extends $e833773b1f4e7d0f$var$W {
    constructor(){
        super(...arguments), this.box_name = "White balance bracketing";
    }
    static{
        this.fourcc = "wbbr";
    }
}, $e833773b1f4e7d0f$var$Xd = class extends $e833773b1f4e7d0f$var$W {
    constructor(){
        super(...arguments), this.box_name = "Progressive rendering";
    }
    static{
        this.fourcc = "prgr";
    }
}, $e833773b1f4e7d0f$var$Kd = class extends $e833773b1f4e7d0f$var$W {
    constructor(){
        super(...arguments), this.box_name = "Image pyramid";
    }
    static{
        this.fourcc = "pymd";
    }
    parse(i) {
        this.parseFullHeader(i), this.group_id = i.readUint32(), this.num_entities_in_group = i.readUint32(), this.entity_ids = [];
        for(let e = 0; e < this.num_entities_in_group; e++){
            let t = i.readUint32();
            this.entity_ids.push(t);
        }
        this.tile_size_x = i.readUint16(), this.tile_size_y = i.readUint16(), this.layer_binning = [], this.tiles_in_layer_column_minus1 = [], this.tiles_in_layer_row_minus1 = [];
        for(let e = 0; e < this.num_entities_in_group; e++)this.layer_binning[e] = i.readUint16(), this.tiles_in_layer_row_minus1[e] = i.readUint16(), this.tiles_in_layer_column_minus1[e] = i.readUint16();
    }
}, $e833773b1f4e7d0f$var$$d = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "FieldHandlingBox";
    }
    static{
        this.fourcc = "fiel";
    }
    parse(i) {
        this.fieldCount = i.readUint8(), this.fieldOrdering = i.readUint8();
    }
}, $e833773b1f4e7d0f$var$Qd = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "OriginalFormatBox";
    }
    static{
        this.fourcc = "frma";
    }
    parse(i) {
        this.data_format = i.readString(4);
    }
}, $e833773b1f4e7d0f$var$Zd = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "ImageMirror";
    }
    static{
        this.fourcc = "imir";
    }
    parse(i) {
        let e = i.readUint8();
        this.reserved = e >> 7, this.axis = e & 1;
    }
}, $e833773b1f4e7d0f$var$Jd = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "ItemPropertyAssociationBox";
    }
    static{
        this.fourcc = "ipma";
    }
    parse(i) {
        this.parseFullHeader(i);
        let e = i.readUint32();
        this.associations = [];
        for(let t = 0; t < e; t++){
            let s = this.version < 1 ? i.readUint16() : i.readUint32(), r = [], n = i.readUint8();
            for(let a = 0; a < n; a++){
                let o = i.readUint8();
                r.push({
                    essential: (o & 128) >> 7 === 1,
                    property_index: this.flags & 1 ? (o & 127) << 8 | i.readUint8() : o & 127
                });
            }
            this.associations.push({
                id: s,
                props: r
            });
        }
    }
}, $e833773b1f4e7d0f$var$ec = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "ImageRotation";
    }
    static{
        this.fourcc = "irot";
    }
    parse(i) {
        this.angle = i.readUint8() & 3;
    }
}, $e833773b1f4e7d0f$var$tc = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "ImageSpatialExtentsProperty";
    }
    static{
        this.fourcc = "ispe";
    }
    parse(i) {
        this.parseFullHeader(i), this.image_width = i.readUint32(), this.image_height = i.readUint32();
    }
}, $e833773b1f4e7d0f$var$ic = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "TAITimestampBox";
    }
    static{
        this.fourcc = "itai";
    }
    parse(i) {
        this.TAI_timestamp = i.readUint64();
        let e = i.readUint8();
        this.sychronization_state = e >> 7 & 1, this.timestamp_generation_failure = e >> 6 & 1, this.timestamp_is_modified = e >> 5 & 1;
    }
}, $e833773b1f4e7d0f$var$sc = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "KindBox";
    }
    static{
        this.fourcc = "kind";
    }
    parse(i) {
        this.parseFullHeader(i), this.schemeURI = i.readCString(), this.isEndOfBox(i) || (this.value = i.readCString());
    }
    write(i) {
        this.version = 0, this.flags = 0, this.size = this.schemeURI.length + 1 + (this.value ? this.value.length + 1 : 0), this.writeHeader(i), i.writeCString(this.schemeURI), this.value && i.writeCString(this.value);
    }
}, $e833773b1f4e7d0f$var$rc = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "LevelAssignmentBox";
    }
    static{
        this.fourcc = "leva";
    }
    parse(i) {
        this.parseFullHeader(i);
        let e = i.readUint8();
        this.levels = [];
        for(let t = 0; t < e; t++){
            let s = {};
            this.levels[t] = s, s.track_ID = i.readUint32();
            let r = i.readUint8();
            switch(s.padding_flag = r >> 7, s.assignment_type = r & 127, s.assignment_type){
                case 0:
                    s.grouping_type = i.readString(4);
                    break;
                case 1:
                    s.grouping_type = i.readString(4), s.grouping_type_parameter = i.readUint32();
                    break;
                case 2:
                    break;
                case 3:
                    break;
                case 4:
                    s.sub_track_id = i.readUint32();
                    break;
                default:
                    $e833773b1f4e7d0f$var$g.warn("BoxParser", `Unknown level assignment type: ${s.assignment_type}`);
            }
        }
    }
}, $e833773b1f4e7d0f$var$nc = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "LHEVCConfigurationBox";
    }
    static{
        this.fourcc = "lhvC";
    }
    parse(i) {
        this.configurationVersion = i.readUint8(), this.min_spatial_segmentation_idc = i.readUint16() & 4095, this.parallelismType = i.readUint8() & 3;
        let e = i.readUint8();
        this.numTemporalLayers = (e & 13) >> 3, this.temporalIdNested = (e & 4) >> 2, this.lengthSizeMinusOne = e & 3, this.nalu_arrays = [];
        let t = i.readUint8();
        for(let s = 0; s < t; s++){
            let r = [];
            this.nalu_arrays.push(r), e = i.readUint8(), r.completeness = (e & 128) >> 7, r.nalu_type = e & 63;
            let n = i.readUint16();
            for(let a = 0; a < n; a++){
                let o = i.readUint16();
                r.push({
                    data: i.readUint8Array(o)
                });
            }
        }
    }
}, $e833773b1f4e7d0f$var$ac = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "LayerSelectorProperty";
    }
    static{
        this.fourcc = "lsel";
    }
    parse(i) {
        this.layer_id = i.readUint16();
    }
}, $e833773b1f4e7d0f$var$oc = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "hintmaxrate";
    }
    static{
        this.fourcc = "maxr";
    }
    parse(i) {
        this.period = i.readUint32(), this.bytes = i.readUint32();
    }
}, $e833773b1f4e7d0f$var$zt = class {
    constructor(i, e){
        this.x = i, this.y = e;
    }
    toString() {
        return "(" + this.x + "," + this.y + ")";
    }
}, $e833773b1f4e7d0f$var$uc = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "MasteringDisplayColourVolumeBox";
    }
    static{
        this.fourcc = "mdcv";
    }
    parse(i) {
        this.display_primaries = [], this.display_primaries[0] = new $e833773b1f4e7d0f$var$zt(i.readUint16(), i.readUint16()), this.display_primaries[1] = new $e833773b1f4e7d0f$var$zt(i.readUint16(), i.readUint16()), this.display_primaries[2] = new $e833773b1f4e7d0f$var$zt(i.readUint16(), i.readUint16()), this.white_point = new $e833773b1f4e7d0f$var$zt(i.readUint16(), i.readUint16()), this.max_display_mastering_luminance = i.readUint32(), this.min_display_mastering_luminance = i.readUint32();
    }
}, $e833773b1f4e7d0f$var$lc = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "MovieFragmentRandomAccessOffsetBox";
    }
    static{
        this.fourcc = "mfro";
    }
    parse(i) {
        this.parseFullHeader(i), this._size = i.readUint32();
    }
}, $e833773b1f4e7d0f$var$hc = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "MaskConfigurationProperty";
    }
    static{
        this.fourcc = "mskC";
    }
    parse(i) {
        this.parseFullHeader(i), this.bits_per_pixel = i.readUint8();
    }
}, $e833773b1f4e7d0f$var$dc = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "hintPacketsSent";
    }
    static{
        this.fourcc = "npck";
    }
    parse(i) {
        this.packetssent = i.readUint32();
    }
}, $e833773b1f4e7d0f$var$cc = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "hintPacketsSent";
    }
    static{
        this.fourcc = "nump";
    }
    parse(i) {
        this.packetssent = i.readUint64();
    }
}, $e833773b1f4e7d0f$var$fc = class {
    constructor(i, e){
        this.pad1 = i, this.pad2 = e;
    }
}, $e833773b1f4e7d0f$var$pc = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "PaddingBitsBox";
    }
    static{
        this.fourcc = "padb";
    }
    parse(i) {
        this.parseFullHeader(i);
        let e = i.readUint32();
        this.padbits = [];
        for(let t = 0; t < Math.floor((e + 1) / 2); t++){
            let s = i.readUint8(), r = (s & 112) >> 4, n = s & 7;
            this.padbits.push(new $e833773b1f4e7d0f$var$fc(r, n));
        }
    }
}, $e833773b1f4e7d0f$var$mc = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "PixelAspectRatioBox";
    }
    static{
        this.fourcc = "pasp";
    }
    parse(i) {
        this.hSpacing = i.readUint32(), this.vSpacing = i.readUint32();
    }
}, $e833773b1f4e7d0f$var$gc = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "CuePayloadBox";
    }
    static{
        this.fourcc = "payl";
    }
    parse(i) {
        this.text = i.readString(this.size - this.hdr_size);
    }
}, $e833773b1f4e7d0f$var$_c = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "hintpayloadID";
    }
    static{
        this.fourcc = "payt";
    }
    parse(i) {
        this.payloadID = i.readUint32();
        let e = i.readUint8();
        this.rtpmap_string = i.readString(e);
    }
}, $e833773b1f4e7d0f$var$xc = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "ProgressiveDownloadInfoBox", this.rate = [], this.initial_delay = [];
    }
    static{
        this.fourcc = "pdin";
    }
    parse(i) {
        this.parseFullHeader(i);
        let e = (this.size - this.hdr_size) / 8;
        for(let t = 0; t < e; t++)this.rate[t] = i.readUint32(), this.initial_delay[t] = i.readUint32();
    }
}, $e833773b1f4e7d0f$var$yc = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "PixelInformationProperty";
    }
    static{
        this.fourcc = "pixi";
    }
    parse(i) {
        this.parseFullHeader(i), this.num_channels = i.readUint8(), this.bits_per_channels = [];
        for(let e = 0; e < this.num_channels; e++)this.bits_per_channels[e] = i.readUint8();
    }
}, $e833773b1f4e7d0f$var$vc = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "hintlargestpacket";
    }
    static{
        this.fourcc = "pmax";
    }
    parse(i) {
        this.bytes = i.readUint32();
    }
}, $e833773b1f4e7d0f$var$bc = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "ProgressiveDerivedImageItemInformationProperty";
    }
    static{
        this.fourcc = "prdi";
    }
    parse(i) {
        if (this.parseFullHeader(i), this.step_count = i.readUint16(), this.item_count = [], this.flags & 2) for(let e = 0; e < this.step_count; e++)this.item_count[e] = i.readUint16();
    }
}, $e833773b1f4e7d0f$var$Sc = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "ProjectionFormatBox";
    }
    static{
        this.fourcc = "prfr";
    }
    parse(i) {
        this.parseFullHeader(i), this.projection_type = i.readUint8() & 31;
    }
}, $e833773b1f4e7d0f$var$Tc = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "ProducerReferenceTimeBox";
    }
    static{
        this.fourcc = "prft";
    }
    parse(i) {
        this.parseFullHeader(i), this.ref_track_id = i.readUint32(), this.ntp_timestamp = i.readUint64(), this.version === 0 ? this.media_time = i.readUint32() : this.media_time = i.readUint64();
    }
}, $e833773b1f4e7d0f$var$wc = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "ProtectionSystemSpecificHeaderBox";
    }
    static{
        this.fourcc = "pssh";
    }
    parse(i) {
        if (this.parseFullHeader(i), this.system_id = $e833773b1f4e7d0f$var$ke(i), this.kid = [], this.version > 0) {
            let t = i.readUint32();
            for(let s = 0; s < t; s++)this.kid[s] = $e833773b1f4e7d0f$var$ke(i);
        }
        let e = i.readUint32();
        e > 0 && (this.protection_data = i.readUint8Array(e));
    }
}, $e833773b1f4e7d0f$var$Uc = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "TrackCleanApertureDimensionsBox";
    }
    static{
        this.fourcc = "clef";
    }
    parse(i) {
        this.parseFullHeader(i), this.width = i.readUint32(), this.height = i.readUint32();
    }
};
function $e833773b1f4e7d0f$var$Ec(i, e) {
    if (i === $e833773b1f4e7d0f$var$at.Types.UTF8) return new TextDecoder("utf-8").decode(e);
    let t = new DataView(e.buffer);
    if (i === $e833773b1f4e7d0f$var$at.Types.BE_UNSIGNED_INT) {
        if (e.length === 1) return t.getUint8(0);
        if (e.length === 2) return t.getUint16(0, !1);
        if (e.length === 4) return t.getUint32(0, !1);
        if (e.length === 8) return t.getBigUint64(0, !1);
        throw new Error("Unsupported ITIF_TYPE_BE_UNSIGNED_INT length " + e.length);
    } else if (i === $e833773b1f4e7d0f$var$at.Types.BE_SIGNED_INT) {
        if (e.length === 1) return t.getInt8(0);
        if (e.length === 2) return t.getInt16(0, !1);
        if (e.length === 4) return t.getInt32(0, !1);
        if (e.length === 8) return t.getBigInt64(0, !1);
        throw new Error("Unsupported ITIF_TYPE_BE_SIGNED_INT length " + e.length);
    } else if (i === $e833773b1f4e7d0f$var$at.Types.BE_FLOAT32) return t.getFloat32(0, !1);
    $e833773b1f4e7d0f$var$g.warn("DataBox", "Unsupported or unimplemented itif data type: " + i);
}
var $e833773b1f4e7d0f$var$at = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "DataBox";
    }
    static{
        this.fourcc = "data";
    }
    static{
        this.Types = {
            RESERVED: 0,
            UTF8: 1,
            UTF16: 2,
            SJIS: 3,
            UTF8_SORT: 4,
            UTF16_SORT: 5,
            JPEG: 13,
            PNG: 14,
            BE_SIGNED_INT: 21,
            BE_UNSIGNED_INT: 22,
            BE_FLOAT32: 23,
            BE_FLOAT64: 24,
            BMP: 27,
            QT_ATOM: 28,
            BE_SIGNED_INT8: 65,
            BE_SIGNED_INT16: 66,
            BE_SIGNED_INT32: 67,
            BE_FLOAT32_POINT: 70,
            BE_FLOAT32_DIMENSIONS: 71,
            BE_FLOAT32_RECT: 72,
            BE_SIGNED_INT64: 74,
            BE_UNSIGNED_INT8: 75,
            BE_UNSIGNED_INT16: 76,
            BE_UNSIGNED_INT32: 77,
            BE_UNSIGNED_INT64: 78,
            BE_FLOAT64_AFFINE_TRANSFORM: 79
        };
    }
    parse(i) {
        this.valueType = i.readUint32(), this.country = i.readUint16(), this.country > 255 && (i.seek(i.getPosition() - 2), this.countryString = i.readString(2)), this.language = i.readUint16(), this.language > 255 && (i.seek(i.getPosition() - 2), this.parseLanguage(i)), this.raw = i.readUint8Array(this.size - this.hdr_size - 8), this.value = $e833773b1f4e7d0f$var$Ec(this.valueType, this.raw);
    }
}, $e833773b1f4e7d0f$var$Ic = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "TrackEncodedPixelsDimensionsBox";
    }
    static{
        this.fourcc = "enof";
    }
    parse(i) {
        this.parseFullHeader(i), this.width = i.readUint32(), this.height = i.readUint32();
    }
}, $e833773b1f4e7d0f$var$Cc = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "IlstBox";
    }
    static{
        this.fourcc = "ilst";
    }
    parse(i) {
        this.list = {};
        let e = this.size - this.hdr_size;
        for(; e > 0;){
            let t = i.readUint32(), s = i.readUint32(), r = $e833773b1f4e7d0f$var$oe(i, !1, t - 8);
            r.code === $e833773b1f4e7d0f$var$J && (this.list[s] = r.box), e -= t;
        }
    }
}, $e833773b1f4e7d0f$var$Bc = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "KeysBox";
    }
    static{
        this.fourcc = "keys";
    }
    parse(i) {
        this.parseFullHeader(i), this.count = i.readUint32(), this.keys = {};
        for(let e = 0; e < this.count; e++){
            let t = i.readUint32();
            this.keys[e + 1] = i.readString(t - 4);
        }
    }
}, $e833773b1f4e7d0f$var$Ac = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "TrackProductionApertureDimensionsBox";
    }
    static{
        this.fourcc = "prof";
    }
    parse(i) {
        this.parseFullHeader(i), this.width = i.readUint32(), this.height = i.readUint32();
    }
}, $e833773b1f4e7d0f$var$Dc = class extends $e833773b1f4e7d0f$var$E {
    constructor(){
        super(...arguments), this.box_name = "TrackApertureModeDimensionsBox", this.clefs = [], this.profs = [], this.enofs = [], this.subBoxNames = [
            "clef",
            "prof",
            "enof"
        ];
    }
    static{
        this.fourcc = "tapt";
    }
}, $e833773b1f4e7d0f$var$Pc = class extends $e833773b1f4e7d0f$var$E {
    constructor(){
        super(...arguments), this.box_name = "siDecompressionParamBox";
    }
    static{
        this.fourcc = "wave";
    }
}, $e833773b1f4e7d0f$var$kc = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "rtpmoviehintinformation";
    }
    static{
        this.fourcc = "rtp ";
    }
    parse(i) {
        this.descriptionformat = i.readString(4), this.sdptext = i.readString(this.size - this.hdr_size - 4);
    }
}, $e833773b1f4e7d0f$var$Rc = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "SampleAuxiliaryInformationOffsetsBox";
    }
    static{
        this.fourcc = "saio";
    }
    parse(i) {
        this.parseFullHeader(i), this.flags & 1 && (this.aux_info_type = i.readString(4), this.aux_info_type_parameter = i.readUint32());
        let e = i.readUint32();
        this.offset = [];
        for(let t = 0; t < e; t++)this.version === 0 ? this.offset[t] = i.readUint32() : this.offset[t] = i.readUint64();
    }
}, $e833773b1f4e7d0f$var$Fc = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "SampleAuxiliaryInformationSizesBox";
    }
    static{
        this.fourcc = "saiz";
    }
    parse(i) {
        if (this.parseFullHeader(i), this.flags & 1 && (this.aux_info_type = i.readString(4), this.aux_info_type_parameter = i.readUint32()), this.default_sample_info_size = i.readUint8(), this.sample_count = i.readUint32(), this.sample_info_size = [], this.default_sample_info_size === 0) for(let e = 0; e < this.sample_count; e++)this.sample_info_size[e] = i.readUint8();
    }
}, $e833773b1f4e7d0f$var$Mc = class {
    constructor(i, e){
        this.bad_pixel_row = i, this.bad_pixel_column = e;
    }
    toString() {
        return "[row: " + this.bad_pixel_row + ", column: " + this.bad_pixel_column + "]";
    }
}, $e833773b1f4e7d0f$var$Oc = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "SensorBadPixelsMapBox";
    }
    static{
        this.fourcc = "sbpm";
    }
    parse(i) {
        this.parseFullHeader(i), this.component_count = i.readUint16(), this.component_index = [];
        for(let t = 0; t < this.component_count; t++)this.component_index.push(i.readUint16());
        let e = i.readUint8();
        this.correction_applied = (e & 128) === 128, this.num_bad_rows = i.readUint32(), this.num_bad_cols = i.readUint32(), this.num_bad_pixels = i.readUint32(), this.bad_rows = [], this.bad_columns = [], this.bad_pixels = [];
        for(let t = 0; t < this.num_bad_rows; t++)this.bad_rows.push(i.readUint32());
        for(let t = 0; t < this.num_bad_cols; t++)this.bad_columns.push(i.readUint32());
        for(let t = 0; t < this.num_bad_pixels; t++){
            let s = i.readUint32(), r = i.readUint32();
            this.bad_pixels.push(new $e833773b1f4e7d0f$var$Mc(s, r));
        }
    }
}, $e833773b1f4e7d0f$var$Lc = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "SchemeTypeBox";
    }
    static{
        this.fourcc = "schm";
    }
    parse(i) {
        this.parseFullHeader(i), this.scheme_type = i.readString(4), this.scheme_version = i.readUint32(), this.flags & 1 && (this.scheme_uri = i.readString(this.size - this.hdr_size - 8));
    }
}, $e833773b1f4e7d0f$var$Nc = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "rtptracksdphintinformation";
    }
    static{
        this.fourcc = "sdp ";
    }
    parse(i) {
        this.sdptext = i.readString(this.size - this.hdr_size);
    }
}, $e833773b1f4e7d0f$var$zc = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "SampleEncryptionBox";
    }
    static{
        this.fourcc = "senc";
    }
}, $e833773b1f4e7d0f$var$Gc = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "SMPTE2086MasteringDisplayMetadataBox";
    }
    static{
        this.fourcc = "SmDm";
    }
    parse(i) {
        this.parseFullHeader(i), this.primaryRChromaticity_x = i.readUint16(), this.primaryRChromaticity_y = i.readUint16(), this.primaryGChromaticity_x = i.readUint16(), this.primaryGChromaticity_y = i.readUint16(), this.primaryBChromaticity_x = i.readUint16(), this.primaryBChromaticity_y = i.readUint16(), this.whitePointChromaticity_x = i.readUint16(), this.whitePointChromaticity_y = i.readUint16(), this.luminanceMax = i.readUint32(), this.luminanceMin = i.readUint32();
    }
}, $e833773b1f4e7d0f$var$Vc = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "SamplingRateBox";
    }
    static{
        this.fourcc = "srat";
    }
    parse(i) {
        this.parseFullHeader(i), this.sampling_rate = i.readUint32();
    }
}, $e833773b1f4e7d0f$var$Hc = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "CompressedSubsegmentIndexBox";
    }
    static{
        this.fourcc = "ssix";
    }
    parse(i) {
        this.parseFullHeader(i), this.subsegments = [];
        let e = i.readUint32();
        for(let t = 0; t < e; t++){
            let s = {};
            this.subsegments.push(s), s.ranges = [];
            let r = i.readUint32();
            for(let n = 0; n < r; n++){
                let a = {};
                s.ranges.push(a), a.level = i.readUint8(), a.range_size = i.readUint24();
            }
        }
    }
}, $e833773b1f4e7d0f$var$qc = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "DegradationPriorityBox";
    }
    static{
        this.fourcc = "stpd";
    }
    parse(i) {
        this.parseFullHeader(i);
        let e = (this.size - this.hdr_size) / 2;
        this.priority = [];
        for(let t = 0; t < e; t++)this.priority[t] = i.readUint16();
    }
}, $e833773b1f4e7d0f$var$Wc = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "SubTrackInformationBox";
    }
    static{
        this.fourcc = "stri";
    }
    parse(i) {
        this.parseFullHeader(i), this.switch_group = i.readUint16(), this.alternate_group = i.readUint16(), this.sub_track_id = i.readUint32();
        let e = (this.size - this.hdr_size - 8) / 4;
        this.attribute_list = [];
        for(let t = 0; t < e; t++)this.attribute_list[t] = i.readUint32();
    }
}, $e833773b1f4e7d0f$var$Yc = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "SubTrackSampleGroupBox";
    }
    static{
        this.fourcc = "stsg";
    }
    parse(i) {
        this.parseFullHeader(i), this.grouping_type = i.readUint32();
        let e = i.readUint16();
        this.group_description_index = [];
        for(let t = 0; t < e; t++)this.group_description_index[t] = i.readUint32();
    }
}, $e833773b1f4e7d0f$var$jc = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "ShadowSyncSampleBox";
    }
    static{
        this.fourcc = "stsh";
    }
    parse(i) {
        this.parseFullHeader(i);
        let e = i.readUint32();
        if (this.shadowed_sample_numbers = [], this.sync_sample_numbers = [], this.version === 0) for(let t = 0; t < e; t++)this.shadowed_sample_numbers.push(i.readUint32()), this.sync_sample_numbers.push(i.readUint32());
    }
    write(i) {
        this.version = 0, this.flags = 0, this.size = 4 + 8 * this.shadowed_sample_numbers.length, this.writeHeader(i), i.writeUint32(this.shadowed_sample_numbers.length);
        for(let e = 0; e < this.shadowed_sample_numbers.length; e++)i.writeUint32(this.shadowed_sample_numbers[e]), i.writeUint32(this.sync_sample_numbers[e]);
    }
}, $e833773b1f4e7d0f$var$Xc = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "SyncSampleBox";
    }
    static{
        this.fourcc = "stss";
    }
    parse(i) {
        this.parseFullHeader(i);
        let e = i.readUint32();
        if (this.version === 0) {
            this.sample_numbers = [];
            for(let t = 0; t < e; t++)this.sample_numbers.push(i.readUint32());
        }
    }
    write(i) {
        this.version = 0, this.flags = 0, this.size = 4 + 4 * this.sample_numbers.length, this.writeHeader(i), i.writeUint32(this.sample_numbers.length), i.writeUint32Array(this.sample_numbers);
    }
}, $e833773b1f4e7d0f$var$Kc = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "StereoVideoBox";
    }
    static{
        this.fourcc = "stvi";
    }
    parse(i) {
        this.parseFullHeader(i);
        let e = i.readUint32();
        this.single_view_allowed = e & 3, this.stereo_scheme = i.readUint32();
        let t = i.readUint32();
        for(this.stereo_indication_type = i.readString(t), this.boxes = []; i.getPosition() < this.start + this.size;){
            let s = $e833773b1f4e7d0f$var$oe(i, !1, this.size - (i.getPosition() - this.start));
            if (s.code === $e833773b1f4e7d0f$var$J) {
                let r = s.box;
                this.boxes.push(r), this[r.type] = r;
            } else return;
        }
    }
}, $e833773b1f4e7d0f$var$$c = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "SegmentTypeBox";
    }
    static{
        this.fourcc = "styp";
    }
    parse(i) {
        let e = this.size - this.hdr_size;
        this.major_brand = i.readString(4), this.minor_version = i.readUint32(), e -= 8, this.compatible_brands = [];
        let t = 0;
        for(; e >= 4;)this.compatible_brands[t] = i.readString(4), e -= 4, t++;
    }
    write(i) {
        this.size = 8 + 4 * this.compatible_brands.length, this.writeHeader(i), i.writeString(this.major_brand, void 0, 4), i.writeUint32(this.minor_version);
        for(let e = 0; e < this.compatible_brands.length; e++)i.writeString(this.compatible_brands[e], void 0, 4);
    }
}, $e833773b1f4e7d0f$var$Qc = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "CompactSampleSizeBox";
    }
    static{
        this.fourcc = "stz2";
    }
    parse(i) {
        if (this.parseFullHeader(i), this.sample_sizes = [], this.version === 0) {
            this.reserved = i.readUint24(), this.field_size = i.readUint8();
            let e = i.readUint32();
            if (this.field_size === 4) for(let t = 0; t < e; t += 2){
                let s = i.readUint8();
                this.sample_sizes[t] = s >> 4 & 15, this.sample_sizes[t + 1] = s & 15;
            }
            else if (this.field_size === 8) for(let t = 0; t < e; t++)this.sample_sizes[t] = i.readUint8();
            else if (this.field_size === 16) for(let t = 0; t < e; t++)this.sample_sizes[t] = i.readUint16();
            else $e833773b1f4e7d0f$var$g.error("BoxParser", "Error in length field in stz2 box", i.isofile);
        }
    }
}, $e833773b1f4e7d0f$var$Zc = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "SubSampleInformationBox";
    }
    static{
        this.fourcc = "subs";
    }
    parse(i) {
        this.parseFullHeader(i);
        let e = i.readUint32();
        this.entries = [];
        let t;
        for(let s = 0; s < e; s++){
            let r = {};
            if (this.entries[s] = r, r.sample_delta = i.readUint32(), r.subsamples = [], t = i.readUint16(), t > 0) for(let n = 0; n < t; n++){
                let a = {};
                r.subsamples.push(a), this.version === 1 ? a.size = i.readUint32() : a.size = i.readUint16(), a.priority = i.readUint8(), a.discardable = i.readUint8(), a.codec_specific_parameters = i.readUint32();
            }
        }
    }
}, $e833773b1f4e7d0f$var$Jc = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "TAIClockInfoBox";
    }
    static{
        this.fourcc = "taic";
    }
    parse(i) {
        this.time_uncertainty = i.readUint64(), this.clock_resolution = i.readUint32(), this.clock_drift_rate = i.readInt32();
        let e = i.readUint8();
        this.clock_type = (e & 192) >> 6;
    }
}, $e833773b1f4e7d0f$var$ef = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "TrackEncryptionBox";
    }
    static{
        this.fourcc = "tenc";
    }
    parse(i) {
        if (this.parseFullHeader(i), i.readUint8(), this.version === 0) i.readUint8();
        else {
            let e = i.readUint8();
            this.default_crypt_byte_block = e >> 4 & 15, this.default_skip_byte_block = e & 15;
        }
        this.default_isProtected = i.readUint8(), this.default_Per_Sample_IV_Size = i.readUint8(), this.default_KID = $e833773b1f4e7d0f$var$ke(i), this.default_isProtected === 1 && this.default_Per_Sample_IV_Size === 0 && (this.default_constant_IV_size = i.readUint8(), this.default_constant_IV = i.readUint8Array(this.default_constant_IV_size));
    }
}, $e833773b1f4e7d0f$var$tf = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "TrackFragmentRandomAccessBox";
    }
    static{
        this.fourcc = "tfra";
    }
    parse(i) {
        this.parseFullHeader(i), this.track_ID = i.readUint32(), i.readUint24();
        let e = i.readUint8();
        this.length_size_of_traf_num = e >> 4 & 3, this.length_size_of_trun_num = e >> 2 & 3, this.length_size_of_sample_num = e & 3, this.entries = [];
        let t = i.readUint32();
        for(let s = 0; s < t; s++)this.version === 1 ? (this.time = i.readUint64(), this.moof_offset = i.readUint64()) : (this.time = i.readUint32(), this.moof_offset = i.readUint32()), this.traf_number = i["readUint" + 8 * (this.length_size_of_traf_num + 1)](), this.trun_number = i["readUint" + 8 * (this.length_size_of_trun_num + 1)](), this.sample_number = i["readUint" + 8 * (this.length_size_of_sample_num + 1)]();
    }
}, $e833773b1f4e7d0f$var$sf = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "hintmaxrelativetime";
    }
    static{
        this.fourcc = "tmax";
    }
    parse(i) {
        this.time = i.readUint32();
    }
}, $e833773b1f4e7d0f$var$rf = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "hintminrelativetime";
    }
    static{
        this.fourcc = "tmin";
    }
    parse(i) {
        this.time = i.readUint32();
    }
}, $e833773b1f4e7d0f$var$nf = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "hintBytesSent";
    }
    static{
        this.fourcc = "totl";
    }
    parse(i) {
        this.bytessent = i.readUint32();
    }
}, $e833773b1f4e7d0f$var$af = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "hintBytesSent";
    }
    static{
        this.fourcc = "tpay";
    }
    parse(i) {
        this.bytessent = i.readUint32();
    }
}, $e833773b1f4e7d0f$var$of = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "hintBytesSent";
    }
    static{
        this.fourcc = "tpyl";
    }
    parse(i) {
        this.bytessent = i.readUint64();
    }
}, $e833773b1f4e7d0f$var$uf = class extends $e833773b1f4e7d0f$var$Ju {
    static{
        this.fourcc = "msrc";
    }
}, $e833773b1f4e7d0f$var$lf = class Tn extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "TrackReferenceBox", this.references = [];
    }
    static{
        this.fourcc = "tref";
    }
    static{
        this.allowed_types = [
            "hint",
            "cdsc",
            "font",
            "hind",
            "vdep",
            "vplx",
            "subt",
            "thmb",
            "auxl",
            "cdtg",
            "shsc",
            "aest"
        ];
    }
    parse(e) {
        for(; e.getPosition() < this.start + this.size;){
            let t = $e833773b1f4e7d0f$var$oe(e, !0, this.size - (e.getPosition() - this.start));
            if (t.code === $e833773b1f4e7d0f$var$J) {
                Tn.allowed_types.includes(t.type) || $e833773b1f4e7d0f$var$g.warn("BoxParser", `Unknown track reference type: '${t.type}'`);
                let s = new $e833773b1f4e7d0f$var$il(t.type, t.size, t.hdr_size, t.start);
                s.write === $e833773b1f4e7d0f$var$y.prototype.write && s.type !== "mdat" && ($e833773b1f4e7d0f$var$g.info("BoxParser", "TrackReference " + s.type + " box writing not yet implemented, keeping unparsed data in memory for later write"), s.parseDataAndRewind(e)), s.parse(e), this.references.push(s);
            } else return;
        }
    }
}, $e833773b1f4e7d0f$var$hf = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "TrackExtensionPropertiesBox";
    }
    static{
        this.fourcc = "trep";
    }
    parse(i) {
        for(this.parseFullHeader(i), this.track_ID = i.readUint32(), this.boxes = []; i.getPosition() < this.start + this.size;){
            let e = $e833773b1f4e7d0f$var$oe(i, !1, this.size - (i.getPosition() - this.start));
            if (e.code === $e833773b1f4e7d0f$var$J) {
                let t = e.box;
                this.boxes.push(t);
            } else return;
        }
    }
}, $e833773b1f4e7d0f$var$df = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "hintBytesSent";
    }
    static{
        this.fourcc = "trpy";
    }
    parse(i) {
        this.bytessent = i.readUint64();
    }
}, $e833773b1f4e7d0f$var$cf = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "TrackSelectionBox";
    }
    static{
        this.fourcc = "tsel";
    }
    parse(i) {
        this.parseFullHeader(i), this.switch_group = i.readUint32();
        let e = (this.size - this.hdr_size - 4) / 4;
        this.attribute_list = [];
        for(let t = 0; t < e; t++)this.attribute_list[t] = i.readUint32();
    }
}, $e833773b1f4e7d0f$var$ff = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "TextConfigBox";
    }
    static{
        this.fourcc = "txtc";
    }
    parse(i) {
        this.parseFullHeader(i), this.config = i.readCString();
    }
}, $e833773b1f4e7d0f$var$pf = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "TypeCombinationBox";
    }
    static{
        this.fourcc = "tyco";
    }
    parse(i) {
        let e = (this.size - this.hdr_size) / 4;
        this.compatible_brands = [];
        for(let t = 0; t < e; t++)this.compatible_brands[t] = i.readString(4);
    }
}, $e833773b1f4e7d0f$var$mf = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "UserDescriptionProperty";
    }
    static{
        this.fourcc = "udes";
    }
    parse(i) {
        this.parseFullHeader(i), this.lang = i.readCString(), this.name = i.readCString(), this.description = i.readCString(), this.tags = i.readCString();
    }
}, $e833773b1f4e7d0f$var$gf = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "UncompressedFrameConfigBox";
    }
    static{
        this.fourcc = "uncC";
    }
    parse(i) {
        if (this.parseFullHeader(i), this.profile = i.readString(4), this.version !== 1) {
            if (this.version === 0) {
                this.component_count = i.readUint32(), this.component_index = [], this.component_bit_depth_minus_one = [], this.component_format = [], this.component_align_size = [];
                for(let t = 0; t < this.component_count; t++)this.component_index.push(i.readUint16()), this.component_bit_depth_minus_one.push(i.readUint8()), this.component_format.push(i.readUint8()), this.component_align_size.push(i.readUint8());
                this.sampling_type = i.readUint8(), this.interleave_type = i.readUint8(), this.block_size = i.readUint8();
                let e = i.readUint8();
                this.component_little_endian = e >> 7 & 1, this.block_pad_lsb = e >> 6 & 1, this.block_little_endian = e >> 5 & 1, this.block_reversed = e >> 4 & 1, this.pad_unknown = e >> 3 & 1, this.pixel_size = i.readUint32(), this.row_align_size = i.readUint32(), this.tile_align_size = i.readUint32(), this.num_tile_cols_minus_one = i.readUint32(), this.num_tile_rows_minus_one = i.readUint32();
            }
        }
    }
}, $e833773b1f4e7d0f$var$_f = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "DataEntryUrnBox";
    }
    static{
        this.fourcc = "urn ";
    }
    parse(i) {
        this.parseFullHeader(i), this.name = i.readCString(), this.size - this.hdr_size - this.name.length - 1 > 0 && (this.location = i.readCString());
    }
    write(i) {
        this.version = 0, this.flags = 0, this.size = this.name.length + 1 + (this.location ? this.location.length + 1 : 0), this.writeHeader(i), i.writeCString(this.name), this.location && i.writeCString(this.location);
    }
}, $e833773b1f4e7d0f$var$xf = class extends $e833773b1f4e7d0f$var$y {
    constructor(){
        super(...arguments), this.box_name = "WebVTTConfigurationBox";
    }
    static{
        this.fourcc = "vttC";
    }
    parse(i) {
        this.text = i.readString(this.size - this.hdr_size);
    }
}, $e833773b1f4e7d0f$var$yf = class extends $e833773b1f4e7d0f$var$x {
    constructor(){
        super(...arguments), this.box_name = "VvcNALUConfigBox";
    }
    static{
        this.fourcc = "vvnC";
    }
    parse(i) {
        this.parseFullHeader(i);
        let e = i.readUint8();
        this.lengthSizeMinusOne = e & 3;
    }
}, $e833773b1f4e7d0f$var$vf = class extends $e833773b1f4e7d0f$var$z {
    static{
        this.grouping_type = "alst";
    }
    parse(i) {
        let e = i.readUint16();
        this.first_output_sample = i.readUint16(), this.sample_offset = [];
        for(let s = 0; s < e; s++)this.sample_offset[s] = i.readUint32();
        let t = this.description_length - 4 - 4 * e;
        this.num_output_samples = [], this.num_total_samples = [];
        for(let s = 0; s < t / 4; s++)this.num_output_samples[s] = i.readUint16(), this.num_total_samples[s] = i.readUint16();
    }
}, $e833773b1f4e7d0f$var$bf = class extends $e833773b1f4e7d0f$var$z {
    static{
        this.grouping_type = "avll";
    }
    parse(i) {
        this.layerNumber = i.readUint8(), this.accurateStatisticsFlag = i.readUint8(), this.avgBitRate = i.readUint16(), this.avgFrameRate = i.readUint16();
    }
}, $e833773b1f4e7d0f$var$Sf = class extends $e833773b1f4e7d0f$var$z {
    static{
        this.grouping_type = "avss";
    }
    parse(i) {
        this.subSequenceIdentifier = i.readUint16(), this.layerNumber = i.readUint8();
        let e = i.readUint8();
        this.durationFlag = e >> 7, this.avgRateFlag = e >> 6 & 1, this.durationFlag && (this.duration = i.readUint32()), this.avgRateFlag && (this.accurateStatisticsFlag = i.readUint8(), this.avgBitRate = i.readUint16(), this.avgFrameRate = i.readUint16()), this.dependency = [];
        let t = i.readUint8();
        for(let s = 0; s < t; s++)this.dependency.push({
            subSeqDirectionFlag: i.readUint8(),
            layerNumber: i.readUint8(),
            subSequenceIdentifier: i.readUint16()
        });
    }
}, $e833773b1f4e7d0f$var$Tf = class extends $e833773b1f4e7d0f$var$z {
    static{
        this.grouping_type = "dtrt";
    }
    parse(i) {
        $e833773b1f4e7d0f$var$g.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
    }
}, $e833773b1f4e7d0f$var$wf = class extends $e833773b1f4e7d0f$var$z {
    static{
        this.grouping_type = "mvif";
    }
    parse(i) {
        $e833773b1f4e7d0f$var$g.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
    }
}, $e833773b1f4e7d0f$var$Uf = class extends $e833773b1f4e7d0f$var$z {
    static{
        this.grouping_type = "prol";
    }
    parse(i) {
        this.roll_distance = i.readInt16();
    }
}, $e833773b1f4e7d0f$var$Ef = class extends $e833773b1f4e7d0f$var$z {
    static{
        this.grouping_type = "rap ";
    }
    parse(i) {
        let e = i.readUint8();
        this.num_leading_samples_known = e >> 7, this.num_leading_samples = e & 127;
    }
}, $e833773b1f4e7d0f$var$If = class extends $e833773b1f4e7d0f$var$z {
    static{
        this.grouping_type = "rash";
    }
    parse(i) {
        if (this.operation_point_count = i.readUint16(), this.description_length !== 2 + (this.operation_point_count === 1 ? 2 : this.operation_point_count * 6) + 9) $e833773b1f4e7d0f$var$g.warn("BoxParser", "Mismatch in " + this.grouping_type + " sample group length"), this.data = i.readUint8Array(this.description_length - 2);
        else {
            if (this.operation_point_count === 1) this.target_rate_share = i.readUint16();
            else {
                this.target_rate_share = [], this.available_bitrate = [];
                for(let e = 0; e < this.operation_point_count; e++)this.available_bitrate[e] = i.readUint32(), this.target_rate_share[e] = i.readUint16();
            }
            this.maximum_bitrate = i.readUint32(), this.minimum_bitrate = i.readUint32(), this.discard_priority = i.readUint8();
        }
    }
}, $e833773b1f4e7d0f$var$Cf = class extends $e833773b1f4e7d0f$var$z {
    static{
        this.grouping_type = "roll";
    }
    parse(i) {
        this.roll_distance = i.readInt16();
    }
}, $e833773b1f4e7d0f$var$Bf = class extends $e833773b1f4e7d0f$var$z {
    static{
        this.grouping_type = "scif";
    }
    parse(i) {
        $e833773b1f4e7d0f$var$g.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
    }
}, $e833773b1f4e7d0f$var$Af = class extends $e833773b1f4e7d0f$var$z {
    static{
        this.grouping_type = "scnm";
    }
    parse(i) {
        $e833773b1f4e7d0f$var$g.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
    }
}, $e833773b1f4e7d0f$var$Df = class extends $e833773b1f4e7d0f$var$z {
    static{
        this.grouping_type = "seig";
    }
    parse(i) {
        this.reserved = i.readUint8();
        let e = i.readUint8();
        this.crypt_byte_block = e >> 4, this.skip_byte_block = e & 15, this.isProtected = i.readUint8(), this.Per_Sample_IV_Size = i.readUint8(), this.KID = $e833773b1f4e7d0f$var$ke(i), this.constant_IV_size = 0, this.constant_IV = 0, this.isProtected === 1 && this.Per_Sample_IV_Size === 0 && (this.constant_IV_size = i.readUint8(), this.constant_IV = i.readUint8Array(this.constant_IV_size));
    }
}, $e833773b1f4e7d0f$var$Pf = class extends $e833773b1f4e7d0f$var$z {
    static{
        this.grouping_type = "stsa";
    }
    parse(i) {
        $e833773b1f4e7d0f$var$g.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
    }
}, $e833773b1f4e7d0f$var$kf = class extends $e833773b1f4e7d0f$var$z {
    static{
        this.grouping_type = "sync";
    }
    parse(i) {
        let e = i.readUint8();
        this.NAL_unit_type = e & 63;
    }
}, $e833773b1f4e7d0f$var$Rf = class extends $e833773b1f4e7d0f$var$z {
    static{
        this.grouping_type = "tele";
    }
    parse(i) {
        let e = i.readUint8();
        this.level_independently_decodable = e >> 7;
    }
}, $e833773b1f4e7d0f$var$Ff = class extends $e833773b1f4e7d0f$var$z {
    static{
        this.grouping_type = "tsas";
    }
    parse(i) {
        $e833773b1f4e7d0f$var$g.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
    }
}, $e833773b1f4e7d0f$var$Mf = class extends $e833773b1f4e7d0f$var$z {
    static{
        this.grouping_type = "tscl";
    }
    parse(i) {
        $e833773b1f4e7d0f$var$g.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
    }
}, $e833773b1f4e7d0f$var$Of = class extends $e833773b1f4e7d0f$var$z {
    static{
        this.grouping_type = "vipr";
    }
    parse(i) {
        $e833773b1f4e7d0f$var$g.warn("BoxParser", "Sample Group type: " + this.grouping_type + " not fully parsed");
    }
}, $e833773b1f4e7d0f$var$Lf = class extends $e833773b1f4e7d0f$var$y {
    static{
        this.fourcc = "uuid";
    }
}, $e833773b1f4e7d0f$var$je = class extends $e833773b1f4e7d0f$var$x {
    static{
        this.fourcc = "uuid";
    }
}, $e833773b1f4e7d0f$var$Nf = class extends $e833773b1f4e7d0f$var$je {
    constructor(){
        super(...arguments), this.box_name = "LiveServerManifestBox";
    }
    static{
        this.uuid = "a5d40b30e81411ddba2f0800200c9a66";
    }
    parse(i) {
        this.parseFullHeader(i), this.LiveServerManifest = i.readString(this.size - this.hdr_size).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
    }
}, $e833773b1f4e7d0f$var$zf = class extends $e833773b1f4e7d0f$var$je {
    constructor(){
        super(...arguments), this.box_name = "PiffProtectionSystemSpecificHeaderBox";
    }
    static{
        this.uuid = "d08a4f1810f34a82b6c832d8aba183d3";
    }
    parse(i) {
        this.parseFullHeader(i), this.system_id = $e833773b1f4e7d0f$var$ke(i);
        let e = i.readUint32();
        e > 0 && (this.data = i.readUint8Array(e));
    }
}, $e833773b1f4e7d0f$var$Gf = class extends $e833773b1f4e7d0f$var$je {
    constructor(){
        super(...arguments), this.box_name = "PiffSampleEncryptionBox";
    }
    static{
        this.uuid = "a2394f525a9b4f14a2446c427c648df4";
    }
}, $e833773b1f4e7d0f$var$Vf = class extends $e833773b1f4e7d0f$var$je {
    constructor(){
        super(...arguments), this.box_name = "PiffTrackEncryptionBox";
    }
    static{
        this.uuid = "8974dbce7be74c5184f97148f9882554";
    }
    parse(i) {
        this.parseFullHeader(i), this.default_AlgorithmID = i.readUint24(), this.default_IV_size = i.readUint8(), this.default_KID = $e833773b1f4e7d0f$var$ke(i);
    }
}, $e833773b1f4e7d0f$var$Hf = class extends $e833773b1f4e7d0f$var$je {
    constructor(){
        super(...arguments), this.box_name = "TfrfBox";
    }
    static{
        this.uuid = "d4807ef2ca3946958e5426cb9e46a79f";
    }
    parse(i) {
        this.parseFullHeader(i), this.fragment_count = i.readUint8(), this.entries = [];
        for(let e = 0; e < this.fragment_count; e++){
            let t = 0, s = 0;
            this.version === 1 ? (t = i.readUint64(), s = i.readUint64()) : (t = i.readUint32(), s = i.readUint32()), this.entries.push({
                absolute_time: t,
                absolute_duration: s
            });
        }
    }
}, $e833773b1f4e7d0f$var$qf = class extends $e833773b1f4e7d0f$var$je {
    constructor(){
        super(...arguments), this.box_name = "TfxdBox";
    }
    static{
        this.uuid = "6d1d9b0542d544e680e2141daff757b2";
    }
    parse(i) {
        this.parseFullHeader(i), this.version === 1 ? (this.absolute_time = i.readUint64(), this.duration = i.readUint64()) : (this.absolute_time = i.readUint32(), this.duration = i.readUint32());
    }
}, $e833773b1f4e7d0f$var$Wf = class extends $e833773b1f4e7d0f$var$Lf {
    constructor(){
        super(...arguments), this.box_name = "ItemContentIDProperty";
    }
    static{
        this.uuid = "261ef3741d975bbaacbd9d2c8ea73522";
    }
    parse(i) {
        this.content_id = i.readCString();
    }
}, $e833773b1f4e7d0f$var$Qg = $e833773b1f4e7d0f$var$ul($e833773b1f4e7d0f$var$Sn);
$e833773b1f4e7d0f$var$ll($e833773b1f4e7d0f$var$fn);
var $e833773b1f4e7d0f$export$49319ecd1bc407a5 = ((s)=>(s.ERROR = "ERROR", s.SAMPLES = "SAMPLES", s.READY = "READY", s))($e833773b1f4e7d0f$export$49319ecd1bc407a5 || {}), $e833773b1f4e7d0f$var$Xf = 1, $e833773b1f4e7d0f$var$Kf = 2, $e833773b1f4e7d0f$var$$f = 8, $e833773b1f4e7d0f$var$Qf = 16, $e833773b1f4e7d0f$var$Zf = 32, $e833773b1f4e7d0f$var$Jf = 131072, $e833773b1f4e7d0f$var$ep = 1, $e833773b1f4e7d0f$var$tp = 4, $e833773b1f4e7d0f$var$ip = 256, $e833773b1f4e7d0f$var$sp = 512, $e833773b1f4e7d0f$var$rp = 1024, $e833773b1f4e7d0f$var$np = 2048;
$e833773b1f4e7d0f$var$ft.prototype.updateSampleLists = function() {
    let i, e, t, s, r = 0;
    if (this.moov !== void 0) for(; this.lastMoofIndex < this.moofs.length;){
        let n = this.moofs[this.lastMoofIndex];
        if (this.lastMoofIndex++, n.type === "moof") {
            let a = n;
            for(let o = 0; o < a.trafs.length; o++){
                let u = a.trafs[o], l = this.getTrackById(u.tfhd.track_id), h = this.getTrexById(u.tfhd.track_id);
                u.tfhd.flags & $e833773b1f4e7d0f$var$Kf ? i = u.tfhd.default_sample_description_index : i = h ? h.default_sample_description_index : 1, u.tfhd.flags & $e833773b1f4e7d0f$var$$f ? e = u.tfhd.default_sample_duration : e = h ? h.default_sample_duration : 0, u.tfhd.flags & $e833773b1f4e7d0f$var$Qf ? t = u.tfhd.default_sample_size : t = h ? h.default_sample_size : 0, u.tfhd.flags & $e833773b1f4e7d0f$var$Zf ? s = u.tfhd.default_sample_flags : s = h ? h.default_sample_flags : 0, u.sample_number = 0, u.sbgps.length > 0 && $e833773b1f4e7d0f$var$ft.initSampleGroups(l, u, u.sbgps, l.mdia.minf.stbl.sgpds, u.sgpds);
                for(let d = 0; d < u.truns.length; d++){
                    let c = u.truns[d];
                    for(let p = 0; p < c.sample_count; p++){
                        let f = i - 1, _ = s;
                        c.flags & $e833773b1f4e7d0f$var$rp ? _ = c.sample_flags[p] : p === 0 && c.flags & $e833773b1f4e7d0f$var$tp && (_ = c.first_sample_flags);
                        let m = t;
                        c.flags & $e833773b1f4e7d0f$var$sp && (m = c.sample_size[p]), l.samples_size += m;
                        let b = e;
                        c.flags & $e833773b1f4e7d0f$var$ip && (b = c.sample_duration[p]), l.samples_duration += b;
                        let S;
                        l.first_traf_merged || p > 0 ? S = l.samples[l.samples.length - 1].dts + l.samples[l.samples.length - 1].duration : u.tfdt ? S = u.tfdt.baseMediaDecodeTime : S = 0;
                        let C = S;
                        c.flags & $e833773b1f4e7d0f$var$np && (C = S + c.sample_composition_time_offset[p]);
                        let j = !!(u.tfhd.flags & $e833773b1f4e7d0f$var$Xf), N = !!(u.tfhd.flags & $e833773b1f4e7d0f$var$Jf), P = !!(c.flags & $e833773b1f4e7d0f$var$ep), G = 0;
                        j ? G = u.tfhd.base_data_offset : N || d === 0 ? G = a.start ?? 0 : G = r;
                        let R;
                        d === 0 && p === 0 ? P ? R = G + c.data_offset : R = G : R = r, r = R + m;
                        let X = u.sample_number;
                        u.sample_number++;
                        let w = {
                            cts: C,
                            description_index: f,
                            description: l.mdia.minf.stbl.stsd.entries[f],
                            dts: S,
                            duration: b,
                            moof_number: this.lastMoofIndex,
                            number_in_traf: X,
                            number: l.samples.length,
                            offset: R,
                            size: m,
                            timescale: l.mdia.mdhd.timescale,
                            track_id: l.tkhd.track_id,
                            is_sync: !(_ >> 16 & 1),
                            is_leading: _ >> 26 & 3,
                            depends_on: _ >> 24 & 3,
                            is_depended_on: _ >> 22 & 3,
                            has_redundancy: _ >> 20 & 3,
                            degradation_priority: _ & 65535
                        };
                        u.first_sample_index = l.samples.length, l.samples.push(w), (u.sbgps.length > 0 || u.sgpds.length > 0 || l.mdia.minf.stbl.sbgps.length > 0 || l.mdia.minf.stbl.sgpds.length > 0) && $e833773b1f4e7d0f$var$ft.setSampleGroupProperties(l, w, w.number_in_traf ?? 0, u.sample_groups_info);
                    }
                }
                if (u.subs) {
                    l.has_fragment_subsamples = !0;
                    let d = u.first_sample_index;
                    for(let c = 0; c < u.subs.entries.length; c++){
                        d += u.subs.entries[c].sample_delta;
                        let p = l.samples[d - 1];
                        p.subsamples = u.subs.entries[c].subsamples;
                    }
                }
            }
        }
    }
};
var $e833773b1f4e7d0f$export$a135db7b815fe660 = class extends (0, (/*@__PURE__*/$parcel$interopDefault($jOCUE))) {
    _file = $e833773b1f4e7d0f$var$ti();
    _offset = 0;
    _isReady = !1;
    get isReady() {
        return this._isReady;
    }
    get info() {
        return this._file.getInfo();
    }
    constructor(e){
        super(), this._file.onReady = (t)=>{
            this._isReady = !0;
            for (let s of t.tracks)(e === void 0 || e.includes(s.id)) && this._file.setExtractionOptions(s.id);
            this.emit("READY", t);
        }, this._file.onError = (t)=>{
            this.emit("ERROR", t);
        }, this._file.onSamples = (t, s, r)=>{
            this.emit("SAMPLES", t, r), this._file.releaseUsedSamples(t, r[r.length - 1].number);
        };
    }
    getArrayBuffer(e) {
        if (e instanceof ArrayBuffer) return $e833773b1f4e7d0f$var$$.fromArrayBuffer(e, this._offset);
        let t = new ArrayBuffer(e.byteLength);
        return new Uint8Array(t).set(e), $e833773b1f4e7d0f$var$$.fromArrayBuffer(t, this._offset);
    }
    write(e) {
        let t = this.getArrayBuffer(e);
        this._offset += t.byteLength, this._file.appendBuffer(t);
    }
    flush() {
        this._file.flush(), this._offset = 0;
    }
    start() {
        this._file.start();
    }
    stop() {
        this._file.stop(), this._file.flush(), this._offset = 0;
    }
    seek(e) {
        this._file.seek(e, !0);
    }
    getAudioConfig(e) {
        return this._file.getTrackById(e)?.mdia?.minf?.stbl?.stsd?.entries[0]?.esds?.esd?.descs[0]?.descs[0]?.data;
    }
    getVideoConfig(e) {
        let s = this._file.getTrackById(e)?.mdia?.minf?.stbl?.stsd?.entries[0];
        if (s === void 0) return;
        let r = s.avcC || s.hvcC || s.vpcC || s.av1C;
        if (!r) return;
        let n = new $e833773b1f4e7d0f$var$V(void 0, 0, $e833773b1f4e7d0f$var$ns.BIG_ENDIAN);
        return r.write(n), new Uint8Array(n.buffer, 8);
    }
};
var $e833773b1f4e7d0f$export$a0dc6448a77581eb = ((a)=>(a.MediaSource = "MediaSource", a.Video = "Video", a.MediaCapabilitiesStream = "MediaCapabilitiesStream", a.MediaCapabilitiesFile = "MediaCapabilitiesFile", a.VideoDecoder = "VideoDecoder", a.AudioDecoder = "AudioDecoder", a))($e833773b1f4e7d0f$export$a0dc6448a77581eb || {}), $e833773b1f4e7d0f$export$850b3343ef1018ff = class i {
    _video = null;
    _header = null;
    _demuxer = new $e833773b1f4e7d0f$export$a135db7b815fe660;
    _checks = new Map([
        [
            "MediaSource",
            async (e)=>"MediaSource" in globalThis && globalThis.MediaSource.isTypeSupported(e.mimeType) || "ManagedMediaSource" in globalThis && globalThis.ManagedMediaSource.isTypeSupported(e.mimeType)
        ],
        [
            "Video",
            async (e)=>this._video === null || this._video.canPlayType(e.mimeType) !== ""
        ],
        [
            "MediaCapabilitiesStream",
            async (e)=>(await globalThis.navigator.mediaCapabilities?.decodingInfo(e))?.supported ?? !0
        ],
        [
            "MediaCapabilitiesFile",
            async (e)=>(e.type = "file", (await globalThis.navigator.mediaCapabilities?.decodingInfo(e))?.supported ?? !0)
        ],
        [
            "VideoDecoder",
            async (e)=>"VideoDecoder" in globalThis && (e.video === void 0 || (await globalThis.VideoDecoder.isConfigSupported(e.video)).supported === !0)
        ],
        [
            "AudioDecoder",
            async (e)=>"AudioDecoder" in globalThis && (e.audio === void 0 || (await globalThis.AudioDecoder.isConfigSupported(e.audio)).supported === !0)
        ]
    ]);
    get hasHeader() {
        return this._header !== null;
    }
    constructor(){
        this._video = globalThis.document?.createElement("video") ?? null;
    }
    static getMp4Configuration(e) {
        let t = e.tracks.filter((n)=>n.type === "video" || n.type === "audio").map((n)=>n.codec).reduce((n, a)=>n += `, ${a}`), r = {
            type: "media-source",
            mimeType: e !== null ? `video/mp4; codecs="${t}"` : "",
            codecs: t,
            tracks: []
        };
        if (e.videoTracks.length > 0) {
            r.videoTracks = [];
            for (let n of e.videoTracks)r.videoTracks.push(this.getVideoConfiguration(n));
            r.video = r.videoTracks[0], r.tracks.push(...r.videoTracks);
        }
        if (e.audioTracks.length > 0) {
            r.audioTracks = [];
            for (let n of e.audioTracks)r.audioTracks.push(this.getAudioConfiguration(n));
            r.audio = r.audioTracks[0], r.tracks.push(...r.audioTracks);
        }
        if (e.subtitleTracks.length > 0) {
            r.subtitleTracks = [];
            for (let n of e.subtitleTracks)r.subtitleTracks.push(this.getSubtitleConfiguration(n));
        }
        if (e.metadataTracks.length > 0 && e.metadataTracks.some((n)=>n.codec === "wvtt")) {
            r.subtitleTracks || (r.subtitleTracks = []);
            for (let n of e.metadataTracks)n.codec === "wvtt" && r.subtitleTracks.push(this.getSubtitleConfiguration(n));
        }
        return r.subtitleTracks && r.tracks.push(...r.subtitleTracks), r;
    }
    clear() {
        this._header = null;
    }
    setHeader(e) {
        e instanceof ArrayBuffer ? this._header = new Uint8Array(e) : this._header = e;
    }
    compareHeaders(e, t = 0) {
        if (this._header === null) return !1;
        for(let s = 0; s < e.length; s++)if (String.fromCharCode(this._header[t + s]) !== e[s]) return !1;
        return !0;
    }
    async getConfiguration() {
        return this._header === null ? null : this.compareHeaders("ftypiso", 4) ? await this.getMp4Configuration() : null;
    }
    static getVideoConfiguration(e) {
        let t = e.nb_samples * e.timescale / e.samples_duration;
        return {
            type: "video",
            contentType: `video/mp4;codecs="${e.codec}"`,
            codec: e.codec,
            bitrate: e.bitrate,
            width: e.video?.width ?? 0,
            height: e.video?.height ?? 0,
            framerate: Number.isFinite(t) ? t : 50,
            id: e.id
        };
    }
    static getAudioConfiguration(e) {
        return {
            type: "audio",
            contentType: `audio/mp4;codecs="${e.codec}"`,
            codec: e.codec,
            channels: e.audio?.channel_count.toString(),
            samplerate: e.audio?.sample_rate,
            bitrate: e.bitrate,
            numberOfChannels: e.audio?.channel_count ?? 0,
            sampleRate: e.audio?.sample_rate ?? 0,
            id: e.id
        };
    }
    static getSubtitleConfiguration(e) {
        return {
            type: "text",
            id: e.id,
            language: e.language,
            codec: e.codec
        };
    }
    async getMp4Configuration() {
        return this._header === null ? {
            type: "media-source",
            mimeType: "",
            tracks: [],
            codecs: ""
        } : (this._demuxer.write(this._header), this._demuxer.flush(), await $e833773b1f4e7d0f$export$7c9e1d487e9f2bc0(()=>this._demuxer.isReady), this._demuxer.info === null ? {
            type: "media-source",
            mimeType: "",
            tracks: [],
            codecs: ""
        } : i.getMp4Configuration(this._demuxer.info));
    }
    async checkCapability(...e) {
        let t = await this.getConfiguration();
        if (t === null) return {
            isSupported: !1,
            config: t
        };
        for (let s of e){
            if (!this._checks.has(s)) return {
                isSupported: !1,
                config: t
            };
            if (await this._checks.get(s)(t) === !1) return {
                isSupported: !1,
                config: t
            };
        }
        return {
            isSupported: !0,
            config: t
        };
    }
};
var $e833773b1f4e7d0f$export$c7986f8afdb111ee = ((s)=>(s.UNKNOWN = "unknown", s.LIVE = "live", s.ON_DEMAND = "on-demand", s))($e833773b1f4e7d0f$export$c7986f8afdb111ee || {});
var $e833773b1f4e7d0f$export$ca664994d1d54bff = ((n)=>(n[n.Error = 0] = "Error", n[n.Warning = 1] = "Warning", n[n.Informational = 2] = "Informational", n[n.Debug = 3] = "Debug", n[n.Verbose = 4] = "Verbose", n))($e833773b1f4e7d0f$export$ca664994d1d54bff || {}), $e833773b1f4e7d0f$export$ce30dbb46644d06c = class {
    static level = 1;
    static errorFunc = console.error;
    static warnFunc = console.warn;
    static logFunc = console.log;
}, $e833773b1f4e7d0f$export$57519a39c3119ec1 = class i extends $e833773b1f4e7d0f$export$ce30dbb46644d06c {
    static out(e, ...t) {
        if (e > $e833773b1f4e7d0f$export$ce30dbb46644d06c.level) return;
        let s;
        e <= 0 ? s = this.errorFunc : e === 1 ? s = this.warnFunc : s = this.logFunc, $e833773b1f4e7d0f$export$ce30dbb46644d06c.level >= 3 && t && t.unshift(i._getTime()), s(...t);
    }
    static error(...e) {
        i.out(0, ...e);
    }
    static warn(...e) {
        i.out(1, ...e);
    }
    static info(...e) {
        i.out(2, ...e);
    }
    static debug(...e) {
        i.out(3, ...e);
    }
    static verbose(...e) {
        i.out(4, ...e);
    }
    static _getTime() {
        let e = new Date;
        return ("0" + e.getHours()).slice(-2) + ":" + ("0" + e.getMinutes()).slice(-2) + ":" + ("0" + e.getSeconds()).slice(-2) + "." + ("00" + e.getMilliseconds()).slice(-3);
    }
};
var $e833773b1f4e7d0f$export$ca12f2943758ef55 = class {
    _locked = !1;
    get locked() {
        return this._locked;
    }
    async lockAsync() {
        this._locked && await $e833773b1f4e7d0f$export$7c9e1d487e9f2bc0(()=>this._locked !== !0), this._locked = !0;
    }
    tryLock() {
        return this._locked ? !1 : (this._locked = !0, !0);
    }
    unlock() {
        this._locked = !1;
    }
    async waitAsync() {
        this._locked && await $e833773b1f4e7d0f$export$7c9e1d487e9f2bc0(()=>this._locked !== !0);
    }
};
function $e833773b1f4e7d0f$export$abe4376e1bf796d6() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(i) {
        let e = Math.random() * 16 | 0;
        return (i === "x" ? e : e & 3 | 8).toString(16);
    });
}
function $e833773b1f4e7d0f$export$a4c72ae47296db0c(i) {
    return /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(i);
}
var $e833773b1f4e7d0f$export$328341dfbad2f46d = class {
    _duration;
    _maxEvents;
    _events = [];
    constructor(e, t){
        this._duration = e, this._maxEvents = t;
    }
    trigger() {
        this._events.push(performance.now());
    }
    update() {
        let e = performance.now();
        return this._events = this._events.filter((t)=>t > e - this._duration), this._events.length < this._maxEvents;
    }
    clear() {
        this._events.length = 0;
    }
};
var $e833773b1f4e7d0f$export$aa8676fc676da4a1 = ((s)=>(s.V1 = "0.0.1", s.V3 = "3.0.0", s.V4 = "4.0.0", s))($e833773b1f4e7d0f$export$aa8676fc676da4a1 || {});
var $e833773b1f4e7d0f$export$c9f38831ebbeacb6 = class extends EventTarget {
    _listeners = new Set;
    _init = null;
    _noAutomaticOnProcessed = !1;
    _isStarted = !1;
    get priority() {}
    get isRunning() {
        return this._isStarted;
    }
    init(e) {
        this._init = e;
    }
    async start() {
        this._isStarted || (this._isStarted = !0, await this.startInternal(this._init));
    }
    async stop() {
        this._isStarted && (await this.stopInternal(), this._isStarted = !1);
    }
    async process(e) {
        let t = await this.processInternal(e);
        return this._noAutomaticOnProcessed || this.onProcessed(t), t;
    }
    dispose() {
        this.removeAllEventListeners();
    }
    addEventListener(e, t, s) {
        super.addEventListener(e, t, s), this._listeners.add({
            type: e,
            listener: t,
            options: s
        });
    }
    removeEventListener(e, t, s) {
        super.removeEventListener(e, t, s), this._listeners.delete({
            type: e,
            listener: t,
            options: s
        });
    }
    removeAllEventListeners() {
        for (let e of this._listeners)super.removeEventListener(e.type, e.listener, e.options);
        this._listeners.clear();
    }
    onProcessed(e) {
        this.dispatchEvent(new CustomEvent("processed", {
            detail: e,
            composed: !0,
            bubbles: !1,
            cancelable: !0
        }));
    }
};
var $e833773b1f4e7d0f$export$f82961e691216dba = class {
    static _nodes = new Set;
    static comparePriorities(e, t) {
        return e.priority === t.priority ? 0 : e.priority === void 0 ? 1 : t.priority === void 0 ? -1 : e.priority - t.priority;
    }
    static Register(e) {
        this._nodes.add(e);
    }
    static Create(e) {
        let t = [];
        for (let r of this.RegisteredNodes){
            let n = new r;
            n.isSupported(e) && t.push(n);
        }
        if (t.length === 0) return null;
        let s = t.sort((r, n)=>this.comparePriorities(r, n)).shift();
        return t.forEach((r)=>r.dispose()), s.init(e), s;
    }
    static get RegisteredNodes() {
        return [
            ...this._nodes
        ];
    }
};
var $e833773b1f4e7d0f$export$d9bd565f488464f9 = ((t)=>(t[t.Parallel = 0] = "Parallel", t[t.Sequential = 1] = "Sequential", t))($e833773b1f4e7d0f$export$d9bd565f488464f9 || {}), $e833773b1f4e7d0f$export$b4772c72a3674b1d = class i extends $e833773b1f4e7d0f$export$c9f38831ebbeacb6 {
    get nodeName() {
        return i.name;
    }
    static get groupType() {
        return 1;
    }
    _nodes = [];
    async stop() {
        await super.stop();
        for (let e of this._nodes)await e.stop();
        this._nodes.length = 0;
    }
};
var $e833773b1f4e7d0f$export$7013175f13a2ad18 = ((d)=>(d.CONNECTION_ERROR = "CONNECTION_ERROR", d.CRITICAL_CONNECTION_ERROR = "CRITICAL_CONNECTION_ERROR", d.CONNECTION_CLOSED = "CONNECTION_CLOSED", d.DATA = "DATA", d.STREAM_NOT_FOUND_ERROR = "STREAM_NOT_FOUND_ERROR", d.STREAM_ENDED = "STREAM_ENDED", d.STREAM_TYPE_DISCOVERED = "STREAM_TYPE_DISCOVERED", d.UNAUTHORIZED = "UNAUTHORIZED", d.INVALID_TOKEN = "INVALID_TOKEN", d.TOKEN_SERVER_ERROR = "TOKEN_SERVER_ERROR", d.PT_START = "PT_START", d))($e833773b1f4e7d0f$export$7013175f13a2ad18 || {}), $e833773b1f4e7d0f$export$dd2b2277c9c98f1d = class extends (0, (/*@__PURE__*/$parcel$interopDefault($jOCUE))) {
    constructor(e){
        super();
    }
    _expectedBuffer = 500;
    _isComplete = !1;
    _duration = 1 / 0;
    _crossOrigin = "";
    _token = "";
    _includeMask = !1;
    _streamType = "unknown";
    get expectedBuffer() {
        return this._expectedBuffer;
    }
    get isComplete() {
        return this._isComplete;
    }
    get duration() {
        return this._duration;
    }
    get streamType() {
        return this._streamType;
    }
    get token() {
        return this._token;
    }
    set token(e) {
        this._token = e;
    }
    get includeMask() {
        return this._includeMask;
    }
    set includeMask(e) {
        this._includeMask = e;
    }
    get crossOrigin() {
        return this._crossOrigin;
    }
    set crossOrigin(e) {
        this._crossOrigin = e;
    }
    changeStreamType(e) {
        this._streamType != e && (this._streamType = e, this.emit("STREAM_TYPE_DISCOVERED", this._streamType));
    }
};
var $e833773b1f4e7d0f$export$cb8dde19db6bb34a = class i {
    static _sources = [];
    static Register(e) {
        i._sources.push(e);
    }
    static Create(e, t) {
        let s = this._sources.filter((r)=>r.urlTest(e));
        return s.length === 0 ? null : new s[0].ctor(e, t);
    }
    static HasDataSource(e) {
        return this._sources.some((t)=>t.urlTest(e));
    }
};
var $e833773b1f4e7d0f$export$92738401e1603719 = ((o)=>(o[o.Void = 0] = "Void", o[o.Float = 1] = "Float", o[o.Int = 2] = "Int", o[o.Bool = 3] = "Bool", o[o.String = 4] = "String", o[o.Attributes = 5] = "Attributes", o[o.Enum = 6] = "Enum", o))($e833773b1f4e7d0f$export$92738401e1603719 || {});
var $e833773b1f4e7d0f$export$3269b13795673282 = class {
    _attribute;
    _type;
    get type() {
        return this._type;
    }
    get attribute() {
        return this._attribute;
    }
    constructor(e, t){
        this._attribute = e, this._type = t;
    }
    is(e) {
        return e.includes(this._attribute);
    }
    static _getParser(e) {
        switch(e){
            case 0:
                return ()=>!0;
            case 1:
                return (t)=>t == null ? 0 : Number.parseFloat(t);
            case 2:
                return (t)=>t == null ? 0 : Number.parseInt(t);
            case 3:
                return (t)=>t == null ? !1 : t.toUpperCase() === "YES";
            case 4:
                return (t)=>t == null ? "" : t.substring(1, t.length - 1);
            case 6:
                return (t)=>t ?? "";
            case 5:
                return (t)=>null;
        }
    }
    static _getRegex(e) {
        switch(e){
            case 0:
                return /(?=.)/;
            case 1:
                return /\d+(?:\.\d+)?/;
            case 2:
                return /\d+/;
            case 3:
                return /(?:YES|NO)/i;
            case 4:
                return /".+?"/;
            case 6:
                return /.+?/;
            case 5:
                return /(?=.)/;
        }
    }
}, $e833773b1f4e7d0f$var$hs = class i extends $e833773b1f4e7d0f$export$3269b13795673282 {
    _parser;
    _valueRegex;
    constructor(e, t){
        super(e, t), this._valueRegex = i._getRegex(t), this._parser = $e833773b1f4e7d0f$export$3269b13795673282._getParser(t);
    }
    parse(e) {
        let t = new RegExp(`(${this._attribute})=(${this._valueRegex.source})(?:,|$)`).exec(e);
        return t != null && t[1] !== void 0 && t[2] !== void 0 ? this._parser(t[2]) : null;
    }
}, $e833773b1f4e7d0f$export$c9b05af3423265bb = class {
    _name;
    get name() {
        return this._name;
    }
    constructor(e){
        this._name = e;
    }
}, $e833773b1f4e7d0f$export$ab9c25261cd8c720 = class extends $e833773b1f4e7d0f$export$c9b05af3423265bb {
    _value;
    get value() {
        return this._value;
    }
    constructor(e, t){
        super(e), this._value = t;
    }
}, $e833773b1f4e7d0f$export$dbffdffe9ee784bd = class {
    static _rules = [];
    static Register(e, t) {
        this._rules.push(new $e833773b1f4e7d0f$var$hs(e.toUpperCase(), t));
    }
    static Get(e) {
        let t = this._rules.find((s)=>s.is(e));
        if (t === void 0) return null;
        switch(t.type){
            case 0:
                return new $e833773b1f4e7d0f$export$ab9c25261cd8c720(t.attribute, t.parse(e) ?? !1);
            case 1:
            case 2:
                return new $e833773b1f4e7d0f$export$ab9c25261cd8c720(t.attribute, t.parse(e) ?? 0);
            case 3:
                return new $e833773b1f4e7d0f$export$ab9c25261cd8c720(t.attribute, t.parse(e) ?? !1);
            case 4:
                return new $e833773b1f4e7d0f$export$ab9c25261cd8c720(t.attribute, t.parse(e) ?? "");
            case 6:
                return new $e833773b1f4e7d0f$export$ab9c25261cd8c720(t.attribute, t.parse(e) ?? "");
        }
        return null;
    }
};
var $e833773b1f4e7d0f$var$ni = class {
    _tag;
    _type;
    _regex;
    get tag() {
        return this._tag;
    }
    get type() {
        return this._type;
    }
    constructor(e, t){
        this._tag = e, this._type = t;
        let s = this.tag === "M3U" || this.tag === "INF" ? `#EXT${this.tag}` : `#EXT-X-${this.tag}`;
        this._regex = new RegExp(`${s}(?::|$)`);
    }
    is(e) {
        return this.tag === "" ? !e.startsWith("#") : this._regex.test(e);
    }
    value(e) {
        if (this.tag === "") return e;
        let t = e.split(":");
        if (t.length < 2) return null;
        let s = t.slice(1).join(":");
        return s.endsWith(",") ? s.substring(0, s.length - 1) : s;
    }
    static _getParser(e) {
        switch(e){
            case 0:
                return ()=>!0;
            case 1:
                return (t)=>t == null ? 0 : Number.parseFloat(t);
            case 2:
                return (t)=>t == null ? 0 : Number.parseInt(t);
            case 3:
                return (t)=>t == null ? !1 : t.toUpperCase() === "YES";
            case 4:
                return (t)=>t ?? "";
            case 6:
                return (t)=>t ?? "";
            case 5:
                return (t)=>t === null ? null : t.split(",").map((s)=>$e833773b1f4e7d0f$export$dbffdffe9ee784bd.Get(s));
        }
    }
}, $e833773b1f4e7d0f$var$cs = class extends $e833773b1f4e7d0f$var$ni {
    _parser;
    constructor(e, t){
        super(e, t), this._parser = $e833773b1f4e7d0f$var$ni._getParser(t);
    }
    parse(e) {
        return this._parser(this.value(e));
    }
}, $e833773b1f4e7d0f$export$4c0feda3e1a7cdf6 = class {
    _name;
    get name() {
        return this._name;
    }
    constructor(e){
        this._name = e;
    }
}, $e833773b1f4e7d0f$export$3288d34c523a1192 = class extends $e833773b1f4e7d0f$export$4c0feda3e1a7cdf6 {
    _value;
    get value() {
        return this._value;
    }
    constructor(e, t){
        super(e), this._value = t;
    }
}, $e833773b1f4e7d0f$export$30cfa27479c0d294 = class {
    static _rules = [];
    static Register(e, t) {
        this._rules.push(new $e833773b1f4e7d0f$var$cs(e.toUpperCase(), t));
    }
    static Get(e) {
        let t = this._rules.find((s)=>s.is(e));
        if (t === void 0) return null;
        switch(t.type){
            case 0:
                return new $e833773b1f4e7d0f$export$3288d34c523a1192(t.tag, t.parse(e) ?? !1);
            case 1:
            case 2:
                return new $e833773b1f4e7d0f$export$3288d34c523a1192(t.tag, t.parse(e) ?? 0);
            case 3:
                return new $e833773b1f4e7d0f$export$3288d34c523a1192(t.tag, t.parse(e) ?? !1);
            case 4:
                return new $e833773b1f4e7d0f$export$3288d34c523a1192(t.tag, t.parse(e) ?? "");
            case 6:
                return new $e833773b1f4e7d0f$export$3288d34c523a1192(t.tag, t.parse(e) ?? "");
            case 5:
                return new $e833773b1f4e7d0f$export$3288d34c523a1192(t.tag, t.parse(e) ?? []);
        }
    }
};
var $e833773b1f4e7d0f$export$7acfa6ed01010e37 = class {
    _parseTags(e) {
        let t = [];
        for (let s of e.split(/\r?\n/)){
            let r = $e833773b1f4e7d0f$export$30cfa27479c0d294.Get(s);
            r !== null && t.push(r);
        }
        return t;
    }
    _getDatum(e, t) {
        let s = e.find((r)=>r?.name === t);
        return s === void 0 ? null : s;
    }
    _getValue(e, t) {
        let s = this._getDatum(e, t);
        return s === null ? null : s.value;
    }
    _getAttributeValue(e, t, s) {
        let r = this._getDatum(e, t);
        return r === null ? null : this._getValue(r.value, s);
    }
    parse(e, t) {
        let s = this._parseTags(e);
        if (!this._getValue(s, "M3U")) return null;
        if (s.some((h)=>h.name === "STREAM-INF")) {
            let h = [], d = s.filter((c)=>c.name === "MEDIA").map((c)=>c);
            for (let c of d){
                let p = this._getValue(c.value, "URI"), f = this._getValue(c.value, "TYPE");
                p === null || f === null || h.push({
                    uri: new URL(p, t),
                    type: f
                });
            }
            for(let c = 0; c < s.length; c++){
                if (s[c].name !== "STREAM-INF") continue;
                let p = s[c], f = this._getValue(p.value, "TYPE"), _ = s[++c], m = {
                    uri: new URL(_.value, t),
                    type: f ?? h.filter((b)=>b.type === "AUDIO").length > 0 ? "VIDEO" : "COMBINED"
                };
                h.push(m);
            }
            return {
                playlists: h
            };
        }
        let r = this._getValue(s, "MEDIA-SEQUENCE") ?? 0, n = [], a = -1;
        for(let h = 0; h < s.length; h++){
            if (s[h].name !== "INF") continue;
            a++;
            let d = s[h], c = s[++h], p = c.value.lastIndexOf("/"), f = c.value.lastIndexOf("."), _ = c.value.substring(p + 1, f), m = {
                uri: new URL(c.value, t),
                duration: d.value,
                id: _,
                index: r + a,
                mediaType: null
            };
            n.push(m);
        }
        let o = s.filter((h)=>h.name === "PART"), u = [];
        a = -1;
        for (let h of o){
            let d = h, c = this._getValue(d.value, "URI");
            if (c === null) continue;
            let p = c.split("."), f = p.slice(0, -2).join("."), _ = f.lastIndexOf("/"), m = this._getValue(d.value, "DURATION") ?? 0, b = this._getValue(d.value, "INDEPENDENT") ?? !1, S = Number.parseInt(p[p.length - 2]) ?? 0, C = n.find((N)=>N.id === f)?.index;
            C != null && (a = C);
            let j = {
                id: f.substring(_ + 1),
                duration: m,
                independent: b,
                partIndex: S,
                index: C ?? a + 1,
                uri: new URL(c, t),
                mediaType: null
            };
            u.push(j);
        }
        let l = this._getAttributeValue(s, "MAP", "URI");
        return {
            id: r,
            type: this._getValue(s, "PLAYLIST-TYPE") ?? "",
            targetDuration: this._getValue(s, "TARGETDURATION") ?? 0,
            partTargetDuration: this._getAttributeValue(s, "PART-INF", "PART-TARGET"),
            initUrl: l !== null ? new URL(l, t) : null,
            segments: n,
            fragments: u,
            endList: this._getValue(s, "ENDLIST"),
            uri: new URL(t.toString()),
            mediaType: null
        };
    }
};
$e833773b1f4e7d0f$export$dbffdffe9ee784bd.Register("PART-TARGET", 1);
$e833773b1f4e7d0f$export$dbffdffe9ee784bd.Register("INDEPENDENT", 3);
$e833773b1f4e7d0f$export$dbffdffe9ee784bd.Register("DURATION", 1);
$e833773b1f4e7d0f$export$dbffdffe9ee784bd.Register("URI", 4);
$e833773b1f4e7d0f$export$dbffdffe9ee784bd.Register("TYPE", 6);
$e833773b1f4e7d0f$export$30cfa27479c0d294.Register("M3U", 0);
$e833773b1f4e7d0f$export$30cfa27479c0d294.Register("VERSION", 2);
$e833773b1f4e7d0f$export$30cfa27479c0d294.Register("MEDIA", 5);
$e833773b1f4e7d0f$export$30cfa27479c0d294.Register("STREAM-INF", 5);
$e833773b1f4e7d0f$export$30cfa27479c0d294.Register("MEDIA-SEQUENCE", 2);
$e833773b1f4e7d0f$export$30cfa27479c0d294.Register("PART-INF", 5);
$e833773b1f4e7d0f$export$30cfa27479c0d294.Register("MAP", 5);
$e833773b1f4e7d0f$export$30cfa27479c0d294.Register("TARGETDURATION", 1);
$e833773b1f4e7d0f$export$30cfa27479c0d294.Register("PLAYLIST-TYPE", 4);
$e833773b1f4e7d0f$export$30cfa27479c0d294.Register("ENDLIST", 0);
$e833773b1f4e7d0f$export$30cfa27479c0d294.Register("INF", 1);
$e833773b1f4e7d0f$export$30cfa27479c0d294.Register("PART", 5);
$e833773b1f4e7d0f$export$30cfa27479c0d294.Register("", 4);
function $e833773b1f4e7d0f$export$ee6b3261831ac136(i) {
    return "playlists" in i;
}
function $e833773b1f4e7d0f$export$cb08cd3f248be4de(i) {
    return !$e833773b1f4e7d0f$export$ee6b3261831ac136(i);
}
var $e833773b1f4e7d0f$var$Cu = $e833773b1f4e7d0f$var$Hu($e833773b1f4e7d0f$var$Iu(), 1);
function $e833773b1f4e7d0f$export$9522e17588c12572(i) {
    return "partIndex" in i;
}
function $e833773b1f4e7d0f$export$f077a0a8bc674ed4(i, e) {
    return $e833773b1f4e7d0f$export$9522e17588c12572(i) != $e833773b1f4e7d0f$export$9522e17588c12572(e) ? !1 : $e833773b1f4e7d0f$export$9522e17588c12572(i) && $e833773b1f4e7d0f$export$9522e17588c12572(e) ? i.index === e.index && i.partIndex === e.partIndex && i.mediaType === e.mediaType : i.index === e.index && i.mediaType === e.mediaType;
}
var $e833773b1f4e7d0f$export$a0320a29d38259b9 = class i extends $e833773b1f4e7d0f$export$dd2b2277c9c98f1d {
    get name() {
        return "HLS";
    }
    static _UPDATE_TIMEOUT = 10;
    static _MANIFEST_FAILED_TIMEOUT = 1e3;
    _transmuxer = new $e833773b1f4e7d0f$var$Cu.default.mp4.Transmuxer;
    _parser = new $e833773b1f4e7d0f$export$7acfa6ed01010e37;
    _segmentsQueue = [];
    _dataQueue = [];
    _readSegments = [];
    _fetchingSegments = [];
    _readManifestTimeout = null;
    _processSegmentsTimeout = null;
    _processDataTimeout = null;
    _segmentsPerManifest = 32768;
    _lastSegment = null;
    _readInitSegment = !1;
    _isRunning;
    _nextSegmentNumber = null;
    _nextFragmentNumber = null;
    _targetDuration = 0;
    _cachedSegments = [];
    _queueId = 0;
    _abortController = new AbortController;
    get canFetch() {
        return this.streamType == "live" ? !0 : this._fetchingSegments.length == 0;
    }
    get requestInit() {
        return this.crossOrigin === "" ? {
            signal: this._abortController.signal
        } : {
            credentials: this.crossOrigin === "anonymous" ? "same-origin" : "include",
            mode: this.crossOrigin === "anonymous" ? "same-origin" : "cors",
            signal: this._abortController.signal
        };
    }
    async getErrorMessage(e) {
        if (e.statusText !== "") return e.statusText;
        if (e.headers.get("content-type") === "application/json") try {
            return (await e.json())?.message ?? "";
        } catch  {
            return "";
        }
        return "";
    }
    async fetchPlaylist(e) {
        let t = null;
        try {
            if (this._nextSegmentNumber != null && e.searchParams.set("_HLS_msn", this._nextSegmentNumber.toString()), this._nextFragmentNumber != null && e.searchParams.set("_HLS_part", this._nextFragmentNumber.toString()), t = await fetch(e, this.requestInit), !t.ok) {
                if (t.status === 403) {
                    let r = await this.getErrorMessage(t);
                    this.emit("UNAUTHORIZED", r), this._isRunning = !1;
                }
                return null;
            }
        } catch  {
            return null;
        }
        let s = await t.text();
        return this._parser.parse(s, e);
    }
    static compareMediaTypes(e, t) {
        return e.type === t.type ? 0 : e.type === "COMBINED" ? -1 : t.type === "COMBINED" ? 1 : e.type === "VIDEO" && t.type === "AUDIO" ? -1 : e.type === "AUDIO" && t.type === "VIDEO" ? 1 : 0;
    }
    async parseManifest(e) {
        let t = await this.fetchPlaylist(e);
        if (t === null) return null;
        if ($e833773b1f4e7d0f$export$ee6b3261831ac136(t)) {
            let s = [];
            for (let r of t.playlists.sort((n, a)=>i.compareMediaTypes(n, a)).slice(0, 1)){
                if (s.some((a)=>a.mediaType === r.type)) continue;
                let n = await this.fetchPlaylist(r.uri);
                n === null || !$e833773b1f4e7d0f$export$cb08cd3f248be4de(n) || (n.mediaType = r.type, n.segments.forEach((a)=>a.mediaType = n.mediaType), n.fragments.forEach((a)=>a.mediaType = n.mediaType), s.push(n));
            }
            return s;
        }
        return [
            t
        ];
    }
    async readManifest(e) {
        if (!this._isRunning) return;
        let t = await this.parseManifest(e);
        if (t === null) {
            this._readManifestTimeout = setTimeout(()=>{
                this.readManifest(e);
            }, i._MANIFEST_FAILED_TIMEOUT);
            return;
        }
        let s = 0;
        if (!this._readInitSegment && t.some((r)=>r.initUrl)) {
            for (let r of t.filter((n)=>n.initUrl)){
                let n = {
                    uri: r.initUrl,
                    duration: 0,
                    id: "init",
                    index: null,
                    mediaType: r.mediaType
                };
                this._segmentsQueue.push(n);
            }
            this._readInitSegment = !0;
        }
        for (let r of t){
            if (this._segmentsPerManifest < Math.max(r.segments.length, r.fragments.length) && (this._segmentsPerManifest = Math.max(r.segments.length, r.fragments.length)), r.type === "VOD" ? (this._isComplete = !0, this._duration = r.segments.map((n)=>n.duration).reduce((n, a)=>n += a), this.changeStreamType("on-demand")) : (this._duration = 1 / 0, this.changeStreamType("live")), this._targetDuration = r.targetDuration, r.partTargetDuration === null) {
                let n = 0;
                if (r.type !== "VOD" && r.endList !== !0) {
                    r.segments = r.segments.filter((u)=>this._lastSegment === null || (u.index ?? -1) >= this._lastSegment);
                    let o = r.segments.length;
                    for(let u = o - 1; u >= 0; u--)if (n += r.segments[u].duration, n >= r.targetDuration) {
                        r.segments = r.segments.slice(u === o - 1 ? u : u + 1);
                        break;
                    }
                    r.segments.length > 0 && (this._lastSegment = r.segments[r.segments.length - 1].index);
                }
                if (r.targetDuration > 0 && r.endList !== !0 && r.type !== "VOD") {
                    let o = n !== 0 ? n : r.targetDuration;
                    (s === null || s < o) && (s = o);
                }
                for (let o of r.segments)this._segmentsQueue.findIndex((u)=>$e833773b1f4e7d0f$export$f077a0a8bc674ed4(u, o)) !== -1 || this._readSegments.findIndex((u)=>$e833773b1f4e7d0f$export$f077a0a8bc674ed4(u, o)) !== -1 || this._fetchingSegments.findIndex((u)=>$e833773b1f4e7d0f$export$f077a0a8bc674ed4(u, o)) !== -1 || this._segmentsQueue.push(o);
                this._expectedBuffer < r.targetDuration * 1500 && (this._expectedBuffer = r.targetDuration * 1500);
                let a = r.segments[r.segments.length - 1];
                a !== void 0 && a.index != null && (this._nextSegmentNumber = a.index + 1);
            } else {
                for (let o of r.fragments)this._segmentsQueue.findIndex((u)=>$e833773b1f4e7d0f$export$f077a0a8bc674ed4(u, o)) !== -1 || this._readSegments.findIndex((u)=>$e833773b1f4e7d0f$export$f077a0a8bc674ed4(u, o)) !== -1 || this._fetchingSegments.findIndex((u)=>$e833773b1f4e7d0f$export$f077a0a8bc674ed4(u, o)) !== -1 || this._segmentsQueue.push(o);
                r.partTargetDuration !== null && r.partTargetDuration > 0 && r.endList !== !0 && r.type !== "VOD" && (s === null || s < r.partTargetDuration) && (s = r.partTargetDuration), this._expectedBuffer < r.targetDuration * 1500 && (this._expectedBuffer = r.targetDuration * 1500);
                let n = r.segments[r.segments.length - 1], a = r.fragments[r.fragments.length - 1];
                n !== void 0 && n.index != null ? a === void 0 || n.id === a.id ? (this._nextSegmentNumber = n.index + 1, this._nextFragmentNumber = 0) : a !== void 0 && (this._nextSegmentNumber = a.index, this._nextFragmentNumber = a.partIndex + 1) : n === void 0 && a !== void 0 && (this._nextSegmentNumber = a.index, this._nextFragmentNumber = a.partIndex + 1);
            }
            (r.endList === !0 || r.type === "VOD") && (s = null, this._isComplete = !0);
        }
        s !== null && (this._readManifestTimeout = setTimeout(()=>{
            this.readManifest(e);
        }, s * 1e3));
    }
    async processSegments() {
        if (this._isRunning) {
            if (this.canFetch) {
                let e = this._segmentsQueue.shift();
                if (e !== void 0) {
                    let t = this._cachedSegments.find((s)=>s.segment.uri === e.uri);
                    if (t !== void 0) this.emit("DATA", t.data.buffer), this._readSegments.push(t.segment);
                    else try {
                        this._fetchingSegments.push(e);
                        let s = await fetch(e.uri, this.requestInit);
                        if (this.streamType === "on-demand" && s.status === 403) {
                            let r = await this.getErrorMessage(s);
                            this.emit("UNAUTHORIZED", r), this._isRunning = !1;
                        } else {
                            let r = await s.arrayBuffer(), n = new Uint8Array(r), a = s.headers.get("content-type")?.toLowerCase();
                            a === "video/mp2t" || a === "application/octet-stream" && /.*\.ts(?=\?|$)/.test(e.uri.toString()) ? this._dataQueue.push(n) : (this._isComplete && this._cachedSegments.push({
                                segment: e,
                                data: n
                            }), this.emit("DATA", n.buffer, this._queueId)), this._readSegments.push(e);
                        }
                    } catch (s) {
                        this.streamType == "on-demand" ? this._segmentsQueue.unshift(e) : s.name !== "AbortError" && $e833773b1f4e7d0f$export$57519a39c3119ec1.warn(s);
                    } finally{
                        this._fetchingSegments.splice(this._fetchingSegments.indexOf(e), 1);
                    }
                }
                this._readSegments.length > this._segmentsPerManifest && this._readSegments.shift();
            }
            this._processSegmentsTimeout = setTimeout(()=>{
                this.processSegments();
            }, i._UPDATE_TIMEOUT);
        }
    }
    async processData() {
        if (!this._isRunning) return;
        let e = this._dataQueue.shift();
        e !== void 0 && (this._transmuxer.push(e), this._transmuxer.flush()), this._processDataTimeout = setTimeout(()=>{
            this.processData();
        }, i._UPDATE_TIMEOUT);
    }
    _onData = (e)=>{
        let t = new Uint8Array(e.initSegment.byteLength + e.data.byteLength);
        t.set(e.initSegment, 0), t.set(e.data, e.initSegment.byteLength), this.emit("DATA", t.buffer);
    };
    constructor(e){
        super(e), this._isRunning = !0, this._transmuxer.on("data", this._onData), (async ()=>await this.readManifest(new URL(e)))(), (async ()=>await this.processSegments())(), (async ()=>await this.processData())();
    }
    dispose() {
        this._isRunning = !1, this._abortController.abort(), this._transmuxer.off("data", this._onData), this._readManifestTimeout !== null && (clearTimeout(this._readManifestTimeout), this._readManifestTimeout = null), this._processSegmentsTimeout !== null && (clearTimeout(this._processSegmentsTimeout), this._processSegmentsTimeout = null), this._processDataTimeout !== null && (clearTimeout(this._processDataTimeout), this._processDataTimeout = null), this._dataQueue.length = 0, this._cachedSegments.length = 0;
    }
    seek(e) {
        if (this.streamType != "on-demand") return;
        this._isRunning = !1;
        let t = [], s = [], r = 0, n = !0;
        for (let a of [
            ...this._readSegments,
            ...this._segmentsQueue
        ])n && r + a.duration >= e - this._targetDuration * 2 && (n = !1), n ? (t.push(a), r += a.duration) : s.push(a);
        this._readSegments.length = 0, this._segmentsQueue.length = 0, this._dataQueue.length = 0, this._fetchingSegments.length = 0, this._transmuxer.reset(), this._readSegments.push(...t), this._segmentsQueue.push(...s), this._queueId++, this._isRunning = !0, (async ()=>await this.processSegments())(), (async ()=>await this.processData())();
    }
};
$e833773b1f4e7d0f$export$cb8dde19db6bb34a.Register({
    urlTest: (i)=>{
        if (URL.canParse !== void 0 && !URL.canParse(i) || URL.canParse === void 0 && (i == "" || i == null || i == null || !/^https?:\/\/.+\.m3u8(?:$|\?|\/)/.test(i))) return !1;
        let e = new URL(i);
        return /^https?:$/.test(e.protocol) && e.pathname.endsWith(".m3u8");
    },
    ctor: $e833773b1f4e7d0f$export$a0320a29d38259b9
});
function $e833773b1f4e7d0f$var$rr(i) {
    return "error" in i;
}
function $e833773b1f4e7d0f$var$Pg(i) {
    return $e833773b1f4e7d0f$var$rr(i) && "code" in i;
}
function $e833773b1f4e7d0f$var$kg(i) {
    return i.url == "stream/qual" && "connid" in i;
}
var $e833773b1f4e7d0f$export$562a36df7fd8444 = class extends $e833773b1f4e7d0f$export$dd2b2277c9c98f1d {
    _fmp4ProtocolVersion;
    _webSocket;
    _commandMap = new Map;
    get name() {
        return "FMP4";
    }
    get token() {
        return super.token;
    }
    set token(e) {
        super.token = e, this.play();
    }
    get includeMask() {
        return super.includeMask;
    }
    set includeMask(e) {
        super.includeMask = e, this.play();
    }
    get isOpen() {
        return this._webSocket !== null && this._webSocket.readyState === WebSocket.OPEN;
    }
    constructor(e, t){
        if (super(e), this._fmp4ProtocolVersion = t?.fmp4ProtocolVersion ?? "4.0.0", e.startsWith("fmp4://")) e = "ws" + e.substring(4);
        else if (e.startsWith("fmp4s://")) e = "wss" + e.substring(5);
        else throw new Error("Wrong url.");
        this._webSocket = new WebSocket(e), this._webSocket.binaryType = "arraybuffer", this._webSocket.onopen = ()=>{
            this.send("hello"), this.changeStreamType("live");
        }, this._webSocket.onmessage = this.onMessage, this._webSocket.onerror = (s)=>{
            this.emit(this.isOpen ? "CONNECTION_ERROR" : "CRITICAL_CONNECTION_ERROR", s.message);
        }, this._webSocket.onclose = ()=>{
            this.emit("CONNECTION_CLOSED");
        };
    }
    dispose() {
        this.stop(), this._webSocket && (this._webSocket.onmessage = null, this._webSocket.onclose = null, (this._webSocket.readyState === WebSocket.OPEN || this._webSocket.readyState == WebSocket.CONNECTING) && this._webSocket.close(), this._webSocket = null), this.removeAllListeners();
    }
    seek(e) {}
    onMessage = (e)=>{
        typeof e.data == "string" ? this.onTextMessage(e.data) : this.onBinaryMessage(e.data);
    };
    play() {
        this.send("play", {
            includeMask: this.includeMask,
            passthroughToken: this.token
        });
    }
    stop() {
        this.send("stop");
    }
    handleCode(e) {
        if ($e833773b1f4e7d0f$var$Pg(e)) switch(e.code){
            case "PT_START_SUCCESS":
                return this.emit("PT_START"), !0;
            case "PT_START_FAIL_TOKEN_INVALID":
                return this.emit("INVALID_TOKEN"), !0;
            case "PT_START_FAIL_TOKEN_TIMEOUT":
                return this.play(), !0;
            case "PT_START_FAIL_SERVER_FAULT":
                return this.emit("TOKEN_SERVER_ERROR", e.error), !0;
        }
        return !1;
    }
    handleError(e) {
        if ($e833773b1f4e7d0f$var$rr(e)) switch(e.error){
            case "Stream not found":
                return this.emit("STREAM_NOT_FOUND_ERROR"), !0;
            case "Stream ended":
                return this._isComplete = !0, this.emit("STREAM_ENDED"), !0;
        }
        return !1;
    }
    onTextMessage(e) {
        let t = JSON.parse(e);
        $e833773b1f4e7d0f$var$rr(t) && t.correlationId !== void 0 && this._commandMap.has(t.url) && this._commandMap.get(t.url) != t.correlationId || this.handleCode(t) || this.handleError(t) || $e833773b1f4e7d0f$var$kg(t) && this.play();
    }
    onBinaryMessage(e) {
        this.emit("DATA", e);
    }
    send(e, t = null) {
        if (!this._webSocket || !this.isOpen) return;
        let s = t || {}, r = "stream/" + e, n = $e833773b1f4e7d0f$export$abe4376e1bf796d6();
        s.url = r, s.version = this._fmp4ProtocolVersion, s.correlationId = n, this._commandMap.set(r, n), this._webSocket.send(JSON.stringify(s));
    }
};
$e833773b1f4e7d0f$export$cb8dde19db6bb34a.Register({
    urlTest: (i)=>{
        if (URL.canParse !== void 0 && !URL.canParse(i) || URL.canParse === void 0 && (i == "" || i == null || i == null || !/^fmp4s?:/.test(i))) return !1;
        let e = new URL(i);
        return /^fmp4s?:$/.test(e.protocol);
    },
    ctor: $e833773b1f4e7d0f$export$562a36df7fd8444
});
var $e833773b1f4e7d0f$export$27a4864e1e35718c = class extends $e833773b1f4e7d0f$export$dd2b2277c9c98f1d {
    _url;
    dispose() {}
    get name() {
        return "File";
    }
    seek(e) {}
    constructor(e){
        super(e), this._url = e.replace(/^file?:\/\//, globalThis.document?.baseURI != null ? new URL(globalThis.document.baseURI).origin : ""), (async ()=>await this.load())();
    }
    async fetchData(e, t) {
        let s = await fetch(e, t);
        if (!s.ok || !s.body) return;
        let r = s.body.getReader(), n = await r.read();
        for(; !n.done;)n.value && this.emit("DATA", n.value.buffer), n = await r.read();
    }
    async load() {
        let e = this.crossOrigin === null ? void 0 : {
            credentials: this.crossOrigin === "anonymous" ? "same-origin" : "include",
            mode: this.crossOrigin === "anonymous" ? "same-origin" : "cors"
        };
        await this.fetchData(this._url, e), this._isComplete = !0, this.emit("STREAM_TYPE_DISCOVERED", "on-demand");
    }
};
$e833773b1f4e7d0f$export$cb8dde19db6bb34a.Register({
    urlTest: (i)=>{
        if (URL.canParse !== void 0 && !URL.canParse(i) || URL.canParse === void 0 && (i == "" || i == null || i == null || !(/^file?:/.test(i) || /^blob\:/.test(i)))) return !1;
        let e = new URL(i);
        return /^file?:$/.test(e.protocol) || /^blob\:$/.test(e.protocol);
    },
    ctor: $e833773b1f4e7d0f$export$27a4864e1e35718c
});
var $e833773b1f4e7d0f$export$c5a1576c045df4a8 = ((r)=>(r.DATA_CONSUMED = "DATA_CONSUMED", r.ERROR = "ERROR", r.SOURCE_CHANGED = "SOURCE_CHANGED", r.TEXT_CUES = "TEXT_CUES", r))($e833773b1f4e7d0f$export$c5a1576c045df4a8 || {});
var $e833773b1f4e7d0f$export$f9d7ad0f85d99f8c = ((s)=>(s.ERROR = "ERROR", s.HEADER = "HEADER", s.SEGMENT = "SEGMENT", s))($e833773b1f4e7d0f$export$f9d7ad0f85d99f8c || {}), $e833773b1f4e7d0f$export$b7ba6b2a75ba90d5 = class extends (0, (/*@__PURE__*/$parcel$interopDefault($jOCUE))) {
    _file = $e833773b1f4e7d0f$var$ti();
    _offset = 0;
    _isReady = !1;
    _requestedTracks;
    get isReady() {
        return this._isReady;
    }
    get info() {
        return this._file.getInfo();
    }
    constructor(e){
        super(), this._requestedTracks = e, this._file.onReady = (t)=>{
            this._isReady = !0;
            for (let r of t.tracks.filter((n)=>this._requestedTracks.includes(n.id)))this._file.setExtractionOptions(r.id), this._file.setSegmentOptions(r.id, void 0, {});
            let s = this._file.initializeSegmentation();
            this.emit("HEADER", s.buffer);
        }, this._file.onError = (t)=>{
            this.emit("ERROR", t);
        }, this._file.onSegment = (t, s, r)=>{
            this.emit("SEGMENT", t, r);
        };
    }
    start() {
        this._file.start();
    }
    flush() {
        this._file.flush(), this._offset = 0;
    }
    stop() {
        this._file.stop(), this._file.flush(), this._offset = 0;
    }
    getArrayBuffer(e) {
        if (e instanceof ArrayBuffer) return $e833773b1f4e7d0f$var$$.fromArrayBuffer(e, this._offset);
        let t = new ArrayBuffer(e.byteLength);
        return new Uint8Array(t).set(e), $e833773b1f4e7d0f$var$$.fromArrayBuffer(t, this._offset);
    }
    write(e) {
        let t = this.getArrayBuffer(e);
        this._offset += t.byteLength, this._file.appendBuffer(t);
    }
};
var $e833773b1f4e7d0f$export$d9262064d3e82a38 = class i {
    static _sources = [];
    static Register(e) {
        i._sources.push(e);
    }
    static Create(e) {
        let t = this._sources.filter((s)=>s.streamTest(e));
        return t.length === 0 ? null : new t[0].ctor;
    }
};
function $e833773b1f4e7d0f$var$Mg(i) {
    return i.tracks !== void 0;
}
var $e833773b1f4e7d0f$export$b686acd414cb5f71 = class extends (0, (/*@__PURE__*/$parcel$interopDefault($jOCUE))) {
    _streamMediaSource = null;
    _muxer = null;
    _queue = [];
    get hasSourceBuffer() {
        return this._streamMediaSource?.hasSourceBuffer ?? !1;
    }
    get canUpdateSourceBuffer() {
        return this._streamMediaSource?.canUpdateSourceBuffer ?? !1;
    }
    get bufferMax() {
        return this._streamMediaSource?.bufferMax;
    }
    get mediaSource() {
        return this._streamMediaSource?.mediaSource ?? null;
    }
    constructor(e){
        if (super(), $e833773b1f4e7d0f$var$Mg(e)) this._muxer = new $e833773b1f4e7d0f$export$b7ba6b2a75ba90d5(e.tracks), this._muxer.addListener("HEADER", async (t)=>{
            this._queue.push(t);
            let s = new $e833773b1f4e7d0f$export$850b3343ef1018ff;
            s.setHeader(t);
            let r = await s.getMp4Configuration();
            this.initStreamMediaSource(r);
        }), this._muxer.addListener("SEGMENT", (t, s)=>{
            this._queue.push(s);
        });
        else {
            let t = Object.assign({}, e.config);
            t.videoTracks = void 0, this.initStreamMediaSource(t);
        }
    }
    start() {
        this._muxer?.start();
    }
    stop() {
        this.removeAllListeners(), this._muxer?.stop(), this._streamMediaSource?.dispose(), this._queue.length = 0;
    }
    appendData(e) {
        var t = new ArrayBuffer(e.byteLength);
        new Uint8Array(t).set(new Uint8Array(e)), this._muxer !== null ? this._muxer.write(t) : this._queue.push(t);
    }
    async advanceBuffer(e) {
        this._streamMediaSource?.advanceBuffer(e);
    }
    async clearBuffer(e) {
        this._streamMediaSource?.clearBuffer(e);
    }
    async endOfStream() {
        this._streamMediaSource?.endOfStream();
    }
    async seek(e) {
        this._streamMediaSource?.seek(e);
    }
    async setDuration(e) {
        this._streamMediaSource?.setDuration(e);
    }
    initStreamMediaSource(e) {
        if (this._streamMediaSource === null) {
            if (this._streamMediaSource = $e833773b1f4e7d0f$export$d9262064d3e82a38.Create(e), this._streamMediaSource === null) {
                this.emit("ERROR", "Failed to create a media source", "UNSUPPORTED_MEDIA_FORMAT");
                return;
            }
            this._streamMediaSource.setQueue(this._queue), this._streamMediaSource.init(e), this.emit("SOURCE_CHANGED");
        }
    }
};
var $e833773b1f4e7d0f$export$767933ebd734b1bc = class {
    static _vttParser = new $e833773b1f4e7d0f$var$xn;
    static _xmlParser = new $e833773b1f4e7d0f$var$yn;
    static _tx3gParser = new $e833773b1f4e7d0f$var$bn;
    static _textParser = new $e833773b1f4e7d0f$var$vn;
    static parse(e, t) {
        if (!e.data) return null;
        let s = e.dts / e.timescale, r = (e.dts + e.duration) / e.timescale, n = 0, a = (o)=>{
            let u = `${s}-${r}-${n++}`;
            return {
                start: s,
                end: r,
                text: o,
                id: u
            };
        };
        switch(t){
            case "tx3g":
                return [
                    a(this._tx3gParser.parseSample(e))
                ];
            case "wvtt":
                return this._vttParser.parseSample(e.data).map((u)=>a(u.payl ? u.payl.text : ""));
            case "metx":
            case "stpp":
                {
                    let o = this._xmlParser.parseSample(e);
                    return [
                        a(o.documentString)
                    ];
                }
            case "mett":
            case "sbtt":
            case "stxt":
                return [
                    a(this._textParser.parseSample(e))
                ];
        }
        return null;
    }
};
var $e833773b1f4e7d0f$export$489ba36c22333bef = class extends (0, (/*@__PURE__*/$parcel$interopDefault($jOCUE))) {
    _streamMediaSources = [];
    _queue = [];
    _isRunning = !1;
    _appendDataTimeout = null;
    _demuxer = null;
    get hasSourceBuffer() {
        return this._streamMediaSources.every((e)=>e.hasSourceBuffer);
    }
    get canUpdateSourceBuffer() {
        return this._streamMediaSources.every((e)=>e.canUpdateSourceBuffer);
    }
    get bufferMax() {
        let e = this._streamMediaSources.map((t)=>t.bufferMax).filter((t)=>t !== void 0);
        if (e.length !== 0) return e.reduce((t, s)=>Math.max(t, s));
    }
    get mediaSource() {
        return this._streamMediaSources.some((e)=>e.mediaSource === null) ? null : this._streamMediaSources.map((e)=>e.mediaSource);
    }
    init(e) {
        this._streamMediaSources.push(new $e833773b1f4e7d0f$export$b686acd414cb5f71({
            tracks: [
                e.videoTracks[0].id,
                e.audioTracks[0].id
            ]
        }), new $e833773b1f4e7d0f$export$b686acd414cb5f71({
            tracks: [
                e.videoTracks[1].id
            ]
        })), this._streamMediaSources.forEach((t)=>{
            t.addListener("SOURCE_CHANGED", ()=>this.emit("SOURCE_CHANGED")), t.addListener("TEXT_CUES", (s)=>this.emit("TEXT_CUES", s)), t.addListener("ERROR", (s, r)=>this.emit("ERROR", s, r)), t.start();
        }), this.emit("SOURCE_CHANGED"), this._isRunning = !0, (async ()=>await this.appendData())(), e.subtitleTracks && (this._demuxer = new $e833773b1f4e7d0f$export$a135db7b815fe660(e.subtitleTracks.map((t)=>t.id)), this._demuxer.addListener("SAMPLES", (t, s)=>{
            let r = this._demuxer?.info?.tracks.find((n)=>n.id === t);
            this.emit("TEXT_CUES", {
                trackId: t,
                language: r?.language ?? "",
                cues: s.flatMap((n)=>$e833773b1f4e7d0f$export$767933ebd734b1bc.parse(n, r?.codec ?? "")).filter((n)=>n !== null)
            });
        }), this._demuxer.start());
    }
    async advanceBuffer(e) {
        this._streamMediaSources.forEach((t)=>t.advanceBuffer(e));
    }
    async clearBuffer(e) {
        this._streamMediaSources.forEach((t)=>t.clearBuffer(e));
    }
    async endOfStream() {
        this._streamMediaSources.forEach((e)=>e.endOfStream());
    }
    async seek(e) {
        this._streamMediaSources.forEach((t)=>t.seek(e));
    }
    setQueue(e) {
        this._queue = e;
    }
    async setDuration(e) {
        this._streamMediaSources.forEach((t)=>t.setDuration(e));
    }
    dispose() {
        this.removeAllListeners(), this._isRunning = !1, this._appendDataTimeout && clearTimeout(this._appendDataTimeout), this._appendDataTimeout = null, this._streamMediaSources.forEach((e)=>e.stop()), this._demuxer && this._demuxer.stop(), this._demuxer = null;
    }
    async appendData() {
        if (!this._isRunning) return;
        let e = !1;
        for(; this._queue && this._queue.length > 0;){
            let t = this._queue.shift();
            t && (e = !0, this._streamMediaSources.forEach((s)=>s.appendData(t)), this._demuxer?.write(t));
        }
        e && this.emit("DATA_CONSUMED"), this._appendDataTimeout = setTimeout(async ()=>await this.appendData(), 10);
    }
};
$e833773b1f4e7d0f$export$d9262064d3e82a38.Register({
    streamTest: (i)=>i.videoTracks !== void 0 && i.videoTracks.length > 1,
    ctor: $e833773b1f4e7d0f$export$489ba36c22333bef
});
var $e833773b1f4e7d0f$export$25428d5deff72909 = class extends (0, (/*@__PURE__*/$parcel$interopDefault($jOCUE))) {
    _streamMediaSources = [];
    _queue = [];
    _isRunning = !1;
    _appendDataTimeout = null;
    _demuxer = null;
    get hasSourceBuffer() {
        return this._streamMediaSources.every((e)=>e.hasSourceBuffer);
    }
    get canUpdateSourceBuffer() {
        return this._streamMediaSources.every((e)=>e.canUpdateSourceBuffer);
    }
    get bufferMax() {
        let e = this._streamMediaSources.map((t)=>t.bufferMax).filter((t)=>t !== void 0);
        if (e.length !== 0) return e.reduce((t, s)=>Math.max(t, s));
    }
    get mediaSource() {
        return this._streamMediaSources.some((e)=>e.mediaSource === null) ? null : this._streamMediaSources.map((e)=>e.mediaSource);
    }
    init(e) {
        this._streamMediaSources.push(new $e833773b1f4e7d0f$export$b686acd414cb5f71({
            tracks: [
                e.videoTracks[0].id,
                e.audioTracks[0].id
            ]
        })), this._streamMediaSources.forEach((t)=>{
            t.addListener("SOURCE_CHANGED", ()=>this.emit("SOURCE_CHANGED")), t.addListener("TEXT_CUES", (s)=>this.emit("TEXT_CUES", s)), t.addListener("ERROR", (s, r)=>this.emit("ERROR", s, r)), t.start();
        }), this.emit("SOURCE_CHANGED"), this._isRunning = !0, (async ()=>await this.appendData())(), e.subtitleTracks && (this._demuxer = new $e833773b1f4e7d0f$export$a135db7b815fe660(e.subtitleTracks.map((t)=>t.id)), this._demuxer.addListener("SAMPLES", (t, s)=>{
            let r = this._demuxer?.info?.tracks.find((n)=>n.id === t);
            this.emit("TEXT_CUES", {
                trackId: t,
                language: r?.language ?? "",
                cues: s.flatMap((n)=>$e833773b1f4e7d0f$export$767933ebd734b1bc.parse(n, r?.codec ?? "")).filter((n)=>n !== null)
            });
        }), this._demuxer.start());
    }
    async advanceBuffer(e) {
        this._streamMediaSources.forEach((t)=>t.advanceBuffer(e));
    }
    async clearBuffer(e) {
        this._streamMediaSources.forEach((t)=>t.clearBuffer(e));
    }
    async endOfStream() {
        this._streamMediaSources.forEach((e)=>e.endOfStream());
    }
    async seek(e) {
        this._streamMediaSources.forEach((t)=>t.seek(e));
    }
    setQueue(e) {
        this._queue = e;
    }
    async setDuration(e) {
        this._streamMediaSources.forEach((t)=>t.setDuration(e));
    }
    dispose() {
        this.removeAllListeners(), this._isRunning = !1, this._appendDataTimeout && clearTimeout(this._appendDataTimeout), this._appendDataTimeout = null, this._streamMediaSources.forEach((e)=>e.stop()), this._demuxer && this._demuxer.stop(), this._demuxer = null;
    }
    async appendData() {
        if (!this._isRunning) return;
        let e = !1;
        for(; this._queue && this._queue.length > 0;){
            let t = this._queue.shift();
            t && (e = !0, this._streamMediaSources.forEach((s)=>s.appendData(t)), this._demuxer?.write(t));
        }
        e && this.emit("DATA_CONSUMED"), this._appendDataTimeout = setTimeout(async ()=>await this.appendData(), 10);
    }
};
$e833773b1f4e7d0f$export$d9262064d3e82a38.Register({
    streamTest: (i)=>i.subtitleTracks !== void 0 && i.subtitleTracks.length > 0,
    ctor: $e833773b1f4e7d0f$export$25428d5deff72909
});
var $e833773b1f4e7d0f$export$8e4b508bf17677c6 = class extends (0, (/*@__PURE__*/$parcel$interopDefault($jOCUE))) {
    _mediaSource = null;
    _sourceBuffer = null;
    _queue = null;
    _canAppendData = !1;
    _mimeType = null;
    _isRunning = !1;
    _appendDataTimeout = null;
    get mediaSource() {
        return this._mediaSource;
    }
    get sourceBuffer() {
        return this._sourceBuffer;
    }
    get hasSourceBuffer() {
        return this.sourceBuffer !== null;
    }
    get canUpdateSourceBuffer() {
        return this.sourceBuffer !== null && !this.sourceBuffer.updating;
    }
    get bufferMax() {
        if (this.sourceBuffer != null) return this.sourceBuffer.max;
    }
    init(e) {
        if (this._mimeType = e.mimeType, this._mediaSource = this.createMediaSource(), this._mediaSource === null) {
            this.emit("ERROR", "Failed to create MediaSource", "UNKNOWN_ERROR");
            return;
        }
        this._mediaSource.addEventListener("sourceopen", this.mediaSourceOnSourceOpen), this._mediaSource.sourceBuffers.addEventListener("addsourcebuffer", ()=>{
            this._canAppendData = !0;
        }), this._mediaSource.sourceBuffers.addEventListener("removesourcebuffer", ()=>{
            this._canAppendData = !1, this._sourceBuffer && (this._sourceBuffer.onerror = null, this._sourceBuffer = null);
        }), this.emit("SOURCE_CHANGED"), this._isRunning = !0, (async ()=>await this.appendData())();
    }
    async advanceBuffer(e) {
        this.sourceBuffer !== null && Number.isFinite(e) && !Number.isNaN(e) && (await $e833773b1f4e7d0f$export$e11603d565eb502f(()=>this.sourceBuffer?.updating === !1) && this.sourceBuffer.buffered.length > 0 && this.sourceBuffer.remove(0, e), this._canAppendData = !0);
    }
    isInRange(e, t) {
        for(let s = 0; s < t.length; s++)if (e >= t.start(s) && e <= t.end(s)) return s;
        return -1;
    }
    async clearBuffer(e) {
        if (this.sourceBuffer !== null) {
            if (this._canAppendData = !1, this._queue && (this._queue.length = 0), await $e833773b1f4e7d0f$export$e11603d565eb502f(()=>this.sourceBuffer?.updating === !1) && this._mediaSource?.readyState === "open" && this.sourceBuffer.abort(), await $e833773b1f4e7d0f$export$e11603d565eb502f(()=>this.sourceBuffer?.updating === !1)) {
                for(let t = this.sourceBuffer.buffered.length - 1; t >= 0; t--)if (await $e833773b1f4e7d0f$export$e11603d565eb502f(()=>this.sourceBuffer?.updating === !1)) {
                    let s = this.isInRange(e, this.sourceBuffer.buffered);
                    if (t !== s) t < this.sourceBuffer.buffered.length - 1 && this.sourceBuffer.remove(this.sourceBuffer.buffered.start(t), this.sourceBuffer.buffered.end(t));
                    else if (await $e833773b1f4e7d0f$export$e11603d565eb502f(()=>this.sourceBuffer?.updating === !1)) {
                        let r = this.sourceBuffer.buffered.start(t), n = this.sourceBuffer.buffered.end(t), o = (n - r) / 10;
                        e - r > o && this.sourceBuffer.remove(r, e - o), await $e833773b1f4e7d0f$export$e11603d565eb502f(()=>this.sourceBuffer?.updating === !1) && n - e > o && this.sourceBuffer.remove(e + o, n);
                    }
                }
            }
            this._canAppendData = !0;
        }
    }
    createMediaSource() {
        return globalThis.MediaSource !== void 0 ? new globalThis.MediaSource : globalThis.ManagedMediaSource !== void 0 ? new globalThis.ManagedMediaSource : null;
    }
    async appendData() {
        if (!this._isRunning) return;
        let e = !1;
        for(; this.sourceBuffer && this._queue && this._queue.length > 0 && this._canAppendData;){
            let t = this._queue.shift();
            if (t) {
                e = !0;
                try {
                    await $e833773b1f4e7d0f$export$e11603d565eb502f(()=>this.sourceBuffer?.updating === !1) && this.sourceBuffer.appendBuffer(t);
                } catch (s) {
                    if (s.name === "QuotaExceededError") {
                        if (this._queue.unshift(t), this._canAppendData = !1, this.sourceBuffer.max == null) {
                            let r = 0;
                            for(let n = 0; n < this.sourceBuffer.buffered.length; n++)r += this.sourceBuffer.buffered.end(n) - this.sourceBuffer.buffered.start(n);
                            this.sourceBuffer.max = r;
                        }
                        break;
                    } else s.name === "NotSupportedError" ? this.emit("ERROR", "Unsupported media format", "UNSUPPORTED_MEDIA_FORMAT") : this.emit("ERROR", JSON.stringify(s), "UNKNOWN_ERROR");
                }
            }
        }
        e && this.emit("DATA_CONSUMED"), this._appendDataTimeout = setTimeout(async ()=>await this.appendData(), 50);
    }
    mediaSourceOnSourceOpen = ()=>{
        !this._mediaSource || this._mimeType === null || this._mediaSource.sourceBuffers.length > 0 || (this._sourceBuffer = this._mediaSource.addSourceBuffer(this._mimeType), this._sourceBuffer.onerror = (e)=>{
            this.emit("ERROR", `Buffer error: ${JSON.stringify(e)}.`, "BUFFER_ERROR");
        });
    };
    dispose() {
        if (this._isRunning = !1, this.removeAllListeners(), this._mediaSource?.removeEventListener("sourceopen", this.mediaSourceOnSourceOpen), this._appendDataTimeout !== null && (clearTimeout(this._appendDataTimeout), this._appendDataTimeout = null), this._queue && (this._queue.length = 0), this._sourceBuffer) {
            if (this._sourceBuffer.onerror = null, this.mediaSource !== null && this._mediaSource.sourceBuffers.length > 0) try {
                this._mediaSource?.removeSourceBuffer(this._sourceBuffer);
            } catch (e) {
                if (e.name !== "InvalidStateError") throw e;
            }
            this._sourceBuffer = null;
        }
        this._mediaSource = null;
    }
    async seek(e) {}
    async endOfStream() {
        this._mediaSource !== null && this._mediaSource.readyState === "open" && await $e833773b1f4e7d0f$export$e11603d565eb502f(()=>this.sourceBuffer?.updating === !1) && this._mediaSource.endOfStream();
    }
    setQueue(e) {
        this._queue = e;
    }
    async setDuration(e) {
        await $e833773b1f4e7d0f$export$e11603d565eb502f(()=>this.mediaSource !== null && this._mediaSource.readyState === "open") && (this._mediaSource.duration = e);
    }
};
$e833773b1f4e7d0f$export$d9262064d3e82a38.Register({
    streamTest: ()=>!0,
    ctor: $e833773b1f4e7d0f$export$8e4b508bf17677c6
});
var $e833773b1f4e7d0f$export$66383d53cd2ff2e0 = ((r)=>(r.STREAM_TYPE_DISCOVERED = "STREAM_TYPE_DISCOVERED", r.INVALID_TOKEN = "INVALID_TOKEN", r.PT_START = "PT_START", r.CONFIG_CHANGED = "CONFIG_CHANGED", r))($e833773b1f4e7d0f$export$66383d53cd2ff2e0 || {});
var $e833773b1f4e7d0f$export$c514de6cdde151fc = class extends (0, (/*@__PURE__*/$parcel$interopDefault($jOCUE))) {
    _streamMediaSource = null;
    _streamDataSource = null;
    _url = "";
    _sourceObject = null;
    _seeking = !1;
    _crossOrigin = "";
    _queueId = 0;
    _streamConfig = null;
    _queue = [];
    _capabilitiesChecker = null;
    _capabilityChecks = [];
    _includeMask = !1;
    _passthroughToken = "";
    _fmp4ProtocolVersion = "4.0.0";
    get name() {
        return "MainThread";
    }
    get hasSourceBuffer() {
        return $e833773b1f4e7d0f$export$1625492ec82002b9(()=>this._streamMediaSource !== null && this._streamMediaSource.hasSourceBuffer);
    }
    get canUpdateSourceBuffer() {
        return $e833773b1f4e7d0f$export$1625492ec82002b9(()=>this._streamMediaSource !== null && this._streamMediaSource.canUpdateSourceBuffer);
    }
    get sourceObject() {
        return this._sourceObject;
    }
    get expectedBuffer() {
        return $e833773b1f4e7d0f$export$1625492ec82002b9(()=>this._streamDataSource?.expectedBuffer ?? 0);
    }
    get isComplete() {
        return $e833773b1f4e7d0f$export$1625492ec82002b9(()=>this._streamDataSource?.isComplete ?? !1);
    }
    get includeMask() {
        return $e833773b1f4e7d0f$export$1625492ec82002b9(()=>this._streamDataSource?.includeMask ?? !1);
    }
    set includeMask(e) {
        this._includeMask != e && (this._includeMask = e, this._streamDataSource !== null && (this._streamDataSource.includeMask = e));
    }
    get passthroughToken() {
        return $e833773b1f4e7d0f$export$1625492ec82002b9(()=>this._streamDataSource?.token ?? "");
    }
    set passthroughToken(e) {
        this._passthroughToken != e && (this._passthroughToken = e, this._streamDataSource !== null && (this._streamDataSource.token = e));
    }
    get fmp4ProtocolVersion() {
        return $e833773b1f4e7d0f$export$1625492ec82002b9(()=>this._fmp4ProtocolVersion);
    }
    set fmp4ProtocolVersion(e) {
        this._fmp4ProtocolVersion !== e && (this._fmp4ProtocolVersion = e);
    }
    get bufferMax() {
        return $e833773b1f4e7d0f$export$1625492ec82002b9(()=>this._streamMediaSource?.bufferMax);
    }
    constructor(){
        super();
    }
    handleEvent(e, ...t) {
        this.emit(e, ...t);
    }
    handleError(e, t) {
        this.emit("ERROR", t, e);
    }
    async setSource(e, ...t) {
        this._url = e, this._capabilityChecks.length === 0 && this._capabilityChecks.push(...t), this._streamMediaSource?.dispose(), this._streamDataSource?.dispose(), this._streamDataSource = null, this._queueId = 0;
        try {
            if (this._streamDataSource = $e833773b1f4e7d0f$export$cb8dde19db6bb34a.Create(e, {
                fmp4ProtocolVersion: this._fmp4ProtocolVersion
            }), this._streamDataSource === null) throw new Error("Failed to create a data source");
            this._streamDataSource.on("CONNECTION_ERROR", (s)=>{
                this.emit("ERROR", `Connection error: ${JSON.stringify(s)}.`, "CONNECTION_ERROR");
            }), this._streamDataSource.on("CRITICAL_CONNECTION_ERROR", (s)=>{
                this.emit("ERROR", `Critical connection error: ${JSON.stringify(s)}.`, "CRITICAL_CONNECTION_ERROR");
            }), this._streamDataSource.on("CONNECTION_CLOSED", ()=>{
                this.emit("ERROR", "Connection closed.", "CONNECTION_CLOSED");
            }), this._streamDataSource.on("STREAM_NOT_FOUND_ERROR", ()=>{
                this.emit("ERROR", "Stream not found.", "STREAM_NOT_FOUND");
            }), this._streamDataSource.on("STREAM_ENDED", ()=>{
                this.emit("ERROR", "Stream ended", "STREAM_ENDED");
            }), this._streamDataSource.on("UNAUTHORIZED", (s)=>{
                this.emit("ERROR", s, "UNAUTHORIZED");
            }), this._streamDataSource.on("DATA", (s, r)=>{
                (r === void 0 || this._queueId === r) && this._queue.push(s), this.checkData(s);
            }), this._streamDataSource.on("STREAM_TYPE_DISCOVERED", async (s)=>{
                await this._streamMediaSource?.setDuration(this._streamDataSource?.duration ?? 0), this.emit("STREAM_TYPE_DISCOVERED", s);
            }), this._streamDataSource?.on("INVALID_TOKEN", ()=>{
                this.emit("INVALID_TOKEN");
            }), this._streamDataSource?.on("PT_START", ()=>this.emit("PT_START")), this._crossOrigin && (this._streamDataSource.crossOrigin = this._crossOrigin), this._streamDataSource.token = this._passthroughToken, this._streamDataSource.includeMask = this._includeMask;
        } catch (s) {
            await this.removeSource();
            let r = s.message;
            r && r === "Wrong url." ? this.emit("ERROR", r, "WRONG_URL") : r && r === "Not supported" ? this.emit("ERROR", r, "UNSUPPORTED_MEDIA_FORMAT") : this.emit("ERROR", r, "UNKNOWN_ERROR");
        }
    }
    async init() {
        this._streamConfig !== null && (this._streamMediaSource = $e833773b1f4e7d0f$export$d9262064d3e82a38.Create(this._streamConfig), this._streamMediaSource !== null && (this._streamMediaSource.addListener("DATA_CONSUMED", ()=>{
            this.handleEvent("DATA_CONSUMED");
        }), this._streamMediaSource.addListener("TEXT_CUES", (e)=>{
            this.handleEvent("TEXT_CUES", e);
        }), this._streamMediaSource.addListener("ERROR", (e, t)=>{
            this.handleEvent("ERROR", e, t);
        }), this._streamMediaSource.addListener("SOURCE_CHANGED", ()=>{
            this._streamMediaSource !== null && (this._sourceObject = this._streamMediaSource.mediaSource), this.handleEvent("SOURCE_CHANGED");
        }), this._streamMediaSource.init(this._streamConfig), this._streamMediaSource.setQueue(this._queue), await this._streamMediaSource.setDuration(this._streamDataSource?.duration ?? 0), this._sourceObject = this._streamMediaSource.mediaSource, this.emit("CONFIG_CHANGED", this._streamConfig)));
    }
    async removeSource() {
        this._streamMediaSource?.removeAllListeners(), this._streamMediaSource?.dispose(), this._streamMediaSource = null, this._capabilityChecks.length = 0, this._capabilitiesChecker?.clear(), this._capabilitiesChecker = null, this._streamDataSource?.removeAllListeners(), this._streamDataSource?.dispose(), this._streamDataSource = null, this._streamConfig = null, this._sourceObject = null;
    }
    async resetSource() {
        await this.setSource(this._url, ...this._capabilityChecks);
    }
    async advanceSourceBuffer(e) {
        await this.hasSourceBuffer && await $e833773b1f4e7d0f$export$e11603d565eb502f(()=>this.canUpdateSourceBuffer, ()=>this._seeking) && this._streamMediaSource.advanceBuffer(e);
    }
    async seek(e, t) {
        this._streamMediaSource && (this._seeking = !0, this._queueId++, await this._streamMediaSource.clearBuffer(e), await this._streamMediaSource.seek(t), this._streamDataSource?.seek(t), this._seeking = !1);
    }
    async endOfStream() {
        await this._streamMediaSource?.endOfStream();
    }
    async dispose() {
        await this.removeSource();
    }
    async setCrossOrigin(e) {
        this._crossOrigin = e, this._streamDataSource && (this._streamDataSource.crossOrigin = e);
    }
    async checkData(e) {
        if (this._capabilitiesChecker == null && (this._capabilitiesChecker = new $e833773b1f4e7d0f$export$850b3343ef1018ff), !this._capabilitiesChecker.hasHeader) {
            this._capabilitiesChecker.setHeader(e);
            let t = await this._capabilitiesChecker.checkCapability(...this._capabilityChecks);
            if (!t.isSupported) {
                this.emit("ERROR", `Unsupported media format: "${t.config?.mimeType}" ${t.config?.video?.width}x${t.config?.video?.height}@${t.config?.video?.framerate}`, "UNSUPPORTED_MEDIA_FORMAT");
                return;
            }
            this._streamConfig = t.config, await this.init();
        }
    }
};
var $e833773b1f4e7d0f$export$d1c93d4fd30bfb17 = class i {
    static _wrappers = [];
    static Register(e) {
        i._wrappers.some((t)=>t.name === e.name) || i._wrappers.push(e);
    }
    static Create(e, t = 0) {
        return t >= this._wrappers.length || t < 0 || !this._wrappers[t].isSupported() ? null : new this._wrappers[t].ctor(e);
    }
    static get AllSources() {
        return this._wrappers;
    }
    static get SupportedSources() {
        return this._wrappers.filter((e)=>e.isSupported()).map((e)=>e.name);
    }
};
var $e833773b1f4e7d0f$export$f639b77a12470151 = ((s)=>(s.READY = "READY", s.ERROR = "ERROR", s.WAITING = "WAITING", s))($e833773b1f4e7d0f$export$f639b77a12470151 || {});
var $e833773b1f4e7d0f$export$8ba41255403597d1 = class extends (0, (/*@__PURE__*/$parcel$interopDefault($jOCUE))) {
    _ctor;
    _decoder;
    _sampleQueue = [];
    _chunkQueue = [];
    _config;
    _isReady = !1;
    _hadKeyFrame = !1;
    _nextDataTimeout = null;
    _durationEpsilon = 1e3 / 30;
    _useCache;
    _buffer = [];
    get buffer() {
        return this._buffer;
    }
    get isReady() {
        return this._isReady;
    }
    constructor(e, t, s){
        super(), this._ctor = e, this._decoder = new this._ctor({
            output: (r)=>this.onOutput(r),
            error: (r)=>this.onError(r)
        }), this._config = t, this._useCache = s, this._decoder.configure(t);
    }
    onError(e) {
        this.emit("ERROR", e), this._hadKeyFrame = !1, this.resetDecoder();
    }
    onOutput(e) {
        this._sampleQueue.push(e), this._isReady || (this._isReady = !0, this.emit("READY"));
    }
    takeInternal(e) {
        if (this._sampleQueue.length !== 0) {
            for(; this._sampleQueue.length > 0 && this._sampleQueue[0].timestamp + (this._sampleQueue[0].duration ?? 0) < e;)this._sampleQueue.shift()?.close();
            if (!(this._sampleQueue.length > 0 && this._sampleQueue[0].timestamp > e)) return this._sampleQueue.shift();
        }
    }
    resetDecoder() {
        this._decoder = new this._ctor({
            output: (e)=>this.onOutput(e),
            error: (e)=>this.onError(e)
        }), this._decoder.configure(this._config);
    }
    putInternal(e) {
        if (!(!this._hadKeyFrame && e.type !== "key")) {
            this._hadKeyFrame = !0;
            try {
                this._decoder.decode(e);
            } catch (t) {
                this.onError(t);
            }
        }
    }
    updateBuffer(e) {
        let t = this._buffer.find((r)=>Math.abs(r.end - e.start) < .001), s = this._buffer.find((r)=>Math.abs(r.start - e.end) < .001);
        t === void 0 && s === void 0 ? this._buffer.push(e) : (t !== void 0 && (e.start = t.start, this._buffer.splice(this._buffer.indexOf(t), 1)), s !== void 0 && (e.end = s.end, this._buffer.splice(this._buffer.indexOf(s), 1)), this.updateBuffer(e));
    }
    put(e) {
        this._useCache && this._chunkQueue.push(e), this.putInternal(e);
        let t = e.timestamp * 1e-6, s = t + (e.duration ?? 0) * 1e-6;
        this.updateBuffer({
            start: t,
            end: s
        }), this._buffer.sort((r, n)=>r.start - n.start);
    }
    take(e) {
        let t = this.takeInternal(e);
        return t && t.duration !== null && (this._nextDataTimeout !== null && clearTimeout(this._nextDataTimeout), this._nextDataTimeout = setTimeout(()=>{
            this._isReady = !1, this.emit("WAITING");
        }, t.duration * .001 + this._durationEpsilon)), t;
    }
    nextTS() {
        return this._sampleQueue[0]?.timestamp;
    }
    async close() {
        this._decoder.state !== "closed" && this._decoder.close(), await this.flush(), this._chunkQueue.length = 0, this._buffer.length = 0, this._isReady = !1;
    }
    async flush() {
        this._decoder.state !== "closed" && (this._decoder.reset(), this._decoder.configure(this._config)), this._sampleQueue.forEach((e)=>e.close()), this._sampleQueue.length = 0, this._hadKeyFrame = !1, this._nextDataTimeout !== null && clearTimeout(this._nextDataTimeout);
    }
    async seek(e) {
        let t = e * 1e6, s = this._sampleQueue.findIndex((n)=>t >= n.timestamp && t < n.timestamp + (n.duration ?? 0));
        if (s > -1) {
            this._sampleQueue.splice(0, s);
            return;
        }
        await this.flush();
        let r = t < this._chunkQueue[0]?.timestamp ? 0 : this._chunkQueue.findIndex((n)=>t >= n.timestamp && t < n.timestamp + (n.duration ?? 0));
        if (r > -1) for(let n = r; n < this._chunkQueue.length; n++)this.putInternal(this._chunkQueue[n]);
    }
}, $e833773b1f4e7d0f$export$9a176c5b4837ea02 = class extends $e833773b1f4e7d0f$export$8ba41255403597d1 {
    constructor(e, t){
        super(AudioDecoder, e, t);
    }
}, $e833773b1f4e7d0f$export$cfca9fa173b5584d = class extends $e833773b1f4e7d0f$export$8ba41255403597d1 {
    constructor(e, t){
        super(VideoDecoder, e, t);
    }
};
var $e833773b1f4e7d0f$export$f9de6ca0bc043724 = class extends (0, (/*@__PURE__*/$parcel$interopDefault($jOCUE))) {
    _decoders = new Map;
    get buffer() {
        let e = [];
        return this._decoders.forEach((t)=>e.push(t.buffer)), e.flat();
    }
    constructor(){
        super();
    }
    onReady = ()=>{
        for (let e of this._decoders.values())if (!e.isReady) return;
        this.emit("READY");
    };
    onError = (e)=>{
        this.emit("ERROR", e);
    };
    onWaiting = ()=>{
        this.emit("WAITING");
    };
    async start(e, t, s) {
        this.stop();
        for (let r of e)this._decoders.set(r.trackId, new $e833773b1f4e7d0f$export$9a176c5b4837ea02(r.config, s));
        for (let r of t)this._decoders.set(r.trackId, new $e833773b1f4e7d0f$export$cfca9fa173b5584d(r.config, s));
        this._decoders.forEach((r)=>{
            r.addListener("READY", this.onReady), r.addListener("ERROR", this.onError), r.addListener("WAITING", this.onWaiting);
        });
    }
    put(e, t) {
        $e833773b1f4e7d0f$export$57519a39c3119ec1.verbose(`[DECODER#${e}] IS_KEY: ${t.type === "key"} TS:${t.timestamp}, DURATION: ${t.duration}`), this._decoders.get(e)?.put(t);
    }
    take(e, t) {
        return this._decoders.get(e)?.take(t);
    }
    nextTS() {
        let e = Number.POSITIVE_INFINITY;
        return this._decoders.forEach((t)=>{
            let s = t.nextTS();
            s !== void 0 && s < e && (e = s);
        }), e !== Number.POSITIVE_INFINITY ? e : null;
    }
    stop() {
        this._decoders.forEach(async (e)=>{
            e.removeAllListeners(), await e.close();
        }), this._decoders.clear();
    }
    async flush() {
        for (let e of this._decoders.values())await e.flush();
    }
    async seek(e) {
        for (let t of this._decoders.values())await t.seek(e);
    }
};
var $e833773b1f4e7d0f$export$9277330a1db15539 = ((t)=>(t[t.Main = 0] = "Main", t[t.Supplementary = 1] = "Supplementary", t))($e833773b1f4e7d0f$export$9277330a1db15539 || {});
function $e833773b1f4e7d0f$export$10682a8e214d9fcf(i) {
    return i.type === 0;
}
function $e833773b1f4e7d0f$export$fac04d879aa24ca8(i) {
    return i.type === 1;
}
var $e833773b1f4e7d0f$export$58ab3ed211eed562 = class i extends $e833773b1f4e7d0f$export$c9f38831ebbeacb6 {
    get type() {
        return "none";
    }
    get nodeName() {
        return i.name;
    }
    isSupported(e) {
        return e.trackType === this.type;
    }
};
var $e833773b1f4e7d0f$export$e1ba7b4bcaf34e50 = class i extends $e833773b1f4e7d0f$export$58ab3ed211eed562 {
    get type() {
        return "audio";
    }
    get nodeName() {
        return i.name;
    }
    get displayElement() {
        return null;
    }
    addSupplementaryData(e) {}
};
var $e833773b1f4e7d0f$export$ea0e3cb398c9e66b = class i extends $e833773b1f4e7d0f$export$e1ba7b4bcaf34e50 {
    _volume = 0;
    _muted = !0;
    _sinkId = null;
    _writer = null;
    _isOpen = !1;
    _mediaStreamSource = null;
    _trackGenerator = null;
    _context = null;
    _gain = null;
    get nodeName() {
        return i.name;
    }
    isSupported(e) {
        return super.isSupported(e) && true;
    }
    get volume() {
        return this._volume;
    }
    set volume(e) {
        this._volume !== e && (this._volume = e, this._gain && (this._gain.gain.value = e));
    }
    get muted() {
        return this._muted;
    }
    set muted(e) {
        this._muted !== e && (this._muted = e, this._gain && (this._gain.gain.value = this.muted ? 0 : this.volume));
    }
    get sinkId() {
        return this._sinkId ?? "";
    }
    set sinkId(e) {
        this._sinkId !== e && (this._sinkId = e, this.setSinkIdInternal());
    }
    async startInternal() {
        this._trackGenerator = new MediaStreamTrackGenerator({
            kind: "audio"
        }), this._context = new AudioContext({
            latencyHint: 0
        }), await this.setSinkIdInternal(), this._gain = new GainNode(this._context), this._gain.connect(this._context.destination), this._mediaStreamSource = new MediaStreamAudioSourceNode(this._context, {
            mediaStream: new MediaStream([
                this._trackGenerator
            ])
        }), this._mediaStreamSource.connect(this._gain), this._gain.gain.value = this.muted ? 0 : this.volume, this._writer = this._trackGenerator.writable.getWriter(), this._isOpen = !0;
    }
    async processInternal(e) {
        this._isOpen && await this._writer?.write(e);
    }
    async stopInternal() {
        this._isOpen = !1, this._writer?.releaseLock(), this._writer = null, this._gain?.disconnect(), this._gain = null, this._mediaStreamSource?.disconnect(), this._mediaStreamSource = null, this._trackGenerator?.stop(), this._trackGenerator = null;
    }
    async setSinkIdInternal() {
        this._context !== null && this._sinkId !== null && ("setSinkId" in this._context ? await this._context.setSinkId(this._sinkId) : "sinkId" in this._context && (this._context.sinkId = this._sinkId));
    }
};
$e833773b1f4e7d0f$export$f82961e691216dba.Register($e833773b1f4e7d0f$export$ea0e3cb398c9e66b);
var $e833773b1f4e7d0f$export$6f3abde71cb2410d = class i extends $e833773b1f4e7d0f$export$58ab3ed211eed562 {
    get type() {
        return "video";
    }
    get nodeName() {
        return i.name;
    }
    get displayElement() {
        return this._canvas;
    }
    _canvas = null;
    _isVRB = !1;
    get width() {
        return this._canvas?.width ?? 0;
    }
    get height() {
        return this._canvas?.height ?? 0;
    }
    init(e) {
        super.init(e), e.displayElement && e.displayElement instanceof HTMLCanvasElement && (this._canvas = e.displayElement), this._isVRB = e.isVRB ?? !1;
    }
    getDimensions(e) {
        return e instanceof HTMLVideoElement ? {
            width: e.videoWidth,
            height: e.videoHeight
        } : e instanceof VideoFrame ? {
            width: e.displayWidth,
            height: e.displayHeight
        } : {
            width: e.width,
            height: e.height
        };
    }
    addSupplementaryData(e) {
        typeof e.isVRB == "boolean" && (this._isVRB = e.isVRB);
    }
};
var $e833773b1f4e7d0f$export$4e78b5eb04d1927a = class i extends $e833773b1f4e7d0f$export$6f3abde71cb2410d {
    _lastMainFrame = null;
    _lastAlphaFrame = null;
    get nodeName() {
        return i.name;
    }
    async stopInternal() {
        this._lastMainFrame instanceof VideoFrame && this._lastMainFrame.close(), this._lastMainFrame = null, this._lastAlphaFrame instanceof VideoFrame && this._lastAlphaFrame.close(), this._lastAlphaFrame = null;
    }
    getFrames(e) {
        "data" in e ? e.isSupplementary ? (this._lastAlphaFrame instanceof VideoFrame && this._lastAlphaFrame.close(), this._lastAlphaFrame = e.data) : (this._lastMainFrame instanceof VideoFrame && this._lastMainFrame.close(), this._lastMainFrame = e.data) : (this._lastMainFrame instanceof VideoFrame && this._lastMainFrame.close(), this._lastMainFrame = e);
        let t = this._lastMainFrame, s = this._lastAlphaFrame;
        return {
            frame: t,
            alpha: s
        };
    }
    canRender(e) {
        return e instanceof HTMLVideoElement ? e.readyState >= e.HAVE_CURRENT_DATA : !0;
    }
};
var $e833773b1f4e7d0f$export$f6cc00ef28d7cf97 = class i extends $e833773b1f4e7d0f$export$4e78b5eb04d1927a {
    static _vertexShaderSource = `
    attribute vec2 xy;

    varying highp vec2 uv;

    void main(void) 
    {
        gl_Position = vec4(xy, 0.0, 1.0);
        // Map vertex coordinates (-1 to +1) to UV coordinates (0 to 1).
        // UV coordinates are Y-flipped relative to vertex coordinates.
        uv = vec2((1.0 + xy.x) / 2.0, (1.0 - xy.y) / 2.0);
    }
  `;
    static _fragmentShaderSource = `
    varying highp vec2 uv;

    uniform sampler2D texture;
    uniform sampler2D alphaTexture;
    uniform int hasAlpha;
    uniform int isVRB;

    highp vec3 RGBfromYUV(highp vec3 yuv)
    {
        highp float y = yuv.r - 16.0/256.0;
        highp float u = yuv.g - 128.0/256.0;
        highp float v = yuv.b - 128.0/256.0;
        highp float r = 1.164 * y             + 1.596 * v;
        highp float g = 1.164 * y - 0.392 * u - 0.813 * v;
        highp float b = 1.164 * y + 2.017 * u;
        return vec3(r,g,b);
    }

    void main(void) 
    {
        gl_FragColor = texture2D(texture, uv);
        if(hasAlpha == 0)
            return;
        highp vec4 alpha = texture2D(alphaTexture, uv);
        if(isVRB == 0)
        {
            gl_FragColor.a = RGBfromYUV(alpha.rgb).b;
        }
        else 
        {
            gl_FragColor.a = alpha.g;
        }
        if(gl_FragColor.a <= 0.01)
            discard;
    }
  `;
    _mainTex = null;
    _alphaTex = null;
    _maxTextureSize = null;
    _workingCanvas = null;
    _hasAlphaLoc = null;
    _shaderProgram = null;
    _vertexBuffer = null;
    _hasAlpha = !1;
    initContext(e) {
        let t = e.getContext("webgl2", {
            alpha: !0,
            powerPreference: "high-performance",
            antialias: !0,
            desynchronized: !0
        }), s = t.createShader(t.VERTEX_SHADER);
        if (t.shaderSource(s, i._vertexShaderSource), t.compileShader(s), !t.getShaderParameter(s, t.COMPILE_STATUS)) throw t.getShaderInfoLog(s);
        let r = t.createShader(t.FRAGMENT_SHADER);
        if (t.shaderSource(r, i._fragmentShaderSource), t.compileShader(r), !t.getShaderParameter(r, t.COMPILE_STATUS)) throw t.getShaderInfoLog(r);
        if (this._shaderProgram = t.createProgram(), t.attachShader(this._shaderProgram, s), t.attachShader(this._shaderProgram, r), t.linkProgram(this._shaderProgram), !t.getProgramParameter(this._shaderProgram, t.LINK_STATUS)) throw t.getProgramInfoLog(this._shaderProgram);
        let n = t.getUniformLocation(this._shaderProgram, "texture"), a = t.getUniformLocation(this._shaderProgram, "alphaTexture");
        this._hasAlphaLoc = t.getUniformLocation(this._shaderProgram, "hasAlpha");
        let o = t.getUniformLocation(this._shaderProgram, "isVRB");
        t.useProgram(this._shaderProgram), t.uniform1i(n, 0), t.uniform1i(a, 1), this._vertexBuffer = t.createBuffer(), t.bindBuffer(t.ARRAY_BUFFER, this._vertexBuffer), t.bufferData(t.ARRAY_BUFFER, new Float32Array([
            -1,
            -1,
            -1,
            1,
            1,
            1,
            1,
            -1
        ]), t.STATIC_DRAW);
        let u = t.getAttribLocation(this._shaderProgram, "xy");
        return t.vertexAttribPointer(u, 2, t.FLOAT, !1, 0, 0), t.enableVertexAttribArray(u), t.activeTexture(t.TEXTURE0), this._mainTex = t.createTexture(), t.bindTexture(t.TEXTURE_2D, this._mainTex), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MAG_FILTER, t.LINEAR), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, t.LINEAR), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_S, t.CLAMP_TO_EDGE), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_T, t.CLAMP_TO_EDGE), t.activeTexture(t.TEXTURE1), this._alphaTex = t.createTexture(), t.bindTexture(t.TEXTURE_2D, this._alphaTex), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MAG_FILTER, t.LINEAR), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_MIN_FILTER, t.LINEAR), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_S, t.CLAMP_TO_EDGE), t.texParameteri(t.TEXTURE_2D, t.TEXTURE_WRAP_T, t.CLAMP_TO_EDGE), t.uniform1i(o, this._isVRB ? 1 : 0), t.clearColor(0, 0, 0, 0), t.viewport(0, 0, t.drawingBufferWidth, t.drawingBufferHeight), t;
    }
};
var $e833773b1f4e7d0f$export$d93d224e20a6ad2 = class i extends $e833773b1f4e7d0f$export$f6cc00ef28d7cf97 {
    get nodeName() {
        return i.name;
    }
    isSupported(e) {
        return super.isSupported(e) && typeof WebGL2RenderingContext < "u";
    }
    get priority() {
        return 50;
    }
    _renderContext = null;
    _workingContext = null;
    get width() {
        return this._workingCanvas?.width ?? this._canvas?.width ?? 0;
    }
    get height() {
        return this._workingCanvas?.height ?? this._canvas?.height ?? 0;
    }
    async startInternal() {
        this._canvas && (this._renderContext = this._canvas.getContext("2d"));
    }
    initOffscreenCanvas(e, t) {
        if (this._workingCanvas === null) {
            if (this._workingCanvas = new OffscreenCanvas(e, t), this._workingContext = this._workingCanvas.getContext("webgl2", {
                alpha: !0,
                powerPreference: "high-performance",
                antialias: !0,
                desynchronized: !0
            }), this._maxTextureSize = this._workingContext.getParameter(this._workingContext.MAX_TEXTURE_SIZE), this._maxTextureSize !== null && (e > this._maxTextureSize || t > this._maxTextureSize)) {
                let s = Math.max(e / this._maxTextureSize, t / this._maxTextureSize), r = {
                    x: Math.floor(e / s),
                    y: Math.floor(t / s)
                };
                this._workingCanvas = new OffscreenCanvas(r.x, r.y);
            }
            this._workingContext = this.initContext(this._workingCanvas);
        }
    }
    drawImage(e, t) {
        if (this._workingContext !== null) {
            if (t) {
                let { width: s, height: r } = this.getDimensions(e);
                this._workingContext.texStorage2D(this._workingContext.TEXTURE_2D, 1, this._workingContext.RGBA8, s, r);
            }
            this._workingContext.texSubImage2D(this._workingContext.TEXTURE_2D, 0, 0, 0, this._workingContext.RGBA, this._workingContext.UNSIGNED_BYTE, e);
        }
    }
    async processInternal(e) {
        if (this._canvas === null || this._renderContext === null) return;
        let { frame: t, alpha: s } = this.getFrames(e);
        if (t === null) return;
        let { width: r, height: n } = this.getDimensions(t);
        if (this.initOffscreenCanvas(r, n), this._workingCanvas === null || this._workingContext === null) return;
        let a = !1;
        if ((r != this._canvas.width || n !== this._canvas.height) && (this._canvas.width = r, this._canvas.height = n, this._workingContext.viewport(0, 0, this._workingContext.drawingBufferWidth, this._workingContext.drawingBufferHeight), a = !0), this.canRender(t) && (this._workingContext.activeTexture(this._workingContext.TEXTURE0), this.drawImage(t, a)), s) {
            let o = !1;
            this._hasAlpha || (this._hasAlpha = !0, this._workingContext.uniform1i(this._hasAlphaLoc, 1), o = !0), this.canRender(s) && (this._workingContext.activeTexture(this._workingContext.TEXTURE1), this.drawImage(s, o));
        } else this._hasAlpha && (this._workingContext.activeTexture(this._workingContext.TEXTURE1), this._workingContext.texImage2D(this._workingContext.TEXTURE_2D, 0, this._workingContext.RGBA, 4, 4, 0, this._workingContext.RGBA, this._workingContext.UNSIGNED_BYTE, null), this._hasAlpha = !1, this._workingContext.uniform1i(this._hasAlphaLoc, 0));
        this._workingContext.clear(this._workingContext.COLOR_BUFFER_BIT), this._workingContext.drawArrays(this._workingContext.TRIANGLE_FAN, 0, 4), (r != this._canvas.width || n !== this._canvas.height) && (this._canvas.width = r, this._canvas.height = n), this._renderContext.clearRect(0, 0, r, n), this._renderContext.drawImage(this._workingCanvas, 0, 0, this._workingCanvas.width, this._workingCanvas.height, 0, 0, r, n);
    }
    clear() {
        this._workingContext === null || this._renderContext === null || this._canvas === null || (this._workingContext.clear(this._workingContext.COLOR_BUFFER_BIT), this._renderContext.clearRect(0, 0, this._canvas.width, this._canvas.height));
    }
    async stopInternal() {
        this.clear(), this._workingContext?.deleteTexture(this._mainTex), this._workingContext?.deleteTexture(this._alphaTex), this._workingContext?.deleteProgram(this._shaderProgram), this._workingContext?.deleteBuffer(this._vertexBuffer), await super.stopInternal();
    }
};
$e833773b1f4e7d0f$export$f82961e691216dba.Register($e833773b1f4e7d0f$export$d93d224e20a6ad2);
var $e833773b1f4e7d0f$export$3677d433beeb8172 = class i extends $e833773b1f4e7d0f$export$f6cc00ef28d7cf97 {
    get nodeName() {
        return i.name;
    }
    isSupported(e) {
        return super.isSupported(e) && (typeof WebGL2RenderingContext < "u" || typeof WebGLRenderingContext < "u");
    }
    get priority() {
        return 100;
    }
    _context = null;
    _workingContext = null;
    get width() {
        return this._workingCanvas?.width ?? this._canvas?.width ?? 0;
    }
    get height() {
        return this._workingCanvas?.height ?? this._canvas?.height ?? 0;
    }
    async startInternal() {
        this._canvas !== null && (this._context = this._canvas.getContext("webgl2", {
            alpha: !0,
            powerPreference: "high-performance",
            antialias: !0,
            desynchronized: !0
        }) ?? this._canvas?.getContext("webgl", {
            alpha: !0,
            powerPreference: "high-performance",
            antialias: !0,
            desynchronized: !0
        }), this._maxTextureSize = this._context.getParameter(this._context.MAX_TEXTURE_SIZE), this._context = this.initContext(this._canvas));
    }
    getTextureSource(e) {
        let { width: t, height: s } = this.getDimensions(e);
        if (this._maxTextureSize !== null && (t > this._maxTextureSize || s > this._maxTextureSize)) {
            let r = Math.max(t / this._maxTextureSize, s / this._maxTextureSize), n = {
                x: Math.floor(t / r),
                y: Math.floor(s / r)
            };
            return (this._workingCanvas === null || this._workingContext === null) && (this._workingCanvas = new OffscreenCanvas(n.x, n.y), this._workingContext = this._workingCanvas.getContext("2d")), this._workingContext.drawImage(e, 0, 0, t, s, 0, 0, this._workingCanvas.width, this._workingCanvas.height), this._workingCanvas;
        }
        return e;
    }
    async processInternal(e) {
        if (this._canvas === null || this._context === null) return;
        let { frame: t, alpha: s } = this.getFrames(e);
        if (t === null) return;
        let { width: r, height: n } = this.getDimensions(t);
        (r != this._canvas.width || n !== this._canvas.height) && (this._canvas.width = r, this._canvas.height = n, this._context.viewport(0, 0, this._context.drawingBufferWidth, this._context.drawingBufferHeight)), this.canRender(t) && (this._context.activeTexture(this._context.TEXTURE0), this._context.texImage2D(this._context.TEXTURE_2D, 0, this._context.RGBA, this._context.RGBA, this._context.UNSIGNED_BYTE, this.getTextureSource(t))), s ? (this._hasAlpha || (this._hasAlpha = !0, this._context.uniform1i(this._hasAlphaLoc, 1)), this.canRender(s) && (this._context.activeTexture(this._context.TEXTURE1), this._context.texImage2D(this._context.TEXTURE_2D, 0, this._context.RGBA, this._context.RGBA, this._context.UNSIGNED_BYTE, this.getTextureSource(s)))) : (this._context.activeTexture(this._context.TEXTURE1), this._context.texImage2D(this._context.TEXTURE_2D, 0, this._context.RGBA, 4, 4, 0, this._context.RGBA, this._context.UNSIGNED_BYTE, null), this._hasAlpha && (this._hasAlpha = !1, this._context.uniform1i(this._hasAlphaLoc, 0))), this._context.clear(this._context.COLOR_BUFFER_BIT), this._context.drawArrays(this._context.TRIANGLE_FAN, 0, 4);
    }
    clear() {
        this._context !== null && this._context.clear(this._context.COLOR_BUFFER_BIT);
    }
    async stopInternal() {
        this.clear(), this._context?.deleteTexture(this._mainTex), this._context?.deleteTexture(this._alphaTex), this._context?.deleteProgram(this._shaderProgram), this._context?.deleteBuffer(this._vertexBuffer), await super.stopInternal();
    }
};
$e833773b1f4e7d0f$export$f82961e691216dba.Register($e833773b1f4e7d0f$export$3677d433beeb8172);
var $e833773b1f4e7d0f$export$19fd8015bd4822d4 = class i extends $e833773b1f4e7d0f$export$4e78b5eb04d1927a {
    isSupported(e) {
        return super.isSupported(e) && "gpu" in navigator && globalThis.GPUDevice !== void 0 && globalThis.GPUDevice?.prototype?.importExternalTexture !== void 0;
    }
    get nodeName() {
        return i.name;
    }
    get priority() {
        return 20;
    }
    _context = null;
    _format = null;
    _device = null;
    _mainPipeline = null;
    _alphaPipeline = null;
    _clearPipeline = null;
    _mainSampler = null;
    _alphaSampler = null;
    _started = !1;
    static _vertexShaderSource = `
    struct VertexOutput {
      @builtin(position) Position: vec4<f32>,
      @location(0) uv: vec2<f32>,
    }

    @vertex
    fn vert_main(@builtin(vertex_index) VertexIndex: u32) -> VertexOutput {
      var pos = array<vec2<f32>, 6>(
        vec2<f32>( 1.0,  1.0),
        vec2<f32>( 1.0, -1.0),
        vec2<f32>(-1.0, -1.0),
        vec2<f32>( 1.0,  1.0),
        vec2<f32>(-1.0, -1.0),
        vec2<f32>(-1.0,  1.0)
      );

      var uv = array<vec2<f32>, 6>(
        vec2<f32>(1.0, 0.0),
        vec2<f32>(1.0, 1.0),
        vec2<f32>(0.0, 1.0),
        vec2<f32>(1.0, 0.0),
        vec2<f32>(0.0, 1.0),
        vec2<f32>(0.0, 0.0)
      );

      var output : VertexOutput;
      output.Position = vec4<f32>(pos[VertexIndex], 0.0, 1.0);
      output.uv = uv[VertexIndex];
      return output;
    }
  `;
    static _mainfragmentShaderSource = `
    @group(0) @binding(1) var mainSampler: sampler;
    @group(0) @binding(2) var mainTexture: texture_external;

    @fragment
    fn frag_main(@location(0) uv : vec2<f32>) -> @location(0) vec4<f32> {
        return textureSampleBaseClampToEdge(mainTexture, mainSampler, uv);
    }
  `;
    static _clearfragmentShaderSource = `

    @fragment
    fn frag_main(@location(0) uv : vec2<f32>) -> @location(0) vec4<f32> {
        return vec4f(0.0, 0.0, 0.0, 0.0);
    }
  `;
    static _alphafragmentShaderSource = `
    @group(0) @binding(1) var mainSampler: sampler;
    @group(0) @binding(2) var mainTexture: texture_external;
    @group(1) @binding(1) var alphaSampler: sampler;
    @group(1) @binding(2) var alphaTexture: texture_external;

    fn RGBfromYUV(yuv: vec4f) -> vec3f
    {
        let y: f32 = yuv.r - 16.0/256.0;
        let u: f32 = yuv.g - 128.0/256.0;
        let v: f32 = yuv.b - 128.0/256.0;
        let r: f32 = 1.164 * y             + 1.596 * v;
        let g: f32 = 1.164 * y - 0.392 * u - 0.813 * v;
        let b: f32 = 1.164 * y + 2.017 * u;
        return vec3f(r,g,b);
    }
    @fragment
    fn frag_main(@location(0) uv : vec2<f32>) -> @location(0) vec4<f32> {
        let color = textureSampleBaseClampToEdge(mainTexture, mainSampler, uv);
        let alpha = RGBfromYUV(textureSampleBaseClampToEdge(alphaTexture, alphaSampler, uv));
        return vec4f(color.r, color.g, color.b, alpha.b);
    }
  `;
    static _vrbAlphafragmentShaderSource = `
    @group(0) @binding(1) var mainSampler: sampler;
    @group(0) @binding(2) var mainTexture: texture_external;
    @group(1) @binding(1) var alphaSampler: sampler;
    @group(1) @binding(2) var alphaTexture: texture_external;

    @fragment
    fn frag_main(@location(0) uv : vec2<f32>) -> @location(0) vec4<f32> {
        let color = textureSampleBaseClampToEdge(mainTexture, mainSampler, uv);
        let alpha = textureSampleBaseClampToEdge(alphaTexture, alphaSampler, uv);
        return vec4f(color.r, color.g, color.b, alpha.g);
    }
  `;
    get width() {
        return this._canvas?.width ?? 0;
    }
    get height() {
        return this._canvas?.height ?? 0;
    }
    async startInternal() {
        if (!("gpu" in navigator)) return;
        let e = navigator.gpu, t = await e.requestAdapter({
            powerPreference: "high-performance",
            xrCompatible: !0
        });
        this._device = await t.requestDevice(), this._format = e.getPreferredCanvasFormat(), this._context = this._canvas?.getContext("webgpu"), !(this._context === null || this._device === null || this._format === null) && (this._context.configure({
            device: this._device,
            format: this._format,
            alphaMode: "premultiplied"
        }), this._mainPipeline = this._device.createRenderPipeline({
            layout: "auto",
            vertex: {
                module: this._device.createShaderModule({
                    code: i._vertexShaderSource
                }),
                entryPoint: "vert_main"
            },
            fragment: {
                module: this._device.createShaderModule({
                    code: i._mainfragmentShaderSource
                }),
                entryPoint: "frag_main",
                targets: [
                    {
                        format: this._format
                    }
                ]
            },
            primitive: {
                topology: "triangle-list"
            }
        }), this._alphaPipeline = this._device.createRenderPipeline({
            layout: "auto",
            vertex: {
                module: this._device.createShaderModule({
                    code: i._vertexShaderSource
                }),
                entryPoint: "vert_main"
            },
            fragment: {
                module: this._device.createShaderModule({
                    code: this._isVRB ? i._vrbAlphafragmentShaderSource : i._alphafragmentShaderSource
                }),
                entryPoint: "frag_main",
                targets: [
                    {
                        format: this._format
                    }
                ]
            },
            primitive: {
                topology: "triangle-list"
            }
        }), this._clearPipeline = this._device.createRenderPipeline({
            layout: "auto",
            vertex: {
                module: this._device.createShaderModule({
                    code: i._vertexShaderSource
                }),
                entryPoint: "vert_main"
            },
            fragment: {
                module: this._device.createShaderModule({
                    code: i._clearfragmentShaderSource
                }),
                entryPoint: "frag_main",
                targets: [
                    {
                        format: this._format
                    }
                ]
            },
            primitive: {
                topology: "triangle-list"
            }
        }), this._mainSampler = this._device.createSampler({}), this._alphaSampler = this._device.createSampler({}), this._started = !0);
    }
    async processInternal(e) {
        if (!this._started || this._mainSampler === null || this._alphaSampler === null || this._device === null || this._mainPipeline === null || this._alphaPipeline === null || this._canvas === null || this._context === null) return;
        let { frame: t, alpha: s } = this.getFrames(e);
        if (t === null) return;
        let { width: r, height: n } = this.getDimensions(t);
        (r != this._canvas.width || n !== this._canvas.height) && (this._canvas.width = r, this._canvas.height = n);
        let a = s === null ? this._mainPipeline : this._alphaPipeline, o = this._device.createBindGroup({
            layout: a.getBindGroupLayout(0),
            entries: [
                {
                    binding: 1,
                    resource: this._mainSampler
                },
                {
                    binding: 2,
                    resource: this._device.importExternalTexture({
                        source: t
                    })
                }
            ]
        }), u = this._device.createCommandEncoder(), h = {
            colorAttachments: [
                {
                    view: this._context.getCurrentTexture().createView(),
                    clearValue: [
                        0,
                        0,
                        0,
                        0
                    ],
                    loadOp: "clear",
                    storeOp: "store"
                }
            ]
        }, d = u.beginRenderPass(h);
        if (d.setBindGroup(0, o), s !== null) {
            let c = this._device.createBindGroup({
                layout: a.getBindGroupLayout(1),
                entries: [
                    {
                        binding: 1,
                        resource: this._alphaSampler
                    },
                    {
                        binding: 2,
                        resource: this._device.importExternalTexture({
                            source: s
                        })
                    }
                ]
            });
            d.setBindGroup(1, c);
        }
        d.setPipeline(a), d.draw(6, 1, 0, 0), d.end(), this._device.queue.submit([
            u.finish()
        ]);
    }
    clear() {
        if (this._mainSampler === null || this._alphaSampler === null || this._device === null || this._clearPipeline === null || this._context === null) return;
        this._started = !1;
        let e = this._clearPipeline, t = this._device.createCommandEncoder(), r = {
            colorAttachments: [
                {
                    view: this._context.getCurrentTexture().createView(),
                    clearValue: [
                        0,
                        0,
                        0,
                        0
                    ],
                    loadOp: "clear",
                    storeOp: "store"
                }
            ]
        }, n = t.beginRenderPass(r);
        n.setPipeline(e), n.draw(6, 1, 0, 0), n.end(), this._device.queue.submit([
            t.finish()
        ]);
    }
    async stopInternal() {
        this.clear(), this._started = !1, this._device?.destroy(), this._device = null, this._mainPipeline = null, this._alphaPipeline = null, this._clearPipeline = null, this._mainSampler = null, this._alphaSampler = null, await super.stopInternal();
    }
};
var $e833773b1f4e7d0f$export$2617fcae20c3c057 = class i extends $e833773b1f4e7d0f$export$4e78b5eb04d1927a {
    get nodeName() {
        return i.name;
    }
    get priority() {
        return 200;
    }
    _context = null;
    _alphaCanvas = null;
    async startInternal() {
        this._context = this._canvas?.getContext("2d");
    }
    async processInternal(e) {
        if (this._canvas === null || this._context === null) return;
        let { frame: t, alpha: s } = this.getFrames(e);
        if (t === null) return;
        let { width: r, height: n } = this.getDimensions(t);
        if ((r != this._canvas.width || n !== this._canvas.height) && (this._canvas.width = r, this._canvas.height = n), this._context.clearRect(0, 0, this._canvas.width, this._canvas.height), s !== null) {
            if (this._context.globalCompositeOperation = "source-over", this._isVRB) {
                let a = this.colorShiftVRB(s);
                this._context.drawImage(a, 0, 0, a.width, a.height, 0, 0, this._canvas.width, this._canvas.height);
            } else {
                let a = this.colorShift(s);
                this._context.drawImage(a, 0, 0, a.width, a.height, 0, 0, this._canvas.width, this._canvas.height);
            }
            this._context.globalCompositeOperation = "source-in";
        } else this._alphaCanvas = null;
        this._context.drawImage(t, 0, 0, this._canvas.width, this._canvas.height);
    }
    clear() {
        this._canvas === null || this._context === null || (this._context.clearRect(0, 0, this._canvas.width, this._canvas.height), this._alphaCanvas = null);
    }
    async stopInternal() {
        this.clear(), await super.stopInternal();
    }
    colorShift(e) {
        let { width: t, height: s } = this.getDimensions(e);
        (this._alphaCanvas === null || this._alphaCanvas.width !== t || this._alphaCanvas.height !== s) && (this._alphaCanvas = new OffscreenCanvas(t, s));
        let r = this._alphaCanvas.getContext("2d", {
            alpha: !0,
            willReadFrequently: !0
        });
        r.drawImage(e, 0, 0);
        let n = r.getImageData(0, 0, t, s);
        for(let a = 0; a < n.data.length; a += 4)n.data[a + 3] = Math.floor((n.data[a] - 0.0625) * 256);
        return r.putImageData(n, 0, 0), this._alphaCanvas;
    }
    colorShiftVRB(e) {
        let { width: t, height: s } = this.getDimensions(e);
        if ((this._alphaCanvas === null || this._alphaCanvas.width !== t || this._alphaCanvas.height !== s) && (this._alphaCanvas = new OffscreenCanvas(t, s)), t === 0 || s === 0) return this._alphaCanvas;
        let r = this._alphaCanvas.getContext("2d", {
            alpha: !0,
            willReadFrequently: !0
        });
        r.drawImage(e, 0, 0);
        let n = r.getImageData(0, 0, t, s);
        for(let a = 0; a < n.data.length; a += 4)n.data[a + 3] = n.data[a + 1];
        return r.putImageData(n, 0, 0), this._alphaCanvas;
    }
};
$e833773b1f4e7d0f$export$f82961e691216dba.Register($e833773b1f4e7d0f$export$2617fcae20c3c057);
var $e833773b1f4e7d0f$export$712c343b526067c0 = class i extends $e833773b1f4e7d0f$export$4e78b5eb04d1927a {
    static _vertexShaderSource = `
    attribute vec2 xy;

    varying highp vec2 uv;

    void main(void) 
    {
        gl_Position = vec4(xy, 0.0, 1.0);
        // Map vertex coordinates (-1 to +1) to UV coordinates (0 to 1).
        // UV coordinates are Y-flipped relative to vertex coordinates.
        uv = vec2((1.0 + xy.x) / 2.0, (1.0 - xy.y) / 2.0);
    }
  `;
    static _yuvFragmentShaderSource = `
    varying highp vec2 uv;

    uniform sampler2D texture;

    highp vec3 RGBfromYUV(highp vec3 yuv)
    {
        highp float y = yuv.r - 16.0/256.0;
        highp float u = yuv.g - 128.0/256.0;
        highp float v = yuv.b - 128.0/256.0;
        highp float r = 1.164 * y             + 1.596 * v;
        highp float g = 1.164 * y - 0.392 * u - 0.813 * v;
        highp float b = 1.164 * y + 2.017 * u;
        return vec3(r,g,b);
    }

    void main(void) 
    {
        highp vec4 alpha = texture2D(texture, uv);
        gl_FragColor.a = RGBfromYUV(alpha.rgb).b;
        if(gl_FragColor.a <= 0.01)
            discard;
    }
  `;
    static _rgbFragmentShaderSource = `
    varying highp vec2 uv;

    uniform sampler2D texture;

    void main(void) 
    {
        highp vec4 alpha = texture2D(texture, uv);
        gl_FragColor.a = alpha.g;
        if(gl_FragColor.a <= 0.01)
            discard;
    }
  `;
    get nodeName() {
        return i.name;
    }
    isSupported(e) {
        return super.isSupported(e) && typeof WebGL2RenderingContext < "u";
    }
    get priority() {
        return 10;
    }
    _context = null;
    _workingCanvas = null;
    _workingContext = null;
    _mainTex = null;
    _shaderProgram = null;
    _vertexBuffer = null;
    async startInternal() {
        this._context = this._canvas?.getContext("2d");
    }
    async processInternal(e) {
        if (this._canvas === null || this._context === null) return;
        let { frame: t, alpha: s } = this.getFrames(e);
        if (t === null) return;
        let { width: r, height: n } = this.getDimensions(t);
        if ((r != this._canvas.width || n !== this._canvas.height) && (this._canvas.width = r, this._canvas.height = n), this._context.clearRect(0, 0, this._canvas.width, this._canvas.height), this._context.drawImage(t, 0, 0, this._canvas.width, this._canvas.height), s) {
            let a = this.getDimensions(s);
            this.initContext(a.width, a.height), this.drawAlpha(s);
        }
    }
    clear() {
        this._canvas === null || this._context === null || (this._context.clearRect(0, 0, this._canvas.width, this._canvas.height), this._workingCanvas = null);
    }
    async stopInternal() {
        this.clear(), this._workingContext?.deleteTexture(this._mainTex), this._workingContext?.deleteProgram(this._shaderProgram), this._workingContext?.deleteBuffer(this._vertexBuffer), await super.stopInternal();
    }
    drawAlpha(e) {
        if (this._workingCanvas === null || this._workingContext === null || this._canvas === null || this._context === null) return;
        let { width: t, height: s } = this.getDimensions(e);
        (t != this._workingCanvas.width || s !== this._workingCanvas.height) && (this._workingCanvas.width = t, this._workingCanvas.height = s, this._workingContext.viewport(0, 0, this._workingContext.drawingBufferWidth, this._workingContext.drawingBufferHeight)), this.canRender(e) && this._workingContext.texSubImage2D(this._workingContext.TEXTURE_2D, 0, 0, 0, this._workingContext.RGBA, this._workingContext.UNSIGNED_BYTE, e), this._workingContext.clear(this._workingContext.COLOR_BUFFER_BIT), this._workingContext.drawArrays(this._workingContext.TRIANGLE_FAN, 0, 4), this._context.globalCompositeOperation = "destination-in", this._context.drawImage(this._workingCanvas, 0, 0, this._workingCanvas.width, this._workingCanvas.height, 0, 0, this._canvas.width, this._canvas.height), this._context.globalCompositeOperation = "source-over";
    }
    initContext(e, t) {
        if (this._workingCanvas !== null) return;
        this._workingCanvas = new OffscreenCanvas(e, t), this._workingContext = this._workingCanvas.getContext("webgl2", {
            alpha: !0,
            powerPreference: "high-performance",
            antialias: !0,
            desynchronized: !0
        });
        let s = this._workingContext.createShader(this._workingContext.VERTEX_SHADER);
        if (this._workingContext.shaderSource(s, i._vertexShaderSource), this._workingContext.compileShader(s), !this._workingContext.getShaderParameter(s, this._workingContext.COMPILE_STATUS)) throw this._workingContext.getShaderInfoLog(s);
        let r = this._workingContext.createShader(this._workingContext.FRAGMENT_SHADER);
        if (this._workingContext.shaderSource(r, this._isVRB ? i._rgbFragmentShaderSource : i._yuvFragmentShaderSource), this._workingContext.compileShader(r), !this._workingContext.getShaderParameter(r, this._workingContext.COMPILE_STATUS)) throw this._workingContext.getShaderInfoLog(r);
        if (this._shaderProgram = this._workingContext.createProgram(), this._workingContext.attachShader(this._shaderProgram, s), this._workingContext.attachShader(this._shaderProgram, r), this._workingContext.linkProgram(this._shaderProgram), !this._workingContext.getProgramParameter(this._shaderProgram, this._workingContext.LINK_STATUS)) throw this._workingContext.getProgramInfoLog(this._shaderProgram);
        let n = this._workingContext.getUniformLocation(this._shaderProgram, "texture");
        this._workingContext.useProgram(this._shaderProgram), this._workingContext.uniform1i(n, 0), this._vertexBuffer = this._workingContext.createBuffer(), this._workingContext.bindBuffer(this._workingContext.ARRAY_BUFFER, this._vertexBuffer), this._workingContext.bufferData(this._workingContext.ARRAY_BUFFER, new Float32Array([
            -1,
            -1,
            -1,
            1,
            1,
            1,
            1,
            -1
        ]), this._workingContext.STATIC_DRAW);
        let a = this._workingContext.getAttribLocation(this._shaderProgram, "xy");
        this._workingContext.vertexAttribPointer(a, 2, this._workingContext.FLOAT, !1, 0, 0), this._workingContext.enableVertexAttribArray(a), this._workingContext.activeTexture(this._workingContext.TEXTURE0), this._mainTex = this._workingContext.createTexture(), this._workingContext.bindTexture(this._workingContext.TEXTURE_2D, this._mainTex), this._workingContext.texParameteri(this._workingContext.TEXTURE_2D, this._workingContext.TEXTURE_MAG_FILTER, this._workingContext.LINEAR), this._workingContext.texParameteri(this._workingContext.TEXTURE_2D, this._workingContext.TEXTURE_MIN_FILTER, this._workingContext.LINEAR), this._workingContext.texParameteri(this._workingContext.TEXTURE_2D, this._workingContext.TEXTURE_WRAP_S, this._workingContext.CLAMP_TO_EDGE), this._workingContext.texParameteri(this._workingContext.TEXTURE_2D, this._workingContext.TEXTURE_WRAP_T, this._workingContext.CLAMP_TO_EDGE), this._workingContext.texStorage2D(this._workingContext.TEXTURE_2D, 1, this._workingContext.RGBA8, e, t), this._workingContext.clearColor(0, 0, 0, 0), this._workingContext.viewport(0, 0, this._workingContext.drawingBufferWidth, this._workingContext.drawingBufferHeight);
    }
};
$e833773b1f4e7d0f$export$f82961e691216dba.Register($e833773b1f4e7d0f$export$712c343b526067c0);
var $e833773b1f4e7d0f$export$77a2a2e4927ef3c2 = class i extends $e833773b1f4e7d0f$export$c9f38831ebbeacb6 {
    static _defaultSampleRate = 50;
    get nodeName() {
        return i.name;
    }
    isSupported(e) {
        return e.length > 1 && e.some((t)=>t.canDriveSync);
    }
    _tracks = new Map;
    _timestamps = new Map;
    async startInternal(e) {
        e.forEach((t)=>this._tracks.set(t.trackId, t));
    }
    async processInternal(e) {
        if (!this._tracks.has(e.trackId)) return this.dispatchEvent(new ErrorEvent("error", {
            bubbles: !1,
            composed: !0,
            error: "SynchronizerError",
            message: "Unknown track"
        })), 0;
        this._timestamps.get(e.trackId) === void 0 && this._timestamps.set(e.trackId, e.timestamp);
        let t = 0, s = Number.POSITIVE_INFINITY;
        this._tracks.forEach((o)=>{
            if (o.canDriveSync) {
                let u = 1e3 / (o.sampleRate ?? i._defaultSampleRate), l = this._timestamps.get(o.trackId) / u;
                l < s && (s = l);
            }
        });
        let n = 1e3 / (this._tracks.get(e.trackId).sampleRate ?? i._defaultSampleRate), a = e.timestamp / n - s;
        if (Math.abs(a) > 1 && (t = a * n), [
            ...this._tracks.values()
        ].filter((o)=>o.canDriveSync).every((o)=>this._timestamps.get(o.trackId) !== void 0)) {
            let o = [
                ...this._tracks.keys()
            ];
            for (let u of o)this._timestamps.set(u, void 0);
        }
        return t;
    }
    async stopInternal() {
        this._tracks.clear(), this._timestamps.clear();
    }
};
$e833773b1f4e7d0f$export$f82961e691216dba.Register($e833773b1f4e7d0f$export$77a2a2e4927ef3c2);
var $e833773b1f4e7d0f$export$1ab82b514bfe7494 = class i extends $e833773b1f4e7d0f$export$b4772c72a3674b1d {
    _trackRenderers = new Map;
    _renderDataQueue = [];
    _synchronizer = null;
    _volume = 0;
    _muted = !1;
    _sinkId = "";
    _renderCallbackId = void 0;
    get volume() {
        return this._volume;
    }
    set volume(e) {
        if (this._volume === e) return;
        let t = [
            ...this._trackRenderers.values()
        ].filter((s)=>s.type === "audio").filter((s)=>s instanceof $e833773b1f4e7d0f$export$e1ba7b4bcaf34e50 || s.volume !== void 0);
        for (let s of t)s.volume = e;
    }
    get muted() {
        return this._muted;
    }
    set muted(e) {
        if (this._muted === e) return;
        let t = [
            ...this._trackRenderers.values()
        ].filter((s)=>s.type === "audio").filter((s)=>s instanceof $e833773b1f4e7d0f$export$e1ba7b4bcaf34e50 || s.muted !== void 0);
        for (let s of t)s.muted = e;
    }
    get sinkId() {
        return this._sinkId;
    }
    set sinkId(e) {
        if (this._sinkId === e) return;
        let t = [
            ...this._trackRenderers.values()
        ].filter((s)=>s.type === "audio").filter((s)=>s instanceof $e833773b1f4e7d0f$export$e1ba7b4bcaf34e50 || s.sinkId !== void 0);
        for (let s of t)s.sinkId = e;
    }
    static get groupType() {
        return 0;
    }
    get nodeName() {
        return i.name;
    }
    isSupported(e) {
        return e.length > 1;
    }
    get displayElement() {
        return [
            ...this._trackRenderers.values()
        ].map((e)=>e.displayElement).filter((e)=>e !== null).shift() ?? null;
    }
    get width() {
        let e = this.displayElement;
        return e instanceof HTMLVideoElement || e instanceof HTMLCanvasElement || e instanceof HTMLImageElement ? e.width : e?.offsetWidth ?? 0;
    }
    get height() {
        let e = this.displayElement;
        return e instanceof HTMLVideoElement || e instanceof HTMLCanvasElement || e instanceof HTMLImageElement ? e.height : e?.offsetHeight ?? 0;
    }
    init(e) {
        super.init(e), this._noAutomaticOnProcessed = !0;
    }
    async startInternal(e) {
        for (let s of e.filter((r)=>$e833773b1f4e7d0f$export$10682a8e214d9fcf(r))){
            let r = $e833773b1f4e7d0f$export$f82961e691216dba.Create({
                ...s
            });
            r && (this._trackRenderers.set(s.trackNumber, r), r.addEventListener("processed", ()=>this.onProcessed()), r.addEventListener("error", (n)=>this.dispatchEvent(n)), this._nodes.push(r));
        }
        for (let s of e.filter((r)=>$e833773b1f4e7d0f$export$fac04d879aa24ca8(r))){
            let r = this._trackRenderers.get(s.supplementsTrack);
            r && s.supplementaryData && r.addSupplementaryData(s.supplementaryData);
        }
        for (let s of this._trackRenderers)s[1].start();
        let t = e.map((s)=>({
                trackId: s.trackNumber,
                canDriveSync: s.trackType !== "text",
                sampleRate: s.sampleRate
            }));
        if (this._synchronizer = $e833773b1f4e7d0f$export$f82961e691216dba.Create(t), !this._synchronizer) {
            this.dispatchEvent(new ErrorEvent("error", {
                bubbles: !1,
                composed: !0,
                error: "NodeFactoryError",
                message: "Failed to create a synchronizer"
            }));
            return;
        }
        this._synchronizer.addEventListener("error", (s)=>this.dispatchEvent(s)), this._synchronizer.start(), this._nodes.push(this._synchronizer), this.render(!1);
    }
    async processInternal(e) {
        let t = await this._synchronizer?.process({
            timestamp: e.timestamp,
            trackId: e.trackId
        });
        t !== void 0 && t > 0 ? setTimeout(()=>this._renderDataQueue.push(e), t) : this._renderDataQueue.push(e);
    }
    async stopInternal() {
        this._synchronizer = null, this._trackRenderers.clear(), this._renderDataQueue.length = 0;
    }
    render(e) {
        if (!this.isRunning) return;
        let t = this._renderDataQueue.shift();
        t && this._trackRenderers.get(t.supplementsTrack ?? t.trackId)?.process(t.supplementsTrack === void 0 ? t.data : {
            data: t.data,
            isSupplementary: !0
        }), this._renderCallbackId && clearTimeout(this._renderCallbackId), !e && (this._renderCallbackId = setTimeout(()=>this.render(!1), 10));
    }
};
$e833773b1f4e7d0f$export$f82961e691216dba.Register($e833773b1f4e7d0f$export$1ab82b514bfe7494);

});

parcelRegister("3ztn0", function(module, exports) {

$parcel$export(module.exports, "DOMTokenListLike", () => $299b6c40adc500b8$export$5680f531ee093102);
$parcel$export(module.exports, "WebPlayerElement", () => $299b6c40adc500b8$export$dc16865c51905b16);
$parcel$export(module.exports, "FMP4ProtocolVersion", () => (parcelRequire("jW02B")).FMP4ProtocolVersion);
$parcel$export(module.exports, "Log", () => (parcelRequire("jW02B")).Log);

var $jW02B = parcelRequire("jW02B");

var $jOCUE = parcelRequire("jOCUE");
var $299b6c40adc500b8$export$21933374bb433488 = ((r)=>(r.UNKNOWN = "unknown", r.LIVE = "live", r.ON_DEMAND = "on-demand", r))($299b6c40adc500b8$export$21933374bb433488 || {}), $299b6c40adc500b8$export$e3425b961a6a8509 = ((s)=>(s.STOPPED = "STOPPED", s.PLAYING = "PLAYING", s.STALLING = "STALLING", s.PAUSED = "PAUSED", s.PREPARING = "PREPARING", s))($299b6c40adc500b8$export$e3425b961a6a8509 || {}), $299b6c40adc500b8$export$d04c4d0f556ca814 = ((u)=>(u.UNHANDLED_PLAYER_ERROR = "UNHANDLED_PLAYER_ERROR", u.GENERAL_ERROR = "GENERAL_ERROR", u.CRITICAL_TIMEOUT = "CRITICAL_TIMEOUT", u.UNSUPPORTED_MEDIA_FORMAT = "UNSUPPORTED_MEDIA_FORMAT", u.START_PLAYING_NOT_ALLOWED = "START_PLAYING_NOT_ALLOWED", u.WRONG_URL = "WRONG_URL", u.UNAUTHORIZED = "UNAUTHORIZED", u.FREQUENT_STALLS = "FREQUENT_STALLS", u))($299b6c40adc500b8$export$d04c4d0f556ca814 || {});
var $299b6c40adc500b8$export$83d89fbfd8236492 = "5.5.0-rc.5";
var $299b6c40adc500b8$export$73095185aa19db6b = class extends ErrorEvent {
    detail;
    constructor(e, t){
        super(e, t), this.detail = t?.detail;
    }
};
var $299b6c40adc500b8$export$5680f531ee093102 = class {
    _tokens = [];
    _supportCheck;
    _onChange;
    get length() {
        return this._tokens.length;
    }
    get value() {
        return this._tokens.join(" ");
    }
    get tokens() {
        return this._tokens;
    }
    constructor(e, t, r){
        this._supportCheck = t, this.add(...e), this._onChange = r;
    }
    toString() {
        return this.value;
    }
    add(...e) {
        for (let t of e.map((r)=>r.trim()))/^\s?$/.test(t) || this._tokens.includes(t) || this.supports(t) && (this[this.length] = t, this._tokens.push(t));
        this._onChange && this._onChange();
    }
    addValue(e) {
        this.add(...e.split(" "));
    }
    contains(e) {
        return this._tokens.includes(e);
    }
    item(e) {
        return this._tokens.at(e) ?? null;
    }
    remove(...e) {
        let t = this.length;
        for (let r of e.map((n1)=>n1.trim())){
            let n1 = this._tokens.indexOf(r);
            this._tokens.splice(n1, 1);
        }
        if (t !== this.length) {
            for(let r = 0; r < t; r++)delete this[r];
            for(let r = 0; r < this._tokens.length; r++)this[r] = this._tokens[r];
        }
        this._onChange && this._onChange();
    }
    replace(e, t) {
        if (e = e.trim(), t = t.trim(), this._tokens.includes(e) && this.supports(e)) {
            let r = this._tokens.indexOf(e);
            return this._tokens[r] = t, this[r] = t, this._onChange && this._onChange(), !0;
        }
        return !1;
    }
    supports(e) {
        return this._supportCheck ? this._supportCheck(e) : !0;
    }
    toggle(e, t) {
        return t === void 0 ? this.contains(e) ? this.remove(e) : this.add(e) : t ? this.add(e) : this.remove(e), this._onChange && this._onChange(), this.contains(e);
    }
    forEach(e, t) {
        this._tokens.forEach((r, n1)=>t !== void 0 ? e.bind(t)(r, n1, this) : e(r, n1, this));
    }
    clear() {
        this.length !== 0 && (this.clearInternal(), this._onChange && this._onChange());
    }
    equals(e) {
        if (this.length !== e.length) return !1;
        for(let t = 0; t < this.length; t++)if (!e.contains(this[t])) return !1;
        return !0;
    }
    set(e) {
        this.equals(e) || (this.clearInternal(), this.add(...e.tokens));
    }
    setValue(e) {
        this.value !== e && (this.clearInternal(), this.addValue(e));
    }
    clearInternal() {
        if (this.length !== 0) {
            for(let e = 0; e < this.length; e++)delete this[e];
            this._tokens.length = 0;
        }
    }
};
var $299b6c40adc500b8$export$48efa616601f8730 = ((r)=>(r.ADD_TRACK = "addtrack", r.REMOVE_TRACK = "removetrack", r.CHANGE = "change", r))($299b6c40adc500b8$export$48efa616601f8730 || {}), $299b6c40adc500b8$export$8931430458a8a419 = class extends Array {
    _eventTarget = new EventTarget;
    push(...e) {
        let t = super.push(...e);
        return this.dispatchEvent(new Event("addtrack")), t;
    }
    unshift(...e) {
        let t = super.unshift(...e);
        return this.dispatchEvent(new Event("addtrack")), t;
    }
    shift() {
        let e = super.shift();
        return e != null && this.dispatchEvent(new Event("removetrack")), e;
    }
    pop() {
        let e = super.pop();
        return e != null && this.dispatchEvent(new Event("removetrack")), e;
    }
    clear() {
        let e = this.length > 0;
        this.length = 0, e && this.dispatchEvent(new Event("removetrack"));
    }
    getTrackById(e) {
        return this.find((t)=>t.id === e);
    }
    addEventListener(e, t, r) {
        this._eventTarget.addEventListener(e, t, r);
    }
    removeEventListener(e, t, r) {
        this._eventTarget.removeEventListener(e, t, r);
    }
    dispatchEvent(e) {
        return this._eventTarget.dispatchEvent(e);
    }
}, $299b6c40adc500b8$export$a4240145594c03e8 = class extends $299b6c40adc500b8$export$8931430458a8a419 {
    get selectedIndex() {
        return this.findIndex((e)=>e.selected);
    }
    set selectedIndex(e) {
        this.length <= e || this.selectedIndex !== e && (this.forEach((t)=>t.selected = !1), this[e].selected = !0, this.dispatchEvent(new Event("change")));
    }
    get selected() {
        return this.find((e)=>e.selected) ?? null;
    }
    set selected(e) {
        e !== null && !this.includes(e) || this.selected !== e && (this.selectedIndex = e ? this.indexOf(e) : -1);
    }
};
var $299b6c40adc500b8$var$Et = class i extends HTMLElement {
    static observedAttributes = [
        "src",
        "lowlatency",
        "muted",
        "loop",
        "volume",
        "width",
        "height",
        "disablepictureinpicture",
        "passthroughtoken",
        "includemask",
        "autoplay",
        "engineslist",
        "connectiontimeout",
        "controls",
        "playsinline",
        "poster",
        "crossorigin",
        "onstatechanged",
        "onwarning",
        "onpositionchanged",
        "onscreenshot",
        "onerror",
        "onframeready",
        "oninvalidpassthroughtoken",
        "onmaskdecodingerror",
        "ondurationchange",
        "onstreamtypechange",
        "onended",
        "onaddvideotrack",
        "onremovevideotrack",
        "onvideotrackchange",
        "onenterpictureinpicture",
        "onleavepictureinpicture",
        "externalrenderer",
        "stallwindow",
        "maxstallevents",
        "fmp4protocolversion"
    ];
    static propertyPairs = [];
    HAVE_NOTHING = 0;
    HAVE_METADATA = 1;
    HAVE_CURRENT_DATA = 2;
    HAVE_FUTURE_DATA = 3;
    HAVE_ENOUGH_DATA = 4;
    NETWORK_EMPTY = 0;
    NETWORK_IDLE = 1;
    NETWORK_LOADING = 2;
    NETWORK_NO_SOURCE = 3;
    _src = "";
    _lowLatency = !1;
    _muted = !1;
    _loop = !1;
    _volume = 1;
    _width = 0;
    _height = 0;
    _disablePictureInPicture = !1;
    _token = "";
    _includeMask = !1;
    _autoplay = !1;
    _enginesList = new $299b6c40adc500b8$export$5680f531ee093102([], void 0, ()=>{
        this.enginesList !== this._enginesList.value && (this.setAttributeValue("enginesList", this._enginesList.value), this.enginesListInternal = this.enginesList);
    });
    _connectionTimeout = 1e4;
    _controls = !1;
    _playsInline = !1;
    _poster = "";
    _crossOrigin = "";
    _externalRenderer = !1;
    _stallWindow = 1e4;
    _maxStallEvents = 5;
    _fmp4ProtocolVersion = (0, $jW02B.FMP4ProtocolVersion).V4;
    _defaultMuted = !1;
    get observedAttributes() {
        return i.observedAttributes;
    }
    get defaultMuted() {
        return this._defaultMuted;
    }
    set defaultMuted(e) {
        this._defaultMuted !== e && (this._defaultMuted = e);
    }
    get controls() {
        return this._controls;
    }
    set controls(e) {
        this._controls !== e && (this._controls = e, this.setAttributeValue("controls", e), this.controlsInternal = e);
    }
    get autoplay() {
        return this._autoplay;
    }
    set autoplay(e) {
        this._autoplay !== e && (this._autoplay = e, this.setAttributeValue("autoplay", e), this.autoplayInternal = e);
    }
    get src() {
        return this._src;
    }
    set src(e) {
        this.src !== e && (this._src = e, this.setAttributeValue("src", e), this.srcInternal = e);
    }
    get lowLatency() {
        return this._lowLatency;
    }
    set lowLatency(e) {
        this.lowLatency !== e && (this._lowLatency = e, this.setAttributeValue("lowLatency", e), this.lowLatencyInternal = e);
    }
    get muted() {
        return this._muted;
    }
    set muted(e) {
        this.muted !== e && (this._muted = e, this.setAttributeValue("muted", e), this.mutedInternal = e);
    }
    get loop() {
        return this._loop;
    }
    set loop(e) {
        this.loop !== e && (this._loop = e, this.setAttributeValue("loop", e), this.loopInternal = e);
    }
    get volume() {
        return this._volume;
    }
    set volume(e) {
        this.volume !== e && (this._volume = e, this.setAttributeValue("volume", e), this.volumeInternal = e);
    }
    get width() {
        return this._width;
    }
    set width(e) {
        this.width !== e && (this._width = e, this.setAttributeValue("width", e), this.widthInternal = e);
    }
    get height() {
        return this._height;
    }
    set height(e) {
        this.height !== e && (this._height = e, this.setAttributeValue("height", e), this.heightInternal = e);
    }
    get disablePictureInPicture() {
        return this._disablePictureInPicture;
    }
    set disablePictureInPicture(e) {
        this.disablePictureInPicture !== e && (this._disablePictureInPicture = e, this.setAttributeValue("disablePictureInPicture", e), this.disablePictureInPictureInternal = e);
    }
    get passthroughToken() {
        return this._token;
    }
    set passthroughToken(e) {
        this._token !== e && (this._token = e, this.setAttributeValue("passthroughToken", e), this.tokenInternal = e);
    }
    get includeMask() {
        return this._includeMask;
    }
    set includeMask(e) {
        this._includeMask !== e && (this._includeMask = e, this.setAttributeValue("includeMask", e), this.includeMaskInternal = e);
    }
    get enginesList() {
        return this._enginesList.value;
    }
    set enginesList(e) {
        this.enginesList !== e && (this._enginesList.setValue(e), this.setAttributeValue("enginesList", this.enginesList), this.enginesListInternal = this.enginesList);
    }
    get connectionTimeout() {
        return this._connectionTimeout;
    }
    set connectionTimeout(e) {
        this._connectionTimeout !== e && (this._connectionTimeout = e, this.setAttributeValue("connectionTimeout", e), this.connectionTimeoutInternal = e);
    }
    get playsInline() {
        return this._playsInline;
    }
    set playsInline(e) {
        this._playsInline !== e && (this._playsInline = e, this.setAttributeValue("playsInline", e), this.playsInlineInternal = e);
    }
    get poster() {
        return this._poster;
    }
    set poster(e) {
        this._poster !== e && (this._poster = e, this.setAttributeValue("poster", e), this.posterInternal = e);
    }
    get networkState() {
        if (this.src === "") return this.NETWORK_NO_SOURCE;
        switch(this.readyState){
            case this.HAVE_NOTHING:
                return this.NETWORK_EMPTY;
            case this.HAVE_ENOUGH_DATA:
                return this.NETWORK_IDLE;
        }
        return this.NETWORK_LOADING;
    }
    get crossOrigin() {
        return this._crossOrigin;
    }
    set crossOrigin(e) {
        this.crossOrigin !== e && (e === null ? this._crossOrigin = "" : this._crossOrigin = e === "anonymous" || e === "use-credentials" || e === "" ? e : "anonymous", this.setAttribute("crossorigin", this.crossOrigin ?? ""), this.crossOriginInternal = this._crossOrigin ?? "");
    }
    get fmp4ProtocolVersion() {
        return this._fmp4ProtocolVersion;
    }
    set fmp4ProtocolVersion(e) {
        this._fmp4ProtocolVersion !== e && (this._fmp4ProtocolVersion = e, this.setAttributeValue("fmp4ProtocolVersion", e), this.fmp4ProtocolVersionInternal = e);
    }
    get externalRenderer() {
        return this._externalRenderer;
    }
    set externalRenderer(e) {
        this._externalRenderer !== e && (this._externalRenderer = e, this.setAttributeValue("externalRenderer", e), this.externalRendererInternal = e);
    }
    get stallWindow() {
        return this._stallWindow;
    }
    set stallWindow(e) {
        this._stallWindow !== e && (this._stallWindow = e, this.setAttributeValue("stallWindow", e), this.stallWindowInternal = e);
    }
    get maxStallEvents() {
        return this._maxStallEvents;
    }
    set maxStallEvents(e) {
        this._maxStallEvents !== e && (this._maxStallEvents = e, this.setAttributeValue("maxStallEvents", e), this.maxStallEventsInternal = e);
    }
    constructor(){
        super(), this.attachShadow({
            mode: "open"
        });
    }
    connectedCallback() {
        (0, $jW02B.LogInternal).info(`[${this.tagName}] Custom element added to page.`), this.upgradeProperty("src"), this.upgradeProperty("autoplay"), this.upgradeProperty("controls"), this.upgradeProperty("lowLatency"), this.upgradeProperty("muted"), this.upgradeProperty("volume"), this.upgradeProperty("loop"), this.upgradeProperty("width"), this.upgradeProperty("height"), this.upgradeProperty("disablePictureInPicture"), this.upgradeProperty("passthroughToken"), this.upgradeProperty("includeMask"), this.upgradeProperty("enginesList"), this.upgradeProperty("connectionTimeout"), this.upgradeProperty("poster"), this.upgradeProperty("crossOrigin"), this.upgradeProperty("externalRenderer"), this.upgradeProperty("stallWindow"), this.upgradeProperty("maxStallEvents"), this.upgradeProperty("fmp4ProtocolVersion"), this.upgradeProperty("onstatechanged"), this.upgradeProperty("onwarning"), this.upgradeProperty("onpositionchanged"), this.upgradeProperty("onerror"), this.upgradeProperty("onframeready"), this.upgradeProperty("oninvalidpassthroughtoken"), this.upgradeProperty("onmaskdecodingerror"), this.upgradeProperty("ondurationchange"), this.upgradeProperty("onstreamtypechange"), this.upgradeProperty("onended"), this.upgradeProperty("onaddvideotrack"), this.upgradeProperty("onremovevideotrack"), this.upgradeProperty("onvideotrackchange"), this.upgradeProperty("onenterpictureinpicture"), this.upgradeProperty("onleavepictureinpicture"), this.upgradeProperty("onengineschange"), this._defaultMuted && (this.muted = !0);
    }
    disconnectedCallback() {
        (0, $jW02B.LogInternal).info(`[${this.tagName}] Custom element removed from page.`);
    }
    adoptedCallback() {
        (0, $jW02B.LogInternal).info(`[${this.tagName}] Custom element moved to new page.`);
    }
    async fastSeek(e) {
        await this.seek(e);
    }
    srcObject = null;
    mozSrcObject = null;
    preload = "";
    defaultPlaybackRate = 1;
    playbackRate = 1;
    disableRemotePlayback = !1;
    onstatechanged = null;
    onwarning = null;
    onpositionchanged = null;
    onframeready = null;
    oninvalidpassthroughtoken = null;
    onmaskdecodingerror = null;
    onstreamtypechange = null;
    onaddvideotrack = null;
    onremovevideotrack = null;
    onvideotrackchange = null;
    onenterpictureinpicture = null;
    onleavepictureinpicture = null;
    onencrypted = null;
    onwaitingforkey = null;
    onengineschange = null;
    addEventListener(e, t, r) {
        super.addEventListener(e, t, r);
    }
    removeEventListener(e, t, r) {
        super.removeEventListener(e, t, r);
    }
    setAttributeValue(e, t) {
        let r = e.toLowerCase();
        if (this.observedAttributes.includes(r)) {
            if (t === null && this.getAttribute(r) !== null) this.removeAttribute(r);
            else if (typeof t == "object" && t instanceof $299b6c40adc500b8$export$5680f531ee093102) this.setAttribute(r, t.value);
            else if (typeof t == "object" && Array.isArray(t)) {
                let n1 = t.length > 0 ? t.join(" ") : "";
                this.getAttribute(r) !== n1 && this.setAttribute(r, n1);
            } else typeof t == "string" && this.getAttribute(r) !== t ? t !== "" ? this.setAttribute(r, t) : this.removeAttribute(r) : typeof t == "number" && this.getAttribute(r) !== t.toString() ? this.setAttribute(r, t.toString()) : typeof t == "boolean" && t && this.getAttribute(r) === null ? this.setAttribute(r, "") : typeof t == "boolean" && !t && this.getAttribute(r) !== null && this.removeAttribute(r);
        }
    }
    static setPropertyValue(e, t) {
        let r = e.getAttribute(t);
        if (r === null) return;
        let n1 = e[t];
        typeof n1 == "string" ? e[t] = r : typeof n1 == "number" ? e[t] = Number.parseFloat(r) : typeof n1 == "boolean" ? e[t] = r !== null : typeof n1 == "object" && n1 instanceof $299b6c40adc500b8$export$5680f531ee093102 ? n1.setValue(r) : typeof n1 == "object" && Array.isArray(n1) && (e[t] = r.includes(" ") ? r.split(" ") : [
            r
        ]);
    }
    static upgradeProperty(e, t) {
        if (i.propertyPairs.push({
            property: t,
            attribute: t.toLowerCase()
        }), e.hasOwnProperty(t)) {
            let r = e[t];
            delete e[t], e[t] = r;
        } else t in e && i.setPropertyValue(e, t);
    }
    upgradeProperty(e) {
        i.upgradeProperty(this, e);
    }
    attributeChangedCallback(e, t, r) {
        let n1 = i.propertyPairs.find((o)=>o.attribute === e)?.property ?? "", s = JSON.stringify(this[n1]);
        n1 in this && (typeof this[n1] == typeof r ? this[n1] = r : typeof this[n1] == "number" && typeof r == "string" ? this[n1] = Number.parseFloat(r) : typeof this[n1] == "number" && r === null ? this[n1] = 0 : typeof this[n1] == "boolean" && r === null ? this[n1] = !1 : typeof this[n1] == "string" && r === null ? this[n1] = "" : typeof this[n1] == "boolean" && typeof r == "string" ? this[n1] = !0 : typeof this[n1] == "object" && Array.isArray(this[n1]) && typeof r == "string" ? this[n1] = r.split(" ") : typeof this[n1] == "object" && Array.isArray(this[n1]) && r === null ? this[n1] = [] : typeof this[n1] == "object" && this[n1] instanceof $299b6c40adc500b8$export$5680f531ee093102 && typeof r == "string" ? this[n1].setValue(r) : typeof this[n1] == "object" && this[n1]), (0, $jW02B.LogInternal).debug(`[${this.tagName}] Attribute '${e}' (property: '${n1}') changed, old value: ${t}, new value: ${r}, old property value: ${s}, new property value: ${JSON.stringify(this[n1])}`);
    }
};
var $299b6c40adc500b8$var$Zr = class {
    addEventListener() {}
    removeEventListener() {}
    dispatchEvent() {
        return !0;
    }
}, $299b6c40adc500b8$var$Qr = class extends $299b6c40adc500b8$var$Zr {
}, $299b6c40adc500b8$var$zr = class extends $299b6c40adc500b8$var$Qr {
    constructor(){
        super(...arguments), this.role = null;
    }
}, $299b6c40adc500b8$var$Ks = class {
    observe() {}
    unobserve() {}
    disconnect() {}
}, $299b6c40adc500b8$var$Cl = {
    createElement: function() {
        return new $299b6c40adc500b8$var$Ni.HTMLElement;
    },
    createElementNS: function() {
        return new $299b6c40adc500b8$var$Ni.HTMLElement;
    },
    addEventListener () {},
    removeEventListener () {},
    dispatchEvent (i) {
        return !1;
    }
}, $299b6c40adc500b8$var$Ni = {
    ResizeObserver: $299b6c40adc500b8$var$Ks,
    document: $299b6c40adc500b8$var$Cl,
    Node: $299b6c40adc500b8$var$Qr,
    Element: $299b6c40adc500b8$var$zr,
    HTMLElement: class extends $299b6c40adc500b8$var$zr {
        constructor(){
            super(...arguments), this.innerHTML = "";
        }
        get content() {
            return new $299b6c40adc500b8$var$Ni.DocumentFragment;
        }
    },
    DocumentFragment: class extends $299b6c40adc500b8$var$Zr {
    },
    customElements: {
        get: function() {},
        define: function() {},
        whenDefined: function() {}
    },
    localStorage: {
        getItem (i) {
            return null;
        },
        setItem (i, e) {},
        removeItem (i) {}
    },
    CustomEvent: function() {},
    getComputedStyle: function() {},
    navigator: {
        languages: [],
        get userAgent () {
            return "";
        }
    },
    matchMedia (i) {
        return {
            matches: !1,
            media: i
        };
    },
    DOMParser: class {
        parseFromString(e, t) {
            return {
                body: {
                    textContent: e
                }
            };
        }
    }
}, $299b6c40adc500b8$var$Rl = typeof window > "u" || typeof window.customElements > "u", $299b6c40adc500b8$var$Pl = Object.keys($299b6c40adc500b8$var$Ni).every((i)=>i in globalThis), $299b6c40adc500b8$var$l = $299b6c40adc500b8$var$Rl && !$299b6c40adc500b8$var$Pl ? $299b6c40adc500b8$var$Ni : globalThis, $299b6c40adc500b8$var$F = $299b6c40adc500b8$var$Rl && !$299b6c40adc500b8$var$Pl ? $299b6c40adc500b8$var$Cl : globalThis.document;
var $299b6c40adc500b8$var$h = {
    MEDIA_PLAY_REQUEST: "mediaplayrequest",
    MEDIA_PAUSE_REQUEST: "mediapauserequest",
    MEDIA_MUTE_REQUEST: "mediamuterequest",
    MEDIA_UNMUTE_REQUEST: "mediaunmuterequest",
    MEDIA_VOLUME_REQUEST: "mediavolumerequest",
    MEDIA_SEEK_REQUEST: "mediaseekrequest",
    MEDIA_AIRPLAY_REQUEST: "mediaairplayrequest",
    MEDIA_ENTER_FULLSCREEN_REQUEST: "mediaenterfullscreenrequest",
    MEDIA_EXIT_FULLSCREEN_REQUEST: "mediaexitfullscreenrequest",
    MEDIA_PREVIEW_REQUEST: "mediapreviewrequest",
    MEDIA_ENTER_PIP_REQUEST: "mediaenterpiprequest",
    MEDIA_EXIT_PIP_REQUEST: "mediaexitpiprequest",
    MEDIA_ENTER_CAST_REQUEST: "mediaentercastrequest",
    MEDIA_EXIT_CAST_REQUEST: "mediaexitcastrequest",
    MEDIA_SHOW_TEXT_TRACKS_REQUEST: "mediashowtexttracksrequest",
    MEDIA_HIDE_TEXT_TRACKS_REQUEST: "mediahidetexttracksrequest",
    MEDIA_SHOW_SUBTITLES_REQUEST: "mediashowsubtitlesrequest",
    MEDIA_DISABLE_SUBTITLES_REQUEST: "mediadisablesubtitlesrequest",
    MEDIA_TOGGLE_SUBTITLES_REQUEST: "mediatogglesubtitlesrequest",
    MEDIA_PLAYBACK_RATE_REQUEST: "mediaplaybackraterequest",
    MEDIA_RENDITION_REQUEST: "mediarenditionrequest",
    MEDIA_AUDIO_TRACK_REQUEST: "mediaaudiotrackrequest",
    MEDIA_SEEK_TO_LIVE_REQUEST: "mediaseektoliverequest",
    REGISTER_MEDIA_STATE_RECEIVER: "registermediastatereceiver",
    UNREGISTER_MEDIA_STATE_RECEIVER: "unregistermediastatereceiver"
}, $299b6c40adc500b8$var$I = {
    MEDIA_CHROME_ATTRIBUTES: "mediachromeattributes",
    MEDIA_CONTROLLER: "mediacontroller"
}, $299b6c40adc500b8$var$qs = {
    MEDIA_AIRPLAY_UNAVAILABLE: "mediaAirplayUnavailable",
    MEDIA_AUDIO_TRACK_ENABLED: "mediaAudioTrackEnabled",
    MEDIA_AUDIO_TRACK_LIST: "mediaAudioTrackList",
    MEDIA_AUDIO_TRACK_UNAVAILABLE: "mediaAudioTrackUnavailable",
    MEDIA_BUFFERED: "mediaBuffered",
    MEDIA_CAST_UNAVAILABLE: "mediaCastUnavailable",
    MEDIA_CHAPTERS_CUES: "mediaChaptersCues",
    MEDIA_CURRENT_TIME: "mediaCurrentTime",
    MEDIA_DURATION: "mediaDuration",
    MEDIA_ENDED: "mediaEnded",
    MEDIA_ERROR: "mediaError",
    MEDIA_ERROR_CODE: "mediaErrorCode",
    MEDIA_ERROR_MESSAGE: "mediaErrorMessage",
    MEDIA_FULLSCREEN_UNAVAILABLE: "mediaFullscreenUnavailable",
    MEDIA_HAS_PLAYED: "mediaHasPlayed",
    MEDIA_HEIGHT: "mediaHeight",
    MEDIA_IS_AIRPLAYING: "mediaIsAirplaying",
    MEDIA_IS_CASTING: "mediaIsCasting",
    MEDIA_IS_FULLSCREEN: "mediaIsFullscreen",
    MEDIA_IS_PIP: "mediaIsPip",
    MEDIA_LOADING: "mediaLoading",
    MEDIA_MUTED: "mediaMuted",
    MEDIA_PAUSED: "mediaPaused",
    MEDIA_PIP_UNAVAILABLE: "mediaPipUnavailable",
    MEDIA_PLAYBACK_RATE: "mediaPlaybackRate",
    MEDIA_PREVIEW_CHAPTER: "mediaPreviewChapter",
    MEDIA_PREVIEW_COORDS: "mediaPreviewCoords",
    MEDIA_PREVIEW_IMAGE: "mediaPreviewImage",
    MEDIA_PREVIEW_TIME: "mediaPreviewTime",
    MEDIA_RENDITION_LIST: "mediaRenditionList",
    MEDIA_RENDITION_SELECTED: "mediaRenditionSelected",
    MEDIA_RENDITION_UNAVAILABLE: "mediaRenditionUnavailable",
    MEDIA_SEEKABLE: "mediaSeekable",
    MEDIA_STREAM_TYPE: "mediaStreamType",
    MEDIA_SUBTITLES_LIST: "mediaSubtitlesList",
    MEDIA_SUBTITLES_SHOWING: "mediaSubtitlesShowing",
    MEDIA_TARGET_LIVE_WINDOW: "mediaTargetLiveWindow",
    MEDIA_TIME_IS_LIVE: "mediaTimeIsLive",
    MEDIA_VOLUME: "mediaVolume",
    MEDIA_VOLUME_LEVEL: "mediaVolumeLevel",
    MEDIA_VOLUME_UNAVAILABLE: "mediaVolumeUnavailable",
    MEDIA_LANG: "mediaLang",
    MEDIA_WIDTH: "mediaWidth"
}, $299b6c40adc500b8$var$Dl = Object.entries($299b6c40adc500b8$var$qs), $299b6c40adc500b8$var$a = $299b6c40adc500b8$var$Dl.reduce((i, [e, t])=>(i[e] = t.toLowerCase(), i), {}), $299b6c40adc500b8$var$rc = {
    USER_INACTIVE_CHANGE: "userinactivechange",
    BREAKPOINTS_CHANGE: "breakpointchange",
    BREAKPOINTS_COMPUTED: "breakpointscomputed"
}, $299b6c40adc500b8$var$gt = $299b6c40adc500b8$var$Dl.reduce((i, [e, t])=>(i[e] = t.toLowerCase(), i), {
    ...$299b6c40adc500b8$var$rc
}), $299b6c40adc500b8$var$zp = Object.entries($299b6c40adc500b8$var$gt).reduce((i, [e, t])=>{
    let r = $299b6c40adc500b8$var$a[e];
    return r && (i[t] = r), i;
}, {
    userinactivechange: "userinactive"
}), $299b6c40adc500b8$var$Ol = Object.entries($299b6c40adc500b8$var$a).reduce((i, [e, t])=>{
    let r = $299b6c40adc500b8$var$gt[e];
    return r && (i[t] = r), i;
}, {
    userinactive: "userinactivechange"
}), $299b6c40adc500b8$var$ie = {
    SUBTITLES: "subtitles",
    CAPTIONS: "captions",
    DESCRIPTIONS: "descriptions",
    CHAPTERS: "chapters",
    METADATA: "metadata"
}, $299b6c40adc500b8$var$je = {
    DISABLED: "disabled",
    HIDDEN: "hidden",
    SHOWING: "showing"
};
var $299b6c40adc500b8$var$Ys = {
    MOUSE: "mouse",
    PEN: "pen",
    TOUCH: "touch"
}, $299b6c40adc500b8$var$re = {
    UNAVAILABLE: "unavailable",
    UNSUPPORTED: "unsupported"
}, $299b6c40adc500b8$var$Te = {
    LIVE: "live",
    ON_DEMAND: "on-demand",
    UNKNOWN: "unknown"
};
var $299b6c40adc500b8$var$xl = {
    INLINE: "inline",
    FULLSCREEN: "fullscreen",
    PICTURE_IN_PICTURE: "picture-in-picture"
};
function $299b6c40adc500b8$var$Nl({ anchor: i, floating: e, placement: t }) {
    let r = $299b6c40adc500b8$var$sc({
        anchor: i,
        floating: e
    }), { x: n1, y: s } = $299b6c40adc500b8$var$oc(r, t);
    return {
        x: n1,
        y: s
    };
}
function $299b6c40adc500b8$var$sc({ anchor: i, floating: e }) {
    return {
        anchor: $299b6c40adc500b8$var$ac(i, e.offsetParent),
        floating: {
            x: 0,
            y: 0,
            width: e.offsetWidth,
            height: e.offsetHeight
        }
    };
}
function $299b6c40adc500b8$var$ac(i, e) {
    var t;
    let r = i.getBoundingClientRect(), n1 = (t = e?.getBoundingClientRect()) != null ? t : {
        x: 0,
        y: 0
    };
    return {
        x: r.x - n1.x,
        y: r.y - n1.y,
        width: r.width,
        height: r.height
    };
}
function $299b6c40adc500b8$var$oc({ anchor: i, floating: e }, t) {
    let r = $299b6c40adc500b8$var$lc(t) === "x" ? "y" : "x", n1 = r === "y" ? "height" : "width", s = $299b6c40adc500b8$var$Ul(t), o = i.x + i.width / 2 - e.width / 2, d = i.y + i.height / 2 - e.height / 2, u = i[n1] / 2 - e[n1] / 2, m;
    switch(s){
        case "top":
            m = {
                x: o,
                y: i.y - e.height
            };
            break;
        case "bottom":
            m = {
                x: o,
                y: i.y + i.height
            };
            break;
        case "right":
            m = {
                x: i.x + i.width,
                y: d
            };
            break;
        case "left":
            m = {
                x: i.x - e.width,
                y: d
            };
            break;
        default:
            m = {
                x: i.x,
                y: i.y
            };
    }
    switch(t.split("-")[1]){
        case "start":
            m[r] -= u;
            break;
        case "end":
            m[r] += u;
            break;
    }
    return m;
}
function $299b6c40adc500b8$var$Ul(i) {
    return i.split("-")[0];
}
function $299b6c40adc500b8$var$lc(i) {
    return [
        "top",
        "bottom"
    ].includes($299b6c40adc500b8$var$Ul(i)) ? "y" : "x";
}
var $299b6c40adc500b8$var$Hl = new WeakMap, $299b6c40adc500b8$var$Zs = (i)=>{
    let e = $299b6c40adc500b8$var$Hl.get(i);
    return e || $299b6c40adc500b8$var$Hl.set(i, e = new Set), e;
}, $299b6c40adc500b8$var$Vl = new $299b6c40adc500b8$var$l.ResizeObserver((i)=>{
    for (let e of i)for (let t of $299b6c40adc500b8$var$Zs(e.target))t(e);
});
function $299b6c40adc500b8$var$qe(i, e) {
    $299b6c40adc500b8$var$Zs(i).add(e), $299b6c40adc500b8$var$Vl.observe(i);
}
function $299b6c40adc500b8$var$Ye(i, e) {
    let t = $299b6c40adc500b8$var$Zs(i);
    t.delete(e), t.size || $299b6c40adc500b8$var$Vl.unobserve(i);
}
var $299b6c40adc500b8$var$et = class extends Event {
    constructor({ action: e = "auto", relatedTarget: t, ...r }){
        super("invoke", r), this.action = e, this.relatedTarget = t;
    }
}, $299b6c40adc500b8$var$Xr = class extends Event {
    constructor({ newState: e, oldState: t, ...r }){
        super("toggle", r), this.newState = e, this.oldState = t;
    }
};
function $299b6c40adc500b8$var$W(i) {
    let e = {};
    for (let t of i)e[t.name] = t.value;
    return e;
}
function $299b6c40adc500b8$var$D(i) {
    var e;
    return (e = $299b6c40adc500b8$var$Jr(i)) != null ? e : $299b6c40adc500b8$var$we(i, "media-controller");
}
function $299b6c40adc500b8$var$Jr(i) {
    var e;
    let { MEDIA_CONTROLLER: t } = $299b6c40adc500b8$var$I, r = i.getAttribute(t);
    if (r) return (e = $299b6c40adc500b8$var$bt(i)) == null ? void 0 : e.getElementById(r);
}
var $299b6c40adc500b8$var$jr = (i, e, t = ".value")=>{
    let r = i.querySelector(t);
    r && (r.textContent = e);
}, $299b6c40adc500b8$var$dc = (i, e)=>{
    let t = `slot[name="${e}"]`, r = i.shadowRoot.querySelector(t);
    return r ? r.children : [];
}, $299b6c40adc500b8$var$en = (i, e)=>$299b6c40adc500b8$var$dc(i, e)[0], $299b6c40adc500b8$var$ee = (i, e)=>!i || !e ? !1 : i?.contains(e) ? !0 : $299b6c40adc500b8$var$ee(i, e.getRootNode().host), $299b6c40adc500b8$var$we = (i, e)=>{
    if (!i) return null;
    let t = i.closest(e);
    return t || $299b6c40adc500b8$var$we(i.getRootNode().host, e);
};
function $299b6c40adc500b8$var$Ui(i = document) {
    var e;
    let t = i?.activeElement;
    return t ? (e = $299b6c40adc500b8$var$Ui(t.shadowRoot)) != null ? e : t : null;
}
function $299b6c40adc500b8$var$bt(i) {
    var e;
    let t = (e = i?.getRootNode) == null ? void 0 : e.call(i);
    return t instanceof ShadowRoot || t instanceof Document ? t : null;
}
function $299b6c40adc500b8$var$tn(i, { depth: e = 3, checkOpacity: t = !0, checkVisibilityCSS: r = !0 } = {}) {
    if (i.checkVisibility) return i.checkVisibility({
        checkOpacity: t,
        checkVisibilityCSS: r
    });
    let n1 = i;
    for(; n1 && e > 0;){
        let s = getComputedStyle(n1);
        if (t && s.opacity === "0" || r && s.visibility === "hidden" || s.display === "none") return !1;
        n1 = n1.parentElement, e--;
    }
    return !0;
}
function $299b6c40adc500b8$var$Wl(i, e, t, r) {
    let n1 = r.x - t.x, s = r.y - t.y, o = n1 * n1 + s * s;
    if (o === 0) return 0;
    let d = ((i - t.x) * n1 + (e - t.y) * s) / o;
    return Math.max(0, Math.min(1, d));
}
function $299b6c40adc500b8$var$O(i, e) {
    let t = $299b6c40adc500b8$var$uc(i, (r)=>r === e);
    return t || $299b6c40adc500b8$var$Qs(i, e);
}
function $299b6c40adc500b8$var$uc(i, e) {
    var t, r;
    let n1;
    for (n1 of (t = i.querySelectorAll("style:not([media])")) != null ? t : []){
        let s;
        try {
            s = (r = n1.sheet) == null ? void 0 : r.cssRules;
        } catch  {
            continue;
        }
        for (let o of s ?? [])if (e(o.selectorText)) return o;
    }
}
function $299b6c40adc500b8$var$Qs(i, e) {
    var t, r;
    let n1 = (t = i.querySelectorAll("style:not([media])")) != null ? t : [], s = n1?.[n1.length - 1];
    return s?.sheet ? (s?.sheet.insertRule(`${e}{}`, s.sheet.cssRules.length), (r = s.sheet.cssRules) == null ? void 0 : r[s.sheet.cssRules.length - 1]) : (console.warn("Media Chrome: No style sheet found on style tag of", i), {
        style: {
            setProperty: ()=>{},
            removeProperty: ()=>"",
            getPropertyValue: ()=>""
        }
    });
}
function $299b6c40adc500b8$var$M(i, e, t = Number.NaN) {
    let r = i.getAttribute(e);
    return r != null ? +r : t;
}
function $299b6c40adc500b8$var$w(i, e, t) {
    let r = +t;
    if (t == null || Number.isNaN(r)) {
        i.hasAttribute(e) && i.removeAttribute(e);
        return;
    }
    $299b6c40adc500b8$var$M(i, e, void 0) !== r && i.setAttribute(e, `${r}`);
}
function $299b6c40adc500b8$var$A(i, e) {
    return i.hasAttribute(e);
}
function $299b6c40adc500b8$var$y(i, e, t) {
    if (t == null) {
        i.hasAttribute(e) && i.removeAttribute(e);
        return;
    }
    $299b6c40adc500b8$var$A(i, e) != t && i.toggleAttribute(e, t);
}
function $299b6c40adc500b8$var$_(i, e, t = null) {
    var r;
    return (r = i.getAttribute(e)) != null ? r : t;
}
function $299b6c40adc500b8$var$b(i, e, t) {
    if (t == null) {
        i.hasAttribute(e) && i.removeAttribute(e);
        return;
    }
    let r = `${t}`;
    $299b6c40adc500b8$var$_(i, e, void 0) !== r && i.setAttribute(e, r);
}
var $299b6c40adc500b8$var$oa = (i, e, t)=>{
    if (!e.has(i)) throw TypeError("Cannot " + t);
}, $299b6c40adc500b8$var$C = (i, e, t)=>($299b6c40adc500b8$var$oa(i, e, "read from private field"), t ? t.call(i) : e.get(i)), $299b6c40adc500b8$var$x = (i, e, t)=>{
    if (e.has(i)) throw TypeError("Cannot add the same private member more than once");
    e instanceof WeakSet ? e.add(i) : e.set(i, t);
}, $299b6c40adc500b8$var$Ce = (i, e, t, r)=>($299b6c40adc500b8$var$oa(i, e, "write to private field"), r ? r.call(i, t) : e.set(i, t), t), $299b6c40adc500b8$var$N = (i, e, t)=>($299b6c40adc500b8$var$oa(i, e, "access private method"), t), $299b6c40adc500b8$var$Re, $299b6c40adc500b8$var$_t, $299b6c40adc500b8$var$tt, $299b6c40adc500b8$var$rn, $299b6c40adc500b8$var$nn, $299b6c40adc500b8$var$Tt, $299b6c40adc500b8$var$Wi, $299b6c40adc500b8$var$zs, $299b6c40adc500b8$var$Fl, $299b6c40adc500b8$var$on, $299b6c40adc500b8$var$la, $299b6c40adc500b8$var$ln, $299b6c40adc500b8$var$sn, $299b6c40adc500b8$var$Xs, $299b6c40adc500b8$var$Js, $299b6c40adc500b8$var$Bl, $299b6c40adc500b8$var$js, $299b6c40adc500b8$var$$l, $299b6c40adc500b8$var$ea, $299b6c40adc500b8$var$Gl, $299b6c40adc500b8$var$Kt, $299b6c40adc500b8$var$qt, $299b6c40adc500b8$var$Yt, $299b6c40adc500b8$var$Fi, $299b6c40adc500b8$var$dn, $299b6c40adc500b8$var$da, $299b6c40adc500b8$var$ta, $299b6c40adc500b8$var$Kl, $299b6c40adc500b8$var$ua, $299b6c40adc500b8$var$ql, $299b6c40adc500b8$var$ia, $299b6c40adc500b8$var$Yl, $299b6c40adc500b8$var$ca, $299b6c40adc500b8$var$Zl, $299b6c40adc500b8$var$ra, $299b6c40adc500b8$var$Ql, $299b6c40adc500b8$var$na, $299b6c40adc500b8$var$zl, $299b6c40adc500b8$var$Hi, $299b6c40adc500b8$var$un, $299b6c40adc500b8$var$sa, $299b6c40adc500b8$var$Xl, $299b6c40adc500b8$var$Vi, $299b6c40adc500b8$var$cn, $299b6c40adc500b8$var$an, $299b6c40adc500b8$var$aa;
function $299b6c40adc500b8$var$pe({ type: i, text: e, value: t, checked: r }) {
    let n1 = $299b6c40adc500b8$var$F.createElement("media-chrome-menu-item");
    n1.type = i ?? "", n1.part.add("menu-item"), i && n1.part.add(i), n1.value = t, n1.checked = r;
    let s = $299b6c40adc500b8$var$F.createElement("span");
    return s.textContent = e, n1.append(s), n1;
}
function $299b6c40adc500b8$var$ue(i, e) {
    let t = i.querySelector(`:scope > [slot="${e}"]`);
    if (t?.nodeName == "SLOT" && (t = t.assignedElements({
        flatten: !0
    })[0]), t) return t = t.cloneNode(!0), t;
    let r = i.shadowRoot.querySelector(`[name="${e}"] > svg`);
    return r ? r.cloneNode(!0) : "";
}
function $299b6c40adc500b8$var$cc(i) {
    return `
    <style>
      :host {
        font: var(--media-font,
          var(--media-font-weight, normal)
          var(--media-font-size, 14px) /
          var(--media-text-content-height, var(--media-control-height, 24px))
          var(--media-font-family, helvetica neue, segoe ui, roboto, arial, sans-serif));
        color: var(--media-text-color, var(--media-primary-color, rgb(238 238 238)));
        --_menu-bg: rgb(20 20 30 / .8);
        background: var(--media-menu-background, var(--media-control-background, var(--media-secondary-color, var(--_menu-bg))));
        border-radius: var(--media-menu-border-radius);
        border: var(--media-menu-border, none);
        display: var(--media-menu-display, inline-flex) !important;
        
        transition: var(--media-menu-transition-in,
          visibility 0s,
          opacity .2s ease-out,
          transform .15s ease-out,
          left .2s ease-in-out,
          min-width .2s ease-in-out,
          min-height .2s ease-in-out
        ) !important;
        
        visibility: var(--media-menu-visibility, visible);
        opacity: var(--media-menu-opacity, 1);
        max-height: var(--media-menu-max-height, var(--_menu-max-height, 300px));
        transform: var(--media-menu-transform-in, translateY(0) scale(1));
        flex-direction: column;
        
        min-height: 0;
        position: relative;
        bottom: var(--_menu-bottom);
        box-sizing: border-box;
      } 

      @-moz-document url-prefix() {
        :host{
          --_menu-bg: rgb(20 20 30);
        }
      }

      :host([hidden]) {
        transition: var(--media-menu-transition-out,
          visibility .15s ease-in,
          opacity .15s ease-in,
          transform .15s ease-in
        ) !important;
        visibility: var(--media-menu-hidden-visibility, hidden);
        opacity: var(--media-menu-hidden-opacity, 0);
        max-height: var(--media-menu-hidden-max-height,
          var(--media-menu-max-height, var(--_menu-max-height, 300px)));
        transform: var(--media-menu-transform-out, translateY(2px) scale(.99));
        pointer-events: none;
      }

      :host([slot="submenu"]) {
        background: none;
        width: 100%;
        min-height: 100%;
        position: absolute;
        bottom: 0;
        right: -100%;
      }

      #container {
        display: flex;
        flex-direction: column;
        min-height: 0;
        transition: transform .2s ease-out;
        transform: translate(0, 0);
      }

      #container.has-expanded {
        transition: transform .2s ease-in;
        transform: translate(-100%, 0);
      }

      button {
        background: none;
        color: inherit;
        border: none;
        padding: 0;
        font: inherit;
        outline: inherit;
        display: inline-flex;
        align-items: center;
      }

      slot[name="header"][hidden] {
        display: none;
      }

      slot[name="header"] > *,
      slot[name="header"]::slotted(*) {
        padding: .4em .7em;
        border-bottom: 1px solid rgb(255 255 255 / .25);
        cursor: var(--media-cursor, default);
      }

      slot[name="header"] > button[part~="back"],
      slot[name="header"]::slotted(button[part~="back"]) {
        cursor: var(--media-cursor, pointer);
      }

      svg[part~="back"] {
        height: var(--media-menu-icon-height, var(--media-control-height, 24px));
        fill: var(--media-icon-color, var(--media-primary-color, rgb(238 238 238)));
        display: block;
        margin-right: .5ch;
      }

      slot:not([name]) {
        gap: var(--media-menu-gap);
        flex-direction: var(--media-menu-flex-direction, column);
        overflow: var(--media-menu-overflow, hidden auto);
        display: flex;
        min-height: 0;
      }

      :host([role="menu"]) slot:not([name]) {
        padding-block: .4em;
      }

      slot:not([name])::slotted([role="menu"]) {
        background: none;
      }

      media-chrome-menu-item > span {
        margin-right: .5ch;
        max-width: var(--media-menu-item-max-width);
        text-overflow: ellipsis;
        overflow: hidden;
      }
    </style>
    <style id="layout-row" media="width:0">

      slot[name="header"] > *,
      slot[name="header"]::slotted(*) {
        padding: .4em .5em;
      }

      slot:not([name]) {
        gap: var(--media-menu-gap, .25em);
        flex-direction: var(--media-menu-flex-direction, row);
        padding-inline: .5em;
      }

      media-chrome-menu-item {
        padding: .3em .5em;
      }

      media-chrome-menu-item[aria-checked="true"] {
        background: var(--media-menu-item-checked-background, rgb(255 255 255 / .2));
      }

      
      media-chrome-menu-item::part(checked-indicator) {
        display: var(--media-menu-item-checked-indicator-display, none);
      }
    </style>
    <div id="container" part="container">
      <slot name="header" hidden>
        <button part="back button" aria-label="Back to previous menu">
          <slot name="back-icon">
            <svg aria-hidden="true" viewBox="0 0 20 24" part="back indicator">
              <path d="m11.88 17.585.742-.669-4.2-4.665 4.2-4.666-.743-.669-4.803 5.335 4.803 5.334Z"/>
            </svg>
          </slot>
          <slot name="title"></slot>
        </button>
      </slot>
      <slot></slot>
    </div>
    <slot name="checked-indicator" hidden></slot>
  `;
}
var $299b6c40adc500b8$var$ft = {
    STYLE: "style",
    HIDDEN: "hidden",
    DISABLED: "disabled",
    ANCHOR: "anchor"
}, $299b6c40adc500b8$var$K = class extends $299b6c40adc500b8$var$l.HTMLElement {
    constructor(){
        if (super(), $299b6c40adc500b8$var$x(this, $299b6c40adc500b8$var$zs), $299b6c40adc500b8$var$x(this, $299b6c40adc500b8$var$on), $299b6c40adc500b8$var$x(this, $299b6c40adc500b8$var$sn), $299b6c40adc500b8$var$x(this, $299b6c40adc500b8$var$Js), $299b6c40adc500b8$var$x(this, $299b6c40adc500b8$var$js), $299b6c40adc500b8$var$x(this, $299b6c40adc500b8$var$ea), $299b6c40adc500b8$var$x(this, $299b6c40adc500b8$var$Yt), $299b6c40adc500b8$var$x(this, $299b6c40adc500b8$var$dn), $299b6c40adc500b8$var$x(this, $299b6c40adc500b8$var$ta), $299b6c40adc500b8$var$x(this, $299b6c40adc500b8$var$ua), $299b6c40adc500b8$var$x(this, $299b6c40adc500b8$var$ia), $299b6c40adc500b8$var$x(this, $299b6c40adc500b8$var$ca), $299b6c40adc500b8$var$x(this, $299b6c40adc500b8$var$ra), $299b6c40adc500b8$var$x(this, $299b6c40adc500b8$var$na), $299b6c40adc500b8$var$x(this, $299b6c40adc500b8$var$Hi), $299b6c40adc500b8$var$x(this, $299b6c40adc500b8$var$sa), $299b6c40adc500b8$var$x(this, $299b6c40adc500b8$var$Vi), $299b6c40adc500b8$var$x(this, $299b6c40adc500b8$var$an), $299b6c40adc500b8$var$x(this, $299b6c40adc500b8$var$Re, null), $299b6c40adc500b8$var$x(this, $299b6c40adc500b8$var$_t, null), $299b6c40adc500b8$var$x(this, $299b6c40adc500b8$var$tt, null), $299b6c40adc500b8$var$x(this, $299b6c40adc500b8$var$rn, new Set), $299b6c40adc500b8$var$x(this, $299b6c40adc500b8$var$nn, void 0), $299b6c40adc500b8$var$x(this, $299b6c40adc500b8$var$Tt, !1), $299b6c40adc500b8$var$x(this, $299b6c40adc500b8$var$Wi, null), $299b6c40adc500b8$var$x(this, $299b6c40adc500b8$var$ln, ()=>{
            let e = $299b6c40adc500b8$var$C(this, $299b6c40adc500b8$var$rn), t = new Set(this.items);
            for (let r of e)t.has(r) || this.dispatchEvent(new CustomEvent("removemenuitem", {
                detail: r
            }));
            for (let r of t)e.has(r) || this.dispatchEvent(new CustomEvent("addmenuitem", {
                detail: r
            }));
            $299b6c40adc500b8$var$Ce(this, $299b6c40adc500b8$var$rn, t);
        }), $299b6c40adc500b8$var$x(this, $299b6c40adc500b8$var$Kt, ()=>{
            $299b6c40adc500b8$var$N(this, $299b6c40adc500b8$var$Yt, $299b6c40adc500b8$var$Fi).call(this), $299b6c40adc500b8$var$N(this, $299b6c40adc500b8$var$dn, $299b6c40adc500b8$var$da).call(this, !1);
        }), $299b6c40adc500b8$var$x(this, $299b6c40adc500b8$var$qt, ()=>{
            $299b6c40adc500b8$var$N(this, $299b6c40adc500b8$var$Yt, $299b6c40adc500b8$var$Fi).call(this);
        }), !this.shadowRoot) {
            this.attachShadow(this.constructor.shadowRootOptions);
            let e = $299b6c40adc500b8$var$W(this.attributes);
            this.shadowRoot.innerHTML = this.constructor.getTemplateHTML(e);
        }
        this.container = this.shadowRoot.querySelector("#container"), this.defaultSlot = this.shadowRoot.querySelector("slot:not([name])"), this.shadowRoot.addEventListener("slotchange", this), $299b6c40adc500b8$var$Ce(this, $299b6c40adc500b8$var$nn, new MutationObserver($299b6c40adc500b8$var$C(this, $299b6c40adc500b8$var$ln))), $299b6c40adc500b8$var$C(this, $299b6c40adc500b8$var$nn).observe(this.defaultSlot, {
            childList: !0
        });
    }
    static get observedAttributes() {
        return [
            $299b6c40adc500b8$var$ft.DISABLED,
            $299b6c40adc500b8$var$ft.HIDDEN,
            $299b6c40adc500b8$var$ft.STYLE,
            $299b6c40adc500b8$var$ft.ANCHOR,
            $299b6c40adc500b8$var$I.MEDIA_CONTROLLER
        ];
    }
    static formatMenuItemText(e, t) {
        return e;
    }
    enable() {
        this.addEventListener("click", this), this.addEventListener("focusout", this), this.addEventListener("keydown", this), this.addEventListener("invoke", this), this.addEventListener("toggle", this);
    }
    disable() {
        this.removeEventListener("click", this), this.removeEventListener("focusout", this), this.removeEventListener("keyup", this), this.removeEventListener("invoke", this), this.removeEventListener("toggle", this);
    }
    handleEvent(e) {
        switch(e.type){
            case "slotchange":
                $299b6c40adc500b8$var$N(this, $299b6c40adc500b8$var$zs, $299b6c40adc500b8$var$Fl).call(this, e);
                break;
            case "invoke":
                $299b6c40adc500b8$var$N(this, $299b6c40adc500b8$var$Js, $299b6c40adc500b8$var$Bl).call(this, e);
                break;
            case "click":
                $299b6c40adc500b8$var$N(this, $299b6c40adc500b8$var$ta, $299b6c40adc500b8$var$Kl).call(this, e);
                break;
            case "toggle":
                $299b6c40adc500b8$var$N(this, $299b6c40adc500b8$var$ia, $299b6c40adc500b8$var$Yl).call(this, e);
                break;
            case "focusout":
                $299b6c40adc500b8$var$N(this, $299b6c40adc500b8$var$ra, $299b6c40adc500b8$var$Ql).call(this, e);
                break;
            case "keydown":
                $299b6c40adc500b8$var$N(this, $299b6c40adc500b8$var$na, $299b6c40adc500b8$var$zl).call(this, e);
                break;
        }
    }
    connectedCallback() {
        var e, t;
        $299b6c40adc500b8$var$Ce(this, $299b6c40adc500b8$var$Wi, $299b6c40adc500b8$var$Qs(this.shadowRoot, ":host")), $299b6c40adc500b8$var$N(this, $299b6c40adc500b8$var$sn, $299b6c40adc500b8$var$Xs).call(this), this.hasAttribute("disabled") || this.enable(), this.role || (this.role = "menu"), $299b6c40adc500b8$var$Ce(this, $299b6c40adc500b8$var$Re, $299b6c40adc500b8$var$Jr(this)), (t = (e = $299b6c40adc500b8$var$C(this, $299b6c40adc500b8$var$Re)) == null ? void 0 : e.associateElement) == null || t.call(e, this), this.hidden || ($299b6c40adc500b8$var$qe($299b6c40adc500b8$var$Bi(this), $299b6c40adc500b8$var$C(this, $299b6c40adc500b8$var$Kt)), $299b6c40adc500b8$var$qe(this, $299b6c40adc500b8$var$C(this, $299b6c40adc500b8$var$qt))), $299b6c40adc500b8$var$N(this, $299b6c40adc500b8$var$on, $299b6c40adc500b8$var$la).call(this);
    }
    disconnectedCallback() {
        var e, t;
        $299b6c40adc500b8$var$Ye($299b6c40adc500b8$var$Bi(this), $299b6c40adc500b8$var$C(this, $299b6c40adc500b8$var$Kt)), $299b6c40adc500b8$var$Ye(this, $299b6c40adc500b8$var$C(this, $299b6c40adc500b8$var$qt)), this.disable(), (t = (e = $299b6c40adc500b8$var$C(this, $299b6c40adc500b8$var$Re)) == null ? void 0 : e.unassociateElement) == null || t.call(e, this), $299b6c40adc500b8$var$Ce(this, $299b6c40adc500b8$var$Re, null);
    }
    attributeChangedCallback(e, t, r) {
        var n1, s, o, d;
        e === $299b6c40adc500b8$var$ft.HIDDEN && r !== t ? ($299b6c40adc500b8$var$C(this, $299b6c40adc500b8$var$Tt) || $299b6c40adc500b8$var$Ce(this, $299b6c40adc500b8$var$Tt, !0), this.hidden ? $299b6c40adc500b8$var$N(this, $299b6c40adc500b8$var$ea, $299b6c40adc500b8$var$Gl).call(this) : $299b6c40adc500b8$var$N(this, $299b6c40adc500b8$var$js, $299b6c40adc500b8$var$$l).call(this), this.dispatchEvent(new $299b6c40adc500b8$var$Xr({
            oldState: this.hidden ? "open" : "closed",
            newState: this.hidden ? "closed" : "open",
            bubbles: !0
        }))) : e === $299b6c40adc500b8$var$I.MEDIA_CONTROLLER ? (t && ((s = (n1 = $299b6c40adc500b8$var$C(this, $299b6c40adc500b8$var$Re)) == null ? void 0 : n1.unassociateElement) == null || s.call(n1, this), $299b6c40adc500b8$var$Ce(this, $299b6c40adc500b8$var$Re, null)), r && this.isConnected && ($299b6c40adc500b8$var$Ce(this, $299b6c40adc500b8$var$Re, $299b6c40adc500b8$var$Jr(this)), (d = (o = $299b6c40adc500b8$var$C(this, $299b6c40adc500b8$var$Re)) == null ? void 0 : o.associateElement) == null || d.call(o, this))) : e === $299b6c40adc500b8$var$ft.DISABLED && r !== t ? r == null ? this.enable() : this.disable() : e === $299b6c40adc500b8$var$ft.STYLE && r !== t && $299b6c40adc500b8$var$N(this, $299b6c40adc500b8$var$sn, $299b6c40adc500b8$var$Xs).call(this);
    }
    formatMenuItemText(e, t) {
        return this.constructor.formatMenuItemText(e, t);
    }
    get anchor() {
        return this.getAttribute("anchor");
    }
    set anchor(e) {
        this.setAttribute("anchor", `${e}`);
    }
    get anchorElement() {
        var e;
        return this.anchor ? (e = $299b6c40adc500b8$var$bt(this)) == null ? void 0 : e.querySelector(`#${this.anchor}`) : null;
    }
    get items() {
        return this.defaultSlot.assignedElements({
            flatten: !0
        }).filter($299b6c40adc500b8$var$hc);
    }
    get radioGroupItems() {
        return this.items.filter((e)=>e.role === "menuitemradio");
    }
    get checkedItems() {
        return this.items.filter((e)=>e.checked);
    }
    get value() {
        var e, t;
        return (t = (e = this.checkedItems[0]) == null ? void 0 : e.value) != null ? t : "";
    }
    set value(e) {
        let t = this.items.find((r)=>r.value === e);
        t && $299b6c40adc500b8$var$N(this, $299b6c40adc500b8$var$an, $299b6c40adc500b8$var$aa).call(this, t);
    }
    focus() {
        if ($299b6c40adc500b8$var$Ce(this, $299b6c40adc500b8$var$_t, $299b6c40adc500b8$var$Ui()), this.items.length) {
            $299b6c40adc500b8$var$N(this, $299b6c40adc500b8$var$Vi, $299b6c40adc500b8$var$cn).call(this, this.items[0]), this.items[0].focus();
            return;
        }
        let e = this.querySelector('[autofocus], [tabindex]:not([tabindex="-1"]), [role="menu"]');
        e?.focus();
    }
    handleSelect(e) {
        var t;
        let r = $299b6c40adc500b8$var$N(this, $299b6c40adc500b8$var$Hi, $299b6c40adc500b8$var$un).call(this, e);
        r && ($299b6c40adc500b8$var$N(this, $299b6c40adc500b8$var$an, $299b6c40adc500b8$var$aa).call(this, r, r.type === "checkbox"), $299b6c40adc500b8$var$C(this, $299b6c40adc500b8$var$tt) && !this.hidden && ((t = $299b6c40adc500b8$var$C(this, $299b6c40adc500b8$var$_t)) == null || t.focus(), this.hidden = !0));
    }
    get keysUsed() {
        return [
            "Enter",
            "Escape",
            "Tab",
            " ",
            "ArrowDown",
            "ArrowUp",
            "Home",
            "End"
        ];
    }
    handleMove(e) {
        var t, r;
        let { key: n1 } = e, s = this.items, o = (r = (t = $299b6c40adc500b8$var$N(this, $299b6c40adc500b8$var$Hi, $299b6c40adc500b8$var$un).call(this, e)) != null ? t : $299b6c40adc500b8$var$N(this, $299b6c40adc500b8$var$sa, $299b6c40adc500b8$var$Xl).call(this)) != null ? r : s[0], d = s.indexOf(o), u = Math.max(0, d);
        n1 === "ArrowDown" ? u++ : n1 === "ArrowUp" ? u-- : e.key === "Home" ? u = 0 : e.key === "End" && (u = s.length - 1), u < 0 && (u = s.length - 1), u > s.length - 1 && (u = 0), $299b6c40adc500b8$var$N(this, $299b6c40adc500b8$var$Vi, $299b6c40adc500b8$var$cn).call(this, s[u]), s[u].focus();
    }
};
$299b6c40adc500b8$var$Re = new WeakMap;
$299b6c40adc500b8$var$_t = new WeakMap;
$299b6c40adc500b8$var$tt = new WeakMap;
$299b6c40adc500b8$var$rn = new WeakMap;
$299b6c40adc500b8$var$nn = new WeakMap;
$299b6c40adc500b8$var$Tt = new WeakMap;
$299b6c40adc500b8$var$Wi = new WeakMap;
$299b6c40adc500b8$var$zs = new WeakSet;
$299b6c40adc500b8$var$Fl = function(i) {
    let e = i.target;
    for (let t of e.assignedNodes({
        flatten: !0
    }))t.nodeType === 3 && t.textContent.trim() === "" && t.remove();
    [
        "header",
        "title"
    ].includes(e.name) && $299b6c40adc500b8$var$N(this, $299b6c40adc500b8$var$on, $299b6c40adc500b8$var$la).call(this), e.name || $299b6c40adc500b8$var$C(this, $299b6c40adc500b8$var$ln).call(this);
};
$299b6c40adc500b8$var$on = new WeakSet;
$299b6c40adc500b8$var$la = function() {
    let i = this.shadowRoot.querySelector('slot[name="header"]'), e = this.shadowRoot.querySelector('slot[name="title"]');
    i.hidden = e.assignedNodes().length === 0 && i.assignedNodes().length === 0;
};
$299b6c40adc500b8$var$ln = new WeakMap;
$299b6c40adc500b8$var$sn = new WeakSet;
$299b6c40adc500b8$var$Xs = function() {
    var i;
    let e = this.shadowRoot.querySelector("#layout-row"), t = (i = getComputedStyle(this).getPropertyValue("--media-menu-layout")) == null ? void 0 : i.trim();
    e.setAttribute("media", t === "row" ? "" : "width:0");
};
$299b6c40adc500b8$var$Js = new WeakSet;
$299b6c40adc500b8$var$Bl = function(i) {
    $299b6c40adc500b8$var$Ce(this, $299b6c40adc500b8$var$tt, i.relatedTarget), $299b6c40adc500b8$var$ee(this, i.relatedTarget) || (this.hidden = !this.hidden);
};
$299b6c40adc500b8$var$js = new WeakSet;
$299b6c40adc500b8$var$$l = function() {
    var i;
    (i = $299b6c40adc500b8$var$C(this, $299b6c40adc500b8$var$tt)) == null || i.setAttribute("aria-expanded", "true"), this.addEventListener("transitionend", ()=>this.focus(), {
        once: !0
    }), $299b6c40adc500b8$var$qe($299b6c40adc500b8$var$Bi(this), $299b6c40adc500b8$var$C(this, $299b6c40adc500b8$var$Kt)), $299b6c40adc500b8$var$qe(this, $299b6c40adc500b8$var$C(this, $299b6c40adc500b8$var$qt));
};
$299b6c40adc500b8$var$ea = new WeakSet;
$299b6c40adc500b8$var$Gl = function() {
    var i;
    (i = $299b6c40adc500b8$var$C(this, $299b6c40adc500b8$var$tt)) == null || i.setAttribute("aria-expanded", "false"), $299b6c40adc500b8$var$Ye($299b6c40adc500b8$var$Bi(this), $299b6c40adc500b8$var$C(this, $299b6c40adc500b8$var$Kt)), $299b6c40adc500b8$var$Ye(this, $299b6c40adc500b8$var$C(this, $299b6c40adc500b8$var$qt));
};
$299b6c40adc500b8$var$Kt = new WeakMap;
$299b6c40adc500b8$var$qt = new WeakMap;
$299b6c40adc500b8$var$Yt = new WeakSet;
$299b6c40adc500b8$var$Fi = function(i) {
    if (this.hasAttribute("mediacontroller") && !this.anchor || this.hidden || !this.anchorElement) return;
    let { x: e, y: t } = $299b6c40adc500b8$var$Nl({
        anchor: this.anchorElement,
        floating: this,
        placement: "top-start"
    });
    i ?? (i = this.offsetWidth);
    let n1 = $299b6c40adc500b8$var$Bi(this).getBoundingClientRect(), s = n1.width - e - i, o = n1.height - t - this.offsetHeight, { style: d } = $299b6c40adc500b8$var$C(this, $299b6c40adc500b8$var$Wi);
    d.setProperty("position", "absolute"), d.setProperty("right", `${Math.max(0, s)}px`), d.setProperty("--_menu-bottom", `${o}px`);
    let u = getComputedStyle(this), f = d.getPropertyValue("--_menu-bottom") === u.bottom ? o : parseFloat(u.bottom), g = n1.height - f - parseFloat(u.marginBottom);
    this.style.setProperty("--_menu-max-height", `${g}px`);
};
$299b6c40adc500b8$var$dn = new WeakSet;
$299b6c40adc500b8$var$da = function(i) {
    let e = this.querySelector('[role="menuitem"][aria-haspopup][aria-expanded="true"]'), t = e?.querySelector('[role="menu"]'), { style: r } = $299b6c40adc500b8$var$C(this, $299b6c40adc500b8$var$Wi);
    if (i || r.setProperty("--media-menu-transition-in", "none"), t) {
        let n1 = t.offsetHeight, s = Math.max(t.offsetWidth, e.offsetWidth);
        this.style.setProperty("min-width", `${s}px`), this.style.setProperty("min-height", `${n1}px`), $299b6c40adc500b8$var$N(this, $299b6c40adc500b8$var$Yt, $299b6c40adc500b8$var$Fi).call(this, s);
    } else this.style.removeProperty("min-width"), this.style.removeProperty("min-height"), $299b6c40adc500b8$var$N(this, $299b6c40adc500b8$var$Yt, $299b6c40adc500b8$var$Fi).call(this);
    r.removeProperty("--media-menu-transition-in");
};
$299b6c40adc500b8$var$ta = new WeakSet;
$299b6c40adc500b8$var$Kl = function(i) {
    var e;
    if (i.stopPropagation(), i.composedPath().includes($299b6c40adc500b8$var$C(this, $299b6c40adc500b8$var$ua, $299b6c40adc500b8$var$ql))) {
        (e = $299b6c40adc500b8$var$C(this, $299b6c40adc500b8$var$_t)) == null || e.focus(), this.hidden = !0;
        return;
    }
    let t = $299b6c40adc500b8$var$N(this, $299b6c40adc500b8$var$Hi, $299b6c40adc500b8$var$un).call(this, i);
    !t || t.hasAttribute("disabled") || ($299b6c40adc500b8$var$N(this, $299b6c40adc500b8$var$Vi, $299b6c40adc500b8$var$cn).call(this, t), this.handleSelect(i));
};
$299b6c40adc500b8$var$ua = new WeakSet;
$299b6c40adc500b8$var$ql = function() {
    var i;
    return (i = this.shadowRoot.querySelector('slot[name="header"]').assignedElements({
        flatten: !0
    })) == null ? void 0 : i.find((t)=>t.matches('button[part~="back"]'));
};
$299b6c40adc500b8$var$ia = new WeakSet;
$299b6c40adc500b8$var$Yl = function(i) {
    if (i.target === this) return;
    $299b6c40adc500b8$var$N(this, $299b6c40adc500b8$var$ca, $299b6c40adc500b8$var$Zl).call(this);
    let e = Array.from(this.querySelectorAll('[role="menuitem"][aria-haspopup]'));
    for (let t of e)t.invokeTargetElement != i.target && i.newState == "open" && t.getAttribute("aria-expanded") == "true" && !t.invokeTargetElement.hidden && t.invokeTargetElement.dispatchEvent(new $299b6c40adc500b8$var$et({
        relatedTarget: t
    }));
    for (let t of e)t.setAttribute("aria-expanded", `${!t.submenuElement.hidden}`);
    $299b6c40adc500b8$var$N(this, $299b6c40adc500b8$var$dn, $299b6c40adc500b8$var$da).call(this, !0);
};
$299b6c40adc500b8$var$ca = new WeakSet;
$299b6c40adc500b8$var$Zl = function() {
    let e = this.querySelector('[role="menuitem"] > [role="menu"]:not([hidden])');
    this.container.classList.toggle("has-expanded", !!e);
};
$299b6c40adc500b8$var$ra = new WeakSet;
$299b6c40adc500b8$var$Ql = function(i) {
    var e;
    $299b6c40adc500b8$var$ee(this, i.relatedTarget) || ($299b6c40adc500b8$var$C(this, $299b6c40adc500b8$var$Tt) && ((e = $299b6c40adc500b8$var$C(this, $299b6c40adc500b8$var$_t)) == null || e.focus()), $299b6c40adc500b8$var$C(this, $299b6c40adc500b8$var$tt) && $299b6c40adc500b8$var$C(this, $299b6c40adc500b8$var$tt) !== i.relatedTarget && !this.hidden && (this.hidden = !0));
};
$299b6c40adc500b8$var$na = new WeakSet;
$299b6c40adc500b8$var$zl = function(i) {
    var e, t, r, n1, s;
    let { key: o, ctrlKey: d, altKey: u, metaKey: m } = i;
    if (!(d || u || m) && this.keysUsed.includes(o)) {
        if (i.preventDefault(), i.stopPropagation(), o === "Tab") {
            if ($299b6c40adc500b8$var$C(this, $299b6c40adc500b8$var$Tt)) {
                this.hidden = !0;
                return;
            }
            i.shiftKey ? (t = (e = this.previousElementSibling) == null ? void 0 : e.focus) == null || t.call(e) : (n1 = (r = this.nextElementSibling) == null ? void 0 : r.focus) == null || n1.call(r), this.blur();
        } else o === "Escape" ? ((s = $299b6c40adc500b8$var$C(this, $299b6c40adc500b8$var$_t)) == null || s.focus(), $299b6c40adc500b8$var$C(this, $299b6c40adc500b8$var$Tt) && (this.hidden = !0)) : o === "Enter" || o === " " ? this.handleSelect(i) : this.handleMove(i);
    }
};
$299b6c40adc500b8$var$Hi = new WeakSet;
$299b6c40adc500b8$var$un = function(i) {
    return i.composedPath().find((e)=>[
            "menuitemradio",
            "menuitemcheckbox"
        ].includes(e.role));
};
$299b6c40adc500b8$var$sa = new WeakSet;
$299b6c40adc500b8$var$Xl = function() {
    return this.items.find((i)=>i.tabIndex === 0);
};
$299b6c40adc500b8$var$Vi = new WeakSet;
$299b6c40adc500b8$var$cn = function(i) {
    for (let e of this.items)e.tabIndex = e === i ? 0 : -1;
};
$299b6c40adc500b8$var$an = new WeakSet;
$299b6c40adc500b8$var$aa = function(i, e) {
    let t = [
        ...this.checkedItems
    ];
    i.type === "radio" && this.radioGroupItems.forEach((r)=>r.checked = !1), e ? i.checked = !i.checked : i.checked = !0, this.checkedItems.some((r, n1)=>r != t[n1]) && this.dispatchEvent(new Event("change", {
        bubbles: !0,
        composed: !0
    }));
};
$299b6c40adc500b8$var$K.shadowRootOptions = {
    mode: "open"
};
$299b6c40adc500b8$var$K.getTemplateHTML = $299b6c40adc500b8$var$cc;
function $299b6c40adc500b8$var$hc(i) {
    return [
        "menuitem",
        "menuitemradio",
        "menuitemcheckbox"
    ].includes(i?.role);
}
function $299b6c40adc500b8$var$Bi(i) {
    var e;
    return (e = i.getAttribute("bounds") ? $299b6c40adc500b8$var$we(i, `#${i.getAttribute("bounds")}`) : $299b6c40adc500b8$var$D(i) || i.parentElement) != null ? e : i;
}
$299b6c40adc500b8$var$l.customElements.get("media-chrome-menu") || $299b6c40adc500b8$var$l.customElements.define("media-chrome-menu", $299b6c40adc500b8$var$K);
function $299b6c40adc500b8$var$$i(i) {
    return i?.map($299b6c40adc500b8$var$pc).join(" ");
}
function $299b6c40adc500b8$var$mc(i) {
    return i?.split(/\s+/).map($299b6c40adc500b8$var$vc).filter((e)=>e !== null);
}
function $299b6c40adc500b8$var$pc(i) {
    if (i) {
        let { id: e, kind: t, language: r, label: n1, selected: s } = i;
        return [
            e,
            t,
            r,
            n1,
            s
        ].filter((o)=>o != null).join(":");
    }
    return "";
}
function $299b6c40adc500b8$var$vc(i) {
    if (i) {
        let [e, t, r, n1, s] = i.split(":");
        return {
            id: e,
            kind: t,
            language: r,
            label: n1,
            selected: s.toLowerCase() === "true"
        };
    }
    return null;
}
var $299b6c40adc500b8$var$ha = class extends $299b6c40adc500b8$var$K {
    static get observedAttributes() {
        return [
            ...super.observedAttributes,
            "mediaVideoTrackSelected",
            "mediaVideoTrackList",
            "mediaVideoTrackUnavailable"
        ];
    }
    _videoTrackList = new $299b6c40adc500b8$export$a4240145594c03e8;
    _prevState;
    attributeChangedCallback(e, t, r) {
        super.attributeChangedCallback(e, t, r), e === "mediaVideoTrackSelected" && t !== r ? this.value = r ?? "" : e === "mediaVideoTrackList" && t !== r && (this._videoTrackList = new $299b6c40adc500b8$export$a4240145594c03e8(...$299b6c40adc500b8$var$mc(r ?? "")), this.render());
    }
    connectedCallback() {
        super.connectedCallback(), this.addEventListener("change", this.onChange);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this.removeEventListener("change", this.onChange);
    }
    get anchorElement() {
        return this.anchor !== "auto" ? super.anchorElement : $299b6c40adc500b8$var$D(this)?.querySelector("media-video-track-menu-button-custom");
    }
    get mediaVideoTrackList() {
        return this._videoTrackList;
    }
    set mediaVideoTrackList(e) {
        this._videoTrackList.removeEventListener("addtrack", ()=>$299b6c40adc500b8$var$b(this, "mediaVideoTrackList", $299b6c40adc500b8$var$$i(this._videoTrackList))), this._videoTrackList.removeEventListener("removetrack", ()=>$299b6c40adc500b8$var$b(this, "mediaVideoTrackList", $299b6c40adc500b8$var$$i(this._videoTrackList))), this._videoTrackList = e, this._videoTrackList.addEventListener("addtrack", ()=>$299b6c40adc500b8$var$b(this, "mediaVideoTrackList", $299b6c40adc500b8$var$$i(this._videoTrackList))), this._videoTrackList.addEventListener("removetrack", ()=>$299b6c40adc500b8$var$b(this, "mediaVideoTrackList", $299b6c40adc500b8$var$$i(this._videoTrackList))), $299b6c40adc500b8$var$b(this, "mediaVideoTrackList", $299b6c40adc500b8$var$$i(this._videoTrackList)), this._videoTrackList.selectedIndex > -1 && (this.mediaVideoTrackSelected = this._videoTrackList[this._videoTrackList.selectedIndex].id ?? ""), this.render();
    }
    get mediaVideoTrackSelected() {
        return $299b6c40adc500b8$var$_(this, "mediaVideoTrackSelected") ?? "";
    }
    set mediaVideoTrackSelected(e) {
        $299b6c40adc500b8$var$_(this, "mediaVideoTrackSelected") !== e && ($299b6c40adc500b8$var$b(this, "mediaVideoTrackSelected", e), this.render());
    }
    render() {
        if (this._prevState === JSON.stringify(this.mediaVideoTrackList)) return;
        this._prevState = JSON.stringify(this.mediaVideoTrackList);
        let e = this.mediaVideoTrackList;
        this.defaultSlot.textContent = "";
        for (let t of e){
            let r = this.formatMenuItemText(t.label, t), n1 = $299b6c40adc500b8$var$pe({
                type: "radio",
                text: r,
                value: `${t.id}`,
                checked: t.selected
            });
            n1.prepend($299b6c40adc500b8$var$ue(this, "checked-indicator")), this.defaultSlot.append(n1);
        }
    }
    onChange() {
        if (this.value == null) return;
        let e = this._videoTrackList.getTrackById(this.value);
        this._videoTrackList.selected = e ?? null, this.mediaVideoTrackSelected = this.value;
        let t = new $299b6c40adc500b8$var$l.CustomEvent("mediavideotrackrequest", {
            composed: !0,
            bubbles: !0,
            detail: this.value
        });
        this.dispatchEvent(t);
    }
};
customElements.get("media-video-track-menu-custom") || customElements.define("media-video-track-menu-custom", $299b6c40adc500b8$var$ha);
var $299b6c40adc500b8$var$Zt = {
    PLACEMENT: "placement",
    BOUNDS: "bounds"
};
function $299b6c40adc500b8$var$Ec(i) {
    return `
    <style>
      :host {
        --_tooltip-background-color: var(--media-tooltip-background-color, var(--media-secondary-color, rgba(20, 20, 30, .7)));
        --_tooltip-background: var(--media-tooltip-background, var(--_tooltip-background-color));
        --_tooltip-arrow-half-width: calc(var(--media-tooltip-arrow-width, 12px) / 2);
        --_tooltip-arrow-height: var(--media-tooltip-arrow-height, 5px);
        --_tooltip-arrow-background: var(--media-tooltip-arrow-color, var(--_tooltip-background-color));
        position: relative;
        pointer-events: none;
        display: var(--media-tooltip-display, inline-flex);
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        z-index: var(--media-tooltip-z-index, 1);
        background: var(--_tooltip-background);
        color: var(--media-text-color, var(--media-primary-color, rgb(238 238 238)));
        font: var(--media-font,
          var(--media-font-weight, 400)
          var(--media-font-size, 13px) /
          var(--media-text-content-height, var(--media-control-height, 18px))
          var(--media-font-family, helvetica neue, segoe ui, roboto, arial, sans-serif));
        padding: var(--media-tooltip-padding, .35em .7em);
        border: var(--media-tooltip-border, none);
        border-radius: var(--media-tooltip-border-radius, 5px);
        filter: var(--media-tooltip-filter, drop-shadow(0 0 4px rgba(0, 0, 0, .2)));
        white-space: var(--media-tooltip-white-space, nowrap);
      }

      :host([hidden]) {
        display: none;
      }

      img, svg {
        display: inline-block;
      }

      #arrow {
        position: absolute;
        width: 0px;
        height: 0px;
        border-style: solid;
        display: var(--media-tooltip-arrow-display, block);
      }

      :host(:not([placement])),
      :host([placement="top"]) {
        position: absolute;
        bottom: calc(100% + var(--media-tooltip-distance, 12px));
        left: 50%;
        transform: translate(calc(-50% - var(--media-tooltip-offset-x, 0px)), 0);
      }
      :host(:not([placement])) #arrow,
      :host([placement="top"]) #arrow {
        top: 100%;
        left: 50%;
        border-width: var(--_tooltip-arrow-height) var(--_tooltip-arrow-half-width) 0 var(--_tooltip-arrow-half-width);
        border-color: var(--_tooltip-arrow-background) transparent transparent transparent;
        transform: translate(calc(-50% + var(--media-tooltip-offset-x, 0px)), 0);
      }

      :host([placement="right"]) {
        position: absolute;
        left: calc(100% + var(--media-tooltip-distance, 12px));
        top: 50%;
        transform: translate(0, -50%);
      }
      :host([placement="right"]) #arrow {
        top: 50%;
        right: 100%;
        border-width: var(--_tooltip-arrow-half-width) var(--_tooltip-arrow-height) var(--_tooltip-arrow-half-width) 0;
        border-color: transparent var(--_tooltip-arrow-background) transparent transparent;
        transform: translate(0, -50%);
      }

      :host([placement="bottom"]) {
        position: absolute;
        top: calc(100% + var(--media-tooltip-distance, 12px));
        left: 50%;
        transform: translate(calc(-50% - var(--media-tooltip-offset-x, 0px)), 0);
      }
      :host([placement="bottom"]) #arrow {
        bottom: 100%;
        left: 50%;
        border-width: 0 var(--_tooltip-arrow-half-width) var(--_tooltip-arrow-height) var(--_tooltip-arrow-half-width);
        border-color: transparent transparent var(--_tooltip-arrow-background) transparent;
        transform: translate(calc(-50% + var(--media-tooltip-offset-x, 0px)), 0);
      }

      :host([placement="left"]) {
        position: absolute;
        right: calc(100% + var(--media-tooltip-distance, 12px));
        top: 50%;
        transform: translate(0, -50%);
      }
      :host([placement="left"]) #arrow {
        top: 50%;
        left: 100%;
        border-width: var(--_tooltip-arrow-half-width) 0 var(--_tooltip-arrow-half-width) var(--_tooltip-arrow-height);
        border-color: transparent transparent transparent var(--_tooltip-arrow-background);
        transform: translate(0, -50%);
      }
      
      :host([placement="none"]) #arrow {
        display: none;
      }
    </style>
    <slot></slot>
    <div id="arrow"></div>
  `;
}
var $299b6c40adc500b8$var$Qt = class extends $299b6c40adc500b8$var$l.HTMLElement {
    constructor(){
        if (super(), this.updateXOffset = ()=>{
            var e;
            if (!$299b6c40adc500b8$var$tn(this, {
                checkOpacity: !1,
                checkVisibilityCSS: !1
            })) return;
            let t = this.placement;
            if (t === "left" || t === "right") {
                this.style.removeProperty("--media-tooltip-offset-x");
                return;
            }
            let r = getComputedStyle(this), n1 = (e = $299b6c40adc500b8$var$we(this, "#" + this.bounds)) != null ? e : $299b6c40adc500b8$var$D(this);
            if (!n1) return;
            let { x: s, width: o } = n1.getBoundingClientRect(), { x: d, width: u } = this.getBoundingClientRect(), m = d + u, f = s + o, g = r.getPropertyValue("--media-tooltip-offset-x"), v = g ? parseFloat(g.replace("px", "")) : 0, E = r.getPropertyValue("--media-tooltip-container-margin"), R = E ? parseFloat(E.replace("px", "")) : 0, k = d - s + v - R, S = m - f + v + R;
            if (k < 0) {
                this.style.setProperty("--media-tooltip-offset-x", `${k}px`);
                return;
            }
            if (S > 0) {
                this.style.setProperty("--media-tooltip-offset-x", `${S}px`);
                return;
            }
            this.style.removeProperty("--media-tooltip-offset-x");
        }, !this.shadowRoot) {
            this.attachShadow(this.constructor.shadowRootOptions);
            let e = $299b6c40adc500b8$var$W(this.attributes);
            this.shadowRoot.innerHTML = this.constructor.getTemplateHTML(e);
        }
        if (this.arrowEl = this.shadowRoot.querySelector("#arrow"), Object.prototype.hasOwnProperty.call(this, "placement")) {
            let e = this.placement;
            delete this.placement, this.placement = e;
        }
    }
    static get observedAttributes() {
        return [
            $299b6c40adc500b8$var$Zt.PLACEMENT,
            $299b6c40adc500b8$var$Zt.BOUNDS
        ];
    }
    get placement() {
        return $299b6c40adc500b8$var$_(this, $299b6c40adc500b8$var$Zt.PLACEMENT);
    }
    set placement(e) {
        $299b6c40adc500b8$var$b(this, $299b6c40adc500b8$var$Zt.PLACEMENT, e);
    }
    get bounds() {
        return $299b6c40adc500b8$var$_(this, $299b6c40adc500b8$var$Zt.BOUNDS);
    }
    set bounds(e) {
        $299b6c40adc500b8$var$b(this, $299b6c40adc500b8$var$Zt.BOUNDS, e);
    }
};
$299b6c40adc500b8$var$Qt.shadowRootOptions = {
    mode: "open"
};
$299b6c40adc500b8$var$Qt.getTemplateHTML = $299b6c40adc500b8$var$Ec;
$299b6c40adc500b8$var$l.customElements.get("media-tooltip") || $299b6c40adc500b8$var$l.customElements.define("media-tooltip", $299b6c40adc500b8$var$Qt);
var $299b6c40adc500b8$var$hn = $299b6c40adc500b8$var$Qt;
var $299b6c40adc500b8$var$pa = (i, e, t)=>{
    if (!e.has(i)) throw TypeError("Cannot " + t);
}, $299b6c40adc500b8$var$q = (i, e, t)=>($299b6c40adc500b8$var$pa(i, e, "read from private field"), t ? t.call(i) : e.get(i)), $299b6c40adc500b8$var$zt = (i, e, t)=>{
    if (e.has(i)) throw TypeError("Cannot add the same private member more than once");
    e instanceof WeakSet ? e.add(i) : e.set(i, t);
}, $299b6c40adc500b8$var$mn = (i, e, t, r)=>($299b6c40adc500b8$var$pa(i, e, "write to private field"), r ? r.call(i, t) : e.set(i, t), t), $299b6c40adc500b8$var$gc = (i, e, t)=>($299b6c40adc500b8$var$pa(i, e, "access private method"), t), $299b6c40adc500b8$var$Pe, $299b6c40adc500b8$var$Jt, $299b6c40adc500b8$var$rt, $299b6c40adc500b8$var$Xt, $299b6c40adc500b8$var$pn, $299b6c40adc500b8$var$ma, $299b6c40adc500b8$var$Jl, $299b6c40adc500b8$var$it = {
    TOOLTIP_PLACEMENT: "tooltipplacement",
    DISABLED: "disabled",
    NO_TOOLTIP: "notooltip"
};
function $299b6c40adc500b8$var$bc(i, e = {}) {
    return `
    <style>
      :host {
        position: relative;
        font: var(--media-font,
          var(--media-font-weight, bold)
          var(--media-font-size, 14px) /
          var(--media-text-content-height, var(--media-control-height, 24px))
          var(--media-font-family, helvetica neue, segoe ui, roboto, arial, sans-serif));
        color: var(--media-text-color, var(--media-primary-color, rgb(238 238 238)));
        background: var(--media-control-background, var(--media-secondary-color, rgb(20 20 30 / .7)));
        padding: var(--media-button-padding, var(--media-control-padding, 10px));
        justify-content: var(--media-button-justify-content, center);
        display: inline-flex;
        align-items: center;
        vertical-align: middle;
        box-sizing: border-box;
        transition: background .15s linear;
        pointer-events: auto;
        cursor: var(--media-cursor, pointer);
        -webkit-tap-highlight-color: transparent;
      }

      
      :host(:focus-visible) {
        box-shadow: inset 0 0 0 2px rgb(27 127 204 / .9);
        outline: 0;
      }
      
      :host(:where(:focus)) {
        box-shadow: none;
        outline: 0;
      }

      :host(:hover) {
        background: var(--media-control-hover-background, rgba(50 50 70 / .7));
      }

      svg, img, ::slotted(svg), ::slotted(img) {
        width: var(--media-button-icon-width);
        height: var(--media-button-icon-height, var(--media-control-height, 24px));
        transform: var(--media-button-icon-transform);
        transition: var(--media-button-icon-transition);
        fill: var(--media-icon-color, var(--media-primary-color, rgb(238 238 238)));
        vertical-align: middle;
        max-width: 100%;
        max-height: 100%;
        min-width: 100%;
      }

      media-tooltip {
        
        max-width: 0;
        overflow-x: clip;
        opacity: 0;
        transition: opacity .3s, max-width 0s 9s;
      }

      :host(:hover) media-tooltip,
      :host(:focus-visible) media-tooltip {
        max-width: 100vw;
        opacity: 1;
        transition: opacity .3s;
      }

      :host([notooltip]) slot[name="tooltip"] {
        display: none;
      }
    </style>

    ${this.getSlotTemplateHTML(i, e)}

    <slot name="tooltip">
      <media-tooltip part="tooltip" aria-hidden="true">
        <template shadowrootmode="${$299b6c40adc500b8$var$hn.shadowRootOptions.mode}">
          ${$299b6c40adc500b8$var$hn.getTemplateHTML({})}
        </template>
        <slot name="tooltip-content">
          ${this.getTooltipContentHTML(i)}
        </slot>
      </media-tooltip>
    </slot>
  `;
}
function $299b6c40adc500b8$var$fc(i, e) {
    return `
    <slot></slot>
  `;
}
function $299b6c40adc500b8$var$_c() {
    return "";
}
var $299b6c40adc500b8$var$P = class extends $299b6c40adc500b8$var$l.HTMLElement {
    constructor(){
        if (super(), $299b6c40adc500b8$var$zt(this, $299b6c40adc500b8$var$ma), $299b6c40adc500b8$var$zt(this, $299b6c40adc500b8$var$Pe, void 0), this.preventClick = !1, this.tooltipEl = null, $299b6c40adc500b8$var$zt(this, $299b6c40adc500b8$var$Jt, (e)=>{
            this.preventClick || this.handleClick(e), setTimeout($299b6c40adc500b8$var$q(this, $299b6c40adc500b8$var$rt), 0);
        }), $299b6c40adc500b8$var$zt(this, $299b6c40adc500b8$var$rt, ()=>{
            var e, t;
            (t = (e = this.tooltipEl) == null ? void 0 : e.updateXOffset) == null || t.call(e);
        }), $299b6c40adc500b8$var$zt(this, $299b6c40adc500b8$var$Xt, (e)=>{
            let { key: t } = e;
            if (!this.keysUsed.includes(t)) {
                this.removeEventListener("keyup", $299b6c40adc500b8$var$q(this, $299b6c40adc500b8$var$Xt));
                return;
            }
            this.preventClick || this.handleClick(e);
        }), $299b6c40adc500b8$var$zt(this, $299b6c40adc500b8$var$pn, (e)=>{
            let { metaKey: t, altKey: r, key: n1 } = e;
            if (t || r || !this.keysUsed.includes(n1)) {
                this.removeEventListener("keyup", $299b6c40adc500b8$var$q(this, $299b6c40adc500b8$var$Xt));
                return;
            }
            this.addEventListener("keyup", $299b6c40adc500b8$var$q(this, $299b6c40adc500b8$var$Xt), {
                once: !0
            });
        }), !this.shadowRoot) {
            this.attachShadow(this.constructor.shadowRootOptions);
            let e = $299b6c40adc500b8$var$W(this.attributes), t = this.constructor.getTemplateHTML(e);
            this.shadowRoot.setHTMLUnsafe ? this.shadowRoot.setHTMLUnsafe(t) : this.shadowRoot.innerHTML = t;
        }
        this.tooltipEl = this.shadowRoot.querySelector("media-tooltip");
    }
    static get observedAttributes() {
        return [
            "disabled",
            $299b6c40adc500b8$var$it.TOOLTIP_PLACEMENT,
            $299b6c40adc500b8$var$I.MEDIA_CONTROLLER,
            $299b6c40adc500b8$var$a.MEDIA_LANG
        ];
    }
    enable() {
        this.addEventListener("click", $299b6c40adc500b8$var$q(this, $299b6c40adc500b8$var$Jt)), this.addEventListener("keydown", $299b6c40adc500b8$var$q(this, $299b6c40adc500b8$var$pn)), this.tabIndex = 0;
    }
    disable() {
        this.removeEventListener("click", $299b6c40adc500b8$var$q(this, $299b6c40adc500b8$var$Jt)), this.removeEventListener("keydown", $299b6c40adc500b8$var$q(this, $299b6c40adc500b8$var$pn)), this.removeEventListener("keyup", $299b6c40adc500b8$var$q(this, $299b6c40adc500b8$var$Xt)), this.tabIndex = -1;
    }
    attributeChangedCallback(e, t, r) {
        var n1, s, o, d, u;
        e === $299b6c40adc500b8$var$I.MEDIA_CONTROLLER ? (t && ((s = (n1 = $299b6c40adc500b8$var$q(this, $299b6c40adc500b8$var$Pe)) == null ? void 0 : n1.unassociateElement) == null || s.call(n1, this), $299b6c40adc500b8$var$mn(this, $299b6c40adc500b8$var$Pe, null)), r && this.isConnected && ($299b6c40adc500b8$var$mn(this, $299b6c40adc500b8$var$Pe, (o = this.getRootNode()) == null ? void 0 : o.getElementById(r)), (u = (d = $299b6c40adc500b8$var$q(this, $299b6c40adc500b8$var$Pe)) == null ? void 0 : d.associateElement) == null || u.call(d, this))) : e === "disabled" && r !== t ? r == null ? this.enable() : this.disable() : e === $299b6c40adc500b8$var$it.TOOLTIP_PLACEMENT && this.tooltipEl && r !== t ? this.tooltipEl.placement = r : e === $299b6c40adc500b8$var$a.MEDIA_LANG && (this.shadowRoot.querySelector('slot[name="tooltip-content"]').innerHTML = this.constructor.getTooltipContentHTML()), $299b6c40adc500b8$var$q(this, $299b6c40adc500b8$var$rt).call(this);
    }
    connectedCallback() {
        var e, t, r;
        let { style: n1 } = $299b6c40adc500b8$var$O(this.shadowRoot, ":host");
        n1.setProperty("display", `var(--media-control-display, var(--${this.localName}-display, inline-flex))`), this.hasAttribute("disabled") ? this.disable() : this.enable(), this.setAttribute("role", "button");
        let s = this.getAttribute($299b6c40adc500b8$var$I.MEDIA_CONTROLLER);
        s && ($299b6c40adc500b8$var$mn(this, $299b6c40adc500b8$var$Pe, (e = this.getRootNode()) == null ? void 0 : e.getElementById(s)), (r = (t = $299b6c40adc500b8$var$q(this, $299b6c40adc500b8$var$Pe)) == null ? void 0 : t.associateElement) == null || r.call(t, this)), $299b6c40adc500b8$var$l.customElements.whenDefined("media-tooltip").then(()=>$299b6c40adc500b8$var$gc(this, $299b6c40adc500b8$var$ma, $299b6c40adc500b8$var$Jl).call(this));
    }
    disconnectedCallback() {
        var e, t;
        this.disable(), (t = (e = $299b6c40adc500b8$var$q(this, $299b6c40adc500b8$var$Pe)) == null ? void 0 : e.unassociateElement) == null || t.call(e, this), $299b6c40adc500b8$var$mn(this, $299b6c40adc500b8$var$Pe, null), this.removeEventListener("mouseenter", $299b6c40adc500b8$var$q(this, $299b6c40adc500b8$var$rt)), this.removeEventListener("focus", $299b6c40adc500b8$var$q(this, $299b6c40adc500b8$var$rt)), this.removeEventListener("click", $299b6c40adc500b8$var$q(this, $299b6c40adc500b8$var$Jt));
    }
    get keysUsed() {
        return [
            "Enter",
            " "
        ];
    }
    get tooltipPlacement() {
        return $299b6c40adc500b8$var$_(this, $299b6c40adc500b8$var$it.TOOLTIP_PLACEMENT);
    }
    set tooltipPlacement(e) {
        $299b6c40adc500b8$var$b(this, $299b6c40adc500b8$var$it.TOOLTIP_PLACEMENT, e);
    }
    get mediaController() {
        return $299b6c40adc500b8$var$_(this, $299b6c40adc500b8$var$I.MEDIA_CONTROLLER);
    }
    set mediaController(e) {
        $299b6c40adc500b8$var$b(this, $299b6c40adc500b8$var$I.MEDIA_CONTROLLER, e);
    }
    get disabled() {
        return $299b6c40adc500b8$var$A(this, $299b6c40adc500b8$var$it.DISABLED);
    }
    set disabled(e) {
        $299b6c40adc500b8$var$y(this, $299b6c40adc500b8$var$it.DISABLED, e);
    }
    get noTooltip() {
        return $299b6c40adc500b8$var$A(this, $299b6c40adc500b8$var$it.NO_TOOLTIP);
    }
    set noTooltip(e) {
        $299b6c40adc500b8$var$y(this, $299b6c40adc500b8$var$it.NO_TOOLTIP, e);
    }
    handleClick(e) {}
};
$299b6c40adc500b8$var$Pe = new WeakMap;
$299b6c40adc500b8$var$Jt = new WeakMap;
$299b6c40adc500b8$var$rt = new WeakMap;
$299b6c40adc500b8$var$Xt = new WeakMap;
$299b6c40adc500b8$var$pn = new WeakMap;
$299b6c40adc500b8$var$ma = new WeakSet;
$299b6c40adc500b8$var$Jl = function() {
    this.addEventListener("mouseenter", $299b6c40adc500b8$var$q(this, $299b6c40adc500b8$var$rt)), this.addEventListener("focus", $299b6c40adc500b8$var$q(this, $299b6c40adc500b8$var$rt)), this.addEventListener("click", $299b6c40adc500b8$var$q(this, $299b6c40adc500b8$var$Jt));
    let i = this.tooltipPlacement;
    i && this.tooltipEl && (this.tooltipEl.placement = i);
};
$299b6c40adc500b8$var$P.shadowRootOptions = {
    mode: "open"
};
$299b6c40adc500b8$var$P.getTemplateHTML = $299b6c40adc500b8$var$bc;
$299b6c40adc500b8$var$P.getSlotTemplateHTML = $299b6c40adc500b8$var$fc;
$299b6c40adc500b8$var$P.getTooltipContentHTML = $299b6c40adc500b8$var$_c;
$299b6c40adc500b8$var$l.customElements.get("media-chrome-button") || $299b6c40adc500b8$var$l.customElements.define("media-chrome-button", $299b6c40adc500b8$var$P);
var $299b6c40adc500b8$var$J = class extends $299b6c40adc500b8$var$P {
    connectedCallback() {
        super.connectedCallback(), this.invokeTargetElement && this.setAttribute("aria-haspopup", "menu");
    }
    get invokeTarget() {
        return this.getAttribute("invoketarget");
    }
    set invokeTarget(e) {
        this.setAttribute("invoketarget", `${e}`);
    }
    get invokeTargetElement() {
        var e;
        return this.invokeTarget ? (e = $299b6c40adc500b8$var$bt(this)) == null ? void 0 : e.querySelector(`#${this.invokeTarget}`) : null;
    }
    handleClick() {
        var e;
        (e = this.invokeTargetElement) == null || e.dispatchEvent(new $299b6c40adc500b8$var$et({
            relatedTarget: this
        }));
    }
};
$299b6c40adc500b8$var$l.customElements.get("media-chrome-menu-button") || $299b6c40adc500b8$var$l.customElements.define("media-chrome-menu-button", $299b6c40adc500b8$var$J);
var $299b6c40adc500b8$var$Tc = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M2 4C2 2.89543 2.89543 2 4 2H20C21.1046 2 22 2.89543 22 4V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V4ZM7.5 3.5H16.5V11.25H7.5V3.5ZM7.5 12.75V20.5H16.5V12.75H7.5ZM18 5.5V3.5H20C20.2761 3.5 20.5 3.72386 20.5 4V5.5H18ZM18 8.5V6.5H20.5V8.5H18ZM18 11.5V9.5H20.5V11.5H18ZM18 14.5V12.5H20.5V14.5H18ZM18 17.5V15.5H20.5V17.5H18ZM18 20.5V18.5H20.5V20C20.5 20.2761 20.2761 20.5 20 20.5H18ZM6 3.5H4C3.72386 3.5 3.5 3.72386 3.5 4V5.5H6V3.5ZM3.5 8.5V6.5H6V8.5H3.5ZM3.5 9.5V11.5H6V9.5H3.5ZM3.5 14.5V12.5H6V14.5H3.5ZM3.5 17.5V15.5H6V17.5H3.5ZM3.5 18.5V20C3.5 20.2761 3.72386 20.5 4 20.5H6V18.5H3.5Z"/>
</svg>`;
function $299b6c40adc500b8$var$Ac() {
    return `
  <style>
    :host([aria-expanded="true"]) slot[name=tooltip] {
      display: none;
    }
  </style>
  <slot name="icon">${$299b6c40adc500b8$var$Tc}</slot>
`;
}
function $299b6c40adc500b8$var$yc() {
    return "Video Track";
}
var $299b6c40adc500b8$var$va = class extends $299b6c40adc500b8$var$J {
    static get observedAttributes() {
        return [
            ...super.observedAttributes,
            "mediaVideoTrackSelected",
            "mediaVideoTrackUnavailable"
        ];
    }
    static getTooltipContentHTML = $299b6c40adc500b8$var$yc;
    static getSlotTemplateHTML = $299b6c40adc500b8$var$Ac;
    constructor(){
        super();
    }
    connectedCallback() {
        super.connectedCallback(), this.setAttribute("aria-label", "video tracks");
    }
    attributeChangedCallback(e, t, r) {
        super.attributeChangedCallback(e, t, r);
    }
    get invokeTargetElement() {
        return this.invokeTarget != null ? super.invokeTargetElement : $299b6c40adc500b8$var$D(this)?.querySelector("media-video-track-menu-custom") ?? null;
    }
    get mediaVideoTrackSelected() {
        return $299b6c40adc500b8$var$_(this, "mediaVideoTrackSelected") ?? "";
    }
    set mediaVideoTrackSelected(e) {
        $299b6c40adc500b8$var$b(this, "mediaVideoTrackSelected", e);
    }
};
$299b6c40adc500b8$var$l.customElements.get("media-video-track-menu-button-custom") || $299b6c40adc500b8$var$l.customElements.define("media-video-track-menu-button-custom", $299b6c40adc500b8$var$va);
function $299b6c40adc500b8$var$jl(i) {
    return i?.map($299b6c40adc500b8$var$kc).join(" ");
}
function $299b6c40adc500b8$var$ed(i) {
    return i?.split(/\s+/).map($299b6c40adc500b8$var$Ic);
}
function $299b6c40adc500b8$var$kc(i) {
    if (i) {
        let { id: e, width: t, height: r } = i;
        return [
            e,
            t,
            r
        ].filter((n1)=>n1 != null).join(":");
    }
}
function $299b6c40adc500b8$var$Ic(i) {
    if (i) {
        let [e, t, r] = i.split(":");
        return {
            id: e,
            width: +t,
            height: +r
        };
    }
}
function $299b6c40adc500b8$var$td(i) {
    return i?.map($299b6c40adc500b8$var$Sc).join(" ");
}
function $299b6c40adc500b8$var$id(i) {
    return i?.split(/\s+/).map($299b6c40adc500b8$var$Mc);
}
function $299b6c40adc500b8$var$Sc(i) {
    if (i) {
        let { id: e, kind: t, language: r, label: n1 } = i;
        return [
            e,
            t,
            r,
            n1
        ].filter((s)=>s != null).join(":");
    }
}
function $299b6c40adc500b8$var$Mc(i) {
    if (i) {
        let [e, t, r, n1] = i.split(":");
        return {
            id: e,
            kind: t,
            language: r,
            label: n1
        };
    }
}
function $299b6c40adc500b8$var$jt(i) {
    return typeof i == "number" && !Number.isNaN(i) && Number.isFinite(i);
}
var $299b6c40adc500b8$var$vn = (i)=>new Promise((e)=>setTimeout(e, i));
var $299b6c40adc500b8$var$rd = [
    {
        singular: "hour",
        plural: "hours"
    },
    {
        singular: "minute",
        plural: "minutes"
    },
    {
        singular: "second",
        plural: "seconds"
    }
], $299b6c40adc500b8$var$Lc = (i, e)=>{
    let t = i === 1 ? $299b6c40adc500b8$var$rd[e].singular : $299b6c40adc500b8$var$rd[e].plural;
    return `${i} ${t}`;
}, $299b6c40adc500b8$var$At = (i)=>{
    if (!$299b6c40adc500b8$var$jt(i)) return "";
    let e = Math.abs(i), t = e !== i, r = new Date(0, 0, 0, 0, 0, e, 0);
    return `${[
        r.getHours(),
        r.getMinutes(),
        r.getSeconds()
    ].map((d, u)=>d && $299b6c40adc500b8$var$Lc(d, u)).filter((d)=>d).join(", ")}${t ? " remaining" : ""}`;
};
function $299b6c40adc500b8$var$Ae(i, e) {
    let t = !1;
    i < 0 && (t = !0, i = 0 - i), i = i < 0 ? 0 : i;
    let r = Math.floor(i % 60), n1 = Math.floor(i / 60 % 60), s = Math.floor(i / 3600), o = Math.floor(e / 60 % 60), d = Math.floor(e / 3600);
    return (isNaN(i) || i === 1 / 0) && (s = n1 = r = "0"), s = s > 0 || d > 0 ? s + ":" : "", n1 = ((s || o >= 10) && n1 < 10 ? "0" + n1 : n1) + ":", r = r < 10 ? "0" + r : r, (t ? "-" : "") + s + n1 + r;
}
var $299b6c40adc500b8$var$Wv = Object.freeze({
    length: 0,
    start (i) {
        let e = i >>> 0;
        if (e >= this.length) throw new DOMException(`Failed to execute 'start' on 'TimeRanges': The index provided (${e}) is greater than or equal to the maximum bound (${this.length}).`);
        return 0;
    },
    end (i) {
        let e = i >>> 0;
        if (e >= this.length) throw new DOMException(`Failed to execute 'end' on 'TimeRanges': The index provided (${e}) is greater than or equal to the maximum bound (${this.length}).`);
        return 0;
    }
});
var $299b6c40adc500b8$var$nd = {
    "Start airplay": "Start airplay",
    "Stop airplay": "Stop airplay",
    Audio: "Audio",
    Captions: "Captions",
    "Enable captions": "Enable captions",
    "Disable captions": "Disable captions",
    "Start casting": "Start casting",
    "Stop casting": "Stop casting",
    "Enter fullscreen mode": "Enter fullscreen mode",
    "Exit fullscreen mode": "Exit fullscreen mode",
    Mute: "Mute",
    Unmute: "Unmute",
    "Enter picture in picture mode": "Enter picture in picture mode",
    "Exit picture in picture mode": "Exit picture in picture mode",
    Play: "Play",
    Pause: "Pause",
    "Playback rate": "Playback rate",
    "Playback rate {playbackRate}": "Playback rate {playbackRate}",
    Quality: "Quality",
    "Seek backward": "Seek backward",
    "Seek forward": "Seek forward",
    Settings: "Settings",
    Auto: "Auto",
    "audio player": "audio player",
    "video player": "video player",
    volume: "volume",
    seek: "seek",
    "closed captions": "closed captions",
    "current playback rate": "current playback rate",
    "playback time": "playback time",
    "media loading": "media loading",
    settings: "settings",
    "audio tracks": "audio tracks",
    quality: "quality",
    play: "play",
    pause: "pause",
    mute: "mute",
    unmute: "unmute",
    "chapter: {chapterName}": "chapter: {chapterName}",
    live: "live",
    Off: "Off",
    "start airplay": "start airplay",
    "stop airplay": "stop airplay",
    "start casting": "start casting",
    "stop casting": "stop casting",
    "enter fullscreen mode": "enter fullscreen mode",
    "exit fullscreen mode": "exit fullscreen mode",
    "enter picture in picture mode": "enter picture in picture mode",
    "exit picture in picture mode": "exit picture in picture mode",
    "seek to live": "seek to live",
    "playing live": "playing live",
    "seek back {seekOffset} seconds": "seek back {seekOffset} seconds",
    "seek forward {seekOffset} seconds": "seek forward {seekOffset} seconds",
    "Network Error": "Network Error",
    "Decode Error": "Decode Error",
    "Source Not Supported": "Source Not Supported",
    "Encryption Error": "Encryption Error",
    "A network error caused the media download to fail.": "A network error caused the media download to fail.",
    "A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format.": "A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format.",
    "An unsupported error occurred. The server or network failed, or your browser does not support this format.": "An unsupported error occurred. The server or network failed, or your browser does not support this format.",
    "The media is encrypted and there are no keys to decrypt it.": "The media is encrypted and there are no keys to decrypt it."
};
var $299b6c40adc500b8$var$sd, $299b6c40adc500b8$var$Ea = {
    en: $299b6c40adc500b8$var$nd
}, $299b6c40adc500b8$var$ga = (($299b6c40adc500b8$var$sd = globalThis.navigator) == null ? void 0 : $299b6c40adc500b8$var$sd.language) || "en", $299b6c40adc500b8$var$ad = (i)=>{
    $299b6c40adc500b8$var$ga = i;
};
var $299b6c40adc500b8$var$Cc = (i)=>{
    var e, t, r;
    let [n1] = $299b6c40adc500b8$var$ga.split("-");
    return ((e = $299b6c40adc500b8$var$Ea[$299b6c40adc500b8$var$ga]) == null ? void 0 : e[i]) || ((t = $299b6c40adc500b8$var$Ea[n1]) == null ? void 0 : t[i]) || ((r = $299b6c40adc500b8$var$Ea.en) == null ? void 0 : r[i]) || i;
}, $299b6c40adc500b8$var$c = (i, e = {})=>$299b6c40adc500b8$var$Cc(i).replace(/\{(\w+)\}/g, (t, r)=>r in e ? String(e[r]) : `{${r}}`);
var $299b6c40adc500b8$var$od = (i, e, t)=>{
    if (!e.has(i)) throw TypeError("Cannot " + t);
}, $299b6c40adc500b8$var$nt = (i, e, t)=>($299b6c40adc500b8$var$od(i, e, "read from private field"), t ? t.call(i) : e.get(i)), $299b6c40adc500b8$var$Rc = (i, e, t)=>{
    if (e.has(i)) throw TypeError("Cannot add the same private member more than once");
    e instanceof WeakSet ? e.add(i) : e.set(i, t);
}, $299b6c40adc500b8$var$En = (i, e, t, r)=>($299b6c40adc500b8$var$od(i, e, "write to private field"), r ? r.call(i, t) : e.set(i, t), t), $299b6c40adc500b8$var$ne;
function $299b6c40adc500b8$var$Pc(i) {
    return `
    <style>
      :host {
        display: var(--media-control-display, var(--media-gesture-receiver-display, inline-block));
        box-sizing: border-box;
      }
    </style>
  `;
}
var $299b6c40adc500b8$var$ei = class extends $299b6c40adc500b8$var$l.HTMLElement {
    constructor(){
        if (super(), $299b6c40adc500b8$var$Rc(this, $299b6c40adc500b8$var$ne, void 0), !this.shadowRoot) {
            this.attachShadow(this.constructor.shadowRootOptions);
            let e = $299b6c40adc500b8$var$W(this.attributes);
            this.shadowRoot.innerHTML = this.constructor.getTemplateHTML(e);
        }
    }
    static get observedAttributes() {
        return [
            $299b6c40adc500b8$var$I.MEDIA_CONTROLLER,
            $299b6c40adc500b8$var$a.MEDIA_PAUSED
        ];
    }
    attributeChangedCallback(e, t, r) {
        var n1, s, o, d, u;
        e === $299b6c40adc500b8$var$I.MEDIA_CONTROLLER && (t && ((s = (n1 = $299b6c40adc500b8$var$nt(this, $299b6c40adc500b8$var$ne)) == null ? void 0 : n1.unassociateElement) == null || s.call(n1, this), $299b6c40adc500b8$var$En(this, $299b6c40adc500b8$var$ne, null)), r && this.isConnected && ($299b6c40adc500b8$var$En(this, $299b6c40adc500b8$var$ne, (o = this.getRootNode()) == null ? void 0 : o.getElementById(r)), (u = (d = $299b6c40adc500b8$var$nt(this, $299b6c40adc500b8$var$ne)) == null ? void 0 : d.associateElement) == null || u.call(d, this)));
    }
    connectedCallback() {
        var e, t, r, n1;
        this.tabIndex = -1, this.setAttribute("aria-hidden", "true"), $299b6c40adc500b8$var$En(this, $299b6c40adc500b8$var$ne, $299b6c40adc500b8$var$Dc(this)), this.getAttribute($299b6c40adc500b8$var$I.MEDIA_CONTROLLER) && ((t = (e = $299b6c40adc500b8$var$nt(this, $299b6c40adc500b8$var$ne)) == null ? void 0 : e.associateElement) == null || t.call(e, this)), (r = $299b6c40adc500b8$var$nt(this, $299b6c40adc500b8$var$ne)) == null || r.addEventListener("pointerdown", this), (n1 = $299b6c40adc500b8$var$nt(this, $299b6c40adc500b8$var$ne)) == null || n1.addEventListener("click", this);
    }
    disconnectedCallback() {
        var e, t, r, n1;
        this.getAttribute($299b6c40adc500b8$var$I.MEDIA_CONTROLLER) && ((t = (e = $299b6c40adc500b8$var$nt(this, $299b6c40adc500b8$var$ne)) == null ? void 0 : e.unassociateElement) == null || t.call(e, this)), (r = $299b6c40adc500b8$var$nt(this, $299b6c40adc500b8$var$ne)) == null || r.removeEventListener("pointerdown", this), (n1 = $299b6c40adc500b8$var$nt(this, $299b6c40adc500b8$var$ne)) == null || n1.removeEventListener("click", this), $299b6c40adc500b8$var$En(this, $299b6c40adc500b8$var$ne, null);
    }
    handleEvent(e) {
        var t;
        let r = (t = e.composedPath()) == null ? void 0 : t[0];
        if ([
            "video",
            "media-controller"
        ].includes(r?.localName)) {
            if (e.type === "pointerdown") this._pointerType = e.pointerType;
            else if (e.type === "click") {
                let { clientX: s, clientY: o } = e, { left: d, top: u, width: m, height: f } = this.getBoundingClientRect(), g = s - d, v = o - u;
                if (g < 0 || v < 0 || g > m || v > f || m === 0 && f === 0) return;
                let E = this._pointerType || "mouse";
                if (this._pointerType = void 0, E === $299b6c40adc500b8$var$Ys.TOUCH) {
                    this.handleTap(e);
                    return;
                } else if (E === $299b6c40adc500b8$var$Ys.MOUSE) {
                    this.handleMouseClick(e);
                    return;
                }
            }
        }
    }
    get mediaPaused() {
        return $299b6c40adc500b8$var$A(this, $299b6c40adc500b8$var$a.MEDIA_PAUSED);
    }
    set mediaPaused(e) {
        $299b6c40adc500b8$var$y(this, $299b6c40adc500b8$var$a.MEDIA_PAUSED, e);
    }
    handleTap(e) {}
    handleMouseClick(e) {
        let t = this.mediaPaused ? $299b6c40adc500b8$var$h.MEDIA_PLAY_REQUEST : $299b6c40adc500b8$var$h.MEDIA_PAUSE_REQUEST;
        this.dispatchEvent(new $299b6c40adc500b8$var$l.CustomEvent(t, {
            composed: !0,
            bubbles: !0
        }));
    }
};
$299b6c40adc500b8$var$ne = new WeakMap;
$299b6c40adc500b8$var$ei.shadowRootOptions = {
    mode: "open"
};
$299b6c40adc500b8$var$ei.getTemplateHTML = $299b6c40adc500b8$var$Pc;
function $299b6c40adc500b8$var$Dc(i) {
    var e;
    let t = i.getAttribute($299b6c40adc500b8$var$I.MEDIA_CONTROLLER);
    return t ? (e = i.getRootNode()) == null ? void 0 : e.getElementById(t) : $299b6c40adc500b8$var$we(i, "media-controller");
}
$299b6c40adc500b8$var$l.customElements.get("media-gesture-receiver") || $299b6c40adc500b8$var$l.customElements.define("media-gesture-receiver", $299b6c40adc500b8$var$ei);
var $299b6c40adc500b8$var$gn = $299b6c40adc500b8$var$ei;
var $299b6c40adc500b8$var$Ta = (i, e, t)=>{
    if (!e.has(i)) throw TypeError("Cannot " + t);
}, $299b6c40adc500b8$var$he = (i, e, t)=>($299b6c40adc500b8$var$Ta(i, e, "read from private field"), t ? t.call(i) : e.get(i)), $299b6c40adc500b8$var$ce = (i, e, t)=>{
    if (e.has(i)) throw TypeError("Cannot add the same private member more than once");
    e instanceof WeakSet ? e.add(i) : e.set(i, t);
}, $299b6c40adc500b8$var$yt = (i, e, t, r)=>($299b6c40adc500b8$var$Ta(i, e, "write to private field"), r ? r.call(i, t) : e.set(i, t), t), $299b6c40adc500b8$var$ve = (i, e, t)=>($299b6c40adc500b8$var$Ta(i, e, "access private method"), t), $299b6c40adc500b8$var$_n, $299b6c40adc500b8$var$ti, $299b6c40adc500b8$var$Ki, $299b6c40adc500b8$var$ii, $299b6c40adc500b8$var$bn, $299b6c40adc500b8$var$ba, $299b6c40adc500b8$var$ld, $299b6c40adc500b8$var$Gi, $299b6c40adc500b8$var$fn, $299b6c40adc500b8$var$fa, $299b6c40adc500b8$var$dd, $299b6c40adc500b8$var$_a, $299b6c40adc500b8$var$ud, $299b6c40adc500b8$var$qi, $299b6c40adc500b8$var$Tn, $299b6c40adc500b8$var$An, $299b6c40adc500b8$var$Aa, $299b6c40adc500b8$var$ri, $299b6c40adc500b8$var$Yi, $299b6c40adc500b8$var$T = {
    AUDIO: "audio",
    AUTOHIDE: "autohide",
    BREAKPOINTS: "breakpoints",
    GESTURES_DISABLED: "gesturesdisabled",
    KEYBOARD_CONTROL: "keyboardcontrol",
    NO_AUTOHIDE: "noautohide",
    USER_INACTIVE: "userinactive",
    AUTOHIDE_OVER_CONTROLS: "autohideovercontrols"
};
function $299b6c40adc500b8$var$Oc(i) {
    return `
    <style>
      
      :host([${$299b6c40adc500b8$var$a.MEDIA_IS_FULLSCREEN}]) ::slotted([slot=media]) {
        outline: none;
      }

      :host {
        box-sizing: border-box;
        position: relative;
        display: inline-block;
        line-height: 0;
        background-color: var(--media-background-color, #000);
      }

      :host(:not([${$299b6c40adc500b8$var$T.AUDIO}])) [part~=layer]:not([part~=media-layer]) {
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        display: flex;
        flex-flow: column nowrap;
        align-items: start;
        pointer-events: none;
        background: none;
      }

      slot[name=media] {
        display: var(--media-slot-display, contents);
      }

      
      :host([${$299b6c40adc500b8$var$T.AUDIO}]) slot[name=media] {
        display: var(--media-slot-display, none);
      }

      
      :host([${$299b6c40adc500b8$var$T.AUDIO}]) [part~=layer][part~=gesture-layer] {
        height: 0;
        display: block;
      }

      
      :host(:not([${$299b6c40adc500b8$var$T.AUDIO}])[${$299b6c40adc500b8$var$T.GESTURES_DISABLED}]) ::slotted([slot=gestures-chrome]),
          :host(:not([${$299b6c40adc500b8$var$T.AUDIO}])[${$299b6c40adc500b8$var$T.GESTURES_DISABLED}]) media-gesture-receiver[slot=gestures-chrome] {
        display: none;
      }

      
      ::slotted(:not([slot=media]):not([slot=poster]):not(media-loading-indicator):not([role=dialog]):not([hidden])) {
        pointer-events: auto;
      }

      :host(:not([${$299b6c40adc500b8$var$T.AUDIO}])) *[part~=layer][part~=centered-layer] {
        align-items: center;
        justify-content: center;
      }

      :host(:not([${$299b6c40adc500b8$var$T.AUDIO}])) ::slotted(media-gesture-receiver[slot=gestures-chrome]),
      :host(:not([${$299b6c40adc500b8$var$T.AUDIO}])) media-gesture-receiver[slot=gestures-chrome] {
        align-self: stretch;
        flex-grow: 1;
      }

      slot[name=middle-chrome] {
        display: inline;
        flex-grow: 1;
        pointer-events: none;
        background: none;
      }

      
      ::slotted([slot=media]),
      ::slotted([slot=poster]) {
        width: 100%;
        height: 100%;
      }

      
      :host(:not([${$299b6c40adc500b8$var$T.AUDIO}])) .spacer {
        flex-grow: 1;
      }

      
      :host(:-webkit-full-screen) {
        
        width: 100% !important;
        height: 100% !important;
      }

      
      ::slotted(:not([slot=media]):not([slot=poster]):not([${$299b6c40adc500b8$var$T.NO_AUTOHIDE}]):not([hidden]):not([role=dialog])) {
        opacity: 1;
        transition: var(--media-control-transition-in, opacity 0.25s);
      }

      
      :host([${$299b6c40adc500b8$var$T.USER_INACTIVE}]:not([${$299b6c40adc500b8$var$a.MEDIA_PAUSED}]):not([${$299b6c40adc500b8$var$a.MEDIA_IS_AIRPLAYING}]):not([${$299b6c40adc500b8$var$a.MEDIA_IS_CASTING}]):not([${$299b6c40adc500b8$var$T.AUDIO}])) ::slotted(:not([slot=media]):not([slot=poster]):not([${$299b6c40adc500b8$var$T.NO_AUTOHIDE}]):not([role=dialog])) {
        opacity: 0;
        transition: var(--media-control-transition-out, opacity 1s);
      }

      :host([${$299b6c40adc500b8$var$T.USER_INACTIVE}]:not([${$299b6c40adc500b8$var$T.NO_AUTOHIDE}]):not([${$299b6c40adc500b8$var$a.MEDIA_PAUSED}]):not([${$299b6c40adc500b8$var$a.MEDIA_IS_CASTING}]):not([${$299b6c40adc500b8$var$T.AUDIO}])) ::slotted([slot=media]) {
        cursor: none;
      }

      :host([${$299b6c40adc500b8$var$T.USER_INACTIVE}][${$299b6c40adc500b8$var$T.AUTOHIDE_OVER_CONTROLS}]:not([${$299b6c40adc500b8$var$T.NO_AUTOHIDE}]):not([${$299b6c40adc500b8$var$a.MEDIA_PAUSED}]):not([${$299b6c40adc500b8$var$a.MEDIA_IS_CASTING}]):not([${$299b6c40adc500b8$var$T.AUDIO}])) * {
        --media-cursor: none;
        cursor: none;
      }


      ::slotted(media-control-bar)  {
        align-self: stretch;
      }

      
      :host(:not([${$299b6c40adc500b8$var$T.AUDIO}])[${$299b6c40adc500b8$var$a.MEDIA_HAS_PLAYED}]) slot[name=poster] {
        display: none;
      }

      ::slotted([role=dialog]) {
        width: 100%;
        height: 100%;
        align-self: center;
      }

      ::slotted([role=menu]) {
        align-self: end;
      }
    </style>

    <slot name="media" part="layer media-layer"></slot>
    <slot name="poster" part="layer poster-layer"></slot>
    <slot name="gestures-chrome" part="layer gesture-layer">
      <media-gesture-receiver slot="gestures-chrome">
        <template shadowrootmode="${$299b6c40adc500b8$var$gn.shadowRootOptions.mode}">
          ${$299b6c40adc500b8$var$gn.getTemplateHTML({})}
        </template>
      </media-gesture-receiver>
    </slot>
    <span part="layer vertical-layer">
      <slot name="top-chrome" part="top chrome"></slot>
      <slot name="middle-chrome" part="middle chrome"></slot>
      <slot name="centered-chrome" part="layer centered-layer center centered chrome"></slot>
      
      <slot part="bottom chrome"></slot>
    </span>
    <slot name="dialog" part="layer dialog-layer"></slot>
  `;
}
var $299b6c40adc500b8$var$xc = Object.values($299b6c40adc500b8$var$a), $299b6c40adc500b8$var$Nc = "sm:384 md:576 lg:768 xl:960";
function $299b6c40adc500b8$var$Uc(i) {
    $299b6c40adc500b8$var$cd(i.target, i.contentRect.width);
}
function $299b6c40adc500b8$var$cd(i, e) {
    var t;
    if (!i.isConnected) return;
    let r = (t = i.getAttribute($299b6c40adc500b8$var$T.BREAKPOINTS)) != null ? t : $299b6c40adc500b8$var$Nc, n1 = $299b6c40adc500b8$var$Hc(r), s = $299b6c40adc500b8$var$Vc(n1, e), o = !1;
    if (Object.keys(n1).forEach((d)=>{
        if (s.includes(d)) {
            i.hasAttribute(`breakpoint${d}`) || (i.setAttribute(`breakpoint${d}`, ""), o = !0);
            return;
        }
        i.hasAttribute(`breakpoint${d}`) && (i.removeAttribute(`breakpoint${d}`), o = !0);
    }), o) {
        let d = new CustomEvent($299b6c40adc500b8$var$gt.BREAKPOINTS_CHANGE, {
            detail: s
        });
        i.dispatchEvent(d);
    }
    i.breakpointsComputed || (i.breakpointsComputed = !0, i.dispatchEvent(new CustomEvent($299b6c40adc500b8$var$gt.BREAKPOINTS_COMPUTED, {
        bubbles: !0,
        composed: !0
    })));
}
function $299b6c40adc500b8$var$Hc(i) {
    let e = i.split(/\s+/);
    return Object.fromEntries(e.map((t)=>t.split(":")));
}
function $299b6c40adc500b8$var$Vc(i, e) {
    return Object.keys(i).filter((t)=>e >= parseInt(i[t]));
}
var $299b6c40adc500b8$var$kt = class extends $299b6c40adc500b8$var$l.HTMLElement {
    constructor(){
        if (super(), $299b6c40adc500b8$var$ce(this, $299b6c40adc500b8$var$ba), $299b6c40adc500b8$var$ce(this, $299b6c40adc500b8$var$fa), $299b6c40adc500b8$var$ce(this, $299b6c40adc500b8$var$_a), $299b6c40adc500b8$var$ce(this, $299b6c40adc500b8$var$qi), $299b6c40adc500b8$var$ce(this, $299b6c40adc500b8$var$An), $299b6c40adc500b8$var$ce(this, $299b6c40adc500b8$var$ri), $299b6c40adc500b8$var$ce(this, $299b6c40adc500b8$var$_n, 0), $299b6c40adc500b8$var$ce(this, $299b6c40adc500b8$var$ti, null), $299b6c40adc500b8$var$ce(this, $299b6c40adc500b8$var$Ki, null), $299b6c40adc500b8$var$ce(this, $299b6c40adc500b8$var$ii, void 0), this.breakpointsComputed = !1, $299b6c40adc500b8$var$ce(this, $299b6c40adc500b8$var$bn, new MutationObserver($299b6c40adc500b8$var$ve(this, $299b6c40adc500b8$var$ba, $299b6c40adc500b8$var$ld).bind(this))), $299b6c40adc500b8$var$ce(this, $299b6c40adc500b8$var$Gi, !1), $299b6c40adc500b8$var$ce(this, $299b6c40adc500b8$var$fn, (t)=>{
            $299b6c40adc500b8$var$he(this, $299b6c40adc500b8$var$Gi) || (setTimeout(()=>{
                $299b6c40adc500b8$var$Uc(t), $299b6c40adc500b8$var$yt(this, $299b6c40adc500b8$var$Gi, !1);
            }, 0), $299b6c40adc500b8$var$yt(this, $299b6c40adc500b8$var$Gi, !0));
        }), !this.shadowRoot) {
            this.attachShadow(this.constructor.shadowRootOptions);
            let t = $299b6c40adc500b8$var$W(this.attributes), r = this.constructor.getTemplateHTML(t);
            this.shadowRoot.setHTMLUnsafe ? this.shadowRoot.setHTMLUnsafe(r) : this.shadowRoot.innerHTML = r;
        }
        let e = this.querySelector(":scope > slot[slot=media]");
        e && e.addEventListener("slotchange", ()=>{
            if (!e.assignedElements({
                flatten: !0
            }).length) {
                $299b6c40adc500b8$var$he(this, $299b6c40adc500b8$var$ti) && this.mediaUnsetCallback($299b6c40adc500b8$var$he(this, $299b6c40adc500b8$var$ti));
                return;
            }
            this.handleMediaUpdated(this.media);
        });
    }
    static get observedAttributes() {
        return [
            $299b6c40adc500b8$var$T.AUTOHIDE,
            $299b6c40adc500b8$var$T.GESTURES_DISABLED
        ].concat($299b6c40adc500b8$var$xc).filter((e)=>![
                $299b6c40adc500b8$var$a.MEDIA_RENDITION_LIST,
                $299b6c40adc500b8$var$a.MEDIA_AUDIO_TRACK_LIST,
                $299b6c40adc500b8$var$a.MEDIA_CHAPTERS_CUES,
                $299b6c40adc500b8$var$a.MEDIA_WIDTH,
                $299b6c40adc500b8$var$a.MEDIA_HEIGHT,
                $299b6c40adc500b8$var$a.MEDIA_ERROR,
                $299b6c40adc500b8$var$a.MEDIA_ERROR_MESSAGE
            ].includes(e));
    }
    attributeChangedCallback(e, t, r) {
        e.toLowerCase() == $299b6c40adc500b8$var$T.AUTOHIDE && (this.autohide = r);
    }
    get media() {
        let e = this.querySelector(":scope > [slot=media]");
        return e?.nodeName == "SLOT" && (e = e.assignedElements({
            flatten: !0
        })[0]), e;
    }
    async handleMediaUpdated(e) {
        e && ($299b6c40adc500b8$var$yt(this, $299b6c40adc500b8$var$ti, e), e.localName.includes("-") && await $299b6c40adc500b8$var$l.customElements.whenDefined(e.localName), this.mediaSetCallback(e));
    }
    connectedCallback() {
        var e;
        $299b6c40adc500b8$var$he(this, $299b6c40adc500b8$var$bn).observe(this, {
            childList: !0,
            subtree: !0
        }), $299b6c40adc500b8$var$qe(this, $299b6c40adc500b8$var$he(this, $299b6c40adc500b8$var$fn));
        let r = this.getAttribute($299b6c40adc500b8$var$T.AUDIO) != null ? $299b6c40adc500b8$var$c("audio player") : $299b6c40adc500b8$var$c("video player");
        this.setAttribute("role", "region"), this.setAttribute("aria-label", r), this.handleMediaUpdated(this.media), this.setAttribute($299b6c40adc500b8$var$T.USER_INACTIVE, ""), $299b6c40adc500b8$var$cd(this, this.getBoundingClientRect().width), this.addEventListener("pointerdown", this), this.addEventListener("pointermove", this), this.addEventListener("pointerup", this), this.addEventListener("mouseleave", this), this.addEventListener("keyup", this), (e = $299b6c40adc500b8$var$l.window) == null || e.addEventListener("mouseup", this);
    }
    disconnectedCallback() {
        var e;
        $299b6c40adc500b8$var$he(this, $299b6c40adc500b8$var$bn).disconnect(), $299b6c40adc500b8$var$Ye(this, $299b6c40adc500b8$var$he(this, $299b6c40adc500b8$var$fn)), this.media && this.mediaUnsetCallback(this.media), (e = $299b6c40adc500b8$var$l.window) == null || e.removeEventListener("mouseup", this);
    }
    mediaSetCallback(e) {}
    mediaUnsetCallback(e) {
        $299b6c40adc500b8$var$yt(this, $299b6c40adc500b8$var$ti, null);
    }
    handleEvent(e) {
        switch(e.type){
            case "pointerdown":
                $299b6c40adc500b8$var$yt(this, $299b6c40adc500b8$var$_n, e.timeStamp);
                break;
            case "pointermove":
                $299b6c40adc500b8$var$ve(this, $299b6c40adc500b8$var$fa, $299b6c40adc500b8$var$dd).call(this, e);
                break;
            case "pointerup":
                $299b6c40adc500b8$var$ve(this, $299b6c40adc500b8$var$_a, $299b6c40adc500b8$var$ud).call(this, e);
                break;
            case "mouseleave":
                $299b6c40adc500b8$var$ve(this, $299b6c40adc500b8$var$qi, $299b6c40adc500b8$var$Tn).call(this);
                break;
            case "mouseup":
                this.removeAttribute($299b6c40adc500b8$var$T.KEYBOARD_CONTROL);
                break;
            case "keyup":
                $299b6c40adc500b8$var$ve(this, $299b6c40adc500b8$var$ri, $299b6c40adc500b8$var$Yi).call(this), this.setAttribute($299b6c40adc500b8$var$T.KEYBOARD_CONTROL, "");
                break;
        }
    }
    set autohide(e) {
        let t = Number(e);
        $299b6c40adc500b8$var$yt(this, $299b6c40adc500b8$var$ii, isNaN(t) ? 0 : t);
    }
    get autohide() {
        return ($299b6c40adc500b8$var$he(this, $299b6c40adc500b8$var$ii) === void 0 ? 2 : $299b6c40adc500b8$var$he(this, $299b6c40adc500b8$var$ii)).toString();
    }
    get breakpoints() {
        return $299b6c40adc500b8$var$_(this, $299b6c40adc500b8$var$T.BREAKPOINTS);
    }
    set breakpoints(e) {
        $299b6c40adc500b8$var$b(this, $299b6c40adc500b8$var$T.BREAKPOINTS, e);
    }
    get audio() {
        return $299b6c40adc500b8$var$A(this, $299b6c40adc500b8$var$T.AUDIO);
    }
    set audio(e) {
        $299b6c40adc500b8$var$y(this, $299b6c40adc500b8$var$T.AUDIO, e);
    }
    get gesturesDisabled() {
        return $299b6c40adc500b8$var$A(this, $299b6c40adc500b8$var$T.GESTURES_DISABLED);
    }
    set gesturesDisabled(e) {
        $299b6c40adc500b8$var$y(this, $299b6c40adc500b8$var$T.GESTURES_DISABLED, e);
    }
    get keyboardControl() {
        return $299b6c40adc500b8$var$A(this, $299b6c40adc500b8$var$T.KEYBOARD_CONTROL);
    }
    set keyboardControl(e) {
        $299b6c40adc500b8$var$y(this, $299b6c40adc500b8$var$T.KEYBOARD_CONTROL, e);
    }
    get noAutohide() {
        return $299b6c40adc500b8$var$A(this, $299b6c40adc500b8$var$T.NO_AUTOHIDE);
    }
    set noAutohide(e) {
        $299b6c40adc500b8$var$y(this, $299b6c40adc500b8$var$T.NO_AUTOHIDE, e);
    }
    get autohideOverControls() {
        return $299b6c40adc500b8$var$A(this, $299b6c40adc500b8$var$T.AUTOHIDE_OVER_CONTROLS);
    }
    set autohideOverControls(e) {
        $299b6c40adc500b8$var$y(this, $299b6c40adc500b8$var$T.AUTOHIDE_OVER_CONTROLS, e);
    }
    get userInteractive() {
        return $299b6c40adc500b8$var$A(this, $299b6c40adc500b8$var$T.USER_INACTIVE);
    }
    set userInteractive(e) {
        $299b6c40adc500b8$var$y(this, $299b6c40adc500b8$var$T.USER_INACTIVE, e);
    }
};
$299b6c40adc500b8$var$_n = new WeakMap;
$299b6c40adc500b8$var$ti = new WeakMap;
$299b6c40adc500b8$var$Ki = new WeakMap;
$299b6c40adc500b8$var$ii = new WeakMap;
$299b6c40adc500b8$var$bn = new WeakMap;
$299b6c40adc500b8$var$ba = new WeakSet;
$299b6c40adc500b8$var$ld = function(i) {
    let e = this.media;
    for (let t of i){
        if (t.type !== "childList") continue;
        let r = t.removedNodes;
        for (let n1 of r){
            if (n1.slot != "media" || t.target != this) continue;
            let s = t.previousSibling && t.previousSibling.previousElementSibling;
            if (!s || !e) this.mediaUnsetCallback(n1);
            else {
                let o = s.slot !== "media";
                for(; (s = s.previousSibling) !== null;)s.slot == "media" && (o = !1);
                o && this.mediaUnsetCallback(n1);
            }
        }
        if (e) for (let n1 of t.addedNodes)n1 === e && this.handleMediaUpdated(e);
    }
};
$299b6c40adc500b8$var$Gi = new WeakMap;
$299b6c40adc500b8$var$fn = new WeakMap;
$299b6c40adc500b8$var$fa = new WeakSet;
$299b6c40adc500b8$var$dd = function(i) {
    if (i.pointerType !== "mouse" && i.timeStamp - $299b6c40adc500b8$var$he(this, $299b6c40adc500b8$var$_n) < 250) return;
    $299b6c40adc500b8$var$ve(this, $299b6c40adc500b8$var$An, $299b6c40adc500b8$var$Aa).call(this), clearTimeout($299b6c40adc500b8$var$he(this, $299b6c40adc500b8$var$Ki));
    let e = this.hasAttribute($299b6c40adc500b8$var$T.AUTOHIDE_OVER_CONTROLS);
    ([
        this,
        this.media
    ].includes(i.target) || e) && $299b6c40adc500b8$var$ve(this, $299b6c40adc500b8$var$ri, $299b6c40adc500b8$var$Yi).call(this);
};
$299b6c40adc500b8$var$_a = new WeakSet;
$299b6c40adc500b8$var$ud = function(i) {
    if (i.pointerType === "touch") {
        let e = !this.hasAttribute($299b6c40adc500b8$var$T.USER_INACTIVE);
        [
            this,
            this.media
        ].includes(i.target) && e ? $299b6c40adc500b8$var$ve(this, $299b6c40adc500b8$var$qi, $299b6c40adc500b8$var$Tn).call(this) : $299b6c40adc500b8$var$ve(this, $299b6c40adc500b8$var$ri, $299b6c40adc500b8$var$Yi).call(this);
    } else i.composedPath().some((e)=>[
            "media-play-button",
            "media-fullscreen-button"
        ].includes(e?.localName)) && $299b6c40adc500b8$var$ve(this, $299b6c40adc500b8$var$ri, $299b6c40adc500b8$var$Yi).call(this);
};
$299b6c40adc500b8$var$qi = new WeakSet;
$299b6c40adc500b8$var$Tn = function() {
    if ($299b6c40adc500b8$var$he(this, $299b6c40adc500b8$var$ii) < 0 || this.hasAttribute($299b6c40adc500b8$var$T.USER_INACTIVE)) return;
    this.setAttribute($299b6c40adc500b8$var$T.USER_INACTIVE, "");
    let i = new $299b6c40adc500b8$var$l.CustomEvent($299b6c40adc500b8$var$gt.USER_INACTIVE_CHANGE, {
        composed: !0,
        bubbles: !0,
        detail: !0
    });
    this.dispatchEvent(i);
};
$299b6c40adc500b8$var$An = new WeakSet;
$299b6c40adc500b8$var$Aa = function() {
    if (!this.hasAttribute($299b6c40adc500b8$var$T.USER_INACTIVE)) return;
    this.removeAttribute($299b6c40adc500b8$var$T.USER_INACTIVE);
    let i = new $299b6c40adc500b8$var$l.CustomEvent($299b6c40adc500b8$var$gt.USER_INACTIVE_CHANGE, {
        composed: !0,
        bubbles: !0,
        detail: !1
    });
    this.dispatchEvent(i);
};
$299b6c40adc500b8$var$ri = new WeakSet;
$299b6c40adc500b8$var$Yi = function() {
    $299b6c40adc500b8$var$ve(this, $299b6c40adc500b8$var$An, $299b6c40adc500b8$var$Aa).call(this), clearTimeout($299b6c40adc500b8$var$he(this, $299b6c40adc500b8$var$Ki));
    let i = parseInt(this.autohide);
    i < 0 || $299b6c40adc500b8$var$yt(this, $299b6c40adc500b8$var$Ki, setTimeout(()=>{
        $299b6c40adc500b8$var$ve(this, $299b6c40adc500b8$var$qi, $299b6c40adc500b8$var$Tn).call(this);
    }, i * 1e3));
};
$299b6c40adc500b8$var$kt.shadowRootOptions = {
    mode: "open"
};
$299b6c40adc500b8$var$kt.getTemplateHTML = $299b6c40adc500b8$var$Oc;
$299b6c40adc500b8$var$l.customElements.get("media-container") || $299b6c40adc500b8$var$l.customElements.define("media-container", $299b6c40adc500b8$var$kt);
var $299b6c40adc500b8$var$hd = (i, e, t)=>{
    if (!e.has(i)) throw TypeError("Cannot " + t);
}, $299b6c40adc500b8$var$Q = (i, e, t)=>($299b6c40adc500b8$var$hd(i, e, "read from private field"), t ? t.call(i) : e.get(i)), $299b6c40adc500b8$var$Zi = (i, e, t)=>{
    if (e.has(i)) throw TypeError("Cannot add the same private member more than once");
    e instanceof WeakSet ? e.add(i) : e.set(i, t);
}, $299b6c40adc500b8$var$yn = (i, e, t, r)=>($299b6c40adc500b8$var$hd(i, e, "write to private field"), r ? r.call(i, t) : e.set(i, t), t), $299b6c40adc500b8$var$ni, $299b6c40adc500b8$var$si, $299b6c40adc500b8$var$kn, $299b6c40adc500b8$var$It, $299b6c40adc500b8$var$Ze, $299b6c40adc500b8$var$st, $299b6c40adc500b8$var$at = class {
    constructor(e, t, { defaultValue: r } = {
        defaultValue: void 0
    }){
        $299b6c40adc500b8$var$Zi(this, $299b6c40adc500b8$var$Ze), $299b6c40adc500b8$var$Zi(this, $299b6c40adc500b8$var$ni, void 0), $299b6c40adc500b8$var$Zi(this, $299b6c40adc500b8$var$si, void 0), $299b6c40adc500b8$var$Zi(this, $299b6c40adc500b8$var$kn, void 0), $299b6c40adc500b8$var$Zi(this, $299b6c40adc500b8$var$It, new Set), $299b6c40adc500b8$var$yn(this, $299b6c40adc500b8$var$ni, e), $299b6c40adc500b8$var$yn(this, $299b6c40adc500b8$var$si, t), $299b6c40adc500b8$var$yn(this, $299b6c40adc500b8$var$kn, new Set(r));
    }
    [Symbol.iterator]() {
        return $299b6c40adc500b8$var$Q(this, $299b6c40adc500b8$var$Ze, $299b6c40adc500b8$var$st).values();
    }
    get length() {
        return $299b6c40adc500b8$var$Q(this, $299b6c40adc500b8$var$Ze, $299b6c40adc500b8$var$st).size;
    }
    get value() {
        var e;
        return (e = [
            ...$299b6c40adc500b8$var$Q(this, $299b6c40adc500b8$var$Ze, $299b6c40adc500b8$var$st)
        ].join(" ")) != null ? e : "";
    }
    set value(e) {
        var t;
        e !== this.value && ($299b6c40adc500b8$var$yn(this, $299b6c40adc500b8$var$It, new Set), this.add(...(t = e?.split(" ")) != null ? t : []));
    }
    toString() {
        return this.value;
    }
    item(e) {
        return [
            ...$299b6c40adc500b8$var$Q(this, $299b6c40adc500b8$var$Ze, $299b6c40adc500b8$var$st)
        ][e];
    }
    values() {
        return $299b6c40adc500b8$var$Q(this, $299b6c40adc500b8$var$Ze, $299b6c40adc500b8$var$st).values();
    }
    forEach(e, t) {
        $299b6c40adc500b8$var$Q(this, $299b6c40adc500b8$var$Ze, $299b6c40adc500b8$var$st).forEach(e, t);
    }
    add(...e) {
        var t, r;
        e.forEach((n1)=>$299b6c40adc500b8$var$Q(this, $299b6c40adc500b8$var$It).add(n1)), !(this.value === "" && !((t = $299b6c40adc500b8$var$Q(this, $299b6c40adc500b8$var$ni)) != null && t.hasAttribute(`${$299b6c40adc500b8$var$Q(this, $299b6c40adc500b8$var$si)}`))) && ((r = $299b6c40adc500b8$var$Q(this, $299b6c40adc500b8$var$ni)) == null || r.setAttribute(`${$299b6c40adc500b8$var$Q(this, $299b6c40adc500b8$var$si)}`, `${this.value}`));
    }
    remove(...e) {
        var t;
        e.forEach((r)=>$299b6c40adc500b8$var$Q(this, $299b6c40adc500b8$var$It).delete(r)), (t = $299b6c40adc500b8$var$Q(this, $299b6c40adc500b8$var$ni)) == null || t.setAttribute(`${$299b6c40adc500b8$var$Q(this, $299b6c40adc500b8$var$si)}`, `${this.value}`);
    }
    contains(e) {
        return $299b6c40adc500b8$var$Q(this, $299b6c40adc500b8$var$Ze, $299b6c40adc500b8$var$st).has(e);
    }
    toggle(e, t) {
        return typeof t < "u" ? t ? (this.add(e), !0) : (this.remove(e), !1) : this.contains(e) ? (this.remove(e), !1) : (this.add(e), !0);
    }
    replace(e, t) {
        return this.remove(e), this.add(t), e === t;
    }
};
$299b6c40adc500b8$var$ni = new WeakMap;
$299b6c40adc500b8$var$si = new WeakMap;
$299b6c40adc500b8$var$kn = new WeakMap;
$299b6c40adc500b8$var$It = new WeakMap;
$299b6c40adc500b8$var$Ze = new WeakSet;
$299b6c40adc500b8$var$st = function() {
    return $299b6c40adc500b8$var$Q(this, $299b6c40adc500b8$var$It).size ? $299b6c40adc500b8$var$Q(this, $299b6c40adc500b8$var$It) : $299b6c40adc500b8$var$Q(this, $299b6c40adc500b8$var$kn);
};
var $299b6c40adc500b8$var$Wc = (i = "")=>i.split(/\s+/), $299b6c40adc500b8$var$md = (i = "")=>{
    let [e, t, r] = i.split(":"), n1 = r ? decodeURIComponent(r) : void 0;
    return {
        kind: e === "cc" ? $299b6c40adc500b8$var$ie.CAPTIONS : $299b6c40adc500b8$var$ie.SUBTITLES,
        language: t,
        label: n1
    };
}, $299b6c40adc500b8$var$St = (i = "", e = {})=>$299b6c40adc500b8$var$Wc(i).map((t)=>{
        let r = $299b6c40adc500b8$var$md(t);
        return {
            ...e,
            ...r
        };
    }), $299b6c40adc500b8$var$ya = (i)=>i ? Array.isArray(i) ? i.map((e)=>typeof e == "string" ? $299b6c40adc500b8$var$md(e) : e) : typeof i == "string" ? $299b6c40adc500b8$var$St(i) : [
        i
    ] : [], $299b6c40adc500b8$var$In = ({ kind: i, label: e, language: t } = {
    kind: "subtitles"
})=>e ? `${i === "captions" ? "cc" : "sb"}:${t}:${encodeURIComponent(e)}` : t, $299b6c40adc500b8$var$Qe = (i = [])=>Array.prototype.map.call(i, $299b6c40adc500b8$var$In).join(" "), $299b6c40adc500b8$var$Fc = (i, e)=>(t)=>t[i] === e, $299b6c40adc500b8$var$pd = (i)=>{
    let e = Object.entries(i).map(([t, r])=>$299b6c40adc500b8$var$Fc(t, r));
    return (t)=>e.every((r)=>r(t));
}, $299b6c40adc500b8$var$Mt = (i, e = [], t = [])=>{
    let r = $299b6c40adc500b8$var$ya(t).map($299b6c40adc500b8$var$pd), n1 = (s)=>r.some((o)=>o(s));
    Array.from(e).filter(n1).forEach((s)=>{
        s.mode = i;
    });
}, $299b6c40adc500b8$var$Lt = (i, e = ()=>!0)=>{
    if (!i?.textTracks) return [];
    let t = typeof e == "function" ? e : $299b6c40adc500b8$var$pd(e);
    return Array.from(i.textTracks).filter(t);
}, $299b6c40adc500b8$var$Sn = (i)=>{
    var e;
    return !!((e = i.mediaSubtitlesShowing) != null && e.length) || i.hasAttribute($299b6c40adc500b8$var$a.MEDIA_SUBTITLES_SHOWING);
};
var $299b6c40adc500b8$var$Ed = (i)=>{
    var e;
    let { media: t, fullscreenElement: r } = i;
    try {
        let n1 = r && "requestFullscreen" in r ? "requestFullscreen" : r && "webkitRequestFullScreen" in r ? "webkitRequestFullScreen" : void 0;
        if (n1) {
            let s = (e = r[n1]) == null ? void 0 : e.call(r);
            if (s instanceof Promise) return s.catch(()=>{});
        } else t?.webkitEnterFullscreen ? t.webkitEnterFullscreen() : t?.requestFullscreen && t.requestFullscreen();
    } catch (n1) {
        console.error(n1);
    }
}, $299b6c40adc500b8$var$vd = "exitFullscreen" in $299b6c40adc500b8$var$F ? "exitFullscreen" : "webkitExitFullscreen" in $299b6c40adc500b8$var$F ? "webkitExitFullscreen" : "webkitCancelFullScreen" in $299b6c40adc500b8$var$F ? "webkitCancelFullScreen" : void 0, $299b6c40adc500b8$var$gd = (i)=>{
    var e;
    let { documentElement: t } = i;
    if ($299b6c40adc500b8$var$vd) {
        let r = (e = t?.[$299b6c40adc500b8$var$vd]) == null ? void 0 : e.call(t);
        if (r instanceof Promise) return r.catch(()=>{});
    }
}, $299b6c40adc500b8$var$Qi = "fullscreenElement" in $299b6c40adc500b8$var$F ? "fullscreenElement" : "webkitFullscreenElement" in $299b6c40adc500b8$var$F ? "webkitFullscreenElement" : void 0, $299b6c40adc500b8$var$Bc = (i)=>{
    let { documentElement: e, media: t } = i, r = e?.[$299b6c40adc500b8$var$Qi];
    return !r && "webkitDisplayingFullscreen" in t && "webkitPresentationMode" in t && t.webkitDisplayingFullscreen && t.webkitPresentationMode === $299b6c40adc500b8$var$xl.FULLSCREEN ? t : r;
}, $299b6c40adc500b8$var$bd = (i)=>{
    var e;
    let { media: t, documentElement: r, fullscreenElement: n1 = t } = i;
    if (!t || !r) return !1;
    let s = $299b6c40adc500b8$var$Bc(i);
    if (!s) return !1;
    if (s === n1 || s === t) return !0;
    if (s.localName.includes("-")) {
        let o = s.shadowRoot;
        if (!($299b6c40adc500b8$var$Qi in o)) return $299b6c40adc500b8$var$ee(s, n1);
        for(; o?.[$299b6c40adc500b8$var$Qi];){
            if (o[$299b6c40adc500b8$var$Qi] === n1) return !0;
            o = (e = o[$299b6c40adc500b8$var$Qi]) == null ? void 0 : e.shadowRoot;
        }
    }
    return !1;
}, $299b6c40adc500b8$var$$c = "fullscreenEnabled" in $299b6c40adc500b8$var$F ? "fullscreenEnabled" : "webkitFullscreenEnabled" in $299b6c40adc500b8$var$F ? "webkitFullscreenEnabled" : void 0, $299b6c40adc500b8$var$fd = (i)=>{
    let { documentElement: e, media: t } = i;
    return !!e?.[$299b6c40adc500b8$var$$c] || t && "webkitSupportsFullscreen" in t;
};
var $299b6c40adc500b8$var$Mn, $299b6c40adc500b8$var$ka = ()=>{
    var i, e;
    return $299b6c40adc500b8$var$Mn || ($299b6c40adc500b8$var$Mn = (e = (i = $299b6c40adc500b8$var$F) == null ? void 0 : i.createElement) == null ? void 0 : e.call(i, "video"), $299b6c40adc500b8$var$Mn);
}, $299b6c40adc500b8$var$_d = async (i = $299b6c40adc500b8$var$ka())=>{
    if (!i) return !1;
    let e = i.volume;
    i.volume = e / 2 + .1;
    let t = new AbortController, r = await Promise.race([
        $299b6c40adc500b8$var$Gc(i, t.signal),
        $299b6c40adc500b8$var$Kc(i, e)
    ]);
    return t.abort(), r;
}, $299b6c40adc500b8$var$Gc = (i, e)=>new Promise((t)=>{
        i.addEventListener("volumechange", ()=>t(!0), {
            signal: e
        });
    }), $299b6c40adc500b8$var$Kc = async (i, e)=>{
    for(let t = 0; t < 10; t++){
        if (i.volume === e) return !1;
        await $299b6c40adc500b8$var$vn(10);
    }
    return i.volume !== e;
}, $299b6c40adc500b8$var$qc = /.*Version\/.*Safari\/.*/.test($299b6c40adc500b8$var$l.navigator.userAgent), $299b6c40adc500b8$var$Ia = (i = $299b6c40adc500b8$var$ka())=>$299b6c40adc500b8$var$l.matchMedia("(display-mode: standalone)").matches && $299b6c40adc500b8$var$qc ? !1 : typeof i?.requestPictureInPicture == "function", $299b6c40adc500b8$var$Sa = (i = $299b6c40adc500b8$var$ka())=>$299b6c40adc500b8$var$fd({
        documentElement: $299b6c40adc500b8$var$F,
        media: i
    }), $299b6c40adc500b8$var$Td = $299b6c40adc500b8$var$Sa(), $299b6c40adc500b8$var$Ad = $299b6c40adc500b8$var$Ia(), $299b6c40adc500b8$var$yd = !!$299b6c40adc500b8$var$l.WebKitPlaybackTargetAvailabilityEvent, $299b6c40adc500b8$var$kd = !!$299b6c40adc500b8$var$l.chrome;
var $299b6c40adc500b8$var$ai = (i)=>$299b6c40adc500b8$var$Lt(i.media, (e)=>[
            $299b6c40adc500b8$var$ie.SUBTITLES,
            $299b6c40adc500b8$var$ie.CAPTIONS
        ].includes(e.kind)).sort((e, t)=>e.kind >= t.kind ? 1 : -1), $299b6c40adc500b8$var$Ma = (i)=>$299b6c40adc500b8$var$Lt(i.media, (e)=>e.mode === $299b6c40adc500b8$var$je.SHOWING && [
            $299b6c40adc500b8$var$ie.SUBTITLES,
            $299b6c40adc500b8$var$ie.CAPTIONS
        ].includes(e.kind)), $299b6c40adc500b8$var$Ln = (i, e)=>{
    let t = $299b6c40adc500b8$var$ai(i), r = $299b6c40adc500b8$var$Ma(i), n1 = !!r.length;
    if (t.length) {
        if (e === !1 || n1 && e !== !0) $299b6c40adc500b8$var$Mt($299b6c40adc500b8$var$je.DISABLED, t, r);
        else if (e === !0 || !n1 && e !== !1) {
            let s = t[0], { options: o } = i;
            if (!o?.noSubtitlesLangPref) {
                let f = globalThis.localStorage.getItem("media-chrome-pref-subtitles-lang"), g = f ? [
                    f,
                    ...globalThis.navigator.languages
                ] : globalThis.navigator.languages, v = t.filter((E)=>g.some((R)=>E.language.toLowerCase().startsWith(R.split("-")[0]))).sort((E, R)=>{
                    let k = g.findIndex((V)=>E.language.toLowerCase().startsWith(V.split("-")[0])), S = g.findIndex((V)=>R.language.toLowerCase().startsWith(V.split("-")[0]));
                    return k - S;
                });
                v[0] && (s = v[0]);
            }
            let { language: d, label: u, kind: m } = s;
            $299b6c40adc500b8$var$Mt($299b6c40adc500b8$var$je.DISABLED, t, r), $299b6c40adc500b8$var$Mt($299b6c40adc500b8$var$je.SHOWING, t, [
                {
                    language: d,
                    label: u,
                    kind: m
                }
            ]);
        }
    }
}, $299b6c40adc500b8$var$wn = (i, e)=>i === e ? !0 : i == null || e == null || typeof i != typeof e ? !1 : typeof i == "number" && Number.isNaN(i) && Number.isNaN(e) ? !0 : typeof i != "object" ? !1 : Array.isArray(i) ? $299b6c40adc500b8$var$Yc(i, e) : Object.entries(i).every(([t, r])=>t in e && $299b6c40adc500b8$var$wn(r, e[t])), $299b6c40adc500b8$var$Yc = (i, e)=>{
    let t = Array.isArray(i), r = Array.isArray(e);
    return t !== r ? !1 : t || r ? i.length !== e.length ? !1 : i.every((n1, s)=>$299b6c40adc500b8$var$wn(n1, e[s])) : !0;
};
var $299b6c40adc500b8$var$Zc = Object.values($299b6c40adc500b8$var$Te), $299b6c40adc500b8$var$Cn, $299b6c40adc500b8$var$Qc = $299b6c40adc500b8$var$_d().then((i)=>($299b6c40adc500b8$var$Cn = i, $299b6c40adc500b8$var$Cn)), $299b6c40adc500b8$var$Id = async (...i)=>{
    await Promise.all(i.filter((e)=>e).map(async (e)=>{
        if (!("localName" in e && e instanceof $299b6c40adc500b8$var$l.HTMLElement)) return;
        let t = e.localName;
        if (!t.includes("-")) return;
        let r = $299b6c40adc500b8$var$l.customElements.get(t);
        r && e instanceof r || (await $299b6c40adc500b8$var$l.customElements.whenDefined(t), $299b6c40adc500b8$var$l.customElements.upgrade(e));
    }));
}, $299b6c40adc500b8$var$zc = new $299b6c40adc500b8$var$l.DOMParser, $299b6c40adc500b8$var$Xc = (i)=>i && ($299b6c40adc500b8$var$zc.parseFromString(i, "text/html").body.textContent || i), $299b6c40adc500b8$var$oi = {
    mediaError: {
        get (i, e) {
            let { media: t } = i;
            if (e?.type !== "playing") return t?.error;
        },
        mediaEvents: [
            "emptied",
            "error",
            "playing"
        ]
    },
    mediaErrorCode: {
        get (i, e) {
            var t;
            let { media: r } = i;
            if (e?.type !== "playing") return (t = r?.error) == null ? void 0 : t.code;
        },
        mediaEvents: [
            "emptied",
            "error",
            "playing"
        ]
    },
    mediaErrorMessage: {
        get (i, e) {
            var t, r;
            let { media: n1 } = i;
            if (e?.type !== "playing") return (r = (t = n1?.error) == null ? void 0 : t.message) != null ? r : "";
        },
        mediaEvents: [
            "emptied",
            "error",
            "playing"
        ]
    },
    mediaWidth: {
        get (i) {
            var e;
            let { media: t } = i;
            return (e = t?.videoWidth) != null ? e : 0;
        },
        mediaEvents: [
            "resize"
        ]
    },
    mediaHeight: {
        get (i) {
            var e;
            let { media: t } = i;
            return (e = t?.videoHeight) != null ? e : 0;
        },
        mediaEvents: [
            "resize"
        ]
    },
    mediaPaused: {
        get (i) {
            var e;
            let { media: t } = i;
            return (e = t?.paused) != null ? e : !0;
        },
        set (i, e) {
            var t;
            let { media: r } = e;
            r && (i ? r.pause() : (t = r.play()) == null || t.catch(()=>{}));
        },
        mediaEvents: [
            "play",
            "playing",
            "pause",
            "emptied"
        ]
    },
    mediaHasPlayed: {
        get (i, e) {
            let { media: t } = i;
            return t ? e ? e.type === "playing" : !t.paused : !1;
        },
        mediaEvents: [
            "playing",
            "emptied"
        ]
    },
    mediaEnded: {
        get (i) {
            var e;
            let { media: t } = i;
            return (e = t?.ended) != null ? e : !1;
        },
        mediaEvents: [
            "seeked",
            "ended",
            "emptied"
        ]
    },
    mediaPlaybackRate: {
        get (i) {
            var e;
            let { media: t } = i;
            return (e = t?.playbackRate) != null ? e : 1;
        },
        set (i, e) {
            let { media: t } = e;
            t && Number.isFinite(+i) && (t.playbackRate = +i);
        },
        mediaEvents: [
            "ratechange",
            "loadstart"
        ]
    },
    mediaMuted: {
        get (i) {
            var e;
            let { media: t } = i;
            return (e = t?.muted) != null ? e : !1;
        },
        set (i, e) {
            let { media: t, options: { noMutedPref: r } = {} } = e;
            if (t) {
                if (!t.hasAttribute("muted") && !r) try {
                    $299b6c40adc500b8$var$l.localStorage.setItem("media-chrome-pref-muted", i ? "true" : "false");
                } catch (n1) {
                    console.debug("Error setting muted pref", n1);
                }
                t.muted = i;
            }
        },
        mediaEvents: [
            "volumechange"
        ],
        stateOwnersUpdateHandlers: [
            (i, e)=>{
                let { options: { noMutedPref: t } } = e, { media: r } = e;
                if (!(!r || r.muted || t)) try {
                    let n1 = $299b6c40adc500b8$var$l.localStorage.getItem("media-chrome-pref-muted") === "true";
                    $299b6c40adc500b8$var$oi.mediaMuted.set(n1, e), i(n1);
                } catch (n1) {
                    console.debug("Error getting muted pref", n1);
                }
            }
        ]
    },
    mediaVolume: {
        get (i) {
            var e;
            let { media: t } = i;
            return (e = t?.volume) != null ? e : 1;
        },
        set (i, e) {
            let { media: t, options: { noVolumePref: r } = {} } = e;
            if (t) {
                try {
                    i == null ? $299b6c40adc500b8$var$l.localStorage.removeItem("media-chrome-pref-volume") : !t.hasAttribute("muted") && !r && $299b6c40adc500b8$var$l.localStorage.setItem("media-chrome-pref-volume", i.toString());
                } catch (n1) {
                    console.debug("Error setting volume pref", n1);
                }
                Number.isFinite(+i) && (t.volume = +i);
            }
        },
        mediaEvents: [
            "volumechange"
        ],
        stateOwnersUpdateHandlers: [
            (i, e)=>{
                let { options: { noVolumePref: t } } = e;
                if (!t) try {
                    let { media: r } = e;
                    if (!r) return;
                    let n1 = $299b6c40adc500b8$var$l.localStorage.getItem("media-chrome-pref-volume");
                    if (n1 == null) return;
                    $299b6c40adc500b8$var$oi.mediaVolume.set(+n1, e), i(+n1);
                } catch (r) {
                    console.debug("Error getting volume pref", r);
                }
            }
        ]
    },
    mediaVolumeLevel: {
        get (i) {
            let { media: e } = i;
            return typeof e?.volume > "u" ? "high" : e.muted || e.volume === 0 ? "off" : e.volume < .5 ? "low" : e.volume < .75 ? "medium" : "high";
        },
        mediaEvents: [
            "volumechange"
        ]
    },
    mediaCurrentTime: {
        get (i) {
            var e;
            let { media: t } = i;
            return (e = t?.currentTime) != null ? e : 0;
        },
        set (i, e) {
            let { media: t } = e;
            !t || !$299b6c40adc500b8$var$jt(i) || (t.currentTime = i);
        },
        mediaEvents: [
            "timeupdate",
            "loadedmetadata"
        ]
    },
    mediaDuration: {
        get (i) {
            let { media: e, options: { defaultDuration: t } = {} } = i;
            return t && (!e || !e.duration || Number.isNaN(e.duration) || !Number.isFinite(e.duration)) ? t : Number.isFinite(e?.duration) ? e.duration : Number.NaN;
        },
        mediaEvents: [
            "durationchange",
            "loadedmetadata",
            "emptied"
        ]
    },
    mediaLoading: {
        get (i) {
            let { media: e } = i;
            return e?.readyState < 3;
        },
        mediaEvents: [
            "waiting",
            "playing",
            "emptied"
        ]
    },
    mediaSeekable: {
        get (i) {
            var e;
            let { media: t } = i;
            if (!((e = t?.seekable) != null && e.length)) return;
            let r = t.seekable.start(0), n1 = t.seekable.end(t.seekable.length - 1);
            if (!(!r && !n1)) return [
                Number(r.toFixed(3)),
                Number(n1.toFixed(3))
            ];
        },
        mediaEvents: [
            "loadedmetadata",
            "emptied",
            "progress",
            "seekablechange"
        ]
    },
    mediaBuffered: {
        get (i) {
            var e;
            let { media: t } = i, r = (e = t?.buffered) != null ? e : [];
            return Array.from(r).map((n1, s)=>[
                    Number(r.start(s).toFixed(3)),
                    Number(r.end(s).toFixed(3))
                ]);
        },
        mediaEvents: [
            "progress",
            "emptied"
        ]
    },
    mediaStreamType: {
        get (i) {
            let { media: e, options: { defaultStreamType: t } = {} } = i, r = [
                $299b6c40adc500b8$var$Te.LIVE,
                $299b6c40adc500b8$var$Te.ON_DEMAND
            ].includes(t) ? t : void 0;
            if (!e) return r;
            let { streamType: n1 } = e;
            if ($299b6c40adc500b8$var$Zc.includes(n1)) return n1 === $299b6c40adc500b8$var$Te.UNKNOWN ? r : n1;
            let s = e.duration;
            return s === 1 / 0 ? $299b6c40adc500b8$var$Te.LIVE : Number.isFinite(s) ? $299b6c40adc500b8$var$Te.ON_DEMAND : r;
        },
        mediaEvents: [
            "emptied",
            "durationchange",
            "loadedmetadata",
            "streamtypechange"
        ]
    },
    mediaTargetLiveWindow: {
        get (i) {
            let { media: e } = i;
            if (!e) return Number.NaN;
            let { targetLiveWindow: t } = e, r = $299b6c40adc500b8$var$oi.mediaStreamType.get(i);
            return (t == null || Number.isNaN(t)) && r === $299b6c40adc500b8$var$Te.LIVE ? 0 : t;
        },
        mediaEvents: [
            "emptied",
            "durationchange",
            "loadedmetadata",
            "streamtypechange",
            "targetlivewindowchange"
        ]
    },
    mediaTimeIsLive: {
        get (i) {
            let { media: e, options: { liveEdgeOffset: t = 10 } = {} } = i;
            if (!e) return !1;
            if (typeof e.liveEdgeStart == "number") return Number.isNaN(e.liveEdgeStart) ? !1 : e.currentTime >= e.liveEdgeStart;
            if (!($299b6c40adc500b8$var$oi.mediaStreamType.get(i) === $299b6c40adc500b8$var$Te.LIVE)) return !1;
            let n1 = e.seekable;
            if (!n1) return !0;
            if (!n1.length) return !1;
            let s = n1.end(n1.length - 1) - t;
            return e.currentTime >= s;
        },
        mediaEvents: [
            "playing",
            "timeupdate",
            "progress",
            "waiting",
            "emptied"
        ]
    },
    mediaSubtitlesList: {
        get (i) {
            return $299b6c40adc500b8$var$ai(i).map(({ kind: e, label: t, language: r })=>({
                    kind: e,
                    label: t,
                    language: r
                }));
        },
        mediaEvents: [
            "loadstart"
        ],
        textTracksEvents: [
            "addtrack",
            "removetrack"
        ]
    },
    mediaSubtitlesShowing: {
        get (i) {
            return $299b6c40adc500b8$var$Ma(i).map(({ kind: e, label: t, language: r })=>({
                    kind: e,
                    label: t,
                    language: r
                }));
        },
        mediaEvents: [
            "loadstart"
        ],
        textTracksEvents: [
            "addtrack",
            "removetrack",
            "change"
        ],
        stateOwnersUpdateHandlers: [
            (i, e)=>{
                var t, r;
                let { media: n1, options: s } = e;
                if (!n1) return;
                let o = (d)=>{
                    var u;
                    !s.defaultSubtitles || d && ![
                        $299b6c40adc500b8$var$ie.CAPTIONS,
                        $299b6c40adc500b8$var$ie.SUBTITLES
                    ].includes((u = d?.track) == null ? void 0 : u.kind) || $299b6c40adc500b8$var$Ln(e, !0);
                };
                return n1.addEventListener("loadstart", o), (t = n1.textTracks) == null || t.addEventListener("addtrack", o), (r = n1.textTracks) == null || r.addEventListener("removetrack", o), ()=>{
                    var d, u;
                    n1.removeEventListener("loadstart", o), (d = n1.textTracks) == null || d.removeEventListener("addtrack", o), (u = n1.textTracks) == null || u.removeEventListener("removetrack", o);
                };
            }
        ]
    },
    mediaChaptersCues: {
        get (i) {
            var e;
            let { media: t } = i;
            if (!t) return [];
            let [r] = $299b6c40adc500b8$var$Lt(t, {
                kind: $299b6c40adc500b8$var$ie.CHAPTERS
            });
            return Array.from((e = r?.cues) != null ? e : []).map(({ text: n1, startTime: s, endTime: o })=>({
                    text: $299b6c40adc500b8$var$Xc(n1),
                    startTime: s,
                    endTime: o
                }));
        },
        mediaEvents: [
            "loadstart",
            "loadedmetadata"
        ],
        textTracksEvents: [
            "addtrack",
            "removetrack",
            "change"
        ],
        stateOwnersUpdateHandlers: [
            (i, e)=>{
                var t;
                let { media: r } = e;
                if (!r) return;
                let n1 = r.querySelector('track[kind="chapters"][default][src]'), s = (t = r.shadowRoot) == null ? void 0 : t.querySelector(':is(video,audio) > track[kind="chapters"][default][src]');
                return n1?.addEventListener("load", i), s?.addEventListener("load", i), ()=>{
                    n1?.removeEventListener("load", i), s?.removeEventListener("load", i);
                };
            }
        ]
    },
    mediaIsPip: {
        get (i) {
            var e, t;
            let { media: r, documentElement: n1 } = i;
            if (!r || !n1 || !n1.pictureInPictureElement) return !1;
            if (n1.pictureInPictureElement === r) return !0;
            if (n1.pictureInPictureElement instanceof HTMLMediaElement) return (e = r.localName) != null && e.includes("-") ? $299b6c40adc500b8$var$ee(r, n1.pictureInPictureElement) : !1;
            if (n1.pictureInPictureElement.localName.includes("-")) {
                let s = n1.pictureInPictureElement.shadowRoot;
                for(; s?.pictureInPictureElement;){
                    if (s.pictureInPictureElement === r) return !0;
                    s = (t = s.pictureInPictureElement) == null ? void 0 : t.shadowRoot;
                }
            }
            return !1;
        },
        set (i, e) {
            let { media: t } = e;
            if (t) {
                if (i) {
                    if (!$299b6c40adc500b8$var$F.pictureInPictureEnabled) {
                        console.warn("MediaChrome: Picture-in-picture is not enabled");
                        return;
                    }
                    if (!t.requestPictureInPicture) {
                        console.warn("MediaChrome: The current media does not support picture-in-picture");
                        return;
                    }
                    let r = ()=>{
                        console.warn("MediaChrome: The media is not ready for picture-in-picture. It must have a readyState > 0.");
                    };
                    t.requestPictureInPicture().catch((n1)=>{
                        if (n1.code === 11) {
                            if (!t.src) {
                                console.warn("MediaChrome: The media is not ready for picture-in-picture. It must have a src set.");
                                return;
                            }
                            if (t.readyState === 0 && t.preload === "none") {
                                let s = ()=>{
                                    t.removeEventListener("loadedmetadata", o), t.preload = "none";
                                }, o = ()=>{
                                    t.requestPictureInPicture().catch(r), s();
                                };
                                t.addEventListener("loadedmetadata", o), t.preload = "metadata", setTimeout(()=>{
                                    t.readyState === 0 && r(), s();
                                }, 1e3);
                            } else throw n1;
                        } else throw n1;
                    });
                } else $299b6c40adc500b8$var$F.pictureInPictureElement && $299b6c40adc500b8$var$F.exitPictureInPicture();
            }
        },
        mediaEvents: [
            "enterpictureinpicture",
            "leavepictureinpicture"
        ]
    },
    mediaRenditionList: {
        get (i) {
            var e;
            let { media: t } = i;
            return [
                ...(e = t?.videoRenditions) != null ? e : []
            ].map((r)=>({
                    ...r
                }));
        },
        mediaEvents: [
            "emptied",
            "loadstart"
        ],
        videoRenditionsEvents: [
            "addrendition",
            "removerendition"
        ]
    },
    mediaRenditionSelected: {
        get (i) {
            var e, t, r;
            let { media: n1 } = i;
            return (r = (t = n1?.videoRenditions) == null ? void 0 : t[(e = n1.videoRenditions) == null ? void 0 : e.selectedIndex]) == null ? void 0 : r.id;
        },
        set (i, e) {
            let { media: t } = e;
            if (!t?.videoRenditions) {
                console.warn("MediaController: Rendition selection not supported by this media.");
                return;
            }
            let r = i, n1 = Array.prototype.findIndex.call(t.videoRenditions, (s)=>s.id == r);
            t.videoRenditions.selectedIndex != n1 && (t.videoRenditions.selectedIndex = n1);
        },
        mediaEvents: [
            "emptied"
        ],
        videoRenditionsEvents: [
            "addrendition",
            "removerendition",
            "change"
        ]
    },
    mediaAudioTrackList: {
        get (i) {
            var e;
            let { media: t } = i;
            return [
                ...(e = t?.audioTracks) != null ? e : []
            ];
        },
        mediaEvents: [
            "emptied",
            "loadstart"
        ],
        audioTracksEvents: [
            "addtrack",
            "removetrack"
        ]
    },
    mediaAudioTrackEnabled: {
        get (i) {
            var e, t;
            let { media: r } = i;
            return (t = [
                ...(e = r?.audioTracks) != null ? e : []
            ].find((n1)=>n1.enabled)) == null ? void 0 : t.id;
        },
        set (i, e) {
            let { media: t } = e;
            if (!t?.audioTracks) {
                console.warn("MediaChrome: Audio track selection not supported by this media.");
                return;
            }
            let r = i;
            for (let n1 of t.audioTracks)n1.enabled = r == n1.id;
        },
        mediaEvents: [
            "emptied"
        ],
        audioTracksEvents: [
            "addtrack",
            "removetrack",
            "change"
        ]
    },
    mediaIsFullscreen: {
        get (i) {
            return $299b6c40adc500b8$var$bd(i);
        },
        set (i, e) {
            i ? $299b6c40adc500b8$var$Ed(e) : $299b6c40adc500b8$var$gd(e);
        },
        rootEvents: [
            "fullscreenchange",
            "webkitfullscreenchange"
        ],
        mediaEvents: [
            "webkitbeginfullscreen",
            "webkitendfullscreen",
            "webkitpresentationmodechanged"
        ]
    },
    mediaIsCasting: {
        get (i) {
            var e;
            let { media: t } = i;
            return !t?.remote || ((e = t.remote) == null ? void 0 : e.state) === "disconnected" ? !1 : !!t.remote.state;
        },
        set (i, e) {
            var t, r;
            let { media: n1 } = e;
            if (n1 && !(i && ((t = n1.remote) == null ? void 0 : t.state) !== "disconnected") && !(!i && ((r = n1.remote) == null ? void 0 : r.state) !== "connected")) {
                if (typeof n1.remote.prompt != "function") {
                    console.warn("MediaChrome: Casting is not supported in this environment");
                    return;
                }
                n1.remote.prompt().catch(()=>{});
            }
        },
        remoteEvents: [
            "connect",
            "connecting",
            "disconnect"
        ]
    },
    mediaIsAirplaying: {
        get () {
            return !1;
        },
        set (i, e) {
            let { media: t } = e;
            if (t) {
                if (!(t.webkitShowPlaybackTargetPicker && $299b6c40adc500b8$var$l.WebKitPlaybackTargetAvailabilityEvent)) {
                    console.error("MediaChrome: received a request to select AirPlay but AirPlay is not supported in this environment");
                    return;
                }
                t.webkitShowPlaybackTargetPicker();
            }
        },
        mediaEvents: [
            "webkitcurrentplaybacktargetiswirelesschanged"
        ]
    },
    mediaFullscreenUnavailable: {
        get (i) {
            let { media: e } = i;
            if (!$299b6c40adc500b8$var$Td || !$299b6c40adc500b8$var$Sa(e)) return $299b6c40adc500b8$var$re.UNSUPPORTED;
        }
    },
    mediaPipUnavailable: {
        get (i) {
            let { media: e } = i;
            if (!$299b6c40adc500b8$var$Ad || !$299b6c40adc500b8$var$Ia(e)) return $299b6c40adc500b8$var$re.UNSUPPORTED;
            if (e?.disablePictureInPicture) return $299b6c40adc500b8$var$re.UNAVAILABLE;
        }
    },
    mediaVolumeUnavailable: {
        get (i) {
            let { media: e } = i;
            if ($299b6c40adc500b8$var$Cn === !1 || e?.volume == null) return $299b6c40adc500b8$var$re.UNSUPPORTED;
        },
        stateOwnersUpdateHandlers: [
            (i)=>{
                $299b6c40adc500b8$var$Cn == null && $299b6c40adc500b8$var$Qc.then((e)=>i(e ? void 0 : $299b6c40adc500b8$var$re.UNSUPPORTED));
            }
        ]
    },
    mediaCastUnavailable: {
        get (i, { availability: e = "not-available" } = {}) {
            var t;
            let { media: r } = i;
            if (!$299b6c40adc500b8$var$kd || !((t = r?.remote) != null && t.state)) return $299b6c40adc500b8$var$re.UNSUPPORTED;
            if (!(e == null || e === "available")) return $299b6c40adc500b8$var$re.UNAVAILABLE;
        },
        stateOwnersUpdateHandlers: [
            (i, e)=>{
                var t;
                let { media: r } = e;
                return r ? (r.disableRemotePlayback || r.hasAttribute("disableremoteplayback") || (t = r?.remote) == null || t.watchAvailability((s)=>{
                    i({
                        availability: s ? "available" : "not-available"
                    });
                }).catch((s)=>{
                    s.name === "NotSupportedError" ? i({
                        availability: null
                    }) : i({
                        availability: "not-available"
                    });
                }), ()=>{
                    var s;
                    (s = r?.remote) == null || s.cancelWatchAvailability().catch(()=>{});
                }) : void 0;
            }
        ]
    },
    mediaAirplayUnavailable: {
        get (i, e) {
            if (!$299b6c40adc500b8$var$yd) return $299b6c40adc500b8$var$re.UNSUPPORTED;
            if (e?.availability === "not-available") return $299b6c40adc500b8$var$re.UNAVAILABLE;
        },
        mediaEvents: [
            "webkitplaybacktargetavailabilitychanged"
        ],
        stateOwnersUpdateHandlers: [
            (i, e)=>{
                var t;
                let { media: r } = e;
                return r ? (r.disableRemotePlayback || r.hasAttribute("disableremoteplayback") || (t = r?.remote) == null || t.watchAvailability((s)=>{
                    i({
                        availability: s ? "available" : "not-available"
                    });
                }).catch((s)=>{
                    s.name === "NotSupportedError" ? i({
                        availability: null
                    }) : i({
                        availability: "not-available"
                    });
                }), ()=>{
                    var s;
                    (s = r?.remote) == null || s.cancelWatchAvailability().catch(()=>{});
                }) : void 0;
            }
        ]
    },
    mediaRenditionUnavailable: {
        get (i) {
            var e;
            let { media: t } = i;
            if (!t?.videoRenditions) return $299b6c40adc500b8$var$re.UNSUPPORTED;
            if (!((e = t.videoRenditions) != null && e.length)) return $299b6c40adc500b8$var$re.UNAVAILABLE;
        },
        mediaEvents: [
            "emptied",
            "loadstart"
        ],
        videoRenditionsEvents: [
            "addrendition",
            "removerendition"
        ]
    },
    mediaAudioTrackUnavailable: {
        get (i) {
            var e, t;
            let { media: r } = i;
            if (!r?.audioTracks) return $299b6c40adc500b8$var$re.UNSUPPORTED;
            if (((t = (e = r.audioTracks) == null ? void 0 : e.length) != null ? t : 0) <= 1) return $299b6c40adc500b8$var$re.UNAVAILABLE;
        },
        mediaEvents: [
            "emptied",
            "loadstart"
        ],
        audioTracksEvents: [
            "addtrack",
            "removetrack"
        ]
    },
    mediaLang: {
        get (i) {
            let { options: { mediaLang: e } = {} } = i;
            return e ?? "en";
        }
    }
};
var $299b6c40adc500b8$var$Sd = {
    [$299b6c40adc500b8$var$h.MEDIA_PREVIEW_REQUEST] (i, e, { detail: t }) {
        var r, n1, s;
        let { media: o } = e, d = t ?? void 0, u, m;
        if (o && d != null) {
            let [E] = $299b6c40adc500b8$var$Lt(o, {
                kind: $299b6c40adc500b8$var$ie.METADATA,
                label: "thumbnails"
            }), R = Array.prototype.find.call((r = E?.cues) != null ? r : [], (k, S, V)=>S === 0 ? k.endTime > d : S === V.length - 1 ? k.startTime <= d : k.startTime <= d && k.endTime > d);
            if (R) {
                let k = /'^(?:[a-z]+:)?\/\//i.test(R.text) || (n1 = o?.querySelector('track[label="thumbnails"]')) == null ? void 0 : n1.src, S = new URL(R.text, k);
                m = new URLSearchParams(S.hash).get("#xywh").split(",").map((oe)=>+oe), u = S.href;
            }
        }
        let f = i.mediaDuration.get(e), v = (s = i.mediaChaptersCues.get(e).find((E, R, k)=>R === k.length - 1 && f === E.endTime ? E.startTime <= d && E.endTime >= d : E.startTime <= d && E.endTime > d)) == null ? void 0 : s.text;
        return t != null && v == null && (v = ""), {
            mediaPreviewTime: d,
            mediaPreviewImage: u,
            mediaPreviewCoords: m,
            mediaPreviewChapter: v
        };
    },
    [$299b6c40adc500b8$var$h.MEDIA_PAUSE_REQUEST] (i, e) {
        i["mediaPaused"].set(!0, e);
    },
    [$299b6c40adc500b8$var$h.MEDIA_PLAY_REQUEST] (i, e) {
        var t, r, n1, s;
        let o = "mediaPaused", u = i.mediaStreamType.get(e) === $299b6c40adc500b8$var$Te.LIVE, m = !((t = e.options) != null && t.noAutoSeekToLive), f = i.mediaTargetLiveWindow.get(e) > 0;
        if (u && m && !f) {
            let g = (r = i.mediaSeekable.get(e)) == null ? void 0 : r[1];
            if (g) {
                let v = (s = (n1 = e.options) == null ? void 0 : n1.seekToLiveOffset) != null ? s : 0, E = g - v;
                i.mediaCurrentTime.set(E, e);
            }
        }
        i[o].set(!1, e);
    },
    [$299b6c40adc500b8$var$h.MEDIA_PLAYBACK_RATE_REQUEST] (i, e, { detail: t }) {
        let r = "mediaPlaybackRate", n1 = t;
        i[r].set(n1, e);
    },
    [$299b6c40adc500b8$var$h.MEDIA_MUTE_REQUEST] (i, e) {
        i["mediaMuted"].set(!0, e);
    },
    [$299b6c40adc500b8$var$h.MEDIA_UNMUTE_REQUEST] (i, e) {
        let t = "mediaMuted";
        i.mediaVolume.get(e) || i.mediaVolume.set(.25, e), i[t].set(!1, e);
    },
    [$299b6c40adc500b8$var$h.MEDIA_VOLUME_REQUEST] (i, e, { detail: t }) {
        let r = "mediaVolume", n1 = t;
        n1 && i.mediaMuted.get(e) && i.mediaMuted.set(!1, e), i[r].set(n1, e);
    },
    [$299b6c40adc500b8$var$h.MEDIA_SEEK_REQUEST] (i, e, { detail: t }) {
        let r = "mediaCurrentTime", n1 = t;
        i[r].set(n1, e);
    },
    [$299b6c40adc500b8$var$h.MEDIA_SEEK_TO_LIVE_REQUEST] (i, e) {
        var t, r, n1;
        let s = "mediaCurrentTime", o = (t = i.mediaSeekable.get(e)) == null ? void 0 : t[1];
        if (Number.isNaN(Number(o))) return;
        let d = (n1 = (r = e.options) == null ? void 0 : r.seekToLiveOffset) != null ? n1 : 0, u = o - d;
        i[s].set(u, e);
    },
    [$299b6c40adc500b8$var$h.MEDIA_SHOW_SUBTITLES_REQUEST] (i, e, { detail: t }) {
        var r;
        let { options: n1 } = e, s = $299b6c40adc500b8$var$ai(e), o = $299b6c40adc500b8$var$ya(t), d = (r = o[0]) == null ? void 0 : r.language;
        d && !n1.noSubtitlesLangPref && $299b6c40adc500b8$var$l.localStorage.setItem("media-chrome-pref-subtitles-lang", d), $299b6c40adc500b8$var$Mt($299b6c40adc500b8$var$je.SHOWING, s, o);
    },
    [$299b6c40adc500b8$var$h.MEDIA_DISABLE_SUBTITLES_REQUEST] (i, e, { detail: t }) {
        let r = $299b6c40adc500b8$var$ai(e), n1 = t ?? [];
        $299b6c40adc500b8$var$Mt($299b6c40adc500b8$var$je.DISABLED, r, n1);
    },
    [$299b6c40adc500b8$var$h.MEDIA_TOGGLE_SUBTITLES_REQUEST] (i, e, { detail: t }) {
        $299b6c40adc500b8$var$Ln(e, t);
    },
    [$299b6c40adc500b8$var$h.MEDIA_RENDITION_REQUEST] (i, e, { detail: t }) {
        let r = "mediaRenditionSelected", n1 = t;
        i[r].set(n1, e);
    },
    [$299b6c40adc500b8$var$h.MEDIA_AUDIO_TRACK_REQUEST] (i, e, { detail: t }) {
        let r = "mediaAudioTrackEnabled", n1 = t;
        i[r].set(n1, e);
    },
    [$299b6c40adc500b8$var$h.MEDIA_ENTER_PIP_REQUEST] (i, e) {
        let t = "mediaIsPip";
        i.mediaIsFullscreen.get(e) && i.mediaIsFullscreen.set(!1, e), i[t].set(!0, e);
    },
    [$299b6c40adc500b8$var$h.MEDIA_EXIT_PIP_REQUEST] (i, e) {
        i["mediaIsPip"].set(!1, e);
    },
    [$299b6c40adc500b8$var$h.MEDIA_ENTER_FULLSCREEN_REQUEST] (i, e) {
        let t = "mediaIsFullscreen";
        i.mediaIsPip.get(e) && i.mediaIsPip.set(!1, e), i[t].set(!0, e);
    },
    [$299b6c40adc500b8$var$h.MEDIA_EXIT_FULLSCREEN_REQUEST] (i, e) {
        i["mediaIsFullscreen"].set(!1, e);
    },
    [$299b6c40adc500b8$var$h.MEDIA_ENTER_CAST_REQUEST] (i, e) {
        let t = "mediaIsCasting";
        i.mediaIsFullscreen.get(e) && i.mediaIsFullscreen.set(!1, e), i[t].set(!0, e);
    },
    [$299b6c40adc500b8$var$h.MEDIA_EXIT_CAST_REQUEST] (i, e) {
        i["mediaIsCasting"].set(!1, e);
    },
    [$299b6c40adc500b8$var$h.MEDIA_AIRPLAY_REQUEST] (i, e) {
        i["mediaIsAirplaying"].set(!0, e);
    }
};
var $299b6c40adc500b8$var$Md = ({ media: i, fullscreenElement: e, documentElement: t, stateMediator: r = $299b6c40adc500b8$var$oi, requestMap: n1 = $299b6c40adc500b8$var$Sd, options: s = {}, monitorStateOwnersOnlyWithSubscriptions: o = !0 })=>{
    let d = [], u = {
        options: {
            ...s
        }
    }, m = Object.freeze({
        mediaPreviewTime: void 0,
        mediaPreviewImage: void 0,
        mediaPreviewCoords: void 0,
        mediaPreviewChapter: void 0
    }), f = (k)=>{
        k != null && ($299b6c40adc500b8$var$wn(k, m) || (m = Object.freeze({
            ...m,
            ...k
        }), d.forEach((S)=>S(m))));
    }, g = ()=>{
        let k = Object.entries(r).reduce((S, [V, { get: oe }])=>(S[V] = oe(u), S), {});
        f(k);
    }, v = {}, E, R = async (k, S)=>{
        var V, oe, Me, Oi, Bt, Jo, jo, el, tl, il, rl, nl, sl, al, ol, ll;
        let Zu = !!E;
        if (E = {
            ...u,
            ...E ?? {},
            ...k
        }, Zu) return;
        await $299b6c40adc500b8$var$Id(...Object.values(k));
        let $t = d.length > 0 && S === 0 && o, dl = u.media !== E.media, ul = ((V = u.media) == null ? void 0 : V.textTracks) !== ((oe = E.media) == null ? void 0 : oe.textTracks), cl = ((Me = u.media) == null ? void 0 : Me.videoRenditions) !== ((Oi = E.media) == null ? void 0 : Oi.videoRenditions), hl = ((Bt = u.media) == null ? void 0 : Bt.audioTracks) !== ((Jo = E.media) == null ? void 0 : Jo.audioTracks), ml = ((jo = u.media) == null ? void 0 : jo.remote) !== ((el = E.media) == null ? void 0 : el.remote), pl = u.documentElement !== E.documentElement, vl = !!u.media && (dl || $t), El = !!((tl = u.media) != null && tl.textTracks) && (ul || $t), gl = !!((il = u.media) != null && il.videoRenditions) && (cl || $t), bl = !!((rl = u.media) != null && rl.audioTracks) && (hl || $t), fl = !!((nl = u.media) != null && nl.remote) && (ml || $t), _l = !!u.documentElement && (pl || $t), Tl = vl || El || gl || bl || fl || _l, Gt = d.length === 0 && S === 1 && o, Al = !!E.media && (dl || Gt), yl = !!((sl = E.media) != null && sl.textTracks) && (ul || Gt), kl = !!((al = E.media) != null && al.videoRenditions) && (cl || Gt), Il = !!((ol = E.media) != null && ol.audioTracks) && (hl || Gt), Sl = !!((ll = E.media) != null && ll.remote) && (ml || Gt), Ml = !!E.documentElement && (pl || Gt), Ll = Al || yl || kl || Il || Sl || Ml;
        if (!(Tl || Ll)) {
            Object.entries(E).forEach(([H, xi])=>{
                u[H] = xi;
            }), g(), E = void 0;
            return;
        }
        Object.entries(r).forEach(([H, { get: xi, mediaEvents: Qu = [], textTracksEvents: zu = [], videoRenditionsEvents: Xu = [], audioTracksEvents: Ju = [], remoteEvents: ju = [], rootEvents: ec = [], stateOwnersUpdateHandlers: tc = [] }])=>{
            v[H] || (v[H] = {});
            let le = ($)=>{
                let de = xi(u, $);
                f({
                    [H]: de
                });
            }, Z;
            Z = v[H].mediaEvents, Qu.forEach(($)=>{
                Z && vl && (u.media.removeEventListener($, Z), v[H].mediaEvents = void 0), Al && (E.media.addEventListener($, le), v[H].mediaEvents = le);
            }), Z = v[H].textTracksEvents, zu.forEach(($)=>{
                var de, _e;
                Z && El && ((de = u.media.textTracks) == null || de.removeEventListener($, Z), v[H].textTracksEvents = void 0), yl && ((_e = E.media.textTracks) == null || _e.addEventListener($, le), v[H].textTracksEvents = le);
            }), Z = v[H].videoRenditionsEvents, Xu.forEach(($)=>{
                var de, _e;
                Z && gl && ((de = u.media.videoRenditions) == null || de.removeEventListener($, Z), v[H].videoRenditionsEvents = void 0), kl && ((_e = E.media.videoRenditions) == null || _e.addEventListener($, le), v[H].videoRenditionsEvents = le);
            }), Z = v[H].audioTracksEvents, Ju.forEach(($)=>{
                var de, _e;
                Z && bl && ((de = u.media.audioTracks) == null || de.removeEventListener($, Z), v[H].audioTracksEvents = void 0), Il && ((_e = E.media.audioTracks) == null || _e.addEventListener($, le), v[H].audioTracksEvents = le);
            }), Z = v[H].remoteEvents, ju.forEach(($)=>{
                var de, _e;
                Z && fl && ((de = u.media.remote) == null || de.removeEventListener($, Z), v[H].remoteEvents = void 0), Sl && ((_e = E.media.remote) == null || _e.addEventListener($, le), v[H].remoteEvents = le);
            }), Z = v[H].rootEvents, ec.forEach(($)=>{
                Z && _l && (u.documentElement.removeEventListener($, Z), v[H].rootEvents = void 0), Ml && (E.documentElement.addEventListener($, le), v[H].rootEvents = le);
            });
            let wl = v[H].stateOwnersUpdateHandlers;
            tc.forEach(($)=>{
                wl && Tl && wl(), Ll && (v[H].stateOwnersUpdateHandlers = $(le, E));
            });
        }), Object.entries(E).forEach(([H, xi])=>{
            u[H] = xi;
        }), g(), E = void 0;
    };
    return R({
        media: i,
        fullscreenElement: e,
        documentElement: t,
        options: s
    }), {
        dispatch (k) {
            let { type: S, detail: V } = k;
            if (n1[S] && m.mediaErrorCode == null) {
                f(n1[S](r, u, k));
                return;
            }
            S === "mediaelementchangerequest" ? R({
                media: V
            }) : S === "fullscreenelementchangerequest" ? R({
                fullscreenElement: V
            }) : S === "documentelementchangerequest" ? R({
                documentElement: V
            }) : S === "optionschangerequest" && (Object.entries(V ?? {}).forEach(([oe, Me])=>{
                u.options[oe] = Me;
            }), g());
        },
        getState () {
            return m;
        },
        subscribe (k) {
            return R({}, d.length + 1), d.push(k), k(m), ()=>{
                let S = d.indexOf(k);
                S >= 0 && (R({}, d.length - 1), d.splice(S, 1));
            };
        }
    };
};
var $299b6c40adc500b8$var$Pa = (i, e, t)=>{
    if (!e.has(i)) throw TypeError("Cannot " + t);
}, $299b6c40adc500b8$var$L = (i, e, t)=>($299b6c40adc500b8$var$Pa(i, e, "read from private field"), t ? t.call(i) : e.get(i)), $299b6c40adc500b8$var$ze = (i, e, t)=>{
    if (e.has(i)) throw TypeError("Cannot add the same private member more than once");
    e instanceof WeakSet ? e.add(i) : e.set(i, t);
}, $299b6c40adc500b8$var$ot = (i, e, t, r)=>($299b6c40adc500b8$var$Pa(i, e, "write to private field"), r ? r.call(i, t) : e.set(i, t), t), $299b6c40adc500b8$var$lt = (i, e, t)=>($299b6c40adc500b8$var$Pa(i, e, "access private method"), t), $299b6c40adc500b8$var$Ct, $299b6c40adc500b8$var$zi, $299b6c40adc500b8$var$U, $299b6c40adc500b8$var$Xi, $299b6c40adc500b8$var$De, $299b6c40adc500b8$var$Rn, $299b6c40adc500b8$var$Pn, $299b6c40adc500b8$var$La, $299b6c40adc500b8$var$li, $299b6c40adc500b8$var$Ji, $299b6c40adc500b8$var$Dn, $299b6c40adc500b8$var$wa, $299b6c40adc500b8$var$Pd = [
    "ArrowLeft",
    "ArrowRight",
    "Enter",
    " ",
    "f",
    "m",
    "k",
    "c"
], $299b6c40adc500b8$var$Ld = 10, $299b6c40adc500b8$var$p = {
    DEFAULT_SUBTITLES: "defaultsubtitles",
    DEFAULT_STREAM_TYPE: "defaultstreamtype",
    DEFAULT_DURATION: "defaultduration",
    FULLSCREEN_ELEMENT: "fullscreenelement",
    HOTKEYS: "hotkeys",
    KEYS_USED: "keysused",
    LIVE_EDGE_OFFSET: "liveedgeoffset",
    SEEK_TO_LIVE_OFFSET: "seektoliveoffset",
    NO_AUTO_SEEK_TO_LIVE: "noautoseektolive",
    NO_HOTKEYS: "nohotkeys",
    NO_VOLUME_PREF: "novolumepref",
    NO_MUTED_PREF: "nomutedpref",
    NO_SUBTITLES_LANG_PREF: "nosubtitleslangpref",
    NO_DEFAULT_STORE: "nodefaultstore",
    KEYBOARD_FORWARD_SEEK_OFFSET: "keyboardforwardseekoffset",
    KEYBOARD_BACKWARD_SEEK_OFFSET: "keyboardbackwardseekoffset",
    LANG: "lang"
}, $299b6c40adc500b8$var$Ca = class extends $299b6c40adc500b8$var$kt {
    constructor(){
        super(), $299b6c40adc500b8$var$ze(this, $299b6c40adc500b8$var$Pn), $299b6c40adc500b8$var$ze(this, $299b6c40adc500b8$var$li), $299b6c40adc500b8$var$ze(this, $299b6c40adc500b8$var$Dn), this.mediaStateReceivers = [], this.associatedElementSubscriptions = new Map, $299b6c40adc500b8$var$ze(this, $299b6c40adc500b8$var$Ct, new $299b6c40adc500b8$var$at(this, $299b6c40adc500b8$var$p.HOTKEYS)), $299b6c40adc500b8$var$ze(this, $299b6c40adc500b8$var$zi, void 0), $299b6c40adc500b8$var$ze(this, $299b6c40adc500b8$var$U, void 0), $299b6c40adc500b8$var$ze(this, $299b6c40adc500b8$var$Xi, void 0), $299b6c40adc500b8$var$ze(this, $299b6c40adc500b8$var$De, void 0), $299b6c40adc500b8$var$ze(this, $299b6c40adc500b8$var$Rn, (t)=>{
            var r;
            (r = $299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$U)) == null || r.dispatch(t);
        }), this.associateElement(this);
        let e = {};
        $299b6c40adc500b8$var$ot(this, $299b6c40adc500b8$var$Xi, (t)=>{
            Object.entries(t).forEach(([r, n1])=>{
                if (r in e && e[r] === n1) return;
                this.propagateMediaState(r, n1);
                let s = r.toLowerCase(), o = new $299b6c40adc500b8$var$l.CustomEvent($299b6c40adc500b8$var$Ol[s], {
                    composed: !0,
                    detail: n1
                });
                this.dispatchEvent(o);
            }), e = t;
        }), this.hasAttribute($299b6c40adc500b8$var$p.NO_HOTKEYS) ? this.disableHotkeys() : this.enableHotkeys();
    }
    static get observedAttributes() {
        return super.observedAttributes.concat($299b6c40adc500b8$var$p.NO_HOTKEYS, $299b6c40adc500b8$var$p.HOTKEYS, $299b6c40adc500b8$var$p.DEFAULT_STREAM_TYPE, $299b6c40adc500b8$var$p.DEFAULT_SUBTITLES, $299b6c40adc500b8$var$p.DEFAULT_DURATION, $299b6c40adc500b8$var$p.LANG);
    }
    get mediaStore() {
        return $299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$U);
    }
    set mediaStore(e) {
        var t, r;
        if ($299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$U) && ((t = $299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$De)) == null || t.call(this), $299b6c40adc500b8$var$ot(this, $299b6c40adc500b8$var$De, void 0)), $299b6c40adc500b8$var$ot(this, $299b6c40adc500b8$var$U, e), !$299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$U) && !this.hasAttribute($299b6c40adc500b8$var$p.NO_DEFAULT_STORE)) {
            $299b6c40adc500b8$var$lt(this, $299b6c40adc500b8$var$Pn, $299b6c40adc500b8$var$La).call(this);
            return;
        }
        $299b6c40adc500b8$var$ot(this, $299b6c40adc500b8$var$De, (r = $299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$U)) == null ? void 0 : r.subscribe($299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$Xi)));
    }
    get fullscreenElement() {
        var e;
        return (e = $299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$zi)) != null ? e : this;
    }
    set fullscreenElement(e) {
        var t;
        this.hasAttribute($299b6c40adc500b8$var$p.FULLSCREEN_ELEMENT) && this.removeAttribute($299b6c40adc500b8$var$p.FULLSCREEN_ELEMENT), $299b6c40adc500b8$var$ot(this, $299b6c40adc500b8$var$zi, e), (t = $299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$U)) == null || t.dispatch({
            type: "fullscreenelementchangerequest",
            detail: this.fullscreenElement
        });
    }
    get defaultSubtitles() {
        return $299b6c40adc500b8$var$A(this, $299b6c40adc500b8$var$p.DEFAULT_SUBTITLES);
    }
    set defaultSubtitles(e) {
        $299b6c40adc500b8$var$y(this, $299b6c40adc500b8$var$p.DEFAULT_SUBTITLES, e);
    }
    get defaultStreamType() {
        return $299b6c40adc500b8$var$_(this, $299b6c40adc500b8$var$p.DEFAULT_STREAM_TYPE);
    }
    set defaultStreamType(e) {
        $299b6c40adc500b8$var$b(this, $299b6c40adc500b8$var$p.DEFAULT_STREAM_TYPE, e);
    }
    get defaultDuration() {
        return $299b6c40adc500b8$var$M(this, $299b6c40adc500b8$var$p.DEFAULT_DURATION);
    }
    set defaultDuration(e) {
        $299b6c40adc500b8$var$w(this, $299b6c40adc500b8$var$p.DEFAULT_DURATION, e);
    }
    get noHotkeys() {
        return $299b6c40adc500b8$var$A(this, $299b6c40adc500b8$var$p.NO_HOTKEYS);
    }
    set noHotkeys(e) {
        $299b6c40adc500b8$var$y(this, $299b6c40adc500b8$var$p.NO_HOTKEYS, e);
    }
    get keysUsed() {
        return $299b6c40adc500b8$var$_(this, $299b6c40adc500b8$var$p.KEYS_USED);
    }
    set keysUsed(e) {
        $299b6c40adc500b8$var$b(this, $299b6c40adc500b8$var$p.KEYS_USED, e);
    }
    get liveEdgeOffset() {
        return $299b6c40adc500b8$var$M(this, $299b6c40adc500b8$var$p.LIVE_EDGE_OFFSET);
    }
    set liveEdgeOffset(e) {
        $299b6c40adc500b8$var$w(this, $299b6c40adc500b8$var$p.LIVE_EDGE_OFFSET, e);
    }
    get noAutoSeekToLive() {
        return $299b6c40adc500b8$var$A(this, $299b6c40adc500b8$var$p.NO_AUTO_SEEK_TO_LIVE);
    }
    set noAutoSeekToLive(e) {
        $299b6c40adc500b8$var$y(this, $299b6c40adc500b8$var$p.NO_AUTO_SEEK_TO_LIVE, e);
    }
    get noVolumePref() {
        return $299b6c40adc500b8$var$A(this, $299b6c40adc500b8$var$p.NO_VOLUME_PREF);
    }
    set noVolumePref(e) {
        $299b6c40adc500b8$var$y(this, $299b6c40adc500b8$var$p.NO_VOLUME_PREF, e);
    }
    get noMutedPref() {
        return $299b6c40adc500b8$var$A(this, $299b6c40adc500b8$var$p.NO_MUTED_PREF);
    }
    set noMutedPref(e) {
        $299b6c40adc500b8$var$y(this, $299b6c40adc500b8$var$p.NO_MUTED_PREF, e);
    }
    get noSubtitlesLangPref() {
        return $299b6c40adc500b8$var$A(this, $299b6c40adc500b8$var$p.NO_SUBTITLES_LANG_PREF);
    }
    set noSubtitlesLangPref(e) {
        $299b6c40adc500b8$var$y(this, $299b6c40adc500b8$var$p.NO_SUBTITLES_LANG_PREF, e);
    }
    get noDefaultStore() {
        return $299b6c40adc500b8$var$A(this, $299b6c40adc500b8$var$p.NO_DEFAULT_STORE);
    }
    set noDefaultStore(e) {
        $299b6c40adc500b8$var$y(this, $299b6c40adc500b8$var$p.NO_DEFAULT_STORE, e);
    }
    attributeChangedCallback(e, t, r) {
        var n1, s, o, d, u, m, f, g, v;
        if (super.attributeChangedCallback(e, t, r), e === $299b6c40adc500b8$var$p.NO_HOTKEYS) r !== t && r === "" ? (this.hasAttribute($299b6c40adc500b8$var$p.HOTKEYS) && console.warn("Media Chrome: Both `hotkeys` and `nohotkeys` have been set. All hotkeys will be disabled."), this.disableHotkeys()) : r !== t && r === null && this.enableHotkeys();
        else if (e === $299b6c40adc500b8$var$p.HOTKEYS) $299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$Ct).value = r;
        else if (e === $299b6c40adc500b8$var$p.DEFAULT_SUBTITLES && r !== t) (n1 = $299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$U)) == null || n1.dispatch({
            type: "optionschangerequest",
            detail: {
                defaultSubtitles: this.hasAttribute($299b6c40adc500b8$var$p.DEFAULT_SUBTITLES)
            }
        });
        else if (e === $299b6c40adc500b8$var$p.DEFAULT_STREAM_TYPE) (o = $299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$U)) == null || o.dispatch({
            type: "optionschangerequest",
            detail: {
                defaultStreamType: (s = this.getAttribute($299b6c40adc500b8$var$p.DEFAULT_STREAM_TYPE)) != null ? s : void 0
            }
        });
        else if (e === $299b6c40adc500b8$var$p.LIVE_EDGE_OFFSET) (d = $299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$U)) == null || d.dispatch({
            type: "optionschangerequest",
            detail: {
                liveEdgeOffset: this.hasAttribute($299b6c40adc500b8$var$p.LIVE_EDGE_OFFSET) ? +this.getAttribute($299b6c40adc500b8$var$p.LIVE_EDGE_OFFSET) : void 0,
                seekToLiveOffset: this.hasAttribute($299b6c40adc500b8$var$p.SEEK_TO_LIVE_OFFSET) ? void 0 : +this.getAttribute($299b6c40adc500b8$var$p.LIVE_EDGE_OFFSET)
            }
        });
        else if (e === $299b6c40adc500b8$var$p.SEEK_TO_LIVE_OFFSET) (u = $299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$U)) == null || u.dispatch({
            type: "optionschangerequest",
            detail: {
                seekToLiveOffset: this.hasAttribute($299b6c40adc500b8$var$p.SEEK_TO_LIVE_OFFSET) ? +this.getAttribute($299b6c40adc500b8$var$p.SEEK_TO_LIVE_OFFSET) : void 0
            }
        });
        else if (e === $299b6c40adc500b8$var$p.NO_AUTO_SEEK_TO_LIVE) (m = $299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$U)) == null || m.dispatch({
            type: "optionschangerequest",
            detail: {
                noAutoSeekToLive: this.hasAttribute($299b6c40adc500b8$var$p.NO_AUTO_SEEK_TO_LIVE)
            }
        });
        else if (e === $299b6c40adc500b8$var$p.FULLSCREEN_ELEMENT) {
            let E = r ? (f = this.getRootNode()) == null ? void 0 : f.getElementById(r) : void 0;
            $299b6c40adc500b8$var$ot(this, $299b6c40adc500b8$var$zi, E), (g = $299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$U)) == null || g.dispatch({
                type: "fullscreenelementchangerequest",
                detail: this.fullscreenElement
            });
        } else e === $299b6c40adc500b8$var$p.LANG && r !== t && ($299b6c40adc500b8$var$ad(r), (v = $299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$U)) == null || v.dispatch({
            type: "optionschangerequest",
            detail: {
                mediaLang: r
            }
        }));
    }
    connectedCallback() {
        var e, t;
        !$299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$U) && !this.hasAttribute($299b6c40adc500b8$var$p.NO_DEFAULT_STORE) && $299b6c40adc500b8$var$lt(this, $299b6c40adc500b8$var$Pn, $299b6c40adc500b8$var$La).call(this), (e = $299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$U)) == null || e.dispatch({
            type: "documentelementchangerequest",
            detail: $299b6c40adc500b8$var$F
        }), super.connectedCallback(), $299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$U) && !$299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$De) && $299b6c40adc500b8$var$ot(this, $299b6c40adc500b8$var$De, (t = $299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$U)) == null ? void 0 : t.subscribe($299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$Xi))), this.hasAttribute($299b6c40adc500b8$var$p.NO_HOTKEYS) ? this.disableHotkeys() : this.enableHotkeys();
    }
    disconnectedCallback() {
        var e, t, r, n1;
        (e = super.disconnectedCallback) == null || e.call(this), $299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$U) && ((t = $299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$U)) == null || t.dispatch({
            type: "documentelementchangerequest",
            detail: void 0
        }), (r = $299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$U)) == null || r.dispatch({
            type: $299b6c40adc500b8$var$h.MEDIA_TOGGLE_SUBTITLES_REQUEST,
            detail: !1
        })), $299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$De) && ((n1 = $299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$De)) == null || n1.call(this), $299b6c40adc500b8$var$ot(this, $299b6c40adc500b8$var$De, void 0));
    }
    mediaSetCallback(e) {
        var t;
        super.mediaSetCallback(e), (t = $299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$U)) == null || t.dispatch({
            type: "mediaelementchangerequest",
            detail: e
        }), e.hasAttribute("tabindex") || (e.tabIndex = -1);
    }
    mediaUnsetCallback(e) {
        var t;
        super.mediaUnsetCallback(e), (t = $299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$U)) == null || t.dispatch({
            type: "mediaelementchangerequest",
            detail: void 0
        });
    }
    propagateMediaState(e, t) {
        $299b6c40adc500b8$var$Rd(this.mediaStateReceivers, e, t);
    }
    associateElement(e) {
        if (!e) return;
        let { associatedElementSubscriptions: t } = this;
        if (t.has(e)) return;
        let r = this.registerMediaStateReceiver.bind(this), n1 = this.unregisterMediaStateReceiver.bind(this), s = $299b6c40adc500b8$var$rh(e, r, n1);
        Object.values($299b6c40adc500b8$var$h).forEach((o)=>{
            e.addEventListener(o, $299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$Rn));
        }), t.set(e, s);
    }
    unassociateElement(e) {
        if (!e) return;
        let { associatedElementSubscriptions: t } = this;
        if (!t.has(e)) return;
        t.get(e)(), t.delete(e), Object.values($299b6c40adc500b8$var$h).forEach((n1)=>{
            e.removeEventListener(n1, $299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$Rn));
        });
    }
    registerMediaStateReceiver(e) {
        if (!e) return;
        let t = this.mediaStateReceivers;
        t.indexOf(e) > -1 || (t.push(e), $299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$U) && Object.entries($299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$U).getState()).forEach(([n1, s])=>{
            $299b6c40adc500b8$var$Rd([
                e
            ], n1, s);
        }));
    }
    unregisterMediaStateReceiver(e) {
        let t = this.mediaStateReceivers, r = t.indexOf(e);
        r < 0 || t.splice(r, 1);
    }
    enableHotkeys() {
        this.addEventListener("keydown", $299b6c40adc500b8$var$lt(this, $299b6c40adc500b8$var$Dn, $299b6c40adc500b8$var$wa));
    }
    disableHotkeys() {
        this.removeEventListener("keydown", $299b6c40adc500b8$var$lt(this, $299b6c40adc500b8$var$Dn, $299b6c40adc500b8$var$wa)), this.removeEventListener("keyup", $299b6c40adc500b8$var$lt(this, $299b6c40adc500b8$var$li, $299b6c40adc500b8$var$Ji));
    }
    get hotkeys() {
        return $299b6c40adc500b8$var$_(this, $299b6c40adc500b8$var$p.HOTKEYS);
    }
    set hotkeys(e) {
        $299b6c40adc500b8$var$b(this, $299b6c40adc500b8$var$p.HOTKEYS, e);
    }
    keyboardShortcutHandler(e) {
        var t, r, n1, s, o;
        let d = e.target;
        if (((n1 = (r = (t = d.getAttribute($299b6c40adc500b8$var$p.KEYS_USED)) == null ? void 0 : t.split(" ")) != null ? r : d?.keysUsed) != null ? n1 : []).map((v)=>v === "Space" ? " " : v).filter(Boolean).includes(e.key)) return;
        let m, f, g;
        if (!$299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$Ct).contains(`no${e.key.toLowerCase()}`) && !(e.key === " " && $299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$Ct).contains("nospace"))) switch(e.key){
            case " ":
            case "k":
                m = $299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$U).getState().mediaPaused ? $299b6c40adc500b8$var$h.MEDIA_PLAY_REQUEST : $299b6c40adc500b8$var$h.MEDIA_PAUSE_REQUEST, this.dispatchEvent(new $299b6c40adc500b8$var$l.CustomEvent(m, {
                    composed: !0,
                    bubbles: !0
                }));
                break;
            case "m":
                m = this.mediaStore.getState().mediaVolumeLevel === "off" ? $299b6c40adc500b8$var$h.MEDIA_UNMUTE_REQUEST : $299b6c40adc500b8$var$h.MEDIA_MUTE_REQUEST, this.dispatchEvent(new $299b6c40adc500b8$var$l.CustomEvent(m, {
                    composed: !0,
                    bubbles: !0
                }));
                break;
            case "f":
                m = this.mediaStore.getState().mediaIsFullscreen ? $299b6c40adc500b8$var$h.MEDIA_EXIT_FULLSCREEN_REQUEST : $299b6c40adc500b8$var$h.MEDIA_ENTER_FULLSCREEN_REQUEST, this.dispatchEvent(new $299b6c40adc500b8$var$l.CustomEvent(m, {
                    composed: !0,
                    bubbles: !0
                }));
                break;
            case "c":
                this.dispatchEvent(new $299b6c40adc500b8$var$l.CustomEvent($299b6c40adc500b8$var$h.MEDIA_TOGGLE_SUBTITLES_REQUEST, {
                    composed: !0,
                    bubbles: !0
                }));
                break;
            case "ArrowLeft":
                {
                    let v = this.hasAttribute($299b6c40adc500b8$var$p.KEYBOARD_BACKWARD_SEEK_OFFSET) ? +this.getAttribute($299b6c40adc500b8$var$p.KEYBOARD_BACKWARD_SEEK_OFFSET) : $299b6c40adc500b8$var$Ld;
                    f = Math.max(((s = this.mediaStore.getState().mediaCurrentTime) != null ? s : 0) - v, 0), g = new $299b6c40adc500b8$var$l.CustomEvent($299b6c40adc500b8$var$h.MEDIA_SEEK_REQUEST, {
                        composed: !0,
                        bubbles: !0,
                        detail: f
                    }), this.dispatchEvent(g);
                    break;
                }
            case "ArrowRight":
                {
                    let v = this.hasAttribute($299b6c40adc500b8$var$p.KEYBOARD_FORWARD_SEEK_OFFSET) ? +this.getAttribute($299b6c40adc500b8$var$p.KEYBOARD_FORWARD_SEEK_OFFSET) : $299b6c40adc500b8$var$Ld;
                    f = Math.max(((o = this.mediaStore.getState().mediaCurrentTime) != null ? o : 0) + v, 0), g = new $299b6c40adc500b8$var$l.CustomEvent($299b6c40adc500b8$var$h.MEDIA_SEEK_REQUEST, {
                        composed: !0,
                        bubbles: !0,
                        detail: f
                    }), this.dispatchEvent(g);
                    break;
                }
            default:
                break;
        }
    }
};
$299b6c40adc500b8$var$Ct = new WeakMap;
$299b6c40adc500b8$var$zi = new WeakMap;
$299b6c40adc500b8$var$U = new WeakMap;
$299b6c40adc500b8$var$Xi = new WeakMap;
$299b6c40adc500b8$var$De = new WeakMap;
$299b6c40adc500b8$var$Rn = new WeakMap;
$299b6c40adc500b8$var$Pn = new WeakSet;
$299b6c40adc500b8$var$La = function() {
    var i;
    this.mediaStore = $299b6c40adc500b8$var$Md({
        media: this.media,
        fullscreenElement: this.fullscreenElement,
        options: {
            defaultSubtitles: this.hasAttribute($299b6c40adc500b8$var$p.DEFAULT_SUBTITLES),
            defaultDuration: this.hasAttribute($299b6c40adc500b8$var$p.DEFAULT_DURATION) ? +this.getAttribute($299b6c40adc500b8$var$p.DEFAULT_DURATION) : void 0,
            defaultStreamType: (i = this.getAttribute($299b6c40adc500b8$var$p.DEFAULT_STREAM_TYPE)) != null ? i : void 0,
            liveEdgeOffset: this.hasAttribute($299b6c40adc500b8$var$p.LIVE_EDGE_OFFSET) ? +this.getAttribute($299b6c40adc500b8$var$p.LIVE_EDGE_OFFSET) : void 0,
            seekToLiveOffset: this.hasAttribute($299b6c40adc500b8$var$p.SEEK_TO_LIVE_OFFSET) ? +this.getAttribute($299b6c40adc500b8$var$p.SEEK_TO_LIVE_OFFSET) : this.hasAttribute($299b6c40adc500b8$var$p.LIVE_EDGE_OFFSET) ? +this.getAttribute($299b6c40adc500b8$var$p.LIVE_EDGE_OFFSET) : void 0,
            noAutoSeekToLive: this.hasAttribute($299b6c40adc500b8$var$p.NO_AUTO_SEEK_TO_LIVE),
            noVolumePref: this.hasAttribute($299b6c40adc500b8$var$p.NO_VOLUME_PREF),
            noMutedPref: this.hasAttribute($299b6c40adc500b8$var$p.NO_MUTED_PREF),
            noSubtitlesLangPref: this.hasAttribute($299b6c40adc500b8$var$p.NO_SUBTITLES_LANG_PREF)
        }
    });
};
$299b6c40adc500b8$var$li = new WeakSet;
$299b6c40adc500b8$var$Ji = function(i) {
    let { key: e } = i;
    if (!$299b6c40adc500b8$var$Pd.includes(e)) {
        this.removeEventListener("keyup", $299b6c40adc500b8$var$lt(this, $299b6c40adc500b8$var$li, $299b6c40adc500b8$var$Ji));
        return;
    }
    this.keyboardShortcutHandler(i);
};
$299b6c40adc500b8$var$Dn = new WeakSet;
$299b6c40adc500b8$var$wa = function(i) {
    let { metaKey: e, altKey: t, key: r } = i;
    if (e || t || !$299b6c40adc500b8$var$Pd.includes(r)) {
        this.removeEventListener("keyup", $299b6c40adc500b8$var$lt(this, $299b6c40adc500b8$var$li, $299b6c40adc500b8$var$Ji));
        return;
    }
    [
        " ",
        "ArrowLeft",
        "ArrowRight"
    ].includes(r) && !($299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$Ct).contains(`no${r.toLowerCase()}`) || r === " " && $299b6c40adc500b8$var$L(this, $299b6c40adc500b8$var$Ct).contains("nospace")) && i.preventDefault(), this.addEventListener("keyup", $299b6c40adc500b8$var$lt(this, $299b6c40adc500b8$var$li, $299b6c40adc500b8$var$Ji), {
        once: !0
    });
};
var $299b6c40adc500b8$var$Jc = Object.values($299b6c40adc500b8$var$a), $299b6c40adc500b8$var$jc = Object.values($299b6c40adc500b8$var$qs), $299b6c40adc500b8$var$Dd = (i)=>{
    var e, t, r, n1;
    let { observedAttributes: s } = i.constructor;
    !s && (e = i.nodeName) != null && e.includes("-") && ($299b6c40adc500b8$var$l.customElements.upgrade(i), { observedAttributes: s } = i.constructor);
    let o = (n1 = (r = (t = i?.getAttribute) == null ? void 0 : t.call(i, $299b6c40adc500b8$var$I.MEDIA_CHROME_ATTRIBUTES)) == null ? void 0 : r.split) == null ? void 0 : n1.call(r, /\s+/);
    return Array.isArray(s || o) ? (s || o).filter((d)=>$299b6c40adc500b8$var$Jc.includes(d)) : [];
}, $299b6c40adc500b8$var$eh = (i)=>{
    var e, t;
    return (e = i.nodeName) != null && e.includes("-") && $299b6c40adc500b8$var$l.customElements.get((t = i.nodeName) == null ? void 0 : t.toLowerCase()) && !(i instanceof $299b6c40adc500b8$var$l.customElements.get(i.nodeName.toLowerCase())) && $299b6c40adc500b8$var$l.customElements.upgrade(i), $299b6c40adc500b8$var$jc.some((r)=>r in i);
}, $299b6c40adc500b8$var$Ra = (i)=>$299b6c40adc500b8$var$eh(i) || !!$299b6c40adc500b8$var$Dd(i).length, $299b6c40adc500b8$var$wd = (i)=>{
    var e;
    return (e = i?.join) == null ? void 0 : e.call(i, ":");
}, $299b6c40adc500b8$var$Cd = {
    [$299b6c40adc500b8$var$a.MEDIA_SUBTITLES_LIST]: $299b6c40adc500b8$var$Qe,
    [$299b6c40adc500b8$var$a.MEDIA_SUBTITLES_SHOWING]: $299b6c40adc500b8$var$Qe,
    [$299b6c40adc500b8$var$a.MEDIA_SEEKABLE]: $299b6c40adc500b8$var$wd,
    [$299b6c40adc500b8$var$a.MEDIA_BUFFERED]: (i)=>i?.map($299b6c40adc500b8$var$wd).join(" "),
    [$299b6c40adc500b8$var$a.MEDIA_PREVIEW_COORDS]: (i)=>i?.join(" "),
    [$299b6c40adc500b8$var$a.MEDIA_RENDITION_LIST]: $299b6c40adc500b8$var$jl,
    [$299b6c40adc500b8$var$a.MEDIA_AUDIO_TRACK_LIST]: $299b6c40adc500b8$var$td
}, $299b6c40adc500b8$var$th = async (i, e, t)=>{
    var r, n1;
    if (i.isConnected || await $299b6c40adc500b8$var$vn(0), typeof t == "boolean" || t == null) return $299b6c40adc500b8$var$y(i, e, t);
    if (typeof t == "number") return $299b6c40adc500b8$var$w(i, e, t);
    if (typeof t == "string") return $299b6c40adc500b8$var$b(i, e, t);
    if (Array.isArray(t) && !t.length) return i.removeAttribute(e);
    let s = (n1 = (r = $299b6c40adc500b8$var$Cd[e]) == null ? void 0 : r.call($299b6c40adc500b8$var$Cd, t)) != null ? n1 : t;
    return i.setAttribute(e, s);
}, $299b6c40adc500b8$var$ih = (i)=>{
    var e;
    return !!((e = i.closest) != null && e.call(i, '*[slot="media"]'));
}, $299b6c40adc500b8$var$wt = (i, e)=>{
    if ($299b6c40adc500b8$var$ih(i)) return;
    let t = (n1, s)=>{
        var o, d;
        $299b6c40adc500b8$var$Ra(n1) && s(n1);
        let { children: u = [] } = n1 ?? {}, m = (d = (o = n1?.shadowRoot) == null ? void 0 : o.children) != null ? d : [];
        [
            ...u,
            ...m
        ].forEach((g)=>$299b6c40adc500b8$var$wt(g, s));
    }, r = i?.nodeName.toLowerCase();
    if (r.includes("-") && !$299b6c40adc500b8$var$Ra(i)) {
        $299b6c40adc500b8$var$l.customElements.whenDefined(r).then(()=>{
            t(i, e);
        });
        return;
    }
    t(i, e);
}, $299b6c40adc500b8$var$Rd = (i, e, t)=>{
    i.forEach((r)=>{
        if (e in r) {
            r[e] = t;
            return;
        }
        let n1 = $299b6c40adc500b8$var$Dd(r), s = e.toLowerCase();
        n1.includes(s) && $299b6c40adc500b8$var$th(r, s, t);
    });
}, $299b6c40adc500b8$var$rh = (i, e, t)=>{
    $299b6c40adc500b8$var$wt(i, e);
    let r = (f)=>{
        var g;
        let v = (g = f?.composedPath()[0]) != null ? g : f.target;
        e(v);
    }, n1 = (f)=>{
        var g;
        let v = (g = f?.composedPath()[0]) != null ? g : f.target;
        t(v);
    };
    i.addEventListener($299b6c40adc500b8$var$h.REGISTER_MEDIA_STATE_RECEIVER, r), i.addEventListener($299b6c40adc500b8$var$h.UNREGISTER_MEDIA_STATE_RECEIVER, n1);
    let s = (f)=>{
        f.forEach((g)=>{
            let { addedNodes: v = [], removedNodes: E = [], type: R, target: k, attributeName: S } = g;
            R === "childList" ? (Array.prototype.forEach.call(v, (V)=>$299b6c40adc500b8$var$wt(V, e)), Array.prototype.forEach.call(E, (V)=>$299b6c40adc500b8$var$wt(V, t))) : R === "attributes" && S === $299b6c40adc500b8$var$I.MEDIA_CHROME_ATTRIBUTES && ($299b6c40adc500b8$var$Ra(k) ? e(k) : t(k));
        });
    }, o = [], d = (f)=>{
        let g = f.target;
        g.name !== "media" && (o.forEach((v)=>$299b6c40adc500b8$var$wt(v, t)), o = [
            ...g.assignedElements({
                flatten: !0
            })
        ], o.forEach((v)=>$299b6c40adc500b8$var$wt(v, e)));
    };
    i.addEventListener("slotchange", d);
    let u = new MutationObserver(s);
    return u.observe(i, {
        childList: !0,
        attributes: !0,
        subtree: !0
    }), ()=>{
        $299b6c40adc500b8$var$wt(i, t), i.removeEventListener("slotchange", d), u.disconnect(), i.removeEventListener($299b6c40adc500b8$var$h.REGISTER_MEDIA_STATE_RECEIVER, r), i.removeEventListener($299b6c40adc500b8$var$h.UNREGISTER_MEDIA_STATE_RECEIVER, n1);
    };
};
$299b6c40adc500b8$var$l.customElements.get("media-controller") || $299b6c40adc500b8$var$l.customElements.define("media-controller", $299b6c40adc500b8$var$Ca);
var $299b6c40adc500b8$var$Od = `<svg aria-hidden="true" viewBox="0 0 26 24">
  <path d="M22.13 3H3.87a.87.87 0 0 0-.87.87v13.26a.87.87 0 0 0 .87.87h3.4L9 16H5V5h16v11h-4l1.72 2h3.4a.87.87 0 0 0 .87-.87V3.87a.87.87 0 0 0-.86-.87Zm-8.75 11.44a.5.5 0 0 0-.76 0l-4.91 5.73a.5.5 0 0 0 .38.83h9.82a.501.501 0 0 0 .38-.83l-4.91-5.73Z"/>
</svg>
`;
function $299b6c40adc500b8$var$nh(i) {
    return `
    <style>
      :host([${$299b6c40adc500b8$var$a.MEDIA_IS_AIRPLAYING}]) slot[name=icon] slot:not([name=exit]) {
        display: none !important;
      }

      
      :host(:not([${$299b6c40adc500b8$var$a.MEDIA_IS_AIRPLAYING}])) slot[name=icon] slot:not([name=enter]) {
        display: none !important;
      }

      :host([${$299b6c40adc500b8$var$a.MEDIA_IS_AIRPLAYING}]) slot[name=tooltip-enter],
      :host(:not([${$299b6c40adc500b8$var$a.MEDIA_IS_AIRPLAYING}])) slot[name=tooltip-exit] {
        display: none;
      }
    </style>

    <slot name="icon">
      <slot name="enter">${$299b6c40adc500b8$var$Od}</slot>
      <slot name="exit">${$299b6c40adc500b8$var$Od}</slot>
    </slot>
  `;
}
function $299b6c40adc500b8$var$sh() {
    return `
    <slot name="tooltip-enter">${$299b6c40adc500b8$var$c("start airplay")}</slot>
    <slot name="tooltip-exit">${$299b6c40adc500b8$var$c("stop airplay")}</slot>
  `;
}
var $299b6c40adc500b8$var$xd = (i)=>{
    let e = i.mediaIsAirplaying ? $299b6c40adc500b8$var$c("stop airplay") : $299b6c40adc500b8$var$c("start airplay");
    i.setAttribute("aria-label", e);
}, $299b6c40adc500b8$var$ji = class extends $299b6c40adc500b8$var$P {
    static get observedAttributes() {
        return [
            ...super.observedAttributes,
            $299b6c40adc500b8$var$a.MEDIA_IS_AIRPLAYING,
            $299b6c40adc500b8$var$a.MEDIA_AIRPLAY_UNAVAILABLE
        ];
    }
    connectedCallback() {
        super.connectedCallback(), $299b6c40adc500b8$var$xd(this);
    }
    attributeChangedCallback(e, t, r) {
        super.attributeChangedCallback(e, t, r), e === $299b6c40adc500b8$var$a.MEDIA_IS_AIRPLAYING && $299b6c40adc500b8$var$xd(this);
    }
    get mediaIsAirplaying() {
        return $299b6c40adc500b8$var$A(this, $299b6c40adc500b8$var$a.MEDIA_IS_AIRPLAYING);
    }
    set mediaIsAirplaying(e) {
        $299b6c40adc500b8$var$y(this, $299b6c40adc500b8$var$a.MEDIA_IS_AIRPLAYING, e);
    }
    get mediaAirplayUnavailable() {
        return $299b6c40adc500b8$var$_(this, $299b6c40adc500b8$var$a.MEDIA_AIRPLAY_UNAVAILABLE);
    }
    set mediaAirplayUnavailable(e) {
        $299b6c40adc500b8$var$b(this, $299b6c40adc500b8$var$a.MEDIA_AIRPLAY_UNAVAILABLE, e);
    }
    handleClick() {
        let e = new $299b6c40adc500b8$var$l.CustomEvent($299b6c40adc500b8$var$h.MEDIA_AIRPLAY_REQUEST, {
            composed: !0,
            bubbles: !0
        });
        this.dispatchEvent(e);
    }
};
$299b6c40adc500b8$var$ji.getSlotTemplateHTML = $299b6c40adc500b8$var$nh;
$299b6c40adc500b8$var$ji.getTooltipContentHTML = $299b6c40adc500b8$var$sh;
$299b6c40adc500b8$var$l.customElements.get("media-airplay-button") || $299b6c40adc500b8$var$l.customElements.define("media-airplay-button", $299b6c40adc500b8$var$ji);
var $299b6c40adc500b8$var$ah = `<svg aria-hidden="true" viewBox="0 0 26 24">
  <path d="M22.83 5.68a2.58 2.58 0 0 0-2.3-2.5c-3.62-.24-11.44-.24-15.06 0a2.58 2.58 0 0 0-2.3 2.5c-.23 4.21-.23 8.43 0 12.64a2.58 2.58 0 0 0 2.3 2.5c3.62.24 11.44.24 15.06 0a2.58 2.58 0 0 0 2.3-2.5c.23-4.21.23-8.43 0-12.64Zm-11.39 9.45a3.07 3.07 0 0 1-1.91.57 3.06 3.06 0 0 1-2.34-1 3.75 3.75 0 0 1-.92-2.67 3.92 3.92 0 0 1 .92-2.77 3.18 3.18 0 0 1 2.43-1 2.94 2.94 0 0 1 2.13.78c.364.359.62.813.74 1.31l-1.43.35a1.49 1.49 0 0 0-1.51-1.17 1.61 1.61 0 0 0-1.29.58 2.79 2.79 0 0 0-.5 1.89 3 3 0 0 0 .49 1.93 1.61 1.61 0 0 0 1.27.58 1.48 1.48 0 0 0 1-.37 2.1 2.1 0 0 0 .59-1.14l1.4.44a3.23 3.23 0 0 1-1.07 1.69Zm7.22 0a3.07 3.07 0 0 1-1.91.57 3.06 3.06 0 0 1-2.34-1 3.75 3.75 0 0 1-.92-2.67 3.88 3.88 0 0 1 .93-2.77 3.14 3.14 0 0 1 2.42-1 3 3 0 0 1 2.16.82 2.8 2.8 0 0 1 .73 1.31l-1.43.35a1.49 1.49 0 0 0-1.51-1.21 1.61 1.61 0 0 0-1.29.58A2.79 2.79 0 0 0 15 12a3 3 0 0 0 .49 1.93 1.61 1.61 0 0 0 1.27.58 1.44 1.44 0 0 0 1-.37 2.1 2.1 0 0 0 .6-1.15l1.4.44a3.17 3.17 0 0 1-1.1 1.7Z"/>
</svg>`, $299b6c40adc500b8$var$oh = `<svg aria-hidden="true" viewBox="0 0 26 24">
  <path d="M17.73 14.09a1.4 1.4 0 0 1-1 .37 1.579 1.579 0 0 1-1.27-.58A3 3 0 0 1 15 12a2.8 2.8 0 0 1 .5-1.85 1.63 1.63 0 0 1 1.29-.57 1.47 1.47 0 0 1 1.51 1.2l1.43-.34A2.89 2.89 0 0 0 19 9.07a3 3 0 0 0-2.14-.78 3.14 3.14 0 0 0-2.42 1 3.91 3.91 0 0 0-.93 2.78 3.74 3.74 0 0 0 .92 2.66 3.07 3.07 0 0 0 2.34 1 3.07 3.07 0 0 0 1.91-.57 3.17 3.17 0 0 0 1.07-1.74l-1.4-.45c-.083.43-.3.822-.62 1.12Zm-7.22 0a1.43 1.43 0 0 1-1 .37 1.58 1.58 0 0 1-1.27-.58A3 3 0 0 1 7.76 12a2.8 2.8 0 0 1 .5-1.85 1.63 1.63 0 0 1 1.29-.57 1.47 1.47 0 0 1 1.51 1.2l1.43-.34a2.81 2.81 0 0 0-.74-1.32 2.94 2.94 0 0 0-2.13-.78 3.18 3.18 0 0 0-2.43 1 4 4 0 0 0-.92 2.78 3.74 3.74 0 0 0 .92 2.66 3.07 3.07 0 0 0 2.34 1 3.07 3.07 0 0 0 1.91-.57 3.23 3.23 0 0 0 1.07-1.74l-1.4-.45a2.06 2.06 0 0 1-.6 1.07Zm12.32-8.41a2.59 2.59 0 0 0-2.3-2.51C18.72 3.05 15.86 3 13 3c-2.86 0-5.72.05-7.53.17a2.59 2.59 0 0 0-2.3 2.51c-.23 4.207-.23 8.423 0 12.63a2.57 2.57 0 0 0 2.3 2.5c1.81.13 4.67.19 7.53.19 2.86 0 5.72-.06 7.53-.19a2.57 2.57 0 0 0 2.3-2.5c.23-4.207.23-8.423 0-12.63Zm-1.49 12.53a1.11 1.11 0 0 1-.91 1.11c-1.67.11-4.45.18-7.43.18-2.98 0-5.76-.07-7.43-.18a1.11 1.11 0 0 1-.91-1.11c-.21-4.14-.21-8.29 0-12.43a1.11 1.11 0 0 1 .91-1.11C7.24 4.56 10 4.49 13 4.49s5.76.07 7.43.18a1.11 1.11 0 0 1 .91 1.11c.21 4.14.21 8.29 0 12.43Z"/>
</svg>`;
function $299b6c40adc500b8$var$lh(i) {
    return `
    <style>
      :host([aria-checked="true"]) slot[name=off] {
        display: none !important;
      }

      
      :host(:not([aria-checked="true"])) slot[name=on] {
        display: none !important;
      }

      :host([aria-checked="true"]) slot[name=tooltip-enable],
      :host(:not([aria-checked="true"])) slot[name=tooltip-disable] {
        display: none;
      }
    </style>

    <slot name="icon">
      <slot name="on">${$299b6c40adc500b8$var$ah}</slot>
      <slot name="off">${$299b6c40adc500b8$var$oh}</slot>
    </slot>
  `;
}
function $299b6c40adc500b8$var$dh() {
    return `
    <slot name="tooltip-enable">${$299b6c40adc500b8$var$c("Enable captions")}</slot>
    <slot name="tooltip-disable">${$299b6c40adc500b8$var$c("Disable captions")}</slot>
  `;
}
var $299b6c40adc500b8$var$Nd = (i)=>{
    i.setAttribute("aria-checked", $299b6c40adc500b8$var$Sn(i).toString());
}, $299b6c40adc500b8$var$er = class extends $299b6c40adc500b8$var$P {
    static get observedAttributes() {
        return [
            ...super.observedAttributes,
            $299b6c40adc500b8$var$a.MEDIA_SUBTITLES_LIST,
            $299b6c40adc500b8$var$a.MEDIA_SUBTITLES_SHOWING
        ];
    }
    connectedCallback() {
        super.connectedCallback(), this.setAttribute("role", "switch"), this.setAttribute("aria-label", $299b6c40adc500b8$var$c("closed captions")), $299b6c40adc500b8$var$Nd(this);
    }
    attributeChangedCallback(e, t, r) {
        super.attributeChangedCallback(e, t, r), e === $299b6c40adc500b8$var$a.MEDIA_SUBTITLES_SHOWING && $299b6c40adc500b8$var$Nd(this);
    }
    get mediaSubtitlesList() {
        return $299b6c40adc500b8$var$Ud(this, $299b6c40adc500b8$var$a.MEDIA_SUBTITLES_LIST);
    }
    set mediaSubtitlesList(e) {
        $299b6c40adc500b8$var$Hd(this, $299b6c40adc500b8$var$a.MEDIA_SUBTITLES_LIST, e);
    }
    get mediaSubtitlesShowing() {
        return $299b6c40adc500b8$var$Ud(this, $299b6c40adc500b8$var$a.MEDIA_SUBTITLES_SHOWING);
    }
    set mediaSubtitlesShowing(e) {
        $299b6c40adc500b8$var$Hd(this, $299b6c40adc500b8$var$a.MEDIA_SUBTITLES_SHOWING, e);
    }
    handleClick() {
        this.dispatchEvent(new $299b6c40adc500b8$var$l.CustomEvent($299b6c40adc500b8$var$h.MEDIA_TOGGLE_SUBTITLES_REQUEST, {
            composed: !0,
            bubbles: !0
        }));
    }
};
$299b6c40adc500b8$var$er.getSlotTemplateHTML = $299b6c40adc500b8$var$lh;
$299b6c40adc500b8$var$er.getTooltipContentHTML = $299b6c40adc500b8$var$dh;
var $299b6c40adc500b8$var$Ud = (i, e)=>{
    let t = i.getAttribute(e);
    return t ? $299b6c40adc500b8$var$St(t) : [];
}, $299b6c40adc500b8$var$Hd = (i, e, t)=>{
    if (!t?.length) {
        i.removeAttribute(e);
        return;
    }
    let r = $299b6c40adc500b8$var$Qe(t);
    i.getAttribute(e) !== r && i.setAttribute(e, r);
};
$299b6c40adc500b8$var$l.customElements.get("media-captions-button") || $299b6c40adc500b8$var$l.customElements.define("media-captions-button", $299b6c40adc500b8$var$er);
var $299b6c40adc500b8$var$uh = '<svg aria-hidden="true" viewBox="0 0 24 24"><g><path class="cast_caf_icon_arch0" d="M1,18 L1,21 L4,21 C4,19.3 2.66,18 1,18 L1,18 Z"/><path class="cast_caf_icon_arch1" d="M1,14 L1,16 C3.76,16 6,18.2 6,21 L8,21 C8,17.13 4.87,14 1,14 L1,14 Z"/><path class="cast_caf_icon_arch2" d="M1,10 L1,12 C5.97,12 10,16.0 10,21 L12,21 C12,14.92 7.07,10 1,10 L1,10 Z"/><path class="cast_caf_icon_box" d="M21,3 L3,3 C1.9,3 1,3.9 1,5 L1,8 L3,8 L3,5 L21,5 L21,19 L14,19 L14,21 L21,21 C22.1,21 23,20.1 23,19 L23,5 C23,3.9 22.1,3 21,3 L21,3 Z"/></g></svg>', $299b6c40adc500b8$var$ch = '<svg aria-hidden="true" viewBox="0 0 24 24"><g><path class="cast_caf_icon_arch0" d="M1,18 L1,21 L4,21 C4,19.3 2.66,18 1,18 L1,18 Z"/><path class="cast_caf_icon_arch1" d="M1,14 L1,16 C3.76,16 6,18.2 6,21 L8,21 C8,17.13 4.87,14 1,14 L1,14 Z"/><path class="cast_caf_icon_arch2" d="M1,10 L1,12 C5.97,12 10,16.0 10,21 L12,21 C12,14.92 7.07,10 1,10 L1,10 Z"/><path class="cast_caf_icon_box" d="M21,3 L3,3 C1.9,3 1,3.9 1,5 L1,8 L3,8 L3,5 L21,5 L21,19 L14,19 L14,21 L21,21 C22.1,21 23,20.1 23,19 L23,5 C23,3.9 22.1,3 21,3 L21,3 Z"/><path class="cast_caf_icon_boxfill" d="M5,7 L5,8.63 C8,8.6 13.37,14 13.37,17 L19,17 L19,7 Z"/></g></svg>';
function $299b6c40adc500b8$var$hh(i) {
    return `
    <style>
      :host([${$299b6c40adc500b8$var$a.MEDIA_IS_CASTING}]) slot[name=icon] slot:not([name=exit]) {
        display: none !important;
      }

      
      :host(:not([${$299b6c40adc500b8$var$a.MEDIA_IS_CASTING}])) slot[name=icon] slot:not([name=enter]) {
        display: none !important;
      }

      :host([${$299b6c40adc500b8$var$a.MEDIA_IS_CASTING}]) slot[name=tooltip-enter],
      :host(:not([${$299b6c40adc500b8$var$a.MEDIA_IS_CASTING}])) slot[name=tooltip-exit] {
        display: none;
      }
    </style>

    <slot name="icon">
      <slot name="enter">${$299b6c40adc500b8$var$uh}</slot>
      <slot name="exit">${$299b6c40adc500b8$var$ch}</slot>
    </slot>
  `;
}
function $299b6c40adc500b8$var$mh() {
    return `
    <slot name="tooltip-enter">${$299b6c40adc500b8$var$c("Start casting")}</slot>
    <slot name="tooltip-exit">${$299b6c40adc500b8$var$c("Stop casting")}</slot>
  `;
}
var $299b6c40adc500b8$var$Vd = (i)=>{
    let e = i.mediaIsCasting ? $299b6c40adc500b8$var$c("stop casting") : $299b6c40adc500b8$var$c("start casting");
    i.setAttribute("aria-label", e);
}, $299b6c40adc500b8$var$tr = class extends $299b6c40adc500b8$var$P {
    static get observedAttributes() {
        return [
            ...super.observedAttributes,
            $299b6c40adc500b8$var$a.MEDIA_IS_CASTING,
            $299b6c40adc500b8$var$a.MEDIA_CAST_UNAVAILABLE
        ];
    }
    connectedCallback() {
        super.connectedCallback(), $299b6c40adc500b8$var$Vd(this);
    }
    attributeChangedCallback(e, t, r) {
        super.attributeChangedCallback(e, t, r), e === $299b6c40adc500b8$var$a.MEDIA_IS_CASTING && $299b6c40adc500b8$var$Vd(this);
    }
    get mediaIsCasting() {
        return $299b6c40adc500b8$var$A(this, $299b6c40adc500b8$var$a.MEDIA_IS_CASTING);
    }
    set mediaIsCasting(e) {
        $299b6c40adc500b8$var$y(this, $299b6c40adc500b8$var$a.MEDIA_IS_CASTING, e);
    }
    get mediaCastUnavailable() {
        return $299b6c40adc500b8$var$_(this, $299b6c40adc500b8$var$a.MEDIA_CAST_UNAVAILABLE);
    }
    set mediaCastUnavailable(e) {
        $299b6c40adc500b8$var$b(this, $299b6c40adc500b8$var$a.MEDIA_CAST_UNAVAILABLE, e);
    }
    handleClick() {
        let e = this.mediaIsCasting ? $299b6c40adc500b8$var$h.MEDIA_EXIT_CAST_REQUEST : $299b6c40adc500b8$var$h.MEDIA_ENTER_CAST_REQUEST;
        this.dispatchEvent(new $299b6c40adc500b8$var$l.CustomEvent(e, {
            composed: !0,
            bubbles: !0
        }));
    }
};
$299b6c40adc500b8$var$tr.getSlotTemplateHTML = $299b6c40adc500b8$var$hh;
$299b6c40adc500b8$var$tr.getTooltipContentHTML = $299b6c40adc500b8$var$mh;
$299b6c40adc500b8$var$l.customElements.get("media-cast-button") || $299b6c40adc500b8$var$l.customElements.define("media-cast-button", $299b6c40adc500b8$var$tr);
var $299b6c40adc500b8$var$Va = (i, e, t)=>{
    if (!e.has(i)) throw TypeError("Cannot " + t);
}, $299b6c40adc500b8$var$Pt = (i, e, t)=>($299b6c40adc500b8$var$Va(i, e, "read from private field"), t ? t.call(i) : e.get(i)), $299b6c40adc500b8$var$Xe = (i, e, t)=>{
    if (e.has(i)) throw TypeError("Cannot add the same private member more than once");
    e instanceof WeakSet ? e.add(i) : e.set(i, t);
}, $299b6c40adc500b8$var$Wa = (i, e, t, r)=>($299b6c40adc500b8$var$Va(i, e, "write to private field"), r ? r.call(i, t) : e.set(i, t), t), $299b6c40adc500b8$var$Rt = (i, e, t)=>($299b6c40adc500b8$var$Va(i, e, "access private method"), t), $299b6c40adc500b8$var$xn, $299b6c40adc500b8$var$rr, $299b6c40adc500b8$var$Dt, $299b6c40adc500b8$var$On, $299b6c40adc500b8$var$Da, $299b6c40adc500b8$var$Oa, $299b6c40adc500b8$var$Wd, $299b6c40adc500b8$var$xa, $299b6c40adc500b8$var$Fd, $299b6c40adc500b8$var$Na, $299b6c40adc500b8$var$Bd, $299b6c40adc500b8$var$Ua, $299b6c40adc500b8$var$$d, $299b6c40adc500b8$var$Ha, $299b6c40adc500b8$var$Gd;
function $299b6c40adc500b8$var$ph(i) {
    return `
    <style>
      :host {
        font: var(--media-font,
          var(--media-font-weight, normal)
          var(--media-font-size, 14px) /
          var(--media-text-content-height, var(--media-control-height, 24px))
          var(--media-font-family, helvetica neue, segoe ui, roboto, arial, sans-serif));
        color: var(--media-text-color, var(--media-primary-color, rgb(238 238 238)));
        display: var(--media-dialog-display, inline-flex);
        justify-content: center;
        align-items: center;
        
        transition-behavior: allow-discrete;
        visibility: hidden;
        opacity: 0;
        transform: translateY(2px) scale(.99);
        pointer-events: none;
      }

      :host([open]) {
        transition: display .2s, visibility 0s, opacity .2s ease-out, transform .15s ease-out;
        visibility: visible;
        opacity: 1;
        transform: translateY(0) scale(1);
        pointer-events: auto;
      }

      #content {
        display: flex;
        position: relative;
        box-sizing: border-box;
        width: min(320px, 100%);
        word-wrap: break-word;
        max-height: 100%;
        overflow: auto;
        text-align: center;
        line-height: 1.4;
      }
    </style>
    ${this.getSlotTemplateHTML(i)}
  `;
}
function $299b6c40adc500b8$var$vh(i) {
    return `
    <slot id="content"></slot>
  `;
}
var $299b6c40adc500b8$var$ir = {
    OPEN: "open",
    ANCHOR: "anchor"
}, $299b6c40adc500b8$var$dt = class extends $299b6c40adc500b8$var$l.HTMLElement {
    constructor(){
        super(), $299b6c40adc500b8$var$Xe(this, $299b6c40adc500b8$var$On), $299b6c40adc500b8$var$Xe(this, $299b6c40adc500b8$var$Oa), $299b6c40adc500b8$var$Xe(this, $299b6c40adc500b8$var$xa), $299b6c40adc500b8$var$Xe(this, $299b6c40adc500b8$var$Na), $299b6c40adc500b8$var$Xe(this, $299b6c40adc500b8$var$Ua), $299b6c40adc500b8$var$Xe(this, $299b6c40adc500b8$var$Ha), $299b6c40adc500b8$var$Xe(this, $299b6c40adc500b8$var$xn, !1), $299b6c40adc500b8$var$Xe(this, $299b6c40adc500b8$var$rr, null), $299b6c40adc500b8$var$Xe(this, $299b6c40adc500b8$var$Dt, null), this.addEventListener("invoke", this), this.addEventListener("focusout", this), this.addEventListener("keydown", this);
    }
    static get observedAttributes() {
        return [
            $299b6c40adc500b8$var$ir.OPEN,
            $299b6c40adc500b8$var$ir.ANCHOR
        ];
    }
    get open() {
        return $299b6c40adc500b8$var$A(this, $299b6c40adc500b8$var$ir.OPEN);
    }
    set open(e) {
        $299b6c40adc500b8$var$y(this, $299b6c40adc500b8$var$ir.OPEN, e);
    }
    handleEvent(e) {
        switch(e.type){
            case "invoke":
                $299b6c40adc500b8$var$Rt(this, $299b6c40adc500b8$var$Na, $299b6c40adc500b8$var$Bd).call(this, e);
                break;
            case "focusout":
                $299b6c40adc500b8$var$Rt(this, $299b6c40adc500b8$var$Ua, $299b6c40adc500b8$var$$d).call(this, e);
                break;
            case "keydown":
                $299b6c40adc500b8$var$Rt(this, $299b6c40adc500b8$var$Ha, $299b6c40adc500b8$var$Gd).call(this, e);
                break;
        }
    }
    connectedCallback() {
        $299b6c40adc500b8$var$Rt(this, $299b6c40adc500b8$var$On, $299b6c40adc500b8$var$Da).call(this), this.role || (this.role = "dialog");
    }
    attributeChangedCallback(e, t, r) {
        $299b6c40adc500b8$var$Rt(this, $299b6c40adc500b8$var$On, $299b6c40adc500b8$var$Da).call(this), e === $299b6c40adc500b8$var$ir.OPEN && r !== t && (this.open ? $299b6c40adc500b8$var$Rt(this, $299b6c40adc500b8$var$Oa, $299b6c40adc500b8$var$Wd).call(this) : $299b6c40adc500b8$var$Rt(this, $299b6c40adc500b8$var$xa, $299b6c40adc500b8$var$Fd).call(this));
    }
    focus() {
        $299b6c40adc500b8$var$Wa(this, $299b6c40adc500b8$var$rr, $299b6c40adc500b8$var$Ui());
        let e = !this.dispatchEvent(new Event("focus", {
            composed: !0,
            cancelable: !0
        })), t = !this.dispatchEvent(new Event("focusin", {
            composed: !0,
            bubbles: !0,
            cancelable: !0
        }));
        if (e || t) return;
        let r = this.querySelector('[autofocus], [tabindex]:not([tabindex="-1"]), [role="menu"]');
        r?.focus();
    }
    get keysUsed() {
        return [
            "Escape",
            "Tab"
        ];
    }
};
$299b6c40adc500b8$var$xn = new WeakMap;
$299b6c40adc500b8$var$rr = new WeakMap;
$299b6c40adc500b8$var$Dt = new WeakMap;
$299b6c40adc500b8$var$On = new WeakSet;
$299b6c40adc500b8$var$Da = function() {
    if (!$299b6c40adc500b8$var$Pt(this, $299b6c40adc500b8$var$xn) && ($299b6c40adc500b8$var$Wa(this, $299b6c40adc500b8$var$xn, !0), !this.shadowRoot)) {
        this.attachShadow(this.constructor.shadowRootOptions);
        let i = $299b6c40adc500b8$var$W(this.attributes);
        this.shadowRoot.innerHTML = this.constructor.getTemplateHTML(i), queueMicrotask(()=>{
            let { style: e } = $299b6c40adc500b8$var$O(this.shadowRoot, ":host");
            e.setProperty("transition", "display .15s, visibility .15s, opacity .15s ease-in, transform .15s ease-in");
        });
    }
};
$299b6c40adc500b8$var$Oa = new WeakSet;
$299b6c40adc500b8$var$Wd = function() {
    var i;
    (i = $299b6c40adc500b8$var$Pt(this, $299b6c40adc500b8$var$Dt)) == null || i.setAttribute("aria-expanded", "true"), this.dispatchEvent(new Event("open", {
        composed: !0,
        bubbles: !0
    })), this.addEventListener("transitionend", ()=>this.focus(), {
        once: !0
    });
};
$299b6c40adc500b8$var$xa = new WeakSet;
$299b6c40adc500b8$var$Fd = function() {
    var i;
    (i = $299b6c40adc500b8$var$Pt(this, $299b6c40adc500b8$var$Dt)) == null || i.setAttribute("aria-expanded", "false"), this.dispatchEvent(new Event("close", {
        composed: !0,
        bubbles: !0
    }));
};
$299b6c40adc500b8$var$Na = new WeakSet;
$299b6c40adc500b8$var$Bd = function(i) {
    $299b6c40adc500b8$var$Wa(this, $299b6c40adc500b8$var$Dt, i.relatedTarget), $299b6c40adc500b8$var$ee(this, i.relatedTarget) || (this.open = !this.open);
};
$299b6c40adc500b8$var$Ua = new WeakSet;
$299b6c40adc500b8$var$$d = function(i) {
    var e;
    $299b6c40adc500b8$var$ee(this, i.relatedTarget) || ((e = $299b6c40adc500b8$var$Pt(this, $299b6c40adc500b8$var$rr)) == null || e.focus(), $299b6c40adc500b8$var$Pt(this, $299b6c40adc500b8$var$Dt) && $299b6c40adc500b8$var$Pt(this, $299b6c40adc500b8$var$Dt) !== i.relatedTarget && this.open && (this.open = !1));
};
$299b6c40adc500b8$var$Ha = new WeakSet;
$299b6c40adc500b8$var$Gd = function(i) {
    var e, t, r, n1, s;
    let { key: o, ctrlKey: d, altKey: u, metaKey: m } = i;
    d || u || m || this.keysUsed.includes(o) && (i.preventDefault(), i.stopPropagation(), o === "Tab" ? (i.shiftKey ? (t = (e = this.previousElementSibling) == null ? void 0 : e.focus) == null || t.call(e) : (n1 = (r = this.nextElementSibling) == null ? void 0 : r.focus) == null || n1.call(r), this.blur()) : o === "Escape" && ((s = $299b6c40adc500b8$var$Pt(this, $299b6c40adc500b8$var$rr)) == null || s.focus(), this.open = !1));
};
$299b6c40adc500b8$var$dt.shadowRootOptions = {
    mode: "open"
};
$299b6c40adc500b8$var$dt.getTemplateHTML = $299b6c40adc500b8$var$ph;
$299b6c40adc500b8$var$dt.getSlotTemplateHTML = $299b6c40adc500b8$var$vh;
$299b6c40adc500b8$var$l.customElements.get("media-chrome-dialog") || $299b6c40adc500b8$var$l.customElements.define("media-chrome-dialog", $299b6c40adc500b8$var$dt);
var $299b6c40adc500b8$var$Ya = (i, e, t)=>{
    if (!e.has(i)) throw TypeError("Cannot " + t);
}, $299b6c40adc500b8$var$B = (i, e, t)=>($299b6c40adc500b8$var$Ya(i, e, "read from private field"), t ? t.call(i) : e.get(i)), $299b6c40adc500b8$var$X = (i, e, t)=>{
    if (e.has(i)) throw TypeError("Cannot add the same private member more than once");
    e instanceof WeakSet ? e.add(i) : e.set(i, t);
}, $299b6c40adc500b8$var$ut = (i, e, t, r)=>($299b6c40adc500b8$var$Ya(i, e, "write to private field"), r ? r.call(i, t) : e.set(i, t), t), $299b6c40adc500b8$var$ye = (i, e, t)=>($299b6c40adc500b8$var$Ya(i, e, "access private method"), t), $299b6c40adc500b8$var$Oe, $299b6c40adc500b8$var$Kn, $299b6c40adc500b8$var$Nn, $299b6c40adc500b8$var$Un, $299b6c40adc500b8$var$ke, $299b6c40adc500b8$var$$n, $299b6c40adc500b8$var$Hn, $299b6c40adc500b8$var$Vn, $299b6c40adc500b8$var$Wn, $299b6c40adc500b8$var$Za, $299b6c40adc500b8$var$Kd, $299b6c40adc500b8$var$Fn, $299b6c40adc500b8$var$Fa, $299b6c40adc500b8$var$Bn, $299b6c40adc500b8$var$Ba, $299b6c40adc500b8$var$Gn, $299b6c40adc500b8$var$Qa, $299b6c40adc500b8$var$$a, $299b6c40adc500b8$var$qd, $299b6c40adc500b8$var$Ga, $299b6c40adc500b8$var$Yd, $299b6c40adc500b8$var$Ka, $299b6c40adc500b8$var$Zd, $299b6c40adc500b8$var$qa, $299b6c40adc500b8$var$Qd;
function $299b6c40adc500b8$var$Eh(i) {
    return `
    <style>
      :host {
        --_focus-box-shadow: var(--media-focus-box-shadow, inset 0 0 0 2px rgb(27 127 204 / .9));
        --_media-range-padding: var(--media-range-padding, var(--media-control-padding, 10px));

        box-shadow: var(--_focus-visible-box-shadow, none);
        background: var(--media-control-background, var(--media-secondary-color, rgb(20 20 30 / .7)));
        height: calc(var(--media-control-height, 24px) + 2 * var(--_media-range-padding));
        display: inline-flex;
        align-items: center;
        
        vertical-align: middle;
        box-sizing: border-box;
        position: relative;
        width: 100px;
        transition: background .15s linear;
        cursor: var(--media-cursor, pointer);
        pointer-events: auto;
        touch-action: none; 
      }

      
      input[type=range]:focus {
        outline: 0;
      }
      input[type=range]:focus::-webkit-slider-runnable-track {
        outline: 0;
      }

      :host(:hover) {
        background: var(--media-control-hover-background, rgb(50 50 70 / .7));
      }

      #leftgap {
        padding-left: var(--media-range-padding-left, var(--_media-range-padding));
      }

      #rightgap {
        padding-right: var(--media-range-padding-right, var(--_media-range-padding));
      }

      #startpoint,
      #endpoint {
        position: absolute;
      }

      #endpoint {
        right: 0;
      }

      #container {
        
        width: var(--media-range-track-width, 100%);
        transform: translate(var(--media-range-track-translate-x, 0px), var(--media-range-track-translate-y, 0px));
        position: relative;
        height: 100%;
        display: flex;
        align-items: center;
        min-width: 40px;
      }

      #range {
        
        display: var(--media-time-range-hover-display, block);
        bottom: var(--media-time-range-hover-bottom, -7px);
        height: var(--media-time-range-hover-height, max(100% + 7px, 25px));
        width: 100%;
        position: absolute;
        cursor: var(--media-cursor, pointer);

        -webkit-appearance: none; 
        -webkit-tap-highlight-color: transparent;
        background: transparent; 
        margin: 0;
        z-index: 1;
      }

      @media (hover: hover) {
        #range {
          bottom: var(--media-time-range-hover-bottom, -5px);
          height: var(--media-time-range-hover-height, max(100% + 5px, 20px));
        }
      }

      
      
      #range::-webkit-slider-thumb {
        -webkit-appearance: none;
        background: transparent;
        width: .1px;
        height: .1px;
      }

      
      #range::-moz-range-thumb {
        background: transparent;
        border: transparent;
        width: .1px;
        height: .1px;
      }

      #appearance {
        height: var(--media-range-track-height, 4px);
        display: flex;
        flex-direction: column;
        justify-content: center;
        width: 100%;
        position: absolute;
        
        will-change: transform;
      }

      #track {
        background: var(--media-range-track-background, rgb(255 255 255 / .2));
        border-radius: var(--media-range-track-border-radius, 1px);
        border: var(--media-range-track-border, none);
        outline: var(--media-range-track-outline);
        outline-offset: var(--media-range-track-outline-offset);
        backdrop-filter: var(--media-range-track-backdrop-filter);
        -webkit-backdrop-filter: var(--media-range-track-backdrop-filter);
        box-shadow: var(--media-range-track-box-shadow, none);
        position: absolute;
        width: 100%;
        height: 100%;
        overflow: hidden;
      }

      #progress,
      #pointer {
        position: absolute;
        height: 100%;
        will-change: width;
      }

      #progress {
        background: var(--media-range-bar-color, var(--media-primary-color, rgb(238 238 238)));
        transition: var(--media-range-track-transition);
      }

      #pointer {
        background: var(--media-range-track-pointer-background);
        border-right: var(--media-range-track-pointer-border-right);
        transition: visibility .25s, opacity .25s;
        visibility: hidden;
        opacity: 0;
      }

      @media (hover: hover) {
        :host(:hover) #pointer {
          transition: visibility .5s, opacity .5s;
          visibility: visible;
          opacity: 1;
        }
      }

      #thumb,
      ::slotted([slot=thumb]) {
        width: var(--media-range-thumb-width, 10px);
        height: var(--media-range-thumb-height, 10px);
        transition: var(--media-range-thumb-transition);
        transform: var(--media-range-thumb-transform, none);
        opacity: var(--media-range-thumb-opacity, 1);
        translate: -50%;
        position: absolute;
        left: 0;
        cursor: var(--media-cursor, pointer);
      }

      #thumb {
        border-radius: var(--media-range-thumb-border-radius, 10px);
        background: var(--media-range-thumb-background, var(--media-primary-color, rgb(238 238 238)));
        box-shadow: var(--media-range-thumb-box-shadow, 1px 1px 1px transparent);
        border: var(--media-range-thumb-border, none);
      }

      :host([disabled]) #thumb {
        background-color: #777;
      }

      .segments #appearance {
        height: var(--media-range-segment-hover-height, 7px);
      }

      #track {
        clip-path: url(#segments-clipping);
      }

      #segments {
        --segments-gap: var(--media-range-segments-gap, 2px);
        position: absolute;
        width: 100%;
        height: 100%;
      }

      #segments-clipping {
        transform: translateX(calc(var(--segments-gap) / 2));
      }

      #segments-clipping:empty {
        display: none;
      }

      #segments-clipping rect {
        height: var(--media-range-track-height, 4px);
        y: calc((var(--media-range-segment-hover-height, 7px) - var(--media-range-track-height, 4px)) / 2);
        transition: var(--media-range-segment-transition, transform .1s ease-in-out);
        transform: var(--media-range-segment-transform, scaleY(1));
        transform-origin: center;
      }
    </style>
    <div id="leftgap"></div>
    <div id="container">
      <div id="startpoint"></div>
      <div id="endpoint"></div>
      <div id="appearance">
        <div id="track" part="track">
          <div id="pointer"></div>
          <div id="progress" part="progress"></div>
        </div>
        <slot name="thumb">
          <div id="thumb" part="thumb"></div>
        </slot>
        <svg id="segments"><clipPath id="segments-clipping"></clipPath></svg>
      </div>
      <input id="range" type="range" min="0" max="1" step="any" value="0">
    </div>
    <div id="rightgap"></div>
  `;
}
var $299b6c40adc500b8$var$xe = class extends $299b6c40adc500b8$var$l.HTMLElement {
    constructor(){
        if (super(), $299b6c40adc500b8$var$X(this, $299b6c40adc500b8$var$Za), $299b6c40adc500b8$var$X(this, $299b6c40adc500b8$var$Fn), $299b6c40adc500b8$var$X(this, $299b6c40adc500b8$var$Bn), $299b6c40adc500b8$var$X(this, $299b6c40adc500b8$var$Gn), $299b6c40adc500b8$var$X(this, $299b6c40adc500b8$var$$a), $299b6c40adc500b8$var$X(this, $299b6c40adc500b8$var$Ga), $299b6c40adc500b8$var$X(this, $299b6c40adc500b8$var$Ka), $299b6c40adc500b8$var$X(this, $299b6c40adc500b8$var$qa), $299b6c40adc500b8$var$X(this, $299b6c40adc500b8$var$Oe, void 0), $299b6c40adc500b8$var$X(this, $299b6c40adc500b8$var$Kn, void 0), $299b6c40adc500b8$var$X(this, $299b6c40adc500b8$var$Nn, void 0), $299b6c40adc500b8$var$X(this, $299b6c40adc500b8$var$Un, void 0), $299b6c40adc500b8$var$X(this, $299b6c40adc500b8$var$ke, {}), $299b6c40adc500b8$var$X(this, $299b6c40adc500b8$var$$n, []), $299b6c40adc500b8$var$X(this, $299b6c40adc500b8$var$Hn, ()=>{
            if (this.range.matches(":focus-visible")) {
                let { style: e } = $299b6c40adc500b8$var$O(this.shadowRoot, ":host");
                e.setProperty("--_focus-visible-box-shadow", "var(--_focus-box-shadow)");
            }
        }), $299b6c40adc500b8$var$X(this, $299b6c40adc500b8$var$Vn, ()=>{
            let { style: e } = $299b6c40adc500b8$var$O(this.shadowRoot, ":host");
            e.removeProperty("--_focus-visible-box-shadow");
        }), $299b6c40adc500b8$var$X(this, $299b6c40adc500b8$var$Wn, ()=>{
            let e = this.shadowRoot.querySelector("#segments-clipping");
            e && e.parentNode.append(e);
        }), !this.shadowRoot) {
            this.attachShadow(this.constructor.shadowRootOptions);
            let e = $299b6c40adc500b8$var$W(this.attributes), t = this.constructor.getTemplateHTML(e);
            this.shadowRoot.setHTMLUnsafe ? this.shadowRoot.setHTMLUnsafe(t) : this.shadowRoot.innerHTML = t;
        }
        this.container = this.shadowRoot.querySelector("#container"), $299b6c40adc500b8$var$ut(this, $299b6c40adc500b8$var$Nn, this.shadowRoot.querySelector("#startpoint")), $299b6c40adc500b8$var$ut(this, $299b6c40adc500b8$var$Un, this.shadowRoot.querySelector("#endpoint")), this.range = this.shadowRoot.querySelector("#range"), this.appearance = this.shadowRoot.querySelector("#appearance");
    }
    static get observedAttributes() {
        return [
            "disabled",
            "aria-disabled",
            $299b6c40adc500b8$var$I.MEDIA_CONTROLLER
        ];
    }
    attributeChangedCallback(e, t, r) {
        var n1, s, o, d, u;
        e === $299b6c40adc500b8$var$I.MEDIA_CONTROLLER ? (t && ((s = (n1 = $299b6c40adc500b8$var$B(this, $299b6c40adc500b8$var$Oe)) == null ? void 0 : n1.unassociateElement) == null || s.call(n1, this), $299b6c40adc500b8$var$ut(this, $299b6c40adc500b8$var$Oe, null)), r && this.isConnected && ($299b6c40adc500b8$var$ut(this, $299b6c40adc500b8$var$Oe, (o = this.getRootNode()) == null ? void 0 : o.getElementById(r)), (u = (d = $299b6c40adc500b8$var$B(this, $299b6c40adc500b8$var$Oe)) == null ? void 0 : d.associateElement) == null || u.call(d, this))) : (e === "disabled" || e === "aria-disabled" && t !== r) && (r == null ? (this.range.removeAttribute(e), $299b6c40adc500b8$var$ye(this, $299b6c40adc500b8$var$Fn, $299b6c40adc500b8$var$Fa).call(this)) : (this.range.setAttribute(e, r), $299b6c40adc500b8$var$ye(this, $299b6c40adc500b8$var$Bn, $299b6c40adc500b8$var$Ba).call(this)));
    }
    connectedCallback() {
        var e, t, r;
        let { style: n1 } = $299b6c40adc500b8$var$O(this.shadowRoot, ":host");
        n1.setProperty("display", `var(--media-control-display, var(--${this.localName}-display, inline-flex))`), $299b6c40adc500b8$var$B(this, $299b6c40adc500b8$var$ke).pointer = $299b6c40adc500b8$var$O(this.shadowRoot, "#pointer"), $299b6c40adc500b8$var$B(this, $299b6c40adc500b8$var$ke).progress = $299b6c40adc500b8$var$O(this.shadowRoot, "#progress"), $299b6c40adc500b8$var$B(this, $299b6c40adc500b8$var$ke).thumb = $299b6c40adc500b8$var$O(this.shadowRoot, '#thumb, ::slotted([slot="thumb"])'), $299b6c40adc500b8$var$B(this, $299b6c40adc500b8$var$ke).activeSegment = $299b6c40adc500b8$var$O(this.shadowRoot, "#segments-clipping rect:nth-child(0)");
        let s = this.getAttribute($299b6c40adc500b8$var$I.MEDIA_CONTROLLER);
        s && ($299b6c40adc500b8$var$ut(this, $299b6c40adc500b8$var$Oe, (e = this.getRootNode()) == null ? void 0 : e.getElementById(s)), (r = (t = $299b6c40adc500b8$var$B(this, $299b6c40adc500b8$var$Oe)) == null ? void 0 : t.associateElement) == null || r.call(t, this)), this.updateBar(), this.shadowRoot.addEventListener("focusin", $299b6c40adc500b8$var$B(this, $299b6c40adc500b8$var$Hn)), this.shadowRoot.addEventListener("focusout", $299b6c40adc500b8$var$B(this, $299b6c40adc500b8$var$Vn)), $299b6c40adc500b8$var$ye(this, $299b6c40adc500b8$var$Fn, $299b6c40adc500b8$var$Fa).call(this), $299b6c40adc500b8$var$qe(this.container, $299b6c40adc500b8$var$B(this, $299b6c40adc500b8$var$Wn));
    }
    disconnectedCallback() {
        var e, t;
        $299b6c40adc500b8$var$ye(this, $299b6c40adc500b8$var$Bn, $299b6c40adc500b8$var$Ba).call(this), (t = (e = $299b6c40adc500b8$var$B(this, $299b6c40adc500b8$var$Oe)) == null ? void 0 : e.unassociateElement) == null || t.call(e, this), $299b6c40adc500b8$var$ut(this, $299b6c40adc500b8$var$Oe, null), this.shadowRoot.removeEventListener("focusin", $299b6c40adc500b8$var$B(this, $299b6c40adc500b8$var$Hn)), this.shadowRoot.removeEventListener("focusout", $299b6c40adc500b8$var$B(this, $299b6c40adc500b8$var$Vn)), $299b6c40adc500b8$var$Ye(this.container, $299b6c40adc500b8$var$B(this, $299b6c40adc500b8$var$Wn));
    }
    updatePointerBar(e) {
        var t;
        (t = $299b6c40adc500b8$var$B(this, $299b6c40adc500b8$var$ke).pointer) == null || t.style.setProperty("width", `${this.getPointerRatio(e) * 100}%`);
    }
    updateBar() {
        var e, t;
        let r = this.range.valueAsNumber * 100;
        (e = $299b6c40adc500b8$var$B(this, $299b6c40adc500b8$var$ke).progress) == null || e.style.setProperty("width", `${r}%`), (t = $299b6c40adc500b8$var$B(this, $299b6c40adc500b8$var$ke).thumb) == null || t.style.setProperty("left", `${r}%`);
    }
    updateSegments(e) {
        let t = this.shadowRoot.querySelector("#segments-clipping");
        if (t.textContent = "", this.container.classList.toggle("segments", !!e?.length), !e?.length) return;
        let r = [
            ...new Set([
                +this.range.min,
                ...e.flatMap((s)=>[
                        s.start,
                        s.end
                    ]),
                +this.range.max
            ])
        ];
        $299b6c40adc500b8$var$ut(this, $299b6c40adc500b8$var$$n, [
            ...r
        ]);
        let n1 = r.pop();
        for (let [s, o] of r.entries()){
            let [d, u] = [
                s === 0,
                s === r.length - 1
            ], m = d ? "calc(var(--segments-gap) / -1)" : `${o * 100}%`, g = `calc(${((u ? n1 : r[s + 1]) - o) * 100}%${d || u ? "" : " - var(--segments-gap)"})`, v = $299b6c40adc500b8$var$F.createElementNS("http://www.w3.org/2000/svg", "rect"), E = $299b6c40adc500b8$var$O(this.shadowRoot, `#segments-clipping rect:nth-child(${s + 1})`);
            E.style.setProperty("x", m), E.style.setProperty("width", g), t.append(v);
        }
    }
    getPointerRatio(e) {
        return $299b6c40adc500b8$var$Wl(e.clientX, e.clientY, $299b6c40adc500b8$var$B(this, $299b6c40adc500b8$var$Nn).getBoundingClientRect(), $299b6c40adc500b8$var$B(this, $299b6c40adc500b8$var$Un).getBoundingClientRect());
    }
    get dragging() {
        return this.hasAttribute("dragging");
    }
    handleEvent(e) {
        switch(e.type){
            case "pointermove":
                $299b6c40adc500b8$var$ye(this, $299b6c40adc500b8$var$qa, $299b6c40adc500b8$var$Qd).call(this, e);
                break;
            case "input":
                this.updateBar();
                break;
            case "pointerenter":
                $299b6c40adc500b8$var$ye(this, $299b6c40adc500b8$var$$a, $299b6c40adc500b8$var$qd).call(this, e);
                break;
            case "pointerdown":
                $299b6c40adc500b8$var$ye(this, $299b6c40adc500b8$var$Gn, $299b6c40adc500b8$var$Qa).call(this, e);
                break;
            case "pointerup":
                $299b6c40adc500b8$var$ye(this, $299b6c40adc500b8$var$Ga, $299b6c40adc500b8$var$Yd).call(this);
                break;
            case "pointerleave":
                $299b6c40adc500b8$var$ye(this, $299b6c40adc500b8$var$Ka, $299b6c40adc500b8$var$Zd).call(this);
                break;
        }
    }
    get keysUsed() {
        return [
            "ArrowUp",
            "ArrowRight",
            "ArrowDown",
            "ArrowLeft"
        ];
    }
};
$299b6c40adc500b8$var$Oe = new WeakMap;
$299b6c40adc500b8$var$Kn = new WeakMap;
$299b6c40adc500b8$var$Nn = new WeakMap;
$299b6c40adc500b8$var$Un = new WeakMap;
$299b6c40adc500b8$var$ke = new WeakMap;
$299b6c40adc500b8$var$$n = new WeakMap;
$299b6c40adc500b8$var$Hn = new WeakMap;
$299b6c40adc500b8$var$Vn = new WeakMap;
$299b6c40adc500b8$var$Wn = new WeakMap;
$299b6c40adc500b8$var$Za = new WeakSet;
$299b6c40adc500b8$var$Kd = function(i) {
    let e = $299b6c40adc500b8$var$B(this, $299b6c40adc500b8$var$ke).activeSegment;
    if (!e) return;
    let t = this.getPointerRatio(i), n1 = `#segments-clipping rect:nth-child(${$299b6c40adc500b8$var$B(this, $299b6c40adc500b8$var$$n).findIndex((s, o, d)=>{
        let u = d[o + 1];
        return u != null && t >= s && t <= u;
    }) + 1})`;
    (e.selectorText != n1 || !e.style.transform) && (e.selectorText = n1, e.style.setProperty("transform", "var(--media-range-segment-hover-transform, scaleY(2))"));
};
$299b6c40adc500b8$var$Fn = new WeakSet;
$299b6c40adc500b8$var$Fa = function() {
    this.hasAttribute("disabled") || (this.addEventListener("input", this), this.addEventListener("pointerdown", this), this.addEventListener("pointerenter", this));
};
$299b6c40adc500b8$var$Bn = new WeakSet;
$299b6c40adc500b8$var$Ba = function() {
    var i, e;
    this.removeEventListener("input", this), this.removeEventListener("pointerdown", this), this.removeEventListener("pointerenter", this), (i = $299b6c40adc500b8$var$l.window) == null || i.removeEventListener("pointerup", this), (e = $299b6c40adc500b8$var$l.window) == null || e.removeEventListener("pointermove", this);
};
$299b6c40adc500b8$var$Gn = new WeakSet;
$299b6c40adc500b8$var$Qa = function(i) {
    var e;
    $299b6c40adc500b8$var$ut(this, $299b6c40adc500b8$var$Kn, i.composedPath().includes(this.range)), (e = $299b6c40adc500b8$var$l.window) == null || e.addEventListener("pointerup", this);
};
$299b6c40adc500b8$var$$a = new WeakSet;
$299b6c40adc500b8$var$qd = function(i) {
    var e;
    i.pointerType !== "mouse" && $299b6c40adc500b8$var$ye(this, $299b6c40adc500b8$var$Gn, $299b6c40adc500b8$var$Qa).call(this, i), this.addEventListener("pointerleave", this), (e = $299b6c40adc500b8$var$l.window) == null || e.addEventListener("pointermove", this);
};
$299b6c40adc500b8$var$Ga = new WeakSet;
$299b6c40adc500b8$var$Yd = function() {
    var i;
    (i = $299b6c40adc500b8$var$l.window) == null || i.removeEventListener("pointerup", this), this.toggleAttribute("dragging", !1), this.range.disabled = this.hasAttribute("disabled");
};
$299b6c40adc500b8$var$Ka = new WeakSet;
$299b6c40adc500b8$var$Zd = function() {
    var i, e;
    this.removeEventListener("pointerleave", this), (i = $299b6c40adc500b8$var$l.window) == null || i.removeEventListener("pointermove", this), this.toggleAttribute("dragging", !1), this.range.disabled = this.hasAttribute("disabled"), (e = $299b6c40adc500b8$var$B(this, $299b6c40adc500b8$var$ke).activeSegment) == null || e.style.removeProperty("transform");
};
$299b6c40adc500b8$var$qa = new WeakSet;
$299b6c40adc500b8$var$Qd = function(i) {
    this.toggleAttribute("dragging", i.buttons === 1 || i.pointerType !== "mouse"), this.updatePointerBar(i), $299b6c40adc500b8$var$ye(this, $299b6c40adc500b8$var$Za, $299b6c40adc500b8$var$Kd).call(this, i), this.dragging && (i.pointerType !== "mouse" || !$299b6c40adc500b8$var$B(this, $299b6c40adc500b8$var$Kn)) && (this.range.disabled = !0, this.range.valueAsNumber = this.getPointerRatio(i), this.range.dispatchEvent(new Event("input", {
        bubbles: !0,
        composed: !0
    })));
};
$299b6c40adc500b8$var$xe.shadowRootOptions = {
    mode: "open"
};
$299b6c40adc500b8$var$xe.getTemplateHTML = $299b6c40adc500b8$var$Eh;
$299b6c40adc500b8$var$l.customElements.get("media-chrome-range") || $299b6c40adc500b8$var$l.customElements.define("media-chrome-range", $299b6c40adc500b8$var$xe);
var $299b6c40adc500b8$var$zd = (i, e, t)=>{
    if (!e.has(i)) throw TypeError("Cannot " + t);
}, $299b6c40adc500b8$var$qn = (i, e, t)=>($299b6c40adc500b8$var$zd(i, e, "read from private field"), t ? t.call(i) : e.get(i)), $299b6c40adc500b8$var$gh = (i, e, t)=>{
    if (e.has(i)) throw TypeError("Cannot add the same private member more than once");
    e instanceof WeakSet ? e.add(i) : e.set(i, t);
}, $299b6c40adc500b8$var$Yn = (i, e, t, r)=>($299b6c40adc500b8$var$zd(i, e, "write to private field"), r ? r.call(i, t) : e.set(i, t), t), $299b6c40adc500b8$var$Ne;
function $299b6c40adc500b8$var$bh(i) {
    return `
    <style>
      :host {
        
        box-sizing: border-box;
        display: var(--media-control-display, var(--media-control-bar-display, inline-flex));
        color: var(--media-text-color, var(--media-primary-color, rgb(238 238 238)));
        --media-loading-indicator-icon-height: 44px;
      }

      ::slotted(media-time-range),
      ::slotted(media-volume-range) {
        min-height: 100%;
      }

      ::slotted(media-time-range),
      ::slotted(media-clip-selector) {
        flex-grow: 1;
      }

      ::slotted([role="menu"]) {
        position: absolute;
      }
    </style>

    <slot></slot>
  `;
}
var $299b6c40adc500b8$var$nr = class extends $299b6c40adc500b8$var$l.HTMLElement {
    constructor(){
        if (super(), $299b6c40adc500b8$var$gh(this, $299b6c40adc500b8$var$Ne, void 0), !this.shadowRoot) {
            this.attachShadow(this.constructor.shadowRootOptions);
            let e = $299b6c40adc500b8$var$W(this.attributes);
            this.shadowRoot.innerHTML = this.constructor.getTemplateHTML(e);
        }
    }
    static get observedAttributes() {
        return [
            $299b6c40adc500b8$var$I.MEDIA_CONTROLLER
        ];
    }
    attributeChangedCallback(e, t, r) {
        var n1, s, o, d, u;
        e === $299b6c40adc500b8$var$I.MEDIA_CONTROLLER && (t && ((s = (n1 = $299b6c40adc500b8$var$qn(this, $299b6c40adc500b8$var$Ne)) == null ? void 0 : n1.unassociateElement) == null || s.call(n1, this), $299b6c40adc500b8$var$Yn(this, $299b6c40adc500b8$var$Ne, null)), r && this.isConnected && ($299b6c40adc500b8$var$Yn(this, $299b6c40adc500b8$var$Ne, (o = this.getRootNode()) == null ? void 0 : o.getElementById(r)), (u = (d = $299b6c40adc500b8$var$qn(this, $299b6c40adc500b8$var$Ne)) == null ? void 0 : d.associateElement) == null || u.call(d, this)));
    }
    connectedCallback() {
        var e, t, r;
        let n1 = this.getAttribute($299b6c40adc500b8$var$I.MEDIA_CONTROLLER);
        n1 && ($299b6c40adc500b8$var$Yn(this, $299b6c40adc500b8$var$Ne, (e = this.getRootNode()) == null ? void 0 : e.getElementById(n1)), (r = (t = $299b6c40adc500b8$var$qn(this, $299b6c40adc500b8$var$Ne)) == null ? void 0 : t.associateElement) == null || r.call(t, this));
    }
    disconnectedCallback() {
        var e, t;
        (t = (e = $299b6c40adc500b8$var$qn(this, $299b6c40adc500b8$var$Ne)) == null ? void 0 : e.unassociateElement) == null || t.call(e, this), $299b6c40adc500b8$var$Yn(this, $299b6c40adc500b8$var$Ne, null);
    }
};
$299b6c40adc500b8$var$Ne = new WeakMap;
$299b6c40adc500b8$var$nr.shadowRootOptions = {
    mode: "open"
};
$299b6c40adc500b8$var$nr.getTemplateHTML = $299b6c40adc500b8$var$bh;
$299b6c40adc500b8$var$l.customElements.get("media-control-bar") || $299b6c40adc500b8$var$l.customElements.define("media-control-bar", $299b6c40adc500b8$var$nr);
var $299b6c40adc500b8$var$Xd = (i, e, t)=>{
    if (!e.has(i)) throw TypeError("Cannot " + t);
}, $299b6c40adc500b8$var$Zn = (i, e, t)=>($299b6c40adc500b8$var$Xd(i, e, "read from private field"), t ? t.call(i) : e.get(i)), $299b6c40adc500b8$var$fh = (i, e, t)=>{
    if (e.has(i)) throw TypeError("Cannot add the same private member more than once");
    e instanceof WeakSet ? e.add(i) : e.set(i, t);
}, $299b6c40adc500b8$var$Qn = (i, e, t, r)=>($299b6c40adc500b8$var$Xd(i, e, "write to private field"), r ? r.call(i, t) : e.set(i, t), t), $299b6c40adc500b8$var$Ue;
function $299b6c40adc500b8$var$_h(i, e = {}) {
    return `
    <style>
      :host {
        font: var(--media-font,
          var(--media-font-weight, normal)
          var(--media-font-size, 14px) /
          var(--media-text-content-height, var(--media-control-height, 24px))
          var(--media-font-family, helvetica neue, segoe ui, roboto, arial, sans-serif));
        color: var(--media-text-color, var(--media-primary-color, rgb(238 238 238)));
        background: var(--media-text-background, var(--media-control-background, var(--media-secondary-color, rgb(20 20 30 / .7))));
        padding: var(--media-control-padding, 10px);
        display: inline-flex;
        justify-content: center;
        align-items: center;
        vertical-align: middle;
        box-sizing: border-box;
        text-align: center;
        pointer-events: auto;
      }

      
      :host(:focus-visible) {
        box-shadow: inset 0 0 0 2px rgb(27 127 204 / .9);
        outline: 0;
      }

      
      :host(:where(:focus)) {
        box-shadow: none;
        outline: 0;
      }
    </style>

    ${this.getSlotTemplateHTML(i, e)}
  `;
}
function $299b6c40adc500b8$var$Th(i, e) {
    return `
    <slot></slot>
  `;
}
var $299b6c40adc500b8$var$se = class extends $299b6c40adc500b8$var$l.HTMLElement {
    constructor(){
        if (super(), $299b6c40adc500b8$var$fh(this, $299b6c40adc500b8$var$Ue, void 0), !this.shadowRoot) {
            this.attachShadow(this.constructor.shadowRootOptions);
            let e = $299b6c40adc500b8$var$W(this.attributes);
            this.shadowRoot.innerHTML = this.constructor.getTemplateHTML(e);
        }
    }
    static get observedAttributes() {
        return [
            $299b6c40adc500b8$var$I.MEDIA_CONTROLLER
        ];
    }
    attributeChangedCallback(e, t, r) {
        var n1, s, o, d, u;
        e === $299b6c40adc500b8$var$I.MEDIA_CONTROLLER && (t && ((s = (n1 = $299b6c40adc500b8$var$Zn(this, $299b6c40adc500b8$var$Ue)) == null ? void 0 : n1.unassociateElement) == null || s.call(n1, this), $299b6c40adc500b8$var$Qn(this, $299b6c40adc500b8$var$Ue, null)), r && this.isConnected && ($299b6c40adc500b8$var$Qn(this, $299b6c40adc500b8$var$Ue, (o = this.getRootNode()) == null ? void 0 : o.getElementById(r)), (u = (d = $299b6c40adc500b8$var$Zn(this, $299b6c40adc500b8$var$Ue)) == null ? void 0 : d.associateElement) == null || u.call(d, this)));
    }
    connectedCallback() {
        var e, t, r;
        let { style: n1 } = $299b6c40adc500b8$var$O(this.shadowRoot, ":host");
        n1.setProperty("display", `var(--media-control-display, var(--${this.localName}-display, inline-flex))`);
        let s = this.getAttribute($299b6c40adc500b8$var$I.MEDIA_CONTROLLER);
        s && ($299b6c40adc500b8$var$Qn(this, $299b6c40adc500b8$var$Ue, (e = this.getRootNode()) == null ? void 0 : e.getElementById(s)), (r = (t = $299b6c40adc500b8$var$Zn(this, $299b6c40adc500b8$var$Ue)) == null ? void 0 : t.associateElement) == null || r.call(t, this));
    }
    disconnectedCallback() {
        var e, t;
        (t = (e = $299b6c40adc500b8$var$Zn(this, $299b6c40adc500b8$var$Ue)) == null ? void 0 : e.unassociateElement) == null || t.call(e, this), $299b6c40adc500b8$var$Qn(this, $299b6c40adc500b8$var$Ue, null);
    }
};
$299b6c40adc500b8$var$Ue = new WeakMap;
$299b6c40adc500b8$var$se.shadowRootOptions = {
    mode: "open"
};
$299b6c40adc500b8$var$se.getTemplateHTML = $299b6c40adc500b8$var$_h;
$299b6c40adc500b8$var$se.getSlotTemplateHTML = $299b6c40adc500b8$var$Th;
$299b6c40adc500b8$var$l.customElements.get("media-text-display") || $299b6c40adc500b8$var$l.customElements.define("media-text-display", $299b6c40adc500b8$var$se);
var $299b6c40adc500b8$var$jd = (i, e, t)=>{
    if (!e.has(i)) throw TypeError("Cannot " + t);
}, $299b6c40adc500b8$var$Jd = (i, e, t)=>($299b6c40adc500b8$var$jd(i, e, "read from private field"), t ? t.call(i) : e.get(i)), $299b6c40adc500b8$var$Ah = (i, e, t)=>{
    if (e.has(i)) throw TypeError("Cannot add the same private member more than once");
    e instanceof WeakSet ? e.add(i) : e.set(i, t);
}, $299b6c40adc500b8$var$yh = (i, e, t, r)=>($299b6c40adc500b8$var$jd(i, e, "write to private field"), r ? r.call(i, t) : e.set(i, t), t), $299b6c40adc500b8$var$sr;
function $299b6c40adc500b8$var$kh(i, e) {
    return `
    <slot>${$299b6c40adc500b8$var$Ae(e.mediaDuration)}</slot>
  `;
}
var $299b6c40adc500b8$var$zn = class extends $299b6c40adc500b8$var$se {
    constructor(){
        var e;
        super(), $299b6c40adc500b8$var$Ah(this, $299b6c40adc500b8$var$sr, void 0), $299b6c40adc500b8$var$yh(this, $299b6c40adc500b8$var$sr, this.shadowRoot.querySelector("slot")), $299b6c40adc500b8$var$Jd(this, $299b6c40adc500b8$var$sr).textContent = $299b6c40adc500b8$var$Ae((e = this.mediaDuration) != null ? e : 0);
    }
    static get observedAttributes() {
        return [
            ...super.observedAttributes,
            $299b6c40adc500b8$var$a.MEDIA_DURATION
        ];
    }
    attributeChangedCallback(e, t, r) {
        e === $299b6c40adc500b8$var$a.MEDIA_DURATION && ($299b6c40adc500b8$var$Jd(this, $299b6c40adc500b8$var$sr).textContent = $299b6c40adc500b8$var$Ae(+r)), super.attributeChangedCallback(e, t, r);
    }
    get mediaDuration() {
        return $299b6c40adc500b8$var$M(this, $299b6c40adc500b8$var$a.MEDIA_DURATION);
    }
    set mediaDuration(e) {
        $299b6c40adc500b8$var$w(this, $299b6c40adc500b8$var$a.MEDIA_DURATION, e);
    }
};
$299b6c40adc500b8$var$sr = new WeakMap;
$299b6c40adc500b8$var$zn.getSlotTemplateHTML = $299b6c40adc500b8$var$kh;
$299b6c40adc500b8$var$l.customElements.get("media-duration-display") || $299b6c40adc500b8$var$l.customElements.define("media-duration-display", $299b6c40adc500b8$var$zn);
var $299b6c40adc500b8$var$Ih = {
    2: $299b6c40adc500b8$var$c("Network Error"),
    3: $299b6c40adc500b8$var$c("Decode Error"),
    4: $299b6c40adc500b8$var$c("Source Not Supported"),
    5: $299b6c40adc500b8$var$c("Encryption Error")
}, $299b6c40adc500b8$var$Sh = {
    2: $299b6c40adc500b8$var$c("A network error caused the media download to fail."),
    3: $299b6c40adc500b8$var$c("A media error caused playback to be aborted. The media could be corrupt or your browser does not support this format."),
    4: $299b6c40adc500b8$var$c("An unsupported error occurred. The server or network failed, or your browser does not support this format."),
    5: $299b6c40adc500b8$var$c("The media is encrypted and there are no keys to decrypt it.")
}, $299b6c40adc500b8$var$za = (i)=>{
    var e, t;
    return i.code === 1 ? null : {
        title: (e = $299b6c40adc500b8$var$Ih[i.code]) != null ? e : `Error ${i.code}`,
        message: (t = $299b6c40adc500b8$var$Sh[i.code]) != null ? t : i.message
    };
};
var $299b6c40adc500b8$var$tu = (i, e, t)=>{
    if (!e.has(i)) throw TypeError("Cannot " + t);
}, $299b6c40adc500b8$var$Mh = (i, e, t)=>($299b6c40adc500b8$var$tu(i, e, "read from private field"), t ? t.call(i) : e.get(i)), $299b6c40adc500b8$var$Lh = (i, e, t)=>{
    if (e.has(i)) throw TypeError("Cannot add the same private member more than once");
    e instanceof WeakSet ? e.add(i) : e.set(i, t);
}, $299b6c40adc500b8$var$wh = (i, e, t, r)=>($299b6c40adc500b8$var$tu(i, e, "write to private field"), r ? r.call(i, t) : e.set(i, t), t), $299b6c40adc500b8$var$Xn;
function $299b6c40adc500b8$var$Ch(i) {
    return `
    <style>
      :host {
        background: rgb(20 20 30 / .8);
      }

      #content {
        display: block;
        padding: 1.2em 1.5em;
      }

      h3,
      p {
        margin-block: 0 .3em;
      }
    </style>
    <slot name="error-${i.mediaerrorcode}" id="content">
      ${$299b6c40adc500b8$var$iu({
        code: +i.mediaerrorcode,
        message: i.mediaerrormessage
    })}
    </slot>
  `;
}
function $299b6c40adc500b8$var$Rh(i) {
    return i.code && $299b6c40adc500b8$var$za(i) !== null;
}
function $299b6c40adc500b8$var$iu(i) {
    var e;
    let { title: t, message: r } = (e = $299b6c40adc500b8$var$za(i)) != null ? e : {}, n1 = "";
    return t && (n1 += `<slot name="error-${i.code}-title"><h3>${t}</h3></slot>`), r && (n1 += `<slot name="error-${i.code}-message"><p>${r}</p></slot>`), n1;
}
var $299b6c40adc500b8$var$eu = [
    $299b6c40adc500b8$var$a.MEDIA_ERROR_CODE,
    $299b6c40adc500b8$var$a.MEDIA_ERROR_MESSAGE
], $299b6c40adc500b8$var$ar = class extends $299b6c40adc500b8$var$dt {
    constructor(){
        super(...arguments), $299b6c40adc500b8$var$Lh(this, $299b6c40adc500b8$var$Xn, null);
    }
    static get observedAttributes() {
        return [
            ...super.observedAttributes,
            ...$299b6c40adc500b8$var$eu
        ];
    }
    formatErrorMessage(e) {
        return this.constructor.formatErrorMessage(e);
    }
    attributeChangedCallback(e, t, r) {
        var n1;
        if (super.attributeChangedCallback(e, t, r), !$299b6c40adc500b8$var$eu.includes(e)) return;
        let s = (n1 = this.mediaError) != null ? n1 : {
            code: this.mediaErrorCode,
            message: this.mediaErrorMessage
        };
        this.open = $299b6c40adc500b8$var$Rh(s), this.open && (this.shadowRoot.querySelector("slot").name = `error-${this.mediaErrorCode}`, this.shadowRoot.querySelector("#content").innerHTML = this.formatErrorMessage(s));
    }
    get mediaError() {
        return $299b6c40adc500b8$var$Mh(this, $299b6c40adc500b8$var$Xn);
    }
    set mediaError(e) {
        $299b6c40adc500b8$var$wh(this, $299b6c40adc500b8$var$Xn, e);
    }
    get mediaErrorCode() {
        return $299b6c40adc500b8$var$M(this, "mediaerrorcode");
    }
    set mediaErrorCode(e) {
        $299b6c40adc500b8$var$w(this, "mediaerrorcode", e);
    }
    get mediaErrorMessage() {
        return $299b6c40adc500b8$var$_(this, "mediaerrormessage");
    }
    set mediaErrorMessage(e) {
        $299b6c40adc500b8$var$b(this, "mediaerrormessage", e);
    }
};
$299b6c40adc500b8$var$Xn = new WeakMap;
$299b6c40adc500b8$var$ar.getSlotTemplateHTML = $299b6c40adc500b8$var$Ch;
$299b6c40adc500b8$var$ar.formatErrorMessage = $299b6c40adc500b8$var$iu;
$299b6c40adc500b8$var$l.customElements.get("media-error-dialog") || $299b6c40adc500b8$var$l.customElements.define("media-error-dialog", $299b6c40adc500b8$var$ar);
var $299b6c40adc500b8$var$Ph = `<svg aria-hidden="true" viewBox="0 0 26 24">
  <path d="M16 3v2.5h3.5V9H22V3h-6ZM4 9h2.5V5.5H10V3H4v6Zm15.5 9.5H16V21h6v-6h-2.5v3.5ZM6.5 15H4v6h6v-2.5H6.5V15Z"/>
</svg>`, $299b6c40adc500b8$var$Dh = `<svg aria-hidden="true" viewBox="0 0 26 24">
  <path d="M18.5 6.5V3H16v6h6V6.5h-3.5ZM16 21h2.5v-3.5H22V15h-6v6ZM4 17.5h3.5V21H10v-6H4v2.5Zm3.5-11H4V9h6V3H7.5v3.5Z"/>
</svg>`;
function $299b6c40adc500b8$var$Oh(i) {
    return `
    <style>
      :host([${$299b6c40adc500b8$var$a.MEDIA_IS_FULLSCREEN}]) slot[name=icon] slot:not([name=exit]) {
        display: none !important;
      }

      
      :host(:not([${$299b6c40adc500b8$var$a.MEDIA_IS_FULLSCREEN}])) slot[name=icon] slot:not([name=enter]) {
        display: none !important;
      }

      :host([${$299b6c40adc500b8$var$a.MEDIA_IS_FULLSCREEN}]) slot[name=tooltip-enter],
      :host(:not([${$299b6c40adc500b8$var$a.MEDIA_IS_FULLSCREEN}])) slot[name=tooltip-exit] {
        display: none;
      }
    </style>

    <slot name="icon">
      <slot name="enter">${$299b6c40adc500b8$var$Ph}</slot>
      <slot name="exit">${$299b6c40adc500b8$var$Dh}</slot>
    </slot>
  `;
}
function $299b6c40adc500b8$var$xh() {
    return `
    <slot name="tooltip-enter">${$299b6c40adc500b8$var$c("Enter fullscreen mode")}</slot>
    <slot name="tooltip-exit">${$299b6c40adc500b8$var$c("Exit fullscreen mode")}</slot>
  `;
}
var $299b6c40adc500b8$var$ru = (i)=>{
    let e = i.mediaIsFullscreen ? $299b6c40adc500b8$var$c("exit fullscreen mode") : $299b6c40adc500b8$var$c("enter fullscreen mode");
    i.setAttribute("aria-label", e);
}, $299b6c40adc500b8$var$or = class extends $299b6c40adc500b8$var$P {
    static get observedAttributes() {
        return [
            ...super.observedAttributes,
            $299b6c40adc500b8$var$a.MEDIA_IS_FULLSCREEN,
            $299b6c40adc500b8$var$a.MEDIA_FULLSCREEN_UNAVAILABLE
        ];
    }
    connectedCallback() {
        super.connectedCallback(), $299b6c40adc500b8$var$ru(this);
    }
    attributeChangedCallback(e, t, r) {
        super.attributeChangedCallback(e, t, r), e === $299b6c40adc500b8$var$a.MEDIA_IS_FULLSCREEN && $299b6c40adc500b8$var$ru(this);
    }
    get mediaFullscreenUnavailable() {
        return $299b6c40adc500b8$var$_(this, $299b6c40adc500b8$var$a.MEDIA_FULLSCREEN_UNAVAILABLE);
    }
    set mediaFullscreenUnavailable(e) {
        $299b6c40adc500b8$var$b(this, $299b6c40adc500b8$var$a.MEDIA_FULLSCREEN_UNAVAILABLE, e);
    }
    get mediaIsFullscreen() {
        return $299b6c40adc500b8$var$A(this, $299b6c40adc500b8$var$a.MEDIA_IS_FULLSCREEN);
    }
    set mediaIsFullscreen(e) {
        $299b6c40adc500b8$var$y(this, $299b6c40adc500b8$var$a.MEDIA_IS_FULLSCREEN, e);
    }
    handleClick() {
        let e = this.mediaIsFullscreen ? $299b6c40adc500b8$var$h.MEDIA_EXIT_FULLSCREEN_REQUEST : $299b6c40adc500b8$var$h.MEDIA_ENTER_FULLSCREEN_REQUEST;
        this.dispatchEvent(new $299b6c40adc500b8$var$l.CustomEvent(e, {
            composed: !0,
            bubbles: !0
        }));
    }
};
$299b6c40adc500b8$var$or.getSlotTemplateHTML = $299b6c40adc500b8$var$Oh;
$299b6c40adc500b8$var$or.getTooltipContentHTML = $299b6c40adc500b8$var$xh;
$299b6c40adc500b8$var$l.customElements.get("media-fullscreen-button") || $299b6c40adc500b8$var$l.customElements.define("media-fullscreen-button", $299b6c40adc500b8$var$or);
var { MEDIA_TIME_IS_LIVE: $299b6c40adc500b8$var$Jn, MEDIA_PAUSED: $299b6c40adc500b8$var$lr } = $299b6c40adc500b8$var$a, { MEDIA_SEEK_TO_LIVE_REQUEST: $299b6c40adc500b8$var$Nh, MEDIA_PLAY_REQUEST: $299b6c40adc500b8$var$Uh } = $299b6c40adc500b8$var$h, $299b6c40adc500b8$var$Hh = '<svg viewBox="0 0 6 12"><circle cx="3" cy="6" r="2"></circle></svg>';
function $299b6c40adc500b8$var$Vh(i) {
    return `
    <style>
      :host { --media-tooltip-display: none; }
      
      slot[name=indicator] > *,
      :host ::slotted([slot=indicator]) {
        
        min-width: auto;
        fill: var(--media-live-button-icon-color, rgb(140, 140, 140));
        color: var(--media-live-button-icon-color, rgb(140, 140, 140));
      }

      :host([${$299b6c40adc500b8$var$Jn}]:not([${$299b6c40adc500b8$var$lr}])) slot[name=indicator] > *,
      :host([${$299b6c40adc500b8$var$Jn}]:not([${$299b6c40adc500b8$var$lr}])) ::slotted([slot=indicator]) {
        fill: var(--media-live-button-indicator-color, rgb(255, 0, 0));
        color: var(--media-live-button-indicator-color, rgb(255, 0, 0));
      }

      :host([${$299b6c40adc500b8$var$Jn}]:not([${$299b6c40adc500b8$var$lr}])) {
        cursor: var(--media-cursor, not-allowed);
      }

      slot[name=text]{
        text-transform: uppercase;
      }

    </style>

    <slot name="indicator">${$299b6c40adc500b8$var$Hh}</slot>
    
    <slot name="spacer">&nbsp;</slot><slot name="text">${$299b6c40adc500b8$var$c("live")}</slot>
  `;
}
var $299b6c40adc500b8$var$nu = (i)=>{
    var e;
    let t = i.mediaPaused || !i.mediaTimeIsLive, r = t ? $299b6c40adc500b8$var$c("seek to live") : $299b6c40adc500b8$var$c("playing live");
    i.setAttribute("aria-label", r);
    let n1 = (e = i.shadowRoot) == null ? void 0 : e.querySelector('slot[name="text"]');
    n1 && (n1.textContent = $299b6c40adc500b8$var$c("live")), t ? i.removeAttribute("aria-disabled") : i.setAttribute("aria-disabled", "true");
}, $299b6c40adc500b8$var$jn = class extends $299b6c40adc500b8$var$P {
    static get observedAttributes() {
        return [
            ...super.observedAttributes,
            $299b6c40adc500b8$var$Jn,
            $299b6c40adc500b8$var$lr
        ];
    }
    connectedCallback() {
        super.connectedCallback(), $299b6c40adc500b8$var$nu(this);
    }
    attributeChangedCallback(e, t, r) {
        super.attributeChangedCallback(e, t, r), $299b6c40adc500b8$var$nu(this);
    }
    get mediaPaused() {
        return $299b6c40adc500b8$var$A(this, $299b6c40adc500b8$var$a.MEDIA_PAUSED);
    }
    set mediaPaused(e) {
        $299b6c40adc500b8$var$y(this, $299b6c40adc500b8$var$a.MEDIA_PAUSED, e);
    }
    get mediaTimeIsLive() {
        return $299b6c40adc500b8$var$A(this, $299b6c40adc500b8$var$a.MEDIA_TIME_IS_LIVE);
    }
    set mediaTimeIsLive(e) {
        $299b6c40adc500b8$var$y(this, $299b6c40adc500b8$var$a.MEDIA_TIME_IS_LIVE, e);
    }
    handleClick() {
        !this.mediaPaused && this.mediaTimeIsLive || (this.dispatchEvent(new $299b6c40adc500b8$var$l.CustomEvent($299b6c40adc500b8$var$Nh, {
            composed: !0,
            bubbles: !0
        })), this.hasAttribute($299b6c40adc500b8$var$lr) && this.dispatchEvent(new $299b6c40adc500b8$var$l.CustomEvent($299b6c40adc500b8$var$Uh, {
            composed: !0,
            bubbles: !0
        })));
    }
};
$299b6c40adc500b8$var$jn.getSlotTemplateHTML = $299b6c40adc500b8$var$Vh;
$299b6c40adc500b8$var$l.customElements.get("media-live-button") || $299b6c40adc500b8$var$l.customElements.define("media-live-button", $299b6c40adc500b8$var$jn);
var $299b6c40adc500b8$var$au = (i, e, t)=>{
    if (!e.has(i)) throw TypeError("Cannot " + t);
}, $299b6c40adc500b8$var$dr = (i, e, t)=>($299b6c40adc500b8$var$au(i, e, "read from private field"), t ? t.call(i) : e.get(i)), $299b6c40adc500b8$var$su = (i, e, t)=>{
    if (e.has(i)) throw TypeError("Cannot add the same private member more than once");
    e instanceof WeakSet ? e.add(i) : e.set(i, t);
}, $299b6c40adc500b8$var$ur = (i, e, t, r)=>($299b6c40adc500b8$var$au(i, e, "write to private field"), r ? r.call(i, t) : e.set(i, t), t), $299b6c40adc500b8$var$He, $299b6c40adc500b8$var$ts, $299b6c40adc500b8$var$es = {
    LOADING_DELAY: "loadingdelay",
    NO_AUTOHIDE: "noautohide"
}, $299b6c40adc500b8$var$ou = 500, $299b6c40adc500b8$var$Wh = `
<svg aria-hidden="true" viewBox="0 0 100 100">
  <path d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
    <animateTransform
       attributeName="transform"
       attributeType="XML"
       type="rotate"
       dur="1s"
       from="0 50 50"
       to="360 50 50"
       repeatCount="indefinite" />
  </path>
</svg>
`;
function $299b6c40adc500b8$var$Fh(i) {
    return `
    <style>
      :host {
        display: var(--media-control-display, var(--media-loading-indicator-display, inline-block));
        vertical-align: middle;
        box-sizing: border-box;
        --_loading-indicator-delay: var(--media-loading-indicator-transition-delay, ${$299b6c40adc500b8$var$ou}ms);
      }

      #status {
        color: rgba(0,0,0,0);
        width: 0px;
        height: 0px;
      }

      :host slot[name=icon] > *,
      :host ::slotted([slot=icon]) {
        opacity: var(--media-loading-indicator-opacity, 0);
        transition: opacity 0.15s;
      }

      :host([${$299b6c40adc500b8$var$a.MEDIA_LOADING}]:not([${$299b6c40adc500b8$var$a.MEDIA_PAUSED}])) slot[name=icon] > *,
      :host([${$299b6c40adc500b8$var$a.MEDIA_LOADING}]:not([${$299b6c40adc500b8$var$a.MEDIA_PAUSED}])) ::slotted([slot=icon]) {
        opacity: var(--media-loading-indicator-opacity, 1);
        transition: opacity 0.15s var(--_loading-indicator-delay);
      }

      :host #status {
        visibility: var(--media-loading-indicator-opacity, hidden);
        transition: visibility 0.15s;
      }

      :host([${$299b6c40adc500b8$var$a.MEDIA_LOADING}]:not([${$299b6c40adc500b8$var$a.MEDIA_PAUSED}])) #status {
        visibility: var(--media-loading-indicator-opacity, visible);
        transition: visibility 0.15s var(--_loading-indicator-delay);
      }

      svg, img, ::slotted(svg), ::slotted(img) {
        width: var(--media-loading-indicator-icon-width);
        height: var(--media-loading-indicator-icon-height, 100px);
        fill: var(--media-icon-color, var(--media-primary-color, rgb(238 238 238)));
        vertical-align: middle;
      }
    </style>

    <slot name="icon">${$299b6c40adc500b8$var$Wh}</slot>
    <div id="status" role="status" aria-live="polite">${$299b6c40adc500b8$var$c("media loading")}</div>
  `;
}
var $299b6c40adc500b8$var$cr = class extends $299b6c40adc500b8$var$l.HTMLElement {
    constructor(){
        if (super(), $299b6c40adc500b8$var$su(this, $299b6c40adc500b8$var$He, void 0), $299b6c40adc500b8$var$su(this, $299b6c40adc500b8$var$ts, $299b6c40adc500b8$var$ou), !this.shadowRoot) {
            this.attachShadow(this.constructor.shadowRootOptions);
            let e = $299b6c40adc500b8$var$W(this.attributes);
            this.shadowRoot.innerHTML = this.constructor.getTemplateHTML(e);
        }
    }
    static get observedAttributes() {
        return [
            $299b6c40adc500b8$var$I.MEDIA_CONTROLLER,
            $299b6c40adc500b8$var$a.MEDIA_PAUSED,
            $299b6c40adc500b8$var$a.MEDIA_LOADING,
            $299b6c40adc500b8$var$es.LOADING_DELAY
        ];
    }
    attributeChangedCallback(e, t, r) {
        var n1, s, o, d, u;
        e === $299b6c40adc500b8$var$es.LOADING_DELAY && t !== r ? this.loadingDelay = Number(r) : e === $299b6c40adc500b8$var$I.MEDIA_CONTROLLER && (t && ((s = (n1 = $299b6c40adc500b8$var$dr(this, $299b6c40adc500b8$var$He)) == null ? void 0 : n1.unassociateElement) == null || s.call(n1, this), $299b6c40adc500b8$var$ur(this, $299b6c40adc500b8$var$He, null)), r && this.isConnected && ($299b6c40adc500b8$var$ur(this, $299b6c40adc500b8$var$He, (o = this.getRootNode()) == null ? void 0 : o.getElementById(r)), (u = (d = $299b6c40adc500b8$var$dr(this, $299b6c40adc500b8$var$He)) == null ? void 0 : d.associateElement) == null || u.call(d, this)));
    }
    connectedCallback() {
        var e, t, r;
        let n1 = this.getAttribute($299b6c40adc500b8$var$I.MEDIA_CONTROLLER);
        n1 && ($299b6c40adc500b8$var$ur(this, $299b6c40adc500b8$var$He, (e = this.getRootNode()) == null ? void 0 : e.getElementById(n1)), (r = (t = $299b6c40adc500b8$var$dr(this, $299b6c40adc500b8$var$He)) == null ? void 0 : t.associateElement) == null || r.call(t, this));
    }
    disconnectedCallback() {
        var e, t;
        (t = (e = $299b6c40adc500b8$var$dr(this, $299b6c40adc500b8$var$He)) == null ? void 0 : e.unassociateElement) == null || t.call(e, this), $299b6c40adc500b8$var$ur(this, $299b6c40adc500b8$var$He, null);
    }
    get loadingDelay() {
        return $299b6c40adc500b8$var$dr(this, $299b6c40adc500b8$var$ts);
    }
    set loadingDelay(e) {
        $299b6c40adc500b8$var$ur(this, $299b6c40adc500b8$var$ts, e);
        let { style: t } = $299b6c40adc500b8$var$O(this.shadowRoot, ":host");
        t.setProperty("--_loading-indicator-delay", `var(--media-loading-indicator-transition-delay, ${e}ms)`);
    }
    get mediaPaused() {
        return $299b6c40adc500b8$var$A(this, $299b6c40adc500b8$var$a.MEDIA_PAUSED);
    }
    set mediaPaused(e) {
        $299b6c40adc500b8$var$y(this, $299b6c40adc500b8$var$a.MEDIA_PAUSED, e);
    }
    get mediaLoading() {
        return $299b6c40adc500b8$var$A(this, $299b6c40adc500b8$var$a.MEDIA_LOADING);
    }
    set mediaLoading(e) {
        $299b6c40adc500b8$var$y(this, $299b6c40adc500b8$var$a.MEDIA_LOADING, e);
    }
    get mediaController() {
        return $299b6c40adc500b8$var$_(this, $299b6c40adc500b8$var$I.MEDIA_CONTROLLER);
    }
    set mediaController(e) {
        $299b6c40adc500b8$var$b(this, $299b6c40adc500b8$var$I.MEDIA_CONTROLLER, e);
    }
    get noAutohide() {
        return $299b6c40adc500b8$var$A(this, $299b6c40adc500b8$var$es.NO_AUTOHIDE);
    }
    set noAutohide(e) {
        $299b6c40adc500b8$var$y(this, $299b6c40adc500b8$var$es.NO_AUTOHIDE, e);
    }
};
$299b6c40adc500b8$var$He = new WeakMap;
$299b6c40adc500b8$var$ts = new WeakMap;
$299b6c40adc500b8$var$cr.shadowRootOptions = {
    mode: "open"
};
$299b6c40adc500b8$var$cr.getTemplateHTML = $299b6c40adc500b8$var$Fh;
$299b6c40adc500b8$var$l.customElements.get("media-loading-indicator") || $299b6c40adc500b8$var$l.customElements.define("media-loading-indicator", $299b6c40adc500b8$var$cr);
var $299b6c40adc500b8$var$Bh = `<svg aria-hidden="true" viewBox="0 0 24 24">
  <path d="M16.5 12A4.5 4.5 0 0 0 14 8v2.18l2.45 2.45a4.22 4.22 0 0 0 .05-.63Zm2.5 0a6.84 6.84 0 0 1-.54 2.64L20 16.15A8.8 8.8 0 0 0 21 12a9 9 0 0 0-7-8.77v2.06A7 7 0 0 1 19 12ZM4.27 3 3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25A6.92 6.92 0 0 1 14 18.7v2.06A9 9 0 0 0 17.69 19l2 2.05L21 19.73l-9-9L4.27 3ZM12 4 9.91 6.09 12 8.18V4Z"/>
</svg>`, $299b6c40adc500b8$var$lu = `<svg aria-hidden="true" viewBox="0 0 24 24">
  <path d="M3 9v6h4l5 5V4L7 9H3Zm13.5 3A4.5 4.5 0 0 0 14 8v8a4.47 4.47 0 0 0 2.5-4Z"/>
</svg>`, $299b6c40adc500b8$var$$h = `<svg aria-hidden="true" viewBox="0 0 24 24">
  <path d="M3 9v6h4l5 5V4L7 9H3Zm13.5 3A4.5 4.5 0 0 0 14 8v8a4.47 4.47 0 0 0 2.5-4ZM14 3.23v2.06a7 7 0 0 1 0 13.42v2.06a9 9 0 0 0 0-17.54Z"/>
</svg>`;
function $299b6c40adc500b8$var$Gh(i) {
    return `
    <style>
      :host(:not([${$299b6c40adc500b8$var$a.MEDIA_VOLUME_LEVEL}])) slot[name=icon] slot:not([name=high]),
      :host([${$299b6c40adc500b8$var$a.MEDIA_VOLUME_LEVEL}=high]) slot[name=icon] slot:not([name=high]) {
        display: none !important;
      }

      :host([${$299b6c40adc500b8$var$a.MEDIA_VOLUME_LEVEL}=off]) slot[name=icon] slot:not([name=off]) {
        display: none !important;
      }

      :host([${$299b6c40adc500b8$var$a.MEDIA_VOLUME_LEVEL}=low]) slot[name=icon] slot:not([name=low]) {
        display: none !important;
      }

      :host([${$299b6c40adc500b8$var$a.MEDIA_VOLUME_LEVEL}=medium]) slot[name=icon] slot:not([name=medium]) {
        display: none !important;
      }

      :host(:not([${$299b6c40adc500b8$var$a.MEDIA_VOLUME_LEVEL}=off])) slot[name=tooltip-unmute],
      :host([${$299b6c40adc500b8$var$a.MEDIA_VOLUME_LEVEL}=off]) slot[name=tooltip-mute] {
        display: none;
      }
    </style>

    <slot name="icon">
      <slot name="off">${$299b6c40adc500b8$var$Bh}</slot>
      <slot name="low">${$299b6c40adc500b8$var$lu}</slot>
      <slot name="medium">${$299b6c40adc500b8$var$lu}</slot>
      <slot name="high">${$299b6c40adc500b8$var$$h}</slot>
    </slot>
  `;
}
function $299b6c40adc500b8$var$Kh() {
    return `
    <slot name="tooltip-mute">${$299b6c40adc500b8$var$c("Mute")}</slot>
    <slot name="tooltip-unmute">${$299b6c40adc500b8$var$c("Unmute")}</slot>
  `;
}
var $299b6c40adc500b8$var$du = (i)=>{
    let t = i.mediaVolumeLevel === "off" ? $299b6c40adc500b8$var$c("unmute") : $299b6c40adc500b8$var$c("mute");
    i.setAttribute("aria-label", t);
}, $299b6c40adc500b8$var$hr = class extends $299b6c40adc500b8$var$P {
    static get observedAttributes() {
        return [
            ...super.observedAttributes,
            $299b6c40adc500b8$var$a.MEDIA_VOLUME_LEVEL
        ];
    }
    connectedCallback() {
        super.connectedCallback(), $299b6c40adc500b8$var$du(this);
    }
    attributeChangedCallback(e, t, r) {
        super.attributeChangedCallback(e, t, r), e === $299b6c40adc500b8$var$a.MEDIA_VOLUME_LEVEL && $299b6c40adc500b8$var$du(this);
    }
    get mediaVolumeLevel() {
        return $299b6c40adc500b8$var$_(this, $299b6c40adc500b8$var$a.MEDIA_VOLUME_LEVEL);
    }
    set mediaVolumeLevel(e) {
        $299b6c40adc500b8$var$b(this, $299b6c40adc500b8$var$a.MEDIA_VOLUME_LEVEL, e);
    }
    handleClick() {
        let e = this.mediaVolumeLevel === "off" ? $299b6c40adc500b8$var$h.MEDIA_UNMUTE_REQUEST : $299b6c40adc500b8$var$h.MEDIA_MUTE_REQUEST;
        this.dispatchEvent(new $299b6c40adc500b8$var$l.CustomEvent(e, {
            composed: !0,
            bubbles: !0
        }));
    }
};
$299b6c40adc500b8$var$hr.getSlotTemplateHTML = $299b6c40adc500b8$var$Gh;
$299b6c40adc500b8$var$hr.getTooltipContentHTML = $299b6c40adc500b8$var$Kh;
$299b6c40adc500b8$var$l.customElements.get("media-mute-button") || $299b6c40adc500b8$var$l.customElements.define("media-mute-button", $299b6c40adc500b8$var$hr);
var $299b6c40adc500b8$var$uu = `<svg aria-hidden="true" viewBox="0 0 28 24">
  <path d="M24 3H4a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1Zm-1 16H5V5h18v14Zm-3-8h-7v5h7v-5Z"/>
</svg>`;
function $299b6c40adc500b8$var$qh(i) {
    return `
    <style>
      :host([${$299b6c40adc500b8$var$a.MEDIA_IS_PIP}]) slot[name=icon] slot:not([name=exit]) {
        display: none !important;
      }

      :host(:not([${$299b6c40adc500b8$var$a.MEDIA_IS_PIP}])) slot[name=icon] slot:not([name=enter]) {
        display: none !important;
      }

      :host([${$299b6c40adc500b8$var$a.MEDIA_IS_PIP}]) slot[name=tooltip-enter],
      :host(:not([${$299b6c40adc500b8$var$a.MEDIA_IS_PIP}])) slot[name=tooltip-exit] {
        display: none;
      }
    </style>

    <slot name="icon">
      <slot name="enter">${$299b6c40adc500b8$var$uu}</slot>
      <slot name="exit">${$299b6c40adc500b8$var$uu}</slot>
    </slot>
  `;
}
function $299b6c40adc500b8$var$Yh() {
    return `
    <slot name="tooltip-enter">${$299b6c40adc500b8$var$c("Enter picture in picture mode")}</slot>
    <slot name="tooltip-exit">${$299b6c40adc500b8$var$c("Exit picture in picture mode")}</slot>
  `;
}
var $299b6c40adc500b8$var$cu = (i)=>{
    let e = i.mediaIsPip ? $299b6c40adc500b8$var$c("exit picture in picture mode") : $299b6c40adc500b8$var$c("enter picture in picture mode");
    i.setAttribute("aria-label", e);
}, $299b6c40adc500b8$var$mr = class extends $299b6c40adc500b8$var$P {
    static get observedAttributes() {
        return [
            ...super.observedAttributes,
            $299b6c40adc500b8$var$a.MEDIA_IS_PIP,
            $299b6c40adc500b8$var$a.MEDIA_PIP_UNAVAILABLE
        ];
    }
    connectedCallback() {
        super.connectedCallback(), $299b6c40adc500b8$var$cu(this);
    }
    attributeChangedCallback(e, t, r) {
        super.attributeChangedCallback(e, t, r), e === $299b6c40adc500b8$var$a.MEDIA_IS_PIP && $299b6c40adc500b8$var$cu(this);
    }
    get mediaPipUnavailable() {
        return $299b6c40adc500b8$var$_(this, $299b6c40adc500b8$var$a.MEDIA_PIP_UNAVAILABLE);
    }
    set mediaPipUnavailable(e) {
        $299b6c40adc500b8$var$b(this, $299b6c40adc500b8$var$a.MEDIA_PIP_UNAVAILABLE, e);
    }
    get mediaIsPip() {
        return $299b6c40adc500b8$var$A(this, $299b6c40adc500b8$var$a.MEDIA_IS_PIP);
    }
    set mediaIsPip(e) {
        $299b6c40adc500b8$var$y(this, $299b6c40adc500b8$var$a.MEDIA_IS_PIP, e);
    }
    handleClick() {
        let e = this.mediaIsPip ? $299b6c40adc500b8$var$h.MEDIA_EXIT_PIP_REQUEST : $299b6c40adc500b8$var$h.MEDIA_ENTER_PIP_REQUEST;
        this.dispatchEvent(new $299b6c40adc500b8$var$l.CustomEvent(e, {
            composed: !0,
            bubbles: !0
        }));
    }
};
$299b6c40adc500b8$var$mr.getSlotTemplateHTML = $299b6c40adc500b8$var$qh;
$299b6c40adc500b8$var$mr.getTooltipContentHTML = $299b6c40adc500b8$var$Yh;
$299b6c40adc500b8$var$l.customElements.get("media-pip-button") || $299b6c40adc500b8$var$l.customElements.define("media-pip-button", $299b6c40adc500b8$var$mr);
var $299b6c40adc500b8$var$Zh = (i, e, t)=>{
    if (!e.has(i)) throw TypeError("Cannot " + t);
}, $299b6c40adc500b8$var$di = (i, e, t)=>($299b6c40adc500b8$var$Zh(i, e, "read from private field"), t ? t.call(i) : e.get(i)), $299b6c40adc500b8$var$Qh = (i, e, t)=>{
    if (e.has(i)) throw TypeError("Cannot add the same private member more than once");
    e instanceof WeakSet ? e.add(i) : e.set(i, t);
}, $299b6c40adc500b8$var$ct, $299b6c40adc500b8$var$Xa = {
    RATES: "rates"
}, $299b6c40adc500b8$var$Ja = [
    1,
    1.2,
    1.5,
    1.7,
    2
], $299b6c40adc500b8$var$Ot = 1;
function $299b6c40adc500b8$var$zh(i) {
    return `
    <style>
      :host {
        min-width: 5ch;
        padding: var(--media-button-padding, var(--media-control-padding, 10px 5px));
      }
    </style>
    <slot name="icon">${i.mediaplaybackrate || $299b6c40adc500b8$var$Ot}x</slot>
  `;
}
function $299b6c40adc500b8$var$Xh() {
    return $299b6c40adc500b8$var$c("Playback rate");
}
var $299b6c40adc500b8$var$pr = class extends $299b6c40adc500b8$var$P {
    constructor(){
        var e;
        super(), $299b6c40adc500b8$var$Qh(this, $299b6c40adc500b8$var$ct, new $299b6c40adc500b8$var$at(this, $299b6c40adc500b8$var$Xa.RATES, {
            defaultValue: $299b6c40adc500b8$var$Ja
        })), this.container = this.shadowRoot.querySelector('slot[name="icon"]'), this.container.innerHTML = `${(e = this.mediaPlaybackRate) != null ? e : $299b6c40adc500b8$var$Ot}x`;
    }
    static get observedAttributes() {
        return [
            ...super.observedAttributes,
            $299b6c40adc500b8$var$a.MEDIA_PLAYBACK_RATE,
            $299b6c40adc500b8$var$Xa.RATES
        ];
    }
    attributeChangedCallback(e, t, r) {
        if (super.attributeChangedCallback(e, t, r), e === $299b6c40adc500b8$var$Xa.RATES && ($299b6c40adc500b8$var$di(this, $299b6c40adc500b8$var$ct).value = r), e === $299b6c40adc500b8$var$a.MEDIA_PLAYBACK_RATE) {
            let n1 = r ? +r : Number.NaN, s = Number.isNaN(n1) ? $299b6c40adc500b8$var$Ot : n1;
            this.container.innerHTML = `${s}x`, this.setAttribute("aria-label", $299b6c40adc500b8$var$c("Playback rate {playbackRate}", {
                playbackRate: s
            }));
        }
    }
    get rates() {
        return $299b6c40adc500b8$var$di(this, $299b6c40adc500b8$var$ct);
    }
    set rates(e) {
        e ? Array.isArray(e) ? $299b6c40adc500b8$var$di(this, $299b6c40adc500b8$var$ct).value = e.join(" ") : typeof e == "string" && ($299b6c40adc500b8$var$di(this, $299b6c40adc500b8$var$ct).value = e) : $299b6c40adc500b8$var$di(this, $299b6c40adc500b8$var$ct).value = "";
    }
    get mediaPlaybackRate() {
        return $299b6c40adc500b8$var$M(this, $299b6c40adc500b8$var$a.MEDIA_PLAYBACK_RATE, $299b6c40adc500b8$var$Ot);
    }
    set mediaPlaybackRate(e) {
        $299b6c40adc500b8$var$w(this, $299b6c40adc500b8$var$a.MEDIA_PLAYBACK_RATE, e);
    }
    handleClick() {
        var e, t;
        let r = Array.from($299b6c40adc500b8$var$di(this, $299b6c40adc500b8$var$ct).values(), (o)=>+o).sort((o, d)=>o - d), n1 = (t = (e = r.find((o)=>o > this.mediaPlaybackRate)) != null ? e : r[0]) != null ? t : $299b6c40adc500b8$var$Ot, s = new $299b6c40adc500b8$var$l.CustomEvent($299b6c40adc500b8$var$h.MEDIA_PLAYBACK_RATE_REQUEST, {
            composed: !0,
            bubbles: !0,
            detail: n1
        });
        this.dispatchEvent(s);
    }
};
$299b6c40adc500b8$var$ct = new WeakMap;
$299b6c40adc500b8$var$pr.getSlotTemplateHTML = $299b6c40adc500b8$var$zh;
$299b6c40adc500b8$var$pr.getTooltipContentHTML = $299b6c40adc500b8$var$Xh;
$299b6c40adc500b8$var$l.customElements.get("media-playback-rate-button") || $299b6c40adc500b8$var$l.customElements.define("media-playback-rate-button", $299b6c40adc500b8$var$pr);
var $299b6c40adc500b8$var$Jh = `<svg aria-hidden="true" viewBox="0 0 24 24">
  <path d="m6 21 15-9L6 3v18Z"/>
</svg>`, $299b6c40adc500b8$var$jh = `<svg aria-hidden="true" viewBox="0 0 24 24">
  <path d="M6 20h4V4H6v16Zm8-16v16h4V4h-4Z"/>
</svg>`;
function $299b6c40adc500b8$var$em(i) {
    return `
    <style>
      :host([${$299b6c40adc500b8$var$a.MEDIA_PAUSED}]) slot[name=pause],
      :host(:not([${$299b6c40adc500b8$var$a.MEDIA_PAUSED}])) slot[name=play] {
        display: none !important;
      }

      :host([${$299b6c40adc500b8$var$a.MEDIA_PAUSED}]) slot[name=tooltip-pause],
      :host(:not([${$299b6c40adc500b8$var$a.MEDIA_PAUSED}])) slot[name=tooltip-play] {
        display: none;
      }
    </style>

    <slot name="icon">
      <slot name="play">${$299b6c40adc500b8$var$Jh}</slot>
      <slot name="pause">${$299b6c40adc500b8$var$jh}</slot>
    </slot>
  `;
}
function $299b6c40adc500b8$var$tm() {
    return `
    <slot name="tooltip-play">${$299b6c40adc500b8$var$c("Play")}</slot>
    <slot name="tooltip-pause">${$299b6c40adc500b8$var$c("Pause")}</slot>
  `;
}
var $299b6c40adc500b8$var$hu = (i)=>{
    let e = i.mediaPaused ? $299b6c40adc500b8$var$c("play") : $299b6c40adc500b8$var$c("pause");
    i.setAttribute("aria-label", e);
}, $299b6c40adc500b8$var$vr = class extends $299b6c40adc500b8$var$P {
    static get observedAttributes() {
        return [
            ...super.observedAttributes,
            $299b6c40adc500b8$var$a.MEDIA_PAUSED,
            $299b6c40adc500b8$var$a.MEDIA_ENDED
        ];
    }
    connectedCallback() {
        super.connectedCallback(), $299b6c40adc500b8$var$hu(this);
    }
    attributeChangedCallback(e, t, r) {
        super.attributeChangedCallback(e, t, r), (e === $299b6c40adc500b8$var$a.MEDIA_PAUSED || e === $299b6c40adc500b8$var$a.MEDIA_LANG) && $299b6c40adc500b8$var$hu(this);
    }
    get mediaPaused() {
        return $299b6c40adc500b8$var$A(this, $299b6c40adc500b8$var$a.MEDIA_PAUSED);
    }
    set mediaPaused(e) {
        $299b6c40adc500b8$var$y(this, $299b6c40adc500b8$var$a.MEDIA_PAUSED, e);
    }
    handleClick() {
        let e = this.mediaPaused ? $299b6c40adc500b8$var$h.MEDIA_PLAY_REQUEST : $299b6c40adc500b8$var$h.MEDIA_PAUSE_REQUEST;
        this.dispatchEvent(new $299b6c40adc500b8$var$l.CustomEvent(e, {
            composed: !0,
            bubbles: !0
        }));
    }
};
$299b6c40adc500b8$var$vr.getSlotTemplateHTML = $299b6c40adc500b8$var$em;
$299b6c40adc500b8$var$vr.getTooltipContentHTML = $299b6c40adc500b8$var$tm;
$299b6c40adc500b8$var$l.customElements.get("media-play-button") || $299b6c40adc500b8$var$l.customElements.define("media-play-button", $299b6c40adc500b8$var$vr);
var $299b6c40adc500b8$var$Ve = {
    PLACEHOLDER_SRC: "placeholdersrc",
    SRC: "src"
};
function $299b6c40adc500b8$var$im(i) {
    return `
    <style>
      :host {
        pointer-events: none;
        display: var(--media-poster-image-display, inline-block);
        box-sizing: border-box;
      }

      img {
        max-width: 100%;
        max-height: 100%;
        min-width: 100%;
        min-height: 100%;
        background-repeat: no-repeat;
        background-position: var(--media-poster-image-background-position, var(--media-object-position, center));
        background-size: var(--media-poster-image-background-size, var(--media-object-fit, contain));
        object-fit: var(--media-object-fit, contain);
        object-position: var(--media-object-position, center);
      }
    </style>

    <img part="poster img" aria-hidden="true" id="image"/>
  `;
}
var $299b6c40adc500b8$var$rm = (i)=>{
    i.style.removeProperty("background-image");
}, $299b6c40adc500b8$var$nm = (i, e)=>{
    i.style["background-image"] = `url('${e}')`;
}, $299b6c40adc500b8$var$Er = class extends $299b6c40adc500b8$var$l.HTMLElement {
    static get observedAttributes() {
        return [
            $299b6c40adc500b8$var$Ve.PLACEHOLDER_SRC,
            $299b6c40adc500b8$var$Ve.SRC
        ];
    }
    constructor(){
        if (super(), !this.shadowRoot) {
            this.attachShadow(this.constructor.shadowRootOptions);
            let e = $299b6c40adc500b8$var$W(this.attributes);
            this.shadowRoot.innerHTML = this.constructor.getTemplateHTML(e);
        }
        this.image = this.shadowRoot.querySelector("#image");
    }
    attributeChangedCallback(e, t, r) {
        e === $299b6c40adc500b8$var$Ve.SRC && (r == null ? this.image.removeAttribute($299b6c40adc500b8$var$Ve.SRC) : this.image.setAttribute($299b6c40adc500b8$var$Ve.SRC, r)), e === $299b6c40adc500b8$var$Ve.PLACEHOLDER_SRC && (r == null ? $299b6c40adc500b8$var$rm(this.image) : $299b6c40adc500b8$var$nm(this.image, r));
    }
    get placeholderSrc() {
        return $299b6c40adc500b8$var$_(this, $299b6c40adc500b8$var$Ve.PLACEHOLDER_SRC);
    }
    set placeholderSrc(e) {
        $299b6c40adc500b8$var$b(this, $299b6c40adc500b8$var$Ve.SRC, e);
    }
    get src() {
        return $299b6c40adc500b8$var$_(this, $299b6c40adc500b8$var$Ve.SRC);
    }
    set src(e) {
        $299b6c40adc500b8$var$b(this, $299b6c40adc500b8$var$Ve.SRC, e);
    }
};
$299b6c40adc500b8$var$Er.shadowRootOptions = {
    mode: "open"
};
$299b6c40adc500b8$var$Er.getTemplateHTML = $299b6c40adc500b8$var$im;
$299b6c40adc500b8$var$l.customElements.get("media-poster-image") || $299b6c40adc500b8$var$l.customElements.define("media-poster-image", $299b6c40adc500b8$var$Er);
var $299b6c40adc500b8$var$mu = (i, e, t)=>{
    if (!e.has(i)) throw TypeError("Cannot " + t);
}, $299b6c40adc500b8$var$sm = (i, e, t)=>($299b6c40adc500b8$var$mu(i, e, "read from private field"), t ? t.call(i) : e.get(i)), $299b6c40adc500b8$var$am = (i, e, t)=>{
    if (e.has(i)) throw TypeError("Cannot add the same private member more than once");
    e instanceof WeakSet ? e.add(i) : e.set(i, t);
}, $299b6c40adc500b8$var$om = (i, e, t, r)=>($299b6c40adc500b8$var$mu(i, e, "write to private field"), r ? r.call(i, t) : e.set(i, t), t), $299b6c40adc500b8$var$is, $299b6c40adc500b8$var$ja = class extends $299b6c40adc500b8$var$se {
    constructor(){
        super(), $299b6c40adc500b8$var$am(this, $299b6c40adc500b8$var$is, void 0), $299b6c40adc500b8$var$om(this, $299b6c40adc500b8$var$is, this.shadowRoot.querySelector("slot"));
    }
    static get observedAttributes() {
        return [
            ...super.observedAttributes,
            $299b6c40adc500b8$var$a.MEDIA_PREVIEW_CHAPTER,
            $299b6c40adc500b8$var$a.MEDIA_LANG
        ];
    }
    attributeChangedCallback(e, t, r) {
        if (super.attributeChangedCallback(e, t, r), (e === $299b6c40adc500b8$var$a.MEDIA_PREVIEW_CHAPTER || e === $299b6c40adc500b8$var$a.MEDIA_LANG) && r !== t && r != null) {
            if ($299b6c40adc500b8$var$sm(this, $299b6c40adc500b8$var$is).textContent = r, r !== "") {
                let n1 = $299b6c40adc500b8$var$c("chapter: {chapterName}", {
                    chapterName: r
                });
                this.setAttribute("aria-valuetext", n1);
            } else this.removeAttribute("aria-valuetext");
        }
    }
    get mediaPreviewChapter() {
        return $299b6c40adc500b8$var$_(this, $299b6c40adc500b8$var$a.MEDIA_PREVIEW_CHAPTER);
    }
    set mediaPreviewChapter(e) {
        $299b6c40adc500b8$var$b(this, $299b6c40adc500b8$var$a.MEDIA_PREVIEW_CHAPTER, e);
    }
};
$299b6c40adc500b8$var$is = new WeakMap;
$299b6c40adc500b8$var$l.customElements.get("media-preview-chapter-display") || $299b6c40adc500b8$var$l.customElements.define("media-preview-chapter-display", $299b6c40adc500b8$var$ja);
var $299b6c40adc500b8$var$pu = (i, e, t)=>{
    if (!e.has(i)) throw TypeError("Cannot " + t);
}, $299b6c40adc500b8$var$rs = (i, e, t)=>($299b6c40adc500b8$var$pu(i, e, "read from private field"), t ? t.call(i) : e.get(i)), $299b6c40adc500b8$var$lm = (i, e, t)=>{
    if (e.has(i)) throw TypeError("Cannot add the same private member more than once");
    e instanceof WeakSet ? e.add(i) : e.set(i, t);
}, $299b6c40adc500b8$var$ns = (i, e, t, r)=>($299b6c40adc500b8$var$pu(i, e, "write to private field"), r ? r.call(i, t) : e.set(i, t), t), $299b6c40adc500b8$var$We;
function $299b6c40adc500b8$var$dm(i) {
    return `
    <style>
      :host {
        box-sizing: border-box;
        display: var(--media-control-display, var(--media-preview-thumbnail-display, inline-block));
        overflow: hidden;
      }

      img {
        display: none;
        position: relative;
      }
    </style>
    <img crossorigin loading="eager" decoding="async">
  `;
}
var $299b6c40adc500b8$var$ui = class extends $299b6c40adc500b8$var$l.HTMLElement {
    constructor(){
        if (super(), $299b6c40adc500b8$var$lm(this, $299b6c40adc500b8$var$We, void 0), !this.shadowRoot) {
            this.attachShadow(this.constructor.shadowRootOptions);
            let e = $299b6c40adc500b8$var$W(this.attributes);
            this.shadowRoot.innerHTML = this.constructor.getTemplateHTML(e);
        }
    }
    static get observedAttributes() {
        return [
            $299b6c40adc500b8$var$I.MEDIA_CONTROLLER,
            $299b6c40adc500b8$var$a.MEDIA_PREVIEW_IMAGE,
            $299b6c40adc500b8$var$a.MEDIA_PREVIEW_COORDS
        ];
    }
    connectedCallback() {
        var e, t, r;
        let n1 = this.getAttribute($299b6c40adc500b8$var$I.MEDIA_CONTROLLER);
        n1 && ($299b6c40adc500b8$var$ns(this, $299b6c40adc500b8$var$We, (e = this.getRootNode()) == null ? void 0 : e.getElementById(n1)), (r = (t = $299b6c40adc500b8$var$rs(this, $299b6c40adc500b8$var$We)) == null ? void 0 : t.associateElement) == null || r.call(t, this));
    }
    disconnectedCallback() {
        var e, t;
        (t = (e = $299b6c40adc500b8$var$rs(this, $299b6c40adc500b8$var$We)) == null ? void 0 : e.unassociateElement) == null || t.call(e, this), $299b6c40adc500b8$var$ns(this, $299b6c40adc500b8$var$We, null);
    }
    attributeChangedCallback(e, t, r) {
        var n1, s, o, d, u;
        [
            $299b6c40adc500b8$var$a.MEDIA_PREVIEW_IMAGE,
            $299b6c40adc500b8$var$a.MEDIA_PREVIEW_COORDS
        ].includes(e) && this.update(), e === $299b6c40adc500b8$var$I.MEDIA_CONTROLLER && (t && ((s = (n1 = $299b6c40adc500b8$var$rs(this, $299b6c40adc500b8$var$We)) == null ? void 0 : n1.unassociateElement) == null || s.call(n1, this), $299b6c40adc500b8$var$ns(this, $299b6c40adc500b8$var$We, null)), r && this.isConnected && ($299b6c40adc500b8$var$ns(this, $299b6c40adc500b8$var$We, (o = this.getRootNode()) == null ? void 0 : o.getElementById(r)), (u = (d = $299b6c40adc500b8$var$rs(this, $299b6c40adc500b8$var$We)) == null ? void 0 : d.associateElement) == null || u.call(d, this)));
    }
    get mediaPreviewImage() {
        return $299b6c40adc500b8$var$_(this, $299b6c40adc500b8$var$a.MEDIA_PREVIEW_IMAGE);
    }
    set mediaPreviewImage(e) {
        $299b6c40adc500b8$var$b(this, $299b6c40adc500b8$var$a.MEDIA_PREVIEW_IMAGE, e);
    }
    get mediaPreviewCoords() {
        let e = this.getAttribute($299b6c40adc500b8$var$a.MEDIA_PREVIEW_COORDS);
        if (e) return e.split(/\s+/).map((t)=>+t);
    }
    set mediaPreviewCoords(e) {
        if (!e) {
            this.removeAttribute($299b6c40adc500b8$var$a.MEDIA_PREVIEW_COORDS);
            return;
        }
        this.setAttribute($299b6c40adc500b8$var$a.MEDIA_PREVIEW_COORDS, e.join(" "));
    }
    update() {
        let e = this.mediaPreviewCoords, t = this.mediaPreviewImage;
        if (!(e && t)) return;
        let [r, n1, s, o] = e, d = t.split("#")[0], u = getComputedStyle(this), { maxWidth: m, maxHeight: f, minWidth: g, minHeight: v } = u, E = Math.min(parseInt(m) / s, parseInt(f) / o), R = Math.max(parseInt(g) / s, parseInt(v) / o), k = E < 1, S = k ? E : R > 1 ? R : 1, { style: V } = $299b6c40adc500b8$var$O(this.shadowRoot, ":host"), oe = $299b6c40adc500b8$var$O(this.shadowRoot, "img").style, Me = this.shadowRoot.querySelector("img"), Oi = k ? "min" : "max";
        V.setProperty(`${Oi}-width`, "initial", "important"), V.setProperty(`${Oi}-height`, "initial", "important"), V.width = `${s * S}px`, V.height = `${o * S}px`;
        let Bt = ()=>{
            oe.width = `${this.imgWidth * S}px`, oe.height = `${this.imgHeight * S}px`, oe.display = "block";
        };
        Me.src !== d && (Me.onload = ()=>{
            this.imgWidth = Me.naturalWidth, this.imgHeight = Me.naturalHeight, Bt();
        }, Me.src = d, Bt()), Bt(), oe.transform = `translate(-${r * S}px, -${n1 * S}px)`;
    }
};
$299b6c40adc500b8$var$We = new WeakMap;
$299b6c40adc500b8$var$ui.shadowRootOptions = {
    mode: "open"
};
$299b6c40adc500b8$var$ui.getTemplateHTML = $299b6c40adc500b8$var$dm;
$299b6c40adc500b8$var$l.customElements.get("media-preview-thumbnail") || $299b6c40adc500b8$var$l.customElements.define("media-preview-thumbnail", $299b6c40adc500b8$var$ui);
var $299b6c40adc500b8$var$ss = $299b6c40adc500b8$var$ui;
var $299b6c40adc500b8$var$Eu = (i, e, t)=>{
    if (!e.has(i)) throw TypeError("Cannot " + t);
}, $299b6c40adc500b8$var$vu = (i, e, t)=>($299b6c40adc500b8$var$Eu(i, e, "read from private field"), t ? t.call(i) : e.get(i)), $299b6c40adc500b8$var$um = (i, e, t)=>{
    if (e.has(i)) throw TypeError("Cannot add the same private member more than once");
    e instanceof WeakSet ? e.add(i) : e.set(i, t);
}, $299b6c40adc500b8$var$cm = (i, e, t, r)=>($299b6c40adc500b8$var$Eu(i, e, "write to private field"), r ? r.call(i, t) : e.set(i, t), t), $299b6c40adc500b8$var$gr, $299b6c40adc500b8$var$eo = class extends $299b6c40adc500b8$var$se {
    constructor(){
        super(), $299b6c40adc500b8$var$um(this, $299b6c40adc500b8$var$gr, void 0), $299b6c40adc500b8$var$cm(this, $299b6c40adc500b8$var$gr, this.shadowRoot.querySelector("slot")), $299b6c40adc500b8$var$vu(this, $299b6c40adc500b8$var$gr).textContent = $299b6c40adc500b8$var$Ae(0);
    }
    static get observedAttributes() {
        return [
            ...super.observedAttributes,
            $299b6c40adc500b8$var$a.MEDIA_PREVIEW_TIME
        ];
    }
    attributeChangedCallback(e, t, r) {
        super.attributeChangedCallback(e, t, r), e === $299b6c40adc500b8$var$a.MEDIA_PREVIEW_TIME && r != null && ($299b6c40adc500b8$var$vu(this, $299b6c40adc500b8$var$gr).textContent = $299b6c40adc500b8$var$Ae(parseFloat(r)));
    }
    get mediaPreviewTime() {
        return $299b6c40adc500b8$var$M(this, $299b6c40adc500b8$var$a.MEDIA_PREVIEW_TIME);
    }
    set mediaPreviewTime(e) {
        $299b6c40adc500b8$var$w(this, $299b6c40adc500b8$var$a.MEDIA_PREVIEW_TIME, e);
    }
};
$299b6c40adc500b8$var$gr = new WeakMap;
$299b6c40adc500b8$var$l.customElements.get("media-preview-time-display") || $299b6c40adc500b8$var$l.customElements.define("media-preview-time-display", $299b6c40adc500b8$var$eo);
var $299b6c40adc500b8$var$ci = {
    SEEK_OFFSET: "seekoffset"
}, $299b6c40adc500b8$var$to = 30, $299b6c40adc500b8$var$hm = (i)=>`
  <svg aria-hidden="true" viewBox="0 0 20 24">
    <defs>
      <style>.text{font-size:8px;font-family:Arial-BoldMT, Arial;font-weight:700;}</style>
    </defs>
    <text class="text value" transform="translate(2.18 19.87)">${i}</text>
    <path d="M10 6V3L4.37 7 10 10.94V8a5.54 5.54 0 0 1 1.9 10.48v2.12A7.5 7.5 0 0 0 10 6Z"/>
  </svg>`;
function $299b6c40adc500b8$var$mm(i, e) {
    return `
    <slot name="icon">${$299b6c40adc500b8$var$hm(e.seekOffset)}</slot>
  `;
}
function $299b6c40adc500b8$var$pm() {
    return $299b6c40adc500b8$var$c("Seek backward");
}
var $299b6c40adc500b8$var$vm = 0, $299b6c40adc500b8$var$br = class extends $299b6c40adc500b8$var$P {
    static get observedAttributes() {
        return [
            ...super.observedAttributes,
            $299b6c40adc500b8$var$a.MEDIA_CURRENT_TIME,
            $299b6c40adc500b8$var$ci.SEEK_OFFSET
        ];
    }
    connectedCallback() {
        super.connectedCallback(), this.seekOffset = $299b6c40adc500b8$var$M(this, $299b6c40adc500b8$var$ci.SEEK_OFFSET, $299b6c40adc500b8$var$to);
    }
    attributeChangedCallback(e, t, r) {
        super.attributeChangedCallback(e, t, r), e === $299b6c40adc500b8$var$ci.SEEK_OFFSET && (this.seekOffset = $299b6c40adc500b8$var$M(this, $299b6c40adc500b8$var$ci.SEEK_OFFSET, $299b6c40adc500b8$var$to));
    }
    get seekOffset() {
        return $299b6c40adc500b8$var$M(this, $299b6c40adc500b8$var$ci.SEEK_OFFSET, $299b6c40adc500b8$var$to);
    }
    set seekOffset(e) {
        $299b6c40adc500b8$var$w(this, $299b6c40adc500b8$var$ci.SEEK_OFFSET, e), this.setAttribute("aria-label", $299b6c40adc500b8$var$c("seek back {seekOffset} seconds", {
            seekOffset: this.seekOffset
        })), $299b6c40adc500b8$var$jr($299b6c40adc500b8$var$en(this, "icon"), this.seekOffset);
    }
    get mediaCurrentTime() {
        return $299b6c40adc500b8$var$M(this, $299b6c40adc500b8$var$a.MEDIA_CURRENT_TIME, $299b6c40adc500b8$var$vm);
    }
    set mediaCurrentTime(e) {
        $299b6c40adc500b8$var$w(this, $299b6c40adc500b8$var$a.MEDIA_CURRENT_TIME, e);
    }
    handleClick() {
        let e = Math.max(this.mediaCurrentTime - this.seekOffset, 0), t = new $299b6c40adc500b8$var$l.CustomEvent($299b6c40adc500b8$var$h.MEDIA_SEEK_REQUEST, {
            composed: !0,
            bubbles: !0,
            detail: e
        });
        this.dispatchEvent(t);
    }
};
$299b6c40adc500b8$var$br.getSlotTemplateHTML = $299b6c40adc500b8$var$mm;
$299b6c40adc500b8$var$br.getTooltipContentHTML = $299b6c40adc500b8$var$pm;
$299b6c40adc500b8$var$l.customElements.get("media-seek-backward-button") || $299b6c40adc500b8$var$l.customElements.define("media-seek-backward-button", $299b6c40adc500b8$var$br);
var $299b6c40adc500b8$var$hi = {
    SEEK_OFFSET: "seekoffset"
}, $299b6c40adc500b8$var$io = 30, $299b6c40adc500b8$var$Em = (i)=>`
  <svg aria-hidden="true" viewBox="0 0 20 24">
    <defs>
      <style>.text{font-size:8px;font-family:Arial-BoldMT, Arial;font-weight:700;}</style>
    </defs>
    <text class="text value" transform="translate(8.9 19.87)">${i}</text>
    <path d="M10 6V3l5.61 4L10 10.94V8a5.54 5.54 0 0 0-1.9 10.48v2.12A7.5 7.5 0 0 1 10 6Z"/>
  </svg>`;
function $299b6c40adc500b8$var$gm(i, e) {
    return `
    <slot name="icon">${$299b6c40adc500b8$var$Em(e.seekOffset)}</slot>
  `;
}
function $299b6c40adc500b8$var$bm() {
    return $299b6c40adc500b8$var$c("Seek forward");
}
var $299b6c40adc500b8$var$fm = 0, $299b6c40adc500b8$var$fr = class extends $299b6c40adc500b8$var$P {
    static get observedAttributes() {
        return [
            ...super.observedAttributes,
            $299b6c40adc500b8$var$a.MEDIA_CURRENT_TIME,
            $299b6c40adc500b8$var$hi.SEEK_OFFSET
        ];
    }
    connectedCallback() {
        super.connectedCallback(), this.seekOffset = $299b6c40adc500b8$var$M(this, $299b6c40adc500b8$var$hi.SEEK_OFFSET, $299b6c40adc500b8$var$io);
    }
    attributeChangedCallback(e, t, r) {
        super.attributeChangedCallback(e, t, r), e === $299b6c40adc500b8$var$hi.SEEK_OFFSET && (this.seekOffset = $299b6c40adc500b8$var$M(this, $299b6c40adc500b8$var$hi.SEEK_OFFSET, $299b6c40adc500b8$var$io));
    }
    get seekOffset() {
        return $299b6c40adc500b8$var$M(this, $299b6c40adc500b8$var$hi.SEEK_OFFSET, $299b6c40adc500b8$var$io);
    }
    set seekOffset(e) {
        $299b6c40adc500b8$var$w(this, $299b6c40adc500b8$var$hi.SEEK_OFFSET, e), this.setAttribute("aria-label", $299b6c40adc500b8$var$c("seek forward {seekOffset} seconds", {
            seekOffset: this.seekOffset
        })), $299b6c40adc500b8$var$jr($299b6c40adc500b8$var$en(this, "icon"), this.seekOffset);
    }
    get mediaCurrentTime() {
        return $299b6c40adc500b8$var$M(this, $299b6c40adc500b8$var$a.MEDIA_CURRENT_TIME, $299b6c40adc500b8$var$fm);
    }
    set mediaCurrentTime(e) {
        $299b6c40adc500b8$var$w(this, $299b6c40adc500b8$var$a.MEDIA_CURRENT_TIME, e);
    }
    handleClick() {
        let e = this.mediaCurrentTime + this.seekOffset, t = new $299b6c40adc500b8$var$l.CustomEvent($299b6c40adc500b8$var$h.MEDIA_SEEK_REQUEST, {
            composed: !0,
            bubbles: !0,
            detail: e
        });
        this.dispatchEvent(t);
    }
};
$299b6c40adc500b8$var$fr.getSlotTemplateHTML = $299b6c40adc500b8$var$gm;
$299b6c40adc500b8$var$fr.getTooltipContentHTML = $299b6c40adc500b8$var$bm;
$299b6c40adc500b8$var$l.customElements.get("media-seek-forward-button") || $299b6c40adc500b8$var$l.customElements.define("media-seek-forward-button", $299b6c40adc500b8$var$fr);
var $299b6c40adc500b8$var$fu = (i, e, t)=>{
    if (!e.has(i)) throw TypeError("Cannot " + t);
}, $299b6c40adc500b8$var$ro = (i, e, t)=>($299b6c40adc500b8$var$fu(i, e, "read from private field"), t ? t.call(i) : e.get(i)), $299b6c40adc500b8$var$_m = (i, e, t)=>{
    if (e.has(i)) throw TypeError("Cannot add the same private member more than once");
    e instanceof WeakSet ? e.add(i) : e.set(i, t);
}, $299b6c40adc500b8$var$Tm = (i, e, t, r)=>($299b6c40adc500b8$var$fu(i, e, "write to private field"), r ? r.call(i, t) : e.set(i, t), t), $299b6c40adc500b8$var$mi, $299b6c40adc500b8$var$xt = {
    REMAINING: "remaining",
    SHOW_DURATION: "showduration",
    NO_TOGGLE: "notoggle"
}, $299b6c40adc500b8$var$gu = [
    ...Object.values($299b6c40adc500b8$var$xt),
    $299b6c40adc500b8$var$a.MEDIA_CURRENT_TIME,
    $299b6c40adc500b8$var$a.MEDIA_DURATION,
    $299b6c40adc500b8$var$a.MEDIA_SEEKABLE
], $299b6c40adc500b8$var$bu = [
    "Enter",
    " "
], $299b6c40adc500b8$var$Am = "&nbsp;/&nbsp;", $299b6c40adc500b8$var$no = (i, { timesSep: e = $299b6c40adc500b8$var$Am } = {})=>{
    var t, r;
    let n1 = (t = i.mediaCurrentTime) != null ? t : 0, [, s] = (r = i.mediaSeekable) != null ? r : [], o = 0;
    Number.isFinite(i.mediaDuration) ? o = i.mediaDuration : Number.isFinite(s) && (o = s);
    let d = i.remaining ? $299b6c40adc500b8$var$Ae(0 - (o - n1)) : $299b6c40adc500b8$var$Ae(n1);
    return i.showDuration ? `${d}${e}${$299b6c40adc500b8$var$Ae(o)}` : d;
}, $299b6c40adc500b8$var$ym = "video not loaded, unknown time.", $299b6c40adc500b8$var$km = (i)=>{
    var e;
    let t = i.mediaCurrentTime, [, r] = (e = i.mediaSeekable) != null ? e : [], n1 = null;
    if (Number.isFinite(i.mediaDuration) ? n1 = i.mediaDuration : Number.isFinite(r) && (n1 = r), t == null || n1 === null) {
        i.setAttribute("aria-valuetext", $299b6c40adc500b8$var$ym);
        return;
    }
    let s = i.remaining ? $299b6c40adc500b8$var$At(0 - (n1 - t)) : $299b6c40adc500b8$var$At(t);
    if (!i.showDuration) {
        i.setAttribute("aria-valuetext", s);
        return;
    }
    let o = $299b6c40adc500b8$var$At(n1), d = `${s} of ${o}`;
    i.setAttribute("aria-valuetext", d);
};
function $299b6c40adc500b8$var$Im(i, e) {
    return `
    <slot>${$299b6c40adc500b8$var$no(e)}</slot>
  `;
}
var $299b6c40adc500b8$var$as = class extends $299b6c40adc500b8$var$se {
    constructor(){
        super(), $299b6c40adc500b8$var$_m(this, $299b6c40adc500b8$var$mi, void 0), $299b6c40adc500b8$var$Tm(this, $299b6c40adc500b8$var$mi, this.shadowRoot.querySelector("slot")), $299b6c40adc500b8$var$ro(this, $299b6c40adc500b8$var$mi).innerHTML = `${$299b6c40adc500b8$var$no(this)}`;
    }
    static get observedAttributes() {
        return [
            ...super.observedAttributes,
            ...$299b6c40adc500b8$var$gu,
            "disabled"
        ];
    }
    connectedCallback() {
        let { style: e } = $299b6c40adc500b8$var$O(this.shadowRoot, ":host(:hover:not([notoggle]))");
        e.setProperty("cursor", "var(--media-cursor, pointer)"), e.setProperty("background", "var(--media-control-hover-background, rgba(50 50 70 / .7))"), this.hasAttribute("disabled") || this.enable(), this.setAttribute("role", "progressbar"), this.setAttribute("aria-label", $299b6c40adc500b8$var$c("playback time"));
        let t = (r)=>{
            let { key: n1 } = r;
            if (!$299b6c40adc500b8$var$bu.includes(n1)) {
                this.removeEventListener("keyup", t);
                return;
            }
            this.toggleTimeDisplay();
        };
        this.addEventListener("keydown", (r)=>{
            let { metaKey: n1, altKey: s, key: o } = r;
            if (n1 || s || !$299b6c40adc500b8$var$bu.includes(o)) {
                this.removeEventListener("keyup", t);
                return;
            }
            this.addEventListener("keyup", t);
        }), this.addEventListener("click", this.toggleTimeDisplay), super.connectedCallback();
    }
    toggleTimeDisplay() {
        this.noToggle || (this.hasAttribute("remaining") ? this.removeAttribute("remaining") : this.setAttribute("remaining", ""));
    }
    disconnectedCallback() {
        this.disable(), super.disconnectedCallback();
    }
    attributeChangedCallback(e, t, r) {
        $299b6c40adc500b8$var$gu.includes(e) ? this.update() : e === "disabled" && r !== t && (r == null ? this.enable() : this.disable()), super.attributeChangedCallback(e, t, r);
    }
    enable() {
        this.tabIndex = 0;
    }
    disable() {
        this.tabIndex = -1;
    }
    get remaining() {
        return $299b6c40adc500b8$var$A(this, $299b6c40adc500b8$var$xt.REMAINING);
    }
    set remaining(e) {
        $299b6c40adc500b8$var$y(this, $299b6c40adc500b8$var$xt.REMAINING, e);
    }
    get showDuration() {
        return $299b6c40adc500b8$var$A(this, $299b6c40adc500b8$var$xt.SHOW_DURATION);
    }
    set showDuration(e) {
        $299b6c40adc500b8$var$y(this, $299b6c40adc500b8$var$xt.SHOW_DURATION, e);
    }
    get noToggle() {
        return $299b6c40adc500b8$var$A(this, $299b6c40adc500b8$var$xt.NO_TOGGLE);
    }
    set noToggle(e) {
        $299b6c40adc500b8$var$y(this, $299b6c40adc500b8$var$xt.NO_TOGGLE, e);
    }
    get mediaDuration() {
        return $299b6c40adc500b8$var$M(this, $299b6c40adc500b8$var$a.MEDIA_DURATION);
    }
    set mediaDuration(e) {
        $299b6c40adc500b8$var$w(this, $299b6c40adc500b8$var$a.MEDIA_DURATION, e);
    }
    get mediaCurrentTime() {
        return $299b6c40adc500b8$var$M(this, $299b6c40adc500b8$var$a.MEDIA_CURRENT_TIME);
    }
    set mediaCurrentTime(e) {
        $299b6c40adc500b8$var$w(this, $299b6c40adc500b8$var$a.MEDIA_CURRENT_TIME, e);
    }
    get mediaSeekable() {
        let e = this.getAttribute($299b6c40adc500b8$var$a.MEDIA_SEEKABLE);
        if (e) return e.split(":").map((t)=>+t);
    }
    set mediaSeekable(e) {
        if (e == null) {
            this.removeAttribute($299b6c40adc500b8$var$a.MEDIA_SEEKABLE);
            return;
        }
        this.setAttribute($299b6c40adc500b8$var$a.MEDIA_SEEKABLE, e.join(":"));
    }
    update() {
        let e = $299b6c40adc500b8$var$no(this);
        $299b6c40adc500b8$var$km(this), e !== $299b6c40adc500b8$var$ro(this, $299b6c40adc500b8$var$mi).innerHTML && ($299b6c40adc500b8$var$ro(this, $299b6c40adc500b8$var$mi).innerHTML = e);
    }
};
$299b6c40adc500b8$var$mi = new WeakMap;
$299b6c40adc500b8$var$as.getSlotTemplateHTML = $299b6c40adc500b8$var$Im;
$299b6c40adc500b8$var$l.customElements.get("media-time-display") || $299b6c40adc500b8$var$l.customElements.define("media-time-display", $299b6c40adc500b8$var$as);
var $299b6c40adc500b8$var$_u = (i, e, t)=>{
    if (!e.has(i)) throw TypeError("Cannot " + t);
}, $299b6c40adc500b8$var$z = (i, e, t)=>($299b6c40adc500b8$var$_u(i, e, "read from private field"), t ? t.call(i) : e.get(i)), $299b6c40adc500b8$var$Fe = (i, e, t)=>{
    if (e.has(i)) throw TypeError("Cannot add the same private member more than once");
    e instanceof WeakSet ? e.add(i) : e.set(i, t);
}, $299b6c40adc500b8$var$me = (i, e, t, r)=>($299b6c40adc500b8$var$_u(i, e, "write to private field"), r ? r.call(i, t) : e.set(i, t), t), $299b6c40adc500b8$var$Sm = (i, e, t, r)=>({
        set _ (n){
            $299b6c40adc500b8$var$me(i, e, n, t);
        },
        get _ () {
            return $299b6c40adc500b8$var$z(i, e, r);
        }
    }), $299b6c40adc500b8$var$pi, $299b6c40adc500b8$var$os, $299b6c40adc500b8$var$vi, $299b6c40adc500b8$var$_r, $299b6c40adc500b8$var$ls, $299b6c40adc500b8$var$ds, $299b6c40adc500b8$var$us, $299b6c40adc500b8$var$Ei, $299b6c40adc500b8$var$Nt, $299b6c40adc500b8$var$cs, $299b6c40adc500b8$var$hs = class {
    constructor(e, t, r){
        $299b6c40adc500b8$var$Fe(this, $299b6c40adc500b8$var$pi, void 0), $299b6c40adc500b8$var$Fe(this, $299b6c40adc500b8$var$os, void 0), $299b6c40adc500b8$var$Fe(this, $299b6c40adc500b8$var$vi, void 0), $299b6c40adc500b8$var$Fe(this, $299b6c40adc500b8$var$_r, void 0), $299b6c40adc500b8$var$Fe(this, $299b6c40adc500b8$var$ls, void 0), $299b6c40adc500b8$var$Fe(this, $299b6c40adc500b8$var$ds, void 0), $299b6c40adc500b8$var$Fe(this, $299b6c40adc500b8$var$us, void 0), $299b6c40adc500b8$var$Fe(this, $299b6c40adc500b8$var$Ei, void 0), $299b6c40adc500b8$var$Fe(this, $299b6c40adc500b8$var$Nt, 0), $299b6c40adc500b8$var$Fe(this, $299b6c40adc500b8$var$cs, (n1 = performance.now())=>{
            $299b6c40adc500b8$var$me(this, $299b6c40adc500b8$var$Nt, requestAnimationFrame($299b6c40adc500b8$var$z(this, $299b6c40adc500b8$var$cs))), $299b6c40adc500b8$var$me(this, $299b6c40adc500b8$var$_r, performance.now() - $299b6c40adc500b8$var$z(this, $299b6c40adc500b8$var$vi));
            let s = 1e3 / this.fps;
            if ($299b6c40adc500b8$var$z(this, $299b6c40adc500b8$var$_r) > s) {
                $299b6c40adc500b8$var$me(this, $299b6c40adc500b8$var$vi, n1 - $299b6c40adc500b8$var$z(this, $299b6c40adc500b8$var$_r) % s);
                let o = 1e3 / ((n1 - $299b6c40adc500b8$var$z(this, $299b6c40adc500b8$var$os)) / ++$299b6c40adc500b8$var$Sm(this, $299b6c40adc500b8$var$ls)._), d = (n1 - $299b6c40adc500b8$var$z(this, $299b6c40adc500b8$var$ds)) / 1e3 / this.duration, u = $299b6c40adc500b8$var$z(this, $299b6c40adc500b8$var$us) + d * this.playbackRate;
                u - $299b6c40adc500b8$var$z(this, $299b6c40adc500b8$var$pi).valueAsNumber > 0 ? $299b6c40adc500b8$var$me(this, $299b6c40adc500b8$var$Ei, this.playbackRate / this.duration / o) : ($299b6c40adc500b8$var$me(this, $299b6c40adc500b8$var$Ei, .995 * $299b6c40adc500b8$var$z(this, $299b6c40adc500b8$var$Ei)), u = $299b6c40adc500b8$var$z(this, $299b6c40adc500b8$var$pi).valueAsNumber + $299b6c40adc500b8$var$z(this, $299b6c40adc500b8$var$Ei)), this.callback(u);
            }
        }), $299b6c40adc500b8$var$me(this, $299b6c40adc500b8$var$pi, e), this.callback = t, this.fps = r;
    }
    start() {
        $299b6c40adc500b8$var$z(this, $299b6c40adc500b8$var$Nt) === 0 && ($299b6c40adc500b8$var$me(this, $299b6c40adc500b8$var$vi, performance.now()), $299b6c40adc500b8$var$me(this, $299b6c40adc500b8$var$os, $299b6c40adc500b8$var$z(this, $299b6c40adc500b8$var$vi)), $299b6c40adc500b8$var$me(this, $299b6c40adc500b8$var$ls, 0), $299b6c40adc500b8$var$z(this, $299b6c40adc500b8$var$cs).call(this));
    }
    stop() {
        $299b6c40adc500b8$var$z(this, $299b6c40adc500b8$var$Nt) !== 0 && (cancelAnimationFrame($299b6c40adc500b8$var$z(this, $299b6c40adc500b8$var$Nt)), $299b6c40adc500b8$var$me(this, $299b6c40adc500b8$var$Nt, 0));
    }
    update({ start: e, duration: t, playbackRate: r }) {
        let n1 = e - $299b6c40adc500b8$var$z(this, $299b6c40adc500b8$var$pi).valueAsNumber, s = Math.abs(t - this.duration);
        (n1 > 0 || n1 < -0.03 || s >= .5) && this.callback(e), $299b6c40adc500b8$var$me(this, $299b6c40adc500b8$var$us, e), $299b6c40adc500b8$var$me(this, $299b6c40adc500b8$var$ds, performance.now()), this.duration = t, this.playbackRate = r;
    }
};
$299b6c40adc500b8$var$pi = new WeakMap;
$299b6c40adc500b8$var$os = new WeakMap;
$299b6c40adc500b8$var$vi = new WeakMap;
$299b6c40adc500b8$var$_r = new WeakMap;
$299b6c40adc500b8$var$ls = new WeakMap;
$299b6c40adc500b8$var$ds = new WeakMap;
$299b6c40adc500b8$var$us = new WeakMap;
$299b6c40adc500b8$var$Ei = new WeakMap;
$299b6c40adc500b8$var$Nt = new WeakMap;
$299b6c40adc500b8$var$cs = new WeakMap;
var $299b6c40adc500b8$var$lo = (i, e, t)=>{
    if (!e.has(i)) throw TypeError("Cannot " + t);
}, $299b6c40adc500b8$var$G = (i, e, t)=>($299b6c40adc500b8$var$lo(i, e, "read from private field"), t ? t.call(i) : e.get(i)), $299b6c40adc500b8$var$Y = (i, e, t)=>{
    if (e.has(i)) throw TypeError("Cannot add the same private member more than once");
    e instanceof WeakSet ? e.add(i) : e.set(i, t);
}, $299b6c40adc500b8$var$Ee = (i, e, t, r)=>($299b6c40adc500b8$var$lo(i, e, "write to private field"), r ? r.call(i, t) : e.set(i, t), t), $299b6c40adc500b8$var$j = (i, e, t)=>($299b6c40adc500b8$var$lo(i, e, "access private method"), t), $299b6c40adc500b8$var$gi, $299b6c40adc500b8$var$Ut, $299b6c40adc500b8$var$vs, $299b6c40adc500b8$var$Ar, $299b6c40adc500b8$var$Es, $299b6c40adc500b8$var$ps, $299b6c40adc500b8$var$yr, $299b6c40adc500b8$var$kr, $299b6c40adc500b8$var$bi, $299b6c40adc500b8$var$fi, $299b6c40adc500b8$var$_i, $299b6c40adc500b8$var$Tr, $299b6c40adc500b8$var$uo, $299b6c40adc500b8$var$Tu, $299b6c40adc500b8$var$so, $299b6c40adc500b8$var$gs, $299b6c40adc500b8$var$co, $299b6c40adc500b8$var$bs, $299b6c40adc500b8$var$ho, $299b6c40adc500b8$var$fs, $299b6c40adc500b8$var$mo, $299b6c40adc500b8$var$ao, $299b6c40adc500b8$var$Au, $299b6c40adc500b8$var$Ir, $299b6c40adc500b8$var$_s, $299b6c40adc500b8$var$oo, $299b6c40adc500b8$var$yu, $299b6c40adc500b8$var$Mm = "video not loaded, unknown time.", $299b6c40adc500b8$var$Lm = (i)=>{
    let e = i.range, t = $299b6c40adc500b8$var$At(+$299b6c40adc500b8$var$ku(i)), r = $299b6c40adc500b8$var$At(+i.mediaSeekableEnd), n1 = t && r ? `${t} of ${r}` : $299b6c40adc500b8$var$Mm;
    e.setAttribute("aria-valuetext", n1);
};
function $299b6c40adc500b8$var$wm(i) {
    return `
    ${$299b6c40adc500b8$var$xe.getTemplateHTML(i)}
    <style>
      :host {
        --media-box-border-radius: 4px;
        --media-box-padding-left: 10px;
        --media-box-padding-right: 10px;
        --media-preview-border-radius: var(--media-box-border-radius);
        --media-box-arrow-offset: var(--media-box-border-radius);
        --_control-background: var(--media-control-background, var(--media-secondary-color, rgb(20 20 30 / .7)));
        --_preview-background: var(--media-preview-background, var(--_control-background));

        
        contain: layout;
      }

      #buffered {
        background: var(--media-time-range-buffered-color, rgb(255 255 255 / .4));
        position: absolute;
        height: 100%;
        will-change: width;
      }

      #preview-rail,
      #current-rail {
        width: 100%;
        position: absolute;
        left: 0;
        bottom: 100%;
        pointer-events: none;
        will-change: transform;
      }

      [part~="box"] {
        width: min-content;
        
        position: absolute;
        bottom: 100%;
        flex-direction: column;
        align-items: center;
        transform: translateX(-50%);
      }

      [part~="current-box"] {
        display: var(--media-current-box-display, var(--media-box-display, flex));
        margin: var(--media-current-box-margin, var(--media-box-margin, 0 0 5px));
        visibility: hidden;
      }

      [part~="preview-box"] {
        display: var(--media-preview-box-display, var(--media-box-display, flex));
        margin: var(--media-preview-box-margin, var(--media-box-margin, 0 0 5px));
        transition-property: var(--media-preview-transition-property, visibility, opacity);
        transition-duration: var(--media-preview-transition-duration-out, .25s);
        transition-delay: var(--media-preview-transition-delay-out, 0s);
        visibility: hidden;
        opacity: 0;
      }

      :host(:is([${$299b6c40adc500b8$var$a.MEDIA_PREVIEW_IMAGE}], [${$299b6c40adc500b8$var$a.MEDIA_PREVIEW_TIME}])[dragging]) [part~="preview-box"] {
        transition-duration: var(--media-preview-transition-duration-in, .5s);
        transition-delay: var(--media-preview-transition-delay-in, .25s);
        visibility: visible;
        opacity: 1;
      }

      @media (hover: hover) {
        :host(:is([${$299b6c40adc500b8$var$a.MEDIA_PREVIEW_IMAGE}], [${$299b6c40adc500b8$var$a.MEDIA_PREVIEW_TIME}]):hover) [part~="preview-box"] {
          transition-duration: var(--media-preview-transition-duration-in, .5s);
          transition-delay: var(--media-preview-transition-delay-in, .25s);
          visibility: visible;
          opacity: 1;
        }
      }

      media-preview-thumbnail,
      ::slotted(media-preview-thumbnail) {
        visibility: hidden;
        
        transition: visibility 0s .25s;
        transition-delay: calc(var(--media-preview-transition-delay-out, 0s) + var(--media-preview-transition-duration-out, .25s));
        background: var(--media-preview-thumbnail-background, var(--_preview-background));
        box-shadow: var(--media-preview-thumbnail-box-shadow, 0 0 4px rgb(0 0 0 / .2));
        max-width: var(--media-preview-thumbnail-max-width, 180px);
        max-height: var(--media-preview-thumbnail-max-height, 160px);
        min-width: var(--media-preview-thumbnail-min-width, 120px);
        min-height: var(--media-preview-thumbnail-min-height, 80px);
        border: var(--media-preview-thumbnail-border);
        border-radius: var(--media-preview-thumbnail-border-radius,
          var(--media-preview-border-radius) var(--media-preview-border-radius) 0 0);
      }

      :host([${$299b6c40adc500b8$var$a.MEDIA_PREVIEW_IMAGE}][dragging]) media-preview-thumbnail,
      :host([${$299b6c40adc500b8$var$a.MEDIA_PREVIEW_IMAGE}][dragging]) ::slotted(media-preview-thumbnail) {
        transition-delay: var(--media-preview-transition-delay-in, .25s);
        visibility: visible;
      }

      @media (hover: hover) {
        :host([${$299b6c40adc500b8$var$a.MEDIA_PREVIEW_IMAGE}]:hover) media-preview-thumbnail,
        :host([${$299b6c40adc500b8$var$a.MEDIA_PREVIEW_IMAGE}]:hover) ::slotted(media-preview-thumbnail) {
          transition-delay: var(--media-preview-transition-delay-in, .25s);
          visibility: visible;
        }

        :host([${$299b6c40adc500b8$var$a.MEDIA_PREVIEW_TIME}]:hover) {
          --media-time-range-hover-display: block;
        }
      }

      media-preview-chapter-display,
      ::slotted(media-preview-chapter-display) {
        font-size: var(--media-font-size, 13px);
        line-height: 17px;
        min-width: 0;
        visibility: hidden;
        
        transition: min-width 0s, border-radius 0s, margin 0s, padding 0s, visibility 0s;
        transition-delay: calc(var(--media-preview-transition-delay-out, 0s) + var(--media-preview-transition-duration-out, .25s));
        background: var(--media-preview-chapter-background, var(--_preview-background));
        border-radius: var(--media-preview-chapter-border-radius,
          var(--media-preview-border-radius) var(--media-preview-border-radius)
          var(--media-preview-border-radius) var(--media-preview-border-radius));
        padding: var(--media-preview-chapter-padding, 3.5px 9px);
        margin: var(--media-preview-chapter-margin, 0 0 5px);
        text-shadow: var(--media-preview-chapter-text-shadow, 0 0 4px rgb(0 0 0 / .75));
      }

      :host([${$299b6c40adc500b8$var$a.MEDIA_PREVIEW_IMAGE}]) media-preview-chapter-display,
      :host([${$299b6c40adc500b8$var$a.MEDIA_PREVIEW_IMAGE}]) ::slotted(media-preview-chapter-display) {
        transition-delay: var(--media-preview-transition-delay-in, .25s);
        border-radius: var(--media-preview-chapter-border-radius, 0);
        padding: var(--media-preview-chapter-padding, 3.5px 9px 0);
        margin: var(--media-preview-chapter-margin, 0);
        min-width: 100%;
      }

      media-preview-chapter-display[${$299b6c40adc500b8$var$a.MEDIA_PREVIEW_CHAPTER}],
      ::slotted(media-preview-chapter-display[${$299b6c40adc500b8$var$a.MEDIA_PREVIEW_CHAPTER}]) {
        visibility: visible;
      }

      media-preview-chapter-display:not([aria-valuetext]),
      ::slotted(media-preview-chapter-display:not([aria-valuetext])) {
        display: none;
      }

      media-preview-time-display,
      ::slotted(media-preview-time-display),
      media-time-display,
      ::slotted(media-time-display) {
        font-size: var(--media-font-size, 13px);
        line-height: 17px;
        min-width: 0;
        
        transition: min-width 0s, border-radius 0s;
        transition-delay: calc(var(--media-preview-transition-delay-out, 0s) + var(--media-preview-transition-duration-out, .25s));
        background: var(--media-preview-time-background, var(--_preview-background));
        border-radius: var(--media-preview-time-border-radius,
          var(--media-preview-border-radius) var(--media-preview-border-radius)
          var(--media-preview-border-radius) var(--media-preview-border-radius));
        padding: var(--media-preview-time-padding, 3.5px 9px);
        margin: var(--media-preview-time-margin, 0);
        text-shadow: var(--media-preview-time-text-shadow, 0 0 4px rgb(0 0 0 / .75));
        transform: translateX(min(
          max(calc(50% - var(--_box-width) / 2),
          calc(var(--_box-shift, 0))),
          calc(var(--_box-width) / 2 - 50%)
        ));
      }

      :host([${$299b6c40adc500b8$var$a.MEDIA_PREVIEW_IMAGE}]) media-preview-time-display,
      :host([${$299b6c40adc500b8$var$a.MEDIA_PREVIEW_IMAGE}]) ::slotted(media-preview-time-display) {
        transition-delay: var(--media-preview-transition-delay-in, .25s);
        border-radius: var(--media-preview-time-border-radius,
          0 0 var(--media-preview-border-radius) var(--media-preview-border-radius));
        min-width: 100%;
      }

      :host([${$299b6c40adc500b8$var$a.MEDIA_PREVIEW_TIME}]:hover) {
        --media-time-range-hover-display: block;
      }

      [part~="arrow"],
      ::slotted([part~="arrow"]) {
        display: var(--media-box-arrow-display, inline-block);
        transform: translateX(min(
          max(calc(50% - var(--_box-width) / 2 + var(--media-box-arrow-offset)),
          calc(var(--_box-shift, 0))),
          calc(var(--_box-width) / 2 - 50% - var(--media-box-arrow-offset))
        ));
        
        border-color: transparent;
        border-top-color: var(--media-box-arrow-background, var(--_control-background));
        border-width: var(--media-box-arrow-border-width,
          var(--media-box-arrow-height, 5px) var(--media-box-arrow-width, 6px) 0);
        border-style: solid;
        justify-content: center;
        height: 0;
      }
    </style>
    <div id="preview-rail">
      <slot name="preview" part="box preview-box">
        <media-preview-thumbnail>
          <template shadowrootmode="${$299b6c40adc500b8$var$ss.shadowRootOptions.mode}">
            ${$299b6c40adc500b8$var$ss.getTemplateHTML({})}
          </template>
        </media-preview-thumbnail>
        <media-preview-chapter-display></media-preview-chapter-display>
        <media-preview-time-display></media-preview-time-display>
        <slot name="preview-arrow"><div part="arrow"></div></slot>
      </slot>
    </div>
    <div id="current-rail">
      <slot name="current" part="box current-box">
        
      </slot>
    </div>
  `;
}
var $299b6c40adc500b8$var$ms = (i, e = i.mediaCurrentTime)=>{
    let t = Number.isFinite(i.mediaSeekableStart) ? i.mediaSeekableStart : 0, r = Number.isFinite(i.mediaDuration) ? i.mediaDuration : i.mediaSeekableEnd;
    if (Number.isNaN(r)) return 0;
    let n1 = (e - t) / (r - t);
    return Math.max(0, Math.min(n1, 1));
}, $299b6c40adc500b8$var$ku = (i, e = i.range.valueAsNumber)=>{
    let t = Number.isFinite(i.mediaSeekableStart) ? i.mediaSeekableStart : 0, r = Number.isFinite(i.mediaDuration) ? i.mediaDuration : i.mediaSeekableEnd;
    return Number.isNaN(r) ? 0 : e * (r - t) + t;
}, $299b6c40adc500b8$var$Sr = class extends $299b6c40adc500b8$var$xe {
    constructor(){
        super(), $299b6c40adc500b8$var$Y(this, $299b6c40adc500b8$var$_i), $299b6c40adc500b8$var$Y(this, $299b6c40adc500b8$var$uo), $299b6c40adc500b8$var$Y(this, $299b6c40adc500b8$var$gs), $299b6c40adc500b8$var$Y(this, $299b6c40adc500b8$var$bs), $299b6c40adc500b8$var$Y(this, $299b6c40adc500b8$var$fs), $299b6c40adc500b8$var$Y(this, $299b6c40adc500b8$var$ao), $299b6c40adc500b8$var$Y(this, $299b6c40adc500b8$var$Ir), $299b6c40adc500b8$var$Y(this, $299b6c40adc500b8$var$oo), $299b6c40adc500b8$var$Y(this, $299b6c40adc500b8$var$gi, void 0), $299b6c40adc500b8$var$Y(this, $299b6c40adc500b8$var$Ut, void 0), $299b6c40adc500b8$var$Y(this, $299b6c40adc500b8$var$vs, void 0), $299b6c40adc500b8$var$Y(this, $299b6c40adc500b8$var$Ar, void 0), $299b6c40adc500b8$var$Y(this, $299b6c40adc500b8$var$Es, void 0), $299b6c40adc500b8$var$Y(this, $299b6c40adc500b8$var$ps, void 0), $299b6c40adc500b8$var$Y(this, $299b6c40adc500b8$var$yr, void 0), $299b6c40adc500b8$var$Y(this, $299b6c40adc500b8$var$kr, void 0), $299b6c40adc500b8$var$Y(this, $299b6c40adc500b8$var$bi, void 0), $299b6c40adc500b8$var$Y(this, $299b6c40adc500b8$var$fi, void 0), $299b6c40adc500b8$var$Y(this, $299b6c40adc500b8$var$so, (r)=>{
            this.dragging || ($299b6c40adc500b8$var$jt(r) && (this.range.valueAsNumber = r), $299b6c40adc500b8$var$G(this, $299b6c40adc500b8$var$fi) || this.updateBar());
        }), this.shadowRoot.querySelector("#track").insertAdjacentHTML("afterbegin", '<div id="buffered" part="buffered"></div>'), $299b6c40adc500b8$var$Ee(this, $299b6c40adc500b8$var$vs, this.shadowRoot.querySelectorAll('[part~="box"]')), $299b6c40adc500b8$var$Ee(this, $299b6c40adc500b8$var$Es, this.shadowRoot.querySelector('[part~="preview-box"]')), $299b6c40adc500b8$var$Ee(this, $299b6c40adc500b8$var$ps, this.shadowRoot.querySelector('[part~="current-box"]'));
        let t = getComputedStyle(this);
        $299b6c40adc500b8$var$Ee(this, $299b6c40adc500b8$var$yr, parseInt(t.getPropertyValue("--media-box-padding-left"))), $299b6c40adc500b8$var$Ee(this, $299b6c40adc500b8$var$kr, parseInt(t.getPropertyValue("--media-box-padding-right"))), $299b6c40adc500b8$var$Ee(this, $299b6c40adc500b8$var$Ut, new $299b6c40adc500b8$var$hs(this.range, $299b6c40adc500b8$var$G(this, $299b6c40adc500b8$var$so), 60));
    }
    static get observedAttributes() {
        return [
            ...super.observedAttributes,
            $299b6c40adc500b8$var$a.MEDIA_PAUSED,
            $299b6c40adc500b8$var$a.MEDIA_DURATION,
            $299b6c40adc500b8$var$a.MEDIA_SEEKABLE,
            $299b6c40adc500b8$var$a.MEDIA_CURRENT_TIME,
            $299b6c40adc500b8$var$a.MEDIA_PREVIEW_IMAGE,
            $299b6c40adc500b8$var$a.MEDIA_PREVIEW_TIME,
            $299b6c40adc500b8$var$a.MEDIA_PREVIEW_CHAPTER,
            $299b6c40adc500b8$var$a.MEDIA_BUFFERED,
            $299b6c40adc500b8$var$a.MEDIA_PLAYBACK_RATE,
            $299b6c40adc500b8$var$a.MEDIA_LOADING,
            $299b6c40adc500b8$var$a.MEDIA_ENDED
        ];
    }
    connectedCallback() {
        var e;
        super.connectedCallback(), this.range.setAttribute("aria-label", $299b6c40adc500b8$var$c("seek")), $299b6c40adc500b8$var$j(this, $299b6c40adc500b8$var$_i, $299b6c40adc500b8$var$Tr).call(this), $299b6c40adc500b8$var$Ee(this, $299b6c40adc500b8$var$gi, this.getRootNode()), (e = $299b6c40adc500b8$var$G(this, $299b6c40adc500b8$var$gi)) == null || e.addEventListener("transitionstart", this);
    }
    disconnectedCallback() {
        var e;
        super.disconnectedCallback(), $299b6c40adc500b8$var$j(this, $299b6c40adc500b8$var$_i, $299b6c40adc500b8$var$Tr).call(this), (e = $299b6c40adc500b8$var$G(this, $299b6c40adc500b8$var$gi)) == null || e.removeEventListener("transitionstart", this), $299b6c40adc500b8$var$Ee(this, $299b6c40adc500b8$var$gi, null);
    }
    attributeChangedCallback(e, t, r) {
        super.attributeChangedCallback(e, t, r), t != r && (e === $299b6c40adc500b8$var$a.MEDIA_CURRENT_TIME || e === $299b6c40adc500b8$var$a.MEDIA_PAUSED || e === $299b6c40adc500b8$var$a.MEDIA_ENDED || e === $299b6c40adc500b8$var$a.MEDIA_LOADING || e === $299b6c40adc500b8$var$a.MEDIA_DURATION || e === $299b6c40adc500b8$var$a.MEDIA_SEEKABLE ? ($299b6c40adc500b8$var$G(this, $299b6c40adc500b8$var$Ut).update({
            start: $299b6c40adc500b8$var$ms(this),
            duration: this.mediaSeekableEnd - this.mediaSeekableStart,
            playbackRate: this.mediaPlaybackRate
        }), $299b6c40adc500b8$var$j(this, $299b6c40adc500b8$var$_i, $299b6c40adc500b8$var$Tr).call(this), $299b6c40adc500b8$var$Lm(this)) : e === $299b6c40adc500b8$var$a.MEDIA_BUFFERED && this.updateBufferedBar(), (e === $299b6c40adc500b8$var$a.MEDIA_DURATION || e === $299b6c40adc500b8$var$a.MEDIA_SEEKABLE) && (this.mediaChaptersCues = $299b6c40adc500b8$var$G(this, $299b6c40adc500b8$var$bi), this.updateBar()));
    }
    get mediaChaptersCues() {
        return $299b6c40adc500b8$var$G(this, $299b6c40adc500b8$var$bi);
    }
    set mediaChaptersCues(e) {
        var t;
        $299b6c40adc500b8$var$Ee(this, $299b6c40adc500b8$var$bi, e), this.updateSegments((t = $299b6c40adc500b8$var$G(this, $299b6c40adc500b8$var$bi)) == null ? void 0 : t.map((r)=>({
                start: $299b6c40adc500b8$var$ms(this, r.startTime),
                end: $299b6c40adc500b8$var$ms(this, r.endTime)
            })));
    }
    get mediaPaused() {
        return $299b6c40adc500b8$var$A(this, $299b6c40adc500b8$var$a.MEDIA_PAUSED);
    }
    set mediaPaused(e) {
        $299b6c40adc500b8$var$y(this, $299b6c40adc500b8$var$a.MEDIA_PAUSED, e);
    }
    get mediaLoading() {
        return $299b6c40adc500b8$var$A(this, $299b6c40adc500b8$var$a.MEDIA_LOADING);
    }
    set mediaLoading(e) {
        $299b6c40adc500b8$var$y(this, $299b6c40adc500b8$var$a.MEDIA_LOADING, e);
    }
    get mediaDuration() {
        return $299b6c40adc500b8$var$M(this, $299b6c40adc500b8$var$a.MEDIA_DURATION);
    }
    set mediaDuration(e) {
        $299b6c40adc500b8$var$w(this, $299b6c40adc500b8$var$a.MEDIA_DURATION, e);
    }
    get mediaCurrentTime() {
        return $299b6c40adc500b8$var$M(this, $299b6c40adc500b8$var$a.MEDIA_CURRENT_TIME);
    }
    set mediaCurrentTime(e) {
        $299b6c40adc500b8$var$w(this, $299b6c40adc500b8$var$a.MEDIA_CURRENT_TIME, e);
    }
    get mediaPlaybackRate() {
        return $299b6c40adc500b8$var$M(this, $299b6c40adc500b8$var$a.MEDIA_PLAYBACK_RATE, 1);
    }
    set mediaPlaybackRate(e) {
        $299b6c40adc500b8$var$w(this, $299b6c40adc500b8$var$a.MEDIA_PLAYBACK_RATE, e);
    }
    get mediaBuffered() {
        let e = this.getAttribute($299b6c40adc500b8$var$a.MEDIA_BUFFERED);
        return e ? e.split(" ").map((t)=>t.split(":").map((r)=>+r)) : [];
    }
    set mediaBuffered(e) {
        if (!e) {
            this.removeAttribute($299b6c40adc500b8$var$a.MEDIA_BUFFERED);
            return;
        }
        let t = e.map((r)=>r.join(":")).join(" ");
        this.setAttribute($299b6c40adc500b8$var$a.MEDIA_BUFFERED, t);
    }
    get mediaSeekable() {
        let e = this.getAttribute($299b6c40adc500b8$var$a.MEDIA_SEEKABLE);
        if (e) return e.split(":").map((t)=>+t);
    }
    set mediaSeekable(e) {
        if (e == null) {
            this.removeAttribute($299b6c40adc500b8$var$a.MEDIA_SEEKABLE);
            return;
        }
        this.setAttribute($299b6c40adc500b8$var$a.MEDIA_SEEKABLE, e.join(":"));
    }
    get mediaSeekableEnd() {
        var e;
        let [, t = this.mediaDuration] = (e = this.mediaSeekable) != null ? e : [];
        return t;
    }
    get mediaSeekableStart() {
        var e;
        let [t = 0] = (e = this.mediaSeekable) != null ? e : [];
        return t;
    }
    get mediaPreviewImage() {
        return $299b6c40adc500b8$var$_(this, $299b6c40adc500b8$var$a.MEDIA_PREVIEW_IMAGE);
    }
    set mediaPreviewImage(e) {
        $299b6c40adc500b8$var$b(this, $299b6c40adc500b8$var$a.MEDIA_PREVIEW_IMAGE, e);
    }
    get mediaPreviewTime() {
        return $299b6c40adc500b8$var$M(this, $299b6c40adc500b8$var$a.MEDIA_PREVIEW_TIME);
    }
    set mediaPreviewTime(e) {
        $299b6c40adc500b8$var$w(this, $299b6c40adc500b8$var$a.MEDIA_PREVIEW_TIME, e);
    }
    get mediaEnded() {
        return $299b6c40adc500b8$var$A(this, $299b6c40adc500b8$var$a.MEDIA_ENDED);
    }
    set mediaEnded(e) {
        $299b6c40adc500b8$var$y(this, $299b6c40adc500b8$var$a.MEDIA_ENDED, e);
    }
    updateBar() {
        super.updateBar(), this.updateBufferedBar(), this.updateCurrentBox();
    }
    updateBufferedBar() {
        var e;
        let t = this.mediaBuffered;
        if (!t.length) return;
        let r;
        if (this.mediaEnded) r = 1;
        else {
            let s = this.mediaCurrentTime, [, o = this.mediaSeekableStart] = (e = t.find(([d, u])=>d <= s && s <= u)) != null ? e : [];
            r = $299b6c40adc500b8$var$ms(this, o);
        }
        let { style: n1 } = $299b6c40adc500b8$var$O(this.shadowRoot, "#buffered");
        n1.setProperty("width", `${r * 100}%`);
    }
    updateCurrentBox() {
        if (!this.shadowRoot.querySelector('slot[name="current"]').assignedElements().length) return;
        let t = $299b6c40adc500b8$var$O(this.shadowRoot, "#current-rail"), r = $299b6c40adc500b8$var$O(this.shadowRoot, '[part~="current-box"]'), n1 = $299b6c40adc500b8$var$j(this, $299b6c40adc500b8$var$gs, $299b6c40adc500b8$var$co).call(this, $299b6c40adc500b8$var$G(this, $299b6c40adc500b8$var$ps)), s = $299b6c40adc500b8$var$j(this, $299b6c40adc500b8$var$bs, $299b6c40adc500b8$var$ho).call(this, n1, this.range.valueAsNumber), o = $299b6c40adc500b8$var$j(this, $299b6c40adc500b8$var$fs, $299b6c40adc500b8$var$mo).call(this, n1, this.range.valueAsNumber);
        t.style.transform = `translateX(${s})`, t.style.setProperty("--_range-width", `${n1.range.width}`), r.style.setProperty("--_box-shift", `${o}`), r.style.setProperty("--_box-width", `${n1.box.width}px`), r.style.setProperty("visibility", "initial");
    }
    handleEvent(e) {
        switch(super.handleEvent(e), e.type){
            case "input":
                $299b6c40adc500b8$var$j(this, $299b6c40adc500b8$var$oo, $299b6c40adc500b8$var$yu).call(this);
                break;
            case "pointermove":
                $299b6c40adc500b8$var$j(this, $299b6c40adc500b8$var$ao, $299b6c40adc500b8$var$Au).call(this, e);
                break;
            case "pointerup":
                $299b6c40adc500b8$var$G(this, $299b6c40adc500b8$var$fi) && $299b6c40adc500b8$var$Ee(this, $299b6c40adc500b8$var$fi, !1);
                break;
            case "pointerdown":
                $299b6c40adc500b8$var$Ee(this, $299b6c40adc500b8$var$fi, !0);
                break;
            case "pointerleave":
                $299b6c40adc500b8$var$j(this, $299b6c40adc500b8$var$Ir, $299b6c40adc500b8$var$_s).call(this, null);
                break;
            case "transitionstart":
                $299b6c40adc500b8$var$ee(e.target, this) && setTimeout(()=>$299b6c40adc500b8$var$j(this, $299b6c40adc500b8$var$_i, $299b6c40adc500b8$var$Tr).call(this), 0);
                break;
        }
    }
};
$299b6c40adc500b8$var$gi = new WeakMap;
$299b6c40adc500b8$var$Ut = new WeakMap;
$299b6c40adc500b8$var$vs = new WeakMap;
$299b6c40adc500b8$var$Ar = new WeakMap;
$299b6c40adc500b8$var$Es = new WeakMap;
$299b6c40adc500b8$var$ps = new WeakMap;
$299b6c40adc500b8$var$yr = new WeakMap;
$299b6c40adc500b8$var$kr = new WeakMap;
$299b6c40adc500b8$var$bi = new WeakMap;
$299b6c40adc500b8$var$fi = new WeakMap;
$299b6c40adc500b8$var$_i = new WeakSet;
$299b6c40adc500b8$var$Tr = function() {
    $299b6c40adc500b8$var$j(this, $299b6c40adc500b8$var$uo, $299b6c40adc500b8$var$Tu).call(this) ? $299b6c40adc500b8$var$G(this, $299b6c40adc500b8$var$Ut).start() : $299b6c40adc500b8$var$G(this, $299b6c40adc500b8$var$Ut).stop();
};
$299b6c40adc500b8$var$uo = new WeakSet;
$299b6c40adc500b8$var$Tu = function() {
    return this.isConnected && !this.mediaPaused && !this.mediaLoading && !this.mediaEnded && this.mediaSeekableEnd > 0 && $299b6c40adc500b8$var$tn(this);
};
$299b6c40adc500b8$var$so = new WeakMap;
$299b6c40adc500b8$var$gs = new WeakSet;
$299b6c40adc500b8$var$co = function(i) {
    var e;
    let r = ((e = this.getAttribute("bounds") ? $299b6c40adc500b8$var$we(this, `#${this.getAttribute("bounds")}`) : this.parentElement) != null ? e : this).getBoundingClientRect(), n1 = this.range.getBoundingClientRect(), s = i.offsetWidth, o = -(n1.left - r.left - s / 2), d = r.right - n1.left - s / 2;
    return {
        box: {
            width: s,
            min: o,
            max: d
        },
        bounds: r,
        range: n1
    };
};
$299b6c40adc500b8$var$bs = new WeakSet;
$299b6c40adc500b8$var$ho = function(i, e) {
    let t = `${e * 100}%`, { width: r, min: n1, max: s } = i.box;
    if (!r) return t;
    if (Number.isNaN(n1) || (t = `max(${`calc(1 / var(--_range-width) * 100 * ${n1}% + var(--media-box-padding-left))`}, ${t})`), !Number.isNaN(s)) {
        let d = `calc(1 / var(--_range-width) * 100 * ${s}% - var(--media-box-padding-right))`;
        t = `min(${t}, ${d})`;
    }
    return t;
};
$299b6c40adc500b8$var$fs = new WeakSet;
$299b6c40adc500b8$var$mo = function(i, e) {
    let { width: t, min: r, max: n1 } = i.box, s = e * i.range.width;
    if (s < r + $299b6c40adc500b8$var$G(this, $299b6c40adc500b8$var$yr)) {
        let o = i.range.left - i.bounds.left - $299b6c40adc500b8$var$G(this, $299b6c40adc500b8$var$yr);
        return `${s - t / 2 + o}px`;
    }
    if (s > n1 - $299b6c40adc500b8$var$G(this, $299b6c40adc500b8$var$kr)) {
        let o = i.bounds.right - i.range.right - $299b6c40adc500b8$var$G(this, $299b6c40adc500b8$var$kr);
        return `${s + t / 2 - o - i.range.width}px`;
    }
    return 0;
};
$299b6c40adc500b8$var$ao = new WeakSet;
$299b6c40adc500b8$var$Au = function(i) {
    let e = [
        ...$299b6c40adc500b8$var$G(this, $299b6c40adc500b8$var$vs)
    ].some((f)=>i.composedPath().includes(f));
    if (!this.dragging && (e || !i.composedPath().includes(this))) {
        $299b6c40adc500b8$var$j(this, $299b6c40adc500b8$var$Ir, $299b6c40adc500b8$var$_s).call(this, null);
        return;
    }
    let t = this.mediaSeekableEnd;
    if (!t) return;
    let r = $299b6c40adc500b8$var$O(this.shadowRoot, "#preview-rail"), n1 = $299b6c40adc500b8$var$O(this.shadowRoot, '[part~="preview-box"]'), s = $299b6c40adc500b8$var$j(this, $299b6c40adc500b8$var$gs, $299b6c40adc500b8$var$co).call(this, $299b6c40adc500b8$var$G(this, $299b6c40adc500b8$var$Es)), o = (i.clientX - s.range.left) / s.range.width;
    o = Math.max(0, Math.min(1, o));
    let d = $299b6c40adc500b8$var$j(this, $299b6c40adc500b8$var$bs, $299b6c40adc500b8$var$ho).call(this, s, o), u = $299b6c40adc500b8$var$j(this, $299b6c40adc500b8$var$fs, $299b6c40adc500b8$var$mo).call(this, s, o);
    r.style.transform = `translateX(${d})`, r.style.setProperty("--_range-width", `${s.range.width}`), n1.style.setProperty("--_box-shift", `${u}`), n1.style.setProperty("--_box-width", `${s.box.width}px`);
    let m = Math.round($299b6c40adc500b8$var$G(this, $299b6c40adc500b8$var$Ar)) - Math.round(o * t);
    Math.abs(m) < 1 && o > .01 && o < .99 || ($299b6c40adc500b8$var$Ee(this, $299b6c40adc500b8$var$Ar, o * t), $299b6c40adc500b8$var$j(this, $299b6c40adc500b8$var$Ir, $299b6c40adc500b8$var$_s).call(this, $299b6c40adc500b8$var$G(this, $299b6c40adc500b8$var$Ar)));
};
$299b6c40adc500b8$var$Ir = new WeakSet;
$299b6c40adc500b8$var$_s = function(i) {
    this.dispatchEvent(new $299b6c40adc500b8$var$l.CustomEvent($299b6c40adc500b8$var$h.MEDIA_PREVIEW_REQUEST, {
        composed: !0,
        bubbles: !0,
        detail: i
    }));
};
$299b6c40adc500b8$var$oo = new WeakSet;
$299b6c40adc500b8$var$yu = function() {
    $299b6c40adc500b8$var$G(this, $299b6c40adc500b8$var$Ut).stop();
    let i = $299b6c40adc500b8$var$ku(this);
    this.dispatchEvent(new $299b6c40adc500b8$var$l.CustomEvent($299b6c40adc500b8$var$h.MEDIA_SEEK_REQUEST, {
        composed: !0,
        bubbles: !0,
        detail: i
    }));
};
$299b6c40adc500b8$var$Sr.shadowRootOptions = {
    mode: "open"
};
$299b6c40adc500b8$var$Sr.getTemplateHTML = $299b6c40adc500b8$var$wm;
$299b6c40adc500b8$var$l.customElements.get("media-time-range") || $299b6c40adc500b8$var$l.customElements.define("media-time-range", $299b6c40adc500b8$var$Sr);
var $299b6c40adc500b8$var$Cm = 1, $299b6c40adc500b8$var$Rm = (i)=>i.mediaMuted ? 0 : i.mediaVolume, $299b6c40adc500b8$var$Pm = (i)=>`${Math.round(i * 100)}%`, $299b6c40adc500b8$var$po = class extends $299b6c40adc500b8$var$xe {
    static get observedAttributes() {
        return [
            ...super.observedAttributes,
            $299b6c40adc500b8$var$a.MEDIA_VOLUME,
            $299b6c40adc500b8$var$a.MEDIA_MUTED,
            $299b6c40adc500b8$var$a.MEDIA_VOLUME_UNAVAILABLE
        ];
    }
    constructor(){
        super(), this.range.addEventListener("input", ()=>{
            let e = this.range.value, t = new $299b6c40adc500b8$var$l.CustomEvent($299b6c40adc500b8$var$h.MEDIA_VOLUME_REQUEST, {
                composed: !0,
                bubbles: !0,
                detail: e
            });
            this.dispatchEvent(t);
        });
    }
    connectedCallback() {
        super.connectedCallback(), this.range.setAttribute("aria-label", $299b6c40adc500b8$var$c("volume"));
    }
    attributeChangedCallback(e, t, r) {
        super.attributeChangedCallback(e, t, r), (e === $299b6c40adc500b8$var$a.MEDIA_VOLUME || e === $299b6c40adc500b8$var$a.MEDIA_MUTED) && (this.range.valueAsNumber = $299b6c40adc500b8$var$Rm(this), this.range.setAttribute("aria-valuetext", $299b6c40adc500b8$var$Pm(this.range.valueAsNumber)), this.updateBar());
    }
    get mediaVolume() {
        return $299b6c40adc500b8$var$M(this, $299b6c40adc500b8$var$a.MEDIA_VOLUME, $299b6c40adc500b8$var$Cm);
    }
    set mediaVolume(e) {
        $299b6c40adc500b8$var$w(this, $299b6c40adc500b8$var$a.MEDIA_VOLUME, e);
    }
    get mediaMuted() {
        return $299b6c40adc500b8$var$A(this, $299b6c40adc500b8$var$a.MEDIA_MUTED);
    }
    set mediaMuted(e) {
        $299b6c40adc500b8$var$y(this, $299b6c40adc500b8$var$a.MEDIA_MUTED, e);
    }
    get mediaVolumeUnavailable() {
        return $299b6c40adc500b8$var$_(this, $299b6c40adc500b8$var$a.MEDIA_VOLUME_UNAVAILABLE);
    }
    set mediaVolumeUnavailable(e) {
        $299b6c40adc500b8$var$b(this, $299b6c40adc500b8$var$a.MEDIA_VOLUME_UNAVAILABLE, e);
    }
};
$299b6c40adc500b8$var$l.customElements.get("media-volume-range") || $299b6c40adc500b8$var$l.customElements.define("media-volume-range", $299b6c40adc500b8$var$po);
var $299b6c40adc500b8$var$_o = (i, e, t)=>{
    if (!e.has(i)) throw TypeError("Cannot " + t);
}, $299b6c40adc500b8$var$Be = (i, e, t)=>($299b6c40adc500b8$var$_o(i, e, "read from private field"), t ? t.call(i) : e.get(i)), $299b6c40adc500b8$var$Je = (i, e, t)=>{
    if (e.has(i)) throw TypeError("Cannot add the same private member more than once");
    e instanceof WeakSet ? e.add(i) : e.set(i, t);
}, $299b6c40adc500b8$var$vo = (i, e, t, r)=>($299b6c40adc500b8$var$_o(i, e, "write to private field"), r ? r.call(i, t) : e.set(i, t), t), $299b6c40adc500b8$var$Ie = (i, e, t)=>($299b6c40adc500b8$var$_o(i, e, "access private method"), t), $299b6c40adc500b8$var$Ts, $299b6c40adc500b8$var$Lr, $299b6c40adc500b8$var$Eo, $299b6c40adc500b8$var$Iu, $299b6c40adc500b8$var$ys, $299b6c40adc500b8$var$To, $299b6c40adc500b8$var$Ao, $299b6c40adc500b8$var$Su, $299b6c40adc500b8$var$$e, $299b6c40adc500b8$var$Ti, $299b6c40adc500b8$var$wr, $299b6c40adc500b8$var$go, $299b6c40adc500b8$var$Mu, $299b6c40adc500b8$var$As, $299b6c40adc500b8$var$bo;
function $299b6c40adc500b8$var$Dm(i) {
    return `
    <style>
      :host {
        transition: var(--media-menu-item-transition,
          background .15s linear,
          opacity .2s ease-in-out
        );
        outline: var(--media-menu-item-outline, 0);
        outline-offset: var(--media-menu-item-outline-offset, -1px);
        cursor: var(--media-cursor, pointer);
        display: flex;
        align-items: center;
        align-self: stretch;
        justify-self: stretch;
        white-space: nowrap;
        white-space-collapse: collapse;
        text-wrap: nowrap;
        padding: .4em .8em .4em 1em;
      }

      :host(:focus-visible) {
        box-shadow: var(--media-menu-item-focus-shadow, inset 0 0 0 2px rgb(27 127 204 / .9));
        outline: var(--media-menu-item-hover-outline, 0);
        outline-offset: var(--media-menu-item-hover-outline-offset,  var(--media-menu-item-outline-offset, -1px));
      }

      :host(:hover) {
        cursor: var(--media-cursor, pointer);
        background: var(--media-menu-item-hover-background, rgb(92 92 102 / .5));
        outline: var(--media-menu-item-hover-outline);
        outline-offset: var(--media-menu-item-hover-outline-offset,  var(--media-menu-item-outline-offset, -1px));
      }

      :host([aria-checked="true"]) {
        background: var(--media-menu-item-checked-background);
      }

      :host([hidden]) {
        display: none;
      }

      :host([disabled]) {
        pointer-events: none;
        color: rgba(255, 255, 255, .3);
      }

      slot:not([name]) {
        width: 100%;
      }

      slot:not([name="submenu"]) {
        display: inline-flex;
        align-items: center;
        transition: inherit;
        opacity: var(--media-menu-item-opacity, 1);
      }

      slot[name="description"] {
        justify-content: end;
      }

      slot[name="description"] > span {
        display: inline-block;
        margin-inline: 1em .2em;
        max-width: var(--media-menu-item-description-max-width, 100px);
        text-overflow: ellipsis;
        overflow: hidden;
        font-size: .8em;
        font-weight: 400;
        text-align: right;
        position: relative;
        top: .04em;
      }

      slot[name="checked-indicator"] {
        display: none;
      }

      :host(:is([role="menuitemradio"],[role="menuitemcheckbox"])) slot[name="checked-indicator"] {
        display: var(--media-menu-item-checked-indicator-display, inline-block);
      }

      
      svg, img, ::slotted(svg), ::slotted(img) {
        height: var(--media-menu-item-icon-height, var(--media-control-height, 24px));
        fill: var(--media-icon-color, var(--media-primary-color, rgb(238 238 238)));
        display: block;
      }

      
      [part~="indicator"],
      ::slotted([part~="indicator"]) {
        fill: var(--media-menu-item-indicator-fill,
          var(--media-icon-color, var(--media-primary-color, rgb(238 238 238))));
        height: var(--media-menu-item-indicator-height, 1.25em);
        margin-right: .5ch;
      }

      [part~="checked-indicator"] {
        visibility: hidden;
      }

      :host([aria-checked="true"]) [part~="checked-indicator"] {
        visibility: visible;
      }
    </style>
    <slot name="checked-indicator">
      <svg aria-hidden="true" viewBox="0 1 24 24" part="checked-indicator indicator">
        <path d="m10 15.17 9.193-9.191 1.414 1.414-10.606 10.606-6.364-6.364 1.414-1.414 4.95 4.95Z"/>
      </svg>
    </slot>
    <slot name="prefix"></slot>
    <slot></slot>
    <slot name="description"></slot>
    <slot name="suffix">
      ${this.getSuffixSlotInnerHTML(i)}
    </slot>
    <slot name="submenu"></slot>
  `;
}
function $299b6c40adc500b8$var$Om(i) {
    return "";
}
var $299b6c40adc500b8$var$ge = {
    TYPE: "type",
    VALUE: "value",
    CHECKED: "checked",
    DISABLED: "disabled"
}, $299b6c40adc500b8$var$Ge = class extends $299b6c40adc500b8$var$l.HTMLElement {
    constructor(){
        if (super(), $299b6c40adc500b8$var$Je(this, $299b6c40adc500b8$var$Eo), $299b6c40adc500b8$var$Je(this, $299b6c40adc500b8$var$ys), $299b6c40adc500b8$var$Je(this, $299b6c40adc500b8$var$Ao), $299b6c40adc500b8$var$Je(this, $299b6c40adc500b8$var$Ti), $299b6c40adc500b8$var$Je(this, $299b6c40adc500b8$var$go), $299b6c40adc500b8$var$Je(this, $299b6c40adc500b8$var$As), $299b6c40adc500b8$var$Je(this, $299b6c40adc500b8$var$Ts, !1), $299b6c40adc500b8$var$Je(this, $299b6c40adc500b8$var$Lr, void 0), $299b6c40adc500b8$var$Je(this, $299b6c40adc500b8$var$$e, ()=>{
            var e, t;
            this.submenuElement.items && this.setAttribute("submenusize", `${this.submenuElement.items.length}`);
            let r = this.shadowRoot.querySelector('slot[name="description"]'), n1 = (e = this.submenuElement.checkedItems) == null ? void 0 : e[0], s = (t = n1?.dataset.description) != null ? t : n1?.text, o = $299b6c40adc500b8$var$F.createElement("span");
            o.textContent = s ?? "", r.replaceChildren(o);
        }), !this.shadowRoot) {
            this.attachShadow(this.constructor.shadowRootOptions);
            let e = $299b6c40adc500b8$var$W(this.attributes);
            this.shadowRoot.innerHTML = this.constructor.getTemplateHTML(e);
        }
        this.shadowRoot.addEventListener("slotchange", this);
    }
    static get observedAttributes() {
        return [
            $299b6c40adc500b8$var$ge.TYPE,
            $299b6c40adc500b8$var$ge.DISABLED,
            $299b6c40adc500b8$var$ge.CHECKED,
            $299b6c40adc500b8$var$ge.VALUE
        ];
    }
    enable() {
        this.hasAttribute("tabindex") || this.setAttribute("tabindex", "-1"), $299b6c40adc500b8$var$Mr(this) && !this.hasAttribute("aria-checked") && this.setAttribute("aria-checked", "false"), this.addEventListener("click", this), this.addEventListener("keydown", this);
    }
    disable() {
        this.removeAttribute("tabindex"), this.removeEventListener("click", this), this.removeEventListener("keydown", this), this.removeEventListener("keyup", this);
    }
    handleEvent(e) {
        switch(e.type){
            case "slotchange":
                $299b6c40adc500b8$var$Ie(this, $299b6c40adc500b8$var$Eo, $299b6c40adc500b8$var$Iu).call(this, e);
                break;
            case "click":
                this.handleClick(e);
                break;
            case "keydown":
                $299b6c40adc500b8$var$Ie(this, $299b6c40adc500b8$var$go, $299b6c40adc500b8$var$Mu).call(this, e);
                break;
            case "keyup":
                $299b6c40adc500b8$var$Ie(this, $299b6c40adc500b8$var$Ti, $299b6c40adc500b8$var$wr).call(this, e);
                break;
        }
    }
    attributeChangedCallback(e, t, r) {
        e === $299b6c40adc500b8$var$ge.CHECKED && $299b6c40adc500b8$var$Mr(this) && !$299b6c40adc500b8$var$Be(this, $299b6c40adc500b8$var$Ts) ? this.setAttribute("aria-checked", r != null ? "true" : "false") : e === $299b6c40adc500b8$var$ge.TYPE && r !== t ? this.role = "menuitem" + r : e === $299b6c40adc500b8$var$ge.DISABLED && r !== t && (r == null ? this.enable() : this.disable());
    }
    connectedCallback() {
        this.hasAttribute($299b6c40adc500b8$var$ge.DISABLED) || this.enable(), this.role = "menuitem" + this.type, $299b6c40adc500b8$var$vo(this, $299b6c40adc500b8$var$Lr, $299b6c40adc500b8$var$fo(this, this.parentNode)), $299b6c40adc500b8$var$Ie(this, $299b6c40adc500b8$var$As, $299b6c40adc500b8$var$bo).call(this), this.submenuElement && $299b6c40adc500b8$var$Ie(this, $299b6c40adc500b8$var$ys, $299b6c40adc500b8$var$To).call(this);
    }
    disconnectedCallback() {
        this.disable(), $299b6c40adc500b8$var$Ie(this, $299b6c40adc500b8$var$As, $299b6c40adc500b8$var$bo).call(this), $299b6c40adc500b8$var$vo(this, $299b6c40adc500b8$var$Lr, null);
    }
    get invokeTarget() {
        return this.getAttribute("invoketarget");
    }
    set invokeTarget(e) {
        this.setAttribute("invoketarget", `${e}`);
    }
    get invokeTargetElement() {
        var e;
        return this.invokeTarget ? (e = $299b6c40adc500b8$var$bt(this)) == null ? void 0 : e.querySelector(`#${this.invokeTarget}`) : this.submenuElement;
    }
    get submenuElement() {
        return this.shadowRoot.querySelector('slot[name="submenu"]').assignedElements({
            flatten: !0
        })[0];
    }
    get type() {
        var e;
        return (e = this.getAttribute($299b6c40adc500b8$var$ge.TYPE)) != null ? e : "";
    }
    set type(e) {
        this.setAttribute($299b6c40adc500b8$var$ge.TYPE, `${e}`);
    }
    get value() {
        var e;
        return (e = this.getAttribute($299b6c40adc500b8$var$ge.VALUE)) != null ? e : this.text;
    }
    set value(e) {
        this.setAttribute($299b6c40adc500b8$var$ge.VALUE, e);
    }
    get text() {
        var e;
        return ((e = this.textContent) != null ? e : "").trim();
    }
    get checked() {
        if ($299b6c40adc500b8$var$Mr(this)) return this.getAttribute("aria-checked") === "true";
    }
    set checked(e) {
        $299b6c40adc500b8$var$Mr(this) && ($299b6c40adc500b8$var$vo(this, $299b6c40adc500b8$var$Ts, !0), this.setAttribute("aria-checked", e ? "true" : "false"), e ? this.part.add("checked") : this.part.remove("checked"));
    }
    handleClick(e) {
        $299b6c40adc500b8$var$Mr(this) || this.invokeTargetElement && $299b6c40adc500b8$var$ee(this, e.target) && this.invokeTargetElement.dispatchEvent(new $299b6c40adc500b8$var$et({
            relatedTarget: this
        }));
    }
    get keysUsed() {
        return [
            "Enter",
            " "
        ];
    }
};
$299b6c40adc500b8$var$Ts = new WeakMap;
$299b6c40adc500b8$var$Lr = new WeakMap;
$299b6c40adc500b8$var$Eo = new WeakSet;
$299b6c40adc500b8$var$Iu = function(i) {
    let e = i.target;
    if (!e?.name) for (let r of e.assignedNodes({
        flatten: !0
    }))r instanceof Text && r.textContent.trim() === "" && r.remove();
    e.name === "submenu" && (this.submenuElement ? $299b6c40adc500b8$var$Ie(this, $299b6c40adc500b8$var$ys, $299b6c40adc500b8$var$To).call(this) : $299b6c40adc500b8$var$Ie(this, $299b6c40adc500b8$var$Ao, $299b6c40adc500b8$var$Su).call(this));
};
$299b6c40adc500b8$var$ys = new WeakSet;
$299b6c40adc500b8$var$To = async function() {
    this.setAttribute("aria-haspopup", "menu"), this.setAttribute("aria-expanded", `${!this.submenuElement.hidden}`), this.submenuElement.addEventListener("change", $299b6c40adc500b8$var$Be(this, $299b6c40adc500b8$var$$e)), this.submenuElement.addEventListener("addmenuitem", $299b6c40adc500b8$var$Be(this, $299b6c40adc500b8$var$$e)), this.submenuElement.addEventListener("removemenuitem", $299b6c40adc500b8$var$Be(this, $299b6c40adc500b8$var$$e)), $299b6c40adc500b8$var$Be(this, $299b6c40adc500b8$var$$e).call(this);
};
$299b6c40adc500b8$var$Ao = new WeakSet;
$299b6c40adc500b8$var$Su = function() {
    this.removeAttribute("aria-haspopup"), this.removeAttribute("aria-expanded"), this.submenuElement.removeEventListener("change", $299b6c40adc500b8$var$Be(this, $299b6c40adc500b8$var$$e)), this.submenuElement.removeEventListener("addmenuitem", $299b6c40adc500b8$var$Be(this, $299b6c40adc500b8$var$$e)), this.submenuElement.removeEventListener("removemenuitem", $299b6c40adc500b8$var$Be(this, $299b6c40adc500b8$var$$e)), $299b6c40adc500b8$var$Be(this, $299b6c40adc500b8$var$$e).call(this);
};
$299b6c40adc500b8$var$$e = new WeakMap;
$299b6c40adc500b8$var$Ti = new WeakSet;
$299b6c40adc500b8$var$wr = function(i) {
    let { key: e } = i;
    if (!this.keysUsed.includes(e)) {
        this.removeEventListener("keyup", $299b6c40adc500b8$var$Ie(this, $299b6c40adc500b8$var$Ti, $299b6c40adc500b8$var$wr));
        return;
    }
    this.handleClick(i);
};
$299b6c40adc500b8$var$go = new WeakSet;
$299b6c40adc500b8$var$Mu = function(i) {
    let { metaKey: e, altKey: t, key: r } = i;
    if (e || t || !this.keysUsed.includes(r)) {
        this.removeEventListener("keyup", $299b6c40adc500b8$var$Ie(this, $299b6c40adc500b8$var$Ti, $299b6c40adc500b8$var$wr));
        return;
    }
    this.addEventListener("keyup", $299b6c40adc500b8$var$Ie(this, $299b6c40adc500b8$var$Ti, $299b6c40adc500b8$var$wr), {
        once: !0
    });
};
$299b6c40adc500b8$var$As = new WeakSet;
$299b6c40adc500b8$var$bo = function() {
    var i;
    let e = (i = $299b6c40adc500b8$var$Be(this, $299b6c40adc500b8$var$Lr)) == null ? void 0 : i.radioGroupItems;
    if (!e) return;
    let t = e.filter((r)=>r.getAttribute("aria-checked") === "true").pop();
    t || (t = e[0]);
    for (let r of e)r.setAttribute("aria-checked", "false");
    t?.setAttribute("aria-checked", "true");
};
$299b6c40adc500b8$var$Ge.shadowRootOptions = {
    mode: "open"
};
$299b6c40adc500b8$var$Ge.getTemplateHTML = $299b6c40adc500b8$var$Dm;
$299b6c40adc500b8$var$Ge.getSuffixSlotInnerHTML = $299b6c40adc500b8$var$Om;
function $299b6c40adc500b8$var$Mr(i) {
    return i.type === "radio" || i.type === "checkbox";
}
function $299b6c40adc500b8$var$fo(i, e) {
    if (!i) return null;
    let { host: t } = i.getRootNode();
    return !e && t ? $299b6c40adc500b8$var$fo(i, t) : e?.items ? e : $299b6c40adc500b8$var$fo(e, e?.parentNode);
}
$299b6c40adc500b8$var$l.customElements.get("media-chrome-menu-item") || $299b6c40adc500b8$var$l.customElements.define("media-chrome-menu-item", $299b6c40adc500b8$var$Ge);
function $299b6c40adc500b8$var$xm(i) {
    return `
    ${$299b6c40adc500b8$var$K.getTemplateHTML(i)}
    <style>
      :host {
        --_menu-bg: rgb(20 20 30 / .8);
        background: var(--media-settings-menu-background,
            var(--media-menu-background,
              var(--media-control-background,
                var(--media-secondary-color, var(--_menu-bg)))));
        min-width: var(--media-settings-menu-min-width, 170px);
        border-radius: 2px 2px 0 0;
        overflow: hidden;
      }

      @-moz-document url-prefix() {
        :host{
          --_menu-bg: rgb(20 20 30);
        }
      }

      :host([role="menu"]) {
        
        justify-content: end;
      }

      slot:not([name]) {
        justify-content: var(--media-settings-menu-justify-content);
        flex-direction: var(--media-settings-menu-flex-direction, column);
        overflow: visible;
      }

      #container.has-expanded {
        --media-settings-menu-item-opacity: 0;
      }
    </style>
  `;
}
var $299b6c40adc500b8$var$Cr = class extends $299b6c40adc500b8$var$K {
    get anchorElement() {
        return this.anchor !== "auto" ? super.anchorElement : $299b6c40adc500b8$var$D(this).querySelector("media-settings-menu-button");
    }
};
$299b6c40adc500b8$var$Cr.getTemplateHTML = $299b6c40adc500b8$var$xm;
$299b6c40adc500b8$var$l.customElements.get("media-settings-menu") || $299b6c40adc500b8$var$l.customElements.define("media-settings-menu", $299b6c40adc500b8$var$Cr);
function $299b6c40adc500b8$var$Nm(i) {
    return `
    ${$299b6c40adc500b8$var$Ge.getTemplateHTML.call(this, i)}
    <style>
      slot:not([name="submenu"]) {
        opacity: var(--media-settings-menu-item-opacity, var(--media-menu-item-opacity));
      }

      :host([aria-expanded="true"]:hover) {
        background: transparent;
      }
    </style>
  `;
}
function $299b6c40adc500b8$var$Um(i) {
    return `
    <svg aria-hidden="true" viewBox="0 0 20 24">
      <path d="m8.12 17.585-.742-.669 4.2-4.665-4.2-4.666.743-.669 4.803 5.335-4.803 5.334Z"/>
    </svg>
  `;
}
var $299b6c40adc500b8$var$Ht = class extends $299b6c40adc500b8$var$Ge {
};
$299b6c40adc500b8$var$Ht.shadowRootOptions = {
    mode: "open"
};
$299b6c40adc500b8$var$Ht.getTemplateHTML = $299b6c40adc500b8$var$Nm;
$299b6c40adc500b8$var$Ht.getSuffixSlotInnerHTML = $299b6c40adc500b8$var$Um;
$299b6c40adc500b8$var$l.customElements.get("media-settings-menu-item") || $299b6c40adc500b8$var$l.customElements.define("media-settings-menu-item", $299b6c40adc500b8$var$Ht);
function $299b6c40adc500b8$var$Hm() {
    return `
    <style>
      :host([aria-expanded="true"]) slot[name=tooltip] {
        display: none;
      }
    </style>
    <slot name="icon">
      <svg aria-hidden="true" viewBox="0 0 24 24">
        <path d="M4.5 14.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm7.5 0a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm7.5 0a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Z"/>
      </svg>
    </slot>
  `;
}
function $299b6c40adc500b8$var$Vm() {
    return $299b6c40adc500b8$var$c("Settings");
}
var $299b6c40adc500b8$var$Ai = class extends $299b6c40adc500b8$var$J {
    static get observedAttributes() {
        return [
            ...super.observedAttributes,
            "target"
        ];
    }
    connectedCallback() {
        super.connectedCallback(), this.setAttribute("aria-label", $299b6c40adc500b8$var$c("settings"));
    }
    get invokeTargetElement() {
        return this.invokeTarget != null ? super.invokeTargetElement : $299b6c40adc500b8$var$D(this).querySelector("media-settings-menu");
    }
};
$299b6c40adc500b8$var$Ai.getSlotTemplateHTML = $299b6c40adc500b8$var$Hm;
$299b6c40adc500b8$var$Ai.getTooltipContentHTML = $299b6c40adc500b8$var$Vm;
$299b6c40adc500b8$var$l.customElements.get("media-settings-menu-button") || $299b6c40adc500b8$var$l.customElements.define("media-settings-menu-button", $299b6c40adc500b8$var$Ai);
var $299b6c40adc500b8$var$So = (i, e, t)=>{
    if (!e.has(i)) throw TypeError("Cannot " + t);
}, $299b6c40adc500b8$var$Lu = (i, e, t)=>($299b6c40adc500b8$var$So(i, e, "read from private field"), t ? t.call(i) : e.get(i)), $299b6c40adc500b8$var$ks = (i, e, t)=>{
    if (e.has(i)) throw TypeError("Cannot add the same private member more than once");
    e instanceof WeakSet ? e.add(i) : e.set(i, t);
}, $299b6c40adc500b8$var$yo = (i, e, t, r)=>($299b6c40adc500b8$var$So(i, e, "write to private field"), r ? r.call(i, t) : e.set(i, t), t), $299b6c40adc500b8$var$Is = (i, e, t)=>($299b6c40adc500b8$var$So(i, e, "access private method"), t), $299b6c40adc500b8$var$Rr, $299b6c40adc500b8$var$Ls, $299b6c40adc500b8$var$Ss, $299b6c40adc500b8$var$ko, $299b6c40adc500b8$var$Ms, $299b6c40adc500b8$var$Io, $299b6c40adc500b8$var$ws = class extends $299b6c40adc500b8$var$K {
    constructor(){
        super(...arguments), $299b6c40adc500b8$var$ks(this, $299b6c40adc500b8$var$Ss), $299b6c40adc500b8$var$ks(this, $299b6c40adc500b8$var$Ms), $299b6c40adc500b8$var$ks(this, $299b6c40adc500b8$var$Rr, []), $299b6c40adc500b8$var$ks(this, $299b6c40adc500b8$var$Ls, void 0);
    }
    static get observedAttributes() {
        return [
            ...super.observedAttributes,
            $299b6c40adc500b8$var$a.MEDIA_AUDIO_TRACK_LIST,
            $299b6c40adc500b8$var$a.MEDIA_AUDIO_TRACK_ENABLED,
            $299b6c40adc500b8$var$a.MEDIA_AUDIO_TRACK_UNAVAILABLE
        ];
    }
    attributeChangedCallback(e, t, r) {
        super.attributeChangedCallback(e, t, r), e === $299b6c40adc500b8$var$a.MEDIA_AUDIO_TRACK_ENABLED && t !== r ? this.value = r : e === $299b6c40adc500b8$var$a.MEDIA_AUDIO_TRACK_LIST && t !== r && ($299b6c40adc500b8$var$yo(this, $299b6c40adc500b8$var$Rr, $299b6c40adc500b8$var$id(r ?? "")), $299b6c40adc500b8$var$Is(this, $299b6c40adc500b8$var$Ss, $299b6c40adc500b8$var$ko).call(this));
    }
    connectedCallback() {
        super.connectedCallback(), this.addEventListener("change", $299b6c40adc500b8$var$Is(this, $299b6c40adc500b8$var$Ms, $299b6c40adc500b8$var$Io));
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this.removeEventListener("change", $299b6c40adc500b8$var$Is(this, $299b6c40adc500b8$var$Ms, $299b6c40adc500b8$var$Io));
    }
    get anchorElement() {
        var e;
        return this.anchor !== "auto" ? super.anchorElement : (e = $299b6c40adc500b8$var$D(this)) == null ? void 0 : e.querySelector("media-audio-track-menu-button");
    }
    get mediaAudioTrackList() {
        return $299b6c40adc500b8$var$Lu(this, $299b6c40adc500b8$var$Rr);
    }
    set mediaAudioTrackList(e) {
        $299b6c40adc500b8$var$yo(this, $299b6c40adc500b8$var$Rr, e), $299b6c40adc500b8$var$Is(this, $299b6c40adc500b8$var$Ss, $299b6c40adc500b8$var$ko).call(this);
    }
    get mediaAudioTrackEnabled() {
        var e;
        return (e = $299b6c40adc500b8$var$_(this, $299b6c40adc500b8$var$a.MEDIA_AUDIO_TRACK_ENABLED)) != null ? e : "";
    }
    set mediaAudioTrackEnabled(e) {
        $299b6c40adc500b8$var$b(this, $299b6c40adc500b8$var$a.MEDIA_AUDIO_TRACK_ENABLED, e);
    }
};
$299b6c40adc500b8$var$Rr = new WeakMap;
$299b6c40adc500b8$var$Ls = new WeakMap;
$299b6c40adc500b8$var$Ss = new WeakSet;
$299b6c40adc500b8$var$ko = function() {
    if ($299b6c40adc500b8$var$Lu(this, $299b6c40adc500b8$var$Ls) === JSON.stringify(this.mediaAudioTrackList)) return;
    $299b6c40adc500b8$var$yo(this, $299b6c40adc500b8$var$Ls, JSON.stringify(this.mediaAudioTrackList));
    let i = this.mediaAudioTrackList;
    this.defaultSlot.textContent = "";
    for (let e of i){
        let t = this.formatMenuItemText(e.label, e), r = $299b6c40adc500b8$var$pe({
            type: "radio",
            text: t,
            value: `${e.id}`,
            checked: e.enabled
        });
        r.prepend($299b6c40adc500b8$var$ue(this, "checked-indicator")), this.defaultSlot.append(r);
    }
};
$299b6c40adc500b8$var$Ms = new WeakSet;
$299b6c40adc500b8$var$Io = function() {
    if (this.value == null) return;
    let i = new $299b6c40adc500b8$var$l.CustomEvent($299b6c40adc500b8$var$h.MEDIA_AUDIO_TRACK_REQUEST, {
        composed: !0,
        bubbles: !0,
        detail: this.value
    });
    this.dispatchEvent(i);
};
$299b6c40adc500b8$var$l.customElements.get("media-audio-track-menu") || $299b6c40adc500b8$var$l.customElements.define("media-audio-track-menu", $299b6c40adc500b8$var$ws);
var $299b6c40adc500b8$var$Wm = `<svg aria-hidden="true" viewBox="0 0 24 24">
  <path d="M11 17H9.5V7H11v10Zm-3-3H6.5v-4H8v4Zm6-5h-1.5v6H14V9Zm3 7h-1.5V8H17v8Z"/>
  <path d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10Zm-2 0a8 8 0 1 0-16 0 8 8 0 0 0 16 0Z"/>
</svg>`;
function $299b6c40adc500b8$var$Fm() {
    return `
    <style>
      :host([aria-expanded="true"]) slot[name=tooltip] {
        display: none;
      }
    </style>
    <slot name="icon">${$299b6c40adc500b8$var$Wm}</slot>
  `;
}
function $299b6c40adc500b8$var$Bm() {
    return $299b6c40adc500b8$var$c("Audio");
}
var $299b6c40adc500b8$var$wu = (i)=>{
    let e = $299b6c40adc500b8$var$c("Audio");
    i.setAttribute("aria-label", e);
}, $299b6c40adc500b8$var$yi = class extends $299b6c40adc500b8$var$J {
    static get observedAttributes() {
        return [
            ...super.observedAttributes,
            $299b6c40adc500b8$var$a.MEDIA_AUDIO_TRACK_ENABLED,
            $299b6c40adc500b8$var$a.MEDIA_AUDIO_TRACK_UNAVAILABLE
        ];
    }
    connectedCallback() {
        super.connectedCallback(), $299b6c40adc500b8$var$wu(this);
    }
    attributeChangedCallback(e, t, r) {
        super.attributeChangedCallback(e, t, r), e === $299b6c40adc500b8$var$a.MEDIA_LANG && $299b6c40adc500b8$var$wu(this);
    }
    get invokeTargetElement() {
        var e;
        return this.invokeTarget != null ? super.invokeTargetElement : (e = $299b6c40adc500b8$var$D(this)) == null ? void 0 : e.querySelector("media-audio-track-menu");
    }
    get mediaAudioTrackEnabled() {
        var e;
        return (e = $299b6c40adc500b8$var$_(this, $299b6c40adc500b8$var$a.MEDIA_AUDIO_TRACK_ENABLED)) != null ? e : "";
    }
    set mediaAudioTrackEnabled(e) {
        $299b6c40adc500b8$var$b(this, $299b6c40adc500b8$var$a.MEDIA_AUDIO_TRACK_ENABLED, e);
    }
};
$299b6c40adc500b8$var$yi.getSlotTemplateHTML = $299b6c40adc500b8$var$Fm;
$299b6c40adc500b8$var$yi.getTooltipContentHTML = $299b6c40adc500b8$var$Bm;
$299b6c40adc500b8$var$l.customElements.get("media-audio-track-menu-button") || $299b6c40adc500b8$var$l.customElements.define("media-audio-track-menu-button", $299b6c40adc500b8$var$yi);
var $299b6c40adc500b8$var$Ro = (i, e, t)=>{
    if (!e.has(i)) throw TypeError("Cannot " + t);
}, $299b6c40adc500b8$var$$m = (i, e, t)=>($299b6c40adc500b8$var$Ro(i, e, "read from private field"), t ? t.call(i) : e.get(i)), $299b6c40adc500b8$var$Mo = (i, e, t)=>{
    if (e.has(i)) throw TypeError("Cannot add the same private member more than once");
    e instanceof WeakSet ? e.add(i) : e.set(i, t);
}, $299b6c40adc500b8$var$Gm = (i, e, t, r)=>($299b6c40adc500b8$var$Ro(i, e, "write to private field"), r ? r.call(i, t) : e.set(i, t), t), $299b6c40adc500b8$var$Lo = (i, e, t)=>($299b6c40adc500b8$var$Ro(i, e, "access private method"), t), $299b6c40adc500b8$var$Rs, $299b6c40adc500b8$var$wo, $299b6c40adc500b8$var$Pu, $299b6c40adc500b8$var$Cs, $299b6c40adc500b8$var$Co, $299b6c40adc500b8$var$Km = `
  <svg aria-hidden="true" viewBox="0 0 26 24" part="captions-indicator indicator">
    <path d="M22.83 5.68a2.58 2.58 0 0 0-2.3-2.5c-3.62-.24-11.44-.24-15.06 0a2.58 2.58 0 0 0-2.3 2.5c-.23 4.21-.23 8.43 0 12.64a2.58 2.58 0 0 0 2.3 2.5c3.62.24 11.44.24 15.06 0a2.58 2.58 0 0 0 2.3-2.5c.23-4.21.23-8.43 0-12.64Zm-11.39 9.45a3.07 3.07 0 0 1-1.91.57 3.06 3.06 0 0 1-2.34-1 3.75 3.75 0 0 1-.92-2.67 3.92 3.92 0 0 1 .92-2.77 3.18 3.18 0 0 1 2.43-1 2.94 2.94 0 0 1 2.13.78c.364.359.62.813.74 1.31l-1.43.35a1.49 1.49 0 0 0-1.51-1.17 1.61 1.61 0 0 0-1.29.58 2.79 2.79 0 0 0-.5 1.89 3 3 0 0 0 .49 1.93 1.61 1.61 0 0 0 1.27.58 1.48 1.48 0 0 0 1-.37 2.1 2.1 0 0 0 .59-1.14l1.4.44a3.23 3.23 0 0 1-1.07 1.69Zm7.22 0a3.07 3.07 0 0 1-1.91.57 3.06 3.06 0 0 1-2.34-1 3.75 3.75 0 0 1-.92-2.67 3.88 3.88 0 0 1 .93-2.77 3.14 3.14 0 0 1 2.42-1 3 3 0 0 1 2.16.82 2.8 2.8 0 0 1 .73 1.31l-1.43.35a1.49 1.49 0 0 0-1.51-1.21 1.61 1.61 0 0 0-1.29.58A2.79 2.79 0 0 0 15 12a3 3 0 0 0 .49 1.93 1.61 1.61 0 0 0 1.27.58 1.44 1.44 0 0 0 1-.37 2.1 2.1 0 0 0 .6-1.15l1.4.44a3.17 3.17 0 0 1-1.1 1.7Z"/>
  </svg>`;
function $299b6c40adc500b8$var$qm(i) {
    return `
    ${$299b6c40adc500b8$var$K.getTemplateHTML(i)}
    <slot name="captions-indicator" hidden>${$299b6c40adc500b8$var$Km}</slot>
  `;
}
var $299b6c40adc500b8$var$Pr = class extends $299b6c40adc500b8$var$K {
    constructor(){
        super(...arguments), $299b6c40adc500b8$var$Mo(this, $299b6c40adc500b8$var$wo), $299b6c40adc500b8$var$Mo(this, $299b6c40adc500b8$var$Cs), $299b6c40adc500b8$var$Mo(this, $299b6c40adc500b8$var$Rs, void 0);
    }
    static get observedAttributes() {
        return [
            ...super.observedAttributes,
            $299b6c40adc500b8$var$a.MEDIA_SUBTITLES_LIST,
            $299b6c40adc500b8$var$a.MEDIA_SUBTITLES_SHOWING
        ];
    }
    attributeChangedCallback(e, t, r) {
        super.attributeChangedCallback(e, t, r), e === $299b6c40adc500b8$var$a.MEDIA_SUBTITLES_LIST && t !== r ? $299b6c40adc500b8$var$Lo(this, $299b6c40adc500b8$var$wo, $299b6c40adc500b8$var$Pu).call(this) : e === $299b6c40adc500b8$var$a.MEDIA_SUBTITLES_SHOWING && t !== r && (this.value = r);
    }
    connectedCallback() {
        super.connectedCallback(), this.addEventListener("change", $299b6c40adc500b8$var$Lo(this, $299b6c40adc500b8$var$Cs, $299b6c40adc500b8$var$Co));
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this.removeEventListener("change", $299b6c40adc500b8$var$Lo(this, $299b6c40adc500b8$var$Cs, $299b6c40adc500b8$var$Co));
    }
    get anchorElement() {
        return this.anchor !== "auto" ? super.anchorElement : $299b6c40adc500b8$var$D(this).querySelector("media-captions-menu-button");
    }
    get mediaSubtitlesList() {
        return $299b6c40adc500b8$var$Cu(this, $299b6c40adc500b8$var$a.MEDIA_SUBTITLES_LIST);
    }
    set mediaSubtitlesList(e) {
        $299b6c40adc500b8$var$Ru(this, $299b6c40adc500b8$var$a.MEDIA_SUBTITLES_LIST, e);
    }
    get mediaSubtitlesShowing() {
        return $299b6c40adc500b8$var$Cu(this, $299b6c40adc500b8$var$a.MEDIA_SUBTITLES_SHOWING);
    }
    set mediaSubtitlesShowing(e) {
        $299b6c40adc500b8$var$Ru(this, $299b6c40adc500b8$var$a.MEDIA_SUBTITLES_SHOWING, e);
    }
};
$299b6c40adc500b8$var$Rs = new WeakMap;
$299b6c40adc500b8$var$wo = new WeakSet;
$299b6c40adc500b8$var$Pu = function() {
    var i;
    if ($299b6c40adc500b8$var$$m(this, $299b6c40adc500b8$var$Rs) === JSON.stringify(this.mediaSubtitlesList)) return;
    $299b6c40adc500b8$var$Gm(this, $299b6c40adc500b8$var$Rs, JSON.stringify(this.mediaSubtitlesList)), this.defaultSlot.textContent = "";
    let e = !this.value, t = $299b6c40adc500b8$var$pe({
        type: "radio",
        text: this.formatMenuItemText($299b6c40adc500b8$var$c("Off")),
        value: "off",
        checked: e
    });
    t.prepend($299b6c40adc500b8$var$ue(this, "checked-indicator")), this.defaultSlot.append(t);
    let r = this.mediaSubtitlesList;
    for (let n1 of r){
        let s = $299b6c40adc500b8$var$pe({
            type: "radio",
            text: this.formatMenuItemText(n1.label, n1),
            value: $299b6c40adc500b8$var$In(n1),
            checked: this.value == $299b6c40adc500b8$var$In(n1)
        });
        s.prepend($299b6c40adc500b8$var$ue(this, "checked-indicator")), ((i = n1.kind) != null ? i : "subs") === "captions" && s.append($299b6c40adc500b8$var$ue(this, "captions-indicator")), this.defaultSlot.append(s);
    }
};
$299b6c40adc500b8$var$Cs = new WeakSet;
$299b6c40adc500b8$var$Co = function() {
    let i = this.mediaSubtitlesShowing, e = this.getAttribute($299b6c40adc500b8$var$a.MEDIA_SUBTITLES_SHOWING), t = this.value !== e;
    if (i?.length && t && this.dispatchEvent(new $299b6c40adc500b8$var$l.CustomEvent($299b6c40adc500b8$var$h.MEDIA_DISABLE_SUBTITLES_REQUEST, {
        composed: !0,
        bubbles: !0,
        detail: i
    })), !this.value || !t) return;
    let r = new $299b6c40adc500b8$var$l.CustomEvent($299b6c40adc500b8$var$h.MEDIA_SHOW_SUBTITLES_REQUEST, {
        composed: !0,
        bubbles: !0,
        detail: this.value
    });
    this.dispatchEvent(r);
};
$299b6c40adc500b8$var$Pr.getTemplateHTML = $299b6c40adc500b8$var$qm;
var $299b6c40adc500b8$var$Cu = (i, e)=>{
    let t = i.getAttribute(e);
    return t ? $299b6c40adc500b8$var$St(t) : [];
}, $299b6c40adc500b8$var$Ru = (i, e, t)=>{
    if (!t?.length) {
        i.removeAttribute(e);
        return;
    }
    let r = $299b6c40adc500b8$var$Qe(t);
    i.getAttribute(e) !== r && i.setAttribute(e, r);
};
$299b6c40adc500b8$var$l.customElements.get("media-captions-menu") || $299b6c40adc500b8$var$l.customElements.define("media-captions-menu", $299b6c40adc500b8$var$Pr);
var $299b6c40adc500b8$var$Ym = `<svg aria-hidden="true" viewBox="0 0 26 24">
  <path d="M22.83 5.68a2.58 2.58 0 0 0-2.3-2.5c-3.62-.24-11.44-.24-15.06 0a2.58 2.58 0 0 0-2.3 2.5c-.23 4.21-.23 8.43 0 12.64a2.58 2.58 0 0 0 2.3 2.5c3.62.24 11.44.24 15.06 0a2.58 2.58 0 0 0 2.3-2.5c.23-4.21.23-8.43 0-12.64Zm-11.39 9.45a3.07 3.07 0 0 1-1.91.57 3.06 3.06 0 0 1-2.34-1 3.75 3.75 0 0 1-.92-2.67 3.92 3.92 0 0 1 .92-2.77 3.18 3.18 0 0 1 2.43-1 2.94 2.94 0 0 1 2.13.78c.364.359.62.813.74 1.31l-1.43.35a1.49 1.49 0 0 0-1.51-1.17 1.61 1.61 0 0 0-1.29.58 2.79 2.79 0 0 0-.5 1.89 3 3 0 0 0 .49 1.93 1.61 1.61 0 0 0 1.27.58 1.48 1.48 0 0 0 1-.37 2.1 2.1 0 0 0 .59-1.14l1.4.44a3.23 3.23 0 0 1-1.07 1.69Zm7.22 0a3.07 3.07 0 0 1-1.91.57 3.06 3.06 0 0 1-2.34-1 3.75 3.75 0 0 1-.92-2.67 3.88 3.88 0 0 1 .93-2.77 3.14 3.14 0 0 1 2.42-1 3 3 0 0 1 2.16.82 2.8 2.8 0 0 1 .73 1.31l-1.43.35a1.49 1.49 0 0 0-1.51-1.21 1.61 1.61 0 0 0-1.29.58A2.79 2.79 0 0 0 15 12a3 3 0 0 0 .49 1.93 1.61 1.61 0 0 0 1.27.58 1.44 1.44 0 0 0 1-.37 2.1 2.1 0 0 0 .6-1.15l1.4.44a3.17 3.17 0 0 1-1.1 1.7Z"/>
</svg>`, $299b6c40adc500b8$var$Zm = `<svg aria-hidden="true" viewBox="0 0 26 24">
  <path d="M17.73 14.09a1.4 1.4 0 0 1-1 .37 1.579 1.579 0 0 1-1.27-.58A3 3 0 0 1 15 12a2.8 2.8 0 0 1 .5-1.85 1.63 1.63 0 0 1 1.29-.57 1.47 1.47 0 0 1 1.51 1.2l1.43-.34A2.89 2.89 0 0 0 19 9.07a3 3 0 0 0-2.14-.78 3.14 3.14 0 0 0-2.42 1 3.91 3.91 0 0 0-.93 2.78 3.74 3.74 0 0 0 .92 2.66 3.07 3.07 0 0 0 2.34 1 3.07 3.07 0 0 0 1.91-.57 3.17 3.17 0 0 0 1.07-1.74l-1.4-.45c-.083.43-.3.822-.62 1.12Zm-7.22 0a1.43 1.43 0 0 1-1 .37 1.58 1.58 0 0 1-1.27-.58A3 3 0 0 1 7.76 12a2.8 2.8 0 0 1 .5-1.85 1.63 1.63 0 0 1 1.29-.57 1.47 1.47 0 0 1 1.51 1.2l1.43-.34a2.81 2.81 0 0 0-.74-1.32 2.94 2.94 0 0 0-2.13-.78 3.18 3.18 0 0 0-2.43 1 4 4 0 0 0-.92 2.78 3.74 3.74 0 0 0 .92 2.66 3.07 3.07 0 0 0 2.34 1 3.07 3.07 0 0 0 1.91-.57 3.23 3.23 0 0 0 1.07-1.74l-1.4-.45a2.06 2.06 0 0 1-.6 1.07Zm12.32-8.41a2.59 2.59 0 0 0-2.3-2.51C18.72 3.05 15.86 3 13 3c-2.86 0-5.72.05-7.53.17a2.59 2.59 0 0 0-2.3 2.51c-.23 4.207-.23 8.423 0 12.63a2.57 2.57 0 0 0 2.3 2.5c1.81.13 4.67.19 7.53.19 2.86 0 5.72-.06 7.53-.19a2.57 2.57 0 0 0 2.3-2.5c.23-4.207.23-8.423 0-12.63Zm-1.49 12.53a1.11 1.11 0 0 1-.91 1.11c-1.67.11-4.45.18-7.43.18-2.98 0-5.76-.07-7.43-.18a1.11 1.11 0 0 1-.91-1.11c-.21-4.14-.21-8.29 0-12.43a1.11 1.11 0 0 1 .91-1.11C7.24 4.56 10 4.49 13 4.49s5.76.07 7.43.18a1.11 1.11 0 0 1 .91 1.11c.21 4.14.21 8.29 0 12.43Z"/>
</svg>`;
function $299b6c40adc500b8$var$Qm() {
    return `
    <style>
      :host([data-captions-enabled="true"]) slot[name=off] {
        display: none !important;
      }

      
      :host(:not([data-captions-enabled="true"])) slot[name=on] {
        display: none !important;
      }

      :host([aria-expanded="true"]) slot[name=tooltip] {
        display: none;
      }
    </style>

    <slot name="icon">
      <slot name="on">${$299b6c40adc500b8$var$Ym}</slot>
      <slot name="off">${$299b6c40adc500b8$var$Zm}</slot>
    </slot>
  `;
}
function $299b6c40adc500b8$var$zm() {
    return $299b6c40adc500b8$var$c("Captions");
}
var $299b6c40adc500b8$var$Du = (i)=>{
    i.setAttribute("data-captions-enabled", $299b6c40adc500b8$var$Sn(i).toString());
}, $299b6c40adc500b8$var$Ou = (i)=>{
    i.setAttribute("aria-label", $299b6c40adc500b8$var$c("closed captions"));
}, $299b6c40adc500b8$var$ki = class extends $299b6c40adc500b8$var$J {
    static get observedAttributes() {
        return [
            ...super.observedAttributes,
            $299b6c40adc500b8$var$a.MEDIA_SUBTITLES_LIST,
            $299b6c40adc500b8$var$a.MEDIA_SUBTITLES_SHOWING,
            $299b6c40adc500b8$var$a.MEDIA_LANG
        ];
    }
    connectedCallback() {
        super.connectedCallback(), $299b6c40adc500b8$var$Ou(this), $299b6c40adc500b8$var$Du(this);
    }
    attributeChangedCallback(e, t, r) {
        super.attributeChangedCallback(e, t, r), e === $299b6c40adc500b8$var$a.MEDIA_SUBTITLES_SHOWING ? $299b6c40adc500b8$var$Du(this) : e === $299b6c40adc500b8$var$a.MEDIA_LANG && $299b6c40adc500b8$var$Ou(this);
    }
    get invokeTargetElement() {
        var e;
        return this.invokeTarget != null ? super.invokeTargetElement : (e = $299b6c40adc500b8$var$D(this)) == null ? void 0 : e.querySelector("media-captions-menu");
    }
    get mediaSubtitlesList() {
        return $299b6c40adc500b8$var$xu(this, $299b6c40adc500b8$var$a.MEDIA_SUBTITLES_LIST);
    }
    set mediaSubtitlesList(e) {
        $299b6c40adc500b8$var$Nu(this, $299b6c40adc500b8$var$a.MEDIA_SUBTITLES_LIST, e);
    }
    get mediaSubtitlesShowing() {
        return $299b6c40adc500b8$var$xu(this, $299b6c40adc500b8$var$a.MEDIA_SUBTITLES_SHOWING);
    }
    set mediaSubtitlesShowing(e) {
        $299b6c40adc500b8$var$Nu(this, $299b6c40adc500b8$var$a.MEDIA_SUBTITLES_SHOWING, e);
    }
};
$299b6c40adc500b8$var$ki.getSlotTemplateHTML = $299b6c40adc500b8$var$Qm;
$299b6c40adc500b8$var$ki.getTooltipContentHTML = $299b6c40adc500b8$var$zm;
var $299b6c40adc500b8$var$xu = (i, e)=>{
    let t = i.getAttribute(e);
    return t ? $299b6c40adc500b8$var$St(t) : [];
}, $299b6c40adc500b8$var$Nu = (i, e, t)=>{
    if (!t?.length) {
        i.removeAttribute(e);
        return;
    }
    let r = $299b6c40adc500b8$var$Qe(t);
    i.getAttribute(e) !== r && i.setAttribute(e, r);
};
$299b6c40adc500b8$var$l.customElements.get("media-captions-menu-button") || $299b6c40adc500b8$var$l.customElements.define("media-captions-menu-button", $299b6c40adc500b8$var$ki);
var $299b6c40adc500b8$var$Uu = (i, e, t)=>{
    if (!e.has(i)) throw TypeError("Cannot " + t);
}, $299b6c40adc500b8$var$Ii = (i, e, t)=>($299b6c40adc500b8$var$Uu(i, e, "read from private field"), t ? t.call(i) : e.get(i)), $299b6c40adc500b8$var$Po = (i, e, t)=>{
    if (e.has(i)) throw TypeError("Cannot add the same private member more than once");
    e instanceof WeakSet ? e.add(i) : e.set(i, t);
}, $299b6c40adc500b8$var$Dr = (i, e, t)=>($299b6c40adc500b8$var$Uu(i, e, "access private method"), t), $299b6c40adc500b8$var$ht, $299b6c40adc500b8$var$Or, $299b6c40adc500b8$var$Ps, $299b6c40adc500b8$var$Ds, $299b6c40adc500b8$var$Oo, $299b6c40adc500b8$var$Do = {
    RATES: "rates"
}, $299b6c40adc500b8$var$Os = class extends $299b6c40adc500b8$var$K {
    constructor(){
        super(), $299b6c40adc500b8$var$Po(this, $299b6c40adc500b8$var$Or), $299b6c40adc500b8$var$Po(this, $299b6c40adc500b8$var$Ds), $299b6c40adc500b8$var$Po(this, $299b6c40adc500b8$var$ht, new $299b6c40adc500b8$var$at(this, $299b6c40adc500b8$var$Do.RATES, {
            defaultValue: $299b6c40adc500b8$var$Ja
        })), $299b6c40adc500b8$var$Dr(this, $299b6c40adc500b8$var$Or, $299b6c40adc500b8$var$Ps).call(this);
    }
    static get observedAttributes() {
        return [
            ...super.observedAttributes,
            $299b6c40adc500b8$var$a.MEDIA_PLAYBACK_RATE,
            $299b6c40adc500b8$var$Do.RATES
        ];
    }
    attributeChangedCallback(e, t, r) {
        super.attributeChangedCallback(e, t, r), e === $299b6c40adc500b8$var$a.MEDIA_PLAYBACK_RATE && t != r ? this.value = r : e === $299b6c40adc500b8$var$Do.RATES && t != r && ($299b6c40adc500b8$var$Ii(this, $299b6c40adc500b8$var$ht).value = r, $299b6c40adc500b8$var$Dr(this, $299b6c40adc500b8$var$Or, $299b6c40adc500b8$var$Ps).call(this));
    }
    connectedCallback() {
        super.connectedCallback(), this.addEventListener("change", $299b6c40adc500b8$var$Dr(this, $299b6c40adc500b8$var$Ds, $299b6c40adc500b8$var$Oo));
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this.removeEventListener("change", $299b6c40adc500b8$var$Dr(this, $299b6c40adc500b8$var$Ds, $299b6c40adc500b8$var$Oo));
    }
    get anchorElement() {
        return this.anchor !== "auto" ? super.anchorElement : $299b6c40adc500b8$var$D(this).querySelector("media-playback-rate-menu-button");
    }
    get rates() {
        return $299b6c40adc500b8$var$Ii(this, $299b6c40adc500b8$var$ht);
    }
    set rates(e) {
        e ? Array.isArray(e) ? $299b6c40adc500b8$var$Ii(this, $299b6c40adc500b8$var$ht).value = e.join(" ") : typeof e == "string" && ($299b6c40adc500b8$var$Ii(this, $299b6c40adc500b8$var$ht).value = e) : $299b6c40adc500b8$var$Ii(this, $299b6c40adc500b8$var$ht).value = "", $299b6c40adc500b8$var$Dr(this, $299b6c40adc500b8$var$Or, $299b6c40adc500b8$var$Ps).call(this);
    }
    get mediaPlaybackRate() {
        return $299b6c40adc500b8$var$M(this, $299b6c40adc500b8$var$a.MEDIA_PLAYBACK_RATE, $299b6c40adc500b8$var$Ot);
    }
    set mediaPlaybackRate(e) {
        $299b6c40adc500b8$var$w(this, $299b6c40adc500b8$var$a.MEDIA_PLAYBACK_RATE, e);
    }
};
$299b6c40adc500b8$var$ht = new WeakMap;
$299b6c40adc500b8$var$Or = new WeakSet;
$299b6c40adc500b8$var$Ps = function() {
    this.defaultSlot.textContent = "";
    for (let i of $299b6c40adc500b8$var$Ii(this, $299b6c40adc500b8$var$ht)){
        let e = $299b6c40adc500b8$var$pe({
            type: "radio",
            text: this.formatMenuItemText(`${i}x`, i),
            value: i,
            checked: this.mediaPlaybackRate === Number(i)
        });
        e.prepend($299b6c40adc500b8$var$ue(this, "checked-indicator")), this.defaultSlot.append(e);
    }
};
$299b6c40adc500b8$var$Ds = new WeakSet;
$299b6c40adc500b8$var$Oo = function() {
    if (!this.value) return;
    let i = new $299b6c40adc500b8$var$l.CustomEvent($299b6c40adc500b8$var$h.MEDIA_PLAYBACK_RATE_REQUEST, {
        composed: !0,
        bubbles: !0,
        detail: this.value
    });
    this.dispatchEvent(i);
};
$299b6c40adc500b8$var$l.customElements.get("media-playback-rate-menu") || $299b6c40adc500b8$var$l.customElements.define("media-playback-rate-menu", $299b6c40adc500b8$var$Os);
var $299b6c40adc500b8$var$xs = 1;
function $299b6c40adc500b8$var$Xm(i) {
    return `
    <style>
      :host {
        min-width: 5ch;
        padding: var(--media-button-padding, var(--media-control-padding, 10px 5px));
      }
      
      :host([aria-expanded="true"]) slot[name=tooltip] {
        display: none;
      }
    </style>
    <slot name="icon">${i.mediaplaybackrate || $299b6c40adc500b8$var$xs}x</slot>
  `;
}
function $299b6c40adc500b8$var$Jm() {
    return $299b6c40adc500b8$var$c("Playback rate");
}
var $299b6c40adc500b8$var$Si = class extends $299b6c40adc500b8$var$J {
    static get observedAttributes() {
        return [
            ...super.observedAttributes,
            $299b6c40adc500b8$var$a.MEDIA_PLAYBACK_RATE
        ];
    }
    constructor(){
        var e;
        super(), this.container = this.shadowRoot.querySelector('slot[name="icon"]'), this.container.innerHTML = `${(e = this.mediaPlaybackRate) != null ? e : $299b6c40adc500b8$var$xs}x`;
    }
    attributeChangedCallback(e, t, r) {
        if (super.attributeChangedCallback(e, t, r), e === $299b6c40adc500b8$var$a.MEDIA_PLAYBACK_RATE) {
            let n1 = r ? +r : Number.NaN, s = Number.isNaN(n1) ? $299b6c40adc500b8$var$xs : n1;
            this.container.innerHTML = `${s}x`, this.setAttribute("aria-label", $299b6c40adc500b8$var$c("Playback rate {playbackRate}", {
                playbackRate: s
            }));
        }
    }
    get invokeTargetElement() {
        return this.invokeTarget != null ? super.invokeTargetElement : $299b6c40adc500b8$var$D(this).querySelector("media-playback-rate-menu");
    }
    get mediaPlaybackRate() {
        return $299b6c40adc500b8$var$M(this, $299b6c40adc500b8$var$a.MEDIA_PLAYBACK_RATE, $299b6c40adc500b8$var$xs);
    }
    set mediaPlaybackRate(e) {
        $299b6c40adc500b8$var$w(this, $299b6c40adc500b8$var$a.MEDIA_PLAYBACK_RATE, e);
    }
};
$299b6c40adc500b8$var$Si.getSlotTemplateHTML = $299b6c40adc500b8$var$Xm;
$299b6c40adc500b8$var$Si.getTooltipContentHTML = $299b6c40adc500b8$var$Jm;
$299b6c40adc500b8$var$l.customElements.get("media-playback-rate-menu-button") || $299b6c40adc500b8$var$l.customElements.define("media-playback-rate-menu-button", $299b6c40adc500b8$var$Si);
var $299b6c40adc500b8$var$No = (i, e, t)=>{
    if (!e.has(i)) throw TypeError("Cannot " + t);
}, $299b6c40adc500b8$var$xr = (i, e, t)=>($299b6c40adc500b8$var$No(i, e, "read from private field"), t ? t.call(i) : e.get(i)), $299b6c40adc500b8$var$Ns = (i, e, t)=>{
    if (e.has(i)) throw TypeError("Cannot add the same private member more than once");
    e instanceof WeakSet ? e.add(i) : e.set(i, t);
}, $299b6c40adc500b8$var$Hu = (i, e, t, r)=>($299b6c40adc500b8$var$No(i, e, "write to private field"), r ? r.call(i, t) : e.set(i, t), t), $299b6c40adc500b8$var$Mi = (i, e, t)=>($299b6c40adc500b8$var$No(i, e, "access private method"), t), $299b6c40adc500b8$var$Nr, $299b6c40adc500b8$var$wi, $299b6c40adc500b8$var$Li, $299b6c40adc500b8$var$Ur, $299b6c40adc500b8$var$Us, $299b6c40adc500b8$var$xo, $299b6c40adc500b8$var$Hs = class extends $299b6c40adc500b8$var$K {
    constructor(){
        super(...arguments), $299b6c40adc500b8$var$Ns(this, $299b6c40adc500b8$var$Li), $299b6c40adc500b8$var$Ns(this, $299b6c40adc500b8$var$Us), $299b6c40adc500b8$var$Ns(this, $299b6c40adc500b8$var$Nr, []), $299b6c40adc500b8$var$Ns(this, $299b6c40adc500b8$var$wi, {});
    }
    static get observedAttributes() {
        return [
            ...super.observedAttributes,
            $299b6c40adc500b8$var$a.MEDIA_RENDITION_LIST,
            $299b6c40adc500b8$var$a.MEDIA_RENDITION_SELECTED,
            $299b6c40adc500b8$var$a.MEDIA_RENDITION_UNAVAILABLE,
            $299b6c40adc500b8$var$a.MEDIA_HEIGHT
        ];
    }
    static formatMenuItemText(e, t) {
        return super.formatMenuItemText(e, t);
    }
    static formatRendition(e, { showBitrate: t = !1 } = {}) {
        let r = `${Math.min(e.width, e.height)}p`;
        if (t && e.bitrate) {
            let n1 = e.bitrate / 1e6, s = `${n1.toFixed(n1 < 1 ? 1 : 0)} Mbps`;
            return `${r} (${s})`;
        }
        return this.formatMenuItemText(r, e);
    }
    static compareRendition(e, t) {
        var r, n1;
        return t.height === e.height ? ((r = t.bitrate) != null ? r : 0) - ((n1 = e.bitrate) != null ? n1 : 0) : t.height - e.height;
    }
    attributeChangedCallback(e, t, r) {
        super.attributeChangedCallback(e, t, r), e === $299b6c40adc500b8$var$a.MEDIA_RENDITION_SELECTED && t !== r ? (this.value = r ?? "auto", $299b6c40adc500b8$var$Mi(this, $299b6c40adc500b8$var$Li, $299b6c40adc500b8$var$Ur).call(this)) : e === $299b6c40adc500b8$var$a.MEDIA_RENDITION_LIST && t !== r ? ($299b6c40adc500b8$var$Hu(this, $299b6c40adc500b8$var$Nr, $299b6c40adc500b8$var$ed(r)), $299b6c40adc500b8$var$Mi(this, $299b6c40adc500b8$var$Li, $299b6c40adc500b8$var$Ur).call(this)) : e === $299b6c40adc500b8$var$a.MEDIA_HEIGHT && t !== r && $299b6c40adc500b8$var$Mi(this, $299b6c40adc500b8$var$Li, $299b6c40adc500b8$var$Ur).call(this);
    }
    connectedCallback() {
        super.connectedCallback(), this.addEventListener("change", $299b6c40adc500b8$var$Mi(this, $299b6c40adc500b8$var$Us, $299b6c40adc500b8$var$xo));
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this.removeEventListener("change", $299b6c40adc500b8$var$Mi(this, $299b6c40adc500b8$var$Us, $299b6c40adc500b8$var$xo));
    }
    get anchorElement() {
        return this.anchor !== "auto" ? super.anchorElement : $299b6c40adc500b8$var$D(this).querySelector("media-rendition-menu-button");
    }
    get mediaRenditionList() {
        return $299b6c40adc500b8$var$xr(this, $299b6c40adc500b8$var$Nr);
    }
    set mediaRenditionList(e) {
        $299b6c40adc500b8$var$Hu(this, $299b6c40adc500b8$var$Nr, e), $299b6c40adc500b8$var$Mi(this, $299b6c40adc500b8$var$Li, $299b6c40adc500b8$var$Ur).call(this);
    }
    get mediaRenditionSelected() {
        return $299b6c40adc500b8$var$_(this, $299b6c40adc500b8$var$a.MEDIA_RENDITION_SELECTED);
    }
    set mediaRenditionSelected(e) {
        $299b6c40adc500b8$var$b(this, $299b6c40adc500b8$var$a.MEDIA_RENDITION_SELECTED, e);
    }
    get mediaHeight() {
        return $299b6c40adc500b8$var$M(this, $299b6c40adc500b8$var$a.MEDIA_HEIGHT);
    }
    set mediaHeight(e) {
        $299b6c40adc500b8$var$w(this, $299b6c40adc500b8$var$a.MEDIA_HEIGHT, e);
    }
    compareRendition(e, t) {
        return this.constructor.compareRendition(e, t);
    }
    formatMenuItemText(e, t) {
        return this.constructor.formatMenuItemText(e, t);
    }
    formatRendition(e, t) {
        return this.constructor.formatRendition(e, t);
    }
    showRenditionBitrate(e) {
        return this.mediaRenditionList.some((t)=>t !== e && t.height === e.height && t.bitrate !== e.bitrate);
    }
};
$299b6c40adc500b8$var$Nr = new WeakMap;
$299b6c40adc500b8$var$wi = new WeakMap;
$299b6c40adc500b8$var$Li = new WeakSet;
$299b6c40adc500b8$var$Ur = function() {
    if ($299b6c40adc500b8$var$xr(this, $299b6c40adc500b8$var$wi).mediaRenditionList === JSON.stringify(this.mediaRenditionList) && $299b6c40adc500b8$var$xr(this, $299b6c40adc500b8$var$wi).mediaHeight === this.mediaHeight) return;
    $299b6c40adc500b8$var$xr(this, $299b6c40adc500b8$var$wi).mediaRenditionList = JSON.stringify(this.mediaRenditionList), $299b6c40adc500b8$var$xr(this, $299b6c40adc500b8$var$wi).mediaHeight = this.mediaHeight;
    let i = this.mediaRenditionList.sort(this.compareRendition.bind(this)), e = i.find((o)=>o.id === this.mediaRenditionSelected);
    for (let o of i)o.selected = o === e;
    this.defaultSlot.textContent = "";
    let t = !this.mediaRenditionSelected;
    for (let o of i){
        let d = this.formatRendition(o, {
            showBitrate: this.showRenditionBitrate(o)
        }), u = $299b6c40adc500b8$var$pe({
            type: "radio",
            text: d,
            value: `${o.id}`,
            checked: o.selected && !t
        });
        u.prepend($299b6c40adc500b8$var$ue(this, "checked-indicator")), this.defaultSlot.append(u);
    }
    let r = e && this.showRenditionBitrate(e), n1 = t ? e ? this.formatMenuItemText(`${$299b6c40adc500b8$var$c("Auto")} \u2022 ${this.formatRendition(e, {
        showBitrate: r
    })}`, e) : this.formatMenuItemText(`${$299b6c40adc500b8$var$c("Auto")} (${this.mediaHeight}p)`) : this.formatMenuItemText($299b6c40adc500b8$var$c("Auto")), s = $299b6c40adc500b8$var$pe({
        type: "radio",
        text: n1,
        value: "auto",
        checked: t
    });
    s.dataset.description = n1, s.prepend($299b6c40adc500b8$var$ue(this, "checked-indicator")), this.defaultSlot.append(s);
};
$299b6c40adc500b8$var$Us = new WeakSet;
$299b6c40adc500b8$var$xo = function() {
    if (this.value == null) return;
    let i = new $299b6c40adc500b8$var$l.CustomEvent($299b6c40adc500b8$var$h.MEDIA_RENDITION_REQUEST, {
        composed: !0,
        bubbles: !0,
        detail: this.value
    });
    this.dispatchEvent(i);
};
$299b6c40adc500b8$var$l.customElements.get("media-rendition-menu") || $299b6c40adc500b8$var$l.customElements.define("media-rendition-menu", $299b6c40adc500b8$var$Hs);
var $299b6c40adc500b8$var$jm = `<svg aria-hidden="true" viewBox="0 0 24 24">
  <path d="M13.5 2.5h2v6h-2v-2h-11v-2h11v-2Zm4 2h4v2h-4v-2Zm-12 4h2v6h-2v-2h-3v-2h3v-2Zm4 2h12v2h-12v-2Zm1 4h2v6h-2v-2h-8v-2h8v-2Zm4 2h7v2h-7v-2Z" />
</svg>`;
function $299b6c40adc500b8$var$ep() {
    return `
    <style>
      :host([aria-expanded="true"]) slot[name=tooltip] {
        display: none;
      }
    </style>
    <slot name="icon">${$299b6c40adc500b8$var$jm}</slot>
  `;
}
function $299b6c40adc500b8$var$tp() {
    return $299b6c40adc500b8$var$c("Quality");
}
var $299b6c40adc500b8$var$Ci = class extends $299b6c40adc500b8$var$J {
    static get observedAttributes() {
        return [
            ...super.observedAttributes,
            $299b6c40adc500b8$var$a.MEDIA_RENDITION_SELECTED,
            $299b6c40adc500b8$var$a.MEDIA_RENDITION_UNAVAILABLE,
            $299b6c40adc500b8$var$a.MEDIA_HEIGHT
        ];
    }
    connectedCallback() {
        super.connectedCallback(), this.setAttribute("aria-label", $299b6c40adc500b8$var$c("quality"));
    }
    get invokeTargetElement() {
        return this.invokeTarget != null ? super.invokeTargetElement : $299b6c40adc500b8$var$D(this).querySelector("media-rendition-menu");
    }
    get mediaRenditionSelected() {
        return $299b6c40adc500b8$var$_(this, $299b6c40adc500b8$var$a.MEDIA_RENDITION_SELECTED);
    }
    set mediaRenditionSelected(e) {
        $299b6c40adc500b8$var$b(this, $299b6c40adc500b8$var$a.MEDIA_RENDITION_SELECTED, e);
    }
    get mediaHeight() {
        return $299b6c40adc500b8$var$M(this, $299b6c40adc500b8$var$a.MEDIA_HEIGHT);
    }
    set mediaHeight(e) {
        $299b6c40adc500b8$var$w(this, $299b6c40adc500b8$var$a.MEDIA_HEIGHT, e);
    }
};
$299b6c40adc500b8$var$Ci.getSlotTemplateHTML = $299b6c40adc500b8$var$ep;
$299b6c40adc500b8$var$Ci.getTooltipContentHTML = $299b6c40adc500b8$var$tp;
$299b6c40adc500b8$var$l.customElements.get("media-rendition-menu-button") || $299b6c40adc500b8$var$l.customElements.define("media-rendition-menu-button", $299b6c40adc500b8$var$Ci);
(0, $jW02B.StreamMediaSourceWrapperFactory).Register({
    ctor: (0, $jW02B.StreamMediaSourceWrapper),
    isSupported: ()=>!0,
    name: "MainThread"
});
var $299b6c40adc500b8$var$be = class {
    static _engines = [];
    static get _allEngines() {
        return this._engines.flatMap((e)=>e());
    }
    static get _supportedEngines() {
        return this._allEngines.filter((e)=>e.isSupported());
    }
    static get SupportedEngines() {
        return this._supportedEngines.map((e)=>e.name);
    }
    static get AllEngines() {
        return this._allEngines.map((e)=>e.name);
    }
    static isSubset(e, t) {
        return t.includes("/") ? e === t : new RegExp(`^${t}(?:/w+)?$`).test(e);
    }
    static Register(e, t) {
        t === void 0 ? this._engines.push(()=>[
                e
            ]) : this._engines.push(()=>t().map((r, n1)=>({
                    urlTest: e.urlTest,
                    ctor: e.ctor,
                    isSupported: ()=>e.isSupported() && r.isSupported(),
                    name: `${e.name}/${r.name}`,
                    variantIdx: n1
                })));
    }
    static async Create(e, t, r, n1, s, o, d, u, m = 0) {
        let f = (k)=>u.indexOf(k) !== -1 ? u.indexOf(k) : Number.MAX_SAFE_INTEGER, v = (this._supportedEngines.toSorted !== void 0 ? this._supportedEngines.toSorted((k, S)=>f(k.name) - f(S.name)) : this._supportedEngines).filter((k)=>u.some((S)=>this.isSubset(k.name, S))), E = [];
        for (let k of v)await k.urlTest(t) && E.push(k);
        if (m >= E.length || m < 0) return null;
        let R = E[m];
        return new R.ctor(e, R.variantIdx, {
            video: r,
            maskVideo: n1,
            img: s,
            canvas: o,
            offscreenCanvas: d
        });
    }
};
var $299b6c40adc500b8$var$Vt = class i extends (0, (/*@__PURE__*/$parcel$interopDefault($jOCUE))) {
    static DECREASING_LATENCY_SPAN_S = 30;
    static DECREASING_LATENCY_VALUE_MS = 1e3;
    static LOW_LATENCY_BUFFER_MS = 800;
    lock = new (0, $jW02B.Mutex);
    _status = (0, $jW02B.Status).STOPPED;
    lastDecreasingLatencySeconds = 0;
    timeStarted = null;
    lastLowLatencyReset = null;
    videoTimeStarted = null;
    connectionTimeoutMs = 0;
    connectionTimeoutId = null;
    _seeking = !1;
    _url = null;
    _resumeAfterSeek = !1;
    _videoConfig = null;
    _streamType = (0, $jW02B.StreamType).UNKNOWN;
    _ended = !1;
    _crossOrigin = "";
    _lowLatency = !1;
    _externalRenderer = !1;
    _canPlay = !1;
    _fmp4ProtocolVersion = (0, $jW02B.FMP4ProtocolVersion).V4;
    get fullName() {
        return this.variant === null ? this.name : `${this.name}/${this.variant}`;
    }
    get streamType() {
        return this._streamType;
    }
    set streamType(e) {
        this._streamType !== e && (this._streamType = e, this.emit((0, $jW02B.Events).STREAM_TYPE_CHANGE, e));
    }
    get acceptableDelay() {
        return (0, $jW02B.makePromise)(()=>0);
    }
    get seeking() {
        return this._seeking;
    }
    set ended(e) {
        this._ended = e;
    }
    get ended() {
        return this._ended;
    }
    get videoConfig() {
        return this._videoConfig;
    }
    get crossOrigin() {
        return this._crossOrigin;
    }
    set crossOrigin(e) {
        this._crossOrigin = e;
    }
    get minBufferMs() {
        return this.lowLatency ? i.LOW_LATENCY_BUFFER_MS : 1e3;
    }
    get canPlay() {
        return this._canPlay;
    }
    set canPlay(e) {
        this._canPlay !== e && (this._canPlay = e, e && this.emit((0, $jW02B.Events).CAN_PLAY));
    }
    get status() {
        return this._status;
    }
    set status(e) {
        this._status !== e && (this._status = e, this.emit((0, $jW02B.Events).STATUS_CHANGED, this._status));
    }
    get lowLatency() {
        return this._lowLatency;
    }
    set lowLatency(e) {
        this._lowLatency !== e && (this._lowLatency = e);
    }
    get externalRenderer() {
        return this._externalRenderer;
    }
    set externalRenderer(e) {
        this._externalRenderer !== e && (this._externalRenderer = e);
    }
    get videoTrackNumber() {
        return this._videoConfig?.videoTracks?.length ?? 0;
    }
    get fmp4ProtocolVersion() {
        return this._fmp4ProtocolVersion;
    }
    set fmp4ProtocolVersion(e) {
        this._fmp4ProtocolVersion !== e && (this._fmp4ProtocolVersion = e);
    }
    constructor(){
        super();
    }
    isInBuffer(e) {
        for (let t of this.buffer)if (e >= t.start && e <= t.end) return !0;
        return !1;
    }
    async dispose(e = !1) {
        await this.stop(), this.unsubscribe(), await this.removeSource();
    }
    async play(e, t = 1e4) {
        await this.stop(), this.connectionTimeoutMs = t, this.status = (0, $jW02B.Status).CONNECTING, this.resetConnectionTimeout(!0), this._url = e, await this.setSource(e), await this.initPlayer();
    }
    async pause() {
        this.streamType == (0, $jW02B.StreamType).ON_DEMAND && (await this.pauseInternal(), this.resetConnectionTimeout(!1));
    }
    async resume() {
        this.streamType == (0, $jW02B.StreamType).ON_DEMAND && (await this.resumeInternal(), this.resetConnectionTimeout(!0));
    }
    async stop(e = !1) {
        this.resetConnectionTimeout(), await this.removeSource(), await this.pauseInternal(), this.status !== (0, $jW02B.Status).STOPPED && (await this.pauseInternal(), this.unsubscribe(), e && this.takeScreenshot(), this.unsetSource()), this.lastDecreasingLatencySeconds = 0, this.canPlay = !1, this.status = (0, $jW02B.Status).STOPPED, this._resumeAfterSeek = !1, this._url = null;
    }
    resetConnectionTimeout(e = !1) {
        this.connectionTimeoutId && (clearTimeout(this.connectionTimeoutId), this.connectionTimeoutId = null), e && (this.connectionTimeoutId = setTimeout(this.onConnectionTimeout, this.connectionTimeoutMs));
    }
    onConnectionTimeout = async ()=>{
        await this.stopWithError("Connection timeout.", (0, $jW02B.Errors).CONNECTION_TIMEOUT);
    };
    takeScreenshot() {
        try {
            this.takeScreenshotInternal(), this.emit((0, $jW02B.Events).SCREENSHOT);
        } catch (e) {
            (0, $jW02B.LogInternal).warn(e);
        }
    }
    async stopWithError(e, t) {
        let r = this.position, n1 = this.duration, s = this.status;
        await this.stop(!0), this.emit((0, $jW02B.Events).ERROR, e, t, {
            position: r,
            duration: n1,
            state: s
        });
    }
    async initPlayer() {
        this.status = (0, $jW02B.Status).LOOKING_FOR_START, this.subscribe();
    }
};
var $299b6c40adc500b8$var$Ri = class extends $299b6c40adc500b8$var$Vt {
    screenshotCanvas;
    screenshotContext;
    video;
    maskVideo;
    canvas;
    _isSubscribed = !1;
    _token = "";
    _includeMask = !1;
    _isRunningRenderThread = !1;
    _mainVideoCallback = null;
    _maskVideoCallback = null;
    _rendererManager = null;
    _renderThreadRequest = null;
    get token() {
        return this._token;
    }
    set token(e) {
        this._token = e;
    }
    get includeMask() {
        return this._includeMask;
    }
    set includeMask(e) {
        this._includeMask = e, this._includeMask || this.requestStopRenderThread();
    }
    get displayElement() {
        return this._rendererManager && this._rendererManager.isRunning && this._rendererManager.displayElement ? this._rendererManager.displayElement : this.video;
    }
    get buffer() {
        if (this.video.buffered.length === 0) return [];
        let e = [];
        for(let t = 0; t < this.video.buffered.length; t++)e.push({
            start: this.video.buffered.start(t),
            end: this.video.buffered.end(t)
        });
        return e;
    }
    get buffered() {
        return this.video.buffered;
    }
    get position() {
        return this.video.currentTime;
    }
    get duration() {
        return this.video.duration;
    }
    get muted() {
        return this.video.muted;
    }
    set muted(e) {
        this.video.muted = e;
    }
    get loop() {
        return this.video.loop;
    }
    set loop(e) {
        this.video.loop = e, this.maskVideo.loop = e;
    }
    get volume() {
        return this.video.volume;
    }
    set volume(e) {
        this.video.volume = e;
    }
    get videoWidth() {
        return this.video.videoWidth;
    }
    get videoHeight() {
        return this.video.videoHeight;
    }
    get renderingWidth() {
        return this.video.videoWidth;
    }
    get renderingHeight() {
        return this.video.videoHeight;
    }
    get externalRenderer() {
        return this._externalRenderer;
    }
    set externalRenderer(e) {
        this._externalRenderer !== e && (this._externalRenderer = e, this.requestStartRenderThread());
    }
    get readyState() {
        return this.video.readyState;
    }
    get bufferMs() {
        if (this.status === (0, $jW02B.Status).STOPPED || this.video.buffered.length === 0 || this._rendererManager?.isRunning && this.maskVideo.buffered.length === 0) return 0;
        let t = [
            {
                start: Math.max(this.video.buffered.start(0), this.video.currentTime),
                end: this.video.buffered.end(this.video.buffered.length - 1)
            }
        ];
        return this._rendererManager?.isRunning && t.push({
            start: Math.max(this.maskVideo.buffered.start(0), this.maskVideo.currentTime),
            end: this.maskVideo.buffered.end(this.maskVideo.buffered.length - 1)
        }), Math.floor(1e3 * Math.min(...t.map((n1)=>n1.end - n1.start)));
    }
    get isRunningRenderThread() {
        return this._isRunningRenderThread;
    }
    constructor(e, t, r, n1){
        super(), this.video = e, this.maskVideo = t, this.canvas = r, this.screenshotCanvas = n1, this.screenshotContext = this.screenshotCanvas.getContext("2d");
    }
    async clear() {
        this.screenshotContext.clearRect(0, 0, this.screenshotCanvas.width, this.screenshotCanvas.height);
    }
    async setSinkId(e) {
        await this.video.setSinkId(e);
    }
    render() {
        this._rendererManager?.process({
            data: this.video,
            timestamp: this.video.currentTime,
            trackId: this._videoConfig?.video?.id ?? 1
        }), this._rendererManager?.process({
            data: this.maskVideo,
            timestamp: this.maskVideo.currentTime,
            trackId: this._videoConfig?.videoTracks?.at(1)?.id ?? 2,
            supplementsTrack: this._videoConfig?.video?.id
        }), this._rendererManager?.render(!0);
    }
    async seek(e) {
        this._seeking || (await this.lock.lockAsync(), await this.seekInternal(e), this.lock.unlock(), this._seeking = !1);
    }
    async pauseInternal() {
        this.video.pause(), this.maskVideo.pause(), await (0, $jW02B.waitUntilAsync)(()=>this.video.paused && this.maskVideo.paused);
    }
    async resumeInternal() {
        this._rendererManager?.isRunning ? await Promise.all([
            this.video.play(),
            this.maskVideo.play()
        ]) : await this.video.play();
    }
    async performVideoAction(e, t, r) {
        let n1 = [
            async ()=>{
                (t === void 0 || await t.call(this, this.video)) && await e.call(this, this.video);
            },
            async ()=>{
                (t === void 0 || await t.call(this, this.maskVideo)) && await e.call(this, this.maskVideo);
            }
        ];
        if (r) await Promise.all(n1);
        else for (let s of n1)await s();
    }
    videoElementOnCanPlay = ()=>{
        this.canPlay = !0;
    };
    videoElementOnPlaying = ()=>{
        this.status = (0, $jW02B.Status).PLAYING, this._resumeAfterSeek = !1;
    };
    videoElementOnPause = async ()=>{
        this.video.seeking && this.status !== (0, $jW02B.Status).PAUSED && (this._resumeAfterSeek = !0), this.status !== (0, $jW02B.Status).CONNECTING && this.status !== (0, $jW02B.Status).LOOKING_FOR_START && (this.status = (0, $jW02B.Status).PAUSED);
    };
    videoElementOnEnded = async ()=>{
        this.streamType === (0, $jW02B.StreamType).ON_DEMAND ? (this.video.pause(), this.maskVideo.pause(), await (0, $jW02B.waitUntilAsync)(()=>this.video.paused && this.maskVideo.paused), this.video.loop ? (this.video.currentTime = 0, this._rendererManager?.isRunning ? await Promise.all([
            this.video.play(),
            this.maskVideo.play()
        ]) : await this.video.play()) : (this.resetConnectionTimeout(), this.status = (0, $jW02B.Status).STOPPED, this._resumeAfterSeek = !1, this.emit((0, $jW02B.Events).ENDED))) : this.status = (0, $jW02B.Status).STOPPED;
    };
    videoElementOnSeeking = async ()=>{
        this.streamType === (0, $jW02B.StreamType).ON_DEMAND && !this._resumeAfterSeek && !this.isInBuffer(this.video.currentTime) && this.status === (0, $jW02B.Status).PAUSED && (await this.resume(), await this.pause());
    };
    videoElementOnLoadedMetadata = ()=>{
        this.emit((0, $jW02B.Events).LOADED_METADATA, this.videoTrackNumber > 1);
    };
    videoElementOnLoadedData = ()=>{
        this.emit((0, $jW02B.Events).LOADED_DATA);
    };
    videoElementOnProgress = ()=>{
        this.emit((0, $jW02B.Events).PROGRESS);
    };
    videoElementOnPlay = ()=>{
        this.emit((0, $jW02B.Events).PLAY);
    };
    async discardOldBuffer(e) {
        return !0;
    }
    async canUpdateVideo() {
        return this.status === (0, $jW02B.Status).PLAYING;
    }
    async synchronizeTracks() {
        if (this._rendererManager?.isRunning && !this.lock.locked) {
            let e = this.video.currentTime, t = this.maskVideo.currentTime, r = e - t, n1 = .02, s = 2;
            if ((0, $jW02B.LogInternal).verbose(`Mask delay: ${r}, videoTime: ${e}, maskTime: ${t}`), Math.abs(r) > n1) {
                if (await this.lock.lockAsync(), r > s && this.video.buffered.length > 0) {
                    this.video.addEventListener("seeked", ()=>{
                        this.lock.unlock();
                    }, {
                        once: !0
                    });
                    let o = Math.max(t, this.video.buffered.start(0)) + n1;
                    this.video.fastSeek !== void 0 ? this.video.fastSeek(o) : this.video.currentTime = o;
                } else if (r < -s && this.maskVideo.buffered.length > 0) {
                    this.maskVideo.addEventListener("seeked", ()=>{
                        this.lock.unlock();
                    }, {
                        once: !0
                    });
                    let o = Math.max(e, this.maskVideo.buffered.start(0)) + n1;
                    this.maskVideo.fastSeek !== void 0 ? this.maskVideo.fastSeek(o) : this.maskVideo.currentTime = o;
                } else r > n1 ? (this.video.pause(), (0, $jW02B.waitUntilAsync)(()=>this.video.currentTime - this.maskVideo.currentTime < n1, s * 1e3).then(async ()=>{
                    await this.video.play(), this.lock.unlock();
                })) : r < -n1 && (this.maskVideo.pause(), (0, $jW02B.waitUntilAsync)(()=>this.maskVideo.currentTime - this.video.currentTime < n1, s * 1e3).then(async ()=>{
                    await this.maskVideo.play(), this.lock.unlock();
                }));
            }
        }
    }
    videoElementOnTimeUpdate = async ()=>{
        if (this.emit((0, $jW02B.Events).TIME_UPDATE), !await this.canUpdateVideo()) return;
        await this.synchronizeTracks();
        let e = this.video.currentTime;
        if (await this.discardOldBuffer(e) && this.streamType == (0, $jW02B.StreamType).LIVE) {
            let t = performance.now();
            if (this.timeStarted === null && (this.timeStarted = t), this.videoTimeStarted === null && (this.videoTimeStarted = this.video.currentTime * 1e3), this.lowLatency) {
                if (this.lastDecreasingLatencySeconds < this.videoTimeStarted / 1e3 && (this.lastDecreasingLatencySeconds = e), e - this.lastDecreasingLatencySeconds > $299b6c40adc500b8$var$Vt.DECREASING_LATENCY_SPAN_S && this.bufferMs > this.minBufferMs + await this.acceptableDelay) await this.seek(Math.min(e + (this.bufferMs - this.minBufferMs) / 1e3, this.video.seekable.end(this.video.seekable.length - 1))), this.lastDecreasingLatencySeconds = e;
                else {
                    let r = this.video.currentTime * 1e3 - this.videoTimeStarted, n1 = t - this.timeStarted, s = n1 - r;
                    r > 0 && n1 > 0 && t - (this.lastLowLatencyReset ?? 0) > $299b6c40adc500b8$var$Vt.DECREASING_LATENCY_SPAN_S * 1e3 && s > $299b6c40adc500b8$var$Vt.DECREASING_LATENCY_VALUE_MS && (this.lastLowLatencyReset = t, this.timeStarted = null, this.videoTimeStarted = null, this.video.pause(), this.maskVideo.pause(), await (0, $jW02B.waitUntilAsync)(()=>this.video.paused && this.maskVideo.paused), this.takeScreenshot(), this.resetSource(), this.unsetSource(), this.unsubscribe(), await this.initPlayer());
                }
            }
        }
    };
    takeScreenshotInternal() {
        !this.video.src && !this.video.srcObject || this.video.readyState < this.video.HAVE_CURRENT_DATA || (this._rendererManager?.isRunning ? (this.screenshotCanvas.width = this.canvas.width, this.screenshotCanvas.height = this.canvas.height, this.screenshotContext?.drawImage(this.canvas, 0, 0)) : (this.screenshotCanvas.width = this.video.videoWidth, this.screenshotCanvas.height = this.video.videoHeight, this.screenshotContext?.drawImage(this.video, 0, 0)));
    }
    frameCallback = ()=>{
        this._isSubscribed && (this.status === (0, $jW02B.Status).PLAYING && !this._rendererManager?.isRunning && this.emit((0, $jW02B.Events).FRAME_READY), this.video.requestVideoFrameCallback !== void 0 ? this.video.requestVideoFrameCallback(this.frameCallback) : requestAnimationFrame(this.frameCallback));
    };
    subscribe() {
        this.video.addEventListener("canplay", this.videoElementOnCanPlay), this.video.addEventListener("play", this.videoElementOnPlay), this.video.addEventListener("timeupdate", this.videoElementOnTimeUpdate), this.video.addEventListener("playing", this.videoElementOnPlaying), this.video.addEventListener("pause", this.videoElementOnPause), this.video.addEventListener("ended", this.videoElementOnEnded), this.video.addEventListener("seeking", this.videoElementOnSeeking), this.video.addEventListener("loadedmetadata", this.videoElementOnLoadedMetadata), this.video.addEventListener("loadeddata", this.videoElementOnLoadedData), this.video.addEventListener("progress", this.videoElementOnProgress), this._isSubscribed = !0, this.frameCallback();
    }
    unsubscribe() {
        this.video.removeEventListener("canplay", this.videoElementOnCanPlay), this.video.removeEventListener("play", this.videoElementOnPlay), this.video.removeEventListener("timeupdate", this.videoElementOnTimeUpdate), this.video.removeEventListener("playing", this.videoElementOnPlaying), this.video.removeEventListener("pause", this.videoElementOnPause), this.video.removeEventListener("ended", this.videoElementOnEnded), this.video.removeEventListener("seeking", this.videoElementOnSeeking), this.video.removeEventListener("loadedmetadata", this.videoElementOnLoadedMetadata), this.video.removeEventListener("loadeddata", this.videoElementOnLoadedData), this.video.removeEventListener("progress", this.videoElementOnProgress), this._isSubscribed = !1;
    }
    async removeSource() {
        await this.stopRenderThread();
    }
    renderMain() {
        this.externalRenderer || !this._isRunningRenderThread || (this._rendererManager?.isRunning && !this.video.paused && !this.maskVideo.paused && this._rendererManager?.process({
            data: this.video,
            timestamp: this.video.currentTime * 1e3,
            trackId: this._videoConfig?.video?.id ?? 1
        }), this.requestMainFrame());
    }
    renderMask() {
        this.externalRenderer || !this._isRunningRenderThread || (this._rendererManager?.isRunning && !this.video.paused && !this.maskVideo.paused && this._rendererManager?.process({
            data: this.maskVideo,
            timestamp: this.maskVideo.currentTime * 1e3,
            trackId: this._videoConfig?.videoTracks?.at(1)?.id ?? 2,
            supplementsTrack: this._videoConfig?.video?.id
        }), this.requestMaskFrame());
    }
    requestMainFrame() {
        this.video.requestVideoFrameCallback !== void 0 ? this._mainVideoCallback = this.video.requestVideoFrameCallback(()=>this.renderMain()) : this._mainVideoCallback = requestAnimationFrame(()=>this.renderMain());
    }
    requestMaskFrame() {
        this.maskVideo.requestVideoFrameCallback !== void 0 ? this._maskVideoCallback = this.maskVideo.requestVideoFrameCallback(()=>this.renderMask()) : this._maskVideoCallback = requestAnimationFrame(()=>this.renderMask());
    }
    getRendererConfig() {
        return this._videoConfig?.videoTracks?.map((e)=>({
                type: e.type === (0, $jW02B.BuiltInTrackTypes).Video && e == this._videoConfig?.video ? (0, $jW02B.TrackConfigType).Main : (0, $jW02B.TrackConfigType).Supplementary,
                trackNumber: e.id,
                trackType: e.type,
                displayElement: e.type === (0, $jW02B.BuiltInTrackTypes).Video && e == this._videoConfig?.video ? this.canvas : void 0,
                supplementsTrack: e.type === (0, $jW02B.BuiltInTrackTypes).Video && e != this._videoConfig?.video ? this._videoConfig?.video?.id : void 0
            })) ?? [];
    }
    requestStartRenderThread() {
        this._renderThreadRequest !== null && this.video.cancelVideoFrameCallback(this._renderThreadRequest), this._renderThreadRequest = this.video.requestVideoFrameCallback(async ()=>{
            await this.startRenderThread(), this._renderThreadRequest = null;
        });
    }
    requestStopRenderThread() {
        this._renderThreadRequest !== null && this.video.cancelVideoFrameCallback(this._renderThreadRequest), this._renderThreadRequest = this.video.requestVideoFrameCallback(async ()=>{
            await this.stopRenderThread(), this._renderThreadRequest = null;
        });
    }
    async startRenderThread() {
        if (await this.stopRenderThread(), !this._isRunningRenderThread && !(this.videoTrackNumber <= 1 || !this.includeMask)) {
            if (this._rendererManager === null) {
                let e = this.getRendererConfig();
                this._rendererManager = (0, $jW02B.PlayerNodeFactory).Create(e), this._rendererManager?.addEventListener("processed", ()=>this.emit((0, $jW02B.Events).FRAME_READY));
            }
            await this._rendererManager?.start(), this._isRunningRenderThread = !0, !this._externalRenderer && (this.requestMainFrame(), this.requestMaskFrame());
        }
    }
    async stopRenderThread() {
        this._isRunningRenderThread = !1, await this._rendererManager?.stop(), this._mainVideoCallback !== null && (this.video.requestVideoFrameCallback !== void 0 ? this.video.cancelVideoFrameCallback(this._mainVideoCallback) : cancelAnimationFrame(this._mainVideoCallback), this._mainVideoCallback = null), this._maskVideoCallback !== null && (this.maskVideo.requestVideoFrameCallback !== void 0 ? this.maskVideo.cancelVideoFrameCallback(this._maskVideoCallback) : cancelAnimationFrame(this._maskVideoCallback), this._maskVideoCallback = null);
    }
};
var $299b6c40adc500b8$var$Pi = class extends $299b6c40adc500b8$var$Ri {
    parser = new (0, $jW02B.Parser);
    capabilitiesChecker = new (0, $jW02B.CapabilitiesChecker);
    abortController = new AbortController;
    get variant() {
        return null;
    }
    get muted() {
        return super.muted;
    }
    set muted(e) {
        super.muted = e, this.video.defaultMuted = e;
    }
    get requestInit() {
        return this.crossOrigin === "" ? {
            signal: this.abortController.signal
        } : {
            credentials: this.crossOrigin === "anonymous" ? "same-origin" : "include",
            mode: this.crossOrigin === "anonymous" && new URL(this._url ?? "").host === globalThis.location.host ? "same-origin" : "cors",
            signal: this.abortController.signal
        };
    }
    constructor(e, t, r){
        super(r.video, r.maskVideo, r.canvas, r.img);
    }
    async setSource(e) {
        this._videoConfig = null, this.video.src = e;
    }
    async removeSource() {
        await super.removeSource(), await this.performVideoAction((e)=>{
            e.src = "", e.removeAttribute("src");
        });
    }
    unsetSource() {
        this.performVideoAction((e)=>{
            e.src = "", e.removeAttribute("src");
        });
    }
    resetSource() {
        this.performVideoAction((e)=>{
            let t = e.src;
            t && (e.src = "", e.removeAttribute("src"), e.src = t);
        });
    }
    async dispose() {
        this.video.pause(), await (0, $jW02B.waitUntilAsync)(()=>this.video.paused), this.abortController.abort(), this.unsetSource(), this._videoConfig = null;
    }
    subscribe() {
        super.subscribe(), this.video.addEventListener("play", this._videoElementOnPlay), this.video.addEventListener("playing", this._videoElementOnPlaying), this.video.addEventListener("timeupdate", this._videoElementOnTimeUpdate);
    }
    unsubscribe() {
        super.unsubscribe(), this.video.removeEventListener("play", this._videoElementOnPlay), this.video.removeEventListener("playing", this._videoElementOnPlaying), this.video.removeEventListener("timeupdate", this._videoElementOnTimeUpdate);
    }
    _videoElementOnPlay = async ()=>{
        this.canPlay = !0, (this.status === (0, $jW02B.Status).WAIT_FOR_BUFFER || this.status === (0, $jW02B.Status).LOOKING_FOR_START) && (this.status = (0, $jW02B.Status).STARTING_PLAYING);
    };
    _videoElementOnPlaying = ()=>{
        Number.isFinite(this.video.duration) ? this.streamType = (0, $jW02B.StreamType).ON_DEMAND : this.streamType = (0, $jW02B.StreamType).LIVE, this.status = (0, $jW02B.Status).PLAYING;
    };
    _videoElementOnTimeUpdate = ()=>{
        this.resetConnectionTimeout(!0);
    };
    async initPlayer() {
        await super.initPlayer();
        let e = !1;
        for(let t = 0; t < 3; t++)if (await this.testSrc(this._url ?? "")) try {
            let r = [
                this.video.play()
            ];
            if (this.maskVideo.src && r.push(this.maskVideo.play()), await Promise.race([
                this.performVideoAction(async (s)=>await s.play(), (s)=>!!s.src, !0),
                (0, $jW02B.waitUntilAsync)(()=>this.status === (0, $jW02B.Status).PLAYING, this.connectionTimeoutMs)
            ]) !== !1) {
                e = !0;
                break;
            }
        } catch (r) {
            let n1 = r;
            if (n1.name === "AbortError") return;
            await this.stopWithError(`Start playing error: ${n1.message}`, n1.name === "NotSupportedError" ? (0, $jW02B.Errors).UNSUPPORTED_MEDIA_FORMAT : (0, $jW02B.Errors).UNKNOWN_ERROR);
            break;
        }
        e || await this.stopWithError("Start playing error: Failed to load the video.", (0, $jW02B.Errors).CRITICAL_CONNECTION_ERROR);
    }
    async seekInternal(e) {
        this.streamType === (0, $jW02B.StreamType).ON_DEMAND && (this.video.fastSeek !== void 0 ? this.video.fastSeek(e) : this.video.currentTime = e, this.videoTrackNumber > 1 && (this.maskVideo.fastSeek !== void 0 ? this.maskVideo.fastSeek(e) : this.maskVideo.currentTime = e), await (0, $jW02B.waitUntilAsync)(()=>!this.video.seeking && !this.maskVideo.seeking));
    }
};
var $299b6c40adc500b8$var$Fu = "MSE", $299b6c40adc500b8$var$Ko = class extends $299b6c40adc500b8$var$Ri {
    get name() {
        return $299b6c40adc500b8$var$Fu;
    }
    get variant() {
        return this.streamMediaSourceWrapper.name;
    }
    streamMediaSourceWrapper;
    _capabilityChecks = [
        (0, $jW02B.CapabilityCheck).MediaSource,
        (0, $jW02B.CapabilityCheck).Video,
        (0, $jW02B.CapabilityCheck).MediaCapabilitiesStream
    ];
    _needsTimeReset = !1;
    _isAdvancingBuffer = !1;
    _textTracks = new Map;
    get acceptableDelay() {
        return this.streamMediaSourceWrapper.expectedBuffer;
    }
    get token() {
        return super.token;
    }
    set token(e) {
        super.token = e, this.streamMediaSourceWrapper.passthroughToken = e;
    }
    get includeMask() {
        return super.includeMask;
    }
    set includeMask(e) {
        super.includeMask = e, this.streamMediaSourceWrapper.includeMask = e;
    }
    constructor(e, t, r){
        super(r.video, r.maskVideo, r.canvas, r.img);
        let n1 = (0, $jW02B.StreamMediaSourceWrapperFactory).Create(e, t);
        if (n1 === null) throw new Error("Failed to create requested media source");
        this.streamMediaSourceWrapper = n1;
    }
    subscribe() {
        super.subscribe(), this.video.addEventListener("waiting", this._videoElementOnWaiting), this.video.addEventListener("timeupdate", this._videoElementOnTimeUpdate);
    }
    unsubscribe() {
        super.unsubscribe(), this.video.removeEventListener("waiting", this._videoElementOnWaiting), this.video.removeEventListener("timeupdate", this._videoElementOnTimeUpdate);
    }
    _videoElementOnWaiting = async ()=>{
        this.status !== (0, $jW02B.Status).STOPPED && this.status !== (0, $jW02B.Status).STARTING_PLAYING && (this.canPlay = !1, this.streamType === (0, $jW02B.StreamType).ON_DEMAND ? this.duration - this.position < .5 && !this.video.ended ? await this.streamMediaSourceWrapper.endOfStream() : (this.status = (0, $jW02B.Status).WAIT_FOR_BUFFER, await (0, $jW02B.waitUntilCancelleableAsync)(()=>this.status !== (0, $jW02B.Status).WAIT_FOR_BUFFER, null, 1e3) || await this.seek(this.position + .5)) : this.status = (0, $jW02B.Status).WAIT_FOR_BUFFER);
    };
    _videoElementOnTimeUpdate = async ()=>{
        await this.streamMediaSourceWrapper.isComplete && this.resetConnectionTimeout(!1);
    };
    async dispose(e = !1) {
        await this.streamMediaSourceWrapper.removeSource(), e && await this.streamMediaSourceWrapper.dispose(), this._videoConfig = null, this.clearTracks();
    }
    clearTracks() {
        let e = this.video.querySelectorAll("track");
        for(let t = e.length - 1; t >= 0; t--)e[t].track.mode = "disabled", this.video.removeChild(e[t]);
        this._textTracks.clear();
    }
    async setSource(e) {
        this._videoConfig = null, this.clearTracks(), this.streamMediaSourceWrapper.fmp4ProtocolVersion = this.fmp4ProtocolVersion, this.streamMediaSourceWrapper.on((0, $jW02B.StreamMediaSourceEvents).DATA_CONSUMED, async ()=>await this.appendData()), this.streamMediaSourceWrapper.on((0, $jW02B.StreamMediaSourceEvents).ERROR, async (t, r)=>{
            await this.streamMediaSourceWrapper.isComplete && r === (0, $jW02B.Errors).STREAM_ENDED && (!this.video.ended || !this.maskVideo.ended) ? await this.stop() : await this.stopWithError(t, r);
        }), this.streamMediaSourceWrapper.on((0, $jW02B.StreamMediaSourceWrapperEvents).STREAM_TYPE_DISCOVERED, async (t)=>{
            t === (0, $jW02B.StreamType).UNKNOWN ? await this.stopWithError("Unknown stream type", (0, $jW02B.Errors).UNSUPPORTED_MEDIA_FORMAT) : this.streamType = t;
        }), this.streamMediaSourceWrapper.on((0, $jW02B.StreamMediaSourceEvents).SOURCE_CHANGED, async ()=>{
            if (this.streamMediaSourceWrapper.sourceObject !== null) {
                this.video.disableRemotePlayback = !0, this.maskVideo.disableRemotePlayback = !0;
                try {
                    Array.isArray(this.streamMediaSourceWrapper.sourceObject) ? (this.video.srcObject = this.streamMediaSourceWrapper.sourceObject[0], this.streamMediaSourceWrapper.sourceObject.length > 1 && (this.maskVideo.srcObject = this.streamMediaSourceWrapper.sourceObject[1])) : this.video.srcObject = this.streamMediaSourceWrapper.sourceObject;
                } catch (t) {
                    t.name === "TypeError" && (Array.isArray(this.streamMediaSourceWrapper.sourceObject) && this.streamMediaSourceWrapper.sourceObject.every((r)=>r instanceof MediaSource) ? (this.video.src = URL.createObjectURL(this.streamMediaSourceWrapper.sourceObject[0]), this.streamMediaSourceWrapper.sourceObject.length > 1 && (this.maskVideo.src = URL.createObjectURL(this.streamMediaSourceWrapper.sourceObject[1]))) : this.streamMediaSourceWrapper.sourceObject instanceof MediaSource && (this.video.src = URL.createObjectURL(this.streamMediaSourceWrapper.sourceObject)));
                }
                await this.startRenderThread();
            }
        }), this.streamMediaSourceWrapper.on((0, $jW02B.StreamMediaSourceWrapperEvents).INVALID_TOKEN, ()=>{
            this.emit((0, $jW02B.Events).INVALID_PASSTHROUGH_TOKEN);
        }), this.streamMediaSourceWrapper.on((0, $jW02B.StreamMediaSourceWrapperEvents).PT_START, async ()=>{
            await this.startRenderThread();
        }), this.streamMediaSourceWrapper.on((0, $jW02B.StreamMediaSourceEvents).TEXT_CUES, (t)=>{
            let r = this._textTracks.get(t.trackId);
            if (r) {
                for (let n1 of t.cues)if (!r.cues?.getCueById(n1.id)) {
                    let s = new VTTCue(n1.start, n1.end, n1.text);
                    s.id = n1.id, r.addCue(s);
                }
            }
        }), this.streamMediaSourceWrapper.on((0, $jW02B.StreamMediaSourceWrapperEvents).CONFIG_CHANGED, (t)=>{
            if (this._videoConfig = t, t.subtitleTracks) for (let r of t.subtitleTracks){
                let n1 = this._textTracks.get(r.id);
                if (!n1) {
                    let s = document.createElement("track");
                    s.kind = "subtitles", s.label = r.language.charAt(0).toUpperCase() + r.language.slice(1), s.srclang = r.language, this.video.appendChild(s), n1 = s.track, this._textTracks.set(r.id, n1);
                }
            }
        }), await this.streamMediaSourceWrapper.setCrossOrigin(this.crossOrigin), await this.streamMediaSourceWrapper.setSource(e, ...this._capabilityChecks);
    }
    async removeSource() {
        super.removeSource(), this.streamMediaSourceWrapper.removeAllListeners(), await this.streamMediaSourceWrapper.removeSource();
    }
    resetSource() {
        this.streamMediaSourceWrapper.resetSource();
    }
    async discardOldBuffer(e) {
        if (this.seeking) return !1;
        if (this._isAdvancingBuffer) return !0;
        if (this.video.buffered.length === 0) return this._needsTimeReset = !0, !1;
        if (this.video.buffered.length > 0 && (this.videoTrackNumber == 1 || this.maskVideo.buffered.length > 0) && this._needsTimeReset && this.streamType === (0, $jW02B.StreamType).LIVE) {
            this._needsTimeReset = !1;
            let t = this.video.buffered.start(0);
            if (e < t) return this.video.currentTime = t, this.lastDecreasingLatencySeconds = 0, !1;
        }
        if (await this.canUpdateVideo()) {
            let t = await this.streamMediaSourceWrapper.bufferMax;
            if (t !== void 0) {
                let r = Math.min(2, t / 2), n1 = e - r;
                return n1 > 0 && (this._isAdvancingBuffer = !0, await this.streamMediaSourceWrapper.advanceSourceBuffer(n1), this._isAdvancingBuffer = !1), !0;
            }
            return !0;
        }
        return !1;
    }
    async canUpdateVideo() {
        return await super.canUpdateVideo() && await this.streamMediaSourceWrapper.hasSourceBuffer;
    }
    unsetSource() {
        this.performVideoAction((e)=>{
            try {
                e.src && (URL.revokeObjectURL(e.src), e.removeAttribute("src")), e.srcObject !== null && (e.srcObject = null, e.removeAttribute("srcObject"));
            } catch (t) {
                (0, $jW02B.LogInternal).warn(t);
            }
        });
    }
    bufferSeek(e) {
        this.performVideoAction((t)=>{
            t.fastSeek !== void 0 ? t.fastSeek(e) : t.currentTime = e;
        });
    }
    async seekInternal(e) {
        if (this.streamType === (0, $jW02B.StreamType).ON_DEMAND && e < 0 ? e = 0 : this.streamType === (0, $jW02B.StreamType).ON_DEMAND && e > this.duration && (e = this.duration - .1), this.isInBuffer(e)) this.bufferSeek(e);
        else if (this.streamType === (0, $jW02B.StreamType).ON_DEMAND && await (0, $jW02B.waitUntilCancelleableAsync)(async ()=>await this.streamMediaSourceWrapper.canUpdateSourceBuffer)) {
            await this.streamMediaSourceWrapper.seek(this.position, e);
            let t = await this.acceptableDelay, r = t > 0 ? t : 1e3;
            if (await (0, $jW02B.waitUntilCancelleableAsync)(()=>this.isInBuffer(e), null, r)) this.bufferSeek(e);
            else if (this.buffer.length > 0) {
                let n1 = 1 / 0, s = this.video.currentTime, o = this.buffer;
                for(let d = 0; d < o.length; d++){
                    let u = Math.abs(e - o[d].start);
                    u < n1 && (n1 = u, s = o[d].start);
                }
                this.bufferSeek(s);
            }
        }
    }
    async appendData() {
        if (this.status === (0, $jW02B.Status).PLAYING && !await this.streamMediaSourceWrapper.isComplete && this.resetConnectionTimeout(!0), !(this.video.buffered.length === 0 || this.videoTrackNumber > 1 && this.maskVideo.buffered.length === 0 || this.status === (0, $jW02B.Status).PLAYING) && !(this.bufferMs < this.minBufferMs) && (this.status === (0, $jW02B.Status).LOOKING_FOR_START && (this.status = (0, $jW02B.Status).WAIT_FOR_BUFFER, this.video.currentTime = this.video.buffered.start(0), this.videoTrackNumber > 1 && (this.maskVideo.currentTime = this.maskVideo.buffered.start(0))), this.status === (0, $jW02B.Status).WAIT_FOR_BUFFER && this.canPlay)) {
            this.status = (0, $jW02B.Status).STARTING_PLAYING;
            try {
                await (0, $jW02B.waitUntilAsync)(()=>this.video.paused && this.maskVideo.paused, 150), this.videoTrackNumber > 1 ? await Promise.all([
                    this.video.play(),
                    this.maskVideo.play()
                ]) : await this.video.play(), this.status = (0, $jW02B.Status).PLAYING;
            } catch (e) {
                let t, r = e.name;
                r === "NotAllowedError" ? t = (0, $jW02B.Errors).START_PLAYING_NOT_ALLOWED : r === "NotSupportedError" ? t = (0, $jW02B.Errors).START_PLAYING_NOT_SUPPORTED : t = (0, $jW02B.Errors).START_PLAYING, await this.stopWithError(`Start playing error: ${e}.`, t);
            }
        }
    }
};
$299b6c40adc500b8$var$be.Register({
    urlTest: (i)=>(0, $jW02B.StreamDataSourceFactory).HasDataSource(i),
    ctor: $299b6c40adc500b8$var$Ko,
    isSupported: ()=>globalThis.MediaSource !== void 0 || globalThis.ManagedMediaSource !== void 0,
    name: $299b6c40adc500b8$var$Fu
}, ()=>(0, $jW02B.StreamMediaSourceWrapperFactory).AllSources);
var $299b6c40adc500b8$var$Bu = "NativeHLS", $299b6c40adc500b8$var$Yo = class i extends $299b6c40adc500b8$var$Pi {
    get name() {
        return $299b6c40adc500b8$var$Bu;
    }
    subscribe() {
        super.subscribe(), this.video.addEventListener("canplaythrough", this._videoElementOnCanPlayThrough);
    }
    unsubscribe() {
        super.unsubscribe(), this.video.removeEventListener("canplaythrough", this._videoElementOnCanPlayThrough);
    }
    _videoElementOnCanPlayThrough = async ()=>{
        this.streamType === (0, $jW02B.StreamType).ON_DEMAND && (this.video.buffered.length < 1 || this.video.buffered.end(this.video.buffered.length - 1) < this.duration) && await this.checkStreamHealth();
    };
    async checkStreamHealth() {
        try {
            let e = await fetch(this.video.src.toString(), this.requestInit);
            if (!e.ok) {
                let t = e.statusText !== "" ? e.statusText : (await e.json())?.message ?? "";
                await this.stopWithError(t, e.status === 403 ? (0, $jW02B.Errors).UNAUTHORIZED : (0, $jW02B.Errors).UNKNOWN_ERROR);
            }
        } catch (e) {
            let t = e;
            await this.stopWithError(t.message, t.code === 403 ? (0, $jW02B.Errors).UNAUTHORIZED : (0, $jW02B.Errors).UNKNOWN_ERROR);
        }
    }
    static compareMediaTypes(e, t) {
        return e.type === t.type ? 0 : e.type === "COMBINED" ? -1 : t.type === "COMBINED" ? 1 : e.type === "VIDEO" && t.type === "AUDIO" ? -1 : e.type === "AUDIO" && t.type === "VIDEO" ? 1 : 0;
    }
    async fetchPlaylist(e) {
        let t = null;
        try {
            if (t = await fetch(e.toString(), this.requestInit), !t.ok) {
                let n1 = t.statusText !== "" ? t.statusText : (await t.json())?.message ?? "";
                return await this.stopWithError(n1, t.status === 403 ? (0, $jW02B.Errors).UNAUTHORIZED : (0, $jW02B.Errors).UNKNOWN_ERROR), null;
            }
        } catch  {
            return null;
        }
        let r = await t.text();
        return this.parser.parse(r, e);
    }
    async parseManifest(e) {
        let t = await this.fetchPlaylist(e);
        if (t === null) return null;
        if ((0, $jW02B.isMultiVariant)(t)) {
            let r = [];
            for (let n1 of t.playlists.sort((s, o)=>i.compareMediaTypes(s, o)).slice(0, 1)){
                if (r.some((o)=>o.mediaType === n1.type)) continue;
                let s = await this.fetchPlaylist(n1.uri);
                s === null || !(0, $jW02B.isRegularPlaylist)(s) || (s.mediaType = n1.type, s.segments.forEach((o)=>o.mediaType = s.mediaType), s.fragments.forEach((o)=>o.mediaType = s.mediaType), r.push(s));
            }
            return r;
        }
        return [
            t
        ];
    }
    async testSrc(e) {
        if (URL.canParse !== void 0 && !URL.canParse(e) || URL.canParse === void 0 && (e == "" || e == null || e == null)) return !1;
        let t = await this.parseManifest(new URL(e));
        if (t === null) return !1;
        try {
            for (let r of t){
                if (this.capabilitiesChecker.clear(), r.initUrl) {
                    let s = await fetch(r.initUrl, this.requestInit);
                    this.capabilitiesChecker.setHeader(await s.arrayBuffer());
                } else {
                    let s = await fetch(r.segments[0].uri, this.requestInit);
                    this.capabilitiesChecker.setHeader(await s.arrayBuffer());
                }
                let n1 = await this.capabilitiesChecker.checkCapability((0, $jW02B.CapabilityCheck).MediaSource, (0, $jW02B.CapabilityCheck).Video, (0, $jW02B.CapabilityCheck).MediaCapabilitiesStream);
                if (!n1.isSupported) return await this.stopWithError(`Start playing error: ${new Error(`Unsupported media format: "${n1.config?.mimeType}" ${n1.config?.video?.width}x${n1.config?.video?.height}@${n1.config?.video?.framerate}`)}.`, (0, $jW02B.Errors).UNSUPPORTED_MEDIA_FORMAT), !1;
                this._videoConfig = n1.config;
            }
        } catch  {
            return !1;
        }
        return !0;
    }
};
$299b6c40adc500b8$var$be.Register({
    urlTest: (i)=>/^https?:\/\/.*\.m3u8\??.*/.test(i),
    ctor: $299b6c40adc500b8$var$Yo,
    isSupported: ()=>{
        let i = navigator.userAgent || navigator.vendor;
        if (/android|picobrowser/i.test(i)) return !1;
        let e = document.createElement("video"), t = e.canPlayType("application/vnd.apple.mpegURL") !== "";
        return e.remove(), t;
    },
    name: $299b6c40adc500b8$var$Bu
});
var $299b6c40adc500b8$var$qu = "NativeFile", $299b6c40adc500b8$var$Fs = class i extends $299b6c40adc500b8$var$Pi {
    static parseVRBUrl(e) {
        if (!e.startsWith("mask://")) return {
            mainUrl: e
        };
        let t = [
            ...e.matchAll(/mask:\/\/(.*?)\+(.*)?/gi)
        ][0], r = decodeURIComponent(t[1]), n1 = t.length > 2 ? decodeURIComponent(t[2]) : void 0;
        return {
            mainUrl: r,
            maskUrl: n1
        };
    }
    get name() {
        return $299b6c40adc500b8$var$qu;
    }
    get includeMask() {
        return super.includeMask;
    }
    set includeMask(e) {
        e !== this.includeMask && (super.includeMask = e, this.requestStartRenderThread());
    }
    async setSource(e) {
        this._videoConfig = null;
        let t = i.parseVRBUrl(e);
        this.video.src = t.mainUrl, t.maskUrl && (this.maskVideo.src = t.maskUrl);
    }
    async initPlayer() {
        await super.initPlayer(), this.streamType = (0, $jW02B.StreamType).ON_DEMAND, this.includeMask && await this.startRenderThread();
    }
    getRendererConfig() {
        let e = super.getRendererConfig();
        return this.videoTrackNumber > 1 && (e[1].supplementaryData = {
            isVRB: !0
        }), e;
    }
    async seekInternal(e) {
        let t = this.video.paused && this.maskVideo.paused;
        t || (this.video.pause(), this.maskVideo.pause()), await (0, $jW02B.waitUntilAsync)(()=>this.video.paused && this.maskVideo.paused), await super.seekInternal(e), t || (await this.performVideoAction(async (r)=>await r.play(), (r)=>!!r.src), await (0, $jW02B.waitUntilAsync)(()=>!this.video.paused && (this.videoTrackNumber <= 1 || !this.maskVideo.paused) && this.status !== (0, $jW02B.Status).WAIT_FOR_BUFFER));
    }
    async testUri(e) {
        let t = (n1, s = 0)=>n1[s] << 24 | n1[s + 1] << 16 | n1[s + 2] << 8 | n1[s + 3], r = (n1, s = 0)=>String.fromCharCode(n1[s + 4], n1[s + 5], n1[s + 6], n1[s + 7]);
        this.capabilitiesChecker.clear();
        try {
            let s = (await fetch(e, this.requestInit)).body?.getReader(), o = !1, d = new Uint8Array, u = !1, m = !1, f = 0, g = 0;
            for(; !o;){
                let v = await s?.read();
                if (o = v?.done ?? !0, v?.value) {
                    let E = d.length;
                    if (d = new Uint8Array(E + v.value.length), d.set(d), d.set(v.value, E), !u && d.length >= 8 && (u = r(d) === "ftyp", f = t(d), g += f, u && d.length >= g + 8 && r(d, g) === "free" && (g += t(d, f))), u && !m && d.length >= g + 8) {
                        let R = r(d, g);
                        if (R === "mdat") {
                            o = !0, this.abortController.abort();
                            break;
                        }
                        m = R === "moov", g += t(d, f);
                    }
                    m && d.length >= g && (o = !0, this.abortController.abort());
                }
            }
            m && this.capabilitiesChecker.setHeader(d);
        } catch  {} finally{
            if (!this.capabilitiesChecker.hasHeader) {
                let s = {
                    type: (0, $jW02B.BuiltInTrackTypes).Video,
                    codec: "",
                    bitrate: 1e4,
                    contentType: "video/mp4",
                    framerate: 50,
                    height: 1920,
                    width: 1080,
                    id: 1
                }, o = [
                    s
                ], d = {
                    type: (0, $jW02B.BuiltInTrackTypes).Audio,
                    codec: "",
                    numberOfChannels: 1,
                    sampleRate: 48e3,
                    contentType: "audio/aac",
                    id: 2
                };
                return {
                    isSupported: !0,
                    config: {
                        video: s,
                        videoTracks: o,
                        audio: d,
                        audioTracks: [
                            d
                        ],
                        tracks: [
                            ...o,
                            d
                        ].sort((u, m)=>u.id - m.id),
                        mimeType: "video/mp4",
                        codecs: "",
                        type: "file"
                    }
                };
            }
            let n1 = await this.capabilitiesChecker.checkCapability((0, $jW02B.CapabilityCheck).MediaSource, (0, $jW02B.CapabilityCheck).Video, (0, $jW02B.CapabilityCheck).MediaCapabilitiesFile);
            return this.capabilitiesChecker.clear(), n1;
        }
    }
    async testSrc(e) {
        let t = i.parseVRBUrl(e);
        try {
            this.capabilitiesChecker.clear();
            let r = await this.testUri(t.mainUrl);
            if (r.isSupported && r.config) {
                if (t.maskUrl) {
                    let n1 = await this.testUri(t.maskUrl);
                    n1.isSupported && n1.config && (n1.config.videoTracks && r.config.videoTracks?.push(...n1.config.videoTracks), r.config.codecs += n1.config.codecs, r.config.mimeType = `video/mp4; codecs="${r.config.codecs}"`);
                }
                this._videoConfig = r.config;
            } else await this.stopWithError(`Start playing error: ${new Error(`Unsupported media format: "${r.config?.mimeType}" ${r.config?.video?.width}x${r.config?.video?.height}@${r.config?.video?.framerate}`)}.`, (0, $jW02B.Errors).UNSUPPORTED_MEDIA_FORMAT);
        } catch  {
            return !1;
        }
        return !0;
    }
};
$299b6c40adc500b8$var$be.Register({
    urlTest: async (i)=>{
        if (!i.startsWith("mask") && !i.startsWith("http")) return !1;
        let e = $299b6c40adc500b8$var$Fs.parseVRBUrl(i), t = "video/", r = "application/octet-stream", n1 = !0, s = await (0, $jW02B.getContentType)(e.mainUrl);
        if (!s.startsWith(t) && s !== r) return !1;
        let o = document.createElement("video");
        if (s != r && (n1 = n1 && o.canPlayType(s) !== ""), n1 && e.maskUrl) {
            let d = await (0, $jW02B.getContentType)(e.maskUrl);
            if (!d.startsWith(t) && d !== r) return !1;
            d != r && (n1 = n1 && o.canPlayType(d) !== "");
        }
        return o.remove(), n1;
    },
    ctor: $299b6c40adc500b8$var$Fs,
    isSupported: ()=>!0,
    name: $299b6c40adc500b8$var$qu
});
var $299b6c40adc500b8$var$Bs = class i extends (0, (/*@__PURE__*/$parcel$interopDefault($jOCUE))) {
    static SHORT_BREAK_MS = 300;
    static NORMAL_BREAK_MS = 800;
    static LONG_BREAK_MS = 1e3;
    static PLAYER_ERROR_TO_BREAK_MAP = {
        [(0, $jW02B.Errors).CONNECTION_ERROR]: i.SHORT_BREAK_MS,
        [(0, $jW02B.Errors).CONNECTION_CLOSED]: i.SHORT_BREAK_MS,
        [(0, $jW02B.Errors).STREAM_NOT_FOUND]: i.NORMAL_BREAK_MS,
        [(0, $jW02B.Errors).STREAM_ENDED]: i.NORMAL_BREAK_MS,
        [(0, $jW02B.Errors).CONNECTION_TIMEOUT]: i.SHORT_BREAK_MS,
        [(0, $jW02B.Errors).UNSUPPORTED_MEDIA_FORMAT]: "UNSUPPORTED_MEDIA_FORMAT",
        [(0, $jW02B.Errors).BUFFER_ERROR]: i.SHORT_BREAK_MS,
        [(0, $jW02B.Errors).START_PLAYING]: i.LONG_BREAK_MS,
        [(0, $jW02B.Errors).START_PLAYING_NOT_ALLOWED]: "START_PLAYING_NOT_ALLOWED",
        [(0, $jW02B.Errors).START_PLAYING_NOT_SUPPORTED]: i.LONG_BREAK_MS,
        [(0, $jW02B.Errors).WRONG_URL]: i.LONG_BREAK_MS,
        [(0, $jW02B.Errors).UNKNOWN_ERROR]: i.LONG_BREAK_MS,
        [(0, $jW02B.Errors).CRITICAL_CONNECTION_ERROR]: "CRITICAL_TIMEOUT",
        [(0, $jW02B.Errors).UNAUTHORIZED]: "UNAUTHORIZED"
    };
    static _nextPlayerId = 0;
    _video;
    _maskVideo;
    _img;
    _canvas;
    _transferredCanvas;
    _connectionTimeout = void 0;
    _playerId;
    _videoTracks = new $299b6c40adc500b8$export$a4240145594c03e8;
    _requestedEngines = [
        "MSE/DedicatedWorker",
        "MSE/MainThread",
        "NativeHLS",
        "NativeFile"
    ];
    _opLock = new (0, $jW02B.Mutex);
    _engine = null;
    _state = null;
    _restartPlayingHandler = null;
    _criticalTimeoutHandler = null;
    _lastError = null;
    _currentSrc = null;
    _playerIndex = 0;
    _token = "";
    _ended = !1;
    _includeMask = !1;
    _muted = !1;
    _loop = !1;
    _volume = 1;
    _sinkId = null;
    _crossOrigin = "";
    _lowLatency = !1;
    _externalRenderer = !1;
    _stallSlidingWindow = null;
    _stallWindowDuration = 1e4;
    _stallWindowMaxEvents = 5;
    _fmp4ProtocolVersion = (0, $jW02B.FMP4ProtocolVersion).V4;
    get supportedEngines() {
        return $299b6c40adc500b8$var$be.SupportedEngines;
    }
    get allEngines() {
        return $299b6c40adc500b8$var$be.AllEngines;
    }
    get enabledEngines() {
        return this.allEngines.filter((e)=>this.requestedEngines.length === 0 || this.requestedEngines.includes(e));
    }
    get usedEngines() {
        return this.supportedEngines.filter((e)=>this.enabledEngines.includes(e)).sort((e, t)=>this.requestedEngines.indexOf(e) - this.requestedEngines.indexOf(t));
    }
    get requestedEngines() {
        return this._requestedEngines;
    }
    set requestedEngines(e) {
        this._requestedEngines.length = 0, this._requestedEngines.push(...e);
    }
    get currentEngine() {
        return this._engine?.fullName ?? "None";
    }
    get playerId() {
        return this._playerId;
    }
    get buffer() {
        return this._engine === null ? null : this._engine.buffer;
    }
    get buffered() {
        return this._engine === null ? {
            start: ()=>{
                throw new DOMException("Index out of bounds", "IndexSizeError");
            },
            end: ()=>{
                throw new DOMException("Index out of bounds", "IndexSizeError");
            },
            length: 0
        } : this._engine.buffered;
    }
    get position() {
        return this._engine === null || Number.isNaN(this._engine.position) ? 0 : this._engine.position;
    }
    get duration() {
        return this._engine === null || Number.isNaN(this._engine.duration) ? 1 / 0 : this._engine.duration;
    }
    get muted() {
        return this._muted;
    }
    set muted(e) {
        this._muted !== e && (this._muted = e, this._engine && (this._engine.muted = e));
    }
    get loop() {
        return this._loop;
    }
    set loop(e) {
        this._loop !== e && (this._loop = e, this._engine && (this._engine.loop = e));
    }
    get lowLatency() {
        return this._lowLatency;
    }
    set lowLatency(e) {
        this._lowLatency !== e && (this._lowLatency = e, this._engine && (this._engine.lowLatency = e));
    }
    get volume() {
        return this._volume;
    }
    set volume(e) {
        e !== this._volume && (this._volume = e, this._engine && (this._engine.volume = e));
    }
    get state() {
        return this._engine === null ? "STOPPED" : this._state ?? "STOPPED";
    }
    get readyState() {
        return this._engine?.readyState ?? HTMLMediaElement.HAVE_NOTHING;
    }
    get streamType() {
        if (this._engine === null) return "unknown";
        switch(this._engine.streamType){
            case (0, $jW02B.StreamType).UNKNOWN:
                return "unknown";
            case (0, $jW02B.StreamType).LIVE:
                return "live";
            case (0, $jW02B.StreamType).ON_DEMAND:
                return "on-demand";
        }
    }
    get currentUrl() {
        return this._currentSrc ?? "";
    }
    get displayElement() {
        return this._engine?.displayElement ?? null;
    }
    get texture() {
        return this.displayElement;
    }
    get videoWidth() {
        return this._engine?.videoWidth ?? 0;
    }
    get videoHeight() {
        return this._engine?.videoHeight ?? 0;
    }
    get renderingWidth() {
        return this._engine?.renderingWidth ?? 0;
    }
    get renderingHeight() {
        return this._engine?.renderingHeight ?? 0;
    }
    get ended() {
        return this._ended;
    }
    set token(e) {
        this._token = e, this._engine && (this._engine.token = e);
    }
    set includeMask(e) {
        this._includeMask !== e && (this._includeMask = e, this._engine && (this._engine.includeMask = e), this.videoTracks.length > 0 && (this.videoTracks.selected = this.videoTracks.getTrackById(e ? "with_mask" : "default")));
    }
    get includeMask() {
        return this._includeMask;
    }
    get videoTracks() {
        return this._videoTracks;
    }
    get connectionTimeout() {
        return this._connectionTimeout;
    }
    set connectionTimeout(e) {
        this._connectionTimeout !== e && (this._connectionTimeout = e, this._state !== "STOPPED" && this.currentUrl && this.playInternal(this.currentUrl, this.position));
    }
    get crossOrigin() {
        return this._crossOrigin;
    }
    set crossOrigin(e) {
        this._crossOrigin !== e && (this._engine && (this._engine.crossOrigin = e), this._crossOrigin = e);
    }
    get externalRenderer() {
        return this._externalRenderer;
    }
    set externalRenderer(e) {
        this.externalRenderer !== e && (this._externalRenderer = e, this._engine && (this._engine.externalRenderer = e));
    }
    get stallWindow() {
        return this._stallWindowDuration;
    }
    set stallWindow(e) {
        this.stallWindow !== e && (this._stallWindowDuration = e, this._stallSlidingWindow?.clear(), this._stallSlidingWindow = new (0, $jW02B.SlidingWindow)(this.stallWindow, this.maxStallEvents));
    }
    get maxStallEvents() {
        return this._stallWindowMaxEvents;
    }
    set maxStallEvents(e) {
        this._stallWindowMaxEvents !== e && (this._stallWindowMaxEvents = e, this._stallSlidingWindow?.clear(), this._stallSlidingWindow = new (0, $jW02B.SlidingWindow)(this.stallWindow, this.maxStallEvents));
    }
    get fmp4ProtocolVersion() {
        return this._fmp4ProtocolVersion;
    }
    set fmp4ProtocolVersion(e) {
        this._fmp4ProtocolVersion !== e && (this._fmp4ProtocolVersion = e, this._engine && (this._engine.fmp4ProtocolVersion = e));
    }
    constructor(e, t, r, n1, s){
        super(), this._video = e, this._maskVideo = t, this._img = r, this._canvas = n1, this._transferredCanvas = s.transferControlToOffscreen !== void 0 ? s.transferControlToOffscreen() : null, this._playerId = i._nextPlayerId++;
    }
    async play(e) {
        await this.stopInternal();
        let t = this._lastError?.data?.position;
        this._lastError = null, this._playerIndex = 0, await this.playInternal(e, this._currentSrc === e ? t : void 0);
    }
    async resume() {
        this._engine !== null && this.state === "PAUSED" && await this._engine.resume();
    }
    async pause() {
        this._engine !== null && await this._engine.pause();
    }
    async togglePause() {
        this._engine !== null && (this.state === "PAUSED" ? await this._engine.resume() : await this._engine.pause());
    }
    toggleMute() {
        this.muted = !this.muted;
    }
    async seek(e) {
        this._engine?.seek(e);
    }
    async stop() {
        this.clear(), await this.stopInternal(), this._currentSrc = null, this._lastError = null, this._playerIndex = 0;
    }
    async clear() {
        await this._engine?.clear();
    }
    async dispose() {
        await this.stopInternal(!0), this._currentSrc = null, this._lastError = null, this._playerIndex = 0, this.removeAllListeners();
    }
    canPlayType(e) {
        return this._video.canPlayType(e);
    }
    async load() {
        await this.stop();
    }
    async setSinkId(e) {
        this._sinkId !== e && (this._sinkId = e, this._engine && this._engine.setSinkId(e));
    }
    render() {
        this._engine?.render();
    }
    async playInternal(e, t) {
        if (await this._opLock.lockAsync(), this._engine === null && (this._engine = await $299b6c40adc500b8$var$be.Create(this._playerId, e, this._video, this._maskVideo, this._img, this._canvas, this._transferredCanvas, this.requestedEngines, this._playerIndex)), this.videoTracks.clear(), this._currentSrc = e, this._engine === null) {
            this._opLock.unlock(), await this.onEngineError(this._lastError?.message ?? "Failed to create a player", this._lastError?.error ?? (0, $jW02B.Errors).UNSUPPORTED_MEDIA_FORMAT, this._lastError?.data ?? {
                position: 0,
                duration: 0,
                state: (0, $jW02B.Status).STOPPED
            }, this._lastError?.engine, this._lastError?.lastStreamType, this._lastError?.videoConfig);
            return;
        }
        this._engine.muted = this.muted, this._engine.volume = this.volume, this._engine.loop = this.loop, this._engine.crossOrigin = this.crossOrigin, this._engine.lowLatency = this.lowLatency, this._sinkId && this._engine.setSinkId(this._sinkId), this._stallSlidingWindow?.clear(), this._stallSlidingWindow = new (0, $jW02B.SlidingWindow)(this.stallWindow, this.maxStallEvents), this._engine.on((0, $jW02B.Events).STATUS_CHANGED, this.onEngineStatusChanged), this._engine.on((0, $jW02B.Events).ERROR, this.onEngineError), this._engine.on((0, $jW02B.Events).TIME_UPDATE, ()=>this.emit("TIME_UPDATE")), this._engine.on((0, $jW02B.Events).TIME_UPDATE, this.checkStallWindow), this._engine.on((0, $jW02B.Events).DURATION_CHANGE, ()=>this.emit("DURATION_CHANGE")), this._engine.on((0, $jW02B.Events).FRAME_READY, ()=>this.emit("FRAME_READY", this.texture)), this._engine.on((0, $jW02B.Events).LOADED_METADATA, this.onEngineLoadedMetadata), this._engine.on((0, $jW02B.Events).LOADED_DATA, ()=>this.emit("LOADED_DATA")), this._engine.on((0, $jW02B.Events).INVALID_PASSTHROUGH_TOKEN, this.onPassthroughTokenInvalid), this._engine.on((0, $jW02B.Events).STREAM_TYPE_CHANGE, ()=>this.emit("STREAM_TYPE_CHANGE")), this._engine.on((0, $jW02B.Events).PROGRESS, ()=>this.emit("PROGRESS")), this._engine.on((0, $jW02B.Events).ENDED, ()=>{
            this._ended = !0, this.emit("ENDED");
        }), this._engine.on((0, $jW02B.Events).CAN_PLAY, ()=>this.emit("CAN_PLAY")), this._engine.on((0, $jW02B.Events).PLAY, ()=>{
            this._ended = !1, this.emit("PLAY");
        }), this._engine.token = this._token, this._engine.includeMask = this._includeMask, this._engine.externalRenderer = this.externalRenderer, this._engine.fmp4ProtocolVersion = this.fmp4ProtocolVersion, await this._engine.play(e, this._connectionTimeout), t !== void 0 && Number.isFinite(t) && t > 0 && await this.seek(t), this._opLock.unlock();
    }
    async stopInternal(e = !1) {
        await this._opLock.lockAsync(), this.resetCriticalTimeout(), this._engine !== null && (await this._engine.stop(), this._engine?.removeAllListeners(), await this._engine?.dispose(e), this._engine = null, this.videoTracks.clear(), this.emit("TIME_UPDATE"), this.emit("DURATION_CHANGE"), this.emit("STREAM_TYPE_CHANGE")), this._state = null, this._opLock.unlock();
    }
    async raiseError(e, t, r, n1, s, o) {
        this.emitError(e, t, r, n1, s, o), await this.stopInternal(), this._playerIndex = 0;
    }
    resetCriticalTimeout() {
        this._criticalTimeoutHandler && (clearTimeout(this._criticalTimeoutHandler), this._criticalTimeoutHandler = null);
    }
    changeState(e) {
        if (e !== this._state) {
            if (this._state === "PREPARING" && e === "STALLING") return;
            let t = this._state;
            this._state === null && e !== "PLAYING" ? this._state = "PREPARING" : this._state = e, this.emit("STATE_CHANGED", {
                newState: this._state ?? "STOPPED",
                previousState: t ?? "STOPPED"
            }), e === "STALLING" && this._stallSlidingWindow?.trigger();
        }
    }
    getState(e) {
        switch(e){
            case (0, $jW02B.Status).PAUSED:
                return "PAUSED";
            case (0, $jW02B.Status).PLAYING:
                return "PLAYING";
            case (0, $jW02B.Status).STOPPED:
                return "STOPPED";
            default:
                return "STALLING";
        }
    }
    onEngineStatusChanged = (e)=>{
        (e === (0, $jW02B.Status).PLAYING || e === (0, $jW02B.Status).STARTING_PLAYING || e === (0, $jW02B.Status).PAUSED) && this.resetCriticalTimeout(), this.changeState(this.getState(e));
    };
    makeMsg(e) {
        return `[${this.currentEngine} Player] ` + e;
    }
    makeErrorData(e, t, r, n1, s, o) {
        return {
            error: e,
            message: t,
            engine: r ?? this._lastError?.engine ?? this.currentEngine,
            lastUrl: this.currentUrl,
            lastTimestamp: o?.position ?? this._lastError?.data.position ?? this.position,
            lastDuration: o?.duration ?? this._lastError?.data.duration ?? this.duration,
            lastStreamType: n1 ?? this._lastError?.lastStreamType ?? this.streamType,
            lastPlayerState: o ? this.getState(o.state) : this._lastError?.data ? this.getState(this._lastError.data.state) : this.state,
            videoConfig: s ?? this._lastError?.videoConfig ?? this._engine?.videoConfig ?? null,
            enabledEngines: this.enabledEngines,
            supportedEngines: this.supportedEngines,
            usedEngines: this.usedEngines
        };
    }
    onEngineLoadedMetadata = (e)=>{
        this.videoTracks.clear();
        let t = [
            {
                id: "default",
                kind: "main",
                label: "Main",
                language: "",
                selected: !(e && this.includeMask)
            }
        ];
        e && t.push({
            id: "with_mask",
            kind: "alternative",
            label: "Passthrough",
            language: "",
            selected: e && this.includeMask
        }), this.videoTracks.push(...t), this.emit("LOADED_METADATA");
    };
    onPassthroughTokenInvalid = ()=>{
        this.emit("INVALID_PASSTHROUGH_TOKEN"), this.includeMask = !1;
    };
    checkStallWindow = ()=>{
        this._stallSlidingWindow?.update() === !1 && (this._stallSlidingWindow.clear(), this.emitWarning("FREQUENT_STALLS", "Stalls exceeded maximum.", this.currentEngine));
    };
    onEngineError = async (e, t, r, n1, s, o)=>{
        let d = i.PLAYER_ERROR_TO_BREAK_MAP[t];
        if (this._state = null, this._lastError === null && (this._lastError = {
            error: t,
            message: e,
            engine: n1 ?? this.currentEngine,
            lastStreamType: s ?? this.streamType,
            videoConfig: o ?? this._engine?.videoConfig ?? null,
            data: r
        }), !d) await this.raiseError("UNHANDLED_PLAYER_ERROR", `Unknown player error: ${e} (${t})`, n1, s, o, r);
        else if (typeof d == "number") this.scheduleRestarting(d), this.scheduleCriticalTimeout(), this.emitWarning(t, e, n1, s, o, r);
        else {
            let u = d;
            this._playerIndex < this.usedEngines.length - 1 ? (this.emitWarning(u, e, n1, s, o, r), await this.stopInternal(), this._playerIndex++, await this.playInternal(this.currentUrl, r.position)) : await this.raiseError(u, e, n1, s, o, this._lastError?.data ?? r);
        }
    };
    scheduleCriticalTimeout() {
        this._criticalTimeoutHandler === null && (this._criticalTimeoutHandler = setTimeout(()=>{
            this.emitWarning("CRITICAL_TIMEOUT", "Cannot start playing", this.currentEngine), this.scheduleRestarting(i.LONG_BREAK_MS), this.scheduleCriticalTimeout();
        }, this._connectionTimeout));
    }
    emitError(e, t, r, n1, s, o) {
        this.emit("ERROR", e, this.makeMsg(t), this.makeErrorData(e, t, r, n1, s, o));
    }
    emitWarning(e, t, r, n1, s, o) {
        this.emit("WARNING", e, this.makeMsg(t), this.makeErrorData(e, t, r, n1, s, o));
    }
    scheduleRestarting(e) {
        this._restartPlayingHandler === null && (this._restartPlayingHandler = setTimeout(async ()=>{
            this._engine !== null && this.currentUrl !== "" && (URL.canParse === void 0 || URL.canParse(this.currentUrl)) && await this._engine.play(this.currentUrl, this._connectionTimeout), this._restartPlayingHandler = null;
        }, e));
    }
};
var $299b6c40adc500b8$var$$r = class i extends $299b6c40adc500b8$var$Et {
    static _templateString = `
        <style>
            :host {
                display: block;
                background-color: transparent;
            }
            :host([hidden]) {
                display: none;
            }
            #video, #maskVideo, #img, #canvas, #offscreencanvas, #posterImage {
                width: 100%;
                height: 100%
            }
        </style>
        <video id="video" preload="none" oncontextmenu="return false;" playsinline disablepictureinpicture hidden></video>
        <video id="maskVideo" preload="none" oncontextmenu="return false;" playsinline disablepictureinpicture hidden muted></video>
        <canvas id="img" oncontextmenu="return false;" hidden></canvas>
        <canvas id="canvas" oncontextmenu="return false;" hidden></canvas>
        <canvas id="offscreencanvas" oncontextmenu="return false;" hidden></canvas>
        <img id="posterImage" oncontextmenu="return false;" hidden></canvas>
        `;
    static _template = null;
    static get template() {
        return this._template !== null ? this._template : (this._template = document.createElement("template"), this._template.innerHTML = this._templateString, this._template);
    }
    _eventHandlers = new Map;
    _player;
    _videoFrameCallbackHandle = 0;
    _videoFrameCallbackAbortController = null;
    _error = null;
    _seeking = !1;
    _video = null;
    _maskVideo = null;
    _img = null;
    _canvas = null;
    _offscreenCanvas = null;
    _posterImage = null;
    _sinkId = null;
    _pipWindow = null;
    get video() {
        return this._video === null && (this._video = this.shadowRoot?.getElementById("video")), this._video;
    }
    get maskVideo() {
        return this._maskVideo === null && (this._maskVideo = this.shadowRoot?.getElementById("maskVideo")), this._maskVideo;
    }
    get img() {
        return this._img === null && (this._img = this.shadowRoot?.getElementById("img")), this._img;
    }
    get canvas() {
        return this._canvas === null && (this._canvas = this.shadowRoot?.getElementById("canvas")), this._canvas;
    }
    get offscreenCanvas() {
        return this._offscreenCanvas === null && (this._offscreenCanvas = this.shadowRoot?.getElementById("offscreencanvas")), this._offscreenCanvas;
    }
    get posterImage() {
        return this._posterImage === null && (this._posterImage = this.shadowRoot?.getElementById("posterImage")), this._posterImage;
    }
    get displayElements() {
        return [
            this.video,
            this.img,
            this.canvas,
            this.offscreenCanvas,
            this.posterImage
        ];
    }
    get displayElement() {
        return this._player.displayElement ?? (this.posterImage.src ? this.posterImage : null);
    }
    set autoplayInternal(e) {
        this.autoplay && this.src !== "" && this.state === "STOPPED" && this._player.play(this.src);
    }
    set controlsInternal(e) {}
    get currentSrc() {
        return this._player.currentUrl;
    }
    get ended() {
        return this._player.ended;
    }
    set widthInternal(e) {
        this.video.width = e, this.maskVideo.width = e, this.img.width = e, this.canvas.width = e, this.posterImage.width = e;
    }
    set heightInternal(e) {
        this.video.height = e, this.maskVideo.height = e, this.img.height = e, this.canvas.height = e, this.canvas.height = e;
    }
    set disablePictureInPictureInternal(e) {}
    set srcInternal(e) {
        e !== this._player.currentUrl && (this.src === "" ? this._player.stop() : this.autoplay && this._player.play(this.src));
    }
    set lowLatencyInternal(e) {
        this._player.lowLatency = e;
    }
    set mutedInternal(e) {
        this._player.muted = e, this.emit("VOLUME_CHANGE");
    }
    set volumeInternal(e) {
        this._player.volume = e, this.emit("VOLUME_CHANGE");
    }
    set loopInternal(e) {
        this._player.loop = e;
    }
    set tokenInternal(e) {
        this._player.token = e;
    }
    set includeMaskInternal(e) {
        this._player.includeMask = e;
    }
    set enginesListInternal(e) {
        this._player.requestedEngines = e.split(" "), this.emit("ENGINES_CHANGE");
    }
    set connectionTimeoutInternal(e) {
        this._player.connectionTimeout = e;
    }
    set playsInlineInternal(e) {
        e ? (this.video.setAttribute("playsinline", ""), this.maskVideo.setAttribute("playsinline", "")) : (this.video.removeAttribute("playsinline"), this.maskVideo.removeAttribute("playsinline"));
    }
    get state() {
        return this._player.state;
    }
    get currentEngine() {
        return this._player.currentEngine;
    }
    get playerId() {
        return this._player.playerId;
    }
    get currentTime() {
        return this._player.position;
    }
    set currentTime(e) {
        this.seek(e);
    }
    get duration() {
        return this._player.duration;
    }
    get paused() {
        return this.state === "PAUSED";
    }
    get buffered() {
        return this._player.buffered;
    }
    get played() {
        return this.streamType === "on-demand" ? {
            start: ()=>0,
            end: ()=>this.currentTime,
            length: 1
        } : {
            start: ()=>this.buffered.start(0),
            end: ()=>this.currentTime,
            length: 1
        };
    }
    get seekable() {
        return this.streamType === "on-demand" ? {
            start: ()=>0,
            end: ()=>this.duration,
            length: 1
        } : this.buffered;
    }
    get texture() {
        return this._player.texture;
    }
    get videoWidth() {
        return this._player.videoWidth;
    }
    get videoHeight() {
        return this._player.videoHeight;
    }
    get renderingWidth() {
        return this._player.renderingWidth;
    }
    get renderingHeight() {
        return this._player.renderingHeight;
    }
    get readyState() {
        return this._player.readyState;
    }
    set posterInternal(e) {
        e ? this.posterImage.src = e : this.posterImage.removeAttribute("src"), this.updateDisplay();
    }
    set crossOriginInternal(e) {
        this._player.crossOrigin = e, e !== "" ? (this.video.crossOrigin = e, this.maskVideo.crossOrigin = e) : (this.video.removeAttribute("crossorigin"), this.maskVideo.removeAttribute("crossorigin"));
    }
    get streamType() {
        return this._player.streamType;
    }
    get videoTracks() {
        return this._player.videoTracks;
    }
    get allEngines() {
        return this._player.allEngines;
    }
    get enabledEngines() {
        return this._player.enabledEngines;
    }
    get supportedEngines() {
        return this._player.supportedEngines;
    }
    get usedEngines() {
        return this._player.usedEngines;
    }
    get error() {
        return this._error;
    }
    get seeking() {
        return this._seeking;
    }
    get textTracks() {
        return this.video.textTracks;
    }
    get remote() {
        return this.video.remote;
    }
    get sinkId() {
        return this._sinkId ?? "";
    }
    get mediaKeys() {
        return this.video.mediaKeys;
    }
    get preservesPitch() {
        return this.video.preservesPitch;
    }
    set preservesPitch(e) {
        this.video.preservesPitch !== e && (this.video.preservesPitch = e);
    }
    set externalRendererInternal(e) {
        this._player.externalRenderer = e;
    }
    set stallWindowInternal(e) {
        this._player.stallWindow = e;
    }
    set maxStallEventsInternal(e) {
        this._player.maxStallEvents = e;
    }
    set fmp4ProtocolVersionInternal(e) {
        this._player.fmp4ProtocolVersion = e;
    }
    constructor(){
        super(), this.shadowRoot?.appendChild(i.template.content.cloneNode(!0)), this._player = new $299b6c40adc500b8$var$Bs(this.video, this.maskVideo, this.img, this.canvas, this.offscreenCanvas);
    }
    connectedCallback() {
        super.connectedCallback(), this._player.addListener("STATE_CHANGED", this.getEventHandler("STATE_CHANGED", CustomEvent, this.makeEventArgs)), this._player.addListener("WARNING", this.getEventHandler("WARNING", CustomEvent, this.makeErrorEventArgs)), this._player.addListener("ERROR", this.onError), this._player.addListener("ERROR", this.getEventHandler("ERROR", $299b6c40adc500b8$export$73095185aa19db6b, this.makeErrorEventArgs)), this._player.addListener("TIME_UPDATE", this.getEventHandler("TIME_UPDATE", CustomEvent, this.makeEventArgs)), this._player.addListener("DURATION_CHANGE", this.getEventHandler("DURATION_CHANGE", CustomEvent, this.makeEventArgs)), this._player.addListener("FRAME_READY", this.getEventHandler("FRAME_READY", CustomEvent, this.makeEventArgs)), this._player.addListener("FRAME_READY", ()=>this.updateDisplay()), this._player.addListener("LOADED_METADATA", this.getEventHandler("LOADED_METADATA", CustomEvent, this.makeEventArgs)), this._player.addListener("LOADED_DATA", this.getEventHandler("LOADED_DATA", CustomEvent, this.makeEventArgs)), this._player.addListener("CAN_PLAY", this.getEventHandler("CAN_PLAY", CustomEvent, this.makeEventArgs)), this._player.addListener("PLAY", this.getEventHandler("PLAY", CustomEvent, this.makeEventArgs)), this._player.addListener("STATE_CHANGED", (e)=>this.onStateChanged(e.newState, e.previousState)), this._player.addListener("INVALID_PASSTHROUGH_TOKEN", this.getEventHandler("INVALID_PASSTHROUGH_TOKEN", CustomEvent, this.makeEventArgs)), this._player.addListener("MASK_DECODING_ERROR", this.getEventHandler("MASK_DECODING_ERROR", CustomEvent, this.makeEventArgs)), this._player.addListener("STREAM_TYPE_CHANGE", this.getEventHandler("STREAM_TYPE_CHANGE", CustomEvent, this.makeEventArgs)), this._player.addListener("PROGRESS", this.getEventHandler("PROGRESS", ProgressEvent, this.makeEventArgs)), this._player.addListener("ENDED", this.getEventHandler("ENDED", CustomEvent, this.makeEventArgs)), this.videoTracks.addEventListener("addtrack", this.getEventHandler("ADD_VIDEO_TRACK", CustomEvent, this.makeEventArgs)), this.videoTracks.addEventListener("removetrack", this.getEventHandler("REMOVE_VIDEO_TRACK", CustomEvent, this.makeEventArgs)), this.videoTracks.addEventListener("change", this.getEventHandler("VIDEO_TRACK_CHANGE", CustomEvent, this.makeEventArgs)), this.posterImage.addEventListener("error", (e)=>{
            (0, $jW02B.LogInternal).warn("Failed to set poster", e);
        }), this.video.addEventListener("resize", ()=>this.emit("RESIZE"));
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this._player.removeAllListeners(), this.videoTracks.removeEventListener("addtrack", this.getEventHandler("ADD_VIDEO_TRACK", CustomEvent, this.makeEventArgs)), this.videoTracks.removeEventListener("removetrack", this.getEventHandler("REMOVE_VIDEO_TRACK", CustomEvent, this.makeEventArgs)), this.videoTracks.removeEventListener("change", this.getEventHandler("VIDEO_TRACK_CHANGE", CustomEvent, this.makeEventArgs)), this.posterImage.removeEventListener("error", (e)=>{
            (0, $jW02B.LogInternal).warn("Failed to set poster", e);
        }), this.video.removeEventListener("resize", ()=>this.emit("RESIZE"));
    }
    async play() {
        this._seeking = !1, this._player.state === "PAUSED" && this.currentSrc == this.src ? await this._player.resume() : this.src !== null && await this._player.play(this.src);
    }
    async stop() {
        this._seeking = !1, await this._player.stop(), this.updateDisplay();
    }
    async togglePause() {
        await this._player.togglePause();
    }
    async seek(e) {
        this._seeking = !0, this.emit("SEEKING"), await this._player.seek(e), this._seeking = !1, this.emit("SEEKED");
    }
    async pause() {
        await this._player.pause();
    }
    async requestPictureInPicture() {
        if (this.disablePictureInPicture === !0) throw new DOMException("Picture-in-picture is disabled", "InvalidStateError");
        if (!("documentPictureInPicture" in window)) throw new DOMException("Document Picture-in-Picture API is not supported", "InvalidStateError");
        let e = this.videoWidth > 0 && this.videoHeight > 0 ? this.videoWidth / this.videoHeight : window.screen.width / window.screen.height, t = window.screen.height / 5, r = e * t;
        this._pipWindow = await window.documentPictureInPicture.requestWindow({
            width: r,
            height: t
        }), [
            ...document.styleSheets
        ].forEach((m)=>{
            try {
                let f = [
                    ...m.cssRules
                ].map((v)=>v.cssText).join(""), g = document.createElement("style");
                g.textContent = f, this._pipWindow?.document.head.appendChild(g);
            } catch  {
                let g = document.createElement("link");
                g.rel = "stylesheet", g.type = m.type, g.media = m.media, g.href = m.href, this._pipWindow?.document.head.appendChild(g);
            }
        }), this._pipWindow && (this._pipWindow.document.body.style = "margin: 0; overflow: hidden; scrollbar-width: 0");
        let n1 = this.parentElement, s = n1.parentNode, o = s.querySelector("#media-controller-pip"), d = s.querySelector("#media-controller-main"), u = s.getElementById("player_style");
        if (u) {
            let m = u.cloneNode(!0);
            this._pipWindow?.document.head.appendChild(m);
        }
        return this._pipWindow?.document.body.append(o), o.appendChild(this), o.removeAttribute("hidden"), d.setAttribute("hidden", ""), this._pipWindow?.addEventListener("pagehide", ()=>{
            n1.append(this), o.setAttribute("hidden", ""), d.removeAttribute("hidden"), s.appendChild(o);
            let m = new Event("leavepictureinpicture", {
                bubbles: !0,
                composed: !0
            });
            this.dispatchEvent(m), this.onleavepictureinpicture && this.onleavepictureinpicture(m);
        }), this._pipWindow;
    }
    exitPictureInPicture() {
        this._pipWindow?.close(), this._pipWindow = null;
    }
    canPlayType(e) {
        return this._player.canPlayType(e);
    }
    async load() {
        await this._player.load();
    }
    requestVideoFrameCallback(e) {
        return this._videoFrameCallbackAbortController = new AbortController, this._videoFrameCallbackAbortController.handle = this._videoFrameCallbackHandle++, this._player.once("FRAME_READY", ()=>{
            (this._videoFrameCallbackAbortController === null || !this._videoFrameCallbackAbortController.signal.aborted) && e(performance.timeOrigin + performance.now(), {
                width: this._player.videoWidth,
                height: this._player.videoHeight,
                expectedDisplayTime: 0,
                mediaTime: 0,
                presentationTime: 0,
                presentedFrames: 0
            });
        }), this._videoFrameCallbackAbortController.handle;
    }
    cancelVideoFrameCallback(e) {
        e === this._videoFrameCallbackAbortController?.handle && this._videoFrameCallbackAbortController?.abort();
    }
    addTextTrack(e, t, r) {
        return this.video.addTextTrack(e, t, r);
    }
    async setSinkId(e) {
        this._sinkId = e, await this._player.setSinkId(e);
    }
    render() {
        this._player.render();
    }
    async setMediaKeys(e) {
        await this.video.setMediaKeys(e);
    }
    getVideoPlaybackQuality() {
        return this.video.getVideoPlaybackQuality();
    }
    captureStream() {
        return this._player.displayElement instanceof HTMLVideoElement ? "captureStream" in this.video && typeof this.video.captureStream == "function" ? this.video.captureStream() : "mozCaptureStream" in this.video && typeof this.video.mozCaptureStream == "function" ? this.video.mozCaptureStream() : new MediaStream : this._player.displayElement instanceof HTMLCanvasElement ? this._player.displayElement.captureStream() : new MediaStream;
    }
    isOnFunction(e) {
        return e in this && e.startsWith("on") && Object.keys(this).includes(e) && typeof this[e] == "function";
    }
    getFallbackEvent(e) {
        let t = e in this ? this[e] : null;
        return t !== null && typeof t == "function" ? t : null;
    }
    getEventHandler(e, t, r) {
        if (this._eventHandlers.has(e)) return this._eventHandlers.get(e);
        let n1 = e.toLowerCase().replaceAll("_", ""), s = (...o)=>{
            queueMicrotask(()=>{
                let d = new t(n1, r(...o));
                if (this.dispatchEvent(d), n1 === "error") return;
                let u = `on${n1}`;
                if (this.isOnFunction(u)) {
                    let m = this.getFallbackEvent(u);
                    m && m.bind(this)(d);
                }
            });
        };
        return this._eventHandlers.set(e, s), s;
    }
    makeEventArgs(e) {
        return {
            detail: e,
            bubbles: !0,
            composed: !0
        };
    }
    makeErrorEventArgs(...e) {
        return {
            error: e[0],
            message: e[1],
            detail: e[2],
            bubbles: !0,
            composed: !0
        };
    }
    updateDisplay() {
        (this.displayElement?.hidden ?? !this.displayElement) && (this.displayElements.filter((e)=>e !== this.displayElement).forEach((e)=>e.hidden = !0), this.displayElement && (this.displayElement.hidden = !1));
    }
    onStateChanged(e, t) {
        switch(this.updateDisplay(), e){
            case "PLAYING":
                this.emit("PLAYING");
                break;
            case "PAUSED":
                this.emit("PAUSE");
                break;
            case "PREPARING":
                this.emit("LOAD_START");
                break;
            case "STALLING":
                this.emit("WAITING");
                break;
        }
    }
    emit(e) {
        this.getEventHandler(e, CustomEvent, this.makeEventArgs)();
    }
    onError = (e, t)=>{
        let r = 0;
        switch(e){
            case (0, $jW02B.Errors).CONNECTION_ERROR:
            case (0, $jW02B.Errors).CRITICAL_CONNECTION_ERROR:
            case (0, $jW02B.Errors).CONNECTION_CLOSED:
            case (0, $jW02B.Errors).CONNECTION_TIMEOUT:
            case "CRITICAL_TIMEOUT":
            case (0, $jW02B.Errors).STREAM_NOT_FOUND:
            case (0, $jW02B.Errors).STREAM_ENDED:
            case (0, $jW02B.Errors).BUFFER_ERROR:
                r = MediaError.MEDIA_ERR_NETWORK;
                break;
            case "UNAUTHORIZED":
            case (0, $jW02B.Errors).START_PLAYING:
            case "START_PLAYING_NOT_ALLOWED":
                r = MediaError.MEDIA_ERR_ABORTED;
                break;
            case "WRONG_URL":
            case (0, $jW02B.Errors).START_PLAYING_NOT_SUPPORTED:
            case "UNSUPPORTED_MEDIA_FORMAT":
                r = MediaError.MEDIA_ERR_SRC_NOT_SUPPORTED;
                break;
            case "UNHANDLED_PLAYER_ERROR":
            case "GENERAL_ERROR":
            case (0, $jW02B.Errors).UNKNOWN_ERROR:
                r = MediaError.MEDIA_ERR_DECODE;
                break;
        }
        let n1 = {
            code: r,
            message: t,
            MEDIA_ERR_ABORTED: 1,
            MEDIA_ERR_NETWORK: 2,
            MEDIA_ERR_DECODE: 3,
            MEDIA_ERR_SRC_NOT_SUPPORTED: 4
        };
        this._error = n1;
    };
};
customElements.get("web-player-internal") === void 0 && customElements.define("web-player-internal", $299b6c40adc500b8$var$$r);
var $299b6c40adc500b8$export$dc16865c51905b16 = class i extends $299b6c40adc500b8$var$Et {
    static Register() {
        customElements.get("web-player-internal") === void 0 && customElements.define("web-player-internal", $299b6c40adc500b8$var$$r), customElements.get("web-player") === void 0 && customElements.define("web-player", i);
    }
    static observedAttributes = [
        ...$299b6c40adc500b8$var$Et.observedAttributes,
        "controlslist"
    ];
    static _template = null;
    static get template() {
        return this._template !== null ? this._template : (this._template = document.createElement("template"), this._template.innerHTML = `
        <style id="player_style">        
            :host {
                display: block;
            }
            :host([hidden]) {
                display: none;
            }
            web-player-internal, media-controller {
                width: 100%;
                height: 100%;
            }

            media-controller[mediastreamtype=unknown] media-time-range, 
            media-controller[mediastreamtype=unknown] media-time-display,  
            media-controller[mediastreamtype=unknown] media-play-button, 
            media-controller[mediastreamtype=unknown] media-video-track-menu-button-custom, 
            media-controller[mediastreamtype=unknown] media-captions-menu-button, 
            media-controller[mediastreamtype=unknown] media-seek-forward-button, 
            media-controller[mediastreamtype=unknown] media-seek-backward-button{
                display: none;
            }
            media-controller[mediastreamtype=live] media-time-range, 
            media-controller[mediastreamtype=live] media-play-button, 
            media-controller[mediastreamtype=live] media-seek-forward-button, 
            media-controller[mediastreamtype=live] media-seek-backward-button{
                display: none;
            }

            media-controller[multipletracks=false] media-video-track-menu-button-custom{
                display: none;
            }   
            media-controller[multipletracks=true] media-video-track-menu-button-custom{
                display: block;
            }  
            media-controller[captionstracks=false] media-captions-menu-button{
                display: none;
            }   
            media-controller[captionstracks=true] media-captions-menu-button{
                display: block;
            }  
            media-controller[nocontrols] media-control-bar{            
                display: none;
            }
            media-controller[nocontrols] media-video-track-menu-custom{            
                display: none;
            }
            media-controller[nopip] media-pip-button,
            media-controller[pipnotsupported] media-pip-button{   
                display: none;
            }   
            media-controller[hidden] {
                display: none;
            }  
            media-controller[nofullscreen] media-fullscreen-button{
                display: none;
            }   
            media-controller[fullscreen] media-fullscreen-button{
                display: block;
            }   
            media-controller[notimedisplay] media-time-display{
                display: none;
            }   
            media-controller[timedisplay] media-time-display{
                display: block;
            }   
            media-controller[notimeline] media-time-range{
                display: none;
            }   
            media-controller[timeline] media-time-range{
                display: block;
            }   
            media-controller[novolume] media-volume-range{
                display: none;
            }   
            media-controller[volume] media-volume-range{
                display: block;
            }  
            media-controller[nomute] media-mute-button{
                display: none;
            }   
            media-controller[mute] media-mute-button{
                display: block;
            }  
            media-controller[noplay] media-play-button{
                display: none;
            }   
            media-controller[play] media-play-button{
                display: block;
            }                  
            media-controller[noseekforward] media-seek-forward-button{
                display: none;
            }   
            media-controller[seekforward] media-seek-forward-button{
                display: block;
            }  
            media-controller[noseekbackward] media-seek-backward-button{
                display: none;
            }   
            media-controller[seekbackward] media-seek-backward-button{
                display: block;
            }  
            media-controller[novideotrackselect] media-video-track-menu-button-custom{
                display: none;
            }   
            media-controller[videotrackselect] media-video-track-menu-button-custom{
                display: block;
            }
            media-controller[nocaptionsselect] media-captions-menu-button{
                display: none;
            }   
            media-controller[captionsselect] media-captions-menu-button{
                display: block;
            }
            media-controller{
                background-color: transparent;
            }
        </style>
        <media-controller id="media-controller-main" nocontrols defaultstreamtype="live">
            <web-player-internal id="wpi" slot="media"></web-player-internal>
            <media-video-track-menu-custom hidden anchor="auto" id="media-video-tracks-menu"></media-video-track-menu-custom>
            <media-captions-menu hidden anchor="auto" id="media-caption-tracks-menu"></media-captions-menu>
            <media-control-bar>
                <media-play-button></media-play-button>
                <media-seek-backward-button></media-seek-backward-button>
                <media-seek-forward-button></media-seek-forward-button>
                <media-video-track-menu-button-custom></media-video-track-menu-button-custom>
                <media-captions-menu-button></media-captions-menu-button>
                <media-mute-button></media-mute-button>
                <media-volume-range></media-volume-range>
                <media-time-range></media-time-range>
                <media-time-display showduration id="time-display"></media-time-display>
                <media-pip-button></media-pip-button>
                <media-fullscreen-button></media-fullscreen-button>
            </media-control-bar>
            <media-loading-indicator slot="centered-chrome"></media-loading-indicator>
        </media-controller>
        <media-controller id="media-controller-pip" hidden defaultstreamtype="live">
            <media-video-track-menu-custom hidden anchor="auto" id="media-video-tracks-menu-pip"></media-video-track-menu-custom>
            <media-captions-menu hidden anchor="auto" id="media-caption-tracks-menu-pip"></media-captions-menu>
            <media-control-bar>
                <media-play-button></media-play-button>
                <media-seek-backward-button></media-seek-backward-button>
                <media-seek-forward-button></media-seek-forward-button>
                <media-video-track-menu-button-custom></media-video-track-menu-button-custom>
                <media-captions-menu-button></media-captions-menu-button>
                <media-mute-button></media-mute-button>
                <media-volume-range></media-volume-range>
                <media-time-range></media-time-range>
                <media-time-display showduration id="time-display-pip"></media-time-display>
            </media-control-bar>
            <media-loading-indicator slot="centered-chrome"></media-loading-indicator>
        </media-controller>`, this._template);
    }
    static fullControlsList = [
        "fullscreen",
        "timedisplay",
        "timeline",
        "volume",
        "mute",
        "play",
        "seekforward",
        "seekbackward",
        "videotrackselect",
        "captionsselect",
        "nofullscreen",
        "notimedisplay",
        "notimeline",
        "novolume",
        "nomute",
        "noplay",
        "noseekforward",
        "noseekbackward",
        "novideotrackselect",
        "nocaptionsselect",
        "nodownload",
        "noremoteplayback"
    ];
    _controlsList = new $299b6c40adc500b8$export$5680f531ee093102([], (e)=>i.fullControlsList.includes(e), ()=>{
        this.setAttributeValue("controlsList", this.controlsList);
        for (let e of i.fullControlsList)this.setControllerAttribute(e, this._controlsList.contains(e));
    });
    _webPlayerInternal = null;
    _mediaControllerMain = null;
    _mediaControllerPip = null;
    _mutationObserver = null;
    get webPlayerInternal() {
        return this._webPlayerInternal === null && (this._webPlayerInternal = this.shadowRoot?.getElementById("wpi")), this._webPlayerInternal;
    }
    get mediaControllerMain() {
        return this._mediaControllerMain === null && (this._mediaControllerMain = this.shadowRoot?.getElementById("media-controller-main")), this._mediaControllerMain;
    }
    get mediaControllerPip() {
        return this._mediaControllerPip === null && (this._mediaControllerPip = this.shadowRoot?.getElementById("media-controller-pip")), this._mediaControllerPip;
    }
    get observedAttributes() {
        return i.observedAttributes;
    }
    set srcInternal(e) {
        this.webPlayerInternal.src = e;
    }
    set lowLatencyInternal(e) {
        this.webPlayerInternal.lowLatency = e;
    }
    set mutedInternal(e) {
        this.webPlayerInternal.muted = e;
    }
    set loopInternal(e) {
        this.webPlayerInternal.loop = e;
    }
    set volumeInternal(e) {
        this.webPlayerInternal.volume = e;
    }
    set widthInternal(e) {
        this.webPlayerInternal.width = e;
    }
    set heightInternal(e) {
        this.webPlayerInternal.height = e;
    }
    set disablePictureInPictureInternal(e) {
        this.setControllerAttribute("nopip", e), this.webPlayerInternal.disablePictureInPicture = e;
    }
    set enginesListInternal(e) {
        this.webPlayerInternal.enginesList = e;
    }
    set tokenInternal(e) {
        this.webPlayerInternal.passthroughToken = e;
    }
    set includeMaskInternal(e) {
        this.webPlayerInternal.includeMask = e;
    }
    get state() {
        return this.webPlayerInternal.state;
    }
    get currentEngine() {
        return this.webPlayerInternal.currentEngine;
    }
    get playerId() {
        return this.webPlayerInternal.playerId;
    }
    get currentTime() {
        return this.webPlayerInternal.currentTime;
    }
    set currentTime(e) {
        this.webPlayerInternal.currentTime = e;
    }
    get duration() {
        return this.webPlayerInternal.duration;
    }
    get paused() {
        return this.state === "PAUSED";
    }
    get buffered() {
        return this.webPlayerInternal.buffered;
    }
    get played() {
        return this.webPlayerInternal.played;
    }
    get seekable() {
        return this.webPlayerInternal.seekable;
    }
    get texture() {
        return this.webPlayerInternal.texture;
    }
    get videoWidth() {
        return this.webPlayerInternal.videoWidth;
    }
    get videoHeight() {
        return this.webPlayerInternal.videoHeight;
    }
    get renderingWidth() {
        return this.webPlayerInternal.renderingWidth;
    }
    get renderingHeight() {
        return this.webPlayerInternal.renderingHeight;
    }
    get readyState() {
        return this.webPlayerInternal.readyState;
    }
    set autoplayInternal(e) {
        this.webPlayerInternal.autoplay = e;
    }
    get currentSrc() {
        return this.webPlayerInternal.currentSrc;
    }
    get ended() {
        return this.webPlayerInternal.ended;
    }
    get streamType() {
        return this.webPlayerInternal.streamType;
    }
    get videoTracks() {
        return this.webPlayerInternal.videoTracks;
    }
    get allEngines() {
        return this.webPlayerInternal.allEngines;
    }
    get enabledEngines() {
        return this.webPlayerInternal.enabledEngines;
    }
    get supportedEngines() {
        return this.webPlayerInternal.supportedEngines;
    }
    get usedEngines() {
        return this.webPlayerInternal.usedEngines;
    }
    set connectionTimeoutInternal(e) {
        this.webPlayerInternal.connectionTimeout = e;
    }
    get seeking() {
        return this.webPlayerInternal.seeking;
    }
    set controlsInternal(e) {
        this.setControllerAttribute("nocontrols", !e);
    }
    get error() {
        return this.webPlayerInternal.error;
    }
    get textTracks() {
        return this.webPlayerInternal.textTracks;
    }
    get remote() {
        return this.webPlayerInternal.remote;
    }
    get sinkId() {
        return this.webPlayerInternal.sinkId;
    }
    get mediaKeys() {
        return this.webPlayerInternal.mediaKeys;
    }
    get preservesPitch() {
        return this.webPlayerInternal.preservesPitch;
    }
    set preservesPitch(e) {
        this.webPlayerInternal.preservesPitch = e;
    }
    set playsInlineInternal(e) {
        this.webPlayerInternal.playsInline = e;
    }
    set posterInternal(e) {
        this.webPlayerInternal.poster = e;
    }
    set crossOriginInternal(e) {
        this.webPlayerInternal.crossOrigin = e;
    }
    set externalRendererInternal(e) {
        this.webPlayerInternal.externalRenderer = e;
    }
    set stallWindowInternal(e) {
        this.webPlayerInternal.stallWindow = e;
    }
    set maxStallEventsInternal(e) {
        this.webPlayerInternal.maxStallEvents = e;
    }
    set fmp4ProtocolVersionInternal(e) {
        this.webPlayerInternal.fmp4ProtocolVersion = e;
    }
    get controlsList() {
        return this._controlsList.value;
    }
    set controlsList(e) {
        if (e !== this.controlsList) {
            this._controlsList.setValue(e), this.setAttributeValue("controlsList", this.controlsList);
            for (let t of i.fullControlsList)this.setControllerAttribute(t, this._controlsList.contains(t));
        }
    }
    constructor(){
        super(), i.Register(), this.shadowRoot?.appendChild(i.template.content.cloneNode(!0)), customElements.get("web-player-internal") !== void 0 ? this.upgrade() : customElements.whenDefined("web-player-internal").then(()=>this.upgrade()), this._mutationObserver = new MutationObserver((e)=>{
            e.forEach((t)=>{
                if (t.type === "attributes" && t.target === this.webPlayerInternal && t.attributeName !== null && this.observedAttributes.includes(t.attributeName.toLowerCase())) {
                    let r = this.getAttribute(t.attributeName), n1 = this.webPlayerInternal.getAttribute(t.attributeName);
                    r !== n1 && (n1 !== null ? this.setAttribute(t.attributeName, n1) : this.removeAttribute(t.attributeName));
                }
            });
        }), this._mutationObserver.observe(this.webPlayerInternal, {
            attributes: !0
        }), this.videoTracks.addEventListener("change", ()=>{
            this.includeMask = this.videoTracks.selected?.id === "with_mask";
        });
    }
    connectedCallback() {
        super.connectedCallback(), i.upgradeProperty(this, "controlsList"), this.setControllerAttributeValue("multipletracks", this.videoTracks.length > 1, "true", "false"), this.setControllerAttributeValue("captionstracks", this.textTracks.length > 0, "true", "false");
        let e = this.shadowRoot?.getElementById("media-video-tracks-menu"), t = this.shadowRoot?.getElementById("media-video-tracks-menu-pip");
        this.webPlayerInternal.addEventListener("addvideotrack", ()=>{
            e.mediaVideoTrackList = this.videoTracks, e.mediaVideoTrackSelected = this.videoTracks.selected?.id ?? "", t.mediaVideoTrackList = this.videoTracks, t.mediaVideoTrackSelected = this.videoTracks.selected?.id ?? "", this.setControllerAttributeValue("multipletracks", this.videoTracks.length > 1, "true", "false");
        }), this.webPlayerInternal.addEventListener("removevideotrack", ()=>{
            e.mediaVideoTrackList = this.videoTracks, e.mediaVideoTrackSelected = this.videoTracks.selected?.id ?? "", t.mediaVideoTrackList = this.videoTracks, t.mediaVideoTrackSelected = this.videoTracks.selected?.id ?? "", this.setControllerAttributeValue("multipletracks", this.videoTracks.length > 1, "true", "false");
        }), this.webPlayerInternal.addEventListener("videotrackchange", ()=>{
            e.mediaVideoTrackSelected = this.videoTracks.selected?.id ?? "", t.mediaVideoTrackSelected = this.videoTracks.selected?.id ?? "", this.setControllerAttributeValue("multipletracks", this.videoTracks.length > 1, "true", "false");
        }), this.textTracks.addEventListener("addtrack", ()=>{
            this.setControllerAttributeValue("captionstracks", this.textTracks.length > 0, "true", "false");
        }), this.textTracks.addEventListener("removetrack", ()=>{
            this.setControllerAttributeValue("captionstracks", this.textTracks.length > 0, "true", "false");
        }), this.addEventListener("change", (r)=>{
            r.detail === void 0 && r.stopImmediatePropagation();
        }), this.webPlayerInternal.addEventListener("streamtypechange", ()=>{
            let r = this.shadowRoot?.getElementById("time-display"), n1 = this.shadowRoot?.getElementById("time-display-pip");
            switch(this.streamType){
                case "live":
                    r?.removeAttribute("showduration"), n1?.removeAttribute("showduration");
                    break;
                case "on-demand":
                    r?.setAttribute("showduration", ""), n1?.setAttribute("showduration", "");
                    break;
            }
            this.mediaControllerMain.setAttribute("mediastreamtype", this.streamType), this.mediaControllerPip.setAttribute("mediastreamtype", this.streamType);
        }), "documentPictureInPicture" in window && window.documentPictureInPicture.addEventListener("enter", ()=>{
            let r = new Event("enterpictureinpicture", {
                bubbles: !0,
                composed: !0
            });
            if (this.dispatchEvent(r), this.onenterpictureinpicture && this.onenterpictureinpicture(r), "documentPictureInPicture" in window) {
                let n1 = window.documentPictureInPicture.window;
                this.passThroughPipWindowEvent("statechanged", n1), this.passThroughPipWindowEvent("warning", n1), this.passThroughPipWindowEvent("error", n1), this.passThroughPipWindowEvent("frameready", n1), this.passThroughPipWindowEvent("invalidpassthroughtoken", n1), this.passThroughPipWindowEvent("maskdecodingerror", n1), this.passThroughPipWindowEvent("streamtypechange", n1), this.passThroughPipWindowEvent("addvideotrack", n1), this.passThroughPipWindowEvent("removevideotrack", n1), this.passThroughPipWindowEvent("videotrackchange", n1), this.passThroughPipWindowEvent("enterpictureinpicture", n1), this.passThroughPipWindowEvent("leavepictureinpicture", n1), this.passThroughPipWindowEvent("engineschange", n1), this.passThroughPipWindowEvent("loadedmetadata", n1), this.passThroughPipWindowEvent("loadeddata", n1), this.passThroughPipWindowEvent("playing", n1), this.passThroughPipWindowEvent("pause", n1), this.passThroughPipWindowEvent("waiting", n1), this.passThroughPipWindowEvent("ended", n1), this.passThroughPipWindowEvent("timeupdate", n1), this.passThroughPipWindowEvent("durationchange", n1), this.passThroughPipWindowEvent("progress", n1);
            }
        }), setTimeout(()=>{
            this.mediaControllerMain.setAttribute("mediastreamtype", "unknown"), this.mediaControllerPip.setAttribute("mediastreamtype", "unknown"), "documentPictureInPicture" in window || this.mediaControllerMain.setAttribute("pipnotsupported", "");
        }, 0);
    }
    disconnectedCallback() {
        super.disconnectedCallback(), this.stop();
    }
    async play() {
        await this.webPlayerInternal.play();
    }
    async stop() {
        await this.webPlayerInternal.stop();
    }
    async togglePause() {
        await this.webPlayerInternal.togglePause();
    }
    async seek(e) {
        await this.webPlayerInternal.seek(e);
    }
    async pause() {
        await this.webPlayerInternal.pause();
    }
    async requestPictureInPicture() {
        return await this.webPlayerInternal.requestPictureInPicture();
    }
    exitPictureInPicture() {
        this.webPlayerInternal.exitPictureInPicture();
    }
    requestVideoFrameCallback(e) {
        return this.webPlayerInternal.requestVideoFrameCallback(e);
    }
    cancelVideoFrameCallback(e) {
        this.webPlayerInternal.cancelVideoFrameCallback(e);
    }
    canPlayType(e) {
        return this.webPlayerInternal.canPlayType(e);
    }
    async load() {
        await this.webPlayerInternal.load();
    }
    addTextTrack(e, t, r) {
        return this.webPlayerInternal.addTextTrack(e, t, r);
    }
    async setSinkId(e) {
        await this.webPlayerInternal.setSinkId(e);
    }
    render() {
        this.externalRenderer && this.state === "PLAYING" && this.webPlayerInternal.render();
    }
    async setMediaKeys(e) {
        this.webPlayerInternal.setMediaKeys(e);
    }
    getVideoPlaybackQuality() {
        return this.webPlayerInternal.getVideoPlaybackQuality();
    }
    captureStream() {
        return this.webPlayerInternal.captureStream();
    }
    setControllerAttributeValue(e, t, r = "", n1) {
        t ? (this.mediaControllerMain.setAttribute(e, r), this.mediaControllerPip.setAttribute(e, r)) : n1 !== void 0 ? (this.mediaControllerMain.setAttribute(e, n1), this.mediaControllerPip.setAttribute(e, n1)) : (this.mediaControllerMain.removeAttribute(e), this.mediaControllerPip.removeAttribute(e));
    }
    setControllerAttribute(e, t) {
        this.setControllerAttributeValue(e, t);
    }
    passThroughPipWindowEvent(e, t) {
        t.addEventListener(e, (r)=>{
            r instanceof $299b6c40adc500b8$export$73095185aa19db6b ? this.dispatchEvent(new $299b6c40adc500b8$export$73095185aa19db6b(e, {
                error: r.detail?.error ?? "",
                message: r.detail?.message ?? "",
                detail: r.detail,
                bubbles: !0,
                composed: !0
            })) : r instanceof CustomEvent ? this.dispatchEvent(new CustomEvent(e, {
                detail: r.detail,
                bubbles: !0,
                composed: !0
            })) : this.dispatchEvent(new Event(e, {
                bubbles: !0,
                composed: !0
            }));
        });
    }
    upgrade() {
        customElements && customElements.upgrade && customElements.upgrade(this.webPlayerInternal);
    }
};
$299b6c40adc500b8$export$dc16865c51905b16.Register();

});

parcelRegister("8AeNp", function(module, exports) {

var $7ryUf = parcelRequire("7ryUf");
let $63fd29b15d5f4658$var$url = new URL(import.meta.resolve("6kyAB"));
module.exports = $7ryUf($63fd29b15d5f4658$var$url.toString(), $63fd29b15d5f4658$var$url.origin, true);

});
parcelRegister("7ryUf", function(module, exports) {
"use strict";
module.exports = function(workerUrl, origin, isESM) {
    if (origin === self.location.origin) // If the worker bundle's url is on the same origin as the document,
    // use the worker bundle's own url.
    return workerUrl;
    else {
        // Otherwise, create a blob URL which loads the worker bundle with `importScripts`.
        var source = isESM ? 'import ' + JSON.stringify(workerUrl) + ';' : 'importScripts(' + JSON.stringify(workerUrl) + ');';
        return URL.createObjectURL(new Blob([
            source
        ], {
            type: 'application/javascript'
        }));
    }
};

});



parcelRegister("1YqIQ", function(module, exports) {
parcelRequire("eCbil");
parcelRequire("gBcGT");

});
parcelRegister("eCbil", function(module, exports) {
parcelRequire("2xip6");
var $7etnY = parcelRequire("7etnY");
var $5YkyR = parcelRequire("5YkyR");
var $gmbCk = parcelRequire("gmbCk");
var $765rp = parcelRequire("765rp");
var $ha1VO = parcelRequire("ha1VO");
parcelRequire("fZvDz");
var $keU3U = parcelRequire("keU3U");
parcelRequire("a7fWI");
var $c8Dvh = parcelRequire("c8Dvh");
var $833Wh = parcelRequire("833Wh");
parcelRequire("jbmOc");
var $52Ze3 = parcelRequire("52Ze3");
var $euqMi = parcelRequire("euqMi");
class $c35fb5076ee4af4d$export$1fc4640bc6360dcd {
    //#endregion
    //#region Public Properties
    get projectionMesh() {
        return this._projectionMesh;
    }
    get engine() {
        return this._engine;
    }
    get zoomSensitivity() {
        return this._zoomSensitivity;
    }
    set zoomSensitivity(value) {
        if (this.zoomSensitivity === value) return;
        this._zoomSensitivity = value;
        this._touchInput.zoomSensitivity = value;
    }
    get touchMoveXSensitivity() {
        return this._touchMoveXSensitivity;
    }
    set touchMoveXSensitivity(value) {
        if (this.touchMoveXSensitivity === value) return;
        this._touchMoveXSensitivity = value;
        this._touchInput.moveXSensitivity = value;
    }
    get touchMoveYSensitivity() {
        return this._touchMoveYSensitivity;
    }
    set touchMoveYSensitivity(value) {
        if (this.touchMoveYSensitivity === value) return;
        this._touchMoveYSensitivity = value;
        this._touchInput.moveYSensitivity = value;
    }
    get zoomMin() {
        return this._zoomMin;
    }
    set zoomMin(value) {
        if (this.zoomMin === value) return;
        this._zoomMin = value;
        this._touchInput.zoomMin = value;
    }
    get zoomMax() {
        return this._zoomMax;
    }
    set zoomMax(value) {
        if (this.zoomMax === value) return;
        this._zoomMax = value;
        this._touchInput.zoomMax = value;
    }
    get touchZoomMode() {
        return this._touchZoomMode;
    }
    set touchZoomMode(value) {
        if (this.touchZoomMode === value) return;
        this._touchZoomMode = value;
        this._touchInput.zoomMode = value;
    }
    get requireReleaseAfterZoom() {
        return this._requireReleaseAfterZoom;
    }
    set requireReleaseAfterZoom(value) {
        if (this.requireReleaseAfterZoom === value) return;
        this._requireReleaseAfterZoom = value;
        this._touchInput.requireReleaseAfterZoom = value;
    }
    get mouseMoveXSensitivity() {
        return this._moveXSensitivity;
    }
    set mouseMoveXSensitivity(value) {
        if (this.mouseMoveXSensitivity === value) return;
        this._moveXSensitivity = value;
        this._mouseInput.moveXSensitivity = value;
    }
    get mouseMoveYSensitivity() {
        return this._moveYSensitivity;
    }
    set mouseMoveYSensitivity(value) {
        if (this.mouseMoveYSensitivity === value) return;
        this._moveYSensitivity = value;
        this._mouseInput.moveYSensitivity = value;
    }
    get rotationXLimit() {
        return this._rotationXLimit;
    }
    set rotationXLimit(value) {
        if (this.rotationXLimit === value) return;
        this._rotationXLimit = value;
        this._touchInput.rotationXLimit = value;
        this._mouseInput.rotationXLimit = value;
    }
    get rotationYLimit() {
        return this._rotationYLimit;
    }
    set rotationYLimit(value) {
        if (this.rotationYLimit === value) return;
        this._rotationYLimit = value;
        this._touchInput.rotationYLimit = value;
        this._mouseInput.rotationYLimit = value;
    }
    get currentZoom() {
        return this._cameraInitialZoomZ;
    }
    set currentZoom(value) {
        if (this.currentZoom === value) return;
        this._cameraInitialZoomZ = value;
    }
    get sceneColor() {
        return this._sceneColor;
    }
    set sceneColor(value) {
        if (this.sceneColor === value) return;
        this._sceneColor = value;
        this._scene.clearColor = (0, $7etnY.Color4).FromHexString(value);
    }
    //#endregion
    //#region Constructor
    constructor(canvas){
        this._zoomSensitivity = 25;
        this._touchMoveXSensitivity = 500;
        this._touchMoveYSensitivity = 500;
        this._zoomMin = -14;
        this._zoomMax = 6;
        this._touchZoomMode = "pinch";
        this._requireReleaseAfterZoom = true;
        this._moveXSensitivity = 2000;
        this._moveYSensitivity = 2000;
        this._rotationXLimit = 90;
        this._rotationYLimit = 90;
        this._cameraInitialZoomZ = -9;
        this._sceneColor = "#000000";
        this._engine = new (0, $5YkyR.Engine)(canvas, true, {
            preserveDrawingBuffer: true,
            stencil: true,
            useHighPrecisionFloats: true,
            powerPreference: "high-performance"
        });
        this._scene = new (0, $gmbCk.Scene)(this._engine);
        this._camera = new (0, $765rp.UniversalCamera)("camera", (0, $ha1VO.Vector3).Zero(), this._scene);
        this._projectionMesh = new (0, $euqMi.ProjectionMeshBabylonJS)((0, $52Ze3.Projection).FromString(""), 10, this._scene);
        this._touchInput = new (0, $833Wh.AdvancedFreeCameraTouchInput)({
            zoomSensitivity: this.zoomSensitivity,
            moveXSensitivity: this.touchMoveXSensitivity,
            moveYSensitivity: this.touchMoveYSensitivity,
            zoomMin: this.zoomMin,
            zoomMax: this.zoomMax,
            rotationXLimit: this.rotationXLimit,
            rotationYLimit: this.rotationYLimit,
            zoomMode: this.touchZoomMode,
            requireReleaseAfterZoom: this.requireReleaseAfterZoom
        });
        this._mouseInput = new (0, $c8Dvh.AdvancedFreeCameraMouseInput)({
            moveXSensitivity: this.mouseMoveXSensitivity,
            moveYSensitivity: this.mouseMoveYSensitivity,
            rotationXLimit: this.rotationXLimit,
            rotationYLimit: this.rotationYLimit
        });
        this.init();
    }
    //#endregion
    //#region Methods
    zoom(value) {
        this._camera.fov += value;
    }
    init() {
        this._engine.resize();
        this._scene.createDefaultEnvironment({
            enableGroundShadow: false,
            groundYBias: 0,
            createGround: true,
            groundSize: 0.0001,
            groundOpacity: 0,
            setupImageProcessing: false,
            createSkybox: false
        });
        this._scene.clearColor = (0, $7etnY.Color4).FromHexString("#00000000");
        this._camera.fovMode = (0, $765rp.UniversalCamera).FOVMODE_HORIZONTAL_FIXED;
        this._camera.fov = 1.05;
        this._camera.position.z = this.currentZoom;
        this._camera.setTarget((0, $ha1VO.Vector3).Forward());
        this._camera.attachControl();
        this._camera.inputs.removeByType('FreeCameraTouchInput');
        this._camera.inputs.removeMouse();
        this._camera.inputs.add(this._touchInput);
        this._camera.inputs.add(this._mouseInput);
        this._camera.layerMask |= this._projectionMesh?.Layers.x ?? 0;
        this._projectionMesh.IsVisible = true;
        this._engine?.runRenderLoop(()=>{
            if (this._scene?.activeCamera) this._scene?.render();
        });
    }
}
(0, $keU3U.SceneFactory).Register($c35fb5076ee4af4d$export$1fc4640bc6360dcd);

});
parcelRegister("2xip6", function(module, exports) {
/* eslint-disable import/no-internal-modules */ 
var $5Tqba = parcelRequire("5Tqba");

var $dSXe4 = parcelRequire("dSXe4");

var $hD7z9 = parcelRequire("hD7z9");

var $kMzus = parcelRequire("kMzus");

var $9HEaj = parcelRequire("9HEaj");

var $fF6RN = parcelRequire("fF6RN");

var $bqNL2 = parcelRequire("bqNL2");

var $eeqmf = parcelRequire("eeqmf");

var $fH5IN = parcelRequire("fH5IN");

var $eCR42 = parcelRequire("eCR42");

var $1aZcZ = parcelRequire("1aZcZ");

var $iZjJh = parcelRequire("iZjJh");

var $1aVAP = parcelRequire("1aVAP");

var $lxwQt = parcelRequire("lxwQt");

var $6Ggn5 = parcelRequire("6Ggn5");

var $aq3hd = parcelRequire("aq3hd");

var $ebp3Z = parcelRequire("ebp3Z");

var $eIwy1 = parcelRequire("eIwy1");

var $210RJ = parcelRequire("210RJ");

var $kWvPW = parcelRequire("kWvPW");

var $dXHo1 = parcelRequire("dXHo1");

var $76Hyh = parcelRequire("76Hyh");

var $8xKGe = parcelRequire("8xKGe");

var $eh12X = parcelRequire("eh12X");

var $8PAFk = parcelRequire("8PAFk");

var $hHnf3 = parcelRequire("hHnf3");

var $4aDh4 = parcelRequire("4aDh4");

var $9ZIGQ = parcelRequire("9ZIGQ");

var $2kwDx = parcelRequire("2kwDx");

var $lacby = parcelRequire("lacby");

var $bgssx = parcelRequire("bgssx");

var $9Uw9w = parcelRequire("9Uw9w");

var $hzbqE = parcelRequire("hzbqE");

var $4d3nY = parcelRequire("4d3nY");

var $bZYgT = parcelRequire("bZYgT");

var $7snoU = parcelRequire("7snoU");

var $0G59o = parcelRequire("0G59o");

var $gmbCk = parcelRequire("gmbCk");

var $bv05l = parcelRequire("bv05l");

var $4hgCb = parcelRequire("4hgCb");

var $lqHJJ = parcelRequire("lqHJJ");

var $uyjIM = parcelRequire("uyjIM");

var $lxDra = parcelRequire("lxDra");

var $bk2fd = parcelRequire("bk2fd");

var $01PXR = parcelRequire("01PXR");

var $7Va7p = parcelRequire("7Va7p");

var $3mXOV = parcelRequire("3mXOV");
$parcel$exportWildcard(module.exports, $5Tqba);
$parcel$exportWildcard(module.exports, $dSXe4);
$parcel$exportWildcard(module.exports, $hD7z9);
$parcel$exportWildcard(module.exports, $kMzus);
$parcel$exportWildcard(module.exports, $9HEaj);
$parcel$exportWildcard(module.exports, $fF6RN);
$parcel$exportWildcard(module.exports, $bqNL2);
$parcel$exportWildcard(module.exports, $eeqmf);
$parcel$exportWildcard(module.exports, $fH5IN);
$parcel$exportWildcard(module.exports, $eCR42);
$parcel$exportWildcard(module.exports, $1aZcZ);
$parcel$exportWildcard(module.exports, $iZjJh);
$parcel$exportWildcard(module.exports, $1aVAP);
$parcel$exportWildcard(module.exports, $lxwQt);
$parcel$exportWildcard(module.exports, $6Ggn5);
$parcel$exportWildcard(module.exports, $aq3hd);
$parcel$exportWildcard(module.exports, $ebp3Z);
$parcel$exportWildcard(module.exports, $eIwy1);
$parcel$exportWildcard(module.exports, $210RJ);
$parcel$exportWildcard(module.exports, $kWvPW);
$parcel$exportWildcard(module.exports, $dXHo1);
$parcel$exportWildcard(module.exports, $76Hyh);
$parcel$exportWildcard(module.exports, $8xKGe);
$parcel$exportWildcard(module.exports, $eh12X);
$parcel$exportWildcard(module.exports, $8PAFk);
$parcel$exportWildcard(module.exports, $hHnf3);
$parcel$exportWildcard(module.exports, $4aDh4);
$parcel$exportWildcard(module.exports, $9ZIGQ);
$parcel$exportWildcard(module.exports, $2kwDx);
$parcel$exportWildcard(module.exports, $lacby);
$parcel$exportWildcard(module.exports, $bgssx);
$parcel$exportWildcard(module.exports, $9Uw9w);
$parcel$exportWildcard(module.exports, $hzbqE);
$parcel$exportWildcard(module.exports, $4d3nY);
$parcel$exportWildcard(module.exports, $bZYgT);
$parcel$exportWildcard(module.exports, $7snoU);
$parcel$exportWildcard(module.exports, $0G59o);
$parcel$exportWildcard(module.exports, $gmbCk);
$parcel$exportWildcard(module.exports, $bv05l);
$parcel$exportWildcard(module.exports, $4hgCb);
$parcel$exportWildcard(module.exports, $lqHJJ);
$parcel$exportWildcard(module.exports, $uyjIM);
$parcel$exportWildcard(module.exports, $lxDra);
$parcel$exportWildcard(module.exports, $bk2fd);
$parcel$exportWildcard(module.exports, $01PXR);
$parcel$exportWildcard(module.exports, $7Va7p);
$parcel$exportWildcard(module.exports, $3mXOV);

});
parcelRegister("5Tqba", function(module, exports) {

$parcel$export(module.exports, "AbstractScene", () => $44a665738f42497f$export$765fdbac0eda2a0b);
/**
 * Base class of the scene acting as a container for the different elements composing a scene.
 * This class is dynamically extended by the different components of the scene increasing
 * flexibility and reducing coupling
 */ class $44a665738f42497f$export$765fdbac0eda2a0b {
    constructor(){
        /**
         * Gets the list of root nodes (ie. nodes with no parent)
         */ this.rootNodes = [];
        /** All of the cameras added to this scene
         * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras
         */ this.cameras = [];
        /**
         * All of the lights added to this scene
         * @see https://doc.babylonjs.com/features/featuresDeepDive/lights/lights_introduction
         */ this.lights = [];
        /**
         * All of the (abstract) meshes added to this scene
         */ this.meshes = [];
        /**
         * The list of skeletons added to the scene
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/bonesSkeletons
         */ this.skeletons = [];
        /**
         * All of the particle systems added to this scene
         * @see https://doc.babylonjs.com/features/featuresDeepDive/particles/particle_system/particle_system_intro
         */ this.particleSystems = [];
        /**
         * Gets a list of Animations associated with the scene
         */ this.animations = [];
        /**
         * All of the animation groups added to this scene
         * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/groupAnimations
         */ this.animationGroups = [];
        /**
         * All of the multi-materials added to this scene
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/multiMaterials
         */ this.multiMaterials = [];
        /**
         * All of the materials added to this scene
         * In the context of a Scene, it is not supposed to be modified manually.
         * Any addition or removal should be done using the addMaterial and removeMaterial Scene methods.
         * Note also that the order of the Material within the array is not significant and might change.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/materials_introduction
         */ this.materials = [];
        /**
         * The list of morph target managers added to the scene
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/dynamicMeshMorph
         */ this.morphTargetManagers = [];
        /**
         * The list of geometries used in the scene.
         */ this.geometries = [];
        /**
         * All of the transform nodes added to this scene
         * In the context of a Scene, it is not supposed to be modified manually.
         * Any addition or removal should be done using the addTransformNode and removeTransformNode Scene methods.
         * Note also that the order of the TransformNode within the array is not significant and might change.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/transforms/parent_pivot/transform_node
         */ this.transformNodes = [];
        /**
         * ActionManagers available on the scene.
         * @deprecated
         */ this.actionManagers = [];
        /**
         * Textures to keep.
         */ this.textures = [];
        /** @internal */ this._environmentTexture = null;
        /**
         * The list of postprocesses added to the scene
         */ this.postProcesses = [];
    }
    /**
     * Adds a parser in the list of available ones
     * @param name Defines the name of the parser
     * @param parser Defines the parser to add
     */ static AddParser(name, parser) {
        this._BabylonFileParsers[name] = parser;
    }
    /**
     * Gets a general parser from the list of available ones
     * @param name Defines the name of the parser
     * @returns the requested parser or null
     */ static GetParser(name) {
        if (this._BabylonFileParsers[name]) return this._BabylonFileParsers[name];
        return null;
    }
    /**
     * Adds n individual parser in the list of available ones
     * @param name Defines the name of the parser
     * @param parser Defines the parser to add
     */ static AddIndividualParser(name, parser) {
        this._IndividualBabylonFileParsers[name] = parser;
    }
    /**
     * Gets an individual parser from the list of available ones
     * @param name Defines the name of the parser
     * @returns the requested parser or null
     */ static GetIndividualParser(name) {
        if (this._IndividualBabylonFileParsers[name]) return this._IndividualBabylonFileParsers[name];
        return null;
    }
    /**
     * Parser json data and populate both a scene and its associated container object
     * @param jsonData Defines the data to parse
     * @param scene Defines the scene to parse the data for
     * @param container Defines the container attached to the parsing sequence
     * @param rootUrl Defines the root url of the data
     */ static Parse(jsonData, scene, container, rootUrl) {
        for(const parserName in this._BabylonFileParsers)if (Object.prototype.hasOwnProperty.call(this._BabylonFileParsers, parserName)) this._BabylonFileParsers[parserName](jsonData, scene, container, rootUrl);
    }
    /**
     * Texture used in all pbr material as the reflection texture.
     * As in the majority of the scene they are the same (exception for multi room and so on),
     * this is easier to reference from here than from all the materials.
     */ get environmentTexture() {
        return this._environmentTexture;
    }
    set environmentTexture(value) {
        this._environmentTexture = value;
    }
    /**
     * @returns all meshes, lights, cameras, transformNodes and bones
     */ getNodes() {
        let nodes = [];
        nodes = nodes.concat(this.meshes);
        nodes = nodes.concat(this.lights);
        nodes = nodes.concat(this.cameras);
        nodes = nodes.concat(this.transformNodes); // dummies
        this.skeletons.forEach((skeleton)=>nodes = nodes.concat(skeleton.bones));
        return nodes;
    }
}
/**
 * Stores the list of available parsers in the application.
 */ $44a665738f42497f$export$765fdbac0eda2a0b._BabylonFileParsers = {};
/**
 * Stores the list of available individual parsers in the application.
 */ $44a665738f42497f$export$765fdbac0eda2a0b._IndividualBabylonFileParsers = {};

});

parcelRegister("dSXe4", function(module, exports) {

var $kNPE8 = parcelRequire("kNPE8");

var $5lx8l = parcelRequire("5lx8l");

var $cmj0B = parcelRequire("cmj0B");

var $ebhJB = parcelRequire("ebhJB");

var $gv9um = parcelRequire("gv9um");

var $ahTnb = parcelRequire("ahTnb");

var $crJJ6 = parcelRequire("crJJ6");

var $3Pmts = parcelRequire("3Pmts");
$parcel$exportWildcard(module.exports, $kNPE8);
$parcel$exportWildcard(module.exports, $5lx8l);
$parcel$exportWildcard(module.exports, $cmj0B);
$parcel$exportWildcard(module.exports, $ebhJB);
$parcel$exportWildcard(module.exports, $gv9um);
$parcel$exportWildcard(module.exports, $ahTnb);
$parcel$exportWildcard(module.exports, $crJJ6);
$parcel$exportWildcard(module.exports, $3Pmts);

});
parcelRegister("kNPE8", function(module, exports) {

$parcel$export(module.exports, "AbstractActionManager", () => $03e885f839d57774$export$14ad3606dc0e1e35);
/**
 * Abstract class used to decouple action Manager from scene and meshes.
 * Do not instantiate.
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions
 */ class $03e885f839d57774$export$14ad3606dc0e1e35 {
    constructor(){
        /** Gets the cursor to use when hovering items */ this.hoverCursor = "";
        /** Gets the list of actions */ this.actions = [];
        /**
         * Gets or sets a boolean indicating that the manager is recursive meaning that it can trigger action from children
         */ this.isRecursive = false;
    }
    /**
     * Does exist one action manager with at least one trigger
     **/ static get HasTriggers() {
        for(const t in $03e885f839d57774$export$14ad3606dc0e1e35.Triggers){
            if (Object.prototype.hasOwnProperty.call($03e885f839d57774$export$14ad3606dc0e1e35.Triggers, t)) return true;
        }
        return false;
    }
    /**
     * Does exist one action manager with at least one pick trigger
     **/ static get HasPickTriggers() {
        for(const t in $03e885f839d57774$export$14ad3606dc0e1e35.Triggers)if (Object.prototype.hasOwnProperty.call($03e885f839d57774$export$14ad3606dc0e1e35.Triggers, t)) {
            const tAsInt = parseInt(t);
            if (tAsInt >= 1 && tAsInt <= 7) return true;
        }
        return false;
    }
    /**
     * Does exist one action manager that handles actions of a given trigger
     * @param trigger defines the trigger to be tested
     * @returns a boolean indicating whether the trigger is handled by at least one action manager
     **/ static HasSpecificTrigger(trigger) {
        for(const t in $03e885f839d57774$export$14ad3606dc0e1e35.Triggers)if (Object.prototype.hasOwnProperty.call($03e885f839d57774$export$14ad3606dc0e1e35.Triggers, t)) {
            const tAsInt = parseInt(t);
            if (tAsInt === trigger) return true;
        }
        return false;
    }
}
/** Gets the list of active triggers */ $03e885f839d57774$export$14ad3606dc0e1e35.Triggers = {};

});

parcelRegister("5lx8l", function(module, exports) {

$parcel$export(module.exports, "Action", () => $3e489d8a2af0aefb$export$e19cd5f9376f8cee);

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $8DoUR = parcelRequire("8DoUR");
class $3e489d8a2af0aefb$export$e19cd5f9376f8cee {
    /**
     * Creates a new Action
     * @param triggerOptions the trigger, with or without parameters, for the action
     * @param condition an optional determinant of action
     */ constructor(/** the trigger, with or without parameters, for the action */ triggerOptions, condition){
        this.triggerOptions = triggerOptions;
        /**
         * An event triggered prior to action being executed.
         */ this.onBeforeExecuteObservable = new (0, $diGQf.Observable)();
        if (triggerOptions.parameter) {
            this.trigger = triggerOptions.trigger;
            this._triggerParameter = triggerOptions.parameter;
        } else if (triggerOptions.trigger) this.trigger = triggerOptions.trigger;
        else this.trigger = triggerOptions;
        this._nextActiveAction = this;
        this._condition = condition;
    }
    /**
     * Internal only
     * @internal
     */ _prepare() {}
    /**
     * Gets the trigger parameter
     * @returns the trigger parameter
     */ getTriggerParameter() {
        return this._triggerParameter;
    }
    /**
     * Sets the trigger parameter
     * @param value defines the new trigger parameter
     */ setTriggerParameter(value) {
        this._triggerParameter = value;
    }
    /**
     * Internal only - Returns if the current condition allows to run the action
     * @internal
     */ _evaluateConditionForCurrentFrame() {
        const condition = this._condition;
        if (!condition) return true;
        const currentRenderId = this._actionManager.getScene().getRenderId();
        // We cache the current evaluation for the current frame
        if (condition._evaluationId !== currentRenderId) {
            condition._evaluationId = currentRenderId;
            condition._currentResult = condition.isValid();
        }
        return condition._currentResult;
    }
    /**
     * Internal only - executes current action event
     * @internal
     */ _executeCurrent(evt) {
        const isConditionValid = this._evaluateConditionForCurrentFrame();
        if (!isConditionValid) return;
        this.onBeforeExecuteObservable.notifyObservers(this);
        this._nextActiveAction.execute(evt);
        this.skipToNextActiveAction();
    }
    /**
     * Execute placeholder for child classes
     * @param evt optional action event
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    execute(evt) {}
    /**
     * Skips to next active action
     */ skipToNextActiveAction() {
        if (this._nextActiveAction._child) {
            if (!this._nextActiveAction._child._actionManager) this._nextActiveAction._child._actionManager = this._actionManager;
            this._nextActiveAction = this._nextActiveAction._child;
        } else this._nextActiveAction = this;
    }
    /**
     * Adds action to chain of actions, may be a DoNothingAction
     * @param action defines the next action to execute
     * @returns The action passed in
     * @see https://www.babylonjs-playground.com/#1T30HR#0
     */ then(action) {
        this._child = action;
        action._actionManager = this._actionManager;
        action._prepare();
        return action;
    }
    /**
     * Internal only
     * @internal
     */ _getProperty(propertyPath) {
        return this._actionManager._getProperty(propertyPath);
    }
    /**
     * @internal
     */ _getEffectiveTarget(target, propertyPath) {
        return this._actionManager._getEffectiveTarget(target, propertyPath);
    }
    /**
     * Serialize placeholder for child classes
     * @param parent of child
     * @returns the serialized object
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    serialize(parent) {
        return null;
    }
    /**
     * Internal only called by serialize
     * @internal
     */ _serialize(serializedAction, parent) {
        const serializationObject = {
            type: 1,
            children: [],
            name: serializedAction.name,
            properties: serializedAction.properties || []
        };
        // Serialize child
        if (this._child) this._child.serialize(serializationObject);
        // Check if "this" has a condition
        if (this._condition) {
            const serializedCondition = this._condition.serialize();
            serializedCondition.children.push(serializationObject);
            if (parent) parent.children.push(serializedCondition);
            return serializedCondition;
        }
        if (parent) parent.children.push(serializationObject);
        return serializationObject;
    }
}
/**
 * Internal only
 * @internal
 */ $3e489d8a2af0aefb$export$e19cd5f9376f8cee._SerializeValueAsString = (value)=>{
    if (typeof value === "number") return value.toString();
    if (typeof value === "boolean") return value ? "true" : "false";
    if (value instanceof (0, $ha1VO.Vector2)) return value.x + ", " + value.y;
    if (value instanceof (0, $ha1VO.Vector3)) return value.x + ", " + value.y + ", " + value.z;
    if (value instanceof (0, $7etnY.Color3)) return value.r + ", " + value.g + ", " + value.b;
    if (value instanceof (0, $7etnY.Color4)) return value.r + ", " + value.g + ", " + value.b + ", " + value.a;
    return value; // string
};
/**
 * Internal only
 * @internal
 */ $3e489d8a2af0aefb$export$e19cd5f9376f8cee._GetTargetProperty = (target)=>{
    return {
        name: "target",
        targetType: target._isMesh ? "MeshProperties" : target._isLight ? "LightProperties" : target._isCamera ? "CameraProperties" : target._isMaterial ? "MaterialProperties" : "SceneProperties",
        value: target._isScene ? "Scene" : target.name
    };
};
(0, $8DoUR.RegisterClass)("BABYLON.Action", $3e489d8a2af0aefb$export$e19cd5f9376f8cee);

});
parcelRegister("diGQf", function(module, exports) {

$parcel$export(module.exports, "EventState", () => $9aee303f50159649$export$194fef50961cb62d);
$parcel$export(module.exports, "Observer", () => $9aee303f50159649$export$c1cbdee04e18ea8b);
$parcel$export(module.exports, "Observable", () => $9aee303f50159649$export$77cea355fa80b5f4);
/**
 * A class serves as a medium between the observable and its observers
 */ class $9aee303f50159649$export$194fef50961cb62d {
    /**
     * Create a new EventState
     * @param mask defines the mask associated with this state
     * @param skipNextObservers defines a flag which will instruct the observable to skip following observers when set to true
     * @param target defines the original target of the state
     * @param currentTarget defines the current target of the state
     */ constructor(mask, skipNextObservers = false, target, currentTarget){
        this.initialize(mask, skipNextObservers, target, currentTarget);
    }
    /**
     * Initialize the current event state
     * @param mask defines the mask associated with this state
     * @param skipNextObservers defines a flag which will instruct the observable to skip following observers when set to true
     * @param target defines the original target of the state
     * @param currentTarget defines the current target of the state
     * @returns the current event state
     */ initialize(mask, skipNextObservers = false, target, currentTarget) {
        this.mask = mask;
        this.skipNextObservers = skipNextObservers;
        this.target = target;
        this.currentTarget = currentTarget;
        return this;
    }
}
class $9aee303f50159649$export$c1cbdee04e18ea8b {
    /**
     * Creates a new observer
     * @param callback defines the callback to call when the observer is notified
     * @param mask defines the mask of the observer (used to filter notifications)
     * @param scope defines the current scope used to restore the JS context
     */ constructor(/**
     * Defines the callback to call when the observer is notified
     */ callback, /**
     * Defines the mask of the observer (used to filter notifications)
     */ mask, /**
     * Defines the current scope used to restore the JS context
     */ scope = null){
        this.callback = callback;
        this.mask = mask;
        this.scope = scope;
        /** @internal */ this._willBeUnregistered = false;
        /**
         * Gets or sets a property defining that the observer as to be unregistered after the next notification
         */ this.unregisterOnNextCall = false;
        /**
         * this function can be used to remove the observer from the observable.
         * It will be set by the observable that the observer belongs to.
         * @internal
         */ this._remove = null;
    }
    /**
     * Remove the observer from its observable
     * This can be used instead of using the observable's remove function.
     */ remove() {
        if (this._remove) this._remove();
    }
}
class $9aee303f50159649$export$77cea355fa80b5f4 {
    /**
     * Create an observable from a Promise.
     * @param promise a promise to observe for fulfillment.
     * @param onErrorObservable an observable to notify if a promise was rejected.
     * @returns the new Observable
     */ static FromPromise(promise, onErrorObservable) {
        const observable = new $9aee303f50159649$export$77cea355fa80b5f4();
        promise.then((ret)=>{
            observable.notifyObservers(ret);
        }).catch((err)=>{
            if (onErrorObservable) onErrorObservable.notifyObservers(err);
            else throw err;
        });
        return observable;
    }
    /**
     * Gets the list of observers
     * Note that observers that were recently deleted may still be present in the list because they are only really deleted on the next javascript tick!
     */ get observers() {
        return this._observers;
    }
    /**
     * Creates a new observable
     * @param onObserverAdded defines a callback to call when a new observer is added
     * @param notifyIfTriggered If set to true the observable will notify when an observer was added if the observable was already triggered.
     */ constructor(onObserverAdded, /**
     * If set to true the observable will notify when an observer was added if the observable was already triggered.
     * This is helpful to single-state observables like the scene onReady or the dispose observable.
     */ notifyIfTriggered = false){
        this.notifyIfTriggered = notifyIfTriggered;
        this._observers = new Array();
        this._numObserversMarkedAsDeleted = 0;
        this._hasNotified = false;
        this._eventState = new $9aee303f50159649$export$194fef50961cb62d(0);
        if (onObserverAdded) this._onObserverAdded = onObserverAdded;
    }
    add(callback, mask = -1, insertFirst = false, scope = null, unregisterOnFirstCall = false) {
        if (!callback) return null;
        const observer = new $9aee303f50159649$export$c1cbdee04e18ea8b(callback, mask, scope);
        observer.unregisterOnNextCall = unregisterOnFirstCall;
        if (insertFirst) this._observers.unshift(observer);
        else this._observers.push(observer);
        if (this._onObserverAdded) this._onObserverAdded(observer);
        // If the observable was already triggered and the observable is set to notify if triggered, notify the new observer
        if (this._hasNotified && this.notifyIfTriggered) {
            if (this._lastNotifiedValue !== undefined) this.notifyObserver(observer, this._lastNotifiedValue);
        }
        // attach the remove function to the observer
        observer._remove = ()=>{
            this.remove(observer);
        };
        return observer;
    }
    addOnce(callback) {
        return this.add(callback, undefined, undefined, undefined, true);
    }
    /**
     * Remove an Observer from the Observable object
     * @param observer the instance of the Observer to remove
     * @returns false if it doesn't belong to this Observable
     */ remove(observer) {
        if (!observer) return false;
        observer._remove = null;
        const index = this._observers.indexOf(observer);
        if (index !== -1) {
            this._deferUnregister(observer);
            return true;
        }
        return false;
    }
    /**
     * Remove a callback from the Observable object
     * @param callback the callback to remove
     * @param scope optional scope. If used only the callbacks with this scope will be removed
     * @returns false if it doesn't belong to this Observable
     */ removeCallback(callback, scope) {
        for(let index = 0; index < this._observers.length; index++){
            const observer = this._observers[index];
            if (observer._willBeUnregistered) continue;
            if (observer.callback === callback && (!scope || scope === observer.scope)) {
                this._deferUnregister(observer);
                return true;
            }
        }
        return false;
    }
    /**
     * @internal
     */ _deferUnregister(observer) {
        if (observer._willBeUnregistered) return;
        this._numObserversMarkedAsDeleted++;
        observer.unregisterOnNextCall = false;
        observer._willBeUnregistered = true;
        setTimeout(()=>{
            this._remove(observer);
        }, 0);
    }
    // This should only be called when not iterating over _observers to avoid callback skipping.
    // Removes an observer from the _observer Array.
    _remove(observer, updateCounter = true) {
        if (!observer) return false;
        const index = this._observers.indexOf(observer);
        if (index !== -1) {
            if (updateCounter) this._numObserversMarkedAsDeleted--;
            this._observers.splice(index, 1);
            return true;
        }
        return false;
    }
    /**
     * Moves the observable to the top of the observer list making it get called first when notified
     * @param observer the observer to move
     */ makeObserverTopPriority(observer) {
        this._remove(observer, false);
        this._observers.unshift(observer);
    }
    /**
     * Moves the observable to the bottom of the observer list making it get called last when notified
     * @param observer the observer to move
     */ makeObserverBottomPriority(observer) {
        this._remove(observer, false);
        this._observers.push(observer);
    }
    /**
     * Notify all Observers by calling their respective callback with the given data
     * Will return true if all observers were executed, false if an observer set skipNextObservers to true, then prevent the subsequent ones to execute
     * @param eventData defines the data to send to all observers
     * @param mask defines the mask of the current notification (observers with incompatible mask (ie mask & observer.mask === 0) will not be notified)
     * @param target defines the original target of the state
     * @param currentTarget defines the current target of the state
     * @param userInfo defines any user info to send to observers
     * @returns false if the complete observer chain was not processed (because one observer set the skipNextObservers to true)
     */ notifyObservers(eventData, mask = -1, target, currentTarget, userInfo) {
        // this prevents potential memory leaks - if an object is disposed but the observable doesn't get cleared.
        if (this.notifyIfTriggered) {
            this._hasNotified = true;
            this._lastNotifiedValue = eventData;
        }
        if (!this._observers.length) return true;
        const state = this._eventState;
        state.mask = mask;
        state.target = target;
        state.currentTarget = currentTarget;
        state.skipNextObservers = false;
        state.lastReturnValue = eventData;
        state.userInfo = userInfo;
        for (const obs of this._observers){
            if (obs._willBeUnregistered) continue;
            if (obs.mask & mask) {
                if (obs.unregisterOnNextCall) this._deferUnregister(obs);
                if (obs.scope) state.lastReturnValue = obs.callback.apply(obs.scope, [
                    eventData,
                    state
                ]);
                else state.lastReturnValue = obs.callback(eventData, state);
            }
            if (state.skipNextObservers) return false;
        }
        return true;
    }
    /**
     * Notify a specific observer
     * @param observer defines the observer to notify
     * @param eventData defines the data to be sent to each callback
     * @param mask is used to filter observers defaults to -1
     */ notifyObserver(observer, eventData, mask = -1) {
        // this prevents potential memory leaks - if an object is disposed but the observable doesn't get cleared.
        if (this.notifyIfTriggered) {
            this._hasNotified = true;
            this._lastNotifiedValue = eventData;
        }
        if (observer._willBeUnregistered) return;
        const state = this._eventState;
        state.mask = mask;
        state.skipNextObservers = false;
        if (observer.unregisterOnNextCall) this._deferUnregister(observer);
        observer.callback(eventData, state);
    }
    /**
     * Gets a boolean indicating if the observable has at least one observer
     * @returns true is the Observable has at least one Observer registered
     */ hasObservers() {
        return this._observers.length - this._numObserversMarkedAsDeleted > 0;
    }
    /**
     * Clear the list of observers
     */ clear() {
        while(this._observers.length){
            const o = this._observers.pop();
            if (o) o._remove = null;
        }
        this._onObserverAdded = null;
        this._numObserversMarkedAsDeleted = 0;
        this.cleanLastNotifiedState();
    }
    /**
     * Clean the last notified state - both the internal last value and the has-notified flag
     */ cleanLastNotifiedState() {
        this._hasNotified = false;
        this._lastNotifiedValue = undefined;
    }
    /**
     * Clone the current observable
     * @returns a new observable
     */ clone() {
        const result = new $9aee303f50159649$export$77cea355fa80b5f4();
        result._observers = this._observers.slice(0);
        return result;
    }
    /**
     * Does this observable handles observer registered with a given mask
     * @param mask defines the mask to be tested
     * @returns whether or not one observer registered with the given mask is handled
     **/ hasSpecificMask(mask = -1) {
        for (const obs of this._observers){
            if (obs.mask & mask || obs.mask === mask) return true;
        }
        return false;
    }
}

});

parcelRegister("ha1VO", function(module, exports) {

$parcel$export(module.exports, "Vector2", () => $c7e4de670ed74d35$export$c977b3e384af9ae1);
$parcel$export(module.exports, "Vector3", () => $c7e4de670ed74d35$export$64b5c384219d3699);
$parcel$export(module.exports, "Quaternion", () => $c7e4de670ed74d35$export$23d6a54f0bbc85a3);
$parcel$export(module.exports, "TmpVectors", () => $c7e4de670ed74d35$export$269f00bf0c0718d1);
$parcel$export(module.exports, "Matrix", () => $c7e4de670ed74d35$export$5b12bf1653c0dd85);
$parcel$export(module.exports, "Vector4", () => $c7e4de670ed74d35$export$fa7daccca11cdbe3);
/* eslint-disable @typescript-eslint/naming-convention */ 
var $53VPf = parcelRequire("53VPf");

var $opFp4 = parcelRequire("opFp4");

var $8DoUR = parcelRequire("8DoUR");

var $3agwF = parcelRequire("3agwF");

var $ejQPp = parcelRequire("ejQPp");

var $iosaP = parcelRequire("iosaP");
// eslint-disable-next-line @typescript-eslint/naming-convention
const $c7e4de670ed74d35$var$_ExtractAsInt = (value)=>{
    return parseInt(value.toString().replace(/\W/g, ""));
};
class $c7e4de670ed74d35$export$c977b3e384af9ae1 {
    /**
     * Creates a new Vector2 from the given x and y coordinates
     * @param x defines the first coordinate
     * @param y defines the second coordinate
     */ constructor(/** defines the first coordinate */ x = 0, /** defines the second coordinate */ y = 0){
        this.x = x;
        this.y = y;
    }
    /**
     * Gets a string with the Vector2 coordinates
     * @returns a string with the Vector2 coordinates
     */ toString() {
        return `{X: ${this.x} Y: ${this.y}}`;
    }
    /**
     * Gets class name
     * @returns the string "Vector2"
     */ getClassName() {
        return "Vector2";
    }
    /**
     * Gets current vector hash code
     * @returns the Vector2 hash code as a number
     */ getHashCode() {
        const x = $c7e4de670ed74d35$var$_ExtractAsInt(this.x);
        const y = $c7e4de670ed74d35$var$_ExtractAsInt(this.y);
        let hash = x;
        hash = hash * 397 ^ y;
        return hash;
    }
    // Operators
    /**
     * Sets the Vector2 coordinates in the given array or Float32Array from the given index.
     * Example Playground https://playground.babylonjs.com/#QYBWV4#15
     * @param array defines the source array
     * @param index defines the offset in source array
     * @returns the current Vector2
     */ toArray(array, index = 0) {
        array[index] = this.x;
        array[index + 1] = this.y;
        return this;
    }
    /**
     * Update the current vector from an array
     * Example Playground https://playground.babylonjs.com/#QYBWV4#39
     * @param array defines the destination array
     * @param offset defines the offset in the destination array
     * @returns the current Vector2
     */ fromArray(array, offset = 0) {
        $c7e4de670ed74d35$export$c977b3e384af9ae1.FromArrayToRef(array, offset, this);
        return this;
    }
    /**
     * Copy the current vector to an array
     * Example Playground https://playground.babylonjs.com/#QYBWV4#40
     * @returns a new array with 2 elements: the Vector2 coordinates.
     */ asArray() {
        return [
            this.x,
            this.y
        ];
    }
    /**
     * Sets the Vector2 coordinates with the given Vector2 coordinates
     * Example Playground https://playground.babylonjs.com/#QYBWV4#24
     * @param source defines the source Vector2
     * @returns the current updated Vector2
     */ copyFrom(source) {
        this.x = source.x;
        this.y = source.y;
        return this;
    }
    /**
     * Sets the Vector2 coordinates with the given floats
     * Example Playground https://playground.babylonjs.com/#QYBWV4#25
     * @param x defines the first coordinate
     * @param y defines the second coordinate
     * @returns the current updated Vector2
     */ copyFromFloats(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    /**
     * Sets the Vector2 coordinates with the given floats
     * Example Playground https://playground.babylonjs.com/#QYBWV4#62
     * @param x defines the first coordinate
     * @param y defines the second coordinate
     * @returns the current updated Vector2
     */ set(x, y) {
        return this.copyFromFloats(x, y);
    }
    /**
     * Copies the given float to the current Vector2 coordinates
     * @param v defines the x and y coordinates of the operand
     * @returns the current updated Vector2
     */ setAll(v) {
        return this.copyFromFloats(v, v);
    }
    /**
     * Add another vector with the current one
     * Example Playground https://playground.babylonjs.com/#QYBWV4#11
     * @param otherVector defines the other vector
     * @returns a new Vector2 set with the addition of the current Vector2 and the given one coordinates
     */ add(otherVector) {
        return new this.constructor(this.x + otherVector.x, this.y + otherVector.y);
    }
    /**
     * Sets the "result" coordinates with the addition of the current Vector2 and the given one coordinates
     * Example Playground https://playground.babylonjs.com/#QYBWV4#12
     * @param otherVector defines the other vector
     * @param result defines the target vector
     * @returns result input
     */ addToRef(otherVector, result) {
        result.x = this.x + otherVector.x;
        result.y = this.y + otherVector.y;
        return result;
    }
    /**
     * Set the Vector2 coordinates by adding the given Vector2 coordinates
     * Example Playground https://playground.babylonjs.com/#QYBWV4#13
     * @param otherVector defines the other vector
     * @returns the current updated Vector2
     */ addInPlace(otherVector) {
        this.x += otherVector.x;
        this.y += otherVector.y;
        return this;
    }
    /**
     * Adds the given coordinates to the current Vector2
     * @param x defines the x coordinate of the operand
     * @param y defines the y coordinate of the operand
     * @returns the current updated Vector2
     */ addInPlaceFromFloats(x, y) {
        this.x += x;
        this.y += y;
        return this;
    }
    /**
     * Gets a new Vector2 by adding the current Vector2 coordinates to the given Vector3 x, y coordinates
     * Example Playground https://playground.babylonjs.com/#QYBWV4#14
     * @param otherVector defines the other vector
     * @returns a new Vector2
     */ addVector3(otherVector) {
        return new this.constructor(this.x + otherVector.x, this.y + otherVector.y);
    }
    /**
     * Gets a new Vector2 set with the subtracted coordinates of the given one from the current Vector2
     * Example Playground https://playground.babylonjs.com/#QYBWV4#61
     * @param otherVector defines the other vector
     * @returns a new Vector2
     */ subtract(otherVector) {
        return new this.constructor(this.x - otherVector.x, this.y - otherVector.y);
    }
    /**
     * Sets the "result" coordinates with the subtraction of the given one from the current Vector2 coordinates.
     * Example Playground https://playground.babylonjs.com/#QYBWV4#63
     * @param otherVector defines the other vector
     * @param result defines the target vector
     * @returns result input
     */ subtractToRef(otherVector, result) {
        result.x = this.x - otherVector.x;
        result.y = this.y - otherVector.y;
        return result;
    }
    /**
     * Sets the current Vector2 coordinates by subtracting from it the given one coordinates
     * Example Playground https://playground.babylonjs.com/#QYBWV4#88
     * @param otherVector defines the other vector
     * @returns the current updated Vector2
     */ subtractInPlace(otherVector) {
        this.x -= otherVector.x;
        this.y -= otherVector.y;
        return this;
    }
    /**
     * Multiplies in place the current Vector2 coordinates by the given ones
     * Example Playground https://playground.babylonjs.com/#QYBWV4#43
     * @param otherVector defines the other vector
     * @returns the current updated Vector2
     */ multiplyInPlace(otherVector) {
        this.x *= otherVector.x;
        this.y *= otherVector.y;
        return this;
    }
    /**
     * Returns a new Vector2 set with the multiplication of the current Vector2 and the given one coordinates
     * Example Playground https://playground.babylonjs.com/#QYBWV4#42
     * @param otherVector defines the other vector
     * @returns a new Vector2
     */ multiply(otherVector) {
        return new this.constructor(this.x * otherVector.x, this.y * otherVector.y);
    }
    /**
     * Sets "result" coordinates with the multiplication of the current Vector2 and the given one coordinates
     * Example Playground https://playground.babylonjs.com/#QYBWV4#44
     * @param otherVector defines the other vector
     * @param result defines the target vector
     * @returns result input
     */ multiplyToRef(otherVector, result) {
        result.x = this.x * otherVector.x;
        result.y = this.y * otherVector.y;
        return result;
    }
    /**
     * Gets a new Vector2 set with the Vector2 coordinates multiplied by the given floats
     * Example Playground https://playground.babylonjs.com/#QYBWV4#89
     * @param x defines the first coordinate
     * @param y defines the second coordinate
     * @returns a new Vector2
     */ multiplyByFloats(x, y) {
        return new this.constructor(this.x * x, this.y * y);
    }
    /**
     * Returns a new Vector2 set with the Vector2 coordinates divided by the given one coordinates
     * Example Playground https://playground.babylonjs.com/#QYBWV4#27
     * @param otherVector defines the other vector
     * @returns a new Vector2
     */ divide(otherVector) {
        return new this.constructor(this.x / otherVector.x, this.y / otherVector.y);
    }
    /**
     * Sets the "result" coordinates with the Vector2 divided by the given one coordinates
     * Example Playground https://playground.babylonjs.com/#QYBWV4#30
     * @param otherVector defines the other vector
     * @param result defines the target vector
     * @returns result input
     */ divideToRef(otherVector, result) {
        result.x = this.x / otherVector.x;
        result.y = this.y / otherVector.y;
        return result;
    }
    /**
     * Divides the current Vector2 coordinates by the given ones
     * Example Playground https://playground.babylonjs.com/#QYBWV4#28
     * @param otherVector defines the other vector
     * @returns the current updated Vector2
     */ divideInPlace(otherVector) {
        this.x = this.x / otherVector.x;
        this.y = this.y / otherVector.y;
        return this;
    }
    /**
     * Updates the current Vector2 with the minimal coordinate values between its and the given vector ones
     * @param other defines the second operand
     * @returns the current updated Vector2
     */ minimizeInPlace(other) {
        return this.minimizeInPlaceFromFloats(other.x, other.y);
    }
    /**
     * Updates the current Vector2 with the maximal coordinate values between its and the given vector ones.
     * @param other defines the second operand
     * @returns the current updated Vector2
     */ maximizeInPlace(other) {
        return this.maximizeInPlaceFromFloats(other.x, other.y);
    }
    /**
     * Updates the current Vector2 with the minimal coordinate values between its and the given coordinates
     * @param x defines the x coordinate of the operand
     * @param y defines the y coordinate of the operand
     * @returns the current updated Vector2
     */ minimizeInPlaceFromFloats(x, y) {
        this.x = Math.min(x, this.x);
        this.y = Math.min(y, this.y);
        return this;
    }
    /**
     * Updates the current Vector2 with the maximal coordinate values between its and the given coordinates.
     * @param x defines the x coordinate of the operand
     * @param y defines the y coordinate of the operand
     * @returns the current updated Vector2
     */ maximizeInPlaceFromFloats(x, y) {
        this.x = Math.max(x, this.x);
        this.y = Math.max(y, this.y);
        return this;
    }
    /**
     * Returns a new Vector2 set with the subtraction of the given floats from the current Vector2 coordinates
     * @param x defines the x coordinate of the operand
     * @param y defines the y coordinate of the operand
     * @returns the resulting Vector2
     */ subtractFromFloats(x, y) {
        return new this.constructor(this.x - x, this.y - y);
    }
    /**
     * Subtracts the given floats from the current Vector2 coordinates and set the given vector "result" with this result
     * @param x defines the x coordinate of the operand
     * @param y defines the y coordinate of the operand
     * @param result defines the Vector2 object where to store the result
     * @returns the result
     */ subtractFromFloatsToRef(x, y, result) {
        return result.copyFromFloats(this.x - x, this.y - y);
    }
    /**
     * Gets a new Vector2 with current Vector2 negated coordinates
     * @returns a new Vector2
     */ negate() {
        return new this.constructor(-this.x, -this.y);
    }
    /**
     * Negate this vector in place
     * Example Playground https://playground.babylonjs.com/#QYBWV4#23
     * @returns this
     */ negateInPlace() {
        this.x *= -1;
        this.y *= -1;
        return this;
    }
    /**
     * Negate the current Vector2 and stores the result in the given vector "result" coordinates
     * Example Playground https://playground.babylonjs.com/#QYBWV4#41
     * @param result defines the Vector3 object where to store the result
     * @returns the result
     */ negateToRef(result) {
        return result.copyFromFloats(this.x * -1, this.y * -1);
    }
    /**
     * Multiply the Vector2 coordinates by
     * Example Playground https://playground.babylonjs.com/#QYBWV4#59
     * @param scale defines the scaling factor
     * @returns the current updated Vector2
     */ scaleInPlace(scale) {
        this.x *= scale;
        this.y *= scale;
        return this;
    }
    /**
     * Returns a new Vector2 scaled by "scale" from the current Vector2
     * Example Playground https://playground.babylonjs.com/#QYBWV4#52
     * @param scale defines the scaling factor
     * @returns a new Vector2
     */ scale(scale) {
        return new this.constructor(this.x * scale, this.y * scale);
    }
    /**
     * Scale the current Vector2 values by a factor to a given Vector2
     * Example Playground https://playground.babylonjs.com/#QYBWV4#57
     * @param scale defines the scale factor
     * @param result defines the Vector2 object where to store the result
     * @returns result input
     */ scaleToRef(scale, result) {
        result.x = this.x * scale;
        result.y = this.y * scale;
        return result;
    }
    /**
     * Scale the current Vector2 values by a factor and add the result to a given Vector2
     * Example Playground https://playground.babylonjs.com/#QYBWV4#58
     * @param scale defines the scale factor
     * @param result defines the Vector2 object where to store the result
     * @returns result input
     */ scaleAndAddToRef(scale, result) {
        result.x += this.x * scale;
        result.y += this.y * scale;
        return result;
    }
    /**
     * Gets a boolean if two vectors are equals
     * Example Playground https://playground.babylonjs.com/#QYBWV4#31
     * @param otherVector defines the other vector
     * @returns true if the given vector coordinates strictly equal the current Vector2 ones
     */ equals(otherVector) {
        return otherVector && this.x === otherVector.x && this.y === otherVector.y;
    }
    /**
     * Gets a boolean if two vectors are equals (using an epsilon value)
     * Example Playground https://playground.babylonjs.com/#QYBWV4#32
     * @param otherVector defines the other vector
     * @param epsilon defines the minimal distance to consider equality
     * @returns true if the given vector coordinates are close to the current ones by a distance of epsilon.
     */ equalsWithEpsilon(otherVector, epsilon = (0, $53VPf.Epsilon)) {
        return otherVector && (0, $iosaP.WithinEpsilon)(this.x, otherVector.x, epsilon) && (0, $iosaP.WithinEpsilon)(this.y, otherVector.y, epsilon);
    }
    /**
     * Returns true if the current Vector2 coordinates equals the given floats
     * @param x defines the x coordinate of the operand
     * @param y defines the y coordinate of the operand
     * @returns true if both vectors are equal
     */ equalsToFloats(x, y) {
        return this.x === x && this.y === y;
    }
    /**
     * Gets a new Vector2 from current Vector2 floored values
     * Example Playground https://playground.babylonjs.com/#QYBWV4#35
     * eg (1.2, 2.31) returns (1, 2)
     * @returns a new Vector2
     */ floor() {
        return new this.constructor(Math.floor(this.x), Math.floor(this.y));
    }
    /**
     * Gets the current Vector2's floored values and stores them in result
     * @param result the Vector2 to store the result in
     * @returns the result Vector2
     */ floorToRef(result) {
        result.x = Math.floor(this.x);
        result.y = Math.floor(this.y);
        return result;
    }
    /**
     * Gets a new Vector2 from current Vector2 fractional values
     * Example Playground https://playground.babylonjs.com/#QYBWV4#34
     * eg (1.2, 2.31) returns (0.2, 0.31)
     * @returns a new Vector2
     */ fract() {
        return new this.constructor(this.x - Math.floor(this.x), this.y - Math.floor(this.y));
    }
    /**
     * Gets the current Vector2's fractional values and stores them in result
     * @param result the Vector2 to store the result in
     * @returns the result Vector2
     */ fractToRef(result) {
        result.x = this.x - Math.floor(this.x);
        result.y = this.y - Math.floor(this.y);
        return result;
    }
    /**
     * Rotate the current vector into a given result vector
     * Example Playground https://playground.babylonjs.com/#QYBWV4#49
     * @param angle defines the rotation angle
     * @param result defines the result vector where to store the rotated vector
     * @returns result input
     */ rotateToRef(angle, result) {
        const cos = Math.cos(angle);
        const sin = Math.sin(angle);
        const x = cos * this.x - sin * this.y;
        const y = sin * this.x + cos * this.y;
        result.x = x;
        result.y = y;
        return result;
    }
    // Properties
    /**
     * Gets the length of the vector
     * @returns the vector length (float)
     */ length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    /**
     * Gets the vector squared length
     * @returns the vector squared length (float)
     */ lengthSquared() {
        return this.x * this.x + this.y * this.y;
    }
    // Methods
    /**
     * Normalize the vector
     * Example Playground https://playground.babylonjs.com/#QYBWV4#48
     * @returns the current updated Vector2
     */ normalize() {
        return this.normalizeFromLength(this.length());
    }
    /**
     * Normalize the current Vector2 with the given input length.
     * Please note that this is an in place operation.
     * @param len the length of the vector
     * @returns the current updated Vector2
     */ normalizeFromLength(len) {
        if (len === 0 || len === 1.0) return this;
        return this.scaleInPlace(1.0 / len);
    }
    /**
     * Normalize the current Vector2 to a new vector
     * @returns the new Vector2
     */ normalizeToNew() {
        const normalized = new this.constructor();
        this.normalizeToRef(normalized);
        return normalized;
    }
    /**
     * Normalize the current Vector2 to the reference
     * @param reference define the Vector to update
     * @returns the updated Vector2
     */ normalizeToRef(reference) {
        const len = this.length();
        if (len === 0) return reference.copyFrom(this);
        return this.scaleToRef(1.0 / len, reference);
    }
    /**
     * Gets a new Vector2 copied from the Vector2
     * Example Playground https://playground.babylonjs.com/#QYBWV4#20
     * @returns a new Vector2
     */ clone() {
        return new this.constructor(this.x, this.y);
    }
    /**
     * Gets the dot product of the current vector and the vector "otherVector"
     * @param otherVector defines second vector
     * @returns the dot product (float)
     */ dot(otherVector) {
        return this.x * otherVector.x + this.y * otherVector.y;
    }
    // Statics
    /**
     * Gets a new Vector2(0, 0)
     * @returns a new Vector2
     */ static Zero() {
        return new $c7e4de670ed74d35$export$c977b3e384af9ae1(0, 0);
    }
    /**
     * Gets a new Vector2(1, 1)
     * @returns a new Vector2
     */ static One() {
        return new $c7e4de670ed74d35$export$c977b3e384af9ae1(1, 1);
    }
    /**
     * Returns a new Vector2 with random values between min and max
     * @param min the minimum random value
     * @param max the maximum random value
     * @returns a Vector2 with random values between min and max
     */ static Random(min = 0, max = 1) {
        return new $c7e4de670ed74d35$export$c977b3e384af9ae1((0, $iosaP.RandomRange)(min, max), (0, $iosaP.RandomRange)(min, max));
    }
    /**
     * Sets a Vector2 with random values between min and max
     * @param min the minimum random value
     * @param max the maximum random value
     * @param ref the ref to store the values in
     * @returns the ref with random values between min and max
     */ static RandomToRef(min = 0, max = 1, ref) {
        return ref.copyFromFloats((0, $iosaP.RandomRange)(min, max), (0, $iosaP.RandomRange)(min, max));
    }
    /**
     * Gets a zero Vector2 that must not be updated
     */ static get ZeroReadOnly() {
        return $c7e4de670ed74d35$export$c977b3e384af9ae1._ZeroReadOnly;
    }
    /**
     * Gets a new Vector2 set from the given index element of the given array
     * Example Playground https://playground.babylonjs.com/#QYBWV4#79
     * @param array defines the data source
     * @param offset defines the offset in the data source
     * @returns a new Vector2
     */ static FromArray(array, offset = 0) {
        return new $c7e4de670ed74d35$export$c977b3e384af9ae1(array[offset], array[offset + 1]);
    }
    /**
     * Sets "result" from the given index element of the given array
     * Example Playground https://playground.babylonjs.com/#QYBWV4#80
     * @param array defines the data source
     * @param offset defines the offset in the data source
     * @param result defines the target vector
     * @returns result input
     */ static FromArrayToRef(array, offset, result) {
        result.x = array[offset];
        result.y = array[offset + 1];
        return result;
    }
    /**
     * Sets the given vector "result" with the given floats.
     * @param x defines the x coordinate of the source
     * @param y defines the y coordinate of the source
     * @param result defines the Vector2 where to store the result
     * @returns the result vector
     */ static FromFloatsToRef(x, y, result) {
        result.copyFromFloats(x, y);
        return result;
    }
    /**
     * Gets a new Vector2 located for "amount" (float) on the CatmullRom spline defined by the given four Vector2
     * Example Playground https://playground.babylonjs.com/#QYBWV4#65
     * @param value1 defines 1st point of control
     * @param value2 defines 2nd point of control
     * @param value3 defines 3rd point of control
     * @param value4 defines 4th point of control
     * @param amount defines the interpolation factor
     * @returns a new Vector2
     */ static CatmullRom(value1, value2, value3, value4, amount) {
        const squared = amount * amount;
        const cubed = amount * squared;
        const x = 0.5 * (2.0 * value2.x + (-value1.x + value3.x) * amount + (2.0 * value1.x - 5.0 * value2.x + 4.0 * value3.x - value4.x) * squared + (-value1.x + 3.0 * value2.x - 3.0 * value3.x + value4.x) * cubed);
        const y = 0.5 * (2.0 * value2.y + (-value1.y + value3.y) * amount + (2.0 * value1.y - 5.0 * value2.y + 4.0 * value3.y - value4.y) * squared + (-value1.y + 3.0 * value2.y - 3.0 * value3.y + value4.y) * cubed);
        return new value1.constructor(x, y);
    }
    /**
     * Sets reference with same the coordinates than "value" ones if the vector "value" is in the square defined by "min" and "max".
     * If a coordinate of "value" is lower than "min" coordinates, the returned Vector2 is given this "min" coordinate.
     * If a coordinate of "value" is greater than "max" coordinates, the returned Vector2 is given this "max" coordinate
     * @param value defines the value to clamp
     * @param min defines the lower limit
     * @param max defines the upper limit
     * @param ref the reference
     * @returns the reference
     */ static ClampToRef(value, min, max, ref) {
        ref.x = (0, $iosaP.Clamp)(value.x, min.x, max.x);
        ref.y = (0, $iosaP.Clamp)(value.y, min.y, max.y);
        return ref;
    }
    /**
     * Returns a new Vector2 set with same the coordinates than "value" ones if the vector "value" is in the square defined by "min" and "max".
     * If a coordinate of "value" is lower than "min" coordinates, the returned Vector2 is given this "min" coordinate.
     * If a coordinate of "value" is greater than "max" coordinates, the returned Vector2 is given this "max" coordinate
     * Example Playground https://playground.babylonjs.com/#QYBWV4#76
     * @param value defines the value to clamp
     * @param min defines the lower limit
     * @param max defines the upper limit
     * @returns a new Vector2
     */ static Clamp(value, min, max) {
        const x = (0, $iosaP.Clamp)(value.x, min.x, max.x);
        const y = (0, $iosaP.Clamp)(value.y, min.y, max.y);
        return new value.constructor(x, y);
    }
    /**
     * Returns a new Vector2 located for "amount" (float) on the Hermite spline defined by the vectors "value1", "value2", "tangent1", "tangent2"
     * Example Playground https://playground.babylonjs.com/#QYBWV4#81
     * @param value1 defines the 1st control point
     * @param tangent1 defines the outgoing tangent
     * @param value2 defines the 2nd control point
     * @param tangent2 defines the incoming tangent
     * @param amount defines the interpolation factor
     * @returns a new Vector2
     */ static Hermite(value1, tangent1, value2, tangent2, amount) {
        const squared = amount * amount;
        const cubed = amount * squared;
        const part1 = 2.0 * cubed - 3.0 * squared + 1.0;
        const part2 = -2 * cubed + 3.0 * squared;
        const part3 = cubed - 2.0 * squared + amount;
        const part4 = cubed - squared;
        const x = value1.x * part1 + value2.x * part2 + tangent1.x * part3 + tangent2.x * part4;
        const y = value1.y * part1 + value2.y * part2 + tangent1.y * part3 + tangent2.y * part4;
        return new value1.constructor(x, y);
    }
    /**
     * Returns a new Vector2 which is the 1st derivative of the Hermite spline defined by the vectors "value1", "value2", "tangent1", "tangent2".
     * Example Playground https://playground.babylonjs.com/#QYBWV4#82
     * @param value1 defines the first control point
     * @param tangent1 defines the first tangent
     * @param value2 defines the second control point
     * @param tangent2 defines the second tangent
     * @param time define where the derivative must be done
     * @returns 1st derivative
     */ static Hermite1stDerivative(value1, tangent1, value2, tangent2, time) {
        const result = new value1.constructor();
        this.Hermite1stDerivativeToRef(value1, tangent1, value2, tangent2, time, result);
        return result;
    }
    /**
     * Returns a new Vector2 which is the 1st derivative of the Hermite spline defined by the vectors "value1", "value2", "tangent1", "tangent2".
     * Example Playground https://playground.babylonjs.com/#QYBWV4#83
     * @param value1 defines the first control point
     * @param tangent1 defines the first tangent
     * @param value2 defines the second control point
     * @param tangent2 defines the second tangent
     * @param time define where the derivative must be done
     * @param result define where the derivative will be stored
     * @returns result input
     */ static Hermite1stDerivativeToRef(value1, tangent1, value2, tangent2, time, result) {
        const t2 = time * time;
        result.x = (t2 - time) * 6 * value1.x + (3 * t2 - 4 * time + 1) * tangent1.x + (-t2 + time) * 6 * value2.x + (3 * t2 - 2 * time) * tangent2.x;
        result.y = (t2 - time) * 6 * value1.y + (3 * t2 - 4 * time + 1) * tangent1.y + (-t2 + time) * 6 * value2.y + (3 * t2 - 2 * time) * tangent2.y;
        return result;
    }
    /**
     * Returns a new Vector2 located for "amount" (float) on the linear interpolation between the vector "start" adn the vector "end".
     * Example Playground https://playground.babylonjs.com/#QYBWV4#84
     * @param start defines the start vector
     * @param end defines the end vector
     * @param amount defines the interpolation factor
     * @returns a new Vector2
     */ static Lerp(start, end, amount) {
        const x = start.x + (end.x - start.x) * amount;
        const y = start.y + (end.y - start.y) * amount;
        return new start.constructor(x, y);
    }
    /**
     * Gets the dot product of the vector "left" and the vector "right"
     * Example Playground https://playground.babylonjs.com/#QYBWV4#90
     * @param left defines first vector
     * @param right defines second vector
     * @returns the dot product (float)
     */ static Dot(left, right) {
        return left.x * right.x + left.y * right.y;
    }
    /**
     * Returns a new Vector2 equal to the normalized given vector
     * Example Playground https://playground.babylonjs.com/#QYBWV4#46
     * @param vector defines the vector to normalize
     * @returns a new Vector2
     */ static Normalize(vector) {
        const result = new vector.constructor();
        $c7e4de670ed74d35$export$c977b3e384af9ae1.NormalizeToRef(vector, result);
        return result;
    }
    /**
     * Normalize a given vector into a second one
     * Example Playground https://playground.babylonjs.com/#QYBWV4#50
     * @param vector defines the vector to normalize
     * @param result defines the vector where to store the result
     * @returns result input
     */ static NormalizeToRef(vector, result) {
        vector.normalizeToRef(result);
        return result;
    }
    /**
     * Gets a new Vector2 set with the minimal coordinate values from the "left" and "right" vectors
     * Example Playground https://playground.babylonjs.com/#QYBWV4#86
     * @param left defines 1st vector
     * @param right defines 2nd vector
     * @returns a new Vector2
     */ static Minimize(left, right) {
        const x = left.x < right.x ? left.x : right.x;
        const y = left.y < right.y ? left.y : right.y;
        return new left.constructor(x, y);
    }
    /**
     * Gets a new Vector2 set with the maximal coordinate values from the "left" and "right" vectors
     * Example Playground https://playground.babylonjs.com/#QYBWV4#86
     * @param left defines 1st vector
     * @param right defines 2nd vector
     * @returns a new Vector2
     */ static Maximize(left, right) {
        const x = left.x > right.x ? left.x : right.x;
        const y = left.y > right.y ? left.y : right.y;
        return new left.constructor(x, y);
    }
    /**
     * Gets a new Vector2 set with the transformed coordinates of the given vector by the given transformation matrix
     * Example Playground https://playground.babylonjs.com/#QYBWV4#17
     * @param vector defines the vector to transform
     * @param transformation defines the matrix to apply
     * @returns a new Vector2
     */ static Transform(vector, transformation) {
        const result = new vector.constructor();
        $c7e4de670ed74d35$export$c977b3e384af9ae1.TransformToRef(vector, transformation, result);
        return result;
    }
    /**
     * Transforms the given vector coordinates by the given transformation matrix and stores the result in the vector "result" coordinates
     * Example Playground https://playground.babylonjs.com/#QYBWV4#19
     * @param vector defines the vector to transform
     * @param transformation defines the matrix to apply
     * @param result defines the target vector
     * @returns result input
     */ static TransformToRef(vector, transformation, result) {
        const m = transformation.m;
        const x = vector.x * m[0] + vector.y * m[4] + m[12];
        const y = vector.x * m[1] + vector.y * m[5] + m[13];
        result.x = x;
        result.y = y;
        return result;
    }
    /**
     * Determines if a given vector is included in a triangle
     * Example Playground https://playground.babylonjs.com/#QYBWV4#87
     * @param p defines the vector to test
     * @param p0 defines 1st triangle point
     * @param p1 defines 2nd triangle point
     * @param p2 defines 3rd triangle point
     * @returns true if the point "p" is in the triangle defined by the vectors "p0", "p1", "p2"
     */ static PointInTriangle(p, p0, p1, p2) {
        const a = 0.5 * (-p1.y * p2.x + p0.y * (-p1.x + p2.x) + p0.x * (p1.y - p2.y) + p1.x * p2.y);
        const sign = a < 0 ? -1 : 1;
        const s = (p0.y * p2.x - p0.x * p2.y + (p2.y - p0.y) * p.x + (p0.x - p2.x) * p.y) * sign;
        const t = (p0.x * p1.y - p0.y * p1.x + (p0.y - p1.y) * p.x + (p1.x - p0.x) * p.y) * sign;
        return s > 0 && t > 0 && s + t < 2 * a * sign;
    }
    /**
     * Gets the distance between the vectors "value1" and "value2"
     * Example Playground https://playground.babylonjs.com/#QYBWV4#71
     * @param value1 defines first vector
     * @param value2 defines second vector
     * @returns the distance between vectors
     */ static Distance(value1, value2) {
        return Math.sqrt($c7e4de670ed74d35$export$c977b3e384af9ae1.DistanceSquared(value1, value2));
    }
    /**
     * Returns the squared distance between the vectors "value1" and "value2"
     * Example Playground https://playground.babylonjs.com/#QYBWV4#72
     * @param value1 defines first vector
     * @param value2 defines second vector
     * @returns the squared distance between vectors
     */ static DistanceSquared(value1, value2) {
        const x = value1.x - value2.x;
        const y = value1.y - value2.y;
        return x * x + y * y;
    }
    /**
     * Gets a new Vector2 located at the center of the vectors "value1" and "value2"
     * Example Playground https://playground.babylonjs.com/#QYBWV4#86
     * Example Playground https://playground.babylonjs.com/#QYBWV4#66
     * @param value1 defines first vector
     * @param value2 defines second vector
     * @returns a new Vector2
     */ static Center(value1, value2) {
        const result = new value1.constructor();
        return $c7e4de670ed74d35$export$c977b3e384af9ae1.CenterToRef(value1, value2, result);
    }
    /**
     * Gets the center of the vectors "value1" and "value2" and stores the result in the vector "ref"
     * Example Playground https://playground.babylonjs.com/#QYBWV4#66
     * @param value1 defines first vector
     * @param value2 defines second vector
     * @param ref defines third vector
     * @returns ref
     */ static CenterToRef(value1, value2, ref) {
        return ref.copyFromFloats((value1.x + value2.x) / 2, (value1.y + value2.y) / 2);
    }
    /**
     * Gets the shortest distance (float) between the point "p" and the segment defined by the two points "segA" and "segB".
     * Example Playground https://playground.babylonjs.com/#QYBWV4#77
     * @param p defines the middle point
     * @param segA defines one point of the segment
     * @param segB defines the other point of the segment
     * @returns the shortest distance
     */ static DistanceOfPointFromSegment(p, segA, segB) {
        const l2 = $c7e4de670ed74d35$export$c977b3e384af9ae1.DistanceSquared(segA, segB);
        if (l2 === 0.0) return $c7e4de670ed74d35$export$c977b3e384af9ae1.Distance(p, segA);
        const v = segB.subtract(segA);
        const t = Math.max(0, Math.min(1, $c7e4de670ed74d35$export$c977b3e384af9ae1.Dot(p.subtract(segA), v) / l2));
        const proj = segA.add(v.multiplyByFloats(t, t));
        return $c7e4de670ed74d35$export$c977b3e384af9ae1.Distance(p, proj);
    }
}
$c7e4de670ed74d35$export$c977b3e384af9ae1._ZeroReadOnly = $c7e4de670ed74d35$export$c977b3e384af9ae1.Zero();
$c7e4de670ed74d35$export$c977b3e384af9ae1;
Object.defineProperties($c7e4de670ed74d35$export$c977b3e384af9ae1.prototype, {
    dimension: {
        value: [
            2
        ]
    },
    rank: {
        value: 1
    }
});
class $c7e4de670ed74d35$export$64b5c384219d3699 {
    /** Gets or sets the x coordinate */ get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._isDirty = true;
    }
    /** Gets or sets the y coordinate */ get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._isDirty = true;
    }
    /** Gets or sets the z coordinate */ get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._isDirty = true;
    }
    /**
     * Creates a new Vector3 object from the given x, y, z (floats) coordinates.
     * @param x defines the first coordinates (on X axis)
     * @param y defines the second coordinates (on Y axis)
     * @param z defines the third coordinates (on Z axis)
     */ constructor(x = 0, y = 0, z = 0){
        /** @internal */ this._isDirty = true;
        this._x = x;
        this._y = y;
        this._z = z;
    }
    /**
     * Creates a string representation of the Vector3
     * Example Playground https://playground.babylonjs.com/#R1F8YU#67
     * @returns a string with the Vector3 coordinates.
     */ toString() {
        return `{X: ${this._x} Y: ${this._y} Z: ${this._z}}`;
    }
    /**
     * Gets the class name
     * @returns the string "Vector3"
     */ getClassName() {
        return "Vector3";
    }
    /**
     * Creates the Vector3 hash code
     * @returns a number which tends to be unique between Vector3 instances
     */ getHashCode() {
        const x = $c7e4de670ed74d35$var$_ExtractAsInt(this._x);
        const y = $c7e4de670ed74d35$var$_ExtractAsInt(this._y);
        const z = $c7e4de670ed74d35$var$_ExtractAsInt(this._z);
        let hash = x;
        hash = hash * 397 ^ y;
        hash = hash * 397 ^ z;
        return hash;
    }
    // Operators
    /**
     * Creates an array containing three elements : the coordinates of the Vector3
     * Example Playground https://playground.babylonjs.com/#R1F8YU#10
     * @returns a new array of numbers
     */ asArray() {
        return [
            this._x,
            this._y,
            this._z
        ];
    }
    /**
     * Populates the given array or Float32Array from the given index with the successive coordinates of the Vector3
     * Example Playground https://playground.babylonjs.com/#R1F8YU#65
     * @param array defines the destination array
     * @param index defines the offset in the destination array
     * @returns the current Vector3
     */ toArray(array, index = 0) {
        array[index] = this._x;
        array[index + 1] = this._y;
        array[index + 2] = this._z;
        return this;
    }
    /**
     * Update the current vector from an array
     * Example Playground https://playground.babylonjs.com/#R1F8YU#24
     * @param array defines the destination array
     * @param offset defines the offset in the destination array
     * @returns the current Vector3
     */ fromArray(array, offset = 0) {
        $c7e4de670ed74d35$export$64b5c384219d3699.FromArrayToRef(array, offset, this);
        return this;
    }
    /**
     * Converts the current Vector3 into a quaternion (considering that the Vector3 contains Euler angles representation of a rotation)
     * Example Playground https://playground.babylonjs.com/#R1F8YU#66
     * @returns a new Quaternion object, computed from the Vector3 coordinates
     */ toQuaternion() {
        return $c7e4de670ed74d35$export$23d6a54f0bbc85a3.RotationYawPitchRoll(this._y, this._x, this._z);
    }
    /**
     * Adds the given vector to the current Vector3
     * Example Playground https://playground.babylonjs.com/#R1F8YU#4
     * @param otherVector defines the second operand
     * @returns the current updated Vector3
     */ addInPlace(otherVector) {
        this._x += otherVector._x;
        this._y += otherVector._y;
        this._z += otherVector._z;
        this._isDirty = true;
        return this;
    }
    /**
     * Adds the given coordinates to the current Vector3
     * Example Playground https://playground.babylonjs.com/#R1F8YU#5
     * @param x defines the x coordinate of the operand
     * @param y defines the y coordinate of the operand
     * @param z defines the z coordinate of the operand
     * @returns the current updated Vector3
     */ addInPlaceFromFloats(x, y, z) {
        this._x += x;
        this._y += y;
        this._z += z;
        this._isDirty = true;
        return this;
    }
    /**
     * Gets a new Vector3, result of the addition the current Vector3 and the given vector
     * Example Playground https://playground.babylonjs.com/#R1F8YU#3
     * @param otherVector defines the second operand
     * @returns the resulting Vector3
     */ add(otherVector) {
        return new this.constructor(this._x + otherVector._x, this._y + otherVector._y, this._z + otherVector._z);
    }
    /**
     * Adds the current Vector3 to the given one and stores the result in the vector "result"
     * Example Playground https://playground.babylonjs.com/#R1F8YU#6
     * @param otherVector defines the second operand
     * @param result defines the Vector3 object where to store the result
     * @returns the result
     */ addToRef(otherVector, result) {
        return result.copyFromFloats(this._x + otherVector._x, this._y + otherVector._y, this._z + otherVector._z);
    }
    /**
     * Subtract the given vector from the current Vector3
     * Example Playground https://playground.babylonjs.com/#R1F8YU#61
     * @param otherVector defines the second operand
     * @returns the current updated Vector3
     */ subtractInPlace(otherVector) {
        this._x -= otherVector._x;
        this._y -= otherVector._y;
        this._z -= otherVector._z;
        this._isDirty = true;
        return this;
    }
    /**
     * Returns a new Vector3, result of the subtraction of the given vector from the current Vector3
     * Example Playground https://playground.babylonjs.com/#R1F8YU#60
     * @param otherVector defines the second operand
     * @returns the resulting Vector3
     */ subtract(otherVector) {
        return new this.constructor(this._x - otherVector._x, this._y - otherVector._y, this._z - otherVector._z);
    }
    /**
     * Subtracts the given vector from the current Vector3 and stores the result in the vector "result".
     * Example Playground https://playground.babylonjs.com/#R1F8YU#63
     * @param otherVector defines the second operand
     * @param result defines the Vector3 object where to store the result
     * @returns the result
     */ subtractToRef(otherVector, result) {
        return this.subtractFromFloatsToRef(otherVector._x, otherVector._y, otherVector._z, result);
    }
    /**
     * Returns a new Vector3 set with the subtraction of the given floats from the current Vector3 coordinates
     * Example Playground https://playground.babylonjs.com/#R1F8YU#62
     * @param x defines the x coordinate of the operand
     * @param y defines the y coordinate of the operand
     * @param z defines the z coordinate of the operand
     * @returns the resulting Vector3
     */ subtractFromFloats(x, y, z) {
        return new this.constructor(this._x - x, this._y - y, this._z - z);
    }
    /**
     * Subtracts the given floats from the current Vector3 coordinates and set the given vector "result" with this result
     * Example Playground https://playground.babylonjs.com/#R1F8YU#64
     * @param x defines the x coordinate of the operand
     * @param y defines the y coordinate of the operand
     * @param z defines the z coordinate of the operand
     * @param result defines the Vector3 object where to store the result
     * @returns the result
     */ subtractFromFloatsToRef(x, y, z, result) {
        return result.copyFromFloats(this._x - x, this._y - y, this._z - z);
    }
    /**
     * Gets a new Vector3 set with the current Vector3 negated coordinates
     * Example Playground https://playground.babylonjs.com/#R1F8YU#35
     * @returns a new Vector3
     */ negate() {
        return new this.constructor(-this._x, -this._y, -this._z);
    }
    /**
     * Negate this vector in place
     * Example Playground https://playground.babylonjs.com/#R1F8YU#36
     * @returns this
     */ negateInPlace() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._isDirty = true;
        return this;
    }
    /**
     * Negate the current Vector3 and stores the result in the given vector "result" coordinates
     * Example Playground https://playground.babylonjs.com/#R1F8YU#37
     * @param result defines the Vector3 object where to store the result
     * @returns the result
     */ negateToRef(result) {
        return result.copyFromFloats(this._x * -1, this._y * -1, this._z * -1);
    }
    /**
     * Multiplies the Vector3 coordinates by the float "scale"
     * Example Playground https://playground.babylonjs.com/#R1F8YU#56
     * @param scale defines the multiplier factor
     * @returns the current updated Vector3
     */ scaleInPlace(scale) {
        this._x *= scale;
        this._y *= scale;
        this._z *= scale;
        this._isDirty = true;
        return this;
    }
    /**
     * Returns a new Vector3 set with the current Vector3 coordinates multiplied by the float "scale"
     * Example Playground https://playground.babylonjs.com/#R1F8YU#53
     * @param scale defines the multiplier factor
     * @returns a new Vector3
     */ scale(scale) {
        return new this.constructor(this._x * scale, this._y * scale, this._z * scale);
    }
    /**
     * Multiplies the current Vector3 coordinates by the float "scale" and stores the result in the given vector "result" coordinates
     * Example Playground https://playground.babylonjs.com/#R1F8YU#57
     * @param scale defines the multiplier factor
     * @param result defines the Vector3 object where to store the result
     * @returns the result
     */ scaleToRef(scale, result) {
        return result.copyFromFloats(this._x * scale, this._y * scale, this._z * scale);
    }
    /**
     * Creates a vector normal (perpendicular) to the current Vector3 and stores the result in the given vector
     * Out of the infinite possibilities the normal chosen is the one formed by rotating the current vector
     * 90 degrees about an axis which lies perpendicular to the current vector
     * and its projection on the xz plane. In the case of a current vector in the xz plane
     * the normal is calculated to be along the y axis.
     * Example Playground https://playground.babylonjs.com/#R1F8YU#230
     * Example Playground https://playground.babylonjs.com/#R1F8YU#231
     * @param result defines the Vector3 object where to store the resultant normal
     * @returns the result
     */ getNormalToRef(result) {
        /**
         * Calculates the spherical coordinates of the current vector
         * so saves on memory rather than importing whole Spherical Class
         */ const radius = this.length();
        let theta = Math.acos(this.y / radius);
        const phi = Math.atan2(this.z, this.x);
        //makes angle 90 degs to current vector
        if (theta > Math.PI / 2) theta -= Math.PI / 2;
        else theta += Math.PI / 2;
        //Calculates resutant normal vector from spherical coordinate of perpendicular vector
        const x = radius * Math.sin(theta) * Math.cos(phi);
        const y = radius * Math.cos(theta);
        const z = radius * Math.sin(theta) * Math.sin(phi);
        result.set(x, y, z);
        return result;
    }
    /**
     * Rotates the vector using the given unit quaternion and stores the new vector in result
     * Example Playground https://playground.babylonjs.com/#R1F8YU#9
     * @param q the unit quaternion representing the rotation
     * @param result the output vector
     * @returns the result
     */ applyRotationQuaternionToRef(q, result) {
        // Derived from https://raw.org/proof/vector-rotation-using-quaternions/
        const vx = this._x, vy = this._y, vz = this._z;
        const qx = q._x, qy = q._y, qz = q._z, qw = q._w;
        // t = 2q x v
        const tx = 2 * (qy * vz - qz * vy);
        const ty = 2 * (qz * vx - qx * vz);
        const tz = 2 * (qx * vy - qy * vx);
        // v + w t + q x t
        result._x = vx + qw * tx + qy * tz - qz * ty;
        result._y = vy + qw * ty + qz * tx - qx * tz;
        result._z = vz + qw * tz + qx * ty - qy * tx;
        result._isDirty = true;
        return result;
    }
    /**
     * Rotates the vector in place using the given unit quaternion
     * Example Playground https://playground.babylonjs.com/#R1F8YU#8
     * @param q the unit quaternion representing the rotation
     * @returns the current updated Vector3
     */ applyRotationQuaternionInPlace(q) {
        return this.applyRotationQuaternionToRef(q, this);
    }
    /**
     * Rotates the vector using the given unit quaternion and returns the new vector
     * Example Playground https://playground.babylonjs.com/#R1F8YU#7
     * @param q the unit quaternion representing the rotation
     * @returns a new Vector3
     */ applyRotationQuaternion(q) {
        return this.applyRotationQuaternionToRef(q, new this.constructor());
    }
    /**
     * Scale the current Vector3 values by a factor and add the result to a given Vector3
     * Example Playground https://playground.babylonjs.com/#R1F8YU#55
     * @param scale defines the scale factor
     * @param result defines the Vector3 object where to store the result
     * @returns result input
     */ scaleAndAddToRef(scale, result) {
        return result.addInPlaceFromFloats(this._x * scale, this._y * scale, this._z * scale);
    }
    /**
     * Projects the current point Vector3 to a plane along a ray starting from a specified origin and passing through the current point Vector3.
     * Example Playground https://playground.babylonjs.com/#R1F8YU#48
     * @param plane defines the plane to project to
     * @param origin defines the origin of the projection ray
     * @returns the projected vector3
     */ projectOnPlane(plane, origin) {
        const result = new this.constructor();
        this.projectOnPlaneToRef(plane, origin, result);
        return result;
    }
    /**
     * Projects the current point Vector3 to a plane along a ray starting from a specified origin and passing through the current point Vector3.
     * Example Playground https://playground.babylonjs.com/#R1F8YU#49
     * @param plane defines the plane to project to
     * @param origin defines the origin of the projection ray
     * @param result defines the Vector3 where to store the result
     * @returns result input
     */ projectOnPlaneToRef(plane, origin, result) {
        const n = plane.normal;
        const d = plane.d;
        const V = $c7e4de670ed74d35$var$MathTmp.Vector3[0];
        // ray direction
        this.subtractToRef(origin, V);
        V.normalize();
        const denom = $c7e4de670ed74d35$export$64b5c384219d3699.Dot(V, n);
        //When the ray is close to parallel to the plane return infinity vector
        if (Math.abs(denom) < 0.0000000001) result.setAll(Infinity);
        else {
            const t = -($c7e4de670ed74d35$export$64b5c384219d3699.Dot(origin, n) + d) / denom;
            // P = P0 + t*V
            const scaledV = V.scaleInPlace(t);
            origin.addToRef(scaledV, result);
        }
        return result;
    }
    /**
     * Returns true if the current Vector3 and the given vector coordinates are strictly equal
     * Example Playground https://playground.babylonjs.com/#R1F8YU#19
     * @param otherVector defines the second operand
     * @returns true if both vectors are equals
     */ equals(otherVector) {
        return otherVector && this._x === otherVector._x && this._y === otherVector._y && this._z === otherVector._z;
    }
    /**
     * Returns true if the current Vector3 and the given vector coordinates are distant less than epsilon
     * Example Playground https://playground.babylonjs.com/#R1F8YU#21
     * @param otherVector defines the second operand
     * @param epsilon defines the minimal distance to define values as equals
     * @returns true if both vectors are distant less than epsilon
     */ equalsWithEpsilon(otherVector, epsilon = (0, $53VPf.Epsilon)) {
        return otherVector && (0, $iosaP.WithinEpsilon)(this._x, otherVector._x, epsilon) && (0, $iosaP.WithinEpsilon)(this._y, otherVector._y, epsilon) && (0, $iosaP.WithinEpsilon)(this._z, otherVector._z, epsilon);
    }
    /**
     * Returns true if the current Vector3 coordinates equals the given floats
     * Example Playground https://playground.babylonjs.com/#R1F8YU#20
     * @param x defines the x coordinate of the operand
     * @param y defines the y coordinate of the operand
     * @param z defines the z coordinate of the operand
     * @returns true if both vectors are equal
     */ equalsToFloats(x, y, z) {
        return this._x === x && this._y === y && this._z === z;
    }
    /**
     * Multiplies the current Vector3 coordinates by the given ones
     * Example Playground https://playground.babylonjs.com/#R1F8YU#32
     * @param otherVector defines the second operand
     * @returns the current updated Vector3
     */ multiplyInPlace(otherVector) {
        this._x *= otherVector._x;
        this._y *= otherVector._y;
        this._z *= otherVector._z;
        this._isDirty = true;
        return this;
    }
    /**
     * Returns a new Vector3, result of the multiplication of the current Vector3 by the given vector
     * Example Playground https://playground.babylonjs.com/#R1F8YU#31
     * @param otherVector defines the second operand
     * @returns the new Vector3
     */ multiply(otherVector) {
        return this.multiplyByFloats(otherVector._x, otherVector._y, otherVector._z);
    }
    /**
     * Multiplies the current Vector3 by the given one and stores the result in the given vector "result"
     * Example Playground https://playground.babylonjs.com/#R1F8YU#33
     * @param otherVector defines the second operand
     * @param result defines the Vector3 object where to store the result
     * @returns the result
     */ multiplyToRef(otherVector, result) {
        return result.copyFromFloats(this._x * otherVector._x, this._y * otherVector._y, this._z * otherVector._z);
    }
    /**
     * Returns a new Vector3 set with the result of the multiplication of the current Vector3 coordinates by the given floats
     * Example Playground https://playground.babylonjs.com/#R1F8YU#34
     * @param x defines the x coordinate of the operand
     * @param y defines the y coordinate of the operand
     * @param z defines the z coordinate of the operand
     * @returns the new Vector3
     */ multiplyByFloats(x, y, z) {
        return new this.constructor(this._x * x, this._y * y, this._z * z);
    }
    /**
     * Returns a new Vector3 set with the result of the division of the current Vector3 coordinates by the given ones
     * Example Playground https://playground.babylonjs.com/#R1F8YU#16
     * @param otherVector defines the second operand
     * @returns the new Vector3
     */ divide(otherVector) {
        return new this.constructor(this._x / otherVector._x, this._y / otherVector._y, this._z / otherVector._z);
    }
    /**
     * Divides the current Vector3 coordinates by the given ones and stores the result in the given vector "result"
     * Example Playground https://playground.babylonjs.com/#R1F8YU#18
     * @param otherVector defines the second operand
     * @param result defines the Vector3 object where to store the result
     * @returns the result
     */ divideToRef(otherVector, result) {
        return result.copyFromFloats(this._x / otherVector._x, this._y / otherVector._y, this._z / otherVector._z);
    }
    /**
     * Divides the current Vector3 coordinates by the given ones.
     * Example Playground https://playground.babylonjs.com/#R1F8YU#17
     * @param otherVector defines the second operand
     * @returns the current updated Vector3
     */ divideInPlace(otherVector) {
        this._x = this._x / otherVector._x;
        this._y = this._y / otherVector._y;
        this._z = this._z / otherVector._z;
        this._isDirty = true;
        return this;
    }
    /**
     * Updates the current Vector3 with the minimal coordinate values between its and the given vector ones
     * Example Playground https://playground.babylonjs.com/#R1F8YU#29
     * @param other defines the second operand
     * @returns the current updated Vector3
     */ minimizeInPlace(other) {
        return this.minimizeInPlaceFromFloats(other._x, other._y, other._z);
    }
    /**
     * Updates the current Vector3 with the maximal coordinate values between its and the given vector ones.
     * Example Playground https://playground.babylonjs.com/#R1F8YU#27
     * @param other defines the second operand
     * @returns the current updated Vector3
     */ maximizeInPlace(other) {
        return this.maximizeInPlaceFromFloats(other._x, other._y, other._z);
    }
    /**
     * Updates the current Vector3 with the minimal coordinate values between its and the given coordinates
     * Example Playground https://playground.babylonjs.com/#R1F8YU#30
     * @param x defines the x coordinate of the operand
     * @param y defines the y coordinate of the operand
     * @param z defines the z coordinate of the operand
     * @returns the current updated Vector3
     */ minimizeInPlaceFromFloats(x, y, z) {
        if (x < this._x) this.x = x;
        if (y < this._y) this.y = y;
        if (z < this._z) this.z = z;
        return this;
    }
    /**
     * Updates the current Vector3 with the maximal coordinate values between its and the given coordinates.
     * Example Playground https://playground.babylonjs.com/#R1F8YU#28
     * @param x defines the x coordinate of the operand
     * @param y defines the y coordinate of the operand
     * @param z defines the z coordinate of the operand
     * @returns the current updated Vector3
     */ maximizeInPlaceFromFloats(x, y, z) {
        if (x > this._x) this.x = x;
        if (y > this._y) this.y = y;
        if (z > this._z) this.z = z;
        return this;
    }
    /**
     * Due to float precision, scale of a mesh could be uniform but float values are off by a small fraction
     * Check if is non uniform within a certain amount of decimal places to account for this
     * @param epsilon the amount the values can differ
     * @returns if the vector is non uniform to a certain number of decimal places
     */ isNonUniformWithinEpsilon(epsilon) {
        const absX = Math.abs(this._x);
        const absY = Math.abs(this._y);
        if (!(0, $iosaP.WithinEpsilon)(absX, absY, epsilon)) return true;
        const absZ = Math.abs(this._z);
        if (!(0, $iosaP.WithinEpsilon)(absX, absZ, epsilon)) return true;
        if (!(0, $iosaP.WithinEpsilon)(absY, absZ, epsilon)) return true;
        return false;
    }
    /**
     * Gets a boolean indicating that the vector is non uniform meaning x, y or z are not all the same
     */ get isNonUniform() {
        const absX = Math.abs(this._x);
        const absY = Math.abs(this._y);
        if (absX !== absY) return true;
        const absZ = Math.abs(this._z);
        if (absX !== absZ) return true;
        return false;
    }
    /**
     * Gets the current Vector3's floored values and stores them in result
     * @param result the vector to store the result in
     * @returns the result vector
     */ floorToRef(result) {
        result._x = Math.floor(this._x);
        result._y = Math.floor(this._y);
        result._z = Math.floor(this._z);
        result._isDirty = true;
        return result;
    }
    /**
     * Gets a new Vector3 from current Vector3 floored values
     * Example Playground https://playground.babylonjs.com/#R1F8YU#22
     * @returns a new Vector3
     */ floor() {
        return new this.constructor(Math.floor(this.x), Math.floor(this.y), Math.floor(this.z));
    }
    /**
     * Gets the current Vector3's fractional values and stores them in result
     * @param result the vector to store the result in
     * @returns the result vector
     */ fractToRef(result) {
        result._x = this.x - Math.floor(this._x);
        result._y = this.y - Math.floor(this._y);
        result._z = this.z - Math.floor(this._z);
        result._isDirty = true;
        return result;
    }
    /**
     * Gets a new Vector3 from current Vector3 fractional values
     * Example Playground https://playground.babylonjs.com/#R1F8YU#23
     * @returns a new Vector3
     */ fract() {
        return new this.constructor(this.x - Math.floor(this._x), this.y - Math.floor(this._y), this.z - Math.floor(this._z));
    }
    // Properties
    /**
     * Gets the length of the Vector3
     * Example Playground https://playground.babylonjs.com/#R1F8YU#25
     * @returns the length of the Vector3
     */ length() {
        return Math.sqrt(this.lengthSquared());
    }
    /**
     * Gets the squared length of the Vector3
     * Example Playground https://playground.babylonjs.com/#R1F8YU#26
     * @returns squared length of the Vector3
     */ lengthSquared() {
        return this._x * this._x + this._y * this._y + this._z * this._z;
    }
    /**
     * Gets a boolean indicating if the vector contains a zero in one of its components
     * Example Playground https://playground.babylonjs.com/#R1F8YU#1
     */ get hasAZeroComponent() {
        return this._x * this._y * this._z === 0;
    }
    /**
     * Normalize the current Vector3.
     * Please note that this is an in place operation.
     * Example Playground https://playground.babylonjs.com/#R1F8YU#122
     * @returns the current updated Vector3
     */ normalize() {
        return this.normalizeFromLength(this.length());
    }
    /**
     * Reorders the x y z properties of the vector in place
     * Example Playground https://playground.babylonjs.com/#R1F8YU#44
     * @param order new ordering of the properties (eg. for vector 1,2,3 with "ZYX" will produce 3,2,1)
     * @returns the current updated vector
     */ reorderInPlace(order) {
        order = order.toLowerCase();
        if (order === "xyz") return this;
        const tem = $c7e4de670ed74d35$var$MathTmp.Vector3[0].copyFrom(this);
        this.x = tem[order[0]];
        this.y = tem[order[1]];
        this.z = tem[order[2]];
        return this;
    }
    /**
     * Rotates the vector around 0,0,0 by a quaternion
     * Example Playground https://playground.babylonjs.com/#R1F8YU#47
     * @param quaternion the rotation quaternion
     * @param result vector to store the result
     * @returns the resulting vector
     */ rotateByQuaternionToRef(quaternion, result) {
        quaternion.toRotationMatrix($c7e4de670ed74d35$var$MathTmp.Matrix[0]);
        $c7e4de670ed74d35$export$64b5c384219d3699.TransformCoordinatesToRef(this, $c7e4de670ed74d35$var$MathTmp.Matrix[0], result);
        return result;
    }
    /**
     * Rotates a vector around a given point
     * Example Playground https://playground.babylonjs.com/#R1F8YU#46
     * @param quaternion the rotation quaternion
     * @param point the point to rotate around
     * @param result vector to store the result
     * @returns the resulting vector
     */ rotateByQuaternionAroundPointToRef(quaternion, point, result) {
        this.subtractToRef(point, $c7e4de670ed74d35$var$MathTmp.Vector3[0]);
        $c7e4de670ed74d35$var$MathTmp.Vector3[0].rotateByQuaternionToRef(quaternion, $c7e4de670ed74d35$var$MathTmp.Vector3[0]);
        point.addToRef($c7e4de670ed74d35$var$MathTmp.Vector3[0], result);
        return result;
    }
    /**
     * Returns a new Vector3 as the cross product of the current vector and the "other" one
     * The cross product is then orthogonal to both current and "other"
     * Example Playground https://playground.babylonjs.com/#R1F8YU#14
     * @param other defines the right operand
     * @returns the cross product
     */ cross(other) {
        const result = new this.constructor();
        return $c7e4de670ed74d35$export$64b5c384219d3699.CrossToRef(this, other, result);
    }
    /**
     * Normalize the current Vector3 with the given input length.
     * Please note that this is an in place operation.
     * Example Playground https://playground.babylonjs.com/#R1F8YU#123
     * @param len the length of the vector
     * @returns the current updated Vector3
     */ normalizeFromLength(len) {
        if (len === 0 || len === 1.0) return this;
        return this.scaleInPlace(1.0 / len);
    }
    /**
     * Normalize the current Vector3 to a new vector
     * Example Playground https://playground.babylonjs.com/#R1F8YU#124
     * @returns the new Vector3
     */ normalizeToNew() {
        const normalized = new this.constructor(0, 0, 0);
        this.normalizeToRef(normalized);
        return normalized;
    }
    /**
     * Normalize the current Vector3 to the reference
     * Example Playground https://playground.babylonjs.com/#R1F8YU#125
     * @param reference define the Vector3 to update
     * @returns the updated Vector3
     */ normalizeToRef(reference) {
        const len = this.length();
        if (len === 0 || len === 1.0) return reference.copyFrom(this);
        return this.scaleToRef(1.0 / len, reference);
    }
    /**
     * Creates a new Vector3 copied from the current Vector3
     * Example Playground https://playground.babylonjs.com/#R1F8YU#11
     * @returns the new Vector3
     */ clone() {
        return new this.constructor(this._x, this._y, this._z);
    }
    /**
     * Copies the given vector coordinates to the current Vector3 ones
     * Example Playground https://playground.babylonjs.com/#R1F8YU#12
     * @param source defines the source Vector3
     * @returns the current updated Vector3
     */ copyFrom(source) {
        return this.copyFromFloats(source._x, source._y, source._z);
    }
    /**
     * Copies the given floats to the current Vector3 coordinates
     * Example Playground https://playground.babylonjs.com/#R1F8YU#13
     * @param x defines the x coordinate of the operand
     * @param y defines the y coordinate of the operand
     * @param z defines the z coordinate of the operand
     * @returns the current updated Vector3
     */ copyFromFloats(x, y, z) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._isDirty = true;
        return this;
    }
    /**
     * Copies the given floats to the current Vector3 coordinates
     * Example Playground https://playground.babylonjs.com/#R1F8YU#58
     * @param x defines the x coordinate of the operand
     * @param y defines the y coordinate of the operand
     * @param z defines the z coordinate of the operand
     * @returns the current updated Vector3
     */ set(x, y, z) {
        return this.copyFromFloats(x, y, z);
    }
    /**
     * Copies the given float to the current Vector3 coordinates
     * Example Playground https://playground.babylonjs.com/#R1F8YU#59
     * @param v defines the x, y and z coordinates of the operand
     * @returns the current updated Vector3
     */ setAll(v) {
        this._x = this._y = this._z = v;
        this._isDirty = true;
        return this;
    }
    // Statics
    /**
     * Get the clip factor between two vectors
     * Example Playground https://playground.babylonjs.com/#R1F8YU#126
     * @param vector0 defines the first operand
     * @param vector1 defines the second operand
     * @param axis defines the axis to use
     * @param size defines the size along the axis
     * @returns the clip factor
     */ static GetClipFactor(vector0, vector1, axis, size) {
        const d0 = $c7e4de670ed74d35$export$64b5c384219d3699.Dot(vector0, axis);
        const d1 = $c7e4de670ed74d35$export$64b5c384219d3699.Dot(vector1, axis);
        return (d0 - size) / (d0 - d1);
    }
    /**
     * Get angle between two vectors
     * Example Playground https://playground.babylonjs.com/#R1F8YU#86
     * @param vector0 the starting point
     * @param vector1 the ending point
     * @param normal direction of the normal
     * @returns the angle between vector0 and vector1
     */ static GetAngleBetweenVectors(vector0, vector1, normal) {
        const v0 = vector0.normalizeToRef($c7e4de670ed74d35$var$MathTmp.Vector3[1]);
        const v1 = vector1.normalizeToRef($c7e4de670ed74d35$var$MathTmp.Vector3[2]);
        let dot = $c7e4de670ed74d35$export$64b5c384219d3699.Dot(v0, v1);
        // Vectors are normalized so dot will be in [-1, 1] (aside precision issues enough to break the result which explains the below clamp)
        dot = (0, $iosaP.Clamp)(dot, -1, 1);
        const angle = Math.acos(dot);
        const n = $c7e4de670ed74d35$var$MathTmp.Vector3[3];
        $c7e4de670ed74d35$export$64b5c384219d3699.CrossToRef(v0, v1, n);
        if ($c7e4de670ed74d35$export$64b5c384219d3699.Dot(n, normal) > 0) return isNaN(angle) ? 0 : angle;
        return isNaN(angle) ? -Math.PI : -Math.acos(dot);
    }
    /**
     * Get angle between two vectors projected on a plane
     * Example Playground https://playground.babylonjs.com/#R1F8YU#87
     * Expectation compute time: 0.01 ms (median) and 0.02 ms (percentile 95%)
     * @param vector0 angle between vector0 and vector1
     * @param vector1 angle between vector0 and vector1
     * @param normal Normal of the projection plane
     * @returns the angle in radians (float) between vector0 and vector1 projected on the plane with the specified normal
     */ static GetAngleBetweenVectorsOnPlane(vector0, vector1, normal) {
        $c7e4de670ed74d35$var$MathTmp.Vector3[0].copyFrom(vector0);
        const v0 = $c7e4de670ed74d35$var$MathTmp.Vector3[0];
        $c7e4de670ed74d35$var$MathTmp.Vector3[1].copyFrom(vector1);
        const v1 = $c7e4de670ed74d35$var$MathTmp.Vector3[1];
        $c7e4de670ed74d35$var$MathTmp.Vector3[2].copyFrom(normal);
        const vNormal = $c7e4de670ed74d35$var$MathTmp.Vector3[2];
        const right = $c7e4de670ed74d35$var$MathTmp.Vector3[3];
        const forward = $c7e4de670ed74d35$var$MathTmp.Vector3[4];
        v0.normalize();
        v1.normalize();
        vNormal.normalize();
        $c7e4de670ed74d35$export$64b5c384219d3699.CrossToRef(vNormal, v0, right);
        $c7e4de670ed74d35$export$64b5c384219d3699.CrossToRef(right, vNormal, forward);
        const angle = Math.atan2($c7e4de670ed74d35$export$64b5c384219d3699.Dot(v1, right), $c7e4de670ed74d35$export$64b5c384219d3699.Dot(v1, forward));
        return (0, $iosaP.NormalizeRadians)(angle);
    }
    /**
     * Gets the rotation that aligns the roll axis (Y) to the line joining the start point to the target point and stores it in the ref Vector3
     * Example PG https://playground.babylonjs.com/#R1F8YU#189
     * @param start the starting point
     * @param target the target point
     * @param ref the vector3 to store the result
     * @returns ref in the form (pitch, yaw, 0)
     */ static PitchYawRollToMoveBetweenPointsToRef(start, target, ref) {
        const diff = $c7e4de670ed74d35$export$269f00bf0c0718d1.Vector3[0];
        target.subtractToRef(start, diff);
        ref._y = Math.atan2(diff.x, diff.z) || 0;
        ref._x = Math.atan2(Math.sqrt(diff.x ** 2 + diff.z ** 2), diff.y) || 0;
        ref._z = 0;
        ref._isDirty = true;
        return ref;
    }
    /**
     * Gets the rotation that aligns the roll axis (Y) to the line joining the start point to the target point
     * Example PG https://playground.babylonjs.com/#R1F8YU#188
     * @param start the starting point
     * @param target the target point
     * @returns the rotation in the form (pitch, yaw, 0)
     */ static PitchYawRollToMoveBetweenPoints(start, target) {
        const ref = $c7e4de670ed74d35$export$64b5c384219d3699.Zero();
        return $c7e4de670ed74d35$export$64b5c384219d3699.PitchYawRollToMoveBetweenPointsToRef(start, target, ref);
    }
    /**
     * Slerp between two vectors. See also `SmoothToRef`
     * Slerp is a spherical linear interpolation
     * giving a slow in and out effect
     * Example Playground 1 https://playground.babylonjs.com/#R1F8YU#108
     * Example Playground 2 https://playground.babylonjs.com/#R1F8YU#109
     * @param vector0 Start vector
     * @param vector1 End vector
     * @param slerp amount (will be clamped between 0 and 1)
     * @param result The slerped vector
     * @returns The slerped vector
     */ static SlerpToRef(vector0, vector1, slerp, result) {
        slerp = (0, $iosaP.Clamp)(slerp, 0, 1);
        const vector0Dir = $c7e4de670ed74d35$var$MathTmp.Vector3[0];
        const vector1Dir = $c7e4de670ed74d35$var$MathTmp.Vector3[1];
        vector0Dir.copyFrom(vector0);
        const vector0Length = vector0Dir.length();
        vector0Dir.normalizeFromLength(vector0Length);
        vector1Dir.copyFrom(vector1);
        const vector1Length = vector1Dir.length();
        vector1Dir.normalizeFromLength(vector1Length);
        const dot = $c7e4de670ed74d35$export$64b5c384219d3699.Dot(vector0Dir, vector1Dir);
        let scale0;
        let scale1;
        if (dot < 1 - (0, $53VPf.Epsilon)) {
            const omega = Math.acos(dot);
            const invSin = 1 / Math.sin(omega);
            scale0 = Math.sin((1 - slerp) * omega) * invSin;
            scale1 = Math.sin(slerp * omega) * invSin;
        } else {
            // Use linear interpolation
            scale0 = 1 - slerp;
            scale1 = slerp;
        }
        vector0Dir.scaleInPlace(scale0);
        vector1Dir.scaleInPlace(scale1);
        result.copyFrom(vector0Dir).addInPlace(vector1Dir);
        result.scaleInPlace((0, $iosaP.Lerp)(vector0Length, vector1Length, slerp));
        return result;
    }
    /**
     * Smooth interpolation between two vectors using Slerp
     * Example Playground https://playground.babylonjs.com/#R1F8YU#110
     * @param source source vector
     * @param goal goal vector
     * @param deltaTime current interpolation frame
     * @param lerpTime total interpolation time
     * @param result the smoothed vector
     * @returns the smoothed vector
     */ static SmoothToRef(source, goal, deltaTime, lerpTime, result) {
        $c7e4de670ed74d35$export$64b5c384219d3699.SlerpToRef(source, goal, lerpTime === 0 ? 1 : deltaTime / lerpTime, result);
        return result;
    }
    /**
     * Returns a new Vector3 set from the index "offset" of the given array
     * Example Playground https://playground.babylonjs.com/#R1F8YU#83
     * @param array defines the source array
     * @param offset defines the offset in the source array
     * @returns the new Vector3
     */ static FromArray(array, offset = 0) {
        return new $c7e4de670ed74d35$export$64b5c384219d3699(array[offset], array[offset + 1], array[offset + 2]);
    }
    /**
     * Returns a new Vector3 set from the index "offset" of the given Float32Array
     * @param array defines the source array
     * @param offset defines the offset in the source array
     * @returns the new Vector3
     * @deprecated Please use FromArray instead.
     */ static FromFloatArray(array, offset) {
        return $c7e4de670ed74d35$export$64b5c384219d3699.FromArray(array, offset);
    }
    /**
     * Sets the given vector "result" with the element values from the index "offset" of the given array
     * Example Playground https://playground.babylonjs.com/#R1F8YU#84
     * @param array defines the source array
     * @param offset defines the offset in the source array
     * @param result defines the Vector3 where to store the result
     * @returns result input
     */ static FromArrayToRef(array, offset, result) {
        result._x = array[offset];
        result._y = array[offset + 1];
        result._z = array[offset + 2];
        result._isDirty = true;
        return result;
    }
    /**
     * Sets the given vector "result" with the element values from the index "offset" of the given Float32Array
     * @param array defines the source array
     * @param offset defines the offset in the source array
     * @param result defines the Vector3 where to store the result
     * @deprecated Please use FromArrayToRef instead.
     * @returns result input
     */ static FromFloatArrayToRef(array, offset, result) {
        return $c7e4de670ed74d35$export$64b5c384219d3699.FromArrayToRef(array, offset, result);
    }
    /**
     * Sets the given vector "result" with the given floats.
     * Example Playground https://playground.babylonjs.com/#R1F8YU#85
     * @param x defines the x coordinate of the source
     * @param y defines the y coordinate of the source
     * @param z defines the z coordinate of the source
     * @param result defines the Vector3 where to store the result
     * @returns the result vector
     */ static FromFloatsToRef(x, y, z, result) {
        result.copyFromFloats(x, y, z);
        return result;
    }
    /**
     * Returns a new Vector3 set to (0.0, 0.0, 0.0)
     * @returns a new empty Vector3
     */ static Zero() {
        return new $c7e4de670ed74d35$export$64b5c384219d3699(0.0, 0.0, 0.0);
    }
    /**
     * Returns a new Vector3 set to (1.0, 1.0, 1.0)
     * @returns a new Vector3
     */ static One() {
        return new $c7e4de670ed74d35$export$64b5c384219d3699(1.0, 1.0, 1.0);
    }
    /**
     * Returns a new Vector3 set to (0.0, 1.0, 0.0)
     * Example Playground https://playground.babylonjs.com/#R1F8YU#71
     * @returns a new up Vector3
     */ static Up() {
        return new $c7e4de670ed74d35$export$64b5c384219d3699(0.0, 1.0, 0.0);
    }
    /**
     * Gets an up Vector3 that must not be updated
     */ static get UpReadOnly() {
        return $c7e4de670ed74d35$export$64b5c384219d3699._UpReadOnly;
    }
    /**
     * Gets a down Vector3 that must not be updated
     */ static get DownReadOnly() {
        return $c7e4de670ed74d35$export$64b5c384219d3699._DownReadOnly;
    }
    /**
     * Gets a right Vector3 that must not be updated
     */ static get RightReadOnly() {
        return $c7e4de670ed74d35$export$64b5c384219d3699._RightReadOnly;
    }
    /**
     * Gets a left Vector3 that must not be updated
     */ static get LeftReadOnly() {
        return $c7e4de670ed74d35$export$64b5c384219d3699._LeftReadOnly;
    }
    /**
     * Gets a forward Vector3 that must not be updated
     */ static get LeftHandedForwardReadOnly() {
        return $c7e4de670ed74d35$export$64b5c384219d3699._LeftHandedForwardReadOnly;
    }
    /**
     * Gets a forward Vector3 that must not be updated
     */ static get RightHandedForwardReadOnly() {
        return $c7e4de670ed74d35$export$64b5c384219d3699._RightHandedForwardReadOnly;
    }
    /**
     * Gets a backward Vector3 that must not be updated
     */ static get LeftHandedBackwardReadOnly() {
        return $c7e4de670ed74d35$export$64b5c384219d3699._LeftHandedBackwardReadOnly;
    }
    /**
     * Gets a backward Vector3 that must not be updated
     */ static get RightHandedBackwardReadOnly() {
        return $c7e4de670ed74d35$export$64b5c384219d3699._RightHandedBackwardReadOnly;
    }
    /**
     * Gets a zero Vector3 that must not be updated
     */ static get ZeroReadOnly() {
        return $c7e4de670ed74d35$export$64b5c384219d3699._ZeroReadOnly;
    }
    /**
     * Gets a one Vector3 that must not be updated
     */ static get OneReadOnly() {
        return $c7e4de670ed74d35$export$64b5c384219d3699._OneReadOnly;
    }
    /**
     * Returns a new Vector3 set to (0.0, -1.0, 0.0)
     * Example Playground https://playground.babylonjs.com/#R1F8YU#71
     * @returns a new down Vector3
     */ static Down() {
        return new $c7e4de670ed74d35$export$64b5c384219d3699(0.0, -1, 0.0);
    }
    /**
     * Returns a new Vector3 set to (0.0, 0.0, 1.0)
     * Example Playground https://playground.babylonjs.com/#R1F8YU#71
     * @param rightHandedSystem is the scene right-handed (negative z)
     * @returns a new forward Vector3
     */ static Forward(rightHandedSystem = false) {
        return new $c7e4de670ed74d35$export$64b5c384219d3699(0.0, 0.0, rightHandedSystem ? -1 : 1.0);
    }
    /**
     * Returns a new Vector3 set to (0.0, 0.0, -1.0)
     * Example Playground https://playground.babylonjs.com/#R1F8YU#71
     * @param rightHandedSystem is the scene right-handed (negative-z)
     * @returns a new Backward Vector3
     */ static Backward(rightHandedSystem = false) {
        return new $c7e4de670ed74d35$export$64b5c384219d3699(0.0, 0.0, rightHandedSystem ? 1.0 : -1);
    }
    /**
     * Returns a new Vector3 set to (1.0, 0.0, 0.0)
     * Example Playground https://playground.babylonjs.com/#R1F8YU#71
     * @returns a new right Vector3
     */ static Right() {
        return new $c7e4de670ed74d35$export$64b5c384219d3699(1.0, 0.0, 0.0);
    }
    /**
     * Returns a new Vector3 set to (-1.0, 0.0, 0.0)
     * Example Playground https://playground.babylonjs.com/#R1F8YU#71
     * @returns a new left Vector3
     */ static Left() {
        return new $c7e4de670ed74d35$export$64b5c384219d3699(-1, 0.0, 0.0);
    }
    /**
     * Returns a new Vector3 with random values between min and max
     * @param min the minimum random value
     * @param max the maximum random value
     * @returns a Vector3 with random values between min and max
     */ static Random(min = 0, max = 1) {
        return new $c7e4de670ed74d35$export$64b5c384219d3699((0, $iosaP.RandomRange)(min, max), (0, $iosaP.RandomRange)(min, max), (0, $iosaP.RandomRange)(min, max));
    }
    /**
     * Sets a Vector3 with random values between min and max
     * @param min the minimum random value
     * @param max the maximum random value
     * @param ref the ref to store the values in
     * @returns the ref with random values between min and max
     */ static RandomToRef(min = 0, max = 1, ref) {
        return ref.copyFromFloats((0, $iosaP.RandomRange)(min, max), (0, $iosaP.RandomRange)(min, max), (0, $iosaP.RandomRange)(min, max));
    }
    /**
     * Returns a new Vector3 set with the result of the transformation by the given matrix of the given vector.
     * This method computes transformed coordinates only, not transformed direction vectors (ie. it takes translation in account)
     * Example Playground https://playground.babylonjs.com/#R1F8YU#111
     * @param vector defines the Vector3 to transform
     * @param transformation defines the transformation matrix
     * @returns the transformed Vector3
     */ static TransformCoordinates(vector, transformation) {
        const result = $c7e4de670ed74d35$export$64b5c384219d3699.Zero();
        $c7e4de670ed74d35$export$64b5c384219d3699.TransformCoordinatesToRef(vector, transformation, result);
        return result;
    }
    /**
     * Sets the given vector "result" coordinates with the result of the transformation by the given matrix of the given vector
     * This method computes transformed coordinates only, not transformed direction vectors (ie. it takes translation in account)
     * Example Playground https://playground.babylonjs.com/#R1F8YU#113
     * @param vector defines the Vector3 to transform
     * @param transformation defines the transformation matrix
     * @param result defines the Vector3 where to store the result
     * @returns result input
     */ static TransformCoordinatesToRef(vector, transformation, result) {
        $c7e4de670ed74d35$export$64b5c384219d3699.TransformCoordinatesFromFloatsToRef(vector._x, vector._y, vector._z, transformation, result);
        return result;
    }
    /**
     * Sets the given vector "result" coordinates with the result of the transformation by the given matrix of the given floats (x, y, z)
     * This method computes transformed coordinates only, not transformed direction vectors
     * Example Playground https://playground.babylonjs.com/#R1F8YU#115
     * @param x define the x coordinate of the source vector
     * @param y define the y coordinate of the source vector
     * @param z define the z coordinate of the source vector
     * @param transformation defines the transformation matrix
     * @param result defines the Vector3 where to store the result
     * @returns result input
     */ static TransformCoordinatesFromFloatsToRef(x, y, z, transformation, result) {
        const m = transformation.m;
        const rx = x * m[0] + y * m[4] + z * m[8] + m[12];
        const ry = x * m[1] + y * m[5] + z * m[9] + m[13];
        const rz = x * m[2] + y * m[6] + z * m[10] + m[14];
        const rw = 1 / (x * m[3] + y * m[7] + z * m[11] + m[15]);
        result._x = rx * rw;
        result._y = ry * rw;
        result._z = rz * rw;
        result._isDirty = true;
        return result;
    }
    /**
     * Returns a new Vector3 set with the result of the normal transformation by the given matrix of the given vector
     * This methods computes transformed normalized direction vectors only (ie. it does not apply translation)
     * Example Playground https://playground.babylonjs.com/#R1F8YU#112
     * @param vector defines the Vector3 to transform
     * @param transformation defines the transformation matrix
     * @returns the new Vector3
     */ static TransformNormal(vector, transformation) {
        const result = $c7e4de670ed74d35$export$64b5c384219d3699.Zero();
        $c7e4de670ed74d35$export$64b5c384219d3699.TransformNormalToRef(vector, transformation, result);
        return result;
    }
    /**
     * Sets the given vector "result" with the result of the normal transformation by the given matrix of the given vector
     * This methods computes transformed normalized direction vectors only (ie. it does not apply translation)
     * Example Playground https://playground.babylonjs.com/#R1F8YU#114
     * @param vector defines the Vector3 to transform
     * @param transformation defines the transformation matrix
     * @param result defines the Vector3 where to store the result
     * @returns result input
     */ static TransformNormalToRef(vector, transformation, result) {
        this.TransformNormalFromFloatsToRef(vector._x, vector._y, vector._z, transformation, result);
        return result;
    }
    /**
     * Sets the given vector "result" with the result of the normal transformation by the given matrix of the given floats (x, y, z)
     * This methods computes transformed normalized direction vectors only (ie. it does not apply translation)
     * Example Playground https://playground.babylonjs.com/#R1F8YU#116
     * @param x define the x coordinate of the source vector
     * @param y define the y coordinate of the source vector
     * @param z define the z coordinate of the source vector
     * @param transformation defines the transformation matrix
     * @param result defines the Vector3 where to store the result
     * @returns result input
     */ static TransformNormalFromFloatsToRef(x, y, z, transformation, result) {
        const m = transformation.m;
        result._x = x * m[0] + y * m[4] + z * m[8];
        result._y = x * m[1] + y * m[5] + z * m[9];
        result._z = x * m[2] + y * m[6] + z * m[10];
        result._isDirty = true;
        return result;
    }
    /**
     * Returns a new Vector3 located for "amount" on the CatmullRom interpolation spline defined by the vectors "value1", "value2", "value3", "value4"
     * Example Playground https://playground.babylonjs.com/#R1F8YU#69
     * @param value1 defines the first control point
     * @param value2 defines the second control point
     * @param value3 defines the third control point
     * @param value4 defines the fourth control point
     * @param amount defines the amount on the spline to use
     * @returns the new Vector3
     */ static CatmullRom(value1, value2, value3, value4, amount) {
        const squared = amount * amount;
        const cubed = amount * squared;
        const x = 0.5 * (2.0 * value2._x + (-value1._x + value3._x) * amount + (2.0 * value1._x - 5.0 * value2._x + 4.0 * value3._x - value4._x) * squared + (-value1._x + 3.0 * value2._x - 3.0 * value3._x + value4._x) * cubed);
        const y = 0.5 * (2.0 * value2._y + (-value1._y + value3._y) * amount + (2.0 * value1._y - 5.0 * value2._y + 4.0 * value3._y - value4._y) * squared + (-value1._y + 3.0 * value2._y - 3.0 * value3._y + value4._y) * cubed);
        const z = 0.5 * (2.0 * value2._z + (-value1._z + value3._z) * amount + (2.0 * value1._z - 5.0 * value2._z + 4.0 * value3._z - value4._z) * squared + (-value1._z + 3.0 * value2._z - 3.0 * value3._z + value4._z) * cubed);
        return new value1.constructor(x, y, z);
    }
    /**
     * Returns a new Vector3 set with the coordinates of "value", if the vector "value" is in the cube defined by the vectors "min" and "max"
     * If a coordinate value of "value" is lower than one of the "min" coordinate, then this "value" coordinate is set with the "min" one
     * If a coordinate value of "value" is greater than one of the "max" coordinate, then this "value" coordinate is set with the "max" one
     * Example Playground https://playground.babylonjs.com/#R1F8YU#76
     * @param value defines the current value
     * @param min defines the lower range value
     * @param max defines the upper range value
     * @returns the new Vector3
     */ static Clamp(value, min, max) {
        const result = new value.constructor();
        $c7e4de670ed74d35$export$64b5c384219d3699.ClampToRef(value, min, max, result);
        return result;
    }
    /**
     * Sets the given vector "result" with the coordinates of "value", if the vector "value" is in the cube defined by the vectors "min" and "max"
     * If a coordinate value of "value" is lower than one of the "min" coordinate, then this "value" coordinate is set with the "min" one
     * If a coordinate value of "value" is greater than one of the "max" coordinate, then this "value" coordinate is set with the "max" one
     * Example Playground https://playground.babylonjs.com/#R1F8YU#77
     * @param value defines the current value
     * @param min defines the lower range value
     * @param max defines the upper range value
     * @param result defines the Vector3 where to store the result
     * @returns result input
     */ static ClampToRef(value, min, max, result) {
        let x = value._x;
        x = x > max._x ? max._x : x;
        x = x < min._x ? min._x : x;
        let y = value._y;
        y = y > max._y ? max._y : y;
        y = y < min._y ? min._y : y;
        let z = value._z;
        z = z > max._z ? max._z : z;
        z = z < min._z ? min._z : z;
        result.copyFromFloats(x, y, z);
        return result;
    }
    /**
     * Checks if a given vector is inside a specific range
     * Example Playground https://playground.babylonjs.com/#R1F8YU#75
     * @param v defines the vector to test
     * @param min defines the minimum range
     * @param max defines the maximum range
     */ static CheckExtends(v, min, max) {
        min.minimizeInPlace(v);
        max.maximizeInPlace(v);
    }
    /**
     * Returns a new Vector3 located for "amount" (float) on the Hermite interpolation spline defined by the vectors "value1", "tangent1", "value2", "tangent2"
     * Example Playground https://playground.babylonjs.com/#R1F8YU#89
     * @param value1 defines the first control point
     * @param tangent1 defines the first tangent vector
     * @param value2 defines the second control point
     * @param tangent2 defines the second tangent vector
     * @param amount defines the amount on the interpolation spline (between 0 and 1)
     * @returns the new Vector3
     */ static Hermite(value1, tangent1, value2, tangent2, amount) {
        const squared = amount * amount;
        const cubed = amount * squared;
        const part1 = 2.0 * cubed - 3.0 * squared + 1.0;
        const part2 = -2 * cubed + 3.0 * squared;
        const part3 = cubed - 2.0 * squared + amount;
        const part4 = cubed - squared;
        const x = value1._x * part1 + value2._x * part2 + tangent1._x * part3 + tangent2._x * part4;
        const y = value1._y * part1 + value2._y * part2 + tangent1._y * part3 + tangent2._y * part4;
        const z = value1._z * part1 + value2._z * part2 + tangent1._z * part3 + tangent2._z * part4;
        return new value1.constructor(x, y, z);
    }
    /**
     * Returns a new Vector3 which is the 1st derivative of the Hermite spline defined by the vectors "value1", "value2", "tangent1", "tangent2".
     * Example Playground https://playground.babylonjs.com/#R1F8YU#90
     * @param value1 defines the first control point
     * @param tangent1 defines the first tangent
     * @param value2 defines the second control point
     * @param tangent2 defines the second tangent
     * @param time define where the derivative must be done
     * @returns 1st derivative
     */ static Hermite1stDerivative(value1, tangent1, value2, tangent2, time) {
        const result = new value1.constructor();
        this.Hermite1stDerivativeToRef(value1, tangent1, value2, tangent2, time, result);
        return result;
    }
    /**
     * Update a Vector3 with the 1st derivative of the Hermite spline defined by the vectors "value1", "value2", "tangent1", "tangent2".
     * Example Playground https://playground.babylonjs.com/#R1F8YU#91
     * @param value1 defines the first control point
     * @param tangent1 defines the first tangent
     * @param value2 defines the second control point
     * @param tangent2 defines the second tangent
     * @param time define where the derivative must be done
     * @param result define where to store the derivative
     * @returns result input
     */ static Hermite1stDerivativeToRef(value1, tangent1, value2, tangent2, time, result) {
        const t2 = time * time;
        result._x = (t2 - time) * 6 * value1._x + (3 * t2 - 4 * time + 1) * tangent1._x + (-t2 + time) * 6 * value2._x + (3 * t2 - 2 * time) * tangent2._x;
        result._y = (t2 - time) * 6 * value1._y + (3 * t2 - 4 * time + 1) * tangent1._y + (-t2 + time) * 6 * value2._y + (3 * t2 - 2 * time) * tangent2._y;
        result._z = (t2 - time) * 6 * value1._z + (3 * t2 - 4 * time + 1) * tangent1._z + (-t2 + time) * 6 * value2._z + (3 * t2 - 2 * time) * tangent2._z;
        result._isDirty = true;
        return result;
    }
    /**
     * Returns a new Vector3 located for "amount" (float) on the linear interpolation between the vectors "start" and "end"
     * Example Playground https://playground.babylonjs.com/#R1F8YU#95
     * @param start defines the start value
     * @param end defines the end value
     * @param amount max defines amount between both (between 0 and 1)
     * @returns the new Vector3
     */ static Lerp(start, end, amount) {
        const result = new start.constructor(0, 0, 0);
        $c7e4de670ed74d35$export$64b5c384219d3699.LerpToRef(start, end, amount, result);
        return result;
    }
    /**
     * Sets the given vector "result" with the result of the linear interpolation from the vector "start" for "amount" to the vector "end"
     * Example Playground https://playground.babylonjs.com/#R1F8YU#93
     * @param start defines the start value
     * @param end defines the end value
     * @param amount max defines amount between both (between 0 and 1)
     * @param result defines the Vector3 where to store the result
     * @returns result input
     */ static LerpToRef(start, end, amount, result) {
        result._x = start._x + (end._x - start._x) * amount;
        result._y = start._y + (end._y - start._y) * amount;
        result._z = start._z + (end._z - start._z) * amount;
        result._isDirty = true;
        return result;
    }
    /**
     * Returns the dot product (float) between the vectors "left" and "right"
     * Example Playground https://playground.babylonjs.com/#R1F8YU#82
     * @param left defines the left operand
     * @param right defines the right operand
     * @returns the dot product
     */ static Dot(left, right) {
        return left._x * right._x + left._y * right._y + left._z * right._z;
    }
    /**
     * Returns the dot product (float) between the current vectors and "otherVector"
     * @param otherVector defines the right operand
     * @returns the dot product
     */ dot(otherVector) {
        return this._x * otherVector._x + this._y * otherVector._y + this._z * otherVector._z;
    }
    /**
     * Returns a new Vector3 as the cross product of the vectors "left" and "right"
     * The cross product is then orthogonal to both "left" and "right"
     * Example Playground https://playground.babylonjs.com/#R1F8YU#15
     * @param left defines the left operand
     * @param right defines the right operand
     * @returns the cross product
     */ static Cross(left, right) {
        const result = new left.constructor();
        $c7e4de670ed74d35$export$64b5c384219d3699.CrossToRef(left, right, result);
        return result;
    }
    /**
     * Sets the given vector "result" with the cross product of "left" and "right"
     * The cross product is then orthogonal to both "left" and "right"
     * Example Playground https://playground.babylonjs.com/#R1F8YU#78
     * @param left defines the left operand
     * @param right defines the right operand
     * @param result defines the Vector3 where to store the result
     * @returns result input
     */ static CrossToRef(left, right, result) {
        const x = left._y * right._z - left._z * right._y;
        const y = left._z * right._x - left._x * right._z;
        const z = left._x * right._y - left._y * right._x;
        result.copyFromFloats(x, y, z);
        return result;
    }
    /**
     * Returns a new Vector3 as the normalization of the given vector
     * Example Playground https://playground.babylonjs.com/#R1F8YU#98
     * @param vector defines the Vector3 to normalize
     * @returns the new Vector3
     */ static Normalize(vector) {
        const result = $c7e4de670ed74d35$export$64b5c384219d3699.Zero();
        $c7e4de670ed74d35$export$64b5c384219d3699.NormalizeToRef(vector, result);
        return result;
    }
    /**
     * Sets the given vector "result" with the normalization of the given first vector
     * Example Playground https://playground.babylonjs.com/#R1F8YU#98
     * @param vector defines the Vector3 to normalize
     * @param result defines the Vector3 where to store the result
     * @returns result input
     */ static NormalizeToRef(vector, result) {
        vector.normalizeToRef(result);
        return result;
    }
    /**
     * Project a Vector3 onto screen space
     * Example Playground https://playground.babylonjs.com/#R1F8YU#101
     * @param vector defines the Vector3 to project
     * @param world defines the world matrix to use
     * @param transform defines the transform (view x projection) matrix to use
     * @param viewport defines the screen viewport to use
     * @returns the new Vector3
     */ static Project(vector, world, transform, viewport) {
        const result = new vector.constructor();
        $c7e4de670ed74d35$export$64b5c384219d3699.ProjectToRef(vector, world, transform, viewport, result);
        return result;
    }
    /**
     * Project a Vector3 onto screen space to reference
     * Example Playground https://playground.babylonjs.com/#R1F8YU#102
     * @param vector defines the Vector3 to project
     * @param world defines the world matrix to use
     * @param transform defines the transform (view x projection) matrix to use
     * @param viewport defines the screen viewport to use
     * @param result the vector in which the screen space will be stored
     * @returns result input
     */ static ProjectToRef(vector, world, transform, viewport, result) {
        const cw = viewport.width;
        const ch = viewport.height;
        const cx = viewport.x;
        const cy = viewport.y;
        const viewportMatrix = $c7e4de670ed74d35$var$MathTmp.Matrix[1];
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(cw / 2.0, 0, 0, 0, 0, -ch / 2.0, 0, 0, 0, 0, 0.5, 0, cx + cw / 2.0, ch / 2.0 + cy, 0.5, 1, viewportMatrix);
        const matrix = $c7e4de670ed74d35$var$MathTmp.Matrix[0];
        world.multiplyToRef(transform, matrix);
        matrix.multiplyToRef(viewportMatrix, matrix);
        $c7e4de670ed74d35$export$64b5c384219d3699.TransformCoordinatesToRef(vector, matrix, result);
        return result;
    }
    /**
     * Reflects a vector off the plane defined by a normalized normal
     * @param inDirection defines the vector direction
     * @param normal defines the normal - Must be normalized
     * @returns the resulting vector
     */ static Reflect(inDirection, normal) {
        return this.ReflectToRef(inDirection, normal, new $c7e4de670ed74d35$export$64b5c384219d3699());
    }
    /**
     * Reflects a vector off the plane defined by a normalized normal to reference
     * @param inDirection defines the vector direction
     * @param normal defines the normal - Must be normalized
     * @param ref defines the Vector3 where to store the result
     * @returns the resulting vector
     */ static ReflectToRef(inDirection, normal, ref) {
        const tmp = $c7e4de670ed74d35$export$269f00bf0c0718d1.Vector3[0];
        tmp.copyFrom(normal).scaleInPlace(2 * $c7e4de670ed74d35$export$64b5c384219d3699.Dot(inDirection, normal));
        return ref.copyFrom(inDirection).subtractInPlace(tmp);
    }
    /**
     * @internal
     */ static _UnprojectFromInvertedMatrixToRef(source, matrix, result) {
        $c7e4de670ed74d35$export$64b5c384219d3699.TransformCoordinatesToRef(source, matrix, result);
        const m = matrix.m;
        const num = source._x * m[3] + source._y * m[7] + source._z * m[11] + m[15];
        if ((0, $iosaP.WithinEpsilon)(num, 1.0)) result.scaleInPlace(1.0 / num);
        return result;
    }
    /**
     * Unproject from screen space to object space
     * Example Playground https://playground.babylonjs.com/#R1F8YU#121
     * @param source defines the screen space Vector3 to use
     * @param viewportWidth defines the current width of the viewport
     * @param viewportHeight defines the current height of the viewport
     * @param world defines the world matrix to use (can be set to Identity to go to world space)
     * @param transform defines the transform (view x projection) matrix to use
     * @returns the new Vector3
     */ static UnprojectFromTransform(source, viewportWidth, viewportHeight, world, transform) {
        return this.Unproject(source, viewportWidth, viewportHeight, world, transform, $c7e4de670ed74d35$export$5b12bf1653c0dd85.IdentityReadOnly);
    }
    /**
     * Unproject from screen space to object space
     * Example Playground https://playground.babylonjs.com/#R1F8YU#117
     * @param source defines the screen space Vector3 to use
     * @param viewportWidth defines the current width of the viewport
     * @param viewportHeight defines the current height of the viewport
     * @param world defines the world matrix to use (can be set to Identity to go to world space)
     * @param view defines the view matrix to use
     * @param projection defines the projection matrix to use
     * @returns the new Vector3
     */ static Unproject(source, viewportWidth, viewportHeight, world, view, projection) {
        const result = new source.constructor();
        $c7e4de670ed74d35$export$64b5c384219d3699.UnprojectToRef(source, viewportWidth, viewportHeight, world, view, projection, result);
        return result;
    }
    /**
     * Unproject from screen space to object space
     * Example Playground https://playground.babylonjs.com/#R1F8YU#119
     * @param source defines the screen space Vector3 to use
     * @param viewportWidth defines the current width of the viewport
     * @param viewportHeight defines the current height of the viewport
     * @param world defines the world matrix to use (can be set to Identity to go to world space)
     * @param view defines the view matrix to use
     * @param projection defines the projection matrix to use
     * @param result defines the Vector3 where to store the result
     * @returns result input
     */ static UnprojectToRef(source, viewportWidth, viewportHeight, world, view, projection, result) {
        $c7e4de670ed74d35$export$64b5c384219d3699.UnprojectFloatsToRef(source._x, source._y, source._z, viewportWidth, viewportHeight, world, view, projection, result);
        return result;
    }
    /**
     * Unproject from screen space to object space
     * Example Playground https://playground.babylonjs.com/#R1F8YU#120
     * @param sourceX defines the screen space x coordinate to use
     * @param sourceY defines the screen space y coordinate to use
     * @param sourceZ defines the screen space z coordinate to use
     * @param viewportWidth defines the current width of the viewport
     * @param viewportHeight defines the current height of the viewport
     * @param world defines the world matrix to use (can be set to Identity to go to world space)
     * @param view defines the view matrix to use
     * @param projection defines the projection matrix to use
     * @param result defines the Vector3 where to store the result
     * @returns result input
     */ static UnprojectFloatsToRef(sourceX, sourceY, sourceZ, viewportWidth, viewportHeight, world, view, projection, result) {
        const matrix = $c7e4de670ed74d35$var$MathTmp.Matrix[0];
        world.multiplyToRef(view, matrix);
        matrix.multiplyToRef(projection, matrix);
        matrix.invert();
        const screenSource = $c7e4de670ed74d35$var$MathTmp.Vector3[0];
        screenSource.x = sourceX / viewportWidth * 2 - 1;
        screenSource.y = -(sourceY / viewportHeight * 2 - 1);
        if ((0, $ejQPp.EngineStore).LastCreatedEngine?.isNDCHalfZRange) screenSource.z = sourceZ;
        else screenSource.z = 2 * sourceZ - 1.0;
        $c7e4de670ed74d35$export$64b5c384219d3699._UnprojectFromInvertedMatrixToRef(screenSource, matrix, result);
        return result;
    }
    /**
     * Gets the minimal coordinate values between two Vector3
     * Example Playground https://playground.babylonjs.com/#R1F8YU#97
     * @param left defines the first operand
     * @param right defines the second operand
     * @returns the new Vector3
     */ static Minimize(left, right) {
        const min = new left.constructor();
        min.copyFrom(left);
        min.minimizeInPlace(right);
        return min;
    }
    /**
     * Gets the maximal coordinate values between two Vector3
     * Example Playground https://playground.babylonjs.com/#R1F8YU#96
     * @param left defines the first operand
     * @param right defines the second operand
     * @returns the new Vector3
     */ static Maximize(left, right) {
        const max = new left.constructor();
        max.copyFrom(left);
        max.maximizeInPlace(right);
        return max;
    }
    /**
     * Returns the distance between the vectors "value1" and "value2"
     * Example Playground https://playground.babylonjs.com/#R1F8YU#81
     * @param value1 defines the first operand
     * @param value2 defines the second operand
     * @returns the distance
     */ static Distance(value1, value2) {
        return Math.sqrt($c7e4de670ed74d35$export$64b5c384219d3699.DistanceSquared(value1, value2));
    }
    /**
     * Returns the squared distance between the vectors "value1" and "value2"
     * Example Playground https://playground.babylonjs.com/#R1F8YU#80
     * @param value1 defines the first operand
     * @param value2 defines the second operand
     * @returns the squared distance
     */ static DistanceSquared(value1, value2) {
        const x = value1._x - value2._x;
        const y = value1._y - value2._y;
        const z = value1._z - value2._z;
        return x * x + y * y + z * z;
    }
    /**
     * Projects "vector" on the triangle determined by its extremities "p0", "p1" and "p2", stores the result in "ref"
     * and returns the distance to the projected point.
     * Example Playground https://playground.babylonjs.com/#R1F8YU#104
     * From http://citeseerx.ist.psu.edu/viewdoc/download?doi=10.1.1.104.4264&rep=rep1&type=pdf
     *
     * @param vector the vector to get distance from
     * @param p0 extremity of the triangle
     * @param p1 extremity of the triangle
     * @param p2 extremity of the triangle
     * @param ref variable to store the result to
     * @returns The distance between "ref" and "vector"
     */ static ProjectOnTriangleToRef(vector, p0, p1, p2, ref) {
        const p1p0 = $c7e4de670ed74d35$var$MathTmp.Vector3[0];
        const p2p0 = $c7e4de670ed74d35$var$MathTmp.Vector3[1];
        const p2p1 = $c7e4de670ed74d35$var$MathTmp.Vector3[2];
        const normal = $c7e4de670ed74d35$var$MathTmp.Vector3[3];
        const vectorp0 = $c7e4de670ed74d35$var$MathTmp.Vector3[4];
        // Triangle vectors
        p1.subtractToRef(p0, p1p0);
        p2.subtractToRef(p0, p2p0);
        p2.subtractToRef(p1, p2p1);
        const p1p0L = p1p0.length();
        const p2p0L = p2p0.length();
        const p2p1L = p2p1.length();
        if (p1p0L < (0, $53VPf.Epsilon) || p2p0L < (0, $53VPf.Epsilon) || p2p1L < (0, $53VPf.Epsilon)) {
            // This is a degenerate triangle. As we assume this is part of a non-degenerate mesh,
            // we will find a better intersection later.
            // Let's just return one of the extremities
            ref.copyFrom(p0);
            return $c7e4de670ed74d35$export$64b5c384219d3699.Distance(vector, p0);
        }
        // Compute normal and vector to p0
        vector.subtractToRef(p0, vectorp0);
        $c7e4de670ed74d35$export$64b5c384219d3699.CrossToRef(p1p0, p2p0, normal);
        const nl = normal.length();
        if (nl < (0, $53VPf.Epsilon)) {
            // Extremities are aligned, we are back on the case of a degenerate triangle
            ref.copyFrom(p0);
            return $c7e4de670ed74d35$export$64b5c384219d3699.Distance(vector, p0);
        }
        normal.normalizeFromLength(nl);
        let l = vectorp0.length();
        if (l < (0, $53VPf.Epsilon)) {
            // Vector is p0
            ref.copyFrom(p0);
            return 0;
        }
        vectorp0.normalizeFromLength(l);
        // Project to "proj" that lies on the triangle plane
        const cosA = $c7e4de670ed74d35$export$64b5c384219d3699.Dot(normal, vectorp0);
        const projVector = $c7e4de670ed74d35$var$MathTmp.Vector3[5];
        const proj = $c7e4de670ed74d35$var$MathTmp.Vector3[6];
        projVector.copyFrom(normal).scaleInPlace(-l * cosA);
        proj.copyFrom(vector).addInPlace(projVector);
        // Compute barycentric coordinates (v0, v1 and v2 are axis from barycenter to extremities)
        const v0 = $c7e4de670ed74d35$var$MathTmp.Vector3[4];
        const v1 = $c7e4de670ed74d35$var$MathTmp.Vector3[5];
        const v2 = $c7e4de670ed74d35$var$MathTmp.Vector3[7];
        const tmp = $c7e4de670ed74d35$var$MathTmp.Vector3[8];
        v0.copyFrom(p1p0).scaleInPlace(1 / p1p0L);
        tmp.copyFrom(p2p0).scaleInPlace(1 / p2p0L);
        v0.addInPlace(tmp).scaleInPlace(-1);
        v1.copyFrom(p1p0).scaleInPlace(-1 / p1p0L);
        tmp.copyFrom(p2p1).scaleInPlace(1 / p2p1L);
        v1.addInPlace(tmp).scaleInPlace(-1);
        v2.copyFrom(p2p1).scaleInPlace(-1 / p2p1L);
        tmp.copyFrom(p2p0).scaleInPlace(-1 / p2p0L);
        v2.addInPlace(tmp).scaleInPlace(-1);
        // Determines which edge of the triangle is closest to "proj"
        const projP = $c7e4de670ed74d35$var$MathTmp.Vector3[9];
        let dot;
        projP.copyFrom(proj).subtractInPlace(p0);
        $c7e4de670ed74d35$export$64b5c384219d3699.CrossToRef(v0, projP, tmp);
        dot = $c7e4de670ed74d35$export$64b5c384219d3699.Dot(tmp, normal);
        const s0 = dot;
        projP.copyFrom(proj).subtractInPlace(p1);
        $c7e4de670ed74d35$export$64b5c384219d3699.CrossToRef(v1, projP, tmp);
        dot = $c7e4de670ed74d35$export$64b5c384219d3699.Dot(tmp, normal);
        const s1 = dot;
        projP.copyFrom(proj).subtractInPlace(p2);
        $c7e4de670ed74d35$export$64b5c384219d3699.CrossToRef(v2, projP, tmp);
        dot = $c7e4de670ed74d35$export$64b5c384219d3699.Dot(tmp, normal);
        const s2 = dot;
        const edge = $c7e4de670ed74d35$var$MathTmp.Vector3[10];
        let e0, e1;
        if (s0 > 0 && s1 < 0) {
            edge.copyFrom(p1p0);
            e0 = p0;
            e1 = p1;
        } else if (s1 > 0 && s2 < 0) {
            edge.copyFrom(p2p1);
            e0 = p1;
            e1 = p2;
        } else {
            edge.copyFrom(p2p0).scaleInPlace(-1);
            e0 = p2;
            e1 = p0;
        }
        // Determines if "proj" lies inside the triangle
        const tmp2 = $c7e4de670ed74d35$var$MathTmp.Vector3[9];
        const tmp3 = $c7e4de670ed74d35$var$MathTmp.Vector3[4];
        e0.subtractToRef(proj, tmp);
        e1.subtractToRef(proj, tmp2);
        $c7e4de670ed74d35$export$64b5c384219d3699.CrossToRef(tmp, tmp2, tmp3);
        const isOutside = $c7e4de670ed74d35$export$64b5c384219d3699.Dot(tmp3, normal) < 0;
        // If inside, we already found the projected point, "proj"
        if (!isOutside) {
            ref.copyFrom(proj);
            return Math.abs(l * cosA);
        }
        // If outside, we find "triProj", the closest point from "proj" on the closest edge
        const r = $c7e4de670ed74d35$var$MathTmp.Vector3[5];
        $c7e4de670ed74d35$export$64b5c384219d3699.CrossToRef(edge, tmp3, r);
        r.normalize();
        const e0proj = $c7e4de670ed74d35$var$MathTmp.Vector3[9];
        e0proj.copyFrom(e0).subtractInPlace(proj);
        const e0projL = e0proj.length();
        if (e0projL < (0, $53VPf.Epsilon)) {
            // Proj is e0
            ref.copyFrom(e0);
            return $c7e4de670ed74d35$export$64b5c384219d3699.Distance(vector, e0);
        }
        e0proj.normalizeFromLength(e0projL);
        const cosG = $c7e4de670ed74d35$export$64b5c384219d3699.Dot(r, e0proj);
        const triProj = $c7e4de670ed74d35$var$MathTmp.Vector3[7];
        triProj.copyFrom(proj).addInPlace(r.scaleInPlace(e0projL * cosG));
        // Now we clamp "triProj" so it lies between e0 and e1
        tmp.copyFrom(triProj).subtractInPlace(e0);
        l = edge.length();
        edge.normalizeFromLength(l);
        let t = $c7e4de670ed74d35$export$64b5c384219d3699.Dot(tmp, edge) / Math.max(l, (0, $53VPf.Epsilon));
        t = (0, $iosaP.Clamp)(t, 0, 1);
        triProj.copyFrom(e0).addInPlace(edge.scaleInPlace(t * l));
        ref.copyFrom(triProj);
        return $c7e4de670ed74d35$export$64b5c384219d3699.Distance(vector, triProj);
    }
    /**
     * Returns a new Vector3 located at the center between "value1" and "value2"
     * Example Playground https://playground.babylonjs.com/#R1F8YU#72
     * @param value1 defines the first operand
     * @param value2 defines the second operand
     * @returns the new Vector3
     */ static Center(value1, value2) {
        return $c7e4de670ed74d35$export$64b5c384219d3699.CenterToRef(value1, value2, $c7e4de670ed74d35$export$64b5c384219d3699.Zero());
    }
    /**
     * Gets the center of the vectors "value1" and "value2" and stores the result in the vector "ref"
     * Example Playground https://playground.babylonjs.com/#R1F8YU#73
     * @param value1 defines first vector
     * @param value2 defines second vector
     * @param ref defines third vector
     * @returns ref
     */ static CenterToRef(value1, value2, ref) {
        return ref.copyFromFloats((value1._x + value2._x) / 2, (value1._y + value2._y) / 2, (value1._z + value2._z) / 2);
    }
    /**
     * Given three orthogonal normalized left-handed oriented Vector3 axis in space (target system),
     * RotationFromAxis() returns the rotation Euler angles (ex : rotation.x, rotation.y, rotation.z) to apply
     * to something in order to rotate it from its local system to the given target system
     * Note: axis1, axis2 and axis3 are normalized during this operation
     * Example Playground https://playground.babylonjs.com/#R1F8YU#106
     * @param axis1 defines the first axis
     * @param axis2 defines the second axis
     * @param axis3 defines the third axis
     * @returns a new Vector3
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/transforms/center_origin/target_align
     */ static RotationFromAxis(axis1, axis2, axis3) {
        const rotation = new axis1.constructor();
        $c7e4de670ed74d35$export$64b5c384219d3699.RotationFromAxisToRef(axis1, axis2, axis3, rotation);
        return rotation;
    }
    /**
     * The same than RotationFromAxis but updates the given ref Vector3 parameter instead of returning a new Vector3
     * Example Playground https://playground.babylonjs.com/#R1F8YU#107
     * @param axis1 defines the first axis
     * @param axis2 defines the second axis
     * @param axis3 defines the third axis
     * @param ref defines the Vector3 where to store the result
     * @returns result input
     */ static RotationFromAxisToRef(axis1, axis2, axis3, ref) {
        const quat = $c7e4de670ed74d35$var$MathTmp.Quaternion[0];
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.RotationQuaternionFromAxisToRef(axis1, axis2, axis3, quat);
        quat.toEulerAnglesToRef(ref);
        return ref;
    }
}
$c7e4de670ed74d35$export$64b5c384219d3699._UpReadOnly = $c7e4de670ed74d35$export$64b5c384219d3699.Up();
$c7e4de670ed74d35$export$64b5c384219d3699._DownReadOnly = $c7e4de670ed74d35$export$64b5c384219d3699.Down();
$c7e4de670ed74d35$export$64b5c384219d3699._LeftHandedForwardReadOnly = $c7e4de670ed74d35$export$64b5c384219d3699.Forward(false);
$c7e4de670ed74d35$export$64b5c384219d3699._RightHandedForwardReadOnly = $c7e4de670ed74d35$export$64b5c384219d3699.Forward(true);
$c7e4de670ed74d35$export$64b5c384219d3699._LeftHandedBackwardReadOnly = $c7e4de670ed74d35$export$64b5c384219d3699.Backward(false);
$c7e4de670ed74d35$export$64b5c384219d3699._RightHandedBackwardReadOnly = $c7e4de670ed74d35$export$64b5c384219d3699.Backward(true);
$c7e4de670ed74d35$export$64b5c384219d3699._RightReadOnly = $c7e4de670ed74d35$export$64b5c384219d3699.Right();
$c7e4de670ed74d35$export$64b5c384219d3699._LeftReadOnly = $c7e4de670ed74d35$export$64b5c384219d3699.Left();
$c7e4de670ed74d35$export$64b5c384219d3699._ZeroReadOnly = $c7e4de670ed74d35$export$64b5c384219d3699.Zero();
$c7e4de670ed74d35$export$64b5c384219d3699._OneReadOnly = $c7e4de670ed74d35$export$64b5c384219d3699.One();
$c7e4de670ed74d35$export$64b5c384219d3699;
Object.defineProperties($c7e4de670ed74d35$export$64b5c384219d3699.prototype, {
    dimension: {
        value: [
            3
        ]
    },
    rank: {
        value: 1
    }
});
class $c7e4de670ed74d35$export$fa7daccca11cdbe3 {
    /**
     * Creates a Vector4 object from the given floats.
     * @param x x value of the vector
     * @param y y value of the vector
     * @param z z value of the vector
     * @param w w value of the vector
     */ constructor(/** x value of the vector */ x = 0, /** y value of the vector */ y = 0, /** z value of the vector */ z = 0, /** w value of the vector */ w = 0){
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
    }
    /**
     * Returns the string with the Vector4 coordinates.
     * @returns a string containing all the vector values
     */ toString() {
        return `{X: ${this.x} Y: ${this.y} Z: ${this.z} W: ${this.w}}`;
    }
    /**
     * Returns the string "Vector4".
     * @returns "Vector4"
     */ getClassName() {
        return "Vector4";
    }
    /**
     * Returns the Vector4 hash code.
     * @returns a unique hash code
     */ getHashCode() {
        const x = $c7e4de670ed74d35$var$_ExtractAsInt(this.x);
        const y = $c7e4de670ed74d35$var$_ExtractAsInt(this.y);
        const z = $c7e4de670ed74d35$var$_ExtractAsInt(this.z);
        const w = $c7e4de670ed74d35$var$_ExtractAsInt(this.w);
        let hash = x;
        hash = hash * 397 ^ y;
        hash = hash * 397 ^ z;
        hash = hash * 397 ^ w;
        return hash;
    }
    // Operators
    /**
     * Returns a new array populated with 4 elements : the Vector4 coordinates.
     * @returns the resulting array
     */ asArray() {
        return [
            this.x,
            this.y,
            this.z,
            this.w
        ];
    }
    /**
     * Populates the given array from the given index with the Vector4 coordinates.
     * @param array array to populate
     * @param index index of the array to start at (default: 0)
     * @returns the Vector4.
     */ toArray(array, index) {
        if (index === undefined) index = 0;
        array[index] = this.x;
        array[index + 1] = this.y;
        array[index + 2] = this.z;
        array[index + 3] = this.w;
        return this;
    }
    /**
     * Update the current vector from an array
     * @param array defines the destination array
     * @param offset defines the offset in the destination array
     * @returns the current Vector3
     */ fromArray(array, offset = 0) {
        $c7e4de670ed74d35$export$fa7daccca11cdbe3.FromArrayToRef(array, offset, this);
        return this;
    }
    /**
     * Adds the given vector to the current Vector4.
     * @param otherVector the vector to add
     * @returns the updated Vector4.
     */ addInPlace(otherVector) {
        this.x += otherVector.x;
        this.y += otherVector.y;
        this.z += otherVector.z;
        this.w += otherVector.w;
        return this;
    }
    /**
     * Adds the given coordinates to the current Vector4
     * @param x defines the x coordinate of the operand
     * @param y defines the y coordinate of the operand
     * @param z defines the z coordinate of the operand
     * @param w defines the w coordinate of the operand
     * @returns the current updated Vector4
     */ addInPlaceFromFloats(x, y, z, w) {
        this.x += x;
        this.y += y;
        this.z += z;
        this.w += w;
        return this;
    }
    /**
     * Returns a new Vector4 as the result of the addition of the current Vector4 and the given one.
     * @param otherVector the vector to add
     * @returns the resulting vector
     */ add(otherVector) {
        return new this.constructor(this.x + otherVector.x, this.y + otherVector.y, this.z + otherVector.z, this.w + otherVector.w);
    }
    /**
     * Updates the given vector "result" with the result of the addition of the current Vector4 and the given one.
     * @param otherVector the vector to add
     * @param result the vector to store the result
     * @returns result input
     */ addToRef(otherVector, result) {
        result.x = this.x + otherVector.x;
        result.y = this.y + otherVector.y;
        result.z = this.z + otherVector.z;
        result.w = this.w + otherVector.w;
        return result;
    }
    /**
     * Subtract in place the given vector from the current Vector4.
     * @param otherVector the vector to subtract
     * @returns the updated Vector4.
     */ subtractInPlace(otherVector) {
        this.x -= otherVector.x;
        this.y -= otherVector.y;
        this.z -= otherVector.z;
        this.w -= otherVector.w;
        return this;
    }
    /**
     * Returns a new Vector4 with the result of the subtraction of the given vector from the current Vector4.
     * @param otherVector the vector to add
     * @returns the new vector with the result
     */ subtract(otherVector) {
        return new this.constructor(this.x - otherVector.x, this.y - otherVector.y, this.z - otherVector.z, this.w - otherVector.w);
    }
    /**
     * Sets the given vector "result" with the result of the subtraction of the given vector from the current Vector4.
     * @param otherVector the vector to subtract
     * @param result the vector to store the result
     * @returns result input
     */ subtractToRef(otherVector, result) {
        result.x = this.x - otherVector.x;
        result.y = this.y - otherVector.y;
        result.z = this.z - otherVector.z;
        result.w = this.w - otherVector.w;
        return result;
    }
    /**
     * Returns a new Vector4 set with the result of the subtraction of the given floats from the current Vector4 coordinates.
     * @param x value to subtract
     * @param y value to subtract
     * @param z value to subtract
     * @param w value to subtract
     * @returns new vector containing the result
     */ subtractFromFloats(x, y, z, w) {
        return new this.constructor(this.x - x, this.y - y, this.z - z, this.w - w);
    }
    /**
     * Sets the given vector "result" set with the result of the subtraction of the given floats from the current Vector4 coordinates.
     * @param x value to subtract
     * @param y value to subtract
     * @param z value to subtract
     * @param w value to subtract
     * @param result the vector to store the result in
     * @returns result input
     */ subtractFromFloatsToRef(x, y, z, w, result) {
        result.x = this.x - x;
        result.y = this.y - y;
        result.z = this.z - z;
        result.w = this.w - w;
        return result;
    }
    /**
     * Returns a new Vector4 set with the current Vector4 negated coordinates.
     * @returns a new vector with the negated values
     */ negate() {
        return new this.constructor(-this.x, -this.y, -this.z, -this.w);
    }
    /**
     * Negate this vector in place
     * @returns this
     */ negateInPlace() {
        this.x *= -1;
        this.y *= -1;
        this.z *= -1;
        this.w *= -1;
        return this;
    }
    /**
     * Negate the current Vector4 and stores the result in the given vector "result" coordinates
     * @param result defines the Vector3 object where to store the result
     * @returns the result
     */ negateToRef(result) {
        return result.copyFromFloats(this.x * -1, this.y * -1, this.z * -1, this.w * -1);
    }
    /**
     * Multiplies the current Vector4 coordinates by scale (float).
     * @param scale the number to scale with
     * @returns the updated Vector4.
     */ scaleInPlace(scale) {
        this.x *= scale;
        this.y *= scale;
        this.z *= scale;
        this.w *= scale;
        return this;
    }
    /**
     * Returns a new Vector4 set with the current Vector4 coordinates multiplied by scale (float).
     * @param scale the number to scale with
     * @returns a new vector with the result
     */ scale(scale) {
        return new this.constructor(this.x * scale, this.y * scale, this.z * scale, this.w * scale);
    }
    /**
     * Sets the given vector "result" with the current Vector4 coordinates multiplied by scale (float).
     * @param scale the number to scale with
     * @param result a vector to store the result in
     * @returns result input
     */ scaleToRef(scale, result) {
        result.x = this.x * scale;
        result.y = this.y * scale;
        result.z = this.z * scale;
        result.w = this.w * scale;
        return result;
    }
    /**
     * Scale the current Vector4 values by a factor and add the result to a given Vector4
     * @param scale defines the scale factor
     * @param result defines the Vector4 object where to store the result
     * @returns result input
     */ scaleAndAddToRef(scale, result) {
        result.x += this.x * scale;
        result.y += this.y * scale;
        result.z += this.z * scale;
        result.w += this.w * scale;
        return result;
    }
    /**
     * Boolean : True if the current Vector4 coordinates are stricly equal to the given ones.
     * @param otherVector the vector to compare against
     * @returns true if they are equal
     */ equals(otherVector) {
        return otherVector && this.x === otherVector.x && this.y === otherVector.y && this.z === otherVector.z && this.w === otherVector.w;
    }
    /**
     * Boolean : True if the current Vector4 coordinates are each beneath the distance "epsilon" from the given vector ones.
     * @param otherVector vector to compare against
     * @param epsilon (Default: very small number)
     * @returns true if they are equal
     */ equalsWithEpsilon(otherVector, epsilon = (0, $53VPf.Epsilon)) {
        return otherVector && (0, $iosaP.WithinEpsilon)(this.x, otherVector.x, epsilon) && (0, $iosaP.WithinEpsilon)(this.y, otherVector.y, epsilon) && (0, $iosaP.WithinEpsilon)(this.z, otherVector.z, epsilon) && (0, $iosaP.WithinEpsilon)(this.w, otherVector.w, epsilon);
    }
    /**
     * Boolean : True if the given floats are strictly equal to the current Vector4 coordinates.
     * @param x x value to compare against
     * @param y y value to compare against
     * @param z z value to compare against
     * @param w w value to compare against
     * @returns true if equal
     */ equalsToFloats(x, y, z, w) {
        return this.x === x && this.y === y && this.z === z && this.w === w;
    }
    /**
     * Multiplies in place the current Vector4 by the given one.
     * @param otherVector vector to multiple with
     * @returns the updated Vector4.
     */ multiplyInPlace(otherVector) {
        this.x *= otherVector.x;
        this.y *= otherVector.y;
        this.z *= otherVector.z;
        this.w *= otherVector.w;
        return this;
    }
    /**
     * Returns a new Vector4 set with the multiplication result of the current Vector4 and the given one.
     * @param otherVector vector to multiple with
     * @returns resulting new vector
     */ multiply(otherVector) {
        return new this.constructor(this.x * otherVector.x, this.y * otherVector.y, this.z * otherVector.z, this.w * otherVector.w);
    }
    /**
     * Updates the given vector "result" with the multiplication result of the current Vector4 and the given one.
     * @param otherVector vector to multiple with
     * @param result vector to store the result
     * @returns result input
     */ multiplyToRef(otherVector, result) {
        result.x = this.x * otherVector.x;
        result.y = this.y * otherVector.y;
        result.z = this.z * otherVector.z;
        result.w = this.w * otherVector.w;
        return result;
    }
    /**
     * Returns a new Vector4 set with the multiplication result of the given floats and the current Vector4 coordinates.
     * @param x x value multiply with
     * @param y y value multiply with
     * @param z z value multiply with
     * @param w w value multiply with
     * @returns resulting new vector
     */ multiplyByFloats(x, y, z, w) {
        return new this.constructor(this.x * x, this.y * y, this.z * z, this.w * w);
    }
    /**
     * Returns a new Vector4 set with the division result of the current Vector4 by the given one.
     * @param otherVector vector to devide with
     * @returns resulting new vector
     */ divide(otherVector) {
        return new this.constructor(this.x / otherVector.x, this.y / otherVector.y, this.z / otherVector.z, this.w / otherVector.w);
    }
    /**
     * Updates the given vector "result" with the division result of the current Vector4 by the given one.
     * @param otherVector vector to devide with
     * @param result vector to store the result
     * @returns result input
     */ divideToRef(otherVector, result) {
        result.x = this.x / otherVector.x;
        result.y = this.y / otherVector.y;
        result.z = this.z / otherVector.z;
        result.w = this.w / otherVector.w;
        return result;
    }
    /**
     * Divides the current Vector3 coordinates by the given ones.
     * @param otherVector vector to devide with
     * @returns the updated Vector3.
     */ divideInPlace(otherVector) {
        return this.divideToRef(otherVector, this);
    }
    /**
     * Updates the Vector4 coordinates with the minimum values between its own and the given vector ones
     * @param other defines the second operand
     * @returns the current updated Vector4
     */ minimizeInPlace(other) {
        if (other.x < this.x) this.x = other.x;
        if (other.y < this.y) this.y = other.y;
        if (other.z < this.z) this.z = other.z;
        if (other.w < this.w) this.w = other.w;
        return this;
    }
    /**
     * Updates the Vector4 coordinates with the maximum values between its own and the given vector ones
     * @param other defines the second operand
     * @returns the current updated Vector4
     */ maximizeInPlace(other) {
        if (other.x > this.x) this.x = other.x;
        if (other.y > this.y) this.y = other.y;
        if (other.z > this.z) this.z = other.z;
        if (other.w > this.w) this.w = other.w;
        return this;
    }
    /**
     * Updates the current Vector4 with the minimal coordinate values between its and the given coordinates
     * @param x defines the x coordinate of the operand
     * @param y defines the y coordinate of the operand
     * @param z defines the z coordinate of the operand
     * @param w defines the w coordinate of the operand
     * @returns the current updated Vector4
     */ minimizeInPlaceFromFloats(x, y, z, w) {
        this.x = Math.min(x, this.x);
        this.y = Math.min(y, this.y);
        this.z = Math.min(z, this.z);
        this.w = Math.min(w, this.w);
        return this;
    }
    /**
     * Updates the current Vector4 with the maximal coordinate values between its and the given coordinates.
     * @param x defines the x coordinate of the operand
     * @param y defines the y coordinate of the operand
     * @param z defines the z coordinate of the operand
     * @param w defines the w coordinate of the operand
     * @returns the current updated Vector4
     */ maximizeInPlaceFromFloats(x, y, z, w) {
        this.x = Math.max(x, this.x);
        this.y = Math.max(y, this.y);
        this.z = Math.max(z, this.z);
        this.w = Math.max(w, this.w);
        return this;
    }
    /**
     * Gets the current Vector4's floored values and stores them in result
     * @param result the vector to store the result in
     * @returns the result vector
     */ floorToRef(result) {
        result.x = Math.floor(this.x);
        result.y = Math.floor(this.y);
        result.z = Math.floor(this.z);
        result.w = Math.floor(this.w);
        return result;
    }
    /**
     * Gets a new Vector4 from current Vector4 floored values
     * @returns a new Vector4
     */ floor() {
        return new this.constructor(Math.floor(this.x), Math.floor(this.y), Math.floor(this.z), Math.floor(this.w));
    }
    /**
     * Gets the current Vector4's fractional values and stores them in result
     * @param result the vector to store the result in
     * @returns the result vector
     */ fractToRef(result) {
        result.x = this.x - Math.floor(this.x);
        result.y = this.y - Math.floor(this.y);
        result.z = this.z - Math.floor(this.z);
        result.w = this.w - Math.floor(this.w);
        return result;
    }
    /**
     * Gets a new Vector4 from current Vector4 fractional values
     * @returns a new Vector4
     */ fract() {
        return new this.constructor(this.x - Math.floor(this.x), this.y - Math.floor(this.y), this.z - Math.floor(this.z), this.w - Math.floor(this.w));
    }
    // Properties
    /**
     * Returns the Vector4 length (float).
     * @returns the length
     */ length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    /**
     * Returns the Vector4 squared length (float).
     * @returns the length squared
     */ lengthSquared() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    // Methods
    /**
     * Normalizes in place the Vector4.
     * @returns the updated Vector4.
     */ normalize() {
        return this.normalizeFromLength(this.length());
    }
    /**
     * Normalize the current Vector4 with the given input length.
     * Please note that this is an in place operation.
     * @param len the length of the vector
     * @returns the current updated Vector4
     */ normalizeFromLength(len) {
        if (len === 0 || len === 1.0) return this;
        return this.scaleInPlace(1.0 / len);
    }
    /**
     * Normalize the current Vector4 to a new vector
     * @returns the new Vector4
     */ normalizeToNew() {
        const normalized = new this.constructor();
        this.normalizeToRef(normalized);
        return normalized;
    }
    /**
     * Normalize the current Vector4 to the reference
     * @param reference define the Vector4 to update
     * @returns the updated Vector4
     */ normalizeToRef(reference) {
        const len = this.length();
        if (len === 0 || len === 1.0) return reference.copyFrom(this);
        return this.scaleToRef(1.0 / len, reference);
    }
    /**
     * Returns a new Vector3 from the Vector4 (x, y, z) coordinates.
     * @returns this converted to a new vector3
     */ toVector3() {
        return new $c7e4de670ed74d35$export$64b5c384219d3699(this.x, this.y, this.z);
    }
    /**
     * Returns a new Vector4 copied from the current one.
     * @returns the new cloned vector
     */ clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    /**
     * Updates the current Vector4 with the given one coordinates.
     * @param source the source vector to copy from
     * @returns the updated Vector4.
     */ copyFrom(source) {
        this.x = source.x;
        this.y = source.y;
        this.z = source.z;
        this.w = source.w;
        return this;
    }
    /**
     * Updates the current Vector4 coordinates with the given floats.
     * @param x float to copy from
     * @param y float to copy from
     * @param z float to copy from
     * @param w float to copy from
     * @returns the updated Vector4.
     */ copyFromFloats(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
    }
    /**
     * Updates the current Vector4 coordinates with the given floats.
     * @param x float to set from
     * @param y float to set from
     * @param z float to set from
     * @param w float to set from
     * @returns the updated Vector4.
     */ set(x, y, z, w) {
        return this.copyFromFloats(x, y, z, w);
    }
    /**
     * Copies the given float to the current Vector4 coordinates
     * @param v defines the x, y, z and w coordinates of the operand
     * @returns the current updated Vector4
     */ setAll(v) {
        this.x = this.y = this.z = this.w = v;
        return this;
    }
    /**
     * Returns the dot product (float) between the current vectors and "otherVector"
     * @param otherVector defines the right operand
     * @returns the dot product
     */ dot(otherVector) {
        return this.x * otherVector.x + this.y * otherVector.y + this.z * otherVector.z + this.w * otherVector.w;
    }
    // Statics
    /**
     * Returns a new Vector4 set from the starting index of the given array.
     * @param array the array to pull values from
     * @param offset the offset into the array to start at
     * @returns the new vector
     */ static FromArray(array, offset) {
        if (!offset) offset = 0;
        return new $c7e4de670ed74d35$export$fa7daccca11cdbe3(array[offset], array[offset + 1], array[offset + 2], array[offset + 3]);
    }
    /**
     * Updates the given vector "result" from the starting index of the given array.
     * @param array the array to pull values from
     * @param offset the offset into the array to start at
     * @param result the vector to store the result in
     * @returns result input
     */ static FromArrayToRef(array, offset, result) {
        result.x = array[offset];
        result.y = array[offset + 1];
        result.z = array[offset + 2];
        result.w = array[offset + 3];
        return result;
    }
    /**
     * Updates the given vector "result" from the starting index of the given Float32Array.
     * @param array the array to pull values from
     * @param offset the offset into the array to start at
     * @param result the vector to store the result in
     * @returns result input
     */ static FromFloatArrayToRef(array, offset, result) {
        $c7e4de670ed74d35$export$fa7daccca11cdbe3.FromArrayToRef(array, offset, result);
        return result;
    }
    /**
     * Updates the given vector "result" coordinates from the given floats.
     * @param x float to set from
     * @param y float to set from
     * @param z float to set from
     * @param w float to set from
     * @param result the vector to the floats in
     * @returns result input
     */ static FromFloatsToRef(x, y, z, w, result) {
        result.x = x;
        result.y = y;
        result.z = z;
        result.w = w;
        return result;
    }
    /**
     * Returns a new Vector4 set to (0.0, 0.0, 0.0, 0.0)
     * @returns the new vector
     */ static Zero() {
        return new $c7e4de670ed74d35$export$fa7daccca11cdbe3(0.0, 0.0, 0.0, 0.0);
    }
    /**
     * Returns a new Vector4 set to (1.0, 1.0, 1.0, 1.0)
     * @returns the new vector
     */ static One() {
        return new $c7e4de670ed74d35$export$fa7daccca11cdbe3(1.0, 1.0, 1.0, 1.0);
    }
    /**
     * Returns a new Vector4 with random values between min and max
     * @param min the minimum random value
     * @param max the maximum random value
     * @returns a Vector4 with random values between min and max
     */ static Random(min = 0, max = 1) {
        return new $c7e4de670ed74d35$export$fa7daccca11cdbe3((0, $iosaP.RandomRange)(min, max), (0, $iosaP.RandomRange)(min, max), (0, $iosaP.RandomRange)(min, max), (0, $iosaP.RandomRange)(min, max));
    }
    /**
     * Sets a Vector4 with random values between min and max
     * @param min the minimum random value
     * @param max the maximum random value
     * @param ref the ref to store the values in
     * @returns the ref with random values between min and max
     */ static RandomToRef(min = 0, max = 1, ref) {
        return ref.copyFromFloats((0, $iosaP.RandomRange)(min, max), (0, $iosaP.RandomRange)(min, max), (0, $iosaP.RandomRange)(min, max), (0, $iosaP.RandomRange)(min, max));
    }
    /**
     * Returns a new Vector4 set with the coordinates of "value", if the vector "value" is in the cube defined by the vectors "min" and "max"
     * If a coordinate value of "value" is lower than one of the "min" coordinate, then this "value" coordinate is set with the "min" one
     * If a coordinate value of "value" is greater than one of the "max" coordinate, then this "value" coordinate is set with the "max" one
     * @param value defines the current value
     * @param min defines the lower range value
     * @param max defines the upper range value
     * @returns the new Vector4
     */ static Clamp(value, min, max) {
        const result = new value.constructor();
        $c7e4de670ed74d35$export$fa7daccca11cdbe3.ClampToRef(value, min, max, result);
        return result;
    }
    /**
     * Sets the given vector "result" with the coordinates of "value", if the vector "value" is in the cube defined by the vectors "min" and "max"
     * If a coordinate value of "value" is lower than one of the "min" coordinate, then this "value" coordinate is set with the "min" one
     * If a coordinate value of "value" is greater than one of the "max" coordinate, then this "value" coordinate is set with the "max" one
     * @param value defines the current value
     * @param min defines the lower range value
     * @param max defines the upper range value
     * @param result defines the Vector4 where to store the result
     * @returns result input
     */ static ClampToRef(value, min, max, result) {
        return result.copyFromFloats((0, $iosaP.Clamp)(value.x, min.x, max.x), (0, $iosaP.Clamp)(value.y, min.y, max.y), (0, $iosaP.Clamp)(value.z, min.z, max.z), (0, $iosaP.Clamp)(value.w, min.w, max.w));
    }
    /**
     * Checks if a given vector is inside a specific range
     * Example Playground https://playground.babylonjs.com/#R1F8YU#75
     * @param v defines the vector to test
     * @param min defines the minimum range
     * @param max defines the maximum range
     */ static CheckExtends(v, min, max) {
        min.minimizeInPlace(v);
        max.maximizeInPlace(v);
    }
    /**
     * Gets a zero Vector4 that must not be updated
     */ static get ZeroReadOnly() {
        return $c7e4de670ed74d35$export$fa7daccca11cdbe3._ZeroReadOnly;
    }
    /**
     * Returns a new normalized Vector4 from the given one.
     * @param vector the vector to normalize
     * @returns the vector
     */ static Normalize(vector) {
        const result = $c7e4de670ed74d35$export$fa7daccca11cdbe3.Zero();
        $c7e4de670ed74d35$export$fa7daccca11cdbe3.NormalizeToRef(vector, result);
        return result;
    }
    /**
     * Updates the given vector "result" from the normalization of the given one.
     * @param vector the vector to normalize
     * @param result the vector to store the result in
     * @returns result input
     */ static NormalizeToRef(vector, result) {
        vector.normalizeToRef(result);
        return result;
    }
    /**
     * Returns a vector with the minimum values from the left and right vectors
     * @param left left vector to minimize
     * @param right right vector to minimize
     * @returns a new vector with the minimum of the left and right vector values
     */ static Minimize(left, right) {
        const min = new left.constructor();
        min.copyFrom(left);
        min.minimizeInPlace(right);
        return min;
    }
    /**
     * Returns a vector with the maximum values from the left and right vectors
     * @param left left vector to maximize
     * @param right right vector to maximize
     * @returns a new vector with the maximum of the left and right vector values
     */ static Maximize(left, right) {
        const max = new left.constructor();
        max.copyFrom(left);
        max.maximizeInPlace(right);
        return max;
    }
    /**
     * Returns the distance (float) between the vectors "value1" and "value2".
     * @param value1 value to calulate the distance between
     * @param value2 value to calulate the distance between
     * @returns the distance between the two vectors
     */ static Distance(value1, value2) {
        return Math.sqrt($c7e4de670ed74d35$export$fa7daccca11cdbe3.DistanceSquared(value1, value2));
    }
    /**
     * Returns the squared distance (float) between the vectors "value1" and "value2".
     * @param value1 value to calulate the distance between
     * @param value2 value to calulate the distance between
     * @returns the distance between the two vectors squared
     */ static DistanceSquared(value1, value2) {
        const x = value1.x - value2.x;
        const y = value1.y - value2.y;
        const z = value1.z - value2.z;
        const w = value1.w - value2.w;
        return x * x + y * y + z * z + w * w;
    }
    /**
     * Returns a new Vector4 located at the center between the vectors "value1" and "value2".
     * @param value1 value to calulate the center between
     * @param value2 value to calulate the center between
     * @returns the center between the two vectors
     */ static Center(value1, value2) {
        return $c7e4de670ed74d35$export$fa7daccca11cdbe3.CenterToRef(value1, value2, $c7e4de670ed74d35$export$fa7daccca11cdbe3.Zero());
    }
    /**
     * Gets the center of the vectors "value1" and "value2" and stores the result in the vector "ref"
     * @param value1 defines first vector
     * @param value2 defines second vector
     * @param ref defines third vector
     * @returns ref
     */ static CenterToRef(value1, value2, ref) {
        return ref.copyFromFloats((value1.x + value2.x) / 2, (value1.y + value2.y) / 2, (value1.z + value2.z) / 2, (value1.w + value2.w) / 2);
    }
    /**
     * Returns a new Vector4 set with the result of the transformation by the given matrix of the given vector.
     * This method computes tranformed coordinates only, not transformed direction vectors (ie. it takes translation in account)
     * The difference with Vector3.TransformCoordinates is that the w component is not used to divide the other coordinates but is returned in the w coordinate instead
     * @param vector defines the Vector3 to transform
     * @param transformation defines the transformation matrix
     * @returns the transformed Vector4
     */ static TransformCoordinates(vector, transformation) {
        const result = $c7e4de670ed74d35$export$fa7daccca11cdbe3.Zero();
        $c7e4de670ed74d35$export$fa7daccca11cdbe3.TransformCoordinatesToRef(vector, transformation, result);
        return result;
    }
    /**
     * Sets the given vector "result" coordinates with the result of the transformation by the given matrix of the given vector
     * This method computes tranformed coordinates only, not transformed direction vectors (ie. it takes translation in account)
     * The difference with Vector3.TransformCoordinatesToRef is that the w component is not used to divide the other coordinates but is returned in the w coordinate instead
     * @param vector defines the Vector3 to transform
     * @param transformation defines the transformation matrix
     * @param result defines the Vector4 where to store the result
     * @returns result input
     */ static TransformCoordinatesToRef(vector, transformation, result) {
        $c7e4de670ed74d35$export$fa7daccca11cdbe3.TransformCoordinatesFromFloatsToRef(vector._x, vector._y, vector._z, transformation, result);
        return result;
    }
    /**
     * Sets the given vector "result" coordinates with the result of the transformation by the given matrix of the given floats (x, y, z)
     * This method computes tranformed coordinates only, not transformed direction vectors
     * The difference with Vector3.TransformCoordinatesFromFloatsToRef is that the w component is not used to divide the other coordinates but is returned in the w coordinate instead
     * @param x define the x coordinate of the source vector
     * @param y define the y coordinate of the source vector
     * @param z define the z coordinate of the source vector
     * @param transformation defines the transformation matrix
     * @param result defines the Vector4 where to store the result
     * @returns result input
     */ static TransformCoordinatesFromFloatsToRef(x, y, z, transformation, result) {
        const m = transformation.m;
        const rx = x * m[0] + y * m[4] + z * m[8] + m[12];
        const ry = x * m[1] + y * m[5] + z * m[9] + m[13];
        const rz = x * m[2] + y * m[6] + z * m[10] + m[14];
        const rw = x * m[3] + y * m[7] + z * m[11] + m[15];
        result.x = rx;
        result.y = ry;
        result.z = rz;
        result.w = rw;
        return result;
    }
    /**
     * Returns a new Vector4 set with the result of the normal transformation by the given matrix of the given vector.
     * This methods computes transformed normalized direction vectors only.
     * @param vector the vector to transform
     * @param transformation the transformation matrix to apply
     * @returns the new vector
     */ static TransformNormal(vector, transformation) {
        const result = new vector.constructor();
        $c7e4de670ed74d35$export$fa7daccca11cdbe3.TransformNormalToRef(vector, transformation, result);
        return result;
    }
    /**
     * Sets the given vector "result" with the result of the normal transformation by the given matrix of the given vector.
     * This methods computes transformed normalized direction vectors only.
     * @param vector the vector to transform
     * @param transformation the transformation matrix to apply
     * @param result the vector to store the result in
     * @returns result input
     */ static TransformNormalToRef(vector, transformation, result) {
        const m = transformation.m;
        const x = vector.x * m[0] + vector.y * m[4] + vector.z * m[8];
        const y = vector.x * m[1] + vector.y * m[5] + vector.z * m[9];
        const z = vector.x * m[2] + vector.y * m[6] + vector.z * m[10];
        result.x = x;
        result.y = y;
        result.z = z;
        result.w = vector.w;
        return result;
    }
    /**
     * Sets the given vector "result" with the result of the normal transformation by the given matrix of the given floats (x, y, z, w).
     * This methods computes transformed normalized direction vectors only.
     * @param x value to transform
     * @param y value to transform
     * @param z value to transform
     * @param w value to transform
     * @param transformation the transformation matrix to apply
     * @param result the vector to store the results in
     * @returns result input
     */ static TransformNormalFromFloatsToRef(x, y, z, w, transformation, result) {
        const m = transformation.m;
        result.x = x * m[0] + y * m[4] + z * m[8];
        result.y = x * m[1] + y * m[5] + z * m[9];
        result.z = x * m[2] + y * m[6] + z * m[10];
        result.w = w;
        return result;
    }
    /**
     * Creates a new Vector4 from a Vector3
     * @param source defines the source data
     * @param w defines the 4th component (default is 0)
     * @returns a new Vector4
     */ static FromVector3(source, w = 0) {
        return new $c7e4de670ed74d35$export$fa7daccca11cdbe3(source._x, source._y, source._z, w);
    }
    /**
     * Returns the dot product (float) between the vectors "left" and "right"
     * @param left defines the left operand
     * @param right defines the right operand
     * @returns the dot product
     */ static Dot(left, right) {
        return left.dot(right);
    }
}
$c7e4de670ed74d35$export$fa7daccca11cdbe3._ZeroReadOnly = $c7e4de670ed74d35$export$fa7daccca11cdbe3.Zero();
$c7e4de670ed74d35$export$fa7daccca11cdbe3;
Object.defineProperties($c7e4de670ed74d35$export$fa7daccca11cdbe3.prototype, {
    dimension: {
        value: [
            4
        ]
    },
    rank: {
        value: 1
    }
});
class $c7e4de670ed74d35$export$23d6a54f0bbc85a3 {
    /** Gets or sets the x coordinate */ get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._isDirty = true;
    }
    /** Gets or sets the y coordinate */ get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._isDirty = true;
    }
    /** Gets or sets the z coordinate */ get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._isDirty = true;
    }
    /** Gets or sets the w coordinate */ get w() {
        return this._w;
    }
    set w(value) {
        this._w = value;
        this._isDirty = true;
    }
    /**
     * Creates a new Quaternion from the given floats
     * @param x defines the first component (0 by default)
     * @param y defines the second component (0 by default)
     * @param z defines the third component (0 by default)
     * @param w defines the fourth component (1.0 by default)
     */ constructor(x = 0.0, y = 0.0, z = 0.0, w = 1.0){
        /** @internal */ this._isDirty = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
    /**
     * Gets a string representation for the current quaternion
     * @returns a string with the Quaternion coordinates
     */ toString() {
        return `{X: ${this._x} Y: ${this._y} Z: ${this._z} W: ${this._w}}`;
    }
    /**
     * Gets the class name of the quaternion
     * @returns the string "Quaternion"
     */ getClassName() {
        return "Quaternion";
    }
    /**
     * Gets a hash code for this quaternion
     * @returns the quaternion hash code
     */ getHashCode() {
        const x = $c7e4de670ed74d35$var$_ExtractAsInt(this._x);
        const y = $c7e4de670ed74d35$var$_ExtractAsInt(this._y);
        const z = $c7e4de670ed74d35$var$_ExtractAsInt(this._z);
        const w = $c7e4de670ed74d35$var$_ExtractAsInt(this._w);
        let hash = x;
        hash = hash * 397 ^ y;
        hash = hash * 397 ^ z;
        hash = hash * 397 ^ w;
        return hash;
    }
    /**
     * Copy the quaternion to an array
     * Example Playground https://playground.babylonjs.com/#L49EJ7#13
     * @returns a new array populated with 4 elements from the quaternion coordinates
     */ asArray() {
        return [
            this._x,
            this._y,
            this._z,
            this._w
        ];
    }
    /**
     * Stores from the starting index in the given array the Quaternion successive values
     * Example Playground https://playground.babylonjs.com/#L49EJ7#59
     * @param array defines the array where to store the x,y,z,w components
     * @param index defines an optional index in the target array to define where to start storing values
     * @returns the current Quaternion object
     */ toArray(array, index = 0) {
        array[index] = this._x;
        array[index + 1] = this._y;
        array[index + 2] = this._z;
        array[index + 3] = this._w;
        return this;
    }
    fromArray(array, index = 0) {
        return $c7e4de670ed74d35$export$23d6a54f0bbc85a3.FromArrayToRef(array, index, this);
    }
    /**
     * Check if two quaternions are equals
     * Example Playground https://playground.babylonjs.com/#L49EJ7#38
     * @param otherQuaternion defines the second operand
     * @returns true if the current quaternion and the given one coordinates are strictly equals
     */ equals(otherQuaternion) {
        return otherQuaternion && this._x === otherQuaternion._x && this._y === otherQuaternion._y && this._z === otherQuaternion._z && this._w === otherQuaternion._w;
    }
    /**
     * Gets a boolean if two quaternions are equals (using an epsilon value)
     * Example Playground https://playground.babylonjs.com/#L49EJ7#37
     * @param otherQuaternion defines the other quaternion
     * @param epsilon defines the minimal distance to consider equality
     * @returns true if the given quaternion coordinates are close to the current ones by a distance of epsilon.
     */ equalsWithEpsilon(otherQuaternion, epsilon = (0, $53VPf.Epsilon)) {
        return otherQuaternion && (0, $iosaP.WithinEpsilon)(this._x, otherQuaternion._x, epsilon) && (0, $iosaP.WithinEpsilon)(this._y, otherQuaternion._y, epsilon) && (0, $iosaP.WithinEpsilon)(this._z, otherQuaternion._z, epsilon) && (0, $iosaP.WithinEpsilon)(this._w, otherQuaternion._w, epsilon);
    }
    /**
     * Clone the current quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#12
     * @returns a new quaternion copied from the current one
     */ clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    /**
     * Copy a quaternion to the current one
     * Example Playground https://playground.babylonjs.com/#L49EJ7#86
     * @param other defines the other quaternion
     * @returns the updated current quaternion
     */ copyFrom(other) {
        this._x = other._x;
        this._y = other._y;
        this._z = other._z;
        this._w = other._w;
        this._isDirty = true;
        return this;
    }
    /**
     * Updates the current quaternion with the given float coordinates
     * Example Playground https://playground.babylonjs.com/#L49EJ7#87
     * @param x defines the x coordinate
     * @param y defines the y coordinate
     * @param z defines the z coordinate
     * @param w defines the w coordinate
     * @returns the updated current quaternion
     */ copyFromFloats(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._isDirty = true;
        return this;
    }
    /**
     * Updates the current quaternion from the given float coordinates
     * Example Playground https://playground.babylonjs.com/#L49EJ7#56
     * @param x defines the x coordinate
     * @param y defines the y coordinate
     * @param z defines the z coordinate
     * @param w defines the w coordinate
     * @returns the updated current quaternion
     */ set(x, y, z, w) {
        return this.copyFromFloats(x, y, z, w);
    }
    setAll(value) {
        return this.copyFromFloats(value, value, value, value);
    }
    /**
     * Adds two quaternions
     * Example Playground https://playground.babylonjs.com/#L49EJ7#10
     * @param other defines the second operand
     * @returns a new quaternion as the addition result of the given one and the current quaternion
     */ add(other) {
        return new this.constructor(this._x + other._x, this._y + other._y, this._z + other._z, this._w + other._w);
    }
    /**
     * Add a quaternion to the current one
     * Example Playground https://playground.babylonjs.com/#L49EJ7#11
     * @param other defines the quaternion to add
     * @returns the current quaternion
     */ addInPlace(other) {
        this._x += other._x;
        this._y += other._y;
        this._z += other._z;
        this._w += other._w;
        this._isDirty = true;
        return this;
    }
    addToRef(other, result) {
        result._x = this._x + other._x;
        result._y = this._y + other._y;
        result._z = this._z + other._z;
        result._w = this._w + other._w;
        result._isDirty = true;
        return result;
    }
    addInPlaceFromFloats(x, y, z, w) {
        this._x += x;
        this._y += y;
        this._z += z;
        this._w += w;
        this._isDirty = true;
        return this;
    }
    subtractToRef(other, result) {
        result._x = this._x - other._x;
        result._y = this._y - other._y;
        result._z = this._z - other._z;
        result._w = this._w - other._w;
        result._isDirty = true;
        return result;
    }
    subtractFromFloats(x, y, z, w) {
        return this.subtractFromFloatsToRef(x, y, z, w, new this.constructor());
    }
    subtractFromFloatsToRef(x, y, z, w, result) {
        result._x = this._x - x;
        result._y = this._y - y;
        result._z = this._z - z;
        result._w = this._w - w;
        result._isDirty = true;
        return result;
    }
    /**
     * Subtract two quaternions
     * Example Playground https://playground.babylonjs.com/#L49EJ7#57
     * @param other defines the second operand
     * @returns a new quaternion as the subtraction result of the given one from the current one
     */ subtract(other) {
        return new this.constructor(this._x - other._x, this._y - other._y, this._z - other._z, this._w - other._w);
    }
    /**
     * Subtract a quaternion to the current one
     * Example Playground https://playground.babylonjs.com/#L49EJ7#58
     * @param other defines the quaternion to subtract
     * @returns the current quaternion
     */ subtractInPlace(other) {
        this._x -= other._x;
        this._y -= other._y;
        this._z -= other._z;
        this._w -= other._w;
        this._isDirty = true;
        return this;
    }
    /**
     * Multiplies the current quaternion by a scale factor
     * Example Playground https://playground.babylonjs.com/#L49EJ7#88
     * @param value defines the scale factor
     * @returns a new quaternion set by multiplying the current quaternion coordinates by the float "scale"
     */ scale(value) {
        return new this.constructor(this._x * value, this._y * value, this._z * value, this._w * value);
    }
    /**
     * Scale the current quaternion values by a factor and stores the result to a given quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#89
     * @param scale defines the scale factor
     * @param result defines the Quaternion object where to store the result
     * @returns result input
     */ scaleToRef(scale, result) {
        result._x = this._x * scale;
        result._y = this._y * scale;
        result._z = this._z * scale;
        result._w = this._w * scale;
        result._isDirty = true;
        return result;
    }
    /**
     * Multiplies in place the current quaternion by a scale factor
     * Example Playground https://playground.babylonjs.com/#L49EJ7#90
     * @param value defines the scale factor
     * @returns the current modified quaternion
     */ scaleInPlace(value) {
        this._x *= value;
        this._y *= value;
        this._z *= value;
        this._w *= value;
        this._isDirty = true;
        return this;
    }
    /**
     * Scale the current quaternion values by a factor and add the result to a given quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#91
     * @param scale defines the scale factor
     * @param result defines the Quaternion object where to store the result
     * @returns result input
     */ scaleAndAddToRef(scale, result) {
        result._x += this._x * scale;
        result._y += this._y * scale;
        result._z += this._z * scale;
        result._w += this._w * scale;
        result._isDirty = true;
        return result;
    }
    /**
     * Multiplies two quaternions
     * Example Playground https://playground.babylonjs.com/#L49EJ7#43
     * @param q1 defines the second operand
     * @returns a new quaternion set as the multiplication result of the current one with the given one "q1"
     */ multiply(q1) {
        const result = new this.constructor(0, 0, 0, 1.0);
        this.multiplyToRef(q1, result);
        return result;
    }
    /**
     * Sets the given "result" as the multiplication result of the current one with the given one "q1"
     * Example Playground https://playground.babylonjs.com/#L49EJ7#45
     * @param q1 defines the second operand
     * @param result defines the target quaternion
     * @returns the current quaternion
     */ multiplyToRef(q1, result) {
        const x = this._x * q1._w + this._y * q1._z - this._z * q1._y + this._w * q1._x;
        const y = -this._x * q1._z + this._y * q1._w + this._z * q1._x + this._w * q1._y;
        const z = this._x * q1._y - this._y * q1._x + this._z * q1._w + this._w * q1._z;
        const w = -this._x * q1._x - this._y * q1._y - this._z * q1._z + this._w * q1._w;
        result.copyFromFloats(x, y, z, w);
        return result;
    }
    /**
     * Updates the current quaternion with the multiplication of itself with the given one "q1"
     * Example Playground https://playground.babylonjs.com/#L49EJ7#46
     * @param other defines the second operand
     * @returns the currentupdated quaternion
     */ multiplyInPlace(other) {
        return this.multiplyToRef(other, this);
    }
    multiplyByFloats(x, y, z, w) {
        this._x *= x;
        this._y *= y;
        this._z *= z;
        this._w *= w;
        this._isDirty = true;
        return this;
    }
    /**
     * @internal
     * Do not use
     */ divide(_other) {
        throw new ReferenceError("Can not divide a quaternion");
    }
    /**
     * @internal
     * Do not use
     */ divideToRef(_other, _result) {
        throw new ReferenceError("Can not divide a quaternion");
    }
    /**
     * @internal
     * Do not use
     */ divideInPlace(_other) {
        throw new ReferenceError("Can not divide a quaternion");
    }
    /**
     * @internal
     * Do not use
     */ minimizeInPlace() {
        throw new ReferenceError("Can not minimize a quaternion");
    }
    /**
     * @internal
     * Do not use
     */ minimizeInPlaceFromFloats() {
        throw new ReferenceError("Can not minimize a quaternion");
    }
    /**
     * @internal
     * Do not use
     */ maximizeInPlace() {
        throw new ReferenceError("Can not maximize a quaternion");
    }
    /**
     * @internal
     * Do not use
     */ maximizeInPlaceFromFloats() {
        throw new ReferenceError("Can not maximize a quaternion");
    }
    negate() {
        return this.negateToRef(new this.constructor());
    }
    negateInPlace() {
        this._x = -this._x;
        this._y = -this._y;
        this._z = -this._z;
        this._w = -this._w;
        this._isDirty = true;
        return this;
    }
    negateToRef(result) {
        result._x = -this._x;
        result._y = -this._y;
        result._z = -this._z;
        result._w = -this._w;
        result._isDirty = true;
        return result;
    }
    equalsToFloats(x, y, z, w) {
        return this._x === x && this._y === y && this._z === z && this._w === w;
    }
    /**
     * @internal
     * Do not use
     */ floorToRef(_result) {
        throw new ReferenceError("Can not floor a quaternion");
    }
    /**
     * @internal
     * Do not use
     */ floor() {
        throw new ReferenceError("Can not floor a quaternion");
    }
    /**
     * @internal
     * Do not use
     */ fractToRef(_result) {
        throw new ReferenceError("Can not fract a quaternion");
    }
    /**
     * @internal
     * Do not use
     */ fract() {
        throw new ReferenceError("Can not fract a quaternion");
    }
    /**
     * Conjugates the current quaternion and stores the result in the given quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#81
     * @param ref defines the target quaternion
     * @returns result input
     */ conjugateToRef(ref) {
        ref.copyFromFloats(-this._x, -this._y, -this._z, this._w);
        return ref;
    }
    /**
     * Conjugates in place the current quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#82
     * @returns the current updated quaternion
     */ conjugateInPlace() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._isDirty = true;
        return this;
    }
    /**
     * Conjugates (1-q) the current quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#83
     * @returns a new quaternion
     */ conjugate() {
        return new this.constructor(-this._x, -this._y, -this._z, this._w);
    }
    /**
     * Returns the inverse of the current quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#84
     * @returns a new quaternion
     */ invert() {
        const conjugate = this.conjugate();
        const lengthSquared = this.lengthSquared();
        if (lengthSquared == 0 || lengthSquared == 1) return conjugate;
        conjugate.scaleInPlace(1 / lengthSquared);
        return conjugate;
    }
    /**
     * Invert in place the current quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#85
     * @returns this quaternion
     */ invertInPlace() {
        this.conjugateInPlace();
        const lengthSquared = this.lengthSquared();
        if (lengthSquared == 0 || lengthSquared == 1) return this;
        this.scaleInPlace(1 / lengthSquared);
        return this;
    }
    /**
     * Gets squared length of current quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#29
     * @returns the quaternion length (float)
     */ lengthSquared() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    /**
     * Gets length of current quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#28
     * @returns the quaternion length (float)
     */ length() {
        return Math.sqrt(this.lengthSquared());
    }
    /**
     * Normalize in place the current quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#54
     * @returns the current updated quaternion
     */ normalize() {
        return this.normalizeFromLength(this.length());
    }
    /**
     * Normalize the current quaternion with the given input length.
     * Please note that this is an in place operation.
     * @param len the length of the quaternion
     * @returns the current updated Quaternion
     */ normalizeFromLength(len) {
        if (len === 0 || len === 1.0) return this;
        return this.scaleInPlace(1.0 / len);
    }
    /**
     * Normalize a copy of the current quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#55
     * @returns the normalized quaternion
     */ normalizeToNew() {
        const normalized = new this.constructor(0, 0, 0, 1);
        this.normalizeToRef(normalized);
        return normalized;
    }
    /**
     * Normalize the current Quaternion to the reference
     * @param reference define the Quaternion to update
     * @returns the updated Quaternion
     */ normalizeToRef(reference) {
        const len = this.length();
        if (len === 0 || len === 1.0) return reference.copyFromFloats(this._x, this._y, this._z, this._w);
        return this.scaleToRef(1.0 / len, reference);
    }
    /**
     * Returns a new Vector3 set with the Euler angles translated from the current quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#32
     * @returns a new Vector3 containing the Euler angles
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/transforms/center_origin/rotation_conventions
     */ toEulerAngles() {
        const result = $c7e4de670ed74d35$export$64b5c384219d3699.Zero();
        this.toEulerAnglesToRef(result);
        return result;
    }
    /**
     * Sets the given vector3 "result" with the Euler angles translated from the current quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#31
     * @param result defines the vector which will be filled with the Euler angles
     * @returns result input
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/transforms/center_origin/rotation_conventions
     */ toEulerAnglesToRef(result) {
        const qz = this._z;
        const qx = this._x;
        const qy = this._y;
        const qw = this._w;
        const zAxisY = qy * qz - qx * qw;
        const limit = 0.4999999;
        if (zAxisY < -limit) {
            result._y = 2 * Math.atan2(qy, qw);
            result._x = Math.PI / 2;
            result._z = 0;
            result._isDirty = true;
        } else if (zAxisY > limit) {
            result._y = 2 * Math.atan2(qy, qw);
            result._x = -Math.PI / 2;
            result._z = 0;
            result._isDirty = true;
        } else {
            const sqw = qw * qw;
            const sqz = qz * qz;
            const sqx = qx * qx;
            const sqy = qy * qy;
            result._z = Math.atan2(2.0 * (qx * qy + qz * qw), -sqz - sqx + sqy + sqw);
            result._x = Math.asin(-2 * zAxisY);
            result._y = Math.atan2(2.0 * (qz * qx + qy * qw), sqz - sqx - sqy + sqw);
            result._isDirty = true;
        }
        return result;
    }
    /**
     * Updates the given rotation matrix with the current quaternion values
     * Example Playground https://playground.babylonjs.com/#L49EJ7#67
     * @param result defines the target matrix
     * @returns the updated matrix with the rotation
     */ toRotationMatrix(result) {
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromQuaternionToRef(this, result);
        return result;
    }
    /**
     * Updates the current quaternion from the given rotation matrix values
     * Example Playground https://playground.babylonjs.com/#L49EJ7#41
     * @param matrix defines the source matrix
     * @returns the current updated quaternion
     */ fromRotationMatrix(matrix) {
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.FromRotationMatrixToRef(matrix, this);
        return this;
    }
    /**
     * Returns the dot product (float) between the current quaternions and "other"
     * @param other defines the right operand
     * @returns the dot product
     */ dot(other) {
        return this._x * other._x + this._y * other._y + this._z * other._z + this._w * other._w;
    }
    // Statics
    /**
     * Creates a new quaternion from a rotation matrix
     * Example Playground https://playground.babylonjs.com/#L49EJ7#101
     * @param matrix defines the source matrix
     * @returns a new quaternion created from the given rotation matrix values
     */ static FromRotationMatrix(matrix) {
        const result = new $c7e4de670ed74d35$export$23d6a54f0bbc85a3();
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.FromRotationMatrixToRef(matrix, result);
        return result;
    }
    /**
     * Updates the given quaternion with the given rotation matrix values
     * Example Playground https://playground.babylonjs.com/#L49EJ7#102
     * @param matrix defines the source matrix
     * @param result defines the target quaternion
     * @returns result input
     */ static FromRotationMatrixToRef(matrix, result) {
        const data = matrix.m;
        const m11 = data[0], m12 = data[4], m13 = data[8];
        const m21 = data[1], m22 = data[5], m23 = data[9];
        const m31 = data[2], m32 = data[6], m33 = data[10];
        const trace = m11 + m22 + m33;
        let s;
        if (trace > 0) {
            s = 0.5 / Math.sqrt(trace + 1.0);
            result._w = 0.25 / s;
            result._x = (m32 - m23) * s;
            result._y = (m13 - m31) * s;
            result._z = (m21 - m12) * s;
            result._isDirty = true;
        } else if (m11 > m22 && m11 > m33) {
            s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
            result._w = (m32 - m23) / s;
            result._x = 0.25 * s;
            result._y = (m12 + m21) / s;
            result._z = (m13 + m31) / s;
            result._isDirty = true;
        } else if (m22 > m33) {
            s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
            result._w = (m13 - m31) / s;
            result._x = (m12 + m21) / s;
            result._y = 0.25 * s;
            result._z = (m23 + m32) / s;
            result._isDirty = true;
        } else {
            s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
            result._w = (m21 - m12) / s;
            result._x = (m13 + m31) / s;
            result._y = (m23 + m32) / s;
            result._z = 0.25 * s;
            result._isDirty = true;
        }
        return result;
    }
    /**
     * Returns the dot product (float) between the quaternions "left" and "right"
     * Example Playground https://playground.babylonjs.com/#L49EJ7#61
     * @param left defines the left operand
     * @param right defines the right operand
     * @returns the dot product
     */ static Dot(left, right) {
        return left._x * right._x + left._y * right._y + left._z * right._z + left._w * right._w;
    }
    /**
     * Checks if the orientations of two rotation quaternions are close to each other
     * Example Playground https://playground.babylonjs.com/#L49EJ7#60
     * @param quat0 defines the first quaternion to check
     * @param quat1 defines the second quaternion to check
     * @param epsilon defines closeness, 0 same orientation, 1 PI apart, default 0.1
     * @returns true if the two quaternions are close to each other within epsilon
     */ static AreClose(quat0, quat1, epsilon = 0.1) {
        const dot = $c7e4de670ed74d35$export$23d6a54f0bbc85a3.Dot(quat0, quat1);
        return 1 - dot * dot <= epsilon;
    }
    /**
     * Smooth interpolation between two quaternions using Slerp
     * Example Playground https://playground.babylonjs.com/#L49EJ7#93
     * @param source source quaternion
     * @param goal goal quaternion
     * @param deltaTime current interpolation frame
     * @param lerpTime total interpolation time
     * @param result the smoothed quaternion
     * @returns the smoothed quaternion
     */ static SmoothToRef(source, goal, deltaTime, lerpTime, result) {
        let slerp = lerpTime === 0 ? 1 : deltaTime / lerpTime;
        slerp = (0, $iosaP.Clamp)(slerp, 0, 1);
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.SlerpToRef(source, goal, slerp, result);
        return result;
    }
    /**
     * Creates an empty quaternion
     * @returns a new quaternion set to (0.0, 0.0, 0.0)
     */ static Zero() {
        return new $c7e4de670ed74d35$export$23d6a54f0bbc85a3(0.0, 0.0, 0.0, 0.0);
    }
    /**
     * Inverse a given quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#103
     * @param q defines the source quaternion
     * @returns a new quaternion as the inverted current quaternion
     */ static Inverse(q) {
        return new q.constructor(-q._x, -q._y, -q._z, q._w);
    }
    /**
     * Inverse a given quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#104
     * @param q defines the source quaternion
     * @param result the quaternion the result will be stored in
     * @returns the result quaternion
     */ static InverseToRef(q, result) {
        result.set(-q._x, -q._y, -q._z, q._w);
        return result;
    }
    /**
     * Creates an identity quaternion
     * @returns the identity quaternion
     */ static Identity() {
        return new $c7e4de670ed74d35$export$23d6a54f0bbc85a3(0.0, 0.0, 0.0, 1.0);
    }
    /**
     * Gets a boolean indicating if the given quaternion is identity
     * @param quaternion defines the quaternion to check
     * @returns true if the quaternion is identity
     */ static IsIdentity(quaternion) {
        return quaternion && quaternion._x === 0 && quaternion._y === 0 && quaternion._z === 0 && quaternion._w === 1;
    }
    /**
     * Creates a quaternion from a rotation around an axis
     * Example Playground https://playground.babylonjs.com/#L49EJ7#72
     * @param axis defines the axis to use
     * @param angle defines the angle to use
     * @returns a new quaternion created from the given axis (Vector3) and angle in radians (float)
     */ static RotationAxis(axis, angle) {
        return $c7e4de670ed74d35$export$23d6a54f0bbc85a3.RotationAxisToRef(axis, angle, new $c7e4de670ed74d35$export$23d6a54f0bbc85a3());
    }
    /**
     * Creates a rotation around an axis and stores it into the given quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#73
     * @param axis defines the axis to use
     * @param angle defines the angle to use
     * @param result defines the target quaternion
     * @returns the target quaternion
     */ static RotationAxisToRef(axis, angle, result) {
        const sin = Math.sin(angle / 2);
        axis.normalize();
        result._w = Math.cos(angle / 2);
        result._x = axis._x * sin;
        result._y = axis._y * sin;
        result._z = axis._z * sin;
        result._isDirty = true;
        return result;
    }
    /**
     * Creates a new quaternion from data stored into an array
     * Example Playground https://playground.babylonjs.com/#L49EJ7#63
     * @param array defines the data source
     * @param offset defines the offset in the source array where the data starts
     * @returns a new quaternion
     */ static FromArray(array, offset) {
        if (!offset) offset = 0;
        return new $c7e4de670ed74d35$export$23d6a54f0bbc85a3(array[offset], array[offset + 1], array[offset + 2], array[offset + 3]);
    }
    /**
     * Updates the given quaternion "result" from the starting index of the given array.
     * Example Playground https://playground.babylonjs.com/#L49EJ7#64
     * @param array the array to pull values from
     * @param offset the offset into the array to start at
     * @param result the quaternion to store the result in
     * @returns result input
     */ static FromArrayToRef(array, offset, result) {
        result._x = array[offset];
        result._y = array[offset + 1];
        result._z = array[offset + 2];
        result._w = array[offset + 3];
        result._isDirty = true;
        return result;
    }
    /**
     * Sets the given quaternion "result" with the given floats.
     * @param x defines the x coordinate of the source
     * @param y defines the y coordinate of the source
     * @param z defines the z coordinate of the source
     * @param w defines the w coordinate of the source
     * @param result defines the quaternion where to store the result
     * @returns the result quaternion
     */ static FromFloatsToRef(x, y, z, w, result) {
        result.copyFromFloats(x, y, z, w);
        return result;
    }
    /**
     * Create a quaternion from Euler rotation angles
     * Example Playground https://playground.babylonjs.com/#L49EJ7#33
     * @param x Pitch
     * @param y Yaw
     * @param z Roll
     * @returns the new Quaternion
     */ static FromEulerAngles(x, y, z) {
        const q = new $c7e4de670ed74d35$export$23d6a54f0bbc85a3();
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.RotationYawPitchRollToRef(y, x, z, q);
        return q;
    }
    /**
     * Updates a quaternion from Euler rotation angles
     * Example Playground https://playground.babylonjs.com/#L49EJ7#34
     * @param x Pitch
     * @param y Yaw
     * @param z Roll
     * @param result the quaternion to store the result
     * @returns the updated quaternion
     */ static FromEulerAnglesToRef(x, y, z, result) {
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.RotationYawPitchRollToRef(y, x, z, result);
        return result;
    }
    /**
     * Create a quaternion from Euler rotation vector
     * Example Playground https://playground.babylonjs.com/#L49EJ7#35
     * @param vec the Euler vector (x Pitch, y Yaw, z Roll)
     * @returns the new Quaternion
     */ static FromEulerVector(vec) {
        const q = new $c7e4de670ed74d35$export$23d6a54f0bbc85a3();
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.RotationYawPitchRollToRef(vec._y, vec._x, vec._z, q);
        return q;
    }
    /**
     * Updates a quaternion from Euler rotation vector
     * Example Playground https://playground.babylonjs.com/#L49EJ7#36
     * @param vec the Euler vector (x Pitch, y Yaw, z Roll)
     * @param result the quaternion to store the result
     * @returns the updated quaternion
     */ static FromEulerVectorToRef(vec, result) {
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.RotationYawPitchRollToRef(vec._y, vec._x, vec._z, result);
        return result;
    }
    /**
     * Updates a quaternion so that it rotates vector vecFrom to vector vecTo
     * Example Playground - https://playground.babylonjs.com/#L49EJ7#70
     * @param vecFrom defines the direction vector from which to rotate
     * @param vecTo defines the direction vector to which to rotate
     * @param result the quaternion to store the result
     * @param epsilon defines the minimal dot value to define vecs as opposite. Default: `BABYLON.Epsilon`
     * @returns the updated quaternion
     */ static FromUnitVectorsToRef(vecFrom, vecTo, result, epsilon = (0, $53VPf.Epsilon)) {
        const r = $c7e4de670ed74d35$export$64b5c384219d3699.Dot(vecFrom, vecTo) + 1;
        if (r < epsilon) {
            if (Math.abs(vecFrom.x) > Math.abs(vecFrom.z)) result.set(-vecFrom.y, vecFrom.x, 0, 0);
            else result.set(0, -vecFrom.z, vecFrom.y, 0);
        } else {
            $c7e4de670ed74d35$export$64b5c384219d3699.CrossToRef(vecFrom, vecTo, $c7e4de670ed74d35$export$269f00bf0c0718d1.Vector3[0]);
            result.set($c7e4de670ed74d35$export$269f00bf0c0718d1.Vector3[0].x, $c7e4de670ed74d35$export$269f00bf0c0718d1.Vector3[0].y, $c7e4de670ed74d35$export$269f00bf0c0718d1.Vector3[0].z, r);
        }
        return result.normalize();
    }
    /**
     * Creates a new quaternion from the given Euler float angles (y, x, z)
     * Example Playground https://playground.babylonjs.com/#L49EJ7#77
     * @param yaw defines the rotation around Y axis
     * @param pitch defines the rotation around X axis
     * @param roll defines the rotation around Z axis
     * @returns the new quaternion
     */ static RotationYawPitchRoll(yaw, pitch, roll) {
        const q = new $c7e4de670ed74d35$export$23d6a54f0bbc85a3();
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.RotationYawPitchRollToRef(yaw, pitch, roll, q);
        return q;
    }
    /**
     * Creates a new rotation from the given Euler float angles (y, x, z) and stores it in the target quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#78
     * @param yaw defines the rotation around Y axis
     * @param pitch defines the rotation around X axis
     * @param roll defines the rotation around Z axis
     * @param result defines the target quaternion
     * @returns result input
     */ static RotationYawPitchRollToRef(yaw, pitch, roll, result) {
        // Produces a quaternion from Euler angles in the z-y-x orientation (Tait-Bryan angles)
        const halfRoll = roll * 0.5;
        const halfPitch = pitch * 0.5;
        const halfYaw = yaw * 0.5;
        const sinRoll = Math.sin(halfRoll);
        const cosRoll = Math.cos(halfRoll);
        const sinPitch = Math.sin(halfPitch);
        const cosPitch = Math.cos(halfPitch);
        const sinYaw = Math.sin(halfYaw);
        const cosYaw = Math.cos(halfYaw);
        result._x = cosYaw * sinPitch * cosRoll + sinYaw * cosPitch * sinRoll;
        result._y = sinYaw * cosPitch * cosRoll - cosYaw * sinPitch * sinRoll;
        result._z = cosYaw * cosPitch * sinRoll - sinYaw * sinPitch * cosRoll;
        result._w = cosYaw * cosPitch * cosRoll + sinYaw * sinPitch * sinRoll;
        result._isDirty = true;
        return result;
    }
    /**
     * Creates a new quaternion from the given Euler float angles expressed in z-x-z orientation
     * Example Playground https://playground.babylonjs.com/#L49EJ7#68
     * @param alpha defines the rotation around first axis
     * @param beta defines the rotation around second axis
     * @param gamma defines the rotation around third axis
     * @returns the new quaternion
     */ static RotationAlphaBetaGamma(alpha, beta, gamma) {
        const result = new $c7e4de670ed74d35$export$23d6a54f0bbc85a3();
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.RotationAlphaBetaGammaToRef(alpha, beta, gamma, result);
        return result;
    }
    /**
     * Creates a new quaternion from the given Euler float angles expressed in z-x-z orientation and stores it in the target quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#69
     * @param alpha defines the rotation around first axis
     * @param beta defines the rotation around second axis
     * @param gamma defines the rotation around third axis
     * @param result defines the target quaternion
     * @returns result input
     */ static RotationAlphaBetaGammaToRef(alpha, beta, gamma, result) {
        // Produces a quaternion from Euler angles in the z-x-z orientation
        const halfGammaPlusAlpha = (gamma + alpha) * 0.5;
        const halfGammaMinusAlpha = (gamma - alpha) * 0.5;
        const halfBeta = beta * 0.5;
        result._x = Math.cos(halfGammaMinusAlpha) * Math.sin(halfBeta);
        result._y = Math.sin(halfGammaMinusAlpha) * Math.sin(halfBeta);
        result._z = Math.sin(halfGammaPlusAlpha) * Math.cos(halfBeta);
        result._w = Math.cos(halfGammaPlusAlpha) * Math.cos(halfBeta);
        result._isDirty = true;
        return result;
    }
    /**
     * Creates a new quaternion containing the rotation value to reach the target (axis1, axis2, axis3) orientation as a rotated XYZ system (axis1, axis2 and axis3 are normalized during this operation)
     * Example Playground https://playground.babylonjs.com/#L49EJ7#75
     * @param axis1 defines the first axis
     * @param axis2 defines the second axis
     * @param axis3 defines the third axis
     * @returns the new quaternion
     */ static RotationQuaternionFromAxis(axis1, axis2, axis3) {
        const quat = new $c7e4de670ed74d35$export$23d6a54f0bbc85a3(0.0, 0.0, 0.0, 0.0);
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.RotationQuaternionFromAxisToRef(axis1, axis2, axis3, quat);
        return quat;
    }
    /**
     * Creates a rotation value to reach the target (axis1, axis2, axis3) orientation as a rotated XYZ system (axis1, axis2 and axis3 are normalized during this operation) and stores it in the target quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#76
     * @param axis1 defines the first axis
     * @param axis2 defines the second axis
     * @param axis3 defines the third axis
     * @param ref defines the target quaternion
     * @returns result input
     */ static RotationQuaternionFromAxisToRef(axis1, axis2, axis3, ref) {
        const rotMat = $c7e4de670ed74d35$var$MathTmp.Matrix[0];
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromXYZAxesToRef(axis1.normalize(), axis2.normalize(), axis3.normalize(), rotMat);
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.FromRotationMatrixToRef(rotMat, ref);
        return ref;
    }
    /**
     * Creates a new rotation value to orient an object to look towards the given forward direction, the up direction being oriented like "up".
     * This function works in left handed mode
     * Example Playground https://playground.babylonjs.com/#L49EJ7#96
     * @param forward defines the forward direction - Must be normalized and orthogonal to up.
     * @param up defines the up vector for the entity - Must be normalized and orthogonal to forward.
     * @returns A new quaternion oriented toward the specified forward and up.
     */ static FromLookDirectionLH(forward, up) {
        const quat = new $c7e4de670ed74d35$export$23d6a54f0bbc85a3();
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.FromLookDirectionLHToRef(forward, up, quat);
        return quat;
    }
    /**
     * Creates a new rotation value to orient an object to look towards the given forward direction with the up direction being oriented like "up", and stores it in the target quaternion.
     * This function works in left handed mode
     * Example Playground https://playground.babylonjs.com/#L49EJ7#97
     * @param forward defines the forward direction - Must be normalized and orthogonal to up.
     * @param up defines the up vector for the entity - Must be normalized and orthogonal to forward.
     * @param ref defines the target quaternion.
     * @returns result input
     */ static FromLookDirectionLHToRef(forward, up, ref) {
        const rotMat = $c7e4de670ed74d35$var$MathTmp.Matrix[0];
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.LookDirectionLHToRef(forward, up, rotMat);
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.FromRotationMatrixToRef(rotMat, ref);
        return ref;
    }
    /**
     * Creates a new rotation value to orient an object to look towards the given forward direction, the up direction being oriented like "up".
     * This function works in right handed mode
     * Example Playground https://playground.babylonjs.com/#L49EJ7#98
     * @param forward defines the forward direction - Must be normalized and orthogonal to up.
     * @param up defines the up vector for the entity - Must be normalized and orthogonal to forward.
     * @returns A new quaternion oriented toward the specified forward and up.
     */ static FromLookDirectionRH(forward, up) {
        const quat = new $c7e4de670ed74d35$export$23d6a54f0bbc85a3();
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.FromLookDirectionRHToRef(forward, up, quat);
        return quat;
    }
    /**
     * Creates a new rotation value to orient an object to look towards the given forward direction with the up direction being oriented like "up", and stores it in the target quaternion.
     * This function works in right handed mode
     * Example Playground https://playground.babylonjs.com/#L49EJ7#105
     * @param forward defines the forward direction - Must be normalized and orthogonal to up.
     * @param up defines the up vector for the entity - Must be normalized and orthogonal to forward.
     * @param ref defines the target quaternion.
     * @returns result input
     */ static FromLookDirectionRHToRef(forward, up, ref) {
        const rotMat = $c7e4de670ed74d35$var$MathTmp.Matrix[0];
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.LookDirectionRHToRef(forward, up, rotMat);
        return $c7e4de670ed74d35$export$23d6a54f0bbc85a3.FromRotationMatrixToRef(rotMat, ref);
    }
    /**
     * Interpolates between two quaternions
     * Example Playground https://playground.babylonjs.com/#L49EJ7#79
     * @param left defines first quaternion
     * @param right defines second quaternion
     * @param amount defines the gradient to use
     * @returns the new interpolated quaternion
     */ static Slerp(left, right, amount) {
        const result = $c7e4de670ed74d35$export$23d6a54f0bbc85a3.Identity();
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.SlerpToRef(left, right, amount, result);
        return result;
    }
    /**
     * Interpolates between two quaternions and stores it into a target quaternion
     * Example Playground https://playground.babylonjs.com/#L49EJ7#92
     * @param left defines first quaternion
     * @param right defines second quaternion
     * @param amount defines the gradient to use
     * @param result defines the target quaternion
     * @returns result input
     */ static SlerpToRef(left, right, amount, result) {
        let num2;
        let num3;
        let num4 = left._x * right._x + left._y * right._y + left._z * right._z + left._w * right._w;
        let flag = false;
        if (num4 < 0) {
            flag = true;
            num4 = -num4;
        }
        if (num4 > 0.999999) {
            num3 = 1 - amount;
            num2 = flag ? -amount : amount;
        } else {
            const num5 = Math.acos(num4);
            const num6 = 1.0 / Math.sin(num5);
            num3 = Math.sin((1.0 - amount) * num5) * num6;
            num2 = flag ? -Math.sin(amount * num5) * num6 : Math.sin(amount * num5) * num6;
        }
        result._x = num3 * left._x + num2 * right._x;
        result._y = num3 * left._y + num2 * right._y;
        result._z = num3 * left._z + num2 * right._z;
        result._w = num3 * left._w + num2 * right._w;
        result._isDirty = true;
        return result;
    }
    /**
     * Interpolate between two quaternions using Hermite interpolation
     * Example Playground https://playground.babylonjs.com/#L49EJ7#47
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/drawCurves#hermite-quaternion-spline
     * @param value1 defines first quaternion
     * @param tangent1 defines the incoming tangent
     * @param value2 defines second quaternion
     * @param tangent2 defines the outgoing tangent
     * @param amount defines the target quaternion
     * @returns the new interpolated quaternion
     */ static Hermite(value1, tangent1, value2, tangent2, amount) {
        const squared = amount * amount;
        const cubed = amount * squared;
        const part1 = 2.0 * cubed - 3.0 * squared + 1.0;
        const part2 = -2 * cubed + 3.0 * squared;
        const part3 = cubed - 2.0 * squared + amount;
        const part4 = cubed - squared;
        const x = value1._x * part1 + value2._x * part2 + tangent1._x * part3 + tangent2._x * part4;
        const y = value1._y * part1 + value2._y * part2 + tangent1._y * part3 + tangent2._y * part4;
        const z = value1._z * part1 + value2._z * part2 + tangent1._z * part3 + tangent2._z * part4;
        const w = value1._w * part1 + value2._w * part2 + tangent1._w * part3 + tangent2._w * part4;
        return new value1.constructor(x, y, z, w);
    }
    /**
     * Returns a new Quaternion which is the 1st derivative of the Hermite spline defined by the quaternions "value1", "value2", "tangent1", "tangent2".
     * Example Playground https://playground.babylonjs.com/#L49EJ7#48
     * @param value1 defines the first control point
     * @param tangent1 defines the first tangent
     * @param value2 defines the second control point
     * @param tangent2 defines the second tangent
     * @param time define where the derivative must be done
     * @returns 1st derivative
     */ static Hermite1stDerivative(value1, tangent1, value2, tangent2, time) {
        const result = new value1.constructor();
        this.Hermite1stDerivativeToRef(value1, tangent1, value2, tangent2, time, result);
        return result;
    }
    /**
     * Update a Quaternion with the 1st derivative of the Hermite spline defined by the quaternions "value1", "value2", "tangent1", "tangent2".
     * Example Playground https://playground.babylonjs.com/#L49EJ7#49
     * @param value1 defines the first control point
     * @param tangent1 defines the first tangent
     * @param value2 defines the second control point
     * @param tangent2 defines the second tangent
     * @param time define where the derivative must be done
     * @param result define where to store the derivative
     * @returns result input
     */ static Hermite1stDerivativeToRef(value1, tangent1, value2, tangent2, time, result) {
        const t2 = time * time;
        result._x = (t2 - time) * 6 * value1._x + (3 * t2 - 4 * time + 1) * tangent1._x + (-t2 + time) * 6 * value2._x + (3 * t2 - 2 * time) * tangent2._x;
        result._y = (t2 - time) * 6 * value1._y + (3 * t2 - 4 * time + 1) * tangent1._y + (-t2 + time) * 6 * value2._y + (3 * t2 - 2 * time) * tangent2._y;
        result._z = (t2 - time) * 6 * value1._z + (3 * t2 - 4 * time + 1) * tangent1._z + (-t2 + time) * 6 * value2._z + (3 * t2 - 2 * time) * tangent2._z;
        result._w = (t2 - time) * 6 * value1._w + (3 * t2 - 4 * time + 1) * tangent1._w + (-t2 + time) * 6 * value2._w + (3 * t2 - 2 * time) * tangent2._w;
        result._isDirty = true;
        return result;
    }
    /**
     * Returns a new Quaternion as the normalization of the given Quaternion
     * @param quat defines the Quaternion to normalize
     * @returns the new Quaternion
     */ static Normalize(quat) {
        const result = $c7e4de670ed74d35$export$23d6a54f0bbc85a3.Zero();
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.NormalizeToRef(quat, result);
        return result;
    }
    /**
     * Sets the given Quaternion "result" with the normalization of the given first Quaternion
     * @param quat defines the Quaternion to normalize
     * @param result defines the Quaternion where to store the result
     * @returns result input
     */ static NormalizeToRef(quat, result) {
        quat.normalizeToRef(result);
        return result;
    }
    /**
     * Returns a new Quaternion set with the coordinates of "value", if the quaternion "value" is in the cube defined by the quaternions "min" and "max"
     * If a coordinate value of "value" is lower than one of the "min" coordinate, then this "value" coordinate is set with the "min" one
     * If a coordinate value of "value" is greater than one of the "max" coordinate, then this "value" coordinate is set with the "max" one
     * @param value defines the current value
     * @param min defines the lower range value
     * @param max defines the upper range value
     * @returns the new Quaternion
     */ static Clamp(value, min, max) {
        const result = new value.constructor();
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.ClampToRef(value, min, max, result);
        return result;
    }
    /**
     * Sets the given quaternion "result" with the coordinates of "value", if the quaternion "value" is in the cube defined by the quaternions "min" and "max"
     * If a coordinate value of "value" is lower than one of the "min" coordinate, then this "value" coordinate is set with the "min" one
     * If a coordinate value of "value" is greater than one of the "max" coordinate, then this "value" coordinate is set with the "max" one
     * @param value defines the current value
     * @param min defines the lower range value
     * @param max defines the upper range value
     * @param result defines the Quaternion where to store the result
     * @returns result input
     */ static ClampToRef(value, min, max, result) {
        return result.copyFromFloats((0, $iosaP.Clamp)(value.x, min.x, max.x), (0, $iosaP.Clamp)(value.y, min.y, max.y), (0, $iosaP.Clamp)(value.z, min.z, max.z), (0, $iosaP.Clamp)(value.w, min.w, max.w));
    }
    /**
     * Returns a new Quaternion with random values between min and max
     * @param min the minimum random value
     * @param max the maximum random value
     * @returns a Quaternion with random values between min and max
     */ static Random(min = 0, max = 1) {
        return new $c7e4de670ed74d35$export$23d6a54f0bbc85a3((0, $iosaP.RandomRange)(min, max), (0, $iosaP.RandomRange)(min, max), (0, $iosaP.RandomRange)(min, max), (0, $iosaP.RandomRange)(min, max));
    }
    /**
     * Sets a Quaternion with random values between min and max
     * @param min the minimum random value
     * @param max the maximum random value
     * @param ref the ref to store the values in
     * @returns the ref with random values between min and max
     */ static RandomToRef(min = 0, max = 1, ref) {
        return ref.copyFromFloats((0, $iosaP.RandomRange)(min, max), (0, $iosaP.RandomRange)(min, max), (0, $iosaP.RandomRange)(min, max), (0, $iosaP.RandomRange)(min, max));
    }
    /**
     * Do not use
     * @internal
     */ static Minimize() {
        throw new ReferenceError("Quaternion.Minimize does not make sense");
    }
    /**
     * Do not use
     * @internal
     */ static Maximize() {
        throw new ReferenceError("Quaternion.Maximize does not make sense");
    }
    /**
     * Returns the distance (float) between the quaternions "value1" and "value2".
     * @param value1 value to calulate the distance between
     * @param value2 value to calulate the distance between
     * @returns the distance between the two quaternions
     */ static Distance(value1, value2) {
        return Math.sqrt($c7e4de670ed74d35$export$23d6a54f0bbc85a3.DistanceSquared(value1, value2));
    }
    /**
     * Returns the squared distance (float) between the quaternions "value1" and "value2".
     * @param value1 value to calulate the distance between
     * @param value2 value to calulate the distance between
     * @returns the distance between the two quaternions squared
     */ static DistanceSquared(value1, value2) {
        const x = value1.x - value2.x;
        const y = value1.y - value2.y;
        const z = value1.z - value2.z;
        const w = value1.w - value2.w;
        return x * x + y * y + z * z + w * w;
    }
    /**
     * Returns a new Quaternion located at the center between the quaternions "value1" and "value2".
     * @param value1 value to calulate the center between
     * @param value2 value to calulate the center between
     * @returns the center between the two quaternions
     */ static Center(value1, value2) {
        return $c7e4de670ed74d35$export$23d6a54f0bbc85a3.CenterToRef(value1, value2, $c7e4de670ed74d35$export$23d6a54f0bbc85a3.Zero());
    }
    /**
     * Gets the center of the quaternions "value1" and "value2" and stores the result in the quaternion "ref"
     * @param value1 defines first quaternion
     * @param value2 defines second quaternion
     * @param ref defines third quaternion
     * @returns ref
     */ static CenterToRef(value1, value2, ref) {
        return ref.copyFromFloats((value1.x + value2.x) / 2, (value1.y + value2.y) / 2, (value1.z + value2.z) / 2, (value1.w + value2.w) / 2);
    }
}
$c7e4de670ed74d35$export$23d6a54f0bbc85a3;
Object.defineProperties($c7e4de670ed74d35$export$23d6a54f0bbc85a3.prototype, {
    dimension: {
        value: [
            4
        ]
    },
    rank: {
        value: 1
    }
});
class $c7e4de670ed74d35$export$5b12bf1653c0dd85 {
    /**
     * Gets the precision of matrix computations
     */ static get Use64Bits() {
        return (0, $3agwF.PerformanceConfigurator).MatrixUse64Bits;
    }
    /**
     * Gets the internal data of the matrix
     */ get m() {
        return this._m;
    }
    /**
     * Update the updateFlag to indicate that the matrix has been updated
     */ markAsUpdated() {
        this.updateFlag = $c7e4de670ed74d35$export$5b12bf1653c0dd85._UpdateFlagSeed++;
        this._isIdentity = false;
        this._isIdentity3x2 = false;
        this._isIdentityDirty = true;
        this._isIdentity3x2Dirty = true;
    }
    _updateIdentityStatus(isIdentity, isIdentityDirty = false, isIdentity3x2 = false, isIdentity3x2Dirty = true) {
        this._isIdentity = isIdentity;
        this._isIdentity3x2 = isIdentity || isIdentity3x2;
        this._isIdentityDirty = this._isIdentity ? false : isIdentityDirty;
        this._isIdentity3x2Dirty = this._isIdentity3x2 ? false : isIdentity3x2Dirty;
    }
    /**
     * Creates an empty matrix (filled with zeros)
     */ constructor(){
        this._isIdentity = false;
        this._isIdentityDirty = true;
        this._isIdentity3x2 = true;
        this._isIdentity3x2Dirty = true;
        /**
         * Gets the update flag of the matrix which is an unique number for the matrix.
         * It will be incremented every time the matrix data change.
         * You can use it to speed the comparison between two versions of the same matrix.
         */ this.updateFlag = -1;
        if ((0, $3agwF.PerformanceConfigurator).MatrixTrackPrecisionChange) (0, $3agwF.PerformanceConfigurator).MatrixTrackedMatrices.push(this);
        this._m = new (0, $3agwF.PerformanceConfigurator).MatrixCurrentType(16);
        this.markAsUpdated();
    }
    // Properties
    /**
     * Check if the current matrix is identity
     * @returns true is the matrix is the identity matrix
     */ isIdentity() {
        if (this._isIdentityDirty) {
            this._isIdentityDirty = false;
            const m = this._m;
            this._isIdentity = m[0] === 1.0 && m[1] === 0.0 && m[2] === 0.0 && m[3] === 0.0 && m[4] === 0.0 && m[5] === 1.0 && m[6] === 0.0 && m[7] === 0.0 && m[8] === 0.0 && m[9] === 0.0 && m[10] === 1.0 && m[11] === 0.0 && m[12] === 0.0 && m[13] === 0.0 && m[14] === 0.0 && m[15] === 1.0;
        }
        return this._isIdentity;
    }
    /**
     * Check if the current matrix is identity as a texture matrix (3x2 store in 4x4)
     * @returns true is the matrix is the identity matrix
     */ isIdentityAs3x2() {
        if (this._isIdentity3x2Dirty) {
            this._isIdentity3x2Dirty = false;
            if (this._m[0] !== 1.0 || this._m[5] !== 1.0 || this._m[15] !== 1.0) this._isIdentity3x2 = false;
            else if (this._m[1] !== 0.0 || this._m[2] !== 0.0 || this._m[3] !== 0.0 || this._m[4] !== 0.0 || this._m[6] !== 0.0 || this._m[7] !== 0.0 || this._m[8] !== 0.0 || this._m[9] !== 0.0 || this._m[10] !== 0.0 || this._m[11] !== 0.0 || this._m[12] !== 0.0 || this._m[13] !== 0.0 || this._m[14] !== 0.0) this._isIdentity3x2 = false;
            else this._isIdentity3x2 = true;
        }
        return this._isIdentity3x2;
    }
    /**
     * Gets the determinant of the matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#34
     * @returns the matrix determinant
     */ determinant() {
        if (this._isIdentity === true) return 1;
        const m = this._m;
        const m00 = m[0], m01 = m[1], m02 = m[2], m03 = m[3];
        const m10 = m[4], m11 = m[5], m12 = m[6], m13 = m[7];
        const m20 = m[8], m21 = m[9], m22 = m[10], m23 = m[11];
        const m30 = m[12], m31 = m[13], m32 = m[14], m33 = m[15];
        // https://en.wikipedia.org/wiki/Laplace_expansion
        // to compute the deterrminant of a 4x4 Matrix we compute the cofactors of any row or column,
        // then we multiply each Cofactor by its corresponding matrix value and sum them all to get the determinant
        // Cofactor(i, j) = sign(i,j) * det(Minor(i, j))
        // where
        //  - sign(i,j) = (i+j) % 2 === 0 ? 1 : -1
        //  - Minor(i, j) is the 3x3 matrix we get by removing row i and column j from current Matrix
        //
        // Here we do that for the 1st row.
        const det_22_33 = m22 * m33 - m32 * m23;
        const det_21_33 = m21 * m33 - m31 * m23;
        const det_21_32 = m21 * m32 - m31 * m22;
        const det_20_33 = m20 * m33 - m30 * m23;
        const det_20_32 = m20 * m32 - m22 * m30;
        const det_20_31 = m20 * m31 - m30 * m21;
        const cofact_00 = +(m11 * det_22_33 - m12 * det_21_33 + m13 * det_21_32);
        const cofact_01 = -(m10 * det_22_33 - m12 * det_20_33 + m13 * det_20_32);
        const cofact_02 = +(m10 * det_21_33 - m11 * det_20_33 + m13 * det_20_31);
        const cofact_03 = -(m10 * det_21_32 - m11 * det_20_32 + m12 * det_20_31);
        return m00 * cofact_00 + m01 * cofact_01 + m02 * cofact_02 + m03 * cofact_03;
    }
    // Methods
    /**
     * Gets a string with the Matrix values
     * @returns a string with the Matrix values
     */ toString() {
        return `{${this.m[0]}, ${this.m[1]}, ${this.m[2]}, ${this.m[3]}\n${this.m[4]}, ${this.m[5]}, ${this.m[6]}, ${this.m[7]}\n${this.m[8]}, ${this.m[9]}, ${this.m[10]}, ${this.m[11]}\n${this.m[12]}, ${this.m[13]}, ${this.m[14]}, ${this.m[15]}}`;
    }
    toArray(array = null, index = 0) {
        if (!array) return this._m;
        const m = this._m;
        for(let i = 0; i < 16; i++)array[index + i] = m[i];
        return this;
    }
    /**
     * Returns the matrix as a Float32Array or Array<number>
     * Example Playground - https://playground.babylonjs.com/#AV9X17#114
     * @returns the matrix underlying array.
     */ asArray() {
        return this._m;
    }
    fromArray(array, index = 0) {
        return $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromArrayToRef(array, index, this);
    }
    copyFromFloats(...floats) {
        return $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromArrayToRef(floats, 0, this);
    }
    set(...values) {
        const m = this._m;
        for(let i = 0; i < 16; i++)m[i] = values[i];
        this.markAsUpdated();
        return this;
    }
    setAll(value) {
        const m = this._m;
        for(let i = 0; i < 16; i++)m[i] = value;
        this.markAsUpdated();
        return this;
    }
    /**
     * Inverts the current matrix in place
     * Example Playground - https://playground.babylonjs.com/#AV9X17#118
     * @returns the current inverted matrix
     */ invert() {
        this.invertToRef(this);
        return this;
    }
    /**
     * Sets all the matrix elements to zero
     * @returns the current matrix
     */ reset() {
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, this);
        this._updateIdentityStatus(false);
        return this;
    }
    /**
     * Adds the current matrix with a second one
     * Example Playground - https://playground.babylonjs.com/#AV9X17#44
     * @param other defines the matrix to add
     * @returns a new matrix as the addition of the current matrix and the given one
     */ add(other) {
        const result = new this.constructor();
        this.addToRef(other, result);
        return result;
    }
    /**
     * Sets the given matrix "result" to the addition of the current matrix and the given one
     * Example Playground - https://playground.babylonjs.com/#AV9X17#45
     * @param other defines the matrix to add
     * @param result defines the target matrix
     * @returns result input
     */ addToRef(other, result) {
        const m = this._m;
        const resultM = result._m;
        const otherM = other.m;
        for(let index = 0; index < 16; index++)resultM[index] = m[index] + otherM[index];
        result.markAsUpdated();
        return result;
    }
    /**
     * Adds in place the given matrix to the current matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#46
     * @param other defines the second operand
     * @returns the current updated matrix
     */ addToSelf(other) {
        const m = this._m;
        const otherM = other.m;
        for(let index = 0; index < 16; index++)m[index] += otherM[index];
        this.markAsUpdated();
        return this;
    }
    addInPlace(other) {
        const m = this._m, otherM = other.m;
        for(let i = 0; i < 16; i++)m[i] += otherM[i];
        this.markAsUpdated();
        return this;
    }
    addInPlaceFromFloats(...floats) {
        const m = this._m;
        for(let i = 0; i < 16; i++)m[i] += floats[i];
        this.markAsUpdated();
        return this;
    }
    subtract(other) {
        const m = this._m, otherM = other.m;
        for(let i = 0; i < 16; i++)m[i] -= otherM[i];
        this.markAsUpdated();
        return this;
    }
    subtractToRef(other, result) {
        const m = this._m, otherM = other.m, resultM = result._m;
        for(let i = 0; i < 16; i++)resultM[i] = m[i] - otherM[i];
        result.markAsUpdated();
        return result;
    }
    subtractInPlace(other) {
        const m = this._m, otherM = other.m;
        for(let i = 0; i < 16; i++)m[i] -= otherM[i];
        this.markAsUpdated();
        return this;
    }
    subtractFromFloats(...floats) {
        return this.subtractFromFloatsToRef(...floats, new this.constructor());
    }
    subtractFromFloatsToRef(...args) {
        const result = args.pop(), m = this._m, resultM = result._m, values = args;
        for(let i = 0; i < 16; i++)resultM[i] = m[i] - values[i];
        result.markAsUpdated();
        return result;
    }
    /**
     * Sets the given matrix to the current inverted Matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#119
     * @param other defines the target matrix
     * @returns result input
     */ invertToRef(other) {
        if (this._isIdentity === true) {
            $c7e4de670ed74d35$export$5b12bf1653c0dd85.IdentityToRef(other);
            return other;
        }
        // the inverse of a Matrix is the transpose of cofactor matrix divided by the determinant
        const m = this._m;
        const m00 = m[0], m01 = m[1], m02 = m[2], m03 = m[3];
        const m10 = m[4], m11 = m[5], m12 = m[6], m13 = m[7];
        const m20 = m[8], m21 = m[9], m22 = m[10], m23 = m[11];
        const m30 = m[12], m31 = m[13], m32 = m[14], m33 = m[15];
        const det_22_33 = m22 * m33 - m32 * m23;
        const det_21_33 = m21 * m33 - m31 * m23;
        const det_21_32 = m21 * m32 - m31 * m22;
        const det_20_33 = m20 * m33 - m30 * m23;
        const det_20_32 = m20 * m32 - m22 * m30;
        const det_20_31 = m20 * m31 - m30 * m21;
        const cofact_00 = +(m11 * det_22_33 - m12 * det_21_33 + m13 * det_21_32);
        const cofact_01 = -(m10 * det_22_33 - m12 * det_20_33 + m13 * det_20_32);
        const cofact_02 = +(m10 * det_21_33 - m11 * det_20_33 + m13 * det_20_31);
        const cofact_03 = -(m10 * det_21_32 - m11 * det_20_32 + m12 * det_20_31);
        const det = m00 * cofact_00 + m01 * cofact_01 + m02 * cofact_02 + m03 * cofact_03;
        if (det === 0) {
            // not invertible
            other.copyFrom(this);
            return other;
        }
        const detInv = 1 / det;
        const det_12_33 = m12 * m33 - m32 * m13;
        const det_11_33 = m11 * m33 - m31 * m13;
        const det_11_32 = m11 * m32 - m31 * m12;
        const det_10_33 = m10 * m33 - m30 * m13;
        const det_10_32 = m10 * m32 - m30 * m12;
        const det_10_31 = m10 * m31 - m30 * m11;
        const det_12_23 = m12 * m23 - m22 * m13;
        const det_11_23 = m11 * m23 - m21 * m13;
        const det_11_22 = m11 * m22 - m21 * m12;
        const det_10_23 = m10 * m23 - m20 * m13;
        const det_10_22 = m10 * m22 - m20 * m12;
        const det_10_21 = m10 * m21 - m20 * m11;
        const cofact_10 = -(m01 * det_22_33 - m02 * det_21_33 + m03 * det_21_32);
        const cofact_11 = +(m00 * det_22_33 - m02 * det_20_33 + m03 * det_20_32);
        const cofact_12 = -(m00 * det_21_33 - m01 * det_20_33 + m03 * det_20_31);
        const cofact_13 = +(m00 * det_21_32 - m01 * det_20_32 + m02 * det_20_31);
        const cofact_20 = +(m01 * det_12_33 - m02 * det_11_33 + m03 * det_11_32);
        const cofact_21 = -(m00 * det_12_33 - m02 * det_10_33 + m03 * det_10_32);
        const cofact_22 = +(m00 * det_11_33 - m01 * det_10_33 + m03 * det_10_31);
        const cofact_23 = -(m00 * det_11_32 - m01 * det_10_32 + m02 * det_10_31);
        const cofact_30 = -(m01 * det_12_23 - m02 * det_11_23 + m03 * det_11_22);
        const cofact_31 = +(m00 * det_12_23 - m02 * det_10_23 + m03 * det_10_22);
        const cofact_32 = -(m00 * det_11_23 - m01 * det_10_23 + m03 * det_10_21);
        const cofact_33 = +(m00 * det_11_22 - m01 * det_10_22 + m02 * det_10_21);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(cofact_00 * detInv, cofact_10 * detInv, cofact_20 * detInv, cofact_30 * detInv, cofact_01 * detInv, cofact_11 * detInv, cofact_21 * detInv, cofact_31 * detInv, cofact_02 * detInv, cofact_12 * detInv, cofact_22 * detInv, cofact_32 * detInv, cofact_03 * detInv, cofact_13 * detInv, cofact_23 * detInv, cofact_33 * detInv, other);
        return other;
    }
    /**
     * add a value at the specified position in the current Matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#47
     * @param index the index of the value within the matrix. between 0 and 15.
     * @param value the value to be added
     * @returns the current updated matrix
     */ addAtIndex(index, value) {
        this._m[index] += value;
        this.markAsUpdated();
        return this;
    }
    /**
     * mutiply the specified position in the current Matrix by a value
     * @param index the index of the value within the matrix. between 0 and 15.
     * @param value the value to be added
     * @returns the current updated matrix
     */ multiplyAtIndex(index, value) {
        this._m[index] *= value;
        this.markAsUpdated();
        return this;
    }
    /**
     * Inserts the translation vector (using 3 floats) in the current matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#120
     * @param x defines the 1st component of the translation
     * @param y defines the 2nd component of the translation
     * @param z defines the 3rd component of the translation
     * @returns the current updated matrix
     */ setTranslationFromFloats(x, y, z) {
        this._m[12] = x;
        this._m[13] = y;
        this._m[14] = z;
        this.markAsUpdated();
        return this;
    }
    /**
     * Adds the translation vector (using 3 floats) in the current matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#20
     * Example Playground - https://playground.babylonjs.com/#AV9X17#48
     * @param x defines the 1st component of the translation
     * @param y defines the 2nd component of the translation
     * @param z defines the 3rd component of the translation
     * @returns the current updated matrix
     */ addTranslationFromFloats(x, y, z) {
        this._m[12] += x;
        this._m[13] += y;
        this._m[14] += z;
        this.markAsUpdated();
        return this;
    }
    /**
     * Inserts the translation vector in the current matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#121
     * @param vector3 defines the translation to insert
     * @returns the current updated matrix
     */ setTranslation(vector3) {
        return this.setTranslationFromFloats(vector3._x, vector3._y, vector3._z);
    }
    /**
     * Gets the translation value of the current matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#122
     * @returns a new Vector3 as the extracted translation from the matrix
     */ getTranslation() {
        return new $c7e4de670ed74d35$export$64b5c384219d3699(this._m[12], this._m[13], this._m[14]);
    }
    /**
     * Fill a Vector3 with the extracted translation from the matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#123
     * @param result defines the Vector3 where to store the translation
     * @returns the current matrix
     */ getTranslationToRef(result) {
        result.x = this._m[12];
        result.y = this._m[13];
        result.z = this._m[14];
        return result;
    }
    /**
     * Remove rotation and scaling part from the matrix
     * @returns the updated matrix
     */ removeRotationAndScaling() {
        const m = this.m;
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, m[12], m[13], m[14], m[15], this);
        this._updateIdentityStatus(m[12] === 0 && m[13] === 0 && m[14] === 0 && m[15] === 1);
        return this;
    }
    /**
     * Copy the current matrix from the given one
     * Example Playground - https://playground.babylonjs.com/#AV9X17#21
     * @param other defines the source matrix
     * @returns the current updated matrix
     */ copyFrom(other) {
        other.copyToArray(this._m);
        const o = other;
        this.updateFlag = o.updateFlag;
        this._updateIdentityStatus(o._isIdentity, o._isIdentityDirty, o._isIdentity3x2, o._isIdentity3x2Dirty);
        return this;
    }
    /**
     * Populates the given array from the starting index with the current matrix values
     * @param array defines the target array
     * @param offset defines the offset in the target array where to start storing values
     * @returns the current matrix
     */ copyToArray(array, offset = 0) {
        const source = this._m;
        array[offset] = source[0];
        array[offset + 1] = source[1];
        array[offset + 2] = source[2];
        array[offset + 3] = source[3];
        array[offset + 4] = source[4];
        array[offset + 5] = source[5];
        array[offset + 6] = source[6];
        array[offset + 7] = source[7];
        array[offset + 8] = source[8];
        array[offset + 9] = source[9];
        array[offset + 10] = source[10];
        array[offset + 11] = source[11];
        array[offset + 12] = source[12];
        array[offset + 13] = source[13];
        array[offset + 14] = source[14];
        array[offset + 15] = source[15];
        return this;
    }
    /**
     * Multiply two matrices
     * Example Playground - https://playground.babylonjs.com/#AV9X17#15
     * A.multiply(B) means apply B to A so result is B x A
     * @param other defines the second operand
     * @returns a new matrix set with the multiplication result of the current Matrix and the given one
     */ multiply(other) {
        const result = new this.constructor();
        this.multiplyToRef(other, result);
        return result;
    }
    multiplyInPlace(other) {
        const m = this._m, otherM = other.m;
        for(let i = 0; i < 16; i++)m[i] *= otherM[i];
        this.markAsUpdated();
        return this;
    }
    multiplyByFloats(...floats) {
        const m = this._m;
        for(let i = 0; i < 16; i++)m[i] = floats[i];
        this.markAsUpdated();
        return this;
    }
    /**
     * Multiples the current matrix by the given floats and stores them in the given ref
     * @param args The floats and ref
     * @returns The updated ref
     */ multiplyByFloatsToRef(...args) {
        const result = args.pop(), m = this._m, resultM = result._m, values = args;
        for(let i = 0; i < 16; i++)resultM[i] = m[i] * values[i];
        result.markAsUpdated();
        return result;
    }
    /**
     * Sets the given matrix "result" with the multiplication result of the current Matrix and the given one
     * A.multiplyToRef(B, R) means apply B to A and store in R and R = B x A
     * Example Playground - https://playground.babylonjs.com/#AV9X17#16
     * @param other defines the second operand
     * @param result defines the matrix where to store the multiplication
     * @returns result input
     */ multiplyToRef(other, result) {
        if (this._isIdentity) {
            result.copyFrom(other);
            return result;
        }
        if (other._isIdentity) {
            result.copyFrom(this);
            return result;
        }
        this.multiplyToArray(other, result._m, 0);
        result.markAsUpdated();
        return result;
    }
    /**
     * Sets the Float32Array "result" from the given index "offset" with the multiplication of the current matrix and the given one
     * @param other defines the second operand
     * @param result defines the array where to store the multiplication
     * @param offset defines the offset in the target array where to start storing values
     * @returns the current matrix
     */ multiplyToArray(other, result, offset) {
        const m = this._m;
        const otherM = other.m;
        const tm0 = m[0], tm1 = m[1], tm2 = m[2], tm3 = m[3];
        const tm4 = m[4], tm5 = m[5], tm6 = m[6], tm7 = m[7];
        const tm8 = m[8], tm9 = m[9], tm10 = m[10], tm11 = m[11];
        const tm12 = m[12], tm13 = m[13], tm14 = m[14], tm15 = m[15];
        const om0 = otherM[0], om1 = otherM[1], om2 = otherM[2], om3 = otherM[3];
        const om4 = otherM[4], om5 = otherM[5], om6 = otherM[6], om7 = otherM[7];
        const om8 = otherM[8], om9 = otherM[9], om10 = otherM[10], om11 = otherM[11];
        const om12 = otherM[12], om13 = otherM[13], om14 = otherM[14], om15 = otherM[15];
        result[offset] = tm0 * om0 + tm1 * om4 + tm2 * om8 + tm3 * om12;
        result[offset + 1] = tm0 * om1 + tm1 * om5 + tm2 * om9 + tm3 * om13;
        result[offset + 2] = tm0 * om2 + tm1 * om6 + tm2 * om10 + tm3 * om14;
        result[offset + 3] = tm0 * om3 + tm1 * om7 + tm2 * om11 + tm3 * om15;
        result[offset + 4] = tm4 * om0 + tm5 * om4 + tm6 * om8 + tm7 * om12;
        result[offset + 5] = tm4 * om1 + tm5 * om5 + tm6 * om9 + tm7 * om13;
        result[offset + 6] = tm4 * om2 + tm5 * om6 + tm6 * om10 + tm7 * om14;
        result[offset + 7] = tm4 * om3 + tm5 * om7 + tm6 * om11 + tm7 * om15;
        result[offset + 8] = tm8 * om0 + tm9 * om4 + tm10 * om8 + tm11 * om12;
        result[offset + 9] = tm8 * om1 + tm9 * om5 + tm10 * om9 + tm11 * om13;
        result[offset + 10] = tm8 * om2 + tm9 * om6 + tm10 * om10 + tm11 * om14;
        result[offset + 11] = tm8 * om3 + tm9 * om7 + tm10 * om11 + tm11 * om15;
        result[offset + 12] = tm12 * om0 + tm13 * om4 + tm14 * om8 + tm15 * om12;
        result[offset + 13] = tm12 * om1 + tm13 * om5 + tm14 * om9 + tm15 * om13;
        result[offset + 14] = tm12 * om2 + tm13 * om6 + tm14 * om10 + tm15 * om14;
        result[offset + 15] = tm12 * om3 + tm13 * om7 + tm14 * om11 + tm15 * om15;
        return this;
    }
    divide(other) {
        return this.divideToRef(other, new this.constructor());
    }
    divideToRef(other, result) {
        const m = this._m, otherM = other.m, resultM = result._m;
        for(let i = 0; i < 16; i++)resultM[i] = m[i] / otherM[i];
        result.markAsUpdated();
        return result;
    }
    divideInPlace(other) {
        const m = this._m, otherM = other.m;
        for(let i = 0; i < 16; i++)m[i] /= otherM[i];
        this.markAsUpdated();
        return this;
    }
    minimizeInPlace(other) {
        const m = this._m, otherM = other.m;
        for(let i = 0; i < 16; i++)m[i] = Math.min(m[i], otherM[i]);
        this.markAsUpdated();
        return this;
    }
    minimizeInPlaceFromFloats(...floats) {
        const m = this._m;
        for(let i = 0; i < 16; i++)m[i] = Math.min(m[i], floats[i]);
        this.markAsUpdated();
        return this;
    }
    maximizeInPlace(other) {
        const m = this._m, otherM = other.m;
        for(let i = 0; i < 16; i++)m[i] = Math.min(m[i], otherM[i]);
        this.markAsUpdated();
        return this;
    }
    maximizeInPlaceFromFloats(...floats) {
        const m = this._m;
        for(let i = 0; i < 16; i++)m[i] = Math.min(m[i], floats[i]);
        this.markAsUpdated();
        return this;
    }
    negate() {
        return this.negateToRef(new this.constructor());
    }
    negateInPlace() {
        const m = this._m;
        for(let i = 0; i < 16; i++)m[i] = -m[i];
        this.markAsUpdated();
        return this;
    }
    negateToRef(result) {
        const m = this._m, resultM = result._m;
        for(let i = 0; i < 16; i++)resultM[i] = -m[i];
        result.markAsUpdated();
        return result;
    }
    /**
     * Check equality between this matrix and a second one
     * @param value defines the second matrix to compare
     * @returns true is the current matrix and the given one values are strictly equal
     */ equals(value) {
        const other = value;
        if (!other) return false;
        if (this._isIdentity || other._isIdentity) {
            if (!this._isIdentityDirty && !other._isIdentityDirty) return this._isIdentity && other._isIdentity;
        }
        const m = this.m;
        const om = other.m;
        return m[0] === om[0] && m[1] === om[1] && m[2] === om[2] && m[3] === om[3] && m[4] === om[4] && m[5] === om[5] && m[6] === om[6] && m[7] === om[7] && m[8] === om[8] && m[9] === om[9] && m[10] === om[10] && m[11] === om[11] && m[12] === om[12] && m[13] === om[13] && m[14] === om[14] && m[15] === om[15];
    }
    equalsWithEpsilon(other, epsilon = 0) {
        const m = this._m, otherM = other.m;
        for(let i = 0; i < 16; i++){
            if (!(0, $iosaP.WithinEpsilon)(m[i], otherM[i], epsilon)) return false;
        }
        return true;
    }
    equalsToFloats(...floats) {
        const m = this._m;
        for(let i = 0; i < 16; i++){
            if (m[i] != floats[i]) return false;
        }
        return true;
    }
    floor() {
        return this.floorToRef(new this.constructor());
    }
    floorToRef(result) {
        const m = this._m, resultM = result._m;
        for(let i = 0; i < 16; i++)resultM[i] = Math.floor(m[i]);
        result.markAsUpdated();
        return result;
    }
    fract() {
        return this.fractToRef(new this.constructor());
    }
    fractToRef(result) {
        const m = this._m, resultM = result._m;
        for(let i = 0; i < 16; i++)resultM[i] = m[i] - Math.floor(m[i]);
        result.markAsUpdated();
        return result;
    }
    /**
     * Clone the current matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#18
     * @returns a new matrix from the current matrix
     */ clone() {
        const matrix = new this.constructor();
        matrix.copyFrom(this);
        return matrix;
    }
    /**
     * Returns the name of the current matrix class
     * @returns the string "Matrix"
     */ getClassName() {
        return "Matrix";
    }
    /**
     * Gets the hash code of the current matrix
     * @returns the hash code
     */ getHashCode() {
        let hash = $c7e4de670ed74d35$var$_ExtractAsInt(this._m[0]);
        for(let i = 1; i < 16; i++)hash = hash * 397 ^ $c7e4de670ed74d35$var$_ExtractAsInt(this._m[i]);
        return hash;
    }
    /**
     * Decomposes the current Matrix into a translation, rotation and scaling components of the provided node
     * Example Playground - https://playground.babylonjs.com/#AV9X17#13
     * @param node the node to decompose the matrix to
     * @returns true if operation was successful
     */ decomposeToTransformNode(node) {
        node.rotationQuaternion = node.rotationQuaternion || new $c7e4de670ed74d35$export$23d6a54f0bbc85a3();
        return this.decompose(node.scaling, node.rotationQuaternion, node.position);
    }
    /**
     * Decomposes the current Matrix into a translation, rotation and scaling components
     * Example Playground - https://playground.babylonjs.com/#AV9X17#12
     * @param scale defines the scale vector3 given as a reference to update
     * @param rotation defines the rotation quaternion given as a reference to update
     * @param translation defines the translation vector3 given as a reference to update
     * @param preserveScalingNode Use scaling sign coming from this node. Otherwise scaling sign might change.
     * @param useAbsoluteScaling Use scaling sign coming from this absoluteScaling when true or scaling otherwise.
     * @returns true if operation was successful
     */ decompose(scale, rotation, translation, preserveScalingNode, useAbsoluteScaling = true) {
        if (this._isIdentity) {
            if (translation) translation.setAll(0);
            if (scale) scale.setAll(1);
            if (rotation) rotation.copyFromFloats(0, 0, 0, 1);
            return true;
        }
        const m = this._m;
        if (translation) translation.copyFromFloats(m[12], m[13], m[14]);
        scale = scale || $c7e4de670ed74d35$var$MathTmp.Vector3[0];
        scale.x = Math.sqrt(m[0] * m[0] + m[1] * m[1] + m[2] * m[2]);
        scale.y = Math.sqrt(m[4] * m[4] + m[5] * m[5] + m[6] * m[6]);
        scale.z = Math.sqrt(m[8] * m[8] + m[9] * m[9] + m[10] * m[10]);
        if (preserveScalingNode) {
            const signX = (useAbsoluteScaling ? preserveScalingNode.absoluteScaling.x : preserveScalingNode.scaling.x) < 0 ? -1 : 1;
            const signY = (useAbsoluteScaling ? preserveScalingNode.absoluteScaling.y : preserveScalingNode.scaling.y) < 0 ? -1 : 1;
            const signZ = (useAbsoluteScaling ? preserveScalingNode.absoluteScaling.z : preserveScalingNode.scaling.z) < 0 ? -1 : 1;
            scale.x *= signX;
            scale.y *= signY;
            scale.z *= signZ;
        } else if (this.determinant() <= 0) scale.y *= -1;
        if (scale._x === 0 || scale._y === 0 || scale._z === 0) {
            if (rotation) rotation.copyFromFloats(0.0, 0.0, 0.0, 1.0);
            return false;
        }
        if (rotation) {
            const sx = 1 / scale._x, sy = 1 / scale._y, sz = 1 / scale._z;
            $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(m[0] * sx, m[1] * sx, m[2] * sx, 0.0, m[4] * sy, m[5] * sy, m[6] * sy, 0.0, m[8] * sz, m[9] * sz, m[10] * sz, 0.0, 0.0, 0.0, 0.0, 1.0, $c7e4de670ed74d35$var$MathTmp.Matrix[0]);
            $c7e4de670ed74d35$export$23d6a54f0bbc85a3.FromRotationMatrixToRef($c7e4de670ed74d35$var$MathTmp.Matrix[0], rotation);
        }
        return true;
    }
    /**
     * Gets specific row of the matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#36
     * @param index defines the number of the row to get
     * @returns the index-th row of the current matrix as a new Vector4
     */ getRow(index) {
        if (index < 0 || index > 3) return null;
        const i = index * 4;
        return new $c7e4de670ed74d35$export$fa7daccca11cdbe3(this._m[i + 0], this._m[i + 1], this._m[i + 2], this._m[i + 3]);
    }
    /**
     * Gets specific row of the matrix to ref
     * Example Playground - https://playground.babylonjs.com/#AV9X17#36
     * @param index defines the number of the row to get
     * @param rowVector vector to store the index-th row of the current matrix
     * @returns result input
     */ getRowToRef(index, rowVector) {
        if (index >= 0 && index <= 3) {
            const i = index * 4;
            rowVector.x = this._m[i + 0];
            rowVector.y = this._m[i + 1];
            rowVector.z = this._m[i + 2];
            rowVector.w = this._m[i + 3];
        }
        return rowVector;
    }
    /**
     * Sets the index-th row of the current matrix to the vector4 values
     * Example Playground - https://playground.babylonjs.com/#AV9X17#36
     * @param index defines the number of the row to set
     * @param row defines the target vector4
     * @returns the updated current matrix
     */ setRow(index, row) {
        return this.setRowFromFloats(index, row.x, row.y, row.z, row.w);
    }
    /**
     * Compute the transpose of the matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#40
     * @returns the new transposed matrix
     */ transpose() {
        const result = new this.constructor();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.TransposeToRef(this, result);
        return result;
    }
    /**
     * Compute the transpose of the matrix and store it in a given matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#41
     * @param result defines the target matrix
     * @returns result input
     */ transposeToRef(result) {
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.TransposeToRef(this, result);
        return result;
    }
    /**
     * Sets the index-th row of the current matrix with the given 4 x float values
     * Example Playground - https://playground.babylonjs.com/#AV9X17#36
     * @param index defines the row index
     * @param x defines the x component to set
     * @param y defines the y component to set
     * @param z defines the z component to set
     * @param w defines the w component to set
     * @returns the updated current matrix
     */ setRowFromFloats(index, x, y, z, w) {
        if (index < 0 || index > 3) return this;
        const i = index * 4;
        this._m[i + 0] = x;
        this._m[i + 1] = y;
        this._m[i + 2] = z;
        this._m[i + 3] = w;
        this.markAsUpdated();
        return this;
    }
    /**
     * Compute a new matrix set with the current matrix values multiplied by scale (float)
     * @param scale defines the scale factor
     * @returns a new matrix
     */ scale(scale) {
        const result = new this.constructor();
        this.scaleToRef(scale, result);
        return result;
    }
    /**
     * Scale the current matrix values by a factor to a given result matrix
     * @param scale defines the scale factor
     * @param result defines the matrix to store the result
     * @returns result input
     */ scaleToRef(scale, result) {
        for(let index = 0; index < 16; index++)result._m[index] = this._m[index] * scale;
        result.markAsUpdated();
        return result;
    }
    /**
     * Scale the current matrix values by a factor and add the result to a given matrix
     * @param scale defines the scale factor
     * @param result defines the Matrix to store the result
     * @returns result input
     */ scaleAndAddToRef(scale, result) {
        for(let index = 0; index < 16; index++)result._m[index] += this._m[index] * scale;
        result.markAsUpdated();
        return result;
    }
    scaleInPlace(scale) {
        const m = this._m;
        for(let i = 0; i < 16; i++)m[i] *= scale;
        this.markAsUpdated();
        return this;
    }
    /**
     * Writes to the given matrix a normal matrix, computed from this one (using values from identity matrix for fourth row and column).
     * Example Playground - https://playground.babylonjs.com/#AV9X17#17
     * @param ref matrix to store the result
     * @returns the reference matrix
     */ toNormalMatrix(ref) {
        const tmp = $c7e4de670ed74d35$var$MathTmp.Matrix[0];
        this.invertToRef(tmp);
        tmp.transposeToRef(ref);
        const m = ref._m;
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(m[0], m[1], m[2], 0.0, m[4], m[5], m[6], 0.0, m[8], m[9], m[10], 0.0, 0.0, 0.0, 0.0, 1.0, ref);
        return ref;
    }
    /**
     * Gets only rotation part of the current matrix
     * @returns a new matrix sets to the extracted rotation matrix from the current one
     */ getRotationMatrix() {
        const result = new this.constructor();
        this.getRotationMatrixToRef(result);
        return result;
    }
    /**
     * Extracts the rotation matrix from the current one and sets it as the given "result"
     * @param result defines the target matrix to store data to
     * @returns result input
     */ getRotationMatrixToRef(result) {
        const scale = $c7e4de670ed74d35$var$MathTmp.Vector3[0];
        if (!this.decompose(scale)) {
            $c7e4de670ed74d35$export$5b12bf1653c0dd85.IdentityToRef(result);
            return result;
        }
        const m = this._m;
        const sx = 1 / scale._x, sy = 1 / scale._y, sz = 1 / scale._z;
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(m[0] * sx, m[1] * sx, m[2] * sx, 0.0, m[4] * sy, m[5] * sy, m[6] * sy, 0.0, m[8] * sz, m[9] * sz, m[10] * sz, 0.0, 0.0, 0.0, 0.0, 1.0, result);
        return result;
    }
    /**
     * Toggles model matrix from being right handed to left handed in place and vice versa
     * @returns the current updated matrix
     */ toggleModelMatrixHandInPlace() {
        const m = this._m;
        m[2] *= -1;
        m[6] *= -1;
        m[8] *= -1;
        m[9] *= -1;
        m[14] *= -1;
        this.markAsUpdated();
        return this;
    }
    /**
     * Toggles projection matrix from being right handed to left handed in place and vice versa
     * @returns the current updated matrix
     */ toggleProjectionMatrixHandInPlace() {
        const m = this._m;
        m[8] *= -1;
        m[9] *= -1;
        m[10] *= -1;
        m[11] *= -1;
        this.markAsUpdated();
        return this;
    }
    // Statics
    /**
     * Creates a matrix from an array
     * Example Playground - https://playground.babylonjs.com/#AV9X17#42
     * @param array defines the source array
     * @param offset defines an offset in the source array
     * @returns a new Matrix set from the starting index of the given array
     */ static FromArray(array, offset = 0) {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromArrayToRef(array, offset, result);
        return result;
    }
    /**
     * Copy the content of an array into a given matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#43
     * @param array defines the source array
     * @param offset defines an offset in the source array
     * @param result defines the target matrix
     * @returns result input
     */ static FromArrayToRef(array, offset, result) {
        for(let index = 0; index < 16; index++)result._m[index] = array[index + offset];
        result.markAsUpdated();
        return result;
    }
    /**
     * Stores an array into a matrix after having multiplied each component by a given factor
     * Example Playground - https://playground.babylonjs.com/#AV9X17#50
     * @param array defines the source array
     * @param offset defines the offset in the source array
     * @param scale defines the scaling factor
     * @param result defines the target matrix
     * @returns result input
     */ static FromFloat32ArrayToRefScaled(array, offset, scale, result) {
        for(let index = 0; index < 16; index++)result._m[index] = array[index + offset] * scale;
        result.markAsUpdated();
        return result;
    }
    /**
     * Gets an identity matrix that must not be updated
     */ static get IdentityReadOnly() {
        return $c7e4de670ed74d35$export$5b12bf1653c0dd85._IdentityReadOnly;
    }
    /**
     * Stores a list of values (16) inside a given matrix
     * @param initialM11 defines 1st value of 1st row
     * @param initialM12 defines 2nd value of 1st row
     * @param initialM13 defines 3rd value of 1st row
     * @param initialM14 defines 4th value of 1st row
     * @param initialM21 defines 1st value of 2nd row
     * @param initialM22 defines 2nd value of 2nd row
     * @param initialM23 defines 3rd value of 2nd row
     * @param initialM24 defines 4th value of 2nd row
     * @param initialM31 defines 1st value of 3rd row
     * @param initialM32 defines 2nd value of 3rd row
     * @param initialM33 defines 3rd value of 3rd row
     * @param initialM34 defines 4th value of 3rd row
     * @param initialM41 defines 1st value of 4th row
     * @param initialM42 defines 2nd value of 4th row
     * @param initialM43 defines 3rd value of 4th row
     * @param initialM44 defines 4th value of 4th row
     * @param result defines the target matrix
     */ static FromValuesToRef(initialM11, initialM12, initialM13, initialM14, initialM21, initialM22, initialM23, initialM24, initialM31, initialM32, initialM33, initialM34, initialM41, initialM42, initialM43, initialM44, result) {
        const m = result._m;
        m[0] = initialM11;
        m[1] = initialM12;
        m[2] = initialM13;
        m[3] = initialM14;
        m[4] = initialM21;
        m[5] = initialM22;
        m[6] = initialM23;
        m[7] = initialM24;
        m[8] = initialM31;
        m[9] = initialM32;
        m[10] = initialM33;
        m[11] = initialM34;
        m[12] = initialM41;
        m[13] = initialM42;
        m[14] = initialM43;
        m[15] = initialM44;
        result.markAsUpdated();
    }
    /**
     * Creates new matrix from a list of values (16)
     * @param initialM11 defines 1st value of 1st row
     * @param initialM12 defines 2nd value of 1st row
     * @param initialM13 defines 3rd value of 1st row
     * @param initialM14 defines 4th value of 1st row
     * @param initialM21 defines 1st value of 2nd row
     * @param initialM22 defines 2nd value of 2nd row
     * @param initialM23 defines 3rd value of 2nd row
     * @param initialM24 defines 4th value of 2nd row
     * @param initialM31 defines 1st value of 3rd row
     * @param initialM32 defines 2nd value of 3rd row
     * @param initialM33 defines 3rd value of 3rd row
     * @param initialM34 defines 4th value of 3rd row
     * @param initialM41 defines 1st value of 4th row
     * @param initialM42 defines 2nd value of 4th row
     * @param initialM43 defines 3rd value of 4th row
     * @param initialM44 defines 4th value of 4th row
     * @returns the new matrix
     */ static FromValues(initialM11, initialM12, initialM13, initialM14, initialM21, initialM22, initialM23, initialM24, initialM31, initialM32, initialM33, initialM34, initialM41, initialM42, initialM43, initialM44) {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        const m = result._m;
        m[0] = initialM11;
        m[1] = initialM12;
        m[2] = initialM13;
        m[3] = initialM14;
        m[4] = initialM21;
        m[5] = initialM22;
        m[6] = initialM23;
        m[7] = initialM24;
        m[8] = initialM31;
        m[9] = initialM32;
        m[10] = initialM33;
        m[11] = initialM34;
        m[12] = initialM41;
        m[13] = initialM42;
        m[14] = initialM43;
        m[15] = initialM44;
        result.markAsUpdated();
        return result;
    }
    /**
     * Creates a new matrix composed by merging scale (vector3), rotation (quaternion) and translation (vector3)
     * Example Playground - https://playground.babylonjs.com/#AV9X17#24
     * @param scale defines the scale vector3
     * @param rotation defines the rotation quaternion
     * @param translation defines the translation vector3
     * @returns a new matrix
     */ static Compose(scale, rotation, translation) {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.ComposeToRef(scale, rotation, translation, result);
        return result;
    }
    /**
     * Sets a matrix to a value composed by merging scale (vector3), rotation (quaternion) and translation (vector3)
     * Example Playground - https://playground.babylonjs.com/#AV9X17#25
     * @param scale defines the scale vector3
     * @param rotation defines the rotation quaternion
     * @param translation defines the translation vector3
     * @param result defines the target matrix
     * @returns result input
     */ static ComposeToRef(scale, rotation, translation, result) {
        const m = result._m;
        const x = rotation._x, y = rotation._y, z = rotation._z, w = rotation._w;
        const x2 = x + x, y2 = y + y, z2 = z + z;
        const xx = x * x2, xy = x * y2, xz = x * z2;
        const yy = y * y2, yz = y * z2, zz = z * z2;
        const wx = w * x2, wy = w * y2, wz = w * z2;
        const sx = scale._x, sy = scale._y, sz = scale._z;
        m[0] = (1 - (yy + zz)) * sx;
        m[1] = (xy + wz) * sx;
        m[2] = (xz - wy) * sx;
        m[3] = 0;
        m[4] = (xy - wz) * sy;
        m[5] = (1 - (xx + zz)) * sy;
        m[6] = (yz + wx) * sy;
        m[7] = 0;
        m[8] = (xz + wy) * sz;
        m[9] = (yz - wx) * sz;
        m[10] = (1 - (xx + yy)) * sz;
        m[11] = 0;
        m[12] = translation._x;
        m[13] = translation._y;
        m[14] = translation._z;
        m[15] = 1;
        result.markAsUpdated();
        return result;
    }
    /**
     * Creates a new identity matrix
     * @returns a new identity matrix
     */ static Identity() {
        const identity = $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValues(1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0);
        identity._updateIdentityStatus(true);
        return identity;
    }
    /**
     * Creates a new identity matrix and stores the result in a given matrix
     * @param result defines the target matrix
     * @returns result input
     */ static IdentityToRef(result) {
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, result);
        result._updateIdentityStatus(true);
        return result;
    }
    /**
     * Creates a new zero matrix
     * @returns a new zero matrix
     */ static Zero() {
        const zero = $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValues(0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0);
        zero._updateIdentityStatus(false);
        return zero;
    }
    /**
     * Creates a new rotation matrix for "angle" radians around the X axis
     * Example Playground - https://playground.babylonjs.com/#AV9X17#97
     * @param angle defines the angle (in radians) to use
     * @returns the new matrix
     */ static RotationX(angle) {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.RotationXToRef(angle, result);
        return result;
    }
    /**
     * Creates a new matrix as the invert of a given matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#124
     * @param source defines the source matrix
     * @returns the new matrix
     */ static Invert(source) {
        const result = new source.constructor();
        source.invertToRef(result);
        return result;
    }
    /**
     * Creates a new rotation matrix for "angle" radians around the X axis and stores it in a given matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#98
     * @param angle defines the angle (in radians) to use
     * @param result defines the target matrix
     * @returns result input
     */ static RotationXToRef(angle, result) {
        const s = Math.sin(angle);
        const c = Math.cos(angle);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(1.0, 0.0, 0.0, 0.0, 0.0, c, s, 0.0, 0.0, -s, c, 0.0, 0.0, 0.0, 0.0, 1.0, result);
        result._updateIdentityStatus(c === 1 && s === 0);
        return result;
    }
    /**
     * Creates a new rotation matrix for "angle" radians around the Y axis
     * Example Playground - https://playground.babylonjs.com/#AV9X17#99
     * @param angle defines the angle (in radians) to use
     * @returns the new matrix
     */ static RotationY(angle) {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.RotationYToRef(angle, result);
        return result;
    }
    /**
     * Creates a new rotation matrix for "angle" radians around the Y axis and stores it in a given matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#100
     * @param angle defines the angle (in radians) to use
     * @param result defines the target matrix
     * @returns result input
     */ static RotationYToRef(angle, result) {
        const s = Math.sin(angle);
        const c = Math.cos(angle);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(c, 0.0, -s, 0.0, 0.0, 1.0, 0.0, 0.0, s, 0.0, c, 0.0, 0.0, 0.0, 0.0, 1.0, result);
        result._updateIdentityStatus(c === 1 && s === 0);
        return result;
    }
    /**
     * Creates a new rotation matrix for "angle" radians around the Z axis
     * Example Playground - https://playground.babylonjs.com/#AV9X17#101
     * @param angle defines the angle (in radians) to use
     * @returns the new matrix
     */ static RotationZ(angle) {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.RotationZToRef(angle, result);
        return result;
    }
    /**
     * Creates a new rotation matrix for "angle" radians around the Z axis and stores it in a given matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#102
     * @param angle defines the angle (in radians) to use
     * @param result defines the target matrix
     * @returns result input
     */ static RotationZToRef(angle, result) {
        const s = Math.sin(angle);
        const c = Math.cos(angle);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(c, s, 0.0, 0.0, -s, c, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, result);
        result._updateIdentityStatus(c === 1 && s === 0);
        return result;
    }
    /**
     * Creates a new rotation matrix for "angle" radians around the given axis
     * Example Playground - https://playground.babylonjs.com/#AV9X17#96
     * @param axis defines the axis to use
     * @param angle defines the angle (in radians) to use
     * @returns the new matrix
     */ static RotationAxis(axis, angle) {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.RotationAxisToRef(axis, angle, result);
        return result;
    }
    /**
     * Creates a new rotation matrix for "angle" radians around the given axis and stores it in a given matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#94
     * @param axis defines the axis to use
     * @param angle defines the angle (in radians) to use
     * @param result defines the target matrix
     * @returns result input
     */ static RotationAxisToRef(axis, angle, result) {
        const s = Math.sin(-angle);
        const c = Math.cos(-angle);
        const c1 = 1 - c;
        axis.normalize();
        const m = result._m;
        m[0] = axis._x * axis._x * c1 + c;
        m[1] = axis._x * axis._y * c1 - axis._z * s;
        m[2] = axis._x * axis._z * c1 + axis._y * s;
        m[3] = 0.0;
        m[4] = axis._y * axis._x * c1 + axis._z * s;
        m[5] = axis._y * axis._y * c1 + c;
        m[6] = axis._y * axis._z * c1 - axis._x * s;
        m[7] = 0.0;
        m[8] = axis._z * axis._x * c1 - axis._y * s;
        m[9] = axis._z * axis._y * c1 + axis._x * s;
        m[10] = axis._z * axis._z * c1 + c;
        m[11] = 0.0;
        m[12] = 0.0;
        m[13] = 0.0;
        m[14] = 0.0;
        m[15] = 1.0;
        result.markAsUpdated();
        return result;
    }
    /**
     * Takes normalised vectors and returns a rotation matrix to align "from" with "to".
     * Taken from http://www.iquilezles.org/www/articles/noacos/noacos.htm
     * Example Playground - https://playground.babylonjs.com/#AV9X17#93
     * @param from defines the vector to align
     * @param to defines the vector to align to
     * @param result defines the target matrix
     * @param useYAxisForCoplanar defines a boolean indicating that we should favor Y axis for coplanar vectors (default is false)
     * @returns result input
     */ static RotationAlignToRef(from, to, result, useYAxisForCoplanar = false) {
        const c = $c7e4de670ed74d35$export$64b5c384219d3699.Dot(to, from);
        const m = result._m;
        if (c < -1 + (0, $53VPf.Epsilon)) {
            // from and to are colinear and opposite direction.
            // compute a PI rotation on Y axis
            m[0] = -1;
            m[1] = 0;
            m[2] = 0;
            m[3] = 0;
            m[4] = 0;
            m[5] = useYAxisForCoplanar ? 1 : -1;
            m[6] = 0;
            m[7] = 0;
            m[8] = 0;
            m[9] = 0;
            m[10] = useYAxisForCoplanar ? -1 : 1;
            m[11] = 0;
        } else {
            const v = $c7e4de670ed74d35$export$64b5c384219d3699.Cross(to, from);
            const k = 1 / (1 + c);
            m[0] = v._x * v._x * k + c;
            m[1] = v._y * v._x * k - v._z;
            m[2] = v._z * v._x * k + v._y;
            m[3] = 0;
            m[4] = v._x * v._y * k + v._z;
            m[5] = v._y * v._y * k + c;
            m[6] = v._z * v._y * k - v._x;
            m[7] = 0;
            m[8] = v._x * v._z * k - v._y;
            m[9] = v._y * v._z * k + v._x;
            m[10] = v._z * v._z * k + c;
            m[11] = 0;
        }
        m[12] = 0;
        m[13] = 0;
        m[14] = 0;
        m[15] = 1;
        result.markAsUpdated();
        return result;
    }
    /**
     * Creates a rotation matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#103
     * Example Playground - https://playground.babylonjs.com/#AV9X17#105
     * @param yaw defines the yaw angle in radians (Y axis)
     * @param pitch defines the pitch angle in radians (X axis)
     * @param roll defines the roll angle in radians (Z axis)
     * @returns the new rotation matrix
     */ static RotationYawPitchRoll(yaw, pitch, roll) {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.RotationYawPitchRollToRef(yaw, pitch, roll, result);
        return result;
    }
    /**
     * Creates a rotation matrix and stores it in a given matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#104
     * @param yaw defines the yaw angle in radians (Y axis)
     * @param pitch defines the pitch angle in radians (X axis)
     * @param roll defines the roll angle in radians (Z axis)
     * @param result defines the target matrix
     * @returns result input
     */ static RotationYawPitchRollToRef(yaw, pitch, roll, result) {
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.RotationYawPitchRollToRef(yaw, pitch, roll, $c7e4de670ed74d35$var$MathTmp.Quaternion[0]);
        $c7e4de670ed74d35$var$MathTmp.Quaternion[0].toRotationMatrix(result);
        return result;
    }
    /**
     * Creates a scaling matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#107
     * @param x defines the scale factor on X axis
     * @param y defines the scale factor on Y axis
     * @param z defines the scale factor on Z axis
     * @returns the new matrix
     */ static Scaling(x, y, z) {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.ScalingToRef(x, y, z, result);
        return result;
    }
    /**
     * Creates a scaling matrix and stores it in a given matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#108
     * @param x defines the scale factor on X axis
     * @param y defines the scale factor on Y axis
     * @param z defines the scale factor on Z axis
     * @param result defines the target matrix
     * @returns result input
     */ static ScalingToRef(x, y, z, result) {
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(x, 0.0, 0.0, 0.0, 0.0, y, 0.0, 0.0, 0.0, 0.0, z, 0.0, 0.0, 0.0, 0.0, 1.0, result);
        result._updateIdentityStatus(x === 1 && y === 1 && z === 1);
        return result;
    }
    /**
     * Creates a translation matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#109
     * @param x defines the translation on X axis
     * @param y defines the translation on Y axis
     * @param z defines the translationon Z axis
     * @returns the new matrix
     */ static Translation(x, y, z) {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.TranslationToRef(x, y, z, result);
        return result;
    }
    /**
     * Creates a translation matrix and stores it in a given matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#110
     * @param x defines the translation on X axis
     * @param y defines the translation on Y axis
     * @param z defines the translationon Z axis
     * @param result defines the target matrix
     * @returns result input
     */ static TranslationToRef(x, y, z, result) {
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, x, y, z, 1.0, result);
        result._updateIdentityStatus(x === 0 && y === 0 && z === 0);
        return result;
    }
    /**
     * Returns a new Matrix whose values are the interpolated values for "gradient" (float) between the ones of the matrices "startValue" and "endValue".
     * Example Playground - https://playground.babylonjs.com/#AV9X17#55
     * @param startValue defines the start value
     * @param endValue defines the end value
     * @param gradient defines the gradient factor
     * @returns the new matrix
     */ static Lerp(startValue, endValue, gradient) {
        const result = new startValue.constructor();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.LerpToRef(startValue, endValue, gradient, result);
        return result;
    }
    /**
     * Set the given matrix "result" as the interpolated values for "gradient" (float) between the ones of the matrices "startValue" and "endValue".
     * Example Playground - https://playground.babylonjs.com/#AV9X17#54
     * @param startValue defines the start value
     * @param endValue defines the end value
     * @param gradient defines the gradient factor
     * @param result defines the Matrix object where to store data
     * @returns result input
     */ static LerpToRef(startValue, endValue, gradient, result) {
        const resultM = result._m;
        const startM = startValue.m;
        const endM = endValue.m;
        for(let index = 0; index < 16; index++)resultM[index] = startM[index] * (1.0 - gradient) + endM[index] * gradient;
        result.markAsUpdated();
        return result;
    }
    /**
     * Builds a new matrix whose values are computed by:
     * * decomposing the "startValue" and "endValue" matrices into their respective scale, rotation and translation matrices
     * * interpolating for "gradient" (float) the values between each of these decomposed matrices between the start and the end
     * * recomposing a new matrix from these 3 interpolated scale, rotation and translation matrices
     * Example Playground - https://playground.babylonjs.com/#AV9X17#22
     * Example Playground - https://playground.babylonjs.com/#AV9X17#51
     * @param startValue defines the first matrix
     * @param endValue defines the second matrix
     * @param gradient defines the gradient between the two matrices
     * @returns the new matrix
     */ static DecomposeLerp(startValue, endValue, gradient) {
        const result = new startValue.constructor();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.DecomposeLerpToRef(startValue, endValue, gradient, result);
        return result;
    }
    /**
     * Update a matrix to values which are computed by:
     * * decomposing the "startValue" and "endValue" matrices into their respective scale, rotation and translation matrices
     * * interpolating for "gradient" (float) the values between each of these decomposed matrices between the start and the end
     * * recomposing a new matrix from these 3 interpolated scale, rotation and translation matrices
     * Example Playground - https://playground.babylonjs.com/#AV9X17#23
     * Example Playground - https://playground.babylonjs.com/#AV9X17#53
     * @param startValue defines the first matrix
     * @param endValue defines the second matrix
     * @param gradient defines the gradient between the two matrices
     * @param result defines the target matrix
     * @returns result input
     */ static DecomposeLerpToRef(startValue, endValue, gradient, result) {
        const startScale = $c7e4de670ed74d35$var$MathTmp.Vector3[0];
        const startRotation = $c7e4de670ed74d35$var$MathTmp.Quaternion[0];
        const startTranslation = $c7e4de670ed74d35$var$MathTmp.Vector3[1];
        startValue.decompose(startScale, startRotation, startTranslation);
        const endScale = $c7e4de670ed74d35$var$MathTmp.Vector3[2];
        const endRotation = $c7e4de670ed74d35$var$MathTmp.Quaternion[1];
        const endTranslation = $c7e4de670ed74d35$var$MathTmp.Vector3[3];
        endValue.decompose(endScale, endRotation, endTranslation);
        const resultScale = $c7e4de670ed74d35$var$MathTmp.Vector3[4];
        $c7e4de670ed74d35$export$64b5c384219d3699.LerpToRef(startScale, endScale, gradient, resultScale);
        const resultRotation = $c7e4de670ed74d35$var$MathTmp.Quaternion[2];
        $c7e4de670ed74d35$export$23d6a54f0bbc85a3.SlerpToRef(startRotation, endRotation, gradient, resultRotation);
        const resultTranslation = $c7e4de670ed74d35$var$MathTmp.Vector3[5];
        $c7e4de670ed74d35$export$64b5c384219d3699.LerpToRef(startTranslation, endTranslation, gradient, resultTranslation);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.ComposeToRef(resultScale, resultRotation, resultTranslation, result);
        return result;
    }
    /**
     * Creates a new matrix that transforms vertices from world space to camera space. It takes three vectors as arguments that together describe the position and orientation of the camera.
     * This function generates a matrix suitable for a left handed coordinate system
     * Example Playground - https://playground.babylonjs.com/#AV9X17#58
     * Example Playground - https://playground.babylonjs.com/#AV9X17#59
     * @param eye defines the final position of the entity
     * @param target defines where the entity should look at
     * @param up defines the up vector for the entity
     * @returns the new matrix
     */ static LookAtLH(eye, target, up) {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.LookAtLHToRef(eye, target, up, result);
        return result;
    }
    /**
     * Sets the given "result" Matrix to a matrix that transforms vertices from world space to camera space. It takes three vectors as arguments that together describe the position and orientation of the camera.
     * This function generates a matrix suitable for a left handed coordinate system
     * Example Playground - https://playground.babylonjs.com/#AV9X17#60
     * Example Playground - https://playground.babylonjs.com/#AV9X17#61
     * @param eye defines the final position of the entity
     * @param target defines where the entity should look at
     * @param up defines the up vector for the entity
     * @param result defines the target matrix
     * @returns result input
     */ static LookAtLHToRef(eye, target, up, result) {
        const xAxis = $c7e4de670ed74d35$var$MathTmp.Vector3[0];
        const yAxis = $c7e4de670ed74d35$var$MathTmp.Vector3[1];
        const zAxis = $c7e4de670ed74d35$var$MathTmp.Vector3[2];
        // Z axis
        target.subtractToRef(eye, zAxis);
        zAxis.normalize();
        // X axis
        $c7e4de670ed74d35$export$64b5c384219d3699.CrossToRef(up, zAxis, xAxis);
        const xSquareLength = xAxis.lengthSquared();
        if (xSquareLength === 0) xAxis.x = 1.0;
        else xAxis.normalizeFromLength(Math.sqrt(xSquareLength));
        // Y axis
        $c7e4de670ed74d35$export$64b5c384219d3699.CrossToRef(zAxis, xAxis, yAxis);
        yAxis.normalize();
        // Eye angles
        const ex = -$c7e4de670ed74d35$export$64b5c384219d3699.Dot(xAxis, eye);
        const ey = -$c7e4de670ed74d35$export$64b5c384219d3699.Dot(yAxis, eye);
        const ez = -$c7e4de670ed74d35$export$64b5c384219d3699.Dot(zAxis, eye);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(xAxis._x, yAxis._x, zAxis._x, 0.0, xAxis._y, yAxis._y, zAxis._y, 0.0, xAxis._z, yAxis._z, zAxis._z, 0.0, ex, ey, ez, 1.0, result);
        return result;
    }
    /**
     * Creates a new matrix that transforms vertices from world space to camera space. It takes three vectors as arguments that together describe the position and orientation of the camera.
     * This function generates a matrix suitable for a right handed coordinate system
     * Example Playground - https://playground.babylonjs.com/#AV9X17#62
     * Example Playground - https://playground.babylonjs.com/#AV9X17#63
     * @param eye defines the final position of the entity
     * @param target defines where the entity should look at
     * @param up defines the up vector for the entity
     * @returns the new matrix
     */ static LookAtRH(eye, target, up) {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.LookAtRHToRef(eye, target, up, result);
        return result;
    }
    /**
     * Sets the given "result" Matrix to a matrix that transforms vertices from world space to camera space. It takes three vectors as arguments that together describe the position and orientation of the camera.
     * This function generates a matrix suitable for a right handed coordinate system
     * Example Playground - https://playground.babylonjs.com/#AV9X17#64
     * Example Playground - https://playground.babylonjs.com/#AV9X17#65
     * @param eye defines the final position of the entity
     * @param target defines where the entity should look at
     * @param up defines the up vector for the entity
     * @param result defines the target matrix
     * @returns result input
     */ static LookAtRHToRef(eye, target, up, result) {
        const xAxis = $c7e4de670ed74d35$var$MathTmp.Vector3[0];
        const yAxis = $c7e4de670ed74d35$var$MathTmp.Vector3[1];
        const zAxis = $c7e4de670ed74d35$var$MathTmp.Vector3[2];
        // Z axis
        eye.subtractToRef(target, zAxis);
        zAxis.normalize();
        // X axis
        $c7e4de670ed74d35$export$64b5c384219d3699.CrossToRef(up, zAxis, xAxis);
        const xSquareLength = xAxis.lengthSquared();
        if (xSquareLength === 0) xAxis.x = 1.0;
        else xAxis.normalizeFromLength(Math.sqrt(xSquareLength));
        // Y axis
        $c7e4de670ed74d35$export$64b5c384219d3699.CrossToRef(zAxis, xAxis, yAxis);
        yAxis.normalize();
        // Eye angles
        const ex = -$c7e4de670ed74d35$export$64b5c384219d3699.Dot(xAxis, eye);
        const ey = -$c7e4de670ed74d35$export$64b5c384219d3699.Dot(yAxis, eye);
        const ez = -$c7e4de670ed74d35$export$64b5c384219d3699.Dot(zAxis, eye);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(xAxis._x, yAxis._x, zAxis._x, 0.0, xAxis._y, yAxis._y, zAxis._y, 0.0, xAxis._z, yAxis._z, zAxis._z, 0.0, ex, ey, ez, 1.0, result);
        return result;
    }
    /**
     * Creates a new matrix that transforms vertices from world space to camera space. It takes two vectors as arguments that together describe the orientation of the camera. The position is assumed to be at the origin (0,0,0)
     * This function generates a matrix suitable for a left handed coordinate system
     * Example Playground - https://playground.babylonjs.com/#AV9X17#66
     * @param forward defines the forward direction - Must be normalized and orthogonal to up.
     * @param up defines the up vector for the entity - Must be normalized and orthogonal to forward.
     * @returns the new matrix
     */ static LookDirectionLH(forward, up) {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.LookDirectionLHToRef(forward, up, result);
        return result;
    }
    /**
     * Sets the given "result" Matrix to a matrix that transforms vertices from world space to camera space. It takes two vectors as arguments that together describe the orientation of the camera. The position is assumed to be at the origin (0,0,0)
     * This function generates a matrix suitable for a left handed coordinate system
     * Example Playground - https://playground.babylonjs.com/#AV9X17#67
     * @param forward defines the forward direction - Must be normalized and orthogonal to up.
     * @param up defines the up vector for the entity - Must be normalized and orthogonal to forward.
     * @param result defines the target matrix
     * @returns result input
     */ static LookDirectionLHToRef(forward, up, result) {
        const back = $c7e4de670ed74d35$var$MathTmp.Vector3[0];
        back.copyFrom(forward);
        back.scaleInPlace(-1);
        const left = $c7e4de670ed74d35$var$MathTmp.Vector3[1];
        $c7e4de670ed74d35$export$64b5c384219d3699.CrossToRef(up, back, left);
        // Generate the rotation matrix.
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(left._x, left._y, left._z, 0.0, up._x, up._y, up._z, 0.0, back._x, back._y, back._z, 0.0, 0, 0, 0, 1.0, result);
        return result;
    }
    /**
     * Creates a new matrix that transforms vertices from world space to camera space. It takes two vectors as arguments that together describe the orientation of the camera. The position is assumed to be at the origin (0,0,0)
     * This function generates a matrix suitable for a right handed coordinate system
     * Example Playground - https://playground.babylonjs.com/#AV9X17#68
     * @param forward defines the forward direction - Must be normalized and orthogonal to up.
     * @param up defines the up vector for the entity - Must be normalized and orthogonal to forward.
     * @returns the new matrix
     */ static LookDirectionRH(forward, up) {
        const result = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.LookDirectionRHToRef(forward, up, result);
        return result;
    }
    /**
     * Sets the given "result" Matrix to a matrix that transforms vertices from world space to camera space. It takes two vectors as arguments that together describe the orientation of the camera. The position is assumed to be at the origin (0,0,0)
     * This function generates a matrix suitable for a right handed coordinate system
     * Example Playground - https://playground.babylonjs.com/#AV9X17#69
     * @param forward defines the forward direction - Must be normalized and orthogonal to up.
     * @param up defines the up vector for the entity - Must be normalized and orthogonal to forward.
     * @param result defines the target matrix
     * @returns result input
     */ static LookDirectionRHToRef(forward, up, result) {
        const right = $c7e4de670ed74d35$var$MathTmp.Vector3[2];
        $c7e4de670ed74d35$export$64b5c384219d3699.CrossToRef(up, forward, right);
        // Generate the rotation matrix.
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(right._x, right._y, right._z, 0.0, up._x, up._y, up._z, 0.0, forward._x, forward._y, forward._z, 0.0, 0, 0, 0, 1.0, result);
        return result;
    }
    /**
     * Create a left-handed orthographic projection matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#70
     * @param width defines the viewport width
     * @param height defines the viewport height
     * @param znear defines the near clip plane
     * @param zfar defines the far clip plane
     * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
     * @returns a new matrix as a left-handed orthographic projection matrix
     */ static OrthoLH(width, height, znear, zfar, halfZRange) {
        const matrix = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.OrthoLHToRef(width, height, znear, zfar, matrix, halfZRange);
        return matrix;
    }
    /**
     * Store a left-handed orthographic projection to a given matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#71
     * @param width defines the viewport width
     * @param height defines the viewport height
     * @param znear defines the near clip plane
     * @param zfar defines the far clip plane
     * @param result defines the target matrix
     * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
     * @returns result input
     */ static OrthoLHToRef(width, height, znear, zfar, result, halfZRange) {
        const n = znear;
        const f = zfar;
        const a = 2.0 / width;
        const b = 2.0 / height;
        const c = 2.0 / (f - n);
        const d = -(f + n) / (f - n);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(a, 0.0, 0.0, 0.0, 0.0, b, 0.0, 0.0, 0.0, 0.0, c, 0.0, 0.0, 0.0, d, 1.0, result);
        if (halfZRange) result.multiplyToRef($c7e4de670ed74d35$var$mtxConvertNDCToHalfZRange, result);
        result._updateIdentityStatus(a === 1 && b === 1 && c === 1 && d === 0);
        return result;
    }
    /**
     * Create a left-handed orthographic projection matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#72
     * @param left defines the viewport left coordinate
     * @param right defines the viewport right coordinate
     * @param bottom defines the viewport bottom coordinate
     * @param top defines the viewport top coordinate
     * @param znear defines the near clip plane
     * @param zfar defines the far clip plane
     * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
     * @returns a new matrix as a left-handed orthographic projection matrix
     */ static OrthoOffCenterLH(left, right, bottom, top, znear, zfar, halfZRange) {
        const matrix = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.OrthoOffCenterLHToRef(left, right, bottom, top, znear, zfar, matrix, halfZRange);
        return matrix;
    }
    /**
     * Stores a left-handed orthographic projection into a given matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#73
     * @param left defines the viewport left coordinate
     * @param right defines the viewport right coordinate
     * @param bottom defines the viewport bottom coordinate
     * @param top defines the viewport top coordinate
     * @param znear defines the near clip plane
     * @param zfar defines the far clip plane
     * @param result defines the target matrix
     * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
     * @returns result input
     */ static OrthoOffCenterLHToRef(left, right, bottom, top, znear, zfar, result, halfZRange) {
        const n = znear;
        const f = zfar;
        const a = 2.0 / (right - left);
        const b = 2.0 / (top - bottom);
        const c = 2.0 / (f - n);
        const d = -(f + n) / (f - n);
        const i0 = (left + right) / (left - right);
        const i1 = (top + bottom) / (bottom - top);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(a, 0.0, 0.0, 0.0, 0.0, b, 0.0, 0.0, 0.0, 0.0, c, 0.0, i0, i1, d, 1.0, result);
        if (halfZRange) result.multiplyToRef($c7e4de670ed74d35$var$mtxConvertNDCToHalfZRange, result);
        result.markAsUpdated();
        return result;
    }
    /**
     * Stores a left-handed oblique projection into a given matrix
     * @param left defines the viewport left coordinate
     * @param right defines the viewport right coordinate
     * @param bottom defines the viewport bottom coordinate
     * @param top defines the viewport top coordinate
     * @param znear defines the near clip plane
     * @param zfar defines the far clip plane
     * @param length Length of the shear
     * @param angle Angle (along X/Y Plane) to apply shear
     * @param distance Distance from shear point
     * @param result defines the target matrix
     * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
     * @returns result input
     */ static ObliqueOffCenterLHToRef(left, right, bottom, top, znear, zfar, length, angle, distance, result, halfZRange) {
        const a = -length * Math.cos(angle);
        const b = -length * Math.sin(angle);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.TranslationToRef(0, 0, -distance, $c7e4de670ed74d35$var$MathTmp.Matrix[1]);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(1, 0, 0, 0, 0, 1, 0, 0, a, b, 1, 0, 0, 0, 0, 1, $c7e4de670ed74d35$var$MathTmp.Matrix[0]);
        $c7e4de670ed74d35$var$MathTmp.Matrix[1].multiplyToRef($c7e4de670ed74d35$var$MathTmp.Matrix[0], $c7e4de670ed74d35$var$MathTmp.Matrix[0]);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.TranslationToRef(0, 0, distance, $c7e4de670ed74d35$var$MathTmp.Matrix[1]);
        $c7e4de670ed74d35$var$MathTmp.Matrix[0].multiplyToRef($c7e4de670ed74d35$var$MathTmp.Matrix[1], $c7e4de670ed74d35$var$MathTmp.Matrix[0]);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.OrthoOffCenterLHToRef(left, right, bottom, top, znear, zfar, result, halfZRange);
        $c7e4de670ed74d35$var$MathTmp.Matrix[0].multiplyToRef(result, result);
        return result;
    }
    /**
     * Creates a right-handed orthographic projection matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#76
     * @param left defines the viewport left coordinate
     * @param right defines the viewport right coordinate
     * @param bottom defines the viewport bottom coordinate
     * @param top defines the viewport top coordinate
     * @param znear defines the near clip plane
     * @param zfar defines the far clip plane
     * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
     * @returns a new matrix as a right-handed orthographic projection matrix
     */ static OrthoOffCenterRH(left, right, bottom, top, znear, zfar, halfZRange) {
        const matrix = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.OrthoOffCenterRHToRef(left, right, bottom, top, znear, zfar, matrix, halfZRange);
        return matrix;
    }
    /**
     * Stores a right-handed orthographic projection into a given matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#77
     * @param left defines the viewport left coordinate
     * @param right defines the viewport right coordinate
     * @param bottom defines the viewport bottom coordinate
     * @param top defines the viewport top coordinate
     * @param znear defines the near clip plane
     * @param zfar defines the far clip plane
     * @param result defines the target matrix
     * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
     * @returns result input
     */ static OrthoOffCenterRHToRef(left, right, bottom, top, znear, zfar, result, halfZRange) {
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.OrthoOffCenterLHToRef(left, right, bottom, top, znear, zfar, result, halfZRange);
        result._m[10] *= -1; // No need to call markAsUpdated as previous function already called it and let _isIdentityDirty to true
        return result;
    }
    /**
     * Stores a right-handed oblique projection into a given matrix
     * @param left defines the viewport left coordinate
     * @param right defines the viewport right coordinate
     * @param bottom defines the viewport bottom coordinate
     * @param top defines the viewport top coordinate
     * @param znear defines the near clip plane
     * @param zfar defines the far clip plane
     * @param length Length of the shear
     * @param angle Angle (along X/Y Plane) to apply shear
     * @param distance Distance from shear point
     * @param result defines the target matrix
     * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
     * @returns result input
     */ static ObliqueOffCenterRHToRef(left, right, bottom, top, znear, zfar, length, angle, distance, result, halfZRange) {
        const a = length * Math.cos(angle);
        const b = length * Math.sin(angle);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.TranslationToRef(0, 0, distance, $c7e4de670ed74d35$var$MathTmp.Matrix[1]);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(1, 0, 0, 0, 0, 1, 0, 0, a, b, 1, 0, 0, 0, 0, 1, $c7e4de670ed74d35$var$MathTmp.Matrix[0]);
        $c7e4de670ed74d35$var$MathTmp.Matrix[1].multiplyToRef($c7e4de670ed74d35$var$MathTmp.Matrix[0], $c7e4de670ed74d35$var$MathTmp.Matrix[0]);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.TranslationToRef(0, 0, -distance, $c7e4de670ed74d35$var$MathTmp.Matrix[1]);
        $c7e4de670ed74d35$var$MathTmp.Matrix[0].multiplyToRef($c7e4de670ed74d35$var$MathTmp.Matrix[1], $c7e4de670ed74d35$var$MathTmp.Matrix[0]);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.OrthoOffCenterRHToRef(left, right, bottom, top, znear, zfar, result, halfZRange);
        $c7e4de670ed74d35$var$MathTmp.Matrix[0].multiplyToRef(result, result);
        return result;
    }
    /**
     * Creates a left-handed perspective projection matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#85
     * @param width defines the viewport width
     * @param height defines the viewport height
     * @param znear defines the near clip plane
     * @param zfar defines the far clip plane
     * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
     * @param projectionPlaneTilt optional tilt angle of the projection plane around the X axis (horizontal)
     * @returns a new matrix as a left-handed perspective projection matrix
     */ static PerspectiveLH(width, height, znear, zfar, halfZRange, projectionPlaneTilt = 0) {
        const matrix = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        const n = znear;
        const f = zfar;
        const a = 2.0 * n / width;
        const b = 2.0 * n / height;
        const c = (f + n) / (f - n);
        const d = -2 * f * n / (f - n);
        const rot = Math.tan(projectionPlaneTilt);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(a, 0.0, 0.0, 0.0, 0.0, b, 0.0, rot, 0.0, 0.0, c, 1.0, 0.0, 0.0, d, 0.0, matrix);
        if (halfZRange) matrix.multiplyToRef($c7e4de670ed74d35$var$mtxConvertNDCToHalfZRange, matrix);
        matrix._updateIdentityStatus(false);
        return matrix;
    }
    /**
     * Creates a left-handed perspective projection matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#78
     * @param fov defines the horizontal field of view
     * @param aspect defines the aspect ratio
     * @param znear defines the near clip plane
     * @param zfar defines the far clip plane. If 0, assume we are in "infinite zfar" mode
     * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
     * @param projectionPlaneTilt optional tilt angle of the projection plane around the X axis (horizontal)
     * @param reverseDepthBufferMode true to indicate that we are in a reverse depth buffer mode (meaning znear and zfar have been inverted when calling the function)
     * @returns a new matrix as a left-handed perspective projection matrix
     */ static PerspectiveFovLH(fov, aspect, znear, zfar, halfZRange, projectionPlaneTilt = 0, reverseDepthBufferMode = false) {
        const matrix = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.PerspectiveFovLHToRef(fov, aspect, znear, zfar, matrix, true, halfZRange, projectionPlaneTilt, reverseDepthBufferMode);
        return matrix;
    }
    /**
     * Stores a left-handed perspective projection into a given matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#81
     * @param fov defines the horizontal field of view
     * @param aspect defines the aspect ratio
     * @param znear defines the near clip plane
     * @param zfar defines the far clip plane. If 0, assume we are in "infinite zfar" mode
     * @param result defines the target matrix
     * @param isVerticalFovFixed defines it the fov is vertically fixed (default) or horizontally
     * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
     * @param projectionPlaneTilt optional tilt angle of the projection plane around the X axis (horizontal)
     * @param reverseDepthBufferMode true to indicate that we are in a reverse depth buffer mode (meaning znear and zfar have been inverted when calling the function)
     * @returns result input
     */ static PerspectiveFovLHToRef(fov, aspect, znear, zfar, result, isVerticalFovFixed = true, halfZRange, projectionPlaneTilt = 0, reverseDepthBufferMode = false) {
        const n = znear;
        const f = zfar;
        const t = 1.0 / Math.tan(fov * 0.5);
        const a = isVerticalFovFixed ? t / aspect : t;
        const b = isVerticalFovFixed ? t : t * aspect;
        const c = reverseDepthBufferMode && n === 0 ? -1 : f !== 0 ? (f + n) / (f - n) : 1;
        const d = reverseDepthBufferMode && n === 0 ? 2 * f : f !== 0 ? -2 * f * n / (f - n) : -2 * n;
        const rot = Math.tan(projectionPlaneTilt);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(a, 0.0, 0.0, 0.0, 0.0, b, 0.0, rot, 0.0, 0.0, c, 1.0, 0.0, 0.0, d, 0.0, result);
        if (halfZRange) result.multiplyToRef($c7e4de670ed74d35$var$mtxConvertNDCToHalfZRange, result);
        result._updateIdentityStatus(false);
        return result;
    }
    /**
     * Stores a left-handed perspective projection into a given matrix with depth reversed
     * Example Playground - https://playground.babylonjs.com/#AV9X17#89
     * @param fov defines the horizontal field of view
     * @param aspect defines the aspect ratio
     * @param znear defines the near clip plane
     * @param zfar not used as infinity is used as far clip
     * @param result defines the target matrix
     * @param isVerticalFovFixed defines it the fov is vertically fixed (default) or horizontally
     * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
     * @param projectionPlaneTilt optional tilt angle of the projection plane around the X axis (horizontal)
     * @returns result input
     */ static PerspectiveFovReverseLHToRef(fov, aspect, znear, zfar, result, isVerticalFovFixed = true, halfZRange, projectionPlaneTilt = 0) {
        const t = 1.0 / Math.tan(fov * 0.5);
        const a = isVerticalFovFixed ? t / aspect : t;
        const b = isVerticalFovFixed ? t : t * aspect;
        const rot = Math.tan(projectionPlaneTilt);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(a, 0.0, 0.0, 0.0, 0.0, b, 0.0, rot, 0.0, 0.0, -znear, 1.0, 0.0, 0.0, 1.0, 0.0, result);
        if (halfZRange) result.multiplyToRef($c7e4de670ed74d35$var$mtxConvertNDCToHalfZRange, result);
        result._updateIdentityStatus(false);
        return result;
    }
    /**
     * Creates a right-handed perspective projection matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#83
     * @param fov defines the horizontal field of view
     * @param aspect defines the aspect ratio
     * @param znear defines the near clip plane
     * @param zfar defines the far clip plane. If 0, assume we are in "infinite zfar" mode
     * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
     * @param projectionPlaneTilt optional tilt angle of the projection plane around the X axis (horizontal)
     * @param reverseDepthBufferMode true to indicate that we are in a reverse depth buffer mode (meaning znear and zfar have been inverted when calling the function)
     * @returns a new matrix as a right-handed perspective projection matrix
     */ static PerspectiveFovRH(fov, aspect, znear, zfar, halfZRange, projectionPlaneTilt = 0, reverseDepthBufferMode = false) {
        const matrix = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.PerspectiveFovRHToRef(fov, aspect, znear, zfar, matrix, true, halfZRange, projectionPlaneTilt, reverseDepthBufferMode);
        return matrix;
    }
    /**
     * Stores a right-handed perspective projection into a given matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#84
     * @param fov defines the horizontal field of view
     * @param aspect defines the aspect ratio
     * @param znear defines the near clip plane
     * @param zfar defines the far clip plane. If 0, assume we are in "infinite zfar" mode
     * @param result defines the target matrix
     * @param isVerticalFovFixed defines it the fov is vertically fixed (default) or horizontally
     * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
     * @param projectionPlaneTilt optional tilt angle of the projection plane around the X axis (horizontal)
     * @param reverseDepthBufferMode true to indicate that we are in a reverse depth buffer mode (meaning znear and zfar have been inverted when calling the function)
     * @returns result input
     */ static PerspectiveFovRHToRef(fov, aspect, znear, zfar, result, isVerticalFovFixed = true, halfZRange, projectionPlaneTilt = 0, reverseDepthBufferMode = false) {
        //alternatively this could be expressed as:
        //    m = PerspectiveFovLHToRef
        //    m[10] *= -1.0;
        //    m[11] *= -1.0;
        const n = znear;
        const f = zfar;
        const t = 1.0 / Math.tan(fov * 0.5);
        const a = isVerticalFovFixed ? t / aspect : t;
        const b = isVerticalFovFixed ? t : t * aspect;
        const c = reverseDepthBufferMode && n === 0 ? 1 : f !== 0 ? -(f + n) / (f - n) : -1;
        const d = reverseDepthBufferMode && n === 0 ? 2 * f : f !== 0 ? -2 * f * n / (f - n) : -2 * n;
        const rot = Math.tan(projectionPlaneTilt);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(a, 0.0, 0.0, 0.0, 0.0, b, 0.0, rot, 0.0, 0.0, c, -1, 0.0, 0.0, d, 0.0, result);
        if (halfZRange) result.multiplyToRef($c7e4de670ed74d35$var$mtxConvertNDCToHalfZRange, result);
        result._updateIdentityStatus(false);
        return result;
    }
    /**
     * Stores a right-handed perspective projection into a given matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#90
     * @param fov defines the horizontal field of view
     * @param aspect defines the aspect ratio
     * @param znear defines the near clip plane
     * @param zfar not used as infinity is used as far clip
     * @param result defines the target matrix
     * @param isVerticalFovFixed defines it the fov is vertically fixed (default) or horizontally
     * @param halfZRange true to generate NDC coordinates between 0 and 1 instead of -1 and 1 (default: false)
     * @param projectionPlaneTilt optional tilt angle of the projection plane around the X axis (horizontal)
     * @returns result input
     */ static PerspectiveFovReverseRHToRef(fov, aspect, znear, zfar, result, isVerticalFovFixed = true, halfZRange, projectionPlaneTilt = 0) {
        const t = 1.0 / Math.tan(fov * 0.5);
        const a = isVerticalFovFixed ? t / aspect : t;
        const b = isVerticalFovFixed ? t : t * aspect;
        const rot = Math.tan(projectionPlaneTilt);
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(a, 0.0, 0.0, 0.0, 0.0, b, 0.0, rot, 0.0, 0.0, -znear, -1, 0.0, 0.0, -1, 0.0, result);
        if (halfZRange) result.multiplyToRef($c7e4de670ed74d35$var$mtxConvertNDCToHalfZRange, result);
        result._updateIdentityStatus(false);
        return result;
    }
    /**
     * Computes a complete transformation matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#113
     * @param viewport defines the viewport to use
     * @param world defines the world matrix
     * @param view defines the view matrix
     * @param projection defines the projection matrix
     * @param zmin defines the near clip plane
     * @param zmax defines the far clip plane
     * @returns the transformation matrix
     */ static GetFinalMatrix(viewport, world, view, projection, zmin, zmax) {
        const cw = viewport.width;
        const ch = viewport.height;
        const cx = viewport.x;
        const cy = viewport.y;
        const viewportMatrix = $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValues(cw / 2.0, 0.0, 0.0, 0.0, 0.0, -ch / 2.0, 0.0, 0.0, 0.0, 0.0, zmax - zmin, 0.0, cx + cw / 2.0, ch / 2.0 + cy, zmin, 1.0);
        const matrix = new world.constructor();
        world.multiplyToRef(view, matrix);
        matrix.multiplyToRef(projection, matrix);
        return matrix.multiplyToRef(viewportMatrix, matrix);
    }
    /**
     * Extracts a 2x2 matrix from a given matrix and store the result in a Float32Array
     * @param matrix defines the matrix to use
     * @returns a new Float32Array array with 4 elements : the 2x2 matrix extracted from the given matrix
     */ static GetAsMatrix2x2(matrix) {
        const m = matrix.m;
        const arr = [
            m[0],
            m[1],
            m[4],
            m[5]
        ];
        return (0, $3agwF.PerformanceConfigurator).MatrixUse64Bits ? arr : new Float32Array(arr);
    }
    /**
     * Extracts a 3x3 matrix from a given matrix and store the result in a Float32Array
     * @param matrix defines the matrix to use
     * @returns a new Float32Array array with 9 elements : the 3x3 matrix extracted from the given matrix
     */ static GetAsMatrix3x3(matrix) {
        const m = matrix.m;
        const arr = [
            m[0],
            m[1],
            m[2],
            m[4],
            m[5],
            m[6],
            m[8],
            m[9],
            m[10]
        ];
        return (0, $3agwF.PerformanceConfigurator).MatrixUse64Bits ? arr : new Float32Array(arr);
    }
    /**
     * Compute the transpose of a given matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#111
     * @param matrix defines the matrix to transpose
     * @returns the new matrix
     */ static Transpose(matrix) {
        const result = new matrix.constructor();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.TransposeToRef(matrix, result);
        return result;
    }
    /**
     * Compute the transpose of a matrix and store it in a target matrix
     * Example Playground - https://playground.babylonjs.com/#AV9X17#112
     * @param matrix defines the matrix to transpose
     * @param result defines the target matrix
     * @returns result input
     */ static TransposeToRef(matrix, result) {
        const mm = matrix.m;
        const rm0 = mm[0];
        const rm1 = mm[4];
        const rm2 = mm[8];
        const rm3 = mm[12];
        const rm4 = mm[1];
        const rm5 = mm[5];
        const rm6 = mm[9];
        const rm7 = mm[13];
        const rm8 = mm[2];
        const rm9 = mm[6];
        const rm10 = mm[10];
        const rm11 = mm[14];
        const rm12 = mm[3];
        const rm13 = mm[7];
        const rm14 = mm[11];
        const rm15 = mm[15];
        const rm = result._m;
        rm[0] = rm0;
        rm[1] = rm1;
        rm[2] = rm2;
        rm[3] = rm3;
        rm[4] = rm4;
        rm[5] = rm5;
        rm[6] = rm6;
        rm[7] = rm7;
        rm[8] = rm8;
        rm[9] = rm9;
        rm[10] = rm10;
        rm[11] = rm11;
        rm[12] = rm12;
        rm[13] = rm13;
        rm[14] = rm14;
        rm[15] = rm15;
        result.markAsUpdated();
        // identity-ness does not change when transposing
        result._updateIdentityStatus(matrix._isIdentity, matrix._isIdentityDirty);
        return result;
    }
    /**
     * Computes a reflection matrix from a plane
     * Example Playground - https://playground.babylonjs.com/#AV9X17#87
     * @param plane defines the reflection plane
     * @returns a new matrix
     */ static Reflection(plane) {
        const matrix = new $c7e4de670ed74d35$export$5b12bf1653c0dd85();
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.ReflectionToRef(plane, matrix);
        return matrix;
    }
    /**
     * Computes a reflection matrix from a plane
     * Example Playground - https://playground.babylonjs.com/#AV9X17#88
     * @param plane defines the reflection plane
     * @param result defines the target matrix
     * @returns result input
     */ static ReflectionToRef(plane, result) {
        plane.normalize();
        const x = plane.normal.x;
        const y = plane.normal.y;
        const z = plane.normal.z;
        const temp = -2 * x;
        const temp2 = -2 * y;
        const temp3 = -2 * z;
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(temp * x + 1, temp2 * x, temp3 * x, 0.0, temp * y, temp2 * y + 1, temp3 * y, 0.0, temp * z, temp2 * z, temp3 * z + 1, 0.0, temp * plane.d, temp2 * plane.d, temp3 * plane.d, 1.0, result);
        return result;
    }
    /**
     * Sets the given matrix as a rotation matrix composed from the 3 left handed axes
     * @param xaxis defines the value of the 1st axis
     * @param yaxis defines the value of the 2nd axis
     * @param zaxis defines the value of the 3rd axis
     * @param result defines the target matrix
     * @returns result input
     */ static FromXYZAxesToRef(xaxis, yaxis, zaxis, result) {
        $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValuesToRef(xaxis._x, xaxis._y, xaxis._z, 0.0, yaxis._x, yaxis._y, yaxis._z, 0.0, zaxis._x, zaxis._y, zaxis._z, 0.0, 0.0, 0.0, 0.0, 1.0, result);
        return result;
    }
    /**
     * Creates a rotation matrix from a quaternion and stores it in a target matrix
     * @param quat defines the quaternion to use
     * @param result defines the target matrix
     * @returns result input
     */ static FromQuaternionToRef(quat, result) {
        const xx = quat._x * quat._x;
        const yy = quat._y * quat._y;
        const zz = quat._z * quat._z;
        const xy = quat._x * quat._y;
        const zw = quat._z * quat._w;
        const zx = quat._z * quat._x;
        const yw = quat._y * quat._w;
        const yz = quat._y * quat._z;
        const xw = quat._x * quat._w;
        result._m[0] = 1.0 - 2.0 * (yy + zz);
        result._m[1] = 2.0 * (xy + zw);
        result._m[2] = 2.0 * (zx - yw);
        result._m[3] = 0.0;
        result._m[4] = 2.0 * (xy - zw);
        result._m[5] = 1.0 - 2.0 * (zz + xx);
        result._m[6] = 2.0 * (yz + xw);
        result._m[7] = 0.0;
        result._m[8] = 2.0 * (zx + yw);
        result._m[9] = 2.0 * (yz - xw);
        result._m[10] = 1.0 - 2.0 * (yy + xx);
        result._m[11] = 0.0;
        result._m[12] = 0.0;
        result._m[13] = 0.0;
        result._m[14] = 0.0;
        result._m[15] = 1.0;
        result.markAsUpdated();
        return result;
    }
}
$c7e4de670ed74d35$export$5b12bf1653c0dd85._UpdateFlagSeed = 0;
$c7e4de670ed74d35$export$5b12bf1653c0dd85._IdentityReadOnly = $c7e4de670ed74d35$export$5b12bf1653c0dd85.Identity();
Object.defineProperties($c7e4de670ed74d35$export$5b12bf1653c0dd85.prototype, {
    dimension: {
        value: [
            4,
            4
        ]
    },
    rank: {
        value: 2
    }
});
/**
 * @internal
 * Same as Tmp but not exported to keep it only for math functions to avoid conflicts
 */ class $c7e4de670ed74d35$var$MathTmp {
}
// Temporary Vector3s
$c7e4de670ed74d35$var$MathTmp.Vector3 = (0, $opFp4.ArrayTools).BuildTuple(11, $c7e4de670ed74d35$export$64b5c384219d3699.Zero);
// Temporary Matricies
$c7e4de670ed74d35$var$MathTmp.Matrix = (0, $opFp4.ArrayTools).BuildTuple(2, $c7e4de670ed74d35$export$5b12bf1653c0dd85.Identity);
// Temporary Quaternions
$c7e4de670ed74d35$var$MathTmp.Quaternion = (0, $opFp4.ArrayTools).BuildTuple(3, $c7e4de670ed74d35$export$23d6a54f0bbc85a3.Zero);
class $c7e4de670ed74d35$export$269f00bf0c0718d1 {
}
/** 3 temp Vector2 at once should be enough */ $c7e4de670ed74d35$export$269f00bf0c0718d1.Vector2 = (0, $opFp4.ArrayTools).BuildTuple(3, $c7e4de670ed74d35$export$c977b3e384af9ae1.Zero);
/** 13 temp Vector3 at once should be enough */ $c7e4de670ed74d35$export$269f00bf0c0718d1.Vector3 = (0, $opFp4.ArrayTools).BuildTuple(13, $c7e4de670ed74d35$export$64b5c384219d3699.Zero);
/** 3 temp Vector4 at once should be enough */ $c7e4de670ed74d35$export$269f00bf0c0718d1.Vector4 = (0, $opFp4.ArrayTools).BuildTuple(3, $c7e4de670ed74d35$export$fa7daccca11cdbe3.Zero);
/** 2 temp Quaternion at once should be enough */ $c7e4de670ed74d35$export$269f00bf0c0718d1.Quaternion = (0, $opFp4.ArrayTools).BuildTuple(2, $c7e4de670ed74d35$export$23d6a54f0bbc85a3.Zero);
/** 8 temp Matrices at once should be enough */ $c7e4de670ed74d35$export$269f00bf0c0718d1.Matrix = (0, $opFp4.ArrayTools).BuildTuple(8, $c7e4de670ed74d35$export$5b12bf1653c0dd85.Identity);
(0, $8DoUR.RegisterClass)("BABYLON.Vector2", $c7e4de670ed74d35$export$c977b3e384af9ae1);
(0, $8DoUR.RegisterClass)("BABYLON.Vector3", $c7e4de670ed74d35$export$64b5c384219d3699);
(0, $8DoUR.RegisterClass)("BABYLON.Vector4", $c7e4de670ed74d35$export$fa7daccca11cdbe3);
(0, $8DoUR.RegisterClass)("BABYLON.Matrix", $c7e4de670ed74d35$export$5b12bf1653c0dd85);
const $c7e4de670ed74d35$var$mtxConvertNDCToHalfZRange = $c7e4de670ed74d35$export$5b12bf1653c0dd85.FromValues(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0.5, 0, 0, 0, 0.5, 1);

});
parcelRegister("53VPf", function(module, exports) {

$parcel$export(module.exports, "ToGammaSpace", () => $3afa168367ea15a0$export$a8ac250023fc4297);
$parcel$export(module.exports, "ToLinearSpace", () => $3afa168367ea15a0$export$489f0bc65ef7375c);
$parcel$export(module.exports, "PHI", () => $3afa168367ea15a0$export$ed904dc4011d96f7);
$parcel$export(module.exports, "Epsilon", () => $3afa168367ea15a0$export$cb998ac70542b2c3);
/**
 * Constant used to convert a value to gamma space
 * @ignorenaming
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
const $3afa168367ea15a0$export$a8ac250023fc4297 = 1 / 2.2;
const $3afa168367ea15a0$export$489f0bc65ef7375c = 2.2;
const $3afa168367ea15a0$export$ed904dc4011d96f7 = (1 + Math.sqrt(5)) / 2;
/**
 * Constant used to define the minimal number value in Babylon.js
 * @ignorenaming
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
const $3afa168367ea15a0$export$cb998ac70542b2c3 = 0.001;

});

parcelRegister("opFp4", function(module, exports) {

$parcel$export(module.exports, "ArrayTools", () => $049626e575d1494e$export$86d7b3b9478f951d);
$parcel$export(module.exports, "_ObserveArray", () => $049626e575d1494e$export$96a3d8721b7deb3a);
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Class containing a set of static utilities functions for arrays.
 */ class $049626e575d1494e$export$86d7b3b9478f951d {
    /**
     * Returns an array of the given size filled with elements built from the given constructor and the parameters.
     * @param size the number of element to construct and put in the array.
     * @param itemBuilder a callback responsible for creating new instance of item. Called once per array entry.
     * @returns a new array filled with new objects.
     */ static BuildArray(size, itemBuilder) {
        const a = [];
        for(let i = 0; i < size; ++i)a.push(itemBuilder());
        return a;
    }
    /**
     * Returns a tuple of the given size filled with elements built from the given constructor and the parameters.
     * @param size he number of element to construct and put in the tuple.
     * @param itemBuilder a callback responsible for creating new instance of item. Called once per tuple entry.
     * @returns a new tuple filled with new objects.
     */ static BuildTuple(size, itemBuilder) {
        return $049626e575d1494e$export$86d7b3b9478f951d.BuildArray(size, itemBuilder);
    }
}
/**
 * Observes a function and calls the given callback when it is called.
 * @param object Defines the object the function to observe belongs to.
 * @param functionName Defines the name of the function to observe.
 * @param callback Defines the callback to call when the function is called.
 * @returns A function to call to stop observing
 */ function $049626e575d1494e$var$_observeArrayfunction(object, functionName, callback) {
    // Finds the function to observe
    const oldFunction = object[functionName];
    if (typeof oldFunction !== "function") return null;
    // Creates a new function that calls the callback and the old function
    const newFunction = function() {
        const previousLength = object.length;
        const returnValue = newFunction.previous.apply(object, arguments);
        callback(functionName, previousLength);
        return returnValue;
    };
    // Doublishly links the new function and the old function
    oldFunction.next = newFunction;
    newFunction.previous = oldFunction;
    // Replaces the old function with the new function
    object[functionName] = newFunction;
    // Returns a function to disable the hook
    return ()=>{
        // Only unhook if the function is still hooked
        const previous = newFunction.previous;
        if (!previous) return;
        // Finds the ref to the next function in the chain
        const next = newFunction.next;
        // If in the middle of the chain, link the previous and next functions
        if (next) {
            previous.next = next;
            next.previous = previous;
        } else {
            previous.next = undefined;
            object[functionName] = previous;
        }
        // Lose reference to the previous and next functions
        newFunction.next = undefined;
        newFunction.previous = undefined;
    };
}
/**
 * Defines the list of functions to proxy when observing an array.
 * The scope is currently reduced to the common functions used in the render target render list and the scene cameras.
 */ const $049626e575d1494e$var$observedArrayFunctions = [
    "push",
    "splice",
    "pop",
    "shift",
    "unshift"
];
function $049626e575d1494e$export$96a3d8721b7deb3a(array, callback) {
    // Observes all the required array functions and stores the unhook functions
    const unObserveFunctions = $049626e575d1494e$var$observedArrayFunctions.map((name)=>{
        return $049626e575d1494e$var$_observeArrayfunction(array, name, callback);
    });
    // Returns a function that unhook all the observed functions
    return ()=>{
        unObserveFunctions.forEach((unObserveFunction)=>{
            unObserveFunction?.();
        });
    };
}

});

parcelRegister("8DoUR", function(module, exports) {

$parcel$export(module.exports, "RegisterClass", () => $64954b10efba2b52$export$1b9ac54a99baf77);
$parcel$export(module.exports, "GetClass", () => $64954b10efba2b52$export$8b6eb39d35ebe016);
/** @internal */ // eslint-disable-next-line @typescript-eslint/naming-convention
const $64954b10efba2b52$var$_RegisteredTypes = {};
function $64954b10efba2b52$export$1b9ac54a99baf77(className, type) {
    $64954b10efba2b52$var$_RegisteredTypes[className] = type;
}
function $64954b10efba2b52$export$8b6eb39d35ebe016(fqdn) {
    return $64954b10efba2b52$var$_RegisteredTypes[fqdn];
}

});

parcelRegister("3agwF", function(module, exports) {

$parcel$export(module.exports, "PerformanceConfigurator", () => $24df1ffa5ae52c50$export$d3f2aa2665f671ec);
/** @internal */ class $24df1ffa5ae52c50$export$d3f2aa2665f671ec {
    /**
     * @internal
     */ static SetMatrixPrecision(use64bits) {
        $24df1ffa5ae52c50$export$d3f2aa2665f671ec.MatrixTrackPrecisionChange = false;
        if (use64bits && !$24df1ffa5ae52c50$export$d3f2aa2665f671ec.MatrixUse64Bits) {
            if ($24df1ffa5ae52c50$export$d3f2aa2665f671ec.MatrixTrackedMatrices) for(let m = 0; m < $24df1ffa5ae52c50$export$d3f2aa2665f671ec.MatrixTrackedMatrices.length; ++m){
                const matrix = $24df1ffa5ae52c50$export$d3f2aa2665f671ec.MatrixTrackedMatrices[m];
                const values = matrix._m;
                matrix._m = new Array(16);
                for(let i = 0; i < 16; ++i)matrix._m[i] = values[i];
            }
        }
        $24df1ffa5ae52c50$export$d3f2aa2665f671ec.MatrixUse64Bits = use64bits;
        $24df1ffa5ae52c50$export$d3f2aa2665f671ec.MatrixCurrentType = $24df1ffa5ae52c50$export$d3f2aa2665f671ec.MatrixUse64Bits ? Array : Float32Array;
        $24df1ffa5ae52c50$export$d3f2aa2665f671ec.MatrixTrackedMatrices = null; // reclaim some memory, as we don't need _TrackedMatrices anymore
    }
}
/** @internal */ $24df1ffa5ae52c50$export$d3f2aa2665f671ec.MatrixUse64Bits = false;
/** @internal */ $24df1ffa5ae52c50$export$d3f2aa2665f671ec.MatrixTrackPrecisionChange = true;
/** @internal */ $24df1ffa5ae52c50$export$d3f2aa2665f671ec.MatrixCurrentType = Float32Array;
/** @internal */ $24df1ffa5ae52c50$export$d3f2aa2665f671ec.MatrixTrackedMatrices = [];

});

parcelRegister("ejQPp", function(module, exports) {

$parcel$export(module.exports, "EngineStore", () => $a6cbd19ef6f666c3$export$56410c8371a1c0dc);

var $diGQf = parcelRequire("diGQf");
class $a6cbd19ef6f666c3$export$56410c8371a1c0dc {
    /**
     * Gets the latest created engine
     */ static get LastCreatedEngine() {
        if (this.Instances.length === 0) return null;
        return this.Instances[this.Instances.length - 1];
    }
    /**
     * Gets the latest created scene
     */ static get LastCreatedScene() {
        return this._LastCreatedScene;
    }
}
/** Gets the list of created engines */ $a6cbd19ef6f666c3$export$56410c8371a1c0dc.Instances = [];
/**
 * Notifies when an engine was disposed.
 * Mainly used for static/cache cleanup
 */ $a6cbd19ef6f666c3$export$56410c8371a1c0dc.OnEnginesDisposedObservable = new (0, $diGQf.Observable)();
/** @internal */ $a6cbd19ef6f666c3$export$56410c8371a1c0dc._LastCreatedScene = null;
/**
 * Gets or sets a global variable indicating if fallback texture must be used when a texture cannot be loaded
 * @ignorenaming
 */ $a6cbd19ef6f666c3$export$56410c8371a1c0dc.UseFallbackTexture = true;
/**
 * Texture content used if a texture cannot loaded
 * @ignorenaming
 */ $a6cbd19ef6f666c3$export$56410c8371a1c0dc.FallbackTexture = "";

});

parcelRegister("iosaP", function(module, exports) {

$parcel$export(module.exports, "WithinEpsilon", () => $d6405296de9267dd$export$af7aa7c6a365352b);
$parcel$export(module.exports, "RandomRange", () => $d6405296de9267dd$export$b784f163cb360c55);
$parcel$export(module.exports, "Lerp", () => $d6405296de9267dd$export$30e52872ef59c897);
$parcel$export(module.exports, "Clamp", () => $d6405296de9267dd$export$90534cad35a14134);
$parcel$export(module.exports, "NormalizeRadians", () => $d6405296de9267dd$export$f5cbed47313e4153);
$parcel$export(module.exports, "ToHex", () => $d6405296de9267dd$export$6a3297bb326da27e);
/**
 * Extract int value
 * @param value number value
 * @returns int value
 */ function $d6405296de9267dd$export$1b7c609baaf2a9d3(value) {
    return parseInt(value.toString().replace(/\W/g, ""));
}
function $d6405296de9267dd$export$af7aa7c6a365352b(a, b, epsilon = 1.401298e-45) {
    return Math.abs(a - b) <= epsilon;
}
function $d6405296de9267dd$export$b784f163cb360c55(min, max) {
    if (min === max) return min;
    return Math.random() * (max - min) + min;
}
function $d6405296de9267dd$export$30e52872ef59c897(start, end, amount) {
    return start + (end - start) * amount;
}
function $d6405296de9267dd$export$90534cad35a14134(value, min = 0, max = 1) {
    return Math.min(max, Math.max(min, value));
}
function $d6405296de9267dd$export$f5cbed47313e4153(angle) {
    // More precise but slower version kept for reference.
    // angle = angle % Tools.TwoPi;
    // angle = (angle + Tools.TwoPi) % Tools.TwoPi;
    //if (angle > Math.PI) {
    //	angle -= Tools.TwoPi;
    //}
    angle -= Math.PI * 2 * Math.floor((angle + Math.PI) / (Math.PI * 2));
    return angle;
}
function $d6405296de9267dd$export$6a3297bb326da27e(i) {
    const str = i.toString(16);
    if (i <= 15) return ("0" + str).toUpperCase();
    return str.toUpperCase();
}

});


parcelRegister("7etnY", function(module, exports) {

$parcel$export(module.exports, "Color3", () => $5440a29da7c4a7fe$export$b3ff593cf6d17bf0);
$parcel$export(module.exports, "Color4", () => $5440a29da7c4a7fe$export$cb7e366859c95cb0);
$parcel$export(module.exports, "TmpColors", () => $5440a29da7c4a7fe$export$22fd4211f9ff6a1d);

var $1VEEL = parcelRequire("1VEEL");

var $iosaP = parcelRequire("iosaP");

var $53VPf = parcelRequire("53VPf");

var $opFp4 = parcelRequire("opFp4");

var $8DoUR = parcelRequire("8DoUR");
function $5440a29da7c4a7fe$var$colorChannelToLinearSpace(color) {
    return Math.pow(color, (0, $53VPf.ToLinearSpace));
}
function $5440a29da7c4a7fe$var$colorChannelToLinearSpaceExact(color) {
    if (color <= 0.04045) return 0.0773993808 * color;
    return Math.pow(0.947867299 * (color + 0.055), 2.4);
}
function $5440a29da7c4a7fe$var$colorChannelToGammaSpace(color) {
    return Math.pow(color, (0, $53VPf.ToGammaSpace));
}
function $5440a29da7c4a7fe$var$colorChannelToGammaSpaceExact(color) {
    if (color <= 0.0031308) return 12.92 * color;
    return 1.055 * Math.pow(color, 0.41666) - 0.055;
}
class $5440a29da7c4a7fe$export$b3ff593cf6d17bf0 {
    /**
     * Creates a new Color3 object from red, green, blue values, all between 0 and 1
     * @param r defines the red component (between 0 and 1, default is 0)
     * @param g defines the green component (between 0 and 1, default is 0)
     * @param b defines the blue component (between 0 and 1, default is 0)
     */ constructor(/**
     * Defines the red component (between 0 and 1, default is 0)
     */ r = 0, /**
     * Defines the green component (between 0 and 1, default is 0)
     */ g = 0, /**
     * Defines the blue component (between 0 and 1, default is 0)
     */ b = 0){
        this.r = r;
        this.g = g;
        this.b = b;
    }
    /**
     * Creates a string with the Color3 current values
     * @returns the string representation of the Color3 object
     */ toString() {
        return "{R: " + this.r + " G:" + this.g + " B:" + this.b + "}";
    }
    /**
     * Returns the string "Color3"
     * @returns "Color3"
     */ getClassName() {
        return "Color3";
    }
    /**
     * Compute the Color3 hash code
     * @returns an unique number that can be used to hash Color3 objects
     */ getHashCode() {
        let hash = this.r * 255 | 0;
        hash = hash * 397 ^ (this.g * 255 | 0);
        hash = hash * 397 ^ (this.b * 255 | 0);
        return hash;
    }
    // Operators
    /**
     * Stores in the given array from the given starting index the red, green, blue values as successive elements
     * @param array defines the array where to store the r,g,b components
     * @param index defines an optional index in the target array to define where to start storing values
     * @returns the current Color3 object
     */ toArray(array, index = 0) {
        array[index] = this.r;
        array[index + 1] = this.g;
        array[index + 2] = this.b;
        return this;
    }
    /**
     * Update the current color with values stored in an array from the starting index of the given array
     * @param array defines the source array
     * @param offset defines an offset in the source array
     * @returns the current Color3 object
     */ fromArray(array, offset = 0) {
        $5440a29da7c4a7fe$export$b3ff593cf6d17bf0.FromArrayToRef(array, offset, this);
        return this;
    }
    /**
     * Returns a new Color4 object from the current Color3 and the given alpha
     * @param alpha defines the alpha component on the new Color4 object (default is 1)
     * @returns a new Color4 object
     */ toColor4(alpha = 1) {
        return new $5440a29da7c4a7fe$export$cb7e366859c95cb0(this.r, this.g, this.b, alpha);
    }
    /**
     * Returns a new array populated with 3 numeric elements : red, green and blue values
     * @returns the new array
     */ asArray() {
        return [
            this.r,
            this.g,
            this.b
        ];
    }
    /**
     * Returns the luminance value
     * @returns a float value
     */ toLuminance() {
        return this.r * 0.3 + this.g * 0.59 + this.b * 0.11;
    }
    /**
     * Multiply each Color3 rgb values by the given Color3 rgb values in a new Color3 object
     * @param otherColor defines the second operand
     * @returns the new Color3 object
     */ multiply(otherColor) {
        return new this.constructor(this.r * otherColor.r, this.g * otherColor.g, this.b * otherColor.b);
    }
    /**
     * Multiply the rgb values of the Color3 and the given Color3 and stores the result in the object "result"
     * @param otherColor defines the second operand
     * @param result defines the Color3 object where to store the result
     * @returns the result Color3
     */ multiplyToRef(otherColor, result) {
        result.r = this.r * otherColor.r;
        result.g = this.g * otherColor.g;
        result.b = this.b * otherColor.b;
        return result;
    }
    /**
     * Multiplies the current Color3 coordinates by the given ones
     * @param otherColor defines the second operand
     * @returns the current updated Color3
     */ multiplyInPlace(otherColor) {
        this.r *= otherColor.r;
        this.g *= otherColor.g;
        this.b *= otherColor.b;
        return this;
    }
    /**
     * Returns a new Color3 set with the result of the multiplication of the current Color3 coordinates by the given floats
     * @param r defines the r coordinate of the operand
     * @param g defines the g coordinate of the operand
     * @param b defines the b coordinate of the operand
     * @returns the new Color3
     */ multiplyByFloats(r, g, b) {
        return new this.constructor(this.r * r, this.g * g, this.b * b);
    }
    /**
     * @internal
     * Do not use
     */ divide(_other) {
        throw new ReferenceError("Can not divide a color");
    }
    /**
     * @internal
     * Do not use
     */ divideToRef(_other, _result) {
        throw new ReferenceError("Can not divide a color");
    }
    /**
     * @internal
     * Do not use
     */ divideInPlace(_other) {
        throw new ReferenceError("Can not divide a color");
    }
    /**
     * Updates the current Color3 with the minimal coordinate values between its and the given color ones
     * @param other defines the second operand
     * @returns the current updated Color3
     */ minimizeInPlace(other) {
        return this.minimizeInPlaceFromFloats(other.r, other.g, other.b);
    }
    /**
     * Updates the current Color3 with the maximal coordinate values between its and the given color ones.
     * @param other defines the second operand
     * @returns the current updated Color3
     */ maximizeInPlace(other) {
        return this.maximizeInPlaceFromFloats(other.r, other.g, other.b);
    }
    /**
     * Updates the current Color3 with the minimal coordinate values between its and the given coordinates
     * @param r defines the r coordinate of the operand
     * @param g defines the g coordinate of the operand
     * @param b defines the b coordinate of the operand
     * @returns the current updated Color3
     */ minimizeInPlaceFromFloats(r, g, b) {
        this.r = Math.min(r, this.r);
        this.g = Math.min(g, this.g);
        this.b = Math.min(b, this.b);
        return this;
    }
    /**
     * Updates the current Color3 with the maximal coordinate values between its and the given coordinates.
     * @param r defines the r coordinate of the operand
     * @param g defines the g coordinate of the operand
     * @param b defines the b coordinate of the operand
     * @returns the current updated Color3
     */ maximizeInPlaceFromFloats(r, g, b) {
        this.r = Math.max(r, this.r);
        this.g = Math.max(g, this.g);
        this.b = Math.max(b, this.b);
        return this;
    }
    /**
     * @internal
     * Do not use
     */ floorToRef(_result) {
        throw new ReferenceError("Can not floor a color");
    }
    /**
     * @internal
     * Do not use
     */ floor() {
        throw new ReferenceError("Can not floor a color");
    }
    /**
     * @internal
     * Do not use
     */ fractToRef(_result) {
        throw new ReferenceError("Can not fract a color");
    }
    /**
     * @internal
     * Do not use
     */ fract() {
        throw new ReferenceError("Can not fract a color");
    }
    /**
     * Determines equality between Color3 objects
     * @param otherColor defines the second operand
     * @returns true if the rgb values are equal to the given ones
     */ equals(otherColor) {
        return otherColor && this.r === otherColor.r && this.g === otherColor.g && this.b === otherColor.b;
    }
    /**
     * Alias for equalsToFloats
     * @param r red color component
     * @param g green color component
     * @param b blue color component
     * @returns boolean
     */ equalsFloats(r, g, b) {
        return this.equalsToFloats(r, g, b);
    }
    /**
     * Determines equality between the current Color3 object and a set of r,b,g values
     * @param r defines the red component to check
     * @param g defines the green component to check
     * @param b defines the blue component to check
     * @returns true if the rgb values are equal to the given ones
     */ equalsToFloats(r, g, b) {
        return this.r === r && this.g === g && this.b === b;
    }
    /**
     * Returns true if the current Color3 and the given color coordinates are distant less than epsilon
     * @param otherColor defines the second operand
     * @param epsilon defines the minimal distance to define values as equals
     * @returns true if both colors are distant less than epsilon
     */ equalsWithEpsilon(otherColor, epsilon = (0, $53VPf.Epsilon)) {
        return (0, $1VEEL.Scalar).WithinEpsilon(this.r, otherColor.r, epsilon) && (0, $1VEEL.Scalar).WithinEpsilon(this.g, otherColor.g, epsilon) && (0, $1VEEL.Scalar).WithinEpsilon(this.b, otherColor.b, epsilon);
    }
    /**
     * @internal
     * Do not use
     */ negate() {
        throw new ReferenceError("Can not negate a color");
    }
    /**
     * @internal
     * Do not use
     */ negateInPlace() {
        throw new ReferenceError("Can not negate a color");
    }
    /**
     * @internal
     * Do not use
     */ negateToRef(_result) {
        throw new ReferenceError("Can not negate a color");
    }
    /**
     * Creates a new Color3 with the current Color3 values multiplied by scale
     * @param scale defines the scaling factor to apply
     * @returns a new Color3 object
     */ scale(scale) {
        return new this.constructor(this.r * scale, this.g * scale, this.b * scale);
    }
    /**
     * Multiplies the Color3 values by the float "scale"
     * @param scale defines the scaling factor to apply
     * @returns the current updated Color3
     */ scaleInPlace(scale) {
        this.r *= scale;
        this.g *= scale;
        this.b *= scale;
        return this;
    }
    /**
     * Multiplies the rgb values by scale and stores the result into "result"
     * @param scale defines the scaling factor
     * @param result defines the Color3 object where to store the result
     * @returns the result Color3
     */ scaleToRef(scale, result) {
        result.r = this.r * scale;
        result.g = this.g * scale;
        result.b = this.b * scale;
        return result;
    }
    /**
     * Scale the current Color3 values by a factor and add the result to a given Color3
     * @param scale defines the scale factor
     * @param result defines color to store the result into
     * @returns the result Color3
     */ scaleAndAddToRef(scale, result) {
        result.r += this.r * scale;
        result.g += this.g * scale;
        result.b += this.b * scale;
        return result;
    }
    /**
     * Clamps the rgb values by the min and max values and stores the result into "result"
     * @param min defines minimum clamping value (default is 0)
     * @param max defines maximum clamping value (default is 1)
     * @param result defines color to store the result into
     * @returns the result Color3
     */ clampToRef(min = 0, max = 1, result) {
        result.r = (0, $iosaP.Clamp)(this.r, min, max);
        result.g = (0, $iosaP.Clamp)(this.g, min, max);
        result.b = (0, $iosaP.Clamp)(this.b, min, max);
        return result;
    }
    /**
     * Creates a new Color3 set with the added values of the current Color3 and of the given one
     * @param otherColor defines the second operand
     * @returns the new Color3
     */ add(otherColor) {
        return new this.constructor(this.r + otherColor.r, this.g + otherColor.g, this.b + otherColor.b);
    }
    /**
     * Adds the given color to the current Color3
     * @param otherColor defines the second operand
     * @returns the current updated Color3
     */ addInPlace(otherColor) {
        this.r += otherColor.r;
        this.g += otherColor.g;
        this.b += otherColor.b;
        return this;
    }
    /**
     * Adds the given coordinates to the current Color3
     * @param r defines the r coordinate of the operand
     * @param g defines the g coordinate of the operand
     * @param b defines the b coordinate of the operand
     * @returns the current updated Color3
     */ addInPlaceFromFloats(r, g, b) {
        this.r += r;
        this.g += g;
        this.b += b;
        return this;
    }
    /**
     * Stores the result of the addition of the current Color3 and given one rgb values into "result"
     * @param otherColor defines the second operand
     * @param result defines Color3 object to store the result into
     * @returns the unmodified current Color3
     */ addToRef(otherColor, result) {
        result.r = this.r + otherColor.r;
        result.g = this.g + otherColor.g;
        result.b = this.b + otherColor.b;
        return result;
    }
    /**
     * Returns a new Color3 set with the subtracted values of the given one from the current Color3
     * @param otherColor defines the second operand
     * @returns the new Color3
     */ subtract(otherColor) {
        return new this.constructor(this.r - otherColor.r, this.g - otherColor.g, this.b - otherColor.b);
    }
    /**
     * Stores the result of the subtraction of given one from the current Color3 rgb values into "result"
     * @param otherColor defines the second operand
     * @param result defines Color3 object to store the result into
     * @returns the unmodified current Color3
     */ subtractToRef(otherColor, result) {
        result.r = this.r - otherColor.r;
        result.g = this.g - otherColor.g;
        result.b = this.b - otherColor.b;
        return result;
    }
    /**
     * Subtract the given color from the current Color3
     * @param otherColor defines the second operand
     * @returns the current updated Color3
     */ subtractInPlace(otherColor) {
        this.r -= otherColor.r;
        this.g -= otherColor.g;
        this.b -= otherColor.b;
        return this;
    }
    /**
     * Returns a new Color3 set with the subtraction of the given floats from the current Color3 coordinates
     * @param r defines the r coordinate of the operand
     * @param g defines the g coordinate of the operand
     * @param b defines the b coordinate of the operand
     * @returns the resulting Color3
     */ subtractFromFloats(r, g, b) {
        return new this.constructor(this.r - r, this.g - g, this.b - b);
    }
    /**
     * Subtracts the given floats from the current Color3 coordinates and set the given color "result" with this result
     * @param r defines the r coordinate of the operand
     * @param g defines the g coordinate of the operand
     * @param b defines the b coordinate of the operand
     * @param result defines the Color3 object where to store the result
     * @returns the result
     */ subtractFromFloatsToRef(r, g, b, result) {
        return result.copyFromFloats(this.r - r, this.g - g, this.b - b);
    }
    /**
     * Copy the current object
     * @returns a new Color3 copied the current one
     */ clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    /**
     * Copies the rgb values from the source in the current Color3
     * @param source defines the source Color3 object
     * @returns the updated Color3 object
     */ copyFrom(source) {
        this.r = source.r;
        this.g = source.g;
        this.b = source.b;
        return this;
    }
    /**
     * Updates the Color3 rgb values from the given floats
     * @param r defines the red component to read from
     * @param g defines the green component to read from
     * @param b defines the blue component to read from
     * @returns the current Color3 object
     */ copyFromFloats(r, g, b) {
        this.r = r;
        this.g = g;
        this.b = b;
        return this;
    }
    /**
     * Updates the Color3 rgb values from the given floats
     * @param r defines the red component to read from
     * @param g defines the green component to read from
     * @param b defines the blue component to read from
     * @returns the current Color3 object
     */ set(r, g, b) {
        return this.copyFromFloats(r, g, b);
    }
    /**
     * Copies the given float to the current Color3 coordinates
     * @param v defines the r, g and b coordinates of the operand
     * @returns the current updated Color3
     */ setAll(v) {
        this.r = this.g = this.b = v;
        return this;
    }
    /**
     * Compute the Color3 hexadecimal code as a string
     * @returns a string containing the hexadecimal representation of the Color3 object
     */ toHexString() {
        const intR = Math.round(this.r * 255);
        const intG = Math.round(this.g * 255);
        const intB = Math.round(this.b * 255);
        return "#" + (0, $iosaP.ToHex)(intR) + (0, $iosaP.ToHex)(intG) + (0, $iosaP.ToHex)(intB);
    }
    /**
     * Converts current color in rgb space to HSV values
     * @returns a new color3 representing the HSV values
     */ toHSV() {
        const result = new this.constructor();
        this.toHSVToRef(result);
        return result;
    }
    /**
     * Converts current color in rgb space to HSV values
     * @param result defines the Color3 where to store the HSV values
     */ toHSVToRef(result) {
        const r = this.r;
        const g = this.g;
        const b = this.b;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let h = 0;
        let s = 0;
        const v = max;
        const dm = max - min;
        if (max !== 0) s = dm / max;
        if (max != min) {
            if (max == r) {
                h = (g - b) / dm;
                if (g < b) h += 6;
            } else if (max == g) h = (b - r) / dm + 2;
            else if (max == b) h = (r - g) / dm + 4;
            h *= 60;
        }
        result.r = h;
        result.g = s;
        result.b = v;
    }
    /**
     * Computes a new Color3 converted from the current one to linear space
     * @param exact defines if the conversion will be done in an exact way which is slower but more accurate (default is false)
     * @returns a new Color3 object
     */ toLinearSpace(exact = false) {
        const convertedColor = new this.constructor();
        this.toLinearSpaceToRef(convertedColor, exact);
        return convertedColor;
    }
    /**
     * Converts the Color3 values to linear space and stores the result in "convertedColor"
     * @param convertedColor defines the Color3 object where to store the linear space version
     * @param exact defines if the conversion will be done in an exact way which is slower but more accurate (default is false)
     * @returns the unmodified Color3
     */ toLinearSpaceToRef(convertedColor, exact = false) {
        if (exact) {
            convertedColor.r = $5440a29da7c4a7fe$var$colorChannelToLinearSpaceExact(this.r);
            convertedColor.g = $5440a29da7c4a7fe$var$colorChannelToLinearSpaceExact(this.g);
            convertedColor.b = $5440a29da7c4a7fe$var$colorChannelToLinearSpaceExact(this.b);
        } else {
            convertedColor.r = $5440a29da7c4a7fe$var$colorChannelToLinearSpace(this.r);
            convertedColor.g = $5440a29da7c4a7fe$var$colorChannelToLinearSpace(this.g);
            convertedColor.b = $5440a29da7c4a7fe$var$colorChannelToLinearSpace(this.b);
        }
        return this;
    }
    /**
     * Computes a new Color3 converted from the current one to gamma space
     * @param exact defines if the conversion will be done in an exact way which is slower but more accurate (default is false)
     * @returns a new Color3 object
     */ toGammaSpace(exact = false) {
        const convertedColor = new this.constructor();
        this.toGammaSpaceToRef(convertedColor, exact);
        return convertedColor;
    }
    /**
     * Converts the Color3 values to gamma space and stores the result in "convertedColor"
     * @param convertedColor defines the Color3 object where to store the gamma space version
     * @param exact defines if the conversion will be done in an exact way which is slower but more accurate (default is false)
     * @returns the unmodified Color3
     */ toGammaSpaceToRef(convertedColor, exact = false) {
        if (exact) {
            convertedColor.r = $5440a29da7c4a7fe$var$colorChannelToGammaSpaceExact(this.r);
            convertedColor.g = $5440a29da7c4a7fe$var$colorChannelToGammaSpaceExact(this.g);
            convertedColor.b = $5440a29da7c4a7fe$var$colorChannelToGammaSpaceExact(this.b);
        } else {
            convertedColor.r = $5440a29da7c4a7fe$var$colorChannelToGammaSpace(this.r);
            convertedColor.g = $5440a29da7c4a7fe$var$colorChannelToGammaSpace(this.g);
            convertedColor.b = $5440a29da7c4a7fe$var$colorChannelToGammaSpace(this.b);
        }
        return this;
    }
    /**
     * Converts Hue, saturation and value to a Color3 (RGB)
     * @param hue defines the hue (value between 0 and 360)
     * @param saturation defines the saturation (value between 0 and 1)
     * @param value defines the value (value between 0 and 1)
     * @param result defines the Color3 where to store the RGB values
     */ static HSVtoRGBToRef(hue, saturation, value, result) {
        const chroma = value * saturation;
        const h = hue / 60;
        const x = chroma * (1 - Math.abs(h % 2 - 1));
        let r = 0;
        let g = 0;
        let b = 0;
        if (h >= 0 && h <= 1) {
            r = chroma;
            g = x;
        } else if (h >= 1 && h <= 2) {
            r = x;
            g = chroma;
        } else if (h >= 2 && h <= 3) {
            g = chroma;
            b = x;
        } else if (h >= 3 && h <= 4) {
            g = x;
            b = chroma;
        } else if (h >= 4 && h <= 5) {
            r = x;
            b = chroma;
        } else if (h >= 5 && h <= 6) {
            r = chroma;
            b = x;
        }
        const m = value - chroma;
        result.set(r + m, g + m, b + m);
    }
    /**
     * Converts Hue, saturation and value to a new Color3 (RGB)
     * @param hue defines the hue (value between 0 and 360)
     * @param saturation defines the saturation (value between 0 and 1)
     * @param value defines the value (value between 0 and 1)
     * @returns a new Color3 object
     */ static FromHSV(hue, saturation, value) {
        const result = new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(0, 0, 0);
        $5440a29da7c4a7fe$export$b3ff593cf6d17bf0.HSVtoRGBToRef(hue, saturation, value, result);
        return result;
    }
    /**
     * Creates a new Color3 from the string containing valid hexadecimal values
     * @param hex defines a string containing valid hexadecimal values
     * @returns a new Color3 object
     */ static FromHexString(hex) {
        if (hex.substring(0, 1) !== "#" || hex.length !== 7) return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(0, 0, 0);
        const r = parseInt(hex.substring(1, 3), 16);
        const g = parseInt(hex.substring(3, 5), 16);
        const b = parseInt(hex.substring(5, 7), 16);
        return $5440a29da7c4a7fe$export$b3ff593cf6d17bf0.FromInts(r, g, b);
    }
    /**
     * Creates a new Color3 from the starting index of the given array
     * @param array defines the source array
     * @param offset defines an offset in the source array
     * @returns a new Color3 object
     */ static FromArray(array, offset = 0) {
        return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(array[offset], array[offset + 1], array[offset + 2]);
    }
    /**
     * Creates a new Color3 from the starting index element of the given array
     * @param array defines the source array to read from
     * @param offset defines the offset in the source array
     * @param result defines the target Color3 object
     */ static FromArrayToRef(array, offset = 0, result) {
        result.r = array[offset];
        result.g = array[offset + 1];
        result.b = array[offset + 2];
    }
    /**
     * Creates a new Color3 from integer values (\< 256)
     * @param r defines the red component to read from (value between 0 and 255)
     * @param g defines the green component to read from (value between 0 and 255)
     * @param b defines the blue component to read from (value between 0 and 255)
     * @returns a new Color3 object
     */ static FromInts(r, g, b) {
        return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(r / 255.0, g / 255.0, b / 255.0);
    }
    /**
     * Creates a new Color3 with values linearly interpolated of "amount" between the start Color3 and the end Color3
     * @param start defines the start Color3 value
     * @param end defines the end Color3 value
     * @param amount defines the gradient value between start and end
     * @returns a new Color3 object
     */ static Lerp(start, end, amount) {
        const result = new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(0.0, 0.0, 0.0);
        $5440a29da7c4a7fe$export$b3ff593cf6d17bf0.LerpToRef(start, end, amount, result);
        return result;
    }
    /**
     * Creates a new Color3 with values linearly interpolated of "amount" between the start Color3 and the end Color3
     * @param left defines the start value
     * @param right defines the end value
     * @param amount defines the gradient factor
     * @param result defines the Color3 object where to store the result
     */ static LerpToRef(left, right, amount, result) {
        result.r = left.r + (right.r - left.r) * amount;
        result.g = left.g + (right.g - left.g) * amount;
        result.b = left.b + (right.b - left.b) * amount;
    }
    /**
     * Returns a new Color3 located for "amount" (float) on the Hermite interpolation spline defined by the vectors "value1", "tangent1", "value2", "tangent2"
     * @param value1 defines the first control point
     * @param tangent1 defines the first tangent Color3
     * @param value2 defines the second control point
     * @param tangent2 defines the second tangent Color3
     * @param amount defines the amount on the interpolation spline (between 0 and 1)
     * @returns the new Color3
     */ static Hermite(value1, tangent1, value2, tangent2, amount) {
        const squared = amount * amount;
        const cubed = amount * squared;
        const part1 = 2.0 * cubed - 3.0 * squared + 1.0;
        const part2 = -2 * cubed + 3.0 * squared;
        const part3 = cubed - 2.0 * squared + amount;
        const part4 = cubed - squared;
        const r = value1.r * part1 + value2.r * part2 + tangent1.r * part3 + tangent2.r * part4;
        const g = value1.g * part1 + value2.g * part2 + tangent1.g * part3 + tangent2.g * part4;
        const b = value1.b * part1 + value2.b * part2 + tangent1.b * part3 + tangent2.b * part4;
        return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(r, g, b);
    }
    /**
     * Returns a new Color3 which is the 1st derivative of the Hermite spline defined by the colors "value1", "value2", "tangent1", "tangent2".
     * @param value1 defines the first control point
     * @param tangent1 defines the first tangent
     * @param value2 defines the second control point
     * @param tangent2 defines the second tangent
     * @param time define where the derivative must be done
     * @returns 1st derivative
     */ static Hermite1stDerivative(value1, tangent1, value2, tangent2, time) {
        const result = $5440a29da7c4a7fe$export$b3ff593cf6d17bf0.Black();
        this.Hermite1stDerivativeToRef(value1, tangent1, value2, tangent2, time, result);
        return result;
    }
    /**
     * Returns a new Color3 which is the 1st derivative of the Hermite spline defined by the colors "value1", "value2", "tangent1", "tangent2".
     * @param value1 defines the first control point
     * @param tangent1 defines the first tangent
     * @param value2 defines the second control point
     * @param tangent2 defines the second tangent
     * @param time define where the derivative must be done
     * @param result define where to store the derivative
     */ static Hermite1stDerivativeToRef(value1, tangent1, value2, tangent2, time, result) {
        const t2 = time * time;
        result.r = (t2 - time) * 6 * value1.r + (3 * t2 - 4 * time + 1) * tangent1.r + (-t2 + time) * 6 * value2.r + (3 * t2 - 2 * time) * tangent2.r;
        result.g = (t2 - time) * 6 * value1.g + (3 * t2 - 4 * time + 1) * tangent1.g + (-t2 + time) * 6 * value2.g + (3 * t2 - 2 * time) * tangent2.g;
        result.b = (t2 - time) * 6 * value1.b + (3 * t2 - 4 * time + 1) * tangent1.b + (-t2 + time) * 6 * value2.b + (3 * t2 - 2 * time) * tangent2.b;
    }
    /**
     * Returns a Color3 value containing a red color
     * @returns a new Color3 object
     */ static Red() {
        return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(1, 0, 0);
    }
    /**
     * Returns a Color3 value containing a green color
     * @returns a new Color3 object
     */ static Green() {
        return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(0, 1, 0);
    }
    /**
     * Returns a Color3 value containing a blue color
     * @returns a new Color3 object
     */ static Blue() {
        return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(0, 0, 1);
    }
    /**
     * Returns a Color3 value containing a black color
     * @returns a new Color3 object
     */ static Black() {
        return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(0, 0, 0);
    }
    /**
     * Gets a Color3 value containing a black color that must not be updated
     */ static get BlackReadOnly() {
        return $5440a29da7c4a7fe$export$b3ff593cf6d17bf0._BlackReadOnly;
    }
    /**
     * Returns a Color3 value containing a white color
     * @returns a new Color3 object
     */ static White() {
        return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(1, 1, 1);
    }
    /**
     * Returns a Color3 value containing a purple color
     * @returns a new Color3 object
     */ static Purple() {
        return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(0.5, 0, 0.5);
    }
    /**
     * Returns a Color3 value containing a magenta color
     * @returns a new Color3 object
     */ static Magenta() {
        return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(1, 0, 1);
    }
    /**
     * Returns a Color3 value containing a yellow color
     * @returns a new Color3 object
     */ static Yellow() {
        return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(1, 1, 0);
    }
    /**
     * Returns a Color3 value containing a gray color
     * @returns a new Color3 object
     */ static Gray() {
        return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(0.5, 0.5, 0.5);
    }
    /**
     * Returns a Color3 value containing a teal color
     * @returns a new Color3 object
     */ static Teal() {
        return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(0, 1.0, 1.0);
    }
    /**
     * Returns a Color3 value containing a random color
     * @returns a new Color3 object
     */ static Random() {
        return new $5440a29da7c4a7fe$export$b3ff593cf6d17bf0(Math.random(), Math.random(), Math.random());
    }
}
// Statics
$5440a29da7c4a7fe$export$b3ff593cf6d17bf0._BlackReadOnly = $5440a29da7c4a7fe$export$b3ff593cf6d17bf0.Black();
Object.defineProperties($5440a29da7c4a7fe$export$b3ff593cf6d17bf0.prototype, {
    dimension: {
        value: [
            3
        ]
    },
    rank: {
        value: 1
    }
});
class $5440a29da7c4a7fe$export$cb7e366859c95cb0 {
    /**
     * Creates a new Color4 object from red, green, blue values, all between 0 and 1
     * @param r defines the red component (between 0 and 1, default is 0)
     * @param g defines the green component (between 0 and 1, default is 0)
     * @param b defines the blue component (between 0 and 1, default is 0)
     * @param a defines the alpha component (between 0 and 1, default is 1)
     */ constructor(/**
     * Defines the red component (between 0 and 1, default is 0)
     */ r = 0, /**
     * Defines the green component (between 0 and 1, default is 0)
     */ g = 0, /**
     * Defines the blue component (between 0 and 1, default is 0)
     */ b = 0, /**
     * Defines the alpha component (between 0 and 1, default is 1)
     */ a = 1){
        this.r = r;
        this.g = g;
        this.b = b;
        this.a = a;
    }
    // Operators
    /**
     * Creates a new array populated with 4 numeric elements : red, green, blue, alpha values
     * @returns the new array
     */ asArray() {
        return [
            this.r,
            this.g,
            this.b,
            this.a
        ];
    }
    /**
     * Stores from the starting index in the given array the Color4 successive values
     * @param array defines the array where to store the r,g,b components
     * @param index defines an optional index in the target array to define where to start storing values
     * @returns the current Color4 object
     */ toArray(array, index = 0) {
        array[index] = this.r;
        array[index + 1] = this.g;
        array[index + 2] = this.b;
        array[index + 3] = this.a;
        return this;
    }
    /**
     * Update the current color with values stored in an array from the starting index of the given array
     * @param array defines the source array
     * @param offset defines an offset in the source array
     * @returns the current Color4 object
     */ fromArray(array, offset = 0) {
        this.r = array[offset];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        this.a = array[offset + 3];
        return this;
    }
    /**
     * Determines equality between Color4 objects
     * @param otherColor defines the second operand
     * @returns true if the rgba values are equal to the given ones
     */ equals(otherColor) {
        return otherColor && this.r === otherColor.r && this.g === otherColor.g && this.b === otherColor.b && this.a === otherColor.a;
    }
    /**
     * Creates a new Color4 set with the added values of the current Color4 and of the given one
     * @param otherColor defines the second operand
     * @returns a new Color4 object
     */ add(otherColor) {
        return new this.constructor(this.r + otherColor.r, this.g + otherColor.g, this.b + otherColor.b, this.a + otherColor.a);
    }
    /**
     * Updates the given color "result" with the result of the addition of the current Color4 and the given one.
     * @param otherColor the color to add
     * @param result the color to store the result
     * @returns result input
     */ addToRef(otherColor, result) {
        result.r = this.r + otherColor.r;
        result.g = this.g + otherColor.g;
        result.b = this.b + otherColor.b;
        result.a = this.a + otherColor.a;
        return result;
    }
    /**
     * Adds in place the given Color4 values to the current Color4 object
     * @param otherColor defines the second operand
     * @returns the current updated Color4 object
     */ addInPlace(otherColor) {
        this.r += otherColor.r;
        this.g += otherColor.g;
        this.b += otherColor.b;
        this.a += otherColor.a;
        return this;
    }
    /**
     * Adds the given coordinates to the current Color4
     * @param r defines the r coordinate of the operand
     * @param g defines the g coordinate of the operand
     * @param b defines the b coordinate of the operand
     * @param a defines the a coordinate of the operand
     * @returns the current updated Color4
     */ addInPlaceFromFloats(r, g, b, a) {
        this.r += r;
        this.g += g;
        this.b += b;
        this.a += a;
        return this;
    }
    /**
     * Creates a new Color4 set with the subtracted values of the given one from the current Color4
     * @param otherColor defines the second operand
     * @returns a new Color4 object
     */ subtract(otherColor) {
        return new this.constructor(this.r - otherColor.r, this.g - otherColor.g, this.b - otherColor.b, this.a - otherColor.a);
    }
    /**
     * Subtracts the given ones from the current Color4 values and stores the results in "result"
     * @param otherColor defines the second operand
     * @param result defines the Color4 object where to store the result
     * @returns the result Color4 object
     */ subtractToRef(otherColor, result) {
        result.r = this.r - otherColor.r;
        result.g = this.g - otherColor.g;
        result.b = this.b - otherColor.b;
        result.a = this.a - otherColor.a;
        return result;
    }
    /**
     * Subtract in place the given color from the current Color4.
     * @param otherColor the color to subtract
     * @returns the updated Color4.
     */ subtractInPlace(otherColor) {
        this.r -= otherColor.r;
        this.g -= otherColor.g;
        this.b -= otherColor.b;
        this.a -= otherColor.a;
        return this;
    }
    /**
     * Returns a new Color4 set with the result of the subtraction of the given floats from the current Color4 coordinates.
     * @param r value to subtract
     * @param g value to subtract
     * @param b value to subtract
     * @param a value to subtract
     * @returns new color containing the result
     */ subtractFromFloats(r, g, b, a) {
        return new this.constructor(this.r - r, this.g - g, this.b - b, this.a - a);
    }
    /**
     * Sets the given color "result" set with the result of the subtraction of the given floats from the current Color4 coordinates.
     * @param r value to subtract
     * @param g value to subtract
     * @param b value to subtract
     * @param a value to subtract
     * @param result the color to store the result in
     * @returns result input
     */ subtractFromFloatsToRef(r, g, b, a, result) {
        result.r = this.r - r;
        result.g = this.g - g;
        result.b = this.b - b;
        result.a = this.a - a;
        return result;
    }
    /**
     * Creates a new Color4 with the current Color4 values multiplied by scale
     * @param scale defines the scaling factor to apply
     * @returns a new Color4 object
     */ scale(scale) {
        return new this.constructor(this.r * scale, this.g * scale, this.b * scale, this.a * scale);
    }
    /**
     * Multiplies the Color4 values by the float "scale"
     * @param scale defines the scaling factor to apply
     * @returns the current updated Color4
     */ scaleInPlace(scale) {
        this.r *= scale;
        this.g *= scale;
        this.b *= scale;
        this.a *= scale;
        return this;
    }
    /**
     * Multiplies the current Color4 values by scale and stores the result in "result"
     * @param scale defines the scaling factor to apply
     * @param result defines the Color4 object where to store the result
     * @returns the result Color4
     */ scaleToRef(scale, result) {
        result.r = this.r * scale;
        result.g = this.g * scale;
        result.b = this.b * scale;
        result.a = this.a * scale;
        return result;
    }
    /**
     * Scale the current Color4 values by a factor and add the result to a given Color4
     * @param scale defines the scale factor
     * @param result defines the Color4 object where to store the result
     * @returns the result Color4
     */ scaleAndAddToRef(scale, result) {
        result.r += this.r * scale;
        result.g += this.g * scale;
        result.b += this.b * scale;
        result.a += this.a * scale;
        return result;
    }
    /**
     * Clamps the rgb values by the min and max values and stores the result into "result"
     * @param min defines minimum clamping value (default is 0)
     * @param max defines maximum clamping value (default is 1)
     * @param result defines color to store the result into.
     * @returns the result Color4
     */ clampToRef(min = 0, max = 1, result) {
        result.r = (0, $iosaP.Clamp)(this.r, min, max);
        result.g = (0, $iosaP.Clamp)(this.g, min, max);
        result.b = (0, $iosaP.Clamp)(this.b, min, max);
        result.a = (0, $iosaP.Clamp)(this.a, min, max);
        return result;
    }
    /**
     * Multiply an Color4 value by another and return a new Color4 object
     * @param color defines the Color4 value to multiply by
     * @returns a new Color4 object
     */ multiply(color) {
        return new this.constructor(this.r * color.r, this.g * color.g, this.b * color.b, this.a * color.a);
    }
    /**
     * Multiply a Color4 value by another and push the result in a reference value
     * @param color defines the Color4 value to multiply by
     * @param result defines the Color4 to fill the result in
     * @returns the result Color4
     */ multiplyToRef(color, result) {
        result.r = this.r * color.r;
        result.g = this.g * color.g;
        result.b = this.b * color.b;
        result.a = this.a * color.a;
        return result;
    }
    /**
     * Multiplies in place the current Color4 by the given one.
     * @param otherColor color to multiple with
     * @returns the updated Color4.
     */ multiplyInPlace(otherColor) {
        this.r *= otherColor.r;
        this.g *= otherColor.g;
        this.b *= otherColor.b;
        this.a *= otherColor.a;
        return this;
    }
    /**
     * Returns a new Color4 set with the multiplication result of the given floats and the current Color4 coordinates.
     * @param r value multiply with
     * @param g value multiply with
     * @param b value multiply with
     * @param a value multiply with
     * @returns resulting new color
     */ multiplyByFloats(r, g, b, a) {
        return new this.constructor(this.r * r, this.g * g, this.b * b, this.a * a);
    }
    /**
     * @internal
     * Do not use
     */ divide(_other) {
        throw new ReferenceError("Can not divide a color");
    }
    /**
     * @internal
     * Do not use
     */ divideToRef(_other, _result) {
        throw new ReferenceError("Can not divide a color");
    }
    /**
     * @internal
     * Do not use
     */ divideInPlace(_other) {
        throw new ReferenceError("Can not divide a color");
    }
    /**
     * Updates the Color4 coordinates with the minimum values between its own and the given color ones
     * @param other defines the second operand
     * @returns the current updated Color4
     */ minimizeInPlace(other) {
        this.r = Math.min(this.r, other.r);
        this.g = Math.min(this.g, other.g);
        this.b = Math.min(this.b, other.b);
        this.a = Math.min(this.a, other.a);
        return this;
    }
    /**
     * Updates the Color4 coordinates with the maximum values between its own and the given color ones
     * @param other defines the second operand
     * @returns the current updated Color4
     */ maximizeInPlace(other) {
        this.r = Math.max(this.r, other.r);
        this.g = Math.max(this.g, other.g);
        this.b = Math.max(this.b, other.b);
        this.a = Math.max(this.a, other.a);
        return this;
    }
    /**
     * Updates the current Color4 with the minimal coordinate values between its and the given coordinates
     * @param r defines the r coordinate of the operand
     * @param g defines the g coordinate of the operand
     * @param b defines the b coordinate of the operand
     * @param a defines the a coordinate of the operand
     * @returns the current updated Color4
     */ minimizeInPlaceFromFloats(r, g, b, a) {
        this.r = Math.min(r, this.r);
        this.g = Math.min(g, this.g);
        this.b = Math.min(b, this.b);
        this.a = Math.min(a, this.a);
        return this;
    }
    /**
     * Updates the current Color4 with the maximal coordinate values between its and the given coordinates.
     * @param r defines the r coordinate of the operand
     * @param g defines the g coordinate of the operand
     * @param b defines the b coordinate of the operand
     * @param a defines the a coordinate of the operand
     * @returns the current updated Color4
     */ maximizeInPlaceFromFloats(r, g, b, a) {
        this.r = Math.max(r, this.r);
        this.g = Math.max(g, this.g);
        this.b = Math.max(b, this.b);
        this.a = Math.max(a, this.a);
        return this;
    }
    /**
     * @internal
     * Do not use
     */ floorToRef(_result) {
        throw new ReferenceError("Can not floor a color");
    }
    /**
     * @internal
     * Do not use
     */ floor() {
        throw new ReferenceError("Can not floor a color");
    }
    /**
     * @internal
     * Do not use
     */ fractToRef(_result) {
        throw new ReferenceError("Can not fract a color");
    }
    /**
     * @internal
     * Do not use
     */ fract() {
        throw new ReferenceError("Can not fract a color");
    }
    /**
     * @internal
     * Do not use
     */ negate() {
        throw new ReferenceError("Can not negate a color");
    }
    /**
     * @internal
     * Do not use
     */ negateInPlace() {
        throw new ReferenceError("Can not negate a color");
    }
    /**
     * @internal
     * Do not use
     */ negateToRef(_result) {
        throw new ReferenceError("Can not negate a color");
    }
    /**
     * Boolean : True if the current Color4 coordinates are each beneath the distance "epsilon" from the given color ones.
     * @param otherColor color to compare against
     * @param epsilon (Default: very small number)
     * @returns true if they are equal
     */ equalsWithEpsilon(otherColor, epsilon = (0, $53VPf.Epsilon)) {
        return (0, $1VEEL.Scalar).WithinEpsilon(this.r, otherColor.r, epsilon) && (0, $1VEEL.Scalar).WithinEpsilon(this.g, otherColor.g, epsilon) && (0, $1VEEL.Scalar).WithinEpsilon(this.b, otherColor.b, epsilon) && (0, $1VEEL.Scalar).WithinEpsilon(this.a, otherColor.a, epsilon);
    }
    /**
     * Boolean : True if the given floats are strictly equal to the current Color4 coordinates.
     * @param x x value to compare against
     * @param y y value to compare against
     * @param z z value to compare against
     * @param w w value to compare against
     * @returns true if equal
     */ equalsToFloats(x, y, z, w) {
        return this.r === x && this.g === y && this.b === z && this.a === w;
    }
    /**
     * Creates a string with the Color4 current values
     * @returns the string representation of the Color4 object
     */ toString() {
        return "{R: " + this.r + " G:" + this.g + " B:" + this.b + " A:" + this.a + "}";
    }
    /**
     * Returns the string "Color4"
     * @returns "Color4"
     */ getClassName() {
        return "Color4";
    }
    /**
     * Compute the Color4 hash code
     * @returns an unique number that can be used to hash Color4 objects
     */ getHashCode() {
        let hash = this.r * 255 | 0;
        hash = hash * 397 ^ (this.g * 255 | 0);
        hash = hash * 397 ^ (this.b * 255 | 0);
        hash = hash * 397 ^ (this.a * 255 | 0);
        return hash;
    }
    /**
     * Creates a new Color4 copied from the current one
     * @returns a new Color4 object
     */ clone() {
        const result = new this.constructor();
        return result.copyFrom(this);
    }
    /**
     * Copies the given Color4 values into the current one
     * @param source defines the source Color4 object
     * @returns the current updated Color4 object
     */ copyFrom(source) {
        this.r = source.r;
        this.g = source.g;
        this.b = source.b;
        this.a = source.a;
        return this;
    }
    /**
     * Copies the given float values into the current one
     * @param r defines the red component to read from
     * @param g defines the green component to read from
     * @param b defines the blue component to read from
     * @param a defines the alpha component to read from
     * @returns the current updated Color4 object
     */ copyFromFloats(r, g, b, a) {
        this.r = r;
        this.g = g;
        this.b = b;
        this.a = a;
        return this;
    }
    /**
     * Copies the given float values into the current one
     * @param r defines the red component to read from
     * @param g defines the green component to read from
     * @param b defines the blue component to read from
     * @param a defines the alpha component to read from
     * @returns the current updated Color4 object
     */ set(r, g, b, a) {
        return this.copyFromFloats(r, g, b, a);
    }
    /**
     * Copies the given float to the current Vector4 coordinates
     * @param v defines the r, g, b, and a coordinates of the operand
     * @returns the current updated Vector4
     */ setAll(v) {
        this.r = this.g = this.b = this.a = v;
        return this;
    }
    /**
     * Compute the Color4 hexadecimal code as a string
     * @param returnAsColor3 defines if the string should only contains RGB values (off by default)
     * @returns a string containing the hexadecimal representation of the Color4 object
     */ toHexString(returnAsColor3 = false) {
        const intR = Math.round(this.r * 255);
        const intG = Math.round(this.g * 255);
        const intB = Math.round(this.b * 255);
        if (returnAsColor3) return "#" + (0, $iosaP.ToHex)(intR) + (0, $iosaP.ToHex)(intG) + (0, $iosaP.ToHex)(intB);
        const intA = Math.round(this.a * 255);
        return "#" + (0, $iosaP.ToHex)(intR) + (0, $iosaP.ToHex)(intG) + (0, $iosaP.ToHex)(intB) + (0, $iosaP.ToHex)(intA);
    }
    /**
     * Computes a new Color4 converted from the current one to linear space
     * @param exact defines if the conversion will be done in an exact way which is slower but more accurate (default is false)
     * @returns a new Color4 object
     */ toLinearSpace(exact = false) {
        const convertedColor = new $5440a29da7c4a7fe$export$cb7e366859c95cb0();
        this.toLinearSpaceToRef(convertedColor, exact);
        return convertedColor;
    }
    /**
     * Converts the Color4 values to linear space and stores the result in "convertedColor"
     * @param convertedColor defines the Color4 object where to store the linear space version
     * @param exact defines if the conversion will be done in an exact way which is slower but more accurate (default is false)
     * @returns the unmodified Color4
     */ toLinearSpaceToRef(convertedColor, exact = false) {
        if (exact) {
            convertedColor.r = $5440a29da7c4a7fe$var$colorChannelToLinearSpaceExact(this.r);
            convertedColor.g = $5440a29da7c4a7fe$var$colorChannelToLinearSpaceExact(this.g);
            convertedColor.b = $5440a29da7c4a7fe$var$colorChannelToLinearSpaceExact(this.b);
        } else {
            convertedColor.r = $5440a29da7c4a7fe$var$colorChannelToLinearSpace(this.r);
            convertedColor.g = $5440a29da7c4a7fe$var$colorChannelToLinearSpace(this.g);
            convertedColor.b = $5440a29da7c4a7fe$var$colorChannelToLinearSpace(this.b);
        }
        convertedColor.a = this.a;
        return this;
    }
    /**
     * Computes a new Color4 converted from the current one to gamma space
     * @param exact defines if the conversion will be done in an exact way which is slower but more accurate (default is false)
     * @returns a new Color4 object
     */ toGammaSpace(exact = false) {
        const convertedColor = new $5440a29da7c4a7fe$export$cb7e366859c95cb0();
        this.toGammaSpaceToRef(convertedColor, exact);
        return convertedColor;
    }
    /**
     * Converts the Color4 values to gamma space and stores the result in "convertedColor"
     * @param convertedColor defines the Color4 object where to store the gamma space version
     * @param exact defines if the conversion will be done in an exact way which is slower but more accurate (default is false)
     * @returns the unmodified Color4
     */ toGammaSpaceToRef(convertedColor, exact = false) {
        if (exact) {
            convertedColor.r = $5440a29da7c4a7fe$var$colorChannelToGammaSpaceExact(this.r);
            convertedColor.g = $5440a29da7c4a7fe$var$colorChannelToGammaSpaceExact(this.g);
            convertedColor.b = $5440a29da7c4a7fe$var$colorChannelToGammaSpaceExact(this.b);
        } else {
            convertedColor.r = $5440a29da7c4a7fe$var$colorChannelToGammaSpace(this.r);
            convertedColor.g = $5440a29da7c4a7fe$var$colorChannelToGammaSpace(this.g);
            convertedColor.b = $5440a29da7c4a7fe$var$colorChannelToGammaSpace(this.b);
        }
        convertedColor.a = this.a;
        return this;
    }
    // Statics
    /**
     * Creates a new Color4 from the string containing valid hexadecimal values.
     *
     * A valid hex string is either in the format #RRGGBB or #RRGGBBAA.
     *
     * When a hex string without alpha is passed, the resulting Color4 has
     * its alpha value set to 1.0.
     *
     * An invalid string results in a Color with all its channels set to 0.0,
     * i.e. "transparent black".
     *
     * @param hex defines a string containing valid hexadecimal values
     * @returns a new Color4 object
     */ static FromHexString(hex) {
        if (hex.substring(0, 1) !== "#" || hex.length !== 9 && hex.length !== 7) return new $5440a29da7c4a7fe$export$cb7e366859c95cb0(0.0, 0.0, 0.0, 0.0);
        const r = parseInt(hex.substring(1, 3), 16);
        const g = parseInt(hex.substring(3, 5), 16);
        const b = parseInt(hex.substring(5, 7), 16);
        const a = hex.length === 9 ? parseInt(hex.substring(7, 9), 16) : 255;
        return $5440a29da7c4a7fe$export$cb7e366859c95cb0.FromInts(r, g, b, a);
    }
    /**
     * Creates a new Color4 object set with the linearly interpolated values of "amount" between the left Color4 object and the right Color4 object
     * @param left defines the start value
     * @param right defines the end value
     * @param amount defines the gradient factor
     * @returns a new Color4 object
     */ static Lerp(left, right, amount) {
        const result = new $5440a29da7c4a7fe$export$cb7e366859c95cb0(0.0, 0.0, 0.0, 0.0);
        $5440a29da7c4a7fe$export$cb7e366859c95cb0.LerpToRef(left, right, amount, result);
        return result;
    }
    /**
     * Set the given "result" with the linearly interpolated values of "amount" between the left Color4 object and the right Color4 object
     * @param left defines the start value
     * @param right defines the end value
     * @param amount defines the gradient factor
     * @param result defines the Color4 object where to store data
     */ static LerpToRef(left, right, amount, result) {
        result.r = left.r + (right.r - left.r) * amount;
        result.g = left.g + (right.g - left.g) * amount;
        result.b = left.b + (right.b - left.b) * amount;
        result.a = left.a + (right.a - left.a) * amount;
    }
    /**
     * Interpolate between two Color4 using Hermite interpolation
     * @param value1 defines first Color4
     * @param tangent1 defines the incoming tangent
     * @param value2 defines second Color4
     * @param tangent2 defines the outgoing tangent
     * @param amount defines the target Color4
     * @returns the new interpolated Color4
     */ static Hermite(value1, tangent1, value2, tangent2, amount) {
        const squared = amount * amount;
        const cubed = amount * squared;
        const part1 = 2.0 * cubed - 3.0 * squared + 1.0;
        const part2 = -2 * cubed + 3.0 * squared;
        const part3 = cubed - 2.0 * squared + amount;
        const part4 = cubed - squared;
        const r = value1.r * part1 + value2.r * part2 + tangent1.r * part3 + tangent2.r * part4;
        const g = value1.g * part1 + value2.g * part2 + tangent1.g * part3 + tangent2.g * part4;
        const b = value1.b * part1 + value2.b * part2 + tangent1.b * part3 + tangent2.b * part4;
        const a = value1.a * part1 + value2.a * part2 + tangent1.a * part3 + tangent2.a * part4;
        return new $5440a29da7c4a7fe$export$cb7e366859c95cb0(r, g, b, a);
    }
    /**
     * Returns a new Color4 which is the 1st derivative of the Hermite spline defined by the colors "value1", "value2", "tangent1", "tangent2".
     * @param value1 defines the first control point
     * @param tangent1 defines the first tangent
     * @param value2 defines the second control point
     * @param tangent2 defines the second tangent
     * @param time define where the derivative must be done
     * @returns 1st derivative
     */ static Hermite1stDerivative(value1, tangent1, value2, tangent2, time) {
        const result = new $5440a29da7c4a7fe$export$cb7e366859c95cb0();
        this.Hermite1stDerivativeToRef(value1, tangent1, value2, tangent2, time, result);
        return result;
    }
    /**
     * Update a Color4 with the 1st derivative of the Hermite spline defined by the colors "value1", "value2", "tangent1", "tangent2".
     * @param value1 defines the first control point
     * @param tangent1 defines the first tangent
     * @param value2 defines the second control point
     * @param tangent2 defines the second tangent
     * @param time define where the derivative must be done
     * @param result define where to store the derivative
     */ static Hermite1stDerivativeToRef(value1, tangent1, value2, tangent2, time, result) {
        const t2 = time * time;
        result.r = (t2 - time) * 6 * value1.r + (3 * t2 - 4 * time + 1) * tangent1.r + (-t2 + time) * 6 * value2.r + (3 * t2 - 2 * time) * tangent2.r;
        result.g = (t2 - time) * 6 * value1.g + (3 * t2 - 4 * time + 1) * tangent1.g + (-t2 + time) * 6 * value2.g + (3 * t2 - 2 * time) * tangent2.g;
        result.b = (t2 - time) * 6 * value1.b + (3 * t2 - 4 * time + 1) * tangent1.b + (-t2 + time) * 6 * value2.b + (3 * t2 - 2 * time) * tangent2.b;
        result.a = (t2 - time) * 6 * value1.a + (3 * t2 - 4 * time + 1) * tangent1.a + (-t2 + time) * 6 * value2.a + (3 * t2 - 2 * time) * tangent2.a;
    }
    /**
     * Creates a new Color4 from a Color3 and an alpha value
     * @param color3 defines the source Color3 to read from
     * @param alpha defines the alpha component (1.0 by default)
     * @returns a new Color4 object
     */ static FromColor3(color3, alpha = 1.0) {
        return new $5440a29da7c4a7fe$export$cb7e366859c95cb0(color3.r, color3.g, color3.b, alpha);
    }
    /**
     * Creates a new Color4 from the starting index element of the given array
     * @param array defines the source array to read from
     * @param offset defines the offset in the source array
     * @returns a new Color4 object
     */ static FromArray(array, offset = 0) {
        return new $5440a29da7c4a7fe$export$cb7e366859c95cb0(array[offset], array[offset + 1], array[offset + 2], array[offset + 3]);
    }
    /**
     * Creates a new Color4 from the starting index element of the given array
     * @param array defines the source array to read from
     * @param offset defines the offset in the source array
     * @param result defines the target Color4 object
     */ static FromArrayToRef(array, offset = 0, result) {
        result.r = array[offset];
        result.g = array[offset + 1];
        result.b = array[offset + 2];
        result.a = array[offset + 3];
    }
    /**
     * Creates a new Color3 from integer values (less than 256)
     * @param r defines the red component to read from (value between 0 and 255)
     * @param g defines the green component to read from (value between 0 and 255)
     * @param b defines the blue component to read from (value between 0 and 255)
     * @param a defines the alpha component to read from (value between 0 and 255)
     * @returns a new Color3 object
     */ static FromInts(r, g, b, a) {
        return new $5440a29da7c4a7fe$export$cb7e366859c95cb0(r / 255.0, g / 255.0, b / 255.0, a / 255.0);
    }
    /**
     * Check the content of a given array and convert it to an array containing RGBA data
     * If the original array was already containing count * 4 values then it is returned directly
     * @param colors defines the array to check
     * @param count defines the number of RGBA data to expect
     * @returns an array containing count * 4 values (RGBA)
     */ static CheckColors4(colors, count) {
        // Check if color3 was used
        if (colors.length === count * 3) {
            const colors4 = [];
            for(let index = 0; index < colors.length; index += 3){
                const newIndex = index / 3 * 4;
                colors4[newIndex] = colors[index];
                colors4[newIndex + 1] = colors[index + 1];
                colors4[newIndex + 2] = colors[index + 2];
                colors4[newIndex + 3] = 1.0;
            }
            return colors4;
        }
        return colors;
    }
}
Object.defineProperties($5440a29da7c4a7fe$export$cb7e366859c95cb0.prototype, {
    dimension: {
        value: [
            4
        ]
    },
    rank: {
        value: 1
    }
});
class $5440a29da7c4a7fe$export$22fd4211f9ff6a1d {
}
$5440a29da7c4a7fe$export$22fd4211f9ff6a1d.Color3 = (0, $opFp4.ArrayTools).BuildArray(3, $5440a29da7c4a7fe$export$b3ff593cf6d17bf0.Black);
$5440a29da7c4a7fe$export$22fd4211f9ff6a1d.Color4 = (0, $opFp4.ArrayTools).BuildArray(3, ()=>new $5440a29da7c4a7fe$export$cb7e366859c95cb0(0, 0, 0, 0));
(0, $8DoUR.RegisterClass)("BABYLON.Color3", $5440a29da7c4a7fe$export$b3ff593cf6d17bf0);
(0, $8DoUR.RegisterClass)("BABYLON.Color4", $5440a29da7c4a7fe$export$cb7e366859c95cb0);

});
parcelRegister("1VEEL", function(module, exports) {

$parcel$export(module.exports, "Scalar", () => $167aa6dc80be9b6f$export$595dbf49c602a1f);

var $iosaP = parcelRequire("iosaP");
class $167aa6dc80be9b6f$export$595dbf49c602a1f {
    /**
     * Returns -1 if value is negative and +1 is value is positive.
     * @param value the value
     * @returns the value itself if it's equal to zero.
     */ static Sign(value) {
        value = +value; // convert to a number
        if (value === 0 || isNaN(value)) return value;
        return value > 0 ? 1 : -1;
    }
    /**
     * the log2 of value.
     * @param value the value to compute log2 of
     * @returns the log2 of value.
     */ static Log2(value) {
        return Math.log(value) * Math.LOG2E;
    }
    /**
     * the floor part of a log2 value.
     * @param value the value to compute log2 of
     * @returns the log2 of value.
     */ static ILog2(value) {
        if (Math.log2) return Math.floor(Math.log2(value));
        if (value < 0) return NaN;
        else if (value === 0) return -Infinity;
        let n = 0;
        if (value < 1) {
            while(value < 1){
                n++;
                value = value * 2;
            }
            n = -n;
        } else if (value > 1) while(value > 1){
            n++;
            value = Math.floor(value / 2);
        }
        return n;
    }
    /**
     * Loops the value, so that it is never larger than length and never smaller than 0.
     *
     * This is similar to the modulo operator but it works with floating point numbers.
     * For example, using 3.0 for t and 2.5 for length, the result would be 0.5.
     * With t = 5 and length = 2.5, the result would be 0.0.
     * Note, however, that the behaviour is not defined for negative numbers as it is for the modulo operator
     * @param value the value
     * @param length the length
     * @returns the looped value
     */ static Repeat(value, length) {
        return value - Math.floor(value / length) * length;
    }
    /**
     * Normalize the value between 0.0 and 1.0 using min and max values
     * @param value value to normalize
     * @param min max to normalize between
     * @param max min to normalize between
     * @returns the normalized value
     */ static Normalize(value, min, max) {
        return (value - min) / (max - min);
    }
    /**
     * Denormalize the value from 0.0 and 1.0 using min and max values
     * @param normalized value to denormalize
     * @param min max to denormalize between
     * @param max min to denormalize between
     * @returns the denormalized value
     */ static Denormalize(normalized, min, max) {
        return normalized * (max - min) + min;
    }
    /**
     * Calculates the shortest difference between two given angles given in degrees.
     * @param current current angle in degrees
     * @param target target angle in degrees
     * @returns the delta
     */ static DeltaAngle(current, target) {
        let num = $167aa6dc80be9b6f$export$595dbf49c602a1f.Repeat(target - current, 360.0);
        if (num > 180.0) num -= 360.0;
        return num;
    }
    /**
     * PingPongs the value t, so that it is never larger than length and never smaller than 0.
     * @param tx value
     * @param length length
     * @returns The returned value will move back and forth between 0 and length
     */ static PingPong(tx, length) {
        const t = $167aa6dc80be9b6f$export$595dbf49c602a1f.Repeat(tx, length * 2.0);
        return length - Math.abs(t - length);
    }
    /**
     * Interpolates between min and max with smoothing at the limits.
     *
     * This function interpolates between min and max in a similar way to Lerp. However, the interpolation will gradually speed up
     * from the start and slow down toward the end. This is useful for creating natural-looking animation, fading and other transitions.
     * @param from from
     * @param to to
     * @param tx value
     * @returns the smooth stepped value
     */ static SmoothStep(from, to, tx) {
        let t = $167aa6dc80be9b6f$export$595dbf49c602a1f.Clamp(tx);
        t = -2 * t * t * t + 3.0 * t * t;
        return to * t + from * (1.0 - t);
    }
    /**
     * Moves a value current towards target.
     *
     * This is essentially the same as Mathf.Lerp but instead the function will ensure that the speed never exceeds maxDelta.
     * Negative values of maxDelta pushes the value away from target.
     * @param current current value
     * @param target target value
     * @param maxDelta max distance to move
     * @returns resulting value
     */ static MoveTowards(current, target, maxDelta) {
        let result = 0;
        if (Math.abs(target - current) <= maxDelta) result = target;
        else result = current + $167aa6dc80be9b6f$export$595dbf49c602a1f.Sign(target - current) * maxDelta;
        return result;
    }
    /**
     * Same as MoveTowards but makes sure the values interpolate correctly when they wrap around 360 degrees.
     *
     * Variables current and target are assumed to be in degrees. For optimization reasons, negative values of maxDelta
     *  are not supported and may cause oscillation. To push current away from a target angle, add 180 to that angle instead.
     * @param current current value
     * @param target target value
     * @param maxDelta max distance to move
     * @returns resulting angle
     */ static MoveTowardsAngle(current, target, maxDelta) {
        const num = $167aa6dc80be9b6f$export$595dbf49c602a1f.DeltaAngle(current, target);
        let result = 0;
        if (-maxDelta < num && num < maxDelta) result = target;
        else {
            target = current + num;
            result = $167aa6dc80be9b6f$export$595dbf49c602a1f.MoveTowards(current, target, maxDelta);
        }
        return result;
    }
    /**
     * Same as Lerp but makes sure the values interpolate correctly when they wrap around 360 degrees.
     * The parameter t is clamped to the range [0, 1]. Variables a and b are assumed to be in degrees.
     * @param start start value
     * @param end target value
     * @param amount amount to lerp between
     * @returns the lerped value
     */ static LerpAngle(start, end, amount) {
        let num = $167aa6dc80be9b6f$export$595dbf49c602a1f.Repeat(end - start, 360.0);
        if (num > 180.0) num -= 360.0;
        return start + num * (0, $iosaP.Clamp)(amount);
    }
    /**
     * Calculates the linear parameter t that produces the interpolant value within the range [a, b].
     * @param a start value
     * @param b target value
     * @param value value between a and b
     * @returns the inverseLerp value
     */ static InverseLerp(a, b, value) {
        let result = 0;
        if (a != b) result = (0, $iosaP.Clamp)((value - a) / (b - a));
        else result = 0.0;
        return result;
    }
    /**
     * Returns a new scalar located for "amount" (float) on the Hermite spline defined by the scalars "value1", "value3", "tangent1", "tangent2".
     * @see http://mathworld.wolfram.com/HermitePolynomial.html
     * @param value1 defines the first control point
     * @param tangent1 defines the first tangent
     * @param value2 defines the second control point
     * @param tangent2 defines the second tangent
     * @param amount defines the amount on the interpolation spline (between 0 and 1)
     * @returns hermite result
     */ static Hermite(value1, tangent1, value2, tangent2, amount) {
        const squared = amount * amount;
        const cubed = amount * squared;
        const part1 = 2.0 * cubed - 3.0 * squared + 1.0;
        const part2 = -2 * cubed + 3.0 * squared;
        const part3 = cubed - 2.0 * squared + amount;
        const part4 = cubed - squared;
        return value1 * part1 + value2 * part2 + tangent1 * part3 + tangent2 * part4;
    }
    /**
     * Returns a new scalar which is the 1st derivative of the Hermite spline defined by the scalars "value1", "value2", "tangent1", "tangent2".
     * @param value1 defines the first control point
     * @param tangent1 defines the first tangent
     * @param value2 defines the second control point
     * @param tangent2 defines the second tangent
     * @param time define where the derivative must be done
     * @returns 1st derivative
     */ static Hermite1stDerivative(value1, tangent1, value2, tangent2, time) {
        const t2 = time * time;
        return (t2 - time) * 6 * value1 + (3 * t2 - 4 * time + 1) * tangent1 + (-t2 + time) * 6 * value2 + (3 * t2 - 2 * time) * tangent2;
    }
    /**
     * This function returns percentage of a number in a given range.
     *
     * RangeToPercent(40,20,60) will return 0.5 (50%)
     * RangeToPercent(34,0,100) will return 0.34 (34%)
     * @param number to convert to percentage
     * @param min min range
     * @param max max range
     * @returns the percentage
     */ static RangeToPercent(number, min, max) {
        return (number - min) / (max - min);
    }
    /**
     * This function returns number that corresponds to the percentage in a given range.
     *
     * PercentToRange(0.34,0,100) will return 34.
     * @param percent to convert to number
     * @param min min range
     * @param max max range
     * @returns the number
     */ static PercentToRange(percent, min, max) {
        return (max - min) * percent + min;
    }
    /**
     * Returns the highest common factor of two integers.
     * @param a first parameter
     * @param b second parameter
     * @returns HCF of a and b
     */ static HCF(a, b) {
        const r = a % b;
        if (r === 0) return b;
        return $167aa6dc80be9b6f$export$595dbf49c602a1f.HCF(b, r);
    }
}
/**
 * Two pi constants convenient for computation.
 */ $167aa6dc80be9b6f$export$595dbf49c602a1f.TwoPi = Math.PI * 2;
/**
 * Boolean : true if the absolute difference between a and b is lower than epsilon (default = 1.401298E-45)
 * @param a number
 * @param b number
 * @param epsilon (default = 1.401298E-45)
 * @returns true if the absolute difference between a and b is lower than epsilon (default = 1.401298E-45)
 */ $167aa6dc80be9b6f$export$595dbf49c602a1f.WithinEpsilon = (0, $iosaP.WithinEpsilon);
/**
 * Returns a string : the upper case translation of the number i to hexadecimal.
 * @param i number
 * @returns the upper case translation of the number i to hexadecimal.
 */ $167aa6dc80be9b6f$export$595dbf49c602a1f.ToHex = (0, $iosaP.ToHex);
/**
 * Returns the value itself if it's between min and max.
 * Returns min if the value is lower than min.
 * Returns max if the value is greater than max.
 * @param value the value to clmap
 * @param min the min value to clamp to (default: 0)
 * @param max the max value to clamp to (default: 1)
 * @returns the clamped value
 */ $167aa6dc80be9b6f$export$595dbf49c602a1f.Clamp = (0, $iosaP.Clamp);
/**
 * Creates a new scalar with values linearly interpolated of "amount" between the start scalar and the end scalar.
 * @param start start value
 * @param end target value
 * @param amount amount to lerp between
 * @returns the lerped value
 */ $167aa6dc80be9b6f$export$595dbf49c602a1f.Lerp = (0, $iosaP.Lerp);
/**
 * Returns a random float number between and min and max values
 * @param min min value of random
 * @param max max value of random
 * @returns random value
 */ $167aa6dc80be9b6f$export$595dbf49c602a1f.RandomRange = (0, $iosaP.RandomRange);
/**
 * Returns the angle converted to equivalent value between -Math.PI and Math.PI radians.
 * @param angle The angle to normalize in radian.
 * @returns The converted angle.
 */ $167aa6dc80be9b6f$export$595dbf49c602a1f.NormalizeRadians = (0, $iosaP.NormalizeRadians);

});



parcelRegister("cmj0B", function(module, exports) {

$parcel$export(module.exports, "ActionEvent", () => $8ff648d23f338fa0$export$be110ec04f34d03b);
/**
 * ActionEvent is the event being sent when an action is triggered.
 */ class $8ff648d23f338fa0$export$be110ec04f34d03b {
    /**
     * Creates a new ActionEvent
     * @param source The mesh or sprite that triggered the action
     * @param pointerX The X mouse cursor position at the time of the event
     * @param pointerY The Y mouse cursor position at the time of the event
     * @param meshUnderPointer The mesh that is currently pointed at (can be null)
     * @param sourceEvent the original (browser) event that triggered the ActionEvent
     * @param additionalData additional data for the event
     */ constructor(/** The mesh or sprite that triggered the action */ source, /** The X mouse cursor position at the time of the event */ pointerX, /** The Y mouse cursor position at the time of the event */ pointerY, /** The mesh that is currently pointed at (can be null) */ meshUnderPointer, /** the original (browser) event that triggered the ActionEvent */ sourceEvent, /** additional data for the event */ additionalData){
        this.source = source;
        this.pointerX = pointerX;
        this.pointerY = pointerY;
        this.meshUnderPointer = meshUnderPointer;
        this.sourceEvent = sourceEvent;
        this.additionalData = additionalData;
    }
    /**
     * Helper function to auto-create an ActionEvent from a source mesh.
     * @param source The source mesh that triggered the event
     * @param evt The original (browser) event
     * @param additionalData additional data for the event
     * @returns the new ActionEvent
     */ static CreateNew(source, evt, additionalData) {
        const scene = source.getScene();
        return new $8ff648d23f338fa0$export$be110ec04f34d03b(source, scene.pointerX, scene.pointerY, scene.meshUnderPointer || source, evt, additionalData);
    }
    /**
     * Helper function to auto-create an ActionEvent from a source sprite
     * @param source The source sprite that triggered the event
     * @param scene Scene associated with the sprite
     * @param evt The original (browser) event
     * @param additionalData additional data for the event
     * @returns the new ActionEvent
     */ static CreateNewFromSprite(source, scene, evt, additionalData) {
        return new $8ff648d23f338fa0$export$be110ec04f34d03b(source, scene.pointerX, scene.pointerY, scene.meshUnderPointer, evt, additionalData);
    }
    /**
     * Helper function to auto-create an ActionEvent from a scene. If triggered by a mesh use ActionEvent.CreateNew
     * @param scene the scene where the event occurred
     * @param evt The original (browser) event
     * @returns the new ActionEvent
     */ static CreateNewFromScene(scene, evt) {
        return new $8ff648d23f338fa0$export$be110ec04f34d03b(null, scene.pointerX, scene.pointerY, scene.meshUnderPointer, evt);
    }
    /**
     * Helper function to auto-create an ActionEvent from a primitive
     * @param prim defines the target primitive
     * @param pointerPos defines the pointer position
     * @param evt The original (browser) event
     * @param additionalData additional data for the event
     * @returns the new ActionEvent
     */ static CreateNewFromPrimitive(prim, pointerPos, evt, additionalData) {
        return new $8ff648d23f338fa0$export$be110ec04f34d03b(prim, pointerPos.x, pointerPos.y, null, evt, additionalData);
    }
}

});

parcelRegister("ebhJB", function(module, exports) {

$parcel$export(module.exports, "ActionManager", () => $a52fd97a934030a8$export$489f44c6804eda05);

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $gv9um = parcelRequire("gv9um");

var $5lx8l = parcelRequire("5lx8l");

var $ahTnb = parcelRequire("ahTnb");

var $ejQPp = parcelRequire("ejQPp");

var $kVtWi = parcelRequire("kVtWi");

var $fhgis = parcelRequire("fhgis");

var $8DoUR = parcelRequire("8DoUR");

var $kNPE8 = parcelRequire("kNPE8");
class $a52fd97a934030a8$export$489f44c6804eda05 extends (0, $kNPE8.AbstractActionManager) {
    /**
     * Creates a new action manager
     * @param scene defines the hosting scene
     */ constructor(scene){
        super();
        scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        if (!scene) return;
        this._scene = scene;
        scene.actionManagers.push(this);
    }
    // Methods
    /**
     * Releases all associated resources
     */ dispose() {
        const sceneIndex = this._scene.actionManagers.indexOf(this);
        for(let i = 0; i < this.actions.length; i++){
            const action = this.actions[i];
            $a52fd97a934030a8$export$489f44c6804eda05.Triggers[action.trigger]--;
            if ($a52fd97a934030a8$export$489f44c6804eda05.Triggers[action.trigger] === 0) delete $a52fd97a934030a8$export$489f44c6804eda05.Triggers[action.trigger];
        }
        this.actions.length = 0;
        if (sceneIndex > -1) this._scene.actionManagers.splice(sceneIndex, 1);
        const ownerMeshes = this._scene.meshes.filter((m)=>m.actionManager === this);
        for (const ownerMesh of ownerMeshes)ownerMesh.actionManager = null;
    }
    /**
     * Gets hosting scene
     * @returns the hosting scene
     */ getScene() {
        return this._scene;
    }
    /**
     * Does this action manager handles actions of any of the given triggers
     * @param triggers defines the triggers to be tested
     * @returns a boolean indicating whether one (or more) of the triggers is handled
     */ hasSpecificTriggers(triggers) {
        for(let index = 0; index < this.actions.length; index++){
            const action = this.actions[index];
            if (triggers.indexOf(action.trigger) > -1) return true;
        }
        return false;
    }
    /**
     * Does this action manager handles actions of any of the given triggers. This function takes two arguments for
     * speed.
     * @param triggerA defines the trigger to be tested
     * @param triggerB defines the trigger to be tested
     * @returns a boolean indicating whether one (or more) of the triggers is handled
     */ hasSpecificTriggers2(triggerA, triggerB) {
        for(let index = 0; index < this.actions.length; index++){
            const action = this.actions[index];
            if (triggerA == action.trigger || triggerB == action.trigger) return true;
        }
        return false;
    }
    /**
     * Does this action manager handles actions of a given trigger
     * @param trigger defines the trigger to be tested
     * @param parameterPredicate defines an optional predicate to filter triggers by parameter
     * @returns whether the trigger is handled
     */ hasSpecificTrigger(trigger, parameterPredicate) {
        for(let index = 0; index < this.actions.length; index++){
            const action = this.actions[index];
            if (action.trigger === trigger) {
                if (parameterPredicate) {
                    if (parameterPredicate(action.getTriggerParameter())) return true;
                } else return true;
            }
        }
        return false;
    }
    /**
     * Does this action manager has pointer triggers
     */ get hasPointerTriggers() {
        for(let index = 0; index < this.actions.length; index++){
            const action = this.actions[index];
            if (action.trigger >= $a52fd97a934030a8$export$489f44c6804eda05.OnPickTrigger && action.trigger <= $a52fd97a934030a8$export$489f44c6804eda05.OnPointerOutTrigger) return true;
        }
        return false;
    }
    /**
     * Does this action manager has pick triggers
     */ get hasPickTriggers() {
        for(let index = 0; index < this.actions.length; index++){
            const action = this.actions[index];
            if (action.trigger >= $a52fd97a934030a8$export$489f44c6804eda05.OnPickTrigger && action.trigger <= $a52fd97a934030a8$export$489f44c6804eda05.OnPickUpTrigger) return true;
        }
        return false;
    }
    /**
     * Registers an action to this action manager
     * @param action defines the action to be registered
     * @returns the action amended (prepared) after registration
     */ registerAction(action) {
        if (action.trigger === $a52fd97a934030a8$export$489f44c6804eda05.OnEveryFrameTrigger) {
            if (this.getScene().actionManager !== this) {
                (0, $kVtWi.Logger).Warn("OnEveryFrameTrigger can only be used with scene.actionManager");
                return null;
            }
        }
        this.actions.push(action);
        this.getScene()._registeredActions++;
        if ($a52fd97a934030a8$export$489f44c6804eda05.Triggers[action.trigger]) $a52fd97a934030a8$export$489f44c6804eda05.Triggers[action.trigger]++;
        else $a52fd97a934030a8$export$489f44c6804eda05.Triggers[action.trigger] = 1;
        action._actionManager = this;
        action._prepare();
        return action;
    }
    /**
     * Unregisters an action to this action manager
     * @param action defines the action to be unregistered
     * @returns a boolean indicating whether the action has been unregistered
     */ unregisterAction(action) {
        const index = this.actions.indexOf(action);
        if (index !== -1) {
            this.actions.splice(index, 1);
            $a52fd97a934030a8$export$489f44c6804eda05.Triggers[action.trigger] -= 1;
            if ($a52fd97a934030a8$export$489f44c6804eda05.Triggers[action.trigger] === 0) delete $a52fd97a934030a8$export$489f44c6804eda05.Triggers[action.trigger];
            action._actionManager = null;
            this.getScene()._registeredActions--;
            return true;
        }
        return false;
    }
    /**
     * Process a specific trigger
     * @param trigger defines the trigger to process
     * @param evt defines the event details to be processed
     */ processTrigger(trigger, evt) {
        for(let index = 0; index < this.actions.length; index++){
            const action = this.actions[index];
            if (action.trigger === trigger) {
                if (evt) {
                    if (trigger === $a52fd97a934030a8$export$489f44c6804eda05.OnKeyUpTrigger || trigger === $a52fd97a934030a8$export$489f44c6804eda05.OnKeyDownTrigger) {
                        const parameter = action.getTriggerParameter();
                        if (typeof parameter === "function") {
                            if (!parameter(evt)) continue;
                        } else if (parameter && parameter !== evt.sourceEvent.keyCode) {
                            if (!parameter.toLowerCase) continue;
                            const lowerCase = parameter.toLowerCase();
                            if (lowerCase !== evt.sourceEvent.key) {
                                const unicode = evt.sourceEvent.charCode ? evt.sourceEvent.charCode : evt.sourceEvent.keyCode;
                                const actualkey = String.fromCharCode(unicode).toLowerCase();
                                if (actualkey !== lowerCase) continue;
                            }
                        }
                    }
                }
                action._executeCurrent(evt);
            }
        }
    }
    /**
     * @internal
     */ _getEffectiveTarget(target, propertyPath) {
        const properties = propertyPath.split(".");
        for(let index = 0; index < properties.length - 1; index++)target = target[properties[index]];
        return target;
    }
    /**
     * @internal
     */ _getProperty(propertyPath) {
        const properties = propertyPath.split(".");
        return properties[properties.length - 1];
    }
    /**
     * Serialize this manager to a JSON object
     * @param name defines the property name to store this manager
     * @returns a JSON representation of this manager
     */ serialize(name) {
        const root = {
            children: new Array(),
            name: name,
            type: 3,
            properties: new Array()
        };
        for(let i = 0; i < this.actions.length; i++){
            const triggerObject = {
                type: 0,
                children: new Array(),
                name: $a52fd97a934030a8$export$489f44c6804eda05.GetTriggerName(this.actions[i].trigger),
                properties: new Array()
            };
            const triggerOptions = this.actions[i].triggerOptions;
            if (triggerOptions && typeof triggerOptions !== "number") {
                if (triggerOptions.parameter instanceof Node) triggerObject.properties.push((0, $5lx8l.Action)._GetTargetProperty(triggerOptions.parameter));
                else if (typeof triggerOptions.parameter === "object") {
                    const parameter = {};
                    (0, $fhgis.DeepCopier).DeepCopy(triggerOptions.parameter, parameter, [
                        "mesh"
                    ]);
                    if (triggerOptions.parameter && triggerOptions.parameter.mesh) parameter._meshId = triggerOptions.parameter.mesh.id;
                    triggerObject.properties.push({
                        name: "parameter",
                        targetType: null,
                        value: parameter
                    });
                } else triggerObject.properties.push({
                    name: "parameter",
                    targetType: null,
                    value: triggerOptions.parameter
                });
            }
            // Serialize child action, recursively
            this.actions[i].serialize(triggerObject);
            // Add serialized trigger
            root.children.push(triggerObject);
        }
        return root;
    }
    /**
     * Creates a new ActionManager from a JSON data
     * @param parsedActions defines the JSON data to read from
     * @param object defines the hosting mesh
     * @param scene defines the hosting scene
     */ static Parse(parsedActions, object, scene) {
        const actionManager = new $a52fd97a934030a8$export$489f44c6804eda05(scene);
        if (object === null) scene.actionManager = actionManager;
        else object.actionManager = actionManager;
        // instantiate a new object
        const instantiate = (name, params)=>{
            const internalClassType = (0, $8DoUR.GetClass)("BABYLON." + name);
            return internalClassType && new internalClassType(...params);
        };
        const parseParameter = (name, value, target, propertyPath)=>{
            if (propertyPath === null) {
                // String, boolean or float
                const floatValue = parseFloat(value);
                if (value === "true" || value === "false") return value === "true";
                else return isNaN(floatValue) ? value : floatValue;
            }
            const effectiveTarget = propertyPath.split(".");
            const values = value.split(",");
            // Get effective Target
            for(let i = 0; i < effectiveTarget.length; i++)target = target[effectiveTarget[i]];
            // Return appropriate value with its type
            if (typeof target === "boolean") return values[0] === "true";
            if (typeof target === "string") return values[0];
            // Parameters with multiple values such as Vector3 etc.
            const split = [];
            for(let i = 0; i < values.length; i++)split.push(parseFloat(values[i]));
            if (target instanceof (0, $ha1VO.Vector3)) return (0, $ha1VO.Vector3).FromArray(split);
            if (target instanceof (0, $ha1VO.Vector4)) return (0, $ha1VO.Vector4).FromArray(split);
            if (target instanceof (0, $7etnY.Color3)) return (0, $7etnY.Color3).FromArray(split);
            if (target instanceof (0, $7etnY.Color4)) return (0, $7etnY.Color4).FromArray(split);
            return parseFloat(values[0]);
        };
        // traverse graph per trigger
        const traverse = (parsedAction, trigger, condition, action, combineArray = null)=>{
            if (parsedAction.detached) return;
            const parameters = [];
            let target = null;
            let propertyPath = null;
            const combine = parsedAction.combine && parsedAction.combine.length > 0;
            // Parameters
            if (parsedAction.type === 2) parameters.push(actionManager);
            else parameters.push(trigger);
            if (combine) {
                const actions = [];
                for(let j = 0; j < parsedAction.combine.length; j++)traverse(parsedAction.combine[j], $a52fd97a934030a8$export$489f44c6804eda05.NothingTrigger, condition, action, actions);
                parameters.push(actions);
            } else for(let i = 0; i < parsedAction.properties.length; i++){
                let value = parsedAction.properties[i].value;
                const name = parsedAction.properties[i].name;
                const targetType = parsedAction.properties[i].targetType;
                if (name === "target") {
                    if (targetType === "SceneProperties") value = target = scene;
                    else if (targetType === "MaterialProperties") value = target = scene.getMaterialByName(value);
                    else value = target = scene.getNodeByName(value);
                } else if (name === "parent") value = scene.getNodeByName(value);
                else if (name === "sound") // Can not externalize to component, so only checks for the presence off the API.
                {
                    if (scene.getSoundByName) value = scene.getSoundByName(value);
                } else if (name !== "propertyPath") {
                    if (parsedAction.type === 2 && name === "operator") value = (0, $gv9um.ValueCondition)[value];
                    else value = parseParameter(name, value, target, name === "value" ? propertyPath : null);
                } else propertyPath = value;
                parameters.push(value);
            }
            if (combineArray === null) parameters.push(condition);
            else parameters.push(null);
            // If interpolate value action
            if (parsedAction.name === "InterpolateValueAction") {
                const param = parameters[parameters.length - 2];
                parameters[parameters.length - 1] = param;
                parameters[parameters.length - 2] = condition;
            }
            // Action or condition(s) and not CombineAction
            let newAction = instantiate(parsedAction.name, parameters);
            if (newAction instanceof (0, $gv9um.Condition) && condition !== null) {
                const nothing = new (0, $ahTnb.DoNothingAction)(trigger, condition);
                if (action) action.then(nothing);
                else actionManager.registerAction(nothing);
                action = nothing;
            }
            if (combineArray === null) {
                if (newAction instanceof (0, $gv9um.Condition)) {
                    condition = newAction;
                    newAction = action;
                } else {
                    condition = null;
                    if (action) action.then(newAction);
                    else actionManager.registerAction(newAction);
                }
            } else combineArray.push(newAction);
            for(let i = 0; i < parsedAction.children.length; i++)traverse(parsedAction.children[i], trigger, condition, newAction, null);
        };
        // triggers
        for(let i = 0; i < parsedActions.children.length; i++){
            let triggerParams;
            const trigger = parsedActions.children[i];
            if (trigger.properties.length > 0) {
                const param = trigger.properties[0].value;
                const value = trigger.properties[0].targetType === null ? param : scene.getMeshByName(param);
                if (value._meshId) value.mesh = scene.getMeshById(value._meshId);
                triggerParams = {
                    trigger: $a52fd97a934030a8$export$489f44c6804eda05[trigger.name],
                    parameter: value
                };
            } else triggerParams = $a52fd97a934030a8$export$489f44c6804eda05[trigger.name];
            for(let j = 0; j < trigger.children.length; j++)if (!trigger.detached) traverse(trigger.children[j], triggerParams, null, null);
        }
    }
    /**
     * Get a trigger name by index
     * @param trigger defines the trigger index
     * @returns a trigger name
     */ static GetTriggerName(trigger) {
        switch(trigger){
            case 0:
                return "NothingTrigger";
            case 1:
                return "OnPickTrigger";
            case 2:
                return "OnLeftPickTrigger";
            case 3:
                return "OnRightPickTrigger";
            case 4:
                return "OnCenterPickTrigger";
            case 5:
                return "OnPickDownTrigger";
            case 6:
                return "OnDoublePickTrigger"; // start;
            case 7:
                return "OnPickUpTrigger";
            case 8:
                return "OnLongPressTrigger";
            case 9:
                return "OnPointerOverTrigger";
            case 10:
                return "OnPointerOutTrigger";
            case 11:
                return "OnEveryFrameTrigger";
            case 12:
                return "OnIntersectionEnterTrigger";
            case 13:
                return "OnIntersectionExitTrigger";
            case 14:
                return "OnKeyDownTrigger";
            case 15:
                return "OnKeyUpTrigger";
            case 16:
                return "OnPickOutTrigger";
            default:
                return "";
        }
    }
}
/**
 * Nothing
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $a52fd97a934030a8$export$489f44c6804eda05.NothingTrigger = 0;
/**
 * On pick
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $a52fd97a934030a8$export$489f44c6804eda05.OnPickTrigger = 1;
/**
 * On left pick
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $a52fd97a934030a8$export$489f44c6804eda05.OnLeftPickTrigger = 2;
/**
 * On right pick
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $a52fd97a934030a8$export$489f44c6804eda05.OnRightPickTrigger = 3;
/**
 * On center pick
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $a52fd97a934030a8$export$489f44c6804eda05.OnCenterPickTrigger = 4;
/**
 * On pick down
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $a52fd97a934030a8$export$489f44c6804eda05.OnPickDownTrigger = 5;
/**
 * On double pick
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $a52fd97a934030a8$export$489f44c6804eda05.OnDoublePickTrigger = 6;
/**
 * On pick up
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $a52fd97a934030a8$export$489f44c6804eda05.OnPickUpTrigger = 7;
/**
 * On pick out.
 * This trigger will only be raised if you also declared a OnPickDown
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $a52fd97a934030a8$export$489f44c6804eda05.OnPickOutTrigger = 16;
/**
 * On long press
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $a52fd97a934030a8$export$489f44c6804eda05.OnLongPressTrigger = 8;
/**
 * On pointer over
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $a52fd97a934030a8$export$489f44c6804eda05.OnPointerOverTrigger = 9;
/**
 * On pointer out
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $a52fd97a934030a8$export$489f44c6804eda05.OnPointerOutTrigger = 10;
/**
 * On every frame
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $a52fd97a934030a8$export$489f44c6804eda05.OnEveryFrameTrigger = 11;
/**
 * On intersection enter
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $a52fd97a934030a8$export$489f44c6804eda05.OnIntersectionEnterTrigger = 12;
/**
 * On intersection exit
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $a52fd97a934030a8$export$489f44c6804eda05.OnIntersectionExitTrigger = 13;
/**
 * On key down
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $a52fd97a934030a8$export$489f44c6804eda05.OnKeyDownTrigger = 14;
/**
 * On key up
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $a52fd97a934030a8$export$489f44c6804eda05.OnKeyUpTrigger = 15;

});
parcelRegister("gv9um", function(module, exports) {

$parcel$export(module.exports, "Condition", () => $c036e6d387c56d36$export$fcea0b2db26e6b18);
$parcel$export(module.exports, "ValueCondition", () => $c036e6d387c56d36$export$2cb075af1d62689a);
$parcel$export(module.exports, "PredicateCondition", () => $c036e6d387c56d36$export$f31191dfc7e2e1e5);
$parcel$export(module.exports, "StateCondition", () => $c036e6d387c56d36$export$b197c82767fb43f2);

var $5lx8l = parcelRequire("5lx8l");

var $8DoUR = parcelRequire("8DoUR");
class $c036e6d387c56d36$export$fcea0b2db26e6b18 {
    /**
     * Creates a new Condition
     * @param actionManager the manager of the action the condition is applied to
     */ constructor(actionManager){
        this._actionManager = actionManager;
    }
    /**
     * Check if the current condition is valid
     * @returns a boolean
     */ isValid() {
        return true;
    }
    /**
     * @internal
     */ _getProperty(propertyPath) {
        return this._actionManager._getProperty(propertyPath);
    }
    /**
     * @internal
     */ _getEffectiveTarget(target, propertyPath) {
        return this._actionManager._getEffectiveTarget(target, propertyPath);
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Serialize placeholder for child classes
     * @returns the serialized object
     */ serialize() {}
    /**
     * @internal
     */ _serialize(serializedCondition) {
        return {
            type: 2,
            children: [],
            name: serializedCondition.name,
            properties: serializedCondition.properties
        };
    }
}
class $c036e6d387c56d36$export$2cb075af1d62689a extends $c036e6d387c56d36$export$fcea0b2db26e6b18 {
    /**
     * returns the number for IsEqual
     */ static get IsEqual() {
        return $c036e6d387c56d36$export$2cb075af1d62689a._IsEqual;
    }
    /**
     * Returns the number for IsDifferent
     */ static get IsDifferent() {
        return $c036e6d387c56d36$export$2cb075af1d62689a._IsDifferent;
    }
    /**
     * Returns the number for IsGreater
     */ static get IsGreater() {
        return $c036e6d387c56d36$export$2cb075af1d62689a._IsGreater;
    }
    /**
     * Returns the number for IsLesser
     */ static get IsLesser() {
        return $c036e6d387c56d36$export$2cb075af1d62689a._IsLesser;
    }
    /**
     * Creates a new ValueCondition
     * @param actionManager manager for the action the condition applies to
     * @param target for the action
     * @param propertyPath path to specify the property of the target the conditional operator uses
     * @param value the value compared by the conditional operator against the current value of the property
     * @param operator the conditional operator, default ValueCondition.IsEqual
     */ constructor(actionManager, target, /** path to specify the property of the target the conditional operator uses  */ propertyPath, /** the value compared by the conditional operator against the current value of the property */ value, /** the conditional operator, default ValueCondition.IsEqual */ operator = $c036e6d387c56d36$export$2cb075af1d62689a.IsEqual){
        super(actionManager);
        this.propertyPath = propertyPath;
        this.value = value;
        this.operator = operator;
        this._target = target;
        this._effectiveTarget = this._getEffectiveTarget(target, this.propertyPath);
        this._property = this._getProperty(this.propertyPath);
    }
    /**
     * Compares the given value with the property value for the specified conditional operator
     * @returns the result of the comparison
     */ isValid() {
        switch(this.operator){
            case $c036e6d387c56d36$export$2cb075af1d62689a.IsGreater:
                return this._effectiveTarget[this._property] > this.value;
            case $c036e6d387c56d36$export$2cb075af1d62689a.IsLesser:
                return this._effectiveTarget[this._property] < this.value;
            case $c036e6d387c56d36$export$2cb075af1d62689a.IsEqual:
            case $c036e6d387c56d36$export$2cb075af1d62689a.IsDifferent:
                {
                    let check;
                    if (this.value.equals) check = this.value.equals(this._effectiveTarget[this._property]);
                    else check = this.value === this._effectiveTarget[this._property];
                    return this.operator === $c036e6d387c56d36$export$2cb075af1d62689a.IsEqual ? check : !check;
                }
        }
        return false;
    }
    /**
     * Serialize the ValueCondition into a JSON compatible object
     * @returns serialization object
     */ serialize() {
        return this._serialize({
            name: "ValueCondition",
            properties: [
                (0, $5lx8l.Action)._GetTargetProperty(this._target),
                {
                    name: "propertyPath",
                    value: this.propertyPath
                },
                {
                    name: "value",
                    value: (0, $5lx8l.Action)._SerializeValueAsString(this.value)
                },
                {
                    name: "operator",
                    value: $c036e6d387c56d36$export$2cb075af1d62689a.GetOperatorName(this.operator)
                }
            ]
        });
    }
    /**
     * Gets the name of the conditional operator for the ValueCondition
     * @param operator the conditional operator
     * @returns the name
     */ static GetOperatorName(operator) {
        switch(operator){
            case $c036e6d387c56d36$export$2cb075af1d62689a._IsEqual:
                return "IsEqual";
            case $c036e6d387c56d36$export$2cb075af1d62689a._IsDifferent:
                return "IsDifferent";
            case $c036e6d387c56d36$export$2cb075af1d62689a._IsGreater:
                return "IsGreater";
            case $c036e6d387c56d36$export$2cb075af1d62689a._IsLesser:
                return "IsLesser";
            default:
                return "";
        }
    }
}
$c036e6d387c56d36$export$2cb075af1d62689a._IsEqual = 0;
$c036e6d387c56d36$export$2cb075af1d62689a._IsDifferent = 1;
$c036e6d387c56d36$export$2cb075af1d62689a._IsGreater = 2;
$c036e6d387c56d36$export$2cb075af1d62689a._IsLesser = 3;
class $c036e6d387c56d36$export$f31191dfc7e2e1e5 extends $c036e6d387c56d36$export$fcea0b2db26e6b18 {
    /**
     * Creates a new PredicateCondition
     * @param actionManager manager for the action the condition applies to
     * @param predicate defines the predicate function used to validate the condition
     */ constructor(actionManager, /** defines the predicate function used to validate the condition */ predicate){
        super(actionManager);
        this.predicate = predicate;
    }
    /**
     * @returns the validity of the predicate condition
     */ isValid() {
        return this.predicate();
    }
}
class $c036e6d387c56d36$export$b197c82767fb43f2 extends $c036e6d387c56d36$export$fcea0b2db26e6b18 {
    /**
     * Creates a new StateCondition
     * @param actionManager manager for the action the condition applies to
     * @param target of the condition
     * @param value to compare with target state
     */ constructor(actionManager, target, /** Value to compare with target state  */ value){
        super(actionManager);
        this.value = value;
        this._target = target;
    }
    /**
     * Gets a boolean indicating if the current condition is met
     * @returns the validity of the state
     */ isValid() {
        return this._target.state === this.value;
    }
    /**
     * Serialize the StateCondition into a JSON compatible object
     * @returns serialization object
     */ serialize() {
        return this._serialize({
            name: "StateCondition",
            properties: [
                (0, $5lx8l.Action)._GetTargetProperty(this._target),
                {
                    name: "value",
                    value: this.value
                }
            ]
        });
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.ValueCondition", $c036e6d387c56d36$export$2cb075af1d62689a);
(0, $8DoUR.RegisterClass)("BABYLON.PredicateCondition", $c036e6d387c56d36$export$f31191dfc7e2e1e5);
(0, $8DoUR.RegisterClass)("BABYLON.StateCondition", $c036e6d387c56d36$export$b197c82767fb43f2);

});

parcelRegister("ahTnb", function(module, exports) {

$parcel$export(module.exports, "SwitchBooleanAction", () => $77d671d6e17cb239$export$1b56680778b66700);
$parcel$export(module.exports, "SetStateAction", () => $77d671d6e17cb239$export$e5e9a31807e6477);
$parcel$export(module.exports, "SetValueAction", () => $77d671d6e17cb239$export$a54ba1c3e3099a3e);
$parcel$export(module.exports, "IncrementValueAction", () => $77d671d6e17cb239$export$1447cf7351040a1a);
$parcel$export(module.exports, "PlayAnimationAction", () => $77d671d6e17cb239$export$df8cb2be925940f3);
$parcel$export(module.exports, "StopAnimationAction", () => $77d671d6e17cb239$export$c993efa1daf7a9c7);
$parcel$export(module.exports, "DoNothingAction", () => $77d671d6e17cb239$export$f98ea23232c8b722);
$parcel$export(module.exports, "CombineAction", () => $77d671d6e17cb239$export$359de0d9952b4d96);
$parcel$export(module.exports, "ExecuteCodeAction", () => $77d671d6e17cb239$export$83ff33bbf195817a);
$parcel$export(module.exports, "SetParentAction", () => $77d671d6e17cb239$export$202e37f3f439176a);

var $kVtWi = parcelRequire("kVtWi");

var $ha1VO = parcelRequire("ha1VO");

var $5lx8l = parcelRequire("5lx8l");

var $8DoUR = parcelRequire("8DoUR");
class $77d671d6e17cb239$export$1b56680778b66700 extends (0, $5lx8l.Action) {
    /**
     * Instantiate the action
     * @param triggerOptions defines the trigger options
     * @param target defines the object containing the boolean
     * @param propertyPath defines the path to the boolean property in the target object
     * @param condition defines the trigger related conditions
     */ constructor(triggerOptions, target, propertyPath, condition){
        super(triggerOptions, condition);
        this.propertyPath = propertyPath;
        this._target = this._effectiveTarget = target;
    }
    /** @internal */ _prepare() {
        this._effectiveTarget = this._getEffectiveTarget(this._effectiveTarget, this.propertyPath);
        this._property = this._getProperty(this.propertyPath);
    }
    /**
     * Execute the action toggle the boolean value.
     */ execute() {
        this._effectiveTarget[this._property] = !this._effectiveTarget[this._property];
    }
    /**
     * Serializes the actions and its related information.
     * @param parent defines the object to serialize in
     * @returns the serialized object
     */ serialize(parent) {
        return super._serialize({
            name: "SwitchBooleanAction",
            properties: [
                (0, $5lx8l.Action)._GetTargetProperty(this._target),
                {
                    name: "propertyPath",
                    value: this.propertyPath
                }
            ]
        }, parent);
    }
}
class $77d671d6e17cb239$export$e5e9a31807e6477 extends (0, $5lx8l.Action) {
    /**
     * Instantiate the action
     * @param triggerOptions defines the trigger options
     * @param target defines the object containing the state property
     * @param value defines the value to store in the state field
     * @param condition defines the trigger related conditions
     */ constructor(triggerOptions, target, value, condition){
        super(triggerOptions, condition);
        this.value = value;
        this._target = target;
    }
    /**
     * Execute the action and store the value on the target state property.
     */ execute() {
        this._target.state = this.value;
    }
    /**
     * Serializes the actions and its related information.
     * @param parent defines the object to serialize in
     * @returns the serialized object
     */ serialize(parent) {
        return super._serialize({
            name: "SetStateAction",
            properties: [
                (0, $5lx8l.Action)._GetTargetProperty(this._target),
                {
                    name: "value",
                    value: this.value
                }
            ]
        }, parent);
    }
}
class $77d671d6e17cb239$export$a54ba1c3e3099a3e extends (0, $5lx8l.Action) {
    /**
     * Instantiate the action
     * @param triggerOptions defines the trigger options
     * @param target defines the object containing the property
     * @param propertyPath defines the path of the property to set in the target
     * @param value defines the value to set in the property
     * @param condition defines the trigger related conditions
     */ constructor(triggerOptions, target, propertyPath, value, condition){
        super(triggerOptions, condition);
        this.propertyPath = propertyPath;
        this.value = value;
        this._target = this._effectiveTarget = target;
    }
    /** @internal */ _prepare() {
        this._effectiveTarget = this._getEffectiveTarget(this._effectiveTarget, this.propertyPath);
        this._property = this._getProperty(this.propertyPath);
    }
    /**
     * Execute the action and set the targeted property to the desired value.
     */ execute() {
        this._effectiveTarget[this._property] = this.value;
        if (this._target.markAsDirty) this._target.markAsDirty(this._property);
    }
    /**
     * Serializes the actions and its related information.
     * @param parent defines the object to serialize in
     * @returns the serialized object
     */ serialize(parent) {
        return super._serialize({
            name: "SetValueAction",
            properties: [
                (0, $5lx8l.Action)._GetTargetProperty(this._target),
                {
                    name: "propertyPath",
                    value: this.propertyPath
                },
                {
                    name: "value",
                    value: (0, $5lx8l.Action)._SerializeValueAsString(this.value)
                }
            ]
        }, parent);
    }
}
class $77d671d6e17cb239$export$1447cf7351040a1a extends (0, $5lx8l.Action) {
    /**
     * Instantiate the action
     * @param triggerOptions defines the trigger options
     * @param target defines the object containing the property
     * @param propertyPath defines the path of the property to increment in the target
     * @param value defines the value value we should increment the property by
     * @param condition defines the trigger related conditions
     */ constructor(triggerOptions, target, propertyPath, value, condition){
        super(triggerOptions, condition);
        this.propertyPath = propertyPath;
        this.value = value;
        this._target = this._effectiveTarget = target;
    }
    /** @internal */ _prepare() {
        this._effectiveTarget = this._getEffectiveTarget(this._effectiveTarget, this.propertyPath);
        this._property = this._getProperty(this.propertyPath);
        if (typeof this._effectiveTarget[this._property] !== "number") (0, $kVtWi.Logger).Warn("Warning: IncrementValueAction can only be used with number values");
    }
    /**
     * Execute the action and increment the target of the value amount.
     */ execute() {
        this._effectiveTarget[this._property] += this.value;
        if (this._target.markAsDirty) this._target.markAsDirty(this._property);
    }
    /**
     * Serializes the actions and its related information.
     * @param parent defines the object to serialize in
     * @returns the serialized object
     */ serialize(parent) {
        return super._serialize({
            name: "IncrementValueAction",
            properties: [
                (0, $5lx8l.Action)._GetTargetProperty(this._target),
                {
                    name: "propertyPath",
                    value: this.propertyPath
                },
                {
                    name: "value",
                    value: (0, $5lx8l.Action)._SerializeValueAsString(this.value)
                }
            ]
        }, parent);
    }
}
class $77d671d6e17cb239$export$df8cb2be925940f3 extends (0, $5lx8l.Action) {
    /**
     * Instantiate the action
     * @param triggerOptions defines the trigger options
     * @param target defines the target animation or animation name
     * @param from defines from where the animation should start (animation frame)
     * @param to defines where the animation should stop (animation frame)
     * @param loop defines if the animation should loop or stop after the first play
     * @param condition defines the trigger related conditions
     */ constructor(triggerOptions, target, from, to, loop, condition){
        super(triggerOptions, condition);
        this.from = from;
        this.to = to;
        this.loop = loop;
        this._target = target;
    }
    /** @internal */ _prepare() {}
    /**
     * Execute the action and play the animation.
     */ execute() {
        const scene = this._actionManager.getScene();
        scene.beginAnimation(this._target, this.from, this.to, this.loop);
    }
    /**
     * Serializes the actions and its related information.
     * @param parent defines the object to serialize in
     * @returns the serialized object
     */ serialize(parent) {
        return super._serialize({
            name: "PlayAnimationAction",
            properties: [
                (0, $5lx8l.Action)._GetTargetProperty(this._target),
                {
                    name: "from",
                    value: String(this.from)
                },
                {
                    name: "to",
                    value: String(this.to)
                },
                {
                    name: "loop",
                    value: (0, $5lx8l.Action)._SerializeValueAsString(this.loop) || false
                }
            ]
        }, parent);
    }
}
class $77d671d6e17cb239$export$c993efa1daf7a9c7 extends (0, $5lx8l.Action) {
    /**
     * Instantiate the action
     * @param triggerOptions defines the trigger options
     * @param target defines the target animation or animation name
     * @param condition defines the trigger related conditions
     */ constructor(triggerOptions, target, condition){
        super(triggerOptions, condition);
        this._target = target;
    }
    /** @internal */ _prepare() {}
    /**
     * Execute the action and stop the animation.
     */ execute() {
        const scene = this._actionManager.getScene();
        scene.stopAnimation(this._target);
    }
    /**
     * Serializes the actions and its related information.
     * @param parent defines the object to serialize in
     * @returns the serialized object
     */ serialize(parent) {
        return super._serialize({
            name: "StopAnimationAction",
            properties: [
                (0, $5lx8l.Action)._GetTargetProperty(this._target)
            ]
        }, parent);
    }
}
class $77d671d6e17cb239$export$f98ea23232c8b722 extends (0, $5lx8l.Action) {
    /**
     * Instantiate the action
     * @param triggerOptions defines the trigger options
     * @param condition defines the trigger related conditions
     */ constructor(triggerOptions = 0, condition){
        super(triggerOptions, condition);
    }
    /**
     * Execute the action and do nothing.
     */ execute() {}
    /**
     * Serializes the actions and its related information.
     * @param parent defines the object to serialize in
     * @returns the serialized object
     */ serialize(parent) {
        return super._serialize({
            name: "DoNothingAction",
            properties: []
        }, parent);
    }
}
class $77d671d6e17cb239$export$359de0d9952b4d96 extends (0, $5lx8l.Action) {
    /**
     * Instantiate the action
     * @param triggerOptions defines the trigger options
     * @param children defines the list of aggregated animations to run
     * @param condition defines the trigger related conditions
     * @param enableChildrenConditions defines if the children actions conditions should be check before execution
     */ constructor(triggerOptions, children, condition, enableChildrenConditions = true){
        super(triggerOptions, condition);
        this.children = children;
        this.enableChildrenConditions = enableChildrenConditions;
    }
    /** @internal */ _prepare() {
        for(let index = 0; index < this.children.length; index++){
            this.children[index]._actionManager = this._actionManager;
            this.children[index]._prepare();
        }
    }
    /**
     * Execute the action and executes all the aggregated actions.
     * @param evt event to execute
     */ execute(evt) {
        for (const action of this.children)if (!this.enableChildrenConditions || action._evaluateConditionForCurrentFrame()) action.execute(evt);
    }
    /**
     * Serializes the actions and its related information.
     * @param parent defines the object to serialize in
     * @returns the serialized object
     */ serialize(parent) {
        const serializationObject = super._serialize({
            name: "CombineAction",
            properties: [],
            combine: []
        }, parent);
        for(let i = 0; i < this.children.length; i++)serializationObject.combine.push(this.children[i].serialize(null));
        return serializationObject;
    }
}
class $77d671d6e17cb239$export$83ff33bbf195817a extends (0, $5lx8l.Action) {
    /**
     * Instantiate the action
     * @param triggerOptions defines the trigger options
     * @param func defines the callback function to run
     * @param condition defines the trigger related conditions
     */ constructor(triggerOptions, func, condition){
        super(triggerOptions, condition);
        this.func = func;
    }
    /**
     * Execute the action and run the attached code.
     * @param evt event to execute
     */ execute(evt) {
        this.func(evt);
    }
}
class $77d671d6e17cb239$export$202e37f3f439176a extends (0, $5lx8l.Action) {
    /**
     * Instantiate the action
     * @param triggerOptions defines the trigger options
     * @param target defines the target containing the parent property
     * @param parent defines from where the animation should start (animation frame)
     * @param condition defines the trigger related conditions
     */ constructor(triggerOptions, target, parent, condition){
        super(triggerOptions, condition);
        this._target = target;
        this._parent = parent;
    }
    /** @internal */ _prepare() {}
    /**
     * Execute the action and set the parent property.
     */ execute() {
        if (this._target.parent === this._parent) return;
        const invertParentWorldMatrix = this._parent.getWorldMatrix().clone();
        invertParentWorldMatrix.invert();
        this._target.position = (0, $ha1VO.Vector3).TransformCoordinates(this._target.position, invertParentWorldMatrix);
        this._target.parent = this._parent;
    }
    /**
     * Serializes the actions and its related information.
     * @param parent defines the object to serialize in
     * @returns the serialized object
     */ serialize(parent) {
        return super._serialize({
            name: "SetParentAction",
            properties: [
                (0, $5lx8l.Action)._GetTargetProperty(this._target),
                (0, $5lx8l.Action)._GetTargetProperty(this._parent)
            ]
        }, parent);
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.SetParentAction", $77d671d6e17cb239$export$202e37f3f439176a);
(0, $8DoUR.RegisterClass)("BABYLON.ExecuteCodeAction", $77d671d6e17cb239$export$83ff33bbf195817a);
(0, $8DoUR.RegisterClass)("BABYLON.DoNothingAction", $77d671d6e17cb239$export$f98ea23232c8b722);
(0, $8DoUR.RegisterClass)("BABYLON.StopAnimationAction", $77d671d6e17cb239$export$c993efa1daf7a9c7);
(0, $8DoUR.RegisterClass)("BABYLON.PlayAnimationAction", $77d671d6e17cb239$export$df8cb2be925940f3);
(0, $8DoUR.RegisterClass)("BABYLON.IncrementValueAction", $77d671d6e17cb239$export$1447cf7351040a1a);
(0, $8DoUR.RegisterClass)("BABYLON.SetValueAction", $77d671d6e17cb239$export$a54ba1c3e3099a3e);
(0, $8DoUR.RegisterClass)("BABYLON.SetStateAction", $77d671d6e17cb239$export$e5e9a31807e6477);
(0, $8DoUR.RegisterClass)("BABYLON.SetParentAction", $77d671d6e17cb239$export$202e37f3f439176a);
(0, $8DoUR.RegisterClass)("BABYLON.SwitchBooleanAction", $77d671d6e17cb239$export$1b56680778b66700);
(0, $8DoUR.RegisterClass)("BABYLON.CombineAction", $77d671d6e17cb239$export$359de0d9952b4d96);

});
parcelRegister("kVtWi", function(module, exports) {

$parcel$export(module.exports, "Logger", () => $f3c05ad6b036a45a$export$efa9a398d6368992);
/* eslint-disable no-console */ /**
 * Logger used throughout the application to allow configuration of
 * the log level required for the messages.
 */ class $f3c05ad6b036a45a$export$efa9a398d6368992 {
    static _CheckLimit(message, limit) {
        let entry = $f3c05ad6b036a45a$export$efa9a398d6368992._LogLimitOutputs[message];
        if (!entry) {
            entry = {
                limit: limit,
                current: 1
            };
            $f3c05ad6b036a45a$export$efa9a398d6368992._LogLimitOutputs[message] = entry;
        } else entry.current++;
        return entry.current <= entry.limit;
    }
    static _GenerateLimitMessage(message, level = 1) {
        const entry = $f3c05ad6b036a45a$export$efa9a398d6368992._LogLimitOutputs[message];
        if (!entry || !$f3c05ad6b036a45a$export$efa9a398d6368992.MessageLimitReached) return;
        const type = this._Levels[level];
        if (entry.current === entry.limit) $f3c05ad6b036a45a$export$efa9a398d6368992[type.name]($f3c05ad6b036a45a$export$efa9a398d6368992.MessageLimitReached.replace(/%LIMIT%/g, "" + entry.limit).replace(/%TYPE%/g, type.name ?? ""));
    }
    static _AddLogEntry(entry) {
        $f3c05ad6b036a45a$export$efa9a398d6368992._LogCache = entry + $f3c05ad6b036a45a$export$efa9a398d6368992._LogCache;
        if ($f3c05ad6b036a45a$export$efa9a398d6368992.OnNewCacheEntry) $f3c05ad6b036a45a$export$efa9a398d6368992.OnNewCacheEntry(entry);
    }
    static _FormatMessage(message) {
        const padStr = (i)=>i < 10 ? "0" + i : "" + i;
        const date = new Date();
        return "[" + padStr(date.getHours()) + ":" + padStr(date.getMinutes()) + ":" + padStr(date.getSeconds()) + "]: " + message;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    static _LogDisabled(message, limit) {
    // nothing to do
    }
    static _LogEnabled(level = 1, message, limit) {
        // take first message if array
        const msg = Array.isArray(message) ? message[0] : message;
        if (limit !== undefined && !$f3c05ad6b036a45a$export$efa9a398d6368992._CheckLimit(msg, limit)) return;
        const formattedMessage = $f3c05ad6b036a45a$export$efa9a398d6368992._FormatMessage(msg);
        const type = this._Levels[level];
        const optionals = Array.isArray(message) ? message.slice(1) : [];
        type.logFunc && type.logFunc("BJS - " + formattedMessage, ...optionals);
        const entry = `<div style='color:${type.color}'>${formattedMessage}</div><br>`;
        $f3c05ad6b036a45a$export$efa9a398d6368992._AddLogEntry(entry);
        $f3c05ad6b036a45a$export$efa9a398d6368992._GenerateLimitMessage(msg, level);
    }
    /**
     * Gets current log cache (list of logs)
     */ static get LogCache() {
        return $f3c05ad6b036a45a$export$efa9a398d6368992._LogCache;
    }
    /**
     * Clears the log cache
     */ static ClearLogCache() {
        $f3c05ad6b036a45a$export$efa9a398d6368992._LogCache = "";
        $f3c05ad6b036a45a$export$efa9a398d6368992._LogLimitOutputs = {};
        $f3c05ad6b036a45a$export$efa9a398d6368992.errorsCount = 0;
    }
    /**
     * Sets the current log level (MessageLogLevel / WarningLogLevel / ErrorLogLevel)
     */ static set LogLevels(level) {
        $f3c05ad6b036a45a$export$efa9a398d6368992.Log = $f3c05ad6b036a45a$export$efa9a398d6368992._LogDisabled;
        $f3c05ad6b036a45a$export$efa9a398d6368992.Warn = $f3c05ad6b036a45a$export$efa9a398d6368992._LogDisabled;
        $f3c05ad6b036a45a$export$efa9a398d6368992.Error = $f3c05ad6b036a45a$export$efa9a398d6368992._LogDisabled;
        [
            $f3c05ad6b036a45a$export$efa9a398d6368992.MessageLogLevel,
            $f3c05ad6b036a45a$export$efa9a398d6368992.WarningLogLevel,
            $f3c05ad6b036a45a$export$efa9a398d6368992.ErrorLogLevel
        ].forEach((l)=>{
            if ((level & l) === l) {
                const type = this._Levels[l];
                $f3c05ad6b036a45a$export$efa9a398d6368992[type.name] = $f3c05ad6b036a45a$export$efa9a398d6368992._LogEnabled.bind($f3c05ad6b036a45a$export$efa9a398d6368992, l);
            }
        });
    }
}
/**
 * No log
 */ $f3c05ad6b036a45a$export$efa9a398d6368992.NoneLogLevel = 0;
/**
 * Only message logs
 */ $f3c05ad6b036a45a$export$efa9a398d6368992.MessageLogLevel = 1;
/**
 * Only warning logs
 */ $f3c05ad6b036a45a$export$efa9a398d6368992.WarningLogLevel = 2;
/**
 * Only error logs
 */ $f3c05ad6b036a45a$export$efa9a398d6368992.ErrorLogLevel = 4;
/**
 * All logs
 */ $f3c05ad6b036a45a$export$efa9a398d6368992.AllLogLevel = 7;
/**
 * Message to display when a message has been logged too many times
 */ $f3c05ad6b036a45a$export$efa9a398d6368992.MessageLimitReached = "Too many %TYPE%s (%LIMIT%), no more %TYPE%s will be reported for this message.";
$f3c05ad6b036a45a$export$efa9a398d6368992._LogCache = "";
$f3c05ad6b036a45a$export$efa9a398d6368992._LogLimitOutputs = {};
// levels according to the (binary) numbering.
$f3c05ad6b036a45a$export$efa9a398d6368992._Levels = [
    {},
    {
        color: "white",
        logFunc: console.log,
        name: "Log"
    },
    {
        color: "orange",
        logFunc: console.warn,
        name: "Warn"
    },
    {},
    {
        color: "red",
        logFunc: console.error,
        name: "Error"
    }
];
/**
 * Gets a value indicating the number of loading errors
 * @ignorenaming
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
$f3c05ad6b036a45a$export$efa9a398d6368992.errorsCount = 0;
/**
 * Log a message to the console
 */ $f3c05ad6b036a45a$export$efa9a398d6368992.Log = $f3c05ad6b036a45a$export$efa9a398d6368992._LogEnabled.bind($f3c05ad6b036a45a$export$efa9a398d6368992, $f3c05ad6b036a45a$export$efa9a398d6368992.MessageLogLevel);
/**
 * Write a warning message to the console
 */ $f3c05ad6b036a45a$export$efa9a398d6368992.Warn = $f3c05ad6b036a45a$export$efa9a398d6368992._LogEnabled.bind($f3c05ad6b036a45a$export$efa9a398d6368992, $f3c05ad6b036a45a$export$efa9a398d6368992.WarningLogLevel);
/**
 * Write an error message to the console
 */ $f3c05ad6b036a45a$export$efa9a398d6368992.Error = $f3c05ad6b036a45a$export$efa9a398d6368992._LogEnabled.bind($f3c05ad6b036a45a$export$efa9a398d6368992, $f3c05ad6b036a45a$export$efa9a398d6368992.ErrorLogLevel);

});


parcelRegister("fhgis", function(module, exports) {

$parcel$export(module.exports, "DeepCopier", () => $b1f515ba352436f8$export$9500e724ea15a79);

var $kVtWi = parcelRequire("kVtWi");
const $b1f515ba352436f8$var$CloneValue = (source, destinationObject, shallowCopyValues)=>{
    if (!source) return null;
    if (source.getClassName && source.getClassName() === "Mesh") return null;
    if (source.getClassName && (source.getClassName() === "SubMesh" || source.getClassName() === "PhysicsBody")) return source.clone(destinationObject);
    else if (source.clone) return source.clone();
    else if (Array.isArray(source)) return source.slice();
    else if (shallowCopyValues && typeof source === "object") return {
        ...source
    };
    return null;
};
function $b1f515ba352436f8$var$GetAllPropertyNames(obj) {
    const props = [];
    do Object.getOwnPropertyNames(obj).forEach(function(prop) {
        if (props.indexOf(prop) === -1) props.push(prop);
    });
    while (obj = Object.getPrototypeOf(obj));
    return props;
}
class $b1f515ba352436f8$export$9500e724ea15a79 {
    /**
     * Tries to copy an object by duplicating every property
     * @param source defines the source object
     * @param destination defines the target object
     * @param doNotCopyList defines a list of properties to avoid
     * @param mustCopyList defines a list of properties to copy (even if they start with _)
     * @param shallowCopyValues defines wether properties referencing objects (none cloneable) must be shallow copied (false by default)
     * @remarks shallowCopyValues will not instantite the copied values which makes it only usable for "JSON objects"
     */ static DeepCopy(source, destination, doNotCopyList, mustCopyList, shallowCopyValues = false) {
        const properties = $b1f515ba352436f8$var$GetAllPropertyNames(source);
        for (const prop of properties){
            if (prop[0] === "_" && (!mustCopyList || mustCopyList.indexOf(prop) === -1)) continue;
            if (prop.endsWith("Observable")) continue;
            if (doNotCopyList && doNotCopyList.indexOf(prop) !== -1) continue;
            const sourceValue = source[prop];
            const typeOfSourceValue = typeof sourceValue;
            if (typeOfSourceValue === "function") continue;
            try {
                if (typeOfSourceValue === "object") {
                    if (sourceValue instanceof Uint8Array) destination[prop] = Uint8Array.from(sourceValue);
                    else if (sourceValue instanceof Array) {
                        destination[prop] = [];
                        if (sourceValue.length > 0) {
                            if (typeof sourceValue[0] == "object") for(let index = 0; index < sourceValue.length; index++){
                                const clonedValue = $b1f515ba352436f8$var$CloneValue(sourceValue[index], destination, shallowCopyValues);
                                if (destination[prop].indexOf(clonedValue) === -1) // Test if auto inject was not done
                                destination[prop].push(clonedValue);
                            }
                            else destination[prop] = sourceValue.slice(0);
                        }
                    } else destination[prop] = $b1f515ba352436f8$var$CloneValue(sourceValue, destination, shallowCopyValues);
                } else destination[prop] = sourceValue;
            } catch (e) {
                // Log a warning (it could be because of a read-only property)
                (0, $kVtWi.Logger).Warn(e.message);
            }
        }
    }
}

});


parcelRegister("crJJ6", function(module, exports) {

$parcel$export(module.exports, "PlaySoundAction", () => $90fb79f99a74ba59$export$1d76c50e7d2b995f);
$parcel$export(module.exports, "StopSoundAction", () => $90fb79f99a74ba59$export$b87c970610941f0e);

var $5lx8l = parcelRequire("5lx8l");

var $8DoUR = parcelRequire("8DoUR");
class $90fb79f99a74ba59$export$1d76c50e7d2b995f extends (0, $5lx8l.Action) {
    /**
     * Instantiate the action
     * @param triggerOptions defines the trigger options
     * @param sound defines the sound to play
     * @param condition defines the trigger related conditions
     */ constructor(triggerOptions, sound, condition){
        super(triggerOptions, condition);
        this._sound = sound;
    }
    /** @internal */ _prepare() {}
    /**
     * Execute the action and play the sound.
     */ execute() {
        if (this._sound !== undefined) this._sound.play();
    }
    /**
     * Serializes the actions and its related information.
     * @param parent defines the object to serialize in
     * @returns the serialized object
     */ serialize(parent) {
        return super._serialize({
            name: "PlaySoundAction",
            properties: [
                {
                    name: "sound",
                    value: this._sound.name
                }
            ]
        }, parent);
    }
}
class $90fb79f99a74ba59$export$b87c970610941f0e extends (0, $5lx8l.Action) {
    /**
     * Instantiate the action
     * @param triggerOptions defines the trigger options
     * @param sound defines the sound to stop
     * @param condition defines the trigger related conditions
     */ constructor(triggerOptions, sound, condition){
        super(triggerOptions, condition);
        this._sound = sound;
    }
    /** @internal */ _prepare() {}
    /**
     * Execute the action and stop the sound.
     */ execute() {
        if (this._sound !== undefined) this._sound.stop();
    }
    /**
     * Serializes the actions and its related information.
     * @param parent defines the object to serialize in
     * @returns the serialized object
     */ serialize(parent) {
        return super._serialize({
            name: "StopSoundAction",
            properties: [
                {
                    name: "sound",
                    value: this._sound.name
                }
            ]
        }, parent);
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.PlaySoundAction", $90fb79f99a74ba59$export$1d76c50e7d2b995f);
(0, $8DoUR.RegisterClass)("BABYLON.StopSoundAction", $90fb79f99a74ba59$export$b87c970610941f0e);

});

parcelRegister("3Pmts", function(module, exports) {

$parcel$export(module.exports, "InterpolateValueAction", () => $2c979168aa8c9bdc$export$ceff5bb8ee2d90b5);

var $5lx8l = parcelRequire("5lx8l");

var $kVtWi = parcelRequire("kVtWi");

var $diGQf = parcelRequire("diGQf");

var $7etnY = parcelRequire("7etnY");

var $ha1VO = parcelRequire("ha1VO");

var $lWogh = parcelRequire("lWogh");

var $8DoUR = parcelRequire("8DoUR");
class $2c979168aa8c9bdc$export$ceff5bb8ee2d90b5 extends (0, $5lx8l.Action) {
    /**
     * Instantiate the action
     * @param triggerOptions defines the trigger options
     * @param target defines the object containing the value to interpolate
     * @param propertyPath defines the path to the property in the target object
     * @param value defines the target value at the end of the interpolation
     * @param duration defines the time it will take for the property to interpolate to the value.
     * @param condition defines the trigger related conditions
     * @param stopOtherAnimations defines if the other scene animations should be stopped when the action has been triggered
     * @param onInterpolationDone defines a callback raised once the interpolation animation has been done
     */ constructor(triggerOptions, target, propertyPath, value, duration = 1000, condition, stopOtherAnimations, onInterpolationDone){
        super(triggerOptions, condition);
        /**
         * Defines the time it will take for the property to interpolate to the value.
         */ this.duration = 1000;
        /**
         * Observable triggered once the interpolation animation has been done.
         */ this.onInterpolationDoneObservable = new (0, $diGQf.Observable)();
        this.propertyPath = propertyPath;
        this.value = value;
        this.duration = duration;
        this.stopOtherAnimations = stopOtherAnimations;
        this.onInterpolationDone = onInterpolationDone;
        this._target = this._effectiveTarget = target;
    }
    /** @internal */ _prepare() {
        this._effectiveTarget = this._getEffectiveTarget(this._effectiveTarget, this.propertyPath);
        this._property = this._getProperty(this.propertyPath);
    }
    /**
     * Execute the action starts the value interpolation.
     */ execute() {
        const scene = this._actionManager.getScene();
        const keys = [
            {
                frame: 0,
                value: this._effectiveTarget[this._property]
            },
            {
                frame: 100,
                value: this.value
            }
        ];
        let dataType;
        if (typeof this.value === "number") dataType = (0, $lWogh.Animation).ANIMATIONTYPE_FLOAT;
        else if (this.value instanceof (0, $7etnY.Color3)) dataType = (0, $lWogh.Animation).ANIMATIONTYPE_COLOR3;
        else if (this.value instanceof (0, $ha1VO.Vector3)) dataType = (0, $lWogh.Animation).ANIMATIONTYPE_VECTOR3;
        else if (this.value instanceof (0, $ha1VO.Matrix)) dataType = (0, $lWogh.Animation).ANIMATIONTYPE_MATRIX;
        else if (this.value instanceof (0, $ha1VO.Quaternion)) dataType = (0, $lWogh.Animation).ANIMATIONTYPE_QUATERNION;
        else {
            (0, $kVtWi.Logger).Warn("InterpolateValueAction: Unsupported type (" + typeof this.value + ")");
            return;
        }
        const animation = new (0, $lWogh.Animation)("InterpolateValueAction", this._property, 100 * (1000.0 / this.duration), dataType, (0, $lWogh.Animation).ANIMATIONLOOPMODE_CONSTANT);
        animation.setKeys(keys);
        if (this.stopOtherAnimations) scene.stopAnimation(this._effectiveTarget);
        const wrapper = ()=>{
            this.onInterpolationDoneObservable.notifyObservers(this);
            if (this.onInterpolationDone) this.onInterpolationDone();
        };
        scene.beginDirectAnimation(this._effectiveTarget, [
            animation
        ], 0, 100, false, 1, wrapper);
    }
    /**
     * Serializes the actions and its related information.
     * @param parent defines the object to serialize in
     * @returns the serialized object
     */ serialize(parent) {
        return super._serialize({
            name: "InterpolateValueAction",
            properties: [
                (0, $5lx8l.Action)._GetTargetProperty(this._target),
                {
                    name: "propertyPath",
                    value: this.propertyPath
                },
                {
                    name: "value",
                    value: (0, $5lx8l.Action)._SerializeValueAsString(this.value)
                },
                {
                    name: "duration",
                    value: (0, $5lx8l.Action)._SerializeValueAsString(this.duration)
                },
                {
                    name: "stopOtherAnimations",
                    value: (0, $5lx8l.Action)._SerializeValueAsString(this.stopOtherAnimations) || false
                }
            ]
        }, parent);
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.InterpolateValueAction", $2c979168aa8c9bdc$export$ceff5bb8ee2d90b5);

});
parcelRegister("lWogh", function(module, exports) {

$parcel$export(module.exports, "_staticOffsetValueQuaternion", () => $ff91d59daa75db10$export$519770a712ff637a);
$parcel$export(module.exports, "_staticOffsetValueVector3", () => $ff91d59daa75db10$export$499344e023610249);
$parcel$export(module.exports, "_staticOffsetValueVector2", () => $ff91d59daa75db10$export$6d83b9c8972825ff);
$parcel$export(module.exports, "_staticOffsetValueSize", () => $ff91d59daa75db10$export$1246757db6a7aaea);
$parcel$export(module.exports, "_staticOffsetValueColor3", () => $ff91d59daa75db10$export$d98e5cb9b7a6dc07);
$parcel$export(module.exports, "_staticOffsetValueColor4", () => $ff91d59daa75db10$export$6e4972fa3772cc35);
$parcel$export(module.exports, "Animation", () => $ff91d59daa75db10$export$c35d437ae5945fcd);

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $1VEEL = parcelRequire("1VEEL");

var $8DoUR = parcelRequire("8DoUR");

var $GNvkC = parcelRequire("GNvkC");

var $knVpn = parcelRequire("knVpn");

var $bgssx = parcelRequire("bgssx");

var $93o7r = parcelRequire("93o7r");

var $hUzEl = parcelRequire("hUzEl");

var $6Ho1L = parcelRequire("6Ho1L");
const $ff91d59daa75db10$export$519770a712ff637a = Object.freeze(new (0, $ha1VO.Quaternion)(0, 0, 0, 0));
const $ff91d59daa75db10$export$499344e023610249 = Object.freeze((0, $ha1VO.Vector3).Zero());
const $ff91d59daa75db10$export$6d83b9c8972825ff = Object.freeze((0, $ha1VO.Vector2).Zero());
const $ff91d59daa75db10$export$1246757db6a7aaea = Object.freeze((0, $93o7r.Size).Zero());
const $ff91d59daa75db10$export$d98e5cb9b7a6dc07 = Object.freeze((0, $7etnY.Color3).Black());
const $ff91d59daa75db10$export$6e4972fa3772cc35 = Object.freeze(new (0, $7etnY.Color4)(0, 0, 0, 0));
const $ff91d59daa75db10$var$evaluateAnimationState = {
    key: 0,
    repeatCount: 0,
    loopMode: 2 /*Animation.ANIMATIONLOOPMODE_CONSTANT*/ 
};
class $ff91d59daa75db10$export$c35d437ae5945fcd {
    /**
     * @internal Internal use
     */ static _PrepareAnimation(name, targetProperty, framePerSecond, totalFrame, from, to, loopMode, easingFunction) {
        let dataType = undefined;
        if (!isNaN(parseFloat(from)) && isFinite(from)) dataType = $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_FLOAT;
        else if (from instanceof (0, $ha1VO.Quaternion)) dataType = $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_QUATERNION;
        else if (from instanceof (0, $ha1VO.Vector3)) dataType = $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_VECTOR3;
        else if (from instanceof (0, $ha1VO.Vector2)) dataType = $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_VECTOR2;
        else if (from instanceof (0, $7etnY.Color3)) dataType = $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_COLOR3;
        else if (from instanceof (0, $7etnY.Color4)) dataType = $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_COLOR4;
        else if (from instanceof (0, $93o7r.Size)) dataType = $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_SIZE;
        if (dataType == undefined) return null;
        const animation = new $ff91d59daa75db10$export$c35d437ae5945fcd(name, targetProperty, framePerSecond, dataType, loopMode);
        const keys = [
            {
                frame: 0,
                value: from
            },
            {
                frame: totalFrame,
                value: to
            }
        ];
        animation.setKeys(keys);
        if (easingFunction !== undefined) animation.setEasingFunction(easingFunction);
        return animation;
    }
    /**
     * Sets up an animation
     * @param property The property to animate
     * @param animationType The animation type to apply
     * @param framePerSecond The frames per second of the animation
     * @param easingFunction The easing function used in the animation
     * @returns The created animation
     */ static CreateAnimation(property, animationType, framePerSecond, easingFunction) {
        const animation = new $ff91d59daa75db10$export$c35d437ae5945fcd(property + "Animation", property, framePerSecond, animationType, $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CONSTANT);
        animation.setEasingFunction(easingFunction);
        return animation;
    }
    /**
     * Create and start an animation on a node
     * @param name defines the name of the global animation that will be run on all nodes
     * @param target defines the target where the animation will take place
     * @param targetProperty defines property to animate
     * @param framePerSecond defines the number of frame per second yo use
     * @param totalFrame defines the number of frames in total
     * @param from defines the initial value
     * @param to defines the final value
     * @param loopMode defines which loop mode you want to use (off by default)
     * @param easingFunction defines the easing function to use (linear by default)
     * @param onAnimationEnd defines the callback to call when animation end
     * @param scene defines the hosting scene
     * @returns the animatable created for this animation
     */ static CreateAndStartAnimation(name, target, targetProperty, framePerSecond, totalFrame, from, to, loopMode, easingFunction, onAnimationEnd, scene) {
        const animation = $ff91d59daa75db10$export$c35d437ae5945fcd._PrepareAnimation(name, targetProperty, framePerSecond, totalFrame, from, to, loopMode, easingFunction);
        if (!animation) return null;
        if (target.getScene) scene = target.getScene();
        if (!scene) return null;
        return scene.beginDirectAnimation(target, [
            animation
        ], 0, totalFrame, animation.loopMode === 1, 1.0, onAnimationEnd);
    }
    /**
     * Create and start an animation on a node and its descendants
     * @param name defines the name of the global animation that will be run on all nodes
     * @param node defines the root node where the animation will take place
     * @param directDescendantsOnly if true only direct descendants will be used, if false direct and also indirect (children of children, an so on in a recursive manner) descendants will be used
     * @param targetProperty defines property to animate
     * @param framePerSecond defines the number of frame per second to use
     * @param totalFrame defines the number of frames in total
     * @param from defines the initial value
     * @param to defines the final value
     * @param loopMode defines which loop mode you want to use (off by default)
     * @param easingFunction defines the easing function to use (linear by default)
     * @param onAnimationEnd defines the callback to call when an animation ends (will be called once per node)
     * @returns the list of animatables created for all nodes
     * @example https://www.babylonjs-playground.com/#MH0VLI
     */ static CreateAndStartHierarchyAnimation(name, node, directDescendantsOnly, targetProperty, framePerSecond, totalFrame, from, to, loopMode, easingFunction, onAnimationEnd) {
        const animation = $ff91d59daa75db10$export$c35d437ae5945fcd._PrepareAnimation(name, targetProperty, framePerSecond, totalFrame, from, to, loopMode, easingFunction);
        if (!animation) return null;
        const scene = node.getScene();
        return scene.beginDirectHierarchyAnimation(node, directDescendantsOnly, [
            animation
        ], 0, totalFrame, animation.loopMode === 1, 1.0, onAnimationEnd);
    }
    /**
     * Creates a new animation, merges it with the existing animations and starts it
     * @param name Name of the animation
     * @param node Node which contains the scene that begins the animations
     * @param targetProperty Specifies which property to animate
     * @param framePerSecond The frames per second of the animation
     * @param totalFrame The total number of frames
     * @param from The frame at the beginning of the animation
     * @param to The frame at the end of the animation
     * @param loopMode Specifies the loop mode of the animation
     * @param easingFunction (Optional) The easing function of the animation, which allow custom mathematical formulas for animations
     * @param onAnimationEnd Callback to run once the animation is complete
     * @returns Nullable animation
     */ static CreateMergeAndStartAnimation(name, node, targetProperty, framePerSecond, totalFrame, from, to, loopMode, easingFunction, onAnimationEnd) {
        const animation = $ff91d59daa75db10$export$c35d437ae5945fcd._PrepareAnimation(name, targetProperty, framePerSecond, totalFrame, from, to, loopMode, easingFunction);
        if (!animation) return null;
        node.animations.push(animation);
        return node.getScene().beginAnimation(node, 0, totalFrame, animation.loopMode === 1, 1.0, onAnimationEnd);
    }
    /** @internal */ static MakeAnimationAdditive(sourceAnimation, referenceFrameOrOptions, range, cloneOriginal = false, clonedName) {
        let options;
        if (typeof referenceFrameOrOptions === "object") options = referenceFrameOrOptions;
        else options = {
            referenceFrame: referenceFrameOrOptions ?? 0,
            range: range,
            cloneOriginalAnimation: cloneOriginal,
            clonedAnimationName: clonedName
        };
        let animation = sourceAnimation;
        if (options.cloneOriginalAnimation) {
            animation = sourceAnimation.clone();
            animation.name = options.clonedAnimationName || animation.name;
        }
        if (!animation._keys.length) return animation;
        const referenceFrame = options.referenceFrame && options.referenceFrame >= 0 ? options.referenceFrame : 0;
        let startIndex = 0;
        const firstKey = animation._keys[0];
        let endIndex = animation._keys.length - 1;
        const lastKey = animation._keys[endIndex];
        const valueStore = {
            referenceValue: firstKey.value,
            referencePosition: (0, $ha1VO.TmpVectors).Vector3[0],
            referenceQuaternion: (0, $ha1VO.TmpVectors).Quaternion[0],
            referenceScaling: (0, $ha1VO.TmpVectors).Vector3[1],
            keyPosition: (0, $ha1VO.TmpVectors).Vector3[2],
            keyQuaternion: (0, $ha1VO.TmpVectors).Quaternion[1],
            keyScaling: (0, $ha1VO.TmpVectors).Vector3[3]
        };
        let from = firstKey.frame;
        let to = lastKey.frame;
        if (options.range) {
            const rangeValue = animation.getRange(options.range);
            if (rangeValue) {
                from = rangeValue.from;
                to = rangeValue.to;
            }
        } else {
            from = options.fromFrame ?? from;
            to = options.toFrame ?? to;
        }
        if (from !== firstKey.frame) startIndex = animation.createKeyForFrame(from);
        if (to !== lastKey.frame) endIndex = animation.createKeyForFrame(to);
        // There's only one key, so use it
        if (animation._keys.length === 1) {
            const value = animation._getKeyValue(animation._keys[0]);
            valueStore.referenceValue = value.clone ? value.clone() : value;
        } else if (referenceFrame <= firstKey.frame) {
            const value = animation._getKeyValue(firstKey.value);
            valueStore.referenceValue = value.clone ? value.clone() : value;
        } else if (referenceFrame >= lastKey.frame) {
            const value = animation._getKeyValue(lastKey.value);
            valueStore.referenceValue = value.clone ? value.clone() : value;
        } else {
            $ff91d59daa75db10$var$evaluateAnimationState.key = 0;
            const value = animation._interpolate(referenceFrame, $ff91d59daa75db10$var$evaluateAnimationState);
            valueStore.referenceValue = value.clone ? value.clone() : value;
        }
        // Conjugate the quaternion
        if (animation.dataType === $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_QUATERNION) valueStore.referenceValue.normalize().conjugateInPlace();
        else if (animation.dataType === $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_MATRIX) {
            valueStore.referenceValue.decompose(valueStore.referenceScaling, valueStore.referenceQuaternion, valueStore.referencePosition);
            valueStore.referenceQuaternion.normalize().conjugateInPlace();
        }
        let startFrame = Number.MAX_VALUE;
        const clippedKeys = options.clipKeys ? [] : null;
        // Subtract the reference value from all of the key values
        for(let index = startIndex; index <= endIndex; index++){
            let key = animation._keys[index];
            if (clippedKeys) {
                key = {
                    frame: key.frame,
                    value: key.value.clone ? key.value.clone() : key.value,
                    inTangent: key.inTangent,
                    outTangent: key.outTangent,
                    interpolation: key.interpolation,
                    lockedTangent: key.lockedTangent
                };
                if (startFrame === Number.MAX_VALUE) startFrame = key.frame;
                key.frame -= startFrame;
                clippedKeys.push(key);
            }
            // If this key was duplicated to create a frame 0 key, skip it because its value has already been updated
            if (index && animation.dataType !== $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_FLOAT && key.value === firstKey.value) continue;
            switch(animation.dataType){
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_MATRIX:
                    key.value.decompose(valueStore.keyScaling, valueStore.keyQuaternion, valueStore.keyPosition);
                    valueStore.keyPosition.subtractInPlace(valueStore.referencePosition);
                    valueStore.keyScaling.divideInPlace(valueStore.referenceScaling);
                    valueStore.referenceQuaternion.multiplyToRef(valueStore.keyQuaternion, valueStore.keyQuaternion);
                    (0, $ha1VO.Matrix).ComposeToRef(valueStore.keyScaling, valueStore.keyQuaternion, valueStore.keyPosition, key.value);
                    break;
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_QUATERNION:
                    valueStore.referenceValue.multiplyToRef(key.value, key.value);
                    break;
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_VECTOR2:
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_VECTOR3:
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_COLOR3:
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_COLOR4:
                    key.value.subtractToRef(valueStore.referenceValue, key.value);
                    break;
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_SIZE:
                    key.value.width -= valueStore.referenceValue.width;
                    key.value.height -= valueStore.referenceValue.height;
                    break;
                default:
                    key.value -= valueStore.referenceValue;
            }
        }
        if (clippedKeys) animation.setKeys(clippedKeys, true);
        return animation;
    }
    /**
     * Transition property of an host to the target Value
     * @param property The property to transition
     * @param targetValue The target Value of the property
     * @param host The object where the property to animate belongs
     * @param scene Scene used to run the animation
     * @param frameRate Framerate (in frame/s) to use
     * @param transition The transition type we want to use
     * @param duration The duration of the animation, in milliseconds
     * @param onAnimationEnd Callback trigger at the end of the animation
     * @returns Nullable animation
     */ static TransitionTo(property, targetValue, host, scene, frameRate, transition, duration, onAnimationEnd = null) {
        if (duration <= 0) {
            host[property] = targetValue;
            if (onAnimationEnd) onAnimationEnd();
            return null;
        }
        const endFrame = frameRate * (duration / 1000);
        transition.setKeys([
            {
                frame: 0,
                value: host[property].clone ? host[property].clone() : host[property]
            },
            {
                frame: endFrame,
                value: targetValue
            }
        ]);
        if (!host.animations) host.animations = [];
        host.animations.push(transition);
        const animation = scene.beginAnimation(host, 0, endFrame, false);
        animation.onAnimationEnd = onAnimationEnd;
        return animation;
    }
    /**
     * Return the array of runtime animations currently using this animation
     */ get runtimeAnimations() {
        return this._runtimeAnimations;
    }
    /**
     * Specifies if any of the runtime animations are currently running
     */ get hasRunningRuntimeAnimations() {
        for (const runtimeAnimation of this._runtimeAnimations){
            if (!runtimeAnimation.isStopped()) return true;
        }
        return false;
    }
    /**
     * Initializes the animation
     * @param name Name of the animation
     * @param targetProperty Property to animate
     * @param framePerSecond The frames per second of the animation
     * @param dataType The data type of the animation
     * @param loopMode The loop mode of the animation
     * @param enableBlending Specifies if blending should be enabled
     */ constructor(/**Name of the animation */ name, /**Property to animate */ targetProperty, /**The frames per second of the animation */ framePerSecond, /**The data type of the animation */ dataType, /**The loop mode of the animation */ loopMode, /**Specifies if blending should be enabled */ enableBlending){
        this.name = name;
        this.targetProperty = targetProperty;
        this.framePerSecond = framePerSecond;
        this.dataType = dataType;
        this.loopMode = loopMode;
        this.enableBlending = enableBlending;
        /**
         * Stores the easing function of the animation
         */ this._easingFunction = null;
        /**
         * @internal Internal use only
         */ this._runtimeAnimations = new Array();
        /**
         * The set of event that will be linked to this animation
         */ this._events = new Array();
        /**
         * Stores the blending speed of the animation
         */ this.blendingSpeed = 0.01;
        /**
         * Stores the animation ranges for the animation
         */ this._ranges = {};
        this.targetPropertyPath = targetProperty.split(".");
        this.dataType = dataType;
        this.loopMode = loopMode === undefined ? $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CYCLE : loopMode;
        this.uniqueId = $ff91d59daa75db10$export$c35d437ae5945fcd._UniqueIdGenerator++;
    }
    // Methods
    /**
     * Converts the animation to a string
     * @param fullDetails support for multiple levels of logging within scene loading
     * @returns String form of the animation
     */ toString(fullDetails) {
        let ret = "Name: " + this.name + ", property: " + this.targetProperty;
        ret += ", datatype: " + [
            "Float",
            "Vector3",
            "Quaternion",
            "Matrix",
            "Color3",
            "Vector2"
        ][this.dataType];
        ret += ", nKeys: " + (this._keys ? this._keys.length : "none");
        ret += ", nRanges: " + (this._ranges ? Object.keys(this._ranges).length : "none");
        if (fullDetails) {
            ret += ", Ranges: {";
            let first = true;
            for(const name in this._ranges){
                if (first) {
                    ret += ", ";
                    first = false;
                }
                ret += name;
            }
            ret += "}";
        }
        return ret;
    }
    /**
     * Add an event to this animation
     * @param event Event to add
     */ addEvent(event) {
        this._events.push(event);
        this._events.sort((a, b)=>a.frame - b.frame);
    }
    /**
     * Remove all events found at the given frame
     * @param frame The frame to remove events from
     */ removeEvents(frame) {
        for(let index = 0; index < this._events.length; index++)if (this._events[index].frame === frame) {
            this._events.splice(index, 1);
            index--;
        }
    }
    /**
     * Retrieves all the events from the animation
     * @returns Events from the animation
     */ getEvents() {
        return this._events;
    }
    /**
     * Creates an animation range
     * @param name Name of the animation range
     * @param from Starting frame of the animation range
     * @param to Ending frame of the animation
     */ createRange(name, from, to) {
        // check name not already in use; could happen for bones after serialized
        if (!this._ranges[name]) this._ranges[name] = new (0, $knVpn.AnimationRange)(name, from, to);
    }
    /**
     * Deletes an animation range by name
     * @param name Name of the animation range to delete
     * @param deleteFrames Specifies if the key frames for the range should also be deleted (true) or not (false)
     */ deleteRange(name, deleteFrames = true) {
        const range = this._ranges[name];
        if (!range) return;
        if (deleteFrames) {
            const from = range.from;
            const to = range.to;
            // this loop MUST go high to low for multiple splices to work
            for(let key = this._keys.length - 1; key >= 0; key--)if (this._keys[key].frame >= from && this._keys[key].frame <= to) this._keys.splice(key, 1);
        }
        this._ranges[name] = null; // said much faster than 'delete this._range[name]'
    }
    /**
     * Gets the animation range by name, or null if not defined
     * @param name Name of the animation range
     * @returns Nullable animation range
     */ getRange(name) {
        return this._ranges[name];
    }
    /**
     * Gets the key frames from the animation
     * @returns The key frames of the animation
     */ getKeys() {
        return this._keys;
    }
    /**
     * Gets the highest frame rate of the animation
     * @returns Highest frame rate of the animation
     */ getHighestFrame() {
        let ret = 0;
        for(let key = 0, nKeys = this._keys.length; key < nKeys; key++)if (ret < this._keys[key].frame) ret = this._keys[key].frame;
        return ret;
    }
    /**
     * Gets the easing function of the animation
     * @returns Easing function of the animation
     */ getEasingFunction() {
        return this._easingFunction;
    }
    /**
     * Sets the easing function of the animation
     * @param easingFunction A custom mathematical formula for animation
     */ setEasingFunction(easingFunction) {
        this._easingFunction = easingFunction;
    }
    /**
     * Interpolates a scalar linearly
     * @param startValue Start value of the animation curve
     * @param endValue End value of the animation curve
     * @param gradient Scalar amount to interpolate
     * @returns Interpolated scalar value
     */ floatInterpolateFunction(startValue, endValue, gradient) {
        return (0, $1VEEL.Scalar).Lerp(startValue, endValue, gradient);
    }
    /**
     * Interpolates a scalar cubically
     * @param startValue Start value of the animation curve
     * @param outTangent End tangent of the animation
     * @param endValue End value of the animation curve
     * @param inTangent Start tangent of the animation curve
     * @param gradient Scalar amount to interpolate
     * @returns Interpolated scalar value
     */ floatInterpolateFunctionWithTangents(startValue, outTangent, endValue, inTangent, gradient) {
        return (0, $1VEEL.Scalar).Hermite(startValue, outTangent, endValue, inTangent, gradient);
    }
    /**
     * Interpolates a quaternion using a spherical linear interpolation
     * @param startValue Start value of the animation curve
     * @param endValue End value of the animation curve
     * @param gradient Scalar amount to interpolate
     * @returns Interpolated quaternion value
     */ quaternionInterpolateFunction(startValue, endValue, gradient) {
        return (0, $ha1VO.Quaternion).Slerp(startValue, endValue, gradient);
    }
    /**
     * Interpolates a quaternion cubically
     * @param startValue Start value of the animation curve
     * @param outTangent End tangent of the animation curve
     * @param endValue End value of the animation curve
     * @param inTangent Start tangent of the animation curve
     * @param gradient Scalar amount to interpolate
     * @returns Interpolated quaternion value
     */ quaternionInterpolateFunctionWithTangents(startValue, outTangent, endValue, inTangent, gradient) {
        return (0, $ha1VO.Quaternion).Hermite(startValue, outTangent, endValue, inTangent, gradient).normalize();
    }
    /**
     * Interpolates a Vector3 linearly
     * @param startValue Start value of the animation curve
     * @param endValue End value of the animation curve
     * @param gradient Scalar amount to interpolate (value between 0 and 1)
     * @returns Interpolated scalar value
     */ vector3InterpolateFunction(startValue, endValue, gradient) {
        return (0, $ha1VO.Vector3).Lerp(startValue, endValue, gradient);
    }
    /**
     * Interpolates a Vector3 cubically
     * @param startValue Start value of the animation curve
     * @param outTangent End tangent of the animation
     * @param endValue End value of the animation curve
     * @param inTangent Start tangent of the animation curve
     * @param gradient Scalar amount to interpolate (value between 0 and 1)
     * @returns InterpolatedVector3 value
     */ vector3InterpolateFunctionWithTangents(startValue, outTangent, endValue, inTangent, gradient) {
        return (0, $ha1VO.Vector3).Hermite(startValue, outTangent, endValue, inTangent, gradient);
    }
    /**
     * Interpolates a Vector2 linearly
     * @param startValue Start value of the animation curve
     * @param endValue End value of the animation curve
     * @param gradient Scalar amount to interpolate (value between 0 and 1)
     * @returns Interpolated Vector2 value
     */ vector2InterpolateFunction(startValue, endValue, gradient) {
        return (0, $ha1VO.Vector2).Lerp(startValue, endValue, gradient);
    }
    /**
     * Interpolates a Vector2 cubically
     * @param startValue Start value of the animation curve
     * @param outTangent End tangent of the animation
     * @param endValue End value of the animation curve
     * @param inTangent Start tangent of the animation curve
     * @param gradient Scalar amount to interpolate (value between 0 and 1)
     * @returns Interpolated Vector2 value
     */ vector2InterpolateFunctionWithTangents(startValue, outTangent, endValue, inTangent, gradient) {
        return (0, $ha1VO.Vector2).Hermite(startValue, outTangent, endValue, inTangent, gradient);
    }
    /**
     * Interpolates a size linearly
     * @param startValue Start value of the animation curve
     * @param endValue End value of the animation curve
     * @param gradient Scalar amount to interpolate
     * @returns Interpolated Size value
     */ sizeInterpolateFunction(startValue, endValue, gradient) {
        return (0, $93o7r.Size).Lerp(startValue, endValue, gradient);
    }
    /**
     * Interpolates a Color3 linearly
     * @param startValue Start value of the animation curve
     * @param endValue End value of the animation curve
     * @param gradient Scalar amount to interpolate
     * @returns Interpolated Color3 value
     */ color3InterpolateFunction(startValue, endValue, gradient) {
        return (0, $7etnY.Color3).Lerp(startValue, endValue, gradient);
    }
    /**
     * Interpolates a Color3 cubically
     * @param startValue Start value of the animation curve
     * @param outTangent End tangent of the animation
     * @param endValue End value of the animation curve
     * @param inTangent Start tangent of the animation curve
     * @param gradient Scalar amount to interpolate
     * @returns interpolated value
     */ color3InterpolateFunctionWithTangents(startValue, outTangent, endValue, inTangent, gradient) {
        return (0, $7etnY.Color3).Hermite(startValue, outTangent, endValue, inTangent, gradient);
    }
    /**
     * Interpolates a Color4 linearly
     * @param startValue Start value of the animation curve
     * @param endValue End value of the animation curve
     * @param gradient Scalar amount to interpolate
     * @returns Interpolated Color3 value
     */ color4InterpolateFunction(startValue, endValue, gradient) {
        return (0, $7etnY.Color4).Lerp(startValue, endValue, gradient);
    }
    /**
     * Interpolates a Color4 cubically
     * @param startValue Start value of the animation curve
     * @param outTangent End tangent of the animation
     * @param endValue End value of the animation curve
     * @param inTangent Start tangent of the animation curve
     * @param gradient Scalar amount to interpolate
     * @returns interpolated value
     */ color4InterpolateFunctionWithTangents(startValue, outTangent, endValue, inTangent, gradient) {
        return (0, $7etnY.Color4).Hermite(startValue, outTangent, endValue, inTangent, gradient);
    }
    /**
     * @internal Internal use only
     */ _getKeyValue(value) {
        if (typeof value === "function") return value();
        return value;
    }
    /**
     * Evaluate the animation value at a given frame
     * @param currentFrame defines the frame where we want to evaluate the animation
     * @returns the animation value
     */ evaluate(currentFrame) {
        $ff91d59daa75db10$var$evaluateAnimationState.key = 0;
        return this._interpolate(currentFrame, $ff91d59daa75db10$var$evaluateAnimationState);
    }
    /**
     * @internal Internal use only
     */ _interpolate(currentFrame, state, searchClosestKeyOnly = false) {
        if (state.loopMode === $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CONSTANT && state.repeatCount > 0) return state.highLimitValue.clone ? state.highLimitValue.clone() : state.highLimitValue;
        const keys = this._keys;
        const keysLength = keys.length;
        let key = state.key;
        while(key >= 0 && currentFrame < keys[key].frame)--key;
        while(key + 1 <= keysLength - 1 && currentFrame >= keys[key + 1].frame)++key;
        state.key = key;
        if (key < 0) return searchClosestKeyOnly ? undefined : this._getKeyValue(keys[0].value);
        else if (key + 1 > keysLength - 1) return searchClosestKeyOnly ? undefined : this._getKeyValue(keys[keysLength - 1].value);
        const startKey = keys[key];
        const endKey = keys[key + 1];
        if (searchClosestKeyOnly && (currentFrame === startKey.frame || currentFrame === endKey.frame)) return undefined;
        const startValue = this._getKeyValue(startKey.value);
        const endValue = this._getKeyValue(endKey.value);
        if (startKey.interpolation === (0, $GNvkC.AnimationKeyInterpolation).STEP) {
            if (endKey.frame > currentFrame) return startValue;
            else return endValue;
        }
        const useTangent = startKey.outTangent !== undefined && endKey.inTangent !== undefined;
        const frameDelta = endKey.frame - startKey.frame;
        // gradient : percent of currentFrame between the frame inf and the frame sup
        let gradient = (currentFrame - startKey.frame) / frameDelta;
        // check for easingFunction and correction of gradient
        const easingFunction = startKey.easingFunction || this.getEasingFunction();
        if (easingFunction !== null) gradient = easingFunction.ease(gradient);
        switch(this.dataType){
            // Float
            case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_FLOAT:
                {
                    const floatValue = useTangent ? this.floatInterpolateFunctionWithTangents(startValue, startKey.outTangent * frameDelta, endValue, endKey.inTangent * frameDelta, gradient) : this.floatInterpolateFunction(startValue, endValue, gradient);
                    switch(state.loopMode){
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CYCLE:
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CONSTANT:
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_YOYO:
                            return floatValue;
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_RELATIVE:
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_RELATIVE_FROM_CURRENT:
                            return (state.offsetValue ?? 0) * state.repeatCount + floatValue;
                    }
                    break;
                }
            // Quaternion
            case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_QUATERNION:
                {
                    const quatValue = useTangent ? this.quaternionInterpolateFunctionWithTangents(startValue, startKey.outTangent.scale(frameDelta), endValue, endKey.inTangent.scale(frameDelta), gradient) : this.quaternionInterpolateFunction(startValue, endValue, gradient);
                    switch(state.loopMode){
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CYCLE:
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CONSTANT:
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_YOYO:
                            return quatValue;
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_RELATIVE:
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_RELATIVE_FROM_CURRENT:
                            return quatValue.addInPlace((state.offsetValue || $ff91d59daa75db10$export$519770a712ff637a).scale(state.repeatCount));
                    }
                    return quatValue;
                }
            // Vector3
            case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_VECTOR3:
                {
                    const vec3Value = useTangent ? this.vector3InterpolateFunctionWithTangents(startValue, startKey.outTangent.scale(frameDelta), endValue, endKey.inTangent.scale(frameDelta), gradient) : this.vector3InterpolateFunction(startValue, endValue, gradient);
                    switch(state.loopMode){
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CYCLE:
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CONSTANT:
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_YOYO:
                            return vec3Value;
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_RELATIVE:
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_RELATIVE_FROM_CURRENT:
                            return vec3Value.add((state.offsetValue || $ff91d59daa75db10$export$499344e023610249).scale(state.repeatCount));
                    }
                    break;
                }
            // Vector2
            case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_VECTOR2:
                {
                    const vec2Value = useTangent ? this.vector2InterpolateFunctionWithTangents(startValue, startKey.outTangent.scale(frameDelta), endValue, endKey.inTangent.scale(frameDelta), gradient) : this.vector2InterpolateFunction(startValue, endValue, gradient);
                    switch(state.loopMode){
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CYCLE:
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CONSTANT:
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_YOYO:
                            return vec2Value;
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_RELATIVE:
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_RELATIVE_FROM_CURRENT:
                            return vec2Value.add((state.offsetValue || $ff91d59daa75db10$export$6d83b9c8972825ff).scale(state.repeatCount));
                    }
                    break;
                }
            // Size
            case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_SIZE:
                switch(state.loopMode){
                    case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CYCLE:
                    case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CONSTANT:
                    case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_YOYO:
                        return this.sizeInterpolateFunction(startValue, endValue, gradient);
                    case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_RELATIVE:
                    case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_RELATIVE_FROM_CURRENT:
                        return this.sizeInterpolateFunction(startValue, endValue, gradient).add((state.offsetValue || $ff91d59daa75db10$export$1246757db6a7aaea).scale(state.repeatCount));
                }
                break;
            // Color3
            case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_COLOR3:
                {
                    const color3Value = useTangent ? this.color3InterpolateFunctionWithTangents(startValue, startKey.outTangent.scale(frameDelta), endValue, endKey.inTangent.scale(frameDelta), gradient) : this.color3InterpolateFunction(startValue, endValue, gradient);
                    switch(state.loopMode){
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CYCLE:
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CONSTANT:
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_YOYO:
                            return color3Value;
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_RELATIVE:
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_RELATIVE_FROM_CURRENT:
                            return color3Value.add((state.offsetValue || $ff91d59daa75db10$export$d98e5cb9b7a6dc07).scale(state.repeatCount));
                    }
                    break;
                }
            // Color4
            case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_COLOR4:
                {
                    const color4Value = useTangent ? this.color4InterpolateFunctionWithTangents(startValue, startKey.outTangent.scale(frameDelta), endValue, endKey.inTangent.scale(frameDelta), gradient) : this.color4InterpolateFunction(startValue, endValue, gradient);
                    switch(state.loopMode){
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CYCLE:
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CONSTANT:
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_YOYO:
                            return color4Value;
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_RELATIVE:
                        case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_RELATIVE_FROM_CURRENT:
                            return color4Value.add((state.offsetValue || $ff91d59daa75db10$export$6e4972fa3772cc35).scale(state.repeatCount));
                    }
                    break;
                }
            // Matrix
            case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_MATRIX:
                switch(state.loopMode){
                    case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CYCLE:
                    case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CONSTANT:
                    case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_YOYO:
                        if ($ff91d59daa75db10$export$c35d437ae5945fcd.AllowMatricesInterpolation) return this.matrixInterpolateFunction(startValue, endValue, gradient, state.workValue);
                        return startValue;
                    case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_RELATIVE:
                    case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_RELATIVE_FROM_CURRENT:
                        return startValue;
                }
                break;
        }
        return 0;
    }
    /**
     * Defines the function to use to interpolate matrices
     * @param startValue defines the start matrix
     * @param endValue defines the end matrix
     * @param gradient defines the gradient between both matrices
     * @param result defines an optional target matrix where to store the interpolation
     * @returns the interpolated matrix
     */ matrixInterpolateFunction(startValue, endValue, gradient, result) {
        if ($ff91d59daa75db10$export$c35d437ae5945fcd.AllowMatrixDecomposeForInterpolation) {
            if (result) {
                (0, $ha1VO.Matrix).DecomposeLerpToRef(startValue, endValue, gradient, result);
                return result;
            }
            return (0, $ha1VO.Matrix).DecomposeLerp(startValue, endValue, gradient);
        }
        if (result) {
            (0, $ha1VO.Matrix).LerpToRef(startValue, endValue, gradient, result);
            return result;
        }
        return (0, $ha1VO.Matrix).Lerp(startValue, endValue, gradient);
    }
    /**
     * Makes a copy of the animation
     * @returns Cloned animation
     */ clone() {
        const clone = new $ff91d59daa75db10$export$c35d437ae5945fcd(this.name, this.targetPropertyPath.join("."), this.framePerSecond, this.dataType, this.loopMode);
        clone.enableBlending = this.enableBlending;
        clone.blendingSpeed = this.blendingSpeed;
        if (this._keys) clone.setKeys(this._keys);
        if (this._ranges) {
            clone._ranges = {};
            for(const name in this._ranges){
                const range = this._ranges[name];
                if (!range) continue;
                clone._ranges[name] = range.clone();
            }
        }
        return clone;
    }
    /**
     * Sets the key frames of the animation
     * @param values The animation key frames to set
     * @param dontClone Whether to clone the keys or not (default is false, so the array of keys is cloned)
     */ setKeys(values, dontClone = false) {
        this._keys = !dontClone ? values.slice(0) : values;
    }
    /**
     * Creates a key for the frame passed as a parameter and adds it to the animation IF a key doesn't already exist for that frame
     * @param frame Frame number
     * @returns The key index if the key was added or the index of the pre existing key if the frame passed as parameter already has a corresponding key
     */ createKeyForFrame(frame) {
        // Find the key corresponding to frame
        $ff91d59daa75db10$var$evaluateAnimationState.key = 0;
        const value = this._interpolate(frame, $ff91d59daa75db10$var$evaluateAnimationState, true);
        if (!value) // A key corresponding to this frame already exists
        return this._keys[$ff91d59daa75db10$var$evaluateAnimationState.key].frame === frame ? $ff91d59daa75db10$var$evaluateAnimationState.key : $ff91d59daa75db10$var$evaluateAnimationState.key + 1;
        // The frame is between two keys, so create a new key
        const newKey = {
            frame: frame,
            value: value.clone ? value.clone() : value
        };
        this._keys.splice($ff91d59daa75db10$var$evaluateAnimationState.key + 1, 0, newKey);
        return $ff91d59daa75db10$var$evaluateAnimationState.key + 1;
    }
    /**
     * Serializes the animation to an object
     * @returns Serialized object
     */ serialize() {
        const serializationObject = {};
        serializationObject.name = this.name;
        serializationObject.property = this.targetProperty;
        serializationObject.framePerSecond = this.framePerSecond;
        serializationObject.dataType = this.dataType;
        serializationObject.loopBehavior = this.loopMode;
        serializationObject.enableBlending = this.enableBlending;
        serializationObject.blendingSpeed = this.blendingSpeed;
        const dataType = this.dataType;
        serializationObject.keys = [];
        const keys = this.getKeys();
        for(let index = 0; index < keys.length; index++){
            const animationKey = keys[index];
            const key = {};
            key.frame = animationKey.frame;
            switch(dataType){
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_FLOAT:
                    key.values = [
                        animationKey.value
                    ];
                    if (animationKey.inTangent !== undefined) key.values.push(animationKey.inTangent);
                    if (animationKey.outTangent !== undefined) {
                        if (animationKey.inTangent === undefined) key.values.push(undefined);
                        key.values.push(animationKey.outTangent);
                    }
                    if (animationKey.interpolation !== undefined) {
                        if (animationKey.inTangent === undefined) key.values.push(undefined);
                        if (animationKey.outTangent === undefined) key.values.push(undefined);
                        key.values.push(animationKey.interpolation);
                    }
                    break;
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_QUATERNION:
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_MATRIX:
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_VECTOR3:
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_COLOR3:
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_COLOR4:
                    key.values = animationKey.value.asArray();
                    if (animationKey.inTangent != undefined) key.values.push(animationKey.inTangent.asArray());
                    if (animationKey.outTangent != undefined) {
                        if (animationKey.inTangent === undefined) key.values.push(undefined);
                        key.values.push(animationKey.outTangent.asArray());
                    }
                    if (animationKey.interpolation !== undefined) {
                        if (animationKey.inTangent === undefined) key.values.push(undefined);
                        if (animationKey.outTangent === undefined) key.values.push(undefined);
                        key.values.push(animationKey.interpolation);
                    }
                    break;
            }
            serializationObject.keys.push(key);
        }
        serializationObject.ranges = [];
        for(const name in this._ranges){
            const source = this._ranges[name];
            if (!source) continue;
            const range = {};
            range.name = name;
            range.from = source.from;
            range.to = source.to;
            serializationObject.ranges.push(range);
        }
        return serializationObject;
    }
    /**
     * @internal
     */ static _UniversalLerp(left, right, amount) {
        const constructor = left.constructor;
        if (constructor.Lerp) // Lerp supported
        return constructor.Lerp(left, right, amount);
        else if (constructor.Slerp) // Slerp supported
        return constructor.Slerp(left, right, amount);
        else if (left.toFixed) // Number
        return left * (1.0 - amount) + amount * right;
        else // Blending not supported
        return right;
    }
    /**
     * Parses an animation object and creates an animation
     * @param parsedAnimation Parsed animation object
     * @returns Animation object
     */ static Parse(parsedAnimation) {
        const animation = new $ff91d59daa75db10$export$c35d437ae5945fcd(parsedAnimation.name, parsedAnimation.property, parsedAnimation.framePerSecond, parsedAnimation.dataType, parsedAnimation.loopBehavior);
        const dataType = parsedAnimation.dataType;
        const keys = [];
        let data;
        let index;
        if (parsedAnimation.enableBlending) animation.enableBlending = parsedAnimation.enableBlending;
        if (parsedAnimation.blendingSpeed) animation.blendingSpeed = parsedAnimation.blendingSpeed;
        for(index = 0; index < parsedAnimation.keys.length; index++){
            const key = parsedAnimation.keys[index];
            let inTangent = undefined;
            let outTangent = undefined;
            let interpolation = undefined;
            switch(dataType){
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_FLOAT:
                    data = key.values[0];
                    if (key.values.length >= 2) inTangent = key.values[1];
                    if (key.values.length >= 3) outTangent = key.values[2];
                    if (key.values.length >= 4) interpolation = key.values[3];
                    break;
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_QUATERNION:
                    data = (0, $ha1VO.Quaternion).FromArray(key.values);
                    if (key.values.length >= 8) {
                        const _inTangent = (0, $ha1VO.Quaternion).FromArray(key.values.slice(4, 8));
                        if (!_inTangent.equals((0, $ha1VO.Quaternion).Zero())) inTangent = _inTangent;
                    }
                    if (key.values.length >= 12) {
                        const _outTangent = (0, $ha1VO.Quaternion).FromArray(key.values.slice(8, 12));
                        if (!_outTangent.equals((0, $ha1VO.Quaternion).Zero())) outTangent = _outTangent;
                    }
                    if (key.values.length >= 13) interpolation = key.values[12];
                    break;
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_MATRIX:
                    data = (0, $ha1VO.Matrix).FromArray(key.values);
                    if (key.values.length >= 17) interpolation = key.values[16];
                    break;
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_COLOR3:
                    data = (0, $7etnY.Color3).FromArray(key.values);
                    if (key.values[3]) inTangent = (0, $7etnY.Color3).FromArray(key.values[3]);
                    if (key.values[4]) outTangent = (0, $7etnY.Color3).FromArray(key.values[4]);
                    if (key.values[5]) interpolation = key.values[5];
                    break;
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_COLOR4:
                    data = (0, $7etnY.Color4).FromArray(key.values);
                    if (key.values[4]) inTangent = (0, $7etnY.Color4).FromArray(key.values[4]);
                    if (key.values[5]) outTangent = (0, $7etnY.Color4).FromArray(key.values[5]);
                    if (key.values[6]) interpolation = (0, $7etnY.Color4).FromArray(key.values[6]);
                    break;
                case $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_VECTOR3:
                default:
                    data = (0, $ha1VO.Vector3).FromArray(key.values);
                    if (key.values[3]) inTangent = (0, $ha1VO.Vector3).FromArray(key.values[3]);
                    if (key.values[4]) outTangent = (0, $ha1VO.Vector3).FromArray(key.values[4]);
                    if (key.values[5]) interpolation = key.values[5];
                    break;
            }
            const keyData = {};
            keyData.frame = key.frame;
            keyData.value = data;
            if (inTangent != undefined) keyData.inTangent = inTangent;
            if (outTangent != undefined) keyData.outTangent = outTangent;
            if (interpolation != undefined) keyData.interpolation = interpolation;
            keys.push(keyData);
        }
        animation.setKeys(keys);
        if (parsedAnimation.ranges) for(index = 0; index < parsedAnimation.ranges.length; index++){
            data = parsedAnimation.ranges[index];
            animation.createRange(data.name, data.from, data.to);
        }
        return animation;
    }
    /**
     * Appends the serialized animations from the source animations
     * @param source Source containing the animations
     * @param destination Target to store the animations
     */ static AppendSerializedAnimations(source, destination) {
        (0, $6Ho1L.SerializationHelper).AppendSerializedAnimations(source, destination);
    }
    /**
     * Creates a new animation or an array of animations from a snippet saved in a remote file
     * @param name defines the name of the animation to create (can be null or empty to use the one from the json data)
     * @param url defines the url to load from
     * @returns a promise that will resolve to the new animation or an array of animations
     */ static ParseFromFileAsync(name, url) {
        return new Promise((resolve, reject)=>{
            const request = new (0, $hUzEl.WebRequest)();
            request.addEventListener("readystatechange", ()=>{
                if (request.readyState == 4) {
                    if (request.status == 200) {
                        let serializationObject = JSON.parse(request.responseText);
                        if (serializationObject.animations) serializationObject = serializationObject.animations;
                        if (serializationObject.length) {
                            const output = [];
                            for (const serializedAnimation of serializationObject)output.push(this.Parse(serializedAnimation));
                            resolve(output);
                        } else {
                            const output = this.Parse(serializationObject);
                            if (name) output.name = name;
                            resolve(output);
                        }
                    } else reject("Unable to load the animation");
                }
            });
            request.open("GET", url);
            request.send();
        });
    }
    /**
     * Creates an animation or an array of animations from a snippet saved by the Inspector
     * @param snippetId defines the snippet to load
     * @returns a promise that will resolve to the new animation or a new array of animations
     */ static ParseFromSnippetAsync(snippetId) {
        return new Promise((resolve, reject)=>{
            const request = new (0, $hUzEl.WebRequest)();
            request.addEventListener("readystatechange", ()=>{
                if (request.readyState == 4) {
                    if (request.status == 200) {
                        const snippet = JSON.parse(JSON.parse(request.responseText).jsonPayload);
                        if (snippet.animations) {
                            const serializationObject = JSON.parse(snippet.animations);
                            const outputs = [];
                            for (const serializedAnimation of serializationObject.animations){
                                const output = this.Parse(serializedAnimation);
                                output.snippetId = snippetId;
                                outputs.push(output);
                            }
                            resolve(outputs);
                        } else {
                            const serializationObject = JSON.parse(snippet.animation);
                            const output = this.Parse(serializationObject);
                            output.snippetId = snippetId;
                            resolve(output);
                        }
                    } else reject("Unable to load the snippet " + snippetId);
                }
            });
            request.open("GET", this.SnippetUrl + "/" + snippetId.replace(/#/g, "/"));
            request.send();
        });
    }
}
$ff91d59daa75db10$export$c35d437ae5945fcd._UniqueIdGenerator = 0;
/**
 * Use matrix interpolation instead of using direct key value when animating matrices
 */ $ff91d59daa75db10$export$c35d437ae5945fcd.AllowMatricesInterpolation = false;
/**
 * When matrix interpolation is enabled, this boolean forces the system to use Matrix.DecomposeLerp instead of Matrix.Lerp. Interpolation is more precise but slower
 */ $ff91d59daa75db10$export$c35d437ae5945fcd.AllowMatrixDecomposeForInterpolation = true;
/** Define the Url to load snippets */ $ff91d59daa75db10$export$c35d437ae5945fcd.SnippetUrl = `https://snippet.babylonjs.com`;
// Statics
/**
 * Float animation type
 */ $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_FLOAT = 0;
/**
 * Vector3 animation type
 */ $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_VECTOR3 = 1;
/**
 * Quaternion animation type
 */ $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_QUATERNION = 2;
/**
 * Matrix animation type
 */ $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_MATRIX = 3;
/**
 * Color3 animation type
 */ $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_COLOR3 = 4;
/**
 * Color3 animation type
 */ $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_COLOR4 = 7;
/**
 * Vector2 animation type
 */ $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_VECTOR2 = 5;
/**
 * Size animation type
 */ $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONTYPE_SIZE = 6;
/**
 * Relative Loop Mode
 */ $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_RELATIVE = 0;
/**
 * Cycle Loop Mode
 */ $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CYCLE = 1;
/**
 * Constant Loop Mode
 */ $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_CONSTANT = 2;
/**
 * Yoyo Loop Mode
 */ $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_YOYO = 4;
/**
 * Relative Loop Mode (add to current value of animated object, unlike ANIMATIONLOOPMODE_RELATIVE)
 */ $ff91d59daa75db10$export$c35d437ae5945fcd.ANIMATIONLOOPMODE_RELATIVE_FROM_CURRENT = 5;
/**
 * Creates an animation or an array of animations from a snippet saved by the Inspector
 * @deprecated Please use ParseFromSnippetAsync instead
 * @param snippetId defines the snippet to load
 * @returns a promise that will resolve to the new animation or a new array of animations
 */ $ff91d59daa75db10$export$c35d437ae5945fcd.CreateFromSnippetAsync = $ff91d59daa75db10$export$c35d437ae5945fcd.ParseFromSnippetAsync;
(0, $8DoUR.RegisterClass)("BABYLON.Animation", $ff91d59daa75db10$export$c35d437ae5945fcd);
(0, $bgssx.Node)._AnimationRangeFactory = (name, from, to)=>new (0, $knVpn.AnimationRange)(name, from, to);

});
parcelRegister("GNvkC", function(module, exports) {

$parcel$export(module.exports, "AnimationKeyInterpolation", () => $080a52e42209a056$export$586c4b2d0a5dc0c1);
/**
 * Enum for the animation key frame interpolation type
 */ var $080a52e42209a056$export$586c4b2d0a5dc0c1;
(function(AnimationKeyInterpolation) {
    /**
     * Use tangents to interpolate between start and end values.
     */ AnimationKeyInterpolation[AnimationKeyInterpolation["NONE"] = 0] = "NONE";
    /**
     * Do not interpolate between keys and use the start key value only. Tangents are ignored
     */ AnimationKeyInterpolation[AnimationKeyInterpolation["STEP"] = 1] = "STEP";
})($080a52e42209a056$export$586c4b2d0a5dc0c1 || ($080a52e42209a056$export$586c4b2d0a5dc0c1 = {}));

});

parcelRegister("knVpn", function(module, exports) {

$parcel$export(module.exports, "AnimationRange", () => $ed727cbc04f22ca3$export$eeed3d1abb539eaf);
/**
 * Represents the range of an animation
 */ class $ed727cbc04f22ca3$export$eeed3d1abb539eaf {
    /**
     * Initializes the range of an animation
     * @param name The name of the animation range
     * @param from The starting frame of the animation
     * @param to The ending frame of the animation
     */ constructor(/**The name of the animation range**/ name, /**The starting frame of the animation */ from, /**The ending frame of the animation*/ to){
        this.name = name;
        this.from = from;
        this.to = to;
    }
    /**
     * Makes a copy of the animation range
     * @returns A copy of the animation range
     */ clone() {
        return new $ed727cbc04f22ca3$export$eeed3d1abb539eaf(this.name, this.from, this.to);
    }
}

});

parcelRegister("bgssx", function(module, exports) {

$parcel$export(module.exports, "Node", () => $021dcb6a570ae9c1$export$85c928794f8d04d4);

var $e0Suo = parcelRequire("e0Suo");

var $ha1VO = parcelRequire("ha1VO");

var $ir0rz = parcelRequire("ir0rz");

var $diGQf = parcelRequire("diGQf");

var $ejQPp = parcelRequire("ejQPp");

var $dUFYy = parcelRequire("dUFYy");

var $6Ho1L = parcelRequire("6Ho1L");
/** @internal */ class $021dcb6a570ae9c1$var$_InternalNodeDataInfo {
    constructor(){
        this._doNotSerialize = false;
        this._isDisposed = false;
        this._sceneRootNodesIndex = -1;
        this._isEnabled = true;
        this._isParentEnabled = true;
        this._isReady = true;
        this._onEnabledStateChangedObservable = new (0, $diGQf.Observable)();
        this._onClonedObservable = new (0, $diGQf.Observable)();
    }
}
class $021dcb6a570ae9c1$export$85c928794f8d04d4 {
    /**
     * Add a new node constructor
     * @param type defines the type name of the node to construct
     * @param constructorFunc defines the constructor function
     */ static AddNodeConstructor(type, constructorFunc) {
        this._NodeConstructors[type] = constructorFunc;
    }
    /**
     * Returns a node constructor based on type name
     * @param type defines the type name
     * @param name defines the new node name
     * @param scene defines the hosting scene
     * @param options defines optional options to transmit to constructors
     * @returns the new constructor or null
     */ static Construct(type, name, scene, options) {
        const constructorFunc = this._NodeConstructors[type];
        if (!constructorFunc) return null;
        return constructorFunc(name, scene, options);
    }
    /**
     * Gets or sets the accessibility tag to describe the node for accessibility purpose.
     */ set accessibilityTag(value) {
        this._accessibilityTag = value;
        this.onAccessibilityTagChangedObservable.notifyObservers(value);
    }
    get accessibilityTag() {
        return this._accessibilityTag;
    }
    /**
     * Gets or sets a boolean used to define if the node must be serialized
     */ get doNotSerialize() {
        if (this._nodeDataStorage._doNotSerialize) return true;
        if (this._parentNode) return this._parentNode.doNotSerialize;
        return false;
    }
    set doNotSerialize(value) {
        this._nodeDataStorage._doNotSerialize = value;
    }
    /**
     * Gets a boolean indicating if the node has been disposed
     * @returns true if the node was disposed
     */ isDisposed() {
        return this._nodeDataStorage._isDisposed;
    }
    /**
     * Gets or sets the parent of the node (without keeping the current position in the scene)
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/transforms/parent_pivot/parent
     */ set parent(parent) {
        if (this._parentNode === parent) return;
        const previousParentNode = this._parentNode;
        // Remove self from list of children of parent
        if (this._parentNode && this._parentNode._children !== undefined && this._parentNode._children !== null) {
            const index = this._parentNode._children.indexOf(this);
            if (index !== -1) this._parentNode._children.splice(index, 1);
            if (!parent && !this._nodeDataStorage._isDisposed) this._addToSceneRootNodes();
        }
        // Store new parent
        this._parentNode = parent;
        // Add as child to new parent
        if (this._parentNode) {
            if (this._parentNode._children === undefined || this._parentNode._children === null) this._parentNode._children = new Array();
            this._parentNode._children.push(this);
            if (!previousParentNode) this._removeFromSceneRootNodes();
        }
        // Enabled state
        this._syncParentEnabledState();
    }
    get parent() {
        return this._parentNode;
    }
    /**
     * @internal
     */ _serializeAsParent(serializationObject) {
        serializationObject.parentId = this.uniqueId;
    }
    /** @internal */ _addToSceneRootNodes() {
        if (this._nodeDataStorage._sceneRootNodesIndex === -1) {
            this._nodeDataStorage._sceneRootNodesIndex = this._scene.rootNodes.length;
            this._scene.rootNodes.push(this);
        }
    }
    /** @internal */ _removeFromSceneRootNodes() {
        if (this._nodeDataStorage._sceneRootNodesIndex !== -1) {
            const rootNodes = this._scene.rootNodes;
            const lastIdx = rootNodes.length - 1;
            rootNodes[this._nodeDataStorage._sceneRootNodesIndex] = rootNodes[lastIdx];
            rootNodes[this._nodeDataStorage._sceneRootNodesIndex]._nodeDataStorage._sceneRootNodesIndex = this._nodeDataStorage._sceneRootNodesIndex;
            this._scene.rootNodes.pop();
            this._nodeDataStorage._sceneRootNodesIndex = -1;
        }
    }
    /**
     * Gets or sets the animation properties override
     */ get animationPropertiesOverride() {
        if (!this._animationPropertiesOverride) return this._scene.animationPropertiesOverride;
        return this._animationPropertiesOverride;
    }
    set animationPropertiesOverride(value) {
        this._animationPropertiesOverride = value;
    }
    /**
     * Gets a string identifying the name of the class
     * @returns "Node" string
     */ getClassName() {
        return "Node";
    }
    /**
     * Sets a callback that will be raised when the node will be disposed
     */ set onDispose(callback) {
        if (this._onDisposeObserver) this.onDisposeObservable.remove(this._onDisposeObserver);
        this._onDisposeObserver = this.onDisposeObservable.add(callback);
    }
    /**
     * An event triggered when the enabled state of the node changes
     */ get onEnabledStateChangedObservable() {
        return this._nodeDataStorage._onEnabledStateChangedObservable;
    }
    /**
     * An event triggered when the node is cloned
     */ get onClonedObservable() {
        return this._nodeDataStorage._onClonedObservable;
    }
    /**
     * Creates a new Node
     * @param name the name and id to be given to this node
     * @param scene the scene this node will be added to
     */ constructor(name, scene = null){
        this._isDirty = false;
        this._nodeDataStorage = new $021dcb6a570ae9c1$var$_InternalNodeDataInfo();
        /**
         * Gets or sets a string used to store user defined state for the node
         */ this.state = "";
        /**
         * Gets or sets an object used to store user defined information for the node
         */ this.metadata = null;
        /**
         * For internal use only. Please do not use.
         */ this.reservedDataStore = null;
        this._accessibilityTag = null;
        /**
         * Observable fired when an accessibility tag is changed
         */ this.onAccessibilityTagChangedObservable = new (0, $diGQf.Observable)();
        /** @internal */ this._parentContainer = null;
        /**
         * Gets a list of Animations associated with the node
         */ this.animations = [];
        this._ranges = {};
        /**
         * Callback raised when the node is ready to be used
         */ this.onReady = null;
        /** @internal */ this._currentRenderId = -1;
        this._parentUpdateId = -1;
        /** @internal */ this._childUpdateId = -1;
        /** @internal */ this._waitingParentId = null;
        /** @internal */ this._waitingParentInstanceIndex = null;
        /** @internal */ this._waitingParsedUniqueId = null;
        /** @internal */ this._cache = {};
        this._parentNode = null;
        /** @internal */ this._children = null;
        /** @internal */ this._worldMatrix = (0, $ha1VO.Matrix).Identity();
        /** @internal */ this._worldMatrixDeterminant = 0;
        /** @internal */ this._worldMatrixDeterminantIsDirty = true;
        this._animationPropertiesOverride = null;
        /** @internal */ this._isNode = true;
        /**
         * An event triggered when the mesh is disposed
         */ this.onDisposeObservable = new (0, $diGQf.Observable)();
        this._onDisposeObserver = null;
        // Behaviors
        this._behaviors = new Array();
        this.name = name;
        this.id = name;
        this._scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        this.uniqueId = this._scene.getUniqueId();
        this._initCache();
    }
    /**
     * Gets the scene of the node
     * @returns a scene
     */ getScene() {
        return this._scene;
    }
    /**
     * Gets the engine of the node
     * @returns a Engine
     */ getEngine() {
        return this._scene.getEngine();
    }
    /**
     * Attach a behavior to the node
     * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors
     * @param behavior defines the behavior to attach
     * @param attachImmediately defines that the behavior must be attached even if the scene is still loading
     * @returns the current Node
     */ addBehavior(behavior, attachImmediately = false) {
        const index = this._behaviors.indexOf(behavior);
        if (index !== -1) return this;
        behavior.init();
        if (this._scene.isLoading && !attachImmediately) // We defer the attach when the scene will be loaded
        this._scene.onDataLoadedObservable.addOnce(()=>{
            behavior.attach(this);
        });
        else behavior.attach(this);
        this._behaviors.push(behavior);
        return this;
    }
    /**
     * Remove an attached behavior
     * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors
     * @param behavior defines the behavior to attach
     * @returns the current Node
     */ removeBehavior(behavior) {
        const index = this._behaviors.indexOf(behavior);
        if (index === -1) return this;
        this._behaviors[index].detach();
        this._behaviors.splice(index, 1);
        return this;
    }
    /**
     * Gets the list of attached behaviors
     * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors
     */ get behaviors() {
        return this._behaviors;
    }
    /**
     * Gets an attached behavior by name
     * @param name defines the name of the behavior to look for
     * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors
     * @returns null if behavior was not found else the requested behavior
     */ getBehaviorByName(name) {
        for (const behavior of this._behaviors){
            if (behavior.name === name) return behavior;
        }
        return null;
    }
    /**
     * Returns the latest update of the World matrix
     * @returns a Matrix
     */ getWorldMatrix() {
        if (this._currentRenderId !== this._scene.getRenderId()) this.computeWorldMatrix();
        return this._worldMatrix;
    }
    /** @internal */ _getWorldMatrixDeterminant() {
        if (this._worldMatrixDeterminantIsDirty) {
            this._worldMatrixDeterminantIsDirty = false;
            this._worldMatrixDeterminant = this._worldMatrix.determinant();
        }
        return this._worldMatrixDeterminant;
    }
    /**
     * Returns directly the latest state of the mesh World matrix.
     * A Matrix is returned.
     */ get worldMatrixFromCache() {
        return this._worldMatrix;
    }
    // override it in derived class if you add new variables to the cache
    // and call the parent class method
    /** @internal */ _initCache() {
        this._cache = {};
        this._cache.parent = undefined;
    }
    /**
     * @internal
     */ updateCache(force) {
        if (!force && this.isSynchronized()) return;
        this._cache.parent = this.parent;
        this._updateCache();
    }
    /**
     * @internal
     */ _getActionManagerForTrigger(trigger, _initialCall = true) {
        if (!this.parent) return null;
        return this.parent._getActionManagerForTrigger(trigger, false);
    }
    // override it in derived class if you add new variables to the cache
    // and call the parent class method if !ignoreParentClass
    /**
     * @internal
     */ _updateCache(_ignoreParentClass) {}
    // override it in derived class if you add new variables to the cache
    /** @internal */ _isSynchronized() {
        return true;
    }
    /** @internal */ _markSyncedWithParent() {
        if (this._parentNode) this._parentUpdateId = this._parentNode._childUpdateId;
    }
    /** @internal */ isSynchronizedWithParent() {
        if (!this._parentNode) return true;
        if (this._parentNode._isDirty || this._parentUpdateId !== this._parentNode._childUpdateId) return false;
        return this._parentNode.isSynchronized();
    }
    /** @internal */ isSynchronized() {
        if (this._cache.parent !== this._parentNode) {
            this._cache.parent = this._parentNode;
            return false;
        }
        if (this._parentNode && !this.isSynchronizedWithParent()) return false;
        return this._isSynchronized();
    }
    /**
     * Is this node ready to be used/rendered
     * @param _completeCheck defines if a complete check (including materials and lights) has to be done (false by default)
     * @returns true if the node is ready
     */ isReady(_completeCheck = false) {
        return this._nodeDataStorage._isReady;
    }
    /**
     * Flag the  node as dirty (Forcing it to update everything)
     * @param _property helps children apply precise "dirtyfication"
     * @returns this node
     */ markAsDirty(_property) {
        this._currentRenderId = Number.MAX_VALUE;
        this._isDirty = true;
        return this;
    }
    /**
     * Is this node enabled?
     * If the node has a parent, all ancestors will be checked and false will be returned if any are false (not enabled), otherwise will return true
     * @param checkAncestors indicates if this method should check the ancestors. The default is to check the ancestors. If set to false, the method will return the value of this node without checking ancestors
     * @returns whether this node (and its parent) is enabled
     */ isEnabled(checkAncestors = true) {
        if (checkAncestors === false) return this._nodeDataStorage._isEnabled;
        if (!this._nodeDataStorage._isEnabled) return false;
        return this._nodeDataStorage._isParentEnabled;
    }
    /** @internal */ _syncParentEnabledState() {
        this._nodeDataStorage._isParentEnabled = this._parentNode ? this._parentNode.isEnabled() : true;
        if (this._children) this._children.forEach((c)=>{
            c._syncParentEnabledState(); // Force children to update accordingly
        });
    }
    /**
     * Set the enabled state of this node
     * @param value defines the new enabled state
     */ setEnabled(value) {
        if (this._nodeDataStorage._isEnabled === value) return;
        this._nodeDataStorage._isEnabled = value;
        this._syncParentEnabledState();
        this._nodeDataStorage._onEnabledStateChangedObservable.notifyObservers(value);
    }
    /**
     * Is this node a descendant of the given node?
     * The function will iterate up the hierarchy until the ancestor was found or no more parents defined
     * @param ancestor defines the parent node to inspect
     * @returns a boolean indicating if this node is a descendant of the given node
     */ isDescendantOf(ancestor) {
        if (this.parent) {
            if (this.parent === ancestor) return true;
            return this.parent.isDescendantOf(ancestor);
        }
        return false;
    }
    /**
     * @internal
     */ _getDescendants(results, directDescendantsOnly = false, predicate) {
        if (!this._children) return;
        for(let index = 0; index < this._children.length; index++){
            const item = this._children[index];
            if (!predicate || predicate(item)) results.push(item);
            if (!directDescendantsOnly) item._getDescendants(results, false, predicate);
        }
    }
    /**
     * Will return all nodes that have this node as ascendant
     * @param directDescendantsOnly defines if true only direct descendants of 'this' will be considered, if false direct and also indirect (children of children, an so on in a recursive manner) descendants of 'this' will be considered
     * @param predicate defines an optional predicate that will be called on every evaluated child, the predicate must return true for a given child to be part of the result, otherwise it will be ignored
     * @returns all children nodes of all types
     */ getDescendants(directDescendantsOnly, predicate) {
        const results = [];
        this._getDescendants(results, directDescendantsOnly, predicate);
        return results;
    }
    /**
     * Get all child-meshes of this node
     * @param directDescendantsOnly defines if true only direct descendants of 'this' will be considered, if false direct and also indirect (children of children, an so on in a recursive manner) descendants of 'this' will be considered (Default: false)
     * @param predicate defines an optional predicate that will be called on every evaluated child, the predicate must return true for a given child to be part of the result, otherwise it will be ignored
     * @returns an array of AbstractMesh
     */ getChildMeshes(directDescendantsOnly, predicate) {
        const results = [];
        this._getDescendants(results, directDescendantsOnly, (node)=>{
            return (!predicate || predicate(node)) && node.cullingStrategy !== undefined;
        });
        return results;
    }
    /**
     * Get all direct children of this node
     * @param predicate defines an optional predicate that will be called on every evaluated child, the predicate must return true for a given child to be part of the result, otherwise it will be ignored
     * @param directDescendantsOnly defines if true only direct descendants of 'this' will be considered, if false direct and also indirect (children of children, an so on in a recursive manner) descendants of 'this' will be considered (Default: true)
     * @returns an array of Node
     */ getChildren(predicate, directDescendantsOnly = true) {
        return this.getDescendants(directDescendantsOnly, predicate);
    }
    /**
     * @internal
     */ _setReady(state) {
        if (state === this._nodeDataStorage._isReady) return;
        if (!state) {
            this._nodeDataStorage._isReady = false;
            return;
        }
        if (this.onReady) this.onReady(this);
        this._nodeDataStorage._isReady = true;
    }
    /**
     * Get an animation by name
     * @param name defines the name of the animation to look for
     * @returns null if not found else the requested animation
     */ getAnimationByName(name) {
        for(let i = 0; i < this.animations.length; i++){
            const animation = this.animations[i];
            if (animation.name === name) return animation;
        }
        return null;
    }
    /**
     * Creates an animation range for this node
     * @param name defines the name of the range
     * @param from defines the starting key
     * @param to defines the end key
     */ createAnimationRange(name, from, to) {
        // check name not already in use
        if (!this._ranges[name]) {
            this._ranges[name] = $021dcb6a570ae9c1$export$85c928794f8d04d4._AnimationRangeFactory(name, from, to);
            for(let i = 0, nAnimations = this.animations.length; i < nAnimations; i++)if (this.animations[i]) this.animations[i].createRange(name, from, to);
        }
    }
    /**
     * Delete a specific animation range
     * @param name defines the name of the range to delete
     * @param deleteFrames defines if animation frames from the range must be deleted as well
     */ deleteAnimationRange(name, deleteFrames = true) {
        for(let i = 0, nAnimations = this.animations.length; i < nAnimations; i++)if (this.animations[i]) this.animations[i].deleteRange(name, deleteFrames);
        this._ranges[name] = null; // said much faster than 'delete this._range[name]'
    }
    /**
     * Get an animation range by name
     * @param name defines the name of the animation range to look for
     * @returns null if not found else the requested animation range
     */ getAnimationRange(name) {
        return this._ranges[name] || null;
    }
    /**
     * Clone the current node
     * @param name Name of the new clone
     * @param newParent New parent for the clone
     * @param doNotCloneChildren Do not clone children hierarchy
     * @returns the new transform node
     */ clone(name, newParent, doNotCloneChildren) {
        const result = (0, $6Ho1L.SerializationHelper).Clone(()=>new $021dcb6a570ae9c1$export$85c928794f8d04d4(name, this.getScene()), this);
        if (newParent) result.parent = newParent;
        if (!doNotCloneChildren) {
            // Children
            const directDescendants = this.getDescendants(true);
            for(let index = 0; index < directDescendants.length; index++){
                const child = directDescendants[index];
                child.clone(name + "." + child.name, result);
            }
        }
        return result;
    }
    /**
     * Gets the list of all animation ranges defined on this node
     * @returns an array
     */ getAnimationRanges() {
        const animationRanges = [];
        let name;
        for(name in this._ranges)animationRanges.push(this._ranges[name]);
        return animationRanges;
    }
    /**
     * Will start the animation sequence
     * @param name defines the range frames for animation sequence
     * @param loop defines if the animation should loop (false by default)
     * @param speedRatio defines the speed factor in which to run the animation (1 by default)
     * @param onAnimationEnd defines a function to be executed when the animation ended (undefined by default)
     * @returns the object created for this animation. If range does not exist, it will return null
     */ beginAnimation(name, loop, speedRatio, onAnimationEnd) {
        const range = this.getAnimationRange(name);
        if (!range) return null;
        return this._scene.beginAnimation(this, range.from, range.to, loop, speedRatio, onAnimationEnd);
    }
    /**
     * Serialize animation ranges into a JSON compatible object
     * @returns serialization object
     */ serializeAnimationRanges() {
        const serializationRanges = [];
        for(const name in this._ranges){
            const localRange = this._ranges[name];
            if (!localRange) continue;
            const range = {};
            range.name = name;
            range.from = localRange.from;
            range.to = localRange.to;
            serializationRanges.push(range);
        }
        return serializationRanges;
    }
    /**
     * Computes the world matrix of the node
     * @param _force defines if the cache version should be invalidated forcing the world matrix to be created from scratch
     * @returns the world matrix
     */ computeWorldMatrix(_force) {
        if (!this._worldMatrix) this._worldMatrix = (0, $ha1VO.Matrix).Identity();
        return this._worldMatrix;
    }
    /**
     * Releases resources associated with this node.
     * @param doNotRecurse Set to true to not recurse into each children (recurse into each children by default)
     * @param disposeMaterialAndTextures Set to true to also dispose referenced materials and textures (false by default)
     */ dispose(doNotRecurse, disposeMaterialAndTextures = false) {
        this._nodeDataStorage._isDisposed = true;
        if (!doNotRecurse) {
            const nodes = this.getDescendants(true);
            for (const node of nodes)node.dispose(doNotRecurse, disposeMaterialAndTextures);
        }
        if (!this.parent) this._removeFromSceneRootNodes();
        else this.parent = null;
        // Callback
        this.onDisposeObservable.notifyObservers(this);
        this.onDisposeObservable.clear();
        this.onEnabledStateChangedObservable.clear();
        this.onClonedObservable.clear();
        // Behaviors
        for (const behavior of this._behaviors)behavior.detach();
        this._behaviors.length = 0;
        this.metadata = null;
    }
    /**
     * Parse animation range data from a serialization object and store them into a given node
     * @param node defines where to store the animation ranges
     * @param parsedNode defines the serialization object to read data from
     * @param _scene defines the hosting scene
     */ static ParseAnimationRanges(node, parsedNode, _scene) {
        if (parsedNode.ranges) for(let index = 0; index < parsedNode.ranges.length; index++){
            const data = parsedNode.ranges[index];
            node.createAnimationRange(data.name, data.from, data.to);
        }
    }
    /**
     * Return the minimum and maximum world vectors of the entire hierarchy under current node
     * @param includeDescendants Include bounding info from descendants as well (true by default)
     * @param predicate defines a callback function that can be customize to filter what meshes should be included in the list used to compute the bounding vectors
     * @returns the new bounding vectors
     */ getHierarchyBoundingVectors(includeDescendants = true, predicate = null) {
        // Ensures that all world matrix will be recomputed.
        this.getScene().incrementRenderId();
        this.computeWorldMatrix(true);
        let min;
        let max;
        const thisAbstractMesh = this;
        if (thisAbstractMesh.getBoundingInfo && thisAbstractMesh.subMeshes) {
            // If this is an abstract mesh get its bounding info
            const boundingInfo = thisAbstractMesh.getBoundingInfo();
            min = boundingInfo.boundingBox.minimumWorld.clone();
            max = boundingInfo.boundingBox.maximumWorld.clone();
        } else {
            min = new (0, $ha1VO.Vector3)(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
            max = new (0, $ha1VO.Vector3)(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
        }
        if (includeDescendants) {
            const descendants = this.getDescendants(false);
            for (const descendant of descendants){
                const childMesh = descendant;
                childMesh.computeWorldMatrix(true);
                // Filters meshes based on custom predicate function.
                if (predicate && !predicate(childMesh)) continue;
                //make sure we have the needed params to get mix and max
                if (!childMesh.getBoundingInfo || childMesh.getTotalVertices() === 0) continue;
                const childBoundingInfo = childMesh.getBoundingInfo();
                const boundingBox = childBoundingInfo.boundingBox;
                const minBox = boundingBox.minimumWorld;
                const maxBox = boundingBox.maximumWorld;
                (0, $ha1VO.Vector3).CheckExtends(minBox, min, max);
                (0, $ha1VO.Vector3).CheckExtends(maxBox, min, max);
            }
        }
        return {
            min: min,
            max: max
        };
    }
}
/**
 * @internal
 */ $021dcb6a570ae9c1$export$85c928794f8d04d4._AnimationRangeFactory = (_name, _from, _to)=>{
    throw (0, $dUFYy._WarnImport)("AnimationRange");
};
$021dcb6a570ae9c1$export$85c928794f8d04d4._NodeConstructors = {};
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $021dcb6a570ae9c1$export$85c928794f8d04d4.prototype, "name", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $021dcb6a570ae9c1$export$85c928794f8d04d4.prototype, "id", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $021dcb6a570ae9c1$export$85c928794f8d04d4.prototype, "uniqueId", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $021dcb6a570ae9c1$export$85c928794f8d04d4.prototype, "state", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $021dcb6a570ae9c1$export$85c928794f8d04d4.prototype, "metadata", void 0);

});
parcelRegister("e0Suo", function(module, exports) {

$parcel$export(module.exports, "__decorate", () => $a33b5536ee447e49$export$29e00dfd3077644b);
/******************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $a33b5536ee447e49$var$extendStatics = function(d, b) {
    $a33b5536ee447e49$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $a33b5536ee447e49$var$extendStatics(d, b);
};
function $a33b5536ee447e49$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $a33b5536ee447e49$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a33b5536ee447e49$export$18ce0697a983be9b = function() {
    $a33b5536ee447e49$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a33b5536ee447e49$export$18ce0697a983be9b.apply(this, arguments);
};
function $a33b5536ee447e49$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a33b5536ee447e49$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $a33b5536ee447e49$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $a33b5536ee447e49$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $a33b5536ee447e49$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a33b5536ee447e49$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $a33b5536ee447e49$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $a33b5536ee447e49$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $a33b5536ee447e49$export$45d3717a4c69092e(o, m, p);
}
function $a33b5536ee447e49$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a33b5536ee447e49$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $a33b5536ee447e49$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($a33b5536ee447e49$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $a33b5536ee447e49$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $a33b5536ee447e49$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $a33b5536ee447e49$export$10c90e4f7922046c(v) {
    return this instanceof $a33b5536ee447e49$export$10c90e4f7922046c ? (this.v = v, this) : new $a33b5536ee447e49$export$10c90e4f7922046c(v);
}
function $a33b5536ee447e49$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a33b5536ee447e49$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $a33b5536ee447e49$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $a33b5536ee447e49$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $a33b5536ee447e49$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $a33b5536ee447e49$export$19a8beecd37a4c45 === "function" ? $a33b5536ee447e49$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $a33b5536ee447e49$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $a33b5536ee447e49$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $a33b5536ee447e49$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a33b5536ee447e49$export$45d3717a4c69092e(result, mod, k);
    }
    $a33b5536ee447e49$var$__setModuleDefault(result, mod);
    return result;
}
function $a33b5536ee447e49$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $a33b5536ee447e49$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $a33b5536ee447e49$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $a33b5536ee447e49$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}

});

parcelRegister("ir0rz", function(module, exports) {

$parcel$export(module.exports, "expandToProperty", () => $d6bb17ba9442dd7d$export$203b3c6995397e5e);
$parcel$export(module.exports, "serialize", () => $d6bb17ba9442dd7d$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "serializeAsTexture", () => $d6bb17ba9442dd7d$export$e76ad6c032366edc);
$parcel$export(module.exports, "serializeAsColor3", () => $d6bb17ba9442dd7d$export$f39b11f54e3219cf);
$parcel$export(module.exports, "serializeAsFresnelParameters", () => $d6bb17ba9442dd7d$export$ef9196ceae518245);
$parcel$export(module.exports, "serializeAsVector2", () => $d6bb17ba9442dd7d$export$e0ab9460c5b8abfe);
$parcel$export(module.exports, "serializeAsVector3", () => $d6bb17ba9442dd7d$export$c5783c6fe7ef9867);
$parcel$export(module.exports, "serializeAsMeshReference", () => $d6bb17ba9442dd7d$export$ae00ee082f688526);
$parcel$export(module.exports, "serializeAsColorCurves", () => $d6bb17ba9442dd7d$export$76755f760291e85b);
$parcel$export(module.exports, "serializeAsColor4", () => $d6bb17ba9442dd7d$export$6337ec176e95f4eb);
$parcel$export(module.exports, "serializeAsImageProcessingConfiguration", () => $d6bb17ba9442dd7d$export$5e2d0ccc49dd24b0);
$parcel$export(module.exports, "serializeAsQuaternion", () => $d6bb17ba9442dd7d$export$aee7845601ccd2d9);
$parcel$export(module.exports, "serializeAsMatrix", () => $d6bb17ba9442dd7d$export$62d5bf94e4c09dfa);
$parcel$export(module.exports, "serializeAsCameraReference", () => $d6bb17ba9442dd7d$export$1f0fc892c6407020);
$parcel$export(module.exports, "nativeOverride", () => $d6bb17ba9442dd7d$export$8fa84e8951b5413e);

var $225Mx = parcelRequire("225Mx");
function $d6bb17ba9442dd7d$var$generateSerializableMember(type, sourceName) {
    return (target, propertyKey)=>{
        const classStore = (0, $225Mx.GetDirectStore)(target);
        if (!classStore[propertyKey]) classStore[propertyKey] = {
            type: type,
            sourceName: sourceName
        };
    };
}
function $d6bb17ba9442dd7d$var$generateExpandMember(setCallback, targetKey = null) {
    return (target, propertyKey)=>{
        const key = targetKey || "_" + propertyKey;
        Object.defineProperty(target, propertyKey, {
            get: function() {
                return this[key];
            },
            set: function(value) {
                // does this object (i.e. vector3) has an equals function? use it!
                // Note - not using "with epsilon" here, it is expected te behave like the internal cache does.
                if (typeof this.equals === "function") {
                    if (this.equals(value)) return;
                }
                if (this[key] === value) return;
                this[key] = value;
                target[setCallback].apply(this);
            },
            enumerable: true,
            configurable: true
        });
    };
}
function $d6bb17ba9442dd7d$export$203b3c6995397e5e(callback, targetKey = null) {
    return $d6bb17ba9442dd7d$var$generateExpandMember(callback, targetKey);
}
function $d6bb17ba9442dd7d$export$dfdc1655ccc5b9cb(sourceName) {
    return $d6bb17ba9442dd7d$var$generateSerializableMember(0, sourceName); // value member
}
function $d6bb17ba9442dd7d$export$e76ad6c032366edc(sourceName) {
    return $d6bb17ba9442dd7d$var$generateSerializableMember(1, sourceName); // texture member
}
function $d6bb17ba9442dd7d$export$f39b11f54e3219cf(sourceName) {
    return $d6bb17ba9442dd7d$var$generateSerializableMember(2, sourceName); // color3 member
}
function $d6bb17ba9442dd7d$export$ef9196ceae518245(sourceName) {
    return $d6bb17ba9442dd7d$var$generateSerializableMember(3, sourceName); // fresnel parameters member
}
function $d6bb17ba9442dd7d$export$e0ab9460c5b8abfe(sourceName) {
    return $d6bb17ba9442dd7d$var$generateSerializableMember(4, sourceName); // vector2 member
}
function $d6bb17ba9442dd7d$export$c5783c6fe7ef9867(sourceName) {
    return $d6bb17ba9442dd7d$var$generateSerializableMember(5, sourceName); // vector3 member
}
function $d6bb17ba9442dd7d$export$ae00ee082f688526(sourceName) {
    return $d6bb17ba9442dd7d$var$generateSerializableMember(6, sourceName); // mesh reference member
}
function $d6bb17ba9442dd7d$export$76755f760291e85b(sourceName) {
    return $d6bb17ba9442dd7d$var$generateSerializableMember(7, sourceName); // color curves
}
function $d6bb17ba9442dd7d$export$6337ec176e95f4eb(sourceName) {
    return $d6bb17ba9442dd7d$var$generateSerializableMember(8, sourceName); // color 4
}
function $d6bb17ba9442dd7d$export$5e2d0ccc49dd24b0(sourceName) {
    return $d6bb17ba9442dd7d$var$generateSerializableMember(9, sourceName); // image processing
}
function $d6bb17ba9442dd7d$export$aee7845601ccd2d9(sourceName) {
    return $d6bb17ba9442dd7d$var$generateSerializableMember(10, sourceName); // quaternion member
}
function $d6bb17ba9442dd7d$export$62d5bf94e4c09dfa(sourceName) {
    return $d6bb17ba9442dd7d$var$generateSerializableMember(12, sourceName); // matrix member
}
function $d6bb17ba9442dd7d$export$1f0fc892c6407020(sourceName) {
    return $d6bb17ba9442dd7d$var$generateSerializableMember(11, sourceName); // camera reference member
}
function $d6bb17ba9442dd7d$export$8fa84e8951b5413e(target, propertyKey, descriptor, predicate) {
    // Cache the original JS function for later.
    const jsFunc = descriptor.value;
    // Override the JS function to check for a native override on first invocation. Setting descriptor.value overrides the function at the early stage of code being loaded/imported.
    descriptor.value = (...params)=>{
        // Assume the resolved function will be the original JS function, then we will check for the Babylon Native context.
        let func = jsFunc;
        // Check if we are executing in a Babylon Native context (e.g. check the presence of the _native global property) and if so also check if a function override is available.
        if (typeof _native !== "undefined" && _native[propertyKey]) {
            const nativeFunc = _native[propertyKey];
            // If a predicate was provided, then we'll need to invoke the predicate on each invocation of the underlying function to determine whether to call the native function or the JS function.
            if (predicate) // The resolved function will execute the predicate and then either execute the native function or the JS function.
            func = (...params)=>predicate(...params) ? nativeFunc(...params) : jsFunc(...params);
            else // The resolved function will directly execute the native function.
            func = nativeFunc;
        }
        // Override the JS function again with the final resolved target function.
        target[propertyKey] = func;
        // The JS function has now been overridden based on whether we're executing in the context of Babylon Native, but we still need to invoke that function.
        // Future invocations of the function will just directly invoke the final overridden function, not any of the decorator setup logic above.
        return func(...params);
    };
}
/**
 * Decorator factory that applies the nativeOverride decorator, but determines whether to redirect to the native implementation based on a filter function that evaluates the function arguments.
 * @param predicate
 * @example @nativeOverride.filter((...[arg1]: Parameters<typeof someClass.someMethod>) => arg1.length > 20)
 *          public someMethod(arg1: string, arg2: number): string {
 * @internal
 */ $d6bb17ba9442dd7d$export$8fa84e8951b5413e.filter = function(predicate) {
    return (target, propertyKey, descriptor)=>$d6bb17ba9442dd7d$export$8fa84e8951b5413e(target, propertyKey, descriptor, predicate);
};

});
parcelRegister("225Mx", function(module, exports) {

$parcel$export(module.exports, "GetDirectStore", () => $17b040da3238b37f$export$27a5fe883f738bc2);
$parcel$export(module.exports, "GetMergedStore", () => $17b040da3238b37f$export$48e1269973505d05);
// eslint-disable-next-line @typescript-eslint/naming-convention
const $17b040da3238b37f$var$__mergedStore = {};
// eslint-disable-next-line @typescript-eslint/naming-convention
const $17b040da3238b37f$var$__decoratorInitialStore = {};
function $17b040da3238b37f$export$27a5fe883f738bc2(target) {
    const classKey = target.getClassName();
    if (!$17b040da3238b37f$var$__decoratorInitialStore[classKey]) $17b040da3238b37f$var$__decoratorInitialStore[classKey] = {};
    return $17b040da3238b37f$var$__decoratorInitialStore[classKey];
}
function $17b040da3238b37f$export$48e1269973505d05(target) {
    const classKey = target.getClassName();
    if ($17b040da3238b37f$var$__mergedStore[classKey]) return $17b040da3238b37f$var$__mergedStore[classKey];
    $17b040da3238b37f$var$__mergedStore[classKey] = {};
    const store = $17b040da3238b37f$var$__mergedStore[classKey];
    let currentTarget = target;
    let currentKey = classKey;
    while(currentKey){
        const initialStore = $17b040da3238b37f$var$__decoratorInitialStore[currentKey];
        for(const property in initialStore)store[property] = initialStore[property];
        let parent;
        let done = false;
        do {
            parent = Object.getPrototypeOf(currentTarget);
            if (!parent.getClassName) {
                done = true;
                break;
            }
            if (parent.getClassName() !== currentKey) break;
            currentTarget = parent;
        }while (parent);
        if (done) break;
        currentKey = parent.getClassName();
        currentTarget = parent;
    }
    return store;
}

});


parcelRegister("dUFYy", function(module, exports) {

$parcel$export(module.exports, "_WarnImport", () => $a21110d40db8ed13$export$2ee7d0376c644e32);
const $a21110d40db8ed13$var$warnedMap = {};
function $a21110d40db8ed13$export$2ee7d0376c644e32(name, warnOnce = false) {
    if (warnOnce && $a21110d40db8ed13$var$warnedMap[name]) return;
    $a21110d40db8ed13$var$warnedMap[name] = true;
    return `${name} needs to be imported before as it contains a side-effect required by your code.`;
}

});

parcelRegister("6Ho1L", function(module, exports) {

$parcel$export(module.exports, "SerializationHelper", () => $4e09659a684f09ce$export$fa3e9fa0be4352ce);

var $dUFYy = parcelRequire("dUFYy");

var $7212E = parcelRequire("7212E");

var $7etnY = parcelRequire("7etnY");

var $ha1VO = parcelRequire("ha1VO");

var $225Mx = parcelRequire("225Mx");
const $4e09659a684f09ce$var$_copySource = function(creationFunction, source, instanciate, options = {}) {
    const destination = creationFunction();
    // Tags
    if ((0, $7212E.Tags) && (0, $7212E.Tags).HasTags(source)) (0, $7212E.Tags).AddTagsTo(destination, (0, $7212E.Tags).GetTags(source, true));
    const classStore = (0, $225Mx.GetMergedStore)(destination);
    // Map from source texture uniqueId to destination texture
    const textureMap = {};
    // Properties
    for(const property in classStore){
        const propertyDescriptor = classStore[property];
        const sourceProperty = source[property];
        const propertyType = propertyDescriptor.type;
        if (sourceProperty !== undefined && sourceProperty !== null && (property !== "uniqueId" || $4e09659a684f09ce$export$fa3e9fa0be4352ce.AllowLoadingUniqueId)) switch(propertyType){
            case 0:
            case 6:
            case 11:
                destination[property] = sourceProperty;
                break;
            case 1:
                if (options.cloneTexturesOnlyOnce && textureMap[sourceProperty.uniqueId]) destination[property] = textureMap[sourceProperty.uniqueId];
                else {
                    destination[property] = instanciate || sourceProperty.isRenderTarget ? sourceProperty : sourceProperty.clone();
                    textureMap[sourceProperty.uniqueId] = destination[property];
                }
                break;
            case 2:
            case 3:
            case 4:
            case 5:
            case 7:
            case 10:
            case 12:
                destination[property] = instanciate ? sourceProperty : sourceProperty.clone();
                break;
        }
    }
    return destination;
};
class $4e09659a684f09ce$export$fa3e9fa0be4352ce {
    /**
     * Appends the serialized animations from the source animations
     * @param source Source containing the animations
     * @param destination Target to store the animations
     */ static AppendSerializedAnimations(source, destination) {
        if (source.animations) {
            destination.animations = [];
            for(let animationIndex = 0; animationIndex < source.animations.length; animationIndex++){
                const animation = source.animations[animationIndex];
                destination.animations.push(animation.serialize());
            }
        }
    }
    /**
     * Static function used to serialized a specific entity
     * @param entity defines the entity to serialize
     * @param serializationObject defines the optional target object where serialization data will be stored
     * @returns a JSON compatible object representing the serialization of the entity
     */ static Serialize(entity, serializationObject) {
        if (!serializationObject) serializationObject = {};
        // Tags
        if (0, $7212E.Tags) serializationObject.tags = (0, $7212E.Tags).GetTags(entity);
        const serializedProperties = (0, $225Mx.GetMergedStore)(entity);
        // Properties
        for(const property in serializedProperties){
            const propertyDescriptor = serializedProperties[property];
            const targetPropertyName = propertyDescriptor.sourceName || property;
            const propertyType = propertyDescriptor.type;
            const sourceProperty = entity[property];
            if (sourceProperty !== undefined && sourceProperty !== null && (property !== "uniqueId" || $4e09659a684f09ce$export$fa3e9fa0be4352ce.AllowLoadingUniqueId)) switch(propertyType){
                case 0:
                    serializationObject[targetPropertyName] = sourceProperty;
                    break;
                case 1:
                    serializationObject[targetPropertyName] = sourceProperty.serialize();
                    break;
                case 2:
                    serializationObject[targetPropertyName] = sourceProperty.asArray();
                    break;
                case 3:
                    serializationObject[targetPropertyName] = sourceProperty.serialize();
                    break;
                case 4:
                    serializationObject[targetPropertyName] = sourceProperty.asArray();
                    break;
                case 5:
                    serializationObject[targetPropertyName] = sourceProperty.asArray();
                    break;
                case 6:
                    serializationObject[targetPropertyName] = sourceProperty.id;
                    break;
                case 7:
                    serializationObject[targetPropertyName] = sourceProperty.serialize();
                    break;
                case 8:
                    serializationObject[targetPropertyName] = sourceProperty.asArray();
                    break;
                case 9:
                    serializationObject[targetPropertyName] = sourceProperty.serialize();
                    break;
                case 10:
                    serializationObject[targetPropertyName] = sourceProperty.asArray();
                    break;
                case 11:
                    serializationObject[targetPropertyName] = sourceProperty.id;
                    break;
                case 12:
                    serializationObject[targetPropertyName] = sourceProperty.asArray();
                    break;
            }
        }
        return serializationObject;
    }
    /**
     * Given a source json and a destination object in a scene, this function will parse the source and will try to apply its content to the destination object
     * @param source the source json data
     * @param destination the destination object
     * @param scene the scene where the object is
     * @param rootUrl root url to use to load assets
     */ static ParseProperties(source, destination, scene, rootUrl) {
        if (!rootUrl) rootUrl = "";
        const classStore = (0, $225Mx.GetMergedStore)(destination);
        // Properties
        for(const property in classStore){
            const propertyDescriptor = classStore[property];
            const sourceProperty = source[propertyDescriptor.sourceName || property];
            const propertyType = propertyDescriptor.type;
            if (sourceProperty !== undefined && sourceProperty !== null && (property !== "uniqueId" || $4e09659a684f09ce$export$fa3e9fa0be4352ce.AllowLoadingUniqueId)) {
                const dest = destination;
                switch(propertyType){
                    case 0:
                        dest[property] = sourceProperty;
                        break;
                    case 1:
                        if (scene) dest[property] = $4e09659a684f09ce$export$fa3e9fa0be4352ce._TextureParser(sourceProperty, scene, rootUrl);
                        break;
                    case 2:
                        dest[property] = (0, $7etnY.Color3).FromArray(sourceProperty);
                        break;
                    case 3:
                        dest[property] = $4e09659a684f09ce$export$fa3e9fa0be4352ce._FresnelParametersParser(sourceProperty);
                        break;
                    case 4:
                        dest[property] = (0, $ha1VO.Vector2).FromArray(sourceProperty);
                        break;
                    case 5:
                        dest[property] = (0, $ha1VO.Vector3).FromArray(sourceProperty);
                        break;
                    case 6:
                        if (scene) dest[property] = scene.getLastMeshById(sourceProperty);
                        break;
                    case 7:
                        dest[property] = $4e09659a684f09ce$export$fa3e9fa0be4352ce._ColorCurvesParser(sourceProperty);
                        break;
                    case 8:
                        dest[property] = (0, $7etnY.Color4).FromArray(sourceProperty);
                        break;
                    case 9:
                        dest[property] = $4e09659a684f09ce$export$fa3e9fa0be4352ce._ImageProcessingConfigurationParser(sourceProperty);
                        break;
                    case 10:
                        dest[property] = (0, $ha1VO.Quaternion).FromArray(sourceProperty);
                        break;
                    case 11:
                        if (scene) dest[property] = scene.getCameraById(sourceProperty);
                        break;
                    case 12:
                        dest[property] = (0, $ha1VO.Matrix).FromArray(sourceProperty);
                        break;
                }
            }
        }
    }
    /**
     * Creates a new entity from a serialization data object
     * @param creationFunction defines a function used to instanciated the new entity
     * @param source defines the source serialization data
     * @param scene defines the hosting scene
     * @param rootUrl defines the root url for resources
     * @returns a new entity
     */ static Parse(creationFunction, source, scene, rootUrl = null) {
        const destination = creationFunction();
        // Tags
        if (0, $7212E.Tags) (0, $7212E.Tags).AddTagsTo(destination, source.tags);
        $4e09659a684f09ce$export$fa3e9fa0be4352ce.ParseProperties(source, destination, scene, rootUrl);
        return destination;
    }
    /**
     * Clones an object
     * @param creationFunction defines the function used to instanciate the new object
     * @param source defines the source object
     * @param options defines the options to use
     * @returns the cloned object
     */ static Clone(creationFunction, source, options = {}) {
        return $4e09659a684f09ce$var$_copySource(creationFunction, source, false, options);
    }
    /**
     * Instanciates a new object based on a source one (some data will be shared between both object)
     * @param creationFunction defines the function used to instanciate the new object
     * @param source defines the source object
     * @returns the new object
     */ static Instanciate(creationFunction, source) {
        return $4e09659a684f09ce$var$_copySource(creationFunction, source, true);
    }
}
/**
 * Gets or sets a boolean to indicate if the UniqueId property should be serialized
 */ $4e09659a684f09ce$export$fa3e9fa0be4352ce.AllowLoadingUniqueId = false;
/**
 * @internal
 */ $4e09659a684f09ce$export$fa3e9fa0be4352ce._ImageProcessingConfigurationParser = (sourceProperty)=>{
    throw (0, $dUFYy._WarnImport)("ImageProcessingConfiguration");
};
/**
 * @internal
 */ $4e09659a684f09ce$export$fa3e9fa0be4352ce._FresnelParametersParser = (sourceProperty)=>{
    throw (0, $dUFYy._WarnImport)("FresnelParameters");
};
/**
 * @internal
 */ $4e09659a684f09ce$export$fa3e9fa0be4352ce._ColorCurvesParser = (sourceProperty)=>{
    throw (0, $dUFYy._WarnImport)("ColorCurves");
};
/**
 * @internal
 */ $4e09659a684f09ce$export$fa3e9fa0be4352ce._TextureParser = (sourceProperty, scene, rootUrl)=>{
    throw (0, $dUFYy._WarnImport)("Texture");
};

});
parcelRegister("7212E", function(module, exports) {

$parcel$export(module.exports, "Tags", () => $51e9872e32043eff$export$b72686b556e29ca6);

var $1VA7I = parcelRequire("1VA7I");
class $51e9872e32043eff$export$b72686b556e29ca6 {
    /**
     * Adds support for tags on the given object
     * @param obj defines the object to use
     */ static EnableFor(obj) {
        obj._tags = obj._tags || {};
        obj.hasTags = ()=>{
            return $51e9872e32043eff$export$b72686b556e29ca6.HasTags(obj);
        };
        obj.addTags = (tagsString)=>{
            return $51e9872e32043eff$export$b72686b556e29ca6.AddTagsTo(obj, tagsString);
        };
        obj.removeTags = (tagsString)=>{
            return $51e9872e32043eff$export$b72686b556e29ca6.RemoveTagsFrom(obj, tagsString);
        };
        obj.matchesTagsQuery = (tagsQuery)=>{
            return $51e9872e32043eff$export$b72686b556e29ca6.MatchesQuery(obj, tagsQuery);
        };
    }
    /**
     * Removes tags support
     * @param obj defines the object to use
     */ static DisableFor(obj) {
        delete obj._tags;
        delete obj.hasTags;
        delete obj.addTags;
        delete obj.removeTags;
        delete obj.matchesTagsQuery;
    }
    /**
     * Gets a boolean indicating if the given object has tags
     * @param obj defines the object to use
     * @returns a boolean
     */ static HasTags(obj) {
        if (!obj._tags) return false;
        const tags = obj._tags;
        for(const i in tags){
            if (Object.prototype.hasOwnProperty.call(tags, i)) return true;
        }
        return false;
    }
    /**
     * Gets the tags available on a given object
     * @param obj defines the object to use
     * @param asString defines if the tags must be returned as a string instead of an array of strings
     * @returns the tags
     */ static GetTags(obj, asString = true) {
        if (!obj._tags) return null;
        if (asString) {
            const tagsArray = [];
            for(const tag in obj._tags)if (Object.prototype.hasOwnProperty.call(obj._tags, tag) && obj._tags[tag] === true) tagsArray.push(tag);
            return tagsArray.join(" ");
        } else return obj._tags;
    }
    /**
     * Adds tags to an object
     * @param obj defines the object to use
     * @param tagsString defines the tag string. The tags 'true' and 'false' are reserved and cannot be used as tags.
     * A tag cannot start with '||', '&&', and '!'. It cannot contain whitespaces
     */ static AddTagsTo(obj, tagsString) {
        if (!tagsString) return;
        if (typeof tagsString !== "string") return;
        const tags = tagsString.split(" ");
        tags.forEach(function(tag) {
            $51e9872e32043eff$export$b72686b556e29ca6._AddTagTo(obj, tag);
        });
    }
    /**
     * @internal
     */ static _AddTagTo(obj, tag) {
        tag = tag.trim();
        if (tag === "" || tag === "true" || tag === "false") return;
        if (tag.match(/[\s]/) || tag.match(/^([!]|([|]|[&]){2})/)) return;
        $51e9872e32043eff$export$b72686b556e29ca6.EnableFor(obj);
        obj._tags[tag] = true;
    }
    /**
     * Removes specific tags from a specific object
     * @param obj defines the object to use
     * @param tagsString defines the tags to remove
     */ static RemoveTagsFrom(obj, tagsString) {
        if (!$51e9872e32043eff$export$b72686b556e29ca6.HasTags(obj)) return;
        const tags = tagsString.split(" ");
        for(const t in tags)$51e9872e32043eff$export$b72686b556e29ca6._RemoveTagFrom(obj, tags[t]);
    }
    /**
     * @internal
     */ static _RemoveTagFrom(obj, tag) {
        delete obj._tags[tag];
    }
    /**
     * Defines if tags hosted on an object match a given query
     * @param obj defines the object to use
     * @param tagsQuery defines the tag query
     * @returns a boolean
     */ static MatchesQuery(obj, tagsQuery) {
        if (tagsQuery === undefined) return true;
        if (tagsQuery === "") return $51e9872e32043eff$export$b72686b556e29ca6.HasTags(obj);
        return (0, $1VA7I.AndOrNotEvaluator).Eval(tagsQuery, (r)=>$51e9872e32043eff$export$b72686b556e29ca6.HasTags(obj) && obj._tags[r]);
    }
}

});
parcelRegister("1VA7I", function(module, exports) {

$parcel$export(module.exports, "AndOrNotEvaluator", () => $167722b44b8176d3$export$538bb86bc662e468);
/**
 * Class used to evaluate queries containing `and` and `or` operators
 */ class $167722b44b8176d3$export$538bb86bc662e468 {
    /**
     * Evaluate a query
     * @param query defines the query to evaluate
     * @param evaluateCallback defines the callback used to filter result
     * @returns true if the query matches
     */ static Eval(query, evaluateCallback) {
        if (!query.match(/\([^()]*\)/g)) query = $167722b44b8176d3$export$538bb86bc662e468._HandleParenthesisContent(query, evaluateCallback);
        else query = query.replace(/\([^()]*\)/g, (r)=>{
            // remove parenthesis
            r = r.slice(1, r.length - 1);
            return $167722b44b8176d3$export$538bb86bc662e468._HandleParenthesisContent(r, evaluateCallback);
        });
        if (query === "true") return true;
        if (query === "false") return false;
        return $167722b44b8176d3$export$538bb86bc662e468.Eval(query, evaluateCallback);
    }
    static _HandleParenthesisContent(parenthesisContent, evaluateCallback) {
        evaluateCallback = evaluateCallback || ((r)=>{
            return r === "true" ? true : false;
        });
        let result;
        const or = parenthesisContent.split("||");
        for(const i in or)if (Object.prototype.hasOwnProperty.call(or, i)) {
            let ori = $167722b44b8176d3$export$538bb86bc662e468._SimplifyNegation(or[i].trim());
            const and = ori.split("&&");
            if (and.length > 1) for(let j = 0; j < and.length; ++j){
                const andj = $167722b44b8176d3$export$538bb86bc662e468._SimplifyNegation(and[j].trim());
                if (andj !== "true" && andj !== "false") {
                    if (andj[0] === "!") result = !evaluateCallback(andj.substring(1));
                    else result = evaluateCallback(andj);
                } else result = andj === "true" ? true : false;
                if (!result) {
                    // no need to continue since 'false && ... && ...' will always return false
                    ori = "false";
                    break;
                }
            }
            if (result || ori === "true") {
                // no need to continue since 'true || ... || ...' will always return true
                result = true;
                break;
            }
            // result equals false (or undefined)
            if (ori !== "true" && ori !== "false") {
                if (ori[0] === "!") result = !evaluateCallback(ori.substring(1));
                else result = evaluateCallback(ori);
            } else result = ori === "true" ? true : false;
        }
        // the whole parenthesis scope is replaced by 'true' or 'false'
        return result ? "true" : "false";
    }
    static _SimplifyNegation(booleanString) {
        booleanString = booleanString.replace(/^[\s!]+/, (r)=>{
            // remove whitespaces
            r = r.replace(/[\s]/g, ()=>"");
            return r.length % 2 ? "!" : "";
        });
        booleanString = booleanString.trim();
        if (booleanString === "!true") booleanString = "false";
        else if (booleanString === "!false") booleanString = "true";
        return booleanString;
    }
}

});




parcelRegister("93o7r", function(module, exports) {

$parcel$export(module.exports, "Size", () => $69771a6a6db876b9$export$cb6da89c6af1a8ec);
/**
 * Size containing width and height
 */ class $69771a6a6db876b9$export$cb6da89c6af1a8ec {
    /**
     * Creates a Size object from the given width and height (floats).
     * @param width width of the new size
     * @param height height of the new size
     */ constructor(width, height){
        this.width = width;
        this.height = height;
    }
    /**
     * Returns a string with the Size width and height
     * @returns a string with the Size width and height
     */ toString() {
        return `{W: ${this.width}, H: ${this.height}}`;
    }
    /**
     * "Size"
     * @returns the string "Size"
     */ getClassName() {
        return "Size";
    }
    /**
     * Returns the Size hash code.
     * @returns a hash code for a unique width and height
     */ getHashCode() {
        let hash = this.width | 0;
        hash = hash * 397 ^ (this.height | 0);
        return hash;
    }
    /**
     * Updates the current size from the given one.
     * @param src the given size
     */ copyFrom(src) {
        this.width = src.width;
        this.height = src.height;
    }
    /**
     * Updates in place the current Size from the given floats.
     * @param width width of the new size
     * @param height height of the new size
     * @returns the updated Size.
     */ copyFromFloats(width, height) {
        this.width = width;
        this.height = height;
        return this;
    }
    /**
     * Updates in place the current Size from the given floats.
     * @param width width to set
     * @param height height to set
     * @returns the updated Size.
     */ set(width, height) {
        return this.copyFromFloats(width, height);
    }
    /**
     * Multiplies the width and height by numbers
     * @param w factor to multiple the width by
     * @param h factor to multiple the height by
     * @returns a new Size set with the multiplication result of the current Size and the given floats.
     */ multiplyByFloats(w, h) {
        return new $69771a6a6db876b9$export$cb6da89c6af1a8ec(this.width * w, this.height * h);
    }
    /**
     * Clones the size
     * @returns a new Size copied from the given one.
     */ clone() {
        return new $69771a6a6db876b9$export$cb6da89c6af1a8ec(this.width, this.height);
    }
    /**
     * True if the current Size and the given one width and height are strictly equal.
     * @param other the other size to compare against
     * @returns True if the current Size and the given one width and height are strictly equal.
     */ equals(other) {
        if (!other) return false;
        return this.width === other.width && this.height === other.height;
    }
    /**
     * The surface of the Size : width * height (float).
     */ get surface() {
        return this.width * this.height;
    }
    /**
     * Create a new size of zero
     * @returns a new Size set to (0.0, 0.0)
     */ static Zero() {
        return new $69771a6a6db876b9$export$cb6da89c6af1a8ec(0.0, 0.0);
    }
    /**
     * Sums the width and height of two sizes
     * @param otherSize size to add to this size
     * @returns a new Size set as the addition result of the current Size and the given one.
     */ add(otherSize) {
        const r = new $69771a6a6db876b9$export$cb6da89c6af1a8ec(this.width + otherSize.width, this.height + otherSize.height);
        return r;
    }
    /**
     * Subtracts the width and height of two
     * @param otherSize size to subtract to this size
     * @returns a new Size set as the subtraction result of  the given one from the current Size.
     */ subtract(otherSize) {
        const r = new $69771a6a6db876b9$export$cb6da89c6af1a8ec(this.width - otherSize.width, this.height - otherSize.height);
        return r;
    }
    /**
     * Scales the width and height
     * @param scale the scale to multiply the width and height by
     * @returns a new Size set with the multiplication result of the current Size and the given floats.
     */ scale(scale) {
        return new $69771a6a6db876b9$export$cb6da89c6af1a8ec(this.width * scale, this.height * scale);
    }
    /**
     * Creates a new Size set at the linear interpolation "amount" between "start" and "end"
     * @param start starting size to lerp between
     * @param end end size to lerp between
     * @param amount amount to lerp between the start and end values
     * @returns a new Size set at the linear interpolation "amount" between "start" and "end"
     */ static Lerp(start, end, amount) {
        const w = start.width + (end.width - start.width) * amount;
        const h = start.height + (end.height - start.height) * amount;
        return new $69771a6a6db876b9$export$cb6da89c6af1a8ec(w, h);
    }
}

});

parcelRegister("hUzEl", function(module, exports) {

$parcel$export(module.exports, "WebRequest", () => $d0a351f143d2884d$export$6f76b2393893a286);
/** @internal */ // eslint-disable-next-line @typescript-eslint/naming-convention
function $d0a351f143d2884d$var$createXMLHttpRequest() {
    // If running in Babylon Native, then defer to the native XMLHttpRequest, which has the same public contract
    if (typeof _native !== "undefined" && _native.XMLHttpRequest) return new _native.XMLHttpRequest();
    else return new XMLHttpRequest();
}
class $d0a351f143d2884d$export$6f76b2393893a286 {
    constructor(){
        this._xhr = $d0a351f143d2884d$var$createXMLHttpRequest();
        this._requestURL = "";
    }
    /**
     * This function can be called to check if there are request modifiers for network requests
     * @returns true if there are any custom requests available
     */ static get IsCustomRequestAvailable() {
        return Object.keys($d0a351f143d2884d$export$6f76b2393893a286.CustomRequestHeaders).length > 0 || $d0a351f143d2884d$export$6f76b2393893a286.CustomRequestModifiers.length > 0;
    }
    _injectCustomRequestHeaders() {
        if (this._shouldSkipRequestModifications(this._requestURL)) return;
        for(const key in $d0a351f143d2884d$export$6f76b2393893a286.CustomRequestHeaders){
            const val = $d0a351f143d2884d$export$6f76b2393893a286.CustomRequestHeaders[key];
            if (val) this._xhr.setRequestHeader(key, val);
        }
    }
    _shouldSkipRequestModifications(url) {
        return $d0a351f143d2884d$export$6f76b2393893a286.SkipRequestModificationForBabylonCDN && (url.includes("preview.babylonjs.com") || url.includes("cdn.babylonjs.com"));
    }
    /**
     * Gets or sets a function to be called when loading progress changes
     */ get onprogress() {
        return this._xhr.onprogress;
    }
    set onprogress(value) {
        this._xhr.onprogress = value;
    }
    /**
     * Returns client's state
     */ get readyState() {
        return this._xhr.readyState;
    }
    /**
     * Returns client's status
     */ get status() {
        return this._xhr.status;
    }
    /**
     * Returns client's status as a text
     */ get statusText() {
        return this._xhr.statusText;
    }
    /**
     * Returns client's response
     */ get response() {
        return this._xhr.response;
    }
    /**
     * Returns client's response url
     */ get responseURL() {
        return this._xhr.responseURL;
    }
    /**
     * Returns client's response as text
     */ get responseText() {
        return this._xhr.responseText;
    }
    /**
     * Gets or sets the expected response type
     */ get responseType() {
        return this._xhr.responseType;
    }
    set responseType(value) {
        this._xhr.responseType = value;
    }
    /**
     * Gets or sets the timeout value in milliseconds
     */ get timeout() {
        return this._xhr.timeout;
    }
    set timeout(value) {
        this._xhr.timeout = value;
    }
    addEventListener(type, listener, options) {
        this._xhr.addEventListener(type, listener, options);
    }
    removeEventListener(type, listener, options) {
        this._xhr.removeEventListener(type, listener, options);
    }
    /**
     * Cancels any network activity
     */ abort() {
        this._xhr.abort();
    }
    /**
     * Initiates the request. The optional argument provides the request body. The argument is ignored if request method is GET or HEAD
     * @param body defines an optional request body
     */ send(body) {
        if ($d0a351f143d2884d$export$6f76b2393893a286.CustomRequestHeaders) this._injectCustomRequestHeaders();
        this._xhr.send(body);
    }
    /**
     * Sets the request method, request URL
     * @param method defines the method to use (GET, POST, etc..)
     * @param url defines the url to connect with
     */ open(method, url) {
        for (const update of $d0a351f143d2884d$export$6f76b2393893a286.CustomRequestModifiers){
            if (this._shouldSkipRequestModifications(url)) return;
            update(this._xhr, url);
        }
        // Clean url
        url = url.replace("file:http:", "http:");
        url = url.replace("file:https:", "https:");
        this._requestURL = url;
        this._xhr.open(method, url, true);
    }
    /**
     * Sets the value of a request header.
     * @param name The name of the header whose value is to be set
     * @param value The value to set as the body of the header
     */ setRequestHeader(name, value) {
        this._xhr.setRequestHeader(name, value);
    }
    /**
     * Get the string containing the text of a particular header's value.
     * @param name The name of the header
     * @returns The string containing the text of the given header name
     */ getResponseHeader(name) {
        return this._xhr.getResponseHeader(name);
    }
}
/**
 * Custom HTTP Request Headers to be sent with XMLHttpRequests
 * i.e. when loading files, where the server/service expects an Authorization header
 */ $d0a351f143d2884d$export$6f76b2393893a286.CustomRequestHeaders = {};
/**
 * Add callback functions in this array to update all the requests before they get sent to the network
 */ $d0a351f143d2884d$export$6f76b2393893a286.CustomRequestModifiers = new Array();
/**
 * If set to true, requests to Babylon.js CDN requests will not be modified
 */ $d0a351f143d2884d$export$6f76b2393893a286.SkipRequestModificationForBabylonCDN = true;

});




parcelRegister("hD7z9", function(module, exports) {

var $aAGn3 = parcelRequire("aAGn3");

var $lWogh = parcelRequire("lWogh");

var $c0Yfq = parcelRequire("c0Yfq");

var $01TD7 = parcelRequire("01TD7");

var $6l39S = parcelRequire("6l39S");

var $3Ey8i = parcelRequire("3Ey8i");

var $1LmZt = parcelRequire("1LmZt");

var $GNvkC = parcelRequire("GNvkC");

var $knVpn = parcelRequire("knVpn");

var $ymxrh = parcelRequire("ymxrh");

var $78nGO = parcelRequire("78nGO");

var $6Xc2k = parcelRequire("6Xc2k");
$parcel$exportWildcard(module.exports, $aAGn3);
$parcel$exportWildcard(module.exports, $lWogh);
$parcel$exportWildcard(module.exports, $c0Yfq);
$parcel$exportWildcard(module.exports, $01TD7);
$parcel$exportWildcard(module.exports, $6l39S);
$parcel$exportWildcard(module.exports, $3Ey8i);
$parcel$exportWildcard(module.exports, $1LmZt);
$parcel$exportWildcard(module.exports, $GNvkC);
$parcel$exportWildcard(module.exports, $knVpn);
$parcel$exportWildcard(module.exports, $ymxrh);
$parcel$exportWildcard(module.exports, $78nGO);
$parcel$exportWildcard(module.exports, $6Xc2k);

});
parcelRegister("aAGn3", function(module, exports) {

$parcel$export(module.exports, "Animatable", () => $7b5e22274c2ef47e$export$8d0d04e6da868f4);

var $lWogh = parcelRequire("lWogh");

var $6l39S = parcelRequire("6l39S");

var $diGQf = parcelRequire("diGQf");

var $gmbCk = parcelRequire("gmbCk");

var $ha1VO = parcelRequire("ha1VO");

var $blHSI = parcelRequire("blHSI");

var $g6X9E = parcelRequire("g6X9E");
class $7b5e22274c2ef47e$export$8d0d04e6da868f4 {
    /**
     * Gets the root Animatable used to synchronize and normalize animations
     */ get syncRoot() {
        return this._syncRoot;
    }
    /**
     * Gets the current frame of the first RuntimeAnimation
     * Used to synchronize Animatables
     */ get masterFrame() {
        if (this._runtimeAnimations.length === 0) return 0;
        return this._runtimeAnimations[0].currentFrame;
    }
    /**
     * Gets or sets the animatable weight (-1.0 by default meaning not weighted)
     */ get weight() {
        return this._weight;
    }
    set weight(value) {
        if (value === -1) {
            // -1 is ok and means no weight
            this._weight = -1;
            return;
        }
        // Else weight must be in [0, 1] range
        this._weight = Math.min(Math.max(value, 0), 1.0);
    }
    /**
     * Gets or sets the speed ratio to apply to the animatable (1.0 by default)
     */ get speedRatio() {
        return this._speedRatio;
    }
    set speedRatio(value) {
        for(let index = 0; index < this._runtimeAnimations.length; index++){
            const animation = this._runtimeAnimations[index];
            animation._prepareForSpeedRatioChange(value);
        }
        this._speedRatio = value;
        // Resync _manualJumpDelay in case goToFrame was called before speedRatio was set.
        if (this._goToFrame !== null) this.goToFrame(this._goToFrame);
    }
    /**
     * Gets the elapsed time since the animatable started in milliseconds
     */ get elapsedTime() {
        return this._localDelayOffset === null ? 0 : this._scene._animationTime - this._localDelayOffset;
    }
    /**
     * Creates a new Animatable
     * @param scene defines the hosting scene
     * @param target defines the target object
     * @param fromFrame defines the starting frame number (default is 0)
     * @param toFrame defines the ending frame number (default is 100)
     * @param loopAnimation defines if the animation must loop (default is false)
     * @param speedRatio defines the factor to apply to animation speed (default is 1)
     * @param onAnimationEnd defines a callback to call when animation ends if it is not looping
     * @param animations defines a group of animation to add to the new Animatable
     * @param onAnimationLoop defines a callback to call when animation loops
     * @param isAdditive defines whether the animation should be evaluated additively
     * @param playOrder defines the order in which this animatable should be processed in the list of active animatables (default: 0)
     */ constructor(scene, /** defines the target object */ target, /** defines the starting frame number (default is 0) */ fromFrame = 0, /** defines the ending frame number (default is 100) */ toFrame = 100, /** defines if the animation must loop (default is false)  */ loopAnimation = false, speedRatio = 1.0, /** defines a callback to call when animation ends if it is not looping */ onAnimationEnd, animations, /** defines a callback to call when animation loops */ onAnimationLoop, /** defines whether the animation should be evaluated additively */ isAdditive = false, /** defines the order in which this animatable should be processed in the list of active animatables (default: 0) */ playOrder = 0){
        this.target = target;
        this.fromFrame = fromFrame;
        this.toFrame = toFrame;
        this.loopAnimation = loopAnimation;
        this.onAnimationEnd = onAnimationEnd;
        this.onAnimationLoop = onAnimationLoop;
        this.isAdditive = isAdditive;
        this.playOrder = playOrder;
        this._localDelayOffset = null;
        this._pausedDelay = null;
        this._manualJumpDelay = null;
        /** @hidden */ this._runtimeAnimations = new Array();
        this._paused = false;
        this._speedRatio = 1;
        this._weight = -1;
        this._syncRoot = null;
        this._frameToSyncFromJump = null;
        this._goToFrame = null;
        /**
         * Gets or sets a boolean indicating if the animatable must be disposed and removed at the end of the animation.
         * This will only apply for non looping animation (default is true)
         */ this.disposeOnEnd = true;
        /**
         * Gets a boolean indicating if the animation has started
         */ this.animationStarted = false;
        /**
         * Observer raised when the animation ends
         */ this.onAnimationEndObservable = new (0, $diGQf.Observable)();
        /**
         * Observer raised when the animation loops
         */ this.onAnimationLoopObservable = new (0, $diGQf.Observable)();
        this._scene = scene;
        if (animations) this.appendAnimations(target, animations);
        this._speedRatio = speedRatio;
        scene._activeAnimatables.push(this);
    }
    // Methods
    /**
     * Synchronize and normalize current Animatable with a source Animatable
     * This is useful when using animation weights and when animations are not of the same length
     * @param root defines the root Animatable to synchronize with (null to stop synchronizing)
     * @returns the current Animatable
     */ syncWith(root) {
        this._syncRoot = root;
        if (root) {
            // Make sure this animatable will animate after the root
            const index = this._scene._activeAnimatables.indexOf(this);
            if (index > -1) {
                this._scene._activeAnimatables.splice(index, 1);
                this._scene._activeAnimatables.push(this);
            }
        }
        return this;
    }
    /**
     * Gets the list of runtime animations
     * @returns an array of RuntimeAnimation
     */ getAnimations() {
        return this._runtimeAnimations;
    }
    /**
     * Adds more animations to the current animatable
     * @param target defines the target of the animations
     * @param animations defines the new animations to add
     */ appendAnimations(target, animations) {
        for(let index = 0; index < animations.length; index++){
            const animation = animations[index];
            const newRuntimeAnimation = new (0, $6l39S.RuntimeAnimation)(target, animation, this._scene, this);
            newRuntimeAnimation._onLoop = ()=>{
                this.onAnimationLoopObservable.notifyObservers(this);
                if (this.onAnimationLoop) this.onAnimationLoop();
            };
            this._runtimeAnimations.push(newRuntimeAnimation);
        }
    }
    /**
     * Gets the source animation for a specific property
     * @param property defines the property to look for
     * @returns null or the source animation for the given property
     */ getAnimationByTargetProperty(property) {
        const runtimeAnimations = this._runtimeAnimations;
        for(let index = 0; index < runtimeAnimations.length; index++){
            if (runtimeAnimations[index].animation.targetProperty === property) return runtimeAnimations[index].animation;
        }
        return null;
    }
    /**
     * Gets the runtime animation for a specific property
     * @param property defines the property to look for
     * @returns null or the runtime animation for the given property
     */ getRuntimeAnimationByTargetProperty(property) {
        const runtimeAnimations = this._runtimeAnimations;
        for(let index = 0; index < runtimeAnimations.length; index++){
            if (runtimeAnimations[index].animation.targetProperty === property) return runtimeAnimations[index];
        }
        return null;
    }
    /**
     * Resets the animatable to its original state
     */ reset() {
        const runtimeAnimations = this._runtimeAnimations;
        for(let index = 0; index < runtimeAnimations.length; index++)runtimeAnimations[index].reset(true);
        this._localDelayOffset = null;
        this._pausedDelay = null;
    }
    /**
     * Allows the animatable to blend with current running animations
     * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#animation-blending
     * @param blendingSpeed defines the blending speed to use
     */ enableBlending(blendingSpeed) {
        const runtimeAnimations = this._runtimeAnimations;
        for(let index = 0; index < runtimeAnimations.length; index++){
            runtimeAnimations[index].animation.enableBlending = true;
            runtimeAnimations[index].animation.blendingSpeed = blendingSpeed;
        }
    }
    /**
     * Disable animation blending
     * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#animation-blending
     */ disableBlending() {
        const runtimeAnimations = this._runtimeAnimations;
        for(let index = 0; index < runtimeAnimations.length; index++)runtimeAnimations[index].animation.enableBlending = false;
    }
    /**
     * Jump directly to a given frame
     * @param frame defines the frame to jump to
     */ goToFrame(frame) {
        const runtimeAnimations = this._runtimeAnimations;
        if (runtimeAnimations[0]) {
            const fps = runtimeAnimations[0].animation.framePerSecond;
            this._frameToSyncFromJump = this._frameToSyncFromJump ?? runtimeAnimations[0].currentFrame;
            const delay = this.speedRatio === 0 ? 0 : (frame - this._frameToSyncFromJump) / fps * 1000 / this.speedRatio;
            this._manualJumpDelay = -delay;
        }
        for(let index = 0; index < runtimeAnimations.length; index++)runtimeAnimations[index].goToFrame(frame);
        this._goToFrame = frame;
    }
    /**
     * Returns true if the animations for this animatable are paused
     */ get paused() {
        return this._paused;
    }
    /**
     * Pause the animation
     */ pause() {
        if (this._paused) return;
        this._paused = true;
    }
    /**
     * Restart the animation
     */ restart() {
        this._paused = false;
    }
    _raiseOnAnimationEnd() {
        if (this.onAnimationEnd) this.onAnimationEnd();
        this.onAnimationEndObservable.notifyObservers(this);
    }
    /**
     * Stop and delete the current animation
     * @param animationName defines a string used to only stop some of the runtime animations instead of all
     * @param targetMask a function that determines if the animation should be stopped based on its target (all animations will be stopped if both this and animationName are empty)
     * @param useGlobalSplice if true, the animatables will be removed by the caller of this function (false by default)
     */ stop(animationName, targetMask, useGlobalSplice = false) {
        if (animationName || targetMask) {
            const idx = this._scene._activeAnimatables.indexOf(this);
            if (idx > -1) {
                const runtimeAnimations = this._runtimeAnimations;
                for(let index = runtimeAnimations.length - 1; index >= 0; index--){
                    const runtimeAnimation = runtimeAnimations[index];
                    if (animationName && runtimeAnimation.animation.name != animationName) continue;
                    if (targetMask && !targetMask(runtimeAnimation.target)) continue;
                    runtimeAnimation.dispose();
                    runtimeAnimations.splice(index, 1);
                }
                if (runtimeAnimations.length == 0) {
                    if (!useGlobalSplice) this._scene._activeAnimatables.splice(idx, 1);
                    this._raiseOnAnimationEnd();
                }
            }
        } else {
            const index = this._scene._activeAnimatables.indexOf(this);
            if (index > -1) {
                if (!useGlobalSplice) this._scene._activeAnimatables.splice(index, 1);
                const runtimeAnimations = this._runtimeAnimations;
                for(let index = 0; index < runtimeAnimations.length; index++)runtimeAnimations[index].dispose();
                this._runtimeAnimations.length = 0;
                this._raiseOnAnimationEnd();
            }
        }
    }
    /**
     * Wait asynchronously for the animation to end
     * @returns a promise which will be fulfilled when the animation ends
     */ waitAsync() {
        return new Promise((resolve)=>{
            this.onAnimationEndObservable.add(()=>{
                resolve(this);
            }, undefined, undefined, this, true);
        });
    }
    /**
     * @internal
     */ _animate(delay) {
        if (this._paused) {
            this.animationStarted = false;
            if (this._pausedDelay === null) this._pausedDelay = delay;
            return true;
        }
        if (this._localDelayOffset === null) {
            this._localDelayOffset = delay;
            this._pausedDelay = null;
        } else if (this._pausedDelay !== null) {
            this._localDelayOffset += delay - this._pausedDelay;
            this._pausedDelay = null;
        }
        if (this._manualJumpDelay !== null) {
            this._localDelayOffset += this._manualJumpDelay;
            this._manualJumpDelay = null;
            this._frameToSyncFromJump = null;
        }
        this._goToFrame = null;
        if (this._weight === 0) // We consider that an animatable with a weight === 0 is "actively" paused
        return true;
        // Animating
        let running = false;
        const runtimeAnimations = this._runtimeAnimations;
        let index;
        for(index = 0; index < runtimeAnimations.length; index++){
            const animation = runtimeAnimations[index];
            const isRunning = animation.animate(delay - this._localDelayOffset, this.fromFrame, this.toFrame, this.loopAnimation, this._speedRatio, this._weight);
            running = running || isRunning;
        }
        this.animationStarted = running;
        if (!running) {
            if (this.disposeOnEnd) {
                // Remove from active animatables
                index = this._scene._activeAnimatables.indexOf(this);
                this._scene._activeAnimatables.splice(index, 1);
                // Dispose all runtime animations
                for(index = 0; index < runtimeAnimations.length; index++)runtimeAnimations[index].dispose();
            }
            this._raiseOnAnimationEnd();
            if (this.disposeOnEnd) {
                this.onAnimationEnd = null;
                this.onAnimationLoop = null;
                this.onAnimationLoopObservable.clear();
                this.onAnimationEndObservable.clear();
            }
        }
        return running;
    }
}
(0, $gmbCk.Scene).prototype._animate = function(customDeltaTime) {
    if (!this.animationsEnabled) return;
    // Getting time
    const now = (0, $blHSI.PrecisionDate).Now;
    if (!this._animationTimeLast) {
        if (this._pendingData.length > 0) return;
        this._animationTimeLast = now;
    }
    this.deltaTime = customDeltaTime !== undefined ? customDeltaTime : this.useConstantAnimationDeltaTime ? 16.0 : (now - this._animationTimeLast) * this.animationTimeScale;
    this._animationTimeLast = now;
    const animatables = this._activeAnimatables;
    if (animatables.length === 0) return;
    this._animationTime += this.deltaTime;
    const animationTime = this._animationTime;
    for(let index = 0; index < animatables.length; index++){
        const animatable = animatables[index];
        if (!animatable._animate(animationTime) && animatable.disposeOnEnd) index--; // Array was updated
    }
    // Late animation bindings
    this._processLateAnimationBindings();
};
(0, $gmbCk.Scene).prototype.sortActiveAnimatables = function() {
    this._activeAnimatables.sort((a, b)=>{
        return a.playOrder - b.playOrder;
    });
};
(0, $gmbCk.Scene).prototype.beginWeightedAnimation = function(target, from, to, weight = 1.0, loop, speedRatio = 1.0, onAnimationEnd, animatable, targetMask, onAnimationLoop, isAdditive = false) {
    const returnedAnimatable = this.beginAnimation(target, from, to, loop, speedRatio, onAnimationEnd, animatable, false, targetMask, onAnimationLoop, isAdditive);
    returnedAnimatable.weight = weight;
    return returnedAnimatable;
};
(0, $gmbCk.Scene).prototype.beginAnimation = function(target, from, to, loop, speedRatio = 1.0, onAnimationEnd, animatable, stopCurrent = true, targetMask, onAnimationLoop, isAdditive = false) {
    if (from > to && speedRatio > 0) speedRatio *= -1;
    if (stopCurrent) this.stopAnimation(target, undefined, targetMask);
    if (!animatable) animatable = new $7b5e22274c2ef47e$export$8d0d04e6da868f4(this, target, from, to, loop, speedRatio, onAnimationEnd, undefined, onAnimationLoop, isAdditive);
    const shouldRunTargetAnimations = targetMask ? targetMask(target) : true;
    // Local animations
    if (target.animations && shouldRunTargetAnimations) animatable.appendAnimations(target, target.animations);
    // Children animations
    if (target.getAnimatables) {
        const animatables = target.getAnimatables();
        for(let index = 0; index < animatables.length; index++)this.beginAnimation(animatables[index], from, to, loop, speedRatio, onAnimationEnd, animatable, stopCurrent, targetMask, onAnimationLoop);
    }
    animatable.reset();
    return animatable;
};
(0, $gmbCk.Scene).prototype.beginHierarchyAnimation = function(target, directDescendantsOnly, from, to, loop, speedRatio = 1.0, onAnimationEnd, animatable, stopCurrent = true, targetMask, onAnimationLoop, isAdditive = false) {
    const children = target.getDescendants(directDescendantsOnly);
    const result = [];
    result.push(this.beginAnimation(target, from, to, loop, speedRatio, onAnimationEnd, animatable, stopCurrent, targetMask, undefined, isAdditive));
    for (const child of children)result.push(this.beginAnimation(child, from, to, loop, speedRatio, onAnimationEnd, animatable, stopCurrent, targetMask, undefined, isAdditive));
    return result;
};
(0, $gmbCk.Scene).prototype.beginDirectAnimation = function(target, animations, from, to, loop, speedRatio, onAnimationEnd, onAnimationLoop, isAdditive = false) {
    if (speedRatio === undefined) speedRatio = 1.0;
    if (from > to && speedRatio > 0) speedRatio *= -1;
    else if (to > from && speedRatio < 0) {
        const temp = to;
        to = from;
        from = temp;
    }
    const animatable = new $7b5e22274c2ef47e$export$8d0d04e6da868f4(this, target, from, to, loop, speedRatio, onAnimationEnd, animations, onAnimationLoop, isAdditive);
    return animatable;
};
(0, $gmbCk.Scene).prototype.beginDirectHierarchyAnimation = function(target, directDescendantsOnly, animations, from, to, loop, speedRatio, onAnimationEnd, onAnimationLoop, isAdditive = false) {
    const children = target.getDescendants(directDescendantsOnly);
    const result = [];
    result.push(this.beginDirectAnimation(target, animations, from, to, loop, speedRatio, onAnimationEnd, onAnimationLoop, isAdditive));
    for (const child of children)result.push(this.beginDirectAnimation(child, animations, from, to, loop, speedRatio, onAnimationEnd, onAnimationLoop, isAdditive));
    return result;
};
(0, $gmbCk.Scene).prototype.getAnimatableByTarget = function(target) {
    for(let index = 0; index < this._activeAnimatables.length; index++){
        if (this._activeAnimatables[index].target === target) return this._activeAnimatables[index];
    }
    return null;
};
(0, $gmbCk.Scene).prototype.getAllAnimatablesByTarget = function(target) {
    const result = [];
    for(let index = 0; index < this._activeAnimatables.length; index++)if (this._activeAnimatables[index].target === target) result.push(this._activeAnimatables[index]);
    return result;
};
/**
 * Will stop the animation of the given target
 * @param target - the target
 * @param animationName - the name of the animation to stop (all animations will be stopped if both this and targetMask are empty)
 * @param targetMask - a function that determines if the animation should be stopped based on its target (all animations will be stopped if both this and animationName are empty)
 */ (0, $gmbCk.Scene).prototype.stopAnimation = function(target, animationName, targetMask) {
    const animatables = this.getAllAnimatablesByTarget(target);
    for (const animatable of animatables)animatable.stop(animationName, targetMask);
};
/**
 * Stops and removes all animations that have been applied to the scene
 */ (0, $gmbCk.Scene).prototype.stopAllAnimations = function() {
    if (this._activeAnimatables) {
        for(let i = 0; i < this._activeAnimatables.length; i++)this._activeAnimatables[i].stop(undefined, undefined, true);
        this._activeAnimatables.length = 0;
    }
    for (const group of this.animationGroups)group.stop();
};
(0, $gmbCk.Scene).prototype._registerTargetForLateAnimationBinding = function(runtimeAnimation, originalValue) {
    const target = runtimeAnimation.target;
    this._registeredForLateAnimationBindings.pushNoDuplicate(target);
    if (!target._lateAnimationHolders) target._lateAnimationHolders = {};
    if (!target._lateAnimationHolders[runtimeAnimation.targetPath]) target._lateAnimationHolders[runtimeAnimation.targetPath] = {
        totalWeight: 0,
        totalAdditiveWeight: 0,
        animations: [],
        additiveAnimations: [],
        originalValue: originalValue
    };
    if (runtimeAnimation.isAdditive) {
        target._lateAnimationHolders[runtimeAnimation.targetPath].additiveAnimations.push(runtimeAnimation);
        target._lateAnimationHolders[runtimeAnimation.targetPath].totalAdditiveWeight += runtimeAnimation.weight;
    } else {
        target._lateAnimationHolders[runtimeAnimation.targetPath].animations.push(runtimeAnimation);
        target._lateAnimationHolders[runtimeAnimation.targetPath].totalWeight += runtimeAnimation.weight;
    }
};
(0, $gmbCk.Scene).prototype._processLateAnimationBindingsForMatrices = function(holder) {
    if (holder.totalWeight === 0 && holder.totalAdditiveWeight === 0) return holder.originalValue;
    let normalizer = 1.0;
    const finalPosition = (0, $ha1VO.TmpVectors).Vector3[0];
    const finalScaling = (0, $ha1VO.TmpVectors).Vector3[1];
    const finalQuaternion = (0, $ha1VO.TmpVectors).Quaternion[0];
    let startIndex = 0;
    const originalAnimation = holder.animations[0];
    const originalValue = holder.originalValue;
    let scale = 1;
    let skipOverride = false;
    if (holder.totalWeight < 1.0) {
        // We need to mix the original value in
        scale = 1.0 - holder.totalWeight;
        originalValue.decompose(finalScaling, finalQuaternion, finalPosition);
    } else {
        startIndex = 1;
        // We need to normalize the weights
        normalizer = holder.totalWeight;
        scale = originalAnimation.weight / normalizer;
        if (scale == 1) {
            if (holder.totalAdditiveWeight) skipOverride = true;
            else return originalAnimation.currentValue;
        }
        originalAnimation.currentValue.decompose(finalScaling, finalQuaternion, finalPosition);
    }
    // Add up the override animations
    if (!skipOverride) {
        finalScaling.scaleInPlace(scale);
        finalPosition.scaleInPlace(scale);
        finalQuaternion.scaleInPlace(scale);
        for(let animIndex = startIndex; animIndex < holder.animations.length; animIndex++){
            const runtimeAnimation = holder.animations[animIndex];
            if (runtimeAnimation.weight === 0) continue;
            scale = runtimeAnimation.weight / normalizer;
            const currentPosition = (0, $ha1VO.TmpVectors).Vector3[2];
            const currentScaling = (0, $ha1VO.TmpVectors).Vector3[3];
            const currentQuaternion = (0, $ha1VO.TmpVectors).Quaternion[1];
            runtimeAnimation.currentValue.decompose(currentScaling, currentQuaternion, currentPosition);
            currentScaling.scaleAndAddToRef(scale, finalScaling);
            currentQuaternion.scaleAndAddToRef((0, $ha1VO.Quaternion).Dot(finalQuaternion, currentQuaternion) > 0 ? scale : -scale, finalQuaternion);
            currentPosition.scaleAndAddToRef(scale, finalPosition);
        }
        finalQuaternion.normalize();
    }
    // Add up the additive animations
    for(let animIndex = 0; animIndex < holder.additiveAnimations.length; animIndex++){
        const runtimeAnimation = holder.additiveAnimations[animIndex];
        if (runtimeAnimation.weight === 0) continue;
        const currentPosition = (0, $ha1VO.TmpVectors).Vector3[2];
        const currentScaling = (0, $ha1VO.TmpVectors).Vector3[3];
        const currentQuaternion = (0, $ha1VO.TmpVectors).Quaternion[1];
        runtimeAnimation.currentValue.decompose(currentScaling, currentQuaternion, currentPosition);
        currentScaling.multiplyToRef(finalScaling, currentScaling);
        (0, $ha1VO.Vector3).LerpToRef(finalScaling, currentScaling, runtimeAnimation.weight, finalScaling);
        finalQuaternion.multiplyToRef(currentQuaternion, currentQuaternion);
        (0, $ha1VO.Quaternion).SlerpToRef(finalQuaternion, currentQuaternion, runtimeAnimation.weight, finalQuaternion);
        currentPosition.scaleAndAddToRef(runtimeAnimation.weight, finalPosition);
    }
    const workValue = originalAnimation ? originalAnimation._animationState.workValue : (0, $ha1VO.TmpVectors).Matrix[0].clone();
    (0, $ha1VO.Matrix).ComposeToRef(finalScaling, finalQuaternion, finalPosition, workValue);
    return workValue;
};
(0, $gmbCk.Scene).prototype._processLateAnimationBindingsForQuaternions = function(holder, refQuaternion) {
    if (holder.totalWeight === 0 && holder.totalAdditiveWeight === 0) return refQuaternion;
    const originalAnimation = holder.animations[0];
    const originalValue = holder.originalValue;
    let cumulativeQuaternion = refQuaternion;
    if (holder.totalWeight === 0 && holder.totalAdditiveWeight > 0) cumulativeQuaternion.copyFrom(originalValue);
    else if (holder.animations.length === 1) {
        (0, $ha1VO.Quaternion).SlerpToRef(originalValue, originalAnimation.currentValue, Math.min(1.0, holder.totalWeight), cumulativeQuaternion);
        if (holder.totalAdditiveWeight === 0) return cumulativeQuaternion;
    } else if (holder.animations.length > 1) {
        // Add up the override animations
        let normalizer = 1.0;
        let quaternions;
        let weights;
        if (holder.totalWeight < 1.0) {
            const scale = 1.0 - holder.totalWeight;
            quaternions = [];
            weights = [];
            quaternions.push(originalValue);
            weights.push(scale);
        } else {
            if (holder.animations.length === 2) {
                // Slerp as soon as we can
                (0, $ha1VO.Quaternion).SlerpToRef(holder.animations[0].currentValue, holder.animations[1].currentValue, holder.animations[1].weight / holder.totalWeight, refQuaternion);
                if (holder.totalAdditiveWeight === 0) return refQuaternion;
            }
            quaternions = [];
            weights = [];
            normalizer = holder.totalWeight;
        }
        for(let animIndex = 0; animIndex < holder.animations.length; animIndex++){
            const runtimeAnimation = holder.animations[animIndex];
            quaternions.push(runtimeAnimation.currentValue);
            weights.push(runtimeAnimation.weight / normalizer);
        }
        // https://gamedev.stackexchange.com/questions/62354/method-for-interpolation-between-3-quaternions
        let cumulativeAmount = 0;
        for(let index = 0; index < quaternions.length;){
            if (!index) {
                (0, $ha1VO.Quaternion).SlerpToRef(quaternions[index], quaternions[index + 1], weights[index + 1] / (weights[index] + weights[index + 1]), refQuaternion);
                cumulativeQuaternion = refQuaternion;
                cumulativeAmount = weights[index] + weights[index + 1];
                index += 2;
                continue;
            }
            cumulativeAmount += weights[index];
            (0, $ha1VO.Quaternion).SlerpToRef(cumulativeQuaternion, quaternions[index], weights[index] / cumulativeAmount, cumulativeQuaternion);
            index++;
        }
    }
    // Add up the additive animations
    for(let animIndex = 0; animIndex < holder.additiveAnimations.length; animIndex++){
        const runtimeAnimation = holder.additiveAnimations[animIndex];
        if (runtimeAnimation.weight === 0) continue;
        cumulativeQuaternion.multiplyToRef(runtimeAnimation.currentValue, (0, $ha1VO.TmpVectors).Quaternion[0]);
        (0, $ha1VO.Quaternion).SlerpToRef(cumulativeQuaternion, (0, $ha1VO.TmpVectors).Quaternion[0], runtimeAnimation.weight, cumulativeQuaternion);
    }
    return cumulativeQuaternion;
};
(0, $gmbCk.Scene).prototype._processLateAnimationBindings = function() {
    if (!this._registeredForLateAnimationBindings.length) return;
    for(let index = 0; index < this._registeredForLateAnimationBindings.length; index++){
        const target = this._registeredForLateAnimationBindings.data[index];
        for(const path in target._lateAnimationHolders){
            const holder = target._lateAnimationHolders[path];
            const originalAnimation = holder.animations[0];
            const originalValue = holder.originalValue;
            if (originalValue === undefined || originalValue === null) continue;
            const matrixDecomposeMode = (0, $lWogh.Animation).AllowMatrixDecomposeForInterpolation && originalValue.m; // ie. data is matrix
            let finalValue = target[path];
            if (matrixDecomposeMode) finalValue = this._processLateAnimationBindingsForMatrices(holder);
            else {
                const quaternionMode = originalValue.w !== undefined;
                if (quaternionMode) finalValue = this._processLateAnimationBindingsForQuaternions(holder, finalValue || (0, $ha1VO.Quaternion).Identity());
                else {
                    let startIndex = 0;
                    let normalizer = 1.0;
                    const originalAnimationIsLoopRelativeFromCurrent = originalAnimation && originalAnimation._animationState.loopMode === (0, $lWogh.Animation).ANIMATIONLOOPMODE_RELATIVE_FROM_CURRENT;
                    if (holder.totalWeight < 1.0) {
                        // We need to mix the original value in
                        if (originalAnimationIsLoopRelativeFromCurrent) finalValue = originalValue.clone ? originalValue.clone() : originalValue;
                        else if (originalAnimation && originalValue.scale) finalValue = originalValue.scale(1.0 - holder.totalWeight);
                        else if (originalAnimation) finalValue = originalValue * (1.0 - holder.totalWeight);
                        else if (originalValue.clone) finalValue = originalValue.clone();
                        else finalValue = originalValue;
                    } else if (originalAnimation) {
                        // We need to normalize the weights
                        normalizer = holder.totalWeight;
                        const scale = originalAnimation.weight / normalizer;
                        if (scale !== 1) {
                            if (originalAnimation.currentValue.scale) finalValue = originalAnimation.currentValue.scale(scale);
                            else finalValue = originalAnimation.currentValue * scale;
                        } else finalValue = originalAnimation.currentValue;
                        if (originalAnimationIsLoopRelativeFromCurrent) {
                            if (finalValue.addToRef) finalValue.addToRef(originalValue, finalValue);
                            else finalValue += originalValue;
                        }
                        startIndex = 1;
                    }
                    // Add up the override animations
                    for(let animIndex = startIndex; animIndex < holder.animations.length; animIndex++){
                        const runtimeAnimation = holder.animations[animIndex];
                        const scale = runtimeAnimation.weight / normalizer;
                        if (!scale) continue;
                        else if (runtimeAnimation.currentValue.scaleAndAddToRef) runtimeAnimation.currentValue.scaleAndAddToRef(scale, finalValue);
                        else finalValue += runtimeAnimation.currentValue * scale;
                    }
                    // Add up the additive animations
                    for(let animIndex = 0; animIndex < holder.additiveAnimations.length; animIndex++){
                        const runtimeAnimation = holder.additiveAnimations[animIndex];
                        const scale = runtimeAnimation.weight;
                        if (!scale) continue;
                        else if (runtimeAnimation.currentValue.scaleAndAddToRef) runtimeAnimation.currentValue.scaleAndAddToRef(scale, finalValue);
                        else finalValue += runtimeAnimation.currentValue * scale;
                    }
                }
            }
            target[path] = finalValue;
        }
        target._lateAnimationHolders = {};
    }
    this._registeredForLateAnimationBindings.reset();
};
(0, $g6X9E.Bone).prototype.copyAnimationRange = function(source, rangeName, frameOffset, rescaleAsRequired = false, skelDimensionsRatio = null) {
    // all animation may be coming from a library skeleton, so may need to create animation
    if (this.animations.length === 0) {
        this.animations.push(new (0, $lWogh.Animation)(this.name, "_matrix", source.animations[0].framePerSecond, (0, $lWogh.Animation).ANIMATIONTYPE_MATRIX, 0));
        this.animations[0].setKeys([]);
    }
    // get animation info / verify there is such a range from the source bone
    const sourceRange = source.animations[0].getRange(rangeName);
    if (!sourceRange) return false;
    const from = sourceRange.from;
    const to = sourceRange.to;
    const sourceKeys = source.animations[0].getKeys();
    // rescaling prep
    const sourceBoneLength = source.length;
    const sourceParent = source.getParent();
    const parent = this.getParent();
    const parentScalingReqd = rescaleAsRequired && sourceParent && sourceBoneLength && this.length && sourceBoneLength !== this.length;
    const parentRatio = parentScalingReqd && parent && sourceParent ? parent.length / sourceParent.length : 1;
    const dimensionsScalingReqd = rescaleAsRequired && !parent && skelDimensionsRatio && (skelDimensionsRatio.x !== 1 || skelDimensionsRatio.y !== 1 || skelDimensionsRatio.z !== 1);
    const destKeys = this.animations[0].getKeys();
    // loop vars declaration
    let orig;
    let origTranslation;
    let mat;
    for(let key = 0, nKeys = sourceKeys.length; key < nKeys; key++){
        orig = sourceKeys[key];
        if (orig.frame >= from && orig.frame <= to) {
            if (rescaleAsRequired) {
                mat = orig.value.clone();
                // scale based on parent ratio, when bone has parent
                if (parentScalingReqd) {
                    origTranslation = mat.getTranslation();
                    mat.setTranslation(origTranslation.scaleInPlace(parentRatio));
                // scale based on skeleton dimension ratio when root bone, and value is passed
                } else if (dimensionsScalingReqd && skelDimensionsRatio) {
                    origTranslation = mat.getTranslation();
                    mat.setTranslation(origTranslation.multiplyInPlace(skelDimensionsRatio));
                // use original when root bone, and no data for skelDimensionsRatio
                } else mat = orig.value;
            } else mat = orig.value;
            destKeys.push({
                frame: orig.frame + frameOffset,
                value: mat
            });
        }
    }
    this.animations[0].createRange(rangeName, from + frameOffset, to + frameOffset);
    return true;
};

});
parcelRegister("6l39S", function(module, exports) {

$parcel$export(module.exports, "RuntimeAnimation", () => $49d72768d87ebb9d$export$ce4961f17ea23fea);

var $ha1VO = parcelRequire("ha1VO");

var $lWogh = parcelRequire("lWogh");
class $49d72768d87ebb9d$export$ce4961f17ea23fea {
    /**
     * Gets the current frame of the runtime animation
     */ get currentFrame() {
        return this._currentFrame;
    }
    /**
     * Gets the weight of the runtime animation
     */ get weight() {
        return this._weight;
    }
    /**
     * Gets the current value of the runtime animation
     */ get currentValue() {
        return this._currentValue;
    }
    /**
     * Gets or sets the target path of the runtime animation
     */ get targetPath() {
        return this._targetPath;
    }
    /**
     * Gets the actual target of the runtime animation
     */ get target() {
        return this._currentActiveTarget;
    }
    /**
     * Gets the additive state of the runtime animation
     */ get isAdditive() {
        return this._host && this._host.isAdditive;
    }
    /**
     * Create a new RuntimeAnimation object
     * @param target defines the target of the animation
     * @param animation defines the source animation object
     * @param scene defines the hosting scene
     * @param host defines the initiating Animatable
     */ constructor(target, animation, scene, host){
        this._events = new Array();
        /**
         * The current frame of the runtime animation
         */ this._currentFrame = 0;
        /**
         * The original value of the runtime animation
         */ this._originalValue = new Array();
        /**
         * The original blend value of the runtime animation
         */ this._originalBlendValue = null;
        /**
         * The offsets cache of the runtime animation
         */ this._offsetsCache = {};
        /**
         * The high limits cache of the runtime animation
         */ this._highLimitsCache = {};
        /**
         * Specifies if the runtime animation has been stopped
         */ this._stopped = false;
        /**
         * The blending factor of the runtime animation
         */ this._blendingFactor = 0;
        /**
         * The current value of the runtime animation
         */ this._currentValue = null;
        this._currentActiveTarget = null;
        this._directTarget = null;
        /**
         * The target path of the runtime animation
         */ this._targetPath = "";
        /**
         * The weight of the runtime animation
         */ this._weight = 1.0;
        /**
         * The absolute frame offset of the runtime animation
         */ this._absoluteFrameOffset = 0;
        /**
         * The previous elapsed time (since start of animation) of the runtime animation
         */ this._previousElapsedTime = 0;
        /**
         * The previous absolute frame of the runtime animation (meaning, without taking into account the from/to values, only the elapsed time and the fps)
         */ this._previousAbsoluteFrame = 0;
        this._targetIsArray = false;
        this._animation = animation;
        this._target = target;
        this._scene = scene;
        this._host = host;
        this._activeTargets = [];
        animation._runtimeAnimations.push(this);
        // State
        this._animationState = {
            key: 0,
            repeatCount: 0,
            loopMode: this._getCorrectLoopMode()
        };
        if (this._animation.dataType === (0, $lWogh.Animation).ANIMATIONTYPE_MATRIX) this._animationState.workValue = (0, $ha1VO.Matrix).Zero();
        // Limits
        this._keys = this._animation.getKeys();
        this._minFrame = this._keys[0].frame;
        this._maxFrame = this._keys[this._keys.length - 1].frame;
        this._minValue = this._keys[0].value;
        this._maxValue = this._keys[this._keys.length - 1].value;
        // Add a start key at frame 0 if missing
        if (this._minFrame !== 0) {
            const newKey = {
                frame: 0,
                value: this._minValue
            };
            this._keys.splice(0, 0, newKey);
        }
        // Check data
        if (this._target instanceof Array) {
            let index = 0;
            for (const target of this._target){
                this._preparePath(target, index);
                this._getOriginalValues(index);
                index++;
            }
            this._targetIsArray = true;
        } else {
            this._preparePath(this._target);
            this._getOriginalValues();
            this._targetIsArray = false;
            this._directTarget = this._activeTargets[0];
        }
        // Cloning events locally
        const events = animation.getEvents();
        if (events && events.length > 0) events.forEach((e)=>{
            this._events.push(e._clone());
        });
        this._enableBlending = target && target.animationPropertiesOverride ? target.animationPropertiesOverride.enableBlending : this._animation.enableBlending;
    }
    _preparePath(target, targetIndex = 0) {
        const targetPropertyPath = this._animation.targetPropertyPath;
        if (targetPropertyPath.length > 1) {
            let property = target[targetPropertyPath[0]];
            for(let index = 1; index < targetPropertyPath.length - 1; index++)property = property[targetPropertyPath[index]];
            this._targetPath = targetPropertyPath[targetPropertyPath.length - 1];
            this._activeTargets[targetIndex] = property;
        } else {
            this._targetPath = targetPropertyPath[0];
            this._activeTargets[targetIndex] = target;
        }
    }
    /**
     * Gets the animation from the runtime animation
     */ get animation() {
        return this._animation;
    }
    /**
     * Resets the runtime animation to the beginning
     * @param restoreOriginal defines whether to restore the target property to the original value
     */ reset(restoreOriginal = false) {
        if (restoreOriginal) {
            if (this._target instanceof Array) {
                let index = 0;
                for (const target of this._target){
                    if (this._originalValue[index] !== undefined) this._setValue(target, this._activeTargets[index], this._originalValue[index], -1, index);
                    index++;
                }
            } else if (this._originalValue[0] !== undefined) this._setValue(this._target, this._directTarget, this._originalValue[0], -1, 0);
        }
        this._offsetsCache = {};
        this._highLimitsCache = {};
        this._currentFrame = 0;
        this._blendingFactor = 0;
        // Events
        for(let index = 0; index < this._events.length; index++)this._events[index].isDone = false;
    }
    /**
     * Specifies if the runtime animation is stopped
     * @returns Boolean specifying if the runtime animation is stopped
     */ isStopped() {
        return this._stopped;
    }
    /**
     * Disposes of the runtime animation
     */ dispose() {
        const index = this._animation.runtimeAnimations.indexOf(this);
        if (index > -1) this._animation.runtimeAnimations.splice(index, 1);
    }
    /**
     * Apply the interpolated value to the target
     * @param currentValue defines the value computed by the animation
     * @param weight defines the weight to apply to this value (Defaults to 1.0)
     */ setValue(currentValue, weight) {
        if (this._targetIsArray) {
            for(let index = 0; index < this._target.length; index++){
                const target = this._target[index];
                this._setValue(target, this._activeTargets[index], currentValue, weight, index);
            }
            return;
        }
        this._setValue(this._target, this._directTarget, currentValue, weight, 0);
    }
    _getOriginalValues(targetIndex = 0) {
        let originalValue;
        const target = this._activeTargets[targetIndex];
        if (target.getLocalMatrix && this._targetPath === "_matrix") // For bones
        originalValue = target.getLocalMatrix();
        else originalValue = target[this._targetPath];
        if (originalValue && originalValue.clone) this._originalValue[targetIndex] = originalValue.clone();
        else this._originalValue[targetIndex] = originalValue;
    }
    _setValue(target, destination, currentValue, weight, targetIndex) {
        // Set value
        this._currentActiveTarget = destination;
        this._weight = weight;
        if (this._enableBlending && this._blendingFactor <= 1.0) {
            if (!this._originalBlendValue) {
                const originalValue = destination[this._targetPath];
                if (originalValue.clone) this._originalBlendValue = originalValue.clone();
                else this._originalBlendValue = originalValue;
            }
            if (this._originalBlendValue.m) {
                // Matrix
                if ((0, $lWogh.Animation).AllowMatrixDecomposeForInterpolation) {
                    if (this._currentValue) (0, $ha1VO.Matrix).DecomposeLerpToRef(this._originalBlendValue, currentValue, this._blendingFactor, this._currentValue);
                    else this._currentValue = (0, $ha1VO.Matrix).DecomposeLerp(this._originalBlendValue, currentValue, this._blendingFactor);
                } else if (this._currentValue) (0, $ha1VO.Matrix).LerpToRef(this._originalBlendValue, currentValue, this._blendingFactor, this._currentValue);
                else this._currentValue = (0, $ha1VO.Matrix).Lerp(this._originalBlendValue, currentValue, this._blendingFactor);
            } else this._currentValue = (0, $lWogh.Animation)._UniversalLerp(this._originalBlendValue, currentValue, this._blendingFactor);
            const blendingSpeed = target && target.animationPropertiesOverride ? target.animationPropertiesOverride.blendingSpeed : this._animation.blendingSpeed;
            this._blendingFactor += blendingSpeed;
        } else {
            if (!this._currentValue) {
                if (currentValue?.clone) this._currentValue = currentValue.clone();
                else this._currentValue = currentValue;
            } else if (this._currentValue.copyFrom) this._currentValue.copyFrom(currentValue);
            else this._currentValue = currentValue;
        }
        if (weight !== -1) this._scene._registerTargetForLateAnimationBinding(this, this._originalValue[targetIndex]);
        else if (this._animationState.loopMode === (0, $lWogh.Animation).ANIMATIONLOOPMODE_RELATIVE_FROM_CURRENT) {
            if (this._currentValue.addToRef) this._currentValue.addToRef(this._originalValue[targetIndex], destination[this._targetPath]);
            else destination[this._targetPath] = this._originalValue[targetIndex] + this._currentValue;
        } else destination[this._targetPath] = this._currentValue;
        if (target.markAsDirty) target.markAsDirty(this._animation.targetProperty);
    }
    /**
     * Gets the loop pmode of the runtime animation
     * @returns Loop Mode
     */ _getCorrectLoopMode() {
        if (this._target && this._target.animationPropertiesOverride) return this._target.animationPropertiesOverride.loopMode;
        return this._animation.loopMode;
    }
    /**
     * Move the current animation to a given frame
     * @param frame defines the frame to move to
     */ goToFrame(frame) {
        const keys = this._animation.getKeys();
        if (frame < keys[0].frame) frame = keys[0].frame;
        else if (frame > keys[keys.length - 1].frame) frame = keys[keys.length - 1].frame;
        // Need to reset animation events
        const events = this._events;
        if (events.length) {
            for(let index = 0; index < events.length; index++)if (!events[index].onlyOnce) // reset events in the future
            events[index].isDone = events[index].frame < frame;
        }
        this._currentFrame = frame;
        const currentValue = this._animation._interpolate(frame, this._animationState);
        this.setValue(currentValue, -1);
    }
    /**
     * @internal Internal use only
     */ _prepareForSpeedRatioChange(newSpeedRatio) {
        const newAbsoluteFrame = this._previousElapsedTime * (this._animation.framePerSecond * newSpeedRatio) / 1000.0;
        this._absoluteFrameOffset = this._previousAbsoluteFrame - newAbsoluteFrame;
    }
    /**
     * Execute the current animation
     * @param elapsedTimeSinceAnimationStart defines the elapsed time (in milliseconds) since the animation was started
     * @param from defines the lower frame of the animation range
     * @param to defines the upper frame of the animation range
     * @param loop defines if the current animation must loop
     * @param speedRatio defines the current speed ratio
     * @param weight defines the weight of the animation (default is -1 so no weight)
     * @returns a boolean indicating if the animation is running
     */ animate(elapsedTimeSinceAnimationStart, from, to, loop, speedRatio, weight = -1) {
        const animation = this._animation;
        const targetPropertyPath = animation.targetPropertyPath;
        if (!targetPropertyPath || targetPropertyPath.length < 1) {
            this._stopped = true;
            return false;
        }
        let returnValue = true;
        // Check limits
        if (from < this._minFrame || from > this._maxFrame) from = this._minFrame;
        if (to < this._minFrame || to > this._maxFrame) to = this._maxFrame;
        const frameRange = to - from;
        let offsetValue;
        // Compute the frame according to the elapsed time and the fps of the animation ("from" and "to" are not factored in!)
        let absoluteFrame = elapsedTimeSinceAnimationStart * (animation.framePerSecond * speedRatio) / 1000.0 + this._absoluteFrameOffset;
        let highLimitValue = 0;
        // Apply the yoyo function if required
        if (loop && this._animationState.loopMode === (0, $lWogh.Animation).ANIMATIONLOOPMODE_YOYO) {
            const position = (absoluteFrame - from) / frameRange;
            // Apply the yoyo curve
            const yoyoPosition = Math.abs(Math.sin(position * Math.PI));
            // Map the yoyo position back to the range
            absoluteFrame = yoyoPosition * frameRange + from;
        }
        this._previousElapsedTime = elapsedTimeSinceAnimationStart;
        this._previousAbsoluteFrame = absoluteFrame;
        if (!loop && to >= from && (absoluteFrame >= frameRange && speedRatio > 0 || absoluteFrame <= 0 && speedRatio < 0)) {
            // If we are out of range and not looping get back to caller
            returnValue = false;
            highLimitValue = animation._getKeyValue(this._maxValue);
        } else if (!loop && from >= to && (absoluteFrame <= frameRange && speedRatio < 0 || absoluteFrame >= 0 && speedRatio > 0)) {
            returnValue = false;
            highLimitValue = animation._getKeyValue(this._minValue);
        } else if (this._animationState.loopMode !== (0, $lWogh.Animation).ANIMATIONLOOPMODE_CYCLE) {
            const keyOffset = to.toString() + from.toString();
            if (!this._offsetsCache[keyOffset]) {
                this._animationState.repeatCount = 0;
                this._animationState.loopMode = (0, $lWogh.Animation).ANIMATIONLOOPMODE_CYCLE; // force a specific codepath in animation._interpolate()!
                const fromValue = animation._interpolate(from, this._animationState);
                const toValue = animation._interpolate(to, this._animationState);
                this._animationState.loopMode = this._getCorrectLoopMode();
                switch(animation.dataType){
                    // Float
                    case (0, $lWogh.Animation).ANIMATIONTYPE_FLOAT:
                        this._offsetsCache[keyOffset] = toValue - fromValue;
                        break;
                    // Quaternion
                    case (0, $lWogh.Animation).ANIMATIONTYPE_QUATERNION:
                        this._offsetsCache[keyOffset] = toValue.subtract(fromValue);
                        break;
                    // Vector3
                    case (0, $lWogh.Animation).ANIMATIONTYPE_VECTOR3:
                        this._offsetsCache[keyOffset] = toValue.subtract(fromValue);
                        break;
                    // Vector2
                    case (0, $lWogh.Animation).ANIMATIONTYPE_VECTOR2:
                        this._offsetsCache[keyOffset] = toValue.subtract(fromValue);
                        break;
                    // Size
                    case (0, $lWogh.Animation).ANIMATIONTYPE_SIZE:
                        this._offsetsCache[keyOffset] = toValue.subtract(fromValue);
                        break;
                    // Color3
                    case (0, $lWogh.Animation).ANIMATIONTYPE_COLOR3:
                        this._offsetsCache[keyOffset] = toValue.subtract(fromValue);
                        break;
                    default:
                        break;
                }
                this._highLimitsCache[keyOffset] = toValue;
            }
            highLimitValue = this._highLimitsCache[keyOffset];
            offsetValue = this._offsetsCache[keyOffset];
        }
        if (offsetValue === undefined) switch(animation.dataType){
            // Float
            case (0, $lWogh.Animation).ANIMATIONTYPE_FLOAT:
                offsetValue = 0;
                break;
            // Quaternion
            case (0, $lWogh.Animation).ANIMATIONTYPE_QUATERNION:
                offsetValue = (0, $lWogh._staticOffsetValueQuaternion);
                break;
            // Vector3
            case (0, $lWogh.Animation).ANIMATIONTYPE_VECTOR3:
                offsetValue = (0, $lWogh._staticOffsetValueVector3);
                break;
            // Vector2
            case (0, $lWogh.Animation).ANIMATIONTYPE_VECTOR2:
                offsetValue = (0, $lWogh._staticOffsetValueVector2);
                break;
            // Size
            case (0, $lWogh.Animation).ANIMATIONTYPE_SIZE:
                offsetValue = (0, $lWogh._staticOffsetValueSize);
                break;
            // Color3
            case (0, $lWogh.Animation).ANIMATIONTYPE_COLOR3:
                offsetValue = (0, $lWogh._staticOffsetValueColor3);
                break;
            case (0, $lWogh.Animation).ANIMATIONTYPE_COLOR4:
                offsetValue = (0, $lWogh._staticOffsetValueColor4);
                break;
        }
        // Compute value
        let currentFrame;
        if (this._host && this._host.syncRoot) {
            // If we must sync with an animatable, calculate the current frame based on the frame of the root animatable
            const syncRoot = this._host.syncRoot;
            const hostNormalizedFrame = (syncRoot.masterFrame - syncRoot.fromFrame) / (syncRoot.toFrame - syncRoot.fromFrame);
            currentFrame = from + frameRange * hostNormalizedFrame;
        } else if (absoluteFrame > 0 && from > to || absoluteFrame < 0 && from < to) currentFrame = returnValue && frameRange !== 0 ? to + absoluteFrame % frameRange : from;
        else currentFrame = returnValue && frameRange !== 0 ? from + absoluteFrame % frameRange : to;
        const events = this._events;
        // Reset event/state if looping
        if (speedRatio > 0 && this.currentFrame > currentFrame || speedRatio < 0 && this.currentFrame < currentFrame) {
            this._onLoop();
            // Need to reset animation events
            for(let index = 0; index < events.length; index++)if (!events[index].onlyOnce) // reset event, the animation is looping
            events[index].isDone = false;
            this._animationState.key = speedRatio > 0 ? 0 : animation.getKeys().length - 1;
        }
        this._currentFrame = currentFrame;
        this._animationState.repeatCount = frameRange === 0 ? 0 : absoluteFrame / frameRange >> 0;
        this._animationState.highLimitValue = highLimitValue;
        this._animationState.offsetValue = offsetValue;
        const currentValue = animation._interpolate(currentFrame, this._animationState);
        // Set value
        this.setValue(currentValue, weight);
        // Check events
        if (events.length) {
            for(let index = 0; index < events.length; index++)// Make sure current frame has passed event frame and that event frame is within the current range
            // Also, handle both forward and reverse animations
            if (frameRange >= 0 && currentFrame >= events[index].frame && events[index].frame >= from || frameRange < 0 && currentFrame <= events[index].frame && events[index].frame <= from) {
                const event = events[index];
                if (!event.isDone) {
                    // If event should be done only once, remove it.
                    if (event.onlyOnce) {
                        events.splice(index, 1);
                        index--;
                    }
                    event.isDone = true;
                    event.action(currentFrame);
                } // Don't do anything if the event has already been done.
            }
        }
        if (!returnValue) this._stopped = true;
        return returnValue;
    }
}

});

parcelRegister("gmbCk", function(module, exports) {

$parcel$export(module.exports, "ScenePerformancePriority", () => $be87b65ec8caf46b$export$fc68a5778ead24b1);
$parcel$export(module.exports, "Scene", () => $be87b65ec8caf46b$export$38af1803e3442a7f);

var $bOhSV = parcelRequire("bOhSV");

var $blHSI = parcelRequire("blHSI");

var $diGQf = parcelRequire("diGQf");

var $57onU = parcelRequire("57onU");

var $895IS = parcelRequire("895IS");

var $7212E = parcelRequire("7212E");

var $ha1VO = parcelRequire("ha1VO");

var $5Tqba = parcelRequire("5Tqba");

var $dG1pf = parcelRequire("dG1pf");

var $ghoTi = parcelRequire("ghoTi");

var $gzCma = parcelRequire("gzCma");

var $cmj0B = parcelRequire("cmj0B");

var $8MhbJ = parcelRequire("8MhbJ");

var $jJNg8 = parcelRequire("jJNg8");

var $bv05l = parcelRequire("bv05l");

var $jFz47 = parcelRequire("jFz47");

var $ejQPp = parcelRequire("ejQPp");

var $dUFYy = parcelRequire("dUFYy");

var $7md5A = parcelRequire("7md5A");

var $2Fclq = parcelRequire("2Fclq");

var $7etnY = parcelRequire("7etnY");

var $9sPMJ = parcelRequire("9sPMJ");

var $3u0QC = parcelRequire("3u0QC");

var $EOxw7 = parcelRequire("EOxw7");

var $1gEbu = parcelRequire("1gEbu");

var $opFp4 = parcelRequire("opFp4");

var $lDzLx = parcelRequire("lDzLx");

var $kVtWi = parcelRequire("kVtWi");
var $be87b65ec8caf46b$export$fc68a5778ead24b1;
(function(ScenePerformancePriority) {
    /** Default mode. No change. Performance will be treated as less important than backward compatibility */ ScenePerformancePriority[ScenePerformancePriority["BackwardCompatible"] = 0] = "BackwardCompatible";
    /** Some performance options will be turned on trying to strike a balance between perf and ease of use */ ScenePerformancePriority[ScenePerformancePriority["Intermediate"] = 1] = "Intermediate";
    /** Performance will be top priority */ ScenePerformancePriority[ScenePerformancePriority["Aggressive"] = 2] = "Aggressive";
})($be87b65ec8caf46b$export$fc68a5778ead24b1 || ($be87b65ec8caf46b$export$fc68a5778ead24b1 = {}));
class $be87b65ec8caf46b$export$38af1803e3442a7f extends (0, $5Tqba.AbstractScene) {
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Factory used to create the default material.
     * @param scene The scene to create the material for
     * @returns The default material
     */ static DefaultMaterialFactory(scene) {
        throw (0, $dUFYy._WarnImport)("StandardMaterial");
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Factory used to create the a collision coordinator.
     * @returns The collision coordinator
     */ static CollisionCoordinatorFactory() {
        throw (0, $dUFYy._WarnImport)("DefaultCollisionCoordinator");
    }
    /**
     * Texture used in all pbr material as the reflection texture.
     * As in the majority of the scene they are the same (exception for multi room and so on),
     * this is easier to reference from here than from all the materials.
     */ get environmentTexture() {
        return this._environmentTexture;
    }
    /**
     * Texture used in all pbr material as the reflection texture.
     * As in the majority of the scene they are the same (exception for multi room and so on),
     * this is easier to set here than in all the materials.
     */ set environmentTexture(value) {
        if (this._environmentTexture === value) return;
        this._environmentTexture = value;
        this.markAllMaterialsAsDirty(1);
    }
    /**
     * Default image processing configuration used either in the rendering
     * Forward main pass or through the imageProcessingPostProcess if present.
     * As in the majority of the scene they are the same (exception for multi camera),
     * this is easier to reference from here than from all the materials and post process.
     *
     * No setter as we it is a shared configuration, you can set the values instead.
     */ get imageProcessingConfiguration() {
        return this._imageProcessingConfiguration;
    }
    /**
     * Gets or sets a value indicating how to treat performance relatively to ease of use and backward compatibility
     */ get performancePriority() {
        return this._performancePriority;
    }
    set performancePriority(value) {
        if (value === this._performancePriority) return;
        this._performancePriority = value;
        switch(value){
            case $be87b65ec8caf46b$export$fc68a5778ead24b1.BackwardCompatible:
                this.skipFrustumClipping = false;
                this._renderingManager.maintainStateBetweenFrames = false;
                this.skipPointerMovePicking = false;
                this.autoClear = true;
                break;
            case $be87b65ec8caf46b$export$fc68a5778ead24b1.Intermediate:
                this.skipFrustumClipping = false;
                this._renderingManager.maintainStateBetweenFrames = false;
                this.skipPointerMovePicking = true;
                this.autoClear = false;
                break;
            case $be87b65ec8caf46b$export$fc68a5778ead24b1.Aggressive:
                this.skipFrustumClipping = true;
                this._renderingManager.maintainStateBetweenFrames = true;
                this.skipPointerMovePicking = true;
                this.autoClear = false;
                break;
        }
        this.onScenePerformancePriorityChangedObservable.notifyObservers(value);
    }
    /**
     * Gets or sets a boolean indicating if all rendering must be done in wireframe
     */ set forceWireframe(value) {
        if (this._forceWireframe === value) return;
        this._forceWireframe = value;
        this.markAllMaterialsAsDirty(16);
    }
    get forceWireframe() {
        return this._forceWireframe;
    }
    /**
     * Gets or sets a boolean indicating if we should skip the frustum clipping part of the active meshes selection
     */ set skipFrustumClipping(value) {
        if (this._skipFrustumClipping === value) return;
        this._skipFrustumClipping = value;
    }
    get skipFrustumClipping() {
        return this._skipFrustumClipping;
    }
    /**
     * Gets or sets a boolean indicating if all rendering must be done in point cloud
     */ set forcePointsCloud(value) {
        if (this._forcePointsCloud === value) return;
        this._forcePointsCloud = value;
        this.markAllMaterialsAsDirty(16);
    }
    get forcePointsCloud() {
        return this._forcePointsCloud;
    }
    /**
     * Gets or sets the animation properties override
     */ get animationPropertiesOverride() {
        return this._animationPropertiesOverride;
    }
    set animationPropertiesOverride(value) {
        this._animationPropertiesOverride = value;
    }
    /** Sets a function to be executed when this scene is disposed. */ set onDispose(callback) {
        if (this._onDisposeObserver) this.onDisposeObservable.remove(this._onDisposeObserver);
        this._onDisposeObserver = this.onDisposeObservable.add(callback);
    }
    /** Sets a function to be executed before rendering this scene */ set beforeRender(callback) {
        if (this._onBeforeRenderObserver) this.onBeforeRenderObservable.remove(this._onBeforeRenderObserver);
        if (callback) this._onBeforeRenderObserver = this.onBeforeRenderObservable.add(callback);
    }
    /** Sets a function to be executed after rendering this scene */ set afterRender(callback) {
        if (this._onAfterRenderObserver) this.onAfterRenderObservable.remove(this._onAfterRenderObserver);
        if (callback) this._onAfterRenderObserver = this.onAfterRenderObservable.add(callback);
    }
    /** Sets a function to be executed before rendering a camera*/ set beforeCameraRender(callback) {
        if (this._onBeforeCameraRenderObserver) this.onBeforeCameraRenderObservable.remove(this._onBeforeCameraRenderObserver);
        this._onBeforeCameraRenderObserver = this.onBeforeCameraRenderObservable.add(callback);
    }
    /** Sets a function to be executed after rendering a camera*/ set afterCameraRender(callback) {
        if (this._onAfterCameraRenderObserver) this.onAfterCameraRenderObservable.remove(this._onAfterCameraRenderObserver);
        this._onAfterCameraRenderObserver = this.onAfterCameraRenderObservable.add(callback);
    }
    /**
     * Gets or sets a predicate used to select candidate meshes for a pointer down event
     */ get pointerDownPredicate() {
        return this._pointerPickingConfiguration.pointerDownPredicate;
    }
    set pointerDownPredicate(value) {
        this._pointerPickingConfiguration.pointerDownPredicate = value;
    }
    /**
     * Gets or sets a predicate used to select candidate meshes for a pointer up event
     */ get pointerUpPredicate() {
        return this._pointerPickingConfiguration.pointerUpPredicate;
    }
    set pointerUpPredicate(value) {
        this._pointerPickingConfiguration.pointerUpPredicate = value;
    }
    /**
     * Gets or sets a predicate used to select candidate meshes for a pointer move event
     */ get pointerMovePredicate() {
        return this._pointerPickingConfiguration.pointerMovePredicate;
    }
    set pointerMovePredicate(value) {
        this._pointerPickingConfiguration.pointerMovePredicate = value;
    }
    /**
     * Gets or sets a predicate used to select candidate meshes for a pointer down event
     */ get pointerDownFastCheck() {
        return this._pointerPickingConfiguration.pointerDownFastCheck;
    }
    set pointerDownFastCheck(value) {
        this._pointerPickingConfiguration.pointerDownFastCheck = value;
    }
    /**
     * Gets or sets a predicate used to select candidate meshes for a pointer up event
     */ get pointerUpFastCheck() {
        return this._pointerPickingConfiguration.pointerUpFastCheck;
    }
    set pointerUpFastCheck(value) {
        this._pointerPickingConfiguration.pointerUpFastCheck = value;
    }
    /**
     * Gets or sets a predicate used to select candidate meshes for a pointer move event
     */ get pointerMoveFastCheck() {
        return this._pointerPickingConfiguration.pointerMoveFastCheck;
    }
    set pointerMoveFastCheck(value) {
        this._pointerPickingConfiguration.pointerMoveFastCheck = value;
    }
    /**
     * Gets or sets a boolean indicating if the user want to entirely skip the picking phase when a pointer move event occurs.
     */ get skipPointerMovePicking() {
        return this._pointerPickingConfiguration.skipPointerMovePicking;
    }
    set skipPointerMovePicking(value) {
        this._pointerPickingConfiguration.skipPointerMovePicking = value;
    }
    /**
     * Gets or sets a boolean indicating if the user want to entirely skip the picking phase when a pointer down event occurs.
     */ get skipPointerDownPicking() {
        return this._pointerPickingConfiguration.skipPointerDownPicking;
    }
    set skipPointerDownPicking(value) {
        this._pointerPickingConfiguration.skipPointerDownPicking = value;
    }
    /**
     * Gets or sets a boolean indicating if the user want to entirely skip the picking phase when a pointer up event occurs.  Off by default.
     */ get skipPointerUpPicking() {
        return this._pointerPickingConfiguration.skipPointerUpPicking;
    }
    set skipPointerUpPicking(value) {
        this._pointerPickingConfiguration.skipPointerUpPicking = value;
    }
    /**
     * Gets the pointer coordinates without any translation (ie. straight out of the pointer event)
     */ get unTranslatedPointer() {
        return this._inputManager.unTranslatedPointer;
    }
    /**
     * Gets or sets the distance in pixel that you have to move to prevent some events. Default is 10 pixels
     */ static get DragMovementThreshold() {
        return (0, $7md5A.InputManager).DragMovementThreshold;
    }
    static set DragMovementThreshold(value) {
        (0, $7md5A.InputManager).DragMovementThreshold = value;
    }
    /**
     * Time in milliseconds to wait to raise long press events if button is still pressed. Default is 500 ms
     */ static get LongPressDelay() {
        return (0, $7md5A.InputManager).LongPressDelay;
    }
    static set LongPressDelay(value) {
        (0, $7md5A.InputManager).LongPressDelay = value;
    }
    /**
     * Time in milliseconds to wait to raise long press events if button is still pressed. Default is 300 ms
     */ static get DoubleClickDelay() {
        return (0, $7md5A.InputManager).DoubleClickDelay;
    }
    static set DoubleClickDelay(value) {
        (0, $7md5A.InputManager).DoubleClickDelay = value;
    }
    /** If you need to check double click without raising a single click at first click, enable this flag */ static get ExclusiveDoubleClickMode() {
        return (0, $7md5A.InputManager).ExclusiveDoubleClickMode;
    }
    static set ExclusiveDoubleClickMode(value) {
        (0, $7md5A.InputManager).ExclusiveDoubleClickMode = value;
    }
    /**
     * Bind the current view position to an effect.
     * @param effect The effect to be bound
     * @param variableName name of the shader variable that will hold the eye position
     * @param isVector3 true to indicates that variableName is a Vector3 and not a Vector4
     * @returns the computed eye position
     */ bindEyePosition(effect, variableName = "vEyePosition", isVector3 = false) {
        const eyePosition = this._forcedViewPosition ? this._forcedViewPosition : this._mirroredCameraPosition ? this._mirroredCameraPosition : this.activeCamera.globalPosition;
        const invertNormal = this.useRightHandedSystem === (this._mirroredCameraPosition != null);
        (0, $ha1VO.TmpVectors).Vector4[0].set(eyePosition.x, eyePosition.y, eyePosition.z, invertNormal ? -1 : 1);
        if (effect) {
            if (isVector3) effect.setFloat3(variableName, (0, $ha1VO.TmpVectors).Vector4[0].x, (0, $ha1VO.TmpVectors).Vector4[0].y, (0, $ha1VO.TmpVectors).Vector4[0].z);
            else effect.setVector4(variableName, (0, $ha1VO.TmpVectors).Vector4[0]);
        }
        return (0, $ha1VO.TmpVectors).Vector4[0];
    }
    /**
     * Update the scene ubo before it can be used in rendering processing
     * @returns the scene UniformBuffer
     */ finalizeSceneUbo() {
        const ubo = this.getSceneUniformBuffer();
        const eyePosition = this.bindEyePosition(null);
        ubo.updateFloat4("vEyePosition", eyePosition.x, eyePosition.y, eyePosition.z, eyePosition.w);
        ubo.update();
        return ubo;
    }
    /**
     * Gets or sets a boolean indicating if the scene must use right-handed coordinates system
     */ set useRightHandedSystem(value) {
        if (this._useRightHandedSystem === value) return;
        this._useRightHandedSystem = value;
        this.markAllMaterialsAsDirty(16);
    }
    get useRightHandedSystem() {
        return this._useRightHandedSystem;
    }
    /**
     * Sets the step Id used by deterministic lock step
     * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#deterministic-lockstep
     * @param newStepId defines the step Id
     */ setStepId(newStepId) {
        this._currentStepId = newStepId;
    }
    /**
     * Gets the step Id used by deterministic lock step
     * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#deterministic-lockstep
     * @returns the step Id
     */ getStepId() {
        return this._currentStepId;
    }
    /**
     * Gets the internal step used by deterministic lock step
     * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#deterministic-lockstep
     * @returns the internal step
     */ getInternalStep() {
        return this._currentInternalStep;
    }
    /**
     * Gets or sets a boolean indicating if fog is enabled on this scene
     * @see https://doc.babylonjs.com/features/featuresDeepDive/environment/environment_introduction#fog
     * (Default is true)
     */ set fogEnabled(value) {
        if (this._fogEnabled === value) return;
        this._fogEnabled = value;
        this.markAllMaterialsAsDirty(16);
    }
    get fogEnabled() {
        return this._fogEnabled;
    }
    /**
     * Gets or sets the fog mode to use
     * @see https://doc.babylonjs.com/features/featuresDeepDive/environment/environment_introduction#fog
     * | mode | value |
     * | --- | --- |
     * | FOGMODE_NONE | 0 |
     * | FOGMODE_EXP | 1 |
     * | FOGMODE_EXP2 | 2 |
     * | FOGMODE_LINEAR | 3 |
     */ set fogMode(value) {
        if (this._fogMode === value) return;
        this._fogMode = value;
        this.markAllMaterialsAsDirty(16);
    }
    get fogMode() {
        return this._fogMode;
    }
    /**
     * Flag indicating that the frame buffer binding is handled by another component
     */ get prePass() {
        return !!this.prePassRenderer && this.prePassRenderer.defaultRT.enabled;
    }
    /**
     * Gets or sets a boolean indicating if shadows are enabled on this scene
     */ set shadowsEnabled(value) {
        if (this._shadowsEnabled === value) return;
        this._shadowsEnabled = value;
        this.markAllMaterialsAsDirty(2);
    }
    get shadowsEnabled() {
        return this._shadowsEnabled;
    }
    /**
     * Gets or sets a boolean indicating if lights are enabled on this scene
     */ set lightsEnabled(value) {
        if (this._lightsEnabled === value) return;
        this._lightsEnabled = value;
        this.markAllMaterialsAsDirty(2);
    }
    get lightsEnabled() {
        return this._lightsEnabled;
    }
    /** All of the active cameras added to this scene. */ get activeCameras() {
        return this._activeCameras;
    }
    set activeCameras(cameras) {
        if (this._unObserveActiveCameras) {
            this._unObserveActiveCameras();
            this._unObserveActiveCameras = null;
        }
        if (cameras) this._unObserveActiveCameras = (0, $opFp4._ObserveArray)(cameras, ()=>{
            this.onActiveCamerasChanged.notifyObservers(this);
        });
        this._activeCameras = cameras;
    }
    /** Gets or sets the current active camera */ get activeCamera() {
        return this._activeCamera;
    }
    set activeCamera(value) {
        if (value === this._activeCamera) return;
        this._activeCamera = value;
        this.onActiveCameraChanged.notifyObservers(this);
    }
    /** The default material used on meshes when no material is affected */ get defaultMaterial() {
        if (!this._defaultMaterial) this._defaultMaterial = $be87b65ec8caf46b$export$38af1803e3442a7f.DefaultMaterialFactory(this);
        return this._defaultMaterial;
    }
    /** The default material used on meshes when no material is affected */ set defaultMaterial(value) {
        this._defaultMaterial = value;
    }
    /**
     * Gets or sets a boolean indicating if textures are enabled on this scene
     */ set texturesEnabled(value) {
        if (this._texturesEnabled === value) return;
        this._texturesEnabled = value;
        this.markAllMaterialsAsDirty(1);
    }
    get texturesEnabled() {
        return this._texturesEnabled;
    }
    /**
     * Gets or sets a boolean indicating if skeletons are enabled on this scene
     */ set skeletonsEnabled(value) {
        if (this._skeletonsEnabled === value) return;
        this._skeletonsEnabled = value;
        this.markAllMaterialsAsDirty(8);
    }
    get skeletonsEnabled() {
        return this._skeletonsEnabled;
    }
    /** @internal */ get collisionCoordinator() {
        if (!this._collisionCoordinator) {
            this._collisionCoordinator = $be87b65ec8caf46b$export$38af1803e3442a7f.CollisionCoordinatorFactory();
            this._collisionCoordinator.init(this);
        }
        return this._collisionCoordinator;
    }
    /**
     * Gets the scene's rendering manager
     */ get renderingManager() {
        return this._renderingManager;
    }
    /**
     * Gets the list of frustum planes (built from the active camera)
     */ get frustumPlanes() {
        return this._frustumPlanes;
    }
    /**
     * Registers the transient components if needed.
     */ _registerTransientComponents() {
        // Register components that have been associated lately to the scene.
        if (this._transientComponents.length > 0) {
            for (const component of this._transientComponents)component.register();
            this._transientComponents.length = 0;
        }
    }
    /**
     * @internal
     * Add a component to the scene.
     * Note that the ccomponent could be registered on th next frame if this is called after
     * the register component stage.
     * @param component Defines the component to add to the scene
     */ _addComponent(component) {
        this._components.push(component);
        this._transientComponents.push(component);
        const serializableComponent = component;
        if (serializableComponent.addFromContainer && serializableComponent.serialize) this._serializableComponents.push(serializableComponent);
    }
    /**
     * @internal
     * Gets a component from the scene.
     * @param name defines the name of the component to retrieve
     * @returns the component or null if not present
     */ _getComponent(name) {
        for (const component of this._components){
            if (component.name === name) return component;
        }
        return null;
    }
    /**
     * Creates a new Scene
     * @param engine defines the engine to use to render this scene
     * @param options defines the scene options
     */ constructor(engine, options){
        super();
        // Members
        /** @internal */ this._inputManager = new (0, $7md5A.InputManager)(this);
        /** Define this parameter if you are using multiple cameras and you want to specify which one should be used for pointer position */ this.cameraToUseForPointers = null;
        /** @internal */ this._isScene = true;
        /** @internal */ this._blockEntityCollection = false;
        /**
         * Gets or sets a boolean that indicates if the scene must clear the render buffer before rendering a frame
         */ this.autoClear = true;
        /**
         * Gets or sets a boolean that indicates if the scene must clear the depth and stencil buffers before rendering a frame
         */ this.autoClearDepthAndStencil = true;
        /**
         * Defines the color used to clear the render buffer (Default is (0.2, 0.2, 0.3, 1.0))
         */ this.clearColor = new (0, $7etnY.Color4)(0.2, 0.2, 0.3, 1.0);
        /**
         * Defines the color used to simulate the ambient color (Default is (0, 0, 0))
         */ this.ambientColor = new (0, $7etnY.Color3)(0, 0, 0);
        /**
         * Intensity of the environment in all pbr material.
         * This dims or reinforces the IBL lighting overall (reflection and diffuse).
         * As in the majority of the scene they are the same (exception for multi room and so on),
         * this is easier to reference from here than from all the materials.
         */ this.environmentIntensity = 1;
        this._performancePriority = $be87b65ec8caf46b$export$fc68a5778ead24b1.BackwardCompatible;
        /**
         * Observable triggered when the performance priority is changed
         */ this.onScenePerformancePriorityChangedObservable = new (0, $diGQf.Observable)();
        this._forceWireframe = false;
        this._skipFrustumClipping = false;
        this._forcePointsCloud = false;
        /**
         * Gets or sets a boolean indicating if animations are enabled
         */ this.animationsEnabled = true;
        this._animationPropertiesOverride = null;
        /**
         * Gets or sets a boolean indicating if a constant deltatime has to be used
         * This is mostly useful for testing purposes when you do not want the animations to scale with the framerate
         */ this.useConstantAnimationDeltaTime = false;
        /**
         * Gets or sets a boolean indicating if the scene must keep the meshUnderPointer property updated
         * Please note that it requires to run a ray cast through the scene on every frame
         */ this.constantlyUpdateMeshUnderPointer = false;
        /**
         * Defines the HTML cursor to use when hovering over interactive elements
         */ this.hoverCursor = "pointer";
        /**
         * Defines the HTML default cursor to use (empty by default)
         */ this.defaultCursor = "";
        /**
         * Defines whether cursors are handled by the scene.
         */ this.doNotHandleCursors = false;
        /**
         * This is used to call preventDefault() on pointer down
         * in order to block unwanted artifacts like system double clicks
         */ this.preventDefaultOnPointerDown = true;
        /**
         * This is used to call preventDefault() on pointer up
         * in order to block unwanted artifacts like system double clicks
         */ this.preventDefaultOnPointerUp = true;
        // Metadata
        /**
         * Gets or sets user defined metadata
         */ this.metadata = null;
        /**
         * For internal use only. Please do not use.
         */ this.reservedDataStore = null;
        /**
         * Use this array to add regular expressions used to disable offline support for specific urls
         */ this.disableOfflineSupportExceptionRules = [];
        /**
         * An event triggered when the scene is disposed.
         */ this.onDisposeObservable = new (0, $diGQf.Observable)();
        this._onDisposeObserver = null;
        /**
         * An event triggered before rendering the scene (right after animations and physics)
         */ this.onBeforeRenderObservable = new (0, $diGQf.Observable)();
        this._onBeforeRenderObserver = null;
        /**
         * An event triggered after rendering the scene
         */ this.onAfterRenderObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered after rendering the scene for an active camera (When scene.render is called this will be called after each camera)
         * This is triggered for each "sub" camera in a Camera Rig unlike onAfterCameraRenderObservable
         */ this.onAfterRenderCameraObservable = new (0, $diGQf.Observable)();
        this._onAfterRenderObserver = null;
        /**
         * An event triggered before animating the scene
         */ this.onBeforeAnimationsObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered after animations processing
         */ this.onAfterAnimationsObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered before draw calls are ready to be sent
         */ this.onBeforeDrawPhaseObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered after draw calls have been sent
         */ this.onAfterDrawPhaseObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the scene is ready
         */ this.onReadyObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered before rendering a camera
         */ this.onBeforeCameraRenderObservable = new (0, $diGQf.Observable)();
        this._onBeforeCameraRenderObserver = null;
        /**
         * An event triggered after rendering a camera
         * This is triggered for the full rig Camera only unlike onAfterRenderCameraObservable
         */ this.onAfterCameraRenderObservable = new (0, $diGQf.Observable)();
        this._onAfterCameraRenderObserver = null;
        /**
         * An event triggered when active meshes evaluation is about to start
         */ this.onBeforeActiveMeshesEvaluationObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when active meshes evaluation is done
         */ this.onAfterActiveMeshesEvaluationObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when particles rendering is about to start
         * Note: This event can be trigger more than once per frame (because particles can be rendered by render target textures as well)
         */ this.onBeforeParticlesRenderingObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when particles rendering is done
         * Note: This event can be trigger more than once per frame (because particles can be rendered by render target textures as well)
         */ this.onAfterParticlesRenderingObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when SceneLoader.Append or SceneLoader.Load or SceneLoader.ImportMesh were successfully executed
         */ this.onDataLoadedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a camera is created
         */ this.onNewCameraAddedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a camera is removed
         */ this.onCameraRemovedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a light is created
         */ this.onNewLightAddedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a light is removed
         */ this.onLightRemovedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a geometry is created
         */ this.onNewGeometryAddedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a geometry is removed
         */ this.onGeometryRemovedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a transform node is created
         */ this.onNewTransformNodeAddedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a transform node is removed
         */ this.onTransformNodeRemovedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a mesh is created
         */ this.onNewMeshAddedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a mesh is removed
         */ this.onMeshRemovedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a skeleton is created
         */ this.onNewSkeletonAddedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a skeleton is removed
         */ this.onSkeletonRemovedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a material is created
         */ this.onNewMaterialAddedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a multi material is created
         */ this.onNewMultiMaterialAddedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a material is removed
         */ this.onMaterialRemovedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a multi material is removed
         */ this.onMultiMaterialRemovedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a texture is created
         */ this.onNewTextureAddedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a texture is removed
         */ this.onTextureRemovedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when render targets are about to be rendered
         * Can happen multiple times per frame.
         */ this.onBeforeRenderTargetsRenderObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when render targets were rendered.
         * Can happen multiple times per frame.
         */ this.onAfterRenderTargetsRenderObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered before calculating deterministic simulation step
         */ this.onBeforeStepObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered after calculating deterministic simulation step
         */ this.onAfterStepObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the activeCamera property is updated
         */ this.onActiveCameraChanged = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the activeCameras property is updated
         */ this.onActiveCamerasChanged = new (0, $diGQf.Observable)();
        /**
         * This Observable will be triggered before rendering each renderingGroup of each rendered camera.
         * The RenderingGroupInfo class contains all the information about the context in which the observable is called
         * If you wish to register an Observer only for a given set of renderingGroup, use the mask with a combination of the renderingGroup index elevated to the power of two (1 for renderingGroup 0, 2 for renderingrOup1, 4 for 2 and 8 for 3)
         */ this.onBeforeRenderingGroupObservable = new (0, $diGQf.Observable)();
        /**
         * This Observable will be triggered after rendering each renderingGroup of each rendered camera.
         * The RenderingGroupInfo class contains all the information about the context in which the observable is called
         * If you wish to register an Observer only for a given set of renderingGroup, use the mask with a combination of the renderingGroup index elevated to the power of two (1 for renderingGroup 0, 2 for renderingrOup1, 4 for 2 and 8 for 3)
         */ this.onAfterRenderingGroupObservable = new (0, $diGQf.Observable)();
        /**
         * This Observable will when a mesh has been imported into the scene.
         */ this.onMeshImportedObservable = new (0, $diGQf.Observable)();
        /**
         * This Observable will when an animation file has been imported into the scene.
         */ this.onAnimationFileImportedObservable = new (0, $diGQf.Observable)();
        // Animations
        /** @internal */ this._registeredForLateAnimationBindings = new (0, $57onU.SmartArrayNoDuplicate)(256);
        // Pointers
        this._pointerPickingConfiguration = new (0, $lDzLx.PointerPickingConfiguration)();
        /**
         * This observable event is triggered when any ponter event is triggered. It is registered during Scene.attachControl() and it is called BEFORE the 3D engine process anything (mesh/sprite picking for instance).
         * You have the possibility to skip the process and the call to onPointerObservable by setting PointerInfoPre.skipOnPointerObservable to true
         */ this.onPrePointerObservable = new (0, $diGQf.Observable)();
        /**
         * Observable event triggered each time an input event is received from the rendering canvas
         */ this.onPointerObservable = new (0, $diGQf.Observable)();
        // Keyboard
        /**
         * This observable event is triggered when any keyboard event si raised and registered during Scene.attachControl()
         * You have the possibility to skip the process and the call to onKeyboardObservable by setting KeyboardInfoPre.skipOnPointerObservable to true
         */ this.onPreKeyboardObservable = new (0, $diGQf.Observable)();
        /**
         * Observable event triggered each time an keyboard event is received from the hosting window
         */ this.onKeyboardObservable = new (0, $diGQf.Observable)();
        // Coordinates system
        this._useRightHandedSystem = false;
        // Deterministic lockstep
        this._timeAccumulator = 0;
        this._currentStepId = 0;
        this._currentInternalStep = 0;
        // Fog
        this._fogEnabled = true;
        this._fogMode = $be87b65ec8caf46b$export$38af1803e3442a7f.FOGMODE_NONE;
        /**
         * Gets or sets the fog color to use
         * @see https://doc.babylonjs.com/features/featuresDeepDive/environment/environment_introduction#fog
         * (Default is Color3(0.2, 0.2, 0.3))
         */ this.fogColor = new (0, $7etnY.Color3)(0.2, 0.2, 0.3);
        /**
         * Gets or sets the fog density to use
         * @see https://doc.babylonjs.com/features/featuresDeepDive/environment/environment_introduction#fog
         * (Default is 0.1)
         */ this.fogDensity = 0.1;
        /**
         * Gets or sets the fog start distance to use
         * @see https://doc.babylonjs.com/features/featuresDeepDive/environment/environment_introduction#fog
         * (Default is 0)
         */ this.fogStart = 0;
        /**
         * Gets or sets the fog end distance to use
         * @see https://doc.babylonjs.com/features/featuresDeepDive/environment/environment_introduction#fog
         * (Default is 1000)
         */ this.fogEnd = 1000.0;
        /**
         * Flag indicating if we need to store previous matrices when rendering
         */ this.needsPreviousWorldMatrices = false;
        // Lights
        this._shadowsEnabled = true;
        this._lightsEnabled = true;
        this._unObserveActiveCameras = null;
        // Textures
        this._texturesEnabled = true;
        // Physics
        /**
         * Gets or sets a boolean indicating if physic engines are enabled on this scene
         */ this.physicsEnabled = true;
        // Particles
        /**
         * Gets or sets a boolean indicating if particles are enabled on this scene
         */ this.particlesEnabled = true;
        // Sprites
        /**
         * Gets or sets a boolean indicating if sprites are enabled on this scene
         */ this.spritesEnabled = true;
        // Skeletons
        this._skeletonsEnabled = true;
        // Lens flares
        /**
         * Gets or sets a boolean indicating if lens flares are enabled on this scene
         */ this.lensFlaresEnabled = true;
        // Collisions
        /**
         * Gets or sets a boolean indicating if collisions are enabled on this scene
         * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_collisions
         */ this.collisionsEnabled = true;
        /**
         * Defines the gravity applied to this scene (used only for collisions)
         * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_collisions
         */ this.gravity = new (0, $ha1VO.Vector3)(0, -9.807, 0);
        // Postprocesses
        /**
         * Gets or sets a boolean indicating if postprocesses are enabled on this scene
         */ this.postProcessesEnabled = true;
        // Customs render targets
        /**
         * Gets or sets a boolean indicating if render targets are enabled on this scene
         */ this.renderTargetsEnabled = true;
        /**
         * Gets or sets a boolean indicating if next render targets must be dumped as image for debugging purposes
         * We recommend not using it and instead rely on Spector.js: http://spector.babylonjs.com
         */ this.dumpNextRenderTargets = false;
        /**
         * The list of user defined render targets added to the scene
         */ this.customRenderTargets = [];
        /**
         * Gets the list of meshes imported to the scene through SceneLoader
         */ this.importedMeshesFiles = [];
        // Probes
        /**
         * Gets or sets a boolean indicating if probes are enabled on this scene
         */ this.probesEnabled = true;
        this._meshesForIntersections = new (0, $57onU.SmartArrayNoDuplicate)(256);
        // Procedural textures
        /**
         * Gets or sets a boolean indicating if procedural textures are enabled on this scene
         */ this.proceduralTexturesEnabled = true;
        // Performance counters
        this._totalVertices = new (0, $2Fclq.PerfCounter)();
        /** @internal */ this._activeIndices = new (0, $2Fclq.PerfCounter)();
        /** @internal */ this._activeParticles = new (0, $2Fclq.PerfCounter)();
        /** @internal */ this._activeBones = new (0, $2Fclq.PerfCounter)();
        /** @internal */ this._animationTime = 0;
        /**
         * Gets or sets a general scale for animation speed
         * @see https://www.babylonjs-playground.com/#IBU2W7#3
         */ this.animationTimeScale = 1;
        this._renderId = 0;
        this._frameId = 0;
        this._executeWhenReadyTimeoutId = null;
        this._intermediateRendering = false;
        this._defaultFrameBufferCleared = false;
        this._viewUpdateFlag = -1;
        this._projectionUpdateFlag = -1;
        /** @internal */ this._toBeDisposed = new Array(256);
        this._activeRequests = new Array();
        /** @internal */ this._pendingData = new Array();
        this._isDisposed = false;
        /**
         * Gets or sets a boolean indicating that all submeshes of active meshes must be rendered
         * Use this boolean to avoid computing frustum clipping on submeshes (This could help when you are CPU bound)
         */ this.dispatchAllSubMeshesOfActiveMeshes = false;
        this._activeMeshes = new (0, $57onU.SmartArray)(256);
        this._processedMaterials = new (0, $57onU.SmartArray)(256);
        this._renderTargets = new (0, $57onU.SmartArrayNoDuplicate)(256);
        this._materialsRenderTargets = new (0, $57onU.SmartArrayNoDuplicate)(256);
        /** @internal */ this._activeParticleSystems = new (0, $57onU.SmartArray)(256);
        this._activeSkeletons = new (0, $57onU.SmartArrayNoDuplicate)(32);
        this._softwareSkinnedMeshes = new (0, $57onU.SmartArrayNoDuplicate)(32);
        /** @internal */ this._activeAnimatables = new Array();
        this._transformMatrix = (0, $ha1VO.Matrix).Zero();
        /**
         * Gets or sets a boolean indicating if lights must be sorted by priority (off by default)
         * This is useful if there are more lights that the maximum simulteanous authorized
         */ this.requireLightSorting = false;
        /**
         * @internal
         * Backing store of defined scene components.
         */ this._components = [];
        /**
         * @internal
         * Backing store of defined scene components.
         */ this._serializableComponents = [];
        /**
         * List of components to register on the next registration step.
         */ this._transientComponents = [];
        /**
         * @internal
         * Defines the actions happening before camera updates.
         */ this._beforeCameraUpdateStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening before clear the canvas.
         */ this._beforeClearStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening before clear the canvas.
         */ this._beforeRenderTargetClearStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions when collecting render targets for the frame.
         */ this._gatherRenderTargetsStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening for one camera in the frame.
         */ this._gatherActiveCameraRenderTargetsStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening during the per mesh ready checks.
         */ this._isReadyForMeshStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening before evaluate active mesh checks.
         */ this._beforeEvaluateActiveMeshStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening during the evaluate sub mesh checks.
         */ this._evaluateSubMeshStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening during the active mesh stage.
         */ this._preActiveMeshStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening during the per camera render target step.
         */ this._cameraDrawRenderTargetStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening just before the active camera is drawing.
         */ this._beforeCameraDrawStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening just before a render target is drawing.
         */ this._beforeRenderTargetDrawStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening just before a rendering group is drawing.
         */ this._beforeRenderingGroupDrawStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening just before a mesh is drawing.
         */ this._beforeRenderingMeshStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening just after a mesh has been drawn.
         */ this._afterRenderingMeshStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening just after a rendering group has been drawn.
         */ this._afterRenderingGroupDrawStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening just after the active camera has been drawn.
         */ this._afterCameraDrawStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening just after the post processing
         */ this._afterCameraPostProcessStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening just after a render target has been drawn.
         */ this._afterRenderTargetDrawStage = (0, $bv05l.Stage).Create();
        /**
         * Defines the actions happening just after the post processing on a render target
         */ this._afterRenderTargetPostProcessStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening just after rendering all cameras and computing intersections.
         */ this._afterRenderStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening when a pointer move event happens.
         */ this._pointerMoveStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening when a pointer down event happens.
         */ this._pointerDownStage = (0, $bv05l.Stage).Create();
        /**
         * @internal
         * Defines the actions happening when a pointer up event happens.
         */ this._pointerUpStage = (0, $bv05l.Stage).Create();
        /**
         * an optional map from Geometry Id to Geometry index in the 'geometries' array
         */ this._geometriesByUniqueId = null;
        this._defaultMeshCandidates = {
            data: [],
            length: 0
        };
        this._defaultSubMeshCandidates = {
            data: [],
            length: 0
        };
        this._preventFreeActiveMeshesAndRenderingGroups = false;
        /** @internal */ this._activeMeshesFrozen = false;
        /** @internal */ this._activeMeshesFrozenButKeepClipping = false;
        this._skipEvaluateActiveMeshesCompletely = false;
        /** @internal */ this._allowPostProcessClearColor = true;
        /**
         * User updatable function that will return a deterministic frame time when engine is in deterministic lock step mode
         * @returns the frame time
         */ this.getDeterministicFrameTime = ()=>{
            return this._engine.getTimeStep();
        };
        /** @internal */ this._registeredActions = 0;
        this._blockMaterialDirtyMechanism = false;
        /**
         * Internal perfCollector instance used for sharing between inspector and playground.
         * Marked as protected to allow sharing between prototype extensions, but disallow access at toplevel.
         */ this._perfCollector = null;
        this.activeCameras = [];
        const fullOptions = {
            useGeometryUniqueIdsMap: true,
            useMaterialMeshMap: true,
            useClonedMeshMap: true,
            virtual: false,
            ...options
        };
        engine = this._engine = engine || (0, $ejQPp.EngineStore).LastCreatedEngine;
        if (fullOptions.virtual) engine._virtualScenes.push(this);
        else {
            (0, $ejQPp.EngineStore)._LastCreatedScene = this;
            engine.scenes.push(this);
        }
        this._uid = null;
        this._renderingManager = new (0, $jJNg8.RenderingManager)(this);
        if (0, $8MhbJ.PostProcessManager) this.postProcessManager = new (0, $8MhbJ.PostProcessManager)(this);
        if ((0, $jFz47.IsWindowObjectExist)()) this.attachControl();
        // Uniform Buffer
        this._createUbo();
        // Default Image processing definition
        if (0, $dG1pf.ImageProcessingConfiguration) this._imageProcessingConfiguration = new (0, $dG1pf.ImageProcessingConfiguration)();
        this.setDefaultCandidateProviders();
        if (fullOptions.useGeometryUniqueIdsMap) this._geometriesByUniqueId = {};
        this.useMaterialMeshMap = fullOptions.useMaterialMeshMap;
        this.useClonedMeshMap = fullOptions.useClonedMeshMap;
        if (!options || !options.virtual) engine.onNewSceneAddedObservable.notifyObservers(this);
    }
    /**
     * Gets a string identifying the name of the class
     * @returns "Scene" string
     */ getClassName() {
        return "Scene";
    }
    /**
     * @internal
     */ _getDefaultMeshCandidates() {
        this._defaultMeshCandidates.data = this.meshes;
        this._defaultMeshCandidates.length = this.meshes.length;
        return this._defaultMeshCandidates;
    }
    /**
     * @internal
     */ _getDefaultSubMeshCandidates(mesh) {
        this._defaultSubMeshCandidates.data = mesh.subMeshes;
        this._defaultSubMeshCandidates.length = mesh.subMeshes.length;
        return this._defaultSubMeshCandidates;
    }
    /**
     * Sets the default candidate providers for the scene.
     * This sets the getActiveMeshCandidates, getActiveSubMeshCandidates, getIntersectingSubMeshCandidates
     * and getCollidingSubMeshCandidates to their default function
     */ setDefaultCandidateProviders() {
        this.getActiveMeshCandidates = ()=>this._getDefaultMeshCandidates();
        this.getActiveSubMeshCandidates = (mesh)=>this._getDefaultSubMeshCandidates(mesh);
        this.getIntersectingSubMeshCandidates = (mesh, localRay)=>this._getDefaultSubMeshCandidates(mesh);
        this.getCollidingSubMeshCandidates = (mesh, collider)=>this._getDefaultSubMeshCandidates(mesh);
    }
    /**
     * Gets the mesh that is currently under the pointer
     */ get meshUnderPointer() {
        return this._inputManager.meshUnderPointer;
    }
    /**
     * Gets or sets the current on-screen X position of the pointer
     */ get pointerX() {
        return this._inputManager.pointerX;
    }
    set pointerX(value) {
        this._inputManager.pointerX = value;
    }
    /**
     * Gets or sets the current on-screen Y position of the pointer
     */ get pointerY() {
        return this._inputManager.pointerY;
    }
    set pointerY(value) {
        this._inputManager.pointerY = value;
    }
    /**
     * Gets the cached material (ie. the latest rendered one)
     * @returns the cached material
     */ getCachedMaterial() {
        return this._cachedMaterial;
    }
    /**
     * Gets the cached effect (ie. the latest rendered one)
     * @returns the cached effect
     */ getCachedEffect() {
        return this._cachedEffect;
    }
    /**
     * Gets the cached visibility state (ie. the latest rendered one)
     * @returns the cached visibility state
     */ getCachedVisibility() {
        return this._cachedVisibility;
    }
    /**
     * Gets a boolean indicating if the current material / effect / visibility must be bind again
     * @param material defines the current material
     * @param effect defines the current effect
     * @param visibility defines the current visibility state
     * @returns true if one parameter is not cached
     */ isCachedMaterialInvalid(material, effect, visibility = 1) {
        return this._cachedEffect !== effect || this._cachedMaterial !== material || this._cachedVisibility !== visibility;
    }
    /**
     * Gets the engine associated with the scene
     * @returns an Engine
     */ getEngine() {
        return this._engine;
    }
    /**
     * Gets the total number of vertices rendered per frame
     * @returns the total number of vertices rendered per frame
     */ getTotalVertices() {
        return this._totalVertices.current;
    }
    /**
     * Gets the performance counter for total vertices
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/optimize_your_scene#instrumentation
     */ get totalVerticesPerfCounter() {
        return this._totalVertices;
    }
    /**
     * Gets the total number of active indices rendered per frame (You can deduce the number of rendered triangles by dividing this number by 3)
     * @returns the total number of active indices rendered per frame
     */ getActiveIndices() {
        return this._activeIndices.current;
    }
    /**
     * Gets the performance counter for active indices
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/optimize_your_scene#instrumentation
     */ get totalActiveIndicesPerfCounter() {
        return this._activeIndices;
    }
    /**
     * Gets the total number of active particles rendered per frame
     * @returns the total number of active particles rendered per frame
     */ getActiveParticles() {
        return this._activeParticles.current;
    }
    /**
     * Gets the performance counter for active particles
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/optimize_your_scene#instrumentation
     */ get activeParticlesPerfCounter() {
        return this._activeParticles;
    }
    /**
     * Gets the total number of active bones rendered per frame
     * @returns the total number of active bones rendered per frame
     */ getActiveBones() {
        return this._activeBones.current;
    }
    /**
     * Gets the performance counter for active bones
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/optimize_your_scene#instrumentation
     */ get activeBonesPerfCounter() {
        return this._activeBones;
    }
    /**
     * Gets the array of active meshes
     * @returns an array of AbstractMesh
     */ getActiveMeshes() {
        return this._activeMeshes;
    }
    /**
     * Gets the animation ratio (which is 1.0 is the scene renders at 60fps and 2 if the scene renders at 30fps, etc.)
     * @returns a number
     */ getAnimationRatio() {
        return this._animationRatio !== undefined ? this._animationRatio : 1;
    }
    /**
     * Gets an unique Id for the current render phase
     * @returns a number
     */ getRenderId() {
        return this._renderId;
    }
    /**
     * Gets an unique Id for the current frame
     * @returns a number
     */ getFrameId() {
        return this._frameId;
    }
    /** Call this function if you want to manually increment the render Id*/ incrementRenderId() {
        this._renderId++;
    }
    _createUbo() {
        this.setSceneUniformBuffer(this.createSceneUniformBuffer());
    }
    /**
     * Use this method to simulate a pointer move on a mesh
     * The pickResult parameter can be obtained from a scene.pick or scene.pickWithRay
     * @param pickResult pickingInfo of the object wished to simulate pointer event on
     * @param pointerEventInit pointer event state to be used when simulating the pointer event (eg. pointer id for multitouch)
     * @returns the current scene
     */ simulatePointerMove(pickResult, pointerEventInit) {
        this._inputManager.simulatePointerMove(pickResult, pointerEventInit);
        return this;
    }
    /**
     * Use this method to simulate a pointer down on a mesh
     * The pickResult parameter can be obtained from a scene.pick or scene.pickWithRay
     * @param pickResult pickingInfo of the object wished to simulate pointer event on
     * @param pointerEventInit pointer event state to be used when simulating the pointer event (eg. pointer id for multitouch)
     * @returns the current scene
     */ simulatePointerDown(pickResult, pointerEventInit) {
        this._inputManager.simulatePointerDown(pickResult, pointerEventInit);
        return this;
    }
    /**
     * Use this method to simulate a pointer up on a mesh
     * The pickResult parameter can be obtained from a scene.pick or scene.pickWithRay
     * @param pickResult pickingInfo of the object wished to simulate pointer event on
     * @param pointerEventInit pointer event state to be used when simulating the pointer event (eg. pointer id for multitouch)
     * @param doubleTap indicates that the pointer up event should be considered as part of a double click (false by default)
     * @returns the current scene
     */ simulatePointerUp(pickResult, pointerEventInit, doubleTap) {
        this._inputManager.simulatePointerUp(pickResult, pointerEventInit, doubleTap);
        return this;
    }
    /**
     * Gets a boolean indicating if the current pointer event is captured (meaning that the scene has already handled the pointer down)
     * @param pointerId defines the pointer id to use in a multi-touch scenario (0 by default)
     * @returns true if the pointer was captured
     */ isPointerCaptured(pointerId = 0) {
        return this._inputManager.isPointerCaptured(pointerId);
    }
    /**
     * Attach events to the canvas (To handle actionManagers triggers and raise onPointerMove, onPointerDown and onPointerUp
     * @param attachUp defines if you want to attach events to pointerup
     * @param attachDown defines if you want to attach events to pointerdown
     * @param attachMove defines if you want to attach events to pointermove
     */ attachControl(attachUp = true, attachDown = true, attachMove = true) {
        this._inputManager.attachControl(attachUp, attachDown, attachMove);
    }
    /** Detaches all event handlers*/ detachControl() {
        this._inputManager.detachControl();
    }
    /**
     * This function will check if the scene can be rendered (textures are loaded, shaders are compiled)
     * Delay loaded resources are not taking in account
     * @param checkRenderTargets true to also check that the meshes rendered as part of a render target are ready (default: true)
     * @returns true if all required resources are ready
     */ isReady(checkRenderTargets = true) {
        if (this._isDisposed) return false;
        let index;
        const engine = this.getEngine();
        const currentRenderPassId = engine.currentRenderPassId;
        engine.currentRenderPassId = this.activeCamera?.renderPassId ?? currentRenderPassId;
        let isReady = true;
        // Pending data
        if (this._pendingData.length > 0) isReady = false;
        // Ensures that the pre-pass renderer is enabled if it is to be enabled.
        this.prePassRenderer?.update();
        // OIT
        if (this.useOrderIndependentTransparency && this.depthPeelingRenderer) isReady && (isReady = this.depthPeelingRenderer.isReady());
        // Meshes
        if (checkRenderTargets) {
            this._processedMaterials.reset();
            this._materialsRenderTargets.reset();
        }
        for(index = 0; index < this.meshes.length; index++){
            const mesh = this.meshes[index];
            if (!mesh.subMeshes || mesh.subMeshes.length === 0) continue;
            // Do not stop at the first encountered "unready" object as we want to ensure
            // all materials are starting off their compilation in parallel.
            if (!mesh.isReady(true)) {
                isReady = false;
                continue;
            }
            const hardwareInstancedRendering = mesh.hasThinInstances || mesh.getClassName() === "InstancedMesh" || mesh.getClassName() === "InstancedLinesMesh" || engine.getCaps().instancedArrays && mesh.instances.length > 0;
            // Is Ready For Mesh
            for (const step of this._isReadyForMeshStage)if (!step.action(mesh, hardwareInstancedRendering)) isReady = false;
            if (!checkRenderTargets) continue;
            const mat = mesh.material || this.defaultMaterial;
            if (mat) {
                if (mat._storeEffectOnSubMeshes) for (const subMesh of mesh.subMeshes){
                    const material = subMesh.getMaterial();
                    if (material && material.hasRenderTargetTextures && material.getRenderTargetTextures != null) {
                        if (this._processedMaterials.indexOf(material) === -1) {
                            this._processedMaterials.push(material);
                            this._materialsRenderTargets.concatWithNoDuplicate(material.getRenderTargetTextures());
                        }
                    }
                }
                else {
                    if (mat.hasRenderTargetTextures && mat.getRenderTargetTextures != null) {
                        if (this._processedMaterials.indexOf(mat) === -1) {
                            this._processedMaterials.push(mat);
                            this._materialsRenderTargets.concatWithNoDuplicate(mat.getRenderTargetTextures());
                        }
                    }
                }
            }
        }
        // Render targets
        if (checkRenderTargets) for(index = 0; index < this._materialsRenderTargets.length; ++index){
            const rtt = this._materialsRenderTargets.data[index];
            if (!rtt.isReadyForRendering()) isReady = false;
        }
        // Geometries
        for(index = 0; index < this.geometries.length; index++){
            const geometry = this.geometries[index];
            if (geometry.delayLoadState === 2) isReady = false;
        }
        // Post-processes
        if (this.activeCameras && this.activeCameras.length > 0) {
            for (const camera of this.activeCameras)if (!camera.isReady(true)) isReady = false;
        } else if (this.activeCamera) {
            if (!this.activeCamera.isReady(true)) isReady = false;
        }
        // Particles
        for (const particleSystem of this.particleSystems)if (!particleSystem.isReady()) isReady = false;
        // Layers
        if (this.layers) {
            for (const layer of this.layers)if (!layer.isReady()) isReady = false;
        }
        // Effects
        if (!engine.areAllEffectsReady()) isReady = false;
        engine.currentRenderPassId = currentRenderPassId;
        return isReady;
    }
    /** Resets all cached information relative to material (including effect and visibility) */ resetCachedMaterial() {
        this._cachedMaterial = null;
        this._cachedEffect = null;
        this._cachedVisibility = null;
    }
    /**
     * Registers a function to be called before every frame render
     * @param func defines the function to register
     */ registerBeforeRender(func) {
        this.onBeforeRenderObservable.add(func);
    }
    /**
     * Unregisters a function called before every frame render
     * @param func defines the function to unregister
     */ unregisterBeforeRender(func) {
        this.onBeforeRenderObservable.removeCallback(func);
    }
    /**
     * Registers a function to be called after every frame render
     * @param func defines the function to register
     */ registerAfterRender(func) {
        this.onAfterRenderObservable.add(func);
    }
    /**
     * Unregisters a function called after every frame render
     * @param func defines the function to unregister
     */ unregisterAfterRender(func) {
        this.onAfterRenderObservable.removeCallback(func);
    }
    _executeOnceBeforeRender(func) {
        const execFunc = ()=>{
            func();
            setTimeout(()=>{
                this.unregisterBeforeRender(execFunc);
            });
        };
        this.registerBeforeRender(execFunc);
    }
    /**
     * The provided function will run before render once and will be disposed afterwards.
     * A timeout delay can be provided so that the function will be executed in N ms.
     * The timeout is using the browser's native setTimeout so time percision cannot be guaranteed.
     * @param func The function to be executed.
     * @param timeout optional delay in ms
     */ executeOnceBeforeRender(func, timeout) {
        if (timeout !== undefined) setTimeout(()=>{
            this._executeOnceBeforeRender(func);
        }, timeout);
        else this._executeOnceBeforeRender(func);
    }
    /**
     * This function can help adding any object to the list of data awaited to be ready in order to check for a complete scene loading.
     * @param data defines the object to wait for
     */ addPendingData(data) {
        this._pendingData.push(data);
    }
    /**
     * Remove a pending data from the loading list which has previously been added with addPendingData.
     * @param data defines the object to remove from the pending list
     */ removePendingData(data) {
        const wasLoading = this.isLoading;
        const index = this._pendingData.indexOf(data);
        if (index !== -1) this._pendingData.splice(index, 1);
        if (wasLoading && !this.isLoading) this.onDataLoadedObservable.notifyObservers(this);
    }
    /**
     * Returns the number of items waiting to be loaded
     * @returns the number of items waiting to be loaded
     */ getWaitingItemsCount() {
        return this._pendingData.length;
    }
    /**
     * Returns a boolean indicating if the scene is still loading data
     */ get isLoading() {
        return this._pendingData.length > 0;
    }
    /**
     * Registers a function to be executed when the scene is ready
     * @param func - the function to be executed
     * @param checkRenderTargets true to also check that the meshes rendered as part of a render target are ready (default: false)
     */ executeWhenReady(func, checkRenderTargets = false) {
        this.onReadyObservable.addOnce(func);
        if (this._executeWhenReadyTimeoutId !== null) return;
        this._checkIsReady(checkRenderTargets);
    }
    /**
     * Returns a promise that resolves when the scene is ready
     * @param checkRenderTargets true to also check that the meshes rendered as part of a render target are ready (default: false)
     * @returns A promise that resolves when the scene is ready
     */ whenReadyAsync(checkRenderTargets = false) {
        return new Promise((resolve)=>{
            this.executeWhenReady(()=>{
                resolve();
            }, checkRenderTargets);
        });
    }
    /**
     * @internal
     */ _checkIsReady(checkRenderTargets = false) {
        this._registerTransientComponents();
        if (this.isReady(checkRenderTargets)) {
            this.onReadyObservable.notifyObservers(this);
            this.onReadyObservable.clear();
            this._executeWhenReadyTimeoutId = null;
            return;
        }
        if (this._isDisposed) {
            this.onReadyObservable.clear();
            this._executeWhenReadyTimeoutId = null;
            return;
        }
        this._executeWhenReadyTimeoutId = setTimeout(()=>{
            // Ensure materials effects are checked outside render loops
            this.incrementRenderId();
            this._checkIsReady(checkRenderTargets);
        }, 100);
    }
    /**
     * Gets all animatable attached to the scene
     */ get animatables() {
        return this._activeAnimatables;
    }
    /**
     * Resets the last animation time frame.
     * Useful to override when animations start running when loading a scene for the first time.
     */ resetLastAnimationTimeFrame() {
        this._animationTimeLast = (0, $blHSI.PrecisionDate).Now;
    }
    // Matrix
    /**
     * Gets the current view matrix
     * @returns a Matrix
     */ getViewMatrix() {
        return this._viewMatrix;
    }
    /**
     * Gets the current projection matrix
     * @returns a Matrix
     */ getProjectionMatrix() {
        return this._projectionMatrix;
    }
    /**
     * Gets the current transform matrix
     * @returns a Matrix made of View * Projection
     */ getTransformMatrix() {
        return this._transformMatrix;
    }
    /**
     * Sets the current transform matrix
     * @param viewL defines the View matrix to use
     * @param projectionL defines the Projection matrix to use
     * @param viewR defines the right View matrix to use (if provided)
     * @param projectionR defines the right Projection matrix to use (if provided)
     */ setTransformMatrix(viewL, projectionL, viewR, projectionR) {
        // clear the multiviewSceneUbo if no viewR and projectionR are defined
        if (!viewR && !projectionR && this._multiviewSceneUbo) {
            this._multiviewSceneUbo.dispose();
            this._multiviewSceneUbo = null;
        }
        if (this._viewUpdateFlag === viewL.updateFlag && this._projectionUpdateFlag === projectionL.updateFlag) return;
        this._viewUpdateFlag = viewL.updateFlag;
        this._projectionUpdateFlag = projectionL.updateFlag;
        this._viewMatrix = viewL;
        this._projectionMatrix = projectionL;
        this._viewMatrix.multiplyToRef(this._projectionMatrix, this._transformMatrix);
        // Update frustum
        if (!this._frustumPlanes) this._frustumPlanes = (0, $9sPMJ.Frustum).GetPlanes(this._transformMatrix);
        else (0, $9sPMJ.Frustum).GetPlanesToRef(this._transformMatrix, this._frustumPlanes);
        if (this._multiviewSceneUbo && this._multiviewSceneUbo.useUbo) this._updateMultiviewUbo(viewR, projectionR);
        else if (this._sceneUbo.useUbo) {
            this._sceneUbo.updateMatrix("viewProjection", this._transformMatrix);
            this._sceneUbo.updateMatrix("view", this._viewMatrix);
            this._sceneUbo.updateMatrix("projection", this._projectionMatrix);
        }
    }
    /**
     * Gets the uniform buffer used to store scene data
     * @returns a UniformBuffer
     */ getSceneUniformBuffer() {
        return this._multiviewSceneUbo ? this._multiviewSceneUbo : this._sceneUbo;
    }
    /**
     * Creates a scene UBO
     * @param name name of the uniform buffer (optional, for debugging purpose only)
     * @returns a new ubo
     */ createSceneUniformBuffer(name) {
        const sceneUbo = new (0, $ghoTi.UniformBuffer)(this._engine, undefined, false, name ?? "scene");
        sceneUbo.addUniform("viewProjection", 16);
        sceneUbo.addUniform("view", 16);
        sceneUbo.addUniform("projection", 16);
        sceneUbo.addUniform("vEyePosition", 4);
        return sceneUbo;
    }
    /**
     * Sets the scene ubo
     * @param ubo the ubo to set for the scene
     */ setSceneUniformBuffer(ubo) {
        this._sceneUbo = ubo;
        this._viewUpdateFlag = -1;
        this._projectionUpdateFlag = -1;
    }
    /**
     * Gets an unique (relatively to the current scene) Id
     * @returns an unique number for the scene
     */ getUniqueId() {
        return (0, $3u0QC.UniqueIdGenerator).UniqueId;
    }
    /**
     * Add a mesh to the list of scene's meshes
     * @param newMesh defines the mesh to add
     * @param recursive if all child meshes should also be added to the scene
     */ addMesh(newMesh, recursive = false) {
        if (this._blockEntityCollection) return;
        this.meshes.push(newMesh);
        newMesh._resyncLightSources();
        if (!newMesh.parent) newMesh._addToSceneRootNodes();
        this.onNewMeshAddedObservable.notifyObservers(newMesh);
        if (recursive) newMesh.getChildMeshes().forEach((m)=>{
            this.addMesh(m);
        });
    }
    /**
     * Remove a mesh for the list of scene's meshes
     * @param toRemove defines the mesh to remove
     * @param recursive if all child meshes should also be removed from the scene
     * @returns the index where the mesh was in the mesh list
     */ removeMesh(toRemove, recursive = false) {
        const index = this.meshes.indexOf(toRemove);
        if (index !== -1) {
            // Remove from the scene if mesh found
            this.meshes[index] = this.meshes[this.meshes.length - 1];
            this.meshes.pop();
            if (!toRemove.parent) toRemove._removeFromSceneRootNodes();
        }
        this._inputManager._invalidateMesh(toRemove);
        this.onMeshRemovedObservable.notifyObservers(toRemove);
        if (recursive) toRemove.getChildMeshes().forEach((m)=>{
            this.removeMesh(m);
        });
        return index;
    }
    /**
     * Add a transform node to the list of scene's transform nodes
     * @param newTransformNode defines the transform node to add
     */ addTransformNode(newTransformNode) {
        if (this._blockEntityCollection) return;
        if (newTransformNode.getScene() === this && newTransformNode._indexInSceneTransformNodesArray !== -1) // Already there?
        return;
        newTransformNode._indexInSceneTransformNodesArray = this.transformNodes.length;
        this.transformNodes.push(newTransformNode);
        if (!newTransformNode.parent) newTransformNode._addToSceneRootNodes();
        this.onNewTransformNodeAddedObservable.notifyObservers(newTransformNode);
    }
    /**
     * Remove a transform node for the list of scene's transform nodes
     * @param toRemove defines the transform node to remove
     * @returns the index where the transform node was in the transform node list
     */ removeTransformNode(toRemove) {
        const index = toRemove._indexInSceneTransformNodesArray;
        if (index !== -1) {
            if (index !== this.transformNodes.length - 1) {
                const lastNode = this.transformNodes[this.transformNodes.length - 1];
                this.transformNodes[index] = lastNode;
                lastNode._indexInSceneTransformNodesArray = index;
            }
            toRemove._indexInSceneTransformNodesArray = -1;
            this.transformNodes.pop();
            if (!toRemove.parent) toRemove._removeFromSceneRootNodes();
        }
        this.onTransformNodeRemovedObservable.notifyObservers(toRemove);
        return index;
    }
    /**
     * Remove a skeleton for the list of scene's skeletons
     * @param toRemove defines the skeleton to remove
     * @returns the index where the skeleton was in the skeleton list
     */ removeSkeleton(toRemove) {
        const index = this.skeletons.indexOf(toRemove);
        if (index !== -1) {
            // Remove from the scene if found
            this.skeletons.splice(index, 1);
            this.onSkeletonRemovedObservable.notifyObservers(toRemove);
            // Clean active container
            this._executeActiveContainerCleanup(this._activeSkeletons);
        }
        return index;
    }
    /**
     * Remove a morph target for the list of scene's morph targets
     * @param toRemove defines the morph target to remove
     * @returns the index where the morph target was in the morph target list
     */ removeMorphTargetManager(toRemove) {
        const index = this.morphTargetManagers.indexOf(toRemove);
        if (index !== -1) // Remove from the scene if found
        this.morphTargetManagers.splice(index, 1);
        return index;
    }
    /**
     * Remove a light for the list of scene's lights
     * @param toRemove defines the light to remove
     * @returns the index where the light was in the light list
     */ removeLight(toRemove) {
        const index = this.lights.indexOf(toRemove);
        if (index !== -1) {
            // Remove from meshes
            for (const mesh of this.meshes)mesh._removeLightSource(toRemove, false);
            // Remove from the scene if mesh found
            this.lights.splice(index, 1);
            this.sortLightsByPriority();
            if (!toRemove.parent) toRemove._removeFromSceneRootNodes();
        }
        this.onLightRemovedObservable.notifyObservers(toRemove);
        return index;
    }
    /**
     * Remove a camera for the list of scene's cameras
     * @param toRemove defines the camera to remove
     * @returns the index where the camera was in the camera list
     */ removeCamera(toRemove) {
        const index = this.cameras.indexOf(toRemove);
        if (index !== -1) {
            // Remove from the scene if mesh found
            this.cameras.splice(index, 1);
            if (!toRemove.parent) toRemove._removeFromSceneRootNodes();
        }
        // Remove from activeCameras
        if (this.activeCameras) {
            const index2 = this.activeCameras.indexOf(toRemove);
            if (index2 !== -1) // Remove from the scene if mesh found
            this.activeCameras.splice(index2, 1);
        }
        // Reset the activeCamera
        if (this.activeCamera === toRemove) {
            if (this.cameras.length > 0) this.activeCamera = this.cameras[0];
            else this.activeCamera = null;
        }
        this.onCameraRemovedObservable.notifyObservers(toRemove);
        return index;
    }
    /**
     * Remove a particle system for the list of scene's particle systems
     * @param toRemove defines the particle system to remove
     * @returns the index where the particle system was in the particle system list
     */ removeParticleSystem(toRemove) {
        const index = this.particleSystems.indexOf(toRemove);
        if (index !== -1) {
            this.particleSystems.splice(index, 1);
            // Clean active container
            this._executeActiveContainerCleanup(this._activeParticleSystems);
        }
        return index;
    }
    /**
     * Remove a animation for the list of scene's animations
     * @param toRemove defines the animation to remove
     * @returns the index where the animation was in the animation list
     */ removeAnimation(toRemove) {
        const index = this.animations.indexOf(toRemove);
        if (index !== -1) this.animations.splice(index, 1);
        return index;
    }
    /**
     * Will stop the animation of the given target
     * @param target - the target
     * @param animationName - the name of the animation to stop (all animations will be stopped if both this and targetMask are empty)
     * @param targetMask - a function that determines if the animation should be stopped based on its target (all animations will be stopped if both this and animationName are empty)
     */ stopAnimation(target, animationName, targetMask) {
    // Do nothing as code will be provided by animation component
    }
    /**
     * Removes the given animation group from this scene.
     * @param toRemove The animation group to remove
     * @returns The index of the removed animation group
     */ removeAnimationGroup(toRemove) {
        const index = this.animationGroups.indexOf(toRemove);
        if (index !== -1) this.animationGroups.splice(index, 1);
        return index;
    }
    /**
     * Removes the given multi-material from this scene.
     * @param toRemove The multi-material to remove
     * @returns The index of the removed multi-material
     */ removeMultiMaterial(toRemove) {
        const index = this.multiMaterials.indexOf(toRemove);
        if (index !== -1) this.multiMaterials.splice(index, 1);
        this.onMultiMaterialRemovedObservable.notifyObservers(toRemove);
        return index;
    }
    /**
     * Removes the given material from this scene.
     * @param toRemove The material to remove
     * @returns The index of the removed material
     */ removeMaterial(toRemove) {
        const index = toRemove._indexInSceneMaterialArray;
        if (index !== -1 && index < this.materials.length) {
            if (index !== this.materials.length - 1) {
                const lastMaterial = this.materials[this.materials.length - 1];
                this.materials[index] = lastMaterial;
                lastMaterial._indexInSceneMaterialArray = index;
            }
            toRemove._indexInSceneMaterialArray = -1;
            this.materials.pop();
        }
        this.onMaterialRemovedObservable.notifyObservers(toRemove);
        return index;
    }
    /**
     * Removes the given action manager from this scene.
     * @deprecated
     * @param toRemove The action manager to remove
     * @returns The index of the removed action manager
     */ removeActionManager(toRemove) {
        const index = this.actionManagers.indexOf(toRemove);
        if (index !== -1) this.actionManagers.splice(index, 1);
        return index;
    }
    /**
     * Removes the given texture from this scene.
     * @param toRemove The texture to remove
     * @returns The index of the removed texture
     */ removeTexture(toRemove) {
        const index = this.textures.indexOf(toRemove);
        if (index !== -1) this.textures.splice(index, 1);
        this.onTextureRemovedObservable.notifyObservers(toRemove);
        return index;
    }
    /**
     * Adds the given light to this scene
     * @param newLight The light to add
     */ addLight(newLight) {
        if (this._blockEntityCollection) return;
        this.lights.push(newLight);
        this.sortLightsByPriority();
        if (!newLight.parent) newLight._addToSceneRootNodes();
        // Add light to all meshes (To support if the light is removed and then re-added)
        for (const mesh of this.meshes)if (mesh.lightSources.indexOf(newLight) === -1) {
            mesh.lightSources.push(newLight);
            mesh._resyncLightSources();
        }
        this.onNewLightAddedObservable.notifyObservers(newLight);
    }
    /**
     * Sorts the list list based on light priorities
     */ sortLightsByPriority() {
        if (this.requireLightSorting) this.lights.sort((0, $1gEbu.LightConstants).CompareLightsPriority);
    }
    /**
     * Adds the given camera to this scene
     * @param newCamera The camera to add
     */ addCamera(newCamera) {
        if (this._blockEntityCollection) return;
        this.cameras.push(newCamera);
        this.onNewCameraAddedObservable.notifyObservers(newCamera);
        if (!newCamera.parent) newCamera._addToSceneRootNodes();
    }
    /**
     * Adds the given skeleton to this scene
     * @param newSkeleton The skeleton to add
     */ addSkeleton(newSkeleton) {
        if (this._blockEntityCollection) return;
        this.skeletons.push(newSkeleton);
        this.onNewSkeletonAddedObservable.notifyObservers(newSkeleton);
    }
    /**
     * Adds the given particle system to this scene
     * @param newParticleSystem The particle system to add
     */ addParticleSystem(newParticleSystem) {
        if (this._blockEntityCollection) return;
        this.particleSystems.push(newParticleSystem);
    }
    /**
     * Adds the given animation to this scene
     * @param newAnimation The animation to add
     */ addAnimation(newAnimation) {
        if (this._blockEntityCollection) return;
        this.animations.push(newAnimation);
    }
    /**
     * Adds the given animation group to this scene.
     * @param newAnimationGroup The animation group to add
     */ addAnimationGroup(newAnimationGroup) {
        if (this._blockEntityCollection) return;
        this.animationGroups.push(newAnimationGroup);
    }
    /**
     * Adds the given multi-material to this scene
     * @param newMultiMaterial The multi-material to add
     */ addMultiMaterial(newMultiMaterial) {
        if (this._blockEntityCollection) return;
        this.multiMaterials.push(newMultiMaterial);
        this.onNewMultiMaterialAddedObservable.notifyObservers(newMultiMaterial);
    }
    /**
     * Adds the given material to this scene
     * @param newMaterial The material to add
     */ addMaterial(newMaterial) {
        if (this._blockEntityCollection) return;
        if (newMaterial.getScene() === this && newMaterial._indexInSceneMaterialArray !== -1) // Already there??
        return;
        newMaterial._indexInSceneMaterialArray = this.materials.length;
        this.materials.push(newMaterial);
        this.onNewMaterialAddedObservable.notifyObservers(newMaterial);
    }
    /**
     * Adds the given morph target to this scene
     * @param newMorphTargetManager The morph target to add
     */ addMorphTargetManager(newMorphTargetManager) {
        if (this._blockEntityCollection) return;
        this.morphTargetManagers.push(newMorphTargetManager);
    }
    /**
     * Adds the given geometry to this scene
     * @param newGeometry The geometry to add
     */ addGeometry(newGeometry) {
        if (this._blockEntityCollection) return;
        if (this._geometriesByUniqueId) this._geometriesByUniqueId[newGeometry.uniqueId] = this.geometries.length;
        this.geometries.push(newGeometry);
    }
    /**
     * Adds the given action manager to this scene
     * @deprecated
     * @param newActionManager The action manager to add
     */ addActionManager(newActionManager) {
        this.actionManagers.push(newActionManager);
    }
    /**
     * Adds the given texture to this scene.
     * @param newTexture The texture to add
     */ addTexture(newTexture) {
        if (this._blockEntityCollection) return;
        this.textures.push(newTexture);
        this.onNewTextureAddedObservable.notifyObservers(newTexture);
    }
    /**
     * Switch active camera
     * @param newCamera defines the new active camera
     * @param attachControl defines if attachControl must be called for the new active camera (default: true)
     */ switchActiveCamera(newCamera, attachControl = true) {
        const canvas = this._engine.getInputElement();
        if (!canvas) return;
        if (this.activeCamera) this.activeCamera.detachControl();
        this.activeCamera = newCamera;
        if (attachControl) newCamera.attachControl();
    }
    /**
     * sets the active camera of the scene using its Id
     * @param id defines the camera's Id
     * @returns the new active camera or null if none found.
     */ setActiveCameraById(id) {
        const camera = this.getCameraById(id);
        if (camera) {
            this.activeCamera = camera;
            return camera;
        }
        return null;
    }
    /**
     * sets the active camera of the scene using its name
     * @param name defines the camera's name
     * @returns the new active camera or null if none found.
     */ setActiveCameraByName(name) {
        const camera = this.getCameraByName(name);
        if (camera) {
            this.activeCamera = camera;
            return camera;
        }
        return null;
    }
    /**
     * get an animation group using its name
     * @param name defines the material's name
     * @returns the animation group or null if none found.
     */ getAnimationGroupByName(name) {
        for(let index = 0; index < this.animationGroups.length; index++){
            if (this.animationGroups[index].name === name) return this.animationGroups[index];
        }
        return null;
    }
    _getMaterial(allowMultiMaterials, predicate) {
        for(let index = 0; index < this.materials.length; index++){
            const material = this.materials[index];
            if (predicate(material)) return material;
        }
        if (allowMultiMaterials) for(let index = 0; index < this.multiMaterials.length; index++){
            const material = this.multiMaterials[index];
            if (predicate(material)) return material;
        }
        return null;
    }
    /**
     * Get a material using its unique id
     * @param uniqueId defines the material's unique id
     * @param allowMultiMaterials determines whether multimaterials should be considered
     * @returns the material or null if none found.
     */ getMaterialByUniqueID(uniqueId, allowMultiMaterials = false) {
        return this._getMaterial(allowMultiMaterials, (m)=>m.uniqueId === uniqueId);
    }
    /**
     * get a material using its id
     * @param id defines the material's Id
     * @param allowMultiMaterials determines whether multimaterials should be considered
     * @returns the material or null if none found.
     */ getMaterialById(id, allowMultiMaterials = false) {
        return this._getMaterial(allowMultiMaterials, (m)=>m.id === id);
    }
    /**
     * Gets a material using its name
     * @param name defines the material's name
     * @param allowMultiMaterials determines whether multimaterials should be considered
     * @returns the material or null if none found.
     */ getMaterialByName(name, allowMultiMaterials = false) {
        return this._getMaterial(allowMultiMaterials, (m)=>m.name === name);
    }
    /**
     * Gets a last added material using a given id
     * @param id defines the material's id
     * @param allowMultiMaterials determines whether multimaterials should be considered
     * @returns the last material with the given id or null if none found.
     */ getLastMaterialById(id, allowMultiMaterials = false) {
        for(let index = this.materials.length - 1; index >= 0; index--){
            if (this.materials[index].id === id) return this.materials[index];
        }
        if (allowMultiMaterials) for(let index = this.multiMaterials.length - 1; index >= 0; index--){
            if (this.multiMaterials[index].id === id) return this.multiMaterials[index];
        }
        return null;
    }
    /**
     * Get a texture using its unique id
     * @param uniqueId defines the texture's unique id
     * @returns the texture or null if none found.
     */ getTextureByUniqueId(uniqueId) {
        for(let index = 0; index < this.textures.length; index++){
            if (this.textures[index].uniqueId === uniqueId) return this.textures[index];
        }
        return null;
    }
    /**
     * Gets a texture using its name
     * @param name defines the texture's name
     * @returns the texture or null if none found.
     */ getTextureByName(name) {
        for(let index = 0; index < this.textures.length; index++){
            if (this.textures[index].name === name) return this.textures[index];
        }
        return null;
    }
    /**
     * Gets a camera using its Id
     * @param id defines the Id to look for
     * @returns the camera or null if not found
     */ getCameraById(id) {
        for(let index = 0; index < this.cameras.length; index++){
            if (this.cameras[index].id === id) return this.cameras[index];
        }
        return null;
    }
    /**
     * Gets a camera using its unique Id
     * @param uniqueId defines the unique Id to look for
     * @returns the camera or null if not found
     */ getCameraByUniqueId(uniqueId) {
        for(let index = 0; index < this.cameras.length; index++){
            if (this.cameras[index].uniqueId === uniqueId) return this.cameras[index];
        }
        return null;
    }
    /**
     * Gets a camera using its name
     * @param name defines the camera's name
     * @returns the camera or null if none found.
     */ getCameraByName(name) {
        for(let index = 0; index < this.cameras.length; index++){
            if (this.cameras[index].name === name) return this.cameras[index];
        }
        return null;
    }
    /**
     * Gets a bone using its Id
     * @param id defines the bone's Id
     * @returns the bone or null if not found
     */ getBoneById(id) {
        for(let skeletonIndex = 0; skeletonIndex < this.skeletons.length; skeletonIndex++){
            const skeleton = this.skeletons[skeletonIndex];
            for(let boneIndex = 0; boneIndex < skeleton.bones.length; boneIndex++){
                if (skeleton.bones[boneIndex].id === id) return skeleton.bones[boneIndex];
            }
        }
        return null;
    }
    /**
     * Gets a bone using its id
     * @param name defines the bone's name
     * @returns the bone or null if not found
     */ getBoneByName(name) {
        for(let skeletonIndex = 0; skeletonIndex < this.skeletons.length; skeletonIndex++){
            const skeleton = this.skeletons[skeletonIndex];
            for(let boneIndex = 0; boneIndex < skeleton.bones.length; boneIndex++){
                if (skeleton.bones[boneIndex].name === name) return skeleton.bones[boneIndex];
            }
        }
        return null;
    }
    /**
     * Gets a light node using its name
     * @param name defines the light's name
     * @returns the light or null if none found.
     */ getLightByName(name) {
        for(let index = 0; index < this.lights.length; index++){
            if (this.lights[index].name === name) return this.lights[index];
        }
        return null;
    }
    /**
     * Gets a light node using its Id
     * @param id defines the light's Id
     * @returns the light or null if none found.
     */ getLightById(id) {
        for(let index = 0; index < this.lights.length; index++){
            if (this.lights[index].id === id) return this.lights[index];
        }
        return null;
    }
    /**
     * Gets a light node using its scene-generated unique Id
     * @param uniqueId defines the light's unique Id
     * @returns the light or null if none found.
     */ getLightByUniqueId(uniqueId) {
        for(let index = 0; index < this.lights.length; index++){
            if (this.lights[index].uniqueId === uniqueId) return this.lights[index];
        }
        return null;
    }
    /**
     * Gets a particle system by Id
     * @param id defines the particle system Id
     * @returns the corresponding system or null if none found
     */ getParticleSystemById(id) {
        for(let index = 0; index < this.particleSystems.length; index++){
            if (this.particleSystems[index].id === id) return this.particleSystems[index];
        }
        return null;
    }
    /**
     * Gets a geometry using its Id
     * @param id defines the geometry's Id
     * @returns the geometry or null if none found.
     */ getGeometryById(id) {
        for(let index = 0; index < this.geometries.length; index++){
            if (this.geometries[index].id === id) return this.geometries[index];
        }
        return null;
    }
    _getGeometryByUniqueId(uniqueId) {
        if (this._geometriesByUniqueId) {
            const index = this._geometriesByUniqueId[uniqueId];
            if (index !== undefined) return this.geometries[index];
        } else for(let index = 0; index < this.geometries.length; index++){
            if (this.geometries[index].uniqueId === uniqueId) return this.geometries[index];
        }
        return null;
    }
    /**
     * Add a new geometry to this scene
     * @param geometry defines the geometry to be added to the scene.
     * @param force defines if the geometry must be pushed even if a geometry with this id already exists
     * @returns a boolean defining if the geometry was added or not
     */ pushGeometry(geometry, force) {
        if (!force && this._getGeometryByUniqueId(geometry.uniqueId)) return false;
        this.addGeometry(geometry);
        this.onNewGeometryAddedObservable.notifyObservers(geometry);
        return true;
    }
    /**
     * Removes an existing geometry
     * @param geometry defines the geometry to be removed from the scene
     * @returns a boolean defining if the geometry was removed or not
     */ removeGeometry(geometry) {
        let index;
        if (this._geometriesByUniqueId) {
            index = this._geometriesByUniqueId[geometry.uniqueId];
            if (index === undefined) return false;
        } else {
            index = this.geometries.indexOf(geometry);
            if (index < 0) return false;
        }
        if (index !== this.geometries.length - 1) {
            const lastGeometry = this.geometries[this.geometries.length - 1];
            if (lastGeometry) {
                this.geometries[index] = lastGeometry;
                if (this._geometriesByUniqueId) this._geometriesByUniqueId[lastGeometry.uniqueId] = index;
            }
        }
        if (this._geometriesByUniqueId) this._geometriesByUniqueId[geometry.uniqueId] = undefined;
        this.geometries.pop();
        this.onGeometryRemovedObservable.notifyObservers(geometry);
        return true;
    }
    /**
     * Gets the list of geometries attached to the scene
     * @returns an array of Geometry
     */ getGeometries() {
        return this.geometries;
    }
    /**
     * Gets the first added mesh found of a given Id
     * @param id defines the Id to search for
     * @returns the mesh found or null if not found at all
     */ getMeshById(id) {
        for(let index = 0; index < this.meshes.length; index++){
            if (this.meshes[index].id === id) return this.meshes[index];
        }
        return null;
    }
    /**
     * Gets a list of meshes using their Id
     * @param id defines the Id to search for
     * @returns a list of meshes
     */ getMeshesById(id) {
        return this.meshes.filter(function(m) {
            return m.id === id;
        });
    }
    /**
     * Gets the first added transform node found of a given Id
     * @param id defines the Id to search for
     * @returns the found transform node or null if not found at all.
     */ getTransformNodeById(id) {
        for(let index = 0; index < this.transformNodes.length; index++){
            if (this.transformNodes[index].id === id) return this.transformNodes[index];
        }
        return null;
    }
    /**
     * Gets a transform node with its auto-generated unique Id
     * @param uniqueId defines the unique Id to search for
     * @returns the found transform node or null if not found at all.
     */ getTransformNodeByUniqueId(uniqueId) {
        for(let index = 0; index < this.transformNodes.length; index++){
            if (this.transformNodes[index].uniqueId === uniqueId) return this.transformNodes[index];
        }
        return null;
    }
    /**
     * Gets a list of transform nodes using their Id
     * @param id defines the Id to search for
     * @returns a list of transform nodes
     */ getTransformNodesById(id) {
        return this.transformNodes.filter(function(m) {
            return m.id === id;
        });
    }
    /**
     * Gets a mesh with its auto-generated unique Id
     * @param uniqueId defines the unique Id to search for
     * @returns the found mesh or null if not found at all.
     */ getMeshByUniqueId(uniqueId) {
        for(let index = 0; index < this.meshes.length; index++){
            if (this.meshes[index].uniqueId === uniqueId) return this.meshes[index];
        }
        return null;
    }
    /**
     * Gets a the last added mesh using a given Id
     * @param id defines the Id to search for
     * @returns the found mesh or null if not found at all.
     */ getLastMeshById(id) {
        for(let index = this.meshes.length - 1; index >= 0; index--){
            if (this.meshes[index].id === id) return this.meshes[index];
        }
        return null;
    }
    /**
     * Gets a the last transform node using a given Id
     * @param id defines the Id to search for
     * @returns the found mesh or null if not found at all.
     */ getLastTransformNodeById(id) {
        for(let index = this.transformNodes.length - 1; index >= 0; index--){
            if (this.transformNodes[index].id === id) return this.transformNodes[index];
        }
        return null;
    }
    /**
     * Gets a the last added node (Mesh, Camera, Light) using a given Id
     * @param id defines the Id to search for
     * @returns the found node or null if not found at all
     */ getLastEntryById(id) {
        let index;
        for(index = this.meshes.length - 1; index >= 0; index--){
            if (this.meshes[index].id === id) return this.meshes[index];
        }
        for(index = this.transformNodes.length - 1; index >= 0; index--){
            if (this.transformNodes[index].id === id) return this.transformNodes[index];
        }
        for(index = this.cameras.length - 1; index >= 0; index--){
            if (this.cameras[index].id === id) return this.cameras[index];
        }
        for(index = this.lights.length - 1; index >= 0; index--){
            if (this.lights[index].id === id) return this.lights[index];
        }
        return null;
    }
    /**
     * Gets a node (Mesh, Camera, Light) using a given Id
     * @param id defines the Id to search for
     * @returns the found node or null if not found at all
     */ getNodeById(id) {
        const mesh = this.getMeshById(id);
        if (mesh) return mesh;
        const transformNode = this.getTransformNodeById(id);
        if (transformNode) return transformNode;
        const light = this.getLightById(id);
        if (light) return light;
        const camera = this.getCameraById(id);
        if (camera) return camera;
        const bone = this.getBoneById(id);
        if (bone) return bone;
        return null;
    }
    /**
     * Gets a node (Mesh, Camera, Light) using a given name
     * @param name defines the name to search for
     * @returns the found node or null if not found at all.
     */ getNodeByName(name) {
        const mesh = this.getMeshByName(name);
        if (mesh) return mesh;
        const transformNode = this.getTransformNodeByName(name);
        if (transformNode) return transformNode;
        const light = this.getLightByName(name);
        if (light) return light;
        const camera = this.getCameraByName(name);
        if (camera) return camera;
        const bone = this.getBoneByName(name);
        if (bone) return bone;
        return null;
    }
    /**
     * Gets a mesh using a given name
     * @param name defines the name to search for
     * @returns the found mesh or null if not found at all.
     */ getMeshByName(name) {
        for(let index = 0; index < this.meshes.length; index++){
            if (this.meshes[index].name === name) return this.meshes[index];
        }
        return null;
    }
    /**
     * Gets a transform node using a given name
     * @param name defines the name to search for
     * @returns the found transform node or null if not found at all.
     */ getTransformNodeByName(name) {
        for(let index = 0; index < this.transformNodes.length; index++){
            if (this.transformNodes[index].name === name) return this.transformNodes[index];
        }
        return null;
    }
    /**
     * Gets a skeleton using a given Id (if many are found, this function will pick the last one)
     * @param id defines the Id to search for
     * @returns the found skeleton or null if not found at all.
     */ getLastSkeletonById(id) {
        for(let index = this.skeletons.length - 1; index >= 0; index--){
            if (this.skeletons[index].id === id) return this.skeletons[index];
        }
        return null;
    }
    /**
     * Gets a skeleton using a given auto generated unique id
     * @param  uniqueId defines the unique id to search for
     * @returns the found skeleton or null if not found at all.
     */ getSkeletonByUniqueId(uniqueId) {
        for(let index = 0; index < this.skeletons.length; index++){
            if (this.skeletons[index].uniqueId === uniqueId) return this.skeletons[index];
        }
        return null;
    }
    /**
     * Gets a skeleton using a given id (if many are found, this function will pick the first one)
     * @param id defines the id to search for
     * @returns the found skeleton or null if not found at all.
     */ getSkeletonById(id) {
        for(let index = 0; index < this.skeletons.length; index++){
            if (this.skeletons[index].id === id) return this.skeletons[index];
        }
        return null;
    }
    /**
     * Gets a skeleton using a given name
     * @param name defines the name to search for
     * @returns the found skeleton or null if not found at all.
     */ getSkeletonByName(name) {
        for(let index = 0; index < this.skeletons.length; index++){
            if (this.skeletons[index].name === name) return this.skeletons[index];
        }
        return null;
    }
    /**
     * Gets a morph target manager  using a given id (if many are found, this function will pick the last one)
     * @param id defines the id to search for
     * @returns the found morph target manager or null if not found at all.
     */ getMorphTargetManagerById(id) {
        for(let index = 0; index < this.morphTargetManagers.length; index++){
            if (this.morphTargetManagers[index].uniqueId === id) return this.morphTargetManagers[index];
        }
        return null;
    }
    /**
     * Gets a morph target using a given id (if many are found, this function will pick the first one)
     * @param id defines the id to search for
     * @returns the found morph target or null if not found at all.
     */ getMorphTargetById(id) {
        for(let managerIndex = 0; managerIndex < this.morphTargetManagers.length; ++managerIndex){
            const morphTargetManager = this.morphTargetManagers[managerIndex];
            for(let index = 0; index < morphTargetManager.numTargets; ++index){
                const target = morphTargetManager.getTarget(index);
                if (target.id === id) return target;
            }
        }
        return null;
    }
    /**
     * Gets a morph target using a given name (if many are found, this function will pick the first one)
     * @param name defines the name to search for
     * @returns the found morph target or null if not found at all.
     */ getMorphTargetByName(name) {
        for(let managerIndex = 0; managerIndex < this.morphTargetManagers.length; ++managerIndex){
            const morphTargetManager = this.morphTargetManagers[managerIndex];
            for(let index = 0; index < morphTargetManager.numTargets; ++index){
                const target = morphTargetManager.getTarget(index);
                if (target.name === name) return target;
            }
        }
        return null;
    }
    /**
     * Gets a post process using a given name (if many are found, this function will pick the first one)
     * @param name defines the name to search for
     * @returns the found post process or null if not found at all.
     */ getPostProcessByName(name) {
        for(let postProcessIndex = 0; postProcessIndex < this.postProcesses.length; ++postProcessIndex){
            const postProcess = this.postProcesses[postProcessIndex];
            if (postProcess.name === name) return postProcess;
        }
        return null;
    }
    /**
     * Gets a boolean indicating if the given mesh is active
     * @param mesh defines the mesh to look for
     * @returns true if the mesh is in the active list
     */ isActiveMesh(mesh) {
        return this._activeMeshes.indexOf(mesh) !== -1;
    }
    /**
     * Return a unique id as a string which can serve as an identifier for the scene
     */ get uid() {
        if (!this._uid) this._uid = (0, $bOhSV.Tools).RandomId();
        return this._uid;
    }
    /**
     * Add an externally attached data from its key.
     * This method call will fail and return false, if such key already exists.
     * If you don't care and just want to get the data no matter what, use the more convenient getOrAddExternalDataWithFactory() method.
     * @param key the unique key that identifies the data
     * @param data the data object to associate to the key for this Engine instance
     * @returns true if no such key were already present and the data was added successfully, false otherwise
     */ addExternalData(key, data) {
        if (!this._externalData) this._externalData = new (0, $895IS.StringDictionary)();
        return this._externalData.add(key, data);
    }
    /**
     * Get an externally attached data from its key
     * @param key the unique key that identifies the data
     * @returns the associated data, if present (can be null), or undefined if not present
     */ getExternalData(key) {
        if (!this._externalData) return null;
        return this._externalData.get(key);
    }
    /**
     * Get an externally attached data from its key, create it using a factory if it's not already present
     * @param key the unique key that identifies the data
     * @param factory the factory that will be called to create the instance if and only if it doesn't exists
     * @returns the associated data, can be null if the factory returned null.
     */ getOrAddExternalDataWithFactory(key, factory) {
        if (!this._externalData) this._externalData = new (0, $895IS.StringDictionary)();
        return this._externalData.getOrAddWithFactory(key, factory);
    }
    /**
     * Remove an externally attached data from the Engine instance
     * @param key the unique key that identifies the data
     * @returns true if the data was successfully removed, false if it doesn't exist
     */ removeExternalData(key) {
        return this._externalData.remove(key);
    }
    _evaluateSubMesh(subMesh, mesh, initialMesh, forcePush) {
        if (forcePush || subMesh.isInFrustum(this._frustumPlanes)) {
            for (const step of this._evaluateSubMeshStage)step.action(mesh, subMesh);
            const material = subMesh.getMaterial();
            if (material !== null && material !== undefined) {
                // Render targets
                if (material.hasRenderTargetTextures && material.getRenderTargetTextures != null) {
                    if (this._processedMaterials.indexOf(material) === -1) {
                        this._processedMaterials.push(material);
                        this._materialsRenderTargets.concatWithNoDuplicate(material.getRenderTargetTextures());
                    }
                }
                // Dispatch
                this._renderingManager.dispatch(subMesh, mesh, material);
            }
        }
    }
    /**
     * Clear the processed materials smart array preventing retention point in material dispose.
     */ freeProcessedMaterials() {
        this._processedMaterials.dispose();
    }
    /** Gets or sets a boolean blocking all the calls to freeActiveMeshes and freeRenderingGroups
     * It can be used in order to prevent going through methods freeRenderingGroups and freeActiveMeshes several times to improve performance
     * when disposing several meshes in a row or a hierarchy of meshes.
     * When used, it is the responsibility of the user to blockfreeActiveMeshesAndRenderingGroups back to false.
     */ get blockfreeActiveMeshesAndRenderingGroups() {
        return this._preventFreeActiveMeshesAndRenderingGroups;
    }
    set blockfreeActiveMeshesAndRenderingGroups(value) {
        if (this._preventFreeActiveMeshesAndRenderingGroups === value) return;
        if (value) {
            this.freeActiveMeshes();
            this.freeRenderingGroups();
        }
        this._preventFreeActiveMeshesAndRenderingGroups = value;
    }
    /**
     * Clear the active meshes smart array preventing retention point in mesh dispose.
     */ freeActiveMeshes() {
        if (this.blockfreeActiveMeshesAndRenderingGroups) return;
        this._activeMeshes.dispose();
        if (this.activeCamera && this.activeCamera._activeMeshes) this.activeCamera._activeMeshes.dispose();
        if (this.activeCameras) for(let i = 0; i < this.activeCameras.length; i++){
            const activeCamera = this.activeCameras[i];
            if (activeCamera && activeCamera._activeMeshes) activeCamera._activeMeshes.dispose();
        }
    }
    /**
     * Clear the info related to rendering groups preventing retention points during dispose.
     */ freeRenderingGroups() {
        if (this.blockfreeActiveMeshesAndRenderingGroups) return;
        if (this._renderingManager) this._renderingManager.freeRenderingGroups();
        if (this.textures) for(let i = 0; i < this.textures.length; i++){
            const texture = this.textures[i];
            if (texture && texture.renderList) texture.freeRenderingGroups();
        }
    }
    /** @internal */ _isInIntermediateRendering() {
        return this._intermediateRendering;
    }
    /**
     * Use this function to stop evaluating active meshes. The current list will be keep alive between frames
     * @param skipEvaluateActiveMeshes defines an optional boolean indicating that the evaluate active meshes step must be completely skipped
     * @param onSuccess optional success callback
     * @param onError optional error callback
     * @param freezeMeshes defines if meshes should be frozen (true by default)
     * @param keepFrustumCulling defines if you want to keep running the frustum clipping (false by default)
     * @returns the current scene
     */ freezeActiveMeshes(skipEvaluateActiveMeshes = false, onSuccess, onError, freezeMeshes = true, keepFrustumCulling = false) {
        this.executeWhenReady(()=>{
            if (!this.activeCamera) {
                onError && onError("No active camera found");
                return;
            }
            if (!this._frustumPlanes) this.updateTransformMatrix();
            this._evaluateActiveMeshes();
            this._activeMeshesFrozen = true;
            this._activeMeshesFrozenButKeepClipping = keepFrustumCulling;
            this._skipEvaluateActiveMeshesCompletely = skipEvaluateActiveMeshes;
            if (freezeMeshes) for(let index = 0; index < this._activeMeshes.length; index++)this._activeMeshes.data[index]._freeze();
            onSuccess && onSuccess();
        });
        return this;
    }
    /**
     * Use this function to restart evaluating active meshes on every frame
     * @returns the current scene
     */ unfreezeActiveMeshes() {
        for(let index = 0; index < this.meshes.length; index++){
            const mesh = this.meshes[index];
            if (mesh._internalAbstractMeshDataInfo) mesh._internalAbstractMeshDataInfo._isActive = false;
        }
        for(let index = 0; index < this._activeMeshes.length; index++)this._activeMeshes.data[index]._unFreeze();
        this._activeMeshesFrozen = false;
        return this;
    }
    _executeActiveContainerCleanup(container) {
        const isInFastMode = this._engine.snapshotRendering && this._engine.snapshotRenderingMode === 1;
        if (!isInFastMode && this._activeMeshesFrozen && this._activeMeshes.length) return; // Do not execute in frozen mode
        // We need to ensure we are not in the rendering loop
        this.onBeforeRenderObservable.addOnce(()=>container.dispose());
    }
    _evaluateActiveMeshes() {
        if (this._engine.snapshotRendering && this._engine.snapshotRenderingMode === 1) {
            if (this._activeMeshes.length > 0) {
                this.activeCamera?._activeMeshes.reset();
                this._activeMeshes.reset();
                this._renderingManager.reset();
                this._processedMaterials.reset();
                this._activeParticleSystems.reset();
                this._activeSkeletons.reset();
                this._softwareSkinnedMeshes.reset();
            }
            return;
        }
        if (this._activeMeshesFrozen && this._activeMeshes.length) {
            if (!this._skipEvaluateActiveMeshesCompletely) {
                const len = this._activeMeshes.length;
                for(let i = 0; i < len; i++){
                    const mesh = this._activeMeshes.data[i];
                    mesh.computeWorldMatrix();
                }
            }
            if (this._activeParticleSystems) {
                const psLength = this._activeParticleSystems.length;
                for(let i = 0; i < psLength; i++)this._activeParticleSystems.data[i].animate();
            }
            this._renderingManager.resetSprites();
            return;
        }
        if (!this.activeCamera) return;
        this.onBeforeActiveMeshesEvaluationObservable.notifyObservers(this);
        this.activeCamera._activeMeshes.reset();
        this._activeMeshes.reset();
        this._renderingManager.reset();
        this._processedMaterials.reset();
        this._activeParticleSystems.reset();
        this._activeSkeletons.reset();
        this._softwareSkinnedMeshes.reset();
        this._materialsRenderTargets.reset();
        for (const step of this._beforeEvaluateActiveMeshStage)step.action();
        // Determine mesh candidates
        const meshes = this.getActiveMeshCandidates();
        // Check each mesh
        const len = meshes.length;
        for(let i = 0; i < len; i++){
            const mesh = meshes.data[i];
            mesh._internalAbstractMeshDataInfo._currentLODIsUpToDate = false;
            if (mesh.isBlocked) continue;
            this._totalVertices.addCount(mesh.getTotalVertices(), false);
            if (!mesh.isReady() || !mesh.isEnabled() || mesh.scaling.hasAZeroComponent) continue;
            mesh.computeWorldMatrix();
            // Intersections
            if (mesh.actionManager && mesh.actionManager.hasSpecificTriggers2(12, 13)) this._meshesForIntersections.pushNoDuplicate(mesh);
            // Switch to current LOD
            let meshToRender = this.customLODSelector ? this.customLODSelector(mesh, this.activeCamera) : mesh.getLOD(this.activeCamera);
            mesh._internalAbstractMeshDataInfo._currentLOD = meshToRender;
            mesh._internalAbstractMeshDataInfo._currentLODIsUpToDate = true;
            if (meshToRender === undefined || meshToRender === null) continue;
            // Compute world matrix if LOD is billboard
            if (meshToRender !== mesh && meshToRender.billboardMode !== 0) meshToRender.computeWorldMatrix();
            mesh._preActivate();
            if (mesh.isVisible && mesh.visibility > 0 && (mesh.layerMask & this.activeCamera.layerMask) !== 0 && (this._skipFrustumClipping || mesh.alwaysSelectAsActiveMesh || mesh.isInFrustum(this._frustumPlanes))) {
                this._activeMeshes.push(mesh);
                this.activeCamera._activeMeshes.push(mesh);
                if (meshToRender !== mesh) meshToRender._activate(this._renderId, false);
                for (const step of this._preActiveMeshStage)step.action(mesh);
                if (mesh._activate(this._renderId, false)) {
                    if (!mesh.isAnInstance) meshToRender._internalAbstractMeshDataInfo._onlyForInstances = false;
                    else if (mesh._internalAbstractMeshDataInfo._actAsRegularMesh) meshToRender = mesh;
                    meshToRender._internalAbstractMeshDataInfo._isActive = true;
                    this._activeMesh(mesh, meshToRender);
                }
                mesh._postActivate();
            }
        }
        this.onAfterActiveMeshesEvaluationObservable.notifyObservers(this);
        // Particle systems
        if (this.particlesEnabled) {
            this.onBeforeParticlesRenderingObservable.notifyObservers(this);
            for(let particleIndex = 0; particleIndex < this.particleSystems.length; particleIndex++){
                const particleSystem = this.particleSystems[particleIndex];
                if (!particleSystem.isStarted() || !particleSystem.emitter) continue;
                const emitter = particleSystem.emitter;
                if (!emitter.position || emitter.isEnabled()) {
                    this._activeParticleSystems.push(particleSystem);
                    particleSystem.animate();
                    this._renderingManager.dispatchParticles(particleSystem);
                }
            }
            this.onAfterParticlesRenderingObservable.notifyObservers(this);
        }
    }
    _activeMesh(sourceMesh, mesh) {
        if (this._skeletonsEnabled && mesh.skeleton !== null && mesh.skeleton !== undefined) {
            if (this._activeSkeletons.pushNoDuplicate(mesh.skeleton)) {
                mesh.skeleton.prepare();
                this._activeBones.addCount(mesh.skeleton.bones.length, false);
            }
            if (!mesh.computeBonesUsingShaders) this._softwareSkinnedMeshes.pushNoDuplicate(mesh);
        }
        let forcePush = sourceMesh.hasInstances || sourceMesh.isAnInstance || this.dispatchAllSubMeshesOfActiveMeshes || this._skipFrustumClipping || mesh.alwaysSelectAsActiveMesh;
        if (mesh && mesh.subMeshes && mesh.subMeshes.length > 0) {
            const subMeshes = this.getActiveSubMeshCandidates(mesh);
            const len = subMeshes.length;
            forcePush = forcePush || len === 1;
            for(let i = 0; i < len; i++){
                const subMesh = subMeshes.data[i];
                this._evaluateSubMesh(subMesh, mesh, sourceMesh, forcePush);
            }
        }
    }
    /**
     * Update the transform matrix to update from the current active camera
     * @param force defines a boolean used to force the update even if cache is up to date
     */ updateTransformMatrix(force) {
        const activeCamera = this.activeCamera;
        if (!activeCamera) return;
        if (activeCamera._renderingMultiview) {
            const leftCamera = activeCamera._rigCameras[0];
            const rightCamera = activeCamera._rigCameras[1];
            this.setTransformMatrix(leftCamera.getViewMatrix(), leftCamera.getProjectionMatrix(force), rightCamera.getViewMatrix(), rightCamera.getProjectionMatrix(force));
        } else this.setTransformMatrix(activeCamera.getViewMatrix(), activeCamera.getProjectionMatrix(force));
    }
    _bindFrameBuffer(camera, clear = true) {
        if (camera && camera._multiviewTexture) camera._multiviewTexture._bindFrameBuffer();
        else if (camera && camera.outputRenderTarget) camera.outputRenderTarget._bindFrameBuffer();
        else if (!this._engine._currentFrameBufferIsDefaultFrameBuffer()) this._engine.restoreDefaultFramebuffer();
        if (clear) this._clearFrameBuffer(camera);
    }
    _clearFrameBuffer(camera) {
        // we assume the framebuffer currently bound is the right one
        if (camera && camera._multiviewTexture) ;
        else if (camera && camera.outputRenderTarget && !camera._renderingMultiview) {
            const rtt = camera.outputRenderTarget;
            if (rtt.onClearObservable.hasObservers()) rtt.onClearObservable.notifyObservers(this._engine);
            else if (!rtt.skipInitialClear && !camera.isRightCamera) {
                if (this.autoClear) this._engine.clear(rtt.clearColor || this.clearColor, !rtt._cleared, true, true);
                rtt._cleared = true;
            }
        } else if (!this._defaultFrameBufferCleared) {
            this._defaultFrameBufferCleared = true;
            this._clear();
        } else this._engine.clear(null, false, true, true);
    }
    /**
     * @internal
     */ _renderForCamera(camera, rigParent, bindFrameBuffer = true) {
        if (camera && camera._skipRendering) return;
        const engine = this._engine;
        // Use _activeCamera instead of activeCamera to avoid onActiveCameraChanged
        this._activeCamera = camera;
        if (!this.activeCamera) throw new Error("Active camera not set");
        // Viewport
        engine.setViewport(this.activeCamera.viewport);
        // Camera
        this.resetCachedMaterial();
        this._renderId++;
        if (!this.prePass && bindFrameBuffer) {
            let skipInitialClear = true;
            if (camera._renderingMultiview && camera.outputRenderTarget) {
                skipInitialClear = camera.outputRenderTarget.skipInitialClear;
                if (this.autoClear) {
                    this._defaultFrameBufferCleared = false;
                    camera.outputRenderTarget.skipInitialClear = false;
                }
            }
            this._bindFrameBuffer(this._activeCamera);
            if (camera._renderingMultiview && camera.outputRenderTarget) camera.outputRenderTarget.skipInitialClear = skipInitialClear;
        }
        this.updateTransformMatrix();
        this.onBeforeCameraRenderObservable.notifyObservers(this.activeCamera);
        // Meshes
        this._evaluateActiveMeshes();
        // Software skinning
        for(let softwareSkinnedMeshIndex = 0; softwareSkinnedMeshIndex < this._softwareSkinnedMeshes.length; softwareSkinnedMeshIndex++){
            const mesh = this._softwareSkinnedMeshes.data[softwareSkinnedMeshIndex];
            mesh.applySkeleton(mesh.skeleton);
        }
        // Render targets
        this.onBeforeRenderTargetsRenderObservable.notifyObservers(this);
        this._renderTargets.concatWithNoDuplicate(this._materialsRenderTargets);
        if (camera.customRenderTargets && camera.customRenderTargets.length > 0) this._renderTargets.concatWithNoDuplicate(camera.customRenderTargets);
        if (rigParent && rigParent.customRenderTargets && rigParent.customRenderTargets.length > 0) this._renderTargets.concatWithNoDuplicate(rigParent.customRenderTargets);
        if (this.environmentTexture && this.environmentTexture.isRenderTarget) this._renderTargets.pushNoDuplicate(this.environmentTexture);
        // Collects render targets from external components.
        for (const step of this._gatherActiveCameraRenderTargetsStage)step.action(this._renderTargets);
        let needRebind = false;
        if (this.renderTargetsEnabled) {
            this._intermediateRendering = true;
            if (this._renderTargets.length > 0) {
                (0, $bOhSV.Tools).StartPerformanceCounter("Render targets", this._renderTargets.length > 0);
                for(let renderIndex = 0; renderIndex < this._renderTargets.length; renderIndex++){
                    const renderTarget = this._renderTargets.data[renderIndex];
                    if (renderTarget._shouldRender()) {
                        this._renderId++;
                        const hasSpecialRenderTargetCamera = renderTarget.activeCamera && renderTarget.activeCamera !== this.activeCamera;
                        renderTarget.render(hasSpecialRenderTargetCamera, this.dumpNextRenderTargets);
                        needRebind = true;
                    }
                }
                (0, $bOhSV.Tools).EndPerformanceCounter("Render targets", this._renderTargets.length > 0);
                this._renderId++;
            }
            for (const step of this._cameraDrawRenderTargetStage)needRebind = step.action(this.activeCamera) || needRebind;
            this._intermediateRendering = false;
        }
        this._engine.currentRenderPassId = camera.outputRenderTarget?.renderPassId ?? camera.renderPassId ?? 0;
        // Restore framebuffer after rendering to targets
        if (needRebind && !this.prePass) {
            this._bindFrameBuffer(this._activeCamera, false);
            this.updateTransformMatrix();
        }
        this.onAfterRenderTargetsRenderObservable.notifyObservers(this);
        // Prepare Frame
        if (this.postProcessManager && !camera._multiviewTexture && !this.prePass) this.postProcessManager._prepareFrame();
        // Before Camera Draw
        for (const step of this._beforeCameraDrawStage)step.action(this.activeCamera);
        // Render
        this.onBeforeDrawPhaseObservable.notifyObservers(this);
        if (engine.snapshotRendering && engine.snapshotRenderingMode === 1) this.finalizeSceneUbo();
        this._renderingManager.render(null, null, true, true);
        this.onAfterDrawPhaseObservable.notifyObservers(this);
        // After Camera Draw
        for (const step of this._afterCameraDrawStage)step.action(this.activeCamera);
        // Finalize frame
        if (this.postProcessManager && !camera._multiviewTexture) {
            // if the camera has an output render target, render the post process to the render target
            const texture = camera.outputRenderTarget ? camera.outputRenderTarget.renderTarget : undefined;
            this.postProcessManager._finalizeFrame(camera.isIntermediate, texture);
        }
        // After post process
        for (const step of this._afterCameraPostProcessStage)step.action(this.activeCamera);
        // Reset some special arrays
        this._renderTargets.reset();
        this.onAfterCameraRenderObservable.notifyObservers(this.activeCamera);
    }
    _processSubCameras(camera, bindFrameBuffer = true) {
        if (camera.cameraRigMode === 0 || camera._renderingMultiview) {
            if (camera._renderingMultiview && !this._multiviewSceneUbo) this._createMultiviewUbo();
            this._renderForCamera(camera, undefined, bindFrameBuffer);
            this.onAfterRenderCameraObservable.notifyObservers(camera);
            return;
        }
        if (camera._useMultiviewToSingleView) this._renderMultiviewToSingleView(camera);
        else {
            // rig cameras
            this.onBeforeCameraRenderObservable.notifyObservers(camera);
            for(let index = 0; index < camera._rigCameras.length; index++)this._renderForCamera(camera._rigCameras[index], camera);
        }
        // Use _activeCamera instead of activeCamera to avoid onActiveCameraChanged
        this._activeCamera = camera;
        this.updateTransformMatrix();
        this.onAfterRenderCameraObservable.notifyObservers(camera);
    }
    _checkIntersections() {
        for(let index = 0; index < this._meshesForIntersections.length; index++){
            const sourceMesh = this._meshesForIntersections.data[index];
            if (!sourceMesh.actionManager) continue;
            for(let actionIndex = 0; sourceMesh.actionManager && actionIndex < sourceMesh.actionManager.actions.length; actionIndex++){
                const action = sourceMesh.actionManager.actions[actionIndex];
                if (action.trigger === 12 || action.trigger === 13) {
                    const parameters = action.getTriggerParameter();
                    const otherMesh = parameters.mesh ? parameters.mesh : parameters;
                    const areIntersecting = otherMesh.intersectsMesh(sourceMesh, parameters.usePreciseIntersection);
                    const currentIntersectionInProgress = sourceMesh._intersectionsInProgress.indexOf(otherMesh);
                    if (areIntersecting && currentIntersectionInProgress === -1) {
                        if (action.trigger === 12) {
                            action._executeCurrent((0, $cmj0B.ActionEvent).CreateNew(sourceMesh, undefined, otherMesh));
                            sourceMesh._intersectionsInProgress.push(otherMesh);
                        } else if (action.trigger === 13) sourceMesh._intersectionsInProgress.push(otherMesh);
                    } else if (!areIntersecting && currentIntersectionInProgress > -1) {
                        //They intersected, and now they don't.
                        //is this trigger an exit trigger? execute an event.
                        if (action.trigger === 13) action._executeCurrent((0, $cmj0B.ActionEvent).CreateNew(sourceMesh, undefined, otherMesh));
                        //if this is an exit trigger, or no exit trigger exists, remove the id from the intersection in progress array.
                        if (!sourceMesh.actionManager.hasSpecificTrigger(13, (parameter)=>{
                            const parameterMesh = parameter.mesh ? parameter.mesh : parameter;
                            return otherMesh === parameterMesh;
                        }) || action.trigger === 13) sourceMesh._intersectionsInProgress.splice(currentIntersectionInProgress, 1);
                    }
                }
            }
        }
    }
    /**
     * @internal
     */ _advancePhysicsEngineStep(step) {
    // Do nothing. Code will be replaced if physics engine component is referenced
    }
    /** @internal */ _animate(customDeltaTime) {
    // Nothing to do as long as Animatable have not been imported.
    }
    /** Execute all animations (for a frame) */ animate() {
        if (this._engine.isDeterministicLockStep()) {
            let deltaTime = Math.max($be87b65ec8caf46b$export$38af1803e3442a7f.MinDeltaTime, Math.min(this._engine.getDeltaTime(), $be87b65ec8caf46b$export$38af1803e3442a7f.MaxDeltaTime)) + this._timeAccumulator;
            const defaultFrameTime = this._engine.getTimeStep();
            const defaultFPS = 1000.0 / defaultFrameTime / 1000.0;
            let stepsTaken = 0;
            const maxSubSteps = this._engine.getLockstepMaxSteps();
            let internalSteps = Math.floor(deltaTime / defaultFrameTime);
            internalSteps = Math.min(internalSteps, maxSubSteps);
            while(deltaTime > 0 && stepsTaken < internalSteps){
                this.onBeforeStepObservable.notifyObservers(this);
                // Animations
                this._animationRatio = defaultFrameTime * defaultFPS;
                this._animate(defaultFrameTime);
                this.onAfterAnimationsObservable.notifyObservers(this);
                // Physics
                if (this.physicsEnabled) this._advancePhysicsEngineStep(defaultFrameTime);
                this.onAfterStepObservable.notifyObservers(this);
                this._currentStepId++;
                stepsTaken++;
                deltaTime -= defaultFrameTime;
            }
            this._timeAccumulator = deltaTime < 0 ? 0 : deltaTime;
        } else {
            // Animations
            const deltaTime = this.useConstantAnimationDeltaTime ? 16 : Math.max($be87b65ec8caf46b$export$38af1803e3442a7f.MinDeltaTime, Math.min(this._engine.getDeltaTime(), $be87b65ec8caf46b$export$38af1803e3442a7f.MaxDeltaTime));
            this._animationRatio = deltaTime * 0.06;
            this._animate();
            this.onAfterAnimationsObservable.notifyObservers(this);
            // Physics
            if (this.physicsEnabled) this._advancePhysicsEngineStep(deltaTime);
        }
    }
    _clear() {
        if (this.autoClearDepthAndStencil || this.autoClear) this._engine.clear(this.clearColor, this.autoClear || this.forceWireframe || this.forcePointsCloud, this.autoClearDepthAndStencil, this.autoClearDepthAndStencil);
    }
    _checkCameraRenderTarget(camera) {
        if (camera?.outputRenderTarget && !camera?.isRigCamera) camera.outputRenderTarget._cleared = false;
        if (camera?.rigCameras?.length) for(let i = 0; i < camera.rigCameras.length; ++i){
            const rtt = camera.rigCameras[i].outputRenderTarget;
            if (rtt) rtt._cleared = false;
        }
    }
    /**
     * Resets the draw wrappers cache of all meshes
     * @param passId If provided, releases only the draw wrapper corresponding to this render pass id
     */ resetDrawCache(passId) {
        if (!this.meshes) return;
        for (const mesh of this.meshes)mesh.resetDrawCache(passId);
    }
    /**
     * Render the scene
     * @param updateCameras defines a boolean indicating if cameras must update according to their inputs (true by default)
     * @param ignoreAnimations defines a boolean indicating if animations should not be executed (false by default)
     */ render(updateCameras = true, ignoreAnimations = false) {
        if (this.isDisposed) return;
        if (this.onReadyObservable.hasObservers() && this._executeWhenReadyTimeoutId === null) this._checkIsReady();
        this._frameId++;
        this._defaultFrameBufferCleared = false;
        this._checkCameraRenderTarget(this.activeCamera);
        if (this.activeCameras?.length) this.activeCameras.forEach(this._checkCameraRenderTarget);
        // Register components that have been associated lately to the scene.
        this._registerTransientComponents();
        this._activeParticles.fetchNewFrame();
        this._totalVertices.fetchNewFrame();
        this._activeIndices.fetchNewFrame();
        this._activeBones.fetchNewFrame();
        this._meshesForIntersections.reset();
        this.resetCachedMaterial();
        this.onBeforeAnimationsObservable.notifyObservers(this);
        // Actions
        if (this.actionManager) this.actionManager.processTrigger(11);
        // Animations
        if (!ignoreAnimations) this.animate();
        // Before camera update steps
        for (const step of this._beforeCameraUpdateStage)step.action();
        // Update Cameras
        if (updateCameras) {
            if (this.activeCameras && this.activeCameras.length > 0) for(let cameraIndex = 0; cameraIndex < this.activeCameras.length; cameraIndex++){
                const camera = this.activeCameras[cameraIndex];
                camera.update();
                if (camera.cameraRigMode !== 0) // rig cameras
                for(let index = 0; index < camera._rigCameras.length; index++)camera._rigCameras[index].update();
            }
            else if (this.activeCamera) {
                this.activeCamera.update();
                if (this.activeCamera.cameraRigMode !== 0) // rig cameras
                for(let index = 0; index < this.activeCamera._rigCameras.length; index++)this.activeCamera._rigCameras[index].update();
            }
        }
        // Before render
        this.onBeforeRenderObservable.notifyObservers(this);
        const engine = this.getEngine();
        // Customs render targets
        this.onBeforeRenderTargetsRenderObservable.notifyObservers(this);
        const currentActiveCamera = this.activeCameras?.length ? this.activeCameras[0] : this.activeCamera;
        if (this.renderTargetsEnabled) {
            (0, $bOhSV.Tools).StartPerformanceCounter("Custom render targets", this.customRenderTargets.length > 0);
            this._intermediateRendering = true;
            for(let customIndex = 0; customIndex < this.customRenderTargets.length; customIndex++){
                const renderTarget = this.customRenderTargets[customIndex];
                if (renderTarget._shouldRender()) {
                    this._renderId++;
                    this.activeCamera = renderTarget.activeCamera || this.activeCamera;
                    if (!this.activeCamera) throw new Error("Active camera not set");
                    // Viewport
                    engine.setViewport(this.activeCamera.viewport);
                    // Camera
                    this.updateTransformMatrix();
                    renderTarget.render(currentActiveCamera !== this.activeCamera, this.dumpNextRenderTargets);
                }
            }
            (0, $bOhSV.Tools).EndPerformanceCounter("Custom render targets", this.customRenderTargets.length > 0);
            this._intermediateRendering = false;
            this._renderId++;
        }
        this._engine.currentRenderPassId = currentActiveCamera?.renderPassId ?? 0;
        // Restore back buffer
        this.activeCamera = currentActiveCamera;
        if (this._activeCamera && this._activeCamera.cameraRigMode !== 22 && !this.prePass) this._bindFrameBuffer(this._activeCamera, false);
        this.onAfterRenderTargetsRenderObservable.notifyObservers(this);
        for (const step of this._beforeClearStage)step.action();
        // Clear
        this._clearFrameBuffer(this.activeCamera);
        // Collects render targets from external components.
        for (const step of this._gatherRenderTargetsStage)step.action(this._renderTargets);
        // Multi-cameras?
        if (this.activeCameras && this.activeCameras.length > 0) for(let cameraIndex = 0; cameraIndex < this.activeCameras.length; cameraIndex++)this._processSubCameras(this.activeCameras[cameraIndex], cameraIndex > 0);
        else {
            if (!this.activeCamera) throw new Error("No camera defined");
            this._processSubCameras(this.activeCamera, !!this.activeCamera.outputRenderTarget);
        }
        // Intersection checks
        this._checkIntersections();
        // Executes the after render stage actions.
        for (const step of this._afterRenderStage)step.action();
        // After render
        if (this.afterRender) this.afterRender();
        this.onAfterRenderObservable.notifyObservers(this);
        // Cleaning
        if (this._toBeDisposed.length) {
            for(let index = 0; index < this._toBeDisposed.length; index++){
                const data = this._toBeDisposed[index];
                if (data) data.dispose();
            }
            this._toBeDisposed.length = 0;
        }
        if (this.dumpNextRenderTargets) this.dumpNextRenderTargets = false;
        this._activeBones.addCount(0, true);
        this._activeIndices.addCount(0, true);
        this._activeParticles.addCount(0, true);
        this._engine.restoreDefaultFramebuffer();
    }
    /**
     * Freeze all materials
     * A frozen material will not be updatable but should be faster to render
     * Note: multimaterials will not be frozen, but their submaterials will
     */ freezeMaterials() {
        for(let i = 0; i < this.materials.length; i++)this.materials[i].freeze();
    }
    /**
     * Unfreeze all materials
     * A frozen material will not be updatable but should be faster to render
     */ unfreezeMaterials() {
        for(let i = 0; i < this.materials.length; i++)this.materials[i].unfreeze();
    }
    /**
     * Releases all held resources
     */ dispose() {
        if (this.isDisposed) return;
        this.beforeRender = null;
        this.afterRender = null;
        this.metadata = null;
        this.skeletons.length = 0;
        this.morphTargetManagers.length = 0;
        this._transientComponents.length = 0;
        this._isReadyForMeshStage.clear();
        this._beforeEvaluateActiveMeshStage.clear();
        this._evaluateSubMeshStage.clear();
        this._preActiveMeshStage.clear();
        this._cameraDrawRenderTargetStage.clear();
        this._beforeCameraDrawStage.clear();
        this._beforeRenderTargetDrawStage.clear();
        this._beforeRenderingGroupDrawStage.clear();
        this._beforeRenderingMeshStage.clear();
        this._afterRenderingMeshStage.clear();
        this._afterRenderingGroupDrawStage.clear();
        this._afterCameraDrawStage.clear();
        this._afterRenderTargetDrawStage.clear();
        this._afterRenderStage.clear();
        this._beforeCameraUpdateStage.clear();
        this._beforeClearStage.clear();
        this._gatherRenderTargetsStage.clear();
        this._gatherActiveCameraRenderTargetsStage.clear();
        this._pointerMoveStage.clear();
        this._pointerDownStage.clear();
        this._pointerUpStage.clear();
        this.importedMeshesFiles = [];
        if (this.stopAllAnimations) {
            // Ensures that no animatable notifies a callback that could start a new animation group, constantly adding new animatables to the active list...
            this._activeAnimatables.forEach((animatable)=>{
                animatable.onAnimationEndObservable.clear();
                animatable.onAnimationEnd = null;
            });
            this.stopAllAnimations();
        }
        this.resetCachedMaterial();
        // Smart arrays
        if (this.activeCamera) {
            this.activeCamera._activeMeshes.dispose();
            this.activeCamera = null;
        }
        this.activeCameras = null;
        this._activeMeshes.dispose();
        this._renderingManager.dispose();
        this._processedMaterials.dispose();
        this._activeParticleSystems.dispose();
        this._activeSkeletons.dispose();
        this._softwareSkinnedMeshes.dispose();
        this._renderTargets.dispose();
        this._materialsRenderTargets.dispose();
        this._registeredForLateAnimationBindings.dispose();
        this._meshesForIntersections.dispose();
        this._toBeDisposed.length = 0;
        // Abort active requests
        const activeRequests = this._activeRequests.slice();
        for (const request of activeRequests)request.abort();
        this._activeRequests.length = 0;
        // Events
        try {
            this.onDisposeObservable.notifyObservers(this);
        } catch (e) {
            (0, $kVtWi.Logger).Error("An error occurred while calling onDisposeObservable!", e);
        }
        this.detachControl();
        // Detach cameras
        const canvas = this._engine.getInputElement();
        if (canvas) for(let index = 0; index < this.cameras.length; index++)this.cameras[index].detachControl();
        // Release animation groups
        this._disposeList(this.animationGroups);
        // Release lights
        this._disposeList(this.lights);
        // Release meshes
        this._disposeList(this.meshes, (item)=>item.dispose(true));
        this._disposeList(this.transformNodes, (item)=>item.dispose(true));
        // Release cameras
        const cameras = this.cameras;
        this._disposeList(cameras);
        // Release materials
        if (this._defaultMaterial) this._defaultMaterial.dispose();
        this._disposeList(this.multiMaterials);
        this._disposeList(this.materials);
        // Release particles
        this._disposeList(this.particleSystems);
        // Release postProcesses
        this._disposeList(this.postProcesses);
        // Release textures
        this._disposeList(this.textures);
        // Release morph targets
        this._disposeList(this.morphTargetManagers);
        // Release UBO
        this._sceneUbo.dispose();
        if (this._multiviewSceneUbo) this._multiviewSceneUbo.dispose();
        // Post-processes
        this.postProcessManager.dispose();
        // Components
        this._disposeList(this._components);
        // Remove from engine
        let index = this._engine.scenes.indexOf(this);
        if (index > -1) this._engine.scenes.splice(index, 1);
        if ((0, $ejQPp.EngineStore)._LastCreatedScene === this) {
            if (this._engine.scenes.length > 0) (0, $ejQPp.EngineStore)._LastCreatedScene = this._engine.scenes[this._engine.scenes.length - 1];
            else (0, $ejQPp.EngineStore)._LastCreatedScene = null;
        }
        index = this._engine._virtualScenes.indexOf(this);
        if (index > -1) this._engine._virtualScenes.splice(index, 1);
        this._engine.wipeCaches(true);
        this.onDisposeObservable.clear();
        this.onBeforeRenderObservable.clear();
        this.onAfterRenderObservable.clear();
        this.onBeforeRenderTargetsRenderObservable.clear();
        this.onAfterRenderTargetsRenderObservable.clear();
        this.onAfterStepObservable.clear();
        this.onBeforeStepObservable.clear();
        this.onBeforeActiveMeshesEvaluationObservable.clear();
        this.onAfterActiveMeshesEvaluationObservable.clear();
        this.onBeforeParticlesRenderingObservable.clear();
        this.onAfterParticlesRenderingObservable.clear();
        this.onBeforeDrawPhaseObservable.clear();
        this.onAfterDrawPhaseObservable.clear();
        this.onBeforeAnimationsObservable.clear();
        this.onAfterAnimationsObservable.clear();
        this.onDataLoadedObservable.clear();
        this.onBeforeRenderingGroupObservable.clear();
        this.onAfterRenderingGroupObservable.clear();
        this.onMeshImportedObservable.clear();
        this.onBeforeCameraRenderObservable.clear();
        this.onAfterCameraRenderObservable.clear();
        this.onAfterRenderCameraObservable.clear();
        this.onReadyObservable.clear();
        this.onNewCameraAddedObservable.clear();
        this.onCameraRemovedObservable.clear();
        this.onNewLightAddedObservable.clear();
        this.onLightRemovedObservable.clear();
        this.onNewGeometryAddedObservable.clear();
        this.onGeometryRemovedObservable.clear();
        this.onNewTransformNodeAddedObservable.clear();
        this.onTransformNodeRemovedObservable.clear();
        this.onNewMeshAddedObservable.clear();
        this.onMeshRemovedObservable.clear();
        this.onNewSkeletonAddedObservable.clear();
        this.onSkeletonRemovedObservable.clear();
        this.onNewMaterialAddedObservable.clear();
        this.onNewMultiMaterialAddedObservable.clear();
        this.onMaterialRemovedObservable.clear();
        this.onMultiMaterialRemovedObservable.clear();
        this.onNewTextureAddedObservable.clear();
        this.onTextureRemovedObservable.clear();
        this.onPrePointerObservable.clear();
        this.onPointerObservable.clear();
        this.onPreKeyboardObservable.clear();
        this.onKeyboardObservable.clear();
        this.onActiveCameraChanged.clear();
        this.onScenePerformancePriorityChangedObservable.clear();
        this._isDisposed = true;
    }
    _disposeList(items, callback) {
        const itemsCopy = items.slice(0);
        callback = callback ?? ((item)=>item.dispose());
        for (const item of itemsCopy)callback(item);
        items.length = 0;
    }
    /**
     * Gets if the scene is already disposed
     */ get isDisposed() {
        return this._isDisposed;
    }
    /**
     * Call this function to reduce memory footprint of the scene.
     * Vertex buffers will not store CPU data anymore (this will prevent picking, collisions or physics to work correctly)
     */ clearCachedVertexData() {
        for(let meshIndex = 0; meshIndex < this.meshes.length; meshIndex++){
            const mesh = this.meshes[meshIndex];
            const geometry = mesh.geometry;
            if (geometry) geometry.clearCachedData();
        }
    }
    /**
     * This function will remove the local cached buffer data from texture.
     * It will save memory but will prevent the texture from being rebuilt
     */ cleanCachedTextureBuffer() {
        for (const baseTexture of this.textures){
            const buffer = baseTexture._buffer;
            if (buffer) baseTexture._buffer = null;
        }
    }
    /**
     * Get the world extend vectors with an optional filter
     *
     * @param filterPredicate the predicate - which meshes should be included when calculating the world size
     * @returns {{ min: Vector3; max: Vector3 }} min and max vectors
     */ getWorldExtends(filterPredicate) {
        const min = new (0, $ha1VO.Vector3)(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
        const max = new (0, $ha1VO.Vector3)(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
        filterPredicate = filterPredicate || (()=>true);
        this.meshes.filter(filterPredicate).forEach((mesh)=>{
            mesh.computeWorldMatrix(true);
            if (!mesh.subMeshes || mesh.subMeshes.length === 0 || mesh.infiniteDistance) return;
            const boundingInfo = mesh.getBoundingInfo();
            const minBox = boundingInfo.boundingBox.minimumWorld;
            const maxBox = boundingInfo.boundingBox.maximumWorld;
            (0, $ha1VO.Vector3).CheckExtends(minBox, min, max);
            (0, $ha1VO.Vector3).CheckExtends(maxBox, min, max);
        });
        return {
            min: min,
            max: max
        };
    }
    // Picking
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Creates a ray that can be used to pick in the scene
     * @param x defines the x coordinate of the origin (on-screen)
     * @param y defines the y coordinate of the origin (on-screen)
     * @param world defines the world matrix to use if you want to pick in object space (instead of world space)
     * @param camera defines the camera to use for the picking
     * @param cameraViewSpace defines if picking will be done in view space (false by default)
     * @returns a Ray
     */ createPickingRay(x, y, world, camera, cameraViewSpace = false) {
        throw (0, $dUFYy._WarnImport)("Ray");
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Creates a ray that can be used to pick in the scene
     * @param x defines the x coordinate of the origin (on-screen)
     * @param y defines the y coordinate of the origin (on-screen)
     * @param world defines the world matrix to use if you want to pick in object space (instead of world space)
     * @param result defines the ray where to store the picking ray
     * @param camera defines the camera to use for the picking
     * @param cameraViewSpace defines if picking will be done in view space (false by default)
     * @param enableDistantPicking defines if picking should handle large values for mesh position/scaling (false by default)
     * @returns the current scene
     */ createPickingRayToRef(x, y, world, result, camera, cameraViewSpace = false, enableDistantPicking = false) {
        throw (0, $dUFYy._WarnImport)("Ray");
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Creates a ray that can be used to pick in the scene
     * @param x defines the x coordinate of the origin (on-screen)
     * @param y defines the y coordinate of the origin (on-screen)
     * @param camera defines the camera to use for the picking
     * @returns a Ray
     */ createPickingRayInCameraSpace(x, y, camera) {
        throw (0, $dUFYy._WarnImport)("Ray");
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Creates a ray that can be used to pick in the scene
     * @param x defines the x coordinate of the origin (on-screen)
     * @param y defines the y coordinate of the origin (on-screen)
     * @param result defines the ray where to store the picking ray
     * @param camera defines the camera to use for the picking
     * @returns the current scene
     */ createPickingRayInCameraSpaceToRef(x, y, result, camera) {
        throw (0, $dUFYy._WarnImport)("Ray");
    }
    /** @internal */ get _pickingAvailable() {
        return false;
    }
    /** Launch a ray to try to pick a mesh in the scene
     * @param x position on screen
     * @param y position on screen
     * @param predicate Predicate function used to determine eligible meshes. Can be set to null. In this case, a mesh must be enabled, visible and with isPickable set to true
     * @param fastCheck defines if the first intersection will be used (and not the closest)
     * @param camera to use for computing the picking ray. Can be set to null. In this case, the scene.activeCamera will be used
     * @param trianglePredicate defines an optional predicate used to select faces when a mesh intersection is detected
     * @returns a PickingInfo
     */ pick(x, y, predicate, fastCheck, camera, trianglePredicate) {
        const warn = (0, $dUFYy._WarnImport)("Ray", true);
        if (warn) (0, $kVtWi.Logger).Warn(warn);
        // Dummy info if picking as not been imported
        return new (0, $gzCma.PickingInfo)();
    }
    /** Launch a ray to try to pick a mesh in the scene using only bounding information of the main mesh (not using submeshes)
     * @param x position on screen
     * @param y position on screen
     * @param predicate Predicate function used to determine eligible meshes. Can be set to null. In this case, a mesh must be enabled, visible and with isPickable set to true
     * @param fastCheck defines if the first intersection will be used (and not the closest)
     * @param camera to use for computing the picking ray. Can be set to null. In this case, the scene.activeCamera will be used
     * @returns a PickingInfo (Please note that some info will not be set like distance, bv, bu and everything that cannot be capture by only using bounding infos)
     */ pickWithBoundingInfo(x, y, predicate, fastCheck, camera) {
        const warn = (0, $dUFYy._WarnImport)("Ray", true);
        if (warn) (0, $kVtWi.Logger).Warn(warn);
        // Dummy info if picking as not been imported
        return new (0, $gzCma.PickingInfo)();
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Use the given ray to pick a mesh in the scene. A mesh triangle can be picked both from its front and back sides,
     * irrespective of orientation.
     * @param ray The ray to use to pick meshes
     * @param predicate Predicate function used to determine eligible meshes. Can be set to null. In this case, a mesh must have isPickable set to true
     * @param fastCheck defines if the first intersection will be used (and not the closest)
     * @param trianglePredicate defines an optional predicate used to select faces when a mesh intersection is detected
     * @returns a PickingInfo
     */ pickWithRay(ray, predicate, fastCheck, trianglePredicate) {
        throw (0, $dUFYy._WarnImport)("Ray");
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Launch a ray to try to pick a mesh in the scene. A mesh triangle can be picked both from its front and back sides,
     * irrespective of orientation.
     * @param x X position on screen
     * @param y Y position on screen
     * @param predicate Predicate function used to determine eligible meshes. Can be set to null. In this case, a mesh must be enabled, visible and with isPickable set to true
     * @param camera camera to use for computing the picking ray. Can be set to null. In this case, the scene.activeCamera will be used
     * @param trianglePredicate defines an optional predicate used to select faces when a mesh intersection is detected
     * @returns an array of PickingInfo
     */ multiPick(x, y, predicate, camera, trianglePredicate) {
        throw (0, $dUFYy._WarnImport)("Ray");
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Launch a ray to try to pick a mesh in the scene
     * @param ray Ray to use
     * @param predicate Predicate function used to determine eligible meshes. Can be set to null. In this case, a mesh must be enabled, visible and with isPickable set to true
     * @param trianglePredicate defines an optional predicate used to select faces when a mesh intersection is detected
     * @returns an array of PickingInfo
     */ multiPickWithRay(ray, predicate, trianglePredicate) {
        throw (0, $dUFYy._WarnImport)("Ray");
    }
    /**
     * Force the value of meshUnderPointer
     * @param mesh defines the mesh to use
     * @param pointerId optional pointer id when using more than one pointer
     * @param pickResult optional pickingInfo data used to find mesh
     */ setPointerOverMesh(mesh, pointerId, pickResult) {
        this._inputManager.setPointerOverMesh(mesh, pointerId, pickResult);
    }
    /**
     * Gets the mesh under the pointer
     * @returns a Mesh or null if no mesh is under the pointer
     */ getPointerOverMesh() {
        return this._inputManager.getPointerOverMesh();
    }
    // Misc.
    /** @internal */ _rebuildGeometries() {
        for (const geometry of this.geometries)geometry._rebuild();
        for (const mesh of this.meshes)mesh._rebuild();
        if (this.postProcessManager) this.postProcessManager._rebuild();
        for (const component of this._components)component.rebuild();
        for (const system of this.particleSystems)system.rebuild();
        if (this.spriteManagers) for (const spriteMgr of this.spriteManagers)spriteMgr.rebuild();
    }
    /** @internal */ _rebuildTextures() {
        for (const texture of this.textures)texture._rebuild(true);
        this.markAllMaterialsAsDirty(1);
    }
    /**
     * Get from a list of objects by tags
     * @param list the list of objects to use
     * @param tagsQuery the query to use
     * @param filter a predicate to filter for tags
     * @returns
     */ _getByTags(list, tagsQuery, filter) {
        if (tagsQuery === undefined) // returns the complete list (could be done with Tags.MatchesQuery but no need to have a for-loop here)
        return list;
        const listByTags = [];
        for(const i in list){
            const item = list[i];
            if ((0, $7212E.Tags) && (0, $7212E.Tags).MatchesQuery(item, tagsQuery) && (!filter || filter(item))) listByTags.push(item);
        }
        return listByTags;
    }
    /**
     * Get a list of meshes by tags
     * @param tagsQuery defines the tags query to use
     * @param filter defines a predicate used to filter results
     * @returns an array of Mesh
     */ getMeshesByTags(tagsQuery, filter) {
        return this._getByTags(this.meshes, tagsQuery, filter);
    }
    /**
     * Get a list of cameras by tags
     * @param tagsQuery defines the tags query to use
     * @param filter defines a predicate used to filter results
     * @returns an array of Camera
     */ getCamerasByTags(tagsQuery, filter) {
        return this._getByTags(this.cameras, tagsQuery, filter);
    }
    /**
     * Get a list of lights by tags
     * @param tagsQuery defines the tags query to use
     * @param filter defines a predicate used to filter results
     * @returns an array of Light
     */ getLightsByTags(tagsQuery, filter) {
        return this._getByTags(this.lights, tagsQuery, filter);
    }
    /**
     * Get a list of materials by tags
     * @param tagsQuery defines the tags query to use
     * @param filter defines a predicate used to filter results
     * @returns an array of Material
     */ getMaterialByTags(tagsQuery, filter) {
        return this._getByTags(this.materials, tagsQuery, filter).concat(this._getByTags(this.multiMaterials, tagsQuery, filter));
    }
    /**
     * Get a list of transform nodes by tags
     * @param tagsQuery defines the tags query to use
     * @param filter defines a predicate used to filter results
     * @returns an array of TransformNode
     */ getTransformNodesByTags(tagsQuery, filter) {
        return this._getByTags(this.transformNodes, tagsQuery, filter);
    }
    /**
     * Overrides the default sort function applied in the rendering group to prepare the meshes.
     * This allowed control for front to back rendering or reversly depending of the special needs.
     *
     * @param renderingGroupId The rendering group id corresponding to its index
     * @param opaqueSortCompareFn The opaque queue comparison function use to sort.
     * @param alphaTestSortCompareFn The alpha test queue comparison function use to sort.
     * @param transparentSortCompareFn The transparent queue comparison function use to sort.
     */ setRenderingOrder(renderingGroupId, opaqueSortCompareFn = null, alphaTestSortCompareFn = null, transparentSortCompareFn = null) {
        this._renderingManager.setRenderingOrder(renderingGroupId, opaqueSortCompareFn, alphaTestSortCompareFn, transparentSortCompareFn);
    }
    /**
     * Specifies whether or not the stencil and depth buffer are cleared between two rendering groups.
     *
     * @param renderingGroupId The rendering group id corresponding to its index
     * @param autoClearDepthStencil Automatically clears depth and stencil between groups if true.
     * @param depth Automatically clears depth between groups if true and autoClear is true.
     * @param stencil Automatically clears stencil between groups if true and autoClear is true.
     */ setRenderingAutoClearDepthStencil(renderingGroupId, autoClearDepthStencil, depth = true, stencil = true) {
        this._renderingManager.setRenderingAutoClearDepthStencil(renderingGroupId, autoClearDepthStencil, depth, stencil);
    }
    /**
     * Gets the current auto clear configuration for one rendering group of the rendering
     * manager.
     * @param index the rendering group index to get the information for
     * @returns The auto clear setup for the requested rendering group
     */ getAutoClearDepthStencilSetup(index) {
        return this._renderingManager.getAutoClearDepthStencilSetup(index);
    }
    /** @internal */ _forceBlockMaterialDirtyMechanism(value) {
        this._blockMaterialDirtyMechanism = value;
    }
    /** Gets or sets a boolean blocking all the calls to markAllMaterialsAsDirty (ie. the materials won't be updated if they are out of sync) */ get blockMaterialDirtyMechanism() {
        return this._blockMaterialDirtyMechanism;
    }
    set blockMaterialDirtyMechanism(value) {
        if (this._blockMaterialDirtyMechanism === value) return;
        this._blockMaterialDirtyMechanism = value;
        if (!value) // Do a complete update
        this.markAllMaterialsAsDirty(63);
    }
    /**
     * Will flag all materials as dirty to trigger new shader compilation
     * @param flag defines the flag used to specify which material part must be marked as dirty
     * @param predicate If not null, it will be used to specify if a material has to be marked as dirty
     */ markAllMaterialsAsDirty(flag, predicate) {
        if (this._blockMaterialDirtyMechanism) return;
        for (const material of this.materials){
            if (predicate && !predicate(material)) continue;
            material.markAsDirty(flag);
        }
    }
    /**
     * @internal
     */ _loadFile(fileOrUrl, onSuccess, onProgress, useOfflineSupport, useArrayBuffer, onError, onOpened) {
        const request = (0, $EOxw7.LoadFile)(fileOrUrl, onSuccess, onProgress, useOfflineSupport ? this.offlineProvider : undefined, useArrayBuffer, onError, onOpened);
        this._activeRequests.push(request);
        request.onCompleteObservable.add((request)=>{
            this._activeRequests.splice(this._activeRequests.indexOf(request), 1);
        });
        return request;
    }
    /**
     * @internal
     */ _loadFileAsync(fileOrUrl, onProgress, useOfflineSupport, useArrayBuffer, onOpened) {
        return new Promise((resolve, reject)=>{
            this._loadFile(fileOrUrl, (data)=>{
                resolve(data);
            }, onProgress, useOfflineSupport, useArrayBuffer, (request, exception)=>{
                reject(exception);
            }, onOpened);
        });
    }
    /**
     * @internal
     */ _requestFile(url, onSuccess, onProgress, useOfflineSupport, useArrayBuffer, onError, onOpened) {
        const request = (0, $EOxw7.RequestFile)(url, onSuccess, onProgress, useOfflineSupport ? this.offlineProvider : undefined, useArrayBuffer, onError, onOpened);
        this._activeRequests.push(request);
        request.onCompleteObservable.add((request)=>{
            this._activeRequests.splice(this._activeRequests.indexOf(request), 1);
        });
        return request;
    }
    /**
     * @internal
     */ _requestFileAsync(url, onProgress, useOfflineSupport, useArrayBuffer, onOpened) {
        return new Promise((resolve, reject)=>{
            this._requestFile(url, (data)=>{
                resolve(data);
            }, onProgress, useOfflineSupport, useArrayBuffer, (error)=>{
                reject(error);
            }, onOpened);
        });
    }
    /**
     * @internal
     */ _readFile(file, onSuccess, onProgress, useArrayBuffer, onError) {
        const request = (0, $EOxw7.ReadFile)(file, onSuccess, onProgress, useArrayBuffer, onError);
        this._activeRequests.push(request);
        request.onCompleteObservable.add((request)=>{
            this._activeRequests.splice(this._activeRequests.indexOf(request), 1);
        });
        return request;
    }
    /**
     * @internal
     */ _readFileAsync(file, onProgress, useArrayBuffer) {
        return new Promise((resolve, reject)=>{
            this._readFile(file, (data)=>{
                resolve(data);
            }, onProgress, useArrayBuffer, (error)=>{
                reject(error);
            });
        });
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * This method gets the performance collector belonging to the scene, which is generally shared with the inspector.
     * @returns the perf collector belonging to the scene.
     */ getPerfCollector() {
        throw (0, $dUFYy._WarnImport)("performanceViewerSceneExtension");
    }
    // deprecated
    /**
     * Sets the active camera of the scene using its Id
     * @param id defines the camera's Id
     * @returns the new active camera or null if none found.
     * @deprecated Please use setActiveCameraById instead
     */ setActiveCameraByID(id) {
        return this.setActiveCameraById(id);
    }
    /**
     * Get a material using its id
     * @param id defines the material's Id
     * @returns the material or null if none found.
     * @deprecated Please use getMaterialById instead
     */ getMaterialByID(id) {
        return this.getMaterialById(id);
    }
    /**
     * Gets a the last added material using a given id
     * @param id defines the material's Id
     * @returns the last material with the given id or null if none found.
     * @deprecated Please use getLastMaterialById instead
     */ getLastMaterialByID(id) {
        return this.getLastMaterialById(id);
    }
    /**
     * Get a texture using its unique id
     * @param uniqueId defines the texture's unique id
     * @returns the texture or null if none found.
     * @deprecated Please use getTextureByUniqueId instead
     */ getTextureByUniqueID(uniqueId) {
        return this.getTextureByUniqueId(uniqueId);
    }
    /**
     * Gets a camera using its Id
     * @param id defines the Id to look for
     * @returns the camera or null if not found
     * @deprecated Please use getCameraById instead
     */ getCameraByID(id) {
        return this.getCameraById(id);
    }
    /**
     * Gets a camera using its unique Id
     * @param uniqueId defines the unique Id to look for
     * @returns the camera or null if not found
     * @deprecated Please use getCameraByUniqueId instead
     */ getCameraByUniqueID(uniqueId) {
        return this.getCameraByUniqueId(uniqueId);
    }
    /**
     * Gets a bone using its Id
     * @param id defines the bone's Id
     * @returns the bone or null if not found
     * @deprecated Please use getBoneById instead
     */ getBoneByID(id) {
        return this.getBoneById(id);
    }
    /**
     * Gets a light node using its Id
     * @param id defines the light's Id
     * @returns the light or null if none found.
     * @deprecated Please use getLightById instead
     */ getLightByID(id) {
        return this.getLightById(id);
    }
    /**
     * Gets a light node using its scene-generated unique Id
     * @param uniqueId defines the light's unique Id
     * @returns the light or null if none found.
     * @deprecated Please use getLightByUniqueId instead
     */ getLightByUniqueID(uniqueId) {
        return this.getLightByUniqueId(uniqueId);
    }
    /**
     * Gets a particle system by Id
     * @param id defines the particle system Id
     * @returns the corresponding system or null if none found
     * @deprecated Please use getParticleSystemById instead
     */ getParticleSystemByID(id) {
        return this.getParticleSystemById(id);
    }
    /**
     * Gets a geometry using its Id
     * @param id defines the geometry's Id
     * @returns the geometry or null if none found.
     * @deprecated Please use getGeometryById instead
     */ getGeometryByID(id) {
        return this.getGeometryById(id);
    }
    /**
     * Gets the first added mesh found of a given Id
     * @param id defines the Id to search for
     * @returns the mesh found or null if not found at all
     * @deprecated Please use getMeshById instead
     */ getMeshByID(id) {
        return this.getMeshById(id);
    }
    /**
     * Gets a mesh with its auto-generated unique Id
     * @param uniqueId defines the unique Id to search for
     * @returns the found mesh or null if not found at all.
     * @deprecated Please use getMeshByUniqueId instead
     */ getMeshByUniqueID(uniqueId) {
        return this.getMeshByUniqueId(uniqueId);
    }
    /**
     * Gets a the last added mesh using a given Id
     * @param id defines the Id to search for
     * @returns the found mesh or null if not found at all.
     * @deprecated Please use getLastMeshById instead
     */ getLastMeshByID(id) {
        return this.getLastMeshById(id);
    }
    /**
     * Gets a list of meshes using their Id
     * @param id defines the Id to search for
     * @returns a list of meshes
     * @deprecated Please use getMeshesById instead
     */ getMeshesByID(id) {
        return this.getMeshesById(id);
    }
    /**
     * Gets the first added transform node found of a given Id
     * @param id defines the Id to search for
     * @returns the found transform node or null if not found at all.
     * @deprecated Please use getTransformNodeById instead
     */ getTransformNodeByID(id) {
        return this.getTransformNodeById(id);
    }
    /**
     * Gets a transform node with its auto-generated unique Id
     * @param uniqueId defines the unique Id to search for
     * @returns the found transform node or null if not found at all.
     * @deprecated Please use getTransformNodeByUniqueId instead
     */ getTransformNodeByUniqueID(uniqueId) {
        return this.getTransformNodeByUniqueId(uniqueId);
    }
    /**
     * Gets a list of transform nodes using their Id
     * @param id defines the Id to search for
     * @returns a list of transform nodes
     * @deprecated Please use getTransformNodesById instead
     */ getTransformNodesByID(id) {
        return this.getTransformNodesById(id);
    }
    /**
     * Gets a node (Mesh, Camera, Light) using a given Id
     * @param id defines the Id to search for
     * @returns the found node or null if not found at all
     * @deprecated Please use getNodeById instead
     */ getNodeByID(id) {
        return this.getNodeById(id);
    }
    /**
     * Gets a the last added node (Mesh, Camera, Light) using a given Id
     * @param id defines the Id to search for
     * @returns the found node or null if not found at all
     * @deprecated Please use getLastEntryById instead
     */ getLastEntryByID(id) {
        return this.getLastEntryById(id);
    }
    /**
     * Gets a skeleton using a given Id (if many are found, this function will pick the last one)
     * @param id defines the Id to search for
     * @returns the found skeleton or null if not found at all.
     * @deprecated Please use getLastSkeletonById instead
     */ getLastSkeletonByID(id) {
        return this.getLastSkeletonById(id);
    }
}
/** The fog is deactivated */ $be87b65ec8caf46b$export$38af1803e3442a7f.FOGMODE_NONE = 0;
/** The fog density is following an exponential function */ $be87b65ec8caf46b$export$38af1803e3442a7f.FOGMODE_EXP = 1;
/** The fog density is following an exponential function faster than FOGMODE_EXP */ $be87b65ec8caf46b$export$38af1803e3442a7f.FOGMODE_EXP2 = 2;
/** The fog density is following a linear function. */ $be87b65ec8caf46b$export$38af1803e3442a7f.FOGMODE_LINEAR = 3;
/**
 * Gets or sets the minimum deltatime when deterministic lock step is enabled
 * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#deterministic-lockstep
 */ $be87b65ec8caf46b$export$38af1803e3442a7f.MinDeltaTime = 1.0;
/**
 * Gets or sets the maximum deltatime when deterministic lock step is enabled
 * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#deterministic-lockstep
 */ $be87b65ec8caf46b$export$38af1803e3442a7f.MaxDeltaTime = 1000.0;

});
parcelRegister("bOhSV", function(module, exports) {

$parcel$export(module.exports, "Tools", () => $89923ccd30e6d161$export$390d11d353c16e49);
$parcel$export(module.exports, "className", () => $89923ccd30e6d161$export$2913c0c0b5623090);
$parcel$export(module.exports, "AsyncLoop", () => $89923ccd30e6d161$export$867c188241b31f47);

var $diGQf = parcelRequire("diGQf");

var $jFz47 = parcelRequire("jFz47");

var $kVtWi = parcelRequire("kVtWi");

var $fhgis = parcelRequire("fhgis");

var $blHSI = parcelRequire("blHSI");

var $dUFYy = parcelRequire("dUFYy");

var $hUzEl = parcelRequire("hUzEl");

var $ejQPp = parcelRequire("ejQPp");

var $EOxw7 = parcelRequire("EOxw7");

var $av6Bc = parcelRequire("av6Bc");

var $i1moY = parcelRequire("i1moY");

var $321Uk = parcelRequire("321Uk");

var $wK2xc = parcelRequire("wK2xc");
class $89923ccd30e6d161$export$390d11d353c16e49 {
    /**
     * Gets or sets the base URL to use to load assets
     */ static get BaseUrl() {
        return (0, $EOxw7.FileToolsOptions).BaseUrl;
    }
    static set BaseUrl(value) {
        (0, $EOxw7.FileToolsOptions).BaseUrl = value;
    }
    /**
     * This function checks whether a URL is absolute or not.
     * It will also detect data and blob URLs
     * @param url the url to check
     * @returns is the url absolute or relative
     */ static IsAbsoluteUrl(url) {
        // See https://stackoverflow.com/a/38979205.
        // URL is protocol-relative (= absolute)
        if (url.indexOf("//") === 0) return true;
        // URL has no protocol (= relative)
        if (url.indexOf("://") === -1) return false;
        // URL does not contain a dot, i.e. no TLD (= relative, possibly REST)
        if (url.indexOf(".") === -1) return false;
        // URL does not contain a single slash (= relative)
        if (url.indexOf("/") === -1) return false;
        // The first colon comes after the first slash (= relative)
        if (url.indexOf(":") > url.indexOf("/")) return false;
        // Protocol is defined before first dot (= absolute)
        if (url.indexOf("://") < url.indexOf(".")) return true;
        if (url.indexOf("data:") === 0 || url.indexOf("blob:") === 0) return true;
        // Anything else must be relative
        return false;
    }
    /**
     * Sets the base URL to use to load scripts
     */ static set ScriptBaseUrl(value) {
        (0, $EOxw7.FileToolsOptions).ScriptBaseUrl = value;
    }
    static get ScriptBaseUrl() {
        return (0, $EOxw7.FileToolsOptions).ScriptBaseUrl;
    }
    /**
     * Sets a preprocessing function to run on a source URL before importing it
     * Note that this function will execute AFTER the base URL is appended to the URL
     */ static set ScriptPreprocessUrl(func) {
        (0, $EOxw7.FileToolsOptions).ScriptPreprocessUrl = func;
    }
    static get ScriptPreprocessUrl() {
        return (0, $EOxw7.FileToolsOptions).ScriptPreprocessUrl;
    }
    /**
     * Gets or sets the retry strategy to apply when an error happens while loading an asset
     */ static get DefaultRetryStrategy() {
        return (0, $EOxw7.FileToolsOptions).DefaultRetryStrategy;
    }
    static set DefaultRetryStrategy(strategy) {
        (0, $EOxw7.FileToolsOptions).DefaultRetryStrategy = strategy;
    }
    /**
     * Default behavior for cors in the application.
     * It can be a string if the expected behavior is identical in the entire app.
     * Or a callback to be able to set it per url or on a group of them (in case of Video source for instance)
     */ static get CorsBehavior() {
        return (0, $EOxw7.FileToolsOptions).CorsBehavior;
    }
    static set CorsBehavior(value) {
        (0, $EOxw7.FileToolsOptions).CorsBehavior = value;
    }
    /**
     * Gets or sets a global variable indicating if fallback texture must be used when a texture cannot be loaded
     * @ignorenaming
     */ static get UseFallbackTexture() {
        return (0, $ejQPp.EngineStore).UseFallbackTexture;
    }
    static set UseFallbackTexture(value) {
        (0, $ejQPp.EngineStore).UseFallbackTexture = value;
    }
    /**
     * Use this object to register external classes like custom textures or material
     * to allow the loaders to instantiate them
     */ static get RegisteredExternalClasses() {
        return (0, $i1moY.InstantiationTools).RegisteredExternalClasses;
    }
    static set RegisteredExternalClasses(classes) {
        (0, $i1moY.InstantiationTools).RegisteredExternalClasses = classes;
    }
    /**
     * Texture content used if a texture cannot loaded
     * @ignorenaming
     */ // eslint-disable-next-line @typescript-eslint/naming-convention
    static get fallbackTexture() {
        return (0, $ejQPp.EngineStore).FallbackTexture;
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    static set fallbackTexture(value) {
        (0, $ejQPp.EngineStore).FallbackTexture = value;
    }
    /**
     * Read the content of a byte array at a specified coordinates (taking in account wrapping)
     * @param u defines the coordinate on X axis
     * @param v defines the coordinate on Y axis
     * @param width defines the width of the source data
     * @param height defines the height of the source data
     * @param pixels defines the source byte array
     * @param color defines the output color
     */ static FetchToRef(u, v, width, height, pixels, color) {
        const wrappedU = Math.abs(u) * width % width | 0;
        const wrappedV = Math.abs(v) * height % height | 0;
        const position = (wrappedU + wrappedV * width) * 4;
        color.r = pixels[position] / 255;
        color.g = pixels[position + 1] / 255;
        color.b = pixels[position + 2] / 255;
        color.a = pixels[position + 3] / 255;
    }
    /**
     * Interpolates between a and b via alpha
     * @param a The lower value (returned when alpha = 0)
     * @param b The upper value (returned when alpha = 1)
     * @param alpha The interpolation-factor
     * @returns The mixed value
     */ static Mix(a, b, alpha) {
        return 0;
    }
    /**
     * Tries to instantiate a new object from a given class name
     * @param className defines the class name to instantiate
     * @returns the new object or null if the system was not able to do the instantiation
     */ static Instantiate(className) {
        return (0, $i1moY.InstantiationTools).Instantiate(className);
    }
    /**
     * Polyfill for setImmediate
     * @param action defines the action to execute after the current execution block
     */ static SetImmediate(action) {
        (0, $av6Bc.TimingTools).SetImmediate(action);
    }
    /**
     * Function indicating if a number is an exponent of 2
     * @param value defines the value to test
     * @returns true if the value is an exponent of 2
     */ static IsExponentOfTwo(value) {
        return true;
    }
    /**
     * Returns the nearest 32-bit single precision float representation of a Number
     * @param value A Number.  If the parameter is of a different type, it will get converted
     * to a number or to NaN if it cannot be converted
     * @returns number
     */ static FloatRound(value) {
        return Math.fround(value);
    }
    /**
     * Extracts the filename from a path
     * @param path defines the path to use
     * @returns the filename
     */ static GetFilename(path) {
        const index = path.lastIndexOf("/");
        if (index < 0) return path;
        return path.substring(index + 1);
    }
    /**
     * Extracts the "folder" part of a path (everything before the filename).
     * @param uri The URI to extract the info from
     * @param returnUnchangedIfNoSlash Do not touch the URI if no slashes are present
     * @returns The "folder" part of the path
     */ static GetFolderPath(uri, returnUnchangedIfNoSlash = false) {
        const index = uri.lastIndexOf("/");
        if (index < 0) {
            if (returnUnchangedIfNoSlash) return uri;
            return "";
        }
        return uri.substring(0, index + 1);
    }
    /**
     * Convert an angle in radians to degrees
     * @param angle defines the angle to convert
     * @returns the angle in degrees
     */ static ToDegrees(angle) {
        return angle * 180 / Math.PI;
    }
    /**
     * Convert an angle in degrees to radians
     * @param angle defines the angle to convert
     * @returns the angle in radians
     */ static ToRadians(angle) {
        return angle * Math.PI / 180;
    }
    /**
     * Smooth angle changes (kind of low-pass filter), in particular for device orientation "shaking"
     * Use trigonometric functions to avoid discontinuity (0/360, -180/180)
     * @param previousAngle defines last angle value, in degrees
     * @param newAngle defines new angle value, in degrees
     * @param smoothFactor defines smoothing sensitivity; min 0: no smoothing, max 1: new data ignored
     * @returns the angle in degrees
     */ static SmoothAngleChange(previousAngle, newAngle, smoothFactor = 0.9) {
        const previousAngleRad = this.ToRadians(previousAngle);
        const newAngleRad = this.ToRadians(newAngle);
        return this.ToDegrees(Math.atan2((1 - smoothFactor) * Math.sin(newAngleRad) + smoothFactor * Math.sin(previousAngleRad), (1 - smoothFactor) * Math.cos(newAngleRad) + smoothFactor * Math.cos(previousAngleRad)));
    }
    /**
     * Returns an array if obj is not an array
     * @param obj defines the object to evaluate as an array
     * @param allowsNullUndefined defines a boolean indicating if obj is allowed to be null or undefined
     * @returns either obj directly if obj is an array or a new array containing obj
     */ static MakeArray(obj, allowsNullUndefined) {
        if (allowsNullUndefined !== true && (obj === undefined || obj == null)) return null;
        return Array.isArray(obj) ? obj : [
            obj
        ];
    }
    /**
     * Gets the pointer prefix to use
     * @param engine defines the engine we are finding the prefix for
     * @returns "pointer" if touch is enabled. Else returns "mouse"
     */ static GetPointerPrefix(engine) {
        let eventPrefix = "pointer";
        // Check if pointer events are supported
        if ((0, $jFz47.IsWindowObjectExist)() && !window.PointerEvent) eventPrefix = "mouse";
        // Special Fallback MacOS Safari...
        if (engine._badDesktopOS && !engine._badOS && // And not ipad pros who claim to be macs...
        !(document && "ontouchend" in document)) eventPrefix = "mouse";
        return eventPrefix;
    }
    /**
     * Sets the cors behavior on a dom element. This will add the required Tools.CorsBehavior to the element.
     * @param url define the url we are trying
     * @param element define the dom element where to configure the cors policy
     * @param element.crossOrigin
     */ static SetCorsBehavior(url, element) {
        (0, $EOxw7.SetCorsBehavior)(url, element);
    }
    /**
     * Sets the referrerPolicy behavior on a dom element.
     * @param referrerPolicy define the referrer policy to use
     * @param element define the dom element where to configure the referrer policy
     * @param element.referrerPolicy
     */ static SetReferrerPolicyBehavior(referrerPolicy, element) {
        element.referrerPolicy = referrerPolicy;
    }
    // External files
    /**
     * Removes unwanted characters from an url
     * @param url defines the url to clean
     * @returns the cleaned url
     */ static CleanUrl(url) {
        url = url.replace(/#/gm, "%23");
        return url;
    }
    /**
     * Gets or sets a function used to pre-process url before using them to load assets
     */ static get PreprocessUrl() {
        return (0, $EOxw7.FileToolsOptions).PreprocessUrl;
    }
    static set PreprocessUrl(processor) {
        (0, $EOxw7.FileToolsOptions).PreprocessUrl = processor;
    }
    /**
     * Loads an image as an HTMLImageElement.
     * @param input url string, ArrayBuffer, or Blob to load
     * @param onLoad callback called when the image successfully loads
     * @param onError callback called when the image fails to load
     * @param offlineProvider offline provider for caching
     * @param mimeType optional mime type
     * @param imageBitmapOptions optional the options to use when creating an ImageBitmap
     * @returns the HTMLImageElement of the loaded image
     */ static LoadImage(input, onLoad, onError, offlineProvider, mimeType, imageBitmapOptions) {
        return (0, $EOxw7.LoadImage)(input, onLoad, onError, offlineProvider, mimeType, imageBitmapOptions);
    }
    /**
     * Loads a file from a url
     * @param url url string, ArrayBuffer, or Blob to load
     * @param onSuccess callback called when the file successfully loads
     * @param onProgress callback called while file is loading (if the server supports this mode)
     * @param offlineProvider defines the offline provider for caching
     * @param useArrayBuffer defines a boolean indicating that date must be returned as ArrayBuffer
     * @param onError callback called when the file fails to load
     * @returns a file request object
     */ static LoadFile(url, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError) {
        return (0, $EOxw7.LoadFile)(url, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError);
    }
    /**
     * Loads a file from a url
     * @param url the file url to load
     * @param useArrayBuffer defines a boolean indicating that date must be returned as ArrayBuffer
     * @returns a promise containing an ArrayBuffer corresponding to the loaded file
     */ static LoadFileAsync(url, useArrayBuffer = true) {
        return new Promise((resolve, reject)=>{
            (0, $EOxw7.LoadFile)(url, (data)=>{
                resolve(data);
            }, undefined, undefined, useArrayBuffer, (request, exception)=>{
                reject(exception);
            });
        });
    }
    /**
     * Get a script URL including preprocessing
     * @param scriptUrl the script Url to process
     * @param forceAbsoluteUrl force the script to be an absolute url (adding the current base url if necessary)
     * @returns a modified URL to use
     */ static GetBabylonScriptURL(scriptUrl, forceAbsoluteUrl) {
        if (!scriptUrl) return "";
        // if the base URL was set, and the script Url is an absolute path change the default path
        if ($89923ccd30e6d161$export$390d11d353c16e49.ScriptBaseUrl && scriptUrl.startsWith($89923ccd30e6d161$export$390d11d353c16e49._DefaultCdnUrl)) {
            // change the default host, which is https://cdn.babylonjs.com with the one defined
            // make sure no trailing slash is present
            const baseUrl = $89923ccd30e6d161$export$390d11d353c16e49.ScriptBaseUrl[$89923ccd30e6d161$export$390d11d353c16e49.ScriptBaseUrl.length - 1] === "/" ? $89923ccd30e6d161$export$390d11d353c16e49.ScriptBaseUrl.substring(0, $89923ccd30e6d161$export$390d11d353c16e49.ScriptBaseUrl.length - 1) : $89923ccd30e6d161$export$390d11d353c16e49.ScriptBaseUrl;
            scriptUrl = scriptUrl.replace($89923ccd30e6d161$export$390d11d353c16e49._DefaultCdnUrl, baseUrl);
        }
        // run the preprocessor
        scriptUrl = $89923ccd30e6d161$export$390d11d353c16e49.ScriptPreprocessUrl(scriptUrl);
        if (forceAbsoluteUrl) scriptUrl = $89923ccd30e6d161$export$390d11d353c16e49.GetAbsoluteUrl(scriptUrl);
        return scriptUrl;
    }
    /**
     * This function is used internally by babylon components to load a script (identified by an url). When the url returns, the
     * content of this file is added into a new script element, attached to the DOM (body element)
     * @param scriptUrl defines the url of the script to load
     * @param onSuccess defines the callback called when the script is loaded
     * @param onError defines the callback to call if an error occurs
     * @param scriptId defines the id of the script element
     */ static LoadBabylonScript(scriptUrl, onSuccess, onError, scriptId) {
        scriptUrl = $89923ccd30e6d161$export$390d11d353c16e49.GetBabylonScriptURL(scriptUrl);
        $89923ccd30e6d161$export$390d11d353c16e49.LoadScript(scriptUrl, onSuccess, onError);
    }
    /**
     * Load an asynchronous script (identified by an url). When the url returns, the
     * content of this file is added into a new script element, attached to the DOM (body element)
     * @param scriptUrl defines the url of the script to laod
     * @returns a promise request object
     */ static LoadBabylonScriptAsync(scriptUrl) {
        scriptUrl = $89923ccd30e6d161$export$390d11d353c16e49.GetBabylonScriptURL(scriptUrl);
        return $89923ccd30e6d161$export$390d11d353c16e49.LoadScriptAsync(scriptUrl);
    }
    /**
     * This function is used internally by babylon components to load a script (identified by an url). When the url returns, the
     * content of this file is added into a new script element, attached to the DOM (body element)
     * @param scriptUrl defines the url of the script to load
     * @param onSuccess defines the callback called when the script is loaded
     * @param onError defines the callback to call if an error occurs
     * @param scriptId defines the id of the script element
     */ static LoadScript(scriptUrl, onSuccess, onError, scriptId) {
        if (typeof importScripts === "function") {
            try {
                importScripts(scriptUrl);
                onSuccess();
            } catch (e) {
                onError?.(`Unable to load script '${scriptUrl}' in worker`, e);
            }
            return;
        } else if (!(0, $jFz47.IsWindowObjectExist)()) {
            onError?.(`Cannot load script '${scriptUrl}' outside of a window or a worker`);
            return;
        }
        const head = document.getElementsByTagName("head")[0];
        const script = document.createElement("script");
        script.setAttribute("type", "text/javascript");
        script.setAttribute("src", scriptUrl);
        if (scriptId) script.id = scriptId;
        script.onload = ()=>{
            if (onSuccess) onSuccess();
        };
        script.onerror = (e)=>{
            if (onError) onError(`Unable to load script '${scriptUrl}'`, e);
        };
        head.appendChild(script);
    }
    /**
     * Load an asynchronous script (identified by an url). When the url returns, the
     * content of this file is added into a new script element, attached to the DOM (body element)
     * @param scriptUrl defines the url of the script to load
     * @param scriptId defines the id of the script element
     * @returns a promise request object
     */ static LoadScriptAsync(scriptUrl, scriptId) {
        return new Promise((resolve, reject)=>{
            this.LoadScript(scriptUrl, ()=>{
                resolve();
            }, (message, exception)=>{
                reject(exception || new Error(message));
            }, scriptId);
        });
    }
    /**
     * Loads a file from a blob
     * @param fileToLoad defines the blob to use
     * @param callback defines the callback to call when data is loaded
     * @param progressCallback defines the callback to call during loading process
     * @returns a file request object
     */ static ReadFileAsDataURL(fileToLoad, callback, progressCallback) {
        const reader = new FileReader();
        const request = {
            onCompleteObservable: new (0, $diGQf.Observable)(),
            abort: ()=>reader.abort()
        };
        reader.onloadend = ()=>{
            request.onCompleteObservable.notifyObservers(request);
        };
        reader.onload = (e)=>{
            //target doesn't have result from ts 1.3
            callback(e.target["result"]);
        };
        reader.onprogress = progressCallback;
        reader.readAsDataURL(fileToLoad);
        return request;
    }
    /**
     * Reads a file from a File object
     * @param file defines the file to load
     * @param onSuccess defines the callback to call when data is loaded
     * @param onProgress defines the callback to call during loading process
     * @param useArrayBuffer defines a boolean indicating that data must be returned as an ArrayBuffer
     * @param onError defines the callback to call when an error occurs
     * @returns a file request object
     */ static ReadFile(file, onSuccess, onProgress, useArrayBuffer, onError) {
        return (0, $EOxw7.ReadFile)(file, onSuccess, onProgress, useArrayBuffer, onError);
    }
    /**
     * Creates a data url from a given string content
     * @param content defines the content to convert
     * @returns the new data url link
     */ static FileAsURL(content) {
        const fileBlob = new Blob([
            content
        ]);
        const url = window.URL;
        const link = url.createObjectURL(fileBlob);
        return link;
    }
    /**
     * Format the given number to a specific decimal format
     * @param value defines the number to format
     * @param decimals defines the number of decimals to use
     * @returns the formatted string
     */ static Format(value, decimals = 2) {
        return value.toFixed(decimals);
    }
    /**
     * Tries to copy an object by duplicating every property
     * @param source defines the source object
     * @param destination defines the target object
     * @param doNotCopyList defines a list of properties to avoid
     * @param mustCopyList defines a list of properties to copy (even if they start with _)
     */ static DeepCopy(source, destination, doNotCopyList, mustCopyList) {
        (0, $fhgis.DeepCopier).DeepCopy(source, destination, doNotCopyList, mustCopyList);
    }
    /**
     * Gets a boolean indicating if the given object has no own property
     * @param obj defines the object to test
     * @returns true if object has no own property
     */ static IsEmpty(obj) {
        for(const i in obj){
            if (Object.prototype.hasOwnProperty.call(obj, i)) return false;
        }
        return true;
    }
    /**
     * Function used to register events at window level
     * @param windowElement defines the Window object to use
     * @param events defines the events to register
     */ static RegisterTopRootEvents(windowElement, events) {
        for(let index = 0; index < events.length; index++){
            const event = events[index];
            windowElement.addEventListener(event.name, event.handler, false);
            try {
                if (window.parent) window.parent.addEventListener(event.name, event.handler, false);
            } catch (e) {
            // Silently fails...
            }
        }
    }
    /**
     * Function used to unregister events from window level
     * @param windowElement defines the Window object to use
     * @param events defines the events to unregister
     */ static UnregisterTopRootEvents(windowElement, events) {
        for(let index = 0; index < events.length; index++){
            const event = events[index];
            windowElement.removeEventListener(event.name, event.handler);
            try {
                if (windowElement.parent) windowElement.parent.removeEventListener(event.name, event.handler);
            } catch (e) {
            // Silently fails...
            }
        }
    }
    /**
     * Dumps the current bound framebuffer
     * @param width defines the rendering width
     * @param height defines the rendering height
     * @param engine defines the hosting engine
     * @param successCallback defines the callback triggered once the data are available
     * @param mimeType defines the mime type of the result
     * @param fileName defines the filename to download. If present, the result will automatically be downloaded
     * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
     * @returns a void promise
     */ static async DumpFramebuffer(width, height, engine, successCallback, mimeType = "image/png", fileName, quality) {
        throw (0, $dUFYy._WarnImport)("DumpTools");
    }
    /**
     * Dumps an array buffer
     * @param width defines the rendering width
     * @param height defines the rendering height
     * @param data the data array
     * @param successCallback defines the callback triggered once the data are available
     * @param mimeType defines the mime type of the result
     * @param fileName defines the filename to download. If present, the result will automatically be downloaded
     * @param invertY true to invert the picture in the Y dimension
     * @param toArrayBuffer true to convert the data to an ArrayBuffer (encoded as `mimeType`) instead of a base64 string
     * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
     */ static DumpData(width, height, data, successCallback, mimeType = "image/png", fileName, invertY = false, toArrayBuffer = false, quality) {
        throw (0, $dUFYy._WarnImport)("DumpTools");
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Dumps an array buffer
     * @param width defines the rendering width
     * @param height defines the rendering height
     * @param data the data array
     * @param mimeType defines the mime type of the result
     * @param fileName defines the filename to download. If present, the result will automatically be downloaded
     * @param invertY true to invert the picture in the Y dimension
     * @param toArrayBuffer true to convert the data to an ArrayBuffer (encoded as `mimeType`) instead of a base64 string
     * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
     * @returns a promise that resolve to the final data
     */ static DumpDataAsync(width, height, data, mimeType = "image/png", fileName, invertY = false, toArrayBuffer = false, quality) {
        throw (0, $dUFYy._WarnImport)("DumpTools");
    }
    static _IsOffScreenCanvas(canvas) {
        return canvas.convertToBlob !== undefined;
    }
    /**
     * Converts the canvas data to blob.
     * This acts as a polyfill for browsers not supporting the to blob function.
     * @param canvas Defines the canvas to extract the data from (can be an offscreen canvas)
     * @param successCallback Defines the callback triggered once the data are available
     * @param mimeType Defines the mime type of the result
     * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
     */ static ToBlob(canvas, successCallback, mimeType = "image/png", quality) {
        // We need HTMLCanvasElement.toBlob for HD screenshots
        if (!$89923ccd30e6d161$export$390d11d353c16e49._IsOffScreenCanvas(canvas) && !canvas.toBlob) //  low performance polyfill based on toDataURL (https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob)
        canvas.toBlob = function(callback, type, quality) {
            setTimeout(()=>{
                const binStr = atob(this.toDataURL(type, quality).split(",")[1]), len = binStr.length, arr = new Uint8Array(len);
                for(let i = 0; i < len; i++)arr[i] = binStr.charCodeAt(i);
                callback(new Blob([
                    arr
                ]));
            });
        };
        if ($89923ccd30e6d161$export$390d11d353c16e49._IsOffScreenCanvas(canvas)) canvas.convertToBlob({
            type: mimeType,
            quality: quality
        }).then((blob)=>successCallback(blob));
        else canvas.toBlob(function(blob) {
            successCallback(blob);
        }, mimeType, quality);
    }
    /**
     * Download a Blob object
     * @param blob the Blob object
     * @param fileName the file name to download
     */ static DownloadBlob(blob, fileName) {
        //Creating a link if the browser have the download attribute on the a tag, to automatically start download generated image.
        if ("download" in document.createElement("a")) {
            if (!fileName) {
                const date = new Date();
                const stringDate = (date.getFullYear() + "-" + (date.getMonth() + 1)).slice(2) + "-" + date.getDate() + "_" + date.getHours() + "-" + ("0" + date.getMinutes()).slice(-2);
                fileName = "screenshot_" + stringDate + ".png";
            }
            $89923ccd30e6d161$export$390d11d353c16e49.Download(blob, fileName);
        } else if (blob && typeof URL !== "undefined") {
            const url = URL.createObjectURL(blob);
            const newWindow = window.open("");
            if (!newWindow) return;
            const img = newWindow.document.createElement("img");
            img.onload = function() {
                // no longer need to read the blob so it's revoked
                URL.revokeObjectURL(url);
            };
            img.src = url;
            newWindow.document.body.appendChild(img);
        }
    }
    /**
     * Encodes the canvas data to base 64, or automatically downloads the result if `fileName` is defined.
     * @param canvas The canvas to get the data from, which can be an offscreen canvas.
     * @param successCallback The callback which is triggered once the data is available. If `fileName` is defined, the callback will be invoked after the download occurs, and the `data` argument will be an empty string.
     * @param mimeType The mime type of the result.
     * @param fileName The name of the file to download. If defined, the result will automatically be downloaded. If not defined, and `successCallback` is also not defined, the result will automatically be downloaded with an auto-generated file name.
     * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
     */ static EncodeScreenshotCanvasData(canvas, successCallback, mimeType = "image/png", fileName, quality) {
        if (typeof fileName === "string" || !successCallback) this.ToBlob(canvas, function(blob) {
            if (blob) $89923ccd30e6d161$export$390d11d353c16e49.DownloadBlob(blob, fileName);
            if (successCallback) successCallback("");
        }, mimeType, quality);
        else if (successCallback) {
            if ($89923ccd30e6d161$export$390d11d353c16e49._IsOffScreenCanvas(canvas)) {
                canvas.convertToBlob({
                    type: mimeType,
                    quality: quality
                }).then((blob)=>{
                    const reader = new FileReader();
                    reader.readAsDataURL(blob);
                    reader.onloadend = ()=>{
                        const base64data = reader.result;
                        successCallback(base64data);
                    };
                });
                return;
            }
            const base64Image = canvas.toDataURL(mimeType, quality);
            successCallback(base64Image);
        }
    }
    /**
     * Downloads a blob in the browser
     * @param blob defines the blob to download
     * @param fileName defines the name of the downloaded file
     */ static Download(blob, fileName) {
        if (typeof URL === "undefined") return;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.style.display = "none";
        a.href = url;
        a.download = fileName;
        a.addEventListener("click", ()=>{
            if (a.parentElement) a.parentElement.removeChild(a);
        });
        a.click();
        window.URL.revokeObjectURL(url);
    }
    /**
     * Will return the right value of the noPreventDefault variable
     * Needed to keep backwards compatibility to the old API.
     *
     * @param args arguments passed to the attachControl function
     * @returns the correct value for noPreventDefault
     */ static BackCompatCameraNoPreventDefault(args) {
        // is it used correctly?
        if (typeof args[0] === "boolean") return args[0];
        else if (typeof args[1] === "boolean") return args[1];
        return false;
    }
    /**
     * Captures a screenshot of the current rendering
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/renderToPNG
     * @param engine defines the rendering engine
     * @param camera defines the source camera
     * @param size This parameter can be set to a single number or to an object with the
     * following (optional) properties: precision, width, height. If a single number is passed,
     * it will be used for both width and height. If an object is passed, the screenshot size
     * will be derived from the parameters. The precision property is a multiplier allowing
     * rendering at a higher or lower resolution
     * @param successCallback defines the callback receives a single parameter which contains the
     * screenshot as a string of base64-encoded characters. This string can be assigned to the
     * src parameter of an <img> to display it
     * @param mimeType defines the MIME type of the screenshot image (default: image/png).
     * Check your browser for supported MIME types
     * @param forceDownload force the system to download the image even if a successCallback is provided
     * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    static CreateScreenshot(engine, camera, size, successCallback, mimeType = "image/png", forceDownload = false, quality) {
        throw (0, $dUFYy._WarnImport)("ScreenshotTools");
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Captures a screenshot of the current rendering
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/renderToPNG
     * @param engine defines the rendering engine
     * @param camera defines the source camera
     * @param size This parameter can be set to a single number or to an object with the
     * following (optional) properties: precision, width, height. If a single number is passed,
     * it will be used for both width and height. If an object is passed, the screenshot size
     * will be derived from the parameters. The precision property is a multiplier allowing
     * rendering at a higher or lower resolution
     * @param mimeType defines the MIME type of the screenshot image (default: image/png).
     * Check your browser for supported MIME types
     * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
     * @returns screenshot as a string of base64-encoded characters. This string can be assigned
     * to the src parameter of an <img> to display it
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    static CreateScreenshotAsync(engine, camera, size, mimeType = "image/png", quality) {
        throw (0, $dUFYy._WarnImport)("ScreenshotTools");
    }
    /**
     * Generates an image screenshot from the specified camera.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/renderToPNG
     * @param engine The engine to use for rendering
     * @param camera The camera to use for rendering
     * @param size This parameter can be set to a single number or to an object with the
     * following (optional) properties: precision, width, height. If a single number is passed,
     * it will be used for both width and height. If an object is passed, the screenshot size
     * will be derived from the parameters. The precision property is a multiplier allowing
     * rendering at a higher or lower resolution
     * @param successCallback The callback receives a single parameter which contains the
     * screenshot as a string of base64-encoded characters. This string can be assigned to the
     * src parameter of an <img> to display it
     * @param mimeType The MIME type of the screenshot image (default: image/png).
     * Check your browser for supported MIME types
     * @param samples Texture samples (default: 1)
     * @param antialiasing Whether antialiasing should be turned on or not (default: false)
     * @param fileName A name for for the downloaded file.
     * @param renderSprites Whether the sprites should be rendered or not (default: false)
     * @param enableStencilBuffer Whether the stencil buffer should be enabled or not (default: false)
     * @param useLayerMask if the camera's layer mask should be used to filter what should be rendered (default: true)
     * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    static CreateScreenshotUsingRenderTarget(engine, camera, size, successCallback, mimeType = "image/png", samples = 1, antialiasing = false, fileName, renderSprites = false, enableStencilBuffer = false, useLayerMask = true, quality) {
        throw (0, $dUFYy._WarnImport)("ScreenshotTools");
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Generates an image screenshot from the specified camera.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/renderToPNG
     * @param engine The engine to use for rendering
     * @param camera The camera to use for rendering
     * @param size This parameter can be set to a single number or to an object with the
     * following (optional) properties: precision, width, height. If a single number is passed,
     * it will be used for both width and height. If an object is passed, the screenshot size
     * will be derived from the parameters. The precision property is a multiplier allowing
     * rendering at a higher or lower resolution
     * @param mimeType The MIME type of the screenshot image (default: image/png).
     * Check your browser for supported MIME types
     * @param samples Texture samples (default: 1)
     * @param antialiasing Whether antialiasing should be turned on or not (default: false)
     * @param fileName A name for for the downloaded file.
     * @returns screenshot as a string of base64-encoded characters. This string can be assigned
     * @param renderSprites Whether the sprites should be rendered or not (default: false)
     * @param enableStencilBuffer Whether the stencil buffer should be enabled or not (default: false)
     * @param useLayerMask if the camera's layer mask should be used to filter what should be rendered (default: true)
     * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
     * to the src parameter of an <img> to display it
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    static CreateScreenshotUsingRenderTargetAsync(engine, camera, size, mimeType = "image/png", samples = 1, antialiasing = false, fileName, renderSprites = false, enableStencilBuffer = false, useLayerMask = true, quality) {
        throw (0, $dUFYy._WarnImport)("ScreenshotTools");
    }
    /**
     * Implementation from http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#answer-2117523
     * Be aware Math.random() could cause collisions, but:
     * "All but 6 of the 128 bits of the ID are randomly generated, which means that for any two ids, there's a 1 in 2^^122 (or 5.3x10^^36) chance they'll collide"
     * @returns a pseudo random id
     */ static RandomId() {
        return (0, $321Uk.RandomGUID)();
    }
    /**
     * Test if the given uri is a base64 string
     * @deprecated Please use FileTools.IsBase64DataUrl instead.
     * @param uri The uri to test
     * @returns True if the uri is a base64 string or false otherwise
     */ static IsBase64(uri) {
        return (0, $EOxw7.IsBase64DataUrl)(uri);
    }
    /**
     * Decode the given base64 uri.
     * @deprecated Please use FileTools.DecodeBase64UrlToBinary instead.
     * @param uri The uri to decode
     * @returns The decoded base64 data.
     */ static DecodeBase64(uri) {
        return (0, $EOxw7.DecodeBase64UrlToBinary)(uri);
    }
    /**
     * Gets a value indicating the number of loading errors
     * @ignorenaming
     */ // eslint-disable-next-line @typescript-eslint/naming-convention
    static get errorsCount() {
        return (0, $kVtWi.Logger).errorsCount;
    }
    /**
     * Log a message to the console
     * @param message defines the message to log
     */ static Log(message) {
        (0, $kVtWi.Logger).Log(message);
    }
    /**
     * Write a warning message to the console
     * @param message defines the message to log
     */ static Warn(message) {
        (0, $kVtWi.Logger).Warn(message);
    }
    /**
     * Write an error message to the console
     * @param message defines the message to log
     */ static Error(message) {
        (0, $kVtWi.Logger).Error(message);
    }
    /**
     * Gets current log cache (list of logs)
     */ static get LogCache() {
        return (0, $kVtWi.Logger).LogCache;
    }
    /**
     * Clears the log cache
     */ static ClearLogCache() {
        (0, $kVtWi.Logger).ClearLogCache();
    }
    /**
     * Sets the current log level (MessageLogLevel / WarningLogLevel / ErrorLogLevel)
     */ static set LogLevels(level) {
        (0, $kVtWi.Logger).LogLevels = level;
    }
    /**
     * Sets the current performance log level
     */ static set PerformanceLogLevel(level) {
        if ((level & $89923ccd30e6d161$export$390d11d353c16e49.PerformanceUserMarkLogLevel) === $89923ccd30e6d161$export$390d11d353c16e49.PerformanceUserMarkLogLevel) {
            $89923ccd30e6d161$export$390d11d353c16e49.StartPerformanceCounter = $89923ccd30e6d161$export$390d11d353c16e49._StartUserMark;
            $89923ccd30e6d161$export$390d11d353c16e49.EndPerformanceCounter = $89923ccd30e6d161$export$390d11d353c16e49._EndUserMark;
            return;
        }
        if ((level & $89923ccd30e6d161$export$390d11d353c16e49.PerformanceConsoleLogLevel) === $89923ccd30e6d161$export$390d11d353c16e49.PerformanceConsoleLogLevel) {
            $89923ccd30e6d161$export$390d11d353c16e49.StartPerformanceCounter = $89923ccd30e6d161$export$390d11d353c16e49._StartPerformanceConsole;
            $89923ccd30e6d161$export$390d11d353c16e49.EndPerformanceCounter = $89923ccd30e6d161$export$390d11d353c16e49._EndPerformanceConsole;
            return;
        }
        $89923ccd30e6d161$export$390d11d353c16e49.StartPerformanceCounter = $89923ccd30e6d161$export$390d11d353c16e49._StartPerformanceCounterDisabled;
        $89923ccd30e6d161$export$390d11d353c16e49.EndPerformanceCounter = $89923ccd30e6d161$export$390d11d353c16e49._EndPerformanceCounterDisabled;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    static _StartPerformanceCounterDisabled(counterName, condition) {}
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    static _EndPerformanceCounterDisabled(counterName, condition) {}
    static _StartUserMark(counterName, condition = true) {
        if (!$89923ccd30e6d161$export$390d11d353c16e49._Performance) {
            if (!(0, $jFz47.IsWindowObjectExist)()) return;
            $89923ccd30e6d161$export$390d11d353c16e49._Performance = window.performance;
        }
        if (!condition || !$89923ccd30e6d161$export$390d11d353c16e49._Performance.mark) return;
        $89923ccd30e6d161$export$390d11d353c16e49._Performance.mark(counterName + "-Begin");
    }
    static _EndUserMark(counterName, condition = true) {
        if (!condition || !$89923ccd30e6d161$export$390d11d353c16e49._Performance.mark) return;
        $89923ccd30e6d161$export$390d11d353c16e49._Performance.mark(counterName + "-End");
        $89923ccd30e6d161$export$390d11d353c16e49._Performance.measure(counterName, counterName + "-Begin", counterName + "-End");
    }
    static _StartPerformanceConsole(counterName, condition = true) {
        if (!condition) return;
        $89923ccd30e6d161$export$390d11d353c16e49._StartUserMark(counterName, condition);
        if (console.time) console.time(counterName);
    }
    static _EndPerformanceConsole(counterName, condition = true) {
        if (!condition) return;
        $89923ccd30e6d161$export$390d11d353c16e49._EndUserMark(counterName, condition);
        console.timeEnd(counterName);
    }
    /**
     * Gets either window.performance.now() if supported or Date.now() else
     */ static get Now() {
        return (0, $blHSI.PrecisionDate).Now;
    }
    /**
     * This method will return the name of the class used to create the instance of the given object.
     * It will works only on Javascript basic data types (number, string, ...) and instance of class declared with the @className decorator.
     * @param object the object to get the class name from
     * @param isType defines if the object is actually a type
     * @returns the name of the class, will be "object" for a custom data type not using the @className decorator
     */ static GetClassName(object, isType = false) {
        let name = null;
        if (!isType && object.getClassName) name = object.getClassName();
        else {
            if (object instanceof Object) {
                const classObj = isType ? object : Object.getPrototypeOf(object);
                name = classObj.constructor["__bjsclassName__"];
            }
            if (!name) name = typeof object;
        }
        return name;
    }
    /**
     * Gets the first element of an array satisfying a given predicate
     * @param array defines the array to browse
     * @param predicate defines the predicate to use
     * @returns null if not found or the element
     */ static First(array, predicate) {
        for (const el of array){
            if (predicate(el)) return el;
        }
        return null;
    }
    /**
     * This method will return the name of the full name of the class, including its owning module (if any).
     * It will works only on Javascript basic data types (number, string, ...) and instance of class declared with the @className decorator or implementing a method getClassName():string (in which case the module won't be specified).
     * @param object the object to get the class name from
     * @param isType defines if the object is actually a type
     * @returns a string that can have two forms: "moduleName.className" if module was specified when the class' Name was registered or "className" if there was not module specified.
     * @ignorenaming
     */ // eslint-disable-next-line @typescript-eslint/naming-convention
    static getFullClassName(object, isType = false) {
        let className = null;
        let moduleName = null;
        if (!isType && object.getClassName) className = object.getClassName();
        else {
            if (object instanceof Object) {
                const classObj = isType ? object : Object.getPrototypeOf(object);
                className = classObj.constructor["__bjsclassName__"];
                moduleName = classObj.constructor["__bjsmoduleName__"];
            }
            if (!className) className = typeof object;
        }
        if (!className) return null;
        return (moduleName != null ? moduleName + "." : "") + className;
    }
    /**
     * Returns a promise that resolves after the given amount of time.
     * @param delay Number of milliseconds to delay
     * @returns Promise that resolves after the given amount of time
     */ static DelayAsync(delay) {
        return new Promise((resolve)=>{
            setTimeout(()=>{
                resolve();
            }, delay);
        });
    }
    /**
     * Utility function to detect if the current user agent is Safari
     * @returns whether or not the current user agent is safari
     */ static IsSafari() {
        if (!(0, $jFz47.IsNavigatorAvailable)()) return false;
        return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    }
}
/**
 * Enable/Disable Custom HTTP Request Headers globally.
 * default = false
 * @see CustomRequestHeaders
 */ $89923ccd30e6d161$export$390d11d353c16e49.UseCustomRequestHeaders = false;
/**
 * Custom HTTP Request Headers to be sent with XMLHttpRequests
 * i.e. when loading files, where the server/service expects an Authorization header
 */ $89923ccd30e6d161$export$390d11d353c16e49.CustomRequestHeaders = (0, $hUzEl.WebRequest).CustomRequestHeaders;
/**
 * Extracts text content from a DOM element hierarchy
 * Back Compat only, please use GetDOMTextContent instead.
 */ $89923ccd30e6d161$export$390d11d353c16e49.GetDOMTextContent = (0, $jFz47.GetDOMTextContent);
/**
 * @internal
 */ $89923ccd30e6d161$export$390d11d353c16e49._DefaultCdnUrl = "https://cdn.babylonjs.com";
// eslint-disable-next-line jsdoc/require-returns-check, jsdoc/require-param
/**
 * @returns the absolute URL of a given (relative) url
 */ $89923ccd30e6d161$export$390d11d353c16e49.GetAbsoluteUrl = typeof document === "object" ? (url)=>{
    const a = document.createElement("a");
    a.href = url;
    return a.href;
} : typeof URL === "function" && typeof location === "object" ? (url)=>new URL(url, location.origin).href : ()=>{
    throw new Error("Unable to get absolute URL. Override BABYLON.Tools.GetAbsoluteUrl to a custom implementation for the current context.");
};
// Logs
/**
 * No log
 */ $89923ccd30e6d161$export$390d11d353c16e49.NoneLogLevel = (0, $kVtWi.Logger).NoneLogLevel;
/**
 * Only message logs
 */ $89923ccd30e6d161$export$390d11d353c16e49.MessageLogLevel = (0, $kVtWi.Logger).MessageLogLevel;
/**
 * Only warning logs
 */ $89923ccd30e6d161$export$390d11d353c16e49.WarningLogLevel = (0, $kVtWi.Logger).WarningLogLevel;
/**
 * Only error logs
 */ $89923ccd30e6d161$export$390d11d353c16e49.ErrorLogLevel = (0, $kVtWi.Logger).ErrorLogLevel;
/**
 * All logs
 */ $89923ccd30e6d161$export$390d11d353c16e49.AllLogLevel = (0, $kVtWi.Logger).AllLogLevel;
/**
 * Checks if the window object exists
 * Back Compat only, please use IsWindowObjectExist instead.
 */ $89923ccd30e6d161$export$390d11d353c16e49.IsWindowObjectExist = (0, $jFz47.IsWindowObjectExist);
// Performances
/**
 * No performance log
 */ $89923ccd30e6d161$export$390d11d353c16e49.PerformanceNoneLogLevel = 0;
/**
 * Use user marks to log performance
 */ $89923ccd30e6d161$export$390d11d353c16e49.PerformanceUserMarkLogLevel = 1;
/**
 * Log performance to the console
 */ $89923ccd30e6d161$export$390d11d353c16e49.PerformanceConsoleLogLevel = 2;
/**
 * Starts a performance counter
 */ $89923ccd30e6d161$export$390d11d353c16e49.StartPerformanceCounter = $89923ccd30e6d161$export$390d11d353c16e49._StartPerformanceCounterDisabled;
/**
 * Ends a specific performance counter
 */ $89923ccd30e6d161$export$390d11d353c16e49.EndPerformanceCounter = $89923ccd30e6d161$export$390d11d353c16e49._EndPerformanceCounterDisabled;
function $89923ccd30e6d161$export$2913c0c0b5623090(name, module) {
    return (target)=>{
        target["__bjsclassName__"] = name;
        target["__bjsmoduleName__"] = module != null ? module : null;
    };
}
class $89923ccd30e6d161$export$867c188241b31f47 {
    /**
     * Constructor.
     * @param iterations the number of iterations.
     * @param func the function to run each iteration
     * @param successCallback the callback that will be called upon successful execution
     * @param offset starting offset.
     */ constructor(/**
     * Defines the number of iterations for the loop
     */ iterations, func, successCallback, offset = 0){
        this.iterations = iterations;
        this.index = offset - 1;
        this._done = false;
        this._fn = func;
        this._successCallback = successCallback;
    }
    /**
     * Execute the next iteration. Must be called after the last iteration was finished.
     */ executeNext() {
        if (!this._done) {
            if (this.index + 1 < this.iterations) {
                ++this.index;
                this._fn(this);
            } else this.breakLoop();
        }
    }
    /**
     * Break the loop and run the success callback.
     */ breakLoop() {
        this._done = true;
        this._successCallback();
    }
    /**
     * Create and run an async loop.
     * @param iterations the number of iterations.
     * @param fn the function to run each iteration
     * @param successCallback the callback that will be called upon successful execution
     * @param offset starting offset.
     * @returns the created async loop object
     */ static Run(iterations, fn, successCallback, offset = 0) {
        const loop = new $89923ccd30e6d161$export$867c188241b31f47(iterations, fn, successCallback, offset);
        loop.executeNext();
        return loop;
    }
    /**
     * A for-loop that will run a given number of iterations synchronous and the rest async.
     * @param iterations total number of iterations
     * @param syncedIterations number of synchronous iterations in each async iteration.
     * @param fn the function to call each iteration.
     * @param callback a success call back that will be called when iterating stops.
     * @param breakFunction a break condition (optional)
     * @param timeout timeout settings for the setTimeout function. default - 0.
     * @returns the created async loop object
     */ static SyncAsyncForLoop(iterations, syncedIterations, fn, callback, breakFunction, timeout = 0) {
        return $89923ccd30e6d161$export$867c188241b31f47.Run(Math.ceil(iterations / syncedIterations), (loop)=>{
            if (breakFunction && breakFunction()) loop.breakLoop();
            else setTimeout(()=>{
                for(let i = 0; i < syncedIterations; ++i){
                    const iteration = loop.index * syncedIterations + i;
                    if (iteration >= iterations) break;
                    fn(iteration);
                    if (breakFunction && breakFunction()) {
                        loop.breakLoop();
                        break;
                    }
                }
                loop.executeNext();
            }, timeout);
        }, callback);
    }
}
$89923ccd30e6d161$export$390d11d353c16e49.Mix = (0, $wK2xc.Mix);
$89923ccd30e6d161$export$390d11d353c16e49.IsExponentOfTwo = (0, $wK2xc.IsExponentOfTwo);
// Will only be define if Tools is imported freeing up some space when only engine is required
(0, $ejQPp.EngineStore).FallbackTexture = "data:image/jpg;base64,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";

});
parcelRegister("jFz47", function(module, exports) {

$parcel$export(module.exports, "IsWindowObjectExist", () => $e51d0be5b0623881$export$5fa14a6824e0afb4);
$parcel$export(module.exports, "IsNavigatorAvailable", () => $e51d0be5b0623881$export$56ff6edc4c9939ed);
$parcel$export(module.exports, "IsDocumentAvailable", () => $e51d0be5b0623881$export$a29feb91d8b4b85d);
$parcel$export(module.exports, "GetDOMTextContent", () => $e51d0be5b0623881$export$5697c7702aeb1f9c);
$parcel$export(module.exports, "DomManagement", () => $e51d0be5b0623881$export$c5b65df3cf806e8b);
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Checks if the window object exists
 * @returns true if the window object exists
 */ function $e51d0be5b0623881$export$5fa14a6824e0afb4() {
    return typeof window !== "undefined";
}
function $e51d0be5b0623881$export$56ff6edc4c9939ed() {
    return typeof navigator !== "undefined";
}
function $e51d0be5b0623881$export$a29feb91d8b4b85d() {
    return typeof document !== "undefined";
}
function $e51d0be5b0623881$export$5697c7702aeb1f9c(element) {
    let result = "";
    let child = element.firstChild;
    while(child){
        if (child.nodeType === 3) result += child.textContent;
        child = child.nextSibling;
    }
    return result;
}
const $e51d0be5b0623881$export$c5b65df3cf806e8b = {
    IsWindowObjectExist: /**
     * Checks if the window object exists
     * @returns true if the window object exists
     */ $e51d0be5b0623881$export$5fa14a6824e0afb4,
    IsNavigatorAvailable: /**
     * Checks if the navigator object exists
     * @returns true if the navigator object exists
     */ $e51d0be5b0623881$export$56ff6edc4c9939ed,
    IsDocumentAvailable: /**
     * Check if the document object exists
     * @returns true if the document object exists
     */ $e51d0be5b0623881$export$a29feb91d8b4b85d,
    GetDOMTextContent: /**
     * Extracts text content from a DOM element hierarchy
     * @param element defines the root element
     * @returns a string
     */ $e51d0be5b0623881$export$5697c7702aeb1f9c
};

});

parcelRegister("blHSI", function(module, exports) {

$parcel$export(module.exports, "PrecisionDate", () => $8433b1cffc3accb9$export$43f85f75a5a0b594);

var $jFz47 = parcelRequire("jFz47");
class $8433b1cffc3accb9$export$43f85f75a5a0b594 {
    /**
     * Gets either window.performance.now() if supported or Date.now() else
     */ static get Now() {
        if ((0, $jFz47.IsWindowObjectExist)() && window.performance && window.performance.now) return window.performance.now();
        return Date.now();
    }
}

});

parcelRegister("EOxw7", function(module, exports) {

$parcel$export(module.exports, "LoadFileError", () => $07aaf0a72a34b36c$export$43bc2e920b24af3b);
$parcel$export(module.exports, "RequestFileError", () => $07aaf0a72a34b36c$export$c5bad8820e6a4362);
$parcel$export(module.exports, "ReadFileError", () => $07aaf0a72a34b36c$export$f20a28865dd27b8f);
$parcel$export(module.exports, "FileToolsOptions", () => $07aaf0a72a34b36c$export$c6667b012a1924ce);
$parcel$export(module.exports, "SetCorsBehavior", () => $07aaf0a72a34b36c$export$702ccb4912b94000);
$parcel$export(module.exports, "LoadImage", () => $07aaf0a72a34b36c$export$25299f3c4579a3a1);
$parcel$export(module.exports, "LoadFile", () => $07aaf0a72a34b36c$export$59daebe6f5c4b354);
$parcel$export(module.exports, "ReadFile", () => $07aaf0a72a34b36c$export$dde4d76a2e6dd805);
$parcel$export(module.exports, "TestBase64DataUrl", () => $07aaf0a72a34b36c$export$91734fbaccdffc48);
$parcel$export(module.exports, "DecodeBase64UrlToBinary", () => $07aaf0a72a34b36c$export$c8330d53aa73bc13);
$parcel$export(module.exports, "DecodeBase64UrlToString", () => $07aaf0a72a34b36c$export$a35972a337c29f7a);
$parcel$export(module.exports, "RequestFile", () => $07aaf0a72a34b36c$export$94e3aec8611d3b55);
$parcel$export(module.exports, "IsFileURL", () => $07aaf0a72a34b36c$export$83bbca801f4fc9f);
$parcel$export(module.exports, "IsBase64DataUrl", () => $07aaf0a72a34b36c$export$dd25b96132dd59eb);
$parcel$export(module.exports, "FileTools", () => $07aaf0a72a34b36c$export$95c1b81028a4cfad);
$parcel$export(module.exports, "_injectLTSFileTools", () => $07aaf0a72a34b36c$export$4891d9942bd12bdb);
/* eslint-disable @typescript-eslint/naming-convention */ 
var $hUzEl = parcelRequire("hUzEl");

var $jFz47 = parcelRequire("jFz47");

var $diGQf = parcelRequire("diGQf");

var $8btZm = parcelRequire("8btZm");

var $c10Gh = parcelRequire("c10Gh");

var $1FkG9 = parcelRequire("1FkG9");

var $eLv1o = parcelRequire("eLv1o");

var $kbQ0z = parcelRequire("kbQ0z");

var $2h5JR = parcelRequire("2h5JR");

var $ejQPp = parcelRequire("ejQPp");

var $kVtWi = parcelRequire("kVtWi");

var $av6Bc = parcelRequire("av6Bc");
const $07aaf0a72a34b36c$var$Base64DataUrlRegEx = new RegExp(/^data:([^,]+\/[^,]+)?;base64,/i);
class $07aaf0a72a34b36c$export$43bc2e920b24af3b extends (0, $1FkG9.RuntimeError) {
    /**
     * Creates a new LoadFileError
     * @param message defines the message of the error
     * @param object defines the optional web request
     */ constructor(message, object){
        super(message, (0, $1FkG9.ErrorCodes).LoadFileError);
        this.name = "LoadFileError";
        (0, $1FkG9.BaseError)._setPrototypeOf(this, $07aaf0a72a34b36c$export$43bc2e920b24af3b.prototype);
        if (object instanceof (0, $hUzEl.WebRequest)) this.request = object;
        else this.file = object;
    }
}
class $07aaf0a72a34b36c$export$c5bad8820e6a4362 extends (0, $1FkG9.RuntimeError) {
    /**
     * Creates a new LoadFileError
     * @param message defines the message of the error
     * @param request defines the optional web request
     */ constructor(message, request){
        super(message, (0, $1FkG9.ErrorCodes).RequestFileError);
        this.request = request;
        this.name = "RequestFileError";
        (0, $1FkG9.BaseError)._setPrototypeOf(this, $07aaf0a72a34b36c$export$c5bad8820e6a4362.prototype);
    }
}
class $07aaf0a72a34b36c$export$f20a28865dd27b8f extends (0, $1FkG9.RuntimeError) {
    /**
     * Creates a new ReadFileError
     * @param message defines the message of the error
     * @param file defines the optional file
     */ constructor(message, file){
        super(message, (0, $1FkG9.ErrorCodes).ReadFileError);
        this.file = file;
        this.name = "ReadFileError";
        (0, $1FkG9.BaseError)._setPrototypeOf(this, $07aaf0a72a34b36c$export$f20a28865dd27b8f.prototype);
    }
}
const $07aaf0a72a34b36c$export$c6667b012a1924ce = {
    /**
     * Gets or sets the retry strategy to apply when an error happens while loading an asset.
     * When defining this function, return the wait time before trying again or return -1 to
     * stop retrying and error out.
     */ DefaultRetryStrategy: (0, $c10Gh.RetryStrategy).ExponentialBackoff(),
    /**
     * Gets or sets the base URL to use to load assets
     */ BaseUrl: "",
    /**
     * Default behaviour for cors in the application.
     * It can be a string if the expected behavior is identical in the entire app.
     * Or a callback to be able to set it per url or on a group of them (in case of Video source for instance)
     */ CorsBehavior: "anonymous",
    /**
     * Gets or sets a function used to pre-process url before using them to load assets
     * @param url
     * @returns the processed url
     */ PreprocessUrl: (url)=>url,
    /**
     * Gets or sets the base URL to use to load scripts
     * Used for both JS and WASM
     */ ScriptBaseUrl: "",
    /**
     * Gets or sets a function used to pre-process script url before using them to load.
     * Used for both JS and WASM
     * @param url defines the url to process
     * @returns the processed url
     */ ScriptPreprocessUrl: (url)=>url
};
/**
 * Removes unwanted characters from an url
 * @param url defines the url to clean
 * @returns the cleaned url
 */ const $07aaf0a72a34b36c$var$_CleanUrl = (url)=>{
    url = url.replace(/#/gm, "%23");
    return url;
};
const $07aaf0a72a34b36c$export$702ccb4912b94000 = (url, element)=>{
    if (url && url.indexOf("data:") === 0) return;
    if ($07aaf0a72a34b36c$export$c6667b012a1924ce.CorsBehavior) {
        if (typeof $07aaf0a72a34b36c$export$c6667b012a1924ce.CorsBehavior === "string" || $07aaf0a72a34b36c$export$c6667b012a1924ce.CorsBehavior instanceof String) element.crossOrigin = $07aaf0a72a34b36c$export$c6667b012a1924ce.CorsBehavior;
        else {
            const result = $07aaf0a72a34b36c$export$c6667b012a1924ce.CorsBehavior(url);
            if (result) element.crossOrigin = result;
        }
    }
};
const $07aaf0a72a34b36c$export$25299f3c4579a3a1 = (input, onLoad, onError, offlineProvider, mimeType = "", imageBitmapOptions)=>{
    const engine = (0, $ejQPp.EngineStore).LastCreatedEngine;
    if (typeof HTMLImageElement === "undefined" && !engine?._features.forceBitmapOverHTMLImageElement) {
        onError("LoadImage is only supported in web or BabylonNative environments.");
        return null;
    }
    let url;
    let usingObjectURL = false;
    if (input instanceof ArrayBuffer || ArrayBuffer.isView(input)) {
        if (typeof Blob !== "undefined" && typeof URL !== "undefined") {
            url = URL.createObjectURL(new Blob([
                input
            ], {
                type: mimeType
            }));
            usingObjectURL = true;
        } else url = `data:${mimeType};base64,` + (0, $eLv1o.EncodeArrayBufferToBase64)(input);
    } else if (input instanceof Blob) {
        url = URL.createObjectURL(input);
        usingObjectURL = true;
    } else {
        url = $07aaf0a72a34b36c$var$_CleanUrl(input);
        url = $07aaf0a72a34b36c$export$c6667b012a1924ce.PreprocessUrl(input);
    }
    const onErrorHandler = (exception)=>{
        if (onError) {
            const inputText = url || input.toString();
            onError(`Error while trying to load image: ${inputText.indexOf("http") === 0 || inputText.length <= 128 ? inputText : inputText.slice(0, 128) + "..."}`, exception);
        }
    };
    if (engine?._features.forceBitmapOverHTMLImageElement) {
        $07aaf0a72a34b36c$export$59daebe6f5c4b354(url, (data)=>{
            engine.createImageBitmap(new Blob([
                data
            ], {
                type: mimeType
            }), {
                premultiplyAlpha: "none",
                ...imageBitmapOptions
            }).then((imgBmp)=>{
                onLoad(imgBmp);
                if (usingObjectURL) URL.revokeObjectURL(url);
            }).catch((reason)=>{
                if (onError) onError("Error while trying to load image: " + input, reason);
            });
        }, undefined, offlineProvider || undefined, true, (request, exception)=>{
            onErrorHandler(exception);
        });
        return null;
    }
    const img = new Image();
    $07aaf0a72a34b36c$export$702ccb4912b94000(url, img);
    const handlersList = [];
    const loadHandlersList = ()=>{
        handlersList.forEach((handler)=>{
            handler.target.addEventListener(handler.name, handler.handler);
        });
    };
    const unloadHandlersList = ()=>{
        handlersList.forEach((handler)=>{
            handler.target.removeEventListener(handler.name, handler.handler);
        });
        handlersList.length = 0;
    };
    const loadHandler = ()=>{
        unloadHandlersList();
        onLoad(img);
        // Must revoke the URL after calling onLoad to avoid security exceptions in
        // certain scenarios (e.g. when hosted in vscode).
        if (usingObjectURL && img.src) URL.revokeObjectURL(img.src);
    };
    const errorHandler = (err)=>{
        unloadHandlersList();
        onErrorHandler(err);
        if (usingObjectURL && img.src) URL.revokeObjectURL(img.src);
    };
    const cspHandler = (err)=>{
        if (err.blockedURI !== img.src) return;
        unloadHandlersList();
        const cspException = new Error(`CSP violation of policy ${err.effectiveDirective} ${err.blockedURI}. Current policy is ${err.originalPolicy}`);
        (0, $ejQPp.EngineStore).UseFallbackTexture = false;
        onErrorHandler(cspException);
        if (usingObjectURL && img.src) URL.revokeObjectURL(img.src);
        img.src = "";
    };
    handlersList.push({
        target: img,
        name: "load",
        handler: loadHandler
    });
    handlersList.push({
        target: img,
        name: "error",
        handler: errorHandler
    });
    handlersList.push({
        target: document,
        name: "securitypolicyviolation",
        handler: cspHandler
    });
    loadHandlersList();
    const fromBlob = url.substring(0, 5) === "blob:";
    const fromData = url.substring(0, 5) === "data:";
    const noOfflineSupport = ()=>{
        if (fromBlob || fromData || !(0, $hUzEl.WebRequest).IsCustomRequestAvailable) img.src = url;
        else $07aaf0a72a34b36c$export$59daebe6f5c4b354(url, (data, _, contentType)=>{
            const type = !mimeType && contentType ? contentType : mimeType;
            const blob = new Blob([
                data
            ], {
                type: type
            });
            const url = URL.createObjectURL(blob);
            usingObjectURL = true;
            img.src = url;
        }, undefined, offlineProvider || undefined, true, (_request, exception)=>{
            onErrorHandler(exception);
        });
    };
    const loadFromOfflineSupport = ()=>{
        if (offlineProvider) offlineProvider.loadImage(url, img);
    };
    if (!fromBlob && !fromData && offlineProvider && offlineProvider.enableTexturesOffline) offlineProvider.open(loadFromOfflineSupport, noOfflineSupport);
    else {
        if (url.indexOf("file:") !== -1) {
            const textureName = decodeURIComponent(url.substring(5).toLowerCase());
            if ((0, $8btZm.FilesInputStore).FilesToLoad[textureName] && typeof URL !== "undefined") {
                try {
                    let blobURL;
                    try {
                        blobURL = URL.createObjectURL((0, $8btZm.FilesInputStore).FilesToLoad[textureName]);
                    } catch (ex) {
                        // Chrome doesn't support oneTimeOnly parameter
                        blobURL = URL.createObjectURL((0, $8btZm.FilesInputStore).FilesToLoad[textureName]);
                    }
                    img.src = blobURL;
                    usingObjectURL = true;
                } catch (e) {
                    img.src = "";
                }
                return img;
            }
        }
        noOfflineSupport();
    }
    return img;
};
const $07aaf0a72a34b36c$export$dde4d76a2e6dd805 = (file, onSuccess, onProgress, useArrayBuffer, onError)=>{
    const reader = new FileReader();
    const fileRequest = {
        onCompleteObservable: new (0, $diGQf.Observable)(),
        abort: ()=>reader.abort()
    };
    reader.onloadend = ()=>fileRequest.onCompleteObservable.notifyObservers(fileRequest);
    if (onError) reader.onerror = ()=>{
        onError(new $07aaf0a72a34b36c$export$f20a28865dd27b8f(`Unable to read ${file.name}`, file));
    };
    reader.onload = (e)=>{
        //target doesn't have result from ts 1.3
        onSuccess(e.target["result"]);
    };
    if (onProgress) reader.onprogress = onProgress;
    if (!useArrayBuffer) // Asynchronous read
    reader.readAsText(file);
    else reader.readAsArrayBuffer(file);
    return fileRequest;
};
const $07aaf0a72a34b36c$export$59daebe6f5c4b354 = (fileOrUrl, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError, onOpened)=>{
    if (fileOrUrl.name) return $07aaf0a72a34b36c$export$dde4d76a2e6dd805(fileOrUrl, onSuccess, onProgress, useArrayBuffer, onError ? (error)=>{
        onError(undefined, error);
    } : undefined);
    const url = fileOrUrl;
    // If file and file input are set
    if (url.indexOf("file:") !== -1) {
        let fileName = decodeURIComponent(url.substring(5).toLowerCase());
        if (fileName.indexOf("./") === 0) fileName = fileName.substring(2);
        const file = (0, $8btZm.FilesInputStore).FilesToLoad[fileName];
        if (file) return $07aaf0a72a34b36c$export$dde4d76a2e6dd805(file, onSuccess, onProgress, useArrayBuffer, onError ? (error)=>onError(undefined, new $07aaf0a72a34b36c$export$43bc2e920b24af3b(error.message, error.file)) : undefined);
    }
    // For a Base64 Data URL
    const { match: match, type: type } = $07aaf0a72a34b36c$export$91734fbaccdffc48(url);
    if (match) {
        const fileRequest = {
            onCompleteObservable: new (0, $diGQf.Observable)(),
            abort: ()=>()=>{}
        };
        try {
            const data = useArrayBuffer ? $07aaf0a72a34b36c$export$c8330d53aa73bc13(url) : $07aaf0a72a34b36c$export$a35972a337c29f7a(url);
            onSuccess(data, undefined, type);
        } catch (error) {
            if (onError) onError(undefined, error);
            else (0, $kVtWi.Logger).Error(error.message || "Failed to parse the Data URL");
        }
        (0, $av6Bc.TimingTools).SetImmediate(()=>{
            fileRequest.onCompleteObservable.notifyObservers(fileRequest);
        });
        return fileRequest;
    }
    return $07aaf0a72a34b36c$export$94e3aec8611d3b55(url, (data, request)=>{
        onSuccess(data, request?.responseURL, request?.getResponseHeader("content-type"));
    }, onProgress, offlineProvider, useArrayBuffer, onError ? (error)=>{
        onError(error.request, new $07aaf0a72a34b36c$export$43bc2e920b24af3b(error.message, error.request));
    } : undefined, onOpened);
};
const $07aaf0a72a34b36c$export$94e3aec8611d3b55 = (url, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError, onOpened)=>{
    url = $07aaf0a72a34b36c$var$_CleanUrl(url);
    url = $07aaf0a72a34b36c$export$c6667b012a1924ce.PreprocessUrl(url);
    const loadUrl = $07aaf0a72a34b36c$export$c6667b012a1924ce.BaseUrl + url;
    let aborted = false;
    const fileRequest = {
        onCompleteObservable: new (0, $diGQf.Observable)(),
        abort: ()=>aborted = true
    };
    const requestFile = ()=>{
        let request = new (0, $hUzEl.WebRequest)();
        let retryHandle = null;
        let onReadyStateChange;
        const unbindEvents = ()=>{
            if (!request) return;
            if (onProgress) request.removeEventListener("progress", onProgress);
            if (onReadyStateChange) request.removeEventListener("readystatechange", onReadyStateChange);
            request.removeEventListener("loadend", onLoadEnd);
        };
        let onLoadEnd = ()=>{
            unbindEvents();
            fileRequest.onCompleteObservable.notifyObservers(fileRequest);
            fileRequest.onCompleteObservable.clear();
            onProgress = undefined;
            onReadyStateChange = null;
            onLoadEnd = null;
            onError = undefined;
            onOpened = undefined;
            onSuccess = undefined;
        };
        fileRequest.abort = ()=>{
            aborted = true;
            if (onLoadEnd) onLoadEnd();
            if (request && request.readyState !== (XMLHttpRequest.DONE || 4)) request.abort();
            if (retryHandle !== null) {
                clearTimeout(retryHandle);
                retryHandle = null;
            }
            request = null;
        };
        const handleError = (error)=>{
            const message = error.message || "Unknown error";
            if (onError && request) onError(new $07aaf0a72a34b36c$export$c5bad8820e6a4362(message, request));
            else (0, $kVtWi.Logger).Error(message);
        };
        const retryLoop = (retryIndex)=>{
            if (!request) return;
            request.open("GET", loadUrl);
            if (onOpened) try {
                onOpened(request);
            } catch (e) {
                handleError(e);
                return;
            }
            if (useArrayBuffer) request.responseType = "arraybuffer";
            if (onProgress) request.addEventListener("progress", onProgress);
            if (onLoadEnd) request.addEventListener("loadend", onLoadEnd);
            onReadyStateChange = ()=>{
                if (aborted || !request) return;
                // In case of undefined state in some browsers.
                if (request.readyState === (XMLHttpRequest.DONE || 4)) {
                    // Some browsers have issues where onreadystatechange can be called multiple times with the same value.
                    if (onReadyStateChange) request.removeEventListener("readystatechange", onReadyStateChange);
                    if (request.status >= 200 && request.status < 300 || request.status === 0 && (!(0, $jFz47.IsWindowObjectExist)() || $07aaf0a72a34b36c$export$83bbca801f4fc9f())) {
                        try {
                            if (onSuccess) onSuccess(useArrayBuffer ? request.response : request.responseText, request);
                        } catch (e) {
                            handleError(e);
                        }
                        return;
                    }
                    const retryStrategy = $07aaf0a72a34b36c$export$c6667b012a1924ce.DefaultRetryStrategy;
                    if (retryStrategy) {
                        const waitTime = retryStrategy(loadUrl, request, retryIndex);
                        if (waitTime !== -1) {
                            // Prevent the request from completing for retry.
                            unbindEvents();
                            request = new (0, $hUzEl.WebRequest)();
                            retryHandle = setTimeout(()=>retryLoop(retryIndex + 1), waitTime);
                            return;
                        }
                    }
                    const error = new $07aaf0a72a34b36c$export$c5bad8820e6a4362("Error status: " + request.status + " " + request.statusText + " - Unable to load " + loadUrl, request);
                    if (onError) onError(error);
                }
            };
            request.addEventListener("readystatechange", onReadyStateChange);
            request.send();
        };
        retryLoop(0);
    };
    // Caching all files
    if (offlineProvider && offlineProvider.enableSceneOffline) {
        const noOfflineSupport = (request)=>{
            if (request && request.status > 400) {
                if (onError) onError(request);
            } else requestFile();
        };
        const loadFromOfflineSupport = ()=>{
            // TODO: database needs to support aborting and should return a IFileRequest
            if (offlineProvider) offlineProvider.loadFile($07aaf0a72a34b36c$export$c6667b012a1924ce.BaseUrl + url, (data)=>{
                if (!aborted && onSuccess) onSuccess(data);
                fileRequest.onCompleteObservable.notifyObservers(fileRequest);
            }, onProgress ? (event)=>{
                if (!aborted && onProgress) onProgress(event);
            } : undefined, noOfflineSupport, useArrayBuffer);
        };
        offlineProvider.open(loadFromOfflineSupport, noOfflineSupport);
    } else requestFile();
    return fileRequest;
};
const $07aaf0a72a34b36c$export$83bbca801f4fc9f = ()=>{
    return typeof location !== "undefined" && location.protocol === "file:";
};
const $07aaf0a72a34b36c$export$dd25b96132dd59eb = (uri)=>{
    return $07aaf0a72a34b36c$var$Base64DataUrlRegEx.test(uri);
};
const $07aaf0a72a34b36c$export$91734fbaccdffc48 = (uri)=>{
    const results = $07aaf0a72a34b36c$var$Base64DataUrlRegEx.exec(uri);
    if (results === null || results.length === 0) return {
        match: false,
        type: ""
    };
    else {
        const type = results[0].replace("data:", "").replace("base64,", "");
        return {
            match: true,
            type: type
        };
    }
};
function $07aaf0a72a34b36c$export$c8330d53aa73bc13(uri) {
    return (0, $eLv1o.DecodeBase64ToBinary)(uri.split(",")[1]);
}
const $07aaf0a72a34b36c$export$a35972a337c29f7a = (uri)=>{
    return (0, $eLv1o.DecodeBase64ToString)(uri.split(",")[1]);
};
/**
 * This will be executed automatically for UMD and es5.
 * If esm dev wants the side effects to execute they will have to run it manually
 * Once we build native modules those need to be exported.
 * @internal
 */ const $07aaf0a72a34b36c$var$initSideEffects = ()=>{
    (0, $2h5JR.ThinEngine)._FileToolsLoadImage = $07aaf0a72a34b36c$export$25299f3c4579a3a1;
    (0, $2h5JR.ThinEngine)._FileToolsLoadFile = $07aaf0a72a34b36c$export$59daebe6f5c4b354;
    (0, $kbQ0z.ShaderProcessor)._FileToolsLoadFile = $07aaf0a72a34b36c$export$59daebe6f5c4b354;
};
$07aaf0a72a34b36c$var$initSideEffects();
let $07aaf0a72a34b36c$export$95c1b81028a4cfad;
const $07aaf0a72a34b36c$export$4891d9942bd12bdb = (DecodeBase64UrlToBinary, DecodeBase64UrlToString, FileToolsOptions, IsBase64DataUrl, IsFileURL, LoadFile, LoadImage, ReadFile, RequestFile, SetCorsBehavior)=>{
    /**
     * Backwards compatibility.
     * @internal
     * @deprecated
     */ $07aaf0a72a34b36c$export$95c1b81028a4cfad = {
        DecodeBase64UrlToBinary: DecodeBase64UrlToBinary,
        DecodeBase64UrlToString: DecodeBase64UrlToString,
        DefaultRetryStrategy: FileToolsOptions.DefaultRetryStrategy,
        BaseUrl: FileToolsOptions.BaseUrl,
        CorsBehavior: FileToolsOptions.CorsBehavior,
        PreprocessUrl: FileToolsOptions.PreprocessUrl,
        IsBase64DataUrl: IsBase64DataUrl,
        IsFileURL: IsFileURL,
        LoadFile: LoadFile,
        LoadImage: LoadImage,
        ReadFile: ReadFile,
        RequestFile: RequestFile,
        SetCorsBehavior: SetCorsBehavior
    };
    Object.defineProperty($07aaf0a72a34b36c$export$95c1b81028a4cfad, "DefaultRetryStrategy", {
        get: function() {
            return FileToolsOptions.DefaultRetryStrategy;
        },
        set: function(value) {
            FileToolsOptions.DefaultRetryStrategy = value;
        }
    });
    Object.defineProperty($07aaf0a72a34b36c$export$95c1b81028a4cfad, "BaseUrl", {
        get: function() {
            return FileToolsOptions.BaseUrl;
        },
        set: function(value) {
            FileToolsOptions.BaseUrl = value;
        }
    });
    Object.defineProperty($07aaf0a72a34b36c$export$95c1b81028a4cfad, "PreprocessUrl", {
        get: function() {
            return FileToolsOptions.PreprocessUrl;
        },
        set: function(value) {
            FileToolsOptions.PreprocessUrl = value;
        }
    });
    Object.defineProperty($07aaf0a72a34b36c$export$95c1b81028a4cfad, "CorsBehavior", {
        get: function() {
            return FileToolsOptions.CorsBehavior;
        },
        set: function(value) {
            FileToolsOptions.CorsBehavior = value;
        }
    });
};
$07aaf0a72a34b36c$export$4891d9942bd12bdb($07aaf0a72a34b36c$export$c8330d53aa73bc13, $07aaf0a72a34b36c$export$a35972a337c29f7a, $07aaf0a72a34b36c$export$c6667b012a1924ce, $07aaf0a72a34b36c$export$dd25b96132dd59eb, $07aaf0a72a34b36c$export$83bbca801f4fc9f, $07aaf0a72a34b36c$export$59daebe6f5c4b354, $07aaf0a72a34b36c$export$25299f3c4579a3a1, $07aaf0a72a34b36c$export$dde4d76a2e6dd805, $07aaf0a72a34b36c$export$94e3aec8611d3b55, $07aaf0a72a34b36c$export$702ccb4912b94000);

});
parcelRegister("8btZm", function(module, exports) {

$parcel$export(module.exports, "FilesInputStore", () => $5f569ced0b4209fd$export$16eb4d7c0a0517f4);
/**
 * Class used to help managing file picking and drag'n'drop
 * File Storage
 */ class $5f569ced0b4209fd$export$16eb4d7c0a0517f4 {
}
/**
 * List of files ready to be loaded
 */ $5f569ced0b4209fd$export$16eb4d7c0a0517f4.FilesToLoad = {};

});

parcelRegister("c10Gh", function(module, exports) {

$parcel$export(module.exports, "RetryStrategy", () => $8bf61b3d45bd4953$export$a700efba39673191);
/**
 * Class used to define a retry strategy when error happens while loading assets
 */ class $8bf61b3d45bd4953$export$a700efba39673191 {
    /**
     * Function used to defines an exponential back off strategy
     * @param maxRetries defines the maximum number of retries (3 by default)
     * @param baseInterval defines the interval between retries
     * @returns the strategy function to use
     */ static ExponentialBackoff(maxRetries = 3, baseInterval = 500) {
        return (url, request, retryIndex)=>{
            if (request.status !== 0 || retryIndex >= maxRetries || url.indexOf("file:") !== -1) return -1;
            return Math.pow(2, retryIndex) * baseInterval;
        };
    }
}

});

parcelRegister("1FkG9", function(module, exports) {

$parcel$export(module.exports, "BaseError", () => $1369a92b7089f970$export$a490eb03cb7a0a5e);
$parcel$export(module.exports, "ErrorCodes", () => $1369a92b7089f970$export$10e8e1cf990558d7);
$parcel$export(module.exports, "RuntimeError", () => $1369a92b7089f970$export$4a24a86bdbcf02bb);
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Base error. Due to limitations of typedoc-check and missing documentation
 * in lib.es5.d.ts, cannot extend Error directly for RuntimeError.
 * @ignore
 */ class $1369a92b7089f970$export$a490eb03cb7a0a5e extends Error {
}
// See https://stackoverflow.com/questions/12915412/how-do-i-extend-a-host-object-e-g-error-in-typescript
// and https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
// Polyfill for Object.setPrototypeOf if necessary.
$1369a92b7089f970$export$a490eb03cb7a0a5e._setPrototypeOf = Object.setPrototypeOf || ((o, proto)=>{
    o.__proto__ = proto;
    return o;
});
const $1369a92b7089f970$export$10e8e1cf990558d7 = {
    // Mesh errors 0-999
    /** Invalid or empty mesh vertex positions. */ MeshInvalidPositionsError: 0,
    // Texture errors 1000-1999
    /** Unsupported texture found. */ UnsupportedTextureError: 1000,
    // GLTFLoader errors 2000-2999
    /** Unexpected magic number found in GLTF file header. */ GLTFLoaderUnexpectedMagicError: 2000,
    // SceneLoader errors 3000-3999
    /** SceneLoader generic error code. Ideally wraps the inner exception. */ SceneLoaderError: 3000,
    // File related errors 4000-4999
    /** Load file error */ LoadFileError: 4000,
    /** Request file error */ RequestFileError: 4001,
    /** Read file error */ ReadFileError: 4002
};
class $1369a92b7089f970$export$4a24a86bdbcf02bb extends $1369a92b7089f970$export$a490eb03cb7a0a5e {
    /**
     * Creates a new RuntimeError
     * @param message defines the message of the error
     * @param errorCode the error code
     * @param innerError the error that caused the outer error
     */ constructor(message, errorCode, innerError){
        super(message);
        this.errorCode = errorCode;
        this.innerError = innerError;
        this.name = "RuntimeError";
        $1369a92b7089f970$export$a490eb03cb7a0a5e._setPrototypeOf(this, $1369a92b7089f970$export$4a24a86bdbcf02bb.prototype);
    }
}

});

parcelRegister("eLv1o", function(module, exports) {

$parcel$export(module.exports, "EndsWith", () => $abfd84b2a7c60488$export$b378f36d7aa04d3e);
$parcel$export(module.exports, "StartsWith", () => $abfd84b2a7c60488$export$96ebffb07897cd9c);
$parcel$export(module.exports, "Decode", () => $abfd84b2a7c60488$export$325185342b153af9);
$parcel$export(module.exports, "EncodeArrayBufferToBase64", () => $abfd84b2a7c60488$export$88038554b26d4b46);
$parcel$export(module.exports, "DecodeBase64ToString", () => $abfd84b2a7c60488$export$bf9b48664c8e387);
$parcel$export(module.exports, "DecodeBase64ToBinary", () => $abfd84b2a7c60488$export$3530a531e4225c2f);
$parcel$export(module.exports, "PadNumber", () => $abfd84b2a7c60488$export$bc6b405b5a1a6a5b);
$parcel$export(module.exports, "StringTools", () => $abfd84b2a7c60488$export$80369d553ce790c0);
/* eslint-disable @typescript-eslint/naming-convention */ /**
 * Checks for a matching suffix at the end of a string (for ES5 and lower)
 * @param str Source string
 * @param suffix Suffix to search for in the source string
 * @returns Boolean indicating whether the suffix was found (true) or not (false)
 * @deprecated Please use native string function instead
 */ const $abfd84b2a7c60488$export$b378f36d7aa04d3e = (str, suffix)=>{
    return str.endsWith(suffix);
};
const $abfd84b2a7c60488$export$96ebffb07897cd9c = (str, suffix)=>{
    if (!str) return false;
    return str.startsWith(suffix);
};
const $abfd84b2a7c60488$export$325185342b153af9 = (buffer)=>{
    if (typeof TextDecoder !== "undefined") return new TextDecoder().decode(buffer);
    let result = "";
    for(let i = 0; i < buffer.byteLength; i++)result += String.fromCharCode(buffer[i]);
    return result;
};
const $abfd84b2a7c60488$export$88038554b26d4b46 = (buffer)=>{
    const keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    let output = "";
    let chr1, chr2, chr3, enc1, enc2, enc3, enc4;
    let i = 0;
    const bytes = ArrayBuffer.isView(buffer) ? new Uint8Array(buffer.buffer, buffer.byteOffset, buffer.byteLength) : new Uint8Array(buffer);
    while(i < bytes.length){
        chr1 = bytes[i++];
        chr2 = i < bytes.length ? bytes[i++] : Number.NaN;
        chr3 = i < bytes.length ? bytes[i++] : Number.NaN;
        enc1 = chr1 >> 2;
        enc2 = (chr1 & 3) << 4 | chr2 >> 4;
        enc3 = (chr2 & 15) << 2 | chr3 >> 6;
        enc4 = chr3 & 63;
        if (isNaN(chr2)) enc3 = enc4 = 64;
        else if (isNaN(chr3)) enc4 = 64;
        output += keyStr.charAt(enc1) + keyStr.charAt(enc2) + keyStr.charAt(enc3) + keyStr.charAt(enc4);
    }
    return output;
};
const $abfd84b2a7c60488$export$bf9b48664c8e387 = (base64Data)=>{
    return atob(base64Data);
};
const $abfd84b2a7c60488$export$3530a531e4225c2f = (base64Data)=>{
    const decodedString = $abfd84b2a7c60488$export$bf9b48664c8e387(base64Data);
    const bufferLength = decodedString.length;
    const bufferView = new Uint8Array(new ArrayBuffer(bufferLength));
    for(let i = 0; i < bufferLength; i++)bufferView[i] = decodedString.charCodeAt(i);
    return bufferView.buffer;
};
const $abfd84b2a7c60488$export$bc6b405b5a1a6a5b = (num, length)=>{
    let str = String(num);
    while(str.length < length)str = "0" + str;
    return str;
};
const $abfd84b2a7c60488$export$80369d553ce790c0 = {
    EndsWith: $abfd84b2a7c60488$export$b378f36d7aa04d3e,
    StartsWith: $abfd84b2a7c60488$export$96ebffb07897cd9c,
    Decode: $abfd84b2a7c60488$export$325185342b153af9,
    EncodeArrayBufferToBase64: $abfd84b2a7c60488$export$88038554b26d4b46,
    DecodeBase64ToString: $abfd84b2a7c60488$export$bf9b48664c8e387,
    DecodeBase64ToBinary: $abfd84b2a7c60488$export$3530a531e4225c2f,
    PadNumber: $abfd84b2a7c60488$export$bc6b405b5a1a6a5b
};

});

parcelRegister("kbQ0z", function(module, exports) {

$parcel$export(module.exports, "ShaderProcessor", () => $eb2d2d73daee21fb$export$67c6f511533846ba);
/* eslint-disable @typescript-eslint/no-unused-vars */ 
var $9ePQk = parcelRequire("9ePQk");

var $cLE9v = parcelRequire("cLE9v");

var $8LAT3 = parcelRequire("8LAT3");

var $Dmfod = parcelRequire("Dmfod");

var $lxPUQ = parcelRequire("lxPUQ");

var $2V8i3 = parcelRequire("2V8i3");

var $3gTIF = parcelRequire("3gTIF");

var $3FBHc = parcelRequire("3FBHc");

var $lm1xJ = parcelRequire("lm1xJ");

var $dUFYy = parcelRequire("dUFYy");

var $8WI3I = parcelRequire("8WI3I");
const $eb2d2d73daee21fb$var$regexSE = /defined\s*?\((.+?)\)/g;
const $eb2d2d73daee21fb$var$regexSERevert = /defined\s*?\[(.+?)\]/g;
const $eb2d2d73daee21fb$var$regexShaderInclude = /#include\s?<(.+)>(\((.*)\))*(\[(.*)\])*/g;
const $eb2d2d73daee21fb$var$regexShaderDecl = /__decl__/;
const $eb2d2d73daee21fb$var$regexLightX = /light\{X\}.(\w*)/g;
const $eb2d2d73daee21fb$var$regexX = /\{X\}/g;
const $eb2d2d73daee21fb$var$reusableMatches = [];
class $eb2d2d73daee21fb$export$67c6f511533846ba {
    static Initialize(options) {
        if (options.processor && options.processor.initializeShaders) options.processor.initializeShaders(options.processingContext);
    }
    static Process(sourceCode, options, callback, engine) {
        if (options.processor?.preProcessShaderCode) sourceCode = options.processor.preProcessShaderCode(sourceCode, options.isFragment);
        this._ProcessIncludes(sourceCode, options, (codeWithIncludes)=>{
            if (options.processCodeAfterIncludes) codeWithIncludes = options.processCodeAfterIncludes(options.isFragment ? "fragment" : "vertex", codeWithIncludes);
            const migratedCode = this._ProcessShaderConversion(codeWithIncludes, options, engine);
            callback(migratedCode, codeWithIncludes);
        });
    }
    static PreProcess(sourceCode, options, callback, engine) {
        if (options.processor?.preProcessShaderCode) sourceCode = options.processor.preProcessShaderCode(sourceCode, options.isFragment);
        this._ProcessIncludes(sourceCode, options, (codeWithIncludes)=>{
            if (options.processCodeAfterIncludes) codeWithIncludes = options.processCodeAfterIncludes(options.isFragment ? "fragment" : "vertex", codeWithIncludes);
            const migratedCode = this._ApplyPreProcessing(codeWithIncludes, options, engine);
            callback(migratedCode, codeWithIncludes);
        });
    }
    static Finalize(vertexCode, fragmentCode, options) {
        if (!options.processor || !options.processor.finalizeShaders) return {
            vertexCode: vertexCode,
            fragmentCode: fragmentCode
        };
        return options.processor.finalizeShaders(vertexCode, fragmentCode, options.processingContext);
    }
    static _ProcessPrecision(source, options) {
        if (options.processor?.noPrecision) return source;
        const shouldUseHighPrecisionShader = options.shouldUseHighPrecisionShader;
        if (source.indexOf("precision highp float") === -1) {
            if (!shouldUseHighPrecisionShader) source = "precision mediump float;\n" + source;
            else source = "precision highp float;\n" + source;
        } else if (!shouldUseHighPrecisionShader) // Moving highp to mediump
        source = source.replace("precision highp float", "precision mediump float");
        return source;
    }
    static _ExtractOperation(expression) {
        const regex = /defined\((.+)\)/;
        const match = regex.exec(expression);
        if (match && match.length) return new (0, $lxPUQ.ShaderDefineIsDefinedOperator)(match[1].trim(), expression[0] === "!");
        const operators = [
            "==",
            "!=",
            ">=",
            "<=",
            "<",
            ">"
        ];
        let operator = "";
        let indexOperator = 0;
        for (operator of operators){
            indexOperator = expression.indexOf(operator);
            if (indexOperator > -1) break;
        }
        if (indexOperator === -1) return new (0, $lxPUQ.ShaderDefineIsDefinedOperator)(expression);
        const define = expression.substring(0, indexOperator).trim();
        const value = expression.substring(indexOperator + operator.length).trim();
        return new (0, $lm1xJ.ShaderDefineArithmeticOperator)(define, operator, value);
    }
    static _BuildSubExpression(expression) {
        expression = expression.replace($eb2d2d73daee21fb$var$regexSE, "defined[$1]");
        const postfix = (0, $3FBHc.ShaderDefineExpression).infixToPostfix(expression);
        const stack = [];
        for (const c of postfix){
            if (c !== "||" && c !== "&&") stack.push(c);
            else if (stack.length >= 2) {
                let v1 = stack[stack.length - 1], v2 = stack[stack.length - 2];
                stack.length -= 2;
                const operator = c == "&&" ? new (0, $3gTIF.ShaderDefineAndOperator)() : new (0, $2V8i3.ShaderDefineOrOperator)();
                if (typeof v1 === "string") v1 = v1.replace($eb2d2d73daee21fb$var$regexSERevert, "defined($1)");
                if (typeof v2 === "string") v2 = v2.replace($eb2d2d73daee21fb$var$regexSERevert, "defined($1)");
                operator.leftOperand = typeof v2 === "string" ? this._ExtractOperation(v2) : v2;
                operator.rightOperand = typeof v1 === "string" ? this._ExtractOperation(v1) : v1;
                stack.push(operator);
            }
        }
        let result = stack[stack.length - 1];
        if (typeof result === "string") result = result.replace($eb2d2d73daee21fb$var$regexSERevert, "defined($1)");
        // note: stack.length !== 1 if there was an error in the parsing
        return typeof result === "string" ? this._ExtractOperation(result) : result;
    }
    static _BuildExpression(line, start) {
        const node = new (0, $Dmfod.ShaderCodeTestNode)();
        const command = line.substring(0, start);
        let expression = line.substring(start);
        expression = expression.substring(0, (expression.indexOf("//") + 1 || expression.length + 1) - 1).trim();
        if (command === "#ifdef") node.testExpression = new (0, $lxPUQ.ShaderDefineIsDefinedOperator)(expression);
        else if (command === "#ifndef") node.testExpression = new (0, $lxPUQ.ShaderDefineIsDefinedOperator)(expression, true);
        else node.testExpression = this._BuildSubExpression(expression);
        return node;
    }
    static _MoveCursorWithinIf(cursor, rootNode, ifNode) {
        let line = cursor.currentLine;
        while(this._MoveCursor(cursor, ifNode)){
            line = cursor.currentLine;
            const first5 = line.substring(0, 5).toLowerCase();
            if (first5 === "#else") {
                const elseNode = new (0, $9ePQk.ShaderCodeNode)();
                rootNode.children.push(elseNode);
                this._MoveCursor(cursor, elseNode);
                return;
            } else if (first5 === "#elif") {
                const elifNode = this._BuildExpression(line, 5);
                rootNode.children.push(elifNode);
                ifNode = elifNode;
            }
        }
    }
    static _MoveCursor(cursor, rootNode) {
        while(cursor.canRead){
            cursor.lineIndex++;
            const line = cursor.currentLine;
            if (line.indexOf("#") >= 0) {
                const matches = $eb2d2d73daee21fb$export$67c6f511533846ba._MoveCursorRegex.exec(line);
                if (matches && matches.length) {
                    const keyword = matches[0];
                    switch(keyword){
                        case "#ifdef":
                            {
                                const newRootNode = new (0, $8LAT3.ShaderCodeConditionNode)();
                                rootNode.children.push(newRootNode);
                                const ifNode = this._BuildExpression(line, 6);
                                newRootNode.children.push(ifNode);
                                this._MoveCursorWithinIf(cursor, newRootNode, ifNode);
                                break;
                            }
                        case "#else":
                        case "#elif":
                            return true;
                        case "#endif":
                            return false;
                        case "#ifndef":
                            {
                                const newRootNode = new (0, $8LAT3.ShaderCodeConditionNode)();
                                rootNode.children.push(newRootNode);
                                const ifNode = this._BuildExpression(line, 7);
                                newRootNode.children.push(ifNode);
                                this._MoveCursorWithinIf(cursor, newRootNode, ifNode);
                                break;
                            }
                        case "#if":
                            {
                                const newRootNode = new (0, $8LAT3.ShaderCodeConditionNode)();
                                const ifNode = this._BuildExpression(line, 3);
                                rootNode.children.push(newRootNode);
                                newRootNode.children.push(ifNode);
                                this._MoveCursorWithinIf(cursor, newRootNode, ifNode);
                                break;
                            }
                    }
                    continue;
                }
            }
            const newNode = new (0, $9ePQk.ShaderCodeNode)();
            newNode.line = line;
            rootNode.children.push(newNode);
            // Detect additional defines
            if (line[0] === "#" && line[1] === "d") {
                const split = line.replace(";", "").split(" ");
                newNode.additionalDefineKey = split[1];
                if (split.length === 3) newNode.additionalDefineValue = split[2];
            }
        }
        return false;
    }
    static _EvaluatePreProcessors(sourceCode, preprocessors, options) {
        const rootNode = new (0, $9ePQk.ShaderCodeNode)();
        const cursor = new (0, $cLE9v.ShaderCodeCursor)();
        cursor.lineIndex = -1;
        cursor.lines = sourceCode.split("\n");
        // Decompose (We keep it in 2 steps so it is easier to maintain and perf hit is insignificant)
        this._MoveCursor(cursor, rootNode);
        // Recompose
        return rootNode.process(preprocessors, options);
    }
    static _PreparePreProcessors(options, engine) {
        const defines = options.defines;
        const preprocessors = {};
        for (const define of defines){
            const keyValue = define.replace("#define", "").replace(";", "").trim();
            const split = keyValue.split(" ");
            preprocessors[split[0]] = split.length > 1 ? split[1] : "";
        }
        if (options.processor?.shaderLanguage === (0, $8WI3I.ShaderLanguage).GLSL) preprocessors["GL_ES"] = "true";
        preprocessors["__VERSION__"] = options.version;
        preprocessors[options.platformName] = "true";
        engine._getGlobalDefines(preprocessors);
        return preprocessors;
    }
    static _ProcessShaderConversion(sourceCode, options, engine) {
        let preparedSourceCode = this._ProcessPrecision(sourceCode, options);
        if (!options.processor) return preparedSourceCode;
        // Already converted
        if (options.processor.shaderLanguage === (0, $8WI3I.ShaderLanguage).GLSL && preparedSourceCode.indexOf("#version 3") !== -1) {
            preparedSourceCode = preparedSourceCode.replace("#version 300 es", "");
            if (!options.processor.parseGLES3) return preparedSourceCode;
        }
        const defines = options.defines;
        const preprocessors = this._PreparePreProcessors(options, engine);
        // General pre processing
        if (options.processor.preProcessor) preparedSourceCode = options.processor.preProcessor(preparedSourceCode, defines, options.isFragment, options.processingContext);
        preparedSourceCode = this._EvaluatePreProcessors(preparedSourceCode, preprocessors, options);
        // Post processing
        if (options.processor.postProcessor) preparedSourceCode = options.processor.postProcessor(preparedSourceCode, defines, options.isFragment, options.processingContext, engine);
        // Inline functions tagged with #define inline
        if (engine._features.needShaderCodeInlining) preparedSourceCode = engine.inlineShaderCode(preparedSourceCode);
        return preparedSourceCode;
    }
    static _ApplyPreProcessing(sourceCode, options, engine) {
        let preparedSourceCode = sourceCode;
        const defines = options.defines;
        const preprocessors = this._PreparePreProcessors(options, engine);
        // General pre processing
        if (options.processor?.preProcessor) preparedSourceCode = options.processor.preProcessor(preparedSourceCode, defines, options.isFragment, options.processingContext);
        preparedSourceCode = this._EvaluatePreProcessors(preparedSourceCode, preprocessors, options);
        // Post processing
        if (options.processor?.postProcessor) preparedSourceCode = options.processor.postProcessor(preparedSourceCode, defines, options.isFragment, options.processingContext, engine);
        // Inline functions tagged with #define inline
        if (engine._features.needShaderCodeInlining) preparedSourceCode = engine.inlineShaderCode(preparedSourceCode);
        return preparedSourceCode;
    }
    /** @internal */ static _ProcessIncludes(sourceCode, options, callback) {
        $eb2d2d73daee21fb$var$reusableMatches.length = 0;
        let match;
        // stay back-compat to the old matchAll syntax
        while((match = $eb2d2d73daee21fb$var$regexShaderInclude.exec(sourceCode)) !== null)$eb2d2d73daee21fb$var$reusableMatches.push(match);
        let returnValue = String(sourceCode);
        let parts = [
            sourceCode
        ];
        let keepProcessing = false;
        for (const match of $eb2d2d73daee21fb$var$reusableMatches){
            let includeFile = match[1];
            // Uniform declaration
            if (includeFile.indexOf("__decl__") !== -1) {
                includeFile = includeFile.replace($eb2d2d73daee21fb$var$regexShaderDecl, "");
                if (options.supportsUniformBuffers) includeFile = includeFile.replace("Vertex", "Ubo").replace("Fragment", "Ubo");
                includeFile = includeFile + "Declaration";
            }
            if (options.includesShadersStore[includeFile]) {
                // Substitution
                let includeContent = options.includesShadersStore[includeFile];
                if (match[2]) {
                    const splits = match[3].split(",");
                    for(let index = 0; index < splits.length; index += 2){
                        const source = new RegExp(splits[index], "g");
                        const dest = splits[index + 1];
                        includeContent = includeContent.replace(source, dest);
                    }
                }
                if (match[4]) {
                    const indexString = match[5];
                    if (indexString.indexOf("..") !== -1) {
                        const indexSplits = indexString.split("..");
                        const minIndex = parseInt(indexSplits[0]);
                        let maxIndex = parseInt(indexSplits[1]);
                        let sourceIncludeContent = includeContent.slice(0);
                        includeContent = "";
                        if (isNaN(maxIndex)) maxIndex = options.indexParameters[indexSplits[1]];
                        for(let i = minIndex; i < maxIndex; i++){
                            if (!options.supportsUniformBuffers) // Ubo replacement
                            sourceIncludeContent = sourceIncludeContent.replace($eb2d2d73daee21fb$var$regexLightX, (str, p1)=>{
                                return p1 + "{X}";
                            });
                            includeContent += sourceIncludeContent.replace($eb2d2d73daee21fb$var$regexX, i.toString()) + "\n";
                        }
                    } else {
                        if (!options.supportsUniformBuffers) // Ubo replacement
                        includeContent = includeContent.replace($eb2d2d73daee21fb$var$regexLightX, (str, p1)=>{
                            return p1 + "{X}";
                        });
                        includeContent = includeContent.replace($eb2d2d73daee21fb$var$regexX, indexString);
                    }
                }
                // Replace
                // Split all parts on match[0] and intersperse the parts with the include content
                const newParts = [];
                for (const part of parts){
                    const splitPart = part.split(match[0]);
                    for(let i = 0; i < splitPart.length - 1; i++){
                        newParts.push(splitPart[i]);
                        newParts.push(includeContent);
                    }
                    newParts.push(splitPart[splitPart.length - 1]);
                }
                parts = newParts;
                keepProcessing = keepProcessing || includeContent.indexOf("#include<") >= 0 || includeContent.indexOf("#include <") >= 0;
            } else {
                const includeShaderUrl = options.shadersRepository + "ShadersInclude/" + includeFile + ".fx";
                $eb2d2d73daee21fb$export$67c6f511533846ba._FileToolsLoadFile(includeShaderUrl, (fileContent)=>{
                    options.includesShadersStore[includeFile] = fileContent;
                    this._ProcessIncludes(parts.join(""), options, callback);
                });
                return;
            }
        }
        $eb2d2d73daee21fb$var$reusableMatches.length = 0;
        returnValue = parts.join("");
        if (keepProcessing) this._ProcessIncludes(returnValue.toString(), options, callback);
        else callback(returnValue);
    }
    /**
     * Loads a file from a url
     * @param url url to load
     * @param onSuccess callback called when the file successfully loads
     * @param onProgress callback called while file is loading (if the server supports this mode)
     * @param offlineProvider defines the offline provider for caching
     * @param useArrayBuffer defines a boolean indicating that date must be returned as ArrayBuffer
     * @param onError callback called when the file fails to load
     * @returns a file request object
     * @internal
     */ static _FileToolsLoadFile(url, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError) {
        throw (0, $dUFYy._WarnImport)("FileTools");
    }
}
$eb2d2d73daee21fb$export$67c6f511533846ba._MoveCursorRegex = /(#ifdef)|(#else)|(#elif)|(#endif)|(#ifndef)|(#if)/;

});
parcelRegister("9ePQk", function(module, exports) {

$parcel$export(module.exports, "ShaderCodeNode", () => $6b9da2cc172255d7$export$860cf9b8229373f3);
const $6b9da2cc172255d7$var$defaultAttributeKeywordName = "attribute";
const $6b9da2cc172255d7$var$defaultVaryingKeywordName = "varying";
class $6b9da2cc172255d7$export$860cf9b8229373f3 {
    constructor(){
        this.children = [];
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isValid(preprocessors) {
        return true;
    }
    process(preprocessors, options) {
        let result = "";
        if (this.line) {
            let value = this.line;
            const processor = options.processor;
            if (processor) {
                // This must be done before other replacements to avoid mistakenly changing something that was already changed.
                if (processor.lineProcessor) value = processor.lineProcessor(value, options.isFragment, options.processingContext);
                const attributeKeyword = options.processor?.attributeKeywordName ?? $6b9da2cc172255d7$var$defaultAttributeKeywordName;
                const varyingKeyword = options.isFragment && options.processor?.varyingFragmentKeywordName ? options.processor?.varyingFragmentKeywordName : !options.isFragment && options.processor?.varyingVertexKeywordName ? options.processor?.varyingVertexKeywordName : $6b9da2cc172255d7$var$defaultVaryingKeywordName;
                if (!options.isFragment && processor.attributeProcessor && this.line.startsWith(attributeKeyword)) value = processor.attributeProcessor(this.line, preprocessors, options.processingContext);
                else if (processor.varyingProcessor && (processor.varyingCheck?.(this.line, options.isFragment) || !processor.varyingCheck && this.line.startsWith(varyingKeyword))) value = processor.varyingProcessor(this.line, options.isFragment, preprocessors, options.processingContext);
                else if (processor.uniformProcessor && processor.uniformRegexp && processor.uniformRegexp.test(this.line)) {
                    if (!options.lookForClosingBracketForUniformBuffer) value = processor.uniformProcessor(this.line, options.isFragment, preprocessors, options.processingContext);
                } else if (processor.uniformBufferProcessor && processor.uniformBufferRegexp && processor.uniformBufferRegexp.test(this.line)) {
                    if (!options.lookForClosingBracketForUniformBuffer) {
                        value = processor.uniformBufferProcessor(this.line, options.isFragment, options.processingContext);
                        options.lookForClosingBracketForUniformBuffer = true;
                    }
                } else if (processor.textureProcessor && processor.textureRegexp && processor.textureRegexp.test(this.line)) value = processor.textureProcessor(this.line, options.isFragment, preprocessors, options.processingContext);
                else if ((processor.uniformProcessor || processor.uniformBufferProcessor) && this.line.startsWith("uniform") && !options.lookForClosingBracketForUniformBuffer) {
                    const regex = /uniform\s+(?:(?:highp)?|(?:lowp)?)\s*(\S+)\s+(\S+)\s*;/;
                    if (regex.test(this.line)) // uniform
                    {
                        if (processor.uniformProcessor) value = processor.uniformProcessor(this.line, options.isFragment, preprocessors, options.processingContext);
                    } else // Uniform buffer
                    if (processor.uniformBufferProcessor) {
                        value = processor.uniformBufferProcessor(this.line, options.isFragment, options.processingContext);
                        options.lookForClosingBracketForUniformBuffer = true;
                    }
                }
                if (options.lookForClosingBracketForUniformBuffer && this.line.indexOf("}") !== -1) {
                    options.lookForClosingBracketForUniformBuffer = false;
                    if (processor.endOfUniformBufferProcessor) value = processor.endOfUniformBufferProcessor(this.line, options.isFragment, options.processingContext);
                }
            }
            result += value + "\n";
        }
        this.children.forEach((child)=>{
            result += child.process(preprocessors, options);
        });
        if (this.additionalDefineKey) preprocessors[this.additionalDefineKey] = this.additionalDefineValue || "true";
        return result;
    }
}

});

parcelRegister("cLE9v", function(module, exports) {

$parcel$export(module.exports, "ShaderCodeCursor", () => $94b90538c5e84ed0$export$447f9aad68c4a0b5);
/** @internal */ class $94b90538c5e84ed0$export$447f9aad68c4a0b5 {
    constructor(){
        this._lines = [];
    }
    get currentLine() {
        return this._lines[this.lineIndex];
    }
    get canRead() {
        return this.lineIndex < this._lines.length - 1;
    }
    set lines(value) {
        this._lines.length = 0;
        for (const line of value){
            // Skip empty lines
            if (!line || line === "\r") continue;
            // Prevent removing line break in macros.
            if (line[0] === "#") {
                this._lines.push(line);
                continue;
            }
            // Do not split single line comments
            const trimmedLine = line.trim();
            if (!trimmedLine) continue;
            if (trimmedLine.startsWith("//")) {
                this._lines.push(line);
                continue;
            }
            // Work with semicolon in the line
            const semicolonIndex = trimmedLine.indexOf(";");
            if (semicolonIndex === -1) // No semicolon in the line
            this._lines.push(trimmedLine);
            else if (semicolonIndex === trimmedLine.length - 1) // Single semicolon at the end of the line
            // If trimmedLine == ";", we must not push, to be backward compatible with the old code!
            {
                if (trimmedLine.length > 1) this._lines.push(trimmedLine);
            } else {
                // Semicolon in the middle of the line
                const split = line.split(";");
                for(let index = 0; index < split.length; index++){
                    let subLine = split[index];
                    if (!subLine) continue;
                    subLine = subLine.trim();
                    if (!subLine) continue;
                    this._lines.push(subLine + (index !== split.length - 1 ? ";" : ""));
                }
            }
        }
    }
}

});

parcelRegister("8LAT3", function(module, exports) {

$parcel$export(module.exports, "ShaderCodeConditionNode", () => $661f53864883222b$export$bf5fb72825e99da7);

var $9ePQk = parcelRequire("9ePQk");
class $661f53864883222b$export$bf5fb72825e99da7 extends (0, $9ePQk.ShaderCodeNode) {
    process(preprocessors, options) {
        for(let index = 0; index < this.children.length; index++){
            const node = this.children[index];
            if (node.isValid(preprocessors)) return node.process(preprocessors, options);
        }
        return "";
    }
}

});

parcelRegister("Dmfod", function(module, exports) {

$parcel$export(module.exports, "ShaderCodeTestNode", () => $0764e677b7a6d382$export$a671c751cc11167f);

var $9ePQk = parcelRequire("9ePQk");
class $0764e677b7a6d382$export$a671c751cc11167f extends (0, $9ePQk.ShaderCodeNode) {
    isValid(preprocessors) {
        return this.testExpression.isTrue(preprocessors);
    }
}

});

parcelRegister("lxPUQ", function(module, exports) {

$parcel$export(module.exports, "ShaderDefineIsDefinedOperator", () => $faf4f37305ff3435$export$e04e366a8401cd6e);

var $3FBHc = parcelRequire("3FBHc");
class $faf4f37305ff3435$export$e04e366a8401cd6e extends (0, $3FBHc.ShaderDefineExpression) {
    constructor(define, not = false){
        super();
        this.define = define;
        this.not = not;
    }
    isTrue(preprocessors) {
        let condition = preprocessors[this.define] !== undefined;
        if (this.not) condition = !condition;
        return condition;
    }
}

});
parcelRegister("3FBHc", function(module, exports) {

$parcel$export(module.exports, "ShaderDefineExpression", () => $2ac27104007dc5a5$export$71ef9c78ba3a183);
/* eslint-disable @typescript-eslint/naming-convention */ /** @internal */ class $2ac27104007dc5a5$export$71ef9c78ba3a183 {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isTrue(preprocessors) {
        return true;
    }
    static postfixToInfix(postfix) {
        const stack = [];
        for (const c of postfix)if ($2ac27104007dc5a5$export$71ef9c78ba3a183._OperatorPriority[c] === undefined) stack.push(c);
        else {
            const v1 = stack[stack.length - 1], v2 = stack[stack.length - 2];
            stack.length -= 2;
            stack.push(`(${v2}${c}${v1})`);
        }
        return stack[stack.length - 1];
    }
    /**
     * Converts an infix expression to a postfix expression.
     *
     * This method is used to transform infix expressions, which are more human-readable,
     * into postfix expressions, also known as Reverse Polish Notation (RPN), that can be
     * evaluated more efficiently by a computer. The conversion is based on the operator
     * priority defined in _OperatorPriority.
     *
     * The function employs a stack-based algorithm for the conversion and caches the result
     * to improve performance. The cache keeps track of each converted expression's access time
     * to manage the cache size and optimize memory usage. When the cache size exceeds a specified
     * limit, the least recently accessed items in the cache are deleted.
     *
     * The cache mechanism is particularly helpful for shader compilation, where the same infix
     * expressions might be encountered repeatedly, hence the caching can speed up the process.
     *
     * @param infix - The infix expression to be converted.
     * @returns The postfix expression as an array of strings.
     */ static infixToPostfix(infix) {
        // Is infix already in cache
        const cacheItem = $2ac27104007dc5a5$export$71ef9c78ba3a183._InfixToPostfixCache.get(infix);
        if (cacheItem) {
            cacheItem.accessTime = Date.now();
            return cacheItem.result;
        }
        // Is infix contain any operator
        if (!infix.includes("&&") && !infix.includes("||") && !infix.includes(")") && !infix.includes("(")) return [
            infix
        ];
        const result = [];
        let stackIdx = -1;
        const pushOperand = ()=>{
            operand = operand.trim();
            if (operand !== "") {
                result.push(operand);
                operand = "";
            }
        };
        const push = (s)=>{
            if (stackIdx < $2ac27104007dc5a5$export$71ef9c78ba3a183._Stack.length - 1) $2ac27104007dc5a5$export$71ef9c78ba3a183._Stack[++stackIdx] = s;
        };
        const peek = ()=>$2ac27104007dc5a5$export$71ef9c78ba3a183._Stack[stackIdx];
        const pop = ()=>stackIdx === -1 ? "!!INVALID EXPRESSION!!" : $2ac27104007dc5a5$export$71ef9c78ba3a183._Stack[stackIdx--];
        let idx = 0, operand = "";
        while(idx < infix.length){
            const c = infix.charAt(idx), token = idx < infix.length - 1 ? infix.substr(idx, 2) : "";
            if (c === "(") {
                operand = "";
                push(c);
            } else if (c === ")") {
                pushOperand();
                while(stackIdx !== -1 && peek() !== "(")result.push(pop());
                pop();
            } else if ($2ac27104007dc5a5$export$71ef9c78ba3a183._OperatorPriority[token] > 1) {
                pushOperand();
                while(stackIdx !== -1 && $2ac27104007dc5a5$export$71ef9c78ba3a183._OperatorPriority[peek()] >= $2ac27104007dc5a5$export$71ef9c78ba3a183._OperatorPriority[token])result.push(pop());
                push(token);
                idx++;
            } else operand += c;
            idx++;
        }
        pushOperand();
        while(stackIdx !== -1)if (peek() === "(") pop();
        else result.push(pop());
        // If the cache is at capacity, clear it before adding a new item
        if ($2ac27104007dc5a5$export$71ef9c78ba3a183._InfixToPostfixCache.size >= $2ac27104007dc5a5$export$71ef9c78ba3a183.InfixToPostfixCacheLimitSize) $2ac27104007dc5a5$export$71ef9c78ba3a183.ClearCache();
        // Add the new item to the cache, including the current time as the last access time
        $2ac27104007dc5a5$export$71ef9c78ba3a183._InfixToPostfixCache.set(infix, {
            result: result,
            accessTime: Date.now()
        });
        return result;
    }
    static ClearCache() {
        // Convert the cache to an array and sort by last access time
        const sortedCache = Array.from($2ac27104007dc5a5$export$71ef9c78ba3a183._InfixToPostfixCache.entries()).sort((a, b)=>a[1].accessTime - b[1].accessTime);
        // Remove the least recently accessed half of the cache
        for(let i = 0; i < $2ac27104007dc5a5$export$71ef9c78ba3a183.InfixToPostfixCacheCleanupSize; i++)$2ac27104007dc5a5$export$71ef9c78ba3a183._InfixToPostfixCache.delete(sortedCache[i][0]);
    }
}
/**
 * Cache items count limit for the InfixToPostfix cache.
 * It uses to improve the performance of the shader compilation.
 * For details see PR: https://github.com/BabylonJS/Babylon.js/pull/13936
 */ $2ac27104007dc5a5$export$71ef9c78ba3a183.InfixToPostfixCacheLimitSize = 50000;
/**
 * When the cache size is exceeded, a cache cleanup will be triggered
 * and the cache will be reduced by the size specified
 * in the InfixToPostfixCacheCleanupSize variable, removing entries
 * that have not been accessed the longest.
 */ $2ac27104007dc5a5$export$71ef9c78ba3a183.InfixToPostfixCacheCleanupSize = 25000;
$2ac27104007dc5a5$export$71ef9c78ba3a183._InfixToPostfixCache = new Map();
$2ac27104007dc5a5$export$71ef9c78ba3a183._OperatorPriority = {
    ")": 0,
    "(": 1,
    "||": 2,
    "&&": 3
};
$2ac27104007dc5a5$export$71ef9c78ba3a183._Stack = [
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    ""
];

});


parcelRegister("2V8i3", function(module, exports) {

$parcel$export(module.exports, "ShaderDefineOrOperator", () => $220755ed94cfe29a$export$69b3a67fedf1f6bb);

var $3FBHc = parcelRequire("3FBHc");
class $220755ed94cfe29a$export$69b3a67fedf1f6bb extends (0, $3FBHc.ShaderDefineExpression) {
    isTrue(preprocessors) {
        return this.leftOperand.isTrue(preprocessors) || this.rightOperand.isTrue(preprocessors);
    }
}

});

parcelRegister("3gTIF", function(module, exports) {

$parcel$export(module.exports, "ShaderDefineAndOperator", () => $261e1671f43d1b3c$export$9fedfc76ed59009d);

var $3FBHc = parcelRequire("3FBHc");
class $261e1671f43d1b3c$export$9fedfc76ed59009d extends (0, $3FBHc.ShaderDefineExpression) {
    isTrue(preprocessors) {
        return this.leftOperand.isTrue(preprocessors) && this.rightOperand.isTrue(preprocessors);
    }
}

});

parcelRegister("lm1xJ", function(module, exports) {

$parcel$export(module.exports, "ShaderDefineArithmeticOperator", () => $f8bcd971b4e116f5$export$31722351e227a615);

var $3FBHc = parcelRequire("3FBHc");
class $f8bcd971b4e116f5$export$31722351e227a615 extends (0, $3FBHc.ShaderDefineExpression) {
    constructor(define, operand, testValue){
        super();
        this.define = define;
        this.operand = operand;
        this.testValue = testValue;
    }
    isTrue(preprocessors) {
        let value = preprocessors[this.define];
        if (value === undefined) value = this.define;
        let condition = false;
        const left = parseInt(value);
        const right = parseInt(this.testValue);
        switch(this.operand){
            case ">":
                condition = left > right;
                break;
            case "<":
                condition = left < right;
                break;
            case "<=":
                condition = left <= right;
                break;
            case ">=":
                condition = left >= right;
                break;
            case "==":
                condition = left === right;
                break;
            case "!=":
                condition = left !== right;
                break;
        }
        return condition;
    }
}

});

parcelRegister("8WI3I", function(module, exports) {

$parcel$export(module.exports, "ShaderLanguage", () => $6835eab2dae87461$export$96d8560dfee5f47e);
/**
 * Language of the shader code
 */ var $6835eab2dae87461$export$96d8560dfee5f47e;
(function(ShaderLanguage) {
    /** language is GLSL (used by WebGL) */ ShaderLanguage[ShaderLanguage["GLSL"] = 0] = "GLSL";
    /** language is WGSL (used by WebGPU) */ ShaderLanguage[ShaderLanguage["WGSL"] = 1] = "WGSL";
})($6835eab2dae87461$export$96d8560dfee5f47e || ($6835eab2dae87461$export$96d8560dfee5f47e = {}));

});


parcelRegister("2h5JR", function(module, exports) {

$parcel$export(module.exports, "ThinEngine", () => $1a819ede290e980a$export$bfb63ef0b91d03e9);
/* eslint-disable @typescript-eslint/no-unused-vars */ 
var $ejQPp = parcelRequire("ejQPp");

var $lUDWq = parcelRequire("lUDWq");

var $dUFYy = parcelRequire("dUFYy");

var $diGQf = parcelRequire("diGQf");

var $36XJ5 = parcelRequire("36XJ5");

var $d7F9z = parcelRequire("d7F9z");

var $ano9R = parcelRequire("ano9R");

var $b9e4a = parcelRequire("b9e4a");

var $kVtWi = parcelRequire("kVtWi");

var $jFz47 = parcelRequire("jFz47");

var $6faFW = parcelRequire("6faFW");

var $i1R6L = parcelRequire("i1R6L");

var $koExS = parcelRequire("koExS");

var $d6QZE = parcelRequire("d6QZE");

var $3agwF = parcelRequire("3agwF");

var $8ClRi = parcelRequire("8ClRi");

var $hOyoX = parcelRequire("hOyoX");

var $cyIBx = parcelRequire("cyIBx");

var $8WI3I = parcelRequire("8WI3I");

var $blHSI = parcelRequire("blHSI");
/**
 * Keeps track of all the buffer info used in engine.
 */ class $1a819ede290e980a$var$BufferPointer {
}
class $1a819ede290e980a$export$bfb63ef0b91d03e9 {
    /**
     * Returns the current npm package of the sdk
     */ // Not mixed with Version for tooling purpose.
    static get NpmPackage() {
        return "babylonjs@6.49.0";
    }
    /**
     * Returns the current version of the framework
     */ static get Version() {
        return "6.49.0";
    }
    /**
     * Returns a string describing the current engine
     */ get description() {
        let description = this.name + this.webGLVersion;
        if (this._caps.parallelShaderCompile) description += " - Parallel shader compilation";
        return description;
    }
    /**
     * Gets or sets the name of the engine
     */ get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }
    /**
     * Returns the version of the engine
     */ get version() {
        return this._webGLVersion;
    }
    get isDisposed() {
        return this._isDisposed;
    }
    /**
     * Gets or sets the relative url used to load shaders if using the engine in non-minified mode
     */ static get ShadersRepository() {
        return (0, $lUDWq.Effect).ShadersRepository;
    }
    static set ShadersRepository(value) {
        (0, $lUDWq.Effect).ShadersRepository = value;
    }
    /**
     * @internal
     */ _getShaderProcessor(shaderLanguage) {
        return this._shaderProcessor;
    }
    /**
     * Gets or sets a boolean indicating if depth buffer should be reverse, going from far to near.
     * This can provide greater z depth for distant objects.
     */ get useReverseDepthBuffer() {
        return this._useReverseDepthBuffer;
    }
    set useReverseDepthBuffer(useReverse) {
        if (useReverse === this._useReverseDepthBuffer) return;
        this._useReverseDepthBuffer = useReverse;
        if (useReverse) this._depthCullingState.depthFunc = 518;
        else this._depthCullingState.depthFunc = 515;
    }
    /**
     * Gets the current frame id
     */ get frameId() {
        return this._frameId;
    }
    /**
     * Gets a boolean indicating that the engine supports uniform buffers
     * @see https://doc.babylonjs.com/setup/support/webGL2#uniform-buffer-objets
     */ get supportsUniformBuffers() {
        return this.webGLVersion > 1 && !this.disableUniformBuffers;
    }
    /**
     * Gets the options used for engine creation
     * @returns EngineOptions object
     */ getCreationOptions() {
        return this._creationOptions;
    }
    /** @internal */ get _shouldUseHighPrecisionShader() {
        return !!(this._caps.highPrecisionShaderSupported && this._highPrecisionShadersAllowed);
    }
    /**
     * Gets a boolean indicating that only power of 2 textures are supported
     * Please note that you can still use non power of 2 textures but in this case the engine will forcefully convert them
     */ get needPOTTextures() {
        return this._webGLVersion < 2 || this.forcePOTTextures;
    }
    /**
     * Gets the list of current active render loop functions
     * @returns a read only array with the current render loop functions
     */ get activeRenderLoops() {
        return this._activeRenderLoops;
    }
    /**
     * Gets or sets a boolean indicating if resources should be retained to be able to handle context lost events
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/optimize_your_scene#handling-webgl-context-lost
     */ get doNotHandleContextLost() {
        return this._doNotHandleContextLost;
    }
    set doNotHandleContextLost(value) {
        this._doNotHandleContextLost = value;
    }
    get _supportsHardwareTextureRescaling() {
        return false;
    }
    /**
     * sets the object from which width and height will be taken from when getting render width and height
     * Will fallback to the gl object
     * @param dimensions the framebuffer width and height that will be used.
     */ set framebufferDimensionsObject(dimensions) {
        this._framebufferDimensionsObject = dimensions;
    }
    /**
     * Gets the current viewport
     */ get currentViewport() {
        return this._cachedViewport;
    }
    /**
     * Gets the default empty texture
     */ get emptyTexture() {
        if (!this._emptyTexture) this._emptyTexture = this.createRawTexture(new Uint8Array(4), 1, 1, 5, false, false, 1);
        return this._emptyTexture;
    }
    /**
     * Gets the default empty 3D texture
     */ get emptyTexture3D() {
        if (!this._emptyTexture3D) this._emptyTexture3D = this.createRawTexture3D(new Uint8Array(4), 1, 1, 1, 5, false, false, 1);
        return this._emptyTexture3D;
    }
    /**
     * Gets the default empty 2D array texture
     */ get emptyTexture2DArray() {
        if (!this._emptyTexture2DArray) this._emptyTexture2DArray = this.createRawTexture2DArray(new Uint8Array(4), 1, 1, 1, 5, false, false, 1);
        return this._emptyTexture2DArray;
    }
    /**
     * Gets the default empty cube texture
     */ get emptyCubeTexture() {
        if (!this._emptyCubeTexture) {
            const faceData = new Uint8Array(4);
            const cubeData = [
                faceData,
                faceData,
                faceData,
                faceData,
                faceData,
                faceData
            ];
            this._emptyCubeTexture = this.createRawCubeTexture(cubeData, 1, 5, 0, false, false, 1);
        }
        return this._emptyCubeTexture;
    }
    /**
     * Gets a boolean indicating if the engine runs in WebGPU or not.
     */ get isWebGPU() {
        return this._isWebGPU;
    }
    /**
     * Gets the shader platform name used by the effects.
     */ get shaderPlatformName() {
        return this._shaderPlatformName;
    }
    /**
     * Enables or disables the snapshot rendering mode
     * Note that the WebGL engine does not support snapshot rendering so setting the value won't have any effect for this engine
     */ get snapshotRendering() {
        return false;
    }
    set snapshotRendering(activate) {
    // WebGL engine does not support snapshot rendering
    }
    /**
     * Gets or sets the snapshot rendering mode
     */ get snapshotRenderingMode() {
        return this._snapshotRenderingMode;
    }
    set snapshotRenderingMode(mode) {
        this._snapshotRenderingMode = mode;
    }
    /**
     * Creates a new snapshot at the next frame using the current snapshotRenderingMode
     */ snapshotRenderingReset() {
        this.snapshotRendering = false;
    }
    static _CreateCanvas(width, height) {
        if (typeof document === "undefined") return new OffscreenCanvas(width, height);
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
    /**
     * Create a canvas. This method is overridden by other engines
     * @param width width
     * @param height height
     * @returns ICanvas interface
     */ createCanvas(width, height) {
        return $1a819ede290e980a$export$bfb63ef0b91d03e9._CreateCanvas(width, height);
    }
    /**
     * Create an image to use with canvas
     * @returns IImage interface
     */ createCanvasImage() {
        return document.createElement("img");
    }
    /**
     * Creates a new engine
     * @param canvasOrContext defines the canvas or WebGL context to use for rendering. If you provide a WebGL context, Babylon.js will not hook events on the canvas (like pointers, keyboards, etc...) so no event observables will be available. This is mostly used when Babylon.js is used as a plugin on a system which already used the WebGL context
     * @param antialias defines enable antialiasing (default: false)
     * @param options defines further options to be sent to the getContext() function
     * @param adaptToDeviceRatio defines whether to adapt to the device's viewport characteristics (default: false)
     */ constructor(canvasOrContext, antialias, options, adaptToDeviceRatio){
        /** @internal */ this._name = "WebGL";
        this._isDisposed = false;
        /**
         * Gets or sets a boolean that indicates if textures must be forced to power of 2 size even if not required
         */ this.forcePOTTextures = false;
        /**
         * Gets a boolean indicating if the engine is currently rendering in fullscreen mode
         */ this.isFullscreen = false;
        /**
         * Gets or sets a boolean indicating if back faces must be culled. If false, front faces are culled instead (true by default)
         * If non null, this takes precedence over the value from the material
         */ this.cullBackFaces = null;
        /**
         * Gets or sets a boolean indicating if the engine must keep rendering even if the window is not in foreground
         */ this.renderEvenInBackground = true;
        /**
         * Gets or sets a boolean indicating that cache can be kept between frames
         */ this.preventCacheWipeBetweenFrames = false;
        /** Gets or sets a boolean indicating if the engine should validate programs after compilation */ this.validateShaderPrograms = false;
        this._useReverseDepthBuffer = false;
        /**
         * Indicates if the z range in NDC space is 0..1 (value: true) or -1..1 (value: false)
         */ this.isNDCHalfZRange = false;
        /**
         * Indicates that the origin of the texture/framebuffer space is the bottom left corner. If false, the origin is top left
         */ this.hasOriginBottomLeft = true;
        /**
         * Gets or sets a boolean indicating that uniform buffers must be disabled even if they are supported
         */ this.disableUniformBuffers = false;
        /**
         * An event triggered when the engine is disposed.
         */ this.onDisposeObservable = new (0, $diGQf.Observable)();
        this._frameId = 0;
        /** @internal */ this._uniformBuffers = new Array();
        /** @internal */ this._storageBuffers = new Array();
        /** @internal */ this._webGLVersion = 1.0;
        this._windowIsBackground = false;
        this._highPrecisionShadersAllowed = true;
        /** @internal */ this._badOS = false;
        /** @internal */ this._badDesktopOS = false;
        this._activeRenderLoops = new Array();
        // Lost context
        /**
         * Observable signaled when a context lost event is raised
         */ this.onContextLostObservable = new (0, $diGQf.Observable)();
        /**
         * Observable signaled when a context restored event is raised
         */ this.onContextRestoredObservable = new (0, $diGQf.Observable)();
        this._contextWasLost = false;
        /** @internal */ this._doNotHandleContextLost = false;
        /**
         * Gets or sets a boolean indicating that vertex array object must be disabled even if they are supported
         */ this.disableVertexArrayObjects = false;
        // States
        /** @internal */ this._colorWrite = true;
        /** @internal */ this._colorWriteChanged = true;
        /** @internal */ this._depthCullingState = new (0, $36XJ5.DepthCullingState)();
        /** @internal */ this._stencilStateComposer = new (0, $cyIBx.StencilStateComposer)();
        /** @internal */ this._stencilState = new (0, $d7F9z.StencilState)();
        /** @internal */ this._alphaState = new (0, $ano9R.AlphaState)();
        /** @internal */ this._alphaMode = 1;
        /** @internal */ this._alphaEquation = 0;
        // Cache
        /** @internal */ this._internalTexturesCache = new Array();
        /** @internal */ this._renderTargetWrapperCache = new Array();
        /** @internal */ this._activeChannel = 0;
        this._currentTextureChannel = -1;
        /** @internal */ this._boundTexturesCache = {};
        this._compiledEffects = {};
        this._vertexAttribArraysEnabled = [];
        /** @internal */ this._currentRenderTarget = null;
        this._uintIndicesCurrentlySet = false;
        this._currentBoundBuffer = new Array();
        /** @internal */ this._currentFramebuffer = null;
        /** @internal */ this._dummyFramebuffer = null;
        this._currentBufferPointers = new Array();
        this._currentInstanceLocations = new Array();
        this._currentInstanceBuffers = new Array();
        /** @internal */ this._boundRenderFunction = ()=>this._renderLoop();
        this._vaoRecordInProgress = false;
        this._mustWipeVertexAttributes = false;
        /** @internal */ this._frameHandler = 0;
        this._nextFreeTextureSlots = new Array();
        this._maxSimultaneousTextures = 0;
        this._maxMSAASamplesOverride = null;
        this._activeRequests = new Array();
        /**
         * If set to true zooming in and out in the browser will rescale the hardware-scaling correctly.
         */ this.adaptToDeviceRatio = false;
        /** @internal */ this._lastDevicePixelRatio = 1.0;
        /** @internal */ this._transformTextureUrl = null;
        /**
         * Gets information about the current host
         */ this.hostInformation = {
            isMobile: false
        };
        /**
         * Defines whether the engine has been created with the premultipliedAlpha option on or not.
         */ this.premultipliedAlpha = true;
        /**
         * Observable event triggered before each texture is initialized
         */ this.onBeforeTextureInitObservable = new (0, $diGQf.Observable)();
        /** @internal */ this._isWebGPU = false;
        this._snapshotRenderingMode = 0;
        this._viewportCached = {
            x: 0,
            y: 0,
            z: 0,
            w: 0
        };
        this._unpackFlipYCached = null;
        /**
         * In case you are sharing the context with other applications, it might
         * be interested to not cache the unpack flip y state to ensure a consistent
         * value would be set.
         */ this.enableUnpackFlipYCached = true;
        this._boundUniforms = {};
        this.startTime = (0, $blHSI.PrecisionDate).Now;
        let canvas = null;
        options = options || {};
        this._creationOptions = options;
        // Save this off for use in resize().
        this.adaptToDeviceRatio = adaptToDeviceRatio ?? false;
        this._stencilStateComposer.stencilGlobal = this._stencilState;
        (0, $3agwF.PerformanceConfigurator).SetMatrixPrecision(!!options.useHighPrecisionMatrix);
        options.antialias = antialias ?? options.antialias;
        options.deterministicLockstep = options.deterministicLockstep ?? false;
        options.lockstepMaxSteps = options.lockstepMaxSteps ?? 4;
        options.timeStep = options.timeStep ?? 1 / 60;
        options.audioEngine = options.audioEngine ?? true;
        options.stencil = options.stencil ?? true;
        this._audioContext = options.audioEngineOptions?.audioContext ?? null;
        this._audioDestination = options.audioEngineOptions?.audioDestination ?? null;
        this.premultipliedAlpha = options.premultipliedAlpha ?? true;
        this.useExactSrgbConversions = options.useExactSrgbConversions ?? false;
        this._doNotHandleContextLost = !!options.doNotHandleContextLost;
        this._isStencilEnable = options.stencil ? true : false;
        // Viewport
        adaptToDeviceRatio = adaptToDeviceRatio || options.adaptToDeviceRatio || false;
        const devicePixelRatio = (0, $jFz47.IsWindowObjectExist)() ? window.devicePixelRatio || 1.0 : 1.0;
        const limitDeviceRatio = options.limitDeviceRatio || devicePixelRatio;
        this._hardwareScalingLevel = adaptToDeviceRatio ? 1.0 / Math.min(limitDeviceRatio, devicePixelRatio) : 1.0;
        this._lastDevicePixelRatio = devicePixelRatio;
        if (!canvasOrContext) return;
        if (canvasOrContext.getContext) {
            canvas = canvasOrContext;
            this._renderingCanvas = canvas;
            if (options.preserveDrawingBuffer === undefined) options.preserveDrawingBuffer = false;
            if (options.xrCompatible === undefined) options.xrCompatible = true;
            // Exceptions
            if (navigator && navigator.userAgent) {
                this._setupMobileChecks();
                const ua = navigator.userAgent;
                for (const exception of $1a819ede290e980a$export$bfb63ef0b91d03e9.ExceptionList){
                    const key = exception.key;
                    const targets = exception.targets;
                    const check = new RegExp(key);
                    if (check.test(ua)) {
                        if (exception.capture && exception.captureConstraint) {
                            const capture = exception.capture;
                            const constraint = exception.captureConstraint;
                            const regex = new RegExp(capture);
                            const matches = regex.exec(ua);
                            if (matches && matches.length > 0) {
                                const capturedValue = parseInt(matches[matches.length - 1]);
                                if (capturedValue >= constraint) continue;
                            }
                        }
                        for (const target of targets)switch(target){
                            case "uniformBuffer":
                                this.disableUniformBuffers = true;
                                break;
                            case "vao":
                                this.disableVertexArrayObjects = true;
                                break;
                            case "antialias":
                                options.antialias = false;
                                break;
                            case "maxMSAASamples":
                                this._maxMSAASamplesOverride = 1;
                                break;
                        }
                    }
                }
            }
            // Context lost
            if (!this._doNotHandleContextLost) {
                this._onContextLost = (evt)=>{
                    evt.preventDefault();
                    this._contextWasLost = true;
                    (0, $kVtWi.Logger).Warn("WebGL context lost.");
                    this.onContextLostObservable.notifyObservers(this);
                };
                this._onContextRestored = ()=>{
                    this._restoreEngineAfterContextLost(()=>this._initGLContext());
                };
                canvas.addEventListener("webglcontextlost", this._onContextLost, false);
                canvas.addEventListener("webglcontextrestored", this._onContextRestored, false);
                options.powerPreference = options.powerPreference || "high-performance";
            }
            // Detect if we are running on a faulty buggy desktop OS.
            this._badDesktopOS = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            if (this._badDesktopOS) options.xrCompatible = false;
            // GL
            if (!options.disableWebGL2Support) try {
                this._gl = canvas.getContext("webgl2", options) || canvas.getContext("experimental-webgl2", options);
                if (this._gl) {
                    this._webGLVersion = 2.0;
                    this._shaderPlatformName = "WEBGL2";
                    // Prevent weird browsers to lie (yeah that happens!)
                    if (!this._gl.deleteQuery) {
                        this._webGLVersion = 1.0;
                        this._shaderPlatformName = "WEBGL1";
                    }
                }
            } catch (e) {
            // Do nothing
            }
            if (!this._gl) {
                if (!canvas) throw new Error("The provided canvas is null or undefined.");
                try {
                    this._gl = canvas.getContext("webgl", options) || canvas.getContext("experimental-webgl", options);
                } catch (e) {
                    throw new Error("WebGL not supported");
                }
            }
            if (!this._gl) throw new Error("WebGL not supported");
        } else {
            this._gl = canvasOrContext;
            this._renderingCanvas = this._gl.canvas;
            if (this._gl.renderbufferStorageMultisample) {
                this._webGLVersion = 2.0;
                this._shaderPlatformName = "WEBGL2";
            } else this._shaderPlatformName = "WEBGL1";
            const attributes = this._gl.getContextAttributes();
            if (attributes) options.stencil = attributes.stencil;
        }
        // Ensures a consistent color space unpacking of textures cross browser.
        this._gl.pixelStorei(this._gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, this._gl.NONE);
        if (options.useHighPrecisionFloats !== undefined) this._highPrecisionShadersAllowed = options.useHighPrecisionFloats;
        this.resize();
        this._initGLContext();
        this._initFeatures();
        // Prepare buffer pointers
        for(let i = 0; i < this._caps.maxVertexAttribs; i++)this._currentBufferPointers[i] = new $1a819ede290e980a$var$BufferPointer();
        // Shader processor
        this._shaderProcessor = this.webGLVersion > 1 ? new (0, $i1R6L.WebGL2ShaderProcessor)() : new (0, $6faFW.WebGLShaderProcessor)();
        // Detect if we are running on a faulty buggy OS.
        this._badOS = /iPad/i.test(navigator.userAgent) || /iPhone/i.test(navigator.userAgent);
        // Starting with iOS 14, we can trust the browser
        // let matches = navigator.userAgent.match(/Version\/(\d+)/);
        // if (matches && matches.length === 2) {
        //     if (parseInt(matches[1]) >= 14) {
        //         this._badOS = false;
        //     }
        // }
        const versionToLog = `Babylon.js v${$1a819ede290e980a$export$bfb63ef0b91d03e9.Version}`;
        (0, $kVtWi.Logger).Log(versionToLog + ` - ${this.description}`);
        // Check setAttribute in case of workers
        if (this._renderingCanvas && this._renderingCanvas.setAttribute) this._renderingCanvas.setAttribute("data-engine", versionToLog);
    }
    _setupMobileChecks() {
        if (!(navigator && navigator.userAgent)) return;
        // Function to check if running on mobile device
        this._checkForMobile = ()=>{
            const currentUA = navigator.userAgent;
            this.hostInformation.isMobile = currentUA.indexOf("Mobile") !== -1 || // Needed for iOS 13+ detection on iPad (inspired by solution from https://stackoverflow.com/questions/9038625/detect-if-device-is-ios)
            currentUA.indexOf("Mac") !== -1 && (0, $jFz47.IsDocumentAvailable)() && "ontouchend" in document;
        };
        // Set initial isMobile value
        this._checkForMobile();
        // Set up event listener to check when window is resized (used to get emulator activation to work properly)
        if ((0, $jFz47.IsWindowObjectExist)()) window.addEventListener("resize", this._checkForMobile);
    }
    _clearEmptyResources() {
        this._dummyFramebuffer = null;
        this._emptyTexture = null;
        this._emptyCubeTexture = null;
        this._emptyTexture3D = null;
        this._emptyTexture2DArray = null;
    }
    _rebuildGraphicsResources() {
        // Ensure webgl and engine states are matching
        this.wipeCaches(true);
        // Rebuild effects
        this._rebuildEffects();
        this._rebuildComputeEffects?.();
        // Note:
        //  The call to _rebuildBuffers must be made before the call to _rebuildInternalTextures because in the process of _rebuildBuffers the buffers used by the post process managers will be rebuilt
        //  and we may need to use the post process manager of the scene during _rebuildInternalTextures (in WebGL1, non-POT textures are rescaled using a post process + post process manager of the scene)
        // Rebuild buffers
        this._rebuildBuffers();
        // Rebuild textures
        this._rebuildInternalTextures();
        // Rebuild textures
        this._rebuildTextures();
        // Rebuild textures
        this._rebuildRenderTargetWrappers();
        // Reset engine states after all the buffer/textures/... have been rebuilt
        this.wipeCaches(true);
    }
    _flagContextRestored() {
        (0, $kVtWi.Logger).Warn(this.name + " context successfully restored.");
        this.onContextRestoredObservable.notifyObservers(this);
        this._contextWasLost = false;
    }
    _restoreEngineAfterContextLost(initEngine) {
        // Adding a timeout to avoid race condition at browser level
        setTimeout(async ()=>{
            this._clearEmptyResources();
            const depthTest = this._depthCullingState.depthTest; // backup those values because the call to initEngine / wipeCaches will reset them
            const depthFunc = this._depthCullingState.depthFunc;
            const depthMask = this._depthCullingState.depthMask;
            const stencilTest = this._stencilState.stencilTest;
            // Rebuild context
            await initEngine();
            this._rebuildGraphicsResources();
            this._depthCullingState.depthTest = depthTest;
            this._depthCullingState.depthFunc = depthFunc;
            this._depthCullingState.depthMask = depthMask;
            this._stencilState.stencilTest = stencilTest;
            this._flagContextRestored();
        }, 0);
    }
    /**
     * Shared initialization across engines types.
     * @param canvas The canvas associated with this instance of the engine.
     */ _sharedInit(canvas) {
        this._renderingCanvas = canvas;
    }
    /**
     * @internal
     */ _getShaderProcessingContext(shaderLanguage) {
        return null;
    }
    _rebuildInternalTextures() {
        const currentState = this._internalTexturesCache.slice(); // Do a copy because the rebuild will add proxies
        for (const internalTexture of currentState)internalTexture._rebuild();
    }
    _rebuildRenderTargetWrappers() {
        const currentState = this._renderTargetWrapperCache.slice(); // Do a copy because the rebuild will add proxies
        for (const renderTargetWrapper of currentState)renderTargetWrapper._rebuild();
    }
    _rebuildEffects() {
        for(const key in this._compiledEffects){
            const effect = this._compiledEffects[key];
            effect._pipelineContext = null; // because _prepareEffect will try to dispose this pipeline before recreating it and that would lead to webgl errors
            effect._prepareEffect();
        }
        (0, $lUDWq.Effect).ResetCache();
    }
    /**
     * Gets a boolean indicating if all created effects are ready
     * @returns true if all effects are ready
     */ areAllEffectsReady() {
        for(const key in this._compiledEffects){
            const effect = this._compiledEffects[key];
            if (!effect.isReady()) return false;
        }
        return true;
    }
    _rebuildBuffers() {
        // Uniforms
        for (const uniformBuffer of this._uniformBuffers)uniformBuffer._rebuildAfterContextLost();
    }
    _rebuildTextures() {}
    _initGLContext() {
        // Caps
        this._caps = {
            maxTexturesImageUnits: this._gl.getParameter(this._gl.MAX_TEXTURE_IMAGE_UNITS),
            maxCombinedTexturesImageUnits: this._gl.getParameter(this._gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS),
            maxVertexTextureImageUnits: this._gl.getParameter(this._gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS),
            maxTextureSize: this._gl.getParameter(this._gl.MAX_TEXTURE_SIZE),
            maxSamples: this._webGLVersion > 1 ? this._gl.getParameter(this._gl.MAX_SAMPLES) : 1,
            maxCubemapTextureSize: this._gl.getParameter(this._gl.MAX_CUBE_MAP_TEXTURE_SIZE),
            maxRenderTextureSize: this._gl.getParameter(this._gl.MAX_RENDERBUFFER_SIZE),
            maxVertexAttribs: this._gl.getParameter(this._gl.MAX_VERTEX_ATTRIBS),
            maxVaryingVectors: this._gl.getParameter(this._gl.MAX_VARYING_VECTORS),
            maxFragmentUniformVectors: this._gl.getParameter(this._gl.MAX_FRAGMENT_UNIFORM_VECTORS),
            maxVertexUniformVectors: this._gl.getParameter(this._gl.MAX_VERTEX_UNIFORM_VECTORS),
            parallelShaderCompile: this._gl.getExtension("KHR_parallel_shader_compile") || undefined,
            standardDerivatives: this._webGLVersion > 1 || this._gl.getExtension("OES_standard_derivatives") !== null,
            maxAnisotropy: 1,
            astc: this._gl.getExtension("WEBGL_compressed_texture_astc") || this._gl.getExtension("WEBKIT_WEBGL_compressed_texture_astc"),
            bptc: this._gl.getExtension("EXT_texture_compression_bptc") || this._gl.getExtension("WEBKIT_EXT_texture_compression_bptc"),
            s3tc: this._gl.getExtension("WEBGL_compressed_texture_s3tc") || this._gl.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc"),
            // eslint-disable-next-line @typescript-eslint/naming-convention
            s3tc_srgb: this._gl.getExtension("WEBGL_compressed_texture_s3tc_srgb") || this._gl.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc_srgb"),
            pvrtc: this._gl.getExtension("WEBGL_compressed_texture_pvrtc") || this._gl.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc"),
            etc1: this._gl.getExtension("WEBGL_compressed_texture_etc1") || this._gl.getExtension("WEBKIT_WEBGL_compressed_texture_etc1"),
            etc2: this._gl.getExtension("WEBGL_compressed_texture_etc") || this._gl.getExtension("WEBKIT_WEBGL_compressed_texture_etc") || this._gl.getExtension("WEBGL_compressed_texture_es3_0"),
            textureAnisotropicFilterExtension: this._gl.getExtension("EXT_texture_filter_anisotropic") || this._gl.getExtension("WEBKIT_EXT_texture_filter_anisotropic") || this._gl.getExtension("MOZ_EXT_texture_filter_anisotropic"),
            uintIndices: this._webGLVersion > 1 || this._gl.getExtension("OES_element_index_uint") !== null,
            fragmentDepthSupported: this._webGLVersion > 1 || this._gl.getExtension("EXT_frag_depth") !== null,
            highPrecisionShaderSupported: false,
            timerQuery: this._gl.getExtension("EXT_disjoint_timer_query_webgl2") || this._gl.getExtension("EXT_disjoint_timer_query"),
            supportOcclusionQuery: this._webGLVersion > 1,
            canUseTimestampForTimerQuery: false,
            drawBuffersExtension: false,
            maxMSAASamples: 1,
            colorBufferFloat: !!(this._webGLVersion > 1 && this._gl.getExtension("EXT_color_buffer_float")),
            supportFloatTexturesResolve: false,
            rg11b10ufColorRenderable: false,
            colorBufferHalfFloat: !!(this._webGLVersion > 1 && this._gl.getExtension("EXT_color_buffer_half_float")),
            textureFloat: this._webGLVersion > 1 || this._gl.getExtension("OES_texture_float") ? true : false,
            textureHalfFloat: this._webGLVersion > 1 || this._gl.getExtension("OES_texture_half_float") ? true : false,
            textureHalfFloatRender: false,
            textureFloatLinearFiltering: false,
            textureFloatRender: false,
            textureHalfFloatLinearFiltering: false,
            vertexArrayObject: false,
            instancedArrays: false,
            textureLOD: this._webGLVersion > 1 || this._gl.getExtension("EXT_shader_texture_lod") ? true : false,
            texelFetch: this._webGLVersion !== 1,
            blendMinMax: false,
            multiview: this._gl.getExtension("OVR_multiview2"),
            oculusMultiview: this._gl.getExtension("OCULUS_multiview"),
            depthTextureExtension: false,
            canUseGLInstanceID: this._webGLVersion > 1,
            canUseGLVertexID: this._webGLVersion > 1,
            supportComputeShaders: false,
            supportSRGBBuffers: false,
            supportTransformFeedbacks: this._webGLVersion > 1,
            textureMaxLevel: this._webGLVersion > 1,
            texture2DArrayMaxLayerCount: this._webGLVersion > 1 ? this._gl.getParameter(this._gl.MAX_ARRAY_TEXTURE_LAYERS) : 128,
            disableMorphTargetTexture: false
        };
        this._caps.supportFloatTexturesResolve = this._caps.colorBufferFloat;
        this._caps.rg11b10ufColorRenderable = this._caps.colorBufferFloat;
        // Infos
        this._glVersion = this._gl.getParameter(this._gl.VERSION);
        const rendererInfo = this._gl.getExtension("WEBGL_debug_renderer_info");
        if (rendererInfo != null) {
            this._glRenderer = this._gl.getParameter(rendererInfo.UNMASKED_RENDERER_WEBGL);
            this._glVendor = this._gl.getParameter(rendererInfo.UNMASKED_VENDOR_WEBGL);
        }
        if (!this._glVendor) this._glVendor = this._gl.getParameter(this._gl.VENDOR) || "Unknown vendor";
        if (!this._glRenderer) this._glRenderer = this._gl.getParameter(this._gl.RENDERER) || "Unknown renderer";
        // Constants
        if (this._gl.HALF_FLOAT_OES !== 0x8d61) this._gl.HALF_FLOAT_OES = 0x8d61; // Half floating-point type (16-bit).
        if (this._gl.RGBA16F !== 0x881a) this._gl.RGBA16F = 0x881a; // RGBA 16-bit floating-point color-renderable internal sized format.
        if (this._gl.RGBA32F !== 0x8814) this._gl.RGBA32F = 0x8814; // RGBA 32-bit floating-point color-renderable internal sized format.
        if (this._gl.DEPTH24_STENCIL8 !== 35056) this._gl.DEPTH24_STENCIL8 = 35056;
        // Extensions
        if (this._caps.timerQuery) {
            if (this._webGLVersion === 1) this._gl.getQuery = this._caps.timerQuery.getQueryEXT.bind(this._caps.timerQuery);
            // WebGLQuery casted to number to avoid TS error
            this._caps.canUseTimestampForTimerQuery = (this._gl.getQuery(this._caps.timerQuery.TIMESTAMP_EXT, this._caps.timerQuery.QUERY_COUNTER_BITS_EXT) ?? 0) > 0;
        }
        this._caps.maxAnisotropy = this._caps.textureAnisotropicFilterExtension ? this._gl.getParameter(this._caps.textureAnisotropicFilterExtension.MAX_TEXTURE_MAX_ANISOTROPY_EXT) : 0;
        this._caps.textureFloatLinearFiltering = this._caps.textureFloat && this._gl.getExtension("OES_texture_float_linear") ? true : false;
        this._caps.textureFloatRender = this._caps.textureFloat && this._canRenderToFloatFramebuffer() ? true : false;
        this._caps.textureHalfFloatLinearFiltering = this._webGLVersion > 1 || this._caps.textureHalfFloat && this._gl.getExtension("OES_texture_half_float_linear") ? true : false;
        // Compressed formats
        if (this._caps.astc) this._gl.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR = this._caps.astc.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR;
        if (this._caps.bptc) this._gl.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT = this._caps.bptc.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT;
        if (this._caps.s3tc_srgb) {
            this._gl.COMPRESSED_SRGB_S3TC_DXT1_EXT = this._caps.s3tc_srgb.COMPRESSED_SRGB_S3TC_DXT1_EXT;
            this._gl.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT = this._caps.s3tc_srgb.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
            this._gl.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT = this._caps.s3tc_srgb.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
        }
        if (this._caps.etc2) {
            this._gl.COMPRESSED_SRGB8_ETC2 = this._caps.etc2.COMPRESSED_SRGB8_ETC2;
            this._gl.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC = this._caps.etc2.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC;
        }
        // Checks if some of the format renders first to allow the use of webgl inspector.
        if (this._webGLVersion > 1) {
            if (this._gl.HALF_FLOAT_OES !== 0x140b) this._gl.HALF_FLOAT_OES = 0x140b;
        }
        this._caps.textureHalfFloatRender = this._caps.textureHalfFloat && this._canRenderToHalfFloatFramebuffer();
        // Draw buffers
        if (this._webGLVersion > 1) {
            this._caps.drawBuffersExtension = true;
            this._caps.maxMSAASamples = this._maxMSAASamplesOverride !== null ? this._maxMSAASamplesOverride : this._gl.getParameter(this._gl.MAX_SAMPLES);
        } else {
            const drawBuffersExtension = this._gl.getExtension("WEBGL_draw_buffers");
            if (drawBuffersExtension !== null) {
                this._caps.drawBuffersExtension = true;
                this._gl.drawBuffers = drawBuffersExtension.drawBuffersWEBGL.bind(drawBuffersExtension);
                this._gl.DRAW_FRAMEBUFFER = this._gl.FRAMEBUFFER;
                for(let i = 0; i < 16; i++)this._gl["COLOR_ATTACHMENT" + i + "_WEBGL"] = drawBuffersExtension["COLOR_ATTACHMENT" + i + "_WEBGL"];
            }
        }
        // Depth Texture
        if (this._webGLVersion > 1) this._caps.depthTextureExtension = true;
        else {
            const depthTextureExtension = this._gl.getExtension("WEBGL_depth_texture");
            if (depthTextureExtension != null) {
                this._caps.depthTextureExtension = true;
                this._gl.UNSIGNED_INT_24_8 = depthTextureExtension.UNSIGNED_INT_24_8_WEBGL;
            }
        }
        // Vertex array object
        if (this.disableVertexArrayObjects) this._caps.vertexArrayObject = false;
        else if (this._webGLVersion > 1) this._caps.vertexArrayObject = true;
        else {
            const vertexArrayObjectExtension = this._gl.getExtension("OES_vertex_array_object");
            if (vertexArrayObjectExtension != null) {
                this._caps.vertexArrayObject = true;
                this._gl.createVertexArray = vertexArrayObjectExtension.createVertexArrayOES.bind(vertexArrayObjectExtension);
                this._gl.bindVertexArray = vertexArrayObjectExtension.bindVertexArrayOES.bind(vertexArrayObjectExtension);
                this._gl.deleteVertexArray = vertexArrayObjectExtension.deleteVertexArrayOES.bind(vertexArrayObjectExtension);
            }
        }
        // Instances count
        if (this._webGLVersion > 1) this._caps.instancedArrays = true;
        else {
            const instanceExtension = this._gl.getExtension("ANGLE_instanced_arrays");
            if (instanceExtension != null) {
                this._caps.instancedArrays = true;
                this._gl.drawArraysInstanced = instanceExtension.drawArraysInstancedANGLE.bind(instanceExtension);
                this._gl.drawElementsInstanced = instanceExtension.drawElementsInstancedANGLE.bind(instanceExtension);
                this._gl.vertexAttribDivisor = instanceExtension.vertexAttribDivisorANGLE.bind(instanceExtension);
            } else this._caps.instancedArrays = false;
        }
        if (this._gl.getShaderPrecisionFormat) {
            const vertexhighp = this._gl.getShaderPrecisionFormat(this._gl.VERTEX_SHADER, this._gl.HIGH_FLOAT);
            const fragmenthighp = this._gl.getShaderPrecisionFormat(this._gl.FRAGMENT_SHADER, this._gl.HIGH_FLOAT);
            if (vertexhighp && fragmenthighp) this._caps.highPrecisionShaderSupported = vertexhighp.precision !== 0 && fragmenthighp.precision !== 0;
        }
        if (this._webGLVersion > 1) this._caps.blendMinMax = true;
        else {
            const blendMinMaxExtension = this._gl.getExtension("EXT_blend_minmax");
            if (blendMinMaxExtension != null) {
                this._caps.blendMinMax = true;
                this._gl.MAX = blendMinMaxExtension.MAX_EXT;
                this._gl.MIN = blendMinMaxExtension.MIN_EXT;
            }
        }
        // sRGB buffers
        // only run this if not already set to true (in the constructor, for example)
        if (!this._caps.supportSRGBBuffers) {
            if (this._webGLVersion > 1) {
                this._caps.supportSRGBBuffers = true;
                this._glSRGBExtensionValues = {
                    SRGB: WebGL2RenderingContext.SRGB,
                    SRGB8: WebGL2RenderingContext.SRGB8,
                    SRGB8_ALPHA8: WebGL2RenderingContext.SRGB8_ALPHA8
                };
            } else {
                const sRGBExtension = this._gl.getExtension("EXT_sRGB");
                if (sRGBExtension != null) {
                    this._caps.supportSRGBBuffers = true;
                    this._glSRGBExtensionValues = {
                        SRGB: sRGBExtension.SRGB_EXT,
                        SRGB8: sRGBExtension.SRGB_ALPHA_EXT,
                        SRGB8_ALPHA8: sRGBExtension.SRGB_ALPHA_EXT
                    };
                }
            }
            // take into account the forced state that was provided in options
            // When the issue in angle/chrome is fixed the flag should be taken into account only when it is explicitly defined
            this._caps.supportSRGBBuffers = this._caps.supportSRGBBuffers && !!(this._creationOptions && this._creationOptions.forceSRGBBufferSupportState);
        }
        // Depth buffer
        this._depthCullingState.depthTest = true;
        this._depthCullingState.depthFunc = this._gl.LEQUAL;
        this._depthCullingState.depthMask = true;
        // Texture maps
        this._maxSimultaneousTextures = this._caps.maxCombinedTexturesImageUnits;
        for(let slot = 0; slot < this._maxSimultaneousTextures; slot++)this._nextFreeTextureSlots.push(slot);
        if (this._glRenderer === "Mali-G72") // Overcome a bug when using a texture to store morph targets on Mali-G72
        this._caps.disableMorphTargetTexture = true;
    }
    _initFeatures() {
        this._features = {
            forceBitmapOverHTMLImageElement: typeof HTMLImageElement === "undefined",
            supportRenderAndCopyToLodForFloatTextures: this._webGLVersion !== 1,
            supportDepthStencilTexture: this._webGLVersion !== 1,
            supportShadowSamplers: this._webGLVersion !== 1,
            uniformBufferHardCheckMatrix: false,
            allowTexturePrefiltering: this._webGLVersion !== 1,
            trackUbosInFrame: false,
            checkUbosContentBeforeUpload: false,
            supportCSM: this._webGLVersion !== 1,
            basisNeedsPOT: this._webGLVersion === 1,
            support3DTextures: this._webGLVersion !== 1,
            needTypeSuffixInShaderConstants: this._webGLVersion !== 1,
            supportMSAA: this._webGLVersion !== 1,
            supportSSAO2: this._webGLVersion !== 1,
            supportExtendedTextureFormats: this._webGLVersion !== 1,
            supportSwitchCaseInShader: this._webGLVersion !== 1,
            supportSyncTextureRead: true,
            needsInvertingBitmap: true,
            useUBOBindingCache: true,
            needShaderCodeInlining: false,
            needToAlwaysBindUniformBuffers: false,
            supportRenderPasses: false,
            supportSpriteInstancing: true,
            forceVertexBufferStrideAndOffsetMultiple4Bytes: false,
            _collectUbosUpdatedInFrame: false
        };
    }
    /**
     * Gets version of the current webGL context
     * Keep it for back compat - use version instead
     */ get webGLVersion() {
        return this._webGLVersion;
    }
    /**
     * Gets a string identifying the name of the class
     * @returns "Engine" string
     */ getClassName() {
        return "ThinEngine";
    }
    /**
     * Returns true if the stencil buffer has been enabled through the creation option of the context.
     */ get isStencilEnable() {
        return this._isStencilEnable;
    }
    /** @internal */ _prepareWorkingCanvas() {
        if (this._workingCanvas) return;
        this._workingCanvas = this.createCanvas(1, 1);
        const context = this._workingCanvas.getContext("2d");
        if (context) this._workingContext = context;
    }
    /**
     * Reset the texture cache to empty state
     */ resetTextureCache() {
        for(const key in this._boundTexturesCache){
            if (!Object.prototype.hasOwnProperty.call(this._boundTexturesCache, key)) continue;
            this._boundTexturesCache[key] = null;
        }
        this._currentTextureChannel = -1;
    }
    /**
     * Gets an object containing information about the current engine context
     * @returns an object containing the vendor, the renderer and the version of the current engine context
     */ getInfo() {
        return this.getGlInfo();
    }
    /**
     * Gets an object containing information about the current webGL context
     * @returns an object containing the vendor, the renderer and the version of the current webGL context
     */ getGlInfo() {
        return {
            vendor: this._glVendor,
            renderer: this._glRenderer,
            version: this._glVersion
        };
    }
    /**
     * Defines the hardware scaling level.
     * By default the hardware scaling level is computed from the window device ratio.
     * if level = 1 then the engine will render at the exact resolution of the canvas. If level = 0.5 then the engine will render at twice the size of the canvas.
     * @param level defines the level to use
     */ setHardwareScalingLevel(level) {
        this._hardwareScalingLevel = level;
        this.resize();
    }
    /**
     * Gets the current hardware scaling level.
     * By default the hardware scaling level is computed from the window device ratio.
     * if level = 1 then the engine will render at the exact resolution of the canvas. If level = 0.5 then the engine will render at twice the size of the canvas.
     * @returns a number indicating the current hardware scaling level
     */ getHardwareScalingLevel() {
        return this._hardwareScalingLevel;
    }
    /**
     * Gets the list of loaded textures
     * @returns an array containing all loaded textures
     */ getLoadedTexturesCache() {
        return this._internalTexturesCache;
    }
    /**
     * Gets the object containing all engine capabilities
     * @returns the EngineCapabilities object
     */ getCaps() {
        return this._caps;
    }
    /**
     * stop executing a render loop function and remove it from the execution array
     * @param renderFunction defines the function to be removed. If not provided all functions will be removed.
     */ stopRenderLoop(renderFunction) {
        if (!renderFunction) {
            this._activeRenderLoops.length = 0;
            this._cancelFrame();
            return;
        }
        const index = this._activeRenderLoops.indexOf(renderFunction);
        if (index >= 0) {
            this._activeRenderLoops.splice(index, 1);
            if (this._activeRenderLoops.length == 0) this._cancelFrame();
        }
    }
    _cancelFrame() {
        if (this._frameHandler !== 0) {
            const handlerToCancel = this._frameHandler;
            this._frameHandler = 0;
            if (!(0, $jFz47.IsWindowObjectExist)()) {
                if (typeof cancelAnimationFrame === "function") return cancelAnimationFrame(handlerToCancel);
            } else {
                const { cancelAnimationFrame: cancelAnimationFrame1 } = this.getHostWindow() || window;
                if (typeof cancelAnimationFrame1 === "function") return cancelAnimationFrame1(handlerToCancel);
            }
            return clearTimeout(handlerToCancel);
        }
    }
    /** @internal */ _renderLoop() {
        this._frameHandler = 0;
        if (!this._contextWasLost) {
            let shouldRender = true;
            if (this._isDisposed || !this.renderEvenInBackground && this._windowIsBackground) shouldRender = false;
            if (shouldRender) {
                // Start new frame
                this.beginFrame();
                for(let index = 0; index < this._activeRenderLoops.length; index++){
                    const renderFunction = this._activeRenderLoops[index];
                    renderFunction();
                }
                // Present
                this.endFrame();
            }
        }
        if (this._frameHandler === 0) this._frameHandler = this._queueNewFrame(this._boundRenderFunction, this.getHostWindow());
    }
    /**
     * Gets the HTML canvas attached with the current webGL context
     * @returns a HTML canvas
     */ getRenderingCanvas() {
        return this._renderingCanvas;
    }
    /**
     * Gets the audio context specified in engine initialization options
     * @returns an Audio Context
     */ getAudioContext() {
        return this._audioContext;
    }
    /**
     * Gets the audio destination specified in engine initialization options
     * @returns an audio destination node
     */ getAudioDestination() {
        return this._audioDestination;
    }
    /**
     * Gets host window
     * @returns the host window object
     */ getHostWindow() {
        if (!(0, $jFz47.IsWindowObjectExist)()) return null;
        if (this._renderingCanvas && this._renderingCanvas.ownerDocument && this._renderingCanvas.ownerDocument.defaultView) return this._renderingCanvas.ownerDocument.defaultView;
        return window;
    }
    /**
     * Gets the current render width
     * @param useScreen defines if screen size must be used (or the current render target if any)
     * @returns a number defining the current render width
     */ getRenderWidth(useScreen = false) {
        if (!useScreen && this._currentRenderTarget) return this._currentRenderTarget.width;
        return this._framebufferDimensionsObject ? this._framebufferDimensionsObject.framebufferWidth : this._gl.drawingBufferWidth;
    }
    /**
     * Gets the current render height
     * @param useScreen defines if screen size must be used (or the current render target if any)
     * @returns a number defining the current render height
     */ getRenderHeight(useScreen = false) {
        if (!useScreen && this._currentRenderTarget) return this._currentRenderTarget.height;
        return this._framebufferDimensionsObject ? this._framebufferDimensionsObject.framebufferHeight : this._gl.drawingBufferHeight;
    }
    /**
     * Can be used to override the current requestAnimationFrame requester.
     * @internal
     */ _queueNewFrame(bindedRenderFunction, requester) {
        return $1a819ede290e980a$export$bfb63ef0b91d03e9.QueueNewFrame(bindedRenderFunction, requester);
    }
    /**
     * Register and execute a render loop. The engine can have more than one render function
     * @param renderFunction defines the function to continuously execute
     */ runRenderLoop(renderFunction) {
        if (this._activeRenderLoops.indexOf(renderFunction) !== -1) return;
        this._activeRenderLoops.push(renderFunction);
        // On the first added function, start the render loop.
        if (this._activeRenderLoops.length === 1 && this._frameHandler === 0) this._frameHandler = this._queueNewFrame(this._boundRenderFunction, this.getHostWindow());
    }
    /**
     * Clear the current render buffer or the current render target (if any is set up)
     * @param color defines the color to use
     * @param backBuffer defines if the back buffer must be cleared
     * @param depth defines if the depth buffer must be cleared
     * @param stencil defines if the stencil buffer must be cleared
     */ clear(color, backBuffer, depth, stencil = false) {
        const useStencilGlobalOnly = this.stencilStateComposer.useStencilGlobalOnly;
        this.stencilStateComposer.useStencilGlobalOnly = true; // make sure the stencil mask is coming from the global stencil and not from a material (effect) which would currently be in effect
        this.applyStates();
        this.stencilStateComposer.useStencilGlobalOnly = useStencilGlobalOnly;
        let mode = 0;
        if (backBuffer && color) {
            let setBackBufferColor = true;
            if (this._currentRenderTarget) {
                const textureFormat = this._currentRenderTarget.texture?.format;
                if (textureFormat === 8 || textureFormat === 9 || textureFormat === 10 || textureFormat === 11) {
                    const textureType = this._currentRenderTarget.texture?.type;
                    if (textureType === 7 || textureType === 5) {
                        $1a819ede290e980a$export$bfb63ef0b91d03e9._TempClearColorUint32[0] = color.r * 255;
                        $1a819ede290e980a$export$bfb63ef0b91d03e9._TempClearColorUint32[1] = color.g * 255;
                        $1a819ede290e980a$export$bfb63ef0b91d03e9._TempClearColorUint32[2] = color.b * 255;
                        $1a819ede290e980a$export$bfb63ef0b91d03e9._TempClearColorUint32[3] = color.a * 255;
                        this._gl.clearBufferuiv(this._gl.COLOR, 0, $1a819ede290e980a$export$bfb63ef0b91d03e9._TempClearColorUint32);
                        setBackBufferColor = false;
                    } else {
                        $1a819ede290e980a$export$bfb63ef0b91d03e9._TempClearColorInt32[0] = color.r * 255;
                        $1a819ede290e980a$export$bfb63ef0b91d03e9._TempClearColorInt32[1] = color.g * 255;
                        $1a819ede290e980a$export$bfb63ef0b91d03e9._TempClearColorInt32[2] = color.b * 255;
                        $1a819ede290e980a$export$bfb63ef0b91d03e9._TempClearColorInt32[3] = color.a * 255;
                        this._gl.clearBufferiv(this._gl.COLOR, 0, $1a819ede290e980a$export$bfb63ef0b91d03e9._TempClearColorInt32);
                        setBackBufferColor = false;
                    }
                }
            }
            if (setBackBufferColor) {
                this._gl.clearColor(color.r, color.g, color.b, color.a !== undefined ? color.a : 1.0);
                mode |= this._gl.COLOR_BUFFER_BIT;
            }
        }
        if (depth) {
            if (this.useReverseDepthBuffer) {
                this._depthCullingState.depthFunc = this._gl.GEQUAL;
                this._gl.clearDepth(0.0);
            } else this._gl.clearDepth(1.0);
            mode |= this._gl.DEPTH_BUFFER_BIT;
        }
        if (stencil) {
            this._gl.clearStencil(0);
            mode |= this._gl.STENCIL_BUFFER_BIT;
        }
        this._gl.clear(mode);
    }
    /**
     * @internal
     */ _viewport(x, y, width, height) {
        if (x !== this._viewportCached.x || y !== this._viewportCached.y || width !== this._viewportCached.z || height !== this._viewportCached.w) {
            this._viewportCached.x = x;
            this._viewportCached.y = y;
            this._viewportCached.z = width;
            this._viewportCached.w = height;
            this._gl.viewport(x, y, width, height);
        }
    }
    /**
     * Set the WebGL's viewport
     * @param viewport defines the viewport element to be used
     * @param requiredWidth defines the width required for rendering. If not provided the rendering canvas' width is used
     * @param requiredHeight defines the height required for rendering. If not provided the rendering canvas' height is used
     */ setViewport(viewport, requiredWidth, requiredHeight) {
        const width = requiredWidth || this.getRenderWidth();
        const height = requiredHeight || this.getRenderHeight();
        const x = viewport.x || 0;
        const y = viewport.y || 0;
        this._cachedViewport = viewport;
        this._viewport(x * width, y * height, width * viewport.width, height * viewport.height);
    }
    /**
     * Begin a new frame
     */ beginFrame() {}
    /**
     * Enf the current frame
     */ endFrame() {
        // Force a flush in case we are using a bad OS.
        if (this._badOS) this.flushFramebuffer();
        this._frameId++;
    }
    /**
     * Resize the view according to the canvas' size
     * @param forceSetSize true to force setting the sizes of the underlying canvas
     */ resize(forceSetSize = false) {
        let width;
        let height;
        // Re-query hardware scaling level to handle zoomed-in resizing.
        if (this.adaptToDeviceRatio) {
            const devicePixelRatio = (0, $jFz47.IsWindowObjectExist)() ? window.devicePixelRatio || 1.0 : 1.0;
            const changeRatio = this._lastDevicePixelRatio / devicePixelRatio;
            this._lastDevicePixelRatio = devicePixelRatio;
            this._hardwareScalingLevel *= changeRatio;
        }
        if ((0, $jFz47.IsWindowObjectExist)() && (0, $jFz47.IsDocumentAvailable)()) {
            // make sure it is a Node object, and is a part of the document.
            if (this._renderingCanvas) {
                const boundingRect = this._renderingCanvas.getBoundingClientRect ? this._renderingCanvas.getBoundingClientRect() : {
                    // fallback to last solution in case the function doesn't exist
                    width: this._renderingCanvas.width * this._hardwareScalingLevel,
                    height: this._renderingCanvas.height * this._hardwareScalingLevel
                };
                width = this._renderingCanvas.clientWidth || boundingRect.width || this._renderingCanvas.width || 100;
                height = this._renderingCanvas.clientHeight || boundingRect.height || this._renderingCanvas.height || 100;
            } else {
                width = window.innerWidth;
                height = window.innerHeight;
            }
        } else {
            width = this._renderingCanvas ? this._renderingCanvas.width : 100;
            height = this._renderingCanvas ? this._renderingCanvas.height : 100;
        }
        this.setSize(width / this._hardwareScalingLevel, height / this._hardwareScalingLevel, forceSetSize);
    }
    /**
     * Force a specific size of the canvas
     * @param width defines the new canvas' width
     * @param height defines the new canvas' height
     * @param forceSetSize true to force setting the sizes of the underlying canvas
     * @returns true if the size was changed
     */ setSize(width, height, forceSetSize = false) {
        if (!this._renderingCanvas) return false;
        width = width | 0;
        height = height | 0;
        if (!forceSetSize && this._renderingCanvas.width === width && this._renderingCanvas.height === height) return false;
        this._renderingCanvas.width = width;
        this._renderingCanvas.height = height;
        return true;
    }
    /**
     * Binds the frame buffer to the specified texture.
     * @param rtWrapper The render target wrapper to render to
     * @param faceIndex The face of the texture to render to in case of cube texture and if the render target wrapper is not a multi render target
     * @param requiredWidth The width of the target to render to
     * @param requiredHeight The height of the target to render to
     * @param forceFullscreenViewport Forces the viewport to be the entire texture/screen if true
     * @param lodLevel Defines the lod level to bind to the frame buffer
     * @param layer Defines the 2d array index to bind to the frame buffer if the render target wrapper is not a multi render target
     */ bindFramebuffer(rtWrapper, faceIndex = 0, requiredWidth, requiredHeight, forceFullscreenViewport, lodLevel = 0, layer = 0) {
        const webglRTWrapper = rtWrapper;
        if (this._currentRenderTarget) this.unBindFramebuffer(this._currentRenderTarget);
        this._currentRenderTarget = rtWrapper;
        this._bindUnboundFramebuffer(webglRTWrapper._MSAAFramebuffer ? webglRTWrapper._MSAAFramebuffer : webglRTWrapper._framebuffer);
        const gl = this._gl;
        if (!rtWrapper.isMulti) {
            if (rtWrapper.is2DArray) gl.framebufferTextureLayer(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, rtWrapper.texture._hardwareTexture?.underlyingResource, lodLevel, layer);
            else if (rtWrapper.isCube) gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex, rtWrapper.texture._hardwareTexture?.underlyingResource, lodLevel);
            else if (webglRTWrapper._currentLOD !== lodLevel) {
                gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, rtWrapper.texture._hardwareTexture?.underlyingResource, lodLevel);
                webglRTWrapper._currentLOD = lodLevel;
            }
        }
        const depthStencilTexture = rtWrapper._depthStencilTexture;
        if (depthStencilTexture) {
            const attachment = rtWrapper._depthStencilTextureWithStencil ? gl.DEPTH_STENCIL_ATTACHMENT : gl.DEPTH_ATTACHMENT;
            if (rtWrapper.is2DArray) gl.framebufferTextureLayer(gl.FRAMEBUFFER, attachment, depthStencilTexture._hardwareTexture?.underlyingResource, lodLevel, layer);
            else if (rtWrapper.isCube) gl.framebufferTexture2D(gl.FRAMEBUFFER, attachment, gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex, depthStencilTexture._hardwareTexture?.underlyingResource, lodLevel);
            else gl.framebufferTexture2D(gl.FRAMEBUFFER, attachment, gl.TEXTURE_2D, depthStencilTexture._hardwareTexture?.underlyingResource, lodLevel);
        }
        if (this._cachedViewport && !forceFullscreenViewport) this.setViewport(this._cachedViewport, requiredWidth, requiredHeight);
        else {
            if (!requiredWidth) {
                requiredWidth = rtWrapper.width;
                if (lodLevel) requiredWidth = requiredWidth / Math.pow(2, lodLevel);
            }
            if (!requiredHeight) {
                requiredHeight = rtWrapper.height;
                if (lodLevel) requiredHeight = requiredHeight / Math.pow(2, lodLevel);
            }
            this._viewport(0, 0, requiredWidth, requiredHeight);
        }
        this.wipeCaches();
    }
    /**
     * Set various states to the webGL context
     * @param culling defines culling state: true to enable culling, false to disable it
     * @param zOffset defines the value to apply to zOffset (0 by default)
     * @param force defines if states must be applied even if cache is up to date
     * @param reverseSide defines if culling must be reversed (CCW if false, CW if true)
     * @param cullBackFaces true to cull back faces, false to cull front faces (if culling is enabled)
     * @param stencil stencil states to set
     * @param zOffsetUnits defines the value to apply to zOffsetUnits (0 by default)
     */ setState(culling, zOffset = 0, force, reverseSide = false, cullBackFaces, stencil, zOffsetUnits = 0) {
        // Culling
        if (this._depthCullingState.cull !== culling || force) this._depthCullingState.cull = culling;
        // Cull face
        const cullFace = this.cullBackFaces ?? cullBackFaces ?? true ? this._gl.BACK : this._gl.FRONT;
        if (this._depthCullingState.cullFace !== cullFace || force) this._depthCullingState.cullFace = cullFace;
        // Z offset
        this.setZOffset(zOffset);
        this.setZOffsetUnits(zOffsetUnits);
        // Front face
        const frontFace = reverseSide ? this._gl.CW : this._gl.CCW;
        if (this._depthCullingState.frontFace !== frontFace || force) this._depthCullingState.frontFace = frontFace;
        this._stencilStateComposer.stencilMaterial = stencil;
    }
    /**
     * Gets a boolean indicating if depth testing is enabled
     * @returns the current state
     */ getDepthBuffer() {
        return this._depthCullingState.depthTest;
    }
    /**
     * Enable or disable depth buffering
     * @param enable defines the state to set
     */ setDepthBuffer(enable) {
        this._depthCullingState.depthTest = enable;
    }
    /**
     * Set the z offset Factor to apply to current rendering
     * @param value defines the offset to apply
     */ setZOffset(value) {
        this._depthCullingState.zOffset = this.useReverseDepthBuffer ? -value : value;
    }
    /**
     * Gets the current value of the zOffset Factor
     * @returns the current zOffset Factor state
     */ getZOffset() {
        const zOffset = this._depthCullingState.zOffset;
        return this.useReverseDepthBuffer ? -zOffset : zOffset;
    }
    /**
     * Set the z offset Units to apply to current rendering
     * @param value defines the offset to apply
     */ setZOffsetUnits(value) {
        this._depthCullingState.zOffsetUnits = this.useReverseDepthBuffer ? -value : value;
    }
    /**
     * Gets the current value of the zOffset Units
     * @returns the current zOffset Units state
     */ getZOffsetUnits() {
        const zOffsetUnits = this._depthCullingState.zOffsetUnits;
        return this.useReverseDepthBuffer ? -zOffsetUnits : zOffsetUnits;
    }
    /**
     * @internal
     */ _bindUnboundFramebuffer(framebuffer) {
        if (this._currentFramebuffer !== framebuffer) {
            this._gl.bindFramebuffer(this._gl.FRAMEBUFFER, framebuffer);
            this._currentFramebuffer = framebuffer;
        }
    }
    /** @internal */ _currentFrameBufferIsDefaultFrameBuffer() {
        return this._currentFramebuffer === null;
    }
    /**
     * Generates the mipmaps for a texture
     * @param texture texture to generate the mipmaps for
     */ generateMipmaps(texture) {
        this._bindTextureDirectly(this._gl.TEXTURE_2D, texture, true);
        this._gl.generateMipmap(this._gl.TEXTURE_2D);
        this._bindTextureDirectly(this._gl.TEXTURE_2D, null);
    }
    /**
     * Unbind the current render target texture from the webGL context
     * @param texture defines the render target wrapper to unbind
     * @param disableGenerateMipMaps defines a boolean indicating that mipmaps must not be generated
     * @param onBeforeUnbind defines a function which will be called before the effective unbind
     */ unBindFramebuffer(texture, disableGenerateMipMaps = false, onBeforeUnbind) {
        const webglRTWrapper = texture;
        this._currentRenderTarget = null;
        // If MSAA, we need to bitblt back to main texture
        const gl = this._gl;
        if (webglRTWrapper._MSAAFramebuffer) {
            if (texture.isMulti) {
                // This texture is part of a MRT texture, we need to treat all attachments
                this.unBindMultiColorAttachmentFramebuffer(texture, disableGenerateMipMaps, onBeforeUnbind);
                return;
            }
            gl.bindFramebuffer(gl.READ_FRAMEBUFFER, webglRTWrapper._MSAAFramebuffer);
            gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, webglRTWrapper._framebuffer);
            gl.blitFramebuffer(0, 0, texture.width, texture.height, 0, 0, texture.width, texture.height, gl.COLOR_BUFFER_BIT, gl.NEAREST);
        }
        if (texture.texture?.generateMipMaps && !disableGenerateMipMaps && !texture.isCube) this.generateMipmaps(texture.texture);
        if (onBeforeUnbind) {
            if (webglRTWrapper._MSAAFramebuffer) // Bind the correct framebuffer
            this._bindUnboundFramebuffer(webglRTWrapper._framebuffer);
            onBeforeUnbind();
        }
        this._bindUnboundFramebuffer(null);
    }
    /**
     * Force a webGL flush (ie. a flush of all waiting webGL commands)
     */ flushFramebuffer() {
        this._gl.flush();
    }
    /**
     * Unbind the current render target and bind the default framebuffer
     */ restoreDefaultFramebuffer() {
        if (this._currentRenderTarget) this.unBindFramebuffer(this._currentRenderTarget);
        else this._bindUnboundFramebuffer(null);
        if (this._cachedViewport) this.setViewport(this._cachedViewport);
        this.wipeCaches();
    }
    // VBOs
    /** @internal */ _resetVertexBufferBinding() {
        this.bindArrayBuffer(null);
        this._cachedVertexBuffers = null;
    }
    /**
     * Creates a vertex buffer
     * @param data the data or size for the vertex buffer
     * @param _updatable whether the buffer should be created as updatable
     * @param _label defines the label of the buffer (for debug purpose)
     * @returns the new WebGL static buffer
     */ createVertexBuffer(data, _updatable, _label) {
        return this._createVertexBuffer(data, this._gl.STATIC_DRAW);
    }
    _createVertexBuffer(data, usage) {
        const vbo = this._gl.createBuffer();
        if (!vbo) throw new Error("Unable to create vertex buffer");
        const dataBuffer = new (0, $koExS.WebGLDataBuffer)(vbo);
        this.bindArrayBuffer(dataBuffer);
        if (typeof data !== "number") {
            if (data instanceof Array) {
                this._gl.bufferData(this._gl.ARRAY_BUFFER, new Float32Array(data), usage);
                dataBuffer.capacity = data.length * 4;
            } else {
                this._gl.bufferData(this._gl.ARRAY_BUFFER, data, usage);
                dataBuffer.capacity = data.byteLength;
            }
        } else {
            this._gl.bufferData(this._gl.ARRAY_BUFFER, new Uint8Array(data), usage);
            dataBuffer.capacity = data;
        }
        this._resetVertexBufferBinding();
        dataBuffer.references = 1;
        return dataBuffer;
    }
    /**
     * Creates a dynamic vertex buffer
     * @param data the data for the dynamic vertex buffer
     * @param _label defines the label of the buffer (for debug purpose)
     * @returns the new WebGL dynamic buffer
     */ createDynamicVertexBuffer(data, _label) {
        return this._createVertexBuffer(data, this._gl.DYNAMIC_DRAW);
    }
    _resetIndexBufferBinding() {
        this.bindIndexBuffer(null);
        this._cachedIndexBuffer = null;
    }
    /**
     * Creates a new index buffer
     * @param indices defines the content of the index buffer
     * @param updatable defines if the index buffer must be updatable
     * @param _label defines the label of the buffer (for debug purpose)
     * @returns a new webGL buffer
     */ createIndexBuffer(indices, updatable, _label) {
        const vbo = this._gl.createBuffer();
        const dataBuffer = new (0, $koExS.WebGLDataBuffer)(vbo);
        if (!vbo) throw new Error("Unable to create index buffer");
        this.bindIndexBuffer(dataBuffer);
        const data = this._normalizeIndexData(indices);
        this._gl.bufferData(this._gl.ELEMENT_ARRAY_BUFFER, data, updatable ? this._gl.DYNAMIC_DRAW : this._gl.STATIC_DRAW);
        this._resetIndexBufferBinding();
        dataBuffer.references = 1;
        dataBuffer.is32Bits = data.BYTES_PER_ELEMENT === 4;
        return dataBuffer;
    }
    _normalizeIndexData(indices) {
        const bytesPerElement = indices.BYTES_PER_ELEMENT;
        if (bytesPerElement === 2) return indices;
        // Check 32 bit support
        if (this._caps.uintIndices) {
            if (indices instanceof Uint32Array) return indices;
            else {
                // number[] or Int32Array, check if 32 bit is necessary
                for(let index = 0; index < indices.length; index++){
                    if (indices[index] >= 65535) return new Uint32Array(indices);
                }
                return new Uint16Array(indices);
            }
        }
        // No 32 bit support, force conversion to 16 bit (values greater 16 bit are lost)
        return new Uint16Array(indices);
    }
    /**
     * Bind a webGL buffer to the webGL context
     * @param buffer defines the buffer to bind
     */ bindArrayBuffer(buffer) {
        if (!this._vaoRecordInProgress) this._unbindVertexArrayObject();
        this._bindBuffer(buffer, this._gl.ARRAY_BUFFER);
    }
    /**
     * Bind a specific block at a given index in a specific shader program
     * @param pipelineContext defines the pipeline context to use
     * @param blockName defines the block name
     * @param index defines the index where to bind the block
     */ bindUniformBlock(pipelineContext, blockName, index) {
        const program = pipelineContext.program;
        const uniformLocation = this._gl.getUniformBlockIndex(program, blockName);
        this._gl.uniformBlockBinding(program, uniformLocation, index);
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    bindIndexBuffer(buffer) {
        if (!this._vaoRecordInProgress) this._unbindVertexArrayObject();
        this._bindBuffer(buffer, this._gl.ELEMENT_ARRAY_BUFFER);
    }
    _bindBuffer(buffer, target) {
        if (this._vaoRecordInProgress || this._currentBoundBuffer[target] !== buffer) {
            this._gl.bindBuffer(target, buffer ? buffer.underlyingResource : null);
            this._currentBoundBuffer[target] = buffer;
        }
    }
    /**
     * update the bound buffer with the given data
     * @param data defines the data to update
     */ updateArrayBuffer(data) {
        this._gl.bufferSubData(this._gl.ARRAY_BUFFER, 0, data);
    }
    _vertexAttribPointer(buffer, indx, size, type, normalized, stride, offset) {
        const pointer = this._currentBufferPointers[indx];
        if (!pointer) return;
        let changed = false;
        if (!pointer.active) {
            changed = true;
            pointer.active = true;
            pointer.index = indx;
            pointer.size = size;
            pointer.type = type;
            pointer.normalized = normalized;
            pointer.stride = stride;
            pointer.offset = offset;
            pointer.buffer = buffer;
        } else {
            if (pointer.buffer !== buffer) {
                pointer.buffer = buffer;
                changed = true;
            }
            if (pointer.size !== size) {
                pointer.size = size;
                changed = true;
            }
            if (pointer.type !== type) {
                pointer.type = type;
                changed = true;
            }
            if (pointer.normalized !== normalized) {
                pointer.normalized = normalized;
                changed = true;
            }
            if (pointer.stride !== stride) {
                pointer.stride = stride;
                changed = true;
            }
            if (pointer.offset !== offset) {
                pointer.offset = offset;
                changed = true;
            }
        }
        if (changed || this._vaoRecordInProgress) {
            this.bindArrayBuffer(buffer);
            if (type === this._gl.UNSIGNED_INT || type === this._gl.INT) this._gl.vertexAttribIPointer(indx, size, type, stride, offset);
            else this._gl.vertexAttribPointer(indx, size, type, normalized, stride, offset);
        }
    }
    /**
     * @internal
     */ _bindIndexBufferWithCache(indexBuffer) {
        if (indexBuffer == null) return;
        if (this._cachedIndexBuffer !== indexBuffer) {
            this._cachedIndexBuffer = indexBuffer;
            this.bindIndexBuffer(indexBuffer);
            this._uintIndicesCurrentlySet = indexBuffer.is32Bits;
        }
    }
    _bindVertexBuffersAttributes(vertexBuffers, effect, overrideVertexBuffers) {
        const attributes = effect.getAttributesNames();
        if (!this._vaoRecordInProgress) this._unbindVertexArrayObject();
        this.unbindAllAttributes();
        for(let index = 0; index < attributes.length; index++){
            const order = effect.getAttributeLocation(index);
            if (order >= 0) {
                const ai = attributes[index];
                let vertexBuffer = null;
                if (overrideVertexBuffers) vertexBuffer = overrideVertexBuffers[ai];
                if (!vertexBuffer) vertexBuffer = vertexBuffers[ai];
                if (!vertexBuffer) continue;
                this._gl.enableVertexAttribArray(order);
                if (!this._vaoRecordInProgress) this._vertexAttribArraysEnabled[order] = true;
                const buffer = vertexBuffer.getBuffer();
                if (buffer) {
                    this._vertexAttribPointer(buffer, order, vertexBuffer.getSize(), vertexBuffer.type, vertexBuffer.normalized, vertexBuffer.byteStride, vertexBuffer.byteOffset);
                    if (vertexBuffer.getIsInstanced()) {
                        this._gl.vertexAttribDivisor(order, vertexBuffer.getInstanceDivisor());
                        if (!this._vaoRecordInProgress) {
                            this._currentInstanceLocations.push(order);
                            this._currentInstanceBuffers.push(buffer);
                        }
                    }
                }
            }
        }
    }
    /**
     * Records a vertex array object
     * @see https://doc.babylonjs.com/setup/support/webGL2#vertex-array-objects
     * @param vertexBuffers defines the list of vertex buffers to store
     * @param indexBuffer defines the index buffer to store
     * @param effect defines the effect to store
     * @param overrideVertexBuffers defines optional list of avertex buffers that overrides the entries in vertexBuffers
     * @returns the new vertex array object
     */ recordVertexArrayObject(vertexBuffers, indexBuffer, effect, overrideVertexBuffers) {
        const vao = this._gl.createVertexArray();
        if (!vao) throw new Error("Unable to create VAO");
        this._vaoRecordInProgress = true;
        this._gl.bindVertexArray(vao);
        this._mustWipeVertexAttributes = true;
        this._bindVertexBuffersAttributes(vertexBuffers, effect, overrideVertexBuffers);
        this.bindIndexBuffer(indexBuffer);
        this._vaoRecordInProgress = false;
        this._gl.bindVertexArray(null);
        return vao;
    }
    /**
     * Bind a specific vertex array object
     * @see https://doc.babylonjs.com/setup/support/webGL2#vertex-array-objects
     * @param vertexArrayObject defines the vertex array object to bind
     * @param indexBuffer defines the index buffer to bind
     */ bindVertexArrayObject(vertexArrayObject, indexBuffer) {
        if (this._cachedVertexArrayObject !== vertexArrayObject) {
            this._cachedVertexArrayObject = vertexArrayObject;
            this._gl.bindVertexArray(vertexArrayObject);
            this._cachedVertexBuffers = null;
            this._cachedIndexBuffer = null;
            this._uintIndicesCurrentlySet = indexBuffer != null && indexBuffer.is32Bits;
            this._mustWipeVertexAttributes = true;
        }
    }
    /**
     * Bind webGl buffers directly to the webGL context
     * @param vertexBuffer defines the vertex buffer to bind
     * @param indexBuffer defines the index buffer to bind
     * @param vertexDeclaration defines the vertex declaration to use with the vertex buffer
     * @param vertexStrideSize defines the vertex stride of the vertex buffer
     * @param effect defines the effect associated with the vertex buffer
     */ bindBuffersDirectly(vertexBuffer, indexBuffer, vertexDeclaration, vertexStrideSize, effect) {
        if (this._cachedVertexBuffers !== vertexBuffer || this._cachedEffectForVertexBuffers !== effect) {
            this._cachedVertexBuffers = vertexBuffer;
            this._cachedEffectForVertexBuffers = effect;
            const attributesCount = effect.getAttributesCount();
            this._unbindVertexArrayObject();
            this.unbindAllAttributes();
            let offset = 0;
            for(let index = 0; index < attributesCount; index++)if (index < vertexDeclaration.length) {
                const order = effect.getAttributeLocation(index);
                if (order >= 0) {
                    this._gl.enableVertexAttribArray(order);
                    this._vertexAttribArraysEnabled[order] = true;
                    this._vertexAttribPointer(vertexBuffer, order, vertexDeclaration[index], this._gl.FLOAT, false, vertexStrideSize, offset);
                }
                offset += vertexDeclaration[index] * 4;
            }
        }
        this._bindIndexBufferWithCache(indexBuffer);
    }
    _unbindVertexArrayObject() {
        if (!this._cachedVertexArrayObject) return;
        this._cachedVertexArrayObject = null;
        this._gl.bindVertexArray(null);
    }
    /**
     * Bind a list of vertex buffers to the webGL context
     * @param vertexBuffers defines the list of vertex buffers to bind
     * @param indexBuffer defines the index buffer to bind
     * @param effect defines the effect associated with the vertex buffers
     * @param overrideVertexBuffers defines optional list of avertex buffers that overrides the entries in vertexBuffers
     */ bindBuffers(vertexBuffers, indexBuffer, effect, overrideVertexBuffers) {
        if (this._cachedVertexBuffers !== vertexBuffers || this._cachedEffectForVertexBuffers !== effect) {
            this._cachedVertexBuffers = vertexBuffers;
            this._cachedEffectForVertexBuffers = effect;
            this._bindVertexBuffersAttributes(vertexBuffers, effect, overrideVertexBuffers);
        }
        this._bindIndexBufferWithCache(indexBuffer);
    }
    /**
     * Unbind all instance attributes
     */ unbindInstanceAttributes() {
        let boundBuffer;
        for(let i = 0, ul = this._currentInstanceLocations.length; i < ul; i++){
            const instancesBuffer = this._currentInstanceBuffers[i];
            if (boundBuffer != instancesBuffer && instancesBuffer.references) {
                boundBuffer = instancesBuffer;
                this.bindArrayBuffer(instancesBuffer);
            }
            const offsetLocation = this._currentInstanceLocations[i];
            this._gl.vertexAttribDivisor(offsetLocation, 0);
        }
        this._currentInstanceBuffers.length = 0;
        this._currentInstanceLocations.length = 0;
    }
    /**
     * Release and free the memory of a vertex array object
     * @param vao defines the vertex array object to delete
     */ releaseVertexArrayObject(vao) {
        this._gl.deleteVertexArray(vao);
    }
    /**
     * @internal
     */ _releaseBuffer(buffer) {
        buffer.references--;
        if (buffer.references === 0) {
            this._deleteBuffer(buffer);
            return true;
        }
        return false;
    }
    _deleteBuffer(buffer) {
        this._gl.deleteBuffer(buffer.underlyingResource);
    }
    /**
     * Update the content of a webGL buffer used with instantiation and bind it to the webGL context
     * @param instancesBuffer defines the webGL buffer to update and bind
     * @param data defines the data to store in the buffer
     * @param offsetLocations defines the offsets or attributes information used to determine where data must be stored in the buffer
     */ updateAndBindInstancesBuffer(instancesBuffer, data, offsetLocations) {
        this.bindArrayBuffer(instancesBuffer);
        if (data) this._gl.bufferSubData(this._gl.ARRAY_BUFFER, 0, data);
        if (offsetLocations[0].index !== undefined) this.bindInstancesBuffer(instancesBuffer, offsetLocations, true);
        else for(let index = 0; index < 4; index++){
            const offsetLocation = offsetLocations[index];
            if (!this._vertexAttribArraysEnabled[offsetLocation]) {
                this._gl.enableVertexAttribArray(offsetLocation);
                this._vertexAttribArraysEnabled[offsetLocation] = true;
            }
            this._vertexAttribPointer(instancesBuffer, offsetLocation, 4, this._gl.FLOAT, false, 64, index * 16);
            this._gl.vertexAttribDivisor(offsetLocation, 1);
            this._currentInstanceLocations.push(offsetLocation);
            this._currentInstanceBuffers.push(instancesBuffer);
        }
    }
    /**
     * Bind the content of a webGL buffer used with instantiation
     * @param instancesBuffer defines the webGL buffer to bind
     * @param attributesInfo defines the offsets or attributes information used to determine where data must be stored in the buffer
     * @param computeStride defines Whether to compute the strides from the info or use the default 0
     */ bindInstancesBuffer(instancesBuffer, attributesInfo, computeStride = true) {
        this.bindArrayBuffer(instancesBuffer);
        let stride = 0;
        if (computeStride) for(let i = 0; i < attributesInfo.length; i++){
            const ai = attributesInfo[i];
            stride += ai.attributeSize * 4;
        }
        for(let i = 0; i < attributesInfo.length; i++){
            const ai = attributesInfo[i];
            if (ai.index === undefined) ai.index = this._currentEffect.getAttributeLocationByName(ai.attributeName);
            if (ai.index < 0) continue;
            if (!this._vertexAttribArraysEnabled[ai.index]) {
                this._gl.enableVertexAttribArray(ai.index);
                this._vertexAttribArraysEnabled[ai.index] = true;
            }
            this._vertexAttribPointer(instancesBuffer, ai.index, ai.attributeSize, ai.attributeType || this._gl.FLOAT, ai.normalized || false, stride, ai.offset);
            this._gl.vertexAttribDivisor(ai.index, ai.divisor === undefined ? 1 : ai.divisor);
            this._currentInstanceLocations.push(ai.index);
            this._currentInstanceBuffers.push(instancesBuffer);
        }
    }
    /**
     * Disable the instance attribute corresponding to the name in parameter
     * @param name defines the name of the attribute to disable
     */ disableInstanceAttributeByName(name) {
        if (!this._currentEffect) return;
        const attributeLocation = this._currentEffect.getAttributeLocationByName(name);
        this.disableInstanceAttribute(attributeLocation);
    }
    /**
     * Disable the instance attribute corresponding to the location in parameter
     * @param attributeLocation defines the attribute location of the attribute to disable
     */ disableInstanceAttribute(attributeLocation) {
        let shouldClean = false;
        let index;
        while((index = this._currentInstanceLocations.indexOf(attributeLocation)) !== -1){
            this._currentInstanceLocations.splice(index, 1);
            this._currentInstanceBuffers.splice(index, 1);
            shouldClean = true;
            index = this._currentInstanceLocations.indexOf(attributeLocation);
        }
        if (shouldClean) {
            this._gl.vertexAttribDivisor(attributeLocation, 0);
            this.disableAttributeByIndex(attributeLocation);
        }
    }
    /**
     * Disable the attribute corresponding to the location in parameter
     * @param attributeLocation defines the attribute location of the attribute to disable
     */ disableAttributeByIndex(attributeLocation) {
        this._gl.disableVertexAttribArray(attributeLocation);
        this._vertexAttribArraysEnabled[attributeLocation] = false;
        this._currentBufferPointers[attributeLocation].active = false;
    }
    /**
     * Send a draw order
     * @param useTriangles defines if triangles must be used to draw (else wireframe will be used)
     * @param indexStart defines the starting index
     * @param indexCount defines the number of index to draw
     * @param instancesCount defines the number of instances to draw (if instantiation is enabled)
     */ draw(useTriangles, indexStart, indexCount, instancesCount) {
        this.drawElementsType(useTriangles ? 0 : 1, indexStart, indexCount, instancesCount);
    }
    /**
     * Draw a list of points
     * @param verticesStart defines the index of first vertex to draw
     * @param verticesCount defines the count of vertices to draw
     * @param instancesCount defines the number of instances to draw (if instantiation is enabled)
     */ drawPointClouds(verticesStart, verticesCount, instancesCount) {
        this.drawArraysType(2, verticesStart, verticesCount, instancesCount);
    }
    /**
     * Draw a list of unindexed primitives
     * @param useTriangles defines if triangles must be used to draw (else wireframe will be used)
     * @param verticesStart defines the index of first vertex to draw
     * @param verticesCount defines the count of vertices to draw
     * @param instancesCount defines the number of instances to draw (if instantiation is enabled)
     */ drawUnIndexed(useTriangles, verticesStart, verticesCount, instancesCount) {
        this.drawArraysType(useTriangles ? 0 : 1, verticesStart, verticesCount, instancesCount);
    }
    /**
     * Draw a list of indexed primitives
     * @param fillMode defines the primitive to use
     * @param indexStart defines the starting index
     * @param indexCount defines the number of index to draw
     * @param instancesCount defines the number of instances to draw (if instantiation is enabled)
     */ drawElementsType(fillMode, indexStart, indexCount, instancesCount) {
        // Apply states
        this.applyStates();
        this._reportDrawCall();
        // Render
        const drawMode = this._drawMode(fillMode);
        const indexFormat = this._uintIndicesCurrentlySet ? this._gl.UNSIGNED_INT : this._gl.UNSIGNED_SHORT;
        const mult = this._uintIndicesCurrentlySet ? 4 : 2;
        if (instancesCount) this._gl.drawElementsInstanced(drawMode, indexCount, indexFormat, indexStart * mult, instancesCount);
        else this._gl.drawElements(drawMode, indexCount, indexFormat, indexStart * mult);
    }
    /**
     * Draw a list of unindexed primitives
     * @param fillMode defines the primitive to use
     * @param verticesStart defines the index of first vertex to draw
     * @param verticesCount defines the count of vertices to draw
     * @param instancesCount defines the number of instances to draw (if instantiation is enabled)
     */ drawArraysType(fillMode, verticesStart, verticesCount, instancesCount) {
        // Apply states
        this.applyStates();
        this._reportDrawCall();
        const drawMode = this._drawMode(fillMode);
        if (instancesCount) this._gl.drawArraysInstanced(drawMode, verticesStart, verticesCount, instancesCount);
        else this._gl.drawArrays(drawMode, verticesStart, verticesCount);
    }
    _drawMode(fillMode) {
        switch(fillMode){
            // Triangle views
            case 0:
                return this._gl.TRIANGLES;
            case 2:
                return this._gl.POINTS;
            case 1:
                return this._gl.LINES;
            // Draw modes
            case 3:
                return this._gl.POINTS;
            case 4:
                return this._gl.LINES;
            case 5:
                return this._gl.LINE_LOOP;
            case 6:
                return this._gl.LINE_STRIP;
            case 7:
                return this._gl.TRIANGLE_STRIP;
            case 8:
                return this._gl.TRIANGLE_FAN;
            default:
                return this._gl.TRIANGLES;
        }
    }
    /** @internal */ _reportDrawCall() {
    // Will be implemented by children
    }
    // Shaders
    /**
     * @internal
     */ _releaseEffect(effect) {
        if (this._compiledEffects[effect._key]) delete this._compiledEffects[effect._key];
        const pipelineContext = effect.getPipelineContext();
        if (pipelineContext) this._deletePipelineContext(pipelineContext);
    }
    /**
     * @internal
     */ _deletePipelineContext(pipelineContext) {
        const webGLPipelineContext = pipelineContext;
        if (webGLPipelineContext && webGLPipelineContext.program) {
            webGLPipelineContext.program.__SPECTOR_rebuildProgram = null;
            this._gl.deleteProgram(webGLPipelineContext.program);
        }
    }
    /** @internal */ _getGlobalDefines(defines) {
        if (defines) {
            if (this.isNDCHalfZRange) defines["IS_NDC_HALF_ZRANGE"] = "";
            else delete defines["IS_NDC_HALF_ZRANGE"];
            if (this.useReverseDepthBuffer) defines["USE_REVERSE_DEPTHBUFFER"] = "";
            else delete defines["USE_REVERSE_DEPTHBUFFER"];
            if (this.useExactSrgbConversions) defines["USE_EXACT_SRGB_CONVERSIONS"] = "";
            else delete defines["USE_EXACT_SRGB_CONVERSIONS"];
            return;
        } else {
            let s = "";
            if (this.isNDCHalfZRange) s += "#define IS_NDC_HALF_ZRANGE";
            if (this.useReverseDepthBuffer) {
                if (s) s += "\n";
                s += "#define USE_REVERSE_DEPTHBUFFER";
            }
            if (this.useExactSrgbConversions) {
                if (s) s += "\n";
                s += "#define USE_EXACT_SRGB_CONVERSIONS";
            }
            return s;
        }
    }
    /**
     * Create a new effect (used to store vertex/fragment shaders)
     * @param baseName defines the base name of the effect (The name of file without .fragment.fx or .vertex.fx)
     * @param attributesNamesOrOptions defines either a list of attribute names or an IEffectCreationOptions object
     * @param uniformsNamesOrEngine defines either a list of uniform names or the engine to use
     * @param samplers defines an array of string used to represent textures
     * @param defines defines the string containing the defines to use to compile the shaders
     * @param fallbacks defines the list of potential fallbacks to use if shader compilation fails
     * @param onCompiled defines a function to call when the effect creation is successful
     * @param onError defines a function to call when the effect creation has failed
     * @param indexParameters defines an object containing the index values to use to compile shaders (like the maximum number of simultaneous lights)
     * @param shaderLanguage the language the shader is written in (default: GLSL)
     * @returns the new Effect
     */ createEffect(baseName, attributesNamesOrOptions, uniformsNamesOrEngine, samplers, defines, fallbacks, onCompiled, onError, indexParameters, shaderLanguage = (0, $8WI3I.ShaderLanguage).GLSL) {
        const vertex = baseName.vertexElement || baseName.vertex || baseName.vertexToken || baseName.vertexSource || baseName;
        const fragment = baseName.fragmentElement || baseName.fragment || baseName.fragmentToken || baseName.fragmentSource || baseName;
        const globalDefines = this._getGlobalDefines();
        let fullDefines = defines ?? attributesNamesOrOptions.defines ?? "";
        if (globalDefines) fullDefines += globalDefines;
        const name = vertex + "+" + fragment + "@" + fullDefines;
        if (this._compiledEffects[name]) {
            const compiledEffect = this._compiledEffects[name];
            if (onCompiled && compiledEffect.isReady()) onCompiled(compiledEffect);
            return compiledEffect;
        }
        const effect = new (0, $lUDWq.Effect)(baseName, attributesNamesOrOptions, uniformsNamesOrEngine, samplers, this, defines, fallbacks, onCompiled, onError, indexParameters, name, shaderLanguage);
        this._compiledEffects[name] = effect;
        return effect;
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    static _ConcatenateShader(source, defines, shaderVersion = "") {
        return shaderVersion + (defines ? defines + "\n" : "") + source;
    }
    _compileShader(source, type, defines, shaderVersion) {
        return this._compileRawShader($1a819ede290e980a$export$bfb63ef0b91d03e9._ConcatenateShader(source, defines, shaderVersion), type);
    }
    _compileRawShader(source, type) {
        const gl = this._gl;
        const shader = gl.createShader(type === "vertex" ? gl.VERTEX_SHADER : gl.FRAGMENT_SHADER);
        if (!shader) {
            let error = gl.NO_ERROR;
            let tempError = gl.NO_ERROR;
            while((tempError = gl.getError()) !== gl.NO_ERROR)error = tempError;
            throw new Error(`Something went wrong while creating a gl ${type} shader object. gl error=${error}, gl isContextLost=${gl.isContextLost()}, _contextWasLost=${this._contextWasLost}`);
        }
        gl.shaderSource(shader, source);
        gl.compileShader(shader);
        return shader;
    }
    /**
     * @internal
     */ _getShaderSource(shader) {
        return this._gl.getShaderSource(shader);
    }
    /**
     * Directly creates a webGL program
     * @param pipelineContext  defines the pipeline context to attach to
     * @param vertexCode defines the vertex shader code to use
     * @param fragmentCode defines the fragment shader code to use
     * @param context defines the webGL context to use (if not set, the current one will be used)
     * @param transformFeedbackVaryings defines the list of transform feedback varyings to use
     * @returns the new webGL program
     */ createRawShaderProgram(pipelineContext, vertexCode, fragmentCode, context, transformFeedbackVaryings = null) {
        context = context || this._gl;
        const vertexShader = this._compileRawShader(vertexCode, "vertex");
        const fragmentShader = this._compileRawShader(fragmentCode, "fragment");
        return this._createShaderProgram(pipelineContext, vertexShader, fragmentShader, context, transformFeedbackVaryings);
    }
    /**
     * Creates a webGL program
     * @param pipelineContext  defines the pipeline context to attach to
     * @param vertexCode  defines the vertex shader code to use
     * @param fragmentCode defines the fragment shader code to use
     * @param defines defines the string containing the defines to use to compile the shaders
     * @param context defines the webGL context to use (if not set, the current one will be used)
     * @param transformFeedbackVaryings defines the list of transform feedback varyings to use
     * @returns the new webGL program
     */ createShaderProgram(pipelineContext, vertexCode, fragmentCode, defines, context, transformFeedbackVaryings = null) {
        context = context || this._gl;
        const shaderVersion = this._webGLVersion > 1 ? "#version 300 es\n#define WEBGL2 \n" : "";
        const vertexShader = this._compileShader(vertexCode, "vertex", defines, shaderVersion);
        const fragmentShader = this._compileShader(fragmentCode, "fragment", defines, shaderVersion);
        return this._createShaderProgram(pipelineContext, vertexShader, fragmentShader, context, transformFeedbackVaryings);
    }
    /**
     * Inline functions in shader code that are marked to be inlined
     * @param code code to inline
     * @returns inlined code
     */ inlineShaderCode(code) {
        // no inlining needed in the WebGL engine
        return code;
    }
    /**
     * Creates a new pipeline context
     * @param shaderProcessingContext defines the shader processing context used during the processing if available
     * @returns the new pipeline
     */ createPipelineContext(shaderProcessingContext) {
        const pipelineContext = new (0, $d6QZE.WebGLPipelineContext)();
        pipelineContext.engine = this;
        if (this._caps.parallelShaderCompile) pipelineContext.isParallelCompiled = true;
        return pipelineContext;
    }
    /**
     * Creates a new material context
     * @returns the new context
     */ createMaterialContext() {
        return undefined;
    }
    /**
     * Creates a new draw context
     * @returns the new context
     */ createDrawContext() {
        return undefined;
    }
    _createShaderProgram(pipelineContext, vertexShader, fragmentShader, context, transformFeedbackVaryings = null) {
        const shaderProgram = context.createProgram();
        pipelineContext.program = shaderProgram;
        if (!shaderProgram) throw new Error("Unable to create program");
        context.attachShader(shaderProgram, vertexShader);
        context.attachShader(shaderProgram, fragmentShader);
        context.linkProgram(shaderProgram);
        pipelineContext.context = context;
        pipelineContext.vertexShader = vertexShader;
        pipelineContext.fragmentShader = fragmentShader;
        if (!pipelineContext.isParallelCompiled) this._finalizePipelineContext(pipelineContext);
        return shaderProgram;
    }
    _finalizePipelineContext(pipelineContext) {
        const context = pipelineContext.context;
        const vertexShader = pipelineContext.vertexShader;
        const fragmentShader = pipelineContext.fragmentShader;
        const program = pipelineContext.program;
        const linked = context.getProgramParameter(program, context.LINK_STATUS);
        if (!linked) {
            // Get more info
            // Vertex
            if (!this._gl.getShaderParameter(vertexShader, this._gl.COMPILE_STATUS)) {
                const log = this._gl.getShaderInfoLog(vertexShader);
                if (log) {
                    pipelineContext.vertexCompilationError = log;
                    throw new Error("VERTEX SHADER " + log);
                }
            }
            // Fragment
            if (!this._gl.getShaderParameter(fragmentShader, this._gl.COMPILE_STATUS)) {
                const log = this._gl.getShaderInfoLog(fragmentShader);
                if (log) {
                    pipelineContext.fragmentCompilationError = log;
                    throw new Error("FRAGMENT SHADER " + log);
                }
            }
            const error = context.getProgramInfoLog(program);
            if (error) {
                pipelineContext.programLinkError = error;
                throw new Error(error);
            }
        }
        if (this.validateShaderPrograms) {
            context.validateProgram(program);
            const validated = context.getProgramParameter(program, context.VALIDATE_STATUS);
            if (!validated) {
                const error = context.getProgramInfoLog(program);
                if (error) {
                    pipelineContext.programValidationError = error;
                    throw new Error(error);
                }
            }
        }
        context.deleteShader(vertexShader);
        context.deleteShader(fragmentShader);
        pipelineContext.vertexShader = undefined;
        pipelineContext.fragmentShader = undefined;
        if (pipelineContext.onCompiled) {
            pipelineContext.onCompiled();
            pipelineContext.onCompiled = undefined;
        }
    }
    /**
     * @internal
     */ _preparePipelineContext(pipelineContext, vertexSourceCode, fragmentSourceCode, createAsRaw, rawVertexSourceCode, rawFragmentSourceCode, rebuildRebind, defines, transformFeedbackVaryings, key) {
        const webGLRenderingState = pipelineContext;
        if (createAsRaw) webGLRenderingState.program = this.createRawShaderProgram(webGLRenderingState, vertexSourceCode, fragmentSourceCode, undefined, transformFeedbackVaryings);
        else webGLRenderingState.program = this.createShaderProgram(webGLRenderingState, vertexSourceCode, fragmentSourceCode, defines, undefined, transformFeedbackVaryings);
        webGLRenderingState.program.__SPECTOR_rebuildProgram = rebuildRebind;
    }
    /**
     * @internal
     */ _isRenderingStateCompiled(pipelineContext) {
        const webGLPipelineContext = pipelineContext;
        if (this._isDisposed || webGLPipelineContext._isDisposed) return false;
        if (this._gl.getProgramParameter(webGLPipelineContext.program, this._caps.parallelShaderCompile.COMPLETION_STATUS_KHR)) {
            this._finalizePipelineContext(webGLPipelineContext);
            return true;
        }
        return false;
    }
    /**
     * @internal
     */ _executeWhenRenderingStateIsCompiled(pipelineContext, action) {
        const webGLPipelineContext = pipelineContext;
        if (!webGLPipelineContext.isParallelCompiled) {
            action();
            return;
        }
        const oldHandler = webGLPipelineContext.onCompiled;
        if (oldHandler) webGLPipelineContext.onCompiled = ()=>{
            oldHandler();
            action();
        };
        else webGLPipelineContext.onCompiled = action;
    }
    /**
     * Gets the list of webGL uniform locations associated with a specific program based on a list of uniform names
     * @param pipelineContext defines the pipeline context to use
     * @param uniformsNames defines the list of uniform names
     * @returns an array of webGL uniform locations
     */ getUniforms(pipelineContext, uniformsNames) {
        const results = new Array();
        const webGLPipelineContext = pipelineContext;
        for(let index = 0; index < uniformsNames.length; index++)results.push(this._gl.getUniformLocation(webGLPipelineContext.program, uniformsNames[index]));
        return results;
    }
    /**
     * Gets the list of active attributes for a given webGL program
     * @param pipelineContext defines the pipeline context to use
     * @param attributesNames defines the list of attribute names to get
     * @returns an array of indices indicating the offset of each attribute
     */ getAttributes(pipelineContext, attributesNames) {
        const results = [];
        const webGLPipelineContext = pipelineContext;
        for(let index = 0; index < attributesNames.length; index++)try {
            results.push(this._gl.getAttribLocation(webGLPipelineContext.program, attributesNames[index]));
        } catch (e) {
            results.push(-1);
        }
        return results;
    }
    /**
     * Activates an effect, making it the current one (ie. the one used for rendering)
     * @param effect defines the effect to activate
     */ enableEffect(effect) {
        effect = effect !== null && (0, $hOyoX.DrawWrapper).IsWrapper(effect) ? effect.effect : effect; // get only the effect, we don't need a Wrapper in the WebGL engine
        if (!effect || effect === this._currentEffect) return;
        this._stencilStateComposer.stencilMaterial = undefined;
        effect;
        // Use program
        this.bindSamplers(effect);
        this._currentEffect = effect;
        if (effect.onBind) effect.onBind(effect);
        if (effect._onBindObservable) effect._onBindObservable.notifyObservers(effect);
    }
    /**
     * Set the value of an uniform to a number (int)
     * @param uniform defines the webGL uniform location where to store the value
     * @param value defines the int number to store
     * @returns true if the value was set
     */ setInt(uniform, value) {
        if (!uniform) return false;
        this._gl.uniform1i(uniform, value);
        return true;
    }
    /**
     * Set the value of an uniform to a int2
     * @param uniform defines the webGL uniform location where to store the value
     * @param x defines the 1st component of the value
     * @param y defines the 2nd component of the value
     * @returns true if the value was set
     */ setInt2(uniform, x, y) {
        if (!uniform) return false;
        this._gl.uniform2i(uniform, x, y);
        return true;
    }
    /**
     * Set the value of an uniform to a int3
     * @param uniform defines the webGL uniform location where to store the value
     * @param x defines the 1st component of the value
     * @param y defines the 2nd component of the value
     * @param z defines the 3rd component of the value
     * @returns true if the value was set
     */ setInt3(uniform, x, y, z) {
        if (!uniform) return false;
        this._gl.uniform3i(uniform, x, y, z);
        return true;
    }
    /**
     * Set the value of an uniform to a int4
     * @param uniform defines the webGL uniform location where to store the value
     * @param x defines the 1st component of the value
     * @param y defines the 2nd component of the value
     * @param z defines the 3rd component of the value
     * @param w defines the 4th component of the value
     * @returns true if the value was set
     */ setInt4(uniform, x, y, z, w) {
        if (!uniform) return false;
        this._gl.uniform4i(uniform, x, y, z, w);
        return true;
    }
    /**
     * Set the value of an uniform to an array of int32
     * @param uniform defines the webGL uniform location where to store the value
     * @param array defines the array of int32 to store
     * @returns true if the value was set
     */ setIntArray(uniform, array) {
        if (!uniform) return false;
        this._gl.uniform1iv(uniform, array);
        return true;
    }
    /**
     * Set the value of an uniform to an array of int32 (stored as vec2)
     * @param uniform defines the webGL uniform location where to store the value
     * @param array defines the array of int32 to store
     * @returns true if the value was set
     */ setIntArray2(uniform, array) {
        if (!uniform || array.length % 2 !== 0) return false;
        this._gl.uniform2iv(uniform, array);
        return true;
    }
    /**
     * Set the value of an uniform to an array of int32 (stored as vec3)
     * @param uniform defines the webGL uniform location where to store the value
     * @param array defines the array of int32 to store
     * @returns true if the value was set
     */ setIntArray3(uniform, array) {
        if (!uniform || array.length % 3 !== 0) return false;
        this._gl.uniform3iv(uniform, array);
        return true;
    }
    /**
     * Set the value of an uniform to an array of int32 (stored as vec4)
     * @param uniform defines the webGL uniform location where to store the value
     * @param array defines the array of int32 to store
     * @returns true if the value was set
     */ setIntArray4(uniform, array) {
        if (!uniform || array.length % 4 !== 0) return false;
        this._gl.uniform4iv(uniform, array);
        return true;
    }
    /**
     * Set the value of an uniform to a number (unsigned int)
     * @param uniform defines the webGL uniform location where to store the value
     * @param value defines the unsigned int number to store
     * @returns true if the value was set
     */ setUInt(uniform, value) {
        if (!uniform) return false;
        this._gl.uniform1ui(uniform, value);
        return true;
    }
    /**
     * Set the value of an uniform to a unsigned int2
     * @param uniform defines the webGL uniform location where to store the value
     * @param x defines the 1st component of the value
     * @param y defines the 2nd component of the value
     * @returns true if the value was set
     */ setUInt2(uniform, x, y) {
        if (!uniform) return false;
        this._gl.uniform2ui(uniform, x, y);
        return true;
    }
    /**
     * Set the value of an uniform to a unsigned int3
     * @param uniform defines the webGL uniform location where to store the value
     * @param x defines the 1st component of the value
     * @param y defines the 2nd component of the value
     * @param z defines the 3rd component of the value
     * @returns true if the value was set
     */ setUInt3(uniform, x, y, z) {
        if (!uniform) return false;
        this._gl.uniform3ui(uniform, x, y, z);
        return true;
    }
    /**
     * Set the value of an uniform to a unsigned int4
     * @param uniform defines the webGL uniform location where to store the value
     * @param x defines the 1st component of the value
     * @param y defines the 2nd component of the value
     * @param z defines the 3rd component of the value
     * @param w defines the 4th component of the value
     * @returns true if the value was set
     */ setUInt4(uniform, x, y, z, w) {
        if (!uniform) return false;
        this._gl.uniform4ui(uniform, x, y, z, w);
        return true;
    }
    /**
     * Set the value of an uniform to an array of unsigned int32
     * @param uniform defines the webGL uniform location where to store the value
     * @param array defines the array of unsigned int32 to store
     * @returns true if the value was set
     */ setUIntArray(uniform, array) {
        if (!uniform) return false;
        this._gl.uniform1uiv(uniform, array);
        return true;
    }
    /**
     * Set the value of an uniform to an array of unsigned int32 (stored as vec2)
     * @param uniform defines the webGL uniform location where to store the value
     * @param array defines the array of unsigned int32 to store
     * @returns true if the value was set
     */ setUIntArray2(uniform, array) {
        if (!uniform || array.length % 2 !== 0) return false;
        this._gl.uniform2uiv(uniform, array);
        return true;
    }
    /**
     * Set the value of an uniform to an array of unsigned int32 (stored as vec3)
     * @param uniform defines the webGL uniform location where to store the value
     * @param array defines the array of unsigned int32 to store
     * @returns true if the value was set
     */ setUIntArray3(uniform, array) {
        if (!uniform || array.length % 3 !== 0) return false;
        this._gl.uniform3uiv(uniform, array);
        return true;
    }
    /**
     * Set the value of an uniform to an array of unsigned int32 (stored as vec4)
     * @param uniform defines the webGL uniform location where to store the value
     * @param array defines the array of unsigned int32 to store
     * @returns true if the value was set
     */ setUIntArray4(uniform, array) {
        if (!uniform || array.length % 4 !== 0) return false;
        this._gl.uniform4uiv(uniform, array);
        return true;
    }
    /**
     * Set the value of an uniform to an array of number
     * @param uniform defines the webGL uniform location where to store the value
     * @param array defines the array of number to store
     * @returns true if the value was set
     */ setArray(uniform, array) {
        if (!uniform) return false;
        if (array.length < 1) return false;
        this._gl.uniform1fv(uniform, array);
        return true;
    }
    /**
     * Set the value of an uniform to an array of number (stored as vec2)
     * @param uniform defines the webGL uniform location where to store the value
     * @param array defines the array of number to store
     * @returns true if the value was set
     */ setArray2(uniform, array) {
        if (!uniform || array.length % 2 !== 0) return false;
        this._gl.uniform2fv(uniform, array);
        return true;
    }
    /**
     * Set the value of an uniform to an array of number (stored as vec3)
     * @param uniform defines the webGL uniform location where to store the value
     * @param array defines the array of number to store
     * @returns true if the value was set
     */ setArray3(uniform, array) {
        if (!uniform || array.length % 3 !== 0) return false;
        this._gl.uniform3fv(uniform, array);
        return true;
    }
    /**
     * Set the value of an uniform to an array of number (stored as vec4)
     * @param uniform defines the webGL uniform location where to store the value
     * @param array defines the array of number to store
     * @returns true if the value was set
     */ setArray4(uniform, array) {
        if (!uniform || array.length % 4 !== 0) return false;
        this._gl.uniform4fv(uniform, array);
        return true;
    }
    /**
     * Set the value of an uniform to an array of float32 (stored as matrices)
     * @param uniform defines the webGL uniform location where to store the value
     * @param matrices defines the array of float32 to store
     * @returns true if the value was set
     */ setMatrices(uniform, matrices) {
        if (!uniform) return false;
        this._gl.uniformMatrix4fv(uniform, false, matrices);
        return true;
    }
    /**
     * Set the value of an uniform to a matrix (3x3)
     * @param uniform defines the webGL uniform location where to store the value
     * @param matrix defines the Float32Array representing the 3x3 matrix to store
     * @returns true if the value was set
     */ setMatrix3x3(uniform, matrix) {
        if (!uniform) return false;
        this._gl.uniformMatrix3fv(uniform, false, matrix);
        return true;
    }
    /**
     * Set the value of an uniform to a matrix (2x2)
     * @param uniform defines the webGL uniform location where to store the value
     * @param matrix defines the Float32Array representing the 2x2 matrix to store
     * @returns true if the value was set
     */ setMatrix2x2(uniform, matrix) {
        if (!uniform) return false;
        this._gl.uniformMatrix2fv(uniform, false, matrix);
        return true;
    }
    /**
     * Set the value of an uniform to a number (float)
     * @param uniform defines the webGL uniform location where to store the value
     * @param value defines the float number to store
     * @returns true if the value was transferred
     */ setFloat(uniform, value) {
        if (!uniform) return false;
        this._gl.uniform1f(uniform, value);
        return true;
    }
    /**
     * Set the value of an uniform to a vec2
     * @param uniform defines the webGL uniform location where to store the value
     * @param x defines the 1st component of the value
     * @param y defines the 2nd component of the value
     * @returns true if the value was set
     */ setFloat2(uniform, x, y) {
        if (!uniform) return false;
        this._gl.uniform2f(uniform, x, y);
        return true;
    }
    /**
     * Set the value of an uniform to a vec3
     * @param uniform defines the webGL uniform location where to store the value
     * @param x defines the 1st component of the value
     * @param y defines the 2nd component of the value
     * @param z defines the 3rd component of the value
     * @returns true if the value was set
     */ setFloat3(uniform, x, y, z) {
        if (!uniform) return false;
        this._gl.uniform3f(uniform, x, y, z);
        return true;
    }
    /**
     * Set the value of an uniform to a vec4
     * @param uniform defines the webGL uniform location where to store the value
     * @param x defines the 1st component of the value
     * @param y defines the 2nd component of the value
     * @param z defines the 3rd component of the value
     * @param w defines the 4th component of the value
     * @returns true if the value was set
     */ setFloat4(uniform, x, y, z, w) {
        if (!uniform) return false;
        this._gl.uniform4f(uniform, x, y, z, w);
        return true;
    }
    // States
    /**
     * Apply all cached states (depth, culling, stencil and alpha)
     */ applyStates() {
        this._depthCullingState.apply(this._gl);
        this._stencilStateComposer.apply(this._gl);
        this._alphaState.apply(this._gl);
        if (this._colorWriteChanged) {
            this._colorWriteChanged = false;
            const enable = this._colorWrite;
            this._gl.colorMask(enable, enable, enable, enable);
        }
    }
    /**
     * Enable or disable color writing
     * @param enable defines the state to set
     */ setColorWrite(enable) {
        if (enable !== this._colorWrite) {
            this._colorWriteChanged = true;
            this._colorWrite = enable;
        }
    }
    /**
     * Gets a boolean indicating if color writing is enabled
     * @returns the current color writing state
     */ getColorWrite() {
        return this._colorWrite;
    }
    /**
     * Gets the depth culling state manager
     */ get depthCullingState() {
        return this._depthCullingState;
    }
    /**
     * Gets the alpha state manager
     */ get alphaState() {
        return this._alphaState;
    }
    /**
     * Gets the stencil state manager
     */ get stencilState() {
        return this._stencilState;
    }
    /**
     * Gets the stencil state composer
     */ get stencilStateComposer() {
        return this._stencilStateComposer;
    }
    // Textures
    /**
     * Clears the list of texture accessible through engine.
     * This can help preventing texture load conflict due to name collision.
     */ clearInternalTexturesCache() {
        this._internalTexturesCache.length = 0;
    }
    /**
     * Force the entire cache to be cleared
     * You should not have to use this function unless your engine needs to share the webGL context with another engine
     * @param bruteForce defines a boolean to force clearing ALL caches (including stencil, detoh and alpha states)
     */ wipeCaches(bruteForce) {
        if (this.preventCacheWipeBetweenFrames && !bruteForce) return;
        this._currentEffect = null;
        this._viewportCached.x = 0;
        this._viewportCached.y = 0;
        this._viewportCached.z = 0;
        this._viewportCached.w = 0;
        // Done before in case we clean the attributes
        this._unbindVertexArrayObject();
        if (bruteForce) {
            this._currentProgram = null;
            this.resetTextureCache();
            this._stencilStateComposer.reset();
            this._depthCullingState.reset();
            this._depthCullingState.depthFunc = this._gl.LEQUAL;
            this._alphaState.reset();
            this._alphaMode = 1;
            this._alphaEquation = 0;
            this._colorWrite = true;
            this._colorWriteChanged = true;
            this._unpackFlipYCached = null;
            this._gl.pixelStorei(this._gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, this._gl.NONE);
            this._gl.pixelStorei(this._gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, 0);
            this._mustWipeVertexAttributes = true;
            this.unbindAllAttributes();
        }
        this._resetVertexBufferBinding();
        this._cachedIndexBuffer = null;
        this._cachedEffectForVertexBuffers = null;
        this.bindIndexBuffer(null);
    }
    /**
     * @internal
     */ _getSamplingParameters(samplingMode, generateMipMaps) {
        const gl = this._gl;
        let magFilter = gl.NEAREST;
        let minFilter = gl.NEAREST;
        switch(samplingMode){
            case 11:
                magFilter = gl.LINEAR;
                if (generateMipMaps) minFilter = gl.LINEAR_MIPMAP_NEAREST;
                else minFilter = gl.LINEAR;
                break;
            case 3:
                magFilter = gl.LINEAR;
                if (generateMipMaps) minFilter = gl.LINEAR_MIPMAP_LINEAR;
                else minFilter = gl.LINEAR;
                break;
            case 8:
                magFilter = gl.NEAREST;
                if (generateMipMaps) minFilter = gl.NEAREST_MIPMAP_LINEAR;
                else minFilter = gl.NEAREST;
                break;
            case 4:
                magFilter = gl.NEAREST;
                if (generateMipMaps) minFilter = gl.NEAREST_MIPMAP_NEAREST;
                else minFilter = gl.NEAREST;
                break;
            case 5:
                magFilter = gl.NEAREST;
                if (generateMipMaps) minFilter = gl.LINEAR_MIPMAP_NEAREST;
                else minFilter = gl.LINEAR;
                break;
            case 6:
                magFilter = gl.NEAREST;
                if (generateMipMaps) minFilter = gl.LINEAR_MIPMAP_LINEAR;
                else minFilter = gl.LINEAR;
                break;
            case 7:
                magFilter = gl.NEAREST;
                minFilter = gl.LINEAR;
                break;
            case 1:
                magFilter = gl.NEAREST;
                minFilter = gl.NEAREST;
                break;
            case 9:
                magFilter = gl.LINEAR;
                if (generateMipMaps) minFilter = gl.NEAREST_MIPMAP_NEAREST;
                else minFilter = gl.NEAREST;
                break;
            case 10:
                magFilter = gl.LINEAR;
                if (generateMipMaps) minFilter = gl.NEAREST_MIPMAP_LINEAR;
                else minFilter = gl.NEAREST;
                break;
            case 2:
                magFilter = gl.LINEAR;
                minFilter = gl.LINEAR;
                break;
            case 12:
                magFilter = gl.LINEAR;
                minFilter = gl.NEAREST;
                break;
        }
        return {
            min: minFilter,
            mag: magFilter
        };
    }
    /** @internal */ _createTexture() {
        const texture = this._gl.createTexture();
        if (!texture) throw new Error("Unable to create texture");
        return texture;
    }
    /** @internal */ _createHardwareTexture() {
        return new (0, $8ClRi.WebGLHardwareTexture)(this._createTexture(), this._gl);
    }
    /**
     * Creates an internal texture without binding it to a framebuffer
     * @internal
     * @param size defines the size of the texture
     * @param options defines the options used to create the texture
     * @param delayGPUTextureCreation true to delay the texture creation the first time it is really needed. false to create it right away
     * @param source source type of the texture
     * @returns a new internal texture
     */ _createInternalTexture(size, options, delayGPUTextureCreation = true, source = (0, $b9e4a.InternalTextureSource).Unknown) {
        let generateMipMaps = false;
        let type = 0;
        let samplingMode = 3;
        let format = 5;
        let useSRGBBuffer = false;
        let samples = 1;
        let label;
        if (options !== undefined && typeof options === "object") {
            generateMipMaps = !!options.generateMipMaps;
            type = options.type === undefined ? 0 : options.type;
            samplingMode = options.samplingMode === undefined ? 3 : options.samplingMode;
            format = options.format === undefined ? 5 : options.format;
            useSRGBBuffer = options.useSRGBBuffer === undefined ? false : options.useSRGBBuffer;
            samples = options.samples ?? 1;
            label = options.label;
        } else generateMipMaps = !!options;
        useSRGBBuffer && (useSRGBBuffer = this._caps.supportSRGBBuffers && (this.webGLVersion > 1 || this.isWebGPU));
        if (type === 1 && !this._caps.textureFloatLinearFiltering) // if floating point linear (gl.FLOAT) then force to NEAREST_SAMPLINGMODE
        samplingMode = 1;
        else if (type === 2 && !this._caps.textureHalfFloatLinearFiltering) // if floating point linear (HALF_FLOAT) then force to NEAREST_SAMPLINGMODE
        samplingMode = 1;
        if (type === 1 && !this._caps.textureFloat) {
            type = 0;
            (0, $kVtWi.Logger).Warn("Float textures are not supported. Type forced to TEXTURETYPE_UNSIGNED_BYTE");
        }
        const gl = this._gl;
        const texture = new (0, $b9e4a.InternalTexture)(this, source);
        const width = size.width || size;
        const height = size.height || size;
        const layers = size.layers || 0;
        const filters = this._getSamplingParameters(samplingMode, generateMipMaps);
        const target = layers !== 0 ? gl.TEXTURE_2D_ARRAY : gl.TEXTURE_2D;
        const sizedFormat = this._getRGBABufferInternalSizedFormat(type, format, useSRGBBuffer);
        const internalFormat = this._getInternalFormat(format);
        const textureType = this._getWebGLTextureType(type);
        // Bind
        this._bindTextureDirectly(target, texture);
        if (layers !== 0) {
            texture.is2DArray = true;
            gl.texImage3D(target, 0, sizedFormat, width, height, layers, 0, internalFormat, textureType, null);
        } else gl.texImage2D(target, 0, sizedFormat, width, height, 0, internalFormat, textureType, null);
        gl.texParameteri(target, gl.TEXTURE_MAG_FILTER, filters.mag);
        gl.texParameteri(target, gl.TEXTURE_MIN_FILTER, filters.min);
        gl.texParameteri(target, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(target, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        // MipMaps
        if (generateMipMaps) this._gl.generateMipmap(target);
        this._bindTextureDirectly(target, null);
        texture._useSRGBBuffer = useSRGBBuffer;
        texture.baseWidth = width;
        texture.baseHeight = height;
        texture.width = width;
        texture.height = height;
        texture.depth = layers;
        texture.isReady = true;
        texture.samples = samples;
        texture.generateMipMaps = generateMipMaps;
        texture.samplingMode = samplingMode;
        texture.type = type;
        texture.format = format;
        texture.label = label;
        this._internalTexturesCache.push(texture);
        return texture;
    }
    /**
     * @internal
     */ _getUseSRGBBuffer(useSRGBBuffer, noMipmap) {
        // Generating mipmaps for sRGB textures is not supported in WebGL1 so we must disable the support if mipmaps is enabled
        return useSRGBBuffer && this._caps.supportSRGBBuffers && (this.webGLVersion > 1 || this.isWebGPU || noMipmap);
    }
    _createTextureBase(url, noMipmap, invertY, scene, samplingMode = 3, onLoad = null, onError = null, prepareTexture, prepareTextureProcessFunction, buffer = null, fallback = null, format = null, forcedExtension = null, mimeType, loaderOptions, useSRGBBuffer) {
        url = url || "";
        const fromData = url.substr(0, 5) === "data:";
        const fromBlob = url.substr(0, 5) === "blob:";
        const isBase64 = fromData && url.indexOf(";base64,") !== -1;
        const texture = fallback ? fallback : new (0, $b9e4a.InternalTexture)(this, (0, $b9e4a.InternalTextureSource).Url);
        if (texture !== fallback) texture.label = url.substring(0, 60); // default label, can be overriden by the caller
        const originalUrl = url;
        if (this._transformTextureUrl && !isBase64 && !fallback && !buffer) url = this._transformTextureUrl(url);
        if (originalUrl !== url) texture._originalUrl = originalUrl;
        // establish the file extension, if possible
        const lastDot = url.lastIndexOf(".");
        let extension = forcedExtension ? forcedExtension : lastDot > -1 ? url.substring(lastDot).toLowerCase() : "";
        let loader = null;
        // Remove query string
        const queryStringIndex = extension.indexOf("?");
        if (queryStringIndex > -1) extension = extension.split("?")[0];
        for (const availableLoader of $1a819ede290e980a$export$bfb63ef0b91d03e9._TextureLoaders)if (availableLoader.canLoad(extension, mimeType)) {
            loader = availableLoader;
            break;
        }
        if (scene) scene.addPendingData(texture);
        texture.url = url;
        texture.generateMipMaps = !noMipmap;
        texture.samplingMode = samplingMode;
        texture.invertY = invertY;
        texture._useSRGBBuffer = this._getUseSRGBBuffer(!!useSRGBBuffer, noMipmap);
        if (!this._doNotHandleContextLost) // Keep a link to the buffer only if we plan to handle context lost
        texture._buffer = buffer;
        let onLoadObserver = null;
        if (onLoad && !fallback) onLoadObserver = texture.onLoadedObservable.add(onLoad);
        if (!fallback) this._internalTexturesCache.push(texture);
        const onInternalError = (message, exception)=>{
            if (scene) scene.removePendingData(texture);
            if (url === originalUrl) {
                if (onLoadObserver) texture.onLoadedObservable.remove(onLoadObserver);
                if ((0, $ejQPp.EngineStore).UseFallbackTexture && url !== (0, $ejQPp.EngineStore).FallbackTexture) this._createTextureBase((0, $ejQPp.EngineStore).FallbackTexture, noMipmap, texture.invertY, scene, samplingMode, null, onError, prepareTexture, prepareTextureProcessFunction, buffer, texture);
                message = (message || "Unknown error") + ((0, $ejQPp.EngineStore).UseFallbackTexture ? " - Fallback texture was used" : "");
                texture.onErrorObservable.notifyObservers({
                    message: message,
                    exception: exception
                });
                if (onError) onError(message, exception);
            } else {
                // fall back to the original url if the transformed url fails to load
                (0, $kVtWi.Logger).Warn(`Failed to load ${url}, falling back to ${originalUrl}`);
                this._createTextureBase(originalUrl, noMipmap, texture.invertY, scene, samplingMode, onLoad, onError, prepareTexture, prepareTextureProcessFunction, buffer, texture, format, forcedExtension, mimeType, loaderOptions, useSRGBBuffer);
            }
        };
        // processing for non-image formats
        if (loader) {
            const callback = (data)=>{
                loader.loadData(data, texture, (width, height, loadMipmap, isCompressed, done, loadFailed)=>{
                    if (loadFailed) onInternalError("TextureLoader failed to load data");
                    else prepareTexture(texture, extension, scene, {
                        width: width,
                        height: height
                    }, texture.invertY, !loadMipmap, isCompressed, ()=>{
                        done();
                        return false;
                    }, samplingMode);
                }, loaderOptions);
            };
            if (!buffer) this._loadFile(url, (data)=>callback(new Uint8Array(data)), undefined, scene ? scene.offlineProvider : undefined, true, (request, exception)=>{
                onInternalError("Unable to load " + (request ? request.responseURL : url, exception));
            });
            else {
                if (buffer instanceof ArrayBuffer) callback(new Uint8Array(buffer));
                else if (ArrayBuffer.isView(buffer)) callback(buffer);
                else if (onError) onError("Unable to load: only ArrayBuffer or ArrayBufferView is supported", null);
            }
        } else {
            const onload = (img)=>{
                if (fromBlob && !this._doNotHandleContextLost) // We need to store the image if we need to rebuild the texture
                // in case of a webgl context lost
                texture._buffer = img;
                prepareTexture(texture, extension, scene, img, texture.invertY, noMipmap, false, prepareTextureProcessFunction, samplingMode);
            };
            // According to the WebGL spec section 6.10, ImageBitmaps must be inverted on creation.
            // So, we pass imageOrientation to _FileToolsLoadImage() as it may create an ImageBitmap.
            if (!fromData || isBase64) {
                if (buffer && (typeof buffer.decoding === "string" || buffer.close)) onload(buffer);
                else $1a819ede290e980a$export$bfb63ef0b91d03e9._FileToolsLoadImage(url, onload, onInternalError, scene ? scene.offlineProvider : null, mimeType, texture.invertY && this._features.needsInvertingBitmap ? {
                    imageOrientation: "flipY"
                } : undefined);
            } else if (typeof buffer === "string" || buffer instanceof ArrayBuffer || ArrayBuffer.isView(buffer) || buffer instanceof Blob) $1a819ede290e980a$export$bfb63ef0b91d03e9._FileToolsLoadImage(buffer, onload, onInternalError, scene ? scene.offlineProvider : null, mimeType, texture.invertY && this._features.needsInvertingBitmap ? {
                imageOrientation: "flipY"
            } : undefined);
            else if (buffer) onload(buffer);
        }
        return texture;
    }
    /**
     * Usually called from Texture.ts.
     * Passed information to create a WebGLTexture
     * @param url defines a value which contains one of the following:
     * * A conventional http URL, e.g. 'http://...' or 'file://...'
     * * A base64 string of in-line texture data, e.g. 'data:image/jpg;base64,/...'
     * * An indicator that data being passed using the buffer parameter, e.g. 'data:mytexture.jpg'
     * @param noMipmap defines a boolean indicating that no mipmaps shall be generated.  Ignored for compressed textures.  They must be in the file
     * @param invertY when true, image is flipped when loaded.  You probably want true. Certain compressed textures may invert this if their default is inverted (eg. ktx)
     * @param scene needed for loading to the correct scene
     * @param samplingMode mode with should be used sample / access the texture (Default: Texture.TRILINEAR_SAMPLINGMODE)
     * @param onLoad optional callback to be called upon successful completion
     * @param onError optional callback to be called upon failure
     * @param buffer a source of a file previously fetched as either a base64 string, an ArrayBuffer (compressed or image format), HTMLImageElement (image format), or a Blob
     * @param fallback an internal argument in case the function must be called again, due to etc1 not having alpha capabilities
     * @param format internal format.  Default: RGB when extension is '.jpg' else RGBA.  Ignored for compressed textures
     * @param forcedExtension defines the extension to use to pick the right loader
     * @param mimeType defines an optional mime type
     * @param loaderOptions options to be passed to the loader
     * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
     * @param useSRGBBuffer defines if the texture must be loaded in a sRGB GPU buffer (if supported by the GPU).
     * @returns a InternalTexture for assignment back into BABYLON.Texture
     */ createTexture(url, noMipmap, invertY, scene, samplingMode = 3, onLoad = null, onError = null, buffer = null, fallback = null, format = null, forcedExtension = null, mimeType, loaderOptions, creationFlags, useSRGBBuffer) {
        return this._createTextureBase(url, noMipmap, invertY, scene, samplingMode, onLoad, onError, this._prepareWebGLTexture.bind(this), (potWidth, potHeight, img, extension, texture, continuationCallback)=>{
            const gl = this._gl;
            const isPot = img.width === potWidth && img.height === potHeight;
            texture._creationFlags = creationFlags ?? 0;
            const tip = this._getTexImageParametersForCreateTexture(format, extension, texture._useSRGBBuffer);
            if (isPot) {
                gl.texImage2D(gl.TEXTURE_2D, 0, tip.internalFormat, tip.format, tip.type, img);
                return false;
            }
            const maxTextureSize = this._caps.maxTextureSize;
            if (img.width > maxTextureSize || img.height > maxTextureSize || !this._supportsHardwareTextureRescaling) {
                this._prepareWorkingCanvas();
                if (!this._workingCanvas || !this._workingContext) return false;
                this._workingCanvas.width = potWidth;
                this._workingCanvas.height = potHeight;
                this._workingContext.drawImage(img, 0, 0, img.width, img.height, 0, 0, potWidth, potHeight);
                gl.texImage2D(gl.TEXTURE_2D, 0, tip.internalFormat, tip.format, tip.type, this._workingCanvas);
                texture.width = potWidth;
                texture.height = potHeight;
                return false;
            } else {
                // Using shaders when possible to rescale because canvas.drawImage is lossy
                const source = new (0, $b9e4a.InternalTexture)(this, (0, $b9e4a.InternalTextureSource).Temp);
                this._bindTextureDirectly(gl.TEXTURE_2D, source, true);
                gl.texImage2D(gl.TEXTURE_2D, 0, tip.internalFormat, tip.format, tip.type, img);
                this._rescaleTexture(source, texture, scene, tip.format, ()=>{
                    this._releaseTexture(source);
                    this._bindTextureDirectly(gl.TEXTURE_2D, texture, true);
                    continuationCallback();
                });
            }
            return true;
        }, buffer, fallback, format, forcedExtension, mimeType, loaderOptions, useSRGBBuffer);
    }
    /**
     * Calls to the GL texImage2D and texImage3D functions require three arguments describing the pixel format of the texture.
     * createTexture derives these from the babylonFormat and useSRGBBuffer arguments and also the file extension of the URL it's working with.
     * This function encapsulates that derivation for easy unit testing.
     * @param babylonFormat Babylon's format enum, as specified in ITextureCreationOptions.
     * @param fileExtension The file extension including the dot, e.g. .jpg.
     * @param useSRGBBuffer Use SRGB not linear.
     * @returns The options to pass to texImage2D or texImage3D calls.
     * @internal
     */ _getTexImageParametersForCreateTexture(babylonFormat, fileExtension, useSRGBBuffer) {
        if (babylonFormat === undefined || babylonFormat === null) babylonFormat = fileExtension === ".jpg" && !useSRGBBuffer ? 4 : 5;
        let format, internalFormat;
        if (this.webGLVersion === 1) {
            // In WebGL 1, format and internalFormat must be the same and taken from a limited set of values, see https://docs.gl/es2/glTexImage2D.
            // The SRGB extension (https://developer.mozilla.org/en-US/docs/Web/API/EXT_sRGB) adds some extra values, hence passing useSRGBBuffer
            // to getInternalFormat.
            format = this._getInternalFormat(babylonFormat, useSRGBBuffer);
            internalFormat = format;
        } else {
            // In WebGL 2, format has a wider range of values and internal format can be one of the sized formats, see
            // https://registry.khronos.org/OpenGL-Refpages/es3.0/html/glTexImage2D.xhtml.
            // SRGB is included in the sized format and should not be passed in "format", hence always passing useSRGBBuffer as false.
            format = this._getInternalFormat(babylonFormat, false);
            internalFormat = this._getRGBABufferInternalSizedFormat(0, babylonFormat, useSRGBBuffer);
        }
        return {
            internalFormat: internalFormat,
            format: format,
            type: this._gl.UNSIGNED_BYTE
        };
    }
    /**
     * Loads an image as an HTMLImageElement.
     * @param input url string, ArrayBuffer, or Blob to load
     * @param onLoad callback called when the image successfully loads
     * @param onError callback called when the image fails to load
     * @param offlineProvider offline provider for caching
     * @param mimeType optional mime type
     * @param imageBitmapOptions optional the options to use when creating an ImageBitmap
     * @returns the HTMLImageElement of the loaded image
     * @internal
     */ static _FileToolsLoadImage(input, onLoad, onError, offlineProvider, mimeType, imageBitmapOptions) {
        throw (0, $dUFYy._WarnImport)("FileTools");
    }
    /**
     * @internal
     */ _rescaleTexture(source, destination, scene, internalFormat, onComplete) {}
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Creates a raw texture
     * @param data defines the data to store in the texture
     * @param width defines the width of the texture
     * @param height defines the height of the texture
     * @param format defines the format of the data
     * @param generateMipMaps defines if the engine should generate the mip levels
     * @param invertY defines if data must be stored with Y axis inverted
     * @param samplingMode defines the required sampling mode (Texture.NEAREST_SAMPLINGMODE by default)
     * @param compression defines the compression used (null by default)
     * @param type defines the type fo the data (Engine.TEXTURETYPE_UNSIGNED_INT by default)
     * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
     * @param useSRGBBuffer defines if the texture must be loaded in a sRGB GPU buffer (if supported by the GPU).
     * @returns the raw texture inside an InternalTexture
     */ createRawTexture(data, width, height, format, generateMipMaps, invertY, samplingMode, compression = null, type = 0, creationFlags = 0, useSRGBBuffer = false) {
        throw (0, $dUFYy._WarnImport)("Engine.RawTexture");
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Creates a new raw cube texture
     * @param data defines the array of data to use to create each face
     * @param size defines the size of the textures
     * @param format defines the format of the data
     * @param type defines the type of the data (like Engine.TEXTURETYPE_UNSIGNED_INT)
     * @param generateMipMaps  defines if the engine should generate the mip levels
     * @param invertY defines if data must be stored with Y axis inverted
     * @param samplingMode defines the required sampling mode (like Texture.NEAREST_SAMPLINGMODE)
     * @param compression defines the compression used (null by default)
     * @returns the cube texture as an InternalTexture
     */ createRawCubeTexture(data, size, format, type, generateMipMaps, invertY, samplingMode, compression = null) {
        throw (0, $dUFYy._WarnImport)("Engine.RawTexture");
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Creates a new raw 3D texture
     * @param data defines the data used to create the texture
     * @param width defines the width of the texture
     * @param height defines the height of the texture
     * @param depth defines the depth of the texture
     * @param format defines the format of the texture
     * @param generateMipMaps defines if the engine must generate mip levels
     * @param invertY defines if data must be stored with Y axis inverted
     * @param samplingMode defines the required sampling mode (like Texture.NEAREST_SAMPLINGMODE)
     * @param compression defines the compressed used (can be null)
     * @param textureType defines the compressed used (can be null)
     * @returns a new raw 3D texture (stored in an InternalTexture)
     */ createRawTexture3D(data, width, height, depth, format, generateMipMaps, invertY, samplingMode, compression = null, textureType = 0) {
        throw (0, $dUFYy._WarnImport)("Engine.RawTexture");
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Creates a new raw 2D array texture
     * @param data defines the data used to create the texture
     * @param width defines the width of the texture
     * @param height defines the height of the texture
     * @param depth defines the number of layers of the texture
     * @param format defines the format of the texture
     * @param generateMipMaps defines if the engine must generate mip levels
     * @param invertY defines if data must be stored with Y axis inverted
     * @param samplingMode defines the required sampling mode (like Texture.NEAREST_SAMPLINGMODE)
     * @param compression defines the compressed used (can be null)
     * @param textureType defines the compressed used (can be null)
     * @returns a new raw 2D array texture (stored in an InternalTexture)
     */ createRawTexture2DArray(data, width, height, depth, format, generateMipMaps, invertY, samplingMode, compression = null, textureType = 0) {
        throw (0, $dUFYy._WarnImport)("Engine.RawTexture");
    }
    /**
     * @internal
     */ _unpackFlipY(value) {
        if (this._unpackFlipYCached !== value) {
            this._gl.pixelStorei(this._gl.UNPACK_FLIP_Y_WEBGL, value ? 1 : 0);
            if (this.enableUnpackFlipYCached) this._unpackFlipYCached = value;
        }
    }
    /** @internal */ _getUnpackAlignement() {
        return this._gl.getParameter(this._gl.UNPACK_ALIGNMENT);
    }
    _getTextureTarget(texture) {
        if (texture.isCube) return this._gl.TEXTURE_CUBE_MAP;
        else if (texture.is3D) return this._gl.TEXTURE_3D;
        else if (texture.is2DArray || texture.isMultiview) return this._gl.TEXTURE_2D_ARRAY;
        return this._gl.TEXTURE_2D;
    }
    /**
     * Update the sampling mode of a given texture
     * @param samplingMode defines the required sampling mode
     * @param texture defines the texture to update
     * @param generateMipMaps defines whether to generate mipmaps for the texture
     */ updateTextureSamplingMode(samplingMode, texture, generateMipMaps = false) {
        const target = this._getTextureTarget(texture);
        const filters = this._getSamplingParameters(samplingMode, texture.useMipMaps || generateMipMaps);
        this._setTextureParameterInteger(target, this._gl.TEXTURE_MAG_FILTER, filters.mag, texture);
        this._setTextureParameterInteger(target, this._gl.TEXTURE_MIN_FILTER, filters.min);
        if (generateMipMaps) {
            texture.generateMipMaps = true;
            this._gl.generateMipmap(target);
        }
        this._bindTextureDirectly(target, null);
        texture.samplingMode = samplingMode;
    }
    /**
     * Update the dimensions of a texture
     * @param texture texture to update
     * @param width new width of the texture
     * @param height new height of the texture
     * @param depth new depth of the texture
     */ updateTextureDimensions(texture, width, height, depth = 1) {}
    /**
     * Update the sampling mode of a given texture
     * @param texture defines the texture to update
     * @param wrapU defines the texture wrap mode of the u coordinates
     * @param wrapV defines the texture wrap mode of the v coordinates
     * @param wrapR defines the texture wrap mode of the r coordinates
     */ updateTextureWrappingMode(texture, wrapU, wrapV = null, wrapR = null) {
        const target = this._getTextureTarget(texture);
        if (wrapU !== null) {
            this._setTextureParameterInteger(target, this._gl.TEXTURE_WRAP_S, this._getTextureWrapMode(wrapU), texture);
            texture._cachedWrapU = wrapU;
        }
        if (wrapV !== null) {
            this._setTextureParameterInteger(target, this._gl.TEXTURE_WRAP_T, this._getTextureWrapMode(wrapV), texture);
            texture._cachedWrapV = wrapV;
        }
        if ((texture.is2DArray || texture.is3D) && wrapR !== null) {
            this._setTextureParameterInteger(target, this._gl.TEXTURE_WRAP_R, this._getTextureWrapMode(wrapR), texture);
            texture._cachedWrapR = wrapR;
        }
        this._bindTextureDirectly(target, null);
    }
    /**
     * @internal
     */ _setupDepthStencilTexture(internalTexture, size, generateStencil, bilinearFiltering, comparisonFunction, samples = 1) {
        const width = size.width || size;
        const height = size.height || size;
        const layers = size.layers || 0;
        internalTexture.baseWidth = width;
        internalTexture.baseHeight = height;
        internalTexture.width = width;
        internalTexture.height = height;
        internalTexture.is2DArray = layers > 0;
        internalTexture.depth = layers;
        internalTexture.isReady = true;
        internalTexture.samples = samples;
        internalTexture.generateMipMaps = false;
        internalTexture.samplingMode = bilinearFiltering ? 2 : 1;
        internalTexture.type = 0;
        internalTexture._comparisonFunction = comparisonFunction;
        const gl = this._gl;
        const target = this._getTextureTarget(internalTexture);
        const samplingParameters = this._getSamplingParameters(internalTexture.samplingMode, false);
        gl.texParameteri(target, gl.TEXTURE_MAG_FILTER, samplingParameters.mag);
        gl.texParameteri(target, gl.TEXTURE_MIN_FILTER, samplingParameters.min);
        gl.texParameteri(target, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(target, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        // TEXTURE_COMPARE_FUNC/MODE are only availble in WebGL2.
        if (this.webGLVersion > 1) {
            if (comparisonFunction === 0) {
                gl.texParameteri(target, gl.TEXTURE_COMPARE_FUNC, 515);
                gl.texParameteri(target, gl.TEXTURE_COMPARE_MODE, gl.NONE);
            } else {
                gl.texParameteri(target, gl.TEXTURE_COMPARE_FUNC, comparisonFunction);
                gl.texParameteri(target, gl.TEXTURE_COMPARE_MODE, gl.COMPARE_REF_TO_TEXTURE);
            }
        }
    }
    /**
     * @internal
     */ _uploadCompressedDataToTextureDirectly(texture, internalFormat, width, height, data, faceIndex = 0, lod = 0) {
        const gl = this._gl;
        let target = gl.TEXTURE_2D;
        if (texture.isCube) target = gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex;
        if (texture._useSRGBBuffer) switch(internalFormat){
            case 37492:
            case 36196:
                // Note, if using ETC1 and sRGB is requested, this will use ETC2 if available.
                if (this._caps.etc2) internalFormat = gl.COMPRESSED_SRGB8_ETC2;
                else texture._useSRGBBuffer = false;
                break;
            case 37496:
                if (this._caps.etc2) internalFormat = gl.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC;
                else texture._useSRGBBuffer = false;
                break;
            case 36492:
                internalFormat = gl.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT;
                break;
            case 37808:
                internalFormat = gl.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR;
                break;
            case 33776:
                if (this._caps.s3tc_srgb) internalFormat = gl.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                else // S3TC sRGB extension not supported
                texture._useSRGBBuffer = false;
                break;
            case 33777:
                if (this._caps.s3tc_srgb) internalFormat = gl.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                else // S3TC sRGB extension not supported
                texture._useSRGBBuffer = false;
                break;
            case 33779:
                if (this._caps.s3tc_srgb) internalFormat = gl.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                else // S3TC sRGB extension not supported
                texture._useSRGBBuffer = false;
                break;
            default:
                // We don't support a sRGB format corresponding to internalFormat, so revert to non sRGB format
                texture._useSRGBBuffer = false;
                break;
        }
        this._gl.compressedTexImage2D(target, lod, internalFormat, width, height, 0, data);
    }
    /**
     * @internal
     */ _uploadDataToTextureDirectly(texture, imageData, faceIndex = 0, lod = 0, babylonInternalFormat, useTextureWidthAndHeight = false) {
        const gl = this._gl;
        const textureType = this._getWebGLTextureType(texture.type);
        const format = this._getInternalFormat(texture.format);
        const internalFormat = babylonInternalFormat === undefined ? this._getRGBABufferInternalSizedFormat(texture.type, texture.format, texture._useSRGBBuffer) : this._getInternalFormat(babylonInternalFormat, texture._useSRGBBuffer);
        this._unpackFlipY(texture.invertY);
        let target = gl.TEXTURE_2D;
        if (texture.isCube) target = gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex;
        const lodMaxWidth = Math.round(Math.log(texture.width) * Math.LOG2E);
        const lodMaxHeight = Math.round(Math.log(texture.height) * Math.LOG2E);
        const width = useTextureWidthAndHeight ? texture.width : Math.pow(2, Math.max(lodMaxWidth - lod, 0));
        const height = useTextureWidthAndHeight ? texture.height : Math.pow(2, Math.max(lodMaxHeight - lod, 0));
        gl.texImage2D(target, lod, internalFormat, width, height, 0, format, textureType, imageData);
    }
    /**
     * Update a portion of an internal texture
     * @param texture defines the texture to update
     * @param imageData defines the data to store into the texture
     * @param xOffset defines the x coordinates of the update rectangle
     * @param yOffset defines the y coordinates of the update rectangle
     * @param width defines the width of the update rectangle
     * @param height defines the height of the update rectangle
     * @param faceIndex defines the face index if texture is a cube (0 by default)
     * @param lod defines the lod level to update (0 by default)
     * @param generateMipMaps defines whether to generate mipmaps or not
     */ updateTextureData(texture, imageData, xOffset, yOffset, width, height, faceIndex = 0, lod = 0, generateMipMaps = false) {
        const gl = this._gl;
        const textureType = this._getWebGLTextureType(texture.type);
        const format = this._getInternalFormat(texture.format);
        this._unpackFlipY(texture.invertY);
        let targetForBinding = gl.TEXTURE_2D;
        let target = gl.TEXTURE_2D;
        if (texture.isCube) {
            target = gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex;
            targetForBinding = gl.TEXTURE_CUBE_MAP;
        }
        this._bindTextureDirectly(targetForBinding, texture, true);
        gl.texSubImage2D(target, lod, xOffset, yOffset, width, height, format, textureType, imageData);
        if (generateMipMaps) this._gl.generateMipmap(target);
        this._bindTextureDirectly(targetForBinding, null);
    }
    /**
     * @internal
     */ _uploadArrayBufferViewToTexture(texture, imageData, faceIndex = 0, lod = 0) {
        const gl = this._gl;
        const bindTarget = texture.isCube ? gl.TEXTURE_CUBE_MAP : gl.TEXTURE_2D;
        this._bindTextureDirectly(bindTarget, texture, true);
        this._uploadDataToTextureDirectly(texture, imageData, faceIndex, lod);
        this._bindTextureDirectly(bindTarget, null, true);
    }
    _prepareWebGLTextureContinuation(texture, scene, noMipmap, isCompressed, samplingMode) {
        const gl = this._gl;
        if (!gl) return;
        const filters = this._getSamplingParameters(samplingMode, !noMipmap);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, filters.mag);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, filters.min);
        if (!noMipmap && !isCompressed) gl.generateMipmap(gl.TEXTURE_2D);
        this._bindTextureDirectly(gl.TEXTURE_2D, null);
        // this.resetTextureCache();
        if (scene) scene.removePendingData(texture);
        texture.onLoadedObservable.notifyObservers(texture);
        texture.onLoadedObservable.clear();
    }
    _prepareWebGLTexture(texture, extension, scene, img, invertY, noMipmap, isCompressed, processFunction, samplingMode = 3) {
        const maxTextureSize = this.getCaps().maxTextureSize;
        const potWidth = Math.min(maxTextureSize, this.needPOTTextures ? $1a819ede290e980a$export$bfb63ef0b91d03e9.GetExponentOfTwo(img.width, maxTextureSize) : img.width);
        const potHeight = Math.min(maxTextureSize, this.needPOTTextures ? $1a819ede290e980a$export$bfb63ef0b91d03e9.GetExponentOfTwo(img.height, maxTextureSize) : img.height);
        const gl = this._gl;
        if (!gl) return;
        if (!texture._hardwareTexture) {
            //  this.resetTextureCache();
            if (scene) scene.removePendingData(texture);
            return;
        }
        this._bindTextureDirectly(gl.TEXTURE_2D, texture, true);
        this._unpackFlipY(invertY === undefined ? true : invertY ? true : false);
        texture.baseWidth = img.width;
        texture.baseHeight = img.height;
        texture.width = potWidth;
        texture.height = potHeight;
        texture.isReady = true;
        texture.type = texture.type !== -1 ? texture.type : 0;
        texture.format = texture.format !== -1 ? texture.format : extension === ".jpg" && !texture._useSRGBBuffer ? 4 : 5;
        if (processFunction(potWidth, potHeight, img, extension, texture, ()=>{
            this._prepareWebGLTextureContinuation(texture, scene, noMipmap, isCompressed, samplingMode);
        })) // Returning as texture needs extra async steps
        return;
        this._prepareWebGLTextureContinuation(texture, scene, noMipmap, isCompressed, samplingMode);
    }
    /**
     * @internal
     */ _setupFramebufferDepthAttachments(generateStencilBuffer, generateDepthBuffer, width, height, samples = 1) {
        const gl = this._gl;
        // Create the depth/stencil buffer
        if (generateStencilBuffer && generateDepthBuffer) return this._createRenderBuffer(width, height, samples, gl.DEPTH_STENCIL, gl.DEPTH24_STENCIL8, gl.DEPTH_STENCIL_ATTACHMENT);
        if (generateDepthBuffer) {
            let depthFormat = gl.DEPTH_COMPONENT16;
            if (this._webGLVersion > 1) depthFormat = gl.DEPTH_COMPONENT32F;
            return this._createRenderBuffer(width, height, samples, depthFormat, depthFormat, gl.DEPTH_ATTACHMENT);
        }
        if (generateStencilBuffer) return this._createRenderBuffer(width, height, samples, gl.STENCIL_INDEX8, gl.STENCIL_INDEX8, gl.STENCIL_ATTACHMENT);
        return null;
    }
    /**
     * @internal
     */ _createRenderBuffer(width, height, samples, internalFormat, msInternalFormat, attachment, unbindBuffer = true) {
        const gl = this._gl;
        const renderBuffer = gl.createRenderbuffer();
        return this._updateRenderBuffer(renderBuffer, width, height, samples, internalFormat, msInternalFormat, attachment, unbindBuffer);
    }
    _updateRenderBuffer(renderBuffer, width, height, samples, internalFormat, msInternalFormat, attachment, unbindBuffer = true) {
        const gl = this._gl;
        gl.bindRenderbuffer(gl.RENDERBUFFER, renderBuffer);
        if (samples > 1 && gl.renderbufferStorageMultisample) gl.renderbufferStorageMultisample(gl.RENDERBUFFER, samples, msInternalFormat, width, height);
        else gl.renderbufferStorage(gl.RENDERBUFFER, internalFormat, width, height);
        gl.framebufferRenderbuffer(gl.FRAMEBUFFER, attachment, gl.RENDERBUFFER, renderBuffer);
        if (unbindBuffer) gl.bindRenderbuffer(gl.RENDERBUFFER, null);
        return renderBuffer;
    }
    /**
     * @internal
     */ _releaseTexture(texture) {
        this._deleteTexture(texture._hardwareTexture?.underlyingResource);
        // Unbind channels
        this.unbindAllTextures();
        const index = this._internalTexturesCache.indexOf(texture);
        if (index !== -1) this._internalTexturesCache.splice(index, 1);
        // Integrated fixed lod samplers.
        if (texture._lodTextureHigh) texture._lodTextureHigh.dispose();
        if (texture._lodTextureMid) texture._lodTextureMid.dispose();
        if (texture._lodTextureLow) texture._lodTextureLow.dispose();
        // Integrated irradiance map.
        if (texture._irradianceTexture) texture._irradianceTexture.dispose();
    }
    /**
     * @internal
     */ _releaseRenderTargetWrapper(rtWrapper) {
        const index = this._renderTargetWrapperCache.indexOf(rtWrapper);
        if (index !== -1) this._renderTargetWrapperCache.splice(index, 1);
    }
    _deleteTexture(texture) {
        if (texture) this._gl.deleteTexture(texture);
    }
    _setProgram(program) {
        if (this._currentProgram !== program) {
            this._gl.useProgram(program);
            this._currentProgram = program;
        }
    }
    /**
     * Binds an effect to the webGL context
     * @param effect defines the effect to bind
     */ bindSamplers(effect) {
        const webGLPipelineContext = effect.getPipelineContext();
        this._setProgram(webGLPipelineContext.program);
        const samplers = effect.getSamplers();
        for(let index = 0; index < samplers.length; index++){
            const uniform = effect.getUniform(samplers[index]);
            if (uniform) this._boundUniforms[index] = uniform;
        }
        this._currentEffect = null;
    }
    _activateCurrentTexture() {
        if (this._currentTextureChannel !== this._activeChannel) {
            this._gl.activeTexture(this._gl.TEXTURE0 + this._activeChannel);
            this._currentTextureChannel = this._activeChannel;
        }
    }
    /**
     * @internal
     */ _bindTextureDirectly(target, texture, forTextureDataUpdate = false, force = false) {
        let wasPreviouslyBound = false;
        const isTextureForRendering = texture && texture._associatedChannel > -1;
        if (forTextureDataUpdate && isTextureForRendering) this._activeChannel = texture._associatedChannel;
        const currentTextureBound = this._boundTexturesCache[this._activeChannel];
        if (currentTextureBound !== texture || force) {
            this._activateCurrentTexture();
            if (texture && texture.isMultiview) {
                //this._gl.bindTexture(target, texture ? texture._colorTextureArray : null);
                (0, $kVtWi.Logger).Error([
                    "_bindTextureDirectly called with a multiview texture!",
                    target,
                    texture
                ]);
                // eslint-disable-next-line no-throw-literal
                throw "_bindTextureDirectly called with a multiview texture!";
            } else this._gl.bindTexture(target, texture?._hardwareTexture?.underlyingResource ?? null);
            this._boundTexturesCache[this._activeChannel] = texture;
            if (texture) texture._associatedChannel = this._activeChannel;
        } else if (forTextureDataUpdate) {
            wasPreviouslyBound = true;
            this._activateCurrentTexture();
        }
        if (isTextureForRendering && !forTextureDataUpdate) this._bindSamplerUniformToChannel(texture._associatedChannel, this._activeChannel);
        return wasPreviouslyBound;
    }
    /**
     * @internal
     */ _bindTexture(channel, texture, name) {
        if (channel === undefined) return;
        if (texture) texture._associatedChannel = channel;
        this._activeChannel = channel;
        const target = texture ? this._getTextureTarget(texture) : this._gl.TEXTURE_2D;
        this._bindTextureDirectly(target, texture);
    }
    /**
     * Unbind all textures from the webGL context
     */ unbindAllTextures() {
        for(let channel = 0; channel < this._maxSimultaneousTextures; channel++){
            this._activeChannel = channel;
            this._bindTextureDirectly(this._gl.TEXTURE_2D, null);
            this._bindTextureDirectly(this._gl.TEXTURE_CUBE_MAP, null);
            if (this.webGLVersion > 1) {
                this._bindTextureDirectly(this._gl.TEXTURE_3D, null);
                this._bindTextureDirectly(this._gl.TEXTURE_2D_ARRAY, null);
            }
        }
    }
    /**
     * Sets a texture to the according uniform.
     * @param channel The texture channel
     * @param uniform The uniform to set
     * @param texture The texture to apply
     * @param name The name of the uniform in the effect
     */ setTexture(channel, uniform, texture, name) {
        if (channel === undefined) return;
        if (uniform) this._boundUniforms[channel] = uniform;
        this._setTexture(channel, texture);
    }
    _bindSamplerUniformToChannel(sourceSlot, destination) {
        const uniform = this._boundUniforms[sourceSlot];
        if (!uniform || uniform._currentState === destination) return;
        this._gl.uniform1i(uniform, destination);
        uniform._currentState = destination;
    }
    _getTextureWrapMode(mode) {
        switch(mode){
            case 1:
                return this._gl.REPEAT;
            case 0:
                return this._gl.CLAMP_TO_EDGE;
            case 2:
                return this._gl.MIRRORED_REPEAT;
        }
        return this._gl.REPEAT;
    }
    _setTexture(channel, texture, isPartOfTextureArray = false, depthStencilTexture = false, name = "") {
        // Not ready?
        if (!texture) {
            if (this._boundTexturesCache[channel] != null) {
                this._activeChannel = channel;
                this._bindTextureDirectly(this._gl.TEXTURE_2D, null);
                this._bindTextureDirectly(this._gl.TEXTURE_CUBE_MAP, null);
                if (this.webGLVersion > 1) {
                    this._bindTextureDirectly(this._gl.TEXTURE_3D, null);
                    this._bindTextureDirectly(this._gl.TEXTURE_2D_ARRAY, null);
                }
            }
            return false;
        }
        // Video
        if (texture.video) {
            this._activeChannel = channel;
            const videoInternalTexture = texture.getInternalTexture();
            if (videoInternalTexture) videoInternalTexture._associatedChannel = channel;
            texture.update();
        } else if (texture.delayLoadState === 4) {
            // Delay loading
            texture.delayLoad();
            return false;
        }
        let internalTexture;
        if (depthStencilTexture) internalTexture = texture.depthStencilTexture;
        else if (texture.isReady()) internalTexture = texture.getInternalTexture();
        else if (texture.isCube) internalTexture = this.emptyCubeTexture;
        else if (texture.is3D) internalTexture = this.emptyTexture3D;
        else if (texture.is2DArray) internalTexture = this.emptyTexture2DArray;
        else internalTexture = this.emptyTexture;
        if (!isPartOfTextureArray && internalTexture) internalTexture._associatedChannel = channel;
        let needToBind = true;
        if (this._boundTexturesCache[channel] === internalTexture) {
            if (!isPartOfTextureArray) this._bindSamplerUniformToChannel(internalTexture._associatedChannel, channel);
            needToBind = false;
        }
        this._activeChannel = channel;
        const target = this._getTextureTarget(internalTexture);
        if (needToBind) this._bindTextureDirectly(target, internalTexture, isPartOfTextureArray);
        if (internalTexture && !internalTexture.isMultiview) {
            // CUBIC_MODE and SKYBOX_MODE both require CLAMP_TO_EDGE.  All other modes use REPEAT.
            if (internalTexture.isCube && internalTexture._cachedCoordinatesMode !== texture.coordinatesMode) {
                internalTexture._cachedCoordinatesMode = texture.coordinatesMode;
                const textureWrapMode = texture.coordinatesMode !== 3 && texture.coordinatesMode !== 5 ? 1 : 0;
                texture.wrapU = textureWrapMode;
                texture.wrapV = textureWrapMode;
            }
            if (internalTexture._cachedWrapU !== texture.wrapU) {
                internalTexture._cachedWrapU = texture.wrapU;
                this._setTextureParameterInteger(target, this._gl.TEXTURE_WRAP_S, this._getTextureWrapMode(texture.wrapU), internalTexture);
            }
            if (internalTexture._cachedWrapV !== texture.wrapV) {
                internalTexture._cachedWrapV = texture.wrapV;
                this._setTextureParameterInteger(target, this._gl.TEXTURE_WRAP_T, this._getTextureWrapMode(texture.wrapV), internalTexture);
            }
            if (internalTexture.is3D && internalTexture._cachedWrapR !== texture.wrapR) {
                internalTexture._cachedWrapR = texture.wrapR;
                this._setTextureParameterInteger(target, this._gl.TEXTURE_WRAP_R, this._getTextureWrapMode(texture.wrapR), internalTexture);
            }
            this._setAnisotropicLevel(target, internalTexture, texture.anisotropicFilteringLevel);
        }
        return true;
    }
    /**
     * Sets an array of texture to the webGL context
     * @param channel defines the channel where the texture array must be set
     * @param uniform defines the associated uniform location
     * @param textures defines the array of textures to bind
     * @param name name of the channel
     */ setTextureArray(channel, uniform, textures, name) {
        if (channel === undefined || !uniform) return;
        if (!this._textureUnits || this._textureUnits.length !== textures.length) this._textureUnits = new Int32Array(textures.length);
        for(let i = 0; i < textures.length; i++){
            const texture = textures[i].getInternalTexture();
            if (texture) {
                this._textureUnits[i] = channel + i;
                texture._associatedChannel = channel + i;
            } else this._textureUnits[i] = -1;
        }
        this._gl.uniform1iv(uniform, this._textureUnits);
        for(let index = 0; index < textures.length; index++)this._setTexture(this._textureUnits[index], textures[index], true);
    }
    /**
     * @internal
     */ _setAnisotropicLevel(target, internalTexture, anisotropicFilteringLevel) {
        const anisotropicFilterExtension = this._caps.textureAnisotropicFilterExtension;
        if (internalTexture.samplingMode !== 11 && internalTexture.samplingMode !== 3 && internalTexture.samplingMode !== 2) anisotropicFilteringLevel = 1; // Forcing the anisotropic to 1 because else webgl will force filters to linear
        if (anisotropicFilterExtension && internalTexture._cachedAnisotropicFilteringLevel !== anisotropicFilteringLevel) {
            this._setTextureParameterFloat(target, anisotropicFilterExtension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(anisotropicFilteringLevel, this._caps.maxAnisotropy), internalTexture);
            internalTexture._cachedAnisotropicFilteringLevel = anisotropicFilteringLevel;
        }
    }
    _setTextureParameterFloat(target, parameter, value, texture) {
        this._bindTextureDirectly(target, texture, true, true);
        this._gl.texParameterf(target, parameter, value);
    }
    _setTextureParameterInteger(target, parameter, value, texture) {
        if (texture) this._bindTextureDirectly(target, texture, true, true);
        this._gl.texParameteri(target, parameter, value);
    }
    /**
     * Unbind all vertex attributes from the webGL context
     */ unbindAllAttributes() {
        if (this._mustWipeVertexAttributes) {
            this._mustWipeVertexAttributes = false;
            for(let i = 0; i < this._caps.maxVertexAttribs; i++)this.disableAttributeByIndex(i);
            return;
        }
        for(let i = 0, ul = this._vertexAttribArraysEnabled.length; i < ul; i++){
            if (i >= this._caps.maxVertexAttribs || !this._vertexAttribArraysEnabled[i]) continue;
            this.disableAttributeByIndex(i);
        }
    }
    /**
     * Force the engine to release all cached effects. This means that next effect compilation will have to be done completely even if a similar effect was already compiled
     */ releaseEffects() {
        for(const name in this._compiledEffects){
            const webGLPipelineContext = this._compiledEffects[name].getPipelineContext();
            this._deletePipelineContext(webGLPipelineContext);
        }
        this._compiledEffects = {};
    }
    /**
     * Dispose and release all associated resources
     */ dispose() {
        this._isDisposed = true;
        this.stopRenderLoop();
        // Clear observables
        if (this.onBeforeTextureInitObservable) this.onBeforeTextureInitObservable.clear();
        // Empty texture
        if (this._emptyTexture) {
            this._releaseTexture(this._emptyTexture);
            this._emptyTexture = null;
        }
        if (this._emptyCubeTexture) {
            this._releaseTexture(this._emptyCubeTexture);
            this._emptyCubeTexture = null;
        }
        if (this._dummyFramebuffer) this._gl.deleteFramebuffer(this._dummyFramebuffer);
        // Release effects
        this.releaseEffects();
        this.releaseComputeEffects?.();
        // Unbind
        this.unbindAllAttributes();
        this._boundUniforms = {};
        // Events
        if ((0, $jFz47.IsWindowObjectExist)()) {
            if (this._renderingCanvas) {
                if (!this._doNotHandleContextLost) {
                    this._renderingCanvas.removeEventListener("webglcontextlost", this._onContextLost);
                    this._renderingCanvas.removeEventListener("webglcontextrestored", this._onContextRestored);
                }
                window.removeEventListener("resize", this._checkForMobile);
            }
        }
        this._workingCanvas = null;
        this._workingContext = null;
        this._currentBufferPointers.length = 0;
        this._renderingCanvas = null;
        this._currentProgram = null;
        this._boundRenderFunction = null;
        (0, $lUDWq.Effect).ResetCache();
        // Abort active requests
        for (const request of this._activeRequests)request.abort();
        this.onDisposeObservable.notifyObservers(this);
        this.onDisposeObservable.clear();
        if (this._creationOptions.loseContextOnDispose) this._gl.getExtension("WEBGL_lose_context")?.loseContext();
    }
    /**
     * Attach a new callback raised when context lost event is fired
     * @param callback defines the callback to call
     */ attachContextLostEvent(callback) {
        if (this._renderingCanvas) this._renderingCanvas.addEventListener("webglcontextlost", callback, false);
    }
    /**
     * Attach a new callback raised when context restored event is fired
     * @param callback defines the callback to call
     */ attachContextRestoredEvent(callback) {
        if (this._renderingCanvas) this._renderingCanvas.addEventListener("webglcontextrestored", callback, false);
    }
    /**
     * Get the current error code of the webGL context
     * @returns the error code
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/getError
     */ getError() {
        return this._gl.getError();
    }
    _canRenderToFloatFramebuffer() {
        if (this._webGLVersion > 1) return this._caps.colorBufferFloat;
        return this._canRenderToFramebuffer(1);
    }
    _canRenderToHalfFloatFramebuffer() {
        if (this._webGLVersion > 1) return this._caps.colorBufferFloat;
        return this._canRenderToFramebuffer(2);
    }
    // Thank you : http://stackoverflow.com/questions/28827511/webgl-ios-render-to-floating-point-texture
    _canRenderToFramebuffer(type) {
        const gl = this._gl;
        //clear existing errors
        // eslint-disable-next-line no-empty
        while(gl.getError() !== gl.NO_ERROR);
        let successful = true;
        const texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.texImage2D(gl.TEXTURE_2D, 0, this._getRGBABufferInternalSizedFormat(type), 1, 1, 0, gl.RGBA, this._getWebGLTextureType(type), null);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        const fb = gl.createFramebuffer();
        gl.bindFramebuffer(gl.FRAMEBUFFER, fb);
        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
        const status = gl.checkFramebufferStatus(gl.FRAMEBUFFER);
        successful = successful && status === gl.FRAMEBUFFER_COMPLETE;
        successful = successful && gl.getError() === gl.NO_ERROR;
        //try render by clearing frame buffer's color buffer
        if (successful) {
            gl.clear(gl.COLOR_BUFFER_BIT);
            successful = successful && gl.getError() === gl.NO_ERROR;
        }
        //try reading from frame to ensure render occurs (just creating the FBO is not sufficient to determine if rendering is supported)
        if (successful) {
            //in practice it's sufficient to just read from the backbuffer rather than handle potentially issues reading from the texture
            gl.bindFramebuffer(gl.FRAMEBUFFER, null);
            const readFormat = gl.RGBA;
            const readType = gl.UNSIGNED_BYTE;
            const buffer = new Uint8Array(4);
            gl.readPixels(0, 0, 1, 1, readFormat, readType, buffer);
            successful = successful && gl.getError() === gl.NO_ERROR;
        }
        //clean up
        gl.deleteTexture(texture);
        gl.deleteFramebuffer(fb);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        //clear accumulated errors
        // eslint-disable-next-line no-empty
        while(!successful && gl.getError() !== gl.NO_ERROR);
        return successful;
    }
    /**
     * @internal
     */ _getWebGLTextureType(type) {
        if (this._webGLVersion === 1) {
            switch(type){
                case 1:
                    return this._gl.FLOAT;
                case 2:
                    return this._gl.HALF_FLOAT_OES;
                case 0:
                    return this._gl.UNSIGNED_BYTE;
                case 8:
                    return this._gl.UNSIGNED_SHORT_4_4_4_4;
                case 9:
                    return this._gl.UNSIGNED_SHORT_5_5_5_1;
                case 10:
                    return this._gl.UNSIGNED_SHORT_5_6_5;
            }
            return this._gl.UNSIGNED_BYTE;
        }
        switch(type){
            case 3:
                return this._gl.BYTE;
            case 0:
                return this._gl.UNSIGNED_BYTE;
            case 4:
                return this._gl.SHORT;
            case 5:
                return this._gl.UNSIGNED_SHORT;
            case 6:
                return this._gl.INT;
            case 7:
                return this._gl.UNSIGNED_INT;
            case 1:
                return this._gl.FLOAT;
            case 2:
                return this._gl.HALF_FLOAT;
            case 8:
                return this._gl.UNSIGNED_SHORT_4_4_4_4;
            case 9:
                return this._gl.UNSIGNED_SHORT_5_5_5_1;
            case 10:
                return this._gl.UNSIGNED_SHORT_5_6_5;
            case 11:
                return this._gl.UNSIGNED_INT_2_10_10_10_REV;
            case 12:
                return this._gl.UNSIGNED_INT_24_8;
            case 13:
                return this._gl.UNSIGNED_INT_10F_11F_11F_REV;
            case 14:
                return this._gl.UNSIGNED_INT_5_9_9_9_REV;
            case 15:
                return this._gl.FLOAT_32_UNSIGNED_INT_24_8_REV;
        }
        return this._gl.UNSIGNED_BYTE;
    }
    /**
     * @internal
     */ _getInternalFormat(format, useSRGBBuffer = false) {
        let internalFormat = useSRGBBuffer ? this._glSRGBExtensionValues.SRGB8_ALPHA8 : this._gl.RGBA;
        switch(format){
            case 0:
                internalFormat = this._gl.ALPHA;
                break;
            case 1:
                internalFormat = this._gl.LUMINANCE;
                break;
            case 2:
                internalFormat = this._gl.LUMINANCE_ALPHA;
                break;
            case 6:
                internalFormat = this._gl.RED;
                break;
            case 7:
                internalFormat = this._gl.RG;
                break;
            case 4:
                internalFormat = useSRGBBuffer ? this._glSRGBExtensionValues.SRGB : this._gl.RGB;
                break;
            case 5:
                internalFormat = useSRGBBuffer ? this._glSRGBExtensionValues.SRGB8_ALPHA8 : this._gl.RGBA;
                break;
        }
        if (this._webGLVersion > 1) switch(format){
            case 8:
                internalFormat = this._gl.RED_INTEGER;
                break;
            case 9:
                internalFormat = this._gl.RG_INTEGER;
                break;
            case 10:
                internalFormat = this._gl.RGB_INTEGER;
                break;
            case 11:
                internalFormat = this._gl.RGBA_INTEGER;
                break;
        }
        return internalFormat;
    }
    /**
     * @internal
     */ _getRGBABufferInternalSizedFormat(type, format, useSRGBBuffer = false) {
        if (this._webGLVersion === 1) {
            if (format !== undefined) switch(format){
                case 0:
                    return this._gl.ALPHA;
                case 1:
                    return this._gl.LUMINANCE;
                case 2:
                    return this._gl.LUMINANCE_ALPHA;
                case 4:
                    return useSRGBBuffer ? this._glSRGBExtensionValues.SRGB : this._gl.RGB;
            }
            return this._gl.RGBA;
        }
        switch(type){
            case 3:
                switch(format){
                    case 6:
                        return this._gl.R8_SNORM;
                    case 7:
                        return this._gl.RG8_SNORM;
                    case 4:
                        return this._gl.RGB8_SNORM;
                    case 8:
                        return this._gl.R8I;
                    case 9:
                        return this._gl.RG8I;
                    case 10:
                        return this._gl.RGB8I;
                    case 11:
                        return this._gl.RGBA8I;
                    default:
                        return this._gl.RGBA8_SNORM;
                }
            case 0:
                switch(format){
                    case 6:
                        return this._gl.R8;
                    case 7:
                        return this._gl.RG8;
                    case 4:
                        return useSRGBBuffer ? this._glSRGBExtensionValues.SRGB8 : this._gl.RGB8; // By default. Other possibilities are RGB565, SRGB8.
                    case 5:
                        return useSRGBBuffer ? this._glSRGBExtensionValues.SRGB8_ALPHA8 : this._gl.RGBA8; // By default. Other possibilities are RGB5_A1, RGBA4, SRGB8_ALPHA8.
                    case 8:
                        return this._gl.R8UI;
                    case 9:
                        return this._gl.RG8UI;
                    case 10:
                        return this._gl.RGB8UI;
                    case 11:
                        return this._gl.RGBA8UI;
                    case 0:
                        return this._gl.ALPHA;
                    case 1:
                        return this._gl.LUMINANCE;
                    case 2:
                        return this._gl.LUMINANCE_ALPHA;
                    default:
                        return this._gl.RGBA8;
                }
            case 4:
                switch(format){
                    case 8:
                        return this._gl.R16I;
                    case 9:
                        return this._gl.RG16I;
                    case 10:
                        return this._gl.RGB16I;
                    case 11:
                        return this._gl.RGBA16I;
                    default:
                        return this._gl.RGBA16I;
                }
            case 5:
                switch(format){
                    case 8:
                        return this._gl.R16UI;
                    case 9:
                        return this._gl.RG16UI;
                    case 10:
                        return this._gl.RGB16UI;
                    case 11:
                        return this._gl.RGBA16UI;
                    default:
                        return this._gl.RGBA16UI;
                }
            case 6:
                switch(format){
                    case 8:
                        return this._gl.R32I;
                    case 9:
                        return this._gl.RG32I;
                    case 10:
                        return this._gl.RGB32I;
                    case 11:
                        return this._gl.RGBA32I;
                    default:
                        return this._gl.RGBA32I;
                }
            case 7:
                switch(format){
                    case 8:
                        return this._gl.R32UI;
                    case 9:
                        return this._gl.RG32UI;
                    case 10:
                        return this._gl.RGB32UI;
                    case 11:
                        return this._gl.RGBA32UI;
                    default:
                        return this._gl.RGBA32UI;
                }
            case 1:
                switch(format){
                    case 6:
                        return this._gl.R32F; // By default. Other possibility is R16F.
                    case 7:
                        return this._gl.RG32F; // By default. Other possibility is RG16F.
                    case 4:
                        return this._gl.RGB32F; // By default. Other possibilities are RGB16F, R11F_G11F_B10F, RGB9_E5.
                    case 5:
                        return this._gl.RGBA32F; // By default. Other possibility is RGBA16F.
                    default:
                        return this._gl.RGBA32F;
                }
            case 2:
                switch(format){
                    case 6:
                        return this._gl.R16F;
                    case 7:
                        return this._gl.RG16F;
                    case 4:
                        return this._gl.RGB16F; // By default. Other possibilities are R11F_G11F_B10F, RGB9_E5.
                    case 5:
                        return this._gl.RGBA16F;
                    default:
                        return this._gl.RGBA16F;
                }
            case 10:
                return this._gl.RGB565;
            case 13:
                return this._gl.R11F_G11F_B10F;
            case 14:
                return this._gl.RGB9_E5;
            case 8:
                return this._gl.RGBA4;
            case 9:
                return this._gl.RGB5_A1;
            case 11:
                switch(format){
                    case 5:
                        return this._gl.RGB10_A2; // By default. Other possibility is RGB5_A1.
                    case 11:
                        return this._gl.RGB10_A2UI;
                    default:
                        return this._gl.RGB10_A2;
                }
        }
        return useSRGBBuffer ? this._glSRGBExtensionValues.SRGB8_ALPHA8 : this._gl.RGBA8;
    }
    /**
     * @internal
     */ _loadFile(url, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError) {
        const request = $1a819ede290e980a$export$bfb63ef0b91d03e9._FileToolsLoadFile(url, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError);
        this._activeRequests.push(request);
        request.onCompleteObservable.add((request)=>{
            this._activeRequests.splice(this._activeRequests.indexOf(request), 1);
        });
        return request;
    }
    /**
     * Loads a file from a url
     * @param url url to load
     * @param onSuccess callback called when the file successfully loads
     * @param onProgress callback called while file is loading (if the server supports this mode)
     * @param offlineProvider defines the offline provider for caching
     * @param useArrayBuffer defines a boolean indicating that date must be returned as ArrayBuffer
     * @param onError callback called when the file fails to load
     * @returns a file request object
     * @internal
     */ static _FileToolsLoadFile(url, onSuccess, onProgress, offlineProvider, useArrayBuffer, onError) {
        throw (0, $dUFYy._WarnImport)("FileTools");
    }
    /**
     * Reads pixels from the current frame buffer. Please note that this function can be slow
     * @param x defines the x coordinate of the rectangle where pixels must be read
     * @param y defines the y coordinate of the rectangle where pixels must be read
     * @param width defines the width of the rectangle where pixels must be read
     * @param height defines the height of the rectangle where pixels must be read
     * @param hasAlpha defines whether the output should have alpha or not (defaults to true)
     * @param flushRenderer true to flush the renderer from the pending commands before reading the pixels
     * @returns a ArrayBufferView promise (Uint8Array) containing RGBA colors
     */ readPixels(x, y, width, height, hasAlpha = true, flushRenderer = true) {
        const numChannels = hasAlpha ? 4 : 3;
        const format = hasAlpha ? this._gl.RGBA : this._gl.RGB;
        const data = new Uint8Array(height * width * numChannels);
        if (flushRenderer) this.flushFramebuffer();
        this._gl.readPixels(x, y, width, height, format, this._gl.UNSIGNED_BYTE, data);
        return Promise.resolve(data);
    }
    /**
     * Gets a Promise<boolean> indicating if the engine can be instantiated (ie. if a webGL context can be found)
     */ static get IsSupportedAsync() {
        return Promise.resolve(this.isSupported());
    }
    /**
     * Gets a boolean indicating if the engine can be instantiated (ie. if a webGL context can be found)
     */ static get IsSupported() {
        return this.isSupported(); // Backward compat
    }
    /**
     * Gets a boolean indicating if the engine can be instantiated (ie. if a webGL context can be found)
     * @returns true if the engine can be created
     * @ignorenaming
     */ // eslint-disable-next-line @typescript-eslint/naming-convention
    static isSupported() {
        if (this._HasMajorPerformanceCaveat !== null) return !this._HasMajorPerformanceCaveat; // We know it is performant so WebGL is supported
        if (this._IsSupported === null) try {
            const tempcanvas = this._CreateCanvas(1, 1);
            const gl = tempcanvas.getContext("webgl") || tempcanvas.getContext("experimental-webgl");
            this._IsSupported = gl != null && !!window.WebGLRenderingContext;
        } catch (e) {
            this._IsSupported = false;
        }
        return this._IsSupported;
    }
    /**
     * Gets a boolean indicating if the engine can be instantiated on a performant device (ie. if a webGL context can be found and it does not use a slow implementation)
     */ static get HasMajorPerformanceCaveat() {
        if (this._HasMajorPerformanceCaveat === null) try {
            const tempcanvas = this._CreateCanvas(1, 1);
            const gl = tempcanvas.getContext("webgl", {
                failIfMajorPerformanceCaveat: true
            }) || tempcanvas.getContext("experimental-webgl", {
                failIfMajorPerformanceCaveat: true
            });
            this._HasMajorPerformanceCaveat = !gl;
        } catch (e) {
            this._HasMajorPerformanceCaveat = false;
        }
        return this._HasMajorPerformanceCaveat;
    }
    /**
     * Find the next highest power of two.
     * @param x Number to start search from.
     * @returns Next highest power of two.
     */ static CeilingPOT(x) {
        x--;
        x |= x >> 1;
        x |= x >> 2;
        x |= x >> 4;
        x |= x >> 8;
        x |= x >> 16;
        x++;
        return x;
    }
    /**
     * Find the next lowest power of two.
     * @param x Number to start search from.
     * @returns Next lowest power of two.
     */ static FloorPOT(x) {
        x = x | x >> 1;
        x = x | x >> 2;
        x = x | x >> 4;
        x = x | x >> 8;
        x = x | x >> 16;
        return x - (x >> 1);
    }
    /**
     * Find the nearest power of two.
     * @param x Number to start search from.
     * @returns Next nearest power of two.
     */ static NearestPOT(x) {
        const c = $1a819ede290e980a$export$bfb63ef0b91d03e9.CeilingPOT(x);
        const f = $1a819ede290e980a$export$bfb63ef0b91d03e9.FloorPOT(x);
        return c - x > x - f ? f : c;
    }
    /**
     * Get the closest exponent of two
     * @param value defines the value to approximate
     * @param max defines the maximum value to return
     * @param mode defines how to define the closest value
     * @returns closest exponent of two of the given value
     */ static GetExponentOfTwo(value, max, mode = 2) {
        let pot;
        switch(mode){
            case 1:
                pot = $1a819ede290e980a$export$bfb63ef0b91d03e9.FloorPOT(value);
                break;
            case 2:
                pot = $1a819ede290e980a$export$bfb63ef0b91d03e9.NearestPOT(value);
                break;
            case 3:
            default:
                pot = $1a819ede290e980a$export$bfb63ef0b91d03e9.CeilingPOT(value);
                break;
        }
        return Math.min(pot, max);
    }
    /**
     * Queue a new function into the requested animation frame pool (ie. this function will be executed by the browser (or the javascript engine) for the next frame)
     * @param func - the function to be called
     * @param requester - the object that will request the next frame. Falls back to window.
     * @returns frame number
     */ static QueueNewFrame(func, requester) {
        // Note that there is kind of a typing issue here, as `setTimeout` might return something else than a number (NodeJs returns a NodeJS.Timeout object).
        // Also if the global `requestAnimationFrame`'s returnType is number, `requester.requestPostAnimationFrame` and `requester.requestAnimationFrame` types
        // are `any`.
        if (!(0, $jFz47.IsWindowObjectExist)()) {
            if (typeof requestAnimationFrame === "function") return requestAnimationFrame(func);
        } else {
            const { requestAnimationFrame: requestAnimationFrame1 } = requester || window;
            if (typeof requestAnimationFrame1 === "function") return requestAnimationFrame1(func);
        }
        // fallback to the global `setTimeout`.
        // In most cases (aka in the browser), `window` is the global object, so instead of calling `window.setTimeout` we could call the global `setTimeout`.
        return setTimeout(func, 16);
    }
    /**
     * Gets host document
     * @returns the host document object
     */ getHostDocument() {
        if (this._renderingCanvas && this._renderingCanvas.ownerDocument) return this._renderingCanvas.ownerDocument;
        return (0, $jFz47.IsDocumentAvailable)() ? document : null;
    }
}
$1a819ede290e980a$export$bfb63ef0b91d03e9._TempClearColorUint32 = new Uint32Array(4);
$1a819ede290e980a$export$bfb63ef0b91d03e9._TempClearColorInt32 = new Int32Array(4);
/** Use this array to turn off some WebGL2 features on known buggy browsers version */ $1a819ede290e980a$export$bfb63ef0b91d03e9.ExceptionList = [
    {
        key: "Chrome/63.0",
        capture: "63\\.0\\.3239\\.(\\d+)",
        captureConstraint: 108,
        targets: [
            "uniformBuffer"
        ]
    },
    {
        key: "Firefox/58",
        capture: null,
        captureConstraint: null,
        targets: [
            "uniformBuffer"
        ]
    },
    {
        key: "Firefox/59",
        capture: null,
        captureConstraint: null,
        targets: [
            "uniformBuffer"
        ]
    },
    {
        key: "Chrome/72.+?Mobile",
        capture: null,
        captureConstraint: null,
        targets: [
            "vao"
        ]
    },
    {
        key: "Chrome/73.+?Mobile",
        capture: null,
        captureConstraint: null,
        targets: [
            "vao"
        ]
    },
    {
        key: "Chrome/74.+?Mobile",
        capture: null,
        captureConstraint: null,
        targets: [
            "vao"
        ]
    },
    {
        key: "Mac OS.+Chrome/71",
        capture: null,
        captureConstraint: null,
        targets: [
            "vao"
        ]
    },
    {
        key: "Mac OS.+Chrome/72",
        capture: null,
        captureConstraint: null,
        targets: [
            "vao"
        ]
    },
    {
        key: "Mac OS.+Chrome",
        capture: null,
        captureConstraint: null,
        targets: [
            "uniformBuffer"
        ]
    },
    {
        key: "Chrome/12\\d\\..+?Mobile",
        capture: null,
        captureConstraint: null,
        targets: [
            "uniformBuffer"
        ]
    },
    // desktop osx safari 15.4
    {
        key: ".*AppleWebKit.*(15.4).*Safari",
        capture: null,
        captureConstraint: null,
        targets: [
            "antialias",
            "maxMSAASamples"
        ]
    },
    // mobile browsers using safari 15.4 on ios
    {
        key: ".*(15.4).*AppleWebKit.*Safari",
        capture: null,
        captureConstraint: null,
        targets: [
            "antialias",
            "maxMSAASamples"
        ]
    }
];
/** @internal */ $1a819ede290e980a$export$bfb63ef0b91d03e9._TextureLoaders = [];
// Updatable statics so stick with vars here
/**
 * Gets or sets the epsilon value used by collision engine
 */ $1a819ede290e980a$export$bfb63ef0b91d03e9.CollisionsEpsilon = 0.001;
// Statics
$1a819ede290e980a$export$bfb63ef0b91d03e9._IsSupported = null;
$1a819ede290e980a$export$bfb63ef0b91d03e9._HasMajorPerformanceCaveat = null;

});
parcelRegister("lUDWq", function(module, exports) {

$parcel$export(module.exports, "Effect", () => $ff3dcf72127134d1$export$a32b0b1c1ac59d04);

var $diGQf = parcelRequire("diGQf");

var $jFz47 = parcelRequire("jFz47");

var $kVtWi = parcelRequire("kVtWi");

var $kbQ0z = parcelRequire("kbQ0z");

var $68BIi = parcelRequire("68BIi");

var $8WI3I = parcelRequire("8WI3I");
class $ff3dcf72127134d1$export$a32b0b1c1ac59d04 {
    /**
     * Gets or sets the relative url used to load shaders if using the engine in non-minified mode
     */ static get ShadersRepository() {
        return (0, $68BIi.ShaderStore).ShadersRepository;
    }
    static set ShadersRepository(repo) {
        (0, $68BIi.ShaderStore).ShadersRepository = repo;
    }
    /**
     * Observable that will be called when effect is bound.
     */ get onBindObservable() {
        if (!this._onBindObservable) this._onBindObservable = new (0, $diGQf.Observable)();
        return this._onBindObservable;
    }
    /**
     * Gets the shader language type used to write vertex and fragment source code.
     */ get shaderLanguage() {
        return this._shaderLanguage;
    }
    /**
     * Instantiates an effect.
     * An effect can be used to create/manage/execute vertex and fragment shaders.
     * @param baseName Name of the effect.
     * @param attributesNamesOrOptions List of attribute names that will be passed to the shader or set of all options to create the effect.
     * @param uniformsNamesOrEngine List of uniform variable names that will be passed to the shader or the engine that will be used to render effect.
     * @param samplers List of sampler variables that will be passed to the shader.
     * @param engine Engine to be used to render the effect
     * @param defines Define statements to be added to the shader.
     * @param fallbacks Possible fallbacks for this effect to improve performance when needed.
     * @param onCompiled Callback that will be called when the shader is compiled.
     * @param onError Callback that will be called if an error occurs during shader compilation.
     * @param indexParameters Parameters to be used with Babylons include syntax to iterate over an array (eg. \{lights: 10\})
     * @param key Effect Key identifying uniquely compiled shader variants
     * @param shaderLanguage the language the shader is written in (default: GLSL)
     */ constructor(baseName, attributesNamesOrOptions, uniformsNamesOrEngine, samplers = null, engine, defines = null, fallbacks = null, onCompiled = null, onError = null, indexParameters, key = "", shaderLanguage = (0, $8WI3I.ShaderLanguage).GLSL){
        /**
         * Name of the effect.
         */ this.name = null;
        /**
         * String container all the define statements that should be set on the shader.
         */ this.defines = "";
        /**
         * Callback that will be called when the shader is compiled.
         */ this.onCompiled = null;
        /**
         * Callback that will be called if an error occurs during shader compilation.
         */ this.onError = null;
        /**
         * Callback that will be called when effect is bound.
         */ this.onBind = null;
        /**
         * Unique ID of the effect.
         */ this.uniqueId = 0;
        /**
         * Observable that will be called when the shader is compiled.
         * It is recommended to use executeWhenCompile() or to make sure that scene.isReady() is called to get this observable raised.
         */ this.onCompileObservable = new (0, $diGQf.Observable)();
        /**
         * Observable that will be called if an error occurs during shader compilation.
         */ this.onErrorObservable = new (0, $diGQf.Observable)();
        /** @internal */ this._onBindObservable = null;
        this._isDisposed = false;
        /** @internal */ this._bonesComputationForcedToCPU = false;
        /** @internal */ this._uniformBuffersNames = {};
        /** @internal */ this._multiTarget = false;
        this._samplers = {};
        this._isReady = false;
        this._compilationError = "";
        this._allFallbacksProcessed = false;
        this._uniforms = {};
        /**
         * Key for the effect.
         * @internal
         */ this._key = "";
        this._fallbacks = null;
        this._vertexSourceCodeOverride = "";
        this._fragmentSourceCodeOverride = "";
        this._transformFeedbackVaryings = null;
        /**
         * Compiled shader to webGL program.
         * @internal
         */ this._pipelineContext = null;
        /** @internal */ this._vertexSourceCode = "";
        /** @internal */ this._fragmentSourceCode = "";
        /** @internal */ this._vertexSourceCodeBeforeMigration = "";
        /** @internal */ this._fragmentSourceCodeBeforeMigration = "";
        /** @internal */ this._rawVertexSourceCode = "";
        /** @internal */ this._rawFragmentSourceCode = "";
        this._processCodeAfterIncludes = undefined;
        this._processFinalCode = null;
        this.name = baseName;
        this._key = key;
        if (attributesNamesOrOptions.attributes) {
            const options = attributesNamesOrOptions;
            this._engine = uniformsNamesOrEngine;
            this._attributesNames = options.attributes;
            this._uniformsNames = options.uniformsNames.concat(options.samplers);
            this._samplerList = options.samplers.slice();
            this.defines = options.defines;
            this.onError = options.onError;
            this.onCompiled = options.onCompiled;
            this._fallbacks = options.fallbacks;
            this._indexParameters = options.indexParameters;
            this._transformFeedbackVaryings = options.transformFeedbackVaryings || null;
            this._multiTarget = !!options.multiTarget;
            this._shaderLanguage = options.shaderLanguage ?? (0, $8WI3I.ShaderLanguage).GLSL;
            if (options.uniformBuffersNames) {
                this._uniformBuffersNamesList = options.uniformBuffersNames.slice();
                for(let i = 0; i < options.uniformBuffersNames.length; i++)this._uniformBuffersNames[options.uniformBuffersNames[i]] = i;
            }
            this._processFinalCode = options.processFinalCode ?? null;
            this._processCodeAfterIncludes = options.processCodeAfterIncludes ?? undefined;
        } else {
            this._engine = engine;
            this.defines = defines == null ? "" : defines;
            this._uniformsNames = uniformsNamesOrEngine.concat(samplers);
            this._samplerList = samplers ? samplers.slice() : [];
            this._attributesNames = attributesNamesOrOptions;
            this._uniformBuffersNamesList = [];
            this._shaderLanguage = shaderLanguage;
            this.onError = onError;
            this.onCompiled = onCompiled;
            this._indexParameters = indexParameters;
            this._fallbacks = fallbacks;
        }
        this._attributeLocationByName = {};
        this.uniqueId = $ff3dcf72127134d1$export$a32b0b1c1ac59d04._UniqueIdSeed++;
        this._processShaderCode();
    }
    /** @internal */ _processShaderCode(shaderProcessor = null, keepExistingPipelineContext = false) {
        let vertexSource;
        let fragmentSource;
        const baseName = this.name;
        const hostDocument = (0, $jFz47.IsWindowObjectExist)() ? this._engine.getHostDocument() : null;
        if (baseName.vertexSource) vertexSource = "source:" + baseName.vertexSource;
        else if (baseName.vertexElement) {
            vertexSource = hostDocument ? hostDocument.getElementById(baseName.vertexElement) : null;
            if (!vertexSource) vertexSource = baseName.vertexElement;
        } else vertexSource = baseName.vertex || baseName;
        if (baseName.fragmentSource) fragmentSource = "source:" + baseName.fragmentSource;
        else if (baseName.fragmentElement) {
            fragmentSource = hostDocument ? hostDocument.getElementById(baseName.fragmentElement) : null;
            if (!fragmentSource) fragmentSource = baseName.fragmentElement;
        } else fragmentSource = baseName.fragment || baseName;
        this._processingContext = this._engine._getShaderProcessingContext(this._shaderLanguage);
        let processorOptions = {
            defines: this.defines.split("\n"),
            indexParameters: this._indexParameters,
            isFragment: false,
            shouldUseHighPrecisionShader: this._engine._shouldUseHighPrecisionShader,
            processor: shaderProcessor ?? this._engine._getShaderProcessor(this._shaderLanguage),
            supportsUniformBuffers: this._engine.supportsUniformBuffers,
            shadersRepository: (0, $68BIi.ShaderStore).GetShadersRepository(this._shaderLanguage),
            includesShadersStore: (0, $68BIi.ShaderStore).GetIncludesShadersStore(this._shaderLanguage),
            version: (this._engine.version * 100).toString(),
            platformName: this._engine.shaderPlatformName,
            processingContext: this._processingContext,
            isNDCHalfZRange: this._engine.isNDCHalfZRange,
            useReverseDepthBuffer: this._engine.useReverseDepthBuffer,
            processCodeAfterIncludes: this._processCodeAfterIncludes
        };
        const shaderCodes = [
            undefined,
            undefined
        ];
        const shadersLoaded = ()=>{
            if (shaderCodes[0] && shaderCodes[1]) {
                processorOptions.isFragment = true;
                const [migratedVertexCode, fragmentCode] = shaderCodes;
                (0, $kbQ0z.ShaderProcessor).Process(fragmentCode, processorOptions, (migratedFragmentCode, codeBeforeMigration)=>{
                    this._fragmentSourceCodeBeforeMigration = codeBeforeMigration;
                    if (this._processFinalCode) migratedFragmentCode = this._processFinalCode("fragment", migratedFragmentCode);
                    const finalShaders = (0, $kbQ0z.ShaderProcessor).Finalize(migratedVertexCode, migratedFragmentCode, processorOptions);
                    processorOptions = null;
                    this._useFinalCode(finalShaders.vertexCode, finalShaders.fragmentCode, baseName, keepExistingPipelineContext);
                }, this._engine);
            }
        };
        this._loadShader(vertexSource, "Vertex", "", (vertexCode)=>{
            (0, $kbQ0z.ShaderProcessor).Initialize(processorOptions);
            (0, $kbQ0z.ShaderProcessor).Process(vertexCode, processorOptions, (migratedVertexCode, codeBeforeMigration)=>{
                this._rawVertexSourceCode = vertexCode;
                this._vertexSourceCodeBeforeMigration = codeBeforeMigration;
                if (this._processFinalCode) migratedVertexCode = this._processFinalCode("vertex", migratedVertexCode);
                shaderCodes[0] = migratedVertexCode;
                shadersLoaded();
            }, this._engine);
        });
        this._loadShader(fragmentSource, "Fragment", "Pixel", (fragmentCode)=>{
            this._rawFragmentSourceCode = fragmentCode;
            shaderCodes[1] = fragmentCode;
            shadersLoaded();
        });
    }
    _useFinalCode(migratedVertexCode, migratedFragmentCode, baseName, keepExistingPipelineContext = false) {
        if (baseName) {
            const vertex = baseName.vertexElement || baseName.vertex || baseName.spectorName || baseName;
            const fragment = baseName.fragmentElement || baseName.fragment || baseName.spectorName || baseName;
            this._vertexSourceCode = (this._shaderLanguage === (0, $8WI3I.ShaderLanguage).WGSL ? "//" : "") + "#define SHADER_NAME vertex:" + vertex + "\n" + migratedVertexCode;
            this._fragmentSourceCode = (this._shaderLanguage === (0, $8WI3I.ShaderLanguage).WGSL ? "//" : "") + "#define SHADER_NAME fragment:" + fragment + "\n" + migratedFragmentCode;
        } else {
            this._vertexSourceCode = migratedVertexCode;
            this._fragmentSourceCode = migratedFragmentCode;
        }
        this._prepareEffect(keepExistingPipelineContext);
    }
    /**
     * Unique key for this effect
     */ get key() {
        return this._key;
    }
    /**
     * If the effect has been compiled and prepared.
     * @returns if the effect is compiled and prepared.
     */ isReady() {
        try {
            return this._isReadyInternal();
        } catch  {
            return false;
        }
    }
    _isReadyInternal() {
        if (this._isReady) return true;
        if (this._pipelineContext) return this._pipelineContext.isReady;
        return false;
    }
    /**
     * The engine the effect was initialized with.
     * @returns the engine.
     */ getEngine() {
        return this._engine;
    }
    /**
     * The pipeline context for this effect
     * @returns the associated pipeline context
     */ getPipelineContext() {
        return this._pipelineContext;
    }
    /**
     * The set of names of attribute variables for the shader.
     * @returns An array of attribute names.
     */ getAttributesNames() {
        return this._attributesNames;
    }
    /**
     * Returns the attribute at the given index.
     * @param index The index of the attribute.
     * @returns The location of the attribute.
     */ getAttributeLocation(index) {
        return this._attributes[index];
    }
    /**
     * Returns the attribute based on the name of the variable.
     * @param name of the attribute to look up.
     * @returns the attribute location.
     */ getAttributeLocationByName(name) {
        return this._attributeLocationByName[name];
    }
    /**
     * The number of attributes.
     * @returns the number of attributes.
     */ getAttributesCount() {
        return this._attributes.length;
    }
    /**
     * Gets the index of a uniform variable.
     * @param uniformName of the uniform to look up.
     * @returns the index.
     */ getUniformIndex(uniformName) {
        return this._uniformsNames.indexOf(uniformName);
    }
    /**
     * Returns the attribute based on the name of the variable.
     * @param uniformName of the uniform to look up.
     * @returns the location of the uniform.
     */ getUniform(uniformName) {
        return this._uniforms[uniformName];
    }
    /**
     * Returns an array of sampler variable names
     * @returns The array of sampler variable names.
     */ getSamplers() {
        return this._samplerList;
    }
    /**
     * Returns an array of uniform variable names
     * @returns The array of uniform variable names.
     */ getUniformNames() {
        return this._uniformsNames;
    }
    /**
     * Returns an array of uniform buffer variable names
     * @returns The array of uniform buffer variable names.
     */ getUniformBuffersNames() {
        return this._uniformBuffersNamesList;
    }
    /**
     * Returns the index parameters used to create the effect
     * @returns The index parameters object
     */ getIndexParameters() {
        return this._indexParameters;
    }
    /**
     * The error from the last compilation.
     * @returns the error string.
     */ getCompilationError() {
        return this._compilationError;
    }
    /**
     * Gets a boolean indicating that all fallbacks were used during compilation
     * @returns true if all fallbacks were used
     */ allFallbacksProcessed() {
        return this._allFallbacksProcessed;
    }
    /**
     * Adds a callback to the onCompiled observable and call the callback immediately if already ready.
     * @param func The callback to be used.
     */ executeWhenCompiled(func) {
        if (this.isReady()) {
            func(this);
            return;
        }
        this.onCompileObservable.add((effect)=>{
            func(effect);
        });
        if (!this._pipelineContext || this._pipelineContext.isAsync) setTimeout(()=>{
            this._checkIsReady(null);
        }, 16);
    }
    _checkIsReady(previousPipelineContext) {
        try {
            if (this._isReadyInternal()) return;
        } catch (e) {
            this._processCompilationErrors(e, previousPipelineContext);
            return;
        }
        if (this._isDisposed) return;
        setTimeout(()=>{
            this._checkIsReady(previousPipelineContext);
        }, 16);
    }
    _loadShader(shader, key, optionalKey, callback) {
        if (typeof HTMLElement !== "undefined") // DOM element ?
        {
            if (shader instanceof HTMLElement) {
                const shaderCode = (0, $jFz47.GetDOMTextContent)(shader);
                callback(shaderCode);
                return;
            }
        }
        // Direct source ?
        if (shader.substr(0, 7) === "source:") {
            callback(shader.substr(7));
            return;
        }
        // Base64 encoded ?
        if (shader.substr(0, 7) === "base64:") {
            const shaderBinary = window.atob(shader.substr(7));
            callback(shaderBinary);
            return;
        }
        const shaderStore = (0, $68BIi.ShaderStore).GetShadersStore(this._shaderLanguage);
        // Is in local store ?
        if (shaderStore[shader + key + "Shader"]) {
            callback(shaderStore[shader + key + "Shader"]);
            return;
        }
        if (optionalKey && shaderStore[shader + optionalKey + "Shader"]) {
            callback(shaderStore[shader + optionalKey + "Shader"]);
            return;
        }
        let shaderUrl;
        if (shader[0] === "." || shader[0] === "/" || shader.indexOf("http") > -1) shaderUrl = shader;
        else shaderUrl = (0, $68BIi.ShaderStore).GetShadersRepository(this._shaderLanguage) + shader;
        // Vertex shader
        this._engine._loadFile(shaderUrl + "." + key.toLowerCase() + ".fx", callback);
    }
    /**
     * Gets the vertex shader source code of this effect
     * This is the final source code that will be compiled, after all the processing has been done (pre-processing applied, code injection/replacement, etc)
     */ get vertexSourceCode() {
        return this._vertexSourceCodeOverride && this._fragmentSourceCodeOverride ? this._vertexSourceCodeOverride : this._pipelineContext?._getVertexShaderCode() ?? this._vertexSourceCode;
    }
    /**
     * Gets the fragment shader source code of this effect
     * This is the final source code that will be compiled, after all the processing has been done (pre-processing applied, code injection/replacement, etc)
     */ get fragmentSourceCode() {
        return this._vertexSourceCodeOverride && this._fragmentSourceCodeOverride ? this._fragmentSourceCodeOverride : this._pipelineContext?._getFragmentShaderCode() ?? this._fragmentSourceCode;
    }
    /**
     * Gets the vertex shader source code before migration.
     * This is the source code after the include directives have been replaced by their contents but before the code is migrated, i.e. before ShaderProcess._ProcessShaderConversion is executed.
     * This method is, among other things, responsible for parsing #if/#define directives as well as converting GLES2 syntax to GLES3 (in the case of WebGL).
     */ get vertexSourceCodeBeforeMigration() {
        return this._vertexSourceCodeBeforeMigration;
    }
    /**
     * Gets the fragment shader source code before migration.
     * This is the source code after the include directives have been replaced by their contents but before the code is migrated, i.e. before ShaderProcess._ProcessShaderConversion is executed.
     * This method is, among other things, responsible for parsing #if/#define directives as well as converting GLES2 syntax to GLES3 (in the case of WebGL).
     */ get fragmentSourceCodeBeforeMigration() {
        return this._fragmentSourceCodeBeforeMigration;
    }
    /**
     * Gets the vertex shader source code before it has been modified by any processing
     */ get rawVertexSourceCode() {
        return this._rawVertexSourceCode;
    }
    /**
     * Gets the fragment shader source code before it has been modified by any processing
     */ get rawFragmentSourceCode() {
        return this._rawFragmentSourceCode;
    }
    /**
     * Recompiles the webGL program
     * @param vertexSourceCode The source code for the vertex shader.
     * @param fragmentSourceCode The source code for the fragment shader.
     * @param onCompiled Callback called when completed.
     * @param onError Callback called on error.
     * @internal
     */ _rebuildProgram(vertexSourceCode, fragmentSourceCode, onCompiled, onError) {
        this._isReady = false;
        this._vertexSourceCodeOverride = vertexSourceCode;
        this._fragmentSourceCodeOverride = fragmentSourceCode;
        this.onError = (effect, error)=>{
            if (onError) onError(error);
        };
        this.onCompiled = ()=>{
            const scenes = this.getEngine().scenes;
            if (scenes) for(let i = 0; i < scenes.length; i++)scenes[i].markAllMaterialsAsDirty(63);
            this._pipelineContext._handlesSpectorRebuildCallback?.(onCompiled);
        };
        this._fallbacks = null;
        this._prepareEffect();
    }
    /**
     * Prepares the effect
     * @internal
     */ _prepareEffect(keepExistingPipelineContext = false) {
        const attributesNames = this._attributesNames;
        const defines = this.defines;
        const previousPipelineContext = this._pipelineContext;
        this._isReady = false;
        try {
            const engine = this._engine;
            this._pipelineContext = (keepExistingPipelineContext ? previousPipelineContext : undefined) ?? engine.createPipelineContext(this._processingContext);
            this._pipelineContext._name = this._key.replace(/\r/g, "").replace(/\n/g, "|");
            const rebuildRebind = (vertexSourceCode, fragmentSourceCode, onCompiled, onError)=>this._rebuildProgram(vertexSourceCode, fragmentSourceCode, onCompiled, onError);
            if (this._vertexSourceCodeOverride && this._fragmentSourceCodeOverride) engine._preparePipelineContext(this._pipelineContext, this._vertexSourceCodeOverride, this._fragmentSourceCodeOverride, true, this._rawVertexSourceCode, this._rawFragmentSourceCode, rebuildRebind, null, this._transformFeedbackVaryings, this._key);
            else engine._preparePipelineContext(this._pipelineContext, this._vertexSourceCode, this._fragmentSourceCode, false, this._rawVertexSourceCode, this._rawFragmentSourceCode, rebuildRebind, defines, this._transformFeedbackVaryings, this._key);
            engine._executeWhenRenderingStateIsCompiled(this._pipelineContext, ()=>{
                this._attributes = [];
                this._pipelineContext._fillEffectInformation(this, this._uniformBuffersNames, this._uniformsNames, this._uniforms, this._samplerList, this._samplers, attributesNames, this._attributes);
                // Caches attribute locations.
                if (attributesNames) for(let i = 0; i < attributesNames.length; i++){
                    const name = attributesNames[i];
                    this._attributeLocationByName[name] = this._attributes[i];
                }
                engine.bindSamplers(this);
                this._compilationError = "";
                this._isReady = true;
                if (this.onCompiled) this.onCompiled(this);
                this.onCompileObservable.notifyObservers(this);
                this.onCompileObservable.clear();
                // Unbind mesh reference in fallbacks
                if (this._fallbacks) this._fallbacks.unBindMesh();
                if (previousPipelineContext && !keepExistingPipelineContext) this.getEngine()._deletePipelineContext(previousPipelineContext);
            });
            if (this._pipelineContext.isAsync) this._checkIsReady(previousPipelineContext);
        } catch (e) {
            this._processCompilationErrors(e, previousPipelineContext);
        }
    }
    _getShaderCodeAndErrorLine(code, error, isFragment) {
        const regexp = isFragment ? /FRAGMENT SHADER ERROR: 0:(\d+?):/ : /VERTEX SHADER ERROR: 0:(\d+?):/;
        let errorLine = null;
        if (error && code) {
            const res = error.match(regexp);
            if (res && res.length === 2) {
                const lineNumber = parseInt(res[1]);
                const lines = code.split("\n", -1);
                if (lines.length >= lineNumber) errorLine = `Offending line [${lineNumber}] in ${isFragment ? "fragment" : "vertex"} code: ${lines[lineNumber - 1]}`;
            }
        }
        return [
            code,
            errorLine
        ];
    }
    _processCompilationErrors(e, previousPipelineContext = null) {
        this._compilationError = e.message;
        const attributesNames = this._attributesNames;
        const fallbacks = this._fallbacks;
        // Let's go through fallbacks then
        (0, $kVtWi.Logger).Error("Unable to compile effect:");
        (0, $kVtWi.Logger).Error("Uniforms: " + this._uniformsNames.map(function(uniform) {
            return " " + uniform;
        }));
        (0, $kVtWi.Logger).Error("Attributes: " + attributesNames.map(function(attribute) {
            return " " + attribute;
        }));
        (0, $kVtWi.Logger).Error("Defines:\n" + this.defines);
        if ($ff3dcf72127134d1$export$a32b0b1c1ac59d04.LogShaderCodeOnCompilationError) {
            let lineErrorVertex = null, lineErrorFragment = null, code = null;
            if (this._pipelineContext?._getVertexShaderCode()) {
                [code, lineErrorVertex] = this._getShaderCodeAndErrorLine(this._pipelineContext._getVertexShaderCode(), this._compilationError, false);
                if (code) {
                    (0, $kVtWi.Logger).Error("Vertex code:");
                    (0, $kVtWi.Logger).Error(code);
                }
            }
            if (this._pipelineContext?._getFragmentShaderCode()) {
                [code, lineErrorFragment] = this._getShaderCodeAndErrorLine(this._pipelineContext?._getFragmentShaderCode(), this._compilationError, true);
                if (code) {
                    (0, $kVtWi.Logger).Error("Fragment code:");
                    (0, $kVtWi.Logger).Error(code);
                }
            }
            if (lineErrorVertex) (0, $kVtWi.Logger).Error(lineErrorVertex);
            if (lineErrorFragment) (0, $kVtWi.Logger).Error(lineErrorFragment);
        }
        (0, $kVtWi.Logger).Error("Error: " + this._compilationError);
        const notifyErrors = ()=>{
            if (this.onError) this.onError(this, this._compilationError);
            this.onErrorObservable.notifyObservers(this);
        };
        // In case a previous compilation was successful, we need to restore the previous pipeline context
        if (previousPipelineContext) {
            this._pipelineContext = previousPipelineContext;
            this._isReady = true;
            notifyErrors();
        }
        // Lets try to compile fallbacks as long as we have some.
        if (fallbacks) {
            this._pipelineContext = null;
            if (fallbacks.hasMoreFallbacks) {
                this._allFallbacksProcessed = false;
                (0, $kVtWi.Logger).Error("Trying next fallback.");
                this.defines = fallbacks.reduce(this.defines, this);
                this._prepareEffect();
            } else {
                // Sorry we did everything we can
                this._allFallbacksProcessed = true;
                notifyErrors();
                this.onErrorObservable.clear();
                // Unbind mesh reference in fallbacks
                if (this._fallbacks) this._fallbacks.unBindMesh();
            }
        } else {
            this._allFallbacksProcessed = true;
            // In case of error, without any prior successful compilation, let s notify observers
            if (!previousPipelineContext) notifyErrors();
        }
    }
    /**
     * Checks if the effect is supported. (Must be called after compilation)
     */ get isSupported() {
        return this._compilationError === "";
    }
    /**
     * Binds a texture to the engine to be used as output of the shader.
     * @param channel Name of the output variable.
     * @param texture Texture to bind.
     * @internal
     */ _bindTexture(channel, texture) {
        this._engine._bindTexture(this._samplers[channel], texture, channel);
    }
    /**
     * Sets a texture on the engine to be used in the shader.
     * @param channel Name of the sampler variable.
     * @param texture Texture to set.
     */ setTexture(channel, texture) {
        this._engine.setTexture(this._samplers[channel], this._uniforms[channel], texture, channel);
    }
    /**
     * Sets a depth stencil texture from a render target on the engine to be used in the shader.
     * @param channel Name of the sampler variable.
     * @param texture Texture to set.
     */ setDepthStencilTexture(channel, texture) {
        this._engine.setDepthStencilTexture(this._samplers[channel], this._uniforms[channel], texture, channel);
    }
    /**
     * Sets an array of textures on the engine to be used in the shader.
     * @param channel Name of the variable.
     * @param textures Textures to set.
     */ setTextureArray(channel, textures) {
        const exName = channel + "Ex";
        if (this._samplerList.indexOf(exName + "0") === -1) {
            const initialPos = this._samplerList.indexOf(channel);
            for(let index = 1; index < textures.length; index++){
                const currentExName = exName + (index - 1).toString();
                this._samplerList.splice(initialPos + index, 0, currentExName);
            }
            // Reset every channels
            let channelIndex = 0;
            for (const key of this._samplerList){
                this._samplers[key] = channelIndex;
                channelIndex += 1;
            }
        }
        this._engine.setTextureArray(this._samplers[channel], this._uniforms[channel], textures, channel);
    }
    /**
     * Sets a texture to be the input of the specified post process. (To use the output, pass in the next post process in the pipeline)
     * @param channel Name of the sampler variable.
     * @param postProcess Post process to get the input texture from.
     */ setTextureFromPostProcess(channel, postProcess) {
        this._engine.setTextureFromPostProcess(this._samplers[channel], postProcess, channel);
    }
    /**
     * (Warning! setTextureFromPostProcessOutput may be desired instead)
     * Sets the input texture of the passed in post process to be input of this effect. (To use the output of the passed in post process use setTextureFromPostProcessOutput)
     * @param channel Name of the sampler variable.
     * @param postProcess Post process to get the output texture from.
     */ setTextureFromPostProcessOutput(channel, postProcess) {
        this._engine.setTextureFromPostProcessOutput(this._samplers[channel], postProcess, channel);
    }
    /**
     * Binds a buffer to a uniform.
     * @param buffer Buffer to bind.
     * @param name Name of the uniform variable to bind to.
     */ bindUniformBuffer(buffer, name) {
        const bufferName = this._uniformBuffersNames[name];
        if (bufferName === undefined || $ff3dcf72127134d1$export$a32b0b1c1ac59d04._BaseCache[bufferName] === buffer && this._engine._features.useUBOBindingCache) return;
        $ff3dcf72127134d1$export$a32b0b1c1ac59d04._BaseCache[bufferName] = buffer;
        this._engine.bindUniformBufferBase(buffer, bufferName, name);
    }
    /**
     * Binds block to a uniform.
     * @param blockName Name of the block to bind.
     * @param index Index to bind.
     */ bindUniformBlock(blockName, index) {
        this._engine.bindUniformBlock(this._pipelineContext, blockName, index);
    }
    /**
     * Sets an integer value on a uniform variable.
     * @param uniformName Name of the variable.
     * @param value Value to be set.
     * @returns this effect.
     */ setInt(uniformName, value) {
        this._pipelineContext.setInt(uniformName, value);
        return this;
    }
    /**
     * Sets an int2 value on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First int in int2.
     * @param y Second int in int2.
     * @returns this effect.
     */ setInt2(uniformName, x, y) {
        this._pipelineContext.setInt2(uniformName, x, y);
        return this;
    }
    /**
     * Sets an int3 value on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First int in int3.
     * @param y Second int in int3.
     * @param z Third int in int3.
     * @returns this effect.
     */ setInt3(uniformName, x, y, z) {
        this._pipelineContext.setInt3(uniformName, x, y, z);
        return this;
    }
    /**
     * Sets an int4 value on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First int in int4.
     * @param y Second int in int4.
     * @param z Third int in int4.
     * @param w Fourth int in int4.
     * @returns this effect.
     */ setInt4(uniformName, x, y, z, w) {
        this._pipelineContext.setInt4(uniformName, x, y, z, w);
        return this;
    }
    /**
     * Sets an int array on a uniform variable.
     * @param uniformName Name of the variable.
     * @param array array to be set.
     * @returns this effect.
     */ setIntArray(uniformName, array) {
        this._pipelineContext.setIntArray(uniformName, array);
        return this;
    }
    /**
     * Sets an int array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     * @returns this effect.
     */ setIntArray2(uniformName, array) {
        this._pipelineContext.setIntArray2(uniformName, array);
        return this;
    }
    /**
     * Sets an int array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     * @returns this effect.
     */ setIntArray3(uniformName, array) {
        this._pipelineContext.setIntArray3(uniformName, array);
        return this;
    }
    /**
     * Sets an int array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     * @returns this effect.
     */ setIntArray4(uniformName, array) {
        this._pipelineContext.setIntArray4(uniformName, array);
        return this;
    }
    /**
     * Sets an unsigned integer value on a uniform variable.
     * @param uniformName Name of the variable.
     * @param value Value to be set.
     * @returns this effect.
     */ setUInt(uniformName, value) {
        this._pipelineContext.setUInt(uniformName, value);
        return this;
    }
    /**
     * Sets an unsigned int2 value on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First unsigned int in uint2.
     * @param y Second unsigned int in uint2.
     * @returns this effect.
     */ setUInt2(uniformName, x, y) {
        this._pipelineContext.setUInt2(uniformName, x, y);
        return this;
    }
    /**
     * Sets an unsigned int3 value on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First unsigned int in uint3.
     * @param y Second unsigned int in uint3.
     * @param z Third unsigned int in uint3.
     * @returns this effect.
     */ setUInt3(uniformName, x, y, z) {
        this._pipelineContext.setUInt3(uniformName, x, y, z);
        return this;
    }
    /**
     * Sets an unsigned int4 value on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First unsigned int in uint4.
     * @param y Second unsigned int in uint4.
     * @param z Third unsigned int in uint4.
     * @param w Fourth unsigned int in uint4.
     * @returns this effect.
     */ setUInt4(uniformName, x, y, z, w) {
        this._pipelineContext.setUInt4(uniformName, x, y, z, w);
        return this;
    }
    /**
     * Sets an unsigned int array on a uniform variable.
     * @param uniformName Name of the variable.
     * @param array array to be set.
     * @returns this effect.
     */ setUIntArray(uniformName, array) {
        this._pipelineContext.setUIntArray(uniformName, array);
        return this;
    }
    /**
     * Sets an unsigned int array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     * @returns this effect.
     */ setUIntArray2(uniformName, array) {
        this._pipelineContext.setUIntArray2(uniformName, array);
        return this;
    }
    /**
     * Sets an unsigned int array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     * @returns this effect.
     */ setUIntArray3(uniformName, array) {
        this._pipelineContext.setUIntArray3(uniformName, array);
        return this;
    }
    /**
     * Sets an unsigned int array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     * @returns this effect.
     */ setUIntArray4(uniformName, array) {
        this._pipelineContext.setUIntArray4(uniformName, array);
        return this;
    }
    /**
     * Sets an float array on a uniform variable.
     * @param uniformName Name of the variable.
     * @param array array to be set.
     * @returns this effect.
     */ setFloatArray(uniformName, array) {
        this._pipelineContext.setArray(uniformName, array);
        return this;
    }
    /**
     * Sets an float array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     * @returns this effect.
     */ setFloatArray2(uniformName, array) {
        this._pipelineContext.setArray2(uniformName, array);
        return this;
    }
    /**
     * Sets an float array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     * @returns this effect.
     */ setFloatArray3(uniformName, array) {
        this._pipelineContext.setArray3(uniformName, array);
        return this;
    }
    /**
     * Sets an float array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     * @returns this effect.
     */ setFloatArray4(uniformName, array) {
        this._pipelineContext.setArray4(uniformName, array);
        return this;
    }
    /**
     * Sets an array on a uniform variable.
     * @param uniformName Name of the variable.
     * @param array array to be set.
     * @returns this effect.
     */ setArray(uniformName, array) {
        this._pipelineContext.setArray(uniformName, array);
        return this;
    }
    /**
     * Sets an array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     * @returns this effect.
     */ setArray2(uniformName, array) {
        this._pipelineContext.setArray2(uniformName, array);
        return this;
    }
    /**
     * Sets an array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     * @returns this effect.
     */ setArray3(uniformName, array) {
        this._pipelineContext.setArray3(uniformName, array);
        return this;
    }
    /**
     * Sets an array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     * @returns this effect.
     */ setArray4(uniformName, array) {
        this._pipelineContext.setArray4(uniformName, array);
        return this;
    }
    /**
     * Sets matrices on a uniform variable.
     * @param uniformName Name of the variable.
     * @param matrices matrices to be set.
     * @returns this effect.
     */ setMatrices(uniformName, matrices) {
        this._pipelineContext.setMatrices(uniformName, matrices);
        return this;
    }
    /**
     * Sets matrix on a uniform variable.
     * @param uniformName Name of the variable.
     * @param matrix matrix to be set.
     * @returns this effect.
     */ setMatrix(uniformName, matrix) {
        this._pipelineContext.setMatrix(uniformName, matrix);
        return this;
    }
    /**
     * Sets a 3x3 matrix on a uniform variable. (Specified as [1,2,3,4,5,6,7,8,9] will result in [1,2,3][4,5,6][7,8,9] matrix)
     * @param uniformName Name of the variable.
     * @param matrix matrix to be set.
     * @returns this effect.
     */ setMatrix3x3(uniformName, matrix) {
        // the cast is ok because it is gl.uniformMatrix3fv() which is called at the end, and this function accepts Float32Array and Array<number>
        this._pipelineContext.setMatrix3x3(uniformName, matrix);
        return this;
    }
    /**
     * Sets a 2x2 matrix on a uniform variable. (Specified as [1,2,3,4] will result in [1,2][3,4] matrix)
     * @param uniformName Name of the variable.
     * @param matrix matrix to be set.
     * @returns this effect.
     */ setMatrix2x2(uniformName, matrix) {
        // the cast is ok because it is gl.uniformMatrix3fv() which is called at the end, and this function accepts Float32Array and Array<number>
        this._pipelineContext.setMatrix2x2(uniformName, matrix);
        return this;
    }
    /**
     * Sets a float on a uniform variable.
     * @param uniformName Name of the variable.
     * @param value value to be set.
     * @returns this effect.
     */ setFloat(uniformName, value) {
        this._pipelineContext.setFloat(uniformName, value);
        return this;
    }
    /**
     * Sets a boolean on a uniform variable.
     * @param uniformName Name of the variable.
     * @param bool value to be set.
     * @returns this effect.
     */ setBool(uniformName, bool) {
        this._pipelineContext.setInt(uniformName, bool ? 1 : 0);
        return this;
    }
    /**
     * Sets a Vector2 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param vector2 vector2 to be set.
     * @returns this effect.
     */ setVector2(uniformName, vector2) {
        this._pipelineContext.setVector2(uniformName, vector2);
        return this;
    }
    /**
     * Sets a float2 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First float in float2.
     * @param y Second float in float2.
     * @returns this effect.
     */ setFloat2(uniformName, x, y) {
        this._pipelineContext.setFloat2(uniformName, x, y);
        return this;
    }
    /**
     * Sets a Vector3 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param vector3 Value to be set.
     * @returns this effect.
     */ setVector3(uniformName, vector3) {
        this._pipelineContext.setVector3(uniformName, vector3);
        return this;
    }
    /**
     * Sets a float3 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First float in float3.
     * @param y Second float in float3.
     * @param z Third float in float3.
     * @returns this effect.
     */ setFloat3(uniformName, x, y, z) {
        this._pipelineContext.setFloat3(uniformName, x, y, z);
        return this;
    }
    /**
     * Sets a Vector4 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param vector4 Value to be set.
     * @returns this effect.
     */ setVector4(uniformName, vector4) {
        this._pipelineContext.setVector4(uniformName, vector4);
        return this;
    }
    /**
     * Sets a Quaternion on a uniform variable.
     * @param uniformName Name of the variable.
     * @param quaternion Value to be set.
     * @returns this effect.
     */ setQuaternion(uniformName, quaternion) {
        this._pipelineContext.setQuaternion(uniformName, quaternion);
        return this;
    }
    /**
     * Sets a float4 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First float in float4.
     * @param y Second float in float4.
     * @param z Third float in float4.
     * @param w Fourth float in float4.
     * @returns this effect.
     */ setFloat4(uniformName, x, y, z, w) {
        this._pipelineContext.setFloat4(uniformName, x, y, z, w);
        return this;
    }
    /**
     * Sets a Color3 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param color3 Value to be set.
     * @returns this effect.
     */ setColor3(uniformName, color3) {
        this._pipelineContext.setColor3(uniformName, color3);
        return this;
    }
    /**
     * Sets a Color4 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param color3 Value to be set.
     * @param alpha Alpha value to be set.
     * @returns this effect.
     */ setColor4(uniformName, color3, alpha) {
        this._pipelineContext.setColor4(uniformName, color3, alpha);
        return this;
    }
    /**
     * Sets a Color4 on a uniform variable
     * @param uniformName defines the name of the variable
     * @param color4 defines the value to be set
     * @returns this effect.
     */ setDirectColor4(uniformName, color4) {
        this._pipelineContext.setDirectColor4(uniformName, color4);
        return this;
    }
    /**
     * Release all associated resources.
     **/ dispose() {
        if (this._pipelineContext) this._pipelineContext.dispose();
        this._engine._releaseEffect(this);
        this._isDisposed = true;
    }
    /**
     * This function will add a new shader to the shader store
     * @param name the name of the shader
     * @param pixelShader optional pixel shader content
     * @param vertexShader optional vertex shader content
     * @param shaderLanguage the language the shader is written in (default: GLSL)
     */ static RegisterShader(name, pixelShader, vertexShader, shaderLanguage = (0, $8WI3I.ShaderLanguage).GLSL) {
        if (pixelShader) (0, $68BIi.ShaderStore).GetShadersStore(shaderLanguage)[`${name}PixelShader`] = pixelShader;
        if (vertexShader) (0, $68BIi.ShaderStore).GetShadersStore(shaderLanguage)[`${name}VertexShader`] = vertexShader;
    }
    /**
     * Resets the cache of effects.
     */ static ResetCache() {
        $ff3dcf72127134d1$export$a32b0b1c1ac59d04._BaseCache = {};
    }
}
/**
 * Enable logging of the shader code when a compilation error occurs
 */ $ff3dcf72127134d1$export$a32b0b1c1ac59d04.LogShaderCodeOnCompilationError = true;
$ff3dcf72127134d1$export$a32b0b1c1ac59d04._UniqueIdSeed = 0;
$ff3dcf72127134d1$export$a32b0b1c1ac59d04._BaseCache = {};
/**
 * Store of each shader (The can be looked up using effect.key)
 */ $ff3dcf72127134d1$export$a32b0b1c1ac59d04.ShadersStore = (0, $68BIi.ShaderStore).ShadersStore;
/**
 * Store of each included file for a shader (The can be looked up using effect.key)
 */ $ff3dcf72127134d1$export$a32b0b1c1ac59d04.IncludesShadersStore = (0, $68BIi.ShaderStore).IncludesShadersStore;

});
parcelRegister("68BIi", function(module, exports) {

$parcel$export(module.exports, "ShaderStore", () => $4780be8fe6bd1293$export$6ac25226e6db297b);

var $8WI3I = parcelRequire("8WI3I");
class $4780be8fe6bd1293$export$6ac25226e6db297b {
    /**
     * Gets the shaders repository path for a given shader language
     * @param shaderLanguage the shader language
     * @returns the path to the shaders repository
     */ static GetShadersRepository(shaderLanguage = (0, $8WI3I.ShaderLanguage).GLSL) {
        return shaderLanguage === (0, $8WI3I.ShaderLanguage).GLSL ? $4780be8fe6bd1293$export$6ac25226e6db297b.ShadersRepository : $4780be8fe6bd1293$export$6ac25226e6db297b.ShadersRepositoryWGSL;
    }
    /**
     * Gets the shaders store of a given shader language
     * @param shaderLanguage the shader language
     * @returns the shaders store
     */ static GetShadersStore(shaderLanguage = (0, $8WI3I.ShaderLanguage).GLSL) {
        return shaderLanguage === (0, $8WI3I.ShaderLanguage).GLSL ? $4780be8fe6bd1293$export$6ac25226e6db297b.ShadersStore : $4780be8fe6bd1293$export$6ac25226e6db297b.ShadersStoreWGSL;
    }
    /**
     * Gets the include shaders store of a given shader language
     * @param shaderLanguage the shader language
     * @returns the include shaders store
     */ static GetIncludesShadersStore(shaderLanguage = (0, $8WI3I.ShaderLanguage).GLSL) {
        return shaderLanguage === (0, $8WI3I.ShaderLanguage).GLSL ? $4780be8fe6bd1293$export$6ac25226e6db297b.IncludesShadersStore : $4780be8fe6bd1293$export$6ac25226e6db297b.IncludesShadersStoreWGSL;
    }
}
/**
 * Gets or sets the relative url used to load shaders if using the engine in non-minified mode
 */ $4780be8fe6bd1293$export$6ac25226e6db297b.ShadersRepository = "src/Shaders/";
/**
 * Store of each shader (The can be looked up using effect.key)
 */ $4780be8fe6bd1293$export$6ac25226e6db297b.ShadersStore = {};
/**
 * Store of each included file for a shader (The can be looked up using effect.key)
 */ $4780be8fe6bd1293$export$6ac25226e6db297b.IncludesShadersStore = {};
/**
 * Gets or sets the relative url used to load shaders (WGSL) if using the engine in non-minified mode
 */ $4780be8fe6bd1293$export$6ac25226e6db297b.ShadersRepositoryWGSL = "src/ShadersWGSL/";
/**
 * Store of each shader  (WGSL)
 */ $4780be8fe6bd1293$export$6ac25226e6db297b.ShadersStoreWGSL = {};
/**
 * Store of each included file for a shader (WGSL)
 */ $4780be8fe6bd1293$export$6ac25226e6db297b.IncludesShadersStoreWGSL = {};

});


parcelRegister("36XJ5", function(module, exports) {

$parcel$export(module.exports, "DepthCullingState", () => $2440430a59d4103a$export$59ff886bea753bad);
/**
 * @internal
 **/ class $2440430a59d4103a$export$59ff886bea753bad {
    /**
     * Initializes the state.
     * @param reset
     */ constructor(reset = true){
        this._isDepthTestDirty = false;
        this._isDepthMaskDirty = false;
        this._isDepthFuncDirty = false;
        this._isCullFaceDirty = false;
        this._isCullDirty = false;
        this._isZOffsetDirty = false;
        this._isFrontFaceDirty = false;
        if (reset) this.reset();
    }
    get isDirty() {
        return this._isDepthFuncDirty || this._isDepthTestDirty || this._isDepthMaskDirty || this._isCullFaceDirty || this._isCullDirty || this._isZOffsetDirty || this._isFrontFaceDirty;
    }
    get zOffset() {
        return this._zOffset;
    }
    set zOffset(value) {
        if (this._zOffset === value) return;
        this._zOffset = value;
        this._isZOffsetDirty = true;
    }
    get zOffsetUnits() {
        return this._zOffsetUnits;
    }
    set zOffsetUnits(value) {
        if (this._zOffsetUnits === value) return;
        this._zOffsetUnits = value;
        this._isZOffsetDirty = true;
    }
    get cullFace() {
        return this._cullFace;
    }
    set cullFace(value) {
        if (this._cullFace === value) return;
        this._cullFace = value;
        this._isCullFaceDirty = true;
    }
    get cull() {
        return this._cull;
    }
    set cull(value) {
        if (this._cull === value) return;
        this._cull = value;
        this._isCullDirty = true;
    }
    get depthFunc() {
        return this._depthFunc;
    }
    set depthFunc(value) {
        if (this._depthFunc === value) return;
        this._depthFunc = value;
        this._isDepthFuncDirty = true;
    }
    get depthMask() {
        return this._depthMask;
    }
    set depthMask(value) {
        if (this._depthMask === value) return;
        this._depthMask = value;
        this._isDepthMaskDirty = true;
    }
    get depthTest() {
        return this._depthTest;
    }
    set depthTest(value) {
        if (this._depthTest === value) return;
        this._depthTest = value;
        this._isDepthTestDirty = true;
    }
    get frontFace() {
        return this._frontFace;
    }
    set frontFace(value) {
        if (this._frontFace === value) return;
        this._frontFace = value;
        this._isFrontFaceDirty = true;
    }
    reset() {
        this._depthMask = true;
        this._depthTest = true;
        this._depthFunc = null;
        this._cullFace = null;
        this._cull = null;
        this._zOffset = 0;
        this._zOffsetUnits = 0;
        this._frontFace = null;
        this._isDepthTestDirty = true;
        this._isDepthMaskDirty = true;
        this._isDepthFuncDirty = false;
        this._isCullFaceDirty = false;
        this._isCullDirty = false;
        this._isZOffsetDirty = true;
        this._isFrontFaceDirty = false;
    }
    apply(gl) {
        if (!this.isDirty) return;
        // Cull
        if (this._isCullDirty) {
            if (this.cull) gl.enable(gl.CULL_FACE);
            else gl.disable(gl.CULL_FACE);
            this._isCullDirty = false;
        }
        // Cull face
        if (this._isCullFaceDirty) {
            gl.cullFace(this.cullFace);
            this._isCullFaceDirty = false;
        }
        // Depth mask
        if (this._isDepthMaskDirty) {
            gl.depthMask(this.depthMask);
            this._isDepthMaskDirty = false;
        }
        // Depth test
        if (this._isDepthTestDirty) {
            if (this.depthTest) gl.enable(gl.DEPTH_TEST);
            else gl.disable(gl.DEPTH_TEST);
            this._isDepthTestDirty = false;
        }
        // Depth func
        if (this._isDepthFuncDirty) {
            gl.depthFunc(this.depthFunc);
            this._isDepthFuncDirty = false;
        }
        // zOffset
        if (this._isZOffsetDirty) {
            if (this.zOffset || this.zOffsetUnits) {
                gl.enable(gl.POLYGON_OFFSET_FILL);
                gl.polygonOffset(this.zOffset, this.zOffsetUnits);
            } else gl.disable(gl.POLYGON_OFFSET_FILL);
            this._isZOffsetDirty = false;
        }
        // Front face
        if (this._isFrontFaceDirty) {
            gl.frontFace(this.frontFace);
            this._isFrontFaceDirty = false;
        }
    }
}

});

parcelRegister("d7F9z", function(module, exports) {

$parcel$export(module.exports, "StencilState", () => $98dbd9fe343661e2$export$6e15af2dccca9cb6);
/**
 * @internal
 **/ class $98dbd9fe343661e2$export$6e15af2dccca9cb6 {
    constructor(){
        this.reset();
    }
    reset() {
        this.enabled = false;
        this.mask = 0xff;
        this.func = $98dbd9fe343661e2$export$6e15af2dccca9cb6.ALWAYS;
        this.funcRef = 1;
        this.funcMask = 0xff;
        this.opStencilFail = $98dbd9fe343661e2$export$6e15af2dccca9cb6.KEEP;
        this.opDepthFail = $98dbd9fe343661e2$export$6e15af2dccca9cb6.KEEP;
        this.opStencilDepthPass = $98dbd9fe343661e2$export$6e15af2dccca9cb6.REPLACE;
    }
    get stencilFunc() {
        return this.func;
    }
    set stencilFunc(value) {
        this.func = value;
    }
    get stencilFuncRef() {
        return this.funcRef;
    }
    set stencilFuncRef(value) {
        this.funcRef = value;
    }
    get stencilFuncMask() {
        return this.funcMask;
    }
    set stencilFuncMask(value) {
        this.funcMask = value;
    }
    get stencilOpStencilFail() {
        return this.opStencilFail;
    }
    set stencilOpStencilFail(value) {
        this.opStencilFail = value;
    }
    get stencilOpDepthFail() {
        return this.opDepthFail;
    }
    set stencilOpDepthFail(value) {
        this.opDepthFail = value;
    }
    get stencilOpStencilDepthPass() {
        return this.opStencilDepthPass;
    }
    set stencilOpStencilDepthPass(value) {
        this.opStencilDepthPass = value;
    }
    get stencilMask() {
        return this.mask;
    }
    set stencilMask(value) {
        this.mask = value;
    }
    get stencilTest() {
        return this.enabled;
    }
    set stencilTest(value) {
        this.enabled = value;
    }
}
/** Passed to depthFunction or stencilFunction to specify depth or stencil tests will always pass. i.e. Pixels will be drawn in the order they are drawn */ $98dbd9fe343661e2$export$6e15af2dccca9cb6.ALWAYS = 519;
/** Passed to stencilOperation to specify that stencil value must be kept */ $98dbd9fe343661e2$export$6e15af2dccca9cb6.KEEP = 7680;
/** Passed to stencilOperation to specify that stencil value must be replaced */ $98dbd9fe343661e2$export$6e15af2dccca9cb6.REPLACE = 7681;

});

parcelRegister("ano9R", function(module, exports) {

$parcel$export(module.exports, "AlphaState", () => $78decaa178ba2683$export$366126238ef23200);
/**
 * @internal
 **/ class $78decaa178ba2683$export$366126238ef23200 {
    /**
     * Initializes the state.
     */ constructor(){
        this._blendFunctionParameters = new Array(4);
        this._blendEquationParameters = new Array(2);
        this._blendConstants = new Array(4);
        this._isBlendConstantsDirty = false;
        this._alphaBlend = false;
        this._isAlphaBlendDirty = false;
        this._isBlendFunctionParametersDirty = false;
        this._isBlendEquationParametersDirty = false;
        this.reset();
    }
    get isDirty() {
        return this._isAlphaBlendDirty || this._isBlendFunctionParametersDirty || this._isBlendEquationParametersDirty;
    }
    get alphaBlend() {
        return this._alphaBlend;
    }
    set alphaBlend(value) {
        if (this._alphaBlend === value) return;
        this._alphaBlend = value;
        this._isAlphaBlendDirty = true;
    }
    setAlphaBlendConstants(r, g, b, a) {
        if (this._blendConstants[0] === r && this._blendConstants[1] === g && this._blendConstants[2] === b && this._blendConstants[3] === a) return;
        this._blendConstants[0] = r;
        this._blendConstants[1] = g;
        this._blendConstants[2] = b;
        this._blendConstants[3] = a;
        this._isBlendConstantsDirty = true;
    }
    setAlphaBlendFunctionParameters(value0, value1, value2, value3) {
        if (this._blendFunctionParameters[0] === value0 && this._blendFunctionParameters[1] === value1 && this._blendFunctionParameters[2] === value2 && this._blendFunctionParameters[3] === value3) return;
        this._blendFunctionParameters[0] = value0;
        this._blendFunctionParameters[1] = value1;
        this._blendFunctionParameters[2] = value2;
        this._blendFunctionParameters[3] = value3;
        this._isBlendFunctionParametersDirty = true;
    }
    setAlphaEquationParameters(rgb, alpha) {
        if (this._blendEquationParameters[0] === rgb && this._blendEquationParameters[1] === alpha) return;
        this._blendEquationParameters[0] = rgb;
        this._blendEquationParameters[1] = alpha;
        this._isBlendEquationParametersDirty = true;
    }
    reset() {
        this._alphaBlend = false;
        this._blendFunctionParameters[0] = null;
        this._blendFunctionParameters[1] = null;
        this._blendFunctionParameters[2] = null;
        this._blendFunctionParameters[3] = null;
        this._blendEquationParameters[0] = null;
        this._blendEquationParameters[1] = null;
        this._blendConstants[0] = null;
        this._blendConstants[1] = null;
        this._blendConstants[2] = null;
        this._blendConstants[3] = null;
        this._isAlphaBlendDirty = true;
        this._isBlendFunctionParametersDirty = false;
        this._isBlendEquationParametersDirty = false;
        this._isBlendConstantsDirty = false;
    }
    apply(gl) {
        if (!this.isDirty) return;
        // Alpha blend
        if (this._isAlphaBlendDirty) {
            if (this._alphaBlend) gl.enable(gl.BLEND);
            else gl.disable(gl.BLEND);
            this._isAlphaBlendDirty = false;
        }
        // Alpha function
        if (this._isBlendFunctionParametersDirty) {
            gl.blendFuncSeparate(this._blendFunctionParameters[0], this._blendFunctionParameters[1], this._blendFunctionParameters[2], this._blendFunctionParameters[3]);
            this._isBlendFunctionParametersDirty = false;
        }
        // Alpha equation
        if (this._isBlendEquationParametersDirty) {
            gl.blendEquationSeparate(this._blendEquationParameters[0], this._blendEquationParameters[1]);
            this._isBlendEquationParametersDirty = false;
        }
        // Constants
        if (this._isBlendConstantsDirty) {
            gl.blendColor(this._blendConstants[0], this._blendConstants[1], this._blendConstants[2], this._blendConstants[3]);
            this._isBlendConstantsDirty = false;
        }
    }
}

});

parcelRegister("b9e4a", function(module, exports) {

$parcel$export(module.exports, "InternalTextureSource", () => $81db7240fd7885fc$export$63176c729abdb17f);
$parcel$export(module.exports, "InternalTexture", () => $81db7240fd7885fc$export$3ab99feff1488737);

var $diGQf = parcelRequire("diGQf");

var $bEkJJ = parcelRequire("bEkJJ");
var $81db7240fd7885fc$export$63176c729abdb17f;
(function(InternalTextureSource) {
    /**
     * The source of the texture data is unknown
     */ InternalTextureSource[InternalTextureSource["Unknown"] = 0] = "Unknown";
    /**
     * Texture data comes from an URL
     */ InternalTextureSource[InternalTextureSource["Url"] = 1] = "Url";
    /**
     * Texture data is only used for temporary storage
     */ InternalTextureSource[InternalTextureSource["Temp"] = 2] = "Temp";
    /**
     * Texture data comes from raw data (ArrayBuffer)
     */ InternalTextureSource[InternalTextureSource["Raw"] = 3] = "Raw";
    /**
     * Texture content is dynamic (video or dynamic texture)
     */ InternalTextureSource[InternalTextureSource["Dynamic"] = 4] = "Dynamic";
    /**
     * Texture content is generated by rendering to it
     */ InternalTextureSource[InternalTextureSource["RenderTarget"] = 5] = "RenderTarget";
    /**
     * Texture content is part of a multi render target process
     */ InternalTextureSource[InternalTextureSource["MultiRenderTarget"] = 6] = "MultiRenderTarget";
    /**
     * Texture data comes from a cube data file
     */ InternalTextureSource[InternalTextureSource["Cube"] = 7] = "Cube";
    /**
     * Texture data comes from a raw cube data
     */ InternalTextureSource[InternalTextureSource["CubeRaw"] = 8] = "CubeRaw";
    /**
     * Texture data come from a prefiltered cube data file
     */ InternalTextureSource[InternalTextureSource["CubePrefiltered"] = 9] = "CubePrefiltered";
    /**
     * Texture content is raw 3D data
     */ InternalTextureSource[InternalTextureSource["Raw3D"] = 10] = "Raw3D";
    /**
     * Texture content is raw 2D array data
     */ InternalTextureSource[InternalTextureSource["Raw2DArray"] = 11] = "Raw2DArray";
    /**
     * Texture content is a depth/stencil texture
     */ InternalTextureSource[InternalTextureSource["DepthStencil"] = 12] = "DepthStencil";
    /**
     * Texture data comes from a raw cube data encoded with RGBD
     */ InternalTextureSource[InternalTextureSource["CubeRawRGBD"] = 13] = "CubeRawRGBD";
    /**
     * Texture content is a depth texture
     */ InternalTextureSource[InternalTextureSource["Depth"] = 14] = "Depth";
})($81db7240fd7885fc$export$63176c729abdb17f || ($81db7240fd7885fc$export$63176c729abdb17f = {}));
class $81db7240fd7885fc$export$3ab99feff1488737 extends (0, $bEkJJ.TextureSampler) {
    /**
     * Gets a boolean indicating if the texture uses mipmaps
     * TODO implements useMipMaps as a separate setting from generateMipMaps
     */ get useMipMaps() {
        return this.generateMipMaps;
    }
    set useMipMaps(value) {
        this.generateMipMaps = value;
    }
    /** Gets the unique id of the internal texture */ get uniqueId() {
        return this._uniqueId;
    }
    /** @internal */ _setUniqueId(id) {
        this._uniqueId = id;
    }
    /**
     * Gets the Engine the texture belongs to.
     * @returns The babylon engine
     */ getEngine() {
        return this._engine;
    }
    /**
     * Gets the data source type of the texture
     */ get source() {
        return this._source;
    }
    /**
     * Creates a new InternalTexture
     * @param engine defines the engine to use
     * @param source defines the type of data that will be used
     * @param delayAllocation if the texture allocation should be delayed (default: false)
     */ constructor(engine, source, delayAllocation = false){
        super();
        /**
         * Defines if the texture is ready
         */ this.isReady = false;
        /**
         * Defines if the texture is a cube texture
         */ this.isCube = false;
        /**
         * Defines if the texture contains 3D data
         */ this.is3D = false;
        /**
         * Defines if the texture contains 2D array data
         */ this.is2DArray = false;
        /**
         * Defines if the texture contains multiview data
         */ this.isMultiview = false;
        /**
         * Gets the URL used to load this texture
         */ this.url = "";
        /**
         * Gets a boolean indicating if the texture needs mipmaps generation
         */ this.generateMipMaps = false;
        /**
         * Gets the number of samples used by the texture (WebGL2+ only)
         */ this.samples = 0;
        /**
         * Gets the type of the texture (int, float...)
         */ this.type = -1;
        /**
         * Gets the format of the texture (RGB, RGBA...)
         */ this.format = -1;
        /**
         * Observable called when the texture is loaded
         */ this.onLoadedObservable = new (0, $diGQf.Observable)();
        /**
         * Observable called when the texture load is raising an error
         */ this.onErrorObservable = new (0, $diGQf.Observable)();
        /**
         * If this callback is defined it will be called instead of the default _rebuild function
         */ this.onRebuildCallback = null;
        /**
         * Gets the width of the texture
         */ this.width = 0;
        /**
         * Gets the height of the texture
         */ this.height = 0;
        /**
         * Gets the depth of the texture
         */ this.depth = 0;
        /**
         * Gets the initial width of the texture (It could be rescaled if the current system does not support non power of two textures)
         */ this.baseWidth = 0;
        /**
         * Gets the initial height of the texture (It could be rescaled if the current system does not support non power of two textures)
         */ this.baseHeight = 0;
        /**
         * Gets the initial depth of the texture (It could be rescaled if the current system does not support non power of two textures)
         */ this.baseDepth = 0;
        /**
         * Gets a boolean indicating if the texture is inverted on Y axis
         */ this.invertY = false;
        // Private
        /** @internal */ this._invertVScale = false;
        /** @internal */ this._associatedChannel = -1;
        /** @internal */ this._source = $81db7240fd7885fc$export$63176c729abdb17f.Unknown;
        /** @internal */ this._buffer = null;
        /** @internal */ this._bufferView = null;
        /** @internal */ this._bufferViewArray = null;
        /** @internal */ this._bufferViewArrayArray = null;
        /** @internal */ this._size = 0;
        /** @internal */ this._extension = "";
        /** @internal */ this._files = null;
        /** @internal */ this._workingCanvas = null;
        /** @internal */ this._workingContext = null;
        /** @internal */ this._cachedCoordinatesMode = null;
        /** @internal */ this._isDisabled = false;
        /** @internal */ this._compression = null;
        /** @internal */ this._sphericalPolynomial = null;
        /** @internal */ this._sphericalPolynomialPromise = null;
        /** @internal */ this._sphericalPolynomialComputed = false;
        /** @internal */ this._lodGenerationScale = 0;
        /** @internal */ this._lodGenerationOffset = 0;
        /** @internal */ this._useSRGBBuffer = false;
        /** @internal */ this._creationFlags = 0;
        // The following three fields helps sharing generated fixed LODs for texture filtering
        // In environment not supporting the textureLOD extension like EDGE. They are for internal use only.
        // They are at the level of the gl texture to benefit from the cache.
        /** @internal */ this._lodTextureHigh = null;
        /** @internal */ this._lodTextureMid = null;
        /** @internal */ this._lodTextureLow = null;
        /** @internal */ this._isRGBD = false;
        /** @internal */ this._linearSpecularLOD = false;
        /** @internal */ this._irradianceTexture = null;
        /** @internal */ this._hardwareTexture = null;
        /** @internal */ this._maxLodLevel = null;
        /** @internal */ this._references = 1;
        /** @internal */ this._gammaSpace = null;
        /** @internal */ this._premulAlpha = false;
        /** @internal */ this._dynamicTextureSource = null;
        this._engine = engine;
        this._source = source;
        this._uniqueId = $81db7240fd7885fc$export$3ab99feff1488737._Counter++;
        if (!delayAllocation) this._hardwareTexture = engine._createHardwareTexture();
    }
    /**
     * Increments the number of references (ie. the number of Texture that point to it)
     */ incrementReferences() {
        this._references++;
    }
    /**
     * Change the size of the texture (not the size of the content)
     * @param width defines the new width
     * @param height defines the new height
     * @param depth defines the new depth (1 by default)
     */ updateSize(width, height, depth = 1) {
        this._engine.updateTextureDimensions(this, width, height, depth);
        this.width = width;
        this.height = height;
        this.depth = depth;
        this.baseWidth = width;
        this.baseHeight = height;
        this.baseDepth = depth;
        this._size = width * height * depth;
    }
    /** @internal */ _rebuild() {
        this.isReady = false;
        this._cachedCoordinatesMode = null;
        this._cachedWrapU = null;
        this._cachedWrapV = null;
        this._cachedWrapR = null;
        this._cachedAnisotropicFilteringLevel = null;
        if (this.onRebuildCallback) {
            const data = this.onRebuildCallback(this);
            const swapAndSetIsReady = (proxyInternalTexture)=>{
                proxyInternalTexture._swapAndDie(this, false);
                this.isReady = data.isReady;
            };
            if (data.isAsync) data.proxy.then(swapAndSetIsReady);
            else swapAndSetIsReady(data.proxy);
            return;
        }
        let proxy;
        switch(this.source){
            case $81db7240fd7885fc$export$63176c729abdb17f.Temp:
                break;
            case $81db7240fd7885fc$export$63176c729abdb17f.Url:
                proxy = this._engine.createTexture(this._originalUrl ?? this.url, !this.generateMipMaps, this.invertY, null, this.samplingMode, // Do not use Proxy here as it could be fully synchronous
                // and proxy would be undefined.
                (temp)=>{
                    temp._swapAndDie(this, false);
                    this.isReady = true;
                }, null, this._buffer, undefined, this.format, this._extension, undefined, undefined, undefined, this._useSRGBBuffer);
                return;
            case $81db7240fd7885fc$export$63176c729abdb17f.Raw:
                proxy = this._engine.createRawTexture(this._bufferView, this.baseWidth, this.baseHeight, this.format, this.generateMipMaps, this.invertY, this.samplingMode, this._compression, this.type, this._creationFlags, this._useSRGBBuffer);
                proxy._swapAndDie(this, false);
                this.isReady = true;
                break;
            case $81db7240fd7885fc$export$63176c729abdb17f.Raw3D:
                proxy = this._engine.createRawTexture3D(this._bufferView, this.baseWidth, this.baseHeight, this.baseDepth, this.format, this.generateMipMaps, this.invertY, this.samplingMode, this._compression, this.type);
                proxy._swapAndDie(this, false);
                this.isReady = true;
                break;
            case $81db7240fd7885fc$export$63176c729abdb17f.Raw2DArray:
                proxy = this._engine.createRawTexture2DArray(this._bufferView, this.baseWidth, this.baseHeight, this.baseDepth, this.format, this.generateMipMaps, this.invertY, this.samplingMode, this._compression, this.type);
                proxy._swapAndDie(this, false);
                this.isReady = true;
                break;
            case $81db7240fd7885fc$export$63176c729abdb17f.Dynamic:
                proxy = this._engine.createDynamicTexture(this.baseWidth, this.baseHeight, this.generateMipMaps, this.samplingMode);
                proxy._swapAndDie(this, false);
                if (this._dynamicTextureSource) this._engine.updateDynamicTexture(this, this._dynamicTextureSource, this.invertY, this._premulAlpha, this.format, true);
                break;
            case $81db7240fd7885fc$export$63176c729abdb17f.Cube:
                proxy = this._engine.createCubeTexture(this.url, null, this._files, !this.generateMipMaps, ()=>{
                    proxy._swapAndDie(this, false);
                    this.isReady = true;
                }, null, this.format, this._extension, false, 0, 0, null, undefined, this._useSRGBBuffer);
                return;
            case $81db7240fd7885fc$export$63176c729abdb17f.CubeRaw:
                proxy = this._engine.createRawCubeTexture(this._bufferViewArray, this.width, this._originalFormat ?? this.format, this.type, this.generateMipMaps, this.invertY, this.samplingMode, this._compression);
                proxy._swapAndDie(this, false);
                this.isReady = true;
                break;
            case $81db7240fd7885fc$export$63176c729abdb17f.CubeRawRGBD:
                // This case is being handeled by the environment texture tools and is not a part of the rebuild process.
                // To use CubeRawRGBD use updateRGBDAsync on the cube texture.
                return;
            case $81db7240fd7885fc$export$63176c729abdb17f.CubePrefiltered:
                proxy = this._engine.createPrefilteredCubeTexture(this.url, null, this._lodGenerationScale, this._lodGenerationOffset, (proxy)=>{
                    if (proxy) proxy._swapAndDie(this, false);
                    this.isReady = true;
                }, null, this.format, this._extension);
                proxy._sphericalPolynomial = this._sphericalPolynomial;
                return;
            case $81db7240fd7885fc$export$63176c729abdb17f.DepthStencil:
            case $81db7240fd7885fc$export$63176c729abdb17f.Depth:
                break;
        }
    }
    /**
     * @internal
     */ _swapAndDie(target, swapAll = true) {
        // TODO what about refcount on target?
        this._hardwareTexture?.setUsage(target._source, this.generateMipMaps, this.is2DArray, this.isCube, this.is3D, this.width, this.height, this.depth);
        target._hardwareTexture = this._hardwareTexture;
        if (swapAll) target._isRGBD = this._isRGBD;
        if (this._lodTextureHigh) {
            if (target._lodTextureHigh) target._lodTextureHigh.dispose();
            target._lodTextureHigh = this._lodTextureHigh;
        }
        if (this._lodTextureMid) {
            if (target._lodTextureMid) target._lodTextureMid.dispose();
            target._lodTextureMid = this._lodTextureMid;
        }
        if (this._lodTextureLow) {
            if (target._lodTextureLow) target._lodTextureLow.dispose();
            target._lodTextureLow = this._lodTextureLow;
        }
        if (this._irradianceTexture) {
            if (target._irradianceTexture) target._irradianceTexture.dispose();
            target._irradianceTexture = this._irradianceTexture;
        }
        const cache = this._engine.getLoadedTexturesCache();
        let index = cache.indexOf(this);
        if (index !== -1) cache.splice(index, 1);
        index = cache.indexOf(target);
        if (index === -1) cache.push(target);
    }
    /**
     * Dispose the current allocated resources
     */ dispose() {
        this._references--;
        this.onLoadedObservable.clear();
        this.onErrorObservable.clear();
        if (this._references === 0) {
            this._engine._releaseTexture(this);
            this._hardwareTexture = null;
            this._dynamicTextureSource = null;
        }
    }
}
/** @internal */ $81db7240fd7885fc$export$3ab99feff1488737._Counter = 0;

});
parcelRegister("bEkJJ", function(module, exports) {

$parcel$export(module.exports, "TextureSampler", () => $87b383f9bc05e018$export$ed302f356acc288d);
/**
 * Class used to store a texture sampler data
 */ class $87b383f9bc05e018$export$ed302f356acc288d {
    /**
     * | Value | Type               | Description |
     * | ----- | ------------------ | ----------- |
     * | 0     | CLAMP_ADDRESSMODE  |             |
     * | 1     | WRAP_ADDRESSMODE   |             |
     * | 2     | MIRROR_ADDRESSMODE |             |
     */ get wrapU() {
        return this._cachedWrapU;
    }
    set wrapU(value) {
        this._cachedWrapU = value;
    }
    /**
     * | Value | Type               | Description |
     * | ----- | ------------------ | ----------- |
     * | 0     | CLAMP_ADDRESSMODE  |             |
     * | 1     | WRAP_ADDRESSMODE   |             |
     * | 2     | MIRROR_ADDRESSMODE |             |
     */ get wrapV() {
        return this._cachedWrapV;
    }
    set wrapV(value) {
        this._cachedWrapV = value;
    }
    /**
     * | Value | Type               | Description |
     * | ----- | ------------------ | ----------- |
     * | 0     | CLAMP_ADDRESSMODE  |             |
     * | 1     | WRAP_ADDRESSMODE   |             |
     * | 2     | MIRROR_ADDRESSMODE |             |
     */ get wrapR() {
        return this._cachedWrapR;
    }
    set wrapR(value) {
        this._cachedWrapR = value;
    }
    /**
     * With compliant hardware and browser (supporting anisotropic filtering)
     * this defines the level of anisotropic filtering in the texture.
     * The higher the better but the slower.
     */ get anisotropicFilteringLevel() {
        return this._cachedAnisotropicFilteringLevel;
    }
    set anisotropicFilteringLevel(value) {
        this._cachedAnisotropicFilteringLevel = value;
    }
    /**
     * Gets or sets the comparison function (513, 514, etc). Set 0 to not use a comparison function
     */ get comparisonFunction() {
        return this._comparisonFunction;
    }
    set comparisonFunction(value) {
        this._comparisonFunction = value;
    }
    /**
     * Indicates to use the mip maps (if available on the texture).
     * Thanks to this flag, you can instruct the sampler to not sample the mipmaps even if they exist (and if the sampling mode is set to a value that normally samples the mipmaps!)
     */ get useMipMaps() {
        return this._useMipMaps;
    }
    set useMipMaps(value) {
        this._useMipMaps = value;
    }
    /**
     * Creates a Sampler instance
     */ constructor(){
        /**
         * Gets the sampling mode of the texture
         */ this.samplingMode = -1;
        this._useMipMaps = true;
        /** @internal */ this._cachedWrapU = null;
        /** @internal */ this._cachedWrapV = null;
        /** @internal */ this._cachedWrapR = null;
        /** @internal */ this._cachedAnisotropicFilteringLevel = null;
        /** @internal */ this._comparisonFunction = 0;
    }
    /**
     * Sets all the parameters of the sampler
     * @param wrapU u address mode (default: TEXTURE_WRAP_ADDRESSMODE)
     * @param wrapV v address mode (default: TEXTURE_WRAP_ADDRESSMODE)
     * @param wrapR r address mode (default: TEXTURE_WRAP_ADDRESSMODE)
     * @param anisotropicFilteringLevel anisotropic level (default: 1)
     * @param samplingMode sampling mode (default: 2)
     * @param comparisonFunction comparison function (default: 0 - no comparison function)
     * @returns the current sampler instance
     */ setParameters(wrapU = 1, wrapV = 1, wrapR = 1, anisotropicFilteringLevel = 1, samplingMode = 2, comparisonFunction = 0) {
        this._cachedWrapU = wrapU;
        this._cachedWrapV = wrapV;
        this._cachedWrapR = wrapR;
        this._cachedAnisotropicFilteringLevel = anisotropicFilteringLevel;
        this.samplingMode = samplingMode;
        this._comparisonFunction = comparisonFunction;
        return this;
    }
    /**
     * Compares this sampler with another one
     * @param other sampler to compare with
     * @returns true if the samplers have the same parametres, else false
     */ compareSampler(other) {
        return this._cachedWrapU === other._cachedWrapU && this._cachedWrapV === other._cachedWrapV && this._cachedWrapR === other._cachedWrapR && this._cachedAnisotropicFilteringLevel === other._cachedAnisotropicFilteringLevel && this.samplingMode === other.samplingMode && this._comparisonFunction === other._comparisonFunction && this._useMipMaps === other._useMipMaps;
    }
}

});


parcelRegister("6faFW", function(module, exports) {

$parcel$export(module.exports, "WebGLShaderProcessor", () => $48bc6cb5e3d77f22$export$9c673094c18050dc);

var $8WI3I = parcelRequire("8WI3I");
class $48bc6cb5e3d77f22$export$9c673094c18050dc {
    constructor(){
        this.shaderLanguage = (0, $8WI3I.ShaderLanguage).GLSL;
    }
    postProcessor(code, defines, isFragment, processingContext, engine) {
        // Remove extensions
        if (!engine.getCaps().drawBuffersExtension) {
            // even if enclosed in #if/#endif, IE11 does parse the #extension declaration, so we need to remove it altogether
            const regex = /#extension.+GL_EXT_draw_buffers.+(enable|require)/g;
            code = code.replace(regex, "");
        }
        return code;
    }
}

});

parcelRegister("i1R6L", function(module, exports) {

$parcel$export(module.exports, "WebGL2ShaderProcessor", () => $d20184274f12e3c3$export$93e16198e561ead1);

var $8WI3I = parcelRequire("8WI3I");
const $d20184274f12e3c3$var$varyingRegex = /(flat\s)?\s*varying\s*.*/;
class $d20184274f12e3c3$export$93e16198e561ead1 {
    constructor(){
        this.shaderLanguage = (0, $8WI3I.ShaderLanguage).GLSL;
    }
    attributeProcessor(attribute) {
        return attribute.replace("attribute", "in");
    }
    varyingCheck(varying, _isFragment) {
        return $d20184274f12e3c3$var$varyingRegex.test(varying);
    }
    varyingProcessor(varying, isFragment) {
        return varying.replace("varying", isFragment ? "in" : "out");
    }
    postProcessor(code, defines, isFragment) {
        const hasDrawBuffersExtension = code.search(/#extension.+GL_EXT_draw_buffers.+require/) !== -1;
        // Remove extensions
        const regex = /#extension.+(GL_OVR_multiview2|GL_OES_standard_derivatives|GL_EXT_shader_texture_lod|GL_EXT_frag_depth|GL_EXT_draw_buffers).+(enable|require)/g;
        code = code.replace(regex, "");
        // Replace instructions
        code = code.replace(/texture2D\s*\(/g, "texture(");
        if (isFragment) {
            const hasOutput = code.search(/layout *\(location *= *0\) *out/g) !== -1;
            code = code.replace(/texture2DLodEXT\s*\(/g, "textureLod(");
            code = code.replace(/textureCubeLodEXT\s*\(/g, "textureLod(");
            code = code.replace(/textureCube\s*\(/g, "texture(");
            code = code.replace(/gl_FragDepthEXT/g, "gl_FragDepth");
            code = code.replace(/gl_FragColor/g, "glFragColor");
            code = code.replace(/gl_FragData/g, "glFragData");
            code = code.replace(/void\s+?main\s*\(/g, (hasDrawBuffersExtension || hasOutput ? "" : "layout(location = 0) out vec4 glFragColor;\n") + "void main(");
        } else {
            const hasMultiviewExtension = defines.indexOf("#define MULTIVIEW") !== -1;
            if (hasMultiviewExtension) return "#extension GL_OVR_multiview2 : require\nlayout (num_views = 2) in;\n" + code;
        }
        return code;
    }
}

});

parcelRegister("koExS", function(module, exports) {

$parcel$export(module.exports, "WebGLDataBuffer", () => $ed958008223f690e$export$cb9a70451d0ac6d8);

var $6zPKs = parcelRequire("6zPKs");
class $ed958008223f690e$export$cb9a70451d0ac6d8 extends (0, $6zPKs.DataBuffer) {
    constructor(resource){
        super();
        this._buffer = resource;
    }
    get underlyingResource() {
        return this._buffer;
    }
}

});
parcelRegister("6zPKs", function(module, exports) {

$parcel$export(module.exports, "DataBuffer", () => $4c9e271f5881ce58$export$e21b1680ace449b);
/**
 * Class used to store gfx data (like WebGLBuffer)
 */ class $4c9e271f5881ce58$export$e21b1680ace449b {
    /**
     * Gets the underlying buffer
     */ get underlyingResource() {
        return null;
    }
    /**
     * Constructs the buffer
     */ constructor(){
        /**
         * Gets or sets the number of objects referencing this buffer
         */ this.references = 0;
        /** Gets or sets the size of the underlying buffer */ this.capacity = 0;
        /**
         * Gets or sets a boolean indicating if the buffer contains 32bits indices
         */ this.is32Bits = false;
        this.uniqueId = $4c9e271f5881ce58$export$e21b1680ace449b._Counter++;
    }
}
$4c9e271f5881ce58$export$e21b1680ace449b._Counter = 0;

});


parcelRegister("d6QZE", function(module, exports) {

$parcel$export(module.exports, "WebGLPipelineContext", () => $98b4f146d346ac54$export$857e3c69c4543d13);
/** @internal */ class $98b4f146d346ac54$export$857e3c69c4543d13 {
    constructor(){
        this._valueCache = {};
        this.vertexCompilationError = null;
        this.fragmentCompilationError = null;
        this.programLinkError = null;
        this.programValidationError = null;
        /** @internal */ this._isDisposed = false;
    }
    get isAsync() {
        return this.isParallelCompiled;
    }
    get isReady() {
        if (this.program) {
            if (this.isParallelCompiled) return this.engine._isRenderingStateCompiled(this);
            return true;
        }
        return false;
    }
    _handlesSpectorRebuildCallback(onCompiled) {
        if (onCompiled && this.program) onCompiled(this.program);
    }
    _fillEffectInformation(effect, uniformBuffersNames, uniformsNames, uniforms, samplerList, samplers, attributesNames, attributes) {
        const engine = this.engine;
        if (engine.supportsUniformBuffers) for(const name in uniformBuffersNames)effect.bindUniformBlock(name, uniformBuffersNames[name]);
        const effectAvailableUniforms = this.engine.getUniforms(this, uniformsNames);
        effectAvailableUniforms.forEach((uniform, index)=>{
            uniforms[uniformsNames[index]] = uniform;
        });
        this._uniforms = uniforms;
        let index;
        for(index = 0; index < samplerList.length; index++){
            const sampler = effect.getUniform(samplerList[index]);
            if (sampler == null) {
                samplerList.splice(index, 1);
                index--;
            }
        }
        samplerList.forEach((name, index)=>{
            samplers[name] = index;
        });
        for (const attr of engine.getAttributes(this, attributesNames))attributes.push(attr);
    }
    /**
     * Release all associated resources.
     **/ dispose() {
        this._uniforms = {};
        this._isDisposed = true;
    }
    /**
     * @internal
     */ _cacheMatrix(uniformName, matrix) {
        const cache = this._valueCache[uniformName];
        const flag = matrix.updateFlag;
        if (cache !== undefined && cache === flag) return false;
        this._valueCache[uniformName] = flag;
        return true;
    }
    /**
     * @internal
     */ _cacheFloat2(uniformName, x, y) {
        let cache = this._valueCache[uniformName];
        if (!cache || cache.length !== 2) {
            cache = [
                x,
                y
            ];
            this._valueCache[uniformName] = cache;
            return true;
        }
        let changed = false;
        if (cache[0] !== x) {
            cache[0] = x;
            changed = true;
        }
        if (cache[1] !== y) {
            cache[1] = y;
            changed = true;
        }
        return changed;
    }
    /**
     * @internal
     */ _cacheFloat3(uniformName, x, y, z) {
        let cache = this._valueCache[uniformName];
        if (!cache || cache.length !== 3) {
            cache = [
                x,
                y,
                z
            ];
            this._valueCache[uniformName] = cache;
            return true;
        }
        let changed = false;
        if (cache[0] !== x) {
            cache[0] = x;
            changed = true;
        }
        if (cache[1] !== y) {
            cache[1] = y;
            changed = true;
        }
        if (cache[2] !== z) {
            cache[2] = z;
            changed = true;
        }
        return changed;
    }
    /**
     * @internal
     */ _cacheFloat4(uniformName, x, y, z, w) {
        let cache = this._valueCache[uniformName];
        if (!cache || cache.length !== 4) {
            cache = [
                x,
                y,
                z,
                w
            ];
            this._valueCache[uniformName] = cache;
            return true;
        }
        let changed = false;
        if (cache[0] !== x) {
            cache[0] = x;
            changed = true;
        }
        if (cache[1] !== y) {
            cache[1] = y;
            changed = true;
        }
        if (cache[2] !== z) {
            cache[2] = z;
            changed = true;
        }
        if (cache[3] !== w) {
            cache[3] = w;
            changed = true;
        }
        return changed;
    }
    /**
     * Sets an integer value on a uniform variable.
     * @param uniformName Name of the variable.
     * @param value Value to be set.
     */ setInt(uniformName, value) {
        const cache = this._valueCache[uniformName];
        if (cache !== undefined && cache === value) return;
        if (this.engine.setInt(this._uniforms[uniformName], value)) this._valueCache[uniformName] = value;
    }
    /**
     * Sets a int2 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First int in int2.
     * @param y Second int in int2.
     */ setInt2(uniformName, x, y) {
        if (this._cacheFloat2(uniformName, x, y)) {
            if (!this.engine.setInt2(this._uniforms[uniformName], x, y)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a int3 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First int in int3.
     * @param y Second int in int3.
     * @param z Third int in int3.
     */ setInt3(uniformName, x, y, z) {
        if (this._cacheFloat3(uniformName, x, y, z)) {
            if (!this.engine.setInt3(this._uniforms[uniformName], x, y, z)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a int4 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First int in int4.
     * @param y Second int in int4.
     * @param z Third int in int4.
     * @param w Fourth int in int4.
     */ setInt4(uniformName, x, y, z, w) {
        if (this._cacheFloat4(uniformName, x, y, z, w)) {
            if (!this.engine.setInt4(this._uniforms[uniformName], x, y, z, w)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets an int array on a uniform variable.
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setIntArray(uniformName, array) {
        this._valueCache[uniformName] = null;
        this.engine.setIntArray(this._uniforms[uniformName], array);
    }
    /**
     * Sets an int array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setIntArray2(uniformName, array) {
        this._valueCache[uniformName] = null;
        this.engine.setIntArray2(this._uniforms[uniformName], array);
    }
    /**
     * Sets an int array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setIntArray3(uniformName, array) {
        this._valueCache[uniformName] = null;
        this.engine.setIntArray3(this._uniforms[uniformName], array);
    }
    /**
     * Sets an int array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setIntArray4(uniformName, array) {
        this._valueCache[uniformName] = null;
        this.engine.setIntArray4(this._uniforms[uniformName], array);
    }
    /**
     * Sets an unsigned integer value on a uniform variable.
     * @param uniformName Name of the variable.
     * @param value Value to be set.
     */ setUInt(uniformName, value) {
        const cache = this._valueCache[uniformName];
        if (cache !== undefined && cache === value) return;
        if (this.engine.setUInt(this._uniforms[uniformName], value)) this._valueCache[uniformName] = value;
    }
    /**
     * Sets an unsigned int2 value on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First unsigned int in uint2.
     * @param y Second unsigned int in uint2.
     */ setUInt2(uniformName, x, y) {
        if (this._cacheFloat2(uniformName, x, y)) {
            if (!this.engine.setUInt2(this._uniforms[uniformName], x, y)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets an unsigned int3 value on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First unsigned int in uint3.
     * @param y Second unsigned int in uint3.
     * @param z Third unsigned int in uint3.
     */ setUInt3(uniformName, x, y, z) {
        if (this._cacheFloat3(uniformName, x, y, z)) {
            if (!this.engine.setUInt3(this._uniforms[uniformName], x, y, z)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets an unsigned int4 value on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First unsigned int in uint4.
     * @param y Second unsigned int in uint4.
     * @param z Third unsigned int in uint4.
     * @param w Fourth unsigned int in uint4.
     */ setUInt4(uniformName, x, y, z, w) {
        if (this._cacheFloat4(uniformName, x, y, z, w)) {
            if (!this.engine.setUInt4(this._uniforms[uniformName], x, y, z, w)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets an unsigned int array on a uniform variable.
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setUIntArray(uniformName, array) {
        this._valueCache[uniformName] = null;
        this.engine.setUIntArray(this._uniforms[uniformName], array);
    }
    /**
     * Sets an unsigned int array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setUIntArray2(uniformName, array) {
        this._valueCache[uniformName] = null;
        this.engine.setUIntArray2(this._uniforms[uniformName], array);
    }
    /**
     * Sets an unsigned int array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setUIntArray3(uniformName, array) {
        this._valueCache[uniformName] = null;
        this.engine.setUIntArray3(this._uniforms[uniformName], array);
    }
    /**
     * Sets an unsigned int array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setUIntArray4(uniformName, array) {
        this._valueCache[uniformName] = null;
        this.engine.setUIntArray4(this._uniforms[uniformName], array);
    }
    /**
     * Sets an array on a uniform variable.
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setArray(uniformName, array) {
        this._valueCache[uniformName] = null;
        this.engine.setArray(this._uniforms[uniformName], array);
    }
    /**
     * Sets an array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setArray2(uniformName, array) {
        this._valueCache[uniformName] = null;
        this.engine.setArray2(this._uniforms[uniformName], array);
    }
    /**
     * Sets an array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setArray3(uniformName, array) {
        this._valueCache[uniformName] = null;
        this.engine.setArray3(this._uniforms[uniformName], array);
    }
    /**
     * Sets an array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setArray4(uniformName, array) {
        this._valueCache[uniformName] = null;
        this.engine.setArray4(this._uniforms[uniformName], array);
    }
    /**
     * Sets matrices on a uniform variable.
     * @param uniformName Name of the variable.
     * @param matrices matrices to be set.
     */ setMatrices(uniformName, matrices) {
        if (!matrices) return;
        this._valueCache[uniformName] = null;
        this.engine.setMatrices(this._uniforms[uniformName], matrices);
    }
    /**
     * Sets matrix on a uniform variable.
     * @param uniformName Name of the variable.
     * @param matrix matrix to be set.
     */ setMatrix(uniformName, matrix) {
        if (this._cacheMatrix(uniformName, matrix)) {
            if (!this.engine.setMatrices(this._uniforms[uniformName], matrix.asArray())) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a 3x3 matrix on a uniform variable. (Specified as [1,2,3,4,5,6,7,8,9] will result in [1,2,3][4,5,6][7,8,9] matrix)
     * @param uniformName Name of the variable.
     * @param matrix matrix to be set.
     */ setMatrix3x3(uniformName, matrix) {
        this._valueCache[uniformName] = null;
        this.engine.setMatrix3x3(this._uniforms[uniformName], matrix);
    }
    /**
     * Sets a 2x2 matrix on a uniform variable. (Specified as [1,2,3,4] will result in [1,2][3,4] matrix)
     * @param uniformName Name of the variable.
     * @param matrix matrix to be set.
     */ setMatrix2x2(uniformName, matrix) {
        this._valueCache[uniformName] = null;
        this.engine.setMatrix2x2(this._uniforms[uniformName], matrix);
    }
    /**
     * Sets a float on a uniform variable.
     * @param uniformName Name of the variable.
     * @param value value to be set.
     */ setFloat(uniformName, value) {
        const cache = this._valueCache[uniformName];
        if (cache !== undefined && cache === value) return;
        if (this.engine.setFloat(this._uniforms[uniformName], value)) this._valueCache[uniformName] = value;
    }
    /**
     * Sets a Vector2 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param vector2 vector2 to be set.
     */ setVector2(uniformName, vector2) {
        if (this._cacheFloat2(uniformName, vector2.x, vector2.y)) {
            if (!this.engine.setFloat2(this._uniforms[uniformName], vector2.x, vector2.y)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a float2 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First float in float2.
     * @param y Second float in float2.
     */ setFloat2(uniformName, x, y) {
        if (this._cacheFloat2(uniformName, x, y)) {
            if (!this.engine.setFloat2(this._uniforms[uniformName], x, y)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a Vector3 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param vector3 Value to be set.
     */ setVector3(uniformName, vector3) {
        if (this._cacheFloat3(uniformName, vector3.x, vector3.y, vector3.z)) {
            if (!this.engine.setFloat3(this._uniforms[uniformName], vector3.x, vector3.y, vector3.z)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a float3 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First float in float3.
     * @param y Second float in float3.
     * @param z Third float in float3.
     */ setFloat3(uniformName, x, y, z) {
        if (this._cacheFloat3(uniformName, x, y, z)) {
            if (!this.engine.setFloat3(this._uniforms[uniformName], x, y, z)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a Vector4 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param vector4 Value to be set.
     */ setVector4(uniformName, vector4) {
        if (this._cacheFloat4(uniformName, vector4.x, vector4.y, vector4.z, vector4.w)) {
            if (!this.engine.setFloat4(this._uniforms[uniformName], vector4.x, vector4.y, vector4.z, vector4.w)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a Quaternion on a uniform variable.
     * @param uniformName Name of the variable.
     * @param quaternion Value to be set.
     */ setQuaternion(uniformName, quaternion) {
        if (this._cacheFloat4(uniformName, quaternion.x, quaternion.y, quaternion.z, quaternion.w)) {
            if (!this.engine.setFloat4(this._uniforms[uniformName], quaternion.x, quaternion.y, quaternion.z, quaternion.w)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a float4 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First float in float4.
     * @param y Second float in float4.
     * @param z Third float in float4.
     * @param w Fourth float in float4.
     */ setFloat4(uniformName, x, y, z, w) {
        if (this._cacheFloat4(uniformName, x, y, z, w)) {
            if (!this.engine.setFloat4(this._uniforms[uniformName], x, y, z, w)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a Color3 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param color3 Value to be set.
     */ setColor3(uniformName, color3) {
        if (this._cacheFloat3(uniformName, color3.r, color3.g, color3.b)) {
            if (!this.engine.setFloat3(this._uniforms[uniformName], color3.r, color3.g, color3.b)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a Color4 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param color3 Value to be set.
     * @param alpha Alpha value to be set.
     */ setColor4(uniformName, color3, alpha) {
        if (this._cacheFloat4(uniformName, color3.r, color3.g, color3.b, alpha)) {
            if (!this.engine.setFloat4(this._uniforms[uniformName], color3.r, color3.g, color3.b, alpha)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a Color4 on a uniform variable
     * @param uniformName defines the name of the variable
     * @param color4 defines the value to be set
     */ setDirectColor4(uniformName, color4) {
        if (this._cacheFloat4(uniformName, color4.r, color4.g, color4.b, color4.a)) {
            if (!this.engine.setFloat4(this._uniforms[uniformName], color4.r, color4.g, color4.b, color4.a)) this._valueCache[uniformName] = null;
        }
    }
    _getVertexShaderCode() {
        return this.vertexShader ? this.engine._getShaderSource(this.vertexShader) : null;
    }
    _getFragmentShaderCode() {
        return this.fragmentShader ? this.engine._getShaderSource(this.fragmentShader) : null;
    }
}

});

parcelRegister("8ClRi", function(module, exports) {

$parcel$export(module.exports, "WebGLHardwareTexture", () => $6462d404321370dd$export$ece48379e57ba1fe);
/** @internal */ class $6462d404321370dd$export$ece48379e57ba1fe {
    get underlyingResource() {
        return this._webGLTexture;
    }
    constructor(existingTexture = null, context){
        // There can be multiple buffers for a single WebGL texture because different layers of a 2DArrayTexture / 3DTexture
        // or different faces of a cube texture can be bound to different render targets at the same time.
        // eslint-disable-next-line @typescript-eslint/naming-convention
        this._MSAARenderBuffers = null;
        this._context = context;
        if (!existingTexture) {
            existingTexture = context.createTexture();
            if (!existingTexture) throw new Error("Unable to create webGL texture");
        }
        this.set(existingTexture);
    }
    setUsage() {}
    set(hardwareTexture) {
        this._webGLTexture = hardwareTexture;
    }
    reset() {
        this._webGLTexture = null;
        this._MSAARenderBuffers = null;
    }
    addMSAARenderBuffer(buffer) {
        if (!this._MSAARenderBuffers) this._MSAARenderBuffers = [];
        this._MSAARenderBuffers.push(buffer);
    }
    releaseMSAARenderBuffers() {
        if (this._MSAARenderBuffers) {
            for (const buffer of this._MSAARenderBuffers)this._context.deleteRenderbuffer(buffer);
            this._MSAARenderBuffers = null;
        }
    }
    getMSAARenderBuffer(index = 0) {
        return this._MSAARenderBuffers?.[index] ?? null;
    }
    release() {
        this.releaseMSAARenderBuffers();
        if (this._webGLTexture) this._context.deleteTexture(this._webGLTexture);
        this.reset();
    }
}

});

parcelRegister("hOyoX", function(module, exports) {

$parcel$export(module.exports, "DrawWrapper", () => $cf81ca9f655ca25e$export$76dd59d923282679);
/** @internal */ class $cf81ca9f655ca25e$export$76dd59d923282679 {
    static IsWrapper(effect) {
        return effect.getPipelineContext === undefined;
    }
    static GetEffect(effect) {
        return effect.getPipelineContext === undefined ? effect.effect : effect;
    }
    constructor(engine, createMaterialContext = true){
        /**
         * @internal
         * Specifies if the effect was previously ready
         */ this._wasPreviouslyReady = false;
        /**
         * @internal
         * Forces the code from bindForSubMesh to be fully run the next time it is called
         */ this._forceRebindOnNextCall = true;
        /**
         * @internal
         * Specifies if the effect was previously using instances
         */ this._wasPreviouslyUsingInstances = null;
        this.effect = null;
        this.defines = null;
        this.drawContext = engine.createDrawContext();
        if (createMaterialContext) this.materialContext = engine.createMaterialContext();
    }
    setEffect(effect, defines, resetContext = true) {
        this.effect = effect;
        if (defines !== undefined) this.defines = defines;
        if (resetContext) this.drawContext?.reset();
    }
    dispose() {
        this.drawContext?.dispose();
    }
}

});

parcelRegister("cyIBx", function(module, exports) {

$parcel$export(module.exports, "StencilStateComposer", () => $924b4284f24e5b9b$export$34fb0697ec4ab56b);
/**
 * @internal
 **/ class $924b4284f24e5b9b$export$34fb0697ec4ab56b {
    get isDirty() {
        return this._isStencilTestDirty || this._isStencilMaskDirty || this._isStencilFuncDirty || this._isStencilOpDirty;
    }
    get func() {
        return this._func;
    }
    set func(value) {
        if (this._func === value) return;
        this._func = value;
        this._isStencilFuncDirty = true;
    }
    get funcRef() {
        return this._funcRef;
    }
    set funcRef(value) {
        if (this._funcRef === value) return;
        this._funcRef = value;
        this._isStencilFuncDirty = true;
    }
    get funcMask() {
        return this._funcMask;
    }
    set funcMask(value) {
        if (this._funcMask === value) return;
        this._funcMask = value;
        this._isStencilFuncDirty = true;
    }
    get opStencilFail() {
        return this._opStencilFail;
    }
    set opStencilFail(value) {
        if (this._opStencilFail === value) return;
        this._opStencilFail = value;
        this._isStencilOpDirty = true;
    }
    get opDepthFail() {
        return this._opDepthFail;
    }
    set opDepthFail(value) {
        if (this._opDepthFail === value) return;
        this._opDepthFail = value;
        this._isStencilOpDirty = true;
    }
    get opStencilDepthPass() {
        return this._opStencilDepthPass;
    }
    set opStencilDepthPass(value) {
        if (this._opStencilDepthPass === value) return;
        this._opStencilDepthPass = value;
        this._isStencilOpDirty = true;
    }
    get mask() {
        return this._mask;
    }
    set mask(value) {
        if (this._mask === value) return;
        this._mask = value;
        this._isStencilMaskDirty = true;
    }
    get enabled() {
        return this._enabled;
    }
    set enabled(value) {
        if (this._enabled === value) return;
        this._enabled = value;
        this._isStencilTestDirty = true;
    }
    constructor(reset = true){
        this._isStencilTestDirty = false;
        this._isStencilMaskDirty = false;
        this._isStencilFuncDirty = false;
        this._isStencilOpDirty = false;
        this.useStencilGlobalOnly = false;
        if (reset) this.reset();
    }
    reset() {
        this.stencilMaterial = undefined;
        this.stencilGlobal?.reset();
        this._isStencilTestDirty = true;
        this._isStencilMaskDirty = true;
        this._isStencilFuncDirty = true;
        this._isStencilOpDirty = true;
    }
    apply(gl) {
        if (!gl) return;
        const stencilMaterialEnabled = !this.useStencilGlobalOnly && !!this.stencilMaterial?.enabled;
        this.enabled = stencilMaterialEnabled ? this.stencilMaterial.enabled : this.stencilGlobal.enabled;
        this.func = stencilMaterialEnabled ? this.stencilMaterial.func : this.stencilGlobal.func;
        this.funcRef = stencilMaterialEnabled ? this.stencilMaterial.funcRef : this.stencilGlobal.funcRef;
        this.funcMask = stencilMaterialEnabled ? this.stencilMaterial.funcMask : this.stencilGlobal.funcMask;
        this.opStencilFail = stencilMaterialEnabled ? this.stencilMaterial.opStencilFail : this.stencilGlobal.opStencilFail;
        this.opDepthFail = stencilMaterialEnabled ? this.stencilMaterial.opDepthFail : this.stencilGlobal.opDepthFail;
        this.opStencilDepthPass = stencilMaterialEnabled ? this.stencilMaterial.opStencilDepthPass : this.stencilGlobal.opStencilDepthPass;
        this.mask = stencilMaterialEnabled ? this.stencilMaterial.mask : this.stencilGlobal.mask;
        if (!this.isDirty) return;
        // Stencil test
        if (this._isStencilTestDirty) {
            if (this.enabled) gl.enable(gl.STENCIL_TEST);
            else gl.disable(gl.STENCIL_TEST);
            this._isStencilTestDirty = false;
        }
        // Stencil mask
        if (this._isStencilMaskDirty) {
            gl.stencilMask(this.mask);
            this._isStencilMaskDirty = false;
        }
        // Stencil func
        if (this._isStencilFuncDirty) {
            gl.stencilFunc(this.func, this.funcRef, this.funcMask);
            this._isStencilFuncDirty = false;
        }
        // Stencil op
        if (this._isStencilOpDirty) {
            gl.stencilOp(this.opStencilFail, this.opDepthFail, this.opStencilDepthPass);
            this._isStencilOpDirty = false;
        }
    }
}

});


parcelRegister("av6Bc", function(module, exports) {

$parcel$export(module.exports, "TimingTools", () => $7a51eb0e2c330399$export$4da47a480c8724e);

var $jFz47 = parcelRequire("jFz47");
class $7a51eb0e2c330399$export$4da47a480c8724e {
    /**
     * Polyfill for setImmediate
     * @param action defines the action to execute after the current execution block
     */ static SetImmediate(action) {
        if ((0, $jFz47.IsWindowObjectExist)() && window.setImmediate) window.setImmediate(action);
        else setTimeout(action, 1);
    }
}

});


parcelRegister("i1moY", function(module, exports) {

$parcel$export(module.exports, "InstantiationTools", () => $d1e9b27fd3209819$export$d445cd1e11268bec);

var $kVtWi = parcelRequire("kVtWi");

var $8DoUR = parcelRequire("8DoUR");
class $d1e9b27fd3209819$export$d445cd1e11268bec {
    /**
     * Tries to instantiate a new object from a given class name
     * @param className defines the class name to instantiate
     * @returns the new object or null if the system was not able to do the instantiation
     */ static Instantiate(className) {
        if (this.RegisteredExternalClasses && this.RegisteredExternalClasses[className]) return this.RegisteredExternalClasses[className];
        const internalClass = (0, $8DoUR.GetClass)(className);
        if (internalClass) return internalClass;
        (0, $kVtWi.Logger).Warn(className + " not found, you may have missed an import.");
        const arr = className.split(".");
        let fn = window || this;
        for(let i = 0, len = arr.length; i < len; i++)fn = fn[arr[i]];
        if (typeof fn !== "function") return null;
        return fn;
    }
}
/**
 * Use this object to register external classes like custom textures or material
 * to allow the loaders to instantiate them
 */ $d1e9b27fd3209819$export$d445cd1e11268bec.RegisteredExternalClasses = {};

});

parcelRegister("321Uk", function(module, exports) {

$parcel$export(module.exports, "RandomGUID", () => $235309cb367bc426$export$1d06f1866d73f3cb);
$parcel$export(module.exports, "GUID", () => $235309cb367bc426$export$aeae6d33ee4c22ee);
/**
 * Implementation from http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#answer-2117523
 * Be aware Math.random() could cause collisions, but:
 * "All but 6 of the 128 bits of the ID are randomly generated, which means that for any two ids, there's a 1 in 2^^122 (or 5.3x10^^36) chance they'll collide"
 * @returns a pseudo random id
 */ function $235309cb367bc426$export$1d06f1866d73f3cb() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0, v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
const $235309cb367bc426$export$aeae6d33ee4c22ee = {
    /**
     * Implementation from http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#answer-2117523
     * Be aware Math.random() could cause collisions, but:
     * "All but 6 of the 128 bits of the ID are randomly generated, which means that for any two ids, there's a 1 in 2^^122 (or 5.3x10^^36) chance they'll collide"
     * @returns a pseudo random id
     */ // eslint-disable-next-line @typescript-eslint/naming-convention
    RandomId: $235309cb367bc426$export$1d06f1866d73f3cb
};

});

parcelRegister("wK2xc", function(module, exports) {

$parcel$export(module.exports, "IsExponentOfTwo", () => $0626b3d5ab722105$export$c3f415aa3baa73a8);
$parcel$export(module.exports, "Mix", () => $0626b3d5ab722105$export$7396bfa63bff91f5);
/**
 * Function indicating if a number is an exponent of 2
 * @param value defines the value to test
 * @returns true if the value is an exponent of 2
 */ function $0626b3d5ab722105$export$c3f415aa3baa73a8(value) {
    let count = 1;
    do count *= 2;
    while (count < value);
    return count === value;
}
function $0626b3d5ab722105$export$7396bfa63bff91f5(a, b, alpha) {
    return a * (1 - alpha) + b * alpha;
}

});


parcelRegister("57onU", function(module, exports) {

$parcel$export(module.exports, "SmartArray", () => $3ba0857505d5e249$export$556f92bf4579e18b);
$parcel$export(module.exports, "SmartArrayNoDuplicate", () => $3ba0857505d5e249$export$b3dcd8157693e8e3);
/**
 * Defines an GC Friendly array where the backfield array do not shrink to prevent over allocations.
 */ class $3ba0857505d5e249$export$556f92bf4579e18b {
    /**
     * Instantiates a Smart Array.
     * @param capacity defines the default capacity of the array.
     */ constructor(capacity){
        /**
         * The active length of the array.
         */ this.length = 0;
        this.data = new Array(capacity);
        this._id = $3ba0857505d5e249$export$556f92bf4579e18b._GlobalId++;
    }
    /**
     * Pushes a value at the end of the active data.
     * @param value defines the object to push in the array.
     */ push(value) {
        this.data[this.length++] = value;
        if (this.length > this.data.length) this.data.length *= 2;
    }
    /**
     * Iterates over the active data and apply the lambda to them.
     * @param func defines the action to apply on each value.
     */ forEach(func) {
        for(let index = 0; index < this.length; index++)func(this.data[index]);
    }
    /**
     * Sorts the full sets of data.
     * @param compareFn defines the comparison function to apply.
     */ sort(compareFn) {
        this.data.sort(compareFn);
    }
    /**
     * Resets the active data to an empty array.
     */ reset() {
        this.length = 0;
    }
    /**
     * Releases all the data from the array as well as the array.
     */ dispose() {
        this.reset();
        if (this.data) this.data.length = 0;
    }
    /**
     * Concats the active data with a given array.
     * @param array defines the data to concatenate with.
     */ concat(array) {
        if (array.length === 0) return;
        if (this.length + array.length > this.data.length) this.data.length = (this.length + array.length) * 2;
        for(let index = 0; index < array.length; index++)this.data[this.length++] = (array.data || array)[index];
    }
    /**
     * Returns the position of a value in the active data.
     * @param value defines the value to find the index for
     * @returns the index if found in the active data otherwise -1
     */ indexOf(value) {
        const position = this.data.indexOf(value);
        if (position >= this.length) return -1;
        return position;
    }
    /**
     * Returns whether an element is part of the active data.
     * @param value defines the value to look for
     * @returns true if found in the active data otherwise false
     */ contains(value) {
        return this.indexOf(value) !== -1;
    }
}
// Statics
$3ba0857505d5e249$export$556f92bf4579e18b._GlobalId = 0;
class $3ba0857505d5e249$export$b3dcd8157693e8e3 extends $3ba0857505d5e249$export$556f92bf4579e18b {
    constructor(){
        super(...arguments);
        this._duplicateId = 0;
    }
    /**
     * Pushes a value at the end of the active data.
     * THIS DOES NOT PREVENT DUPPLICATE DATA
     * @param value defines the object to push in the array.
     */ push(value) {
        super.push(value);
        if (!value.__smartArrayFlags) value.__smartArrayFlags = {};
        value.__smartArrayFlags[this._id] = this._duplicateId;
    }
    /**
     * Pushes a value at the end of the active data.
     * If the data is already present, it won t be added again
     * @param value defines the object to push in the array.
     * @returns true if added false if it was already present
     */ pushNoDuplicate(value) {
        if (value.__smartArrayFlags && value.__smartArrayFlags[this._id] === this._duplicateId) return false;
        this.push(value);
        return true;
    }
    /**
     * Resets the active data to an empty array.
     */ reset() {
        super.reset();
        this._duplicateId++;
    }
    /**
     * Concats the active data with a given array.
     * This ensures no duplicate will be present in the result.
     * @param array defines the data to concatenate with.
     */ concatWithNoDuplicate(array) {
        if (array.length === 0) return;
        if (this.length + array.length > this.data.length) this.data.length = (this.length + array.length) * 2;
        for(let index = 0; index < array.length; index++){
            const item = (array.data || array)[index];
            this.pushNoDuplicate(item);
        }
    }
}

});

parcelRegister("895IS", function(module, exports) {

$parcel$export(module.exports, "StringDictionary", () => $5ee39a6fb0067c4c$export$aa8d5945bd10865c);
/**
 * This class implement a typical dictionary using a string as key and the generic type T as value.
 * The underlying implementation relies on an associative array to ensure the best performances.
 * The value can be anything including 'null' but except 'undefined'
 */ class $5ee39a6fb0067c4c$export$aa8d5945bd10865c {
    constructor(){
        this._count = 0;
        this._data = {};
    }
    /**
     * This will clear this dictionary and copy the content from the 'source' one.
     * If the T value is a custom object, it won't be copied/cloned, the same object will be used
     * @param source the dictionary to take the content from and copy to this dictionary
     */ copyFrom(source) {
        this.clear();
        source.forEach((t, v)=>this.add(t, v));
    }
    /**
     * Get a value based from its key
     * @param key the given key to get the matching value from
     * @returns the value if found, otherwise undefined is returned
     */ get(key) {
        const val = this._data[key];
        if (val !== undefined) return val;
        return undefined;
    }
    /**
     * Get a value from its key or add it if it doesn't exist.
     * This method will ensure you that a given key/data will be present in the dictionary.
     * @param key the given key to get the matching value from
     * @param factory the factory that will create the value if the key is not present in the dictionary.
     * The factory will only be invoked if there's no data for the given key.
     * @returns the value corresponding to the key.
     */ getOrAddWithFactory(key, factory) {
        let val = this.get(key);
        if (val !== undefined) return val;
        val = factory(key);
        if (val) this.add(key, val);
        return val;
    }
    /**
     * Get a value from its key if present in the dictionary otherwise add it
     * @param key the key to get the value from
     * @param val if there's no such key/value pair in the dictionary add it with this value
     * @returns the value corresponding to the key
     */ getOrAdd(key, val) {
        const curVal = this.get(key);
        if (curVal !== undefined) return curVal;
        this.add(key, val);
        return val;
    }
    /**
     * Check if there's a given key in the dictionary
     * @param key the key to check for
     * @returns true if the key is present, false otherwise
     */ contains(key) {
        return this._data[key] !== undefined;
    }
    /**
     * Add a new key and its corresponding value
     * @param key the key to add
     * @param value the value corresponding to the key
     * @returns true if the operation completed successfully, false if we couldn't insert the key/value because there was already this key in the dictionary
     */ add(key, value) {
        if (this._data[key] !== undefined) return false;
        this._data[key] = value;
        ++this._count;
        return true;
    }
    /**
     * Update a specific value associated to a key
     * @param key defines the key to use
     * @param value defines the value to store
     * @returns true if the value was updated (or false if the key was not found)
     */ set(key, value) {
        if (this._data[key] === undefined) return false;
        this._data[key] = value;
        return true;
    }
    /**
     * Get the element of the given key and remove it from the dictionary
     * @param key defines the key to search
     * @returns the value associated with the key or null if not found
     */ getAndRemove(key) {
        const val = this.get(key);
        if (val !== undefined) {
            delete this._data[key];
            --this._count;
            return val;
        }
        return null;
    }
    /**
     * Remove a key/value from the dictionary.
     * @param key the key to remove
     * @returns true if the item was successfully deleted, false if no item with such key exist in the dictionary
     */ remove(key) {
        if (this.contains(key)) {
            delete this._data[key];
            --this._count;
            return true;
        }
        return false;
    }
    /**
     * Clear the whole content of the dictionary
     */ clear() {
        this._data = {};
        this._count = 0;
    }
    /**
     * Gets the current count
     */ get count() {
        return this._count;
    }
    /**
     * Execute a callback on each key/val of the dictionary.
     * Note that you can remove any element in this dictionary in the callback implementation
     * @param callback the callback to execute on a given key/value pair
     */ forEach(callback) {
        for(const cur in this._data){
            const val = this._data[cur];
            callback(cur, val);
        }
    }
    /**
     * Execute a callback on every occurrence of the dictionary until it returns a valid TRes object.
     * If the callback returns null or undefined the method will iterate to the next key/value pair
     * Note that you can remove any element in this dictionary in the callback implementation
     * @param callback the callback to execute, if it return a valid T instanced object the enumeration will stop and the object will be returned
     * @returns the first item
     */ first(callback) {
        for(const cur in this._data){
            const val = this._data[cur];
            const res = callback(cur, val);
            if (res) return res;
        }
        return null;
    }
}

});

parcelRegister("dG1pf", function(module, exports) {

$parcel$export(module.exports, "ImageProcessingConfiguration", () => $9f5049d6792e7ced$export$e58d65d302f9b7ec);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $diGQf = parcelRequire("diGQf");

var $7etnY = parcelRequire("7etnY");

var $eVS9r = parcelRequire("eVS9r");

var $wK2xc = parcelRequire("wK2xc");

var $6Ho1L = parcelRequire("6Ho1L");

var $ePyUi = parcelRequire("ePyUi");
class $9f5049d6792e7ced$export$e58d65d302f9b7ec {
    constructor(){
        /**
         * Color curves setup used in the effect if colorCurvesEnabled is set to true
         */ this.colorCurves = new (0, $eVS9r.ColorCurves)();
        this._colorCurvesEnabled = false;
        this._colorGradingEnabled = false;
        this._colorGradingWithGreenDepth = true;
        this._colorGradingBGR = true;
        /** @internal */ this._exposure = 1.0;
        this._toneMappingEnabled = false;
        this._toneMappingType = $9f5049d6792e7ced$export$e58d65d302f9b7ec.TONEMAPPING_STANDARD;
        this._contrast = 1.0;
        /**
         * Vignette stretch size.
         */ this.vignetteStretch = 0;
        /**
         * Vignette center X Offset.
         */ this.vignetteCenterX = 0;
        /**
         * Vignette center Y Offset.
         */ this.vignetteCenterY = 0;
        /**
         * Vignette weight or intensity of the vignette effect.
         */ this.vignetteWeight = 1.5;
        /**
         * Color of the vignette applied on the screen through the chosen blend mode (vignetteBlendMode)
         * if vignetteEnabled is set to true.
         */ this.vignetteColor = new (0, $7etnY.Color4)(0, 0, 0, 0);
        /**
         * Camera field of view used by the Vignette effect.
         */ this.vignetteCameraFov = 0.5;
        this._vignetteBlendMode = $9f5049d6792e7ced$export$e58d65d302f9b7ec.VIGNETTEMODE_MULTIPLY;
        this._vignetteEnabled = false;
        this._ditheringEnabled = false;
        this._ditheringIntensity = 1.0 / 255.0;
        /** @internal */ this._skipFinalColorClamp = false;
        /** @internal */ this._applyByPostProcess = false;
        this._isEnabled = true;
        /**
         * An event triggered when the configuration changes and requires Shader to Update some parameters.
         */ this.onUpdateParameters = new (0, $diGQf.Observable)();
    }
    /**
     * Gets whether the color curves effect is enabled.
     */ get colorCurvesEnabled() {
        return this._colorCurvesEnabled;
    }
    /**
     * Sets whether the color curves effect is enabled.
     */ set colorCurvesEnabled(value) {
        if (this._colorCurvesEnabled === value) return;
        this._colorCurvesEnabled = value;
        this._updateParameters();
    }
    /**
     * Color grading LUT texture used in the effect if colorGradingEnabled is set to true
     */ get colorGradingTexture() {
        return this._colorGradingTexture;
    }
    /**
     * Color grading LUT texture used in the effect if colorGradingEnabled is set to true
     */ set colorGradingTexture(value) {
        if (this._colorGradingTexture === value) return;
        this._colorGradingTexture = value;
        this._updateParameters();
    }
    /**
     * Gets whether the color grading effect is enabled.
     */ get colorGradingEnabled() {
        return this._colorGradingEnabled;
    }
    /**
     * Sets whether the color grading effect is enabled.
     */ set colorGradingEnabled(value) {
        if (this._colorGradingEnabled === value) return;
        this._colorGradingEnabled = value;
        this._updateParameters();
    }
    /**
     * Gets whether the color grading effect is using a green depth for the 3d Texture.
     */ get colorGradingWithGreenDepth() {
        return this._colorGradingWithGreenDepth;
    }
    /**
     * Sets whether the color grading effect is using a green depth for the 3d Texture.
     */ set colorGradingWithGreenDepth(value) {
        if (this._colorGradingWithGreenDepth === value) return;
        this._colorGradingWithGreenDepth = value;
        this._updateParameters();
    }
    /**
     * Gets whether the color grading texture contains BGR values.
     */ get colorGradingBGR() {
        return this._colorGradingBGR;
    }
    /**
     * Sets whether the color grading texture contains BGR values.
     */ set colorGradingBGR(value) {
        if (this._colorGradingBGR === value) return;
        this._colorGradingBGR = value;
        this._updateParameters();
    }
    /**
     * Gets the Exposure used in the effect.
     */ get exposure() {
        return this._exposure;
    }
    /**
     * Sets the Exposure used in the effect.
     */ set exposure(value) {
        if (this._exposure === value) return;
        this._exposure = value;
        this._updateParameters();
    }
    /**
     * Gets whether the tone mapping effect is enabled.
     */ get toneMappingEnabled() {
        return this._toneMappingEnabled;
    }
    /**
     * Sets whether the tone mapping effect is enabled.
     */ set toneMappingEnabled(value) {
        if (this._toneMappingEnabled === value) return;
        this._toneMappingEnabled = value;
        this._updateParameters();
    }
    /**
     * Gets the type of tone mapping effect.
     */ get toneMappingType() {
        return this._toneMappingType;
    }
    /**
     * Sets the type of tone mapping effect used in BabylonJS.
     */ set toneMappingType(value) {
        if (this._toneMappingType === value) return;
        this._toneMappingType = value;
        this._updateParameters();
    }
    /**
     * Gets the contrast used in the effect.
     */ get contrast() {
        return this._contrast;
    }
    /**
     * Sets the contrast used in the effect.
     */ set contrast(value) {
        if (this._contrast === value) return;
        this._contrast = value;
        this._updateParameters();
    }
    /**
     * Back Compat: Vignette center Y Offset.
     * @deprecated use vignetteCenterY instead
     */ get vignetteCentreY() {
        return this.vignetteCenterY;
    }
    set vignetteCentreY(value) {
        this.vignetteCenterY = value;
    }
    /**
     * Back Compat: Vignette center X Offset.
     * @deprecated use vignetteCenterX instead
     */ get vignetteCentreX() {
        return this.vignetteCenterX;
    }
    set vignetteCentreX(value) {
        this.vignetteCenterX = value;
    }
    /**
     * Gets the vignette blend mode allowing different kind of effect.
     */ get vignetteBlendMode() {
        return this._vignetteBlendMode;
    }
    /**
     * Sets the vignette blend mode allowing different kind of effect.
     */ set vignetteBlendMode(value) {
        if (this._vignetteBlendMode === value) return;
        this._vignetteBlendMode = value;
        this._updateParameters();
    }
    /**
     * Gets whether the vignette effect is enabled.
     */ get vignetteEnabled() {
        return this._vignetteEnabled;
    }
    /**
     * Sets whether the vignette effect is enabled.
     */ set vignetteEnabled(value) {
        if (this._vignetteEnabled === value) return;
        this._vignetteEnabled = value;
        this._updateParameters();
    }
    /**
     * Gets whether the dithering effect is enabled.
     * The dithering effect can be used to reduce banding.
     */ get ditheringEnabled() {
        return this._ditheringEnabled;
    }
    /**
     * Sets whether the dithering effect is enabled.
     * The dithering effect can be used to reduce banding.
     */ set ditheringEnabled(value) {
        if (this._ditheringEnabled === value) return;
        this._ditheringEnabled = value;
        this._updateParameters();
    }
    /**
     * Gets the dithering intensity. 0 is no dithering. Default is 1.0 / 255.0.
     */ get ditheringIntensity() {
        return this._ditheringIntensity;
    }
    /**
     * Sets the dithering intensity. 0 is no dithering. Default is 1.0 / 255.0.
     */ set ditheringIntensity(value) {
        if (this._ditheringIntensity === value) return;
        this._ditheringIntensity = value;
        this._updateParameters();
    }
    /**
     * If apply by post process is set to true, setting this to true will skip the final color clamp step in the fragment shader
     * Applies to PBR materials.
     */ get skipFinalColorClamp() {
        return this._skipFinalColorClamp;
    }
    /**
     * If apply by post process is set to true, setting this to true will skip the final color clamp step in the fragment shader
     * Applies to PBR materials.
     */ set skipFinalColorClamp(value) {
        if (this._skipFinalColorClamp === value) return;
        this._skipFinalColorClamp = value;
        this._updateParameters();
    }
    /**
     * Gets whether the image processing is applied through a post process or not.
     */ get applyByPostProcess() {
        return this._applyByPostProcess;
    }
    /**
     * Sets whether the image processing is applied through a post process or not.
     */ set applyByPostProcess(value) {
        if (this._applyByPostProcess === value) return;
        this._applyByPostProcess = value;
        this._updateParameters();
    }
    /**
     * Gets whether the image processing is enabled or not.
     */ get isEnabled() {
        return this._isEnabled;
    }
    /**
     * Sets whether the image processing is enabled or not.
     */ set isEnabled(value) {
        if (this._isEnabled === value) return;
        this._isEnabled = value;
        this._updateParameters();
    }
    /**
     * Method called each time the image processing information changes requires to recompile the effect.
     */ _updateParameters() {
        this.onUpdateParameters.notifyObservers(this);
    }
    /**
     * Gets the current class name.
     * @returns "ImageProcessingConfiguration"
     */ getClassName() {
        return "ImageProcessingConfiguration";
    }
    /**
     * Prepare the list of defines associated to the shader.
     * @param defines the list of defines to complete
     * @param forPostProcess Define if we are currently in post process mode or not
     */ prepareDefines(defines, forPostProcess = false) {
        if (forPostProcess !== this.applyByPostProcess || !this._isEnabled) {
            defines.VIGNETTE = false;
            defines.TONEMAPPING = false;
            defines.TONEMAPPING_ACES = false;
            defines.CONTRAST = false;
            defines.EXPOSURE = false;
            defines.COLORCURVES = false;
            defines.COLORGRADING = false;
            defines.COLORGRADING3D = false;
            defines.DITHER = false;
            defines.IMAGEPROCESSING = false;
            defines.SKIPFINALCOLORCLAMP = this.skipFinalColorClamp;
            defines.IMAGEPROCESSINGPOSTPROCESS = this.applyByPostProcess && this._isEnabled;
            return;
        }
        defines.VIGNETTE = this.vignetteEnabled;
        defines.VIGNETTEBLENDMODEMULTIPLY = this.vignetteBlendMode === $9f5049d6792e7ced$export$e58d65d302f9b7ec._VIGNETTEMODE_MULTIPLY;
        defines.VIGNETTEBLENDMODEOPAQUE = !defines.VIGNETTEBLENDMODEMULTIPLY;
        defines.TONEMAPPING = this.toneMappingEnabled;
        switch(this._toneMappingType){
            case $9f5049d6792e7ced$export$e58d65d302f9b7ec.TONEMAPPING_ACES:
                defines.TONEMAPPING_ACES = true;
                break;
            default:
                defines.TONEMAPPING_ACES = false;
                break;
        }
        defines.CONTRAST = this.contrast !== 1.0;
        defines.EXPOSURE = this.exposure !== 1.0;
        defines.COLORCURVES = this.colorCurvesEnabled && !!this.colorCurves;
        defines.COLORGRADING = this.colorGradingEnabled && !!this.colorGradingTexture;
        if (defines.COLORGRADING) defines.COLORGRADING3D = this.colorGradingTexture.is3D;
        else defines.COLORGRADING3D = false;
        defines.SAMPLER3DGREENDEPTH = this.colorGradingWithGreenDepth;
        defines.SAMPLER3DBGRMAP = this.colorGradingBGR;
        defines.DITHER = this._ditheringEnabled;
        defines.IMAGEPROCESSINGPOSTPROCESS = this.applyByPostProcess;
        defines.SKIPFINALCOLORCLAMP = this.skipFinalColorClamp;
        defines.IMAGEPROCESSING = defines.VIGNETTE || defines.TONEMAPPING || defines.CONTRAST || defines.EXPOSURE || defines.COLORCURVES || defines.COLORGRADING || defines.DITHER;
    }
    /**
     * Returns true if all the image processing information are ready.
     * @returns True if ready, otherwise, false
     */ isReady() {
        // Color Grading texture can not be none blocking.
        return !this.colorGradingEnabled || !this.colorGradingTexture || this.colorGradingTexture.isReady();
    }
    /**
     * Binds the image processing to the shader.
     * @param effect The effect to bind to
     * @param overrideAspectRatio Override the aspect ratio of the effect
     */ bind(effect, overrideAspectRatio) {
        // Color Curves
        if (this._colorCurvesEnabled && this.colorCurves) (0, $eVS9r.ColorCurves).Bind(this.colorCurves, effect);
        // Vignette and dither handled together due to common uniform.
        if (this._vignetteEnabled || this._ditheringEnabled) {
            const inverseWidth = 1 / effect.getEngine().getRenderWidth();
            const inverseHeight = 1 / effect.getEngine().getRenderHeight();
            effect.setFloat2("vInverseScreenSize", inverseWidth, inverseHeight);
            if (this._ditheringEnabled) effect.setFloat("ditherIntensity", 0.5 * this._ditheringIntensity);
            if (this._vignetteEnabled) {
                const aspectRatio = overrideAspectRatio != null ? overrideAspectRatio : inverseHeight / inverseWidth;
                let vignetteScaleY = Math.tan(this.vignetteCameraFov * 0.5);
                let vignetteScaleX = vignetteScaleY * aspectRatio;
                const vignetteScaleGeometricMean = Math.sqrt(vignetteScaleX * vignetteScaleY);
                vignetteScaleX = (0, $wK2xc.Mix)(vignetteScaleX, vignetteScaleGeometricMean, this.vignetteStretch);
                vignetteScaleY = (0, $wK2xc.Mix)(vignetteScaleY, vignetteScaleGeometricMean, this.vignetteStretch);
                effect.setFloat4("vignetteSettings1", vignetteScaleX, vignetteScaleY, -vignetteScaleX * this.vignetteCenterX, -vignetteScaleY * this.vignetteCenterY);
                const vignettePower = -2 * this.vignetteWeight;
                effect.setFloat4("vignetteSettings2", this.vignetteColor.r, this.vignetteColor.g, this.vignetteColor.b, vignettePower);
            }
        }
        // Exposure
        effect.setFloat("exposureLinear", this.exposure);
        // Contrast
        effect.setFloat("contrast", this.contrast);
        // Color transform settings
        if (this.colorGradingTexture) {
            effect.setTexture("txColorTransform", this.colorGradingTexture);
            const textureSize = this.colorGradingTexture.getSize().height;
            effect.setFloat4("colorTransformSettings", (textureSize - 1) / textureSize, 0.5 / textureSize, textureSize, this.colorGradingTexture.level // weight
            );
        }
    }
    /**
     * Clones the current image processing instance.
     * @returns The cloned image processing
     */ clone() {
        return (0, $6Ho1L.SerializationHelper).Clone(()=>new $9f5049d6792e7ced$export$e58d65d302f9b7ec(), this);
    }
    /**
     * Serializes the current image processing instance to a json representation.
     * @returns a JSON representation
     */ serialize() {
        return (0, $6Ho1L.SerializationHelper).Serialize(this);
    }
    /**
     * Parses the image processing from a json representation.
     * @param source the JSON source to parse
     * @returns The parsed image processing
     */ static Parse(source) {
        const parsed = (0, $6Ho1L.SerializationHelper).Parse(()=>new $9f5049d6792e7ced$export$e58d65d302f9b7ec(), source, null, null);
        // Backward compatibility
        if (source.vignetteCentreX !== undefined) parsed.vignetteCenterX = source.vignetteCentreX;
        if (source.vignetteCentreY !== undefined) parsed.vignetteCenterY = source.vignetteCentreY;
        return parsed;
    }
    /**
     * Used to apply the vignette as a mix with the pixel color.
     */ static get VIGNETTEMODE_MULTIPLY() {
        return this._VIGNETTEMODE_MULTIPLY;
    }
    /**
     * Used to apply the vignette as a replacement of the pixel color.
     */ static get VIGNETTEMODE_OPAQUE() {
        return this._VIGNETTEMODE_OPAQUE;
    }
}
/**
 * Default tone mapping applied in BabylonJS.
 */ $9f5049d6792e7ced$export$e58d65d302f9b7ec.TONEMAPPING_STANDARD = 0;
/**
 * ACES Tone mapping (used by default in unreal and unity). This can help getting closer
 * to other engines rendering to increase portability.
 */ $9f5049d6792e7ced$export$e58d65d302f9b7ec.TONEMAPPING_ACES = 1;
/**
 * Prepare the list of uniforms associated with the Image Processing effects.
 * @param uniforms The list of uniforms used in the effect
 * @param defines the list of defines currently in use
 */ $9f5049d6792e7ced$export$e58d65d302f9b7ec.PrepareUniforms = (0, $ePyUi.PrepareUniformsForImageProcessing);
/**
 * Prepare the list of samplers associated with the Image Processing effects.
 * @param samplersList The list of uniforms used in the effect
 * @param defines the list of defines currently in use
 */ $9f5049d6792e7ced$export$e58d65d302f9b7ec.PrepareSamplers = (0, $ePyUi.PrepareSamplersForImageProcessing);
// Static constants associated to the image processing.
$9f5049d6792e7ced$export$e58d65d302f9b7ec._VIGNETTEMODE_MULTIPLY = 0;
$9f5049d6792e7ced$export$e58d65d302f9b7ec._VIGNETTEMODE_OPAQUE = 1;
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColorCurves)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "colorCurves", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "_colorCurvesEnabled", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)("colorGradingTexture")
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "_colorGradingTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "_colorGradingEnabled", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "_colorGradingWithGreenDepth", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "_colorGradingBGR", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "_exposure", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "_toneMappingEnabled", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "_toneMappingType", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "_contrast", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "vignetteStretch", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "vignetteCenterX", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "vignetteCenterY", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "vignetteWeight", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor4)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "vignetteColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "vignetteCameraFov", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "_vignetteBlendMode", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "_vignetteEnabled", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "_ditheringEnabled", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "_ditheringIntensity", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "_skipFinalColorClamp", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "_applyByPostProcess", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9f5049d6792e7ced$export$e58d65d302f9b7ec.prototype, "_isEnabled", void 0);
// References the dependencies.
(0, $6Ho1L.SerializationHelper)._ImageProcessingConfigurationParser = $9f5049d6792e7ced$export$e58d65d302f9b7ec.Parse;

});
parcelRegister("eVS9r", function(module, exports) {

$parcel$export(module.exports, "ColorCurves", () => $adf064e0a7b4f422$export$d937e9ba5e5dab2f);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $7etnY = parcelRequire("7etnY");

var $6Ho1L = parcelRequire("6Ho1L");

var $k0jl7 = parcelRequire("k0jl7");
class $adf064e0a7b4f422$export$d937e9ba5e5dab2f {
    constructor(){
        this._dirty = true;
        this._tempColor = new (0, $7etnY.Color4)(0, 0, 0, 0);
        this._globalCurve = new (0, $7etnY.Color4)(0, 0, 0, 0);
        this._highlightsCurve = new (0, $7etnY.Color4)(0, 0, 0, 0);
        this._midtonesCurve = new (0, $7etnY.Color4)(0, 0, 0, 0);
        this._shadowsCurve = new (0, $7etnY.Color4)(0, 0, 0, 0);
        this._positiveCurve = new (0, $7etnY.Color4)(0, 0, 0, 0);
        this._negativeCurve = new (0, $7etnY.Color4)(0, 0, 0, 0);
        this._globalHue = 30;
        this._globalDensity = 0;
        this._globalSaturation = 0;
        this._globalExposure = 0;
        this._highlightsHue = 30;
        this._highlightsDensity = 0;
        this._highlightsSaturation = 0;
        this._highlightsExposure = 0;
        this._midtonesHue = 30;
        this._midtonesDensity = 0;
        this._midtonesSaturation = 0;
        this._midtonesExposure = 0;
        this._shadowsHue = 30;
        this._shadowsDensity = 0;
        this._shadowsSaturation = 0;
        this._shadowsExposure = 0;
    }
    /**
     * Gets the global Hue value.
     * The hue value is a standard HSB hue in the range [0,360] where 0=red, 120=green and 240=blue. The default value is 30 degrees (orange).
     */ get globalHue() {
        return this._globalHue;
    }
    /**
     * Sets the global Hue value.
     * The hue value is a standard HSB hue in the range [0,360] where 0=red, 120=green and 240=blue. The default value is 30 degrees (orange).
     */ set globalHue(value) {
        this._globalHue = value;
        this._dirty = true;
    }
    /**
     * Gets the global Density value.
     * The density value is in range [-100,+100] where 0 means the color filter has no effect and +100 means the color filter has maximum effect.
     * Values less than zero provide a filter of opposite hue.
     */ get globalDensity() {
        return this._globalDensity;
    }
    /**
     * Sets the global Density value.
     * The density value is in range [-100,+100] where 0 means the color filter has no effect and +100 means the color filter has maximum effect.
     * Values less than zero provide a filter of opposite hue.
     */ set globalDensity(value) {
        this._globalDensity = value;
        this._dirty = true;
    }
    /**
     * Gets the global Saturation value.
     * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase saturation and negative values decrease saturation.
     */ get globalSaturation() {
        return this._globalSaturation;
    }
    /**
     * Sets the global Saturation value.
     * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase saturation and negative values decrease saturation.
     */ set globalSaturation(value) {
        this._globalSaturation = value;
        this._dirty = true;
    }
    /**
     * Gets the global Exposure value.
     * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase exposure and negative values decrease exposure.
     */ get globalExposure() {
        return this._globalExposure;
    }
    /**
     * Sets the global Exposure value.
     * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase exposure and negative values decrease exposure.
     */ set globalExposure(value) {
        this._globalExposure = value;
        this._dirty = true;
    }
    /**
     * Gets the highlights Hue value.
     * The hue value is a standard HSB hue in the range [0,360] where 0=red, 120=green and 240=blue. The default value is 30 degrees (orange).
     */ get highlightsHue() {
        return this._highlightsHue;
    }
    /**
     * Sets the highlights Hue value.
     * The hue value is a standard HSB hue in the range [0,360] where 0=red, 120=green and 240=blue. The default value is 30 degrees (orange).
     */ set highlightsHue(value) {
        this._highlightsHue = value;
        this._dirty = true;
    }
    /**
     * Gets the highlights Density value.
     * The density value is in range [-100,+100] where 0 means the color filter has no effect and +100 means the color filter has maximum effect.
     * Values less than zero provide a filter of opposite hue.
     */ get highlightsDensity() {
        return this._highlightsDensity;
    }
    /**
     * Sets the highlights Density value.
     * The density value is in range [-100,+100] where 0 means the color filter has no effect and +100 means the color filter has maximum effect.
     * Values less than zero provide a filter of opposite hue.
     */ set highlightsDensity(value) {
        this._highlightsDensity = value;
        this._dirty = true;
    }
    /**
     * Gets the highlights Saturation value.
     * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase saturation and negative values decrease saturation.
     */ get highlightsSaturation() {
        return this._highlightsSaturation;
    }
    /**
     * Sets the highlights Saturation value.
     * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase saturation and negative values decrease saturation.
     */ set highlightsSaturation(value) {
        this._highlightsSaturation = value;
        this._dirty = true;
    }
    /**
     * Gets the highlights Exposure value.
     * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase exposure and negative values decrease exposure.
     */ get highlightsExposure() {
        return this._highlightsExposure;
    }
    /**
     * Sets the highlights Exposure value.
     * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase exposure and negative values decrease exposure.
     */ set highlightsExposure(value) {
        this._highlightsExposure = value;
        this._dirty = true;
    }
    /**
     * Gets the midtones Hue value.
     * The hue value is a standard HSB hue in the range [0,360] where 0=red, 120=green and 240=blue. The default value is 30 degrees (orange).
     */ get midtonesHue() {
        return this._midtonesHue;
    }
    /**
     * Sets the midtones Hue value.
     * The hue value is a standard HSB hue in the range [0,360] where 0=red, 120=green and 240=blue. The default value is 30 degrees (orange).
     */ set midtonesHue(value) {
        this._midtonesHue = value;
        this._dirty = true;
    }
    /**
     * Gets the midtones Density value.
     * The density value is in range [-100,+100] where 0 means the color filter has no effect and +100 means the color filter has maximum effect.
     * Values less than zero provide a filter of opposite hue.
     */ get midtonesDensity() {
        return this._midtonesDensity;
    }
    /**
     * Sets the midtones Density value.
     * The density value is in range [-100,+100] where 0 means the color filter has no effect and +100 means the color filter has maximum effect.
     * Values less than zero provide a filter of opposite hue.
     */ set midtonesDensity(value) {
        this._midtonesDensity = value;
        this._dirty = true;
    }
    /**
     * Gets the midtones Saturation value.
     * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase saturation and negative values decrease saturation.
     */ get midtonesSaturation() {
        return this._midtonesSaturation;
    }
    /**
     * Sets the midtones Saturation value.
     * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase saturation and negative values decrease saturation.
     */ set midtonesSaturation(value) {
        this._midtonesSaturation = value;
        this._dirty = true;
    }
    /**
     * Gets the midtones Exposure value.
     * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase exposure and negative values decrease exposure.
     */ get midtonesExposure() {
        return this._midtonesExposure;
    }
    /**
     * Sets the midtones Exposure value.
     * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase exposure and negative values decrease exposure.
     */ set midtonesExposure(value) {
        this._midtonesExposure = value;
        this._dirty = true;
    }
    /**
     * Gets the shadows Hue value.
     * The hue value is a standard HSB hue in the range [0,360] where 0=red, 120=green and 240=blue. The default value is 30 degrees (orange).
     */ get shadowsHue() {
        return this._shadowsHue;
    }
    /**
     * Sets the shadows Hue value.
     * The hue value is a standard HSB hue in the range [0,360] where 0=red, 120=green and 240=blue. The default value is 30 degrees (orange).
     */ set shadowsHue(value) {
        this._shadowsHue = value;
        this._dirty = true;
    }
    /**
     * Gets the shadows Density value.
     * The density value is in range [-100,+100] where 0 means the color filter has no effect and +100 means the color filter has maximum effect.
     * Values less than zero provide a filter of opposite hue.
     */ get shadowsDensity() {
        return this._shadowsDensity;
    }
    /**
     * Sets the shadows Density value.
     * The density value is in range [-100,+100] where 0 means the color filter has no effect and +100 means the color filter has maximum effect.
     * Values less than zero provide a filter of opposite hue.
     */ set shadowsDensity(value) {
        this._shadowsDensity = value;
        this._dirty = true;
    }
    /**
     * Gets the shadows Saturation value.
     * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase saturation and negative values decrease saturation.
     */ get shadowsSaturation() {
        return this._shadowsSaturation;
    }
    /**
     * Sets the shadows Saturation value.
     * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase saturation and negative values decrease saturation.
     */ set shadowsSaturation(value) {
        this._shadowsSaturation = value;
        this._dirty = true;
    }
    /**
     * Gets the shadows Exposure value.
     * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase exposure and negative values decrease exposure.
     */ get shadowsExposure() {
        return this._shadowsExposure;
    }
    /**
     * Sets the shadows Exposure value.
     * This is an adjustment value in the range [-100,+100], where the default value of 0.0 makes no adjustment, positive values increase exposure and negative values decrease exposure.
     */ set shadowsExposure(value) {
        this._shadowsExposure = value;
        this._dirty = true;
    }
    /**
     * Returns the class name
     * @returns The class name
     */ getClassName() {
        return "ColorCurves";
    }
    /**
     * Binds the color curves to the shader.
     * @param colorCurves The color curve to bind
     * @param effect The effect to bind to
     * @param positiveUniform The positive uniform shader parameter
     * @param neutralUniform The neutral uniform shader parameter
     * @param negativeUniform The negative uniform shader parameter
     */ static Bind(colorCurves, effect, positiveUniform = "vCameraColorCurvePositive", neutralUniform = "vCameraColorCurveNeutral", negativeUniform = "vCameraColorCurveNegative") {
        if (colorCurves._dirty) {
            colorCurves._dirty = false;
            // Fill in global info.
            colorCurves._getColorGradingDataToRef(colorCurves._globalHue, colorCurves._globalDensity, colorCurves._globalSaturation, colorCurves._globalExposure, colorCurves._globalCurve);
            // Compute highlights info.
            colorCurves._getColorGradingDataToRef(colorCurves._highlightsHue, colorCurves._highlightsDensity, colorCurves._highlightsSaturation, colorCurves._highlightsExposure, colorCurves._tempColor);
            colorCurves._tempColor.multiplyToRef(colorCurves._globalCurve, colorCurves._highlightsCurve);
            // Compute midtones info.
            colorCurves._getColorGradingDataToRef(colorCurves._midtonesHue, colorCurves._midtonesDensity, colorCurves._midtonesSaturation, colorCurves._midtonesExposure, colorCurves._tempColor);
            colorCurves._tempColor.multiplyToRef(colorCurves._globalCurve, colorCurves._midtonesCurve);
            // Compute shadows info.
            colorCurves._getColorGradingDataToRef(colorCurves._shadowsHue, colorCurves._shadowsDensity, colorCurves._shadowsSaturation, colorCurves._shadowsExposure, colorCurves._tempColor);
            colorCurves._tempColor.multiplyToRef(colorCurves._globalCurve, colorCurves._shadowsCurve);
            // Compute deltas (neutral is midtones).
            colorCurves._highlightsCurve.subtractToRef(colorCurves._midtonesCurve, colorCurves._positiveCurve);
            colorCurves._midtonesCurve.subtractToRef(colorCurves._shadowsCurve, colorCurves._negativeCurve);
        }
        if (effect) {
            effect.setFloat4(positiveUniform, colorCurves._positiveCurve.r, colorCurves._positiveCurve.g, colorCurves._positiveCurve.b, colorCurves._positiveCurve.a);
            effect.setFloat4(neutralUniform, colorCurves._midtonesCurve.r, colorCurves._midtonesCurve.g, colorCurves._midtonesCurve.b, colorCurves._midtonesCurve.a);
            effect.setFloat4(negativeUniform, colorCurves._negativeCurve.r, colorCurves._negativeCurve.g, colorCurves._negativeCurve.b, colorCurves._negativeCurve.a);
        }
    }
    /**
     * Returns color grading data based on a hue, density, saturation and exposure value.
     * @param hue
     * @param density
     * @param saturation The saturation.
     * @param exposure The exposure.
     * @param result The result data container.
     */ _getColorGradingDataToRef(hue, density, saturation, exposure, result) {
        if (hue == null) return;
        hue = $adf064e0a7b4f422$export$d937e9ba5e5dab2f._Clamp(hue, 0, 360);
        density = $adf064e0a7b4f422$export$d937e9ba5e5dab2f._Clamp(density, -100, 100);
        saturation = $adf064e0a7b4f422$export$d937e9ba5e5dab2f._Clamp(saturation, -100, 100);
        exposure = $adf064e0a7b4f422$export$d937e9ba5e5dab2f._Clamp(exposure, -100, 100);
        // Remap the slider/config filter density with non-linear mapping and also scale by half
        // so that the maximum filter density is only 50% control. This provides fine control
        // for small values and reasonable range.
        density = $adf064e0a7b4f422$export$d937e9ba5e5dab2f._ApplyColorGradingSliderNonlinear(density);
        density *= 0.5;
        exposure = $adf064e0a7b4f422$export$d937e9ba5e5dab2f._ApplyColorGradingSliderNonlinear(exposure);
        if (density < 0) {
            density *= -1;
            hue = (hue + 180) % 360;
        }
        $adf064e0a7b4f422$export$d937e9ba5e5dab2f._FromHSBToRef(hue, density, 50 + 0.25 * exposure, result);
        result.scaleToRef(2, result);
        result.a = 1 + 0.01 * saturation;
    }
    /**
     * Takes an input slider value and returns an adjusted value that provides extra control near the centre.
     * @param value The input slider value in range [-100,100].
     * @returns Adjusted value.
     */ static _ApplyColorGradingSliderNonlinear(value) {
        value /= 100;
        let x = Math.abs(value);
        x = Math.pow(x, 2);
        if (value < 0) x *= -1;
        x *= 100;
        return x;
    }
    /**
     * Returns an RGBA Color4 based on Hue, Saturation and Brightness (also referred to as value, HSV).
     * @param hue The hue (H) input.
     * @param saturation The saturation (S) input.
     * @param brightness The brightness (B) input.
     * @param result
     * @result An RGBA color represented as Vector4.
     */ static _FromHSBToRef(hue, saturation, brightness, result) {
        let h = $adf064e0a7b4f422$export$d937e9ba5e5dab2f._Clamp(hue, 0, 360);
        const s = $adf064e0a7b4f422$export$d937e9ba5e5dab2f._Clamp(saturation / 100, 0, 1);
        const v = $adf064e0a7b4f422$export$d937e9ba5e5dab2f._Clamp(brightness / 100, 0, 1);
        if (s === 0) {
            result.r = v;
            result.g = v;
            result.b = v;
        } else {
            // sector 0 to 5
            h /= 60;
            const i = Math.floor(h);
            // fractional part of h
            const f = h - i;
            const p = v * (1 - s);
            const q = v * (1 - s * f);
            const t = v * (1 - s * (1 - f));
            switch(i){
                case 0:
                    result.r = v;
                    result.g = t;
                    result.b = p;
                    break;
                case 1:
                    result.r = q;
                    result.g = v;
                    result.b = p;
                    break;
                case 2:
                    result.r = p;
                    result.g = v;
                    result.b = t;
                    break;
                case 3:
                    result.r = p;
                    result.g = q;
                    result.b = v;
                    break;
                case 4:
                    result.r = t;
                    result.g = p;
                    result.b = v;
                    break;
                default:
                    // case 5:
                    result.r = v;
                    result.g = p;
                    result.b = q;
                    break;
            }
        }
        result.a = 1;
    }
    /**
     * Returns a value clamped between min and max
     * @param value The value to clamp
     * @param min The minimum of value
     * @param max The maximum of value
     * @returns The clamped value.
     */ static _Clamp(value, min, max) {
        return Math.min(Math.max(value, min), max);
    }
    /**
     * Clones the current color curve instance.
     * @returns The cloned curves
     */ clone() {
        return (0, $6Ho1L.SerializationHelper).Clone(()=>new $adf064e0a7b4f422$export$d937e9ba5e5dab2f(), this);
    }
    /**
     * Serializes the current color curve instance to a json representation.
     * @returns a JSON representation
     */ serialize() {
        return (0, $6Ho1L.SerializationHelper).Serialize(this);
    }
    /**
     * Parses the color curve from a json representation.
     * @param source the JSON source to parse
     * @returns The parsed curves
     */ static Parse(source) {
        return (0, $6Ho1L.SerializationHelper).Parse(()=>new $adf064e0a7b4f422$export$d937e9ba5e5dab2f(), source, null, null);
    }
}
/**
 * Prepare the list of uniforms associated with the ColorCurves effects.
 * @param uniformsList The list of uniforms used in the effect
 */ $adf064e0a7b4f422$export$d937e9ba5e5dab2f.PrepareUniforms = (0, $k0jl7.PrepareUniformsForColorCurves);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $adf064e0a7b4f422$export$d937e9ba5e5dab2f.prototype, "_globalHue", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $adf064e0a7b4f422$export$d937e9ba5e5dab2f.prototype, "_globalDensity", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $adf064e0a7b4f422$export$d937e9ba5e5dab2f.prototype, "_globalSaturation", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $adf064e0a7b4f422$export$d937e9ba5e5dab2f.prototype, "_globalExposure", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $adf064e0a7b4f422$export$d937e9ba5e5dab2f.prototype, "_highlightsHue", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $adf064e0a7b4f422$export$d937e9ba5e5dab2f.prototype, "_highlightsDensity", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $adf064e0a7b4f422$export$d937e9ba5e5dab2f.prototype, "_highlightsSaturation", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $adf064e0a7b4f422$export$d937e9ba5e5dab2f.prototype, "_highlightsExposure", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $adf064e0a7b4f422$export$d937e9ba5e5dab2f.prototype, "_midtonesHue", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $adf064e0a7b4f422$export$d937e9ba5e5dab2f.prototype, "_midtonesDensity", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $adf064e0a7b4f422$export$d937e9ba5e5dab2f.prototype, "_midtonesSaturation", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $adf064e0a7b4f422$export$d937e9ba5e5dab2f.prototype, "_midtonesExposure", void 0);
// References the dependencies.
(0, $6Ho1L.SerializationHelper)._ColorCurvesParser = $adf064e0a7b4f422$export$d937e9ba5e5dab2f.Parse;

});
parcelRegister("k0jl7", function(module, exports) {

$parcel$export(module.exports, "PrepareUniformsForColorCurves", () => $e902cf2db572083d$export$e4309b6d5d5a2775);
/**
 * Prepare the list of uniforms associated with the ColorCurves effects.
 * @param uniformsList The list of uniforms used in the effect
 */ function $e902cf2db572083d$export$e4309b6d5d5a2775(uniformsList) {
    uniformsList.push("vCameraColorCurveNeutral", "vCameraColorCurvePositive", "vCameraColorCurveNegative");
}

});


parcelRegister("ePyUi", function(module, exports) {

$parcel$export(module.exports, "PrepareUniformsForImageProcessing", () => $acc0e7edf62b6ca4$export$15e1616224800f0e);
$parcel$export(module.exports, "PrepareSamplersForImageProcessing", () => $acc0e7edf62b6ca4$export$c032d5c993ceb4aa);

var $k0jl7 = parcelRequire("k0jl7");
function $acc0e7edf62b6ca4$export$15e1616224800f0e(uniforms, defines) {
    if (defines.EXPOSURE) uniforms.push("exposureLinear");
    if (defines.CONTRAST) uniforms.push("contrast");
    if (defines.COLORGRADING) uniforms.push("colorTransformSettings");
    if (defines.VIGNETTE || defines.DITHER) uniforms.push("vInverseScreenSize");
    if (defines.VIGNETTE) {
        uniforms.push("vignetteSettings1");
        uniforms.push("vignetteSettings2");
    }
    if (defines.COLORCURVES) (0, $k0jl7.PrepareUniformsForColorCurves)(uniforms);
    if (defines.DITHER) uniforms.push("ditherIntensity");
}
function $acc0e7edf62b6ca4$export$c032d5c993ceb4aa(samplersList, defines) {
    if (defines.COLORGRADING) samplersList.push("txColorTransform");
}

});


parcelRegister("ghoTi", function(module, exports) {

$parcel$export(module.exports, "UniformBuffer", () => $bda18ab409280b95$export$e0b4e5723e07d1e5);

var $kVtWi = parcelRequire("kVtWi");

var $bOhSV = parcelRequire("bOhSV");
parcelRequire("jo5qL");
class $bda18ab409280b95$export$e0b4e5723e07d1e5 {
    /**
     * Instantiates a new Uniform buffer objects.
     *
     * Handles blocks of uniform on the GPU.
     *
     * If WebGL 2 is not available, this class falls back on traditional setUniformXXX calls.
     *
     * For more information, please refer to :
     * @see https://www.khronos.org/opengl/wiki/Uniform_Buffer_Object
     * @param engine Define the engine the buffer is associated with
     * @param data Define the data contained in the buffer
     * @param dynamic Define if the buffer is updatable
     * @param name to assign to the buffer (debugging purpose)
     * @param forceNoUniformBuffer define that this object must not rely on UBO objects
     */ constructor(engine, data, dynamic, name, forceNoUniformBuffer = false){
        // Matrix cache
        this._valueCache = {};
        this._engine = engine;
        this._noUBO = !engine.supportsUniformBuffers || forceNoUniformBuffer;
        this._dynamic = dynamic;
        this._name = name ?? "no-name";
        this._data = data || [];
        this._uniformLocations = {};
        this._uniformSizes = {};
        this._uniformArraySizes = {};
        this._uniformLocationPointer = 0;
        this._needSync = false;
        if (this._engine._features.trackUbosInFrame) {
            this._buffers = [];
            this._bufferIndex = -1;
            this._createBufferOnWrite = false;
            this._currentFrameId = 0;
        }
        if (this._noUBO) {
            this.updateMatrix3x3 = this._updateMatrix3x3ForEffect;
            this.updateMatrix2x2 = this._updateMatrix2x2ForEffect;
            this.updateFloat = this._updateFloatForEffect;
            this.updateFloat2 = this._updateFloat2ForEffect;
            this.updateFloat3 = this._updateFloat3ForEffect;
            this.updateFloat4 = this._updateFloat4ForEffect;
            this.updateFloatArray = this._updateFloatArrayForEffect;
            this.updateArray = this._updateArrayForEffect;
            this.updateIntArray = this._updateIntArrayForEffect;
            this.updateUIntArray = this._updateUIntArrayForEffect;
            this.updateMatrix = this._updateMatrixForEffect;
            this.updateMatrices = this._updateMatricesForEffect;
            this.updateVector3 = this._updateVector3ForEffect;
            this.updateVector4 = this._updateVector4ForEffect;
            this.updateColor3 = this._updateColor3ForEffect;
            this.updateColor4 = this._updateColor4ForEffect;
            this.updateDirectColor4 = this._updateDirectColor4ForEffect;
            this.updateInt = this._updateIntForEffect;
            this.updateInt2 = this._updateInt2ForEffect;
            this.updateInt3 = this._updateInt3ForEffect;
            this.updateInt4 = this._updateInt4ForEffect;
            this.updateUInt = this._updateUIntForEffect;
            this.updateUInt2 = this._updateUInt2ForEffect;
            this.updateUInt3 = this._updateUInt3ForEffect;
            this.updateUInt4 = this._updateUInt4ForEffect;
        } else {
            this._engine._uniformBuffers.push(this);
            this.updateMatrix3x3 = this._updateMatrix3x3ForUniform;
            this.updateMatrix2x2 = this._updateMatrix2x2ForUniform;
            this.updateFloat = this._updateFloatForUniform;
            this.updateFloat2 = this._updateFloat2ForUniform;
            this.updateFloat3 = this._updateFloat3ForUniform;
            this.updateFloat4 = this._updateFloat4ForUniform;
            this.updateFloatArray = this._updateFloatArrayForUniform;
            this.updateArray = this._updateArrayForUniform;
            this.updateIntArray = this._updateIntArrayForUniform;
            this.updateUIntArray = this._updateUIntArrayForUniform;
            this.updateMatrix = this._updateMatrixForUniform;
            this.updateMatrices = this._updateMatricesForUniform;
            this.updateVector3 = this._updateVector3ForUniform;
            this.updateVector4 = this._updateVector4ForUniform;
            this.updateColor3 = this._updateColor3ForUniform;
            this.updateColor4 = this._updateColor4ForUniform;
            this.updateDirectColor4 = this._updateDirectColor4ForUniform;
            this.updateInt = this._updateIntForUniform;
            this.updateInt2 = this._updateInt2ForUniform;
            this.updateInt3 = this._updateInt3ForUniform;
            this.updateInt4 = this._updateInt4ForUniform;
            this.updateUInt = this._updateUIntForUniform;
            this.updateUInt2 = this._updateUInt2ForUniform;
            this.updateUInt3 = this._updateUInt3ForUniform;
            this.updateUInt4 = this._updateUInt4ForUniform;
        }
    }
    /**
     * Indicates if the buffer is using the WebGL2 UBO implementation,
     * or just falling back on setUniformXXX calls.
     */ get useUbo() {
        return !this._noUBO;
    }
    /**
     * Indicates if the WebGL underlying uniform buffer is in sync
     * with the javascript cache data.
     */ get isSync() {
        return !this._needSync;
    }
    /**
     * Indicates if the WebGL underlying uniform buffer is dynamic.
     * Also, a dynamic UniformBuffer will disable cache verification and always
     * update the underlying WebGL uniform buffer to the GPU.
     * @returns if Dynamic, otherwise false
     */ isDynamic() {
        return this._dynamic !== undefined;
    }
    /**
     * The data cache on JS side.
     * @returns the underlying data as a float array
     */ getData() {
        return this._bufferData;
    }
    /**
     * The underlying WebGL Uniform buffer.
     * @returns the webgl buffer
     */ getBuffer() {
        return this._buffer;
    }
    /**
     * std140 layout specifies how to align data within an UBO structure.
     * See https://khronos.org/registry/OpenGL/specs/gl/glspec45.core.pdf#page=159
     * for specs.
     * @param size
     */ _fillAlignment(size) {
        // This code has been simplified because we only use floats, vectors of 1, 2, 3, 4 components
        // and 4x4 matrices
        // TODO : change if other types are used
        let alignment;
        if (size <= 2) alignment = size;
        else alignment = 4;
        if (this._uniformLocationPointer % alignment !== 0) {
            const oldPointer = this._uniformLocationPointer;
            this._uniformLocationPointer += alignment - this._uniformLocationPointer % alignment;
            const diff = this._uniformLocationPointer - oldPointer;
            for(let i = 0; i < diff; i++)this._data.push(0);
        }
    }
    /**
     * Adds an uniform in the buffer.
     * Warning : the subsequents calls of this function must be in the same order as declared in the shader
     * for the layout to be correct ! The addUniform function only handles types like float, vec2, vec3, vec4, mat4,
     * meaning size=1,2,3,4 or 16. It does not handle struct types.
     * @param name Name of the uniform, as used in the uniform block in the shader.
     * @param size Data size, or data directly.
     * @param arraySize The number of elements in the array, 0 if not an array.
     */ addUniform(name, size, arraySize = 0) {
        if (this._noUBO) return;
        if (this._uniformLocations[name] !== undefined) // Already existing uniform
        return;
        // This function must be called in the order of the shader layout !
        // size can be the size of the uniform, or data directly
        let data;
        // std140 FTW...
        if (arraySize > 0) {
            if (size instanceof Array) // eslint-disable-next-line no-throw-literal
            throw "addUniform should not be use with Array in UBO: " + name;
            this._fillAlignment(4);
            this._uniformArraySizes[name] = {
                strideSize: size,
                arraySize: arraySize
            };
            if (size == 16) size = size * arraySize;
            else {
                const perElementPadding = 4 - size;
                const totalPadding = perElementPadding * arraySize;
                size = size * arraySize + totalPadding;
            }
            data = [];
            // Fill with zeros
            for(let i = 0; i < size; i++)data.push(0);
        } else {
            if (size instanceof Array) {
                data = size;
                size = data.length;
            } else {
                size;
                data = [];
                // Fill with zeros
                for(let i = 0; i < size; i++)data.push(0);
            }
            this._fillAlignment(size);
        }
        this._uniformSizes[name] = size;
        this._uniformLocations[name] = this._uniformLocationPointer;
        this._uniformLocationPointer += size;
        for(let i = 0; i < size; i++)this._data.push(data[i]);
        this._needSync = true;
    }
    /**
     * Adds a Matrix 4x4 to the uniform buffer.
     * @param name Name of the uniform, as used in the uniform block in the shader.
     * @param mat A 4x4 matrix.
     */ addMatrix(name, mat) {
        this.addUniform(name, Array.prototype.slice.call(mat.asArray()));
    }
    /**
     * Adds a vec2 to the uniform buffer.
     * @param name Name of the uniform, as used in the uniform block in the shader.
     * @param x Define the x component value of the vec2
     * @param y Define the y component value of the vec2
     */ addFloat2(name, x, y) {
        const temp = [
            x,
            y
        ];
        this.addUniform(name, temp);
    }
    /**
     * Adds a vec3 to the uniform buffer.
     * @param name Name of the uniform, as used in the uniform block in the shader.
     * @param x Define the x component value of the vec3
     * @param y Define the y component value of the vec3
     * @param z Define the z component value of the vec3
     */ addFloat3(name, x, y, z) {
        const temp = [
            x,
            y,
            z
        ];
        this.addUniform(name, temp);
    }
    /**
     * Adds a vec3 to the uniform buffer.
     * @param name Name of the uniform, as used in the uniform block in the shader.
     * @param color Define the vec3 from a Color
     */ addColor3(name, color) {
        const temp = [
            color.r,
            color.g,
            color.b
        ];
        this.addUniform(name, temp);
    }
    /**
     * Adds a vec4 to the uniform buffer.
     * @param name Name of the uniform, as used in the uniform block in the shader.
     * @param color Define the rgb components from a Color
     * @param alpha Define the a component of the vec4
     */ addColor4(name, color, alpha) {
        const temp = [
            color.r,
            color.g,
            color.b,
            alpha
        ];
        this.addUniform(name, temp);
    }
    /**
     * Adds a vec3 to the uniform buffer.
     * @param name Name of the uniform, as used in the uniform block in the shader.
     * @param vector Define the vec3 components from a Vector
     */ addVector3(name, vector) {
        const temp = [
            vector.x,
            vector.y,
            vector.z
        ];
        this.addUniform(name, temp);
    }
    /**
     * Adds a Matrix 3x3 to the uniform buffer.
     * @param name Name of the uniform, as used in the uniform block in the shader.
     */ addMatrix3x3(name) {
        this.addUniform(name, 12);
    }
    /**
     * Adds a Matrix 2x2 to the uniform buffer.
     * @param name Name of the uniform, as used in the uniform block in the shader.
     */ addMatrix2x2(name) {
        this.addUniform(name, 8);
    }
    /**
     * Effectively creates the WebGL Uniform Buffer, once layout is completed with `addUniform`.
     */ create() {
        if (this._noUBO) return;
        if (this._buffer) return; // nothing to do
        // See spec, alignment must be filled as a vec4
        this._fillAlignment(4);
        this._bufferData = new Float32Array(this._data);
        this._rebuild();
        this._needSync = true;
    }
    // The result of this method is used for debugging purpose, as part of the buffer name
    // It is meant to more easily know what this buffer is about when debugging
    // Some buffers can have a lot of uniforms (several dozens), so the method only returns the first 10 of them
    // (should be enough to understand what the buffer is for)
    _getNames() {
        const names = [];
        let i = 0;
        for(const name in this._uniformLocations){
            names.push(name);
            if (++i === 10) break;
        }
        return names.join(",");
    }
    /** @internal */ _rebuild() {
        if (this._noUBO || !this._bufferData) return;
        if (this._dynamic) this._buffer = this._engine.createDynamicUniformBuffer(this._bufferData, this._name + "_UniformList:" + this._getNames());
        else this._buffer = this._engine.createUniformBuffer(this._bufferData, this._name + "_UniformList:" + this._getNames());
        if (this._engine._features.trackUbosInFrame) {
            this._buffers.push([
                this._buffer,
                this._engine._features.checkUbosContentBeforeUpload ? this._bufferData.slice() : undefined
            ]);
            this._bufferIndex = this._buffers.length - 1;
            this._createBufferOnWrite = false;
        }
    }
    /** @internal */ _rebuildAfterContextLost() {
        if (this._engine._features.trackUbosInFrame) {
            this._buffers = [];
            this._currentFrameId = 0;
        }
        this._rebuild();
    }
    /** @internal */ get _numBuffers() {
        return this._buffers.length;
    }
    /** @internal */ get _indexBuffer() {
        return this._bufferIndex;
    }
    /** Gets the name of this buffer */ get name() {
        return this._name;
    }
    /** Gets the current effect */ get currentEffect() {
        return this._currentEffect;
    }
    _buffersEqual(buf1, buf2) {
        for(let i = 0; i < buf1.length; ++i){
            if (buf1[i] !== buf2[i]) return false;
        }
        return true;
    }
    _copyBuffer(src, dst) {
        for(let i = 0; i < src.length; ++i)dst[i] = src[i];
    }
    /**
     * Updates the WebGL Uniform Buffer on the GPU.
     * If the `dynamic` flag is set to true, no cache comparison is done.
     * Otherwise, the buffer will be updated only if the cache differs.
     */ update() {
        if (this._noUBO) return;
        this.bindUniformBuffer();
        if (!this._buffer) {
            this.create();
            return;
        }
        if (!this._dynamic && !this._needSync) {
            this._createBufferOnWrite = this._engine._features.trackUbosInFrame;
            return;
        }
        if (this._buffers && this._buffers.length > 1 && this._buffers[this._bufferIndex][1]) {
            if (this._buffersEqual(this._bufferData, this._buffers[this._bufferIndex][1])) {
                this._needSync = false;
                this._createBufferOnWrite = this._engine._features.trackUbosInFrame;
                return;
            } else this._copyBuffer(this._bufferData, this._buffers[this._bufferIndex][1]);
        }
        this._engine.updateUniformBuffer(this._buffer, this._bufferData);
        if (this._engine._features._collectUbosUpdatedInFrame) {
            if (!$bda18ab409280b95$export$e0b4e5723e07d1e5._UpdatedUbosInFrame[this._name]) $bda18ab409280b95$export$e0b4e5723e07d1e5._UpdatedUbosInFrame[this._name] = 0;
            $bda18ab409280b95$export$e0b4e5723e07d1e5._UpdatedUbosInFrame[this._name]++;
        }
        this._needSync = false;
        this._createBufferOnWrite = this._engine._features.trackUbosInFrame;
    }
    _createNewBuffer() {
        if (this._bufferIndex + 1 < this._buffers.length) {
            this._bufferIndex++;
            this._buffer = this._buffers[this._bufferIndex][0];
            this._createBufferOnWrite = false;
            this._needSync = true;
        } else this._rebuild();
    }
    _checkNewFrame() {
        if (this._engine._features.trackUbosInFrame && this._currentFrameId !== this._engine.frameId) {
            this._currentFrameId = this._engine.frameId;
            this._createBufferOnWrite = false;
            if (this._buffers && this._buffers.length > 0) {
                this._needSync = this._bufferIndex !== 0;
                this._bufferIndex = 0;
                this._buffer = this._buffers[this._bufferIndex][0];
            } else this._bufferIndex = -1;
        }
    }
    /**
     * Updates the value of an uniform. The `update` method must be called afterwards to make it effective in the GPU.
     * @param uniformName Define the name of the uniform, as used in the uniform block in the shader.
     * @param data Define the flattened data
     * @param size Define the size of the data.
     */ updateUniform(uniformName, data, size) {
        this._checkNewFrame();
        let location = this._uniformLocations[uniformName];
        if (location === undefined) {
            if (this._buffer) {
                // Cannot add an uniform if the buffer is already created
                (0, $kVtWi.Logger).Error("Cannot add an uniform after UBO has been created. uniformName=" + uniformName);
                return;
            }
            this.addUniform(uniformName, size);
            location = this._uniformLocations[uniformName];
        }
        if (!this._buffer) this.create();
        if (!this._dynamic) {
            // Cache for static uniform buffers
            let changed = false;
            for(let i = 0; i < size; i++)// We are checking the matrix cache before calling updateUniform so we do not need to check it here
            // Hence the test for size === 16 to simply commit the matrix values
            if (size === 16 && !this._engine._features.uniformBufferHardCheckMatrix || this._bufferData[location + i] !== Math.fround(data[i])) {
                changed = true;
                if (this._createBufferOnWrite) this._createNewBuffer();
                this._bufferData[location + i] = data[i];
            }
            this._needSync = this._needSync || changed;
        } else // No cache for dynamic
        for(let i = 0; i < size; i++)this._bufferData[location + i] = data[i];
    }
    /**
     * Updates the value of an uniform. The `update` method must be called afterwards to make it effective in the GPU.
     * @param uniformName Define the name of the uniform, as used in the uniform block in the shader.
     * @param data Define the flattened data
     * @param size Define the size of the data.
     */ updateUniformArray(uniformName, data, size) {
        this._checkNewFrame();
        const location = this._uniformLocations[uniformName];
        if (location === undefined) {
            (0, $kVtWi.Logger).Error("Cannot add an uniform Array dynamically. Please, add it using addUniform and make sure that uniform buffers are supported by the current engine.");
            return;
        }
        if (!this._buffer) this.create();
        const arraySizes = this._uniformArraySizes[uniformName];
        if (!this._dynamic) {
            // Cache for static uniform buffers
            let changed = false;
            let countToFour = 0;
            let baseStride = 0;
            for(let i = 0; i < size; i++){
                if (this._bufferData[location + baseStride * 4 + countToFour] !== (0, $bOhSV.Tools).FloatRound(data[i])) {
                    changed = true;
                    if (this._createBufferOnWrite) this._createNewBuffer();
                    this._bufferData[location + baseStride * 4 + countToFour] = data[i];
                }
                countToFour++;
                if (countToFour === arraySizes.strideSize) {
                    for(; countToFour < 4; countToFour++)this._bufferData[location + baseStride * 4 + countToFour] = 0;
                    countToFour = 0;
                    baseStride++;
                }
            }
            this._needSync = this._needSync || changed;
        } else // No cache for dynamic
        for(let i = 0; i < size; i++)this._bufferData[location + i] = data[i];
    }
    _cacheMatrix(name, matrix) {
        this._checkNewFrame();
        const cache = this._valueCache[name];
        const flag = matrix.updateFlag;
        if (cache !== undefined && cache === flag) return false;
        this._valueCache[name] = flag;
        return true;
    }
    // Update methods
    _updateMatrix3x3ForUniform(name, matrix) {
        // To match std140, matrix must be realigned
        for(let i = 0; i < 3; i++){
            $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[i * 4] = matrix[i * 3];
            $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[i * 4 + 1] = matrix[i * 3 + 1];
            $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[i * 4 + 2] = matrix[i * 3 + 2];
            $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[i * 4 + 3] = 0.0;
        }
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 12);
    }
    _updateMatrix3x3ForEffect(name, matrix) {
        this._currentEffect.setMatrix3x3(name, matrix);
    }
    _updateMatrix2x2ForEffect(name, matrix) {
        this._currentEffect.setMatrix2x2(name, matrix);
    }
    _updateMatrix2x2ForUniform(name, matrix) {
        // To match std140, matrix must be realigned
        for(let i = 0; i < 2; i++){
            $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[i * 4] = matrix[i * 2];
            $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[i * 4 + 1] = matrix[i * 2 + 1];
            $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[i * 4 + 2] = 0.0;
            $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[i * 4 + 3] = 0.0;
        }
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 8);
    }
    _updateFloatForEffect(name, x) {
        this._currentEffect.setFloat(name, x);
    }
    _updateFloatForUniform(name, x) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[0] = x;
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 1);
    }
    _updateFloat2ForEffect(name, x, y, suffix = "") {
        this._currentEffect.setFloat2(name + suffix, x, y);
    }
    _updateFloat2ForUniform(name, x, y) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[0] = x;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[1] = y;
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 2);
    }
    _updateFloat3ForEffect(name, x, y, z, suffix = "") {
        this._currentEffect.setFloat3(name + suffix, x, y, z);
    }
    _updateFloat3ForUniform(name, x, y, z) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[0] = x;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[1] = y;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[2] = z;
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 3);
    }
    _updateFloat4ForEffect(name, x, y, z, w, suffix = "") {
        this._currentEffect.setFloat4(name + suffix, x, y, z, w);
    }
    _updateFloat4ForUniform(name, x, y, z, w) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[0] = x;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[1] = y;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[2] = z;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[3] = w;
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 4);
    }
    _updateFloatArrayForEffect(name, array) {
        this._currentEffect.setFloatArray(name, array);
    }
    _updateFloatArrayForUniform(name, array) {
        this.updateUniformArray(name, array, array.length);
    }
    _updateArrayForEffect(name, array) {
        this._currentEffect.setArray(name, array);
    }
    _updateArrayForUniform(name, array) {
        this.updateUniformArray(name, array, array.length);
    }
    _updateIntArrayForEffect(name, array) {
        this._currentEffect.setIntArray(name, array);
    }
    _updateIntArrayForUniform(name, array) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferInt32View.set(array);
        this.updateUniformArray(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, array.length);
    }
    _updateUIntArrayForEffect(name, array) {
        this._currentEffect.setUIntArray(name, array);
    }
    _updateUIntArrayForUniform(name, array) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferUInt32View.set(array);
        this.updateUniformArray(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, array.length);
    }
    _updateMatrixForEffect(name, mat) {
        this._currentEffect.setMatrix(name, mat);
    }
    _updateMatrixForUniform(name, mat) {
        if (this._cacheMatrix(name, mat)) this.updateUniform(name, mat.asArray(), 16);
    }
    _updateMatricesForEffect(name, mat) {
        this._currentEffect.setMatrices(name, mat);
    }
    _updateMatricesForUniform(name, mat) {
        this.updateUniform(name, mat, mat.length);
    }
    _updateVector3ForEffect(name, vector) {
        this._currentEffect.setVector3(name, vector);
    }
    _updateVector3ForUniform(name, vector) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[0] = vector.x;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[1] = vector.y;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[2] = vector.z;
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 3);
    }
    _updateVector4ForEffect(name, vector) {
        this._currentEffect.setVector4(name, vector);
    }
    _updateVector4ForUniform(name, vector) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[0] = vector.x;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[1] = vector.y;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[2] = vector.z;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[3] = vector.w;
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 4);
    }
    _updateColor3ForEffect(name, color, suffix = "") {
        this._currentEffect.setColor3(name + suffix, color);
    }
    _updateColor3ForUniform(name, color) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[0] = color.r;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[1] = color.g;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[2] = color.b;
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 3);
    }
    _updateColor4ForEffect(name, color, alpha, suffix = "") {
        this._currentEffect.setColor4(name + suffix, color, alpha);
    }
    _updateDirectColor4ForEffect(name, color, suffix = "") {
        this._currentEffect.setDirectColor4(name + suffix, color);
    }
    _updateColor4ForUniform(name, color, alpha) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[0] = color.r;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[1] = color.g;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[2] = color.b;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[3] = alpha;
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 4);
    }
    _updateDirectColor4ForUniform(name, color) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[0] = color.r;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[1] = color.g;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[2] = color.b;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer[3] = color.a;
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 4);
    }
    _updateIntForEffect(name, x, suffix = "") {
        this._currentEffect.setInt(name + suffix, x);
    }
    _updateIntForUniform(name, x) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferInt32View[0] = x;
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 1);
    }
    _updateInt2ForEffect(name, x, y, suffix = "") {
        this._currentEffect.setInt2(name + suffix, x, y);
    }
    _updateInt2ForUniform(name, x, y) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferInt32View[0] = x;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferInt32View[1] = y;
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 2);
    }
    _updateInt3ForEffect(name, x, y, z, suffix = "") {
        this._currentEffect.setInt3(name + suffix, x, y, z);
    }
    _updateInt3ForUniform(name, x, y, z) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferInt32View[0] = x;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferInt32View[1] = y;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferInt32View[2] = z;
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 3);
    }
    _updateInt4ForEffect(name, x, y, z, w, suffix = "") {
        this._currentEffect.setInt4(name + suffix, x, y, z, w);
    }
    _updateInt4ForUniform(name, x, y, z, w) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferInt32View[0] = x;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferInt32View[1] = y;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferInt32View[2] = z;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferInt32View[3] = w;
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 4);
    }
    _updateUIntForEffect(name, x, suffix = "") {
        this._currentEffect.setUInt(name + suffix, x);
    }
    _updateUIntForUniform(name, x) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferUInt32View[0] = x;
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 1);
    }
    _updateUInt2ForEffect(name, x, y, suffix = "") {
        this._currentEffect.setUInt2(name + suffix, x, y);
    }
    _updateUInt2ForUniform(name, x, y) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferUInt32View[0] = x;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferUInt32View[1] = y;
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 2);
    }
    _updateUInt3ForEffect(name, x, y, z, suffix = "") {
        this._currentEffect.setUInt3(name + suffix, x, y, z);
    }
    _updateUInt3ForUniform(name, x, y, z) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferUInt32View[0] = x;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferUInt32View[1] = y;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferUInt32View[2] = z;
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 3);
    }
    _updateUInt4ForEffect(name, x, y, z, w, suffix = "") {
        this._currentEffect.setUInt4(name + suffix, x, y, z, w);
    }
    _updateUInt4ForUniform(name, x, y, z, w) {
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferUInt32View[0] = x;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferUInt32View[1] = y;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferUInt32View[2] = z;
        $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferUInt32View[3] = w;
        this.updateUniform(name, $bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer, 4);
    }
    /**
     * Sets a sampler uniform on the effect.
     * @param name Define the name of the sampler.
     * @param texture Define the texture to set in the sampler
     */ setTexture(name, texture) {
        this._currentEffect.setTexture(name, texture);
    }
    /**
     * Sets a sampler uniform on the effect.
     * @param name Define the name of the sampler.
     * @param texture Define the (internal) texture to set in the sampler
     */ bindTexture(name, texture) {
        this._currentEffect._bindTexture(name, texture);
    }
    /**
     * Directly updates the value of the uniform in the cache AND on the GPU.
     * @param uniformName Define the name of the uniform, as used in the uniform block in the shader.
     * @param data Define the flattened data
     */ updateUniformDirectly(uniformName, data) {
        this.updateUniform(uniformName, data, data.length);
        this.update();
    }
    /**
     * Associates an effect to this uniform buffer
     * @param effect Define the effect to associate the buffer to
     * @param name Name of the uniform block in the shader.
     */ bindToEffect(effect, name) {
        this._currentEffect = effect;
        this._currentEffectName = name;
    }
    /**
     * Binds the current (GPU) buffer to the effect
     */ bindUniformBuffer() {
        if (!this._noUBO && this._buffer && this._currentEffect) this._currentEffect.bindUniformBuffer(this._buffer, this._currentEffectName);
    }
    /**
     * Dissociates the current effect from this uniform buffer
     */ unbindEffect() {
        this._currentEffect = undefined;
        this._currentEffectName = undefined;
    }
    /**
     * Sets the current state of the class (_bufferIndex, _buffer) to point to the data buffer passed in parameter if this buffer is one of the buffers handled by the class (meaning if it can be found in the _buffers array)
     * This method is meant to be able to update a buffer at any time: just call setDataBuffer to set the class in the right state, call some updateXXX methods and then call udpate() => that will update the GPU buffer on the graphic card
     * @param dataBuffer buffer to look for
     * @returns true if the buffer has been found and the class internal state points to it, else false
     */ setDataBuffer(dataBuffer) {
        if (!this._buffers) return this._buffer === dataBuffer;
        for(let b = 0; b < this._buffers.length; ++b){
            const buffer = this._buffers[b];
            if (buffer[0] === dataBuffer) {
                this._bufferIndex = b;
                this._buffer = dataBuffer;
                this._createBufferOnWrite = false;
                this._currentEffect = undefined;
                return true;
            }
        }
        return false;
    }
    /**
     * Disposes the uniform buffer.
     */ dispose() {
        if (this._noUBO) return;
        const uniformBuffers = this._engine._uniformBuffers;
        const index = uniformBuffers.indexOf(this);
        if (index !== -1) {
            uniformBuffers[index] = uniformBuffers[uniformBuffers.length - 1];
            uniformBuffers.pop();
        }
        if (this._engine._features.trackUbosInFrame && this._buffers) for(let i = 0; i < this._buffers.length; ++i){
            const buffer = this._buffers[i][0];
            this._engine._releaseBuffer(buffer);
        }
        else if (this._buffer && this._engine._releaseBuffer(this._buffer)) this._buffer = null;
    }
}
/** @internal */ $bda18ab409280b95$export$e0b4e5723e07d1e5._UpdatedUbosInFrame = {};
// Pool for avoiding memory leaks
$bda18ab409280b95$export$e0b4e5723e07d1e5._MAX_UNIFORM_SIZE = 256;
$bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer = new Float32Array($bda18ab409280b95$export$e0b4e5723e07d1e5._MAX_UNIFORM_SIZE);
$bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferInt32View = new Int32Array($bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer.buffer);
$bda18ab409280b95$export$e0b4e5723e07d1e5._TempBufferUInt32View = new Uint32Array($bda18ab409280b95$export$e0b4e5723e07d1e5._TempBuffer.buffer);

});
parcelRegister("jo5qL", function(module, exports) {

var $2h5JR = parcelRequire("2h5JR");

var $koExS = parcelRequire("koExS");
(0, $2h5JR.ThinEngine).prototype.createUniformBuffer = function(elements, _label) {
    const ubo = this._gl.createBuffer();
    if (!ubo) throw new Error("Unable to create uniform buffer");
    const result = new (0, $koExS.WebGLDataBuffer)(ubo);
    this.bindUniformBuffer(result);
    if (elements instanceof Float32Array) this._gl.bufferData(this._gl.UNIFORM_BUFFER, elements, this._gl.STATIC_DRAW);
    else this._gl.bufferData(this._gl.UNIFORM_BUFFER, new Float32Array(elements), this._gl.STATIC_DRAW);
    this.bindUniformBuffer(null);
    result.references = 1;
    return result;
};
(0, $2h5JR.ThinEngine).prototype.createDynamicUniformBuffer = function(elements, _label) {
    const ubo = this._gl.createBuffer();
    if (!ubo) throw new Error("Unable to create dynamic uniform buffer");
    const result = new (0, $koExS.WebGLDataBuffer)(ubo);
    this.bindUniformBuffer(result);
    if (elements instanceof Float32Array) this._gl.bufferData(this._gl.UNIFORM_BUFFER, elements, this._gl.DYNAMIC_DRAW);
    else this._gl.bufferData(this._gl.UNIFORM_BUFFER, new Float32Array(elements), this._gl.DYNAMIC_DRAW);
    this.bindUniformBuffer(null);
    result.references = 1;
    return result;
};
(0, $2h5JR.ThinEngine).prototype.updateUniformBuffer = function(uniformBuffer, elements, offset, count) {
    this.bindUniformBuffer(uniformBuffer);
    if (offset === undefined) offset = 0;
    if (count === undefined) {
        if (elements instanceof Float32Array) this._gl.bufferSubData(this._gl.UNIFORM_BUFFER, offset, elements);
        else this._gl.bufferSubData(this._gl.UNIFORM_BUFFER, offset, new Float32Array(elements));
    } else if (elements instanceof Float32Array) this._gl.bufferSubData(this._gl.UNIFORM_BUFFER, 0, elements.subarray(offset, offset + count));
    else this._gl.bufferSubData(this._gl.UNIFORM_BUFFER, 0, new Float32Array(elements).subarray(offset, offset + count));
    this.bindUniformBuffer(null);
};
(0, $2h5JR.ThinEngine).prototype.bindUniformBuffer = function(buffer) {
    this._gl.bindBuffer(this._gl.UNIFORM_BUFFER, buffer ? buffer.underlyingResource : null);
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
(0, $2h5JR.ThinEngine).prototype.bindUniformBufferBase = function(buffer, location, name) {
    this._gl.bindBufferBase(this._gl.UNIFORM_BUFFER, location, buffer ? buffer.underlyingResource : null);
};
(0, $2h5JR.ThinEngine).prototype.bindUniformBlock = function(pipelineContext, blockName, index) {
    const program = pipelineContext.program;
    const uniformLocation = this._gl.getUniformBlockIndex(program, blockName);
    if (uniformLocation !== 0xffffffff) this._gl.uniformBlockBinding(program, uniformLocation, index);
};

});


parcelRegister("gzCma", function(module, exports) {

$parcel$export(module.exports, "PickingInfo", () => $c10dab0bed9b9622$export$7f6d7f420a2935cb);

var $ha1VO = parcelRequire("ha1VO");

var $b4i1f = parcelRequire("b4i1f");
class $c10dab0bed9b9622$export$7f6d7f420a2935cb {
    constructor(){
        /**
         * If the pick collided with an object
         */ this.hit = false;
        /**
         * Distance away where the pick collided
         */ this.distance = 0;
        /**
         * The location of pick collision
         */ this.pickedPoint = null;
        /**
         * The mesh corresponding the pick collision
         */ this.pickedMesh = null;
        /** (See getTextureCoordinates) The barycentric U coordinate that is used when calculating the texture coordinates of the collision.*/ this.bu = 0;
        /** (See getTextureCoordinates) The barycentric V coordinate that is used when calculating the texture coordinates of the collision.*/ this.bv = 0;
        /** The index of the face on the mesh that was picked, or the index of the Line if the picked Mesh is a LinesMesh */ this.faceId = -1;
        /** The index of the face on the subMesh that was picked, or the index of the Line if the picked Mesh is a LinesMesh */ this.subMeshFaceId = -1;
        /** Id of the submesh that was picked */ this.subMeshId = 0;
        /** If a sprite was picked, this will be the sprite the pick collided with */ this.pickedSprite = null;
        /** If we are picking a mesh with thin instance, this will give you the picked thin instance */ this.thinInstanceIndex = -1;
        /**
         * The ray that was used to perform the picking.
         */ this.ray = null;
        /**
         * If a mesh was used to do the picking (eg. 6dof controller) as a "near interaction", this will be populated.
         */ this.originMesh = null;
        /**
         * The aim-space transform of the input used for picking, if it is an XR input source.
         */ this.aimTransform = null;
        /**
         * The grip-space transform of the input used for picking, if it is an XR input source.
         * Some XR sources, such as input coming from head mounted displays, do not have this.
         */ this.gripTransform = null;
    }
    /**
     * Gets the normal corresponding to the face the pick collided with
     * @param useWorldCoordinates If the resulting normal should be relative to the world (default: false)
     * @param useVerticesNormals If the vertices normals should be used to calculate the normal instead of the normal map (default: true)
     * @returns The normal corresponding to the face the pick collided with
     * @remarks Note that the returned normal will always point towards the picking ray.
     */ getNormal(useWorldCoordinates = false, useVerticesNormals = true) {
        if (!this.pickedMesh || useVerticesNormals && !this.pickedMesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).NormalKind)) return null;
        let indices = this.pickedMesh.getIndices();
        if (indices?.length === 0) indices = null;
        let result;
        const tmp0 = (0, $ha1VO.TmpVectors).Vector3[0];
        const tmp1 = (0, $ha1VO.TmpVectors).Vector3[1];
        const tmp2 = (0, $ha1VO.TmpVectors).Vector3[2];
        if (useVerticesNormals) {
            const normals = this.pickedMesh.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind);
            let normal0 = indices ? (0, $ha1VO.Vector3).FromArrayToRef(normals, indices[this.faceId * 3] * 3, tmp0) : tmp0.copyFromFloats(normals[this.faceId * 9], normals[this.faceId * 9 + 1], normals[this.faceId * 9 + 2]);
            let normal1 = indices ? (0, $ha1VO.Vector3).FromArrayToRef(normals, indices[this.faceId * 3 + 1] * 3, tmp1) : tmp1.copyFromFloats(normals[(this.faceId * 3 + 1) * 3], normals[(this.faceId * 3 + 1) * 3 + 1], normals[(this.faceId * 3 + 1) * 3 + 2]);
            let normal2 = indices ? (0, $ha1VO.Vector3).FromArrayToRef(normals, indices[this.faceId * 3 + 2] * 3, tmp2) : tmp2.copyFromFloats(normals[(this.faceId * 3 + 2) * 3], normals[(this.faceId * 3 + 2) * 3 + 1], normals[(this.faceId * 3 + 2) * 3 + 2]);
            normal0 = normal0.scale(this.bu);
            normal1 = normal1.scale(this.bv);
            normal2 = normal2.scale(1.0 - this.bu - this.bv);
            result = new (0, $ha1VO.Vector3)(normal0.x + normal1.x + normal2.x, normal0.y + normal1.y + normal2.y, normal0.z + normal1.z + normal2.z);
        } else {
            const positions = this.pickedMesh.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
            const vertex1 = indices ? (0, $ha1VO.Vector3).FromArrayToRef(positions, indices[this.faceId * 3] * 3, tmp0) : tmp0.copyFromFloats(positions[this.faceId * 9], positions[this.faceId * 9 + 1], positions[this.faceId * 9 + 2]);
            const vertex2 = indices ? (0, $ha1VO.Vector3).FromArrayToRef(positions, indices[this.faceId * 3 + 1] * 3, tmp1) : tmp1.copyFromFloats(positions[(this.faceId * 3 + 1) * 3], positions[(this.faceId * 3 + 1) * 3 + 1], positions[(this.faceId * 3 + 1) * 3 + 2]);
            const vertex3 = indices ? (0, $ha1VO.Vector3).FromArrayToRef(positions, indices[this.faceId * 3 + 2] * 3, tmp2) : tmp2.copyFromFloats(positions[(this.faceId * 3 + 2) * 3], positions[(this.faceId * 3 + 2) * 3 + 1], positions[(this.faceId * 3 + 2) * 3 + 2]);
            const p1p2 = vertex1.subtract(vertex2);
            const p3p2 = vertex3.subtract(vertex2);
            result = (0, $ha1VO.Vector3).Cross(p1p2, p3p2);
        }
        const transformNormalToWorld = (pickedMesh, n)=>{
            let wm = pickedMesh.getWorldMatrix();
            if (pickedMesh.nonUniformScaling) {
                (0, $ha1VO.TmpVectors).Matrix[0].copyFrom(wm);
                wm = (0, $ha1VO.TmpVectors).Matrix[0];
                wm.setTranslationFromFloats(0, 0, 0);
                wm.invert();
                wm.transposeToRef((0, $ha1VO.TmpVectors).Matrix[1]);
                wm = (0, $ha1VO.TmpVectors).Matrix[1];
            }
            (0, $ha1VO.Vector3).TransformNormalToRef(n, wm, n);
        };
        if (useWorldCoordinates) transformNormalToWorld(this.pickedMesh, result);
        if (this.ray) {
            const normalForDirectionChecking = (0, $ha1VO.TmpVectors).Vector3[0].copyFrom(result);
            if (!useWorldCoordinates) // the normal has not been transformed to world space as part as the normal processing, so we must do it now
            transformNormalToWorld(this.pickedMesh, normalForDirectionChecking);
            // Flip the normal if the picking ray is in the same direction.
            if ((0, $ha1VO.Vector3).Dot(normalForDirectionChecking, this.ray.direction) > 0) result.negateInPlace();
        }
        result.normalize();
        return result;
    }
    /**
     * Gets the texture coordinates of where the pick occurred
     * @param uvSet The UV set to use to calculate the texture coordinates (default: VertexBuffer.UVKind)
     * @returns The vector containing the coordinates of the texture
     */ getTextureCoordinates(uvSet = (0, $b4i1f.VertexBuffer).UVKind) {
        if (!this.pickedMesh || !this.pickedMesh.isVerticesDataPresent(uvSet)) return null;
        const indices = this.pickedMesh.getIndices();
        if (!indices) return null;
        const uvs = this.pickedMesh.getVerticesData(uvSet);
        if (!uvs) return null;
        let uv0 = (0, $ha1VO.Vector2).FromArray(uvs, indices[this.faceId * 3] * 2);
        let uv1 = (0, $ha1VO.Vector2).FromArray(uvs, indices[this.faceId * 3 + 1] * 2);
        let uv2 = (0, $ha1VO.Vector2).FromArray(uvs, indices[this.faceId * 3 + 2] * 2);
        uv0 = uv0.scale(this.bu);
        uv1 = uv1.scale(this.bv);
        uv2 = uv2.scale(1.0 - this.bu - this.bv);
        return new (0, $ha1VO.Vector2)(uv0.x + uv1.x + uv2.x, uv0.y + uv1.y + uv2.y);
    }
}

});
parcelRegister("b4i1f", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $80ee0ba8fbf79d16$export$a143d493d941bafc);
$parcel$export(module.exports, "VertexBuffer", () => $80ee0ba8fbf79d16$export$41825a1ed6473903);

var $6zPKs = parcelRequire("6zPKs");

var $kVtWi = parcelRequire("kVtWi");
class $80ee0ba8fbf79d16$export$a143d493d941bafc {
    /**
     * Gets a boolean indicating if the Buffer is disposed
     */ get isDisposed() {
        return this._isDisposed;
    }
    /**
     * Constructor
     * @param engine the engine
     * @param data the data to use for this buffer
     * @param updatable whether the data is updatable
     * @param stride the stride (optional)
     * @param postponeInternalCreation whether to postpone creating the internal WebGL buffer (optional)
     * @param instanced whether the buffer is instanced (optional)
     * @param useBytes set to true if the stride in in bytes (optional)
     * @param divisor sets an optional divisor for instances (1 by default)
     * @param label defines the label of the buffer (for debug purpose)
     */ constructor(engine, data, updatable, stride = 0, postponeInternalCreation = false, instanced = false, useBytes = false, divisor, label){
        this._isAlreadyOwned = false;
        this._isDisposed = false;
        if (engine && engine.getScene) // old versions of VertexBuffer accepted 'mesh' instead of 'engine'
        this._engine = engine.getScene().getEngine();
        else this._engine = engine;
        this._updatable = updatable;
        this._instanced = instanced;
        this._divisor = divisor || 1;
        this._label = label;
        if (data instanceof (0, $6zPKs.DataBuffer)) {
            this._data = null;
            this._buffer = data;
        } else {
            this._data = data;
            this._buffer = null;
        }
        this.byteStride = useBytes ? stride : stride * Float32Array.BYTES_PER_ELEMENT;
        if (!postponeInternalCreation) // by default
        this.create();
    }
    /**
     * Create a new VertexBuffer based on the current buffer
     * @param kind defines the vertex buffer kind (position, normal, etc.)
     * @param offset defines offset in the buffer (0 by default)
     * @param size defines the size in floats of attributes (position is 3 for instance)
     * @param stride defines the stride size in floats in the buffer (the offset to apply to reach next value when data is interleaved)
     * @param instanced defines if the vertex buffer contains indexed data
     * @param useBytes defines if the offset and stride are in bytes     *
     * @param divisor sets an optional divisor for instances (1 by default)
     * @returns the new vertex buffer
     */ createVertexBuffer(kind, offset, size, stride, instanced, useBytes = false, divisor) {
        const byteOffset = useBytes ? offset : offset * Float32Array.BYTES_PER_ELEMENT;
        const byteStride = stride ? useBytes ? stride : stride * Float32Array.BYTES_PER_ELEMENT : this.byteStride;
        // a lot of these parameters are ignored as they are overridden by the buffer
        return new $80ee0ba8fbf79d16$export$41825a1ed6473903(this._engine, this, kind, this._updatable, true, byteStride, instanced === undefined ? this._instanced : instanced, byteOffset, size, undefined, undefined, true, this._divisor || divisor);
    }
    // Properties
    /**
     * Gets a boolean indicating if the Buffer is updatable?
     * @returns true if the buffer is updatable
     */ isUpdatable() {
        return this._updatable;
    }
    /**
     * Gets current buffer's data
     * @returns a DataArray or null
     */ getData() {
        return this._data;
    }
    /**
     * Gets underlying native buffer
     * @returns underlying native buffer
     */ getBuffer() {
        return this._buffer;
    }
    /**
     * Gets the stride in float32 units (i.e. byte stride / 4).
     * May not be an integer if the byte stride is not divisible by 4.
     * @returns the stride in float32 units
     * @deprecated Please use byteStride instead.
     */ getStrideSize() {
        return this.byteStride / Float32Array.BYTES_PER_ELEMENT;
    }
    // Methods
    /**
     * Store data into the buffer. Creates the buffer if not used already.
     * If the buffer was already used, it will be updated only if it is updatable, otherwise it will do nothing.
     * @param data defines the data to store
     */ create(data = null) {
        if (!data && this._buffer) return; // nothing to do
        data = data || this._data;
        if (!data) return;
        if (!this._buffer) {
            // create buffer
            if (this._updatable) {
                this._buffer = this._engine.createDynamicVertexBuffer(data, this._label);
                this._data = data;
            } else this._buffer = this._engine.createVertexBuffer(data, undefined, this._label);
        } else if (this._updatable) {
            // update buffer
            this._engine.updateDynamicVertexBuffer(this._buffer, data);
            this._data = data;
        }
    }
    /** @internal */ _rebuild() {
        if (!this._data) {
            if (!this._buffer) // Buffer was not yet created, nothing to do
            return;
            if (this._buffer.capacity > 0) {
                // We can at least recreate the buffer with the right size, even if we don't have the data
                if (this._updatable) this._buffer = this._engine.createDynamicVertexBuffer(this._buffer.capacity, this._label);
                else this._buffer = this._engine.createVertexBuffer(this._buffer.capacity, undefined, this._label);
                return;
            }
            (0, $kVtWi.Logger).Warn(`Missing data for buffer "${this._label}" ${this._buffer ? "(uniqueId: " + this._buffer.uniqueId + ")" : ""}. Buffer reconstruction failed.`);
            this._buffer = null;
        } else {
            this._buffer = null;
            this.create(this._data);
        }
    }
    /**
     * Update current buffer data
     * @param data defines the data to store
     */ update(data) {
        this.create(data);
    }
    /**
     * Updates the data directly.
     * @param data the new data
     * @param offset the new offset
     * @param vertexCount the vertex count (optional)
     * @param useBytes set to true if the offset is in bytes
     */ updateDirectly(data, offset, vertexCount, useBytes = false) {
        if (!this._buffer) return;
        if (this._updatable) {
            // update buffer
            this._engine.updateDynamicVertexBuffer(this._buffer, data, useBytes ? offset : offset * Float32Array.BYTES_PER_ELEMENT, vertexCount ? vertexCount * this.byteStride : undefined);
            if (offset === 0 && vertexCount === undefined) // Keep the data if we easily can
            this._data = data;
            else this._data = null;
        }
    }
    /** @internal */ _increaseReferences() {
        if (!this._buffer) return;
        if (!this._isAlreadyOwned) {
            this._isAlreadyOwned = true;
            return;
        }
        this._buffer.references++;
    }
    /**
     * Release all resources
     */ dispose() {
        if (!this._buffer) return;
        // The data buffer has an internal counter as this buffer can be used by several VertexBuffer objects
        // This means that we only flag it as disposed when all references are released (when _releaseBuffer will return true)
        if (this._engine._releaseBuffer(this._buffer)) {
            this._isDisposed = true;
            this._data = null;
            this._buffer = null;
        }
    }
}
class $80ee0ba8fbf79d16$export$41825a1ed6473903 {
    /**
     * Gets a boolean indicating if the Buffer is disposed
     */ get isDisposed() {
        return this._isDisposed;
    }
    /**
     * Gets or sets the instance divisor when in instanced mode
     */ get instanceDivisor() {
        return this._instanceDivisor;
    }
    set instanceDivisor(value) {
        const isInstanced = value != 0;
        this._instanceDivisor = value;
        if (isInstanced !== this._instanced) {
            this._instanced = isInstanced;
            this._computeHashCode();
        }
    }
    /**
     * Gets the max possible amount of vertices stored within the current vertex buffer.
     * We do not have the end offset or count so this will be too big for concatenated vertex buffers.
     * @internal
     */ get _maxVerticesCount() {
        const data = this.getData();
        if (!data) return 0;
        if (Array.isArray(data)) // data is a regular number[] with float values
        return data.length / (this.byteStride / 4) - this.byteOffset / 4;
        return (data.byteLength - this.byteOffset) / this.byteStride;
    }
    /** @internal */ constructor(engine, data, kind, updatableOrOptions, postponeInternalCreation, stride, instanced, offset, size, type, normalized = false, useBytes = false, divisor = 1, takeBufferOwnership = false){
        /** @internal */ this._isDisposed = false;
        let updatable = false;
        this.engine = engine;
        if (typeof updatableOrOptions === "object" && updatableOrOptions !== null) {
            updatable = updatableOrOptions.updatable ?? false;
            postponeInternalCreation = updatableOrOptions.postponeInternalCreation;
            stride = updatableOrOptions.stride;
            instanced = updatableOrOptions.instanced;
            offset = updatableOrOptions.offset;
            size = updatableOrOptions.size;
            type = updatableOrOptions.type;
            normalized = updatableOrOptions.normalized ?? false;
            useBytes = updatableOrOptions.useBytes ?? false;
            divisor = updatableOrOptions.divisor ?? 1;
            takeBufferOwnership = updatableOrOptions.takeBufferOwnership ?? false;
            this._label = updatableOrOptions.label;
        } else updatable = !!updatableOrOptions;
        if (data instanceof $80ee0ba8fbf79d16$export$a143d493d941bafc) {
            this._buffer = data;
            this._ownsBuffer = takeBufferOwnership;
        } else {
            this._buffer = new $80ee0ba8fbf79d16$export$a143d493d941bafc(engine, data, updatable, stride, postponeInternalCreation, instanced, useBytes, divisor, this._label);
            this._ownsBuffer = true;
        }
        this.uniqueId = $80ee0ba8fbf79d16$export$41825a1ed6473903._Counter++;
        this._kind = kind;
        if (type === undefined) {
            const vertexData = this.getData();
            this.type = vertexData ? $80ee0ba8fbf79d16$export$41825a1ed6473903.GetDataType(vertexData) : $80ee0ba8fbf79d16$export$41825a1ed6473903.FLOAT;
        } else this.type = type;
        const typeByteLength = $80ee0ba8fbf79d16$export$41825a1ed6473903.GetTypeByteLength(this.type);
        if (useBytes) {
            this._size = size || (stride ? stride / typeByteLength : $80ee0ba8fbf79d16$export$41825a1ed6473903.DeduceStride(kind));
            this.byteStride = stride || this._buffer.byteStride || this._size * typeByteLength;
            this.byteOffset = offset || 0;
        } else {
            this._size = size || stride || $80ee0ba8fbf79d16$export$41825a1ed6473903.DeduceStride(kind);
            this.byteStride = stride ? stride * typeByteLength : this._buffer.byteStride || this._size * typeByteLength;
            this.byteOffset = (offset || 0) * typeByteLength;
        }
        this.normalized = normalized;
        this._instanced = instanced !== undefined ? instanced : false;
        this._instanceDivisor = instanced ? divisor : 0;
        this._alignBuffer();
        this._computeHashCode();
    }
    _computeHashCode() {
        // note: cast to any because the property is declared readonly
        this.hashCode = (this.type - 5120 << 0) + ((this.normalized ? 1 : 0) << 3) + (this._size << 4) + ((this._instanced ? 1 : 0) << 6) + /* keep 5 bits free */ (this.byteStride << 12);
    }
    /** @internal */ _rebuild() {
        this._buffer?._rebuild();
    }
    /**
     * Returns the kind of the VertexBuffer (string)
     * @returns a string
     */ getKind() {
        return this._kind;
    }
    // Properties
    /**
     * Gets a boolean indicating if the VertexBuffer is updatable?
     * @returns true if the buffer is updatable
     */ isUpdatable() {
        return this._buffer.isUpdatable();
    }
    /**
     * Gets current buffer's data
     * @returns a DataArray or null
     */ getData() {
        return this._buffer.getData();
    }
    /**
     * Gets current buffer's data as a float array. Float data is constructed if the vertex buffer data cannot be returned directly.
     * @param totalVertices number of vertices in the buffer to take into account
     * @param forceCopy defines a boolean indicating that the returned array must be cloned upon returning it
     * @returns a float array containing vertex data
     */ getFloatData(totalVertices, forceCopy) {
        const data = this.getData();
        if (!data) return null;
        return $80ee0ba8fbf79d16$export$41825a1ed6473903.GetFloatData(data, this._size, this.type, this.byteOffset, this.byteStride, this.normalized, totalVertices, forceCopy);
    }
    /**
     * Gets underlying native buffer
     * @returns underlying native buffer
     */ getBuffer() {
        return this._buffer.getBuffer();
    }
    /**
     * Gets the Buffer instance that wraps the native GPU buffer
     * @returns the wrapper buffer
     */ getWrapperBuffer() {
        return this._buffer;
    }
    /**
     * Gets the stride in float32 units (i.e. byte stride / 4).
     * May not be an integer if the byte stride is not divisible by 4.
     * @returns the stride in float32 units
     * @deprecated Please use byteStride instead.
     */ getStrideSize() {
        return this.byteStride / $80ee0ba8fbf79d16$export$41825a1ed6473903.GetTypeByteLength(this.type);
    }
    /**
     * Returns the offset as a multiple of the type byte length.
     * @returns the offset in bytes
     * @deprecated Please use byteOffset instead.
     */ getOffset() {
        return this.byteOffset / $80ee0ba8fbf79d16$export$41825a1ed6473903.GetTypeByteLength(this.type);
    }
    /**
     * Returns the number of components or the byte size per vertex attribute
     * @param sizeInBytes If true, returns the size in bytes or else the size in number of components of the vertex attribute (default: false)
     * @returns the number of components
     */ getSize(sizeInBytes = false) {
        return sizeInBytes ? this._size * $80ee0ba8fbf79d16$export$41825a1ed6473903.GetTypeByteLength(this.type) : this._size;
    }
    /**
     * Gets a boolean indicating is the internal buffer of the VertexBuffer is instanced
     * @returns true if this buffer is instanced
     */ getIsInstanced() {
        return this._instanced;
    }
    /**
     * Returns the instancing divisor, zero for non-instanced (integer).
     * @returns a number
     */ getInstanceDivisor() {
        return this._instanceDivisor;
    }
    // Methods
    /**
     * Store data into the buffer. If the buffer was already used it will be either recreated or updated depending on isUpdatable property
     * @param data defines the data to store
     */ create(data) {
        this._buffer.create(data);
        this._alignBuffer();
    }
    /**
     * Updates the underlying buffer according to the passed numeric array or Float32Array.
     * This function will create a new buffer if the current one is not updatable
     * @param data defines the data to store
     */ update(data) {
        this._buffer.update(data);
        this._alignBuffer();
    }
    /**
     * Updates directly the underlying WebGLBuffer according to the passed numeric array or Float32Array.
     * Returns the directly updated WebGLBuffer.
     * @param data the new data
     * @param offset the new offset
     * @param useBytes set to true if the offset is in bytes
     */ updateDirectly(data, offset, useBytes = false) {
        this._buffer.updateDirectly(data, offset, undefined, useBytes);
        this._alignBuffer();
    }
    /**
     * Disposes the VertexBuffer and the underlying WebGLBuffer.
     */ dispose() {
        if (this._ownsBuffer) this._buffer.dispose();
        this._isDisposed = true;
    }
    /**
     * Enumerates each value of this vertex buffer as numbers.
     * @param count the number of values to enumerate
     * @param callback the callback function called for each value
     */ forEach(count, callback) {
        $80ee0ba8fbf79d16$export$41825a1ed6473903.ForEach(this._buffer.getData(), this.byteOffset, this.byteStride, this._size, this.type, count, this.normalized, callback);
    }
    /** @internal */ _alignBuffer() {}
    /**
     * Deduces the stride given a kind.
     * @param kind The kind string to deduce
     * @returns The deduced stride
     */ static DeduceStride(kind) {
        switch(kind){
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.UVKind:
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.UV2Kind:
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.UV3Kind:
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.UV4Kind:
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.UV5Kind:
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.UV6Kind:
                return 2;
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.NormalKind:
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.PositionKind:
                return 3;
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.ColorKind:
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.ColorInstanceKind:
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.MatricesIndicesKind:
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.MatricesIndicesExtraKind:
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.MatricesWeightsKind:
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.MatricesWeightsExtraKind:
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.TangentKind:
                return 4;
            default:
                throw new Error("Invalid kind '" + kind + "'");
        }
    }
    /**
     * Gets the vertex buffer type of the given data array.
     * @param data the data array
     * @returns the vertex buffer type
     */ static GetDataType(data) {
        if (data instanceof Int8Array) return $80ee0ba8fbf79d16$export$41825a1ed6473903.BYTE;
        else if (data instanceof Uint8Array) return $80ee0ba8fbf79d16$export$41825a1ed6473903.UNSIGNED_BYTE;
        else if (data instanceof Int16Array) return $80ee0ba8fbf79d16$export$41825a1ed6473903.SHORT;
        else if (data instanceof Uint16Array) return $80ee0ba8fbf79d16$export$41825a1ed6473903.UNSIGNED_SHORT;
        else if (data instanceof Int32Array) return $80ee0ba8fbf79d16$export$41825a1ed6473903.INT;
        else if (data instanceof Uint32Array) return $80ee0ba8fbf79d16$export$41825a1ed6473903.UNSIGNED_INT;
        else return $80ee0ba8fbf79d16$export$41825a1ed6473903.FLOAT;
    }
    /**
     * Gets the byte length of the given type.
     * @param type the type
     * @returns the number of bytes
     */ static GetTypeByteLength(type) {
        switch(type){
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.BYTE:
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.UNSIGNED_BYTE:
                return 1;
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.SHORT:
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.UNSIGNED_SHORT:
                return 2;
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.INT:
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.UNSIGNED_INT:
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.FLOAT:
                return 4;
            default:
                throw new Error(`Invalid type '${type}'`);
        }
    }
    /**
     * Enumerates each value of the given parameters as numbers.
     * @param data the data to enumerate
     * @param byteOffset the byte offset of the data
     * @param byteStride the byte stride of the data
     * @param componentCount the number of components per element
     * @param componentType the type of the component
     * @param count the number of values to enumerate
     * @param normalized whether the data is normalized
     * @param callback the callback function called for each value
     */ static ForEach(data, byteOffset, byteStride, componentCount, componentType, count, normalized, callback) {
        if (data instanceof Array) {
            let offset = byteOffset / 4;
            const stride = byteStride / 4;
            for(let index = 0; index < count; index += componentCount){
                for(let componentIndex = 0; componentIndex < componentCount; componentIndex++)callback(data[offset + componentIndex], index + componentIndex);
                offset += stride;
            }
        } else {
            const dataView = data instanceof ArrayBuffer ? new DataView(data) : new DataView(data.buffer, data.byteOffset, data.byteLength);
            const componentByteLength = $80ee0ba8fbf79d16$export$41825a1ed6473903.GetTypeByteLength(componentType);
            for(let index = 0; index < count; index += componentCount){
                let componentByteOffset = byteOffset;
                for(let componentIndex = 0; componentIndex < componentCount; componentIndex++){
                    const value = $80ee0ba8fbf79d16$export$41825a1ed6473903._GetFloatValue(dataView, componentType, componentByteOffset, normalized);
                    callback(value, index + componentIndex);
                    componentByteOffset += componentByteLength;
                }
                byteOffset += byteStride;
            }
        }
    }
    static _GetFloatValue(dataView, type, byteOffset, normalized) {
        switch(type){
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.BYTE:
                {
                    let value = dataView.getInt8(byteOffset);
                    if (normalized) value = Math.max(value / 127, -1);
                    return value;
                }
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.UNSIGNED_BYTE:
                {
                    let value = dataView.getUint8(byteOffset);
                    if (normalized) value = value / 255;
                    return value;
                }
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.SHORT:
                {
                    let value = dataView.getInt16(byteOffset, true);
                    if (normalized) value = Math.max(value / 32767, -1);
                    return value;
                }
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.UNSIGNED_SHORT:
                {
                    let value = dataView.getUint16(byteOffset, true);
                    if (normalized) value = value / 65535;
                    return value;
                }
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.INT:
                return dataView.getInt32(byteOffset, true);
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.UNSIGNED_INT:
                return dataView.getUint32(byteOffset, true);
            case $80ee0ba8fbf79d16$export$41825a1ed6473903.FLOAT:
                return dataView.getFloat32(byteOffset, true);
            default:
                throw new Error(`Invalid component type ${type}`);
        }
    }
    /**
     * Gets the given data array as a float array. Float data is constructed if the data array cannot be returned directly.
     * @param data the input data array
     * @param size the number of components
     * @param type the component type
     * @param byteOffset the byte offset of the data
     * @param byteStride the byte stride of the data
     * @param normalized whether the data is normalized
     * @param totalVertices number of vertices in the buffer to take into account
     * @param forceCopy defines a boolean indicating that the returned array must be cloned upon returning it
     * @returns a float array containing vertex data
     */ static GetFloatData(data, size, type, byteOffset, byteStride, normalized, totalVertices, forceCopy) {
        const tightlyPackedByteStride = size * $80ee0ba8fbf79d16$export$41825a1ed6473903.GetTypeByteLength(type);
        const count = totalVertices * size;
        if (type !== $80ee0ba8fbf79d16$export$41825a1ed6473903.FLOAT || byteStride !== tightlyPackedByteStride) {
            const copy = new Float32Array(count);
            $80ee0ba8fbf79d16$export$41825a1ed6473903.ForEach(data, byteOffset, byteStride, size, type, count, normalized, (value, index)=>copy[index] = value);
            return copy;
        }
        if (!(data instanceof Array || data instanceof Float32Array) || byteOffset !== 0 || data.length !== count) {
            if (data instanceof Array) {
                const offset = byteOffset / 4;
                return data.slice(offset, offset + count);
            } else if (data instanceof ArrayBuffer) return new Float32Array(data, byteOffset, count);
            else {
                let offset = data.byteOffset + byteOffset;
                if (forceCopy) {
                    const result = new Float32Array(count);
                    const source = new Float32Array(data.buffer, offset, count);
                    result.set(source);
                    return result;
                }
                // Protect against bad data
                const remainder = offset % 4;
                if (remainder) offset = Math.max(0, offset - remainder);
                return new Float32Array(data.buffer, offset, count);
            }
        }
        if (forceCopy) return data.slice();
        return data;
    }
}
$80ee0ba8fbf79d16$export$41825a1ed6473903._Counter = 0;
/**
 * The byte type.
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.BYTE = 5120;
/**
 * The unsigned byte type.
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.UNSIGNED_BYTE = 5121;
/**
 * The short type.
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.SHORT = 5122;
/**
 * The unsigned short type.
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.UNSIGNED_SHORT = 5123;
/**
 * The integer type.
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.INT = 5124;
/**
 * The unsigned integer type.
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.UNSIGNED_INT = 5125;
/**
 * The float type.
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.FLOAT = 5126;
// Enums
/**
 * Positions
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.PositionKind = `position`;
/**
 * Normals
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.NormalKind = `normal`;
/**
 * Tangents
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.TangentKind = `tangent`;
/**
 * Texture coordinates
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.UVKind = `uv`;
/**
 * Texture coordinates 2
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.UV2Kind = `uv2`;
/**
 * Texture coordinates 3
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.UV3Kind = `uv3`;
/**
 * Texture coordinates 4
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.UV4Kind = `uv4`;
/**
 * Texture coordinates 5
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.UV5Kind = `uv5`;
/**
 * Texture coordinates 6
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.UV6Kind = `uv6`;
/**
 * Colors
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.ColorKind = `color`;
/**
 * Instance Colors
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.ColorInstanceKind = `instanceColor`;
/**
 * Matrix indices (for bones)
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.MatricesIndicesKind = `matricesIndices`;
/**
 * Matrix weights (for bones)
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.MatricesWeightsKind = `matricesWeights`;
/**
 * Additional matrix indices (for bones)
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.MatricesIndicesExtraKind = `matricesIndicesExtra`;
/**
 * Additional matrix weights (for bones)
 */ $80ee0ba8fbf79d16$export$41825a1ed6473903.MatricesWeightsExtraKind = `matricesWeightsExtra`;

});


parcelRegister("8MhbJ", function(module, exports) {

$parcel$export(module.exports, "PostProcessManager", () => $664023a246d3c804$export$f775f8caa29bd9a0);

var $b4i1f = parcelRequire("b4i1f");
class $664023a246d3c804$export$f775f8caa29bd9a0 {
    /**
     * Creates a new instance PostProcess
     * @param scene The scene that the post process is associated with.
     */ constructor(scene){
        this._vertexBuffers = {};
        this._scene = scene;
    }
    _prepareBuffers() {
        if (this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind]) return;
        // VBO
        const vertices = [];
        vertices.push(1, 1);
        vertices.push(-1, 1);
        vertices.push(-1, -1);
        vertices.push(1, -1);
        this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind] = new (0, $b4i1f.VertexBuffer)(this._scene.getEngine(), vertices, (0, $b4i1f.VertexBuffer).PositionKind, false, false, 2);
        this._buildIndexBuffer();
    }
    _buildIndexBuffer() {
        // Indices
        const indices = [];
        indices.push(0);
        indices.push(1);
        indices.push(2);
        indices.push(0);
        indices.push(2);
        indices.push(3);
        this._indexBuffer = this._scene.getEngine().createIndexBuffer(indices);
    }
    /**
     * Rebuilds the vertex buffers of the manager.
     * @internal
     */ _rebuild() {
        const vb = this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind];
        if (!vb) return;
        vb._rebuild();
        this._buildIndexBuffer();
    }
    // Methods
    /**
     * Prepares a frame to be run through a post process.
     * @param sourceTexture The input texture to the post processes. (default: null)
     * @param postProcesses An array of post processes to be run. (default: null)
     * @returns True if the post processes were able to be run.
     * @internal
     */ _prepareFrame(sourceTexture = null, postProcesses = null) {
        const camera = this._scene.activeCamera;
        if (!camera) return false;
        postProcesses = postProcesses || camera._postProcesses.filter((pp)=>{
            return pp != null;
        });
        if (!postProcesses || postProcesses.length === 0 || !this._scene.postProcessesEnabled) return false;
        postProcesses[0].activate(camera, sourceTexture, postProcesses !== null && postProcesses !== undefined);
        return true;
    }
    /**
     * Manually render a set of post processes to a texture.
     * Please note, the frame buffer won't be unbound after the call in case you have more render to do.
     * @param postProcesses An array of post processes to be run.
     * @param targetTexture The render target wrapper to render to.
     * @param forceFullscreenViewport force gl.viewport to be full screen eg. 0,0,textureWidth,textureHeight
     * @param faceIndex defines the face to render to if a cubemap is defined as the target
     * @param lodLevel defines which lod of the texture to render to
     * @param doNotBindFrambuffer If set to true, assumes that the framebuffer has been bound previously
     */ directRender(postProcesses, targetTexture = null, forceFullscreenViewport = false, faceIndex = 0, lodLevel = 0, doNotBindFrambuffer = false) {
        const engine = this._scene.getEngine();
        for(let index = 0; index < postProcesses.length; index++){
            if (index < postProcesses.length - 1) postProcesses[index + 1].activate(this._scene.activeCamera, targetTexture?.texture);
            else {
                if (targetTexture) engine.bindFramebuffer(targetTexture, faceIndex, undefined, undefined, forceFullscreenViewport, lodLevel);
                else if (!doNotBindFrambuffer) engine.restoreDefaultFramebuffer();
                engine._debugInsertMarker?.(`post process ${postProcesses[index].name} output`);
            }
            const pp = postProcesses[index];
            const effect = pp.apply();
            if (effect) {
                pp.onBeforeRenderObservable.notifyObservers(effect);
                // VBOs
                this._prepareBuffers();
                engine.bindBuffers(this._vertexBuffers, this._indexBuffer, effect);
                // Draw order
                engine.drawElementsType(0, 0, 6);
                pp.onAfterRenderObservable.notifyObservers(effect);
            }
        }
        // Restore depth buffer
        engine.setDepthBuffer(true);
        engine.setDepthWrite(true);
    }
    /**
     * Finalize the result of the output of the postprocesses.
     * @param doNotPresent If true the result will not be displayed to the screen.
     * @param targetTexture The render target wrapper to render to.
     * @param faceIndex The index of the face to bind the target texture to.
     * @param postProcesses The array of post processes to render.
     * @param forceFullscreenViewport force gl.viewport to be full screen eg. 0,0,textureWidth,textureHeight (default: false)
     * @internal
     */ _finalizeFrame(doNotPresent, targetTexture, faceIndex, postProcesses, forceFullscreenViewport = false) {
        const camera = this._scene.activeCamera;
        if (!camera) return;
        postProcesses = postProcesses || camera._postProcesses.filter((pp)=>{
            return pp != null;
        });
        if (postProcesses.length === 0 || !this._scene.postProcessesEnabled) return;
        const engine = this._scene.getEngine();
        for(let index = 0, len = postProcesses.length; index < len; index++){
            const pp = postProcesses[index];
            if (index < len - 1) pp._outputTexture = postProcesses[index + 1].activate(camera, targetTexture?.texture);
            else {
                if (targetTexture) {
                    engine.bindFramebuffer(targetTexture, faceIndex, undefined, undefined, forceFullscreenViewport);
                    pp._outputTexture = targetTexture;
                } else {
                    engine.restoreDefaultFramebuffer();
                    pp._outputTexture = null;
                }
                engine._debugInsertMarker?.(`post process ${postProcesses[index].name} output`);
            }
            if (doNotPresent) break;
            const effect = pp.apply();
            if (effect) {
                pp.onBeforeRenderObservable.notifyObservers(effect);
                // VBOs
                this._prepareBuffers();
                engine.bindBuffers(this._vertexBuffers, this._indexBuffer, effect);
                // Draw order
                engine.drawElementsType(0, 0, 6);
                pp.onAfterRenderObservable.notifyObservers(effect);
            }
        }
        // Restore states
        engine.setDepthBuffer(true);
        engine.setDepthWrite(true);
        engine.setAlphaMode(0);
    }
    /**
     * Disposes of the post process manager.
     */ dispose() {
        const buffer = this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind];
        if (buffer) {
            buffer.dispose();
            this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind] = null;
        }
        if (this._indexBuffer) {
            this._scene.getEngine()._releaseBuffer(this._indexBuffer);
            this._indexBuffer = null;
        }
    }
}

});

parcelRegister("jJNg8", function(module, exports) {

$parcel$export(module.exports, "RenderingGroupInfo", () => $e5e86e279e78f743$export$306a93d948b9dc21);
$parcel$export(module.exports, "RenderingManager", () => $e5e86e279e78f743$export$648192f328727d18);

var $78VIa = parcelRequire("78VIa");
class $e5e86e279e78f743$export$306a93d948b9dc21 {
}
class $e5e86e279e78f743$export$648192f328727d18 {
    /**
     * Gets or sets a boolean indicating that the manager will not reset between frames.
     * This means that if a mesh becomes invisible or transparent it will not be visible until this boolean is set to false again.
     * By default, the rendering manager will dispatch all active meshes per frame (moving them to the transparent, opaque or alpha testing lists).
     * By turning this property on, you will accelerate the rendering by keeping all these lists unchanged between frames.
     */ get maintainStateBetweenFrames() {
        return this._maintainStateBetweenFrames;
    }
    set maintainStateBetweenFrames(value) {
        if (value === this._maintainStateBetweenFrames) return;
        this._maintainStateBetweenFrames = value;
        if (!this._maintainStateBetweenFrames) this.restoreDispachedFlags();
    }
    /**
     * Restore wasDispatched flags on the lists of elements to render.
     */ restoreDispachedFlags() {
        for (const mesh of this._scene.meshes){
            if (mesh.subMeshes) for (const subMesh of mesh.subMeshes)subMesh._wasDispatched = false;
        }
        if (this._scene.spriteManagers) for (const spriteManager of this._scene.spriteManagers)spriteManager._wasDispatched = false;
        for (const particleSystem of this._scene.particleSystems)particleSystem._wasDispatched = false;
    }
    /**
     * Instantiates a new rendering group for a particular scene
     * @param scene Defines the scene the groups belongs to
     */ constructor(scene){
        /**
         * @internal
         */ this._useSceneAutoClearSetup = false;
        this._renderingGroups = new Array();
        this._autoClearDepthStencil = {};
        this._customOpaqueSortCompareFn = {};
        this._customAlphaTestSortCompareFn = {};
        this._customTransparentSortCompareFn = {};
        this._renderingGroupInfo = new $e5e86e279e78f743$export$306a93d948b9dc21();
        this._maintainStateBetweenFrames = false;
        this._scene = scene;
        for(let i = $e5e86e279e78f743$export$648192f328727d18.MIN_RENDERINGGROUPS; i < $e5e86e279e78f743$export$648192f328727d18.MAX_RENDERINGGROUPS; i++)this._autoClearDepthStencil[i] = {
            autoClear: true,
            depth: true,
            stencil: true
        };
    }
    /**
     * @returns the rendering group with the specified id.
     * @param id the id of the rendering group (0 by default)
     */ getRenderingGroup(id) {
        const renderingGroupId = id || 0;
        this._prepareRenderingGroup(renderingGroupId);
        return this._renderingGroups[renderingGroupId];
    }
    _clearDepthStencilBuffer(depth = true, stencil = true) {
        if (this._depthStencilBufferAlreadyCleaned) return;
        this._scene.getEngine().clear(null, false, depth, stencil);
        this._depthStencilBufferAlreadyCleaned = true;
    }
    /**
     * Renders the entire managed groups. This is used by the scene or the different render targets.
     * @internal
     */ render(customRenderFunction, activeMeshes, renderParticles, renderSprites) {
        // Update the observable context (not null as it only goes away on dispose)
        const info = this._renderingGroupInfo;
        info.scene = this._scene;
        info.camera = this._scene.activeCamera;
        // Dispatch sprites
        if (this._scene.spriteManagers && renderSprites) for(let index = 0; index < this._scene.spriteManagers.length; index++){
            const manager = this._scene.spriteManagers[index];
            this.dispatchSprites(manager);
        }
        // Render
        for(let index = $e5e86e279e78f743$export$648192f328727d18.MIN_RENDERINGGROUPS; index < $e5e86e279e78f743$export$648192f328727d18.MAX_RENDERINGGROUPS; index++){
            this._depthStencilBufferAlreadyCleaned = index === $e5e86e279e78f743$export$648192f328727d18.MIN_RENDERINGGROUPS;
            const renderingGroup = this._renderingGroups[index];
            if (!renderingGroup || renderingGroup._empty) continue;
            const renderingGroupMask = 1 << index;
            info.renderingGroupId = index;
            // Before Observable
            this._scene.onBeforeRenderingGroupObservable.notifyObservers(info, renderingGroupMask);
            // Clear depth/stencil if needed
            if ($e5e86e279e78f743$export$648192f328727d18.AUTOCLEAR) {
                const autoClear = this._useSceneAutoClearSetup ? this._scene.getAutoClearDepthStencilSetup(index) : this._autoClearDepthStencil[index];
                if (autoClear && autoClear.autoClear) this._clearDepthStencilBuffer(autoClear.depth, autoClear.stencil);
            }
            // Render
            for (const step of this._scene._beforeRenderingGroupDrawStage)step.action(index);
            renderingGroup.render(customRenderFunction, renderSprites, renderParticles, activeMeshes);
            for (const step of this._scene._afterRenderingGroupDrawStage)step.action(index);
            // After Observable
            this._scene.onAfterRenderingGroupObservable.notifyObservers(info, renderingGroupMask);
        }
    }
    /**
     * Resets the different information of the group to prepare a new frame
     * @internal
     */ reset() {
        if (this.maintainStateBetweenFrames) return;
        for(let index = $e5e86e279e78f743$export$648192f328727d18.MIN_RENDERINGGROUPS; index < $e5e86e279e78f743$export$648192f328727d18.MAX_RENDERINGGROUPS; index++){
            const renderingGroup = this._renderingGroups[index];
            if (renderingGroup) renderingGroup.prepare();
        }
    }
    /**
     * Resets the sprites information of the group to prepare a new frame
     * @internal
     */ resetSprites() {
        if (this.maintainStateBetweenFrames) return;
        for(let index = $e5e86e279e78f743$export$648192f328727d18.MIN_RENDERINGGROUPS; index < $e5e86e279e78f743$export$648192f328727d18.MAX_RENDERINGGROUPS; index++){
            const renderingGroup = this._renderingGroups[index];
            if (renderingGroup) renderingGroup.prepareSprites();
        }
    }
    /**
     * Dispose and release the group and its associated resources.
     * @internal
     */ dispose() {
        this.freeRenderingGroups();
        this._renderingGroups.length = 0;
        this._renderingGroupInfo = null;
    }
    /**
     * Clear the info related to rendering groups preventing retention points during dispose.
     */ freeRenderingGroups() {
        for(let index = $e5e86e279e78f743$export$648192f328727d18.MIN_RENDERINGGROUPS; index < $e5e86e279e78f743$export$648192f328727d18.MAX_RENDERINGGROUPS; index++){
            const renderingGroup = this._renderingGroups[index];
            if (renderingGroup) renderingGroup.dispose();
        }
    }
    _prepareRenderingGroup(renderingGroupId) {
        if (this._renderingGroups[renderingGroupId] === undefined) this._renderingGroups[renderingGroupId] = new (0, $78VIa.RenderingGroup)(renderingGroupId, this._scene, this._customOpaqueSortCompareFn[renderingGroupId], this._customAlphaTestSortCompareFn[renderingGroupId], this._customTransparentSortCompareFn[renderingGroupId]);
    }
    /**
     * Add a sprite manager to the rendering manager in order to render it this frame.
     * @param spriteManager Define the sprite manager to render
     */ dispatchSprites(spriteManager) {
        if (this.maintainStateBetweenFrames && spriteManager._wasDispatched) return;
        spriteManager._wasDispatched = true;
        this.getRenderingGroup(spriteManager.renderingGroupId).dispatchSprites(spriteManager);
    }
    /**
     * Add a particle system to the rendering manager in order to render it this frame.
     * @param particleSystem Define the particle system to render
     */ dispatchParticles(particleSystem) {
        if (this.maintainStateBetweenFrames && particleSystem._wasDispatched) return;
        particleSystem._wasDispatched = true;
        this.getRenderingGroup(particleSystem.renderingGroupId).dispatchParticles(particleSystem);
    }
    /**
     * Add a submesh to the manager in order to render it this frame
     * @param subMesh The submesh to dispatch
     * @param mesh Optional reference to the submeshes's mesh. Provide if you have an exiting reference to improve performance.
     * @param material Optional reference to the submeshes's material. Provide if you have an exiting reference to improve performance.
     */ dispatch(subMesh, mesh, material) {
        if (mesh === undefined) mesh = subMesh.getMesh();
        if (this.maintainStateBetweenFrames && subMesh._wasDispatched) return;
        subMesh._wasDispatched = true;
        this.getRenderingGroup(mesh.renderingGroupId).dispatch(subMesh, mesh, material);
    }
    /**
     * Overrides the default sort function applied in the rendering group to prepare the meshes.
     * This allowed control for front to back rendering or reversely depending of the special needs.
     *
     * @param renderingGroupId The rendering group id corresponding to its index
     * @param opaqueSortCompareFn The opaque queue comparison function use to sort.
     * @param alphaTestSortCompareFn The alpha test queue comparison function use to sort.
     * @param transparentSortCompareFn The transparent queue comparison function use to sort.
     */ setRenderingOrder(renderingGroupId, opaqueSortCompareFn = null, alphaTestSortCompareFn = null, transparentSortCompareFn = null) {
        this._customOpaqueSortCompareFn[renderingGroupId] = opaqueSortCompareFn;
        this._customAlphaTestSortCompareFn[renderingGroupId] = alphaTestSortCompareFn;
        this._customTransparentSortCompareFn[renderingGroupId] = transparentSortCompareFn;
        if (this._renderingGroups[renderingGroupId]) {
            const group = this._renderingGroups[renderingGroupId];
            group.opaqueSortCompareFn = this._customOpaqueSortCompareFn[renderingGroupId];
            group.alphaTestSortCompareFn = this._customAlphaTestSortCompareFn[renderingGroupId];
            group.transparentSortCompareFn = this._customTransparentSortCompareFn[renderingGroupId];
        }
    }
    /**
     * Specifies whether or not the stencil and depth buffer are cleared between two rendering groups.
     *
     * @param renderingGroupId The rendering group id corresponding to its index
     * @param autoClearDepthStencil Automatically clears depth and stencil between groups if true.
     * @param depth Automatically clears depth between groups if true and autoClear is true.
     * @param stencil Automatically clears stencil between groups if true and autoClear is true.
     */ setRenderingAutoClearDepthStencil(renderingGroupId, autoClearDepthStencil, depth = true, stencil = true) {
        this._autoClearDepthStencil[renderingGroupId] = {
            autoClear: autoClearDepthStencil,
            depth: depth,
            stencil: stencil
        };
    }
    /**
     * Gets the current auto clear configuration for one rendering group of the rendering
     * manager.
     * @param index the rendering group index to get the information for
     * @returns The auto clear setup for the requested rendering group
     */ getAutoClearDepthStencilSetup(index) {
        return this._autoClearDepthStencil[index];
    }
}
/**
 * The max id used for rendering groups (not included)
 */ $e5e86e279e78f743$export$648192f328727d18.MAX_RENDERINGGROUPS = 4;
/**
 * The min id used for rendering groups (included)
 */ $e5e86e279e78f743$export$648192f328727d18.MIN_RENDERINGGROUPS = 0;
/**
 * Used to globally prevent autoclearing scenes.
 */ $e5e86e279e78f743$export$648192f328727d18.AUTOCLEAR = true;

});
parcelRegister("78VIa", function(module, exports) {

$parcel$export(module.exports, "RenderingGroup", () => $53360c0949bf5711$export$9c1352b86d43d054);

var $57onU = parcelRequire("57onU");

var $ha1VO = parcelRequire("ha1VO");
class $53360c0949bf5711$export$9c1352b86d43d054 {
    /**
     * Set the opaque sort comparison function.
     * If null the sub meshes will be render in the order they were created
     */ set opaqueSortCompareFn(value) {
        if (value) this._opaqueSortCompareFn = value;
        else this._opaqueSortCompareFn = $53360c0949bf5711$export$9c1352b86d43d054.PainterSortCompare;
        this._renderOpaque = this._renderOpaqueSorted;
    }
    /**
     * Set the alpha test sort comparison function.
     * If null the sub meshes will be render in the order they were created
     */ set alphaTestSortCompareFn(value) {
        if (value) this._alphaTestSortCompareFn = value;
        else this._alphaTestSortCompareFn = $53360c0949bf5711$export$9c1352b86d43d054.PainterSortCompare;
        this._renderAlphaTest = this._renderAlphaTestSorted;
    }
    /**
     * Set the transparent sort comparison function.
     * If null the sub meshes will be render in the order they were created
     */ set transparentSortCompareFn(value) {
        if (value) this._transparentSortCompareFn = value;
        else this._transparentSortCompareFn = $53360c0949bf5711$export$9c1352b86d43d054.defaultTransparentSortCompare;
        this._renderTransparent = this._renderTransparentSorted;
    }
    /**
     * Creates a new rendering group.
     * @param index The rendering group index
     * @param scene
     * @param opaqueSortCompareFn The opaque sort comparison function. If null no order is applied
     * @param alphaTestSortCompareFn The alpha test sort comparison function. If null no order is applied
     * @param transparentSortCompareFn The transparent sort comparison function. If null back to front + alpha index sort is applied
     */ constructor(index, scene, opaqueSortCompareFn = null, alphaTestSortCompareFn = null, transparentSortCompareFn = null){
        this.index = index;
        this._opaqueSubMeshes = new (0, $57onU.SmartArray)(256);
        this._transparentSubMeshes = new (0, $57onU.SmartArray)(256);
        this._alphaTestSubMeshes = new (0, $57onU.SmartArray)(256);
        this._depthOnlySubMeshes = new (0, $57onU.SmartArray)(256);
        this._particleSystems = new (0, $57onU.SmartArray)(256);
        this._spriteManagers = new (0, $57onU.SmartArray)(256);
        /** @internal */ this._empty = true;
        /** @internal */ this._edgesRenderers = new (0, $57onU.SmartArrayNoDuplicate)(16);
        this._scene = scene;
        this.opaqueSortCompareFn = opaqueSortCompareFn;
        this.alphaTestSortCompareFn = alphaTestSortCompareFn;
        this.transparentSortCompareFn = transparentSortCompareFn;
    }
    /**
     * Render all the sub meshes contained in the group.
     * @param customRenderFunction Used to override the default render behaviour of the group.
     * @param renderSprites
     * @param renderParticles
     * @param activeMeshes
     */ render(customRenderFunction, renderSprites, renderParticles, activeMeshes) {
        if (customRenderFunction) {
            customRenderFunction(this._opaqueSubMeshes, this._alphaTestSubMeshes, this._transparentSubMeshes, this._depthOnlySubMeshes);
            return;
        }
        const engine = this._scene.getEngine();
        // Depth only
        if (this._depthOnlySubMeshes.length !== 0) {
            engine.setColorWrite(false);
            this._renderAlphaTest(this._depthOnlySubMeshes);
            engine.setColorWrite(true);
        }
        // Opaque
        if (this._opaqueSubMeshes.length !== 0) this._renderOpaque(this._opaqueSubMeshes);
        // Alpha test
        if (this._alphaTestSubMeshes.length !== 0) this._renderAlphaTest(this._alphaTestSubMeshes);
        const stencilState = engine.getStencilBuffer();
        engine.setStencilBuffer(false);
        // Sprites
        if (renderSprites) this._renderSprites();
        // Particles
        if (renderParticles) this._renderParticles(activeMeshes);
        if (this.onBeforeTransparentRendering) this.onBeforeTransparentRendering();
        // Transparent
        if (this._transparentSubMeshes.length !== 0 || this._scene.useOrderIndependentTransparency) {
            engine.setStencilBuffer(stencilState);
            if (this._scene.useOrderIndependentTransparency) {
                const excludedMeshes = this._scene.depthPeelingRenderer.render(this._transparentSubMeshes);
                if (excludedMeshes.length) // Render leftover meshes that could not be processed by depth peeling
                this._renderTransparent(excludedMeshes);
            } else this._renderTransparent(this._transparentSubMeshes);
            engine.setAlphaMode(0);
        }
        // Set back stencil to false in case it changes before the edge renderer.
        engine.setStencilBuffer(false);
        // Edges
        if (this._edgesRenderers.length) {
            for(let edgesRendererIndex = 0; edgesRendererIndex < this._edgesRenderers.length; edgesRendererIndex++)this._edgesRenderers.data[edgesRendererIndex].render();
            engine.setAlphaMode(0);
        }
        // Restore Stencil state.
        engine.setStencilBuffer(stencilState);
    }
    /**
     * Renders the opaque submeshes in the order from the opaqueSortCompareFn.
     * @param subMeshes The submeshes to render
     */ _renderOpaqueSorted(subMeshes) {
        $53360c0949bf5711$export$9c1352b86d43d054._RenderSorted(subMeshes, this._opaqueSortCompareFn, this._scene.activeCamera, false);
    }
    /**
     * Renders the opaque submeshes in the order from the alphatestSortCompareFn.
     * @param subMeshes The submeshes to render
     */ _renderAlphaTestSorted(subMeshes) {
        $53360c0949bf5711$export$9c1352b86d43d054._RenderSorted(subMeshes, this._alphaTestSortCompareFn, this._scene.activeCamera, false);
    }
    /**
     * Renders the opaque submeshes in the order from the transparentSortCompareFn.
     * @param subMeshes The submeshes to render
     */ _renderTransparentSorted(subMeshes) {
        $53360c0949bf5711$export$9c1352b86d43d054._RenderSorted(subMeshes, this._transparentSortCompareFn, this._scene.activeCamera, true);
    }
    /**
     * Renders the submeshes in a specified order.
     * @param subMeshes The submeshes to sort before render
     * @param sortCompareFn The comparison function use to sort
     * @param camera The camera position use to preprocess the submeshes to help sorting
     * @param transparent Specifies to activate blending if true
     */ static _RenderSorted(subMeshes, sortCompareFn, camera, transparent) {
        let subIndex = 0;
        let subMesh;
        const cameraPosition = camera ? camera.globalPosition : $53360c0949bf5711$export$9c1352b86d43d054._ZeroVector;
        if (transparent) for(; subIndex < subMeshes.length; subIndex++){
            subMesh = subMeshes.data[subIndex];
            subMesh._alphaIndex = subMesh.getMesh().alphaIndex;
            subMesh._distanceToCamera = (0, $ha1VO.Vector3).Distance(subMesh.getBoundingInfo().boundingSphere.centerWorld, cameraPosition);
        }
        const sortedArray = subMeshes.length === subMeshes.data.length ? subMeshes.data : subMeshes.data.slice(0, subMeshes.length);
        if (sortCompareFn) sortedArray.sort(sortCompareFn);
        const scene = sortedArray[0].getMesh().getScene();
        for(subIndex = 0; subIndex < sortedArray.length; subIndex++){
            subMesh = sortedArray[subIndex];
            if (scene._activeMeshesFrozenButKeepClipping && !subMesh.isInFrustum(scene._frustumPlanes)) continue;
            if (transparent) {
                const material = subMesh.getMaterial();
                if (material && material.needDepthPrePass) {
                    const engine = material.getScene().getEngine();
                    engine.setColorWrite(false);
                    engine.setAlphaMode(0);
                    subMesh.render(false);
                    engine.setColorWrite(true);
                }
            }
            subMesh.render(transparent);
        }
    }
    /**
     * Build in function which can be applied to ensure meshes of a special queue (opaque, alpha test, transparent)
     * are rendered back to front if in the same alpha index.
     *
     * @param a The first submesh
     * @param b The second submesh
     * @returns The result of the comparison
     */ // eslint-disable-next-line @typescript-eslint/naming-convention
    static defaultTransparentSortCompare(a, b) {
        // Alpha index first
        if (a._alphaIndex > b._alphaIndex) return 1;
        if (a._alphaIndex < b._alphaIndex) return -1;
        // Then distance to camera
        return $53360c0949bf5711$export$9c1352b86d43d054.backToFrontSortCompare(a, b);
    }
    /**
     * Build in function which can be applied to ensure meshes of a special queue (opaque, alpha test, transparent)
     * are rendered back to front.
     *
     * @param a The first submesh
     * @param b The second submesh
     * @returns The result of the comparison
     */ // eslint-disable-next-line @typescript-eslint/naming-convention
    static backToFrontSortCompare(a, b) {
        // Then distance to camera
        if (a._distanceToCamera < b._distanceToCamera) return 1;
        if (a._distanceToCamera > b._distanceToCamera) return -1;
        return 0;
    }
    /**
     * Build in function which can be applied to ensure meshes of a special queue (opaque, alpha test, transparent)
     * are rendered front to back (prevent overdraw).
     *
     * @param a The first submesh
     * @param b The second submesh
     * @returns The result of the comparison
     */ // eslint-disable-next-line @typescript-eslint/naming-convention
    static frontToBackSortCompare(a, b) {
        // Then distance to camera
        if (a._distanceToCamera < b._distanceToCamera) return -1;
        if (a._distanceToCamera > b._distanceToCamera) return 1;
        return 0;
    }
    /**
     * Build in function which can be applied to ensure meshes of a special queue (opaque, alpha test, transparent)
     * are grouped by material then geometry.
     *
     * @param a The first submesh
     * @param b The second submesh
     * @returns The result of the comparison
     */ static PainterSortCompare(a, b) {
        const meshA = a.getMesh();
        const meshB = b.getMesh();
        if (meshA.material && meshB.material) return meshA.material.uniqueId - meshB.material.uniqueId;
        return meshA.uniqueId - meshB.uniqueId;
    }
    /**
     * Resets the different lists of submeshes to prepare a new frame.
     */ prepare() {
        this._opaqueSubMeshes.reset();
        this._transparentSubMeshes.reset();
        this._alphaTestSubMeshes.reset();
        this._depthOnlySubMeshes.reset();
        this._particleSystems.reset();
        this.prepareSprites();
        this._edgesRenderers.reset();
        this._empty = true;
    }
    /**
     * Resets the different lists of sprites to prepare a new frame.
     */ prepareSprites() {
        this._spriteManagers.reset();
    }
    dispose() {
        this._opaqueSubMeshes.dispose();
        this._transparentSubMeshes.dispose();
        this._alphaTestSubMeshes.dispose();
        this._depthOnlySubMeshes.dispose();
        this._particleSystems.dispose();
        this._spriteManagers.dispose();
        this._edgesRenderers.dispose();
    }
    /**
     * Inserts the submesh in its correct queue depending on its material.
     * @param subMesh The submesh to dispatch
     * @param [mesh] Optional reference to the submeshes's mesh. Provide if you have an exiting reference to improve performance.
     * @param [material] Optional reference to the submeshes's material. Provide if you have an exiting reference to improve performance.
     */ dispatch(subMesh, mesh, material) {
        // Get mesh and materials if not provided
        if (mesh === undefined) mesh = subMesh.getMesh();
        if (material === undefined) material = subMesh.getMaterial();
        if (material === null || material === undefined) return;
        if (material.needAlphaBlendingForMesh(mesh)) // Transparent
        this._transparentSubMeshes.push(subMesh);
        else if (material.needAlphaTesting()) {
            // Alpha test
            if (material.needDepthPrePass) this._depthOnlySubMeshes.push(subMesh);
            this._alphaTestSubMeshes.push(subMesh);
        } else {
            if (material.needDepthPrePass) this._depthOnlySubMeshes.push(subMesh);
            this._opaqueSubMeshes.push(subMesh); // Opaque
        }
        mesh._renderingGroup = this;
        if (mesh._edgesRenderer && mesh._edgesRenderer.isEnabled) this._edgesRenderers.pushNoDuplicate(mesh._edgesRenderer);
        this._empty = false;
    }
    dispatchSprites(spriteManager) {
        this._spriteManagers.push(spriteManager);
        this._empty = false;
    }
    dispatchParticles(particleSystem) {
        this._particleSystems.push(particleSystem);
        this._empty = false;
    }
    _renderParticles(activeMeshes) {
        if (this._particleSystems.length === 0) return;
        // Particles
        const activeCamera = this._scene.activeCamera;
        this._scene.onBeforeParticlesRenderingObservable.notifyObservers(this._scene);
        for(let particleIndex = 0; particleIndex < this._particleSystems.length; particleIndex++){
            const particleSystem = this._particleSystems.data[particleIndex];
            if ((activeCamera && activeCamera.layerMask & particleSystem.layerMask) === 0) continue;
            const emitter = particleSystem.emitter;
            if (!emitter.position || !activeMeshes || activeMeshes.indexOf(emitter) !== -1) this._scene._activeParticles.addCount(particleSystem.render(), false);
        }
        this._scene.onAfterParticlesRenderingObservable.notifyObservers(this._scene);
    }
    _renderSprites() {
        if (!this._scene.spritesEnabled || this._spriteManagers.length === 0) return;
        // Sprites
        const activeCamera = this._scene.activeCamera;
        this._scene.onBeforeSpritesRenderingObservable.notifyObservers(this._scene);
        for(let id = 0; id < this._spriteManagers.length; id++){
            const spriteManager = this._spriteManagers.data[id];
            if ((activeCamera && activeCamera.layerMask & spriteManager.layerMask) !== 0) spriteManager.render();
        }
        this._scene.onAfterSpritesRenderingObservable.notifyObservers(this._scene);
    }
}
$53360c0949bf5711$export$9c1352b86d43d054._ZeroVector = (0, $ha1VO.Vector3).Zero();

});


parcelRegister("bv05l", function(module, exports) {

$parcel$export(module.exports, "SceneComponentConstants", () => $85f2a7de3c8a2128$export$1e988a9817f2f20f);
$parcel$export(module.exports, "Stage", () => $85f2a7de3c8a2128$export$208cd1682bd0e4b6);
/**
 * Groups all the scene component constants in one place to ease maintenance.
 * @internal
 */ class $85f2a7de3c8a2128$export$1e988a9817f2f20f {
}
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_EFFECTLAYER = "EffectLayer";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_LAYER = "Layer";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_LENSFLARESYSTEM = "LensFlareSystem";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_BOUNDINGBOXRENDERER = "BoundingBoxRenderer";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_PARTICLESYSTEM = "ParticleSystem";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_GAMEPAD = "Gamepad";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_SIMPLIFICATIONQUEUE = "SimplificationQueue";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_GEOMETRYBUFFERRENDERER = "GeometryBufferRenderer";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_PREPASSRENDERER = "PrePassRenderer";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_DEPTHRENDERER = "DepthRenderer";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_DEPTHPEELINGRENDERER = "DepthPeelingRenderer";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_POSTPROCESSRENDERPIPELINEMANAGER = "PostProcessRenderPipelineManager";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_SPRITE = "Sprite";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_SUBSURFACE = "SubSurface";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_OUTLINERENDERER = "Outline";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_PROCEDURALTEXTURE = "ProceduralTexture";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_SHADOWGENERATOR = "ShadowGenerator";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_OCTREE = "Octree";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_PHYSICSENGINE = "PhysicsEngine";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_AUDIO = "Audio";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.NAME_FLUIDRENDERER = "FluidRenderer";
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_ISREADYFORMESH_EFFECTLAYER = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_BEFOREEVALUATEACTIVEMESH_BOUNDINGBOXRENDERER = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_EVALUATESUBMESH_BOUNDINGBOXRENDERER = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_PREACTIVEMESH_BOUNDINGBOXRENDERER = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_CAMERADRAWRENDERTARGET_EFFECTLAYER = 1;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_BEFORECAMERADRAW_PREPASS = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_BEFORECAMERADRAW_EFFECTLAYER = 1;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_BEFORECAMERADRAW_LAYER = 2;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_BEFORERENDERTARGETDRAW_PREPASS = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_BEFORERENDERTARGETDRAW_LAYER = 1;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_BEFORERENDERINGMESH_PREPASS = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_BEFORERENDERINGMESH_OUTLINE = 1;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_AFTERRENDERINGMESH_PREPASS = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_AFTERRENDERINGMESH_OUTLINE = 1;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_AFTERRENDERINGGROUPDRAW_EFFECTLAYER_DRAW = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_AFTERRENDERINGGROUPDRAW_BOUNDINGBOXRENDERER = 1;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_BEFORECAMERAUPDATE_SIMPLIFICATIONQUEUE = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_BEFORECAMERAUPDATE_GAMEPAD = 1;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_BEFORECLEAR_PROCEDURALTEXTURE = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_BEFORECLEAR_PREPASS = 1;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_BEFORERENDERTARGETCLEAR_PREPASS = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_AFTERRENDERTARGETDRAW_PREPASS = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_AFTERRENDERTARGETDRAW_LAYER = 1;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_AFTERCAMERADRAW_PREPASS = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_AFTERCAMERADRAW_EFFECTLAYER = 1;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_AFTERCAMERADRAW_LENSFLARESYSTEM = 2;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_AFTERCAMERADRAW_EFFECTLAYER_DRAW = 3;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_AFTERCAMERADRAW_LAYER = 4;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_AFTERCAMERADRAW_FLUIDRENDERER = 5;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_AFTERCAMERAPOSTPROCESS_LAYER = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_AFTERRENDERTARGETPOSTPROCESS_LAYER = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_AFTERRENDER_AUDIO = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_GATHERRENDERTARGETS_DEPTHRENDERER = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_GATHERRENDERTARGETS_GEOMETRYBUFFERRENDERER = 1;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_GATHERRENDERTARGETS_SHADOWGENERATOR = 2;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_GATHERRENDERTARGETS_POSTPROCESSRENDERPIPELINEMANAGER = 3;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_GATHERACTIVECAMERARENDERTARGETS_DEPTHRENDERER = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_GATHERACTIVECAMERARENDERTARGETS_FLUIDRENDERER = 1;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_POINTERMOVE_SPRITE = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_POINTERDOWN_SPRITE = 0;
$85f2a7de3c8a2128$export$1e988a9817f2f20f.STEP_POINTERUP_SPRITE = 0;
class $85f2a7de3c8a2128$export$208cd1682bd0e4b6 extends Array {
    /**
     * Hide ctor from the rest of the world.
     * @param items The items to add.
     */ constructor(items){
        super(...items);
    }
    /**
     * Creates a new Stage.
     * @returns A new instance of a Stage
     */ static Create() {
        return Object.create($85f2a7de3c8a2128$export$208cd1682bd0e4b6.prototype);
    }
    /**
     * Registers a step in an ordered way in the targeted stage.
     * @param index Defines the position to register the step in
     * @param component Defines the component attached to the step
     * @param action Defines the action to launch during the step
     */ registerStep(index, component, action) {
        let i = 0;
        let maxIndex = Number.MAX_VALUE;
        for(; i < this.length; i++){
            const step = this[i];
            maxIndex = step.index;
            if (index < maxIndex) break;
        }
        this.splice(i, 0, {
            index: index,
            component: component,
            action: action.bind(component)
        });
    }
    /**
     * Clears all the steps from the stage.
     */ clear() {
        this.length = 0;
    }
}

});

parcelRegister("7md5A", function(module, exports) {

$parcel$export(module.exports, "InputManager", () => $55b4bdb4e513ac29$export$2da2653229140a6c);

var $cfkw4 = parcelRequire("cfkw4");

var $kNPE8 = parcelRequire("kNPE8");

var $gzCma = parcelRequire("gzCma");

var $ha1VO = parcelRequire("ha1VO");

var $cmj0B = parcelRequire("cmj0B");

var $bcFoB = parcelRequire("bcFoB");

var $1orLO = parcelRequire("1orLO");

var $gAZ7u = parcelRequire("gAZ7u");

var $ejQPp = parcelRequire("ejQPp");
/** @internal */ // eslint-disable-next-line @typescript-eslint/naming-convention
class $55b4bdb4e513ac29$var$_ClickInfo {
    constructor(){
        this._singleClick = false;
        this._doubleClick = false;
        this._hasSwiped = false;
        this._ignore = false;
    }
    get singleClick() {
        return this._singleClick;
    }
    get doubleClick() {
        return this._doubleClick;
    }
    get hasSwiped() {
        return this._hasSwiped;
    }
    get ignore() {
        return this._ignore;
    }
    set singleClick(b) {
        this._singleClick = b;
    }
    set doubleClick(b) {
        this._doubleClick = b;
    }
    set hasSwiped(b) {
        this._hasSwiped = b;
    }
    set ignore(b) {
        this._ignore = b;
    }
}
class $55b4bdb4e513ac29$export$2da2653229140a6c {
    /**
     * Creates a new InputManager
     * @param scene - defines the hosting scene
     */ constructor(scene){
        /** This is a defensive check to not allow control attachment prior to an already active one. If already attached, previous control is unattached before attaching the new one. */ this._alreadyAttached = false;
        this._meshPickProceed = false;
        this._currentPickResult = null;
        this._previousPickResult = null;
        this._totalPointersPressed = 0;
        this._doubleClickOccured = false;
        this._isSwiping = false;
        this._swipeButtonPressed = -1;
        this._skipPointerTap = false;
        this._isMultiTouchGesture = false;
        this._pointerX = 0;
        this._pointerY = 0;
        this._startingPointerPosition = new (0, $ha1VO.Vector2)(0, 0);
        this._previousStartingPointerPosition = new (0, $ha1VO.Vector2)(0, 0);
        this._startingPointerTime = 0;
        this._previousStartingPointerTime = 0;
        this._pointerCaptures = {};
        this._meshUnderPointerId = {};
        this._movePointerInfo = null;
        this._cameraObserverCount = 0;
        this._delayedClicks = [
            null,
            null,
            null,
            null,
            null
        ];
        this._deviceSourceManager = null;
        this._scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        if (!this._scene) return;
    }
    /**
     * Gets the mesh that is currently under the pointer
     * @returns Mesh that the pointer is pointer is hovering over
     */ get meshUnderPointer() {
        if (this._movePointerInfo) {
            // Because _pointerOverMesh is populated as part of _pickMove, we need to force a pick to update it.
            // Calling _pickMove calls _setCursorAndPointerOverMesh which calls setPointerOverMesh
            this._movePointerInfo._generatePickInfo();
            // Once we have what we need, we can clear _movePointerInfo because we don't need it anymore
            this._movePointerInfo = null;
        }
        return this._pointerOverMesh;
    }
    /**
     * When using more than one pointer (for example in XR) you can get the mesh under the specific pointer
     * @param pointerId - the pointer id to use
     * @returns The mesh under this pointer id or null if not found
     */ getMeshUnderPointerByPointerId(pointerId) {
        return this._meshUnderPointerId[pointerId] || null;
    }
    /**
     * Gets the pointer coordinates in 2D without any translation (ie. straight out of the pointer event)
     * @returns Vector with X/Y values directly from pointer event
     */ get unTranslatedPointer() {
        return new (0, $ha1VO.Vector2)(this._unTranslatedPointerX, this._unTranslatedPointerY);
    }
    /**
     * Gets or sets the current on-screen X position of the pointer
     * @returns Translated X with respect to screen
     */ get pointerX() {
        return this._pointerX;
    }
    set pointerX(value) {
        this._pointerX = value;
    }
    /**
     * Gets or sets the current on-screen Y position of the pointer
     * @returns Translated Y with respect to screen
     */ get pointerY() {
        return this._pointerY;
    }
    set pointerY(value) {
        this._pointerY = value;
    }
    _updatePointerPosition(evt) {
        const canvasRect = this._scene.getEngine().getInputElementClientRect();
        if (!canvasRect) return;
        this._pointerX = evt.clientX - canvasRect.left;
        this._pointerY = evt.clientY - canvasRect.top;
        this._unTranslatedPointerX = this._pointerX;
        this._unTranslatedPointerY = this._pointerY;
    }
    _processPointerMove(pickResult, evt) {
        const scene = this._scene;
        const engine = scene.getEngine();
        const canvas = engine.getInputElement();
        if (canvas) {
            canvas.tabIndex = engine.canvasTabIndex;
            // Restore pointer
            if (!scene.doNotHandleCursors) canvas.style.cursor = scene.defaultCursor;
        }
        this._setCursorAndPointerOverMesh(pickResult, evt, scene);
        for (const step of scene._pointerMoveStage){
            // If _pointerMoveState is defined, we have an active spriteManager and can't use Lazy Picking
            // Therefore, we need to force a pick to update the pickResult
            pickResult = pickResult || this._pickMove(evt);
            const isMeshPicked = pickResult?.pickedMesh ? true : false;
            pickResult = step.action(this._unTranslatedPointerX, this._unTranslatedPointerY, pickResult, isMeshPicked, canvas);
        }
        const type = evt.inputIndex >= (0, $1orLO.PointerInput).MouseWheelX && evt.inputIndex <= (0, $1orLO.PointerInput).MouseWheelZ ? (0, $cfkw4.PointerEventTypes).POINTERWHEEL : (0, $cfkw4.PointerEventTypes).POINTERMOVE;
        if (scene.onPointerMove) {
            // Because of lazy picking, we need to force a pick to update the pickResult
            pickResult = pickResult || this._pickMove(evt);
            scene.onPointerMove(evt, pickResult, type);
        }
        let pointerInfo;
        if (pickResult) {
            pointerInfo = new (0, $cfkw4.PointerInfo)(type, evt, pickResult);
            this._setRayOnPointerInfo(pickResult, evt);
        } else {
            pointerInfo = new (0, $cfkw4.PointerInfo)(type, evt, null, this);
            this._movePointerInfo = pointerInfo;
        }
        if (scene.onPointerObservable.hasObservers()) scene.onPointerObservable.notifyObservers(pointerInfo, type);
    }
    // Pointers handling
    /** @internal */ _setRayOnPointerInfo(pickInfo, event) {
        const scene = this._scene;
        if (pickInfo && scene._pickingAvailable) {
            if (!pickInfo.ray) pickInfo.ray = scene.createPickingRay(event.offsetX, event.offsetY, (0, $ha1VO.Matrix).Identity(), scene.activeCamera);
        }
    }
    /** @internal */ _addCameraPointerObserver(observer, mask) {
        this._cameraObserverCount++;
        return this._scene.onPointerObservable.add(observer, mask);
    }
    /** @internal */ _removeCameraPointerObserver(observer) {
        this._cameraObserverCount--;
        return this._scene.onPointerObservable.remove(observer);
    }
    _checkForPicking() {
        return !!(this._scene.onPointerObservable.observers.length > this._cameraObserverCount || this._scene.onPointerPick);
    }
    _checkPrePointerObservable(pickResult, evt, type) {
        const scene = this._scene;
        const pi = new (0, $cfkw4.PointerInfoPre)(type, evt, this._unTranslatedPointerX, this._unTranslatedPointerY);
        if (pickResult) {
            pi.originalPickingInfo = pickResult;
            pi.ray = pickResult.ray;
            if (evt.pointerType === "xr-near" && pickResult.originMesh) pi.nearInteractionPickingInfo = pickResult;
        }
        scene.onPrePointerObservable.notifyObservers(pi, type);
        if (pi.skipOnPointerObservable) return true;
        else return false;
    }
    /** @internal */ _pickMove(evt) {
        const scene = this._scene;
        const pickResult = scene.pick(this._unTranslatedPointerX, this._unTranslatedPointerY, scene.pointerMovePredicate, scene.pointerMoveFastCheck, scene.cameraToUseForPointers, scene.pointerMoveTrianglePredicate);
        this._setCursorAndPointerOverMesh(pickResult, evt, scene);
        return pickResult;
    }
    _setCursorAndPointerOverMesh(pickResult, evt, scene) {
        const engine = scene.getEngine();
        const canvas = engine.getInputElement();
        if (pickResult?.pickedMesh) {
            this.setPointerOverMesh(pickResult.pickedMesh, evt.pointerId, pickResult, evt);
            if (!scene.doNotHandleCursors && canvas && this._pointerOverMesh) {
                const actionManager = this._pointerOverMesh._getActionManagerForTrigger();
                if (actionManager && actionManager.hasPointerTriggers) canvas.style.cursor = actionManager.hoverCursor || scene.hoverCursor;
            }
        } else this.setPointerOverMesh(null, evt.pointerId, pickResult, evt);
    }
    /**
     * Use this method to simulate a pointer move on a mesh
     * The pickResult parameter can be obtained from a scene.pick or scene.pickWithRay
     * @param pickResult - pickingInfo of the object wished to simulate pointer event on
     * @param pointerEventInit - pointer event state to be used when simulating the pointer event (eg. pointer id for multitouch)
     */ simulatePointerMove(pickResult, pointerEventInit) {
        const evt = new PointerEvent("pointermove", pointerEventInit);
        evt.inputIndex = (0, $1orLO.PointerInput).Move;
        if (this._checkPrePointerObservable(pickResult, evt, (0, $cfkw4.PointerEventTypes).POINTERMOVE)) return;
        this._processPointerMove(pickResult, evt);
    }
    /**
     * Use this method to simulate a pointer down on a mesh
     * The pickResult parameter can be obtained from a scene.pick or scene.pickWithRay
     * @param pickResult - pickingInfo of the object wished to simulate pointer event on
     * @param pointerEventInit - pointer event state to be used when simulating the pointer event (eg. pointer id for multitouch)
     */ simulatePointerDown(pickResult, pointerEventInit) {
        const evt = new PointerEvent("pointerdown", pointerEventInit);
        evt.inputIndex = evt.button + 2;
        if (this._checkPrePointerObservable(pickResult, evt, (0, $cfkw4.PointerEventTypes).POINTERDOWN)) return;
        this._processPointerDown(pickResult, evt);
    }
    _processPointerDown(pickResult, evt) {
        const scene = this._scene;
        if (pickResult?.pickedMesh) {
            this._pickedDownMesh = pickResult.pickedMesh;
            const actionManager = pickResult.pickedMesh._getActionManagerForTrigger();
            if (actionManager) {
                if (actionManager.hasPickTriggers) {
                    actionManager.processTrigger(5, (0, $cmj0B.ActionEvent).CreateNew(pickResult.pickedMesh, evt, pickResult));
                    switch(evt.button){
                        case 0:
                            actionManager.processTrigger(2, (0, $cmj0B.ActionEvent).CreateNew(pickResult.pickedMesh, evt, pickResult));
                            break;
                        case 1:
                            actionManager.processTrigger(4, (0, $cmj0B.ActionEvent).CreateNew(pickResult.pickedMesh, evt, pickResult));
                            break;
                        case 2:
                            actionManager.processTrigger(3, (0, $cmj0B.ActionEvent).CreateNew(pickResult.pickedMesh, evt, pickResult));
                            break;
                    }
                }
                if (actionManager.hasSpecificTrigger(8)) window.setTimeout(()=>{
                    const pickResult = scene.pick(this._unTranslatedPointerX, this._unTranslatedPointerY, (mesh)=>mesh.isPickable && mesh.isVisible && mesh.isReady() && mesh.actionManager && mesh.actionManager.hasSpecificTrigger(8) && mesh === this._pickedDownMesh, false, scene.cameraToUseForPointers);
                    if (pickResult?.pickedMesh && actionManager) {
                        if (this._totalPointersPressed !== 0 && Date.now() - this._startingPointerTime > $55b4bdb4e513ac29$export$2da2653229140a6c.LongPressDelay && !this._isPointerSwiping()) {
                            this._startingPointerTime = 0;
                            actionManager.processTrigger(8, (0, $cmj0B.ActionEvent).CreateNew(pickResult.pickedMesh, evt));
                        }
                    }
                }, $55b4bdb4e513ac29$export$2da2653229140a6c.LongPressDelay);
            }
        } else for (const step of scene._pointerDownStage)pickResult = step.action(this._unTranslatedPointerX, this._unTranslatedPointerY, pickResult, evt, false);
        let pointerInfo;
        const type = (0, $cfkw4.PointerEventTypes).POINTERDOWN;
        if (pickResult) {
            if (scene.onPointerDown) scene.onPointerDown(evt, pickResult, type);
            pointerInfo = new (0, $cfkw4.PointerInfo)(type, evt, pickResult);
            this._setRayOnPointerInfo(pickResult, evt);
        } else pointerInfo = new (0, $cfkw4.PointerInfo)(type, evt, null, this);
        if (scene.onPointerObservable.hasObservers()) scene.onPointerObservable.notifyObservers(pointerInfo, type);
    }
    /**
     * @internal
     * @internals Boolean if delta for pointer exceeds drag movement threshold
     */ _isPointerSwiping() {
        return this._isSwiping;
    }
    /**
     * Use this method to simulate a pointer up on a mesh
     * The pickResult parameter can be obtained from a scene.pick or scene.pickWithRay
     * @param pickResult - pickingInfo of the object wished to simulate pointer event on
     * @param pointerEventInit - pointer event state to be used when simulating the pointer event (eg. pointer id for multitouch)
     * @param doubleTap - indicates that the pointer up event should be considered as part of a double click (false by default)
     */ simulatePointerUp(pickResult, pointerEventInit, doubleTap) {
        const evt = new PointerEvent("pointerup", pointerEventInit);
        evt.inputIndex = (0, $1orLO.PointerInput).Move;
        const clickInfo = new $55b4bdb4e513ac29$var$_ClickInfo();
        if (doubleTap) clickInfo.doubleClick = true;
        else clickInfo.singleClick = true;
        if (this._checkPrePointerObservable(pickResult, evt, (0, $cfkw4.PointerEventTypes).POINTERUP)) return;
        this._processPointerUp(pickResult, evt, clickInfo);
    }
    _processPointerUp(pickResult, evt, clickInfo) {
        const scene = this._scene;
        if (pickResult?.pickedMesh) {
            this._pickedUpMesh = pickResult.pickedMesh;
            if (this._pickedDownMesh === this._pickedUpMesh) {
                if (scene.onPointerPick) scene.onPointerPick(evt, pickResult);
                if (clickInfo.singleClick && !clickInfo.ignore && scene.onPointerObservable.observers.length > this._cameraObserverCount) {
                    const type = (0, $cfkw4.PointerEventTypes).POINTERPICK;
                    const pi = new (0, $cfkw4.PointerInfo)(type, evt, pickResult);
                    this._setRayOnPointerInfo(pickResult, evt);
                    scene.onPointerObservable.notifyObservers(pi, type);
                }
            }
            const actionManager = pickResult.pickedMesh._getActionManagerForTrigger();
            if (actionManager && !clickInfo.ignore) {
                actionManager.processTrigger(7, (0, $cmj0B.ActionEvent).CreateNew(pickResult.pickedMesh, evt, pickResult));
                if (!clickInfo.hasSwiped && clickInfo.singleClick) actionManager.processTrigger(1, (0, $cmj0B.ActionEvent).CreateNew(pickResult.pickedMesh, evt, pickResult));
                const doubleClickActionManager = pickResult.pickedMesh._getActionManagerForTrigger(6);
                if (clickInfo.doubleClick && doubleClickActionManager) doubleClickActionManager.processTrigger(6, (0, $cmj0B.ActionEvent).CreateNew(pickResult.pickedMesh, evt, pickResult));
            }
        } else {
            if (!clickInfo.ignore) for (const step of scene._pointerUpStage)pickResult = step.action(this._unTranslatedPointerX, this._unTranslatedPointerY, pickResult, evt, clickInfo.doubleClick);
        }
        if (this._pickedDownMesh && this._pickedDownMesh !== this._pickedUpMesh) {
            const pickedDownActionManager = this._pickedDownMesh._getActionManagerForTrigger(16);
            if (pickedDownActionManager) pickedDownActionManager.processTrigger(16, (0, $cmj0B.ActionEvent).CreateNew(this._pickedDownMesh, evt));
        }
        if (!clickInfo.ignore) {
            const pi = new (0, $cfkw4.PointerInfo)((0, $cfkw4.PointerEventTypes).POINTERUP, evt, pickResult);
            // Set ray on picking info.  Note that this info will also be reused for the tap notification.
            this._setRayOnPointerInfo(pickResult, evt);
            scene.onPointerObservable.notifyObservers(pi, (0, $cfkw4.PointerEventTypes).POINTERUP);
            if (scene.onPointerUp) scene.onPointerUp(evt, pickResult, (0, $cfkw4.PointerEventTypes).POINTERUP);
            if (!clickInfo.hasSwiped && !this._skipPointerTap && !this._isMultiTouchGesture) {
                let type = 0;
                if (clickInfo.singleClick) type = (0, $cfkw4.PointerEventTypes).POINTERTAP;
                else if (clickInfo.doubleClick) type = (0, $cfkw4.PointerEventTypes).POINTERDOUBLETAP;
                if (type) {
                    const pi = new (0, $cfkw4.PointerInfo)(type, evt, pickResult);
                    if (scene.onPointerObservable.hasObservers() && scene.onPointerObservable.hasSpecificMask(type)) scene.onPointerObservable.notifyObservers(pi, type);
                }
            }
        }
    }
    /**
     * Gets a boolean indicating if the current pointer event is captured (meaning that the scene has already handled the pointer down)
     * @param pointerId - defines the pointer id to use in a multi-touch scenario (0 by default)
     * @returns true if the pointer was captured
     */ isPointerCaptured(pointerId = 0) {
        return this._pointerCaptures[pointerId];
    }
    /**
     * Attach events to the canvas (To handle actionManagers triggers and raise onPointerMove, onPointerDown and onPointerUp
     * @param attachUp - defines if you want to attach events to pointerup
     * @param attachDown - defines if you want to attach events to pointerdown
     * @param attachMove - defines if you want to attach events to pointermove
     * @param elementToAttachTo - defines the target DOM element to attach to (will use the canvas by default)
     */ attachControl(attachUp = true, attachDown = true, attachMove = true, elementToAttachTo = null) {
        const scene = this._scene;
        const engine = scene.getEngine();
        if (!elementToAttachTo) elementToAttachTo = engine.getInputElement();
        if (this._alreadyAttached) this.detachControl();
        if (elementToAttachTo) this._alreadyAttachedTo = elementToAttachTo;
        this._deviceSourceManager = new (0, $gAZ7u.DeviceSourceManager)(engine);
        // Because this is only called from _initClickEvent, which is called in _onPointerUp, we'll use the pointerUpPredicate for the pick call
        this._initActionManager = (act)=>{
            if (!this._meshPickProceed) {
                const pickResult = scene.skipPointerUpPicking || scene._registeredActions === 0 && !this._checkForPicking() && !scene.onPointerUp ? null : scene.pick(this._unTranslatedPointerX, this._unTranslatedPointerY, scene.pointerUpPredicate, scene.pointerUpFastCheck, scene.cameraToUseForPointers, scene.pointerUpTrianglePredicate);
                this._currentPickResult = pickResult;
                if (pickResult) act = pickResult.hit && pickResult.pickedMesh ? pickResult.pickedMesh._getActionManagerForTrigger() : null;
                this._meshPickProceed = true;
            }
            return act;
        };
        this._delayedSimpleClick = (btn, clickInfo, cb)=>{
            // double click delay is over and that no double click has been raised since, or the 2 consecutive keys pressed are different
            if (Date.now() - this._previousStartingPointerTime > $55b4bdb4e513ac29$export$2da2653229140a6c.DoubleClickDelay && !this._doubleClickOccured || btn !== this._previousButtonPressed) {
                this._doubleClickOccured = false;
                clickInfo.singleClick = true;
                clickInfo.ignore = false;
                // If we have a delayed click, we need to resolve the TAP event
                if (this._delayedClicks[btn]) {
                    const evt = this._delayedClicks[btn].evt;
                    const type = (0, $cfkw4.PointerEventTypes).POINTERTAP;
                    const pi = new (0, $cfkw4.PointerInfo)(type, evt, this._currentPickResult);
                    if (scene.onPointerObservable.hasObservers() && scene.onPointerObservable.hasSpecificMask(type)) scene.onPointerObservable.notifyObservers(pi, type);
                    // Clear the delayed click
                    this._delayedClicks[btn] = null;
                }
            }
        };
        this._initClickEvent = (obs1, obs2, evt, cb)=>{
            const clickInfo = new $55b4bdb4e513ac29$var$_ClickInfo();
            this._currentPickResult = null;
            let act = null;
            let checkPicking = obs1.hasSpecificMask((0, $cfkw4.PointerEventTypes).POINTERPICK) || obs2.hasSpecificMask((0, $cfkw4.PointerEventTypes).POINTERPICK) || obs1.hasSpecificMask((0, $cfkw4.PointerEventTypes).POINTERTAP) || obs2.hasSpecificMask((0, $cfkw4.PointerEventTypes).POINTERTAP) || obs1.hasSpecificMask((0, $cfkw4.PointerEventTypes).POINTERDOUBLETAP) || obs2.hasSpecificMask((0, $cfkw4.PointerEventTypes).POINTERDOUBLETAP);
            if (!checkPicking && (0, $kNPE8.AbstractActionManager)) {
                act = this._initActionManager(act, clickInfo);
                if (act) checkPicking = act.hasPickTriggers;
            }
            let needToIgnoreNext = false;
            if (checkPicking) {
                const btn = evt.button;
                clickInfo.hasSwiped = this._isPointerSwiping();
                if (!clickInfo.hasSwiped) {
                    let checkSingleClickImmediately = !$55b4bdb4e513ac29$export$2da2653229140a6c.ExclusiveDoubleClickMode;
                    if (!checkSingleClickImmediately) {
                        checkSingleClickImmediately = !obs1.hasSpecificMask((0, $cfkw4.PointerEventTypes).POINTERDOUBLETAP) && !obs2.hasSpecificMask((0, $cfkw4.PointerEventTypes).POINTERDOUBLETAP);
                        if (checkSingleClickImmediately && !(0, $kNPE8.AbstractActionManager).HasSpecificTrigger(6)) {
                            act = this._initActionManager(act, clickInfo);
                            if (act) checkSingleClickImmediately = !act.hasSpecificTrigger(6);
                        }
                    }
                    if (checkSingleClickImmediately) // single click detected if double click delay is over or two different successive keys pressed without exclusive double click or no double click required
                    {
                        if (Date.now() - this._previousStartingPointerTime > $55b4bdb4e513ac29$export$2da2653229140a6c.DoubleClickDelay || btn !== this._previousButtonPressed) {
                            clickInfo.singleClick = true;
                            cb(clickInfo, this._currentPickResult);
                            needToIgnoreNext = true;
                        }
                    } else {
                        // Queue up a delayed click, just in case this isn't a double click
                        // It should be noted that while this delayed event happens
                        // because of user input, it shouldn't be considered as a direct,
                        // timing-dependent result of that input.  It's meant to just fire the TAP event
                        const delayedClick = {
                            evt: evt,
                            clickInfo: clickInfo,
                            timeoutId: window.setTimeout(this._delayedSimpleClick.bind(this, btn, clickInfo, cb), $55b4bdb4e513ac29$export$2da2653229140a6c.DoubleClickDelay)
                        };
                        this._delayedClicks[btn] = delayedClick;
                    }
                    let checkDoubleClick = obs1.hasSpecificMask((0, $cfkw4.PointerEventTypes).POINTERDOUBLETAP) || obs2.hasSpecificMask((0, $cfkw4.PointerEventTypes).POINTERDOUBLETAP);
                    if (!checkDoubleClick && (0, $kNPE8.AbstractActionManager).HasSpecificTrigger(6)) {
                        act = this._initActionManager(act, clickInfo);
                        if (act) checkDoubleClick = act.hasSpecificTrigger(6);
                    }
                    if (checkDoubleClick) {
                        // two successive keys pressed are equal, double click delay is not over and double click has not just occurred
                        if (btn === this._previousButtonPressed && Date.now() - this._previousStartingPointerTime < $55b4bdb4e513ac29$export$2da2653229140a6c.DoubleClickDelay && !this._doubleClickOccured) {
                            // pointer has not moved for 2 clicks, it's a double click
                            if (!clickInfo.hasSwiped && !this._isPointerSwiping()) {
                                this._previousStartingPointerTime = 0;
                                this._doubleClickOccured = true;
                                clickInfo.doubleClick = true;
                                clickInfo.ignore = false;
                                // If we have a pending click, we need to cancel it
                                if ($55b4bdb4e513ac29$export$2da2653229140a6c.ExclusiveDoubleClickMode && this._delayedClicks[btn]) {
                                    clearTimeout(this._delayedClicks[btn]?.timeoutId);
                                    this._delayedClicks[btn] = null;
                                }
                                cb(clickInfo, this._currentPickResult);
                            } else {
                                this._doubleClickOccured = false;
                                this._previousStartingPointerTime = this._startingPointerTime;
                                this._previousStartingPointerPosition.x = this._startingPointerPosition.x;
                                this._previousStartingPointerPosition.y = this._startingPointerPosition.y;
                                this._previousButtonPressed = btn;
                                if ($55b4bdb4e513ac29$export$2da2653229140a6c.ExclusiveDoubleClickMode) {
                                    // If we have a delayed click, we need to cancel it
                                    if (this._delayedClicks[btn]) {
                                        clearTimeout(this._delayedClicks[btn]?.timeoutId);
                                        this._delayedClicks[btn] = null;
                                    }
                                    cb(clickInfo, this._previousPickResult);
                                } else cb(clickInfo, this._currentPickResult);
                            }
                            needToIgnoreNext = true;
                        } else {
                            this._doubleClickOccured = false;
                            this._previousStartingPointerTime = this._startingPointerTime;
                            this._previousStartingPointerPosition.x = this._startingPointerPosition.x;
                            this._previousStartingPointerPosition.y = this._startingPointerPosition.y;
                            this._previousButtonPressed = btn;
                        }
                    }
                }
            }
            // Even if ExclusiveDoubleClickMode is true, we need to always handle
            // up events at time of execution, unless we're explicitly ignoring them.
            if (!needToIgnoreNext) cb(clickInfo, this._currentPickResult);
        };
        this._onPointerMove = (evt)=>{
            this._updatePointerPosition(evt);
            // Check if pointer leaves DragMovementThreshold range to determine if swipe is occurring
            if (!this._isSwiping && this._swipeButtonPressed !== -1) this._isSwiping = Math.abs(this._startingPointerPosition.x - this._pointerX) > $55b4bdb4e513ac29$export$2da2653229140a6c.DragMovementThreshold || Math.abs(this._startingPointerPosition.y - this._pointerY) > $55b4bdb4e513ac29$export$2da2653229140a6c.DragMovementThreshold;
            // Because there's a race condition between pointermove and pointerlockchange events, we need to
            // verify that the pointer is still locked after each pointermove event.
            if (engine.isPointerLock) engine._verifyPointerLock();
            // PreObservable support
            if (this._checkPrePointerObservable(null, evt, evt.inputIndex >= (0, $1orLO.PointerInput).MouseWheelX && evt.inputIndex <= (0, $1orLO.PointerInput).MouseWheelZ ? (0, $cfkw4.PointerEventTypes).POINTERWHEEL : (0, $cfkw4.PointerEventTypes).POINTERMOVE)) return;
            if (!scene.cameraToUseForPointers && !scene.activeCamera) return;
            if (scene.skipPointerMovePicking) {
                this._processPointerMove(new (0, $gzCma.PickingInfo)(), evt);
                return;
            }
            if (!scene.pointerMovePredicate) scene.pointerMovePredicate = (mesh)=>mesh.isPickable && mesh.isVisible && mesh.isReady() && mesh.isEnabled() && (mesh.enablePointerMoveEvents || scene.constantlyUpdateMeshUnderPointer || mesh._getActionManagerForTrigger() !== null) && (!scene.cameraToUseForPointers || (scene.cameraToUseForPointers.layerMask & mesh.layerMask) !== 0);
            const pickResult = scene._registeredActions > 0 || scene.constantlyUpdateMeshUnderPointer ? this._pickMove(evt) : null;
            this._processPointerMove(pickResult, evt);
        };
        this._onPointerDown = (evt)=>{
            this._totalPointersPressed++;
            this._pickedDownMesh = null;
            this._meshPickProceed = false;
            // If ExclusiveDoubleClickMode is true, we need to resolve any pending delayed clicks
            if ($55b4bdb4e513ac29$export$2da2653229140a6c.ExclusiveDoubleClickMode) {
                for(let i = 0; i < this._delayedClicks.length; i++)if (this._delayedClicks[i]) {
                    // If the button that was pressed is the same as the one that was released,
                    // just clear the timer.  This will be resolved in the up event.
                    if (evt.button === i) clearTimeout(this._delayedClicks[i]?.timeoutId);
                    else {
                        // Otherwise, we need to resolve the click
                        const clickInfo = this._delayedClicks[i].clickInfo;
                        this._doubleClickOccured = false;
                        clickInfo.singleClick = true;
                        clickInfo.ignore = false;
                        const prevEvt = this._delayedClicks[i].evt;
                        const type = (0, $cfkw4.PointerEventTypes).POINTERTAP;
                        const pi = new (0, $cfkw4.PointerInfo)(type, prevEvt, this._currentPickResult);
                        if (scene.onPointerObservable.hasObservers() && scene.onPointerObservable.hasSpecificMask(type)) scene.onPointerObservable.notifyObservers(pi, type);
                        // Clear the delayed click
                        this._delayedClicks[i] = null;
                    }
                }
            }
            this._updatePointerPosition(evt);
            if (this._swipeButtonPressed === -1) this._swipeButtonPressed = evt.button;
            if (scene.preventDefaultOnPointerDown && elementToAttachTo) {
                evt.preventDefault();
                elementToAttachTo.focus();
            }
            this._startingPointerPosition.x = this._pointerX;
            this._startingPointerPosition.y = this._pointerY;
            this._startingPointerTime = Date.now();
            // PreObservable support
            if (this._checkPrePointerObservable(null, evt, (0, $cfkw4.PointerEventTypes).POINTERDOWN)) return;
            if (!scene.cameraToUseForPointers && !scene.activeCamera) return;
            this._pointerCaptures[evt.pointerId] = true;
            if (!scene.pointerDownPredicate) scene.pointerDownPredicate = (mesh)=>{
                return mesh.isPickable && mesh.isVisible && mesh.isReady() && mesh.isEnabled() && (!scene.cameraToUseForPointers || (scene.cameraToUseForPointers.layerMask & mesh.layerMask) !== 0);
            };
            // Meshes
            this._pickedDownMesh = null;
            let pickResult;
            if (scene.skipPointerDownPicking || scene._registeredActions === 0 && !this._checkForPicking() && !scene.onPointerDown) pickResult = new (0, $gzCma.PickingInfo)();
            else pickResult = scene.pick(this._unTranslatedPointerX, this._unTranslatedPointerY, scene.pointerDownPredicate, scene.pointerDownFastCheck, scene.cameraToUseForPointers, scene.pointerDownTrianglePredicate);
            this._processPointerDown(pickResult, evt);
        };
        this._onPointerUp = (evt)=>{
            if (this._totalPointersPressed === 0) // We are attaching the pointer up to windows because of a bug in FF
            return; // So we need to test it the pointer down was pressed before.
            this._totalPointersPressed--;
            this._pickedUpMesh = null;
            this._meshPickProceed = false;
            this._updatePointerPosition(evt);
            if (scene.preventDefaultOnPointerUp && elementToAttachTo) {
                evt.preventDefault();
                elementToAttachTo.focus();
            }
            this._initClickEvent(scene.onPrePointerObservable, scene.onPointerObservable, evt, (clickInfo, pickResult)=>{
                // PreObservable support
                if (scene.onPrePointerObservable.hasObservers()) {
                    this._skipPointerTap = false;
                    if (!clickInfo.ignore) {
                        if (this._checkPrePointerObservable(null, evt, (0, $cfkw4.PointerEventTypes).POINTERUP)) {
                            // If we're skipping the next observable, we need to reset the swipe state before returning
                            if (this._swipeButtonPressed === evt.button) {
                                this._isSwiping = false;
                                this._swipeButtonPressed = -1;
                            }
                            // If we're going to skip the POINTERUP, we need to reset the pointer capture
                            if (evt.buttons === 0) this._pointerCaptures[evt.pointerId] = false;
                            return;
                        }
                        if (!clickInfo.hasSwiped) {
                            if (clickInfo.singleClick && scene.onPrePointerObservable.hasSpecificMask((0, $cfkw4.PointerEventTypes).POINTERTAP)) {
                                if (this._checkPrePointerObservable(null, evt, (0, $cfkw4.PointerEventTypes).POINTERTAP)) this._skipPointerTap = true;
                            }
                            if (clickInfo.doubleClick && scene.onPrePointerObservable.hasSpecificMask((0, $cfkw4.PointerEventTypes).POINTERDOUBLETAP)) {
                                if (this._checkPrePointerObservable(null, evt, (0, $cfkw4.PointerEventTypes).POINTERDOUBLETAP)) this._skipPointerTap = true;
                            }
                        }
                    }
                }
                // There should be a pointer captured at this point so if there isn't we should reset and return
                if (!this._pointerCaptures[evt.pointerId]) {
                    if (this._swipeButtonPressed === evt.button) {
                        this._isSwiping = false;
                        this._swipeButtonPressed = -1;
                    }
                    return;
                }
                // Only release capture if all buttons are released
                if (evt.buttons === 0) this._pointerCaptures[evt.pointerId] = false;
                if (!scene.cameraToUseForPointers && !scene.activeCamera) return;
                if (!scene.pointerUpPredicate) scene.pointerUpPredicate = (mesh)=>{
                    return mesh.isPickable && mesh.isVisible && mesh.isReady() && mesh.isEnabled() && (!scene.cameraToUseForPointers || (scene.cameraToUseForPointers.layerMask & mesh.layerMask) !== 0);
                };
                // Meshes
                if (!this._meshPickProceed && ((0, $kNPE8.AbstractActionManager) && (0, $kNPE8.AbstractActionManager).HasTriggers || this._checkForPicking() || scene.onPointerUp)) this._initActionManager(null, clickInfo);
                if (!pickResult) pickResult = this._currentPickResult;
                this._processPointerUp(pickResult, evt, clickInfo);
                this._previousPickResult = this._currentPickResult;
                if (this._swipeButtonPressed === evt.button) {
                    this._isSwiping = false;
                    this._swipeButtonPressed = -1;
                }
            });
        };
        this._onKeyDown = (evt)=>{
            const type = (0, $bcFoB.KeyboardEventTypes).KEYDOWN;
            if (scene.onPreKeyboardObservable.hasObservers()) {
                const pi = new (0, $bcFoB.KeyboardInfoPre)(type, evt);
                scene.onPreKeyboardObservable.notifyObservers(pi, type);
                if (pi.skipOnKeyboardObservable) return;
            }
            if (scene.onKeyboardObservable.hasObservers()) {
                const pi = new (0, $bcFoB.KeyboardInfo)(type, evt);
                scene.onKeyboardObservable.notifyObservers(pi, type);
            }
            if (scene.actionManager) scene.actionManager.processTrigger(14, (0, $cmj0B.ActionEvent).CreateNewFromScene(scene, evt));
        };
        this._onKeyUp = (evt)=>{
            const type = (0, $bcFoB.KeyboardEventTypes).KEYUP;
            if (scene.onPreKeyboardObservable.hasObservers()) {
                const pi = new (0, $bcFoB.KeyboardInfoPre)(type, evt);
                scene.onPreKeyboardObservable.notifyObservers(pi, type);
                if (pi.skipOnKeyboardObservable) return;
            }
            if (scene.onKeyboardObservable.hasObservers()) {
                const pi = new (0, $bcFoB.KeyboardInfo)(type, evt);
                scene.onKeyboardObservable.notifyObservers(pi, type);
            }
            if (scene.actionManager) scene.actionManager.processTrigger(15, (0, $cmj0B.ActionEvent).CreateNewFromScene(scene, evt));
        };
        // If a device connects that we can handle, wire up the observable
        this._deviceSourceManager.onDeviceConnectedObservable.add((deviceSource)=>{
            if (deviceSource.deviceType === (0, $1orLO.DeviceType).Mouse) deviceSource.onInputChangedObservable.add((eventData)=>{
                if (eventData.inputIndex === (0, $1orLO.PointerInput).LeftClick || eventData.inputIndex === (0, $1orLO.PointerInput).MiddleClick || eventData.inputIndex === (0, $1orLO.PointerInput).RightClick || eventData.inputIndex === (0, $1orLO.PointerInput).BrowserBack || eventData.inputIndex === (0, $1orLO.PointerInput).BrowserForward) {
                    if (attachDown && deviceSource.getInput(eventData.inputIndex) === 1) this._onPointerDown(eventData);
                    else if (attachUp && deviceSource.getInput(eventData.inputIndex) === 0) this._onPointerUp(eventData);
                } else if (attachMove) {
                    if (eventData.inputIndex === (0, $1orLO.PointerInput).Move) this._onPointerMove(eventData);
                    else if (eventData.inputIndex === (0, $1orLO.PointerInput).MouseWheelX || eventData.inputIndex === (0, $1orLO.PointerInput).MouseWheelY || eventData.inputIndex === (0, $1orLO.PointerInput).MouseWheelZ) this._onPointerMove(eventData);
                }
            });
            else if (deviceSource.deviceType === (0, $1orLO.DeviceType).Touch) deviceSource.onInputChangedObservable.add((eventData)=>{
                if (eventData.inputIndex === (0, $1orLO.PointerInput).LeftClick) {
                    if (attachDown && deviceSource.getInput(eventData.inputIndex) === 1) {
                        this._onPointerDown(eventData);
                        if (this._totalPointersPressed > 1) this._isMultiTouchGesture = true;
                    } else if (attachUp && deviceSource.getInput(eventData.inputIndex) === 0) {
                        this._onPointerUp(eventData);
                        if (this._totalPointersPressed === 0) this._isMultiTouchGesture = false;
                    }
                }
                if (attachMove && eventData.inputIndex === (0, $1orLO.PointerInput).Move) this._onPointerMove(eventData);
            });
            else if (deviceSource.deviceType === (0, $1orLO.DeviceType).Keyboard) deviceSource.onInputChangedObservable.add((eventData)=>{
                if (eventData.type === "keydown") this._onKeyDown(eventData);
                else if (eventData.type === "keyup") this._onKeyUp(eventData);
            });
        });
        this._alreadyAttached = true;
    }
    /**
     * Detaches all event handlers
     */ detachControl() {
        if (this._alreadyAttached) {
            this._deviceSourceManager.dispose();
            this._deviceSourceManager = null;
            // Cursor
            if (this._alreadyAttachedTo && !this._scene.doNotHandleCursors) this._alreadyAttachedTo.style.cursor = this._scene.defaultCursor;
            this._alreadyAttached = false;
            this._alreadyAttachedTo = null;
        }
    }
    /**
     * Force the value of meshUnderPointer
     * @param mesh - defines the mesh to use
     * @param pointerId - optional pointer id when using more than one pointer. Defaults to 0
     * @param pickResult - optional pickingInfo data used to find mesh
     * @param evt - optional pointer event
     */ setPointerOverMesh(mesh, pointerId = 0, pickResult, evt) {
        if (this._meshUnderPointerId[pointerId] === mesh && (!mesh || !mesh._internalAbstractMeshDataInfo._pointerOverDisableMeshTesting)) return;
        const underPointerMesh = this._meshUnderPointerId[pointerId];
        let actionManager;
        if (underPointerMesh) {
            actionManager = underPointerMesh._getActionManagerForTrigger(10);
            if (actionManager) actionManager.processTrigger(10, (0, $cmj0B.ActionEvent).CreateNew(underPointerMesh, evt, {
                pointerId: pointerId
            }));
        }
        if (mesh) {
            this._meshUnderPointerId[pointerId] = mesh;
            this._pointerOverMesh = mesh;
            actionManager = mesh._getActionManagerForTrigger(9);
            if (actionManager) actionManager.processTrigger(9, (0, $cmj0B.ActionEvent).CreateNew(mesh, evt, {
                pointerId: pointerId,
                pickResult: pickResult
            }));
        } else {
            delete this._meshUnderPointerId[pointerId];
            this._pointerOverMesh = null;
        }
    }
    /**
     * Gets the mesh under the pointer
     * @returns a Mesh or null if no mesh is under the pointer
     */ getPointerOverMesh() {
        return this.meshUnderPointer;
    }
    /**
     * @param mesh - Mesh to invalidate
     * @internal
     */ _invalidateMesh(mesh) {
        if (this._pointerOverMesh === mesh) this._pointerOverMesh = null;
        if (this._pickedDownMesh === mesh) this._pickedDownMesh = null;
        if (this._pickedUpMesh === mesh) this._pickedUpMesh = null;
        for(const pointerId in this._meshUnderPointerId)if (this._meshUnderPointerId[pointerId] === mesh) delete this._meshUnderPointerId[pointerId];
    }
}
/** The distance in pixel that you have to move to prevent some events */ $55b4bdb4e513ac29$export$2da2653229140a6c.DragMovementThreshold = 10; // in pixels
/** Time in milliseconds to wait to raise long press events if button is still pressed */ $55b4bdb4e513ac29$export$2da2653229140a6c.LongPressDelay = 500; // in milliseconds
/** Time in milliseconds with two consecutive clicks will be considered as a double click */ $55b4bdb4e513ac29$export$2da2653229140a6c.DoubleClickDelay = 300; // in milliseconds
/**
 * This flag will modify the behavior so that, when true, a click will happen if and only if
 * another click DOES NOT happen within the DoubleClickDelay time frame.  If another click does
 * happen within that time frame, the first click will not fire an event and and a double click will occur.
 */ $55b4bdb4e513ac29$export$2da2653229140a6c.ExclusiveDoubleClickMode = false;

});
parcelRegister("cfkw4", function(module, exports) {

$parcel$export(module.exports, "PointerEventTypes", () => $8ea6ccd88adf8a8f$export$897237b138a30604);
$parcel$export(module.exports, "PointerInfoBase", () => $8ea6ccd88adf8a8f$export$7172ff0e05271a1);
$parcel$export(module.exports, "PointerInfoPre", () => $8ea6ccd88adf8a8f$export$be6c99d56064cfdd);
$parcel$export(module.exports, "PointerInfo", () => $8ea6ccd88adf8a8f$export$3d32e0a6dc61f70c);

var $ha1VO = parcelRequire("ha1VO");
class $8ea6ccd88adf8a8f$export$897237b138a30604 {
}
/**
 * The pointerdown event is fired when a pointer becomes active. For mouse, it is fired when the device transitions from no buttons depressed to at least one button depressed. For touch, it is fired when physical contact is made with the digitizer. For pen, it is fired when the stylus makes physical contact with the digitizer.
 */ $8ea6ccd88adf8a8f$export$897237b138a30604.POINTERDOWN = 0x01;
/**
 * The pointerup event is fired when a pointer is no longer active.
 */ $8ea6ccd88adf8a8f$export$897237b138a30604.POINTERUP = 0x02;
/**
 * The pointermove event is fired when a pointer changes coordinates.
 */ $8ea6ccd88adf8a8f$export$897237b138a30604.POINTERMOVE = 0x04;
/**
 * The pointerwheel event is fired when a mouse wheel has been rotated.
 */ $8ea6ccd88adf8a8f$export$897237b138a30604.POINTERWHEEL = 0x08;
/**
 * The pointerpick event is fired when a mesh or sprite has been picked by the pointer.
 */ $8ea6ccd88adf8a8f$export$897237b138a30604.POINTERPICK = 0x10;
/**
 * The pointertap event is fired when a the object has been touched and released without drag.
 */ $8ea6ccd88adf8a8f$export$897237b138a30604.POINTERTAP = 0x20;
/**
 * The pointerdoubletap event is fired when a the object has been touched and released twice without drag.
 */ $8ea6ccd88adf8a8f$export$897237b138a30604.POINTERDOUBLETAP = 0x40;
class $8ea6ccd88adf8a8f$export$7172ff0e05271a1 {
    /**
     * Instantiates the base class of pointers info.
     * @param type Defines the type of event (PointerEventTypes)
     * @param event Defines the related dom event
     */ constructor(/**
     * Defines the type of event (PointerEventTypes)
     */ type, /**
     * Defines the related dom event
     */ event){
        this.type = type;
        this.event = event;
    }
}
class $8ea6ccd88adf8a8f$export$be6c99d56064cfdd extends $8ea6ccd88adf8a8f$export$7172ff0e05271a1 {
    /**
     * Instantiates a PointerInfoPre to store pointer related info to the onPrePointerObservable event.
     * @param type Defines the type of event (PointerEventTypes)
     * @param event Defines the related dom event
     * @param localX Defines the local x coordinates of the pointer when the event occured
     * @param localY Defines the local y coordinates of the pointer when the event occured
     */ constructor(type, event, localX, localY){
        super(type, event);
        /**
         * Ray from a pointer if available (eg. 6dof controller)
         */ this.ray = null;
        /**
         * The original picking info that was used to trigger the pointer event
         */ this.originalPickingInfo = null;
        this.skipOnPointerObservable = false;
        this.localPosition = new (0, $ha1VO.Vector2)(localX, localY);
    }
}
class $8ea6ccd88adf8a8f$export$3d32e0a6dc61f70c extends $8ea6ccd88adf8a8f$export$7172ff0e05271a1 {
    /**
     * Defines the picking info associated with this PointerInfo object (if applicable)
     */ get pickInfo() {
        if (!this._pickInfo) this._generatePickInfo();
        return this._pickInfo;
    }
    /**
     * Instantiates a PointerInfo to store pointer related info to the onPointerObservable event.
     * @param type Defines the type of event (PointerEventTypes)
     * @param event Defines the related dom event
     * @param pickInfo Defines the picking info associated to the info (if any)
     * @param inputManager Defines the InputManager to use if there is no pickInfo
     */ constructor(type, event, pickInfo, inputManager = null){
        super(type, event);
        this._pickInfo = pickInfo;
        this._inputManager = inputManager;
    }
    /**
     * Generates the picking info if needed
     */ /** @internal */ _generatePickInfo() {
        if (this._inputManager) {
            this._pickInfo = this._inputManager._pickMove(this.event);
            this._inputManager._setRayOnPointerInfo(this._pickInfo, this.event);
            this._inputManager = null;
        }
    }
}

});

parcelRegister("bcFoB", function(module, exports) {

$parcel$export(module.exports, "KeyboardEventTypes", () => $8280ed10dbe12bac$export$62d408755f25b92a);
$parcel$export(module.exports, "KeyboardInfo", () => $8280ed10dbe12bac$export$a6c3dccbac012c10);
$parcel$export(module.exports, "KeyboardInfoPre", () => $8280ed10dbe12bac$export$3c56b2d3254c2f3e);
/**
 * Gather the list of keyboard event types as constants.
 */ class $8280ed10dbe12bac$export$62d408755f25b92a {
}
/**
 * The keydown event is fired when a key becomes active (pressed).
 */ $8280ed10dbe12bac$export$62d408755f25b92a.KEYDOWN = 0x01;
/**
 * The keyup event is fired when a key has been released.
 */ $8280ed10dbe12bac$export$62d408755f25b92a.KEYUP = 0x02;
class $8280ed10dbe12bac$export$a6c3dccbac012c10 {
    /**
     * Instantiates a new keyboard info.
     * This class is used to store keyboard related info for the onKeyboardObservable event.
     * @param type Defines the type of event (KeyboardEventTypes)
     * @param event Defines the related dom event
     */ constructor(/**
     * Defines the type of event (KeyboardEventTypes)
     */ type, /**
     * Defines the related dom event
     */ event){
        this.type = type;
        this.event = event;
    }
}
class $8280ed10dbe12bac$export$3c56b2d3254c2f3e extends $8280ed10dbe12bac$export$a6c3dccbac012c10 {
    /**
     * Defines whether the engine should skip the next onKeyboardObservable associated to this pre.
     * @deprecated use skipOnKeyboardObservable property instead
     */ get skipOnPointerObservable() {
        return this.skipOnKeyboardObservable;
    }
    set skipOnPointerObservable(value) {
        this.skipOnKeyboardObservable = value;
    }
    /**
     * Instantiates a new keyboard pre info.
     * This class is used to store keyboard related info for the onPreKeyboardObservable event.
     * @param type Defines the type of event (KeyboardEventTypes)
     * @param event Defines the related dom event
     */ constructor(/**
     * Defines the type of event (KeyboardEventTypes)
     */ type, /**
     * Defines the related dom event
     */ event){
        super(type, event);
        this.type = type;
        this.event = event;
        this.skipOnKeyboardObservable = false;
    }
}

});

parcelRegister("1orLO", function(module, exports) {

$parcel$export(module.exports, "DeviceType", () => $103d92e76a6c0fd3$export$ec1e04e4e5ef8233);
$parcel$export(module.exports, "PointerInput", () => $103d92e76a6c0fd3$export$f35275c6c22f6aff);
$parcel$export(module.exports, "NativePointerInput", () => $103d92e76a6c0fd3$export$9404b06a0f226aab);
$parcel$export(module.exports, "DualShockInput", () => $103d92e76a6c0fd3$export$90fb9dd49867b794);
$parcel$export(module.exports, "DualSenseInput", () => $103d92e76a6c0fd3$export$ed2f53f4a6709ab5);
$parcel$export(module.exports, "XboxInput", () => $103d92e76a6c0fd3$export$3e2b57f863ae2778);
$parcel$export(module.exports, "SwitchInput", () => $103d92e76a6c0fd3$export$f8fd43a15610a9c6);
/**
 * Enum for Device Types
 */ var $103d92e76a6c0fd3$export$ec1e04e4e5ef8233;
(function(DeviceType) {
    /** Generic */ DeviceType[DeviceType["Generic"] = 0] = "Generic";
    /** Keyboard */ DeviceType[DeviceType["Keyboard"] = 1] = "Keyboard";
    /** Mouse */ DeviceType[DeviceType["Mouse"] = 2] = "Mouse";
    /** Touch Pointers */ DeviceType[DeviceType["Touch"] = 3] = "Touch";
    /** PS4 Dual Shock */ DeviceType[DeviceType["DualShock"] = 4] = "DualShock";
    /** Xbox */ DeviceType[DeviceType["Xbox"] = 5] = "Xbox";
    /** Switch Controller */ DeviceType[DeviceType["Switch"] = 6] = "Switch";
    /** PS5 DualSense */ DeviceType[DeviceType["DualSense"] = 7] = "DualSense";
})($103d92e76a6c0fd3$export$ec1e04e4e5ef8233 || ($103d92e76a6c0fd3$export$ec1e04e4e5ef8233 = {}));
var $103d92e76a6c0fd3$export$f35275c6c22f6aff;
(function(PointerInput) {
    /** Horizontal Axis (Not used in events/observables; only in polling) */ PointerInput[PointerInput["Horizontal"] = 0] = "Horizontal";
    /** Vertical Axis (Not used in events/observables; only in polling) */ PointerInput[PointerInput["Vertical"] = 1] = "Vertical";
    /** Left Click or Touch */ PointerInput[PointerInput["LeftClick"] = 2] = "LeftClick";
    /** Middle Click */ PointerInput[PointerInput["MiddleClick"] = 3] = "MiddleClick";
    /** Right Click */ PointerInput[PointerInput["RightClick"] = 4] = "RightClick";
    /** Browser Back */ PointerInput[PointerInput["BrowserBack"] = 5] = "BrowserBack";
    /** Browser Forward */ PointerInput[PointerInput["BrowserForward"] = 6] = "BrowserForward";
    /** Mouse Wheel X */ PointerInput[PointerInput["MouseWheelX"] = 7] = "MouseWheelX";
    /** Mouse Wheel Y */ PointerInput[PointerInput["MouseWheelY"] = 8] = "MouseWheelY";
    /** Mouse Wheel Z */ PointerInput[PointerInput["MouseWheelZ"] = 9] = "MouseWheelZ";
    /** Used in events/observables to identify if x/y changes occurred */ PointerInput[PointerInput["Move"] = 12] = "Move";
})($103d92e76a6c0fd3$export$f35275c6c22f6aff || ($103d92e76a6c0fd3$export$f35275c6c22f6aff = {}));
var $103d92e76a6c0fd3$export$9404b06a0f226aab;
(function(NativePointerInput) {
    /** Horizontal Axis */ NativePointerInput[NativePointerInput["Horizontal"] = 0] = "Horizontal";
    /** Vertical Axis */ NativePointerInput[NativePointerInput["Vertical"] = 1] = "Vertical";
    /** Left Click or Touch */ NativePointerInput[NativePointerInput["LeftClick"] = 2] = "LeftClick";
    /** Middle Click */ NativePointerInput[NativePointerInput["MiddleClick"] = 3] = "MiddleClick";
    /** Right Click */ NativePointerInput[NativePointerInput["RightClick"] = 4] = "RightClick";
    /** Browser Back */ NativePointerInput[NativePointerInput["BrowserBack"] = 5] = "BrowserBack";
    /** Browser Forward */ NativePointerInput[NativePointerInput["BrowserForward"] = 6] = "BrowserForward";
    /** Mouse Wheel X */ NativePointerInput[NativePointerInput["MouseWheelX"] = 7] = "MouseWheelX";
    /** Mouse Wheel Y */ NativePointerInput[NativePointerInput["MouseWheelY"] = 8] = "MouseWheelY";
    /** Mouse Wheel Z */ NativePointerInput[NativePointerInput["MouseWheelZ"] = 9] = "MouseWheelZ";
    /** Delta X */ NativePointerInput[NativePointerInput["DeltaHorizontal"] = 10] = "DeltaHorizontal";
    /** Delta Y */ NativePointerInput[NativePointerInput["DeltaVertical"] = 11] = "DeltaVertical";
})($103d92e76a6c0fd3$export$9404b06a0f226aab || ($103d92e76a6c0fd3$export$9404b06a0f226aab = {}));
var $103d92e76a6c0fd3$export$90fb9dd49867b794;
(function(DualShockInput) {
    /** Cross */ DualShockInput[DualShockInput["Cross"] = 0] = "Cross";
    /** Circle */ DualShockInput[DualShockInput["Circle"] = 1] = "Circle";
    /** Square */ DualShockInput[DualShockInput["Square"] = 2] = "Square";
    /** Triangle */ DualShockInput[DualShockInput["Triangle"] = 3] = "Triangle";
    /** L1 */ DualShockInput[DualShockInput["L1"] = 4] = "L1";
    /** R1 */ DualShockInput[DualShockInput["R1"] = 5] = "R1";
    /** L2 */ DualShockInput[DualShockInput["L2"] = 6] = "L2";
    /** R2 */ DualShockInput[DualShockInput["R2"] = 7] = "R2";
    /** Share */ DualShockInput[DualShockInput["Share"] = 8] = "Share";
    /** Options */ DualShockInput[DualShockInput["Options"] = 9] = "Options";
    /** L3 */ DualShockInput[DualShockInput["L3"] = 10] = "L3";
    /** R3 */ DualShockInput[DualShockInput["R3"] = 11] = "R3";
    /** DPadUp */ DualShockInput[DualShockInput["DPadUp"] = 12] = "DPadUp";
    /** DPadDown */ DualShockInput[DualShockInput["DPadDown"] = 13] = "DPadDown";
    /** DPadLeft */ DualShockInput[DualShockInput["DPadLeft"] = 14] = "DPadLeft";
    /** DRight */ DualShockInput[DualShockInput["DPadRight"] = 15] = "DPadRight";
    /** Home */ DualShockInput[DualShockInput["Home"] = 16] = "Home";
    /** TouchPad */ DualShockInput[DualShockInput["TouchPad"] = 17] = "TouchPad";
    /** LStickXAxis */ DualShockInput[DualShockInput["LStickXAxis"] = 18] = "LStickXAxis";
    /** LStickYAxis */ DualShockInput[DualShockInput["LStickYAxis"] = 19] = "LStickYAxis";
    /** RStickXAxis */ DualShockInput[DualShockInput["RStickXAxis"] = 20] = "RStickXAxis";
    /** RStickYAxis */ DualShockInput[DualShockInput["RStickYAxis"] = 21] = "RStickYAxis";
})($103d92e76a6c0fd3$export$90fb9dd49867b794 || ($103d92e76a6c0fd3$export$90fb9dd49867b794 = {}));
var $103d92e76a6c0fd3$export$ed2f53f4a6709ab5;
(function(DualSenseInput) {
    /** Cross */ DualSenseInput[DualSenseInput["Cross"] = 0] = "Cross";
    /** Circle */ DualSenseInput[DualSenseInput["Circle"] = 1] = "Circle";
    /** Square */ DualSenseInput[DualSenseInput["Square"] = 2] = "Square";
    /** Triangle */ DualSenseInput[DualSenseInput["Triangle"] = 3] = "Triangle";
    /** L1 */ DualSenseInput[DualSenseInput["L1"] = 4] = "L1";
    /** R1 */ DualSenseInput[DualSenseInput["R1"] = 5] = "R1";
    /** L2 */ DualSenseInput[DualSenseInput["L2"] = 6] = "L2";
    /** R2 */ DualSenseInput[DualSenseInput["R2"] = 7] = "R2";
    /** Create */ DualSenseInput[DualSenseInput["Create"] = 8] = "Create";
    /** Options */ DualSenseInput[DualSenseInput["Options"] = 9] = "Options";
    /** L3 */ DualSenseInput[DualSenseInput["L3"] = 10] = "L3";
    /** R3 */ DualSenseInput[DualSenseInput["R3"] = 11] = "R3";
    /** DPadUp */ DualSenseInput[DualSenseInput["DPadUp"] = 12] = "DPadUp";
    /** DPadDown */ DualSenseInput[DualSenseInput["DPadDown"] = 13] = "DPadDown";
    /** DPadLeft */ DualSenseInput[DualSenseInput["DPadLeft"] = 14] = "DPadLeft";
    /** DRight */ DualSenseInput[DualSenseInput["DPadRight"] = 15] = "DPadRight";
    /** Home */ DualSenseInput[DualSenseInput["Home"] = 16] = "Home";
    /** TouchPad */ DualSenseInput[DualSenseInput["TouchPad"] = 17] = "TouchPad";
    /** LStickXAxis */ DualSenseInput[DualSenseInput["LStickXAxis"] = 18] = "LStickXAxis";
    /** LStickYAxis */ DualSenseInput[DualSenseInput["LStickYAxis"] = 19] = "LStickYAxis";
    /** RStickXAxis */ DualSenseInput[DualSenseInput["RStickXAxis"] = 20] = "RStickXAxis";
    /** RStickYAxis */ DualSenseInput[DualSenseInput["RStickYAxis"] = 21] = "RStickYAxis";
})($103d92e76a6c0fd3$export$ed2f53f4a6709ab5 || ($103d92e76a6c0fd3$export$ed2f53f4a6709ab5 = {}));
var $103d92e76a6c0fd3$export$3e2b57f863ae2778;
(function(XboxInput) {
    /** A */ XboxInput[XboxInput["A"] = 0] = "A";
    /** B */ XboxInput[XboxInput["B"] = 1] = "B";
    /** X */ XboxInput[XboxInput["X"] = 2] = "X";
    /** Y */ XboxInput[XboxInput["Y"] = 3] = "Y";
    /** LB */ XboxInput[XboxInput["LB"] = 4] = "LB";
    /** RB */ XboxInput[XboxInput["RB"] = 5] = "RB";
    /** LT */ XboxInput[XboxInput["LT"] = 6] = "LT";
    /** RT */ XboxInput[XboxInput["RT"] = 7] = "RT";
    /** Back */ XboxInput[XboxInput["Back"] = 8] = "Back";
    /** Start */ XboxInput[XboxInput["Start"] = 9] = "Start";
    /** LS */ XboxInput[XboxInput["LS"] = 10] = "LS";
    /** RS */ XboxInput[XboxInput["RS"] = 11] = "RS";
    /** DPadUp */ XboxInput[XboxInput["DPadUp"] = 12] = "DPadUp";
    /** DPadDown */ XboxInput[XboxInput["DPadDown"] = 13] = "DPadDown";
    /** DPadLeft */ XboxInput[XboxInput["DPadLeft"] = 14] = "DPadLeft";
    /** DRight */ XboxInput[XboxInput["DPadRight"] = 15] = "DPadRight";
    /** Home */ XboxInput[XboxInput["Home"] = 16] = "Home";
    /** LStickXAxis */ XboxInput[XboxInput["LStickXAxis"] = 17] = "LStickXAxis";
    /** LStickYAxis */ XboxInput[XboxInput["LStickYAxis"] = 18] = "LStickYAxis";
    /** RStickXAxis */ XboxInput[XboxInput["RStickXAxis"] = 19] = "RStickXAxis";
    /** RStickYAxis */ XboxInput[XboxInput["RStickYAxis"] = 20] = "RStickYAxis";
})($103d92e76a6c0fd3$export$3e2b57f863ae2778 || ($103d92e76a6c0fd3$export$3e2b57f863ae2778 = {}));
var $103d92e76a6c0fd3$export$f8fd43a15610a9c6;
(function(SwitchInput) {
    /** B */ SwitchInput[SwitchInput["B"] = 0] = "B";
    /** A */ SwitchInput[SwitchInput["A"] = 1] = "A";
    /** Y */ SwitchInput[SwitchInput["Y"] = 2] = "Y";
    /** X */ SwitchInput[SwitchInput["X"] = 3] = "X";
    /** L */ SwitchInput[SwitchInput["L"] = 4] = "L";
    /** R */ SwitchInput[SwitchInput["R"] = 5] = "R";
    /** ZL */ SwitchInput[SwitchInput["ZL"] = 6] = "ZL";
    /** ZR */ SwitchInput[SwitchInput["ZR"] = 7] = "ZR";
    /** Minus */ SwitchInput[SwitchInput["Minus"] = 8] = "Minus";
    /** Plus */ SwitchInput[SwitchInput["Plus"] = 9] = "Plus";
    /** LS */ SwitchInput[SwitchInput["LS"] = 10] = "LS";
    /** RS */ SwitchInput[SwitchInput["RS"] = 11] = "RS";
    /** DPadUp */ SwitchInput[SwitchInput["DPadUp"] = 12] = "DPadUp";
    /** DPadDown */ SwitchInput[SwitchInput["DPadDown"] = 13] = "DPadDown";
    /** DPadLeft */ SwitchInput[SwitchInput["DPadLeft"] = 14] = "DPadLeft";
    /** DRight */ SwitchInput[SwitchInput["DPadRight"] = 15] = "DPadRight";
    /** Home */ SwitchInput[SwitchInput["Home"] = 16] = "Home";
    /** Capture */ SwitchInput[SwitchInput["Capture"] = 17] = "Capture";
    /** LStickXAxis */ SwitchInput[SwitchInput["LStickXAxis"] = 18] = "LStickXAxis";
    /** LStickYAxis */ SwitchInput[SwitchInput["LStickYAxis"] = 19] = "LStickYAxis";
    /** RStickXAxis */ SwitchInput[SwitchInput["RStickXAxis"] = 20] = "RStickXAxis";
    /** RStickYAxis */ SwitchInput[SwitchInput["RStickYAxis"] = 21] = "RStickYAxis";
})($103d92e76a6c0fd3$export$f8fd43a15610a9c6 || ($103d92e76a6c0fd3$export$f8fd43a15610a9c6 = {}));

});

parcelRegister("gAZ7u", function(module, exports) {

$parcel$export(module.exports, "DeviceSourceManager", () => $c14f6b3c4d975c6a$export$2719d0694599575b);

var $1orLO = parcelRequire("1orLO");

var $diGQf = parcelRequire("diGQf");

var $hcXui = parcelRequire("hcXui");
class $c14f6b3c4d975c6a$export$2719d0694599575b {
    // Public Functions
    /**
     * Gets a DeviceSource, given a type and slot
     * @param deviceType - Type of Device
     * @param deviceSlot - Slot or ID of device
     * @returns DeviceSource
     */ getDeviceSource(deviceType, deviceSlot) {
        if (deviceSlot === undefined) {
            if (this._firstDevice[deviceType] === undefined) return null;
            deviceSlot = this._firstDevice[deviceType];
        }
        if (!this._devices[deviceType] || this._devices[deviceType][deviceSlot] === undefined) return null;
        return this._devices[deviceType][deviceSlot];
    }
    /**
     * Gets an array of DeviceSource objects for a given device type
     * @param deviceType - Type of Device
     * @returns All available DeviceSources of a given type
     */ getDeviceSources(deviceType) {
        // If device type hasn't had any devices connected yet, return empty array.
        if (!this._devices[deviceType]) return [];
        return this._devices[deviceType].filter((source)=>{
            return !!source;
        });
    }
    /**
     * Default constructor
     * @param engine - Used to get canvas (if applicable)
     */ constructor(engine){
        const numberOfDeviceTypes = Object.keys((0, $1orLO.DeviceType)).length / 2;
        this._devices = new Array(numberOfDeviceTypes);
        this._firstDevice = new Array(numberOfDeviceTypes);
        this._engine = engine;
        if (!this._engine._deviceSourceManager) this._engine._deviceSourceManager = new (0, $hcXui.InternalDeviceSourceManager)(engine);
        this._engine._deviceSourceManager._refCount++;
        // Observables
        this.onDeviceConnectedObservable = new (0, $diGQf.Observable)((observer)=>{
            for (const devices of this._devices)if (devices) {
                for (const device of devices)if (device) this.onDeviceConnectedObservable.notifyObserver(observer, device);
            }
        });
        this.onDeviceDisconnectedObservable = new (0, $diGQf.Observable)();
        this._engine._deviceSourceManager.registerManager(this);
        this._onDisposeObserver = engine.onDisposeObservable.add(()=>{
            this.dispose();
        });
    }
    /**
     * Dispose of DeviceSourceManager
     */ dispose() {
        // Null out observable refs
        this.onDeviceConnectedObservable.clear();
        this.onDeviceDisconnectedObservable.clear();
        if (this._engine._deviceSourceManager) {
            this._engine._deviceSourceManager.unregisterManager(this);
            if (--this._engine._deviceSourceManager._refCount < 1) {
                this._engine._deviceSourceManager.dispose();
                delete this._engine._deviceSourceManager;
            }
        }
        this._engine.onDisposeObservable.remove(this._onDisposeObserver);
    }
    // Hidden Functions
    /**
     * @param deviceSource - Source to add
     * @internal
     */ _addDevice(deviceSource) {
        if (!this._devices[deviceSource.deviceType]) this._devices[deviceSource.deviceType] = new Array();
        if (!this._devices[deviceSource.deviceType][deviceSource.deviceSlot]) {
            this._devices[deviceSource.deviceType][deviceSource.deviceSlot] = deviceSource;
            this._updateFirstDevices(deviceSource.deviceType);
        }
        this.onDeviceConnectedObservable.notifyObservers(deviceSource);
    }
    /**
     * @param deviceType - DeviceType
     * @param deviceSlot - DeviceSlot
     * @internal
     */ _removeDevice(deviceType, deviceSlot) {
        const deviceSource = this._devices[deviceType]?.[deviceSlot]; // Grab local reference to use before removing from devices
        this.onDeviceDisconnectedObservable.notifyObservers(deviceSource);
        if (this._devices[deviceType]?.[deviceSlot]) delete this._devices[deviceType][deviceSlot];
        // Even if we don't delete a device, we should still check for the first device as things may have gotten out of sync.
        this._updateFirstDevices(deviceType);
    }
    /**
     * @param deviceType - DeviceType
     * @param deviceSlot - DeviceSlot
     * @param eventData - Event
     * @internal
     */ _onInputChanged(deviceType, deviceSlot, eventData) {
        this._devices[deviceType]?.[deviceSlot]?.onInputChangedObservable.notifyObservers(eventData);
    }
    // Private Functions
    _updateFirstDevices(type) {
        switch(type){
            case (0, $1orLO.DeviceType).Keyboard:
            case (0, $1orLO.DeviceType).Mouse:
                this._firstDevice[type] = 0;
                break;
            case (0, $1orLO.DeviceType).Touch:
            case (0, $1orLO.DeviceType).DualSense:
            case (0, $1orLO.DeviceType).DualShock:
            case (0, $1orLO.DeviceType).Xbox:
            case (0, $1orLO.DeviceType).Switch:
            case (0, $1orLO.DeviceType).Generic:
                {
                    delete this._firstDevice[type];
                    // eslint-disable-next-line no-case-declarations
                    const devices = this._devices[type];
                    if (devices) {
                        for(let i = 0; i < devices.length; i++)if (devices[i]) {
                            this._firstDevice[type] = i;
                            break;
                        }
                    }
                    break;
                }
        }
    }
}

});
parcelRegister("hcXui", function(module, exports) {

$parcel$export(module.exports, "InternalDeviceSourceManager", () => $c871b3a4837b5826$export$262f6dddbcae2bda);

var $1orLO = parcelRequire("1orLO");

var $91QRI = parcelRequire("91QRI");

var $ehija = parcelRequire("ehija");

var $akBjT = parcelRequire("akBjT");
class $c871b3a4837b5826$export$262f6dddbcae2bda {
    constructor(engine){
        this._registeredManagers = new Array();
        this._refCount = 0;
        // Public Functions
        this.registerManager = (manager)=>{
            for(let deviceType = 0; deviceType < this._devices.length; deviceType++){
                const device = this._devices[deviceType];
                for(const deviceSlotKey in device){
                    const deviceSlot = +deviceSlotKey;
                    manager._addDevice(new (0, $akBjT.DeviceSource)(this._deviceInputSystem, deviceType, deviceSlot));
                }
            }
            this._registeredManagers.push(manager);
        };
        this.unregisterManager = (manager)=>{
            const idx = this._registeredManagers.indexOf(manager);
            if (idx > -1) this._registeredManagers.splice(idx, 1);
        };
        const numberOfDeviceTypes = Object.keys((0, $1orLO.DeviceType)).length / 2;
        this._devices = new Array(numberOfDeviceTypes);
        const onDeviceConnected = (deviceType, deviceSlot)=>{
            if (!this._devices[deviceType]) this._devices[deviceType] = new Array();
            if (!this._devices[deviceType][deviceSlot]) this._devices[deviceType][deviceSlot] = deviceSlot;
            for (const manager of this._registeredManagers){
                const deviceSource = new (0, $akBjT.DeviceSource)(this._deviceInputSystem, deviceType, deviceSlot);
                manager._addDevice(deviceSource);
            }
        };
        const onDeviceDisconnected = (deviceType, deviceSlot)=>{
            if (this._devices[deviceType]?.[deviceSlot]) delete this._devices[deviceType][deviceSlot];
            for (const manager of this._registeredManagers)manager._removeDevice(deviceType, deviceSlot);
        };
        const onInputChanged = (deviceType, deviceSlot, eventData)=>{
            if (eventData) for (const manager of this._registeredManagers)manager._onInputChanged(deviceType, deviceSlot, eventData);
        };
        if (typeof _native !== "undefined") this._deviceInputSystem = new (0, $91QRI.NativeDeviceInputSystem)(onDeviceConnected, onDeviceDisconnected, onInputChanged);
        else this._deviceInputSystem = new (0, $ehija.WebDeviceInputSystem)(engine, onDeviceConnected, onDeviceDisconnected, onInputChanged);
    }
    dispose() {
        this._deviceInputSystem.dispose();
    }
}

});
parcelRegister("91QRI", function(module, exports) {

$parcel$export(module.exports, "NativeDeviceInputSystem", () => $692d36fececf9f85$export$b7cc62e8778b1937);

var $f1QSW = parcelRequire("f1QSW");

var $1orLO = parcelRequire("1orLO");
class $692d36fececf9f85$export$b7cc62e8778b1937 {
    constructor(onDeviceConnected, onDeviceDisconnected, onInputChanged){
        this._nativeInput = _native.DeviceInputSystem ? new _native.DeviceInputSystem(onDeviceConnected, onDeviceDisconnected, (deviceType, deviceSlot, inputIndex, currentState)=>{
            const evt = (0, $f1QSW.DeviceEventFactory).CreateDeviceEvent(deviceType, deviceSlot, inputIndex, currentState, this);
            onInputChanged(deviceType, deviceSlot, evt);
        }) : this._createDummyNativeInput();
    }
    // Public functions
    /**
     * Checks for current device input value, given an id and input index. Throws exception if requested device not initialized.
     * @param deviceType Enum specifying device type
     * @param deviceSlot "Slot" or index that device is referenced in
     * @param inputIndex Id of input to be checked
     * @returns Current value of input
     */ pollInput(deviceType, deviceSlot, inputIndex) {
        return this._nativeInput.pollInput(deviceType, deviceSlot, inputIndex);
    }
    /**
     * Check for a specific device in the DeviceInputSystem
     * @param deviceType Type of device to check for
     * @returns bool with status of device's existence
     */ isDeviceAvailable(deviceType) {
        //TODO: FIx native side first
        return deviceType === (0, $1orLO.DeviceType).Mouse || deviceType === (0, $1orLO.DeviceType).Touch;
    }
    /**
     * Dispose of all the observables
     */ dispose() {
        this._nativeInput.dispose();
    }
    /**
     * For versions of BabylonNative that don't have the NativeInput plugin initialized, create a dummy version
     * @returns Object with dummy functions
     */ _createDummyNativeInput() {
        const nativeInput = {
            pollInput: ()=>{
                return 0;
            },
            isDeviceAvailable: ()=>{
                return false;
            },
            dispose: ()=>{}
        };
        return nativeInput;
    }
}

});
parcelRegister("f1QSW", function(module, exports) {

$parcel$export(module.exports, "DeviceEventFactory", () => $af0ff8e35d988c18$export$6de5b040bf4692b);

var $jzXHO = parcelRequire("jzXHO");

var $1orLO = parcelRequire("1orLO");
class $af0ff8e35d988c18$export$6de5b040bf4692b {
    /**
     * Create device input events based on provided type and slot
     *
     * @param deviceType Type of device
     * @param deviceSlot "Slot" or index that device is referenced in
     * @param inputIndex Id of input to be checked
     * @param currentState Current value for given input
     * @param deviceInputSystem Reference to DeviceInputSystem
     * @param elementToAttachTo HTMLElement to reference as target for inputs
     * @param pointerId PointerId to use for pointer events
     * @returns IUIEvent object
     */ static CreateDeviceEvent(deviceType, deviceSlot, inputIndex, currentState, deviceInputSystem, elementToAttachTo, pointerId) {
        switch(deviceType){
            case (0, $1orLO.DeviceType).Keyboard:
                return this._CreateKeyboardEvent(inputIndex, currentState, deviceInputSystem, elementToAttachTo);
            case (0, $1orLO.DeviceType).Mouse:
                if (inputIndex === (0, $1orLO.PointerInput).MouseWheelX || inputIndex === (0, $1orLO.PointerInput).MouseWheelY || inputIndex === (0, $1orLO.PointerInput).MouseWheelZ) return this._CreateWheelEvent(deviceType, deviceSlot, inputIndex, currentState, deviceInputSystem, elementToAttachTo);
            // eslint-disable-next-line no-fallthrough
            case (0, $1orLO.DeviceType).Touch:
                return this._CreatePointerEvent(deviceType, deviceSlot, inputIndex, currentState, deviceInputSystem, elementToAttachTo, pointerId);
            default:
                // eslint-disable-next-line no-throw-literal
                throw `Unable to generate event for device ${(0, $1orLO.DeviceType)[deviceType]}`;
        }
    }
    /**
     * Creates pointer event
     *
     * @param deviceType Type of device
     * @param deviceSlot "Slot" or index that device is referenced in
     * @param inputIndex Id of input to be checked
     * @param currentState Current value for given input
     * @param deviceInputSystem Reference to DeviceInputSystem
     * @param elementToAttachTo HTMLElement to reference as target for inputs
     * @param pointerId PointerId to use for pointer events
     * @returns IUIEvent object (Pointer)
     */ static _CreatePointerEvent(deviceType, deviceSlot, inputIndex, currentState, deviceInputSystem, elementToAttachTo, pointerId) {
        const evt = this._CreateMouseEvent(deviceType, deviceSlot, inputIndex, currentState, deviceInputSystem, elementToAttachTo);
        if (deviceType === (0, $1orLO.DeviceType).Mouse) {
            evt.deviceType = (0, $1orLO.DeviceType).Mouse;
            evt.pointerId = 1;
            evt.pointerType = "mouse";
        } else {
            evt.deviceType = (0, $1orLO.DeviceType).Touch;
            evt.pointerId = pointerId ?? deviceSlot;
            evt.pointerType = "touch";
        }
        let buttons = 0;
        // Populate buttons property with current state of all mouse buttons
        // Uses values found on: https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/buttons
        buttons += deviceInputSystem.pollInput(deviceType, deviceSlot, (0, $1orLO.PointerInput).LeftClick);
        buttons += deviceInputSystem.pollInput(deviceType, deviceSlot, (0, $1orLO.PointerInput).RightClick) * 2;
        buttons += deviceInputSystem.pollInput(deviceType, deviceSlot, (0, $1orLO.PointerInput).MiddleClick) * 4;
        evt.buttons = buttons;
        if (inputIndex === (0, $1orLO.PointerInput).Move) evt.type = "pointermove";
        else if (inputIndex >= (0, $1orLO.PointerInput).LeftClick && inputIndex <= (0, $1orLO.PointerInput).RightClick) {
            evt.type = currentState === 1 ? "pointerdown" : "pointerup";
            evt.button = inputIndex - 2;
        }
        return evt;
    }
    /**
     * Create Mouse Wheel Event
     * @param deviceType Type of device
     * @param deviceSlot "Slot" or index that device is referenced in
     * @param inputIndex Id of input to be checked
     * @param currentState Current value for given input
     * @param deviceInputSystem Reference to DeviceInputSystem
     * @param elementToAttachTo HTMLElement to reference as target for inputs
     * @returns IUIEvent object (Wheel)
     */ static _CreateWheelEvent(deviceType, deviceSlot, inputIndex, currentState, deviceInputSystem, elementToAttachTo) {
        const evt = this._CreateMouseEvent(deviceType, deviceSlot, inputIndex, currentState, deviceInputSystem, elementToAttachTo);
        // While WheelEvents don't generally have a pointerId, we used to add one in the InputManager
        // This line has been added to make the InputManager more platform-agnostic
        // Similar code exists in the WebDeviceInputSystem to handle browser created events
        evt.pointerId = 1;
        evt.type = "wheel";
        evt.deltaMode = (0, $jzXHO.EventConstants).DOM_DELTA_PIXEL;
        evt.deltaX = 0;
        evt.deltaY = 0;
        evt.deltaZ = 0;
        switch(inputIndex){
            case (0, $1orLO.PointerInput).MouseWheelX:
                evt.deltaX = currentState;
                break;
            case (0, $1orLO.PointerInput).MouseWheelY:
                evt.deltaY = currentState;
                break;
            case (0, $1orLO.PointerInput).MouseWheelZ:
                evt.deltaZ = currentState;
                break;
        }
        return evt;
    }
    /**
     * Create Mouse Event
     * @param deviceType Type of device
     * @param deviceSlot "Slot" or index that device is referenced in
     * @param inputIndex Id of input to be checked
     * @param currentState Current value for given input
     * @param deviceInputSystem Reference to DeviceInputSystem
     * @param elementToAttachTo HTMLElement to reference as target for inputs
     * @returns IUIEvent object (Mouse)
     */ static _CreateMouseEvent(deviceType, deviceSlot, inputIndex, currentState, deviceInputSystem, elementToAttachTo) {
        const evt = this._CreateEvent(elementToAttachTo);
        const pointerX = deviceInputSystem.pollInput(deviceType, deviceSlot, (0, $1orLO.PointerInput).Horizontal);
        const pointerY = deviceInputSystem.pollInput(deviceType, deviceSlot, (0, $1orLO.PointerInput).Vertical);
        // Handle offsets/deltas based on existence of HTMLElement
        if (elementToAttachTo) {
            evt.movementX = 0;
            evt.movementY = 0;
            evt.offsetX = evt.movementX - elementToAttachTo.getBoundingClientRect().x;
            evt.offsetY = evt.movementY - elementToAttachTo.getBoundingClientRect().y;
        } else {
            evt.movementX = deviceInputSystem.pollInput(deviceType, deviceSlot, (0, $1orLO.NativePointerInput).DeltaHorizontal); // DeltaHorizontal
            evt.movementY = deviceInputSystem.pollInput(deviceType, deviceSlot, (0, $1orLO.NativePointerInput).DeltaVertical); // DeltaVertical
            evt.offsetX = 0;
            evt.offsetY = 0;
        }
        this._CheckNonCharacterKeys(evt, deviceInputSystem);
        evt.clientX = pointerX;
        evt.clientY = pointerY;
        evt.x = pointerX;
        evt.y = pointerY;
        evt.deviceType = deviceType;
        evt.deviceSlot = deviceSlot;
        evt.inputIndex = inputIndex;
        return evt;
    }
    /**
     * Create Keyboard Event
     * @param inputIndex Id of input to be checked
     * @param currentState Current value for given input
     * @param deviceInputSystem Reference to DeviceInputSystem
     * @param elementToAttachTo HTMLElement to reference as target for inputs
     * @returns IEvent object (Keyboard)
     */ static _CreateKeyboardEvent(inputIndex, currentState, deviceInputSystem, elementToAttachTo) {
        const evt = this._CreateEvent(elementToAttachTo);
        this._CheckNonCharacterKeys(evt, deviceInputSystem);
        evt.deviceType = (0, $1orLO.DeviceType).Keyboard;
        evt.deviceSlot = 0;
        evt.inputIndex = inputIndex;
        evt.type = currentState === 1 ? "keydown" : "keyup";
        evt.key = String.fromCharCode(inputIndex);
        evt.keyCode = inputIndex;
        return evt;
    }
    /**
     * Add parameters for non-character keys (Ctrl, Alt, Meta, Shift)
     * @param evt Event object to add parameters to
     * @param deviceInputSystem DeviceInputSystem to pull values from
     */ static _CheckNonCharacterKeys(evt, deviceInputSystem) {
        const isKeyboardActive = deviceInputSystem.isDeviceAvailable((0, $1orLO.DeviceType).Keyboard);
        const altKey = isKeyboardActive && deviceInputSystem.pollInput((0, $1orLO.DeviceType).Keyboard, 0, 18) === 1;
        const ctrlKey = isKeyboardActive && deviceInputSystem.pollInput((0, $1orLO.DeviceType).Keyboard, 0, 17) === 1;
        const metaKey = isKeyboardActive && (deviceInputSystem.pollInput((0, $1orLO.DeviceType).Keyboard, 0, 91) === 1 || deviceInputSystem.pollInput((0, $1orLO.DeviceType).Keyboard, 0, 92) === 1 || deviceInputSystem.pollInput((0, $1orLO.DeviceType).Keyboard, 0, 93) === 1);
        const shiftKey = isKeyboardActive && deviceInputSystem.pollInput((0, $1orLO.DeviceType).Keyboard, 0, 16) === 1;
        evt.altKey = altKey;
        evt.ctrlKey = ctrlKey;
        evt.metaKey = metaKey;
        evt.shiftKey = shiftKey;
    }
    /**
     * Create base event object
     * @param elementToAttachTo Value to use as event target
     * @returns
     */ static _CreateEvent(elementToAttachTo) {
        const evt = {};
        evt.preventDefault = ()=>{};
        evt.target = elementToAttachTo;
        return evt;
    }
}

});
parcelRegister("jzXHO", function(module, exports) {

$parcel$export(module.exports, "DeviceInputEventType", () => $e40f997fe02c49f2$export$78d4eae8a1afef6a);
$parcel$export(module.exports, "EventConstants", () => $e40f997fe02c49f2$export$34ce6eeede54e4b1);
/**
 * Event Types
 */ var $e40f997fe02c49f2$export$78d4eae8a1afef6a;
(function(DeviceInputEventType) {
    // Pointers
    /** PointerMove */ DeviceInputEventType[DeviceInputEventType["PointerMove"] = 0] = "PointerMove";
    /** PointerDown */ DeviceInputEventType[DeviceInputEventType["PointerDown"] = 1] = "PointerDown";
    /** PointerUp */ DeviceInputEventType[DeviceInputEventType["PointerUp"] = 2] = "PointerUp";
})($e40f997fe02c49f2$export$78d4eae8a1afef6a || ($e40f997fe02c49f2$export$78d4eae8a1afef6a = {}));
class $e40f997fe02c49f2$export$34ce6eeede54e4b1 {
}
/**
 * Pixel delta for Wheel Events (Default)
 */ $e40f997fe02c49f2$export$34ce6eeede54e4b1.DOM_DELTA_PIXEL = 0x00;
/**
 * Line delta for Wheel Events
 */ $e40f997fe02c49f2$export$34ce6eeede54e4b1.DOM_DELTA_LINE = 0x01;
/**
 * Page delta for Wheel Events
 */ $e40f997fe02c49f2$export$34ce6eeede54e4b1.DOM_DELTA_PAGE = 0x02;

});



parcelRegister("ehija", function(module, exports) {

$parcel$export(module.exports, "WebDeviceInputSystem", () => $a650dad51390e5d8$export$9337c7f7aa3e5fe9);

var $jFz47 = parcelRequire("jFz47");

var $bOhSV = parcelRequire("bOhSV");

var $f1QSW = parcelRequire("f1QSW");

var $1orLO = parcelRequire("1orLO");
// eslint-disable-next-line @typescript-eslint/naming-convention
const $a650dad51390e5d8$var$MAX_KEYCODES = 255;
// eslint-disable-next-line @typescript-eslint/naming-convention
const $a650dad51390e5d8$var$MAX_POINTER_INPUTS = Object.keys((0, $1orLO.PointerInput)).length / 2;
class $a650dad51390e5d8$export$9337c7f7aa3e5fe9 {
    /**
     * Constructor for the WebDeviceInputSystem
     * @param engine Engine to reference
     * @param onDeviceConnected Callback to execute when device is connected
     * @param onDeviceDisconnected Callback to execute when device is disconnected
     * @param onInputChanged Callback to execute when input changes on device
     */ constructor(engine, onDeviceConnected, onDeviceDisconnected, onInputChanged){
        // Private Members
        this._inputs = [];
        this._keyboardActive = false;
        this._pointerActive = false;
        this._usingSafari = (0, $bOhSV.Tools).IsSafari();
        // Found solution for determining if MacOS is being used here:
        // https://stackoverflow.com/questions/10527983/best-way-to-detect-mac-os-x-or-windows-computers-with-javascript-or-jquery
        this._usingMacOS = (0, $jFz47.IsNavigatorAvailable)() && /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this._keyboardDownEvent = (evt)=>{};
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this._keyboardUpEvent = (evt)=>{};
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this._keyboardBlurEvent = (evt)=>{};
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this._pointerMoveEvent = (evt)=>{};
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this._pointerDownEvent = (evt)=>{};
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this._pointerUpEvent = (evt)=>{};
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this._pointerCancelEvent = (evt)=>{};
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this._pointerWheelEvent = (evt)=>{};
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this._pointerBlurEvent = (evt)=>{};
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this._pointerMacOSChromeOutEvent = (evt)=>{};
        this._eventsAttached = false;
        this._mouseId = -1;
        this._isUsingFirefox = (0, $jFz47.IsNavigatorAvailable)() && navigator.userAgent && navigator.userAgent.indexOf("Firefox") !== -1;
        this._isUsingChromium = (0, $jFz47.IsNavigatorAvailable)() && navigator.userAgent && navigator.userAgent.indexOf("Chrome") !== -1;
        this._maxTouchPoints = 0;
        this._pointerInputClearObserver = null;
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this._gamepadConnectedEvent = (evt)=>{};
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this._gamepadDisconnectedEvent = (evt)=>{};
        this._eventPrefix = (0, $bOhSV.Tools).GetPointerPrefix(engine);
        this._engine = engine;
        this._onDeviceConnected = onDeviceConnected;
        this._onDeviceDisconnected = onDeviceDisconnected;
        this._onInputChanged = onInputChanged;
        // If we need a pointerId, set one for future use
        this._mouseId = this._isUsingFirefox ? 0 : 1;
        this._enableEvents();
        if (this._usingMacOS) this._metaKeys = [];
        // Set callback to enable event handler switching when inputElement changes
        if (!this._engine._onEngineViewChanged) this._engine._onEngineViewChanged = ()=>{
            this._enableEvents();
        };
    }
    // Public functions
    /**
     * Checks for current device input value, given an id and input index. Throws exception if requested device not initialized.
     * @param deviceType Enum specifying device type
     * @param deviceSlot "Slot" or index that device is referenced in
     * @param inputIndex Id of input to be checked
     * @returns Current value of input
     */ pollInput(deviceType, deviceSlot, inputIndex) {
        const device = this._inputs[deviceType][deviceSlot];
        if (!device) // eslint-disable-next-line no-throw-literal
        throw `Unable to find device ${(0, $1orLO.DeviceType)[deviceType]}`;
        if (deviceType >= (0, $1orLO.DeviceType).DualShock && deviceType <= (0, $1orLO.DeviceType).DualSense) this._updateDevice(deviceType, deviceSlot, inputIndex);
        const currentValue = device[inputIndex];
        if (currentValue === undefined) // eslint-disable-next-line no-throw-literal
        throw `Unable to find input ${inputIndex} for device ${(0, $1orLO.DeviceType)[deviceType]} in slot ${deviceSlot}`;
        if (inputIndex === (0, $1orLO.PointerInput).Move) (0, $bOhSV.Tools).Warn(`Unable to provide information for PointerInput.Move.  Try using PointerInput.Horizontal or PointerInput.Vertical for move data.`);
        return currentValue;
    }
    /**
     * Check for a specific device in the DeviceInputSystem
     * @param deviceType Type of device to check for
     * @returns bool with status of device's existence
     */ isDeviceAvailable(deviceType) {
        return this._inputs[deviceType] !== undefined;
    }
    /**
     * Dispose of all the eventlisteners
     */ dispose() {
        // Callbacks
        this._onDeviceConnected = ()=>{};
        this._onDeviceDisconnected = ()=>{};
        this._onInputChanged = ()=>{};
        delete this._engine._onEngineViewChanged;
        if (this._elementToAttachTo) this._disableEvents();
    }
    /**
     * Enable listening for user input events
     */ _enableEvents() {
        const inputElement = this?._engine.getInputElement();
        if (inputElement && (!this._eventsAttached || this._elementToAttachTo !== inputElement)) {
            // Remove events before adding to avoid double events or simultaneous events on multiple canvases
            this._disableEvents();
            // If the inputs array has already been created, zero it out to before setting up events
            if (this._inputs) for (const inputs of this._inputs){
                if (inputs) for(const deviceSlotKey in inputs){
                    const deviceSlot = +deviceSlotKey;
                    const device = inputs[deviceSlot];
                    if (device) for(let inputIndex = 0; inputIndex < device.length; inputIndex++)device[inputIndex] = 0;
                }
            }
            this._elementToAttachTo = inputElement;
            // Set tab index for the inputElement to the engine's canvasTabIndex, if and only if the element's tab index is -1
            this._elementToAttachTo.tabIndex = this._elementToAttachTo.tabIndex !== -1 ? this._elementToAttachTo.tabIndex : this._engine.canvasTabIndex;
            this._handleKeyActions();
            this._handlePointerActions();
            this._handleGamepadActions();
            this._eventsAttached = true;
            // Check for devices that are already connected but aren't registered. Currently, only checks for gamepads and mouse
            this._checkForConnectedDevices();
        }
    }
    /**
     * Disable listening for user input events
     */ _disableEvents() {
        if (this._elementToAttachTo) {
            // Blur Events
            this._elementToAttachTo.removeEventListener("blur", this._keyboardBlurEvent);
            this._elementToAttachTo.removeEventListener("blur", this._pointerBlurEvent);
            // Keyboard Events
            this._elementToAttachTo.removeEventListener("keydown", this._keyboardDownEvent);
            this._elementToAttachTo.removeEventListener("keyup", this._keyboardUpEvent);
            // Pointer Events
            this._elementToAttachTo.removeEventListener(this._eventPrefix + "move", this._pointerMoveEvent);
            this._elementToAttachTo.removeEventListener(this._eventPrefix + "down", this._pointerDownEvent);
            this._elementToAttachTo.removeEventListener(this._eventPrefix + "up", this._pointerUpEvent);
            this._elementToAttachTo.removeEventListener(this._eventPrefix + "cancel", this._pointerCancelEvent);
            this._elementToAttachTo.removeEventListener(this._wheelEventName, this._pointerWheelEvent);
            if (this._usingMacOS && this._isUsingChromium) this._elementToAttachTo.removeEventListener("lostpointercapture", this._pointerMacOSChromeOutEvent);
            // Gamepad Events
            window.removeEventListener("gamepadconnected", this._gamepadConnectedEvent);
            window.removeEventListener("gamepaddisconnected", this._gamepadDisconnectedEvent);
        }
        if (this._pointerInputClearObserver) this._engine.onEndFrameObservable.remove(this._pointerInputClearObserver);
        this._eventsAttached = false;
    }
    /**
     * Checks for existing connections to devices and register them, if necessary
     * Currently handles gamepads and mouse
     */ _checkForConnectedDevices() {
        if (navigator.getGamepads) {
            const gamepads = navigator.getGamepads();
            for (const gamepad of gamepads)if (gamepad) this._addGamePad(gamepad);
        }
        // If the device in use has mouse capabilities, pre-register mouse
        if (typeof matchMedia === "function" && matchMedia("(pointer:fine)").matches) // This will provide a dummy value for the cursor position and is expected to be overridden when the first mouse event happens.
        // There isn't any good way to get the current position outside of a pointer event so that's why this was done.
        this._addPointerDevice((0, $1orLO.DeviceType).Mouse, 0, 0, 0);
    }
    // Private functions
    /**
     * Add a gamepad to the DeviceInputSystem
     * @param gamepad A single DOM Gamepad object
     */ _addGamePad(gamepad) {
        const deviceType = this._getGamepadDeviceType(gamepad.id);
        const deviceSlot = gamepad.index;
        this._gamepads = this._gamepads || new Array(gamepad.index + 1);
        this._registerDevice(deviceType, deviceSlot, gamepad.buttons.length + gamepad.axes.length);
        this._gamepads[deviceSlot] = deviceType;
    }
    /**
     * Add pointer device to DeviceInputSystem
     * @param deviceType Type of Pointer to add
     * @param deviceSlot Pointer ID (0 for mouse, pointerId for Touch)
     * @param currentX Current X at point of adding
     * @param currentY Current Y at point of adding
     */ _addPointerDevice(deviceType, deviceSlot, currentX, currentY) {
        if (!this._pointerActive) this._pointerActive = true;
        this._registerDevice(deviceType, deviceSlot, $a650dad51390e5d8$var$MAX_POINTER_INPUTS);
        const pointer = this._inputs[deviceType][deviceSlot]; /* initialize our pointer position immediately after registration */ 
        pointer[0] = currentX;
        pointer[1] = currentY;
    }
    /**
     * Add device and inputs to device array
     * @param deviceType Enum specifying device type
     * @param deviceSlot "Slot" or index that device is referenced in
     * @param numberOfInputs Number of input entries to create for given device
     */ _registerDevice(deviceType, deviceSlot, numberOfInputs) {
        if (deviceSlot === undefined) // eslint-disable-next-line no-throw-literal
        throw `Unable to register device ${(0, $1orLO.DeviceType)[deviceType]} to undefined slot.`;
        if (!this._inputs[deviceType]) this._inputs[deviceType] = {};
        if (!this._inputs[deviceType][deviceSlot]) {
            const device = new Array(numberOfInputs);
            device.fill(0);
            this._inputs[deviceType][deviceSlot] = device;
            this._onDeviceConnected(deviceType, deviceSlot);
        }
    }
    /**
     * Given a specific device name, remove that device from the device map
     * @param deviceType Enum specifying device type
     * @param deviceSlot "Slot" or index that device is referenced in
     */ _unregisterDevice(deviceType, deviceSlot) {
        if (this._inputs[deviceType][deviceSlot]) {
            delete this._inputs[deviceType][deviceSlot];
            this._onDeviceDisconnected(deviceType, deviceSlot);
        }
    }
    /**
     * Handle all actions that come from keyboard interaction
     */ _handleKeyActions() {
        this._keyboardDownEvent = (evt)=>{
            if (!this._keyboardActive) {
                this._keyboardActive = true;
                this._registerDevice((0, $1orLO.DeviceType).Keyboard, 0, $a650dad51390e5d8$var$MAX_KEYCODES);
            }
            const kbKey = this._inputs[(0, $1orLO.DeviceType).Keyboard][0];
            if (kbKey) {
                kbKey[evt.keyCode] = 1;
                const deviceEvent = evt;
                deviceEvent.inputIndex = evt.keyCode;
                if (this._usingMacOS && evt.metaKey && evt.key !== "Meta") {
                    if (!this._metaKeys.includes(evt.keyCode)) this._metaKeys.push(evt.keyCode);
                }
                this._onInputChanged((0, $1orLO.DeviceType).Keyboard, 0, deviceEvent);
            }
        };
        this._keyboardUpEvent = (evt)=>{
            if (!this._keyboardActive) {
                this._keyboardActive = true;
                this._registerDevice((0, $1orLO.DeviceType).Keyboard, 0, $a650dad51390e5d8$var$MAX_KEYCODES);
            }
            const kbKey = this._inputs[(0, $1orLO.DeviceType).Keyboard][0];
            if (kbKey) {
                kbKey[evt.keyCode] = 0;
                const deviceEvent = evt;
                deviceEvent.inputIndex = evt.keyCode;
                if (this._usingMacOS && evt.key === "Meta" && this._metaKeys.length > 0) {
                    for (const keyCode of this._metaKeys){
                        const deviceEvent = (0, $f1QSW.DeviceEventFactory).CreateDeviceEvent((0, $1orLO.DeviceType).Keyboard, 0, keyCode, 0, this, this._elementToAttachTo);
                        kbKey[keyCode] = 0;
                        this._onInputChanged((0, $1orLO.DeviceType).Keyboard, 0, deviceEvent);
                    }
                    this._metaKeys.splice(0, this._metaKeys.length);
                }
                this._onInputChanged((0, $1orLO.DeviceType).Keyboard, 0, deviceEvent);
            }
        };
        this._keyboardBlurEvent = ()=>{
            if (this._keyboardActive) {
                const kbKey = this._inputs[(0, $1orLO.DeviceType).Keyboard][0];
                for(let i = 0; i < kbKey.length; i++)if (kbKey[i] !== 0) {
                    kbKey[i] = 0;
                    const deviceEvent = (0, $f1QSW.DeviceEventFactory).CreateDeviceEvent((0, $1orLO.DeviceType).Keyboard, 0, i, 0, this, this._elementToAttachTo);
                    this._onInputChanged((0, $1orLO.DeviceType).Keyboard, 0, deviceEvent);
                }
                if (this._usingMacOS) this._metaKeys.splice(0, this._metaKeys.length);
            }
        };
        this._elementToAttachTo.addEventListener("keydown", this._keyboardDownEvent);
        this._elementToAttachTo.addEventListener("keyup", this._keyboardUpEvent);
        this._elementToAttachTo.addEventListener("blur", this._keyboardBlurEvent);
    }
    /**
     * Handle all actions that come from pointer interaction
     */ _handlePointerActions() {
        // If maxTouchPoints is defined, use that value.  Otherwise, allow for a minimum for supported gestures like pinch
        this._maxTouchPoints = (0, $jFz47.IsNavigatorAvailable)() && navigator.maxTouchPoints || 2;
        if (!this._activeTouchIds) this._activeTouchIds = new Array(this._maxTouchPoints);
        for(let i = 0; i < this._maxTouchPoints; i++)this._activeTouchIds[i] = -1;
        this._pointerMoveEvent = (evt)=>{
            const deviceType = this._getPointerType(evt);
            let deviceSlot = deviceType === (0, $1orLO.DeviceType).Mouse ? 0 : this._activeTouchIds.indexOf(evt.pointerId);
            // In the event that we're gettting pointermove events from touch inputs that we aren't tracking,
            // look for an available slot and retroactively connect it.
            if (deviceType === (0, $1orLO.DeviceType).Touch && deviceSlot === -1) {
                const idx = this._activeTouchIds.indexOf(-1);
                if (idx >= 0) {
                    deviceSlot = idx;
                    this._activeTouchIds[idx] = evt.pointerId;
                    // Because this is a "new" input, inform the connected callback
                    this._onDeviceConnected(deviceType, deviceSlot);
                } else {
                    // We can't find an open slot to store new pointer so just return (can only support max number of touches)
                    (0, $bOhSV.Tools).Warn(`Max number of touches exceeded.  Ignoring touches in excess of ${this._maxTouchPoints}`);
                    return;
                }
            }
            if (!this._inputs[deviceType]) this._inputs[deviceType] = {};
            if (!this._inputs[deviceType][deviceSlot]) this._addPointerDevice(deviceType, deviceSlot, evt.clientX, evt.clientY);
            const pointer = this._inputs[deviceType][deviceSlot];
            if (pointer) {
                const deviceEvent = evt;
                deviceEvent.inputIndex = (0, $1orLO.PointerInput).Move;
                pointer[(0, $1orLO.PointerInput).Horizontal] = evt.clientX;
                pointer[(0, $1orLO.PointerInput).Vertical] = evt.clientY;
                // For touches that aren't started with a down, we need to set the button state to 1
                if (deviceType === (0, $1orLO.DeviceType).Touch && pointer[(0, $1orLO.PointerInput).LeftClick] === 0) pointer[(0, $1orLO.PointerInput).LeftClick] = 1;
                if (evt.pointerId === undefined) evt.pointerId = this._mouseId;
                this._onInputChanged(deviceType, deviceSlot, deviceEvent);
                // Lets Propagate the event for move with same position.
                if (!this._usingSafari && evt.button !== -1) {
                    deviceEvent.inputIndex = evt.button + 2;
                    pointer[evt.button + 2] = pointer[evt.button + 2] ? 0 : 1; // Reverse state of button if evt.button has value
                    this._onInputChanged(deviceType, deviceSlot, deviceEvent);
                }
            }
        };
        this._pointerDownEvent = (evt)=>{
            const deviceType = this._getPointerType(evt);
            let deviceSlot = deviceType === (0, $1orLO.DeviceType).Mouse ? 0 : evt.pointerId;
            if (deviceType === (0, $1orLO.DeviceType).Touch) {
                const idx = this._activeTouchIds.indexOf(-1);
                if (idx >= 0) {
                    deviceSlot = idx;
                    this._activeTouchIds[idx] = evt.pointerId;
                } else {
                    // We can't find an open slot to store new pointer so just return (can only support max number of touches)
                    (0, $bOhSV.Tools).Warn(`Max number of touches exceeded.  Ignoring touches in excess of ${this._maxTouchPoints}`);
                    return;
                }
            }
            if (!this._inputs[deviceType]) this._inputs[deviceType] = {};
            if (!this._inputs[deviceType][deviceSlot]) this._addPointerDevice(deviceType, deviceSlot, evt.clientX, evt.clientY);
            else if (deviceType === (0, $1orLO.DeviceType).Touch) this._onDeviceConnected(deviceType, deviceSlot);
            const pointer = this._inputs[deviceType][deviceSlot];
            if (pointer) {
                const previousHorizontal = pointer[(0, $1orLO.PointerInput).Horizontal];
                const previousVertical = pointer[(0, $1orLO.PointerInput).Vertical];
                if (deviceType === (0, $1orLO.DeviceType).Mouse) {
                    // Mouse; Set pointerId if undefined
                    if (evt.pointerId === undefined) evt.pointerId = this._mouseId;
                    if (!document.pointerLockElement) try {
                        this._elementToAttachTo.setPointerCapture(this._mouseId);
                    } catch (e) {
                    // DO NOTHING
                    }
                } else {
                    // Touch; Since touches are dynamically assigned, only set capture if we have an id
                    if (evt.pointerId && !document.pointerLockElement) try {
                        this._elementToAttachTo.setPointerCapture(evt.pointerId);
                    } catch (e) {
                    // DO NOTHING
                    }
                }
                pointer[(0, $1orLO.PointerInput).Horizontal] = evt.clientX;
                pointer[(0, $1orLO.PointerInput).Vertical] = evt.clientY;
                pointer[evt.button + 2] = 1;
                const deviceEvent = evt;
                // NOTE: The +2 used here to is because PointerInput has the same value progression for its mouse buttons as PointerEvent.button
                // However, we have our X and Y values front-loaded to group together the touch inputs but not break this progression
                // EG. ([X, Y, Left-click], Middle-click, etc...)
                deviceEvent.inputIndex = evt.button + 2;
                this._onInputChanged(deviceType, deviceSlot, deviceEvent);
                if (previousHorizontal !== evt.clientX || previousVertical !== evt.clientY) {
                    deviceEvent.inputIndex = (0, $1orLO.PointerInput).Move;
                    this._onInputChanged(deviceType, deviceSlot, deviceEvent);
                }
            }
        };
        this._pointerUpEvent = (evt)=>{
            const deviceType = this._getPointerType(evt);
            const deviceSlot = deviceType === (0, $1orLO.DeviceType).Mouse ? 0 : this._activeTouchIds.indexOf(evt.pointerId);
            if (deviceType === (0, $1orLO.DeviceType).Touch) {
                // If we're getting a pointerup event for a touch that isn't active, just return.
                if (deviceSlot === -1) return;
                else this._activeTouchIds[deviceSlot] = -1;
            }
            const pointer = this._inputs[deviceType]?.[deviceSlot];
            if (pointer && pointer[evt.button + 2] !== 0) {
                const previousHorizontal = pointer[(0, $1orLO.PointerInput).Horizontal];
                const previousVertical = pointer[(0, $1orLO.PointerInput).Vertical];
                pointer[(0, $1orLO.PointerInput).Horizontal] = evt.clientX;
                pointer[(0, $1orLO.PointerInput).Vertical] = evt.clientY;
                pointer[evt.button + 2] = 0;
                const deviceEvent = evt;
                if (evt.pointerId === undefined) evt.pointerId = this._mouseId;
                if (previousHorizontal !== evt.clientX || previousVertical !== evt.clientY) {
                    deviceEvent.inputIndex = (0, $1orLO.PointerInput).Move;
                    this._onInputChanged(deviceType, deviceSlot, deviceEvent);
                }
                // NOTE: The +2 used here to is because PointerInput has the same value progression for its mouse buttons as PointerEvent.button
                // However, we have our X and Y values front-loaded to group together the touch inputs but not break this progression
                // EG. ([X, Y, Left-click], Middle-click, etc...)
                deviceEvent.inputIndex = evt.button + 2;
                if (deviceType === (0, $1orLO.DeviceType).Mouse && this._mouseId >= 0 && this._elementToAttachTo.hasPointerCapture?.(this._mouseId)) this._elementToAttachTo.releasePointerCapture(this._mouseId);
                else if (evt.pointerId && this._elementToAttachTo.hasPointerCapture?.(evt.pointerId)) this._elementToAttachTo.releasePointerCapture(evt.pointerId);
                this._onInputChanged(deviceType, deviceSlot, deviceEvent);
                if (deviceType === (0, $1orLO.DeviceType).Touch) this._onDeviceDisconnected(deviceType, deviceSlot);
            }
        };
        this._pointerCancelEvent = (evt)=>{
            if (evt.pointerType === "mouse") {
                const pointer = this._inputs[(0, $1orLO.DeviceType).Mouse][0];
                if (this._mouseId >= 0 && this._elementToAttachTo.hasPointerCapture?.(this._mouseId)) this._elementToAttachTo.releasePointerCapture(this._mouseId);
                for(let inputIndex = (0, $1orLO.PointerInput).LeftClick; inputIndex <= (0, $1orLO.PointerInput).BrowserForward; inputIndex++)if (pointer[inputIndex] === 1) {
                    pointer[inputIndex] = 0;
                    const deviceEvent = (0, $f1QSW.DeviceEventFactory).CreateDeviceEvent((0, $1orLO.DeviceType).Mouse, 0, inputIndex, 0, this, this._elementToAttachTo);
                    this._onInputChanged((0, $1orLO.DeviceType).Mouse, 0, deviceEvent);
                }
            } else {
                const deviceSlot = this._activeTouchIds.indexOf(evt.pointerId);
                // If we're getting a pointercancel event for a touch that isn't active, just return
                if (deviceSlot === -1) return;
                if (this._elementToAttachTo.hasPointerCapture?.(evt.pointerId)) this._elementToAttachTo.releasePointerCapture(evt.pointerId);
                this._inputs[(0, $1orLO.DeviceType).Touch][deviceSlot][(0, $1orLO.PointerInput).LeftClick] = 0;
                const deviceEvent = (0, $f1QSW.DeviceEventFactory).CreateDeviceEvent((0, $1orLO.DeviceType).Touch, deviceSlot, (0, $1orLO.PointerInput).LeftClick, 0, this, this._elementToAttachTo, evt.pointerId);
                this._onInputChanged((0, $1orLO.DeviceType).Touch, deviceSlot, deviceEvent);
                this._activeTouchIds[deviceSlot] = -1;
                this._onDeviceDisconnected((0, $1orLO.DeviceType).Touch, deviceSlot);
            }
        };
        // Set Wheel Event Name, code originally from scene.inputManager
        this._wheelEventName = "onwheel" in document.createElement("div") ? "wheel" // Modern browsers support "wheel"
         : document.onmousewheel !== undefined ? "mousewheel" // Webkit and IE support at least "mousewheel"
         : "DOMMouseScroll"; // let's assume that remaining browsers are older Firefox
        // Code originally in scene.inputManager.ts
        // Chrome reports warning in console if wheel listener doesn't set an explicit passive option.
        // IE11 only supports captureEvent:boolean, not options:object, and it defaults to false.
        // Feature detection technique copied from: https://github.com/github/eventlistener-polyfill (MIT license)
        let passiveSupported = false;
        const noop = function() {};
        try {
            const options = Object.defineProperty({}, "passive", {
                get: function() {
                    passiveSupported = true;
                }
            });
            this._elementToAttachTo.addEventListener("test", noop, options);
            this._elementToAttachTo.removeEventListener("test", noop, options);
        } catch (e) {
        /* */ }
        this._pointerBlurEvent = ()=>{
            // Handle mouse buttons
            if (this.isDeviceAvailable((0, $1orLO.DeviceType).Mouse)) {
                const pointer = this._inputs[(0, $1orLO.DeviceType).Mouse][0];
                if (this._mouseId >= 0 && this._elementToAttachTo.hasPointerCapture?.(this._mouseId)) this._elementToAttachTo.releasePointerCapture(this._mouseId);
                for(let inputIndex = (0, $1orLO.PointerInput).LeftClick; inputIndex <= (0, $1orLO.PointerInput).BrowserForward; inputIndex++)if (pointer[inputIndex] === 1) {
                    pointer[inputIndex] = 0;
                    const deviceEvent = (0, $f1QSW.DeviceEventFactory).CreateDeviceEvent((0, $1orLO.DeviceType).Mouse, 0, inputIndex, 0, this, this._elementToAttachTo);
                    this._onInputChanged((0, $1orLO.DeviceType).Mouse, 0, deviceEvent);
                }
            }
            // Handle Active Touches
            if (this.isDeviceAvailable((0, $1orLO.DeviceType).Touch)) {
                const pointer = this._inputs[(0, $1orLO.DeviceType).Touch];
                for(let deviceSlot = 0; deviceSlot < this._activeTouchIds.length; deviceSlot++){
                    const pointerId = this._activeTouchIds[deviceSlot];
                    if (this._elementToAttachTo.hasPointerCapture?.(pointerId)) this._elementToAttachTo.releasePointerCapture(pointerId);
                    if (pointerId !== -1 && pointer[deviceSlot]?.[(0, $1orLO.PointerInput).LeftClick] === 1) {
                        pointer[deviceSlot][(0, $1orLO.PointerInput).LeftClick] = 0;
                        const deviceEvent = (0, $f1QSW.DeviceEventFactory).CreateDeviceEvent((0, $1orLO.DeviceType).Touch, deviceSlot, (0, $1orLO.PointerInput).LeftClick, 0, this, this._elementToAttachTo, pointerId);
                        this._onInputChanged((0, $1orLO.DeviceType).Touch, deviceSlot, deviceEvent);
                        this._activeTouchIds[deviceSlot] = -1;
                        this._onDeviceDisconnected((0, $1orLO.DeviceType).Touch, deviceSlot);
                    }
                }
            }
        };
        this._pointerWheelEvent = (evt)=>{
            const deviceType = (0, $1orLO.DeviceType).Mouse;
            const deviceSlot = 0;
            if (!this._inputs[deviceType]) this._inputs[deviceType] = [];
            if (!this._inputs[deviceType][deviceSlot]) {
                this._pointerActive = true;
                this._registerDevice(deviceType, deviceSlot, $a650dad51390e5d8$var$MAX_POINTER_INPUTS);
            }
            const pointer = this._inputs[deviceType][deviceSlot];
            if (pointer) {
                pointer[(0, $1orLO.PointerInput).MouseWheelX] = evt.deltaX || 0;
                pointer[(0, $1orLO.PointerInput).MouseWheelY] = evt.deltaY || evt.wheelDelta || 0;
                pointer[(0, $1orLO.PointerInput).MouseWheelZ] = evt.deltaZ || 0;
                const deviceEvent = evt;
                // By default, there is no pointerId for mouse wheel events so we'll add one here
                // This logic was originally in the InputManager but was added here to make the
                // InputManager more platform-agnostic
                if (evt.pointerId === undefined) evt.pointerId = this._mouseId;
                if (pointer[(0, $1orLO.PointerInput).MouseWheelX] !== 0) {
                    deviceEvent.inputIndex = (0, $1orLO.PointerInput).MouseWheelX;
                    this._onInputChanged(deviceType, deviceSlot, deviceEvent);
                }
                if (pointer[(0, $1orLO.PointerInput).MouseWheelY] !== 0) {
                    deviceEvent.inputIndex = (0, $1orLO.PointerInput).MouseWheelY;
                    this._onInputChanged(deviceType, deviceSlot, deviceEvent);
                }
                if (pointer[(0, $1orLO.PointerInput).MouseWheelZ] !== 0) {
                    deviceEvent.inputIndex = (0, $1orLO.PointerInput).MouseWheelZ;
                    this._onInputChanged(deviceType, deviceSlot, deviceEvent);
                }
            }
        };
        // Workaround for MacOS Chromium Browsers for lost pointer capture bug
        if (this._usingMacOS && this._isUsingChromium) {
            this._pointerMacOSChromeOutEvent = (evt)=>{
                if (evt.buttons > 1) this._pointerCancelEvent(evt);
            };
            this._elementToAttachTo.addEventListener("lostpointercapture", this._pointerMacOSChromeOutEvent);
        }
        this._elementToAttachTo.addEventListener(this._eventPrefix + "move", this._pointerMoveEvent);
        this._elementToAttachTo.addEventListener(this._eventPrefix + "down", this._pointerDownEvent);
        this._elementToAttachTo.addEventListener(this._eventPrefix + "up", this._pointerUpEvent);
        this._elementToAttachTo.addEventListener(this._eventPrefix + "cancel", this._pointerCancelEvent);
        this._elementToAttachTo.addEventListener("blur", this._pointerBlurEvent);
        this._elementToAttachTo.addEventListener(this._wheelEventName, this._pointerWheelEvent, passiveSupported ? {
            passive: false
        } : false);
        // Since there's no up or down event for mouse wheel or delta x/y, clear mouse values at end of frame
        this._pointerInputClearObserver = this._engine.onEndFrameObservable.add(()=>{
            if (this.isDeviceAvailable((0, $1orLO.DeviceType).Mouse)) {
                const pointer = this._inputs[(0, $1orLO.DeviceType).Mouse][0];
                pointer[(0, $1orLO.PointerInput).MouseWheelX] = 0;
                pointer[(0, $1orLO.PointerInput).MouseWheelY] = 0;
                pointer[(0, $1orLO.PointerInput).MouseWheelZ] = 0;
            }
        });
    }
    /**
     * Handle all actions that come from gamepad interaction
     */ _handleGamepadActions() {
        this._gamepadConnectedEvent = (evt)=>{
            this._addGamePad(evt.gamepad);
        };
        this._gamepadDisconnectedEvent = (evt)=>{
            if (this._gamepads) {
                const deviceType = this._getGamepadDeviceType(evt.gamepad.id);
                const deviceSlot = evt.gamepad.index;
                this._unregisterDevice(deviceType, deviceSlot);
                delete this._gamepads[deviceSlot];
            }
        };
        window.addEventListener("gamepadconnected", this._gamepadConnectedEvent);
        window.addEventListener("gamepaddisconnected", this._gamepadDisconnectedEvent);
    }
    /**
     * Update all non-event based devices with each frame
     * @param deviceType Enum specifying device type
     * @param deviceSlot "Slot" or index that device is referenced in
     * @param inputIndex Id of input to be checked
     */ _updateDevice(deviceType, deviceSlot, inputIndex) {
        // Gamepads
        const gp = navigator.getGamepads()[deviceSlot];
        if (gp && deviceType === this._gamepads[deviceSlot]) {
            const device = this._inputs[deviceType][deviceSlot];
            if (inputIndex >= gp.buttons.length) device[inputIndex] = gp.axes[inputIndex - gp.buttons.length].valueOf();
            else device[inputIndex] = gp.buttons[inputIndex].value;
        }
    }
    /**
     * Gets DeviceType from the device name
     * @param deviceName Name of Device from DeviceInputSystem
     * @returns DeviceType enum value
     */ _getGamepadDeviceType(deviceName) {
        if (deviceName.indexOf("054c") !== -1) // DualShock 4 Gamepad
        return deviceName.indexOf("0ce6") !== -1 ? (0, $1orLO.DeviceType).DualSense : (0, $1orLO.DeviceType).DualShock;
        else if (deviceName.indexOf("Xbox One") !== -1 || deviceName.search("Xbox 360") !== -1 || deviceName.search("xinput") !== -1) // Xbox Gamepad
        return (0, $1orLO.DeviceType).Xbox;
        else if (deviceName.indexOf("057e") !== -1) // Switch Gamepad
        return (0, $1orLO.DeviceType).Switch;
        return (0, $1orLO.DeviceType).Generic;
    }
    /**
     * Get DeviceType from a given pointer/mouse/touch event.
     * @param evt PointerEvent to evaluate
     * @returns DeviceType interpreted from event
     */ _getPointerType(evt) {
        let deviceType = (0, $1orLO.DeviceType).Mouse;
        if (evt.pointerType === "touch" || evt.pointerType === "pen" || evt.touches) deviceType = (0, $1orLO.DeviceType).Touch;
        return deviceType;
    }
}

});

parcelRegister("akBjT", function(module, exports) {

$parcel$export(module.exports, "DeviceSource", () => $7858b8951db01de7$export$264532641760444);

var $diGQf = parcelRequire("diGQf");
class $7858b8951db01de7$export$264532641760444 {
    /**
     * Default Constructor
     * @param deviceInputSystem - Reference to DeviceInputSystem
     * @param deviceType - Type of device
     * @param deviceSlot - "Slot" or index that device is referenced in
     */ constructor(deviceInputSystem, /** Type of device */ deviceType, /** "Slot" or index that device is referenced in */ deviceSlot = 0){
        this.deviceType = deviceType;
        this.deviceSlot = deviceSlot;
        // Public Members
        /**
         * Observable to handle device input changes per device
         */ this.onInputChangedObservable = new (0, $diGQf.Observable)();
        this._deviceInputSystem = deviceInputSystem;
    }
    /**
     * Get input for specific input
     * @param inputIndex - index of specific input on device
     * @returns Input value from DeviceInputSystem
     */ getInput(inputIndex) {
        return this._deviceInputSystem.pollInput(this.deviceType, this.deviceSlot, inputIndex);
    }
}

});




parcelRegister("2Fclq", function(module, exports) {

$parcel$export(module.exports, "PerfCounter", () => $1f08fc7b770eb129$export$b169dc0b1adb5bcf);

var $blHSI = parcelRequire("blHSI");
class $1f08fc7b770eb129$export$b169dc0b1adb5bcf {
    /**
     * Returns the smallest value ever
     */ get min() {
        return this._min;
    }
    /**
     * Returns the biggest value ever
     */ get max() {
        return this._max;
    }
    /**
     * Returns the average value since the performance counter is running
     */ get average() {
        return this._average;
    }
    /**
     * Returns the average value of the last second the counter was monitored
     */ get lastSecAverage() {
        return this._lastSecAverage;
    }
    /**
     * Returns the current value
     */ get current() {
        return this._current;
    }
    /**
     * Gets the accumulated total
     */ get total() {
        return this._totalAccumulated;
    }
    /**
     * Gets the total value count
     */ get count() {
        return this._totalValueCount;
    }
    /**
     * Creates a new counter
     */ constructor(){
        this._startMonitoringTime = 0;
        this._min = 0;
        this._max = 0;
        this._average = 0;
        this._lastSecAverage = 0;
        this._current = 0;
        this._totalValueCount = 0;
        this._totalAccumulated = 0;
        this._lastSecAccumulated = 0;
        this._lastSecTime = 0;
        this._lastSecValueCount = 0;
    }
    /**
     * Call this method to start monitoring a new frame.
     * This scenario is typically used when you accumulate monitoring time many times for a single frame, you call this method at the start of the frame, then beginMonitoring to start recording and endMonitoring(false) to accumulated the recorded time to the PerfCounter or addCount() to accumulate a monitored count.
     */ fetchNewFrame() {
        this._totalValueCount++;
        this._current = 0;
        this._lastSecValueCount++;
    }
    /**
     * Call this method to monitor a count of something (e.g. mesh drawn in viewport count)
     * @param newCount the count value to add to the monitored count
     * @param fetchResult true when it's the last time in the frame you add to the counter and you wish to update the statistics properties (min/max/average), false if you only want to update statistics.
     */ addCount(newCount, fetchResult) {
        if (!$1f08fc7b770eb129$export$b169dc0b1adb5bcf.Enabled) return;
        this._current += newCount;
        if (fetchResult) this._fetchResult();
    }
    /**
     * Start monitoring this performance counter
     */ beginMonitoring() {
        if (!$1f08fc7b770eb129$export$b169dc0b1adb5bcf.Enabled) return;
        this._startMonitoringTime = (0, $blHSI.PrecisionDate).Now;
    }
    /**
     * Compute the time lapsed since the previous beginMonitoring() call.
     * @param newFrame true by default to fetch the result and monitor a new frame, if false the time monitored will be added to the current frame counter
     */ endMonitoring(newFrame = true) {
        if (!$1f08fc7b770eb129$export$b169dc0b1adb5bcf.Enabled) return;
        if (newFrame) this.fetchNewFrame();
        const currentTime = (0, $blHSI.PrecisionDate).Now;
        this._current = currentTime - this._startMonitoringTime;
        if (newFrame) this._fetchResult();
    }
    /**
     * Call this method to end the monitoring of a frame.
     * This scenario is typically used when you accumulate monitoring time many times for a single frame, you call this method at the end of the frame, after beginMonitoring to start recording and endMonitoring(false) to accumulated the recorded time to the PerfCounter or addCount() to accumulate a monitored count.
     */ endFrame() {
        this._fetchResult();
    }
    /** @internal */ _fetchResult() {
        this._totalAccumulated += this._current;
        this._lastSecAccumulated += this._current;
        // Min/Max update
        this._min = Math.min(this._min, this._current);
        this._max = Math.max(this._max, this._current);
        this._average = this._totalAccumulated / this._totalValueCount;
        // Reset last sec?
        const now = (0, $blHSI.PrecisionDate).Now;
        if (now - this._lastSecTime > 1000) {
            this._lastSecAverage = this._lastSecAccumulated / this._lastSecValueCount;
            this._lastSecTime = now;
            this._lastSecAccumulated = 0;
            this._lastSecValueCount = 0;
        }
    }
}
/**
 * Gets or sets a global boolean to turn on and off all the counters
 */ $1f08fc7b770eb129$export$b169dc0b1adb5bcf.Enabled = true;

});

parcelRegister("9sPMJ", function(module, exports) {

$parcel$export(module.exports, "Frustum", () => $6e3ee5fb23c17dba$export$35efe6f4c85463d2);

var $23POp = parcelRequire("23POp");
class $6e3ee5fb23c17dba$export$35efe6f4c85463d2 {
    /**
     * Gets the planes representing the frustum
     * @param transform matrix to be applied to the returned planes
     * @returns a new array of 6 Frustum planes computed by the given transformation matrix.
     */ static GetPlanes(transform) {
        const frustumPlanes = [];
        for(let index = 0; index < 6; index++)frustumPlanes.push(new (0, $23POp.Plane)(0.0, 0.0, 0.0, 0.0));
        $6e3ee5fb23c17dba$export$35efe6f4c85463d2.GetPlanesToRef(transform, frustumPlanes);
        return frustumPlanes;
    }
    /**
     * Gets the near frustum plane transformed by the transform matrix
     * @param transform transformation matrix to be applied to the resulting frustum plane
     * @param frustumPlane the resulting frustum plane
     */ static GetNearPlaneToRef(transform, frustumPlane) {
        const m = transform.m;
        frustumPlane.normal.x = m[3] + m[2];
        frustumPlane.normal.y = m[7] + m[6];
        frustumPlane.normal.z = m[11] + m[10];
        frustumPlane.d = m[15] + m[14];
        frustumPlane.normalize();
    }
    /**
     * Gets the far frustum plane transformed by the transform matrix
     * @param transform transformation matrix to be applied to the resulting frustum plane
     * @param frustumPlane the resulting frustum plane
     */ static GetFarPlaneToRef(transform, frustumPlane) {
        const m = transform.m;
        frustumPlane.normal.x = m[3] - m[2];
        frustumPlane.normal.y = m[7] - m[6];
        frustumPlane.normal.z = m[11] - m[10];
        frustumPlane.d = m[15] - m[14];
        frustumPlane.normalize();
    }
    /**
     * Gets the left frustum plane transformed by the transform matrix
     * @param transform transformation matrix to be applied to the resulting frustum plane
     * @param frustumPlane the resulting frustum plane
     */ static GetLeftPlaneToRef(transform, frustumPlane) {
        const m = transform.m;
        frustumPlane.normal.x = m[3] + m[0];
        frustumPlane.normal.y = m[7] + m[4];
        frustumPlane.normal.z = m[11] + m[8];
        frustumPlane.d = m[15] + m[12];
        frustumPlane.normalize();
    }
    /**
     * Gets the right frustum plane transformed by the transform matrix
     * @param transform transformation matrix to be applied to the resulting frustum plane
     * @param frustumPlane the resulting frustum plane
     */ static GetRightPlaneToRef(transform, frustumPlane) {
        const m = transform.m;
        frustumPlane.normal.x = m[3] - m[0];
        frustumPlane.normal.y = m[7] - m[4];
        frustumPlane.normal.z = m[11] - m[8];
        frustumPlane.d = m[15] - m[12];
        frustumPlane.normalize();
    }
    /**
     * Gets the top frustum plane transformed by the transform matrix
     * @param transform transformation matrix to be applied to the resulting frustum plane
     * @param frustumPlane the resulting frustum plane
     */ static GetTopPlaneToRef(transform, frustumPlane) {
        const m = transform.m;
        frustumPlane.normal.x = m[3] - m[1];
        frustumPlane.normal.y = m[7] - m[5];
        frustumPlane.normal.z = m[11] - m[9];
        frustumPlane.d = m[15] - m[13];
        frustumPlane.normalize();
    }
    /**
     * Gets the bottom frustum plane transformed by the transform matrix
     * @param transform transformation matrix to be applied to the resulting frustum plane
     * @param frustumPlane the resulting frustum plane
     */ static GetBottomPlaneToRef(transform, frustumPlane) {
        const m = transform.m;
        frustumPlane.normal.x = m[3] + m[1];
        frustumPlane.normal.y = m[7] + m[5];
        frustumPlane.normal.z = m[11] + m[9];
        frustumPlane.d = m[15] + m[13];
        frustumPlane.normalize();
    }
    /**
     * Sets the given array "frustumPlanes" with the 6 Frustum planes computed by the given transformation matrix.
     * @param transform transformation matrix to be applied to the resulting frustum planes
     * @param frustumPlanes the resulting frustum planes
     */ static GetPlanesToRef(transform, frustumPlanes) {
        // Near
        $6e3ee5fb23c17dba$export$35efe6f4c85463d2.GetNearPlaneToRef(transform, frustumPlanes[0]);
        // Far
        $6e3ee5fb23c17dba$export$35efe6f4c85463d2.GetFarPlaneToRef(transform, frustumPlanes[1]);
        // Left
        $6e3ee5fb23c17dba$export$35efe6f4c85463d2.GetLeftPlaneToRef(transform, frustumPlanes[2]);
        // Right
        $6e3ee5fb23c17dba$export$35efe6f4c85463d2.GetRightPlaneToRef(transform, frustumPlanes[3]);
        // Top
        $6e3ee5fb23c17dba$export$35efe6f4c85463d2.GetTopPlaneToRef(transform, frustumPlanes[4]);
        // Bottom
        $6e3ee5fb23c17dba$export$35efe6f4c85463d2.GetBottomPlaneToRef(transform, frustumPlanes[5]);
    }
    /**
     * Tests if a point is located between the frustum planes.
     * @param point defines the point to test
     * @param frustumPlanes defines the frustum planes to test
     * @returns true if the point is located between the frustum planes
     */ static IsPointInFrustum(point, frustumPlanes) {
        for(let i = 0; i < 6; i++){
            if (frustumPlanes[i].dotCoordinate(point) < 0) return false;
        }
        return true;
    }
}

});
parcelRegister("23POp", function(module, exports) {

$parcel$export(module.exports, "Plane", () => $18040d5ac1d0a403$export$7ff5ac152ef991b0);

var $ha1VO = parcelRequire("ha1VO");
class $18040d5ac1d0a403$export$7ff5ac152ef991b0 {
    /**
     * Creates a Plane object according to the given floats a, b, c, d and the plane equation : ax + by + cz + d = 0
     * @param a a component of the plane
     * @param b b component of the plane
     * @param c c component of the plane
     * @param d d component of the plane
     */ constructor(a, b, c, d){
        this.normal = new (0, $ha1VO.Vector3)(a, b, c);
        this.d = d;
    }
    /**
     * @returns the plane coordinates as a new array of 4 elements [a, b, c, d].
     */ asArray() {
        return [
            this.normal.x,
            this.normal.y,
            this.normal.z,
            this.d
        ];
    }
    // Methods
    /**
     * @returns a new plane copied from the current Plane.
     */ clone() {
        return new $18040d5ac1d0a403$export$7ff5ac152ef991b0(this.normal.x, this.normal.y, this.normal.z, this.d);
    }
    /**
     * @returns the string "Plane".
     */ getClassName() {
        return "Plane";
    }
    /**
     * @returns the Plane hash code.
     */ getHashCode() {
        let hash = this.normal.getHashCode();
        hash = hash * 397 ^ (this.d | 0);
        return hash;
    }
    /**
     * Normalize the current Plane in place.
     * @returns the updated Plane.
     */ normalize() {
        const norm = Math.sqrt(this.normal.x * this.normal.x + this.normal.y * this.normal.y + this.normal.z * this.normal.z);
        let magnitude = 0.0;
        if (norm !== 0) magnitude = 1.0 / norm;
        this.normal.x *= magnitude;
        this.normal.y *= magnitude;
        this.normal.z *= magnitude;
        this.d *= magnitude;
        return this;
    }
    /**
     * Applies a transformation the plane and returns the result
     * @param transformation the transformation matrix to be applied to the plane
     * @returns a new Plane as the result of the transformation of the current Plane by the given matrix.
     */ transform(transformation) {
        const invertedMatrix = $18040d5ac1d0a403$export$7ff5ac152ef991b0._TmpMatrix;
        transformation.invertToRef(invertedMatrix);
        const m = invertedMatrix.m;
        const x = this.normal.x;
        const y = this.normal.y;
        const z = this.normal.z;
        const d = this.d;
        const normalX = x * m[0] + y * m[1] + z * m[2] + d * m[3];
        const normalY = x * m[4] + y * m[5] + z * m[6] + d * m[7];
        const normalZ = x * m[8] + y * m[9] + z * m[10] + d * m[11];
        const finalD = x * m[12] + y * m[13] + z * m[14] + d * m[15];
        return new $18040d5ac1d0a403$export$7ff5ac152ef991b0(normalX, normalY, normalZ, finalD);
    }
    /**
     * Compute the dot product between the point and the plane normal
     * @param point point to calculate the dot product with
     * @returns the dot product (float) of the point coordinates and the plane normal.
     */ dotCoordinate(point) {
        return this.normal.x * point.x + this.normal.y * point.y + this.normal.z * point.z + this.d;
    }
    /**
     * Updates the current Plane from the plane defined by the three given points.
     * @param point1 one of the points used to construct the plane
     * @param point2 one of the points used to construct the plane
     * @param point3 one of the points used to construct the plane
     * @returns the updated Plane.
     */ copyFromPoints(point1, point2, point3) {
        const x1 = point2.x - point1.x;
        const y1 = point2.y - point1.y;
        const z1 = point2.z - point1.z;
        const x2 = point3.x - point1.x;
        const y2 = point3.y - point1.y;
        const z2 = point3.z - point1.z;
        const yz = y1 * z2 - z1 * y2;
        const xz = z1 * x2 - x1 * z2;
        const xy = x1 * y2 - y1 * x2;
        const pyth = Math.sqrt(yz * yz + xz * xz + xy * xy);
        let invPyth;
        if (pyth !== 0) invPyth = 1.0 / pyth;
        else invPyth = 0.0;
        this.normal.x = yz * invPyth;
        this.normal.y = xz * invPyth;
        this.normal.z = xy * invPyth;
        this.d = -(this.normal.x * point1.x + this.normal.y * point1.y + this.normal.z * point1.z);
        return this;
    }
    /**
     * Checks if the plane is facing a given direction (meaning if the plane's normal is pointing in the opposite direction of the given vector).
     * Note that for this function to work as expected you should make sure that:
     *   - direction and the plane normal are normalized
     *   - epsilon is a number just bigger than -1, something like -0.99 for eg
     * @param direction the direction to check if the plane is facing
     * @param epsilon value the dot product is compared against (returns true if dot <= epsilon)
     * @returns True if the plane is facing the given direction
     */ isFrontFacingTo(direction, epsilon) {
        const dot = (0, $ha1VO.Vector3).Dot(this.normal, direction);
        return dot <= epsilon;
    }
    /**
     * Calculates the distance to a point
     * @param point point to calculate distance to
     * @returns the signed distance (float) from the given point to the Plane.
     */ signedDistanceTo(point) {
        return (0, $ha1VO.Vector3).Dot(point, this.normal) + this.d;
    }
    // Statics
    /**
     * Creates a plane from an  array
     * @param array the array to create a plane from
     * @returns a new Plane from the given array.
     */ static FromArray(array) {
        return new $18040d5ac1d0a403$export$7ff5ac152ef991b0(array[0], array[1], array[2], array[3]);
    }
    /**
     * Creates a plane from three points
     * @param point1 point used to create the plane
     * @param point2 point used to create the plane
     * @param point3 point used to create the plane
     * @returns a new Plane defined by the three given points.
     */ static FromPoints(point1, point2, point3) {
        const result = new $18040d5ac1d0a403$export$7ff5ac152ef991b0(0.0, 0.0, 0.0, 0.0);
        result.copyFromPoints(point1, point2, point3);
        return result;
    }
    /**
     * Creates a plane from an origin point and a normal
     * @param origin origin of the plane to be constructed
     * @param normal normal of the plane to be constructed
     * @returns a new Plane the normal vector to this plane at the given origin point.
     */ static FromPositionAndNormal(origin, normal) {
        const plane = new $18040d5ac1d0a403$export$7ff5ac152ef991b0(0.0, 0.0, 0.0, 0.0);
        return this.FromPositionAndNormalToRef(origin, normal, plane);
    }
    /**
     * Updates the given Plane "result" from an origin point and a normal.
     * @param origin origin of the plane to be constructed
     * @param normal the normalized normals of the plane to be constructed
     * @param result defines the Plane where to store the result
     * @returns result input
     */ static FromPositionAndNormalToRef(origin, normal, result) {
        result.normal.copyFrom(normal);
        result.normal.normalize();
        result.d = -origin.dot(result.normal);
        return result;
    }
    /**
     * Calculates the distance from a plane and a point
     * @param origin origin of the plane to be constructed
     * @param normal normal of the plane to be constructed
     * @param point point to calculate distance to
     * @returns the signed distance between the plane defined by the normal vector at the "origin"" point and the given other point.
     */ static SignedDistanceToPlaneFromPositionAndNormal(origin, normal, point) {
        const d = -(normal.x * origin.x + normal.y * origin.y + normal.z * origin.z);
        return (0, $ha1VO.Vector3).Dot(point, normal) + d;
    }
}
$18040d5ac1d0a403$export$7ff5ac152ef991b0._TmpMatrix = (0, $ha1VO.Matrix).Identity();

});


parcelRegister("3u0QC", function(module, exports) {

$parcel$export(module.exports, "UniqueIdGenerator", () => $2894d4ca4074affe$export$454cbf26098d48c4);
/**
 * Helper class used to generate session unique ID
 */ class $2894d4ca4074affe$export$454cbf26098d48c4 {
    /**
     * Gets an unique (relatively to the current scene) Id
     */ static get UniqueId() {
        const result = this._UniqueIdCounter;
        this._UniqueIdCounter++;
        return result;
    }
}
// Statics
$2894d4ca4074affe$export$454cbf26098d48c4._UniqueIdCounter = 1;

});

parcelRegister("1gEbu", function(module, exports) {

$parcel$export(module.exports, "LightConstants", () => $0ec674d257277259$export$d8782f3b376962c0);
/** Defines the cross module constantsused by lights to avoid circular dependencies */ class $0ec674d257277259$export$d8782f3b376962c0 {
    /**
     * Sort function to order lights for rendering.
     * @param a First Light object to compare to second.
     * @param b Second Light object to compare first.
     * @returns -1 to reduce's a's index relative to be, 0 for no change, 1 to increase a's index relative to b.
     */ static CompareLightsPriority(a, b) {
        //shadow-casting lights have priority over non-shadow-casting lights
        //the renderPriority is a secondary sort criterion
        if (a.shadowEnabled !== b.shadowEnabled) return (b.shadowEnabled ? 1 : 0) - (a.shadowEnabled ? 1 : 0);
        return b.renderPriority - a.renderPriority;
    }
}
/**
 * Falloff Default: light is falling off following the material specification:
 * standard material is using standard falloff whereas pbr material can request special falloff per materials.
 */ $0ec674d257277259$export$d8782f3b376962c0.FALLOFF_DEFAULT = 0;
/**
 * Falloff Physical: light is falling off following the inverse squared distance law.
 */ $0ec674d257277259$export$d8782f3b376962c0.FALLOFF_PHYSICAL = 1;
/**
 * Falloff gltf: light is falling off as described in the gltf moving to PBR document
 * to enhance interoperability with other engines.
 */ $0ec674d257277259$export$d8782f3b376962c0.FALLOFF_GLTF = 2;
/**
 * Falloff Standard: light is falling off like in the standard material
 * to enhance interoperability with other materials.
 */ $0ec674d257277259$export$d8782f3b376962c0.FALLOFF_STANDARD = 3;
//lightmapMode Consts
/**
 * If every light affecting the material is in this lightmapMode,
 * material.lightmapTexture adds or multiplies
 * (depends on material.useLightmapAsShadowmap)
 * after every other light calculations.
 */ $0ec674d257277259$export$d8782f3b376962c0.LIGHTMAP_DEFAULT = 0;
/**
 * material.lightmapTexture as only diffuse lighting from this light
 * adds only specular lighting from this light
 * adds dynamic shadows
 */ $0ec674d257277259$export$d8782f3b376962c0.LIGHTMAP_SPECULAR = 1;
/**
 * material.lightmapTexture as only lighting
 * no light calculation from this light
 * only adds dynamic shadows from this light
 */ $0ec674d257277259$export$d8782f3b376962c0.LIGHTMAP_SHADOWSONLY = 2;
// Intensity Mode Consts
/**
 * Each light type uses the default quantity according to its type:
 *      point/spot lights use luminous intensity
 *      directional lights use illuminance
 */ $0ec674d257277259$export$d8782f3b376962c0.INTENSITYMODE_AUTOMATIC = 0;
/**
 * lumen (lm)
 */ $0ec674d257277259$export$d8782f3b376962c0.INTENSITYMODE_LUMINOUSPOWER = 1;
/**
 * candela (lm/sr)
 */ $0ec674d257277259$export$d8782f3b376962c0.INTENSITYMODE_LUMINOUSINTENSITY = 2;
/**
 * lux (lm/m^2)
 */ $0ec674d257277259$export$d8782f3b376962c0.INTENSITYMODE_ILLUMINANCE = 3;
/**
 * nit (cd/m^2)
 */ $0ec674d257277259$export$d8782f3b376962c0.INTENSITYMODE_LUMINANCE = 4;
// Light types ids const.
/**
 * Light type const id of the point light.
 */ $0ec674d257277259$export$d8782f3b376962c0.LIGHTTYPEID_POINTLIGHT = 0;
/**
 * Light type const id of the directional light.
 */ $0ec674d257277259$export$d8782f3b376962c0.LIGHTTYPEID_DIRECTIONALLIGHT = 1;
/**
 * Light type const id of the spot light.
 */ $0ec674d257277259$export$d8782f3b376962c0.LIGHTTYPEID_SPOTLIGHT = 2;
/**
 * Light type const id of the hemispheric light.
 */ $0ec674d257277259$export$d8782f3b376962c0.LIGHTTYPEID_HEMISPHERICLIGHT = 3;

});

parcelRegister("lDzLx", function(module, exports) {

$parcel$export(module.exports, "PointerPickingConfiguration", () => $fc08fbd12e8abddf$export$db76c3278aa44f54);
/**
 * Class used to store configuration data associated with pointer picking
 */ class $fc08fbd12e8abddf$export$db76c3278aa44f54 {
    constructor(){
        /**
         * Gets or sets a predicate used to select candidate meshes for a pointer down event
         */ this.pointerDownFastCheck = false;
        /**
         * Gets or sets a predicate used to select candidate meshes for a pointer up event
         */ this.pointerUpFastCheck = false;
        /**
         * Gets or sets a predicate used to select candidate meshes for a pointer move event
         */ this.pointerMoveFastCheck = false;
        /**
         * Gets or sets a boolean indicating if the user want to entirely skip the picking phase when a pointer move event occurs.
         */ this.skipPointerMovePicking = false;
        /**
         * Gets or sets a boolean indicating if the user want to entirely skip the picking phase when a pointer down event occurs.
         */ this.skipPointerDownPicking = false;
        /**
         * Gets or sets a boolean indicating if the user want to entirely skip the picking phase when a pointer up event occurs.  Off by default.
         */ this.skipPointerUpPicking = false;
    }
}

});


parcelRegister("g6X9E", function(module, exports) {

$parcel$export(module.exports, "Bone", () => $bbab17c2ca6aeebf$export$b127726e56765aa4);

var $ha1VO = parcelRequire("ha1VO");

var $opFp4 = parcelRequire("opFp4");

var $bgssx = parcelRequire("bgssx");

var $dbxbu = parcelRequire("dbxbu");
class $bbab17c2ca6aeebf$export$b127726e56765aa4 extends (0, $bgssx.Node) {
    /** @internal */ get _matrix() {
        this._compose();
        return this._localMatrix;
    }
    /** @internal */ set _matrix(value) {
        // skip if the matrices are the same
        if (value.updateFlag === this._localMatrix.updateFlag && !this._needToCompose) return;
        this._needToCompose = false; // in case there was a pending compose
        this._localMatrix.copyFrom(value);
        this._markAsDirtyAndDecompose();
    }
    /**
     * Create a new bone
     * @param name defines the bone name
     * @param skeleton defines the parent skeleton
     * @param parentBone defines the parent (can be null if the bone is the root)
     * @param localMatrix defines the local matrix (default: identity)
     * @param restMatrix defines the rest matrix (default: localMatrix)
     * @param bindMatrix defines the bind matrix (default: localMatrix)
     * @param index defines index of the bone in the hierarchy (default: null)
     */ constructor(/**
     * defines the bone name
     */ name, skeleton, parentBone = null, localMatrix = null, restMatrix = null, bindMatrix = null, index = null){
        super(name, skeleton.getScene());
        this.name = name;
        /**
         * Gets the list of child bones
         */ this.children = [];
        /** Gets the animations associated with this bone */ this.animations = [];
        /**
         * @internal Internal only
         * Set this value to map this bone to a different index in the transform matrices
         * Set this value to -1 to exclude the bone from the transform matrices
         */ this._index = null;
        this._scalingDeterminant = 1;
        this._needToDecompose = true;
        this._needToCompose = false;
        /** @internal */ this._linkedTransformNode = null;
        /** @internal */ this._waitingTransformNodeId = null;
        this._skeleton = skeleton;
        this._localMatrix = localMatrix?.clone() ?? (0, $ha1VO.Matrix).Identity();
        this._restMatrix = restMatrix ?? this._localMatrix.clone();
        this._bindMatrix = bindMatrix ?? this._localMatrix.clone();
        this._index = index;
        this._absoluteMatrix = new (0, $ha1VO.Matrix)();
        this._absoluteBindMatrix = new (0, $ha1VO.Matrix)();
        this._absoluteInverseBindMatrix = new (0, $ha1VO.Matrix)();
        this._finalMatrix = new (0, $ha1VO.Matrix)();
        skeleton.bones.push(this);
        this.setParent(parentBone, false);
        this._updateAbsoluteBindMatrices();
    }
    /**
     * Gets the current object class name.
     * @returns the class name
     */ getClassName() {
        return "Bone";
    }
    // Members
    /**
     * Gets the parent skeleton
     * @returns a skeleton
     */ getSkeleton() {
        return this._skeleton;
    }
    get parent() {
        return this._parentNode;
    }
    /**
     * Gets parent bone
     * @returns a bone or null if the bone is the root of the bone hierarchy
     */ getParent() {
        return this.parent;
    }
    /**
     * Returns an array containing the children of the bone
     * @returns an array containing the children of the bone (can be empty if the bone has no children)
     */ getChildren() {
        return this.children;
    }
    /**
     * Gets the node index in matrix array generated for rendering
     * @returns the node index
     */ getIndex() {
        return this._index === null ? this.getSkeleton().bones.indexOf(this) : this._index;
    }
    set parent(newParent) {
        this.setParent(newParent);
    }
    /**
     * Sets the parent bone
     * @param parent defines the parent (can be null if the bone is the root)
     * @param updateAbsoluteBindMatrices defines if the absolute bind and absolute inverse bind matrices must be updated
     */ setParent(parent, updateAbsoluteBindMatrices = true) {
        if (this.parent === parent) return;
        if (this.parent) {
            const index = this.parent.children.indexOf(this);
            if (index !== -1) this.parent.children.splice(index, 1);
        }
        this._parentNode = parent;
        if (this.parent) this.parent.children.push(this);
        if (updateAbsoluteBindMatrices) this._updateAbsoluteBindMatrices();
        this.markAsDirty();
    }
    /**
     * Gets the local matrix
     * @returns the local matrix
     */ getLocalMatrix() {
        this._compose();
        return this._localMatrix;
    }
    /**
     * Gets the bind matrix
     * @returns the bind matrix
     */ getBindMatrix() {
        return this._bindMatrix;
    }
    /**
     * Gets the bind matrix.
     * @returns the bind matrix
     * @deprecated Please use getBindMatrix instead
     */ getBaseMatrix() {
        return this.getBindMatrix();
    }
    /**
     * Gets the rest matrix
     * @returns the rest matrix
     */ getRestMatrix() {
        return this._restMatrix;
    }
    /**
     * Gets the rest matrix
     * @returns the rest matrix
     * @deprecated Please use getRestMatrix instead
     */ getRestPose() {
        return this.getRestMatrix();
    }
    /**
     * Sets the rest matrix
     * @param matrix the local-space rest matrix to set for this bone
     */ setRestMatrix(matrix) {
        this._restMatrix.copyFrom(matrix);
    }
    /**
     * Sets the rest matrix
     * @param matrix the local-space rest to set for this bone
     * @deprecated Please use setRestMatrix instead
     */ setRestPose(matrix) {
        this.setRestMatrix(matrix);
    }
    /**
     * Gets the bind matrix
     * @returns the bind matrix
     * @deprecated Please use getBindMatrix instead
     */ getBindPose() {
        return this.getBindMatrix();
    }
    /**
     * Sets the bind matrix
     * This will trigger a recomputation of the absolute bind and absolute inverse bind matrices for this bone and its children
     * Note that the local matrix will also be set with the matrix passed in parameter!
     * @param matrix the local-space bind matrix to set for this bone
     */ setBindMatrix(matrix) {
        this.updateMatrix(matrix);
    }
    /**
     * Sets the bind matrix
     * @param matrix the local-space bind to set for this bone
     * @deprecated Please use setBindMatrix instead
     */ setBindPose(matrix) {
        this.setBindMatrix(matrix);
    }
    /**
     * Gets the matrix used to store the final world transformation of the bone (ie. the matrix sent to shaders)
     * @returns the final world matrix
     */ getFinalMatrix() {
        return this._finalMatrix;
    }
    /**
     * Gets the matrix used to store the final world transformation of the bone (ie. the matrix sent to shaders)
     * @deprecated Please use getFinalMatrix instead
     * @returns the final world matrix
     */ getWorldMatrix() {
        return this.getFinalMatrix();
    }
    /**
     * Sets the local matrix to the rest matrix
     */ returnToRest() {
        if (this._linkedTransformNode) {
            const localScaling = (0, $ha1VO.TmpVectors).Vector3[0];
            const localRotation = (0, $ha1VO.TmpVectors).Quaternion[0];
            const localPosition = (0, $ha1VO.TmpVectors).Vector3[1];
            this.getRestMatrix().decompose(localScaling, localRotation, localPosition);
            this._linkedTransformNode.position.copyFrom(localPosition);
            this._linkedTransformNode.rotationQuaternion = this._linkedTransformNode.rotationQuaternion ?? (0, $ha1VO.Quaternion).Identity();
            this._linkedTransformNode.rotationQuaternion.copyFrom(localRotation);
            this._linkedTransformNode.scaling.copyFrom(localScaling);
        } else this._matrix = this._restMatrix;
    }
    /**
     * Gets the inverse of the bind matrix, in world space (relative to the skeleton root)
     * @returns the inverse bind matrix, in world space
     */ getAbsoluteInverseBindMatrix() {
        return this._absoluteInverseBindMatrix;
    }
    /**
     * Gets the inverse of the bind matrix, in world space (relative to the skeleton root)
     * @returns the inverse bind matrix, in world space
     * @deprecated Please use getAbsoluteInverseBindMatrix instead
     */ getInvertedAbsoluteTransform() {
        return this.getAbsoluteInverseBindMatrix();
    }
    /**
     * Gets the bone matrix, in world space (relative to the skeleton root)
     * @returns the bone matrix, in world space
     */ getAbsoluteMatrix() {
        return this._absoluteMatrix;
    }
    /**
     * Gets the bone matrix, in world space (relative to the skeleton root)
     * @returns the bone matrix, in world space
     * @deprecated Please use getAbsoluteMatrix instead
     */ getAbsoluteTransform() {
        return this._absoluteMatrix;
    }
    /**
     * Links with the given transform node.
     * The local matrix of this bone is overwritten by the transform of the node every frame.
     * @param transformNode defines the transform node to link to
     */ linkTransformNode(transformNode) {
        if (this._linkedTransformNode) this._skeleton._numBonesWithLinkedTransformNode--;
        this._linkedTransformNode = transformNode;
        if (this._linkedTransformNode) this._skeleton._numBonesWithLinkedTransformNode++;
    }
    // Properties (matches TransformNode properties)
    /**
     * Gets the node used to drive the bone's transformation
     * @returns a transform node or null
     */ getTransformNode() {
        return this._linkedTransformNode;
    }
    /** Gets or sets current position (in local space) */ get position() {
        this._decompose();
        return this._localPosition;
    }
    set position(newPosition) {
        this._decompose();
        this._localPosition.copyFrom(newPosition);
        this._markAsDirtyAndCompose();
    }
    /** Gets or sets current rotation (in local space) */ get rotation() {
        return this.getRotation();
    }
    set rotation(newRotation) {
        this.setRotation(newRotation);
    }
    /** Gets or sets current rotation quaternion (in local space) */ get rotationQuaternion() {
        this._decompose();
        return this._localRotation;
    }
    set rotationQuaternion(newRotation) {
        this.setRotationQuaternion(newRotation);
    }
    /** Gets or sets current scaling (in local space) */ get scaling() {
        return this.getScale();
    }
    set scaling(newScaling) {
        this.setScale(newScaling);
    }
    /**
     * Gets the animation properties override
     */ get animationPropertiesOverride() {
        return this._skeleton.animationPropertiesOverride;
    }
    // Methods
    _decompose() {
        if (!this._needToDecompose) return;
        this._needToDecompose = false;
        if (!this._localScaling) {
            this._localScaling = (0, $ha1VO.Vector3).Zero();
            this._localRotation = (0, $ha1VO.Quaternion).Zero();
            this._localPosition = (0, $ha1VO.Vector3).Zero();
        }
        this._localMatrix.decompose(this._localScaling, this._localRotation, this._localPosition);
    }
    _compose() {
        if (!this._needToCompose) return;
        if (!this._localScaling) {
            this._needToCompose = false;
            return;
        }
        this._needToCompose = false;
        (0, $ha1VO.Matrix).ComposeToRef(this._localScaling, this._localRotation, this._localPosition, this._localMatrix);
    }
    /**
     * Update the bind (and optionally the local) matrix
     * @param bindMatrix defines the new matrix to set to the bind/local matrix, in local space
     * @param updateAbsoluteBindMatrices defines if the absolute bind and absolute inverse bind matrices must be recomputed (default: true)
     * @param updateLocalMatrix defines if the local matrix should also be updated with the matrix passed in parameter (default: true)
     */ updateMatrix(bindMatrix, updateAbsoluteBindMatrices = true, updateLocalMatrix = true) {
        this._bindMatrix.copyFrom(bindMatrix);
        if (updateAbsoluteBindMatrices) this._updateAbsoluteBindMatrices();
        if (updateLocalMatrix) this._matrix = bindMatrix;
        else this.markAsDirty();
    }
    /**
     * @internal
     */ _updateAbsoluteBindMatrices(bindMatrix, updateChildren = true) {
        if (!bindMatrix) bindMatrix = this._bindMatrix;
        if (this.parent) bindMatrix.multiplyToRef(this.parent._absoluteBindMatrix, this._absoluteBindMatrix);
        else this._absoluteBindMatrix.copyFrom(bindMatrix);
        this._absoluteBindMatrix.invertToRef(this._absoluteInverseBindMatrix);
        if (updateChildren) for(let index = 0; index < this.children.length; index++)this.children[index]._updateAbsoluteBindMatrices();
        this._scalingDeterminant = this._absoluteBindMatrix.determinant() < 0 ? -1 : 1;
    }
    /**
     * Flag the bone as dirty (Forcing it to update everything)
     * @returns this bone
     */ markAsDirty() {
        this._currentRenderId++;
        this._childUpdateId++;
        this._skeleton._markAsDirty();
        return this;
    }
    /** @internal */ _markAsDirtyAndCompose() {
        this.markAsDirty();
        this._needToCompose = true;
    }
    _markAsDirtyAndDecompose() {
        this.markAsDirty();
        this._needToDecompose = true;
    }
    _updatePosition(vec, space = (0, $dbxbu.Space).LOCAL, tNode, translationMode = true) {
        const lm = this.getLocalMatrix();
        if (space == (0, $dbxbu.Space).LOCAL) {
            if (translationMode) {
                lm.addAtIndex(12, vec.x);
                lm.addAtIndex(13, vec.y);
                lm.addAtIndex(14, vec.z);
            } else lm.setTranslationFromFloats(vec.x, vec.y, vec.z);
        } else {
            let wm = null;
            //tNode.getWorldMatrix() needs to be called before skeleton.computeAbsoluteMatrices()
            if (tNode) wm = tNode.getWorldMatrix();
            this._skeleton.computeAbsoluteMatrices();
            const tmat = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[0];
            const tvec = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpVecs[0];
            if (this.parent) {
                if (tNode && wm) {
                    tmat.copyFrom(this.parent.getAbsoluteMatrix());
                    tmat.multiplyToRef(wm, tmat);
                } else tmat.copyFrom(this.parent.getAbsoluteMatrix());
            } else (0, $ha1VO.Matrix).IdentityToRef(tmat);
            if (translationMode) tmat.setTranslationFromFloats(0, 0, 0);
            tmat.invert();
            (0, $ha1VO.Vector3).TransformCoordinatesToRef(vec, tmat, tvec);
            if (translationMode) {
                lm.addAtIndex(12, tvec.x);
                lm.addAtIndex(13, tvec.y);
                lm.addAtIndex(14, tvec.z);
            } else lm.setTranslationFromFloats(tvec.x, tvec.y, tvec.z);
        }
        this._markAsDirtyAndDecompose();
    }
    /**
     * Translate the bone in local or world space
     * @param vec The amount to translate the bone
     * @param space The space that the translation is in (default: Space.LOCAL)
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     */ translate(vec, space = (0, $dbxbu.Space).LOCAL, tNode) {
        this._updatePosition(vec, space, tNode, true);
    }
    /**
     * Set the position of the bone in local or world space
     * @param position The position to set the bone
     * @param space The space that the position is in (default: Space.LOCAL)
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     */ setPosition(position, space = (0, $dbxbu.Space).LOCAL, tNode) {
        this._updatePosition(position, space, tNode, false);
    }
    /**
     * Set the absolute position of the bone (world space)
     * @param position The position to set the bone
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     */ setAbsolutePosition(position, tNode) {
        this.setPosition(position, (0, $dbxbu.Space).WORLD, tNode);
    }
    /**
     * Scale the bone on the x, y and z axes (in local space)
     * @param x The amount to scale the bone on the x axis
     * @param y The amount to scale the bone on the y axis
     * @param z The amount to scale the bone on the z axis
     * @param scaleChildren sets this to true if children of the bone should be scaled as well (false by default)
     */ scale(x, y, z, scaleChildren = false) {
        const locMat = this.getLocalMatrix();
        // Apply new scaling on top of current local matrix
        const scaleMat = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[0];
        (0, $ha1VO.Matrix).ScalingToRef(x, y, z, scaleMat);
        scaleMat.multiplyToRef(locMat, locMat);
        // Invert scaling matrix and apply the inverse to all children
        scaleMat.invert();
        for (const child of this.children){
            const cm = child.getLocalMatrix();
            cm.multiplyToRef(scaleMat, cm);
            cm.multiplyAtIndex(12, x);
            cm.multiplyAtIndex(13, y);
            cm.multiplyAtIndex(14, z);
            child._markAsDirtyAndDecompose();
        }
        this._markAsDirtyAndDecompose();
        if (scaleChildren) for (const child of this.children)child.scale(x, y, z, scaleChildren);
    }
    /**
     * Set the bone scaling in local space
     * @param scale defines the scaling vector
     */ setScale(scale) {
        this._decompose();
        this._localScaling.copyFrom(scale);
        this._markAsDirtyAndCompose();
    }
    /**
     * Gets the current scaling in local space
     * @returns the current scaling vector
     */ getScale() {
        this._decompose();
        return this._localScaling;
    }
    /**
     * Gets the current scaling in local space and stores it in a target vector
     * @param result defines the target vector
     */ getScaleToRef(result) {
        this._decompose();
        result.copyFrom(this._localScaling);
    }
    /**
     * Set the yaw, pitch, and roll of the bone in local or world space
     * @param yaw The rotation of the bone on the y axis
     * @param pitch The rotation of the bone on the x axis
     * @param roll The rotation of the bone on the z axis
     * @param space The space that the axes of rotation are in
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     */ setYawPitchRoll(yaw, pitch, roll, space = (0, $dbxbu.Space).LOCAL, tNode) {
        if (space === (0, $dbxbu.Space).LOCAL) {
            const quat = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpQuat;
            (0, $ha1VO.Quaternion).RotationYawPitchRollToRef(yaw, pitch, roll, quat);
            this.setRotationQuaternion(quat, space, tNode);
            return;
        }
        const rotMatInv = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[0];
        if (!this._getAbsoluteInverseMatrixUnscaledToRef(rotMatInv, tNode)) return;
        const rotMat = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[1];
        (0, $ha1VO.Matrix).RotationYawPitchRollToRef(yaw, pitch, roll, rotMat);
        rotMatInv.multiplyToRef(rotMat, rotMat);
        this._rotateWithMatrix(rotMat, space, tNode);
    }
    /**
     * Add a rotation to the bone on an axis in local or world space
     * @param axis The axis to rotate the bone on
     * @param amount The amount to rotate the bone
     * @param space The space that the axis is in
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     */ rotate(axis, amount, space = (0, $dbxbu.Space).LOCAL, tNode) {
        const rmat = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[0];
        rmat.setTranslationFromFloats(0, 0, 0);
        (0, $ha1VO.Matrix).RotationAxisToRef(axis, amount, rmat);
        this._rotateWithMatrix(rmat, space, tNode);
    }
    /**
     * Set the rotation of the bone to a particular axis angle in local or world space
     * @param axis The axis to rotate the bone on
     * @param angle The angle that the bone should be rotated to
     * @param space The space that the axis is in
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     */ setAxisAngle(axis, angle, space = (0, $dbxbu.Space).LOCAL, tNode) {
        if (space === (0, $dbxbu.Space).LOCAL) {
            const quat = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpQuat;
            (0, $ha1VO.Quaternion).RotationAxisToRef(axis, angle, quat);
            this.setRotationQuaternion(quat, space, tNode);
            return;
        }
        const rotMatInv = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[0];
        if (!this._getAbsoluteInverseMatrixUnscaledToRef(rotMatInv, tNode)) return;
        const rotMat = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[1];
        (0, $ha1VO.Matrix).RotationAxisToRef(axis, angle, rotMat);
        rotMatInv.multiplyToRef(rotMat, rotMat);
        this._rotateWithMatrix(rotMat, space, tNode);
    }
    /**
     * Set the euler rotation of the bone in local or world space
     * @param rotation The euler rotation that the bone should be set to
     * @param space The space that the rotation is in
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     */ setRotation(rotation, space = (0, $dbxbu.Space).LOCAL, tNode) {
        this.setYawPitchRoll(rotation.y, rotation.x, rotation.z, space, tNode);
    }
    /**
     * Set the quaternion rotation of the bone in local or world space
     * @param quat The quaternion rotation that the bone should be set to
     * @param space The space that the rotation is in
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     */ setRotationQuaternion(quat, space = (0, $dbxbu.Space).LOCAL, tNode) {
        if (space === (0, $dbxbu.Space).LOCAL) {
            this._decompose();
            this._localRotation.copyFrom(quat);
            this._markAsDirtyAndCompose();
            return;
        }
        const rotMatInv = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[0];
        if (!this._getAbsoluteInverseMatrixUnscaledToRef(rotMatInv, tNode)) return;
        const rotMat = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[1];
        (0, $ha1VO.Matrix).FromQuaternionToRef(quat, rotMat);
        rotMatInv.multiplyToRef(rotMat, rotMat);
        this._rotateWithMatrix(rotMat, space, tNode);
    }
    /**
     * Set the rotation matrix of the bone in local or world space
     * @param rotMat The rotation matrix that the bone should be set to
     * @param space The space that the rotation is in
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     */ setRotationMatrix(rotMat, space = (0, $dbxbu.Space).LOCAL, tNode) {
        if (space === (0, $dbxbu.Space).LOCAL) {
            const quat = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpQuat;
            (0, $ha1VO.Quaternion).FromRotationMatrixToRef(rotMat, quat);
            this.setRotationQuaternion(quat, space, tNode);
            return;
        }
        const rotMatInv = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[0];
        if (!this._getAbsoluteInverseMatrixUnscaledToRef(rotMatInv, tNode)) return;
        const rotMat2 = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[1];
        rotMat2.copyFrom(rotMat);
        rotMatInv.multiplyToRef(rotMat, rotMat2);
        this._rotateWithMatrix(rotMat2, space, tNode);
    }
    _rotateWithMatrix(rmat, space = (0, $dbxbu.Space).LOCAL, tNode) {
        const lmat = this.getLocalMatrix();
        const lx = lmat.m[12];
        const ly = lmat.m[13];
        const lz = lmat.m[14];
        const parent = this.getParent();
        const parentScale = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[3];
        const parentScaleInv = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[4];
        if (parent && space == (0, $dbxbu.Space).WORLD) {
            if (tNode) {
                parentScale.copyFrom(tNode.getWorldMatrix());
                parent.getAbsoluteMatrix().multiplyToRef(parentScale, parentScale);
            } else parentScale.copyFrom(parent.getAbsoluteMatrix());
            parentScaleInv.copyFrom(parentScale);
            parentScaleInv.invert();
            lmat.multiplyToRef(parentScale, lmat);
            lmat.multiplyToRef(rmat, lmat);
            lmat.multiplyToRef(parentScaleInv, lmat);
        } else if (space == (0, $dbxbu.Space).WORLD && tNode) {
            parentScale.copyFrom(tNode.getWorldMatrix());
            parentScaleInv.copyFrom(parentScale);
            parentScaleInv.invert();
            lmat.multiplyToRef(parentScale, lmat);
            lmat.multiplyToRef(rmat, lmat);
            lmat.multiplyToRef(parentScaleInv, lmat);
        } else lmat.multiplyToRef(rmat, lmat);
        lmat.setTranslationFromFloats(lx, ly, lz);
        this.computeAbsoluteMatrices();
        this._markAsDirtyAndDecompose();
    }
    _getAbsoluteInverseMatrixUnscaledToRef(rotMatInv, tNode) {
        const scaleMatrix = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[2];
        rotMatInv.copyFrom(this.getAbsoluteMatrix());
        if (tNode) {
            rotMatInv.multiplyToRef(tNode.getWorldMatrix(), rotMatInv);
            (0, $ha1VO.Matrix).ScalingToRef(tNode.scaling.x, tNode.scaling.y, tNode.scaling.z, scaleMatrix);
        } else (0, $ha1VO.Matrix).IdentityToRef(scaleMatrix);
        rotMatInv.invert();
        if (isNaN(rotMatInv.m[0])) // Matrix failed to invert.
        // This can happen if scale is zero for example.
        return false;
        scaleMatrix.multiplyAtIndex(0, this._scalingDeterminant);
        rotMatInv.multiplyToRef(scaleMatrix, rotMatInv);
        return true;
    }
    /**
     * Get the position of the bone in local or world space
     * @param space The space that the returned position is in
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     * @returns The position of the bone
     */ getPosition(space = (0, $dbxbu.Space).LOCAL, tNode = null) {
        const pos = (0, $ha1VO.Vector3).Zero();
        this.getPositionToRef(space, tNode, pos);
        return pos;
    }
    /**
     * Copy the position of the bone to a vector3 in local or world space
     * @param space The space that the returned position is in
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     * @param result The vector3 to copy the position to
     */ getPositionToRef(space = (0, $dbxbu.Space).LOCAL, tNode, result) {
        if (space == (0, $dbxbu.Space).LOCAL) {
            const lm = this.getLocalMatrix();
            result.x = lm.m[12];
            result.y = lm.m[13];
            result.z = lm.m[14];
        } else {
            let wm = null;
            //tNode.getWorldMatrix() needs to be called before skeleton.computeAbsoluteMatrices()
            if (tNode) wm = tNode.getWorldMatrix();
            this._skeleton.computeAbsoluteMatrices();
            let tmat = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[0];
            if (tNode && wm) {
                tmat.copyFrom(this.getAbsoluteMatrix());
                tmat.multiplyToRef(wm, tmat);
            } else tmat = this.getAbsoluteMatrix();
            result.x = tmat.m[12];
            result.y = tmat.m[13];
            result.z = tmat.m[14];
        }
    }
    /**
     * Get the absolute position of the bone (world space)
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     * @returns The absolute position of the bone
     */ getAbsolutePosition(tNode = null) {
        const pos = (0, $ha1VO.Vector3).Zero();
        this.getPositionToRef((0, $dbxbu.Space).WORLD, tNode, pos);
        return pos;
    }
    /**
     * Copy the absolute position of the bone (world space) to the result param
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     * @param result The vector3 to copy the absolute position to
     */ getAbsolutePositionToRef(tNode, result) {
        this.getPositionToRef((0, $dbxbu.Space).WORLD, tNode, result);
    }
    /**
     * Compute the absolute matrices of this bone and its children
     */ computeAbsoluteMatrices() {
        this._compose();
        if (this.parent) this._localMatrix.multiplyToRef(this.parent._absoluteMatrix, this._absoluteMatrix);
        else {
            this._absoluteMatrix.copyFrom(this._localMatrix);
            const poseMatrix = this._skeleton.getPoseMatrix();
            if (poseMatrix) this._absoluteMatrix.multiplyToRef(poseMatrix, this._absoluteMatrix);
        }
        const children = this.children;
        const len = children.length;
        for(let i = 0; i < len; i++)children[i].computeAbsoluteMatrices();
    }
    /**
     * Compute the absolute matrices of this bone and its children
     * @deprecated Please use computeAbsoluteMatrices instead
     */ computeAbsoluteTransforms() {
        this.computeAbsoluteMatrices();
    }
    /**
     * Get the world direction from an axis that is in the local space of the bone
     * @param localAxis The local direction that is used to compute the world direction
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     * @returns The world direction
     */ getDirection(localAxis, tNode = null) {
        const result = (0, $ha1VO.Vector3).Zero();
        this.getDirectionToRef(localAxis, tNode, result);
        return result;
    }
    /**
     * Copy the world direction to a vector3 from an axis that is in the local space of the bone
     * @param localAxis The local direction that is used to compute the world direction
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     * @param result The vector3 that the world direction will be copied to
     */ getDirectionToRef(localAxis, tNode = null, result) {
        let wm = null;
        //tNode.getWorldMatrix() needs to be called before skeleton.computeAbsoluteMatrices()
        if (tNode) wm = tNode.getWorldMatrix();
        this._skeleton.computeAbsoluteMatrices();
        const mat = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[0];
        mat.copyFrom(this.getAbsoluteMatrix());
        if (tNode && wm) mat.multiplyToRef(wm, mat);
        (0, $ha1VO.Vector3).TransformNormalToRef(localAxis, mat, result);
        result.normalize();
    }
    /**
     * Get the euler rotation of the bone in local or world space
     * @param space The space that the rotation should be in
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     * @returns The euler rotation
     */ getRotation(space = (0, $dbxbu.Space).LOCAL, tNode = null) {
        const result = (0, $ha1VO.Vector3).Zero();
        this.getRotationToRef(space, tNode, result);
        return result;
    }
    /**
     * Copy the euler rotation of the bone to a vector3.  The rotation can be in either local or world space
     * @param space The space that the rotation should be in
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     * @param result The vector3 that the rotation should be copied to
     */ getRotationToRef(space = (0, $dbxbu.Space).LOCAL, tNode = null, result) {
        const quat = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpQuat;
        this.getRotationQuaternionToRef(space, tNode, quat);
        quat.toEulerAnglesToRef(result);
    }
    /**
     * Get the quaternion rotation of the bone in either local or world space
     * @param space The space that the rotation should be in
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     * @returns The quaternion rotation
     */ getRotationQuaternion(space = (0, $dbxbu.Space).LOCAL, tNode = null) {
        const result = (0, $ha1VO.Quaternion).Identity();
        this.getRotationQuaternionToRef(space, tNode, result);
        return result;
    }
    /**
     * Copy the quaternion rotation of the bone to a quaternion.  The rotation can be in either local or world space
     * @param space The space that the rotation should be in
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     * @param result The quaternion that the rotation should be copied to
     */ getRotationQuaternionToRef(space = (0, $dbxbu.Space).LOCAL, tNode = null, result) {
        if (space == (0, $dbxbu.Space).LOCAL) {
            this._decompose();
            result.copyFrom(this._localRotation);
        } else {
            const mat = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[0];
            const amat = this.getAbsoluteMatrix();
            if (tNode) amat.multiplyToRef(tNode.getWorldMatrix(), mat);
            else mat.copyFrom(amat);
            mat.multiplyAtIndex(0, this._scalingDeterminant);
            mat.multiplyAtIndex(1, this._scalingDeterminant);
            mat.multiplyAtIndex(2, this._scalingDeterminant);
            mat.decompose(undefined, result, undefined);
        }
    }
    /**
     * Get the rotation matrix of the bone in local or world space
     * @param space The space that the rotation should be in
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     * @returns The rotation matrix
     */ getRotationMatrix(space = (0, $dbxbu.Space).LOCAL, tNode) {
        const result = (0, $ha1VO.Matrix).Identity();
        this.getRotationMatrixToRef(space, tNode, result);
        return result;
    }
    /**
     * Copy the rotation matrix of the bone to a matrix.  The rotation can be in either local or world space
     * @param space The space that the rotation should be in
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     * @param result The quaternion that the rotation should be copied to
     */ getRotationMatrixToRef(space = (0, $dbxbu.Space).LOCAL, tNode, result) {
        if (space == (0, $dbxbu.Space).LOCAL) this.getLocalMatrix().getRotationMatrixToRef(result);
        else {
            const mat = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[0];
            const amat = this.getAbsoluteMatrix();
            if (tNode) amat.multiplyToRef(tNode.getWorldMatrix(), mat);
            else mat.copyFrom(amat);
            mat.multiplyAtIndex(0, this._scalingDeterminant);
            mat.multiplyAtIndex(1, this._scalingDeterminant);
            mat.multiplyAtIndex(2, this._scalingDeterminant);
            mat.getRotationMatrixToRef(result);
        }
    }
    /**
     * Get the world position of a point that is in the local space of the bone
     * @param position The local position
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     * @returns The world position
     */ getAbsolutePositionFromLocal(position, tNode = null) {
        const result = (0, $ha1VO.Vector3).Zero();
        this.getAbsolutePositionFromLocalToRef(position, tNode, result);
        return result;
    }
    /**
     * Get the world position of a point that is in the local space of the bone and copy it to the result param
     * @param position The local position
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     * @param result The vector3 that the world position should be copied to
     */ getAbsolutePositionFromLocalToRef(position, tNode = null, result) {
        let wm = null;
        //tNode.getWorldMatrix() needs to be called before skeleton.computeAbsoluteMatrices()
        if (tNode) wm = tNode.getWorldMatrix();
        this._skeleton.computeAbsoluteMatrices();
        const tmat = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[0];
        tmat.copyFrom(this.getAbsoluteMatrix());
        if (tNode && wm) tmat.multiplyToRef(wm, tmat);
        (0, $ha1VO.Vector3).TransformCoordinatesToRef(position, tmat, result);
    }
    /**
     * Get the local position of a point that is in world space
     * @param position The world position
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     * @returns The local position
     */ getLocalPositionFromAbsolute(position, tNode = null) {
        const result = (0, $ha1VO.Vector3).Zero();
        this.getLocalPositionFromAbsoluteToRef(position, tNode, result);
        return result;
    }
    /**
     * Get the local position of a point that is in world space and copy it to the result param
     * @param position The world position
     * @param tNode A TransformNode whose world matrix is to be applied to the calculated absolute matrix. In most cases, you'll want to pass the mesh associated with the skeleton from which this bone comes. Used only when space=Space.WORLD
     * @param result The vector3 that the local position should be copied to
     */ getLocalPositionFromAbsoluteToRef(position, tNode = null, result) {
        let wm = null;
        //tNode.getWorldMatrix() needs to be called before skeleton.computeAbsoluteMatrices()
        if (tNode) wm = tNode.getWorldMatrix();
        this._skeleton.computeAbsoluteMatrices();
        const tmat = $bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats[0];
        tmat.copyFrom(this.getAbsoluteMatrix());
        if (tNode && wm) tmat.multiplyToRef(wm, tmat);
        tmat.invert();
        (0, $ha1VO.Vector3).TransformCoordinatesToRef(position, tmat, result);
    }
    /**
     * Set the current local matrix as the restMatrix for this bone.
     */ setCurrentPoseAsRest() {
        this.setRestMatrix(this.getLocalMatrix());
    }
}
$bbab17c2ca6aeebf$export$b127726e56765aa4._TmpVecs = (0, $opFp4.ArrayTools).BuildArray(2, (0, $ha1VO.Vector3).Zero);
$bbab17c2ca6aeebf$export$b127726e56765aa4._TmpQuat = (0, $ha1VO.Quaternion).Identity();
$bbab17c2ca6aeebf$export$b127726e56765aa4._TmpMats = (0, $opFp4.ArrayTools).BuildArray(5, (0, $ha1VO.Matrix).Identity);

});
parcelRegister("dbxbu", function(module, exports) {

$parcel$export(module.exports, "Space", () => $99960b2795987ea2$export$eef1e68107c58ef2);
$parcel$export(module.exports, "Axis", () => $99960b2795987ea2$export$d06866a9fb0606da);
$parcel$export(module.exports, "Coordinate", () => $99960b2795987ea2$export$7faa80054108057);

var $ha1VO = parcelRequire("ha1VO");
var $99960b2795987ea2$export$eef1e68107c58ef2;
(function(Space) {
    /** Local (object) space */ Space[Space["LOCAL"] = 0] = "LOCAL";
    /** World space */ Space[Space["WORLD"] = 1] = "WORLD";
    /** Bone space */ Space[Space["BONE"] = 2] = "BONE";
})($99960b2795987ea2$export$eef1e68107c58ef2 || ($99960b2795987ea2$export$eef1e68107c58ef2 = {}));
class $99960b2795987ea2$export$d06866a9fb0606da {
}
/** X axis */ $99960b2795987ea2$export$d06866a9fb0606da.X = new (0, $ha1VO.Vector3)(1.0, 0.0, 0.0);
/** Y axis */ $99960b2795987ea2$export$d06866a9fb0606da.Y = new (0, $ha1VO.Vector3)(0.0, 1.0, 0.0);
/** Z axis */ $99960b2795987ea2$export$d06866a9fb0606da.Z = new (0, $ha1VO.Vector3)(0.0, 0.0, 1.0);
var $99960b2795987ea2$export$7faa80054108057;
(function(Coordinate) {
    /** X axis */ Coordinate[Coordinate["X"] = 0] = "X";
    /** Y axis */ Coordinate[Coordinate["Y"] = 1] = "Y";
    /** Z axis */ Coordinate[Coordinate["Z"] = 2] = "Z";
})($99960b2795987ea2$export$7faa80054108057 || ($99960b2795987ea2$export$7faa80054108057 = {}));

});



parcelRegister("c0Yfq", function(module, exports) {

$parcel$export(module.exports, "AnimationPropertiesOverride", () => $8bf43812305609f3$export$4e64b8292f118401);

var $lWogh = parcelRequire("lWogh");
class $8bf43812305609f3$export$4e64b8292f118401 {
    constructor(){
        /**
         * Gets or sets a value indicating if animation blending must be used
         */ this.enableBlending = false;
        /**
         * Gets or sets the blending speed to use when enableBlending is true
         */ this.blendingSpeed = 0.01;
        /**
         * Gets or sets the default loop mode to use
         */ this.loopMode = (0, $lWogh.Animation).ANIMATIONLOOPMODE_CYCLE;
    }
}

});

parcelRegister("01TD7", function(module, exports) {

$parcel$export(module.exports, "EasingFunction", () => $005b3f0c7a6c24da$export$2a0047e41c4245d1);
$parcel$export(module.exports, "CircleEase", () => $005b3f0c7a6c24da$export$682c243b9f175ba2);
$parcel$export(module.exports, "BackEase", () => $005b3f0c7a6c24da$export$1de0cb74a12790e5);
$parcel$export(module.exports, "BounceEase", () => $005b3f0c7a6c24da$export$f2f580055f47d939);
$parcel$export(module.exports, "CubicEase", () => $005b3f0c7a6c24da$export$b9f6da40882c34cc);
$parcel$export(module.exports, "ElasticEase", () => $005b3f0c7a6c24da$export$73d66f7d40f87bb4);
$parcel$export(module.exports, "ExponentialEase", () => $005b3f0c7a6c24da$export$796b0dbcc6df23ee);
$parcel$export(module.exports, "PowerEase", () => $005b3f0c7a6c24da$export$1e13f737331ff2e4);
$parcel$export(module.exports, "QuadraticEase", () => $005b3f0c7a6c24da$export$2a6c337c04bf5461);
$parcel$export(module.exports, "QuarticEase", () => $005b3f0c7a6c24da$export$92b6eb3430aedbbd);
$parcel$export(module.exports, "QuinticEase", () => $005b3f0c7a6c24da$export$2321f37863089117);
$parcel$export(module.exports, "SineEase", () => $005b3f0c7a6c24da$export$2e71abf7a3c7d863);
$parcel$export(module.exports, "BezierCurveEase", () => $005b3f0c7a6c24da$export$2d1c5f5e8681690c);

var $fm2C6 = parcelRequire("fm2C6");
class $005b3f0c7a6c24da$export$2a0047e41c4245d1 {
    constructor(){
        this._easingMode = $005b3f0c7a6c24da$export$2a0047e41c4245d1.EASINGMODE_EASEIN;
    }
    /**
     * Sets the easing mode of the current function.
     * @param easingMode Defines the willing mode (EASINGMODE_EASEIN, EASINGMODE_EASEOUT or EASINGMODE_EASEINOUT)
     */ setEasingMode(easingMode) {
        const n = Math.min(Math.max(easingMode, 0), 2);
        this._easingMode = n;
    }
    /**
     * Gets the current easing mode.
     * @returns the easing mode
     */ getEasingMode() {
        return this._easingMode;
    }
    /**
     * @internal
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    easeInCore(gradient) {
        throw new Error("You must implement this method");
    }
    /**
     * Given an input gradient between 0 and 1, this returns the corresponding value
     * of the easing function.
     * @param gradient Defines the value between 0 and 1 we want the easing value for
     * @returns the corresponding value on the curve defined by the easing function
     */ ease(gradient) {
        switch(this._easingMode){
            case $005b3f0c7a6c24da$export$2a0047e41c4245d1.EASINGMODE_EASEIN:
                return this.easeInCore(gradient);
            case $005b3f0c7a6c24da$export$2a0047e41c4245d1.EASINGMODE_EASEOUT:
                return 1 - this.easeInCore(1 - gradient);
        }
        if (gradient >= 0.5) return (1 - this.easeInCore((1 - gradient) * 2)) * 0.5 + 0.5;
        return this.easeInCore(gradient * 2) * 0.5;
    }
}
/**
 * Interpolation follows the mathematical formula associated with the easing function.
 */ $005b3f0c7a6c24da$export$2a0047e41c4245d1.EASINGMODE_EASEIN = 0;
/**
 * Interpolation follows 100% interpolation minus the output of the formula associated with the easing function.
 */ $005b3f0c7a6c24da$export$2a0047e41c4245d1.EASINGMODE_EASEOUT = 1;
/**
 * Interpolation uses EaseIn for the first half of the animation and EaseOut for the second half.
 */ $005b3f0c7a6c24da$export$2a0047e41c4245d1.EASINGMODE_EASEINOUT = 2;
class $005b3f0c7a6c24da$export$682c243b9f175ba2 extends $005b3f0c7a6c24da$export$2a0047e41c4245d1 {
    /**
     * @internal
     */ easeInCore(gradient) {
        gradient = Math.max(0, Math.min(1, gradient));
        return 1.0 - Math.sqrt(1.0 - gradient * gradient);
    }
}
class $005b3f0c7a6c24da$export$1de0cb74a12790e5 extends $005b3f0c7a6c24da$export$2a0047e41c4245d1 {
    /**
     * Instantiates a back ease easing
     * @see https://easings.net/#easeInBack
     * @param amplitude Defines the amplitude of the function
     */ constructor(/** Defines the amplitude of the function */ amplitude = 1){
        super();
        this.amplitude = amplitude;
    }
    /**
     * @internal
     */ easeInCore(gradient) {
        const num = Math.max(0, this.amplitude);
        return Math.pow(gradient, 3.0) - gradient * num * Math.sin(3.1415926535897931 * gradient);
    }
}
class $005b3f0c7a6c24da$export$f2f580055f47d939 extends $005b3f0c7a6c24da$export$2a0047e41c4245d1 {
    /**
     * Instantiates a bounce easing
     * @see https://easings.net/#easeInBounce
     * @param bounces Defines the number of bounces
     * @param bounciness Defines the amplitude of the bounce
     */ constructor(/** Defines the number of bounces */ bounces = 3, /** Defines the amplitude of the bounce */ bounciness = 2){
        super();
        this.bounces = bounces;
        this.bounciness = bounciness;
    }
    /**
     * @internal
     */ easeInCore(gradient) {
        const y = Math.max(0.0, this.bounces);
        let bounciness = this.bounciness;
        if (bounciness <= 1.0) bounciness = 1.001;
        const num9 = Math.pow(bounciness, y);
        const num5 = 1.0 - bounciness;
        const num4 = (1.0 - num9) / num5 + num9 * 0.5;
        const num15 = gradient * num4;
        const num65 = Math.log(-num15 * (1.0 - bounciness) + 1.0) / Math.log(bounciness);
        const num3 = Math.floor(num65);
        const num13 = num3 + 1.0;
        const num8 = (1.0 - Math.pow(bounciness, num3)) / (num5 * num4);
        const num12 = (1.0 - Math.pow(bounciness, num13)) / (num5 * num4);
        const num7 = (num8 + num12) * 0.5;
        const num6 = gradient - num7;
        const num2 = num7 - num8;
        return -Math.pow(1.0 / bounciness, y - num3) / (num2 * num2) * (num6 - num2) * (num6 + num2);
    }
}
class $005b3f0c7a6c24da$export$b9f6da40882c34cc extends $005b3f0c7a6c24da$export$2a0047e41c4245d1 {
    /**
     * @internal
     */ easeInCore(gradient) {
        return gradient * gradient * gradient;
    }
}
class $005b3f0c7a6c24da$export$73d66f7d40f87bb4 extends $005b3f0c7a6c24da$export$2a0047e41c4245d1 {
    /**
     * Instantiates an elastic easing function
     * @see https://easings.net/#easeInElastic
     * @param oscillations Defines the number of oscillations
     * @param springiness Defines the amplitude of the oscillations
     */ constructor(/** Defines the number of oscillations*/ oscillations = 3, /** Defines the amplitude of the oscillations*/ springiness = 3){
        super();
        this.oscillations = oscillations;
        this.springiness = springiness;
    }
    /**
     * @internal
     */ easeInCore(gradient) {
        let num2;
        const num3 = Math.max(0.0, this.oscillations);
        const num = Math.max(0.0, this.springiness);
        if (num == 0) num2 = gradient;
        else num2 = (Math.exp(num * gradient) - 1.0) / (Math.exp(num) - 1.0);
        return num2 * Math.sin((6.2831853071795862 * num3 + 1.5707963267948966) * gradient);
    }
}
class $005b3f0c7a6c24da$export$796b0dbcc6df23ee extends $005b3f0c7a6c24da$export$2a0047e41c4245d1 {
    /**
     * Instantiates an exponential easing function
     * @see https://easings.net/#easeInExpo
     * @param exponent Defines the exponent of the function
     */ constructor(/** Defines the exponent of the function */ exponent = 2){
        super();
        this.exponent = exponent;
    }
    /**
     * @internal
     */ easeInCore(gradient) {
        if (this.exponent <= 0) return gradient;
        return (Math.exp(this.exponent * gradient) - 1.0) / (Math.exp(this.exponent) - 1.0);
    }
}
class $005b3f0c7a6c24da$export$1e13f737331ff2e4 extends $005b3f0c7a6c24da$export$2a0047e41c4245d1 {
    /**
     * Instantiates an power base easing function
     * @see https://easings.net/#easeInQuad
     * @param power Defines the power of the function
     */ constructor(/** Defines the power of the function */ power = 2){
        super();
        this.power = power;
    }
    /**
     * @internal
     */ easeInCore(gradient) {
        const y = Math.max(0.0, this.power);
        return Math.pow(gradient, y);
    }
}
class $005b3f0c7a6c24da$export$2a6c337c04bf5461 extends $005b3f0c7a6c24da$export$2a0047e41c4245d1 {
    /**
     * @internal
     */ easeInCore(gradient) {
        return gradient * gradient;
    }
}
class $005b3f0c7a6c24da$export$92b6eb3430aedbbd extends $005b3f0c7a6c24da$export$2a0047e41c4245d1 {
    /**
     * @internal
     */ easeInCore(gradient) {
        return gradient * gradient * gradient * gradient;
    }
}
class $005b3f0c7a6c24da$export$2321f37863089117 extends $005b3f0c7a6c24da$export$2a0047e41c4245d1 {
    /**
     * @internal
     */ easeInCore(gradient) {
        return gradient * gradient * gradient * gradient * gradient;
    }
}
class $005b3f0c7a6c24da$export$2e71abf7a3c7d863 extends $005b3f0c7a6c24da$export$2a0047e41c4245d1 {
    /**
     * @internal
     */ easeInCore(gradient) {
        return 1.0 - Math.sin(1.5707963267948966 * (1.0 - gradient));
    }
}
class $005b3f0c7a6c24da$export$2d1c5f5e8681690c extends $005b3f0c7a6c24da$export$2a0047e41c4245d1 {
    /**
     * Instantiates a bezier function
     * @see http://cubic-bezier.com/#.17,.67,.83,.67
     * @param x1 Defines the x component of the start tangent in the bezier curve
     * @param y1 Defines the y component of the start tangent in the bezier curve
     * @param x2 Defines the x component of the end tangent in the bezier curve
     * @param y2 Defines the y component of the end tangent in the bezier curve
     */ constructor(/** Defines the x component of the start tangent in the bezier curve */ x1 = 0, /** Defines the y component of the start tangent in the bezier curve */ y1 = 0, /** Defines the x component of the end tangent in the bezier curve */ x2 = 1, /** Defines the y component of the end tangent in the bezier curve */ y2 = 1){
        super();
        this.x1 = x1;
        this.y1 = y1;
        this.x2 = x2;
        this.y2 = y2;
    }
    /**
     * @internal
     */ easeInCore(gradient) {
        return (0, $fm2C6.BezierCurve).Interpolate(gradient, this.x1, this.y1, this.x2, this.y2);
    }
}

});
parcelRegister("fm2C6", function(module, exports) {

$parcel$export(module.exports, "Orientation", () => $b2daf017bbb96e17$export$df54d73aa0ec5e82);
$parcel$export(module.exports, "BezierCurve", () => $b2daf017bbb96e17$export$a57c23a30525a34b);
$parcel$export(module.exports, "Angle", () => $b2daf017bbb96e17$export$6cdc1cb9345ffadf);
$parcel$export(module.exports, "Arc2", () => $b2daf017bbb96e17$export$4372ba0b01fe9b6d);
$parcel$export(module.exports, "Path2", () => $b2daf017bbb96e17$export$134926acf342e25);
$parcel$export(module.exports, "Path3D", () => $b2daf017bbb96e17$export$5d6a5d8dc9b2f01b);
$parcel$export(module.exports, "Curve3", () => $b2daf017bbb96e17$export$82bb9f10f9631442);

var $1VEEL = parcelRequire("1VEEL");

var $ha1VO = parcelRequire("ha1VO");

var $53VPf = parcelRequire("53VPf");
var $b2daf017bbb96e17$export$df54d73aa0ec5e82;
(function(Orientation) {
    /**
     * Clockwise
     */ Orientation[Orientation["CW"] = 0] = "CW";
    /** Counter clockwise */ Orientation[Orientation["CCW"] = 1] = "CCW";
})($b2daf017bbb96e17$export$df54d73aa0ec5e82 || ($b2daf017bbb96e17$export$df54d73aa0ec5e82 = {}));
class $b2daf017bbb96e17$export$a57c23a30525a34b {
    /**
     * Returns the cubic Bezier interpolated value (float) at "t" (float) from the given x1, y1, x2, y2 floats
     * @param t defines the time
     * @param x1 defines the left coordinate on X axis
     * @param y1 defines the left coordinate on Y axis
     * @param x2 defines the right coordinate on X axis
     * @param y2 defines the right coordinate on Y axis
     * @returns the interpolated value
     */ static Interpolate(t, x1, y1, x2, y2) {
        // Extract X (which is equal to time here)
        const f0 = 1 - 3 * x2 + 3 * x1;
        const f1 = 3 * x2 - 6 * x1;
        const f2 = 3 * x1;
        let refinedT = t;
        for(let i = 0; i < 5; i++){
            const refinedT2 = refinedT * refinedT;
            const refinedT3 = refinedT2 * refinedT;
            const x = f0 * refinedT3 + f1 * refinedT2 + f2 * refinedT;
            const slope = 1.0 / (3.0 * f0 * refinedT2 + 2.0 * f1 * refinedT + f2);
            refinedT -= (x - t) * slope;
            refinedT = Math.min(1, Math.max(0, refinedT));
        }
        // Resolve cubic bezier for the given x
        return 3 * Math.pow(1 - refinedT, 2) * refinedT * y1 + 3 * (1 - refinedT) * Math.pow(refinedT, 2) * y2 + Math.pow(refinedT, 3);
    }
}
class $b2daf017bbb96e17$export$6cdc1cb9345ffadf {
    /**
     * Creates an Angle object of "radians" radians (float).
     * @param radians the angle in radians
     */ constructor(radians){
        this._radians = radians;
        if (this._radians < 0.0) this._radians += 2.0 * Math.PI;
    }
    /**
     * Get value in degrees
     * @returns the Angle value in degrees (float)
     */ degrees() {
        return this._radians * 180.0 / Math.PI;
    }
    /**
     * Get value in radians
     * @returns the Angle value in radians (float)
     */ radians() {
        return this._radians;
    }
    /**
     * Gets a new Angle object with a value of the angle (in radians) between the line connecting the two points and the x-axis
     * @param a defines first point as the origin
     * @param b defines point
     * @returns a new Angle
     */ static BetweenTwoPoints(a, b) {
        const delta = b.subtract(a);
        const theta = Math.atan2(delta.y, delta.x);
        return new $b2daf017bbb96e17$export$6cdc1cb9345ffadf(theta);
    }
    /**
     * Gets the angle between the two vectors
     * @param a defines first vector
     * @param b defines vector
     * @returns Returns an new Angle between 0 and PI
     */ static BetweenTwoVectors(a, b) {
        let product = a.lengthSquared() * b.lengthSquared();
        if (product === 0) return new $b2daf017bbb96e17$export$6cdc1cb9345ffadf(Math.PI / 2);
        product = Math.sqrt(product);
        let cosVal = a.dot(b) / product;
        cosVal = (0, $1VEEL.Scalar).Clamp(cosVal, -1, 1);
        const angle = Math.acos(cosVal);
        return new $b2daf017bbb96e17$export$6cdc1cb9345ffadf(angle);
    }
    /**
     * Gets a new Angle object from the given float in radians
     * @param radians defines the angle value in radians
     * @returns a new Angle
     */ static FromRadians(radians) {
        return new $b2daf017bbb96e17$export$6cdc1cb9345ffadf(radians);
    }
    /**
     * Gets a new Angle object from the given float in degrees
     * @param degrees defines the angle value in degrees
     * @returns a new Angle
     */ static FromDegrees(degrees) {
        return new $b2daf017bbb96e17$export$6cdc1cb9345ffadf(degrees * Math.PI / 180.0);
    }
}
class $b2daf017bbb96e17$export$4372ba0b01fe9b6d {
    /**
     * Creates an Arc object from the three given points : start, middle and end.
     * @param startPoint Defines the start point of the arc
     * @param midPoint Defines the middle point of the arc
     * @param endPoint Defines the end point of the arc
     */ constructor(/** Defines the start point of the arc */ startPoint, /** Defines the mid point of the arc */ midPoint, /** Defines the end point of the arc */ endPoint){
        this.startPoint = startPoint;
        this.midPoint = midPoint;
        this.endPoint = endPoint;
        const temp = Math.pow(midPoint.x, 2) + Math.pow(midPoint.y, 2);
        const startToMid = (Math.pow(startPoint.x, 2) + Math.pow(startPoint.y, 2) - temp) / 2;
        const midToEnd = (temp - Math.pow(endPoint.x, 2) - Math.pow(endPoint.y, 2)) / 2;
        const det = (startPoint.x - midPoint.x) * (midPoint.y - endPoint.y) - (midPoint.x - endPoint.x) * (startPoint.y - midPoint.y);
        this.centerPoint = new (0, $ha1VO.Vector2)((startToMid * (midPoint.y - endPoint.y) - midToEnd * (startPoint.y - midPoint.y)) / det, ((startPoint.x - midPoint.x) * midToEnd - (midPoint.x - endPoint.x) * startToMid) / det);
        this.radius = this.centerPoint.subtract(this.startPoint).length();
        this.startAngle = $b2daf017bbb96e17$export$6cdc1cb9345ffadf.BetweenTwoPoints(this.centerPoint, this.startPoint);
        const a1 = this.startAngle.degrees();
        let a2 = $b2daf017bbb96e17$export$6cdc1cb9345ffadf.BetweenTwoPoints(this.centerPoint, this.midPoint).degrees();
        let a3 = $b2daf017bbb96e17$export$6cdc1cb9345ffadf.BetweenTwoPoints(this.centerPoint, this.endPoint).degrees();
        // angles correction
        if (a2 - a1 > 180) a2 -= 360.0;
        if (a2 - a1 < -180) a2 += 360.0;
        if (a3 - a2 > 180) a3 -= 360.0;
        if (a3 - a2 < -180) a3 += 360.0;
        this.orientation = a2 - a1 < 0 ? $b2daf017bbb96e17$export$df54d73aa0ec5e82.CW : $b2daf017bbb96e17$export$df54d73aa0ec5e82.CCW;
        this.angle = $b2daf017bbb96e17$export$6cdc1cb9345ffadf.FromDegrees(this.orientation === $b2daf017bbb96e17$export$df54d73aa0ec5e82.CW ? a1 - a3 : a3 - a1);
    }
}
class $b2daf017bbb96e17$export$134926acf342e25 {
    /**
     * Creates a Path2 object from the starting 2D coordinates x and y.
     * @param x the starting points x value
     * @param y the starting points y value
     */ constructor(x, y){
        this._points = new Array();
        this._length = 0.0;
        /**
         * If the path start and end point are the same
         */ this.closed = false;
        this._points.push(new (0, $ha1VO.Vector2)(x, y));
    }
    /**
     * Adds a new segment until the given coordinates (x, y) to the current Path2.
     * @param x the added points x value
     * @param y the added points y value
     * @returns the updated Path2.
     */ addLineTo(x, y) {
        if (this.closed) return this;
        const newPoint = new (0, $ha1VO.Vector2)(x, y);
        const previousPoint = this._points[this._points.length - 1];
        this._points.push(newPoint);
        this._length += newPoint.subtract(previousPoint).length();
        return this;
    }
    /**
     * Adds _numberOfSegments_ segments according to the arc definition (middle point coordinates, end point coordinates, the arc start point being the current Path2 last point) to the current Path2.
     * @param midX middle point x value
     * @param midY middle point y value
     * @param endX end point x value
     * @param endY end point y value
     * @param numberOfSegments (default: 36)
     * @returns the updated Path2.
     */ addArcTo(midX, midY, endX, endY, numberOfSegments = 36) {
        if (this.closed) return this;
        const startPoint = this._points[this._points.length - 1];
        const midPoint = new (0, $ha1VO.Vector2)(midX, midY);
        const endPoint = new (0, $ha1VO.Vector2)(endX, endY);
        const arc = new $b2daf017bbb96e17$export$4372ba0b01fe9b6d(startPoint, midPoint, endPoint);
        let increment = arc.angle.radians() / numberOfSegments;
        if (arc.orientation === $b2daf017bbb96e17$export$df54d73aa0ec5e82.CW) increment *= -1;
        let currentAngle = arc.startAngle.radians() + increment;
        for(let i = 0; i < numberOfSegments; i++){
            const x = Math.cos(currentAngle) * arc.radius + arc.centerPoint.x;
            const y = Math.sin(currentAngle) * arc.radius + arc.centerPoint.y;
            this.addLineTo(x, y);
            currentAngle += increment;
        }
        return this;
    }
    /**
     * Adds _numberOfSegments_ segments according to the quadratic curve definition to the current Path2.
     * @param controlX control point x value
     * @param controlY control point y value
     * @param endX end point x value
     * @param endY end point y value
     * @param numberOfSegments (default: 36)
     * @returns the updated Path2.
     */ addQuadraticCurveTo(controlX, controlY, endX, endY, numberOfSegments = 36) {
        if (this.closed) return this;
        const equation = (t, val0, val1, val2)=>{
            const res = (1.0 - t) * (1.0 - t) * val0 + 2.0 * t * (1.0 - t) * val1 + t * t * val2;
            return res;
        };
        const startPoint = this._points[this._points.length - 1];
        for(let i = 0; i <= numberOfSegments; i++){
            const step = i / numberOfSegments;
            const x = equation(step, startPoint.x, controlX, endX);
            const y = equation(step, startPoint.y, controlY, endY);
            this.addLineTo(x, y);
        }
        return this;
    }
    /**
     * Adds _numberOfSegments_ segments according to the bezier curve definition to the current Path2.
     * @param originTangentX tangent vector at the origin point x value
     * @param originTangentY tangent vector at the origin point y value
     * @param destinationTangentX tangent vector at the destination point x value
     * @param destinationTangentY tangent vector at the destination point y value
     * @param endX end point x value
     * @param endY end point y value
     * @param numberOfSegments (default: 36)
     * @returns the updated Path2.
     */ addBezierCurveTo(originTangentX, originTangentY, destinationTangentX, destinationTangentY, endX, endY, numberOfSegments = 36) {
        if (this.closed) return this;
        const equation = (t, val0, val1, val2, val3)=>{
            const res = (1.0 - t) * (1.0 - t) * (1.0 - t) * val0 + 3.0 * t * (1.0 - t) * (1.0 - t) * val1 + 3.0 * t * t * (1.0 - t) * val2 + t * t * t * val3;
            return res;
        };
        const startPoint = this._points[this._points.length - 1];
        for(let i = 0; i <= numberOfSegments; i++){
            const step = i / numberOfSegments;
            const x = equation(step, startPoint.x, originTangentX, destinationTangentX, endX);
            const y = equation(step, startPoint.y, originTangentY, destinationTangentY, endY);
            this.addLineTo(x, y);
        }
        return this;
    }
    /**
     * Defines if a given point is inside the polygon defines by the path
     * @param point defines the point to test
     * @returns true if the point is inside
     */ isPointInside(point) {
        let isInside = false;
        const count = this._points.length;
        for(let p = count - 1, q = 0; q < count; p = q++){
            let edgeLow = this._points[p];
            let edgeHigh = this._points[q];
            let edgeDx = edgeHigh.x - edgeLow.x;
            let edgeDy = edgeHigh.y - edgeLow.y;
            if (Math.abs(edgeDy) > Number.EPSILON) {
                // Not parallel
                if (edgeDy < 0) {
                    edgeLow = this._points[q];
                    edgeDx = -edgeDx;
                    edgeHigh = this._points[p];
                    edgeDy = -edgeDy;
                }
                if (point.y < edgeLow.y || point.y > edgeHigh.y) continue;
                if (point.y === edgeLow.y && point.x === edgeLow.x) return true;
                else {
                    const perpEdge = edgeDy * (point.x - edgeLow.x) - edgeDx * (point.y - edgeLow.y);
                    if (perpEdge === 0) return true;
                    if (perpEdge < 0) continue;
                    isInside = !isInside;
                }
            } else {
                // parallel or collinear
                if (point.y !== edgeLow.y) continue;
                if (edgeHigh.x <= point.x && point.x <= edgeLow.x || edgeLow.x <= point.x && point.x <= edgeHigh.x) return true;
            }
        }
        return isInside;
    }
    /**
     * Closes the Path2.
     * @returns the Path2.
     */ close() {
        this.closed = true;
        return this;
    }
    /**
     * Gets the sum of the distance between each sequential point in the path
     * @returns the Path2 total length (float).
     */ length() {
        let result = this._length;
        if (this.closed) {
            const lastPoint = this._points[this._points.length - 1];
            const firstPoint = this._points[0];
            result += firstPoint.subtract(lastPoint).length();
        }
        return result;
    }
    /**
     * Gets the area of the polygon defined by the path
     * @returns area value
     */ area() {
        const n = this._points.length;
        let value = 0.0;
        for(let p = n - 1, q = 0; q < n; p = q++)value += this._points[p].x * this._points[q].y - this._points[q].x * this._points[p].y;
        return value * 0.5;
    }
    /**
     * Gets the points which construct the path
     * @returns the Path2 internal array of points.
     */ getPoints() {
        return this._points;
    }
    /**
     * Retrieves the point at the distance aways from the starting point
     * @param normalizedLengthPosition the length along the path to retrieve the point from
     * @returns a new Vector2 located at a percentage of the Path2 total length on this path.
     */ getPointAtLengthPosition(normalizedLengthPosition) {
        if (normalizedLengthPosition < 0 || normalizedLengthPosition > 1) return (0, $ha1VO.Vector2).Zero();
        const lengthPosition = normalizedLengthPosition * this.length();
        let previousOffset = 0;
        for(let i = 0; i < this._points.length; i++){
            const j = (i + 1) % this._points.length;
            const a = this._points[i];
            const b = this._points[j];
            const bToA = b.subtract(a);
            const nextOffset = bToA.length() + previousOffset;
            if (lengthPosition >= previousOffset && lengthPosition <= nextOffset) {
                const dir = bToA.normalize();
                const localOffset = lengthPosition - previousOffset;
                return new (0, $ha1VO.Vector2)(a.x + dir.x * localOffset, a.y + dir.y * localOffset);
            }
            previousOffset = nextOffset;
        }
        return (0, $ha1VO.Vector2).Zero();
    }
    /**
     * Creates a new path starting from an x and y position
     * @param x starting x value
     * @param y starting y value
     * @returns a new Path2 starting at the coordinates (x, y).
     */ static StartingAt(x, y) {
        return new $b2daf017bbb96e17$export$134926acf342e25(x, y);
    }
}
class $b2daf017bbb96e17$export$5d6a5d8dc9b2f01b {
    /**
     * new Path3D(path, normal, raw)
     * Creates a Path3D. A Path3D is a logical math object, so not a mesh.
     * please read the description in the tutorial : https://doc.babylonjs.com/features/featuresDeepDive/mesh/path3D
     * @param path an array of Vector3, the curve axis of the Path3D
     * @param firstNormal (options) Vector3, the first wanted normal to the curve. Ex (0, 1, 0) for a vertical normal.
     * @param raw (optional, default false) : boolean, if true the returned Path3D isn't normalized. Useful to depict path acceleration or speed.
     * @param alignTangentsWithPath (optional, default false) : boolean, if true the tangents will be aligned with the path.
     */ constructor(/**
     * an array of Vector3, the curve axis of the Path3D
     */ path, firstNormal = null, raw, alignTangentsWithPath = false){
        this.path = path;
        this._curve = new Array();
        this._distances = new Array();
        this._tangents = new Array();
        this._normals = new Array();
        this._binormals = new Array();
        // holds interpolated point data
        this._pointAtData = {
            id: 0,
            point: (0, $ha1VO.Vector3).Zero(),
            previousPointArrayIndex: 0,
            position: 0,
            subPosition: 0,
            interpolateReady: false,
            interpolationMatrix: (0, $ha1VO.Matrix).Identity()
        };
        for(let p = 0; p < path.length; p++)this._curve[p] = path[p].clone(); // hard copy
        this._raw = raw || false;
        this._alignTangentsWithPath = alignTangentsWithPath;
        this._compute(firstNormal, alignTangentsWithPath);
    }
    /**
     * Returns the Path3D array of successive Vector3 designing its curve.
     * @returns the Path3D array of successive Vector3 designing its curve.
     */ getCurve() {
        return this._curve;
    }
    /**
     * Returns the Path3D array of successive Vector3 designing its curve.
     * @returns the Path3D array of successive Vector3 designing its curve.
     */ getPoints() {
        return this._curve;
    }
    /**
     * @returns the computed length (float) of the path.
     */ length() {
        return this._distances[this._distances.length - 1];
    }
    /**
     * Returns an array populated with tangent vectors on each Path3D curve point.
     * @returns an array populated with tangent vectors on each Path3D curve point.
     */ getTangents() {
        return this._tangents;
    }
    /**
     * Returns an array populated with normal vectors on each Path3D curve point.
     * @returns an array populated with normal vectors on each Path3D curve point.
     */ getNormals() {
        return this._normals;
    }
    /**
     * Returns an array populated with binormal vectors on each Path3D curve point.
     * @returns an array populated with binormal vectors on each Path3D curve point.
     */ getBinormals() {
        return this._binormals;
    }
    /**
     * Returns an array populated with distances (float) of the i-th point from the first curve point.
     * @returns an array populated with distances (float) of the i-th point from the first curve point.
     */ getDistances() {
        return this._distances;
    }
    /**
     * Returns an interpolated point along this path
     * @param position the position of the point along this path, from 0.0 to 1.0
     * @returns a new Vector3 as the point
     */ getPointAt(position) {
        return this._updatePointAtData(position).point;
    }
    /**
     * Returns the tangent vector of an interpolated Path3D curve point at the specified position along this path.
     * @param position the position of the point along this path, from 0.0 to 1.0
     * @param interpolated (optional, default false) : boolean, if true returns an interpolated tangent instead of the tangent of the previous path point.
     * @returns a tangent vector corresponding to the interpolated Path3D curve point, if not interpolated, the tangent is taken from the precomputed tangents array.
     */ getTangentAt(position, interpolated = false) {
        this._updatePointAtData(position, interpolated);
        return interpolated ? (0, $ha1VO.Vector3).TransformCoordinates((0, $ha1VO.Vector3).Forward(), this._pointAtData.interpolationMatrix) : this._tangents[this._pointAtData.previousPointArrayIndex];
    }
    /**
     * Returns the tangent vector of an interpolated Path3D curve point at the specified position along this path.
     * @param position the position of the point along this path, from 0.0 to 1.0
     * @param interpolated (optional, default false) : boolean, if true returns an interpolated normal instead of the normal of the previous path point.
     * @returns a normal vector corresponding to the interpolated Path3D curve point, if not interpolated, the normal is taken from the precomputed normals array.
     */ getNormalAt(position, interpolated = false) {
        this._updatePointAtData(position, interpolated);
        return interpolated ? (0, $ha1VO.Vector3).TransformCoordinates((0, $ha1VO.Vector3).Right(), this._pointAtData.interpolationMatrix) : this._normals[this._pointAtData.previousPointArrayIndex];
    }
    /**
     * Returns the binormal vector of an interpolated Path3D curve point at the specified position along this path.
     * @param position the position of the point along this path, from 0.0 to 1.0
     * @param interpolated (optional, default false) : boolean, if true returns an interpolated binormal instead of the binormal of the previous path point.
     * @returns a binormal vector corresponding to the interpolated Path3D curve point, if not interpolated, the binormal is taken from the precomputed binormals array.
     */ getBinormalAt(position, interpolated = false) {
        this._updatePointAtData(position, interpolated);
        return interpolated ? (0, $ha1VO.Vector3).TransformCoordinates((0, $ha1VO.Vector3).UpReadOnly, this._pointAtData.interpolationMatrix) : this._binormals[this._pointAtData.previousPointArrayIndex];
    }
    /**
     * Returns the distance (float) of an interpolated Path3D curve point at the specified position along this path.
     * @param position the position of the point along this path, from 0.0 to 1.0
     * @returns the distance of the interpolated Path3D curve point at the specified position along this path.
     */ getDistanceAt(position) {
        return this.length() * position;
    }
    /**
     * Returns the array index of the previous point of an interpolated point along this path
     * @param position the position of the point to interpolate along this path, from 0.0 to 1.0
     * @returns the array index
     */ getPreviousPointIndexAt(position) {
        this._updatePointAtData(position);
        return this._pointAtData.previousPointArrayIndex;
    }
    /**
     * Returns the position of an interpolated point relative to the two path points it lies between, from 0.0 (point A) to 1.0 (point B)
     * @param position the position of the point to interpolate along this path, from 0.0 to 1.0
     * @returns the sub position
     */ getSubPositionAt(position) {
        this._updatePointAtData(position);
        return this._pointAtData.subPosition;
    }
    /**
     * Returns the position of the closest virtual point on this path to an arbitrary Vector3, from 0.0 to 1.0
     * @param target the vector of which to get the closest position to
     * @returns the position of the closest virtual point on this path to the target vector
     */ getClosestPositionTo(target) {
        let smallestDistance = Number.MAX_VALUE;
        let closestPosition = 0.0;
        for(let i = 0; i < this._curve.length - 1; i++){
            const point = this._curve[i + 0];
            const tangent = this._curve[i + 1].subtract(point).normalize();
            const subLength = this._distances[i + 1] - this._distances[i + 0];
            const subPosition = Math.min(Math.max((0, $ha1VO.Vector3).Dot(tangent, target.subtract(point).normalize()), 0.0) * (0, $ha1VO.Vector3).Distance(point, target) / subLength, 1.0);
            const distance = (0, $ha1VO.Vector3).Distance(point.add(tangent.scale(subPosition * subLength)), target);
            if (distance < smallestDistance) {
                smallestDistance = distance;
                closestPosition = (this._distances[i + 0] + subLength * subPosition) / this.length();
            }
        }
        return closestPosition;
    }
    /**
     * Returns a sub path (slice) of this path
     * @param start the position of the fist path point, from 0.0 to 1.0, or a negative value, which will get wrapped around from the end of the path to 0.0 to 1.0 values
     * @param end the position of the last path point, from 0.0 to 1.0, or a negative value, which will get wrapped around from the end of the path to 0.0 to 1.0 values
     * @returns a sub path (slice) of this path
     */ slice(start = 0.0, end = 1.0) {
        if (start < 0.0) start = 1 - start * -1 % 1.0;
        if (end < 0.0) end = 1 - end * -1 % 1.0;
        if (start > end) {
            const _start = start;
            start = end;
            end = _start;
        }
        const curvePoints = this.getCurve();
        const startPoint = this.getPointAt(start);
        let startIndex = this.getPreviousPointIndexAt(start);
        const endPoint = this.getPointAt(end);
        const endIndex = this.getPreviousPointIndexAt(end) + 1;
        const slicePoints = [];
        if (start !== 0.0) {
            startIndex++;
            slicePoints.push(startPoint);
        }
        slicePoints.push(...curvePoints.slice(startIndex, endIndex));
        if (end !== 1.0 || start === 1.0) slicePoints.push(endPoint);
        return new $b2daf017bbb96e17$export$5d6a5d8dc9b2f01b(slicePoints, this.getNormalAt(start), this._raw, this._alignTangentsWithPath);
    }
    /**
     * Forces the Path3D tangent, normal, binormal and distance recomputation.
     * @param path path which all values are copied into the curves points
     * @param firstNormal which should be projected onto the curve
     * @param alignTangentsWithPath (optional, default false) : boolean, if true the tangents will be aligned with the path
     * @returns the same object updated.
     */ update(path, firstNormal = null, alignTangentsWithPath = false) {
        for(let p = 0; p < path.length; p++){
            this._curve[p].x = path[p].x;
            this._curve[p].y = path[p].y;
            this._curve[p].z = path[p].z;
        }
        this._compute(firstNormal, alignTangentsWithPath);
        return this;
    }
    // private function compute() : computes tangents, normals and binormals
    _compute(firstNormal, alignTangentsWithPath = false) {
        const l = this._curve.length;
        if (l < 2) return;
        // first and last tangents
        this._tangents[0] = this._getFirstNonNullVector(0);
        if (!this._raw) this._tangents[0].normalize();
        this._tangents[l - 1] = this._curve[l - 1].subtract(this._curve[l - 2]);
        if (!this._raw) this._tangents[l - 1].normalize();
        // normals and binormals at first point : arbitrary vector with _normalVector()
        const tg0 = this._tangents[0];
        const pp0 = this._normalVector(tg0, firstNormal);
        this._normals[0] = pp0;
        if (!this._raw) this._normals[0].normalize();
        this._binormals[0] = (0, $ha1VO.Vector3).Cross(tg0, this._normals[0]);
        if (!this._raw) this._binormals[0].normalize();
        this._distances[0] = 0.0;
        // normals and binormals : next points
        let prev; // previous vector (segment)
        let cur; // current vector (segment)
        let curTang; // current tangent
        // previous normal
        let prevNor; // previous normal
        let prevBinor; // previous binormal
        for(let i = 1; i < l; i++){
            // tangents
            prev = this._getLastNonNullVector(i);
            if (i < l - 1) {
                cur = this._getFirstNonNullVector(i);
                this._tangents[i] = alignTangentsWithPath ? cur : prev.add(cur);
                this._tangents[i].normalize();
            }
            this._distances[i] = this._distances[i - 1] + this._curve[i].subtract(this._curve[i - 1]).length();
            // normals and binormals
            // http://www.cs.cmu.edu/afs/andrew/scs/cs/15-462/web/old/asst2camera.html
            curTang = this._tangents[i];
            prevBinor = this._binormals[i - 1];
            this._normals[i] = (0, $ha1VO.Vector3).Cross(prevBinor, curTang);
            if (!this._raw) {
                if (this._normals[i].length() === 0) {
                    prevNor = this._normals[i - 1];
                    this._normals[i] = prevNor.clone();
                } else this._normals[i].normalize();
            }
            this._binormals[i] = (0, $ha1VO.Vector3).Cross(curTang, this._normals[i]);
            if (!this._raw) this._binormals[i].normalize();
        }
        this._pointAtData.id = NaN;
    }
    // private function getFirstNonNullVector(index)
    // returns the first non null vector from index : curve[index + N].subtract(curve[index])
    _getFirstNonNullVector(index) {
        let i = 1;
        let nNVector = this._curve[index + i].subtract(this._curve[index]);
        while(nNVector.length() === 0 && index + i + 1 < this._curve.length){
            i++;
            nNVector = this._curve[index + i].subtract(this._curve[index]);
        }
        return nNVector;
    }
    // private function getLastNonNullVector(index)
    // returns the last non null vector from index : curve[index].subtract(curve[index - N])
    _getLastNonNullVector(index) {
        let i = 1;
        let nLVector = this._curve[index].subtract(this._curve[index - i]);
        while(nLVector.length() === 0 && index > i + 1){
            i++;
            nLVector = this._curve[index].subtract(this._curve[index - i]);
        }
        return nLVector;
    }
    // private function normalVector(v0, vt, va) :
    // returns an arbitrary point in the plane defined by the point v0 and the vector vt orthogonal to this plane
    // if va is passed, it returns the va projection on the plane orthogonal to vt at the point v0
    _normalVector(vt, va) {
        let normal0;
        let tgl = vt.length();
        if (tgl === 0.0) tgl = 1.0;
        if (va === undefined || va === null) {
            let point;
            if (!(0, $1VEEL.Scalar).WithinEpsilon(Math.abs(vt.y) / tgl, 1.0, (0, $53VPf.Epsilon))) // search for a point in the plane
            point = new (0, $ha1VO.Vector3)(0.0, -1, 0.0);
            else if (!(0, $1VEEL.Scalar).WithinEpsilon(Math.abs(vt.x) / tgl, 1.0, (0, $53VPf.Epsilon))) point = new (0, $ha1VO.Vector3)(1.0, 0.0, 0.0);
            else if (!(0, $1VEEL.Scalar).WithinEpsilon(Math.abs(vt.z) / tgl, 1.0, (0, $53VPf.Epsilon))) point = new (0, $ha1VO.Vector3)(0.0, 0.0, 1.0);
            else point = (0, $ha1VO.Vector3).Zero();
            normal0 = (0, $ha1VO.Vector3).Cross(vt, point);
        } else {
            normal0 = (0, $ha1VO.Vector3).Cross(vt, va);
            (0, $ha1VO.Vector3).CrossToRef(normal0, vt, normal0);
        }
        normal0.normalize();
        return normal0;
    }
    /**
     * Updates the point at data for an interpolated point along this curve
     * @param position the position of the point along this curve, from 0.0 to 1.0
     * @param interpolateTNB
     * @interpolateTNB whether to compute the interpolated tangent, normal and binormal
     * @returns the (updated) point at data
     */ _updatePointAtData(position, interpolateTNB = false) {
        // set an id for caching the result
        if (this._pointAtData.id === position) {
            if (!this._pointAtData.interpolateReady) this._updateInterpolationMatrix();
            return this._pointAtData;
        } else this._pointAtData.id = position;
        const curvePoints = this.getPoints();
        // clamp position between 0.0 and 1.0
        if (position <= 0.0) return this._setPointAtData(0.0, 0.0, curvePoints[0], 0, interpolateTNB);
        else if (position >= 1.0) return this._setPointAtData(1.0, 1.0, curvePoints[curvePoints.length - 1], curvePoints.length - 1, interpolateTNB);
        let previousPoint = curvePoints[0];
        let currentPoint;
        let currentLength = 0.0;
        const targetLength = position * this.length();
        for(let i = 1; i < curvePoints.length; i++){
            currentPoint = curvePoints[i];
            const distance = (0, $ha1VO.Vector3).Distance(previousPoint, currentPoint);
            currentLength += distance;
            if (currentLength === targetLength) return this._setPointAtData(position, 1.0, currentPoint, i, interpolateTNB);
            else if (currentLength > targetLength) {
                const toLength = currentLength - targetLength;
                const diff = toLength / distance;
                const dir = previousPoint.subtract(currentPoint);
                const point = currentPoint.add(dir.scaleInPlace(diff));
                return this._setPointAtData(position, 1 - diff, point, i - 1, interpolateTNB);
            }
            previousPoint = currentPoint;
        }
        return this._pointAtData;
    }
    /**
     * Updates the point at data from the specified parameters
     * @param position where along the path the interpolated point is, from 0.0 to 1.0
     * @param subPosition
     * @param point the interpolated point
     * @param parentIndex the index of an existing curve point that is on, or else positionally the first behind, the interpolated point
     * @param interpolateTNB whether to compute the interpolated tangent, normal and binormal
     * @returns the (updated) point at data
     */ _setPointAtData(position, subPosition, point, parentIndex, interpolateTNB) {
        this._pointAtData.point = point;
        this._pointAtData.position = position;
        this._pointAtData.subPosition = subPosition;
        this._pointAtData.previousPointArrayIndex = parentIndex;
        this._pointAtData.interpolateReady = interpolateTNB;
        if (interpolateTNB) this._updateInterpolationMatrix();
        return this._pointAtData;
    }
    /**
     * Updates the point at interpolation matrix for the tangents, normals and binormals
     */ _updateInterpolationMatrix() {
        this._pointAtData.interpolationMatrix = (0, $ha1VO.Matrix).Identity();
        const parentIndex = this._pointAtData.previousPointArrayIndex;
        if (parentIndex !== this._tangents.length - 1) {
            const index = parentIndex + 1;
            const tangentFrom = this._tangents[parentIndex].clone();
            const normalFrom = this._normals[parentIndex].clone();
            const binormalFrom = this._binormals[parentIndex].clone();
            const tangentTo = this._tangents[index].clone();
            const normalTo = this._normals[index].clone();
            const binormalTo = this._binormals[index].clone();
            const quatFrom = (0, $ha1VO.Quaternion).RotationQuaternionFromAxis(normalFrom, binormalFrom, tangentFrom);
            const quatTo = (0, $ha1VO.Quaternion).RotationQuaternionFromAxis(normalTo, binormalTo, tangentTo);
            const quatAt = (0, $ha1VO.Quaternion).Slerp(quatFrom, quatTo, this._pointAtData.subPosition);
            quatAt.toRotationMatrix(this._pointAtData.interpolationMatrix);
        }
    }
}
class $b2daf017bbb96e17$export$82bb9f10f9631442 {
    /**
     * Returns a Curve3 object along a Quadratic Bezier curve : https://doc.babylonjs.com/features/featuresDeepDive/mesh/drawCurves#quadratic-bezier-curve
     * @param v0 (Vector3) the origin point of the Quadratic Bezier
     * @param v1 (Vector3) the control point
     * @param v2 (Vector3) the end point of the Quadratic Bezier
     * @param nbPoints (integer) the wanted number of points in the curve
     * @returns the created Curve3
     */ static CreateQuadraticBezier(v0, v1, v2, nbPoints) {
        nbPoints = nbPoints > 2 ? nbPoints : 3;
        const bez = [];
        const equation = (t, val0, val1, val2)=>{
            const res = (1.0 - t) * (1.0 - t) * val0 + 2.0 * t * (1.0 - t) * val1 + t * t * val2;
            return res;
        };
        for(let i = 0; i <= nbPoints; i++)bez.push(new (0, $ha1VO.Vector3)(equation(i / nbPoints, v0.x, v1.x, v2.x), equation(i / nbPoints, v0.y, v1.y, v2.y), equation(i / nbPoints, v0.z, v1.z, v2.z)));
        return new $b2daf017bbb96e17$export$82bb9f10f9631442(bez);
    }
    /**
     * Returns a Curve3 object along a Cubic Bezier curve : https://doc.babylonjs.com/features/featuresDeepDive/mesh/drawCurves#cubic-bezier-curve
     * @param v0 (Vector3) the origin point of the Cubic Bezier
     * @param v1 (Vector3) the first control point
     * @param v2 (Vector3) the second control point
     * @param v3 (Vector3) the end point of the Cubic Bezier
     * @param nbPoints (integer) the wanted number of points in the curve
     * @returns the created Curve3
     */ static CreateCubicBezier(v0, v1, v2, v3, nbPoints) {
        nbPoints = nbPoints > 3 ? nbPoints : 4;
        const bez = [];
        const equation = (t, val0, val1, val2, val3)=>{
            const res = (1.0 - t) * (1.0 - t) * (1.0 - t) * val0 + 3.0 * t * (1.0 - t) * (1.0 - t) * val1 + 3.0 * t * t * (1.0 - t) * val2 + t * t * t * val3;
            return res;
        };
        for(let i = 0; i <= nbPoints; i++)bez.push(new (0, $ha1VO.Vector3)(equation(i / nbPoints, v0.x, v1.x, v2.x, v3.x), equation(i / nbPoints, v0.y, v1.y, v2.y, v3.y), equation(i / nbPoints, v0.z, v1.z, v2.z, v3.z)));
        return new $b2daf017bbb96e17$export$82bb9f10f9631442(bez);
    }
    /**
     * Returns a Curve3 object along a Hermite Spline curve : https://doc.babylonjs.com/features/featuresDeepDive/mesh/drawCurves#hermite-spline
     * @param p1 (Vector3) the origin point of the Hermite Spline
     * @param t1 (Vector3) the tangent vector at the origin point
     * @param p2 (Vector3) the end point of the Hermite Spline
     * @param t2 (Vector3) the tangent vector at the end point
     * @param nSeg (integer) the number of curve segments or nSeg + 1 points in the array
     * @returns the created Curve3
     */ static CreateHermiteSpline(p1, t1, p2, t2, nSeg) {
        const hermite = [];
        const step = 1.0 / nSeg;
        for(let i = 0; i <= nSeg; i++)hermite.push((0, $ha1VO.Vector3).Hermite(p1, t1, p2, t2, i * step));
        return new $b2daf017bbb96e17$export$82bb9f10f9631442(hermite);
    }
    /**
     * Returns a Curve3 object along a CatmullRom Spline curve :
     * @param points (array of Vector3) the points the spline must pass through. At least, four points required
     * @param nbPoints (integer) the wanted number of points between each curve control points
     * @param closed (boolean) optional with default false, when true forms a closed loop from the points
     * @returns the created Curve3
     */ static CreateCatmullRomSpline(points, nbPoints, closed) {
        const catmullRom = [];
        const step = 1.0 / nbPoints;
        let amount = 0.0;
        if (closed) {
            const pointsCount = points.length;
            for(let i = 0; i < pointsCount; i++){
                amount = 0;
                for(let c = 0; c < nbPoints; c++){
                    catmullRom.push((0, $ha1VO.Vector3).CatmullRom(points[i % pointsCount], points[(i + 1) % pointsCount], points[(i + 2) % pointsCount], points[(i + 3) % pointsCount], amount));
                    amount += step;
                }
            }
            catmullRom.push(catmullRom[0]);
        } else {
            const totalPoints = [];
            totalPoints.push(points[0].clone());
            Array.prototype.push.apply(totalPoints, points);
            totalPoints.push(points[points.length - 1].clone());
            let i = 0;
            for(; i < totalPoints.length - 3; i++){
                amount = 0;
                for(let c = 0; c < nbPoints; c++){
                    catmullRom.push((0, $ha1VO.Vector3).CatmullRom(totalPoints[i], totalPoints[i + 1], totalPoints[i + 2], totalPoints[i + 3], amount));
                    amount += step;
                }
            }
            i--;
            catmullRom.push((0, $ha1VO.Vector3).CatmullRom(totalPoints[i], totalPoints[i + 1], totalPoints[i + 2], totalPoints[i + 3], amount));
        }
        return new $b2daf017bbb96e17$export$82bb9f10f9631442(catmullRom);
    }
    /**
     * Returns a Curve3 object along an arc through three vector3 points:
     * The three points should not be colinear. When they are the Curve3 is empty.
     * @param first (Vector3) the first point the arc must pass through.
     * @param second (Vector3) the second point the arc must pass through.
     * @param third (Vector3) the third point the arc must pass through.
     * @param steps (number) the larger the number of steps the more detailed the arc.
     * @param closed (boolean) optional with default false, when true forms the chord from the first and third point
     * @param fullCircle Circle (boolean) optional with default false, when true forms the complete circle through the three points
     * @returns the created Curve3
     */ static ArcThru3Points(first, second, third, steps = 32, closed = false, fullCircle = false) {
        const arc = [];
        const vec1 = second.subtract(first);
        const vec2 = third.subtract(second);
        const vec3 = first.subtract(third);
        const zAxis = (0, $ha1VO.Vector3).Cross(vec1, vec2);
        const len4 = zAxis.length();
        if (len4 < Math.pow(10, -8)) return new $b2daf017bbb96e17$export$82bb9f10f9631442(arc); // colinear points arc is empty
        const len1_sq = vec1.lengthSquared();
        const len2_sq = vec2.lengthSquared();
        const len3_sq = vec3.lengthSquared();
        const len4_sq = zAxis.lengthSquared();
        const len1 = vec1.length();
        const len2 = vec2.length();
        const len3 = vec3.length();
        const radius = 0.5 * len1 * len2 * len3 / len4;
        const dot1 = (0, $ha1VO.Vector3).Dot(vec1, vec3);
        const dot2 = (0, $ha1VO.Vector3).Dot(vec1, vec2);
        const dot3 = (0, $ha1VO.Vector3).Dot(vec2, vec3);
        const a = -0.5 * len2_sq * dot1 / len4_sq;
        const b = -0.5 * len3_sq * dot2 / len4_sq;
        const c = -0.5 * len1_sq * dot3 / len4_sq;
        const center = first.scale(a).add(second.scale(b)).add(third.scale(c));
        const radiusVec = first.subtract(center);
        const xAxis = radiusVec.normalize();
        const yAxis = (0, $ha1VO.Vector3).Cross(zAxis, xAxis).normalize();
        if (fullCircle) {
            const dStep = 2 * Math.PI / steps;
            for(let theta = 0; theta <= 2 * Math.PI; theta += dStep)arc.push(center.add(xAxis.scale(radius * Math.cos(theta)).add(yAxis.scale(radius * Math.sin(theta)))));
            arc.push(first);
        } else {
            const dStep = 1 / steps;
            let theta = 0;
            let point = (0, $ha1VO.Vector3).Zero();
            do {
                point = center.add(xAxis.scale(radius * Math.cos(theta)).add(yAxis.scale(radius * Math.sin(theta))));
                arc.push(point);
                theta += dStep;
            }while (!point.equalsWithEpsilon(third, radius * dStep * 1.1));
            arc.push(third);
            if (closed) arc.push(first);
        }
        return new $b2daf017bbb96e17$export$82bb9f10f9631442(arc);
    }
    /**
     * A Curve3 object is a logical object, so not a mesh, to handle curves in the 3D geometric space.
     * A Curve3 is designed from a series of successive Vector3.
     * Tuto : https://doc.babylonjs.com/features/featuresDeepDive/mesh/drawCurves#curve3-object
     * @param points points which make up the curve
     */ constructor(points){
        this._length = 0.0;
        this._points = points;
        this._length = this._computeLength(points);
    }
    /**
     * @returns the Curve3 stored array of successive Vector3
     */ getPoints() {
        return this._points;
    }
    /**
     * @returns the computed length (float) of the curve.
     */ length() {
        return this._length;
    }
    /**
     * Returns a new instance of Curve3 object : var curve = curveA.continue(curveB);
     * This new Curve3 is built by translating and sticking the curveB at the end of the curveA.
     * curveA and curveB keep unchanged.
     * @param curve the curve to continue from this curve
     * @returns the newly constructed curve
     */ continue(curve) {
        const lastPoint = this._points[this._points.length - 1];
        const continuedPoints = this._points.slice();
        const curvePoints = curve.getPoints();
        for(let i = 1; i < curvePoints.length; i++)continuedPoints.push(curvePoints[i].subtract(curvePoints[0]).add(lastPoint));
        const continuedCurve = new $b2daf017bbb96e17$export$82bb9f10f9631442(continuedPoints);
        return continuedCurve;
    }
    _computeLength(path) {
        let l = 0;
        for(let i = 1; i < path.length; i++)l += path[i].subtract(path[i - 1]).length();
        return l;
    }
}

});


parcelRegister("3Ey8i", function(module, exports) {

$parcel$export(module.exports, "AnimationEvent", () => $2a8f959bd90d4bd4$export$5edd24b0d5bb3e56);
/**
 * Composed of a frame, and an action function
 */ class $2a8f959bd90d4bd4$export$5edd24b0d5bb3e56 {
    /**
     * Initializes the animation event
     * @param frame The frame for which the event is triggered
     * @param action The event to perform when triggered
     * @param onlyOnce Specifies if the event should be triggered only once
     */ constructor(/** The frame for which the event is triggered **/ frame, /** The event to perform when triggered **/ action, /** Specifies if the event should be triggered only once**/ onlyOnce){
        this.frame = frame;
        this.action = action;
        this.onlyOnce = onlyOnce;
        /**
         * Specifies if the animation event is done
         */ this.isDone = false;
    }
    /** @internal */ _clone() {
        return new $2a8f959bd90d4bd4$export$5edd24b0d5bb3e56(this.frame, this.action, this.onlyOnce);
    }
}

});

parcelRegister("1LmZt", function(module, exports) {

$parcel$export(module.exports, "TargetedAnimation", () => $148c03a9e4eef840$export$33241111ceea6ec5);
$parcel$export(module.exports, "AnimationGroup", () => $148c03a9e4eef840$export$4e3f75a11a2fabf5);

var $lWogh = parcelRequire("lWogh");

var $diGQf = parcelRequire("diGQf");

var $ejQPp = parcelRequire("ejQPp");

var $7212E = parcelRequire("7212E");
class $148c03a9e4eef840$export$33241111ceea6ec5 {
    /**
     * Returns the string "TargetedAnimation"
     * @returns "TargetedAnimation"
     */ getClassName() {
        return "TargetedAnimation";
    }
    /**
     * Serialize the object
     * @returns the JSON object representing the current entity
     */ serialize() {
        const serializationObject = {};
        serializationObject.animation = this.animation.serialize();
        serializationObject.targetId = this.target.id;
        return serializationObject;
    }
}
class $148c03a9e4eef840$export$4e3f75a11a2fabf5 {
    /**
     * Gets or sets the mask associated with this animation group. This mask is used to filter which objects should be animated.
     */ get mask() {
        return this._mask;
    }
    set mask(value) {
        if (this._mask === value) return;
        this._mask = value;
        this.syncWithMask(true);
    }
    /**
     * Makes sure that the animations are either played or stopped according to the animation group mask.
     * Note however that the call won't have any effect if the animation group has not been started yet.
     * @param forceUpdate If true, forces to loop over the animatables even if no mask is defined (used internally, you shouldn't need to use it). Default: false.
     */ syncWithMask(forceUpdate = false) {
        if (!this.mask && !forceUpdate) {
            this._numActiveAnimatables = this._targetedAnimations.length;
            return;
        }
        this._numActiveAnimatables = 0;
        for(let i = 0; i < this._animatables.length; ++i){
            const animatable = this._animatables[i];
            if (!this.mask || this.mask.disabled || this.mask.retainsTarget(animatable.target.name)) {
                this._numActiveAnimatables++;
                if (animatable.paused) animatable.restart();
            } else if (!animatable.paused) animatable.pause();
        }
    }
    /**
     * Removes all animations for the targets not retained by the animation group mask.
     * Use this function if you know you won't need those animations anymore and if you want to free memory.
     */ removeUnmaskedAnimations() {
        if (!this.mask || this.mask.disabled) return;
        // Removes all animatables (in case the animation group has already been started)
        for(let i = 0; i < this._animatables.length; ++i){
            const animatable = this._animatables[i];
            if (!this.mask.retainsTarget(animatable.target.name)) {
                animatable.stop();
                this._animatables.splice(i, 1);
                --i;
            }
        }
        // Removes the targeted animations
        for(let index = 0; index < this._targetedAnimations.length; index++){
            const targetedAnimation = this._targetedAnimations[index];
            if (!this.mask.retainsTarget(targetedAnimation.target.name)) {
                this._targetedAnimations.splice(index, 1);
                --index;
            }
        }
    }
    /**
     * Gets or sets the first frame
     */ get from() {
        return this._from;
    }
    set from(value) {
        if (this._from === value) return;
        this._from = value;
        for(let index = 0; index < this._animatables.length; index++){
            const animatable = this._animatables[index];
            animatable.fromFrame = this._from;
        }
    }
    /**
     * Gets or sets the last frame
     */ get to() {
        return this._to;
    }
    set to(value) {
        if (this._to === value) return;
        this._to = value;
        for(let index = 0; index < this._animatables.length; index++){
            const animatable = this._animatables[index];
            animatable.toFrame = this._to;
        }
    }
    /**
     * Define if the animations are started
     */ get isStarted() {
        return this._isStarted;
    }
    /**
     * Gets a value indicating that the current group is playing
     */ get isPlaying() {
        return this._isStarted && !this._isPaused;
    }
    /**
     * Gets or sets the speed ratio to use for all animations
     */ get speedRatio() {
        return this._speedRatio;
    }
    /**
     * Gets or sets the speed ratio to use for all animations
     */ set speedRatio(value) {
        if (this._speedRatio === value) return;
        this._speedRatio = value;
        for(let index = 0; index < this._animatables.length; index++){
            const animatable = this._animatables[index];
            animatable.speedRatio = this._speedRatio;
        }
    }
    /**
     * Gets or sets if all animations should loop or not
     */ get loopAnimation() {
        return this._loopAnimation;
    }
    set loopAnimation(value) {
        if (this._loopAnimation === value) return;
        this._loopAnimation = value;
        for(let index = 0; index < this._animatables.length; index++){
            const animatable = this._animatables[index];
            animatable.loopAnimation = this._loopAnimation;
        }
    }
    /**
     * Gets or sets if all animations should be evaluated additively
     */ get isAdditive() {
        return this._isAdditive;
    }
    set isAdditive(value) {
        if (this._isAdditive === value) return;
        this._isAdditive = value;
        for(let index = 0; index < this._animatables.length; index++){
            const animatable = this._animatables[index];
            animatable.isAdditive = this._isAdditive;
        }
    }
    /**
     * Gets or sets the weight to apply to all animations of the group
     */ get weight() {
        return this._weight;
    }
    set weight(value) {
        if (this._weight === value) return;
        this._weight = value;
        this.setWeightForAllAnimatables(this._weight);
    }
    /**
     * Gets the targeted animations for this animation group
     */ get targetedAnimations() {
        return this._targetedAnimations;
    }
    /**
     * returning the list of animatables controlled by this animation group.
     */ get animatables() {
        return this._animatables;
    }
    /**
     * Gets the list of target animations
     */ get children() {
        return this._targetedAnimations;
    }
    /**
     * Gets or sets the order of play of the animation group (default: 0)
     */ get playOrder() {
        return this._playOrder;
    }
    set playOrder(value) {
        if (this._playOrder === value) return;
        this._playOrder = value;
        if (this._animatables.length > 0) {
            for(let i = 0; i < this._animatables.length; i++)this._animatables[i].playOrder = this._playOrder;
            this._scene.sortActiveAnimatables();
        }
    }
    /**
     * Allows the animations of the animation group to blend with current running animations
     * Note that a null value means that each animation will use their own existing blending configuration (Animation.enableBlending)
     */ get enableBlending() {
        return this._enableBlending;
    }
    set enableBlending(value) {
        if (this._enableBlending === value) return;
        this._enableBlending = value;
        if (value !== null) for(let i = 0; i < this._targetedAnimations.length; ++i)this._targetedAnimations[i].animation.enableBlending = value;
    }
    /**
     * Gets or sets the animation blending speed
     * Note that a null value means that each animation will use their own existing blending configuration (Animation.blendingSpeed)
     */ get blendingSpeed() {
        return this._blendingSpeed;
    }
    set blendingSpeed(value) {
        if (this._blendingSpeed === value) return;
        this._blendingSpeed = value;
        if (value !== null) for(let i = 0; i < this._targetedAnimations.length; ++i)this._targetedAnimations[i].animation.blendingSpeed = value;
    }
    /**
     * Gets the length (in seconds) of the animation group
     * This function assumes that all animations are played at the same framePerSecond speed!
     * Note: you can only call this method after you've added at least one targeted animation!
     * @param from Starting frame range (default is AnimationGroup.from)
     * @param to Ending frame range (default is AnimationGroup.to)
     * @returns The length in seconds
     */ getLength(from, to) {
        from = from ?? this._from;
        to = to ?? this._to;
        const fps = this.targetedAnimations[0].animation.framePerSecond * this._speedRatio;
        return (to - from) / fps;
    }
    /**
     * Merge the array of animation groups into a new animation group
     * @param animationGroups List of animation groups to merge
     * @param disposeSource If true, animation groups will be disposed after being merged (default: true)
     * @param normalize If true, animation groups will be normalized before being merged, so that all animations have the same "from" and "to" frame (default: false)
     * @param weight Weight for the new animation group. If not provided, it will inherit the weight from the first animation group of the array
     * @returns The new animation group or null if no animation groups were passed
     */ static MergeAnimationGroups(animationGroups, disposeSource = true, normalize = false, weight) {
        if (animationGroups.length === 0) return null;
        weight = weight ?? animationGroups[0].weight;
        let beginFrame = Number.MAX_VALUE;
        let endFrame = -Number.MAX_VALUE;
        if (normalize) for (const animationGroup of animationGroups){
            if (animationGroup.from < beginFrame) beginFrame = animationGroup.from;
            if (animationGroup.to > endFrame) endFrame = animationGroup.to;
        }
        const mergedAnimationGroup = new $148c03a9e4eef840$export$4e3f75a11a2fabf5(animationGroups[0].name + "_merged", animationGroups[0]._scene, weight);
        for (const animationGroup of animationGroups){
            if (normalize) animationGroup.normalize(beginFrame, endFrame);
            for (const targetedAnimation of animationGroup.targetedAnimations)mergedAnimationGroup.addTargetedAnimation(targetedAnimation.animation, targetedAnimation.target);
            if (disposeSource) animationGroup.dispose();
        }
        return mergedAnimationGroup;
    }
    /**
     * Instantiates a new Animation Group.
     * This helps managing several animations at once.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/groupAnimations
     * @param name Defines the name of the group
     * @param scene Defines the scene the group belongs to
     * @param weight Defines the weight to use for animations in the group (-1.0 by default, meaning "no weight")
     * @param playOrder Defines the order of play of the animation group (default is 0)
     */ constructor(/** The name of the animation group */ name, scene = null, weight = -1, playOrder = 0){
        this.name = name;
        this._targetedAnimations = new Array();
        this._animatables = new Array();
        this._from = Number.MAX_VALUE;
        this._to = -Number.MAX_VALUE;
        this._speedRatio = 1;
        this._loopAnimation = false;
        this._isAdditive = false;
        this._weight = -1;
        this._playOrder = 0;
        this._enableBlending = null;
        this._blendingSpeed = null;
        this._numActiveAnimatables = 0;
        /** @internal */ this._parentContainer = null;
        /**
         * This observable will notify when one animation have ended
         */ this.onAnimationEndObservable = new (0, $diGQf.Observable)();
        /**
         * Observer raised when one animation loops
         */ this.onAnimationLoopObservable = new (0, $diGQf.Observable)();
        /**
         * Observer raised when all animations have looped
         */ this.onAnimationGroupLoopObservable = new (0, $diGQf.Observable)();
        /**
         * This observable will notify when all animations have ended.
         */ this.onAnimationGroupEndObservable = new (0, $diGQf.Observable)();
        /**
         * This observable will notify when all animations have paused.
         */ this.onAnimationGroupPauseObservable = new (0, $diGQf.Observable)();
        /**
         * This observable will notify when all animations are playing.
         */ this.onAnimationGroupPlayObservable = new (0, $diGQf.Observable)();
        /**
         * Gets or sets an object used to store user defined information for the node
         */ this.metadata = null;
        this._mask = null;
        this._animationLoopFlags = [];
        this._scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        this._weight = weight;
        this._playOrder = playOrder;
        this.uniqueId = this._scene.getUniqueId();
        this._scene.addAnimationGroup(this);
    }
    /**
     * Add an animation (with its target) in the group
     * @param animation defines the animation we want to add
     * @param target defines the target of the animation
     * @returns the TargetedAnimation object
     */ addTargetedAnimation(animation, target) {
        const targetedAnimation = new $148c03a9e4eef840$export$33241111ceea6ec5();
        targetedAnimation.animation = animation;
        targetedAnimation.target = target;
        const keys = animation.getKeys();
        if (this._from > keys[0].frame) this._from = keys[0].frame;
        if (this._to < keys[keys.length - 1].frame) this._to = keys[keys.length - 1].frame;
        if (this._enableBlending !== null) animation.enableBlending = this._enableBlending;
        if (this._blendingSpeed !== null) animation.blendingSpeed = this._blendingSpeed;
        this._targetedAnimations.push(targetedAnimation);
        return targetedAnimation;
    }
    /**
     * Remove an animation from the group
     * @param animation defines the animation we want to remove
     */ removeTargetedAnimation(animation) {
        for(let index = this._targetedAnimations.length - 1; index > -1; index--){
            const targetedAnimation = this._targetedAnimations[index];
            if (targetedAnimation.animation === animation) this._targetedAnimations.splice(index, 1);
        }
    }
    /**
     * This function will normalize every animation in the group to make sure they all go from beginFrame to endFrame
     * It can add constant keys at begin or end
     * @param beginFrame defines the new begin frame for all animations or the smallest begin frame of all animations if null (defaults to null)
     * @param endFrame defines the new end frame for all animations or the largest end frame of all animations if null (defaults to null)
     * @returns the animation group
     */ normalize(beginFrame = null, endFrame = null) {
        if (beginFrame == null) beginFrame = this._from;
        if (endFrame == null) endFrame = this._to;
        for(let index = 0; index < this._targetedAnimations.length; index++){
            const targetedAnimation = this._targetedAnimations[index];
            const keys = targetedAnimation.animation.getKeys();
            const startKey = keys[0];
            const endKey = keys[keys.length - 1];
            if (startKey.frame > beginFrame) {
                const newKey = {
                    frame: beginFrame,
                    value: startKey.value,
                    inTangent: startKey.inTangent,
                    outTangent: startKey.outTangent,
                    interpolation: startKey.interpolation
                };
                keys.splice(0, 0, newKey);
            }
            if (endKey.frame < endFrame) {
                const newKey = {
                    frame: endFrame,
                    value: endKey.value,
                    inTangent: endKey.inTangent,
                    outTangent: endKey.outTangent,
                    interpolation: endKey.interpolation
                };
                keys.push(newKey);
            }
        }
        this._from = beginFrame;
        this._to = endFrame;
        return this;
    }
    _processLoop(animatable, targetedAnimation, index) {
        animatable.onAnimationLoop = ()=>{
            this.onAnimationLoopObservable.notifyObservers(targetedAnimation);
            if (this._animationLoopFlags[index]) return;
            this._animationLoopFlags[index] = true;
            this._animationLoopCount++;
            if (this._animationLoopCount === this._numActiveAnimatables) {
                this.onAnimationGroupLoopObservable.notifyObservers(this);
                this._animationLoopCount = 0;
                this._animationLoopFlags.length = 0;
            }
        };
    }
    /**
     * Start all animations on given targets
     * @param loop defines if animations must loop
     * @param speedRatio defines the ratio to apply to animation speed (1 by default)
     * @param from defines the from key (optional)
     * @param to defines the to key (optional)
     * @param isAdditive defines the additive state for the resulting animatables (optional)
     * @returns the current animation group
     */ start(loop = false, speedRatio = 1, from, to, isAdditive) {
        if (this._isStarted || this._targetedAnimations.length === 0) return this;
        this._loopAnimation = loop;
        this._animationLoopCount = 0;
        this._animationLoopFlags.length = 0;
        for(let index = 0; index < this._targetedAnimations.length; index++){
            const targetedAnimation = this._targetedAnimations[index];
            const animatable = this._scene.beginDirectAnimation(targetedAnimation.target, [
                targetedAnimation.animation
            ], from !== undefined ? from : this._from, to !== undefined ? to : this._to, loop, speedRatio, undefined, undefined, isAdditive !== undefined ? isAdditive : this._isAdditive);
            animatable.weight = this._weight;
            animatable.playOrder = this._playOrder;
            animatable.onAnimationEnd = ()=>{
                this.onAnimationEndObservable.notifyObservers(targetedAnimation);
                this._checkAnimationGroupEnded(animatable);
            };
            this._processLoop(animatable, targetedAnimation, index);
            this._animatables.push(animatable);
        }
        this.syncWithMask();
        this._scene.sortActiveAnimatables();
        this._speedRatio = speedRatio;
        this._isStarted = true;
        this._isPaused = false;
        this.onAnimationGroupPlayObservable.notifyObservers(this);
        return this;
    }
    /**
     * Pause all animations
     * @returns the animation group
     */ pause() {
        if (!this._isStarted) return this;
        this._isPaused = true;
        for(let index = 0; index < this._animatables.length; index++){
            const animatable = this._animatables[index];
            animatable.pause();
        }
        this.onAnimationGroupPauseObservable.notifyObservers(this);
        return this;
    }
    /**
     * Play all animations to initial state
     * This function will start() the animations if they were not started or will restart() them if they were paused
     * @param loop defines if animations must loop
     * @returns the animation group
     */ play(loop) {
        // only if all animatables are ready and exist
        if (this.isStarted && this._animatables.length === this._targetedAnimations.length) {
            if (loop !== undefined) this.loopAnimation = loop;
            this.restart();
        } else {
            this.stop();
            this.start(loop, this._speedRatio);
        }
        this._isPaused = false;
        return this;
    }
    /**
     * Reset all animations to initial state
     * @returns the animation group
     */ reset() {
        if (!this._isStarted) {
            this.play();
            this.goToFrame(0);
            this.stop();
            return this;
        }
        for(let index = 0; index < this._animatables.length; index++){
            const animatable = this._animatables[index];
            animatable.reset();
        }
        return this;
    }
    /**
     * Restart animations from key 0
     * @returns the animation group
     */ restart() {
        if (!this._isStarted) return this;
        for(let index = 0; index < this._animatables.length; index++){
            const animatable = this._animatables[index];
            animatable.restart();
        }
        this.syncWithMask();
        this.onAnimationGroupPlayObservable.notifyObservers(this);
        return this;
    }
    /**
     * Stop all animations
     * @returns the animation group
     */ stop() {
        if (!this._isStarted) return this;
        const list = this._animatables.slice();
        for(let index = 0; index < list.length; index++)list[index].stop(undefined, undefined, true);
        // We will take care of removing all stopped animatables
        let curIndex = 0;
        for(let index = 0; index < this._scene._activeAnimatables.length; index++){
            const animatable = this._scene._activeAnimatables[index];
            if (animatable._runtimeAnimations.length > 0) this._scene._activeAnimatables[curIndex++] = animatable;
        }
        this._scene._activeAnimatables.length = curIndex;
        this._isStarted = false;
        return this;
    }
    /**
     * Set animation weight for all animatables
     *
     * @since 6.12.4
     *  You can pass the weight to the AnimationGroup constructor, or use the weight property to set it after the group has been created,
     *  making it easier to define the overall animation weight than calling setWeightForAllAnimatables() after the animation group has been started
     * @param weight defines the weight to use
     * @returns the animationGroup
     * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#animation-weights
     */ setWeightForAllAnimatables(weight) {
        for(let index = 0; index < this._animatables.length; index++){
            const animatable = this._animatables[index];
            animatable.weight = weight;
        }
        return this;
    }
    /**
     * Synchronize and normalize all animatables with a source animatable
     * @param root defines the root animatable to synchronize with (null to stop synchronizing)
     * @returns the animationGroup
     * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#animation-weights
     */ syncAllAnimationsWith(root) {
        for(let index = 0; index < this._animatables.length; index++){
            const animatable = this._animatables[index];
            animatable.syncWith(root);
        }
        return this;
    }
    /**
     * Goes to a specific frame in this animation group
     * @param frame the frame number to go to
     * @returns the animationGroup
     */ goToFrame(frame) {
        if (!this._isStarted) return this;
        for(let index = 0; index < this._animatables.length; index++){
            const animatable = this._animatables[index];
            animatable.goToFrame(frame);
        }
        return this;
    }
    /**
     * Dispose all associated resources
     */ dispose() {
        this._targetedAnimations.length = 0;
        this._animatables.length = 0;
        // Remove from scene
        const index = this._scene.animationGroups.indexOf(this);
        if (index > -1) this._scene.animationGroups.splice(index, 1);
        if (this._parentContainer) {
            const index = this._parentContainer.animationGroups.indexOf(this);
            if (index > -1) this._parentContainer.animationGroups.splice(index, 1);
            this._parentContainer = null;
        }
        this.onAnimationEndObservable.clear();
        this.onAnimationGroupEndObservable.clear();
        this.onAnimationGroupPauseObservable.clear();
        this.onAnimationGroupPlayObservable.clear();
        this.onAnimationLoopObservable.clear();
        this.onAnimationGroupLoopObservable.clear();
    }
    _checkAnimationGroupEnded(animatable) {
        // animatable should be taken out of the array
        const idx = this._animatables.indexOf(animatable);
        if (idx > -1) this._animatables.splice(idx, 1);
        // all animatables were removed? animation group ended!
        if (this._animatables.length === 0) {
            this._isStarted = false;
            this.onAnimationGroupEndObservable.notifyObservers(this);
        }
    }
    /**
     * Clone the current animation group and returns a copy
     * @param newName defines the name of the new group
     * @param targetConverter defines an optional function used to convert current animation targets to new ones
     * @param cloneAnimations defines if the animations should be cloned or referenced
     * @returns the new animation group
     */ clone(newName, targetConverter, cloneAnimations = false) {
        const newGroup = new $148c03a9e4eef840$export$4e3f75a11a2fabf5(newName || this.name, this._scene, this._weight, this._playOrder);
        newGroup._from = this.from;
        newGroup._to = this.to;
        newGroup._speedRatio = this.speedRatio;
        newGroup._loopAnimation = this.loopAnimation;
        newGroup._isAdditive = this.isAdditive;
        newGroup._enableBlending = this.enableBlending;
        newGroup._blendingSpeed = this.blendingSpeed;
        newGroup.metadata = this.metadata;
        newGroup.mask = this.mask;
        for (const targetAnimation of this._targetedAnimations)newGroup.addTargetedAnimation(cloneAnimations ? targetAnimation.animation.clone() : targetAnimation.animation, targetConverter ? targetConverter(targetAnimation.target) : targetAnimation.target);
        return newGroup;
    }
    /**
     * Serializes the animationGroup to an object
     * @returns Serialized object
     */ serialize() {
        const serializationObject = {};
        serializationObject.name = this.name;
        serializationObject.from = this.from;
        serializationObject.to = this.to;
        serializationObject.speedRatio = this.speedRatio;
        serializationObject.loopAnimation = this.loopAnimation;
        serializationObject.isAdditive = this.isAdditive;
        serializationObject.weight = this.weight;
        serializationObject.playOrder = this.playOrder;
        serializationObject.enableBlending = this.enableBlending;
        serializationObject.blendingSpeed = this.blendingSpeed;
        serializationObject.targetedAnimations = [];
        for(let targetedAnimationIndex = 0; targetedAnimationIndex < this.targetedAnimations.length; targetedAnimationIndex++){
            const targetedAnimation = this.targetedAnimations[targetedAnimationIndex];
            serializationObject.targetedAnimations[targetedAnimationIndex] = targetedAnimation.serialize();
        }
        if ((0, $7212E.Tags) && (0, $7212E.Tags).HasTags(this)) serializationObject.tags = (0, $7212E.Tags).GetTags(this);
        // Metadata
        if (this.metadata) serializationObject.metadata = this.metadata;
        return serializationObject;
    }
    // Statics
    /**
     * Returns a new AnimationGroup object parsed from the source provided.
     * @param parsedAnimationGroup defines the source
     * @param scene defines the scene that will receive the animationGroup
     * @returns a new AnimationGroup
     */ static Parse(parsedAnimationGroup, scene) {
        const animationGroup = new $148c03a9e4eef840$export$4e3f75a11a2fabf5(parsedAnimationGroup.name, scene, parsedAnimationGroup.weight, parsedAnimationGroup.playOrder);
        for(let i = 0; i < parsedAnimationGroup.targetedAnimations.length; i++){
            const targetedAnimation = parsedAnimationGroup.targetedAnimations[i];
            const animation = (0, $lWogh.Animation).Parse(targetedAnimation.animation);
            const id = targetedAnimation.targetId;
            if (targetedAnimation.animation.property === "influence") {
                // morph target animation
                const morphTarget = scene.getMorphTargetById(id);
                if (morphTarget) animationGroup.addTargetedAnimation(animation, morphTarget);
            } else {
                const targetNode = scene.getNodeById(id);
                if (targetNode != null) animationGroup.addTargetedAnimation(animation, targetNode);
            }
        }
        if (0, $7212E.Tags) (0, $7212E.Tags).AddTagsTo(animationGroup, parsedAnimationGroup.tags);
        if (parsedAnimationGroup.from !== null && parsedAnimationGroup.to !== null) animationGroup.normalize(parsedAnimationGroup.from, parsedAnimationGroup.to);
        if (parsedAnimationGroup.speedRatio !== undefined) animationGroup._speedRatio = parsedAnimationGroup.speedRatio;
        if (parsedAnimationGroup.loopAnimation !== undefined) animationGroup._loopAnimation = parsedAnimationGroup.loopAnimation;
        if (parsedAnimationGroup.isAdditive !== undefined) animationGroup._isAdditive = parsedAnimationGroup.isAdditive;
        if (parsedAnimationGroup.weight !== undefined) animationGroup._weight = parsedAnimationGroup.weight;
        if (parsedAnimationGroup.playOrder !== undefined) animationGroup._playOrder = parsedAnimationGroup.playOrder;
        if (parsedAnimationGroup.enableBlending !== undefined) animationGroup._enableBlending = parsedAnimationGroup.enableBlending;
        if (parsedAnimationGroup.blendingSpeed !== undefined) animationGroup._blendingSpeed = parsedAnimationGroup.blendingSpeed;
        if (parsedAnimationGroup.metadata !== undefined) animationGroup.metadata = parsedAnimationGroup.metadata;
        return animationGroup;
    }
    /** @internal */ static MakeAnimationAdditive(sourceAnimationGroup, referenceFrameOrOptions, range, cloneOriginal = false, clonedName) {
        let options;
        if (typeof referenceFrameOrOptions === "object") options = referenceFrameOrOptions;
        else options = {
            referenceFrame: referenceFrameOrOptions,
            range: range,
            cloneOriginalAnimationGroup: cloneOriginal,
            clonedAnimationName: clonedName
        };
        let animationGroup = sourceAnimationGroup;
        if (options.cloneOriginalAnimationGroup) animationGroup = sourceAnimationGroup.clone(options.clonedAnimationGroupName || animationGroup.name);
        const targetedAnimations = animationGroup.targetedAnimations;
        for(let index = 0; index < targetedAnimations.length; index++){
            const targetedAnimation = targetedAnimations[index];
            targetedAnimation.animation = (0, $lWogh.Animation).MakeAnimationAdditive(targetedAnimation.animation, options);
        }
        animationGroup.isAdditive = true;
        if (options.clipKeys) {
            // We need to recalculate the from/to frames for the animation group because some keys may have been removed
            let from = Number.MAX_VALUE;
            let to = -Number.MAX_VALUE;
            const targetedAnimations = animationGroup.targetedAnimations;
            for(let index = 0; index < targetedAnimations.length; index++){
                const targetedAnimation = targetedAnimations[index];
                const animation = targetedAnimation.animation;
                const keys = animation.getKeys();
                if (from > keys[0].frame) from = keys[0].frame;
                if (to < keys[keys.length - 1].frame) to = keys[keys.length - 1].frame;
            }
            animationGroup._from = from;
            animationGroup._to = to;
        }
        return animationGroup;
    }
    /**
     * Creates a new animation, keeping only the keys that are inside a given key range
     * @param sourceAnimationGroup defines the animation group on which to operate
     * @param fromKey defines the lower bound of the range
     * @param toKey defines the upper bound of the range
     * @param name defines the name of the new animation group. If not provided, use the same name as animationGroup
     * @param dontCloneAnimations defines whether or not the animations should be cloned before clipping the keys. Default is false, so animations will be cloned
     * @returns a new animation group stripped from all the keys outside the given range
     */ static ClipKeys(sourceAnimationGroup, fromKey, toKey, name, dontCloneAnimations) {
        const animationGroup = sourceAnimationGroup.clone(name || sourceAnimationGroup.name);
        return $148c03a9e4eef840$export$4e3f75a11a2fabf5.ClipKeysInPlace(animationGroup, fromKey, toKey, dontCloneAnimations);
    }
    /**
     * Updates an existing animation, keeping only the keys that are inside a given key range
     * @param animationGroup defines the animation group on which to operate
     * @param fromKey defines the lower bound of the range
     * @param toKey defines the upper bound of the range
     * @param dontCloneAnimations defines whether or not the animations should be cloned before clipping the keys. Default is false, so animations will be cloned
     * @returns the animationGroup stripped from all the keys outside the given range
     */ static ClipKeysInPlace(animationGroup, fromKey, toKey, dontCloneAnimations) {
        return $148c03a9e4eef840$export$4e3f75a11a2fabf5.ClipInPlace(animationGroup, fromKey, toKey, dontCloneAnimations, false);
    }
    /**
     * Creates a new animation, keeping only the frames that are inside a given frame range
     * @param sourceAnimationGroup defines the animation group on which to operate
     * @param fromFrame defines the lower bound of the range
     * @param toFrame defines the upper bound of the range
     * @param name defines the name of the new animation group. If not provided, use the same name as animationGroup
     * @param dontCloneAnimations defines whether or not the animations should be cloned before clipping the frames. Default is false, so animations will be cloned
     * @returns a new animation group stripped from all the frames outside the given range
     */ static ClipFrames(sourceAnimationGroup, fromFrame, toFrame, name, dontCloneAnimations) {
        const animationGroup = sourceAnimationGroup.clone(name || sourceAnimationGroup.name);
        return $148c03a9e4eef840$export$4e3f75a11a2fabf5.ClipFramesInPlace(animationGroup, fromFrame, toFrame, dontCloneAnimations);
    }
    /**
     * Updates an existing animation, keeping only the frames that are inside a given frame range
     * @param animationGroup defines the animation group on which to operate
     * @param fromFrame defines the lower bound of the range
     * @param toFrame defines the upper bound of the range
     * @param dontCloneAnimations defines whether or not the animations should be cloned before clipping the frames. Default is false, so animations will be cloned
     * @returns the animationGroup stripped from all the frames outside the given range
     */ static ClipFramesInPlace(animationGroup, fromFrame, toFrame, dontCloneAnimations) {
        return $148c03a9e4eef840$export$4e3f75a11a2fabf5.ClipInPlace(animationGroup, fromFrame, toFrame, dontCloneAnimations, true);
    }
    /**
     * Updates an existing animation, keeping only the keys that are inside a given key or frame range
     * @param animationGroup defines the animation group on which to operate
     * @param start defines the lower bound of the range
     * @param end defines the upper bound of the range
     * @param dontCloneAnimations defines whether or not the animations should be cloned before clipping the keys. Default is false, so animations will be cloned
     * @param useFrame defines if the range is defined by frame numbers or key indices (default is false which means use key indices)
     * @returns the animationGroup stripped from all the keys outside the given range
     */ static ClipInPlace(animationGroup, start, end, dontCloneAnimations, useFrame = false) {
        let from = Number.MAX_VALUE;
        let to = -Number.MAX_VALUE;
        const targetedAnimations = animationGroup.targetedAnimations;
        for(let index = 0; index < targetedAnimations.length; index++){
            const targetedAnimation = targetedAnimations[index];
            const animation = dontCloneAnimations ? targetedAnimation.animation : targetedAnimation.animation.clone();
            if (useFrame) {
                // Make sure we have keys corresponding to the bounds of the frame range
                animation.createKeyForFrame(start);
                animation.createKeyForFrame(end);
            }
            const keys = animation.getKeys();
            const newKeys = [];
            let startFrame = Number.MAX_VALUE;
            for(let k = 0; k < keys.length; k++){
                const key = keys[k];
                if (!useFrame && k >= start && k <= end || useFrame && key.frame >= start && key.frame <= end) {
                    const newKey = {
                        frame: key.frame,
                        value: key.value.clone ? key.value.clone() : key.value,
                        inTangent: key.inTangent,
                        outTangent: key.outTangent,
                        interpolation: key.interpolation,
                        lockedTangent: key.lockedTangent
                    };
                    if (startFrame === Number.MAX_VALUE) startFrame = newKey.frame;
                    newKey.frame -= startFrame;
                    newKeys.push(newKey);
                }
            }
            if (newKeys.length === 0) {
                targetedAnimations.splice(index, 1);
                index--;
                continue;
            }
            if (from > newKeys[0].frame) from = newKeys[0].frame;
            if (to < newKeys[newKeys.length - 1].frame) to = newKeys[newKeys.length - 1].frame;
            animation.setKeys(newKeys, true);
            targetedAnimation.animation = animation; // in case the animation has been cloned
        }
        animationGroup._from = from;
        animationGroup._to = to;
        return animationGroup;
    }
    /**
     * Returns the string "AnimationGroup"
     * @returns "AnimationGroup"
     */ getClassName() {
        return "AnimationGroup";
    }
    /**
     * Creates a detailed string about the object
     * @param fullDetails defines if the output string will support multiple levels of logging within scene loading
     * @returns a string representing the object
     */ toString(fullDetails) {
        let ret = "Name: " + this.name;
        ret += ", type: " + this.getClassName();
        if (fullDetails) {
            ret += ", from: " + this._from;
            ret += ", to: " + this._to;
            ret += ", isStarted: " + this._isStarted;
            ret += ", speedRatio: " + this._speedRatio;
            ret += ", targetedAnimations length: " + this._targetedAnimations.length;
            ret += ", animatables length: " + this._animatables;
        }
        return ret;
    }
}

});

parcelRegister("ymxrh", function(module, exports) {

});

parcelRegister("78nGO", function(module, exports) {

$parcel$export(module.exports, "PathCursor", () => $531ba803c514fb96$export$a59f1c6be1677ec6);

var $ha1VO = parcelRequire("ha1VO");
class $531ba803c514fb96$export$a59f1c6be1677ec6 {
    /**
     * Initializes the path cursor
     * @param _path The path to track
     */ constructor(_path){
        this._path = _path;
        /**
         * Stores path cursor callbacks for when an onchange event is triggered
         */ this._onchange = new Array();
        /**
         * The value of the path cursor
         */ this.value = 0;
        /**
         * The animation array of the path cursor
         */ this.animations = [];
    }
    /**
     * Gets the cursor point on the path
     * @returns A point on the path cursor at the cursor location
     */ getPoint() {
        const point = this._path.getPointAtLengthPosition(this.value);
        return new (0, $ha1VO.Vector3)(point.x, 0, point.y);
    }
    /**
     * Moves the cursor ahead by the step amount
     * @param step The amount to move the cursor forward
     * @returns This path cursor
     */ moveAhead(step = 0.002) {
        this.move(step);
        return this;
    }
    /**
     * Moves the cursor behind by the step amount
     * @param step The amount to move the cursor back
     * @returns This path cursor
     */ moveBack(step = 0.002) {
        this.move(-step);
        return this;
    }
    /**
     * Moves the cursor by the step amount
     * If the step amount is greater than one, an exception is thrown
     * @param step The amount to move the cursor
     * @returns This path cursor
     */ move(step) {
        if (Math.abs(step) > 1) // eslint-disable-next-line no-throw-literal
        throw "step size should be less than 1.";
        this.value += step;
        this._ensureLimits();
        this._raiseOnChange();
        return this;
    }
    /**
     * Ensures that the value is limited between zero and one
     * @returns This path cursor
     */ _ensureLimits() {
        while(this.value > 1)this.value -= 1;
        while(this.value < 0)this.value += 1;
        return this;
    }
    /**
     * Runs onchange callbacks on change (used by the animation engine)
     * @returns This path cursor
     */ _raiseOnChange() {
        this._onchange.forEach((f)=>f(this));
        return this;
    }
    /**
     * Executes a function on change
     * @param f A path cursor onchange callback
     * @returns This path cursor
     */ onchange(f) {
        this._onchange.push(f);
        return this;
    }
}

});

parcelRegister("6Xc2k", function(module, exports) {

$parcel$export(module.exports, "AnimationGroupMaskMode", () => $510196fc16045a89$export$50c1d09ab96ba77b);
$parcel$export(module.exports, "AnimationGroupMask", () => $510196fc16045a89$export$5fa7969945668027);
/**
 * Enum used to define the mode for an animation group mask
 */ var $510196fc16045a89$export$50c1d09ab96ba77b;
(function(AnimationGroupMaskMode) {
    /**
     * The mask defines the animatable target names that should be included
     */ AnimationGroupMaskMode[AnimationGroupMaskMode["Include"] = 0] = "Include";
    /**
     * The mask defines the animatable target names in a "exclude" mode: all animatable targets will be animated except the ones defined in the mask
     */ AnimationGroupMaskMode[AnimationGroupMaskMode["Exclude"] = 1] = "Exclude";
})($510196fc16045a89$export$50c1d09ab96ba77b || ($510196fc16045a89$export$50c1d09ab96ba77b = {}));
class $510196fc16045a89$export$5fa7969945668027 {
    /**
     * Creates a new mask
     * @param names The list of target names to add to the mask (optional)
     * @param mode Defines the mode for the mask (default: AnimationGroupMaskMode.Include)
     */ constructor(names, /**
     * Defines the mode for the mask
     */ mode = $510196fc16045a89$export$50c1d09ab96ba77b.Include){
        this.mode = mode;
        /**
         * Gets or sets a boolean indicating if the mask is disabled (default is false)
         */ this.disabled = false;
        this._targetNames = new Set();
        if (names) this.addTargetName(names);
    }
    /**
     * Adds one or several target names to the mask
     * @param name The name(s) to add to the mask
     */ addTargetName(name) {
        if (Array.isArray(name)) {
            for (const n of name)this._targetNames.add(n);
            return;
        }
        this._targetNames.add(name);
    }
    /**
     * Removes one or several target names from the mask
     * @param name The name(s) to remove from the mask
     */ removeTargetName(name) {
        if (Array.isArray(name)) {
            for (const n of name)this._targetNames.delete(n);
            return;
        }
        this._targetNames.delete(name);
    }
    /**
     * Checks if the mask includes a target name.
     * This method is intended to know if a given target name is included in the mask, not if the name is actually retained by the mask (see retainsTarget() instead).
     * @param name The name to check with the mask
     * @returns True if the mask includes the name, false otherwise
     */ hasTarget(name) {
        return this._targetNames.has(name);
    }
    /**
     * Checks if the mask retains a target name.
     * Note that in the "Exclude" mode, this will return false if the mask includes the name, and true otherwise!
     * This method is intended to know if a given target name is retained by the mask, not if the name is in the list of target names.
     * @param name The name to check with the mask
     * @returns True if the mask retains the name, false otherwise
     */ retainsTarget(name) {
        return this._targetNames.has(name) === (this.mode === $510196fc16045a89$export$50c1d09ab96ba77b.Include);
    }
}

});


parcelRegister("kMzus", function(module, exports) {

$parcel$export(module.exports, "KeepAssets", () => $f213d1f9545bf37d$export$d2dab17973a1a538);
$parcel$export(module.exports, "InstantiatedEntries", () => $f213d1f9545bf37d$export$207c767edc04f6d6);
$parcel$export(module.exports, "AssetContainer", () => $f213d1f9545bf37d$export$8bb8d1d0452e3b79);

var $5Tqba = parcelRequire("5Tqba");

var $fbuqw = parcelRequire("fbuqw");

var $klshO = parcelRequire("klshO");

var $0cHNL = parcelRequire("0cHNL");

var $kVtWi = parcelRequire("kVtWi");

var $ejQPp = parcelRequire("ejQPp");

var $9Xybp = parcelRequire("9Xybp");

var $c6YWJ = parcelRequire("c6YWJ");

var $74SKQ = parcelRequire("74SKQ");

var $bOhSV = parcelRequire("bOhSV");
class $f213d1f9545bf37d$export$d2dab17973a1a538 extends (0, $5Tqba.AbstractScene) {
}
class $f213d1f9545bf37d$export$207c767edc04f6d6 {
    constructor(){
        /**
         * List of new root nodes (eg. nodes with no parent)
         */ this.rootNodes = [];
        /**
         * List of new skeletons
         */ this.skeletons = [];
        /**
         * List of new animation groups
         */ this.animationGroups = [];
    }
    /**
     * Disposes the instantiated entries from the scene
     */ dispose() {
        this.rootNodes.slice(0).forEach((o)=>{
            o.dispose();
        });
        this.rootNodes.length = 0;
        this.skeletons.slice(0).forEach((o)=>{
            o.dispose();
        });
        this.skeletons.length = 0;
        this.animationGroups.slice(0).forEach((o)=>{
            o.dispose();
        });
        this.animationGroups.length = 0;
    }
}
class $f213d1f9545bf37d$export$8bb8d1d0452e3b79 extends (0, $5Tqba.AbstractScene) {
    /**
     * Instantiates an AssetContainer.
     * @param scene The scene the AssetContainer belongs to.
     */ constructor(scene){
        super();
        this._wasAddedToScene = false;
        scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        if (!scene) return;
        this.scene = scene;
        this["sounds"] = [];
        this["effectLayers"] = [];
        this["layers"] = [];
        this["lensFlareSystems"] = [];
        this["proceduralTextures"] = [];
        this["reflectionProbes"] = [];
        scene.onDisposeObservable.add(()=>{
            if (!this._wasAddedToScene) this.dispose();
        });
        this._onContextRestoredObserver = scene.getEngine().onContextRestoredObservable.add(()=>{
            for (const geometry of this.geometries)geometry._rebuild();
            for (const mesh of this.meshes)mesh._rebuild();
            for (const system of this.particleSystems)system.rebuild();
            for (const texture of this.textures)texture._rebuild();
        });
    }
    /**
     * Given a list of nodes, return a topological sorting of them.
     * @param nodes
     * @returns a sorted array of nodes
     */ _topologicalSort(nodes) {
        const nodesUidMap = new Map();
        for (const node of nodes)nodesUidMap.set(node.uniqueId, node);
        const dependencyGraph = {
            dependsOn: new Map(),
            dependedBy: new Map()
        };
        // Build the dependency graph given the list of nodes
        // First pass: Initialize the empty dependency graph
        for (const node of nodes){
            const nodeId = node.uniqueId;
            dependencyGraph.dependsOn.set(nodeId, new Set());
            dependencyGraph.dependedBy.set(nodeId, new Set());
        }
        // Second pass: Populate the dependency graph. We assume that we
        // don't need to check for cycles here, as the scene graph cannot
        // contain cycles. Our graph also already contains all transitive
        // dependencies because getDescendants returns the transitive
        // dependencies by default.
        for (const node of nodes){
            const nodeId = node.uniqueId;
            const dependsOn = dependencyGraph.dependsOn.get(nodeId);
            if (node instanceof (0, $9Xybp.InstancedMesh)) {
                const masterMesh = node.sourceMesh;
                if (nodesUidMap.has(masterMesh.uniqueId)) {
                    dependsOn.add(masterMesh.uniqueId);
                    dependencyGraph.dependedBy.get(masterMesh.uniqueId).add(nodeId);
                }
            }
            const dependedBy = dependencyGraph.dependedBy.get(nodeId);
            for (const child of node.getDescendants()){
                const childId = child.uniqueId;
                if (nodesUidMap.has(childId)) {
                    dependedBy.add(childId);
                    const childDependsOn = dependencyGraph.dependsOn.get(childId);
                    childDependsOn.add(nodeId);
                }
            }
        }
        // Third pass: Topological sort
        const sortedNodes = [];
        // First: Find all nodes that have no dependencies
        const leaves = [];
        for (const node of nodes){
            const nodeId = node.uniqueId;
            if (dependencyGraph.dependsOn.get(nodeId).size === 0) {
                leaves.push(node);
                nodesUidMap.delete(nodeId);
            }
        }
        const visitList = leaves;
        while(visitList.length > 0){
            const nodeToVisit = visitList.shift();
            sortedNodes.push(nodeToVisit);
            // Remove the node from the dependency graph
            // When a node is visited, we know that dependsOn is empty.
            // So we only need to remove the node from dependedBy.
            const dependedByVisitedNode = dependencyGraph.dependedBy.get(nodeToVisit.uniqueId);
            // Array.from(x.values()) is to make the TS compiler happy
            for (const dependedByVisitedNodeId of Array.from(dependedByVisitedNode.values())){
                const dependsOnDependedByVisitedNode = dependencyGraph.dependsOn.get(dependedByVisitedNodeId);
                dependsOnDependedByVisitedNode.delete(nodeToVisit.uniqueId);
                if (dependsOnDependedByVisitedNode.size === 0 && nodesUidMap.get(dependedByVisitedNodeId)) {
                    visitList.push(nodesUidMap.get(dependedByVisitedNodeId));
                    nodesUidMap.delete(dependedByVisitedNodeId);
                }
            }
        }
        if (nodesUidMap.size > 0) {
            (0, $kVtWi.Logger).Error("SceneSerializer._topologicalSort: There were unvisited nodes:");
            nodesUidMap.forEach((node)=>(0, $kVtWi.Logger).Error(node.name));
        }
        return sortedNodes;
    }
    _addNodeAndDescendantsToList(list, addedIds, rootNode, predicate) {
        if (!rootNode || predicate && !predicate(rootNode) || addedIds.has(rootNode.uniqueId)) return;
        list.push(rootNode);
        addedIds.add(rootNode.uniqueId);
        for (const child of rootNode.getDescendants(true))this._addNodeAndDescendantsToList(list, addedIds, child, predicate);
    }
    /**
     * Check if a specific node is contained in this asset container.
     * @param node the node to check
     * @returns true if the node is contained in this container, otherwise false.
     */ _isNodeInContainer(node) {
        if (node instanceof (0, $0cHNL.AbstractMesh) && this.meshes.indexOf(node) !== -1) return true;
        if (node instanceof (0, $klshO.TransformNode) && this.transformNodes.indexOf(node) !== -1) return true;
        if (node instanceof (0, $c6YWJ.Light) && this.lights.indexOf(node) !== -1) return true;
        if (node instanceof (0, $74SKQ.Camera) && this.cameras.indexOf(node) !== -1) return true;
        return false;
    }
    /**
     * For every node in the scene, check if its parent node is also in the scene.
     * @returns true if every node's parent is also in the scene, otherwise false.
     */ _isValidHierarchy() {
        for (const node of this.meshes)if (node.parent && !this._isNodeInContainer(node.parent)) {
            (0, $kVtWi.Logger).Warn(`Node ${node.name} has a parent that is not in the container.`);
            return false;
        }
        for (const node of this.transformNodes)if (node.parent && !this._isNodeInContainer(node.parent)) {
            (0, $kVtWi.Logger).Warn(`Node ${node.name} has a parent that is not in the container.`);
            return false;
        }
        for (const node of this.lights)if (node.parent && !this._isNodeInContainer(node.parent)) {
            (0, $kVtWi.Logger).Warn(`Node ${node.name} has a parent that is not in the container.`);
            return false;
        }
        for (const node of this.cameras)if (node.parent && !this._isNodeInContainer(node.parent)) {
            (0, $kVtWi.Logger).Warn(`Node ${node.name} has a parent that is not in the container.`);
            return false;
        }
        return true;
    }
    /**
     * Instantiate or clone all meshes and add the new ones to the scene.
     * Skeletons and animation groups will all be cloned
     * @param nameFunction defines an optional function used to get new names for clones
     * @param cloneMaterials defines an optional boolean that defines if materials must be cloned as well (false by default)
     * @param options defines an optional list of options to control how to instantiate / clone models
     * @param options.doNotInstantiate defines if the model must be instantiated or just cloned
     * @param options.predicate defines a predicate used to filter whih mesh to instantiate/clone
     * @returns a list of rootNodes, skeletons and animation groups that were duplicated
     */ instantiateModelsToScene(nameFunction, cloneMaterials = false, options) {
        if (!this._isValidHierarchy()) (0, $bOhSV.Tools).Warn("SceneSerializer.InstantiateModelsToScene: The Asset Container hierarchy is not valid.");
        const conversionMap = {};
        const storeMap = {};
        const result = new $f213d1f9545bf37d$export$207c767edc04f6d6();
        const alreadySwappedSkeletons = [];
        const alreadySwappedMaterials = [];
        const localOptions = {
            doNotInstantiate: true,
            ...options
        };
        const onClone = (source, clone)=>{
            conversionMap[source.uniqueId] = clone.uniqueId;
            storeMap[clone.uniqueId] = clone;
            if (nameFunction) clone.name = nameFunction(source.name);
            if (clone instanceof (0, $fbuqw.Mesh)) {
                const clonedMesh = clone;
                if (clonedMesh.morphTargetManager) {
                    const oldMorphTargetManager = source.morphTargetManager;
                    clonedMesh.morphTargetManager = oldMorphTargetManager.clone();
                    for(let index = 0; index < oldMorphTargetManager.numTargets; index++){
                        const oldTarget = oldMorphTargetManager.getTarget(index);
                        const newTarget = clonedMesh.morphTargetManager.getTarget(index);
                        conversionMap[oldTarget.uniqueId] = newTarget.uniqueId;
                        storeMap[newTarget.uniqueId] = newTarget;
                    }
                }
            }
        };
        const nodesToSort = [];
        const idsOnSortList = new Set();
        for (const transformNode of this.transformNodes)if (transformNode.parent === null) this._addNodeAndDescendantsToList(nodesToSort, idsOnSortList, transformNode, localOptions.predicate);
        for (const mesh of this.meshes)if (mesh.parent === null) this._addNodeAndDescendantsToList(nodesToSort, idsOnSortList, mesh, localOptions.predicate);
        // Topologically sort nodes by parenting/instancing relationships so that all resources are in place
        // when a given node is instantiated.
        const sortedNodes = this._topologicalSort(nodesToSort);
        const onNewCreated = (source, clone)=>{
            onClone(source, clone);
            if (source.parent) {
                const replicatedParentId = conversionMap[source.parent.uniqueId];
                const replicatedParent = storeMap[replicatedParentId];
                if (replicatedParent) clone.parent = replicatedParent;
                else clone.parent = source.parent;
            }
            if (clone.position && source.position) clone.position.copyFrom(source.position);
            if (clone.rotationQuaternion && source.rotationQuaternion) clone.rotationQuaternion.copyFrom(source.rotationQuaternion);
            if (clone.rotation && source.rotation) clone.rotation.copyFrom(source.rotation);
            if (clone.scaling && source.scaling) clone.scaling.copyFrom(source.scaling);
            if (clone.material) {
                const mesh = clone;
                if (mesh.material) {
                    if (cloneMaterials) {
                        const sourceMaterial = source.material;
                        if (alreadySwappedMaterials.indexOf(sourceMaterial) === -1) {
                            let swap = sourceMaterial.clone(nameFunction ? nameFunction(sourceMaterial.name) : "Clone of " + sourceMaterial.name);
                            alreadySwappedMaterials.push(sourceMaterial);
                            conversionMap[sourceMaterial.uniqueId] = swap.uniqueId;
                            storeMap[swap.uniqueId] = swap;
                            if (sourceMaterial.getClassName() === "MultiMaterial") {
                                const multi = sourceMaterial;
                                for (const material of multi.subMaterials){
                                    if (!material) continue;
                                    swap = material.clone(nameFunction ? nameFunction(material.name) : "Clone of " + material.name);
                                    alreadySwappedMaterials.push(material);
                                    conversionMap[material.uniqueId] = swap.uniqueId;
                                    storeMap[swap.uniqueId] = swap;
                                }
                                multi.subMaterials = multi.subMaterials.map((m)=>m && storeMap[conversionMap[m.uniqueId]]);
                            }
                        }
                        if (mesh.getClassName() !== "InstancedMesh") mesh.material = storeMap[conversionMap[sourceMaterial.uniqueId]];
                    } else {
                        if (mesh.material.getClassName() === "MultiMaterial") {
                            if (this.scene.multiMaterials.indexOf(mesh.material) === -1) this.scene.addMultiMaterial(mesh.material);
                        } else if (this.scene.materials.indexOf(mesh.material) === -1) this.scene.addMaterial(mesh.material);
                    }
                }
            }
            if (clone.parent === null) result.rootNodes.push(clone);
        };
        sortedNodes.forEach((node)=>{
            if (node.getClassName() === "InstancedMesh") {
                const instancedNode = node;
                const sourceMesh = instancedNode.sourceMesh;
                const replicatedSourceId = conversionMap[sourceMesh.uniqueId];
                const replicatedSource = typeof replicatedSourceId === "number" ? storeMap[replicatedSourceId] : sourceMesh;
                const replicatedInstancedNode = replicatedSource.createInstance(instancedNode.name);
                onNewCreated(instancedNode, replicatedInstancedNode);
            } else {
                // Mesh or TransformNode
                let canInstance = true;
                if (node.getClassName() === "TransformNode" || node.getClassName() === "Node" || node.skeleton || !node.getTotalVertices || node.getTotalVertices() === 0) // Transform nodes, skinned meshes, and meshes with no vertices can never be instanced!
                canInstance = false;
                else if (localOptions.doNotInstantiate) {
                    if (typeof localOptions.doNotInstantiate === "function") canInstance = !localOptions.doNotInstantiate(node);
                    else canInstance = !localOptions.doNotInstantiate;
                }
                const replicatedNode = canInstance ? node.createInstance(`instance of ${node.name}`) : node.clone(`Clone of ${node.name}`, null, true);
                if (!replicatedNode) throw new Error(`Could not clone or instantiate node on Asset Container ${node.name}`);
                onNewCreated(node, replicatedNode);
            }
        });
        this.skeletons.forEach((s)=>{
            if (localOptions.predicate && !localOptions.predicate(s)) return;
            const clone = s.clone(nameFunction ? nameFunction(s.name) : "Clone of " + s.name);
            for (const m of this.meshes)if (m.skeleton === s && !m.isAnInstance) {
                const copy = storeMap[conversionMap[m.uniqueId]];
                if (!copy || copy.isAnInstance) continue;
                copy.skeleton = clone;
                if (alreadySwappedSkeletons.indexOf(clone) !== -1) continue;
                alreadySwappedSkeletons.push(clone);
                // Check if bones are mesh linked
                for (const bone of clone.bones)if (bone._linkedTransformNode) bone._linkedTransformNode = storeMap[conversionMap[bone._linkedTransformNode.uniqueId]];
            }
            result.skeletons.push(clone);
        });
        this.animationGroups.forEach((o)=>{
            if (localOptions.predicate && !localOptions.predicate(o)) return;
            const clone = o.clone(nameFunction ? nameFunction(o.name) : "Clone of " + o.name, (oldTarget)=>{
                const newTarget = storeMap[conversionMap[oldTarget.uniqueId]];
                return newTarget || oldTarget;
            });
            result.animationGroups.push(clone);
        });
        return result;
    }
    /**
     * Adds all the assets from the container to the scene.
     */ addAllToScene() {
        if (this._wasAddedToScene) return;
        if (!this._isValidHierarchy()) (0, $bOhSV.Tools).Warn("SceneSerializer.addAllToScene: The Asset Container hierarchy is not valid.");
        this._wasAddedToScene = true;
        this.addToScene(null);
        if (this.environmentTexture) this.scene.environmentTexture = this.environmentTexture;
        for (const component of this.scene._serializableComponents)component.addFromContainer(this);
        this.scene.getEngine().onContextRestoredObservable.remove(this._onContextRestoredObserver);
        this._onContextRestoredObserver = null;
    }
    /**
     * Adds assets from the container to the scene.
     * @param predicate defines a predicate used to select which entity will be added (can be null)
     */ addToScene(predicate = null) {
        const addedNodes = [];
        this.cameras.forEach((o)=>{
            if (predicate && !predicate(o)) return;
            this.scene.addCamera(o);
            addedNodes.push(o);
        });
        this.lights.forEach((o)=>{
            if (predicate && !predicate(o)) return;
            this.scene.addLight(o);
            addedNodes.push(o);
        });
        this.meshes.forEach((o)=>{
            if (predicate && !predicate(o)) return;
            this.scene.addMesh(o);
            addedNodes.push(o);
        });
        this.skeletons.forEach((o)=>{
            if (predicate && !predicate(o)) return;
            this.scene.addSkeleton(o);
        });
        this.animations.forEach((o)=>{
            if (predicate && !predicate(o)) return;
            this.scene.addAnimation(o);
        });
        this.animationGroups.forEach((o)=>{
            if (predicate && !predicate(o)) return;
            this.scene.addAnimationGroup(o);
        });
        this.multiMaterials.forEach((o)=>{
            if (predicate && !predicate(o)) return;
            this.scene.addMultiMaterial(o);
        });
        this.materials.forEach((o)=>{
            if (predicate && !predicate(o)) return;
            this.scene.addMaterial(o);
        });
        this.morphTargetManagers.forEach((o)=>{
            if (predicate && !predicate(o)) return;
            this.scene.addMorphTargetManager(o);
        });
        this.geometries.forEach((o)=>{
            if (predicate && !predicate(o)) return;
            this.scene.addGeometry(o);
        });
        this.transformNodes.forEach((o)=>{
            if (predicate && !predicate(o)) return;
            this.scene.addTransformNode(o);
            addedNodes.push(o);
        });
        this.actionManagers.forEach((o)=>{
            if (predicate && !predicate(o)) return;
            this.scene.addActionManager(o);
        });
        this.textures.forEach((o)=>{
            if (predicate && !predicate(o)) return;
            this.scene.addTexture(o);
        });
        this.reflectionProbes.forEach((o)=>{
            if (predicate && !predicate(o)) return;
            this.scene.addReflectionProbe(o);
        });
        for (const addedNode of addedNodes)// If node was added to the scene, but parent is not in the scene, break the relationship
        if (addedNode.parent && this.scene.getNodes().indexOf(addedNode.parent) === -1) {
            // Use setParent to keep transform if possible
            if (addedNode.setParent) addedNode.setParent(null);
            else addedNode.parent = null;
        }
    }
    /**
     * Removes all the assets in the container from the scene
     */ removeAllFromScene() {
        if (!this._isValidHierarchy()) (0, $bOhSV.Tools).Warn("SceneSerializer.removeAllFromScene: The Asset Container hierarchy is not valid.");
        this._wasAddedToScene = false;
        this.removeFromScene(null);
        if (this.environmentTexture === this.scene.environmentTexture) this.scene.environmentTexture = null;
        for (const component of this.scene._serializableComponents)component.removeFromContainer(this);
    }
    /**
     * Removes assets in the container from the scene
     * @param predicate defines a predicate used to select which entity will be added (can be null)
     */ removeFromScene(predicate = null) {
        this.cameras.forEach((o)=>{
            if (predicate && !predicate(o)) return;
            this.scene.removeCamera(o);
        });
        this.lights.forEach((o)=>{
            if (predicate && !predicate(o)) return;
            this.scene.removeLight(o);
        });
        this.meshes.forEach((o)=>{
            if (predicate && !predicate(o)) return;
            this.scene.removeMesh(o, true);
        });
        this.skeletons.forEach((o)=>{
            if (predicate && !predicate(o)) return;
            this.scene.removeSkeleton(o);
        });
        this.animations.forEach((o)=>{
            if (predicate && !predicate(o)) return;
            this.scene.removeAnimation(o);
        });
        this.animationGroups.forEach((o)=>{
            if (predicate && !predicate(o)) return;
            this.scene.removeAnimationGroup(o);
        });
        this.multiMaterials.forEach((o)=>{
            if (predicate && !predicate(o)) return;
            this.scene.removeMultiMaterial(o);
        });
        this.materials.forEach((o)=>{
            if (predicate && !predicate(o)) return;
            this.scene.removeMaterial(o);
        });
        this.morphTargetManagers.forEach((o)=>{
            if (predicate && !predicate(o)) return;
            this.scene.removeMorphTargetManager(o);
        });
        this.geometries.forEach((o)=>{
            if (predicate && !predicate(o)) return;
            this.scene.removeGeometry(o);
        });
        this.transformNodes.forEach((o)=>{
            if (predicate && !predicate(o)) return;
            this.scene.removeTransformNode(o);
        });
        this.actionManagers.forEach((o)=>{
            if (predicate && !predicate(o)) return;
            this.scene.removeActionManager(o);
        });
        this.textures.forEach((o)=>{
            if (predicate && !predicate(o)) return;
            this.scene.removeTexture(o);
        });
        this.reflectionProbes.forEach((o)=>{
            if (predicate && !predicate(o)) return;
            this.scene.removeReflectionProbe(o);
        });
    }
    /**
     * Disposes all the assets in the container
     */ dispose() {
        this.cameras.slice(0).forEach((o)=>{
            o.dispose();
        });
        this.cameras.length = 0;
        this.lights.slice(0).forEach((o)=>{
            o.dispose();
        });
        this.lights.length = 0;
        this.meshes.slice(0).forEach((o)=>{
            o.dispose();
        });
        this.meshes.length = 0;
        this.skeletons.slice(0).forEach((o)=>{
            o.dispose();
        });
        this.skeletons.length = 0;
        this.animationGroups.slice(0).forEach((o)=>{
            o.dispose();
        });
        this.animationGroups.length = 0;
        this.multiMaterials.slice(0).forEach((o)=>{
            o.dispose();
        });
        this.multiMaterials.length = 0;
        this.materials.slice(0).forEach((o)=>{
            o.dispose();
        });
        this.materials.length = 0;
        this.geometries.slice(0).forEach((o)=>{
            o.dispose();
        });
        this.geometries.length = 0;
        this.transformNodes.slice(0).forEach((o)=>{
            o.dispose();
        });
        this.transformNodes.length = 0;
        this.actionManagers.slice(0).forEach((o)=>{
            o.dispose();
        });
        this.actionManagers.length = 0;
        this.textures.slice(0).forEach((o)=>{
            o.dispose();
        });
        this.textures.length = 0;
        this.reflectionProbes.slice(0).forEach((o)=>{
            o.dispose();
        });
        this.reflectionProbes.length = 0;
        this.morphTargetManagers.slice(0).forEach((o)=>{
            o.dispose();
        });
        this.morphTargetManagers.length = 0;
        if (this.environmentTexture) {
            this.environmentTexture.dispose();
            this.environmentTexture = null;
        }
        for (const component of this.scene._serializableComponents)component.removeFromContainer(this, true);
        if (this._onContextRestoredObserver) {
            this.scene.getEngine().onContextRestoredObservable.remove(this._onContextRestoredObserver);
            this._onContextRestoredObserver = null;
        }
    }
    _moveAssets(sourceAssets, targetAssets, keepAssets) {
        if (!sourceAssets || !targetAssets) return;
        for (const asset of sourceAssets){
            let move = true;
            if (keepAssets) {
                for (const keepAsset of keepAssets)if (asset === keepAsset) {
                    move = false;
                    break;
                }
            }
            if (move) {
                targetAssets.push(asset);
                asset._parentContainer = this;
            }
        }
    }
    /**
     * Removes all the assets contained in the scene and adds them to the container.
     * @param keepAssets Set of assets to keep in the scene. (default: empty)
     */ moveAllFromScene(keepAssets) {
        this._wasAddedToScene = false;
        if (keepAssets === undefined) keepAssets = new $f213d1f9545bf37d$export$d2dab17973a1a538();
        for(const key in this)if (Object.prototype.hasOwnProperty.call(this, key)) {
            this[key] = this[key] || (key === "_environmentTexture" ? null : []);
            this._moveAssets(this.scene[key], this[key], keepAssets[key]);
        }
        this.environmentTexture = this.scene.environmentTexture;
        this.removeAllFromScene();
    }
    /**
     * Adds all meshes in the asset container to a root mesh that can be used to position all the contained meshes. The root mesh is then added to the front of the meshes in the assetContainer.
     * @returns the root mesh
     */ createRootMesh() {
        const rootMesh = new (0, $fbuqw.Mesh)("assetContainerRootMesh", this.scene);
        this.meshes.forEach((m)=>{
            if (!m.parent) rootMesh.addChild(m);
        });
        this.meshes.unshift(rootMesh);
        return rootMesh;
    }
    /**
     * Merge animations (direct and animation groups) from this asset container into a scene
     * @param scene is the instance of BABYLON.Scene to append to (default: last created scene)
     * @param animatables set of animatables to retarget to a node from the scene
     * @param targetConverter defines a function used to convert animation targets from the asset container to the scene (default: search node by name)
     * @returns an array of the new AnimationGroup added to the scene (empty array if none)
     */ mergeAnimationsTo(scene = (0, $ejQPp.EngineStore).LastCreatedScene, animatables, targetConverter = null) {
        if (!scene) {
            (0, $kVtWi.Logger).Error("No scene available to merge animations to");
            return [];
        }
        const _targetConverter = targetConverter ? targetConverter : (target)=>{
            let node = null;
            const targetProperty = target.animations.length ? target.animations[0].targetProperty : "";
            /*
            BabylonJS adds special naming to targets that are children of nodes.
            This name attempts to remove that special naming to get the parent nodes name in case the target
            can't be found in the node tree

            Ex: Torso_primitive0 likely points to a Mesh primitive. We take away primitive0 and are left with "Torso" which is the name
            of the primitive's parent.
        */ const name = target.name.split(".").join("").split("_primitive")[0];
            switch(targetProperty){
                case "position":
                case "rotationQuaternion":
                    node = scene.getTransformNodeByName(target.name) || scene.getTransformNodeByName(name);
                    break;
                case "influence":
                    node = scene.getMorphTargetByName(target.name) || scene.getMorphTargetByName(name);
                    break;
                default:
                    node = scene.getNodeByName(target.name) || scene.getNodeByName(name);
            }
            return node;
        };
        // Copy new node animations
        const nodesInAC = this.getNodes();
        nodesInAC.forEach((nodeInAC)=>{
            const nodeInScene = _targetConverter(nodeInAC);
            if (nodeInScene !== null) {
                // Remove old animations with same target property as a new one
                for (const animationInAC of nodeInAC.animations){
                    // Doing treatment on an array for safety measure
                    const animationsWithSameProperty = nodeInScene.animations.filter((animationInScene)=>{
                        return animationInScene.targetProperty === animationInAC.targetProperty;
                    });
                    for (const animationWithSameProperty of animationsWithSameProperty){
                        const index = nodeInScene.animations.indexOf(animationWithSameProperty, 0);
                        if (index > -1) nodeInScene.animations.splice(index, 1);
                    }
                }
                // Append new animations
                nodeInScene.animations = nodeInScene.animations.concat(nodeInAC.animations);
            }
        });
        const newAnimationGroups = [];
        // Copy new animation groups
        this.animationGroups.slice().forEach((animationGroupInAC)=>{
            // Clone the animation group and all its animatables
            newAnimationGroups.push(animationGroupInAC.clone(animationGroupInAC.name, _targetConverter));
            // Remove animatables related to the asset container
            animationGroupInAC.animatables.forEach((animatable)=>{
                animatable.stop();
            });
        });
        // Retarget animatables
        animatables.forEach((animatable)=>{
            const target = _targetConverter(animatable.target);
            if (target) {
                // Clone the animatable and retarget it
                scene.beginAnimation(target, animatable.fromFrame, animatable.toFrame, animatable.loopAnimation, animatable.speedRatio, animatable.onAnimationEnd ? animatable.onAnimationEnd : undefined, undefined, true, undefined, animatable.onAnimationLoop ? animatable.onAnimationLoop : undefined);
                // Stop animation for the target in the asset container
                scene.stopAnimation(animatable.target);
            }
        });
        return newAnimationGroups;
    }
    /**
     * @since 6.15.0
     * This method checks for any node that has no parent
     * and is not in the rootNodes array, and adds the node
     * there, if so.
     */ populateRootNodes() {
        this.rootNodes.length = 0;
        this.meshes.forEach((m)=>{
            if (!m.parent && this.rootNodes.indexOf(m) === -1) this.rootNodes.push(m);
        });
        this.transformNodes.forEach((t)=>{
            if (!t.parent && this.rootNodes.indexOf(t) === -1) this.rootNodes.push(t);
        });
        this.lights.forEach((l)=>{
            if (!l.parent && this.rootNodes.indexOf(l) === -1) this.rootNodes.push(l);
        });
        this.cameras.forEach((c)=>{
            if (!c.parent && this.rootNodes.indexOf(c) === -1) this.rootNodes.push(c);
        });
    }
    /**
     * @since 6.26.0
     * Given a root asset, this method will traverse its hierarchy and add it, its children and any materials/skeletons/animation groups to the container.
     * @param root root node
     */ addAllAssetsToContainer(root) {
        if (!root) return;
        const nodesToVisit = [];
        const visitedNodes = new Set();
        nodesToVisit.push(root);
        while(nodesToVisit.length > 0){
            const nodeToVisit = nodesToVisit.pop();
            if (nodeToVisit instanceof (0, $fbuqw.Mesh)) {
                if (nodeToVisit.geometry && this.geometries.indexOf(nodeToVisit.geometry) === -1) this.geometries.push(nodeToVisit.geometry);
                this.meshes.push(nodeToVisit);
            } else if (nodeToVisit instanceof (0, $klshO.TransformNode)) this.transformNodes.push(nodeToVisit);
            else if (nodeToVisit instanceof (0, $c6YWJ.Light)) this.lights.push(nodeToVisit);
            else if (nodeToVisit instanceof (0, $74SKQ.Camera)) this.cameras.push(nodeToVisit);
            if (nodeToVisit instanceof (0, $0cHNL.AbstractMesh)) {
                if (nodeToVisit.material && this.materials.indexOf(nodeToVisit.material) === -1) {
                    this.materials.push(nodeToVisit.material);
                    for (const texture of nodeToVisit.material.getActiveTextures())if (this.textures.indexOf(texture) === -1) this.textures.push(texture);
                }
                if (nodeToVisit.skeleton && this.skeletons.indexOf(nodeToVisit.skeleton) === -1) this.skeletons.push(nodeToVisit.skeleton);
                if (nodeToVisit.morphTargetManager && this.morphTargetManagers.indexOf(nodeToVisit.morphTargetManager) === -1) this.morphTargetManagers.push(nodeToVisit.morphTargetManager);
            }
            for (const child of nodeToVisit.getChildren())if (!visitedNodes.has(child)) nodesToVisit.push(child);
            visitedNodes.add(nodeToVisit);
        }
        this.populateRootNodes();
    }
}

});
parcelRegister("fbuqw", function(module, exports) {

$parcel$export(module.exports, "_CreationDataStorage", () => $b0df7c384622c537$export$40270a8f3a8ca785);
$parcel$export(module.exports, "_InstancesBatch", () => $b0df7c384622c537$export$5016a5ee8d7edd22);
$parcel$export(module.exports, "Mesh", () => $b0df7c384622c537$export$e176487c05830cc5);

var $diGQf = parcelRequire("diGQf");

var $bOhSV = parcelRequire("bOhSV");

var $fhgis = parcelRequire("fhgis");

var $7212E = parcelRequire("7212E");

var $4TYUE = parcelRequire("4TYUE");

var $74SKQ = parcelRequire("74SKQ");

var $gmbCk = parcelRequire("gmbCk");

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $bgssx = parcelRequire("bgssx");

var $b4i1f = parcelRequire("b4i1f");

var $5v6ry = parcelRequire("5v6ry");

var $FUHfe = parcelRequire("FUHfe");

var $0cHNL = parcelRequire("0cHNL");

var $lEBSs = parcelRequire("lEBSs");

var $54229 = parcelRequire("54229");

var $3zFLd = parcelRequire("3zFLd");

var $kixW2 = parcelRequire("kixW2");

var $6Ho1L = parcelRequire("6Ho1L");

var $kVtWi = parcelRequire("kVtWi");

var $8DoUR = parcelRequire("8DoUR");

var $dUFYy = parcelRequire("dUFYy");

var $bv05l = parcelRequire("bv05l");

var $8WG4F = parcelRequire("8WG4F");
class $b0df7c384622c537$export$40270a8f3a8ca785 {
}
/**
 * @internal
 **/ class $b0df7c384622c537$var$_InstanceDataStorage {
    constructor(){
        this.visibleInstances = {};
        this.batchCache = new $b0df7c384622c537$export$5016a5ee8d7edd22();
        this.batchCacheReplacementModeInFrozenMode = new $b0df7c384622c537$export$5016a5ee8d7edd22();
        this.instancesBufferSize = 2048; // let's start with a maximum of 32 instances
    }
}
class $b0df7c384622c537$export$5016a5ee8d7edd22 {
    constructor(){
        this.mustReturn = false;
        this.visibleInstances = new Array();
        this.renderSelf = [];
        this.hardwareInstancedRendering = [];
    }
}
/**
 * @internal
 **/ class $b0df7c384622c537$var$_ThinInstanceDataStorage {
    constructor(){
        this.instancesCount = 0;
        this.matrixBuffer = null;
        this.previousMatrixBuffer = null;
        this.matrixBufferSize = 512; // let's start with a maximum of 32 thin instances
        this.matrixData = null;
        this.boundingVectors = [];
        this.worldMatrices = null;
    }
}
/**
 * @internal
 **/ class $b0df7c384622c537$var$_InternalMeshDataInfo {
    constructor(){
        this._areNormalsFrozen = false; // Will be used by ribbons mainly
        // Will be used to save a source mesh reference, If any
        this._source = null;
        // Will be used to for fast cloned mesh lookup
        this.meshMap = null;
        this._preActivateId = -1;
        // eslint-disable-next-line @typescript-eslint/naming-convention
        this._LODLevels = new Array();
        /** Alternative definition of LOD level, using screen coverage instead of distance */ this._useLODScreenCoverage = false;
        this._effectiveMaterial = null;
        this._forcedInstanceCount = 0;
        this._overrideRenderingFillMode = null;
    }
}
class $b0df7c384622c537$export$e176487c05830cc5 extends (0, $0cHNL.AbstractMesh) {
    /**
     * Gets the default side orientation.
     * @param orientation the orientation to value to attempt to get
     * @returns the default orientation
     * @internal
     */ static _GetDefaultSideOrientation(orientation) {
        return orientation || $b0df7c384622c537$export$e176487c05830cc5.FRONTSIDE; // works as Mesh.FRONTSIDE is 0
    }
    /**
     * Determines if the LOD levels are intended to be calculated using screen coverage (surface area ratio) instead of distance.
     */ get useLODScreenCoverage() {
        return this._internalMeshDataInfo._useLODScreenCoverage;
    }
    set useLODScreenCoverage(value) {
        this._internalMeshDataInfo._useLODScreenCoverage = value;
        this._sortLODLevels();
    }
    get computeBonesUsingShaders() {
        return this._internalAbstractMeshDataInfo._computeBonesUsingShaders;
    }
    set computeBonesUsingShaders(value) {
        if (this._internalAbstractMeshDataInfo._computeBonesUsingShaders === value) return;
        if (value && this._internalMeshDataInfo._sourcePositions) {
            // switch from software to GPU computation: we need to reset the vertex and normal buffers that have been updated by the software process
            this.setVerticesData((0, $b4i1f.VertexBuffer).PositionKind, this._internalMeshDataInfo._sourcePositions, true);
            if (this._internalMeshDataInfo._sourceNormals) this.setVerticesData((0, $b4i1f.VertexBuffer).NormalKind, this._internalMeshDataInfo._sourceNormals, true);
            this._internalMeshDataInfo._sourcePositions = null;
            this._internalMeshDataInfo._sourceNormals = null;
        }
        this._internalAbstractMeshDataInfo._computeBonesUsingShaders = value;
        this._markSubMeshesAsAttributesDirty();
    }
    /**
     * An event triggered before rendering the mesh
     */ get onBeforeRenderObservable() {
        if (!this._internalMeshDataInfo._onBeforeRenderObservable) this._internalMeshDataInfo._onBeforeRenderObservable = new (0, $diGQf.Observable)();
        return this._internalMeshDataInfo._onBeforeRenderObservable;
    }
    /**
     * An event triggered before binding the mesh
     */ get onBeforeBindObservable() {
        if (!this._internalMeshDataInfo._onBeforeBindObservable) this._internalMeshDataInfo._onBeforeBindObservable = new (0, $diGQf.Observable)();
        return this._internalMeshDataInfo._onBeforeBindObservable;
    }
    /**
     * An event triggered after rendering the mesh
     */ get onAfterRenderObservable() {
        if (!this._internalMeshDataInfo._onAfterRenderObservable) this._internalMeshDataInfo._onAfterRenderObservable = new (0, $diGQf.Observable)();
        return this._internalMeshDataInfo._onAfterRenderObservable;
    }
    /**
     * An event triggeredbetween rendering pass when using separateCullingPass = true
     */ get onBetweenPassObservable() {
        if (!this._internalMeshDataInfo._onBetweenPassObservable) this._internalMeshDataInfo._onBetweenPassObservable = new (0, $diGQf.Observable)();
        return this._internalMeshDataInfo._onBetweenPassObservable;
    }
    /**
     * An event triggered before drawing the mesh
     */ get onBeforeDrawObservable() {
        if (!this._internalMeshDataInfo._onBeforeDrawObservable) this._internalMeshDataInfo._onBeforeDrawObservable = new (0, $diGQf.Observable)();
        return this._internalMeshDataInfo._onBeforeDrawObservable;
    }
    /**
     * Sets a callback to call before drawing the mesh. It is recommended to use onBeforeDrawObservable instead
     */ set onBeforeDraw(callback) {
        if (this._onBeforeDrawObserver) this.onBeforeDrawObservable.remove(this._onBeforeDrawObserver);
        this._onBeforeDrawObserver = this.onBeforeDrawObservable.add(callback);
    }
    get hasInstances() {
        return this.instances.length > 0;
    }
    get hasThinInstances() {
        return (this.forcedInstanceCount || this._thinInstanceDataStorage.instancesCount || 0) > 0;
    }
    /**
     * Gets or sets the forced number of instances to display.
     * If 0 (default value), the number of instances is not forced and depends on the draw type
     * (regular / instance / thin instances mesh)
     */ get forcedInstanceCount() {
        return this._internalMeshDataInfo._forcedInstanceCount;
    }
    set forcedInstanceCount(count) {
        this._internalMeshDataInfo._forcedInstanceCount = count;
    }
    /**
     * Use this property to override the Material's fillMode value
     */ get overrideRenderingFillMode() {
        return this._internalMeshDataInfo._overrideRenderingFillMode;
    }
    set overrideRenderingFillMode(fillMode) {
        this._internalMeshDataInfo._overrideRenderingFillMode = fillMode;
    }
    /**
     * Gets the source mesh (the one used to clone this one from)
     */ get source() {
        return this._internalMeshDataInfo._source;
    }
    /**
     * Gets the list of clones of this mesh
     * The scene must have been constructed with useClonedMeshMap=true for this to work!
     * Note that useClonedMeshMap=true is the default setting
     */ get cloneMeshMap() {
        return this._internalMeshDataInfo.meshMap;
    }
    /**
     * Gets or sets a boolean indicating that this mesh does not use index buffer
     */ get isUnIndexed() {
        return this._unIndexed;
    }
    set isUnIndexed(value) {
        if (this._unIndexed !== value) {
            this._unIndexed = value;
            this._markSubMeshesAsAttributesDirty();
        }
    }
    /** Gets the array buffer used to store the instanced buffer used for instances' world matrices */ get worldMatrixInstancedBuffer() {
        return this._instanceDataStorage.instancesData;
    }
    /** Gets the array buffer used to store the instanced buffer used for instances' previous world matrices */ get previousWorldMatrixInstancedBuffer() {
        return this._instanceDataStorage.instancesPreviousData;
    }
    /** Gets or sets a boolean indicating that the update of the instance buffer of the world matrices is manual */ get manualUpdateOfWorldMatrixInstancedBuffer() {
        return this._instanceDataStorage.manualUpdate;
    }
    set manualUpdateOfWorldMatrixInstancedBuffer(value) {
        this._instanceDataStorage.manualUpdate = value;
    }
    /** Gets or sets a boolean indicating that the update of the instance buffer of the world matrices is manual */ get manualUpdateOfPreviousWorldMatrixInstancedBuffer() {
        return this._instanceDataStorage.previousManualUpdate;
    }
    set manualUpdateOfPreviousWorldMatrixInstancedBuffer(value) {
        this._instanceDataStorage.previousManualUpdate = value;
    }
    /** Gets or sets a boolean indicating that the update of the instance buffer of the world matrices must be performed in all cases (and notably even in frozen mode) */ get forceWorldMatrixInstancedBufferUpdate() {
        return this._instanceDataStorage.forceMatrixUpdates;
    }
    set forceWorldMatrixInstancedBufferUpdate(value) {
        this._instanceDataStorage.forceMatrixUpdates = value;
    }
    /**
     * @constructor
     * @param name The value used by scene.getMeshByName() to do a lookup.
     * @param scene The scene to add this mesh to.
     * @param parent The parent of this mesh, if it has one
     * @param source An optional Mesh from which geometry is shared, cloned.
     * @param doNotCloneChildren When cloning, skip cloning child meshes of source, default False.
     *                  When false, achieved by calling a clone(), also passing False.
     *                  This will make creation of children, recursive.
     * @param clonePhysicsImpostor When cloning, include cloning mesh physics impostor, default True.
     */ constructor(name, scene = null, parent = null, source = null, doNotCloneChildren, clonePhysicsImpostor = true){
        super(name, scene);
        // Internal data
        this._internalMeshDataInfo = new $b0df7c384622c537$var$_InternalMeshDataInfo();
        // Members
        /**
         * Gets the delay loading state of the mesh (when delay loading is turned on)
         * @see https://doc.babylonjs.com/features/featuresDeepDive/importers/incrementalLoading
         */ this.delayLoadState = 0;
        /**
         * Gets the list of instances created from this mesh
         * it is not supposed to be modified manually.
         * Note also that the order of the InstancedMesh wihin the array is not significant and might change.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/copies/instances
         */ this.instances = [];
        // Private
        /** @internal */ this._creationDataStorage = null;
        /** @internal */ this._geometry = null;
        /** @internal */ this._instanceDataStorage = new $b0df7c384622c537$var$_InstanceDataStorage();
        /** @internal */ this._thinInstanceDataStorage = new $b0df7c384622c537$var$_ThinInstanceDataStorage();
        /** @internal */ this._shouldGenerateFlatShading = false;
        // Use by builder only to know what orientation were the mesh build in.
        /** @internal */ this._originalBuilderSideOrientation = $b0df7c384622c537$export$e176487c05830cc5.DEFAULTSIDE;
        /**
         * Use this property to change the original side orientation defined at construction time
         */ this.overrideMaterialSideOrientation = null;
        /**
         * Gets or sets a boolean indicating whether to render ignoring the active camera's max z setting. (false by default)
         * You should not mix meshes that have this property set to true with meshes that have it set to false if they all write
         * to the depth buffer, because the z-values are not comparable in the two cases and you will get rendering artifacts if you do.
         * You can set the property to true for meshes that do not write to the depth buffer, or set the same value (either false or true) otherwise.
         * Note this will reduce performance when set to true.
         */ this.ignoreCameraMaxZ = false;
        scene = this.getScene();
        this._onBeforeDraw = (isInstance, world, effectiveMaterial)=>{
            if (isInstance && effectiveMaterial) {
                if (this._uniformBuffer) this.transferToEffect(world);
                else effectiveMaterial.bindOnlyWorldMatrix(world);
            }
        };
        if (source) {
            // Geometry
            if (source._geometry) source._geometry.applyToMesh(this);
            // Deep copy
            (0, $fhgis.DeepCopier).DeepCopy(source, this, [
                "name",
                "material",
                "skeleton",
                "instances",
                "parent",
                "uniqueId",
                "source",
                "metadata",
                "morphTargetManager",
                "hasInstances",
                "worldMatrixInstancedBuffer",
                "previousWorldMatrixInstancedBuffer",
                "hasLODLevels",
                "geometry",
                "isBlocked",
                "areNormalsFrozen",
                "facetNb",
                "isFacetDataEnabled",
                "lightSources",
                "useBones",
                "isAnInstance",
                "collider",
                "edgesRenderer",
                "forward",
                "up",
                "right",
                "absolutePosition",
                "absoluteScaling",
                "absoluteRotationQuaternion",
                "isWorldMatrixFrozen",
                "nonUniformScaling",
                "behaviors",
                "worldMatrixFromCache",
                "hasThinInstances",
                "cloneMeshMap",
                "hasBoundingInfo",
                "physicsBody",
                "physicsImpostor"
            ], [
                "_poseMatrix"
            ]);
            // Source mesh
            this._internalMeshDataInfo._source = source;
            if (scene.useClonedMeshMap) {
                if (!source._internalMeshDataInfo.meshMap) source._internalMeshDataInfo.meshMap = {};
                source._internalMeshDataInfo.meshMap[this.uniqueId] = this;
            }
            // Construction Params
            // Clone parameters allowing mesh to be updated in case of parametric shapes.
            this._originalBuilderSideOrientation = source._originalBuilderSideOrientation;
            this._creationDataStorage = source._creationDataStorage;
            // Animation ranges
            if (source._ranges) {
                const ranges = source._ranges;
                for(const name in ranges){
                    if (!Object.prototype.hasOwnProperty.call(ranges, name)) continue;
                    if (!ranges[name]) continue;
                    this.createAnimationRange(name, ranges[name].from, ranges[name].to);
                }
            }
            // Metadata
            if (source.metadata && source.metadata.clone) this.metadata = source.metadata.clone();
            else this.metadata = source.metadata;
            this._internalMetadata = source._internalMetadata;
            // Tags
            if ((0, $7212E.Tags) && (0, $7212E.Tags).HasTags(source)) (0, $7212E.Tags).AddTagsTo(this, (0, $7212E.Tags).GetTags(source, true));
            // Enabled. We shouldn't need to check the source's ancestors, as this mesh
            // will have the same ones.
            this.setEnabled(source.isEnabled(false));
            // Parent
            this.parent = source.parent;
            // Pivot
            this.setPivotMatrix(source.getPivotMatrix(), this._postMultiplyPivotMatrix);
            this.id = name + "." + source.id;
            // Material
            this.material = source.material;
            if (!doNotCloneChildren) {
                // Children
                const directDescendants = source.getDescendants(true);
                for(let index = 0; index < directDescendants.length; index++){
                    const child = directDescendants[index];
                    if (child.clone) child.clone(name + "." + child.name, this);
                }
            }
            // Morphs
            if (source.morphTargetManager) this.morphTargetManager = source.morphTargetManager;
            // Physics clone
            if (scene.getPhysicsEngine) {
                const physicsEngine = scene.getPhysicsEngine();
                if (clonePhysicsImpostor && physicsEngine) {
                    if (physicsEngine.getPluginVersion() === 1) {
                        const impostor = physicsEngine.getImpostorForPhysicsObject(source);
                        if (impostor) this.physicsImpostor = impostor.clone(this);
                    } else if (physicsEngine.getPluginVersion() === 2) {
                        if (source.physicsBody) source.physicsBody.clone(this);
                    }
                }
            }
            // Particles
            for(let index = 0; index < scene.particleSystems.length; index++){
                const system = scene.particleSystems[index];
                if (system.emitter === source) system.clone(system.name, this);
            }
            // Skeleton
            this.skeleton = source.skeleton;
            this.refreshBoundingInfo(true, true);
            this.computeWorldMatrix(true);
        }
        // Parent
        if (parent !== null) this.parent = parent;
        this._instanceDataStorage.hardwareInstancedRendering = this.getEngine().getCaps().instancedArrays;
        this._internalMeshDataInfo._onMeshReadyObserverAdded = (observer)=>{
            // only notify once! then unregister the observer
            observer.unregisterOnNextCall = true;
            if (this.isReady(true)) this.onMeshReadyObservable.notifyObservers(this);
            else if (!this._internalMeshDataInfo._checkReadinessObserver) this._internalMeshDataInfo._checkReadinessObserver = this._scene.onBeforeRenderObservable.add(()=>{
                // check for complete readiness
                if (this.isReady(true)) {
                    this._scene.onBeforeRenderObservable.remove(this._internalMeshDataInfo._checkReadinessObserver);
                    this._internalMeshDataInfo._checkReadinessObserver = null;
                    this.onMeshReadyObservable.notifyObservers(this);
                }
            });
        };
        this.onMeshReadyObservable = new (0, $diGQf.Observable)(this._internalMeshDataInfo._onMeshReadyObserverAdded);
        if (source) source.onClonedObservable.notifyObservers(this);
    }
    instantiateHierarchy(newParent = null, options, onNewNodeCreated) {
        const instance = this.getTotalVertices() === 0 || options && options.doNotInstantiate && (options.doNotInstantiate === true || options.doNotInstantiate(this)) ? this.clone("Clone of " + (this.name || this.id), newParent || this.parent, true) : this.createInstance("instance of " + (this.name || this.id));
        instance.parent = newParent || this.parent;
        instance.position = this.position.clone();
        instance.scaling = this.scaling.clone();
        if (this.rotationQuaternion) instance.rotationQuaternion = this.rotationQuaternion.clone();
        else instance.rotation = this.rotation.clone();
        if (onNewNodeCreated) onNewNodeCreated(this, instance);
        for (const child of this.getChildTransformNodes(true))// instancedMesh should have a different sourced mesh
        if (child.getClassName() === "InstancedMesh" && instance.getClassName() === "Mesh" && child.sourceMesh === this) child.instantiateHierarchy(instance, {
            doNotInstantiate: options && options.doNotInstantiate || false,
            newSourcedMesh: instance
        }, onNewNodeCreated);
        else child.instantiateHierarchy(instance, options, onNewNodeCreated);
        return instance;
    }
    /**
     * Gets the class name
     * @returns the string "Mesh".
     */ getClassName() {
        return "Mesh";
    }
    /** @internal */ get _isMesh() {
        return true;
    }
    /**
     * Returns a description of this mesh
     * @param fullDetails define if full details about this mesh must be used
     * @returns a descriptive string representing this mesh
     */ toString(fullDetails) {
        let ret = super.toString(fullDetails);
        ret += ", n vertices: " + this.getTotalVertices();
        ret += ", parent: " + (this._waitingParentId ? this._waitingParentId : this.parent ? this.parent.name : "NONE");
        if (this.animations) for(let i = 0; i < this.animations.length; i++)ret += ", animation[0]: " + this.animations[i].toString(fullDetails);
        if (fullDetails) {
            if (this._geometry) {
                const ib = this.getIndices();
                const vb = this.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
                if (vb && ib) ret += ", flat shading: " + (vb.length / 3 === ib.length ? "YES" : "NO");
            } else ret += ", flat shading: UNKNOWN";
        }
        return ret;
    }
    /** @internal */ _unBindEffect() {
        super._unBindEffect();
        for (const instance of this.instances)instance._unBindEffect();
    }
    /**
     * Gets a boolean indicating if this mesh has LOD
     */ get hasLODLevels() {
        return this._internalMeshDataInfo._LODLevels.length > 0;
    }
    /**
     * Gets the list of MeshLODLevel associated with the current mesh
     * @returns an array of MeshLODLevel
     */ getLODLevels() {
        return this._internalMeshDataInfo._LODLevels;
    }
    _sortLODLevels() {
        const sortingOrderFactor = this._internalMeshDataInfo._useLODScreenCoverage ? -1 : 1;
        this._internalMeshDataInfo._LODLevels.sort((a, b)=>{
            if (a.distanceOrScreenCoverage < b.distanceOrScreenCoverage) return sortingOrderFactor;
            if (a.distanceOrScreenCoverage > b.distanceOrScreenCoverage) return -sortingOrderFactor;
            return 0;
        });
    }
    /**
     * Add a mesh as LOD level triggered at the given distance.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/LOD
     * @param distanceOrScreenCoverage Either distance from the center of the object to show this level or the screen coverage if `useScreenCoverage` is set to `true`.
     * If screen coverage, value is a fraction of the screen's total surface, between 0 and 1.
     * Example Playground for distance https://playground.babylonjs.com/#QE7KM#197
     * Example Playground for screen coverage https://playground.babylonjs.com/#QE7KM#196
     * @param mesh The mesh to be added as LOD level (can be null)
     * @returns This mesh (for chaining)
     */ addLODLevel(distanceOrScreenCoverage, mesh) {
        if (mesh && mesh._masterMesh) {
            (0, $kVtWi.Logger).Warn("You cannot use a mesh as LOD level twice");
            return this;
        }
        const level = new (0, $8WG4F.MeshLODLevel)(distanceOrScreenCoverage, mesh);
        this._internalMeshDataInfo._LODLevels.push(level);
        if (mesh) mesh._masterMesh = this;
        this._sortLODLevels();
        return this;
    }
    /**
     * Returns the LOD level mesh at the passed distance or null if not found.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/LOD
     * @param distance The distance from the center of the object to show this level
     * @returns a Mesh or `null`
     */ getLODLevelAtDistance(distance) {
        const internalDataInfo = this._internalMeshDataInfo;
        for(let index = 0; index < internalDataInfo._LODLevels.length; index++){
            const level = internalDataInfo._LODLevels[index];
            if (level.distanceOrScreenCoverage === distance) return level.mesh;
        }
        return null;
    }
    /**
     * Remove a mesh from the LOD array
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/LOD
     * @param mesh defines the mesh to be removed
     * @returns This mesh (for chaining)
     */ removeLODLevel(mesh) {
        const internalDataInfo = this._internalMeshDataInfo;
        for(let index = 0; index < internalDataInfo._LODLevels.length; index++)if (internalDataInfo._LODLevels[index].mesh === mesh) {
            internalDataInfo._LODLevels.splice(index, 1);
            if (mesh) mesh._masterMesh = null;
        }
        this._sortLODLevels();
        return this;
    }
    /**
     * Returns the registered LOD mesh distant from the parameter `camera` position if any, else returns the current mesh.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/LOD
     * @param camera defines the camera to use to compute distance
     * @param boundingSphere defines a custom bounding sphere to use instead of the one from this mesh
     * @returns This mesh (for chaining)
     */ getLOD(camera, boundingSphere) {
        const internalDataInfo = this._internalMeshDataInfo;
        if (!internalDataInfo._LODLevels || internalDataInfo._LODLevels.length === 0) return this;
        const bSphere = boundingSphere || this.getBoundingInfo().boundingSphere;
        const distanceToCamera = camera.mode === (0, $74SKQ.Camera).ORTHOGRAPHIC_CAMERA ? camera.minZ : bSphere.centerWorld.subtract(camera.globalPosition).length();
        let compareValue = distanceToCamera;
        let compareSign = 1;
        if (internalDataInfo._useLODScreenCoverage) {
            const screenArea = camera.screenArea;
            let meshArea = bSphere.radiusWorld * camera.minZ / distanceToCamera;
            meshArea = meshArea * meshArea * Math.PI;
            compareValue = meshArea / screenArea;
            compareSign = -1;
        }
        if (compareSign * internalDataInfo._LODLevels[internalDataInfo._LODLevels.length - 1].distanceOrScreenCoverage > compareSign * compareValue) {
            if (this.onLODLevelSelection) this.onLODLevelSelection(compareValue, this, this);
            return this;
        }
        for(let index = 0; index < internalDataInfo._LODLevels.length; index++){
            const level = internalDataInfo._LODLevels[index];
            if (compareSign * level.distanceOrScreenCoverage < compareSign * compareValue) {
                if (level.mesh) {
                    if (level.mesh.delayLoadState === 4) {
                        level.mesh._checkDelayState();
                        return this;
                    }
                    if (level.mesh.delayLoadState === 2) return this;
                    level.mesh._preActivate();
                    level.mesh._updateSubMeshesBoundingInfo(this.worldMatrixFromCache);
                }
                if (this.onLODLevelSelection) this.onLODLevelSelection(compareValue, this, level.mesh);
                return level.mesh;
            }
        }
        if (this.onLODLevelSelection) this.onLODLevelSelection(compareValue, this, this);
        return this;
    }
    /**
     * Gets the mesh internal Geometry object
     */ get geometry() {
        return this._geometry;
    }
    /**
     * Returns the total number of vertices within the mesh geometry or zero if the mesh has no geometry.
     * @returns the total number of vertices
     */ getTotalVertices() {
        if (this._geometry === null || this._geometry === undefined) return 0;
        return this._geometry.getTotalVertices();
    }
    /**
     * Returns the content of an associated vertex buffer
     * @param kind defines which buffer to read from (positions, indices, normals, etc). Possible `kind` values :
     * - VertexBuffer.PositionKind
     * - VertexBuffer.UVKind
     * - VertexBuffer.UV2Kind
     * - VertexBuffer.UV3Kind
     * - VertexBuffer.UV4Kind
     * - VertexBuffer.UV5Kind
     * - VertexBuffer.UV6Kind
     * - VertexBuffer.ColorKind
     * - VertexBuffer.MatricesIndicesKind
     * - VertexBuffer.MatricesIndicesExtraKind
     * - VertexBuffer.MatricesWeightsKind
     * - VertexBuffer.MatricesWeightsExtraKind
     * @param copyWhenShared defines a boolean indicating that if the mesh geometry is shared among some other meshes, the returned array is a copy of the internal one
     * @param forceCopy defines a boolean forcing the copy of the buffer no matter what the value of copyWhenShared is
     * @param bypassInstanceData defines a boolean indicating that the function should not take into account the instance data (applies only if the mesh has instances). Default: false
     * @returns a FloatArray or null if the mesh has no geometry or no vertex buffer for this kind.
     */ getVerticesData(kind, copyWhenShared, forceCopy, bypassInstanceData) {
        if (!this._geometry) return null;
        let data = bypassInstanceData ? undefined : this._userInstancedBuffersStorage?.vertexBuffers[kind]?.getFloatData(this.instances.length + 1, forceCopy || copyWhenShared && this._geometry.meshes.length !== 1);
        if (!data) data = this._geometry.getVerticesData(kind, copyWhenShared, forceCopy);
        return data;
    }
    /**
     * Returns the mesh VertexBuffer object from the requested `kind`
     * @param kind defines which buffer to read from (positions, indices, normals, etc). Possible `kind` values :
     * - VertexBuffer.PositionKind
     * - VertexBuffer.NormalKind
     * - VertexBuffer.UVKind
     * - VertexBuffer.UV2Kind
     * - VertexBuffer.UV3Kind
     * - VertexBuffer.UV4Kind
     * - VertexBuffer.UV5Kind
     * - VertexBuffer.UV6Kind
     * - VertexBuffer.ColorKind
     * - VertexBuffer.MatricesIndicesKind
     * - VertexBuffer.MatricesIndicesExtraKind
     * - VertexBuffer.MatricesWeightsKind
     * - VertexBuffer.MatricesWeightsExtraKind
     * @param bypassInstanceData defines a boolean indicating that the function should not take into account the instance data (applies only if the mesh has instances). Default: false
     * @returns a FloatArray or null if the mesh has no vertex buffer for this kind.
     */ getVertexBuffer(kind, bypassInstanceData) {
        if (!this._geometry) return null;
        return (bypassInstanceData ? undefined : this._userInstancedBuffersStorage?.vertexBuffers[kind]) ?? this._geometry.getVertexBuffer(kind);
    }
    /**
     * Tests if a specific vertex buffer is associated with this mesh
     * @param kind defines which buffer to check (positions, indices, normals, etc). Possible `kind` values :
     * - VertexBuffer.PositionKind
     * - VertexBuffer.NormalKind
     * - VertexBuffer.UVKind
     * - VertexBuffer.UV2Kind
     * - VertexBuffer.UV3Kind
     * - VertexBuffer.UV4Kind
     * - VertexBuffer.UV5Kind
     * - VertexBuffer.UV6Kind
     * - VertexBuffer.ColorKind
     * - VertexBuffer.MatricesIndicesKind
     * - VertexBuffer.MatricesIndicesExtraKind
     * - VertexBuffer.MatricesWeightsKind
     * - VertexBuffer.MatricesWeightsExtraKind
     * @param bypassInstanceData defines a boolean indicating that the function should not take into account the instance data (applies only if the mesh has instances). Default: false
     * @returns a boolean
     */ isVerticesDataPresent(kind, bypassInstanceData) {
        if (!this._geometry) {
            if (this._delayInfo) return this._delayInfo.indexOf(kind) !== -1;
            return false;
        }
        return !bypassInstanceData && this._userInstancedBuffersStorage?.vertexBuffers[kind] !== undefined || this._geometry.isVerticesDataPresent(kind);
    }
    /**
     * Returns a boolean defining if the vertex data for the requested `kind` is updatable.
     * @param kind defines which buffer to check (positions, indices, normals, etc). Possible `kind` values :
     * - VertexBuffer.PositionKind
     * - VertexBuffer.UVKind
     * - VertexBuffer.UV2Kind
     * - VertexBuffer.UV3Kind
     * - VertexBuffer.UV4Kind
     * - VertexBuffer.UV5Kind
     * - VertexBuffer.UV6Kind
     * - VertexBuffer.ColorKind
     * - VertexBuffer.MatricesIndicesKind
     * - VertexBuffer.MatricesIndicesExtraKind
     * - VertexBuffer.MatricesWeightsKind
     * - VertexBuffer.MatricesWeightsExtraKind
     * @param bypassInstanceData defines a boolean indicating that the function should not take into account the instance data (applies only if the mesh has instances). Default: false
     * @returns a boolean
     */ isVertexBufferUpdatable(kind, bypassInstanceData) {
        if (!this._geometry) {
            if (this._delayInfo) return this._delayInfo.indexOf(kind) !== -1;
            return false;
        }
        if (!bypassInstanceData) {
            const buffer = this._userInstancedBuffersStorage?.vertexBuffers[kind];
            if (buffer) return buffer.isUpdatable();
        }
        return this._geometry.isVertexBufferUpdatable(kind);
    }
    /**
     * Returns a string which contains the list of existing `kinds` of Vertex Data associated with this mesh.
     * @param bypassInstanceData defines a boolean indicating that the function should not take into account the instance data (applies only if the mesh has instances). Default: false
     * @returns an array of strings
     */ getVerticesDataKinds(bypassInstanceData) {
        if (!this._geometry) {
            const result = [];
            if (this._delayInfo) this._delayInfo.forEach(function(kind) {
                result.push(kind);
            });
            return result;
        }
        const kinds = this._geometry.getVerticesDataKinds();
        if (!bypassInstanceData && this._userInstancedBuffersStorage) {
            for(const kind in this._userInstancedBuffersStorage.vertexBuffers)if (kinds.indexOf(kind) === -1) kinds.push(kind);
        }
        return kinds;
    }
    /**
     * Returns a positive integer : the total number of indices in this mesh geometry.
     * @returns the numner of indices or zero if the mesh has no geometry.
     */ getTotalIndices() {
        if (!this._geometry) return 0;
        return this._geometry.getTotalIndices();
    }
    /**
     * Returns an array of integers or a typed array (Int32Array, Uint32Array, Uint16Array) populated with the mesh indices.
     * @param copyWhenShared If true (default false) and and if the mesh geometry is shared among some other meshes, the returned array is a copy of the internal one.
     * @param forceCopy defines a boolean indicating that the returned array must be cloned upon returning it
     * @returns the indices array or an empty array if the mesh has no geometry
     */ getIndices(copyWhenShared, forceCopy) {
        if (!this._geometry) return [];
        return this._geometry.getIndices(copyWhenShared, forceCopy);
    }
    get isBlocked() {
        return this._masterMesh !== null && this._masterMesh !== undefined;
    }
    /**
     * Determine if the current mesh is ready to be rendered
     * @param completeCheck defines if a complete check (including materials and lights) has to be done (false by default)
     * @param forceInstanceSupport will check if the mesh will be ready when used with instances (false by default)
     * @returns true if all associated assets are ready (material, textures, shaders)
     */ isReady(completeCheck = false, forceInstanceSupport = false) {
        if (this.delayLoadState === 2) return false;
        if (!super.isReady(completeCheck)) return false;
        if (!this.subMeshes || this.subMeshes.length === 0) return true;
        if (!completeCheck) return true;
        const engine = this.getEngine();
        const scene = this.getScene();
        const hardwareInstancedRendering = forceInstanceSupport || engine.getCaps().instancedArrays && (this.instances.length > 0 || this.hasThinInstances);
        this.computeWorldMatrix();
        const mat = this.material || scene.defaultMaterial;
        if (mat) {
            if (mat._storeEffectOnSubMeshes) for (const subMesh of this.subMeshes){
                const effectiveMaterial = subMesh.getMaterial();
                if (effectiveMaterial) {
                    if (effectiveMaterial._storeEffectOnSubMeshes) {
                        if (!effectiveMaterial.isReadyForSubMesh(this, subMesh, hardwareInstancedRendering)) return false;
                    } else {
                        if (!effectiveMaterial.isReady(this, hardwareInstancedRendering)) return false;
                    }
                }
            }
            else {
                if (!mat.isReady(this, hardwareInstancedRendering)) return false;
            }
        }
        // Shadows
        const currentRenderPassId = engine.currentRenderPassId;
        for (const light of this.lightSources){
            const generators = light.getShadowGenerators();
            if (!generators) continue;
            const iterator = generators.values();
            for(let key = iterator.next(); key.done !== true; key = iterator.next()){
                const generator = key.value;
                if (generator && (!generator.getShadowMap()?.renderList || generator.getShadowMap()?.renderList && generator.getShadowMap()?.renderList?.indexOf(this) !== -1)) {
                    const shadowMap = generator.getShadowMap();
                    const renderPassIds = shadowMap.renderPassIds ?? [
                        engine.currentRenderPassId
                    ];
                    for(let p = 0; p < renderPassIds.length; ++p){
                        engine.currentRenderPassId = renderPassIds[p];
                        for (const subMesh of this.subMeshes)if (!generator.isReady(subMesh, hardwareInstancedRendering, subMesh.getMaterial()?.needAlphaBlendingForMesh(this) ?? false)) {
                            engine.currentRenderPassId = currentRenderPassId;
                            return false;
                        }
                    }
                    engine.currentRenderPassId = currentRenderPassId;
                }
            }
        }
        // LOD
        for (const lod of this._internalMeshDataInfo._LODLevels){
            if (lod.mesh && !lod.mesh.isReady(hardwareInstancedRendering)) return false;
        }
        return true;
    }
    /**
     * Gets a boolean indicating if the normals aren't to be recomputed on next mesh `positions` array update. This property is pertinent only for updatable parametric shapes.
     */ get areNormalsFrozen() {
        return this._internalMeshDataInfo._areNormalsFrozen;
    }
    /**
     * This function affects parametric shapes on vertex position update only : ribbons, tubes, etc. It has no effect at all on other shapes. It prevents the mesh normals from being recomputed on next `positions` array update.
     * @returns the current mesh
     */ freezeNormals() {
        this._internalMeshDataInfo._areNormalsFrozen = true;
        return this;
    }
    /**
     * This function affects parametric shapes on vertex position update only : ribbons, tubes, etc. It has no effect at all on other shapes. It reactivates the mesh normals computation if it was previously frozen
     * @returns the current mesh
     */ unfreezeNormals() {
        this._internalMeshDataInfo._areNormalsFrozen = false;
        return this;
    }
    /**
     * Sets a value overriding the instance count. Only applicable when custom instanced InterleavedVertexBuffer are used rather than InstancedMeshs
     */ set overridenInstanceCount(count) {
        this._instanceDataStorage.overridenInstanceCount = count;
    }
    // Methods
    /** @internal */ _preActivate() {
        const internalDataInfo = this._internalMeshDataInfo;
        const sceneRenderId = this.getScene().getRenderId();
        if (internalDataInfo._preActivateId === sceneRenderId) return this;
        internalDataInfo._preActivateId = sceneRenderId;
        this._instanceDataStorage.visibleInstances = null;
        return this;
    }
    /**
     * @internal
     */ _preActivateForIntermediateRendering(renderId) {
        if (this._instanceDataStorage.visibleInstances) this._instanceDataStorage.visibleInstances.intermediateDefaultRenderId = renderId;
        return this;
    }
    /**
     * @internal
     */ _registerInstanceForRenderId(instance, renderId) {
        if (!this._instanceDataStorage.visibleInstances) this._instanceDataStorage.visibleInstances = {
            defaultRenderId: renderId,
            selfDefaultRenderId: this._renderId
        };
        if (!this._instanceDataStorage.visibleInstances[renderId]) {
            if (this._instanceDataStorage.previousRenderId !== undefined && this._instanceDataStorage.isFrozen) this._instanceDataStorage.visibleInstances[this._instanceDataStorage.previousRenderId] = null;
            this._instanceDataStorage.previousRenderId = renderId;
            this._instanceDataStorage.visibleInstances[renderId] = new Array();
        }
        this._instanceDataStorage.visibleInstances[renderId].push(instance);
        return this;
    }
    _afterComputeWorldMatrix() {
        super._afterComputeWorldMatrix();
        if (!this.hasThinInstances) return;
        if (!this.doNotSyncBoundingInfo) this.thinInstanceRefreshBoundingInfo(false);
    }
    /** @internal */ _postActivate() {
        if (this.edgesShareWithInstances && this.edgesRenderer && this.edgesRenderer.isEnabled && this._renderingGroup) {
            this._renderingGroup._edgesRenderers.pushNoDuplicate(this.edgesRenderer);
            this.edgesRenderer.customInstances.push(this.getWorldMatrix());
        }
    }
    /**
     * This method recomputes and sets a new BoundingInfo to the mesh unless it is locked.
     * This means the mesh underlying bounding box and sphere are recomputed.
     * @param applySkeleton defines whether to apply the skeleton before computing the bounding info
     * @param applyMorph  defines whether to apply the morph target before computing the bounding info
     * @returns the current mesh
     */ refreshBoundingInfo(applySkeleton = false, applyMorph = false) {
        if (this.hasBoundingInfo && this.getBoundingInfo().isLocked) return this;
        const bias = this.geometry ? this.geometry.boundingBias : null;
        this._refreshBoundingInfo(this._getPositionData(applySkeleton, applyMorph), bias);
        return this;
    }
    /**
     * @internal
     */ _createGlobalSubMesh(force) {
        const totalVertices = this.getTotalVertices();
        if (!totalVertices || !this.getIndices()) return null;
        // Check if we need to recreate the submeshes
        if (this.subMeshes && this.subMeshes.length > 0) {
            const ib = this.getIndices();
            if (!ib) return null;
            const totalIndices = ib.length;
            let needToRecreate = false;
            if (force) needToRecreate = true;
            else for (const submesh of this.subMeshes){
                if (submesh.indexStart + submesh.indexCount > totalIndices) {
                    needToRecreate = true;
                    break;
                }
                if (submesh.verticesStart + submesh.verticesCount > totalVertices) {
                    needToRecreate = true;
                    break;
                }
            }
            if (!needToRecreate) return this.subMeshes[0];
        }
        this.releaseSubMeshes();
        return new (0, $lEBSs.SubMesh)(0, 0, totalVertices, 0, this.getTotalIndices(), this);
    }
    /**
     * This function will subdivide the mesh into multiple submeshes
     * @param count defines the expected number of submeshes
     */ subdivide(count) {
        if (count < 1) return;
        const totalIndices = this.getTotalIndices();
        let subdivisionSize = totalIndices / count | 0;
        let offset = 0;
        // Ensure that subdivisionSize is a multiple of 3
        while(subdivisionSize % 3 !== 0)subdivisionSize++;
        this.releaseSubMeshes();
        for(let index = 0; index < count; index++){
            if (offset >= totalIndices) break;
            (0, $lEBSs.SubMesh).CreateFromIndices(0, offset, index === count - 1 ? totalIndices - offset : subdivisionSize, this, undefined, false);
            offset += subdivisionSize;
        }
        this.refreshBoundingInfo();
        this.synchronizeInstances();
    }
    /**
     * Copy a FloatArray into a specific associated vertex buffer
     * @param kind defines which buffer to write to (positions, indices, normals, etc). Possible `kind` values :
     * - VertexBuffer.PositionKind
     * - VertexBuffer.UVKind
     * - VertexBuffer.UV2Kind
     * - VertexBuffer.UV3Kind
     * - VertexBuffer.UV4Kind
     * - VertexBuffer.UV5Kind
     * - VertexBuffer.UV6Kind
     * - VertexBuffer.ColorKind
     * - VertexBuffer.MatricesIndicesKind
     * - VertexBuffer.MatricesIndicesExtraKind
     * - VertexBuffer.MatricesWeightsKind
     * - VertexBuffer.MatricesWeightsExtraKind
     * @param data defines the data source
     * @param updatable defines if the updated vertex buffer must be flagged as updatable
     * @param stride defines the data stride size (can be null)
     * @returns the current mesh
     */ setVerticesData(kind, data, updatable = false, stride) {
        if (!this._geometry) {
            const vertexData = new (0, $5v6ry.VertexData)();
            vertexData.set(data, kind);
            const scene = this.getScene();
            new (0, $FUHfe.Geometry)((0, $FUHfe.Geometry).RandomId(), scene, vertexData, updatable, this);
        } else this._geometry.setVerticesData(kind, data, updatable, stride);
        return this;
    }
    /**
     * Delete a vertex buffer associated with this mesh
     * @param kind defines which buffer to delete (positions, indices, normals, etc). Possible `kind` values :
     * - VertexBuffer.PositionKind
     * - VertexBuffer.UVKind
     * - VertexBuffer.UV2Kind
     * - VertexBuffer.UV3Kind
     * - VertexBuffer.UV4Kind
     * - VertexBuffer.UV5Kind
     * - VertexBuffer.UV6Kind
     * - VertexBuffer.ColorKind
     * - VertexBuffer.MatricesIndicesKind
     * - VertexBuffer.MatricesIndicesExtraKind
     * - VertexBuffer.MatricesWeightsKind
     * - VertexBuffer.MatricesWeightsExtraKind
     */ removeVerticesData(kind) {
        if (!this._geometry) return;
        this._geometry.removeVerticesData(kind);
    }
    /**
     * Flags an associated vertex buffer as updatable
     * @param kind defines which buffer to use (positions, indices, normals, etc). Possible `kind` values :
     * - VertexBuffer.PositionKind
     * - VertexBuffer.UVKind
     * - VertexBuffer.UV2Kind
     * - VertexBuffer.UV3Kind
     * - VertexBuffer.UV4Kind
     * - VertexBuffer.UV5Kind
     * - VertexBuffer.UV6Kind
     * - VertexBuffer.ColorKind
     * - VertexBuffer.MatricesIndicesKind
     * - VertexBuffer.MatricesIndicesExtraKind
     * - VertexBuffer.MatricesWeightsKind
     * - VertexBuffer.MatricesWeightsExtraKind
     * @param updatable defines if the updated vertex buffer must be flagged as updatable
     */ markVerticesDataAsUpdatable(kind, updatable = true) {
        const vb = this.getVertexBuffer(kind);
        if (!vb || vb.isUpdatable() === updatable) return;
        this.setVerticesData(kind, this.getVerticesData(kind), updatable);
    }
    /**
     * Sets the mesh global Vertex Buffer
     * @param buffer defines the buffer to use
     * @param disposeExistingBuffer disposes the existing buffer, if any (default: true)
     * @returns the current mesh
     */ setVerticesBuffer(buffer, disposeExistingBuffer = true) {
        if (!this._geometry) this._geometry = (0, $FUHfe.Geometry).CreateGeometryForMesh(this);
        this._geometry.setVerticesBuffer(buffer, null, disposeExistingBuffer);
        return this;
    }
    /**
     * Update a specific associated vertex buffer
     * @param kind defines which buffer to write to (positions, indices, normals, etc). Possible `kind` values :
     * - VertexBuffer.PositionKind
     * - VertexBuffer.UVKind
     * - VertexBuffer.UV2Kind
     * - VertexBuffer.UV3Kind
     * - VertexBuffer.UV4Kind
     * - VertexBuffer.UV5Kind
     * - VertexBuffer.UV6Kind
     * - VertexBuffer.ColorKind
     * - VertexBuffer.MatricesIndicesKind
     * - VertexBuffer.MatricesIndicesExtraKind
     * - VertexBuffer.MatricesWeightsKind
     * - VertexBuffer.MatricesWeightsExtraKind
     * @param data defines the data source
     * @param updateExtends defines if extends info of the mesh must be updated (can be null). This is mostly useful for "position" kind
     * @param makeItUnique defines if the geometry associated with the mesh must be cloned to make the change only for this mesh (and not all meshes associated with the same geometry)
     * @returns the current mesh
     */ updateVerticesData(kind, data, updateExtends, makeItUnique) {
        if (!this._geometry) return this;
        if (!makeItUnique) this._geometry.updateVerticesData(kind, data, updateExtends);
        else {
            this.makeGeometryUnique();
            this.updateVerticesData(kind, data, updateExtends, false);
        }
        return this;
    }
    /**
     * This method updates the vertex positions of an updatable mesh according to the `positionFunction` returned values.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/dynamicMeshMorph#other-shapes-updatemeshpositions
     * @param positionFunction is a simple JS function what is passed the mesh `positions` array. It doesn't need to return anything
     * @param computeNormals is a boolean (default true) to enable/disable the mesh normal recomputation after the vertex position update
     * @returns the current mesh
     */ updateMeshPositions(positionFunction, computeNormals = true) {
        const positions = this.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        if (!positions) return this;
        positionFunction(positions);
        this.updateVerticesData((0, $b4i1f.VertexBuffer).PositionKind, positions, false, false);
        if (computeNormals) {
            const indices = this.getIndices();
            const normals = this.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind);
            if (!normals) return this;
            (0, $5v6ry.VertexData).ComputeNormals(positions, indices, normals);
            this.updateVerticesData((0, $b4i1f.VertexBuffer).NormalKind, normals, false, false);
        }
        return this;
    }
    /**
     * Creates a un-shared specific occurence of the geometry for the mesh.
     * @returns the current mesh
     */ makeGeometryUnique() {
        if (!this._geometry) return this;
        if (this._geometry.meshes.length === 1) return this;
        const oldGeometry = this._geometry;
        const geometry = this._geometry.copy((0, $FUHfe.Geometry).RandomId());
        oldGeometry.releaseForMesh(this, true);
        geometry.applyToMesh(this);
        return this;
    }
    /**
     * Sets the index buffer of this mesh.
     * @param indexBuffer Defines the index buffer to use for this mesh
     * @param totalVertices Defines the total number of vertices used by the buffer
     * @param totalIndices Defines the total number of indices in the index buffer
     */ setIndexBuffer(indexBuffer, totalVertices, totalIndices) {
        let geometry = this._geometry;
        if (!geometry) geometry = new (0, $FUHfe.Geometry)((0, $FUHfe.Geometry).RandomId(), this.getScene(), undefined, undefined, this);
        geometry.setIndexBuffer(indexBuffer, totalVertices, totalIndices);
    }
    /**
     * Set the index buffer of this mesh
     * @param indices defines the source data
     * @param totalVertices defines the total number of vertices referenced by this index data (can be null)
     * @param updatable defines if the updated index buffer must be flagged as updatable (default is false)
     * @returns the current mesh
     */ setIndices(indices, totalVertices = null, updatable = false) {
        if (!this._geometry) {
            const vertexData = new (0, $5v6ry.VertexData)();
            vertexData.indices = indices;
            const scene = this.getScene();
            new (0, $FUHfe.Geometry)((0, $FUHfe.Geometry).RandomId(), scene, vertexData, updatable, this);
        } else this._geometry.setIndices(indices, totalVertices, updatable);
        return this;
    }
    /**
     * Update the current index buffer
     * @param indices defines the source data
     * @param offset defines the offset in the index buffer where to store the new data (can be null)
     * @param gpuMemoryOnly defines a boolean indicating that only the GPU memory must be updated leaving the CPU version of the indices unchanged (false by default)
     * @returns the current mesh
     */ updateIndices(indices, offset, gpuMemoryOnly = false) {
        if (!this._geometry) return this;
        this._geometry.updateIndices(indices, offset, gpuMemoryOnly);
        return this;
    }
    /**
     * Invert the geometry to move from a right handed system to a left handed one.
     * @returns the current mesh
     */ toLeftHanded() {
        if (!this._geometry) return this;
        this._geometry.toLeftHanded();
        return this;
    }
    /**
     * @internal
     */ _bind(subMesh, effect, fillMode, allowInstancedRendering = true) {
        if (!this._geometry) return this;
        const engine = this.getScene().getEngine();
        // Morph targets
        if (this.morphTargetManager && this.morphTargetManager.isUsingTextureForTargets) this.morphTargetManager._bind(effect);
        // Wireframe
        let indexToBind;
        if (this._unIndexed) indexToBind = null;
        else switch(this._getRenderingFillMode(fillMode)){
            case (0, $54229.Material).PointFillMode:
                indexToBind = null;
                break;
            case (0, $54229.Material).WireFrameFillMode:
                indexToBind = subMesh._getLinesIndexBuffer(this.getIndices(), engine);
                break;
            default:
            case (0, $54229.Material).TriangleFillMode:
                indexToBind = this._geometry.getIndexBuffer();
                break;
        }
        // VBOs
        if (!allowInstancedRendering || !this._userInstancedBuffersStorage || this.hasThinInstances) this._geometry._bind(effect, indexToBind);
        else this._geometry._bind(effect, indexToBind, this._userInstancedBuffersStorage.vertexBuffers, this._userInstancedBuffersStorage.vertexArrayObjects);
        return this;
    }
    /**
     * @internal
     */ _draw(subMesh, fillMode, instancesCount) {
        if (!this._geometry || !this._geometry.getVertexBuffers() || !this._unIndexed && !this._geometry.getIndexBuffer()) return this;
        if (this._internalMeshDataInfo._onBeforeDrawObservable) this._internalMeshDataInfo._onBeforeDrawObservable.notifyObservers(this);
        const scene = this.getScene();
        const engine = scene.getEngine();
        if (this._unIndexed || fillMode == (0, $54229.Material).PointFillMode) // or triangles as points
        engine.drawArraysType(fillMode, subMesh.verticesStart, subMesh.verticesCount, this.forcedInstanceCount || instancesCount);
        else if (fillMode == (0, $54229.Material).WireFrameFillMode) // Triangles as wireframe
        engine.drawElementsType(fillMode, 0, subMesh._linesIndexCount, this.forcedInstanceCount || instancesCount);
        else engine.drawElementsType(fillMode, subMesh.indexStart, subMesh.indexCount, this.forcedInstanceCount || instancesCount);
        return this;
    }
    /**
     * Registers for this mesh a javascript function called just before the rendering process
     * @param func defines the function to call before rendering this mesh
     * @returns the current mesh
     */ registerBeforeRender(func) {
        this.onBeforeRenderObservable.add(func);
        return this;
    }
    /**
     * Disposes a previously registered javascript function called before the rendering
     * @param func defines the function to remove
     * @returns the current mesh
     */ unregisterBeforeRender(func) {
        this.onBeforeRenderObservable.removeCallback(func);
        return this;
    }
    /**
     * Registers for this mesh a javascript function called just after the rendering is complete
     * @param func defines the function to call after rendering this mesh
     * @returns the current mesh
     */ registerAfterRender(func) {
        this.onAfterRenderObservable.add(func);
        return this;
    }
    /**
     * Disposes a previously registered javascript function called after the rendering.
     * @param func defines the function to remove
     * @returns the current mesh
     */ unregisterAfterRender(func) {
        this.onAfterRenderObservable.removeCallback(func);
        return this;
    }
    /**
     * @internal
     */ _getInstancesRenderList(subMeshId, isReplacementMode = false) {
        if (this._instanceDataStorage.isFrozen) {
            if (isReplacementMode) {
                this._instanceDataStorage.batchCacheReplacementModeInFrozenMode.hardwareInstancedRendering[subMeshId] = false;
                this._instanceDataStorage.batchCacheReplacementModeInFrozenMode.renderSelf[subMeshId] = true;
                return this._instanceDataStorage.batchCacheReplacementModeInFrozenMode;
            }
            if (this._instanceDataStorage.previousBatch) return this._instanceDataStorage.previousBatch;
        }
        const scene = this.getScene();
        const isInIntermediateRendering = scene._isInIntermediateRendering();
        const onlyForInstances = isInIntermediateRendering ? this._internalAbstractMeshDataInfo._onlyForInstancesIntermediate : this._internalAbstractMeshDataInfo._onlyForInstances;
        const batchCache = this._instanceDataStorage.batchCache;
        batchCache.mustReturn = false;
        batchCache.renderSelf[subMeshId] = isReplacementMode || !onlyForInstances && this.isEnabled() && this.isVisible;
        batchCache.visibleInstances[subMeshId] = null;
        if (this._instanceDataStorage.visibleInstances && !isReplacementMode) {
            const visibleInstances = this._instanceDataStorage.visibleInstances;
            const currentRenderId = scene.getRenderId();
            const defaultRenderId = isInIntermediateRendering ? visibleInstances.intermediateDefaultRenderId : visibleInstances.defaultRenderId;
            batchCache.visibleInstances[subMeshId] = visibleInstances[currentRenderId];
            if (!batchCache.visibleInstances[subMeshId] && defaultRenderId) batchCache.visibleInstances[subMeshId] = visibleInstances[defaultRenderId];
        }
        batchCache.hardwareInstancedRendering[subMeshId] = !isReplacementMode && this._instanceDataStorage.hardwareInstancedRendering && batchCache.visibleInstances[subMeshId] !== null && batchCache.visibleInstances[subMeshId] !== undefined;
        this._instanceDataStorage.previousBatch = batchCache;
        return batchCache;
    }
    /**
     * @internal
     */ _renderWithInstances(subMesh, fillMode, batch, effect, engine) {
        const visibleInstances = batch.visibleInstances[subMesh._id];
        const visibleInstanceCount = visibleInstances ? visibleInstances.length : 0;
        const instanceStorage = this._instanceDataStorage;
        const currentInstancesBufferSize = instanceStorage.instancesBufferSize;
        let instancesBuffer = instanceStorage.instancesBuffer;
        let instancesPreviousBuffer = instanceStorage.instancesPreviousBuffer;
        const matricesCount = visibleInstanceCount + 1;
        const bufferSize = matricesCount * 64;
        while(instanceStorage.instancesBufferSize < bufferSize)instanceStorage.instancesBufferSize *= 2;
        if (!instanceStorage.instancesData || currentInstancesBufferSize != instanceStorage.instancesBufferSize) instanceStorage.instancesData = new Float32Array(instanceStorage.instancesBufferSize / 4);
        if (this._scene.needsPreviousWorldMatrices && !instanceStorage.instancesPreviousData || currentInstancesBufferSize != instanceStorage.instancesBufferSize) instanceStorage.instancesPreviousData = new Float32Array(instanceStorage.instancesBufferSize / 4);
        let offset = 0;
        let instancesCount = 0;
        const renderSelf = batch.renderSelf[subMesh._id];
        const needUpdateBuffer = !instancesBuffer || currentInstancesBufferSize !== instanceStorage.instancesBufferSize || this._scene.needsPreviousWorldMatrices && !instanceStorage.instancesPreviousBuffer;
        if (!this._instanceDataStorage.manualUpdate && (!instanceStorage.isFrozen || needUpdateBuffer)) {
            const world = this.getWorldMatrix();
            if (renderSelf) {
                if (this._scene.needsPreviousWorldMatrices) {
                    if (!instanceStorage.masterMeshPreviousWorldMatrix) {
                        instanceStorage.masterMeshPreviousWorldMatrix = world.clone();
                        instanceStorage.masterMeshPreviousWorldMatrix.copyToArray(instanceStorage.instancesPreviousData, offset);
                    } else {
                        instanceStorage.masterMeshPreviousWorldMatrix.copyToArray(instanceStorage.instancesPreviousData, offset);
                        instanceStorage.masterMeshPreviousWorldMatrix.copyFrom(world);
                    }
                }
                world.copyToArray(instanceStorage.instancesData, offset);
                offset += 16;
                instancesCount++;
            }
            if (visibleInstances) {
                if ($b0df7c384622c537$export$e176487c05830cc5.INSTANCEDMESH_SORT_TRANSPARENT && this._scene.activeCamera && subMesh.getMaterial()?.needAlphaBlendingForMesh(subMesh.getRenderingMesh())) {
                    const cameraPosition = this._scene.activeCamera.globalPosition;
                    for(let instanceIndex = 0; instanceIndex < visibleInstances.length; instanceIndex++){
                        const instanceMesh = visibleInstances[instanceIndex];
                        instanceMesh._distanceToCamera = (0, $ha1VO.Vector3).Distance(instanceMesh.getBoundingInfo().boundingSphere.centerWorld, cameraPosition);
                    }
                    visibleInstances.sort((m1, m2)=>{
                        return m1._distanceToCamera > m2._distanceToCamera ? -1 : m1._distanceToCamera < m2._distanceToCamera ? 1 : 0;
                    });
                }
                for(let instanceIndex = 0; instanceIndex < visibleInstances.length; instanceIndex++){
                    const instance = visibleInstances[instanceIndex];
                    const matrix = instance.getWorldMatrix();
                    matrix.copyToArray(instanceStorage.instancesData, offset);
                    if (this._scene.needsPreviousWorldMatrices) {
                        if (!instance._previousWorldMatrix) {
                            instance._previousWorldMatrix = matrix.clone();
                            instance._previousWorldMatrix.copyToArray(instanceStorage.instancesPreviousData, offset);
                        } else {
                            instance._previousWorldMatrix.copyToArray(instanceStorage.instancesPreviousData, offset);
                            instance._previousWorldMatrix.copyFrom(matrix);
                        }
                    }
                    offset += 16;
                    instancesCount++;
                }
            }
        } else instancesCount = (renderSelf ? 1 : 0) + visibleInstanceCount;
        if (needUpdateBuffer) {
            if (instancesBuffer) instancesBuffer.dispose();
            if (instancesPreviousBuffer) instancesPreviousBuffer.dispose();
            instancesBuffer = new (0, $b4i1f.Buffer)(engine, instanceStorage.instancesData, true, 16, false, true);
            instanceStorage.instancesBuffer = instancesBuffer;
            if (!this._userInstancedBuffersStorage) this._userInstancedBuffersStorage = {
                data: {},
                vertexBuffers: {},
                strides: {},
                sizes: {},
                vertexArrayObjects: this.getEngine().getCaps().vertexArrayObject ? {} : undefined
            };
            this._userInstancedBuffersStorage.vertexBuffers["world0"] = instancesBuffer.createVertexBuffer("world0", 0, 4);
            this._userInstancedBuffersStorage.vertexBuffers["world1"] = instancesBuffer.createVertexBuffer("world1", 4, 4);
            this._userInstancedBuffersStorage.vertexBuffers["world2"] = instancesBuffer.createVertexBuffer("world2", 8, 4);
            this._userInstancedBuffersStorage.vertexBuffers["world3"] = instancesBuffer.createVertexBuffer("world3", 12, 4);
            if (this._scene.needsPreviousWorldMatrices) {
                instancesPreviousBuffer = new (0, $b4i1f.Buffer)(engine, instanceStorage.instancesPreviousData, true, 16, false, true);
                instanceStorage.instancesPreviousBuffer = instancesPreviousBuffer;
                this._userInstancedBuffersStorage.vertexBuffers["previousWorld0"] = instancesPreviousBuffer.createVertexBuffer("previousWorld0", 0, 4);
                this._userInstancedBuffersStorage.vertexBuffers["previousWorld1"] = instancesPreviousBuffer.createVertexBuffer("previousWorld1", 4, 4);
                this._userInstancedBuffersStorage.vertexBuffers["previousWorld2"] = instancesPreviousBuffer.createVertexBuffer("previousWorld2", 8, 4);
                this._userInstancedBuffersStorage.vertexBuffers["previousWorld3"] = instancesPreviousBuffer.createVertexBuffer("previousWorld3", 12, 4);
            }
            this._invalidateInstanceVertexArrayObject();
        } else if (!this._instanceDataStorage.isFrozen || this._instanceDataStorage.forceMatrixUpdates) {
            instancesBuffer.updateDirectly(instanceStorage.instancesData, 0, instancesCount);
            if (this._scene.needsPreviousWorldMatrices && (!this._instanceDataStorage.manualUpdate || this._instanceDataStorage.previousManualUpdate)) instancesPreviousBuffer.updateDirectly(instanceStorage.instancesPreviousData, 0, instancesCount);
        }
        this._processInstancedBuffers(visibleInstances, renderSelf);
        // Stats
        this.getScene()._activeIndices.addCount(subMesh.indexCount * instancesCount, false);
        // Draw
        if (engine._currentDrawContext) engine._currentDrawContext.useInstancing = true;
        this._bind(subMesh, effect, fillMode);
        this._draw(subMesh, fillMode, instancesCount);
        // Write current matrices as previous matrices in case of manual update
        // Default behaviour when previous matrices are not specified explicitly
        // Will break if instances number/order changes
        if (this._scene.needsPreviousWorldMatrices && !needUpdateBuffer && this._instanceDataStorage.manualUpdate && (!this._instanceDataStorage.isFrozen || this._instanceDataStorage.forceMatrixUpdates) && !this._instanceDataStorage.previousManualUpdate) instancesPreviousBuffer.updateDirectly(instanceStorage.instancesData, 0, instancesCount);
        engine.unbindInstanceAttributes();
        return this;
    }
    /**
     * @internal
     */ _renderWithThinInstances(subMesh, fillMode, effect, engine) {
        // Stats
        const instancesCount = this._thinInstanceDataStorage?.instancesCount ?? 0;
        this.getScene()._activeIndices.addCount(subMesh.indexCount * instancesCount, false);
        // Draw
        if (engine._currentDrawContext) engine._currentDrawContext.useInstancing = true;
        this._bind(subMesh, effect, fillMode);
        this._draw(subMesh, fillMode, instancesCount);
        // Write current matrices as previous matrices
        // Default behaviour when previous matrices are not specified explicitly
        // Will break if instances number/order changes
        if (this._scene.needsPreviousWorldMatrices && !this._thinInstanceDataStorage.previousMatrixData && this._thinInstanceDataStorage.matrixData) {
            if (!this._thinInstanceDataStorage.previousMatrixBuffer) this._thinInstanceDataStorage.previousMatrixBuffer = this._thinInstanceCreateMatrixBuffer("previousWorld", this._thinInstanceDataStorage.matrixData, false);
            else this._thinInstanceDataStorage.previousMatrixBuffer.updateDirectly(this._thinInstanceDataStorage.matrixData, 0, instancesCount);
        }
        engine.unbindInstanceAttributes();
    }
    /**
     * @internal
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _processInstancedBuffers(visibleInstances, renderSelf) {
    // Do nothing
    }
    /**
     * @internal
     */ _processRendering(renderingMesh, subMesh, effect, fillMode, batch, hardwareInstancedRendering, onBeforeDraw, effectiveMaterial) {
        const scene = this.getScene();
        const engine = scene.getEngine();
        fillMode = this._getRenderingFillMode(fillMode);
        if (hardwareInstancedRendering && subMesh.getRenderingMesh().hasThinInstances) {
            this._renderWithThinInstances(subMesh, fillMode, effect, engine);
            return this;
        }
        if (hardwareInstancedRendering) this._renderWithInstances(subMesh, fillMode, batch, effect, engine);
        else {
            if (engine._currentDrawContext) engine._currentDrawContext.useInstancing = false;
            let instanceCount = 0;
            if (batch.renderSelf[subMesh._id]) {
                // Draw
                if (onBeforeDraw) onBeforeDraw(false, renderingMesh.getWorldMatrix(), effectiveMaterial);
                instanceCount++;
                this._draw(subMesh, fillMode, this._instanceDataStorage.overridenInstanceCount);
            }
            const visibleInstancesForSubMesh = batch.visibleInstances[subMesh._id];
            if (visibleInstancesForSubMesh) {
                const visibleInstanceCount = visibleInstancesForSubMesh.length;
                instanceCount += visibleInstanceCount;
                // Stats
                for(let instanceIndex = 0; instanceIndex < visibleInstanceCount; instanceIndex++){
                    const instance = visibleInstancesForSubMesh[instanceIndex];
                    // World
                    const world = instance.getWorldMatrix();
                    if (onBeforeDraw) onBeforeDraw(true, world, effectiveMaterial);
                    // Draw
                    this._draw(subMesh, fillMode);
                }
            }
            // Stats
            scene._activeIndices.addCount(subMesh.indexCount * instanceCount, false);
        }
        return this;
    }
    /**
     * @internal
     */ _rebuild(dispose = false) {
        if (this._instanceDataStorage.instancesBuffer) {
            // Dispose instance buffer to be recreated in _renderWithInstances when rendered
            if (dispose) this._instanceDataStorage.instancesBuffer.dispose();
            this._instanceDataStorage.instancesBuffer = null;
        }
        if (this._userInstancedBuffersStorage) {
            for(const kind in this._userInstancedBuffersStorage.vertexBuffers){
                const buffer = this._userInstancedBuffersStorage.vertexBuffers[kind];
                if (buffer) {
                    // Dispose instance buffer to be recreated in _renderWithInstances when rendered
                    if (dispose) buffer.dispose();
                    this._userInstancedBuffersStorage.vertexBuffers[kind] = null;
                }
            }
            if (this._userInstancedBuffersStorage.vertexArrayObjects) this._userInstancedBuffersStorage.vertexArrayObjects = {};
        }
        this._internalMeshDataInfo._effectiveMaterial = null;
        super._rebuild(dispose);
    }
    /** @internal */ _freeze() {
        if (!this.subMeshes) return;
        // Prepare batches
        for(let index = 0; index < this.subMeshes.length; index++)this._getInstancesRenderList(index);
        this._internalMeshDataInfo._effectiveMaterial = null;
        this._instanceDataStorage.isFrozen = true;
    }
    /** @internal */ _unFreeze() {
        this._instanceDataStorage.isFrozen = false;
        this._instanceDataStorage.previousBatch = null;
    }
    /**
     * Triggers the draw call for the mesh (or a submesh), for a specific render pass id
     * @param renderPassId defines the render pass id to use to draw the mesh / submesh. If not provided, use the current renderPassId of the engine.
     * @param enableAlphaMode defines if alpha mode can be changed (default: false)
     * @param effectiveMeshReplacement defines an optional mesh used to provide info for the rendering (default: undefined)
     * @param subMesh defines the subMesh to render. If not provided, draw all mesh submeshes (default: undefined)
     * @param checkFrustumCulling defines if frustum culling must be checked (default: true). If you know the mesh is in the frustum (or if you don't care!), you can pass false to optimize.
     * @returns the current mesh
     */ renderWithRenderPassId(renderPassId, enableAlphaMode, effectiveMeshReplacement, subMesh, checkFrustumCulling = true) {
        const engine = this._scene.getEngine();
        const currentRenderPassId = engine.currentRenderPassId;
        if (renderPassId !== undefined) engine.currentRenderPassId = renderPassId;
        if (subMesh) {
            if (!checkFrustumCulling || checkFrustumCulling && subMesh.isInFrustum(this._scene._frustumPlanes)) this.render(subMesh, !!enableAlphaMode, effectiveMeshReplacement);
        } else for(let s = 0; s < this.subMeshes.length; s++){
            const subMesh = this.subMeshes[s];
            if (!checkFrustumCulling || checkFrustumCulling && subMesh.isInFrustum(this._scene._frustumPlanes)) this.render(subMesh, !!enableAlphaMode, effectiveMeshReplacement);
        }
        if (renderPassId !== undefined) engine.currentRenderPassId = currentRenderPassId;
        return this;
    }
    /**
     * Triggers the draw call for the mesh. Usually, you don't need to call this method by your own because the mesh rendering is handled by the scene rendering manager
     * @param subMesh defines the subMesh to render
     * @param enableAlphaMode defines if alpha mode can be changed
     * @param effectiveMeshReplacement defines an optional mesh used to provide info for the rendering
     * @returns the current mesh
     */ render(subMesh, enableAlphaMode, effectiveMeshReplacement) {
        const scene = this.getScene();
        if (this._internalAbstractMeshDataInfo._isActiveIntermediate) this._internalAbstractMeshDataInfo._isActiveIntermediate = false;
        else this._internalAbstractMeshDataInfo._isActive = false;
        const numActiveCameras = scene.activeCameras?.length ?? 0;
        const canCheckOcclusionQuery = numActiveCameras > 1 && scene.activeCamera === scene.activeCameras[0] || numActiveCameras <= 1;
        if (canCheckOcclusionQuery && this._checkOcclusionQuery() && !this._occlusionDataStorage.forceRenderingWhenOccluded) return this;
        // Managing instances
        const batch = this._getInstancesRenderList(subMesh._id, !!effectiveMeshReplacement);
        if (batch.mustReturn) return this;
        // Checking geometry state
        if (!this._geometry || !this._geometry.getVertexBuffers() || !this._unIndexed && !this._geometry.getIndexBuffer()) return this;
        const engine = scene.getEngine();
        let oldCameraMaxZ = 0;
        let oldCamera = null;
        if (this.ignoreCameraMaxZ && scene.activeCamera && !scene._isInIntermediateRendering()) {
            oldCameraMaxZ = scene.activeCamera.maxZ;
            oldCamera = scene.activeCamera;
            scene.activeCamera.maxZ = 0;
            scene.updateTransformMatrix(true);
        }
        if (this._internalMeshDataInfo._onBeforeRenderObservable) this._internalMeshDataInfo._onBeforeRenderObservable.notifyObservers(this);
        const renderingMesh = subMesh.getRenderingMesh();
        const hardwareInstancedRendering = batch.hardwareInstancedRendering[subMesh._id] || renderingMesh.hasThinInstances || !!this._userInstancedBuffersStorage && !subMesh.getMesh()._internalAbstractMeshDataInfo._actAsRegularMesh;
        const instanceDataStorage = this._instanceDataStorage;
        const material = subMesh.getMaterial();
        if (!material) {
            if (oldCamera) {
                oldCamera.maxZ = oldCameraMaxZ;
                scene.updateTransformMatrix(true);
            }
            return this;
        }
        // Material
        if (!instanceDataStorage.isFrozen || !this._internalMeshDataInfo._effectiveMaterial || this._internalMeshDataInfo._effectiveMaterial !== material) {
            if (material._storeEffectOnSubMeshes) {
                if (!material.isReadyForSubMesh(this, subMesh, hardwareInstancedRendering)) {
                    if (oldCamera) {
                        oldCamera.maxZ = oldCameraMaxZ;
                        scene.updateTransformMatrix(true);
                    }
                    return this;
                }
            } else if (!material.isReady(this, hardwareInstancedRendering)) {
                if (oldCamera) {
                    oldCamera.maxZ = oldCameraMaxZ;
                    scene.updateTransformMatrix(true);
                }
                return this;
            }
            this._internalMeshDataInfo._effectiveMaterial = material;
        } else if (material._storeEffectOnSubMeshes && !subMesh._drawWrapper?._wasPreviouslyReady || !material._storeEffectOnSubMeshes && !material._getDrawWrapper()._wasPreviouslyReady) {
            if (oldCamera) {
                oldCamera.maxZ = oldCameraMaxZ;
                scene.updateTransformMatrix(true);
            }
            return this;
        }
        // Alpha mode
        if (enableAlphaMode) engine.setAlphaMode(this._internalMeshDataInfo._effectiveMaterial.alphaMode);
        let drawWrapper;
        if (this._internalMeshDataInfo._effectiveMaterial._storeEffectOnSubMeshes) drawWrapper = subMesh._drawWrapper;
        else drawWrapper = this._internalMeshDataInfo._effectiveMaterial._getDrawWrapper();
        const effect = drawWrapper?.effect ?? null;
        for (const step of scene._beforeRenderingMeshStage)step.action(this, subMesh, batch, effect);
        if (!drawWrapper || !effect) {
            if (oldCamera) {
                oldCamera.maxZ = oldCameraMaxZ;
                scene.updateTransformMatrix(true);
            }
            return this;
        }
        const effectiveMesh = effectiveMeshReplacement || this;
        let sideOrientation;
        if (!instanceDataStorage.isFrozen && (this._internalMeshDataInfo._effectiveMaterial.backFaceCulling || this.overrideMaterialSideOrientation !== null || this._internalMeshDataInfo._effectiveMaterial.twoSidedLighting)) {
            // Note: if two sided lighting is enabled, we need to ensure that the normal will point in the right direction even if the determinant of the world matrix is negative
            const mainDeterminant = effectiveMesh._getWorldMatrixDeterminant();
            sideOrientation = this.overrideMaterialSideOrientation;
            if (sideOrientation == null) sideOrientation = this._internalMeshDataInfo._effectiveMaterial.sideOrientation;
            if (mainDeterminant < 0) sideOrientation = sideOrientation === (0, $54229.Material).ClockWiseSideOrientation ? (0, $54229.Material).CounterClockWiseSideOrientation : (0, $54229.Material).ClockWiseSideOrientation;
            instanceDataStorage.sideOrientation = sideOrientation;
        } else sideOrientation = instanceDataStorage.sideOrientation;
        const reverse = this._internalMeshDataInfo._effectiveMaterial._preBind(drawWrapper, sideOrientation);
        if (this._internalMeshDataInfo._effectiveMaterial.forceDepthWrite) engine.setDepthWrite(true);
        // Bind
        const effectiveMaterial = this._internalMeshDataInfo._effectiveMaterial;
        const fillMode = effectiveMaterial.fillMode;
        if (this._internalMeshDataInfo._onBeforeBindObservable) this._internalMeshDataInfo._onBeforeBindObservable.notifyObservers(this);
        if (!hardwareInstancedRendering) // Binding will be done later because we need to add more info to the VB
        this._bind(subMesh, effect, fillMode, false);
        const world = effectiveMesh.getWorldMatrix();
        if (effectiveMaterial._storeEffectOnSubMeshes) effectiveMaterial.bindForSubMesh(world, this, subMesh);
        else effectiveMaterial.bind(world, this);
        if (!effectiveMaterial.backFaceCulling && effectiveMaterial.separateCullingPass) {
            engine.setState(true, effectiveMaterial.zOffset, false, !reverse, effectiveMaterial.cullBackFaces, effectiveMaterial.stencil, effectiveMaterial.zOffsetUnits);
            this._processRendering(this, subMesh, effect, fillMode, batch, hardwareInstancedRendering, this._onBeforeDraw, this._internalMeshDataInfo._effectiveMaterial);
            engine.setState(true, effectiveMaterial.zOffset, false, reverse, effectiveMaterial.cullBackFaces, effectiveMaterial.stencil, effectiveMaterial.zOffsetUnits);
            if (this._internalMeshDataInfo._onBetweenPassObservable) this._internalMeshDataInfo._onBetweenPassObservable.notifyObservers(subMesh);
        }
        // Draw
        this._processRendering(this, subMesh, effect, fillMode, batch, hardwareInstancedRendering, this._onBeforeDraw, this._internalMeshDataInfo._effectiveMaterial);
        // Unbind
        this._internalMeshDataInfo._effectiveMaterial.unbind();
        for (const step of scene._afterRenderingMeshStage)step.action(this, subMesh, batch, effect);
        if (this._internalMeshDataInfo._onAfterRenderObservable) this._internalMeshDataInfo._onAfterRenderObservable.notifyObservers(this);
        if (oldCamera) {
            oldCamera.maxZ = oldCameraMaxZ;
            scene.updateTransformMatrix(true);
        }
        if (scene.performancePriority === (0, $gmbCk.ScenePerformancePriority).Aggressive && !instanceDataStorage.isFrozen) this._freeze();
        return this;
    }
    /**
     *   Renormalize the mesh and patch it up if there are no weights
     *   Similar to normalization by adding the weights compute the reciprocal and multiply all elements, this wil ensure that everything adds to 1.
     *   However in the case of zero weights then we set just a single influence to 1.
     *   We check in the function for extra's present and if so we use the normalizeSkinWeightsWithExtras rather than the FourWeights version.
     */ cleanMatrixWeights() {
        if (this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).MatricesWeightsKind)) {
            if (this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind)) this._normalizeSkinWeightsAndExtra();
            else this._normalizeSkinFourWeights();
        }
    }
    // faster 4 weight version.
    _normalizeSkinFourWeights() {
        const matricesWeights = this.getVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsKind);
        const numWeights = matricesWeights.length;
        for(let a = 0; a < numWeights; a += 4){
            // accumulate weights
            const t = matricesWeights[a] + matricesWeights[a + 1] + matricesWeights[a + 2] + matricesWeights[a + 3];
            // check for invalid weight and just set it to 1.
            if (t === 0) matricesWeights[a] = 1;
            else {
                // renormalize so everything adds to 1 use reciprocal
                const recip = 1 / t;
                matricesWeights[a] *= recip;
                matricesWeights[a + 1] *= recip;
                matricesWeights[a + 2] *= recip;
                matricesWeights[a + 3] *= recip;
            }
        }
        this.setVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsKind, matricesWeights);
    }
    // handle special case of extra verts.  (in theory gltf can handle 12 influences)
    _normalizeSkinWeightsAndExtra() {
        const matricesWeightsExtra = this.getVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind);
        const matricesWeights = this.getVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsKind);
        const numWeights = matricesWeights.length;
        for(let a = 0; a < numWeights; a += 4){
            // accumulate weights
            let t = matricesWeights[a] + matricesWeights[a + 1] + matricesWeights[a + 2] + matricesWeights[a + 3];
            t += matricesWeightsExtra[a] + matricesWeightsExtra[a + 1] + matricesWeightsExtra[a + 2] + matricesWeightsExtra[a + 3];
            // check for invalid weight and just set it to 1.
            if (t === 0) matricesWeights[a] = 1;
            else {
                // renormalize so everything adds to 1 use reciprocal
                const recip = 1 / t;
                matricesWeights[a] *= recip;
                matricesWeights[a + 1] *= recip;
                matricesWeights[a + 2] *= recip;
                matricesWeights[a + 3] *= recip;
                // same goes for extras
                matricesWeightsExtra[a] *= recip;
                matricesWeightsExtra[a + 1] *= recip;
                matricesWeightsExtra[a + 2] *= recip;
                matricesWeightsExtra[a + 3] *= recip;
            }
        }
        this.setVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsKind, matricesWeights);
        this.setVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsKind, matricesWeightsExtra);
    }
    /**
     * ValidateSkinning is used to determine that a mesh has valid skinning data along with skin metrics, if missing weights,
     * or not normalized it is returned as invalid mesh the string can be used for console logs, or on screen messages to let
     * the user know there was an issue with importing the mesh
     * @returns a validation object with skinned, valid and report string
     */ validateSkinning() {
        const matricesWeightsExtra = this.getVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind);
        const matricesWeights = this.getVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsKind);
        if (matricesWeights === null || this.skeleton == null) return {
            skinned: false,
            valid: true,
            report: "not skinned"
        };
        const numWeights = matricesWeights.length;
        let numberNotSorted = 0;
        let missingWeights = 0;
        let maxUsedWeights = 0;
        let numberNotNormalized = 0;
        const numInfluences = matricesWeightsExtra === null ? 4 : 8;
        const usedWeightCounts = [];
        for(let a = 0; a <= numInfluences; a++)usedWeightCounts[a] = 0;
        const toleranceEpsilon = 0.001;
        for(let a = 0; a < numWeights; a += 4){
            let lastWeight = matricesWeights[a];
            let t = lastWeight;
            let usedWeights = t === 0 ? 0 : 1;
            for(let b = 1; b < numInfluences; b++){
                const d = b < 4 ? matricesWeights[a + b] : matricesWeightsExtra[a + b - 4];
                if (d > lastWeight) numberNotSorted++;
                if (d !== 0) usedWeights++;
                t += d;
                lastWeight = d;
            }
            // count the buffer weights usage
            usedWeightCounts[usedWeights]++;
            // max influences
            if (usedWeights > maxUsedWeights) maxUsedWeights = usedWeights;
            // check for invalid weight and just set it to 1.
            if (t === 0) missingWeights++;
            else {
                // renormalize so everything adds to 1 use reciprocal
                const recip = 1 / t;
                let tolerance = 0;
                for(let b = 0; b < numInfluences; b++)if (b < 4) tolerance += Math.abs(matricesWeights[a + b] - matricesWeights[a + b] * recip);
                else tolerance += Math.abs(matricesWeightsExtra[a + b - 4] - matricesWeightsExtra[a + b - 4] * recip);
                // arbitrary epsilon value for dictating not normalized
                if (tolerance > toleranceEpsilon) numberNotNormalized++;
            }
        }
        // validate bone indices are in range of the skeleton
        const numBones = this.skeleton.bones.length;
        const matricesIndices = this.getVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesKind);
        const matricesIndicesExtra = this.getVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind);
        let numBadBoneIndices = 0;
        for(let a = 0; a < numWeights; a += 4)for(let b = 0; b < numInfluences; b++){
            const index = b < 4 ? matricesIndices[a + b] : matricesIndicesExtra[a + b - 4];
            if (index >= numBones || index < 0) numBadBoneIndices++;
        }
        // log mesh stats
        const output = "Number of Weights = " + numWeights / 4 + "\nMaximum influences = " + maxUsedWeights + "\nMissing Weights = " + missingWeights + "\nNot Sorted = " + numberNotSorted + "\nNot Normalized = " + numberNotNormalized + "\nWeightCounts = [" + usedWeightCounts + "]" + "\nNumber of bones = " + numBones + "\nBad Bone Indices = " + numBadBoneIndices;
        return {
            skinned: true,
            valid: missingWeights === 0 && numberNotNormalized === 0 && numBadBoneIndices === 0,
            report: output
        };
    }
    /** @internal */ _checkDelayState() {
        const scene = this.getScene();
        if (this._geometry) this._geometry.load(scene);
        else if (this.delayLoadState === 4) {
            this.delayLoadState = 2;
            this._queueLoad(scene);
        }
        return this;
    }
    _queueLoad(scene) {
        scene.addPendingData(this);
        const getBinaryData = this.delayLoadingFile.indexOf(".babylonbinarymeshdata") !== -1;
        (0, $bOhSV.Tools).LoadFile(this.delayLoadingFile, (data)=>{
            if (data instanceof ArrayBuffer) this._delayLoadingFunction(data, this);
            else this._delayLoadingFunction(JSON.parse(data), this);
            this.instances.forEach((instance)=>{
                instance.refreshBoundingInfo();
                instance._syncSubMeshes();
            });
            this.delayLoadState = 1;
            scene.removePendingData(this);
        }, ()=>{}, scene.offlineProvider, getBinaryData);
        return this;
    }
    /**
     * Returns `true` if the mesh is within the frustum defined by the passed array of planes.
     * A mesh is in the frustum if its bounding box intersects the frustum
     * @param frustumPlanes defines the frustum to test
     * @returns true if the mesh is in the frustum planes
     */ isInFrustum(frustumPlanes) {
        if (this.delayLoadState === 2) return false;
        if (!super.isInFrustum(frustumPlanes)) return false;
        this._checkDelayState();
        return true;
    }
    /**
     * Sets the mesh material by the material or multiMaterial `id` property
     * @param id is a string identifying the material or the multiMaterial
     * @returns the current mesh
     */ setMaterialById(id) {
        const materials = this.getScene().materials;
        let index;
        for(index = materials.length - 1; index > -1; index--)if (materials[index].id === id) {
            this.material = materials[index];
            return this;
        }
        // Multi
        const multiMaterials = this.getScene().multiMaterials;
        for(index = multiMaterials.length - 1; index > -1; index--)if (multiMaterials[index].id === id) {
            this.material = multiMaterials[index];
            return this;
        }
        return this;
    }
    /**
     * Returns as a new array populated with the mesh material and/or skeleton, if any.
     * @returns an array of IAnimatable
     */ getAnimatables() {
        const results = [];
        if (this.material) results.push(this.material);
        if (this.skeleton) results.push(this.skeleton);
        return results;
    }
    /**
     * Modifies the mesh geometry according to the passed transformation matrix.
     * This method returns nothing, but it really modifies the mesh even if it's originally not set as updatable.
     * The mesh normals are modified using the same transformation.
     * Note that, under the hood, this method sets a new VertexBuffer each call.
     * @param transform defines the transform matrix to use
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/transforms/center_origin/bakingTransforms
     * @returns the current mesh
     */ bakeTransformIntoVertices(transform) {
        // Position
        if (!this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).PositionKind)) return this;
        const submeshes = this.subMeshes.splice(0);
        this._resetPointsArrayCache();
        let data = this.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        const temp = (0, $ha1VO.Vector3).Zero();
        let index;
        for(index = 0; index < data.length; index += 3)(0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(data[index], data[index + 1], data[index + 2], transform, temp).toArray(data, index);
        this.setVerticesData((0, $b4i1f.VertexBuffer).PositionKind, data, this.getVertexBuffer((0, $b4i1f.VertexBuffer).PositionKind).isUpdatable());
        // Normals
        if (this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).NormalKind)) {
            data = this.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind);
            for(index = 0; index < data.length; index += 3)(0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(data[index], data[index + 1], data[index + 2], transform, temp).normalize().toArray(data, index);
            this.setVerticesData((0, $b4i1f.VertexBuffer).NormalKind, data, this.getVertexBuffer((0, $b4i1f.VertexBuffer).NormalKind).isUpdatable());
        }
        // Tangents
        if (this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).TangentKind)) {
            data = this.getVerticesData((0, $b4i1f.VertexBuffer).TangentKind);
            for(index = 0; index < data.length; index += 4)(0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(data[index], data[index + 1], data[index + 2], transform, temp).normalize().toArray(data, index);
            this.setVerticesData((0, $b4i1f.VertexBuffer).TangentKind, data, this.getVertexBuffer((0, $b4i1f.VertexBuffer).TangentKind).isUpdatable());
        }
        // flip faces?
        if (transform.determinant() < 0) this.flipFaces();
        // Restore submeshes
        this.releaseSubMeshes();
        this.subMeshes = submeshes;
        return this;
    }
    /**
     * Modifies the mesh geometry according to its own current World Matrix.
     * The mesh World Matrix is then reset.
     * This method returns nothing but really modifies the mesh even if it's originally not set as updatable.
     * Note that, under the hood, this method sets a new VertexBuffer each call.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/transforms/center_origin/bakingTransforms
     * @param bakeIndependentlyOfChildren indicates whether to preserve all child nodes' World Matrix during baking
     * @returns the current mesh
     */ bakeCurrentTransformIntoVertices(bakeIndependentlyOfChildren = true) {
        this.bakeTransformIntoVertices(this.computeWorldMatrix(true));
        this.resetLocalMatrix(bakeIndependentlyOfChildren);
        return this;
    }
    // Cache
    /** @internal */ get _positions() {
        if (this._internalAbstractMeshDataInfo._positions) return this._internalAbstractMeshDataInfo._positions;
        if (this._geometry) return this._geometry._positions;
        return null;
    }
    /** @internal */ _resetPointsArrayCache() {
        if (this._geometry) this._geometry._resetPointsArrayCache();
        return this;
    }
    /** @internal */ _generatePointsArray() {
        if (this._geometry) return this._geometry._generatePointsArray();
        return false;
    }
    /**
     * Returns a new Mesh object generated from the current mesh properties.
     * This method must not get confused with createInstance()
     * @param name is a string, the name given to the new mesh
     * @param newParent can be any Node object (default `null`)
     * @param doNotCloneChildren allows/denies the recursive cloning of the original mesh children if any (default `false`)
     * @param clonePhysicsImpostor allows/denies the cloning in the same time of the original mesh `body` used by the physics engine, if any (default `true`)
     * @returns a new mesh
     */ clone(name = "", newParent = null, doNotCloneChildren, clonePhysicsImpostor = true) {
        return new $b0df7c384622c537$export$e176487c05830cc5(name, this.getScene(), newParent, this, doNotCloneChildren, clonePhysicsImpostor);
    }
    /**
     * Releases resources associated with this mesh.
     * @param doNotRecurse Set to true to not recurse into each children (recurse into each children by default)
     * @param disposeMaterialAndTextures Set to true to also dispose referenced materials and textures (false by default)
     */ dispose(doNotRecurse, disposeMaterialAndTextures = false) {
        this.morphTargetManager = null;
        if (this._geometry) this._geometry.releaseForMesh(this, true);
        const internalDataInfo = this._internalMeshDataInfo;
        if (internalDataInfo._onBeforeDrawObservable) internalDataInfo._onBeforeDrawObservable.clear();
        if (internalDataInfo._onBeforeBindObservable) internalDataInfo._onBeforeBindObservable.clear();
        if (internalDataInfo._onBeforeRenderObservable) internalDataInfo._onBeforeRenderObservable.clear();
        if (internalDataInfo._onAfterRenderObservable) internalDataInfo._onAfterRenderObservable.clear();
        if (internalDataInfo._onBetweenPassObservable) internalDataInfo._onBetweenPassObservable.clear();
        // Sources
        if (this._scene.useClonedMeshMap) {
            if (internalDataInfo.meshMap) for(const uniqueId in internalDataInfo.meshMap){
                const mesh = internalDataInfo.meshMap[uniqueId];
                if (mesh) {
                    mesh._internalMeshDataInfo._source = null;
                    internalDataInfo.meshMap[uniqueId] = undefined;
                }
            }
            if (internalDataInfo._source && internalDataInfo._source._internalMeshDataInfo.meshMap) internalDataInfo._source._internalMeshDataInfo.meshMap[this.uniqueId] = undefined;
        } else {
            const meshes = this.getScene().meshes;
            for (const abstractMesh of meshes){
                const mesh = abstractMesh;
                if (mesh._internalMeshDataInfo && mesh._internalMeshDataInfo._source && mesh._internalMeshDataInfo._source === this) mesh._internalMeshDataInfo._source = null;
            }
        }
        internalDataInfo._source = null;
        this._instanceDataStorage.visibleInstances = {};
        // Instances
        this._disposeInstanceSpecificData();
        // Thin instances
        this._disposeThinInstanceSpecificData();
        if (this._internalMeshDataInfo._checkReadinessObserver) this._scene.onBeforeRenderObservable.remove(this._internalMeshDataInfo._checkReadinessObserver);
        super.dispose(doNotRecurse, disposeMaterialAndTextures);
    }
    /** @internal */ _disposeInstanceSpecificData() {
    // Do nothing
    }
    /** @internal */ _disposeThinInstanceSpecificData() {
    // Do nothing
    }
    /** @internal */ _invalidateInstanceVertexArrayObject() {
    // Do nothing
    }
    /**
     * Modifies the mesh geometry according to a displacement map.
     * A displacement map is a colored image. Each pixel color value (actually a gradient computed from red, green, blue values) will give the displacement to apply to each mesh vertex.
     * The mesh must be set as updatable. Its internal geometry is directly modified, no new buffer are allocated.
     * @param url is a string, the URL from the image file is to be downloaded.
     * @param minHeight is the lower limit of the displacement.
     * @param maxHeight is the upper limit of the displacement.
     * @param onSuccess is an optional Javascript function to be called just after the mesh is modified. It is passed the modified mesh and must return nothing.
     * @param uvOffset is an optional vector2 used to offset UV.
     * @param uvScale is an optional vector2 used to scale UV.
     * @param forceUpdate defines whether or not to force an update of the generated buffers. This is useful to apply on a deserialized model for instance.
     * @param onError defines a callback called when an error occurs during the processing of the request.
     * @returns the Mesh.
     */ applyDisplacementMap(url, minHeight, maxHeight, onSuccess, uvOffset, uvScale, forceUpdate = false, onError) {
        const scene = this.getScene();
        const onload = (img)=>{
            // Getting height map data
            const heightMapWidth = img.width;
            const heightMapHeight = img.height;
            const canvas = this.getEngine().createCanvas(heightMapWidth, heightMapHeight);
            const context = canvas.getContext("2d");
            context.drawImage(img, 0, 0);
            // Create VertexData from map data
            //Cast is due to wrong definition in lib.d.ts from ts 1.3 - https://github.com/Microsoft/TypeScript/issues/949
            const buffer = context.getImageData(0, 0, heightMapWidth, heightMapHeight).data;
            this.applyDisplacementMapFromBuffer(buffer, heightMapWidth, heightMapHeight, minHeight, maxHeight, uvOffset, uvScale, forceUpdate);
            //execute success callback, if set
            if (onSuccess) onSuccess(this);
        };
        (0, $bOhSV.Tools).LoadImage(url, onload, onError ? onError : ()=>{}, scene.offlineProvider);
        return this;
    }
    /**
     * Modifies the mesh geometry according to a displacementMap buffer.
     * A displacement map is a colored image. Each pixel color value (actually a gradient computed from red, green, blue values) will give the displacement to apply to each mesh vertex.
     * The mesh must be set as updatable. Its internal geometry is directly modified, no new buffer are allocated.
     * @param buffer is a `Uint8Array` buffer containing series of `Uint8` lower than 255, the red, green, blue and alpha values of each successive pixel.
     * @param heightMapWidth is the width of the buffer image.
     * @param heightMapHeight is the height of the buffer image.
     * @param minHeight is the lower limit of the displacement.
     * @param maxHeight is the upper limit of the displacement.
     * @param uvOffset is an optional vector2 used to offset UV.
     * @param uvScale is an optional vector2 used to scale UV.
     * @param forceUpdate defines whether or not to force an update of the generated buffers. This is useful to apply on a deserialized model for instance.
     * @returns the Mesh.
     */ applyDisplacementMapFromBuffer(buffer, heightMapWidth, heightMapHeight, minHeight, maxHeight, uvOffset, uvScale, forceUpdate = false) {
        if (!this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).PositionKind) || !this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).NormalKind) || !this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UVKind)) {
            (0, $kVtWi.Logger).Warn("Cannot call applyDisplacementMap: Given mesh is not complete. Position, Normal or UV are missing");
            return this;
        }
        const positions = this.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind, true, true);
        const normals = this.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind);
        const uvs = this.getVerticesData((0, $b4i1f.VertexBuffer).UVKind);
        let position = (0, $ha1VO.Vector3).Zero();
        const normal = (0, $ha1VO.Vector3).Zero();
        const uv = (0, $ha1VO.Vector2).Zero();
        uvOffset = uvOffset || (0, $ha1VO.Vector2).Zero();
        uvScale = uvScale || new (0, $ha1VO.Vector2)(1, 1);
        for(let index = 0; index < positions.length; index += 3){
            (0, $ha1VO.Vector3).FromArrayToRef(positions, index, position);
            (0, $ha1VO.Vector3).FromArrayToRef(normals, index, normal);
            (0, $ha1VO.Vector2).FromArrayToRef(uvs, index / 3 * 2, uv);
            // Compute height
            const u = Math.abs(uv.x * uvScale.x + uvOffset.x % 1) * (heightMapWidth - 1) % heightMapWidth | 0;
            const v = Math.abs(uv.y * uvScale.y + uvOffset.y % 1) * (heightMapHeight - 1) % heightMapHeight | 0;
            const pos = (u + v * heightMapWidth) * 4;
            const r = buffer[pos] / 255.0;
            const g = buffer[pos + 1] / 255.0;
            const b = buffer[pos + 2] / 255.0;
            const gradient = r * 0.3 + g * 0.59 + b * 0.11;
            normal.normalize();
            normal.scaleInPlace(minHeight + (maxHeight - minHeight) * gradient);
            position = position.add(normal);
            position.toArray(positions, index);
        }
        (0, $5v6ry.VertexData).ComputeNormals(positions, this.getIndices(), normals);
        if (forceUpdate) {
            this.setVerticesData((0, $b4i1f.VertexBuffer).PositionKind, positions);
            this.setVerticesData((0, $b4i1f.VertexBuffer).NormalKind, normals);
            this.setVerticesData((0, $b4i1f.VertexBuffer).UVKind, uvs);
        } else {
            this.updateVerticesData((0, $b4i1f.VertexBuffer).PositionKind, positions);
            this.updateVerticesData((0, $b4i1f.VertexBuffer).NormalKind, normals);
        }
        return this;
    }
    _getFlattenedNormals(indices, positions) {
        const normals = new Float32Array(indices.length * 3);
        let normalsCount = 0;
        // Decide if normals should be flipped
        const flipNormalGeneration = this.overrideMaterialSideOrientation === (this._scene.useRightHandedSystem ? 1 : 0);
        // Generate new normals
        for(let index = 0; index < indices.length; index += 3){
            const p1 = (0, $ha1VO.Vector3).FromArray(positions, indices[index] * 3);
            const p2 = (0, $ha1VO.Vector3).FromArray(positions, indices[index + 1] * 3);
            const p3 = (0, $ha1VO.Vector3).FromArray(positions, indices[index + 2] * 3);
            const p1p2 = p1.subtract(p2);
            const p3p2 = p3.subtract(p2);
            const normal = (0, $ha1VO.Vector3).Normalize((0, $ha1VO.Vector3).Cross(p1p2, p3p2));
            if (flipNormalGeneration) normal.scaleInPlace(-1);
            // Store same normals for every vertex
            for(let localIndex = 0; localIndex < 3; localIndex++){
                normals[normalsCount++] = normal.x;
                normals[normalsCount++] = normal.y;
                normals[normalsCount++] = normal.z;
            }
        }
        return normals;
    }
    _convertToUnIndexedMesh(flattenNormals = false) {
        const kinds = this.getVerticesDataKinds();
        const indices = this.getIndices();
        const data = {};
        const separateVertices = (data, stride)=>{
            const newData = new Float32Array(indices.length * stride);
            let count = 0;
            for(let index = 0; index < indices.length; index++)for(let offset = 0; offset < stride; offset++)newData[count++] = data[indices[index] * stride + offset];
            return newData;
        };
        // Save previous submeshes
        const previousSubmeshes = this.geometry ? this.subMeshes.slice(0) : [];
        // Cache vertex data
        for (const kind of kinds)data[kind] = this.getVerticesData(kind);
        // Update vertex data
        for (const kind of kinds){
            const vertexBuffer = this.getVertexBuffer(kind);
            const stride = vertexBuffer.getStrideSize();
            if (flattenNormals && kind === (0, $b4i1f.VertexBuffer).NormalKind) {
                const normals = this._getFlattenedNormals(indices, data[(0, $b4i1f.VertexBuffer).PositionKind]);
                this.setVerticesData((0, $b4i1f.VertexBuffer).NormalKind, normals, vertexBuffer.isUpdatable(), stride);
            } else this.setVerticesData(kind, separateVertices(data[kind], stride), vertexBuffer.isUpdatable(), stride);
        }
        // Update morph targets
        if (this.morphTargetManager) {
            for(let targetIndex = 0; targetIndex < this.morphTargetManager.numTargets; targetIndex++){
                const target = this.morphTargetManager.getTarget(targetIndex);
                const positions = target.getPositions();
                target.setPositions(separateVertices(positions, 3));
                const normals = target.getNormals();
                if (normals) target.setNormals(flattenNormals ? this._getFlattenedNormals(indices, positions) : separateVertices(normals, 3));
                const tangents = target.getTangents();
                if (tangents) target.setTangents(separateVertices(tangents, 3));
                const uvs = target.getUVs();
                if (uvs) target.setUVs(separateVertices(uvs, 2));
            }
            this.morphTargetManager.synchronize();
        }
        // Update indices
        for(let index = 0; index < indices.length; index++)indices[index] = index;
        this.setIndices(indices);
        this._unIndexed = true;
        // Update submeshes
        this.releaseSubMeshes();
        for (const previousOne of previousSubmeshes)(0, $lEBSs.SubMesh).AddToMesh(previousOne.materialIndex, previousOne.indexStart, previousOne.indexCount, previousOne.indexStart, previousOne.indexCount, this);
        this.synchronizeInstances();
        return this;
    }
    /**
     * Modify the mesh to get a flat shading rendering.
     * This means each mesh facet will then have its own normals. Usually new vertices are added in the mesh geometry to get this result.
     * Warning : the mesh is really modified even if not set originally as updatable and, under the hood, a new VertexBuffer is allocated.
     * @returns current mesh
     */ convertToFlatShadedMesh() {
        return this._convertToUnIndexedMesh(true);
    }
    /**
     * This method removes all the mesh indices and add new vertices (duplication) in order to unfold facets into buffers.
     * In other words, more vertices, no more indices and a single bigger VBO.
     * The mesh is really modified even if not set originally as updatable. Under the hood, a new VertexBuffer is allocated.
     * @returns current mesh
     */ convertToUnIndexedMesh() {
        return this._convertToUnIndexedMesh();
    }
    /**
     * Inverses facet orientations.
     * Warning : the mesh is really modified even if not set originally as updatable. A new VertexBuffer is created under the hood each call.
     * @param flipNormals will also inverts the normals
     * @returns current mesh
     */ flipFaces(flipNormals = false) {
        const vertex_data = (0, $5v6ry.VertexData).ExtractFromMesh(this);
        let i;
        if (flipNormals && this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).NormalKind) && vertex_data.normals) for(i = 0; i < vertex_data.normals.length; i++)vertex_data.normals[i] *= -1;
        if (vertex_data.indices) {
            let temp;
            for(i = 0; i < vertex_data.indices.length; i += 3){
                // reassign indices
                temp = vertex_data.indices[i + 1];
                vertex_data.indices[i + 1] = vertex_data.indices[i + 2];
                vertex_data.indices[i + 2] = temp;
            }
        }
        vertex_data.applyToMesh(this, this.isVertexBufferUpdatable((0, $b4i1f.VertexBuffer).PositionKind));
        return this;
    }
    /**
     * Increase the number of facets and hence vertices in a mesh
     * Vertex normals are interpolated from existing vertex normals
     * Warning : the mesh is really modified even if not set originally as updatable. A new VertexBuffer is created under the hood each call.
     * @param numberPerEdge the number of new vertices to add to each edge of a facet, optional default 1
     */ increaseVertices(numberPerEdge = 1) {
        const vertex_data = (0, $5v6ry.VertexData).ExtractFromMesh(this);
        const currentIndices = vertex_data.indices && !Array.isArray(vertex_data.indices) && Array.from ? Array.from(vertex_data.indices) : vertex_data.indices;
        const positions = vertex_data.positions && !Array.isArray(vertex_data.positions) && Array.from ? Array.from(vertex_data.positions) : vertex_data.positions;
        const uvs = vertex_data.uvs && !Array.isArray(vertex_data.uvs) && Array.from ? Array.from(vertex_data.uvs) : vertex_data.uvs;
        const normals = vertex_data.normals && !Array.isArray(vertex_data.normals) && Array.from ? Array.from(vertex_data.normals) : vertex_data.normals;
        if (!currentIndices || !positions) (0, $kVtWi.Logger).Warn("Couldn't increase number of vertices : VertexData must contain at least indices and positions");
        else {
            vertex_data.indices = currentIndices;
            vertex_data.positions = positions;
            if (uvs) vertex_data.uvs = uvs;
            if (normals) vertex_data.normals = normals;
            const segments = numberPerEdge + 1; //segments per current facet edge, become sides of new facets
            const tempIndices = new Array();
            for(let i = 0; i < segments + 1; i++)tempIndices[i] = new Array();
            let a; //vertex index of one end of a side
            let b; //vertex index of other end of the side
            const deltaPosition = new (0, $ha1VO.Vector3)(0, 0, 0);
            const deltaNormal = new (0, $ha1VO.Vector3)(0, 0, 0);
            const deltaUV = new (0, $ha1VO.Vector2)(0, 0);
            const indices = new Array();
            const vertexIndex = new Array();
            const side = new Array();
            let len;
            let positionPtr = positions.length;
            let uvPtr;
            if (uvs) uvPtr = uvs.length;
            let normalsPtr;
            if (normals) normalsPtr = normals.length;
            for(let i = 0; i < currentIndices.length; i += 3){
                vertexIndex[0] = currentIndices[i];
                vertexIndex[1] = currentIndices[i + 1];
                vertexIndex[2] = currentIndices[i + 2];
                for(let j = 0; j < 3; j++){
                    a = vertexIndex[j];
                    b = vertexIndex[(j + 1) % 3];
                    if (side[a] === undefined && side[b] === undefined) {
                        side[a] = new Array();
                        side[b] = new Array();
                    } else {
                        if (side[a] === undefined) side[a] = new Array();
                        if (side[b] === undefined) side[b] = new Array();
                    }
                    if (side[a][b] === undefined && side[b][a] === undefined) {
                        side[a][b] = [];
                        deltaPosition.x = (positions[3 * b] - positions[3 * a]) / segments;
                        deltaPosition.y = (positions[3 * b + 1] - positions[3 * a + 1]) / segments;
                        deltaPosition.z = (positions[3 * b + 2] - positions[3 * a + 2]) / segments;
                        if (normals) {
                            deltaNormal.x = (normals[3 * b] - normals[3 * a]) / segments;
                            deltaNormal.y = (normals[3 * b + 1] - normals[3 * a + 1]) / segments;
                            deltaNormal.z = (normals[3 * b + 2] - normals[3 * a + 2]) / segments;
                        }
                        if (uvs) {
                            deltaUV.x = (uvs[2 * b] - uvs[2 * a]) / segments;
                            deltaUV.y = (uvs[2 * b + 1] - uvs[2 * a + 1]) / segments;
                        }
                        side[a][b].push(a);
                        for(let k = 1; k < segments; k++){
                            side[a][b].push(positions.length / 3);
                            positions[positionPtr++] = positions[3 * a] + k * deltaPosition.x;
                            positions[positionPtr++] = positions[3 * a + 1] + k * deltaPosition.y;
                            positions[positionPtr++] = positions[3 * a + 2] + k * deltaPosition.z;
                            if (normals) {
                                normals[normalsPtr++] = normals[3 * a] + k * deltaNormal.x;
                                normals[normalsPtr++] = normals[3 * a + 1] + k * deltaNormal.y;
                                normals[normalsPtr++] = normals[3 * a + 2] + k * deltaNormal.z;
                            }
                            if (uvs) {
                                uvs[uvPtr++] = uvs[2 * a] + k * deltaUV.x;
                                uvs[uvPtr++] = uvs[2 * a + 1] + k * deltaUV.y;
                            }
                        }
                        side[a][b].push(b);
                        side[b][a] = new Array();
                        len = side[a][b].length;
                        for(let idx = 0; idx < len; idx++)side[b][a][idx] = side[a][b][len - 1 - idx];
                    }
                }
                //Calculate positions, normals and uvs of new internal vertices
                tempIndices[0][0] = currentIndices[i];
                tempIndices[1][0] = side[currentIndices[i]][currentIndices[i + 1]][1];
                tempIndices[1][1] = side[currentIndices[i]][currentIndices[i + 2]][1];
                for(let k = 2; k < segments; k++){
                    tempIndices[k][0] = side[currentIndices[i]][currentIndices[i + 1]][k];
                    tempIndices[k][k] = side[currentIndices[i]][currentIndices[i + 2]][k];
                    deltaPosition.x = (positions[3 * tempIndices[k][k]] - positions[3 * tempIndices[k][0]]) / k;
                    deltaPosition.y = (positions[3 * tempIndices[k][k] + 1] - positions[3 * tempIndices[k][0] + 1]) / k;
                    deltaPosition.z = (positions[3 * tempIndices[k][k] + 2] - positions[3 * tempIndices[k][0] + 2]) / k;
                    if (normals) {
                        deltaNormal.x = (normals[3 * tempIndices[k][k]] - normals[3 * tempIndices[k][0]]) / k;
                        deltaNormal.y = (normals[3 * tempIndices[k][k] + 1] - normals[3 * tempIndices[k][0] + 1]) / k;
                        deltaNormal.z = (normals[3 * tempIndices[k][k] + 2] - normals[3 * tempIndices[k][0] + 2]) / k;
                    }
                    if (uvs) {
                        deltaUV.x = (uvs[2 * tempIndices[k][k]] - uvs[2 * tempIndices[k][0]]) / k;
                        deltaUV.y = (uvs[2 * tempIndices[k][k] + 1] - uvs[2 * tempIndices[k][0] + 1]) / k;
                    }
                    for(let j = 1; j < k; j++){
                        tempIndices[k][j] = positions.length / 3;
                        positions[positionPtr++] = positions[3 * tempIndices[k][0]] + j * deltaPosition.x;
                        positions[positionPtr++] = positions[3 * tempIndices[k][0] + 1] + j * deltaPosition.y;
                        positions[positionPtr++] = positions[3 * tempIndices[k][0] + 2] + j * deltaPosition.z;
                        if (normals) {
                            normals[normalsPtr++] = normals[3 * tempIndices[k][0]] + j * deltaNormal.x;
                            normals[normalsPtr++] = normals[3 * tempIndices[k][0] + 1] + j * deltaNormal.y;
                            normals[normalsPtr++] = normals[3 * tempIndices[k][0] + 2] + j * deltaNormal.z;
                        }
                        if (uvs) {
                            uvs[uvPtr++] = uvs[2 * tempIndices[k][0]] + j * deltaUV.x;
                            uvs[uvPtr++] = uvs[2 * tempIndices[k][0] + 1] + j * deltaUV.y;
                        }
                    }
                }
                tempIndices[segments] = side[currentIndices[i + 1]][currentIndices[i + 2]];
                // reform indices
                indices.push(tempIndices[0][0], tempIndices[1][0], tempIndices[1][1]);
                for(let k = 1; k < segments; k++){
                    let j;
                    for(j = 0; j < k; j++){
                        indices.push(tempIndices[k][j], tempIndices[k + 1][j], tempIndices[k + 1][j + 1]);
                        indices.push(tempIndices[k][j], tempIndices[k + 1][j + 1], tempIndices[k][j + 1]);
                    }
                    indices.push(tempIndices[k][j], tempIndices[k + 1][j], tempIndices[k + 1][j + 1]);
                }
            }
            vertex_data.indices = indices;
            vertex_data.applyToMesh(this, this.isVertexBufferUpdatable((0, $b4i1f.VertexBuffer).PositionKind));
        }
    }
    /**
     * Force adjacent facets to share vertices and remove any facets that have all vertices in a line
     * This will undo any application of covertToFlatShadedMesh
     * Warning : the mesh is really modified even if not set originally as updatable. A new VertexBuffer is created under the hood each call.
     */ forceSharedVertices() {
        const vertex_data = (0, $5v6ry.VertexData).ExtractFromMesh(this);
        const currentUVs = vertex_data.uvs;
        const currentIndices = vertex_data.indices;
        const currentPositions = vertex_data.positions;
        const currentColors = vertex_data.colors;
        const currentMatrixIndices = vertex_data.matricesIndices;
        const currentMatrixWeights = vertex_data.matricesWeights;
        const currentMatrixIndicesExtra = vertex_data.matricesIndicesExtra;
        const currentMatrixWeightsExtra = vertex_data.matricesWeightsExtra;
        if (currentIndices === void 0 || currentPositions === void 0 || currentIndices === null || currentPositions === null) (0, $kVtWi.Logger).Warn("VertexData contains empty entries");
        else {
            const positions = new Array();
            const indices = new Array();
            const uvs = new Array();
            const colors = new Array();
            const matrixIndices = new Array();
            const matrixWeights = new Array();
            const matrixIndicesExtra = new Array();
            const matrixWeightsExtra = new Array();
            let pstring = new Array(); //lists facet vertex positions (a,b,c) as string "a|b|c"
            let indexPtr = 0; // pointer to next available index value
            const uniquePositions = {}; // unique vertex positions
            let ptr; // pointer to element in uniquePositions
            let facet;
            for(let i = 0; i < currentIndices.length; i += 3){
                facet = [
                    currentIndices[i],
                    currentIndices[i + 1],
                    currentIndices[i + 2]
                ]; //facet vertex indices
                pstring = [];
                for(let j = 0; j < 3; j++){
                    pstring[j] = "";
                    for(let k = 0; k < 3; k++){
                        //small values make 0
                        if (Math.abs(currentPositions[3 * facet[j] + k]) < 0.00000001) currentPositions[3 * facet[j] + k] = 0;
                        pstring[j] += currentPositions[3 * facet[j] + k] + "|";
                    }
                }
                //check facet vertices to see that none are repeated
                // do not process any facet that has a repeated vertex, ie is a line
                if (!(pstring[0] == pstring[1] || pstring[0] == pstring[2] || pstring[1] == pstring[2])) //for each facet position check if already listed in uniquePositions
                // if not listed add to uniquePositions and set index pointer
                // if listed use its index in uniquePositions and new index pointer
                for(let j = 0; j < 3; j++){
                    ptr = uniquePositions[pstring[j]];
                    if (ptr === undefined) {
                        uniquePositions[pstring[j]] = indexPtr;
                        ptr = indexPtr++;
                        //not listed so add individual x, y, z coordinates to positions
                        for(let k = 0; k < 3; k++)positions.push(currentPositions[3 * facet[j] + k]);
                        if (currentColors !== null && currentColors !== void 0) for(let k = 0; k < 4; k++)colors.push(currentColors[4 * facet[j] + k]);
                        if (currentUVs !== null && currentUVs !== void 0) for(let k = 0; k < 2; k++)uvs.push(currentUVs[2 * facet[j] + k]);
                        if (currentMatrixIndices !== null && currentMatrixIndices !== void 0) for(let k = 0; k < 4; k++)matrixIndices.push(currentMatrixIndices[4 * facet[j] + k]);
                        if (currentMatrixWeights !== null && currentMatrixWeights !== void 0) for(let k = 0; k < 4; k++)matrixWeights.push(currentMatrixWeights[4 * facet[j] + k]);
                        if (currentMatrixIndicesExtra !== null && currentMatrixIndicesExtra !== void 0) for(let k = 0; k < 4; k++)matrixIndicesExtra.push(currentMatrixIndicesExtra[4 * facet[j] + k]);
                        if (currentMatrixWeightsExtra !== null && currentMatrixWeightsExtra !== void 0) for(let k = 0; k < 4; k++)matrixWeightsExtra.push(currentMatrixWeightsExtra[4 * facet[j] + k]);
                    }
                    // add new index pointer to indices array
                    indices.push(ptr);
                }
            }
            const normals = new Array();
            (0, $5v6ry.VertexData).ComputeNormals(positions, indices, normals);
            //create new vertex data object and update
            vertex_data.positions = positions;
            vertex_data.indices = indices;
            vertex_data.normals = normals;
            if (currentUVs !== null && currentUVs !== void 0) vertex_data.uvs = uvs;
            if (currentColors !== null && currentColors !== void 0) vertex_data.colors = colors;
            if (currentMatrixIndices !== null && currentMatrixIndices !== void 0) vertex_data.matricesIndices = matrixIndices;
            if (currentMatrixWeights !== null && currentMatrixWeights !== void 0) vertex_data.matricesWeights = matrixWeights;
            if (currentMatrixIndicesExtra !== null && currentMatrixIndicesExtra !== void 0) vertex_data.matricesIndicesExtra = matrixIndicesExtra;
            if (currentMatrixWeights !== null && currentMatrixWeights !== void 0) vertex_data.matricesWeightsExtra = matrixWeightsExtra;
            vertex_data.applyToMesh(this, this.isVertexBufferUpdatable((0, $b4i1f.VertexBuffer).PositionKind));
        }
    }
    // Instances
    /**
     * @internal
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/naming-convention
    static _instancedMeshFactory(name, mesh) {
        throw (0, $dUFYy._WarnImport)("InstancedMesh");
    }
    /**
     * @internal
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    static _PhysicsImpostorParser(scene, physicObject, jsonObject) {
        throw (0, $dUFYy._WarnImport)("PhysicsImpostor");
    }
    /**
     * Creates a new InstancedMesh object from the mesh model.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/copies/instances
     * @param name defines the name of the new instance
     * @returns a new InstancedMesh
     */ createInstance(name) {
        return $b0df7c384622c537$export$e176487c05830cc5._instancedMeshFactory(name, this);
    }
    /**
     * Synchronises all the mesh instance submeshes to the current mesh submeshes, if any.
     * After this call, all the mesh instances have the same submeshes than the current mesh.
     * @returns the current mesh
     */ synchronizeInstances() {
        for(let instanceIndex = 0; instanceIndex < this.instances.length; instanceIndex++){
            const instance = this.instances[instanceIndex];
            instance._syncSubMeshes();
        }
        return this;
    }
    /**
     * Optimization of the mesh's indices, in case a mesh has duplicated vertices.
     * The function will only reorder the indices and will not remove unused vertices to avoid problems with submeshes.
     * This should be used together with the simplification to avoid disappearing triangles.
     * @param successCallback an optional success callback to be called after the optimization finished.
     * @returns the current mesh
     */ optimizeIndices(successCallback) {
        const indices = this.getIndices();
        const positions = this.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        if (!positions || !indices) return this;
        const vectorPositions = [];
        for(let pos = 0; pos < positions.length; pos = pos + 3)vectorPositions.push((0, $ha1VO.Vector3).FromArray(positions, pos));
        const dupes = [];
        (0, $bOhSV.AsyncLoop).SyncAsyncForLoop(vectorPositions.length, 40, (iteration)=>{
            const realPos = vectorPositions.length - 1 - iteration;
            const testedPosition = vectorPositions[realPos];
            for(let j = 0; j < realPos; ++j){
                const againstPosition = vectorPositions[j];
                if (testedPosition.equals(againstPosition)) {
                    dupes[realPos] = j;
                    break;
                }
            }
        }, ()=>{
            for(let i = 0; i < indices.length; ++i)indices[i] = dupes[indices[i]] || indices[i];
            //indices are now reordered
            const originalSubMeshes = this.subMeshes.slice(0);
            this.setIndices(indices);
            this.subMeshes = originalSubMeshes;
            if (successCallback) successCallback(this);
        });
        return this;
    }
    /**
     * Serialize current mesh
     * @param serializationObject defines the object which will receive the serialization data
     * @returns the serialized object
     */ serialize(serializationObject = {}) {
        serializationObject.name = this.name;
        serializationObject.id = this.id;
        serializationObject.uniqueId = this.uniqueId;
        serializationObject.type = this.getClassName();
        if ((0, $7212E.Tags) && (0, $7212E.Tags).HasTags(this)) serializationObject.tags = (0, $7212E.Tags).GetTags(this);
        serializationObject.position = this.position.asArray();
        if (this.rotationQuaternion) serializationObject.rotationQuaternion = this.rotationQuaternion.asArray();
        else if (this.rotation) serializationObject.rotation = this.rotation.asArray();
        serializationObject.scaling = this.scaling.asArray();
        if (this._postMultiplyPivotMatrix) serializationObject.pivotMatrix = this.getPivotMatrix().asArray();
        else serializationObject.localMatrix = this.getPivotMatrix().asArray();
        serializationObject.isEnabled = this.isEnabled(false);
        serializationObject.isVisible = this.isVisible;
        serializationObject.infiniteDistance = this.infiniteDistance;
        serializationObject.pickable = this.isPickable;
        serializationObject.receiveShadows = this.receiveShadows;
        serializationObject.billboardMode = this.billboardMode;
        serializationObject.visibility = this.visibility;
        serializationObject.alwaysSelectAsActiveMesh = this.alwaysSelectAsActiveMesh;
        serializationObject.checkCollisions = this.checkCollisions;
        serializationObject.ellipsoid = this.ellipsoid.asArray();
        serializationObject.ellipsoidOffset = this.ellipsoidOffset.asArray();
        serializationObject.doNotSyncBoundingInfo = this.doNotSyncBoundingInfo;
        serializationObject.isBlocker = this.isBlocker;
        serializationObject.overrideMaterialSideOrientation = this.overrideMaterialSideOrientation;
        // Parent
        if (this.parent) this.parent._serializeAsParent(serializationObject);
        // Geometry
        serializationObject.isUnIndexed = this.isUnIndexed;
        const geometry = this._geometry;
        if (geometry && this.subMeshes) {
            serializationObject.geometryUniqueId = geometry.uniqueId;
            serializationObject.geometryId = geometry.id;
            // SubMeshes
            serializationObject.subMeshes = [];
            for(let subIndex = 0; subIndex < this.subMeshes.length; subIndex++){
                const subMesh = this.subMeshes[subIndex];
                serializationObject.subMeshes.push({
                    materialIndex: subMesh.materialIndex,
                    verticesStart: subMesh.verticesStart,
                    verticesCount: subMesh.verticesCount,
                    indexStart: subMesh.indexStart,
                    indexCount: subMesh.indexCount
                });
            }
        }
        // Material
        if (this.material) {
            if (!this.material.doNotSerialize) {
                serializationObject.materialUniqueId = this.material.uniqueId;
                serializationObject.materialId = this.material.id; // back compat
            }
        } else {
            this.material = null;
            serializationObject.materialUniqueId = this._scene.defaultMaterial.uniqueId;
            serializationObject.materialId = this._scene.defaultMaterial.id; // back compat
        }
        // Morph targets
        if (this.morphTargetManager) serializationObject.morphTargetManagerId = this.morphTargetManager.uniqueId;
        // Skeleton
        if (this.skeleton) {
            serializationObject.skeletonId = this.skeleton.id;
            serializationObject.numBoneInfluencers = this.numBoneInfluencers;
        }
        // Physics
        //TODO implement correct serialization for physics impostors.
        if (this.getScene()._getComponent((0, $bv05l.SceneComponentConstants).NAME_PHYSICSENGINE)) {
            const impostor = this.getPhysicsImpostor();
            if (impostor) {
                serializationObject.physicsMass = impostor.getParam("mass");
                serializationObject.physicsFriction = impostor.getParam("friction");
                serializationObject.physicsRestitution = impostor.getParam("mass");
                serializationObject.physicsImpostor = impostor.type;
            }
        }
        // Metadata
        if (this.metadata) serializationObject.metadata = this.metadata;
        // Instances
        serializationObject.instances = [];
        for(let index = 0; index < this.instances.length; index++){
            const instance = this.instances[index];
            if (instance.doNotSerialize) continue;
            const serializationInstance = {
                name: instance.name,
                id: instance.id,
                isEnabled: instance.isEnabled(false),
                isVisible: instance.isVisible,
                isPickable: instance.isPickable,
                checkCollisions: instance.checkCollisions,
                position: instance.position.asArray(),
                scaling: instance.scaling.asArray()
            };
            if (instance.parent) instance.parent._serializeAsParent(serializationInstance);
            if (instance.rotationQuaternion) serializationInstance.rotationQuaternion = instance.rotationQuaternion.asArray();
            else if (instance.rotation) serializationInstance.rotation = instance.rotation.asArray();
            // Physics
            //TODO implement correct serialization for physics impostors.
            if (this.getScene()._getComponent((0, $bv05l.SceneComponentConstants).NAME_PHYSICSENGINE)) {
                const impostor = instance.getPhysicsImpostor();
                if (impostor) {
                    serializationInstance.physicsMass = impostor.getParam("mass");
                    serializationInstance.physicsFriction = impostor.getParam("friction");
                    serializationInstance.physicsRestitution = impostor.getParam("mass");
                    serializationInstance.physicsImpostor = impostor.type;
                }
            }
            // Metadata
            if (instance.metadata) serializationInstance.metadata = instance.metadata;
            // Action Manager
            if (instance.actionManager) serializationInstance.actions = instance.actionManager.serialize(instance.name);
            serializationObject.instances.push(serializationInstance);
            // Animations
            (0, $6Ho1L.SerializationHelper).AppendSerializedAnimations(instance, serializationInstance);
            serializationInstance.ranges = instance.serializeAnimationRanges();
        }
        // Thin instances
        if (this._thinInstanceDataStorage.instancesCount && this._thinInstanceDataStorage.matrixData) {
            serializationObject.thinInstances = {
                instancesCount: this._thinInstanceDataStorage.instancesCount,
                matrixData: Array.from(this._thinInstanceDataStorage.matrixData),
                matrixBufferSize: this._thinInstanceDataStorage.matrixBufferSize,
                enablePicking: this.thinInstanceEnablePicking
            };
            if (this._userThinInstanceBuffersStorage) {
                const userThinInstance = {
                    data: {},
                    sizes: {},
                    strides: {}
                };
                for(const kind in this._userThinInstanceBuffersStorage.data){
                    userThinInstance.data[kind] = Array.from(this._userThinInstanceBuffersStorage.data[kind]);
                    userThinInstance.sizes[kind] = this._userThinInstanceBuffersStorage.sizes[kind];
                    userThinInstance.strides[kind] = this._userThinInstanceBuffersStorage.strides[kind];
                }
                serializationObject.thinInstances.userThinInstance = userThinInstance;
            }
        }
        // Animations
        (0, $6Ho1L.SerializationHelper).AppendSerializedAnimations(this, serializationObject);
        serializationObject.ranges = this.serializeAnimationRanges();
        // Layer mask
        serializationObject.layerMask = this.layerMask;
        // Alpha
        serializationObject.alphaIndex = this.alphaIndex;
        serializationObject.hasVertexAlpha = this.hasVertexAlpha;
        // Overlay
        serializationObject.overlayAlpha = this.overlayAlpha;
        serializationObject.overlayColor = this.overlayColor.asArray();
        serializationObject.renderOverlay = this.renderOverlay;
        // Fog
        serializationObject.applyFog = this.applyFog;
        // Action Manager
        if (this.actionManager) serializationObject.actions = this.actionManager.serialize(this.name);
        return serializationObject;
    }
    /** @internal */ _syncGeometryWithMorphTargetManager() {
        if (!this.geometry) return;
        this._markSubMeshesAsAttributesDirty();
        const morphTargetManager = this._internalAbstractMeshDataInfo._morphTargetManager;
        if (morphTargetManager && morphTargetManager.vertexCount) {
            if (morphTargetManager.vertexCount !== this.getTotalVertices()) {
                (0, $kVtWi.Logger).Error("Mesh is incompatible with morph targets. Targets and mesh must all have the same vertices count.");
                this.morphTargetManager = null;
                return;
            }
            if (morphTargetManager.isUsingTextureForTargets) return;
            for(let index = 0; index < morphTargetManager.numInfluencers; index++){
                const morphTarget = morphTargetManager.getActiveTarget(index);
                const positions = morphTarget.getPositions();
                if (!positions) {
                    (0, $kVtWi.Logger).Error("Invalid morph target. Target must have positions.");
                    return;
                }
                this.geometry.setVerticesData((0, $b4i1f.VertexBuffer).PositionKind + index, positions, false, 3);
                const normals = morphTarget.getNormals();
                if (normals) this.geometry.setVerticesData((0, $b4i1f.VertexBuffer).NormalKind + index, normals, false, 3);
                const tangents = morphTarget.getTangents();
                if (tangents) this.geometry.setVerticesData((0, $b4i1f.VertexBuffer).TangentKind + index, tangents, false, 3);
                const uvs = morphTarget.getUVs();
                if (uvs) this.geometry.setVerticesData((0, $b4i1f.VertexBuffer).UVKind + "_" + index, uvs, false, 2);
            }
        } else {
            let index = 0;
            // Positions
            while(this.geometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).PositionKind + index)){
                this.geometry.removeVerticesData((0, $b4i1f.VertexBuffer).PositionKind + index);
                if (this.geometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).NormalKind + index)) this.geometry.removeVerticesData((0, $b4i1f.VertexBuffer).NormalKind + index);
                if (this.geometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).TangentKind + index)) this.geometry.removeVerticesData((0, $b4i1f.VertexBuffer).TangentKind + index);
                if (this.geometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UVKind + index)) this.geometry.removeVerticesData((0, $b4i1f.VertexBuffer).UVKind + "_" + index);
                index++;
            }
        }
    }
    /**
     * Returns a new Mesh object parsed from the source provided.
     * @param parsedMesh is the source
     * @param scene defines the hosting scene
     * @param rootUrl is the root URL to prefix the `delayLoadingFile` property with
     * @returns a new Mesh
     */ static Parse(parsedMesh, scene, rootUrl) {
        let mesh;
        if (parsedMesh.type && parsedMesh.type === "LinesMesh") mesh = $b0df7c384622c537$export$e176487c05830cc5._LinesMeshParser(parsedMesh, scene);
        else if (parsedMesh.type && parsedMesh.type === "GroundMesh") mesh = $b0df7c384622c537$export$e176487c05830cc5._GroundMeshParser(parsedMesh, scene);
        else if (parsedMesh.type && parsedMesh.type === "GoldbergMesh") mesh = $b0df7c384622c537$export$e176487c05830cc5._GoldbergMeshParser(parsedMesh, scene);
        else if (parsedMesh.type && parsedMesh.type === "GreasedLineMesh") mesh = $b0df7c384622c537$export$e176487c05830cc5._GreasedLineMeshParser(parsedMesh, scene);
        else if (parsedMesh.type && parsedMesh.type === "TrailMesh") mesh = $b0df7c384622c537$export$e176487c05830cc5._TrailMeshParser(parsedMesh, scene);
        else mesh = new $b0df7c384622c537$export$e176487c05830cc5(parsedMesh.name, scene);
        mesh.id = parsedMesh.id;
        mesh._waitingParsedUniqueId = parsedMesh.uniqueId;
        if (0, $7212E.Tags) (0, $7212E.Tags).AddTagsTo(mesh, parsedMesh.tags);
        mesh.position = (0, $ha1VO.Vector3).FromArray(parsedMesh.position);
        if (parsedMesh.metadata !== undefined) mesh.metadata = parsedMesh.metadata;
        if (parsedMesh.rotationQuaternion) mesh.rotationQuaternion = (0, $ha1VO.Quaternion).FromArray(parsedMesh.rotationQuaternion);
        else if (parsedMesh.rotation) mesh.rotation = (0, $ha1VO.Vector3).FromArray(parsedMesh.rotation);
        mesh.scaling = (0, $ha1VO.Vector3).FromArray(parsedMesh.scaling);
        if (parsedMesh.localMatrix) mesh.setPreTransformMatrix((0, $ha1VO.Matrix).FromArray(parsedMesh.localMatrix));
        else if (parsedMesh.pivotMatrix) mesh.setPivotMatrix((0, $ha1VO.Matrix).FromArray(parsedMesh.pivotMatrix));
        mesh.setEnabled(parsedMesh.isEnabled);
        mesh.isVisible = parsedMesh.isVisible;
        mesh.infiniteDistance = parsedMesh.infiniteDistance;
        mesh.alwaysSelectAsActiveMesh = !!parsedMesh.alwaysSelectAsActiveMesh;
        mesh.showBoundingBox = parsedMesh.showBoundingBox;
        mesh.showSubMeshesBoundingBox = parsedMesh.showSubMeshesBoundingBox;
        if (parsedMesh.applyFog !== undefined) mesh.applyFog = parsedMesh.applyFog;
        if (parsedMesh.pickable !== undefined) mesh.isPickable = parsedMesh.pickable;
        if (parsedMesh.alphaIndex !== undefined) mesh.alphaIndex = parsedMesh.alphaIndex;
        mesh.receiveShadows = parsedMesh.receiveShadows;
        if (parsedMesh.billboardMode !== undefined) mesh.billboardMode = parsedMesh.billboardMode;
        if (parsedMesh.visibility !== undefined) mesh.visibility = parsedMesh.visibility;
        mesh.checkCollisions = parsedMesh.checkCollisions;
        mesh.doNotSyncBoundingInfo = !!parsedMesh.doNotSyncBoundingInfo;
        if (parsedMesh.ellipsoid) mesh.ellipsoid = (0, $ha1VO.Vector3).FromArray(parsedMesh.ellipsoid);
        if (parsedMesh.ellipsoidOffset) mesh.ellipsoidOffset = (0, $ha1VO.Vector3).FromArray(parsedMesh.ellipsoidOffset);
        if (parsedMesh.overrideMaterialSideOrientation !== undefined) mesh.overrideMaterialSideOrientation = parsedMesh.overrideMaterialSideOrientation;
        if (parsedMesh.isBlocker !== undefined) mesh.isBlocker = parsedMesh.isBlocker;
        mesh._shouldGenerateFlatShading = parsedMesh.useFlatShading;
        // freezeWorldMatrix
        if (parsedMesh.freezeWorldMatrix) mesh._waitingData.freezeWorldMatrix = parsedMesh.freezeWorldMatrix;
        // Parent
        if (parsedMesh.parentId !== undefined) mesh._waitingParentId = parsedMesh.parentId;
        if (parsedMesh.parentInstanceIndex !== undefined) mesh._waitingParentInstanceIndex = parsedMesh.parentInstanceIndex;
        // Actions
        if (parsedMesh.actions !== undefined) mesh._waitingData.actions = parsedMesh.actions;
        // Overlay
        if (parsedMesh.overlayAlpha !== undefined) mesh.overlayAlpha = parsedMesh.overlayAlpha;
        if (parsedMesh.overlayColor !== undefined) mesh.overlayColor = (0, $7etnY.Color3).FromArray(parsedMesh.overlayColor);
        if (parsedMesh.renderOverlay !== undefined) mesh.renderOverlay = parsedMesh.renderOverlay;
        // Geometry
        mesh.isUnIndexed = !!parsedMesh.isUnIndexed;
        mesh.hasVertexAlpha = parsedMesh.hasVertexAlpha;
        if (parsedMesh.delayLoadingFile) {
            mesh.delayLoadState = 4;
            mesh.delayLoadingFile = rootUrl + parsedMesh.delayLoadingFile;
            mesh.buildBoundingInfo((0, $ha1VO.Vector3).FromArray(parsedMesh.boundingBoxMinimum), (0, $ha1VO.Vector3).FromArray(parsedMesh.boundingBoxMaximum));
            if (parsedMesh._binaryInfo) mesh._binaryInfo = parsedMesh._binaryInfo;
            mesh._delayInfo = [];
            if (parsedMesh.hasUVs) mesh._delayInfo.push((0, $b4i1f.VertexBuffer).UVKind);
            if (parsedMesh.hasUVs2) mesh._delayInfo.push((0, $b4i1f.VertexBuffer).UV2Kind);
            if (parsedMesh.hasUVs3) mesh._delayInfo.push((0, $b4i1f.VertexBuffer).UV3Kind);
            if (parsedMesh.hasUVs4) mesh._delayInfo.push((0, $b4i1f.VertexBuffer).UV4Kind);
            if (parsedMesh.hasUVs5) mesh._delayInfo.push((0, $b4i1f.VertexBuffer).UV5Kind);
            if (parsedMesh.hasUVs6) mesh._delayInfo.push((0, $b4i1f.VertexBuffer).UV6Kind);
            if (parsedMesh.hasColors) mesh._delayInfo.push((0, $b4i1f.VertexBuffer).ColorKind);
            if (parsedMesh.hasMatricesIndices) mesh._delayInfo.push((0, $b4i1f.VertexBuffer).MatricesIndicesKind);
            if (parsedMesh.hasMatricesWeights) mesh._delayInfo.push((0, $b4i1f.VertexBuffer).MatricesWeightsKind);
            mesh._delayLoadingFunction = (0, $FUHfe.Geometry)._ImportGeometry;
            if ((0, $kixW2.SceneLoaderFlags).ForceFullSceneLoadingForIncremental) mesh._checkDelayState();
        } else (0, $FUHfe.Geometry)._ImportGeometry(parsedMesh, mesh);
        // Material
        if (parsedMesh.materialUniqueId) mesh._waitingMaterialId = parsedMesh.materialUniqueId;
        else if (parsedMesh.materialId) mesh._waitingMaterialId = parsedMesh.materialId;
        // Morph targets
        if (parsedMesh.morphTargetManagerId > -1) mesh.morphTargetManager = scene.getMorphTargetManagerById(parsedMesh.morphTargetManagerId);
        // Skeleton
        if (parsedMesh.skeletonId !== undefined && parsedMesh.skeletonId !== null) {
            mesh.skeleton = scene.getLastSkeletonById(parsedMesh.skeletonId);
            if (parsedMesh.numBoneInfluencers) mesh.numBoneInfluencers = parsedMesh.numBoneInfluencers;
        }
        // Animations
        if (parsedMesh.animations) {
            for(let animationIndex = 0; animationIndex < parsedMesh.animations.length; animationIndex++){
                const parsedAnimation = parsedMesh.animations[animationIndex];
                const internalClass = (0, $8DoUR.GetClass)("BABYLON.Animation");
                if (internalClass) mesh.animations.push(internalClass.Parse(parsedAnimation));
            }
            (0, $bgssx.Node).ParseAnimationRanges(mesh, parsedMesh, scene);
        }
        if (parsedMesh.autoAnimate) scene.beginAnimation(mesh, parsedMesh.autoAnimateFrom, parsedMesh.autoAnimateTo, parsedMesh.autoAnimateLoop, parsedMesh.autoAnimateSpeed || 1.0);
        // Layer Mask
        if (parsedMesh.layerMask && !isNaN(parsedMesh.layerMask)) mesh.layerMask = Math.abs(parseInt(parsedMesh.layerMask));
        else mesh.layerMask = 0x0fffffff;
        // Physics
        if (parsedMesh.physicsImpostor) $b0df7c384622c537$export$e176487c05830cc5._PhysicsImpostorParser(scene, mesh, parsedMesh);
        // Levels
        if (parsedMesh.lodMeshIds) mesh._waitingData.lods = {
            ids: parsedMesh.lodMeshIds,
            distances: parsedMesh.lodDistances ? parsedMesh.lodDistances : null,
            coverages: parsedMesh.lodCoverages ? parsedMesh.lodCoverages : null
        };
        // Instances
        if (parsedMesh.instances) for(let index = 0; index < parsedMesh.instances.length; index++){
            const parsedInstance = parsedMesh.instances[index];
            const instance = mesh.createInstance(parsedInstance.name);
            if (parsedInstance.id) instance.id = parsedInstance.id;
            if (0, $7212E.Tags) {
                if (parsedInstance.tags) (0, $7212E.Tags).AddTagsTo(instance, parsedInstance.tags);
                else (0, $7212E.Tags).AddTagsTo(instance, parsedMesh.tags);
            }
            instance.position = (0, $ha1VO.Vector3).FromArray(parsedInstance.position);
            if (parsedInstance.metadata !== undefined) instance.metadata = parsedInstance.metadata;
            if (parsedInstance.parentId !== undefined) instance._waitingParentId = parsedInstance.parentId;
            if (parsedInstance.parentInstanceIndex !== undefined) instance._waitingParentInstanceIndex = parsedInstance.parentInstanceIndex;
            if (parsedInstance.isEnabled !== undefined && parsedInstance.isEnabled !== null) instance.setEnabled(parsedInstance.isEnabled);
            if (parsedInstance.isVisible !== undefined && parsedInstance.isVisible !== null) instance.isVisible = parsedInstance.isVisible;
            if (parsedInstance.isPickable !== undefined && parsedInstance.isPickable !== null) instance.isPickable = parsedInstance.isPickable;
            if (parsedInstance.rotationQuaternion) instance.rotationQuaternion = (0, $ha1VO.Quaternion).FromArray(parsedInstance.rotationQuaternion);
            else if (parsedInstance.rotation) instance.rotation = (0, $ha1VO.Vector3).FromArray(parsedInstance.rotation);
            instance.scaling = (0, $ha1VO.Vector3).FromArray(parsedInstance.scaling);
            if (parsedInstance.checkCollisions != undefined && parsedInstance.checkCollisions != null) instance.checkCollisions = parsedInstance.checkCollisions;
            if (parsedInstance.pickable != undefined && parsedInstance.pickable != null) instance.isPickable = parsedInstance.pickable;
            if (parsedInstance.showBoundingBox != undefined && parsedInstance.showBoundingBox != null) instance.showBoundingBox = parsedInstance.showBoundingBox;
            if (parsedInstance.showSubMeshesBoundingBox != undefined && parsedInstance.showSubMeshesBoundingBox != null) instance.showSubMeshesBoundingBox = parsedInstance.showSubMeshesBoundingBox;
            if (parsedInstance.alphaIndex != undefined && parsedInstance.showSubMeshesBoundingBox != null) instance.alphaIndex = parsedInstance.alphaIndex;
            // Physics
            if (parsedInstance.physicsImpostor) $b0df7c384622c537$export$e176487c05830cc5._PhysicsImpostorParser(scene, instance, parsedInstance);
            // Actions
            if (parsedInstance.actions !== undefined) instance._waitingData.actions = parsedInstance.actions;
            // Animation
            if (parsedInstance.animations) {
                for(let animationIndex = 0; animationIndex < parsedInstance.animations.length; animationIndex++){
                    const parsedAnimation = parsedInstance.animations[animationIndex];
                    const internalClass = (0, $8DoUR.GetClass)("BABYLON.Animation");
                    if (internalClass) instance.animations.push(internalClass.Parse(parsedAnimation));
                }
                (0, $bgssx.Node).ParseAnimationRanges(instance, parsedInstance, scene);
                if (parsedInstance.autoAnimate) scene.beginAnimation(instance, parsedInstance.autoAnimateFrom, parsedInstance.autoAnimateTo, parsedInstance.autoAnimateLoop, parsedInstance.autoAnimateSpeed || 1.0);
            }
        }
        // Thin instances
        if (parsedMesh.thinInstances) {
            const thinInstances = parsedMesh.thinInstances;
            mesh.thinInstanceEnablePicking = !!thinInstances.enablePicking;
            if (thinInstances.matrixData) {
                mesh.thinInstanceSetBuffer("matrix", new Float32Array(thinInstances.matrixData), 16, false);
                mesh._thinInstanceDataStorage.matrixBufferSize = thinInstances.matrixBufferSize;
                mesh._thinInstanceDataStorage.instancesCount = thinInstances.instancesCount;
            } else mesh._thinInstanceDataStorage.matrixBufferSize = thinInstances.matrixBufferSize;
            if (parsedMesh.thinInstances.userThinInstance) {
                const userThinInstance = parsedMesh.thinInstances.userThinInstance;
                for(const kind in userThinInstance.data){
                    mesh.thinInstanceSetBuffer(kind, new Float32Array(userThinInstance.data[kind]), userThinInstance.strides[kind], false);
                    mesh._userThinInstanceBuffersStorage.sizes[kind] = userThinInstance.sizes[kind];
                }
            }
        }
        return mesh;
    }
    // Skeletons
    /**
     * Prepare internal position array for software CPU skinning
     * @returns original positions used for CPU skinning. Useful for integrating Morphing with skeletons in same mesh
     */ setPositionsForCPUSkinning() {
        const internalDataInfo = this._internalMeshDataInfo;
        if (!internalDataInfo._sourcePositions) {
            const source = this.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
            if (!source) return internalDataInfo._sourcePositions;
            internalDataInfo._sourcePositions = new Float32Array(source);
            if (!this.isVertexBufferUpdatable((0, $b4i1f.VertexBuffer).PositionKind)) this.setVerticesData((0, $b4i1f.VertexBuffer).PositionKind, source, true);
        }
        return internalDataInfo._sourcePositions;
    }
    /**
     * Prepare internal normal array for software CPU skinning
     * @returns original normals used for CPU skinning. Useful for integrating Morphing with skeletons in same mesh.
     */ setNormalsForCPUSkinning() {
        const internalDataInfo = this._internalMeshDataInfo;
        if (!internalDataInfo._sourceNormals) {
            const source = this.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind);
            if (!source) return internalDataInfo._sourceNormals;
            internalDataInfo._sourceNormals = new Float32Array(source);
            if (!this.isVertexBufferUpdatable((0, $b4i1f.VertexBuffer).NormalKind)) this.setVerticesData((0, $b4i1f.VertexBuffer).NormalKind, source, true);
        }
        return internalDataInfo._sourceNormals;
    }
    /**
     * Updates the vertex buffer by applying transformation from the bones
     * @param skeleton defines the skeleton to apply to current mesh
     * @returns the current mesh
     */ applySkeleton(skeleton) {
        if (!this.geometry) return this;
        if (this.geometry._softwareSkinningFrameId == this.getScene().getFrameId()) return this;
        this.geometry._softwareSkinningFrameId = this.getScene().getFrameId();
        if (!this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).PositionKind)) return this;
        if (!this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).MatricesIndicesKind)) return this;
        if (!this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).MatricesWeightsKind)) return this;
        const hasNormals = this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).NormalKind);
        const internalDataInfo = this._internalMeshDataInfo;
        if (!internalDataInfo._sourcePositions) {
            const submeshes = this.subMeshes.slice();
            this.setPositionsForCPUSkinning();
            this.subMeshes = submeshes;
        }
        if (hasNormals && !internalDataInfo._sourceNormals) this.setNormalsForCPUSkinning();
        // positionsData checks for not being Float32Array will only pass at most once
        let positionsData = this.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        if (!positionsData) return this;
        if (!(positionsData instanceof Float32Array)) positionsData = new Float32Array(positionsData);
        // normalsData checks for not being Float32Array will only pass at most once
        let normalsData = this.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind);
        if (hasNormals) {
            if (!normalsData) return this;
            if (!(normalsData instanceof Float32Array)) normalsData = new Float32Array(normalsData);
        }
        const matricesIndicesData = this.getVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesKind);
        const matricesWeightsData = this.getVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsKind);
        if (!matricesWeightsData || !matricesIndicesData) return this;
        const needExtras = this.numBoneInfluencers > 4;
        const matricesIndicesExtraData = needExtras ? this.getVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind) : null;
        const matricesWeightsExtraData = needExtras ? this.getVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind) : null;
        const skeletonMatrices = skeleton.getTransformMatrices(this);
        const tempVector3 = (0, $ha1VO.Vector3).Zero();
        const finalMatrix = new (0, $ha1VO.Matrix)();
        const tempMatrix = new (0, $ha1VO.Matrix)();
        let matWeightIdx = 0;
        let inf;
        for(let index = 0; index < positionsData.length; index += 3, matWeightIdx += 4){
            let weight;
            for(inf = 0; inf < 4; inf++){
                weight = matricesWeightsData[matWeightIdx + inf];
                if (weight > 0) {
                    (0, $ha1VO.Matrix).FromFloat32ArrayToRefScaled(skeletonMatrices, Math.floor(matricesIndicesData[matWeightIdx + inf] * 16), weight, tempMatrix);
                    finalMatrix.addToSelf(tempMatrix);
                }
            }
            if (needExtras) for(inf = 0; inf < 4; inf++){
                weight = matricesWeightsExtraData[matWeightIdx + inf];
                if (weight > 0) {
                    (0, $ha1VO.Matrix).FromFloat32ArrayToRefScaled(skeletonMatrices, Math.floor(matricesIndicesExtraData[matWeightIdx + inf] * 16), weight, tempMatrix);
                    finalMatrix.addToSelf(tempMatrix);
                }
            }
            (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(internalDataInfo._sourcePositions[index], internalDataInfo._sourcePositions[index + 1], internalDataInfo._sourcePositions[index + 2], finalMatrix, tempVector3);
            tempVector3.toArray(positionsData, index);
            if (hasNormals) {
                (0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(internalDataInfo._sourceNormals[index], internalDataInfo._sourceNormals[index + 1], internalDataInfo._sourceNormals[index + 2], finalMatrix, tempVector3);
                tempVector3.toArray(normalsData, index);
            }
            finalMatrix.reset();
        }
        this.updateVerticesData((0, $b4i1f.VertexBuffer).PositionKind, positionsData);
        if (hasNormals) this.updateVerticesData((0, $b4i1f.VertexBuffer).NormalKind, normalsData);
        return this;
    }
    // Tools
    /**
     * Returns an object containing a min and max Vector3 which are the minimum and maximum vectors of each mesh bounding box from the passed array, in the world coordinates
     * @param meshes defines the list of meshes to scan
     * @returns an object `{min:` Vector3`, max:` Vector3`}`
     */ static MinMax(meshes) {
        let minVector = null;
        let maxVector = null;
        meshes.forEach(function(mesh) {
            const boundingInfo = mesh.getBoundingInfo();
            const boundingBox = boundingInfo.boundingBox;
            if (!minVector || !maxVector) {
                minVector = boundingBox.minimumWorld;
                maxVector = boundingBox.maximumWorld;
            } else {
                minVector.minimizeInPlace(boundingBox.minimumWorld);
                maxVector.maximizeInPlace(boundingBox.maximumWorld);
            }
        });
        if (!minVector || !maxVector) return {
            min: (0, $ha1VO.Vector3).Zero(),
            max: (0, $ha1VO.Vector3).Zero()
        };
        return {
            min: minVector,
            max: maxVector
        };
    }
    /**
     * Returns the center of the `{min:` Vector3`, max:` Vector3`}` or the center of MinMax vector3 computed from a mesh array
     * @param meshesOrMinMaxVector could be an array of meshes or a `{min:` Vector3`, max:` Vector3`}` object
     * @returns a vector3
     */ static Center(meshesOrMinMaxVector) {
        const minMaxVector = meshesOrMinMaxVector instanceof Array ? $b0df7c384622c537$export$e176487c05830cc5.MinMax(meshesOrMinMaxVector) : meshesOrMinMaxVector;
        return (0, $ha1VO.Vector3).Center(minMaxVector.min, minMaxVector.max);
    }
    /**
     * Merge the array of meshes into a single mesh for performance reasons.
     * @param meshes array of meshes with the vertices to merge. Entries cannot be empty meshes.
     * @param disposeSource when true (default), dispose of the vertices from the source meshes.
     * @param allow32BitsIndices when the sum of the vertices > 64k, this must be set to true.
     * @param meshSubclass (optional) can be set to a Mesh where the merged vertices will be inserted.
     * @param subdivideWithSubMeshes when true (false default), subdivide mesh into subMeshes.
     * @param multiMultiMaterials when true (false default), subdivide mesh into subMeshes with multiple materials, ignores subdivideWithSubMeshes.
     * @returns a new mesh
     */ static MergeMeshes(meshes, disposeSource = true, allow32BitsIndices, meshSubclass, subdivideWithSubMeshes, multiMultiMaterials) {
        return (0, $4TYUE.runCoroutineSync)($b0df7c384622c537$export$e176487c05830cc5._MergeMeshesCoroutine(meshes, disposeSource, allow32BitsIndices, meshSubclass, subdivideWithSubMeshes, multiMultiMaterials, false));
    }
    /**
     * Merge the array of meshes into a single mesh for performance reasons.
     * @param meshes array of meshes with the vertices to merge. Entries cannot be empty meshes.
     * @param disposeSource when true (default), dispose of the vertices from the source meshes.
     * @param allow32BitsIndices when the sum of the vertices > 64k, this must be set to true.
     * @param meshSubclass (optional) can be set to a Mesh where the merged vertices will be inserted.
     * @param subdivideWithSubMeshes when true (false default), subdivide mesh into subMeshes.
     * @param multiMultiMaterials when true (false default), subdivide mesh into subMeshes with multiple materials, ignores subdivideWithSubMeshes.
     * @returns a new mesh
     */ static MergeMeshesAsync(meshes, disposeSource = true, allow32BitsIndices, meshSubclass, subdivideWithSubMeshes, multiMultiMaterials) {
        return (0, $4TYUE.runCoroutineAsync)($b0df7c384622c537$export$e176487c05830cc5._MergeMeshesCoroutine(meshes, disposeSource, allow32BitsIndices, meshSubclass, subdivideWithSubMeshes, multiMultiMaterials, true), (0, $4TYUE.createYieldingScheduler)());
    }
    static *_MergeMeshesCoroutine(meshes, disposeSource = true, allow32BitsIndices, meshSubclass, subdivideWithSubMeshes, multiMultiMaterials, isAsync) {
        // Remove any null/undefined entries from the mesh array
        meshes = meshes.filter(Boolean);
        if (meshes.length === 0) return null;
        let index;
        if (!allow32BitsIndices) {
            let totalVertices = 0;
            // Counting vertices
            for(index = 0; index < meshes.length; index++){
                totalVertices += meshes[index].getTotalVertices();
                if (totalVertices >= 65536) {
                    (0, $kVtWi.Logger).Warn("Cannot merge meshes because resulting mesh will have more than 65536 vertices. Please use allow32BitsIndices = true to use 32 bits indices");
                    return null;
                }
            }
        }
        if (multiMultiMaterials) subdivideWithSubMeshes = false;
        const materialArray = new Array();
        const materialIndexArray = new Array();
        // Merge
        const indiceArray = new Array();
        const currentOverrideMaterialSideOrientation = meshes[0].overrideMaterialSideOrientation;
        for(index = 0; index < meshes.length; index++){
            const mesh = meshes[index];
            if (mesh.isAnInstance) {
                (0, $kVtWi.Logger).Warn("Cannot merge instance meshes.");
                return null;
            }
            if (currentOverrideMaterialSideOrientation !== mesh.overrideMaterialSideOrientation) {
                (0, $kVtWi.Logger).Warn("Cannot merge meshes with different overrideMaterialSideOrientation values.");
                return null;
            }
            if (subdivideWithSubMeshes) indiceArray.push(mesh.getTotalIndices());
            if (multiMultiMaterials) {
                if (mesh.material) {
                    const material = mesh.material;
                    if (material instanceof (0, $3zFLd.MultiMaterial)) {
                        for(let matIndex = 0; matIndex < material.subMaterials.length; matIndex++)if (materialArray.indexOf(material.subMaterials[matIndex]) < 0) materialArray.push(material.subMaterials[matIndex]);
                        for(let subIndex = 0; subIndex < mesh.subMeshes.length; subIndex++){
                            materialIndexArray.push(materialArray.indexOf(material.subMaterials[mesh.subMeshes[subIndex].materialIndex]));
                            indiceArray.push(mesh.subMeshes[subIndex].indexCount);
                        }
                    } else {
                        if (materialArray.indexOf(material) < 0) materialArray.push(material);
                        for(let subIndex = 0; subIndex < mesh.subMeshes.length; subIndex++){
                            materialIndexArray.push(materialArray.indexOf(material));
                            indiceArray.push(mesh.subMeshes[subIndex].indexCount);
                        }
                    }
                } else for(let subIndex = 0; subIndex < mesh.subMeshes.length; subIndex++){
                    materialIndexArray.push(0);
                    indiceArray.push(mesh.subMeshes[subIndex].indexCount);
                }
            }
        }
        const source = meshes[0];
        const getVertexDataFromMesh = (mesh)=>{
            const wm = mesh.computeWorldMatrix(true);
            const vertexData = (0, $5v6ry.VertexData).ExtractFromMesh(mesh, false, false);
            return {
                vertexData: vertexData,
                transform: wm
            };
        };
        const { vertexData: sourceVertexData, transform: sourceTransform } = getVertexDataFromMesh(source);
        if (isAsync) yield;
        const meshVertexDatas = new Array(meshes.length - 1);
        for(let i = 1; i < meshes.length; i++){
            meshVertexDatas[i - 1] = getVertexDataFromMesh(meshes[i]);
            if (isAsync) yield;
        }
        const mergeCoroutine = sourceVertexData._mergeCoroutine(sourceTransform, meshVertexDatas, allow32BitsIndices, isAsync, !disposeSource);
        let mergeCoroutineStep = mergeCoroutine.next();
        while(!mergeCoroutineStep.done){
            if (isAsync) yield;
            mergeCoroutineStep = mergeCoroutine.next();
        }
        const vertexData = mergeCoroutineStep.value;
        if (!meshSubclass) meshSubclass = new $b0df7c384622c537$export$e176487c05830cc5(source.name + "_merged", source.getScene());
        const applyToCoroutine = vertexData._applyToCoroutine(meshSubclass, undefined, isAsync);
        let applyToCoroutineStep = applyToCoroutine.next();
        while(!applyToCoroutineStep.done){
            if (isAsync) yield;
            applyToCoroutineStep = applyToCoroutine.next();
        }
        // Setting properties
        meshSubclass.checkCollisions = source.checkCollisions;
        meshSubclass.overrideMaterialSideOrientation = source.overrideMaterialSideOrientation;
        // Cleaning
        if (disposeSource) for(index = 0; index < meshes.length; index++)meshes[index].dispose();
        // Subdivide
        if (subdivideWithSubMeshes || multiMultiMaterials) {
            //-- removal of global submesh
            meshSubclass.releaseSubMeshes();
            index = 0;
            let offset = 0;
            //-- apply subdivision according to index table
            while(index < indiceArray.length){
                (0, $lEBSs.SubMesh).CreateFromIndices(0, offset, indiceArray[index], meshSubclass, undefined, false);
                offset += indiceArray[index];
                index++;
            }
            for (const subMesh of meshSubclass.subMeshes)subMesh.refreshBoundingInfo();
            meshSubclass.computeWorldMatrix(true);
        }
        if (multiMultiMaterials) {
            const newMultiMaterial = new (0, $3zFLd.MultiMaterial)(source.name + "_merged", source.getScene());
            newMultiMaterial.subMaterials = materialArray;
            for(let subIndex = 0; subIndex < meshSubclass.subMeshes.length; subIndex++)meshSubclass.subMeshes[subIndex].materialIndex = materialIndexArray[subIndex];
            meshSubclass.material = newMultiMaterial;
        } else meshSubclass.material = source.material;
        return meshSubclass;
    }
    /**
     * @internal
     */ addInstance(instance) {
        instance._indexInSourceMeshInstanceArray = this.instances.length;
        this.instances.push(instance);
    }
    /**
     * @internal
     */ removeInstance(instance) {
        // Remove from mesh
        const index = instance._indexInSourceMeshInstanceArray;
        if (index != -1) {
            if (index !== this.instances.length - 1) {
                const last = this.instances[this.instances.length - 1];
                this.instances[index] = last;
                last._indexInSourceMeshInstanceArray = index;
            }
            instance._indexInSourceMeshInstanceArray = -1;
            this.instances.pop();
        }
    }
    /** @internal */ _shouldConvertRHS() {
        return this.overrideMaterialSideOrientation === (0, $54229.Material).CounterClockWiseSideOrientation;
    }
    /** @internal */ _getRenderingFillMode(fillMode) {
        const scene = this.getScene();
        if (scene.forcePointsCloud) return (0, $54229.Material).PointFillMode;
        if (scene.forceWireframe) return (0, $54229.Material).WireFrameFillMode;
        return this.overrideRenderingFillMode ?? fillMode;
    }
    // deprecated methods
    /**
     * Sets the mesh material by the material or multiMaterial `id` property
     * @param id is a string identifying the material or the multiMaterial
     * @returns the current mesh
     * @deprecated Please use MeshBuilder instead Please use setMaterialById instead
     */ setMaterialByID(id) {
        return this.setMaterialById(id);
    }
    /**
     * Creates a ribbon mesh.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param
     * @param name defines the name of the mesh to create
     * @param pathArray is a required array of paths, what are each an array of successive Vector3. The pathArray parameter depicts the ribbon geometry.
     * @param closeArray creates a seam between the first and the last paths of the path array (default is false)
     * @param closePath creates a seam between the first and the last points of each path of the path array
     * @param offset is taken in account only if the `pathArray` is containing a single path
     * @param scene defines the hosting scene
     * @param updatable defines if the mesh must be flagged as updatable
     * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
     * @param instance defines an instance of an existing Ribbon object to be updated with the passed `pathArray` parameter (https://doc.babylonjs.com/how_to/How_to_dynamically_morph_a_mesh#ribbon)
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreateRibbon(name, pathArray, closeArray, closePath, offset, scene, updatable, sideOrientation, instance) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates a plane polygonal mesh.  By default, this is a disc.
     * @param name defines the name of the mesh to create
     * @param radius sets the radius size (float) of the polygon (default 0.5)
     * @param tessellation sets the number of polygon sides (positive integer, default 64). So a tessellation valued to 3 will build a triangle, to 4 a square, etc
     * @param scene defines the hosting scene
     * @param updatable defines if the mesh must be flagged as updatable
     * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreateDisc(name, radius, tessellation, scene, updatable, sideOrientation) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates a box mesh.
     * @param name defines the name of the mesh to create
     * @param size sets the size (float) of each box side (default 1)
     * @param scene defines the hosting scene
     * @param updatable defines if the mesh must be flagged as updatable
     * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreateBox(name, size, scene, updatable, sideOrientation) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates a sphere mesh.
     * @param name defines the name of the mesh to create
     * @param segments sets the sphere number of horizontal stripes (positive integer, default 32)
     * @param diameter sets the diameter size (float) of the sphere (default 1)
     * @param scene defines the hosting scene
     * @param updatable defines if the mesh must be flagged as updatable
     * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreateSphere(name, segments, diameter, scene, updatable, sideOrientation) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates a hemisphere mesh.
     * @param name defines the name of the mesh to create
     * @param segments sets the sphere number of horizontal stripes (positive integer, default 32)
     * @param diameter sets the diameter size (float) of the sphere (default 1)
     * @param scene defines the hosting scene
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreateHemisphere(name, segments, diameter, scene) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates a cylinder or a cone mesh.
     * @param name defines the name of the mesh to create
     * @param height sets the height size (float) of the cylinder/cone (float, default 2)
     * @param diameterTop set the top cap diameter (floats, default 1)
     * @param diameterBottom set the bottom cap diameter (floats, default 1). This value can't be zero
     * @param tessellation sets the number of cylinder sides (positive integer, default 24). Set it to 3 to get a prism for instance
     * @param subdivisions sets the number of rings along the cylinder height (positive integer, default 1)
     * @param scene defines the hosting scene
     * @param updatable defines if the mesh must be flagged as updatable
     * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreateCylinder(name, height, diameterTop, diameterBottom, tessellation, subdivisions, scene, updatable, sideOrientation) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    // Torus  (Code from SharpDX.org)
    /**
     * Creates a torus mesh.
     * @param name defines the name of the mesh to create
     * @param diameter sets the diameter size (float) of the torus (default 1)
     * @param thickness sets the diameter size of the tube of the torus (float, default 0.5)
     * @param tessellation sets the number of torus sides (positive integer, default 16)
     * @param scene defines the hosting scene
     * @param updatable defines if the mesh must be flagged as updatable
     * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreateTorus(name, diameter, thickness, tessellation, scene, updatable, sideOrientation) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates a torus knot mesh.
     * @param name defines the name of the mesh to create
     * @param radius sets the global radius size (float) of the torus knot (default 2)
     * @param tube sets the diameter size of the tube of the torus (float, default 0.5)
     * @param radialSegments sets the number of sides on each tube segments (positive integer, default 32)
     * @param tubularSegments sets the number of tubes to decompose the knot into (positive integer, default 32)
     * @param p the number of windings on X axis (positive integers, default 2)
     * @param q the number of windings on Y axis (positive integers, default 3)
     * @param scene defines the hosting scene
     * @param updatable defines if the mesh must be flagged as updatable
     * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreateTorusKnot(name, radius, tube, radialSegments, tubularSegments, p, q, scene, updatable, sideOrientation) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates a line mesh..
     * @param name defines the name of the mesh to create
     * @param points is an array successive Vector3
     * @param scene defines the hosting scene
     * @param updatable defines if the mesh must be flagged as updatable
     * @param instance is an instance of an existing LineMesh object to be updated with the passed `points` parameter (https://doc.babylonjs.com/how_to/How_to_dynamically_morph_a_mesh#lines-and-dashedlines).
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreateLines(name, points, scene, updatable, instance) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates a dashed line mesh.
     * @param name defines the name of the mesh to create
     * @param points is an array successive Vector3
     * @param dashSize is the size of the dashes relatively the dash number (positive float, default 3)
     * @param gapSize is the size of the gap between two successive dashes relatively the dash number (positive float, default 1)
     * @param dashNb is the intended total number of dashes (positive integer, default 200)
     * @param scene defines the hosting scene
     * @param updatable defines if the mesh must be flagged as updatable
     * @param instance is an instance of an existing LineMesh object to be updated with the passed `points` parameter (https://doc.babylonjs.com/how_to/How_to_dynamically_morph_a_mesh#lines-and-dashedlines)
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreateDashedLines(name, points, dashSize, gapSize, dashNb, scene, updatable, instance) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates a polygon mesh.Please consider using the same method from the MeshBuilder class instead
     * The polygon's shape will depend on the input parameters and is constructed parallel to a ground mesh.
     * The parameter `shape` is a required array of successive Vector3 representing the corners of the polygon in th XoZ plane, that is y = 0 for all vectors.
     * You can set the mesh side orientation with the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created.
     * Remember you can only change the shape positions, not their number when updating a polygon.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param#non-regular-polygon
     * @param name defines the name of the mesh to create
     * @param shape is a required array of successive Vector3 representing the corners of the polygon in th XoZ plane, that is y = 0 for all vectors
     * @param scene defines the hosting scene
     * @param holes is a required array of arrays of successive Vector3 used to defines holes in the polygon
     * @param updatable defines if the mesh must be flagged as updatable
     * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
     * @param earcutInjection can be used to inject your own earcut reference
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreatePolygon(name, shape, scene, holes, updatable, sideOrientation, earcutInjection) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates an extruded polygon mesh, with depth in the Y direction..
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param#extruded-non-regular-polygon
     * @param name defines the name of the mesh to create
     * @param shape is a required array of successive Vector3 representing the corners of the polygon in th XoZ plane, that is y = 0 for all vectors
     * @param depth defines the height of extrusion
     * @param scene defines the hosting scene
     * @param holes is a required array of arrays of successive Vector3 used to defines holes in the polygon
     * @param updatable defines if the mesh must be flagged as updatable
     * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
     * @param earcutInjection can be used to inject your own earcut reference
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static ExtrudePolygon(name, shape, depth, scene, holes, updatable, sideOrientation, earcutInjection) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates an extruded shape mesh.
     * The extrusion is a parametric shape. It has no predefined shape. Its final shape will depend on the input parameters.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param#extruded-shapes
     * @param name defines the name of the mesh to create
     * @param shape is a required array of successive Vector3. This array depicts the shape to be extruded in its local space : the shape must be designed in the xOy plane and will be extruded along the Z axis
     * @param path is a required array of successive Vector3. This is the axis curve the shape is extruded along
     * @param scale is the value to scale the shape
     * @param rotation is the angle value to rotate the shape each step (each path point), from the former step (so rotation added each step) along the curve
     * @param cap sets the way the extruded shape is capped. Possible values : Mesh.NO_CAP (default), Mesh.CAP_START, Mesh.CAP_END, Mesh.CAP_ALL
     * @param scene defines the hosting scene
     * @param updatable defines if the mesh must be flagged as updatable
     * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
     * @param instance is an instance of an existing ExtrudedShape object to be updated with the passed `shape`, `path`, `scale` or `rotation` parameters (https://doc.babylonjs.com/how_to/How_to_dynamically_morph_a_mesh#extruded-shape)
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static ExtrudeShape(name, shape, path, scale, rotation, cap, scene, updatable, sideOrientation, instance) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates an custom extruded shape mesh.
     * The custom extrusion is a parametric shape.
     * It has no predefined shape. Its final shape will depend on the input parameters.
     *
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param#extruded-shapes
     * @param name defines the name of the mesh to create
     * @param shape is a required array of successive Vector3. This array depicts the shape to be extruded in its local space : the shape must be designed in the xOy plane and will be extruded along the Z axis
     * @param path is a required array of successive Vector3. This is the axis curve the shape is extruded along
     * @param scaleFunction is a custom Javascript function called on each path point
     * @param rotationFunction is a custom Javascript function called on each path point
     * @param ribbonCloseArray forces the extrusion underlying ribbon to close all the paths in its `pathArray`
     * @param ribbonClosePath forces the extrusion underlying ribbon to close its `pathArray`
     * @param cap sets the way the extruded shape is capped. Possible values : Mesh.NO_CAP (default), Mesh.CAP_START, Mesh.CAP_END, Mesh.CAP_ALL
     * @param scene defines the hosting scene
     * @param updatable defines if the mesh must be flagged as updatable
     * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
     * @param instance is an instance of an existing ExtrudedShape object to be updated with the passed `shape`, `path`, `scale` or `rotation` parameters (https://doc.babylonjs.com/features/featuresDeepDive/mesh/dynamicMeshMorph#extruded-shape)
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static ExtrudeShapeCustom(name, shape, path, scaleFunction, rotationFunction, ribbonCloseArray, ribbonClosePath, cap, scene, updatable, sideOrientation, instance) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates lathe mesh.
     * The lathe is a shape with a symmetry axis : a 2D model shape is rotated around this axis to design the lathe.
     * @param name defines the name of the mesh to create
     * @param shape is a required array of successive Vector3. This array depicts the shape to be rotated in its local space : the shape must be designed in the xOy plane and will be rotated around the Y axis. It's usually a 2D shape, so the Vector3 z coordinates are often set to zero
     * @param radius is the radius value of the lathe
     * @param tessellation is the side number of the lathe.
     * @param scene defines the hosting scene
     * @param updatable defines if the mesh must be flagged as updatable
     * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreateLathe(name, shape, radius, tessellation, scene, updatable, sideOrientation) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates a plane mesh.
     * @param name defines the name of the mesh to create
     * @param size sets the size (float) of both sides of the plane at once (default 1)
     * @param scene defines the hosting scene
     * @param updatable defines if the mesh must be flagged as updatable
     * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreatePlane(name, size, scene, updatable, sideOrientation) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates a ground mesh.
     * @param name defines the name of the mesh to create
     * @param width set the width of the ground
     * @param height set the height of the ground
     * @param subdivisions sets the number of subdivisions per side
     * @param scene defines the hosting scene
     * @param updatable defines if the mesh must be flagged as updatable
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreateGround(name, width, height, subdivisions, scene, updatable) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates a tiled ground mesh.
     * @param name defines the name of the mesh to create
     * @param xmin set the ground minimum X coordinate
     * @param zmin set the ground minimum Y coordinate
     * @param xmax set the ground maximum X coordinate
     * @param zmax set the ground maximum Z coordinate
     * @param subdivisions is an object `{w: positive integer, h: positive integer}` (default `{w: 6, h: 6}`). `w` and `h` are the numbers of subdivisions on the ground width and height. Each subdivision is called a tile
     * @param precision is an object `{w: positive integer, h: positive integer}` (default `{w: 2, h: 2}`). `w` and `h` are the numbers of subdivisions on the ground width and height of each tile
     * @param scene defines the hosting scene
     * @param updatable defines if the mesh must be flagged as updatable
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreateTiledGround(name, xmin, zmin, xmax, zmax, subdivisions, precision, scene, updatable) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates a ground mesh from a height map.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set/height_map
     * @param name defines the name of the mesh to create
     * @param url sets the URL of the height map image resource
     * @param width set the ground width size
     * @param height set the ground height size
     * @param subdivisions sets the number of subdivision per side
     * @param minHeight is the minimum altitude on the ground
     * @param maxHeight is the maximum altitude on the ground
     * @param scene defines the hosting scene
     * @param updatable defines if the mesh must be flagged as updatable
     * @param onReady  is a callback function that will be called  once the mesh is built (the height map download can last some time)
     * @param alphaFilter will filter any data where the alpha channel is below this value, defaults 0 (all data visible)
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreateGroundFromHeightMap(name, url, width, height, subdivisions, minHeight, maxHeight, scene, updatable, onReady, alphaFilter) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates a tube mesh.
     * The tube is a parametric shape.
     * It has no predefined shape. Its final shape will depend on the input parameters.
     *
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param
     * @param name defines the name of the mesh to create
     * @param path is a required array of successive Vector3. It is the curve used as the axis of the tube
     * @param radius sets the tube radius size
     * @param tessellation is the number of sides on the tubular surface
     * @param radiusFunction is a custom function. If it is not null, it overrides the parameter `radius`. This function is called on each point of the tube path and is passed the index `i` of the i-th point and the distance of this point from the first point of the path
     * @param cap sets the way the extruded shape is capped. Possible values : Mesh.NO_CAP (default), Mesh.CAP_START, Mesh.CAP_END, Mesh.CAP_ALL
     * @param scene defines the hosting scene
     * @param updatable defines if the mesh must be flagged as updatable
     * @param sideOrientation defines the mesh side orientation (https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation)
     * @param instance is an instance of an existing Tube object to be updated with the passed `pathArray` parameter (https://doc.babylonjs.com/how_to/How_to_dynamically_morph_a_mesh#tube)
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreateTube(name, path, radius, tessellation, radiusFunction, cap, scene, updatable, sideOrientation, instance) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates a polyhedron mesh.
     *.
     * * The parameter `type` (positive integer, max 14, default 0) sets the polyhedron type to build among the 15 embedded types. Please refer to the type sheet in the tutorial to choose the wanted type
     * * The parameter `size` (positive float, default 1) sets the polygon size
     * * You can overwrite the `size` on each dimension bu using the parameters `sizeX`, `sizeY` or `sizeZ` (positive floats, default to `size` value)
     * * You can build other polyhedron types than the 15 embbeded ones by setting the parameter `custom` (`polyhedronObject`, default null). If you set the parameter `custom`, this overwrittes the parameter `type`
     * * A `polyhedronObject` is a formatted javascript object. You'll find a full file with pre-set polyhedra here : https://github.com/BabylonJS/Extensions/tree/master/Polyhedron
     * * You can set the color and the UV of each side of the polyhedron with the parameters `faceColors` (Color4, default `(1, 1, 1, 1)`) and faceUV (Vector4, default `(0, 0, 1, 1)`)
     * * To understand how to set `faceUV` or `faceColors`, please read this by considering the right number of faces of your polyhedron, instead of only 6 for the box : https://doc.babylonjs.com/features/featuresDeepDive/materials/using/texturePerBoxFace
     * * The parameter `flat` (boolean, default true). If set to false, it gives the polyhedron a single global face, so less vertices and shared normals. In this case, `faceColors` and `faceUV` are ignored
     * * You can also set the mesh side orientation with the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation
     * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
     * @param name defines the name of the mesh to create
     * @param options defines the options used to create the mesh
     * @param scene defines the hosting scene
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreatePolyhedron(name, options, scene) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates a sphere based upon an icosahedron with 20 triangular faces which can be subdivided
     * * The parameter `radius` sets the radius size (float) of the icosphere (default 1)
     * * You can set some different icosphere dimensions, for instance to build an ellipsoid, by using the parameters `radiusX`, `radiusY` and `radiusZ` (all by default have the same value than `radius`)
     * * The parameter `subdivisions` sets the number of subdivisions (positive integer, default 4). The more subdivisions, the more faces on the icosphere whatever its size
     * * The parameter `flat` (boolean, default true) gives each side its own normals. Set it to false to get a smooth continuous light reflection on the surface
     * * You can also set the mesh side orientation with the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * If you create a double-sided mesh, you can choose what parts of the texture image to crop and stick respectively on the front and the back sides with the parameters `frontUVs` and `backUVs` (Vector4). Detail here : https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/set#side-orientation
     * * The mesh can be set to updatable with the boolean parameter `updatable` (default false) if its internal geometry is supposed to change once created
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/polyhedra#icosphere
     * @param name defines the name of the mesh
     * @param options defines the options used to create the mesh
     * @param scene defines the hosting scene
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreateIcoSphere(name, options, scene) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Creates a decal mesh.
     *.
     * A decal is a mesh usually applied as a model onto the surface of another mesh
     * @param name  defines the name of the mesh
     * @param sourceMesh defines the mesh receiving the decal
     * @param position sets the position of the decal in world coordinates
     * @param normal sets the normal of the mesh where the decal is applied onto in world coordinates
     * @param size sets the decal scaling
     * @param angle sets the angle to rotate the decal
     * @returns a new Mesh
     * @deprecated Please use MeshBuilder instead
     */ static CreateDecal(name, sourceMesh, position, normal, size, angle) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /** Creates a Capsule Mesh
     * @param name defines the name of the mesh.
     * @param options the constructors options used to shape the mesh.
     * @param scene defines the scene the mesh is scoped to.
     * @returns the capsule mesh
     * @see https://doc.babylonjs.com/how_to/capsule_shape
     * @deprecated Please use MeshBuilder instead
     */ static CreateCapsule(name, options, scene) {
        throw new Error("Import MeshBuilder to populate this function");
    }
    /**
     * Extends a mesh to a Goldberg mesh
     * Warning  the mesh to convert MUST be an import of a perviously exported Goldberg mesh
     * @param mesh the mesh to convert
     * @returns the extended mesh
     * @deprecated Please use ExtendMeshToGoldberg instead
     */ static ExtendToGoldberg(mesh) {
        throw new Error("Import MeshBuilder to populate this function");
    }
}
// Consts
/**
 * Mesh side orientation : usually the external or front surface
 */ $b0df7c384622c537$export$e176487c05830cc5.FRONTSIDE = (0, $5v6ry.VertexData).FRONTSIDE;
/**
 * Mesh side orientation : usually the internal or back surface
 */ $b0df7c384622c537$export$e176487c05830cc5.BACKSIDE = (0, $5v6ry.VertexData).BACKSIDE;
/**
 * Mesh side orientation : both internal and external or front and back surfaces
 */ $b0df7c384622c537$export$e176487c05830cc5.DOUBLESIDE = (0, $5v6ry.VertexData).DOUBLESIDE;
/**
 * Mesh side orientation : by default, `FRONTSIDE`
 */ $b0df7c384622c537$export$e176487c05830cc5.DEFAULTSIDE = (0, $5v6ry.VertexData).DEFAULTSIDE;
/**
 * Mesh cap setting : no cap
 */ $b0df7c384622c537$export$e176487c05830cc5.NO_CAP = 0;
/**
 * Mesh cap setting : one cap at the beginning of the mesh
 */ $b0df7c384622c537$export$e176487c05830cc5.CAP_START = 1;
/**
 * Mesh cap setting : one cap at the end of the mesh
 */ $b0df7c384622c537$export$e176487c05830cc5.CAP_END = 2;
/**
 * Mesh cap setting : two caps, one at the beginning  and one at the end of the mesh
 */ $b0df7c384622c537$export$e176487c05830cc5.CAP_ALL = 3;
/**
 * Mesh pattern setting : no flip or rotate
 */ $b0df7c384622c537$export$e176487c05830cc5.NO_FLIP = 0;
/**
 * Mesh pattern setting : flip (reflect in y axis) alternate tiles on each row or column
 */ $b0df7c384622c537$export$e176487c05830cc5.FLIP_TILE = 1;
/**
 * Mesh pattern setting : rotate (180degs) alternate tiles on each row or column
 */ $b0df7c384622c537$export$e176487c05830cc5.ROTATE_TILE = 2;
/**
 * Mesh pattern setting : flip (reflect in y axis) all tiles on alternate rows
 */ $b0df7c384622c537$export$e176487c05830cc5.FLIP_ROW = 3;
/**
 * Mesh pattern setting : rotate (180degs) all tiles on alternate rows
 */ $b0df7c384622c537$export$e176487c05830cc5.ROTATE_ROW = 4;
/**
 * Mesh pattern setting : flip and rotate alternate tiles on each row or column
 */ $b0df7c384622c537$export$e176487c05830cc5.FLIP_N_ROTATE_TILE = 5;
/**
 * Mesh pattern setting : rotate pattern and rotate
 */ $b0df7c384622c537$export$e176487c05830cc5.FLIP_N_ROTATE_ROW = 6;
/**
 * Mesh tile positioning : part tiles same on left/right or top/bottom
 */ $b0df7c384622c537$export$e176487c05830cc5.CENTER = 0;
/**
 * Mesh tile positioning : part tiles on left
 */ $b0df7c384622c537$export$e176487c05830cc5.LEFT = 1;
/**
 * Mesh tile positioning : part tiles on right
 */ $b0df7c384622c537$export$e176487c05830cc5.RIGHT = 2;
/**
 * Mesh tile positioning : part tiles on top
 */ $b0df7c384622c537$export$e176487c05830cc5.TOP = 3;
/**
 * Mesh tile positioning : part tiles on bottom
 */ $b0df7c384622c537$export$e176487c05830cc5.BOTTOM = 4;
/**
 * Indicates that the instanced meshes should be sorted from back to front before rendering if their material is transparent
 */ $b0df7c384622c537$export$e176487c05830cc5.INSTANCEDMESH_SORT_TRANSPARENT = false;
// Statics
/**
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
$b0df7c384622c537$export$e176487c05830cc5._GroundMeshParser = (parsedMesh, scene)=>{
    throw (0, $dUFYy._WarnImport)("GroundMesh");
};
/**
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
$b0df7c384622c537$export$e176487c05830cc5._GoldbergMeshParser = (parsedMesh, scene)=>{
    throw (0, $dUFYy._WarnImport)("GoldbergMesh");
};
/**
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
$b0df7c384622c537$export$e176487c05830cc5._LinesMeshParser = (parsedMesh, scene)=>{
    throw (0, $dUFYy._WarnImport)("LinesMesh");
};
/**
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
$b0df7c384622c537$export$e176487c05830cc5._GreasedLineMeshParser = (parsedMesh, scene)=>{
    throw (0, $dUFYy._WarnImport)("GreasedLineMesh");
};
/**
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
$b0df7c384622c537$export$e176487c05830cc5._GreasedLineRibbonMeshParser = (parsedMesh, scene)=>{
    throw (0, $dUFYy._WarnImport)("GreasedLineRibbonMesh");
};
/**
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
$b0df7c384622c537$export$e176487c05830cc5._TrailMeshParser = (parsedMesh, scene)=>{
    throw (0, $dUFYy._WarnImport)("TrailMesh");
};
(0, $8DoUR.RegisterClass)("BABYLON.Mesh", $b0df7c384622c537$export$e176487c05830cc5);

});
parcelRegister("4TYUE", function(module, exports) {

$parcel$export(module.exports, "inlineScheduler", () => $391b8c7fee050f1f$export$a907eb56dd5ff8c2);
$parcel$export(module.exports, "createYieldingScheduler", () => $391b8c7fee050f1f$export$c074d25b4dc6a454);
$parcel$export(module.exports, "runCoroutine", () => $391b8c7fee050f1f$export$33a305be445da385);
$parcel$export(module.exports, "runCoroutineSync", () => $391b8c7fee050f1f$export$47bff35b05234608);
$parcel$export(module.exports, "runCoroutineAsync", () => $391b8c7fee050f1f$export$73fc13c1ca5fca48);
$parcel$export(module.exports, "makeSyncFunction", () => $391b8c7fee050f1f$export$7241269ae9cbc8ee);
$parcel$export(module.exports, "makeAsyncFunction", () => $391b8c7fee050f1f$export$9162d5b4b7d28c6c);
/* eslint-disable @typescript-eslint/naming-convention */ // "Coroutines are computer program components that generalize subroutines for non-preemptive multitasking, by allowing execution to be suspended and resumed."
// https://en.wikipedia.org/wiki/Coroutine
// The inline scheduler simply steps the coroutine synchronously. This is useful for running a coroutine synchronously, and also as a helper function for other schedulers.
/**
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
function $391b8c7fee050f1f$export$a907eb56dd5ff8c2(coroutine, onStep, onError) {
    try {
        const step = coroutine.next();
        if (step.done) onStep(step);
        else if (!step.value) // NOTE: The properties of step have been narrowed, but the type of step itself is not narrowed, so the cast below is the most type safe way to deal with this without instantiating a new object to hold the values.
        onStep(step);
        else step.value.then(()=>{
            step.value = undefined;
            onStep(step);
        }, onError);
    } catch (error) {
        onError(error);
    }
}
function $391b8c7fee050f1f$export$c074d25b4dc6a454(yieldAfterMS = 25) {
    let startTime;
    return (coroutine, onStep, onError)=>{
        const currentTime = performance.now();
        if (startTime === undefined || currentTime - startTime > yieldAfterMS) {
            // If this is the first coroutine step, or if the time interval has elapsed, record a new start time, and schedule the coroutine step to happen later, effectively yielding control of the execution context.
            startTime = currentTime;
            setTimeout(()=>{
                $391b8c7fee050f1f$export$a907eb56dd5ff8c2(coroutine, onStep, onError);
            }, 0);
        } else // Otherwise it is not time to yield yet, so step the coroutine synchronously.
        $391b8c7fee050f1f$export$a907eb56dd5ff8c2(coroutine, onStep, onError);
    };
}
function $391b8c7fee050f1f$export$33a305be445da385(coroutine, scheduler, onSuccess, onError, abortSignal) {
    const resume = ()=>{
        let reschedule;
        const onStep = (stepResult)=>{
            if (stepResult.done) // If the coroutine is done, report success.
            onSuccess(stepResult.value);
            else // If the coroutine is not done, resume the coroutine (via the scheduler).
            if (reschedule === undefined) // If reschedule is undefined at this point, then the coroutine must have stepped synchronously, so just flag another loop iteration.
            reschedule = true;
            else // If reschedule is defined at this point, then the coroutine must have stepped asynchronously, so call resume to restart the step loop.
            resume();
        };
        do {
            reschedule = undefined;
            if (!abortSignal || !abortSignal.aborted) scheduler(coroutine, onStep, onError);
            else onError(new Error("Aborted"));
            if (reschedule === undefined) // If reschedule is undefined at this point, then the coroutine must have stepped asynchronously, so stop looping and let the coroutine be resumed later.
            reschedule = false;
        }while (reschedule);
    };
    resume();
}
function $391b8c7fee050f1f$export$47bff35b05234608(coroutine, abortSignal) {
    // Run the coroutine with the inline scheduler, storing the returned value, or re-throwing the error (since the error callback will be called synchronously by the inline scheduler).
    let result;
    $391b8c7fee050f1f$export$33a305be445da385(coroutine, $391b8c7fee050f1f$export$a907eb56dd5ff8c2, (r)=>result = r, (e)=>{
        throw e;
    }, abortSignal);
    // Synchronously return the result of the coroutine.
    return result;
}
function $391b8c7fee050f1f$export$73fc13c1ca5fca48(coroutine, scheduler, abortSignal) {
    // Run the coroutine with a yielding scheduler, resolving or rejecting the result promise when the coroutine finishes.
    return new Promise((resolve, reject)=>{
        $391b8c7fee050f1f$export$33a305be445da385(coroutine, scheduler, resolve, reject, abortSignal);
    });
}
function $391b8c7fee050f1f$export$7241269ae9cbc8ee(coroutineFactory, abortSignal) {
    return (...params)=>{
        // Run the coroutine synchronously.
        return $391b8c7fee050f1f$export$47bff35b05234608(coroutineFactory(...params), abortSignal);
    };
}
function $391b8c7fee050f1f$export$9162d5b4b7d28c6c(coroutineFactory, scheduler, abortSignal) {
    return (...params)=>{
        // Run the coroutine asynchronously.
        return $391b8c7fee050f1f$export$73fc13c1ca5fca48(coroutineFactory(...params), scheduler, abortSignal);
    };
}

});

parcelRegister("74SKQ", function(module, exports) {

$parcel$export(module.exports, "Camera", () => $52736139c8513fb2$export$79f141de891a5fed);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $57onU = parcelRequire("57onU");

var $bOhSV = parcelRequire("bOhSV");

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $bgssx = parcelRequire("bgssx");

var $kVtWi = parcelRequire("kVtWi");

var $8DoUR = parcelRequire("8DoUR");

var $dUFYy = parcelRequire("dUFYy");

var $191mA = parcelRequire("191mA");

var $9sPMJ = parcelRequire("9sPMJ");

var $6Ho1L = parcelRequire("6Ho1L");
class $52736139c8513fb2$export$79f141de891a5fed extends (0, $bgssx.Node) {
    /**
     * Define the current local position of the camera in the scene
     */ get position() {
        return this._position;
    }
    set position(newPosition) {
        this._position = newPosition;
    }
    /**
     * The vector the camera should consider as up.
     * (default is Vector3(0, 1, 0) aka Vector3.Up())
     */ set upVector(vec) {
        this._upVector = vec;
    }
    get upVector() {
        return this._upVector;
    }
    /**
     * The screen area in scene units squared
     */ get screenArea() {
        let x = 0;
        let y = 0;
        if (this.mode === $52736139c8513fb2$export$79f141de891a5fed.PERSPECTIVE_CAMERA) {
            if (this.fovMode === $52736139c8513fb2$export$79f141de891a5fed.FOVMODE_VERTICAL_FIXED) {
                y = this.minZ * 2 * Math.tan(this.fov / 2);
                x = this.getEngine().getAspectRatio(this) * y;
            } else {
                x = this.minZ * 2 * Math.tan(this.fov / 2);
                y = x / this.getEngine().getAspectRatio(this);
            }
        } else {
            const halfWidth = this.getEngine().getRenderWidth() / 2.0;
            const halfHeight = this.getEngine().getRenderHeight() / 2.0;
            x = (this.orthoRight ?? halfWidth) - (this.orthoLeft ?? -halfWidth);
            y = (this.orthoTop ?? halfHeight) - (this.orthoBottom ?? -halfHeight);
        }
        return x * y;
    }
    /**
     * Define the current limit on the left side for an orthographic camera
     * In scene unit
     */ set orthoLeft(value) {
        this._orthoLeft = value;
        for (const rigCamera of this._rigCameras)rigCamera.orthoLeft = value;
    }
    get orthoLeft() {
        return this._orthoLeft;
    }
    /**
     * Define the current limit on the right side for an orthographic camera
     * In scene unit
     */ set orthoRight(value) {
        this._orthoRight = value;
        for (const rigCamera of this._rigCameras)rigCamera.orthoRight = value;
    }
    get orthoRight() {
        return this._orthoRight;
    }
    /**
     * Define the current limit on the bottom side for an orthographic camera
     * In scene unit
     */ set orthoBottom(value) {
        this._orthoBottom = value;
        for (const rigCamera of this._rigCameras)rigCamera.orthoBottom = value;
    }
    get orthoBottom() {
        return this._orthoBottom;
    }
    /**
     * Define the current limit on the top side for an orthographic camera
     * In scene unit
     */ set orthoTop(value) {
        this._orthoTop = value;
        for (const rigCamera of this._rigCameras)rigCamera.orthoTop = value;
    }
    get orthoTop() {
        return this._orthoTop;
    }
    /**
     * Define the mode of the camera (Camera.PERSPECTIVE_CAMERA or Camera.ORTHOGRAPHIC_CAMERA)
     */ set mode(mode) {
        this._mode = mode;
        // Pass the mode down to the rig cameras
        for (const rigCamera of this._rigCameras)rigCamera.mode = mode;
    }
    get mode() {
        return this._mode;
    }
    /**
     * Gets a flag indicating that the camera has moved in some way since the last call to Camera.update()
     */ get hasMoved() {
        return this._hasMoved;
    }
    /**
     * Instantiates a new camera object.
     * This should not be used directly but through the inherited cameras: ArcRotate, Free...
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras
     * @param name Defines the name of the camera in the scene
     * @param position Defines the position of the camera
     * @param scene Defines the scene the camera belongs too
     * @param setActiveOnSceneIfNoneActive Defines if the camera should be set as active after creation if no other camera have been defined in the scene
     */ constructor(name, position, scene, setActiveOnSceneIfNoneActive = true){
        super(name, scene);
        /** @internal */ this._position = (0, $ha1VO.Vector3).Zero();
        this._upVector = (0, $ha1VO.Vector3).Up();
        /**
         * Object containing oblique projection values (only used with ORTHOGRAPHIC_CAMERA)
         */ this.oblique = null;
        this._orthoLeft = null;
        this._orthoRight = null;
        this._orthoBottom = null;
        this._orthoTop = null;
        /**
         * Field Of View is set in Radians. (default is 0.8)
         */ this.fov = 0.8;
        /**
         * Projection plane tilt around the X axis (horizontal), set in Radians. (default is 0)
         * Can be used to make vertical lines in world space actually vertical on the screen.
         * See https://forum.babylonjs.com/t/add-vertical-shift-to-3ds-max-exporter-babylon-cameras/17480
         */ this.projectionPlaneTilt = 0;
        /**
         * Define the minimum distance the camera can see from.
         * This is important to note that the depth buffer are not infinite and the closer it starts
         * the more your scene might encounter depth fighting issue.
         */ this.minZ = 1;
        /**
         * Define the maximum distance the camera can see to.
         * This is important to note that the depth buffer are not infinite and the further it end
         * the more your scene might encounter depth fighting issue.
         */ this.maxZ = 10000.0;
        /**
         * Define the default inertia of the camera.
         * This helps giving a smooth feeling to the camera movement.
         */ this.inertia = 0.9;
        this._mode = $52736139c8513fb2$export$79f141de891a5fed.PERSPECTIVE_CAMERA;
        /**
         * Define whether the camera is intermediate.
         * This is useful to not present the output directly to the screen in case of rig without post process for instance
         */ this.isIntermediate = false;
        /**
         * Define the viewport of the camera.
         * This correspond to the portion of the screen the camera will render to in normalized 0 to 1 unit.
         */ this.viewport = new (0, $191mA.Viewport)(0, 0, 1.0, 1.0);
        /**
         * Restricts the camera to viewing objects with the same layerMask.
         * A camera with a layerMask of 1 will render mesh.layerMask & camera.layerMask!== 0
         */ this.layerMask = 0x0fffffff;
        /**
         * fovMode sets the camera frustum bounds to the viewport bounds. (default is FOVMODE_VERTICAL_FIXED)
         */ this.fovMode = $52736139c8513fb2$export$79f141de891a5fed.FOVMODE_VERTICAL_FIXED;
        /**
         * Rig mode of the camera.
         * This is useful to create the camera with two "eyes" instead of one to create VR or stereoscopic scenes.
         * This is normally controlled byt the camera themselves as internal use.
         */ this.cameraRigMode = $52736139c8513fb2$export$79f141de891a5fed.RIG_MODE_NONE;
        /**
         * Defines the list of custom render target which are rendered to and then used as the input to this camera's render. Eg. display another camera view on a TV in the main scene
         * This is pretty helpful if you wish to make a camera render to a texture you could reuse somewhere
         * else in the scene. (Eg. security camera)
         *
         * To change the final output target of the camera, camera.outputRenderTarget should be used instead (eg. webXR renders to a render target corresponding to an HMD)
         */ this.customRenderTargets = [];
        /**
         * When set, the camera will render to this render target instead of the default canvas
         *
         * If the desire is to use the output of a camera as a texture in the scene consider using camera.customRenderTargets instead
         */ this.outputRenderTarget = null;
        /**
         * Observable triggered when the camera view matrix has changed.
         */ this.onViewMatrixChangedObservable = new (0, $diGQf.Observable)();
        /**
         * Observable triggered when the camera Projection matrix has changed.
         */ this.onProjectionMatrixChangedObservable = new (0, $diGQf.Observable)();
        /**
         * Observable triggered when the inputs have been processed.
         */ this.onAfterCheckInputsObservable = new (0, $diGQf.Observable)();
        /**
         * Observable triggered when reset has been called and applied to the camera.
         */ this.onRestoreStateObservable = new (0, $diGQf.Observable)();
        /**
         * Is this camera a part of a rig system?
         */ this.isRigCamera = false;
        this._hasMoved = false;
        /** @internal */ this._rigCameras = new Array();
        /** @internal */ this._skipRendering = false;
        /** @internal */ this._projectionMatrix = new (0, $ha1VO.Matrix)();
        /** @internal */ this._postProcesses = new Array();
        /** @internal */ this._activeMeshes = new (0, $57onU.SmartArray)(256);
        this._globalPosition = (0, $ha1VO.Vector3).Zero();
        /** @internal */ this._computedViewMatrix = (0, $ha1VO.Matrix).Identity();
        this._doNotComputeProjectionMatrix = false;
        this._transformMatrix = (0, $ha1VO.Matrix).Zero();
        this._refreshFrustumPlanes = true;
        this._absoluteRotation = (0, $ha1VO.Quaternion).Identity();
        /** @internal */ this._isCamera = true;
        /** @internal */ this._isLeftCamera = false;
        /** @internal */ this._isRightCamera = false;
        this.getScene().addCamera(this);
        if (setActiveOnSceneIfNoneActive && !this.getScene().activeCamera) this.getScene().activeCamera = this;
        this.position = position;
        this.renderPassId = this.getScene().getEngine().createRenderPassId(`Camera ${name}`);
    }
    /**
     * Store current camera state (fov, position, etc..)
     * @returns the camera
     */ storeState() {
        this._stateStored = true;
        this._storedFov = this.fov;
        return this;
    }
    /**
     * Restores the camera state values if it has been stored. You must call storeState() first
     * @returns true if restored and false otherwise
     */ _restoreStateValues() {
        if (!this._stateStored) return false;
        this.fov = this._storedFov;
        return true;
    }
    /**
     * Restored camera state. You must call storeState() first.
     * @returns true if restored and false otherwise
     */ restoreState() {
        if (this._restoreStateValues()) {
            this.onRestoreStateObservable.notifyObservers(this);
            return true;
        }
        return false;
    }
    /**
     * Gets the class name of the camera.
     * @returns the class name
     */ getClassName() {
        return "Camera";
    }
    /**
     * Gets a string representation of the camera useful for debug purpose.
     * @param fullDetails Defines that a more verbose level of logging is required
     * @returns the string representation
     */ toString(fullDetails) {
        let ret = "Name: " + this.name;
        ret += ", type: " + this.getClassName();
        if (this.animations) for(let i = 0; i < this.animations.length; i++)ret += ", animation[0]: " + this.animations[i].toString(fullDetails);
        return ret;
    }
    /**
     * Automatically tilts the projection plane, using `projectionPlaneTilt`, to correct the perspective effect on vertical lines.
     */ applyVerticalCorrection() {
        const rot = this.absoluteRotation.toEulerAngles();
        this.projectionPlaneTilt = this._scene.useRightHandedSystem ? -rot.x : rot.x;
    }
    /**
     * Gets the current world space position of the camera.
     */ get globalPosition() {
        return this._globalPosition;
    }
    /**
     * Gets the list of active meshes this frame (meshes no culled or excluded by lod s in the frame)
     * @returns the active meshe list
     */ getActiveMeshes() {
        return this._activeMeshes;
    }
    /**
     * Check whether a mesh is part of the current active mesh list of the camera
     * @param mesh Defines the mesh to check
     * @returns true if active, false otherwise
     */ isActiveMesh(mesh) {
        return this._activeMeshes.indexOf(mesh) !== -1;
    }
    /**
     * Is this camera ready to be used/rendered
     * @param completeCheck defines if a complete check (including post processes) has to be done (false by default)
     * @returns true if the camera is ready
     */ isReady(completeCheck = false) {
        if (completeCheck) for (const pp of this._postProcesses){
            if (pp && !pp.isReady()) return false;
        }
        return super.isReady(completeCheck);
    }
    /** @internal */ _initCache() {
        super._initCache();
        this._cache.position = new (0, $ha1VO.Vector3)(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
        this._cache.upVector = new (0, $ha1VO.Vector3)(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
        this._cache.mode = undefined;
        this._cache.minZ = undefined;
        this._cache.maxZ = undefined;
        this._cache.fov = undefined;
        this._cache.fovMode = undefined;
        this._cache.aspectRatio = undefined;
        this._cache.orthoLeft = undefined;
        this._cache.orthoRight = undefined;
        this._cache.orthoBottom = undefined;
        this._cache.orthoTop = undefined;
        this._cache.obliqueAngle = undefined;
        this._cache.obliqueLength = undefined;
        this._cache.obliqueOffset = undefined;
        this._cache.renderWidth = undefined;
        this._cache.renderHeight = undefined;
    }
    /**
     * @internal
     */ _updateCache(ignoreParentClass) {
        if (!ignoreParentClass) super._updateCache();
        this._cache.position.copyFrom(this.position);
        this._cache.upVector.copyFrom(this.upVector);
    }
    /** @internal */ _isSynchronized() {
        return this._isSynchronizedViewMatrix() && this._isSynchronizedProjectionMatrix();
    }
    /** @internal */ _isSynchronizedViewMatrix() {
        if (!super._isSynchronized()) return false;
        return this._cache.position.equals(this.position) && this._cache.upVector.equals(this.upVector) && this.isSynchronizedWithParent();
    }
    /** @internal */ _isSynchronizedProjectionMatrix() {
        let isSynchronized = this._cache.mode === this.mode && this._cache.minZ === this.minZ && this._cache.maxZ === this.maxZ;
        if (!isSynchronized) return false;
        const engine = this.getEngine();
        if (this.mode === $52736139c8513fb2$export$79f141de891a5fed.PERSPECTIVE_CAMERA) isSynchronized = this._cache.fov === this.fov && this._cache.fovMode === this.fovMode && this._cache.aspectRatio === engine.getAspectRatio(this) && this._cache.projectionPlaneTilt === this.projectionPlaneTilt;
        else {
            isSynchronized = this._cache.orthoLeft === this.orthoLeft && this._cache.orthoRight === this.orthoRight && this._cache.orthoBottom === this.orthoBottom && this._cache.orthoTop === this.orthoTop && this._cache.renderWidth === engine.getRenderWidth() && this._cache.renderHeight === engine.getRenderHeight();
            if (this.oblique) isSynchronized = isSynchronized && this._cache.obliqueAngle === this.oblique.angle && this._cache.obliqueLength === this.oblique.length && this._cache.obliqueOffset === this.oblique.offset;
        }
        return isSynchronized;
    }
    /**
     * Attach the input controls to a specific dom element to get the input from.
     * This function is here because typescript removes the typing of the last function.
     * @param _ignored defines an ignored parameter kept for backward compatibility.
     * @param _noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
     */ attachControl(_ignored, _noPreventDefault) {}
    /**
     * Detach the current controls from the specified dom element.
     * This function is here because typescript removes the typing of the last function.
     * @param _ignored defines an ignored parameter kept for backward compatibility.
     */ detachControl(_ignored) {}
    /**
     * Update the camera state according to the different inputs gathered during the frame.
     */ update() {
        this._hasMoved = false;
        this._checkInputs();
        if (this.cameraRigMode !== $52736139c8513fb2$export$79f141de891a5fed.RIG_MODE_NONE) this._updateRigCameras();
        // Attempt to update the camera's view and projection matrices.
        // This call is being made because these matrices are no longer being updated
        // as a part of the picking ray process (in addition to scene.render).
        this.getViewMatrix();
        this.getProjectionMatrix();
    }
    /** @internal */ _checkInputs() {
        this.onAfterCheckInputsObservable.notifyObservers(this);
    }
    /** @internal */ get rigCameras() {
        return this._rigCameras;
    }
    /**
     * Gets the post process used by the rig cameras
     */ get rigPostProcess() {
        return this._rigPostProcess;
    }
    /**
     * Internal, gets the first post process.
     * @returns the first post process to be run on this camera.
     */ _getFirstPostProcess() {
        for(let ppIndex = 0; ppIndex < this._postProcesses.length; ppIndex++){
            if (this._postProcesses[ppIndex] !== null) return this._postProcesses[ppIndex];
        }
        return null;
    }
    _cascadePostProcessesToRigCams() {
        // invalidate framebuffer
        const firstPostProcess = this._getFirstPostProcess();
        if (firstPostProcess) firstPostProcess.markTextureDirty();
        // glue the rigPostProcess to the end of the user postprocesses & assign to each sub-camera
        for(let i = 0, len = this._rigCameras.length; i < len; i++){
            const cam = this._rigCameras[i];
            const rigPostProcess = cam._rigPostProcess;
            // for VR rig, there does not have to be a post process
            if (rigPostProcess) {
                const isPass = rigPostProcess.getEffectName() === "pass";
                if (isPass) // any rig which has a PassPostProcess for rig[0], cannot be isIntermediate when there are also user postProcesses
                cam.isIntermediate = this._postProcesses.length === 0;
                cam._postProcesses = this._postProcesses.slice(0).concat(rigPostProcess);
                rigPostProcess.markTextureDirty();
            } else cam._postProcesses = this._postProcesses.slice(0);
        }
    }
    /**
     * Attach a post process to the camera.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/postProcesses/usePostProcesses#attach-postprocess
     * @param postProcess The post process to attach to the camera
     * @param insertAt The position of the post process in case several of them are in use in the scene
     * @returns the position the post process has been inserted at
     */ attachPostProcess(postProcess, insertAt = null) {
        if (!postProcess.isReusable() && this._postProcesses.indexOf(postProcess) > -1) {
            (0, $kVtWi.Logger).Error("You're trying to reuse a post process not defined as reusable.");
            return 0;
        }
        if (insertAt == null || insertAt < 0) this._postProcesses.push(postProcess);
        else if (this._postProcesses[insertAt] === null) this._postProcesses[insertAt] = postProcess;
        else this._postProcesses.splice(insertAt, 0, postProcess);
        this._cascadePostProcessesToRigCams(); // also ensures framebuffer invalidated
        // Update prePass
        if (this._scene.prePassRenderer) this._scene.prePassRenderer.markAsDirty();
        return this._postProcesses.indexOf(postProcess);
    }
    /**
     * Detach a post process to the camera.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/postProcesses/usePostProcesses#attach-postprocess
     * @param postProcess The post process to detach from the camera
     */ detachPostProcess(postProcess) {
        const idx = this._postProcesses.indexOf(postProcess);
        if (idx !== -1) this._postProcesses[idx] = null;
        // Update prePass
        if (this._scene.prePassRenderer) this._scene.prePassRenderer.markAsDirty();
        this._cascadePostProcessesToRigCams(); // also ensures framebuffer invalidated
    }
    /**
     * Gets the current world matrix of the camera
     * @returns the world matrix
     */ getWorldMatrix() {
        if (this._isSynchronizedViewMatrix()) return this._worldMatrix;
        // Getting the view matrix will also compute the world matrix.
        this.getViewMatrix();
        return this._worldMatrix;
    }
    /** @internal */ _getViewMatrix() {
        return (0, $ha1VO.Matrix).Identity();
    }
    /**
     * Gets the current view matrix of the camera.
     * @param force forces the camera to recompute the matrix without looking at the cached state
     * @returns the view matrix
     */ getViewMatrix(force) {
        if (!force && this._isSynchronizedViewMatrix()) return this._computedViewMatrix;
        this._hasMoved = true;
        this.updateCache();
        this._computedViewMatrix = this._getViewMatrix();
        this._currentRenderId = this.getScene().getRenderId();
        this._childUpdateId++;
        this._refreshFrustumPlanes = true;
        if (this._cameraRigParams && this._cameraRigParams.vrPreViewMatrix) this._computedViewMatrix.multiplyToRef(this._cameraRigParams.vrPreViewMatrix, this._computedViewMatrix);
        // Notify parent camera if rig camera is changed
        if (this.parent && this.parent.onViewMatrixChangedObservable) this.parent.onViewMatrixChangedObservable.notifyObservers(this.parent);
        this.onViewMatrixChangedObservable.notifyObservers(this);
        this._computedViewMatrix.invertToRef(this._worldMatrix);
        return this._computedViewMatrix;
    }
    /**
     * Freeze the projection matrix.
     * It will prevent the cache check of the camera projection compute and can speed up perf
     * if no parameter of the camera are meant to change
     * @param projection Defines manually a projection if necessary
     */ freezeProjectionMatrix(projection) {
        this._doNotComputeProjectionMatrix = true;
        if (projection !== undefined) this._projectionMatrix = projection;
    }
    /**
     * Unfreeze the projection matrix if it has previously been freezed by freezeProjectionMatrix.
     */ unfreezeProjectionMatrix() {
        this._doNotComputeProjectionMatrix = false;
    }
    /**
     * Gets the current projection matrix of the camera.
     * @param force forces the camera to recompute the matrix without looking at the cached state
     * @returns the projection matrix
     */ getProjectionMatrix(force) {
        if (this._doNotComputeProjectionMatrix || !force && this._isSynchronizedProjectionMatrix()) return this._projectionMatrix;
        // Cache
        this._cache.mode = this.mode;
        this._cache.minZ = this.minZ;
        this._cache.maxZ = this.maxZ;
        // Matrix
        this._refreshFrustumPlanes = true;
        const engine = this.getEngine();
        const scene = this.getScene();
        const reverseDepth = engine.useReverseDepthBuffer;
        if (this.mode === $52736139c8513fb2$export$79f141de891a5fed.PERSPECTIVE_CAMERA) {
            this._cache.fov = this.fov;
            this._cache.fovMode = this.fovMode;
            this._cache.aspectRatio = engine.getAspectRatio(this);
            this._cache.projectionPlaneTilt = this.projectionPlaneTilt;
            if (this.minZ <= 0) this.minZ = 0.1;
            let getProjectionMatrix;
            if (scene.useRightHandedSystem) getProjectionMatrix = (0, $ha1VO.Matrix).PerspectiveFovRHToRef;
            else getProjectionMatrix = (0, $ha1VO.Matrix).PerspectiveFovLHToRef;
            getProjectionMatrix(this.fov, engine.getAspectRatio(this), reverseDepth ? this.maxZ : this.minZ, reverseDepth ? this.minZ : this.maxZ, this._projectionMatrix, this.fovMode === $52736139c8513fb2$export$79f141de891a5fed.FOVMODE_VERTICAL_FIXED, engine.isNDCHalfZRange, this.projectionPlaneTilt, reverseDepth);
        } else {
            const halfWidth = engine.getRenderWidth() / 2.0;
            const halfHeight = engine.getRenderHeight() / 2.0;
            if (scene.useRightHandedSystem) {
                if (this.oblique) (0, $ha1VO.Matrix).ObliqueOffCenterRHToRef(this.orthoLeft ?? -halfWidth, this.orthoRight ?? halfWidth, this.orthoBottom ?? -halfHeight, this.orthoTop ?? halfHeight, reverseDepth ? this.maxZ : this.minZ, reverseDepth ? this.minZ : this.maxZ, this.oblique.length, this.oblique.angle, this._computeObliqueDistance(this.oblique.offset), this._projectionMatrix, engine.isNDCHalfZRange);
                else (0, $ha1VO.Matrix).OrthoOffCenterRHToRef(this.orthoLeft ?? -halfWidth, this.orthoRight ?? halfWidth, this.orthoBottom ?? -halfHeight, this.orthoTop ?? halfHeight, reverseDepth ? this.maxZ : this.minZ, reverseDepth ? this.minZ : this.maxZ, this._projectionMatrix, engine.isNDCHalfZRange);
            } else if (this.oblique) (0, $ha1VO.Matrix).ObliqueOffCenterLHToRef(this.orthoLeft ?? -halfWidth, this.orthoRight ?? halfWidth, this.orthoBottom ?? -halfHeight, this.orthoTop ?? halfHeight, reverseDepth ? this.maxZ : this.minZ, reverseDepth ? this.minZ : this.maxZ, this.oblique.length, this.oblique.angle, this._computeObliqueDistance(this.oblique.offset), this._projectionMatrix, engine.isNDCHalfZRange);
            else (0, $ha1VO.Matrix).OrthoOffCenterLHToRef(this.orthoLeft ?? -halfWidth, this.orthoRight ?? halfWidth, this.orthoBottom ?? -halfHeight, this.orthoTop ?? halfHeight, reverseDepth ? this.maxZ : this.minZ, reverseDepth ? this.minZ : this.maxZ, this._projectionMatrix, engine.isNDCHalfZRange);
            this._cache.orthoLeft = this.orthoLeft;
            this._cache.orthoRight = this.orthoRight;
            this._cache.orthoBottom = this.orthoBottom;
            this._cache.orthoTop = this.orthoTop;
            this._cache.obliqueAngle = this.oblique?.angle;
            this._cache.obliqueLength = this.oblique?.length;
            this._cache.obliqueOffset = this.oblique?.offset;
            this._cache.renderWidth = engine.getRenderWidth();
            this._cache.renderHeight = engine.getRenderHeight();
        }
        this.onProjectionMatrixChangedObservable.notifyObservers(this);
        return this._projectionMatrix;
    }
    /**
     * Gets the transformation matrix (ie. the multiplication of view by projection matrices)
     * @returns a Matrix
     */ getTransformationMatrix() {
        this._computedViewMatrix.multiplyToRef(this._projectionMatrix, this._transformMatrix);
        return this._transformMatrix;
    }
    _computeObliqueDistance(offset) {
        const arcRotateCamera = this;
        const targetCamera = this;
        return (arcRotateCamera.radius || (targetCamera.target ? (0, $ha1VO.Vector3).Distance(this.position, targetCamera.target) : this.position.length())) + offset;
    }
    _updateFrustumPlanes() {
        if (!this._refreshFrustumPlanes) return;
        this.getTransformationMatrix();
        if (!this._frustumPlanes) this._frustumPlanes = (0, $9sPMJ.Frustum).GetPlanes(this._transformMatrix);
        else (0, $9sPMJ.Frustum).GetPlanesToRef(this._transformMatrix, this._frustumPlanes);
        this._refreshFrustumPlanes = false;
    }
    /**
     * Checks if a cullable object (mesh...) is in the camera frustum
     * This checks the bounding box center. See isCompletelyInFrustum for a full bounding check
     * @param target The object to check
     * @param checkRigCameras If the rig cameras should be checked (eg. with VR camera both eyes should be checked) (Default: false)
     * @returns true if the object is in frustum otherwise false
     */ isInFrustum(target, checkRigCameras = false) {
        this._updateFrustumPlanes();
        if (checkRigCameras && this.rigCameras.length > 0) {
            let result = false;
            this.rigCameras.forEach((cam)=>{
                cam._updateFrustumPlanes();
                result = result || target.isInFrustum(cam._frustumPlanes);
            });
            return result;
        } else return target.isInFrustum(this._frustumPlanes);
    }
    /**
     * Checks if a cullable object (mesh...) is in the camera frustum
     * Unlike isInFrustum this checks the full bounding box
     * @param target The object to check
     * @returns true if the object is in frustum otherwise false
     */ isCompletelyInFrustum(target) {
        this._updateFrustumPlanes();
        return target.isCompletelyInFrustum(this._frustumPlanes);
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Gets a ray in the forward direction from the camera.
     * @param length Defines the length of the ray to create
     * @param transform Defines the transform to apply to the ray, by default the world matrix is used to create a workd space ray
     * @param origin Defines the start point of the ray which defaults to the camera position
     * @returns the forward ray
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getForwardRay(length = 100, transform, origin) {
        throw (0, $dUFYy._WarnImport)("Ray");
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Gets a ray in the forward direction from the camera.
     * @param refRay the ray to (re)use when setting the values
     * @param length Defines the length of the ray to create
     * @param transform Defines the transform to apply to the ray, by default the world matrx is used to create a workd space ray
     * @param origin Defines the start point of the ray which defaults to the camera position
     * @returns the forward ray
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getForwardRayToRef(refRay, length = 100, transform, origin) {
        throw (0, $dUFYy._WarnImport)("Ray");
    }
    /**
     * Releases resources associated with this node.
     * @param doNotRecurse Set to true to not recurse into each children (recurse into each children by default)
     * @param disposeMaterialAndTextures Set to true to also dispose referenced materials and textures (false by default)
     */ dispose(doNotRecurse, disposeMaterialAndTextures = false) {
        // Observables
        this.onViewMatrixChangedObservable.clear();
        this.onProjectionMatrixChangedObservable.clear();
        this.onAfterCheckInputsObservable.clear();
        this.onRestoreStateObservable.clear();
        // Inputs
        if (this.inputs) this.inputs.clear();
        // Animations
        this.getScene().stopAnimation(this);
        // Remove from scene
        this.getScene().removeCamera(this);
        while(this._rigCameras.length > 0){
            const camera = this._rigCameras.pop();
            if (camera) camera.dispose();
        }
        if (this._parentContainer) {
            const index = this._parentContainer.cameras.indexOf(this);
            if (index > -1) this._parentContainer.cameras.splice(index, 1);
            this._parentContainer = null;
        }
        // Postprocesses
        if (this._rigPostProcess) {
            this._rigPostProcess.dispose(this);
            this._rigPostProcess = null;
            this._postProcesses.length = 0;
        } else if (this.cameraRigMode !== $52736139c8513fb2$export$79f141de891a5fed.RIG_MODE_NONE) {
            this._rigPostProcess = null;
            this._postProcesses.length = 0;
        } else {
            let i = this._postProcesses.length;
            while(--i >= 0){
                const postProcess = this._postProcesses[i];
                if (postProcess) postProcess.dispose(this);
            }
        }
        // Render targets
        let i = this.customRenderTargets.length;
        while(--i >= 0)this.customRenderTargets[i].dispose();
        this.customRenderTargets.length = 0;
        // Active Meshes
        this._activeMeshes.dispose();
        this.getScene().getEngine().releaseRenderPassId(this.renderPassId);
        super.dispose(doNotRecurse, disposeMaterialAndTextures);
    }
    /**
     * Gets the left camera of a rig setup in case of Rigged Camera
     */ get isLeftCamera() {
        return this._isLeftCamera;
    }
    /**
     * Gets the right camera of a rig setup in case of Rigged Camera
     */ get isRightCamera() {
        return this._isRightCamera;
    }
    /**
     * Gets the left camera of a rig setup in case of Rigged Camera
     */ get leftCamera() {
        if (this._rigCameras.length < 1) return null;
        return this._rigCameras[0];
    }
    /**
     * Gets the right camera of a rig setup in case of Rigged Camera
     */ get rightCamera() {
        if (this._rigCameras.length < 2) return null;
        return this._rigCameras[1];
    }
    /**
     * Gets the left camera target of a rig setup in case of Rigged Camera
     * @returns the target position
     */ getLeftTarget() {
        if (this._rigCameras.length < 1) return null;
        return this._rigCameras[0].getTarget();
    }
    /**
     * Gets the right camera target of a rig setup in case of Rigged Camera
     * @returns the target position
     */ getRightTarget() {
        if (this._rigCameras.length < 2) return null;
        return this._rigCameras[1].getTarget();
    }
    /**
     * @internal
     */ setCameraRigMode(mode, rigParams) {
        if (this.cameraRigMode === mode) return;
        while(this._rigCameras.length > 0){
            const camera = this._rigCameras.pop();
            if (camera) camera.dispose();
        }
        this.cameraRigMode = mode;
        this._cameraRigParams = {};
        //we have to implement stereo camera calcultating left and right viewpoints from interaxialDistance and target,
        //not from a given angle as it is now, but until that complete code rewriting provisional stereoHalfAngle value is introduced
        this._cameraRigParams.interaxialDistance = rigParams.interaxialDistance || 0.0637;
        this._cameraRigParams.stereoHalfAngle = (0, $bOhSV.Tools).ToRadians(this._cameraRigParams.interaxialDistance / 0.0637);
        // create the rig cameras, unless none
        if (this.cameraRigMode !== $52736139c8513fb2$export$79f141de891a5fed.RIG_MODE_NONE) {
            const leftCamera = this.createRigCamera(this.name + "_L", 0);
            if (leftCamera) leftCamera._isLeftCamera = true;
            const rightCamera = this.createRigCamera(this.name + "_R", 1);
            if (rightCamera) rightCamera._isRightCamera = true;
            if (leftCamera && rightCamera) {
                this._rigCameras.push(leftCamera);
                this._rigCameras.push(rightCamera);
            }
        }
        this._setRigMode(rigParams);
        this._cascadePostProcessesToRigCams();
        this.update();
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _setRigMode(rigParams) {
    // no-op
    }
    /** @internal */ _getVRProjectionMatrix() {
        (0, $ha1VO.Matrix).PerspectiveFovLHToRef(this._cameraRigParams.vrMetrics.aspectRatioFov, this._cameraRigParams.vrMetrics.aspectRatio, this.minZ, this.maxZ, this._cameraRigParams.vrWorkMatrix, true, this.getEngine().isNDCHalfZRange);
        this._cameraRigParams.vrWorkMatrix.multiplyToRef(this._cameraRigParams.vrHMatrix, this._projectionMatrix);
        return this._projectionMatrix;
    }
    /**
     * @internal
     */ setCameraRigParameter(name, value) {
        if (!this._cameraRigParams) this._cameraRigParams = {};
        this._cameraRigParams[name] = value;
        //provisionnally:
        if (name === "interaxialDistance") this._cameraRigParams.stereoHalfAngle = (0, $bOhSV.Tools).ToRadians(value / 0.0637);
    }
    /**
     * needs to be overridden by children so sub has required properties to be copied
     * @internal
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    createRigCamera(name, cameraIndex) {
        return null;
    }
    /**
     * May need to be overridden by children
     * @internal
     */ _updateRigCameras() {
        for(let i = 0; i < this._rigCameras.length; i++){
            this._rigCameras[i].minZ = this.minZ;
            this._rigCameras[i].maxZ = this.maxZ;
            this._rigCameras[i].fov = this.fov;
            this._rigCameras[i].upVector.copyFrom(this.upVector);
        }
        // only update viewport when ANAGLYPH
        if (this.cameraRigMode === $52736139c8513fb2$export$79f141de891a5fed.RIG_MODE_STEREOSCOPIC_ANAGLYPH) this._rigCameras[0].viewport = this._rigCameras[1].viewport = this.viewport;
    }
    /** @internal */ _setupInputs() {}
    /**
     * Serialiaze the camera setup to a json representation
     * @returns the JSON representation
     */ serialize() {
        const serializationObject = (0, $6Ho1L.SerializationHelper).Serialize(this);
        serializationObject.uniqueId = this.uniqueId;
        // Type
        serializationObject.type = this.getClassName();
        // Parent
        if (this.parent) this.parent._serializeAsParent(serializationObject);
        if (this.inputs) this.inputs.serialize(serializationObject);
        // Animations
        (0, $6Ho1L.SerializationHelper).AppendSerializedAnimations(this, serializationObject);
        serializationObject.ranges = this.serializeAnimationRanges();
        serializationObject.isEnabled = this.isEnabled();
        return serializationObject;
    }
    /**
     * Clones the current camera.
     * @param name The cloned camera name
     * @param newParent The cloned camera's new parent (none by default)
     * @returns the cloned camera
     */ clone(name, newParent = null) {
        const camera = (0, $6Ho1L.SerializationHelper).Clone($52736139c8513fb2$export$79f141de891a5fed.GetConstructorFromName(this.getClassName(), name, this.getScene(), this.interaxialDistance, this.isStereoscopicSideBySide), this);
        camera.name = name;
        camera.parent = newParent;
        this.onClonedObservable.notifyObservers(camera);
        return camera;
    }
    /**
     * Gets the direction of the camera relative to a given local axis.
     * @param localAxis Defines the reference axis to provide a relative direction.
     * @returns the direction
     */ getDirection(localAxis) {
        const result = (0, $ha1VO.Vector3).Zero();
        this.getDirectionToRef(localAxis, result);
        return result;
    }
    /**
     * Returns the current camera absolute rotation
     */ get absoluteRotation() {
        this.getWorldMatrix().decompose(undefined, this._absoluteRotation);
        return this._absoluteRotation;
    }
    /**
     * Gets the direction of the camera relative to a given local axis into a passed vector.
     * @param localAxis Defines the reference axis to provide a relative direction.
     * @param result Defines the vector to store the result in
     */ getDirectionToRef(localAxis, result) {
        (0, $ha1VO.Vector3).TransformNormalToRef(localAxis, this.getWorldMatrix(), result);
    }
    /**
     * Gets a camera constructor for a given camera type
     * @param type The type of the camera to construct (should be equal to one of the camera class name)
     * @param name The name of the camera the result will be able to instantiate
     * @param scene The scene the result will construct the camera in
     * @param interaxial_distance In case of stereoscopic setup, the distance between both eyes
     * @param isStereoscopicSideBySide In case of stereoscopic setup, should the sereo be side b side
     * @returns a factory method to construct the camera
     */ // eslint-disable-next-line @typescript-eslint/naming-convention
    static GetConstructorFromName(type, name, scene, interaxial_distance = 0, isStereoscopicSideBySide = true) {
        const constructorFunc = (0, $bgssx.Node).Construct(type, name, scene, {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            interaxial_distance: interaxial_distance,
            isStereoscopicSideBySide: isStereoscopicSideBySide
        });
        if (constructorFunc) return constructorFunc;
        // Default to universal camera
        return ()=>$52736139c8513fb2$export$79f141de891a5fed._CreateDefaultParsedCamera(name, scene);
    }
    /**
     * Compute the world  matrix of the camera.
     * @returns the camera world matrix
     */ computeWorldMatrix() {
        return this.getWorldMatrix();
    }
    /**
     * Parse a JSON and creates the camera from the parsed information
     * @param parsedCamera The JSON to parse
     * @param scene The scene to instantiate the camera in
     * @returns the newly constructed camera
     */ static Parse(parsedCamera, scene) {
        const type = parsedCamera.type;
        const construct = $52736139c8513fb2$export$79f141de891a5fed.GetConstructorFromName(type, parsedCamera.name, scene, parsedCamera.interaxial_distance, parsedCamera.isStereoscopicSideBySide);
        const camera = (0, $6Ho1L.SerializationHelper).Parse(construct, parsedCamera, scene);
        // Parent
        if (parsedCamera.parentId !== undefined) camera._waitingParentId = parsedCamera.parentId;
        // Parent instance index
        if (parsedCamera.parentInstanceIndex !== undefined) camera._waitingParentInstanceIndex = parsedCamera.parentInstanceIndex;
        //If camera has an input manager, let it parse inputs settings
        if (camera.inputs) {
            camera.inputs.parse(parsedCamera);
            camera._setupInputs();
        }
        if (parsedCamera.upVector) camera.upVector = (0, $ha1VO.Vector3).FromArray(parsedCamera.upVector); // need to force the upVector
        if (camera.setPosition) {
            // need to force position
            camera.position.copyFromFloats(0, 0, 0);
            camera.setPosition((0, $ha1VO.Vector3).FromArray(parsedCamera.position));
        }
        // Target
        if (parsedCamera.target) {
            if (camera.setTarget) camera.setTarget((0, $ha1VO.Vector3).FromArray(parsedCamera.target));
        }
        // Apply 3d rig, when found
        if (parsedCamera.cameraRigMode) {
            const rigParams = parsedCamera.interaxial_distance ? {
                interaxialDistance: parsedCamera.interaxial_distance
            } : {};
            camera.setCameraRigMode(parsedCamera.cameraRigMode, rigParams);
        }
        // Animations
        if (parsedCamera.animations) {
            for(let animationIndex = 0; animationIndex < parsedCamera.animations.length; animationIndex++){
                const parsedAnimation = parsedCamera.animations[animationIndex];
                const internalClass = (0, $8DoUR.GetClass)("BABYLON.Animation");
                if (internalClass) camera.animations.push(internalClass.Parse(parsedAnimation));
            }
            (0, $bgssx.Node).ParseAnimationRanges(camera, parsedCamera, scene);
        }
        if (parsedCamera.autoAnimate) scene.beginAnimation(camera, parsedCamera.autoAnimateFrom, parsedCamera.autoAnimateTo, parsedCamera.autoAnimateLoop, parsedCamera.autoAnimateSpeed || 1.0);
        // Check if isEnabled is defined to be back compatible with prior serialized versions.
        if (parsedCamera.isEnabled !== undefined) camera.setEnabled(parsedCamera.isEnabled);
        return camera;
    }
    /** @internal */ _calculateHandednessMultiplier() {
        let handednessMultiplier = this.getScene().useRightHandedSystem ? -1 : 1;
        if (this.parent && this.parent._getWorldMatrixDeterminant() < 0) handednessMultiplier *= -1;
        return handednessMultiplier;
    }
}
/**
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
$52736139c8513fb2$export$79f141de891a5fed._CreateDefaultParsedCamera = (name, scene)=>{
    throw (0, $dUFYy._WarnImport)("UniversalCamera");
};
/**
 * This is the default projection mode used by the cameras.
 * It helps recreating a feeling of perspective and better appreciate depth.
 * This is the best way to simulate real life cameras.
 */ $52736139c8513fb2$export$79f141de891a5fed.PERSPECTIVE_CAMERA = 0;
/**
 * This helps creating camera with an orthographic mode.
 * Orthographic is commonly used in engineering as a means to produce object specifications that communicate dimensions unambiguously, each line of 1 unit length (cm, meter..whatever) will appear to have the same length everywhere on the drawing. This allows the drafter to dimension only a subset of lines and let the reader know that other lines of that length on the drawing are also that length in reality. Every parallel line in the drawing is also parallel in the object.
 */ $52736139c8513fb2$export$79f141de891a5fed.ORTHOGRAPHIC_CAMERA = 1;
/**
 * This is the default FOV mode for perspective cameras.
 * This setting aligns the upper and lower bounds of the viewport to the upper and lower bounds of the camera frustum.
 */ $52736139c8513fb2$export$79f141de891a5fed.FOVMODE_VERTICAL_FIXED = 0;
/**
 * This setting aligns the left and right bounds of the viewport to the left and right bounds of the camera frustum.
 */ $52736139c8513fb2$export$79f141de891a5fed.FOVMODE_HORIZONTAL_FIXED = 1;
/**
 * This specifies there is no need for a camera rig.
 * Basically only one eye is rendered corresponding to the camera.
 */ $52736139c8513fb2$export$79f141de891a5fed.RIG_MODE_NONE = 0;
/**
 * Simulates a camera Rig with one blue eye and one red eye.
 * This can be use with 3d blue and red glasses.
 */ $52736139c8513fb2$export$79f141de891a5fed.RIG_MODE_STEREOSCOPIC_ANAGLYPH = 10;
/**
 * Defines that both eyes of the camera will be rendered side by side with a parallel target.
 */ $52736139c8513fb2$export$79f141de891a5fed.RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_PARALLEL = 11;
/**
 * Defines that both eyes of the camera will be rendered side by side with a none parallel target.
 */ $52736139c8513fb2$export$79f141de891a5fed.RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_CROSSEYED = 12;
/**
 * Defines that both eyes of the camera will be rendered over under each other.
 */ $52736139c8513fb2$export$79f141de891a5fed.RIG_MODE_STEREOSCOPIC_OVERUNDER = 13;
/**
 * Defines that both eyes of the camera will be rendered on successive lines interlaced for passive 3d monitors.
 */ $52736139c8513fb2$export$79f141de891a5fed.RIG_MODE_STEREOSCOPIC_INTERLACED = 14;
/**
 * Defines that both eyes of the camera should be renderered in a VR mode (carbox).
 */ $52736139c8513fb2$export$79f141de891a5fed.RIG_MODE_VR = 20;
/**
 * Custom rig mode allowing rig cameras to be populated manually with any number of cameras
 */ $52736139c8513fb2$export$79f141de891a5fed.RIG_MODE_CUSTOM = 22;
/**
 * Defines if by default attaching controls should prevent the default javascript event to continue.
 */ $52736139c8513fb2$export$79f141de891a5fed.ForceAttachControlToAlwaysPreventDefault = false;
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsVector3)("position")
], $52736139c8513fb2$export$79f141de891a5fed.prototype, "_position", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsVector3)("upVector")
], $52736139c8513fb2$export$79f141de891a5fed.prototype, "_upVector", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $52736139c8513fb2$export$79f141de891a5fed.prototype, "orthoLeft", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $52736139c8513fb2$export$79f141de891a5fed.prototype, "orthoRight", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $52736139c8513fb2$export$79f141de891a5fed.prototype, "orthoBottom", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $52736139c8513fb2$export$79f141de891a5fed.prototype, "orthoTop", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $52736139c8513fb2$export$79f141de891a5fed.prototype, "fov", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $52736139c8513fb2$export$79f141de891a5fed.prototype, "projectionPlaneTilt", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $52736139c8513fb2$export$79f141de891a5fed.prototype, "minZ", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $52736139c8513fb2$export$79f141de891a5fed.prototype, "maxZ", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $52736139c8513fb2$export$79f141de891a5fed.prototype, "inertia", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $52736139c8513fb2$export$79f141de891a5fed.prototype, "mode", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $52736139c8513fb2$export$79f141de891a5fed.prototype, "layerMask", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $52736139c8513fb2$export$79f141de891a5fed.prototype, "fovMode", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $52736139c8513fb2$export$79f141de891a5fed.prototype, "cameraRigMode", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $52736139c8513fb2$export$79f141de891a5fed.prototype, "interaxialDistance", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $52736139c8513fb2$export$79f141de891a5fed.prototype, "isStereoscopicSideBySide", void 0);

});
parcelRegister("191mA", function(module, exports) {

$parcel$export(module.exports, "Viewport", () => $0d57b0684db3128e$export$d5c6c08dc2d3ca7);
/**
 * Class used to represent a viewport on screen
 */ class $0d57b0684db3128e$export$d5c6c08dc2d3ca7 {
    /**
     * Creates a Viewport object located at (x, y) and sized (width, height)
     * @param x defines viewport left coordinate
     * @param y defines viewport top coordinate
     * @param width defines the viewport width
     * @param height defines the viewport height
     */ constructor(/** viewport left coordinate */ x, /** viewport top coordinate */ y, /**viewport width */ width, /** viewport height */ height){
        this.x = x;
        this.y = y;
        this.width = width;
        this.height = height;
    }
    /**
     * Creates a new viewport using absolute sizing (from 0-> width, 0-> height instead of 0->1)
     * @param renderWidth defines the rendering width
     * @param renderHeight defines the rendering height
     * @returns a new Viewport
     */ toGlobal(renderWidth, renderHeight) {
        return new $0d57b0684db3128e$export$d5c6c08dc2d3ca7(this.x * renderWidth, this.y * renderHeight, this.width * renderWidth, this.height * renderHeight);
    }
    /**
     * Stores absolute viewport value into a target viewport (from 0-> width, 0-> height instead of 0->1)
     * @param renderWidth defines the rendering width
     * @param renderHeight defines the rendering height
     * @param ref defines the target viewport
     * @returns the current viewport
     */ toGlobalToRef(renderWidth, renderHeight, ref) {
        ref.x = this.x * renderWidth;
        ref.y = this.y * renderHeight;
        ref.width = this.width * renderWidth;
        ref.height = this.height * renderHeight;
        return this;
    }
    /**
     * Returns a new Viewport copied from the current one
     * @returns a new Viewport
     */ clone() {
        return new $0d57b0684db3128e$export$d5c6c08dc2d3ca7(this.x, this.y, this.width, this.height);
    }
}

});


parcelRegister("5v6ry", function(module, exports) {

$parcel$export(module.exports, "VertexDataMaterialInfo", () => $4014d881db0e9bc6$export$f5240a0ce3a46ac1);
$parcel$export(module.exports, "VertexData", () => $4014d881db0e9bc6$export$8570d39351855acb);

var $e0Suo = parcelRequire("e0Suo");

var $ha1VO = parcelRequire("ha1VO");

var $b4i1f = parcelRequire("b4i1f");

var $dUFYy = parcelRequire("dUFYy");

var $7etnY = parcelRequire("7etnY");

var $kVtWi = parcelRequire("kVtWi");

var $ir0rz = parcelRequire("ir0rz");

var $4TYUE = parcelRequire("4TYUE");

var $1FkG9 = parcelRequire("1FkG9");

var $lEBSs = parcelRequire("lEBSs");
class $4014d881db0e9bc6$export$f5240a0ce3a46ac1 {
}
class $4014d881db0e9bc6$export$8570d39351855acb {
    /**
     * Creates a new VertexData
     */ constructor(){
        /**
         * Gets the unique ID of this vertex Data
         */ this.uniqueId = 0;
        /**
         * Metadata used to store contextual values
         */ this.metadata = {};
        this._applyTo = (0, $4TYUE.makeSyncFunction)(this._applyToCoroutine.bind(this));
        this.uniqueId = $4014d881db0e9bc6$export$8570d39351855acb._UniqueIDGenerator;
        $4014d881db0e9bc6$export$8570d39351855acb._UniqueIDGenerator++;
    }
    /**
     * Uses the passed data array to set the set the values for the specified kind of data
     * @param data a linear array of floating numbers
     * @param kind the type of data that is being set, eg positions, colors etc
     */ set(data, kind) {
        if (!data.length) (0, $kVtWi.Logger).Warn(`Setting vertex data kind '${kind}' with an empty array`);
        switch(kind){
            case (0, $b4i1f.VertexBuffer).PositionKind:
                this.positions = data;
                break;
            case (0, $b4i1f.VertexBuffer).NormalKind:
                this.normals = data;
                break;
            case (0, $b4i1f.VertexBuffer).TangentKind:
                this.tangents = data;
                break;
            case (0, $b4i1f.VertexBuffer).UVKind:
                this.uvs = data;
                break;
            case (0, $b4i1f.VertexBuffer).UV2Kind:
                this.uvs2 = data;
                break;
            case (0, $b4i1f.VertexBuffer).UV3Kind:
                this.uvs3 = data;
                break;
            case (0, $b4i1f.VertexBuffer).UV4Kind:
                this.uvs4 = data;
                break;
            case (0, $b4i1f.VertexBuffer).UV5Kind:
                this.uvs5 = data;
                break;
            case (0, $b4i1f.VertexBuffer).UV6Kind:
                this.uvs6 = data;
                break;
            case (0, $b4i1f.VertexBuffer).ColorKind:
                this.colors = data;
                break;
            case (0, $b4i1f.VertexBuffer).MatricesIndicesKind:
                this.matricesIndices = data;
                break;
            case (0, $b4i1f.VertexBuffer).MatricesWeightsKind:
                this.matricesWeights = data;
                break;
            case (0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind:
                this.matricesIndicesExtra = data;
                break;
            case (0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind:
                this.matricesWeightsExtra = data;
                break;
        }
    }
    /**
     * Associates the vertexData to the passed Mesh.
     * Sets it as updatable or not (default `false`)
     * @param mesh the mesh the vertexData is applied to
     * @param updatable when used and having the value true allows new data to update the vertexData
     * @returns the VertexData
     */ applyToMesh(mesh, updatable) {
        this._applyTo(mesh, updatable, false);
        return this;
    }
    /**
     * Associates the vertexData to the passed Geometry.
     * Sets it as updatable or not (default `false`)
     * @param geometry the geometry the vertexData is applied to
     * @param updatable when used and having the value true allows new data to update the vertexData
     * @returns VertexData
     */ applyToGeometry(geometry, updatable) {
        this._applyTo(geometry, updatable, false);
        return this;
    }
    /**
     * Updates the associated mesh
     * @param mesh the mesh to be updated
     * @returns VertexData
     */ updateMesh(mesh) {
        this._update(mesh);
        return this;
    }
    /**
     * Updates the associated geometry
     * @param geometry the geometry to be updated
     * @returns VertexData.
     */ updateGeometry(geometry) {
        this._update(geometry);
        return this;
    }
    /**
     * @internal
     */ *_applyToCoroutine(meshOrGeometry, updatable = false, isAsync) {
        if (this.positions) {
            meshOrGeometry.setVerticesData((0, $b4i1f.VertexBuffer).PositionKind, this.positions, updatable);
            if (isAsync) yield;
        }
        if (this.normals) {
            meshOrGeometry.setVerticesData((0, $b4i1f.VertexBuffer).NormalKind, this.normals, updatable);
            if (isAsync) yield;
        }
        if (this.tangents) {
            meshOrGeometry.setVerticesData((0, $b4i1f.VertexBuffer).TangentKind, this.tangents, updatable);
            if (isAsync) yield;
        }
        if (this.uvs) {
            meshOrGeometry.setVerticesData((0, $b4i1f.VertexBuffer).UVKind, this.uvs, updatable);
            if (isAsync) yield;
        }
        if (this.uvs2) {
            meshOrGeometry.setVerticesData((0, $b4i1f.VertexBuffer).UV2Kind, this.uvs2, updatable);
            if (isAsync) yield;
        }
        if (this.uvs3) {
            meshOrGeometry.setVerticesData((0, $b4i1f.VertexBuffer).UV3Kind, this.uvs3, updatable);
            if (isAsync) yield;
        }
        if (this.uvs4) {
            meshOrGeometry.setVerticesData((0, $b4i1f.VertexBuffer).UV4Kind, this.uvs4, updatable);
            if (isAsync) yield;
        }
        if (this.uvs5) {
            meshOrGeometry.setVerticesData((0, $b4i1f.VertexBuffer).UV5Kind, this.uvs5, updatable);
            if (isAsync) yield;
        }
        if (this.uvs6) {
            meshOrGeometry.setVerticesData((0, $b4i1f.VertexBuffer).UV6Kind, this.uvs6, updatable);
            if (isAsync) yield;
        }
        if (this.colors) {
            meshOrGeometry.setVerticesData((0, $b4i1f.VertexBuffer).ColorKind, this.colors, updatable);
            if (this.hasVertexAlpha && meshOrGeometry.hasVertexAlpha !== undefined) meshOrGeometry.hasVertexAlpha = true;
            if (isAsync) yield;
        }
        if (this.matricesIndices) {
            meshOrGeometry.setVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesKind, this.matricesIndices, updatable);
            if (isAsync) yield;
        }
        if (this.matricesWeights) {
            meshOrGeometry.setVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsKind, this.matricesWeights, updatable);
            if (isAsync) yield;
        }
        if (this.matricesIndicesExtra) {
            meshOrGeometry.setVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind, this.matricesIndicesExtra, updatable);
            if (isAsync) yield;
        }
        if (this.matricesWeightsExtra) {
            meshOrGeometry.setVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind, this.matricesWeightsExtra, updatable);
            if (isAsync) yield;
        }
        if (this.indices) {
            meshOrGeometry.setIndices(this.indices, null, updatable);
            if (isAsync) yield;
        } else meshOrGeometry.setIndices([], null);
        if (meshOrGeometry.subMeshes && this.materialInfos && this.materialInfos.length > 1) {
            const mesh = meshOrGeometry;
            mesh.subMeshes = [];
            for (const matInfo of this.materialInfos)new (0, $lEBSs.SubMesh)(matInfo.materialIndex, matInfo.verticesStart, matInfo.verticesCount, matInfo.indexStart, matInfo.indexCount, mesh);
        }
        return this;
    }
    _update(meshOrGeometry, updateExtends, makeItUnique) {
        if (this.positions) meshOrGeometry.updateVerticesData((0, $b4i1f.VertexBuffer).PositionKind, this.positions, updateExtends, makeItUnique);
        if (this.normals) meshOrGeometry.updateVerticesData((0, $b4i1f.VertexBuffer).NormalKind, this.normals, updateExtends, makeItUnique);
        if (this.tangents) meshOrGeometry.updateVerticesData((0, $b4i1f.VertexBuffer).TangentKind, this.tangents, updateExtends, makeItUnique);
        if (this.uvs) meshOrGeometry.updateVerticesData((0, $b4i1f.VertexBuffer).UVKind, this.uvs, updateExtends, makeItUnique);
        if (this.uvs2) meshOrGeometry.updateVerticesData((0, $b4i1f.VertexBuffer).UV2Kind, this.uvs2, updateExtends, makeItUnique);
        if (this.uvs3) meshOrGeometry.updateVerticesData((0, $b4i1f.VertexBuffer).UV3Kind, this.uvs3, updateExtends, makeItUnique);
        if (this.uvs4) meshOrGeometry.updateVerticesData((0, $b4i1f.VertexBuffer).UV4Kind, this.uvs4, updateExtends, makeItUnique);
        if (this.uvs5) meshOrGeometry.updateVerticesData((0, $b4i1f.VertexBuffer).UV5Kind, this.uvs5, updateExtends, makeItUnique);
        if (this.uvs6) meshOrGeometry.updateVerticesData((0, $b4i1f.VertexBuffer).UV6Kind, this.uvs6, updateExtends, makeItUnique);
        if (this.colors) meshOrGeometry.updateVerticesData((0, $b4i1f.VertexBuffer).ColorKind, this.colors, updateExtends, makeItUnique);
        if (this.matricesIndices) meshOrGeometry.updateVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesKind, this.matricesIndices, updateExtends, makeItUnique);
        if (this.matricesWeights) meshOrGeometry.updateVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsKind, this.matricesWeights, updateExtends, makeItUnique);
        if (this.matricesIndicesExtra) meshOrGeometry.updateVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind, this.matricesIndicesExtra, updateExtends, makeItUnique);
        if (this.matricesWeightsExtra) meshOrGeometry.updateVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind, this.matricesWeightsExtra, updateExtends, makeItUnique);
        if (this.indices) meshOrGeometry.setIndices(this.indices, null);
        return this;
    }
    static _TransformVector3Coordinates(coordinates, transformation, offset = 0, length = coordinates.length) {
        const coordinate = (0, $ha1VO.TmpVectors).Vector3[0];
        const transformedCoordinate = (0, $ha1VO.TmpVectors).Vector3[1];
        for(let index = offset; index < offset + length; index += 3){
            (0, $ha1VO.Vector3).FromArrayToRef(coordinates, index, coordinate);
            (0, $ha1VO.Vector3).TransformCoordinatesToRef(coordinate, transformation, transformedCoordinate);
            coordinates[index] = transformedCoordinate.x;
            coordinates[index + 1] = transformedCoordinate.y;
            coordinates[index + 2] = transformedCoordinate.z;
        }
    }
    static _TransformVector3Normals(normals, transformation, offset = 0, length = normals.length) {
        const normal = (0, $ha1VO.TmpVectors).Vector3[0];
        const transformedNormal = (0, $ha1VO.TmpVectors).Vector3[1];
        for(let index = offset; index < offset + length; index += 3){
            (0, $ha1VO.Vector3).FromArrayToRef(normals, index, normal);
            (0, $ha1VO.Vector3).TransformNormalToRef(normal, transformation, transformedNormal);
            normals[index] = transformedNormal.x;
            normals[index + 1] = transformedNormal.y;
            normals[index + 2] = transformedNormal.z;
        }
    }
    static _TransformVector4Normals(normals, transformation, offset = 0, length = normals.length) {
        const normal = (0, $ha1VO.TmpVectors).Vector4[0];
        const transformedNormal = (0, $ha1VO.TmpVectors).Vector4[1];
        for(let index = offset; index < offset + length; index += 4){
            (0, $ha1VO.Vector4).FromArrayToRef(normals, index, normal);
            (0, $ha1VO.Vector4).TransformNormalToRef(normal, transformation, transformedNormal);
            normals[index] = transformedNormal.x;
            normals[index + 1] = transformedNormal.y;
            normals[index + 2] = transformedNormal.z;
            normals[index + 3] = transformedNormal.w;
        }
    }
    static _FlipFaces(indices, offset = 0, length = indices.length) {
        for(let index = offset; index < offset + length; index += 3){
            const tmp = indices[index + 1];
            indices[index + 1] = indices[index + 2];
            indices[index + 2] = tmp;
        }
    }
    /**
     * Transforms each position and each normal of the vertexData according to the passed Matrix
     * @param matrix the transforming matrix
     * @returns the VertexData
     */ transform(matrix) {
        const flip = matrix.determinant() < 0;
        if (this.positions) $4014d881db0e9bc6$export$8570d39351855acb._TransformVector3Coordinates(this.positions, matrix);
        if (this.normals) $4014d881db0e9bc6$export$8570d39351855acb._TransformVector3Normals(this.normals, matrix);
        if (this.tangents) $4014d881db0e9bc6$export$8570d39351855acb._TransformVector4Normals(this.tangents, matrix);
        if (flip && this.indices) $4014d881db0e9bc6$export$8570d39351855acb._FlipFaces(this.indices);
        return this;
    }
    /**
     * Generates an array of vertex data where each vertex data only has one material info
     * @returns An array of VertexData
     */ splitBasedOnMaterialID() {
        if (!this.materialInfos || this.materialInfos.length < 2) return [
            this
        ];
        const result = [];
        for (const materialInfo of this.materialInfos){
            const vertexData = new $4014d881db0e9bc6$export$8570d39351855acb();
            if (this.positions) vertexData.positions = this.positions.slice(materialInfo.verticesStart * 3, (materialInfo.verticesCount + materialInfo.verticesStart) * 3);
            if (this.normals) vertexData.normals = this.normals.slice(materialInfo.verticesStart * 3, (materialInfo.verticesCount + materialInfo.verticesStart) * 3);
            if (this.tangents) vertexData.tangents = this.tangents.slice(materialInfo.verticesStart * 4, (materialInfo.verticesCount + materialInfo.verticesStart) * 4);
            if (this.colors) vertexData.colors = this.colors.slice(materialInfo.verticesStart * 4, (materialInfo.verticesCount + materialInfo.verticesStart) * 4);
            if (this.uvs) vertexData.uvs = this.uvs.slice(materialInfo.verticesStart * 2, (materialInfo.verticesCount + materialInfo.verticesStart) * 2);
            if (this.uvs2) vertexData.uvs2 = this.uvs2.slice(materialInfo.verticesStart * 2, (materialInfo.verticesCount + materialInfo.verticesStart) * 2);
            if (this.uvs3) vertexData.uvs3 = this.uvs3.slice(materialInfo.verticesStart * 2, (materialInfo.verticesCount + materialInfo.verticesStart) * 2);
            if (this.uvs4) vertexData.uvs4 = this.uvs4.slice(materialInfo.verticesStart * 2, (materialInfo.verticesCount + materialInfo.verticesStart) * 2);
            if (this.uvs5) vertexData.uvs5 = this.uvs5.slice(materialInfo.verticesStart * 2, (materialInfo.verticesCount + materialInfo.verticesStart) * 2);
            if (this.uvs6) vertexData.uvs6 = this.uvs6.slice(materialInfo.verticesStart * 2, (materialInfo.verticesCount + materialInfo.verticesStart) * 2);
            if (this.matricesIndices) vertexData.matricesIndices = this.matricesIndices.slice(materialInfo.verticesStart * 4, (materialInfo.verticesCount + materialInfo.verticesStart) * 4);
            if (this.matricesIndicesExtra) vertexData.matricesIndicesExtra = this.matricesIndicesExtra.slice(materialInfo.verticesStart * 4, (materialInfo.verticesCount + materialInfo.verticesStart) * 4);
            if (this.matricesWeights) vertexData.matricesWeights = this.matricesWeights.slice(materialInfo.verticesStart * 4, (materialInfo.verticesCount + materialInfo.verticesStart) * 4);
            if (this.matricesWeightsExtra) vertexData.matricesWeightsExtra = this.matricesWeightsExtra.slice(materialInfo.verticesStart * 4, (materialInfo.verticesCount + materialInfo.verticesStart) * 4);
            if (this.indices) {
                vertexData.indices = [];
                for(let index = materialInfo.indexStart; index < materialInfo.indexStart + materialInfo.indexCount; index++)vertexData.indices.push(this.indices[index] - materialInfo.verticesStart);
            }
            const newMaterialInfo = new $4014d881db0e9bc6$export$f5240a0ce3a46ac1();
            newMaterialInfo.indexStart = 0;
            newMaterialInfo.indexCount = vertexData.indices ? vertexData.indices.length : 0;
            newMaterialInfo.materialIndex = materialInfo.materialIndex;
            newMaterialInfo.verticesStart = 0;
            newMaterialInfo.verticesCount = (vertexData.positions ? vertexData.positions.length : 0) / 3;
            vertexData.materialInfos = [
                newMaterialInfo
            ];
            result.push(vertexData);
        }
        return result;
    }
    /**
     * Merges the passed VertexData into the current one
     * @param others the VertexData to be merged into the current one
     * @param use32BitsIndices defines a boolean indicating if indices must be store in a 32 bits array
     * @param forceCloneIndices defines a boolean indicating if indices are forced to be cloned
     * @param mergeMaterialIds defines a boolean indicating if we need to merge the material infos
     * @param enableCompletion defines a boolean indicating if the vertex data should be completed to be compatible
     * @returns the modified VertexData
     */ merge(others, use32BitsIndices = false, forceCloneIndices = false, mergeMaterialIds = false, enableCompletion = false) {
        const vertexDatas = Array.isArray(others) ? others.map((other)=>{
            return {
                vertexData: other
            };
        }) : [
            {
                vertexData: others
            }
        ];
        return (0, $4TYUE.runCoroutineSync)(this._mergeCoroutine(undefined, vertexDatas, use32BitsIndices, false, forceCloneIndices, mergeMaterialIds, enableCompletion));
    }
    /**
     * @internal
     */ *_mergeCoroutine(transform, vertexDatas, use32BitsIndices = false, isAsync, forceCloneIndices, mergeMaterialIds = false, enableCompletion = false) {
        this._validate();
        let others = vertexDatas.map((vertexData)=>vertexData.vertexData);
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        let root = this;
        if (enableCompletion) // First let's make sure we have the max set of attributes on the main vertex data
        for (const other of others){
            if (!other) continue;
            other._validate();
            if (!this.normals && other.normals) this.normals = new Float32Array(this.positions.length);
            if (!this.tangents && other.tangents) this.tangents = new Float32Array(this.positions.length / 3 * 4);
            if (!this.uvs && other.uvs) this.uvs = new Float32Array(this.positions.length / 3 * 2);
            if (!this.uvs2 && other.uvs2) this.uvs2 = new Float32Array(this.positions.length / 3 * 2);
            if (!this.uvs3 && other.uvs3) this.uvs3 = new Float32Array(this.positions.length / 3 * 2);
            if (!this.uvs4 && other.uvs4) this.uvs4 = new Float32Array(this.positions.length / 3 * 2);
            if (!this.uvs5 && other.uvs5) this.uvs5 = new Float32Array(this.positions.length / 3 * 2);
            if (!this.uvs6 && other.uvs6) this.uvs6 = new Float32Array(this.positions.length / 3 * 2);
            if (!this.colors && other.colors) {
                this.colors = new Float32Array(this.positions.length / 3 * 4);
                this.colors.fill(1); // Set to white by default
            }
            if (!this.matricesIndices && other.matricesIndices) this.matricesIndices = new Float32Array(this.positions.length / 3 * 4);
            if (!this.matricesWeights && other.matricesWeights) this.matricesWeights = new Float32Array(this.positions.length / 3 * 4);
            if (!this.matricesIndicesExtra && other.matricesIndicesExtra) this.matricesIndicesExtra = new Float32Array(this.positions.length / 3 * 4);
            if (!this.matricesWeightsExtra && other.matricesWeightsExtra) this.matricesWeightsExtra = new Float32Array(this.positions.length / 3 * 4);
        }
        for (const other of others){
            if (!other) continue;
            if (!enableCompletion) {
                other._validate();
                if (!this.normals !== !other.normals || !this.tangents !== !other.tangents || !this.uvs !== !other.uvs || !this.uvs2 !== !other.uvs2 || !this.uvs3 !== !other.uvs3 || !this.uvs4 !== !other.uvs4 || !this.uvs5 !== !other.uvs5 || !this.uvs6 !== !other.uvs6 || !this.colors !== !other.colors || !this.matricesIndices !== !other.matricesIndices || !this.matricesWeights !== !other.matricesWeights || !this.matricesIndicesExtra !== !other.matricesIndicesExtra || !this.matricesWeightsExtra !== !other.matricesWeightsExtra) throw new Error("Cannot merge vertex data that do not have the same set of attributes");
            } else {
                // Align the others with main set of attributes
                if (this.normals && !other.normals) other.normals = new Float32Array(other.positions.length);
                if (this.tangents && !other.tangents) other.tangents = new Float32Array(other.positions.length / 3 * 4);
                if (this.uvs && !other.uvs) other.uvs = new Float32Array(other.positions.length / 3 * 2);
                if (this.uvs2 && !other.uvs2) other.uvs2 = new Float32Array(other.positions.length / 3 * 2);
                if (this.uvs3 && !other.uvs3) other.uvs3 = new Float32Array(other.positions.length / 3 * 2);
                if (this.uvs4 && !other.uvs4) other.uvs4 = new Float32Array(other.positions.length / 3 * 2);
                if (this.uvs5 && !other.uvs5) other.uvs5 = new Float32Array(other.positions.length / 3 * 2);
                if (this.uvs6 && !other.uvs6) other.uvs6 = new Float32Array(other.positions.length / 3 * 2);
                if (this.colors && !other.colors) {
                    other.colors = new Float32Array(other.positions.length / 3 * 4);
                    other.colors.fill(1); // Set to white by default
                }
                if (this.matricesIndices && !other.matricesIndices) other.matricesIndices = new Float32Array(other.positions.length / 3 * 4);
                if (this.matricesWeights && !other.matricesWeights) other.matricesWeights = new Float32Array(other.positions.length / 3 * 4);
                if (this.matricesIndicesExtra && !other.matricesIndicesExtra) other.matricesIndicesExtra = new Float32Array(other.positions.length / 3 * 4);
                if (this.matricesWeightsExtra && !other.matricesWeightsExtra) other.matricesWeightsExtra = new Float32Array(other.positions.length / 3 * 4);
            }
        }
        if (mergeMaterialIds) {
            // Merge material infos
            let materialIndex = 0;
            let indexOffset = 0;
            let vertexOffset = 0;
            const materialInfos = [];
            let currentMaterialInfo = null;
            const vertexDataList = [];
            // We need to split vertexData with more than one materialInfo
            for (const split of this.splitBasedOnMaterialID())vertexDataList.push({
                vertexData: split,
                transform: transform
            });
            for (const data of vertexDatas){
                if (!data.vertexData) continue;
                for (const split of data.vertexData.splitBasedOnMaterialID())vertexDataList.push({
                    vertexData: split,
                    transform: data.transform
                });
            }
            // Sort by material IDs
            vertexDataList.sort((a, b)=>{
                const matInfoA = a.vertexData.materialInfos ? a.vertexData.materialInfos[0].materialIndex : 0;
                const matInfoB = b.vertexData.materialInfos ? b.vertexData.materialInfos[0].materialIndex : 0;
                if (matInfoA > matInfoB) return 1;
                if (matInfoA === matInfoB) return 0;
                return -1;
            });
            // Build the new material info
            for (const vertexDataSource of vertexDataList){
                const vertexData = vertexDataSource.vertexData;
                if (vertexData.materialInfos) materialIndex = vertexData.materialInfos[0].materialIndex;
                else materialIndex = 0;
                if (currentMaterialInfo && currentMaterialInfo.materialIndex === materialIndex) {
                    currentMaterialInfo.indexCount += vertexData.indices.length;
                    currentMaterialInfo.verticesCount += vertexData.positions.length / 3;
                } else {
                    const materialInfo = new $4014d881db0e9bc6$export$f5240a0ce3a46ac1();
                    materialInfo.materialIndex = materialIndex;
                    materialInfo.indexStart = indexOffset;
                    materialInfo.indexCount = vertexData.indices.length;
                    materialInfo.verticesStart = vertexOffset;
                    materialInfo.verticesCount = vertexData.positions.length / 3;
                    materialInfos.push(materialInfo);
                    currentMaterialInfo = materialInfo;
                }
                indexOffset += vertexData.indices.length;
                vertexOffset += vertexData.positions.length / 3;
            }
            // Extract sorted values
            const first = vertexDataList.splice(0, 1)[0];
            root = first.vertexData;
            transform = first.transform;
            others = vertexDataList.map((v)=>v.vertexData);
            vertexDatas = vertexDataList;
            this.materialInfos = materialInfos;
        }
        // Merge geometries
        const totalIndices = others.reduce((indexSum, vertexData)=>indexSum + (vertexData.indices?.length ?? 0), root.indices?.length ?? 0);
        const sliceIndices = forceCloneIndices || others.some((vertexData)=>vertexData.indices === root.indices);
        let indices = sliceIndices ? root.indices?.slice() : root.indices;
        if (totalIndices > 0) {
            let indicesOffset = indices?.length ?? 0;
            if (!indices) indices = new Array(totalIndices);
            if (indices.length !== totalIndices) {
                if (Array.isArray(indices)) indices.length = totalIndices;
                else {
                    const temp = use32BitsIndices || indices instanceof Uint32Array ? new Uint32Array(totalIndices) : new Uint16Array(totalIndices);
                    temp.set(indices);
                    indices = temp;
                }
                if (transform && transform.determinant() < 0) $4014d881db0e9bc6$export$8570d39351855acb._FlipFaces(indices, 0, indicesOffset);
            }
            let positionsOffset = root.positions ? root.positions.length / 3 : 0;
            for (const { vertexData: other, transform: transform } of vertexDatas)if (other.indices) {
                for(let index = 0; index < other.indices.length; index++)indices[indicesOffset + index] = other.indices[index] + positionsOffset;
                if (transform && transform.determinant() < 0) $4014d881db0e9bc6$export$8570d39351855acb._FlipFaces(indices, indicesOffset, other.indices.length);
                // The call to _validate already checked for positions
                positionsOffset += other.positions.length / 3;
                indicesOffset += other.indices.length;
                if (isAsync) yield;
            }
        }
        this.indices = indices;
        this.positions = $4014d881db0e9bc6$export$8570d39351855acb._MergeElement((0, $b4i1f.VertexBuffer).PositionKind, root.positions, transform, vertexDatas.map((other)=>[
                other.vertexData.positions,
                other.transform
            ]));
        if (isAsync) yield;
        if (root.normals) {
            this.normals = $4014d881db0e9bc6$export$8570d39351855acb._MergeElement((0, $b4i1f.VertexBuffer).NormalKind, root.normals, transform, vertexDatas.map((other)=>[
                    other.vertexData.normals,
                    other.transform
                ]));
            if (isAsync) yield;
        }
        if (root.tangents) {
            this.tangents = $4014d881db0e9bc6$export$8570d39351855acb._MergeElement((0, $b4i1f.VertexBuffer).TangentKind, root.tangents, transform, vertexDatas.map((other)=>[
                    other.vertexData.tangents,
                    other.transform
                ]));
            if (isAsync) yield;
        }
        if (root.uvs) {
            this.uvs = $4014d881db0e9bc6$export$8570d39351855acb._MergeElement((0, $b4i1f.VertexBuffer).UVKind, root.uvs, transform, vertexDatas.map((other)=>[
                    other.vertexData.uvs,
                    other.transform
                ]));
            if (isAsync) yield;
        }
        if (root.uvs2) {
            this.uvs2 = $4014d881db0e9bc6$export$8570d39351855acb._MergeElement((0, $b4i1f.VertexBuffer).UV2Kind, root.uvs2, transform, vertexDatas.map((other)=>[
                    other.vertexData.uvs2,
                    other.transform
                ]));
            if (isAsync) yield;
        }
        if (root.uvs3) {
            this.uvs3 = $4014d881db0e9bc6$export$8570d39351855acb._MergeElement((0, $b4i1f.VertexBuffer).UV3Kind, root.uvs3, transform, vertexDatas.map((other)=>[
                    other.vertexData.uvs3,
                    other.transform
                ]));
            if (isAsync) yield;
        }
        if (root.uvs4) {
            this.uvs4 = $4014d881db0e9bc6$export$8570d39351855acb._MergeElement((0, $b4i1f.VertexBuffer).UV4Kind, root.uvs4, transform, vertexDatas.map((other)=>[
                    other.vertexData.uvs4,
                    other.transform
                ]));
            if (isAsync) yield;
        }
        if (root.uvs5) {
            this.uvs5 = $4014d881db0e9bc6$export$8570d39351855acb._MergeElement((0, $b4i1f.VertexBuffer).UV5Kind, root.uvs5, transform, vertexDatas.map((other)=>[
                    other.vertexData.uvs5,
                    other.transform
                ]));
            if (isAsync) yield;
        }
        if (root.uvs6) {
            this.uvs6 = $4014d881db0e9bc6$export$8570d39351855acb._MergeElement((0, $b4i1f.VertexBuffer).UV6Kind, root.uvs6, transform, vertexDatas.map((other)=>[
                    other.vertexData.uvs6,
                    other.transform
                ]));
            if (isAsync) yield;
        }
        if (root.colors) {
            this.colors = $4014d881db0e9bc6$export$8570d39351855acb._MergeElement((0, $b4i1f.VertexBuffer).ColorKind, root.colors, transform, vertexDatas.map((other)=>[
                    other.vertexData.colors,
                    other.transform
                ]));
            if (root.hasVertexAlpha !== undefined || vertexDatas.some((other)=>other.vertexData.hasVertexAlpha !== undefined)) this.hasVertexAlpha = root.hasVertexAlpha || vertexDatas.some((other)=>other.vertexData.hasVertexAlpha);
            if (isAsync) yield;
        }
        if (root.matricesIndices) {
            this.matricesIndices = $4014d881db0e9bc6$export$8570d39351855acb._MergeElement((0, $b4i1f.VertexBuffer).MatricesIndicesKind, root.matricesIndices, transform, vertexDatas.map((other)=>[
                    other.vertexData.matricesIndices,
                    other.transform
                ]));
            if (isAsync) yield;
        }
        if (root.matricesWeights) {
            this.matricesWeights = $4014d881db0e9bc6$export$8570d39351855acb._MergeElement((0, $b4i1f.VertexBuffer).MatricesWeightsKind, root.matricesWeights, transform, vertexDatas.map((other)=>[
                    other.vertexData.matricesWeights,
                    other.transform
                ]));
            if (isAsync) yield;
        }
        if (root.matricesIndicesExtra) {
            this.matricesIndicesExtra = $4014d881db0e9bc6$export$8570d39351855acb._MergeElement((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind, root.matricesIndicesExtra, transform, vertexDatas.map((other)=>[
                    other.vertexData.matricesIndicesExtra,
                    other.transform
                ]));
            if (isAsync) yield;
        }
        if (root.matricesWeightsExtra) this.matricesWeightsExtra = $4014d881db0e9bc6$export$8570d39351855acb._MergeElement((0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind, root.matricesWeightsExtra, transform, vertexDatas.map((other)=>[
                other.vertexData.matricesWeightsExtra,
                other.transform
            ]));
        return this;
    }
    static _MergeElement(kind, source, transform, others) {
        const nonNullOthers = others.filter((other)=>other[0] !== null && other[0] !== undefined);
        // If there is no source to copy and no other non-null sources then skip this element.
        if (!source && nonNullOthers.length == 0) return source;
        if (!source) return this._MergeElement(kind, nonNullOthers[0][0], nonNullOthers[0][1], nonNullOthers.slice(1));
        const len = nonNullOthers.reduce((sumLen, elements)=>sumLen + elements[0].length, source.length);
        const transformRange = kind === (0, $b4i1f.VertexBuffer).PositionKind ? $4014d881db0e9bc6$export$8570d39351855acb._TransformVector3Coordinates : kind === (0, $b4i1f.VertexBuffer).NormalKind ? $4014d881db0e9bc6$export$8570d39351855acb._TransformVector3Normals : kind === (0, $b4i1f.VertexBuffer).TangentKind ? $4014d881db0e9bc6$export$8570d39351855acb._TransformVector4Normals : ()=>{};
        if (source instanceof Float32Array) {
            // use non-loop method when the source is Float32Array
            const ret32 = new Float32Array(len);
            ret32.set(source);
            transform && transformRange(ret32, transform, 0, source.length);
            let offset = source.length;
            for (const [vertexData, transform] of nonNullOthers){
                ret32.set(vertexData, offset);
                transform && transformRange(ret32, transform, offset, vertexData.length);
                offset += vertexData.length;
            }
            return ret32;
        } else {
            // don't use concat as it is super slow, just loop for other cases
            const ret = new Array(len);
            for(let i = 0; i < source.length; i++)ret[i] = source[i];
            transform && transformRange(ret, transform, 0, source.length);
            let offset = source.length;
            for (const [vertexData, transform] of nonNullOthers){
                for(let i = 0; i < vertexData.length; i++)ret[offset + i] = vertexData[i];
                transform && transformRange(ret, transform, offset, vertexData.length);
                offset += vertexData.length;
            }
            return ret;
        }
    }
    _validate() {
        if (!this.positions) throw new (0, $1FkG9.RuntimeError)("Positions are required", (0, $1FkG9.ErrorCodes).MeshInvalidPositionsError);
        const getElementCount = (kind, values)=>{
            const stride = (0, $b4i1f.VertexBuffer).DeduceStride(kind);
            if (values.length % stride !== 0) throw new Error("The " + kind + "s array count must be a multiple of " + stride);
            return values.length / stride;
        };
        const positionsElementCount = getElementCount((0, $b4i1f.VertexBuffer).PositionKind, this.positions);
        const validateElementCount = (kind, values)=>{
            const elementCount = getElementCount(kind, values);
            if (elementCount !== positionsElementCount) throw new Error("The " + kind + "s element count (" + elementCount + ") does not match the positions count (" + positionsElementCount + ")");
        };
        if (this.normals) validateElementCount((0, $b4i1f.VertexBuffer).NormalKind, this.normals);
        if (this.tangents) validateElementCount((0, $b4i1f.VertexBuffer).TangentKind, this.tangents);
        if (this.uvs) validateElementCount((0, $b4i1f.VertexBuffer).UVKind, this.uvs);
        if (this.uvs2) validateElementCount((0, $b4i1f.VertexBuffer).UV2Kind, this.uvs2);
        if (this.uvs3) validateElementCount((0, $b4i1f.VertexBuffer).UV3Kind, this.uvs3);
        if (this.uvs4) validateElementCount((0, $b4i1f.VertexBuffer).UV4Kind, this.uvs4);
        if (this.uvs5) validateElementCount((0, $b4i1f.VertexBuffer).UV5Kind, this.uvs5);
        if (this.uvs6) validateElementCount((0, $b4i1f.VertexBuffer).UV6Kind, this.uvs6);
        if (this.colors) validateElementCount((0, $b4i1f.VertexBuffer).ColorKind, this.colors);
        if (this.matricesIndices) validateElementCount((0, $b4i1f.VertexBuffer).MatricesIndicesKind, this.matricesIndices);
        if (this.matricesWeights) validateElementCount((0, $b4i1f.VertexBuffer).MatricesWeightsKind, this.matricesWeights);
        if (this.matricesIndicesExtra) validateElementCount((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind, this.matricesIndicesExtra);
        if (this.matricesWeightsExtra) validateElementCount((0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind, this.matricesWeightsExtra);
    }
    /**
     * Clone the current vertex data
     * @returns a copy of the current data
     */ clone() {
        const serializationObject = this.serialize();
        return $4014d881db0e9bc6$export$8570d39351855acb.Parse(serializationObject);
    }
    /**
     * Serializes the VertexData
     * @returns a serialized object
     */ serialize() {
        const serializationObject = {};
        if (this.positions) serializationObject.positions = Array.from(this.positions);
        if (this.normals) serializationObject.normals = Array.from(this.normals);
        if (this.tangents) serializationObject.tangents = Array.from(this.tangents);
        if (this.uvs) serializationObject.uvs = Array.from(this.uvs);
        if (this.uvs2) serializationObject.uvs2 = Array.from(this.uvs2);
        if (this.uvs3) serializationObject.uvs3 = Array.from(this.uvs3);
        if (this.uvs4) serializationObject.uvs4 = Array.from(this.uvs4);
        if (this.uvs5) serializationObject.uvs5 = Array.from(this.uvs5);
        if (this.uvs6) serializationObject.uvs6 = Array.from(this.uvs6);
        if (this.colors) {
            serializationObject.colors = Array.from(this.colors);
            serializationObject.hasVertexAlpha = this.hasVertexAlpha;
        }
        if (this.matricesIndices) {
            serializationObject.matricesIndices = Array.from(this.matricesIndices);
            serializationObject.matricesIndices._isExpanded = true;
        }
        if (this.matricesWeights) serializationObject.matricesWeights = Array.from(this.matricesWeights);
        if (this.matricesIndicesExtra) {
            serializationObject.matricesIndicesExtra = Array.from(this.matricesIndicesExtra);
            serializationObject.matricesIndicesExtra._isExpanded = true;
        }
        if (this.matricesWeightsExtra) serializationObject.matricesWeightsExtra = Array.from(this.matricesWeightsExtra);
        serializationObject.indices = Array.from(this.indices);
        if (this.materialInfos) {
            serializationObject.materialInfos = [];
            for (const materialInfo of this.materialInfos){
                const materialInfoSerializationObject = {
                    indexStart: materialInfo.indexStart,
                    indexCount: materialInfo.indexCount,
                    materialIndex: materialInfo.materialIndex,
                    verticesStart: materialInfo.verticesStart,
                    verticesCount: materialInfo.verticesCount
                };
                serializationObject.materialInfos.push(materialInfoSerializationObject);
            }
        }
        return serializationObject;
    }
    // Statics
    /**
     * Extracts the vertexData from a mesh
     * @param mesh the mesh from which to extract the VertexData
     * @param copyWhenShared defines if the VertexData must be cloned when shared between multiple meshes, optional, default false
     * @param forceCopy indicating that the VertexData must be cloned, optional, default false
     * @returns the object VertexData associated to the passed mesh
     */ static ExtractFromMesh(mesh, copyWhenShared, forceCopy) {
        return $4014d881db0e9bc6$export$8570d39351855acb._ExtractFrom(mesh, copyWhenShared, forceCopy);
    }
    /**
     * Extracts the vertexData from the geometry
     * @param geometry the geometry from which to extract the VertexData
     * @param copyWhenShared defines if the VertexData must be cloned when the geometry is shared between multiple meshes, optional, default false
     * @param forceCopy indicating that the VertexData must be cloned, optional, default false
     * @returns the object VertexData associated to the passed mesh
     */ static ExtractFromGeometry(geometry, copyWhenShared, forceCopy) {
        return $4014d881db0e9bc6$export$8570d39351855acb._ExtractFrom(geometry, copyWhenShared, forceCopy);
    }
    static _ExtractFrom(meshOrGeometry, copyWhenShared, forceCopy) {
        const result = new $4014d881db0e9bc6$export$8570d39351855acb();
        if (meshOrGeometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).PositionKind)) result.positions = meshOrGeometry.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind, copyWhenShared, forceCopy);
        if (meshOrGeometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).NormalKind)) result.normals = meshOrGeometry.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind, copyWhenShared, forceCopy);
        if (meshOrGeometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).TangentKind)) result.tangents = meshOrGeometry.getVerticesData((0, $b4i1f.VertexBuffer).TangentKind, copyWhenShared, forceCopy);
        if (meshOrGeometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UVKind)) result.uvs = meshOrGeometry.getVerticesData((0, $b4i1f.VertexBuffer).UVKind, copyWhenShared, forceCopy);
        if (meshOrGeometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UV2Kind)) result.uvs2 = meshOrGeometry.getVerticesData((0, $b4i1f.VertexBuffer).UV2Kind, copyWhenShared, forceCopy);
        if (meshOrGeometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UV3Kind)) result.uvs3 = meshOrGeometry.getVerticesData((0, $b4i1f.VertexBuffer).UV3Kind, copyWhenShared, forceCopy);
        if (meshOrGeometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UV4Kind)) result.uvs4 = meshOrGeometry.getVerticesData((0, $b4i1f.VertexBuffer).UV4Kind, copyWhenShared, forceCopy);
        if (meshOrGeometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UV5Kind)) result.uvs5 = meshOrGeometry.getVerticesData((0, $b4i1f.VertexBuffer).UV5Kind, copyWhenShared, forceCopy);
        if (meshOrGeometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UV6Kind)) result.uvs6 = meshOrGeometry.getVerticesData((0, $b4i1f.VertexBuffer).UV6Kind, copyWhenShared, forceCopy);
        if (meshOrGeometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).ColorKind)) result.colors = meshOrGeometry.getVerticesData((0, $b4i1f.VertexBuffer).ColorKind, copyWhenShared, forceCopy);
        if (meshOrGeometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).MatricesIndicesKind)) result.matricesIndices = meshOrGeometry.getVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesKind, copyWhenShared, forceCopy);
        if (meshOrGeometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).MatricesWeightsKind)) result.matricesWeights = meshOrGeometry.getVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsKind, copyWhenShared, forceCopy);
        if (meshOrGeometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind)) result.matricesIndicesExtra = meshOrGeometry.getVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind, copyWhenShared, forceCopy);
        if (meshOrGeometry.isVerticesDataPresent((0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind)) result.matricesWeightsExtra = meshOrGeometry.getVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind, copyWhenShared, forceCopy);
        result.indices = meshOrGeometry.getIndices(copyWhenShared, forceCopy);
        return result;
    }
    /**
     * Creates the VertexData for a Ribbon
     * @param options an object used to set the following optional parameters for the ribbon, required but can be empty
     * * pathArray array of paths, each of which an array of successive Vector3
     * * closeArray creates a seam between the first and the last paths of the pathArray, optional, default false
     * * closePath creates a seam between the first and the last points of each path of the path array, optional, default false
     * * offset a positive integer, only used when pathArray contains a single path (offset = 10 means the point 1 is joined to the point 11), default rounded half size of the pathArray length
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * * invertUV swaps in the U and V coordinates when applying a texture, optional, default false
     * * uvs a linear array, of length 2 * number of vertices, of custom UV values, optional
     * * colors a linear array, of length 4 * number of vertices, of custom color values, optional
     * @returns the VertexData of the ribbon
     * @deprecated use CreateRibbonVertexData instead
     */ static CreateRibbon(options) {
        throw (0, $dUFYy._WarnImport)("ribbonBuilder");
    }
    /**
     * Creates the VertexData for a box
     * @param options an object used to set the following optional parameters for the box, required but can be empty
     * * size sets the width, height and depth of the box to the value of size, optional default 1
     * * width sets the width (x direction) of the box, overwrites the width set by size, optional, default size
     * * height sets the height (y direction) of the box, overwrites the height set by size, optional, default size
     * * depth sets the depth (z direction) of the box, overwrites the depth set by size, optional, default size
     * * faceUV an array of 6 Vector4 elements used to set different images to each box side
     * * faceColors an array of 6 Color3 elements used to set different colors to each box side
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * @returns the VertexData of the box
     * @deprecated Please use CreateBoxVertexData from the BoxBuilder file instead
     */ static CreateBox(options) {
        throw (0, $dUFYy._WarnImport)("boxBuilder");
    }
    /**
     * Creates the VertexData for a tiled box
     * @param options an object used to set the following optional parameters for the box, required but can be empty
     * * faceTiles sets the pattern, tile size and number of tiles for a face
     * * faceUV an array of 6 Vector4 elements used to set different images to each box side
     * * faceColors an array of 6 Color3 elements used to set different colors to each box side
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * @param options.pattern
     * @param options.width
     * @param options.height
     * @param options.depth
     * @param options.tileSize
     * @param options.tileWidth
     * @param options.tileHeight
     * @param options.alignHorizontal
     * @param options.alignVertical
     * @param options.faceUV
     * @param options.faceColors
     * @param options.sideOrientation
     * @returns the VertexData of the box
     * @deprecated Please use CreateTiledBoxVertexData instead
     */ static CreateTiledBox(options) {
        throw (0, $dUFYy._WarnImport)("tiledBoxBuilder");
    }
    /**
     * Creates the VertexData for a tiled plane
     * @param options an object used to set the following optional parameters for the box, required but can be empty
     * * pattern a limited pattern arrangement depending on the number
     * * tileSize sets the width, height and depth of the tile to the value of size, optional default 1
     * * tileWidth sets the width (x direction) of the tile, overwrites the width set by size, optional, default size
     * * tileHeight sets the height (y direction) of the tile, overwrites the height set by size, optional, default size
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * @returns the VertexData of the tiled plane
     * @deprecated use CreateTiledPlaneVertexData instead
     */ static CreateTiledPlane(options) {
        throw (0, $dUFYy._WarnImport)("tiledPlaneBuilder");
    }
    /**
     * Creates the VertexData for an ellipsoid, defaults to a sphere
     * @param options an object used to set the following optional parameters for the box, required but can be empty
     * * segments sets the number of horizontal strips optional, default 32
     * * diameter sets the axes dimensions, diameterX, diameterY and diameterZ to the value of diameter, optional default 1
     * * diameterX sets the diameterX (x direction) of the ellipsoid, overwrites the diameterX set by diameter, optional, default diameter
     * * diameterY sets the diameterY (y direction) of the ellipsoid, overwrites the diameterY set by diameter, optional, default diameter
     * * diameterZ sets the diameterZ (z direction) of the ellipsoid, overwrites the diameterZ set by diameter, optional, default diameter
     * * arc a number from 0 to 1, to create an unclosed ellipsoid based on the fraction of the circumference (latitude) given by the arc value, optional, default 1
     * * slice a number from 0 to 1, to create an unclosed ellipsoid based on the fraction of the height (latitude) given by the arc value, optional, default 1
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * @returns the VertexData of the ellipsoid
     * @deprecated use CreateSphereVertexData instead
     */ static CreateSphere(options) {
        throw (0, $dUFYy._WarnImport)("sphereBuilder");
    }
    /**
     * Creates the VertexData for a cylinder, cone or prism
     * @param options an object used to set the following optional parameters for the box, required but can be empty
     * * height sets the height (y direction) of the cylinder, optional, default 2
     * * diameterTop sets the diameter of the top of the cone, overwrites diameter,  optional, default diameter
     * * diameterBottom sets the diameter of the bottom of the cone, overwrites diameter,  optional, default diameter
     * * diameter sets the diameter of the top and bottom of the cone, optional default 1
     * * tessellation the number of prism sides, 3 for a triangular prism, optional, default 24
     * * subdivisions` the number of rings along the cylinder height, optional, default 1
     * * arc a number from 0 to 1, to create an unclosed cylinder based on the fraction of the circumference given by the arc value, optional, default 1
     * * faceColors an array of Color3 elements used to set different colors to the top, rings and bottom respectively
     * * faceUV an array of Vector4 elements used to set different images to the top, rings and bottom respectively
     * * hasRings when true makes each subdivision independently treated as a face for faceUV and faceColors, optional, default false
     * * enclose when true closes an open cylinder by adding extra flat faces between the height axis and vertical edges, think cut cake
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * @returns the VertexData of the cylinder, cone or prism
     * @deprecated please use CreateCylinderVertexData instead
     */ static CreateCylinder(options) {
        throw (0, $dUFYy._WarnImport)("cylinderBuilder");
    }
    /**
     * Creates the VertexData for a torus
     * @param options an object used to set the following optional parameters for the box, required but can be empty
     * * diameter the diameter of the torus, optional default 1
     * * thickness the diameter of the tube forming the torus, optional default 0.5
     * * tessellation the number of prism sides, 3 for a triangular prism, optional, default 24
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * @returns the VertexData of the torus
     * @deprecated use CreateTorusVertexData instead
     */ static CreateTorus(options) {
        throw (0, $dUFYy._WarnImport)("torusBuilder");
    }
    /**
     * Creates the VertexData of the LineSystem
     * @param options an object used to set the following optional parameters for the LineSystem, required but can be empty
     *  - lines an array of lines, each line being an array of successive Vector3
     *  - colors an array of line colors, each of the line colors being an array of successive Color4, one per line point
     * @returns the VertexData of the LineSystem
     * @deprecated use CreateLineSystemVertexData instead
     */ static CreateLineSystem(options) {
        throw (0, $dUFYy._WarnImport)("linesBuilder");
    }
    /**
     * Create the VertexData for a DashedLines
     * @param options an object used to set the following optional parameters for the DashedLines, required but can be empty
     *  - points an array successive Vector3
     *  - dashSize the size of the dashes relative to the dash number, optional, default 3
     *  - gapSize the size of the gap between two successive dashes relative to the dash number, optional, default 1
     *  - dashNb the intended total number of dashes, optional, default 200
     * @returns the VertexData for the DashedLines
     * @deprecated use CreateDashedLinesVertexData instead
     */ static CreateDashedLines(options) {
        throw (0, $dUFYy._WarnImport)("linesBuilder");
    }
    /**
     * Creates the VertexData for a Ground
     * @param options an object used to set the following optional parameters for the Ground, required but can be empty
     *  - width the width (x direction) of the ground, optional, default 1
     *  - height the height (z direction) of the ground, optional, default 1
     *  - subdivisions the number of subdivisions per side, optional, default 1
     * @returns the VertexData of the Ground
     * @deprecated Please use CreateGroundVertexData instead
     */ static CreateGround(options) {
        throw (0, $dUFYy._WarnImport)("groundBuilder");
    }
    /**
     * Creates the VertexData for a TiledGround by subdividing the ground into tiles
     * @param options an object used to set the following optional parameters for the Ground, required but can be empty
     * * xmin the ground minimum X coordinate, optional, default -1
     * * zmin the ground minimum Z coordinate, optional, default -1
     * * xmax the ground maximum X coordinate, optional, default 1
     * * zmax the ground maximum Z coordinate, optional, default 1
     * * subdivisions a javascript object {w: positive integer, h: positive integer}, `w` and `h` are the numbers of subdivisions on the ground width and height creating 'tiles', default {w: 6, h: 6}
     * * precision a javascript object {w: positive integer, h: positive integer}, `w` and `h` are the numbers of subdivisions on the tile width and height, default {w: 2, h: 2}
     * @returns the VertexData of the TiledGround
     * @deprecated use CreateTiledGroundVertexData instead
     */ static CreateTiledGround(options) {
        throw (0, $dUFYy._WarnImport)("groundBuilder");
    }
    /**
     * Creates the VertexData of the Ground designed from a heightmap
     * @param options an object used to set the following parameters for the Ground, required and provided by CreateGroundFromHeightMap
     * * width the width (x direction) of the ground
     * * height the height (z direction) of the ground
     * * subdivisions the number of subdivisions per side
     * * minHeight the minimum altitude on the ground, optional, default 0
     * * maxHeight the maximum altitude on the ground, optional default 1
     * * colorFilter the filter to apply to the image pixel colors to compute the height, optional Color3, default (0.3, 0.59, 0.11)
     * * buffer the array holding the image color data
     * * bufferWidth the width of image
     * * bufferHeight the height of image
     * * alphaFilter Remove any data where the alpha channel is below this value, defaults 0 (all data visible)
     * @returns the VertexData of the Ground designed from a heightmap
     * @deprecated use CreateGroundFromHeightMapVertexData instead
     */ static CreateGroundFromHeightMap(options) {
        throw (0, $dUFYy._WarnImport)("groundBuilder");
    }
    /**
     * Creates the VertexData for a Plane
     * @param options an object used to set the following optional parameters for the plane, required but can be empty
     * * size sets the width and height of the plane to the value of size, optional default 1
     * * width sets the width (x direction) of the plane, overwrites the width set by size, optional, default size
     * * height sets the height (y direction) of the plane, overwrites the height set by size, optional, default size
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * @returns the VertexData of the box
     * @deprecated use CreatePlaneVertexData instead
     */ static CreatePlane(options) {
        throw (0, $dUFYy._WarnImport)("planeBuilder");
    }
    /**
     * Creates the VertexData of the Disc or regular Polygon
     * @param options an object used to set the following optional parameters for the disc, required but can be empty
     * * radius the radius of the disc, optional default 0.5
     * * tessellation the number of polygon sides, optional, default 64
     * * arc a number from 0 to 1, to create an unclosed polygon based on the fraction of the circumference given by the arc value, optional, default 1
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * @returns the VertexData of the box
     * @deprecated use CreateDiscVertexData instead
     */ static CreateDisc(options) {
        throw (0, $dUFYy._WarnImport)("discBuilder");
    }
    /**
     * Creates the VertexData for an irregular Polygon in the XoZ plane using a mesh built by polygonTriangulation.build()
     * All parameters are provided by CreatePolygon as needed
     * @param polygon a mesh built from polygonTriangulation.build()
     * @param sideOrientation takes the values Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * @param fUV an array of Vector4 elements used to set different images to the top, rings and bottom respectively
     * @param fColors an array of Color3 elements used to set different colors to the top, rings and bottom respectively
     * @param frontUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * @param backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * @param wrap a boolean, default false, when true and fUVs used texture is wrapped around all sides, when false texture is applied side
     * @returns the VertexData of the Polygon
     * @deprecated use CreatePolygonVertexData instead
     */ static CreatePolygon(polygon, sideOrientation, fUV, fColors, frontUVs, backUVs, wrap) {
        throw (0, $dUFYy._WarnImport)("polygonBuilder");
    }
    /**
     * Creates the VertexData of the IcoSphere
     * @param options an object used to set the following optional parameters for the IcoSphere, required but can be empty
     * * radius the radius of the IcoSphere, optional default 1
     * * radiusX allows stretching in the x direction, optional, default radius
     * * radiusY allows stretching in the y direction, optional, default radius
     * * radiusZ allows stretching in the z direction, optional, default radius
     * * flat when true creates a flat shaded mesh, optional, default true
     * * subdivisions increasing the subdivisions increases the number of faces, optional, default 4
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * @returns the VertexData of the IcoSphere
     * @deprecated use CreateIcoSphereVertexData instead
     */ static CreateIcoSphere(options) {
        throw (0, $dUFYy._WarnImport)("icoSphereBuilder");
    }
    // inspired from // http://stemkoski.github.io/Three.js/Polyhedra.html
    /**
     * Creates the VertexData for a Polyhedron
     * @param options an object used to set the following optional parameters for the polyhedron, required but can be empty
     * * type provided types are:
     *  * 0 : Tetrahedron, 1 : Octahedron, 2 : Dodecahedron, 3 : Icosahedron, 4 : Rhombicuboctahedron, 5 : Triangular Prism, 6 : Pentagonal Prism, 7 : Hexagonal Prism, 8 : Square Pyramid (J1)
     *  * 9 : Pentagonal Pyramid (J2), 10 : Triangular Dipyramid (J12), 11 : Pentagonal Dipyramid (J13), 12 : Elongated Square Dipyramid (J15), 13 : Elongated Pentagonal Dipyramid (J16), 14 : Elongated Pentagonal Cupola (J20)
     * * size the size of the IcoSphere, optional default 1
     * * sizeX allows stretching in the x direction, optional, default size
     * * sizeY allows stretching in the y direction, optional, default size
     * * sizeZ allows stretching in the z direction, optional, default size
     * * custom a number that overwrites the type to create from an extended set of polyhedron from https://www.babylonjs-playground.com/#21QRSK#15 with minimised editor
     * * faceUV an array of Vector4 elements used to set different images to the top, rings and bottom respectively
     * * faceColors an array of Color3 elements used to set different colors to the top, rings and bottom respectively
     * * flat when true creates a flat shaded mesh, optional, default true
     * * subdivisions increasing the subdivisions increases the number of faces, optional, default 4
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * @returns the VertexData of the Polyhedron
     * @deprecated use CreatePolyhedronVertexData instead
     */ static CreatePolyhedron(options) {
        throw (0, $dUFYy._WarnImport)("polyhedronBuilder");
    }
    /**
     * Creates the VertexData for a Capsule, inspired from https://github.com/maximeq/three-js-capsule-geometry/blob/master/src/CapsuleBufferGeometry.js
     * @param options an object used to set the following optional parameters for the capsule, required but can be empty
     * @returns the VertexData of the Capsule
     * @deprecated Please use CreateCapsuleVertexData from the capsuleBuilder file instead
     */ static CreateCapsule(options = {
        orientation: (0, $ha1VO.Vector3).Up(),
        subdivisions: 2,
        tessellation: 16,
        height: 1,
        radius: 0.25,
        capSubdivisions: 6
    }) {
        throw (0, $dUFYy._WarnImport)("capsuleBuilder");
    }
    // based on http://code.google.com/p/away3d/source/browse/trunk/fp10/Away3D/src/away3d/primitives/TorusKnot.as?spec=svn2473&r=2473
    /**
     * Creates the VertexData for a TorusKnot
     * @param options an object used to set the following optional parameters for the TorusKnot, required but can be empty
     * * radius the radius of the torus knot, optional, default 2
     * * tube the thickness of the tube, optional, default 0.5
     * * radialSegments the number of sides on each tube segments, optional, default 32
     * * tubularSegments the number of tubes to decompose the knot into, optional, default 32
     * * p the number of windings around the z axis, optional,  default 2
     * * q the number of windings around the x axis, optional,  default 3
     * * sideOrientation optional and takes the values : Mesh.FRONTSIDE (default), Mesh.BACKSIDE or Mesh.DOUBLESIDE
     * * frontUvs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the front side, optional, default vector4 (0, 0, 1, 1)
     * * backUVs only usable when you create a double-sided mesh, used to choose what parts of the texture image to crop and apply on the back side, optional, default vector4 (0, 0, 1, 1)
     * @returns the VertexData of the Torus Knot
     * @deprecated use CreateTorusKnotVertexData instead
     */ static CreateTorusKnot(options) {
        throw (0, $dUFYy._WarnImport)("torusKnotBuilder");
    }
    // Tools
    /**
     * Compute normals for given positions and indices
     * @param positions an array of vertex positions, [...., x, y, z, ......]
     * @param indices an array of indices in groups of three for each triangular facet, [...., i, j, k, ......]
     * @param normals an array of vertex normals, [...., x, y, z, ......]
     * @param options an object used to set the following optional parameters for the TorusKnot, optional
     * * facetNormals : optional array of facet normals (vector3)
     * * facetPositions : optional array of facet positions (vector3)
     * * facetPartitioning : optional partitioning array. facetPositions is required for facetPartitioning computation
     * * ratio : optional partitioning ratio / bounding box, required for facetPartitioning computation
     * * bInfo : optional bounding info, required for facetPartitioning computation
     * * bbSize : optional bounding box size data, required for facetPartitioning computation
     * * subDiv : optional partitioning data about subdivisions on  each axis (int), required for facetPartitioning computation
     * * useRightHandedSystem: optional boolean to for right handed system computation
     * * depthSort : optional boolean to enable the facet depth sort computation
     * * distanceTo : optional Vector3 to compute the facet depth from this location
     * * depthSortedFacets : optional array of depthSortedFacets to store the facet distances from the reference location
     */ static ComputeNormals(positions, indices, normals, options) {
        // temporary scalar variables
        let index = 0; // facet index
        let p1p2x = 0.0; // p1p2 vector x coordinate
        let p1p2y = 0.0; // p1p2 vector y coordinate
        let p1p2z = 0.0; // p1p2 vector z coordinate
        let p3p2x = 0.0; // p3p2 vector x coordinate
        let p3p2y = 0.0; // p3p2 vector y coordinate
        let p3p2z = 0.0; // p3p2 vector z coordinate
        let faceNormalx = 0.0; // facet normal x coordinate
        let faceNormaly = 0.0; // facet normal y coordinate
        let faceNormalz = 0.0; // facet normal z coordinate
        let length = 0.0; // facet normal length before normalization
        let v1x = 0; // vector1 x index in the positions array
        let v1y = 0; // vector1 y index in the positions array
        let v1z = 0; // vector1 z index in the positions array
        let v2x = 0; // vector2 x index in the positions array
        let v2y = 0; // vector2 y index in the positions array
        let v2z = 0; // vector2 z index in the positions array
        let v3x = 0; // vector3 x index in the positions array
        let v3y = 0; // vector3 y index in the positions array
        let v3z = 0; // vector3 z index in the positions array
        let computeFacetNormals = false;
        let computeFacetPositions = false;
        let computeFacetPartitioning = false;
        let computeDepthSort = false;
        let faceNormalSign = 1;
        let ratio = 0;
        let distanceTo = null;
        if (options) {
            computeFacetNormals = options.facetNormals ? true : false;
            computeFacetPositions = options.facetPositions ? true : false;
            computeFacetPartitioning = options.facetPartitioning ? true : false;
            faceNormalSign = options.useRightHandedSystem === true ? -1 : 1;
            ratio = options.ratio || 0;
            computeDepthSort = options.depthSort ? true : false;
            distanceTo = options.distanceTo;
            if (computeDepthSort) {
                if (distanceTo === undefined) distanceTo = (0, $ha1VO.Vector3).Zero();
            }
        }
        // facetPartitioning reinit if needed
        let xSubRatio = 0;
        let ySubRatio = 0;
        let zSubRatio = 0;
        let subSq = 0;
        if (computeFacetPartitioning && options && options.bbSize) {
            //let bbSizeMax = options.bbSize.x > options.bbSize.y ? options.bbSize.x : options.bbSize.y;
            //bbSizeMax = bbSizeMax > options.bbSize.z ? bbSizeMax : options.bbSize.z;
            xSubRatio = options.subDiv.X * ratio / options.bbSize.x;
            ySubRatio = options.subDiv.Y * ratio / options.bbSize.y;
            zSubRatio = options.subDiv.Z * ratio / options.bbSize.z;
            subSq = options.subDiv.max * options.subDiv.max;
            options.facetPartitioning.length = 0;
        }
        // reset the normals
        for(index = 0; index < positions.length; index++)normals[index] = 0.0;
        // Loop : 1 indice triplet = 1 facet
        const nbFaces = indices.length / 3 | 0;
        for(index = 0; index < nbFaces; index++){
            // get the indexes of the coordinates of each vertex of the facet
            v1x = indices[index * 3] * 3;
            v1y = v1x + 1;
            v1z = v1x + 2;
            v2x = indices[index * 3 + 1] * 3;
            v2y = v2x + 1;
            v2z = v2x + 2;
            v3x = indices[index * 3 + 2] * 3;
            v3y = v3x + 1;
            v3z = v3x + 2;
            p1p2x = positions[v1x] - positions[v2x]; // compute two vectors per facet : p1p2 and p3p2
            p1p2y = positions[v1y] - positions[v2y];
            p1p2z = positions[v1z] - positions[v2z];
            p3p2x = positions[v3x] - positions[v2x];
            p3p2y = positions[v3y] - positions[v2y];
            p3p2z = positions[v3z] - positions[v2z];
            // compute the face normal with the cross product
            faceNormalx = faceNormalSign * (p1p2y * p3p2z - p1p2z * p3p2y);
            faceNormaly = faceNormalSign * (p1p2z * p3p2x - p1p2x * p3p2z);
            faceNormalz = faceNormalSign * (p1p2x * p3p2y - p1p2y * p3p2x);
            // normalize this normal and store it in the array facetData
            length = Math.sqrt(faceNormalx * faceNormalx + faceNormaly * faceNormaly + faceNormalz * faceNormalz);
            length = length === 0 ? 1.0 : length;
            faceNormalx /= length;
            faceNormaly /= length;
            faceNormalz /= length;
            if (computeFacetNormals && options) {
                options.facetNormals[index].x = faceNormalx;
                options.facetNormals[index].y = faceNormaly;
                options.facetNormals[index].z = faceNormalz;
            }
            if (computeFacetPositions && options) {
                // compute and the facet barycenter coordinates in the array facetPositions
                options.facetPositions[index].x = (positions[v1x] + positions[v2x] + positions[v3x]) / 3.0;
                options.facetPositions[index].y = (positions[v1y] + positions[v2y] + positions[v3y]) / 3.0;
                options.facetPositions[index].z = (positions[v1z] + positions[v2z] + positions[v3z]) / 3.0;
            }
            if (computeFacetPartitioning && options) {
                // store the facet indexes in arrays in the main facetPartitioning array :
                // compute each facet vertex (+ facet barycenter) index in the partiniong array
                const ox = Math.floor((options.facetPositions[index].x - options.bInfo.minimum.x * ratio) * xSubRatio);
                const oy = Math.floor((options.facetPositions[index].y - options.bInfo.minimum.y * ratio) * ySubRatio);
                const oz = Math.floor((options.facetPositions[index].z - options.bInfo.minimum.z * ratio) * zSubRatio);
                const b1x = Math.floor((positions[v1x] - options.bInfo.minimum.x * ratio) * xSubRatio);
                const b1y = Math.floor((positions[v1y] - options.bInfo.minimum.y * ratio) * ySubRatio);
                const b1z = Math.floor((positions[v1z] - options.bInfo.minimum.z * ratio) * zSubRatio);
                const b2x = Math.floor((positions[v2x] - options.bInfo.minimum.x * ratio) * xSubRatio);
                const b2y = Math.floor((positions[v2y] - options.bInfo.minimum.y * ratio) * ySubRatio);
                const b2z = Math.floor((positions[v2z] - options.bInfo.minimum.z * ratio) * zSubRatio);
                const b3x = Math.floor((positions[v3x] - options.bInfo.minimum.x * ratio) * xSubRatio);
                const b3y = Math.floor((positions[v3y] - options.bInfo.minimum.y * ratio) * ySubRatio);
                const b3z = Math.floor((positions[v3z] - options.bInfo.minimum.z * ratio) * zSubRatio);
                const block_idx_v1 = b1x + options.subDiv.max * b1y + subSq * b1z;
                const block_idx_v2 = b2x + options.subDiv.max * b2y + subSq * b2z;
                const block_idx_v3 = b3x + options.subDiv.max * b3y + subSq * b3z;
                const block_idx_o = ox + options.subDiv.max * oy + subSq * oz;
                options.facetPartitioning[block_idx_o] = options.facetPartitioning[block_idx_o] ? options.facetPartitioning[block_idx_o] : new Array();
                options.facetPartitioning[block_idx_v1] = options.facetPartitioning[block_idx_v1] ? options.facetPartitioning[block_idx_v1] : new Array();
                options.facetPartitioning[block_idx_v2] = options.facetPartitioning[block_idx_v2] ? options.facetPartitioning[block_idx_v2] : new Array();
                options.facetPartitioning[block_idx_v3] = options.facetPartitioning[block_idx_v3] ? options.facetPartitioning[block_idx_v3] : new Array();
                // push each facet index in each block containing the vertex
                options.facetPartitioning[block_idx_v1].push(index);
                if (block_idx_v2 != block_idx_v1) options.facetPartitioning[block_idx_v2].push(index);
                if (!(block_idx_v3 == block_idx_v2 || block_idx_v3 == block_idx_v1)) options.facetPartitioning[block_idx_v3].push(index);
                if (!(block_idx_o == block_idx_v1 || block_idx_o == block_idx_v2 || block_idx_o == block_idx_v3)) options.facetPartitioning[block_idx_o].push(index);
            }
            if (computeDepthSort && options && options.facetPositions) {
                const dsf = options.depthSortedFacets[index];
                dsf.ind = index * 3;
                dsf.sqDistance = (0, $ha1VO.Vector3).DistanceSquared(options.facetPositions[index], distanceTo);
            }
            // compute the normals anyway
            normals[v1x] += faceNormalx; // accumulate all the normals per face
            normals[v1y] += faceNormaly;
            normals[v1z] += faceNormalz;
            normals[v2x] += faceNormalx;
            normals[v2y] += faceNormaly;
            normals[v2z] += faceNormalz;
            normals[v3x] += faceNormalx;
            normals[v3y] += faceNormaly;
            normals[v3z] += faceNormalz;
        }
        // last normalization of each normal
        for(index = 0; index < normals.length / 3; index++){
            faceNormalx = normals[index * 3];
            faceNormaly = normals[index * 3 + 1];
            faceNormalz = normals[index * 3 + 2];
            length = Math.sqrt(faceNormalx * faceNormalx + faceNormaly * faceNormaly + faceNormalz * faceNormalz);
            length = length === 0 ? 1.0 : length;
            faceNormalx /= length;
            faceNormaly /= length;
            faceNormalz /= length;
            normals[index * 3] = faceNormalx;
            normals[index * 3 + 1] = faceNormaly;
            normals[index * 3 + 2] = faceNormalz;
        }
    }
    /**
     * @internal
     */ static _ComputeSides(sideOrientation, positions, indices, normals, uvs, frontUVs, backUVs) {
        const li = indices.length;
        const ln = normals.length;
        let i;
        let n;
        sideOrientation = sideOrientation || $4014d881db0e9bc6$export$8570d39351855acb.DEFAULTSIDE;
        switch(sideOrientation){
            case $4014d881db0e9bc6$export$8570d39351855acb.FRONTSIDE:
                break;
            case $4014d881db0e9bc6$export$8570d39351855acb.BACKSIDE:
                // indices
                for(i = 0; i < li; i += 3){
                    const tmp = indices[i];
                    indices[i] = indices[i + 2];
                    indices[i + 2] = tmp;
                }
                // normals
                for(n = 0; n < ln; n++)normals[n] = -normals[n];
                break;
            case $4014d881db0e9bc6$export$8570d39351855acb.DOUBLESIDE:
                {
                    // positions
                    const lp = positions.length;
                    const l = lp / 3;
                    for(let p = 0; p < lp; p++)positions[lp + p] = positions[p];
                    // indices
                    for(i = 0; i < li; i += 3){
                        indices[i + li] = indices[i + 2] + l;
                        indices[i + 1 + li] = indices[i + 1] + l;
                        indices[i + 2 + li] = indices[i] + l;
                    }
                    // normals
                    for(n = 0; n < ln; n++)normals[ln + n] = -normals[n];
                    // uvs
                    const lu = uvs.length;
                    let u = 0;
                    for(u = 0; u < lu; u++)uvs[u + lu] = uvs[u];
                    frontUVs = frontUVs ? frontUVs : new (0, $ha1VO.Vector4)(0.0, 0.0, 1.0, 1.0);
                    backUVs = backUVs ? backUVs : new (0, $ha1VO.Vector4)(0.0, 0.0, 1.0, 1.0);
                    u = 0;
                    for(i = 0; i < lu / 2; i++){
                        uvs[u] = frontUVs.x + (frontUVs.z - frontUVs.x) * uvs[u];
                        uvs[u + 1] = frontUVs.y + (frontUVs.w - frontUVs.y) * uvs[u + 1];
                        uvs[u + lu] = backUVs.x + (backUVs.z - backUVs.x) * uvs[u + lu];
                        uvs[u + lu + 1] = backUVs.y + (backUVs.w - backUVs.y) * uvs[u + lu + 1];
                        u += 2;
                    }
                    break;
                }
        }
    }
    /**
     * Creates a VertexData from serialized data
     * @param parsedVertexData the parsed data from an imported file
     * @returns a VertexData
     */ static Parse(parsedVertexData) {
        const vertexData = new $4014d881db0e9bc6$export$8570d39351855acb();
        // positions
        const positions = parsedVertexData.positions;
        if (positions) vertexData.set(positions, (0, $b4i1f.VertexBuffer).PositionKind);
        // normals
        const normals = parsedVertexData.normals;
        if (normals) vertexData.set(normals, (0, $b4i1f.VertexBuffer).NormalKind);
        // tangents
        const tangents = parsedVertexData.tangents;
        if (tangents) vertexData.set(tangents, (0, $b4i1f.VertexBuffer).TangentKind);
        // uvs
        const uvs = parsedVertexData.uvs;
        if (uvs) vertexData.set(uvs, (0, $b4i1f.VertexBuffer).UVKind);
        // uv2s
        const uvs2 = parsedVertexData.uvs2;
        if (uvs2) vertexData.set(uvs2, (0, $b4i1f.VertexBuffer).UV2Kind);
        // uv3s
        const uvs3 = parsedVertexData.uvs3;
        if (uvs3) vertexData.set(uvs3, (0, $b4i1f.VertexBuffer).UV3Kind);
        // uv4s
        const uvs4 = parsedVertexData.uvs4;
        if (uvs4) vertexData.set(uvs4, (0, $b4i1f.VertexBuffer).UV4Kind);
        // uv5s
        const uvs5 = parsedVertexData.uvs5;
        if (uvs5) vertexData.set(uvs5, (0, $b4i1f.VertexBuffer).UV5Kind);
        // uv6s
        const uvs6 = parsedVertexData.uvs6;
        if (uvs6) vertexData.set(uvs6, (0, $b4i1f.VertexBuffer).UV6Kind);
        // colors
        const colors = parsedVertexData.colors;
        if (colors) {
            vertexData.set((0, $7etnY.Color4).CheckColors4(colors, positions.length / 3), (0, $b4i1f.VertexBuffer).ColorKind);
            if (parsedVertexData.hasVertexAlpha !== undefined) vertexData.hasVertexAlpha = parsedVertexData.hasVertexAlpha;
        }
        // matricesIndices
        const matricesIndices = parsedVertexData.matricesIndices;
        if (matricesIndices) vertexData.set(matricesIndices, (0, $b4i1f.VertexBuffer).MatricesIndicesKind);
        // matricesWeights
        const matricesWeights = parsedVertexData.matricesWeights;
        if (matricesWeights) vertexData.set(matricesWeights, (0, $b4i1f.VertexBuffer).MatricesWeightsKind);
        // indices
        const indices = parsedVertexData.indices;
        if (indices) vertexData.indices = indices;
        // MaterialInfos
        const materialInfos = parsedVertexData.materialInfos;
        if (materialInfos) {
            vertexData.materialInfos = [];
            for (const materialInfoFromJSON of materialInfos){
                const materialInfo = new $4014d881db0e9bc6$export$f5240a0ce3a46ac1();
                materialInfo.indexCount = materialInfoFromJSON.indexCount;
                materialInfo.indexStart = materialInfoFromJSON.indexStart;
                materialInfo.verticesCount = materialInfoFromJSON.verticesCount;
                materialInfo.verticesStart = materialInfoFromJSON.verticesStart;
                materialInfo.materialIndex = materialInfoFromJSON.materialIndex;
                vertexData.materialInfos.push(materialInfo);
            }
        }
        return vertexData;
    }
    /**
     * Applies VertexData created from the imported parameters to the geometry
     * @param parsedVertexData the parsed data from an imported file
     * @param geometry the geometry to apply the VertexData to
     */ static ImportVertexData(parsedVertexData, geometry) {
        const vertexData = $4014d881db0e9bc6$export$8570d39351855acb.Parse(parsedVertexData);
        geometry.setAllVerticesData(vertexData, parsedVertexData.updatable);
    }
}
/**
 * Mesh side orientation : usually the external or front surface
 */ $4014d881db0e9bc6$export$8570d39351855acb.FRONTSIDE = 0;
/**
 * Mesh side orientation : usually the internal or back surface
 */ $4014d881db0e9bc6$export$8570d39351855acb.BACKSIDE = 1;
/**
 * Mesh side orientation : both internal and external or front and back surfaces
 */ $4014d881db0e9bc6$export$8570d39351855acb.DOUBLESIDE = 2;
/**
 * Mesh side orientation : by default, `FRONTSIDE`
 */ $4014d881db0e9bc6$export$8570d39351855acb.DEFAULTSIDE = 0;
$4014d881db0e9bc6$export$8570d39351855acb._UniqueIDGenerator = 0;
(0, $e0Suo.__decorate)([
    (0, $ir0rz.nativeOverride).filter((...[coordinates])=>!Array.isArray(coordinates))
], $4014d881db0e9bc6$export$8570d39351855acb, "_TransformVector3Coordinates", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.nativeOverride).filter((...[normals])=>!Array.isArray(normals))
], $4014d881db0e9bc6$export$8570d39351855acb, "_TransformVector3Normals", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.nativeOverride).filter((...[normals])=>!Array.isArray(normals))
], $4014d881db0e9bc6$export$8570d39351855acb, "_TransformVector4Normals", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.nativeOverride).filter((...[indices])=>!Array.isArray(indices))
], $4014d881db0e9bc6$export$8570d39351855acb, "_FlipFaces", null);

});
parcelRegister("lEBSs", function(module, exports) {

$parcel$export(module.exports, "SubMesh", () => $fc3ab70ba5c9f506$export$c684db7d654df572);

var $b4i1f = parcelRequire("b4i1f");

var $iKm71 = parcelRequire("iKm71");

var $ef012 = parcelRequire("ef012");

var $1NJAz = parcelRequire("1NJAz");

var $hOyoX = parcelRequire("hOyoX");
class $fc3ab70ba5c9f506$export$c684db7d654df572 {
    /**
     * Gets material defines used by the effect associated to the sub mesh
     */ get materialDefines() {
        return this._mainDrawWrapperOverride ? this._mainDrawWrapperOverride.defines : this._getDrawWrapper()?.defines;
    }
    /**
     * Sets material defines used by the effect associated to the sub mesh
     */ set materialDefines(defines) {
        const drawWrapper = this._mainDrawWrapperOverride ?? this._getDrawWrapper(undefined, true);
        drawWrapper.defines = defines;
    }
    /**
     * @internal
     */ _getDrawWrapper(passId, createIfNotExisting = false) {
        passId = passId ?? this._engine.currentRenderPassId;
        let drawWrapper = this._drawWrappers[passId];
        if (!drawWrapper && createIfNotExisting) this._drawWrappers[passId] = drawWrapper = new (0, $hOyoX.DrawWrapper)(this._mesh.getScene().getEngine());
        return drawWrapper;
    }
    /**
     * @internal
     */ _removeDrawWrapper(passId, disposeWrapper = true) {
        if (disposeWrapper) this._drawWrappers[passId]?.dispose();
        this._drawWrappers[passId] = undefined;
    }
    /**
     * Gets associated (main) effect (possibly the effect override if defined)
     */ get effect() {
        return this._mainDrawWrapperOverride ? this._mainDrawWrapperOverride.effect : this._getDrawWrapper()?.effect ?? null;
    }
    /** @internal */ get _drawWrapper() {
        return this._mainDrawWrapperOverride ?? this._getDrawWrapper(undefined, true);
    }
    /** @internal */ get _drawWrapperOverride() {
        return this._mainDrawWrapperOverride;
    }
    /**
     * @internal
     */ _setMainDrawWrapperOverride(wrapper) {
        this._mainDrawWrapperOverride = wrapper;
    }
    /**
     * Sets associated effect (effect used to render this submesh)
     * @param effect defines the effect to associate with
     * @param defines defines the set of defines used to compile this effect
     * @param materialContext material context associated to the effect
     * @param resetContext true to reset the draw context
     */ setEffect(effect, defines = null, materialContext, resetContext = true) {
        const drawWrapper = this._drawWrapper;
        drawWrapper.setEffect(effect, defines, resetContext);
        if (materialContext !== undefined) drawWrapper.materialContext = materialContext;
        if (!effect) {
            drawWrapper.defines = null;
            drawWrapper.materialContext = undefined;
        }
    }
    /**
     * Resets the draw wrappers cache
     * @param passId If provided, releases only the draw wrapper corresponding to this render pass id
     */ resetDrawCache(passId) {
        if (this._drawWrappers) {
            if (passId !== undefined) {
                this._removeDrawWrapper(passId);
                return;
            } else for (const drawWrapper of this._drawWrappers)drawWrapper?.dispose();
        }
        this._drawWrappers = [];
    }
    /**
     * Add a new submesh to a mesh
     * @param materialIndex defines the material index to use
     * @param verticesStart defines vertex index start
     * @param verticesCount defines vertices count
     * @param indexStart defines index start
     * @param indexCount defines indices count
     * @param mesh defines the parent mesh
     * @param renderingMesh defines an optional rendering mesh
     * @param createBoundingBox defines if bounding box should be created for this submesh
     * @returns the new submesh
     */ static AddToMesh(materialIndex, verticesStart, verticesCount, indexStart, indexCount, mesh, renderingMesh, createBoundingBox = true) {
        return new $fc3ab70ba5c9f506$export$c684db7d654df572(materialIndex, verticesStart, verticesCount, indexStart, indexCount, mesh, renderingMesh, createBoundingBox);
    }
    /**
     * Creates a new submesh
     * @param materialIndex defines the material index to use
     * @param verticesStart defines vertex index start
     * @param verticesCount defines vertices count
     * @param indexStart defines index start
     * @param indexCount defines indices count
     * @param mesh defines the parent mesh
     * @param renderingMesh defines an optional rendering mesh
     * @param createBoundingBox defines if bounding box should be created for this submesh
     * @param addToMesh defines a boolean indicating that the submesh must be added to the mesh.subMeshes array (true by default)
     */ constructor(/** the material index to use */ materialIndex, /** vertex index start */ verticesStart, /** vertices count */ verticesCount, /** index start */ indexStart, /** indices count */ indexCount, mesh, renderingMesh, createBoundingBox = true, addToMesh = true){
        this.materialIndex = materialIndex;
        this.verticesStart = verticesStart;
        this.verticesCount = verticesCount;
        this.indexStart = indexStart;
        this.indexCount = indexCount;
        this._mainDrawWrapperOverride = null;
        /** @internal */ this._linesIndexCount = 0;
        this._linesIndexBuffer = null;
        /** @internal */ this._lastColliderWorldVertices = null;
        /** @internal */ this._lastColliderTransformMatrix = null;
        /** @internal */ this._wasDispatched = false;
        /** @internal */ this._renderId = 0;
        /** @internal */ this._alphaIndex = 0;
        /** @internal */ this._distanceToCamera = 0;
        this._currentMaterial = null;
        this._mesh = mesh;
        this._renderingMesh = renderingMesh || mesh;
        if (addToMesh) mesh.subMeshes.push(this);
        this._engine = this._mesh.getScene().getEngine();
        this.resetDrawCache();
        this._trianglePlanes = [];
        this._id = mesh.subMeshes.length - 1;
        if (createBoundingBox) {
            this.refreshBoundingInfo();
            mesh.computeWorldMatrix(true);
        }
    }
    /**
     * Returns true if this submesh covers the entire parent mesh
     * @ignorenaming
     */ // eslint-disable-next-line @typescript-eslint/naming-convention
    get IsGlobal() {
        return this.verticesStart === 0 && this.verticesCount === this._mesh.getTotalVertices() && this.indexStart === 0 && this.indexCount === this._mesh.getTotalIndices();
    }
    /**
     * Returns the submesh BoundingInfo object
     * @returns current bounding info (or mesh's one if the submesh is global)
     */ getBoundingInfo() {
        if (this.IsGlobal || this._mesh.hasThinInstances) return this._mesh.getBoundingInfo();
        return this._boundingInfo;
    }
    /**
     * Sets the submesh BoundingInfo
     * @param boundingInfo defines the new bounding info to use
     * @returns the SubMesh
     */ setBoundingInfo(boundingInfo) {
        this._boundingInfo = boundingInfo;
        return this;
    }
    /**
     * Returns the mesh of the current submesh
     * @returns the parent mesh
     */ getMesh() {
        return this._mesh;
    }
    /**
     * Returns the rendering mesh of the submesh
     * @returns the rendering mesh (could be different from parent mesh)
     */ getRenderingMesh() {
        return this._renderingMesh;
    }
    /**
     * Returns the replacement mesh of the submesh
     * @returns the replacement mesh (could be different from parent mesh)
     */ getReplacementMesh() {
        return this._mesh._internalAbstractMeshDataInfo._actAsRegularMesh ? this._mesh : null;
    }
    /**
     * Returns the effective mesh of the submesh
     * @returns the effective mesh (could be different from parent mesh)
     */ getEffectiveMesh() {
        const replacementMesh = this._mesh._internalAbstractMeshDataInfo._actAsRegularMesh ? this._mesh : null;
        return replacementMesh ? replacementMesh : this._renderingMesh;
    }
    /**
     * Returns the submesh material
     * @param getDefaultMaterial Defines whether or not to get the default material if nothing has been defined.
     * @returns null or the current material
     */ getMaterial(getDefaultMaterial = true) {
        const rootMaterial = this._renderingMesh.getMaterialForRenderPass(this._engine.currentRenderPassId) ?? this._renderingMesh.material;
        if (!rootMaterial) return getDefaultMaterial ? this._mesh.getScene().defaultMaterial : null;
        else if (this._isMultiMaterial(rootMaterial)) {
            const effectiveMaterial = rootMaterial.getSubMaterial(this.materialIndex);
            if (this._currentMaterial !== effectiveMaterial) {
                this._currentMaterial = effectiveMaterial;
                this.resetDrawCache();
            }
            return effectiveMaterial;
        }
        return rootMaterial;
    }
    _isMultiMaterial(material) {
        return material.getSubMaterial !== undefined;
    }
    // Methods
    /**
     * Sets a new updated BoundingInfo object to the submesh
     * @param data defines an optional position array to use to determine the bounding info
     * @returns the SubMesh
     */ refreshBoundingInfo(data = null) {
        this._lastColliderWorldVertices = null;
        if (this.IsGlobal || !this._renderingMesh || !this._renderingMesh.geometry) return this;
        if (!data) data = this._renderingMesh.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        if (!data) {
            this._boundingInfo = this._mesh.getBoundingInfo();
            return this;
        }
        const indices = this._renderingMesh.getIndices();
        let extend;
        //is this the only submesh?
        if (this.indexStart === 0 && this.indexCount === indices.length) {
            const boundingInfo = this._renderingMesh.getBoundingInfo();
            //the rendering mesh's bounding info can be used, it is the standard submesh for all indices.
            extend = {
                minimum: boundingInfo.minimum.clone(),
                maximum: boundingInfo.maximum.clone()
            };
        } else extend = (0, $1NJAz.extractMinAndMaxIndexed)(data, indices, this.indexStart, this.indexCount, this._renderingMesh.geometry.boundingBias);
        if (this._boundingInfo) this._boundingInfo.reConstruct(extend.minimum, extend.maximum);
        else this._boundingInfo = new (0, $ef012.BoundingInfo)(extend.minimum, extend.maximum);
        return this;
    }
    /**
     * @internal
     */ _checkCollision(collider) {
        const boundingInfo = this.getBoundingInfo();
        return boundingInfo._checkCollision(collider);
    }
    /**
     * Updates the submesh BoundingInfo
     * @param world defines the world matrix to use to update the bounding info
     * @returns the submesh
     */ updateBoundingInfo(world) {
        let boundingInfo = this.getBoundingInfo();
        if (!boundingInfo) {
            this.refreshBoundingInfo();
            boundingInfo = this.getBoundingInfo();
        }
        if (boundingInfo) boundingInfo.update(world);
        return this;
    }
    /**
     * True is the submesh bounding box intersects the frustum defined by the passed array of planes.
     * @param frustumPlanes defines the frustum planes
     * @returns true if the submesh is intersecting with the frustum
     */ isInFrustum(frustumPlanes) {
        const boundingInfo = this.getBoundingInfo();
        if (!boundingInfo) return false;
        return boundingInfo.isInFrustum(frustumPlanes, this._mesh.cullingStrategy);
    }
    /**
     * True is the submesh bounding box is completely inside the frustum defined by the passed array of planes
     * @param frustumPlanes defines the frustum planes
     * @returns true if the submesh is inside the frustum
     */ isCompletelyInFrustum(frustumPlanes) {
        const boundingInfo = this.getBoundingInfo();
        if (!boundingInfo) return false;
        return boundingInfo.isCompletelyInFrustum(frustumPlanes);
    }
    /**
     * Renders the submesh
     * @param enableAlphaMode defines if alpha needs to be used
     * @returns the submesh
     */ render(enableAlphaMode) {
        this._renderingMesh.render(this, enableAlphaMode, this._mesh._internalAbstractMeshDataInfo._actAsRegularMesh ? this._mesh : undefined);
        return this;
    }
    /**
     * @internal
     */ _getLinesIndexBuffer(indices, engine) {
        if (!this._linesIndexBuffer) {
            const linesIndices = [];
            for(let index = this.indexStart; index < this.indexStart + this.indexCount; index += 3)linesIndices.push(indices[index], indices[index + 1], indices[index + 1], indices[index + 2], indices[index + 2], indices[index]);
            this._linesIndexBuffer = engine.createIndexBuffer(linesIndices);
            this._linesIndexCount = linesIndices.length;
        }
        return this._linesIndexBuffer;
    }
    /**
     * Checks if the submesh intersects with a ray
     * @param ray defines the ray to test
     * @returns true is the passed ray intersects the submesh bounding box
     */ canIntersects(ray) {
        const boundingInfo = this.getBoundingInfo();
        if (!boundingInfo) return false;
        return ray.intersectsBox(boundingInfo.boundingBox);
    }
    /**
     * Intersects current submesh with a ray
     * @param ray defines the ray to test
     * @param positions defines mesh's positions array
     * @param indices defines mesh's indices array
     * @param fastCheck defines if the first intersection will be used (and not the closest)
     * @param trianglePredicate defines an optional predicate used to select faces when a mesh intersection is detected
     * @returns intersection info or null if no intersection
     */ intersects(ray, positions, indices, fastCheck, trianglePredicate) {
        const material = this.getMaterial();
        if (!material) return null;
        let step = 3;
        let checkStopper = false;
        switch(material.fillMode){
            case 3:
            case 5:
            case 6:
            case 8:
                return null;
            case 7:
                step = 1;
                checkStopper = true;
                break;
            default:
                break;
        }
        // LineMesh first as it's also a Mesh...
        if (material.fillMode === 4) {
            // Check if mesh is unindexed
            if (!indices.length) return this._intersectUnIndexedLines(ray, positions, indices, this._mesh.intersectionThreshold, fastCheck);
            return this._intersectLines(ray, positions, indices, this._mesh.intersectionThreshold, fastCheck);
        } else {
            // Check if mesh is unindexed
            if (!indices.length && this._mesh._unIndexed) return this._intersectUnIndexedTriangles(ray, positions, indices, fastCheck, trianglePredicate);
            return this._intersectTriangles(ray, positions, indices, step, checkStopper, fastCheck, trianglePredicate);
        }
    }
    /**
     * @internal
     */ _intersectLines(ray, positions, indices, intersectionThreshold, fastCheck) {
        let intersectInfo = null;
        // Line test
        for(let index = this.indexStart; index < this.indexStart + this.indexCount; index += 2){
            const p0 = positions[indices[index]];
            const p1 = positions[indices[index + 1]];
            const length = ray.intersectionSegment(p0, p1, intersectionThreshold);
            if (length < 0) continue;
            if (fastCheck || !intersectInfo || length < intersectInfo.distance) {
                intersectInfo = new (0, $iKm71.IntersectionInfo)(null, null, length);
                intersectInfo.faceId = index / 2;
                if (fastCheck) break;
            }
        }
        return intersectInfo;
    }
    /**
     * @internal
     */ _intersectUnIndexedLines(ray, positions, indices, intersectionThreshold, fastCheck) {
        let intersectInfo = null;
        // Line test
        for(let index = this.verticesStart; index < this.verticesStart + this.verticesCount; index += 2){
            const p0 = positions[index];
            const p1 = positions[index + 1];
            const length = ray.intersectionSegment(p0, p1, intersectionThreshold);
            if (length < 0) continue;
            if (fastCheck || !intersectInfo || length < intersectInfo.distance) {
                intersectInfo = new (0, $iKm71.IntersectionInfo)(null, null, length);
                intersectInfo.faceId = index / 2;
                if (fastCheck) break;
            }
        }
        return intersectInfo;
    }
    /**
     * @internal
     */ _intersectTriangles(ray, positions, indices, step, checkStopper, fastCheck, trianglePredicate) {
        let intersectInfo = null;
        // Triangles test
        let faceId = -1;
        for(let index = this.indexStart; index < this.indexStart + this.indexCount - (3 - step); index += step){
            faceId++;
            const indexA = indices[index];
            const indexB = indices[index + 1];
            const indexC = indices[index + 2];
            if (checkStopper && indexC === 0xffffffff) {
                index += 2;
                continue;
            }
            const p0 = positions[indexA];
            const p1 = positions[indexB];
            const p2 = positions[indexC];
            // stay defensive and don't check against undefined positions.
            if (!p0 || !p1 || !p2) continue;
            if (trianglePredicate && !trianglePredicate(p0, p1, p2, ray, indexA, indexB, indexC)) continue;
            const currentIntersectInfo = ray.intersectsTriangle(p0, p1, p2);
            if (currentIntersectInfo) {
                if (currentIntersectInfo.distance < 0) continue;
                if (fastCheck || !intersectInfo || currentIntersectInfo.distance < intersectInfo.distance) {
                    intersectInfo = currentIntersectInfo;
                    intersectInfo.faceId = faceId;
                    if (fastCheck) break;
                }
            }
        }
        return intersectInfo;
    }
    /**
     * @internal
     */ _intersectUnIndexedTriangles(ray, positions, indices, fastCheck, trianglePredicate) {
        let intersectInfo = null;
        // Triangles test
        for(let index = this.verticesStart; index < this.verticesStart + this.verticesCount; index += 3){
            const p0 = positions[index];
            const p1 = positions[index + 1];
            const p2 = positions[index + 2];
            if (trianglePredicate && !trianglePredicate(p0, p1, p2, ray, -1, -1, -1)) continue;
            const currentIntersectInfo = ray.intersectsTriangle(p0, p1, p2);
            if (currentIntersectInfo) {
                if (currentIntersectInfo.distance < 0) continue;
                if (fastCheck || !intersectInfo || currentIntersectInfo.distance < intersectInfo.distance) {
                    intersectInfo = currentIntersectInfo;
                    intersectInfo.faceId = index / 3;
                    if (fastCheck) break;
                }
            }
        }
        return intersectInfo;
    }
    /** @internal */ _rebuild() {
        if (this._linesIndexBuffer) this._linesIndexBuffer = null;
    }
    // Clone
    /**
     * Creates a new submesh from the passed mesh
     * @param newMesh defines the new hosting mesh
     * @param newRenderingMesh defines an optional rendering mesh
     * @returns the new submesh
     */ clone(newMesh, newRenderingMesh) {
        const result = new $fc3ab70ba5c9f506$export$c684db7d654df572(this.materialIndex, this.verticesStart, this.verticesCount, this.indexStart, this.indexCount, newMesh, newRenderingMesh, false);
        if (!this.IsGlobal) {
            const boundingInfo = this.getBoundingInfo();
            if (!boundingInfo) return result;
            result._boundingInfo = new (0, $ef012.BoundingInfo)(boundingInfo.minimum, boundingInfo.maximum);
        }
        return result;
    }
    // Dispose
    /**
     * Release associated resources
     */ dispose() {
        if (this._linesIndexBuffer) {
            this._mesh.getScene().getEngine()._releaseBuffer(this._linesIndexBuffer);
            this._linesIndexBuffer = null;
        }
        // Remove from mesh
        const index = this._mesh.subMeshes.indexOf(this);
        this._mesh.subMeshes.splice(index, 1);
        this.resetDrawCache();
    }
    /**
     * Gets the class name
     * @returns the string "SubMesh".
     */ getClassName() {
        return "SubMesh";
    }
    // Statics
    /**
     * Creates a new submesh from indices data
     * @param materialIndex the index of the main mesh material
     * @param startIndex the index where to start the copy in the mesh indices array
     * @param indexCount the number of indices to copy then from the startIndex
     * @param mesh the main mesh to create the submesh from
     * @param renderingMesh the optional rendering mesh
     * @param createBoundingBox defines if bounding box should be created for this submesh
     * @returns a new submesh
     */ static CreateFromIndices(materialIndex, startIndex, indexCount, mesh, renderingMesh, createBoundingBox = true) {
        let minVertexIndex = Number.MAX_VALUE;
        let maxVertexIndex = -Number.MAX_VALUE;
        const whatWillRender = renderingMesh || mesh;
        const indices = whatWillRender.getIndices();
        for(let index = startIndex; index < startIndex + indexCount; index++){
            const vertexIndex = indices[index];
            if (vertexIndex < minVertexIndex) minVertexIndex = vertexIndex;
            if (vertexIndex > maxVertexIndex) maxVertexIndex = vertexIndex;
        }
        return new $fc3ab70ba5c9f506$export$c684db7d654df572(materialIndex, minVertexIndex, maxVertexIndex - minVertexIndex + 1, startIndex, indexCount, mesh, renderingMesh, createBoundingBox);
    }
}

});
parcelRegister("iKm71", function(module, exports) {

$parcel$export(module.exports, "IntersectionInfo", () => $da5dace7af8aa5ae$export$3ec28a530ce1ca87);
/**
 * @internal
 */ class $da5dace7af8aa5ae$export$3ec28a530ce1ca87 {
    constructor(bu, bv, distance){
        this.bu = bu;
        this.bv = bv;
        this.distance = distance;
        this.faceId = 0;
        this.subMeshId = 0;
    }
}

});

parcelRegister("ef012", function(module, exports) {

$parcel$export(module.exports, "BoundingInfo", () => $a5e27a85374b8b23$export$dc03daefa4f9a8c4);

var $opFp4 = parcelRequire("opFp4");

var $ha1VO = parcelRequire("ha1VO");

var $7iRaI = parcelRequire("7iRaI");

var $aC4Bv = parcelRequire("aC4Bv");
const $a5e27a85374b8b23$var$_result0 = {
    min: 0,
    max: 0
};
const $a5e27a85374b8b23$var$_result1 = {
    min: 0,
    max: 0
};
const $a5e27a85374b8b23$var$computeBoxExtents = (axis, box, result)=>{
    const p = (0, $ha1VO.Vector3).Dot(box.centerWorld, axis);
    const r0 = Math.abs((0, $ha1VO.Vector3).Dot(box.directions[0], axis)) * box.extendSize.x;
    const r1 = Math.abs((0, $ha1VO.Vector3).Dot(box.directions[1], axis)) * box.extendSize.y;
    const r2 = Math.abs((0, $ha1VO.Vector3).Dot(box.directions[2], axis)) * box.extendSize.z;
    const r = r0 + r1 + r2;
    result.min = p - r;
    result.max = p + r;
};
const $a5e27a85374b8b23$var$axisOverlap = (axis, box0, box1)=>{
    $a5e27a85374b8b23$var$computeBoxExtents(axis, box0, $a5e27a85374b8b23$var$_result0);
    $a5e27a85374b8b23$var$computeBoxExtents(axis, box1, $a5e27a85374b8b23$var$_result1);
    return !($a5e27a85374b8b23$var$_result0.min > $a5e27a85374b8b23$var$_result1.max || $a5e27a85374b8b23$var$_result1.min > $a5e27a85374b8b23$var$_result0.max);
};
class $a5e27a85374b8b23$export$dc03daefa4f9a8c4 {
    /**
     * Constructs bounding info
     * @param minimum min vector of the bounding box/sphere
     * @param maximum max vector of the bounding box/sphere
     * @param worldMatrix defines the new world matrix
     */ constructor(minimum, maximum, worldMatrix){
        this._isLocked = false;
        this.boundingBox = new (0, $7iRaI.BoundingBox)(minimum, maximum, worldMatrix);
        this.boundingSphere = new (0, $aC4Bv.BoundingSphere)(minimum, maximum, worldMatrix);
    }
    /**
     * Recreates the entire bounding info from scratch as if we call the constructor in place
     * @param min defines the new minimum vector (in local space)
     * @param max defines the new maximum vector (in local space)
     * @param worldMatrix defines the new world matrix
     */ reConstruct(min, max, worldMatrix) {
        this.boundingBox.reConstruct(min, max, worldMatrix);
        this.boundingSphere.reConstruct(min, max, worldMatrix);
    }
    /**
     * min vector of the bounding box/sphere
     */ get minimum() {
        return this.boundingBox.minimum;
    }
    /**
     * max vector of the bounding box/sphere
     */ get maximum() {
        return this.boundingBox.maximum;
    }
    /**
     * If the info is locked and won't be updated to avoid perf overhead
     */ get isLocked() {
        return this._isLocked;
    }
    set isLocked(value) {
        this._isLocked = value;
    }
    // Methods
    /**
     * Updates the bounding sphere and box
     * @param world world matrix to be used to update
     */ update(world) {
        if (this._isLocked) return;
        this.boundingBox._update(world);
        this.boundingSphere._update(world);
    }
    /**
     * Recreate the bounding info to be centered around a specific point given a specific extend.
     * @param center New center of the bounding info
     * @param extend New extend of the bounding info
     * @returns the current bounding info
     */ centerOn(center, extend) {
        const minimum = $a5e27a85374b8b23$export$dc03daefa4f9a8c4._TmpVector3[0].copyFrom(center).subtractInPlace(extend);
        const maximum = $a5e27a85374b8b23$export$dc03daefa4f9a8c4._TmpVector3[1].copyFrom(center).addInPlace(extend);
        this.boundingBox.reConstruct(minimum, maximum, this.boundingBox.getWorldMatrix());
        this.boundingSphere.reConstruct(minimum, maximum, this.boundingBox.getWorldMatrix());
        return this;
    }
    /**
     * Grows the bounding info to include the given point.
     * @param point The point that will be included in the current bounding info (in local space)
     * @returns the current bounding info
     */ encapsulate(point) {
        const minimum = (0, $ha1VO.Vector3).Minimize(this.minimum, point);
        const maximum = (0, $ha1VO.Vector3).Maximize(this.maximum, point);
        this.reConstruct(minimum, maximum, this.boundingBox.getWorldMatrix());
        return this;
    }
    /**
     * Grows the bounding info to encapsulate the given bounding info.
     * @param toEncapsulate The bounding info that will be encapsulated in the current bounding info
     * @returns the current bounding info
     */ encapsulateBoundingInfo(toEncapsulate) {
        const invw = (0, $ha1VO.TmpVectors).Matrix[0];
        this.boundingBox.getWorldMatrix().invertToRef(invw);
        const v = (0, $ha1VO.TmpVectors).Vector3[0];
        (0, $ha1VO.Vector3).TransformCoordinatesToRef(toEncapsulate.boundingBox.minimumWorld, invw, v);
        this.encapsulate(v);
        (0, $ha1VO.Vector3).TransformCoordinatesToRef(toEncapsulate.boundingBox.maximumWorld, invw, v);
        this.encapsulate(v);
        return this;
    }
    /**
     * Scale the current bounding info by applying a scale factor
     * @param factor defines the scale factor to apply
     * @returns the current bounding info
     */ scale(factor) {
        this.boundingBox.scale(factor);
        this.boundingSphere.scale(factor);
        return this;
    }
    /**
     * Returns `true` if the bounding info is within the frustum defined by the passed array of planes.
     * @param frustumPlanes defines the frustum to test
     * @param strategy defines the strategy to use for the culling (default is BABYLON.AbstractMesh.CULLINGSTRATEGY_STANDARD)
     * The different strategies available are:
     * * BABYLON.AbstractMesh.CULLINGSTRATEGY_STANDARD most accurate but slower @see https://doc.babylonjs.com/typedoc/classes/BABYLON.AbstractMesh#CULLINGSTRATEGY_STANDARD
     * * BABYLON.AbstractMesh.CULLINGSTRATEGY_BOUNDINGSPHERE_ONLY faster but less accurate @see https://doc.babylonjs.com/typedoc/classes/BABYLON.AbstractMesh#CULLINGSTRATEGY_BOUNDINGSPHERE_ONLY
     * * BABYLON.AbstractMesh.CULLINGSTRATEGY_OPTIMISTIC_INCLUSION can be faster if always visible @see https://doc.babylonjs.com/typedoc/classes/BABYLON.AbstractMesh#CULLINGSTRATEGY_OPTIMISTIC_INCLUSION
     * * BABYLON.AbstractMesh.CULLINGSTRATEGY_OPTIMISTIC_INCLUSION_THEN_BSPHERE_ONLY can be faster if always visible @see https://doc.babylonjs.com/typedoc/classes/BABYLON.AbstractMesh#CULLINGSTRATEGY_OPTIMISTIC_INCLUSION_THEN_BSPHERE_ONLY
     * @returns true if the bounding info is in the frustum planes
     */ isInFrustum(frustumPlanes, strategy = 0) {
        const inclusionTest = strategy === 2 || strategy === 3;
        if (inclusionTest) {
            if (this.boundingSphere.isCenterInFrustum(frustumPlanes)) return true;
        }
        if (!this.boundingSphere.isInFrustum(frustumPlanes)) return false;
        const bSphereOnlyTest = strategy === 1 || strategy === 3;
        if (bSphereOnlyTest) return true;
        return this.boundingBox.isInFrustum(frustumPlanes);
    }
    /**
     * Gets the world distance between the min and max points of the bounding box
     */ get diagonalLength() {
        const boundingBox = this.boundingBox;
        const diag = boundingBox.maximumWorld.subtractToRef(boundingBox.minimumWorld, $a5e27a85374b8b23$export$dc03daefa4f9a8c4._TmpVector3[0]);
        return diag.length();
    }
    /**
     * Checks if a cullable object (mesh...) is in the camera frustum
     * Unlike isInFrustum this checks the full bounding box
     * @param frustumPlanes Camera near/planes
     * @returns true if the object is in frustum otherwise false
     */ isCompletelyInFrustum(frustumPlanes) {
        return this.boundingBox.isCompletelyInFrustum(frustumPlanes);
    }
    /**
     * @internal
     */ _checkCollision(collider) {
        return collider._canDoCollision(this.boundingSphere.centerWorld, this.boundingSphere.radiusWorld, this.boundingBox.minimumWorld, this.boundingBox.maximumWorld);
    }
    /**
     * Checks if a point is inside the bounding box and bounding sphere or the mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/interactions/mesh_intersect
     * @param point the point to check intersection with
     * @returns if the point intersects
     */ intersectsPoint(point) {
        if (!this.boundingSphere.centerWorld) return false;
        if (!this.boundingSphere.intersectsPoint(point)) return false;
        if (!this.boundingBox.intersectsPoint(point)) return false;
        return true;
    }
    /**
     * Checks if another bounding info intersects the bounding box and bounding sphere or the mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/interactions/mesh_intersect
     * @param boundingInfo the bounding info to check intersection with
     * @param precise if the intersection should be done using OBB
     * @returns if the bounding info intersects
     */ intersects(boundingInfo, precise) {
        if (!(0, $aC4Bv.BoundingSphere).Intersects(this.boundingSphere, boundingInfo.boundingSphere)) return false;
        if (!(0, $7iRaI.BoundingBox).Intersects(this.boundingBox, boundingInfo.boundingBox)) return false;
        if (!precise) return true;
        const box0 = this.boundingBox;
        const box1 = boundingInfo.boundingBox;
        if (!$a5e27a85374b8b23$var$axisOverlap(box0.directions[0], box0, box1)) return false;
        if (!$a5e27a85374b8b23$var$axisOverlap(box0.directions[1], box0, box1)) return false;
        if (!$a5e27a85374b8b23$var$axisOverlap(box0.directions[2], box0, box1)) return false;
        if (!$a5e27a85374b8b23$var$axisOverlap(box1.directions[0], box0, box1)) return false;
        if (!$a5e27a85374b8b23$var$axisOverlap(box1.directions[1], box0, box1)) return false;
        if (!$a5e27a85374b8b23$var$axisOverlap(box1.directions[2], box0, box1)) return false;
        if (!$a5e27a85374b8b23$var$axisOverlap((0, $ha1VO.Vector3).Cross(box0.directions[0], box1.directions[0]), box0, box1)) return false;
        if (!$a5e27a85374b8b23$var$axisOverlap((0, $ha1VO.Vector3).Cross(box0.directions[0], box1.directions[1]), box0, box1)) return false;
        if (!$a5e27a85374b8b23$var$axisOverlap((0, $ha1VO.Vector3).Cross(box0.directions[0], box1.directions[2]), box0, box1)) return false;
        if (!$a5e27a85374b8b23$var$axisOverlap((0, $ha1VO.Vector3).Cross(box0.directions[1], box1.directions[0]), box0, box1)) return false;
        if (!$a5e27a85374b8b23$var$axisOverlap((0, $ha1VO.Vector3).Cross(box0.directions[1], box1.directions[1]), box0, box1)) return false;
        if (!$a5e27a85374b8b23$var$axisOverlap((0, $ha1VO.Vector3).Cross(box0.directions[1], box1.directions[2]), box0, box1)) return false;
        if (!$a5e27a85374b8b23$var$axisOverlap((0, $ha1VO.Vector3).Cross(box0.directions[2], box1.directions[0]), box0, box1)) return false;
        if (!$a5e27a85374b8b23$var$axisOverlap((0, $ha1VO.Vector3).Cross(box0.directions[2], box1.directions[1]), box0, box1)) return false;
        if (!$a5e27a85374b8b23$var$axisOverlap((0, $ha1VO.Vector3).Cross(box0.directions[2], box1.directions[2]), box0, box1)) return false;
        return true;
    }
}
$a5e27a85374b8b23$export$dc03daefa4f9a8c4._TmpVector3 = (0, $opFp4.ArrayTools).BuildArray(2, (0, $ha1VO.Vector3).Zero);

});
parcelRegister("7iRaI", function(module, exports) {

$parcel$export(module.exports, "BoundingBox", () => $551375aec883d052$export$63080c4de6cfc362);

var $opFp4 = parcelRequire("opFp4");

var $ha1VO = parcelRequire("ha1VO");

var $53VPf = parcelRequire("53VPf");
class $551375aec883d052$export$63080c4de6cfc362 {
    /**
     * Creates a new bounding box
     * @param min defines the minimum vector (in local space)
     * @param max defines the maximum vector (in local space)
     * @param worldMatrix defines the new world matrix
     */ constructor(min, max, worldMatrix){
        /**
         * Gets the 8 vectors representing the bounding box in local space
         */ this.vectors = (0, $opFp4.ArrayTools).BuildArray(8, (0, $ha1VO.Vector3).Zero);
        /**
         * Gets the center of the bounding box in local space
         */ this.center = (0, $ha1VO.Vector3).Zero();
        /**
         * Gets the center of the bounding box in world space
         */ this.centerWorld = (0, $ha1VO.Vector3).Zero();
        /**
         * Gets the extend size in local space
         */ this.extendSize = (0, $ha1VO.Vector3).Zero();
        /**
         * Gets the extend size in world space
         */ this.extendSizeWorld = (0, $ha1VO.Vector3).Zero();
        /**
         * Gets the OBB (object bounding box) directions
         */ this.directions = (0, $opFp4.ArrayTools).BuildArray(3, (0, $ha1VO.Vector3).Zero);
        /**
         * Gets the 8 vectors representing the bounding box in world space
         */ this.vectorsWorld = (0, $opFp4.ArrayTools).BuildArray(8, (0, $ha1VO.Vector3).Zero);
        /**
         * Gets the minimum vector in world space
         */ this.minimumWorld = (0, $ha1VO.Vector3).Zero();
        /**
         * Gets the maximum vector in world space
         */ this.maximumWorld = (0, $ha1VO.Vector3).Zero();
        /**
         * Gets the minimum vector in local space
         */ this.minimum = (0, $ha1VO.Vector3).Zero();
        /**
         * Gets the maximum vector in local space
         */ this.maximum = (0, $ha1VO.Vector3).Zero();
        /** @internal */ this._drawWrapperFront = null;
        /** @internal */ this._drawWrapperBack = null;
        this.reConstruct(min, max, worldMatrix);
    }
    // Methods
    /**
     * Recreates the entire bounding box from scratch as if we call the constructor in place
     * @param min defines the new minimum vector (in local space)
     * @param max defines the new maximum vector (in local space)
     * @param worldMatrix defines the new world matrix
     */ reConstruct(min, max, worldMatrix) {
        const minX = min.x, minY = min.y, minZ = min.z, maxX = max.x, maxY = max.y, maxZ = max.z;
        const vectors = this.vectors;
        this.minimum.copyFromFloats(minX, minY, minZ);
        this.maximum.copyFromFloats(maxX, maxY, maxZ);
        vectors[0].copyFromFloats(minX, minY, minZ);
        vectors[1].copyFromFloats(maxX, maxY, maxZ);
        vectors[2].copyFromFloats(maxX, minY, minZ);
        vectors[3].copyFromFloats(minX, maxY, minZ);
        vectors[4].copyFromFloats(minX, minY, maxZ);
        vectors[5].copyFromFloats(maxX, maxY, minZ);
        vectors[6].copyFromFloats(minX, maxY, maxZ);
        vectors[7].copyFromFloats(maxX, minY, maxZ);
        // OBB
        max.addToRef(min, this.center).scaleInPlace(0.5);
        max.subtractToRef(min, this.extendSize).scaleInPlace(0.5);
        this._worldMatrix = worldMatrix || (0, $ha1VO.Matrix).IdentityReadOnly;
        this._update(this._worldMatrix);
    }
    /**
     * Scale the current bounding box by applying a scale factor
     * @param factor defines the scale factor to apply
     * @returns the current bounding box
     */ scale(factor) {
        const tmpVectors = $551375aec883d052$export$63080c4de6cfc362._TmpVector3;
        const diff = this.maximum.subtractToRef(this.minimum, tmpVectors[0]);
        const len = diff.length();
        diff.normalizeFromLength(len);
        const distance = len * factor;
        const newRadius = diff.scaleInPlace(distance * 0.5);
        const min = this.center.subtractToRef(newRadius, tmpVectors[1]);
        const max = this.center.addToRef(newRadius, tmpVectors[2]);
        this.reConstruct(min, max, this._worldMatrix);
        return this;
    }
    /**
     * Gets the world matrix of the bounding box
     * @returns a matrix
     */ getWorldMatrix() {
        return this._worldMatrix;
    }
    /**
     * @internal
     */ _update(world) {
        const minWorld = this.minimumWorld;
        const maxWorld = this.maximumWorld;
        const directions = this.directions;
        const vectorsWorld = this.vectorsWorld;
        const vectors = this.vectors;
        if (!world.isIdentity()) {
            minWorld.setAll(Number.MAX_VALUE);
            maxWorld.setAll(-Number.MAX_VALUE);
            for(let index = 0; index < 8; ++index){
                const v = vectorsWorld[index];
                (0, $ha1VO.Vector3).TransformCoordinatesToRef(vectors[index], world, v);
                minWorld.minimizeInPlace(v);
                maxWorld.maximizeInPlace(v);
            }
            // Extend
            maxWorld.subtractToRef(minWorld, this.extendSizeWorld).scaleInPlace(0.5);
            maxWorld.addToRef(minWorld, this.centerWorld).scaleInPlace(0.5);
        } else {
            minWorld.copyFrom(this.minimum);
            maxWorld.copyFrom(this.maximum);
            for(let index = 0; index < 8; ++index)vectorsWorld[index].copyFrom(vectors[index]);
            // Extend
            this.extendSizeWorld.copyFrom(this.extendSize);
            this.centerWorld.copyFrom(this.center);
        }
        (0, $ha1VO.Vector3).FromArrayToRef(world.m, 0, directions[0]);
        (0, $ha1VO.Vector3).FromArrayToRef(world.m, 4, directions[1]);
        (0, $ha1VO.Vector3).FromArrayToRef(world.m, 8, directions[2]);
        this._worldMatrix = world;
    }
    /**
     * Tests if the bounding box is intersecting the frustum planes
     * @param frustumPlanes defines the frustum planes to test
     * @returns true if there is an intersection
     */ isInFrustum(frustumPlanes) {
        return $551375aec883d052$export$63080c4de6cfc362.IsInFrustum(this.vectorsWorld, frustumPlanes);
    }
    /**
     * Tests if the bounding box is entirely inside the frustum planes
     * @param frustumPlanes defines the frustum planes to test
     * @returns true if there is an inclusion
     */ isCompletelyInFrustum(frustumPlanes) {
        return $551375aec883d052$export$63080c4de6cfc362.IsCompletelyInFrustum(this.vectorsWorld, frustumPlanes);
    }
    /**
     * Tests if a point is inside the bounding box
     * @param point defines the point to test
     * @returns true if the point is inside the bounding box
     */ intersectsPoint(point) {
        const min = this.minimumWorld;
        const max = this.maximumWorld;
        const minX = min.x, minY = min.y, minZ = min.z, maxX = max.x, maxY = max.y, maxZ = max.z;
        const pointX = point.x, pointY = point.y, pointZ = point.z;
        const delta = -(0, $53VPf.Epsilon);
        if (maxX - pointX < delta || delta > pointX - minX) return false;
        if (maxY - pointY < delta || delta > pointY - minY) return false;
        if (maxZ - pointZ < delta || delta > pointZ - minZ) return false;
        return true;
    }
    /**
     * Tests if the bounding box intersects with a bounding sphere
     * @param sphere defines the sphere to test
     * @returns true if there is an intersection
     */ intersectsSphere(sphere) {
        return $551375aec883d052$export$63080c4de6cfc362.IntersectsSphere(this.minimumWorld, this.maximumWorld, sphere.centerWorld, sphere.radiusWorld);
    }
    /**
     * Tests if the bounding box intersects with a box defined by a min and max vectors
     * @param min defines the min vector to use
     * @param max defines the max vector to use
     * @returns true if there is an intersection
     */ intersectsMinMax(min, max) {
        const myMin = this.minimumWorld;
        const myMax = this.maximumWorld;
        const myMinX = myMin.x, myMinY = myMin.y, myMinZ = myMin.z, myMaxX = myMax.x, myMaxY = myMax.y, myMaxZ = myMax.z;
        const minX = min.x, minY = min.y, minZ = min.z, maxX = max.x, maxY = max.y, maxZ = max.z;
        if (myMaxX < minX || myMinX > maxX) return false;
        if (myMaxY < minY || myMinY > maxY) return false;
        if (myMaxZ < minZ || myMinZ > maxZ) return false;
        return true;
    }
    /**
     * Disposes the resources of the class
     */ dispose() {
        this._drawWrapperFront?.dispose();
        this._drawWrapperBack?.dispose();
    }
    // Statics
    /**
     * Tests if two bounding boxes are intersections
     * @param box0 defines the first box to test
     * @param box1 defines the second box to test
     * @returns true if there is an intersection
     */ static Intersects(box0, box1) {
        return box0.intersectsMinMax(box1.minimumWorld, box1.maximumWorld);
    }
    /**
     * Tests if a bounding box defines by a min/max vectors intersects a sphere
     * @param minPoint defines the minimum vector of the bounding box
     * @param maxPoint defines the maximum vector of the bounding box
     * @param sphereCenter defines the sphere center
     * @param sphereRadius defines the sphere radius
     * @returns true if there is an intersection
     */ static IntersectsSphere(minPoint, maxPoint, sphereCenter, sphereRadius) {
        const vector = $551375aec883d052$export$63080c4de6cfc362._TmpVector3[0];
        (0, $ha1VO.Vector3).ClampToRef(sphereCenter, minPoint, maxPoint, vector);
        const num = (0, $ha1VO.Vector3).DistanceSquared(sphereCenter, vector);
        return num <= sphereRadius * sphereRadius;
    }
    /**
     * Tests if a bounding box defined with 8 vectors is entirely inside frustum planes
     * @param boundingVectors defines an array of 8 vectors representing a bounding box
     * @param frustumPlanes defines the frustum planes to test
     * @returns true if there is an inclusion
     */ static IsCompletelyInFrustum(boundingVectors, frustumPlanes) {
        for(let p = 0; p < 6; ++p){
            const frustumPlane = frustumPlanes[p];
            for(let i = 0; i < 8; ++i){
                if (frustumPlane.dotCoordinate(boundingVectors[i]) < 0) return false;
            }
        }
        return true;
    }
    /**
     * Tests if a bounding box defined with 8 vectors intersects frustum planes
     * @param boundingVectors defines an array of 8 vectors representing a bounding box
     * @param frustumPlanes defines the frustum planes to test
     * @returns true if there is an intersection
     */ static IsInFrustum(boundingVectors, frustumPlanes) {
        for(let p = 0; p < 6; ++p){
            let canReturnFalse = true;
            const frustumPlane = frustumPlanes[p];
            for(let i = 0; i < 8; ++i)if (frustumPlane.dotCoordinate(boundingVectors[i]) >= 0) {
                canReturnFalse = false;
                break;
            }
            if (canReturnFalse) return false;
        }
        return true;
    }
}
$551375aec883d052$export$63080c4de6cfc362._TmpVector3 = (0, $opFp4.ArrayTools).BuildArray(3, (0, $ha1VO.Vector3).Zero);

});

parcelRegister("aC4Bv", function(module, exports) {

$parcel$export(module.exports, "BoundingSphere", () => $7ba1063d4f2776f9$export$c74f7bf74a297961);

var $opFp4 = parcelRequire("opFp4");

var $ha1VO = parcelRequire("ha1VO");
class $7ba1063d4f2776f9$export$c74f7bf74a297961 {
    /**
     * Creates a new bounding sphere
     * @param min defines the minimum vector (in local space)
     * @param max defines the maximum vector (in local space)
     * @param worldMatrix defines the new world matrix
     */ constructor(min, max, worldMatrix){
        /**
         * Gets the center of the bounding sphere in local space
         */ this.center = (0, $ha1VO.Vector3).Zero();
        /**
         * Gets the center of the bounding sphere in world space
         */ this.centerWorld = (0, $ha1VO.Vector3).Zero();
        /**
         * Gets the minimum vector in local space
         */ this.minimum = (0, $ha1VO.Vector3).Zero();
        /**
         * Gets the maximum vector in local space
         */ this.maximum = (0, $ha1VO.Vector3).Zero();
        this.reConstruct(min, max, worldMatrix);
    }
    /**
     * Recreates the entire bounding sphere from scratch as if we call the constructor in place
     * @param min defines the new minimum vector (in local space)
     * @param max defines the new maximum vector (in local space)
     * @param worldMatrix defines the new world matrix
     */ reConstruct(min, max, worldMatrix) {
        this.minimum.copyFrom(min);
        this.maximum.copyFrom(max);
        const distance = (0, $ha1VO.Vector3).Distance(min, max);
        max.addToRef(min, this.center).scaleInPlace(0.5);
        this.radius = distance * 0.5;
        this._update(worldMatrix || (0, $ha1VO.Matrix).IdentityReadOnly);
    }
    /**
     * Scale the current bounding sphere by applying a scale factor
     * @param factor defines the scale factor to apply
     * @returns the current bounding box
     */ scale(factor) {
        const newRadius = this.radius * factor;
        const tmpVectors = $7ba1063d4f2776f9$export$c74f7bf74a297961._TmpVector3;
        const tempRadiusVector = tmpVectors[0].setAll(newRadius);
        const min = this.center.subtractToRef(tempRadiusVector, tmpVectors[1]);
        const max = this.center.addToRef(tempRadiusVector, tmpVectors[2]);
        this.reConstruct(min, max, this._worldMatrix);
        return this;
    }
    /**
     * Gets the world matrix of the bounding box
     * @returns a matrix
     */ getWorldMatrix() {
        return this._worldMatrix;
    }
    // Methods
    /**
     * @internal
     */ _update(worldMatrix) {
        if (!worldMatrix.isIdentity()) {
            (0, $ha1VO.Vector3).TransformCoordinatesToRef(this.center, worldMatrix, this.centerWorld);
            const tempVector = $7ba1063d4f2776f9$export$c74f7bf74a297961._TmpVector3[0];
            (0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(1.0, 1.0, 1.0, worldMatrix, tempVector);
            this.radiusWorld = Math.max(Math.abs(tempVector.x), Math.abs(tempVector.y), Math.abs(tempVector.z)) * this.radius;
        } else {
            this.centerWorld.copyFrom(this.center);
            this.radiusWorld = this.radius;
        }
    }
    /**
     * Tests if the bounding sphere is intersecting the frustum planes
     * @param frustumPlanes defines the frustum planes to test
     * @returns true if there is an intersection
     */ isInFrustum(frustumPlanes) {
        const center = this.centerWorld;
        const radius = this.radiusWorld;
        for(let i = 0; i < 6; i++){
            if (frustumPlanes[i].dotCoordinate(center) <= -radius) return false;
        }
        return true;
    }
    /**
     * Tests if the bounding sphere center is in between the frustum planes.
     * Used for optimistic fast inclusion.
     * @param frustumPlanes defines the frustum planes to test
     * @returns true if the sphere center is in between the frustum planes
     */ isCenterInFrustum(frustumPlanes) {
        const center = this.centerWorld;
        for(let i = 0; i < 6; i++){
            if (frustumPlanes[i].dotCoordinate(center) < 0) return false;
        }
        return true;
    }
    /**
     * Tests if a point is inside the bounding sphere
     * @param point defines the point to test
     * @returns true if the point is inside the bounding sphere
     */ intersectsPoint(point) {
        const squareDistance = (0, $ha1VO.Vector3).DistanceSquared(this.centerWorld, point);
        if (this.radiusWorld * this.radiusWorld < squareDistance) return false;
        return true;
    }
    // Statics
    /**
     * Checks if two sphere intersect
     * @param sphere0 sphere 0
     * @param sphere1 sphere 1
     * @returns true if the spheres intersect
     */ static Intersects(sphere0, sphere1) {
        const squareDistance = (0, $ha1VO.Vector3).DistanceSquared(sphere0.centerWorld, sphere1.centerWorld);
        const radiusSum = sphere0.radiusWorld + sphere1.radiusWorld;
        if (radiusSum * radiusSum < squareDistance) return false;
        return true;
    }
    /**
     * Creates a sphere from a center and a radius
     * @param center The center
     * @param radius radius
     * @param matrix Optional worldMatrix
     * @returns The sphere
     */ static CreateFromCenterAndRadius(center, radius, matrix) {
        this._TmpVector3[0].copyFrom(center);
        this._TmpVector3[1].copyFromFloats(0, 0, radius);
        this._TmpVector3[2].copyFrom(center);
        this._TmpVector3[0].addInPlace(this._TmpVector3[1]);
        this._TmpVector3[2].subtractInPlace(this._TmpVector3[1]);
        const sphere = new $7ba1063d4f2776f9$export$c74f7bf74a297961(this._TmpVector3[0], this._TmpVector3[2]);
        if (matrix) sphere._worldMatrix = matrix;
        else sphere._worldMatrix = (0, $ha1VO.Matrix).Identity();
        return sphere;
    }
}
$7ba1063d4f2776f9$export$c74f7bf74a297961._TmpVector3 = (0, $opFp4.ArrayTools).BuildArray(3, (0, $ha1VO.Vector3).Zero);

});


parcelRegister("1NJAz", function(module, exports) {

$parcel$export(module.exports, "extractMinAndMaxIndexed", () => $14fdbb07a947065f$export$85b47c2d039f4f24);
$parcel$export(module.exports, "extractMinAndMax", () => $14fdbb07a947065f$export$e1bada46cc64caed);

var $e0Suo = parcelRequire("e0Suo");

var $ha1VO = parcelRequire("ha1VO");

var $ir0rz = parcelRequire("ir0rz");
// This helper class is only here so we can apply the nativeOverride decorator to functions.
class $14fdbb07a947065f$var$MathHelpers {
    static extractMinAndMaxIndexed(positions, indices, indexStart, indexCount, minimum, maximum) {
        for(let index = indexStart; index < indexStart + indexCount; index++){
            const offset = indices[index] * 3;
            const x = positions[offset];
            const y = positions[offset + 1];
            const z = positions[offset + 2];
            minimum.minimizeInPlaceFromFloats(x, y, z);
            maximum.maximizeInPlaceFromFloats(x, y, z);
        }
    }
    static extractMinAndMax(positions, start, count, stride, minimum, maximum) {
        for(let index = start, offset = start * stride; index < start + count; index++, offset += stride){
            const x = positions[offset];
            const y = positions[offset + 1];
            const z = positions[offset + 2];
            minimum.minimizeInPlaceFromFloats(x, y, z);
            maximum.maximizeInPlaceFromFloats(x, y, z);
        }
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.nativeOverride).filter((...[positions, indices])=>!Array.isArray(positions) && !Array.isArray(indices))
], $14fdbb07a947065f$var$MathHelpers, "extractMinAndMaxIndexed", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.nativeOverride).filter((...[positions])=>!Array.isArray(positions))
], $14fdbb07a947065f$var$MathHelpers, "extractMinAndMax", null);
function $14fdbb07a947065f$export$85b47c2d039f4f24(positions, indices, indexStart, indexCount, bias = null) {
    const minimum = new (0, $ha1VO.Vector3)(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
    const maximum = new (0, $ha1VO.Vector3)(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
    $14fdbb07a947065f$var$MathHelpers.extractMinAndMaxIndexed(positions, indices, indexStart, indexCount, minimum, maximum);
    if (bias) {
        minimum.x -= minimum.x * bias.x + bias.y;
        minimum.y -= minimum.y * bias.x + bias.y;
        minimum.z -= minimum.z * bias.x + bias.y;
        maximum.x += maximum.x * bias.x + bias.y;
        maximum.y += maximum.y * bias.x + bias.y;
        maximum.z += maximum.z * bias.x + bias.y;
    }
    return {
        minimum: minimum,
        maximum: maximum
    };
}
function $14fdbb07a947065f$export$e1bada46cc64caed(positions, start, count, bias = null, stride) {
    const minimum = new (0, $ha1VO.Vector3)(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
    const maximum = new (0, $ha1VO.Vector3)(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
    if (!stride) stride = 3;
    $14fdbb07a947065f$var$MathHelpers.extractMinAndMax(positions, start, count, stride, minimum, maximum);
    if (bias) {
        minimum.x -= minimum.x * bias.x + bias.y;
        minimum.y -= minimum.y * bias.x + bias.y;
        minimum.z -= minimum.z * bias.x + bias.y;
        maximum.x += maximum.x * bias.x + bias.y;
        maximum.y += maximum.y * bias.x + bias.y;
        maximum.z += maximum.z * bias.x + bias.y;
    }
    return {
        minimum: minimum,
        maximum: maximum
    };
}

});



parcelRegister("FUHfe", function(module, exports) {

$parcel$export(module.exports, "Geometry", () => $07dfcf3146d3f600$export$2db6c17465f94a2);

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $5v6ry = parcelRequire("5v6ry");

var $b4i1f = parcelRequire("b4i1f");

var $lEBSs = parcelRequire("lEBSs");

var $kixW2 = parcelRequire("kixW2");

var $ef012 = parcelRequire("ef012");

var $bOhSV = parcelRequire("bOhSV");

var $7212E = parcelRequire("7212E");

var $1NJAz = parcelRequire("1NJAz");

var $ejQPp = parcelRequire("ejQPp");

var $fGXjI = parcelRequire("fGXjI");
class $07dfcf3146d3f600$export$2db6c17465f94a2 {
    /**
     *  Gets or sets the Bias Vector to apply on the bounding elements (box/sphere), the max extend is computed as v += v * bias.x + bias.y, the min is computed as v -= v * bias.x + bias.y
     */ get boundingBias() {
        return this._boundingBias;
    }
    /**
     *  Gets or sets the Bias Vector to apply on the bounding elements (box/sphere), the max extend is computed as v += v * bias.x + bias.y, the min is computed as v -= v * bias.x + bias.y
     */ set boundingBias(value) {
        if (this._boundingBias) this._boundingBias.copyFrom(value);
        else this._boundingBias = value.clone();
        this._updateBoundingInfo(true, null);
    }
    /**
     * Static function used to attach a new empty geometry to a mesh
     * @param mesh defines the mesh to attach the geometry to
     * @returns the new Geometry
     */ static CreateGeometryForMesh(mesh) {
        const geometry = new $07dfcf3146d3f600$export$2db6c17465f94a2($07dfcf3146d3f600$export$2db6c17465f94a2.RandomId(), mesh.getScene());
        geometry.applyToMesh(mesh);
        return geometry;
    }
    /** Get the list of meshes using this geometry */ get meshes() {
        return this._meshes;
    }
    /**
     * Creates a new geometry
     * @param id defines the unique ID
     * @param scene defines the hosting scene
     * @param vertexData defines the VertexData used to get geometry data
     * @param updatable defines if geometry must be updatable (false by default)
     * @param mesh defines the mesh that will be associated with the geometry
     */ constructor(id, scene, vertexData, updatable = false, mesh = null){
        /**
         * Gets the delay loading state of the geometry (none by default which means not delayed)
         */ this.delayLoadState = 0;
        this._totalVertices = 0;
        this._isDisposed = false;
        this._indexBufferIsUpdatable = false;
        this._positionsCache = [];
        /** @internal */ this._parentContainer = null;
        /**
         * If set to true (false by default), the bounding info applied to the meshes sharing this geometry will be the bounding info defined at the class level
         * and won't be computed based on the vertex positions (which is what we get when useBoundingInfoFromGeometry = false)
         */ this.useBoundingInfoFromGeometry = false;
        this._scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        if (!this._scene) return;
        this.id = id;
        this.uniqueId = this._scene.getUniqueId();
        this._engine = this._scene.getEngine();
        this._meshes = [];
        //Init vertex buffer cache
        this._vertexBuffers = {};
        this._indices = [];
        this._updatable = updatable;
        // vertexData
        if (vertexData) this.setAllVerticesData(vertexData, updatable);
        else this._totalVertices = 0;
        if (this._engine.getCaps().vertexArrayObject) this._vertexArrayObjects = {};
        // applyToMesh
        if (mesh) {
            this.applyToMesh(mesh);
            mesh.computeWorldMatrix(true);
        }
    }
    /**
     * Gets the current extend of the geometry
     */ get extend() {
        return this._extend;
    }
    /**
     * Gets the hosting scene
     * @returns the hosting Scene
     */ getScene() {
        return this._scene;
    }
    /**
     * Gets the hosting engine
     * @returns the hosting Engine
     */ getEngine() {
        return this._engine;
    }
    /**
     * Defines if the geometry is ready to use
     * @returns true if the geometry is ready to be used
     */ isReady() {
        return this.delayLoadState === 1 || this.delayLoadState === 0;
    }
    /**
     * Gets a value indicating that the geometry should not be serialized
     */ get doNotSerialize() {
        for(let index = 0; index < this._meshes.length; index++){
            if (!this._meshes[index].doNotSerialize) return false;
        }
        return true;
    }
    /** @internal */ _rebuild() {
        if (this._vertexArrayObjects) this._vertexArrayObjects = {};
        // Index buffer
        if (this._meshes.length !== 0 && this._indices) this._indexBuffer = this._engine.createIndexBuffer(this._indices, this._updatable, "Geometry_" + this.id + "_IndexBuffer");
        // Vertex buffers
        const buffers = new Set();
        for(const key in this._vertexBuffers)buffers.add(this._vertexBuffers[key].getWrapperBuffer());
        buffers.forEach((buffer)=>{
            buffer._rebuild();
        });
    }
    /**
     * Affects all geometry data in one call
     * @param vertexData defines the geometry data
     * @param updatable defines if the geometry must be flagged as updatable (false as default)
     */ setAllVerticesData(vertexData, updatable) {
        vertexData.applyToGeometry(this, updatable);
        this._notifyUpdate();
    }
    /**
     * Set specific vertex data
     * @param kind defines the data kind (Position, normal, etc...)
     * @param data defines the vertex data to use
     * @param updatable defines if the vertex must be flagged as updatable (false as default)
     * @param stride defines the stride to use (0 by default). This value is deduced from the kind value if not specified
     */ setVerticesData(kind, data, updatable = false, stride) {
        if (updatable && Array.isArray(data)) // to avoid converting to Float32Array at each draw call in engine.updateDynamicVertexBuffer, we make the conversion a single time here
        data = new Float32Array(data);
        const buffer = new (0, $b4i1f.VertexBuffer)(this._engine, data, kind, {
            updatable: updatable,
            postponeInternalCreation: this._meshes.length === 0,
            stride: stride,
            label: "Geometry_" + this.id + "_" + kind
        });
        this.setVerticesBuffer(buffer);
    }
    /**
     * Removes a specific vertex data
     * @param kind defines the data kind (Position, normal, etc...)
     */ removeVerticesData(kind) {
        if (this._vertexBuffers[kind]) {
            this._vertexBuffers[kind].dispose();
            delete this._vertexBuffers[kind];
        }
        if (this._vertexArrayObjects) this._disposeVertexArrayObjects();
    }
    /**
     * Affect a vertex buffer to the geometry. the vertexBuffer.getKind() function is used to determine where to store the data
     * @param buffer defines the vertex buffer to use
     * @param totalVertices defines the total number of vertices for position kind (could be null)
     * @param disposeExistingBuffer disposes the existing buffer, if any (default: true)
     */ setVerticesBuffer(buffer, totalVertices = null, disposeExistingBuffer = true) {
        const kind = buffer.getKind();
        if (this._vertexBuffers[kind] && disposeExistingBuffer) this._vertexBuffers[kind].dispose();
        if (buffer._buffer) buffer._buffer._increaseReferences();
        this._vertexBuffers[kind] = buffer;
        const meshes = this._meshes;
        const numOfMeshes = meshes.length;
        if (kind === (0, $b4i1f.VertexBuffer).PositionKind) {
            this._totalVertices = totalVertices ?? buffer._maxVerticesCount;
            this._updateExtend(buffer.getFloatData(this._totalVertices));
            this._resetPointsArrayCache();
            // this._extend can be empty if buffer.getFloatData(this._totalVertices) returned null
            const minimum = this._extend && this._extend.minimum || new (0, $ha1VO.Vector3)(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
            const maximum = this._extend && this._extend.maximum || new (0, $ha1VO.Vector3)(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
            for(let index = 0; index < numOfMeshes; index++){
                const mesh = meshes[index];
                mesh.buildBoundingInfo(minimum, maximum);
                mesh._createGlobalSubMesh(mesh.isUnIndexed);
                mesh.computeWorldMatrix(true);
                mesh.synchronizeInstances();
            }
        }
        this._notifyUpdate(kind);
    }
    /**
     * Update a specific vertex buffer
     * This function will directly update the underlying DataBuffer according to the passed numeric array or Float32Array
     * It will do nothing if the buffer is not updatable
     * @param kind defines the data kind (Position, normal, etc...)
     * @param data defines the data to use
     * @param offset defines the offset in the target buffer where to store the data
     * @param useBytes set to true if the offset is in bytes
     */ updateVerticesDataDirectly(kind, data, offset, useBytes = false) {
        const vertexBuffer = this.getVertexBuffer(kind);
        if (!vertexBuffer) return;
        vertexBuffer.updateDirectly(data, offset, useBytes);
        this._notifyUpdate(kind);
    }
    /**
     * Update a specific vertex buffer
     * This function will create a new buffer if the current one is not updatable
     * @param kind defines the data kind (Position, normal, etc...)
     * @param data defines the data to use
     * @param updateExtends defines if the geometry extends must be recomputed (false by default)
     */ updateVerticesData(kind, data, updateExtends = false) {
        const vertexBuffer = this.getVertexBuffer(kind);
        if (!vertexBuffer) return;
        vertexBuffer.update(data);
        if (kind === (0, $b4i1f.VertexBuffer).PositionKind) this._updateBoundingInfo(updateExtends, data);
        this._notifyUpdate(kind);
    }
    _updateBoundingInfo(updateExtends, data) {
        if (updateExtends) this._updateExtend(data);
        this._resetPointsArrayCache();
        if (updateExtends) {
            const meshes = this._meshes;
            for (const mesh of meshes){
                if (mesh.hasBoundingInfo) mesh.getBoundingInfo().reConstruct(this._extend.minimum, this._extend.maximum);
                else mesh.buildBoundingInfo(this._extend.minimum, this._extend.maximum);
                const subMeshes = mesh.subMeshes;
                for (const subMesh of subMeshes)subMesh.refreshBoundingInfo();
            }
        }
    }
    /**
     * @internal
     */ _bind(effect, indexToBind, overrideVertexBuffers, overrideVertexArrayObjects) {
        if (!effect) return;
        if (indexToBind === undefined) indexToBind = this._indexBuffer;
        const vbs = this.getVertexBuffers();
        if (!vbs) return;
        if (indexToBind != this._indexBuffer || !this._vertexArrayObjects && !overrideVertexArrayObjects) {
            this._engine.bindBuffers(vbs, indexToBind, effect, overrideVertexBuffers);
            return;
        }
        const vaos = overrideVertexArrayObjects ? overrideVertexArrayObjects : this._vertexArrayObjects;
        // Using VAO
        if (!vaos[effect.key]) vaos[effect.key] = this._engine.recordVertexArrayObject(vbs, indexToBind, effect, overrideVertexBuffers);
        this._engine.bindVertexArrayObject(vaos[effect.key], indexToBind);
    }
    /**
     * Gets total number of vertices
     * @returns the total number of vertices
     */ getTotalVertices() {
        if (!this.isReady()) return 0;
        return this._totalVertices;
    }
    /**
     * Gets a specific vertex data attached to this geometry. Float data is constructed if the vertex buffer data cannot be returned directly.
     * @param kind defines the data kind (Position, normal, etc...)
     * @param copyWhenShared defines if the returned array must be cloned upon returning it if the current geometry is shared between multiple meshes
     * @param forceCopy defines a boolean indicating that the returned array must be cloned upon returning it
     * @returns a float array containing vertex data
     */ getVerticesData(kind, copyWhenShared, forceCopy) {
        const vertexBuffer = this.getVertexBuffer(kind);
        if (!vertexBuffer) return null;
        return vertexBuffer.getFloatData(this._totalVertices, forceCopy || copyWhenShared && this._meshes.length !== 1);
    }
    /**
     * Returns a boolean defining if the vertex data for the requested `kind` is updatable
     * @param kind defines the data kind (Position, normal, etc...)
     * @returns true if the vertex buffer with the specified kind is updatable
     */ isVertexBufferUpdatable(kind) {
        const vb = this._vertexBuffers[kind];
        if (!vb) return false;
        return vb.isUpdatable();
    }
    /**
     * Gets a specific vertex buffer
     * @param kind defines the data kind (Position, normal, etc...)
     * @returns a VertexBuffer
     */ getVertexBuffer(kind) {
        if (!this.isReady()) return null;
        return this._vertexBuffers[kind];
    }
    /**
     * Returns all vertex buffers
     * @returns an object holding all vertex buffers indexed by kind
     */ getVertexBuffers() {
        if (!this.isReady()) return null;
        return this._vertexBuffers;
    }
    /**
     * Gets a boolean indicating if specific vertex buffer is present
     * @param kind defines the data kind (Position, normal, etc...)
     * @returns true if data is present
     */ isVerticesDataPresent(kind) {
        if (!this._vertexBuffers) {
            if (this._delayInfo) return this._delayInfo.indexOf(kind) !== -1;
            return false;
        }
        return this._vertexBuffers[kind] !== undefined;
    }
    /**
     * Gets a list of all attached data kinds (Position, normal, etc...)
     * @returns a list of string containing all kinds
     */ getVerticesDataKinds() {
        const result = [];
        let kind;
        if (!this._vertexBuffers && this._delayInfo) for(kind in this._delayInfo)result.push(kind);
        else for(kind in this._vertexBuffers)result.push(kind);
        return result;
    }
    /**
     * Update index buffer
     * @param indices defines the indices to store in the index buffer
     * @param offset defines the offset in the target buffer where to store the data
     * @param gpuMemoryOnly defines a boolean indicating that only the GPU memory must be updated leaving the CPU version of the indices unchanged (false by default)
     */ updateIndices(indices, offset, gpuMemoryOnly = false) {
        if (!this._indexBuffer) return;
        if (!this._indexBufferIsUpdatable) this.setIndices(indices, null, true);
        else {
            const needToUpdateSubMeshes = indices.length !== this._indices.length;
            if (!gpuMemoryOnly) this._indices = indices.slice();
            this._engine.updateDynamicIndexBuffer(this._indexBuffer, indices, offset);
            if (needToUpdateSubMeshes) for (const mesh of this._meshes)mesh._createGlobalSubMesh(true);
        }
    }
    /**
     * Sets the index buffer for this geometry.
     * @param indexBuffer Defines the index buffer to use for this geometry
     * @param totalVertices Defines the total number of vertices used by the buffer
     * @param totalIndices Defines the total number of indices in the index buffer
     */ setIndexBuffer(indexBuffer, totalVertices, totalIndices) {
        this._indices = [];
        this._indexBufferIsUpdatable = false;
        this._indexBuffer = indexBuffer;
        this._totalVertices = totalVertices;
        this._totalIndices = totalIndices;
        indexBuffer.is32Bits || (indexBuffer.is32Bits = this._totalIndices > 65535);
        for (const mesh of this._meshes){
            mesh._createGlobalSubMesh(true);
            mesh.synchronizeInstances();
        }
        this._notifyUpdate();
    }
    /**
     * Creates a new index buffer
     * @param indices defines the indices to store in the index buffer
     * @param totalVertices defines the total number of vertices (could be null)
     * @param updatable defines if the index buffer must be flagged as updatable (false by default)
     */ setIndices(indices, totalVertices = null, updatable = false) {
        if (this._indexBuffer) this._engine._releaseBuffer(this._indexBuffer);
        this._indices = indices;
        this._indexBufferIsUpdatable = updatable;
        if (this._meshes.length !== 0 && this._indices) this._indexBuffer = this._engine.createIndexBuffer(this._indices, updatable, "Geometry_" + this.id + "_IndexBuffer");
        if (totalVertices != undefined) // including null and undefined
        this._totalVertices = totalVertices;
        for (const mesh of this._meshes){
            mesh._createGlobalSubMesh(true);
            mesh.synchronizeInstances();
        }
        this._notifyUpdate();
    }
    /**
     * Return the total number of indices
     * @returns the total number of indices
     */ getTotalIndices() {
        if (!this.isReady()) return 0;
        return this._totalIndices !== undefined ? this._totalIndices : this._indices.length;
    }
    /**
     * Gets the index buffer array
     * @param copyWhenShared defines if the returned array must be cloned upon returning it if the current geometry is shared between multiple meshes
     * @param forceCopy defines a boolean indicating that the returned array must be cloned upon returning it
     * @returns the index buffer array
     */ getIndices(copyWhenShared, forceCopy) {
        if (!this.isReady()) return null;
        const orig = this._indices;
        if (!forceCopy && (!copyWhenShared || this._meshes.length === 1)) return orig;
        else return orig.slice();
    }
    /**
     * Gets the index buffer
     * @returns the index buffer
     */ getIndexBuffer() {
        if (!this.isReady()) return null;
        return this._indexBuffer;
    }
    /**
     * @internal
     */ _releaseVertexArrayObject(effect = null) {
        if (!effect || !this._vertexArrayObjects) return;
        if (this._vertexArrayObjects[effect.key]) {
            this._engine.releaseVertexArrayObject(this._vertexArrayObjects[effect.key]);
            delete this._vertexArrayObjects[effect.key];
        }
    }
    /**
     * Release the associated resources for a specific mesh
     * @param mesh defines the source mesh
     * @param shouldDispose defines if the geometry must be disposed if there is no more mesh pointing to it
     */ releaseForMesh(mesh, shouldDispose) {
        const meshes = this._meshes;
        const index = meshes.indexOf(mesh);
        if (index === -1) return;
        meshes.splice(index, 1);
        if (this._vertexArrayObjects) mesh._invalidateInstanceVertexArrayObject();
        mesh._geometry = null;
        if (meshes.length === 0 && shouldDispose) this.dispose();
    }
    /**
     * Apply current geometry to a given mesh
     * @param mesh defines the mesh to apply geometry to
     */ applyToMesh(mesh) {
        if (mesh._geometry === this) return;
        const previousGeometry = mesh._geometry;
        if (previousGeometry) previousGeometry.releaseForMesh(mesh);
        if (this._vertexArrayObjects) mesh._invalidateInstanceVertexArrayObject();
        const meshes = this._meshes;
        // must be done before setting vertexBuffers because of mesh._createGlobalSubMesh()
        mesh._geometry = this;
        mesh._internalAbstractMeshDataInfo._positions = null;
        this._scene.pushGeometry(this);
        meshes.push(mesh);
        if (this.isReady()) this._applyToMesh(mesh);
        else if (this._boundingInfo) mesh.setBoundingInfo(this._boundingInfo);
    }
    _updateExtend(data = null) {
        if (this.useBoundingInfoFromGeometry && this._boundingInfo) this._extend = {
            minimum: this._boundingInfo.minimum.clone(),
            maximum: this._boundingInfo.maximum.clone()
        };
        else {
            if (!data) {
                data = this.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
                // This can happen if the buffer comes from a Hardware Buffer where
                // The data have not been uploaded by Babylon. (ex: Compute Shaders and Storage Buffers)
                if (!data) return;
            }
            this._extend = (0, $1NJAz.extractMinAndMax)(data, 0, this._totalVertices, this.boundingBias, 3);
        }
    }
    _applyToMesh(mesh) {
        const numOfMeshes = this._meshes.length;
        // vertexBuffers
        for(const kind in this._vertexBuffers){
            if (numOfMeshes === 1) this._vertexBuffers[kind].create();
            if (kind === (0, $b4i1f.VertexBuffer).PositionKind) {
                if (!this._extend) this._updateExtend();
                mesh.buildBoundingInfo(this._extend.minimum, this._extend.maximum);
                mesh._createGlobalSubMesh(mesh.isUnIndexed);
                //bounding info was just created again, world matrix should be applied again.
                mesh._updateBoundingInfo();
            }
        }
        // indexBuffer
        if (numOfMeshes === 1 && this._indices && this._indices.length > 0) this._indexBuffer = this._engine.createIndexBuffer(this._indices, this._updatable, "Geometry_" + this.id + "_IndexBuffer");
        // morphTargets
        mesh._syncGeometryWithMorphTargetManager();
        // instances
        mesh.synchronizeInstances();
    }
    _notifyUpdate(kind) {
        if (this.onGeometryUpdated) this.onGeometryUpdated(this, kind);
        if (this._vertexArrayObjects) this._disposeVertexArrayObjects();
        for (const mesh of this._meshes)mesh._markSubMeshesAsAttributesDirty();
    }
    /**
     * Load the geometry if it was flagged as delay loaded
     * @param scene defines the hosting scene
     * @param onLoaded defines a callback called when the geometry is loaded
     */ load(scene, onLoaded) {
        if (this.delayLoadState === 2) return;
        if (this.isReady()) {
            if (onLoaded) onLoaded();
            return;
        }
        this.delayLoadState = 2;
        this._queueLoad(scene, onLoaded);
    }
    _queueLoad(scene, onLoaded) {
        if (!this.delayLoadingFile) return;
        scene.addPendingData(this);
        scene._loadFile(this.delayLoadingFile, (data)=>{
            if (!this._delayLoadingFunction) return;
            this._delayLoadingFunction(JSON.parse(data), this);
            this.delayLoadState = 1;
            this._delayInfo = [];
            scene.removePendingData(this);
            const meshes = this._meshes;
            const numOfMeshes = meshes.length;
            for(let index = 0; index < numOfMeshes; index++)this._applyToMesh(meshes[index]);
            if (onLoaded) onLoaded();
        }, undefined, true);
    }
    /**
     * Invert the geometry to move from a right handed system to a left handed one.
     */ toLeftHanded() {
        // Flip faces
        const tIndices = this.getIndices(false);
        if (tIndices != null && tIndices.length > 0) {
            for(let i = 0; i < tIndices.length; i += 3){
                const tTemp = tIndices[i + 0];
                tIndices[i + 0] = tIndices[i + 2];
                tIndices[i + 2] = tTemp;
            }
            this.setIndices(tIndices);
        }
        // Negate position.z
        const tPositions = this.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind, false);
        if (tPositions != null && tPositions.length > 0) {
            for(let i = 0; i < tPositions.length; i += 3)tPositions[i + 2] = -tPositions[i + 2];
            this.setVerticesData((0, $b4i1f.VertexBuffer).PositionKind, tPositions, false);
        }
        // Negate normal.z
        const tNormals = this.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind, false);
        if (tNormals != null && tNormals.length > 0) {
            for(let i = 0; i < tNormals.length; i += 3)tNormals[i + 2] = -tNormals[i + 2];
            this.setVerticesData((0, $b4i1f.VertexBuffer).NormalKind, tNormals, false);
        }
    }
    // Cache
    /** @internal */ _resetPointsArrayCache() {
        this._positions = null;
    }
    /** @internal */ _generatePointsArray() {
        if (this._positions) return true;
        const data = this.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        if (!data || data.length === 0) return false;
        for(let index = this._positionsCache.length * 3, arrayIdx = this._positionsCache.length; index < data.length; index += 3, ++arrayIdx)this._positionsCache[arrayIdx] = (0, $ha1VO.Vector3).FromArray(data, index);
        for(let index = 0, arrayIdx = 0; index < data.length; index += 3, ++arrayIdx)this._positionsCache[arrayIdx].set(data[0 + index], data[1 + index], data[2 + index]);
        // just in case the number of positions was reduced, splice the array
        this._positionsCache.length = data.length / 3;
        this._positions = this._positionsCache;
        return true;
    }
    /**
     * Gets a value indicating if the geometry is disposed
     * @returns true if the geometry was disposed
     */ isDisposed() {
        return this._isDisposed;
    }
    _disposeVertexArrayObjects() {
        if (this._vertexArrayObjects) {
            for(const kind in this._vertexArrayObjects)this._engine.releaseVertexArrayObject(this._vertexArrayObjects[kind]);
            this._vertexArrayObjects = {}; // Will trigger a rebuild of the VAO if supported
            const meshes = this._meshes;
            const numOfMeshes = meshes.length;
            for(let index = 0; index < numOfMeshes; index++)meshes[index]._invalidateInstanceVertexArrayObject();
        }
    }
    /**
     * Free all associated resources
     */ dispose() {
        const meshes = this._meshes;
        const numOfMeshes = meshes.length;
        let index;
        for(index = 0; index < numOfMeshes; index++)this.releaseForMesh(meshes[index]);
        this._meshes.length = 0;
        this._disposeVertexArrayObjects();
        for(const kind in this._vertexBuffers)this._vertexBuffers[kind].dispose();
        this._vertexBuffers = {};
        this._totalVertices = 0;
        if (this._indexBuffer) this._engine._releaseBuffer(this._indexBuffer);
        this._indexBuffer = null;
        this._indices = [];
        this.delayLoadState = 0;
        this.delayLoadingFile = null;
        this._delayLoadingFunction = null;
        this._delayInfo = [];
        this._boundingInfo = null;
        this._scene.removeGeometry(this);
        if (this._parentContainer) {
            const index = this._parentContainer.geometries.indexOf(this);
            if (index > -1) this._parentContainer.geometries.splice(index, 1);
            this._parentContainer = null;
        }
        this._isDisposed = true;
    }
    /**
     * Clone the current geometry into a new geometry
     * @param id defines the unique ID of the new geometry
     * @returns a new geometry object
     */ copy(id) {
        const vertexData = new (0, $5v6ry.VertexData)();
        vertexData.indices = [];
        const indices = this.getIndices();
        if (indices) for(let index = 0; index < indices.length; index++)vertexData.indices.push(indices[index]);
        let updatable = false;
        let stopChecking = false;
        let kind;
        for(kind in this._vertexBuffers){
            // using slice() to make a copy of the array and not just reference it
            const data = this.getVerticesData(kind);
            if (data) {
                if (data instanceof Float32Array) vertexData.set(new Float32Array(data), kind);
                else vertexData.set(data.slice(0), kind);
                if (!stopChecking) {
                    const vb = this.getVertexBuffer(kind);
                    if (vb) {
                        updatable = vb.isUpdatable();
                        stopChecking = !updatable;
                    }
                }
            }
        }
        const geometry = new $07dfcf3146d3f600$export$2db6c17465f94a2(id, this._scene, vertexData, updatable);
        geometry.delayLoadState = this.delayLoadState;
        geometry.delayLoadingFile = this.delayLoadingFile;
        geometry._delayLoadingFunction = this._delayLoadingFunction;
        for(kind in this._delayInfo){
            geometry._delayInfo = geometry._delayInfo || [];
            geometry._delayInfo.push(kind);
        }
        // Bounding info
        geometry._boundingInfo = new (0, $ef012.BoundingInfo)(this._extend.minimum, this._extend.maximum);
        return geometry;
    }
    /**
     * Serialize the current geometry info (and not the vertices data) into a JSON object
     * @returns a JSON representation of the current geometry data (without the vertices data)
     */ serialize() {
        const serializationObject = {};
        serializationObject.id = this.id;
        serializationObject.uniqueId = this.uniqueId;
        serializationObject.updatable = this._updatable;
        if ((0, $7212E.Tags) && (0, $7212E.Tags).HasTags(this)) serializationObject.tags = (0, $7212E.Tags).GetTags(this);
        return serializationObject;
    }
    _toNumberArray(origin) {
        if (Array.isArray(origin)) return origin;
        else return Array.prototype.slice.call(origin);
    }
    /**
     * Release any memory retained by the cached data on the Geometry.
     *
     * Call this function to reduce memory footprint of the mesh.
     * Vertex buffers will not store CPU data anymore (this will prevent picking, collisions or physics to work correctly)
     */ clearCachedData() {
        this._indices = [];
        this._resetPointsArrayCache();
        for(const vbName in this._vertexBuffers){
            if (!Object.prototype.hasOwnProperty.call(this._vertexBuffers, vbName)) continue;
            this._vertexBuffers[vbName]._buffer._data = null;
        }
    }
    /**
     * Serialize all vertices data into a JSON object
     * @returns a JSON representation of the current geometry data
     */ serializeVerticeData() {
        const serializationObject = this.serialize();
        if (this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).PositionKind)) {
            serializationObject.positions = this._toNumberArray(this.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind));
            if (this.isVertexBufferUpdatable((0, $b4i1f.VertexBuffer).PositionKind)) serializationObject.positions._updatable = true;
        }
        if (this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).NormalKind)) {
            serializationObject.normals = this._toNumberArray(this.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind));
            if (this.isVertexBufferUpdatable((0, $b4i1f.VertexBuffer).NormalKind)) serializationObject.normals._updatable = true;
        }
        if (this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).TangentKind)) {
            serializationObject.tangents = this._toNumberArray(this.getVerticesData((0, $b4i1f.VertexBuffer).TangentKind));
            if (this.isVertexBufferUpdatable((0, $b4i1f.VertexBuffer).TangentKind)) serializationObject.tangents._updatable = true;
        }
        if (this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UVKind)) {
            serializationObject.uvs = this._toNumberArray(this.getVerticesData((0, $b4i1f.VertexBuffer).UVKind));
            if (this.isVertexBufferUpdatable((0, $b4i1f.VertexBuffer).UVKind)) serializationObject.uvs._updatable = true;
        }
        if (this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UV2Kind)) {
            serializationObject.uvs2 = this._toNumberArray(this.getVerticesData((0, $b4i1f.VertexBuffer).UV2Kind));
            if (this.isVertexBufferUpdatable((0, $b4i1f.VertexBuffer).UV2Kind)) serializationObject.uvs2._updatable = true;
        }
        if (this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UV3Kind)) {
            serializationObject.uvs3 = this._toNumberArray(this.getVerticesData((0, $b4i1f.VertexBuffer).UV3Kind));
            if (this.isVertexBufferUpdatable((0, $b4i1f.VertexBuffer).UV3Kind)) serializationObject.uvs3._updatable = true;
        }
        if (this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UV4Kind)) {
            serializationObject.uvs4 = this._toNumberArray(this.getVerticesData((0, $b4i1f.VertexBuffer).UV4Kind));
            if (this.isVertexBufferUpdatable((0, $b4i1f.VertexBuffer).UV4Kind)) serializationObject.uvs4._updatable = true;
        }
        if (this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UV5Kind)) {
            serializationObject.uvs5 = this._toNumberArray(this.getVerticesData((0, $b4i1f.VertexBuffer).UV5Kind));
            if (this.isVertexBufferUpdatable((0, $b4i1f.VertexBuffer).UV5Kind)) serializationObject.uvs5._updatable = true;
        }
        if (this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UV6Kind)) {
            serializationObject.uvs6 = this._toNumberArray(this.getVerticesData((0, $b4i1f.VertexBuffer).UV6Kind));
            if (this.isVertexBufferUpdatable((0, $b4i1f.VertexBuffer).UV6Kind)) serializationObject.uvs6._updatable = true;
        }
        if (this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).ColorKind)) {
            serializationObject.colors = this._toNumberArray(this.getVerticesData((0, $b4i1f.VertexBuffer).ColorKind));
            if (this.isVertexBufferUpdatable((0, $b4i1f.VertexBuffer).ColorKind)) serializationObject.colors._updatable = true;
        }
        if (this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).MatricesIndicesKind)) {
            serializationObject.matricesIndices = this._toNumberArray(this.getVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesKind));
            serializationObject.matricesIndices._isExpanded = true;
            if (this.isVertexBufferUpdatable((0, $b4i1f.VertexBuffer).MatricesIndicesKind)) serializationObject.matricesIndices._updatable = true;
        }
        if (this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).MatricesWeightsKind)) {
            serializationObject.matricesWeights = this._toNumberArray(this.getVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsKind));
            if (this.isVertexBufferUpdatable((0, $b4i1f.VertexBuffer).MatricesWeightsKind)) serializationObject.matricesWeights._updatable = true;
        }
        serializationObject.indices = this._toNumberArray(this.getIndices());
        return serializationObject;
    }
    // Statics
    /**
     * Extracts a clone of a mesh geometry
     * @param mesh defines the source mesh
     * @param id defines the unique ID of the new geometry object
     * @returns the new geometry object
     */ static ExtractFromMesh(mesh, id) {
        const geometry = mesh._geometry;
        if (!geometry) return null;
        return geometry.copy(id);
    }
    /**
     * You should now use Tools.RandomId(), this method is still here for legacy reasons.
     * Implementation from http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#answer-2117523
     * Be aware Math.random() could cause collisions, but:
     * "All but 6 of the 128 bits of the ID are randomly generated, which means that for any two ids, there's a 1 in 2^^122 (or 5.3x10^^36) chance they'll collide"
     * @returns a string containing a new GUID
     */ static RandomId() {
        return (0, $bOhSV.Tools).RandomId();
    }
    static _GetGeometryByLoadedUniqueId(uniqueId, scene) {
        for(let index = 0; index < scene.geometries.length; index++){
            if (scene.geometries[index]._loadedUniqueId === uniqueId) return scene.geometries[index];
        }
        return null;
    }
    /**
     * @internal
     */ static _ImportGeometry(parsedGeometry, mesh) {
        const scene = mesh.getScene();
        // Geometry
        const geometryUniqueId = parsedGeometry.geometryUniqueId;
        const geometryId = parsedGeometry.geometryId;
        if (geometryUniqueId || geometryId) {
            const geometry = geometryUniqueId ? this._GetGeometryByLoadedUniqueId(geometryUniqueId, scene) : scene.getGeometryById(geometryId);
            if (geometry) geometry.applyToMesh(mesh);
        } else if (parsedGeometry instanceof ArrayBuffer) {
            const binaryInfo = mesh._binaryInfo;
            if (binaryInfo.positionsAttrDesc && binaryInfo.positionsAttrDesc.count > 0) {
                const positionsData = new Float32Array(parsedGeometry, binaryInfo.positionsAttrDesc.offset, binaryInfo.positionsAttrDesc.count);
                mesh.setVerticesData((0, $b4i1f.VertexBuffer).PositionKind, positionsData, false);
            }
            if (binaryInfo.normalsAttrDesc && binaryInfo.normalsAttrDesc.count > 0) {
                const normalsData = new Float32Array(parsedGeometry, binaryInfo.normalsAttrDesc.offset, binaryInfo.normalsAttrDesc.count);
                mesh.setVerticesData((0, $b4i1f.VertexBuffer).NormalKind, normalsData, false);
            }
            if (binaryInfo.tangetsAttrDesc && binaryInfo.tangetsAttrDesc.count > 0) {
                const tangentsData = new Float32Array(parsedGeometry, binaryInfo.tangetsAttrDesc.offset, binaryInfo.tangetsAttrDesc.count);
                mesh.setVerticesData((0, $b4i1f.VertexBuffer).TangentKind, tangentsData, false);
            }
            if (binaryInfo.uvsAttrDesc && binaryInfo.uvsAttrDesc.count > 0) {
                const uvsData = new Float32Array(parsedGeometry, binaryInfo.uvsAttrDesc.offset, binaryInfo.uvsAttrDesc.count);
                if ((0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV) for(let index = 1; index < uvsData.length; index += 2)uvsData[index] = 1 - uvsData[index];
                mesh.setVerticesData((0, $b4i1f.VertexBuffer).UVKind, uvsData, false);
            }
            if (binaryInfo.uvs2AttrDesc && binaryInfo.uvs2AttrDesc.count > 0) {
                const uvs2Data = new Float32Array(parsedGeometry, binaryInfo.uvs2AttrDesc.offset, binaryInfo.uvs2AttrDesc.count);
                if ((0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV) for(let index = 1; index < uvs2Data.length; index += 2)uvs2Data[index] = 1 - uvs2Data[index];
                mesh.setVerticesData((0, $b4i1f.VertexBuffer).UV2Kind, uvs2Data, false);
            }
            if (binaryInfo.uvs3AttrDesc && binaryInfo.uvs3AttrDesc.count > 0) {
                const uvs3Data = new Float32Array(parsedGeometry, binaryInfo.uvs3AttrDesc.offset, binaryInfo.uvs3AttrDesc.count);
                if ((0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV) for(let index = 1; index < uvs3Data.length; index += 2)uvs3Data[index] = 1 - uvs3Data[index];
                mesh.setVerticesData((0, $b4i1f.VertexBuffer).UV3Kind, uvs3Data, false);
            }
            if (binaryInfo.uvs4AttrDesc && binaryInfo.uvs4AttrDesc.count > 0) {
                const uvs4Data = new Float32Array(parsedGeometry, binaryInfo.uvs4AttrDesc.offset, binaryInfo.uvs4AttrDesc.count);
                if ((0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV) for(let index = 1; index < uvs4Data.length; index += 2)uvs4Data[index] = 1 - uvs4Data[index];
                mesh.setVerticesData((0, $b4i1f.VertexBuffer).UV4Kind, uvs4Data, false);
            }
            if (binaryInfo.uvs5AttrDesc && binaryInfo.uvs5AttrDesc.count > 0) {
                const uvs5Data = new Float32Array(parsedGeometry, binaryInfo.uvs5AttrDesc.offset, binaryInfo.uvs5AttrDesc.count);
                if ((0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV) for(let index = 1; index < uvs5Data.length; index += 2)uvs5Data[index] = 1 - uvs5Data[index];
                mesh.setVerticesData((0, $b4i1f.VertexBuffer).UV5Kind, uvs5Data, false);
            }
            if (binaryInfo.uvs6AttrDesc && binaryInfo.uvs6AttrDesc.count > 0) {
                const uvs6Data = new Float32Array(parsedGeometry, binaryInfo.uvs6AttrDesc.offset, binaryInfo.uvs6AttrDesc.count);
                if ((0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV) for(let index = 1; index < uvs6Data.length; index += 2)uvs6Data[index] = 1 - uvs6Data[index];
                mesh.setVerticesData((0, $b4i1f.VertexBuffer).UV6Kind, uvs6Data, false);
            }
            if (binaryInfo.colorsAttrDesc && binaryInfo.colorsAttrDesc.count > 0) {
                const colorsData = new Float32Array(parsedGeometry, binaryInfo.colorsAttrDesc.offset, binaryInfo.colorsAttrDesc.count);
                mesh.setVerticesData((0, $b4i1f.VertexBuffer).ColorKind, colorsData, false, binaryInfo.colorsAttrDesc.stride);
            }
            if (binaryInfo.matricesIndicesAttrDesc && binaryInfo.matricesIndicesAttrDesc.count > 0) {
                const matricesIndicesData = new Int32Array(parsedGeometry, binaryInfo.matricesIndicesAttrDesc.offset, binaryInfo.matricesIndicesAttrDesc.count);
                const floatIndices = [];
                for(let i = 0; i < matricesIndicesData.length; i++){
                    const index = matricesIndicesData[i];
                    floatIndices.push(index & 0x000000ff);
                    floatIndices.push((index & 0x0000ff00) >> 8);
                    floatIndices.push((index & 0x00ff0000) >> 16);
                    floatIndices.push(index >> 24 & 0xff); // & 0xFF to convert to v + 256 if v < 0
                }
                mesh.setVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesKind, floatIndices, false);
            }
            if (binaryInfo.matricesIndicesExtraAttrDesc && binaryInfo.matricesIndicesExtraAttrDesc.count > 0) {
                const matricesIndicesData = new Int32Array(parsedGeometry, binaryInfo.matricesIndicesExtraAttrDesc.offset, binaryInfo.matricesIndicesExtraAttrDesc.count);
                const floatIndices = [];
                for(let i = 0; i < matricesIndicesData.length; i++){
                    const index = matricesIndicesData[i];
                    floatIndices.push(index & 0x000000ff);
                    floatIndices.push((index & 0x0000ff00) >> 8);
                    floatIndices.push((index & 0x00ff0000) >> 16);
                    floatIndices.push(index >> 24 & 0xff); // & 0xFF to convert to v + 256 if v < 0
                }
                mesh.setVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind, floatIndices, false);
            }
            if (binaryInfo.matricesWeightsAttrDesc && binaryInfo.matricesWeightsAttrDesc.count > 0) {
                const matricesWeightsData = new Float32Array(parsedGeometry, binaryInfo.matricesWeightsAttrDesc.offset, binaryInfo.matricesWeightsAttrDesc.count);
                mesh.setVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsKind, matricesWeightsData, false);
            }
            if (binaryInfo.indicesAttrDesc && binaryInfo.indicesAttrDesc.count > 0) {
                const indicesData = new Int32Array(parsedGeometry, binaryInfo.indicesAttrDesc.offset, binaryInfo.indicesAttrDesc.count);
                mesh.setIndices(indicesData, null);
            }
            if (binaryInfo.subMeshesAttrDesc && binaryInfo.subMeshesAttrDesc.count > 0) {
                const subMeshesData = new Int32Array(parsedGeometry, binaryInfo.subMeshesAttrDesc.offset, binaryInfo.subMeshesAttrDesc.count * 5);
                mesh.subMeshes = [];
                for(let i = 0; i < binaryInfo.subMeshesAttrDesc.count; i++){
                    const materialIndex = subMeshesData[i * 5 + 0];
                    const verticesStart = subMeshesData[i * 5 + 1];
                    const verticesCount = subMeshesData[i * 5 + 2];
                    const indexStart = subMeshesData[i * 5 + 3];
                    const indexCount = subMeshesData[i * 5 + 4];
                    (0, $lEBSs.SubMesh).AddToMesh(materialIndex, verticesStart, verticesCount, indexStart, indexCount, mesh);
                }
            }
        } else if (parsedGeometry.positions && parsedGeometry.normals && parsedGeometry.indices) {
            mesh.setVerticesData((0, $b4i1f.VertexBuffer).PositionKind, parsedGeometry.positions, parsedGeometry.positions._updatable);
            mesh.setVerticesData((0, $b4i1f.VertexBuffer).NormalKind, parsedGeometry.normals, parsedGeometry.normals._updatable);
            if (parsedGeometry.tangents) mesh.setVerticesData((0, $b4i1f.VertexBuffer).TangentKind, parsedGeometry.tangents, parsedGeometry.tangents._updatable);
            if (parsedGeometry.uvs) mesh.setVerticesData((0, $b4i1f.VertexBuffer).UVKind, parsedGeometry.uvs, parsedGeometry.uvs._updatable);
            if (parsedGeometry.uvs2) mesh.setVerticesData((0, $b4i1f.VertexBuffer).UV2Kind, parsedGeometry.uvs2, parsedGeometry.uvs2._updatable);
            if (parsedGeometry.uvs3) mesh.setVerticesData((0, $b4i1f.VertexBuffer).UV3Kind, parsedGeometry.uvs3, parsedGeometry.uvs3._updatable);
            if (parsedGeometry.uvs4) mesh.setVerticesData((0, $b4i1f.VertexBuffer).UV4Kind, parsedGeometry.uvs4, parsedGeometry.uvs4._updatable);
            if (parsedGeometry.uvs5) mesh.setVerticesData((0, $b4i1f.VertexBuffer).UV5Kind, parsedGeometry.uvs5, parsedGeometry.uvs5._updatable);
            if (parsedGeometry.uvs6) mesh.setVerticesData((0, $b4i1f.VertexBuffer).UV6Kind, parsedGeometry.uvs6, parsedGeometry.uvs6._updatable);
            if (parsedGeometry.colors) mesh.setVerticesData((0, $b4i1f.VertexBuffer).ColorKind, (0, $7etnY.Color4).CheckColors4(parsedGeometry.colors, parsedGeometry.positions.length / 3), parsedGeometry.colors._updatable);
            if (parsedGeometry.matricesIndices) {
                if (!parsedGeometry.matricesIndices._isExpanded) {
                    const floatIndices = [];
                    for(let i = 0; i < parsedGeometry.matricesIndices.length; i++){
                        const matricesIndex = parsedGeometry.matricesIndices[i];
                        floatIndices.push(matricesIndex & 0x000000ff);
                        floatIndices.push((matricesIndex & 0x0000ff00) >> 8);
                        floatIndices.push((matricesIndex & 0x00ff0000) >> 16);
                        floatIndices.push(matricesIndex >> 24 & 0xff); // & 0xFF to convert to v + 256 if v < 0
                    }
                    mesh.setVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesKind, floatIndices, parsedGeometry.matricesIndices._updatable);
                } else {
                    delete parsedGeometry.matricesIndices._isExpanded;
                    mesh.setVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesKind, parsedGeometry.matricesIndices, parsedGeometry.matricesIndices._updatable);
                }
            }
            if (parsedGeometry.matricesIndicesExtra) {
                if (!parsedGeometry.matricesIndicesExtra._isExpanded) {
                    const floatIndices = [];
                    for(let i = 0; i < parsedGeometry.matricesIndicesExtra.length; i++){
                        const matricesIndex = parsedGeometry.matricesIndicesExtra[i];
                        floatIndices.push(matricesIndex & 0x000000ff);
                        floatIndices.push((matricesIndex & 0x0000ff00) >> 8);
                        floatIndices.push((matricesIndex & 0x00ff0000) >> 16);
                        floatIndices.push(matricesIndex >> 24 & 0xff); // & 0xFF to convert to v + 256 if v < 0
                    }
                    mesh.setVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind, floatIndices, parsedGeometry.matricesIndicesExtra._updatable);
                } else {
                    delete parsedGeometry.matricesIndices._isExpanded;
                    mesh.setVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind, parsedGeometry.matricesIndicesExtra, parsedGeometry.matricesIndicesExtra._updatable);
                }
            }
            if (parsedGeometry.matricesWeights) {
                $07dfcf3146d3f600$export$2db6c17465f94a2._CleanMatricesWeights(parsedGeometry, mesh);
                mesh.setVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsKind, parsedGeometry.matricesWeights, parsedGeometry.matricesWeights._updatable);
            }
            if (parsedGeometry.matricesWeightsExtra) mesh.setVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind, parsedGeometry.matricesWeightsExtra, parsedGeometry.matricesWeights._updatable);
            mesh.setIndices(parsedGeometry.indices, null);
        }
        // SubMeshes
        if (parsedGeometry.subMeshes) {
            mesh.subMeshes = [];
            for(let subIndex = 0; subIndex < parsedGeometry.subMeshes.length; subIndex++){
                const parsedSubMesh = parsedGeometry.subMeshes[subIndex];
                (0, $lEBSs.SubMesh).AddToMesh(parsedSubMesh.materialIndex, parsedSubMesh.verticesStart, parsedSubMesh.verticesCount, parsedSubMesh.indexStart, parsedSubMesh.indexCount, mesh);
            }
        }
        // Flat shading
        if (mesh._shouldGenerateFlatShading) {
            mesh.convertToFlatShadedMesh();
            mesh._shouldGenerateFlatShading = false;
        }
        // Update
        mesh.computeWorldMatrix(true);
        scene.onMeshImportedObservable.notifyObservers(mesh);
    }
    static _CleanMatricesWeights(parsedGeometry, mesh) {
        const epsilon = 1e-3;
        if (!(0, $kixW2.SceneLoaderFlags).CleanBoneMatrixWeights) return;
        let noInfluenceBoneIndex = 0.0;
        if (parsedGeometry.skeletonId > -1) {
            const skeleton = mesh.getScene().getLastSkeletonById(parsedGeometry.skeletonId);
            if (!skeleton) return;
            noInfluenceBoneIndex = skeleton.bones.length;
        } else return;
        const matricesIndices = mesh.getVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesKind);
        const matricesIndicesExtra = mesh.getVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind);
        const matricesWeights = parsedGeometry.matricesWeights;
        const matricesWeightsExtra = parsedGeometry.matricesWeightsExtra;
        const influencers = parsedGeometry.numBoneInfluencer;
        const size = matricesWeights.length;
        for(let i = 0; i < size; i += 4){
            let weight = 0.0;
            let firstZeroWeight = -1;
            for(let j = 0; j < 4; j++){
                const w = matricesWeights[i + j];
                weight += w;
                if (w < epsilon && firstZeroWeight < 0) firstZeroWeight = j;
            }
            if (matricesWeightsExtra) for(let j = 0; j < 4; j++){
                const w = matricesWeightsExtra[i + j];
                weight += w;
                if (w < epsilon && firstZeroWeight < 0) firstZeroWeight = j + 4;
            }
            if (firstZeroWeight < 0 || firstZeroWeight > influencers - 1) firstZeroWeight = influencers - 1;
            if (weight > epsilon) {
                const mweight = 1.0 / weight;
                for(let j = 0; j < 4; j++)matricesWeights[i + j] *= mweight;
                if (matricesWeightsExtra) for(let j = 0; j < 4; j++)matricesWeightsExtra[i + j] *= mweight;
            } else if (firstZeroWeight >= 4) {
                matricesWeightsExtra[i + firstZeroWeight - 4] = 1.0 - weight;
                matricesIndicesExtra[i + firstZeroWeight - 4] = noInfluenceBoneIndex;
            } else {
                matricesWeights[i + firstZeroWeight] = 1.0 - weight;
                matricesIndices[i + firstZeroWeight] = noInfluenceBoneIndex;
            }
        }
        mesh.setVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesKind, matricesIndices);
        if (parsedGeometry.matricesWeightsExtra) mesh.setVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind, matricesIndicesExtra);
    }
    /**
     * Create a new geometry from persisted data (Using .babylon file format)
     * @param parsedVertexData defines the persisted data
     * @param scene defines the hosting scene
     * @param rootUrl defines the root url to use to load assets (like delayed data)
     * @returns the new geometry object
     */ static Parse(parsedVertexData, scene, rootUrl) {
        const geometry = new $07dfcf3146d3f600$export$2db6c17465f94a2(parsedVertexData.id, scene, undefined, parsedVertexData.updatable);
        geometry._loadedUniqueId = parsedVertexData.uniqueId;
        if (0, $7212E.Tags) (0, $7212E.Tags).AddTagsTo(geometry, parsedVertexData.tags);
        if (parsedVertexData.delayLoadingFile) {
            geometry.delayLoadState = 4;
            geometry.delayLoadingFile = rootUrl + parsedVertexData.delayLoadingFile;
            geometry._boundingInfo = new (0, $ef012.BoundingInfo)((0, $ha1VO.Vector3).FromArray(parsedVertexData.boundingBoxMinimum), (0, $ha1VO.Vector3).FromArray(parsedVertexData.boundingBoxMaximum));
            geometry._delayInfo = [];
            if (parsedVertexData.hasUVs) geometry._delayInfo.push((0, $b4i1f.VertexBuffer).UVKind);
            if (parsedVertexData.hasUVs2) geometry._delayInfo.push((0, $b4i1f.VertexBuffer).UV2Kind);
            if (parsedVertexData.hasUVs3) geometry._delayInfo.push((0, $b4i1f.VertexBuffer).UV3Kind);
            if (parsedVertexData.hasUVs4) geometry._delayInfo.push((0, $b4i1f.VertexBuffer).UV4Kind);
            if (parsedVertexData.hasUVs5) geometry._delayInfo.push((0, $b4i1f.VertexBuffer).UV5Kind);
            if (parsedVertexData.hasUVs6) geometry._delayInfo.push((0, $b4i1f.VertexBuffer).UV6Kind);
            if (parsedVertexData.hasColors) geometry._delayInfo.push((0, $b4i1f.VertexBuffer).ColorKind);
            if (parsedVertexData.hasMatricesIndices) geometry._delayInfo.push((0, $b4i1f.VertexBuffer).MatricesIndicesKind);
            if (parsedVertexData.hasMatricesWeights) geometry._delayInfo.push((0, $b4i1f.VertexBuffer).MatricesWeightsKind);
            geometry._delayLoadingFunction = (0, $5v6ry.VertexData).ImportVertexData;
        } else (0, $5v6ry.VertexData).ImportVertexData(parsedVertexData, geometry);
        scene.pushGeometry(geometry, true);
        return geometry;
    }
}

});
parcelRegister("kixW2", function(module, exports) {

$parcel$export(module.exports, "SceneLoaderFlags", () => $ec6fcfe568825603$export$6ec0b2ecad265743);
/**
 * Class used to represent data loading progression
 */ class $ec6fcfe568825603$export$6ec0b2ecad265743 {
    /**
     * Gets or sets a boolean indicating if entire scene must be loaded even if scene contains incremental data
     */ static get ForceFullSceneLoadingForIncremental() {
        return $ec6fcfe568825603$export$6ec0b2ecad265743._ForceFullSceneLoadingForIncremental;
    }
    static set ForceFullSceneLoadingForIncremental(value) {
        $ec6fcfe568825603$export$6ec0b2ecad265743._ForceFullSceneLoadingForIncremental = value;
    }
    /**
     * Gets or sets a boolean indicating if loading screen must be displayed while loading a scene
     */ static get ShowLoadingScreen() {
        return $ec6fcfe568825603$export$6ec0b2ecad265743._ShowLoadingScreen;
    }
    static set ShowLoadingScreen(value) {
        $ec6fcfe568825603$export$6ec0b2ecad265743._ShowLoadingScreen = value;
    }
    /**
     * Defines the current logging level (while loading the scene)
     * @ignorenaming
     */ // eslint-disable-next-line @typescript-eslint/naming-convention
    static get loggingLevel() {
        return $ec6fcfe568825603$export$6ec0b2ecad265743._LoggingLevel;
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    static set loggingLevel(value) {
        $ec6fcfe568825603$export$6ec0b2ecad265743._LoggingLevel = value;
    }
    /**
     * Gets or set a boolean indicating if matrix weights must be cleaned upon loading
     */ static get CleanBoneMatrixWeights() {
        return $ec6fcfe568825603$export$6ec0b2ecad265743._CleanBoneMatrixWeights;
    }
    static set CleanBoneMatrixWeights(value) {
        $ec6fcfe568825603$export$6ec0b2ecad265743._CleanBoneMatrixWeights = value;
    }
}
// Flags
$ec6fcfe568825603$export$6ec0b2ecad265743._ForceFullSceneLoadingForIncremental = false;
$ec6fcfe568825603$export$6ec0b2ecad265743._ShowLoadingScreen = true;
$ec6fcfe568825603$export$6ec0b2ecad265743._CleanBoneMatrixWeights = false;
$ec6fcfe568825603$export$6ec0b2ecad265743._LoggingLevel = 0;

});

parcelRegister("fGXjI", function(module, exports) {

$parcel$export(module.exports, "CompatibilityOptions", () => $b6c8ca61d91f5b1f$export$2a04715a0c531dd0);
/**
 * Options used to control default behaviors regarding compatibility support
 */ class $b6c8ca61d91f5b1f$export$2a04715a0c531dd0 {
}
/**
 * Defines if the system should use OpenGL convention for UVs when creating geometry or loading .babylon files (false by default)
 */ $b6c8ca61d91f5b1f$export$2a04715a0c531dd0.UseOpenGLOrientationForUV = false;

});


parcelRegister("0cHNL", function(module, exports) {

$parcel$export(module.exports, "AbstractMesh", () => $0009db3ebb3b86d3$export$8f1d8af674c785a5);

var $diGQf = parcelRequire("diGQf");

var $gmbCk = parcelRequire("gmbCk");

var $ha1VO = parcelRequire("ha1VO");

var $5YkyR = parcelRequire("5YkyR");

var $b4i1f = parcelRequire("b4i1f");

var $5v6ry = parcelRequire("5v6ry");

var $klshO = parcelRequire("klshO");

var $gzCma = parcelRequire("gzCma");

var $ef012 = parcelRequire("ef012");

var $ghoTi = parcelRequire("ghoTi");

var $dng66 = parcelRequire("dng66");

var $dUFYy = parcelRequire("dUFYy");

var $1NJAz = parcelRequire("1NJAz");

var $7etnY = parcelRequire("7etnY");

var $53VPf = parcelRequire("53VPf");

var $dbxbu = parcelRequire("dbxbu");

var $8DoUR = parcelRequire("8DoUR");
/** @internal */ // eslint-disable-next-line @typescript-eslint/naming-convention
class $0009db3ebb3b86d3$var$_FacetDataStorage {
    constructor(){
        this.facetNb = 0; // facet number
        this.partitioningSubdivisions = 10; // number of subdivisions per axis in the partitioning space
        this.partitioningBBoxRatio = 1.01; // the partitioning array space is by default 1% bigger than the bounding box
        this.facetDataEnabled = false; // is the facet data feature enabled on this mesh ?
        this.facetParameters = {}; // keep a reference to the object parameters to avoid memory re-allocation
        this.bbSize = (0, $ha1VO.Vector3).Zero(); // bbox size approximated for facet data
        this.subDiv = {
            // actual number of subdivisions per axis for ComputeNormals()
            max: 1,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            X: 1,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            Y: 1,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            Z: 1
        };
        this.facetDepthSort = false; // is the facet depth sort to be computed
        this.facetDepthSortEnabled = false; // is the facet depth sort initialized
    }
}
/**
 * @internal
 **/ // eslint-disable-next-line @typescript-eslint/naming-convention
class $0009db3ebb3b86d3$var$_InternalAbstractMeshDataInfo {
    constructor(){
        this._hasVertexAlpha = false;
        this._useVertexColors = true;
        this._numBoneInfluencers = 4;
        this._applyFog = true;
        this._receiveShadows = false;
        this._facetData = new $0009db3ebb3b86d3$var$_FacetDataStorage();
        this._visibility = 1.0;
        this._skeleton = null;
        this._layerMask = 0x0fffffff;
        this._computeBonesUsingShaders = true;
        this._isActive = false;
        this._onlyForInstances = false;
        this._isActiveIntermediate = false;
        this._onlyForInstancesIntermediate = false;
        this._actAsRegularMesh = false;
        this._currentLOD = null;
        this._currentLODIsUpToDate = false;
        this._collisionRetryCount = 3;
        this._morphTargetManager = null;
        this._renderingGroupId = 0;
        this._bakedVertexAnimationManager = null;
        this._material = null;
        this._positions = null;
        this._pointerOverDisableMeshTesting = false;
        // Collisions
        this._meshCollisionData = new (0, $dng66._MeshCollisionData)();
        this._enableDistantPicking = false;
        /** @internal
         * Bounding info that is unnafected by the addition of thin instances
         */ this._rawBoundingInfo = null;
    }
}
class $0009db3ebb3b86d3$export$8f1d8af674c785a5 extends (0, $klshO.TransformNode) {
    /**
     * No billboard
     */ static get BILLBOARDMODE_NONE() {
        return (0, $klshO.TransformNode).BILLBOARDMODE_NONE;
    }
    /** Billboard on X axis */ static get BILLBOARDMODE_X() {
        return (0, $klshO.TransformNode).BILLBOARDMODE_X;
    }
    /** Billboard on Y axis */ static get BILLBOARDMODE_Y() {
        return (0, $klshO.TransformNode).BILLBOARDMODE_Y;
    }
    /** Billboard on Z axis */ static get BILLBOARDMODE_Z() {
        return (0, $klshO.TransformNode).BILLBOARDMODE_Z;
    }
    /** Billboard on all axes */ static get BILLBOARDMODE_ALL() {
        return (0, $klshO.TransformNode).BILLBOARDMODE_ALL;
    }
    /** Billboard on using position instead of orientation */ static get BILLBOARDMODE_USE_POSITION() {
        return (0, $klshO.TransformNode).BILLBOARDMODE_USE_POSITION;
    }
    /**
     * Gets the number of facets in the mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData#what-is-a-mesh-facet
     */ get facetNb() {
        return this._internalAbstractMeshDataInfo._facetData.facetNb;
    }
    /**
     * Gets or set the number (integer) of subdivisions per axis in the partitioning space
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData#tweaking-the-partitioning
     */ get partitioningSubdivisions() {
        return this._internalAbstractMeshDataInfo._facetData.partitioningSubdivisions;
    }
    set partitioningSubdivisions(nb) {
        this._internalAbstractMeshDataInfo._facetData.partitioningSubdivisions = nb;
    }
    /**
     * The ratio (float) to apply to the bounding box size to set to the partitioning space.
     * Ex : 1.01 (default) the partitioning space is 1% bigger than the bounding box
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData#tweaking-the-partitioning
     */ get partitioningBBoxRatio() {
        return this._internalAbstractMeshDataInfo._facetData.partitioningBBoxRatio;
    }
    set partitioningBBoxRatio(ratio) {
        this._internalAbstractMeshDataInfo._facetData.partitioningBBoxRatio = ratio;
    }
    /**
     * Gets or sets a boolean indicating that the facets must be depth sorted on next call to `updateFacetData()`.
     * Works only for updatable meshes.
     * Doesn't work with multi-materials
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData#facet-depth-sort
     */ get mustDepthSortFacets() {
        return this._internalAbstractMeshDataInfo._facetData.facetDepthSort;
    }
    set mustDepthSortFacets(sort) {
        this._internalAbstractMeshDataInfo._facetData.facetDepthSort = sort;
    }
    /**
     * The location (Vector3) where the facet depth sort must be computed from.
     * By default, the active camera position.
     * Used only when facet depth sort is enabled
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData#facet-depth-sort
     */ get facetDepthSortFrom() {
        return this._internalAbstractMeshDataInfo._facetData.facetDepthSortFrom;
    }
    set facetDepthSortFrom(location) {
        this._internalAbstractMeshDataInfo._facetData.facetDepthSortFrom = location;
    }
    /** number of collision detection tries. Change this value if not all collisions are detected and handled properly */ get collisionRetryCount() {
        return this._internalAbstractMeshDataInfo._collisionRetryCount;
    }
    set collisionRetryCount(retryCount) {
        this._internalAbstractMeshDataInfo._collisionRetryCount = retryCount;
    }
    /**
     * gets a boolean indicating if facetData is enabled
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData#what-is-a-mesh-facet
     */ get isFacetDataEnabled() {
        return this._internalAbstractMeshDataInfo._facetData.facetDataEnabled;
    }
    /**
     * Gets or sets the morph target manager
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/morphTargets
     */ get morphTargetManager() {
        return this._internalAbstractMeshDataInfo._morphTargetManager;
    }
    set morphTargetManager(value) {
        if (this._internalAbstractMeshDataInfo._morphTargetManager === value) return;
        this._internalAbstractMeshDataInfo._morphTargetManager = value;
        this._syncGeometryWithMorphTargetManager();
    }
    /**
     * Gets or sets the baked vertex animation manager
     * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/baked_texture_animations
     */ get bakedVertexAnimationManager() {
        return this._internalAbstractMeshDataInfo._bakedVertexAnimationManager;
    }
    set bakedVertexAnimationManager(value) {
        if (this._internalAbstractMeshDataInfo._bakedVertexAnimationManager === value) return;
        this._internalAbstractMeshDataInfo._bakedVertexAnimationManager = value;
        this._markSubMeshesAsAttributesDirty();
    }
    /** @internal */ _syncGeometryWithMorphTargetManager() {}
    /**
     * @internal
     */ _updateNonUniformScalingState(value) {
        if (!super._updateNonUniformScalingState(value)) return false;
        this._markSubMeshesAsMiscDirty();
        return true;
    }
    /** @internal */ get rawBoundingInfo() {
        return this._internalAbstractMeshDataInfo._rawBoundingInfo;
    }
    set rawBoundingInfo(boundingInfo) {
        this._internalAbstractMeshDataInfo._rawBoundingInfo = boundingInfo;
    }
    /** Set a function to call when this mesh collides with another one */ set onCollide(callback) {
        if (this._internalAbstractMeshDataInfo._meshCollisionData._onCollideObserver) this.onCollideObservable.remove(this._internalAbstractMeshDataInfo._meshCollisionData._onCollideObserver);
        this._internalAbstractMeshDataInfo._meshCollisionData._onCollideObserver = this.onCollideObservable.add(callback);
    }
    /** Set a function to call when the collision's position changes */ set onCollisionPositionChange(callback) {
        if (this._internalAbstractMeshDataInfo._meshCollisionData._onCollisionPositionChangeObserver) this.onCollisionPositionChangeObservable.remove(this._internalAbstractMeshDataInfo._meshCollisionData._onCollisionPositionChangeObserver);
        this._internalAbstractMeshDataInfo._meshCollisionData._onCollisionPositionChangeObserver = this.onCollisionPositionChangeObservable.add(callback);
    }
    /**
     * Gets or sets mesh visibility between 0 and 1 (default is 1)
     */ get visibility() {
        return this._internalAbstractMeshDataInfo._visibility;
    }
    /**
     * Gets or sets mesh visibility between 0 and 1 (default is 1)
     */ set visibility(value) {
        if (this._internalAbstractMeshDataInfo._visibility === value) return;
        const oldValue = this._internalAbstractMeshDataInfo._visibility;
        this._internalAbstractMeshDataInfo._visibility = value;
        if (oldValue === 1 && value !== 1 || oldValue !== 1 && value === 1) this._markSubMeshesAsDirty((defines)=>{
            defines.markAsMiscDirty();
            defines.markAsPrePassDirty();
        });
    }
    /**
     * Gets or sets the property which disables the test that is checking that the mesh under the pointer is the same than the previous time we tested for it (default: false).
     * Set this property to true if you want thin instances picking to be reported accurately when moving over the mesh.
     * Note that setting this property to true will incur some performance penalties when dealing with pointer events for this mesh so use it sparingly.
     */ get pointerOverDisableMeshTesting() {
        return this._internalAbstractMeshDataInfo._pointerOverDisableMeshTesting;
    }
    set pointerOverDisableMeshTesting(disable) {
        this._internalAbstractMeshDataInfo._pointerOverDisableMeshTesting = disable;
    }
    /**
     * Specifies the rendering group id for this mesh (0 by default)
     * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/advanced/transparent_rendering#rendering-groups
     */ get renderingGroupId() {
        return this._internalAbstractMeshDataInfo._renderingGroupId;
    }
    set renderingGroupId(value) {
        this._internalAbstractMeshDataInfo._renderingGroupId = value;
    }
    /** Gets or sets current material */ get material() {
        return this._internalAbstractMeshDataInfo._material;
    }
    set material(value) {
        if (this._internalAbstractMeshDataInfo._material === value) return;
        // remove from material mesh map id needed
        if (this._internalAbstractMeshDataInfo._material && this._internalAbstractMeshDataInfo._material.meshMap) this._internalAbstractMeshDataInfo._material.meshMap[this.uniqueId] = undefined;
        this._internalAbstractMeshDataInfo._material = value;
        if (value && value.meshMap) value.meshMap[this.uniqueId] = this;
        if (this.onMaterialChangedObservable.hasObservers()) this.onMaterialChangedObservable.notifyObservers(this);
        if (!this.subMeshes) return;
        this.resetDrawCache();
        this._unBindEffect();
    }
    /**
     * Gets the material used to render the mesh in a specific render pass
     * @param renderPassId render pass id
     * @returns material used for the render pass. If no specific material is used for this render pass, undefined is returned (meaning mesh.material is used for this pass)
     */ getMaterialForRenderPass(renderPassId) {
        return this._internalAbstractMeshDataInfo._materialForRenderPass?.[renderPassId];
    }
    /**
     * Sets the material to be used to render the mesh in a specific render pass
     * @param renderPassId render pass id
     * @param material material to use for this render pass. If undefined is passed, no specific material will be used for this render pass but the regular material will be used instead (mesh.material)
     */ setMaterialForRenderPass(renderPassId, material) {
        this.resetDrawCache(renderPassId);
        if (!this._internalAbstractMeshDataInfo._materialForRenderPass) this._internalAbstractMeshDataInfo._materialForRenderPass = [];
        this._internalAbstractMeshDataInfo._materialForRenderPass[renderPassId] = material;
    }
    /**
     * Gets or sets a boolean indicating that this mesh can receive realtime shadows
     * @see https://doc.babylonjs.com/features/featuresDeepDive/lights/shadows
     */ get receiveShadows() {
        return this._internalAbstractMeshDataInfo._receiveShadows;
    }
    set receiveShadows(value) {
        if (this._internalAbstractMeshDataInfo._receiveShadows === value) return;
        this._internalAbstractMeshDataInfo._receiveShadows = value;
        this._markSubMeshesAsLightDirty();
    }
    /** Gets or sets a boolean indicating that this mesh contains vertex color data with alpha values */ get hasVertexAlpha() {
        return this._internalAbstractMeshDataInfo._hasVertexAlpha;
    }
    set hasVertexAlpha(value) {
        if (this._internalAbstractMeshDataInfo._hasVertexAlpha === value) return;
        this._internalAbstractMeshDataInfo._hasVertexAlpha = value;
        this._markSubMeshesAsAttributesDirty();
        this._markSubMeshesAsMiscDirty();
    }
    /** Gets or sets a boolean indicating that this mesh needs to use vertex color data to render (if this kind of vertex data is available in the geometry) */ get useVertexColors() {
        return this._internalAbstractMeshDataInfo._useVertexColors;
    }
    set useVertexColors(value) {
        if (this._internalAbstractMeshDataInfo._useVertexColors === value) return;
        this._internalAbstractMeshDataInfo._useVertexColors = value;
        this._markSubMeshesAsAttributesDirty();
    }
    /**
     * Gets or sets a boolean indicating that bone animations must be computed by the GPU (true by default)
     */ get computeBonesUsingShaders() {
        return this._internalAbstractMeshDataInfo._computeBonesUsingShaders;
    }
    set computeBonesUsingShaders(value) {
        if (this._internalAbstractMeshDataInfo._computeBonesUsingShaders === value) return;
        this._internalAbstractMeshDataInfo._computeBonesUsingShaders = value;
        this._markSubMeshesAsAttributesDirty();
    }
    /** Gets or sets the number of allowed bone influences per vertex (4 by default) */ get numBoneInfluencers() {
        return this._internalAbstractMeshDataInfo._numBoneInfluencers;
    }
    set numBoneInfluencers(value) {
        if (this._internalAbstractMeshDataInfo._numBoneInfluencers === value) return;
        this._internalAbstractMeshDataInfo._numBoneInfluencers = value;
        this._markSubMeshesAsAttributesDirty();
    }
    /** Gets or sets a boolean indicating that this mesh will allow fog to be rendered on it (true by default) */ get applyFog() {
        return this._internalAbstractMeshDataInfo._applyFog;
    }
    set applyFog(value) {
        if (this._internalAbstractMeshDataInfo._applyFog === value) return;
        this._internalAbstractMeshDataInfo._applyFog = value;
        this._markSubMeshesAsMiscDirty();
    }
    /** When enabled, decompose picking matrices for better precision with large values for mesh position and scling */ get enableDistantPicking() {
        return this._internalAbstractMeshDataInfo._enableDistantPicking;
    }
    set enableDistantPicking(value) {
        this._internalAbstractMeshDataInfo._enableDistantPicking = value;
    }
    /**
     * Gets or sets the current layer mask (default is 0x0FFFFFFF)
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/layerMasksAndMultiCam
     */ get layerMask() {
        return this._internalAbstractMeshDataInfo._layerMask;
    }
    set layerMask(value) {
        if (value === this._internalAbstractMeshDataInfo._layerMask) return;
        this._internalAbstractMeshDataInfo._layerMask = value;
        this._resyncLightSources();
    }
    /**
     * Gets or sets a collision mask used to mask collisions (default is -1).
     * A collision between A and B will happen if A.collisionGroup & b.collisionMask !== 0
     */ get collisionMask() {
        return this._internalAbstractMeshDataInfo._meshCollisionData._collisionMask;
    }
    set collisionMask(mask) {
        this._internalAbstractMeshDataInfo._meshCollisionData._collisionMask = !isNaN(mask) ? mask : -1;
    }
    /**
     * Gets or sets a collision response flag (default is true).
     * when collisionResponse is false, events are still triggered but colliding entity has no response
     * This helps creating trigger volume when user wants collision feedback events but not position/velocity
     * to respond to the collision.
     */ get collisionResponse() {
        return this._internalAbstractMeshDataInfo._meshCollisionData._collisionResponse;
    }
    set collisionResponse(response) {
        this._internalAbstractMeshDataInfo._meshCollisionData._collisionResponse = response;
    }
    /**
     * Gets or sets the current collision group mask (-1 by default).
     * A collision between A and B will happen if A.collisionGroup & b.collisionMask !== 0
     */ get collisionGroup() {
        return this._internalAbstractMeshDataInfo._meshCollisionData._collisionGroup;
    }
    set collisionGroup(mask) {
        this._internalAbstractMeshDataInfo._meshCollisionData._collisionGroup = !isNaN(mask) ? mask : -1;
    }
    /**
     * Gets or sets current surrounding meshes (null by default).
     *
     * By default collision detection is tested against every mesh in the scene.
     * It is possible to set surroundingMeshes to a defined list of meshes and then only these specified
     * meshes will be tested for the collision.
     *
     * Note: if set to an empty array no collision will happen when this mesh is moved.
     */ get surroundingMeshes() {
        return this._internalAbstractMeshDataInfo._meshCollisionData._surroundingMeshes;
    }
    set surroundingMeshes(meshes) {
        this._internalAbstractMeshDataInfo._meshCollisionData._surroundingMeshes = meshes;
    }
    /** Gets the list of lights affecting that mesh */ get lightSources() {
        return this._lightSources;
    }
    /** @internal */ get _positions() {
        return null;
    }
    /**
     * Gets or sets a skeleton to apply skinning transformations
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/bonesSkeletons
     */ set skeleton(value) {
        const skeleton = this._internalAbstractMeshDataInfo._skeleton;
        if (skeleton && skeleton.needInitialSkinMatrix) skeleton._unregisterMeshWithPoseMatrix(this);
        if (value && value.needInitialSkinMatrix) value._registerMeshWithPoseMatrix(this);
        this._internalAbstractMeshDataInfo._skeleton = value;
        if (!this._internalAbstractMeshDataInfo._skeleton) this._bonesTransformMatrices = null;
        this._markSubMeshesAsAttributesDirty();
    }
    get skeleton() {
        return this._internalAbstractMeshDataInfo._skeleton;
    }
    // Constructor
    /**
     * Creates a new AbstractMesh
     * @param name defines the name of the mesh
     * @param scene defines the hosting scene
     */ constructor(name, scene = null){
        super(name, scene, false);
        // Internal data
        /** @internal */ this._internalAbstractMeshDataInfo = new $0009db3ebb3b86d3$var$_InternalAbstractMeshDataInfo();
        /** @internal */ this._waitingMaterialId = null;
        /**
         * The culling strategy to use to check whether the mesh must be rendered or not.
         * This value can be changed at any time and will be used on the next render mesh selection.
         * The possible values are :
         * - AbstractMesh.CULLINGSTRATEGY_STANDARD
         * - AbstractMesh.CULLINGSTRATEGY_BOUNDINGSPHERE_ONLY
         * - AbstractMesh.CULLINGSTRATEGY_OPTIMISTIC_INCLUSION
         * - AbstractMesh.CULLINGSTRATEGY_OPTIMISTIC_INCLUSION_THEN_BSPHERE_ONLY
         * Please read each static variable documentation to get details about the culling process.
         * */ this.cullingStrategy = $0009db3ebb3b86d3$export$8f1d8af674c785a5.CULLINGSTRATEGY_BOUNDINGSPHERE_ONLY;
        // Events
        /**
         * An event triggered when this mesh collides with another one
         */ this.onCollideObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the collision's position changes
         */ this.onCollisionPositionChangeObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when material is changed
         */ this.onMaterialChangedObservable = new (0, $diGQf.Observable)();
        // Properties
        /**
         * Gets or sets the orientation for POV movement & rotation
         */ this.definedFacingForward = true;
        /** @internal */ this._occlusionQuery = null;
        /** @internal */ this._renderingGroup = null;
        /** Gets or sets the alpha index used to sort transparent meshes
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/advanced/transparent_rendering#alpha-index
         */ this.alphaIndex = Number.MAX_VALUE;
        /**
         * Gets or sets a boolean indicating if the mesh is visible (renderable). Default is true
         */ this.isVisible = true;
        /**
         * Gets or sets a boolean indicating if the mesh can be picked (by scene.pick for instance or through actions). Default is true
         */ this.isPickable = true;
        /**
         * Gets or sets a boolean indicating if the mesh can be near picked (touched by the XR controller or hands). Default is false
         */ this.isNearPickable = false;
        /**
         * Gets or sets a boolean indicating if the mesh can be grabbed. Default is false.
         * Setting this to true, while using the XR near interaction feature, will trigger a pointer event when the mesh is grabbed.
         * Grabbing means that the controller is using the squeeze or main trigger button to grab the mesh.
         * This is different from nearPickable which only triggers the event when the mesh is touched by the controller
         */ this.isNearGrabbable = false;
        /** Gets or sets a boolean indicating that bounding boxes of subMeshes must be rendered as well (false by default) */ this.showSubMeshesBoundingBox = false;
        /** Gets or sets a boolean indicating if the mesh must be considered as a ray blocker for lens flares (false by default)
         * @see https://doc.babylonjs.com/features/featuresDeepDive/environment/lenseFlare
         */ this.isBlocker = false;
        /**
         * Gets or sets a boolean indicating that pointer move events must be supported on this mesh (false by default)
         */ this.enablePointerMoveEvents = false;
        /** Defines color to use when rendering outline */ this.outlineColor = (0, $7etnY.Color3).Red();
        /** Define width to use when rendering outline */ this.outlineWidth = 0.02;
        /** Defines color to use when rendering overlay */ this.overlayColor = (0, $7etnY.Color3).Red();
        /** Defines alpha to use when rendering overlay */ this.overlayAlpha = 0.5;
        /** Gets or sets a boolean indicating that internal octree (if available) can be used to boost submeshes selection (true by default) */ this.useOctreeForRenderingSelection = true;
        /** Gets or sets a boolean indicating that internal octree (if available) can be used to boost submeshes picking (true by default) */ this.useOctreeForPicking = true;
        /** Gets or sets a boolean indicating that internal octree (if available) can be used to boost submeshes collision (true by default) */ this.useOctreeForCollisions = true;
        /**
         * True if the mesh must be rendered in any case (this will shortcut the frustum clipping phase)
         */ this.alwaysSelectAsActiveMesh = false;
        /**
         * Gets or sets a boolean indicating that the bounding info does not need to be kept in sync (for performance reason)
         */ this.doNotSyncBoundingInfo = false;
        /**
         * Gets or sets the current action manager
         * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions
         */ this.actionManager = null;
        /**
         * Gets or sets the ellipsoid used to impersonate this mesh when using collision engine (default is (0.5, 1, 0.5))
         * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_collisions
         */ this.ellipsoid = new (0, $ha1VO.Vector3)(0.5, 1, 0.5);
        /**
         * Gets or sets the ellipsoid offset used to impersonate this mesh when using collision engine (default is (0, 0, 0))
         * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_collisions
         */ this.ellipsoidOffset = new (0, $ha1VO.Vector3)(0, 0, 0);
        // Edges
        /**
         * Defines edge width used when edgesRenderer is enabled
         * @see https://www.babylonjs-playground.com/#10OJSG#13
         */ this.edgesWidth = 1;
        /**
         * Defines edge color used when edgesRenderer is enabled
         * @see https://www.babylonjs-playground.com/#10OJSG#13
         */ this.edgesColor = new (0, $7etnY.Color4)(1, 0, 0, 1);
        /** @internal */ this._edgesRenderer = null;
        /** @internal */ this._masterMesh = null;
        this._boundingInfo = null;
        this._boundingInfoIsDirty = true;
        /** @internal */ this._renderId = 0;
        /** @internal */ this._intersectionsInProgress = new Array();
        /** @internal */ this._unIndexed = false;
        /** @internal */ this._lightSources = new Array();
        // Loading properties
        /** @internal */ this._waitingData = {
            lods: null,
            actions: null,
            freezeWorldMatrix: null
        };
        /** @internal */ this._bonesTransformMatrices = null;
        /** @internal */ this._transformMatrixTexture = null;
        /**
         * An event triggered when the mesh is rebuilt.
         */ this.onRebuildObservable = new (0, $diGQf.Observable)();
        this._onCollisionPositionChange = (collisionId, newPosition, collidedMesh = null)=>{
            newPosition.subtractToRef(this._internalAbstractMeshDataInfo._meshCollisionData._oldPositionForCollisions, this._internalAbstractMeshDataInfo._meshCollisionData._diffPositionForCollisions);
            if (this._internalAbstractMeshDataInfo._meshCollisionData._diffPositionForCollisions.length() > (0, $5YkyR.Engine).CollisionsEpsilon) this.position.addInPlace(this._internalAbstractMeshDataInfo._meshCollisionData._diffPositionForCollisions);
            if (collidedMesh) this.onCollideObservable.notifyObservers(collidedMesh);
            this.onCollisionPositionChangeObservable.notifyObservers(this.position);
        };
        scene = this.getScene();
        scene.addMesh(this);
        this._resyncLightSources();
        // Mesh Uniform Buffer.
        this._uniformBuffer = new (0, $ghoTi.UniformBuffer)(this.getScene().getEngine(), undefined, undefined, name, !this.getScene().getEngine().isWebGPU);
        this._buildUniformLayout();
        switch(scene.performancePriority){
            case (0, $gmbCk.ScenePerformancePriority).Aggressive:
                this.doNotSyncBoundingInfo = true;
            // eslint-disable-next-line no-fallthrough
            case (0, $gmbCk.ScenePerformancePriority).Intermediate:
                this.alwaysSelectAsActiveMesh = true;
                this.isPickable = false;
                break;
        }
    }
    _buildUniformLayout() {
        this._uniformBuffer.addUniform("world", 16);
        this._uniformBuffer.addUniform("visibility", 1);
        this._uniformBuffer.create();
    }
    /**
     * Transfer the mesh values to its UBO.
     * @param world The world matrix associated with the mesh
     */ transferToEffect(world) {
        const ubo = this._uniformBuffer;
        ubo.updateMatrix("world", world);
        ubo.updateFloat("visibility", this._internalAbstractMeshDataInfo._visibility);
        ubo.update();
    }
    /**
     * Gets the mesh uniform buffer.
     * @returns the uniform buffer of the mesh.
     */ getMeshUniformBuffer() {
        return this._uniformBuffer;
    }
    /**
     * Returns the string "AbstractMesh"
     * @returns "AbstractMesh"
     */ getClassName() {
        return "AbstractMesh";
    }
    /**
     * Gets a string representation of the current mesh
     * @param fullDetails defines a boolean indicating if full details must be included
     * @returns a string representation of the current mesh
     */ toString(fullDetails) {
        let ret = "Name: " + this.name + ", isInstance: " + (this.getClassName() !== "InstancedMesh" ? "YES" : "NO");
        ret += ", # of submeshes: " + (this.subMeshes ? this.subMeshes.length : 0);
        const skeleton = this._internalAbstractMeshDataInfo._skeleton;
        if (skeleton) ret += ", skeleton: " + skeleton.name;
        if (fullDetails) {
            ret += ", billboard mode: " + [
                "NONE",
                "X",
                "Y",
                null,
                "Z",
                null,
                null,
                "ALL"
            ][this.billboardMode];
            ret += ", freeze wrld mat: " + (this._isWorldMatrixFrozen || this._waitingData.freezeWorldMatrix ? "YES" : "NO");
        }
        return ret;
    }
    /**
     * @internal
     */ _getEffectiveParent() {
        if (this._masterMesh && this.billboardMode !== (0, $klshO.TransformNode).BILLBOARDMODE_NONE) return this._masterMesh;
        return super._getEffectiveParent();
    }
    /**
     * @internal
     */ _getActionManagerForTrigger(trigger, initialCall = true) {
        if (this.actionManager && (initialCall || this.actionManager.isRecursive)) {
            if (trigger) {
                if (this.actionManager.hasSpecificTrigger(trigger)) return this.actionManager;
            } else return this.actionManager;
        }
        if (!this.parent) return null;
        return this.parent._getActionManagerForTrigger(trigger, false);
    }
    /**
     * @internal
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _rebuild(dispose = false) {
        this.onRebuildObservable.notifyObservers(this);
        if (this._occlusionQuery !== null) this._occlusionQuery = null;
        if (!this.subMeshes) return;
        for (const subMesh of this.subMeshes)subMesh._rebuild();
        this.resetDrawCache();
    }
    /** @internal */ _resyncLightSources() {
        this._lightSources.length = 0;
        for (const light of this.getScene().lights){
            if (!light.isEnabled()) continue;
            if (light.canAffectMesh(this)) this._lightSources.push(light);
        }
        this._markSubMeshesAsLightDirty();
    }
    /**
     * @internal
     */ _resyncLightSource(light) {
        const isIn = light.isEnabled() && light.canAffectMesh(this);
        const index = this._lightSources.indexOf(light);
        let removed = false;
        if (index === -1) {
            if (!isIn) return;
            this._lightSources.push(light);
        } else {
            if (isIn) return;
            removed = true;
            this._lightSources.splice(index, 1);
        }
        this._markSubMeshesAsLightDirty(removed);
    }
    /** @internal */ _unBindEffect() {
        for (const subMesh of this.subMeshes)subMesh.setEffect(null);
    }
    /**
     * @internal
     */ _removeLightSource(light, dispose) {
        const index = this._lightSources.indexOf(light);
        if (index === -1) return;
        this._lightSources.splice(index, 1);
        this._markSubMeshesAsLightDirty(dispose);
    }
    _markSubMeshesAsDirty(func) {
        if (!this.subMeshes) return;
        for (const subMesh of this.subMeshes)for(let i = 0; i < subMesh._drawWrappers.length; ++i){
            const drawWrapper = subMesh._drawWrappers[i];
            if (!drawWrapper || !drawWrapper.defines || !drawWrapper.defines.markAllAsDirty) continue;
            func(drawWrapper.defines);
        }
    }
    /**
     * @internal
     */ _markSubMeshesAsLightDirty(dispose = false) {
        this._markSubMeshesAsDirty((defines)=>defines.markAsLightDirty(dispose));
    }
    /** @internal */ _markSubMeshesAsAttributesDirty() {
        this._markSubMeshesAsDirty((defines)=>defines.markAsAttributesDirty());
    }
    /** @internal */ _markSubMeshesAsMiscDirty() {
        this._markSubMeshesAsDirty((defines)=>defines.markAsMiscDirty());
    }
    /**
     * Flag the AbstractMesh as dirty (Forcing it to update everything)
     * @param property if set to "rotation" the objects rotationQuaternion will be set to null
     * @returns this AbstractMesh
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    markAsDirty(property) {
        this._currentRenderId = Number.MAX_VALUE;
        this._isDirty = true;
        return this;
    }
    /**
     * Resets the draw wrappers cache for all submeshes of this abstract mesh
     * @param passId If provided, releases only the draw wrapper corresponding to this render pass id
     */ resetDrawCache(passId) {
        if (!this.subMeshes) return;
        for (const subMesh of this.subMeshes)subMesh.resetDrawCache(passId);
    }
    // Methods
    /**
     * Returns true if the mesh is blocked. Implemented by child classes
     */ get isBlocked() {
        return false;
    }
    /**
     * Returns the mesh itself by default. Implemented by child classes
     * @param camera defines the camera to use to pick the right LOD level
     * @returns the currentAbstractMesh
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getLOD(camera) {
        return this;
    }
    /**
     * Returns 0 by default. Implemented by child classes
     * @returns an integer
     */ getTotalVertices() {
        return 0;
    }
    /**
     * Returns a positive integer : the total number of indices in this mesh geometry.
     * @returns the number of indices or zero if the mesh has no geometry.
     */ getTotalIndices() {
        return 0;
    }
    /**
     * Returns null by default. Implemented by child classes
     * @returns null
     */ getIndices() {
        return null;
    }
    /**
     * Returns the array of the requested vertex data kind. Implemented by child classes
     * @param kind defines the vertex data kind to use
     * @returns null
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getVerticesData(kind) {
        return null;
    }
    /**
     * Sets the vertex data of the mesh geometry for the requested `kind`.
     * If the mesh has no geometry, a new Geometry object is set to the mesh and then passed this vertex data.
     * Note that a new underlying VertexBuffer object is created each call.
     * If the `kind` is the `PositionKind`, the mesh BoundingInfo is renewed, so the bounding box and sphere, and the mesh World Matrix is recomputed.
     * @param kind defines vertex data kind:
     * * VertexBuffer.PositionKind
     * * VertexBuffer.UVKind
     * * VertexBuffer.UV2Kind
     * * VertexBuffer.UV3Kind
     * * VertexBuffer.UV4Kind
     * * VertexBuffer.UV5Kind
     * * VertexBuffer.UV6Kind
     * * VertexBuffer.ColorKind
     * * VertexBuffer.MatricesIndicesKind
     * * VertexBuffer.MatricesIndicesExtraKind
     * * VertexBuffer.MatricesWeightsKind
     * * VertexBuffer.MatricesWeightsExtraKind
     * @param data defines the data source
     * @param updatable defines if the data must be flagged as updatable (or static)
     * @param stride defines the vertex stride (size of an entire vertex). Can be null and in this case will be deduced from vertex data kind
     * @returns the current mesh
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setVerticesData(kind, data, updatable, stride) {
        return this;
    }
    /**
     * Updates the existing vertex data of the mesh geometry for the requested `kind`.
     * If the mesh has no geometry, it is simply returned as it is.
     * @param kind defines vertex data kind:
     * * VertexBuffer.PositionKind
     * * VertexBuffer.UVKind
     * * VertexBuffer.UV2Kind
     * * VertexBuffer.UV3Kind
     * * VertexBuffer.UV4Kind
     * * VertexBuffer.UV5Kind
     * * VertexBuffer.UV6Kind
     * * VertexBuffer.ColorKind
     * * VertexBuffer.MatricesIndicesKind
     * * VertexBuffer.MatricesIndicesExtraKind
     * * VertexBuffer.MatricesWeightsKind
     * * VertexBuffer.MatricesWeightsExtraKind
     * @param data defines the data source
     * @param updateExtends If `kind` is `PositionKind` and if `updateExtends` is true, the mesh BoundingInfo is renewed, so the bounding box and sphere, and the mesh World Matrix is recomputed
     * @param makeItUnique If true, a new global geometry is created from this data and is set to the mesh
     * @returns the current mesh
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    updateVerticesData(kind, data, updateExtends, makeItUnique) {
        return this;
    }
    /**
     * Sets the mesh indices,
     * If the mesh has no geometry, a new Geometry object is created and set to the mesh.
     * @param indices Expects an array populated with integers or a typed array (Int32Array, Uint32Array, Uint16Array)
     * @param totalVertices Defines the total number of vertices
     * @returns the current mesh
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setIndices(indices, totalVertices) {
        return this;
    }
    /**
     * Gets a boolean indicating if specific vertex data is present
     * @param kind defines the vertex data kind to use
     * @returns true is data kind is present
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isVerticesDataPresent(kind) {
        return false;
    }
    /**
     * Returns the mesh BoundingInfo object or creates a new one and returns if it was undefined.
     * Note that it returns a shallow bounding of the mesh (i.e. it does not include children).
     * However, if the mesh contains thin instances, it will be expanded to include them. If you want the "raw" bounding data instead, then use `getRawBoundingInfo()`.
     * To get the full bounding of all children, call `getHierarchyBoundingVectors` instead.
     * @returns a BoundingInfo
     */ getBoundingInfo() {
        if (this._masterMesh) return this._masterMesh.getBoundingInfo();
        if (this._boundingInfoIsDirty) {
            this._boundingInfoIsDirty = false;
            // this._boundingInfo is being created if undefined
            this._updateBoundingInfo();
        }
        // cannot be null.
        return this._boundingInfo;
    }
    /**
     * Returns the bounding info unnafected by instance data.
     * @returns the bounding info of the mesh unaffected by instance data.
     */ getRawBoundingInfo() {
        return this.rawBoundingInfo ?? this.getBoundingInfo();
    }
    /**
     * Overwrite the current bounding info
     * @param boundingInfo defines the new bounding info
     * @returns the current mesh
     */ setBoundingInfo(boundingInfo) {
        this._boundingInfo = boundingInfo;
        return this;
    }
    /**
     * Returns true if there is already a bounding info
     */ get hasBoundingInfo() {
        return this._boundingInfo !== null;
    }
    /**
     * Creates a new bounding info for the mesh
     * @param minimum min vector of the bounding box/sphere
     * @param maximum max vector of the bounding box/sphere
     * @param worldMatrix defines the new world matrix
     * @returns the new bounding info
     */ buildBoundingInfo(minimum, maximum, worldMatrix) {
        this._boundingInfo = new (0, $ef012.BoundingInfo)(minimum, maximum, worldMatrix);
        return this._boundingInfo;
    }
    /**
     * Uniformly scales the mesh to fit inside of a unit cube (1 X 1 X 1 units)
     * @param includeDescendants Use the hierarchy's bounding box instead of the mesh's bounding box. Default is false
     * @param ignoreRotation ignore rotation when computing the scale (ie. object will be axis aligned). Default is false
     * @param predicate predicate that is passed in to getHierarchyBoundingVectors when selecting which object should be included when scaling
     * @returns the current mesh
     */ normalizeToUnitCube(includeDescendants = true, ignoreRotation = false, predicate) {
        return super.normalizeToUnitCube(includeDescendants, ignoreRotation, predicate);
    }
    /** Gets a boolean indicating if this mesh has skinning data and an attached skeleton */ get useBones() {
        return this.skeleton && this.getScene().skeletonsEnabled && this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).MatricesIndicesKind) && this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).MatricesWeightsKind);
    }
    /** @internal */ _preActivate() {}
    /**
     * @internal
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _preActivateForIntermediateRendering(renderId) {}
    /**
     * @internal
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _activate(renderId, intermediateRendering) {
        this._renderId = renderId;
        return true;
    }
    /** @internal */ _postActivate() {
    // Do nothing
    }
    /** @internal */ _freeze() {
    // Do nothing
    }
    /** @internal */ _unFreeze() {
    // Do nothing
    }
    /**
     * Gets the current world matrix
     * @returns a Matrix
     */ getWorldMatrix() {
        if (this._masterMesh && this.billboardMode === (0, $klshO.TransformNode).BILLBOARDMODE_NONE) return this._masterMesh.getWorldMatrix();
        return super.getWorldMatrix();
    }
    /** @internal */ _getWorldMatrixDeterminant() {
        if (this._masterMesh) return this._masterMesh._getWorldMatrixDeterminant();
        return super._getWorldMatrixDeterminant();
    }
    /**
     * Gets a boolean indicating if this mesh is an instance or a regular mesh
     */ get isAnInstance() {
        return false;
    }
    /**
     * Gets a boolean indicating if this mesh has instances
     */ get hasInstances() {
        return false;
    }
    /**
     * Gets a boolean indicating if this mesh has thin instances
     */ get hasThinInstances() {
        return false;
    }
    // ================================== Point of View Movement =================================
    /**
     * Perform relative position change from the point of view of behind the front of the mesh.
     * This is performed taking into account the meshes current rotation, so you do not have to care.
     * Supports definition of mesh facing forward or backward {@link definedFacingForwardSearch | See definedFacingForwardSearch }.
     * @param amountRight defines the distance on the right axis
     * @param amountUp defines the distance on the up axis
     * @param amountForward defines the distance on the forward axis
     * @returns the current mesh
     */ movePOV(amountRight, amountUp, amountForward) {
        this.position.addInPlace(this.calcMovePOV(amountRight, amountUp, amountForward));
        return this;
    }
    /**
     * Calculate relative position change from the point of view of behind the front of the mesh.
     * This is performed taking into account the meshes current rotation, so you do not have to care.
     * Supports definition of mesh facing forward or backward {@link definedFacingForwardSearch | See definedFacingForwardSearch }.
     * @param amountRight defines the distance on the right axis
     * @param amountUp defines the distance on the up axis
     * @param amountForward defines the distance on the forward axis
     * @returns the new displacement vector
     */ calcMovePOV(amountRight, amountUp, amountForward) {
        const rotMatrix = new (0, $ha1VO.Matrix)();
        const rotQuaternion = this.rotationQuaternion ? this.rotationQuaternion : (0, $ha1VO.Quaternion).RotationYawPitchRoll(this.rotation.y, this.rotation.x, this.rotation.z);
        rotQuaternion.toRotationMatrix(rotMatrix);
        const translationDelta = (0, $ha1VO.Vector3).Zero();
        const defForwardMult = this.definedFacingForward ? -1 : 1;
        (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(amountRight * defForwardMult, amountUp, amountForward * defForwardMult, rotMatrix, translationDelta);
        return translationDelta;
    }
    // ================================== Point of View Rotation =================================
    /**
     * Perform relative rotation change from the point of view of behind the front of the mesh.
     * Supports definition of mesh facing forward or backward {@link definedFacingForwardSearch | See definedFacingForwardSearch }.
     * @param flipBack defines the flip
     * @param twirlClockwise defines the twirl
     * @param tiltRight defines the tilt
     * @returns the current mesh
     */ rotatePOV(flipBack, twirlClockwise, tiltRight) {
        this.rotation.addInPlace(this.calcRotatePOV(flipBack, twirlClockwise, tiltRight));
        return this;
    }
    /**
     * Calculate relative rotation change from the point of view of behind the front of the mesh.
     * Supports definition of mesh facing forward or backward {@link definedFacingForwardSearch | See definedFacingForwardSearch }.
     * @param flipBack defines the flip
     * @param twirlClockwise defines the twirl
     * @param tiltRight defines the tilt
     * @returns the new rotation vector
     */ calcRotatePOV(flipBack, twirlClockwise, tiltRight) {
        const defForwardMult = this.definedFacingForward ? 1 : -1;
        return new (0, $ha1VO.Vector3)(flipBack * defForwardMult, twirlClockwise, tiltRight * defForwardMult);
    }
    /**
     * This method recomputes and sets a new BoundingInfo to the mesh unless it is locked.
     * This means the mesh underlying bounding box and sphere are recomputed.
     * @param applySkeleton defines whether to apply the skeleton before computing the bounding info
     * @param applyMorph  defines whether to apply the morph target before computing the bounding info
     * @returns the current mesh
     */ refreshBoundingInfo(applySkeleton = false, applyMorph = false) {
        if (this._boundingInfo && this._boundingInfo.isLocked) return this;
        this._refreshBoundingInfo(this._getPositionData(applySkeleton, applyMorph), null);
        return this;
    }
    /**
     * @internal
     */ _refreshBoundingInfo(data, bias) {
        if (data) {
            const extend = (0, $1NJAz.extractMinAndMax)(data, 0, this.getTotalVertices(), bias);
            if (this._boundingInfo) this._boundingInfo.reConstruct(extend.minimum, extend.maximum);
            else this._boundingInfo = new (0, $ef012.BoundingInfo)(extend.minimum, extend.maximum);
        }
        if (this.subMeshes) for(let index = 0; index < this.subMeshes.length; index++)this.subMeshes[index].refreshBoundingInfo(data);
        this._updateBoundingInfo();
    }
    /**
     * Internal function to get buffer data and possibly apply morphs and normals
     * @param applySkeleton
     * @param applyMorph
     * @param data
     * @param kind the kind of data you want. Can be Normal or Position
     * @returns a FloatArray of the vertex data
     */ _getData(applySkeleton = false, applyMorph = false, data, kind = (0, $b4i1f.VertexBuffer).PositionKind) {
        data = data ?? this.getVerticesData(kind).slice();
        if (data && applyMorph && this.morphTargetManager) {
            let faceIndexCount = 0;
            let positionIndex = 0;
            for(let vertexCount = 0; vertexCount < data.length; vertexCount++){
                let value = data[vertexCount];
                for(let targetCount = 0; targetCount < this.morphTargetManager.numTargets; targetCount++){
                    const targetMorph = this.morphTargetManager.getTarget(targetCount);
                    const influence = targetMorph.influence;
                    if (influence !== 0.0) {
                        let morphTargetData = null;
                        switch(kind){
                            case (0, $b4i1f.VertexBuffer).PositionKind:
                                morphTargetData = targetMorph.getPositions();
                                break;
                            case (0, $b4i1f.VertexBuffer).NormalKind:
                                morphTargetData = targetMorph.getNormals();
                                break;
                            case (0, $b4i1f.VertexBuffer).TangentKind:
                                morphTargetData = targetMorph.getTangents();
                                break;
                            case (0, $b4i1f.VertexBuffer).UVKind:
                                morphTargetData = targetMorph.getUVs();
                                break;
                        }
                        if (morphTargetData) value += (morphTargetData[vertexCount] - data[vertexCount]) * influence;
                    }
                }
                data[vertexCount] = value;
                faceIndexCount++;
                if (kind === (0, $b4i1f.VertexBuffer).PositionKind) {
                    if (this._positions && faceIndexCount === 3) {
                        // We want to merge into positions every 3 indices starting (but not 0)
                        faceIndexCount = 0;
                        const index = positionIndex * 3;
                        this._positions[positionIndex++].copyFromFloats(data[index], data[index + 1], data[index + 2]);
                    }
                }
            }
        }
        if (data && applySkeleton && this.skeleton) {
            const matricesIndicesData = this.getVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesKind);
            const matricesWeightsData = this.getVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsKind);
            if (matricesWeightsData && matricesIndicesData) {
                const needExtras = this.numBoneInfluencers > 4;
                const matricesIndicesExtraData = needExtras ? this.getVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind) : null;
                const matricesWeightsExtraData = needExtras ? this.getVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind) : null;
                const skeletonMatrices = this.skeleton.getTransformMatrices(this);
                const tempVector = (0, $ha1VO.TmpVectors).Vector3[0];
                const finalMatrix = (0, $ha1VO.TmpVectors).Matrix[0];
                const tempMatrix = (0, $ha1VO.TmpVectors).Matrix[1];
                let matWeightIdx = 0;
                for(let index = 0; index < data.length; index += 3, matWeightIdx += 4){
                    finalMatrix.reset();
                    let inf;
                    let weight;
                    for(inf = 0; inf < 4; inf++){
                        weight = matricesWeightsData[matWeightIdx + inf];
                        if (weight > 0) {
                            (0, $ha1VO.Matrix).FromFloat32ArrayToRefScaled(skeletonMatrices, Math.floor(matricesIndicesData[matWeightIdx + inf] * 16), weight, tempMatrix);
                            finalMatrix.addToSelf(tempMatrix);
                        }
                    }
                    if (needExtras) for(inf = 0; inf < 4; inf++){
                        weight = matricesWeightsExtraData[matWeightIdx + inf];
                        if (weight > 0) {
                            (0, $ha1VO.Matrix).FromFloat32ArrayToRefScaled(skeletonMatrices, Math.floor(matricesIndicesExtraData[matWeightIdx + inf] * 16), weight, tempMatrix);
                            finalMatrix.addToSelf(tempMatrix);
                        }
                    }
                    if (kind === (0, $b4i1f.VertexBuffer).NormalKind) (0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(data[index], data[index + 1], data[index + 2], finalMatrix, tempVector);
                    else (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(data[index], data[index + 1], data[index + 2], finalMatrix, tempVector);
                    tempVector.toArray(data, index);
                    if (kind === (0, $b4i1f.VertexBuffer).PositionKind && this._positions) this._positions[index / 3].copyFrom(tempVector);
                }
            }
        }
        return data;
    }
    /**
     * Get the normals vertex data and optionally apply skeleton and morphing.
     * @param applySkeleton defines whether to apply the skeleton
     * @param applyMorph  defines whether to apply the morph target
     * @returns the normals data
     */ getNormalsData(applySkeleton = false, applyMorph = false) {
        return this._getData(applySkeleton, applyMorph, null, (0, $b4i1f.VertexBuffer).NormalKind);
    }
    /**
     * Get the position vertex data and optionally apply skeleton and morphing.
     * @param applySkeleton defines whether to apply the skeleton
     * @param applyMorph  defines whether to apply the morph target
     * @param data defines the position data to apply the skeleton and morph to
     * @returns the position data
     */ getPositionData(applySkeleton = false, applyMorph = false, data) {
        return this._getData(applySkeleton, applyMorph, data, (0, $b4i1f.VertexBuffer).PositionKind);
    }
    /**
     * @internal
     */ _getPositionData(applySkeleton, applyMorph) {
        let data = this.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        if (this._internalAbstractMeshDataInfo._positions) this._internalAbstractMeshDataInfo._positions = null;
        if (data && (applySkeleton && this.skeleton || applyMorph && this.morphTargetManager)) {
            data = data.slice();
            this._generatePointsArray();
            if (this._positions) {
                const pos = this._positions;
                this._internalAbstractMeshDataInfo._positions = new Array(pos.length);
                for(let i = 0; i < pos.length; i++)this._internalAbstractMeshDataInfo._positions[i] = pos[i]?.clone() || new (0, $ha1VO.Vector3)();
            }
            return this.getPositionData(applySkeleton, applyMorph, data);
        }
        return data;
    }
    /** @internal */ _updateBoundingInfo() {
        if (this._boundingInfo) this._boundingInfo.update(this.worldMatrixFromCache);
        else this._boundingInfo = new (0, $ef012.BoundingInfo)((0, $ha1VO.Vector3).Zero(), (0, $ha1VO.Vector3).Zero(), this.worldMatrixFromCache);
        this._updateSubMeshesBoundingInfo(this.worldMatrixFromCache);
        return this;
    }
    /**
     * @internal
     */ _updateSubMeshesBoundingInfo(matrix) {
        if (!this.subMeshes) return this;
        const count = this.subMeshes.length;
        for(let subIndex = 0; subIndex < count; subIndex++){
            const subMesh = this.subMeshes[subIndex];
            if (count > 1 || !subMesh.IsGlobal) subMesh.updateBoundingInfo(matrix);
        }
        return this;
    }
    /** @internal */ _afterComputeWorldMatrix() {
        if (this.doNotSyncBoundingInfo) return;
        // Bounding info
        this._boundingInfoIsDirty = true;
    }
    /**
     * Returns `true` if the mesh is within the frustum defined by the passed array of planes.
     * A mesh is in the frustum if its bounding box intersects the frustum
     * @param frustumPlanes defines the frustum to test
     * @returns true if the mesh is in the frustum planes
     */ isInFrustum(frustumPlanes) {
        return this.getBoundingInfo().isInFrustum(frustumPlanes, this.cullingStrategy);
    }
    /**
     * Returns `true` if the mesh is completely in the frustum defined be the passed array of planes.
     * A mesh is completely in the frustum if its bounding box it completely inside the frustum.
     * @param frustumPlanes defines the frustum to test
     * @returns true if the mesh is completely in the frustum planes
     */ isCompletelyInFrustum(frustumPlanes) {
        return this.getBoundingInfo().isCompletelyInFrustum(frustumPlanes);
    }
    /**
     * True if the mesh intersects another mesh or a SolidParticle object
     * @param mesh defines a target mesh or SolidParticle to test
     * @param precise Unless the parameter `precise` is set to `true` the intersection is computed according to Axis Aligned Bounding Boxes (AABB), else according to OBB (Oriented BBoxes)
     * @param includeDescendants Can be set to true to test if the mesh defined in parameters intersects with the current mesh or any child meshes
     * @returns true if there is an intersection
     */ intersectsMesh(mesh, precise = false, includeDescendants) {
        const boundingInfo = this.getBoundingInfo();
        const otherBoundingInfo = mesh.getBoundingInfo();
        if (boundingInfo.intersects(otherBoundingInfo, precise)) return true;
        if (includeDescendants) for (const child of this.getChildMeshes()){
            if (child.intersectsMesh(mesh, precise, true)) return true;
        }
        return false;
    }
    /**
     * Returns true if the passed point (Vector3) is inside the mesh bounding box
     * @param point defines the point to test
     * @returns true if there is an intersection
     */ intersectsPoint(point) {
        return this.getBoundingInfo().intersectsPoint(point);
    }
    // Collisions
    /**
     * Gets or sets a boolean indicating that this mesh can be used in the collision engine
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_collisions
     */ get checkCollisions() {
        return this._internalAbstractMeshDataInfo._meshCollisionData._checkCollisions;
    }
    set checkCollisions(collisionEnabled) {
        this._internalAbstractMeshDataInfo._meshCollisionData._checkCollisions = collisionEnabled;
    }
    /**
     * Gets Collider object used to compute collisions (not physics)
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_collisions
     */ get collider() {
        return this._internalAbstractMeshDataInfo._meshCollisionData._collider;
    }
    /**
     * Move the mesh using collision engine
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_collisions
     * @param displacement defines the requested displacement vector
     * @returns the current mesh
     */ moveWithCollisions(displacement) {
        const globalPosition = this.getAbsolutePosition();
        globalPosition.addToRef(this.ellipsoidOffset, this._internalAbstractMeshDataInfo._meshCollisionData._oldPositionForCollisions);
        const coordinator = this.getScene().collisionCoordinator;
        if (!this._internalAbstractMeshDataInfo._meshCollisionData._collider) this._internalAbstractMeshDataInfo._meshCollisionData._collider = coordinator.createCollider();
        this._internalAbstractMeshDataInfo._meshCollisionData._collider._radius = this.ellipsoid;
        coordinator.getNewPosition(this._internalAbstractMeshDataInfo._meshCollisionData._oldPositionForCollisions, displacement, this._internalAbstractMeshDataInfo._meshCollisionData._collider, this.collisionRetryCount, this, this._onCollisionPositionChange, this.uniqueId);
        return this;
    }
    // Collisions
    /**
     * @internal
     */ _collideForSubMesh(subMesh, transformMatrix, collider) {
        this._generatePointsArray();
        if (!this._positions) return this;
        // Transformation
        if (!subMesh._lastColliderWorldVertices || !subMesh._lastColliderTransformMatrix.equals(transformMatrix)) {
            subMesh._lastColliderTransformMatrix = transformMatrix.clone();
            subMesh._lastColliderWorldVertices = [];
            subMesh._trianglePlanes = [];
            const start = subMesh.verticesStart;
            const end = subMesh.verticesStart + subMesh.verticesCount;
            for(let i = start; i < end; i++)subMesh._lastColliderWorldVertices.push((0, $ha1VO.Vector3).TransformCoordinates(this._positions[i], transformMatrix));
        }
        // Collide
        collider._collide(subMesh._trianglePlanes, subMesh._lastColliderWorldVertices, this.getIndices(), subMesh.indexStart, subMesh.indexStart + subMesh.indexCount, subMesh.verticesStart, !!subMesh.getMaterial(), this, this._shouldConvertRHS(), subMesh.getMaterial()?.fillMode === 7);
        return this;
    }
    /**
     * @internal
     */ _processCollisionsForSubMeshes(collider, transformMatrix) {
        const subMeshes = this._scene.getCollidingSubMeshCandidates(this, collider);
        const len = subMeshes.length;
        for(let index = 0; index < len; index++){
            const subMesh = subMeshes.data[index];
            // Bounding test
            if (len > 1 && !subMesh._checkCollision(collider)) continue;
            this._collideForSubMesh(subMesh, transformMatrix, collider);
        }
        return this;
    }
    /** @internal */ _shouldConvertRHS() {
        return false;
    }
    /**
     * @internal
     */ _checkCollision(collider) {
        // Bounding box test
        if (!this.getBoundingInfo()._checkCollision(collider)) return this;
        // Transformation matrix
        const collisionsScalingMatrix = (0, $ha1VO.TmpVectors).Matrix[0];
        const collisionsTransformMatrix = (0, $ha1VO.TmpVectors).Matrix[1];
        (0, $ha1VO.Matrix).ScalingToRef(1.0 / collider._radius.x, 1.0 / collider._radius.y, 1.0 / collider._radius.z, collisionsScalingMatrix);
        this.worldMatrixFromCache.multiplyToRef(collisionsScalingMatrix, collisionsTransformMatrix);
        this._processCollisionsForSubMeshes(collider, collisionsTransformMatrix);
        return this;
    }
    // Picking
    /** @internal */ _generatePointsArray() {
        return false;
    }
    /**
     * Checks if the passed Ray intersects with the mesh. A mesh triangle can be picked both from its front and back sides,
     * irrespective of orientation.
     * @param ray defines the ray to use. It should be in the mesh's LOCAL coordinate space.
     * @param fastCheck defines if fast mode (but less precise) must be used (false by default)
     * @param trianglePredicate defines an optional predicate used to select faces when a mesh intersection is detected
     * @param onlyBoundingInfo defines a boolean indicating if picking should only happen using bounding info (false by default)
     * @param worldToUse defines the world matrix to use to get the world coordinate of the intersection point
     * @param skipBoundingInfo a boolean indicating if we should skip the bounding info check
     * @returns the picking info
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/interactions/mesh_intersect
     */ intersects(ray, fastCheck, trianglePredicate, onlyBoundingInfo = false, worldToUse, skipBoundingInfo = false) {
        const pickingInfo = new (0, $gzCma.PickingInfo)();
        const className = this.getClassName();
        const intersectionThreshold = className === "InstancedLinesMesh" || className === "LinesMesh" || className === "GreasedLineMesh" ? this.intersectionThreshold : 0;
        const boundingInfo = this.getBoundingInfo();
        if (!this.subMeshes) return pickingInfo;
        if (!skipBoundingInfo && (!ray.intersectsSphere(boundingInfo.boundingSphere, intersectionThreshold) || !ray.intersectsBox(boundingInfo.boundingBox, intersectionThreshold))) return pickingInfo;
        if (onlyBoundingInfo) {
            pickingInfo.hit = skipBoundingInfo ? false : true;
            pickingInfo.pickedMesh = skipBoundingInfo ? null : this;
            pickingInfo.distance = skipBoundingInfo ? 0 : (0, $ha1VO.Vector3).Distance(ray.origin, boundingInfo.boundingSphere.center);
            pickingInfo.subMeshId = 0;
            return pickingInfo;
        }
        if (!this._generatePointsArray()) return pickingInfo;
        let intersectInfo = null;
        const subMeshes = this._scene.getIntersectingSubMeshCandidates(this, ray);
        const len = subMeshes.length;
        // Check if all submeshes are using a material that don't allow picking (point/lines rendering)
        // if no submesh can be picked that way, then fallback to BBox picking
        let anySubmeshSupportIntersect = false;
        for(let index = 0; index < len; index++){
            const subMesh = subMeshes.data[index];
            const material = subMesh.getMaterial();
            if (!material) continue;
            if (material.fillMode == 7 || material.fillMode == 0 || material.fillMode == 1 || material.fillMode == 2 || material.fillMode == 4) {
                anySubmeshSupportIntersect = true;
                break;
            }
        }
        // no sub mesh support intersection, fallback to BBox that has already be done
        if (!anySubmeshSupportIntersect) {
            pickingInfo.hit = true;
            pickingInfo.pickedMesh = this;
            pickingInfo.distance = (0, $ha1VO.Vector3).Distance(ray.origin, boundingInfo.boundingSphere.center);
            pickingInfo.subMeshId = -1;
            return pickingInfo;
        }
        // at least 1 submesh supports intersection, keep going
        for(let index = 0; index < len; index++){
            const subMesh = subMeshes.data[index];
            // Bounding test
            if (len > 1 && !skipBoundingInfo && !subMesh.canIntersects(ray)) continue;
            const currentIntersectInfo = subMesh.intersects(ray, this._positions, this.getIndices(), fastCheck, trianglePredicate);
            if (currentIntersectInfo) {
                if (fastCheck || !intersectInfo || currentIntersectInfo.distance < intersectInfo.distance) {
                    intersectInfo = currentIntersectInfo;
                    intersectInfo.subMeshId = index;
                    if (fastCheck) break;
                }
            }
        }
        if (intersectInfo) {
            // Get picked point
            const world = worldToUse ?? this.getWorldMatrix();
            const worldOrigin = (0, $ha1VO.TmpVectors).Vector3[0];
            const direction = (0, $ha1VO.TmpVectors).Vector3[1];
            (0, $ha1VO.Vector3).TransformCoordinatesToRef(ray.origin, world, worldOrigin);
            ray.direction.scaleToRef(intersectInfo.distance, direction);
            const worldDirection = (0, $ha1VO.Vector3).TransformNormal(direction, world);
            const pickedPoint = worldDirection.addInPlace(worldOrigin);
            // Return result
            pickingInfo.hit = true;
            pickingInfo.distance = (0, $ha1VO.Vector3).Distance(worldOrigin, pickedPoint);
            pickingInfo.pickedPoint = pickedPoint;
            pickingInfo.pickedMesh = this;
            pickingInfo.bu = intersectInfo.bu || 0;
            pickingInfo.bv = intersectInfo.bv || 0;
            pickingInfo.subMeshFaceId = intersectInfo.faceId;
            pickingInfo.faceId = intersectInfo.faceId + subMeshes.data[intersectInfo.subMeshId].indexStart / (this.getClassName().indexOf("LinesMesh") !== -1 ? 2 : 3);
            pickingInfo.subMeshId = intersectInfo.subMeshId;
            return pickingInfo;
        }
        return pickingInfo;
    }
    /**
     * Clones the current mesh
     * @param name defines the mesh name
     * @param newParent defines the new mesh parent
     * @param doNotCloneChildren defines a boolean indicating that children must not be cloned (false by default)
     * @returns the new mesh
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    clone(name, newParent, doNotCloneChildren) {
        return null;
    }
    /**
     * Disposes all the submeshes of the current meshnp
     * @returns the current mesh
     */ releaseSubMeshes() {
        if (this.subMeshes) while(this.subMeshes.length)this.subMeshes[0].dispose();
        else this.subMeshes = [];
        return this;
    }
    /**
     * Releases resources associated with this abstract mesh.
     * @param doNotRecurse Set to true to not recurse into each children (recurse into each children by default)
     * @param disposeMaterialAndTextures Set to true to also dispose referenced materials and textures (false by default)
     */ dispose(doNotRecurse, disposeMaterialAndTextures = false) {
        let index;
        const scene = this.getScene();
        // mesh map release.
        if (this._scene.useMaterialMeshMap) // remove from material mesh map id needed
        {
            if (this._internalAbstractMeshDataInfo._material && this._internalAbstractMeshDataInfo._material.meshMap) this._internalAbstractMeshDataInfo._material.meshMap[this.uniqueId] = undefined;
        }
        // Smart Array Retainers.
        scene.freeActiveMeshes();
        scene.freeRenderingGroups();
        if (scene.renderingManager.maintainStateBetweenFrames) scene.renderingManager.restoreDispachedFlags();
        // Action manager
        if (this.actionManager !== undefined && this.actionManager !== null) {
            // If it's the only mesh using the action manager, dispose of it.
            if (!this._scene.meshes.some((m)=>m !== this && m.actionManager === this.actionManager)) this.actionManager.dispose();
            this.actionManager = null;
        }
        // Skeleton
        this._internalAbstractMeshDataInfo._skeleton = null;
        if (this._transformMatrixTexture) {
            this._transformMatrixTexture.dispose();
            this._transformMatrixTexture = null;
        }
        // Intersections in progress
        for(index = 0; index < this._intersectionsInProgress.length; index++){
            const other = this._intersectionsInProgress[index];
            const pos = other._intersectionsInProgress.indexOf(this);
            other._intersectionsInProgress.splice(pos, 1);
        }
        this._intersectionsInProgress.length = 0;
        // Lights
        const lights = scene.lights;
        lights.forEach((light)=>{
            let meshIndex = light.includedOnlyMeshes.indexOf(this);
            if (meshIndex !== -1) light.includedOnlyMeshes.splice(meshIndex, 1);
            meshIndex = light.excludedMeshes.indexOf(this);
            if (meshIndex !== -1) light.excludedMeshes.splice(meshIndex, 1);
            // Shadow generators
            const generators = light.getShadowGenerators();
            if (generators) {
                const iterator = generators.values();
                for(let key = iterator.next(); key.done !== true; key = iterator.next()){
                    const generator = key.value;
                    const shadowMap = generator.getShadowMap();
                    if (shadowMap && shadowMap.renderList) {
                        meshIndex = shadowMap.renderList.indexOf(this);
                        if (meshIndex !== -1) shadowMap.renderList.splice(meshIndex, 1);
                    }
                }
            }
        });
        // SubMeshes
        if (this.getClassName() !== "InstancedMesh" || this.getClassName() !== "InstancedLinesMesh") this.releaseSubMeshes();
        // Query
        const engine = scene.getEngine();
        if (this._occlusionQuery !== null) {
            this.isOcclusionQueryInProgress = false;
            engine.deleteQuery(this._occlusionQuery);
            this._occlusionQuery = null;
        }
        // Engine
        engine.wipeCaches();
        // Remove from scene
        scene.removeMesh(this);
        if (this._parentContainer) {
            const index = this._parentContainer.meshes.indexOf(this);
            if (index > -1) this._parentContainer.meshes.splice(index, 1);
            this._parentContainer = null;
        }
        if (disposeMaterialAndTextures) {
            if (this.material) {
                if (this.material.getClassName() === "MultiMaterial") this.material.dispose(false, true, true);
                else this.material.dispose(false, true);
            }
        }
        if (!doNotRecurse) {
            // Particles
            for(index = 0; index < scene.particleSystems.length; index++)if (scene.particleSystems[index].emitter === this) {
                scene.particleSystems[index].dispose();
                index--;
            }
        }
        // facet data
        if (this._internalAbstractMeshDataInfo._facetData.facetDataEnabled) this.disableFacetData();
        this._uniformBuffer.dispose();
        this.onAfterWorldMatrixUpdateObservable.clear();
        this.onCollideObservable.clear();
        this.onCollisionPositionChangeObservable.clear();
        this.onRebuildObservable.clear();
        super.dispose(doNotRecurse, disposeMaterialAndTextures);
    }
    /**
     * Adds the passed mesh as a child to the current mesh
     * @param mesh defines the child mesh
     * @param preserveScalingSign if true, keep scaling sign of child. Otherwise, scaling sign might change.
     * @returns the current mesh
     */ addChild(mesh, preserveScalingSign = false) {
        mesh.setParent(this, preserveScalingSign);
        return this;
    }
    /**
     * Removes the passed mesh from the current mesh children list
     * @param mesh defines the child mesh
     * @param preserveScalingSign if true, keep scaling sign of child. Otherwise, scaling sign might change.
     * @returns the current mesh
     */ removeChild(mesh, preserveScalingSign = false) {
        mesh.setParent(null, preserveScalingSign);
        return this;
    }
    // Facet data
    /** @internal */ _initFacetData() {
        const data = this._internalAbstractMeshDataInfo._facetData;
        if (!data.facetNormals) data.facetNormals = [];
        if (!data.facetPositions) data.facetPositions = [];
        if (!data.facetPartitioning) data.facetPartitioning = new Array();
        data.facetNb = this.getIndices().length / 3 | 0;
        data.partitioningSubdivisions = data.partitioningSubdivisions ? data.partitioningSubdivisions : 10; // default nb of partitioning subdivisions = 10
        data.partitioningBBoxRatio = data.partitioningBBoxRatio ? data.partitioningBBoxRatio : 1.01; // default ratio 1.01 = the partitioning is 1% bigger than the bounding box
        for(let f = 0; f < data.facetNb; f++){
            data.facetNormals[f] = (0, $ha1VO.Vector3).Zero();
            data.facetPositions[f] = (0, $ha1VO.Vector3).Zero();
        }
        data.facetDataEnabled = true;
        return this;
    }
    /**
     * Updates the mesh facetData arrays and the internal partitioning when the mesh is morphed or updated.
     * This method can be called within the render loop.
     * You don't need to call this method by yourself in the render loop when you update/morph a mesh with the methods CreateXXX() as they automatically manage this computation
     * @returns the current mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
     */ updateFacetData() {
        const data = this._internalAbstractMeshDataInfo._facetData;
        if (!data.facetDataEnabled) this._initFacetData();
        const positions = this.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        const indices = this.getIndices();
        const normals = this.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind);
        const bInfo = this.getBoundingInfo();
        if (data.facetDepthSort && !data.facetDepthSortEnabled) {
            // init arrays, matrix and sort function on first call
            data.facetDepthSortEnabled = true;
            if (indices instanceof Uint16Array) data.depthSortedIndices = new Uint16Array(indices);
            else if (indices instanceof Uint32Array) data.depthSortedIndices = new Uint32Array(indices);
            else {
                let needs32bits = false;
                for(let i = 0; i < indices.length; i++)if (indices[i] > 65535) {
                    needs32bits = true;
                    break;
                }
                if (needs32bits) data.depthSortedIndices = new Uint32Array(indices);
                else data.depthSortedIndices = new Uint16Array(indices);
            }
            data.facetDepthSortFunction = function(f1, f2) {
                return f2.sqDistance - f1.sqDistance;
            };
            if (!data.facetDepthSortFrom) {
                const camera = this.getScene().activeCamera;
                data.facetDepthSortFrom = camera ? camera.position : (0, $ha1VO.Vector3).Zero();
            }
            data.depthSortedFacets = [];
            for(let f = 0; f < data.facetNb; f++){
                const depthSortedFacet = {
                    ind: f * 3,
                    sqDistance: 0.0
                };
                data.depthSortedFacets.push(depthSortedFacet);
            }
            data.invertedMatrix = (0, $ha1VO.Matrix).Identity();
            data.facetDepthSortOrigin = (0, $ha1VO.Vector3).Zero();
        }
        data.bbSize.x = bInfo.maximum.x - bInfo.minimum.x > (0, $53VPf.Epsilon) ? bInfo.maximum.x - bInfo.minimum.x : (0, $53VPf.Epsilon);
        data.bbSize.y = bInfo.maximum.y - bInfo.minimum.y > (0, $53VPf.Epsilon) ? bInfo.maximum.y - bInfo.minimum.y : (0, $53VPf.Epsilon);
        data.bbSize.z = bInfo.maximum.z - bInfo.minimum.z > (0, $53VPf.Epsilon) ? bInfo.maximum.z - bInfo.minimum.z : (0, $53VPf.Epsilon);
        let bbSizeMax = data.bbSize.x > data.bbSize.y ? data.bbSize.x : data.bbSize.y;
        bbSizeMax = bbSizeMax > data.bbSize.z ? bbSizeMax : data.bbSize.z;
        data.subDiv.max = data.partitioningSubdivisions;
        data.subDiv.X = Math.floor(data.subDiv.max * data.bbSize.x / bbSizeMax); // adjust the number of subdivisions per axis
        data.subDiv.Y = Math.floor(data.subDiv.max * data.bbSize.y / bbSizeMax); // according to each bbox size per axis
        data.subDiv.Z = Math.floor(data.subDiv.max * data.bbSize.z / bbSizeMax);
        data.subDiv.X = data.subDiv.X < 1 ? 1 : data.subDiv.X; // at least one subdivision
        data.subDiv.Y = data.subDiv.Y < 1 ? 1 : data.subDiv.Y;
        data.subDiv.Z = data.subDiv.Z < 1 ? 1 : data.subDiv.Z;
        // set the parameters for ComputeNormals()
        data.facetParameters.facetNormals = this.getFacetLocalNormals();
        data.facetParameters.facetPositions = this.getFacetLocalPositions();
        data.facetParameters.facetPartitioning = this.getFacetLocalPartitioning();
        data.facetParameters.bInfo = bInfo;
        data.facetParameters.bbSize = data.bbSize;
        data.facetParameters.subDiv = data.subDiv;
        data.facetParameters.ratio = this.partitioningBBoxRatio;
        data.facetParameters.depthSort = data.facetDepthSort;
        if (data.facetDepthSort && data.facetDepthSortEnabled) {
            this.computeWorldMatrix(true);
            this._worldMatrix.invertToRef(data.invertedMatrix);
            (0, $ha1VO.Vector3).TransformCoordinatesToRef(data.facetDepthSortFrom, data.invertedMatrix, data.facetDepthSortOrigin);
            data.facetParameters.distanceTo = data.facetDepthSortOrigin;
        }
        data.facetParameters.depthSortedFacets = data.depthSortedFacets;
        if (normals) (0, $5v6ry.VertexData).ComputeNormals(positions, indices, normals, data.facetParameters);
        if (data.facetDepthSort && data.facetDepthSortEnabled) {
            data.depthSortedFacets.sort(data.facetDepthSortFunction);
            const l = data.depthSortedIndices.length / 3 | 0;
            for(let f = 0; f < l; f++){
                const sind = data.depthSortedFacets[f].ind;
                data.depthSortedIndices[f * 3] = indices[sind];
                data.depthSortedIndices[f * 3 + 1] = indices[sind + 1];
                data.depthSortedIndices[f * 3 + 2] = indices[sind + 2];
            }
            this.updateIndices(data.depthSortedIndices, undefined, true);
        }
        return this;
    }
    /**
     * Returns the facetLocalNormals array.
     * The normals are expressed in the mesh local spac
     * @returns an array of Vector3
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
     */ getFacetLocalNormals() {
        const facetData = this._internalAbstractMeshDataInfo._facetData;
        if (!facetData.facetNormals) this.updateFacetData();
        return facetData.facetNormals;
    }
    /**
     * Returns the facetLocalPositions array.
     * The facet positions are expressed in the mesh local space
     * @returns an array of Vector3
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
     */ getFacetLocalPositions() {
        const facetData = this._internalAbstractMeshDataInfo._facetData;
        if (!facetData.facetPositions) this.updateFacetData();
        return facetData.facetPositions;
    }
    /**
     * Returns the facetLocalPartitioning array
     * @returns an array of array of numbers
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
     */ getFacetLocalPartitioning() {
        const facetData = this._internalAbstractMeshDataInfo._facetData;
        if (!facetData.facetPartitioning) this.updateFacetData();
        return facetData.facetPartitioning;
    }
    /**
     * Returns the i-th facet position in the world system.
     * This method allocates a new Vector3 per call
     * @param i defines the facet index
     * @returns a new Vector3
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
     */ getFacetPosition(i) {
        const pos = (0, $ha1VO.Vector3).Zero();
        this.getFacetPositionToRef(i, pos);
        return pos;
    }
    /**
     * Sets the reference Vector3 with the i-th facet position in the world system
     * @param i defines the facet index
     * @param ref defines the target vector
     * @returns the current mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
     */ getFacetPositionToRef(i, ref) {
        const localPos = this.getFacetLocalPositions()[i];
        const world = this.getWorldMatrix();
        (0, $ha1VO.Vector3).TransformCoordinatesToRef(localPos, world, ref);
        return this;
    }
    /**
     * Returns the i-th facet normal in the world system.
     * This method allocates a new Vector3 per call
     * @param i defines the facet index
     * @returns a new Vector3
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
     */ getFacetNormal(i) {
        const norm = (0, $ha1VO.Vector3).Zero();
        this.getFacetNormalToRef(i, norm);
        return norm;
    }
    /**
     * Sets the reference Vector3 with the i-th facet normal in the world system
     * @param i defines the facet index
     * @param ref defines the target vector
     * @returns the current mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
     */ getFacetNormalToRef(i, ref) {
        const localNorm = this.getFacetLocalNormals()[i];
        (0, $ha1VO.Vector3).TransformNormalToRef(localNorm, this.getWorldMatrix(), ref);
        return this;
    }
    /**
     * Returns the facets (in an array) in the same partitioning block than the one the passed coordinates are located (expressed in the mesh local system)
     * @param x defines x coordinate
     * @param y defines y coordinate
     * @param z defines z coordinate
     * @returns the array of facet indexes
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
     */ getFacetsAtLocalCoordinates(x, y, z) {
        const bInfo = this.getBoundingInfo();
        const data = this._internalAbstractMeshDataInfo._facetData;
        const ox = Math.floor((x - bInfo.minimum.x * data.partitioningBBoxRatio) * data.subDiv.X * data.partitioningBBoxRatio / data.bbSize.x);
        const oy = Math.floor((y - bInfo.minimum.y * data.partitioningBBoxRatio) * data.subDiv.Y * data.partitioningBBoxRatio / data.bbSize.y);
        const oz = Math.floor((z - bInfo.minimum.z * data.partitioningBBoxRatio) * data.subDiv.Z * data.partitioningBBoxRatio / data.bbSize.z);
        if (ox < 0 || ox > data.subDiv.max || oy < 0 || oy > data.subDiv.max || oz < 0 || oz > data.subDiv.max) return null;
        return data.facetPartitioning[ox + data.subDiv.max * oy + data.subDiv.max * data.subDiv.max * oz];
    }
    /**
     * Returns the closest mesh facet index at (x,y,z) World coordinates, null if not found
     * @param x defines x coordinate
     * @param y defines y coordinate
     * @param z defines z coordinate
     * @param projected sets as the (x,y,z) world projection on the facet
     * @param checkFace if true (default false), only the facet "facing" to (x,y,z) or only the ones "turning their backs", according to the parameter "facing" are returned
     * @param facing if facing and checkFace are true, only the facet "facing" to (x, y, z) are returned : positive dot (x, y, z) * facet position. If facing si false and checkFace is true, only the facet "turning their backs" to (x, y, z) are returned : negative dot (x, y, z) * facet position
     * @returns the face index if found (or null instead)
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
     */ getClosestFacetAtCoordinates(x, y, z, projected, checkFace = false, facing = true) {
        const world = this.getWorldMatrix();
        const invMat = (0, $ha1VO.TmpVectors).Matrix[5];
        world.invertToRef(invMat);
        const invVect = (0, $ha1VO.TmpVectors).Vector3[8];
        (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(x, y, z, invMat, invVect); // transform (x,y,z) to coordinates in the mesh local space
        const closest = this.getClosestFacetAtLocalCoordinates(invVect.x, invVect.y, invVect.z, projected, checkFace, facing);
        if (projected) // transform the local computed projected vector to world coordinates
        (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(projected.x, projected.y, projected.z, world, projected);
        return closest;
    }
    /**
     * Returns the closest mesh facet index at (x,y,z) local coordinates, null if not found
     * @param x defines x coordinate
     * @param y defines y coordinate
     * @param z defines z coordinate
     * @param projected sets as the (x,y,z) local projection on the facet
     * @param checkFace if true (default false), only the facet "facing" to (x,y,z) or only the ones "turning their backs", according to the parameter "facing" are returned
     * @param facing if facing and checkFace are true, only the facet "facing" to (x, y, z) are returned : positive dot (x, y, z) * facet position. If facing si false and checkFace is true, only the facet "turning their backs" to (x, y, z) are returned : negative dot (x, y, z) * facet position
     * @returns the face index if found (or null instead)
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
     */ getClosestFacetAtLocalCoordinates(x, y, z, projected, checkFace = false, facing = true) {
        let closest = null;
        let tmpx = 0.0;
        let tmpy = 0.0;
        let tmpz = 0.0;
        let d = 0.0; // tmp dot facet normal * facet position
        let t0 = 0.0;
        let projx = 0.0;
        let projy = 0.0;
        let projz = 0.0;
        // Get all the facets in the same partitioning block than (x, y, z)
        const facetPositions = this.getFacetLocalPositions();
        const facetNormals = this.getFacetLocalNormals();
        const facetsInBlock = this.getFacetsAtLocalCoordinates(x, y, z);
        if (!facetsInBlock) return null;
        // Get the closest facet to (x, y, z)
        let shortest = Number.MAX_VALUE; // init distance vars
        let tmpDistance = shortest;
        let fib; // current facet in the block
        let norm; // current facet normal
        let p0; // current facet barycenter position
        // loop on all the facets in the current partitioning block
        for(let idx = 0; idx < facetsInBlock.length; idx++){
            fib = facetsInBlock[idx];
            norm = facetNormals[fib];
            p0 = facetPositions[fib];
            d = (x - p0.x) * norm.x + (y - p0.y) * norm.y + (z - p0.z) * norm.z;
            if (!checkFace || checkFace && facing && d >= 0.0 || checkFace && !facing && d <= 0.0) {
                // compute (x,y,z) projection on the facet = (projx, projy, projz)
                d = norm.x * p0.x + norm.y * p0.y + norm.z * p0.z;
                t0 = -(norm.x * x + norm.y * y + norm.z * z - d) / (norm.x * norm.x + norm.y * norm.y + norm.z * norm.z);
                projx = x + norm.x * t0;
                projy = y + norm.y * t0;
                projz = z + norm.z * t0;
                tmpx = projx - x;
                tmpy = projy - y;
                tmpz = projz - z;
                tmpDistance = tmpx * tmpx + tmpy * tmpy + tmpz * tmpz; // compute length between (x, y, z) and its projection on the facet
                if (tmpDistance < shortest) {
                    // just keep the closest facet to (x, y, z)
                    shortest = tmpDistance;
                    closest = fib;
                    if (projected) {
                        projected.x = projx;
                        projected.y = projy;
                        projected.z = projz;
                    }
                }
            }
        }
        return closest;
    }
    /**
     * Returns the object "parameter" set with all the expected parameters for facetData computation by ComputeNormals()
     * @returns the parameters
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
     */ getFacetDataParameters() {
        return this._internalAbstractMeshDataInfo._facetData.facetParameters;
    }
    /**
     * Disables the feature FacetData and frees the related memory
     * @returns the current mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/facetData
     */ disableFacetData() {
        const facetData = this._internalAbstractMeshDataInfo._facetData;
        if (facetData.facetDataEnabled) {
            facetData.facetDataEnabled = false;
            facetData.facetPositions = [];
            facetData.facetNormals = [];
            facetData.facetPartitioning = new Array();
            facetData.facetParameters = null;
            facetData.depthSortedIndices = new Uint32Array(0);
        }
        return this;
    }
    /**
     * Updates the AbstractMesh indices array
     * @param indices defines the data source
     * @param offset defines the offset in the index buffer where to store the new data (can be null)
     * @param gpuMemoryOnly defines a boolean indicating that only the GPU memory must be updated leaving the CPU version of the indices unchanged (false by default)
     * @returns the current mesh
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    updateIndices(indices, offset, gpuMemoryOnly = false) {
        return this;
    }
    /**
     * Creates new normals data for the mesh
     * @param updatable defines if the normal vertex buffer must be flagged as updatable
     * @returns the current mesh
     */ createNormals(updatable) {
        const positions = this.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        const indices = this.getIndices();
        let normals;
        if (this.isVerticesDataPresent((0, $b4i1f.VertexBuffer).NormalKind)) normals = this.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind);
        else normals = [];
        (0, $5v6ry.VertexData).ComputeNormals(positions, indices, normals, {
            useRightHandedSystem: this.getScene().useRightHandedSystem
        });
        this.setVerticesData((0, $b4i1f.VertexBuffer).NormalKind, normals, updatable);
        return this;
    }
    /**
     * Align the mesh with a normal
     * @param normal defines the normal to use
     * @param upDirection can be used to redefined the up vector to use (will use the (0, 1, 0) by default)
     * @returns the current mesh
     */ alignWithNormal(normal, upDirection) {
        if (!upDirection) upDirection = (0, $dbxbu.Axis).Y;
        const axisX = (0, $ha1VO.TmpVectors).Vector3[0];
        const axisZ = (0, $ha1VO.TmpVectors).Vector3[1];
        (0, $ha1VO.Vector3).CrossToRef(upDirection, normal, axisZ);
        (0, $ha1VO.Vector3).CrossToRef(normal, axisZ, axisX);
        if (this.rotationQuaternion) (0, $ha1VO.Quaternion).RotationQuaternionFromAxisToRef(axisX, normal, axisZ, this.rotationQuaternion);
        else (0, $ha1VO.Vector3).RotationFromAxisToRef(axisX, normal, axisZ, this.rotation);
        return this;
    }
    /** @internal */ _checkOcclusionQuery() {
        // Will be replaced by correct code if Occlusion queries are referenced
        return false;
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Disables the mesh edge rendering mode
     * @returns the currentAbstractMesh
     */ disableEdgesRendering() {
        throw (0, $dUFYy._WarnImport)("EdgesRenderer");
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Enables the edge rendering mode on the mesh.
     * This mode makes the mesh edges visible
     * @param epsilon defines the maximal distance between two angles to detect a face
     * @param checkVerticesInsteadOfIndices indicates that we should check vertex list directly instead of faces
     * @param options options to the edge renderer
     * @returns the currentAbstractMesh
     * @see https://www.babylonjs-playground.com/#19O9TU#0
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    enableEdgesRendering(epsilon, checkVerticesInsteadOfIndices, options) {
        throw (0, $dUFYy._WarnImport)("EdgesRenderer");
    }
    /**
     * This function returns all of the particle systems in the scene that use the mesh as an emitter.
     * @returns an array of particle systems in the scene that use the mesh as an emitter
     */ getConnectedParticleSystems() {
        return this._scene.particleSystems.filter((particleSystem)=>particleSystem.emitter === this);
    }
}
/** No occlusion */ $0009db3ebb3b86d3$export$8f1d8af674c785a5.OCCLUSION_TYPE_NONE = 0;
/** Occlusion set to optimistic */ $0009db3ebb3b86d3$export$8f1d8af674c785a5.OCCLUSION_TYPE_OPTIMISTIC = 1;
/** Occlusion set to strict */ $0009db3ebb3b86d3$export$8f1d8af674c785a5.OCCLUSION_TYPE_STRICT = 2;
/** Use an accurate occlusion algorithm */ $0009db3ebb3b86d3$export$8f1d8af674c785a5.OCCLUSION_ALGORITHM_TYPE_ACCURATE = 0;
/** Use a conservative occlusion algorithm */ $0009db3ebb3b86d3$export$8f1d8af674c785a5.OCCLUSION_ALGORITHM_TYPE_CONSERVATIVE = 1;
/** Default culling strategy : this is an exclusion test and it's the more accurate.
 *  Test order :
 *  Is the bounding sphere outside the frustum ?
 *  If not, are the bounding box vertices outside the frustum ?
 *  It not, then the cullable object is in the frustum.
 */ $0009db3ebb3b86d3$export$8f1d8af674c785a5.CULLINGSTRATEGY_STANDARD = 0;
/** Culling strategy : Bounding Sphere Only.
 *  This is an exclusion test. It's faster than the standard strategy because the bounding box is not tested.
 *  It's also less accurate than the standard because some not visible objects can still be selected.
 *  Test : is the bounding sphere outside the frustum ?
 *  If not, then the cullable object is in the frustum.
 */ $0009db3ebb3b86d3$export$8f1d8af674c785a5.CULLINGSTRATEGY_BOUNDINGSPHERE_ONLY = 1;
/** Culling strategy : Optimistic Inclusion.
 *  This in an inclusion test first, then the standard exclusion test.
 *  This can be faster when a cullable object is expected to be almost always in the camera frustum.
 *  This could also be a little slower than the standard test when the tested object center is not the frustum but one of its bounding box vertex is still inside.
 *  Anyway, it's as accurate as the standard strategy.
 *  Test :
 *  Is the cullable object bounding sphere center in the frustum ?
 *  If not, apply the default culling strategy.
 */ $0009db3ebb3b86d3$export$8f1d8af674c785a5.CULLINGSTRATEGY_OPTIMISTIC_INCLUSION = 2;
/** Culling strategy : Optimistic Inclusion then Bounding Sphere Only.
 *  This in an inclusion test first, then the bounding sphere only exclusion test.
 *  This can be the fastest test when a cullable object is expected to be almost always in the camera frustum.
 *  This could also be a little slower than the BoundingSphereOnly strategy when the tested object center is not in the frustum but its bounding sphere still intersects it.
 *  It's less accurate than the standard strategy and as accurate as the BoundingSphereOnly strategy.
 *  Test :
 *  Is the cullable object bounding sphere center in the frustum ?
 *  If not, apply the Bounding Sphere Only strategy. No Bounding Box is tested here.
 */ $0009db3ebb3b86d3$export$8f1d8af674c785a5.CULLINGSTRATEGY_OPTIMISTIC_INCLUSION_THEN_BSPHERE_ONLY = 3;
(0, $8DoUR.RegisterClass)("BABYLON.AbstractMesh", $0009db3ebb3b86d3$export$8f1d8af674c785a5);

});
parcelRegister("5YkyR", function(module, exports) {

$parcel$export(module.exports, "Engine", () => $4592815ea2be2bed$export$2c3b404bf3a77a1f);

var $diGQf = parcelRequire("diGQf");

var $b9e4a = parcelRequire("b9e4a");

var $jFz47 = parcelRequire("jFz47");

var $ejQPp = parcelRequire("ejQPp");

var $dUFYy = parcelRequire("dUFYy");

var $2h5JR = parcelRequire("2h5JR");

var $aDymS = parcelRequire("aDymS");

var $2Fclq = parcelRequire("2Fclq");

var $koExS = parcelRequire("koExS");

var $kVtWi = parcelRequire("kVtWi");

var $8ClRi = parcelRequire("8ClRi");
parcelRequire("emm58");
parcelRequire("k0sxV");
parcelRequire("7G59J");
class $4592815ea2be2bed$export$2c3b404bf3a77a1f extends (0, $2h5JR.ThinEngine) {
    /**
     * Returns the current npm package of the sdk
     */ // Not mixed with Version for tooling purpose.
    static get NpmPackage() {
        return (0, $2h5JR.ThinEngine).NpmPackage;
    }
    /**
     * Returns the current version of the framework
     */ static get Version() {
        return (0, $2h5JR.ThinEngine).Version;
    }
    /** Gets the list of created engines */ static get Instances() {
        return (0, $ejQPp.EngineStore).Instances;
    }
    /**
     * Gets the latest created engine
     */ static get LastCreatedEngine() {
        return (0, $ejQPp.EngineStore).LastCreatedEngine;
    }
    /**
     * Gets the latest created scene
     */ static get LastCreatedScene() {
        return (0, $ejQPp.EngineStore).LastCreatedScene;
    }
    /** @internal */ /**
     * Engine abstraction for loading and creating an image bitmap from a given source string.
     * @param imageSource source to load the image from.
     * @param options An object that sets options for the image's extraction.
     * @returns ImageBitmap.
     */ _createImageBitmapFromSource(imageSource, options) {
        const promise = new Promise((resolve, reject)=>{
            const image = new Image();
            image.onload = ()=>{
                image.decode().then(()=>{
                    this.createImageBitmap(image, options).then((imageBitmap)=>{
                        resolve(imageBitmap);
                    });
                });
            };
            image.onerror = ()=>{
                reject(`Error loading image ${image.src}`);
            };
            image.src = imageSource;
        });
        return promise;
    }
    /**
     * Engine abstraction for createImageBitmap
     * @param image source for image
     * @param options An object that sets options for the image's extraction.
     * @returns ImageBitmap
     */ createImageBitmap(image, options) {
        return createImageBitmap(image, options);
    }
    /**
     * Resize an image and returns the image data as an uint8array
     * @param image image to resize
     * @param bufferWidth destination buffer width
     * @param bufferHeight destination buffer height
     * @returns an uint8array containing RGBA values of bufferWidth * bufferHeight size
     */ resizeImageBitmap(image, bufferWidth, bufferHeight) {
        const canvas = this.createCanvas(bufferWidth, bufferHeight);
        const context = canvas.getContext("2d");
        if (!context) throw new Error("Unable to get 2d context for resizeImageBitmap");
        context.drawImage(image, 0, 0);
        // Create VertexData from map data
        // Cast is due to wrong definition in lib.d.ts from ts 1.3 - https://github.com/Microsoft/TypeScript/issues/949
        const buffer = context.getImageData(0, 0, bufferWidth, bufferHeight).data;
        return buffer;
    }
    /**
     * Will flag all materials in all scenes in all engines as dirty to trigger new shader compilation
     * @param flag defines which part of the materials must be marked as dirty
     * @param predicate defines a predicate used to filter which materials should be affected
     */ static MarkAllMaterialsAsDirty(flag, predicate) {
        for(let engineIndex = 0; engineIndex < $4592815ea2be2bed$export$2c3b404bf3a77a1f.Instances.length; engineIndex++){
            const engine = $4592815ea2be2bed$export$2c3b404bf3a77a1f.Instances[engineIndex];
            for(let sceneIndex = 0; sceneIndex < engine.scenes.length; sceneIndex++)engine.scenes[sceneIndex].markAllMaterialsAsDirty(flag, predicate);
        }
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Method called to create the default loading screen.
     * This can be overridden in your own app.
     * @param canvas The rendering canvas element
     * @returns The loading screen
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    static DefaultLoadingScreenFactory(canvas) {
        throw (0, $dUFYy._WarnImport)("LoadingScreen");
    }
    get _supportsHardwareTextureRescaling() {
        return !!$4592815ea2be2bed$export$2c3b404bf3a77a1f._RescalePostProcessFactory;
    }
    /**
     * Gets the performance monitor attached to this engine
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/optimize_your_scene#engineinstrumentation
     */ get performanceMonitor() {
        return this._performanceMonitor;
    }
    /**
     * (WebGPU only) True (default) to be in compatibility mode, meaning rendering all existing scenes without artifacts (same rendering than WebGL).
     * Setting the property to false will improve performances but may not work in some scenes if some precautions are not taken.
     * See https://doc.babylonjs.com/setup/support/webGPU/webGPUOptimization/webGPUNonCompatibilityMode for more details
     */ get compatibilityMode() {
        return this._compatibilityMode;
    }
    set compatibilityMode(mode) {
        // not supported in WebGL
        this._compatibilityMode = true;
    }
    // Events
    /**
     * Gets the HTML element used to attach event listeners
     * @returns a HTML element
     */ getInputElement() {
        return this._renderingCanvas;
    }
    /**
     * Creates a new engine
     * @param canvasOrContext defines the canvas or WebGL context to use for rendering. If you provide a WebGL context, Babylon.js will not hook events on the canvas (like pointers, keyboards, etc...) so no event observables will be available. This is mostly used when Babylon.js is used as a plugin on a system which already used the WebGL context
     * @param antialias defines enable antialiasing (default: false)
     * @param options defines further options to be sent to the getContext() function
     * @param adaptToDeviceRatio defines whether to adapt to the device's viewport characteristics (default: false)
     */ constructor(canvasOrContext, antialias, options, adaptToDeviceRatio = false){
        super(canvasOrContext, antialias, options, adaptToDeviceRatio);
        // Members
        /**
         * Gets or sets a boolean to enable/disable IndexedDB support and avoid XHR on .manifest
         **/ this.enableOfflineSupport = false;
        /**
         * Gets or sets a boolean to enable/disable checking manifest if IndexedDB support is enabled (js will always consider the database is up to date)
         **/ this.disableManifestCheck = false;
        /**
         * Gets or sets a boolean to enable/disable the context menu (right-click) from appearing on the main canvas
         */ this.disableContextMenu = true;
        /**
         * Gets the list of created scenes
         */ this.scenes = [];
        /** @internal */ this._virtualScenes = new Array();
        /**
         * Event raised when a new scene is created
         */ this.onNewSceneAddedObservable = new (0, $diGQf.Observable)();
        /**
         * Gets the list of created postprocesses
         */ this.postProcesses = [];
        /**
         * Gets a boolean indicating if the pointer is currently locked
         */ this.isPointerLock = false;
        // Observables
        /**
         * Observable event triggered each time the rendering canvas is resized
         */ this.onResizeObservable = new (0, $diGQf.Observable)();
        /**
         * Observable event triggered each time the canvas loses focus
         */ this.onCanvasBlurObservable = new (0, $diGQf.Observable)();
        /**
         * Observable event triggered each time the canvas gains focus
         */ this.onCanvasFocusObservable = new (0, $diGQf.Observable)();
        /**
         * Observable event triggered each time the canvas receives pointerout event
         */ this.onCanvasPointerOutObservable = new (0, $diGQf.Observable)();
        /**
         * Observable raised when the engine begins a new frame
         */ this.onBeginFrameObservable = new (0, $diGQf.Observable)();
        /**
         * If set, will be used to request the next animation frame for the render loop
         */ this.customAnimationFrameRequester = null;
        /**
         * Observable raised when the engine ends the current frame
         */ this.onEndFrameObservable = new (0, $diGQf.Observable)();
        /**
         * Observable raised when the engine is about to compile a shader
         */ this.onBeforeShaderCompilationObservable = new (0, $diGQf.Observable)();
        /**
         * Observable raised when the engine has just compiled a shader
         */ this.onAfterShaderCompilationObservable = new (0, $diGQf.Observable)();
        // Deterministic lockstepMaxSteps
        this._deterministicLockstep = false;
        this._lockstepMaxSteps = 4;
        this._timeStep = 1 / 60;
        // FPS
        this._fps = 60;
        this._deltaTime = 0;
        /** @internal */ this._drawCalls = new (0, $2Fclq.PerfCounter)();
        /** Gets or sets the tab index to set to the rendering canvas. 1 is the minimum value to set to be able to capture keyboard events */ this.canvasTabIndex = 1;
        /**
         * Turn this value on if you want to pause FPS computation when in background
         */ this.disablePerformanceMonitorInBackground = false;
        this._performanceMonitor = new (0, $aDymS.PerformanceMonitor)();
        this._compatibilityMode = true;
        /**
         * Gets or sets the current render pass id
         */ this.currentRenderPassId = 0;
        this._renderPassNames = [
            "main"
        ];
        $4592815ea2be2bed$export$2c3b404bf3a77a1f.Instances.push(this);
        if (!canvasOrContext) return;
        this._features.supportRenderPasses = true;
        options = this._creationOptions;
        if (canvasOrContext.getContext) {
            const canvas = canvasOrContext;
            this._sharedInit(canvas);
        }
    }
    _initGLContext() {
        super._initGLContext();
        this._rescalePostProcess = null;
    }
    /**
     * Shared initialization across engines types.
     * @param canvas The canvas associated with this instance of the engine.
     */ _sharedInit(canvas) {
        super._sharedInit(canvas);
        this._onCanvasFocus = ()=>{
            this.onCanvasFocusObservable.notifyObservers(this);
        };
        this._onCanvasBlur = ()=>{
            this.onCanvasBlurObservable.notifyObservers(this);
        };
        this._onCanvasContextMenu = (evt)=>{
            if (this.disableContextMenu) evt.preventDefault();
        };
        canvas.addEventListener("focus", this._onCanvasFocus);
        canvas.addEventListener("blur", this._onCanvasBlur);
        canvas.addEventListener("contextmenu", this._onCanvasContextMenu);
        this._onBlur = ()=>{
            if (this.disablePerformanceMonitorInBackground) this._performanceMonitor.disable();
            this._windowIsBackground = true;
        };
        this._onFocus = ()=>{
            if (this.disablePerformanceMonitorInBackground) this._performanceMonitor.enable();
            this._windowIsBackground = false;
        };
        this._onCanvasPointerOut = (ev)=>{
            // Check that the element at the point of the pointer out isn't the canvas and if it isn't, notify observers
            // Note: This is a workaround for a bug with Safari
            if (document.elementFromPoint(ev.clientX, ev.clientY) !== canvas) this.onCanvasPointerOutObservable.notifyObservers(ev);
        };
        const hostWindow = this.getHostWindow(); // it calls IsWindowObjectExist()
        if (hostWindow && typeof hostWindow.addEventListener === "function") {
            hostWindow.addEventListener("blur", this._onBlur);
            hostWindow.addEventListener("focus", this._onFocus);
        }
        canvas.addEventListener("pointerout", this._onCanvasPointerOut);
        if (!this._creationOptions.doNotHandleTouchAction) this._disableTouchAction();
        // Create Audio Engine if needed.
        if (!$4592815ea2be2bed$export$2c3b404bf3a77a1f.audioEngine && this._creationOptions.audioEngine && $4592815ea2be2bed$export$2c3b404bf3a77a1f.AudioEngineFactory) $4592815ea2be2bed$export$2c3b404bf3a77a1f.audioEngine = $4592815ea2be2bed$export$2c3b404bf3a77a1f.AudioEngineFactory(this.getRenderingCanvas(), this.getAudioContext(), this.getAudioDestination());
        if ((0, $jFz47.IsDocumentAvailable)()) {
            // Fullscreen
            this._onFullscreenChange = ()=>{
                this.isFullscreen = !!document.fullscreenElement;
                // Pointer lock
                if (this.isFullscreen && this._pointerLockRequested && canvas) $4592815ea2be2bed$export$2c3b404bf3a77a1f._RequestPointerlock(canvas);
            };
            document.addEventListener("fullscreenchange", this._onFullscreenChange, false);
            document.addEventListener("webkitfullscreenchange", this._onFullscreenChange, false);
            // Pointer lock
            this._onPointerLockChange = ()=>{
                this.isPointerLock = document.pointerLockElement === canvas;
            };
            document.addEventListener("pointerlockchange", this._onPointerLockChange, false);
            document.addEventListener("webkitpointerlockchange", this._onPointerLockChange, false);
        }
        this.enableOfflineSupport = $4592815ea2be2bed$export$2c3b404bf3a77a1f.OfflineProviderFactory !== undefined;
        this._deterministicLockstep = !!this._creationOptions.deterministicLockstep;
        this._lockstepMaxSteps = this._creationOptions.lockstepMaxSteps || 0;
        this._timeStep = this._creationOptions.timeStep || 1 / 60;
    }
    /** @internal */ _verifyPointerLock() {
        this._onPointerLockChange?.();
    }
    /**
     * Gets current aspect ratio
     * @param viewportOwner defines the camera to use to get the aspect ratio
     * @param useScreen defines if screen size must be used (or the current render target if any)
     * @returns a number defining the aspect ratio
     */ getAspectRatio(viewportOwner, useScreen = false) {
        const viewport = viewportOwner.viewport;
        return this.getRenderWidth(useScreen) * viewport.width / (this.getRenderHeight(useScreen) * viewport.height);
    }
    /**
     * Gets current screen aspect ratio
     * @returns a number defining the aspect ratio
     */ getScreenAspectRatio() {
        return this.getRenderWidth(true) / this.getRenderHeight(true);
    }
    /**
     * Gets the client rect of the HTML canvas attached with the current webGL context
     * @returns a client rectangle
     */ getRenderingCanvasClientRect() {
        if (!this._renderingCanvas) return null;
        return this._renderingCanvas.getBoundingClientRect();
    }
    /**
     * Gets the client rect of the HTML element used for events
     * @returns a client rectangle
     */ getInputElementClientRect() {
        if (!this._renderingCanvas) return null;
        return this.getInputElement().getBoundingClientRect();
    }
    /**
     * Gets a boolean indicating that the engine is running in deterministic lock step mode
     * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#deterministic-lockstep
     * @returns true if engine is in deterministic lock step mode
     */ isDeterministicLockStep() {
        return this._deterministicLockstep;
    }
    /**
     * Gets the max steps when engine is running in deterministic lock step
     * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#deterministic-lockstep
     * @returns the max steps
     */ getLockstepMaxSteps() {
        return this._lockstepMaxSteps;
    }
    /**
     * Returns the time in ms between steps when using deterministic lock step.
     * @returns time step in (ms)
     */ getTimeStep() {
        return this._timeStep * 1000;
    }
    /**
     * Force the mipmap generation for the given render target texture
     * @param texture defines the render target texture to use
     * @param unbind defines whether or not to unbind the texture after generation. Defaults to true.
     */ generateMipMapsForCubemap(texture, unbind = true) {
        if (texture.generateMipMaps) {
            const gl = this._gl;
            this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, texture, true);
            gl.generateMipmap(gl.TEXTURE_CUBE_MAP);
            if (unbind) this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, null);
        }
    }
    /** States */ /**
     * Gets a boolean indicating if depth writing is enabled
     * @returns the current depth writing state
     */ getDepthWrite() {
        return this._depthCullingState.depthMask;
    }
    /**
     * Enable or disable depth writing
     * @param enable defines the state to set
     */ setDepthWrite(enable) {
        this._depthCullingState.depthMask = enable;
    }
    /**
     * Gets a boolean indicating if stencil buffer is enabled
     * @returns the current stencil buffer state
     */ getStencilBuffer() {
        return this._stencilState.stencilTest;
    }
    /**
     * Enable or disable the stencil buffer
     * @param enable defines if the stencil buffer must be enabled or disabled
     */ setStencilBuffer(enable) {
        this._stencilState.stencilTest = enable;
    }
    /**
     * Gets the current stencil mask
     * @returns a number defining the new stencil mask to use
     */ getStencilMask() {
        return this._stencilState.stencilMask;
    }
    /**
     * Sets the current stencil mask
     * @param mask defines the new stencil mask to use
     */ setStencilMask(mask) {
        this._stencilState.stencilMask = mask;
    }
    /**
     * Gets the current stencil function
     * @returns a number defining the stencil function to use
     */ getStencilFunction() {
        return this._stencilState.stencilFunc;
    }
    /**
     * Gets the current stencil reference value
     * @returns a number defining the stencil reference value to use
     */ getStencilFunctionReference() {
        return this._stencilState.stencilFuncRef;
    }
    /**
     * Gets the current stencil mask
     * @returns a number defining the stencil mask to use
     */ getStencilFunctionMask() {
        return this._stencilState.stencilFuncMask;
    }
    /**
     * Sets the current stencil function
     * @param stencilFunc defines the new stencil function to use
     */ setStencilFunction(stencilFunc) {
        this._stencilState.stencilFunc = stencilFunc;
    }
    /**
     * Sets the current stencil reference
     * @param reference defines the new stencil reference to use
     */ setStencilFunctionReference(reference) {
        this._stencilState.stencilFuncRef = reference;
    }
    /**
     * Sets the current stencil mask
     * @param mask defines the new stencil mask to use
     */ setStencilFunctionMask(mask) {
        this._stencilState.stencilFuncMask = mask;
    }
    /**
     * Gets the current stencil operation when stencil fails
     * @returns a number defining stencil operation to use when stencil fails
     */ getStencilOperationFail() {
        return this._stencilState.stencilOpStencilFail;
    }
    /**
     * Gets the current stencil operation when depth fails
     * @returns a number defining stencil operation to use when depth fails
     */ getStencilOperationDepthFail() {
        return this._stencilState.stencilOpDepthFail;
    }
    /**
     * Gets the current stencil operation when stencil passes
     * @returns a number defining stencil operation to use when stencil passes
     */ getStencilOperationPass() {
        return this._stencilState.stencilOpStencilDepthPass;
    }
    /**
     * Sets the stencil operation to use when stencil fails
     * @param operation defines the stencil operation to use when stencil fails
     */ setStencilOperationFail(operation) {
        this._stencilState.stencilOpStencilFail = operation;
    }
    /**
     * Sets the stencil operation to use when depth fails
     * @param operation defines the stencil operation to use when depth fails
     */ setStencilOperationDepthFail(operation) {
        this._stencilState.stencilOpDepthFail = operation;
    }
    /**
     * Sets the stencil operation to use when stencil passes
     * @param operation defines the stencil operation to use when stencil passes
     */ setStencilOperationPass(operation) {
        this._stencilState.stencilOpStencilDepthPass = operation;
    }
    /**
     * Sets a boolean indicating if the dithering state is enabled or disabled
     * @param value defines the dithering state
     */ setDitheringState(value) {
        if (value) this._gl.enable(this._gl.DITHER);
        else this._gl.disable(this._gl.DITHER);
    }
    /**
     * Sets a boolean indicating if the rasterizer state is enabled or disabled
     * @param value defines the rasterizer state
     */ setRasterizerState(value) {
        if (value) this._gl.disable(this._gl.RASTERIZER_DISCARD);
        else this._gl.enable(this._gl.RASTERIZER_DISCARD);
    }
    /**
     * Gets the current depth function
     * @returns a number defining the depth function
     */ getDepthFunction() {
        return this._depthCullingState.depthFunc;
    }
    /**
     * Sets the current depth function
     * @param depthFunc defines the function to use
     */ setDepthFunction(depthFunc) {
        this._depthCullingState.depthFunc = depthFunc;
    }
    /**
     * Sets the current depth function to GREATER
     */ setDepthFunctionToGreater() {
        this.setDepthFunction(516);
    }
    /**
     * Sets the current depth function to GEQUAL
     */ setDepthFunctionToGreaterOrEqual() {
        this.setDepthFunction(518);
    }
    /**
     * Sets the current depth function to LESS
     */ setDepthFunctionToLess() {
        this.setDepthFunction(513);
    }
    /**
     * Sets the current depth function to LEQUAL
     */ setDepthFunctionToLessOrEqual() {
        this.setDepthFunction(515);
    }
    /**
     * Caches the state of the stencil buffer
     */ cacheStencilState() {
        this._cachedStencilBuffer = this.getStencilBuffer();
        this._cachedStencilFunction = this.getStencilFunction();
        this._cachedStencilMask = this.getStencilMask();
        this._cachedStencilOperationPass = this.getStencilOperationPass();
        this._cachedStencilOperationFail = this.getStencilOperationFail();
        this._cachedStencilOperationDepthFail = this.getStencilOperationDepthFail();
        this._cachedStencilReference = this.getStencilFunctionReference();
    }
    /**
     * Restores the state of the stencil buffer
     */ restoreStencilState() {
        this.setStencilFunction(this._cachedStencilFunction);
        this.setStencilMask(this._cachedStencilMask);
        this.setStencilBuffer(this._cachedStencilBuffer);
        this.setStencilOperationPass(this._cachedStencilOperationPass);
        this.setStencilOperationFail(this._cachedStencilOperationFail);
        this.setStencilOperationDepthFail(this._cachedStencilOperationDepthFail);
        this.setStencilFunctionReference(this._cachedStencilReference);
    }
    /**
     * Directly set the WebGL Viewport
     * @param x defines the x coordinate of the viewport (in screen space)
     * @param y defines the y coordinate of the viewport (in screen space)
     * @param width defines the width of the viewport (in screen space)
     * @param height defines the height of the viewport (in screen space)
     * @returns the current viewport Object (if any) that is being replaced by this call. You can restore this viewport later on to go back to the original state
     */ setDirectViewport(x, y, width, height) {
        const currentViewport = this._cachedViewport;
        this._cachedViewport = null;
        this._viewport(x, y, width, height);
        return currentViewport;
    }
    /**
     * Executes a scissor clear (ie. a clear on a specific portion of the screen)
     * @param x defines the x-coordinate of the bottom left corner of the clear rectangle
     * @param y defines the y-coordinate of the corner of the clear rectangle
     * @param width defines the width of the clear rectangle
     * @param height defines the height of the clear rectangle
     * @param clearColor defines the clear color
     */ scissorClear(x, y, width, height, clearColor) {
        this.enableScissor(x, y, width, height);
        this.clear(clearColor, true, true, true);
        this.disableScissor();
    }
    /**
     * Enable scissor test on a specific rectangle (ie. render will only be executed on a specific portion of the screen)
     * @param x defines the x-coordinate of the bottom left corner of the clear rectangle
     * @param y defines the y-coordinate of the corner of the clear rectangle
     * @param width defines the width of the clear rectangle
     * @param height defines the height of the clear rectangle
     */ enableScissor(x, y, width, height) {
        const gl = this._gl;
        // Change state
        gl.enable(gl.SCISSOR_TEST);
        gl.scissor(x, y, width, height);
    }
    /**
     * Disable previously set scissor test rectangle
     */ disableScissor() {
        const gl = this._gl;
        gl.disable(gl.SCISSOR_TEST);
    }
    /**
     * @internal
     */ _reportDrawCall(numDrawCalls = 1) {
        this._drawCalls.addCount(numDrawCalls, false);
    }
    /**
     * @internal
     */ _loadFileAsync(url, offlineProvider, useArrayBuffer) {
        return new Promise((resolve, reject)=>{
            this._loadFile(url, (data)=>{
                resolve(data);
            }, undefined, offlineProvider, useArrayBuffer, (request, exception)=>{
                reject(exception);
            });
        });
    }
    /**
     * Gets the source code of the vertex shader associated with a specific webGL program
     * @param program defines the program to use
     * @returns a string containing the source code of the vertex shader associated with the program
     */ getVertexShaderSource(program) {
        const shaders = this._gl.getAttachedShaders(program);
        if (!shaders) return null;
        return this._gl.getShaderSource(shaders[0]);
    }
    /**
     * Gets the source code of the fragment shader associated with a specific webGL program
     * @param program defines the program to use
     * @returns a string containing the source code of the fragment shader associated with the program
     */ getFragmentShaderSource(program) {
        const shaders = this._gl.getAttachedShaders(program);
        if (!shaders) return null;
        return this._gl.getShaderSource(shaders[1]);
    }
    /**
     * Sets a depth stencil texture from a render target to the according uniform.
     * @param channel The texture channel
     * @param uniform The uniform to set
     * @param texture The render target texture containing the depth stencil texture to apply
     * @param name The texture name
     */ setDepthStencilTexture(channel, uniform, texture, name) {
        if (channel === undefined) return;
        if (uniform) this._boundUniforms[channel] = uniform;
        if (!texture || !texture.depthStencilTexture) this._setTexture(channel, null, undefined, undefined, name);
        else this._setTexture(channel, texture, false, true, name);
    }
    /**
     * Sets a texture to the webGL context from a postprocess
     * @param channel defines the channel to use
     * @param postProcess defines the source postprocess
     * @param name name of the channel
     */ setTextureFromPostProcess(channel, postProcess, name) {
        let postProcessInput = null;
        if (postProcess) {
            if (postProcess._forcedOutputTexture) postProcessInput = postProcess._forcedOutputTexture;
            else if (postProcess._textures.data[postProcess._currentRenderTextureInd]) postProcessInput = postProcess._textures.data[postProcess._currentRenderTextureInd];
        }
        this._bindTexture(channel, postProcessInput?.texture ?? null, name);
    }
    /**
     * Binds the output of the passed in post process to the texture channel specified
     * @param channel The channel the texture should be bound to
     * @param postProcess The post process which's output should be bound
     * @param name name of the channel
     */ setTextureFromPostProcessOutput(channel, postProcess, name) {
        this._bindTexture(channel, postProcess?._outputTexture?.texture ?? null, name);
    }
    /**
     * sets the object from which width and height will be taken from when getting render width and height
     * Will fallback to the gl object
     * @param dimensions the framebuffer width and height that will be used.
     */ set framebufferDimensionsObject(dimensions) {
        this._framebufferDimensionsObject = dimensions;
        if (this._framebufferDimensionsObject) this.onResizeObservable.notifyObservers(this);
    }
    _rebuildBuffers() {
        // Index / Vertex
        for (const scene of this.scenes){
            scene.resetCachedMaterial();
            scene._rebuildGeometries();
        }
        for (const scene of this._virtualScenes){
            scene.resetCachedMaterial();
            scene._rebuildGeometries();
        }
        super._rebuildBuffers();
    }
    _rebuildTextures() {
        for (const scene of this.scenes)scene._rebuildTextures();
        for (const scene of this._virtualScenes)scene._rebuildTextures();
        super._rebuildTextures();
    }
    /** @internal */ _renderFrame() {
        for(let index = 0; index < this._activeRenderLoops.length; index++){
            const renderFunction = this._activeRenderLoops[index];
            renderFunction();
        }
    }
    _cancelFrame() {
        if (this.customAnimationFrameRequester) {
            if (this._frameHandler !== 0) {
                this._frameHandler = 0;
                const { cancelAnimationFrame: cancelAnimationFrame } = this.customAnimationFrameRequester;
                if (cancelAnimationFrame) cancelAnimationFrame(this.customAnimationFrameRequester.requestID);
            }
        } else super._cancelFrame();
    }
    _renderLoop() {
        this._frameHandler = 0;
        if (!this._contextWasLost) {
            let shouldRender = true;
            if (this.isDisposed || !this.renderEvenInBackground && this._windowIsBackground) shouldRender = false;
            if (shouldRender) {
                // Start new frame
                this.beginFrame();
                // Child canvases
                if (!this._renderViews()) // Main frame
                this._renderFrame();
                // Present
                this.endFrame();
            }
        }
        if (this._frameHandler === 0) {
            // Register new frame
            if (this.customAnimationFrameRequester) {
                this.customAnimationFrameRequester.requestID = this._queueNewFrame(this.customAnimationFrameRequester.renderFunction || this._boundRenderFunction, this.customAnimationFrameRequester);
                this._frameHandler = this.customAnimationFrameRequester.requestID;
            } else this._frameHandler = this._queueNewFrame(this._boundRenderFunction, this.getHostWindow());
        }
    }
    /** @internal */ _renderViews() {
        return false;
    }
    /**
     * Toggle full screen mode
     * @param requestPointerLock defines if a pointer lock should be requested from the user
     */ switchFullscreen(requestPointerLock) {
        if (this.isFullscreen) this.exitFullscreen();
        else this.enterFullscreen(requestPointerLock);
    }
    /**
     * Enters full screen mode
     * @param requestPointerLock defines if a pointer lock should be requested from the user
     */ enterFullscreen(requestPointerLock) {
        if (!this.isFullscreen) {
            this._pointerLockRequested = requestPointerLock;
            if (this._renderingCanvas) $4592815ea2be2bed$export$2c3b404bf3a77a1f._RequestFullscreen(this._renderingCanvas);
        }
    }
    /**
     * Exits full screen mode
     */ exitFullscreen() {
        if (this.isFullscreen) $4592815ea2be2bed$export$2c3b404bf3a77a1f._ExitFullscreen();
    }
    /**
     * Enters Pointerlock mode
     */ enterPointerlock() {
        if (this._renderingCanvas) $4592815ea2be2bed$export$2c3b404bf3a77a1f._RequestPointerlock(this._renderingCanvas);
    }
    /**
     * Exits Pointerlock mode
     */ exitPointerlock() {
        $4592815ea2be2bed$export$2c3b404bf3a77a1f._ExitPointerlock();
    }
    /**
     * Begin a new frame
     */ beginFrame() {
        this._measureFps();
        this.onBeginFrameObservable.notifyObservers(this);
        super.beginFrame();
    }
    /**
     * End the current frame
     */ endFrame() {
        super.endFrame();
        this.onEndFrameObservable.notifyObservers(this);
    }
    /**
     * Force a specific size of the canvas
     * @param width defines the new canvas' width
     * @param height defines the new canvas' height
     * @param forceSetSize true to force setting the sizes of the underlying canvas
     * @returns true if the size was changed
     */ setSize(width, height, forceSetSize = false) {
        if (!this._renderingCanvas) return false;
        if (!super.setSize(width, height, forceSetSize)) return false;
        if (this.scenes) {
            for(let index = 0; index < this.scenes.length; index++){
                const scene = this.scenes[index];
                for(let camIndex = 0; camIndex < scene.cameras.length; camIndex++){
                    const cam = scene.cameras[camIndex];
                    cam._currentRenderId = 0;
                }
            }
            if (this.onResizeObservable.hasObservers()) this.onResizeObservable.notifyObservers(this);
        }
        return true;
    }
    _deletePipelineContext(pipelineContext) {
        const webGLPipelineContext = pipelineContext;
        if (webGLPipelineContext && webGLPipelineContext.program) {
            if (webGLPipelineContext.transformFeedback) {
                this.deleteTransformFeedback(webGLPipelineContext.transformFeedback);
                webGLPipelineContext.transformFeedback = null;
            }
        }
        super._deletePipelineContext(pipelineContext);
    }
    createShaderProgram(pipelineContext, vertexCode, fragmentCode, defines, context, transformFeedbackVaryings = null) {
        context = context || this._gl;
        this.onBeforeShaderCompilationObservable.notifyObservers(this);
        const program = super.createShaderProgram(pipelineContext, vertexCode, fragmentCode, defines, context, transformFeedbackVaryings);
        this.onAfterShaderCompilationObservable.notifyObservers(this);
        return program;
    }
    _createShaderProgram(pipelineContext, vertexShader, fragmentShader, context, transformFeedbackVaryings = null) {
        const shaderProgram = context.createProgram();
        pipelineContext.program = shaderProgram;
        if (!shaderProgram) throw new Error("Unable to create program");
        context.attachShader(shaderProgram, vertexShader);
        context.attachShader(shaderProgram, fragmentShader);
        if (this.webGLVersion > 1 && transformFeedbackVaryings) {
            const transformFeedback = this.createTransformFeedback();
            this.bindTransformFeedback(transformFeedback);
            this.setTranformFeedbackVaryings(shaderProgram, transformFeedbackVaryings);
            pipelineContext.transformFeedback = transformFeedback;
        }
        context.linkProgram(shaderProgram);
        if (this.webGLVersion > 1 && transformFeedbackVaryings) this.bindTransformFeedback(null);
        pipelineContext.context = context;
        pipelineContext.vertexShader = vertexShader;
        pipelineContext.fragmentShader = fragmentShader;
        if (!pipelineContext.isParallelCompiled) this._finalizePipelineContext(pipelineContext);
        return shaderProgram;
    }
    /**
     * @internal
     */ _releaseTexture(texture) {
        super._releaseTexture(texture);
    }
    /**
     * @internal
     */ _releaseRenderTargetWrapper(rtWrapper) {
        super._releaseRenderTargetWrapper(rtWrapper);
        // Set output texture of post process to null if the framebuffer has been released/disposed
        this.scenes.forEach((scene)=>{
            scene.postProcesses.forEach((postProcess)=>{
                if (postProcess._outputTexture === rtWrapper) postProcess._outputTexture = null;
            });
            scene.cameras.forEach((camera)=>{
                camera._postProcesses.forEach((postProcess)=>{
                    if (postProcess) {
                        if (postProcess._outputTexture === rtWrapper) postProcess._outputTexture = null;
                    }
                });
            });
        });
    }
    /**
     * Gets the names of the render passes that are currently created
     * @returns list of the render pass names
     */ getRenderPassNames() {
        return this._renderPassNames;
    }
    /**
     * Gets the name of the current render pass
     * @returns name of the current render pass
     */ getCurrentRenderPassName() {
        return this._renderPassNames[this.currentRenderPassId];
    }
    /**
     * Creates a render pass id
     * @param name Name of the render pass (for debug purpose only)
     * @returns the id of the new render pass
     */ createRenderPassId(name) {
        // Note: render pass id == 0 is always for the main render pass
        const id = ++$4592815ea2be2bed$export$2c3b404bf3a77a1f._RenderPassIdCounter;
        this._renderPassNames[id] = name ?? "NONAME";
        return id;
    }
    /**
     * Releases a render pass id
     * @param id id of the render pass to release
     */ releaseRenderPassId(id) {
        this._renderPassNames[id] = undefined;
        for(let s = 0; s < this.scenes.length; ++s){
            const scene = this.scenes[s];
            for(let m = 0; m < scene.meshes.length; ++m){
                const mesh = scene.meshes[m];
                if (mesh.subMeshes) for(let b = 0; b < mesh.subMeshes.length; ++b){
                    const subMesh = mesh.subMeshes[b];
                    subMesh._removeDrawWrapper(id);
                }
            }
        }
    }
    /**
     * @internal
     * Rescales a texture
     * @param source input texture
     * @param destination destination texture
     * @param scene scene to use to render the resize
     * @param internalFormat format to use when resizing
     * @param onComplete callback to be called when resize has completed
     */ _rescaleTexture(source, destination, scene, internalFormat, onComplete) {
        this._gl.texParameteri(this._gl.TEXTURE_2D, this._gl.TEXTURE_MAG_FILTER, this._gl.LINEAR);
        this._gl.texParameteri(this._gl.TEXTURE_2D, this._gl.TEXTURE_MIN_FILTER, this._gl.LINEAR);
        this._gl.texParameteri(this._gl.TEXTURE_2D, this._gl.TEXTURE_WRAP_S, this._gl.CLAMP_TO_EDGE);
        this._gl.texParameteri(this._gl.TEXTURE_2D, this._gl.TEXTURE_WRAP_T, this._gl.CLAMP_TO_EDGE);
        const rtt = this.createRenderTargetTexture({
            width: destination.width,
            height: destination.height
        }, {
            generateMipMaps: false,
            type: 0,
            samplingMode: 2,
            generateDepthBuffer: false,
            generateStencilBuffer: false
        });
        if (!this._rescalePostProcess && $4592815ea2be2bed$export$2c3b404bf3a77a1f._RescalePostProcessFactory) this._rescalePostProcess = $4592815ea2be2bed$export$2c3b404bf3a77a1f._RescalePostProcessFactory(this);
        if (this._rescalePostProcess) {
            this._rescalePostProcess.externalTextureSamplerBinding = true;
            this._rescalePostProcess.getEffect().executeWhenCompiled(()=>{
                this._rescalePostProcess.onApply = function(effect) {
                    effect._bindTexture("textureSampler", source);
                };
                let hostingScene = scene;
                if (!hostingScene) hostingScene = this.scenes[this.scenes.length - 1];
                hostingScene.postProcessManager.directRender([
                    this._rescalePostProcess
                ], rtt, true);
                this._bindTextureDirectly(this._gl.TEXTURE_2D, destination, true);
                this._gl.copyTexImage2D(this._gl.TEXTURE_2D, 0, internalFormat, 0, 0, destination.width, destination.height, 0);
                this.unBindFramebuffer(rtt);
                rtt.dispose();
                if (onComplete) onComplete();
            });
        }
    }
    // FPS
    /**
     * Gets the current framerate
     * @returns a number representing the framerate
     */ getFps() {
        return this._fps;
    }
    /**
     * Gets the time spent between current and previous frame
     * @returns a number representing the delta time in ms
     */ getDeltaTime() {
        return this._deltaTime;
    }
    _measureFps() {
        this._performanceMonitor.sampleFrame();
        this._fps = this._performanceMonitor.averageFPS;
        this._deltaTime = this._performanceMonitor.instantaneousFrameTime || 0;
    }
    /**
     * Wraps an external web gl texture in a Babylon texture.
     * @param texture defines the external texture
     * @param hasMipMaps defines whether the external texture has mip maps (default: false)
     * @param samplingMode defines the sampling mode for the external texture (default: 3)
     * @param width defines the width for the external texture (default: 0)
     * @param height defines the height for the external texture (default: 0)
     * @returns the babylon internal texture
     */ wrapWebGLTexture(texture, hasMipMaps = false, samplingMode = 3, width = 0, height = 0) {
        const hardwareTexture = new (0, $8ClRi.WebGLHardwareTexture)(texture, this._gl);
        const internalTexture = new (0, $b9e4a.InternalTexture)(this, (0, $b9e4a.InternalTextureSource).Unknown, true);
        internalTexture._hardwareTexture = hardwareTexture;
        internalTexture.baseWidth = width;
        internalTexture.baseHeight = height;
        internalTexture.width = width;
        internalTexture.height = height;
        internalTexture.isReady = true;
        internalTexture.useMipMaps = hasMipMaps;
        this.updateTextureSamplingMode(samplingMode, internalTexture);
        return internalTexture;
    }
    /**
     * @internal
     */ _uploadImageToTexture(texture, image, faceIndex = 0, lod = 0) {
        const gl = this._gl;
        const textureType = this._getWebGLTextureType(texture.type);
        const format = this._getInternalFormat(texture.format);
        const internalFormat = this._getRGBABufferInternalSizedFormat(texture.type, format);
        const bindTarget = texture.isCube ? gl.TEXTURE_CUBE_MAP : gl.TEXTURE_2D;
        this._bindTextureDirectly(bindTarget, texture, true);
        this._unpackFlipY(texture.invertY);
        let target = gl.TEXTURE_2D;
        if (texture.isCube) target = gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex;
        gl.texImage2D(target, lod, internalFormat, format, textureType, image);
        this._bindTextureDirectly(bindTarget, null, true);
    }
    /**
     * Updates a depth texture Comparison Mode and Function.
     * If the comparison Function is equal to 0, the mode will be set to none.
     * Otherwise, this only works in webgl 2 and requires a shadow sampler in the shader.
     * @param texture The texture to set the comparison function for
     * @param comparisonFunction The comparison function to set, 0 if no comparison required
     */ updateTextureComparisonFunction(texture, comparisonFunction) {
        if (this.webGLVersion === 1) {
            (0, $kVtWi.Logger).Error("WebGL 1 does not support texture comparison.");
            return;
        }
        const gl = this._gl;
        if (texture.isCube) {
            this._bindTextureDirectly(this._gl.TEXTURE_CUBE_MAP, texture, true);
            if (comparisonFunction === 0) {
                gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_COMPARE_FUNC, 515);
                gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_COMPARE_MODE, gl.NONE);
            } else {
                gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_COMPARE_FUNC, comparisonFunction);
                gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_COMPARE_MODE, gl.COMPARE_REF_TO_TEXTURE);
            }
            this._bindTextureDirectly(this._gl.TEXTURE_CUBE_MAP, null);
        } else {
            this._bindTextureDirectly(this._gl.TEXTURE_2D, texture, true);
            if (comparisonFunction === 0) {
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_COMPARE_FUNC, 515);
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_COMPARE_MODE, gl.NONE);
            } else {
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_COMPARE_FUNC, comparisonFunction);
                gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_COMPARE_MODE, gl.COMPARE_REF_TO_TEXTURE);
            }
            this._bindTextureDirectly(this._gl.TEXTURE_2D, null);
        }
        texture._comparisonFunction = comparisonFunction;
    }
    /**
     * Creates a webGL buffer to use with instantiation
     * @param capacity defines the size of the buffer
     * @returns the webGL buffer
     */ createInstancesBuffer(capacity) {
        const buffer = this._gl.createBuffer();
        if (!buffer) throw new Error("Unable to create instance buffer");
        const result = new (0, $koExS.WebGLDataBuffer)(buffer);
        result.capacity = capacity;
        this.bindArrayBuffer(result);
        this._gl.bufferData(this._gl.ARRAY_BUFFER, capacity, this._gl.DYNAMIC_DRAW);
        result.references = 1;
        return result;
    }
    /**
     * Delete a webGL buffer used with instantiation
     * @param buffer defines the webGL buffer to delete
     */ deleteInstancesBuffer(buffer) {
        this._gl.deleteBuffer(buffer);
    }
    _clientWaitAsync(sync, flags = 0, intervalms = 10) {
        const gl = this._gl;
        return new Promise((resolve, reject)=>{
            const check = ()=>{
                const res = gl.clientWaitSync(sync, flags, 0);
                if (res == gl.WAIT_FAILED) {
                    reject();
                    return;
                }
                if (res == gl.TIMEOUT_EXPIRED) {
                    setTimeout(check, intervalms);
                    return;
                }
                resolve();
            };
            check();
        });
    }
    /**
     * @internal
     */ _readPixelsAsync(x, y, w, h, format, type, outputBuffer) {
        if (this._webGLVersion < 2) throw new Error("_readPixelsAsync only work on WebGL2+");
        const gl = this._gl;
        const buf = gl.createBuffer();
        gl.bindBuffer(gl.PIXEL_PACK_BUFFER, buf);
        gl.bufferData(gl.PIXEL_PACK_BUFFER, outputBuffer.byteLength, gl.STREAM_READ);
        gl.readPixels(x, y, w, h, format, type, 0);
        gl.bindBuffer(gl.PIXEL_PACK_BUFFER, null);
        const sync = gl.fenceSync(gl.SYNC_GPU_COMMANDS_COMPLETE, 0);
        if (!sync) return null;
        gl.flush();
        return this._clientWaitAsync(sync, 0, 10).then(()=>{
            gl.deleteSync(sync);
            gl.bindBuffer(gl.PIXEL_PACK_BUFFER, buf);
            gl.getBufferSubData(gl.PIXEL_PACK_BUFFER, 0, outputBuffer);
            gl.bindBuffer(gl.PIXEL_PACK_BUFFER, null);
            gl.deleteBuffer(buf);
            return outputBuffer;
        });
    }
    dispose() {
        this.hideLoadingUI();
        this.onNewSceneAddedObservable.clear();
        // Release postProcesses
        while(this.postProcesses.length)this.postProcesses[0].dispose();
        // Rescale PP
        if (this._rescalePostProcess) this._rescalePostProcess.dispose();
        // Release scenes
        while(this.scenes.length)this.scenes[0].dispose();
        while(this._virtualScenes.length)this._virtualScenes[0].dispose();
        // Release audio engine
        if ((0, $ejQPp.EngineStore).Instances.length === 1 && $4592815ea2be2bed$export$2c3b404bf3a77a1f.audioEngine) {
            $4592815ea2be2bed$export$2c3b404bf3a77a1f.audioEngine.dispose();
            $4592815ea2be2bed$export$2c3b404bf3a77a1f.audioEngine = null;
        }
        // Events
        const hostWindow = this.getHostWindow(); // it calls IsWindowObjectExist()
        if (hostWindow && typeof hostWindow.removeEventListener === "function") {
            hostWindow.removeEventListener("blur", this._onBlur);
            hostWindow.removeEventListener("focus", this._onFocus);
        }
        if (this._renderingCanvas) {
            this._renderingCanvas.removeEventListener("focus", this._onCanvasFocus);
            this._renderingCanvas.removeEventListener("blur", this._onCanvasBlur);
            this._renderingCanvas.removeEventListener("pointerout", this._onCanvasPointerOut);
            this._renderingCanvas.removeEventListener("contextmenu", this._onCanvasContextMenu);
        }
        if ((0, $jFz47.IsDocumentAvailable)()) {
            document.removeEventListener("fullscreenchange", this._onFullscreenChange);
            document.removeEventListener("mozfullscreenchange", this._onFullscreenChange);
            document.removeEventListener("webkitfullscreenchange", this._onFullscreenChange);
            document.removeEventListener("msfullscreenchange", this._onFullscreenChange);
            document.removeEventListener("pointerlockchange", this._onPointerLockChange);
            document.removeEventListener("mspointerlockchange", this._onPointerLockChange);
            document.removeEventListener("mozpointerlockchange", this._onPointerLockChange);
            document.removeEventListener("webkitpointerlockchange", this._onPointerLockChange);
        }
        super.dispose();
        // Remove from Instances
        const index = (0, $ejQPp.EngineStore).Instances.indexOf(this);
        if (index >= 0) (0, $ejQPp.EngineStore).Instances.splice(index, 1);
        // no more engines left in the engine store? Notify!
        if (!$4592815ea2be2bed$export$2c3b404bf3a77a1f.Instances.length) (0, $ejQPp.EngineStore).OnEnginesDisposedObservable.notifyObservers(this);
        // Observables
        this.onResizeObservable.clear();
        this.onCanvasBlurObservable.clear();
        this.onCanvasFocusObservable.clear();
        this.onCanvasPointerOutObservable.clear();
        this.onBeginFrameObservable.clear();
        this.onEndFrameObservable.clear();
    }
    _disableTouchAction() {
        if (!this._renderingCanvas || !this._renderingCanvas.setAttribute) return;
        this._renderingCanvas.setAttribute("touch-action", "none");
        this._renderingCanvas.style.touchAction = "none";
        this._renderingCanvas.style.webkitTapHighlightColor = "transparent";
    }
    // Loading screen
    /**
     * Display the loading screen
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/customLoadingScreen
     */ displayLoadingUI() {
        if (!(0, $jFz47.IsWindowObjectExist)()) return;
        const loadingScreen = this.loadingScreen;
        if (loadingScreen) loadingScreen.displayLoadingUI();
    }
    /**
     * Hide the loading screen
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/customLoadingScreen
     */ hideLoadingUI() {
        if (!(0, $jFz47.IsWindowObjectExist)()) return;
        const loadingScreen = this._loadingScreen;
        if (loadingScreen) loadingScreen.hideLoadingUI();
    }
    /**
     * Gets the current loading screen object
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/customLoadingScreen
     */ get loadingScreen() {
        if (!this._loadingScreen && this._renderingCanvas) this._loadingScreen = $4592815ea2be2bed$export$2c3b404bf3a77a1f.DefaultLoadingScreenFactory(this._renderingCanvas);
        return this._loadingScreen;
    }
    /**
     * Sets the current loading screen object
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/customLoadingScreen
     */ set loadingScreen(loadingScreen) {
        this._loadingScreen = loadingScreen;
    }
    /**
     * Sets the current loading screen text
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/customLoadingScreen
     */ set loadingUIText(text) {
        this.loadingScreen.loadingUIText = text;
    }
    /**
     * Sets the current loading screen background color
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/customLoadingScreen
     */ set loadingUIBackgroundColor(color) {
        this.loadingScreen.loadingUIBackgroundColor = color;
    }
    /**
     * creates and returns a new video element
     * @param constraints video constraints
     * @returns video element
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    createVideoElement(constraints) {
        return document.createElement("video");
    }
    /** Pointerlock and fullscreen */ /**
     * Ask the browser to promote the current element to pointerlock mode
     * @param element defines the DOM element to promote
     */ static _RequestPointerlock(element) {
        if (element.requestPointerLock) {
            // In some browsers, requestPointerLock returns a promise.
            // Handle possible rejections to avoid an unhandled top-level exception.
            const promise = element.requestPointerLock();
            if (promise instanceof Promise) promise.then(()=>{
                element.focus();
            }).catch(()=>{});
            else element.focus();
        }
    }
    /**
     * Asks the browser to exit pointerlock mode
     */ static _ExitPointerlock() {
        if (document.exitPointerLock) document.exitPointerLock();
    }
    /**
     * Ask the browser to promote the current element to fullscreen rendering mode
     * @param element defines the DOM element to promote
     */ static _RequestFullscreen(element) {
        const requestFunction = element.requestFullscreen || element.webkitRequestFullscreen;
        if (!requestFunction) return;
        requestFunction.call(element);
    }
    /**
     * Asks the browser to exit fullscreen mode
     */ static _ExitFullscreen() {
        const anyDoc = document;
        if (document.exitFullscreen) document.exitFullscreen();
        else if (anyDoc.webkitCancelFullScreen) anyDoc.webkitCancelFullScreen();
    }
    /**
     * Get Font size information
     * @param font font name
     * @returns an object containing ascent, height and descent
     */ getFontOffset(font) {
        const text = document.createElement("span");
        text.innerHTML = "Hg";
        text.setAttribute("style", `font: ${font} !important`);
        const block = document.createElement("div");
        block.style.display = "inline-block";
        block.style.width = "1px";
        block.style.height = "0px";
        block.style.verticalAlign = "bottom";
        const div = document.createElement("div");
        div.style.whiteSpace = "nowrap";
        div.appendChild(text);
        div.appendChild(block);
        document.body.appendChild(div);
        let fontAscent = 0;
        let fontHeight = 0;
        try {
            fontHeight = block.getBoundingClientRect().top - text.getBoundingClientRect().top;
            block.style.verticalAlign = "baseline";
            fontAscent = block.getBoundingClientRect().top - text.getBoundingClientRect().top;
        } finally{
            document.body.removeChild(div);
        }
        return {
            ascent: fontAscent,
            height: fontHeight,
            descent: fontHeight - fontAscent
        };
    }
}
// Const statics
/** Defines that alpha blending is disabled */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.ALPHA_DISABLE = 0;
/** Defines that alpha blending to SRC ALPHA * SRC + DEST */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.ALPHA_ADD = 1;
/** Defines that alpha blending to SRC ALPHA * SRC + (1 - SRC ALPHA) * DEST */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.ALPHA_COMBINE = 2;
/** Defines that alpha blending to DEST - SRC * DEST */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.ALPHA_SUBTRACT = 3;
/** Defines that alpha blending to SRC * DEST */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.ALPHA_MULTIPLY = 4;
/** Defines that alpha blending to SRC ALPHA * SRC + (1 - SRC) * DEST */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.ALPHA_MAXIMIZED = 5;
/** Defines that alpha blending to SRC + DEST */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.ALPHA_ONEONE = 6;
/** Defines that alpha blending to SRC + (1 - SRC ALPHA) * DEST */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.ALPHA_PREMULTIPLIED = 7;
/**
 * Defines that alpha blending to SRC + (1 - SRC ALPHA) * DEST
 * Alpha will be set to (1 - SRC ALPHA) * DEST ALPHA
 */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.ALPHA_PREMULTIPLIED_PORTERDUFF = 8;
/** Defines that alpha blending to CST * SRC + (1 - CST) * DEST */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.ALPHA_INTERPOLATE = 9;
/**
 * Defines that alpha blending to SRC + (1 - SRC) * DEST
 * Alpha will be set to SRC ALPHA + (1 - SRC ALPHA) * DEST ALPHA
 */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.ALPHA_SCREENMODE = 10;
/** Defines that the resource is not delayed*/ $4592815ea2be2bed$export$2c3b404bf3a77a1f.DELAYLOADSTATE_NONE = 0;
/** Defines that the resource was successfully delay loaded */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.DELAYLOADSTATE_LOADED = 1;
/** Defines that the resource is currently delay loading */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.DELAYLOADSTATE_LOADING = 2;
/** Defines that the resource is delayed and has not started loading */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.DELAYLOADSTATE_NOTLOADED = 4;
// Depht or Stencil test Constants.
/** Passed to depthFunction or stencilFunction to specify depth or stencil tests will never pass. i.e. Nothing will be drawn */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.NEVER = 512;
/** Passed to depthFunction or stencilFunction to specify depth or stencil tests will always pass. i.e. Pixels will be drawn in the order they are drawn */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.ALWAYS = 519;
/** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is less than the stored value */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.LESS = 513;
/** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is equals to the stored value */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.EQUAL = 514;
/** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is less than or equal to the stored value */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.LEQUAL = 515;
/** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is greater than the stored value */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.GREATER = 516;
/** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is greater than or equal to the stored value */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.GEQUAL = 518;
/** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is not equal to the stored value */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.NOTEQUAL = 517;
// Stencil Actions Constants.
/** Passed to stencilOperation to specify that stencil value must be kept */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.KEEP = 7680;
/** Passed to stencilOperation to specify that stencil value must be replaced */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.REPLACE = 7681;
/** Passed to stencilOperation to specify that stencil value must be incremented */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.INCR = 7682;
/** Passed to stencilOperation to specify that stencil value must be decremented */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.DECR = 7683;
/** Passed to stencilOperation to specify that stencil value must be inverted */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.INVERT = 5386;
/** Passed to stencilOperation to specify that stencil value must be incremented with wrapping */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.INCR_WRAP = 34055;
/** Passed to stencilOperation to specify that stencil value must be decremented with wrapping */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.DECR_WRAP = 34056;
/** Texture is not repeating outside of 0..1 UVs */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_CLAMP_ADDRESSMODE = 0;
/** Texture is repeating outside of 0..1 UVs */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_WRAP_ADDRESSMODE = 1;
/** Texture is repeating and mirrored */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_MIRROR_ADDRESSMODE = 2;
/** ALPHA */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTUREFORMAT_ALPHA = 0;
/** LUMINANCE */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTUREFORMAT_LUMINANCE = 1;
/** LUMINANCE_ALPHA */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTUREFORMAT_LUMINANCE_ALPHA = 2;
/** RGB */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTUREFORMAT_RGB = 4;
/** RGBA */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTUREFORMAT_RGBA = 5;
/** RED */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTUREFORMAT_RED = 6;
/** RED (2nd reference) */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTUREFORMAT_R = 6;
/** RG */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTUREFORMAT_RG = 7;
/** RED_INTEGER */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTUREFORMAT_RED_INTEGER = 8;
/** RED_INTEGER (2nd reference) */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTUREFORMAT_R_INTEGER = 8;
/** RG_INTEGER */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTUREFORMAT_RG_INTEGER = 9;
/** RGB_INTEGER */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTUREFORMAT_RGB_INTEGER = 10;
/** RGBA_INTEGER */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTUREFORMAT_RGBA_INTEGER = 11;
/** UNSIGNED_BYTE */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURETYPE_UNSIGNED_BYTE = 0;
/** UNSIGNED_BYTE (2nd reference) */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURETYPE_UNSIGNED_INT = 0;
/** FLOAT */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURETYPE_FLOAT = 1;
/** HALF_FLOAT */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURETYPE_HALF_FLOAT = 2;
/** BYTE */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURETYPE_BYTE = 3;
/** SHORT */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURETYPE_SHORT = 4;
/** UNSIGNED_SHORT */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURETYPE_UNSIGNED_SHORT = 5;
/** INT */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURETYPE_INT = 6;
/** UNSIGNED_INT */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURETYPE_UNSIGNED_INTEGER = 7;
/** UNSIGNED_SHORT_4_4_4_4 */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURETYPE_UNSIGNED_SHORT_4_4_4_4 = 8;
/** UNSIGNED_SHORT_5_5_5_1 */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURETYPE_UNSIGNED_SHORT_5_5_5_1 = 9;
/** UNSIGNED_SHORT_5_6_5 */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURETYPE_UNSIGNED_SHORT_5_6_5 = 10;
/** UNSIGNED_INT_2_10_10_10_REV */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURETYPE_UNSIGNED_INT_2_10_10_10_REV = 11;
/** UNSIGNED_INT_24_8 */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURETYPE_UNSIGNED_INT_24_8 = 12;
/** UNSIGNED_INT_10F_11F_11F_REV */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURETYPE_UNSIGNED_INT_10F_11F_11F_REV = 13;
/** UNSIGNED_INT_5_9_9_9_REV */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURETYPE_UNSIGNED_INT_5_9_9_9_REV = 14;
/** FLOAT_32_UNSIGNED_INT_24_8_REV */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURETYPE_FLOAT_32_UNSIGNED_INT_24_8_REV = 15;
/** nearest is mag = nearest and min = nearest and mip = none */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_NEAREST_SAMPLINGMODE = 1;
/** Bilinear is mag = linear and min = linear and mip = nearest */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_BILINEAR_SAMPLINGMODE = 2;
/** Trilinear is mag = linear and min = linear and mip = linear */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_TRILINEAR_SAMPLINGMODE = 3;
/** nearest is mag = nearest and min = nearest and mip = linear */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_NEAREST_NEAREST_MIPLINEAR = 8;
/** Bilinear is mag = linear and min = linear and mip = nearest */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_LINEAR_LINEAR_MIPNEAREST = 11;
/** Trilinear is mag = linear and min = linear and mip = linear */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_LINEAR_LINEAR_MIPLINEAR = 3;
/** mag = nearest and min = nearest and mip = nearest */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_NEAREST_NEAREST_MIPNEAREST = 4;
/** mag = nearest and min = linear and mip = nearest */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_NEAREST_LINEAR_MIPNEAREST = 5;
/** mag = nearest and min = linear and mip = linear */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_NEAREST_LINEAR_MIPLINEAR = 6;
/** mag = nearest and min = linear and mip = none */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_NEAREST_LINEAR = 7;
/** mag = nearest and min = nearest and mip = none */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_NEAREST_NEAREST = 1;
/** mag = linear and min = nearest and mip = nearest */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_LINEAR_NEAREST_MIPNEAREST = 9;
/** mag = linear and min = nearest and mip = linear */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_LINEAR_NEAREST_MIPLINEAR = 10;
/** mag = linear and min = linear and mip = none */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_LINEAR_LINEAR = 2;
/** mag = linear and min = nearest and mip = none */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_LINEAR_NEAREST = 12;
/** Explicit coordinates mode */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_EXPLICIT_MODE = 0;
/** Spherical coordinates mode */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_SPHERICAL_MODE = 1;
/** Planar coordinates mode */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_PLANAR_MODE = 2;
/** Cubic coordinates mode */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_CUBIC_MODE = 3;
/** Projection coordinates mode */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_PROJECTION_MODE = 4;
/** Skybox coordinates mode */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_SKYBOX_MODE = 5;
/** Inverse Cubic coordinates mode */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_INVCUBIC_MODE = 6;
/** Equirectangular coordinates mode */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_EQUIRECTANGULAR_MODE = 7;
/** Equirectangular Fixed coordinates mode */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_FIXED_EQUIRECTANGULAR_MODE = 8;
/** Equirectangular Fixed Mirrored coordinates mode */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.TEXTURE_FIXED_EQUIRECTANGULAR_MIRRORED_MODE = 9;
// Texture rescaling mode
/** Defines that texture rescaling will use a floor to find the closer power of 2 size */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.SCALEMODE_FLOOR = 1;
/** Defines that texture rescaling will look for the nearest power of 2 size */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.SCALEMODE_NEAREST = 2;
/** Defines that texture rescaling will use a ceil to find the closer power of 2 size */ $4592815ea2be2bed$export$2c3b404bf3a77a1f.SCALEMODE_CEILING = 3;
/**
 * Method called to create the default rescale post process on each engine.
 */ $4592815ea2be2bed$export$2c3b404bf3a77a1f._RescalePostProcessFactory = null;
// eslint-disable-next-line @typescript-eslint/naming-convention
$4592815ea2be2bed$export$2c3b404bf3a77a1f._RenderPassIdCounter = 0;

});
parcelRegister("aDymS", function(module, exports) {

$parcel$export(module.exports, "PerformanceMonitor", () => $7be834a83633acb2$export$9b229b42dc5ba616);
$parcel$export(module.exports, "RollingAverage", () => $7be834a83633acb2$export$7a96bf227eb00e4);

var $blHSI = parcelRequire("blHSI");
class $7be834a83633acb2$export$9b229b42dc5ba616 {
    /**
     * constructor
     * @param frameSampleSize The number of samples required to saturate the sliding window
     */ constructor(frameSampleSize = 30){
        this._enabled = true;
        this._rollingFrameTime = new $7be834a83633acb2$export$7a96bf227eb00e4(frameSampleSize);
    }
    /**
     * Samples current frame
     * @param timeMs A timestamp in milliseconds of the current frame to compare with other frames
     */ sampleFrame(timeMs = (0, $blHSI.PrecisionDate).Now) {
        if (!this._enabled) return;
        if (this._lastFrameTimeMs != null) {
            const dt = timeMs - this._lastFrameTimeMs;
            this._rollingFrameTime.add(dt);
        }
        this._lastFrameTimeMs = timeMs;
    }
    /**
     * Returns the average frame time in milliseconds over the sliding window (or the subset of frames sampled so far)
     */ get averageFrameTime() {
        return this._rollingFrameTime.average;
    }
    /**
     * Returns the variance frame time in milliseconds over the sliding window (or the subset of frames sampled so far)
     */ get averageFrameTimeVariance() {
        return this._rollingFrameTime.variance;
    }
    /**
     * Returns the frame time of the most recent frame
     */ get instantaneousFrameTime() {
        return this._rollingFrameTime.history(0);
    }
    /**
     * Returns the average framerate in frames per second over the sliding window (or the subset of frames sampled so far)
     */ get averageFPS() {
        return 1000.0 / this._rollingFrameTime.average;
    }
    /**
     * Returns the average framerate in frames per second using the most recent frame time
     */ get instantaneousFPS() {
        const history = this._rollingFrameTime.history(0);
        if (history === 0) return 0;
        return 1000.0 / history;
    }
    /**
     * Returns true if enough samples have been taken to completely fill the sliding window
     */ get isSaturated() {
        return this._rollingFrameTime.isSaturated();
    }
    /**
     * Enables contributions to the sliding window sample set
     */ enable() {
        this._enabled = true;
    }
    /**
     * Disables contributions to the sliding window sample set
     * Samples will not be interpolated over the disabled period
     */ disable() {
        this._enabled = false;
        //clear last sample to avoid interpolating over the disabled period when next enabled
        this._lastFrameTimeMs = null;
    }
    /**
     * Returns true if sampling is enabled
     */ get isEnabled() {
        return this._enabled;
    }
    /**
     * Resets performance monitor
     */ reset() {
        //clear last sample to avoid interpolating over the disabled period when next enabled
        this._lastFrameTimeMs = null;
        //wipe record
        this._rollingFrameTime.reset();
    }
}
class $7be834a83633acb2$export$7a96bf227eb00e4 {
    /**
     * constructor
     * @param length The number of samples required to saturate the sliding window
     */ constructor(length){
        this._samples = new Array(length);
        this.reset();
    }
    /**
     * Adds a sample to the sample set
     * @param v The sample value
     */ add(v) {
        //http://en.wikipedia.org/wiki/Algorithms_for_calculating_variance
        let delta;
        //we need to check if we've already wrapped round
        if (this.isSaturated()) {
            //remove bottom of stack from mean
            const bottomValue = this._samples[this._pos];
            delta = bottomValue - this.average;
            this.average -= delta / (this._sampleCount - 1);
            this._m2 -= delta * (bottomValue - this.average);
        } else this._sampleCount++;
        //add new value to mean
        delta = v - this.average;
        this.average += delta / this._sampleCount;
        this._m2 += delta * (v - this.average);
        //set the new variance
        this.variance = this._m2 / (this._sampleCount - 1);
        this._samples[this._pos] = v;
        this._pos++;
        this._pos %= this._samples.length; //positive wrap around
    }
    /**
     * Returns previously added values or null if outside of history or outside the sliding window domain
     * @param i Index in history. For example, pass 0 for the most recent value and 1 for the value before that
     * @returns Value previously recorded with add() or null if outside of range
     */ history(i) {
        if (i >= this._sampleCount || i >= this._samples.length) return 0;
        const i0 = this._wrapPosition(this._pos - 1.0);
        return this._samples[this._wrapPosition(i0 - i)];
    }
    /**
     * Returns true if enough samples have been taken to completely fill the sliding window
     * @returns true if sample-set saturated
     */ isSaturated() {
        return this._sampleCount >= this._samples.length;
    }
    /**
     * Resets the rolling average (equivalent to 0 samples taken so far)
     */ reset() {
        this.average = 0;
        this.variance = 0;
        this._sampleCount = 0;
        this._pos = 0;
        this._m2 = 0;
    }
    /**
     * Wraps a value around the sample range boundaries
     * @param i Position in sample range, for example if the sample length is 5, and i is -3, then 2 will be returned.
     * @returns Wrapped position in sample range
     */ _wrapPosition(i) {
        const max = this._samples.length;
        return (i % max + max) % max;
    }
}

});

parcelRegister("emm58", function(module, exports) {

var $2h5JR = parcelRequire("2h5JR");
(0, $2h5JR.ThinEngine).prototype.setAlphaConstants = function(r, g, b, a) {
    this._alphaState.setAlphaBlendConstants(r, g, b, a);
};
(0, $2h5JR.ThinEngine).prototype.setAlphaMode = function(mode, noDepthWriteChange = false) {
    if (this._alphaMode === mode) {
        if (!noDepthWriteChange) {
            // Make sure we still have the correct depth mask according to the alpha mode (a transparent material could have forced writting to the depth buffer, for instance)
            const depthMask = mode === 0;
            if (this.depthCullingState.depthMask !== depthMask) this.depthCullingState.depthMask = depthMask;
        }
        return;
    }
    switch(mode){
        case 0:
            this._alphaState.alphaBlend = false;
            break;
        case 7:
            this._alphaState.setAlphaBlendFunctionParameters(this._gl.ONE, this._gl.ONE_MINUS_SRC_ALPHA, this._gl.ONE, this._gl.ONE);
            this._alphaState.alphaBlend = true;
            break;
        case 8:
            this._alphaState.setAlphaBlendFunctionParameters(this._gl.ONE, this._gl.ONE_MINUS_SRC_ALPHA, this._gl.ONE, this._gl.ONE_MINUS_SRC_ALPHA);
            this._alphaState.alphaBlend = true;
            break;
        case 2:
            this._alphaState.setAlphaBlendFunctionParameters(this._gl.SRC_ALPHA, this._gl.ONE_MINUS_SRC_ALPHA, this._gl.ONE, this._gl.ONE);
            this._alphaState.alphaBlend = true;
            break;
        case 6:
            this._alphaState.setAlphaBlendFunctionParameters(this._gl.ONE, this._gl.ONE, this._gl.ZERO, this._gl.ONE);
            this._alphaState.alphaBlend = true;
            break;
        case 1:
            this._alphaState.setAlphaBlendFunctionParameters(this._gl.SRC_ALPHA, this._gl.ONE, this._gl.ZERO, this._gl.ONE);
            this._alphaState.alphaBlend = true;
            break;
        case 3:
            this._alphaState.setAlphaBlendFunctionParameters(this._gl.ZERO, this._gl.ONE_MINUS_SRC_COLOR, this._gl.ONE, this._gl.ONE);
            this._alphaState.alphaBlend = true;
            break;
        case 4:
            this._alphaState.setAlphaBlendFunctionParameters(this._gl.DST_COLOR, this._gl.ZERO, this._gl.ONE, this._gl.ONE);
            this._alphaState.alphaBlend = true;
            break;
        case 5:
            this._alphaState.setAlphaBlendFunctionParameters(this._gl.SRC_ALPHA, this._gl.ONE_MINUS_SRC_COLOR, this._gl.ONE, this._gl.ONE);
            this._alphaState.alphaBlend = true;
            break;
        case 9:
            this._alphaState.setAlphaBlendFunctionParameters(this._gl.CONSTANT_COLOR, this._gl.ONE_MINUS_CONSTANT_COLOR, this._gl.CONSTANT_ALPHA, this._gl.ONE_MINUS_CONSTANT_ALPHA);
            this._alphaState.alphaBlend = true;
            break;
        case 10:
            this._alphaState.setAlphaBlendFunctionParameters(this._gl.ONE, this._gl.ONE_MINUS_SRC_COLOR, this._gl.ONE, this._gl.ONE_MINUS_SRC_ALPHA);
            this._alphaState.alphaBlend = true;
            break;
        case 11:
            this._alphaState.setAlphaBlendFunctionParameters(this._gl.ONE, this._gl.ONE, this._gl.ONE, this._gl.ONE);
            this._alphaState.alphaBlend = true;
            break;
        case 12:
            this._alphaState.setAlphaBlendFunctionParameters(this._gl.DST_ALPHA, this._gl.ONE, this._gl.ZERO, this._gl.ZERO);
            this._alphaState.alphaBlend = true;
            break;
        case 13:
            this._alphaState.setAlphaBlendFunctionParameters(this._gl.ONE_MINUS_DST_COLOR, this._gl.ONE_MINUS_SRC_COLOR, this._gl.ONE_MINUS_DST_ALPHA, this._gl.ONE_MINUS_SRC_ALPHA);
            this._alphaState.alphaBlend = true;
            break;
        case 14:
            this._alphaState.setAlphaBlendFunctionParameters(this._gl.ONE, this._gl.ONE_MINUS_SRC_ALPHA, this._gl.ONE, this._gl.ONE_MINUS_SRC_ALPHA);
            this._alphaState.alphaBlend = true;
            break;
        case 15:
            this._alphaState.setAlphaBlendFunctionParameters(this._gl.ONE, this._gl.ONE, this._gl.ONE, this._gl.ZERO);
            this._alphaState.alphaBlend = true;
            break;
        case 16:
            this._alphaState.setAlphaBlendFunctionParameters(this._gl.ONE_MINUS_DST_COLOR, this._gl.ONE_MINUS_SRC_COLOR, this._gl.ZERO, this._gl.ONE);
            this._alphaState.alphaBlend = true;
            break;
        case 17:
            // Same as ALPHA_COMBINE but accumulates (1 - alpha) values in the alpha channel for a later readout in order independant transparency
            this._alphaState.setAlphaBlendFunctionParameters(this._gl.SRC_ALPHA, this._gl.ONE_MINUS_SRC_ALPHA, this._gl.ONE, this._gl.ONE_MINUS_SRC_ALPHA);
            this._alphaState.alphaBlend = true;
            break;
    }
    if (!noDepthWriteChange) this.depthCullingState.depthMask = mode === 0;
    this._alphaMode = mode;
};
(0, $2h5JR.ThinEngine).prototype.getAlphaMode = function() {
    return this._alphaMode;
};
(0, $2h5JR.ThinEngine).prototype.setAlphaEquation = function(equation) {
    if (this._alphaEquation === equation) return;
    switch(equation){
        case 0:
            this._alphaState.setAlphaEquationParameters(32774, 32774);
            break;
        case 1:
            this._alphaState.setAlphaEquationParameters(32778, 32778);
            break;
        case 2:
            this._alphaState.setAlphaEquationParameters(32779, 32779);
            break;
        case 3:
            this._alphaState.setAlphaEquationParameters(32776, 32776);
            break;
        case 4:
            this._alphaState.setAlphaEquationParameters(32775, 32775);
            break;
        case 5:
            this._alphaState.setAlphaEquationParameters(32775, 32774);
            break;
    }
    this._alphaEquation = equation;
};
(0, $2h5JR.ThinEngine).prototype.getAlphaEquation = function() {
    return this._alphaEquation;
};

});

parcelRegister("k0sxV", function(module, exports) {

$parcel$export(module.exports, "allocateAndCopyTypedBuffer", () => $e909f36e2d9190c8$export$a25b2cd826cd6860);

var $2h5JR = parcelRequire("2h5JR");
function $e909f36e2d9190c8$export$a25b2cd826cd6860(type, sizeOrDstBuffer, sizeInBytes = false, copyBuffer) {
    switch(type){
        case 3:
            {
                const buffer = sizeOrDstBuffer instanceof ArrayBuffer ? new Int8Array(sizeOrDstBuffer) : new Int8Array(sizeOrDstBuffer);
                if (copyBuffer) buffer.set(new Int8Array(copyBuffer));
                return buffer;
            }
        case 0:
            {
                const buffer = sizeOrDstBuffer instanceof ArrayBuffer ? new Uint8Array(sizeOrDstBuffer) : new Uint8Array(sizeOrDstBuffer);
                if (copyBuffer) buffer.set(new Uint8Array(copyBuffer));
                return buffer;
            }
        case 4:
            {
                const buffer = sizeOrDstBuffer instanceof ArrayBuffer ? new Int16Array(sizeOrDstBuffer) : new Int16Array(sizeInBytes ? sizeOrDstBuffer / 2 : sizeOrDstBuffer);
                if (copyBuffer) buffer.set(new Int16Array(copyBuffer));
                return buffer;
            }
        case 5:
        case 8:
        case 9:
        case 10:
        case 2:
            {
                const buffer = sizeOrDstBuffer instanceof ArrayBuffer ? new Uint16Array(sizeOrDstBuffer) : new Uint16Array(sizeInBytes ? sizeOrDstBuffer / 2 : sizeOrDstBuffer);
                if (copyBuffer) buffer.set(new Uint16Array(copyBuffer));
                return buffer;
            }
        case 6:
            {
                const buffer = sizeOrDstBuffer instanceof ArrayBuffer ? new Int32Array(sizeOrDstBuffer) : new Int32Array(sizeInBytes ? sizeOrDstBuffer / 4 : sizeOrDstBuffer);
                if (copyBuffer) buffer.set(new Int32Array(copyBuffer));
                return buffer;
            }
        case 7:
        case 11:
        case 12:
        case 13:
        case 14:
        case 15:
            {
                const buffer = sizeOrDstBuffer instanceof ArrayBuffer ? new Uint32Array(sizeOrDstBuffer) : new Uint32Array(sizeInBytes ? sizeOrDstBuffer / 4 : sizeOrDstBuffer);
                if (copyBuffer) buffer.set(new Uint32Array(copyBuffer));
                return buffer;
            }
        case 1:
            {
                const buffer = sizeOrDstBuffer instanceof ArrayBuffer ? new Float32Array(sizeOrDstBuffer) : new Float32Array(sizeInBytes ? sizeOrDstBuffer / 4 : sizeOrDstBuffer);
                if (copyBuffer) buffer.set(new Float32Array(copyBuffer));
                return buffer;
            }
    }
    const buffer = sizeOrDstBuffer instanceof ArrayBuffer ? new Uint8Array(sizeOrDstBuffer) : new Uint8Array(sizeOrDstBuffer);
    if (copyBuffer) buffer.set(new Uint8Array(copyBuffer));
    return buffer;
}
(0, $2h5JR.ThinEngine).prototype._readTexturePixelsSync = function(texture, width, height, faceIndex = -1, level = 0, buffer = null, flushRenderer = true, noDataConversion = false, x = 0, y = 0) {
    const gl = this._gl;
    if (!gl) throw new Error("Engine does not have gl rendering context.");
    if (!this._dummyFramebuffer) {
        const dummy = gl.createFramebuffer();
        if (!dummy) throw new Error("Unable to create dummy framebuffer");
        this._dummyFramebuffer = dummy;
    }
    gl.bindFramebuffer(gl.FRAMEBUFFER, this._dummyFramebuffer);
    if (faceIndex > -1) gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex, texture._hardwareTexture?.underlyingResource, level);
    else gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture._hardwareTexture?.underlyingResource, level);
    let readType = texture.type !== undefined ? this._getWebGLTextureType(texture.type) : gl.UNSIGNED_BYTE;
    if (!noDataConversion) switch(readType){
        case gl.UNSIGNED_BYTE:
            if (!buffer) buffer = new Uint8Array(4 * width * height);
            readType = gl.UNSIGNED_BYTE;
            break;
        default:
            if (!buffer) buffer = new Float32Array(4 * width * height);
            readType = gl.FLOAT;
            break;
    }
    else if (!buffer) buffer = $e909f36e2d9190c8$export$a25b2cd826cd6860(texture.type, 4 * width * height);
    if (flushRenderer) this.flushFramebuffer();
    gl.readPixels(x, y, width, height, gl.RGBA, readType, buffer);
    gl.bindFramebuffer(gl.FRAMEBUFFER, this._currentFramebuffer);
    return buffer;
};
(0, $2h5JR.ThinEngine).prototype._readTexturePixels = function(texture, width, height, faceIndex = -1, level = 0, buffer = null, flushRenderer = true, noDataConversion = false, x = 0, y = 0) {
    return Promise.resolve(this._readTexturePixelsSync(texture, width, height, faceIndex, level, buffer, flushRenderer, noDataConversion, x, y));
};

});

parcelRegister("7G59J", function(module, exports) {

var $2h5JR = parcelRequire("2h5JR");
// eslint-disable-next-line @typescript-eslint/no-unused-vars
(0, $2h5JR.ThinEngine).prototype.updateDynamicIndexBuffer = function(indexBuffer, indices, offset = 0) {
    // Force cache update
    this._currentBoundBuffer[this._gl.ELEMENT_ARRAY_BUFFER] = null;
    this.bindIndexBuffer(indexBuffer);
    let view;
    if (indexBuffer.is32Bits) // anything else than Uint32Array needs to be converted to Uint32Array
    view = indices instanceof Uint32Array ? indices : new Uint32Array(indices);
    else // anything else than Uint16Array needs to be converted to Uint16Array
    view = indices instanceof Uint16Array ? indices : new Uint16Array(indices);
    this._gl.bufferData(this._gl.ELEMENT_ARRAY_BUFFER, view, this._gl.DYNAMIC_DRAW);
    this._resetIndexBufferBinding();
};
(0, $2h5JR.ThinEngine).prototype.updateDynamicVertexBuffer = function(vertexBuffer, data, byteOffset, byteLength) {
    this.bindArrayBuffer(vertexBuffer);
    if (byteOffset === undefined) byteOffset = 0;
    const dataLength = data.byteLength || data.length;
    if (byteLength === undefined || byteLength >= dataLength && byteOffset === 0) {
        if (data instanceof Array) this._gl.bufferSubData(this._gl.ARRAY_BUFFER, byteOffset, new Float32Array(data));
        else this._gl.bufferSubData(this._gl.ARRAY_BUFFER, byteOffset, data);
    } else if (data instanceof Array) this._gl.bufferSubData(this._gl.ARRAY_BUFFER, 0, new Float32Array(data).subarray(byteOffset, byteOffset + byteLength));
    else {
        if (data instanceof ArrayBuffer) data = new Uint8Array(data, byteOffset, byteLength);
        else data = new Uint8Array(data.buffer, data.byteOffset + byteOffset, byteLength);
        this._gl.bufferSubData(this._gl.ARRAY_BUFFER, 0, data);
    }
    this._resetVertexBufferBinding();
};

});


parcelRegister("klshO", function(module, exports) {

$parcel$export(module.exports, "TransformNode", () => $ecfbb5db4d70b862$export$b600d080bad015f);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $6Ho1L = parcelRequire("6Ho1L");

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $bgssx = parcelRequire("bgssx");

var $dbxbu = parcelRequire("dbxbu");

var $8DoUR = parcelRequire("8DoUR");
const $ecfbb5db4d70b862$var$convertRHSToLHS = (0, $ha1VO.Matrix).Compose((0, $ha1VO.Vector3).One(), (0, $ha1VO.Quaternion).FromEulerAngles(0, Math.PI, 0), (0, $ha1VO.Vector3).Zero());
class $ecfbb5db4d70b862$export$b600d080bad015f extends (0, $bgssx.Node) {
    /**
     * Gets or sets the billboard mode. Default is 0.
     *
     * | Value | Type | Description |
     * | --- | --- | --- |
     * | 0 | BILLBOARDMODE_NONE |  |
     * | 1 | BILLBOARDMODE_X |  |
     * | 2 | BILLBOARDMODE_Y |  |
     * | 4 | BILLBOARDMODE_Z |  |
     * | 7 | BILLBOARDMODE_ALL |  |
     *
     */ get billboardMode() {
        return this._billboardMode;
    }
    set billboardMode(value) {
        if (this._billboardMode === value) return;
        this._billboardMode = value;
        this._cache.useBillboardPosition = (this._billboardMode & $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_USE_POSITION) !== 0;
        this._computeUseBillboardPath();
    }
    /**
     * Gets or sets a boolean indicating that parent rotation should be preserved when using billboards.
     * This could be useful for glTF objects where parent rotation helps converting from right handed to left handed
     */ get preserveParentRotationForBillboard() {
        return this._preserveParentRotationForBillboard;
    }
    set preserveParentRotationForBillboard(value) {
        if (value === this._preserveParentRotationForBillboard) return;
        this._preserveParentRotationForBillboard = value;
        this._computeUseBillboardPath();
    }
    _computeUseBillboardPath() {
        this._cache.useBillboardPath = this._billboardMode !== $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_NONE && !this.preserveParentRotationForBillboard;
    }
    /**
     * Gets or sets the distance of the object to max, often used by skybox
     */ get infiniteDistance() {
        return this._infiniteDistance;
    }
    set infiniteDistance(value) {
        if (this._infiniteDistance === value) return;
        this._infiniteDistance = value;
    }
    constructor(name, scene = null, isPure = true){
        super(name, scene);
        this._forward = new (0, $ha1VO.Vector3)(0, 0, 1);
        this._up = new (0, $ha1VO.Vector3)(0, 1, 0);
        this._right = new (0, $ha1VO.Vector3)(1, 0, 0);
        // Properties
        this._position = (0, $ha1VO.Vector3).Zero();
        this._rotation = (0, $ha1VO.Vector3).Zero();
        this._rotationQuaternion = null;
        this._scaling = (0, $ha1VO.Vector3).One();
        this._transformToBoneReferal = null;
        this._isAbsoluteSynced = false;
        this._billboardMode = $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_NONE;
        this._preserveParentRotationForBillboard = false;
        /**
         * Multiplication factor on scale x/y/z when computing the world matrix. Eg. for a 1x1x1 cube setting this to 2 will make it a 2x2x2 cube
         */ this.scalingDeterminant = 1;
        this._infiniteDistance = false;
        /**
         * Gets or sets a boolean indicating that non uniform scaling (when at least one component is different from others) should be ignored.
         * By default the system will update normals to compensate
         */ this.ignoreNonUniformScaling = false;
        /**
         * Gets or sets a boolean indicating that even if rotationQuaternion is defined, you can keep updating rotation property and Babylon.js will just mix both
         */ this.reIntegrateRotationIntoRotationQuaternion = false;
        // Cache
        /** @internal */ this._poseMatrix = null;
        /** @internal */ this._localMatrix = (0, $ha1VO.Matrix).Zero();
        this._usePivotMatrix = false;
        this._absolutePosition = (0, $ha1VO.Vector3).Zero();
        this._absoluteScaling = (0, $ha1VO.Vector3).Zero();
        this._absoluteRotationQuaternion = (0, $ha1VO.Quaternion).Identity();
        this._pivotMatrix = (0, $ha1VO.Matrix).Identity();
        /** @internal */ this._postMultiplyPivotMatrix = false;
        this._isWorldMatrixFrozen = false;
        /** @internal */ this._indexInSceneTransformNodesArray = -1;
        /**
         * An event triggered after the world matrix is updated
         */ this.onAfterWorldMatrixUpdateObservable = new (0, $diGQf.Observable)();
        this._nonUniformScaling = false;
        if (isPure) this.getScene().addTransformNode(this);
    }
    /**
     * Gets a string identifying the name of the class
     * @returns "TransformNode" string
     */ getClassName() {
        return "TransformNode";
    }
    /**
     * Gets or set the node position (default is (0.0, 0.0, 0.0))
     */ get position() {
        return this._position;
    }
    set position(newPosition) {
        this._position = newPosition;
        this._isDirty = true;
    }
    /**
     * return true if a pivot has been set
     * @returns true if a pivot matrix is used
     */ isUsingPivotMatrix() {
        return this._usePivotMatrix;
    }
    /**
     * @returns true if pivot matrix must be cancelled in the world matrix. When this parameter is set to true (default), the inverse of the pivot matrix is also applied at the end to cancel the transformation effect.
     */ isUsingPostMultiplyPivotMatrix() {
        return this._postMultiplyPivotMatrix;
    }
    /**
     * Gets or sets the rotation property : a Vector3 defining the rotation value in radians around each local axis X, Y, Z  (default is (0.0, 0.0, 0.0)).
     * If rotation quaternion is set, this Vector3 will be ignored and copy from the quaternion
     */ get rotation() {
        return this._rotation;
    }
    set rotation(newRotation) {
        this._rotation = newRotation;
        this._rotationQuaternion = null;
        this._isDirty = true;
    }
    /**
     * Gets or sets the scaling property : a Vector3 defining the node scaling along each local axis X, Y, Z (default is (1.0, 1.0, 1.0)).
     */ get scaling() {
        return this._scaling;
    }
    set scaling(newScaling) {
        this._scaling = newScaling;
        this._isDirty = true;
    }
    /**
     * Gets or sets the rotation Quaternion property : this a Quaternion object defining the node rotation by using a unit quaternion (undefined by default, but can be null).
     * If set, only the rotationQuaternion is then used to compute the node rotation (ie. node.rotation will be ignored)
     */ get rotationQuaternion() {
        return this._rotationQuaternion;
    }
    set rotationQuaternion(quaternion) {
        this._rotationQuaternion = quaternion;
        //reset the rotation vector.
        if (quaternion) this._rotation.setAll(0.0);
        this._isDirty = true;
    }
    /**
     * The forward direction of that transform in world space.
     */ get forward() {
        (0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(0, 0, this.getScene().useRightHandedSystem ? -1 : 1.0, this.getWorldMatrix(), this._forward);
        return this._forward.normalize();
    }
    /**
     * The up direction of that transform in world space.
     */ get up() {
        (0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(0, 1, 0, this.getWorldMatrix(), this._up);
        return this._up.normalize();
    }
    /**
     * The right direction of that transform in world space.
     */ get right() {
        (0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(this.getScene().useRightHandedSystem ? -1 : 1.0, 0, 0, this.getWorldMatrix(), this._right);
        return this._right.normalize();
    }
    /**
     * Copies the parameter passed Matrix into the mesh Pose matrix.
     * @param matrix the matrix to copy the pose from
     * @returns this TransformNode.
     */ updatePoseMatrix(matrix) {
        if (!this._poseMatrix) {
            this._poseMatrix = matrix.clone();
            return this;
        }
        this._poseMatrix.copyFrom(matrix);
        return this;
    }
    /**
     * Returns the mesh Pose matrix.
     * @returns the pose matrix
     */ getPoseMatrix() {
        if (!this._poseMatrix) this._poseMatrix = (0, $ha1VO.Matrix).Identity();
        return this._poseMatrix;
    }
    /** @internal */ _isSynchronized() {
        const cache = this._cache;
        if (this._billboardMode !== cache.billboardMode || this._billboardMode !== $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_NONE) return false;
        if (cache.pivotMatrixUpdated) return false;
        if (this._infiniteDistance) return false;
        if (this._position._isDirty) return false;
        if (this._scaling._isDirty) return false;
        if (this._rotationQuaternion && this._rotationQuaternion._isDirty || this._rotation._isDirty) return false;
        return true;
    }
    /** @internal */ _initCache() {
        super._initCache();
        const cache = this._cache;
        cache.localMatrixUpdated = false;
        cache.billboardMode = -1;
        cache.infiniteDistance = false;
        cache.useBillboardPosition = false;
        cache.useBillboardPath = false;
    }
    /**
     * Returns the current mesh absolute position.
     * Returns a Vector3.
     */ get absolutePosition() {
        return this.getAbsolutePosition();
    }
    /**
     * Returns the current mesh absolute scaling.
     * Returns a Vector3.
     */ get absoluteScaling() {
        this._syncAbsoluteScalingAndRotation();
        return this._absoluteScaling;
    }
    /**
     * Returns the current mesh absolute rotation.
     * Returns a Quaternion.
     */ get absoluteRotationQuaternion() {
        this._syncAbsoluteScalingAndRotation();
        return this._absoluteRotationQuaternion;
    }
    /**
     * Sets a new matrix to apply before all other transformation
     * @param matrix defines the transform matrix
     * @returns the current TransformNode
     */ setPreTransformMatrix(matrix) {
        return this.setPivotMatrix(matrix, false);
    }
    /**
     * Sets a new pivot matrix to the current node
     * @param matrix defines the new pivot matrix to use
     * @param postMultiplyPivotMatrix defines if the pivot matrix must be cancelled in the world matrix. When this parameter is set to true (default), the inverse of the pivot matrix is also applied at the end to cancel the transformation effect
     * @returns the current TransformNode
     */ setPivotMatrix(matrix, postMultiplyPivotMatrix = true) {
        this._pivotMatrix.copyFrom(matrix);
        this._usePivotMatrix = !this._pivotMatrix.isIdentity();
        this._cache.pivotMatrixUpdated = true;
        this._postMultiplyPivotMatrix = postMultiplyPivotMatrix;
        if (this._postMultiplyPivotMatrix) {
            if (!this._pivotMatrixInverse) this._pivotMatrixInverse = (0, $ha1VO.Matrix).Invert(this._pivotMatrix);
            else this._pivotMatrix.invertToRef(this._pivotMatrixInverse);
        }
        return this;
    }
    /**
     * Returns the mesh pivot matrix.
     * Default : Identity.
     * @returns the matrix
     */ getPivotMatrix() {
        return this._pivotMatrix;
    }
    /**
     * Instantiate (when possible) or clone that node with its hierarchy
     * @param newParent defines the new parent to use for the instance (or clone)
     * @param options defines options to configure how copy is done
     * @param options.doNotInstantiate defines if the model must be instantiated or just cloned
     * @param onNewNodeCreated defines an option callback to call when a clone or an instance is created
     * @returns an instance (or a clone) of the current node with its hierarchy
     */ instantiateHierarchy(newParent = null, options, onNewNodeCreated) {
        const clone = this.clone("Clone of " + (this.name || this.id), newParent || this.parent, true);
        if (clone) {
            if (onNewNodeCreated) onNewNodeCreated(this, clone);
        }
        for (const child of this.getChildTransformNodes(true))child.instantiateHierarchy(clone, options, onNewNodeCreated);
        return clone;
    }
    /**
     * Prevents the World matrix to be computed any longer
     * @param newWorldMatrix defines an optional matrix to use as world matrix
     * @param decompose defines whether to decompose the given newWorldMatrix or directly assign
     * @returns the TransformNode.
     */ freezeWorldMatrix(newWorldMatrix = null, decompose = false) {
        if (newWorldMatrix) {
            if (decompose) {
                this._rotation.setAll(0);
                this._rotationQuaternion = this._rotationQuaternion || (0, $ha1VO.Quaternion).Identity();
                newWorldMatrix.decompose(this._scaling, this._rotationQuaternion, this._position);
                this.computeWorldMatrix(true);
            } else {
                this._worldMatrix = newWorldMatrix;
                this._absolutePosition.copyFromFloats(this._worldMatrix.m[12], this._worldMatrix.m[13], this._worldMatrix.m[14]);
                this._afterComputeWorldMatrix();
            }
        } else {
            this._isWorldMatrixFrozen = false; // no guarantee world is not already frozen, switch off temporarily
            this.computeWorldMatrix(true);
        }
        this._isDirty = false;
        this._isWorldMatrixFrozen = true;
        return this;
    }
    /**
     * Allows back the World matrix computation.
     * @returns the TransformNode.
     */ unfreezeWorldMatrix() {
        this._isWorldMatrixFrozen = false;
        this.computeWorldMatrix(true);
        return this;
    }
    /**
     * True if the World matrix has been frozen.
     */ get isWorldMatrixFrozen() {
        return this._isWorldMatrixFrozen;
    }
    /**
     * Returns the mesh absolute position in the World.
     * @returns a Vector3.
     */ getAbsolutePosition() {
        this.computeWorldMatrix();
        return this._absolutePosition;
    }
    /**
     * Sets the mesh absolute position in the World from a Vector3 or an Array(3).
     * @param absolutePosition the absolute position to set
     * @returns the TransformNode.
     */ setAbsolutePosition(absolutePosition) {
        if (!absolutePosition) return this;
        let absolutePositionX;
        let absolutePositionY;
        let absolutePositionZ;
        if (absolutePosition.x === undefined) {
            if (arguments.length < 3) return this;
            absolutePositionX = arguments[0];
            absolutePositionY = arguments[1];
            absolutePositionZ = arguments[2];
        } else {
            absolutePositionX = absolutePosition.x;
            absolutePositionY = absolutePosition.y;
            absolutePositionZ = absolutePosition.z;
        }
        if (this.parent) {
            const invertParentWorldMatrix = (0, $ha1VO.TmpVectors).Matrix[0];
            this.parent.getWorldMatrix().invertToRef(invertParentWorldMatrix);
            (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(absolutePositionX, absolutePositionY, absolutePositionZ, invertParentWorldMatrix, this.position);
        } else {
            this.position.x = absolutePositionX;
            this.position.y = absolutePositionY;
            this.position.z = absolutePositionZ;
        }
        this._absolutePosition.copyFrom(absolutePosition);
        return this;
    }
    /**
     * Sets the mesh position in its local space.
     * @param vector3 the position to set in localspace
     * @returns the TransformNode.
     */ setPositionWithLocalVector(vector3) {
        this.computeWorldMatrix();
        this.position = (0, $ha1VO.Vector3).TransformNormal(vector3, this._localMatrix);
        return this;
    }
    /**
     * Returns the mesh position in the local space from the current World matrix values.
     * @returns a new Vector3.
     */ getPositionExpressedInLocalSpace() {
        this.computeWorldMatrix();
        const invLocalWorldMatrix = (0, $ha1VO.TmpVectors).Matrix[0];
        this._localMatrix.invertToRef(invLocalWorldMatrix);
        return (0, $ha1VO.Vector3).TransformNormal(this.position, invLocalWorldMatrix);
    }
    /**
     * Translates the mesh along the passed Vector3 in its local space.
     * @param vector3 the distance to translate in localspace
     * @returns the TransformNode.
     */ locallyTranslate(vector3) {
        this.computeWorldMatrix(true);
        this.position = (0, $ha1VO.Vector3).TransformCoordinates(vector3, this._localMatrix);
        return this;
    }
    /**
     * Orients a mesh towards a target point. Mesh must be drawn facing user.
     * @param targetPoint the position (must be in same space as current mesh) to look at
     * @param yawCor optional yaw (y-axis) correction in radians
     * @param pitchCor optional pitch (x-axis) correction in radians
     * @param rollCor optional roll (z-axis) correction in radians
     * @param space the chosen space of the target
     * @returns the TransformNode.
     */ lookAt(targetPoint, yawCor = 0, pitchCor = 0, rollCor = 0, space = (0, $dbxbu.Space).LOCAL) {
        const dv = $ecfbb5db4d70b862$export$b600d080bad015f._LookAtVectorCache;
        const pos = space === (0, $dbxbu.Space).LOCAL ? this.position : this.getAbsolutePosition();
        targetPoint.subtractToRef(pos, dv);
        this.setDirection(dv, yawCor, pitchCor, rollCor);
        // Correct for parent's rotation offset
        if (space === (0, $dbxbu.Space).WORLD && this.parent) {
            if (this.rotationQuaternion) {
                // Get local rotation matrix of the looking object
                const rotationMatrix = (0, $ha1VO.TmpVectors).Matrix[0];
                this.rotationQuaternion.toRotationMatrix(rotationMatrix);
                // Offset rotation by parent's inverted rotation matrix to correct in world space
                const parentRotationMatrix = (0, $ha1VO.TmpVectors).Matrix[1];
                this.parent.getWorldMatrix().getRotationMatrixToRef(parentRotationMatrix);
                parentRotationMatrix.invert();
                rotationMatrix.multiplyToRef(parentRotationMatrix, rotationMatrix);
                this.rotationQuaternion.fromRotationMatrix(rotationMatrix);
            } else {
                // Get local rotation matrix of the looking object
                const quaternionRotation = (0, $ha1VO.TmpVectors).Quaternion[0];
                (0, $ha1VO.Quaternion).FromEulerVectorToRef(this.rotation, quaternionRotation);
                const rotationMatrix = (0, $ha1VO.TmpVectors).Matrix[0];
                quaternionRotation.toRotationMatrix(rotationMatrix);
                // Offset rotation by parent's inverted rotation matrix to correct in world space
                const parentRotationMatrix = (0, $ha1VO.TmpVectors).Matrix[1];
                this.parent.getWorldMatrix().getRotationMatrixToRef(parentRotationMatrix);
                parentRotationMatrix.invert();
                rotationMatrix.multiplyToRef(parentRotationMatrix, rotationMatrix);
                quaternionRotation.fromRotationMatrix(rotationMatrix);
                quaternionRotation.toEulerAnglesToRef(this.rotation);
            }
        }
        return this;
    }
    /**
     * Returns a new Vector3 that is the localAxis, expressed in the mesh local space, rotated like the mesh.
     * This Vector3 is expressed in the World space.
     * @param localAxis axis to rotate
     * @returns a new Vector3 that is the localAxis, expressed in the mesh local space, rotated like the mesh.
     */ getDirection(localAxis) {
        const result = (0, $ha1VO.Vector3).Zero();
        this.getDirectionToRef(localAxis, result);
        return result;
    }
    /**
     * Sets the Vector3 "result" as the rotated Vector3 "localAxis" in the same rotation than the mesh.
     * localAxis is expressed in the mesh local space.
     * result is computed in the World space from the mesh World matrix.
     * @param localAxis axis to rotate
     * @param result the resulting transformnode
     * @returns this TransformNode.
     */ getDirectionToRef(localAxis, result) {
        (0, $ha1VO.Vector3).TransformNormalToRef(localAxis, this.getWorldMatrix(), result);
        return this;
    }
    /**
     * Sets this transform node rotation to the given local axis.
     * @param localAxis the axis in local space
     * @param yawCor optional yaw (y-axis) correction in radians
     * @param pitchCor optional pitch (x-axis) correction in radians
     * @param rollCor optional roll (z-axis) correction in radians
     * @returns this TransformNode
     */ setDirection(localAxis, yawCor = 0, pitchCor = 0, rollCor = 0) {
        const yaw = -Math.atan2(localAxis.z, localAxis.x) + Math.PI / 2;
        const len = Math.sqrt(localAxis.x * localAxis.x + localAxis.z * localAxis.z);
        const pitch = -Math.atan2(localAxis.y, len);
        if (this.rotationQuaternion) (0, $ha1VO.Quaternion).RotationYawPitchRollToRef(yaw + yawCor, pitch + pitchCor, rollCor, this.rotationQuaternion);
        else {
            this.rotation.x = pitch + pitchCor;
            this.rotation.y = yaw + yawCor;
            this.rotation.z = rollCor;
        }
        return this;
    }
    /**
     * Sets a new pivot point to the current node
     * @param point defines the new pivot point to use
     * @param space defines if the point is in world or local space (local by default)
     * @returns the current TransformNode
     */ setPivotPoint(point, space = (0, $dbxbu.Space).LOCAL) {
        if (this.getScene().getRenderId() == 0) this.computeWorldMatrix(true);
        const wm = this.getWorldMatrix();
        if (space == (0, $dbxbu.Space).WORLD) {
            const tmat = (0, $ha1VO.TmpVectors).Matrix[0];
            wm.invertToRef(tmat);
            point = (0, $ha1VO.Vector3).TransformCoordinates(point, tmat);
        }
        return this.setPivotMatrix((0, $ha1VO.Matrix).Translation(-point.x, -point.y, -point.z), true);
    }
    /**
     * Returns a new Vector3 set with the mesh pivot point coordinates in the local space.
     * @returns the pivot point
     */ getPivotPoint() {
        const point = (0, $ha1VO.Vector3).Zero();
        this.getPivotPointToRef(point);
        return point;
    }
    /**
     * Sets the passed Vector3 "result" with the coordinates of the mesh pivot point in the local space.
     * @param result the vector3 to store the result
     * @returns this TransformNode.
     */ getPivotPointToRef(result) {
        result.x = -this._pivotMatrix.m[12];
        result.y = -this._pivotMatrix.m[13];
        result.z = -this._pivotMatrix.m[14];
        return this;
    }
    /**
     * Returns a new Vector3 set with the mesh pivot point World coordinates.
     * @returns a new Vector3 set with the mesh pivot point World coordinates.
     */ getAbsolutePivotPoint() {
        const point = (0, $ha1VO.Vector3).Zero();
        this.getAbsolutePivotPointToRef(point);
        return point;
    }
    /**
     * Sets the Vector3 "result" coordinates with the mesh pivot point World coordinates.
     * @param result vector3 to store the result
     * @returns this TransformNode.
     */ getAbsolutePivotPointToRef(result) {
        this.getPivotPointToRef(result);
        (0, $ha1VO.Vector3).TransformCoordinatesToRef(result, this.getWorldMatrix(), result);
        return this;
    }
    /**
     * Flag the transform node as dirty (Forcing it to update everything)
     * @param property if set to "rotation" the objects rotationQuaternion will be set to null
     * @returns this  node
     */ markAsDirty(property) {
        if (this._isDirty) return this;
        // We need to explicitly update the children
        // as the scene.evaluateActiveMeshes will not poll the transform nodes
        if (this._children) for (const child of this._children)child.markAsDirty(property);
        return super.markAsDirty(property);
    }
    /**
     * Defines the passed node as the parent of the current node.
     * The node will remain exactly where it is and its position / rotation will be updated accordingly.
     * Note that if the mesh has a pivot matrix / point defined it will be applied after the parent was updated.
     * In that case the node will not remain in the same space as it is, as the pivot will be applied.
     * To avoid this, you can set updatePivot to true and the pivot will be updated to identity
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/transforms/parent_pivot/parent
     * @param node the node ot set as the parent
     * @param preserveScalingSign if true, keep scaling sign of child. Otherwise, scaling sign might change.
     * @param updatePivot if true, update the pivot matrix to keep the node in the same space as before
     * @returns this TransformNode.
     */ setParent(node, preserveScalingSign = false, updatePivot = false) {
        if (!node && !this.parent) return this;
        const quatRotation = (0, $ha1VO.TmpVectors).Quaternion[0];
        const position = (0, $ha1VO.TmpVectors).Vector3[0];
        const scale = (0, $ha1VO.TmpVectors).Vector3[1];
        const invParentMatrix = (0, $ha1VO.TmpVectors).Matrix[1];
        (0, $ha1VO.Matrix).IdentityToRef(invParentMatrix);
        const composedMatrix = (0, $ha1VO.TmpVectors).Matrix[0];
        this.computeWorldMatrix(true);
        let currentRotation = this.rotationQuaternion;
        if (!currentRotation) {
            currentRotation = $ecfbb5db4d70b862$export$b600d080bad015f._TmpRotation;
            (0, $ha1VO.Quaternion).RotationYawPitchRollToRef(this._rotation.y, this._rotation.x, this._rotation.z, currentRotation);
        }
        // current global transformation without pivot
        (0, $ha1VO.Matrix).ComposeToRef(this.scaling, currentRotation, this.position, composedMatrix);
        if (this.parent) composedMatrix.multiplyToRef(this.parent.computeWorldMatrix(true), composedMatrix);
        // is a node was set, calculate the difference between this and the node
        if (node) {
            node.computeWorldMatrix(true).invertToRef(invParentMatrix);
            composedMatrix.multiplyToRef(invParentMatrix, composedMatrix);
        }
        composedMatrix.decompose(scale, quatRotation, position, preserveScalingSign ? this : undefined);
        if (this.rotationQuaternion) this.rotationQuaternion.copyFrom(quatRotation);
        else quatRotation.toEulerAnglesToRef(this.rotation);
        this.scaling.copyFrom(scale);
        this.position.copyFrom(position);
        this.parent = node;
        if (updatePivot) this.setPivotMatrix((0, $ha1VO.Matrix).Identity());
        return this;
    }
    /**
     * True if the scaling property of this object is non uniform eg. (1,2,1)
     */ get nonUniformScaling() {
        return this._nonUniformScaling;
    }
    /**
     * @internal
     */ _updateNonUniformScalingState(value) {
        if (this._nonUniformScaling === value) return false;
        this._nonUniformScaling = value;
        return true;
    }
    /**
     * Attach the current TransformNode to another TransformNode associated with a bone
     * @param bone Bone affecting the TransformNode
     * @param affectedTransformNode TransformNode associated with the bone
     * @returns this object
     */ attachToBone(bone, affectedTransformNode) {
        this._currentParentWhenAttachingToBone = this.parent;
        this._transformToBoneReferal = affectedTransformNode;
        this.parent = bone;
        bone.getSkeleton().prepare(true); // make sure bone.getFinalMatrix() is up to date
        if (bone.getFinalMatrix().determinant() < 0) this.scalingDeterminant *= -1;
        return this;
    }
    /**
     * Detach the transform node if its associated with a bone
     * @param resetToPreviousParent Indicates if the parent that was in effect when attachToBone was called should be set back or if we should set parent to null instead (defaults to the latter)
     * @returns this object
     */ detachFromBone(resetToPreviousParent = false) {
        if (!this.parent) {
            if (resetToPreviousParent) this.parent = this._currentParentWhenAttachingToBone;
            return this;
        }
        if (this.parent.getWorldMatrix().determinant() < 0) this.scalingDeterminant *= -1;
        this._transformToBoneReferal = null;
        if (resetToPreviousParent) this.parent = this._currentParentWhenAttachingToBone;
        else this.parent = null;
        return this;
    }
    /**
     * Rotates the mesh around the axis vector for the passed angle (amount) expressed in radians, in the given space.
     * space (default LOCAL) can be either Space.LOCAL, either Space.WORLD.
     * Note that the property `rotationQuaternion` is then automatically updated and the property `rotation` is set to (0,0,0) and no longer used.
     * The passed axis is also normalized.
     * @param axis the axis to rotate around
     * @param amount the amount to rotate in radians
     * @param space Space to rotate in (Default: local)
     * @returns the TransformNode.
     */ rotate(axis, amount, space) {
        axis.normalize();
        if (!this.rotationQuaternion) {
            this.rotationQuaternion = this.rotation.toQuaternion();
            this.rotation.setAll(0);
        }
        let rotationQuaternion;
        if (!space || space === (0, $dbxbu.Space).LOCAL) {
            rotationQuaternion = (0, $ha1VO.Quaternion).RotationAxisToRef(axis, amount, $ecfbb5db4d70b862$export$b600d080bad015f._RotationAxisCache);
            this.rotationQuaternion.multiplyToRef(rotationQuaternion, this.rotationQuaternion);
        } else {
            if (this.parent) {
                const parentWorldMatrix = this.parent.getWorldMatrix();
                const invertParentWorldMatrix = (0, $ha1VO.TmpVectors).Matrix[0];
                parentWorldMatrix.invertToRef(invertParentWorldMatrix);
                axis = (0, $ha1VO.Vector3).TransformNormal(axis, invertParentWorldMatrix);
                if (parentWorldMatrix.determinant() < 0) amount *= -1;
            }
            rotationQuaternion = (0, $ha1VO.Quaternion).RotationAxisToRef(axis, amount, $ecfbb5db4d70b862$export$b600d080bad015f._RotationAxisCache);
            rotationQuaternion.multiplyToRef(this.rotationQuaternion, this.rotationQuaternion);
        }
        return this;
    }
    /**
     * Rotates the mesh around the axis vector for the passed angle (amount) expressed in radians, in world space.
     * Note that the property `rotationQuaternion` is then automatically updated and the property `rotation` is set to (0,0,0) and no longer used.
     * The passed axis is also normalized. .
     * Method is based on http://www.euclideanspace.com/maths/geometry/affine/aroundPoint/index.htm
     * @param point the point to rotate around
     * @param axis the axis to rotate around
     * @param amount the amount to rotate in radians
     * @returns the TransformNode
     */ rotateAround(point, axis, amount) {
        axis.normalize();
        if (!this.rotationQuaternion) {
            this.rotationQuaternion = (0, $ha1VO.Quaternion).RotationYawPitchRoll(this.rotation.y, this.rotation.x, this.rotation.z);
            this.rotation.setAll(0);
        }
        const tmpVector = (0, $ha1VO.TmpVectors).Vector3[0];
        const finalScale = (0, $ha1VO.TmpVectors).Vector3[1];
        const finalTranslation = (0, $ha1VO.TmpVectors).Vector3[2];
        const finalRotation = (0, $ha1VO.TmpVectors).Quaternion[0];
        const translationMatrix = (0, $ha1VO.TmpVectors).Matrix[0]; // T
        const translationMatrixInv = (0, $ha1VO.TmpVectors).Matrix[1]; // T'
        const rotationMatrix = (0, $ha1VO.TmpVectors).Matrix[2]; // R
        const finalMatrix = (0, $ha1VO.TmpVectors).Matrix[3]; // T' x R x T
        point.subtractToRef(this.position, tmpVector);
        (0, $ha1VO.Matrix).TranslationToRef(tmpVector.x, tmpVector.y, tmpVector.z, translationMatrix); // T
        (0, $ha1VO.Matrix).TranslationToRef(-tmpVector.x, -tmpVector.y, -tmpVector.z, translationMatrixInv); // T'
        (0, $ha1VO.Matrix).RotationAxisToRef(axis, amount, rotationMatrix); // R
        translationMatrixInv.multiplyToRef(rotationMatrix, finalMatrix); // T' x R
        finalMatrix.multiplyToRef(translationMatrix, finalMatrix); // T' x R x T
        finalMatrix.decompose(finalScale, finalRotation, finalTranslation);
        this.position.addInPlace(finalTranslation);
        finalRotation.multiplyToRef(this.rotationQuaternion, this.rotationQuaternion);
        return this;
    }
    /**
     * Translates the mesh along the axis vector for the passed distance in the given space.
     * space (default LOCAL) can be either Space.LOCAL, either Space.WORLD.
     * @param axis the axis to translate in
     * @param distance the distance to translate
     * @param space Space to rotate in (Default: local)
     * @returns the TransformNode.
     */ translate(axis, distance, space) {
        const displacementVector = axis.scale(distance);
        if (!space || space === (0, $dbxbu.Space).LOCAL) {
            const tempV3 = this.getPositionExpressedInLocalSpace().add(displacementVector);
            this.setPositionWithLocalVector(tempV3);
        } else this.setAbsolutePosition(this.getAbsolutePosition().add(displacementVector));
        return this;
    }
    /**
     * Adds a rotation step to the mesh current rotation.
     * x, y, z are Euler angles expressed in radians.
     * This methods updates the current mesh rotation, either mesh.rotation, either mesh.rotationQuaternion if it's set.
     * This means this rotation is made in the mesh local space only.
     * It's useful to set a custom rotation order different from the BJS standard one YXZ.
     * Example : this rotates the mesh first around its local X axis, then around its local Z axis, finally around its local Y axis.
     * ```javascript
     * mesh.addRotation(x1, 0, 0).addRotation(0, 0, z2).addRotation(0, 0, y3);
     * ```
     * Note that `addRotation()` accumulates the passed rotation values to the current ones and computes the .rotation or .rotationQuaternion updated values.
     * Under the hood, only quaternions are used. So it's a little faster is you use .rotationQuaternion because it doesn't need to translate them back to Euler angles.
     * @param x Rotation to add
     * @param y Rotation to add
     * @param z Rotation to add
     * @returns the TransformNode.
     */ addRotation(x, y, z) {
        let rotationQuaternion;
        if (this.rotationQuaternion) rotationQuaternion = this.rotationQuaternion;
        else {
            rotationQuaternion = (0, $ha1VO.TmpVectors).Quaternion[1];
            (0, $ha1VO.Quaternion).RotationYawPitchRollToRef(this.rotation.y, this.rotation.x, this.rotation.z, rotationQuaternion);
        }
        const accumulation = (0, $ha1VO.TmpVectors).Quaternion[0];
        (0, $ha1VO.Quaternion).RotationYawPitchRollToRef(y, x, z, accumulation);
        rotationQuaternion.multiplyInPlace(accumulation);
        if (!this.rotationQuaternion) rotationQuaternion.toEulerAnglesToRef(this.rotation);
        return this;
    }
    /**
     * @internal
     */ _getEffectiveParent() {
        return this.parent;
    }
    /**
     * Returns whether the transform node world matrix computation needs the camera information to be computed.
     * This is the case when the node is a billboard or has an infinite distance for instance.
     * @returns true if the world matrix computation needs the camera information to be computed
     */ isWorldMatrixCameraDependent() {
        return this._infiniteDistance && !this.parent || this._billboardMode !== $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_NONE && !this.preserveParentRotationForBillboard;
    }
    /**
     * Computes the world matrix of the node
     * @param force defines if the cache version should be invalidated forcing the world matrix to be created from scratch
     * @param camera defines the camera used if different from the scene active camera (This is used with modes like Billboard or infinite distance)
     * @returns the world matrix
     */ computeWorldMatrix(force = false, camera = null) {
        if (this._isWorldMatrixFrozen && !this._isDirty) return this._worldMatrix;
        const currentRenderId = this.getScene().getRenderId();
        if (!this._isDirty && !force && (this._currentRenderId === currentRenderId || this.isSynchronized())) {
            this._currentRenderId = currentRenderId;
            return this._worldMatrix;
        }
        camera = camera || this.getScene().activeCamera;
        this._updateCache();
        const cache = this._cache;
        cache.pivotMatrixUpdated = false;
        cache.billboardMode = this.billboardMode;
        cache.infiniteDistance = this.infiniteDistance;
        cache.parent = this._parentNode;
        this._currentRenderId = currentRenderId;
        this._childUpdateId += 1;
        this._isDirty = false;
        this._position._isDirty = false;
        this._rotation._isDirty = false;
        this._scaling._isDirty = false;
        const parent = this._getEffectiveParent();
        // Scaling
        const scaling = $ecfbb5db4d70b862$export$b600d080bad015f._TmpScaling;
        let translation = this._position;
        // Translation
        if (this._infiniteDistance) {
            if (!this.parent && camera) {
                const cameraWorldMatrix = camera.getWorldMatrix();
                const cameraGlobalPosition = new (0, $ha1VO.Vector3)(cameraWorldMatrix.m[12], cameraWorldMatrix.m[13], cameraWorldMatrix.m[14]);
                translation = $ecfbb5db4d70b862$export$b600d080bad015f._TmpTranslation;
                translation.copyFromFloats(this._position.x + cameraGlobalPosition.x, this._position.y + cameraGlobalPosition.y, this._position.z + cameraGlobalPosition.z);
            }
        }
        // Scaling
        scaling.copyFromFloats(this._scaling.x * this.scalingDeterminant, this._scaling.y * this.scalingDeterminant, this._scaling.z * this.scalingDeterminant);
        // Rotation
        let rotation;
        if (this._rotationQuaternion) {
            this._rotationQuaternion._isDirty = false;
            rotation = this._rotationQuaternion;
            if (this.reIntegrateRotationIntoRotationQuaternion) {
                const len = this.rotation.lengthSquared();
                if (len) {
                    this._rotationQuaternion.multiplyInPlace((0, $ha1VO.Quaternion).RotationYawPitchRoll(this._rotation.y, this._rotation.x, this._rotation.z));
                    this._rotation.copyFromFloats(0, 0, 0);
                }
            }
        } else {
            rotation = $ecfbb5db4d70b862$export$b600d080bad015f._TmpRotation;
            (0, $ha1VO.Quaternion).RotationYawPitchRollToRef(this._rotation.y, this._rotation.x, this._rotation.z, rotation);
        }
        // Compose
        if (this._usePivotMatrix) {
            const scaleMatrix = (0, $ha1VO.TmpVectors).Matrix[1];
            (0, $ha1VO.Matrix).ScalingToRef(scaling.x, scaling.y, scaling.z, scaleMatrix);
            // Rotation
            const rotationMatrix = (0, $ha1VO.TmpVectors).Matrix[0];
            rotation.toRotationMatrix(rotationMatrix);
            // Composing transformations
            this._pivotMatrix.multiplyToRef(scaleMatrix, (0, $ha1VO.TmpVectors).Matrix[4]);
            (0, $ha1VO.TmpVectors).Matrix[4].multiplyToRef(rotationMatrix, this._localMatrix);
            // Post multiply inverse of pivotMatrix
            if (this._postMultiplyPivotMatrix) this._localMatrix.multiplyToRef(this._pivotMatrixInverse, this._localMatrix);
            this._localMatrix.addTranslationFromFloats(translation.x, translation.y, translation.z);
        } else (0, $ha1VO.Matrix).ComposeToRef(scaling, rotation, translation, this._localMatrix);
        // Parent
        if (parent && parent.getWorldMatrix) {
            if (force) parent.computeWorldMatrix(force);
            if (cache.useBillboardPath) {
                if (this._transformToBoneReferal) {
                    const bone = this.parent;
                    bone.getSkeleton().prepare();
                    bone.getFinalMatrix().multiplyToRef(this._transformToBoneReferal.getWorldMatrix(), (0, $ha1VO.TmpVectors).Matrix[7]);
                } else (0, $ha1VO.TmpVectors).Matrix[7].copyFrom(parent.getWorldMatrix());
                // Extract scaling and translation from parent
                const translation = (0, $ha1VO.TmpVectors).Vector3[5];
                const scale = (0, $ha1VO.TmpVectors).Vector3[6];
                const orientation = (0, $ha1VO.TmpVectors).Quaternion[0];
                (0, $ha1VO.TmpVectors).Matrix[7].decompose(scale, orientation, translation);
                (0, $ha1VO.Matrix).ScalingToRef(scale.x, scale.y, scale.z, (0, $ha1VO.TmpVectors).Matrix[7]);
                (0, $ha1VO.TmpVectors).Matrix[7].setTranslation(translation);
                if ($ecfbb5db4d70b862$export$b600d080bad015f.BillboardUseParentOrientation) {
                    // set localMatrix translation to be transformed against parent's orientation.
                    this._position.applyRotationQuaternionToRef(orientation, translation);
                    this._localMatrix.setTranslation(translation);
                }
                this._localMatrix.multiplyToRef((0, $ha1VO.TmpVectors).Matrix[7], this._worldMatrix);
            } else if (this._transformToBoneReferal) {
                const bone = this.parent;
                bone.getSkeleton().prepare();
                this._localMatrix.multiplyToRef(bone.getFinalMatrix(), (0, $ha1VO.TmpVectors).Matrix[6]);
                (0, $ha1VO.TmpVectors).Matrix[6].multiplyToRef(this._transformToBoneReferal.getWorldMatrix(), this._worldMatrix);
            } else this._localMatrix.multiplyToRef(parent.getWorldMatrix(), this._worldMatrix);
            this._markSyncedWithParent();
        } else this._worldMatrix.copyFrom(this._localMatrix);
        // Billboarding based on camera orientation (testing PG:http://www.babylonjs-playground.com/#UJEIL#13)
        if (cache.useBillboardPath && camera && this.billboardMode && !cache.useBillboardPosition) {
            const storedTranslation = (0, $ha1VO.TmpVectors).Vector3[0];
            this._worldMatrix.getTranslationToRef(storedTranslation); // Save translation
            // Cancel camera rotation
            (0, $ha1VO.TmpVectors).Matrix[1].copyFrom(camera.getViewMatrix());
            if (this._scene.useRightHandedSystem) (0, $ha1VO.TmpVectors).Matrix[1].multiplyToRef($ecfbb5db4d70b862$var$convertRHSToLHS, (0, $ha1VO.TmpVectors).Matrix[1]);
            (0, $ha1VO.TmpVectors).Matrix[1].setTranslationFromFloats(0, 0, 0);
            (0, $ha1VO.TmpVectors).Matrix[1].invertToRef((0, $ha1VO.TmpVectors).Matrix[0]);
            if ((this.billboardMode & $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_ALL) !== $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_ALL) {
                (0, $ha1VO.TmpVectors).Matrix[0].decompose(undefined, (0, $ha1VO.TmpVectors).Quaternion[0], undefined);
                const eulerAngles = (0, $ha1VO.TmpVectors).Vector3[1];
                (0, $ha1VO.TmpVectors).Quaternion[0].toEulerAnglesToRef(eulerAngles);
                if ((this.billboardMode & $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_X) !== $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_X) eulerAngles.x = 0;
                if ((this.billboardMode & $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_Y) !== $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_Y) eulerAngles.y = 0;
                if ((this.billboardMode & $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_Z) !== $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_Z) eulerAngles.z = 0;
                (0, $ha1VO.Matrix).RotationYawPitchRollToRef(eulerAngles.y, eulerAngles.x, eulerAngles.z, (0, $ha1VO.TmpVectors).Matrix[0]);
            }
            this._worldMatrix.setTranslationFromFloats(0, 0, 0);
            this._worldMatrix.multiplyToRef((0, $ha1VO.TmpVectors).Matrix[0], this._worldMatrix);
            // Restore translation
            this._worldMatrix.setTranslation((0, $ha1VO.TmpVectors).Vector3[0]);
        } else if (cache.useBillboardPath && camera && cache.useBillboardPosition) {
            const storedTranslation = (0, $ha1VO.TmpVectors).Vector3[0];
            // Save translation
            this._worldMatrix.getTranslationToRef(storedTranslation);
            // Compute camera position in local space
            const cameraPosition = camera.globalPosition;
            this._worldMatrix.invertToRef((0, $ha1VO.TmpVectors).Matrix[1]);
            const camInObjSpace = (0, $ha1VO.TmpVectors).Vector3[1];
            (0, $ha1VO.Vector3).TransformCoordinatesToRef(cameraPosition, (0, $ha1VO.TmpVectors).Matrix[1], camInObjSpace);
            camInObjSpace.normalize();
            // Find the lookAt info in local space
            const yaw = -Math.atan2(camInObjSpace.z, camInObjSpace.x) + Math.PI / 2;
            const len = Math.sqrt(camInObjSpace.x * camInObjSpace.x + camInObjSpace.z * camInObjSpace.z);
            const pitch = -Math.atan2(camInObjSpace.y, len);
            (0, $ha1VO.Quaternion).RotationYawPitchRollToRef(yaw, pitch, 0, (0, $ha1VO.TmpVectors).Quaternion[0]);
            if ((this.billboardMode & $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_ALL) !== $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_ALL) {
                const eulerAngles = (0, $ha1VO.TmpVectors).Vector3[1];
                (0, $ha1VO.TmpVectors).Quaternion[0].toEulerAnglesToRef(eulerAngles);
                if ((this.billboardMode & $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_X) !== $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_X) eulerAngles.x = 0;
                if ((this.billboardMode & $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_Y) !== $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_Y) eulerAngles.y = 0;
                if ((this.billboardMode & $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_Z) !== $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_Z) eulerAngles.z = 0;
                (0, $ha1VO.Matrix).RotationYawPitchRollToRef(eulerAngles.y, eulerAngles.x, eulerAngles.z, (0, $ha1VO.TmpVectors).Matrix[0]);
            } else (0, $ha1VO.Matrix).FromQuaternionToRef((0, $ha1VO.TmpVectors).Quaternion[0], (0, $ha1VO.TmpVectors).Matrix[0]);
            // Cancel translation
            this._worldMatrix.setTranslationFromFloats(0, 0, 0);
            // Rotate according to lookat (diff from local to lookat)
            this._worldMatrix.multiplyToRef((0, $ha1VO.TmpVectors).Matrix[0], this._worldMatrix);
            // Restore translation
            this._worldMatrix.setTranslation((0, $ha1VO.TmpVectors).Vector3[0]);
        }
        // Normal matrix
        if (!this.ignoreNonUniformScaling) {
            if (this._scaling.isNonUniformWithinEpsilon(0.000001)) this._updateNonUniformScalingState(true);
            else if (parent && parent._nonUniformScaling) this._updateNonUniformScalingState(parent._nonUniformScaling);
            else this._updateNonUniformScalingState(false);
        } else this._updateNonUniformScalingState(false);
        this._afterComputeWorldMatrix();
        // Absolute position
        this._absolutePosition.copyFromFloats(this._worldMatrix.m[12], this._worldMatrix.m[13], this._worldMatrix.m[14]);
        this._isAbsoluteSynced = false;
        // Callbacks
        this.onAfterWorldMatrixUpdateObservable.notifyObservers(this);
        if (!this._poseMatrix) this._poseMatrix = (0, $ha1VO.Matrix).Invert(this._worldMatrix);
        // Cache the determinant
        this._worldMatrixDeterminantIsDirty = true;
        return this._worldMatrix;
    }
    /**
     * Resets this nodeTransform's local matrix to Matrix.Identity().
     * @param independentOfChildren indicates if all child nodeTransform's world-space transform should be preserved.
     */ resetLocalMatrix(independentOfChildren = true) {
        this.computeWorldMatrix();
        if (independentOfChildren) {
            const children = this.getChildren();
            for(let i = 0; i < children.length; ++i){
                const child = children[i];
                if (child) {
                    child.computeWorldMatrix();
                    const bakedMatrix = (0, $ha1VO.TmpVectors).Matrix[0];
                    child._localMatrix.multiplyToRef(this._localMatrix, bakedMatrix);
                    const tmpRotationQuaternion = (0, $ha1VO.TmpVectors).Quaternion[0];
                    bakedMatrix.decompose(child.scaling, tmpRotationQuaternion, child.position);
                    if (child.rotationQuaternion) child.rotationQuaternion.copyFrom(tmpRotationQuaternion);
                    else tmpRotationQuaternion.toEulerAnglesToRef(child.rotation);
                }
            }
        }
        this.scaling.copyFromFloats(1, 1, 1);
        this.position.copyFromFloats(0, 0, 0);
        this.rotation.copyFromFloats(0, 0, 0);
        //only if quaternion is already set
        if (this.rotationQuaternion) this.rotationQuaternion = (0, $ha1VO.Quaternion).Identity();
        this._worldMatrix = (0, $ha1VO.Matrix).Identity();
    }
    _afterComputeWorldMatrix() {}
    /**
     * If you'd like to be called back after the mesh position, rotation or scaling has been updated.
     * @param func callback function to add
     *
     * @returns the TransformNode.
     */ registerAfterWorldMatrixUpdate(func) {
        this.onAfterWorldMatrixUpdateObservable.add(func);
        return this;
    }
    /**
     * Removes a registered callback function.
     * @param func callback function to remove
     * @returns the TransformNode.
     */ unregisterAfterWorldMatrixUpdate(func) {
        this.onAfterWorldMatrixUpdateObservable.removeCallback(func);
        return this;
    }
    /**
     * Gets the position of the current mesh in camera space
     * @param camera defines the camera to use
     * @returns a position
     */ getPositionInCameraSpace(camera = null) {
        if (!camera) camera = this.getScene().activeCamera;
        return (0, $ha1VO.Vector3).TransformCoordinates(this.getAbsolutePosition(), camera.getViewMatrix());
    }
    /**
     * Returns the distance from the mesh to the active camera
     * @param camera defines the camera to use
     * @returns the distance
     */ getDistanceToCamera(camera = null) {
        if (!camera) camera = this.getScene().activeCamera;
        return this.getAbsolutePosition().subtract(camera.globalPosition).length();
    }
    /**
     * Clone the current transform node
     * @param name Name of the new clone
     * @param newParent New parent for the clone
     * @param doNotCloneChildren Do not clone children hierarchy
     * @returns the new transform node
     */ clone(name, newParent, doNotCloneChildren) {
        const result = (0, $6Ho1L.SerializationHelper).Clone(()=>new $ecfbb5db4d70b862$export$b600d080bad015f(name, this.getScene()), this);
        result.name = name;
        result.id = name;
        if (newParent) result.parent = newParent;
        if (!doNotCloneChildren) {
            // Children
            const directDescendants = this.getDescendants(true);
            for(let index = 0; index < directDescendants.length; index++){
                const child = directDescendants[index];
                if (child.clone) child.clone(name + "." + child.name, result);
            }
        }
        return result;
    }
    /**
     * Serializes the objects information.
     * @param currentSerializationObject defines the object to serialize in
     * @returns the serialized object
     */ serialize(currentSerializationObject) {
        const serializationObject = (0, $6Ho1L.SerializationHelper).Serialize(this, currentSerializationObject);
        serializationObject.type = this.getClassName();
        serializationObject.uniqueId = this.uniqueId;
        // Parent
        if (this.parent) this.parent._serializeAsParent(serializationObject);
        serializationObject.localMatrix = this.getPivotMatrix().asArray();
        serializationObject.isEnabled = this.isEnabled();
        // Animations
        (0, $6Ho1L.SerializationHelper).AppendSerializedAnimations(this, serializationObject);
        serializationObject.ranges = this.serializeAnimationRanges();
        return serializationObject;
    }
    // Statics
    /**
     * Returns a new TransformNode object parsed from the source provided.
     * @param parsedTransformNode is the source.
     * @param scene the scene the object belongs to
     * @param rootUrl is a string, it's the root URL to prefix the `delayLoadingFile` property with
     * @returns a new TransformNode object parsed from the source provided.
     */ static Parse(parsedTransformNode, scene, rootUrl) {
        const transformNode = (0, $6Ho1L.SerializationHelper).Parse(()=>new $ecfbb5db4d70b862$export$b600d080bad015f(parsedTransformNode.name, scene), parsedTransformNode, scene, rootUrl);
        if (parsedTransformNode.localMatrix) transformNode.setPreTransformMatrix((0, $ha1VO.Matrix).FromArray(parsedTransformNode.localMatrix));
        else if (parsedTransformNode.pivotMatrix) transformNode.setPivotMatrix((0, $ha1VO.Matrix).FromArray(parsedTransformNode.pivotMatrix));
        transformNode.setEnabled(parsedTransformNode.isEnabled);
        transformNode._waitingParsedUniqueId = parsedTransformNode.uniqueId;
        // Parent
        if (parsedTransformNode.parentId !== undefined) transformNode._waitingParentId = parsedTransformNode.parentId;
        if (parsedTransformNode.parentInstanceIndex !== undefined) transformNode._waitingParentInstanceIndex = parsedTransformNode.parentInstanceIndex;
        // Animations
        if (parsedTransformNode.animations) {
            for(let animationIndex = 0; animationIndex < parsedTransformNode.animations.length; animationIndex++){
                const parsedAnimation = parsedTransformNode.animations[animationIndex];
                const internalClass = (0, $8DoUR.GetClass)("BABYLON.Animation");
                if (internalClass) transformNode.animations.push(internalClass.Parse(parsedAnimation));
            }
            (0, $bgssx.Node).ParseAnimationRanges(transformNode, parsedTransformNode, scene);
        }
        if (parsedTransformNode.autoAnimate) scene.beginAnimation(transformNode, parsedTransformNode.autoAnimateFrom, parsedTransformNode.autoAnimateTo, parsedTransformNode.autoAnimateLoop, parsedTransformNode.autoAnimateSpeed || 1.0);
        return transformNode;
    }
    /**
     * Get all child-transformNodes of this node
     * @param directDescendantsOnly defines if true only direct descendants of 'this' will be considered, if false direct and also indirect (children of children, an so on in a recursive manner) descendants of 'this' will be considered
     * @param predicate defines an optional predicate that will be called on every evaluated child, the predicate must return true for a given child to be part of the result, otherwise it will be ignored
     * @returns an array of TransformNode
     */ getChildTransformNodes(directDescendantsOnly, predicate) {
        const results = [];
        this._getDescendants(results, directDescendantsOnly, (node)=>{
            return (!predicate || predicate(node)) && node instanceof $ecfbb5db4d70b862$export$b600d080bad015f;
        });
        return results;
    }
    /**
     * Releases resources associated with this transform node.
     * @param doNotRecurse Set to true to not recurse into each children (recurse into each children by default)
     * @param disposeMaterialAndTextures Set to true to also dispose referenced materials and textures (false by default)
     */ dispose(doNotRecurse, disposeMaterialAndTextures = false) {
        // Animations
        this.getScene().stopAnimation(this);
        // Remove from scene
        this.getScene().removeTransformNode(this);
        if (this._parentContainer) {
            const index = this._parentContainer.transformNodes.indexOf(this);
            if (index > -1) this._parentContainer.transformNodes.splice(index, 1);
            this._parentContainer = null;
        }
        this.onAfterWorldMatrixUpdateObservable.clear();
        if (doNotRecurse) {
            const transformNodes = this.getChildTransformNodes(true);
            for (const transformNode of transformNodes){
                transformNode.parent = null;
                transformNode.computeWorldMatrix(true);
            }
        }
        super.dispose(doNotRecurse, disposeMaterialAndTextures);
    }
    /**
     * Uniformly scales the mesh to fit inside of a unit cube (1 X 1 X 1 units)
     * @param includeDescendants Use the hierarchy's bounding box instead of the mesh's bounding box. Default is false
     * @param ignoreRotation ignore rotation when computing the scale (ie. object will be axis aligned). Default is false
     * @param predicate predicate that is passed in to getHierarchyBoundingVectors when selecting which object should be included when scaling
     * @returns the current mesh
     */ normalizeToUnitCube(includeDescendants = true, ignoreRotation = false, predicate) {
        let storedRotation = null;
        let storedRotationQuaternion = null;
        if (ignoreRotation) {
            if (this.rotationQuaternion) {
                storedRotationQuaternion = this.rotationQuaternion.clone();
                this.rotationQuaternion.copyFromFloats(0, 0, 0, 1);
            } else if (this.rotation) {
                storedRotation = this.rotation.clone();
                this.rotation.copyFromFloats(0, 0, 0);
            }
        }
        const boundingVectors = this.getHierarchyBoundingVectors(includeDescendants, predicate);
        const sizeVec = boundingVectors.max.subtract(boundingVectors.min);
        const maxDimension = Math.max(sizeVec.x, sizeVec.y, sizeVec.z);
        if (maxDimension === 0) return this;
        const scale = 1 / maxDimension;
        this.scaling.scaleInPlace(scale);
        if (ignoreRotation) {
            if (this.rotationQuaternion && storedRotationQuaternion) this.rotationQuaternion.copyFrom(storedRotationQuaternion);
            else if (this.rotation && storedRotation) this.rotation.copyFrom(storedRotation);
        }
        return this;
    }
    _syncAbsoluteScalingAndRotation() {
        if (!this._isAbsoluteSynced) {
            this._worldMatrix.decompose(this._absoluteScaling, this._absoluteRotationQuaternion);
            this._isAbsoluteSynced = true;
        }
    }
}
// Statics
/**
 * Object will not rotate to face the camera
 */ $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_NONE = 0;
/**
 * Object will rotate to face the camera but only on the x axis
 */ $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_X = 1;
/**
 * Object will rotate to face the camera but only on the y axis
 */ $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_Y = 2;
/**
 * Object will rotate to face the camera but only on the z axis
 */ $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_Z = 4;
/**
 * Object will rotate to face the camera
 */ $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_ALL = 7;
/**
 * Object will rotate to face the camera's position instead of orientation
 */ $ecfbb5db4d70b862$export$b600d080bad015f.BILLBOARDMODE_USE_POSITION = 128;
/**
 * Child transform with Billboard flags should or should not apply parent rotation (default if off)
 */ $ecfbb5db4d70b862$export$b600d080bad015f.BillboardUseParentOrientation = false;
$ecfbb5db4d70b862$export$b600d080bad015f._TmpRotation = (0, $ha1VO.Quaternion).Zero();
$ecfbb5db4d70b862$export$b600d080bad015f._TmpScaling = (0, $ha1VO.Vector3).Zero();
$ecfbb5db4d70b862$export$b600d080bad015f._TmpTranslation = (0, $ha1VO.Vector3).Zero();
$ecfbb5db4d70b862$export$b600d080bad015f._LookAtVectorCache = new (0, $ha1VO.Vector3)(0, 0, 0);
$ecfbb5db4d70b862$export$b600d080bad015f._RotationAxisCache = new (0, $ha1VO.Quaternion)();
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsVector3)("position")
], $ecfbb5db4d70b862$export$b600d080bad015f.prototype, "_position", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsVector3)("rotation")
], $ecfbb5db4d70b862$export$b600d080bad015f.prototype, "_rotation", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsQuaternion)("rotationQuaternion")
], $ecfbb5db4d70b862$export$b600d080bad015f.prototype, "_rotationQuaternion", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsVector3)("scaling")
], $ecfbb5db4d70b862$export$b600d080bad015f.prototype, "_scaling", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("billboardMode")
], $ecfbb5db4d70b862$export$b600d080bad015f.prototype, "_billboardMode", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ecfbb5db4d70b862$export$b600d080bad015f.prototype, "scalingDeterminant", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("infiniteDistance")
], $ecfbb5db4d70b862$export$b600d080bad015f.prototype, "_infiniteDistance", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ecfbb5db4d70b862$export$b600d080bad015f.prototype, "ignoreNonUniformScaling", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ecfbb5db4d70b862$export$b600d080bad015f.prototype, "reIntegrateRotationIntoRotationQuaternion", void 0);

});

parcelRegister("dng66", function(module, exports) {

$parcel$export(module.exports, "_MeshCollisionData", () => $9bc9e8f1bdf7b64f$export$ca00c1cbe6d8a82e);

var $ha1VO = parcelRequire("ha1VO");
class $9bc9e8f1bdf7b64f$export$ca00c1cbe6d8a82e {
    constructor(){
        this._checkCollisions = false;
        this._collisionMask = -1;
        this._collisionGroup = -1;
        this._surroundingMeshes = null;
        this._collider = null;
        this._oldPositionForCollisions = new (0, $ha1VO.Vector3)(0, 0, 0);
        this._diffPositionForCollisions = new (0, $ha1VO.Vector3)(0, 0, 0);
        this._collisionResponse = true;
    }
}

});


parcelRegister("54229", function(module, exports) {

$parcel$export(module.exports, "Material", () => $3afee756ef198914$export$a2d8b23205c25948);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $bOhSV = parcelRequire("bOhSV");

var $diGQf = parcelRequire("diGQf");

var $ejQPp = parcelRequire("ejQPp");

var $lEBSs = parcelRequire("lEBSs");

var $ghoTi = parcelRequire("ghoTi");

var $kVtWi = parcelRequire("kVtWi");

var $23POp = parcelRequire("23POp");

var $hOyoX = parcelRequire("hOyoX");

var $7ZNtZ = parcelRequire("7ZNtZ");

var $gmbCk = parcelRequire("gmbCk");

var $7HBDq = parcelRequire("7HBDq");

var $alPCh = parcelRequire("alPCh");

var $6Ho1L = parcelRequire("6Ho1L");
class $3afee756ef198914$export$a2d8b23205c25948 {
    /**
     * If the material can be rendered to several textures with MRT extension
     */ get canRenderToMRT() {
        // By default, shaders are not compatible with MRTs
        // Base classes should override that if their shader supports MRT
        return false;
    }
    /**
     * Sets the alpha value of the material
     */ set alpha(value) {
        if (this._alpha === value) return;
        const oldValue = this._alpha;
        this._alpha = value;
        // Only call dirty when there is a state change (no alpha / alpha)
        if (oldValue === 1 || value === 1) this.markAsDirty($3afee756ef198914$export$a2d8b23205c25948.MiscDirtyFlag + $3afee756ef198914$export$a2d8b23205c25948.PrePassDirtyFlag);
    }
    /**
     * Gets the alpha value of the material
     */ get alpha() {
        return this._alpha;
    }
    /**
     * Sets the culling state (true to enable culling, false to disable)
     */ set backFaceCulling(value) {
        if (this._backFaceCulling === value) return;
        this._backFaceCulling = value;
        this.markAsDirty($3afee756ef198914$export$a2d8b23205c25948.TextureDirtyFlag);
    }
    /**
     * Gets the culling state
     */ get backFaceCulling() {
        return this._backFaceCulling;
    }
    /**
     * Sets the type of faces that should be culled (true for back faces, false for front faces)
     */ set cullBackFaces(value) {
        if (this._cullBackFaces === value) return;
        this._cullBackFaces = value;
        this.markAsDirty($3afee756ef198914$export$a2d8b23205c25948.TextureDirtyFlag);
    }
    /**
     * Gets the type of faces that should be culled
     */ get cullBackFaces() {
        return this._cullBackFaces;
    }
    /**
     * Block the dirty-mechanism for this specific material
     * When set to false after being true the material will be marked as dirty.
     */ get blockDirtyMechanism() {
        return this._blockDirtyMechanism;
    }
    set blockDirtyMechanism(value) {
        if (this._blockDirtyMechanism === value) return;
        this._blockDirtyMechanism = value;
        if (!value) this.markDirty();
    }
    /**
     * This allows you to modify the material without marking it as dirty after every change.
     * This function should be used if you need to make more than one dirty-enabling change to the material - adding a texture, setting a new fill mode and so on.
     * The callback will pass the material as an argument, so you can make your changes to it.
     * @param callback the callback to be executed that will update the material
     */ atomicMaterialsUpdate(callback) {
        this.blockDirtyMechanism = true;
        try {
            callback(this);
        } finally{
            this.blockDirtyMechanism = false;
        }
    }
    /**
     * Gets a boolean indicating that current material needs to register RTT
     */ get hasRenderTargetTextures() {
        this._eventInfo.hasRenderTargetTextures = false;
        this._callbackPluginEventHasRenderTargetTextures(this._eventInfo);
        return this._eventInfo.hasRenderTargetTextures;
    }
    /**
     * Called during a dispose event
     */ set onDispose(callback) {
        if (this._onDisposeObserver) this.onDisposeObservable.remove(this._onDisposeObserver);
        this._onDisposeObserver = this.onDisposeObservable.add(callback);
    }
    /**
     * An event triggered when the material is bound
     */ get onBindObservable() {
        if (!this._onBindObservable) this._onBindObservable = new (0, $diGQf.Observable)();
        return this._onBindObservable;
    }
    /**
     * Called during a bind event
     */ set onBind(callback) {
        if (this._onBindObserver) this.onBindObservable.remove(this._onBindObserver);
        this._onBindObserver = this.onBindObservable.add(callback);
    }
    /**
     * An event triggered when the material is unbound
     */ get onUnBindObservable() {
        if (!this._onUnBindObservable) this._onUnBindObservable = new (0, $diGQf.Observable)();
        return this._onUnBindObservable;
    }
    /**
     * An event triggered when the effect is (re)created
     */ get onEffectCreatedObservable() {
        if (!this._onEffectCreatedObservable) this._onEffectCreatedObservable = new (0, $diGQf.Observable)();
        return this._onEffectCreatedObservable;
    }
    /**
     * Sets the value of the alpha mode.
     *
     * | Value | Type | Description |
     * | --- | --- | --- |
     * | 0 | ALPHA_DISABLE |   |
     * | 1 | ALPHA_ADD |   |
     * | 2 | ALPHA_COMBINE |   |
     * | 3 | ALPHA_SUBTRACT |   |
     * | 4 | ALPHA_MULTIPLY |   |
     * | 5 | ALPHA_MAXIMIZED |   |
     * | 6 | ALPHA_ONEONE |   |
     * | 7 | ALPHA_PREMULTIPLIED |   |
     * | 8 | ALPHA_PREMULTIPLIED_PORTERDUFF |   |
     * | 9 | ALPHA_INTERPOLATE |   |
     * | 10 | ALPHA_SCREENMODE |   |
     *
     */ set alphaMode(value) {
        if (this._alphaMode === value) return;
        this._alphaMode = value;
        this.markAsDirty($3afee756ef198914$export$a2d8b23205c25948.TextureDirtyFlag);
    }
    /**
     * Gets the value of the alpha mode
     */ get alphaMode() {
        return this._alphaMode;
    }
    /**
     * Sets the need depth pre-pass value
     */ set needDepthPrePass(value) {
        if (this._needDepthPrePass === value) return;
        this._needDepthPrePass = value;
        if (this._needDepthPrePass) this.checkReadyOnEveryCall = true;
    }
    /**
     * Gets the depth pre-pass value
     */ get needDepthPrePass() {
        return this._needDepthPrePass;
    }
    /**
     * Can this material render to prepass
     */ get isPrePassCapable() {
        return false;
    }
    /**
     * Sets the state for enabling fog
     */ set fogEnabled(value) {
        if (this._fogEnabled === value) return;
        this._fogEnabled = value;
        this.markAsDirty($3afee756ef198914$export$a2d8b23205c25948.MiscDirtyFlag);
    }
    /**
     * Gets the value of the fog enabled state
     */ get fogEnabled() {
        return this._fogEnabled;
    }
    get wireframe() {
        switch(this._fillMode){
            case $3afee756ef198914$export$a2d8b23205c25948.WireFrameFillMode:
            case $3afee756ef198914$export$a2d8b23205c25948.LineListDrawMode:
            case $3afee756ef198914$export$a2d8b23205c25948.LineLoopDrawMode:
            case $3afee756ef198914$export$a2d8b23205c25948.LineStripDrawMode:
                return true;
        }
        return this._scene.forceWireframe;
    }
    /**
     * Sets the state of wireframe mode
     */ set wireframe(value) {
        this.fillMode = value ? $3afee756ef198914$export$a2d8b23205c25948.WireFrameFillMode : $3afee756ef198914$export$a2d8b23205c25948.TriangleFillMode;
    }
    /**
     * Gets the value specifying if point clouds are enabled
     */ get pointsCloud() {
        switch(this._fillMode){
            case $3afee756ef198914$export$a2d8b23205c25948.PointFillMode:
            case $3afee756ef198914$export$a2d8b23205c25948.PointListDrawMode:
                return true;
        }
        return this._scene.forcePointsCloud;
    }
    /**
     * Sets the state of point cloud mode
     */ set pointsCloud(value) {
        this.fillMode = value ? $3afee756ef198914$export$a2d8b23205c25948.PointFillMode : $3afee756ef198914$export$a2d8b23205c25948.TriangleFillMode;
    }
    /**
     * Gets the material fill mode
     */ get fillMode() {
        return this._fillMode;
    }
    /**
     * Sets the material fill mode
     */ set fillMode(value) {
        if (this._fillMode === value) return;
        this._fillMode = value;
        this.markAsDirty($3afee756ef198914$export$a2d8b23205c25948.MiscDirtyFlag);
    }
    /**
     * In case the depth buffer does not allow enough depth precision for your scene (might be the case in large scenes)
     * You can try switching to logarithmic depth.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/advanced/logarithmicDepthBuffer
     */ get useLogarithmicDepth() {
        return this._useLogarithmicDepth;
    }
    set useLogarithmicDepth(value) {
        const fragmentDepthSupported = this.getScene().getEngine().getCaps().fragmentDepthSupported;
        if (value && !fragmentDepthSupported) (0, $kVtWi.Logger).Warn("Logarithmic depth has been requested for a material on a device that doesn't support it.");
        this._useLogarithmicDepth = value && fragmentDepthSupported;
        this._markAllSubMeshesAsMiscDirty();
    }
    /** @internal */ _getDrawWrapper() {
        return this._drawWrapper;
    }
    /**
     * @internal
     */ _setDrawWrapper(drawWrapper) {
        this._drawWrapper = drawWrapper;
    }
    /**
     * Creates a material instance
     * @param name defines the name of the material
     * @param scene defines the scene to reference
     * @param doNotAdd specifies if the material should be added to the scene
     */ constructor(name, scene, doNotAdd){
        /**
         * Custom shadow depth material to use for shadow rendering instead of the in-built one
         */ this.shadowDepthWrapper = null;
        /**
         * Gets or sets a boolean indicating that the material is allowed (if supported) to do shader hot swapping.
         * This means that the material can keep using a previous shader while a new one is being compiled.
         * This is mostly used when shader parallel compilation is supported (true by default)
         */ this.allowShaderHotSwapping = true;
        /**
         * Gets or sets user defined metadata
         */ this.metadata = null;
        /**
         * For internal use only. Please do not use.
         */ this.reservedDataStore = null;
        /**
         * Specifies if the ready state should be checked on each call
         */ this.checkReadyOnEveryCall = false;
        /**
         * Specifies if the ready state should be checked once
         */ this.checkReadyOnlyOnce = false;
        /**
         * The state of the material
         */ this.state = "";
        /**
         * The alpha value of the material
         */ this._alpha = 1.0;
        /**
         * Specifies if back face culling is enabled
         */ this._backFaceCulling = true;
        /**
         * Specifies if back or front faces should be culled (when culling is enabled)
         */ this._cullBackFaces = true;
        this._blockDirtyMechanism = false;
        /**
         * Callback triggered when the material is compiled
         */ this.onCompiled = null;
        /**
         * Callback triggered when an error occurs
         */ this.onError = null;
        /**
         * Callback triggered to get the render target textures
         */ this.getRenderTargetTextures = null;
        /**
         * Specifies if the material should be serialized
         */ this.doNotSerialize = false;
        /**
         * @internal
         */ this._storeEffectOnSubMeshes = false;
        /**
         * Stores the animations for the material
         */ this.animations = null;
        /**
         * An event triggered when the material is disposed
         */ this.onDisposeObservable = new (0, $diGQf.Observable)();
        /**
         * An observer which watches for dispose events
         */ this._onDisposeObserver = null;
        this._onUnBindObservable = null;
        /**
         * An observer which watches for bind events
         */ this._onBindObserver = null;
        /**
         * Stores the value of the alpha mode
         */ this._alphaMode = 2;
        /**
         * Stores the state of the need depth pre-pass value
         */ this._needDepthPrePass = false;
        /**
         * Specifies if depth writing should be disabled
         */ this.disableDepthWrite = false;
        /**
         * Specifies if color writing should be disabled
         */ this.disableColorWrite = false;
        /**
         * Specifies if depth writing should be forced
         */ this.forceDepthWrite = false;
        /**
         * Specifies the depth function that should be used. 0 means the default engine function
         */ this.depthFunction = 0;
        /**
         * Specifies if there should be a separate pass for culling
         */ this.separateCullingPass = false;
        /**
         * Stores the state specifying if fog should be enabled
         */ this._fogEnabled = true;
        /**
         * Stores the size of points
         */ this.pointSize = 1.0;
        /**
         * Stores the z offset Factor value
         */ this.zOffset = 0;
        /**
         * Stores the z offset Units value
         */ this.zOffsetUnits = 0;
        /**
         * Gives access to the stencil properties of the material
         */ this.stencil = new (0, $7ZNtZ.MaterialStencilState)();
        /**
         * Specifies if uniform buffers should be used
         */ this._useUBO = false;
        /**
         * Stores the fill mode state
         */ this._fillMode = $3afee756ef198914$export$a2d8b23205c25948.TriangleFillMode;
        /**
         * Specifies if the depth write state should be cached
         */ this._cachedDepthWriteState = false;
        /**
         * Specifies if the color write state should be cached
         */ this._cachedColorWriteState = false;
        /**
         * Specifies if the depth function state should be cached
         */ this._cachedDepthFunctionState = 0;
        /** @internal */ this._indexInSceneMaterialArray = -1;
        /** @internal */ this.meshMap = null;
        /** @internal */ this._parentContainer = null;
        /** @internal */ this._uniformBufferLayoutBuilt = false;
        this._eventInfo = {}; // will be initialized before each event notification
        /** @internal */ this._callbackPluginEventGeneric = ()=>void 0;
        /** @internal */ this._callbackPluginEventIsReadyForSubMesh = ()=>void 0;
        /** @internal */ this._callbackPluginEventPrepareDefines = ()=>void 0;
        /** @internal */ this._callbackPluginEventPrepareDefinesBeforeAttributes = ()=>void 0;
        /** @internal */ this._callbackPluginEventHardBindForSubMesh = ()=>void 0;
        /** @internal */ this._callbackPluginEventBindForSubMesh = ()=>void 0;
        /** @internal */ this._callbackPluginEventHasRenderTargetTextures = ()=>void 0;
        /** @internal */ this._callbackPluginEventFillRenderTargetTextures = ()=>void 0;
        /**
         * Enforces alpha test in opaque or blend mode in order to improve the performances of some situations.
         */ this._forceAlphaTest = false;
        /**
         * The transparency mode of the material.
         */ this._transparencyMode = null;
        this.name = name;
        const setScene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        if (!setScene) return;
        this._scene = setScene;
        this._dirtyCallbacks = {};
        this._dirtyCallbacks[1] = this._markAllSubMeshesAsTexturesDirty.bind(this);
        this._dirtyCallbacks[2] = this._markAllSubMeshesAsLightsDirty.bind(this);
        this._dirtyCallbacks[4] = this._markAllSubMeshesAsFresnelDirty.bind(this);
        this._dirtyCallbacks[8] = this._markAllSubMeshesAsAttributesDirty.bind(this);
        this._dirtyCallbacks[16] = this._markAllSubMeshesAsMiscDirty.bind(this);
        this._dirtyCallbacks[32] = this._markAllSubMeshesAsPrePassDirty.bind(this);
        this._dirtyCallbacks[63] = this._markAllSubMeshesAsAllDirty.bind(this);
        this.id = name || (0, $bOhSV.Tools).RandomId();
        this.uniqueId = this._scene.getUniqueId();
        this._materialContext = this._scene.getEngine().createMaterialContext();
        this._drawWrapper = new (0, $hOyoX.DrawWrapper)(this._scene.getEngine(), false);
        this._drawWrapper.materialContext = this._materialContext;
        if (this._scene.useRightHandedSystem) this.sideOrientation = $3afee756ef198914$export$a2d8b23205c25948.ClockWiseSideOrientation;
        else this.sideOrientation = $3afee756ef198914$export$a2d8b23205c25948.CounterClockWiseSideOrientation;
        this._uniformBuffer = new (0, $ghoTi.UniformBuffer)(this._scene.getEngine(), undefined, undefined, name);
        this._useUBO = this.getScene().getEngine().supportsUniformBuffers;
        if (!doNotAdd) this._scene.addMaterial(this);
        if (this._scene.useMaterialMeshMap) this.meshMap = {};
        $3afee756ef198914$export$a2d8b23205c25948.OnEventObservable.notifyObservers(this, (0, $7HBDq.MaterialPluginEvent).Created);
    }
    /**
     * Returns a string representation of the current material
     * @param fullDetails defines a boolean indicating which levels of logging is desired
     * @returns a string with material information
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    toString(fullDetails) {
        const ret = "Name: " + this.name;
        return ret;
    }
    /**
     * Gets the class name of the material
     * @returns a string with the class name of the material
     */ getClassName() {
        return "Material";
    }
    /** @internal */ get _isMaterial() {
        return true;
    }
    /**
     * Specifies if updates for the material been locked
     */ get isFrozen() {
        return this.checkReadyOnlyOnce;
    }
    /**
     * Locks updates for the material
     */ freeze() {
        this.markDirty();
        this.checkReadyOnlyOnce = true;
    }
    /**
     * Unlocks updates for the material
     */ unfreeze() {
        this.markDirty();
        this.checkReadyOnlyOnce = false;
    }
    /**
     * Specifies if the material is ready to be used
     * @param mesh defines the mesh to check
     * @param useInstances specifies if instances should be used
     * @returns a boolean indicating if the material is ready to be used
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isReady(mesh, useInstances) {
        return true;
    }
    /**
     * Specifies that the submesh is ready to be used
     * @param mesh defines the mesh to check
     * @param subMesh defines which submesh to check
     * @param useInstances specifies that instances should be used
     * @returns a boolean indicating that the submesh is ready or not
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isReadyForSubMesh(mesh, subMesh, useInstances) {
        const defines = subMesh.materialDefines;
        if (!defines) return false;
        this._eventInfo.isReadyForSubMesh = true;
        this._eventInfo.defines = defines;
        this._callbackPluginEventIsReadyForSubMesh(this._eventInfo);
        return this._eventInfo.isReadyForSubMesh;
    }
    /**
     * Returns the material effect
     * @returns the effect associated with the material
     */ getEffect() {
        return this._drawWrapper.effect;
    }
    /**
     * Returns the current scene
     * @returns a Scene
     */ getScene() {
        return this._scene;
    }
    /**
     * Gets the current transparency mode.
     */ get transparencyMode() {
        return this._transparencyMode;
    }
    /**
     * Sets the transparency mode of the material.
     *
     * | Value | Type                                | Description |
     * | ----- | ----------------------------------- | ----------- |
     * | 0     | OPAQUE                              |             |
     * | 1     | ALPHATEST                           |             |
     * | 2     | ALPHABLEND                          |             |
     * | 3     | ALPHATESTANDBLEND                   |             |
     *
     */ set transparencyMode(value) {
        if (this._transparencyMode === value) return;
        this._transparencyMode = value;
        this._forceAlphaTest = value === $3afee756ef198914$export$a2d8b23205c25948.MATERIAL_ALPHATESTANDBLEND;
        this._markAllSubMeshesAsTexturesAndMiscDirty();
    }
    /**
     * Returns true if alpha blending should be disabled.
     */ get _disableAlphaBlending() {
        return this._transparencyMode === $3afee756ef198914$export$a2d8b23205c25948.MATERIAL_OPAQUE || this._transparencyMode === $3afee756ef198914$export$a2d8b23205c25948.MATERIAL_ALPHATEST;
    }
    /**
     * Specifies whether or not this material should be rendered in alpha blend mode.
     * @returns a boolean specifying if alpha blending is needed
     */ needAlphaBlending() {
        if (this._disableAlphaBlending) return false;
        return this.alpha < 1.0;
    }
    /**
     * Specifies if the mesh will require alpha blending
     * @param mesh defines the mesh to check
     * @returns a boolean specifying if alpha blending is needed for the mesh
     */ needAlphaBlendingForMesh(mesh) {
        if (mesh.visibility < 1.0) return true;
        if (this._disableAlphaBlending) return false;
        return mesh.hasVertexAlpha || this.needAlphaBlending();
    }
    /**
     * Specifies whether or not this material should be rendered in alpha test mode.
     * @returns a boolean specifying if an alpha test is needed.
     */ needAlphaTesting() {
        if (this._forceAlphaTest) return true;
        return false;
    }
    /**
     * Specifies if material alpha testing should be turned on for the mesh
     * @param mesh defines the mesh to check
     * @returns a boolean specifying if alpha testing should be turned on for the mesh
     */ _shouldTurnAlphaTestOn(mesh) {
        return !this.needAlphaBlendingForMesh(mesh) && this.needAlphaTesting();
    }
    /**
     * Gets the texture used for the alpha test
     * @returns the texture to use for alpha testing
     */ getAlphaTestTexture() {
        return null;
    }
    /**
     * Marks the material to indicate that it needs to be re-calculated
     * @param forceMaterialDirty - Forces the material to be marked as dirty for all components (same as this.markAsDirty(Material.AllDirtyFlag)). You should use this flag if the material is frozen and you want to force a recompilation.
     */ markDirty(forceMaterialDirty = false) {
        const meshes = this.getScene().meshes;
        for (const mesh of meshes){
            if (!mesh.subMeshes) continue;
            for (const subMesh of mesh.subMeshes){
                if (subMesh.getMaterial() !== this) continue;
                for (const drawWrapper of subMesh._drawWrappers){
                    if (!drawWrapper) continue;
                    if (this._materialContext === drawWrapper.materialContext) {
                        drawWrapper._wasPreviouslyReady = false;
                        drawWrapper._wasPreviouslyUsingInstances = null;
                        drawWrapper._forceRebindOnNextCall = forceMaterialDirty;
                    }
                }
            }
        }
        if (forceMaterialDirty) this.markAsDirty($3afee756ef198914$export$a2d8b23205c25948.AllDirtyFlag);
    }
    /**
     * @internal
     */ _preBind(effect, overrideOrientation = null) {
        const engine = this._scene.getEngine();
        const orientation = overrideOrientation == null ? this.sideOrientation : overrideOrientation;
        const reverse = orientation === $3afee756ef198914$export$a2d8b23205c25948.ClockWiseSideOrientation;
        engine.enableEffect(effect ? effect : this._getDrawWrapper());
        engine.setState(this.backFaceCulling, this.zOffset, false, reverse, this._scene._mirroredCameraPosition ? !this.cullBackFaces : this.cullBackFaces, this.stencil, this.zOffsetUnits);
        return reverse;
    }
    /**
     * Binds the material to the mesh
     * @param world defines the world transformation matrix
     * @param mesh defines the mesh to bind the material to
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    bind(world, mesh) {}
    /**
     * Initializes the uniform buffer layout for the shader.
     */ buildUniformLayout() {
        const ubo = this._uniformBuffer;
        this._eventInfo.ubo = ubo;
        this._callbackPluginEventGeneric((0, $7HBDq.MaterialPluginEvent).PrepareUniformBuffer, this._eventInfo);
        ubo.create();
        this._uniformBufferLayoutBuilt = true;
    }
    /**
     * Binds the submesh to the material
     * @param world defines the world transformation matrix
     * @param mesh defines the mesh containing the submesh
     * @param subMesh defines the submesh to bind the material to
     */ bindForSubMesh(world, mesh, subMesh) {
        const drawWrapper = subMesh._drawWrapper;
        this._eventInfo.subMesh = subMesh;
        this._callbackPluginEventBindForSubMesh(this._eventInfo);
        drawWrapper._forceRebindOnNextCall = false;
    }
    /**
     * Binds the world matrix to the material
     * @param world defines the world transformation matrix
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    bindOnlyWorldMatrix(world) {}
    /**
     * Binds the view matrix to the effect
     * @param effect defines the effect to bind the view matrix to
     */ bindView(effect) {
        if (!this._useUBO) effect.setMatrix("view", this.getScene().getViewMatrix());
        else this._needToBindSceneUbo = true;
    }
    /**
     * Binds the view projection and projection matrices to the effect
     * @param effect defines the effect to bind the view projection and projection matrices to
     */ bindViewProjection(effect) {
        if (!this._useUBO) {
            effect.setMatrix("viewProjection", this.getScene().getTransformMatrix());
            effect.setMatrix("projection", this.getScene().getProjectionMatrix());
        } else this._needToBindSceneUbo = true;
    }
    /**
     * Binds the view matrix to the effect
     * @param effect defines the effect to bind the view matrix to
     * @param variableName name of the shader variable that will hold the eye position
     */ bindEyePosition(effect, variableName) {
        if (!this._useUBO) this._scene.bindEyePosition(effect, variableName);
        else this._needToBindSceneUbo = true;
    }
    /**
     * Processes to execute after binding the material to a mesh
     * @param mesh defines the rendered mesh
     * @param effect defines the effect used to bind the material
     * @param _subMesh defines the subMesh that the material has been bound for
     */ _afterBind(mesh, effect = null, _subMesh) {
        this._scene._cachedMaterial = this;
        if (this._needToBindSceneUbo) {
            if (effect) {
                this._needToBindSceneUbo = false;
                (0, $alPCh.BindSceneUniformBuffer)(effect, this.getScene().getSceneUniformBuffer());
                this._scene.finalizeSceneUbo();
            }
        }
        if (mesh) this._scene._cachedVisibility = mesh.visibility;
        else this._scene._cachedVisibility = 1;
        if (this._onBindObservable && mesh) this._onBindObservable.notifyObservers(mesh);
        if (this.disableDepthWrite) {
            const engine = this._scene.getEngine();
            this._cachedDepthWriteState = engine.getDepthWrite();
            engine.setDepthWrite(false);
        }
        if (this.disableColorWrite) {
            const engine = this._scene.getEngine();
            this._cachedColorWriteState = engine.getColorWrite();
            engine.setColorWrite(false);
        }
        if (this.depthFunction !== 0) {
            const engine = this._scene.getEngine();
            this._cachedDepthFunctionState = engine.getDepthFunction() || 0;
            engine.setDepthFunction(this.depthFunction);
        }
    }
    /**
     * Unbinds the material from the mesh
     */ unbind() {
        if (this._onUnBindObservable) this._onUnBindObservable.notifyObservers(this);
        if (this.depthFunction !== 0) {
            const engine = this._scene.getEngine();
            engine.setDepthFunction(this._cachedDepthFunctionState);
        }
        if (this.disableDepthWrite) {
            const engine = this._scene.getEngine();
            engine.setDepthWrite(this._cachedDepthWriteState);
        }
        if (this.disableColorWrite) {
            const engine = this._scene.getEngine();
            engine.setColorWrite(this._cachedColorWriteState);
        }
    }
    /**
     * Returns the animatable textures.
     * @returns - Array of animatable textures.
     */ getAnimatables() {
        this._eventInfo.animatables = [];
        this._callbackPluginEventGeneric((0, $7HBDq.MaterialPluginEvent).GetAnimatables, this._eventInfo);
        return this._eventInfo.animatables;
    }
    /**
     * Gets the active textures from the material
     * @returns an array of textures
     */ getActiveTextures() {
        this._eventInfo.activeTextures = [];
        this._callbackPluginEventGeneric((0, $7HBDq.MaterialPluginEvent).GetActiveTextures, this._eventInfo);
        return this._eventInfo.activeTextures;
    }
    /**
     * Specifies if the material uses a texture
     * @param texture defines the texture to check against the material
     * @returns a boolean specifying if the material uses the texture
     */ hasTexture(texture) {
        this._eventInfo.hasTexture = false;
        this._eventInfo.texture = texture;
        this._callbackPluginEventGeneric((0, $7HBDq.MaterialPluginEvent).HasTexture, this._eventInfo);
        return this._eventInfo.hasTexture;
    }
    /**
     * Makes a duplicate of the material, and gives it a new name
     * @param name defines the new name for the duplicated material
     * @returns the cloned material
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    clone(name) {
        return null;
    }
    _clonePlugins(targetMaterial, rootUrl) {
        const serializationObject = {};
        // Create plugins in targetMaterial in case they don't exist
        this._serializePlugins(serializationObject);
        $3afee756ef198914$export$a2d8b23205c25948._ParsePlugins(serializationObject, targetMaterial, this._scene, rootUrl);
        // Copy the properties of the current plugins to the cloned material's plugins
        if (this.pluginManager) for (const plugin of this.pluginManager._plugins){
            const targetPlugin = targetMaterial.pluginManager.getPlugin(plugin.name);
            if (targetPlugin) plugin.copyTo(targetPlugin);
        }
    }
    /**
     * Gets the meshes bound to the material
     * @returns an array of meshes bound to the material
     */ getBindedMeshes() {
        if (this.meshMap) {
            const result = [];
            for(const meshId in this.meshMap){
                const mesh = this.meshMap[meshId];
                if (mesh) result.push(mesh);
            }
            return result;
        } else {
            const meshes = this._scene.meshes;
            return meshes.filter((mesh)=>mesh.material === this);
        }
    }
    /**
     * Force shader compilation
     * @param mesh defines the mesh associated with this material
     * @param onCompiled defines a function to execute once the material is compiled
     * @param options defines the options to configure the compilation
     * @param onError defines a function to execute if the material fails compiling
     */ forceCompilation(mesh, onCompiled, options, onError) {
        const localOptions = {
            clipPlane: false,
            useInstances: false,
            ...options
        };
        const scene = this.getScene();
        const currentHotSwapingState = this.allowShaderHotSwapping;
        this.allowShaderHotSwapping = false; // Turned off to let us evaluate the real compilation state
        const checkReady = ()=>{
            if (!this._scene || !this._scene.getEngine()) return;
            const clipPlaneState = scene.clipPlane;
            if (localOptions.clipPlane) scene.clipPlane = new (0, $23POp.Plane)(0, 0, 0, 1);
            if (this._storeEffectOnSubMeshes) {
                let allDone = true, lastError = null;
                if (mesh.subMeshes) {
                    const tempSubMesh = new (0, $lEBSs.SubMesh)(0, 0, 0, 0, 0, mesh, undefined, false, false);
                    if (tempSubMesh.materialDefines) tempSubMesh.materialDefines._renderId = -1;
                    if (!this.isReadyForSubMesh(mesh, tempSubMesh, localOptions.useInstances)) {
                        if (tempSubMesh.effect && tempSubMesh.effect.getCompilationError() && tempSubMesh.effect.allFallbacksProcessed()) lastError = tempSubMesh.effect.getCompilationError();
                        else {
                            allDone = false;
                            setTimeout(checkReady, 16);
                        }
                    }
                }
                if (allDone) {
                    this.allowShaderHotSwapping = currentHotSwapingState;
                    if (lastError) {
                        if (onError) onError(lastError);
                    }
                    if (onCompiled) onCompiled(this);
                }
            } else if (this.isReady()) {
                this.allowShaderHotSwapping = currentHotSwapingState;
                if (onCompiled) onCompiled(this);
            } else setTimeout(checkReady, 16);
            if (localOptions.clipPlane) scene.clipPlane = clipPlaneState;
        };
        checkReady();
    }
    /**
     * Force shader compilation
     * @param mesh defines the mesh that will use this material
     * @param options defines additional options for compiling the shaders
     * @returns a promise that resolves when the compilation completes
     */ forceCompilationAsync(mesh, options) {
        return new Promise((resolve, reject)=>{
            this.forceCompilation(mesh, ()=>{
                resolve();
            }, options, (reason)=>{
                reject(reason);
            });
        });
    }
    /**
     * Marks a define in the material to indicate that it needs to be re-computed
     * @param flag defines a flag used to determine which parts of the material have to be marked as dirty
     */ markAsDirty(flag) {
        if (this.getScene().blockMaterialDirtyMechanism || this._blockDirtyMechanism) return;
        $3afee756ef198914$export$a2d8b23205c25948._DirtyCallbackArray.length = 0;
        if (flag & $3afee756ef198914$export$a2d8b23205c25948.TextureDirtyFlag) $3afee756ef198914$export$a2d8b23205c25948._DirtyCallbackArray.push($3afee756ef198914$export$a2d8b23205c25948._TextureDirtyCallBack);
        if (flag & $3afee756ef198914$export$a2d8b23205c25948.LightDirtyFlag) $3afee756ef198914$export$a2d8b23205c25948._DirtyCallbackArray.push($3afee756ef198914$export$a2d8b23205c25948._LightsDirtyCallBack);
        if (flag & $3afee756ef198914$export$a2d8b23205c25948.FresnelDirtyFlag) $3afee756ef198914$export$a2d8b23205c25948._DirtyCallbackArray.push($3afee756ef198914$export$a2d8b23205c25948._FresnelDirtyCallBack);
        if (flag & $3afee756ef198914$export$a2d8b23205c25948.AttributesDirtyFlag) $3afee756ef198914$export$a2d8b23205c25948._DirtyCallbackArray.push($3afee756ef198914$export$a2d8b23205c25948._AttributeDirtyCallBack);
        if (flag & $3afee756ef198914$export$a2d8b23205c25948.MiscDirtyFlag) $3afee756ef198914$export$a2d8b23205c25948._DirtyCallbackArray.push($3afee756ef198914$export$a2d8b23205c25948._MiscDirtyCallBack);
        if (flag & $3afee756ef198914$export$a2d8b23205c25948.PrePassDirtyFlag) $3afee756ef198914$export$a2d8b23205c25948._DirtyCallbackArray.push($3afee756ef198914$export$a2d8b23205c25948._PrePassDirtyCallBack);
        if ($3afee756ef198914$export$a2d8b23205c25948._DirtyCallbackArray.length) this._markAllSubMeshesAsDirty($3afee756ef198914$export$a2d8b23205c25948._RunDirtyCallBacks);
        this.getScene().resetCachedMaterial();
    }
    /**
     * Resets the draw wrappers cache for all submeshes that are using this material
     */ resetDrawCache() {
        const meshes = this.getScene().meshes;
        for (const mesh of meshes){
            if (!mesh.subMeshes) continue;
            for (const subMesh of mesh.subMeshes){
                if (subMesh.getMaterial() !== this) continue;
                subMesh.resetDrawCache();
            }
        }
    }
    /**
     * Marks all submeshes of a material to indicate that their material defines need to be re-calculated
     * @param func defines a function which checks material defines against the submeshes
     */ _markAllSubMeshesAsDirty(func) {
        if (this.getScene().blockMaterialDirtyMechanism || this._blockDirtyMechanism) return;
        const meshes = this.getScene().meshes;
        for (const mesh of meshes){
            if (!mesh.subMeshes) continue;
            for (const subMesh of mesh.subMeshes){
                // We want to skip the submeshes which are not using this material or which have not yet rendered at least once
                if (subMesh.getMaterial(false) !== this) continue;
                for (const drawWrapper of subMesh._drawWrappers){
                    if (!drawWrapper || !drawWrapper.defines || !drawWrapper.defines.markAllAsDirty) continue;
                    if (this._materialContext === drawWrapper.materialContext) func(drawWrapper.defines);
                }
            }
        }
    }
    /**
     * Indicates that the scene should check if the rendering now needs a prepass
     */ _markScenePrePassDirty() {
        if (this.getScene().blockMaterialDirtyMechanism || this._blockDirtyMechanism) return;
        const prePassRenderer = this.getScene().enablePrePassRenderer();
        if (prePassRenderer) prePassRenderer.markAsDirty();
    }
    /**
     * Indicates that we need to re-calculated for all submeshes
     */ _markAllSubMeshesAsAllDirty() {
        this._markAllSubMeshesAsDirty($3afee756ef198914$export$a2d8b23205c25948._AllDirtyCallBack);
    }
    /**
     * Indicates that image processing needs to be re-calculated for all submeshes
     */ _markAllSubMeshesAsImageProcessingDirty() {
        this._markAllSubMeshesAsDirty($3afee756ef198914$export$a2d8b23205c25948._ImageProcessingDirtyCallBack);
    }
    /**
     * Indicates that textures need to be re-calculated for all submeshes
     */ _markAllSubMeshesAsTexturesDirty() {
        this._markAllSubMeshesAsDirty($3afee756ef198914$export$a2d8b23205c25948._TextureDirtyCallBack);
    }
    /**
     * Indicates that fresnel needs to be re-calculated for all submeshes
     */ _markAllSubMeshesAsFresnelDirty() {
        this._markAllSubMeshesAsDirty($3afee756ef198914$export$a2d8b23205c25948._FresnelDirtyCallBack);
    }
    /**
     * Indicates that fresnel and misc need to be re-calculated for all submeshes
     */ _markAllSubMeshesAsFresnelAndMiscDirty() {
        this._markAllSubMeshesAsDirty($3afee756ef198914$export$a2d8b23205c25948._FresnelAndMiscDirtyCallBack);
    }
    /**
     * Indicates that lights need to be re-calculated for all submeshes
     */ _markAllSubMeshesAsLightsDirty() {
        this._markAllSubMeshesAsDirty($3afee756ef198914$export$a2d8b23205c25948._LightsDirtyCallBack);
    }
    /**
     * Indicates that attributes need to be re-calculated for all submeshes
     */ _markAllSubMeshesAsAttributesDirty() {
        this._markAllSubMeshesAsDirty($3afee756ef198914$export$a2d8b23205c25948._AttributeDirtyCallBack);
    }
    /**
     * Indicates that misc needs to be re-calculated for all submeshes
     */ _markAllSubMeshesAsMiscDirty() {
        this._markAllSubMeshesAsDirty($3afee756ef198914$export$a2d8b23205c25948._MiscDirtyCallBack);
    }
    /**
     * Indicates that prepass needs to be re-calculated for all submeshes
     */ _markAllSubMeshesAsPrePassDirty() {
        this._markAllSubMeshesAsDirty($3afee756ef198914$export$a2d8b23205c25948._MiscDirtyCallBack);
    }
    /**
     * Indicates that textures and misc need to be re-calculated for all submeshes
     */ _markAllSubMeshesAsTexturesAndMiscDirty() {
        this._markAllSubMeshesAsDirty($3afee756ef198914$export$a2d8b23205c25948._TextureAndMiscDirtyCallBack);
    }
    _checkScenePerformancePriority() {
        if (this._scene.performancePriority !== (0, $gmbCk.ScenePerformancePriority).BackwardCompatible) {
            this.checkReadyOnlyOnce = true;
            // re-set the flag when the perf priority changes
            const observer = this._scene.onScenePerformancePriorityChangedObservable.addOnce(()=>{
                this.checkReadyOnlyOnce = false;
            });
            // if this material is disposed before the scene is disposed, cleanup the observer
            this.onDisposeObservable.add(()=>{
                this._scene.onScenePerformancePriorityChangedObservable.remove(observer);
            });
        }
    }
    /**
     * Sets the required values to the prepass renderer.
     * @param prePassRenderer defines the prepass renderer to setup.
     * @returns true if the pre pass is needed.
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setPrePassRenderer(prePassRenderer) {
        // Do Nothing by default
        return false;
    }
    /**
     * Disposes the material
     * @param forceDisposeEffect specifies if effects should be forcefully disposed
     * @param forceDisposeTextures specifies if textures should be forcefully disposed
     * @param notBoundToMesh specifies if the material that is being disposed is known to be not bound to any mesh
     */ dispose(forceDisposeEffect, forceDisposeTextures, notBoundToMesh) {
        const scene = this.getScene();
        // Animations
        scene.stopAnimation(this);
        scene.freeProcessedMaterials();
        // Remove from scene
        scene.removeMaterial(this);
        this._eventInfo.forceDisposeTextures = forceDisposeTextures;
        this._callbackPluginEventGeneric((0, $7HBDq.MaterialPluginEvent).Disposed, this._eventInfo);
        if (this._parentContainer) {
            const index = this._parentContainer.materials.indexOf(this);
            if (index > -1) this._parentContainer.materials.splice(index, 1);
            this._parentContainer = null;
        }
        if (notBoundToMesh !== true) {
            // Remove from meshes
            if (this.meshMap) for(const meshId in this.meshMap){
                const mesh = this.meshMap[meshId];
                if (mesh) {
                    mesh.material = null; // will set the entry in the map to undefined
                    this.releaseVertexArrayObject(mesh, forceDisposeEffect);
                }
            }
            else {
                const meshes = scene.meshes;
                for (const mesh of meshes)if (mesh.material === this && !mesh.sourceMesh) {
                    mesh.material = null;
                    this.releaseVertexArrayObject(mesh, forceDisposeEffect);
                }
            }
        }
        this._uniformBuffer.dispose();
        // Shader are kept in cache for further use but we can get rid of this by using forceDisposeEffect
        if (forceDisposeEffect && this._drawWrapper.effect) {
            if (!this._storeEffectOnSubMeshes) this._drawWrapper.effect.dispose();
            this._drawWrapper.effect = null;
        }
        this.metadata = null;
        // Callback
        this.onDisposeObservable.notifyObservers(this);
        this.onDisposeObservable.clear();
        if (this._onBindObservable) this._onBindObservable.clear();
        if (this._onUnBindObservable) this._onUnBindObservable.clear();
        if (this._onEffectCreatedObservable) this._onEffectCreatedObservable.clear();
        if (this._eventInfo) this._eventInfo = {};
    }
    /**
     * @internal
     */ // eslint-disable-next-line @typescript-eslint/naming-convention
    releaseVertexArrayObject(mesh, forceDisposeEffect) {
        const geometry = mesh.geometry;
        if (geometry) {
            if (this._storeEffectOnSubMeshes) {
                if (mesh.subMeshes) for (const subMesh of mesh.subMeshes){
                    geometry._releaseVertexArrayObject(subMesh.effect);
                    if (forceDisposeEffect && subMesh.effect) subMesh.effect.dispose();
                }
            } else geometry._releaseVertexArrayObject(this._drawWrapper.effect);
        }
    }
    /**
     * Serializes this material
     * @returns the serialized material object
     */ serialize() {
        const serializationObject = (0, $6Ho1L.SerializationHelper).Serialize(this);
        serializationObject.stencil = this.stencil.serialize();
        serializationObject.uniqueId = this.uniqueId;
        this._serializePlugins(serializationObject);
        return serializationObject;
    }
    _serializePlugins(serializationObject) {
        serializationObject.plugins = {};
        if (this.pluginManager) for (const plugin of this.pluginManager._plugins)serializationObject.plugins[plugin.getClassName()] = plugin.serialize();
    }
    /**
     * Creates a material from parsed material data
     * @param parsedMaterial defines parsed material data
     * @param scene defines the hosting scene
     * @param rootUrl defines the root URL to use to load textures
     * @returns a new material
     */ static Parse(parsedMaterial, scene, rootUrl) {
        if (!parsedMaterial.customType) parsedMaterial.customType = "BABYLON.StandardMaterial";
        else if (parsedMaterial.customType === "BABYLON.PBRMaterial" && parsedMaterial.overloadedAlbedo) {
            parsedMaterial.customType = "BABYLON.LegacyPBRMaterial";
            if (!BABYLON.LegacyPBRMaterial) {
                (0, $kVtWi.Logger).Error("Your scene is trying to load a legacy version of the PBRMaterial, please, include it from the materials library.");
                return null;
            }
        }
        const materialType = (0, $bOhSV.Tools).Instantiate(parsedMaterial.customType);
        const material = materialType.Parse(parsedMaterial, scene, rootUrl);
        material._loadedUniqueId = parsedMaterial.uniqueId;
        return material;
    }
    static _ParsePlugins(serializationObject, material, scene, rootUrl) {
        if (!serializationObject.plugins) return;
        for(const pluginClassName in serializationObject.plugins){
            const pluginData = serializationObject.plugins[pluginClassName];
            let plugin = material.pluginManager?.getPlugin(pluginData.name);
            if (!plugin) {
                const pluginClassType = (0, $bOhSV.Tools).Instantiate("BABYLON." + pluginClassName);
                if (pluginClassType) plugin = new pluginClassType(material);
            }
            plugin?.parse(pluginData, scene, rootUrl);
        }
    }
}
/**
 * Returns the triangle fill mode
 */ $3afee756ef198914$export$a2d8b23205c25948.TriangleFillMode = 0;
/**
 * Returns the wireframe mode
 */ $3afee756ef198914$export$a2d8b23205c25948.WireFrameFillMode = 1;
/**
 * Returns the point fill mode
 */ $3afee756ef198914$export$a2d8b23205c25948.PointFillMode = 2;
/**
 * Returns the point list draw mode
 */ $3afee756ef198914$export$a2d8b23205c25948.PointListDrawMode = 3;
/**
 * Returns the line list draw mode
 */ $3afee756ef198914$export$a2d8b23205c25948.LineListDrawMode = 4;
/**
 * Returns the line loop draw mode
 */ $3afee756ef198914$export$a2d8b23205c25948.LineLoopDrawMode = 5;
/**
 * Returns the line strip draw mode
 */ $3afee756ef198914$export$a2d8b23205c25948.LineStripDrawMode = 6;
/**
 * Returns the triangle strip draw mode
 */ $3afee756ef198914$export$a2d8b23205c25948.TriangleStripDrawMode = 7;
/**
 * Returns the triangle fan draw mode
 */ $3afee756ef198914$export$a2d8b23205c25948.TriangleFanDrawMode = 8;
/**
 * Stores the clock-wise side orientation
 */ $3afee756ef198914$export$a2d8b23205c25948.ClockWiseSideOrientation = 0;
/**
 * Stores the counter clock-wise side orientation
 */ $3afee756ef198914$export$a2d8b23205c25948.CounterClockWiseSideOrientation = 1;
/**
 * The dirty texture flag value
 */ $3afee756ef198914$export$a2d8b23205c25948.TextureDirtyFlag = 1;
/**
 * The dirty light flag value
 */ $3afee756ef198914$export$a2d8b23205c25948.LightDirtyFlag = 2;
/**
 * The dirty fresnel flag value
 */ $3afee756ef198914$export$a2d8b23205c25948.FresnelDirtyFlag = 4;
/**
 * The dirty attribute flag value
 */ $3afee756ef198914$export$a2d8b23205c25948.AttributesDirtyFlag = 8;
/**
 * The dirty misc flag value
 */ $3afee756ef198914$export$a2d8b23205c25948.MiscDirtyFlag = 16;
/**
 * The dirty prepass flag value
 */ $3afee756ef198914$export$a2d8b23205c25948.PrePassDirtyFlag = 32;
/**
 * The all dirty flag value
 */ $3afee756ef198914$export$a2d8b23205c25948.AllDirtyFlag = 63;
/**
 * MaterialTransparencyMode: No transparency mode, Alpha channel is not use.
 */ $3afee756ef198914$export$a2d8b23205c25948.MATERIAL_OPAQUE = 0;
/**
 * MaterialTransparencyMode: Alpha Test mode, pixel are discarded below a certain threshold defined by the alpha cutoff value.
 */ $3afee756ef198914$export$a2d8b23205c25948.MATERIAL_ALPHATEST = 1;
/**
 * MaterialTransparencyMode: Pixels are blended (according to the alpha mode) with the already drawn pixels in the current frame buffer.
 */ $3afee756ef198914$export$a2d8b23205c25948.MATERIAL_ALPHABLEND = 2;
/**
 * MaterialTransparencyMode: Pixels are blended (according to the alpha mode) with the already drawn pixels in the current frame buffer.
 * They are also discarded below the alpha cutoff threshold to improve performances.
 */ $3afee756ef198914$export$a2d8b23205c25948.MATERIAL_ALPHATESTANDBLEND = 3;
/**
 * The Whiteout method is used to blend normals.
 * Details of the algorithm can be found here: https://blog.selfshadow.com/publications/blending-in-detail/
 */ $3afee756ef198914$export$a2d8b23205c25948.MATERIAL_NORMALBLENDMETHOD_WHITEOUT = 0;
/**
 * The Reoriented Normal Mapping method is used to blend normals.
 * Details of the algorithm can be found here: https://blog.selfshadow.com/publications/blending-in-detail/
 */ $3afee756ef198914$export$a2d8b23205c25948.MATERIAL_NORMALBLENDMETHOD_RNM = 1;
/**
 * Event observable which raises global events common to all materials (like MaterialPluginEvent.Created)
 */ $3afee756ef198914$export$a2d8b23205c25948.OnEventObservable = new (0, $diGQf.Observable)();
$3afee756ef198914$export$a2d8b23205c25948._AllDirtyCallBack = (defines)=>defines.markAllAsDirty();
$3afee756ef198914$export$a2d8b23205c25948._ImageProcessingDirtyCallBack = (defines)=>defines.markAsImageProcessingDirty();
$3afee756ef198914$export$a2d8b23205c25948._TextureDirtyCallBack = (defines)=>defines.markAsTexturesDirty();
$3afee756ef198914$export$a2d8b23205c25948._FresnelDirtyCallBack = (defines)=>defines.markAsFresnelDirty();
$3afee756ef198914$export$a2d8b23205c25948._MiscDirtyCallBack = (defines)=>defines.markAsMiscDirty();
$3afee756ef198914$export$a2d8b23205c25948._PrePassDirtyCallBack = (defines)=>defines.markAsPrePassDirty();
$3afee756ef198914$export$a2d8b23205c25948._LightsDirtyCallBack = (defines)=>defines.markAsLightDirty();
$3afee756ef198914$export$a2d8b23205c25948._AttributeDirtyCallBack = (defines)=>defines.markAsAttributesDirty();
$3afee756ef198914$export$a2d8b23205c25948._FresnelAndMiscDirtyCallBack = (defines)=>{
    $3afee756ef198914$export$a2d8b23205c25948._FresnelDirtyCallBack(defines);
    $3afee756ef198914$export$a2d8b23205c25948._MiscDirtyCallBack(defines);
};
$3afee756ef198914$export$a2d8b23205c25948._TextureAndMiscDirtyCallBack = (defines)=>{
    $3afee756ef198914$export$a2d8b23205c25948._TextureDirtyCallBack(defines);
    $3afee756ef198914$export$a2d8b23205c25948._MiscDirtyCallBack(defines);
};
$3afee756ef198914$export$a2d8b23205c25948._DirtyCallbackArray = [];
$3afee756ef198914$export$a2d8b23205c25948._RunDirtyCallBacks = (defines)=>{
    for (const cb of $3afee756ef198914$export$a2d8b23205c25948._DirtyCallbackArray)cb(defines);
};
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "id", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "uniqueId", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "name", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "metadata", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "checkReadyOnEveryCall", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "checkReadyOnlyOnce", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "state", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("alpha")
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "_alpha", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("backFaceCulling")
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "_backFaceCulling", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("cullBackFaces")
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "_cullBackFaces", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "sideOrientation", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("alphaMode")
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "_alphaMode", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "_needDepthPrePass", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "disableDepthWrite", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "disableColorWrite", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "forceDepthWrite", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "depthFunction", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "separateCullingPass", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("fogEnabled")
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "_fogEnabled", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "pointSize", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "zOffset", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "zOffsetUnits", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "pointsCloud", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "fillMode", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "useLogarithmicDepth", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3afee756ef198914$export$a2d8b23205c25948.prototype, "transparencyMode", null);

});
parcelRegister("7ZNtZ", function(module, exports) {

$parcel$export(module.exports, "MaterialStencilState", () => $5d249d29bbd510f6$export$4fedf983a2fab8f7);

var $e0Suo = parcelRequire("e0Suo");

var $6Ho1L = parcelRequire("6Ho1L");

var $ir0rz = parcelRequire("ir0rz");
class $5d249d29bbd510f6$export$4fedf983a2fab8f7 {
    /**
     * Creates a material stencil state instance
     */ constructor(){
        this.reset();
    }
    /**
     * Resets all the stencil states to default values
     */ reset() {
        this.enabled = false;
        this.mask = 0xff;
        this.func = 519;
        this.funcRef = 1;
        this.funcMask = 0xff;
        this.opStencilFail = 7680;
        this.opDepthFail = 7680;
        this.opStencilDepthPass = 7681;
    }
    /**
     * Gets or sets the stencil function
     */ get func() {
        return this._func;
    }
    set func(value) {
        this._func = value;
    }
    /**
     * Gets or sets the stencil function reference
     */ get funcRef() {
        return this._funcRef;
    }
    set funcRef(value) {
        this._funcRef = value;
    }
    /**
     * Gets or sets the stencil function mask
     */ get funcMask() {
        return this._funcMask;
    }
    set funcMask(value) {
        this._funcMask = value;
    }
    /**
     * Gets or sets the operation when the stencil test fails
     */ get opStencilFail() {
        return this._opStencilFail;
    }
    set opStencilFail(value) {
        this._opStencilFail = value;
    }
    /**
     * Gets or sets the operation when the depth test fails
     */ get opDepthFail() {
        return this._opDepthFail;
    }
    set opDepthFail(value) {
        this._opDepthFail = value;
    }
    /**
     * Gets or sets the operation when the stencil+depth test succeeds
     */ get opStencilDepthPass() {
        return this._opStencilDepthPass;
    }
    set opStencilDepthPass(value) {
        this._opStencilDepthPass = value;
    }
    /**
     * Gets or sets the stencil mask
     */ get mask() {
        return this._mask;
    }
    set mask(value) {
        this._mask = value;
    }
    /**
     * Enables or disables the stencil test
     */ get enabled() {
        return this._enabled;
    }
    set enabled(value) {
        this._enabled = value;
    }
    /**
     * Get the current class name, useful for serialization or dynamic coding.
     * @returns "MaterialStencilState"
     */ getClassName() {
        return "MaterialStencilState";
    }
    /**
     * Makes a duplicate of the current configuration into another one.
     * @param stencilState defines stencil state where to copy the info
     */ copyTo(stencilState) {
        (0, $6Ho1L.SerializationHelper).Clone(()=>stencilState, this);
    }
    /**
     * Serializes this stencil configuration.
     * @returns - An object with the serialized config.
     */ serialize() {
        return (0, $6Ho1L.SerializationHelper).Serialize(this);
    }
    /**
     * Parses a stencil state configuration from a serialized object.
     * @param source - Serialized object.
     * @param scene Defines the scene we are parsing for
     * @param rootUrl Defines the rootUrl to load from
     */ parse(source, scene, rootUrl) {
        (0, $6Ho1L.SerializationHelper).Parse(()=>this, source, scene, rootUrl);
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $5d249d29bbd510f6$export$4fedf983a2fab8f7.prototype, "func", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $5d249d29bbd510f6$export$4fedf983a2fab8f7.prototype, "funcRef", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $5d249d29bbd510f6$export$4fedf983a2fab8f7.prototype, "funcMask", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $5d249d29bbd510f6$export$4fedf983a2fab8f7.prototype, "opStencilFail", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $5d249d29bbd510f6$export$4fedf983a2fab8f7.prototype, "opDepthFail", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $5d249d29bbd510f6$export$4fedf983a2fab8f7.prototype, "opStencilDepthPass", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $5d249d29bbd510f6$export$4fedf983a2fab8f7.prototype, "mask", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $5d249d29bbd510f6$export$4fedf983a2fab8f7.prototype, "enabled", null);

});

parcelRegister("7HBDq", function(module, exports) {

$parcel$export(module.exports, "MaterialPluginEvent", () => $59b9be0de6a448ce$export$2c7b5657778c47a5);
/**
 * @internal
 */ var $59b9be0de6a448ce$export$2c7b5657778c47a5;
(function(MaterialPluginEvent) {
    MaterialPluginEvent[MaterialPluginEvent["Created"] = 1] = "Created";
    MaterialPluginEvent[MaterialPluginEvent["Disposed"] = 2] = "Disposed";
    MaterialPluginEvent[MaterialPluginEvent["GetDefineNames"] = 4] = "GetDefineNames";
    MaterialPluginEvent[MaterialPluginEvent["PrepareUniformBuffer"] = 8] = "PrepareUniformBuffer";
    MaterialPluginEvent[MaterialPluginEvent["IsReadyForSubMesh"] = 16] = "IsReadyForSubMesh";
    MaterialPluginEvent[MaterialPluginEvent["PrepareDefines"] = 32] = "PrepareDefines";
    MaterialPluginEvent[MaterialPluginEvent["BindForSubMesh"] = 64] = "BindForSubMesh";
    MaterialPluginEvent[MaterialPluginEvent["PrepareEffect"] = 128] = "PrepareEffect";
    MaterialPluginEvent[MaterialPluginEvent["GetAnimatables"] = 256] = "GetAnimatables";
    MaterialPluginEvent[MaterialPluginEvent["GetActiveTextures"] = 512] = "GetActiveTextures";
    MaterialPluginEvent[MaterialPluginEvent["HasTexture"] = 1024] = "HasTexture";
    MaterialPluginEvent[MaterialPluginEvent["FillRenderTargetTextures"] = 2048] = "FillRenderTargetTextures";
    MaterialPluginEvent[MaterialPluginEvent["HasRenderTargetTextures"] = 4096] = "HasRenderTargetTextures";
    MaterialPluginEvent[MaterialPluginEvent["HardBindForSubMesh"] = 8192] = "HardBindForSubMesh";
})($59b9be0de6a448ce$export$2c7b5657778c47a5 || ($59b9be0de6a448ce$export$2c7b5657778c47a5 = {}));

});

parcelRegister("alPCh", function(module, exports) {

$parcel$export(module.exports, "BindLogDepth", () => $7893e784ec9add9a$export$c51be962d0cbc5db);
$parcel$export(module.exports, "BindFogParameters", () => $7893e784ec9add9a$export$531a83026b679e28);
$parcel$export(module.exports, "PrepareAttributesForMorphTargetsInfluencers", () => $7893e784ec9add9a$export$ad216e1b4044d0a2);
$parcel$export(module.exports, "PrepareAttributesForMorphTargets", () => $7893e784ec9add9a$export$3f648d9015556392);
$parcel$export(module.exports, "PushAttributesForInstances", () => $7893e784ec9add9a$export$3016ce9563275624);
$parcel$export(module.exports, "BindMorphTargetParameters", () => $7893e784ec9add9a$export$f33581baf6024652);
$parcel$export(module.exports, "BindSceneUniformBuffer", () => $7893e784ec9add9a$export$92f8908347587afc);
$parcel$export(module.exports, "PrepareDefinesForMergedUV", () => $7893e784ec9add9a$export$a906c176bc893d2a);
$parcel$export(module.exports, "BindTextureMatrix", () => $7893e784ec9add9a$export$c335cd4c3275cd5a);
$parcel$export(module.exports, "PrepareAttributesForBakedVertexAnimation", () => $7893e784ec9add9a$export$b48abe8455f59858);
$parcel$export(module.exports, "BindBonesParameters", () => $7893e784ec9add9a$export$1544400469443a89);
$parcel$export(module.exports, "BindLightProperties", () => $7893e784ec9add9a$export$2d66eba98da98e84);
$parcel$export(module.exports, "BindLight", () => $7893e784ec9add9a$export$dc223d5211922d9c);
$parcel$export(module.exports, "BindLights", () => $7893e784ec9add9a$export$c3115b30871adb94);
$parcel$export(module.exports, "PrepareAttributesForBones", () => $7893e784ec9add9a$export$71c246cd17c53a0d);
$parcel$export(module.exports, "PrepareAttributesForInstances", () => $7893e784ec9add9a$export$f9fb9b44aa29cc31);
$parcel$export(module.exports, "HandleFallbacksForShadows", () => $7893e784ec9add9a$export$ae20fd35f0de291d);
$parcel$export(module.exports, "GetFogState", () => $7893e784ec9add9a$export$d5d977fc33c7973);
$parcel$export(module.exports, "PrepareDefinesForMisc", () => $7893e784ec9add9a$export$a000bd067dd304c2);
$parcel$export(module.exports, "PrepareDefinesForLights", () => $7893e784ec9add9a$export$9810631b9b84b23d);
$parcel$export(module.exports, "PrepareDefinesForLight", () => $7893e784ec9add9a$export$14850268f573bb88);
$parcel$export(module.exports, "PrepareDefinesForFrameBoundValues", () => $7893e784ec9add9a$export$40fda531e0d45992);
$parcel$export(module.exports, "PrepareDefinesForCamera", () => $7893e784ec9add9a$export$4229761abe9cca61);
$parcel$export(module.exports, "PrepareDefinesForBones", () => $7893e784ec9add9a$export$af9ee06238217031);
$parcel$export(module.exports, "PrepareDefinesForMorphTargets", () => $7893e784ec9add9a$export$3f96155d9d03dc3d);
$parcel$export(module.exports, "PrepareDefinesForBakedVertexAnimation", () => $7893e784ec9add9a$export$ac9079f07ec6c77a);
$parcel$export(module.exports, "PrepareDefinesForAttributes", () => $7893e784ec9add9a$export$9bf973b33bf006f1);
$parcel$export(module.exports, "PrepareDefinesForMultiview", () => $7893e784ec9add9a$export$55684373b0a692af);
$parcel$export(module.exports, "PrepareDefinesForOIT", () => $7893e784ec9add9a$export$667351a72233f2a3);
$parcel$export(module.exports, "PrepareDefinesForPrePass", () => $7893e784ec9add9a$export$73d6edd5c9bebe3d);
$parcel$export(module.exports, "PrepareUniformsAndSamplersForLight", () => $7893e784ec9add9a$export$5ae312277f42b016);
$parcel$export(module.exports, "PrepareUniformsAndSamplersList", () => $7893e784ec9add9a$export$8c6b0867b1144725);

var $kVtWi = parcelRequire("kVtWi");

var $7etnY = parcelRequire("7etnY");

var $ejQPp = parcelRequire("ejQPp");

var $1gEbu = parcelRequire("1gEbu");

var $aAFeM = parcelRequire("aAFeM");
// Temps
const $7893e784ec9add9a$var$_TempFogColor = (0, $7etnY.Color3).Black();
const $7893e784ec9add9a$var$_TmpMorphInfluencers = {
    NUM_MORPH_INFLUENCERS: 0
};
function $7893e784ec9add9a$export$c51be962d0cbc5db(defines, effect, scene) {
    if (!defines || defines["LOGARITHMICDEPTH"] || defines.indexOf && defines.indexOf("LOGARITHMICDEPTH") >= 0) {
        const camera = scene.activeCamera;
        if (camera.mode === 1) (0, $kVtWi.Logger).Error("Logarithmic depth is not compatible with orthographic cameras!", 20);
        effect.setFloat("logarithmicDepthConstant", 2.0 / (Math.log(camera.maxZ + 1.0) / Math.LN2));
    }
}
function $7893e784ec9add9a$export$531a83026b679e28(scene, mesh, effect, linearSpace = false) {
    if (effect && scene.fogEnabled && (!mesh || mesh.applyFog) && scene.fogMode !== 0) {
        effect.setFloat4("vFogInfos", scene.fogMode, scene.fogStart, scene.fogEnd, scene.fogDensity);
        // Convert fog color to linear space if used in a linear space computed shader.
        if (linearSpace) {
            scene.fogColor.toLinearSpaceToRef($7893e784ec9add9a$var$_TempFogColor, scene.getEngine().useExactSrgbConversions);
            effect.setColor3("vFogColor", $7893e784ec9add9a$var$_TempFogColor);
        } else effect.setColor3("vFogColor", scene.fogColor);
    }
}
function $7893e784ec9add9a$export$ad216e1b4044d0a2(attribs, mesh, influencers) {
    $7893e784ec9add9a$var$_TmpMorphInfluencers.NUM_MORPH_INFLUENCERS = influencers;
    $7893e784ec9add9a$export$3f648d9015556392(attribs, mesh, $7893e784ec9add9a$var$_TmpMorphInfluencers);
}
function $7893e784ec9add9a$export$3f648d9015556392(attribs, mesh, defines) {
    const influencers = defines["NUM_MORPH_INFLUENCERS"];
    if (influencers > 0 && (0, $ejQPp.EngineStore).LastCreatedEngine) {
        const maxAttributesCount = (0, $ejQPp.EngineStore).LastCreatedEngine.getCaps().maxVertexAttribs;
        const manager = mesh.morphTargetManager;
        if (manager?.isUsingTextureForTargets) return;
        const normal = manager && manager.supportsNormals && defines["NORMAL"];
        const tangent = manager && manager.supportsTangents && defines["TANGENT"];
        const uv = manager && manager.supportsUVs && defines["UV1"];
        for(let index = 0; index < influencers; index++){
            attribs.push(`position` + index);
            if (normal) attribs.push(`normal` + index);
            if (tangent) attribs.push(`tangent` + index);
            if (uv) attribs.push(`uv` + "_" + index);
            if (attribs.length > maxAttributesCount) (0, $kVtWi.Logger).Error("Cannot add more vertex attributes for mesh " + mesh.name);
        }
    }
}
function $7893e784ec9add9a$export$3016ce9563275624(attribs, needsPreviousMatrices = false) {
    attribs.push("world0");
    attribs.push("world1");
    attribs.push("world2");
    attribs.push("world3");
    if (needsPreviousMatrices) {
        attribs.push("previousWorld0");
        attribs.push("previousWorld1");
        attribs.push("previousWorld2");
        attribs.push("previousWorld3");
    }
}
function $7893e784ec9add9a$export$f33581baf6024652(abstractMesh, effect) {
    const manager = abstractMesh.morphTargetManager;
    if (!abstractMesh || !manager) return;
    effect.setFloatArray("morphTargetInfluences", manager.influences);
}
function $7893e784ec9add9a$export$92f8908347587afc(effect, sceneUbo) {
    sceneUbo.bindToEffect(effect, "Scene");
}
function $7893e784ec9add9a$export$a906c176bc893d2a(texture, defines, key) {
    defines._needUVs = true;
    defines[key] = true;
    if (texture.optimizeUVAllocation && texture.getTextureMatrix().isIdentityAs3x2()) {
        defines[key + "DIRECTUV"] = texture.coordinatesIndex + 1;
        defines["MAINUV" + (texture.coordinatesIndex + 1)] = true;
    } else defines[key + "DIRECTUV"] = 0;
}
function $7893e784ec9add9a$export$c335cd4c3275cd5a(texture, uniformBuffer, key) {
    const matrix = texture.getTextureMatrix();
    uniformBuffer.updateMatrix(key + "Matrix", matrix);
}
function $7893e784ec9add9a$export$b48abe8455f59858(attribs, mesh, defines) {
    const enabled = defines["BAKED_VERTEX_ANIMATION_TEXTURE"] && defines["INSTANCES"];
    if (enabled) attribs.push("bakedVertexAnimationSettingsInstanced");
}
// Copies the bones transformation matrices into the target array and returns the target's reference
function $7893e784ec9add9a$var$_CopyBonesTransformationMatrices(source, target) {
    target.set(source);
    return target;
}
function $7893e784ec9add9a$export$1544400469443a89(mesh, effect, prePassConfiguration) {
    if (!effect || !mesh) return;
    if (mesh.computeBonesUsingShaders && effect._bonesComputationForcedToCPU) mesh.computeBonesUsingShaders = false;
    if (mesh.useBones && mesh.computeBonesUsingShaders && mesh.skeleton) {
        const skeleton = mesh.skeleton;
        if (skeleton.isUsingTextureForMatrices && effect.getUniformIndex("boneTextureWidth") > -1) {
            const boneTexture = skeleton.getTransformMatrixTexture(mesh);
            effect.setTexture("boneSampler", boneTexture);
            effect.setFloat("boneTextureWidth", 4.0 * (skeleton.bones.length + 1));
        } else {
            const matrices = skeleton.getTransformMatrices(mesh);
            if (matrices) {
                effect.setMatrices("mBones", matrices);
                if (prePassConfiguration && mesh.getScene().prePassRenderer && mesh.getScene().prePassRenderer.getIndex(2)) {
                    if (!prePassConfiguration.previousBones[mesh.uniqueId]) prePassConfiguration.previousBones[mesh.uniqueId] = matrices.slice();
                    effect.setMatrices("mPreviousBones", prePassConfiguration.previousBones[mesh.uniqueId]);
                    $7893e784ec9add9a$var$_CopyBonesTransformationMatrices(matrices, prePassConfiguration.previousBones[mesh.uniqueId]);
                }
            }
        }
    }
}
function $7893e784ec9add9a$export$2d66eba98da98e84(light, effect, lightIndex) {
    light.transferToEffect(effect, lightIndex + "");
}
function $7893e784ec9add9a$export$dc223d5211922d9c(light, lightIndex, scene, effect, useSpecular, receiveShadows = true) {
    light._bindLight(lightIndex, scene, effect, useSpecular, receiveShadows);
}
function $7893e784ec9add9a$export$c3115b30871adb94(scene, mesh, effect, defines, maxSimultaneousLights = 4) {
    const len = Math.min(mesh.lightSources.length, maxSimultaneousLights);
    for(let i = 0; i < len; i++){
        const light = mesh.lightSources[i];
        $7893e784ec9add9a$export$dc223d5211922d9c(light, i, scene, effect, typeof defines === "boolean" ? defines : defines["SPECULARTERM"], mesh.receiveShadows);
    }
}
function $7893e784ec9add9a$export$71c246cd17c53a0d(attribs, mesh, defines, fallbacks) {
    if (defines["NUM_BONE_INFLUENCERS"] > 0) {
        fallbacks.addCPUSkinningFallback(0, mesh);
        attribs.push(`matricesIndices`);
        attribs.push(`matricesWeights`);
        if (defines["NUM_BONE_INFLUENCERS"] > 4) {
            attribs.push(`matricesIndicesExtra`);
            attribs.push(`matricesWeightsExtra`);
        }
    }
}
function $7893e784ec9add9a$export$f9fb9b44aa29cc31(attribs, defines) {
    if (defines["INSTANCES"] || defines["THIN_INSTANCES"]) $7893e784ec9add9a$export$3016ce9563275624(attribs, !!defines["PREPASS_VELOCITY"]);
    if (defines.INSTANCESCOLOR) attribs.push(`instanceColor`);
}
function $7893e784ec9add9a$export$ae20fd35f0de291d(defines, fallbacks, maxSimultaneousLights = 4, rank = 0) {
    let lightFallbackRank = 0;
    for(let lightIndex = 0; lightIndex < maxSimultaneousLights; lightIndex++){
        if (!defines["LIGHT" + lightIndex]) break;
        if (lightIndex > 0) {
            lightFallbackRank = rank + lightIndex;
            fallbacks.addFallback(lightFallbackRank, "LIGHT" + lightIndex);
        }
        if (!defines["SHADOWS"]) {
            if (defines["SHADOW" + lightIndex]) fallbacks.addFallback(rank, "SHADOW" + lightIndex);
            if (defines["SHADOWPCF" + lightIndex]) fallbacks.addFallback(rank, "SHADOWPCF" + lightIndex);
            if (defines["SHADOWPCSS" + lightIndex]) fallbacks.addFallback(rank, "SHADOWPCSS" + lightIndex);
            if (defines["SHADOWPOISSON" + lightIndex]) fallbacks.addFallback(rank, "SHADOWPOISSON" + lightIndex);
            if (defines["SHADOWESM" + lightIndex]) fallbacks.addFallback(rank, "SHADOWESM" + lightIndex);
            if (defines["SHADOWCLOSEESM" + lightIndex]) fallbacks.addFallback(rank, "SHADOWCLOSEESM" + lightIndex);
        }
    }
    return lightFallbackRank++;
}
function $7893e784ec9add9a$export$d5d977fc33c7973(mesh, scene) {
    return scene.fogEnabled && mesh.applyFog && scene.fogMode !== 0;
}
function $7893e784ec9add9a$export$a000bd067dd304c2(mesh, scene, useLogarithmicDepth, pointsCloud, fogEnabled, alphaTest, defines, applyDecalAfterDetail = false) {
    if (defines._areMiscDirty) {
        defines["LOGARITHMICDEPTH"] = useLogarithmicDepth;
        defines["POINTSIZE"] = pointsCloud;
        defines["FOG"] = fogEnabled && $7893e784ec9add9a$export$d5d977fc33c7973(mesh, scene);
        defines["NONUNIFORMSCALING"] = mesh.nonUniformScaling;
        defines["ALPHATEST"] = alphaTest;
        defines["DECAL_AFTER_DETAIL"] = applyDecalAfterDetail;
    }
}
function $7893e784ec9add9a$export$9810631b9b84b23d(scene, mesh, defines, specularSupported, maxSimultaneousLights = 4, disableLighting = false) {
    if (!defines._areLightsDirty) return defines._needNormals;
    let lightIndex = 0;
    const state = {
        needNormals: defines._needNormals,
        needRebuild: false,
        lightmapMode: false,
        shadowEnabled: false,
        specularEnabled: false
    };
    if (scene.lightsEnabled && !disableLighting) for (const light of mesh.lightSources){
        $7893e784ec9add9a$export$14850268f573bb88(scene, mesh, light, lightIndex, defines, specularSupported, state);
        lightIndex++;
        if (lightIndex === maxSimultaneousLights) break;
    }
    defines["SPECULARTERM"] = state.specularEnabled;
    defines["SHADOWS"] = state.shadowEnabled;
    // Resetting all other lights if any
    for(let index = lightIndex; index < maxSimultaneousLights; index++)if (defines["LIGHT" + index] !== undefined) {
        defines["LIGHT" + index] = false;
        defines["HEMILIGHT" + index] = false;
        defines["POINTLIGHT" + index] = false;
        defines["DIRLIGHT" + index] = false;
        defines["SPOTLIGHT" + index] = false;
        defines["SHADOW" + index] = false;
        defines["SHADOWCSM" + index] = false;
        defines["SHADOWCSMDEBUG" + index] = false;
        defines["SHADOWCSMNUM_CASCADES" + index] = false;
        defines["SHADOWCSMUSESHADOWMAXZ" + index] = false;
        defines["SHADOWCSMNOBLEND" + index] = false;
        defines["SHADOWCSM_RIGHTHANDED" + index] = false;
        defines["SHADOWPCF" + index] = false;
        defines["SHADOWPCSS" + index] = false;
        defines["SHADOWPOISSON" + index] = false;
        defines["SHADOWESM" + index] = false;
        defines["SHADOWCLOSEESM" + index] = false;
        defines["SHADOWCUBE" + index] = false;
        defines["SHADOWLOWQUALITY" + index] = false;
        defines["SHADOWMEDIUMQUALITY" + index] = false;
    }
    const caps = scene.getEngine().getCaps();
    if (defines["SHADOWFLOAT"] === undefined) state.needRebuild = true;
    defines["SHADOWFLOAT"] = state.shadowEnabled && (caps.textureFloatRender && caps.textureFloatLinearFiltering || caps.textureHalfFloatRender && caps.textureHalfFloatLinearFiltering);
    defines["LIGHTMAPEXCLUDED"] = state.lightmapMode;
    if (state.needRebuild) defines.rebuild();
    return state.needNormals;
}
function $7893e784ec9add9a$export$14850268f573bb88(scene, mesh, light, lightIndex, defines, specularSupported, state) {
    state.needNormals = true;
    if (defines["LIGHT" + lightIndex] === undefined) state.needRebuild = true;
    defines["LIGHT" + lightIndex] = true;
    defines["SPOTLIGHT" + lightIndex] = false;
    defines["HEMILIGHT" + lightIndex] = false;
    defines["POINTLIGHT" + lightIndex] = false;
    defines["DIRLIGHT" + lightIndex] = false;
    light.prepareLightSpecificDefines(defines, lightIndex);
    // FallOff.
    defines["LIGHT_FALLOFF_PHYSICAL" + lightIndex] = false;
    defines["LIGHT_FALLOFF_GLTF" + lightIndex] = false;
    defines["LIGHT_FALLOFF_STANDARD" + lightIndex] = false;
    switch(light.falloffType){
        case (0, $1gEbu.LightConstants).FALLOFF_GLTF:
            defines["LIGHT_FALLOFF_GLTF" + lightIndex] = true;
            break;
        case (0, $1gEbu.LightConstants).FALLOFF_PHYSICAL:
            defines["LIGHT_FALLOFF_PHYSICAL" + lightIndex] = true;
            break;
        case (0, $1gEbu.LightConstants).FALLOFF_STANDARD:
            defines["LIGHT_FALLOFF_STANDARD" + lightIndex] = true;
            break;
    }
    // Specular
    if (specularSupported && !light.specular.equalsFloats(0, 0, 0)) state.specularEnabled = true;
    // Shadows
    defines["SHADOW" + lightIndex] = false;
    defines["SHADOWCSM" + lightIndex] = false;
    defines["SHADOWCSMDEBUG" + lightIndex] = false;
    defines["SHADOWCSMNUM_CASCADES" + lightIndex] = false;
    defines["SHADOWCSMUSESHADOWMAXZ" + lightIndex] = false;
    defines["SHADOWCSMNOBLEND" + lightIndex] = false;
    defines["SHADOWCSM_RIGHTHANDED" + lightIndex] = false;
    defines["SHADOWPCF" + lightIndex] = false;
    defines["SHADOWPCSS" + lightIndex] = false;
    defines["SHADOWPOISSON" + lightIndex] = false;
    defines["SHADOWESM" + lightIndex] = false;
    defines["SHADOWCLOSEESM" + lightIndex] = false;
    defines["SHADOWCUBE" + lightIndex] = false;
    defines["SHADOWLOWQUALITY" + lightIndex] = false;
    defines["SHADOWMEDIUMQUALITY" + lightIndex] = false;
    if (mesh && mesh.receiveShadows && scene.shadowsEnabled && light.shadowEnabled) {
        const shadowGenerator = light.getShadowGenerator(scene.activeCamera) ?? light.getShadowGenerator();
        if (shadowGenerator) {
            const shadowMap = shadowGenerator.getShadowMap();
            if (shadowMap) {
                if (shadowMap.renderList && shadowMap.renderList.length > 0) {
                    state.shadowEnabled = true;
                    shadowGenerator.prepareDefines(defines, lightIndex);
                }
            }
        }
    }
    if (light.lightmapMode != (0, $1gEbu.LightConstants).LIGHTMAP_DEFAULT) {
        state.lightmapMode = true;
        defines["LIGHTMAPEXCLUDED" + lightIndex] = true;
        defines["LIGHTMAPNOSPECULAR" + lightIndex] = light.lightmapMode == (0, $1gEbu.LightConstants).LIGHTMAP_SHADOWSONLY;
    } else {
        defines["LIGHTMAPEXCLUDED" + lightIndex] = false;
        defines["LIGHTMAPNOSPECULAR" + lightIndex] = false;
    }
}
function $7893e784ec9add9a$export$40fda531e0d45992(scene, engine, material, defines, useInstances, useClipPlane = null, useThinInstances = false) {
    let changed = $7893e784ec9add9a$export$4229761abe9cca61(scene, defines);
    if (useClipPlane !== false) changed = (0, $aAFeM.prepareDefinesForClipPlanes)(material, scene, defines);
    if (defines["DEPTHPREPASS"] !== !engine.getColorWrite()) {
        defines["DEPTHPREPASS"] = !defines["DEPTHPREPASS"];
        changed = true;
    }
    if (defines["INSTANCES"] !== useInstances) {
        defines["INSTANCES"] = useInstances;
        changed = true;
    }
    if (defines["THIN_INSTANCES"] !== useThinInstances) {
        defines["THIN_INSTANCES"] = useThinInstances;
        changed = true;
    }
    if (changed) defines.markAsUnprocessed();
}
function $7893e784ec9add9a$export$af9ee06238217031(mesh, defines) {
    if (mesh.useBones && mesh.computeBonesUsingShaders && mesh.skeleton) {
        defines["NUM_BONE_INFLUENCERS"] = mesh.numBoneInfluencers;
        const materialSupportsBoneTexture = defines["BONETEXTURE"] !== undefined;
        if (mesh.skeleton.isUsingTextureForMatrices && materialSupportsBoneTexture) defines["BONETEXTURE"] = true;
        else {
            defines["BonesPerMesh"] = mesh.skeleton.bones.length + 1;
            defines["BONETEXTURE"] = materialSupportsBoneTexture ? false : undefined;
            const prePassRenderer = mesh.getScene().prePassRenderer;
            if (prePassRenderer && prePassRenderer.enabled) {
                const nonExcluded = prePassRenderer.excludedSkinnedMesh.indexOf(mesh) === -1;
                defines["BONES_VELOCITY_ENABLED"] = nonExcluded;
            }
        }
    } else {
        defines["NUM_BONE_INFLUENCERS"] = 0;
        defines["BonesPerMesh"] = 0;
        if (defines["BONETEXTURE"] !== undefined) defines["BONETEXTURE"] = false;
    }
}
function $7893e784ec9add9a$export$3f96155d9d03dc3d(mesh, defines) {
    const manager = mesh.morphTargetManager;
    if (manager) {
        defines["MORPHTARGETS_UV"] = manager.supportsUVs && defines["UV1"];
        defines["MORPHTARGETS_TANGENT"] = manager.supportsTangents && defines["TANGENT"];
        defines["MORPHTARGETS_NORMAL"] = manager.supportsNormals && defines["NORMAL"];
        defines["NUM_MORPH_INFLUENCERS"] = manager.numMaxInfluencers || manager.numInfluencers;
        defines["MORPHTARGETS"] = defines["NUM_MORPH_INFLUENCERS"] > 0;
        defines["MORPHTARGETS_TEXTURE"] = manager.isUsingTextureForTargets;
    } else {
        defines["MORPHTARGETS_UV"] = false;
        defines["MORPHTARGETS_TANGENT"] = false;
        defines["MORPHTARGETS_NORMAL"] = false;
        defines["MORPHTARGETS"] = false;
        defines["NUM_MORPH_INFLUENCERS"] = 0;
    }
}
function $7893e784ec9add9a$export$ac9079f07ec6c77a(mesh, defines) {
    const manager = mesh.bakedVertexAnimationManager;
    defines["BAKED_VERTEX_ANIMATION_TEXTURE"] = manager && manager.isEnabled ? true : false;
}
function $7893e784ec9add9a$export$9bf973b33bf006f1(mesh, defines, useVertexColor, useBones, useMorphTargets = false, useVertexAlpha = true, useBakedVertexAnimation = true) {
    if (!defines._areAttributesDirty && defines._needNormals === defines._normals && defines._needUVs === defines._uvs) return false;
    defines._normals = defines._needNormals;
    defines._uvs = defines._needUVs;
    defines["NORMAL"] = defines._needNormals && mesh.isVerticesDataPresent(`normal`);
    if (defines._needNormals && mesh.isVerticesDataPresent(`tangent`)) defines["TANGENT"] = true;
    for(let i = 1; i <= 6; ++i)defines["UV" + i] = defines._needUVs ? mesh.isVerticesDataPresent(`uv${i === 1 ? "" : i}`) : false;
    if (useVertexColor) {
        const hasVertexColors = mesh.useVertexColors && mesh.isVerticesDataPresent(`color`);
        defines["VERTEXCOLOR"] = hasVertexColors;
        defines["VERTEXALPHA"] = mesh.hasVertexAlpha && hasVertexColors && useVertexAlpha;
    }
    if (mesh.isVerticesDataPresent(`instanceColor`) && (mesh.hasInstances || mesh.hasThinInstances)) defines["INSTANCESCOLOR"] = true;
    if (useBones) $7893e784ec9add9a$export$af9ee06238217031(mesh, defines);
    if (useMorphTargets) $7893e784ec9add9a$export$3f96155d9d03dc3d(mesh, defines);
    if (useBakedVertexAnimation) $7893e784ec9add9a$export$ac9079f07ec6c77a(mesh, defines);
    return true;
}
function $7893e784ec9add9a$export$55684373b0a692af(scene, defines) {
    if (scene.activeCamera) {
        const previousMultiview = defines.MULTIVIEW;
        defines.MULTIVIEW = scene.activeCamera.outputRenderTarget !== null && scene.activeCamera.outputRenderTarget.getViewCount() > 1;
        if (defines.MULTIVIEW != previousMultiview) defines.markAsUnprocessed();
    }
}
function $7893e784ec9add9a$export$667351a72233f2a3(scene, defines, needAlphaBlending) {
    const previousDefine = defines.ORDER_INDEPENDENT_TRANSPARENCY;
    const previousDefine16Bits = defines.ORDER_INDEPENDENT_TRANSPARENCY_16BITS;
    defines.ORDER_INDEPENDENT_TRANSPARENCY = scene.useOrderIndependentTransparency && needAlphaBlending;
    defines.ORDER_INDEPENDENT_TRANSPARENCY_16BITS = !scene.getEngine().getCaps().textureFloatLinearFiltering;
    if (previousDefine !== defines.ORDER_INDEPENDENT_TRANSPARENCY || previousDefine16Bits !== defines.ORDER_INDEPENDENT_TRANSPARENCY_16BITS) defines.markAsUnprocessed();
}
function $7893e784ec9add9a$export$73d6edd5c9bebe3d(scene, defines, canRenderToMRT) {
    const previousPrePass = defines.PREPASS;
    if (!defines._arePrePassDirty) return;
    const texturesList = [
        {
            type: 1,
            define: "PREPASS_POSITION",
            index: "PREPASS_POSITION_INDEX"
        },
        {
            type: 2,
            define: "PREPASS_VELOCITY",
            index: "PREPASS_VELOCITY_INDEX"
        },
        {
            type: 3,
            define: "PREPASS_REFLECTIVITY",
            index: "PREPASS_REFLECTIVITY_INDEX"
        },
        {
            type: 0,
            define: "PREPASS_IRRADIANCE",
            index: "PREPASS_IRRADIANCE_INDEX"
        },
        {
            type: 7,
            define: "PREPASS_ALBEDO_SQRT",
            index: "PREPASS_ALBEDO_SQRT_INDEX"
        },
        {
            type: 5,
            define: "PREPASS_DEPTH",
            index: "PREPASS_DEPTH_INDEX"
        },
        {
            type: 6,
            define: "PREPASS_NORMAL",
            index: "PREPASS_NORMAL_INDEX"
        }
    ];
    if (scene.prePassRenderer && scene.prePassRenderer.enabled && canRenderToMRT) {
        defines.PREPASS = true;
        defines.SCENE_MRT_COUNT = scene.prePassRenderer.mrtCount;
        defines.PREPASS_NORMAL_WORLDSPACE = scene.prePassRenderer.generateNormalsInWorldSpace;
        for(let i = 0; i < texturesList.length; i++){
            const index = scene.prePassRenderer.getIndex(texturesList[i].type);
            if (index !== -1) {
                defines[texturesList[i].define] = true;
                defines[texturesList[i].index] = index;
            } else defines[texturesList[i].define] = false;
        }
    } else {
        defines.PREPASS = false;
        for(let i = 0; i < texturesList.length; i++)defines[texturesList[i].define] = false;
    }
    if (defines.PREPASS != previousPrePass) {
        defines.markAsUnprocessed();
        defines.markAsImageProcessingDirty();
    }
}
function $7893e784ec9add9a$export$4229761abe9cca61(scene, defines) {
    let changed = false;
    if (scene.activeCamera) {
        const wasOrtho = defines["CAMERA_ORTHOGRAPHIC"] ? 1 : 0;
        const wasPersp = defines["CAMERA_PERSPECTIVE"] ? 1 : 0;
        const isOrtho = scene.activeCamera.mode === 1 ? 1 : 0;
        const isPersp = scene.activeCamera.mode === 0 ? 1 : 0;
        if (wasOrtho ^ isOrtho || wasPersp ^ isPersp) {
            defines["CAMERA_ORTHOGRAPHIC"] = isOrtho === 1;
            defines["CAMERA_PERSPECTIVE"] = isPersp === 1;
            changed = true;
        }
    }
    return changed;
}
function $7893e784ec9add9a$export$5ae312277f42b016(lightIndex, uniformsList, samplersList, projectedLightTexture, uniformBuffersList = null, updateOnlyBuffersList = false) {
    if (uniformBuffersList) uniformBuffersList.push("Light" + lightIndex);
    if (updateOnlyBuffersList) return;
    uniformsList.push("vLightData" + lightIndex, "vLightDiffuse" + lightIndex, "vLightSpecular" + lightIndex, "vLightDirection" + lightIndex, "vLightFalloff" + lightIndex, "vLightGround" + lightIndex, "lightMatrix" + lightIndex, "shadowsInfo" + lightIndex, "depthValues" + lightIndex);
    samplersList.push("shadowSampler" + lightIndex);
    samplersList.push("depthSampler" + lightIndex);
    uniformsList.push("viewFrustumZ" + lightIndex, "cascadeBlendFactor" + lightIndex, "lightSizeUVCorrection" + lightIndex, "depthCorrection" + lightIndex, "penumbraDarkness" + lightIndex, "frustumLengths" + lightIndex);
    if (projectedLightTexture) {
        samplersList.push("projectionLightSampler" + lightIndex);
        uniformsList.push("textureProjectionMatrix" + lightIndex);
    }
}
function $7893e784ec9add9a$export$8c6b0867b1144725(uniformsListOrOptions, samplersList, defines, maxSimultaneousLights = 4) {
    let uniformsList;
    let uniformBuffersList = null;
    if (uniformsListOrOptions.uniformsNames) {
        const options = uniformsListOrOptions;
        uniformsList = options.uniformsNames;
        uniformBuffersList = options.uniformBuffersNames;
        samplersList = options.samplers;
        defines = options.defines;
        maxSimultaneousLights = options.maxSimultaneousLights || 0;
    } else {
        uniformsList = uniformsListOrOptions;
        if (!samplersList) samplersList = [];
    }
    for(let lightIndex = 0; lightIndex < maxSimultaneousLights; lightIndex++){
        if (!defines["LIGHT" + lightIndex]) break;
        $7893e784ec9add9a$export$5ae312277f42b016(lightIndex, uniformsList, samplersList, defines["PROJECTEDLIGHTTEXTURE" + lightIndex], uniformBuffersList);
    }
    if (defines["NUM_MORPH_INFLUENCERS"]) {
        uniformsList.push("morphTargetInfluences");
        uniformsList.push("morphTargetCount");
    }
    if (defines["BAKED_VERTEX_ANIMATION_TEXTURE"]) {
        uniformsList.push("bakedVertexAnimationSettings");
        uniformsList.push("bakedVertexAnimationTextureSizeInverted");
        uniformsList.push("bakedVertexAnimationTime");
        samplersList.push("bakedVertexAnimationTexture");
    }
}

});
parcelRegister("aAFeM", function(module, exports) {

$parcel$export(module.exports, "addClipPlaneUniforms", () => $7b5d4109d15c2b5f$export$959caf24bcfab1fd);
$parcel$export(module.exports, "prepareStringDefinesForClipPlanes", () => $7b5d4109d15c2b5f$export$8deac9e8ed5fc6a9);
$parcel$export(module.exports, "prepareDefinesForClipPlanes", () => $7b5d4109d15c2b5f$export$9a3f745585b7389d);
$parcel$export(module.exports, "bindClipPlane", () => $7b5d4109d15c2b5f$export$99061f41c02073b);
/** @internal */ function $7b5d4109d15c2b5f$export$959caf24bcfab1fd(uniforms) {
    if (uniforms.indexOf("vClipPlane") === -1) uniforms.push("vClipPlane");
    if (uniforms.indexOf("vClipPlane2") === -1) uniforms.push("vClipPlane2");
    if (uniforms.indexOf("vClipPlane3") === -1) uniforms.push("vClipPlane3");
    if (uniforms.indexOf("vClipPlane4") === -1) uniforms.push("vClipPlane4");
    if (uniforms.indexOf("vClipPlane5") === -1) uniforms.push("vClipPlane5");
    if (uniforms.indexOf("vClipPlane6") === -1) uniforms.push("vClipPlane6");
}
function $7b5d4109d15c2b5f$export$8deac9e8ed5fc6a9(primaryHolder, secondaryHolder, defines) {
    const clipPlane = !!(primaryHolder.clipPlane ?? secondaryHolder.clipPlane);
    const clipPlane2 = !!(primaryHolder.clipPlane2 ?? secondaryHolder.clipPlane2);
    const clipPlane3 = !!(primaryHolder.clipPlane3 ?? secondaryHolder.clipPlane3);
    const clipPlane4 = !!(primaryHolder.clipPlane4 ?? secondaryHolder.clipPlane4);
    const clipPlane5 = !!(primaryHolder.clipPlane5 ?? secondaryHolder.clipPlane5);
    const clipPlane6 = !!(primaryHolder.clipPlane6 ?? secondaryHolder.clipPlane6);
    if (clipPlane) defines.push("#define CLIPPLANE");
    if (clipPlane2) defines.push("#define CLIPPLANE2");
    if (clipPlane3) defines.push("#define CLIPPLANE3");
    if (clipPlane4) defines.push("#define CLIPPLANE4");
    if (clipPlane5) defines.push("#define CLIPPLANE5");
    if (clipPlane6) defines.push("#define CLIPPLANE6");
}
function $7b5d4109d15c2b5f$export$9a3f745585b7389d(primaryHolder, secondaryHolder, defines) {
    let changed = false;
    const clipPlane = !!(primaryHolder.clipPlane ?? secondaryHolder.clipPlane);
    const clipPlane2 = !!(primaryHolder.clipPlane2 ?? secondaryHolder.clipPlane2);
    const clipPlane3 = !!(primaryHolder.clipPlane3 ?? secondaryHolder.clipPlane3);
    const clipPlane4 = !!(primaryHolder.clipPlane4 ?? secondaryHolder.clipPlane4);
    const clipPlane5 = !!(primaryHolder.clipPlane5 ?? secondaryHolder.clipPlane5);
    const clipPlane6 = !!(primaryHolder.clipPlane6 ?? secondaryHolder.clipPlane6);
    // Do not factorize this code, it breaks browsers optimizations.
    if (defines["CLIPPLANE"] !== clipPlane) {
        defines["CLIPPLANE"] = clipPlane;
        changed = true;
    }
    if (defines["CLIPPLANE2"] !== clipPlane2) {
        defines["CLIPPLANE2"] = clipPlane2;
        changed = true;
    }
    if (defines["CLIPPLANE3"] !== clipPlane3) {
        defines["CLIPPLANE3"] = clipPlane3;
        changed = true;
    }
    if (defines["CLIPPLANE4"] !== clipPlane4) {
        defines["CLIPPLANE4"] = clipPlane4;
        changed = true;
    }
    if (defines["CLIPPLANE5"] !== clipPlane5) {
        defines["CLIPPLANE5"] = clipPlane5;
        changed = true;
    }
    if (defines["CLIPPLANE6"] !== clipPlane6) {
        defines["CLIPPLANE6"] = clipPlane6;
        changed = true;
    }
    return changed;
}
function $7b5d4109d15c2b5f$export$99061f41c02073b(effect, primaryHolder, secondaryHolder) {
    let clipPlane = primaryHolder.clipPlane ?? secondaryHolder.clipPlane;
    $7b5d4109d15c2b5f$var$setClipPlane(effect, "vClipPlane", clipPlane);
    clipPlane = primaryHolder.clipPlane2 ?? secondaryHolder.clipPlane2;
    $7b5d4109d15c2b5f$var$setClipPlane(effect, "vClipPlane2", clipPlane);
    clipPlane = primaryHolder.clipPlane3 ?? secondaryHolder.clipPlane3;
    $7b5d4109d15c2b5f$var$setClipPlane(effect, "vClipPlane3", clipPlane);
    clipPlane = primaryHolder.clipPlane4 ?? secondaryHolder.clipPlane4;
    $7b5d4109d15c2b5f$var$setClipPlane(effect, "vClipPlane4", clipPlane);
    clipPlane = primaryHolder.clipPlane5 ?? secondaryHolder.clipPlane5;
    $7b5d4109d15c2b5f$var$setClipPlane(effect, "vClipPlane5", clipPlane);
    clipPlane = primaryHolder.clipPlane6 ?? secondaryHolder.clipPlane6;
    $7b5d4109d15c2b5f$var$setClipPlane(effect, "vClipPlane6", clipPlane);
}
function $7b5d4109d15c2b5f$var$setClipPlane(effect, uniformName, clipPlane) {
    if (clipPlane) effect.setFloat4(uniformName, clipPlane.normal.x, clipPlane.normal.y, clipPlane.normal.z, clipPlane.d);
}

});



parcelRegister("3zFLd", function(module, exports) {

$parcel$export(module.exports, "MultiMaterial", () => $29a508bfe7b38d6b$export$4f1842f7cdf61f78);

var $54229 = parcelRequire("54229");

var $7212E = parcelRequire("7212E");

var $8DoUR = parcelRequire("8DoUR");
class $29a508bfe7b38d6b$export$4f1842f7cdf61f78 extends (0, $54229.Material) {
    /**
     * Gets or Sets the list of Materials used within the multi material.
     * They need to be ordered according to the submeshes order in the associated mesh
     */ get subMaterials() {
        return this._subMaterials;
    }
    set subMaterials(value) {
        this._subMaterials = value;
        this._hookArray(value);
    }
    /**
     * Function used to align with Node.getChildren()
     * @returns the list of Materials used within the multi material
     */ getChildren() {
        return this.subMaterials;
    }
    /**
     * Instantiates a new Multi Material
     * A multi-material is used to apply different materials to different parts of the same object without the need of
     * separate meshes. This can be use to improve performances.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/multiMaterials
     * @param name Define the name in the scene
     * @param scene Define the scene the material belongs to
     */ constructor(name, scene){
        super(name, scene, true);
        /** @internal */ this._waitingSubMaterialsUniqueIds = [];
        this.getScene().addMultiMaterial(this);
        this.subMaterials = [];
        this._storeEffectOnSubMeshes = true; // multimaterial is considered like a push material
    }
    _hookArray(array) {
        const oldPush = array.push;
        array.push = (...items)=>{
            const result = oldPush.apply(array, items);
            this._markAllSubMeshesAsTexturesDirty();
            return result;
        };
        const oldSplice = array.splice;
        array.splice = (index, deleteCount)=>{
            const deleted = oldSplice.apply(array, [
                index,
                deleteCount
            ]);
            this._markAllSubMeshesAsTexturesDirty();
            return deleted;
        };
    }
    /**
     * Get one of the submaterial by its index in the submaterials array
     * @param index The index to look the sub material at
     * @returns The Material if the index has been defined
     */ getSubMaterial(index) {
        if (index < 0 || index >= this.subMaterials.length) return this.getScene().defaultMaterial;
        return this.subMaterials[index];
    }
    /**
     * Get the list of active textures for the whole sub materials list.
     * @returns All the textures that will be used during the rendering
     */ getActiveTextures() {
        return super.getActiveTextures().concat(...this.subMaterials.map((subMaterial)=>{
            if (subMaterial) return subMaterial.getActiveTextures();
            else return [];
        }));
    }
    /**
     * Specifies if any sub-materials of this multi-material use a given texture.
     * @param texture Defines the texture to check against this multi-material's sub-materials.
     * @returns A boolean specifying if any sub-material of this multi-material uses the texture.
     */ hasTexture(texture) {
        if (super.hasTexture(texture)) return true;
        for(let i = 0; i < this.subMaterials.length; i++){
            if (this.subMaterials[i]?.hasTexture(texture)) return true;
        }
        return false;
    }
    /**
     * Gets the current class name of the material e.g. "MultiMaterial"
     * Mainly use in serialization.
     * @returns the class name
     */ getClassName() {
        return "MultiMaterial";
    }
    /**
     * Checks if the material is ready to render the requested sub mesh
     * @param mesh Define the mesh the submesh belongs to
     * @param subMesh Define the sub mesh to look readiness for
     * @param useInstances Define whether or not the material is used with instances
     * @returns true if ready, otherwise false
     */ isReadyForSubMesh(mesh, subMesh, useInstances) {
        for(let index = 0; index < this.subMaterials.length; index++){
            const subMaterial = this.subMaterials[index];
            if (subMaterial) {
                if (subMaterial._storeEffectOnSubMeshes) {
                    if (!subMaterial.isReadyForSubMesh(mesh, subMesh, useInstances)) return false;
                    continue;
                }
                if (!subMaterial.isReady(mesh)) return false;
            }
        }
        return true;
    }
    /**
     * Clones the current material and its related sub materials
     * @param name Define the name of the newly cloned material
     * @param cloneChildren Define if submaterial will be cloned or shared with the parent instance
     * @returns the cloned material
     */ clone(name, cloneChildren) {
        const newMultiMaterial = new $29a508bfe7b38d6b$export$4f1842f7cdf61f78(name, this.getScene());
        for(let index = 0; index < this.subMaterials.length; index++){
            let subMaterial = null;
            const current = this.subMaterials[index];
            if (cloneChildren && current) subMaterial = current.clone(name + "-" + current.name);
            else subMaterial = this.subMaterials[index];
            newMultiMaterial.subMaterials.push(subMaterial);
        }
        return newMultiMaterial;
    }
    /**
     * Serializes the materials into a JSON representation.
     * @returns the JSON representation
     */ serialize() {
        const serializationObject = {};
        serializationObject.name = this.name;
        serializationObject.id = this.id;
        serializationObject.uniqueId = this.uniqueId;
        if (0, $7212E.Tags) serializationObject.tags = (0, $7212E.Tags).GetTags(this);
        serializationObject.materialsUniqueIds = [];
        serializationObject.materials = [];
        for(let matIndex = 0; matIndex < this.subMaterials.length; matIndex++){
            const subMat = this.subMaterials[matIndex];
            if (subMat) {
                serializationObject.materialsUniqueIds.push(subMat.uniqueId);
                serializationObject.materials.push(subMat.id);
            } else {
                serializationObject.materialsUniqueIds.push(null);
                serializationObject.materials.push(null);
            }
        }
        return serializationObject;
    }
    /**
     * Dispose the material and release its associated resources
     * @param forceDisposeEffect Define if we want to force disposing the associated effect (if false the shader is not released and could be reuse later on)
     * @param forceDisposeTextures Define if we want to force disposing the associated textures (if false, they will not be disposed and can still be use elsewhere in the app)
     * @param forceDisposeChildren Define if we want to force disposing the associated submaterials (if false, they will not be disposed and can still be use elsewhere in the app)
     */ dispose(forceDisposeEffect, forceDisposeTextures, forceDisposeChildren) {
        const scene = this.getScene();
        if (!scene) return;
        if (forceDisposeChildren) for(let index = 0; index < this.subMaterials.length; index++){
            const subMaterial = this.subMaterials[index];
            if (subMaterial) subMaterial.dispose(forceDisposeEffect, forceDisposeTextures);
        }
        const index = scene.multiMaterials.indexOf(this);
        if (index >= 0) scene.multiMaterials.splice(index, 1);
        super.dispose(forceDisposeEffect, forceDisposeTextures);
    }
    /**
     * Creates a MultiMaterial from parsed MultiMaterial data.
     * @param parsedMultiMaterial defines parsed MultiMaterial data.
     * @param scene defines the hosting scene
     * @returns a new MultiMaterial
     */ static ParseMultiMaterial(parsedMultiMaterial, scene) {
        const multiMaterial = new $29a508bfe7b38d6b$export$4f1842f7cdf61f78(parsedMultiMaterial.name, scene);
        multiMaterial.id = parsedMultiMaterial.id;
        multiMaterial._loadedUniqueId = parsedMultiMaterial.uniqueId;
        if (0, $7212E.Tags) (0, $7212E.Tags).AddTagsTo(multiMaterial, parsedMultiMaterial.tags);
        if (parsedMultiMaterial.materialsUniqueIds) multiMaterial._waitingSubMaterialsUniqueIds = parsedMultiMaterial.materialsUniqueIds;
        else parsedMultiMaterial.materials.forEach((subMatId)=>multiMaterial.subMaterials.push(scene.getLastMaterialById(subMatId)));
        return multiMaterial;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.MultiMaterial", $29a508bfe7b38d6b$export$4f1842f7cdf61f78);

});

parcelRegister("8WG4F", function(module, exports) {

$parcel$export(module.exports, "MeshLODLevel", () => $6834609b79a79ffd$export$70c2ba6cf05fb340);
/**
 * Class used to represent a specific level of detail of a mesh
 * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/LOD
 */ class $6834609b79a79ffd$export$70c2ba6cf05fb340 {
    /**
     * Creates a new LOD level
     * @param distanceOrScreenCoverage defines either the distance or the screen coverage where this level should start being displayed
     * @param mesh defines the mesh to use to render this level
     */ constructor(/** Either distance from the center of the object to show this level or the screen coverage if `useLODScreenCoverage` is set to `true` on the mesh*/ distanceOrScreenCoverage, /** Defines the mesh to use to render this level */ mesh){
        this.distanceOrScreenCoverage = distanceOrScreenCoverage;
        this.mesh = mesh;
    }
}

});


parcelRegister("9Xybp", function(module, exports) {

$parcel$export(module.exports, "InstancedMesh", () => $740423c584384d56$export$f3c979c331175ad7);

var $ha1VO = parcelRequire("ha1VO");

var $kVtWi = parcelRequire("kVtWi");

var $0cHNL = parcelRequire("0cHNL");

var $fbuqw = parcelRequire("fbuqw");

var $fhgis = parcelRequire("fhgis");

var $klshO = parcelRequire("klshO");

var $b4i1f = parcelRequire("b4i1f");

var $bOhSV = parcelRequire("bOhSV");
(0, $fbuqw.Mesh)._instancedMeshFactory = (name, mesh)=>{
    const instance = new $740423c584384d56$export$f3c979c331175ad7(name, mesh);
    if (mesh.instancedBuffers) {
        instance.instancedBuffers = {};
        for(const key in mesh.instancedBuffers)instance.instancedBuffers[key] = mesh.instancedBuffers[key];
    }
    return instance;
};
class $740423c584384d56$export$f3c979c331175ad7 extends (0, $0cHNL.AbstractMesh) {
    /**
     * Creates a new InstancedMesh object from the mesh source.
     * @param name defines the name of the instance
     * @param source the mesh to create the instance from
     */ constructor(name, source){
        super(name, source.getScene());
        /** @internal */ this._indexInSourceMeshInstanceArray = -1;
        /** @internal */ this._distanceToCamera = 0;
        source.addInstance(this);
        this._sourceMesh = source;
        this._unIndexed = source._unIndexed;
        this.position.copyFrom(source.position);
        this.rotation.copyFrom(source.rotation);
        this.scaling.copyFrom(source.scaling);
        if (source.rotationQuaternion) this.rotationQuaternion = source.rotationQuaternion.clone();
        this.animations = source.animations.slice();
        for (const range of source.getAnimationRanges())if (range != null) this.createAnimationRange(range.name, range.from, range.to);
        this.infiniteDistance = source.infiniteDistance;
        this.setPivotMatrix(source.getPivotMatrix());
        this.refreshBoundingInfo(true, true);
        this._syncSubMeshes();
    }
    /**
     * @returns the string "InstancedMesh".
     */ getClassName() {
        return "InstancedMesh";
    }
    /** Gets the list of lights affecting that mesh */ get lightSources() {
        return this._sourceMesh._lightSources;
    }
    _resyncLightSources() {
    // Do nothing as all the work will be done by source mesh
    }
    _resyncLightSource() {
    // Do nothing as all the work will be done by source mesh
    }
    _removeLightSource() {
    // Do nothing as all the work will be done by source mesh
    }
    // Methods
    /**
     * If the source mesh receives shadows
     */ get receiveShadows() {
        return this._sourceMesh.receiveShadows;
    }
    set receiveShadows(_value) {
        if (this._sourceMesh?.receiveShadows !== _value) (0, $bOhSV.Tools).Warn("Setting receiveShadows on an instanced mesh has no effect");
    }
    /**
     * The material of the source mesh
     */ get material() {
        return this._sourceMesh.material;
    }
    set material(_value) {
        if (this._sourceMesh?.material !== _value) (0, $bOhSV.Tools).Warn("Setting material on an instanced mesh has no effect");
    }
    /**
     * Visibility of the source mesh
     */ get visibility() {
        return this._sourceMesh.visibility;
    }
    set visibility(_value) {
        if (this._sourceMesh?.visibility !== _value) (0, $bOhSV.Tools).Warn("Setting visibility on an instanced mesh has no effect");
    }
    /**
     * Skeleton of the source mesh
     */ get skeleton() {
        return this._sourceMesh.skeleton;
    }
    set skeleton(_value) {
        if (this._sourceMesh?.skeleton !== _value) (0, $bOhSV.Tools).Warn("Setting skeleton on an instanced mesh has no effect");
    }
    /**
     * Rendering ground id of the source mesh
     */ get renderingGroupId() {
        return this._sourceMesh.renderingGroupId;
    }
    set renderingGroupId(value) {
        if (!this._sourceMesh || value === this._sourceMesh.renderingGroupId) return;
        //no-op with warning
        (0, $kVtWi.Logger).Warn("Note - setting renderingGroupId of an instanced mesh has no effect on the scene");
    }
    /**
     * @returns the total number of vertices (integer).
     */ getTotalVertices() {
        return this._sourceMesh ? this._sourceMesh.getTotalVertices() : 0;
    }
    /**
     * Returns a positive integer : the total number of indices in this mesh geometry.
     * @returns the number of indices or zero if the mesh has no geometry.
     */ getTotalIndices() {
        return this._sourceMesh.getTotalIndices();
    }
    /**
     * The source mesh of the instance
     */ get sourceMesh() {
        return this._sourceMesh;
    }
    /**
     * Creates a new InstancedMesh object from the mesh model.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/copies/instances
     * @param name defines the name of the new instance
     * @returns a new InstancedMesh
     */ createInstance(name) {
        return this._sourceMesh.createInstance(name);
    }
    /**
     * Is this node ready to be used/rendered
     * @param completeCheck defines if a complete check (including materials and lights) has to be done (false by default)
     * @returns {boolean} is it ready
     */ isReady(completeCheck = false) {
        return this._sourceMesh.isReady(completeCheck, true);
    }
    /**
     * Returns an array of integers or a typed array (Int32Array, Uint32Array, Uint16Array) populated with the mesh indices.
     * @param kind kind of verticies to retrieve (eg. positions, normals, uvs, etc.)
     * @param copyWhenShared If true (default false) and and if the mesh geometry is shared among some other meshes, the returned array is a copy of the internal one.
     * @param forceCopy defines a boolean forcing the copy of the buffer no matter what the value of copyWhenShared is
     * @returns a float array or a Float32Array of the requested kind of data : positions, normals, uvs, etc.
     */ getVerticesData(kind, copyWhenShared, forceCopy) {
        return this._sourceMesh.getVerticesData(kind, copyWhenShared, forceCopy);
    }
    /**
     * Sets the vertex data of the mesh geometry for the requested `kind`.
     * If the mesh has no geometry, a new Geometry object is set to the mesh and then passed this vertex data.
     * The `data` are either a numeric array either a Float32Array.
     * The parameter `updatable` is passed as is to the underlying Geometry object constructor (if initially none) or updater.
     * The parameter `stride` is an optional positive integer, it is usually automatically deducted from the `kind` (3 for positions or normals, 2 for UV, etc).
     * Note that a new underlying VertexBuffer object is created each call.
     * If the `kind` is the `PositionKind`, the mesh BoundingInfo is renewed, so the bounding box and sphere, and the mesh World Matrix is recomputed.
     *
     * Possible `kind` values :
     * - VertexBuffer.PositionKind
     * - VertexBuffer.UVKind
     * - VertexBuffer.UV2Kind
     * - VertexBuffer.UV3Kind
     * - VertexBuffer.UV4Kind
     * - VertexBuffer.UV5Kind
     * - VertexBuffer.UV6Kind
     * - VertexBuffer.ColorKind
     * - VertexBuffer.MatricesIndicesKind
     * - VertexBuffer.MatricesIndicesExtraKind
     * - VertexBuffer.MatricesWeightsKind
     * - VertexBuffer.MatricesWeightsExtraKind
     *
     * Returns the Mesh.
     * @param kind defines vertex data kind
     * @param data defines the data source
     * @param updatable defines if the data must be flagged as updatable (false as default)
     * @param stride defines the vertex stride (optional)
     * @returns the current mesh
     */ setVerticesData(kind, data, updatable, stride) {
        if (this.sourceMesh) this.sourceMesh.setVerticesData(kind, data, updatable, stride);
        return this.sourceMesh;
    }
    /**
     * Updates the existing vertex data of the mesh geometry for the requested `kind`.
     * If the mesh has no geometry, it is simply returned as it is.
     * The `data` are either a numeric array either a Float32Array.
     * No new underlying VertexBuffer object is created.
     * If the `kind` is the `PositionKind` and if `updateExtends` is true, the mesh BoundingInfo is renewed, so the bounding box and sphere, and the mesh World Matrix is recomputed.
     * If the parameter `makeItUnique` is true, a new global geometry is created from this positions and is set to the mesh.
     *
     * Possible `kind` values :
     * - VertexBuffer.PositionKind
     * - VertexBuffer.UVKind
     * - VertexBuffer.UV2Kind
     * - VertexBuffer.UV3Kind
     * - VertexBuffer.UV4Kind
     * - VertexBuffer.UV5Kind
     * - VertexBuffer.UV6Kind
     * - VertexBuffer.ColorKind
     * - VertexBuffer.MatricesIndicesKind
     * - VertexBuffer.MatricesIndicesExtraKind
     * - VertexBuffer.MatricesWeightsKind
     * - VertexBuffer.MatricesWeightsExtraKind
     *
     * Returns the Mesh.
     * @param kind defines vertex data kind
     * @param data defines the data source
     * @param updateExtends defines if extends info of the mesh must be updated (can be null). This is mostly useful for "position" kind
     * @param makeItUnique defines it the updated vertex buffer must be flagged as unique (false by default)
     * @returns the source mesh
     */ updateVerticesData(kind, data, updateExtends, makeItUnique) {
        if (this.sourceMesh) this.sourceMesh.updateVerticesData(kind, data, updateExtends, makeItUnique);
        return this.sourceMesh;
    }
    /**
     * Sets the mesh indices.
     * Expects an array populated with integers or a typed array (Int32Array, Uint32Array, Uint16Array).
     * If the mesh has no geometry, a new Geometry object is created and set to the mesh.
     * This method creates a new index buffer each call.
     * Returns the Mesh.
     * @param indices the source data
     * @param totalVertices defines the total number of vertices referenced by indices (could be null)
     * @returns source mesh
     */ setIndices(indices, totalVertices = null) {
        if (this.sourceMesh) this.sourceMesh.setIndices(indices, totalVertices);
        return this.sourceMesh;
    }
    /**
     * Boolean : True if the mesh owns the requested kind of data.
     * @param kind defines which buffer to check (positions, indices, normals, etc). Possible `kind` values :
     * - VertexBuffer.PositionKind
     * - VertexBuffer.UVKind
     * - VertexBuffer.UV2Kind
     * - VertexBuffer.UV3Kind
     * - VertexBuffer.UV4Kind
     * - VertexBuffer.UV5Kind
     * - VertexBuffer.UV6Kind
     * - VertexBuffer.ColorKind
     * - VertexBuffer.MatricesIndicesKind
     * - VertexBuffer.MatricesIndicesExtraKind
     * - VertexBuffer.MatricesWeightsKind
     * - VertexBuffer.MatricesWeightsExtraKind
     * @returns true if data kind is present
     */ isVerticesDataPresent(kind) {
        return this._sourceMesh.isVerticesDataPresent(kind);
    }
    /**
     * @returns an array of indices (IndicesArray).
     */ getIndices() {
        return this._sourceMesh.getIndices();
    }
    get _positions() {
        return this._sourceMesh._positions;
    }
    /**
     * This method recomputes and sets a new BoundingInfo to the mesh unless it is locked.
     * This means the mesh underlying bounding box and sphere are recomputed.
     * @param applySkeleton defines whether to apply the skeleton before computing the bounding info
     * @param applyMorph  defines whether to apply the morph target before computing the bounding info
     * @returns the current mesh
     */ refreshBoundingInfo(applySkeleton = false, applyMorph = false) {
        if (this.hasBoundingInfo && this.getBoundingInfo().isLocked) return this;
        const bias = this._sourceMesh.geometry ? this._sourceMesh.geometry.boundingBias : null;
        this._refreshBoundingInfo(this._sourceMesh._getPositionData(applySkeleton, applyMorph), bias);
        return this;
    }
    /** @internal */ _preActivate() {
        if (this._currentLOD) this._currentLOD._preActivate();
        return this;
    }
    /**
     * @internal
     */ _activate(renderId, intermediateRendering) {
        super._activate(renderId, intermediateRendering);
        if (!this._sourceMesh.subMeshes) (0, $kVtWi.Logger).Warn("Instances should only be created for meshes with geometry.");
        if (this._currentLOD) {
            const differentSign = this._currentLOD._getWorldMatrixDeterminant() >= 0 !== this._getWorldMatrixDeterminant() >= 0;
            if (differentSign) {
                this._internalAbstractMeshDataInfo._actAsRegularMesh = true;
                return true;
            }
            this._internalAbstractMeshDataInfo._actAsRegularMesh = false;
            this._currentLOD._registerInstanceForRenderId(this, renderId);
            if (intermediateRendering) {
                if (!this._currentLOD._internalAbstractMeshDataInfo._isActiveIntermediate) {
                    this._currentLOD._internalAbstractMeshDataInfo._onlyForInstancesIntermediate = true;
                    return true;
                }
            } else if (!this._currentLOD._internalAbstractMeshDataInfo._isActive) {
                this._currentLOD._internalAbstractMeshDataInfo._onlyForInstances = true;
                return true;
            }
        }
        return false;
    }
    /** @internal */ _postActivate() {
        if (this._sourceMesh.edgesShareWithInstances && this._sourceMesh._edgesRenderer && this._sourceMesh._edgesRenderer.isEnabled && this._sourceMesh._renderingGroup) {
            // we are using the edge renderer of the source mesh
            this._sourceMesh._renderingGroup._edgesRenderers.pushNoDuplicate(this._sourceMesh._edgesRenderer);
            this._sourceMesh._edgesRenderer.customInstances.push(this.getWorldMatrix());
        } else if (this._edgesRenderer && this._edgesRenderer.isEnabled && this._sourceMesh._renderingGroup) // we are using the edge renderer defined for this instance
        this._sourceMesh._renderingGroup._edgesRenderers.push(this._edgesRenderer);
    }
    getWorldMatrix() {
        if (this._currentLOD && this._currentLOD.billboardMode !== (0, $klshO.TransformNode).BILLBOARDMODE_NONE && this._currentLOD._masterMesh !== this) {
            if (!this._billboardWorldMatrix) this._billboardWorldMatrix = new (0, $ha1VO.Matrix)();
            const tempMaster = this._currentLOD._masterMesh;
            this._currentLOD._masterMesh = this;
            (0, $ha1VO.TmpVectors).Vector3[7].copyFrom(this._currentLOD.position);
            this._currentLOD.position.set(0, 0, 0);
            this._billboardWorldMatrix.copyFrom(this._currentLOD.computeWorldMatrix(true));
            this._currentLOD.position.copyFrom((0, $ha1VO.TmpVectors).Vector3[7]);
            this._currentLOD._masterMesh = tempMaster;
            return this._billboardWorldMatrix;
        }
        return super.getWorldMatrix();
    }
    get isAnInstance() {
        return true;
    }
    /**
     * Returns the current associated LOD AbstractMesh.
     * @param camera defines the camera to use to pick the LOD level
     * @returns a Mesh or `null` if no LOD is associated with the AbstractMesh
     */ getLOD(camera) {
        if (!camera) return this;
        const sourceMeshLODLevels = this.sourceMesh.getLODLevels();
        if (!sourceMeshLODLevels || sourceMeshLODLevels.length === 0) this._currentLOD = this.sourceMesh;
        else {
            const boundingInfo = this.getBoundingInfo();
            this._currentLOD = this.sourceMesh.getLOD(camera, boundingInfo.boundingSphere);
        }
        return this._currentLOD;
    }
    /**
     * @internal
     */ _preActivateForIntermediateRendering(renderId) {
        return this.sourceMesh._preActivateForIntermediateRendering(renderId);
    }
    /** @internal */ _syncSubMeshes() {
        this.releaseSubMeshes();
        if (this._sourceMesh.subMeshes) for(let index = 0; index < this._sourceMesh.subMeshes.length; index++)this._sourceMesh.subMeshes[index].clone(this, this._sourceMesh);
        return this;
    }
    /** @internal */ _generatePointsArray() {
        return this._sourceMesh._generatePointsArray();
    }
    /** @internal */ _updateBoundingInfo() {
        if (this.hasBoundingInfo) this.getBoundingInfo().update(this.worldMatrixFromCache);
        else this.buildBoundingInfo(this.absolutePosition, this.absolutePosition, this.worldMatrixFromCache);
        this._updateSubMeshesBoundingInfo(this.worldMatrixFromCache);
        return this;
    }
    /**
     * Creates a new InstancedMesh from the current mesh.
     *
     * Returns the clone.
     * @param name the cloned mesh name
     * @param newParent the optional Node to parent the clone to.
     * @param doNotCloneChildren if `true` the model children aren't cloned.
     * @param newSourceMesh if set this mesh will be used as the source mesh instead of ths instance's one
     * @returns the clone
     */ clone(name, newParent = null, doNotCloneChildren, newSourceMesh) {
        const result = (newSourceMesh || this._sourceMesh).createInstance(name);
        // Deep copy
        (0, $fhgis.DeepCopier).DeepCopy(this, result, [
            "name",
            "subMeshes",
            "uniqueId",
            "parent",
            "lightSources",
            "receiveShadows",
            "material",
            "visibility",
            "skeleton",
            "sourceMesh",
            "isAnInstance",
            "facetNb",
            "isFacetDataEnabled",
            "isBlocked",
            "useBones",
            "hasInstances",
            "collider",
            "edgesRenderer",
            "forward",
            "up",
            "right",
            "absolutePosition",
            "absoluteScaling",
            "absoluteRotationQuaternion",
            "isWorldMatrixFrozen",
            "nonUniformScaling",
            "behaviors",
            "worldMatrixFromCache",
            "hasThinInstances",
            "hasBoundingInfo"
        ], []);
        // Bounding info
        this.refreshBoundingInfo();
        // Parent
        if (newParent) result.parent = newParent;
        if (!doNotCloneChildren) // Children
        for(let index = 0; index < this.getScene().meshes.length; index++){
            const mesh = this.getScene().meshes[index];
            if (mesh.parent === this) mesh.clone(mesh.name, result);
        }
        result.computeWorldMatrix(true);
        this.onClonedObservable.notifyObservers(result);
        return result;
    }
    /**
     * Disposes the InstancedMesh.
     * Returns nothing.
     * @param doNotRecurse Set to true to not recurse into each children (recurse into each children by default)
     * @param disposeMaterialAndTextures Set to true to also dispose referenced materials and textures (false by default)
     */ dispose(doNotRecurse, disposeMaterialAndTextures = false) {
        // Remove from mesh
        this._sourceMesh.removeInstance(this);
        super.dispose(doNotRecurse, disposeMaterialAndTextures);
    }
    /**
     * @internal
     */ _serializeAsParent(serializationObject) {
        super._serializeAsParent(serializationObject);
        serializationObject.parentId = this._sourceMesh.uniqueId;
        serializationObject.parentInstanceIndex = this._indexInSourceMeshInstanceArray;
    }
    /**
     * Instantiate (when possible) or clone that node with its hierarchy
     * @param newParent defines the new parent to use for the instance (or clone)
     * @param options defines options to configure how copy is done
     * @param options.doNotInstantiate defines if the model must be instantiated or just cloned
     * @param options.newSourcedMesh newSourcedMesh the new source mesh for the instance (or clone)
     * @param onNewNodeCreated defines an option callback to call when a clone or an instance is created
     * @returns an instance (or a clone) of the current node with its hierarchy
     */ instantiateHierarchy(newParent = null, options, onNewNodeCreated) {
        const clone = this.clone("Clone of " + (this.name || this.id), newParent || this.parent, true, options && options.newSourcedMesh);
        if (clone) {
            if (onNewNodeCreated) onNewNodeCreated(this, clone);
        }
        for (const child of this.getChildTransformNodes(true))child.instantiateHierarchy(clone, options, onNewNodeCreated);
        return clone;
    }
}
(0, $fbuqw.Mesh).prototype.registerInstancedBuffer = function(kind, stride) {
    // Remove existing one
    this._userInstancedBuffersStorage?.vertexBuffers[kind]?.dispose();
    // Creates the instancedBuffer field if not present
    if (!this.instancedBuffers) {
        this.instancedBuffers = {};
        for (const instance of this.instances)instance.instancedBuffers = {};
    }
    if (!this._userInstancedBuffersStorage) this._userInstancedBuffersStorage = {
        data: {},
        vertexBuffers: {},
        strides: {},
        sizes: {},
        vertexArrayObjects: this.getEngine().getCaps().vertexArrayObject ? {} : undefined
    };
    // Creates an empty property for this kind
    this.instancedBuffers[kind] = null;
    this._userInstancedBuffersStorage.strides[kind] = stride;
    this._userInstancedBuffersStorage.sizes[kind] = stride * 32; // Initial size
    this._userInstancedBuffersStorage.data[kind] = new Float32Array(this._userInstancedBuffersStorage.sizes[kind]);
    this._userInstancedBuffersStorage.vertexBuffers[kind] = new (0, $b4i1f.VertexBuffer)(this.getEngine(), this._userInstancedBuffersStorage.data[kind], kind, true, false, stride, true);
    for (const instance of this.instances)instance.instancedBuffers[kind] = null;
    this._invalidateInstanceVertexArrayObject();
    this._markSubMeshesAsAttributesDirty();
};
(0, $fbuqw.Mesh).prototype._processInstancedBuffers = function(visibleInstances, renderSelf) {
    const instanceCount = visibleInstances ? visibleInstances.length : 0;
    for(const kind in this.instancedBuffers){
        let size = this._userInstancedBuffersStorage.sizes[kind];
        const stride = this._userInstancedBuffersStorage.strides[kind];
        // Resize if required
        const expectedSize = (instanceCount + 1) * stride;
        while(size < expectedSize)size *= 2;
        if (this._userInstancedBuffersStorage.data[kind].length != size) {
            this._userInstancedBuffersStorage.data[kind] = new Float32Array(size);
            this._userInstancedBuffersStorage.sizes[kind] = size;
            if (this._userInstancedBuffersStorage.vertexBuffers[kind]) {
                this._userInstancedBuffersStorage.vertexBuffers[kind].dispose();
                this._userInstancedBuffersStorage.vertexBuffers[kind] = null;
            }
        }
        const data = this._userInstancedBuffersStorage.data[kind];
        // Update data buffer
        let offset = 0;
        if (renderSelf) {
            const value = this.instancedBuffers[kind];
            if (value.toArray) value.toArray(data, offset);
            else if (value.copyToArray) value.copyToArray(data, offset);
            else data[offset] = value;
            offset += stride;
        }
        for(let instanceIndex = 0; instanceIndex < instanceCount; instanceIndex++){
            const instance = visibleInstances[instanceIndex];
            const value = instance.instancedBuffers[kind];
            if (value.toArray) value.toArray(data, offset);
            else if (value.copyToArray) value.copyToArray(data, offset);
            else data[offset] = value;
            offset += stride;
        }
        // Update vertex buffer
        if (!this._userInstancedBuffersStorage.vertexBuffers[kind]) {
            this._userInstancedBuffersStorage.vertexBuffers[kind] = new (0, $b4i1f.VertexBuffer)(this.getEngine(), this._userInstancedBuffersStorage.data[kind], kind, true, false, stride, true);
            this._invalidateInstanceVertexArrayObject();
        } else this._userInstancedBuffersStorage.vertexBuffers[kind].updateDirectly(data, 0);
    }
};
(0, $fbuqw.Mesh).prototype._invalidateInstanceVertexArrayObject = function() {
    if (!this._userInstancedBuffersStorage || this._userInstancedBuffersStorage.vertexArrayObjects === undefined) return;
    for(const kind in this._userInstancedBuffersStorage.vertexArrayObjects)this.getEngine().releaseVertexArrayObject(this._userInstancedBuffersStorage.vertexArrayObjects[kind]);
    this._userInstancedBuffersStorage.vertexArrayObjects = {};
};
(0, $fbuqw.Mesh).prototype._disposeInstanceSpecificData = function() {
    if (this._instanceDataStorage.instancesBuffer) {
        this._instanceDataStorage.instancesBuffer.dispose();
        this._instanceDataStorage.instancesBuffer = null;
    }
    while(this.instances.length)this.instances[0].dispose();
    for(const kind in this.instancedBuffers)if (this._userInstancedBuffersStorage.vertexBuffers[kind]) this._userInstancedBuffersStorage.vertexBuffers[kind].dispose();
    this._invalidateInstanceVertexArrayObject();
    this.instancedBuffers = {};
};

});

parcelRegister("c6YWJ", function(module, exports) {

$parcel$export(module.exports, "Light", () => $8d1552389e88f3b1$export$6ecadb6ed240d696);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $bgssx = parcelRequire("bgssx");

var $ghoTi = parcelRequire("ghoTi");

var $8DoUR = parcelRequire("8DoUR");

var $1gEbu = parcelRequire("1gEbu");

var $6Ho1L = parcelRequire("6Ho1L");
class $8d1552389e88f3b1$export$6ecadb6ed240d696 extends (0, $bgssx.Node) {
    /**
     * Defines how far from the source the light is impacting in scene units.
     * Note: Unused in PBR material as the distance light falloff is defined following the inverse squared falloff.
     */ get range() {
        return this._range;
    }
    /**
     * Defines how far from the source the light is impacting in scene units.
     * Note: Unused in PBR material as the distance light falloff is defined following the inverse squared falloff.
     */ set range(value) {
        this._range = value;
        this._inverseSquaredRange = 1.0 / (this.range * this.range);
    }
    /**
     * Gets the photometric scale used to interpret the intensity.
     * This is only relevant with PBR Materials where the light intensity can be defined in a physical way.
     */ get intensityMode() {
        return this._intensityMode;
    }
    /**
     * Sets the photometric scale used to interpret the intensity.
     * This is only relevant with PBR Materials where the light intensity can be defined in a physical way.
     */ set intensityMode(value) {
        this._intensityMode = value;
        this._computePhotometricScale();
    }
    /**
     * Gets the light radius used by PBR Materials to simulate soft area lights.
     */ get radius() {
        return this._radius;
    }
    /**
     * sets the light radius used by PBR Materials to simulate soft area lights.
     */ set radius(value) {
        this._radius = value;
        this._computePhotometricScale();
    }
    /**
     * Gets whether or not the shadows are enabled for this light. This can help turning off/on shadow without detaching
     * the current shadow generator.
     */ get shadowEnabled() {
        return this._shadowEnabled;
    }
    /**
     * Sets whether or not the shadows are enabled for this light. This can help turning off/on shadow without detaching
     * the current shadow generator.
     */ set shadowEnabled(value) {
        if (this._shadowEnabled === value) return;
        this._shadowEnabled = value;
        this._markMeshesAsLightDirty();
    }
    /**
     * Gets the only meshes impacted by this light.
     */ get includedOnlyMeshes() {
        return this._includedOnlyMeshes;
    }
    /**
     * Sets the only meshes impacted by this light.
     */ set includedOnlyMeshes(value) {
        this._includedOnlyMeshes = value;
        this._hookArrayForIncludedOnly(value);
    }
    /**
     * Gets the meshes not impacted by this light.
     */ get excludedMeshes() {
        return this._excludedMeshes;
    }
    /**
     * Sets the meshes not impacted by this light.
     */ set excludedMeshes(value) {
        this._excludedMeshes = value;
        this._hookArrayForExcluded(value);
    }
    /**
     * Gets the layer id use to find what meshes are not impacted by the light.
     * Inactive if 0
     */ get excludeWithLayerMask() {
        return this._excludeWithLayerMask;
    }
    /**
     * Sets the layer id use to find what meshes are not impacted by the light.
     * Inactive if 0
     */ set excludeWithLayerMask(value) {
        this._excludeWithLayerMask = value;
        this._resyncMeshes();
    }
    /**
     * Gets the layer id use to find what meshes are impacted by the light.
     * Inactive if 0
     */ get includeOnlyWithLayerMask() {
        return this._includeOnlyWithLayerMask;
    }
    /**
     * Sets the layer id use to find what meshes are impacted by the light.
     * Inactive if 0
     */ set includeOnlyWithLayerMask(value) {
        this._includeOnlyWithLayerMask = value;
        this._resyncMeshes();
    }
    /**
     * Gets the lightmap mode of this light (should be one of the constants defined by Light.LIGHTMAP_x)
     */ get lightmapMode() {
        return this._lightmapMode;
    }
    /**
     * Sets the lightmap mode of this light (should be one of the constants defined by Light.LIGHTMAP_x)
     */ set lightmapMode(value) {
        if (this._lightmapMode === value) return;
        this._lightmapMode = value;
        this._markMeshesAsLightDirty();
    }
    /**
     * Returns the view matrix.
     * @param _faceIndex The index of the face for which we want to extract the view matrix. Only used for point light types.
     * @returns The view matrix. Can be null, if a view matrix cannot be defined for the type of light considered (as for a hemispherical light, for example).
     */ getViewMatrix(_faceIndex) {
        return null;
    }
    /**
     * Returns the projection matrix.
     * Note that viewMatrix and renderList are optional and are only used by lights that calculate the projection matrix from a list of meshes (e.g. directional lights with automatic extents calculation).
     * @param _viewMatrix The view transform matrix of the light (optional).
     * @param _renderList The list of meshes to take into account when calculating the projection matrix (optional).
     * @returns The projection matrix. Can be null, if a projection matrix cannot be defined for the type of light considered (as for a hemispherical light, for example).
     */ getProjectionMatrix(_viewMatrix, _renderList) {
        return null;
    }
    /**
     * Creates a Light object in the scene.
     * Documentation : https://doc.babylonjs.com/features/featuresDeepDive/lights/lights_introduction
     * @param name The friendly name of the light
     * @param scene The scene the light belongs too
     */ constructor(name, scene){
        super(name, scene);
        /**
         * Diffuse gives the basic color to an object.
         */ this.diffuse = new (0, $7etnY.Color3)(1.0, 1.0, 1.0);
        /**
         * Specular produces a highlight color on an object.
         * Note: This is not affecting PBR materials.
         */ this.specular = new (0, $7etnY.Color3)(1.0, 1.0, 1.0);
        /**
         * Defines the falloff type for this light. This lets overriding how punctual light are
         * falling off base on range or angle.
         * This can be set to any values in Light.FALLOFF_x.
         *
         * Note: This is only useful for PBR Materials at the moment. This could be extended if required to
         * other types of materials.
         */ this.falloffType = $8d1552389e88f3b1$export$6ecadb6ed240d696.FALLOFF_DEFAULT;
        /**
         * Strength of the light.
         * Note: By default it is define in the framework own unit.
         * Note: In PBR materials the intensityMode can be use to chose what unit the intensity is defined in.
         */ this.intensity = 1.0;
        this._range = Number.MAX_VALUE;
        this._inverseSquaredRange = 0;
        /**
         * Cached photometric scale default to 1.0 as the automatic intensity mode defaults to 1.0 for every type
         * of light.
         */ this._photometricScale = 1.0;
        this._intensityMode = $8d1552389e88f3b1$export$6ecadb6ed240d696.INTENSITYMODE_AUTOMATIC;
        this._radius = 0.00001;
        /**
         * Defines the rendering priority of the lights. It can help in case of fallback or number of lights
         * exceeding the number allowed of the materials.
         */ this.renderPriority = 0;
        this._shadowEnabled = true;
        this._excludeWithLayerMask = 0;
        this._includeOnlyWithLayerMask = 0;
        this._lightmapMode = 0;
        /**
         * Shadow generators associated to the light.
         * @internal Internal use only.
         */ this._shadowGenerators = null;
        /**
         * @internal Internal use only.
         */ this._excludedMeshesIds = new Array();
        /**
         * @internal Internal use only.
         */ this._includedOnlyMeshesIds = new Array();
        /** @internal */ this._isLight = true;
        this.getScene().addLight(this);
        this._uniformBuffer = new (0, $ghoTi.UniformBuffer)(this.getScene().getEngine(), undefined, undefined, name);
        this._buildUniformLayout();
        this.includedOnlyMeshes = [];
        this.excludedMeshes = [];
        this._resyncMeshes();
    }
    /**
     * Sets the passed Effect "effect" with the Light textures.
     * @param effect The effect to update
     * @param lightIndex The index of the light in the effect to update
     * @returns The light
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    transferTexturesToEffect(effect, lightIndex) {
        // Do nothing by default.
        return this;
    }
    /**
     * Binds the lights information from the scene to the effect for the given mesh.
     * @param lightIndex Light index
     * @param scene The scene where the light belongs to
     * @param effect The effect we are binding the data to
     * @param useSpecular Defines if specular is supported
     * @param receiveShadows Defines if the effect (mesh) we bind the light for receives shadows
     */ _bindLight(lightIndex, scene, effect, useSpecular, receiveShadows = true) {
        const iAsString = lightIndex.toString();
        let needUpdate = false;
        this._uniformBuffer.bindToEffect(effect, "Light" + iAsString);
        if (this._renderId !== scene.getRenderId() || this._lastUseSpecular !== useSpecular || !this._uniformBuffer.useUbo) {
            this._renderId = scene.getRenderId();
            this._lastUseSpecular = useSpecular;
            const scaledIntensity = this.getScaledIntensity();
            this.transferToEffect(effect, iAsString);
            this.diffuse.scaleToRef(scaledIntensity, (0, $7etnY.TmpColors).Color3[0]);
            this._uniformBuffer.updateColor4("vLightDiffuse", (0, $7etnY.TmpColors).Color3[0], this.range, iAsString);
            if (useSpecular) {
                this.specular.scaleToRef(scaledIntensity, (0, $7etnY.TmpColors).Color3[1]);
                this._uniformBuffer.updateColor4("vLightSpecular", (0, $7etnY.TmpColors).Color3[1], this.radius, iAsString);
            }
            needUpdate = true;
        }
        // Textures might still need to be rebound.
        this.transferTexturesToEffect(effect, iAsString);
        // Shadows
        if (scene.shadowsEnabled && this.shadowEnabled && receiveShadows) {
            const shadowGenerator = this.getShadowGenerator(scene.activeCamera) ?? this.getShadowGenerator();
            if (shadowGenerator) {
                shadowGenerator.bindShadowLight(iAsString, effect);
                needUpdate = true;
            }
        }
        if (needUpdate) this._uniformBuffer.update();
        else this._uniformBuffer.bindUniformBuffer();
    }
    /**
     * Returns the string "Light".
     * @returns the class name
     */ getClassName() {
        return "Light";
    }
    /**
     * Converts the light information to a readable string for debug purpose.
     * @param fullDetails Supports for multiple levels of logging within scene loading
     * @returns the human readable light info
     */ toString(fullDetails) {
        let ret = "Name: " + this.name;
        ret += ", type: " + [
            "Point",
            "Directional",
            "Spot",
            "Hemispheric"
        ][this.getTypeID()];
        if (this.animations) for(let i = 0; i < this.animations.length; i++)ret += ", animation[0]: " + this.animations[i].toString(fullDetails);
        return ret;
    }
    /** @internal */ _syncParentEnabledState() {
        super._syncParentEnabledState();
        if (!this.isDisposed()) this._resyncMeshes();
    }
    /**
     * Set the enabled state of this node.
     * @param value - the new enabled state
     */ setEnabled(value) {
        super.setEnabled(value);
        this._resyncMeshes();
    }
    /**
     * Returns the Light associated shadow generator if any.
     * @param camera Camera for which the shadow generator should be retrieved (default: null). If null, retrieves the default shadow generator
     * @returns the associated shadow generator.
     */ getShadowGenerator(camera = null) {
        if (this._shadowGenerators === null) return null;
        return this._shadowGenerators.get(camera) ?? null;
    }
    /**
     * Returns all the shadow generators associated to this light
     * @returns
     */ getShadowGenerators() {
        return this._shadowGenerators;
    }
    /**
     * Returns a Vector3, the absolute light position in the World.
     * @returns the world space position of the light
     */ getAbsolutePosition() {
        return (0, $ha1VO.Vector3).Zero();
    }
    /**
     * Specifies if the light will affect the passed mesh.
     * @param mesh The mesh to test against the light
     * @returns true the mesh is affected otherwise, false.
     */ canAffectMesh(mesh) {
        if (!mesh) return true;
        if (this.includedOnlyMeshes && this.includedOnlyMeshes.length > 0 && this.includedOnlyMeshes.indexOf(mesh) === -1) return false;
        if (this.excludedMeshes && this.excludedMeshes.length > 0 && this.excludedMeshes.indexOf(mesh) !== -1) return false;
        if (this.includeOnlyWithLayerMask !== 0 && (this.includeOnlyWithLayerMask & mesh.layerMask) === 0) return false;
        if (this.excludeWithLayerMask !== 0 && this.excludeWithLayerMask & mesh.layerMask) return false;
        return true;
    }
    /**
     * Releases resources associated with this node.
     * @param doNotRecurse Set to true to not recurse into each children (recurse into each children by default)
     * @param disposeMaterialAndTextures Set to true to also dispose referenced materials and textures (false by default)
     */ dispose(doNotRecurse, disposeMaterialAndTextures = false) {
        if (this._shadowGenerators) {
            const iterator = this._shadowGenerators.values();
            for(let key = iterator.next(); key.done !== true; key = iterator.next()){
                const shadowGenerator = key.value;
                shadowGenerator.dispose();
            }
            this._shadowGenerators = null;
        }
        // Animations
        this.getScene().stopAnimation(this);
        if (this._parentContainer) {
            const index = this._parentContainer.lights.indexOf(this);
            if (index > -1) this._parentContainer.lights.splice(index, 1);
            this._parentContainer = null;
        }
        // Remove from meshes
        for (const mesh of this.getScene().meshes)mesh._removeLightSource(this, true);
        this._uniformBuffer.dispose();
        // Remove from scene
        this.getScene().removeLight(this);
        super.dispose(doNotRecurse, disposeMaterialAndTextures);
    }
    /**
     * Returns the light type ID (integer).
     * @returns The light Type id as a constant defines in Light.LIGHTTYPEID_x
     */ getTypeID() {
        return 0;
    }
    /**
     * Returns the intensity scaled by the Photometric Scale according to the light type and intensity mode.
     * @returns the scaled intensity in intensity mode unit
     */ getScaledIntensity() {
        return this._photometricScale * this.intensity;
    }
    /**
     * Returns a new Light object, named "name", from the current one.
     * @param name The name of the cloned light
     * @param newParent The parent of this light, if it has one
     * @returns the new created light
     */ clone(name, newParent = null) {
        const constructor = $8d1552389e88f3b1$export$6ecadb6ed240d696.GetConstructorFromName(this.getTypeID(), name, this.getScene());
        if (!constructor) return null;
        const clonedLight = (0, $6Ho1L.SerializationHelper).Clone(constructor, this);
        if (name) clonedLight.name = name;
        if (newParent) clonedLight.parent = newParent;
        clonedLight.setEnabled(this.isEnabled());
        this.onClonedObservable.notifyObservers(clonedLight);
        return clonedLight;
    }
    /**
     * Serializes the current light into a Serialization object.
     * @returns the serialized object.
     */ serialize() {
        const serializationObject = (0, $6Ho1L.SerializationHelper).Serialize(this);
        serializationObject.uniqueId = this.uniqueId;
        // Type
        serializationObject.type = this.getTypeID();
        // Parent
        if (this.parent) this.parent._serializeAsParent(serializationObject);
        // Inclusion / exclusions
        if (this.excludedMeshes.length > 0) {
            serializationObject.excludedMeshesIds = [];
            this.excludedMeshes.forEach((mesh)=>{
                serializationObject.excludedMeshesIds.push(mesh.id);
            });
        }
        if (this.includedOnlyMeshes.length > 0) {
            serializationObject.includedOnlyMeshesIds = [];
            this.includedOnlyMeshes.forEach((mesh)=>{
                serializationObject.includedOnlyMeshesIds.push(mesh.id);
            });
        }
        // Animations
        (0, $6Ho1L.SerializationHelper).AppendSerializedAnimations(this, serializationObject);
        serializationObject.ranges = this.serializeAnimationRanges();
        serializationObject.isEnabled = this.isEnabled();
        return serializationObject;
    }
    /**
     * Creates a new typed light from the passed type (integer) : point light = 0, directional light = 1, spot light = 2, hemispheric light = 3.
     * This new light is named "name" and added to the passed scene.
     * @param type Type according to the types available in Light.LIGHTTYPEID_x
     * @param name The friendly name of the light
     * @param scene The scene the new light will belong to
     * @returns the constructor function
     */ static GetConstructorFromName(type, name, scene) {
        const constructorFunc = (0, $bgssx.Node).Construct("Light_Type_" + type, name, scene);
        if (constructorFunc) return constructorFunc;
        // Default to no light for none present once.
        return null;
    }
    /**
     * Parses the passed "parsedLight" and returns a new instanced Light from this parsing.
     * @param parsedLight The JSON representation of the light
     * @param scene The scene to create the parsed light in
     * @returns the created light after parsing
     */ static Parse(parsedLight, scene) {
        const constructor = $8d1552389e88f3b1$export$6ecadb6ed240d696.GetConstructorFromName(parsedLight.type, parsedLight.name, scene);
        if (!constructor) return null;
        const light = (0, $6Ho1L.SerializationHelper).Parse(constructor, parsedLight, scene);
        // Inclusion / exclusions
        if (parsedLight.excludedMeshesIds) light._excludedMeshesIds = parsedLight.excludedMeshesIds;
        if (parsedLight.includedOnlyMeshesIds) light._includedOnlyMeshesIds = parsedLight.includedOnlyMeshesIds;
        // Parent
        if (parsedLight.parentId !== undefined) light._waitingParentId = parsedLight.parentId;
        if (parsedLight.parentInstanceIndex !== undefined) light._waitingParentInstanceIndex = parsedLight.parentInstanceIndex;
        // Falloff
        if (parsedLight.falloffType !== undefined) light.falloffType = parsedLight.falloffType;
        // Lightmaps
        if (parsedLight.lightmapMode !== undefined) light.lightmapMode = parsedLight.lightmapMode;
        // Animations
        if (parsedLight.animations) {
            for(let animationIndex = 0; animationIndex < parsedLight.animations.length; animationIndex++){
                const parsedAnimation = parsedLight.animations[animationIndex];
                const internalClass = (0, $8DoUR.GetClass)("BABYLON.Animation");
                if (internalClass) light.animations.push(internalClass.Parse(parsedAnimation));
            }
            (0, $bgssx.Node).ParseAnimationRanges(light, parsedLight, scene);
        }
        if (parsedLight.autoAnimate) scene.beginAnimation(light, parsedLight.autoAnimateFrom, parsedLight.autoAnimateTo, parsedLight.autoAnimateLoop, parsedLight.autoAnimateSpeed || 1.0);
        // Check if isEnabled is defined to be back compatible with prior serialized versions.
        if (parsedLight.isEnabled !== undefined) light.setEnabled(parsedLight.isEnabled);
        return light;
    }
    _hookArrayForExcluded(array) {
        const oldPush = array.push;
        array.push = (...items)=>{
            const result = oldPush.apply(array, items);
            for (const item of items)item._resyncLightSource(this);
            return result;
        };
        const oldSplice = array.splice;
        array.splice = (index, deleteCount)=>{
            const deleted = oldSplice.apply(array, [
                index,
                deleteCount
            ]);
            for (const item of deleted)item._resyncLightSource(this);
            return deleted;
        };
        for (const item of array)item._resyncLightSource(this);
    }
    _hookArrayForIncludedOnly(array) {
        const oldPush = array.push;
        array.push = (...items)=>{
            const result = oldPush.apply(array, items);
            this._resyncMeshes();
            return result;
        };
        const oldSplice = array.splice;
        array.splice = (index, deleteCount)=>{
            const deleted = oldSplice.apply(array, [
                index,
                deleteCount
            ]);
            this._resyncMeshes();
            return deleted;
        };
        this._resyncMeshes();
    }
    _resyncMeshes() {
        for (const mesh of this.getScene().meshes)mesh._resyncLightSource(this);
    }
    /**
     * Forces the meshes to update their light related information in their rendering used effects
     * @internal Internal Use Only
     */ _markMeshesAsLightDirty() {
        for (const mesh of this.getScene().meshes)if (mesh.lightSources.indexOf(this) !== -1) mesh._markSubMeshesAsLightDirty();
    }
    /**
     * Recomputes the cached photometric scale if needed.
     */ _computePhotometricScale() {
        this._photometricScale = this._getPhotometricScale();
        this.getScene().resetCachedMaterial();
    }
    /**
     * @returns the Photometric Scale according to the light type and intensity mode.
     */ _getPhotometricScale() {
        let photometricScale = 0.0;
        const lightTypeID = this.getTypeID();
        //get photometric mode
        let photometricMode = this.intensityMode;
        if (photometricMode === $8d1552389e88f3b1$export$6ecadb6ed240d696.INTENSITYMODE_AUTOMATIC) {
            if (lightTypeID === $8d1552389e88f3b1$export$6ecadb6ed240d696.LIGHTTYPEID_DIRECTIONALLIGHT) photometricMode = $8d1552389e88f3b1$export$6ecadb6ed240d696.INTENSITYMODE_ILLUMINANCE;
            else photometricMode = $8d1552389e88f3b1$export$6ecadb6ed240d696.INTENSITYMODE_LUMINOUSINTENSITY;
        }
        //compute photometric scale
        switch(lightTypeID){
            case $8d1552389e88f3b1$export$6ecadb6ed240d696.LIGHTTYPEID_POINTLIGHT:
            case $8d1552389e88f3b1$export$6ecadb6ed240d696.LIGHTTYPEID_SPOTLIGHT:
                switch(photometricMode){
                    case $8d1552389e88f3b1$export$6ecadb6ed240d696.INTENSITYMODE_LUMINOUSPOWER:
                        photometricScale = 1.0 / (4.0 * Math.PI);
                        break;
                    case $8d1552389e88f3b1$export$6ecadb6ed240d696.INTENSITYMODE_LUMINOUSINTENSITY:
                        photometricScale = 1.0;
                        break;
                    case $8d1552389e88f3b1$export$6ecadb6ed240d696.INTENSITYMODE_LUMINANCE:
                        photometricScale = this.radius * this.radius;
                        break;
                }
                break;
            case $8d1552389e88f3b1$export$6ecadb6ed240d696.LIGHTTYPEID_DIRECTIONALLIGHT:
                switch(photometricMode){
                    case $8d1552389e88f3b1$export$6ecadb6ed240d696.INTENSITYMODE_ILLUMINANCE:
                        photometricScale = 1.0;
                        break;
                    case $8d1552389e88f3b1$export$6ecadb6ed240d696.INTENSITYMODE_LUMINANCE:
                        {
                            // When radius (and therefore solid angle) is non-zero a directional lights brightness can be specified via central (peak) luminance.
                            // For a directional light the 'radius' defines the angular radius (in radians) rather than world-space radius (e.g. in metres).
                            let apexAngleRadians = this.radius;
                            // Impose a minimum light angular size to avoid the light becoming an infinitely small angular light source (i.e. a dirac delta function).
                            apexAngleRadians = Math.max(apexAngleRadians, 0.001);
                            const solidAngle = 2.0 * Math.PI * (1.0 - Math.cos(apexAngleRadians));
                            photometricScale = solidAngle;
                            break;
                        }
                }
                break;
            case $8d1552389e88f3b1$export$6ecadb6ed240d696.LIGHTTYPEID_HEMISPHERICLIGHT:
                // No fall off in hemispheric light.
                photometricScale = 1.0;
                break;
        }
        return photometricScale;
    }
    /**
     * Reorder the light in the scene according to their defined priority.
     * @internal Internal Use Only
     */ _reorderLightsInScene() {
        const scene = this.getScene();
        if (this._renderPriority != 0) scene.requireLightSorting = true;
        this.getScene().sortLightsByPriority();
    }
}
/**
 * Falloff Default: light is falling off following the material specification:
 * standard material is using standard falloff whereas pbr material can request special falloff per materials.
 */ $8d1552389e88f3b1$export$6ecadb6ed240d696.FALLOFF_DEFAULT = (0, $1gEbu.LightConstants).FALLOFF_DEFAULT;
/**
 * Falloff Physical: light is falling off following the inverse squared distance law.
 */ $8d1552389e88f3b1$export$6ecadb6ed240d696.FALLOFF_PHYSICAL = (0, $1gEbu.LightConstants).FALLOFF_PHYSICAL;
/**
 * Falloff gltf: light is falling off as described in the gltf moving to PBR document
 * to enhance interoperability with other engines.
 */ $8d1552389e88f3b1$export$6ecadb6ed240d696.FALLOFF_GLTF = (0, $1gEbu.LightConstants).FALLOFF_GLTF;
/**
 * Falloff Standard: light is falling off like in the standard material
 * to enhance interoperability with other materials.
 */ $8d1552389e88f3b1$export$6ecadb6ed240d696.FALLOFF_STANDARD = (0, $1gEbu.LightConstants).FALLOFF_STANDARD;
//lightmapMode Consts
/**
 * If every light affecting the material is in this lightmapMode,
 * material.lightmapTexture adds or multiplies
 * (depends on material.useLightmapAsShadowmap)
 * after every other light calculations.
 */ $8d1552389e88f3b1$export$6ecadb6ed240d696.LIGHTMAP_DEFAULT = (0, $1gEbu.LightConstants).LIGHTMAP_DEFAULT;
/**
 * material.lightmapTexture as only diffuse lighting from this light
 * adds only specular lighting from this light
 * adds dynamic shadows
 */ $8d1552389e88f3b1$export$6ecadb6ed240d696.LIGHTMAP_SPECULAR = (0, $1gEbu.LightConstants).LIGHTMAP_SPECULAR;
/**
 * material.lightmapTexture as only lighting
 * no light calculation from this light
 * only adds dynamic shadows from this light
 */ $8d1552389e88f3b1$export$6ecadb6ed240d696.LIGHTMAP_SHADOWSONLY = (0, $1gEbu.LightConstants).LIGHTMAP_SHADOWSONLY;
// Intensity Mode Consts
/**
 * Each light type uses the default quantity according to its type:
 *      point/spot lights use luminous intensity
 *      directional lights use illuminance
 */ $8d1552389e88f3b1$export$6ecadb6ed240d696.INTENSITYMODE_AUTOMATIC = (0, $1gEbu.LightConstants).INTENSITYMODE_AUTOMATIC;
/**
 * lumen (lm)
 */ $8d1552389e88f3b1$export$6ecadb6ed240d696.INTENSITYMODE_LUMINOUSPOWER = (0, $1gEbu.LightConstants).INTENSITYMODE_LUMINOUSPOWER;
/**
 * candela (lm/sr)
 */ $8d1552389e88f3b1$export$6ecadb6ed240d696.INTENSITYMODE_LUMINOUSINTENSITY = (0, $1gEbu.LightConstants).INTENSITYMODE_LUMINOUSINTENSITY;
/**
 * lux (lm/m^2)
 */ $8d1552389e88f3b1$export$6ecadb6ed240d696.INTENSITYMODE_ILLUMINANCE = (0, $1gEbu.LightConstants).INTENSITYMODE_ILLUMINANCE;
/**
 * nit (cd/m^2)
 */ $8d1552389e88f3b1$export$6ecadb6ed240d696.INTENSITYMODE_LUMINANCE = (0, $1gEbu.LightConstants).INTENSITYMODE_LUMINANCE;
// Light types ids const.
/**
 * Light type const id of the point light.
 */ $8d1552389e88f3b1$export$6ecadb6ed240d696.LIGHTTYPEID_POINTLIGHT = (0, $1gEbu.LightConstants).LIGHTTYPEID_POINTLIGHT;
/**
 * Light type const id of the directional light.
 */ $8d1552389e88f3b1$export$6ecadb6ed240d696.LIGHTTYPEID_DIRECTIONALLIGHT = (0, $1gEbu.LightConstants).LIGHTTYPEID_DIRECTIONALLIGHT;
/**
 * Light type const id of the spot light.
 */ $8d1552389e88f3b1$export$6ecadb6ed240d696.LIGHTTYPEID_SPOTLIGHT = (0, $1gEbu.LightConstants).LIGHTTYPEID_SPOTLIGHT;
/**
 * Light type const id of the hemispheric light.
 */ $8d1552389e88f3b1$export$6ecadb6ed240d696.LIGHTTYPEID_HEMISPHERICLIGHT = (0, $1gEbu.LightConstants).LIGHTTYPEID_HEMISPHERICLIGHT;
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor3)()
], $8d1552389e88f3b1$export$6ecadb6ed240d696.prototype, "diffuse", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor3)()
], $8d1552389e88f3b1$export$6ecadb6ed240d696.prototype, "specular", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $8d1552389e88f3b1$export$6ecadb6ed240d696.prototype, "falloffType", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $8d1552389e88f3b1$export$6ecadb6ed240d696.prototype, "intensity", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $8d1552389e88f3b1$export$6ecadb6ed240d696.prototype, "range", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $8d1552389e88f3b1$export$6ecadb6ed240d696.prototype, "intensityMode", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $8d1552389e88f3b1$export$6ecadb6ed240d696.prototype, "radius", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $8d1552389e88f3b1$export$6ecadb6ed240d696.prototype, "_renderPriority", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_reorderLightsInScene")
], $8d1552389e88f3b1$export$6ecadb6ed240d696.prototype, "renderPriority", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("shadowEnabled")
], $8d1552389e88f3b1$export$6ecadb6ed240d696.prototype, "_shadowEnabled", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("excludeWithLayerMask")
], $8d1552389e88f3b1$export$6ecadb6ed240d696.prototype, "_excludeWithLayerMask", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("includeOnlyWithLayerMask")
], $8d1552389e88f3b1$export$6ecadb6ed240d696.prototype, "_includeOnlyWithLayerMask", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("lightmapMode")
], $8d1552389e88f3b1$export$6ecadb6ed240d696.prototype, "_lightmapMode", void 0);

});


parcelRegister("9HEaj", function(module, exports) {

var $ceRLM = parcelRequire("ceRLM");

var $3IvEY = parcelRequire("3IvEY");

var $k3GLD = parcelRequire("k3GLD");

var $iIwbj = parcelRequire("iIwbj");

var $inyiK = parcelRequire("inyiK");

var $gEKAb = parcelRequire("gEKAb");

var $kIpCn = parcelRequire("kIpCn");

var $76WOH = parcelRequire("76WOH");
$parcel$exportWildcard(module.exports, $ceRLM);
$parcel$exportWildcard(module.exports, $3IvEY);
$parcel$exportWildcard(module.exports, $k3GLD);
$parcel$exportWildcard(module.exports, $iIwbj);
$parcel$exportWildcard(module.exports, $inyiK);
$parcel$exportWildcard(module.exports, $gEKAb);
$parcel$exportWildcard(module.exports, $kIpCn);
$parcel$exportWildcard(module.exports, $76WOH);

});
parcelRegister("ceRLM", function(module, exports) {

});

parcelRegister("3IvEY", function(module, exports) {

});

parcelRegister("k3GLD", function(module, exports) {

$parcel$export(module.exports, "Analyser", () => $e9a54324f0226576$export$86a05438820989b0);

var $5YkyR = parcelRequire("5YkyR");

var $bOhSV = parcelRequire("bOhSV");

var $ejQPp = parcelRequire("ejQPp");
class $e9a54324f0226576$export$86a05438820989b0 {
    /**
     * Creates a new analyser
     * @param scene defines hosting scene
     */ constructor(scene){
        /**
         * Gets or sets the smoothing
         * @ignorenaming
         */ this.SMOOTHING = 0.75;
        /**
         * Gets or sets the FFT table size
         * @ignorenaming
         */ this.FFT_SIZE = 512;
        /**
         * Gets or sets the bar graph amplitude
         * @ignorenaming
         */ this.BARGRAPHAMPLITUDE = 256;
        /**
         * Gets or sets the position of the debug canvas
         * @ignorenaming
         */ this.DEBUGCANVASPOS = {
            x: 20,
            y: 20
        };
        /**
         * Gets or sets the debug canvas size
         * @ignorenaming
         */ this.DEBUGCANVASSIZE = {
            width: 320,
            height: 200
        };
        scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        if (!scene) return;
        this._scene = scene;
        if (!(0, $5YkyR.Engine).audioEngine) {
            (0, $bOhSV.Tools).Warn("No audio engine initialized, failed to create an audio analyser");
            return;
        }
        this._audioEngine = (0, $5YkyR.Engine).audioEngine;
        if (this._audioEngine.canUseWebAudio && this._audioEngine.audioContext) {
            this._webAudioAnalyser = this._audioEngine.audioContext.createAnalyser();
            this._webAudioAnalyser.minDecibels = -140;
            this._webAudioAnalyser.maxDecibels = 0;
            this._byteFreqs = new Uint8Array(this._webAudioAnalyser.frequencyBinCount);
            this._byteTime = new Uint8Array(this._webAudioAnalyser.frequencyBinCount);
            this._floatFreqs = new Float32Array(this._webAudioAnalyser.frequencyBinCount);
        }
    }
    /**
     * Get the number of data values you will have to play with for the visualization
     * @see https://developer.mozilla.org/en-US/docs/Web/API/AnalyserNode/frequencyBinCount
     * @returns a number
     */ getFrequencyBinCount() {
        if (this._audioEngine.canUseWebAudio) return this._webAudioAnalyser.frequencyBinCount;
        else return 0;
    }
    /**
     * Gets the current frequency data as a byte array
     * @see https://developer.mozilla.org/en-US/docs/Web/API/AnalyserNode/getByteFrequencyData
     * @returns a Uint8Array
     */ getByteFrequencyData() {
        if (this._audioEngine.canUseWebAudio) {
            this._webAudioAnalyser.smoothingTimeConstant = this.SMOOTHING;
            this._webAudioAnalyser.fftSize = this.FFT_SIZE;
            this._webAudioAnalyser.getByteFrequencyData(this._byteFreqs);
        }
        return this._byteFreqs;
    }
    /**
     * Gets the current waveform as a byte array
     * @see https://developer.mozilla.org/en-US/docs/Web/API/AnalyserNode/getByteTimeDomainData
     * @returns a Uint8Array
     */ getByteTimeDomainData() {
        if (this._audioEngine.canUseWebAudio) {
            this._webAudioAnalyser.smoothingTimeConstant = this.SMOOTHING;
            this._webAudioAnalyser.fftSize = this.FFT_SIZE;
            this._webAudioAnalyser.getByteTimeDomainData(this._byteTime);
        }
        return this._byteTime;
    }
    /**
     * Gets the current frequency data as a float array
     * @see https://developer.mozilla.org/en-US/docs/Web/API/AnalyserNode/getByteFrequencyData
     * @returns a Float32Array
     */ getFloatFrequencyData() {
        if (this._audioEngine.canUseWebAudio) {
            this._webAudioAnalyser.smoothingTimeConstant = this.SMOOTHING;
            this._webAudioAnalyser.fftSize = this.FFT_SIZE;
            this._webAudioAnalyser.getFloatFrequencyData(this._floatFreqs);
        }
        return this._floatFreqs;
    }
    /**
     * Renders the debug canvas
     */ drawDebugCanvas() {
        if (this._audioEngine.canUseWebAudio) {
            if (!this._debugCanvas) {
                this._debugCanvas = document.createElement("canvas");
                this._debugCanvas.width = this.DEBUGCANVASSIZE.width;
                this._debugCanvas.height = this.DEBUGCANVASSIZE.height;
                this._debugCanvas.style.position = "absolute";
                this._debugCanvas.style.top = this.DEBUGCANVASPOS.y + "px";
                this._debugCanvas.style.left = this.DEBUGCANVASPOS.x + "px";
                this._debugCanvasContext = this._debugCanvas.getContext("2d");
                document.body.appendChild(this._debugCanvas);
                this._registerFunc = ()=>{
                    this.drawDebugCanvas();
                };
                this._scene.registerBeforeRender(this._registerFunc);
            }
            if (this._registerFunc && this._debugCanvasContext) {
                const workingArray = this.getByteFrequencyData();
                this._debugCanvasContext.fillStyle = "rgb(0, 0, 0)";
                this._debugCanvasContext.fillRect(0, 0, this.DEBUGCANVASSIZE.width, this.DEBUGCANVASSIZE.height);
                // Draw the frequency domain chart.
                for(let i = 0; i < this.getFrequencyBinCount(); i++){
                    const value = workingArray[i];
                    const percent = value / this.BARGRAPHAMPLITUDE;
                    const height = this.DEBUGCANVASSIZE.height * percent;
                    const offset = this.DEBUGCANVASSIZE.height - height - 1;
                    const barWidth = this.DEBUGCANVASSIZE.width / this.getFrequencyBinCount();
                    const hue = i / this.getFrequencyBinCount() * 360;
                    this._debugCanvasContext.fillStyle = "hsl(" + hue + ", 100%, 50%)";
                    this._debugCanvasContext.fillRect(i * barWidth, offset, barWidth, height);
                }
            }
        }
    }
    /**
     * Stops rendering the debug canvas and removes it
     */ stopDebugCanvas() {
        if (this._debugCanvas) {
            if (this._registerFunc) {
                this._scene.unregisterBeforeRender(this._registerFunc);
                this._registerFunc = null;
            }
            document.body.removeChild(this._debugCanvas);
            this._debugCanvas = null;
            this._debugCanvasContext = null;
        }
    }
    /**
     * Connects two audio nodes
     * @param inputAudioNode defines first node to connect
     * @param outputAudioNode defines second node to connect
     */ connectAudioNodes(inputAudioNode, outputAudioNode) {
        if (this._audioEngine.canUseWebAudio) {
            inputAudioNode.connect(this._webAudioAnalyser);
            this._webAudioAnalyser.connect(outputAudioNode);
        }
    }
    /**
     * Releases all associated resources
     */ dispose() {
        if (this._audioEngine.canUseWebAudio) this._webAudioAnalyser.disconnect();
    }
}

});

parcelRegister("iIwbj", function(module, exports) {

$parcel$export(module.exports, "AudioEngine", () => $da054ca30022f9b7$export$2e9600652eafa17);

var $diGQf = parcelRequire("diGQf");

var $kVtWi = parcelRequire("kVtWi");

var $5YkyR = parcelRequire("5YkyR");

var $jFz47 = parcelRequire("jFz47");
// Sets the default audio engine to Babylon.js
(0, $5YkyR.Engine).AudioEngineFactory = (hostElement, audioContext, audioDestination)=>{
    return new $da054ca30022f9b7$export$2e9600652eafa17(hostElement, audioContext, audioDestination);
};
class $da054ca30022f9b7$export$2e9600652eafa17 {
    /**
     * Gets the current AudioContext if available.
     */ get audioContext() {
        if (!this._audioContextInitialized) this._initializeAudioContext();
        return this._audioContext;
    }
    /**
     * Instantiates a new audio engine.
     *
     * There should be only one per page as some browsers restrict the number
     * of audio contexts you can create.
     * @param hostElement defines the host element where to display the mute icon if necessary
     * @param audioContext defines the audio context to be used by the audio engine
     * @param audioDestination defines the audio destination node to be used by audio engine
     */ constructor(hostElement = null, audioContext = null, audioDestination = null){
        this._audioContext = null;
        this._audioContextInitialized = false;
        this._muteButton = null;
        this._audioDestination = null;
        /**
         * Gets whether the current host supports Web Audio and thus could create AudioContexts.
         */ this.canUseWebAudio = false;
        /**
         * Defines if Babylon should emit a warning if WebAudio is not supported.
         * @ignoreNaming
         */ // eslint-disable-next-line @typescript-eslint/naming-convention
        this.WarnedWebAudioUnsupported = false;
        /**
         * Gets whether or not mp3 are supported by your browser.
         */ this.isMP3supported = false;
        /**
         * Gets whether or not ogg are supported by your browser.
         */ this.isOGGsupported = false;
        /**
         * Gets whether audio has been unlocked on the device.
         * Some Browsers have strong restrictions about Audio and won't autoplay unless
         * a user interaction has happened.
         */ this.unlocked = false;
        /**
         * Defines if the audio engine relies on a custom unlocked button.
         * In this case, the embedded button will not be displayed.
         */ this.useCustomUnlockedButton = false;
        /**
         * Event raised when audio has been unlocked on the browser.
         */ this.onAudioUnlockedObservable = new (0, $diGQf.Observable)();
        /**
         * Event raised when audio has been locked on the browser.
         */ this.onAudioLockedObservable = new (0, $diGQf.Observable)();
        this._tryToRun = false;
        this._onResize = ()=>{
            this._moveButtonToTopLeft();
        };
        if (!(0, $jFz47.IsWindowObjectExist)()) return;
        if (typeof window.AudioContext !== "undefined") this.canUseWebAudio = true;
        const audioElem = document.createElement("audio");
        this._hostElement = hostElement;
        this._audioContext = audioContext;
        this._audioDestination = audioDestination;
        try {
            if (audioElem && !!audioElem.canPlayType && (audioElem.canPlayType('audio/mpeg; codecs="mp3"').replace(/^no$/, "") || audioElem.canPlayType("audio/mp3").replace(/^no$/, ""))) this.isMP3supported = true;
        } catch (e) {
        // protect error during capability check.
        }
        try {
            if (audioElem && !!audioElem.canPlayType && audioElem.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, "")) this.isOGGsupported = true;
        } catch (e) {
        // protect error during capability check.
        }
    }
    /**
     * Flags the audio engine in Locked state.
     * This happens due to new browser policies preventing audio to autoplay.
     */ lock() {
        this._triggerSuspendedState();
    }
    /**
     * Unlocks the audio engine once a user action has been done on the dom.
     * This is helpful to resume play once browser policies have been satisfied.
     */ unlock() {
        if (this._audioContext?.state === "running") {
            this._hideMuteButton();
            if (!this.unlocked) {
                // Notify users that the audio stack is unlocked/unmuted
                this.unlocked = true;
                this.onAudioUnlockedObservable.notifyObservers(this);
            }
            return;
        }
        // On iOS, if the audio context resume request was sent from an event other than a `click` event, then
        // the resume promise will never resolve and the only way to get the audio context unstuck is to
        // suspend it and make another resume request.
        if (this._tryToRun) this._audioContext?.suspend().then(()=>{
            this._tryToRun = false;
            this._triggerRunningState();
        });
        else this._triggerRunningState();
    }
    _resumeAudioContext() {
        if (this._audioContext?.resume) return this._audioContext.resume();
        return Promise.resolve();
    }
    _initializeAudioContext() {
        try {
            if (this.canUseWebAudio) {
                if (!this._audioContext) this._audioContext = new AudioContext();
                // create a global volume gain node
                this.masterGain = this._audioContext.createGain();
                this.masterGain.gain.value = 1;
                if (!this._audioDestination) this._audioDestination = this._audioContext.destination;
                this.masterGain.connect(this._audioDestination);
                this._audioContextInitialized = true;
                if (this._audioContext.state === "running") // Do not wait for the promise to unlock.
                this._triggerRunningState();
            }
        } catch (e) {
            this.canUseWebAudio = false;
            (0, $kVtWi.Logger).Error("Web Audio: " + e.message);
        }
    }
    _triggerRunningState() {
        if (this._tryToRun) return;
        this._tryToRun = true;
        this._resumeAudioContext().then(()=>{
            this._tryToRun = false;
            if (this._muteButton) this._hideMuteButton();
            // Notify users that the audio stack is unlocked/unmuted
            this.unlocked = true;
            this.onAudioUnlockedObservable.notifyObservers(this);
        }).catch(()=>{
            this._tryToRun = false;
            this.unlocked = false;
        });
    }
    _triggerSuspendedState() {
        this.unlocked = false;
        this.onAudioLockedObservable.notifyObservers(this);
        this._displayMuteButton();
    }
    _displayMuteButton() {
        if (this.useCustomUnlockedButton || this._muteButton) return;
        this._muteButton = document.createElement("BUTTON");
        this._muteButton.className = "babylonUnmuteIcon";
        this._muteButton.id = "babylonUnmuteIconBtn";
        this._muteButton.title = "Unmute";
        const imageUrl = !window.SVGSVGElement ? "https://cdn.babylonjs.com/Assets/audio.png" : "data:image/svg+xml;charset=UTF-8,%3Csvg%20version%3D%221.1%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2239%22%20height%3D%2232%22%20viewBox%3D%220%200%2039%2032%22%3E%3Cpath%20fill%3D%22white%22%20d%3D%22M9.625%2018.938l-0.031%200.016h-4.953q-0.016%200-0.031-0.016v-12.453q0-0.016%200.031-0.016h4.953q0.031%200%200.031%200.016v12.453zM12.125%207.688l8.719-8.703v27.453l-8.719-8.719-0.016-0.047v-9.938zM23.359%207.875l1.406-1.406%204.219%204.203%204.203-4.203%201.422%201.406-4.219%204.219%204.219%204.203-1.484%201.359-4.141-4.156-4.219%204.219-1.406-1.422%204.219-4.203z%22%3E%3C%2Fpath%3E%3C%2Fsvg%3E";
        const css = ".babylonUnmuteIcon { position: absolute; left: 20px; top: 20px; height: 40px; width: 60px; background-color: rgba(51,51,51,0.7); background-image: url(" + imageUrl + ");  background-size: 80%; background-repeat:no-repeat; background-position: center; background-position-y: 4px; border: none; outline: none; transition: transform 0.125s ease-out; cursor: pointer; z-index: 9999; } .babylonUnmuteIcon:hover { transform: scale(1.05) } .babylonUnmuteIcon:active { background-color: rgba(51,51,51,1) }";
        const style = document.createElement("style");
        style.appendChild(document.createTextNode(css));
        document.getElementsByTagName("head")[0].appendChild(style);
        document.body.appendChild(this._muteButton);
        this._moveButtonToTopLeft();
        this._muteButton.addEventListener("touchend", ()=>{
            this._triggerRunningState();
        }, true);
        this._muteButton.addEventListener("click", ()=>{
            this.unlock();
        }, true);
        window.addEventListener("resize", this._onResize);
    }
    _moveButtonToTopLeft() {
        if (this._hostElement && this._muteButton) {
            this._muteButton.style.top = this._hostElement.offsetTop + 20 + "px";
            this._muteButton.style.left = this._hostElement.offsetLeft + 20 + "px";
        }
    }
    _hideMuteButton() {
        if (this._muteButton) {
            document.body.removeChild(this._muteButton);
            this._muteButton = null;
        }
    }
    /**
     * Destroy and release the resources associated with the audio context.
     */ dispose() {
        if (this.canUseWebAudio && this._audioContextInitialized) {
            if (this._connectedAnalyser && this._audioContext) {
                this._connectedAnalyser.stopDebugCanvas();
                this._connectedAnalyser.dispose();
                this.masterGain.disconnect();
                this.masterGain.connect(this._audioContext.destination);
                this._connectedAnalyser = null;
            }
            this.masterGain.gain.value = 1;
        }
        this.WarnedWebAudioUnsupported = false;
        this._hideMuteButton();
        window.removeEventListener("resize", this._onResize);
        this.onAudioUnlockedObservable.clear();
        this.onAudioLockedObservable.clear();
    }
    /**
     * Gets the global volume sets on the master gain.
     * @returns the global volume if set or -1 otherwise
     */ getGlobalVolume() {
        if (this.canUseWebAudio && this._audioContextInitialized) return this.masterGain.gain.value;
        else return -1;
    }
    /**
     * Sets the global volume of your experience (sets on the master gain).
     * @param newVolume Defines the new global volume of the application
     */ setGlobalVolume(newVolume) {
        if (this.canUseWebAudio && this._audioContextInitialized) this.masterGain.gain.value = newVolume;
    }
    /**
     * Connect the audio engine to an audio analyser allowing some amazing
     * synchronization between the sounds/music and your visualization (VuMeter for instance).
     * @see https://doc.babylonjs.com/features/featuresDeepDive/audio/playingSoundsMusic#using-the-analyser
     * @param analyser The analyser to connect to the engine
     */ connectToAnalyser(analyser) {
        if (this._connectedAnalyser) this._connectedAnalyser.stopDebugCanvas();
        if (this.canUseWebAudio && this._audioContextInitialized && this._audioContext) {
            this._connectedAnalyser = analyser;
            this.masterGain.disconnect();
            this._connectedAnalyser.connectAudioNodes(this.masterGain, this._audioContext.destination);
        }
    }
}

});

parcelRegister("inyiK", function(module, exports) {

$parcel$export(module.exports, "AudioSceneComponent", () => $d614fb81c5ef8408$export$45aa9da8559a72fa);

var $gEKAb = parcelRequire("gEKAb");

var $kIpCn = parcelRequire("kIpCn");

var $5YkyR = parcelRequire("5YkyR");

var $ha1VO = parcelRequire("ha1VO");

var $bv05l = parcelRequire("bv05l");

var $gmbCk = parcelRequire("gmbCk");

var $5Tqba = parcelRequire("5Tqba");
parcelRequire("iIwbj");

var $blHSI = parcelRequire("blHSI");

var $ejQPp = parcelRequire("ejQPp");
// Adds the parser to the scene parsers.
(0, $5Tqba.AbstractScene).AddParser((0, $bv05l.SceneComponentConstants).NAME_AUDIO, (parsedData, scene, container, rootUrl)=>{
    // TODO: add sound
    let loadedSounds = [];
    let loadedSound;
    container.sounds = container.sounds || [];
    if (parsedData.sounds !== undefined && parsedData.sounds !== null) for(let index = 0, cache = parsedData.sounds.length; index < cache; index++){
        const parsedSound = parsedData.sounds[index];
        if ((0, $5YkyR.Engine).audioEngine?.canUseWebAudio) {
            if (!parsedSound.url) parsedSound.url = parsedSound.name;
            if (!loadedSounds[parsedSound.url]) {
                loadedSound = (0, $gEKAb.Sound).Parse(parsedSound, scene, rootUrl);
                loadedSounds[parsedSound.url] = loadedSound;
                container.sounds.push(loadedSound);
            } else container.sounds.push((0, $gEKAb.Sound).Parse(parsedSound, scene, rootUrl, loadedSounds[parsedSound.url]));
        } else container.sounds.push(new (0, $gEKAb.Sound)(parsedSound.name, null, scene));
    }
    loadedSounds = [];
});
Object.defineProperty((0, $gmbCk.Scene).prototype, "mainSoundTrack", {
    get: function() {
        let compo = this._getComponent((0, $bv05l.SceneComponentConstants).NAME_AUDIO);
        if (!compo) {
            compo = new $d614fb81c5ef8408$export$45aa9da8559a72fa(this);
            this._addComponent(compo);
        }
        if (!this._mainSoundTrack) this._mainSoundTrack = new (0, $kIpCn.SoundTrack)(this, {
            mainTrack: true
        });
        return this._mainSoundTrack;
    },
    enumerable: true,
    configurable: true
});
(0, $gmbCk.Scene).prototype.getSoundByName = function(name) {
    let index;
    for(index = 0; index < this.mainSoundTrack.soundCollection.length; index++){
        if (this.mainSoundTrack.soundCollection[index].name === name) return this.mainSoundTrack.soundCollection[index];
    }
    if (this.soundTracks) {
        for(let sdIndex = 0; sdIndex < this.soundTracks.length; sdIndex++)for(index = 0; index < this.soundTracks[sdIndex].soundCollection.length; index++){
            if (this.soundTracks[sdIndex].soundCollection[index].name === name) return this.soundTracks[sdIndex].soundCollection[index];
        }
    }
    return null;
};
Object.defineProperty((0, $gmbCk.Scene).prototype, "audioEnabled", {
    get: function() {
        let compo = this._getComponent((0, $bv05l.SceneComponentConstants).NAME_AUDIO);
        if (!compo) {
            compo = new $d614fb81c5ef8408$export$45aa9da8559a72fa(this);
            this._addComponent(compo);
        }
        return compo.audioEnabled;
    },
    set: function(value) {
        let compo = this._getComponent((0, $bv05l.SceneComponentConstants).NAME_AUDIO);
        if (!compo) {
            compo = new $d614fb81c5ef8408$export$45aa9da8559a72fa(this);
            this._addComponent(compo);
        }
        if (value) compo.enableAudio();
        else compo.disableAudio();
    },
    enumerable: true,
    configurable: true
});
Object.defineProperty((0, $gmbCk.Scene).prototype, "headphone", {
    get: function() {
        let compo = this._getComponent((0, $bv05l.SceneComponentConstants).NAME_AUDIO);
        if (!compo) {
            compo = new $d614fb81c5ef8408$export$45aa9da8559a72fa(this);
            this._addComponent(compo);
        }
        return compo.headphone;
    },
    set: function(value) {
        let compo = this._getComponent((0, $bv05l.SceneComponentConstants).NAME_AUDIO);
        if (!compo) {
            compo = new $d614fb81c5ef8408$export$45aa9da8559a72fa(this);
            this._addComponent(compo);
        }
        if (value) compo.switchAudioModeForHeadphones();
        else compo.switchAudioModeForNormalSpeakers();
    },
    enumerable: true,
    configurable: true
});
Object.defineProperty((0, $gmbCk.Scene).prototype, "audioListenerPositionProvider", {
    get: function() {
        let compo = this._getComponent((0, $bv05l.SceneComponentConstants).NAME_AUDIO);
        if (!compo) {
            compo = new $d614fb81c5ef8408$export$45aa9da8559a72fa(this);
            this._addComponent(compo);
        }
        return compo.audioListenerPositionProvider;
    },
    set: function(value) {
        let compo = this._getComponent((0, $bv05l.SceneComponentConstants).NAME_AUDIO);
        if (!compo) {
            compo = new $d614fb81c5ef8408$export$45aa9da8559a72fa(this);
            this._addComponent(compo);
        }
        if (value && typeof value !== "function") throw new Error("The value passed to [Scene.audioListenerPositionProvider] must be a function that returns a Vector3");
        else compo.audioListenerPositionProvider = value;
    },
    enumerable: true,
    configurable: true
});
Object.defineProperty((0, $gmbCk.Scene).prototype, "audioListenerRotationProvider", {
    get: function() {
        let compo = this._getComponent((0, $bv05l.SceneComponentConstants).NAME_AUDIO);
        if (!compo) {
            compo = new $d614fb81c5ef8408$export$45aa9da8559a72fa(this);
            this._addComponent(compo);
        }
        return compo.audioListenerRotationProvider;
    },
    set: function(value) {
        let compo = this._getComponent((0, $bv05l.SceneComponentConstants).NAME_AUDIO);
        if (!compo) {
            compo = new $d614fb81c5ef8408$export$45aa9da8559a72fa(this);
            this._addComponent(compo);
        }
        if (value && typeof value !== "function") throw new Error("The value passed to [Scene.audioListenerRotationProvider] must be a function that returns a Vector3");
        else compo.audioListenerRotationProvider = value;
    },
    enumerable: true,
    configurable: true
});
Object.defineProperty((0, $gmbCk.Scene).prototype, "audioPositioningRefreshRate", {
    get: function() {
        let compo = this._getComponent((0, $bv05l.SceneComponentConstants).NAME_AUDIO);
        if (!compo) {
            compo = new $d614fb81c5ef8408$export$45aa9da8559a72fa(this);
            this._addComponent(compo);
        }
        return compo.audioPositioningRefreshRate;
    },
    set: function(value) {
        let compo = this._getComponent((0, $bv05l.SceneComponentConstants).NAME_AUDIO);
        if (!compo) {
            compo = new $d614fb81c5ef8408$export$45aa9da8559a72fa(this);
            this._addComponent(compo);
        }
        compo.audioPositioningRefreshRate = value;
    },
    enumerable: true,
    configurable: true
});
class $d614fb81c5ef8408$export$45aa9da8559a72fa {
    /**
     * Gets whether audio is enabled or not.
     * Please use related enable/disable method to switch state.
     */ get audioEnabled() {
        return this._audioEnabled;
    }
    /**
     * Gets whether audio is outputting to headphone or not.
     * Please use the according Switch methods to change output.
     */ get headphone() {
        return this._headphone;
    }
    /**
     * Creates a new instance of the component for the given scene
     * @param scene Defines the scene to register the component in
     */ constructor(scene){
        /**
         * The component name helpful to identify the component in the list of scene components.
         */ this.name = (0, $bv05l.SceneComponentConstants).NAME_AUDIO;
        this._audioEnabled = true;
        this._headphone = false;
        /**
         * Gets or sets a refresh rate when using 3D audio positioning
         */ this.audioPositioningRefreshRate = 500;
        /**
         * Gets or Sets a custom listener position for all sounds in the scene
         * By default, this is the position of the first active camera
         */ this.audioListenerPositionProvider = null;
        /**
         * Gets or Sets a custom listener rotation for all sounds in the scene
         * By default, this is the rotation of the first active camera
         */ this.audioListenerRotationProvider = null;
        this._cachedCameraDirection = new (0, $ha1VO.Vector3)();
        this._cachedCameraPosition = new (0, $ha1VO.Vector3)();
        this._lastCheck = 0;
        this._invertMatrixTemp = new (0, $ha1VO.Matrix)();
        this._cameraDirectionTemp = new (0, $ha1VO.Vector3)();
        scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        if (!scene) return;
        this.scene = scene;
        scene.soundTracks = [];
        scene.sounds = [];
    }
    /**
     * Registers the component in a given scene
     */ register() {
        this.scene._afterRenderStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_AFTERRENDER_AUDIO, this, this._afterRender);
    }
    /**
     * Rebuilds the elements related to this component in case of
     * context lost for instance.
     */ rebuild() {
    // Nothing to do here. (Not rendering related)
    }
    /**
     * Serializes the component data to the specified json object
     * @param serializationObject The object to serialize to
     */ serialize(serializationObject) {
        serializationObject.sounds = [];
        if (this.scene.soundTracks) for(let index = 0; index < this.scene.soundTracks.length; index++){
            const soundtrack = this.scene.soundTracks[index];
            for(let soundId = 0; soundId < soundtrack.soundCollection.length; soundId++)serializationObject.sounds.push(soundtrack.soundCollection[soundId].serialize());
        }
    }
    /**
     * Adds all the elements from the container to the scene
     * @param container the container holding the elements
     */ addFromContainer(container) {
        if (!container.sounds) return;
        container.sounds.forEach((sound)=>{
            sound.play();
            sound.autoplay = true;
            this.scene.mainSoundTrack.addSound(sound);
        });
    }
    /**
     * Removes all the elements in the container from the scene
     * @param container contains the elements to remove
     * @param dispose if the removed element should be disposed (default: false)
     */ removeFromContainer(container, dispose = false) {
        if (!container.sounds) return;
        container.sounds.forEach((sound)=>{
            sound.stop();
            sound.autoplay = false;
            this.scene.mainSoundTrack.removeSound(sound);
            if (dispose) sound.dispose();
        });
    }
    /**
     * Disposes the component and the associated resources.
     */ dispose() {
        const scene = this.scene;
        if (scene._mainSoundTrack) scene.mainSoundTrack.dispose();
        if (scene.soundTracks) for(let scIndex = 0; scIndex < scene.soundTracks.length; scIndex++)scene.soundTracks[scIndex].dispose();
    }
    /**
     * Disables audio in the associated scene.
     */ disableAudio() {
        const scene = this.scene;
        this._audioEnabled = false;
        if ((0, $5YkyR.Engine).audioEngine && (0, $5YkyR.Engine).audioEngine.audioContext) (0, $5YkyR.Engine).audioEngine.audioContext.suspend();
        let i;
        for(i = 0; i < scene.mainSoundTrack.soundCollection.length; i++)scene.mainSoundTrack.soundCollection[i].pause();
        if (scene.soundTracks) {
            for(i = 0; i < scene.soundTracks.length; i++)for(let j = 0; j < scene.soundTracks[i].soundCollection.length; j++)scene.soundTracks[i].soundCollection[j].pause();
        }
    }
    /**
     * Enables audio in the associated scene.
     */ enableAudio() {
        const scene = this.scene;
        this._audioEnabled = true;
        if ((0, $5YkyR.Engine).audioEngine && (0, $5YkyR.Engine).audioEngine.audioContext) (0, $5YkyR.Engine).audioEngine.audioContext.resume();
        let i;
        for(i = 0; i < scene.mainSoundTrack.soundCollection.length; i++)if (scene.mainSoundTrack.soundCollection[i].isPaused) scene.mainSoundTrack.soundCollection[i].play();
        if (scene.soundTracks) for(i = 0; i < scene.soundTracks.length; i++){
            for(let j = 0; j < scene.soundTracks[i].soundCollection.length; j++)if (scene.soundTracks[i].soundCollection[j].isPaused) scene.soundTracks[i].soundCollection[j].play();
        }
    }
    /**
     * Switch audio to headphone output.
     */ switchAudioModeForHeadphones() {
        const scene = this.scene;
        this._headphone = true;
        scene.mainSoundTrack.switchPanningModelToHRTF();
        if (scene.soundTracks) for(let i = 0; i < scene.soundTracks.length; i++)scene.soundTracks[i].switchPanningModelToHRTF();
    }
    /**
     * Switch audio to normal speakers.
     */ switchAudioModeForNormalSpeakers() {
        const scene = this.scene;
        this._headphone = false;
        scene.mainSoundTrack.switchPanningModelToEqualPower();
        if (scene.soundTracks) for(let i = 0; i < scene.soundTracks.length; i++)scene.soundTracks[i].switchPanningModelToEqualPower();
    }
    _afterRender() {
        const now = (0, $blHSI.PrecisionDate).Now;
        if (this._lastCheck && now - this._lastCheck < this.audioPositioningRefreshRate) return;
        this._lastCheck = now;
        const scene = this.scene;
        if (!this._audioEnabled || !scene._mainSoundTrack || !scene.soundTracks || scene._mainSoundTrack.soundCollection.length === 0 && scene.soundTracks.length === 1) return;
        const audioEngine = (0, $5YkyR.Engine).audioEngine;
        if (!audioEngine) return;
        if (audioEngine.audioContext) {
            let listeningCamera = scene.activeCamera;
            if (scene.activeCameras && scene.activeCameras.length > 0) listeningCamera = scene.activeCameras[0];
            // A custom listener position provider was set
            // Use the users provided position instead of camera's
            if (this.audioListenerPositionProvider) {
                const position = this.audioListenerPositionProvider();
                // Set the listener position
                audioEngine.audioContext.listener.setPosition(position.x || 0, position.y || 0, position.z || 0);
            // Check if there is a listening camera
            } else if (listeningCamera) // Set the listener position to the listening camera global position
            {
                if (!this._cachedCameraPosition.equals(listeningCamera.globalPosition)) {
                    this._cachedCameraPosition.copyFrom(listeningCamera.globalPosition);
                    audioEngine.audioContext.listener.setPosition(listeningCamera.globalPosition.x, listeningCamera.globalPosition.y, listeningCamera.globalPosition.z);
                }
            } else // Set the listener position
            audioEngine.audioContext.listener.setPosition(0, 0, 0);
            // A custom listener rotation provider was set
            // Use the users provided rotation instead of camera's
            if (this.audioListenerRotationProvider) {
                const rotation = this.audioListenerRotationProvider();
                audioEngine.audioContext.listener.setOrientation(rotation.x || 0, rotation.y || 0, rotation.z || 0, 0, 1, 0);
            // Check if there is a listening camera
            } else if (listeningCamera) {
                // for VR cameras
                if (listeningCamera.rigCameras && listeningCamera.rigCameras.length > 0) listeningCamera = listeningCamera.rigCameras[0];
                listeningCamera.getViewMatrix().invertToRef(this._invertMatrixTemp);
                (0, $ha1VO.Vector3).TransformNormalToRef($d614fb81c5ef8408$export$45aa9da8559a72fa._CameraDirection, this._invertMatrixTemp, this._cameraDirectionTemp);
                this._cameraDirectionTemp.normalize();
                // To avoid some errors on GearVR
                if (!isNaN(this._cameraDirectionTemp.x) && !isNaN(this._cameraDirectionTemp.y) && !isNaN(this._cameraDirectionTemp.z)) {
                    if (!this._cachedCameraDirection.equals(this._cameraDirectionTemp)) {
                        this._cachedCameraDirection.copyFrom(this._cameraDirectionTemp);
                        audioEngine.audioContext.listener.setOrientation(this._cameraDirectionTemp.x, this._cameraDirectionTemp.y, this._cameraDirectionTemp.z, 0, 1, 0);
                    }
                }
            } else // Set the listener position
            audioEngine.audioContext.listener.setOrientation(0, 0, 0, 0, 1, 0);
            let i;
            for(i = 0; i < scene.mainSoundTrack.soundCollection.length; i++){
                const sound = scene.mainSoundTrack.soundCollection[i];
                if (sound.useCustomAttenuation) sound.updateDistanceFromListener();
            }
            if (scene.soundTracks) {
                for(i = 0; i < scene.soundTracks.length; i++)for(let j = 0; j < scene.soundTracks[i].soundCollection.length; j++){
                    const sound = scene.soundTracks[i].soundCollection[j];
                    if (sound.useCustomAttenuation) sound.updateDistanceFromListener();
                }
            }
        }
    }
}
$d614fb81c5ef8408$export$45aa9da8559a72fa._CameraDirection = new (0, $ha1VO.Vector3)(0, 0, -1);
(0, $gEKAb.Sound)._SceneComponentInitialization = (scene)=>{
    let compo = scene._getComponent((0, $bv05l.SceneComponentConstants).NAME_AUDIO);
    if (!compo) {
        compo = new $d614fb81c5ef8408$export$45aa9da8559a72fa(scene);
        scene._addComponent(compo);
    }
};

});
parcelRegister("gEKAb", function(module, exports) {

$parcel$export(module.exports, "Sound", () => $c204841fc2d888eb$export$85990f0f98a390bb);

var $bOhSV = parcelRequire("bOhSV");

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $5YkyR = parcelRequire("5YkyR");

var $kVtWi = parcelRequire("kVtWi");

var $dUFYy = parcelRequire("dUFYy");

var $ejQPp = parcelRequire("ejQPp");
class $c204841fc2d888eb$export$85990f0f98a390bb {
    /**
     * Does the sound loop after it finishes playing once.
     */ get loop() {
        return this._loop;
    }
    set loop(value) {
        if (value === this._loop) return;
        this._loop = value;
        this.updateOptions({
            loop: value
        });
    }
    /**
     * Gets the current time for the sound.
     */ get currentTime() {
        if (this._htmlAudioElement) return this._htmlAudioElement.currentTime;
        if ((0, $5YkyR.Engine).audioEngine?.audioContext && (this.isPlaying || this.isPaused)) {
            // The `_currentTime` member is only updated when the sound is paused. Add the time since the last start
            // to get the actual current time.
            const timeSinceLastStart = this.isPaused ? 0 : (0, $5YkyR.Engine).audioEngine.audioContext.currentTime - this._startTime;
            return this._currentTime + timeSinceLastStart;
        }
        return 0;
    }
    /**
     * Does this sound enables spatial sound.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/audio/playingSoundsMusic#creating-a-spatial-3d-sound
     */ get spatialSound() {
        return this._spatialSound;
    }
    /**
     * Does this sound enables spatial sound.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/audio/playingSoundsMusic#creating-a-spatial-3d-sound
     */ set spatialSound(newValue) {
        if (newValue == this._spatialSound) return;
        const wasPlaying = this.isPlaying;
        this.pause();
        if (newValue) {
            this._spatialSound = newValue;
            this._updateSpatialParameters();
        } else this._disableSpatialSound();
        if (wasPlaying) this.play();
    }
    /**
     * Create a sound and attach it to a scene
     * @param name Name of your sound
     * @param urlOrArrayBuffer Url to the sound to load async or ArrayBuffer, it also works with MediaStreams and AudioBuffers
     * @param scene defines the scene the sound belongs to
     * @param readyToPlayCallback Provide a callback function if you'd like to load your code once the sound is ready to be played
     * @param options Objects to provide with the current available options: autoplay, loop, volume, spatialSound, maxDistance, rolloffFactor, refDistance, distanceModel, panningModel, streaming
     */ constructor(name, urlOrArrayBuffer, scene, readyToPlayCallback = null, options){
        /**
         * Does the sound autoplay once loaded.
         */ this.autoplay = false;
        this._loop = false;
        /**
         * Does the sound use a custom attenuation curve to simulate the falloff
         * happening when the source gets further away from the camera.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/audio/playingSoundsMusic#creating-your-own-custom-attenuation-function
         */ this.useCustomAttenuation = false;
        /**
         * Is this sound currently played.
         */ this.isPlaying = false;
        /**
         * Is this sound currently paused.
         */ this.isPaused = false;
        /**
         * Define the reference distance the sound should be heard perfectly.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/audio/playingSoundsMusic#creating-a-spatial-3d-sound
         */ this.refDistance = 1;
        /**
         * Define the roll off factor of spatial sounds.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/audio/playingSoundsMusic#creating-a-spatial-3d-sound
         */ this.rolloffFactor = 1;
        /**
         * Define the max distance the sound should be heard (intensity just became 0 at this point).
         * @see https://doc.babylonjs.com/features/featuresDeepDive/audio/playingSoundsMusic#creating-a-spatial-3d-sound
         */ this.maxDistance = 100;
        /**
         * Define the distance attenuation model the sound will follow.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/audio/playingSoundsMusic#creating-a-spatial-3d-sound
         */ this.distanceModel = "linear";
        /**
         * Gets or sets an object used to store user defined information for the sound.
         */ this.metadata = null;
        /**
         * Observable event when the current playing sound finishes.
         */ this.onEndedObservable = new (0, $diGQf.Observable)();
        this._spatialSound = false;
        this._panningModel = "equalpower";
        this._playbackRate = 1;
        this._streaming = false;
        this._startTime = 0;
        this._currentTime = 0;
        this._position = (0, $ha1VO.Vector3).Zero();
        this._localDirection = new (0, $ha1VO.Vector3)(1, 0, 0);
        this._volume = 1;
        this._isReadyToPlay = false;
        this._isDirectional = false;
        // Used if you'd like to create a directional sound.
        // If not set, the sound will be omnidirectional
        this._coneInnerAngle = 360;
        this._coneOuterAngle = 360;
        this._coneOuterGain = 0;
        this._isOutputConnected = false;
        this._urlType = "Unknown";
        this.name = name;
        scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        if (!scene) return;
        this._scene = scene;
        $c204841fc2d888eb$export$85990f0f98a390bb._SceneComponentInitialization(scene);
        this._readyToPlayCallback = readyToPlayCallback;
        // Default custom attenuation function is a linear attenuation
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this._customAttenuationFunction = (currentVolume, currentDistance, maxDistance, refDistance, rolloffFactor)=>{
            if (currentDistance < maxDistance) return currentVolume * (1 - currentDistance / maxDistance);
            else return 0;
        };
        if (options) {
            this.autoplay = options.autoplay || false;
            this._loop = options.loop || false;
            // if volume === 0, we need another way to check this option
            if (options.volume !== undefined) this._volume = options.volume;
            this._spatialSound = options.spatialSound ?? false;
            this.maxDistance = options.maxDistance ?? 100;
            this.useCustomAttenuation = options.useCustomAttenuation ?? false;
            this.rolloffFactor = options.rolloffFactor || 1;
            this.refDistance = options.refDistance || 1;
            this.distanceModel = options.distanceModel || "linear";
            this._playbackRate = options.playbackRate || 1;
            this._streaming = options.streaming ?? false;
            this._length = options.length;
            this._offset = options.offset;
        }
        if ((0, $5YkyR.Engine).audioEngine?.canUseWebAudio && (0, $5YkyR.Engine).audioEngine.audioContext) {
            this._soundGain = (0, $5YkyR.Engine).audioEngine.audioContext.createGain();
            this._soundGain.gain.value = this._volume;
            this._inputAudioNode = this._soundGain;
            this._outputAudioNode = this._soundGain;
            if (this._spatialSound) this._createSpatialParameters();
            this._scene.mainSoundTrack.addSound(this);
            let validParameter = true;
            // if no parameter is passed, you need to call setAudioBuffer yourself to prepare the sound
            if (urlOrArrayBuffer) try {
                if (typeof urlOrArrayBuffer === "string") {
                    this._urlType = "String";
                    this._url = urlOrArrayBuffer;
                } else if (urlOrArrayBuffer instanceof ArrayBuffer) this._urlType = "ArrayBuffer";
                else if (urlOrArrayBuffer instanceof HTMLMediaElement) this._urlType = "MediaElement";
                else if (urlOrArrayBuffer instanceof MediaStream) this._urlType = "MediaStream";
                else if (urlOrArrayBuffer instanceof AudioBuffer) this._urlType = "AudioBuffer";
                else if (Array.isArray(urlOrArrayBuffer)) this._urlType = "Array";
                let urls = [];
                let codecSupportedFound = false;
                switch(this._urlType){
                    case "MediaElement":
                        this._streaming = true;
                        this._isReadyToPlay = true;
                        this._streamingSource = (0, $5YkyR.Engine).audioEngine.audioContext.createMediaElementSource(urlOrArrayBuffer);
                        if (this.autoplay) this.play(0, this._offset, this._length);
                        if (this._readyToPlayCallback) this._readyToPlayCallback();
                        break;
                    case "MediaStream":
                        this._streaming = true;
                        this._isReadyToPlay = true;
                        this._streamingSource = (0, $5YkyR.Engine).audioEngine.audioContext.createMediaStreamSource(urlOrArrayBuffer);
                        if (this.autoplay) this.play(0, this._offset, this._length);
                        if (this._readyToPlayCallback) this._readyToPlayCallback();
                        break;
                    case "ArrayBuffer":
                        if (urlOrArrayBuffer.byteLength > 0) {
                            codecSupportedFound = true;
                            this._soundLoaded(urlOrArrayBuffer);
                        }
                        break;
                    case "AudioBuffer":
                        this._audioBufferLoaded(urlOrArrayBuffer);
                        break;
                    case "String":
                        urls.push(urlOrArrayBuffer);
                    // eslint-disable-next-line no-fallthrough
                    case "Array":
                        if (urls.length === 0) urls = urlOrArrayBuffer;
                        // If we found a supported format, we load it immediately and stop the loop
                        for(let i = 0; i < urls.length; i++){
                            const url = urls[i];
                            codecSupportedFound = options && options.skipCodecCheck || url.indexOf(".mp3", url.length - 4) !== -1 && (0, $5YkyR.Engine).audioEngine.isMP3supported || url.indexOf(".ogg", url.length - 4) !== -1 && (0, $5YkyR.Engine).audioEngine.isOGGsupported || url.indexOf(".wav", url.length - 4) !== -1 || url.indexOf(".m4a", url.length - 4) !== -1 || url.indexOf(".mp4", url.length - 4) !== -1 || url.indexOf("blob:") !== -1;
                            if (codecSupportedFound) {
                                // Loading sound
                                if (!this._streaming) this._scene._loadFile(url, (data)=>{
                                    this._soundLoaded(data);
                                }, undefined, true, true, (exception)=>{
                                    if (exception) (0, $kVtWi.Logger).Error("XHR " + exception.status + " error on: " + url + ".");
                                    (0, $kVtWi.Logger).Error("Sound creation aborted.");
                                    this._scene.mainSoundTrack.removeSound(this);
                                });
                                else {
                                    this._htmlAudioElement = new Audio(url);
                                    this._htmlAudioElement.controls = false;
                                    this._htmlAudioElement.loop = this.loop;
                                    (0, $bOhSV.Tools).SetCorsBehavior(url, this._htmlAudioElement);
                                    this._htmlAudioElement.preload = "auto";
                                    this._htmlAudioElement.addEventListener("canplaythrough", ()=>{
                                        this._isReadyToPlay = true;
                                        if (this.autoplay) this.play(0, this._offset, this._length);
                                        if (this._readyToPlayCallback) this._readyToPlayCallback();
                                    });
                                    document.body.appendChild(this._htmlAudioElement);
                                    this._htmlAudioElement.load();
                                }
                                break;
                            }
                        }
                        break;
                    default:
                        validParameter = false;
                        break;
                }
                if (!validParameter) (0, $kVtWi.Logger).Error("Parameter must be a URL to the sound, an Array of URLs (.mp3 & .ogg) or an ArrayBuffer of the sound.");
                else if (!codecSupportedFound) {
                    this._isReadyToPlay = true;
                    // Simulating a ready to play event to avoid breaking code path
                    if (this._readyToPlayCallback) setTimeout(()=>{
                        if (this._readyToPlayCallback) this._readyToPlayCallback();
                    }, 1000);
                }
            } catch (ex) {
                (0, $kVtWi.Logger).Error("Unexpected error. Sound creation aborted.");
                this._scene.mainSoundTrack.removeSound(this);
            }
        } else {
            // Adding an empty sound to avoid breaking audio calls for non Web Audio browsers
            this._scene.mainSoundTrack.addSound(this);
            if ((0, $5YkyR.Engine).audioEngine && !(0, $5YkyR.Engine).audioEngine.WarnedWebAudioUnsupported) {
                (0, $kVtWi.Logger).Error("Web Audio is not supported by your browser.");
                (0, $5YkyR.Engine).audioEngine.WarnedWebAudioUnsupported = true;
            }
            // Simulating a ready to play event to avoid breaking code for non web audio browsers
            if (this._readyToPlayCallback) setTimeout(()=>{
                if (this._readyToPlayCallback) this._readyToPlayCallback();
            }, 1000);
        }
    }
    /**
     * Release the sound and its associated resources
     */ dispose() {
        if ((0, $5YkyR.Engine).audioEngine?.canUseWebAudio) {
            if (this.isPlaying) this.stop();
            this._isReadyToPlay = false;
            if (this.soundTrackId === -1) this._scene.mainSoundTrack.removeSound(this);
            else if (this._scene.soundTracks) this._scene.soundTracks[this.soundTrackId].removeSound(this);
            if (this._soundGain) {
                this._soundGain.disconnect();
                this._soundGain = null;
            }
            if (this._soundPanner) {
                this._soundPanner.disconnect();
                this._soundPanner = null;
            }
            if (this._soundSource) {
                this._soundSource.disconnect();
                this._soundSource = null;
            }
            this._audioBuffer = null;
            if (this._htmlAudioElement) {
                this._htmlAudioElement.pause();
                this._htmlAudioElement.src = "";
                document.body.removeChild(this._htmlAudioElement);
            }
            if (this._streamingSource) this._streamingSource.disconnect();
            if (this._connectedTransformNode && this._registerFunc) {
                this._connectedTransformNode.unregisterAfterWorldMatrixUpdate(this._registerFunc);
                this._connectedTransformNode = null;
            }
            this._clearTimeoutsAndObservers();
        }
    }
    /**
     * Gets if the sounds is ready to be played or not.
     * @returns true if ready, otherwise false
     */ isReady() {
        return this._isReadyToPlay;
    }
    /**
     * Get the current class name.
     * @returns current class name
     */ getClassName() {
        return "Sound";
    }
    _audioBufferLoaded(buffer) {
        if (!(0, $5YkyR.Engine).audioEngine?.audioContext) return;
        this._audioBuffer = buffer;
        this._isReadyToPlay = true;
        if (this.autoplay) this.play(0, this._offset, this._length);
        if (this._readyToPlayCallback) this._readyToPlayCallback();
    }
    _soundLoaded(audioData) {
        if (!(0, $5YkyR.Engine).audioEngine?.audioContext) return;
        (0, $5YkyR.Engine).audioEngine.audioContext.decodeAudioData(audioData, (buffer)=>{
            this._audioBufferLoaded(buffer);
        }, (err)=>{
            (0, $kVtWi.Logger).Error("Error while decoding audio data for: " + this.name + " / Error: " + err);
        });
    }
    /**
     * Sets the data of the sound from an audiobuffer
     * @param audioBuffer The audioBuffer containing the data
     */ setAudioBuffer(audioBuffer) {
        if ((0, $5YkyR.Engine).audioEngine?.canUseWebAudio) {
            this._audioBuffer = audioBuffer;
            this._isReadyToPlay = true;
        }
    }
    /**
     * Updates the current sounds options such as maxdistance, loop...
     * @param options A JSON object containing values named as the object properties
     */ updateOptions(options) {
        if (options) {
            this.loop = options.loop ?? this.loop;
            this.maxDistance = options.maxDistance ?? this.maxDistance;
            this.useCustomAttenuation = options.useCustomAttenuation ?? this.useCustomAttenuation;
            this.rolloffFactor = options.rolloffFactor ?? this.rolloffFactor;
            this.refDistance = options.refDistance ?? this.refDistance;
            this.distanceModel = options.distanceModel ?? this.distanceModel;
            this._playbackRate = options.playbackRate ?? this._playbackRate;
            this._length = options.length ?? undefined;
            this.spatialSound = options.spatialSound ?? this._spatialSound;
            this._setOffset(options.offset ?? undefined);
            this.setVolume(options.volume ?? this._volume);
            this._updateSpatialParameters();
            if (this.isPlaying) {
                if (this._streaming && this._htmlAudioElement) {
                    this._htmlAudioElement.playbackRate = this._playbackRate;
                    if (this._htmlAudioElement.loop !== this.loop) this._htmlAudioElement.loop = this.loop;
                } else if (this._soundSource) {
                    this._soundSource.playbackRate.value = this._playbackRate;
                    if (this._soundSource.loop !== this.loop) this._soundSource.loop = this.loop;
                    if (this._offset !== undefined && this._soundSource.loopStart !== this._offset) this._soundSource.loopStart = this._offset;
                    if (this._length !== undefined && this._length !== this._soundSource.loopEnd) this._soundSource.loopEnd = (this._offset | 0) + this._length;
                }
            }
        }
    }
    _createSpatialParameters() {
        if ((0, $5YkyR.Engine).audioEngine?.canUseWebAudio && (0, $5YkyR.Engine).audioEngine.audioContext) {
            if (this._scene.headphone) this._panningModel = "HRTF";
            this._soundPanner = this._soundPanner ?? (0, $5YkyR.Engine).audioEngine.audioContext.createPanner();
            if (this._soundPanner && this._outputAudioNode) {
                this._updateSpatialParameters();
                this._soundPanner.connect(this._outputAudioNode);
                this._inputAudioNode = this._soundPanner;
            }
        }
    }
    _disableSpatialSound() {
        if (!this._spatialSound) return;
        this._inputAudioNode = this._soundGain;
        this._soundPanner?.disconnect();
        this._soundPanner = null;
        this._spatialSound = false;
    }
    _updateSpatialParameters() {
        if (!this._spatialSound) return;
        if (this._soundPanner) {
            if (this.useCustomAttenuation) {
                // Tricks to disable in a way embedded Web Audio attenuation
                this._soundPanner.distanceModel = "linear";
                this._soundPanner.maxDistance = Number.MAX_VALUE;
                this._soundPanner.refDistance = 1;
                this._soundPanner.rolloffFactor = 1;
                this._soundPanner.panningModel = this._panningModel;
            } else {
                this._soundPanner.distanceModel = this.distanceModel;
                this._soundPanner.maxDistance = this.maxDistance;
                this._soundPanner.refDistance = this.refDistance;
                this._soundPanner.rolloffFactor = this.rolloffFactor;
                this._soundPanner.panningModel = this._panningModel;
            }
        } else this._createSpatialParameters();
    }
    /**
     * Switch the panning model to HRTF:
     * Renders a stereo output of higher quality than equalpower — it uses a convolution with measured impulse responses from human subjects.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/audio/playingSoundsMusic#creating-a-spatial-3d-sound
     */ switchPanningModelToHRTF() {
        this._panningModel = "HRTF";
        this._switchPanningModel();
    }
    /**
     * Switch the panning model to Equal Power:
     * Represents the equal-power panning algorithm, generally regarded as simple and efficient. equalpower is the default value.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/audio/playingSoundsMusic#creating-a-spatial-3d-sound
     */ switchPanningModelToEqualPower() {
        this._panningModel = "equalpower";
        this._switchPanningModel();
    }
    _switchPanningModel() {
        if ((0, $5YkyR.Engine).audioEngine?.canUseWebAudio && this._spatialSound && this._soundPanner) this._soundPanner.panningModel = this._panningModel;
    }
    /**
     * Connect this sound to a sound track audio node like gain...
     * @param soundTrackAudioNode the sound track audio node to connect to
     */ connectToSoundTrackAudioNode(soundTrackAudioNode) {
        if ((0, $5YkyR.Engine).audioEngine?.canUseWebAudio && this._outputAudioNode) {
            if (this._isOutputConnected) this._outputAudioNode.disconnect();
            this._outputAudioNode.connect(soundTrackAudioNode);
            this._isOutputConnected = true;
        }
    }
    /**
     * Transform this sound into a directional source
     * @param coneInnerAngle Size of the inner cone in degree
     * @param coneOuterAngle Size of the outer cone in degree
     * @param coneOuterGain Volume of the sound outside the outer cone (between 0.0 and 1.0)
     */ setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
        if (coneOuterAngle < coneInnerAngle) {
            (0, $kVtWi.Logger).Error("setDirectionalCone(): outer angle of the cone must be superior or equal to the inner angle.");
            return;
        }
        this._coneInnerAngle = coneInnerAngle;
        this._coneOuterAngle = coneOuterAngle;
        this._coneOuterGain = coneOuterGain;
        this._isDirectional = true;
        if (this.isPlaying && this.loop) {
            this.stop();
            this.play(0, this._offset, this._length);
        }
    }
    /**
     * Gets or sets the inner angle for the directional cone.
     */ get directionalConeInnerAngle() {
        return this._coneInnerAngle;
    }
    /**
     * Gets or sets the inner angle for the directional cone.
     */ set directionalConeInnerAngle(value) {
        if (value != this._coneInnerAngle) {
            if (this._coneOuterAngle < value) {
                (0, $kVtWi.Logger).Error("directionalConeInnerAngle: outer angle of the cone must be superior or equal to the inner angle.");
                return;
            }
            this._coneInnerAngle = value;
            if ((0, $5YkyR.Engine).audioEngine?.canUseWebAudio && this._spatialSound && this._soundPanner) this._soundPanner.coneInnerAngle = this._coneInnerAngle;
        }
    }
    /**
     * Gets or sets the outer angle for the directional cone.
     */ get directionalConeOuterAngle() {
        return this._coneOuterAngle;
    }
    /**
     * Gets or sets the outer angle for the directional cone.
     */ set directionalConeOuterAngle(value) {
        if (value != this._coneOuterAngle) {
            if (value < this._coneInnerAngle) {
                (0, $kVtWi.Logger).Error("directionalConeOuterAngle: outer angle of the cone must be superior or equal to the inner angle.");
                return;
            }
            this._coneOuterAngle = value;
            if ((0, $5YkyR.Engine).audioEngine?.canUseWebAudio && this._spatialSound && this._soundPanner) this._soundPanner.coneOuterAngle = this._coneOuterAngle;
        }
    }
    /**
     * Sets the position of the emitter if spatial sound is enabled
     * @param newPosition Defines the new position
     */ setPosition(newPosition) {
        if (newPosition.equals(this._position)) return;
        this._position.copyFrom(newPosition);
        if ((0, $5YkyR.Engine).audioEngine?.canUseWebAudio && this._spatialSound && this._soundPanner && !isNaN(this._position.x) && !isNaN(this._position.y) && !isNaN(this._position.z)) {
            this._soundPanner.positionX.value = this._position.x;
            this._soundPanner.positionY.value = this._position.y;
            this._soundPanner.positionZ.value = this._position.z;
        }
    }
    /**
     * Sets the local direction of the emitter if spatial sound is enabled
     * @param newLocalDirection Defines the new local direction
     */ setLocalDirectionToMesh(newLocalDirection) {
        this._localDirection = newLocalDirection;
        if ((0, $5YkyR.Engine).audioEngine?.canUseWebAudio && this._connectedTransformNode && this.isPlaying) this._updateDirection();
    }
    _updateDirection() {
        if (!this._connectedTransformNode || !this._soundPanner) return;
        const mat = this._connectedTransformNode.getWorldMatrix();
        const direction = (0, $ha1VO.Vector3).TransformNormal(this._localDirection, mat);
        direction.normalize();
        this._soundPanner.orientationX.value = direction.x;
        this._soundPanner.orientationY.value = direction.y;
        this._soundPanner.orientationZ.value = direction.z;
    }
    /** @internal */ updateDistanceFromListener() {
        if ((0, $5YkyR.Engine).audioEngine?.canUseWebAudio && this._connectedTransformNode && this.useCustomAttenuation && this._soundGain && this._scene.activeCamera) {
            const distance = this._scene.audioListenerPositionProvider ? this._connectedTransformNode.position.subtract(this._scene.audioListenerPositionProvider()).length() : this._connectedTransformNode.getDistanceToCamera(this._scene.activeCamera);
            this._soundGain.gain.value = this._customAttenuationFunction(this._volume, distance, this.maxDistance, this.refDistance, this.rolloffFactor);
        }
    }
    /**
     * Sets a new custom attenuation function for the sound.
     * @param callback Defines the function used for the attenuation
     * @see https://doc.babylonjs.com/features/featuresDeepDive/audio/playingSoundsMusic#creating-your-own-custom-attenuation-function
     */ setAttenuationFunction(callback) {
        this._customAttenuationFunction = callback;
    }
    /**
     * Play the sound
     * @param time (optional) Start the sound after X seconds. Start immediately (0) by default.
     * @param offset (optional) Start the sound at a specific time in seconds
     * @param length (optional) Sound duration (in seconds)
     */ play(time, offset, length) {
        if (this._isReadyToPlay && this._scene.audioEnabled && (0, $5YkyR.Engine).audioEngine?.audioContext) try {
            this._clearTimeoutsAndObservers();
            let startTime = time ? (0, $5YkyR.Engine).audioEngine?.audioContext.currentTime + time : (0, $5YkyR.Engine).audioEngine?.audioContext.currentTime;
            if (!this._soundSource || !this._streamingSource) {
                if (this._spatialSound && this._soundPanner) {
                    if (!isNaN(this._position.x) && !isNaN(this._position.y) && !isNaN(this._position.z)) {
                        this._soundPanner.positionX.value = this._position.x;
                        this._soundPanner.positionY.value = this._position.y;
                        this._soundPanner.positionZ.value = this._position.z;
                    }
                    if (this._isDirectional) {
                        this._soundPanner.coneInnerAngle = this._coneInnerAngle;
                        this._soundPanner.coneOuterAngle = this._coneOuterAngle;
                        this._soundPanner.coneOuterGain = this._coneOuterGain;
                        if (this._connectedTransformNode) this._updateDirection();
                        else this._soundPanner.setOrientation(this._localDirection.x, this._localDirection.y, this._localDirection.z);
                    }
                }
            }
            if (this._streaming) {
                if (!this._streamingSource) {
                    this._streamingSource = (0, $5YkyR.Engine).audioEngine.audioContext.createMediaElementSource(this._htmlAudioElement);
                    this._htmlAudioElement.onended = ()=>{
                        this._onended();
                    };
                    this._htmlAudioElement.playbackRate = this._playbackRate;
                }
                this._streamingSource.disconnect();
                if (this._inputAudioNode) this._streamingSource.connect(this._inputAudioNode);
                if (this._htmlAudioElement) {
                    // required to manage properly the new suspended default state of Chrome
                    // When the option 'streaming: true' is used, we need first to wait for
                    // the audio engine to be unlocked by a user gesture before trying to play
                    // an HTML Audio element
                    const tryToPlay = ()=>{
                        if ((0, $5YkyR.Engine).audioEngine?.unlocked) {
                            const playPromise = this._htmlAudioElement.play();
                            // In browsers that don’t yet support this functionality,
                            // playPromise won’t be defined.
                            if (playPromise !== undefined) playPromise.catch(()=>{
                                // Automatic playback failed.
                                // Waiting for the audio engine to be unlocked by user click on unmute
                                (0, $5YkyR.Engine).audioEngine?.lock();
                                if (this.loop || this.autoplay) this._audioUnlockedObserver = (0, $5YkyR.Engine).audioEngine?.onAudioUnlockedObservable.addOnce(()=>{
                                    tryToPlay();
                                });
                            });
                        } else if (this.loop || this.autoplay) this._audioUnlockedObserver = (0, $5YkyR.Engine).audioEngine?.onAudioUnlockedObservable.addOnce(()=>{
                            tryToPlay();
                        });
                    };
                    tryToPlay();
                }
            } else {
                const tryToPlay = ()=>{
                    if ((0, $5YkyR.Engine).audioEngine?.audioContext) {
                        length = length || this._length;
                        if (offset !== undefined) this._setOffset(offset);
                        if (this._soundSource) {
                            const oldSource = this._soundSource;
                            oldSource.onended = ()=>{
                                oldSource.disconnect();
                            };
                        }
                        this._soundSource = (0, $5YkyR.Engine).audioEngine?.audioContext.createBufferSource();
                        if (this._soundSource && this._inputAudioNode) {
                            this._soundSource.buffer = this._audioBuffer;
                            this._soundSource.connect(this._inputAudioNode);
                            this._soundSource.loop = this.loop;
                            if (offset !== undefined) this._soundSource.loopStart = offset;
                            if (length !== undefined) this._soundSource.loopEnd = (offset | 0) + length;
                            this._soundSource.playbackRate.value = this._playbackRate;
                            this._soundSource.onended = ()=>{
                                this._onended();
                            };
                            startTime = time ? (0, $5YkyR.Engine).audioEngine?.audioContext.currentTime + time : (0, $5YkyR.Engine).audioEngine.audioContext.currentTime;
                            const actualOffset = ((this.isPaused ? this.currentTime : 0) + (this._offset ?? 0)) % this._soundSource.buffer.duration;
                            this._soundSource.start(startTime, actualOffset, this.loop ? undefined : length);
                        }
                    }
                };
                if ((0, $5YkyR.Engine).audioEngine?.audioContext.state === "suspended") // Wait a bit for FF as context seems late to be ready.
                this._tryToPlayTimeout = setTimeout(()=>{
                    if ((0, $5YkyR.Engine).audioEngine?.audioContext.state === "suspended") {
                        // Automatic playback failed.
                        // Waiting for the audio engine to be unlocked by user click on unmute
                        (0, $5YkyR.Engine).audioEngine.lock();
                        if (this.loop || this.autoplay) this._audioUnlockedObserver = (0, $5YkyR.Engine).audioEngine.onAudioUnlockedObservable.addOnce(()=>{
                            tryToPlay();
                        });
                    } else tryToPlay();
                }, 500);
                else tryToPlay();
            }
            this._startTime = startTime;
            this.isPlaying = true;
            this.isPaused = false;
        } catch (ex) {
            (0, $kVtWi.Logger).Error("Error while trying to play audio: " + this.name + ", " + ex.message);
        }
    }
    _onended() {
        this.isPlaying = false;
        this._startTime = 0;
        this._currentTime = 0;
        if (this.onended) this.onended();
        this.onEndedObservable.notifyObservers(this);
    }
    /**
     * Stop the sound
     * @param time (optional) Stop the sound after X seconds. Stop immediately (0) by default.
     */ stop(time) {
        if (this.isPlaying) {
            this._clearTimeoutsAndObservers();
            if (this._streaming) {
                if (this._htmlAudioElement) {
                    this._htmlAudioElement.pause();
                    // Test needed for Firefox or it will generate an Invalid State Error
                    if (this._htmlAudioElement.currentTime > 0) this._htmlAudioElement.currentTime = 0;
                } else this._streamingSource.disconnect();
                this.isPlaying = false;
            } else if ((0, $5YkyR.Engine).audioEngine?.audioContext && this._soundSource) {
                const stopTime = time ? (0, $5YkyR.Engine).audioEngine.audioContext.currentTime + time : undefined;
                this._soundSource.onended = ()=>{
                    this.isPlaying = false;
                    this.isPaused = false;
                    this._startTime = 0;
                    this._currentTime = 0;
                    if (this._soundSource) this._soundSource.onended = ()=>void 0;
                    this._onended();
                };
                this._soundSource.stop(stopTime);
            } else this.isPlaying = false;
        } else if (this.isPaused) {
            this.isPaused = false;
            this._startTime = 0;
            this._currentTime = 0;
        }
    }
    /**
     * Put the sound in pause
     */ pause() {
        if (this.isPlaying) {
            this._clearTimeoutsAndObservers();
            if (this._streaming) {
                if (this._htmlAudioElement) this._htmlAudioElement.pause();
                else this._streamingSource.disconnect();
                this.isPlaying = false;
                this.isPaused = true;
            } else if ((0, $5YkyR.Engine).audioEngine?.audioContext && this._soundSource) {
                this._soundSource.onended = ()=>void 0;
                this._soundSource.stop();
                this.isPlaying = false;
                this.isPaused = true;
                this._currentTime += (0, $5YkyR.Engine).audioEngine.audioContext.currentTime - this._startTime;
            }
        }
    }
    /**
     * Sets a dedicated volume for this sounds
     * @param newVolume Define the new volume of the sound
     * @param time Define time for gradual change to new volume
     */ setVolume(newVolume, time) {
        if ((0, $5YkyR.Engine).audioEngine?.canUseWebAudio && this._soundGain) {
            if (time && (0, $5YkyR.Engine).audioEngine.audioContext) {
                this._soundGain.gain.cancelScheduledValues((0, $5YkyR.Engine).audioEngine.audioContext.currentTime);
                this._soundGain.gain.setValueAtTime(this._soundGain.gain.value, (0, $5YkyR.Engine).audioEngine.audioContext.currentTime);
                this._soundGain.gain.linearRampToValueAtTime(newVolume, (0, $5YkyR.Engine).audioEngine.audioContext.currentTime + time);
            } else this._soundGain.gain.value = newVolume;
        }
        this._volume = newVolume;
    }
    /**
     * Set the sound play back rate
     * @param newPlaybackRate Define the playback rate the sound should be played at
     */ setPlaybackRate(newPlaybackRate) {
        this._playbackRate = newPlaybackRate;
        if (this.isPlaying) {
            if (this._streaming && this._htmlAudioElement) this._htmlAudioElement.playbackRate = this._playbackRate;
            else if (this._soundSource) this._soundSource.playbackRate.value = this._playbackRate;
        }
    }
    /**
     * Gets the sound play back rate.
     * @returns the  play back rate of the sound
     */ getPlaybackRate() {
        return this._playbackRate;
    }
    /**
     * Gets the volume of the sound.
     * @returns the volume of the sound
     */ getVolume() {
        return this._volume;
    }
    /**
     * Attach the sound to a dedicated mesh
     * @param transformNode The transform node to connect the sound with
     * @see https://doc.babylonjs.com/features/featuresDeepDive/audio/playingSoundsMusic#attaching-a-sound-to-a-mesh
     */ attachToMesh(transformNode) {
        if (this._connectedTransformNode && this._registerFunc) {
            this._connectedTransformNode.unregisterAfterWorldMatrixUpdate(this._registerFunc);
            this._registerFunc = null;
        }
        this._connectedTransformNode = transformNode;
        if (!this._spatialSound) {
            this._spatialSound = true;
            this._createSpatialParameters();
            if (this.isPlaying && this.loop) {
                this.stop();
                this.play(0, this._offset, this._length);
            }
        }
        this._onRegisterAfterWorldMatrixUpdate(this._connectedTransformNode);
        this._registerFunc = (transformNode)=>this._onRegisterAfterWorldMatrixUpdate(transformNode);
        this._connectedTransformNode.registerAfterWorldMatrixUpdate(this._registerFunc);
    }
    /**
     * Detach the sound from the previously attached mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/audio/playingSoundsMusic#attaching-a-sound-to-a-mesh
     */ detachFromMesh() {
        if (this._connectedTransformNode && this._registerFunc) {
            this._connectedTransformNode.unregisterAfterWorldMatrixUpdate(this._registerFunc);
            this._registerFunc = null;
            this._connectedTransformNode = null;
        }
    }
    _onRegisterAfterWorldMatrixUpdate(node) {
        if (!node.getBoundingInfo) this.setPosition(node.absolutePosition);
        else {
            const mesh = node;
            const boundingInfo = mesh.getBoundingInfo();
            this.setPosition(boundingInfo.boundingSphere.centerWorld);
        }
        if ((0, $5YkyR.Engine).audioEngine?.canUseWebAudio && this._isDirectional && this.isPlaying) this._updateDirection();
    }
    /**
     * Clone the current sound in the scene.
     * @returns the new sound clone
     */ clone() {
        if (!this._streaming) {
            const setBufferAndRun = ()=>{
                if (this._isReadyToPlay) {
                    clonedSound._audioBuffer = this.getAudioBuffer();
                    clonedSound._isReadyToPlay = true;
                    if (clonedSound.autoplay) clonedSound.play(0, this._offset, this._length);
                } else setTimeout(setBufferAndRun, 300);
            };
            const currentOptions = {
                autoplay: this.autoplay,
                loop: this.loop,
                volume: this._volume,
                spatialSound: this._spatialSound,
                maxDistance: this.maxDistance,
                useCustomAttenuation: this.useCustomAttenuation,
                rolloffFactor: this.rolloffFactor,
                refDistance: this.refDistance,
                distanceModel: this.distanceModel
            };
            const clonedSound = new $c204841fc2d888eb$export$85990f0f98a390bb(this.name + "_cloned", new ArrayBuffer(0), this._scene, null, currentOptions);
            if (this.useCustomAttenuation) clonedSound.setAttenuationFunction(this._customAttenuationFunction);
            clonedSound.setPosition(this._position);
            clonedSound.setPlaybackRate(this._playbackRate);
            setBufferAndRun();
            return clonedSound;
        } else return null;
    }
    /**
     * Gets the current underlying audio buffer containing the data
     * @returns the audio buffer
     */ getAudioBuffer() {
        return this._audioBuffer;
    }
    /**
     * Gets the WebAudio AudioBufferSourceNode, lets you keep track of and stop instances of this Sound.
     * @returns the source node
     */ getSoundSource() {
        return this._soundSource;
    }
    /**
     * Gets the WebAudio GainNode, gives you precise control over the gain of instances of this Sound.
     * @returns the gain node
     */ getSoundGain() {
        return this._soundGain;
    }
    /**
     * Serializes the Sound in a JSON representation
     * @returns the JSON representation of the sound
     */ serialize() {
        const serializationObject = {
            name: this.name,
            url: this._url,
            autoplay: this.autoplay,
            loop: this.loop,
            volume: this._volume,
            spatialSound: this._spatialSound,
            maxDistance: this.maxDistance,
            rolloffFactor: this.rolloffFactor,
            refDistance: this.refDistance,
            distanceModel: this.distanceModel,
            playbackRate: this._playbackRate,
            panningModel: this._panningModel,
            soundTrackId: this.soundTrackId,
            metadata: this.metadata
        };
        if (this._spatialSound) {
            if (this._connectedTransformNode) serializationObject.connectedMeshId = this._connectedTransformNode.id;
            serializationObject.position = this._position.asArray();
            serializationObject.refDistance = this.refDistance;
            serializationObject.distanceModel = this.distanceModel;
            serializationObject.isDirectional = this._isDirectional;
            serializationObject.localDirectionToMesh = this._localDirection.asArray();
            serializationObject.coneInnerAngle = this._coneInnerAngle;
            serializationObject.coneOuterAngle = this._coneOuterAngle;
            serializationObject.coneOuterGain = this._coneOuterGain;
        }
        return serializationObject;
    }
    /**
     * Parse a JSON representation of a sound to instantiate in a given scene
     * @param parsedSound Define the JSON representation of the sound (usually coming from the serialize method)
     * @param scene Define the scene the new parsed sound should be created in
     * @param rootUrl Define the rooturl of the load in case we need to fetch relative dependencies
     * @param sourceSound Define a sound place holder if do not need to instantiate a new one
     * @returns the newly parsed sound
     */ static Parse(parsedSound, scene, rootUrl, sourceSound) {
        const soundName = parsedSound.name;
        let soundUrl;
        if (parsedSound.url) soundUrl = rootUrl + parsedSound.url;
        else soundUrl = rootUrl + soundName;
        const options = {
            autoplay: parsedSound.autoplay,
            loop: parsedSound.loop,
            volume: parsedSound.volume,
            spatialSound: parsedSound.spatialSound,
            maxDistance: parsedSound.maxDistance,
            rolloffFactor: parsedSound.rolloffFactor,
            refDistance: parsedSound.refDistance,
            distanceModel: parsedSound.distanceModel,
            playbackRate: parsedSound.playbackRate
        };
        let newSound;
        if (!sourceSound) {
            newSound = new $c204841fc2d888eb$export$85990f0f98a390bb(soundName, soundUrl, scene, ()=>{
                scene.removePendingData(newSound);
            }, options);
            scene.addPendingData(newSound);
        } else {
            const setBufferAndRun = ()=>{
                if (sourceSound._isReadyToPlay) {
                    newSound._audioBuffer = sourceSound.getAudioBuffer();
                    newSound._isReadyToPlay = true;
                    if (newSound.autoplay) newSound.play(0, newSound._offset, newSound._length);
                } else setTimeout(setBufferAndRun, 300);
            };
            newSound = new $c204841fc2d888eb$export$85990f0f98a390bb(soundName, new ArrayBuffer(0), scene, null, options);
            setBufferAndRun();
        }
        if (parsedSound.position) {
            const soundPosition = (0, $ha1VO.Vector3).FromArray(parsedSound.position);
            newSound.setPosition(soundPosition);
        }
        if (parsedSound.isDirectional) {
            newSound.setDirectionalCone(parsedSound.coneInnerAngle || 360, parsedSound.coneOuterAngle || 360, parsedSound.coneOuterGain || 0);
            if (parsedSound.localDirectionToMesh) {
                const localDirectionToMesh = (0, $ha1VO.Vector3).FromArray(parsedSound.localDirectionToMesh);
                newSound.setLocalDirectionToMesh(localDirectionToMesh);
            }
        }
        if (parsedSound.connectedMeshId) {
            const connectedMesh = scene.getMeshById(parsedSound.connectedMeshId);
            if (connectedMesh) newSound.attachToMesh(connectedMesh);
        }
        if (parsedSound.metadata) newSound.metadata = parsedSound.metadata;
        return newSound;
    }
    _setOffset(value) {
        if (this._offset === value) return;
        if (this.isPaused) {
            this.stop();
            this.isPaused = false;
        }
        this._offset = value;
    }
    _clearTimeoutsAndObservers() {
        if (this._tryToPlayTimeout) {
            clearTimeout(this._tryToPlayTimeout);
            this._tryToPlayTimeout = null;
        }
        if (this._audioUnlockedObserver) {
            (0, $5YkyR.Engine).audioEngine?.onAudioUnlockedObservable.remove(this._audioUnlockedObserver);
            this._audioUnlockedObserver = null;
        }
    }
}
/**
 * @internal
 */ $c204841fc2d888eb$export$85990f0f98a390bb._SceneComponentInitialization = (_)=>{
    throw (0, $dUFYy._WarnImport)("AudioSceneComponent");
};

});

parcelRegister("kIpCn", function(module, exports) {

$parcel$export(module.exports, "SoundTrack", () => $f14bc9e38480ee3f$export$a652c0a9bcc18c16);

var $5YkyR = parcelRequire("5YkyR");

var $ejQPp = parcelRequire("ejQPp");
class $f14bc9e38480ee3f$export$a652c0a9bcc18c16 {
    /**
     * Creates a new sound track.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/audio/playingSoundsMusic#using-sound-tracks
     * @param scene Define the scene the sound track belongs to
     * @param options
     */ constructor(scene, options = {}){
        /**
         * The unique identifier of the sound track in the scene.
         */ this.id = -1;
        this._isInitialized = false;
        scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        if (!scene) return;
        this._scene = scene;
        this.soundCollection = [];
        this._options = options;
        if (!this._options.mainTrack && this._scene.soundTracks) {
            this._scene.soundTracks.push(this);
            this.id = this._scene.soundTracks.length - 1;
        }
    }
    _initializeSoundTrackAudioGraph() {
        if ((0, $5YkyR.Engine).audioEngine?.canUseWebAudio && (0, $5YkyR.Engine).audioEngine.audioContext) {
            this._outputAudioNode = (0, $5YkyR.Engine).audioEngine.audioContext.createGain();
            this._outputAudioNode.connect((0, $5YkyR.Engine).audioEngine.masterGain);
            if (this._options) {
                if (this._options.volume) this._outputAudioNode.gain.value = this._options.volume;
            }
            this._isInitialized = true;
        }
    }
    /**
     * Release the sound track and its associated resources
     */ dispose() {
        if ((0, $5YkyR.Engine).audioEngine && (0, $5YkyR.Engine).audioEngine.canUseWebAudio) {
            if (this._connectedAnalyser) this._connectedAnalyser.stopDebugCanvas();
            while(this.soundCollection.length)this.soundCollection[0].dispose();
            if (this._outputAudioNode) this._outputAudioNode.disconnect();
            this._outputAudioNode = null;
        }
    }
    /**
     * Adds a sound to this sound track
     * @param sound define the sound to add
     * @ignoreNaming
     */ addSound(sound) {
        if (!this._isInitialized) this._initializeSoundTrackAudioGraph();
        if ((0, $5YkyR.Engine).audioEngine?.canUseWebAudio && this._outputAudioNode) sound.connectToSoundTrackAudioNode(this._outputAudioNode);
        if (sound.soundTrackId !== undefined) {
            if (sound.soundTrackId === -1) this._scene.mainSoundTrack.removeSound(sound);
            else if (this._scene.soundTracks) this._scene.soundTracks[sound.soundTrackId].removeSound(sound);
        }
        this.soundCollection.push(sound);
        sound.soundTrackId = this.id;
    }
    /**
     * Removes a sound to this sound track
     * @param sound define the sound to remove
     * @ignoreNaming
     */ removeSound(sound) {
        const index = this.soundCollection.indexOf(sound);
        if (index !== -1) this.soundCollection.splice(index, 1);
    }
    /**
     * Set a global volume for the full sound track.
     * @param newVolume Define the new volume of the sound track
     */ setVolume(newVolume) {
        if ((0, $5YkyR.Engine).audioEngine?.canUseWebAudio && this._outputAudioNode) this._outputAudioNode.gain.value = newVolume;
    }
    /**
     * Switch the panning model to HRTF:
     * Renders a stereo output of higher quality than equalpower — it uses a convolution with measured impulse responses from human subjects.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/audio/playingSoundsMusic#creating-a-spatial-3d-sound
     */ switchPanningModelToHRTF() {
        if ((0, $5YkyR.Engine).audioEngine?.canUseWebAudio) for(let i = 0; i < this.soundCollection.length; i++)this.soundCollection[i].switchPanningModelToHRTF();
    }
    /**
     * Switch the panning model to Equal Power:
     * Represents the equal-power panning algorithm, generally regarded as simple and efficient. equalpower is the default value.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/audio/playingSoundsMusic#creating-a-spatial-3d-sound
     */ switchPanningModelToEqualPower() {
        if ((0, $5YkyR.Engine).audioEngine?.canUseWebAudio) for(let i = 0; i < this.soundCollection.length; i++)this.soundCollection[i].switchPanningModelToEqualPower();
    }
    /**
     * Connect the sound track to an audio analyser allowing some amazing
     * synchronization between the sounds/music and your visualization (VuMeter for instance).
     * @see https://doc.babylonjs.com/features/featuresDeepDive/audio/playingSoundsMusic#using-the-analyser
     * @param analyser The analyser to connect to the engine
     */ connectToAnalyser(analyser) {
        if (this._connectedAnalyser) this._connectedAnalyser.stopDebugCanvas();
        this._connectedAnalyser = analyser;
        if ((0, $5YkyR.Engine).audioEngine?.canUseWebAudio && this._outputAudioNode) {
            this._outputAudioNode.disconnect();
            this._connectedAnalyser.connectAudioNodes(this._outputAudioNode, (0, $5YkyR.Engine).audioEngine.masterGain);
        }
    }
}

});


parcelRegister("76WOH", function(module, exports) {

$parcel$export(module.exports, "WeightedSound", () => $52d6b7bb4eb42358$export$652f5fe06cec00a6);

var $kVtWi = parcelRequire("kVtWi");
class $52d6b7bb4eb42358$export$652f5fe06cec00a6 {
    /**
     * Creates a new WeightedSound from the list of sounds given.
     * @param loop When true a Sound will be selected and played when the current playing Sound completes.
     * @param sounds Array of Sounds that will be selected from.
     * @param weights Array of number values for selection weights; length must equal sounds, values will be normalized to 1
     */ constructor(loop, sounds, weights){
        /** When true a Sound will be selected and played when the current playing Sound completes. */ this.loop = false;
        this._coneInnerAngle = 360;
        this._coneOuterAngle = 360;
        this._volume = 1;
        /** A Sound is currently playing. */ this.isPlaying = false;
        /** A Sound is currently paused. */ this.isPaused = false;
        this._sounds = [];
        this._weights = [];
        if (sounds.length !== weights.length) throw new Error("Sounds length does not equal weights length");
        this.loop = loop;
        this._weights = weights;
        // Normalize the weights
        let weightSum = 0;
        for (const weight of weights)weightSum += weight;
        const invWeightSum = weightSum > 0 ? 1 / weightSum : 0;
        for(let i = 0; i < this._weights.length; i++)this._weights[i] *= invWeightSum;
        this._sounds = sounds;
        for (const sound of this._sounds)sound.onEndedObservable.add(()=>{
            this._onended();
        });
    }
    /**
     * The size of cone in degrees for a directional sound in which there will be no attenuation.
     */ get directionalConeInnerAngle() {
        return this._coneInnerAngle;
    }
    /**
     * The size of cone in degrees for a directional sound in which there will be no attenuation.
     */ set directionalConeInnerAngle(value) {
        if (value !== this._coneInnerAngle) {
            if (this._coneOuterAngle < value) {
                (0, $kVtWi.Logger).Error("directionalConeInnerAngle: outer angle of the cone must be superior or equal to the inner angle.");
                return;
            }
            this._coneInnerAngle = value;
            for (const sound of this._sounds)sound.directionalConeInnerAngle = value;
        }
    }
    /**
     * Size of cone in degrees for a directional sound outside of which there will be no sound.
     * Listener angles between innerAngle and outerAngle will falloff linearly.
     */ get directionalConeOuterAngle() {
        return this._coneOuterAngle;
    }
    /**
     * Size of cone in degrees for a directional sound outside of which there will be no sound.
     * Listener angles between innerAngle and outerAngle will falloff linearly.
     */ set directionalConeOuterAngle(value) {
        if (value !== this._coneOuterAngle) {
            if (value < this._coneInnerAngle) {
                (0, $kVtWi.Logger).Error("directionalConeOuterAngle: outer angle of the cone must be superior or equal to the inner angle.");
                return;
            }
            this._coneOuterAngle = value;
            for (const sound of this._sounds)sound.directionalConeOuterAngle = value;
        }
    }
    /**
     * Playback volume.
     */ get volume() {
        return this._volume;
    }
    /**
     * Playback volume.
     */ set volume(value) {
        if (value !== this._volume) for (const sound of this._sounds)sound.setVolume(value);
    }
    _onended() {
        if (this._currentIndex !== undefined) this._sounds[this._currentIndex].autoplay = false;
        if (this.loop && this.isPlaying) this.play();
        else this.isPlaying = false;
    }
    /**
     * Suspend playback
     */ pause() {
        this.isPaused = true;
        if (this._currentIndex !== undefined) this._sounds[this._currentIndex].pause();
    }
    /**
     * Stop playback
     */ stop() {
        this.isPlaying = false;
        if (this._currentIndex !== undefined) this._sounds[this._currentIndex].stop();
    }
    /**
     * Start playback.
     * @param startOffset Position the clip head at a specific time in seconds.
     */ play(startOffset) {
        if (!this.isPaused) {
            this.stop();
            const randomValue = Math.random();
            let total = 0;
            for(let i = 0; i < this._weights.length; i++){
                total += this._weights[i];
                if (randomValue <= total) {
                    this._currentIndex = i;
                    break;
                }
            }
        }
        const sound = this._sounds[this._currentIndex];
        if (sound.isReady()) sound.play(0, this.isPaused ? undefined : startOffset);
        else sound.autoplay = true;
        this.isPlaying = true;
        this.isPaused = false;
    }
}

});


parcelRegister("fF6RN", function(module, exports) {

var $jI7bl = parcelRequire("jI7bl");

var $jFgrG = parcelRequire("jFgrG");
$parcel$exportWildcard(module.exports, $jI7bl);
$parcel$exportWildcard(module.exports, $jFgrG);

});
parcelRegister("jI7bl", function(module, exports) {

$parcel$export(module.exports, "BakedVertexAnimationManager", () => $e597b2962a5a0468$export$a12b67291b48d0cc);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $ha1VO = parcelRequire("ha1VO");

var $ejQPp = parcelRequire("ejQPp");

var $6Ho1L = parcelRequire("6Ho1L");
class $e597b2962a5a0468$export$a12b67291b48d0cc {
    /**
     * Creates a new BakedVertexAnimationManager
     * @param scene defines the current scene
     */ constructor(scene){
        this._texture = null;
        this._isEnabled = true;
        /**
         * Enable or disable the vertex animation manager
         */ this.isEnabled = true;
        /**
         * The time counter, to pick the correct animation frame.
         */ this.time = 0;
        scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        if (!scene) return;
        this._scene = scene;
        this.animationParameters = new (0, $ha1VO.Vector4)(0, 0, 0, 30);
    }
    /** @internal */ _markSubMeshesAsAttributesDirty() {
        for (const mesh of this._scene.meshes)if (mesh.bakedVertexAnimationManager === this) mesh._markSubMeshesAsAttributesDirty();
    }
    /**
     * Binds to the effect.
     * @param effect The effect to bind to.
     * @param useInstances True when it's an instance.
     */ bind(effect, useInstances = false) {
        if (!this._texture || !this._isEnabled) return;
        const size = this._texture.getSize();
        effect.setFloat2("bakedVertexAnimationTextureSizeInverted", 1.0 / size.width, 1.0 / size.height);
        effect.setFloat("bakedVertexAnimationTime", this.time);
        if (!useInstances) effect.setVector4("bakedVertexAnimationSettings", this.animationParameters);
        effect.setTexture("bakedVertexAnimationTexture", this._texture);
    }
    /**
     * Clone the current manager
     * @returns a new BakedVertexAnimationManager
     */ clone() {
        const copy = new $e597b2962a5a0468$export$a12b67291b48d0cc(this._scene);
        this.copyTo(copy);
        return copy;
    }
    /**
     * Sets animation parameters.
     * @param startFrame The first frame of the animation.
     * @param endFrame The last frame of the animation.
     * @param offset The offset when starting the animation.
     * @param speedFramesPerSecond The frame rate.
     */ setAnimationParameters(startFrame, endFrame, offset = 0, speedFramesPerSecond = 30) {
        this.animationParameters = new (0, $ha1VO.Vector4)(startFrame, endFrame, offset, speedFramesPerSecond);
    }
    /**
     * Disposes the resources of the manager.
     * @param forceDisposeTextures - Forces the disposal of all textures.
     */ dispose(forceDisposeTextures) {
        if (forceDisposeTextures) this._texture?.dispose();
    }
    /**
     * Get the current class name useful for serialization or dynamic coding.
     * @returns "BakedVertexAnimationManager"
     */ getClassName() {
        return "BakedVertexAnimationManager";
    }
    /**
     * Makes a duplicate of the current instance into another one.
     * @param vatMap define the instance where to copy the info
     */ copyTo(vatMap) {
        (0, $6Ho1L.SerializationHelper).Clone(()=>vatMap, this);
    }
    /**
     * Serializes this vertex animation instance
     * @returns - An object with the serialized instance.
     */ serialize() {
        return (0, $6Ho1L.SerializationHelper).Serialize(this);
    }
    /**
     * Parses a vertex animation setting from a serialized object.
     * @param source - Serialized object.
     * @param scene Defines the scene we are parsing for
     * @param rootUrl Defines the rootUrl to load from
     */ parse(source, scene, rootUrl) {
        (0, $6Ho1L.SerializationHelper).Parse(()=>this, source, scene, rootUrl);
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)(),
    (0, $ir0rz.expandToProperty)("_markSubMeshesAsAttributesDirty")
], $e597b2962a5a0468$export$a12b67291b48d0cc.prototype, "texture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markSubMeshesAsAttributesDirty")
], $e597b2962a5a0468$export$a12b67291b48d0cc.prototype, "isEnabled", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e597b2962a5a0468$export$a12b67291b48d0cc.prototype, "animationParameters", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e597b2962a5a0468$export$a12b67291b48d0cc.prototype, "time", void 0);

});

parcelRegister("jFgrG", function(module, exports) {

$parcel$export(module.exports, "VertexAnimationBaker", () => $e50e9a6a4f54f820$export$ada928d07626293b);

var $5Egpj = parcelRequire("5Egpj");

var $j2mX5 = parcelRequire("j2mX5");

var $eLv1o = parcelRequire("eLv1o");

var $3RnX0 = parcelRequire("3RnX0");
class $e50e9a6a4f54f820$export$ada928d07626293b {
    /**
     * Create a new VertexAnimationBaker object which can help baking animations into a texture.
     * @param scene Defines the scene the VAT belongs to
     * @param meshOrSkeleton Defines the skeleton or the mesh from which to retrieve the skeleton from.
     */ constructor(scene, meshOrSkeleton){
        this._scene = scene;
        if (meshOrSkeleton instanceof (0, $3RnX0.Skeleton)) {
            this._skeleton = meshOrSkeleton;
            this._mesh = null;
        } else {
            this._mesh = meshOrSkeleton;
            this._skeleton = meshOrSkeleton.skeleton;
        }
    }
    /**
     * Bakes the animation into the texture. This should be called once, when the
     * scene starts, so the VAT is generated and associated to the mesh.
     * @param ranges Defines the ranges in the animation that will be baked.
     * @returns The array of matrix transforms for each vertex (columns) and frame (rows), as a Float32Array.
     */ async bakeVertexData(ranges) {
        if (!this._skeleton) throw new Error("No skeleton provided.");
        const boneCount = this._skeleton.bones.length;
        /** total number of frames in our animations */ const frameCount = ranges.reduce((previous, current)=>previous + current.to - current.from + 1, 0);
        if (isNaN(frameCount)) throw new Error("Invalid animation ranges.");
        // reset our loop data
        let textureIndex = 0;
        const textureSize = (boneCount + 1) * 16 * frameCount;
        const vertexData = new Float32Array(textureSize);
        this._scene.stopAnimation(this._skeleton);
        this._skeleton.returnToRest();
        // render all frames from our slices
        for (const range of ranges)for(let frameIndex = range.from; frameIndex <= range.to; frameIndex++)await this._executeAnimationFrame(vertexData, frameIndex, textureIndex++);
        return vertexData;
    }
    /**
     * Runs an animation frame and stores its vertex data
     *
     * @param vertexData The array to save data to.
     * @param frameIndex Current frame in the skeleton animation to render.
     * @param textureIndex Current index of the texture data.
     */ async _executeAnimationFrame(vertexData, frameIndex, textureIndex) {
        return new Promise((resolve, _reject)=>{
            this._scene.beginAnimation(this._skeleton, frameIndex, frameIndex, false, 1.0, ()=>{
                // generate matrices
                const skeletonMatrices = this._skeleton.getTransformMatrices(this._mesh);
                vertexData.set(skeletonMatrices, textureIndex * skeletonMatrices.length);
                resolve();
            });
        });
    }
    /**
     * Builds a vertex animation texture given the vertexData in an array.
     * @param vertexData The vertex animation data. You can generate it with bakeVertexData().
     * @returns The vertex animation texture to be used with BakedVertexAnimationManager.
     */ textureFromBakedVertexData(vertexData) {
        if (!this._skeleton) throw new Error("No skeleton provided.");
        const boneCount = this._skeleton.bones.length;
        const texture = (0, $5Egpj.RawTexture).CreateRGBATexture(vertexData, (boneCount + 1) * 4, vertexData.length / ((boneCount + 1) * 16), this._scene, false, false, (0, $j2mX5.Texture).NEAREST_NEAREST, 1);
        texture.name = "VAT" + this._skeleton.name;
        return texture;
    }
    /**
     * Serializes our vertexData to an object, with a nice string for the vertexData.
     * @param vertexData The vertex array data.
     * @returns This object serialized to a JS dict.
     */ serializeBakedVertexDataToObject(vertexData) {
        if (!this._skeleton) throw new Error("No skeleton provided.");
        // this converts the float array to a serialized base64 string, ~1.3x larger
        // than the original.
        const boneCount = this._skeleton.bones.length;
        const width = (boneCount + 1) * 4;
        const height = vertexData.length / ((boneCount + 1) * 16);
        const data = {
            vertexData: (0, $eLv1o.EncodeArrayBufferToBase64)(vertexData),
            width: width,
            height: height
        };
        return data;
    }
    /**
     * Loads previously baked data.
     * @param data The object as serialized by serializeBakedVertexDataToObject()
     * @returns The array of matrix transforms for each vertex (columns) and frame (rows), as a Float32Array.
     */ loadBakedVertexDataFromObject(data) {
        return new Float32Array((0, $eLv1o.DecodeBase64ToBinary)(data.vertexData));
    }
    /**
     * Serializes our vertexData to a JSON string, with a nice string for the vertexData.
     * Should be called right after bakeVertexData().
     * @param vertexData The vertex array data.
     * @returns This object serialized to a safe string.
     */ serializeBakedVertexDataToJSON(vertexData) {
        return JSON.stringify(this.serializeBakedVertexDataToObject(vertexData));
    }
    /**
     * Loads previously baked data in string format.
     * @param json The json string as serialized by serializeBakedVertexDataToJSON().
     * @returns The array of matrix transforms for each vertex (columns) and frame (rows), as a Float32Array.
     */ loadBakedVertexDataFromJSON(json) {
        return this.loadBakedVertexDataFromObject(JSON.parse(json));
    }
}

});
parcelRegister("5Egpj", function(module, exports) {

$parcel$export(module.exports, "RawTexture", () => $41cd6a50c4d71975$export$c6d6cd5ffcb825d2);

var $j2mX5 = parcelRequire("j2mX5");
parcelRequire("e7NUJ");
class $41cd6a50c4d71975$export$c6d6cd5ffcb825d2 extends (0, $j2mX5.Texture) {
    /**
     * Instantiates a new RawTexture.
     * Raw texture can help creating a texture directly from an array of data.
     * This can be super useful if you either get the data from an uncompressed source or
     * if you wish to create your texture pixel by pixel.
     * @param data define the array of data to use to create the texture (null to create an empty texture)
     * @param width define the width of the texture
     * @param height define the height of the texture
     * @param format define the format of the data (RGB, RGBA... Engine.TEXTUREFORMAT_xxx)
     * @param sceneOrEngine defines the scene or engine the texture will belong to
     * @param generateMipMaps define whether mip maps should be generated or not
     * @param invertY define if the data should be flipped on Y when uploaded to the GPU
     * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
     * @param type define the format of the data (int, float... Engine.TEXTURETYPE_xxx)
     * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
     * @param useSRGBBuffer defines if the texture must be loaded in a sRGB GPU buffer (if supported by the GPU).
     */ constructor(data, width, height, /**
     * Define the format of the data (RGB, RGBA... Engine.TEXTUREFORMAT_xxx)
     */ format, sceneOrEngine, generateMipMaps = true, invertY = false, samplingMode = 3, type = 0, creationFlags, useSRGBBuffer){
        super(null, sceneOrEngine, !generateMipMaps, invertY, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, creationFlags);
        this.format = format;
        if (!this._engine) return;
        if (!this._engine._caps.textureFloatLinearFiltering && type === 1) samplingMode = 1;
        if (!this._engine._caps.textureHalfFloatLinearFiltering && type === 2) samplingMode = 1;
        this._texture = this._engine.createRawTexture(data, width, height, format, generateMipMaps, invertY, samplingMode, null, type, creationFlags ?? 0, useSRGBBuffer ?? false);
        this.wrapU = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        this.wrapV = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
    }
    /**
     * Updates the texture underlying data.
     * @param data Define the new data of the texture
     */ update(data) {
        this._getEngine().updateRawTexture(this._texture, data, this._texture.format, this._texture.invertY, null, this._texture.type, this._texture._useSRGBBuffer);
    }
    /**
     * Creates a luminance texture from some data.
     * @param data Define the texture data
     * @param width Define the width of the texture
     * @param height Define the height of the texture
     * @param sceneOrEngine defines the scene or engine the texture will belong to
     * @param generateMipMaps Define whether or not to create mip maps for the texture
     * @param invertY define if the data should be flipped on Y when uploaded to the GPU
     * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
     * @returns the luminance texture
     */ static CreateLuminanceTexture(data, width, height, sceneOrEngine, generateMipMaps = true, invertY = false, samplingMode = 3) {
        return new $41cd6a50c4d71975$export$c6d6cd5ffcb825d2(data, width, height, 1, sceneOrEngine, generateMipMaps, invertY, samplingMode);
    }
    /**
     * Creates a luminance alpha texture from some data.
     * @param data Define the texture data
     * @param width Define the width of the texture
     * @param height Define the height of the texture
     * @param sceneOrEngine defines the scene or engine the texture will belong to
     * @param generateMipMaps Define whether or not to create mip maps for the texture
     * @param invertY define if the data should be flipped on Y when uploaded to the GPU
     * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
     * @returns the luminance alpha texture
     */ static CreateLuminanceAlphaTexture(data, width, height, sceneOrEngine, generateMipMaps = true, invertY = false, samplingMode = 3) {
        return new $41cd6a50c4d71975$export$c6d6cd5ffcb825d2(data, width, height, 2, sceneOrEngine, generateMipMaps, invertY, samplingMode);
    }
    /**
     * Creates an alpha texture from some data.
     * @param data Define the texture data
     * @param width Define the width of the texture
     * @param height Define the height of the texture
     * @param sceneOrEngine defines the scene or engine the texture will belong to
     * @param generateMipMaps Define whether or not to create mip maps for the texture
     * @param invertY define if the data should be flipped on Y when uploaded to the GPU
     * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
     * @returns the alpha texture
     */ static CreateAlphaTexture(data, width, height, sceneOrEngine, generateMipMaps = true, invertY = false, samplingMode = 3) {
        return new $41cd6a50c4d71975$export$c6d6cd5ffcb825d2(data, width, height, 0, sceneOrEngine, generateMipMaps, invertY, samplingMode);
    }
    /**
     * Creates a RGB texture from some data.
     * @param data Define the texture data
     * @param width Define the width of the texture
     * @param height Define the height of the texture
     * @param sceneOrEngine defines the scene or engine the texture will belong to
     * @param generateMipMaps Define whether or not to create mip maps for the texture
     * @param invertY define if the data should be flipped on Y when uploaded to the GPU
     * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
     * @param type define the format of the data (int, float... Engine.TEXTURETYPE_xxx)
     * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
     * @param useSRGBBuffer defines if the texture must be loaded in a sRGB GPU buffer (if supported by the GPU).
     * @returns the RGB alpha texture
     */ static CreateRGBTexture(data, width, height, sceneOrEngine, generateMipMaps = true, invertY = false, samplingMode = 3, type = 0, creationFlags = 0, useSRGBBuffer = false) {
        return new $41cd6a50c4d71975$export$c6d6cd5ffcb825d2(data, width, height, 4, sceneOrEngine, generateMipMaps, invertY, samplingMode, type, creationFlags, useSRGBBuffer);
    }
    /**
     * Creates a RGBA texture from some data.
     * @param data Define the texture data
     * @param width Define the width of the texture
     * @param height Define the height of the texture
     * @param sceneOrEngine defines the scene or engine the texture will belong to
     * @param generateMipMaps Define whether or not to create mip maps for the texture
     * @param invertY define if the data should be flipped on Y when uploaded to the GPU
     * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
     * @param type define the format of the data (int, float... Engine.TEXTURETYPE_xxx)
     * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
     * @param useSRGBBuffer defines if the texture must be loaded in a sRGB GPU buffer (if supported by the GPU).
     * @returns the RGBA texture
     */ static CreateRGBATexture(data, width, height, sceneOrEngine, generateMipMaps = true, invertY = false, samplingMode = 3, type = 0, creationFlags = 0, useSRGBBuffer = false) {
        return new $41cd6a50c4d71975$export$c6d6cd5ffcb825d2(data, width, height, 5, sceneOrEngine, generateMipMaps, invertY, samplingMode, type, creationFlags, useSRGBBuffer);
    }
    /**
     * Creates a RGBA storage texture from some data.
     * @param data Define the texture data
     * @param width Define the width of the texture
     * @param height Define the height of the texture
     * @param sceneOrEngine defines the scene or engine the texture will belong to
     * @param generateMipMaps Define whether or not to create mip maps for the texture
     * @param invertY define if the data should be flipped on Y when uploaded to the GPU
     * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
     * @param type define the format of the data (int, float... Engine.TEXTURETYPE_xxx)
     * @param useSRGBBuffer defines if the texture must be loaded in a sRGB GPU buffer (if supported by the GPU).
     * @returns the RGBA texture
     */ static CreateRGBAStorageTexture(data, width, height, sceneOrEngine, generateMipMaps = true, invertY = false, samplingMode = 3, type = 0, useSRGBBuffer = false) {
        return new $41cd6a50c4d71975$export$c6d6cd5ffcb825d2(data, width, height, 5, sceneOrEngine, generateMipMaps, invertY, samplingMode, type, 1, useSRGBBuffer);
    }
    /**
     * Creates a R texture from some data.
     * @param data Define the texture data
     * @param width Define the width of the texture
     * @param height Define the height of the texture
     * @param sceneOrEngine defines the scene or engine the texture will belong to
     * @param generateMipMaps Define whether or not to create mip maps for the texture
     * @param invertY define if the data should be flipped on Y when uploaded to the GPU
     * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
     * @param type define the format of the data (int, float... Engine.TEXTURETYPE_xxx)
     * @returns the R texture
     */ static CreateRTexture(data, width, height, sceneOrEngine, generateMipMaps = true, invertY = false, samplingMode = (0, $j2mX5.Texture).TRILINEAR_SAMPLINGMODE, type = 1) {
        return new $41cd6a50c4d71975$export$c6d6cd5ffcb825d2(data, width, height, 6, sceneOrEngine, generateMipMaps, invertY, samplingMode, type);
    }
    /**
     * Creates a R storage texture from some data.
     * @param data Define the texture data
     * @param width Define the width of the texture
     * @param height Define the height of the texture
     * @param sceneOrEngine defines the scene or engine the texture will belong to
     * @param generateMipMaps Define whether or not to create mip maps for the texture
     * @param invertY define if the data should be flipped on Y when uploaded to the GPU
     * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
     * @param type define the format of the data (int, float... Engine.TEXTURETYPE_xxx)
     * @returns the R texture
     */ static CreateRStorageTexture(data, width, height, sceneOrEngine, generateMipMaps = true, invertY = false, samplingMode = (0, $j2mX5.Texture).TRILINEAR_SAMPLINGMODE, type = 1) {
        return new $41cd6a50c4d71975$export$c6d6cd5ffcb825d2(data, width, height, 6, sceneOrEngine, generateMipMaps, invertY, samplingMode, type, 1);
    }
}

});
parcelRegister("j2mX5", function(module, exports) {

$parcel$export(module.exports, "Texture", () => $ddc00207ac4a8ab4$export$5431306cf43de24a);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $akOl3 = parcelRequire("akOl3");

var $8DoUR = parcelRequire("8DoUR");

var $dUFYy = parcelRequire("dUFYy");

var $av6Bc = parcelRequire("av6Bc");

var $i1moY = parcelRequire("i1moY");

var $23POp = parcelRequire("23POp");

var $eLv1o = parcelRequire("eLv1o");

var $f2kkL = parcelRequire("f2kkL");

var $fGXjI = parcelRequire("fGXjI");

var $6Ho1L = parcelRequire("6Ho1L");
class $ddc00207ac4a8ab4$export$5431306cf43de24a extends (0, $akOl3.BaseTexture) {
    /**
     * @internal
     */ static _CreateVideoTexture(name, src, scene, generateMipMaps = false, invertY = false, samplingMode = $ddc00207ac4a8ab4$export$5431306cf43de24a.TRILINEAR_SAMPLINGMODE, settings = {}, onError, format = 5) {
        throw (0, $dUFYy._WarnImport)("VideoTexture");
    }
    /**
     * Are mip maps generated for this texture or not.
     */ get noMipmap() {
        return this._noMipmap;
    }
    /** Returns the texture mime type if it was defined by a loader (undefined else) */ get mimeType() {
        return this._mimeType;
    }
    /**
     * Is the texture preventing material to render while loading.
     * If false, a default texture will be used instead of the loading one during the preparation step.
     */ set isBlocking(value) {
        this._isBlocking = value;
    }
    get isBlocking() {
        return this._isBlocking;
    }
    /**
     * Gets a boolean indicating if the texture needs to be inverted on the y axis during loading
     */ get invertY() {
        return this._invertY;
    }
    /**
     * Instantiates a new texture.
     * This represents a texture in babylon. It can be easily loaded from a network, base64 or html input.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/materials_introduction#texture
     * @param url defines the url of the picture to load as a texture
     * @param sceneOrEngine defines the scene or engine the texture will belong to
     * @param noMipmapOrOptions defines if the texture will require mip maps or not or set of all options to create the texture
     * @param invertY defines if the texture needs to be inverted on the y axis during loading
     * @param samplingMode defines the sampling mode we want for the texture while fetching from it (Texture.NEAREST_SAMPLINGMODE...)
     * @param onLoad defines a callback triggered when the texture has been loaded
     * @param onError defines a callback triggered when an error occurred during the loading session
     * @param buffer defines the buffer to load the texture from in case the texture is loaded from a buffer representation
     * @param deleteBuffer defines if the buffer we are loading the texture from should be deleted after load
     * @param format defines the format of the texture we are trying to load (Engine.TEXTUREFORMAT_RGBA...)
     * @param mimeType defines an optional mime type information
     * @param loaderOptions options to be passed to the loader
     * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
     * @param forcedExtension defines the extension to use to pick the right loader
     */ constructor(url, sceneOrEngine, noMipmapOrOptions, invertY, samplingMode = $ddc00207ac4a8ab4$export$5431306cf43de24a.TRILINEAR_SAMPLINGMODE, onLoad = null, onError = null, buffer = null, deleteBuffer = false, format, mimeType, loaderOptions, creationFlags, forcedExtension){
        super(sceneOrEngine);
        /**
         * Define the url of the texture.
         */ this.url = null;
        /**
         * Define an offset on the texture to offset the u coordinates of the UVs
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/moreMaterials#offsetting
         */ this.uOffset = 0;
        /**
         * Define an offset on the texture to offset the v coordinates of the UVs
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/moreMaterials#offsetting
         */ this.vOffset = 0;
        /**
         * Define an offset on the texture to scale the u coordinates of the UVs
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/moreMaterials#tiling
         */ this.uScale = 1.0;
        /**
         * Define an offset on the texture to scale the v coordinates of the UVs
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/moreMaterials#tiling
         */ this.vScale = 1.0;
        /**
         * Define an offset on the texture to rotate around the u coordinates of the UVs
         * The angle is defined in radians.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/moreMaterials
         */ this.uAng = 0;
        /**
         * Define an offset on the texture to rotate around the v coordinates of the UVs
         * The angle is defined in radians.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/moreMaterials
         */ this.vAng = 0;
        /**
         * Define an offset on the texture to rotate around the w coordinates of the UVs (in case of 3d texture)
         * The angle is defined in radians.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/moreMaterials
         */ this.wAng = 0;
        /**
         * Defines the center of rotation (U)
         */ this.uRotationCenter = 0.5;
        /**
         * Defines the center of rotation (V)
         */ this.vRotationCenter = 0.5;
        /**
         * Defines the center of rotation (W)
         */ this.wRotationCenter = 0.5;
        /**
         * Sets this property to true to avoid deformations when rotating the texture with non-uniform scaling
         */ this.homogeneousRotationInUVTransform = false;
        /**
         * List of inspectable custom properties (used by the Inspector)
         * @see https://doc.babylonjs.com/toolsAndResources/inspector#extensibility
         */ this.inspectableCustomProperties = null;
        /** @internal */ this._noMipmap = false;
        /** @internal */ this._invertY = false;
        this._rowGenerationMatrix = null;
        this._cachedTextureMatrix = null;
        this._projectionModeMatrix = null;
        this._t0 = null;
        this._t1 = null;
        this._t2 = null;
        this._cachedUOffset = -1;
        this._cachedVOffset = -1;
        this._cachedUScale = 0;
        this._cachedVScale = 0;
        this._cachedUAng = -1;
        this._cachedVAng = -1;
        this._cachedWAng = -1;
        this._cachedReflectionProjectionMatrixId = -1;
        this._cachedURotationCenter = -1;
        this._cachedVRotationCenter = -1;
        this._cachedWRotationCenter = -1;
        this._cachedHomogeneousRotationInUVTransform = false;
        this._cachedReflectionTextureMatrix = null;
        this._cachedReflectionUOffset = -1;
        this._cachedReflectionVOffset = -1;
        this._cachedReflectionUScale = 0;
        this._cachedReflectionVScale = 0;
        this._cachedReflectionCoordinatesMode = -1;
        /** @internal */ this._buffer = null;
        this._deleteBuffer = false;
        this._format = null;
        this._delayedOnLoad = null;
        this._delayedOnError = null;
        /**
         * Observable triggered once the texture has been loaded.
         */ this.onLoadObservable = new (0, $diGQf.Observable)();
        this._isBlocking = true;
        this.name = url || "";
        this.url = url;
        let noMipmap;
        let useSRGBBuffer = false;
        let internalTexture = null;
        let gammaSpace = true;
        if (typeof noMipmapOrOptions === "object" && noMipmapOrOptions !== null) {
            noMipmap = noMipmapOrOptions.noMipmap ?? false;
            invertY = noMipmapOrOptions.invertY ?? ((0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? false : true);
            samplingMode = noMipmapOrOptions.samplingMode ?? $ddc00207ac4a8ab4$export$5431306cf43de24a.TRILINEAR_SAMPLINGMODE;
            onLoad = noMipmapOrOptions.onLoad ?? null;
            onError = noMipmapOrOptions.onError ?? null;
            buffer = noMipmapOrOptions.buffer ?? null;
            deleteBuffer = noMipmapOrOptions.deleteBuffer ?? false;
            format = noMipmapOrOptions.format;
            mimeType = noMipmapOrOptions.mimeType;
            loaderOptions = noMipmapOrOptions.loaderOptions;
            creationFlags = noMipmapOrOptions.creationFlags;
            useSRGBBuffer = noMipmapOrOptions.useSRGBBuffer ?? false;
            internalTexture = noMipmapOrOptions.internalTexture ?? null;
            gammaSpace = noMipmapOrOptions.gammaSpace ?? gammaSpace;
        } else noMipmap = !!noMipmapOrOptions;
        this._gammaSpace = gammaSpace;
        this._noMipmap = noMipmap;
        this._invertY = invertY === undefined ? (0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? false : true : invertY;
        this._initialSamplingMode = samplingMode;
        this._buffer = buffer;
        this._deleteBuffer = deleteBuffer;
        this._mimeType = mimeType;
        this._loaderOptions = loaderOptions;
        this._creationFlags = creationFlags;
        this._useSRGBBuffer = useSRGBBuffer;
        this._forcedExtension = forcedExtension;
        if (format) this._format = format;
        const scene = this.getScene();
        const engine = this._getEngine();
        if (!engine) return;
        engine.onBeforeTextureInitObservable.notifyObservers(this);
        const load = ()=>{
            if (this._texture) {
                if (this._texture._invertVScale) {
                    this.vScale *= -1;
                    this.vOffset += 1;
                }
                // Update texture to match internal texture's wrapping
                if (this._texture._cachedWrapU !== null) {
                    this.wrapU = this._texture._cachedWrapU;
                    this._texture._cachedWrapU = null;
                }
                if (this._texture._cachedWrapV !== null) {
                    this.wrapV = this._texture._cachedWrapV;
                    this._texture._cachedWrapV = null;
                }
                if (this._texture._cachedWrapR !== null) {
                    this.wrapR = this._texture._cachedWrapR;
                    this._texture._cachedWrapR = null;
                }
            }
            if (this.onLoadObservable.hasObservers()) this.onLoadObservable.notifyObservers(this);
            if (onLoad) onLoad();
            if (!this.isBlocking && scene) scene.resetCachedMaterial();
        };
        const errorHandler = (message, exception)=>{
            this._loadingError = true;
            this._errorObject = {
                message: message,
                exception: exception
            };
            if (onError) onError(message, exception);
            $ddc00207ac4a8ab4$export$5431306cf43de24a.OnTextureLoadErrorObservable.notifyObservers(this);
        };
        if (!this.url && !internalTexture) {
            this._delayedOnLoad = load;
            this._delayedOnError = errorHandler;
            return;
        }
        this._texture = internalTexture ?? this._getFromCache(this.url, noMipmap, samplingMode, this._invertY, useSRGBBuffer, this.isCube);
        if (!this._texture) {
            if (!scene || !scene.useDelayedTextureLoading) {
                try {
                    this._texture = engine.createTexture(this.url, noMipmap, this._invertY, scene, samplingMode, load, errorHandler, this._buffer, undefined, this._format, this._forcedExtension, mimeType, loaderOptions, creationFlags, useSRGBBuffer);
                } catch (e) {
                    errorHandler("error loading", e);
                    throw e;
                }
                if (deleteBuffer) this._buffer = null;
            } else {
                this.delayLoadState = 4;
                this._delayedOnLoad = load;
                this._delayedOnError = errorHandler;
            }
        } else if (this._texture.isReady) (0, $av6Bc.TimingTools).SetImmediate(()=>load());
        else {
            const loadObserver = this._texture.onLoadedObservable.add(load);
            this._texture.onErrorObservable.add((e)=>{
                errorHandler(e.message, e.exception);
                this._texture?.onLoadedObservable.remove(loadObserver);
            });
        }
    }
    /**
     * Update the url (and optional buffer) of this texture if url was null during construction.
     * @param url the url of the texture
     * @param buffer the buffer of the texture (defaults to null)
     * @param onLoad callback called when the texture is loaded  (defaults to null)
     * @param forcedExtension defines the extension to use to pick the right loader
     */ updateURL(url, buffer = null, onLoad, forcedExtension) {
        if (this.url) {
            this.releaseInternalTexture();
            this.getScene().markAllMaterialsAsDirty(1, (mat)=>{
                return mat.hasTexture(this);
            });
        }
        if (!this.name || this.name.startsWith("data:")) this.name = url;
        this.url = url;
        this._buffer = buffer;
        this._forcedExtension = forcedExtension;
        this.delayLoadState = 4;
        if (onLoad) this._delayedOnLoad = onLoad;
        this.delayLoad();
    }
    /**
     * Finish the loading sequence of a texture flagged as delayed load.
     * @internal
     */ delayLoad() {
        if (this.delayLoadState !== 4) return;
        const scene = this.getScene();
        if (!scene) return;
        this.delayLoadState = 1;
        this._texture = this._getFromCache(this.url, this._noMipmap, this.samplingMode, this._invertY, this._useSRGBBuffer, this.isCube);
        if (!this._texture) {
            this._texture = scene.getEngine().createTexture(this.url, this._noMipmap, this._invertY, scene, this.samplingMode, this._delayedOnLoad, this._delayedOnError, this._buffer, null, this._format, this._forcedExtension, this._mimeType, this._loaderOptions, this._creationFlags, this._useSRGBBuffer);
            if (this._deleteBuffer) this._buffer = null;
        } else if (this._delayedOnLoad) {
            if (this._texture.isReady) (0, $av6Bc.TimingTools).SetImmediate(this._delayedOnLoad);
            else this._texture.onLoadedObservable.add(this._delayedOnLoad);
        }
        this._delayedOnLoad = null;
        this._delayedOnError = null;
    }
    _prepareRowForTextureGeneration(x, y, z, t) {
        x *= this._cachedUScale;
        y *= this._cachedVScale;
        x -= this.uRotationCenter * this._cachedUScale;
        y -= this.vRotationCenter * this._cachedVScale;
        z -= this.wRotationCenter;
        (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(x, y, z, this._rowGenerationMatrix, t);
        t.x += this.uRotationCenter * this._cachedUScale + this._cachedUOffset;
        t.y += this.vRotationCenter * this._cachedVScale + this._cachedVOffset;
        t.z += this.wRotationCenter;
    }
    /**
     * Checks if the texture has the same transform matrix than another texture
     * @param texture texture to check against
     * @returns true if the transforms are the same, else false
     */ checkTransformsAreIdentical(texture) {
        return texture !== null && this.uOffset === texture.uOffset && this.vOffset === texture.vOffset && this.uScale === texture.uScale && this.vScale === texture.vScale && this.uAng === texture.uAng && this.vAng === texture.vAng && this.wAng === texture.wAng;
    }
    /**
     * Get the current texture matrix which includes the requested offsetting, tiling and rotation components.
     * @param uBase The horizontal base offset multiplier (1 by default)
     * @returns the transform matrix of the texture.
     */ getTextureMatrix(uBase = 1) {
        if (this.uOffset === this._cachedUOffset && this.vOffset === this._cachedVOffset && this.uScale * uBase === this._cachedUScale && this.vScale === this._cachedVScale && this.uAng === this._cachedUAng && this.vAng === this._cachedVAng && this.wAng === this._cachedWAng && this.uRotationCenter === this._cachedURotationCenter && this.vRotationCenter === this._cachedVRotationCenter && this.wRotationCenter === this._cachedWRotationCenter && this.homogeneousRotationInUVTransform === this._cachedHomogeneousRotationInUVTransform) return this._cachedTextureMatrix;
        this._cachedUOffset = this.uOffset;
        this._cachedVOffset = this.vOffset;
        this._cachedUScale = this.uScale * uBase;
        this._cachedVScale = this.vScale;
        this._cachedUAng = this.uAng;
        this._cachedVAng = this.vAng;
        this._cachedWAng = this.wAng;
        this._cachedURotationCenter = this.uRotationCenter;
        this._cachedVRotationCenter = this.vRotationCenter;
        this._cachedWRotationCenter = this.wRotationCenter;
        this._cachedHomogeneousRotationInUVTransform = this.homogeneousRotationInUVTransform;
        if (!this._cachedTextureMatrix || !this._rowGenerationMatrix) {
            this._cachedTextureMatrix = (0, $ha1VO.Matrix).Zero();
            this._rowGenerationMatrix = new (0, $ha1VO.Matrix)();
            this._t0 = (0, $ha1VO.Vector3).Zero();
            this._t1 = (0, $ha1VO.Vector3).Zero();
            this._t2 = (0, $ha1VO.Vector3).Zero();
        }
        (0, $ha1VO.Matrix).RotationYawPitchRollToRef(this.vAng, this.uAng, this.wAng, this._rowGenerationMatrix);
        if (this.homogeneousRotationInUVTransform) {
            (0, $ha1VO.Matrix).TranslationToRef(-this._cachedURotationCenter, -this._cachedVRotationCenter, -this._cachedWRotationCenter, (0, $ha1VO.TmpVectors).Matrix[0]);
            (0, $ha1VO.Matrix).TranslationToRef(this._cachedURotationCenter, this._cachedVRotationCenter, this._cachedWRotationCenter, (0, $ha1VO.TmpVectors).Matrix[1]);
            (0, $ha1VO.Matrix).ScalingToRef(this._cachedUScale, this._cachedVScale, 0, (0, $ha1VO.TmpVectors).Matrix[2]);
            (0, $ha1VO.Matrix).TranslationToRef(this._cachedUOffset, this._cachedVOffset, 0, (0, $ha1VO.TmpVectors).Matrix[3]);
            (0, $ha1VO.TmpVectors).Matrix[0].multiplyToRef(this._rowGenerationMatrix, this._cachedTextureMatrix);
            this._cachedTextureMatrix.multiplyToRef((0, $ha1VO.TmpVectors).Matrix[1], this._cachedTextureMatrix);
            this._cachedTextureMatrix.multiplyToRef((0, $ha1VO.TmpVectors).Matrix[2], this._cachedTextureMatrix);
            this._cachedTextureMatrix.multiplyToRef((0, $ha1VO.TmpVectors).Matrix[3], this._cachedTextureMatrix);
            // copy the translation row to the 3rd row of the matrix so that we don't need to update the shaders (which expects the translation to be on the 3rd row)
            this._cachedTextureMatrix.setRowFromFloats(2, this._cachedTextureMatrix.m[12], this._cachedTextureMatrix.m[13], this._cachedTextureMatrix.m[14], 1);
        } else {
            this._prepareRowForTextureGeneration(0, 0, 0, this._t0);
            this._prepareRowForTextureGeneration(1.0, 0, 0, this._t1);
            this._prepareRowForTextureGeneration(0, 1.0, 0, this._t2);
            this._t1.subtractInPlace(this._t0);
            this._t2.subtractInPlace(this._t0);
            (0, $ha1VO.Matrix).FromValuesToRef(this._t1.x, this._t1.y, this._t1.z, 0.0, this._t2.x, this._t2.y, this._t2.z, 0.0, this._t0.x, this._t0.y, this._t0.z, 0.0, 0.0, 0.0, 0.0, 1.0, this._cachedTextureMatrix);
        }
        const scene = this.getScene();
        if (!scene) return this._cachedTextureMatrix;
        if (this.optimizeUVAllocation) // We flag the materials that are using this texture as "texture dirty" because depending on the fact that the matrix is the identity or not, some defines
        // will get different values (see PrepareDefinesForMergedUV), meaning we should regenerate the effect accordingly
        scene.markAllMaterialsAsDirty(1, (mat)=>{
            return mat.hasTexture(this);
        });
        return this._cachedTextureMatrix;
    }
    /**
     * Get the current matrix used to apply reflection. This is useful to rotate an environment texture for instance.
     * @returns The reflection texture transform
     */ getReflectionTextureMatrix() {
        const scene = this.getScene();
        if (!scene) return this._cachedReflectionTextureMatrix;
        if (this.uOffset === this._cachedReflectionUOffset && this.vOffset === this._cachedReflectionVOffset && this.uScale === this._cachedReflectionUScale && this.vScale === this._cachedReflectionVScale && this.coordinatesMode === this._cachedReflectionCoordinatesMode) {
            if (this.coordinatesMode === $ddc00207ac4a8ab4$export$5431306cf43de24a.PROJECTION_MODE) {
                if (this._cachedReflectionProjectionMatrixId === scene.getProjectionMatrix().updateFlag) return this._cachedReflectionTextureMatrix;
            } else return this._cachedReflectionTextureMatrix;
        }
        if (!this._cachedReflectionTextureMatrix) this._cachedReflectionTextureMatrix = (0, $ha1VO.Matrix).Zero();
        if (!this._projectionModeMatrix) this._projectionModeMatrix = (0, $ha1VO.Matrix).Zero();
        const flagMaterialsAsTextureDirty = this._cachedReflectionCoordinatesMode !== this.coordinatesMode;
        this._cachedReflectionUOffset = this.uOffset;
        this._cachedReflectionVOffset = this.vOffset;
        this._cachedReflectionUScale = this.uScale;
        this._cachedReflectionVScale = this.vScale;
        this._cachedReflectionCoordinatesMode = this.coordinatesMode;
        switch(this.coordinatesMode){
            case $ddc00207ac4a8ab4$export$5431306cf43de24a.PLANAR_MODE:
                (0, $ha1VO.Matrix).IdentityToRef(this._cachedReflectionTextureMatrix);
                this._cachedReflectionTextureMatrix[0] = this.uScale;
                this._cachedReflectionTextureMatrix[5] = this.vScale;
                this._cachedReflectionTextureMatrix[12] = this.uOffset;
                this._cachedReflectionTextureMatrix[13] = this.vOffset;
                break;
            case $ddc00207ac4a8ab4$export$5431306cf43de24a.PROJECTION_MODE:
                {
                    (0, $ha1VO.Matrix).FromValuesToRef(0.5, 0.0, 0.0, 0.0, 0.0, -0.5, 0.0, 0.0, 0.0, 0.0, 0.0, 0.0, 0.5, 0.5, 1.0, 1.0, this._projectionModeMatrix);
                    const projectionMatrix = scene.getProjectionMatrix();
                    this._cachedReflectionProjectionMatrixId = projectionMatrix.updateFlag;
                    projectionMatrix.multiplyToRef(this._projectionModeMatrix, this._cachedReflectionTextureMatrix);
                    break;
                }
            default:
                (0, $ha1VO.Matrix).IdentityToRef(this._cachedReflectionTextureMatrix);
                break;
        }
        if (flagMaterialsAsTextureDirty) // We flag the materials that are using this texture as "texture dirty" if the coordinatesMode has changed.
        // Indeed, this property is used to set the value of some defines used to generate the effect (in material.isReadyForSubMesh), so we must make sure this code will be re-executed and the effect recreated if necessary
        scene.markAllMaterialsAsDirty(1, (mat)=>{
            return mat.hasTexture(this);
        });
        return this._cachedReflectionTextureMatrix;
    }
    /**
     * Clones the texture.
     * @returns the cloned texture
     */ clone() {
        const options = {
            noMipmap: this._noMipmap,
            invertY: this._invertY,
            samplingMode: this.samplingMode,
            onLoad: undefined,
            onError: undefined,
            buffer: this._texture ? this._texture._buffer : undefined,
            deleteBuffer: this._deleteBuffer,
            format: this.textureFormat,
            mimeType: this.mimeType,
            loaderOptions: this._loaderOptions,
            creationFlags: this._creationFlags,
            useSRGBBuffer: this._useSRGBBuffer
        };
        return (0, $6Ho1L.SerializationHelper).Clone(()=>{
            return new $ddc00207ac4a8ab4$export$5431306cf43de24a(this._texture ? this._texture.url : null, this.getScene(), options);
        }, this);
    }
    /**
     * Serialize the texture to a JSON representation we can easily use in the respective Parse function.
     * @returns The JSON representation of the texture
     */ serialize() {
        const savedName = this.name;
        if (!$ddc00207ac4a8ab4$export$5431306cf43de24a.SerializeBuffers) {
            if (this.name.startsWith("data:")) this.name = "";
        }
        if (this.name.startsWith("data:") && this.url === this.name) this.url = "";
        const serializationObject = super.serialize($ddc00207ac4a8ab4$export$5431306cf43de24a._SerializeInternalTextureUniqueId);
        if (!serializationObject) return null;
        if ($ddc00207ac4a8ab4$export$5431306cf43de24a.SerializeBuffers || $ddc00207ac4a8ab4$export$5431306cf43de24a.ForceSerializeBuffers) {
            if (typeof this._buffer === "string" && this._buffer.substr(0, 5) === "data:") {
                serializationObject.base64String = this._buffer;
                serializationObject.name = serializationObject.name.replace("data:", "");
            } else if (this.url && this.url.startsWith("data:") && this._buffer instanceof Uint8Array) serializationObject.base64String = "data:image/png;base64," + (0, $eLv1o.EncodeArrayBufferToBase64)(this._buffer);
            else if ($ddc00207ac4a8ab4$export$5431306cf43de24a.ForceSerializeBuffers || this.url && this.url.startsWith("blob:") || this._forceSerialize) serializationObject.base64String = !this._engine || this._engine._features.supportSyncTextureRead ? (0, $f2kkL.GenerateBase64StringFromTexture)(this) : (0, $f2kkL.GenerateBase64StringFromTextureAsync)(this);
        }
        serializationObject.invertY = this._invertY;
        serializationObject.samplingMode = this.samplingMode;
        serializationObject._creationFlags = this._creationFlags;
        serializationObject._useSRGBBuffer = this._useSRGBBuffer;
        if ($ddc00207ac4a8ab4$export$5431306cf43de24a._SerializeInternalTextureUniqueId) serializationObject.internalTextureUniqueId = this._texture?.uniqueId ?? undefined;
        serializationObject.noMipmap = this._noMipmap;
        this.name = savedName;
        return serializationObject;
    }
    /**
     * Get the current class name of the texture useful for serialization or dynamic coding.
     * @returns "Texture"
     */ getClassName() {
        return "Texture";
    }
    /**
     * Dispose the texture and release its associated resources.
     */ dispose() {
        super.dispose();
        this.onLoadObservable.clear();
        this._delayedOnLoad = null;
        this._delayedOnError = null;
        this._buffer = null;
    }
    /**
     * Parse the JSON representation of a texture in order to recreate the texture in the given scene.
     * @param parsedTexture Define the JSON representation of the texture
     * @param scene Define the scene the parsed texture should be instantiated in
     * @param rootUrl Define the root url of the parsing sequence in the case of relative dependencies
     * @returns The parsed texture if successful
     */ static Parse(parsedTexture, scene, rootUrl) {
        if (parsedTexture.customType) {
            const customTexture = (0, $i1moY.InstantiationTools).Instantiate(parsedTexture.customType);
            // Update Sampling Mode
            const parsedCustomTexture = customTexture.Parse(parsedTexture, scene, rootUrl);
            if (parsedTexture.samplingMode && parsedCustomTexture.updateSamplingMode && parsedCustomTexture._samplingMode) {
                if (parsedCustomTexture._samplingMode !== parsedTexture.samplingMode) parsedCustomTexture.updateSamplingMode(parsedTexture.samplingMode);
            }
            return parsedCustomTexture;
        }
        if (parsedTexture.isCube && !parsedTexture.isRenderTarget) return $ddc00207ac4a8ab4$export$5431306cf43de24a._CubeTextureParser(parsedTexture, scene, rootUrl);
        const hasInternalTextureUniqueId = parsedTexture.internalTextureUniqueId !== undefined;
        if (!parsedTexture.name && !parsedTexture.isRenderTarget && !hasInternalTextureUniqueId) return null;
        let internalTexture;
        if (hasInternalTextureUniqueId) {
            const cache = scene.getEngine().getLoadedTexturesCache();
            for (const texture of cache)if (texture.uniqueId === parsedTexture.internalTextureUniqueId) {
                internalTexture = texture;
                break;
            }
        }
        const onLoaded = (texture)=>{
            // Clear cache
            if (texture && texture._texture) {
                texture._texture._cachedWrapU = null;
                texture._texture._cachedWrapV = null;
                texture._texture._cachedWrapR = null;
            }
            // Update Sampling Mode
            if (parsedTexture.samplingMode) {
                const sampling = parsedTexture.samplingMode;
                if (texture && texture.samplingMode !== sampling) texture.updateSamplingMode(sampling);
            }
            // Animations
            if (texture && parsedTexture.animations) for(let animationIndex = 0; animationIndex < parsedTexture.animations.length; animationIndex++){
                const parsedAnimation = parsedTexture.animations[animationIndex];
                const internalClass = (0, $8DoUR.GetClass)("BABYLON.Animation");
                if (internalClass) texture.animations.push(internalClass.Parse(parsedAnimation));
            }
            if (hasInternalTextureUniqueId && !internalTexture) texture?._texture?._setUniqueId(parsedTexture.internalTextureUniqueId);
        };
        const texture = (0, $6Ho1L.SerializationHelper).Parse(()=>{
            let generateMipMaps = true;
            if (parsedTexture.noMipmap) generateMipMaps = false;
            if (parsedTexture.mirrorPlane) {
                const mirrorTexture = $ddc00207ac4a8ab4$export$5431306cf43de24a._CreateMirror(parsedTexture.name, parsedTexture.renderTargetSize, scene, generateMipMaps);
                mirrorTexture._waitingRenderList = parsedTexture.renderList;
                mirrorTexture.mirrorPlane = (0, $23POp.Plane).FromArray(parsedTexture.mirrorPlane);
                onLoaded(mirrorTexture);
                return mirrorTexture;
            } else if (parsedTexture.isRenderTarget) {
                let renderTargetTexture = null;
                if (parsedTexture.isCube) {
                    // Search for an existing reflection probe (which contains a cube render target texture)
                    if (scene.reflectionProbes) for(let index = 0; index < scene.reflectionProbes.length; index++){
                        const probe = scene.reflectionProbes[index];
                        if (probe.name === parsedTexture.name) return probe.cubeTexture;
                    }
                } else {
                    renderTargetTexture = $ddc00207ac4a8ab4$export$5431306cf43de24a._CreateRenderTargetTexture(parsedTexture.name, parsedTexture.renderTargetSize, scene, generateMipMaps, parsedTexture._creationFlags ?? 0);
                    renderTargetTexture._waitingRenderList = parsedTexture.renderList;
                }
                onLoaded(renderTargetTexture);
                return renderTargetTexture;
            } else if (parsedTexture.isVideo) {
                const texture = $ddc00207ac4a8ab4$export$5431306cf43de24a._CreateVideoTexture(rootUrl + (parsedTexture.url || parsedTexture.name), rootUrl + (parsedTexture.src || parsedTexture.url), scene, generateMipMaps, parsedTexture.invertY, parsedTexture.samplingMode, parsedTexture.settings || {});
                onLoaded(texture);
                return texture;
            } else {
                let texture;
                if (parsedTexture.base64String && !internalTexture) {
                    // name and url are the same to ensure caching happens from the actual base64 string
                    texture = $ddc00207ac4a8ab4$export$5431306cf43de24a.CreateFromBase64String(parsedTexture.base64String, parsedTexture.base64String, scene, !generateMipMaps, parsedTexture.invertY, parsedTexture.samplingMode, ()=>{
                        onLoaded(texture);
                    }, parsedTexture._creationFlags ?? 0, parsedTexture._useSRGBBuffer ?? false);
                    // prettier name to fit with the loaded data
                    texture.name = parsedTexture.name;
                } else {
                    let url;
                    if (parsedTexture.name && (parsedTexture.name.indexOf("://") > 0 || parsedTexture.name.startsWith("data:"))) url = parsedTexture.name;
                    else url = rootUrl + parsedTexture.name;
                    if (parsedTexture.url && (parsedTexture.url.startsWith("data:") || $ddc00207ac4a8ab4$export$5431306cf43de24a.UseSerializedUrlIfAny)) url = parsedTexture.url;
                    const options = {
                        noMipmap: !generateMipMaps,
                        invertY: parsedTexture.invertY,
                        samplingMode: parsedTexture.samplingMode,
                        onLoad: ()=>{
                            onLoaded(texture);
                        },
                        internalTexture: internalTexture
                    };
                    texture = new $ddc00207ac4a8ab4$export$5431306cf43de24a(url, scene, options);
                }
                return texture;
            }
        }, parsedTexture, scene);
        return texture;
    }
    /**
     * Creates a texture from its base 64 representation.
     * @param data Define the base64 payload without the data: prefix
     * @param name Define the name of the texture in the scene useful fo caching purpose for instance
     * @param scene Define the scene the texture should belong to
     * @param noMipmapOrOptions defines if the texture will require mip maps or not or set of all options to create the texture
     * @param invertY define if the texture needs to be inverted on the y axis during loading
     * @param samplingMode define the sampling mode we want for the texture while fetching from it (Texture.NEAREST_SAMPLINGMODE...)
     * @param onLoad define a callback triggered when the texture has been loaded
     * @param onError define a callback triggered when an error occurred during the loading session
     * @param format define the format of the texture we are trying to load (Engine.TEXTUREFORMAT_RGBA...)
     * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
     * @returns the created texture
     */ static CreateFromBase64String(data, name, scene, noMipmapOrOptions, invertY, samplingMode = $ddc00207ac4a8ab4$export$5431306cf43de24a.TRILINEAR_SAMPLINGMODE, onLoad = null, onError = null, format = 5, creationFlags) {
        return new $ddc00207ac4a8ab4$export$5431306cf43de24a("data:" + name, scene, noMipmapOrOptions, invertY, samplingMode, onLoad, onError, data, false, format, undefined, undefined, creationFlags);
    }
    /**
     * Creates a texture from its data: representation. (data: will be added in case only the payload has been passed in)
     * @param name Define the name of the texture in the scene useful fo caching purpose for instance
     * @param buffer define the buffer to load the texture from in case the texture is loaded from a buffer representation
     * @param scene Define the scene the texture should belong to
     * @param deleteBuffer define if the buffer we are loading the texture from should be deleted after load
     * @param noMipmapOrOptions defines if the texture will require mip maps or not or set of all options to create the texture
     * @param invertY define if the texture needs to be inverted on the y axis during loading
     * @param samplingMode define the sampling mode we want for the texture while fetching from it (Texture.NEAREST_SAMPLINGMODE...)
     * @param onLoad define a callback triggered when the texture has been loaded
     * @param onError define a callback triggered when an error occurred during the loading session
     * @param format define the format of the texture we are trying to load (Engine.TEXTUREFORMAT_RGBA...)
     * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
     * @returns the created texture
     */ static LoadFromDataString(name, buffer, scene, deleteBuffer = false, noMipmapOrOptions, invertY = true, samplingMode = $ddc00207ac4a8ab4$export$5431306cf43de24a.TRILINEAR_SAMPLINGMODE, onLoad = null, onError = null, format = 5, creationFlags) {
        if (name.substr(0, 5) !== "data:") name = "data:" + name;
        return new $ddc00207ac4a8ab4$export$5431306cf43de24a(name, scene, noMipmapOrOptions, invertY, samplingMode, onLoad, onError, buffer, deleteBuffer, format, undefined, undefined, creationFlags);
    }
}
/**
 * Gets or sets a general boolean used to indicate that textures containing direct data (buffers) must be saved as part of the serialization process
 */ $ddc00207ac4a8ab4$export$5431306cf43de24a.SerializeBuffers = true;
/**
 * Gets or sets a general boolean used to indicate that texture buffers must be saved as part of the serialization process.
 * If no buffer exists, one will be created as base64 string from the internal webgl data.
 */ $ddc00207ac4a8ab4$export$5431306cf43de24a.ForceSerializeBuffers = false;
/**
 * This observable will notify when any texture had a loading error
 */ $ddc00207ac4a8ab4$export$5431306cf43de24a.OnTextureLoadErrorObservable = new (0, $diGQf.Observable)();
/** @internal */ $ddc00207ac4a8ab4$export$5431306cf43de24a._SerializeInternalTextureUniqueId = false;
/**
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
$ddc00207ac4a8ab4$export$5431306cf43de24a._CubeTextureParser = (jsonTexture, scene, rootUrl)=>{
    throw (0, $dUFYy._WarnImport)("CubeTexture");
};
/**
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
$ddc00207ac4a8ab4$export$5431306cf43de24a._CreateMirror = (name, renderTargetSize, scene, generateMipMaps)=>{
    throw (0, $dUFYy._WarnImport)("MirrorTexture");
};
/**
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
$ddc00207ac4a8ab4$export$5431306cf43de24a._CreateRenderTargetTexture = (name, renderTargetSize, scene, generateMipMaps, creationFlags)=>{
    throw (0, $dUFYy._WarnImport)("RenderTargetTexture");
};
/** nearest is mag = nearest and min = nearest and no mip */ $ddc00207ac4a8ab4$export$5431306cf43de24a.NEAREST_SAMPLINGMODE = 1;
/** nearest is mag = nearest and min = nearest and mip = linear */ $ddc00207ac4a8ab4$export$5431306cf43de24a.NEAREST_NEAREST_MIPLINEAR = 8; // nearest is mag = nearest and min = nearest and mip = linear
/** Bilinear is mag = linear and min = linear and no mip */ $ddc00207ac4a8ab4$export$5431306cf43de24a.BILINEAR_SAMPLINGMODE = 2;
/** Bilinear is mag = linear and min = linear and mip = nearest */ $ddc00207ac4a8ab4$export$5431306cf43de24a.LINEAR_LINEAR_MIPNEAREST = 11; // Bilinear is mag = linear and min = linear and mip = nearest
/** Trilinear is mag = linear and min = linear and mip = linear */ $ddc00207ac4a8ab4$export$5431306cf43de24a.TRILINEAR_SAMPLINGMODE = 3;
/** Trilinear is mag = linear and min = linear and mip = linear */ $ddc00207ac4a8ab4$export$5431306cf43de24a.LINEAR_LINEAR_MIPLINEAR = 3; // Trilinear is mag = linear and min = linear and mip = linear
/** mag = nearest and min = nearest and mip = nearest */ $ddc00207ac4a8ab4$export$5431306cf43de24a.NEAREST_NEAREST_MIPNEAREST = 4;
/** mag = nearest and min = linear and mip = nearest */ $ddc00207ac4a8ab4$export$5431306cf43de24a.NEAREST_LINEAR_MIPNEAREST = 5;
/** mag = nearest and min = linear and mip = linear */ $ddc00207ac4a8ab4$export$5431306cf43de24a.NEAREST_LINEAR_MIPLINEAR = 6;
/** mag = nearest and min = linear and mip = none */ $ddc00207ac4a8ab4$export$5431306cf43de24a.NEAREST_LINEAR = 7;
/** mag = nearest and min = nearest and mip = none */ $ddc00207ac4a8ab4$export$5431306cf43de24a.NEAREST_NEAREST = 1;
/** mag = linear and min = nearest and mip = nearest */ $ddc00207ac4a8ab4$export$5431306cf43de24a.LINEAR_NEAREST_MIPNEAREST = 9;
/** mag = linear and min = nearest and mip = linear */ $ddc00207ac4a8ab4$export$5431306cf43de24a.LINEAR_NEAREST_MIPLINEAR = 10;
/** mag = linear and min = linear and mip = none */ $ddc00207ac4a8ab4$export$5431306cf43de24a.LINEAR_LINEAR = 2;
/** mag = linear and min = nearest and mip = none */ $ddc00207ac4a8ab4$export$5431306cf43de24a.LINEAR_NEAREST = 12;
/** Explicit coordinates mode */ $ddc00207ac4a8ab4$export$5431306cf43de24a.EXPLICIT_MODE = 0;
/** Spherical coordinates mode */ $ddc00207ac4a8ab4$export$5431306cf43de24a.SPHERICAL_MODE = 1;
/** Planar coordinates mode */ $ddc00207ac4a8ab4$export$5431306cf43de24a.PLANAR_MODE = 2;
/** Cubic coordinates mode */ $ddc00207ac4a8ab4$export$5431306cf43de24a.CUBIC_MODE = 3;
/** Projection coordinates mode */ $ddc00207ac4a8ab4$export$5431306cf43de24a.PROJECTION_MODE = 4;
/** Inverse Cubic coordinates mode */ $ddc00207ac4a8ab4$export$5431306cf43de24a.SKYBOX_MODE = 5;
/** Inverse Cubic coordinates mode */ $ddc00207ac4a8ab4$export$5431306cf43de24a.INVCUBIC_MODE = 6;
/** Equirectangular coordinates mode */ $ddc00207ac4a8ab4$export$5431306cf43de24a.EQUIRECTANGULAR_MODE = 7;
/** Equirectangular Fixed coordinates mode */ $ddc00207ac4a8ab4$export$5431306cf43de24a.FIXED_EQUIRECTANGULAR_MODE = 8;
/** Equirectangular Fixed Mirrored coordinates mode */ $ddc00207ac4a8ab4$export$5431306cf43de24a.FIXED_EQUIRECTANGULAR_MIRRORED_MODE = 9;
/** Texture is not repeating outside of 0..1 UVs */ $ddc00207ac4a8ab4$export$5431306cf43de24a.CLAMP_ADDRESSMODE = 0;
/** Texture is repeating outside of 0..1 UVs */ $ddc00207ac4a8ab4$export$5431306cf43de24a.WRAP_ADDRESSMODE = 1;
/** Texture is repeating and mirrored */ $ddc00207ac4a8ab4$export$5431306cf43de24a.MIRROR_ADDRESSMODE = 2;
/**
 * Gets or sets a boolean which defines if the texture url must be build from the serialized URL instead of just using the name and loading them side by side with the scene file
 */ $ddc00207ac4a8ab4$export$5431306cf43de24a.UseSerializedUrlIfAny = false;
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ddc00207ac4a8ab4$export$5431306cf43de24a.prototype, "url", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ddc00207ac4a8ab4$export$5431306cf43de24a.prototype, "uOffset", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ddc00207ac4a8ab4$export$5431306cf43de24a.prototype, "vOffset", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ddc00207ac4a8ab4$export$5431306cf43de24a.prototype, "uScale", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ddc00207ac4a8ab4$export$5431306cf43de24a.prototype, "vScale", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ddc00207ac4a8ab4$export$5431306cf43de24a.prototype, "uAng", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ddc00207ac4a8ab4$export$5431306cf43de24a.prototype, "vAng", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ddc00207ac4a8ab4$export$5431306cf43de24a.prototype, "wAng", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ddc00207ac4a8ab4$export$5431306cf43de24a.prototype, "uRotationCenter", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ddc00207ac4a8ab4$export$5431306cf43de24a.prototype, "vRotationCenter", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ddc00207ac4a8ab4$export$5431306cf43de24a.prototype, "wRotationCenter", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ddc00207ac4a8ab4$export$5431306cf43de24a.prototype, "homogeneousRotationInUVTransform", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ddc00207ac4a8ab4$export$5431306cf43de24a.prototype, "isBlocking", null);
// References the dependencies.
(0, $8DoUR.RegisterClass)("BABYLON.Texture", $ddc00207ac4a8ab4$export$5431306cf43de24a);
(0, $6Ho1L.SerializationHelper)._TextureParser = $ddc00207ac4a8ab4$export$5431306cf43de24a.Parse;

});
parcelRegister("akOl3", function(module, exports) {

$parcel$export(module.exports, "BaseTexture", () => $7862d1d2c5fb3cf3$export$d6306e508f184154);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $ejQPp = parcelRequire("ejQPp");

var $321Uk = parcelRequire("321Uk");
parcelRequire("EOxw7");

var $jyMMC = parcelRequire("jyMMC");

var $6Ho1L = parcelRequire("6Ho1L");
class $7862d1d2c5fb3cf3$export$d6306e508f184154 extends (0, $jyMMC.ThinTexture) {
    /**
     * Define if the texture is having a usable alpha value (can be use for transparency or glossiness for instance).
     */ set hasAlpha(value) {
        if (this._hasAlpha === value) return;
        this._hasAlpha = value;
        if (this._scene) this._scene.markAllMaterialsAsDirty(1, (mat)=>{
            return mat.hasTexture(this);
        });
    }
    get hasAlpha() {
        return this._hasAlpha;
    }
    /**
     * Defines if the alpha value should be determined via the rgb values.
     * If true the luminance of the pixel might be used to find the corresponding alpha value.
     */ set getAlphaFromRGB(value) {
        if (this._getAlphaFromRGB === value) return;
        this._getAlphaFromRGB = value;
        if (this._scene) this._scene.markAllMaterialsAsDirty(1, (mat)=>{
            return mat.hasTexture(this);
        });
    }
    get getAlphaFromRGB() {
        return this._getAlphaFromRGB;
    }
    /**
     * Define the UV channel to use starting from 0 and defaulting to 0.
     * This is part of the texture as textures usually maps to one uv set.
     */ set coordinatesIndex(value) {
        if (this._coordinatesIndex === value) return;
        this._coordinatesIndex = value;
        if (this._scene) this._scene.markAllMaterialsAsDirty(1, (mat)=>{
            return mat.hasTexture(this);
        });
    }
    get coordinatesIndex() {
        return this._coordinatesIndex;
    }
    /**
     * How a texture is mapped.
     *
     * | Value | Type                                | Description |
     * | ----- | ----------------------------------- | ----------- |
     * | 0     | EXPLICIT_MODE                       |             |
     * | 1     | SPHERICAL_MODE                      |             |
     * | 2     | PLANAR_MODE                         |             |
     * | 3     | CUBIC_MODE                          |             |
     * | 4     | PROJECTION_MODE                     |             |
     * | 5     | SKYBOX_MODE                         |             |
     * | 6     | INVCUBIC_MODE                       |             |
     * | 7     | EQUIRECTANGULAR_MODE                |             |
     * | 8     | FIXED_EQUIRECTANGULAR_MODE          |             |
     * | 9     | FIXED_EQUIRECTANGULAR_MIRRORED_MODE |             |
     */ set coordinatesMode(value) {
        if (this._coordinatesMode === value) return;
        this._coordinatesMode = value;
        if (this._scene) this._scene.markAllMaterialsAsDirty(1, (mat)=>{
            return mat.hasTexture(this);
        });
    }
    get coordinatesMode() {
        return this._coordinatesMode;
    }
    /**
     * | Value | Type               | Description |
     * | ----- | ------------------ | ----------- |
     * | 0     | CLAMP_ADDRESSMODE  |             |
     * | 1     | WRAP_ADDRESSMODE   |             |
     * | 2     | MIRROR_ADDRESSMODE |             |
     */ get wrapU() {
        return this._wrapU;
    }
    set wrapU(value) {
        this._wrapU = value;
    }
    /**
     * | Value | Type               | Description |
     * | ----- | ------------------ | ----------- |
     * | 0     | CLAMP_ADDRESSMODE  |             |
     * | 1     | WRAP_ADDRESSMODE   |             |
     * | 2     | MIRROR_ADDRESSMODE |             |
     */ get wrapV() {
        return this._wrapV;
    }
    set wrapV(value) {
        this._wrapV = value;
    }
    /**
     * Define if the texture is a cube texture or if false a 2d texture.
     */ get isCube() {
        if (!this._texture) return this._isCube;
        return this._texture.isCube;
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    set isCube(value) {
        if (!this._texture) this._isCube = value;
        else this._texture.isCube = value;
    }
    /**
     * Define if the texture is a 3d texture (webgl 2) or if false a 2d texture.
     */ get is3D() {
        if (!this._texture) return false;
        return this._texture.is3D;
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    set is3D(value) {
        if (!this._texture) return;
        this._texture.is3D = value;
    }
    /**
     * Define if the texture is a 2d array texture (webgl 2) or if false a 2d texture.
     */ get is2DArray() {
        if (!this._texture) return false;
        return this._texture.is2DArray;
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    set is2DArray(value) {
        if (!this._texture) return;
        this._texture.is2DArray = value;
    }
    /**
     * Define if the texture contains data in gamma space (most of the png/jpg aside bump).
     * HDR texture are usually stored in linear space.
     * This only impacts the PBR and Background materials
     */ get gammaSpace() {
        if (!this._texture) return this._gammaSpace;
        else if (this._texture._gammaSpace === null) this._texture._gammaSpace = this._gammaSpace;
        return this._texture._gammaSpace && !this._texture._useSRGBBuffer;
    }
    set gammaSpace(gamma) {
        if (!this._texture) {
            if (this._gammaSpace === gamma) return;
            this._gammaSpace = gamma;
        } else {
            if (this._texture._gammaSpace === gamma) return;
            this._texture._gammaSpace = gamma;
        }
        this.getScene()?.markAllMaterialsAsDirty(1, (mat)=>{
            return mat.hasTexture(this);
        });
    }
    /**
     * Gets or sets whether or not the texture contains RGBD data.
     */ get isRGBD() {
        return this._texture != null && this._texture._isRGBD;
    }
    set isRGBD(value) {
        if (value === this.isRGBD) return;
        if (this._texture) this._texture._isRGBD = value;
        this.getScene()?.markAllMaterialsAsDirty(1, (mat)=>{
            return mat.hasTexture(this);
        });
    }
    /**
     * Are mip maps generated for this texture or not.
     */ get noMipmap() {
        return false;
    }
    /**
     * With prefiltered texture, defined the offset used during the prefiltering steps.
     */ get lodGenerationOffset() {
        if (this._texture) return this._texture._lodGenerationOffset;
        return 0.0;
    }
    set lodGenerationOffset(value) {
        if (this._texture) this._texture._lodGenerationOffset = value;
    }
    /**
     * With prefiltered texture, defined the scale used during the prefiltering steps.
     */ get lodGenerationScale() {
        if (this._texture) return this._texture._lodGenerationScale;
        return 0.0;
    }
    set lodGenerationScale(value) {
        if (this._texture) this._texture._lodGenerationScale = value;
    }
    /**
     * With prefiltered texture, defined if the specular generation is based on a linear ramp.
     * By default we are using a log2 of the linear roughness helping to keep a better resolution for
     * average roughness values.
     */ get linearSpecularLOD() {
        if (this._texture) return this._texture._linearSpecularLOD;
        return false;
    }
    set linearSpecularLOD(value) {
        if (this._texture) this._texture._linearSpecularLOD = value;
    }
    /**
     * In case a better definition than spherical harmonics is required for the diffuse part of the environment.
     * You can set the irradiance texture to rely on a texture instead of the spherical approach.
     * This texture need to have the same characteristics than its parent (Cube vs 2d, coordinates mode, Gamma/Linear, RGBD).
     */ get irradianceTexture() {
        if (this._texture) return this._texture._irradianceTexture;
        return null;
    }
    set irradianceTexture(value) {
        if (this._texture) this._texture._irradianceTexture = value;
    }
    /**
     * Define the unique id of the texture in the scene.
     */ get uid() {
        if (!this._uid) this._uid = (0, $321Uk.RandomGUID)();
        return this._uid;
    }
    /**
     * Return a string representation of the texture.
     * @returns the texture as a string
     */ toString() {
        return this.name;
    }
    /**
     * Get the class name of the texture.
     * @returns "BaseTexture"
     */ getClassName() {
        return "BaseTexture";
    }
    /**
     * Callback triggered when the texture has been disposed.
     * Kept for back compatibility, you can use the onDisposeObservable instead.
     */ set onDispose(callback) {
        if (this._onDisposeObserver) this.onDisposeObservable.remove(this._onDisposeObserver);
        this._onDisposeObserver = this.onDisposeObservable.add(callback);
    }
    /**
     * Define if the texture is preventing a material to render or not.
     * If not and the texture is not ready, the engine will use a default black texture instead.
     */ get isBlocking() {
        return true;
    }
    /**
     * Was there any loading error?
     */ get loadingError() {
        return this._loadingError;
    }
    /**
     * If a loading error occurred this object will be populated with information about the error.
     */ get errorObject() {
        return this._errorObject;
    }
    /**
     * Instantiates a new BaseTexture.
     * Base class of all the textures in babylon.
     * It groups all the common properties the materials, post process, lights... might need
     * in order to make a correct use of the texture.
     * @param sceneOrEngine Define the scene or engine the texture belongs to
     * @param internalTexture Define the internal texture associated with the texture
     */ constructor(sceneOrEngine, internalTexture = null){
        super(null);
        /**
         * Gets or sets an object used to store user defined information.
         */ this.metadata = null;
        /**
         * For internal use only. Please do not use.
         */ this.reservedDataStore = null;
        this._hasAlpha = false;
        this._getAlphaFromRGB = false;
        /**
         * Intensity or strength of the texture.
         * It is commonly used by materials to fine tune the intensity of the texture
         */ this.level = 1;
        this._coordinatesIndex = 0;
        /**
         * Gets or sets a boolean indicating that the texture should try to reduce shader code if there is no UV manipulation.
         * (ie. when texture.getTextureMatrix().isIdentityAs3x2() returns true)
         */ this.optimizeUVAllocation = true;
        this._coordinatesMode = 0;
        /**
         * | Value | Type               | Description |
         * | ----- | ------------------ | ----------- |
         * | 0     | CLAMP_ADDRESSMODE  |             |
         * | 1     | WRAP_ADDRESSMODE   |             |
         * | 2     | MIRROR_ADDRESSMODE |             |
         */ this.wrapR = 1;
        /**
         * With compliant hardware and browser (supporting anisotropic filtering)
         * this defines the level of anisotropic filtering in the texture.
         * The higher the better but the slower. This defaults to 4 as it seems to be the best tradeoff.
         */ this.anisotropicFilteringLevel = $7862d1d2c5fb3cf3$export$d6306e508f184154.DEFAULT_ANISOTROPIC_FILTERING_LEVEL;
        /** @internal */ this._isCube = false;
        /** @internal */ this._gammaSpace = true;
        /**
         * Is Z inverted in the texture (useful in a cube texture).
         */ this.invertZ = false;
        /**
         * @internal
         */ this.lodLevelInAlpha = false;
        /**
         * Define if the texture is a render target.
         */ this.isRenderTarget = false;
        /** @internal */ this._prefiltered = false;
        /** @internal */ this._forceSerialize = false;
        /**
         * Define the list of animation attached to the texture.
         */ this.animations = [];
        /**
         * An event triggered when the texture is disposed.
         */ this.onDisposeObservable = new (0, $diGQf.Observable)();
        this._onDisposeObserver = null;
        this._scene = null;
        /** @internal */ this._uid = null;
        /** @internal */ this._parentContainer = null;
        this._loadingError = false;
        if (sceneOrEngine) {
            if ($7862d1d2c5fb3cf3$export$d6306e508f184154._IsScene(sceneOrEngine)) this._scene = sceneOrEngine;
            else this._engine = sceneOrEngine;
        } else this._scene = (0, $ejQPp.EngineStore).LastCreatedScene;
        if (this._scene) {
            this.uniqueId = this._scene.getUniqueId();
            this._scene.addTexture(this);
            this._engine = this._scene.getEngine();
        }
        this._texture = internalTexture;
        this._uid = null;
    }
    /**
     * Get the scene the texture belongs to.
     * @returns the scene or null if undefined
     */ getScene() {
        return this._scene;
    }
    /** @internal */ _getEngine() {
        return this._engine;
    }
    /**
     * Checks if the texture has the same transform matrix than another texture
     * @param texture texture to check against
     * @returns true if the transforms are the same, else false
     */ checkTransformsAreIdentical(texture) {
        return texture !== null;
    }
    /**
     * Get the texture transform matrix used to offset tile the texture for instance.
     * @returns the transformation matrix
     */ getTextureMatrix() {
        return (0, $ha1VO.Matrix).IdentityReadOnly;
    }
    /**
     * Get the texture reflection matrix used to rotate/transform the reflection.
     * @returns the reflection matrix
     */ getReflectionTextureMatrix() {
        return (0, $ha1VO.Matrix).IdentityReadOnly;
    }
    /**
     * Gets a suitable rotate/transform matrix when the texture is used for refraction.
     * There's a separate function from getReflectionTextureMatrix because refraction requires a special configuration of the matrix in right-handed mode.
     * @returns The refraction matrix
     */ getRefractionTextureMatrix() {
        return this.getReflectionTextureMatrix();
    }
    /**
     * Get if the texture is ready to be consumed (either it is ready or it is not blocking)
     * @returns true if ready, not blocking or if there was an error loading the texture
     */ isReadyOrNotBlocking() {
        return !this.isBlocking || this.isReady() || this.loadingError;
    }
    /**
     * Scales the texture if is `canRescale()`
     * @param ratio the resize factor we want to use to rescale
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    scale(ratio) {}
    /**
     * Get if the texture can rescale.
     */ get canRescale() {
        return false;
    }
    /**
     * @internal
     */ _getFromCache(url, noMipmap, sampling, invertY, useSRGBBuffer, isCube) {
        const engine = this._getEngine();
        if (!engine) return null;
        const correctedUseSRGBBuffer = engine._getUseSRGBBuffer(!!useSRGBBuffer, noMipmap);
        const texturesCache = engine.getLoadedTexturesCache();
        for(let index = 0; index < texturesCache.length; index++){
            const texturesCacheEntry = texturesCache[index];
            if (useSRGBBuffer === undefined || correctedUseSRGBBuffer === texturesCacheEntry._useSRGBBuffer) {
                if (invertY === undefined || invertY === texturesCacheEntry.invertY) {
                    if (texturesCacheEntry.url === url && texturesCacheEntry.generateMipMaps === !noMipmap) {
                        if (!sampling || sampling === texturesCacheEntry.samplingMode) {
                            if (isCube === undefined || isCube === texturesCacheEntry.isCube) {
                                texturesCacheEntry.incrementReferences();
                                return texturesCacheEntry;
                            }
                        }
                    }
                }
            }
        }
        return null;
    }
    /** @internal */ _rebuild(_fromContextLost = false) {}
    /**
     * Clones the texture.
     * @returns the cloned texture
     */ clone() {
        return null;
    }
    /**
     * Get the texture underlying type (INT, FLOAT...)
     */ get textureType() {
        if (!this._texture) return 0;
        return this._texture.type !== undefined ? this._texture.type : 0;
    }
    /**
     * Get the texture underlying format (RGB, RGBA...)
     */ get textureFormat() {
        if (!this._texture) return 5;
        return this._texture.format !== undefined ? this._texture.format : 5;
    }
    /**
     * Indicates that textures need to be re-calculated for all materials
     */ _markAllSubMeshesAsTexturesDirty() {
        const scene = this.getScene();
        if (!scene) return;
        scene.markAllMaterialsAsDirty(1);
    }
    /**
     * Reads the pixels stored in the webgl texture and returns them as an ArrayBuffer.
     * This will returns an RGBA array buffer containing either in values (0-255) or
     * float values (0-1) depending of the underlying buffer type.
     * @param faceIndex defines the face of the texture to read (in case of cube texture)
     * @param level defines the LOD level of the texture to read (in case of Mip Maps)
     * @param buffer defines a user defined buffer to fill with data (can be null)
     * @param flushRenderer true to flush the renderer from the pending commands before reading the pixels
     * @param noDataConversion false to convert the data to Uint8Array (if texture type is UNSIGNED_BYTE) or to Float32Array (if texture type is anything but UNSIGNED_BYTE). If true, the type of the generated buffer (if buffer==null) will depend on the type of the texture
     * @param x defines the region x coordinates to start reading from (default to 0)
     * @param y defines the region y coordinates to start reading from (default to 0)
     * @param width defines the region width to read from (default to the texture size at level)
     * @param height defines the region width to read from (default to the texture size at level)
     * @returns The Array buffer promise containing the pixels data.
     */ readPixels(faceIndex = 0, level = 0, buffer = null, flushRenderer = true, noDataConversion = false, x = 0, y = 0, width = Number.MAX_VALUE, height = Number.MAX_VALUE) {
        if (!this._texture) return null;
        const engine = this._getEngine();
        if (!engine) return null;
        const size = this.getSize();
        let maxWidth = size.width;
        let maxHeight = size.height;
        if (level !== 0) {
            maxWidth = maxWidth / Math.pow(2, level);
            maxHeight = maxHeight / Math.pow(2, level);
            maxWidth = Math.round(maxWidth);
            maxHeight = Math.round(maxHeight);
        }
        width = Math.min(maxWidth, width);
        height = Math.min(maxHeight, height);
        try {
            if (this._texture.isCube) return engine._readTexturePixels(this._texture, width, height, faceIndex, level, buffer, flushRenderer, noDataConversion, x, y);
            return engine._readTexturePixels(this._texture, width, height, -1, level, buffer, flushRenderer, noDataConversion, x, y);
        } catch (e) {
            return null;
        }
    }
    /**
     * @internal
     */ _readPixelsSync(faceIndex = 0, level = 0, buffer = null, flushRenderer = true, noDataConversion = false) {
        if (!this._texture) return null;
        const size = this.getSize();
        let width = size.width;
        let height = size.height;
        const engine = this._getEngine();
        if (!engine) return null;
        if (level != 0) {
            width = width / Math.pow(2, level);
            height = height / Math.pow(2, level);
            width = Math.round(width);
            height = Math.round(height);
        }
        try {
            if (this._texture.isCube) return engine._readTexturePixelsSync(this._texture, width, height, faceIndex, level, buffer, flushRenderer, noDataConversion);
            return engine._readTexturePixelsSync(this._texture, width, height, -1, level, buffer, flushRenderer, noDataConversion);
        } catch (e) {
            return null;
        }
    }
    /** @internal */ get _lodTextureHigh() {
        if (this._texture) return this._texture._lodTextureHigh;
        return null;
    }
    /** @internal */ get _lodTextureMid() {
        if (this._texture) return this._texture._lodTextureMid;
        return null;
    }
    /** @internal */ get _lodTextureLow() {
        if (this._texture) return this._texture._lodTextureLow;
        return null;
    }
    /**
     * Dispose the texture and release its associated resources.
     */ dispose() {
        if (this._scene) {
            // Animations
            if (this._scene.stopAnimation) this._scene.stopAnimation(this);
            // Remove from scene
            this._scene.removePendingData(this);
            const index = this._scene.textures.indexOf(this);
            if (index >= 0) this._scene.textures.splice(index, 1);
            this._scene.onTextureRemovedObservable.notifyObservers(this);
            this._scene = null;
            if (this._parentContainer) {
                const index = this._parentContainer.textures.indexOf(this);
                if (index > -1) this._parentContainer.textures.splice(index, 1);
                this._parentContainer = null;
            }
        }
        // Callback
        this.onDisposeObservable.notifyObservers(this);
        this.onDisposeObservable.clear();
        this.metadata = null;
        super.dispose();
    }
    /**
     * Serialize the texture into a JSON representation that can be parsed later on.
     * @param allowEmptyName True to force serialization even if name is empty. Default: false
     * @returns the JSON representation of the texture
     */ serialize(allowEmptyName = false) {
        if (!this.name && !allowEmptyName) return null;
        const serializationObject = (0, $6Ho1L.SerializationHelper).Serialize(this);
        // Animations
        (0, $6Ho1L.SerializationHelper).AppendSerializedAnimations(this, serializationObject);
        return serializationObject;
    }
    /**
     * Helper function to be called back once a list of texture contains only ready textures.
     * @param textures Define the list of textures to wait for
     * @param callback Define the callback triggered once the entire list will be ready
     */ static WhenAllReady(textures, callback) {
        let numRemaining = textures.length;
        if (numRemaining === 0) {
            callback();
            return;
        }
        for(let i = 0; i < textures.length; i++){
            const texture = textures[i];
            if (texture.isReady()) {
                if (--numRemaining === 0) callback();
            } else {
                const onLoadObservable = texture.onLoadObservable;
                if (onLoadObservable) onLoadObservable.addOnce(()=>{
                    if (--numRemaining === 0) callback();
                });
                else if (--numRemaining === 0) callback();
            }
        }
    }
    static _IsScene(sceneOrEngine) {
        return sceneOrEngine.getClassName() === "Scene";
    }
}
/**
 * Default anisotropic filtering level for the application.
 * It is set to 4 as a good tradeoff between perf and quality.
 */ $7862d1d2c5fb3cf3$export$d6306e508f184154.DEFAULT_ANISOTROPIC_FILTERING_LEVEL = 4;
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "uniqueId", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "name", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "metadata", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("hasAlpha")
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "_hasAlpha", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("getAlphaFromRGB")
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "_getAlphaFromRGB", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "level", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("coordinatesIndex")
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "_coordinatesIndex", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "optimizeUVAllocation", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("coordinatesMode")
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "_coordinatesMode", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "wrapU", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "wrapV", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "wrapR", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "anisotropicFilteringLevel", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "isCube", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "is3D", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "is2DArray", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "gammaSpace", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "invertZ", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "lodLevelInAlpha", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "lodGenerationOffset", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "lodGenerationScale", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "linearSpecularLOD", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "irradianceTexture", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7862d1d2c5fb3cf3$export$d6306e508f184154.prototype, "isRenderTarget", void 0);

});
parcelRegister("jyMMC", function(module, exports) {

$parcel$export(module.exports, "ThinTexture", () => $e3d708a51bb30301$export$370601e15e8791a2);

var $93o7r = parcelRequire("93o7r");
class $e3d708a51bb30301$export$370601e15e8791a2 {
    /**
     * | Value | Type               | Description |
     * | ----- | ------------------ | ----------- |
     * | 0     | CLAMP_ADDRESSMODE  |             |
     * | 1     | WRAP_ADDRESSMODE   |             |
     * | 2     | MIRROR_ADDRESSMODE |             |
     */ get wrapU() {
        return this._wrapU;
    }
    set wrapU(value) {
        this._wrapU = value;
    }
    /**
     * | Value | Type               | Description |
     * | ----- | ------------------ | ----------- |
     * | 0     | CLAMP_ADDRESSMODE  |             |
     * | 1     | WRAP_ADDRESSMODE   |             |
     * | 2     | MIRROR_ADDRESSMODE |             |
     */ get wrapV() {
        return this._wrapV;
    }
    set wrapV(value) {
        this._wrapV = value;
    }
    /**
     * How a texture is mapped.
     * Unused in thin texture mode.
     */ get coordinatesMode() {
        return 0;
    }
    /**
     * Define if the texture is a cube texture or if false a 2d texture.
     */ get isCube() {
        if (!this._texture) return false;
        return this._texture.isCube;
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    set isCube(value) {
        if (!this._texture) return;
        this._texture.isCube = value;
    }
    /**
     * Define if the texture is a 3d texture (webgl 2) or if false a 2d texture.
     */ get is3D() {
        if (!this._texture) return false;
        return this._texture.is3D;
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    set is3D(value) {
        if (!this._texture) return;
        this._texture.is3D = value;
    }
    /**
     * Define if the texture is a 2d array texture (webgl 2) or if false a 2d texture.
     */ get is2DArray() {
        if (!this._texture) return false;
        return this._texture.is2DArray;
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    set is2DArray(value) {
        if (!this._texture) return;
        this._texture.is2DArray = value;
    }
    /**
     * Get the class name of the texture.
     * @returns "ThinTexture"
     */ getClassName() {
        return "ThinTexture";
    }
    static _IsRenderTargetWrapper(texture) {
        return texture?._shareDepth !== undefined;
    }
    /**
     * Instantiates a new ThinTexture.
     * Base class of all the textures in babylon.
     * This can be used as an internal texture wrapper in ThinEngine to benefit from the cache
     * @param internalTexture Define the internalTexture to wrap. You can also pass a RenderTargetWrapper, in which case the texture will be the render target's texture
     */ constructor(internalTexture){
        this._wrapU = 1;
        this._wrapV = 1;
        /**
         * | Value | Type               | Description |
         * | ----- | ------------------ | ----------- |
         * | 0     | CLAMP_ADDRESSMODE  |             |
         * | 1     | WRAP_ADDRESSMODE   |             |
         * | 2     | MIRROR_ADDRESSMODE |             |
         */ this.wrapR = 1;
        /**
         * With compliant hardware and browser (supporting anisotropic filtering)
         * this defines the level of anisotropic filtering in the texture.
         * The higher the better but the slower. This defaults to 4 as it seems to be the best tradeoff.
         */ this.anisotropicFilteringLevel = 4;
        /**
         * Define the current state of the loading sequence when in delayed load mode.
         */ this.delayLoadState = 0;
        /** @internal */ this._texture = null;
        this._engine = null;
        this._cachedSize = (0, $93o7r.Size).Zero();
        this._cachedBaseSize = (0, $93o7r.Size).Zero();
        /** @internal */ this._initialSamplingMode = 2;
        this._texture = $e3d708a51bb30301$export$370601e15e8791a2._IsRenderTargetWrapper(internalTexture) ? internalTexture.texture : internalTexture;
        if (this._texture) this._engine = this._texture.getEngine();
    }
    /**
     * Get if the texture is ready to be used (downloaded, converted, mip mapped...).
     * @returns true if fully ready
     */ isReady() {
        if (this.delayLoadState === 4) {
            this.delayLoad();
            return false;
        }
        if (this._texture) return this._texture.isReady;
        return false;
    }
    /**
     * Triggers the load sequence in delayed load mode.
     */ delayLoad() {}
    /**
     * Get the underlying lower level texture from Babylon.
     * @returns the internal texture
     */ getInternalTexture() {
        return this._texture;
    }
    /**
     * Get the size of the texture.
     * @returns the texture size.
     */ getSize() {
        if (this._texture) {
            if (this._texture.width) {
                this._cachedSize.width = this._texture.width;
                this._cachedSize.height = this._texture.height;
                return this._cachedSize;
            }
            if (this._texture._size) {
                this._cachedSize.width = this._texture._size;
                this._cachedSize.height = this._texture._size;
                return this._cachedSize;
            }
        }
        return this._cachedSize;
    }
    /**
     * Get the base size of the texture.
     * It can be different from the size if the texture has been resized for POT for instance
     * @returns the base size
     */ getBaseSize() {
        if (!this.isReady() || !this._texture) {
            this._cachedBaseSize.width = 0;
            this._cachedBaseSize.height = 0;
            return this._cachedBaseSize;
        }
        if (this._texture._size) {
            this._cachedBaseSize.width = this._texture._size;
            this._cachedBaseSize.height = this._texture._size;
            return this._cachedBaseSize;
        }
        this._cachedBaseSize.width = this._texture.baseWidth;
        this._cachedBaseSize.height = this._texture.baseHeight;
        return this._cachedBaseSize;
    }
    /**
     * Get the current sampling mode associated with the texture.
     */ get samplingMode() {
        if (!this._texture) return this._initialSamplingMode;
        return this._texture.samplingMode;
    }
    /**
     * Update the sampling mode of the texture.
     * Default is Trilinear mode.
     *
     * | Value | Type               | Description |
     * | ----- | ------------------ | ----------- |
     * | 1     | NEAREST_SAMPLINGMODE or NEAREST_NEAREST_MIPLINEAR  | Nearest is: mag = nearest, min = nearest, mip = linear |
     * | 2     | BILINEAR_SAMPLINGMODE or LINEAR_LINEAR_MIPNEAREST | Bilinear is: mag = linear, min = linear, mip = nearest |
     * | 3     | TRILINEAR_SAMPLINGMODE or LINEAR_LINEAR_MIPLINEAR | Trilinear is: mag = linear, min = linear, mip = linear |
     * | 4     | NEAREST_NEAREST_MIPNEAREST |             |
     * | 5    | NEAREST_LINEAR_MIPNEAREST |             |
     * | 6    | NEAREST_LINEAR_MIPLINEAR |             |
     * | 7    | NEAREST_LINEAR |             |
     * | 8    | NEAREST_NEAREST |             |
     * | 9   | LINEAR_NEAREST_MIPNEAREST |             |
     * | 10   | LINEAR_NEAREST_MIPLINEAR |             |
     * | 11   | LINEAR_LINEAR |             |
     * | 12   | LINEAR_NEAREST |             |
     *
     *    > _mag_: magnification filter (close to the viewer)
     *    > _min_: minification filter (far from the viewer)
     *    > _mip_: filter used between mip map levels
     *@param samplingMode Define the new sampling mode of the texture
     */ updateSamplingMode(samplingMode) {
        if (this._texture && this._engine) this._engine.updateTextureSamplingMode(samplingMode, this._texture);
    }
    /**
     * Release and destroy the underlying lower level texture aka internalTexture.
     */ releaseInternalTexture() {
        if (this._texture) {
            this._texture.dispose();
            this._texture = null;
        }
    }
    /**
     * Dispose the texture and release its associated resources.
     */ dispose() {
        if (this._texture) {
            this.releaseInternalTexture();
            this._engine = null;
        }
    }
}

});


parcelRegister("f2kkL", function(module, exports) {

$parcel$export(module.exports, "GenerateBase64StringFromPixelData", () => $af26d0cc3ed27ae3$export$87c020095ab48b9a);
$parcel$export(module.exports, "GenerateBase64StringFromTexture", () => $af26d0cc3ed27ae3$export$5ff2effb6017083b);
$parcel$export(module.exports, "GenerateBase64StringFromTextureAsync", () => $af26d0cc3ed27ae3$export$4fce851e948778e9);
$parcel$export(module.exports, "CopyTools", () => $af26d0cc3ed27ae3$export$3481a701739ec579);
/**
 * Transform some pixel data to a base64 string
 * @param pixels defines the pixel data to transform to base64
 * @param size defines the width and height of the (texture) data
 * @param invertY true if the data must be inverted for the Y coordinate during the conversion
 * @returns The base64 encoded string or null
 */ function $af26d0cc3ed27ae3$export$87c020095ab48b9a(pixels, size, invertY = false) {
    const width = size.width;
    const height = size.height;
    if (pixels instanceof Float32Array) {
        let len = pixels.byteLength / pixels.BYTES_PER_ELEMENT;
        const npixels = new Uint8Array(len);
        while(--len >= 0){
            let val = pixels[len];
            if (val < 0) val = 0;
            else if (val > 1) val = 1;
            npixels[len] = val * 255;
        }
        pixels = npixels;
    }
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    if (!ctx) return null;
    const imageData = ctx.createImageData(width, height);
    const castData = imageData.data;
    castData.set(pixels);
    ctx.putImageData(imageData, 0, 0);
    if (invertY) {
        const canvas2 = document.createElement("canvas");
        canvas2.width = width;
        canvas2.height = height;
        const ctx2 = canvas2.getContext("2d");
        if (!ctx2) return null;
        ctx2.translate(0, height);
        ctx2.scale(1, -1);
        ctx2.drawImage(canvas, 0, 0);
        return canvas2.toDataURL("image/png");
    }
    return canvas.toDataURL("image/png");
}
function $af26d0cc3ed27ae3$export$5ff2effb6017083b(texture, faceIndex = 0, level = 0) {
    const internalTexture = texture.getInternalTexture();
    if (!internalTexture) return null;
    const pixels = texture._readPixelsSync(faceIndex, level);
    if (!pixels) return null;
    return $af26d0cc3ed27ae3$export$87c020095ab48b9a(pixels, texture.getSize(), internalTexture.invertY);
}
async function $af26d0cc3ed27ae3$export$4fce851e948778e9(texture, faceIndex = 0, level = 0) {
    const internalTexture = texture.getInternalTexture();
    if (!internalTexture) return null;
    const pixels = await texture.readPixels(faceIndex, level);
    if (!pixels) return null;
    return $af26d0cc3ed27ae3$export$87c020095ab48b9a(pixels, texture.getSize(), internalTexture.invertY);
}
const $af26d0cc3ed27ae3$export$3481a701739ec579 = {
    GenerateBase64StringFromPixelData: /**
     * Transform some pixel data to a base64 string
     * @param pixels defines the pixel data to transform to base64
     * @param size defines the width and height of the (texture) data
     * @param invertY true if the data must be inverted for the Y coordinate during the conversion
     * @returns The base64 encoded string or null
     */ $af26d0cc3ed27ae3$export$87c020095ab48b9a,
    GenerateBase64StringFromTexture: /**
     * Reads the pixels stored in the webgl texture and returns them as a base64 string
     * @param texture defines the texture to read pixels from
     * @param faceIndex defines the face of the texture to read (in case of cube texture)
     * @param level defines the LOD level of the texture to read (in case of Mip Maps)
     * @returns The base64 encoded string or null
     */ $af26d0cc3ed27ae3$export$5ff2effb6017083b,
    GenerateBase64StringFromTextureAsync: /**
     * Reads the pixels stored in the webgl texture and returns them as a base64 string
     * @param texture defines the texture to read pixels from
     * @param faceIndex defines the face of the texture to read (in case of cube texture)
     * @param level defines the LOD level of the texture to read (in case of Mip Maps)
     * @returns The base64 encoded string or null wrapped in a promise
     */ $af26d0cc3ed27ae3$export$4fce851e948778e9
};

});


parcelRegister("e7NUJ", function(module, exports) {

var $b9e4a = parcelRequire("b9e4a");

var $kVtWi = parcelRequire("kVtWi");

var $2h5JR = parcelRequire("2h5JR");

var $wK2xc = parcelRequire("wK2xc");
(0, $2h5JR.ThinEngine).prototype.updateRawTexture = function(texture, data, format, invertY, compression = null, type = 0, useSRGBBuffer = false) {
    if (!texture) return;
    // Babylon's internalSizedFomat but gl's texImage2D internalFormat
    const internalSizedFomat = this._getRGBABufferInternalSizedFormat(type, format, useSRGBBuffer);
    // Babylon's internalFormat but gl's texImage2D format
    const internalFormat = this._getInternalFormat(format);
    const textureType = this._getWebGLTextureType(type);
    this._bindTextureDirectly(this._gl.TEXTURE_2D, texture, true);
    this._unpackFlipY(invertY === undefined ? true : invertY ? true : false);
    if (!this._doNotHandleContextLost) {
        texture._bufferView = data;
        texture.format = format;
        texture.type = type;
        texture.invertY = invertY;
        texture._compression = compression;
    }
    if (texture.width % 4 !== 0) this._gl.pixelStorei(this._gl.UNPACK_ALIGNMENT, 1);
    if (compression && data) this._gl.compressedTexImage2D(this._gl.TEXTURE_2D, 0, this.getCaps().s3tc[compression], texture.width, texture.height, 0, data);
    else this._gl.texImage2D(this._gl.TEXTURE_2D, 0, internalSizedFomat, texture.width, texture.height, 0, internalFormat, textureType, data);
    if (texture.generateMipMaps) this._gl.generateMipmap(this._gl.TEXTURE_2D);
    this._bindTextureDirectly(this._gl.TEXTURE_2D, null);
    //  this.resetTextureCache();
    texture.isReady = true;
};
(0, $2h5JR.ThinEngine).prototype.createRawTexture = function(data, width, height, format, generateMipMaps, invertY, samplingMode, compression = null, type = 0, // eslint-disable-next-line @typescript-eslint/no-unused-vars
creationFlags = 0, useSRGBBuffer = false) {
    const texture = new (0, $b9e4a.InternalTexture)(this, (0, $b9e4a.InternalTextureSource).Raw);
    texture.baseWidth = width;
    texture.baseHeight = height;
    texture.width = width;
    texture.height = height;
    texture.format = format;
    texture.generateMipMaps = generateMipMaps;
    texture.samplingMode = samplingMode;
    texture.invertY = invertY;
    texture._compression = compression;
    texture.type = type;
    texture._useSRGBBuffer = this._getUseSRGBBuffer(useSRGBBuffer, !generateMipMaps);
    if (!this._doNotHandleContextLost) texture._bufferView = data;
    this.updateRawTexture(texture, data, format, invertY, compression, type, texture._useSRGBBuffer);
    this._bindTextureDirectly(this._gl.TEXTURE_2D, texture, true);
    // Filters
    const filters = this._getSamplingParameters(samplingMode, generateMipMaps);
    this._gl.texParameteri(this._gl.TEXTURE_2D, this._gl.TEXTURE_MAG_FILTER, filters.mag);
    this._gl.texParameteri(this._gl.TEXTURE_2D, this._gl.TEXTURE_MIN_FILTER, filters.min);
    if (generateMipMaps) this._gl.generateMipmap(this._gl.TEXTURE_2D);
    this._bindTextureDirectly(this._gl.TEXTURE_2D, null);
    this._internalTexturesCache.push(texture);
    return texture;
};
(0, $2h5JR.ThinEngine).prototype.createRawCubeTexture = function(data, size, format, type, generateMipMaps, invertY, samplingMode, compression = null) {
    const gl = this._gl;
    const texture = new (0, $b9e4a.InternalTexture)(this, (0, $b9e4a.InternalTextureSource).CubeRaw);
    texture.isCube = true;
    texture.format = format;
    texture.type = type;
    if (!this._doNotHandleContextLost) texture._bufferViewArray = data;
    const textureType = this._getWebGLTextureType(type);
    let internalFormat = this._getInternalFormat(format);
    if (internalFormat === gl.RGB) internalFormat = gl.RGBA;
    // Mipmap generation needs a sized internal format that is both color-renderable and texture-filterable
    if (textureType === gl.FLOAT && !this._caps.textureFloatLinearFiltering) {
        generateMipMaps = false;
        samplingMode = 1;
        (0, $kVtWi.Logger).Warn("Float texture filtering is not supported. Mipmap generation and sampling mode are forced to false and TEXTURE_NEAREST_SAMPLINGMODE, respectively.");
    } else if (textureType === this._gl.HALF_FLOAT_OES && !this._caps.textureHalfFloatLinearFiltering) {
        generateMipMaps = false;
        samplingMode = 1;
        (0, $kVtWi.Logger).Warn("Half float texture filtering is not supported. Mipmap generation and sampling mode are forced to false and TEXTURE_NEAREST_SAMPLINGMODE, respectively.");
    } else if (textureType === gl.FLOAT && !this._caps.textureFloatRender) {
        generateMipMaps = false;
        (0, $kVtWi.Logger).Warn("Render to float textures is not supported. Mipmap generation forced to false.");
    } else if (textureType === gl.HALF_FLOAT && !this._caps.colorBufferFloat) {
        generateMipMaps = false;
        (0, $kVtWi.Logger).Warn("Render to half float textures is not supported. Mipmap generation forced to false.");
    }
    const width = size;
    const height = width;
    texture.width = width;
    texture.height = height;
    texture.invertY = invertY;
    texture._compression = compression;
    // Double check on POT to generate Mips.
    const isPot = !this.needPOTTextures || (0, $wK2xc.IsExponentOfTwo)(texture.width) && (0, $wK2xc.IsExponentOfTwo)(texture.height);
    if (!isPot) generateMipMaps = false;
    // Upload data if needed. The texture won't be ready until then.
    if (data) this.updateRawCubeTexture(texture, data, format, type, invertY, compression);
    else {
        const internalSizedFomat = this._getRGBABufferInternalSizedFormat(type);
        const level = 0;
        this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, texture, true);
        for(let faceIndex = 0; faceIndex < 6; faceIndex++)if (compression) gl.compressedTexImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex, level, this.getCaps().s3tc[compression], texture.width, texture.height, 0, undefined);
        else gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex, level, internalSizedFomat, texture.width, texture.height, 0, internalFormat, textureType, null);
        this._bindTextureDirectly(this._gl.TEXTURE_CUBE_MAP, null);
    }
    this._bindTextureDirectly(this._gl.TEXTURE_CUBE_MAP, texture, true);
    // Filters
    if (data && generateMipMaps) this._gl.generateMipmap(this._gl.TEXTURE_CUBE_MAP);
    const filters = this._getSamplingParameters(samplingMode, generateMipMaps);
    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAG_FILTER, filters.mag);
    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MIN_FILTER, filters.min);
    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, null);
    texture.generateMipMaps = generateMipMaps;
    texture.samplingMode = samplingMode;
    texture.isReady = true;
    return texture;
};
(0, $2h5JR.ThinEngine).prototype.updateRawCubeTexture = function(texture, data, format, type, invertY, compression = null, level = 0) {
    texture._bufferViewArray = data;
    texture.format = format;
    texture.type = type;
    texture.invertY = invertY;
    texture._compression = compression;
    const gl = this._gl;
    const textureType = this._getWebGLTextureType(type);
    let internalFormat = this._getInternalFormat(format);
    const internalSizedFomat = this._getRGBABufferInternalSizedFormat(type);
    let needConversion = false;
    if (internalFormat === gl.RGB) {
        internalFormat = gl.RGBA;
        needConversion = true;
    }
    this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, texture, true);
    this._unpackFlipY(invertY === undefined ? true : invertY ? true : false);
    if (texture.width % 4 !== 0) gl.pixelStorei(gl.UNPACK_ALIGNMENT, 1);
    // Data are known to be in +X +Y +Z -X -Y -Z
    for(let faceIndex = 0; faceIndex < 6; faceIndex++){
        let faceData = data[faceIndex];
        if (compression) gl.compressedTexImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex, level, this.getCaps().s3tc[compression], texture.width, texture.height, 0, faceData);
        else {
            if (needConversion) faceData = $a4887001ff88aa24$var$_convertRGBtoRGBATextureData(faceData, texture.width, texture.height, type);
            gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndex, level, internalSizedFomat, texture.width, texture.height, 0, internalFormat, textureType, faceData);
        }
    }
    const isPot = !this.needPOTTextures || (0, $wK2xc.IsExponentOfTwo)(texture.width) && (0, $wK2xc.IsExponentOfTwo)(texture.height);
    if (isPot && texture.generateMipMaps && level === 0) this._gl.generateMipmap(this._gl.TEXTURE_CUBE_MAP);
    this._bindTextureDirectly(this._gl.TEXTURE_CUBE_MAP, null);
    // this.resetTextureCache();
    texture.isReady = true;
};
(0, $2h5JR.ThinEngine).prototype.createRawCubeTextureFromUrl = function(url, scene, size, format, type, noMipmap, callback, mipmapGenerator, onLoad = null, onError = null, samplingMode = 3, invertY = false) {
    const gl = this._gl;
    const texture = this.createRawCubeTexture(null, size, format, type, !noMipmap, invertY, samplingMode, null);
    scene?.addPendingData(texture);
    texture.url = url;
    texture.isReady = false;
    this._internalTexturesCache.push(texture);
    const onerror = (request, exception)=>{
        scene?.removePendingData(texture);
        if (onError && request) onError(request.status + " " + request.statusText, exception);
    };
    const internalCallback = (data)=>{
        const width = texture.width;
        const faceDataArrays = callback(data);
        if (!faceDataArrays) return;
        if (mipmapGenerator) {
            const textureType = this._getWebGLTextureType(type);
            let internalFormat = this._getInternalFormat(format);
            const internalSizedFomat = this._getRGBABufferInternalSizedFormat(type);
            let needConversion = false;
            if (internalFormat === gl.RGB) {
                internalFormat = gl.RGBA;
                needConversion = true;
            }
            this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, texture, true);
            this._unpackFlipY(false);
            const mipData = mipmapGenerator(faceDataArrays);
            for(let level = 0; level < mipData.length; level++){
                const mipSize = width >> level;
                for(let faceIndex = 0; faceIndex < 6; faceIndex++){
                    let mipFaceData = mipData[level][faceIndex];
                    if (needConversion) mipFaceData = $a4887001ff88aa24$var$_convertRGBtoRGBATextureData(mipFaceData, mipSize, mipSize, type);
                    gl.texImage2D(faceIndex, level, internalSizedFomat, mipSize, mipSize, 0, internalFormat, textureType, mipFaceData);
                }
            }
            this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, null);
        } else this.updateRawCubeTexture(texture, faceDataArrays, format, type, invertY);
        texture.isReady = true;
        // this.resetTextureCache();
        scene?.removePendingData(texture);
        texture.onLoadedObservable.notifyObservers(texture);
        texture.onLoadedObservable.clear();
        if (onLoad) onLoad();
    };
    this._loadFile(url, (data)=>{
        internalCallback(data);
    }, undefined, scene?.offlineProvider, true, onerror);
    return texture;
};
/**
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
function $a4887001ff88aa24$var$_convertRGBtoRGBATextureData(rgbData, width, height, textureType) {
    // Create new RGBA data container.
    let rgbaData;
    let val1 = 1;
    if (textureType === 1) rgbaData = new Float32Array(width * height * 4);
    else if (textureType === 2) {
        rgbaData = new Uint16Array(width * height * 4);
        val1 = 15360; // 15360 is the encoding of 1 in half float
    } else if (textureType === 7) rgbaData = new Uint32Array(width * height * 4);
    else rgbaData = new Uint8Array(width * height * 4);
    // Convert each pixel.
    for(let x = 0; x < width; x++)for(let y = 0; y < height; y++){
        const index = (y * width + x) * 3;
        const newIndex = (y * width + x) * 4;
        // Map Old Value to new value.
        rgbaData[newIndex + 0] = rgbData[index + 0];
        rgbaData[newIndex + 1] = rgbData[index + 1];
        rgbaData[newIndex + 2] = rgbData[index + 2];
        // Add fully opaque alpha channel.
        rgbaData[newIndex + 3] = val1;
    }
    return rgbaData;
}
/**
 * Create a function for createRawTexture3D/createRawTexture2DArray
 * @param is3D true for TEXTURE_3D and false for TEXTURE_2D_ARRAY
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
function $a4887001ff88aa24$var$_makeCreateRawTextureFunction(is3D) {
    return function(data, width, height, depth, format, generateMipMaps, invertY, samplingMode, compression = null, textureType = 0) {
        const target = is3D ? this._gl.TEXTURE_3D : this._gl.TEXTURE_2D_ARRAY;
        const source = is3D ? (0, $b9e4a.InternalTextureSource).Raw3D : (0, $b9e4a.InternalTextureSource).Raw2DArray;
        const texture = new (0, $b9e4a.InternalTexture)(this, source);
        texture.baseWidth = width;
        texture.baseHeight = height;
        texture.baseDepth = depth;
        texture.width = width;
        texture.height = height;
        texture.depth = depth;
        texture.format = format;
        texture.type = textureType;
        texture.generateMipMaps = generateMipMaps;
        texture.samplingMode = samplingMode;
        if (is3D) texture.is3D = true;
        else texture.is2DArray = true;
        if (!this._doNotHandleContextLost) texture._bufferView = data;
        if (is3D) this.updateRawTexture3D(texture, data, format, invertY, compression, textureType);
        else this.updateRawTexture2DArray(texture, data, format, invertY, compression, textureType);
        this._bindTextureDirectly(target, texture, true);
        // Filters
        const filters = this._getSamplingParameters(samplingMode, generateMipMaps);
        this._gl.texParameteri(target, this._gl.TEXTURE_MAG_FILTER, filters.mag);
        this._gl.texParameteri(target, this._gl.TEXTURE_MIN_FILTER, filters.min);
        if (generateMipMaps) this._gl.generateMipmap(target);
        this._bindTextureDirectly(target, null);
        this._internalTexturesCache.push(texture);
        return texture;
    };
}
(0, $2h5JR.ThinEngine).prototype.createRawTexture2DArray = $a4887001ff88aa24$var$_makeCreateRawTextureFunction(false);
(0, $2h5JR.ThinEngine).prototype.createRawTexture3D = $a4887001ff88aa24$var$_makeCreateRawTextureFunction(true);
/**
 * Create a function for updateRawTexture3D/updateRawTexture2DArray
 * @param is3D true for TEXTURE_3D and false for TEXTURE_2D_ARRAY
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
function $a4887001ff88aa24$var$_makeUpdateRawTextureFunction(is3D) {
    return function(texture, data, format, invertY, compression = null, textureType = 0) {
        const target = is3D ? this._gl.TEXTURE_3D : this._gl.TEXTURE_2D_ARRAY;
        const internalType = this._getWebGLTextureType(textureType);
        const internalFormat = this._getInternalFormat(format);
        const internalSizedFomat = this._getRGBABufferInternalSizedFormat(textureType, format);
        this._bindTextureDirectly(target, texture, true);
        this._unpackFlipY(invertY === undefined ? true : invertY ? true : false);
        if (!this._doNotHandleContextLost) {
            texture._bufferView = data;
            texture.format = format;
            texture.invertY = invertY;
            texture._compression = compression;
        }
        if (texture.width % 4 !== 0) this._gl.pixelStorei(this._gl.UNPACK_ALIGNMENT, 1);
        if (compression && data) this._gl.compressedTexImage3D(target, 0, this.getCaps().s3tc[compression], texture.width, texture.height, texture.depth, 0, data);
        else this._gl.texImage3D(target, 0, internalSizedFomat, texture.width, texture.height, texture.depth, 0, internalFormat, internalType, data);
        if (texture.generateMipMaps) this._gl.generateMipmap(target);
        this._bindTextureDirectly(target, null);
        // this.resetTextureCache();
        texture.isReady = true;
    };
}
(0, $2h5JR.ThinEngine).prototype.updateRawTexture2DArray = $a4887001ff88aa24$var$_makeUpdateRawTextureFunction(false);
(0, $2h5JR.ThinEngine).prototype.updateRawTexture3D = $a4887001ff88aa24$var$_makeUpdateRawTextureFunction(true);

});


parcelRegister("3RnX0", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $2cf8e676d7e00b7e$export$8f31e4c4a37b8e9c);

var $g6X9E = parcelRequire("g6X9E");

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $5Egpj = parcelRequire("5Egpj");

var $lWogh = parcelRequire("lWogh");

var $knVpn = parcelRequire("knVpn");

var $ejQPp = parcelRequire("ejQPp");

var $kVtWi = parcelRequire("kVtWi");

var $fhgis = parcelRequire("fhgis");
class $2cf8e676d7e00b7e$export$8f31e4c4a37b8e9c {
    /**
     * Gets or sets a boolean indicating that bone matrices should be stored as a texture instead of using shader uniforms (default is true).
     * Please note that this option is not available if the hardware does not support it
     */ get useTextureToStoreBoneMatrices() {
        return this._useTextureToStoreBoneMatrices;
    }
    set useTextureToStoreBoneMatrices(value) {
        this._useTextureToStoreBoneMatrices = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets the animation properties override
     */ get animationPropertiesOverride() {
        if (!this._animationPropertiesOverride) return this._scene.animationPropertiesOverride;
        return this._animationPropertiesOverride;
    }
    set animationPropertiesOverride(value) {
        this._animationPropertiesOverride = value;
    }
    /**
     * Gets a boolean indicating that the skeleton effectively stores matrices into a texture
     */ get isUsingTextureForMatrices() {
        return this.useTextureToStoreBoneMatrices && this._canUseTextureForBones;
    }
    /**
     * Gets the unique ID of this skeleton
     */ get uniqueId() {
        return this._uniqueId;
    }
    /**
     * Creates a new skeleton
     * @param name defines the skeleton name
     * @param id defines the skeleton Id
     * @param scene defines the hosting scene
     */ constructor(/** defines the skeleton name */ name, /** defines the skeleton Id */ id, scene){
        this.name = name;
        this.id = id;
        /**
         * Defines the list of child bones
         */ this.bones = [];
        /**
         * Defines a boolean indicating if the root matrix is provided by meshes or by the current skeleton (this is the default value)
         */ this.needInitialSkinMatrix = false;
        this._isDirty = true;
        this._meshesWithPoseMatrix = new Array();
        this._identity = (0, $ha1VO.Matrix).Identity();
        this._currentRenderId = -1;
        this._ranges = {};
        this._absoluteTransformIsDirty = true;
        this._canUseTextureForBones = false;
        this._uniqueId = 0;
        /** @internal */ this._numBonesWithLinkedTransformNode = 0;
        /** @internal */ this._hasWaitingData = null;
        /** @internal */ this._parentContainer = null;
        /**
         * Specifies if the skeleton should be serialized
         */ this.doNotSerialize = false;
        this._useTextureToStoreBoneMatrices = true;
        this._animationPropertiesOverride = null;
        // Events
        /**
         * An observable triggered before computing the skeleton's matrices
         */ this.onBeforeComputeObservable = new (0, $diGQf.Observable)();
        this.bones = [];
        this._scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        this._uniqueId = this._scene.getUniqueId();
        this._scene.addSkeleton(this);
        //make sure it will recalculate the matrix next time prepare is called.
        this._isDirty = true;
        const engineCaps = this._scene.getEngine().getCaps();
        this._canUseTextureForBones = engineCaps.textureFloat && engineCaps.maxVertexTextureImageUnits > 0;
    }
    /**
     * Gets the current object class name.
     * @returns the class name
     */ getClassName() {
        return "Skeleton";
    }
    /**
     * Returns an array containing the root bones
     * @returns an array containing the root bones
     */ getChildren() {
        return this.bones.filter((b)=>!b.getParent());
    }
    // Members
    /**
     * Gets the list of transform matrices to send to shaders (one matrix per bone)
     * @param mesh defines the mesh to use to get the root matrix (if needInitialSkinMatrix === true)
     * @returns a Float32Array containing matrices data
     */ getTransformMatrices(mesh) {
        if (this.needInitialSkinMatrix) {
            if (!mesh) throw new Error("getTransformMatrices: When using the needInitialSkinMatrix flag, a mesh must be provided");
            if (!mesh._bonesTransformMatrices) this.prepare(true);
            return mesh._bonesTransformMatrices;
        }
        if (!this._transformMatrices || this._isDirty) this.prepare(!this._transformMatrices);
        return this._transformMatrices;
    }
    /**
     * Gets the list of transform matrices to send to shaders inside a texture (one matrix per bone)
     * @param mesh defines the mesh to use to get the root matrix (if needInitialSkinMatrix === true)
     * @returns a raw texture containing the data
     */ getTransformMatrixTexture(mesh) {
        if (this.needInitialSkinMatrix && mesh._transformMatrixTexture) return mesh._transformMatrixTexture;
        return this._transformMatrixTexture;
    }
    /**
     * Gets the current hosting scene
     * @returns a scene object
     */ getScene() {
        return this._scene;
    }
    // Methods
    /**
     * Gets a string representing the current skeleton data
     * @param fullDetails defines a boolean indicating if we want a verbose version
     * @returns a string representing the current skeleton data
     */ toString(fullDetails) {
        let ret = `Name: ${this.name}, nBones: ${this.bones.length}`;
        ret += `, nAnimationRanges: ${this._ranges ? Object.keys(this._ranges).length : "none"}`;
        if (fullDetails) {
            ret += ", Ranges: {";
            let first = true;
            for(const name in this._ranges){
                if (first) {
                    ret += ", ";
                    first = false;
                }
                ret += name;
            }
            ret += "}";
        }
        return ret;
    }
    /**
     * Get bone's index searching by name
     * @param name defines bone's name to search for
     * @returns the indice of the bone. Returns -1 if not found
     */ getBoneIndexByName(name) {
        for(let boneIndex = 0, cache = this.bones.length; boneIndex < cache; boneIndex++){
            if (this.bones[boneIndex].name === name) return boneIndex;
        }
        return -1;
    }
    /**
     * Create a new animation range
     * @param name defines the name of the range
     * @param from defines the start key
     * @param to defines the end key
     */ createAnimationRange(name, from, to) {
        // check name not already in use
        if (!this._ranges[name]) {
            this._ranges[name] = new (0, $knVpn.AnimationRange)(name, from, to);
            for(let i = 0, nBones = this.bones.length; i < nBones; i++)if (this.bones[i].animations[0]) this.bones[i].animations[0].createRange(name, from, to);
        }
    }
    /**
     * Delete a specific animation range
     * @param name defines the name of the range
     * @param deleteFrames defines if frames must be removed as well
     */ deleteAnimationRange(name, deleteFrames = true) {
        for(let i = 0, nBones = this.bones.length; i < nBones; i++)if (this.bones[i].animations[0]) this.bones[i].animations[0].deleteRange(name, deleteFrames);
        this._ranges[name] = null; // said much faster than 'delete this._range[name]'
    }
    /**
     * Gets a specific animation range
     * @param name defines the name of the range to look for
     * @returns the requested animation range or null if not found
     */ getAnimationRange(name) {
        return this._ranges[name] || null;
    }
    /**
     * Gets the list of all animation ranges defined on this skeleton
     * @returns an array
     */ getAnimationRanges() {
        const animationRanges = [];
        let name;
        for(name in this._ranges)animationRanges.push(this._ranges[name]);
        return animationRanges;
    }
    /**
     * Copy animation range from a source skeleton.
     * This is not for a complete retargeting, only between very similar skeleton's with only possible bone length differences
     * @param source defines the source skeleton
     * @param name defines the name of the range to copy
     * @param rescaleAsRequired defines if rescaling must be applied if required
     * @returns true if operation was successful
     */ copyAnimationRange(source, name, rescaleAsRequired = false) {
        if (this._ranges[name] || !source.getAnimationRange(name)) return false;
        let ret = true;
        const frameOffset = this._getHighestAnimationFrame() + 1;
        // make a dictionary of source skeleton's bones, so exact same order or doubly nested loop is not required
        const boneDict = {};
        const sourceBones = source.bones;
        let nBones;
        let i;
        for(i = 0, nBones = sourceBones.length; i < nBones; i++)boneDict[sourceBones[i].name] = sourceBones[i];
        if (this.bones.length !== sourceBones.length) {
            (0, $kVtWi.Logger).Warn(`copyAnimationRange: this rig has ${this.bones.length} bones, while source as ${sourceBones.length}`);
            ret = false;
        }
        const skelDimensionsRatio = rescaleAsRequired && this.dimensionsAtRest && source.dimensionsAtRest ? this.dimensionsAtRest.divide(source.dimensionsAtRest) : null;
        for(i = 0, nBones = this.bones.length; i < nBones; i++){
            const boneName = this.bones[i].name;
            const sourceBone = boneDict[boneName];
            if (sourceBone) ret = ret && this.bones[i].copyAnimationRange(sourceBone, name, frameOffset, rescaleAsRequired, skelDimensionsRatio);
            else {
                (0, $kVtWi.Logger).Warn("copyAnimationRange: not same rig, missing source bone " + boneName);
                ret = false;
            }
        }
        // do not call createAnimationRange(), since it also is done to bones, which was already done
        const range = source.getAnimationRange(name);
        if (range) this._ranges[name] = new (0, $knVpn.AnimationRange)(name, range.from + frameOffset, range.to + frameOffset);
        return ret;
    }
    /**
     * Forces the skeleton to go to rest pose
     */ returnToRest() {
        for (const bone of this.bones)if (bone._index !== -1) bone.returnToRest();
    }
    _getHighestAnimationFrame() {
        let ret = 0;
        for(let i = 0, nBones = this.bones.length; i < nBones; i++)if (this.bones[i].animations[0]) {
            const highest = this.bones[i].animations[0].getHighestFrame();
            if (ret < highest) ret = highest;
        }
        return ret;
    }
    /**
     * Begin a specific animation range
     * @param name defines the name of the range to start
     * @param loop defines if looping must be turned on (false by default)
     * @param speedRatio defines the speed ratio to apply (1 by default)
     * @param onAnimationEnd defines a callback which will be called when animation will end
     * @returns a new animatable
     */ beginAnimation(name, loop, speedRatio, onAnimationEnd) {
        const range = this.getAnimationRange(name);
        if (!range) return null;
        return this._scene.beginAnimation(this, range.from, range.to, loop, speedRatio, onAnimationEnd);
    }
    /**
     * Convert the keyframes for a range of animation on a skeleton to be relative to a given reference frame.
     * @param skeleton defines the Skeleton containing the animation range to convert
     * @param referenceFrame defines the frame that keyframes in the range will be relative to
     * @param range defines the name of the AnimationRange belonging to the Skeleton to convert
     * @returns the original skeleton
     */ static MakeAnimationAdditive(skeleton, referenceFrame = 0, range) {
        const rangeValue = skeleton.getAnimationRange(range);
        // We can't make a range additive if it doesn't exist
        if (!rangeValue) return null;
        // Find any current scene-level animatable belonging to the target that matches the range
        const sceneAnimatables = skeleton._scene.getAllAnimatablesByTarget(skeleton);
        let rangeAnimatable = null;
        for(let index = 0; index < sceneAnimatables.length; index++){
            const sceneAnimatable = sceneAnimatables[index];
            if (sceneAnimatable.fromFrame === rangeValue?.from && sceneAnimatable.toFrame === rangeValue?.to) {
                rangeAnimatable = sceneAnimatable;
                break;
            }
        }
        // Convert the animations belonging to the skeleton to additive keyframes
        const animatables = skeleton.getAnimatables();
        for(let index = 0; index < animatables.length; index++){
            const animatable = animatables[index];
            const animations = animatable.animations;
            if (!animations) continue;
            for(let animIndex = 0; animIndex < animations.length; animIndex++)(0, $lWogh.Animation).MakeAnimationAdditive(animations[animIndex], referenceFrame, range);
        }
        // Mark the scene-level animatable as additive
        if (rangeAnimatable) rangeAnimatable.isAdditive = true;
        return skeleton;
    }
    /** @internal */ _markAsDirty() {
        this._isDirty = true;
        this._absoluteTransformIsDirty = true;
    }
    /**
     * @internal
     */ _registerMeshWithPoseMatrix(mesh) {
        this._meshesWithPoseMatrix.push(mesh);
    }
    /**
     * @internal
     */ _unregisterMeshWithPoseMatrix(mesh) {
        const index = this._meshesWithPoseMatrix.indexOf(mesh);
        if (index > -1) this._meshesWithPoseMatrix.splice(index, 1);
    }
    _computeTransformMatrices(targetMatrix, initialSkinMatrix) {
        this.onBeforeComputeObservable.notifyObservers(this);
        for(let index = 0; index < this.bones.length; index++){
            const bone = this.bones[index];
            bone._childUpdateId++;
            const parentBone = bone.getParent();
            if (parentBone) bone.getLocalMatrix().multiplyToRef(parentBone.getFinalMatrix(), bone.getFinalMatrix());
            else if (initialSkinMatrix) bone.getLocalMatrix().multiplyToRef(initialSkinMatrix, bone.getFinalMatrix());
            else bone.getFinalMatrix().copyFrom(bone.getLocalMatrix());
            if (bone._index !== -1) {
                const mappedIndex = bone._index === null ? index : bone._index;
                bone.getAbsoluteInverseBindMatrix().multiplyToArray(bone.getFinalMatrix(), targetMatrix, mappedIndex * 16);
            }
        }
        this._identity.copyToArray(targetMatrix, this.bones.length * 16);
    }
    /**
     * Build all resources required to render a skeleton
     * @param dontCheckFrameId defines a boolean indicating if prepare should be run without checking first the current frame id (default: false)
     */ prepare(dontCheckFrameId = false) {
        if (!dontCheckFrameId) {
            const currentRenderId = this.getScene().getRenderId();
            if (this._currentRenderId === currentRenderId) return;
            this._currentRenderId = currentRenderId;
        }
        // Update the local matrix of bones with linked transform nodes.
        if (this._numBonesWithLinkedTransformNode > 0) {
            for (const bone of this.bones)if (bone._linkedTransformNode) {
                const node = bone._linkedTransformNode;
                bone.position = node.position;
                if (node.rotationQuaternion) bone.rotationQuaternion = node.rotationQuaternion;
                else bone.rotation = node.rotation;
                bone.scaling = node.scaling;
            }
        }
        if (this.needInitialSkinMatrix) for (const mesh of this._meshesWithPoseMatrix){
            const poseMatrix = mesh.getPoseMatrix();
            let needsUpdate = this._isDirty;
            if (!mesh._bonesTransformMatrices || mesh._bonesTransformMatrices.length !== 16 * (this.bones.length + 1)) {
                mesh._bonesTransformMatrices = new Float32Array(16 * (this.bones.length + 1));
                needsUpdate = true;
            }
            if (!needsUpdate) continue;
            if (this._synchronizedWithMesh !== mesh) {
                this._synchronizedWithMesh = mesh;
                // Prepare bones
                for (const bone of this.bones)if (!bone.getParent()) {
                    const matrix = bone.getBindMatrix();
                    matrix.multiplyToRef(poseMatrix, (0, $ha1VO.TmpVectors).Matrix[1]);
                    bone._updateAbsoluteBindMatrices((0, $ha1VO.TmpVectors).Matrix[1]);
                }
                if (this.isUsingTextureForMatrices) {
                    const textureWidth = (this.bones.length + 1) * 4;
                    if (!mesh._transformMatrixTexture || mesh._transformMatrixTexture.getSize().width !== textureWidth) {
                        if (mesh._transformMatrixTexture) mesh._transformMatrixTexture.dispose();
                        mesh._transformMatrixTexture = (0, $5Egpj.RawTexture).CreateRGBATexture(mesh._bonesTransformMatrices, (this.bones.length + 1) * 4, 1, this._scene, false, false, 1, 1);
                    }
                }
            }
            this._computeTransformMatrices(mesh._bonesTransformMatrices, poseMatrix);
            if (this.isUsingTextureForMatrices && mesh._transformMatrixTexture) mesh._transformMatrixTexture.update(mesh._bonesTransformMatrices);
        }
        else {
            if (!this._isDirty) return;
            if (!this._transformMatrices || this._transformMatrices.length !== 16 * (this.bones.length + 1)) {
                this._transformMatrices = new Float32Array(16 * (this.bones.length + 1));
                if (this.isUsingTextureForMatrices) {
                    if (this._transformMatrixTexture) this._transformMatrixTexture.dispose();
                    this._transformMatrixTexture = (0, $5Egpj.RawTexture).CreateRGBATexture(this._transformMatrices, (this.bones.length + 1) * 4, 1, this._scene, false, false, 1, 1);
                }
            }
            this._computeTransformMatrices(this._transformMatrices, null);
            if (this.isUsingTextureForMatrices && this._transformMatrixTexture) this._transformMatrixTexture.update(this._transformMatrices);
        }
        this._isDirty = false;
    }
    /**
     * Gets the list of animatables currently running for this skeleton
     * @returns an array of animatables
     */ getAnimatables() {
        if (!this._animatables || this._animatables.length !== this.bones.length) {
            this._animatables = [];
            for(let index = 0; index < this.bones.length; index++)this._animatables.push(this.bones[index]);
        }
        return this._animatables;
    }
    /**
     * Clone the current skeleton
     * @param name defines the name of the new skeleton
     * @param id defines the id of the new skeleton
     * @returns the new skeleton
     */ clone(name, id) {
        const result = new $2cf8e676d7e00b7e$export$8f31e4c4a37b8e9c(name, id || name, this._scene);
        result.needInitialSkinMatrix = this.needInitialSkinMatrix;
        for(let index = 0; index < this.bones.length; index++){
            const source = this.bones[index];
            let parentBone = null;
            const parent = source.getParent();
            if (parent) {
                const parentIndex = this.bones.indexOf(parent);
                parentBone = result.bones[parentIndex];
            }
            const bone = new (0, $g6X9E.Bone)(source.name, result, parentBone, source.getBindMatrix().clone(), source.getRestMatrix().clone());
            bone._index = source._index;
            if (source._linkedTransformNode) bone.linkTransformNode(source._linkedTransformNode);
            (0, $fhgis.DeepCopier).DeepCopy(source.animations, bone.animations);
        }
        if (this._ranges) {
            result._ranges = {};
            for(const rangeName in this._ranges){
                const range = this._ranges[rangeName];
                if (range) result._ranges[rangeName] = range.clone();
            }
        }
        this._isDirty = true;
        result.prepare(true);
        return result;
    }
    /**
     * Enable animation blending for this skeleton
     * @param blendingSpeed defines the blending speed to apply
     * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#animation-blending
     */ enableBlending(blendingSpeed = 0.01) {
        this.bones.forEach((bone)=>{
            bone.animations.forEach((animation)=>{
                animation.enableBlending = true;
                animation.blendingSpeed = blendingSpeed;
            });
        });
    }
    /**
     * Releases all resources associated with the current skeleton
     */ dispose() {
        this._meshesWithPoseMatrix.length = 0;
        // Animations
        this.getScene().stopAnimation(this);
        // Remove from scene
        this.getScene().removeSkeleton(this);
        if (this._parentContainer) {
            const index = this._parentContainer.skeletons.indexOf(this);
            if (index > -1) this._parentContainer.skeletons.splice(index, 1);
            this._parentContainer = null;
        }
        if (this._transformMatrixTexture) {
            this._transformMatrixTexture.dispose();
            this._transformMatrixTexture = null;
        }
    }
    /**
     * Serialize the skeleton in a JSON object
     * @returns a JSON object
     */ serialize() {
        const serializationObject = {};
        serializationObject.name = this.name;
        serializationObject.id = this.id;
        if (this.dimensionsAtRest) serializationObject.dimensionsAtRest = this.dimensionsAtRest.asArray();
        serializationObject.bones = [];
        serializationObject.needInitialSkinMatrix = this.needInitialSkinMatrix;
        for(let index = 0; index < this.bones.length; index++){
            const bone = this.bones[index];
            const parent = bone.getParent();
            const serializedBone = {
                parentBoneIndex: parent ? this.bones.indexOf(parent) : -1,
                index: bone.getIndex(),
                name: bone.name,
                id: bone.id,
                matrix: bone.getBindMatrix().asArray(),
                rest: bone.getRestMatrix().asArray(),
                linkedTransformNodeId: bone.getTransformNode()?.id
            };
            serializationObject.bones.push(serializedBone);
            if (bone.length) serializedBone.length = bone.length;
            if (bone.metadata) serializedBone.metadata = bone.metadata;
            if (bone.animations && bone.animations.length > 0) serializedBone.animation = bone.animations[0].serialize();
            serializationObject.ranges = [];
            for(const name in this._ranges){
                const source = this._ranges[name];
                if (!source) continue;
                const range = {};
                range.name = name;
                range.from = source.from;
                range.to = source.to;
                serializationObject.ranges.push(range);
            }
        }
        return serializationObject;
    }
    /**
     * Creates a new skeleton from serialized data
     * @param parsedSkeleton defines the serialized data
     * @param scene defines the hosting scene
     * @returns a new skeleton
     */ static Parse(parsedSkeleton, scene) {
        const skeleton = new $2cf8e676d7e00b7e$export$8f31e4c4a37b8e9c(parsedSkeleton.name, parsedSkeleton.id, scene);
        if (parsedSkeleton.dimensionsAtRest) skeleton.dimensionsAtRest = (0, $ha1VO.Vector3).FromArray(parsedSkeleton.dimensionsAtRest);
        skeleton.needInitialSkinMatrix = parsedSkeleton.needInitialSkinMatrix;
        let index;
        for(index = 0; index < parsedSkeleton.bones.length; index++){
            const parsedBone = parsedSkeleton.bones[index];
            const parsedBoneIndex = parsedSkeleton.bones[index].index;
            let parentBone = null;
            if (parsedBone.parentBoneIndex > -1) parentBone = skeleton.bones[parsedBone.parentBoneIndex];
            const rest = parsedBone.rest ? (0, $ha1VO.Matrix).FromArray(parsedBone.rest) : null;
            const bone = new (0, $g6X9E.Bone)(parsedBone.name, skeleton, parentBone, (0, $ha1VO.Matrix).FromArray(parsedBone.matrix), rest, null, parsedBoneIndex);
            if (parsedBone.id !== undefined && parsedBone.id !== null) bone.id = parsedBone.id;
            if (parsedBone.length) bone.length = parsedBone.length;
            if (parsedBone.metadata) bone.metadata = parsedBone.metadata;
            if (parsedBone.animation) bone.animations.push((0, $lWogh.Animation).Parse(parsedBone.animation));
            if (parsedBone.linkedTransformNodeId !== undefined && parsedBone.linkedTransformNodeId !== null) {
                skeleton._hasWaitingData = true;
                bone._waitingTransformNodeId = parsedBone.linkedTransformNodeId;
            }
        }
        // placed after bones, so createAnimationRange can cascade down
        if (parsedSkeleton.ranges) for(index = 0; index < parsedSkeleton.ranges.length; index++){
            const data = parsedSkeleton.ranges[index];
            skeleton.createAnimationRange(data.name, data.from, data.to);
        }
        return skeleton;
    }
    /**
     * Compute all node absolute matrices
     * @param forceUpdate defines if computation must be done even if cache is up to date
     */ computeAbsoluteMatrices(forceUpdate = false) {
        if (this._absoluteTransformIsDirty || forceUpdate) {
            this.bones[0].computeAbsoluteMatrices();
            this._absoluteTransformIsDirty = false;
        }
    }
    /**
     * Compute all node absolute matrices
     * @param forceUpdate defines if computation must be done even if cache is up to date
     * @deprecated Please use computeAbsoluteMatrices instead
     */ computeAbsoluteTransforms(forceUpdate = false) {
        this.computeAbsoluteMatrices(forceUpdate);
    }
    /**
     * Gets the root pose matrix
     * @returns a matrix
     */ getPoseMatrix() {
        let poseMatrix = null;
        if (this._meshesWithPoseMatrix.length > 0) poseMatrix = this._meshesWithPoseMatrix[0].getPoseMatrix();
        return poseMatrix;
    }
    /**
     * Sorts bones per internal index
     */ sortBones() {
        const bones = [];
        const visited = new Array(this.bones.length);
        for(let index = 0; index < this.bones.length; index++)this._sortBones(index, bones, visited);
        this.bones = bones;
    }
    _sortBones(index, bones, visited) {
        if (visited[index]) return;
        visited[index] = true;
        const bone = this.bones[index];
        if (!bone) return;
        if (bone._index === undefined) bone._index = index;
        const parentBone = bone.getParent();
        if (parentBone) this._sortBones(this.bones.indexOf(parentBone), bones, visited);
        bones.push(bone);
    }
    /**
     * Set the current local matrix as the restPose for all bones in the skeleton.
     */ setCurrentPoseAsRest() {
        this.bones.forEach((b)=>{
            b.setCurrentPoseAsRest();
        });
    }
}

});



parcelRegister("bqNL2", function(module, exports) {
/* eslint-disable import/no-internal-modules */ 
var $iGN9L = parcelRequire("iGN9L");

var $ea7T3 = parcelRequire("ea7T3");

var $5RF5W = parcelRequire("5RF5W");
$parcel$exportWildcard(module.exports, $iGN9L);
$parcel$exportWildcard(module.exports, $ea7T3);
$parcel$exportWildcard(module.exports, $5RF5W);

});
parcelRegister("iGN9L", function(module, exports) {

});

parcelRegister("ea7T3", function(module, exports) {

var $7gmZD = parcelRequire("7gmZD");

var $b01pG = parcelRequire("b01pG");

var $jM85r = parcelRequire("jM85r");
$parcel$exportWildcard(module.exports, $7gmZD);
$parcel$exportWildcard(module.exports, $b01pG);
$parcel$exportWildcard(module.exports, $jM85r);

});
parcelRegister("7gmZD", function(module, exports) {

$parcel$export(module.exports, "AutoRotationBehavior", () => $549bdcf6bf9469ac$export$26177590adee994);

var $cfkw4 = parcelRequire("cfkw4");

var $blHSI = parcelRequire("blHSI");

var $53VPf = parcelRequire("53VPf");
class $549bdcf6bf9469ac$export$26177590adee994 {
    constructor(){
        this._zoomStopsAnimation = false;
        this._idleRotationSpeed = 0.05;
        this._idleRotationWaitTime = 2000;
        this._idleRotationSpinupTime = 2000;
        /**
         * Target alpha
         */ this.targetAlpha = null;
        this._isPointerDown = false;
        this._lastFrameTime = null;
        this._lastInteractionTime = -Infinity;
        this._cameraRotationSpeed = 0;
        this._lastFrameRadius = 0;
    }
    /**
     * Gets the name of the behavior.
     */ get name() {
        return "AutoRotation";
    }
    /**
     * Sets the flag that indicates if user zooming should stop animation.
     */ set zoomStopsAnimation(flag) {
        this._zoomStopsAnimation = flag;
    }
    /**
     * Gets the flag that indicates if user zooming should stop animation.
     */ get zoomStopsAnimation() {
        return this._zoomStopsAnimation;
    }
    /**
     * Sets the default speed at which the camera rotates around the model.
     */ set idleRotationSpeed(speed) {
        this._idleRotationSpeed = speed;
    }
    /**
     * Gets the default speed at which the camera rotates around the model.
     */ get idleRotationSpeed() {
        return this._idleRotationSpeed;
    }
    /**
     * Sets the time (in milliseconds) to wait after user interaction before the camera starts rotating.
     */ set idleRotationWaitTime(time) {
        this._idleRotationWaitTime = time;
    }
    /**
     * Gets the time (milliseconds) to wait after user interaction before the camera starts rotating.
     */ get idleRotationWaitTime() {
        return this._idleRotationWaitTime;
    }
    /**
     * Sets the time (milliseconds) to take to spin up to the full idle rotation speed.
     */ set idleRotationSpinupTime(time) {
        this._idleRotationSpinupTime = time;
    }
    /**
     * Gets the time (milliseconds) to take to spin up to the full idle rotation speed.
     */ get idleRotationSpinupTime() {
        return this._idleRotationSpinupTime;
    }
    /**
     * Gets a value indicating if the camera is currently rotating because of this behavior
     */ get rotationInProgress() {
        return Math.abs(this._cameraRotationSpeed) > 0;
    }
    /**
     * Initializes the behavior.
     */ init() {
    // Do nothing
    }
    /**
     * Attaches the behavior to its arc rotate camera.
     * @param camera Defines the camera to attach the behavior to
     */ attach(camera) {
        this._attachedCamera = camera;
        const scene = this._attachedCamera.getScene();
        this._onPrePointerObservableObserver = scene.onPrePointerObservable.add((pointerInfoPre)=>{
            if (pointerInfoPre.type === (0, $cfkw4.PointerEventTypes).POINTERDOWN) {
                this._isPointerDown = true;
                return;
            }
            if (pointerInfoPre.type === (0, $cfkw4.PointerEventTypes).POINTERUP) this._isPointerDown = false;
        });
        this._onAfterCheckInputsObserver = camera.onAfterCheckInputsObservable.add(()=>{
            if (this._reachTargetAlpha()) return;
            const now = (0, $blHSI.PrecisionDate).Now;
            let dt = 0;
            if (this._lastFrameTime != null) dt = now - this._lastFrameTime;
            this._lastFrameTime = now;
            // Stop the animation if there is user interaction and the animation should stop for this interaction
            this._applyUserInteraction();
            const timeToRotation = now - this._lastInteractionTime - this._idleRotationWaitTime;
            const scale = Math.max(Math.min(timeToRotation / this._idleRotationSpinupTime, 1), 0);
            this._cameraRotationSpeed = this._idleRotationSpeed * scale;
            // Step camera rotation by rotation speed
            if (this._attachedCamera) this._attachedCamera.alpha -= this._cameraRotationSpeed * (dt / 1000);
        });
    }
    /**
     * Detaches the behavior from its current arc rotate camera.
     */ detach() {
        if (!this._attachedCamera) return;
        const scene = this._attachedCamera.getScene();
        if (this._onPrePointerObservableObserver) scene.onPrePointerObservable.remove(this._onPrePointerObservableObserver);
        this._attachedCamera.onAfterCheckInputsObservable.remove(this._onAfterCheckInputsObserver);
        this._attachedCamera = null;
    }
    /**
     * Force-reset the last interaction time
     * @param customTime an optional time that will be used instead of the current last interaction time. For example `Date.now()`
     */ resetLastInteractionTime(customTime) {
        this._lastInteractionTime = customTime ?? (0, $blHSI.PrecisionDate).Now;
    }
    /**
     * Returns true if camera alpha reaches the target alpha
     * @returns true if camera alpha reaches the target alpha
     */ _reachTargetAlpha() {
        if (this._attachedCamera && this.targetAlpha) return Math.abs(this._attachedCamera.alpha - this.targetAlpha) < (0, $53VPf.Epsilon);
        return false;
    }
    /**
     * Returns true if user is scrolling.
     * @returns true if user is scrolling.
     */ _userIsZooming() {
        if (!this._attachedCamera) return false;
        return this._attachedCamera.inertialRadiusOffset !== 0;
    }
    _shouldAnimationStopForInteraction() {
        if (!this._attachedCamera) return false;
        let zoomHasHitLimit = false;
        if (this._lastFrameRadius === this._attachedCamera.radius && this._attachedCamera.inertialRadiusOffset !== 0) zoomHasHitLimit = true;
        // Update the record of previous radius - works as an approx. indicator of hitting radius limits
        this._lastFrameRadius = this._attachedCamera.radius;
        return this._zoomStopsAnimation ? zoomHasHitLimit : this._userIsZooming();
    }
    /**
     *  Applies any current user interaction to the camera. Takes into account maximum alpha rotation.
     */ _applyUserInteraction() {
        if (this._userIsMoving() && !this._shouldAnimationStopForInteraction()) this._lastInteractionTime = (0, $blHSI.PrecisionDate).Now;
    }
    // Tools
    _userIsMoving() {
        if (!this._attachedCamera) return false;
        return this._attachedCamera.inertialAlphaOffset !== 0 || this._attachedCamera.inertialBetaOffset !== 0 || this._attachedCamera.inertialRadiusOffset !== 0 || this._attachedCamera.inertialPanningX !== 0 || this._attachedCamera.inertialPanningY !== 0 || this._isPointerDown;
    }
}

});

parcelRegister("b01pG", function(module, exports) {

$parcel$export(module.exports, "BouncingBehavior", () => $8020ca7199b79bd4$export$bdf68dcd10685529);

var $01TD7 = parcelRequire("01TD7");

var $lWogh = parcelRequire("lWogh");
class $8020ca7199b79bd4$export$bdf68dcd10685529 {
    constructor(){
        /**
         * The duration of the animation, in milliseconds
         */ this.transitionDuration = 450;
        /**
         * Length of the distance animated by the transition when lower radius is reached
         */ this.lowerRadiusTransitionRange = 2;
        /**
         * Length of the distance animated by the transition when upper radius is reached
         */ this.upperRadiusTransitionRange = -2;
        this._autoTransitionRange = false;
        // Animations
        this._radiusIsAnimating = false;
        this._radiusBounceTransition = null;
        this._animatables = new Array();
    }
    /**
     * Gets the name of the behavior.
     */ get name() {
        return "Bouncing";
    }
    /**
     * Gets a value indicating if the lowerRadiusTransitionRange and upperRadiusTransitionRange are defined automatically
     */ get autoTransitionRange() {
        return this._autoTransitionRange;
    }
    /**
     * Sets a value indicating if the lowerRadiusTransitionRange and upperRadiusTransitionRange are defined automatically
     * Transition ranges will be set to 5% of the bounding box diagonal in world space
     */ set autoTransitionRange(value) {
        if (this._autoTransitionRange === value) return;
        this._autoTransitionRange = value;
        const camera = this._attachedCamera;
        if (!camera) return;
        if (value) this._onMeshTargetChangedObserver = camera.onMeshTargetChangedObservable.add((transformNode)=>{
            if (!transformNode) return;
            transformNode.computeWorldMatrix(true);
            if (transformNode.getBoundingInfo) {
                const diagonal = transformNode.getBoundingInfo().diagonalLength;
                this.lowerRadiusTransitionRange = diagonal * 0.05;
                this.upperRadiusTransitionRange = diagonal * 0.05;
            }
        });
        else if (this._onMeshTargetChangedObserver) camera.onMeshTargetChangedObservable.remove(this._onMeshTargetChangedObserver);
    }
    /**
     * Initializes the behavior.
     */ init() {
    // Do nothing
    }
    /**
     * Attaches the behavior to its arc rotate camera.
     * @param camera Defines the camera to attach the behavior to
     */ attach(camera) {
        this._attachedCamera = camera;
        this._onAfterCheckInputsObserver = camera.onAfterCheckInputsObservable.add(()=>{
            if (!this._attachedCamera) return;
            // Add the bounce animation to the lower radius limit
            if (this._isRadiusAtLimit(this._attachedCamera.lowerRadiusLimit)) this._applyBoundRadiusAnimation(this.lowerRadiusTransitionRange);
            // Add the bounce animation to the upper radius limit
            if (this._isRadiusAtLimit(this._attachedCamera.upperRadiusLimit)) this._applyBoundRadiusAnimation(this.upperRadiusTransitionRange);
        });
    }
    /**
     * Detaches the behavior from its current arc rotate camera.
     */ detach() {
        if (!this._attachedCamera) return;
        if (this._onAfterCheckInputsObserver) this._attachedCamera.onAfterCheckInputsObservable.remove(this._onAfterCheckInputsObserver);
        if (this._onMeshTargetChangedObserver) this._attachedCamera.onMeshTargetChangedObservable.remove(this._onMeshTargetChangedObserver);
        this._attachedCamera = null;
    }
    /**
     * Checks if the camera radius is at the specified limit. Takes into account animation locks.
     * @param radiusLimit The limit to check against.
     * @returns Bool to indicate if at limit.
     */ _isRadiusAtLimit(radiusLimit) {
        if (!this._attachedCamera) return false;
        if (this._attachedCamera.radius === radiusLimit && !this._radiusIsAnimating) return true;
        return false;
    }
    /**
     * Applies an animation to the radius of the camera, extending by the radiusDelta.
     * @param radiusDelta The delta by which to animate to. Can be negative.
     */ _applyBoundRadiusAnimation(radiusDelta) {
        if (!this._attachedCamera) return;
        if (!this._radiusBounceTransition) {
            $8020ca7199b79bd4$export$bdf68dcd10685529.EasingFunction.setEasingMode($8020ca7199b79bd4$export$bdf68dcd10685529.EasingMode);
            this._radiusBounceTransition = (0, $lWogh.Animation).CreateAnimation("radius", (0, $lWogh.Animation).ANIMATIONTYPE_FLOAT, 60, $8020ca7199b79bd4$export$bdf68dcd10685529.EasingFunction);
        }
        // Prevent zoom until bounce has completed
        this._cachedWheelPrecision = this._attachedCamera.wheelPrecision;
        this._attachedCamera.wheelPrecision = Infinity;
        this._attachedCamera.inertialRadiusOffset = 0;
        // Animate to the radius limit
        this.stopAllAnimations();
        this._radiusIsAnimating = true;
        const animatable = (0, $lWogh.Animation).TransitionTo("radius", this._attachedCamera.radius + radiusDelta, this._attachedCamera, this._attachedCamera.getScene(), 60, this._radiusBounceTransition, this.transitionDuration, ()=>this._clearAnimationLocks());
        if (animatable) this._animatables.push(animatable);
    }
    /**
     * Removes all animation locks. Allows new animations to be added to any of the camera properties.
     */ _clearAnimationLocks() {
        this._radiusIsAnimating = false;
        if (this._attachedCamera) this._attachedCamera.wheelPrecision = this._cachedWheelPrecision;
    }
    /**
     * Stops and removes all animations that have been applied to the camera
     */ stopAllAnimations() {
        if (this._attachedCamera) this._attachedCamera.animations = [];
        while(this._animatables.length){
            this._animatables[0].onAnimationEnd = null;
            this._animatables[0].stop();
            this._animatables.shift();
        }
    }
}
/**
 * The easing function used by animations
 */ $8020ca7199b79bd4$export$bdf68dcd10685529.EasingFunction = new (0, $01TD7.BackEase)(0.3);
/**
 * The easing mode used by animations
 */ $8020ca7199b79bd4$export$bdf68dcd10685529.EasingMode = (0, $01TD7.EasingFunction).EASINGMODE_EASEOUT;

});

parcelRegister("jM85r", function(module, exports) {

$parcel$export(module.exports, "FramingBehavior", () => $e658c5daf376ba2a$export$77fc4267b4cbd0a1);

var $01TD7 = parcelRequire("01TD7");

var $diGQf = parcelRequire("diGQf");

var $cfkw4 = parcelRequire("cfkw4");

var $blHSI = parcelRequire("blHSI");

var $ha1VO = parcelRequire("ha1VO");

var $lWogh = parcelRequire("lWogh");
class $e658c5daf376ba2a$export$77fc4267b4cbd0a1 {
    constructor(){
        /**
         * An event triggered when the animation to zoom on target mesh has ended
         */ this.onTargetFramingAnimationEndObservable = new (0, $diGQf.Observable)();
        this._mode = $e658c5daf376ba2a$export$77fc4267b4cbd0a1.FitFrustumSidesMode;
        this._radiusScale = 1.0;
        this._positionScale = 0.5;
        this._defaultElevation = 0.3;
        this._elevationReturnTime = 1500;
        this._elevationReturnWaitTime = 1000;
        this._zoomStopsAnimation = false;
        this._framingTime = 1500;
        /**
         * Define if the behavior should automatically change the configured
         * camera limits and sensibilities.
         */ this.autoCorrectCameraLimitsAndSensibility = true;
        this._isPointerDown = false;
        this._lastInteractionTime = -Infinity;
        // Framing control
        this._animatables = new Array();
        this._betaIsAnimating = false;
    }
    /**
     * Gets the name of the behavior.
     */ get name() {
        return "Framing";
    }
    /**
     * Sets the current mode used by the behavior
     */ set mode(mode) {
        this._mode = mode;
    }
    /**
     * Gets current mode used by the behavior.
     */ get mode() {
        return this._mode;
    }
    /**
     * Sets the scale applied to the radius (1 by default)
     */ set radiusScale(radius) {
        this._radiusScale = radius;
    }
    /**
     * Gets the scale applied to the radius
     */ get radiusScale() {
        return this._radiusScale;
    }
    /**
     * Sets the scale to apply on Y axis to position camera focus. 0.5 by default which means the center of the bounding box.
     */ set positionScale(scale) {
        this._positionScale = scale;
    }
    /**
     * Gets the scale to apply on Y axis to position camera focus. 0.5 by default which means the center of the bounding box.
     */ get positionScale() {
        return this._positionScale;
    }
    /**
     * Sets the angle above/below the horizontal plane to return to when the return to default elevation idle
     * behaviour is triggered, in radians.
     */ set defaultElevation(elevation) {
        this._defaultElevation = elevation;
    }
    /**
     * Gets the angle above/below the horizontal plane to return to when the return to default elevation idle
     * behaviour is triggered, in radians.
     */ get defaultElevation() {
        return this._defaultElevation;
    }
    /**
     * Sets the time (in milliseconds) taken to return to the default beta position.
     * Negative value indicates camera should not return to default.
     */ set elevationReturnTime(speed) {
        this._elevationReturnTime = speed;
    }
    /**
     * Gets the time (in milliseconds) taken to return to the default beta position.
     * Negative value indicates camera should not return to default.
     */ get elevationReturnTime() {
        return this._elevationReturnTime;
    }
    /**
     * Sets the delay (in milliseconds) taken before the camera returns to the default beta position.
     */ set elevationReturnWaitTime(time) {
        this._elevationReturnWaitTime = time;
    }
    /**
     * Gets the delay (in milliseconds) taken before the camera returns to the default beta position.
     */ get elevationReturnWaitTime() {
        return this._elevationReturnWaitTime;
    }
    /**
     * Sets the flag that indicates if user zooming should stop animation.
     */ set zoomStopsAnimation(flag) {
        this._zoomStopsAnimation = flag;
    }
    /**
     * Gets the flag that indicates if user zooming should stop animation.
     */ get zoomStopsAnimation() {
        return this._zoomStopsAnimation;
    }
    /**
     * Sets the transition time when framing the mesh, in milliseconds
     */ set framingTime(time) {
        this._framingTime = time;
    }
    /**
     * Gets the transition time when framing the mesh, in milliseconds
     */ get framingTime() {
        return this._framingTime;
    }
    /**
     * Initializes the behavior.
     */ init() {
    // Do nothing
    }
    /**
     * Attaches the behavior to its arc rotate camera.
     * @param camera Defines the camera to attach the behavior to
     */ attach(camera) {
        this._attachedCamera = camera;
        const scene = this._attachedCamera.getScene();
        $e658c5daf376ba2a$export$77fc4267b4cbd0a1.EasingFunction.setEasingMode($e658c5daf376ba2a$export$77fc4267b4cbd0a1.EasingMode);
        this._onPrePointerObservableObserver = scene.onPrePointerObservable.add((pointerInfoPre)=>{
            if (pointerInfoPre.type === (0, $cfkw4.PointerEventTypes).POINTERDOWN) {
                this._isPointerDown = true;
                return;
            }
            if (pointerInfoPre.type === (0, $cfkw4.PointerEventTypes).POINTERUP) this._isPointerDown = false;
        });
        this._onMeshTargetChangedObserver = camera.onMeshTargetChangedObservable.add((transformNode)=>{
            if (transformNode && transformNode.getBoundingInfo) this.zoomOnMesh(transformNode, undefined, ()=>{
                this.onTargetFramingAnimationEndObservable.notifyObservers();
            });
        });
        this._onAfterCheckInputsObserver = camera.onAfterCheckInputsObservable.add(()=>{
            // Stop the animation if there is user interaction and the animation should stop for this interaction
            this._applyUserInteraction();
            // Maintain the camera above the ground. If the user pulls the camera beneath the ground plane, lift it
            // back to the default position after a given timeout
            this._maintainCameraAboveGround();
        });
    }
    /**
     * Detaches the behavior from its current arc rotate camera.
     */ detach() {
        if (!this._attachedCamera) return;
        const scene = this._attachedCamera.getScene();
        if (this._onPrePointerObservableObserver) scene.onPrePointerObservable.remove(this._onPrePointerObservableObserver);
        if (this._onAfterCheckInputsObserver) this._attachedCamera.onAfterCheckInputsObservable.remove(this._onAfterCheckInputsObserver);
        if (this._onMeshTargetChangedObserver) this._attachedCamera.onMeshTargetChangedObservable.remove(this._onMeshTargetChangedObserver);
        this._attachedCamera = null;
    }
    /**
     * Targets the given mesh and updates zoom level accordingly.
     * @param mesh  The mesh to target.
     * @param focusOnOriginXZ Determines if the camera should focus on 0 in the X and Z axis instead of the mesh
     * @param onAnimationEnd Callback triggered at the end of the framing animation
     */ zoomOnMesh(mesh, focusOnOriginXZ = false, onAnimationEnd = null) {
        mesh.computeWorldMatrix(true);
        const boundingBox = mesh.getBoundingInfo().boundingBox;
        this.zoomOnBoundingInfo(boundingBox.minimumWorld, boundingBox.maximumWorld, focusOnOriginXZ, onAnimationEnd);
    }
    /**
     * Targets the given mesh with its children and updates zoom level accordingly.
     * @param mesh  The mesh to target.
     * @param focusOnOriginXZ Determines if the camera should focus on 0 in the X and Z axis instead of the mesh
     * @param onAnimationEnd Callback triggered at the end of the framing animation
     */ zoomOnMeshHierarchy(mesh, focusOnOriginXZ = false, onAnimationEnd = null) {
        mesh.computeWorldMatrix(true);
        const boundingBox = mesh.getHierarchyBoundingVectors(true);
        this.zoomOnBoundingInfo(boundingBox.min, boundingBox.max, focusOnOriginXZ, onAnimationEnd);
    }
    /**
     * Targets the given meshes with their children and updates zoom level accordingly.
     * @param meshes  The mesh to target.
     * @param focusOnOriginXZ Determines if the camera should focus on 0 in the X and Z axis instead of the mesh
     * @param onAnimationEnd Callback triggered at the end of the framing animation
     */ zoomOnMeshesHierarchy(meshes, focusOnOriginXZ = false, onAnimationEnd = null) {
        const min = new (0, $ha1VO.Vector3)(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
        const max = new (0, $ha1VO.Vector3)(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
        for(let i = 0; i < meshes.length; i++){
            const boundingInfo = meshes[i].getHierarchyBoundingVectors(true);
            (0, $ha1VO.Vector3).CheckExtends(boundingInfo.min, min, max);
            (0, $ha1VO.Vector3).CheckExtends(boundingInfo.max, min, max);
        }
        this.zoomOnBoundingInfo(min, max, focusOnOriginXZ, onAnimationEnd);
    }
    /**
     * Targets the bounding box info defined by its extends and updates zoom level accordingly.
     * @param minimumWorld Determines the smaller position of the bounding box extend
     * @param maximumWorld Determines the bigger position of the bounding box extend
     * @param focusOnOriginXZ Determines if the camera should focus on 0 in the X and Z axis instead of the mesh
     * @param onAnimationEnd Callback triggered at the end of the framing animation
     * @returns true if the zoom was done
     */ zoomOnBoundingInfo(minimumWorld, maximumWorld, focusOnOriginXZ = false, onAnimationEnd = null) {
        let zoomTarget;
        if (!this._attachedCamera) return false;
        // Find target by interpolating from bottom of bounding box in world-space to top via framingPositionY
        const bottom = minimumWorld.y;
        const top = maximumWorld.y;
        const zoomTargetY = bottom + (top - bottom) * this._positionScale;
        const radiusWorld = maximumWorld.subtract(minimumWorld).scale(0.5);
        if (focusOnOriginXZ) zoomTarget = new (0, $ha1VO.Vector3)(0, zoomTargetY, 0);
        else {
            const centerWorld = minimumWorld.add(radiusWorld);
            zoomTarget = new (0, $ha1VO.Vector3)(centerWorld.x, zoomTargetY, centerWorld.z);
        }
        if (!this._vectorTransition) this._vectorTransition = (0, $lWogh.Animation).CreateAnimation("target", (0, $lWogh.Animation).ANIMATIONTYPE_VECTOR3, 60, $e658c5daf376ba2a$export$77fc4267b4cbd0a1.EasingFunction);
        this._betaIsAnimating = true;
        let animatable = (0, $lWogh.Animation).TransitionTo("target", zoomTarget, this._attachedCamera, this._attachedCamera.getScene(), 60, this._vectorTransition, this._framingTime);
        if (animatable) this._animatables.push(animatable);
        // sets the radius and lower radius bounds
        // Small delta ensures camera is not always at lower zoom limit.
        let radius = 0;
        if (this._mode === $e658c5daf376ba2a$export$77fc4267b4cbd0a1.FitFrustumSidesMode) {
            const position = this._calculateLowerRadiusFromModelBoundingSphere(minimumWorld, maximumWorld);
            if (this.autoCorrectCameraLimitsAndSensibility) this._attachedCamera.lowerRadiusLimit = radiusWorld.length() + this._attachedCamera.minZ;
            radius = position;
        } else if (this._mode === $e658c5daf376ba2a$export$77fc4267b4cbd0a1.IgnoreBoundsSizeMode) {
            radius = this._calculateLowerRadiusFromModelBoundingSphere(minimumWorld, maximumWorld);
            if (this.autoCorrectCameraLimitsAndSensibility && this._attachedCamera.lowerRadiusLimit === null) this._attachedCamera.lowerRadiusLimit = this._attachedCamera.minZ;
        }
        // Set sensibilities
        if (this.autoCorrectCameraLimitsAndSensibility) {
            const extend = maximumWorld.subtract(minimumWorld).length();
            this._attachedCamera.panningSensibility = 5000 / extend;
            this._attachedCamera.wheelPrecision = 100 / radius;
        }
        // transition to new radius
        if (!this._radiusTransition) this._radiusTransition = (0, $lWogh.Animation).CreateAnimation("radius", (0, $lWogh.Animation).ANIMATIONTYPE_FLOAT, 60, $e658c5daf376ba2a$export$77fc4267b4cbd0a1.EasingFunction);
        animatable = (0, $lWogh.Animation).TransitionTo("radius", radius, this._attachedCamera, this._attachedCamera.getScene(), 60, this._radiusTransition, this._framingTime, ()=>{
            this.stopAllAnimations();
            if (onAnimationEnd) onAnimationEnd();
            if (this._attachedCamera && this._attachedCamera.useInputToRestoreState) this._attachedCamera.storeState();
        });
        if (animatable) this._animatables.push(animatable);
        return true;
    }
    /**
     * Calculates the lowest radius for the camera based on the bounding box of the mesh.
     * @param minimumWorld
     * @param maximumWorld
     * @returns The minimum distance from the primary mesh's center point at which the camera must be kept in order
     *		 to fully enclose the mesh in the viewing frustum.
     */ _calculateLowerRadiusFromModelBoundingSphere(minimumWorld, maximumWorld) {
        const camera = this._attachedCamera;
        if (!camera) return 0;
        let distance = camera._calculateLowerRadiusFromModelBoundingSphere(minimumWorld, maximumWorld, this._radiusScale);
        if (camera.lowerRadiusLimit && this._mode === $e658c5daf376ba2a$export$77fc4267b4cbd0a1.IgnoreBoundsSizeMode) // Don't exceed the requested limit
        distance = distance < camera.lowerRadiusLimit ? camera.lowerRadiusLimit : distance;
        // Don't exceed the upper radius limit
        if (camera.upperRadiusLimit) distance = distance > camera.upperRadiusLimit ? camera.upperRadiusLimit : distance;
        return distance;
    }
    /**
     * Keeps the camera above the ground plane. If the user pulls the camera below the ground plane, the camera
     * is automatically returned to its default position (expected to be above ground plane).
     */ _maintainCameraAboveGround() {
        if (this._elevationReturnTime < 0) return;
        const timeSinceInteraction = (0, $blHSI.PrecisionDate).Now - this._lastInteractionTime;
        const defaultBeta = Math.PI * 0.5 - this._defaultElevation;
        const limitBeta = Math.PI * 0.5;
        // Bring the camera back up if below the ground plane
        if (this._attachedCamera && !this._betaIsAnimating && this._attachedCamera.beta > limitBeta && timeSinceInteraction >= this._elevationReturnWaitTime) {
            this._betaIsAnimating = true;
            //Transition to new position
            this.stopAllAnimations();
            if (!this._betaTransition) this._betaTransition = (0, $lWogh.Animation).CreateAnimation("beta", (0, $lWogh.Animation).ANIMATIONTYPE_FLOAT, 60, $e658c5daf376ba2a$export$77fc4267b4cbd0a1.EasingFunction);
            const animatabe = (0, $lWogh.Animation).TransitionTo("beta", defaultBeta, this._attachedCamera, this._attachedCamera.getScene(), 60, this._betaTransition, this._elevationReturnTime, ()=>{
                this._clearAnimationLocks();
                this.stopAllAnimations();
            });
            if (animatabe) this._animatables.push(animatabe);
        }
    }
    /**
     * Removes all animation locks. Allows new animations to be added to any of the arcCamera properties.
     */ _clearAnimationLocks() {
        this._betaIsAnimating = false;
    }
    /**
     *  Applies any current user interaction to the camera. Takes into account maximum alpha rotation.
     */ _applyUserInteraction() {
        if (this.isUserIsMoving) {
            this._lastInteractionTime = (0, $blHSI.PrecisionDate).Now;
            this.stopAllAnimations();
            this._clearAnimationLocks();
        }
    }
    /**
     * Stops and removes all animations that have been applied to the camera
     */ stopAllAnimations() {
        if (this._attachedCamera) this._attachedCamera.animations = [];
        while(this._animatables.length){
            if (this._animatables[0]) {
                this._animatables[0].onAnimationEnd = null;
                this._animatables[0].stop();
            }
            this._animatables.shift();
        }
    }
    /**
     * Gets a value indicating if the user is moving the camera
     */ get isUserIsMoving() {
        if (!this._attachedCamera) return false;
        return this._attachedCamera.inertialAlphaOffset !== 0 || this._attachedCamera.inertialBetaOffset !== 0 || this._attachedCamera.inertialRadiusOffset !== 0 || this._attachedCamera.inertialPanningX !== 0 || this._attachedCamera.inertialPanningY !== 0 || this._isPointerDown;
    }
}
/**
 * The easing function used by animations
 */ $e658c5daf376ba2a$export$77fc4267b4cbd0a1.EasingFunction = new (0, $01TD7.ExponentialEase)();
/**
 * The easing mode used by animations
 */ $e658c5daf376ba2a$export$77fc4267b4cbd0a1.EasingMode = (0, $01TD7.EasingFunction).EASINGMODE_EASEINOUT;
// Statics
/**
 * The camera can move all the way towards the mesh.
 */ $e658c5daf376ba2a$export$77fc4267b4cbd0a1.IgnoreBoundsSizeMode = 0;
/**
 * The camera is not allowed to zoom closer to the mesh than the point at which the adjusted bounding sphere touches the frustum sides
 */ $e658c5daf376ba2a$export$77fc4267b4cbd0a1.FitFrustumSidesMode = 1;

});


parcelRegister("5RF5W", function(module, exports) {

var $kFNMc = parcelRequire("kFNMc");

var $hRfxv = parcelRequire("hRfxv");

var $aQmzV = parcelRequire("aQmzV");

var $dnn9Q = parcelRequire("dnn9Q");

var $bJA9r = parcelRequire("bJA9r");

var $jSdrl = parcelRequire("jSdrl");

var $hOMth = parcelRequire("hOMth");

var $4XPoq = parcelRequire("4XPoq");

var $fp9Sb = parcelRequire("fp9Sb");
$parcel$exportWildcard(module.exports, $kFNMc);
$parcel$exportWildcard(module.exports, $hRfxv);
$parcel$exportWildcard(module.exports, $aQmzV);
$parcel$exportWildcard(module.exports, $dnn9Q);
$parcel$exportWildcard(module.exports, $bJA9r);
$parcel$exportWildcard(module.exports, $jSdrl);
$parcel$exportWildcard(module.exports, $hOMth);
$parcel$exportWildcard(module.exports, $4XPoq);
$parcel$exportWildcard(module.exports, $fp9Sb);

});
parcelRegister("kFNMc", function(module, exports) {

$parcel$export(module.exports, "AttachToBoxBehavior", () => $f0ce3f8ba9c40b02$export$22c17b3259fdee1a);

var $ha1VO = parcelRequire("ha1VO");
/**
 * @internal
 */ class $f0ce3f8ba9c40b02$var$FaceDirectionInfo {
    constructor(direction, rotatedDirection = new (0, $ha1VO.Vector3)(), diff = 0, ignore = false){
        this.direction = direction;
        this.rotatedDirection = rotatedDirection;
        this.diff = diff;
        this.ignore = ignore;
    }
}
class $f0ce3f8ba9c40b02$export$22c17b3259fdee1a {
    /**
     * Creates the AttachToBoxBehavior, used to attach UI to the closest face of the box to a camera
     * @param _ui The transform node that should be attached to the mesh
     */ constructor(_ui){
        this._ui = _ui;
        /**
         *  The name of the behavior
         */ this.name = "AttachToBoxBehavior";
        /**
         * The distance away from the face of the mesh that the UI should be attached to (default: 0.15)
         */ this.distanceAwayFromFace = 0.15;
        /**
         * The distance from the bottom of the face that the UI should be attached to (default: 0.15)
         */ this.distanceAwayFromBottomOfFace = 0.15;
        this._faceVectors = [
            new $f0ce3f8ba9c40b02$var$FaceDirectionInfo((0, $ha1VO.Vector3).Up()),
            new $f0ce3f8ba9c40b02$var$FaceDirectionInfo((0, $ha1VO.Vector3).Down()),
            new $f0ce3f8ba9c40b02$var$FaceDirectionInfo((0, $ha1VO.Vector3).Left()),
            new $f0ce3f8ba9c40b02$var$FaceDirectionInfo((0, $ha1VO.Vector3).Right()),
            new $f0ce3f8ba9c40b02$var$FaceDirectionInfo((0, $ha1VO.Vector3).Forward()),
            new $f0ce3f8ba9c40b02$var$FaceDirectionInfo((0, $ha1VO.Vector3).Forward().scaleInPlace(-1))
        ];
        this._tmpMatrix = new (0, $ha1VO.Matrix)();
        this._tmpVector = new (0, $ha1VO.Vector3)();
        this._zeroVector = (0, $ha1VO.Vector3).Zero();
        this._lookAtTmpMatrix = new (0, $ha1VO.Matrix)();
    /* Does nothing */ }
    /**
     *  Initializes the behavior
     */ init() {
    /* Does nothing */ }
    _closestFace(targetDirection) {
        // Go over each face and calculate the angle between the face's normal and targetDirection
        this._faceVectors.forEach((v)=>{
            if (!this._target.rotationQuaternion) this._target.rotationQuaternion = (0, $ha1VO.Quaternion).RotationYawPitchRoll(this._target.rotation.y, this._target.rotation.x, this._target.rotation.z);
            this._target.rotationQuaternion.toRotationMatrix(this._tmpMatrix);
            (0, $ha1VO.Vector3).TransformCoordinatesToRef(v.direction, this._tmpMatrix, v.rotatedDirection);
            v.diff = (0, $ha1VO.Vector3).GetAngleBetweenVectors(v.rotatedDirection, targetDirection, (0, $ha1VO.Vector3).Cross(v.rotatedDirection, targetDirection));
        });
        // Return the face information of the one with the normal closest to target direction
        return this._faceVectors.reduce((min, p)=>{
            if (min.ignore) return p;
            else if (p.ignore) return min;
            else return min.diff < p.diff ? min : p;
        }, this._faceVectors[0]);
    }
    _lookAtToRef(pos, up = new (0, $ha1VO.Vector3)(0, 1, 0), ref) {
        (0, $ha1VO.Matrix).LookAtLHToRef(this._zeroVector, pos, up, this._lookAtTmpMatrix);
        this._lookAtTmpMatrix.invert();
        (0, $ha1VO.Quaternion).FromRotationMatrixToRef(this._lookAtTmpMatrix, ref);
    }
    /**
     * Attaches the AttachToBoxBehavior to the passed in mesh
     * @param target The mesh that the specified node will be attached to
     */ attach(target) {
        this._target = target;
        this._scene = this._target.getScene();
        // Every frame, update the app bars position
        this._onRenderObserver = this._scene.onBeforeRenderObservable.add(()=>{
            if (!this._scene.activeCamera) return;
            // Find the face closest to the cameras position
            let cameraPos = this._scene.activeCamera.position;
            if (this._scene.activeCamera.devicePosition) cameraPos = this._scene.activeCamera.devicePosition;
            const facing = this._closestFace(cameraPos.subtract(target.position));
            if (this._scene.activeCamera.leftCamera) this._scene.activeCamera.leftCamera.computeWorldMatrix().getRotationMatrixToRef(this._tmpMatrix);
            else this._scene.activeCamera.computeWorldMatrix().getRotationMatrixToRef(this._tmpMatrix);
            // Get camera up direction
            (0, $ha1VO.Vector3).TransformCoordinatesToRef((0, $ha1VO.Vector3).Up(), this._tmpMatrix, this._tmpVector);
            // Ignore faces to not select a parallel face for the up vector of the UI
            this._faceVectors.forEach((v)=>{
                if (facing.direction.x && v.direction.x) v.ignore = true;
                if (facing.direction.y && v.direction.y) v.ignore = true;
                if (facing.direction.z && v.direction.z) v.ignore = true;
            });
            const facingUp = this._closestFace(this._tmpVector);
            // Unignore faces
            this._faceVectors.forEach((v)=>{
                v.ignore = false;
            });
            // Position the app bar on that face
            this._ui.position.copyFrom(target.position);
            if (facing.direction.x) {
                facing.rotatedDirection.scaleToRef(target.scaling.x / 2 + this.distanceAwayFromFace, this._tmpVector);
                this._ui.position.addInPlace(this._tmpVector);
            }
            if (facing.direction.y) {
                facing.rotatedDirection.scaleToRef(target.scaling.y / 2 + this.distanceAwayFromFace, this._tmpVector);
                this._ui.position.addInPlace(this._tmpVector);
            }
            if (facing.direction.z) {
                facing.rotatedDirection.scaleToRef(target.scaling.z / 2 + this.distanceAwayFromFace, this._tmpVector);
                this._ui.position.addInPlace(this._tmpVector);
            }
            // Rotate to be oriented properly to the camera
            if (!this._ui.rotationQuaternion) this._ui.rotationQuaternion = (0, $ha1VO.Quaternion).RotationYawPitchRoll(this._ui.rotation.y, this._ui.rotation.x, this._ui.rotation.z);
            facing.rotatedDirection.scaleToRef(-1, this._tmpVector);
            this._lookAtToRef(this._tmpVector, facingUp.rotatedDirection, this._ui.rotationQuaternion);
            // Place ui the correct distance from the bottom of the mesh
            if (facingUp.direction.x) this._ui.up.scaleToRef(this.distanceAwayFromBottomOfFace - target.scaling.x / 2, this._tmpVector);
            if (facingUp.direction.y) this._ui.up.scaleToRef(this.distanceAwayFromBottomOfFace - target.scaling.y / 2, this._tmpVector);
            if (facingUp.direction.z) this._ui.up.scaleToRef(this.distanceAwayFromBottomOfFace - target.scaling.z / 2, this._tmpVector);
            this._ui.position.addInPlace(this._tmpVector);
        });
    }
    /**
     *  Detaches the behavior from the mesh
     */ detach() {
        this._scene.onBeforeRenderObservable.remove(this._onRenderObserver);
    }
}

});

parcelRegister("hRfxv", function(module, exports) {

$parcel$export(module.exports, "FadeInOutBehavior", () => $d00370b4554f4908$export$6a123a6413a66ab6);
/**
 * A behavior that when attached to a mesh will allow the mesh to fade in and out
 */ class $d00370b4554f4908$export$6a123a6413a66ab6 {
    /**
     * Time in milliseconds to delay before fading in (Default: 0)
     * Will set both fade in and out delay to the same value
     */ get delay() {
        return this.fadeInDelay;
    }
    set delay(value) {
        this.fadeInDelay = value;
        this.fadeOutDelay = value;
    }
    /**
     * Instantiates the FadeInOutBehavior
     */ constructor(){
        /**
         * Time in milliseconds to delay before fading in (Default: 0)
         */ this.fadeInDelay = 0;
        /**
         * Time in milliseconds to delay before fading out (Default: 0)
         */ this.fadeOutDelay = 0;
        /**
         * Time in milliseconds for the mesh to fade in (Default: 300)
         */ this.fadeInTime = 300;
        /**
         * Time in milliseconds for the mesh to fade out (Default: 300)
         */ this.fadeOutTime = 300;
        this._millisecondsPerFrame = 1000 / 60;
        this._hovered = false;
        this._hoverValue = 0;
        this._ownerNode = null;
        this._delay = 0;
        this._time = 300;
        this._update = ()=>{
            if (this._ownerNode) {
                this._hoverValue += this._hovered ? this._millisecondsPerFrame : -this._millisecondsPerFrame;
                this._setAllVisibility(this._ownerNode, (this._hoverValue - this._delay) / this._time);
                if (this._ownerNode.visibility > 1) {
                    this._setAllVisibility(this._ownerNode, 1);
                    if (this._hoverValue > this._time) {
                        this._hoverValue = this._time;
                        this._detachObserver();
                        return;
                    }
                } else if (this._ownerNode.visibility < 0) {
                    this._setAllVisibility(this._ownerNode, 0);
                    if (this._hoverValue < 0) {
                        this._hoverValue = 0;
                        this._detachObserver();
                        return;
                    }
                }
                this._attachObserver();
            }
        };
    }
    /**
     *  The name of the behavior
     */ get name() {
        return "FadeInOut";
    }
    /**
     *  Initializes the behavior
     */ init() {}
    /**
     * Attaches the fade behavior on the passed in mesh
     * @param ownerNode The mesh that will be faded in/out once attached
     */ attach(ownerNode) {
        this._ownerNode = ownerNode;
        this._setAllVisibility(this._ownerNode, 0);
    }
    /**
     *  Detaches the behavior from the mesh
     */ detach() {
        this._ownerNode = null;
    }
    /**
     * Triggers the mesh to begin fading in (or out)
     * @param fadeIn if the object should fade in or out (true to fade in)
     */ fadeIn(fadeIn = true) {
        this._delay = fadeIn ? this.fadeInDelay : this.fadeOutDelay;
        this._time = fadeIn ? this.fadeInTime : this.fadeOutTime;
        // Cancel any pending updates
        this._detachObserver();
        // If fading in and already visible or fading out and already not visible do nothing
        if (this._ownerNode && (fadeIn && this._ownerNode.visibility >= 1 || !fadeIn && this._ownerNode.visibility <= 0)) return;
        this._hovered = fadeIn;
        if (!this._hovered) // Make the delay the negative of fadeout delay so the hoverValue is kept above 1 until
        // fadeOutDelay has elapsed
        this._delay *= -1;
        // Reset the hoverValue.  This is necessary because we may have been fading out, e.g. but not yet reached
        // the delay, so the hover value is greater than 1
        if (this._ownerNode.visibility >= 1) this._hoverValue = this._time;
        else if (this._ownerNode.visibility <= 0) this._hoverValue = 0;
        this._update();
    }
    /**
     * Triggers the mesh to begin fading out
     */ fadeOut() {
        this.fadeIn(false);
    }
    _setAllVisibility(mesh, value) {
        mesh.visibility = value;
        mesh.getChildMeshes().forEach((c)=>{
            this._setAllVisibility(c, value);
        });
    }
    _attachObserver() {
        if (!this._onBeforeRenderObserver) this._onBeforeRenderObserver = this._ownerNode?.getScene().onBeforeRenderObservable.add(this._update);
    }
    _detachObserver() {
        if (this._onBeforeRenderObserver) {
            this._ownerNode?.getScene().onBeforeRenderObservable.remove(this._onBeforeRenderObserver);
            this._onBeforeRenderObserver = null;
        }
    }
}

});

parcelRegister("aQmzV", function(module, exports) {

$parcel$export(module.exports, "MultiPointerScaleBehavior", () => $7e5046546946c5c8$export$1b0595ce87b66c47);

var $dnn9Q = parcelRequire("dnn9Q");

var $ha1VO = parcelRequire("ha1VO");
class $7e5046546946c5c8$export$1b0595ce87b66c47 {
    /**
     * Instantiate a new behavior that when attached to a mesh will allow the mesh to be scaled
     */ constructor(){
        this._startDistance = 0;
        this._initialScale = new (0, $ha1VO.Vector3)(0, 0, 0);
        this._targetScale = new (0, $ha1VO.Vector3)(0, 0, 0);
        this._sceneRenderObserver = null;
        this._dragBehaviorA = new (0, $dnn9Q.PointerDragBehavior)({});
        this._dragBehaviorA.moveAttached = false;
        this._dragBehaviorB = new (0, $dnn9Q.PointerDragBehavior)({});
        this._dragBehaviorB.moveAttached = false;
    }
    /**
     *  The name of the behavior
     */ get name() {
        return "MultiPointerScale";
    }
    /**
     *  Initializes the behavior
     */ init() {}
    _getCurrentDistance() {
        return this._dragBehaviorA.lastDragPosition.subtract(this._dragBehaviorB.lastDragPosition).length();
    }
    /**
     * Attaches the scale behavior the passed in mesh
     * @param ownerNode The mesh that will be scaled around once attached
     */ attach(ownerNode) {
        this._ownerNode = ownerNode;
        // Create 2 drag behaviors such that each will only be triggered by a separate pointer
        this._dragBehaviorA.onDragStartObservable.add(()=>{
            if (this._dragBehaviorA.dragging && this._dragBehaviorB.dragging) {
                if (this._dragBehaviorA.currentDraggingPointerId == this._dragBehaviorB.currentDraggingPointerId) this._dragBehaviorA.releaseDrag();
                else {
                    this._initialScale.copyFrom(ownerNode.scaling);
                    this._startDistance = this._getCurrentDistance();
                }
            }
        });
        this._dragBehaviorB.onDragStartObservable.add(()=>{
            if (this._dragBehaviorA.dragging && this._dragBehaviorB.dragging) {
                if (this._dragBehaviorA.currentDraggingPointerId == this._dragBehaviorB.currentDraggingPointerId) this._dragBehaviorB.releaseDrag();
                else {
                    this._initialScale.copyFrom(ownerNode.scaling);
                    this._startDistance = this._getCurrentDistance();
                }
            }
        });
        // Once both drag behaviors are active scale based on the distance between the two pointers
        [
            this._dragBehaviorA,
            this._dragBehaviorB
        ].forEach((behavior)=>{
            behavior.onDragObservable.add(()=>{
                if (this._dragBehaviorA.dragging && this._dragBehaviorB.dragging) {
                    const ratio = this._getCurrentDistance() / this._startDistance;
                    this._initialScale.scaleToRef(ratio, this._targetScale);
                }
            });
        });
        ownerNode.addBehavior(this._dragBehaviorA);
        ownerNode.addBehavior(this._dragBehaviorB);
        // On every frame move towards target scaling to avoid jitter caused by vr controllers
        this._sceneRenderObserver = ownerNode.getScene().onBeforeRenderObservable.add(()=>{
            if (this._dragBehaviorA.dragging && this._dragBehaviorB.dragging) {
                const change = this._targetScale.subtract(ownerNode.scaling).scaleInPlace(0.1);
                if (change.length() > 0.01) ownerNode.scaling.addInPlace(change);
            }
        });
    }
    /**
     *  Detaches the behavior from the mesh
     */ detach() {
        this._ownerNode.getScene().onBeforeRenderObservable.remove(this._sceneRenderObserver);
        [
            this._dragBehaviorA,
            this._dragBehaviorB
        ].forEach((behavior)=>{
            behavior.onDragStartObservable.clear();
            behavior.onDragObservable.clear();
            this._ownerNode.removeBehavior(behavior);
        });
    }
}

});
parcelRegister("dnn9Q", function(module, exports) {

$parcel$export(module.exports, "PointerDragBehavior", () => $9bcf62fc0db1470b$export$403bef195f1f0e5a);

var $fbuqw = parcelRequire("fbuqw");

var $gmbCk = parcelRequire("gmbCk");

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $cfkw4 = parcelRequire("cfkw4");

var $3kez7 = parcelRequire("3kez7");

var $3Pok5 = parcelRequire("3Pok5");

var $kt6s5 = parcelRequire("kt6s5");

var $53VPf = parcelRequire("53VPf");
class $9bcf62fc0db1470b$export$403bef195f1f0e5a {
    /**
     * Get or set the currentDraggingPointerId
     * @deprecated Please use currentDraggingPointerId instead
     */ get currentDraggingPointerID() {
        return this.currentDraggingPointerId;
    }
    set currentDraggingPointerID(currentDraggingPointerID) {
        this.currentDraggingPointerId = currentDraggingPointerID;
    }
    /**
     *  If the drag behavior will react to drag events (Default: true)
     */ set enabled(value) {
        if (value != this._enabled) this.onEnabledObservable.notifyObservers(value);
        this._enabled = value;
    }
    get enabled() {
        return this._enabled;
    }
    /**
     * Gets the options used by the behavior
     */ get options() {
        return this._options;
    }
    /**
     * Sets the options used by the behavior
     */ set options(options) {
        this._options = options;
    }
    /**
     * Creates a pointer drag behavior that can be attached to a mesh
     * @param options The drag axis or normal of the plane that will be dragged across. If no options are specified the drag plane will always face the ray's origin (eg. camera)
     * @param options.dragAxis
     * @param options.dragPlaneNormal
     */ constructor(options){
        this._useAlternatePickedPointAboveMaxDragAngleDragSpeed = -1.1;
        this._activeDragButton = -1;
        /**
         * The maximum tolerated angle between the drag plane and dragging pointer rays to trigger pointer events. Set to 0 to allow any angle (default: 0)
         */ this.maxDragAngle = 0;
        /**
         * Butttons that can be used to initiate a drag
         */ this.dragButtons = [
            0,
            1,
            2
        ];
        /**
         * @internal
         */ this._useAlternatePickedPointAboveMaxDragAngle = false;
        /**
         * The id of the pointer that is currently interacting with the behavior (-1 when no pointer is active)
         */ this.currentDraggingPointerId = -1;
        /**
         * If the behavior is currently in a dragging state
         */ this.dragging = false;
        /**
         * The distance towards the target drag position to move each frame. This can be useful to avoid jitter. Set this to 1 for no delay. (Default: 0.2)
         */ this.dragDeltaRatio = 0.2;
        /**
         * If the drag plane orientation should be updated during the dragging (Default: true)
         */ this.updateDragPlane = true;
        // Debug mode will display drag planes to help visualize behavior
        this._debugMode = false;
        this._moving = false;
        /**
         *  Fires each time the attached mesh is dragged with the pointer
         *  * delta between last drag position and current drag position in world space
         *  * dragDistance along the drag axis
         *  * dragPlaneNormal normal of the current drag plane used during the drag
         *  * dragPlanePoint in world space where the drag intersects the drag plane
         *
         *  (if validatedDrag is used, the position of the attached mesh might not equal dragPlanePoint)
         */ this.onDragObservable = new (0, $diGQf.Observable)();
        /**
         *  Fires each time a drag begins (eg. mouse down on mesh)
         *  * dragPlanePoint in world space where the drag intersects the drag plane
         *
         *  (if validatedDrag is used, the position of the attached mesh might not equal dragPlanePoint)
         */ this.onDragStartObservable = new (0, $diGQf.Observable)();
        /**
         *  Fires each time a drag ends (eg. mouse release after drag)
         *  * dragPlanePoint in world space where the drag intersects the drag plane
         *
         *  (if validatedDrag is used, the position of the attached mesh might not equal dragPlanePoint)
         */ this.onDragEndObservable = new (0, $diGQf.Observable)();
        /**
         *  Fires each time behavior enabled state changes
         */ this.onEnabledObservable = new (0, $diGQf.Observable)();
        /**
         *  If the attached mesh should be moved when dragged
         */ this.moveAttached = true;
        this._enabled = true;
        /**
         * If pointer events should start and release the drag (Default: true)
         */ this.startAndReleaseDragOnPointerEvents = true;
        /**
         * If camera controls should be detached during the drag
         */ this.detachCameraControls = true;
        /**
         * If set, the drag plane/axis will be rotated based on the attached mesh's world rotation (Default: true)
         */ this.useObjectOrientationForDragging = true;
        /**
         * Predicate to determine if it is valid to move the object to a new position when it is moved.
         * In the case of rotation gizmo, target contains the angle.
         * @param target destination position or desired angle delta
         * @returns boolean for whether or not it is valid to move
         */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this.validateDrag = (target)=>{
            return true;
        };
        this._tmpVector = new (0, $ha1VO.Vector3)(0, 0, 0);
        this._alternatePickedPoint = new (0, $ha1VO.Vector3)(0, 0, 0);
        this._worldDragAxis = new (0, $ha1VO.Vector3)(0, 0, 0);
        this._targetPosition = new (0, $ha1VO.Vector3)(0, 0, 0);
        this._attachedToElement = false;
        this._startDragRay = new (0, $3kez7.Ray)(new (0, $ha1VO.Vector3)(), new (0, $ha1VO.Vector3)());
        this._lastPointerRay = {};
        this._dragDelta = new (0, $ha1VO.Vector3)();
        // Variables to avoid instantiation in the below method
        this._pointA = new (0, $ha1VO.Vector3)(0, 0, 0);
        this._pointC = new (0, $ha1VO.Vector3)(0, 0, 0);
        this._localAxis = new (0, $ha1VO.Vector3)(0, 0, 0);
        this._lookAt = new (0, $ha1VO.Vector3)(0, 0, 0);
        this._options = options ? options : {};
        let optionCount = 0;
        if (this._options.dragAxis) optionCount++;
        if (this._options.dragPlaneNormal) optionCount++;
        if (optionCount > 1) // eslint-disable-next-line no-throw-literal
        throw "Multiple drag modes specified in dragBehavior options. Only one expected";
    }
    /**
     *  The name of the behavior
     */ get name() {
        return "PointerDrag";
    }
    /**
     *  Initializes the behavior
     */ init() {}
    /**
     * Attaches the drag behavior the passed in mesh
     * @param ownerNode The mesh that will be dragged around once attached
     * @param predicate Predicate to use for pick filtering
     */ attach(ownerNode, predicate) {
        this._scene = ownerNode.getScene();
        ownerNode.isNearGrabbable = true;
        this.attachedNode = ownerNode;
        // Initialize drag plane to not interfere with existing scene
        if (!$9bcf62fc0db1470b$export$403bef195f1f0e5a._PlaneScene) {
            if (this._debugMode) $9bcf62fc0db1470b$export$403bef195f1f0e5a._PlaneScene = this._scene;
            else {
                $9bcf62fc0db1470b$export$403bef195f1f0e5a._PlaneScene = new (0, $gmbCk.Scene)(this._scene.getEngine(), {
                    virtual: true
                });
                $9bcf62fc0db1470b$export$403bef195f1f0e5a._PlaneScene.detachControl();
                this._scene.onDisposeObservable.addOnce(()=>{
                    $9bcf62fc0db1470b$export$403bef195f1f0e5a._PlaneScene.dispose();
                    $9bcf62fc0db1470b$export$403bef195f1f0e5a._PlaneScene = null;
                });
            }
        }
        this._dragPlane = (0, $kt6s5.CreatePlane)("pointerDragPlane", {
            size: this._debugMode ? 1 : 10000,
            updatable: false,
            sideOrientation: (0, $fbuqw.Mesh).DOUBLESIDE
        }, $9bcf62fc0db1470b$export$403bef195f1f0e5a._PlaneScene);
        // State of the drag
        this.lastDragPosition = new (0, $ha1VO.Vector3)(0, 0, 0);
        const pickPredicate = predicate ? predicate : (m)=>{
            return this.attachedNode == m || m.isDescendantOf(this.attachedNode);
        };
        this._pointerObserver = this._scene.onPointerObservable.add((pointerInfo)=>{
            if (!this.enabled) {
                // If behavior is disabled before releaseDrag is ever called, call it now.
                if (this._attachedToElement) this.releaseDrag();
                return;
            }
            if (pointerInfo.type == (0, $cfkw4.PointerEventTypes).POINTERDOWN) {
                if (this.startAndReleaseDragOnPointerEvents && !this.dragging && pointerInfo.pickInfo && pointerInfo.pickInfo.hit && pointerInfo.pickInfo.pickedMesh && pointerInfo.pickInfo.pickedPoint && pointerInfo.pickInfo.ray && pickPredicate(pointerInfo.pickInfo.pickedMesh)) {
                    if (this._activeDragButton === -1 && this.dragButtons.indexOf(pointerInfo.event.button) !== -1) {
                        this._activeDragButton = pointerInfo.event.button;
                        this._activePointerInfo = pointerInfo;
                        this._startDrag(pointerInfo.event.pointerId, pointerInfo.pickInfo.ray, pointerInfo.pickInfo.pickedPoint);
                    }
                }
            } else if (pointerInfo.type == (0, $cfkw4.PointerEventTypes).POINTERUP) {
                if (this.startAndReleaseDragOnPointerEvents && this.currentDraggingPointerId == pointerInfo.event.pointerId && (this._activeDragButton === pointerInfo.event.button || this._activeDragButton === -1)) this.releaseDrag();
            } else if (pointerInfo.type == (0, $cfkw4.PointerEventTypes).POINTERMOVE) {
                const pointerId = pointerInfo.event.pointerId;
                // If drag was started with anyMouseID specified, set pointerID to the next mouse that moved
                if (this.currentDraggingPointerId === $9bcf62fc0db1470b$export$403bef195f1f0e5a._AnyMouseId && pointerId !== $9bcf62fc0db1470b$export$403bef195f1f0e5a._AnyMouseId) {
                    const evt = pointerInfo.event;
                    const isMouseEvent = evt.pointerType === "mouse" || !this._scene.getEngine().hostInformation.isMobile && evt instanceof MouseEvent;
                    if (isMouseEvent) {
                        if (this._lastPointerRay[this.currentDraggingPointerId]) {
                            this._lastPointerRay[pointerId] = this._lastPointerRay[this.currentDraggingPointerId];
                            delete this._lastPointerRay[this.currentDraggingPointerId];
                        }
                        this.currentDraggingPointerId = pointerId;
                    }
                }
                // Keep track of last pointer ray, this is used simulating the start of a drag in startDrag()
                if (!this._lastPointerRay[pointerId]) this._lastPointerRay[pointerId] = new (0, $3kez7.Ray)(new (0, $ha1VO.Vector3)(), new (0, $ha1VO.Vector3)());
                if (pointerInfo.pickInfo && pointerInfo.pickInfo.ray) {
                    this._lastPointerRay[pointerId].origin.copyFrom(pointerInfo.pickInfo.ray.origin);
                    this._lastPointerRay[pointerId].direction.copyFrom(pointerInfo.pickInfo.ray.direction);
                    if (this.currentDraggingPointerId == pointerId && this.dragging) this._moveDrag(pointerInfo.pickInfo.ray);
                }
            }
        });
        this._beforeRenderObserver = this._scene.onBeforeRenderObservable.add(()=>{
            if (this._moving && this.moveAttached) {
                let needMatrixUpdate = false;
                (0, $3Pok5.PivotTools)._RemoveAndStorePivotPoint(this.attachedNode);
                // Slowly move mesh to avoid jitter
                this._targetPosition.subtractToRef(this.attachedNode.absolutePosition, this._tmpVector);
                this._tmpVector.scaleInPlace(this.dragDeltaRatio);
                this.attachedNode.getAbsolutePosition().addToRef(this._tmpVector, this._tmpVector);
                if (this.validateDrag(this._tmpVector)) {
                    this.attachedNode.setAbsolutePosition(this._tmpVector);
                    needMatrixUpdate = true;
                }
                (0, $3Pok5.PivotTools)._RestorePivotPoint(this.attachedNode);
                if (needMatrixUpdate) this.attachedNode.computeWorldMatrix();
            }
        });
    }
    /**
     * Force release the drag action by code.
     */ releaseDrag() {
        if (this.dragging) {
            this.dragging = false;
            this.onDragEndObservable.notifyObservers({
                dragPlanePoint: this.lastDragPosition,
                pointerId: this.currentDraggingPointerId,
                pointerInfo: this._activePointerInfo
            });
        }
        this.currentDraggingPointerId = -1;
        this._activeDragButton = -1;
        this._activePointerInfo = null;
        this._moving = false;
        // Reattach camera controls
        if (this.detachCameraControls && this._attachedToElement && this._scene.activeCamera && !this._scene.activeCamera.leftCamera) {
            if (this._scene.activeCamera.getClassName() === "ArcRotateCamera") {
                const arcRotateCamera = this._scene.activeCamera;
                arcRotateCamera.attachControl(arcRotateCamera.inputs ? arcRotateCamera.inputs.noPreventDefault : true, arcRotateCamera._useCtrlForPanning, arcRotateCamera._panningMouseButton);
            } else this._scene.activeCamera.attachControl(this._scene.activeCamera.inputs ? this._scene.activeCamera.inputs.noPreventDefault : true);
            this._attachedToElement = false;
        }
    }
    /**
     * Simulates the start of a pointer drag event on the behavior
     * @param pointerId pointerID of the pointer that should be simulated (Default: Any mouse pointer ID)
     * @param fromRay initial ray of the pointer to be simulated (Default: Ray from camera to attached mesh)
     * @param startPickedPoint picked point of the pointer to be simulated (Default: attached mesh position)
     */ startDrag(pointerId = $9bcf62fc0db1470b$export$403bef195f1f0e5a._AnyMouseId, fromRay, startPickedPoint) {
        this._startDrag(pointerId, fromRay, startPickedPoint);
        let lastRay = this._lastPointerRay[pointerId];
        if (pointerId === $9bcf62fc0db1470b$export$403bef195f1f0e5a._AnyMouseId) lastRay = this._lastPointerRay[Object.keys(this._lastPointerRay)[0]];
        if (lastRay) // if there was a last pointer ray drag the object there
        this._moveDrag(lastRay);
    }
    _startDrag(pointerId, fromRay, startPickedPoint) {
        if (!this._scene.activeCamera || this.dragging || !this.attachedNode) return;
        (0, $3Pok5.PivotTools)._RemoveAndStorePivotPoint(this.attachedNode);
        // Create start ray from the camera to the object
        if (fromRay) {
            this._startDragRay.direction.copyFrom(fromRay.direction);
            this._startDragRay.origin.copyFrom(fromRay.origin);
        } else {
            this._startDragRay.origin.copyFrom(this._scene.activeCamera.position);
            this.attachedNode.getWorldMatrix().getTranslationToRef(this._tmpVector);
            this._tmpVector.subtractToRef(this._scene.activeCamera.position, this._startDragRay.direction);
        }
        this._updateDragPlanePosition(this._startDragRay, startPickedPoint ? startPickedPoint : this._tmpVector);
        const pickedPoint = this._pickWithRayOnDragPlane(this._startDragRay);
        if (pickedPoint) {
            this.dragging = true;
            this.currentDraggingPointerId = pointerId;
            this.lastDragPosition.copyFrom(pickedPoint);
            this.onDragStartObservable.notifyObservers({
                dragPlanePoint: pickedPoint,
                pointerId: this.currentDraggingPointerId,
                pointerInfo: this._activePointerInfo
            });
            this._targetPosition.copyFrom(this.attachedNode.getAbsolutePosition());
            // Detatch camera controls
            if (this.detachCameraControls && this._scene.activeCamera && this._scene.activeCamera.inputs && !this._scene.activeCamera.leftCamera) {
                if (this._scene.activeCamera.inputs.attachedToElement) {
                    this._scene.activeCamera.detachControl();
                    this._attachedToElement = true;
                } else this._attachedToElement = false;
            }
        } else this.releaseDrag();
        (0, $3Pok5.PivotTools)._RestorePivotPoint(this.attachedNode);
    }
    _moveDrag(ray) {
        this._moving = true;
        const pickedPoint = this._pickWithRayOnDragPlane(ray);
        if (pickedPoint) {
            (0, $3Pok5.PivotTools)._RemoveAndStorePivotPoint(this.attachedNode);
            if (this.updateDragPlane) this._updateDragPlanePosition(ray, pickedPoint);
            let dragLength = 0;
            // depending on the drag mode option drag accordingly
            if (this._options.dragAxis) {
                // Convert local drag axis to world if useObjectOrientationForDragging
                this.useObjectOrientationForDragging ? (0, $ha1VO.Vector3).TransformCoordinatesToRef(this._options.dragAxis, this.attachedNode.getWorldMatrix().getRotationMatrix(), this._worldDragAxis) : this._worldDragAxis.copyFrom(this._options.dragAxis);
                // Project delta drag from the drag plane onto the drag axis
                pickedPoint.subtractToRef(this.lastDragPosition, this._tmpVector);
                dragLength = (0, $ha1VO.Vector3).Dot(this._tmpVector, this._worldDragAxis);
                this._worldDragAxis.scaleToRef(dragLength, this._dragDelta);
            } else {
                dragLength = this._dragDelta.length();
                pickedPoint.subtractToRef(this.lastDragPosition, this._dragDelta);
            }
            this._targetPosition.addInPlace(this._dragDelta);
            this.onDragObservable.notifyObservers({
                dragDistance: dragLength,
                delta: this._dragDelta,
                dragPlanePoint: pickedPoint,
                dragPlaneNormal: this._dragPlane.forward,
                pointerId: this.currentDraggingPointerId,
                pointerInfo: this._activePointerInfo
            });
            this.lastDragPosition.copyFrom(pickedPoint);
            (0, $3Pok5.PivotTools)._RestorePivotPoint(this.attachedNode);
        }
    }
    _pickWithRayOnDragPlane(ray) {
        if (!ray) return null;
        // Calculate angle between plane normal and ray
        let angle = Math.acos((0, $ha1VO.Vector3).Dot(this._dragPlane.forward, ray.direction));
        // Correct if ray is casted from oposite side
        if (angle > Math.PI / 2) angle = Math.PI - angle;
        // If the angle is too perpendicular to the plane pick another point on the plane where it is looking
        if (this.maxDragAngle > 0 && angle > this.maxDragAngle) {
            if (this._useAlternatePickedPointAboveMaxDragAngle) {
                // Invert ray direction along the towards object axis
                this._tmpVector.copyFrom(ray.direction);
                this.attachedNode.absolutePosition.subtractToRef(ray.origin, this._alternatePickedPoint);
                this._alternatePickedPoint.normalize();
                this._alternatePickedPoint.scaleInPlace(this._useAlternatePickedPointAboveMaxDragAngleDragSpeed * (0, $ha1VO.Vector3).Dot(this._alternatePickedPoint, this._tmpVector));
                this._tmpVector.addInPlace(this._alternatePickedPoint);
                // Project resulting vector onto the drag plane and add it to the attached nodes absolute position to get a picked point
                const dot = (0, $ha1VO.Vector3).Dot(this._dragPlane.forward, this._tmpVector);
                this._dragPlane.forward.scaleToRef(-dot, this._alternatePickedPoint);
                this._alternatePickedPoint.addInPlace(this._tmpVector);
                this._alternatePickedPoint.addInPlace(this.attachedNode.absolutePosition);
                return this._alternatePickedPoint;
            } else return null;
        }
        // use an infinite plane instead of ray picking a mesh that must be updated every frame
        const planeNormal = this._dragPlane.forward;
        const planePosition = this._dragPlane.position;
        const dotProduct = ray.direction.dot(planeNormal);
        if (Math.abs(dotProduct) < (0, $53VPf.Epsilon)) // Ray and plane are parallel, no intersection
        return null;
        planePosition.subtractToRef(ray.origin, (0, $ha1VO.TmpVectors).Vector3[0]);
        const t = (0, $ha1VO.TmpVectors).Vector3[0].dot(planeNormal) / dotProduct;
        // Ensure the intersection point is in front of the ray (t must be positive)
        if (t < 0) // Intersection point is behind the ray
        return null;
        // Calculate the intersection point using the parameter t
        ray.direction.scaleToRef(t, (0, $ha1VO.TmpVectors).Vector3[0]);
        const intersectionPoint = ray.origin.add((0, $ha1VO.TmpVectors).Vector3[0]);
        return intersectionPoint;
    }
    // Position the drag plane based on the attached mesh position, for single axis rotate the plane along the axis to face the camera
    _updateDragPlanePosition(ray, dragPlanePosition) {
        this._pointA.copyFrom(dragPlanePosition);
        if (this._options.dragAxis) {
            this.useObjectOrientationForDragging ? (0, $ha1VO.Vector3).TransformCoordinatesToRef(this._options.dragAxis, this.attachedNode.getWorldMatrix().getRotationMatrix(), this._localAxis) : this._localAxis.copyFrom(this._options.dragAxis);
            // Calculate plane normal that is the cross product of local axis and (eye-dragPlanePosition)
            ray.origin.subtractToRef(this._pointA, this._pointC);
            this._pointC.normalize();
            if (Math.abs((0, $ha1VO.Vector3).Dot(this._localAxis, this._pointC)) > 0.999) {
                // the drag axis is colinear with the (eye to position) ray. The cross product will give jittered values.
                // A new axis vector need to be computed
                if (Math.abs((0, $ha1VO.Vector3).Dot((0, $ha1VO.Vector3).UpReadOnly, this._pointC)) > 0.999) this._lookAt.copyFrom((0, $ha1VO.Vector3).Right());
                else this._lookAt.copyFrom((0, $ha1VO.Vector3).UpReadOnly);
            } else {
                (0, $ha1VO.Vector3).CrossToRef(this._localAxis, this._pointC, this._lookAt);
                // Get perpendicular line from previous result and drag axis to adjust lineB to be perpendicular to camera
                (0, $ha1VO.Vector3).CrossToRef(this._localAxis, this._lookAt, this._lookAt);
                this._lookAt.normalize();
            }
            this._dragPlane.position.copyFrom(this._pointA);
            this._pointA.addToRef(this._lookAt, this._lookAt);
            this._dragPlane.lookAt(this._lookAt);
        } else if (this._options.dragPlaneNormal) {
            this.useObjectOrientationForDragging ? (0, $ha1VO.Vector3).TransformCoordinatesToRef(this._options.dragPlaneNormal, this.attachedNode.getWorldMatrix().getRotationMatrix(), this._localAxis) : this._localAxis.copyFrom(this._options.dragPlaneNormal);
            this._dragPlane.position.copyFrom(this._pointA);
            this._pointA.addToRef(this._localAxis, this._lookAt);
            this._dragPlane.lookAt(this._lookAt);
        } else {
            this._dragPlane.position.copyFrom(this._pointA);
            this._dragPlane.lookAt(ray.origin);
        }
        // Update the position of the drag plane so it doesn't get out of sync with the node (eg. when moving back and forth quickly)
        this._dragPlane.position.copyFrom(this.attachedNode.getAbsolutePosition());
        this._dragPlane.computeWorldMatrix(true);
    }
    /**
     *  Detaches the behavior from the mesh
     */ detach() {
        this._lastPointerRay = {};
        if (this.attachedNode) this.attachedNode.isNearGrabbable = false;
        if (this._pointerObserver) this._scene.onPointerObservable.remove(this._pointerObserver);
        if (this._beforeRenderObserver) this._scene.onBeforeRenderObservable.remove(this._beforeRenderObserver);
        if (this._dragPlane) this._dragPlane.dispose();
        this.releaseDrag();
    }
}
$9bcf62fc0db1470b$export$403bef195f1f0e5a._AnyMouseId = -2;

});
parcelRegister("3kez7", function(module, exports) {

$parcel$export(module.exports, "Ray", () => $26be89c393da2d4e$export$a186db52eed6d40e);

var $opFp4 = parcelRequire("opFp4");

var $ha1VO = parcelRequire("ha1VO");

var $gzCma = parcelRequire("gzCma");

var $iKm71 = parcelRequire("iKm71");

var $gmbCk = parcelRequire("gmbCk");

var $74SKQ = parcelRequire("74SKQ");

var $ejQPp = parcelRequire("ejQPp");

var $53VPf = parcelRequire("53VPf");
class $26be89c393da2d4e$export$a186db52eed6d40e {
    /**
     * Creates a new ray
     * @param origin origin point
     * @param direction direction
     * @param length length of the ray
     * @param epsilon The epsilon value to use when calculating the ray/triangle intersection (default: 0)
     */ constructor(/** origin point */ origin, /** direction */ direction, /** length of the ray */ length = Number.MAX_VALUE, /** The epsilon value to use when calculating the ray/triangle intersection (default: Epsilon from math constants) */ epsilon = (0, $53VPf.Epsilon)){
        this.origin = origin;
        this.direction = direction;
        this.length = length;
        this.epsilon = epsilon;
    }
    // Methods
    /**
     * Clone the current ray
     * @returns a new ray
     */ clone() {
        return new $26be89c393da2d4e$export$a186db52eed6d40e(this.origin.clone(), this.direction.clone(), this.length);
    }
    /**
     * Checks if the ray intersects a box
     * This does not account for the ray length by design to improve perfs.
     * @param minimum bound of the box
     * @param maximum bound of the box
     * @param intersectionTreshold extra extend to be added to the box in all direction
     * @returns if the box was hit
     */ intersectsBoxMinMax(minimum, maximum, intersectionTreshold = 0) {
        const newMinimum = $26be89c393da2d4e$export$a186db52eed6d40e._TmpVector3[0].copyFromFloats(minimum.x - intersectionTreshold, minimum.y - intersectionTreshold, minimum.z - intersectionTreshold);
        const newMaximum = $26be89c393da2d4e$export$a186db52eed6d40e._TmpVector3[1].copyFromFloats(maximum.x + intersectionTreshold, maximum.y + intersectionTreshold, maximum.z + intersectionTreshold);
        let d = 0.0;
        let maxValue = Number.MAX_VALUE;
        let inv;
        let min;
        let max;
        let temp;
        if (Math.abs(this.direction.x) < 0.0000001) {
            if (this.origin.x < newMinimum.x || this.origin.x > newMaximum.x) return false;
        } else {
            inv = 1.0 / this.direction.x;
            min = (newMinimum.x - this.origin.x) * inv;
            max = (newMaximum.x - this.origin.x) * inv;
            if (max === -Infinity) max = Infinity;
            if (min > max) {
                temp = min;
                min = max;
                max = temp;
            }
            d = Math.max(min, d);
            maxValue = Math.min(max, maxValue);
            if (d > maxValue) return false;
        }
        if (Math.abs(this.direction.y) < 0.0000001) {
            if (this.origin.y < newMinimum.y || this.origin.y > newMaximum.y) return false;
        } else {
            inv = 1.0 / this.direction.y;
            min = (newMinimum.y - this.origin.y) * inv;
            max = (newMaximum.y - this.origin.y) * inv;
            if (max === -Infinity) max = Infinity;
            if (min > max) {
                temp = min;
                min = max;
                max = temp;
            }
            d = Math.max(min, d);
            maxValue = Math.min(max, maxValue);
            if (d > maxValue) return false;
        }
        if (Math.abs(this.direction.z) < 0.0000001) {
            if (this.origin.z < newMinimum.z || this.origin.z > newMaximum.z) return false;
        } else {
            inv = 1.0 / this.direction.z;
            min = (newMinimum.z - this.origin.z) * inv;
            max = (newMaximum.z - this.origin.z) * inv;
            if (max === -Infinity) max = Infinity;
            if (min > max) {
                temp = min;
                min = max;
                max = temp;
            }
            d = Math.max(min, d);
            maxValue = Math.min(max, maxValue);
            if (d > maxValue) return false;
        }
        return true;
    }
    /**
     * Checks if the ray intersects a box
     * This does not account for the ray lenght by design to improve perfs.
     * @param box the bounding box to check
     * @param intersectionTreshold extra extend to be added to the BoundingBox in all direction
     * @returns if the box was hit
     */ intersectsBox(box, intersectionTreshold = 0) {
        return this.intersectsBoxMinMax(box.minimum, box.maximum, intersectionTreshold);
    }
    /**
     * If the ray hits a sphere
     * @param sphere the bounding sphere to check
     * @param intersectionTreshold extra extend to be added to the BoundingSphere in all direction
     * @returns true if it hits the sphere
     */ intersectsSphere(sphere, intersectionTreshold = 0) {
        const x = sphere.center.x - this.origin.x;
        const y = sphere.center.y - this.origin.y;
        const z = sphere.center.z - this.origin.z;
        const pyth = x * x + y * y + z * z;
        const radius = sphere.radius + intersectionTreshold;
        const rr = radius * radius;
        if (pyth <= rr) return true;
        const dot = x * this.direction.x + y * this.direction.y + z * this.direction.z;
        if (dot < 0.0) return false;
        const temp = pyth - dot * dot;
        return temp <= rr;
    }
    /**
     * If the ray hits a triange
     * @param vertex0 triangle vertex
     * @param vertex1 triangle vertex
     * @param vertex2 triangle vertex
     * @returns intersection information if hit
     */ intersectsTriangle(vertex0, vertex1, vertex2) {
        const edge1 = $26be89c393da2d4e$export$a186db52eed6d40e._TmpVector3[0];
        const edge2 = $26be89c393da2d4e$export$a186db52eed6d40e._TmpVector3[1];
        const pvec = $26be89c393da2d4e$export$a186db52eed6d40e._TmpVector3[2];
        const tvec = $26be89c393da2d4e$export$a186db52eed6d40e._TmpVector3[3];
        const qvec = $26be89c393da2d4e$export$a186db52eed6d40e._TmpVector3[4];
        vertex1.subtractToRef(vertex0, edge1);
        vertex2.subtractToRef(vertex0, edge2);
        (0, $ha1VO.Vector3).CrossToRef(this.direction, edge2, pvec);
        const det = (0, $ha1VO.Vector3).Dot(edge1, pvec);
        if (det === 0) return null;
        const invdet = 1 / det;
        this.origin.subtractToRef(vertex0, tvec);
        const bv = (0, $ha1VO.Vector3).Dot(tvec, pvec) * invdet;
        if (bv < -this.epsilon || bv > 1.0 + this.epsilon) return null;
        (0, $ha1VO.Vector3).CrossToRef(tvec, edge1, qvec);
        const bw = (0, $ha1VO.Vector3).Dot(this.direction, qvec) * invdet;
        if (bw < -this.epsilon || bv + bw > 1.0 + this.epsilon) return null;
        //check if the distance is longer than the predefined length.
        const distance = (0, $ha1VO.Vector3).Dot(edge2, qvec) * invdet;
        if (distance > this.length) return null;
        return new (0, $iKm71.IntersectionInfo)(1 - bv - bw, bv, distance);
    }
    /**
     * Checks if ray intersects a plane
     * @param plane the plane to check
     * @returns the distance away it was hit
     */ intersectsPlane(plane) {
        let distance;
        const result1 = (0, $ha1VO.Vector3).Dot(plane.normal, this.direction);
        if (Math.abs(result1) < 9.99999997475243e-7) return null;
        else {
            const result2 = (0, $ha1VO.Vector3).Dot(plane.normal, this.origin);
            distance = (-plane.d - result2) / result1;
            if (distance < 0.0) {
                if (distance < -0.000000999999997475243) return null;
                else return 0;
            }
            return distance;
        }
    }
    /**
     * Calculate the intercept of a ray on a given axis
     * @param axis to check 'x' | 'y' | 'z'
     * @param offset from axis interception (i.e. an offset of 1y is intercepted above ground)
     * @returns a vector containing the coordinates where 'axis' is equal to zero (else offset), or null if there is no intercept.
     */ intersectsAxis(axis, offset = 0) {
        switch(axis){
            case "y":
                {
                    const t = (this.origin.y - offset) / this.direction.y;
                    if (t > 0) return null;
                    return new (0, $ha1VO.Vector3)(this.origin.x + this.direction.x * -t, offset, this.origin.z + this.direction.z * -t);
                }
            case "x":
                {
                    const t = (this.origin.x - offset) / this.direction.x;
                    if (t > 0) return null;
                    return new (0, $ha1VO.Vector3)(offset, this.origin.y + this.direction.y * -t, this.origin.z + this.direction.z * -t);
                }
            case "z":
                {
                    const t = (this.origin.z - offset) / this.direction.z;
                    if (t > 0) return null;
                    return new (0, $ha1VO.Vector3)(this.origin.x + this.direction.x * -t, this.origin.y + this.direction.y * -t, offset);
                }
            default:
                return null;
        }
    }
    /**
     * Checks if ray intersects a mesh. The ray is defined in WORLD space. A mesh triangle can be picked both from its front and back sides,
     * irrespective of orientation.
     * @param mesh the mesh to check
     * @param fastCheck defines if the first intersection will be used (and not the closest)
     * @param trianglePredicate defines an optional predicate used to select faces when a mesh intersection is detected
     * @param onlyBoundingInfo defines a boolean indicating if picking should only happen using bounding info (false by default)
     * @param worldToUse defines the world matrix to use to get the world coordinate of the intersection point
     * @param skipBoundingInfo a boolean indicating if we should skip the bounding info check
     * @returns picking info of the intersection
     */ intersectsMesh(mesh, fastCheck, trianglePredicate, onlyBoundingInfo = false, worldToUse, skipBoundingInfo = false) {
        const tm = (0, $ha1VO.TmpVectors).Matrix[0];
        mesh.getWorldMatrix().invertToRef(tm);
        if (this._tmpRay) $26be89c393da2d4e$export$a186db52eed6d40e.TransformToRef(this, tm, this._tmpRay);
        else this._tmpRay = $26be89c393da2d4e$export$a186db52eed6d40e.Transform(this, tm);
        return mesh.intersects(this._tmpRay, fastCheck, trianglePredicate, onlyBoundingInfo, worldToUse, skipBoundingInfo);
    }
    /**
     * Checks if ray intersects a mesh
     * @param meshes the meshes to check
     * @param fastCheck defines if the first intersection will be used (and not the closest)
     * @param results array to store result in
     * @returns Array of picking infos
     */ intersectsMeshes(meshes, fastCheck, results) {
        if (results) results.length = 0;
        else results = [];
        for(let i = 0; i < meshes.length; i++){
            const pickInfo = this.intersectsMesh(meshes[i], fastCheck);
            if (pickInfo.hit) results.push(pickInfo);
        }
        results.sort(this._comparePickingInfo);
        return results;
    }
    _comparePickingInfo(pickingInfoA, pickingInfoB) {
        if (pickingInfoA.distance < pickingInfoB.distance) return -1;
        else if (pickingInfoA.distance > pickingInfoB.distance) return 1;
        else return 0;
    }
    /**
     * Intersection test between the ray and a given segment within a given tolerance (threshold)
     * @param sega the first point of the segment to test the intersection against
     * @param segb the second point of the segment to test the intersection against
     * @param threshold the tolerance margin, if the ray doesn't intersect the segment but is close to the given threshold, the intersection is successful
     * @returns the distance from the ray origin to the intersection point if there's intersection, or -1 if there's no intersection
     */ intersectionSegment(sega, segb, threshold) {
        const o = this.origin;
        const u = (0, $ha1VO.TmpVectors).Vector3[0];
        const rsegb = (0, $ha1VO.TmpVectors).Vector3[1];
        const v = (0, $ha1VO.TmpVectors).Vector3[2];
        const w = (0, $ha1VO.TmpVectors).Vector3[3];
        segb.subtractToRef(sega, u);
        this.direction.scaleToRef($26be89c393da2d4e$export$a186db52eed6d40e._Rayl, v);
        o.addToRef(v, rsegb);
        sega.subtractToRef(o, w);
        const a = (0, $ha1VO.Vector3).Dot(u, u); // always >= 0
        const b = (0, $ha1VO.Vector3).Dot(u, v);
        const c = (0, $ha1VO.Vector3).Dot(v, v); // always >= 0
        const d = (0, $ha1VO.Vector3).Dot(u, w);
        const e = (0, $ha1VO.Vector3).Dot(v, w);
        const D = a * c - b * b; // always >= 0
        let sN, sD = D; // sc = sN / sD, default sD = D >= 0
        let tN, tD = D; // tc = tN / tD, default tD = D >= 0
        // compute the line parameters of the two closest points
        if (D < $26be89c393da2d4e$export$a186db52eed6d40e._Smallnum) {
            // the lines are almost parallel
            sN = 0.0; // force using point P0 on segment S1
            sD = 1.0; // to prevent possible division by 0.0 later
            tN = e;
            tD = c;
        } else {
            // get the closest points on the infinite lines
            sN = b * e - c * d;
            tN = a * e - b * d;
            if (sN < 0.0) {
                // sc < 0 => the s=0 edge is visible
                sN = 0.0;
                tN = e;
                tD = c;
            } else if (sN > sD) {
                // sc > 1 => the s=1 edge is visible
                sN = sD;
                tN = e + b;
                tD = c;
            }
        }
        if (tN < 0.0) {
            // tc < 0 => the t=0 edge is visible
            tN = 0.0;
            // recompute sc for this edge
            if (-d < 0.0) sN = 0.0;
            else if (-d > a) sN = sD;
            else {
                sN = -d;
                sD = a;
            }
        } else if (tN > tD) {
            // tc > 1 => the t=1 edge is visible
            tN = tD;
            // recompute sc for this edge
            if (-d + b < 0.0) sN = 0;
            else if (-d + b > a) sN = sD;
            else {
                sN = -d + b;
                sD = a;
            }
        }
        // finally do the division to get sc and tc
        const sc = Math.abs(sN) < $26be89c393da2d4e$export$a186db52eed6d40e._Smallnum ? 0.0 : sN / sD;
        const tc = Math.abs(tN) < $26be89c393da2d4e$export$a186db52eed6d40e._Smallnum ? 0.0 : tN / tD;
        // get the difference of the two closest points
        const qtc = (0, $ha1VO.TmpVectors).Vector3[4];
        v.scaleToRef(tc, qtc);
        const qsc = (0, $ha1VO.TmpVectors).Vector3[5];
        u.scaleToRef(sc, qsc);
        qsc.addInPlace(w);
        const dP = (0, $ha1VO.TmpVectors).Vector3[6];
        qsc.subtractToRef(qtc, dP); // = S1(sc) - S2(tc)
        const isIntersected = tc > 0 && tc <= this.length && dP.lengthSquared() < threshold * threshold; // return intersection result
        if (isIntersected) return qsc.length();
        return -1;
    }
    /**
     * Update the ray from viewport position
     * @param x position
     * @param y y position
     * @param viewportWidth viewport width
     * @param viewportHeight viewport height
     * @param world world matrix
     * @param view view matrix
     * @param projection projection matrix
     * @param enableDistantPicking defines if picking should handle large values for mesh position/scaling (false by default)
     * @returns this ray updated
     */ update(x, y, viewportWidth, viewportHeight, world, view, projection, enableDistantPicking = false) {
        if (enableDistantPicking) {
            // With world matrices having great values (like 8000000000 on 1 or more scaling or position axis),
            // multiplying view/projection/world and doing invert will result in loss of float precision in the matrix.
            // One way to fix it is to compute the ray with world at identity then transform the ray in object space.
            // This is slower (2 matrix inverts instead of 1) but precision is preserved.
            // This is hidden behind `EnableDistantPicking` flag (default is false)
            if (!$26be89c393da2d4e$export$a186db52eed6d40e._RayDistant) $26be89c393da2d4e$export$a186db52eed6d40e._RayDistant = $26be89c393da2d4e$export$a186db52eed6d40e.Zero();
            $26be89c393da2d4e$export$a186db52eed6d40e._RayDistant.unprojectRayToRef(x, y, viewportWidth, viewportHeight, (0, $ha1VO.Matrix).IdentityReadOnly, view, projection);
            const tm = (0, $ha1VO.TmpVectors).Matrix[0];
            world.invertToRef(tm);
            $26be89c393da2d4e$export$a186db52eed6d40e.TransformToRef($26be89c393da2d4e$export$a186db52eed6d40e._RayDistant, tm, this);
        } else this.unprojectRayToRef(x, y, viewportWidth, viewportHeight, world, view, projection);
        return this;
    }
    // Statics
    /**
     * Creates a ray with origin and direction of 0,0,0
     * @returns the new ray
     */ static Zero() {
        return new $26be89c393da2d4e$export$a186db52eed6d40e((0, $ha1VO.Vector3).Zero(), (0, $ha1VO.Vector3).Zero());
    }
    /**
     * Creates a new ray from screen space and viewport
     * @param x position
     * @param y y position
     * @param viewportWidth viewport width
     * @param viewportHeight viewport height
     * @param world world matrix
     * @param view view matrix
     * @param projection projection matrix
     * @returns new ray
     */ static CreateNew(x, y, viewportWidth, viewportHeight, world, view, projection) {
        const result = $26be89c393da2d4e$export$a186db52eed6d40e.Zero();
        return result.update(x, y, viewportWidth, viewportHeight, world, view, projection);
    }
    /**
     * Function will create a new transformed ray starting from origin and ending at the end point. Ray's length will be set, and ray will be
     * transformed to the given world matrix.
     * @param origin The origin point
     * @param end The end point
     * @param world a matrix to transform the ray to. Default is the identity matrix.
     * @returns the new ray
     */ static CreateNewFromTo(origin, end, world = (0, $ha1VO.Matrix).IdentityReadOnly) {
        const result = new $26be89c393da2d4e$export$a186db52eed6d40e(new (0, $ha1VO.Vector3)(0, 0, 0), new (0, $ha1VO.Vector3)(0, 0, 0));
        return $26be89c393da2d4e$export$a186db52eed6d40e.CreateFromToToRef(origin, end, result, world);
    }
    /**
     * Function will update a transformed ray starting from origin and ending at the end point. Ray's length will be set, and ray will be
     * transformed to the given world matrix.
     * @param origin The origin point
     * @param end The end point
     * @param result the object to store the result
     * @param world a matrix to transform the ray to. Default is the identity matrix.
     * @returns the ref ray
     */ static CreateFromToToRef(origin, end, result, world = (0, $ha1VO.Matrix).IdentityReadOnly) {
        result.origin.copyFrom(origin);
        const direction = end.subtractToRef(origin, result.direction);
        const length = Math.sqrt(direction.x * direction.x + direction.y * direction.y + direction.z * direction.z);
        result.length = length;
        result.direction.normalize();
        return $26be89c393da2d4e$export$a186db52eed6d40e.TransformToRef(result, world, result);
    }
    /**
     * Transforms a ray by a matrix
     * @param ray ray to transform
     * @param matrix matrix to apply
     * @returns the resulting new ray
     */ static Transform(ray, matrix) {
        const result = new $26be89c393da2d4e$export$a186db52eed6d40e(new (0, $ha1VO.Vector3)(0, 0, 0), new (0, $ha1VO.Vector3)(0, 0, 0));
        $26be89c393da2d4e$export$a186db52eed6d40e.TransformToRef(ray, matrix, result);
        return result;
    }
    /**
     * Transforms a ray by a matrix
     * @param ray ray to transform
     * @param matrix matrix to apply
     * @param result ray to store result in
     * @returns the updated result ray
     */ static TransformToRef(ray, matrix, result) {
        (0, $ha1VO.Vector3).TransformCoordinatesToRef(ray.origin, matrix, result.origin);
        (0, $ha1VO.Vector3).TransformNormalToRef(ray.direction, matrix, result.direction);
        result.length = ray.length;
        result.epsilon = ray.epsilon;
        const dir = result.direction;
        const len = dir.length();
        if (!(len === 0 || len === 1)) {
            const num = 1.0 / len;
            dir.x *= num;
            dir.y *= num;
            dir.z *= num;
            result.length *= len;
        }
        return result;
    }
    /**
     * Unproject a ray from screen space to object space
     * @param sourceX defines the screen space x coordinate to use
     * @param sourceY defines the screen space y coordinate to use
     * @param viewportWidth defines the current width of the viewport
     * @param viewportHeight defines the current height of the viewport
     * @param world defines the world matrix to use (can be set to Identity to go to world space)
     * @param view defines the view matrix to use
     * @param projection defines the projection matrix to use
     */ unprojectRayToRef(sourceX, sourceY, viewportWidth, viewportHeight, world, view, projection) {
        const matrix = (0, $ha1VO.TmpVectors).Matrix[0];
        world.multiplyToRef(view, matrix);
        matrix.multiplyToRef(projection, matrix);
        matrix.invert();
        const engine = (0, $ejQPp.EngineStore).LastCreatedEngine;
        const nearScreenSource = (0, $ha1VO.TmpVectors).Vector3[0];
        nearScreenSource.x = sourceX / viewportWidth * 2 - 1;
        nearScreenSource.y = -(sourceY / viewportHeight * 2 - 1);
        nearScreenSource.z = engine?.useReverseDepthBuffer ? 1 : engine?.isNDCHalfZRange ? 0 : -1;
        // far Z need to be close but < to 1 or camera projection matrix with maxZ = 0 will NaN
        const farScreenSource = (0, $ha1VO.TmpVectors).Vector3[1].copyFromFloats(nearScreenSource.x, nearScreenSource.y, 1.0 - 1e-8);
        const nearVec3 = (0, $ha1VO.TmpVectors).Vector3[2];
        const farVec3 = (0, $ha1VO.TmpVectors).Vector3[3];
        (0, $ha1VO.Vector3)._UnprojectFromInvertedMatrixToRef(nearScreenSource, matrix, nearVec3);
        (0, $ha1VO.Vector3)._UnprojectFromInvertedMatrixToRef(farScreenSource, matrix, farVec3);
        this.origin.copyFrom(nearVec3);
        farVec3.subtractToRef(nearVec3, this.direction);
        this.direction.normalize();
    }
}
$26be89c393da2d4e$export$a186db52eed6d40e._TmpVector3 = (0, $opFp4.ArrayTools).BuildArray(6, (0, $ha1VO.Vector3).Zero);
$26be89c393da2d4e$export$a186db52eed6d40e._RayDistant = $26be89c393da2d4e$export$a186db52eed6d40e.Zero();
$26be89c393da2d4e$export$a186db52eed6d40e._Smallnum = 0.00000001;
$26be89c393da2d4e$export$a186db52eed6d40e._Rayl = 10e8;
(0, $gmbCk.Scene).prototype.createPickingRay = function(x, y, world, camera, cameraViewSpace = false) {
    const result = $26be89c393da2d4e$export$a186db52eed6d40e.Zero();
    this.createPickingRayToRef(x, y, world, result, camera, cameraViewSpace);
    return result;
};
(0, $gmbCk.Scene).prototype.createPickingRayToRef = function(x, y, world, result, camera, cameraViewSpace = false, enableDistantPicking = false) {
    const engine = this.getEngine();
    if (!camera && !(camera = this.activeCamera)) return this;
    const cameraViewport = camera.viewport;
    const renderHeight = engine.getRenderHeight();
    const { x: vx, y: vy, width: width, height: height } = cameraViewport.toGlobal(engine.getRenderWidth(), renderHeight);
    // Moving coordinates to local viewport world
    const levelInv = 1 / engine.getHardwareScalingLevel();
    x = x * levelInv - vx;
    y = y * levelInv - (renderHeight - vy - height);
    result.update(x, y, width, height, world ? world : (0, $ha1VO.Matrix).IdentityReadOnly, cameraViewSpace ? (0, $ha1VO.Matrix).IdentityReadOnly : camera.getViewMatrix(), camera.getProjectionMatrix(), enableDistantPicking);
    return this;
};
(0, $gmbCk.Scene).prototype.createPickingRayInCameraSpace = function(x, y, camera) {
    const result = $26be89c393da2d4e$export$a186db52eed6d40e.Zero();
    this.createPickingRayInCameraSpaceToRef(x, y, result, camera);
    return result;
};
(0, $gmbCk.Scene).prototype.createPickingRayInCameraSpaceToRef = function(x, y, result, camera) {
    if (!(0, $gzCma.PickingInfo)) return this;
    const engine = this.getEngine();
    if (!camera && !(camera = this.activeCamera)) throw new Error("Active camera not set");
    const cameraViewport = camera.viewport;
    const renderHeight = engine.getRenderHeight();
    const { x: vx, y: vy, width: width, height: height } = cameraViewport.toGlobal(engine.getRenderWidth(), renderHeight);
    const identity = (0, $ha1VO.Matrix).Identity();
    // Moving coordinates to local viewport world
    const levelInv = 1 / engine.getHardwareScalingLevel();
    x = x * levelInv - vx;
    y = y * levelInv - (renderHeight - vy - height);
    result.update(x, y, width, height, identity, identity, camera.getProjectionMatrix());
    return this;
};
(0, $gmbCk.Scene).prototype._internalPickForMesh = function(pickingInfo, rayFunction, mesh, world, fastCheck, onlyBoundingInfo, trianglePredicate, skipBoundingInfo) {
    const ray = rayFunction(world, mesh.enableDistantPicking);
    const result = mesh.intersects(ray, fastCheck, trianglePredicate, onlyBoundingInfo, world, skipBoundingInfo);
    if (!result || !result.hit) return null;
    if (!fastCheck && pickingInfo != null && result.distance >= pickingInfo.distance) return null;
    return result;
};
(0, $gmbCk.Scene).prototype._internalPick = function(rayFunction, predicate, fastCheck, onlyBoundingInfo, trianglePredicate) {
    let pickingInfo = null;
    const computeWorldMatrixForCamera = !!(this.activeCameras && this.activeCameras.length > 1 && this.cameraToUseForPointers !== this.activeCamera);
    const currentCamera = this.cameraToUseForPointers || this.activeCamera;
    for(let meshIndex = 0; meshIndex < this.meshes.length; meshIndex++){
        const mesh = this.meshes[meshIndex];
        if (predicate) {
            if (!predicate(mesh)) continue;
        } else if (!mesh.isEnabled() || !mesh.isVisible || !mesh.isPickable) continue;
        const forceCompute = computeWorldMatrixForCamera && mesh.isWorldMatrixCameraDependent();
        const world = mesh.computeWorldMatrix(forceCompute, currentCamera);
        if (mesh.hasThinInstances && mesh.thinInstanceEnablePicking) {
            // first check if the ray intersects the whole bounding box/sphere of the mesh
            const result = this._internalPickForMesh(pickingInfo, rayFunction, mesh, world, true, true, trianglePredicate);
            if (result) {
                if (onlyBoundingInfo) // the user only asked for a bounding info check so we can return
                return result;
                const tmpMatrix = (0, $ha1VO.TmpVectors).Matrix[1];
                const thinMatrices = mesh.thinInstanceGetWorldMatrices();
                for(let index = 0; index < thinMatrices.length; index++){
                    const thinMatrix = thinMatrices[index];
                    thinMatrix.multiplyToRef(world, tmpMatrix);
                    const result = this._internalPickForMesh(pickingInfo, rayFunction, mesh, tmpMatrix, fastCheck, onlyBoundingInfo, trianglePredicate, true);
                    if (result) {
                        pickingInfo = result;
                        pickingInfo.thinInstanceIndex = index;
                        if (fastCheck) return pickingInfo;
                    }
                }
            }
        } else {
            const result = this._internalPickForMesh(pickingInfo, rayFunction, mesh, world, fastCheck, onlyBoundingInfo, trianglePredicate);
            if (result) {
                pickingInfo = result;
                if (fastCheck) return pickingInfo;
            }
        }
    }
    return pickingInfo || new (0, $gzCma.PickingInfo)();
};
(0, $gmbCk.Scene).prototype._internalMultiPick = function(rayFunction, predicate, trianglePredicate) {
    if (!(0, $gzCma.PickingInfo)) return null;
    const pickingInfos = [];
    const computeWorldMatrixForCamera = !!(this.activeCameras && this.activeCameras.length > 1 && this.cameraToUseForPointers !== this.activeCamera);
    const currentCamera = this.cameraToUseForPointers || this.activeCamera;
    for(let meshIndex = 0; meshIndex < this.meshes.length; meshIndex++){
        const mesh = this.meshes[meshIndex];
        if (predicate) {
            if (!predicate(mesh)) continue;
        } else if (!mesh.isEnabled() || !mesh.isVisible || !mesh.isPickable) continue;
        const forceCompute = computeWorldMatrixForCamera && mesh.isWorldMatrixCameraDependent();
        const world = mesh.computeWorldMatrix(forceCompute, currentCamera);
        if (mesh.hasThinInstances && mesh.thinInstanceEnablePicking) {
            const result = this._internalPickForMesh(null, rayFunction, mesh, world, true, true, trianglePredicate);
            if (result) {
                const tmpMatrix = (0, $ha1VO.TmpVectors).Matrix[1];
                const thinMatrices = mesh.thinInstanceGetWorldMatrices();
                for(let index = 0; index < thinMatrices.length; index++){
                    const thinMatrix = thinMatrices[index];
                    thinMatrix.multiplyToRef(world, tmpMatrix);
                    const result = this._internalPickForMesh(null, rayFunction, mesh, tmpMatrix, false, false, trianglePredicate, true);
                    if (result) {
                        result.thinInstanceIndex = index;
                        pickingInfos.push(result);
                    }
                }
            }
        } else {
            const result = this._internalPickForMesh(null, rayFunction, mesh, world, false, false, trianglePredicate);
            if (result) pickingInfos.push(result);
        }
    }
    return pickingInfos;
};
(0, $gmbCk.Scene).prototype.pickWithBoundingInfo = function(x, y, predicate, fastCheck, camera) {
    if (!(0, $gzCma.PickingInfo)) return null;
    const result = this._internalPick((world)=>{
        if (!this._tempPickingRay) this._tempPickingRay = $26be89c393da2d4e$export$a186db52eed6d40e.Zero();
        this.createPickingRayToRef(x, y, world, this._tempPickingRay, camera || null);
        return this._tempPickingRay;
    }, predicate, fastCheck, true);
    if (result) result.ray = this.createPickingRay(x, y, (0, $ha1VO.Matrix).Identity(), camera || null);
    return result;
};
Object.defineProperty((0, $gmbCk.Scene).prototype, "_pickingAvailable", {
    get: ()=>true,
    enumerable: false,
    configurable: false
});
(0, $gmbCk.Scene).prototype.pick = function(x, y, predicate, fastCheck, camera, trianglePredicate, _enableDistantPicking = false) {
    const result = this._internalPick((world, enableDistantPicking)=>{
        if (!this._tempPickingRay) this._tempPickingRay = $26be89c393da2d4e$export$a186db52eed6d40e.Zero();
        this.createPickingRayToRef(x, y, world, this._tempPickingRay, camera || null, false, enableDistantPicking);
        return this._tempPickingRay;
    }, predicate, fastCheck, false, trianglePredicate);
    if (result) result.ray = this.createPickingRay(x, y, (0, $ha1VO.Matrix).Identity(), camera || null);
    return result;
};
(0, $gmbCk.Scene).prototype.pickWithRay = function(ray, predicate, fastCheck, trianglePredicate) {
    const result = this._internalPick((world)=>{
        if (!this._pickWithRayInverseMatrix) this._pickWithRayInverseMatrix = (0, $ha1VO.Matrix).Identity();
        world.invertToRef(this._pickWithRayInverseMatrix);
        if (!this._cachedRayForTransform) this._cachedRayForTransform = $26be89c393da2d4e$export$a186db52eed6d40e.Zero();
        $26be89c393da2d4e$export$a186db52eed6d40e.TransformToRef(ray, this._pickWithRayInverseMatrix, this._cachedRayForTransform);
        return this._cachedRayForTransform;
    }, predicate, fastCheck, false, trianglePredicate);
    if (result) result.ray = ray;
    return result;
};
(0, $gmbCk.Scene).prototype.multiPick = function(x, y, predicate, camera, trianglePredicate) {
    return this._internalMultiPick((world)=>this.createPickingRay(x, y, world, camera || null), predicate, trianglePredicate);
};
(0, $gmbCk.Scene).prototype.multiPickWithRay = function(ray, predicate, trianglePredicate) {
    return this._internalMultiPick((world)=>{
        if (!this._pickWithRayInverseMatrix) this._pickWithRayInverseMatrix = (0, $ha1VO.Matrix).Identity();
        world.invertToRef(this._pickWithRayInverseMatrix);
        if (!this._cachedRayForTransform) this._cachedRayForTransform = $26be89c393da2d4e$export$a186db52eed6d40e.Zero();
        $26be89c393da2d4e$export$a186db52eed6d40e.TransformToRef(ray, this._pickWithRayInverseMatrix, this._cachedRayForTransform);
        return this._cachedRayForTransform;
    }, predicate, trianglePredicate);
};
(0, $74SKQ.Camera).prototype.getForwardRay = function(length = 100, transform, origin) {
    return this.getForwardRayToRef(new $26be89c393da2d4e$export$a186db52eed6d40e((0, $ha1VO.Vector3).Zero(), (0, $ha1VO.Vector3).Zero(), length), length, transform, origin);
};
(0, $74SKQ.Camera).prototype.getForwardRayToRef = function(refRay, length = 100, transform, origin) {
    if (!transform) transform = this.getWorldMatrix();
    refRay.length = length;
    if (origin) refRay.origin.copyFrom(origin);
    else refRay.origin.copyFrom(this.position);
    const forward = (0, $ha1VO.TmpVectors).Vector3[2];
    forward.set(0, 0, this._scene.useRightHandedSystem ? -1 : 1);
    const worldForward = (0, $ha1VO.TmpVectors).Vector3[3];
    (0, $ha1VO.Vector3).TransformNormalToRef(forward, transform, worldForward);
    (0, $ha1VO.Vector3).NormalizeToRef(worldForward, refRay.direction);
    return refRay;
};

});

parcelRegister("3Pok5", function(module, exports) {

$parcel$export(module.exports, "PivotTools", () => $2c99008b174ad257$export$e206efa2afd62768);

var $ha1VO = parcelRequire("ha1VO");
class $2c99008b174ad257$export$e206efa2afd62768 {
    /**
     * @internal
     */ static _RemoveAndStorePivotPoint(mesh) {
        if (mesh && $2c99008b174ad257$export$e206efa2afd62768._PivotCached === 0) {
            // Save old pivot and set pivot to 0,0,0
            mesh.getPivotPointToRef($2c99008b174ad257$export$e206efa2afd62768._OldPivotPoint);
            $2c99008b174ad257$export$e206efa2afd62768._PivotPostMultiplyPivotMatrix = mesh._postMultiplyPivotMatrix;
            if (!$2c99008b174ad257$export$e206efa2afd62768._OldPivotPoint.equalsToFloats(0, 0, 0)) {
                mesh.setPivotMatrix((0, $ha1VO.Matrix).IdentityReadOnly);
                $2c99008b174ad257$export$e206efa2afd62768._OldPivotPoint.subtractToRef(mesh.getPivotPoint(), $2c99008b174ad257$export$e206efa2afd62768._PivotTranslation);
                $2c99008b174ad257$export$e206efa2afd62768._PivotTmpVector.copyFromFloats(1, 1, 1);
                $2c99008b174ad257$export$e206efa2afd62768._PivotTmpVector.subtractInPlace(mesh.scaling);
                $2c99008b174ad257$export$e206efa2afd62768._PivotTmpVector.multiplyInPlace($2c99008b174ad257$export$e206efa2afd62768._PivotTranslation);
                mesh.position.addInPlace($2c99008b174ad257$export$e206efa2afd62768._PivotTmpVector);
            }
        }
        $2c99008b174ad257$export$e206efa2afd62768._PivotCached++;
    }
    /**
     * @internal
     */ static _RestorePivotPoint(mesh) {
        if (mesh && !$2c99008b174ad257$export$e206efa2afd62768._OldPivotPoint.equalsToFloats(0, 0, 0) && $2c99008b174ad257$export$e206efa2afd62768._PivotCached === 1) {
            mesh.setPivotPoint($2c99008b174ad257$export$e206efa2afd62768._OldPivotPoint);
            mesh._postMultiplyPivotMatrix = $2c99008b174ad257$export$e206efa2afd62768._PivotPostMultiplyPivotMatrix;
            $2c99008b174ad257$export$e206efa2afd62768._PivotTmpVector.copyFromFloats(1, 1, 1);
            $2c99008b174ad257$export$e206efa2afd62768._PivotTmpVector.subtractInPlace(mesh.scaling);
            $2c99008b174ad257$export$e206efa2afd62768._PivotTmpVector.multiplyInPlace($2c99008b174ad257$export$e206efa2afd62768._PivotTranslation);
            mesh.position.subtractInPlace($2c99008b174ad257$export$e206efa2afd62768._PivotTmpVector);
        }
        this._PivotCached--;
    }
}
// Stores the state of the pivot cache (_oldPivotPoint, _pivotTranslation)
// store/remove pivot point should only be applied during their outermost calls
$2c99008b174ad257$export$e206efa2afd62768._PivotCached = 0;
$2c99008b174ad257$export$e206efa2afd62768._OldPivotPoint = new (0, $ha1VO.Vector3)();
$2c99008b174ad257$export$e206efa2afd62768._PivotTranslation = new (0, $ha1VO.Vector3)();
$2c99008b174ad257$export$e206efa2afd62768._PivotTmpVector = new (0, $ha1VO.Vector3)();
$2c99008b174ad257$export$e206efa2afd62768._PivotPostMultiplyPivotMatrix = false;

});

parcelRegister("kt6s5", function(module, exports) {

$parcel$export(module.exports, "CreatePlaneVertexData", () => $ee6b855236d2e2b5$export$f53dee9f1fba62c2);
$parcel$export(module.exports, "CreatePlane", () => $ee6b855236d2e2b5$export$474050064c328a47);
$parcel$export(module.exports, "PlaneBuilder", () => $ee6b855236d2e2b5$export$1a236e78939b969a);

var $fbuqw = parcelRequire("fbuqw");

var $5v6ry = parcelRequire("5v6ry");

var $fGXjI = parcelRequire("fGXjI");
function $ee6b855236d2e2b5$export$f53dee9f1fba62c2(options) {
    const indices = [];
    const positions = [];
    const normals = [];
    const uvs = [];
    const width = options.width || options.size || 1;
    const height = options.height || options.size || 1;
    const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || (0, $5v6ry.VertexData).DEFAULTSIDE;
    // Vertices
    const halfWidth = width / 2.0;
    const halfHeight = height / 2.0;
    positions.push(-halfWidth, -halfHeight, 0);
    normals.push(0, 0, -1);
    uvs.push(0.0, (0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? 1.0 : 0.0);
    positions.push(halfWidth, -halfHeight, 0);
    normals.push(0, 0, -1);
    uvs.push(1.0, (0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? 1.0 : 0.0);
    positions.push(halfWidth, halfHeight, 0);
    normals.push(0, 0, -1);
    uvs.push(1.0, (0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? 0.0 : 1.0);
    positions.push(-halfWidth, halfHeight, 0);
    normals.push(0, 0, -1);
    uvs.push(0.0, (0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? 0.0 : 1.0);
    // Indices
    indices.push(0);
    indices.push(1);
    indices.push(2);
    indices.push(0);
    indices.push(2);
    indices.push(3);
    // Sides
    (0, $5v6ry.VertexData)._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
    // Result
    const vertexData = new (0, $5v6ry.VertexData)();
    vertexData.indices = indices;
    vertexData.positions = positions;
    vertexData.normals = normals;
    vertexData.uvs = uvs;
    return vertexData;
}
function $ee6b855236d2e2b5$export$474050064c328a47(name, options = {}, scene = null) {
    const plane = new (0, $fbuqw.Mesh)(name, scene);
    options.sideOrientation = (0, $fbuqw.Mesh)._GetDefaultSideOrientation(options.sideOrientation);
    plane._originalBuilderSideOrientation = options.sideOrientation;
    const vertexData = $ee6b855236d2e2b5$export$f53dee9f1fba62c2(options);
    vertexData.applyToMesh(plane, options.updatable);
    if (options.sourcePlane) {
        plane.translate(options.sourcePlane.normal, -options.sourcePlane.d);
        plane.setDirection(options.sourcePlane.normal.scale(-1));
    }
    return plane;
}
const $ee6b855236d2e2b5$export$1a236e78939b969a = {
    CreatePlane: // eslint-disable-next-line @typescript-eslint/naming-convention
    $ee6b855236d2e2b5$export$474050064c328a47
};
(0, $5v6ry.VertexData).CreatePlane = $ee6b855236d2e2b5$export$f53dee9f1fba62c2;
(0, $fbuqw.Mesh).CreatePlane = (name, size, scene, updatable, sideOrientation)=>{
    const options = {
        size: size,
        width: size,
        height: size,
        sideOrientation: sideOrientation,
        updatable: updatable
    };
    return $ee6b855236d2e2b5$export$474050064c328a47(name, options, scene);
};

});



parcelRegister("bJA9r", function(module, exports) {

$parcel$export(module.exports, "SixDofDragBehavior", () => $88aff0914566a42c$export$6862e54b43819f28);

var $ha1VO = parcelRequire("ha1VO");

var $diGQf = parcelRequire("diGQf");

var $hOMth = parcelRequire("hOMth");

var $klshO = parcelRequire("klshO");

var $dbxbu = parcelRequire("dbxbu");
class $88aff0914566a42c$export$6862e54b43819f28 extends (0, $hOMth.BaseSixDofDragBehavior) {
    constructor(){
        super(...arguments);
        this._sceneRenderObserver = null;
        this._targetPosition = new (0, $ha1VO.Vector3)(0, 0, 0);
        this._targetOrientation = new (0, $ha1VO.Quaternion)();
        this._targetScaling = new (0, $ha1VO.Vector3)(1, 1, 1);
        this._startingPosition = new (0, $ha1VO.Vector3)(0, 0, 0);
        this._startingOrientation = new (0, $ha1VO.Quaternion)();
        this._startingScaling = new (0, $ha1VO.Vector3)(1, 1, 1);
        /**
         * Fires when position is updated
         */ this.onPositionChangedObservable = new (0, $diGQf.Observable)();
        /**
         * The distance towards the target drag position to move each frame. This can be useful to avoid jitter. Set this to 1 for no delay. (Default: 0.2)
         */ this.dragDeltaRatio = 0.2;
        /**
         * If the object should rotate to face the drag origin
         */ this.rotateDraggedObject = true;
        /**
         * If `rotateDraggedObject` is set to `true`, this parameter determines if we are only rotating around the y axis (yaw)
         */ this.rotateAroundYOnly = false;
        /**
         * Should the behavior rotate 1:1 with the motion controller, when one is used.
         */ this.rotateWithMotionController = true;
        /**
         * Use this flag to update the target but not move the owner node towards the target
         */ this.disableMovement = false;
        /**
         * Should the object rotate towards the camera when we start dragging it
         */ this.faceCameraOnDragStart = false;
    }
    /**
     *  The name of the behavior
     */ get name() {
        return "SixDofDrag";
    }
    /**
     * Attaches the six DoF drag behavior
     * In XR mode the mesh and its children will have their isNearGrabbable property set to true
     * @param ownerNode The mesh that will be dragged around once attached
     */ attach(ownerNode) {
        super.attach(ownerNode);
        ownerNode.isNearGrabbable = true;
        // if it has children, make sure they are grabbable too
        ownerNode.getChildMeshes().forEach((m)=>{
            m.isNearGrabbable = true;
        });
        // Node that will save the owner's transform
        this._virtualTransformNode = new (0, $klshO.TransformNode)("virtual_sixDof", (0, $hOMth.BaseSixDofDragBehavior)._virtualScene);
        this._virtualTransformNode.rotationQuaternion = (0, $ha1VO.Quaternion).Identity();
        // On every frame move towards target scaling to avoid jitter caused by vr controllers
        this._sceneRenderObserver = ownerNode.getScene().onBeforeRenderObservable.add(()=>{
            if (this.currentDraggingPointerIds.length === 1 && this._moving && !this.disableMovement) {
                // 1 pointer only drags mesh
                const deltaToAdd = (0, $ha1VO.TmpVectors).Vector3[0];
                deltaToAdd.copyFrom(this._targetPosition).subtractInPlace(ownerNode.absolutePosition).scaleInPlace(this.dragDeltaRatio);
                const deltaToAddTransformed = (0, $ha1VO.TmpVectors).Vector3[1];
                deltaToAddTransformed.copyFrom(deltaToAdd);
                // If the node has a parent, transform the delta to local space, so it can be added to the
                // position in local space
                if (ownerNode.parent) {
                    const parentRotationMatrixInverse = (0, $ha1VO.TmpVectors).Matrix[0];
                    ownerNode.parent.absoluteRotationQuaternion.toRotationMatrix(parentRotationMatrixInverse);
                    parentRotationMatrixInverse.invert();
                    (0, $ha1VO.Vector3).TransformNormalToRef(deltaToAdd, parentRotationMatrixInverse, deltaToAddTransformed);
                }
                ownerNode.position.addInPlace(deltaToAddTransformed);
                this.onPositionChangedObservable.notifyObservers({
                    position: ownerNode.absolutePosition
                });
                // Only rotate the mesh if it's parent has uniform scaling
                if (!ownerNode.parent || ownerNode.parent.scaling && !ownerNode.parent.scaling.isNonUniformWithinEpsilon(0.001)) {
                    const rotationToApply = (0, $ha1VO.TmpVectors).Quaternion[0];
                    rotationToApply.copyFrom(this._targetOrientation);
                    if (ownerNode.parent) {
                        const parentRotationInverse = (0, $ha1VO.TmpVectors).Quaternion[0];
                        parentRotationInverse.copyFrom(ownerNode.parent.absoluteRotationQuaternion);
                        parentRotationInverse.invertInPlace();
                        parentRotationInverse.multiplyToRef(this._targetOrientation, rotationToApply);
                    }
                    (0, $ha1VO.Quaternion).SlerpToRef(ownerNode.rotationQuaternion, rotationToApply, this.dragDeltaRatio, ownerNode.rotationQuaternion);
                }
            }
        });
    }
    _getPositionOffsetAround(transformationLocalOrigin, scaling, rotation) {
        const translationMatrix = (0, $ha1VO.TmpVectors).Matrix[0]; // T
        const translationMatrixInv = (0, $ha1VO.TmpVectors).Matrix[1]; // T'
        const rotationMatrix = (0, $ha1VO.TmpVectors).Matrix[2]; // R
        const scaleMatrix = (0, $ha1VO.TmpVectors).Matrix[3]; // S
        const finalMatrix = (0, $ha1VO.TmpVectors).Matrix[4]; // T' x R x S x T
        (0, $ha1VO.Matrix).TranslationToRef(transformationLocalOrigin.x, transformationLocalOrigin.y, transformationLocalOrigin.z, translationMatrix); // T
        (0, $ha1VO.Matrix).TranslationToRef(-transformationLocalOrigin.x, -transformationLocalOrigin.y, -transformationLocalOrigin.z, translationMatrixInv); // T'
        (0, $ha1VO.Matrix).FromQuaternionToRef(rotation, rotationMatrix); // R
        (0, $ha1VO.Matrix).ScalingToRef(scaling, scaling, scaling, scaleMatrix);
        translationMatrixInv.multiplyToRef(rotationMatrix, finalMatrix); // T' x R
        finalMatrix.multiplyToRef(scaleMatrix, finalMatrix); // T' x R x S
        finalMatrix.multiplyToRef(translationMatrix, finalMatrix); // T' x R x S x T
        return finalMatrix.getTranslation();
    }
    _onePointerPositionUpdated(worldDeltaPosition, worldDeltaRotation) {
        const pointerDelta = (0, $ha1VO.TmpVectors).Vector3[0];
        pointerDelta.setAll(0);
        if (this._dragging === this._dragType.DRAG) {
            if (this.rotateDraggedObject) {
                if (this.rotateAroundYOnly) // Convert change in rotation to only y axis rotation
                (0, $ha1VO.Quaternion).RotationYawPitchRollToRef(worldDeltaRotation.toEulerAngles().y, 0, 0, (0, $ha1VO.TmpVectors).Quaternion[0]);
                else (0, $ha1VO.TmpVectors).Quaternion[0].copyFrom(worldDeltaRotation);
                (0, $ha1VO.TmpVectors).Quaternion[0].multiplyToRef(this._startingOrientation, this._targetOrientation);
            }
        } else if (this._dragging === this._dragType.NEAR_DRAG || this._dragging === this._dragType.DRAG_WITH_CONTROLLER && this.rotateWithMotionController) worldDeltaRotation.multiplyToRef(this._startingOrientation, this._targetOrientation);
        this._targetPosition.copyFrom(this._startingPosition).addInPlace(worldDeltaPosition);
    }
    _twoPointersPositionUpdated() {
        const startingPosition0 = this._virtualMeshesInfo[this.currentDraggingPointerIds[0]].startingPosition;
        const startingPosition1 = this._virtualMeshesInfo[this.currentDraggingPointerIds[1]].startingPosition;
        const startingCenter = (0, $ha1VO.TmpVectors).Vector3[0];
        startingPosition0.addToRef(startingPosition1, startingCenter);
        startingCenter.scaleInPlace(0.5);
        const startingVector = (0, $ha1VO.TmpVectors).Vector3[1];
        startingPosition1.subtractToRef(startingPosition0, startingVector);
        const currentPosition0 = this._virtualMeshesInfo[this.currentDraggingPointerIds[0]].dragMesh.absolutePosition;
        const currentPosition1 = this._virtualMeshesInfo[this.currentDraggingPointerIds[1]].dragMesh.absolutePosition;
        const currentCenter = (0, $ha1VO.TmpVectors).Vector3[2];
        currentPosition0.addToRef(currentPosition1, currentCenter);
        currentCenter.scaleInPlace(0.5);
        const currentVector = (0, $ha1VO.TmpVectors).Vector3[3];
        currentPosition1.subtractToRef(currentPosition0, currentVector);
        const scaling = currentVector.length() / startingVector.length();
        const translation = currentCenter.subtract(startingCenter);
        const rotationQuaternion = (0, $ha1VO.Quaternion).FromEulerAngles(0, (0, $ha1VO.Vector3).GetAngleBetweenVectorsOnPlane(startingVector.normalize(), currentVector.normalize(), (0, $ha1VO.Vector3).UpReadOnly), 0);
        const oldParent = this._ownerNode.parent;
        this._ownerNode.setParent(null);
        const positionOffset = this._getPositionOffsetAround(startingCenter.subtract(this._virtualTransformNode.getAbsolutePivotPoint()), scaling, rotationQuaternion);
        this._virtualTransformNode.rotationQuaternion.multiplyToRef(rotationQuaternion, this._ownerNode.rotationQuaternion);
        this._virtualTransformNode.scaling.scaleToRef(scaling, this._ownerNode.scaling);
        this._virtualTransformNode.position.addToRef(translation.addInPlace(positionOffset), this._ownerNode.position);
        this.onPositionChangedObservable.notifyObservers({
            position: this._ownerNode.position
        });
        this._ownerNode.setParent(oldParent);
    }
    _targetDragStart() {
        const pointerCount = this.currentDraggingPointerIds.length;
        if (!this._ownerNode.rotationQuaternion) this._ownerNode.rotationQuaternion = (0, $ha1VO.Quaternion).RotationYawPitchRoll(this._ownerNode.rotation.y, this._ownerNode.rotation.x, this._ownerNode.rotation.z);
        const worldPivot = this._ownerNode.getAbsolutePivotPoint();
        if (pointerCount === 1) {
            this._targetPosition.copyFrom(this._ownerNode.absolutePosition);
            this._targetOrientation.copyFrom(this._ownerNode.absoluteRotationQuaternion);
            this._targetScaling.copyFrom(this._ownerNode.absoluteScaling);
            if (this.faceCameraOnDragStart && this._scene.activeCamera) {
                const toCamera = (0, $ha1VO.TmpVectors).Vector3[0];
                this._scene.activeCamera.position.subtractToRef(worldPivot, toCamera);
                toCamera.normalize();
                const quat = (0, $ha1VO.TmpVectors).Quaternion[0];
                if (this._scene.useRightHandedSystem) (0, $ha1VO.Quaternion).FromLookDirectionRHToRef(toCamera, new (0, $ha1VO.Vector3)(0, 1, 0), quat);
                else (0, $ha1VO.Quaternion).FromLookDirectionLHToRef(toCamera, new (0, $ha1VO.Vector3)(0, 1, 0), quat);
                quat.normalize();
                (0, $ha1VO.Quaternion).RotationYawPitchRollToRef(quat.toEulerAngles().y, 0, 0, (0, $ha1VO.TmpVectors).Quaternion[0]);
                this._targetOrientation.copyFrom((0, $ha1VO.TmpVectors).Quaternion[0]);
            }
            this._startingPosition.copyFrom(this._targetPosition);
            this._startingOrientation.copyFrom(this._targetOrientation);
            this._startingScaling.copyFrom(this._targetScaling);
        } else if (pointerCount === 2) {
            this._virtualTransformNode.setPivotPoint(new (0, $ha1VO.Vector3)(0, 0, 0), (0, $dbxbu.Space).LOCAL);
            this._virtualTransformNode.position.copyFrom(this._ownerNode.absolutePosition);
            this._virtualTransformNode.scaling.copyFrom(this._ownerNode.absoluteScaling);
            this._virtualTransformNode.rotationQuaternion.copyFrom(this._ownerNode.absoluteRotationQuaternion);
            this._virtualTransformNode.setPivotPoint(worldPivot, (0, $dbxbu.Space).WORLD);
            this._resetVirtualMeshesPosition();
        }
    }
    _targetDrag(worldDeltaPosition, worldDeltaRotation) {
        if (this.currentDraggingPointerIds.length === 1) this._onePointerPositionUpdated(worldDeltaPosition, worldDeltaRotation);
        else if (this.currentDraggingPointerIds.length === 2) this._twoPointersPositionUpdated();
    }
    _targetDragEnd() {
        if (this.currentDraggingPointerIds.length === 1) {
            // We still have 1 active pointer, we must simulate a dragstart with a reseted position/orientation
            this._resetVirtualMeshesPosition();
            const previousFaceCameraFlag = this.faceCameraOnDragStart;
            this.faceCameraOnDragStart = false;
            this._targetDragStart();
            this.faceCameraOnDragStart = previousFaceCameraFlag;
        }
    }
    /**
     *  Detaches the behavior from the mesh
     */ detach() {
        super.detach();
        if (this._ownerNode) this._ownerNode.getScene().onBeforeRenderObservable.remove(this._sceneRenderObserver);
        if (this._virtualTransformNode) this._virtualTransformNode.dispose();
    }
}

});
parcelRegister("hOMth", function(module, exports) {

$parcel$export(module.exports, "BaseSixDofDragBehavior", () => $cf8cb49424d24fbb$export$c85e24644543f304);

var $0cHNL = parcelRequire("0cHNL");

var $gmbCk = parcelRequire("gmbCk");

var $cfkw4 = parcelRequire("cfkw4");

var $ha1VO = parcelRequire("ha1VO");

var $diGQf = parcelRequire("diGQf");

var $74SKQ = parcelRequire("74SKQ");
class $cf8cb49424d24fbb$export$c85e24644543f304 {
    constructor(){
        this._attachedToElement = false;
        this._virtualMeshesInfo = {};
        this._tmpVector = new (0, $ha1VO.Vector3)();
        this._tmpQuaternion = new (0, $ha1VO.Quaternion)();
        this._dragType = {
            NONE: 0,
            DRAG: 1,
            DRAG_WITH_CONTROLLER: 2,
            NEAR_DRAG: 3
        };
        this._moving = false;
        this._dragging = this._dragType.NONE;
        /**
         * The list of child meshes that can receive drag events
         * If `null`, all child meshes will receive drag event
         */ this.draggableMeshes = null;
        /**
         * How much faster the object should move when the controller is moving towards it. This is useful to bring objects that are far away from the user to them faster. Set this to 0 to avoid any speed increase. (Default: 3)
         */ this.zDragFactor = 3;
        /**
         * In case of multipointer interaction, all pointer ids currently active are stored here
         */ this.currentDraggingPointerIds = [];
        /**
        /**
         * If camera controls should be detached during the drag
         */ this.detachCameraControls = true;
        /**
         * Fires each time a drag starts
         */ this.onDragStartObservable = new (0, $diGQf.Observable)();
        /**
         * Fires each time a drag happens
         */ this.onDragObservable = new (0, $diGQf.Observable)();
        /**
         *  Fires each time a drag ends (eg. mouse release after drag)
         */ this.onDragEndObservable = new (0, $diGQf.Observable)();
        /**
         * Should the behavior allow simultaneous pointers to interact with the owner node.
         */ this.allowMultiPointer = true;
    }
    /**
     * The id of the pointer that is currently interacting with the behavior (-1 when no pointer is active)
     */ get currentDraggingPointerId() {
        if (this.currentDraggingPointerIds[0] !== undefined) return this.currentDraggingPointerIds[0];
        return -1;
    }
    set currentDraggingPointerId(value) {
        this.currentDraggingPointerIds[0] = value;
    }
    /**
     * Get or set the currentDraggingPointerId
     * @deprecated Please use currentDraggingPointerId instead
     */ get currentDraggingPointerID() {
        return this.currentDraggingPointerId;
    }
    set currentDraggingPointerID(currentDraggingPointerID) {
        this.currentDraggingPointerId = currentDraggingPointerID;
    }
    /**
     *  The name of the behavior
     */ get name() {
        return "BaseSixDofDrag";
    }
    /**
     *  Returns true if the attached mesh is currently moving with this behavior
     */ get isMoving() {
        return this._moving;
    }
    /**
     *  Initializes the behavior
     */ init() {}
    /**
     * In the case of multiple active cameras, the cameraToUseForPointers should be used if set instead of active camera
     */ get _pointerCamera() {
        if (this._scene.cameraToUseForPointers) return this._scene.cameraToUseForPointers;
        else return this._scene.activeCamera;
    }
    _createVirtualMeshInfo() {
        // Setup virtual meshes to be used for dragging without dirtying the existing scene
        const dragMesh = new (0, $0cHNL.AbstractMesh)("", $cf8cb49424d24fbb$export$c85e24644543f304._virtualScene);
        dragMesh.rotationQuaternion = new (0, $ha1VO.Quaternion)();
        const originMesh = new (0, $0cHNL.AbstractMesh)("", $cf8cb49424d24fbb$export$c85e24644543f304._virtualScene);
        originMesh.rotationQuaternion = new (0, $ha1VO.Quaternion)();
        const pivotMesh = new (0, $0cHNL.AbstractMesh)("", $cf8cb49424d24fbb$export$c85e24644543f304._virtualScene);
        pivotMesh.rotationQuaternion = new (0, $ha1VO.Quaternion)();
        return {
            dragging: false,
            moving: false,
            dragMesh: dragMesh,
            originMesh: originMesh,
            pivotMesh: pivotMesh,
            startingPivotPosition: new (0, $ha1VO.Vector3)(),
            startingPivotOrientation: new (0, $ha1VO.Quaternion)(),
            startingPosition: new (0, $ha1VO.Vector3)(),
            startingOrientation: new (0, $ha1VO.Quaternion)(),
            lastOriginPosition: new (0, $ha1VO.Vector3)(),
            lastDragPosition: new (0, $ha1VO.Vector3)()
        };
    }
    _resetVirtualMeshesPosition() {
        for(let i = 0; i < this.currentDraggingPointerIds.length; i++){
            this._virtualMeshesInfo[this.currentDraggingPointerIds[i]].pivotMesh.position.copyFrom(this._ownerNode.getAbsolutePivotPoint());
            this._virtualMeshesInfo[this.currentDraggingPointerIds[i]].pivotMesh.rotationQuaternion.copyFrom(this._ownerNode.rotationQuaternion);
            this._virtualMeshesInfo[this.currentDraggingPointerIds[i]].startingPivotPosition.copyFrom(this._virtualMeshesInfo[this.currentDraggingPointerIds[i]].pivotMesh.position);
            this._virtualMeshesInfo[this.currentDraggingPointerIds[i]].startingPivotOrientation.copyFrom(this._virtualMeshesInfo[this.currentDraggingPointerIds[i]].pivotMesh.rotationQuaternion);
            this._virtualMeshesInfo[this.currentDraggingPointerIds[i]].startingPosition.copyFrom(this._virtualMeshesInfo[this.currentDraggingPointerIds[i]].dragMesh.position);
            this._virtualMeshesInfo[this.currentDraggingPointerIds[i]].startingOrientation.copyFrom(this._virtualMeshesInfo[this.currentDraggingPointerIds[i]].dragMesh.rotationQuaternion);
        }
    }
    _pointerUpdate2D(ray, pointerId, zDragFactor) {
        if (this._pointerCamera && this._pointerCamera.cameraRigMode == (0, $74SKQ.Camera).RIG_MODE_NONE && !this._pointerCamera._isLeftCamera && !this._pointerCamera._isRightCamera) {
            ray.origin.copyFrom(this._pointerCamera.globalPosition);
            zDragFactor = 0;
        }
        const virtualMeshesInfo = this._virtualMeshesInfo[pointerId];
        // Calculate controller drag distance in controller space
        const originDragDifference = (0, $ha1VO.TmpVectors).Vector3[0];
        ray.origin.subtractToRef(virtualMeshesInfo.lastOriginPosition, originDragDifference);
        virtualMeshesInfo.lastOriginPosition.copyFrom(ray.origin);
        const localOriginDragDifference = -(0, $ha1VO.Vector3).Dot(originDragDifference, ray.direction);
        virtualMeshesInfo.originMesh.addChild(virtualMeshesInfo.dragMesh);
        virtualMeshesInfo.originMesh.addChild(virtualMeshesInfo.pivotMesh);
        this._applyZOffset(virtualMeshesInfo.dragMesh, localOriginDragDifference, zDragFactor);
        this._applyZOffset(virtualMeshesInfo.pivotMesh, localOriginDragDifference, zDragFactor);
        // Update the controller position
        virtualMeshesInfo.originMesh.position.copyFrom(ray.origin);
        const lookAt = (0, $ha1VO.TmpVectors).Vector3[0];
        ray.origin.addToRef(ray.direction, lookAt);
        virtualMeshesInfo.originMesh.lookAt(lookAt);
        virtualMeshesInfo.originMesh.removeChild(virtualMeshesInfo.dragMesh);
        virtualMeshesInfo.originMesh.removeChild(virtualMeshesInfo.pivotMesh);
    }
    _pointerUpdateXR(controllerAimTransform, controllerGripTransform, pointerId, zDragFactor) {
        const virtualMeshesInfo = this._virtualMeshesInfo[pointerId];
        virtualMeshesInfo.originMesh.position.copyFrom(controllerAimTransform.position);
        if (this._dragging === this._dragType.NEAR_DRAG && controllerGripTransform) virtualMeshesInfo.originMesh.rotationQuaternion.copyFrom(controllerGripTransform.rotationQuaternion);
        else virtualMeshesInfo.originMesh.rotationQuaternion.copyFrom(controllerAimTransform.rotationQuaternion);
        virtualMeshesInfo.pivotMesh.computeWorldMatrix(true);
        virtualMeshesInfo.dragMesh.computeWorldMatrix(true);
        // Z scaling logic
        if (zDragFactor !== 0) {
            // Camera.getForwardRay modifies TmpVectors.Vector[0-3], so cache it in advance
            const cameraForwardVec = (0, $ha1VO.TmpVectors).Vector3[0];
            const originDragDirection = (0, $ha1VO.TmpVectors).Vector3[1];
            cameraForwardVec.copyFrom(this._pointerCamera.getForwardRay().direction);
            virtualMeshesInfo.originMesh.position.subtractToRef(virtualMeshesInfo.lastOriginPosition, originDragDirection);
            virtualMeshesInfo.lastOriginPosition.copyFrom(virtualMeshesInfo.originMesh.position);
            const controllerDragDistance = originDragDirection.length();
            originDragDirection.normalize();
            const cameraToDrag = (0, $ha1VO.TmpVectors).Vector3[2];
            const controllerToDrag = (0, $ha1VO.TmpVectors).Vector3[3];
            virtualMeshesInfo.dragMesh.absolutePosition.subtractToRef(this._pointerCamera.globalPosition, cameraToDrag);
            virtualMeshesInfo.dragMesh.absolutePosition.subtractToRef(virtualMeshesInfo.originMesh.position, controllerToDrag);
            const controllerToDragDistance = controllerToDrag.length();
            cameraToDrag.normalize();
            controllerToDrag.normalize();
            const controllerDragScaling = Math.abs((0, $ha1VO.Vector3).Dot(originDragDirection, controllerToDrag)) * (0, $ha1VO.Vector3).Dot(originDragDirection, cameraForwardVec);
            let zOffsetScaling = controllerDragScaling * zDragFactor * controllerDragDistance * controllerToDragDistance;
            // Prevent pulling the mesh through the controller
            const minDistanceFromControllerToDragMesh = 0.01;
            if (zOffsetScaling < 0 && minDistanceFromControllerToDragMesh - controllerToDragDistance > zOffsetScaling) zOffsetScaling = Math.min(minDistanceFromControllerToDragMesh - controllerToDragDistance, 0);
            controllerToDrag.scaleInPlace(zOffsetScaling);
            controllerToDrag.addToRef(virtualMeshesInfo.pivotMesh.absolutePosition, this._tmpVector);
            virtualMeshesInfo.pivotMesh.setAbsolutePosition(this._tmpVector);
            controllerToDrag.addToRef(virtualMeshesInfo.dragMesh.absolutePosition, this._tmpVector);
            virtualMeshesInfo.dragMesh.setAbsolutePosition(this._tmpVector);
        }
    }
    /**
     * Attaches the scale behavior the passed in mesh
     * @param ownerNode The mesh that will be scaled around once attached
     */ attach(ownerNode) {
        this._ownerNode = ownerNode;
        this._scene = this._ownerNode.getScene();
        if (!$cf8cb49424d24fbb$export$c85e24644543f304._virtualScene) {
            $cf8cb49424d24fbb$export$c85e24644543f304._virtualScene = new (0, $gmbCk.Scene)(this._scene.getEngine(), {
                virtual: true
            });
            $cf8cb49424d24fbb$export$c85e24644543f304._virtualScene.detachControl();
        }
        const pickPredicate = (m)=>{
            return this._ownerNode === m || m.isDescendantOf(this._ownerNode) && (!this.draggableMeshes || this.draggableMeshes.indexOf(m) !== -1);
        };
        this._pointerObserver = this._scene.onPointerObservable.add((pointerInfo)=>{
            const pointerId = pointerInfo.event.pointerId;
            if (!this._virtualMeshesInfo[pointerId]) this._virtualMeshesInfo[pointerId] = this._createVirtualMeshInfo();
            const virtualMeshesInfo = this._virtualMeshesInfo[pointerId];
            const isXRPointer = pointerInfo.event.pointerType === "xr-near" || pointerInfo.event.pointerType === "xr";
            if (pointerInfo.type == (0, $cfkw4.PointerEventTypes).POINTERDOWN) {
                if (!virtualMeshesInfo.dragging && pointerInfo.pickInfo && pointerInfo.pickInfo.hit && pointerInfo.pickInfo.pickedMesh && pointerInfo.pickInfo.pickedPoint && pointerInfo.pickInfo.ray && (!isXRPointer || pointerInfo.pickInfo.aimTransform) && pickPredicate(pointerInfo.pickInfo.pickedMesh)) {
                    if ((!this.allowMultiPointer || isXRPointer) && this.currentDraggingPointerIds.length > 0) return;
                    if (this._pointerCamera && this._pointerCamera.cameraRigMode === (0, $74SKQ.Camera).RIG_MODE_NONE && !this._pointerCamera._isLeftCamera && !this._pointerCamera._isRightCamera) pointerInfo.pickInfo.ray.origin.copyFrom(this._pointerCamera.globalPosition);
                    this._ownerNode.computeWorldMatrix(true);
                    const virtualMeshesInfo = this._virtualMeshesInfo[pointerId];
                    if (isXRPointer) {
                        this._dragging = pointerInfo.pickInfo.originMesh ? this._dragType.NEAR_DRAG : this._dragType.DRAG_WITH_CONTROLLER;
                        virtualMeshesInfo.originMesh.position.copyFrom(pointerInfo.pickInfo.aimTransform.position);
                        if (this._dragging === this._dragType.NEAR_DRAG && pointerInfo.pickInfo.gripTransform) virtualMeshesInfo.originMesh.rotationQuaternion.copyFrom(pointerInfo.pickInfo.gripTransform.rotationQuaternion);
                        else virtualMeshesInfo.originMesh.rotationQuaternion.copyFrom(pointerInfo.pickInfo.aimTransform.rotationQuaternion);
                    } else {
                        this._dragging = this._dragType.DRAG;
                        virtualMeshesInfo.originMesh.position.copyFrom(pointerInfo.pickInfo.ray.origin);
                    }
                    virtualMeshesInfo.lastOriginPosition.copyFrom(virtualMeshesInfo.originMesh.position);
                    virtualMeshesInfo.dragMesh.position.copyFrom(pointerInfo.pickInfo.pickedPoint);
                    virtualMeshesInfo.lastDragPosition.copyFrom(pointerInfo.pickInfo.pickedPoint);
                    virtualMeshesInfo.pivotMesh.position.copyFrom(this._ownerNode.getAbsolutePivotPoint());
                    virtualMeshesInfo.pivotMesh.rotationQuaternion.copyFrom(this._ownerNode.absoluteRotationQuaternion);
                    virtualMeshesInfo.startingPosition.copyFrom(virtualMeshesInfo.dragMesh.position);
                    virtualMeshesInfo.startingPivotPosition.copyFrom(virtualMeshesInfo.pivotMesh.position);
                    virtualMeshesInfo.startingOrientation.copyFrom(virtualMeshesInfo.dragMesh.rotationQuaternion);
                    virtualMeshesInfo.startingPivotOrientation.copyFrom(virtualMeshesInfo.pivotMesh.rotationQuaternion);
                    if (isXRPointer) {
                        virtualMeshesInfo.originMesh.addChild(virtualMeshesInfo.dragMesh);
                        virtualMeshesInfo.originMesh.addChild(virtualMeshesInfo.pivotMesh);
                    } else virtualMeshesInfo.originMesh.lookAt(virtualMeshesInfo.dragMesh.position);
                    // Update state
                    virtualMeshesInfo.dragging = true;
                    if (this.currentDraggingPointerIds.indexOf(pointerId) === -1) this.currentDraggingPointerIds.push(pointerId);
                    // Detach camera controls
                    if (this.detachCameraControls && this._pointerCamera && !this._pointerCamera.leftCamera) {
                        if (this._pointerCamera.inputs && this._pointerCamera.inputs.attachedToElement) {
                            this._pointerCamera.detachControl();
                            this._attachedToElement = true;
                        } else if (!this.allowMultiPointer || this.currentDraggingPointerIds.length === 0) this._attachedToElement = false;
                    }
                    this._targetDragStart(virtualMeshesInfo.pivotMesh.position, virtualMeshesInfo.pivotMesh.rotationQuaternion, pointerId);
                    this.onDragStartObservable.notifyObservers({
                        position: virtualMeshesInfo.pivotMesh.position
                    });
                }
            } else if (pointerInfo.type == (0, $cfkw4.PointerEventTypes).POINTERUP || pointerInfo.type == (0, $cfkw4.PointerEventTypes).POINTERDOUBLETAP) {
                const registeredPointerIndex = this.currentDraggingPointerIds.indexOf(pointerId);
                // Update state
                virtualMeshesInfo.dragging = false;
                if (registeredPointerIndex !== -1) {
                    this.currentDraggingPointerIds.splice(registeredPointerIndex, 1);
                    if (this.currentDraggingPointerIds.length === 0) {
                        this._moving = false;
                        this._dragging = this._dragType.NONE;
                        // Reattach camera controls
                        if (this.detachCameraControls && this._attachedToElement && this._pointerCamera && !this._pointerCamera.leftCamera) {
                            this._reattachCameraControls();
                            this._attachedToElement = false;
                        }
                    }
                    virtualMeshesInfo.originMesh.removeChild(virtualMeshesInfo.dragMesh);
                    virtualMeshesInfo.originMesh.removeChild(virtualMeshesInfo.pivotMesh);
                    this._targetDragEnd(pointerId);
                    this.onDragEndObservable.notifyObservers({});
                }
            } else if (pointerInfo.type == (0, $cfkw4.PointerEventTypes).POINTERMOVE) {
                const registeredPointerIndex = this.currentDraggingPointerIds.indexOf(pointerId);
                if (registeredPointerIndex !== -1 && virtualMeshesInfo.dragging && pointerInfo.pickInfo && (pointerInfo.pickInfo.ray || pointerInfo.pickInfo.aimTransform)) {
                    let zDragFactor = this.zDragFactor;
                    // 2 pointer interaction should not have a z axis drag factor
                    // as well as near interaction
                    if (this.currentDraggingPointerIds.length > 1 || pointerInfo.pickInfo.originMesh) zDragFactor = 0;
                    this._ownerNode.computeWorldMatrix(true);
                    if (!isXRPointer) this._pointerUpdate2D(pointerInfo.pickInfo.ray, pointerId, zDragFactor);
                    else this._pointerUpdateXR(pointerInfo.pickInfo.aimTransform, pointerInfo.pickInfo.gripTransform, pointerId, zDragFactor);
                    // Get change in rotation
                    this._tmpQuaternion.copyFrom(virtualMeshesInfo.startingPivotOrientation);
                    this._tmpQuaternion.x = -this._tmpQuaternion.x;
                    this._tmpQuaternion.y = -this._tmpQuaternion.y;
                    this._tmpQuaternion.z = -this._tmpQuaternion.z;
                    virtualMeshesInfo.pivotMesh.absoluteRotationQuaternion.multiplyToRef(this._tmpQuaternion, this._tmpQuaternion);
                    virtualMeshesInfo.pivotMesh.absolutePosition.subtractToRef(virtualMeshesInfo.startingPivotPosition, this._tmpVector);
                    this.onDragObservable.notifyObservers({
                        delta: this._tmpVector,
                        position: virtualMeshesInfo.pivotMesh.position,
                        pickInfo: pointerInfo.pickInfo
                    });
                    // Notify herited methods and observables
                    this._targetDrag(this._tmpVector, this._tmpQuaternion, pointerId);
                    virtualMeshesInfo.lastDragPosition.copyFrom(virtualMeshesInfo.dragMesh.absolutePosition);
                    this._moving = true;
                }
            }
        });
    }
    _applyZOffset(node, localOriginDragDifference, zDragFactor) {
        // Determine how much the controller moved to/away towards the dragged object and use this to move the object further when its further away
        node.position.z -= node.position.z < 1 ? localOriginDragDifference * zDragFactor : localOriginDragDifference * zDragFactor * node.position.z;
        if (node.position.z < 0) node.position.z = 0;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _targetDragStart(worldPosition, worldRotation, pointerId) {
    // Herited classes can override that
    }
    _targetDrag(worldDeltaPosition, worldDeltaRotation, pointerId) {
    // Herited classes can override that
    }
    _targetDragEnd(pointerId) {
    // Herited classes can override that
    }
    _reattachCameraControls() {
        if (this._pointerCamera) {
            // If the camera is an ArcRotateCamera, preserve the settings from the camera
            // when reattaching control
            if (this._pointerCamera.getClassName() === "ArcRotateCamera") {
                const arcRotateCamera = this._pointerCamera;
                arcRotateCamera.attachControl(arcRotateCamera.inputs ? arcRotateCamera.inputs.noPreventDefault : true, arcRotateCamera._useCtrlForPanning, arcRotateCamera._panningMouseButton);
            } else // preserve the settings from the camera when reattaching control
            this._pointerCamera.attachControl(this._pointerCamera.inputs ? this._pointerCamera.inputs.noPreventDefault : true);
        }
    }
    /**
     * Detaches the behavior from the mesh
     */ detach() {
        if (this._scene) {
            if (this.detachCameraControls && this._attachedToElement && this._pointerCamera && !this._pointerCamera.leftCamera) {
                this._reattachCameraControls();
                this._attachedToElement = false;
            }
            this._scene.onPointerObservable.remove(this._pointerObserver);
        }
        for(const pointerId in this._virtualMeshesInfo){
            this._virtualMeshesInfo[pointerId].originMesh.dispose();
            this._virtualMeshesInfo[pointerId].dragMesh.dispose();
        }
        this.onDragEndObservable.clear();
        this.onDragObservable.clear();
        this.onDragStartObservable.clear();
    }
}

});


parcelRegister("jSdrl", function(module, exports) {

$parcel$export(module.exports, "SurfaceMagnetismBehavior", () => $e77d7c5d85519157$export$3aff36a368661032);

var $cfkw4 = parcelRequire("cfkw4");

var $ha1VO = parcelRequire("ha1VO");
class $e77d7c5d85519157$export$3aff36a368661032 {
    constructor(){
        this._attachPointLocalOffset = new (0, $ha1VO.Vector3)();
        this._workingPosition = new (0, $ha1VO.Vector3)();
        this._workingQuaternion = new (0, $ha1VO.Quaternion)();
        this._lastTick = -1;
        this._hit = false;
        /**
         * Distance offset from the hit point to place the target at, along the hit normal.
         */ this.hitNormalOffset = 0.05;
        /**
         * Spatial mapping meshes to collide with
         */ this.meshes = [];
        /**
         * Set to false if the node should strictly follow the camera without any interpolation time
         */ this.interpolatePose = true;
        /**
         * Rate of interpolation of position and rotation of the attached node.
         * Higher values will give a slower interpolation.
         */ this.lerpTime = 250;
        /**
         * If true, pitch and roll are omitted.
         */ this.keepOrientationVertical = true;
        /**
         * Is this behavior reacting to pointer events
         */ this.enabled = true;
        /**
         * Maximum distance for the node to stick to the surface
         */ this.maxStickingDistance = 0.8;
    }
    /**
     * Name of the behavior
     */ get name() {
        return "SurfaceMagnetism";
    }
    /**
     * Function called when the behavior needs to be initialized (after attaching it to a target)
     */ init() {}
    /**
     * Attaches the behavior to a transform node
     * @param target defines the target where the behavior is attached to
     * @param scene the scene
     */ attach(target, scene) {
        this._attachedMesh = target;
        this._scene = scene || target.getScene();
        if (!this._attachedMesh.rotationQuaternion) this._attachedMesh.rotationQuaternion = (0, $ha1VO.Quaternion).RotationYawPitchRoll(this._attachedMesh.rotation.y, this._attachedMesh.rotation.x, this._attachedMesh.rotation.z);
        this.updateAttachPoint();
        this._workingPosition.copyFrom(this._attachedMesh.position);
        this._workingQuaternion.copyFrom(this._attachedMesh.rotationQuaternion);
        this._addObservables();
    }
    /**
     * Detaches the behavior
     */ detach() {
        this._attachedMesh = null;
        this._removeObservables();
    }
    _getTargetPose(pickingInfo) {
        if (!this._attachedMesh) return null;
        if (pickingInfo && pickingInfo.hit) {
            const pickedNormal = pickingInfo.getNormal(true, true);
            const pickedPoint = pickingInfo.pickedPoint;
            if (!pickedNormal || !pickedPoint) return null;
            pickedNormal.normalize();
            const worldTarget = (0, $ha1VO.TmpVectors).Vector3[0];
            worldTarget.copyFrom(pickedNormal);
            worldTarget.scaleInPlace(this.hitNormalOffset);
            worldTarget.addInPlace(pickedPoint);
            if (this._attachedMesh.parent) {
                (0, $ha1VO.TmpVectors).Matrix[0].copyFrom(this._attachedMesh.parent.getWorldMatrix()).invert();
                (0, $ha1VO.Vector3).TransformNormalToRef(worldTarget, (0, $ha1VO.TmpVectors).Matrix[0], worldTarget);
            }
            return {
                position: worldTarget,
                quaternion: (0, $ha1VO.Quaternion).RotationYawPitchRoll(-Math.atan2(pickedNormal.x, -pickedNormal.z), this.keepOrientationVertical ? 0 : Math.atan2(pickedNormal.y, Math.sqrt(pickedNormal.z * pickedNormal.z + pickedNormal.x * pickedNormal.x)), 0)
            };
        }
        return null;
    }
    /**
     * Updates the attach point with the current geometry extents of the attached mesh
     */ updateAttachPoint() {
        this._getAttachPointOffsetToRef(this._attachPointLocalOffset);
    }
    /**
     * Finds the intersection point of the given ray onto the meshes and updates the target.
     * Transformation will be interpolated according to `interpolatePose` and `lerpTime` properties.
     * If no mesh of `meshes` are hit, this does nothing.
     * @param pickInfo The input pickingInfo that will be used to intersect the meshes
     * @returns a boolean indicating if we found a hit to stick to
     */ findAndUpdateTarget(pickInfo) {
        this._hit = false;
        if (!pickInfo.ray) return false;
        const subPicking = pickInfo.ray.intersectsMeshes(this.meshes)[0];
        if (this._attachedMesh && subPicking && subPicking.hit && subPicking.pickedMesh) {
            const pose = this._getTargetPose(subPicking);
            if (pose && (0, $ha1VO.Vector3).Distance(this._attachedMesh.position, pose.position) < this.maxStickingDistance) {
                this._workingPosition.copyFrom(pose.position);
                this._workingQuaternion.copyFrom(pose.quaternion);
                this._hit = true;
            }
        }
        return this._hit;
    }
    _getAttachPointOffsetToRef(ref) {
        if (!this._attachedMesh) {
            ref.setAll(0);
            return;
        }
        const storedQuat = (0, $ha1VO.TmpVectors).Quaternion[0];
        storedQuat.copyFrom(this._attachedMesh.rotationQuaternion);
        this._attachedMesh.rotationQuaternion.copyFromFloats(0, 0, 0, 1);
        this._attachedMesh.computeWorldMatrix();
        const boundingMinMax = this._attachedMesh.getHierarchyBoundingVectors();
        const center = (0, $ha1VO.TmpVectors).Vector3[0];
        boundingMinMax.max.addToRef(boundingMinMax.min, center);
        center.scaleInPlace(0.5);
        center.z = boundingMinMax.max.z;
        // We max the z coordinate because we want the attach point to be on the back of the mesh
        const invWorld = (0, $ha1VO.TmpVectors).Matrix[0];
        this._attachedMesh.getWorldMatrix().invertToRef(invWorld);
        (0, $ha1VO.Vector3).TransformCoordinatesToRef(center, invWorld, ref);
        this._attachedMesh.rotationQuaternion.copyFrom(storedQuat);
    }
    _updateTransformToGoal(elapsed) {
        if (!this._attachedMesh || !this._hit) return;
        const oldParent = this._attachedMesh.parent;
        this._attachedMesh.setParent(null);
        const worldOffset = (0, $ha1VO.TmpVectors).Vector3[0];
        (0, $ha1VO.Vector3).TransformNormalToRef(this._attachPointLocalOffset, this._attachedMesh.getWorldMatrix(), worldOffset);
        if (!this.interpolatePose) {
            this._attachedMesh.position.copyFrom(this._workingPosition).subtractInPlace(worldOffset);
            this._attachedMesh.rotationQuaternion.copyFrom(this._workingQuaternion);
            return;
        }
        // position
        const interpolatedPosition = new (0, $ha1VO.Vector3)();
        (0, $ha1VO.Vector3).SmoothToRef(this._attachedMesh.position, this._workingPosition, elapsed, this.lerpTime, interpolatedPosition);
        this._attachedMesh.position.copyFrom(interpolatedPosition);
        // rotation
        const currentRotation = new (0, $ha1VO.Quaternion)();
        currentRotation.copyFrom(this._attachedMesh.rotationQuaternion);
        (0, $ha1VO.Quaternion).SmoothToRef(currentRotation, this._workingQuaternion, elapsed, this.lerpTime, this._attachedMesh.rotationQuaternion);
        this._attachedMesh.setParent(oldParent);
    }
    _addObservables() {
        this._pointerObserver = this._scene.onPointerObservable.add((pointerInfo)=>{
            if (this.enabled && pointerInfo.type == (0, $cfkw4.PointerEventTypes).POINTERMOVE && pointerInfo.pickInfo) this.findAndUpdateTarget(pointerInfo.pickInfo);
        });
        this._lastTick = Date.now();
        this._onBeforeRender = this._scene.onBeforeRenderObservable.add(()=>{
            const tick = Date.now();
            this._updateTransformToGoal(tick - this._lastTick);
            this._lastTick = tick;
        });
    }
    _removeObservables() {
        this._scene.onPointerObservable.remove(this._pointerObserver);
        this._scene.onBeforeRenderObservable.remove(this._onBeforeRender);
        this._pointerObserver = null;
        this._onBeforeRender = null;
    }
}

});

parcelRegister("4XPoq", function(module, exports) {

$parcel$export(module.exports, "FollowBehavior", () => $39d489a84736c494$export$9e07c3de228cc0eb);

var $ha1VO = parcelRequire("ha1VO");

var $1VEEL = parcelRequire("1VEEL");

var $53VPf = parcelRequire("53VPf");
class $39d489a84736c494$export$9e07c3de228cc0eb {
    constructor(){
        // Memory cache to avoid GC usage
        this._tmpQuaternion = new (0, $ha1VO.Quaternion)();
        this._tmpVectors = [
            new (0, $ha1VO.Vector3)(),
            new (0, $ha1VO.Vector3)(),
            new (0, $ha1VO.Vector3)(),
            new (0, $ha1VO.Vector3)(),
            new (0, $ha1VO.Vector3)(),
            new (0, $ha1VO.Vector3)(),
            new (0, $ha1VO.Vector3)()
        ];
        this._tmpMatrix = new (0, $ha1VO.Matrix)();
        this._tmpInvertView = new (0, $ha1VO.Matrix)();
        this._tmpForward = new (0, $ha1VO.Vector3)();
        this._tmpNodeForward = new (0, $ha1VO.Vector3)();
        this._tmpPosition = new (0, $ha1VO.Vector3)();
        this._workingPosition = new (0, $ha1VO.Vector3)();
        this._workingQuaternion = new (0, $ha1VO.Quaternion)();
        this._lastTick = -1;
        this._recenterNextUpdate = true;
        /**
         * Set to false if the node should strictly follow the camera without any interpolation time
         */ this.interpolatePose = true;
        /**
         * Rate of interpolation of position and rotation of the attached node.
         * Higher values will give a slower interpolation.
         */ this.lerpTime = 500;
        /**
         * If the behavior should ignore the pitch and roll of the camera.
         */ this.ignoreCameraPitchAndRoll = false;
        /**
         * Pitch offset from camera (relative to Max Distance)
         * Is only effective if `ignoreCameraPitchAndRoll` is set to `true`.
         */ this.pitchOffset = 15;
        /**
         * The vertical angle from the camera forward axis to the owner will not exceed this value
         */ this.maxViewVerticalDegrees = 30;
        /**
         * The horizontal angle from the camera forward axis to the owner will not exceed this value
         */ this.maxViewHorizontalDegrees = 30;
        /**
         * The attached node will not reorient until the angle between its forward vector and the vector to the camera is greater than this value
         */ this.orientToCameraDeadzoneDegrees = 60;
        /**
         * Option to ignore distance clamping
         */ this.ignoreDistanceClamp = false;
        /**
         * Option to ignore angle clamping
         */ this.ignoreAngleClamp = false;
        /**
         * Max vertical distance between the attachedNode and camera
         */ this.verticalMaxDistance = 0;
        /**
         *  Default distance from eye to attached node, i.e. the sphere radius
         */ this.defaultDistance = 0.8;
        /**
         *  Max distance from eye to attached node, i.e. the sphere radius
         */ this.maximumDistance = 2;
        /**
         *  Min distance from eye to attached node, i.e. the sphere radius
         */ this.minimumDistance = 0.3;
        /**
         * Ignore vertical movement and lock the Y position of the object.
         */ this.useFixedVerticalOffset = false;
        /**
         * Fixed vertical position offset distance.
         */ this.fixedVerticalOffset = 0;
        /**
         * Enables/disables the behavior
         * @internal
         */ this._enabled = true;
    }
    /**
     * The camera that should be followed by this behavior
     */ get followedCamera() {
        return this._followedCamera || this._scene.activeCamera;
    }
    set followedCamera(camera) {
        this._followedCamera = camera;
    }
    /**
     *  The name of the behavior
     */ get name() {
        return "Follow";
    }
    /**
     *  Initializes the behavior
     */ init() {}
    /**
     * Attaches the follow behavior
     * @param ownerNode The mesh that will be following once attached
     * @param followedCamera The camera that should be followed by the node
     */ attach(ownerNode, followedCamera) {
        this._scene = ownerNode.getScene();
        this.attachedNode = ownerNode;
        if (followedCamera) this.followedCamera = followedCamera;
        this._addObservables();
    }
    /**
     *  Detaches the behavior from the mesh
     */ detach() {
        this.attachedNode = null;
        this._removeObservables();
    }
    /**
     * Recenters the attached node in front of the camera on the next update
     */ recenter() {
        this._recenterNextUpdate = true;
    }
    _angleBetweenVectorAndPlane(vector, normal) {
        // Work on copies
        this._tmpVectors[0].copyFrom(vector);
        vector = this._tmpVectors[0];
        this._tmpVectors[1].copyFrom(normal);
        normal = this._tmpVectors[1];
        vector.normalize();
        normal.normalize();
        return Math.PI / 2 - Math.acos((0, $ha1VO.Vector3).Dot(vector, normal));
    }
    _length2D(vector) {
        return Math.sqrt(vector.x * vector.x + vector.z * vector.z);
    }
    _distanceClamp(currentToTarget, moveToDefault = false) {
        let minDistance = this.minimumDistance;
        let maxDistance = this.maximumDistance;
        const defaultDistance = this.defaultDistance;
        const direction = this._tmpVectors[0];
        direction.copyFrom(currentToTarget);
        let currentDistance = direction.length();
        direction.normalizeFromLength(currentDistance);
        if (this.ignoreCameraPitchAndRoll) {
            // If we don't account for pitch offset, the casted object will float up/down as the reference
            // gets closer to it because we will still be casting in the direction of the pitched offset.
            // To fix this, only modify the XZ position of the object.
            minDistance = this._length2D(direction) * minDistance;
            maxDistance = this._length2D(direction) * maxDistance;
            const currentDistance2D = this._length2D(currentToTarget);
            direction.scaleInPlace(currentDistance / currentDistance2D);
            currentDistance = currentDistance2D;
        }
        let clampedDistance = currentDistance;
        if (moveToDefault) clampedDistance = defaultDistance;
        else clampedDistance = (0, $1VEEL.Scalar).Clamp(currentDistance, minDistance, maxDistance);
        currentToTarget.copyFrom(direction).scaleInPlace(clampedDistance);
        return currentDistance !== clampedDistance;
    }
    _applyVerticalClamp(currentToTarget) {
        if (this.verticalMaxDistance !== 0) currentToTarget.y = (0, $1VEEL.Scalar).Clamp(currentToTarget.y, -this.verticalMaxDistance, this.verticalMaxDistance);
    }
    _toOrientationQuatToRef(vector, quaternion) {
        (0, $ha1VO.Quaternion).RotationYawPitchRollToRef(Math.atan2(vector.x, vector.z), Math.atan2(vector.y, Math.sqrt(vector.z * vector.z + vector.x * vector.x)), 0, quaternion);
    }
    _applyPitchOffset(invertView) {
        const forward = this._tmpVectors[0];
        const right = this._tmpVectors[1];
        forward.copyFromFloats(0, 0, this._scene.useRightHandedSystem ? -1 : 1);
        right.copyFromFloats(1, 0, 0);
        (0, $ha1VO.Vector3).TransformNormalToRef(forward, invertView, forward);
        forward.y = 0;
        forward.normalize();
        (0, $ha1VO.Vector3).TransformNormalToRef(right, invertView, right);
        (0, $ha1VO.Quaternion).RotationAxisToRef(right, this.pitchOffset * Math.PI / 180, this._tmpQuaternion);
        forward.rotateByQuaternionToRef(this._tmpQuaternion, forward);
        this._toOrientationQuatToRef(forward, this._tmpQuaternion);
        this._tmpQuaternion.toRotationMatrix(this._tmpMatrix);
        // Since we already extracted position from the invert view matrix, we can
        // disregard the position part of the matrix in the copy
        invertView.copyFrom(this._tmpMatrix);
    }
    _angularClamp(invertView, currentToTarget) {
        const forward = this._tmpVectors[5];
        forward.copyFromFloats(0, 0, this._scene.useRightHandedSystem ? -1 : 1);
        const right = this._tmpVectors[6];
        right.copyFromFloats(1, 0, 0);
        // forward and right are related to camera frame of reference
        (0, $ha1VO.Vector3).TransformNormalToRef(forward, invertView, forward);
        (0, $ha1VO.Vector3).TransformNormalToRef(right, invertView, right);
        // Up is global Z
        const up = (0, $ha1VO.Vector3).UpReadOnly;
        const dist = currentToTarget.length();
        if (dist < (0, $53VPf.Epsilon)) return false;
        let angularClamped = false;
        const rotationQuat = this._tmpQuaternion;
        // X-axis leashing
        if (this.ignoreCameraPitchAndRoll) {
            const angle = (0, $ha1VO.Vector3).GetAngleBetweenVectorsOnPlane(currentToTarget, forward, right);
            (0, $ha1VO.Quaternion).RotationAxisToRef(right, angle, rotationQuat);
            currentToTarget.rotateByQuaternionToRef(rotationQuat, currentToTarget);
        } else {
            const angle = -(0, $ha1VO.Vector3).GetAngleBetweenVectorsOnPlane(currentToTarget, forward, right);
            const minMaxAngle = this.maxViewVerticalDegrees * Math.PI / 180 * 0.5;
            if (angle < -minMaxAngle) {
                (0, $ha1VO.Quaternion).RotationAxisToRef(right, -angle - minMaxAngle, rotationQuat);
                currentToTarget.rotateByQuaternionToRef(rotationQuat, currentToTarget);
                angularClamped = true;
            } else if (angle > minMaxAngle) {
                (0, $ha1VO.Quaternion).RotationAxisToRef(right, -angle + minMaxAngle, rotationQuat);
                currentToTarget.rotateByQuaternionToRef(rotationQuat, currentToTarget);
                angularClamped = true;
            }
        }
        // Y-axis leashing
        const angle = this._angleBetweenVectorAndPlane(currentToTarget, right) * (this._scene.useRightHandedSystem ? -1 : 1);
        const minMaxAngle = this.maxViewHorizontalDegrees * Math.PI / 180 * 0.5;
        if (angle < -minMaxAngle) {
            (0, $ha1VO.Quaternion).RotationAxisToRef(up, -angle - minMaxAngle, rotationQuat);
            currentToTarget.rotateByQuaternionToRef(rotationQuat, currentToTarget);
            angularClamped = true;
        } else if (angle > minMaxAngle) {
            (0, $ha1VO.Quaternion).RotationAxisToRef(up, -angle + minMaxAngle, rotationQuat);
            currentToTarget.rotateByQuaternionToRef(rotationQuat, currentToTarget);
            angularClamped = true;
        }
        return angularClamped;
    }
    _orientationClamp(currentToTarget, rotationQuaternion) {
        // Construct a rotation quat from up vector and target vector
        const toFollowed = this._tmpVectors[0];
        toFollowed.copyFrom(currentToTarget).scaleInPlace(-1).normalize();
        const up = this._tmpVectors[1];
        const right = this._tmpVectors[2];
        // We use global up vector to orient the following node (global +Y)
        up.copyFromFloats(0, 1, 0);
        // Gram-Schmidt to create an orthonormal frame
        (0, $ha1VO.Vector3).CrossToRef(toFollowed, up, right);
        const length = right.length();
        if (length < (0, $53VPf.Epsilon)) return;
        right.normalizeFromLength(length);
        (0, $ha1VO.Vector3).CrossToRef(right, toFollowed, up);
        if (this.attachedNode?.getScene().useRightHandedSystem) (0, $ha1VO.Quaternion).FromLookDirectionRHToRef(toFollowed, up, rotationQuaternion);
        else (0, $ha1VO.Quaternion).FromLookDirectionLHToRef(toFollowed, up, rotationQuaternion);
    }
    _passedOrientationDeadzone(currentToTarget, forward) {
        const leashToFollow = this._tmpVectors[5];
        leashToFollow.copyFrom(currentToTarget);
        leashToFollow.normalize();
        const angle = Math.abs((0, $ha1VO.Vector3).GetAngleBetweenVectorsOnPlane(forward, leashToFollow, (0, $ha1VO.Vector3).UpReadOnly));
        return angle * 180 / Math.PI > this.orientToCameraDeadzoneDegrees;
    }
    _updateLeashing(camera) {
        if (this.attachedNode && this._enabled) {
            const oldParent = this.attachedNode.parent;
            this.attachedNode.setParent(null);
            const worldMatrix = this.attachedNode.getWorldMatrix();
            const currentToTarget = this._workingPosition;
            const rotationQuaternion = this._workingQuaternion;
            const pivot = this.attachedNode.getPivotPoint();
            const invertView = this._tmpInvertView;
            invertView.copyFrom(camera.getViewMatrix());
            invertView.invert();
            (0, $ha1VO.Vector3).TransformCoordinatesToRef(pivot, worldMatrix, currentToTarget);
            const position = this._tmpPosition;
            position.copyFromFloats(0, 0, 0);
            (0, $ha1VO.Vector3).TransformCoordinatesToRef(position, worldMatrix, position);
            position.scaleInPlace(-1).subtractInPlace(pivot);
            currentToTarget.subtractInPlace(camera.globalPosition);
            if (this.ignoreCameraPitchAndRoll) this._applyPitchOffset(invertView);
            let angularClamped = false;
            const forward = this._tmpForward;
            forward.copyFromFloats(0, 0, this._scene.useRightHandedSystem ? -1 : 1);
            (0, $ha1VO.Vector3).TransformNormalToRef(forward, invertView, forward);
            const nodeForward = this._tmpNodeForward;
            nodeForward.copyFromFloats(0, 0, this._scene.useRightHandedSystem ? -1 : 1);
            (0, $ha1VO.Vector3).TransformNormalToRef(nodeForward, worldMatrix, nodeForward);
            if (this._recenterNextUpdate) currentToTarget.copyFrom(forward).scaleInPlace(this.defaultDistance);
            else if (this.ignoreAngleClamp) {
                const currentDistance = currentToTarget.length();
                currentToTarget.copyFrom(forward).scaleInPlace(currentDistance);
            } else angularClamped = this._angularClamp(invertView, currentToTarget);
            let distanceClamped = false;
            if (!this.ignoreDistanceClamp) {
                distanceClamped = this._distanceClamp(currentToTarget, angularClamped);
                this._applyVerticalClamp(currentToTarget);
            }
            if (this.useFixedVerticalOffset) currentToTarget.y = position.y - camera.globalPosition.y + this.fixedVerticalOffset;
            if (angularClamped || distanceClamped || this._passedOrientationDeadzone(currentToTarget, nodeForward) || this._recenterNextUpdate) this._orientationClamp(currentToTarget, rotationQuaternion);
            this._workingPosition.subtractInPlace(pivot);
            this._recenterNextUpdate = false;
            this.attachedNode.setParent(oldParent);
        }
    }
    _updateTransformToGoal(elapsed) {
        if (!this.attachedNode || !this.followedCamera || !this._enabled) return;
        if (!this.attachedNode.rotationQuaternion) this.attachedNode.rotationQuaternion = (0, $ha1VO.Quaternion).Identity();
        const oldParent = this.attachedNode.parent;
        this.attachedNode.setParent(null);
        if (!this.interpolatePose) {
            this.attachedNode.position.copyFrom(this.followedCamera.globalPosition).addInPlace(this._workingPosition);
            this.attachedNode.rotationQuaternion.copyFrom(this._workingQuaternion);
            return;
        }
        // position
        const currentDirection = new (0, $ha1VO.Vector3)();
        currentDirection.copyFrom(this.attachedNode.position).subtractInPlace(this.followedCamera.globalPosition);
        (0, $ha1VO.Vector3).SmoothToRef(currentDirection, this._workingPosition, elapsed, this.lerpTime, currentDirection);
        currentDirection.addInPlace(this.followedCamera.globalPosition);
        this.attachedNode.position.copyFrom(currentDirection);
        // rotation
        const currentRotation = new (0, $ha1VO.Quaternion)();
        currentRotation.copyFrom(this.attachedNode.rotationQuaternion);
        (0, $ha1VO.Quaternion).SmoothToRef(currentRotation, this._workingQuaternion, elapsed, this.lerpTime, this.attachedNode.rotationQuaternion);
        this.attachedNode.setParent(oldParent);
    }
    _addObservables() {
        this._lastTick = Date.now();
        this._onBeforeRender = this._scene.onBeforeRenderObservable.add(()=>{
            if (!this.followedCamera) return;
            const tick = Date.now();
            this._updateLeashing(this.followedCamera);
            this._updateTransformToGoal(tick - this._lastTick);
            this._lastTick = tick;
        });
    }
    _removeObservables() {
        if (this._onBeforeRender) this._scene.onBeforeRenderObservable.remove(this._onBeforeRender);
    }
}

});

parcelRegister("fp9Sb", function(module, exports) {

$parcel$export(module.exports, "HandConstraintZone", () => $b370d95d86659149$export$53cf12e606e80996);
$parcel$export(module.exports, "HandConstraintOrientation", () => $b370d95d86659149$export$e8f894232ac51176);
$parcel$export(module.exports, "HandConstraintVisibility", () => $b370d95d86659149$export$302b996a0605af54);
$parcel$export(module.exports, "HandConstraintBehavior", () => $b370d95d86659149$export$48d69afa8539c3d0);

var $cJN7d = parcelRequire("cJN7d");

var $k1hzP = parcelRequire("k1hzP");

var $ha1VO = parcelRequire("ha1VO");

var $bOhSV = parcelRequire("bOhSV");
var $b370d95d86659149$export$53cf12e606e80996;
(function(HandConstraintZone) {
    /**
     * Above finger tips
     */ HandConstraintZone[HandConstraintZone["ABOVE_FINGER_TIPS"] = 0] = "ABOVE_FINGER_TIPS";
    /**
     * Next to the thumb
     */ HandConstraintZone[HandConstraintZone["RADIAL_SIDE"] = 1] = "RADIAL_SIDE";
    /**
     * Next to the pinky finger
     */ HandConstraintZone[HandConstraintZone["ULNAR_SIDE"] = 2] = "ULNAR_SIDE";
    /**
     * Below the wrist
     */ HandConstraintZone[HandConstraintZone["BELOW_WRIST"] = 3] = "BELOW_WRIST";
})($b370d95d86659149$export$53cf12e606e80996 || ($b370d95d86659149$export$53cf12e606e80996 = {}));
var $b370d95d86659149$export$e8f894232ac51176;
(function(HandConstraintOrientation) {
    /**
     * Orientation is towards the camera
     */ HandConstraintOrientation[HandConstraintOrientation["LOOK_AT_CAMERA"] = 0] = "LOOK_AT_CAMERA";
    /**
     * Orientation is determined by the rotation of the palm
     */ HandConstraintOrientation[HandConstraintOrientation["HAND_ROTATION"] = 1] = "HAND_ROTATION";
})($b370d95d86659149$export$e8f894232ac51176 || ($b370d95d86659149$export$e8f894232ac51176 = {}));
var $b370d95d86659149$export$302b996a0605af54;
(function(HandConstraintVisibility) {
    /**
     * Constraint is always visible
     */ HandConstraintVisibility[HandConstraintVisibility["ALWAYS_VISIBLE"] = 0] = "ALWAYS_VISIBLE";
    /**
     * Constraint is only visible when the palm is up
     */ HandConstraintVisibility[HandConstraintVisibility["PALM_UP"] = 1] = "PALM_UP";
    /**
     * Constraint is only visible when the user is looking at the constraint.
     * Uses XR Eye Tracking if enabled/available, otherwise uses camera direction
     */ HandConstraintVisibility[HandConstraintVisibility["GAZE_FOCUS"] = 2] = "GAZE_FOCUS";
    /**
     * Constraint is only visible when the palm is up and the user is looking at it
     */ HandConstraintVisibility[HandConstraintVisibility["PALM_AND_GAZE"] = 3] = "PALM_AND_GAZE";
})($b370d95d86659149$export$302b996a0605af54 || ($b370d95d86659149$export$302b996a0605af54 = {}));
class $b370d95d86659149$export$48d69afa8539c3d0 {
    /**
     * Builds a hand constraint behavior
     */ constructor(){
        this._sceneRenderObserver = null;
        this._zoneAxis = {};
        /**
         * Sets the HandConstraintVisibility level for the hand constraint
         */ this.handConstraintVisibility = $b370d95d86659149$export$302b996a0605af54.PALM_AND_GAZE;
        /**
         * A number from 0.0 to 1.0, marking how restricted the direction the palm faces is for the attached node to be enabled.
         * A 1 means the palm must be directly facing the user before the node is enabled, a 0 means it is always enabled.
         * Used with HandConstraintVisibility.PALM_UP
         */ this.palmUpStrictness = 0.95;
        /**
         * The radius in meters around the center of the hand that the user must gaze inside for the attached node to be enabled and appear.
         * Used with HandConstraintVisibility.GAZE_FOCUS
         */ this.gazeProximityRadius = 0.15;
        /**
         * Offset distance from the hand in meters
         */ this.targetOffset = 0.1;
        /**
         * Where to place the node regarding the center of the hand.
         */ this.targetZone = $b370d95d86659149$export$53cf12e606e80996.ULNAR_SIDE;
        /**
         * Orientation mode of the 4 zones around the hand
         */ this.zoneOrientationMode = $b370d95d86659149$export$e8f894232ac51176.HAND_ROTATION;
        /**
         * Orientation mode of the node attached to this behavior
         */ this.nodeOrientationMode = $b370d95d86659149$export$e8f894232ac51176.HAND_ROTATION;
        /**
         * Set the hand this behavior should follow. If set to "none", it will follow any visible hand (prioritising the left one).
         */ this.handedness = "none";
        /**
         * Rate of interpolation of position and rotation of the attached node.
         * Higher values will give a slower interpolation.
         */ this.lerpTime = 100;
        // For a right hand
        this._zoneAxis[$b370d95d86659149$export$53cf12e606e80996.ABOVE_FINGER_TIPS] = new (0, $ha1VO.Vector3)(0, 1, 0);
        this._zoneAxis[$b370d95d86659149$export$53cf12e606e80996.RADIAL_SIDE] = new (0, $ha1VO.Vector3)(-1, 0, 0);
        this._zoneAxis[$b370d95d86659149$export$53cf12e606e80996.ULNAR_SIDE] = new (0, $ha1VO.Vector3)(1, 0, 0);
        this._zoneAxis[$b370d95d86659149$export$53cf12e606e80996.BELOW_WRIST] = new (0, $ha1VO.Vector3)(0, -1, 0);
    }
    /** gets or sets behavior's name */ get name() {
        return "HandConstraint";
    }
    /** Enable the behavior */ enable() {
        this._node.setEnabled(true);
    }
    /** Disable the behavior */ disable() {
        this._node.setEnabled(false);
    }
    _getHandPose() {
        if (!this._handTracking) return null;
        // Retrieve any available hand, starting by the left
        let hand;
        if (this.handedness === "none") hand = this._handTracking.getHandByHandedness("left") || this._handTracking.getHandByHandedness("right");
        else hand = this._handTracking.getHandByHandedness(this.handedness);
        if (hand) {
            const pinkyMetacarpal = hand.getJointMesh((0, $k1hzP.WebXRHandJoint).PINKY_FINGER_METACARPAL);
            const middleMetacarpal = hand.getJointMesh((0, $k1hzP.WebXRHandJoint).MIDDLE_FINGER_METACARPAL);
            const wrist = hand.getJointMesh((0, $k1hzP.WebXRHandJoint).WRIST);
            if (wrist && middleMetacarpal && pinkyMetacarpal) {
                const handPose = {
                    position: middleMetacarpal.absolutePosition,
                    quaternion: new (0, $ha1VO.Quaternion)(),
                    id: hand.xrController.uniqueId
                };
                // palm forward
                const up = (0, $ha1VO.TmpVectors).Vector3[0];
                const forward = (0, $ha1VO.TmpVectors).Vector3[1];
                const left = (0, $ha1VO.TmpVectors).Vector3[2];
                up.copyFrom(middleMetacarpal.absolutePosition).subtractInPlace(wrist.absolutePosition).normalize();
                forward.copyFrom(pinkyMetacarpal.absolutePosition).subtractInPlace(middleMetacarpal.absolutePosition).normalize();
                // Create vectors for a rotation quaternion, where forward points out from the palm
                (0, $ha1VO.Vector3).CrossToRef(up, forward, forward);
                (0, $ha1VO.Vector3).CrossToRef(forward, up, left);
                (0, $ha1VO.Quaternion).FromLookDirectionLHToRef(forward, up, handPose.quaternion);
                return handPose;
            }
        }
        return null;
    }
    /**
     * Initializes the hand constraint behavior
     */ init() {}
    /**
     * Attaches the hand constraint to a `TransformNode`
     * @param node defines the node to attach the behavior to
     */ attach(node) {
        this._node = node;
        this._scene = node.getScene();
        if (!this._node.rotationQuaternion) this._node.rotationQuaternion = (0, $ha1VO.Quaternion).RotationYawPitchRoll(this._node.rotation.y, this._node.rotation.x, this._node.rotation.z);
        let lastTick = Date.now();
        this._sceneRenderObserver = this._scene.onBeforeRenderObservable.add(()=>{
            const pose = this._getHandPose();
            this._node.reservedDataStore = this._node.reservedDataStore || {};
            this._node.reservedDataStore.nearInteraction = this._node.reservedDataStore.nearInteraction || {};
            this._node.reservedDataStore.nearInteraction.excludedControllerId = null;
            if (pose) {
                const zoneOffset = (0, $ha1VO.TmpVectors).Vector3[0];
                const camera = this._scene.activeCamera;
                zoneOffset.copyFrom(this._zoneAxis[this.targetZone]);
                const cameraLookAtQuaternion = (0, $ha1VO.TmpVectors).Quaternion[0];
                if (camera && (this.zoneOrientationMode === $b370d95d86659149$export$e8f894232ac51176.LOOK_AT_CAMERA || this.nodeOrientationMode === $b370d95d86659149$export$e8f894232ac51176.LOOK_AT_CAMERA)) {
                    const toCamera = (0, $ha1VO.TmpVectors).Vector3[1];
                    toCamera.copyFrom(camera.position).subtractInPlace(pose.position).normalize();
                    if (this._scene.useRightHandedSystem) (0, $ha1VO.Quaternion).FromLookDirectionRHToRef(toCamera, (0, $ha1VO.Vector3).UpReadOnly, cameraLookAtQuaternion);
                    else (0, $ha1VO.Quaternion).FromLookDirectionLHToRef(toCamera, (0, $ha1VO.Vector3).UpReadOnly, cameraLookAtQuaternion);
                }
                if (this.zoneOrientationMode === $b370d95d86659149$export$e8f894232ac51176.HAND_ROTATION) pose.quaternion.toRotationMatrix((0, $ha1VO.TmpVectors).Matrix[0]);
                else cameraLookAtQuaternion.toRotationMatrix((0, $ha1VO.TmpVectors).Matrix[0]);
                (0, $ha1VO.Vector3).TransformNormalToRef(zoneOffset, (0, $ha1VO.TmpVectors).Matrix[0], zoneOffset);
                zoneOffset.scaleInPlace(this.targetOffset);
                const targetPosition = (0, $ha1VO.TmpVectors).Vector3[2];
                const targetRotation = (0, $ha1VO.TmpVectors).Quaternion[1];
                targetPosition.copyFrom(pose.position).addInPlace(zoneOffset);
                if (this.nodeOrientationMode === $b370d95d86659149$export$e8f894232ac51176.HAND_ROTATION) targetRotation.copyFrom(pose.quaternion);
                else targetRotation.copyFrom(cameraLookAtQuaternion);
                const elapsed = Date.now() - lastTick;
                (0, $ha1VO.Vector3).SmoothToRef(this._node.position, targetPosition, elapsed, this.lerpTime, this._node.position);
                (0, $ha1VO.Quaternion).SmoothToRef(this._node.rotationQuaternion, targetRotation, elapsed, this.lerpTime, this._node.rotationQuaternion);
                this._node.reservedDataStore.nearInteraction.excludedControllerId = pose.id;
            }
            this._setVisibility(pose);
            lastTick = Date.now();
        });
    }
    _setVisibility(pose) {
        let palmVisible = true;
        let gazeVisible = true;
        const camera = this._scene.activeCamera;
        if (camera) {
            const cameraForward = camera.getForwardRay();
            if (this.handConstraintVisibility === $b370d95d86659149$export$302b996a0605af54.GAZE_FOCUS || this.handConstraintVisibility === $b370d95d86659149$export$302b996a0605af54.PALM_AND_GAZE) {
                gazeVisible = false;
                let gaze;
                if (this._eyeTracking) gaze = this._eyeTracking.getEyeGaze();
                gaze = gaze || cameraForward;
                const gazeToBehavior = (0, $ha1VO.TmpVectors).Vector3[0];
                if (pose) pose.position.subtractToRef(gaze.origin, gazeToBehavior);
                else this._node.getAbsolutePosition().subtractToRef(gaze.origin, gazeToBehavior);
                const projectedDistance = (0, $ha1VO.Vector3).Dot(gazeToBehavior, gaze.direction);
                const projectedSquared = projectedDistance * projectedDistance;
                if (projectedDistance > 0) {
                    const radiusSquared = gazeToBehavior.lengthSquared() - projectedSquared;
                    if (radiusSquared < this.gazeProximityRadius * this.gazeProximityRadius) gazeVisible = true;
                }
            }
            if (this.handConstraintVisibility === $b370d95d86659149$export$302b996a0605af54.PALM_UP || this.handConstraintVisibility === $b370d95d86659149$export$302b996a0605af54.PALM_AND_GAZE) {
                palmVisible = false;
                if (pose) {
                    const palmDirection = (0, $ha1VO.TmpVectors).Vector3[0];
                    (0, $ha1VO.Vector3).LeftHandedForwardReadOnly.rotateByQuaternionToRef(pose.quaternion, palmDirection);
                    if ((0, $ha1VO.Vector3).Dot(palmDirection, cameraForward.direction) > this.palmUpStrictness * 2 - 1) palmVisible = true;
                }
            }
        }
        this._node.setEnabled(palmVisible && gazeVisible);
    }
    /**
     * Detaches the behavior from the `TransformNode`
     */ detach() {
        this._scene.onBeforeRenderObservable.remove(this._sceneRenderObserver);
    }
    /**
     * Links the behavior to the XR experience in which to retrieve hand transform information.
     * @param xr xr experience
     */ linkToXRExperience(xr) {
        const featuresManager = xr.featuresManager ? xr.featuresManager : xr;
        if (!featuresManager) (0, $bOhSV.Tools).Error("XR features manager must be available or provided directly for the Hand Menu to work");
        else {
            try {
                this._eyeTracking = featuresManager.getEnabledFeature((0, $cJN7d.WebXRFeatureName).EYE_TRACKING);
            } catch  {}
            try {
                this._handTracking = featuresManager.getEnabledFeature((0, $cJN7d.WebXRFeatureName).HAND_TRACKING);
            } catch  {
                (0, $bOhSV.Tools).Error("Hand tracking must be enabled for the Hand Menu to work");
            }
        }
    }
}

});
parcelRegister("cJN7d", function(module, exports) {

$parcel$export(module.exports, "WebXRFeatureName", () => $945fc946b723011e$export$aa379857ab6bff84);
$parcel$export(module.exports, "WebXRFeaturesManager", () => $945fc946b723011e$export$4fee8bc0577a812e);

var $bOhSV = parcelRequire("bOhSV");
class $945fc946b723011e$export$aa379857ab6bff84 {
}
/**
 * The name of the anchor system feature
 */ $945fc946b723011e$export$aa379857ab6bff84.ANCHOR_SYSTEM = "xr-anchor-system";
/**
 * The name of the background remover feature
 */ $945fc946b723011e$export$aa379857ab6bff84.BACKGROUND_REMOVER = "xr-background-remover";
/**
 * The name of the hit test feature
 */ $945fc946b723011e$export$aa379857ab6bff84.HIT_TEST = "xr-hit-test";
/**
 * The name of the mesh detection feature
 */ $945fc946b723011e$export$aa379857ab6bff84.MESH_DETECTION = "xr-mesh-detection";
/**
 * physics impostors for xr controllers feature
 */ $945fc946b723011e$export$aa379857ab6bff84.PHYSICS_CONTROLLERS = "xr-physics-controller";
/**
 * The name of the plane detection feature
 */ $945fc946b723011e$export$aa379857ab6bff84.PLANE_DETECTION = "xr-plane-detection";
/**
 * The name of the pointer selection feature
 */ $945fc946b723011e$export$aa379857ab6bff84.POINTER_SELECTION = "xr-controller-pointer-selection";
/**
 * The name of the teleportation feature
 */ $945fc946b723011e$export$aa379857ab6bff84.TELEPORTATION = "xr-controller-teleportation";
/**
 * The name of the feature points feature.
 */ $945fc946b723011e$export$aa379857ab6bff84.FEATURE_POINTS = "xr-feature-points";
/**
 * The name of the hand tracking feature.
 */ $945fc946b723011e$export$aa379857ab6bff84.HAND_TRACKING = "xr-hand-tracking";
/**
 * The name of the image tracking feature
 */ $945fc946b723011e$export$aa379857ab6bff84.IMAGE_TRACKING = "xr-image-tracking";
/**
 * The name of the near interaction feature
 */ $945fc946b723011e$export$aa379857ab6bff84.NEAR_INTERACTION = "xr-near-interaction";
/**
 * The name of the DOM overlay feature
 */ $945fc946b723011e$export$aa379857ab6bff84.DOM_OVERLAY = "xr-dom-overlay";
/**
 * The name of the movement feature
 */ $945fc946b723011e$export$aa379857ab6bff84.MOVEMENT = "xr-controller-movement";
/**
 * The name of the light estimation feature
 */ $945fc946b723011e$export$aa379857ab6bff84.LIGHT_ESTIMATION = "xr-light-estimation";
/**
 * The name of the eye tracking feature
 */ $945fc946b723011e$export$aa379857ab6bff84.EYE_TRACKING = "xr-eye-tracking";
/**
 * The name of the walking locomotion feature
 */ $945fc946b723011e$export$aa379857ab6bff84.WALKING_LOCOMOTION = "xr-walking-locomotion";
/**
 * The name of the composition layers feature
 */ $945fc946b723011e$export$aa379857ab6bff84.LAYERS = "xr-layers";
/**
 * The name of the depth sensing feature
 */ $945fc946b723011e$export$aa379857ab6bff84.DEPTH_SENSING = "xr-depth-sensing";
/**
 * The name of the WebXR Space Warp feature
 */ $945fc946b723011e$export$aa379857ab6bff84.SPACE_WARP = "xr-space-warp";
/**
 * The name of the WebXR Raw Camera Access feature
 */ $945fc946b723011e$export$aa379857ab6bff84.RAW_CAMERA_ACCESS = "xr-raw-camera-access";
class $945fc946b723011e$export$4fee8bc0577a812e {
    /**
     * constructs a new features manages.
     *
     * @param _xrSessionManager an instance of WebXRSessionManager
     */ constructor(_xrSessionManager){
        this._xrSessionManager = _xrSessionManager;
        this._features = {};
        // when session starts / initialized - attach
        this._xrSessionManager.onXRSessionInit.add(()=>{
            this.getEnabledFeatures().forEach((featureName)=>{
                const feature = this._features[featureName];
                if (feature.enabled && !feature.featureImplementation.attached && !feature.featureImplementation.disableAutoAttach) this.attachFeature(featureName);
            });
        });
        // when session ends - detach
        this._xrSessionManager.onXRSessionEnded.add(()=>{
            this.getEnabledFeatures().forEach((featureName)=>{
                const feature = this._features[featureName];
                if (feature.enabled && feature.featureImplementation.attached) // detach, but don't disable!
                this.detachFeature(featureName);
            });
        });
    }
    /**
     * Used to register a module. After calling this function a developer can use this feature in the scene.
     * Mainly used internally.
     *
     * @param featureName the name of the feature to register
     * @param constructorFunction the function used to construct the module
     * @param version the (babylon) version of the module
     * @param stable is that a stable version of this module
     */ static AddWebXRFeature(featureName, constructorFunction, version = 1, stable = false) {
        this._AvailableFeatures[featureName] = this._AvailableFeatures[featureName] || {
            latest: version
        };
        if (version > this._AvailableFeatures[featureName].latest) this._AvailableFeatures[featureName].latest = version;
        if (stable) this._AvailableFeatures[featureName].stable = version;
        this._AvailableFeatures[featureName][version] = constructorFunction;
    }
    /**
     * Returns a constructor of a specific feature.
     *
     * @param featureName the name of the feature to construct
     * @param version the version of the feature to load
     * @param xrSessionManager the xrSessionManager. Used to construct the module
     * @param options optional options provided to the module.
     * @returns a function that, when called, will return a new instance of this feature
     */ static ConstructFeature(featureName, version = 1, xrSessionManager, options) {
        const constructorFunction = this._AvailableFeatures[featureName][version];
        if (!constructorFunction) // throw an error? return nothing?
        throw new Error("feature not found");
        return constructorFunction(xrSessionManager, options);
    }
    /**
     * Can be used to return the list of features currently registered
     *
     * @returns an Array of available features
     */ static GetAvailableFeatures() {
        return Object.keys(this._AvailableFeatures);
    }
    /**
     * Gets the versions available for a specific feature
     * @param featureName the name of the feature
     * @returns an array with the available versions
     */ static GetAvailableVersions(featureName) {
        return Object.keys(this._AvailableFeatures[featureName]);
    }
    /**
     * Return the latest unstable version of this feature
     * @param featureName the name of the feature to search
     * @returns the version number. if not found will return -1
     */ static GetLatestVersionOfFeature(featureName) {
        return this._AvailableFeatures[featureName] && this._AvailableFeatures[featureName].latest || -1;
    }
    /**
     * Return the latest stable version of this feature
     * @param featureName the name of the feature to search
     * @returns the version number. if not found will return -1
     */ static GetStableVersionOfFeature(featureName) {
        return this._AvailableFeatures[featureName] && this._AvailableFeatures[featureName].stable || -1;
    }
    /**
     * Attach a feature to the current session. Mainly used when session started to start the feature effect.
     * Can be used during a session to start a feature
     * @param featureName the name of feature to attach
     */ attachFeature(featureName) {
        const feature = this._features[featureName];
        if (feature && feature.enabled && !feature.featureImplementation.attached) {
            const attached = feature.featureImplementation.attach();
            if (!attached) (0, $bOhSV.Tools).Warn(`Feature ${featureName} failed to attach`);
        }
    }
    /**
     * Can be used inside a session or when the session ends to detach a specific feature
     * @param featureName the name of the feature to detach
     */ detachFeature(featureName) {
        const feature = this._features[featureName];
        if (feature && feature.featureImplementation.attached) {
            const detached = feature.featureImplementation.detach();
            if (!detached) (0, $bOhSV.Tools).Warn(`Feature ${featureName} failed to detach`);
        }
    }
    /**
     * Used to disable an already-enabled feature
     * The feature will be disposed and will be recreated once enabled.
     * @param featureName the feature to disable
     * @returns true if disable was successful
     */ // eslint-disable-next-line @typescript-eslint/naming-convention
    disableFeature(featureName) {
        const name = typeof featureName === "string" ? featureName : featureName.Name;
        const feature = this._features[name];
        if (feature && feature.enabled) {
            feature.enabled = false;
            this.detachFeature(name);
            feature.featureImplementation.dispose();
            delete this._features[name];
            return true;
        }
        return false;
    }
    /**
     * dispose this features manager
     */ dispose() {
        this.getEnabledFeatures().forEach((feature)=>{
            this.disableFeature(feature);
        });
    }
    /**
     * Enable a feature using its name and a version. This will enable it in the scene, and will be responsible to attach it when the session starts.
     * If used twice, the old version will be disposed and a new one will be constructed. This way you can re-enable with different configuration.
     *
     * @param featureName the name of the feature to load or the class of the feature
     * @param version optional version to load. if not provided the latest version will be enabled
     * @param moduleOptions options provided to the module. Ses the module documentation / constructor
     * @param attachIfPossible if set to true (default) the feature will be automatically attached, if it is currently possible
     * @param required is this feature required to the app. If set to true the session init will fail if the feature is not available.
     * @returns a new constructed feature or throws an error if feature not found or conflicts with another enabled feature.
     */ enableFeature(// eslint-disable-next-line @typescript-eslint/naming-convention
    featureName, version = "latest", moduleOptions = {}, attachIfPossible = true, required = true) {
        const name = typeof featureName === "string" ? featureName : featureName.Name;
        let versionToLoad = 0;
        if (typeof version === "string") {
            if (!version) throw new Error(`Error in provided version - ${name} (${version})`);
            if (version === "stable") versionToLoad = $945fc946b723011e$export$4fee8bc0577a812e.GetStableVersionOfFeature(name);
            else if (version === "latest") versionToLoad = $945fc946b723011e$export$4fee8bc0577a812e.GetLatestVersionOfFeature(name);
            else // try loading the number the string represents
            versionToLoad = +version;
            if (versionToLoad === -1 || isNaN(versionToLoad)) throw new Error(`feature not found - ${name} (${version})`);
        } else versionToLoad = version;
        // check if there is a feature conflict
        const conflictingFeature = $945fc946b723011e$export$4fee8bc0577a812e._ConflictingFeatures[name];
        if (conflictingFeature !== undefined && this.getEnabledFeatures().indexOf(conflictingFeature) !== -1) throw new Error(`Feature ${name} cannot be enabled while ${conflictingFeature} is enabled.`);
        // check if already initialized
        const feature = this._features[name];
        const constructFunction = $945fc946b723011e$export$4fee8bc0577a812e.ConstructFeature(name, versionToLoad, this._xrSessionManager, moduleOptions);
        if (!constructFunction) // report error?
        throw new Error(`feature not found - ${name}`);
        /* If the feature is already enabled, detach and dispose it, and create a new one */ if (feature) this.disableFeature(name);
        const constructed = constructFunction();
        if (constructed.dependsOn) {
            const dependentsFound = constructed.dependsOn.every((featureName)=>!!this._features[featureName]);
            if (!dependentsFound) throw new Error(`Dependant features missing. Make sure the following features are enabled - ${constructed.dependsOn.join(", ")}`);
        }
        if (constructed.isCompatible()) {
            this._features[name] = {
                featureImplementation: constructed,
                enabled: true,
                version: versionToLoad,
                required: required
            };
            if (attachIfPossible) // if session started already, request and enable
            {
                if (this._xrSessionManager.session && !this._features[name].featureImplementation.attached) // enable feature
                this.attachFeature(name);
            } else // disable auto-attach when session starts
            this._features[name].featureImplementation.disableAutoAttach = true;
            return this._features[name].featureImplementation;
        } else {
            if (required) throw new Error("required feature not compatible");
            else {
                (0, $bOhSV.Tools).Warn(`Feature ${name} not compatible with the current environment/browser and was not enabled.`);
                return constructed;
            }
        }
    }
    /**
     * get the implementation of an enabled feature.
     * @param featureName the name of the feature to load
     * @returns the feature class, if found
     */ getEnabledFeature(featureName) {
        return this._features[featureName] && this._features[featureName].featureImplementation;
    }
    /**
     * Get the list of enabled features
     * @returns an array of enabled features
     */ getEnabledFeatures() {
        return Object.keys(this._features);
    }
    /**
     * This function will extend the session creation configuration object with enabled features.
     * If, for example, the anchors feature is enabled, it will be automatically added to the optional or required features list,
     * according to the defined "required" variable, provided during enableFeature call
     * @param xrSessionInit the xr Session init object to extend
     *
     * @returns an extended XRSessionInit object
     */ async _extendXRSessionInitObject(xrSessionInit) {
        const enabledFeatures = this.getEnabledFeatures();
        for (const featureName of enabledFeatures){
            const feature = this._features[featureName];
            const nativeName = feature.featureImplementation.xrNativeFeatureName;
            if (nativeName) {
                if (feature.required) {
                    xrSessionInit.requiredFeatures = xrSessionInit.requiredFeatures || [];
                    if (xrSessionInit.requiredFeatures.indexOf(nativeName) === -1) xrSessionInit.requiredFeatures.push(nativeName);
                } else {
                    xrSessionInit.optionalFeatures = xrSessionInit.optionalFeatures || [];
                    if (xrSessionInit.optionalFeatures.indexOf(nativeName) === -1) xrSessionInit.optionalFeatures.push(nativeName);
                }
            }
            if (feature.featureImplementation.getXRSessionInitExtension) {
                const extended = await feature.featureImplementation.getXRSessionInitExtension();
                xrSessionInit = {
                    ...xrSessionInit,
                    ...extended
                };
            }
        }
        return xrSessionInit;
    }
}
$945fc946b723011e$export$4fee8bc0577a812e._AvailableFeatures = {};
/**
 * The key is the feature to check and the value is the feature that conflicts.
 */ $945fc946b723011e$export$4fee8bc0577a812e._ConflictingFeatures = {
    [$945fc946b723011e$export$aa379857ab6bff84.TELEPORTATION]: $945fc946b723011e$export$aa379857ab6bff84.MOVEMENT,
    [$945fc946b723011e$export$aa379857ab6bff84.MOVEMENT]: $945fc946b723011e$export$aa379857ab6bff84.TELEPORTATION
};

});

parcelRegister("k1hzP", function(module, exports) {

$parcel$export(module.exports, "HandPart", () => $e931890fb7c6eebb$export$fd9e205006227681);
$parcel$export(module.exports, "WebXRHandJoint", () => $e931890fb7c6eebb$export$f8000fe3728c3a7e);
$parcel$export(module.exports, "WebXRHand", () => $e931890fb7c6eebb$export$510a23c80bbd6a39);
$parcel$export(module.exports, "WebXRHandTracking", () => $e931890fb7c6eebb$export$e6185f1e232b5a71);

var $2YzP2 = parcelRequire("2YzP2");

var $cJN7d = parcelRequire("cJN7d");

var $ha1VO = parcelRequire("ha1VO");

var $iz3U8 = parcelRequire("iz3U8");

var $diGQf = parcelRequire("diGQf");

var $agoTA = parcelRequire("agoTA");

var $7etnY = parcelRequire("7etnY");

var $5fNQr = parcelRequire("5fNQr");

var $54229 = parcelRequire("54229");

var $g3tvW = parcelRequire("g3tvW");

var $klshO = parcelRequire("klshO");

var $dbxbu = parcelRequire("dbxbu");

var $ejQPp = parcelRequire("ejQPp");
var $e931890fb7c6eebb$export$fd9e205006227681;
(function(HandPart) {
    /**
     * HandPart - Wrist
     */ HandPart["WRIST"] = "wrist";
    /**
     * HandPart - The thumb
     */ HandPart["THUMB"] = "thumb";
    /**
     * HandPart - Index finger
     */ HandPart["INDEX"] = "index";
    /**
     * HandPart - Middle finger
     */ HandPart["MIDDLE"] = "middle";
    /**
     * HandPart - Ring finger
     */ HandPart["RING"] = "ring";
    /**
     * HandPart - Little finger
     */ HandPart["LITTLE"] = "little";
})($e931890fb7c6eebb$export$fd9e205006227681 || ($e931890fb7c6eebb$export$fd9e205006227681 = {}));
var $e931890fb7c6eebb$export$f8000fe3728c3a7e;
(function(WebXRHandJoint) {
    /** Wrist */ WebXRHandJoint["WRIST"] = "wrist";
    /** Thumb near wrist */ WebXRHandJoint["THUMB_METACARPAL"] = "thumb-metacarpal";
    /** Thumb first knuckle */ WebXRHandJoint["THUMB_PHALANX_PROXIMAL"] = "thumb-phalanx-proximal";
    /** Thumb second knuckle */ WebXRHandJoint["THUMB_PHALANX_DISTAL"] = "thumb-phalanx-distal";
    /** Thumb tip */ WebXRHandJoint["THUMB_TIP"] = "thumb-tip";
    /** Index finger near wrist */ WebXRHandJoint["INDEX_FINGER_METACARPAL"] = "index-finger-metacarpal";
    /** Index finger first knuckle */ WebXRHandJoint["INDEX_FINGER_PHALANX_PROXIMAL"] = "index-finger-phalanx-proximal";
    /** Index finger second knuckle */ WebXRHandJoint["INDEX_FINGER_PHALANX_INTERMEDIATE"] = "index-finger-phalanx-intermediate";
    /** Index finger third knuckle */ WebXRHandJoint["INDEX_FINGER_PHALANX_DISTAL"] = "index-finger-phalanx-distal";
    /** Index finger tip */ WebXRHandJoint["INDEX_FINGER_TIP"] = "index-finger-tip";
    /** Middle finger near wrist */ WebXRHandJoint["MIDDLE_FINGER_METACARPAL"] = "middle-finger-metacarpal";
    /** Middle finger first knuckle */ WebXRHandJoint["MIDDLE_FINGER_PHALANX_PROXIMAL"] = "middle-finger-phalanx-proximal";
    /** Middle finger second knuckle */ WebXRHandJoint["MIDDLE_FINGER_PHALANX_INTERMEDIATE"] = "middle-finger-phalanx-intermediate";
    /** Middle finger third knuckle */ WebXRHandJoint["MIDDLE_FINGER_PHALANX_DISTAL"] = "middle-finger-phalanx-distal";
    /** Middle finger tip */ WebXRHandJoint["MIDDLE_FINGER_TIP"] = "middle-finger-tip";
    /** Ring finger near wrist */ WebXRHandJoint["RING_FINGER_METACARPAL"] = "ring-finger-metacarpal";
    /** Ring finger first knuckle */ WebXRHandJoint["RING_FINGER_PHALANX_PROXIMAL"] = "ring-finger-phalanx-proximal";
    /** Ring finger second knuckle */ WebXRHandJoint["RING_FINGER_PHALANX_INTERMEDIATE"] = "ring-finger-phalanx-intermediate";
    /** Ring finger third knuckle */ WebXRHandJoint["RING_FINGER_PHALANX_DISTAL"] = "ring-finger-phalanx-distal";
    /** Ring finger tip */ WebXRHandJoint["RING_FINGER_TIP"] = "ring-finger-tip";
    /** Pinky finger near wrist */ WebXRHandJoint["PINKY_FINGER_METACARPAL"] = "pinky-finger-metacarpal";
    /** Pinky finger first knuckle */ WebXRHandJoint["PINKY_FINGER_PHALANX_PROXIMAL"] = "pinky-finger-phalanx-proximal";
    /** Pinky finger second knuckle */ WebXRHandJoint["PINKY_FINGER_PHALANX_INTERMEDIATE"] = "pinky-finger-phalanx-intermediate";
    /** Pinky finger third knuckle */ WebXRHandJoint["PINKY_FINGER_PHALANX_DISTAL"] = "pinky-finger-phalanx-distal";
    /** Pinky finger tip */ WebXRHandJoint["PINKY_FINGER_TIP"] = "pinky-finger-tip";
})($e931890fb7c6eebb$export$f8000fe3728c3a7e || ($e931890fb7c6eebb$export$f8000fe3728c3a7e = {}));
const $e931890fb7c6eebb$var$handJointReferenceArray = [
    $e931890fb7c6eebb$export$f8000fe3728c3a7e.WRIST,
    $e931890fb7c6eebb$export$f8000fe3728c3a7e.THUMB_METACARPAL,
    $e931890fb7c6eebb$export$f8000fe3728c3a7e.THUMB_PHALANX_PROXIMAL,
    $e931890fb7c6eebb$export$f8000fe3728c3a7e.THUMB_PHALANX_DISTAL,
    $e931890fb7c6eebb$export$f8000fe3728c3a7e.THUMB_TIP,
    $e931890fb7c6eebb$export$f8000fe3728c3a7e.INDEX_FINGER_METACARPAL,
    $e931890fb7c6eebb$export$f8000fe3728c3a7e.INDEX_FINGER_PHALANX_PROXIMAL,
    $e931890fb7c6eebb$export$f8000fe3728c3a7e.INDEX_FINGER_PHALANX_INTERMEDIATE,
    $e931890fb7c6eebb$export$f8000fe3728c3a7e.INDEX_FINGER_PHALANX_DISTAL,
    $e931890fb7c6eebb$export$f8000fe3728c3a7e.INDEX_FINGER_TIP,
    $e931890fb7c6eebb$export$f8000fe3728c3a7e.MIDDLE_FINGER_METACARPAL,
    $e931890fb7c6eebb$export$f8000fe3728c3a7e.MIDDLE_FINGER_PHALANX_PROXIMAL,
    $e931890fb7c6eebb$export$f8000fe3728c3a7e.MIDDLE_FINGER_PHALANX_INTERMEDIATE,
    $e931890fb7c6eebb$export$f8000fe3728c3a7e.MIDDLE_FINGER_PHALANX_DISTAL,
    $e931890fb7c6eebb$export$f8000fe3728c3a7e.MIDDLE_FINGER_TIP,
    $e931890fb7c6eebb$export$f8000fe3728c3a7e.RING_FINGER_METACARPAL,
    $e931890fb7c6eebb$export$f8000fe3728c3a7e.RING_FINGER_PHALANX_PROXIMAL,
    $e931890fb7c6eebb$export$f8000fe3728c3a7e.RING_FINGER_PHALANX_INTERMEDIATE,
    $e931890fb7c6eebb$export$f8000fe3728c3a7e.RING_FINGER_PHALANX_DISTAL,
    $e931890fb7c6eebb$export$f8000fe3728c3a7e.RING_FINGER_TIP,
    $e931890fb7c6eebb$export$f8000fe3728c3a7e.PINKY_FINGER_METACARPAL,
    $e931890fb7c6eebb$export$f8000fe3728c3a7e.PINKY_FINGER_PHALANX_PROXIMAL,
    $e931890fb7c6eebb$export$f8000fe3728c3a7e.PINKY_FINGER_PHALANX_INTERMEDIATE,
    $e931890fb7c6eebb$export$f8000fe3728c3a7e.PINKY_FINGER_PHALANX_DISTAL,
    $e931890fb7c6eebb$export$f8000fe3728c3a7e.PINKY_FINGER_TIP
];
const $e931890fb7c6eebb$var$handPartsDefinition = {
    [$e931890fb7c6eebb$export$fd9e205006227681.WRIST]: [
        $e931890fb7c6eebb$export$f8000fe3728c3a7e.WRIST
    ],
    [$e931890fb7c6eebb$export$fd9e205006227681.THUMB]: [
        $e931890fb7c6eebb$export$f8000fe3728c3a7e.THUMB_METACARPAL,
        $e931890fb7c6eebb$export$f8000fe3728c3a7e.THUMB_PHALANX_PROXIMAL,
        $e931890fb7c6eebb$export$f8000fe3728c3a7e.THUMB_PHALANX_DISTAL,
        $e931890fb7c6eebb$export$f8000fe3728c3a7e.THUMB_TIP
    ],
    [$e931890fb7c6eebb$export$fd9e205006227681.INDEX]: [
        $e931890fb7c6eebb$export$f8000fe3728c3a7e.INDEX_FINGER_METACARPAL,
        $e931890fb7c6eebb$export$f8000fe3728c3a7e.INDEX_FINGER_PHALANX_PROXIMAL,
        $e931890fb7c6eebb$export$f8000fe3728c3a7e.INDEX_FINGER_PHALANX_INTERMEDIATE,
        $e931890fb7c6eebb$export$f8000fe3728c3a7e.INDEX_FINGER_PHALANX_DISTAL,
        $e931890fb7c6eebb$export$f8000fe3728c3a7e.INDEX_FINGER_TIP
    ],
    [$e931890fb7c6eebb$export$fd9e205006227681.MIDDLE]: [
        $e931890fb7c6eebb$export$f8000fe3728c3a7e.MIDDLE_FINGER_METACARPAL,
        $e931890fb7c6eebb$export$f8000fe3728c3a7e.MIDDLE_FINGER_PHALANX_PROXIMAL,
        $e931890fb7c6eebb$export$f8000fe3728c3a7e.MIDDLE_FINGER_PHALANX_INTERMEDIATE,
        $e931890fb7c6eebb$export$f8000fe3728c3a7e.MIDDLE_FINGER_PHALANX_DISTAL,
        $e931890fb7c6eebb$export$f8000fe3728c3a7e.MIDDLE_FINGER_TIP
    ],
    [$e931890fb7c6eebb$export$fd9e205006227681.RING]: [
        $e931890fb7c6eebb$export$f8000fe3728c3a7e.RING_FINGER_METACARPAL,
        $e931890fb7c6eebb$export$f8000fe3728c3a7e.RING_FINGER_PHALANX_PROXIMAL,
        $e931890fb7c6eebb$export$f8000fe3728c3a7e.RING_FINGER_PHALANX_INTERMEDIATE,
        $e931890fb7c6eebb$export$f8000fe3728c3a7e.RING_FINGER_PHALANX_DISTAL,
        $e931890fb7c6eebb$export$f8000fe3728c3a7e.RING_FINGER_TIP
    ],
    [$e931890fb7c6eebb$export$fd9e205006227681.LITTLE]: [
        $e931890fb7c6eebb$export$f8000fe3728c3a7e.PINKY_FINGER_METACARPAL,
        $e931890fb7c6eebb$export$f8000fe3728c3a7e.PINKY_FINGER_PHALANX_PROXIMAL,
        $e931890fb7c6eebb$export$f8000fe3728c3a7e.PINKY_FINGER_PHALANX_INTERMEDIATE,
        $e931890fb7c6eebb$export$f8000fe3728c3a7e.PINKY_FINGER_PHALANX_DISTAL,
        $e931890fb7c6eebb$export$f8000fe3728c3a7e.PINKY_FINGER_TIP
    ]
};
class $e931890fb7c6eebb$export$510a23c80bbd6a39 {
    /**
     * Get the hand mesh.
     */ get handMesh() {
        return this._handMesh;
    }
    /**
     * Get meshes of part of the hand.
     * @param part The part of hand to get.
     * @returns An array of meshes that correlate to the hand part requested.
     */ getHandPartMeshes(part) {
        return $e931890fb7c6eebb$var$handPartsDefinition[part].map((name)=>this._jointMeshes[$e931890fb7c6eebb$var$handJointReferenceArray.indexOf(name)]);
    }
    /**
     * Retrieves a mesh linked to a named joint in the hand.
     * @param jointName The name of the joint.
     * @returns An AbstractMesh whose position corresponds with the joint position.
     */ getJointMesh(jointName) {
        return this._jointMeshes[$e931890fb7c6eebb$var$handJointReferenceArray.indexOf(jointName)];
    }
    /**
     * Construct a new hand object
     * @param xrController The controller to which the hand correlates.
     * @param _jointMeshes The meshes to be used to track the hand joints.
     * @param _handMesh An optional hand mesh.
     * @param rigMapping An optional rig mapping for the hand mesh.
     *                   If not provided (but a hand mesh is provided),
     *                   it will be assumed that the hand mesh's bones are named
     *                   directly after the WebXR bone names.
     * @param _leftHandedMeshes Are the hand meshes left-handed-system meshes
     * @param _jointsInvisible Are the tracked joint meshes visible
     * @param _jointScaleFactor Scale factor for all joint meshes
     */ constructor(/** The controller to which the hand correlates. */ xrController, _jointMeshes, _handMesh, /** An optional rig mapping for the hand mesh. If not provided (but a hand mesh is provided),
     * it will be assumed that the hand mesh's bones are named directly after the WebXR bone names. */ rigMapping, _leftHandedMeshes = false, _jointsInvisible = false, _jointScaleFactor = 1){
        this.xrController = xrController;
        this._jointMeshes = _jointMeshes;
        this._handMesh = _handMesh;
        this.rigMapping = rigMapping;
        this._leftHandedMeshes = _leftHandedMeshes;
        this._jointsInvisible = _jointsInvisible;
        this._jointScaleFactor = _jointScaleFactor;
        /**
         * Transform nodes that will directly receive the transforms from the WebXR matrix data.
         */ this._jointTransforms = new Array($e931890fb7c6eebb$var$handJointReferenceArray.length);
        /**
         * The float array that will directly receive the transform matrix data from WebXR.
         */ this._jointTransformMatrices = new Float32Array($e931890fb7c6eebb$var$handJointReferenceArray.length * 16);
        this._tempJointMatrix = new (0, $ha1VO.Matrix)();
        /**
         * The float array that will directly receive the joint radii from WebXR.
         */ this._jointRadii = new Float32Array($e931890fb7c6eebb$var$handJointReferenceArray.length);
        this._scene = _jointMeshes[0].getScene();
        // Initialize the joint transform quaternions and link the transforms to the bones.
        for(let jointIdx = 0; jointIdx < this._jointTransforms.length; jointIdx++){
            const jointTransform = this._jointTransforms[jointIdx] = new (0, $klshO.TransformNode)($e931890fb7c6eebb$var$handJointReferenceArray[jointIdx], this._scene);
            jointTransform.rotationQuaternion = new (0, $ha1VO.Quaternion)();
            // Set the rotation quaternion so we can use it later for tracking.
            _jointMeshes[jointIdx].rotationQuaternion = new (0, $ha1VO.Quaternion)();
        }
        if (_handMesh) // Note that this logic needs to happen after we initialize the joint tracking transform nodes.
        this.setHandMesh(_handMesh, rigMapping);
        // hide the motion controller, if available/loaded
        if (this.xrController.motionController) {
            if (this.xrController.motionController.rootMesh) this.xrController.motionController.rootMesh.dispose(false, true);
        }
        this.xrController.onMotionControllerInitObservable.add((motionController)=>{
            motionController._doNotLoadControllerMesh = true;
        });
    }
    /**
     * Sets the current hand mesh to render for the WebXRHand.
     * @param handMesh The rigged hand mesh that will be tracked to the user's hand.
     * @param rigMapping The mapping from XRHandJoint to bone names to use with the mesh.
     * @param _xrSessionManager The XRSessionManager used to initialize the hand mesh.
     */ setHandMesh(handMesh, rigMapping, _xrSessionManager) {
        this._handMesh = handMesh;
        // Avoid any strange frustum culling. We will manually control visibility via attach and detach.
        handMesh.alwaysSelectAsActiveMesh = true;
        handMesh.getChildMeshes().forEach((mesh)=>{
            mesh.alwaysSelectAsActiveMesh = true;
        });
        // Link the bones in the hand mesh to the transform nodes that will be bound to the WebXR tracked joints.
        if (this._handMesh.skeleton) {
            const handMeshSkeleton = this._handMesh.skeleton;
            $e931890fb7c6eebb$var$handJointReferenceArray.forEach((jointName, jointIdx)=>{
                const jointBoneIdx = handMeshSkeleton.getBoneIndexByName(rigMapping ? rigMapping[jointName] : jointName);
                if (jointBoneIdx !== -1) handMeshSkeleton.bones[jointBoneIdx].linkTransformNode(this._jointTransforms[jointIdx]);
            });
        }
    }
    /**
     * Update this hand from the latest xr frame.
     * @param xrFrame The latest frame received from WebXR.
     * @param referenceSpace The current viewer reference space.
     */ updateFromXRFrame(xrFrame, referenceSpace) {
        const hand = this.xrController.inputSource.hand;
        if (!hand) return;
        // TODO: Modify webxr.d.ts to better match WebXR IDL so we don't need this any cast.
        const anyHand = hand;
        const jointSpaces = $e931890fb7c6eebb$var$handJointReferenceArray.map((jointName)=>anyHand[jointName] || hand.get(jointName));
        let trackingSuccessful = false;
        if (xrFrame.fillPoses && xrFrame.fillJointRadii) trackingSuccessful = xrFrame.fillPoses(jointSpaces, referenceSpace, this._jointTransformMatrices) && xrFrame.fillJointRadii(jointSpaces, this._jointRadii);
        else if (xrFrame.getJointPose) {
            trackingSuccessful = true;
            // Warning: This codepath is slow by comparison, only here for compat.
            for(let jointIdx = 0; jointIdx < jointSpaces.length; jointIdx++){
                const jointPose = xrFrame.getJointPose(jointSpaces[jointIdx], referenceSpace);
                if (jointPose) {
                    this._jointTransformMatrices.set(jointPose.transform.matrix, jointIdx * 16);
                    this._jointRadii[jointIdx] = jointPose.radius || 0.008;
                } else {
                    trackingSuccessful = false;
                    break;
                }
            }
        }
        if (!trackingSuccessful) return;
        $e931890fb7c6eebb$var$handJointReferenceArray.forEach((_jointName, jointIdx)=>{
            const jointTransform = this._jointTransforms[jointIdx];
            (0, $ha1VO.Matrix).FromArrayToRef(this._jointTransformMatrices, jointIdx * 16, this._tempJointMatrix);
            this._tempJointMatrix.decompose(undefined, jointTransform.rotationQuaternion, jointTransform.position);
            // The radius we need to make the joint in order for it to roughly cover the joints of the user's real hand.
            const scaledJointRadius = this._jointRadii[jointIdx] * this._jointScaleFactor;
            const jointMesh = this._jointMeshes[jointIdx];
            jointMesh.isVisible = !this._handMesh && !this._jointsInvisible;
            jointMesh.position.copyFrom(jointTransform.position);
            jointMesh.rotationQuaternion.copyFrom(jointTransform.rotationQuaternion);
            jointMesh.scaling.setAll(scaledJointRadius);
            // The WebXR data comes as right-handed, so we might need to do some conversions.
            if (!this._scene.useRightHandedSystem) {
                jointMesh.position.z *= -1;
                jointMesh.rotationQuaternion.z *= -1;
                jointMesh.rotationQuaternion.w *= -1;
                if (this._leftHandedMeshes && this._handMesh) {
                    jointTransform.position.z *= -1;
                    jointTransform.rotationQuaternion.z *= -1;
                    jointTransform.rotationQuaternion.w *= -1;
                }
            }
        });
        if (this._handMesh) this._handMesh.isVisible = true;
    }
    /**
     * Dispose this Hand object
     * @param disposeMeshes Should the meshes be disposed as well
     */ dispose(disposeMeshes = false) {
        if (this._handMesh) {
            if (disposeMeshes) {
                this._handMesh.skeleton?.dispose();
                this._handMesh.dispose(false, true);
            } else this._handMesh.isVisible = false;
        }
    }
}
class $e931890fb7c6eebb$export$e6185f1e232b5a71 extends (0, $2YzP2.WebXRAbstractFeature) {
    static _GenerateTrackedJointMeshes(featureOptions) {
        const meshes = {};
        [
            "left",
            "right"
        ].map((handedness)=>{
            const trackedMeshes = [];
            const originalMesh = featureOptions.jointMeshes?.sourceMesh || (0, $g3tvW.CreateIcoSphere)("jointParent", $e931890fb7c6eebb$export$e6185f1e232b5a71._ICOSPHERE_PARAMS);
            originalMesh.isVisible = !!featureOptions.jointMeshes?.keepOriginalVisible;
            for(let i = 0; i < $e931890fb7c6eebb$var$handJointReferenceArray.length; ++i){
                let newInstance = originalMesh.createInstance(`${handedness}-handJoint-${i}`);
                if (featureOptions.jointMeshes?.onHandJointMeshGenerated) {
                    const returnedMesh = featureOptions.jointMeshes.onHandJointMeshGenerated(newInstance, i, handedness);
                    if (returnedMesh) {
                        if (returnedMesh !== newInstance) {
                            newInstance.dispose();
                            newInstance = returnedMesh;
                        }
                    }
                }
                newInstance.isPickable = false;
                if (featureOptions.jointMeshes?.enablePhysics) {
                    const props = featureOptions.jointMeshes?.physicsProps || {};
                    // downscale the instances so that physics will be initialized correctly
                    newInstance.scaling.setAll(0.02);
                    const type = props.impostorType !== undefined ? props.impostorType : (0, $iz3U8.PhysicsImpostor).SphereImpostor;
                    newInstance.physicsImpostor = new (0, $iz3U8.PhysicsImpostor)(newInstance, type, {
                        mass: 0,
                        ...props
                    });
                }
                newInstance.rotationQuaternion = new (0, $ha1VO.Quaternion)();
                newInstance.isVisible = false;
                trackedMeshes.push(newInstance);
            }
            meshes[handedness] = trackedMeshes;
        });
        return {
            left: meshes.left,
            right: meshes.right
        };
    }
    static _GenerateDefaultHandMeshesAsync(scene, xrSessionManager, options) {
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(async (resolve)=>{
            const riggedMeshes = {};
            // check the cache, defensive
            if ($e931890fb7c6eebb$export$e6185f1e232b5a71._RightHandGLB?.meshes[1]?.isDisposed()) $e931890fb7c6eebb$export$e6185f1e232b5a71._RightHandGLB = null;
            if ($e931890fb7c6eebb$export$e6185f1e232b5a71._LeftHandGLB?.meshes[1]?.isDisposed()) $e931890fb7c6eebb$export$e6185f1e232b5a71._LeftHandGLB = null;
            const handsDefined = !!($e931890fb7c6eebb$export$e6185f1e232b5a71._RightHandGLB && $e931890fb7c6eebb$export$e6185f1e232b5a71._LeftHandGLB);
            // load them in parallel
            const handGLBs = await Promise.all([
                $e931890fb7c6eebb$export$e6185f1e232b5a71._RightHandGLB || (0, $agoTA.SceneLoader).ImportMeshAsync("", $e931890fb7c6eebb$export$e6185f1e232b5a71.DEFAULT_HAND_MODEL_BASE_URL, $e931890fb7c6eebb$export$e6185f1e232b5a71.DEFAULT_HAND_MODEL_RIGHT_FILENAME, scene),
                $e931890fb7c6eebb$export$e6185f1e232b5a71._LeftHandGLB || (0, $agoTA.SceneLoader).ImportMeshAsync("", $e931890fb7c6eebb$export$e6185f1e232b5a71.DEFAULT_HAND_MODEL_BASE_URL, $e931890fb7c6eebb$export$e6185f1e232b5a71.DEFAULT_HAND_MODEL_LEFT_FILENAME, scene)
            ]);
            $e931890fb7c6eebb$export$e6185f1e232b5a71._RightHandGLB = handGLBs[0];
            $e931890fb7c6eebb$export$e6185f1e232b5a71._LeftHandGLB = handGLBs[1];
            const handShader = await (0, $5fNQr.NodeMaterial).ParseFromFileAsync("handShader", $e931890fb7c6eebb$export$e6185f1e232b5a71.DEFAULT_HAND_MODEL_SHADER_URL, scene);
            // depth prepass and alpha mode
            handShader.needDepthPrePass = true;
            handShader.transparencyMode = (0, $54229.Material).MATERIAL_ALPHABLEND;
            handShader.alphaMode = 2;
            // build node materials
            handShader.build(false);
            // shader
            const handColors = {
                base: (0, $7etnY.Color3).FromInts(116, 63, 203),
                fresnel: (0, $7etnY.Color3).FromInts(149, 102, 229),
                fingerColor: (0, $7etnY.Color3).FromInts(177, 130, 255),
                tipFresnel: (0, $7etnY.Color3).FromInts(220, 200, 255),
                ...options?.handMeshes?.customColors
            };
            const handNodes = {
                base: handShader.getBlockByName("baseColor"),
                fresnel: handShader.getBlockByName("fresnelColor"),
                fingerColor: handShader.getBlockByName("fingerColor"),
                tipFresnel: handShader.getBlockByName("tipFresnelColor")
            };
            handNodes.base.value = handColors.base;
            handNodes.fresnel.value = handColors.fresnel;
            handNodes.fingerColor.value = handColors.fingerColor;
            handNodes.tipFresnel.value = handColors.tipFresnel;
            const isMultiview = xrSessionManager._getBaseLayerWrapper()?.isMultiview;
            [
                "left",
                "right"
            ].forEach((handedness)=>{
                const handGLB = handedness == "left" ? $e931890fb7c6eebb$export$e6185f1e232b5a71._LeftHandGLB : $e931890fb7c6eebb$export$e6185f1e232b5a71._RightHandGLB;
                if (!handGLB) // this should never happen!
                throw new Error("Could not load hand model");
                const handMesh = handGLB.meshes[1];
                handMesh._internalAbstractMeshDataInfo._computeBonesUsingShaders = true;
                // if in multiview do not use the material
                if (!isMultiview) handMesh.material = handShader.clone(`${handedness}HandShaderClone`, true);
                handMesh.isVisible = false;
                riggedMeshes[handedness] = handMesh;
                // single change for left handed systems
                if (!handsDefined && !scene.useRightHandedSystem) handGLB.meshes[1].rotate((0, $dbxbu.Axis).Y, Math.PI);
            });
            handShader.dispose();
            resolve({
                left: riggedMeshes.left,
                right: riggedMeshes.right
            });
        });
    }
    /**
     * Generates a mapping from XRHandJoint to bone name for the default hand mesh.
     * @param handedness The handedness being mapped for.
     * @returns A mapping from XRHandJoint to bone name.
     */ static _GenerateDefaultHandMeshRigMapping(handedness) {
        const H = handedness == "right" ? "R" : "L";
        return {
            [$e931890fb7c6eebb$export$f8000fe3728c3a7e.WRIST]: `wrist_${H}`,
            [$e931890fb7c6eebb$export$f8000fe3728c3a7e.THUMB_METACARPAL]: `thumb_metacarpal_${H}`,
            [$e931890fb7c6eebb$export$f8000fe3728c3a7e.THUMB_PHALANX_PROXIMAL]: `thumb_proxPhalanx_${H}`,
            [$e931890fb7c6eebb$export$f8000fe3728c3a7e.THUMB_PHALANX_DISTAL]: `thumb_distPhalanx_${H}`,
            [$e931890fb7c6eebb$export$f8000fe3728c3a7e.THUMB_TIP]: `thumb_tip_${H}`,
            [$e931890fb7c6eebb$export$f8000fe3728c3a7e.INDEX_FINGER_METACARPAL]: `index_metacarpal_${H}`,
            [$e931890fb7c6eebb$export$f8000fe3728c3a7e.INDEX_FINGER_PHALANX_PROXIMAL]: `index_proxPhalanx_${H}`,
            [$e931890fb7c6eebb$export$f8000fe3728c3a7e.INDEX_FINGER_PHALANX_INTERMEDIATE]: `index_intPhalanx_${H}`,
            [$e931890fb7c6eebb$export$f8000fe3728c3a7e.INDEX_FINGER_PHALANX_DISTAL]: `index_distPhalanx_${H}`,
            [$e931890fb7c6eebb$export$f8000fe3728c3a7e.INDEX_FINGER_TIP]: `index_tip_${H}`,
            [$e931890fb7c6eebb$export$f8000fe3728c3a7e.MIDDLE_FINGER_METACARPAL]: `middle_metacarpal_${H}`,
            [$e931890fb7c6eebb$export$f8000fe3728c3a7e.MIDDLE_FINGER_PHALANX_PROXIMAL]: `middle_proxPhalanx_${H}`,
            [$e931890fb7c6eebb$export$f8000fe3728c3a7e.MIDDLE_FINGER_PHALANX_INTERMEDIATE]: `middle_intPhalanx_${H}`,
            [$e931890fb7c6eebb$export$f8000fe3728c3a7e.MIDDLE_FINGER_PHALANX_DISTAL]: `middle_distPhalanx_${H}`,
            [$e931890fb7c6eebb$export$f8000fe3728c3a7e.MIDDLE_FINGER_TIP]: `middle_tip_${H}`,
            [$e931890fb7c6eebb$export$f8000fe3728c3a7e.RING_FINGER_METACARPAL]: `ring_metacarpal_${H}`,
            [$e931890fb7c6eebb$export$f8000fe3728c3a7e.RING_FINGER_PHALANX_PROXIMAL]: `ring_proxPhalanx_${H}`,
            [$e931890fb7c6eebb$export$f8000fe3728c3a7e.RING_FINGER_PHALANX_INTERMEDIATE]: `ring_intPhalanx_${H}`,
            [$e931890fb7c6eebb$export$f8000fe3728c3a7e.RING_FINGER_PHALANX_DISTAL]: `ring_distPhalanx_${H}`,
            [$e931890fb7c6eebb$export$f8000fe3728c3a7e.RING_FINGER_TIP]: `ring_tip_${H}`,
            [$e931890fb7c6eebb$export$f8000fe3728c3a7e.PINKY_FINGER_METACARPAL]: `little_metacarpal_${H}`,
            [$e931890fb7c6eebb$export$f8000fe3728c3a7e.PINKY_FINGER_PHALANX_PROXIMAL]: `little_proxPhalanx_${H}`,
            [$e931890fb7c6eebb$export$f8000fe3728c3a7e.PINKY_FINGER_PHALANX_INTERMEDIATE]: `little_intPhalanx_${H}`,
            [$e931890fb7c6eebb$export$f8000fe3728c3a7e.PINKY_FINGER_PHALANX_DISTAL]: `little_distPhalanx_${H}`,
            [$e931890fb7c6eebb$export$f8000fe3728c3a7e.PINKY_FINGER_TIP]: `little_tip_${H}`
        };
    }
    /**
     * Check if the needed objects are defined.
     * This does not mean that the feature is enabled, but that the objects needed are well defined.
     * @returns true if the needed objects for this feature are defined
     */ isCompatible() {
        return typeof XRHand !== "undefined";
    }
    /**
     * Get the hand object according to the controller id
     * @param controllerId the controller id to which we want to get the hand
     * @returns null if not found or the WebXRHand object if found
     */ getHandByControllerId(controllerId) {
        return this._attachedHands[controllerId];
    }
    /**
     * Get a hand object according to the requested handedness
     * @param handedness the handedness to request
     * @returns null if not found or the WebXRHand object if found
     */ getHandByHandedness(handedness) {
        if (handedness == "none") return null;
        return this._trackingHands[handedness];
    }
    /**
     * Creates a new instance of the XR hand tracking feature.
     * @param _xrSessionManager An instance of WebXRSessionManager.
     * @param options Options to use when constructing this feature.
     */ constructor(_xrSessionManager, /** Options to use when constructing this feature. */ options){
        super(_xrSessionManager);
        this.options = options;
        this._attachedHands = {};
        this._trackingHands = {
            left: null,
            right: null
        };
        this._handResources = {
            jointMeshes: null,
            handMeshes: null,
            rigMappings: null
        };
        this._worldScaleObserver = null;
        /**
         * This observable will notify registered observers when a new hand object was added and initialized
         */ this.onHandAddedObservable = new (0, $diGQf.Observable)();
        /**
         * This observable will notify its observers right before the hand object is disposed
         */ this.onHandRemovedObservable = new (0, $diGQf.Observable)();
        this._attachHand = (xrController)=>{
            if (!xrController.inputSource.hand || xrController.inputSource.handedness == "none" || !this._handResources.jointMeshes) return;
            const handedness = xrController.inputSource.handedness;
            const webxrHand = new $e931890fb7c6eebb$export$510a23c80bbd6a39(xrController, this._handResources.jointMeshes[handedness], this._handResources.handMeshes && this._handResources.handMeshes[handedness], this._handResources.rigMappings && this._handResources.rigMappings[handedness], this.options.handMeshes?.meshesUseLeftHandedCoordinates, this.options.jointMeshes?.invisible, this.options.jointMeshes?.scaleFactor);
            this._attachedHands[xrController.uniqueId] = webxrHand;
            this._trackingHands[handedness] = webxrHand;
            this.onHandAddedObservable.notifyObservers(webxrHand);
        };
        this._detachHand = (xrController)=>{
            this._detachHandById(xrController.uniqueId);
        };
        this.xrNativeFeatureName = "hand-tracking";
        // Support legacy versions of the options object by copying over joint mesh properties
        const anyOptions = options;
        const anyJointMeshOptions = anyOptions.jointMeshes;
        if (anyJointMeshOptions) {
            if (typeof anyJointMeshOptions.disableDefaultHandMesh !== "undefined") {
                options.handMeshes = options.handMeshes || {};
                options.handMeshes.disableDefaultMeshes = anyJointMeshOptions.disableDefaultHandMesh;
            }
            if (typeof anyJointMeshOptions.handMeshes !== "undefined") {
                options.handMeshes = options.handMeshes || {};
                options.handMeshes.customMeshes = anyJointMeshOptions.handMeshes;
            }
            if (typeof anyJointMeshOptions.leftHandedSystemMeshes !== "undefined") {
                options.handMeshes = options.handMeshes || {};
                options.handMeshes.meshesUseLeftHandedCoordinates = anyJointMeshOptions.leftHandedSystemMeshes;
            }
            if (typeof anyJointMeshOptions.rigMapping !== "undefined") {
                options.handMeshes = options.handMeshes || {};
                const leftRigMapping = {};
                const rightRigMapping = {};
                [
                    [
                        anyJointMeshOptions.rigMapping.left,
                        leftRigMapping
                    ],
                    [
                        anyJointMeshOptions.rigMapping.right,
                        rightRigMapping
                    ]
                ].forEach((rigMappingTuple)=>{
                    const legacyRigMapping = rigMappingTuple[0];
                    const rigMapping = rigMappingTuple[1];
                    legacyRigMapping.forEach((modelJointName, index)=>{
                        rigMapping[$e931890fb7c6eebb$var$handJointReferenceArray[index]] = modelJointName;
                    });
                });
                options.handMeshes.customRigMappings = {
                    left: leftRigMapping,
                    right: rightRigMapping
                };
            }
        }
    }
    /**
     * Attach this feature.
     * Will usually be called by the features manager.
     *
     * @returns true if successful.
     */ attach() {
        if (!super.attach()) return false;
        this._handResources = {
            jointMeshes: $e931890fb7c6eebb$export$e6185f1e232b5a71._GenerateTrackedJointMeshes(this.options),
            handMeshes: this.options.handMeshes?.customMeshes || null,
            rigMappings: this.options.handMeshes?.customRigMappings || null
        };
        // If they didn't supply custom meshes and are not disabling the default meshes...
        if (!this.options.handMeshes?.customMeshes && !this.options.handMeshes?.disableDefaultMeshes) {
            $e931890fb7c6eebb$export$e6185f1e232b5a71._GenerateDefaultHandMeshesAsync((0, $ejQPp.EngineStore).LastCreatedScene, this._xrSessionManager, this.options).then((defaultHandMeshes)=>{
                this._handResources.handMeshes = defaultHandMeshes;
                this._handResources.rigMappings = {
                    left: $e931890fb7c6eebb$export$e6185f1e232b5a71._GenerateDefaultHandMeshRigMapping("left"),
                    right: $e931890fb7c6eebb$export$e6185f1e232b5a71._GenerateDefaultHandMeshRigMapping("right")
                };
                // Apply meshes to existing hands if already tracking.
                this._trackingHands.left?.setHandMesh(this._handResources.handMeshes.left, this._handResources.rigMappings.left, this._xrSessionManager);
                this._trackingHands.right?.setHandMesh(this._handResources.handMeshes.right, this._handResources.rigMappings.right, this._xrSessionManager);
                this._handResources.handMeshes.left.scaling.setAll(this._xrSessionManager.worldScalingFactor);
                this._handResources.handMeshes.right.scaling.setAll(this._xrSessionManager.worldScalingFactor);
            });
            this._worldScaleObserver = this._xrSessionManager.onWorldScaleFactorChangedObservable.add((scalingFactors)=>{
                if (this._handResources.handMeshes) {
                    this._handResources.handMeshes.left.scaling.scaleInPlace(scalingFactors.newScaleFactor / scalingFactors.previousScaleFactor);
                    this._handResources.handMeshes.right.scaling.scaleInPlace(scalingFactors.newScaleFactor / scalingFactors.previousScaleFactor);
                }
            });
        }
        this.options.xrInput.controllers.forEach(this._attachHand);
        this._addNewAttachObserver(this.options.xrInput.onControllerAddedObservable, this._attachHand);
        this._addNewAttachObserver(this.options.xrInput.onControllerRemovedObservable, this._detachHand);
        return true;
    }
    _onXRFrame(_xrFrame) {
        this._trackingHands.left?.updateFromXRFrame(_xrFrame, this._xrSessionManager.referenceSpace);
        this._trackingHands.right?.updateFromXRFrame(_xrFrame, this._xrSessionManager.referenceSpace);
    }
    _detachHandById(controllerId, disposeMesh) {
        const hand = this.getHandByControllerId(controllerId);
        if (hand) {
            const handedness = hand.xrController.inputSource.handedness == "left" ? "left" : "right";
            if (this._trackingHands[handedness]?.xrController.uniqueId === controllerId) this._trackingHands[handedness] = null;
            this.onHandRemovedObservable.notifyObservers(hand);
            hand.dispose(disposeMesh);
            delete this._attachedHands[controllerId];
        }
    }
    /**
     * Detach this feature.
     * Will usually be called by the features manager.
     *
     * @returns true if successful.
     */ detach() {
        if (!super.detach()) return false;
        Object.keys(this._attachedHands).forEach((uniqueId)=>this._detachHandById(uniqueId, this.options.handMeshes?.disposeOnSessionEnd));
        if (this.options.handMeshes?.disposeOnSessionEnd) {
            if (this._handResources.jointMeshes) {
                this._handResources.jointMeshes.left.forEach((trackedMesh)=>trackedMesh.dispose());
                this._handResources.jointMeshes.right.forEach((trackedMesh)=>trackedMesh.dispose());
            }
        }
        // remove world scale observer
        if (this._worldScaleObserver) this._xrSessionManager.onWorldScaleFactorChangedObservable.remove(this._worldScaleObserver);
        return true;
    }
    /**
     * Dispose this feature and all of the resources attached.
     */ dispose() {
        super.dispose();
        this.onHandAddedObservable.clear();
        this.onHandRemovedObservable.clear();
        if (this._handResources.handMeshes && !this.options.handMeshes?.customMeshes) {
            // this will dispose the cached meshes
            this._handResources.handMeshes.left.dispose();
            this._handResources.handMeshes.right.dispose();
            // remove the cached meshes
            $e931890fb7c6eebb$export$e6185f1e232b5a71._RightHandGLB = null;
            $e931890fb7c6eebb$export$e6185f1e232b5a71._LeftHandGLB = null;
        }
        if (this._handResources.jointMeshes) {
            this._handResources.jointMeshes.left.forEach((trackedMesh)=>trackedMesh.dispose());
            this._handResources.jointMeshes.right.forEach((trackedMesh)=>trackedMesh.dispose());
        }
    }
}
/**
 * The module's name
 */ $e931890fb7c6eebb$export$e6185f1e232b5a71.Name = (0, $cJN7d.WebXRFeatureName).HAND_TRACKING;
/**
 * The (Babylon) version of this module.
 * This is an integer representing the implementation version.
 * This number does not correspond to the WebXR specs version
 */ $e931890fb7c6eebb$export$e6185f1e232b5a71.Version = 1;
/** The base URL for the default hand model. */ $e931890fb7c6eebb$export$e6185f1e232b5a71.DEFAULT_HAND_MODEL_BASE_URL = "https://assets.babylonjs.com/meshes/HandMeshes/";
/** The filename to use for the default right hand model. */ $e931890fb7c6eebb$export$e6185f1e232b5a71.DEFAULT_HAND_MODEL_RIGHT_FILENAME = "r_hand_rhs.glb";
/** The filename to use for the default left hand model. */ $e931890fb7c6eebb$export$e6185f1e232b5a71.DEFAULT_HAND_MODEL_LEFT_FILENAME = "l_hand_rhs.glb";
/** The URL pointing to the default hand model NodeMaterial shader. */ $e931890fb7c6eebb$export$e6185f1e232b5a71.DEFAULT_HAND_MODEL_SHADER_URL = "https://assets.babylonjs.com/meshes/HandMeshes/handsShader.json";
// We want to use lightweight models, diameter will initially be 1 but scaled to the values returned from WebXR.
$e931890fb7c6eebb$export$e6185f1e232b5a71._ICOSPHERE_PARAMS = {
    radius: 0.5,
    flat: false,
    subdivisions: 2
};
$e931890fb7c6eebb$export$e6185f1e232b5a71._RightHandGLB = null;
$e931890fb7c6eebb$export$e6185f1e232b5a71._LeftHandGLB = null;
//register the plugin
(0, $cJN7d.WebXRFeaturesManager).AddWebXRFeature($e931890fb7c6eebb$export$e6185f1e232b5a71.Name, (xrSessionManager, options)=>{
    return ()=>new $e931890fb7c6eebb$export$e6185f1e232b5a71(xrSessionManager, options);
}, $e931890fb7c6eebb$export$e6185f1e232b5a71.Version, false);

});
parcelRegister("2YzP2", function(module, exports) {

$parcel$export(module.exports, "WebXRAbstractFeature", () => $22acf8e857229e3d$export$e3b6723e64846652);

var $diGQf = parcelRequire("diGQf");

var $kVtWi = parcelRequire("kVtWi");
class $22acf8e857229e3d$export$e3b6723e64846652 {
    /**
     * The name of the native xr feature name (like anchor, hit-test, or hand-tracking)
     */ get xrNativeFeatureName() {
        return this._xrNativeFeatureName;
    }
    set xrNativeFeatureName(name) {
        // check if feature was initialized while in session but needs to be initialized before the session starts
        if (!this._xrSessionManager.isNative && name && this._xrSessionManager.inXRSession && this._xrSessionManager.enabledFeatures?.indexOf(name) === -1) (0, $kVtWi.Logger).Warn(`The feature ${name} needs to be enabled before starting the XR session. Note - It is still possible it is not supported.`);
        this._xrNativeFeatureName = name;
    }
    /**
     * Construct a new (abstract) WebXR feature
     * @param _xrSessionManager the xr session manager for this feature
     */ constructor(_xrSessionManager){
        this._xrSessionManager = _xrSessionManager;
        this._attached = false;
        this._removeOnDetach = [];
        /**
         * Is this feature disposed?
         */ this.isDisposed = false;
        /**
         * Should auto-attach be disabled?
         */ this.disableAutoAttach = false;
        this._xrNativeFeatureName = "";
        /**
         * Observers registered here will be executed when the feature is attached
         */ this.onFeatureAttachObservable = new (0, $diGQf.Observable)();
        /**
         * Observers registered here will be executed when the feature is detached
         */ this.onFeatureDetachObservable = new (0, $diGQf.Observable)();
    }
    /**
     * Is this feature attached
     */ get attached() {
        return this._attached;
    }
    /**
     * attach this feature
     *
     * @param force should attachment be forced (even when already attached)
     * @returns true if successful, false is failed or already attached
     */ attach(force) {
        // do not attach a disposed feature
        if (this.isDisposed) return false;
        if (!force) {
            if (this.attached) return false;
        } else if (this.attached) // detach first, to be sure
        this.detach();
        // if this is a native WebXR feature, check if it is enabled on the session
        // For now only check if not using babylon native
        // vision OS doesn't support the enabledFeatures array, so just warn instead of failing
        if (!this._xrSessionManager.enabledFeatures) (0, $kVtWi.Logger).Warn("session.enabledFeatures is not available on this device. It is possible that this feature is not supported.");
        else if (!this._xrSessionManager.isNative && this.xrNativeFeatureName && this._xrSessionManager.enabledFeatures.indexOf(this.xrNativeFeatureName) === -1) return false;
        this._attached = true;
        this._addNewAttachObserver(this._xrSessionManager.onXRFrameObservable, (frame)=>this._onXRFrame(frame));
        this.onFeatureAttachObservable.notifyObservers(this);
        return true;
    }
    /**
     * detach this feature.
     *
     * @returns true if successful, false if failed or already detached
     */ detach() {
        if (!this._attached) {
            this.disableAutoAttach = true;
            return false;
        }
        this._attached = false;
        this._removeOnDetach.forEach((toRemove)=>{
            toRemove.observable.remove(toRemove.observer);
        });
        this.onFeatureDetachObservable.notifyObservers(this);
        return true;
    }
    /**
     * Dispose this feature and all of the resources attached
     */ dispose() {
        this.detach();
        this.isDisposed = true;
        this.onFeatureAttachObservable.clear();
        this.onFeatureDetachObservable.clear();
    }
    /**
     * This function will be executed during before enabling the feature and can be used to not-allow enabling it.
     * Note that at this point the session has NOT started, so this is purely checking if the browser supports it
     *
     * @returns whether or not the feature is compatible in this environment
     */ isCompatible() {
        return true;
    }
    /**
     * This is used to register callbacks that will automatically be removed when detach is called.
     * @param observable the observable to which the observer will be attached
     * @param callback the callback to register
     * @param insertFirst should the callback be executed as soon as it is registered
     */ _addNewAttachObserver(observable, callback, insertFirst) {
        this._removeOnDetach.push({
            observable: observable,
            observer: observable.add(callback, undefined, insertFirst)
        });
    }
}

});

parcelRegister("iz3U8", function(module, exports) {

$parcel$export(module.exports, "PhysicsImpostor", () => $d83e863443505adb$export$59bf337cc03816a9);

var $kVtWi = parcelRequire("kVtWi");

var $opFp4 = parcelRequire("opFp4");

var $ha1VO = parcelRequire("ha1VO");

var $0cHNL = parcelRequire("0cHNL");

var $fbuqw = parcelRequire("fbuqw");

var $kGTHw = parcelRequire("kGTHw");

var $dbxbu = parcelRequire("dbxbu");
(0, $fbuqw.Mesh)._PhysicsImpostorParser = function(scene, physicObject, jsonObject) {
    return new $d83e863443505adb$export$59bf337cc03816a9(physicObject, jsonObject.physicsImpostor, {
        mass: jsonObject.physicsMass,
        friction: jsonObject.physicsFriction,
        restitution: jsonObject.physicsRestitution
    }, scene);
};
class $d83e863443505adb$export$59bf337cc03816a9 {
    /**
     * Specifies if the physics imposter is disposed
     */ get isDisposed() {
        return this._isDisposed;
    }
    /**
     * Gets the mass of the physics imposter
     */ get mass() {
        return this._physicsEngine ? this._physicsEngine.getPhysicsPlugin().getBodyMass(this) : 0;
    }
    set mass(value) {
        this.setMass(value);
    }
    /**
     * Gets the coefficient of friction
     */ get friction() {
        return this._physicsEngine ? this._physicsEngine.getPhysicsPlugin().getBodyFriction(this) : 0;
    }
    /**
     * Sets the coefficient of friction
     */ set friction(value) {
        if (!this._physicsEngine) return;
        this._physicsEngine.getPhysicsPlugin().setBodyFriction(this, value);
    }
    /**
     * Gets the coefficient of restitution
     */ get restitution() {
        return this._physicsEngine ? this._physicsEngine.getPhysicsPlugin().getBodyRestitution(this) : 0;
    }
    /**
     * Sets the coefficient of restitution
     */ set restitution(value) {
        if (!this._physicsEngine) return;
        this._physicsEngine.getPhysicsPlugin().setBodyRestitution(this, value);
    }
    /**
     * Gets the pressure of a soft body; only supported by the AmmoJSPlugin
     */ get pressure() {
        if (!this._physicsEngine) return 0;
        const plugin = this._physicsEngine.getPhysicsPlugin();
        if (!plugin.setBodyPressure) return 0;
        return plugin.getBodyPressure(this);
    }
    /**
     * Sets the pressure of a soft body; only supported by the AmmoJSPlugin
     */ set pressure(value) {
        if (!this._physicsEngine) return;
        const plugin = this._physicsEngine.getPhysicsPlugin();
        if (!plugin.setBodyPressure) return;
        plugin.setBodyPressure(this, value);
    }
    /**
     * Gets the stiffness of a soft body; only supported by the AmmoJSPlugin
     */ get stiffness() {
        if (!this._physicsEngine) return 0;
        const plugin = this._physicsEngine.getPhysicsPlugin();
        if (!plugin.getBodyStiffness) return 0;
        return plugin.getBodyStiffness(this);
    }
    /**
     * Sets the stiffness of a soft body; only supported by the AmmoJSPlugin
     */ set stiffness(value) {
        if (!this._physicsEngine) return;
        const plugin = this._physicsEngine.getPhysicsPlugin();
        if (!plugin.setBodyStiffness) return;
        plugin.setBodyStiffness(this, value);
    }
    /**
     * Gets the velocityIterations of a soft body; only supported by the AmmoJSPlugin
     */ get velocityIterations() {
        if (!this._physicsEngine) return 0;
        const plugin = this._physicsEngine.getPhysicsPlugin();
        if (!plugin.getBodyVelocityIterations) return 0;
        return plugin.getBodyVelocityIterations(this);
    }
    /**
     * Sets the velocityIterations of a soft body; only supported by the AmmoJSPlugin
     */ set velocityIterations(value) {
        if (!this._physicsEngine) return;
        const plugin = this._physicsEngine.getPhysicsPlugin();
        if (!plugin.setBodyVelocityIterations) return;
        plugin.setBodyVelocityIterations(this, value);
    }
    /**
     * Gets the positionIterations of a soft body; only supported by the AmmoJSPlugin
     */ get positionIterations() {
        if (!this._physicsEngine) return 0;
        const plugin = this._physicsEngine.getPhysicsPlugin();
        if (!plugin.getBodyPositionIterations) return 0;
        return plugin.getBodyPositionIterations(this);
    }
    /**
     * Sets the positionIterations of a soft body; only supported by the AmmoJSPlugin
     */ set positionIterations(value) {
        if (!this._physicsEngine) return;
        const plugin = this._physicsEngine.getPhysicsPlugin();
        if (!plugin.setBodyPositionIterations) return;
        plugin.setBodyPositionIterations(this, value);
    }
    /**
     * Initializes the physics imposter
     * @param object The physics-enabled object used as the physics imposter
     * @param type The type of the physics imposter. Types are available as static members of this class.
     * @param _options The options for the physics imposter
     * @param _scene The Babylon scene
     */ constructor(/**
     * The physics-enabled object used as the physics imposter
     */ object, /**
     * The type of the physics imposter
     */ type, _options = {
        mass: 0
    }, _scene){
        this.object = object;
        this.type = type;
        this._options = _options;
        this._scene = _scene;
        /** @internal */ this._pluginData = {};
        this._bodyUpdateRequired = false;
        this._onBeforePhysicsStepCallbacks = new Array();
        this._onAfterPhysicsStepCallbacks = new Array();
        /** @internal */ this._onPhysicsCollideCallbacks = [];
        this._deltaPosition = (0, $ha1VO.Vector3).Zero();
        this._isDisposed = false;
        /**
         * @internal
         */ this.soft = false;
        /**
         * @internal
         */ this.segments = 0;
        //temp variables for parent rotation calculations
        //private _mats: Array<Matrix> = [new Matrix(), new Matrix()];
        this._tmpQuat = new (0, $ha1VO.Quaternion)();
        this._tmpQuat2 = new (0, $ha1VO.Quaternion)();
        /**
         * this function is executed by the physics engine.
         */ this.beforeStep = ()=>{
            if (!this._physicsEngine) return;
            this.object.translate(this._deltaPosition, -1);
            this._deltaRotationConjugated && this.object.rotationQuaternion && this.object.rotationQuaternion.multiplyToRef(this._deltaRotationConjugated, this.object.rotationQuaternion);
            this.object.computeWorldMatrix(false);
            if (this.object.parent && this.object.rotationQuaternion) {
                this.getParentsRotation();
                this._tmpQuat.multiplyToRef(this.object.rotationQuaternion, this._tmpQuat);
            } else this._tmpQuat.copyFrom(this.object.rotationQuaternion || new (0, $ha1VO.Quaternion)());
            if (!this._options.disableBidirectionalTransformation) this.object.rotationQuaternion && this._physicsEngine.getPhysicsPlugin().setPhysicsBodyTransformation(this, /*bInfo.boundingBox.centerWorld*/ this.object.getAbsolutePosition(), this._tmpQuat);
            this._onBeforePhysicsStepCallbacks.forEach((func)=>{
                func(this);
            });
        };
        /**
         * this function is executed by the physics engine
         */ this.afterStep = ()=>{
            if (!this._physicsEngine) return;
            this._onAfterPhysicsStepCallbacks.forEach((func)=>{
                func(this);
            });
            this._physicsEngine.getPhysicsPlugin().setTransformationFromPhysicsBody(this);
            // object has now its world rotation. needs to be converted to local.
            if (this.object.parent && this.object.rotationQuaternion) {
                this.getParentsRotation();
                this._tmpQuat.conjugateInPlace();
                this._tmpQuat.multiplyToRef(this.object.rotationQuaternion, this.object.rotationQuaternion);
            }
            // take the position set and make it the absolute position of this object.
            this.object.setAbsolutePosition(this.object.position);
            if (this._deltaRotation) {
                this.object.rotationQuaternion && this.object.rotationQuaternion.multiplyToRef(this._deltaRotation, this.object.rotationQuaternion);
                this._deltaPosition.applyRotationQuaternionToRef(this._deltaRotation, $d83e863443505adb$export$59bf337cc03816a9._TmpVecs[0]);
                this.object.translate($d83e863443505adb$export$59bf337cc03816a9._TmpVecs[0], 1);
            } else this.object.translate(this._deltaPosition, 1);
            this.object.computeWorldMatrix(true);
        };
        /**
         * Legacy collision detection event support
         */ this.onCollideEvent = null;
        /**
         *  define an onCollide function to call when this impostor collides against a different body
         * @param e collide event data
         */ this.onCollide = (e)=>{
            if (!this._onPhysicsCollideCallbacks.length && !this.onCollideEvent) return;
            if (!this._physicsEngine) return;
            const otherImpostor = this._physicsEngine.getImpostorWithPhysicsBody(e.body);
            if (otherImpostor) {
                // Legacy collision detection event support
                if (this.onCollideEvent) this.onCollideEvent(this, otherImpostor);
                this._onPhysicsCollideCallbacks.filter((obj)=>{
                    return obj.otherImpostors.indexOf(otherImpostor) !== -1;
                }).forEach((obj)=>{
                    obj.callback(this, otherImpostor, e.point, e.distance, e.impulse, e.normal);
                });
            }
        };
        //sanity check!
        if (!this.object) {
            (0, $kVtWi.Logger).Error("No object was provided. A physics object is obligatory");
            return;
        }
        if (this.object.parent && _options.mass !== 0) (0, $kVtWi.Logger).Warn("A physics impostor has been created for an object which has a parent. Babylon physics currently works in local space so unexpected issues may occur.");
        // Legacy support for old syntax.
        if (!this._scene && object.getScene) this._scene = object.getScene();
        if (!this._scene) return;
        if (this.type > 100) this.soft = true;
        this._physicsEngine = this._scene.getPhysicsEngine();
        if (!this._physicsEngine) (0, $kVtWi.Logger).Error("Physics not enabled. Please use scene.enablePhysics(...) before creating impostors.");
        else {
            //set the object's quaternion, if not set
            if (!this.object.rotationQuaternion) {
                if (this.object.rotation) this.object.rotationQuaternion = (0, $ha1VO.Quaternion).RotationYawPitchRoll(this.object.rotation.y, this.object.rotation.x, this.object.rotation.z);
                else this.object.rotationQuaternion = new (0, $ha1VO.Quaternion)();
            }
            //default options params
            this._options.mass = _options.mass === void 0 ? 0 : _options.mass;
            this._options.friction = _options.friction === void 0 ? 0.2 : _options.friction;
            this._options.restitution = _options.restitution === void 0 ? 0.2 : _options.restitution;
            if (this.soft) {
                //softbody mass must be above 0;
                this._options.mass = this._options.mass > 0 ? this._options.mass : 1;
                this._options.pressure = _options.pressure === void 0 ? 200 : _options.pressure;
                this._options.stiffness = _options.stiffness === void 0 ? 1 : _options.stiffness;
                this._options.velocityIterations = _options.velocityIterations === void 0 ? 20 : _options.velocityIterations;
                this._options.positionIterations = _options.positionIterations === void 0 ? 20 : _options.positionIterations;
                this._options.fixedPoints = _options.fixedPoints === void 0 ? 0 : _options.fixedPoints;
                this._options.margin = _options.margin === void 0 ? 0 : _options.margin;
                this._options.damping = _options.damping === void 0 ? 0 : _options.damping;
                this._options.path = _options.path === void 0 ? null : _options.path;
                this._options.shape = _options.shape === void 0 ? null : _options.shape;
            }
            this._joints = [];
            //If the mesh has a parent, don't initialize the physicsBody. Instead wait for the parent to do that.
            if (!this.object.parent || this._options.ignoreParent) this._init();
            else if (this.object.parent.physicsImpostor) (0, $kVtWi.Logger).Warn("You must affect impostors to children before affecting impostor to parent.");
        }
    }
    /**
     * This function will completely initialize this impostor.
     * It will create a new body - but only if this mesh has no parent.
     * If it has, this impostor will not be used other than to define the impostor
     * of the child mesh.
     * @internal
     */ _init() {
        if (!this._physicsEngine) return;
        this._physicsEngine.removeImpostor(this);
        this.physicsBody = null;
        this._parent = this._parent || this._getPhysicsParent();
        if (!this._isDisposed && (!this.parent || this._options.ignoreParent)) this._physicsEngine.addImpostor(this);
    }
    _getPhysicsParent() {
        if (this.object.parent instanceof (0, $0cHNL.AbstractMesh)) {
            const parentMesh = this.object.parent;
            return parentMesh.physicsImpostor;
        }
        return null;
    }
    /**
     * Should a new body be generated.
     * @returns boolean specifying if body initialization is required
     */ isBodyInitRequired() {
        return this._bodyUpdateRequired || !this._physicsBody && (!this._parent || !!this._options.ignoreParent);
    }
    /**
     * Sets the updated scaling
     */ setScalingUpdated() {
        this.forceUpdate();
    }
    /**
     * Force a regeneration of this or the parent's impostor's body.
     * Use with caution - This will remove all previously-instantiated joints.
     */ forceUpdate() {
        this._init();
        if (this.parent && !this._options.ignoreParent) this.parent.forceUpdate();
    }
    /*public get mesh(): AbstractMesh {
        return this._mesh;
    }*/ /**
     * Gets the body that holds this impostor. Either its own, or its parent.
     */ get physicsBody() {
        return this._parent && !this._options.ignoreParent ? this._parent.physicsBody : this._physicsBody;
    }
    /**
     * Get the parent of the physics imposter
     * @returns Physics imposter or null
     */ get parent() {
        return !this._options.ignoreParent && this._parent ? this._parent : null;
    }
    /**
     * Sets the parent of the physics imposter
     */ set parent(value) {
        this._parent = value;
    }
    /**
     * Set the physics body. Used mainly by the physics engine/plugin
     */ set physicsBody(physicsBody) {
        if (this._physicsBody && this._physicsEngine) this._physicsEngine.getPhysicsPlugin().removePhysicsBody(this);
        this._physicsBody = physicsBody;
        this.resetUpdateFlags();
    }
    /**
     * Resets the update flags
     */ resetUpdateFlags() {
        this._bodyUpdateRequired = false;
    }
    /**
     * Gets the object extents
     * @returns the object extents
     */ getObjectExtents() {
        if (this.object.getBoundingInfo) {
            const q = this.object.rotationQuaternion;
            const scaling = this.object.scaling.clone();
            //reset rotation
            this.object.rotationQuaternion = $d83e863443505adb$export$59bf337cc03816a9.IDENTITY_QUATERNION;
            //calculate the world matrix with no rotation
            const worldMatrix = this.object.computeWorldMatrix && this.object.computeWorldMatrix(true);
            if (worldMatrix) worldMatrix.decompose(scaling, undefined, undefined);
            const boundingInfo = this.object.getBoundingInfo();
            // get the global scaling of the object
            const size = boundingInfo.boundingBox.extendSize.scale(2).multiplyInPlace(scaling);
            size.x = Math.abs(size.x);
            size.y = Math.abs(size.y);
            size.z = Math.abs(size.z);
            //bring back the rotation
            this.object.rotationQuaternion = q;
            //calculate the world matrix with the new rotation
            this.object.computeWorldMatrix && this.object.computeWorldMatrix(true);
            return size;
        } else return $d83e863443505adb$export$59bf337cc03816a9.DEFAULT_OBJECT_SIZE;
    }
    /**
     * Gets the object center
     * @returns The object center
     */ getObjectCenter() {
        if (this.object.getBoundingInfo) {
            const boundingInfo = this.object.getBoundingInfo();
            return boundingInfo.boundingBox.centerWorld;
        } else return this.object.position;
    }
    /**
     * Get a specific parameter from the options parameters
     * @param paramName The object parameter name
     * @returns The object parameter
     */ getParam(paramName) {
        return this._options[paramName];
    }
    /**
     * Sets a specific parameter in the options given to the physics plugin
     * @param paramName The parameter name
     * @param value The value of the parameter
     */ setParam(paramName, value) {
        this._options[paramName] = value;
        this._bodyUpdateRequired = true;
    }
    /**
     * Specifically change the body's mass. Won't recreate the physics body object
     * @param mass The mass of the physics imposter
     */ setMass(mass) {
        if (this.getParam("mass") !== mass) this.setParam("mass", mass);
        if (this._physicsEngine) this._physicsEngine.getPhysicsPlugin().setBodyMass(this, mass);
    }
    /**
     * Gets the linear velocity
     * @returns  linear velocity or null
     */ getLinearVelocity() {
        return this._physicsEngine ? this._physicsEngine.getPhysicsPlugin().getLinearVelocity(this) : (0, $ha1VO.Vector3).Zero();
    }
    /**
     * Sets the linear velocity
     * @param velocity  linear velocity or null
     */ setLinearVelocity(velocity) {
        if (this._physicsEngine) this._physicsEngine.getPhysicsPlugin().setLinearVelocity(this, velocity);
    }
    /**
     * Gets the angular velocity
     * @returns angular velocity or null
     */ getAngularVelocity() {
        return this._physicsEngine ? this._physicsEngine.getPhysicsPlugin().getAngularVelocity(this) : (0, $ha1VO.Vector3).Zero();
    }
    /**
     * Sets the angular velocity
     * @param velocity The velocity or null
     */ setAngularVelocity(velocity) {
        if (this._physicsEngine) this._physicsEngine.getPhysicsPlugin().setAngularVelocity(this, velocity);
    }
    /**
     * Execute a function with the physics plugin native code
     * Provide a function the will have two variables - the world object and the physics body object
     * @param func The function to execute with the physics plugin native code
     */ executeNativeFunction(func) {
        if (this._physicsEngine) func(this._physicsEngine.getPhysicsPlugin().world, this.physicsBody);
    }
    /**
     * Register a function that will be executed before the physics world is stepping forward
     * @param func The function to execute before the physics world is stepped forward
     */ registerBeforePhysicsStep(func) {
        this._onBeforePhysicsStepCallbacks.push(func);
    }
    /**
     * Unregister a function that will be executed before the physics world is stepping forward
     * @param func The function to execute before the physics world is stepped forward
     */ unregisterBeforePhysicsStep(func) {
        const index = this._onBeforePhysicsStepCallbacks.indexOf(func);
        if (index > -1) this._onBeforePhysicsStepCallbacks.splice(index, 1);
        else (0, $kVtWi.Logger).Warn("Function to remove was not found");
    }
    /**
     * Register a function that will be executed after the physics step
     * @param func The function to execute after physics step
     */ registerAfterPhysicsStep(func) {
        this._onAfterPhysicsStepCallbacks.push(func);
    }
    /**
     * Unregisters a function that will be executed after the physics step
     * @param func The function to execute after physics step
     */ unregisterAfterPhysicsStep(func) {
        const index = this._onAfterPhysicsStepCallbacks.indexOf(func);
        if (index > -1) this._onAfterPhysicsStepCallbacks.splice(index, 1);
        else (0, $kVtWi.Logger).Warn("Function to remove was not found");
    }
    /**
     * register a function that will be executed when this impostor collides against a different body
     * @param collideAgainst Physics imposter, or array of physics imposters to collide against
     * @param func Callback that is executed on collision
     */ registerOnPhysicsCollide(collideAgainst, func) {
        const collidedAgainstList = collideAgainst instanceof Array ? collideAgainst : [
            collideAgainst
        ];
        this._onPhysicsCollideCallbacks.push({
            callback: func,
            otherImpostors: collidedAgainstList
        });
    }
    /**
     * Unregisters the physics imposter's collision callback
     * @param collideAgainst The physics object to collide against
     * @param func Callback to execute on collision
     */ unregisterOnPhysicsCollide(collideAgainst, func) {
        const collidedAgainstList = collideAgainst instanceof Array ? collideAgainst : [
            collideAgainst
        ];
        let index = -1;
        const found = this._onPhysicsCollideCallbacks.some((cbDef, idx)=>{
            if (cbDef.callback === func && cbDef.otherImpostors.length === collidedAgainstList.length) {
                // chcek the arrays match
                const sameList = cbDef.otherImpostors.every((impostor)=>{
                    return collidedAgainstList.indexOf(impostor) > -1;
                });
                if (sameList) index = idx;
                return sameList;
            }
            return false;
        });
        if (found) this._onPhysicsCollideCallbacks.splice(index, 1);
        else (0, $kVtWi.Logger).Warn("Function to remove was not found");
    }
    /**
     * Get the parent rotation
     * @returns The parent rotation
     */ getParentsRotation() {
        let parent = this.object.parent;
        this._tmpQuat.copyFromFloats(0, 0, 0, 1);
        while(parent){
            if (parent.rotationQuaternion) this._tmpQuat2.copyFrom(parent.rotationQuaternion);
            else (0, $ha1VO.Quaternion).RotationYawPitchRollToRef(parent.rotation.y, parent.rotation.x, parent.rotation.z, this._tmpQuat2);
            this._tmpQuat.multiplyToRef(this._tmpQuat2, this._tmpQuat);
            parent = parent.parent;
        }
        return this._tmpQuat;
    }
    /**
     * Apply a force
     * @param force The force to apply
     * @param contactPoint The contact point for the force
     * @returns The physics imposter
     */ applyForce(force, contactPoint) {
        if (this._physicsEngine) this._physicsEngine.getPhysicsPlugin().applyForce(this, force, contactPoint);
        return this;
    }
    /**
     * Apply an impulse
     * @param force The impulse force
     * @param contactPoint The contact point for the impulse force
     * @returns The physics imposter
     */ applyImpulse(force, contactPoint) {
        if (this._physicsEngine) this._physicsEngine.getPhysicsPlugin().applyImpulse(this, force, contactPoint);
        return this;
    }
    /**
     * A help function to create a joint
     * @param otherImpostor A physics imposter used to create a joint
     * @param jointType The type of joint
     * @param jointData The data for the joint
     * @returns The physics imposter
     */ createJoint(otherImpostor, jointType, jointData) {
        const joint = new (0, $kGTHw.PhysicsJoint)(jointType, jointData);
        this.addJoint(otherImpostor, joint);
        return this;
    }
    /**
     * Add a joint to this impostor with a different impostor
     * @param otherImpostor A physics imposter used to add a joint
     * @param joint The joint to add
     * @returns The physics imposter
     */ addJoint(otherImpostor, joint) {
        this._joints.push({
            otherImpostor: otherImpostor,
            joint: joint
        });
        if (this._physicsEngine) this._physicsEngine.addJoint(this, otherImpostor, joint);
        return this;
    }
    /**
     * Add an anchor to a cloth impostor
     * @param otherImpostor rigid impostor to anchor to
     * @param width ratio across width from 0 to 1
     * @param height ratio up height from 0 to 1
     * @param influence the elasticity between cloth impostor and anchor from 0, very stretchy to 1, little stretch
     * @param noCollisionBetweenLinkedBodies when true collisions between cloth impostor and anchor are ignored; default false
     * @returns impostor the soft imposter
     */ addAnchor(otherImpostor, width, height, influence, noCollisionBetweenLinkedBodies) {
        if (!this._physicsEngine) return this;
        const plugin = this._physicsEngine.getPhysicsPlugin();
        if (!plugin.appendAnchor) return this;
        if (this._physicsEngine) plugin.appendAnchor(this, otherImpostor, width, height, influence, noCollisionBetweenLinkedBodies);
        return this;
    }
    /**
     * Add a hook to a rope impostor
     * @param otherImpostor rigid impostor to anchor to
     * @param length ratio across rope from 0 to 1
     * @param influence the elasticity between rope impostor and anchor from 0, very stretchy to 1, little stretch
     * @param noCollisionBetweenLinkedBodies when true collisions between soft impostor and anchor are ignored; default false
     * @returns impostor the rope imposter
     */ addHook(otherImpostor, length, influence, noCollisionBetweenLinkedBodies) {
        if (!this._physicsEngine) return this;
        const plugin = this._physicsEngine.getPhysicsPlugin();
        if (!plugin.appendAnchor) return this;
        if (this._physicsEngine) plugin.appendHook(this, otherImpostor, length, influence, noCollisionBetweenLinkedBodies);
        return this;
    }
    /**
     * Will keep this body still, in a sleep mode.
     * @returns the physics imposter
     */ sleep() {
        if (this._physicsEngine) this._physicsEngine.getPhysicsPlugin().sleepBody(this);
        return this;
    }
    /**
     * Wake the body up.
     * @returns The physics imposter
     */ wakeUp() {
        if (this._physicsEngine) this._physicsEngine.getPhysicsPlugin().wakeUpBody(this);
        return this;
    }
    /**
     * Clones the physics imposter
     * @param newObject The physics imposter clones to this physics-enabled object
     * @returns A nullable physics imposter
     */ clone(newObject) {
        if (!newObject) return null;
        return new $d83e863443505adb$export$59bf337cc03816a9(newObject, this.type, this._options, this._scene);
    }
    /**
     * Disposes the physics imposter
     */ dispose() {
        //no dispose if no physics engine is available.
        if (!this._physicsEngine) return;
        this._joints.forEach((j)=>{
            if (this._physicsEngine) this._physicsEngine.removeJoint(this, j.otherImpostor, j.joint);
        });
        //dispose the physics body
        this._physicsEngine.removeImpostor(this);
        if (this.parent) this.parent.forceUpdate();
        this._isDisposed = true;
    }
    /**
     * Sets the delta position
     * @param position The delta position amount
     */ setDeltaPosition(position) {
        this._deltaPosition.copyFrom(position);
    }
    /**
     * Sets the delta rotation
     * @param rotation The delta rotation amount
     */ setDeltaRotation(rotation) {
        if (!this._deltaRotation) this._deltaRotation = new (0, $ha1VO.Quaternion)();
        this._deltaRotation.copyFrom(rotation);
        this._deltaRotationConjugated = this._deltaRotation.conjugate();
    }
    /**
     * Gets the box size of the physics imposter and stores the result in the input parameter
     * @param result Stores the box size
     * @returns The physics imposter
     */ getBoxSizeToRef(result) {
        if (this._physicsEngine) this._physicsEngine.getPhysicsPlugin().getBoxSizeToRef(this, result);
        return this;
    }
    /**
     * Gets the radius of the physics imposter
     * @returns Radius of the physics imposter
     */ getRadius() {
        return this._physicsEngine ? this._physicsEngine.getPhysicsPlugin().getRadius(this) : 0;
    }
    /**
     * Sync a bone with this impostor
     * @param bone The bone to sync to the impostor.
     * @param boneMesh The mesh that the bone is influencing.
     * @param jointPivot The pivot of the joint / bone in local space.
     * @param distToJoint Optional distance from the impostor to the joint.
     * @param adjustRotation Optional quaternion for adjusting the local rotation of the bone.
     */ syncBoneWithImpostor(bone, boneMesh, jointPivot, distToJoint, adjustRotation) {
        const tempVec = $d83e863443505adb$export$59bf337cc03816a9._TmpVecs[0];
        const mesh = this.object;
        if (mesh.rotationQuaternion) {
            if (adjustRotation) {
                const tempQuat = $d83e863443505adb$export$59bf337cc03816a9._TmpQuat;
                mesh.rotationQuaternion.multiplyToRef(adjustRotation, tempQuat);
                bone.setRotationQuaternion(tempQuat, (0, $dbxbu.Space).WORLD, boneMesh);
            } else bone.setRotationQuaternion(mesh.rotationQuaternion, (0, $dbxbu.Space).WORLD, boneMesh);
        }
        tempVec.x = 0;
        tempVec.y = 0;
        tempVec.z = 0;
        if (jointPivot) {
            tempVec.x = jointPivot.x;
            tempVec.y = jointPivot.y;
            tempVec.z = jointPivot.z;
            bone.getDirectionToRef(tempVec, boneMesh, tempVec);
            if (distToJoint === undefined || distToJoint === null) distToJoint = jointPivot.length();
            tempVec.x *= distToJoint;
            tempVec.y *= distToJoint;
            tempVec.z *= distToJoint;
        }
        if (bone.getParent()) {
            tempVec.addInPlace(mesh.getAbsolutePosition());
            bone.setAbsolutePosition(tempVec, boneMesh);
        } else {
            boneMesh.setAbsolutePosition(mesh.getAbsolutePosition());
            boneMesh.position.x -= tempVec.x;
            boneMesh.position.y -= tempVec.y;
            boneMesh.position.z -= tempVec.z;
        }
    }
    /**
     * Sync impostor to a bone
     * @param bone The bone that the impostor will be synced to.
     * @param boneMesh The mesh that the bone is influencing.
     * @param jointPivot The pivot of the joint / bone in local space.
     * @param distToJoint Optional distance from the impostor to the joint.
     * @param adjustRotation Optional quaternion for adjusting the local rotation of the bone.
     * @param boneAxis Optional vector3 axis the bone is aligned with
     */ syncImpostorWithBone(bone, boneMesh, jointPivot, distToJoint, adjustRotation, boneAxis) {
        const mesh = this.object;
        if (mesh.rotationQuaternion) {
            if (adjustRotation) {
                const tempQuat = $d83e863443505adb$export$59bf337cc03816a9._TmpQuat;
                bone.getRotationQuaternionToRef((0, $dbxbu.Space).WORLD, boneMesh, tempQuat);
                tempQuat.multiplyToRef(adjustRotation, mesh.rotationQuaternion);
            } else bone.getRotationQuaternionToRef((0, $dbxbu.Space).WORLD, boneMesh, mesh.rotationQuaternion);
        }
        const pos = $d83e863443505adb$export$59bf337cc03816a9._TmpVecs[0];
        const boneDir = $d83e863443505adb$export$59bf337cc03816a9._TmpVecs[1];
        if (!boneAxis) {
            boneAxis = $d83e863443505adb$export$59bf337cc03816a9._TmpVecs[2];
            boneAxis.x = 0;
            boneAxis.y = 1;
            boneAxis.z = 0;
        }
        bone.getDirectionToRef(boneAxis, boneMesh, boneDir);
        bone.getAbsolutePositionToRef(boneMesh, pos);
        if ((distToJoint === undefined || distToJoint === null) && jointPivot) distToJoint = jointPivot.length();
        if (distToJoint !== undefined && distToJoint !== null) {
            pos.x += boneDir.x * distToJoint;
            pos.y += boneDir.y * distToJoint;
            pos.z += boneDir.z * distToJoint;
        }
        mesh.setAbsolutePosition(pos);
    }
}
/**
 * The default object size of the imposter
 */ $d83e863443505adb$export$59bf337cc03816a9.DEFAULT_OBJECT_SIZE = new (0, $ha1VO.Vector3)(1, 1, 1);
/**
 * The identity quaternion of the imposter
 */ $d83e863443505adb$export$59bf337cc03816a9.IDENTITY_QUATERNION = (0, $ha1VO.Quaternion).Identity();
$d83e863443505adb$export$59bf337cc03816a9._TmpVecs = (0, $opFp4.ArrayTools).BuildArray(3, (0, $ha1VO.Vector3).Zero);
$d83e863443505adb$export$59bf337cc03816a9._TmpQuat = (0, $ha1VO.Quaternion).Identity();
//Impostor types
/**
 * No-Imposter type
 */ $d83e863443505adb$export$59bf337cc03816a9.NoImpostor = 0;
/**
 * Sphere-Imposter type
 */ $d83e863443505adb$export$59bf337cc03816a9.SphereImpostor = 1;
/**
 * Box-Imposter type
 */ $d83e863443505adb$export$59bf337cc03816a9.BoxImpostor = 2;
/**
 * Plane-Imposter type
 */ $d83e863443505adb$export$59bf337cc03816a9.PlaneImpostor = 3;
/**
 * Mesh-imposter type (Only available to objects with vertices data)
 */ $d83e863443505adb$export$59bf337cc03816a9.MeshImpostor = 4;
/**
 * Capsule-Impostor type (Ammo.js plugin only)
 */ $d83e863443505adb$export$59bf337cc03816a9.CapsuleImpostor = 6;
/**
 * Cylinder-Imposter type
 */ $d83e863443505adb$export$59bf337cc03816a9.CylinderImpostor = 7;
/**
 * Particle-Imposter type
 */ $d83e863443505adb$export$59bf337cc03816a9.ParticleImpostor = 8;
/**
 * Heightmap-Imposter type
 */ $d83e863443505adb$export$59bf337cc03816a9.HeightmapImpostor = 9;
/**
 * ConvexHull-Impostor type (Ammo.js plugin only)
 */ $d83e863443505adb$export$59bf337cc03816a9.ConvexHullImpostor = 10;
/**
 * Custom-Imposter type (Ammo.js plugin only)
 */ $d83e863443505adb$export$59bf337cc03816a9.CustomImpostor = 100;
/**
 * Rope-Imposter type
 */ $d83e863443505adb$export$59bf337cc03816a9.RopeImpostor = 101;
/**
 * Cloth-Imposter type
 */ $d83e863443505adb$export$59bf337cc03816a9.ClothImpostor = 102;
/**
 * Softbody-Imposter type
 */ $d83e863443505adb$export$59bf337cc03816a9.SoftbodyImpostor = 103;

});
parcelRegister("kGTHw", function(module, exports) {

$parcel$export(module.exports, "PhysicsJoint", () => $f102eff2d417414e$export$eaa3839683557516);
$parcel$export(module.exports, "DistanceJoint", () => $f102eff2d417414e$export$56a1a4f0f40bb678);
$parcel$export(module.exports, "MotorEnabledJoint", () => $f102eff2d417414e$export$d1e5d14e11d9d999);
$parcel$export(module.exports, "HingeJoint", () => $f102eff2d417414e$export$fd220d773d18b3f5);
$parcel$export(module.exports, "Hinge2Joint", () => $f102eff2d417414e$export$5a72cb7f92095c3c);
/**
 * This is a holder class for the physics joint created by the physics plugin
 * It holds a set of functions to control the underlying joint
 * @see https://doc.babylonjs.com/features/featuresDeepDive/physics/usingPhysicsEngine
 */ class $f102eff2d417414e$export$eaa3839683557516 {
    /**
     * Initializes the physics joint
     * @param type The type of the physics joint
     * @param jointData The data for the physics joint
     */ constructor(/**
     * The type of the physics joint
     */ type, /**
     * The data for the physics joint
     */ jointData){
        this.type = type;
        this.jointData = jointData;
        jointData.nativeParams = jointData.nativeParams || {};
    }
    /**
     * Gets the physics joint
     */ get physicsJoint() {
        return this._physicsJoint;
    }
    /**
     * Sets the physics joint
     */ set physicsJoint(newJoint) {
        this._physicsJoint;
        this._physicsJoint = newJoint;
    }
    /**
     * Sets the physics plugin
     */ set physicsPlugin(physicsPlugin) {
        this._physicsPlugin = physicsPlugin;
    }
    /**
     * Execute a function that is physics-plugin specific.
     * @param {Function} func the function that will be executed.
     *                        It accepts two parameters: the physics world and the physics joint
     */ executeNativeFunction(func) {
        func(this._physicsPlugin.world, this._physicsJoint);
    }
}
//TODO check if the native joints are the same
//Joint Types
/**
 * Distance-Joint type
 */ $f102eff2d417414e$export$eaa3839683557516.DistanceJoint = 0;
/**
 * Hinge-Joint type
 */ $f102eff2d417414e$export$eaa3839683557516.HingeJoint = 1;
/**
 * Ball-and-Socket joint type
 */ $f102eff2d417414e$export$eaa3839683557516.BallAndSocketJoint = 2;
/**
 * Wheel-Joint type
 */ $f102eff2d417414e$export$eaa3839683557516.WheelJoint = 3;
/**
 * Slider-Joint type
 */ $f102eff2d417414e$export$eaa3839683557516.SliderJoint = 4;
//OIMO
/**
 * Prismatic-Joint type
 */ $f102eff2d417414e$export$eaa3839683557516.PrismaticJoint = 5;
//
/**
 * Universal-Joint type
 * ENERGY FTW! (compare with this - @see http://ode-wiki.org/wiki/index.php?title=Manual:_Joint_Types_and_Functions)
 */ $f102eff2d417414e$export$eaa3839683557516.UniversalJoint = 6;
/**
 * Hinge-Joint 2 type
 */ $f102eff2d417414e$export$eaa3839683557516.Hinge2Joint = $f102eff2d417414e$export$eaa3839683557516.WheelJoint;
//Cannon
/**
 * Point to Point Joint type.  Similar to a Ball-Joint.  Different in parameters
 */ $f102eff2d417414e$export$eaa3839683557516.PointToPointJoint = 8;
//Cannon only at the moment
/**
 * Spring-Joint type
 */ $f102eff2d417414e$export$eaa3839683557516.SpringJoint = 9;
/**
 * Lock-Joint type
 */ $f102eff2d417414e$export$eaa3839683557516.LockJoint = 10;
class $f102eff2d417414e$export$56a1a4f0f40bb678 extends $f102eff2d417414e$export$eaa3839683557516 {
    /**
     *
     * @param jointData The data for the Distance-Joint
     */ constructor(jointData){
        super($f102eff2d417414e$export$eaa3839683557516.DistanceJoint, jointData);
    }
    /**
     * Update the predefined distance.
     * @param maxDistance The maximum preferred distance
     * @param minDistance The minimum preferred distance
     */ updateDistance(maxDistance, minDistance) {
        this._physicsPlugin.updateDistanceJoint(this, maxDistance, minDistance);
    }
}
class $f102eff2d417414e$export$d1e5d14e11d9d999 extends $f102eff2d417414e$export$eaa3839683557516 {
    /**
     * Initializes the Motor-Enabled Joint
     * @param type The type of the joint
     * @param jointData The physical joint data for the joint
     */ constructor(type, jointData){
        super(type, jointData);
    }
    /**
     * Set the motor values.
     * Attention, this function is plugin specific. Engines won't react 100% the same.
     * @param force the force to apply
     * @param maxForce max force for this motor.
     */ setMotor(force, maxForce) {
        this._physicsPlugin.setMotor(this, force || 0, maxForce);
    }
    /**
     * Set the motor's limits.
     * Attention, this function is plugin specific. Engines won't react 100% the same.
     * @param upperLimit The upper limit of the motor
     * @param lowerLimit The lower limit of the motor
     */ setLimit(upperLimit, lowerLimit) {
        this._physicsPlugin.setLimit(this, upperLimit, lowerLimit);
    }
}
class $f102eff2d417414e$export$fd220d773d18b3f5 extends $f102eff2d417414e$export$d1e5d14e11d9d999 {
    /**
     * Initializes the Hinge-Joint
     * @param jointData The joint data for the Hinge-Joint
     */ constructor(jointData){
        super($f102eff2d417414e$export$eaa3839683557516.HingeJoint, jointData);
    }
    /**
     * Set the motor values.
     * Attention, this function is plugin specific. Engines won't react 100% the same.
     * @param {number} force the force to apply
     * @param {number} maxForce max force for this motor.
     */ setMotor(force, maxForce) {
        this._physicsPlugin.setMotor(this, force || 0, maxForce);
    }
    /**
     * Set the motor's limits.
     * Attention, this function is plugin specific. Engines won't react 100% the same.
     * @param upperLimit The upper limit of the motor
     * @param lowerLimit The lower limit of the motor
     */ setLimit(upperLimit, lowerLimit) {
        this._physicsPlugin.setLimit(this, upperLimit, lowerLimit);
    }
}
class $f102eff2d417414e$export$5a72cb7f92095c3c extends $f102eff2d417414e$export$d1e5d14e11d9d999 {
    /**
     * Initializes the Hinge2-Joint
     * @param jointData The joint data for the Hinge2-Joint
     */ constructor(jointData){
        super($f102eff2d417414e$export$eaa3839683557516.Hinge2Joint, jointData);
    }
    /**
     * Set the motor values.
     * Attention, this function is plugin specific. Engines won't react 100% the same.
     * @param targetSpeed the speed the motor is to reach
     * @param maxForce max force for this motor.
     * @param motorIndex motor's index, 0 or 1.
     */ setMotor(targetSpeed, maxForce, motorIndex = 0) {
        this._physicsPlugin.setMotor(this, targetSpeed || 0, maxForce, motorIndex);
    }
    /**
     * Set the motor limits.
     * Attention, this function is plugin specific. Engines won't react 100% the same.
     * @param upperLimit the upper limit
     * @param lowerLimit lower limit
     * @param motorIndex the motor's index, 0 or 1.
     */ setLimit(upperLimit, lowerLimit, motorIndex = 0) {
        this._physicsPlugin.setLimit(this, upperLimit, lowerLimit, motorIndex);
    }
}

});


parcelRegister("agoTA", function(module, exports) {

$parcel$export(module.exports, "SceneLoaderAnimationGroupLoadingMode", () => $778eb5b99c1bda64$export$ea6abc4fb7b9984f);
$parcel$export(module.exports, "SceneLoader", () => $778eb5b99c1bda64$export$df9e0282cad33838);

var $bOhSV = parcelRequire("bOhSV");

var $diGQf = parcelRequire("diGQf");

var $gmbCk = parcelRequire("gmbCk");

var $5YkyR = parcelRequire("5YkyR");

var $ejQPp = parcelRequire("ejQPp");

var $kVtWi = parcelRequire("kVtWi");

var $kixW2 = parcelRequire("kixW2");

var $EOxw7 = parcelRequire("EOxw7");

var $1FkG9 = parcelRequire("1FkG9");

var $321Uk = parcelRequire("321Uk");
var $778eb5b99c1bda64$export$ea6abc4fb7b9984f;
(function(SceneLoaderAnimationGroupLoadingMode) {
    /**
     * Reset all old animations to initial state then dispose them.
     */ SceneLoaderAnimationGroupLoadingMode[SceneLoaderAnimationGroupLoadingMode["Clean"] = 0] = "Clean";
    /**
     * Stop all old animations.
     */ SceneLoaderAnimationGroupLoadingMode[SceneLoaderAnimationGroupLoadingMode["Stop"] = 1] = "Stop";
    /**
     * Restart old animations from first frame.
     */ SceneLoaderAnimationGroupLoadingMode[SceneLoaderAnimationGroupLoadingMode["Sync"] = 2] = "Sync";
    /**
     * Old animations remains untouched.
     */ SceneLoaderAnimationGroupLoadingMode[SceneLoaderAnimationGroupLoadingMode["NoSync"] = 3] = "NoSync";
})($778eb5b99c1bda64$export$ea6abc4fb7b9984f || ($778eb5b99c1bda64$export$ea6abc4fb7b9984f = {}));
class $778eb5b99c1bda64$export$df9e0282cad33838 {
    /**
     * Gets or sets a boolean indicating if entire scene must be loaded even if scene contains incremental data
     */ static get ForceFullSceneLoadingForIncremental() {
        return (0, $kixW2.SceneLoaderFlags).ForceFullSceneLoadingForIncremental;
    }
    static set ForceFullSceneLoadingForIncremental(value) {
        (0, $kixW2.SceneLoaderFlags).ForceFullSceneLoadingForIncremental = value;
    }
    /**
     * Gets or sets a boolean indicating if loading screen must be displayed while loading a scene
     */ static get ShowLoadingScreen() {
        return (0, $kixW2.SceneLoaderFlags).ShowLoadingScreen;
    }
    static set ShowLoadingScreen(value) {
        (0, $kixW2.SceneLoaderFlags).ShowLoadingScreen = value;
    }
    /**
     * Defines the current logging level (while loading the scene)
     * @ignorenaming
     */ // eslint-disable-next-line @typescript-eslint/naming-convention
    static get loggingLevel() {
        return (0, $kixW2.SceneLoaderFlags).loggingLevel;
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    static set loggingLevel(value) {
        (0, $kixW2.SceneLoaderFlags).loggingLevel = value;
    }
    /**
     * Gets or set a boolean indicating if matrix weights must be cleaned upon loading
     */ static get CleanBoneMatrixWeights() {
        return (0, $kixW2.SceneLoaderFlags).CleanBoneMatrixWeights;
    }
    static set CleanBoneMatrixWeights(value) {
        (0, $kixW2.SceneLoaderFlags).CleanBoneMatrixWeights = value;
    }
    /**
     * Gets the default plugin (used to load Babylon files)
     * @returns the .babylon plugin
     */ static GetDefaultPlugin() {
        return $778eb5b99c1bda64$export$df9e0282cad33838._RegisteredPlugins[".babylon"];
    }
    static _GetPluginForExtension(extension) {
        const registeredPlugin = $778eb5b99c1bda64$export$df9e0282cad33838._RegisteredPlugins[extension];
        if (registeredPlugin) return registeredPlugin;
        (0, $kVtWi.Logger).Warn("Unable to find a plugin to load " + extension + " files. Trying to use .babylon default plugin. To load from a specific filetype (eg. gltf) see: https://doc.babylonjs.com/features/featuresDeepDive/importers/loadingFileTypes");
        return $778eb5b99c1bda64$export$df9e0282cad33838.GetDefaultPlugin();
    }
    static _GetPluginForDirectLoad(data) {
        for(const extension in $778eb5b99c1bda64$export$df9e0282cad33838._RegisteredPlugins){
            const plugin = $778eb5b99c1bda64$export$df9e0282cad33838._RegisteredPlugins[extension].plugin;
            if (plugin.canDirectLoad && plugin.canDirectLoad(data)) return $778eb5b99c1bda64$export$df9e0282cad33838._RegisteredPlugins[extension];
        }
        return $778eb5b99c1bda64$export$df9e0282cad33838.GetDefaultPlugin();
    }
    static _GetPluginForFilename(sceneFilename) {
        const queryStringPosition = sceneFilename.indexOf("?");
        if (queryStringPosition !== -1) sceneFilename = sceneFilename.substring(0, queryStringPosition);
        const dotPosition = sceneFilename.lastIndexOf(".");
        const extension = sceneFilename.substring(dotPosition, sceneFilename.length).toLowerCase();
        return $778eb5b99c1bda64$export$df9e0282cad33838._GetPluginForExtension(extension);
    }
    static _GetDirectLoad(sceneFilename) {
        if (sceneFilename.substr(0, 5) === "data:") return sceneFilename.substr(5);
        return null;
    }
    static _FormatErrorMessage(fileInfo, message, exception) {
        const fromLoad = fileInfo.rawData ? "binary data" : fileInfo.url;
        let errorMessage = "Unable to load from " + fromLoad;
        if (message) errorMessage += `: ${message}`;
        else if (exception) errorMessage += `: ${exception}`;
        return errorMessage;
    }
    static _LoadData(fileInfo, scene, onSuccess, onProgress, onError, onDispose, pluginExtension, name) {
        const directLoad = $778eb5b99c1bda64$export$df9e0282cad33838._GetDirectLoad(fileInfo.url);
        if (fileInfo.rawData && !pluginExtension) // eslint-disable-next-line no-throw-literal
        throw "When using ArrayBufferView to load data the file extension must be provided.";
        const registeredPlugin = pluginExtension ? $778eb5b99c1bda64$export$df9e0282cad33838._GetPluginForExtension(pluginExtension) : directLoad ? $778eb5b99c1bda64$export$df9e0282cad33838._GetPluginForDirectLoad(fileInfo.url) : $778eb5b99c1bda64$export$df9e0282cad33838._GetPluginForFilename(fileInfo.url);
        if (fileInfo.rawData && !registeredPlugin.isBinary) // eslint-disable-next-line no-throw-literal
        throw "Loading from ArrayBufferView can not be used with plugins that don't support binary loading.";
        let plugin;
        if (registeredPlugin.plugin.createPlugin !== undefined) plugin = registeredPlugin.plugin.createPlugin();
        else plugin = registeredPlugin.plugin;
        if (!plugin) // eslint-disable-next-line no-throw-literal
        throw "The loader plugin corresponding to the file type you are trying to load has not been found. If using es6, please import the plugin you wish to use before.";
        $778eb5b99c1bda64$export$df9e0282cad33838.OnPluginActivatedObservable.notifyObservers(plugin);
        // Check if we have a direct load url. If the plugin is registered to handle
        // it or it's not a base64 data url, then pass it through the direct load path.
        if (directLoad && (plugin.canDirectLoad && plugin.canDirectLoad(fileInfo.url) || !(0, $EOxw7.IsBase64DataUrl)(fileInfo.url))) {
            if (plugin.directLoad) {
                const result = plugin.directLoad(scene, directLoad);
                if (result.then) result.then((data)=>{
                    onSuccess(plugin, data);
                }).catch((error)=>{
                    onError("Error in directLoad of _loadData: " + error, error);
                });
                else onSuccess(plugin, result);
            } else onSuccess(plugin, directLoad);
            return plugin;
        }
        const useArrayBuffer = registeredPlugin.isBinary;
        const dataCallback = (data, responseURL)=>{
            if (scene.isDisposed) {
                onError("Scene has been disposed");
                return;
            }
            onSuccess(plugin, data, responseURL);
        };
        let request = null;
        let pluginDisposed = false;
        const onDisposeObservable = plugin.onDisposeObservable;
        if (onDisposeObservable) onDisposeObservable.add(()=>{
            pluginDisposed = true;
            if (request) {
                request.abort();
                request = null;
            }
            onDispose();
        });
        const manifestChecked = ()=>{
            if (pluginDisposed) return;
            const errorCallback = (request, exception)=>{
                onError(request?.statusText, exception);
            };
            if (!plugin.loadFile && fileInfo.rawData) // eslint-disable-next-line no-throw-literal
            throw "Plugin does not support loading ArrayBufferView.";
            request = plugin.loadFile ? plugin.loadFile(scene, fileInfo.rawData || fileInfo.file || fileInfo.url, fileInfo.rootUrl, dataCallback, onProgress, useArrayBuffer, errorCallback, name) : scene._loadFile(fileInfo.file || fileInfo.url, dataCallback, onProgress, true, useArrayBuffer, errorCallback);
        };
        const engine = scene.getEngine();
        let canUseOfflineSupport = engine.enableOfflineSupport;
        if (canUseOfflineSupport) {
            // Also check for exceptions
            let exceptionFound = false;
            for (const regex of scene.disableOfflineSupportExceptionRules)if (regex.test(fileInfo.url)) {
                exceptionFound = true;
                break;
            }
            canUseOfflineSupport = !exceptionFound;
        }
        if (canUseOfflineSupport && (0, $5YkyR.Engine).OfflineProviderFactory) // Checking if a manifest file has been set for this scene and if offline mode has been requested
        scene.offlineProvider = (0, $5YkyR.Engine).OfflineProviderFactory(fileInfo.url, manifestChecked, engine.disableManifestCheck);
        else manifestChecked();
        return plugin;
    }
    static _GetFileInfo(rootUrl, sceneFilename) {
        let url;
        let name;
        let file = null;
        let rawData = null;
        if (!sceneFilename) {
            url = rootUrl;
            name = (0, $bOhSV.Tools).GetFilename(rootUrl);
            rootUrl = (0, $bOhSV.Tools).GetFolderPath(rootUrl);
        } else if (sceneFilename.name) {
            const sceneFile = sceneFilename;
            url = `file:${sceneFile.name}`;
            name = sceneFile.name;
            file = sceneFile;
        } else if (ArrayBuffer.isView(sceneFilename)) {
            url = "";
            name = (0, $321Uk.RandomGUID)();
            rawData = sceneFilename;
        } else if (typeof sceneFilename === "string" && sceneFilename.startsWith("data:")) {
            url = sceneFilename;
            name = "";
        } else {
            const filename = sceneFilename;
            if (filename.substr(0, 1) === "/") {
                (0, $bOhSV.Tools).Error("Wrong sceneFilename parameter");
                return null;
            }
            url = rootUrl + filename;
            name = filename;
        }
        return {
            url: url,
            rootUrl: rootUrl,
            name: name,
            file: file,
            rawData: rawData
        };
    }
    // Public functions
    /**
     * Gets a plugin that can load the given extension
     * @param extension defines the extension to load
     * @returns a plugin or null if none works
     */ static GetPluginForExtension(extension) {
        return $778eb5b99c1bda64$export$df9e0282cad33838._GetPluginForExtension(extension).plugin;
    }
    /**
     * Gets a boolean indicating that the given extension can be loaded
     * @param extension defines the extension to load
     * @returns true if the extension is supported
     */ static IsPluginForExtensionAvailable(extension) {
        return !!$778eb5b99c1bda64$export$df9e0282cad33838._RegisteredPlugins[extension];
    }
    /**
     * Adds a new plugin to the list of registered plugins
     * @param plugin defines the plugin to add
     */ static RegisterPlugin(plugin) {
        if (typeof plugin.extensions === "string") {
            const extension = plugin.extensions;
            $778eb5b99c1bda64$export$df9e0282cad33838._RegisteredPlugins[extension.toLowerCase()] = {
                plugin: plugin,
                isBinary: false
            };
        } else {
            const extensions = plugin.extensions;
            Object.keys(extensions).forEach((extension)=>{
                $778eb5b99c1bda64$export$df9e0282cad33838._RegisteredPlugins[extension.toLowerCase()] = {
                    plugin: plugin,
                    isBinary: extensions[extension].isBinary
                };
            });
        }
    }
    /**
     * Import meshes into a scene
     * @param meshNames an array of mesh names, a single mesh name, or empty string for all meshes that filter what meshes are imported
     * @param rootUrl a string that defines the root url for the scene and resources or the concatenation of rootURL and filename (e.g. http://example.com/test.glb)
     * @param sceneFilename a string that defines the name of the scene file or starts with "data:" following by the stringified version of the scene or a File object (default: empty string)
     * @param scene the instance of BABYLON.Scene to append to
     * @param onSuccess a callback with a list of imported meshes, particleSystems, skeletons, and animationGroups when import succeeds
     * @param onProgress a callback with a progress event for each file being loaded
     * @param onError a callback with the scene, a message, and possibly an exception when import fails
     * @param pluginExtension the extension used to determine the plugin
     * @param name defines the name of the file, if the data is binary
     * @returns The loaded plugin
     */ static ImportMesh(meshNames, rootUrl, sceneFilename = "", scene = (0, $ejQPp.EngineStore).LastCreatedScene, onSuccess = null, onProgress = null, onError = null, pluginExtension = null, name = "") {
        if (!scene) {
            (0, $kVtWi.Logger).Error("No scene available to import mesh to");
            return null;
        }
        const fileInfo = $778eb5b99c1bda64$export$df9e0282cad33838._GetFileInfo(rootUrl, sceneFilename);
        if (!fileInfo) return null;
        const loadingToken = {};
        scene.addPendingData(loadingToken);
        const disposeHandler = ()=>{
            scene.removePendingData(loadingToken);
        };
        const errorHandler = (message, exception)=>{
            const errorMessage = $778eb5b99c1bda64$export$df9e0282cad33838._FormatErrorMessage(fileInfo, message, exception);
            if (onError) onError(scene, errorMessage, new (0, $1FkG9.RuntimeError)(errorMessage, (0, $1FkG9.ErrorCodes).SceneLoaderError, exception));
            else (0, $kVtWi.Logger).Error(errorMessage);
            disposeHandler();
        };
        const progressHandler = onProgress ? (event)=>{
            try {
                onProgress(event);
            } catch (e) {
                errorHandler("Error in onProgress callback: " + e, e);
            }
        } : undefined;
        const successHandler = (meshes, particleSystems, skeletons, animationGroups, transformNodes, geometries, lights, spriteManagers)=>{
            scene.importedMeshesFiles.push(fileInfo.url);
            if (onSuccess) try {
                onSuccess(meshes, particleSystems, skeletons, animationGroups, transformNodes, geometries, lights, spriteManagers);
            } catch (e) {
                errorHandler("Error in onSuccess callback: " + e, e);
            }
            scene.removePendingData(loadingToken);
        };
        return $778eb5b99c1bda64$export$df9e0282cad33838._LoadData(fileInfo, scene, (plugin, data, responseURL)=>{
            if (plugin.rewriteRootURL) fileInfo.rootUrl = plugin.rewriteRootURL(fileInfo.rootUrl, responseURL);
            if (plugin.importMesh) {
                const syncedPlugin = plugin;
                const meshes = [];
                const particleSystems = [];
                const skeletons = [];
                if (!syncedPlugin.importMesh(meshNames, scene, data, fileInfo.rootUrl, meshes, particleSystems, skeletons, errorHandler)) return;
                scene.loadingPluginName = plugin.name;
                successHandler(meshes, particleSystems, skeletons, [], [], [], [], []);
            } else {
                const asyncedPlugin = plugin;
                asyncedPlugin.importMeshAsync(meshNames, scene, data, fileInfo.rootUrl, progressHandler, fileInfo.name).then((result)=>{
                    scene.loadingPluginName = plugin.name;
                    successHandler(result.meshes, result.particleSystems, result.skeletons, result.animationGroups, result.transformNodes, result.geometries, result.lights, result.spriteManagers);
                }).catch((error)=>{
                    errorHandler(error.message, error);
                });
            }
        }, progressHandler, errorHandler, disposeHandler, pluginExtension, name);
    }
    /**
     * Import meshes into a scene
     * @param meshNames an array of mesh names, a single mesh name, or empty string for all meshes that filter what meshes are imported
     * @param rootUrl a string that defines the root url for the scene and resources or the concatenation of rootURL and filename (e.g. http://example.com/test.glb)
     * @param sceneFilename a string that defines the name of the scene file or starts with "data:" following by the stringified version of the scene or a File object (default: empty string)
     * @param scene the instance of BABYLON.Scene to append to
     * @param onProgress a callback with a progress event for each file being loaded
     * @param pluginExtension the extension used to determine the plugin
     * @param name defines the name of the file
     * @returns The loaded list of imported meshes, particle systems, skeletons, and animation groups
     */ static ImportMeshAsync(meshNames, rootUrl, sceneFilename = "", scene = (0, $ejQPp.EngineStore).LastCreatedScene, onProgress = null, pluginExtension = null, name = "") {
        return new Promise((resolve, reject)=>{
            $778eb5b99c1bda64$export$df9e0282cad33838.ImportMesh(meshNames, rootUrl, sceneFilename, scene, (meshes, particleSystems, skeletons, animationGroups, transformNodes, geometries, lights, spriteManagers)=>{
                resolve({
                    meshes: meshes,
                    particleSystems: particleSystems,
                    skeletons: skeletons,
                    animationGroups: animationGroups,
                    transformNodes: transformNodes,
                    geometries: geometries,
                    lights: lights,
                    spriteManagers: spriteManagers
                });
            }, onProgress, (scene, message, exception)=>{
                reject(exception || new Error(message));
            }, pluginExtension, name);
        });
    }
    /**
     * Load a scene
     * @param rootUrl a string that defines the root url for the scene and resources or the concatenation of rootURL and filename (e.g. http://example.com/test.glb)
     * @param sceneFilename a string that defines the name of the scene file or starts with "data:" following by the stringified version of the scene or a File object (default: empty string)
     * @param engine is the instance of BABYLON.Engine to use to create the scene
     * @param onSuccess a callback with the scene when import succeeds
     * @param onProgress a callback with a progress event for each file being loaded
     * @param onError a callback with the scene, a message, and possibly an exception when import fails
     * @param pluginExtension the extension used to determine the plugin
     * @param name defines the filename, if the data is binary
     * @returns The loaded plugin
     */ static Load(rootUrl, sceneFilename = "", engine = (0, $ejQPp.EngineStore).LastCreatedEngine, onSuccess = null, onProgress = null, onError = null, pluginExtension = null, name = "") {
        if (!engine) {
            (0, $bOhSV.Tools).Error("No engine available");
            return null;
        }
        return $778eb5b99c1bda64$export$df9e0282cad33838.Append(rootUrl, sceneFilename, new (0, $gmbCk.Scene)(engine), onSuccess, onProgress, onError, pluginExtension, name);
    }
    /**
     * Load a scene
     * @param rootUrl a string that defines the root url for the scene and resources or the concatenation of rootURL and filename (e.g. http://example.com/test.glb)
     * @param sceneFilename a string that defines the name of the scene file or starts with "data:" following by the stringified version of the scene or a File object (default: empty string)
     * @param engine is the instance of BABYLON.Engine to use to create the scene
     * @param onProgress a callback with a progress event for each file being loaded
     * @param pluginExtension the extension used to determine the plugin
     * @param name defines the filename, if the data is binary
     * @returns The loaded scene
     */ static LoadAsync(rootUrl, sceneFilename = "", engine = (0, $ejQPp.EngineStore).LastCreatedEngine, onProgress = null, pluginExtension = null, name = "") {
        return new Promise((resolve, reject)=>{
            $778eb5b99c1bda64$export$df9e0282cad33838.Load(rootUrl, sceneFilename, engine, (scene)=>{
                resolve(scene);
            }, onProgress, (scene, message, exception)=>{
                reject(exception || new Error(message));
            }, pluginExtension, name);
        });
    }
    /**
     * Append a scene
     * @param rootUrl a string that defines the root url for the scene and resources or the concatenation of rootURL and filename (e.g. http://example.com/test.glb)
     * @param sceneFilename a string that defines the name of the scene file or starts with "data:" following by the stringified version of the scene or a File object (default: empty string)
     * @param scene is the instance of BABYLON.Scene to append to
     * @param onSuccess a callback with the scene when import succeeds
     * @param onProgress a callback with a progress event for each file being loaded
     * @param onError a callback with the scene, a message, and possibly an exception when import fails
     * @param pluginExtension the extension used to determine the plugin
     * @param name defines the name of the file, if the data is binary
     * @returns The loaded plugin
     */ static Append(rootUrl, sceneFilename = "", scene = (0, $ejQPp.EngineStore).LastCreatedScene, onSuccess = null, onProgress = null, onError = null, pluginExtension = null, name = "") {
        if (!scene) {
            (0, $kVtWi.Logger).Error("No scene available to append to");
            return null;
        }
        const fileInfo = $778eb5b99c1bda64$export$df9e0282cad33838._GetFileInfo(rootUrl, sceneFilename);
        if (!fileInfo) return null;
        const loadingToken = {};
        scene.addPendingData(loadingToken);
        const disposeHandler = ()=>{
            scene.removePendingData(loadingToken);
        };
        if ($778eb5b99c1bda64$export$df9e0282cad33838.ShowLoadingScreen && !this._ShowingLoadingScreen) {
            this._ShowingLoadingScreen = true;
            scene.getEngine().displayLoadingUI();
            scene.executeWhenReady(()=>{
                scene.getEngine().hideLoadingUI();
                this._ShowingLoadingScreen = false;
            });
        }
        const errorHandler = (message, exception)=>{
            const errorMessage = $778eb5b99c1bda64$export$df9e0282cad33838._FormatErrorMessage(fileInfo, message, exception);
            if (onError) onError(scene, errorMessage, new (0, $1FkG9.RuntimeError)(errorMessage, (0, $1FkG9.ErrorCodes).SceneLoaderError, exception));
            else (0, $kVtWi.Logger).Error(errorMessage);
            disposeHandler();
        };
        const progressHandler = onProgress ? (event)=>{
            try {
                onProgress(event);
            } catch (e) {
                errorHandler("Error in onProgress callback", e);
            }
        } : undefined;
        const successHandler = ()=>{
            if (onSuccess) try {
                onSuccess(scene);
            } catch (e) {
                errorHandler("Error in onSuccess callback", e);
            }
            scene.removePendingData(loadingToken);
        };
        return $778eb5b99c1bda64$export$df9e0282cad33838._LoadData(fileInfo, scene, (plugin, data)=>{
            if (plugin.load) {
                const syncedPlugin = plugin;
                if (!syncedPlugin.load(scene, data, fileInfo.rootUrl, errorHandler)) return;
                scene.loadingPluginName = plugin.name;
                successHandler();
            } else {
                const asyncedPlugin = plugin;
                asyncedPlugin.loadAsync(scene, data, fileInfo.rootUrl, progressHandler, fileInfo.name).then(()=>{
                    scene.loadingPluginName = plugin.name;
                    successHandler();
                }).catch((error)=>{
                    errorHandler(error.message, error);
                });
            }
        }, progressHandler, errorHandler, disposeHandler, pluginExtension, name);
    }
    /**
     * Append a scene
     * @param rootUrl a string that defines the root url for the scene and resources or the concatenation of rootURL and filename (e.g. http://example.com/test.glb)
     * @param sceneFilename a string that defines the name of the scene file or starts with "data:" following by the stringified version of the scene or a File object (default: empty string)
     * @param scene is the instance of BABYLON.Scene to append to
     * @param onProgress a callback with a progress event for each file being loaded
     * @param pluginExtension the extension used to determine the plugin
     * @param name defines the name of the file, if the data is binary
     * @returns The given scene
     */ static AppendAsync(rootUrl, sceneFilename = "", scene = (0, $ejQPp.EngineStore).LastCreatedScene, onProgress = null, pluginExtension = null, name = "") {
        return new Promise((resolve, reject)=>{
            $778eb5b99c1bda64$export$df9e0282cad33838.Append(rootUrl, sceneFilename, scene, (scene)=>{
                resolve(scene);
            }, onProgress, (scene, message, exception)=>{
                reject(exception || new Error(message));
            }, pluginExtension, name);
        });
    }
    /**
     * Load a scene into an asset container
     * @param rootUrl a string that defines the root url for the scene and resources or the concatenation of rootURL and filename (e.g. http://example.com/test.glb)
     * @param sceneFilename a string that defines the name of the scene file or starts with "data:" following by the stringified version of the scene or a File object (default: empty string)
     * @param scene is the instance of BABYLON.Scene to append to (default: last created scene)
     * @param onSuccess a callback with the scene when import succeeds
     * @param onProgress a callback with a progress event for each file being loaded
     * @param onError a callback with the scene, a message, and possibly an exception when import fails
     * @param pluginExtension the extension used to determine the plugin
     * @param name defines the filename, if the data is binary
     * @returns The loaded plugin
     */ static LoadAssetContainer(rootUrl, sceneFilename = "", scene = (0, $ejQPp.EngineStore).LastCreatedScene, onSuccess = null, onProgress = null, onError = null, pluginExtension = null, name = "") {
        if (!scene) {
            (0, $kVtWi.Logger).Error("No scene available to load asset container to");
            return null;
        }
        const fileInfo = $778eb5b99c1bda64$export$df9e0282cad33838._GetFileInfo(rootUrl, sceneFilename);
        if (!fileInfo) return null;
        const loadingToken = {};
        scene.addPendingData(loadingToken);
        const disposeHandler = ()=>{
            scene.removePendingData(loadingToken);
        };
        const errorHandler = (message, exception)=>{
            const errorMessage = $778eb5b99c1bda64$export$df9e0282cad33838._FormatErrorMessage(fileInfo, message, exception);
            if (onError) onError(scene, errorMessage, new (0, $1FkG9.RuntimeError)(errorMessage, (0, $1FkG9.ErrorCodes).SceneLoaderError, exception));
            else (0, $kVtWi.Logger).Error(errorMessage);
            disposeHandler();
        };
        const progressHandler = onProgress ? (event)=>{
            try {
                onProgress(event);
            } catch (e) {
                errorHandler("Error in onProgress callback", e);
            }
        } : undefined;
        const successHandler = (assets)=>{
            if (onSuccess) try {
                onSuccess(assets);
            } catch (e) {
                errorHandler("Error in onSuccess callback", e);
            }
            scene.removePendingData(loadingToken);
        };
        return $778eb5b99c1bda64$export$df9e0282cad33838._LoadData(fileInfo, scene, (plugin, data)=>{
            if (plugin.loadAssetContainer) {
                const syncedPlugin = plugin;
                const assetContainer = syncedPlugin.loadAssetContainer(scene, data, fileInfo.rootUrl, errorHandler);
                if (!assetContainer) return;
                assetContainer.populateRootNodes();
                scene.loadingPluginName = plugin.name;
                successHandler(assetContainer);
            } else if (plugin.loadAssetContainerAsync) {
                const asyncedPlugin = plugin;
                asyncedPlugin.loadAssetContainerAsync(scene, data, fileInfo.rootUrl, progressHandler, fileInfo.name).then((assetContainer)=>{
                    assetContainer.populateRootNodes();
                    scene.loadingPluginName = plugin.name;
                    successHandler(assetContainer);
                }).catch((error)=>{
                    errorHandler(error.message, error);
                });
            } else errorHandler("LoadAssetContainer is not supported by this plugin. Plugin did not provide a loadAssetContainer or loadAssetContainerAsync method.");
        }, progressHandler, errorHandler, disposeHandler, pluginExtension, name);
    }
    /**
     * Load a scene into an asset container
     * @param rootUrl a string that defines the root url for the scene and resources or the concatenation of rootURL and filename (e.g. http://example.com/test.glb)
     * @param sceneFilename a string that defines the name of the scene file or starts with "data:" following by the stringified version of the scene (default: empty string)
     * @param scene is the instance of Scene to append to
     * @param onProgress a callback with a progress event for each file being loaded
     * @param pluginExtension the extension used to determine the plugin
     * @returns The loaded asset container
     */ static LoadAssetContainerAsync(rootUrl, sceneFilename = "", scene = (0, $ejQPp.EngineStore).LastCreatedScene, onProgress = null, pluginExtension = null) {
        return new Promise((resolve, reject)=>{
            $778eb5b99c1bda64$export$df9e0282cad33838.LoadAssetContainer(rootUrl, sceneFilename, scene, (assetContainer)=>{
                resolve(assetContainer);
            }, onProgress, (scene, message, exception)=>{
                reject(exception || new Error(message));
            }, pluginExtension);
        });
    }
    /**
     * Import animations from a file into a scene
     * @param rootUrl a string that defines the root url for the scene and resources or the concatenation of rootURL and filename (e.g. http://example.com/test.glb)
     * @param sceneFilename a string that defines the name of the scene file or starts with "data:" following by the stringified version of the scene or a File object (default: empty string)
     * @param scene is the instance of BABYLON.Scene to append to (default: last created scene)
     * @param overwriteAnimations when true, animations are cleaned before importing new ones. Animations are appended otherwise
     * @param animationGroupLoadingMode defines how to handle old animations groups before importing new ones
     * @param targetConverter defines a function used to convert animation targets from loaded scene to current scene (default: search node by name)
     * @param onSuccess a callback with the scene when import succeeds
     * @param onProgress a callback with a progress event for each file being loaded
     * @param onError a callback with the scene, a message, and possibly an exception when import fails
     * @param pluginExtension the extension used to determine the plugin
     */ static ImportAnimations(rootUrl, sceneFilename = "", scene = (0, $ejQPp.EngineStore).LastCreatedScene, overwriteAnimations = true, animationGroupLoadingMode = $778eb5b99c1bda64$export$ea6abc4fb7b9984f.Clean, targetConverter = null, onSuccess = null, onProgress = null, onError = null, pluginExtension = null) {
        if (!scene) {
            (0, $kVtWi.Logger).Error("No scene available to load animations to");
            return;
        }
        if (overwriteAnimations) {
            // Reset, stop and dispose all animations before loading new ones
            for (const animatable of scene.animatables)animatable.reset();
            scene.stopAllAnimations();
            scene.animationGroups.slice().forEach((animationGroup)=>{
                animationGroup.dispose();
            });
            const nodes = scene.getNodes();
            nodes.forEach((node)=>{
                if (node.animations) node.animations = [];
            });
        } else switch(animationGroupLoadingMode){
            case $778eb5b99c1bda64$export$ea6abc4fb7b9984f.Clean:
                scene.animationGroups.slice().forEach((animationGroup)=>{
                    animationGroup.dispose();
                });
                break;
            case $778eb5b99c1bda64$export$ea6abc4fb7b9984f.Stop:
                scene.animationGroups.forEach((animationGroup)=>{
                    animationGroup.stop();
                });
                break;
            case $778eb5b99c1bda64$export$ea6abc4fb7b9984f.Sync:
                scene.animationGroups.forEach((animationGroup)=>{
                    animationGroup.reset();
                    animationGroup.restart();
                });
                break;
            case $778eb5b99c1bda64$export$ea6abc4fb7b9984f.NoSync:
                break;
            default:
                (0, $kVtWi.Logger).Error("Unknown animation group loading mode value '" + animationGroupLoadingMode + "'");
                return;
        }
        const startingIndexForNewAnimatables = scene.animatables.length;
        const onAssetContainerLoaded = (container)=>{
            container.mergeAnimationsTo(scene, scene.animatables.slice(startingIndexForNewAnimatables), targetConverter);
            container.dispose();
            scene.onAnimationFileImportedObservable.notifyObservers(scene);
            if (onSuccess) onSuccess(scene);
        };
        this.LoadAssetContainer(rootUrl, sceneFilename, scene, onAssetContainerLoaded, onProgress, onError, pluginExtension);
    }
    /**
     * Import animations from a file into a scene
     * @param rootUrl a string that defines the root url for the scene and resources or the concatenation of rootURL and filename (e.g. http://example.com/test.glb)
     * @param sceneFilename a string that defines the name of the scene file or starts with "data:" following by the stringified version of the scene or a File object (default: empty string)
     * @param scene is the instance of BABYLON.Scene to append to (default: last created scene)
     * @param overwriteAnimations when true, animations are cleaned before importing new ones. Animations are appended otherwise
     * @param animationGroupLoadingMode defines how to handle old animations groups before importing new ones
     * @param targetConverter defines a function used to convert animation targets from loaded scene to current scene (default: search node by name)
     * @param onSuccess a callback with the scene when import succeeds
     * @param onProgress a callback with a progress event for each file being loaded
     * @param onError a callback with the scene, a message, and possibly an exception when import fails
     * @param pluginExtension the extension used to determine the plugin
     * @returns the updated scene with imported animations
     */ static ImportAnimationsAsync(rootUrl, sceneFilename = "", scene = (0, $ejQPp.EngineStore).LastCreatedScene, overwriteAnimations = true, animationGroupLoadingMode = $778eb5b99c1bda64$export$ea6abc4fb7b9984f.Clean, targetConverter = null, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onSuccess = null, onProgress = null, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onError = null, pluginExtension = null) {
        return new Promise((resolve, reject)=>{
            $778eb5b99c1bda64$export$df9e0282cad33838.ImportAnimations(rootUrl, sceneFilename, scene, overwriteAnimations, animationGroupLoadingMode, targetConverter, (_scene)=>{
                resolve(_scene);
            }, onProgress, (_scene, message, exception)=>{
                reject(exception || new Error(message));
            }, pluginExtension);
        });
    }
}
/**
 * No logging while loading
 */ $778eb5b99c1bda64$export$df9e0282cad33838.NO_LOGGING = 0;
/**
 * Minimal logging while loading
 */ $778eb5b99c1bda64$export$df9e0282cad33838.MINIMAL_LOGGING = 1;
/**
 * Summary logging while loading
 */ $778eb5b99c1bda64$export$df9e0282cad33838.SUMMARY_LOGGING = 2;
/**
 * Detailed logging while loading
 */ $778eb5b99c1bda64$export$df9e0282cad33838.DETAILED_LOGGING = 3;
// Members
/**
 * Event raised when a plugin is used to load a scene
 */ $778eb5b99c1bda64$export$df9e0282cad33838.OnPluginActivatedObservable = new (0, $diGQf.Observable)();
$778eb5b99c1bda64$export$df9e0282cad33838._RegisteredPlugins = {};
$778eb5b99c1bda64$export$df9e0282cad33838._ShowingLoadingScreen = false;

});

parcelRegister("5fNQr", function(module, exports) {

$parcel$export(module.exports, "NodeMaterialDefines", () => $3d35049eb9780bcb$export$a521de9e19f1793b);
$parcel$export(module.exports, "NodeMaterial", () => $3d35049eb9780bcb$export$caaf3b30a544c946);

var $e0Suo = parcelRequire("e0Suo");

var $atHN2 = parcelRequire("atHN2");

var $0cHNL = parcelRequire("0cHNL");

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $5YkyR = parcelRequire("5YkyR");

var $jHEyh = parcelRequire("jHEyh");

var $lUDWq = parcelRequire("lUDWq");

var $diGQf = parcelRequire("diGQf");

var $iAIIe = parcelRequire("iAIIe");

var $2k2yr = parcelRequire("2k2yr");

var $35xmP = parcelRequire("35xmP");

var $b4i1f = parcelRequire("b4i1f");

var $bOhSV = parcelRequire("bOhSV");

var $cFAzb = parcelRequire("cFAzb");

var $eH9s9 = parcelRequire("eH9s9");

var $9d6MD = parcelRequire("9d6MD");

var $aKEh2 = parcelRequire("aKEh2");

var $8DoUR = parcelRequire("8DoUR");

var $ir0rz = parcelRequire("ir0rz");

var $6Ho1L = parcelRequire("6Ho1L");

var $h62fU = parcelRequire("h62fU");

var $hExiF = parcelRequire("hExiF");

var $ejSsy = parcelRequire("ejSsy");

var $h7sVv = parcelRequire("h7sVv");

var $gc8Ja = parcelRequire("gc8Ja");

var $hUzEl = parcelRequire("hUzEl");

var $cFdBb = parcelRequire("cFdBb");

var $jnIu6 = parcelRequire("jnIu6");

var $dIpWY = parcelRequire("dIpWY");

var $fTSHo = parcelRequire("fTSHo");

var $5oHv1 = parcelRequire("5oHv1");

var $j2mX5 = parcelRequire("j2mX5");

var $1iaDW = parcelRequire("1iaDW");

var $6XqNB = parcelRequire("6XqNB");

var $av6Bc = parcelRequire("av6Bc");

var $bds6B = parcelRequire("bds6B");

var $apsYB = parcelRequire("apsYB");

var $3hVDe = parcelRequire("3hVDe");

var $7qH6c = parcelRequire("7qH6c");

var $ejQPp = parcelRequire("ejQPp");

var $kVtWi = parcelRequire("kVtWi");

var $alPCh = parcelRequire("alPCh");
const $3d35049eb9780bcb$var$onCreatedEffectParameters = {
    effect: null,
    subMesh: null
};
class $3d35049eb9780bcb$export$a521de9e19f1793b extends (0, $35xmP.MaterialDefines) {
    /**
     * Creates a new NodeMaterialDefines
     */ constructor(){
        super();
        /** Normal */ this.NORMAL = false;
        /** Tangent */ this.TANGENT = false;
        /** Vertex color */ this.VERTEXCOLOR_NME = false;
        /**  Uv1 **/ this.UV1 = false;
        /** Uv2 **/ this.UV2 = false;
        /** Uv3 **/ this.UV3 = false;
        /** Uv4 **/ this.UV4 = false;
        /** Uv5 **/ this.UV5 = false;
        /** Uv6 **/ this.UV6 = false;
        /** Prepass **/ this.PREPASS = false;
        /** Prepass normal */ this.PREPASS_NORMAL = false;
        /** Prepass normal index */ this.PREPASS_NORMAL_INDEX = -1;
        /** Prepass position */ this.PREPASS_POSITION = false;
        /** Prepass position index */ this.PREPASS_POSITION_INDEX = -1;
        /** Prepass depth */ this.PREPASS_DEPTH = false;
        /** Prepass depth index */ this.PREPASS_DEPTH_INDEX = -1;
        /** Scene MRT count */ this.SCENE_MRT_COUNT = 0;
        /** BONES */ this.NUM_BONE_INFLUENCERS = 0;
        /** Bones per mesh */ this.BonesPerMesh = 0;
        /** Using texture for bone storage */ this.BONETEXTURE = false;
        /** MORPH TARGETS */ this.MORPHTARGETS = false;
        /** Morph target normal */ this.MORPHTARGETS_NORMAL = false;
        /** Morph target tangent */ this.MORPHTARGETS_TANGENT = false;
        /** Morph target uv */ this.MORPHTARGETS_UV = false;
        /** Number of morph influencers */ this.NUM_MORPH_INFLUENCERS = 0;
        /** Using a texture to store morph target data */ this.MORPHTARGETS_TEXTURE = false;
        /** IMAGE PROCESSING */ this.IMAGEPROCESSING = false;
        /** Vignette */ this.VIGNETTE = false;
        /** Multiply blend mode for vignette */ this.VIGNETTEBLENDMODEMULTIPLY = false;
        /** Opaque blend mode for vignette */ this.VIGNETTEBLENDMODEOPAQUE = false;
        /** Tone mapping */ this.TONEMAPPING = false;
        /** ACES tone mapping mode */ this.TONEMAPPING_ACES = false;
        /** Contrast */ this.CONTRAST = false;
        /** Exposure */ this.EXPOSURE = false;
        /** Color curves */ this.COLORCURVES = false;
        /** Color grading */ this.COLORGRADING = false;
        /** 3D color grading */ this.COLORGRADING3D = false;
        /** Sampler green depth */ this.SAMPLER3DGREENDEPTH = false;
        /** Sampler for BGR map */ this.SAMPLER3DBGRMAP = false;
        /** Dithering */ this.DITHER = false;
        /** Using post process for image processing */ this.IMAGEPROCESSINGPOSTPROCESS = false;
        /** Skip color clamp */ this.SKIPFINALCOLORCLAMP = false;
        /** MISC. */ this.BUMPDIRECTUV = 0;
        /** Camera is orthographic */ this.CAMERA_ORTHOGRAPHIC = false;
        /** Camera is perspective */ this.CAMERA_PERSPECTIVE = false;
        this.rebuild();
    }
    /**
     * Set the value of a specific key
     * @param name defines the name of the key to set
     * @param value defines the value to set
     * @param markAsUnprocessedIfDirty Flag to indicate to the cache that this value needs processing
     */ setValue(name, value, markAsUnprocessedIfDirty = false) {
        if (this[name] === undefined) this._keys.push(name);
        if (markAsUnprocessedIfDirty && this[name] !== value) this.markAsUnprocessed();
        this[name] = value;
    }
}
class $3d35049eb9780bcb$export$caaf3b30a544c946 extends (0, $atHN2.PushMaterial) {
    /**
     * Checks if a block is a texture block
     * @param block The block to check
     * @returns True if the block is a texture block
     */ static _BlockIsTextureBlock(block) {
        return block.getClassName() === "TextureBlock" || block.getClassName() === "ReflectionTextureBaseBlock" || block.getClassName() === "ReflectionTextureBlock" || block.getClassName() === "ReflectionBlock" || block.getClassName() === "RefractionBlock" || block.getClassName() === "CurrentScreenBlock" || block.getClassName() === "ParticleTextureBlock" || block.getClassName() === "ImageSourceBlock" || block.getClassName() === "TriPlanarBlock" || block.getClassName() === "BiPlanarBlock" || block.getClassName() === "PrePassTextureBlock";
    }
    /** Get the inspector from bundle or global
     * @returns the global NME
     */ _getGlobalNodeMaterialEditor() {
        // UMD Global name detection from Webpack Bundle UMD Name.
        if (typeof NODEEDITOR !== "undefined") return NODEEDITOR;
        // In case of module let's check the global emitted from the editor entry point.
        if (typeof BABYLON !== "undefined" && typeof BABYLON.NodeEditor !== "undefined") return BABYLON;
        return undefined;
    }
    /** Gets or sets options to control the node material overall behavior */ get options() {
        return this._options;
    }
    set options(options) {
        this._options = options;
    }
    /**
     * Gets the image processing configuration used either in this material.
     */ get imageProcessingConfiguration() {
        return this._imageProcessingConfiguration;
    }
    /**
     * Sets the Default image processing configuration used either in the this material.
     *
     * If sets to null, the scene one is in use.
     */ set imageProcessingConfiguration(value) {
        this._attachImageProcessingConfiguration(value);
        // Ensure the effect will be rebuilt.
        this._markAllSubMeshesAsTexturesDirty();
    }
    /**
     * Gets or sets the mode property
     */ get mode() {
        return this._mode;
    }
    set mode(value) {
        this._mode = value;
    }
    /** Gets or sets the unique identifier used to identified the effect associated with the material */ get buildId() {
        return this._buildId;
    }
    set buildId(value) {
        this._buildId = value;
    }
    /**
     * Create a new node based material
     * @param name defines the material name
     * @param scene defines the hosting scene
     * @param options defines creation option
     */ constructor(name, scene, options = {}){
        super(name, scene || (0, $ejQPp.EngineStore).LastCreatedScene);
        this._buildId = $3d35049eb9780bcb$export$caaf3b30a544c946._BuildIdGenerator++;
        this._buildWasSuccessful = false;
        this._cachedWorldViewMatrix = new (0, $ha1VO.Matrix)();
        this._cachedWorldViewProjectionMatrix = new (0, $ha1VO.Matrix)();
        this._optimizers = new Array();
        this._animationFrame = -1;
        this.BJSNODEMATERIALEDITOR = this._getGlobalNodeMaterialEditor();
        /**
         * Gets or sets data used by visual editor
         * @see https://nme.babylonjs.com
         */ this.editorData = null;
        /**
         * Gets or sets a boolean indicating that alpha value must be ignored (This will turn alpha blending off even if an alpha value is produced by the material)
         */ this.ignoreAlpha = false;
        /**
         * Defines the maximum number of lights that can be used in the material
         */ this.maxSimultaneousLights = 4;
        /**
         * Observable raised when the material is built
         */ this.onBuildObservable = new (0, $diGQf.Observable)();
        /**
         * Gets or sets the root nodes of the material vertex shader
         */ this._vertexOutputNodes = new Array();
        /**
         * Gets or sets the root nodes of the material fragment (pixel) shader
         */ this._fragmentOutputNodes = new Array();
        /**
         * Gets an array of blocks that needs to be serialized even if they are not yet connected
         */ this.attachedBlocks = [];
        /**
         * Specifies the mode of the node material
         * @internal
         */ this._mode = (0, $5oHv1.NodeMaterialModes).Material;
        /**
         * Gets or sets a boolean indicating that alpha blending must be enabled no matter what alpha value or alpha channel of the FragmentBlock are
         */ this.forceAlphaBlending = false;
        this._options = {
            emitComments: false,
            ...options
        };
        // Setup the default processing configuration to the scene.
        this._attachImageProcessingConfiguration(null);
    }
    /**
     * Gets the current class name of the material e.g. "NodeMaterial"
     * @returns the class name
     */ getClassName() {
        return "NodeMaterial";
    }
    /**
     * Attaches a new image processing configuration to the Standard Material.
     * @param configuration
     */ _attachImageProcessingConfiguration(configuration) {
        if (configuration === this._imageProcessingConfiguration) return;
        // Detaches observer.
        if (this._imageProcessingConfiguration && this._imageProcessingObserver) this._imageProcessingConfiguration.onUpdateParameters.remove(this._imageProcessingObserver);
        // Pick the scene configuration if needed.
        if (!configuration) this._imageProcessingConfiguration = this.getScene().imageProcessingConfiguration;
        else this._imageProcessingConfiguration = configuration;
        // Attaches observer.
        if (this._imageProcessingConfiguration) this._imageProcessingObserver = this._imageProcessingConfiguration.onUpdateParameters.add(()=>{
            this._markAllSubMeshesAsImageProcessingDirty();
        });
    }
    /**
     * Get a block by its name
     * @param name defines the name of the block to retrieve
     * @returns the required block or null if not found
     */ getBlockByName(name) {
        let result = null;
        for (const block of this.attachedBlocks)if (block.name === name) {
            if (!result) result = block;
            else {
                (0, $bOhSV.Tools).Warn("More than one block was found with the name `" + name + "`");
                return result;
            }
        }
        return result;
    }
    /**
     * Get a block using a predicate
     * @param predicate defines the predicate used to find the good candidate
     * @returns the required block or null if not found
     */ getBlockByPredicate(predicate) {
        for (const block of this.attachedBlocks){
            if (predicate(block)) return block;
        }
        return null;
    }
    /**
     * Get an input block using a predicate
     * @param predicate defines the predicate used to find the good candidate
     * @returns the required input block or null if not found
     */ getInputBlockByPredicate(predicate) {
        for (const block of this.attachedBlocks){
            if (block.isInput && predicate(block)) return block;
        }
        return null;
    }
    /**
     * Gets the list of input blocks attached to this material
     * @returns an array of InputBlocks
     */ getInputBlocks() {
        const blocks = [];
        for (const block of this.attachedBlocks)if (block.isInput) blocks.push(block);
        return blocks;
    }
    /**
     * Adds a new optimizer to the list of optimizers
     * @param optimizer defines the optimizers to add
     * @returns the current material
     */ registerOptimizer(optimizer) {
        const index = this._optimizers.indexOf(optimizer);
        if (index > -1) return;
        this._optimizers.push(optimizer);
        return this;
    }
    /**
     * Remove an optimizer from the list of optimizers
     * @param optimizer defines the optimizers to remove
     * @returns the current material
     */ unregisterOptimizer(optimizer) {
        const index = this._optimizers.indexOf(optimizer);
        if (index === -1) return;
        this._optimizers.splice(index, 1);
        return this;
    }
    /**
     * Add a new block to the list of output nodes
     * @param node defines the node to add
     * @returns the current material
     */ addOutputNode(node) {
        if (node.target === null) // eslint-disable-next-line no-throw-literal
        throw "This node is not meant to be an output node. You may want to explicitly set its target value.";
        if ((node.target & (0, $iAIIe.NodeMaterialBlockTargets).Vertex) !== 0) this._addVertexOutputNode(node);
        if ((node.target & (0, $iAIIe.NodeMaterialBlockTargets).Fragment) !== 0) this._addFragmentOutputNode(node);
        return this;
    }
    /**
     * Remove a block from the list of root nodes
     * @param node defines the node to remove
     * @returns the current material
     */ removeOutputNode(node) {
        if (node.target === null) return this;
        if ((node.target & (0, $iAIIe.NodeMaterialBlockTargets).Vertex) !== 0) this._removeVertexOutputNode(node);
        if ((node.target & (0, $iAIIe.NodeMaterialBlockTargets).Fragment) !== 0) this._removeFragmentOutputNode(node);
        return this;
    }
    _addVertexOutputNode(node) {
        if (this._vertexOutputNodes.indexOf(node) !== -1) return;
        node.target = (0, $iAIIe.NodeMaterialBlockTargets).Vertex;
        this._vertexOutputNodes.push(node);
        return this;
    }
    _removeVertexOutputNode(node) {
        const index = this._vertexOutputNodes.indexOf(node);
        if (index === -1) return;
        this._vertexOutputNodes.splice(index, 1);
        return this;
    }
    _addFragmentOutputNode(node) {
        if (this._fragmentOutputNodes.indexOf(node) !== -1) return;
        node.target = (0, $iAIIe.NodeMaterialBlockTargets).Fragment;
        this._fragmentOutputNodes.push(node);
        return this;
    }
    _removeFragmentOutputNode(node) {
        const index = this._fragmentOutputNodes.indexOf(node);
        if (index === -1) return;
        this._fragmentOutputNodes.splice(index, 1);
        return this;
    }
    /**
     * Specifies if the material will require alpha blending
     * @returns a boolean specifying if alpha blending is needed
     */ needAlphaBlending() {
        if (this.ignoreAlpha) return false;
        return this.forceAlphaBlending || this.alpha < 1.0 || this._sharedData && this._sharedData.hints.needAlphaBlending;
    }
    /**
     * Specifies if this material should be rendered in alpha test mode
     * @returns a boolean specifying if an alpha test is needed.
     */ needAlphaTesting() {
        return this._sharedData && this._sharedData.hints.needAlphaTesting;
    }
    _processInitializeOnLink(block, state, nodesToProcessForOtherBuildState, autoConfigure = true) {
        if (block.target === (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment) nodesToProcessForOtherBuildState.push(block);
        else if (state.target === (0, $iAIIe.NodeMaterialBlockTargets).Fragment && block.target === (0, $iAIIe.NodeMaterialBlockTargets).Vertex && block._preparationId !== this._buildId) nodesToProcessForOtherBuildState.push(block);
        this._initializeBlock(block, state, nodesToProcessForOtherBuildState, autoConfigure);
    }
    _initializeBlock(node, state, nodesToProcessForOtherBuildState, autoConfigure = true) {
        node.initialize(state);
        if (autoConfigure) node.autoConfigure(this);
        node._preparationId = this._buildId;
        if (this.attachedBlocks.indexOf(node) === -1) {
            if (node.isUnique) {
                const className = node.getClassName();
                for (const other of this.attachedBlocks){
                    if (other.getClassName() === className) // eslint-disable-next-line no-throw-literal
                    throw `Cannot have multiple blocks of type ${className} in the same NodeMaterial`;
                }
            }
            this.attachedBlocks.push(node);
        }
        for (const input of node.inputs){
            input.associatedVariableName = "";
            const connectedPoint = input.connectedPoint;
            if (connectedPoint) {
                const block = connectedPoint.ownerBlock;
                if (block !== node) this._processInitializeOnLink(block, state, nodesToProcessForOtherBuildState, autoConfigure);
            }
        }
        // Teleportation
        if (node.isTeleportOut) {
            const teleport = node;
            if (teleport.entryPoint) this._processInitializeOnLink(teleport.entryPoint, state, nodesToProcessForOtherBuildState, autoConfigure);
        }
        for (const output of node.outputs)output.associatedVariableName = "";
    }
    _resetDualBlocks(node, id) {
        if (node.target === (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment) node.buildId = id;
        for (const inputs of node.inputs){
            const connectedPoint = inputs.connectedPoint;
            if (connectedPoint) {
                const block = connectedPoint.ownerBlock;
                if (block !== node) this._resetDualBlocks(block, id);
            }
        }
        // If this is a teleport out, we need to reset the connected block
        if (node.isTeleportOut) {
            const teleportOut = node;
            if (teleportOut.entryPoint) this._resetDualBlocks(teleportOut.entryPoint, id);
        }
    }
    /**
     * Remove a block from the current node material
     * @param block defines the block to remove
     */ removeBlock(block) {
        const attachedBlockIndex = this.attachedBlocks.indexOf(block);
        if (attachedBlockIndex > -1) this.attachedBlocks.splice(attachedBlockIndex, 1);
        if (block.isFinalMerger) this.removeOutputNode(block);
    }
    /**
     * Build the material and generates the inner effect
     * @param verbose defines if the build should log activity
     * @param updateBuildId defines if the internal build Id should be updated (default is true)
     * @param autoConfigure defines if the autoConfigure method should be called when initializing blocks (default is false)
     */ build(verbose = false, updateBuildId = true, autoConfigure = false) {
        // First time?
        if (!this._vertexCompilationState && !autoConfigure) autoConfigure = true;
        this._buildWasSuccessful = false;
        const engine = this.getScene().getEngine();
        const allowEmptyVertexProgram = this._mode === (0, $5oHv1.NodeMaterialModes).Particle;
        if (this._vertexOutputNodes.length === 0 && !allowEmptyVertexProgram) // eslint-disable-next-line no-throw-literal
        throw "You must define at least one vertexOutputNode";
        if (this._fragmentOutputNodes.length === 0) // eslint-disable-next-line no-throw-literal
        throw "You must define at least one fragmentOutputNode";
        // Compilation state
        this._vertexCompilationState = new (0, $jHEyh.NodeMaterialBuildState)();
        this._vertexCompilationState.supportUniformBuffers = engine.supportsUniformBuffers;
        this._vertexCompilationState.target = (0, $iAIIe.NodeMaterialBlockTargets).Vertex;
        this._fragmentCompilationState = new (0, $jHEyh.NodeMaterialBuildState)();
        this._fragmentCompilationState.supportUniformBuffers = engine.supportsUniformBuffers;
        this._fragmentCompilationState.target = (0, $iAIIe.NodeMaterialBlockTargets).Fragment;
        // Shared data
        this._sharedData = new (0, $2k2yr.NodeMaterialBuildStateSharedData)();
        this._sharedData.nodeMaterial = this;
        this._sharedData.fragmentOutputNodes = this._fragmentOutputNodes;
        this._vertexCompilationState.sharedData = this._sharedData;
        this._fragmentCompilationState.sharedData = this._sharedData;
        this._sharedData.buildId = this._buildId;
        this._sharedData.emitComments = this._options.emitComments;
        this._sharedData.verbose = verbose;
        this._sharedData.scene = this.getScene();
        this._sharedData.allowEmptyVertexProgram = allowEmptyVertexProgram;
        // Initialize blocks
        const vertexNodes = [];
        const fragmentNodes = [];
        for (const vertexOutputNode of this._vertexOutputNodes){
            vertexNodes.push(vertexOutputNode);
            this._initializeBlock(vertexOutputNode, this._vertexCompilationState, fragmentNodes, autoConfigure);
        }
        for (const fragmentOutputNode of this._fragmentOutputNodes){
            fragmentNodes.push(fragmentOutputNode);
            this._initializeBlock(fragmentOutputNode, this._fragmentCompilationState, vertexNodes, autoConfigure);
        }
        // Optimize
        this.optimize();
        // Vertex
        for (const vertexOutputNode of vertexNodes)vertexOutputNode.build(this._vertexCompilationState, vertexNodes);
        // Fragment
        this._fragmentCompilationState.uniforms = this._vertexCompilationState.uniforms.slice(0);
        this._fragmentCompilationState._uniformDeclaration = this._vertexCompilationState._uniformDeclaration;
        this._fragmentCompilationState._constantDeclaration = this._vertexCompilationState._constantDeclaration;
        this._fragmentCompilationState._vertexState = this._vertexCompilationState;
        for (const fragmentOutputNode of fragmentNodes)this._resetDualBlocks(fragmentOutputNode, this._buildId - 1);
        for (const fragmentOutputNode of fragmentNodes)fragmentOutputNode.build(this._fragmentCompilationState, fragmentNodes);
        // Finalize
        this._vertexCompilationState.finalize(this._vertexCompilationState);
        this._fragmentCompilationState.finalize(this._fragmentCompilationState);
        if (updateBuildId) this._buildId = $3d35049eb9780bcb$export$caaf3b30a544c946._BuildIdGenerator++;
        // Errors
        this._sharedData.emitErrors();
        if (verbose) {
            (0, $kVtWi.Logger).Log("Vertex shader:");
            (0, $kVtWi.Logger).Log(this._vertexCompilationState.compilationString);
            (0, $kVtWi.Logger).Log("Fragment shader:");
            (0, $kVtWi.Logger).Log(this._fragmentCompilationState.compilationString);
        }
        this._buildWasSuccessful = true;
        this.onBuildObservable.notifyObservers(this);
        // Wipe defines
        const meshes = this.getScene().meshes;
        for (const mesh of meshes){
            if (!mesh.subMeshes) continue;
            for (const subMesh of mesh.subMeshes){
                if (subMesh.getMaterial() !== this) continue;
                if (!subMesh.materialDefines) continue;
                const defines = subMesh.materialDefines;
                defines.markAllAsDirty();
                defines.reset();
            }
        }
        if (this.prePassTextureInputs.length) this.getScene().enablePrePassRenderer();
        const prePassRenderer = this.getScene().prePassRenderer;
        if (prePassRenderer) prePassRenderer.markAsDirty();
    }
    /**
     * Runs an otpimization phase to try to improve the shader code
     */ optimize() {
        for (const optimizer of this._optimizers)optimizer.optimize(this._vertexOutputNodes, this._fragmentOutputNodes);
    }
    _prepareDefinesForAttributes(mesh, defines) {
        const oldNormal = defines["NORMAL"];
        const oldTangent = defines["TANGENT"];
        const oldColor = defines["VERTEXCOLOR_NME"];
        defines["NORMAL"] = mesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).NormalKind);
        defines["TANGENT"] = mesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).TangentKind);
        const hasVertexColors = mesh.useVertexColors && mesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).ColorKind);
        defines["VERTEXCOLOR_NME"] = hasVertexColors;
        let uvChanged = false;
        for(let i = 1; i <= 6; ++i){
            const oldUV = defines["UV" + i];
            defines["UV" + i] = mesh.isVerticesDataPresent(`uv${i === 1 ? "" : i}`);
            uvChanged = uvChanged || defines["UV" + i] !== oldUV;
        }
        // PrePass
        const oit = this.needAlphaBlendingForMesh(mesh) && this.getScene().useOrderIndependentTransparency;
        (0, $alPCh.PrepareDefinesForPrePass)(this.getScene(), defines, !oit);
        if (oldNormal !== defines["NORMAL"] || oldTangent !== defines["TANGENT"] || oldColor !== defines["VERTEXCOLOR_NME"] || uvChanged) defines.markAsAttributesDirty();
    }
    /**
     * Can this material render to prepass
     */ get isPrePassCapable() {
        return true;
    }
    /**
     * Outputs written to the prepass
     */ get prePassTextureOutputs() {
        const prePassOutputBlock = this.getBlockByPredicate((block)=>block.getClassName() === "PrePassOutputBlock");
        const result = [
            4
        ];
        if (!prePassOutputBlock) return result;
        // Cannot write to prepass if we alread read from prepass
        if (this.prePassTextureInputs.length) return result;
        if (prePassOutputBlock.viewDepth.isConnected) result.push(5);
        if (prePassOutputBlock.viewNormal.isConnected) result.push(6);
        if (prePassOutputBlock.worldPosition.isConnected) result.push(1);
        return result;
    }
    /**
     * Gets the list of prepass texture required
     */ get prePassTextureInputs() {
        const prePassTextureBlocks = this.getAllTextureBlocks().filter((block)=>block.getClassName() === "PrePassTextureBlock");
        const result = [];
        for (const block of prePassTextureBlocks){
            if (block.position.isConnected && !result.includes(1)) result.push(1);
            if (block.depth.isConnected && !result.includes(5)) result.push(5);
            if (block.normal.isConnected && !result.includes(6)) result.push(6);
        }
        return result;
    }
    /**
     * Sets the required values to the prepass renderer.
     * @param prePassRenderer defines the prepass renderer to set
     * @returns true if the pre pass is needed
     */ setPrePassRenderer(prePassRenderer) {
        const prePassTexturesRequired = this.prePassTextureInputs.concat(this.prePassTextureOutputs);
        if (prePassRenderer && prePassTexturesRequired.length > 1) {
            let cfg = prePassRenderer.getEffectConfiguration("nodeMaterial");
            if (!cfg) cfg = prePassRenderer.addEffectConfiguration({
                enabled: true,
                needsImageProcessing: false,
                name: "nodeMaterial",
                texturesRequired: []
            });
            for (const prePassTexture of prePassTexturesRequired)if (!cfg.texturesRequired.includes(prePassTexture)) cfg.texturesRequired.push(prePassTexture);
            cfg.enabled = true;
        }
        // COLOR_TEXTURE is always required for prepass, length > 1 means
        // we actually need to write to special prepass textures
        return prePassTexturesRequired.length > 1;
    }
    /**
     * Create a post process from the material
     * @param camera The camera to apply the render pass to.
     * @param options The required width/height ratio to downsize to before computing the render pass. (Use 1.0 for full size)
     * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
     * @param engine The engine which the post process will be applied. (default: current engine)
     * @param reusable If the post process can be reused on the same frame. (default: false)
     * @param textureType Type of textures used when performing the post process. (default: 0)
     * @param textureFormat Format of textures used when performing the post process. (default: TEXTUREFORMAT_RGBA)
     * @returns the post process created
     */ createPostProcess(camera, options = 1, samplingMode = 1, engine, reusable, textureType = 0, textureFormat = 5) {
        if (this.mode !== (0, $5oHv1.NodeMaterialModes).PostProcess) {
            (0, $kVtWi.Logger).Log("Incompatible material mode");
            return null;
        }
        return this._createEffectForPostProcess(null, camera, options, samplingMode, engine, reusable, textureType, textureFormat);
    }
    /**
     * Create the post process effect from the material
     * @param postProcess The post process to create the effect for
     */ createEffectForPostProcess(postProcess) {
        this._createEffectForPostProcess(postProcess);
    }
    _createEffectForPostProcess(postProcess, camera, options = 1, samplingMode = 1, engine, reusable, textureType = 0, textureFormat = 5) {
        let tempName = this.name + this._buildId;
        const defines = new $3d35049eb9780bcb$export$a521de9e19f1793b();
        const dummyMesh = new (0, $0cHNL.AbstractMesh)(tempName + "PostProcess", this.getScene());
        let buildId = this._buildId;
        this._processDefines(dummyMesh, defines);
        (0, $lUDWq.Effect).RegisterShader(tempName, this._fragmentCompilationState._builtCompilationString, this._vertexCompilationState._builtCompilationString);
        if (!postProcess) postProcess = new (0, $cFdBb.PostProcess)(this.name + "PostProcess", tempName, this._fragmentCompilationState.uniforms, this._fragmentCompilationState.samplers, options, camera, samplingMode, engine, reusable, defines.toString(), textureType, tempName, {
            maxSimultaneousLights: this.maxSimultaneousLights
        }, false, textureFormat);
        else postProcess.updateEffect(defines.toString(), this._fragmentCompilationState.uniforms, this._fragmentCompilationState.samplers, {
            maxSimultaneousLights: this.maxSimultaneousLights
        }, undefined, undefined, tempName, tempName);
        postProcess.nodeMaterialSource = this;
        postProcess.onApplyObservable.add((effect)=>{
            if (buildId !== this._buildId) {
                delete (0, $lUDWq.Effect).ShadersStore[tempName + "VertexShader"];
                delete (0, $lUDWq.Effect).ShadersStore[tempName + "PixelShader"];
                tempName = this.name + this._buildId;
                defines.markAllAsDirty();
                buildId = this._buildId;
            }
            const result = this._processDefines(dummyMesh, defines);
            if (result) {
                (0, $lUDWq.Effect).RegisterShader(tempName, this._fragmentCompilationState._builtCompilationString, this._vertexCompilationState._builtCompilationString);
                (0, $av6Bc.TimingTools).SetImmediate(()=>postProcess.updateEffect(defines.toString(), this._fragmentCompilationState.uniforms, this._fragmentCompilationState.samplers, {
                        maxSimultaneousLights: this.maxSimultaneousLights
                    }, undefined, undefined, tempName, tempName));
            }
            this._checkInternals(effect);
        });
        return postProcess;
    }
    /**
     * Create a new procedural texture based on this node material
     * @param size defines the size of the texture
     * @param scene defines the hosting scene
     * @returns the new procedural texture attached to this node material
     */ createProceduralTexture(size, scene) {
        if (this.mode !== (0, $5oHv1.NodeMaterialModes).ProceduralTexture) {
            (0, $kVtWi.Logger).Log("Incompatible material mode");
            return null;
        }
        let tempName = this.name + this._buildId;
        const proceduralTexture = new (0, $bds6B.ProceduralTexture)(tempName, size, null, scene);
        const dummyMesh = new (0, $0cHNL.AbstractMesh)(tempName + "Procedural", this.getScene());
        dummyMesh.reservedDataStore = {
            hidden: true
        };
        const defines = new $3d35049eb9780bcb$export$a521de9e19f1793b();
        const result = this._processDefines(dummyMesh, defines);
        (0, $lUDWq.Effect).RegisterShader(tempName, this._fragmentCompilationState._builtCompilationString, this._vertexCompilationState._builtCompilationString);
        let effect = this.getScene().getEngine().createEffect({
            vertexElement: tempName,
            fragmentElement: tempName
        }, [
            (0, $b4i1f.VertexBuffer).PositionKind
        ], this._fragmentCompilationState.uniforms, this._fragmentCompilationState.samplers, defines.toString(), result?.fallbacks, undefined);
        proceduralTexture.nodeMaterialSource = this;
        proceduralTexture._setEffect(effect);
        let buildId = this._buildId;
        proceduralTexture.onBeforeGenerationObservable.add(()=>{
            if (buildId !== this._buildId) {
                delete (0, $lUDWq.Effect).ShadersStore[tempName + "VertexShader"];
                delete (0, $lUDWq.Effect).ShadersStore[tempName + "PixelShader"];
                tempName = this.name + this._buildId;
                defines.markAllAsDirty();
                buildId = this._buildId;
            }
            const result = this._processDefines(dummyMesh, defines);
            if (result) {
                (0, $lUDWq.Effect).RegisterShader(tempName, this._fragmentCompilationState._builtCompilationString, this._vertexCompilationState._builtCompilationString);
                (0, $av6Bc.TimingTools).SetImmediate(()=>{
                    effect = this.getScene().getEngine().createEffect({
                        vertexElement: tempName,
                        fragmentElement: tempName
                    }, [
                        (0, $b4i1f.VertexBuffer).PositionKind
                    ], this._fragmentCompilationState.uniforms, this._fragmentCompilationState.samplers, defines.toString(), result?.fallbacks, undefined);
                    proceduralTexture._setEffect(effect);
                });
            }
            this._checkInternals(effect);
        });
        return proceduralTexture;
    }
    _createEffectForParticles(particleSystem, blendMode, onCompiled, onError, effect, defines, dummyMesh, particleSystemDefinesJoined = "") {
        let tempName = this.name + this._buildId + "_" + blendMode;
        if (!defines) defines = new $3d35049eb9780bcb$export$a521de9e19f1793b();
        if (!dummyMesh) {
            dummyMesh = this.getScene().getMeshByName(this.name + "Particle");
            if (!dummyMesh) {
                dummyMesh = new (0, $0cHNL.AbstractMesh)(this.name + "Particle", this.getScene());
                dummyMesh.reservedDataStore = {
                    hidden: true
                };
            }
        }
        let buildId = this._buildId;
        const particleSystemDefines = [];
        let join = particleSystemDefinesJoined;
        if (!effect) {
            const result = this._processDefines(dummyMesh, defines);
            (0, $lUDWq.Effect).RegisterShader(tempName, this._fragmentCompilationState._builtCompilationString);
            particleSystem.fillDefines(particleSystemDefines, blendMode);
            join = particleSystemDefines.join("\n");
            effect = this.getScene().getEngine().createEffectForParticles(tempName, this._fragmentCompilationState.uniforms, this._fragmentCompilationState.samplers, defines.toString() + "\n" + join, result?.fallbacks, onCompiled, onError, particleSystem);
            particleSystem.setCustomEffect(effect, blendMode);
        }
        effect.onBindObservable.add((effect)=>{
            if (buildId !== this._buildId) {
                delete (0, $lUDWq.Effect).ShadersStore[tempName + "PixelShader"];
                tempName = this.name + this._buildId + "_" + blendMode;
                defines.markAllAsDirty();
                buildId = this._buildId;
            }
            particleSystemDefines.length = 0;
            particleSystem.fillDefines(particleSystemDefines, blendMode);
            const particleSystemDefinesJoinedCurrent = particleSystemDefines.join("\n");
            if (particleSystemDefinesJoinedCurrent !== join) {
                defines.markAllAsDirty();
                join = particleSystemDefinesJoinedCurrent;
            }
            const result = this._processDefines(dummyMesh, defines);
            if (result) {
                (0, $lUDWq.Effect).RegisterShader(tempName, this._fragmentCompilationState._builtCompilationString);
                effect = this.getScene().getEngine().createEffectForParticles(tempName, this._fragmentCompilationState.uniforms, this._fragmentCompilationState.samplers, defines.toString() + "\n" + join, result?.fallbacks, onCompiled, onError, particleSystem);
                particleSystem.setCustomEffect(effect, blendMode);
                this._createEffectForParticles(particleSystem, blendMode, onCompiled, onError, effect, defines, dummyMesh, particleSystemDefinesJoined); // add the effect.onBindObservable observer
                return;
            }
            this._checkInternals(effect);
        });
    }
    _checkInternals(effect) {
        // Animated blocks
        if (this._sharedData.animatedInputs) {
            const scene = this.getScene();
            const frameId = scene.getFrameId();
            if (this._animationFrame !== frameId) {
                for (const input of this._sharedData.animatedInputs)input.animate(scene);
                this._animationFrame = frameId;
            }
        }
        // Bindable blocks
        for (const block of this._sharedData.bindableBlocks)block.bind(effect, this);
        // Connection points
        for (const inputBlock of this._sharedData.inputBlocks)inputBlock._transmit(effect, this.getScene(), this);
    }
    /**
     * Create the effect to be used as the custom effect for a particle system
     * @param particleSystem Particle system to create the effect for
     * @param onCompiled defines a function to call when the effect creation is successful
     * @param onError defines a function to call when the effect creation has failed
     */ createEffectForParticles(particleSystem, onCompiled, onError) {
        if (this.mode !== (0, $5oHv1.NodeMaterialModes).Particle) {
            (0, $kVtWi.Logger).Log("Incompatible material mode");
            return;
        }
        this._createEffectForParticles(particleSystem, (0, $1iaDW.BaseParticleSystem).BLENDMODE_ONEONE, onCompiled, onError);
        this._createEffectForParticles(particleSystem, (0, $1iaDW.BaseParticleSystem).BLENDMODE_MULTIPLY, onCompiled, onError);
    }
    /**
     * Use this material as the shadow depth wrapper of a target material
     * @param targetMaterial defines the target material
     */ createAsShadowDepthWrapper(targetMaterial) {
        if (this.mode !== (0, $5oHv1.NodeMaterialModes).Material) {
            (0, $kVtWi.Logger).Log("Incompatible material mode");
            return;
        }
        targetMaterial.shadowDepthWrapper = new BABYLON.ShadowDepthWrapper(this, this.getScene());
    }
    _processDefines(mesh, defines, useInstances = false, subMesh) {
        let result = null;
        // Global defines
        const scene = this.getScene();
        if ((0, $alPCh.PrepareDefinesForCamera)(scene, defines)) defines.markAsMiscDirty();
        // Shared defines
        this._sharedData.blocksWithDefines.forEach((b)=>{
            b.initializeDefines(mesh, this, defines, useInstances);
        });
        this._sharedData.blocksWithDefines.forEach((b)=>{
            b.prepareDefines(mesh, this, defines, useInstances, subMesh);
        });
        // Need to recompile?
        if (defines.isDirty) {
            const lightDisposed = defines._areLightsDisposed;
            defines.markAsProcessed();
            // Repeatable content generators
            this._vertexCompilationState.compilationString = this._vertexCompilationState._builtCompilationString;
            this._fragmentCompilationState.compilationString = this._fragmentCompilationState._builtCompilationString;
            this._sharedData.repeatableContentBlocks.forEach((b)=>{
                b.replaceRepeatableContent(this._vertexCompilationState, this._fragmentCompilationState, mesh, defines);
            });
            // Uniforms
            const uniformBuffers = [];
            this._sharedData.dynamicUniformBlocks.forEach((b)=>{
                b.updateUniformsAndSamples(this._vertexCompilationState, this, defines, uniformBuffers);
            });
            const mergedUniforms = this._vertexCompilationState.uniforms;
            this._fragmentCompilationState.uniforms.forEach((u)=>{
                const index = mergedUniforms.indexOf(u);
                if (index === -1) mergedUniforms.push(u);
            });
            // Samplers
            const mergedSamplers = this._vertexCompilationState.samplers;
            this._fragmentCompilationState.samplers.forEach((s)=>{
                const index = mergedSamplers.indexOf(s);
                if (index === -1) mergedSamplers.push(s);
            });
            const fallbacks = new (0, $gc8Ja.EffectFallbacks)();
            this._sharedData.blocksWithFallbacks.forEach((b)=>{
                b.provideFallbacks(mesh, fallbacks);
            });
            result = {
                lightDisposed: lightDisposed,
                uniformBuffers: uniformBuffers,
                mergedUniforms: mergedUniforms,
                mergedSamplers: mergedSamplers,
                fallbacks: fallbacks
            };
        }
        return result;
    }
    /**
     * Get if the submesh is ready to be used and all its information available.
     * Child classes can use it to update shaders
     * @param mesh defines the mesh to check
     * @param subMesh defines which submesh to check
     * @param useInstances specifies that instances should be used
     * @returns a boolean indicating that the submesh is ready or not
     */ isReadyForSubMesh(mesh, subMesh, useInstances = false) {
        if (!this._buildWasSuccessful) return false;
        const scene = this.getScene();
        if (this._sharedData.animatedInputs) {
            const frameId = scene.getFrameId();
            if (this._animationFrame !== frameId) {
                for (const input of this._sharedData.animatedInputs)input.animate(scene);
                this._animationFrame = frameId;
            }
        }
        const drawWrapper = subMesh._drawWrapper;
        if (drawWrapper.effect && this.isFrozen) {
            if (drawWrapper._wasPreviouslyReady && drawWrapper._wasPreviouslyUsingInstances === useInstances) return true;
        }
        if (!subMesh.materialDefines) subMesh.materialDefines = new $3d35049eb9780bcb$export$a521de9e19f1793b();
        const defines = subMesh.materialDefines;
        if (this._isReadyForSubMesh(subMesh)) return true;
        const engine = scene.getEngine();
        this._prepareDefinesForAttributes(mesh, defines);
        // Check if blocks are ready
        if (this._sharedData.blockingBlocks.some((b)=>!b.isReady(mesh, this, defines, useInstances))) return false;
        const result = this._processDefines(mesh, defines, useInstances, subMesh);
        if (result) {
            const previousEffect = subMesh.effect;
            // Compilation
            const join = defines.toString();
            let effect = engine.createEffect({
                vertex: "nodeMaterial" + this._buildId,
                fragment: "nodeMaterial" + this._buildId,
                vertexSource: this._vertexCompilationState.compilationString,
                fragmentSource: this._fragmentCompilationState.compilationString
            }, {
                attributes: this._vertexCompilationState.attributes,
                uniformsNames: result.mergedUniforms,
                uniformBuffersNames: result.uniformBuffers,
                samplers: result.mergedSamplers,
                defines: join,
                fallbacks: result.fallbacks,
                onCompiled: this.onCompiled,
                onError: this.onError,
                multiTarget: defines.PREPASS,
                indexParameters: {
                    maxSimultaneousLights: this.maxSimultaneousLights,
                    maxSimultaneousMorphTargets: defines.NUM_MORPH_INFLUENCERS
                }
            }, engine);
            if (effect) {
                if (this._onEffectCreatedObservable) {
                    $3d35049eb9780bcb$var$onCreatedEffectParameters.effect = effect;
                    $3d35049eb9780bcb$var$onCreatedEffectParameters.subMesh = subMesh;
                    this._onEffectCreatedObservable.notifyObservers($3d35049eb9780bcb$var$onCreatedEffectParameters);
                }
                // Use previous effect while new one is compiling
                if (this.allowShaderHotSwapping && previousEffect && !effect.isReady()) {
                    effect = previousEffect;
                    defines.markAsUnprocessed();
                    if (result.lightDisposed) {
                        // re register in case it takes more than one frame.
                        defines._areLightsDisposed = true;
                        return false;
                    }
                } else {
                    scene.resetCachedMaterial();
                    subMesh.setEffect(effect, defines, this._materialContext);
                }
            }
        }
        if (!subMesh.effect || !subMesh.effect.isReady()) return false;
        defines._renderId = scene.getRenderId();
        drawWrapper._wasPreviouslyReady = true;
        drawWrapper._wasPreviouslyUsingInstances = useInstances;
        this._checkScenePerformancePriority();
        return true;
    }
    /**
     * Get a string representing the shaders built by the current node graph
     */ get compiledShaders() {
        return `// Vertex shader\n${this._vertexCompilationState.compilationString}\n\n// Fragment shader\n${this._fragmentCompilationState.compilationString}`;
    }
    /**
     * Binds the world matrix to the material
     * @param world defines the world transformation matrix
     */ bindOnlyWorldMatrix(world) {
        const scene = this.getScene();
        if (!this._activeEffect) return;
        const hints = this._sharedData.hints;
        if (hints.needWorldViewMatrix) world.multiplyToRef(scene.getViewMatrix(), this._cachedWorldViewMatrix);
        if (hints.needWorldViewProjectionMatrix) world.multiplyToRef(scene.getTransformMatrix(), this._cachedWorldViewProjectionMatrix);
        // Connection points
        for (const inputBlock of this._sharedData.inputBlocks)inputBlock._transmitWorld(this._activeEffect, world, this._cachedWorldViewMatrix, this._cachedWorldViewProjectionMatrix);
    }
    /**
     * Binds the submesh to this material by preparing the effect and shader to draw
     * @param world defines the world transformation matrix
     * @param mesh defines the mesh containing the submesh
     * @param subMesh defines the submesh to bind the material to
     */ bindForSubMesh(world, mesh, subMesh) {
        const scene = this.getScene();
        const effect = subMesh.effect;
        if (!effect) return;
        this._activeEffect = effect;
        // Matrices
        this.bindOnlyWorldMatrix(world);
        const mustRebind = this._mustRebind(scene, effect, subMesh, mesh.visibility);
        const sharedData = this._sharedData;
        if (mustRebind) {
            // Bindable blocks
            for (const block of sharedData.bindableBlocks)block.bind(effect, this, mesh, subMesh);
            for (const block of sharedData.forcedBindableBlocks)block.bind(effect, this, mesh, subMesh);
            // Connection points
            for (const inputBlock of sharedData.inputBlocks)inputBlock._transmit(effect, scene, this);
        } else if (!this.isFrozen) for (const block of sharedData.forcedBindableBlocks)block.bind(effect, this, mesh, subMesh);
        this._afterBind(mesh, this._activeEffect, subMesh);
    }
    /**
     * Gets the active textures from the material
     * @returns an array of textures
     */ getActiveTextures() {
        const activeTextures = super.getActiveTextures();
        if (this._sharedData) activeTextures.push(...this._sharedData.textureBlocks.filter((tb)=>tb.texture).map((tb)=>tb.texture));
        return activeTextures;
    }
    /**
     * Gets the list of texture blocks
     * Note that this method will only return blocks that are reachable from the final block(s) and only after the material has been built!
     * @returns an array of texture blocks
     */ getTextureBlocks() {
        if (!this._sharedData) return [];
        return this._sharedData.textureBlocks;
    }
    /**
     * Gets the list of all texture blocks
     * Note that this method will scan all attachedBlocks and return blocks that are texture blocks
     * @returns
     */ getAllTextureBlocks() {
        const textureBlocks = [];
        for (const block of this.attachedBlocks)if ($3d35049eb9780bcb$export$caaf3b30a544c946._BlockIsTextureBlock(block)) textureBlocks.push(block);
        return textureBlocks;
    }
    /**
     * Specifies if the material uses a texture
     * @param texture defines the texture to check against the material
     * @returns a boolean specifying if the material uses the texture
     */ hasTexture(texture) {
        if (super.hasTexture(texture)) return true;
        if (!this._sharedData) return false;
        for (const t of this._sharedData.textureBlocks){
            if (t.texture === texture) return true;
        }
        return false;
    }
    /**
     * Disposes the material
     * @param forceDisposeEffect specifies if effects should be forcefully disposed
     * @param forceDisposeTextures specifies if textures should be forcefully disposed
     * @param notBoundToMesh specifies if the material that is being disposed is known to be not bound to any mesh
     */ dispose(forceDisposeEffect, forceDisposeTextures, notBoundToMesh) {
        if (forceDisposeTextures) for (const texture of this.getTextureBlocks().filter((tb)=>tb.texture).map((tb)=>tb.texture))texture.dispose();
        for (const block of this.attachedBlocks)block.dispose();
        this.attachedBlocks.length = 0;
        this._sharedData = null;
        this._vertexCompilationState = null;
        this._fragmentCompilationState = null;
        this.onBuildObservable.clear();
        if (this._imageProcessingObserver) {
            this._imageProcessingConfiguration.onUpdateParameters.remove(this._imageProcessingObserver);
            this._imageProcessingObserver = null;
        }
        super.dispose(forceDisposeEffect, forceDisposeTextures, notBoundToMesh);
    }
    /** Creates the node editor window.
     * @param additionalConfig Define the configuration of the editor
     */ _createNodeEditor(additionalConfig) {
        const nodeEditorConfig = {
            nodeMaterial: this,
            ...additionalConfig
        };
        this.BJSNODEMATERIALEDITOR.NodeEditor.Show(nodeEditorConfig);
    }
    /**
     * Launch the node material editor
     * @param config Define the configuration of the editor
     * @returns a promise fulfilled when the node editor is visible
     */ edit(config) {
        return new Promise((resolve)=>{
            this.BJSNODEMATERIALEDITOR = this.BJSNODEMATERIALEDITOR || this._getGlobalNodeMaterialEditor();
            if (typeof this.BJSNODEMATERIALEDITOR == "undefined") {
                const editorUrl = config && config.editorURL ? config.editorURL : $3d35049eb9780bcb$export$caaf3b30a544c946.EditorURL;
                // Load editor and add it to the DOM
                (0, $bOhSV.Tools).LoadBabylonScript(editorUrl, ()=>{
                    this.BJSNODEMATERIALEDITOR = this.BJSNODEMATERIALEDITOR || this._getGlobalNodeMaterialEditor();
                    this._createNodeEditor(config?.nodeEditorConfig);
                    resolve();
                });
            } else {
                // Otherwise creates the editor
                this._createNodeEditor(config?.nodeEditorConfig);
                resolve();
            }
        });
    }
    /**
     * Clear the current material
     */ clear() {
        this._vertexOutputNodes.length = 0;
        this._fragmentOutputNodes.length = 0;
        this.attachedBlocks.length = 0;
    }
    /**
     * Clear the current material and set it to a default state
     */ setToDefault() {
        this.clear();
        this.editorData = null;
        const positionInput = new (0, $aKEh2.InputBlock)("Position");
        positionInput.setAsAttribute("position");
        const worldInput = new (0, $aKEh2.InputBlock)("World");
        worldInput.setAsSystemValue((0, $7qH6c.NodeMaterialSystemValues).World);
        const worldPos = new (0, $cFAzb.TransformBlock)("WorldPos");
        positionInput.connectTo(worldPos);
        worldInput.connectTo(worldPos);
        const viewProjectionInput = new (0, $aKEh2.InputBlock)("ViewProjection");
        viewProjectionInput.setAsSystemValue((0, $7qH6c.NodeMaterialSystemValues).ViewProjection);
        const worldPosdMultipliedByViewProjection = new (0, $cFAzb.TransformBlock)("WorldPos * ViewProjectionTransform");
        worldPos.connectTo(worldPosdMultipliedByViewProjection);
        viewProjectionInput.connectTo(worldPosdMultipliedByViewProjection);
        const vertexOutput = new (0, $eH9s9.VertexOutputBlock)("VertexOutput");
        worldPosdMultipliedByViewProjection.connectTo(vertexOutput);
        // Pixel
        const pixelColor = new (0, $aKEh2.InputBlock)("color");
        pixelColor.value = new (0, $7etnY.Color4)(0.8, 0.8, 0.8, 1);
        const fragmentOutput = new (0, $9d6MD.FragmentOutputBlock)("FragmentOutput");
        pixelColor.connectTo(fragmentOutput);
        // Add to nodes
        this.addOutputNode(vertexOutput);
        this.addOutputNode(fragmentOutput);
        this._mode = (0, $5oHv1.NodeMaterialModes).Material;
    }
    /**
     * Clear the current material and set it to a default state for post process
     */ setToDefaultPostProcess() {
        this.clear();
        this.editorData = null;
        const position = new (0, $aKEh2.InputBlock)("Position");
        position.setAsAttribute("position2d");
        const const1 = new (0, $aKEh2.InputBlock)("Constant1");
        const1.isConstant = true;
        const1.value = 1;
        const vmerger = new (0, $jnIu6.VectorMergerBlock)("Position3D");
        position.connectTo(vmerger);
        const1.connectTo(vmerger, {
            input: "w"
        });
        const vertexOutput = new (0, $eH9s9.VertexOutputBlock)("VertexOutput");
        vmerger.connectTo(vertexOutput);
        // Pixel
        const scale = new (0, $aKEh2.InputBlock)("Scale");
        scale.visibleInInspector = true;
        scale.value = new (0, $ha1VO.Vector2)(1, 1);
        const uv0 = new (0, $dIpWY.RemapBlock)("uv0");
        position.connectTo(uv0);
        const uv = new (0, $fTSHo.MultiplyBlock)("UV scale");
        uv0.connectTo(uv);
        scale.connectTo(uv);
        const currentScreen = new (0, $h62fU.CurrentScreenBlock)("CurrentScreen");
        uv.connectTo(currentScreen);
        currentScreen.texture = new (0, $j2mX5.Texture)("https://assets.babylonjs.com/nme/currentScreenPostProcess.png", this.getScene());
        const fragmentOutput = new (0, $9d6MD.FragmentOutputBlock)("FragmentOutput");
        currentScreen.connectTo(fragmentOutput, {
            output: "rgba"
        });
        // Add to nodes
        this.addOutputNode(vertexOutput);
        this.addOutputNode(fragmentOutput);
        this._mode = (0, $5oHv1.NodeMaterialModes).PostProcess;
    }
    /**
     * Clear the current material and set it to a default state for procedural texture
     */ setToDefaultProceduralTexture() {
        this.clear();
        this.editorData = null;
        const position = new (0, $aKEh2.InputBlock)("Position");
        position.setAsAttribute("position2d");
        const const1 = new (0, $aKEh2.InputBlock)("Constant1");
        const1.isConstant = true;
        const1.value = 1;
        const vmerger = new (0, $jnIu6.VectorMergerBlock)("Position3D");
        position.connectTo(vmerger);
        const1.connectTo(vmerger, {
            input: "w"
        });
        const vertexOutput = new (0, $eH9s9.VertexOutputBlock)("VertexOutput");
        vmerger.connectTo(vertexOutput);
        // Pixel
        const time = new (0, $aKEh2.InputBlock)("Time");
        time.value = 0;
        time.min = 0;
        time.max = 0;
        time.isBoolean = false;
        time.matrixMode = 0;
        time.animationType = (0, $apsYB.AnimatedInputBlockTypes).Time;
        time.isConstant = false;
        const color = new (0, $aKEh2.InputBlock)("Color3");
        color.value = new (0, $7etnY.Color3)(1, 1, 1);
        color.isConstant = false;
        const fragmentOutput = new (0, $9d6MD.FragmentOutputBlock)("FragmentOutput");
        const vectorMerger = new (0, $jnIu6.VectorMergerBlock)("VectorMerger");
        vectorMerger.visibleInInspector = false;
        const cos = new (0, $3hVDe.TrigonometryBlock)("Cos");
        cos.operation = (0, $3hVDe.TrigonometryBlockOperations).Cos;
        position.connectTo(vectorMerger);
        time.output.connectTo(cos.input);
        cos.output.connectTo(vectorMerger.z);
        vectorMerger.xyzOut.connectTo(fragmentOutput.rgb);
        // Add to nodes
        this.addOutputNode(vertexOutput);
        this.addOutputNode(fragmentOutput);
        this._mode = (0, $5oHv1.NodeMaterialModes).ProceduralTexture;
    }
    /**
     * Clear the current material and set it to a default state for particle
     */ setToDefaultParticle() {
        this.clear();
        this.editorData = null;
        // Pixel
        const uv = new (0, $aKEh2.InputBlock)("uv");
        uv.setAsAttribute("particle_uv");
        const texture = new (0, $hExiF.ParticleTextureBlock)("ParticleTexture");
        uv.connectTo(texture);
        const color = new (0, $aKEh2.InputBlock)("Color");
        color.setAsAttribute("particle_color");
        const multiply = new (0, $fTSHo.MultiplyBlock)("Texture * Color");
        texture.connectTo(multiply);
        color.connectTo(multiply);
        const rampGradient = new (0, $ejSsy.ParticleRampGradientBlock)("ParticleRampGradient");
        multiply.connectTo(rampGradient);
        const cSplitter = new (0, $6XqNB.ColorSplitterBlock)("ColorSplitter");
        color.connectTo(cSplitter);
        const blendMultiply = new (0, $h7sVv.ParticleBlendMultiplyBlock)("ParticleBlendMultiply");
        rampGradient.connectTo(blendMultiply);
        texture.connectTo(blendMultiply, {
            output: "a"
        });
        cSplitter.connectTo(blendMultiply, {
            output: "a"
        });
        const fragmentOutput = new (0, $9d6MD.FragmentOutputBlock)("FragmentOutput");
        blendMultiply.connectTo(fragmentOutput);
        // Add to nodes
        this.addOutputNode(fragmentOutput);
        this._mode = (0, $5oHv1.NodeMaterialModes).Particle;
    }
    /**
     * Loads the current Node Material from a url pointing to a file save by the Node Material Editor
     * @deprecated Please use NodeMaterial.ParseFromFileAsync instead
     * @param url defines the url to load from
     * @param rootUrl defines the root URL for nested url in the node material
     * @returns a promise that will fulfil when the material is fully loaded
     */ async loadAsync(url, rootUrl = "") {
        return $3d35049eb9780bcb$export$caaf3b30a544c946.ParseFromFileAsync("", url, this.getScene(), rootUrl, true, this);
    }
    _gatherBlocks(rootNode, list) {
        if (list.indexOf(rootNode) !== -1) return;
        list.push(rootNode);
        for (const input of rootNode.inputs){
            const connectedPoint = input.connectedPoint;
            if (connectedPoint) {
                const block = connectedPoint.ownerBlock;
                if (block !== rootNode) this._gatherBlocks(block, list);
            }
        }
        // Teleportation
        if (rootNode.isTeleportOut) {
            const block = rootNode;
            if (block.entryPoint) this._gatherBlocks(block.entryPoint, list);
        }
    }
    /**
     * Generate a string containing the code declaration required to create an equivalent of this material
     * @returns a string
     */ generateCode() {
        let alreadyDumped = [];
        const vertexBlocks = [];
        const uniqueNames = [
            "const",
            "var",
            "let"
        ];
        // Gets active blocks
        for (const outputNode of this._vertexOutputNodes)this._gatherBlocks(outputNode, vertexBlocks);
        const fragmentBlocks = [];
        for (const outputNode of this._fragmentOutputNodes)this._gatherBlocks(outputNode, fragmentBlocks);
        // Generate vertex shader
        let codeString = `var nodeMaterial = new BABYLON.NodeMaterial("${this.name || "node material"}");\n`;
        codeString += `nodeMaterial.mode = BABYLON.NodeMaterialModes.${(0, $5oHv1.NodeMaterialModes)[this.mode]};\n`;
        for (const node of vertexBlocks)if (node.isInput && alreadyDumped.indexOf(node) === -1) codeString += node._dumpCode(uniqueNames, alreadyDumped);
        // Generate fragment shader
        for (const node of fragmentBlocks)if (node.isInput && alreadyDumped.indexOf(node) === -1) codeString += node._dumpCode(uniqueNames, alreadyDumped);
        // Connections
        alreadyDumped = [];
        codeString += "\n// Connections\n";
        for (const node of this._vertexOutputNodes)codeString += node._dumpCodeForOutputConnections(alreadyDumped);
        for (const node of this._fragmentOutputNodes)codeString += node._dumpCodeForOutputConnections(alreadyDumped);
        // Output nodes
        codeString += "\n// Output nodes\n";
        for (const node of this._vertexOutputNodes)codeString += `nodeMaterial.addOutputNode(${node._codeVariableName});\n`;
        for (const node of this._fragmentOutputNodes)codeString += `nodeMaterial.addOutputNode(${node._codeVariableName});\n`;
        codeString += `nodeMaterial.build();\n`;
        return codeString;
    }
    /**
     * Serializes this material in a JSON representation
     * @param selectedBlocks defines an optional list of blocks to serialize
     * @returns the serialized material object
     */ serialize(selectedBlocks) {
        const serializationObject = selectedBlocks ? {} : (0, $6Ho1L.SerializationHelper).Serialize(this);
        serializationObject.editorData = JSON.parse(JSON.stringify(this.editorData)); // Copy
        let blocks = [];
        if (selectedBlocks) blocks = selectedBlocks;
        else {
            serializationObject.customType = "BABYLON.NodeMaterial";
            serializationObject.outputNodes = [];
            // Outputs
            for (const outputNode of this._vertexOutputNodes){
                this._gatherBlocks(outputNode, blocks);
                serializationObject.outputNodes.push(outputNode.uniqueId);
            }
            for (const outputNode of this._fragmentOutputNodes){
                this._gatherBlocks(outputNode, blocks);
                if (serializationObject.outputNodes.indexOf(outputNode.uniqueId) === -1) serializationObject.outputNodes.push(outputNode.uniqueId);
            }
        }
        // Blocks
        serializationObject.blocks = [];
        for (const block of blocks)serializationObject.blocks.push(block.serialize());
        if (!selectedBlocks) for (const block of this.attachedBlocks){
            if (blocks.indexOf(block) !== -1) continue;
            serializationObject.blocks.push(block.serialize());
        }
        return serializationObject;
    }
    _restoreConnections(block, source, map) {
        for (const outputPoint of block.outputs)for (const candidate of source.blocks){
            const target = map[candidate.id];
            if (!target) continue;
            for (const input of candidate.inputs)if (map[input.targetBlockId] === block && input.targetConnectionName === outputPoint.name) {
                const inputPoint = target.getInputByName(input.inputName);
                if (!inputPoint || inputPoint.isConnected) continue;
                outputPoint.connectTo(inputPoint, true);
                this._restoreConnections(target, source, map);
                continue;
            }
        }
    }
    /**
     * Clear the current graph and load a new one from a serialization object
     * @param source defines the JSON representation of the material
     * @param rootUrl defines the root URL to use to load textures and relative dependencies
     * @param merge defines whether or not the source must be merged or replace the current content
     */ parseSerializedObject(source, rootUrl = "", merge = false) {
        if (!merge) this.clear();
        const map = {};
        // Create blocks
        for (const parsedBlock of source.blocks){
            const blockType = (0, $8DoUR.GetClass)(parsedBlock.customType);
            if (blockType) {
                const block = new blockType();
                block._deserialize(parsedBlock, this.getScene(), rootUrl);
                map[parsedBlock.id] = block;
                this.attachedBlocks.push(block);
            }
        }
        // Reconnect teleportation
        for (const block of this.attachedBlocks)if (block.isTeleportOut) {
            const teleportOut = block;
            const id = teleportOut._tempEntryPointUniqueId;
            if (id) {
                const source = map[id];
                source.attachToEndpoint(teleportOut);
            }
        }
        // Connections - Starts with input blocks only (except if in "merge" mode where we scan all blocks)
        for(let blockIndex = 0; blockIndex < source.blocks.length; blockIndex++){
            const parsedBlock = source.blocks[blockIndex];
            const block = map[parsedBlock.id];
            if (!block) continue;
            if (block.inputs.length && !merge) continue;
            this._restoreConnections(block, source, map);
        }
        // Outputs
        if (source.outputNodes) for (const outputNodeId of source.outputNodes)this.addOutputNode(map[outputNodeId]);
        // UI related info
        if (source.locations || source.editorData && source.editorData.locations) {
            const locations = source.locations || source.editorData.locations;
            for (const location of locations)if (map[location.blockId]) location.blockId = map[location.blockId].uniqueId;
            if (merge && this.editorData && this.editorData.locations) locations.concat(this.editorData.locations);
            if (source.locations) this.editorData = {
                locations: locations
            };
            else {
                this.editorData = source.editorData;
                this.editorData.locations = locations;
            }
            const blockMap = [];
            for(const key in map)blockMap[key] = map[key].uniqueId;
            this.editorData.map = blockMap;
        }
        this.comment = source.comment;
        if (source.forceAlphaBlending !== undefined) this.forceAlphaBlending = source.forceAlphaBlending;
        if (source.alphaMode !== undefined) this.alphaMode = source.alphaMode;
        if (!merge) this._mode = source.mode ?? (0, $5oHv1.NodeMaterialModes).Material;
    }
    /**
     * Clear the current graph and load a new one from a serialization object
     * @param source defines the JSON representation of the material
     * @param rootUrl defines the root URL to use to load textures and relative dependencies
     * @param merge defines whether or not the source must be merged or replace the current content
     * @deprecated Please use the parseSerializedObject method instead
     */ loadFromSerialization(source, rootUrl = "", merge = false) {
        this.parseSerializedObject(source, rootUrl, merge);
    }
    /**
     * Makes a duplicate of the current material.
     * @param name defines the name to use for the new material
     * @param shareEffect defines if the clone material should share the same effect (default is false)
     * @returns the cloned material
     */ clone(name, shareEffect = false) {
        const serializationObject = this.serialize();
        const clone = (0, $6Ho1L.SerializationHelper).Clone(()=>new $3d35049eb9780bcb$export$caaf3b30a544c946(name, this.getScene(), this.options), this);
        clone.id = name;
        clone.name = name;
        clone.parseSerializedObject(serializationObject);
        clone._buildId = this._buildId;
        clone.build(false, !shareEffect);
        return clone;
    }
    /**
     * Awaits for all the material textures to be ready before resolving the returned promise.
     * @returns A promise that resolves when the textures are ready.
     */ whenTexturesReadyAsync() {
        // Ensures all textures are ready to render.
        const textureReadyPromises = [];
        this.getActiveTextures().forEach((texture)=>{
            const internalTexture = texture.getInternalTexture();
            if (internalTexture && !internalTexture.isReady) textureReadyPromises.push(new Promise((textureResolve, textureReject)=>{
                internalTexture.onLoadedObservable.addOnce(()=>{
                    textureResolve();
                });
                internalTexture.onErrorObservable.addOnce((e)=>{
                    textureReject(e);
                });
            }));
        });
        return Promise.all(textureReadyPromises);
    }
    /**
     * Creates a node material from parsed material data
     * @param source defines the JSON representation of the material
     * @param scene defines the hosting scene
     * @param rootUrl defines the root URL to use to load textures and relative dependencies
     * @returns a new node material
     */ static Parse(source, scene, rootUrl = "") {
        const nodeMaterial = (0, $6Ho1L.SerializationHelper).Parse(()=>new $3d35049eb9780bcb$export$caaf3b30a544c946(source.name, scene), source, scene, rootUrl);
        nodeMaterial.parseSerializedObject(source, rootUrl);
        nodeMaterial.build();
        return nodeMaterial;
    }
    /**
     * Creates a node material from a snippet saved in a remote file
     * @param name defines the name of the material to create
     * @param url defines the url to load from
     * @param scene defines the hosting scene
     * @param rootUrl defines the root URL for nested url in the node material
     * @param skipBuild defines whether to build the node material
     * @param targetMaterial defines a material to use instead of creating a new one
     * @returns a promise that will resolve to the new node material
     */ static async ParseFromFileAsync(name, url, scene, rootUrl = "", skipBuild = false, targetMaterial) {
        const material = targetMaterial ?? new $3d35049eb9780bcb$export$caaf3b30a544c946(name, scene);
        const data = await scene._loadFileAsync(url);
        const serializationObject = JSON.parse(data);
        material.parseSerializedObject(serializationObject, rootUrl);
        if (!skipBuild) material.build();
        return material;
    }
    /**
     * Creates a node material from a snippet saved by the node material editor
     * @param snippetId defines the snippet to load
     * @param scene defines the hosting scene
     * @param rootUrl defines the root URL to use to load textures and relative dependencies
     * @param nodeMaterial defines a node material to update (instead of creating a new one)
     * @param skipBuild defines whether to build the node material
     * @param waitForTextureReadyness defines whether to wait for texture readiness resolving the promise (default: false)
     * @returns a promise that will resolve to the new node material
     */ static ParseFromSnippetAsync(snippetId, scene = (0, $ejQPp.EngineStore).LastCreatedScene, rootUrl = "", nodeMaterial, skipBuild = false, waitForTextureReadyness = false) {
        if (snippetId === "_BLANK") return Promise.resolve($3d35049eb9780bcb$export$caaf3b30a544c946.CreateDefault("blank", scene));
        return new Promise((resolve, reject)=>{
            const request = new (0, $hUzEl.WebRequest)();
            request.addEventListener("readystatechange", ()=>{
                if (request.readyState == 4) {
                    if (request.status == 200) {
                        const snippet = JSON.parse(JSON.parse(request.responseText).jsonPayload);
                        const serializationObject = JSON.parse(snippet.nodeMaterial);
                        if (!nodeMaterial) {
                            nodeMaterial = (0, $6Ho1L.SerializationHelper).Parse(()=>new $3d35049eb9780bcb$export$caaf3b30a544c946(snippetId, scene), serializationObject, scene, rootUrl);
                            nodeMaterial.uniqueId = scene.getUniqueId();
                        }
                        nodeMaterial.parseSerializedObject(serializationObject);
                        nodeMaterial.snippetId = snippetId;
                        try {
                            if (!skipBuild) nodeMaterial.build();
                        } catch (err) {
                            reject(err);
                        }
                        if (waitForTextureReadyness) nodeMaterial.whenTexturesReadyAsync().then(()=>{
                            resolve(nodeMaterial);
                        }).catch((err)=>{
                            reject(err);
                        });
                        else resolve(nodeMaterial);
                    } else reject("Unable to load the snippet " + snippetId);
                }
            });
            request.open("GET", this.SnippetUrl + "/" + snippetId.replace(/#/g, "/"));
            request.send();
        });
    }
    /**
     * Creates a new node material set to default basic configuration
     * @param name defines the name of the material
     * @param scene defines the hosting scene
     * @returns a new NodeMaterial
     */ static CreateDefault(name, scene) {
        const newMaterial = new $3d35049eb9780bcb$export$caaf3b30a544c946(name, scene);
        newMaterial.setToDefault();
        newMaterial.build();
        return newMaterial;
    }
}
$3d35049eb9780bcb$export$caaf3b30a544c946._BuildIdGenerator = 0;
/** Define the Url to load node editor script */ $3d35049eb9780bcb$export$caaf3b30a544c946.EditorURL = `${(0, $bOhSV.Tools)._DefaultCdnUrl}/v${(0, $5YkyR.Engine).Version}/nodeEditor/babylon.nodeEditor.js`;
/** Define the Url to load snippets */ $3d35049eb9780bcb$export$caaf3b30a544c946.SnippetUrl = `https://snippet.babylonjs.com`;
/** Gets or sets a boolean indicating that node materials should not deserialize textures from json / snippet content */ $3d35049eb9780bcb$export$caaf3b30a544c946.IgnoreTexturesAtLoadTime = false;
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3d35049eb9780bcb$export$caaf3b30a544c946.prototype, "ignoreAlpha", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3d35049eb9780bcb$export$caaf3b30a544c946.prototype, "maxSimultaneousLights", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("mode")
], $3d35049eb9780bcb$export$caaf3b30a544c946.prototype, "_mode", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("comment")
], $3d35049eb9780bcb$export$caaf3b30a544c946.prototype, "comment", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3d35049eb9780bcb$export$caaf3b30a544c946.prototype, "forceAlphaBlending", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.NodeMaterial", $3d35049eb9780bcb$export$caaf3b30a544c946);

});
parcelRegister("atHN2", function(module, exports) {

$parcel$export(module.exports, "PushMaterial", () => $7a0e949889738692$export$9026dbc30178f7ea);

var $ha1VO = parcelRequire("ha1VO");

var $54229 = parcelRequire("54229");
class $7a0e949889738692$export$9026dbc30178f7ea extends (0, $54229.Material) {
    constructor(name, scene, storeEffectOnSubMeshes = true){
        super(name, scene);
        this._normalMatrix = new (0, $ha1VO.Matrix)();
        this._storeEffectOnSubMeshes = storeEffectOnSubMeshes;
    }
    getEffect() {
        return this._storeEffectOnSubMeshes ? this._activeEffect : super.getEffect();
    }
    isReady(mesh, useInstances) {
        if (!mesh) return false;
        if (!this._storeEffectOnSubMeshes) return true;
        if (!mesh.subMeshes || mesh.subMeshes.length === 0) return true;
        return this.isReadyForSubMesh(mesh, mesh.subMeshes[0], useInstances);
    }
    _isReadyForSubMesh(subMesh) {
        const defines = subMesh.materialDefines;
        if (!this.checkReadyOnEveryCall && subMesh.effect && defines) {
            if (defines._renderId === this.getScene().getRenderId()) return true;
        }
        return false;
    }
    /**
     * Binds the given world matrix to the active effect
     *
     * @param world the matrix to bind
     */ bindOnlyWorldMatrix(world) {
        this._activeEffect.setMatrix("world", world);
    }
    /**
     * Binds the given normal matrix to the active effect
     *
     * @param normalMatrix the matrix to bind
     */ bindOnlyNormalMatrix(normalMatrix) {
        this._activeEffect.setMatrix("normalMatrix", normalMatrix);
    }
    bind(world, mesh) {
        if (!mesh) return;
        this.bindForSubMesh(world, mesh, mesh.subMeshes[0]);
    }
    _afterBind(mesh, effect = null, subMesh) {
        super._afterBind(mesh, effect, subMesh);
        this.getScene()._cachedEffect = effect;
        if (subMesh) subMesh._drawWrapper._forceRebindOnNextCall = false;
        else this._drawWrapper._forceRebindOnNextCall = false;
    }
    _mustRebind(scene, effect, subMesh, visibility = 1) {
        return subMesh._drawWrapper._forceRebindOnNextCall || scene.isCachedMaterialInvalid(this, effect, visibility);
    }
    dispose(forceDisposeEffect, forceDisposeTextures, notBoundToMesh) {
        this._activeEffect = undefined;
        super.dispose(forceDisposeEffect, forceDisposeTextures, notBoundToMesh);
    }
}

});

parcelRegister("jHEyh", function(module, exports) {

$parcel$export(module.exports, "NodeMaterialBuildState", () => $e5817d398b0befdb$export$63f500a2a65c65fd);

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $lUDWq = parcelRequire("lUDWq");
class $e5817d398b0befdb$export$63f500a2a65c65fd {
    constructor(){
        /** Gets or sets a boolean indicating if the current state can emit uniform buffers */ this.supportUniformBuffers = false;
        /**
         * Gets the list of emitted attributes
         */ this.attributes = [];
        /**
         * Gets the list of emitted uniforms
         */ this.uniforms = [];
        /**
         * Gets the list of emitted constants
         */ this.constants = [];
        /**
         * Gets the list of emitted samplers
         */ this.samplers = [];
        /**
         * Gets the list of emitted functions
         */ this.functions = {};
        /**
         * Gets the list of emitted extensions
         */ this.extensions = {};
        /**
         * Gets the list of emitted prePass outputs - if using the prepass
         */ this.prePassOutput = {};
        /**
         * Gets the list of emitted counters
         */ this.counters = {};
        /** @internal */ this._attributeDeclaration = "";
        /** @internal */ this._uniformDeclaration = "";
        /** @internal */ this._constantDeclaration = "";
        /** @internal */ this._samplerDeclaration = "";
        /** @internal */ this._varyingTransfer = "";
        /** @internal */ this._injectAtEnd = "";
        this._repeatableContentAnchorIndex = 0;
        /** @internal */ this._builtCompilationString = "";
        /**
         * Gets the emitted compilation strings
         */ this.compilationString = "";
    }
    /**
     * Finalize the compilation strings
     * @param state defines the current compilation state
     */ finalize(state) {
        const emitComments = state.sharedData.emitComments;
        const isFragmentMode = this.target === (0, $iAIIe.NodeMaterialBlockTargets).Fragment;
        this.compilationString = `\n${emitComments ? "//Entry point\n" : ""}void main(void) {\n${this.compilationString}`;
        if (this._constantDeclaration) this.compilationString = `\n${emitComments ? "//Constants\n" : ""}${this._constantDeclaration}\n${this.compilationString}`;
        let functionCode = "";
        for(const functionName in this.functions)functionCode += this.functions[functionName] + `\n`;
        this.compilationString = `\n${functionCode}\n${this.compilationString}`;
        if (!isFragmentMode && this._varyingTransfer) this.compilationString = `${this.compilationString}\n${this._varyingTransfer}`;
        if (this._injectAtEnd) this.compilationString = `${this.compilationString}\n${this._injectAtEnd}`;
        this.compilationString = `${this.compilationString}\n}`;
        if (this.sharedData.varyingDeclaration) this.compilationString = `\n${emitComments ? "//Varyings\n" : ""}${this.sharedData.varyingDeclaration}\n${this.compilationString}`;
        if (this._samplerDeclaration) this.compilationString = `\n${emitComments ? "//Samplers\n" : ""}${this._samplerDeclaration}\n${this.compilationString}`;
        if (this._uniformDeclaration) this.compilationString = `\n${emitComments ? "//Uniforms\n" : ""}${this._uniformDeclaration}\n${this.compilationString}`;
        if (this._attributeDeclaration && !isFragmentMode) this.compilationString = `\n${emitComments ? "//Attributes\n" : ""}${this._attributeDeclaration}\n${this.compilationString}`;
        this.compilationString = "precision highp float;\n" + this.compilationString;
        this.compilationString = "#if defined(WEBGL2) || defines(WEBGPU)\nprecision highp sampler2DArray;\n#endif\n" + this.compilationString;
        if (isFragmentMode) this.compilationString = "#if defined(PREPASS)\r\n#extension GL_EXT_draw_buffers : require\r\nlayout(location = 0) out highp vec4 glFragData[SCENE_MRT_COUNT];\r\nhighp vec4 gl_FragColor;\r\n#endif\r\n" + this.compilationString;
        for(const extensionName in this.extensions){
            const extension = this.extensions[extensionName];
            this.compilationString = `\n${extension}\n${this.compilationString}`;
        }
        this._builtCompilationString = this.compilationString;
    }
    /** @internal */ get _repeatableContentAnchor() {
        return `###___ANCHOR${this._repeatableContentAnchorIndex++}___###`;
    }
    /**
     * @internal
     */ _getFreeVariableName(prefix) {
        prefix = prefix.replace(/[^a-zA-Z_]+/g, "");
        if (this.sharedData.variableNames[prefix] === undefined) {
            this.sharedData.variableNames[prefix] = 0;
            // Check reserved words
            if (prefix === "output" || prefix === "texture") return prefix + this.sharedData.variableNames[prefix];
            return prefix;
        } else this.sharedData.variableNames[prefix]++;
        return prefix + this.sharedData.variableNames[prefix];
    }
    /**
     * @internal
     */ _getFreeDefineName(prefix) {
        if (this.sharedData.defineNames[prefix] === undefined) this.sharedData.defineNames[prefix] = 0;
        else this.sharedData.defineNames[prefix]++;
        return prefix + this.sharedData.defineNames[prefix];
    }
    /**
     * @internal
     */ _excludeVariableName(name) {
        this.sharedData.variableNames[name] = 0;
    }
    /**
     * @internal
     */ _emit2DSampler(name) {
        if (this.samplers.indexOf(name) < 0) {
            this._samplerDeclaration += `uniform sampler2D ${name};\n`;
            this.samplers.push(name);
        }
    }
    /**
     * @internal
     */ _emit2DArraySampler(name) {
        if (this.samplers.indexOf(name) < 0) {
            this._samplerDeclaration += `uniform sampler2DArray ${name};\n`;
            this.samplers.push(name);
        }
    }
    /**
     * @internal
     */ _getGLType(type) {
        switch(type){
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float:
                return "float";
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Int:
                return "int";
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2:
                return "vec2";
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3:
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3:
                return "vec3";
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4:
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4:
                return "vec4";
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix:
                return "mat4";
        }
        return "";
    }
    /**
     * @internal
     */ _emitExtension(name, extension, define = "") {
        if (this.extensions[name]) return;
        if (define) extension = `#if ${define}\n${extension}\n#endif`;
        this.extensions[name] = extension;
    }
    /**
     * @internal
     */ _emitFunction(name, code, comments) {
        if (this.functions[name]) return;
        if (this.sharedData.emitComments) code = comments + `\n` + code;
        this.functions[name] = code;
    }
    /**
     * @internal
     */ _emitCodeFromInclude(includeName, comments, options) {
        if (options && options.repeatKey) return `#include<${includeName}>${options.substitutionVars ? "(" + options.substitutionVars + ")" : ""}[0..${options.repeatKey}]\n`;
        let code = (0, $lUDWq.Effect).IncludesShadersStore[includeName] + "\n";
        if (this.sharedData.emitComments) code = comments + `\n` + code;
        if (!options) return code;
        if (options.replaceStrings) for(let index = 0; index < options.replaceStrings.length; index++){
            const replaceString = options.replaceStrings[index];
            code = code.replace(replaceString.search, replaceString.replace);
        }
        return code;
    }
    /**
     * @internal
     */ _emitFunctionFromInclude(includeName, comments, options, storeKey = "") {
        const key = includeName + storeKey;
        if (this.functions[key]) return;
        if (!options || !options.removeAttributes && !options.removeUniforms && !options.removeVaryings && !options.removeIfDef && !options.replaceStrings) {
            if (options && options.repeatKey) this.functions[key] = `#include<${includeName}>${options.substitutionVars ? "(" + options.substitutionVars + ")" : ""}[0..${options.repeatKey}]\n`;
            else this.functions[key] = `#include<${includeName}>${options?.substitutionVars ? "(" + options?.substitutionVars + ")" : ""}\n`;
            if (this.sharedData.emitComments) this.functions[key] = comments + `\n` + this.functions[key];
            return;
        }
        this.functions[key] = (0, $lUDWq.Effect).IncludesShadersStore[includeName];
        if (this.sharedData.emitComments) this.functions[key] = comments + `\n` + this.functions[key];
        if (options.removeIfDef) {
            this.functions[key] = this.functions[key].replace(/^\s*?#ifdef.+$/gm, "");
            this.functions[key] = this.functions[key].replace(/^\s*?#endif.*$/gm, "");
            this.functions[key] = this.functions[key].replace(/^\s*?#else.*$/gm, "");
            this.functions[key] = this.functions[key].replace(/^\s*?#elif.*$/gm, "");
        }
        if (options.removeAttributes) this.functions[key] = this.functions[key].replace(/\s*?attribute .+?;/g, "\n");
        if (options.removeUniforms) this.functions[key] = this.functions[key].replace(/\s*?uniform .*?;/g, "\n");
        if (options.removeVaryings) this.functions[key] = this.functions[key].replace(/\s*?(varying|in) .+?;/g, "\n");
        if (options.replaceStrings) for(let index = 0; index < options.replaceStrings.length; index++){
            const replaceString = options.replaceStrings[index];
            this.functions[key] = this.functions[key].replace(replaceString.search, replaceString.replace);
        }
    }
    /**
     * @internal
     */ _registerTempVariable(name) {
        if (this.sharedData.temps.indexOf(name) !== -1) return false;
        this.sharedData.temps.push(name);
        return true;
    }
    /**
     * @internal
     */ _emitVaryingFromString(name, type, define = "", notDefine = false) {
        if (this.sharedData.varyings.indexOf(name) !== -1) return false;
        this.sharedData.varyings.push(name);
        if (define) {
            if (define.startsWith("defined(")) this.sharedData.varyingDeclaration += `#if ${define}\n`;
            else this.sharedData.varyingDeclaration += `${notDefine ? "#ifndef" : "#ifdef"} ${define}\n`;
        }
        this.sharedData.varyingDeclaration += `varying ${type} ${name};\n`;
        if (define) this.sharedData.varyingDeclaration += `#endif\n`;
        return true;
    }
    /**
     * @internal
     */ _emitUniformFromString(name, type, define = "", notDefine = false) {
        if (this.uniforms.indexOf(name) !== -1) return;
        this.uniforms.push(name);
        if (define) {
            if (define.startsWith("defined(")) this._uniformDeclaration += `#if ${define}\n`;
            else this._uniformDeclaration += `${notDefine ? "#ifndef" : "#ifdef"} ${define}\n`;
        }
        this._uniformDeclaration += `uniform ${type} ${name};\n`;
        if (define) this._uniformDeclaration += `#endif\n`;
    }
    /**
     * @internal
     */ _emitFloat(value) {
        if (value.toString() === value.toFixed(0)) return `${value}.0`;
        return value.toString();
    }
}

});
parcelRegister("3mKw5", function(module, exports) {

$parcel$export(module.exports, "NodeMaterialBlockConnectionPointTypes", () => $27378263329b8b8a$export$624453eca3955c53);
/**
 * Defines the kind of connection point for node based material
 */ var $27378263329b8b8a$export$624453eca3955c53;
(function(NodeMaterialBlockConnectionPointTypes) {
    /** Float */ NodeMaterialBlockConnectionPointTypes[NodeMaterialBlockConnectionPointTypes["Float"] = 1] = "Float";
    /** Int */ NodeMaterialBlockConnectionPointTypes[NodeMaterialBlockConnectionPointTypes["Int"] = 2] = "Int";
    /** Vector2 */ NodeMaterialBlockConnectionPointTypes[NodeMaterialBlockConnectionPointTypes["Vector2"] = 4] = "Vector2";
    /** Vector3 */ NodeMaterialBlockConnectionPointTypes[NodeMaterialBlockConnectionPointTypes["Vector3"] = 8] = "Vector3";
    /** Vector4 */ NodeMaterialBlockConnectionPointTypes[NodeMaterialBlockConnectionPointTypes["Vector4"] = 16] = "Vector4";
    /** Color3 */ NodeMaterialBlockConnectionPointTypes[NodeMaterialBlockConnectionPointTypes["Color3"] = 32] = "Color3";
    /** Color4 */ NodeMaterialBlockConnectionPointTypes[NodeMaterialBlockConnectionPointTypes["Color4"] = 64] = "Color4";
    /** Matrix */ NodeMaterialBlockConnectionPointTypes[NodeMaterialBlockConnectionPointTypes["Matrix"] = 128] = "Matrix";
    /** Custom object */ NodeMaterialBlockConnectionPointTypes[NodeMaterialBlockConnectionPointTypes["Object"] = 256] = "Object";
    /** Detect type based on connection */ NodeMaterialBlockConnectionPointTypes[NodeMaterialBlockConnectionPointTypes["AutoDetect"] = 1024] = "AutoDetect";
    /** Output type that will be defined by input type */ NodeMaterialBlockConnectionPointTypes[NodeMaterialBlockConnectionPointTypes["BasedOnInput"] = 2048] = "BasedOnInput";
    /** Bitmask of all types */ NodeMaterialBlockConnectionPointTypes[NodeMaterialBlockConnectionPointTypes["All"] = 4095] = "All";
})($27378263329b8b8a$export$624453eca3955c53 || ($27378263329b8b8a$export$624453eca3955c53 = {}));

});

parcelRegister("iAIIe", function(module, exports) {

$parcel$export(module.exports, "NodeMaterialBlockTargets", () => $d88e45bb4d5e4d23$export$9d76d5923f9110a7);
/**
 * Enum used to define the target of a block
 */ var $d88e45bb4d5e4d23$export$9d76d5923f9110a7;
(function(NodeMaterialBlockTargets) {
    /** Vertex shader */ NodeMaterialBlockTargets[NodeMaterialBlockTargets["Vertex"] = 1] = "Vertex";
    /** Fragment shader */ NodeMaterialBlockTargets[NodeMaterialBlockTargets["Fragment"] = 2] = "Fragment";
    /** Neutral */ NodeMaterialBlockTargets[NodeMaterialBlockTargets["Neutral"] = 4] = "Neutral";
    /** Vertex and Fragment */ NodeMaterialBlockTargets[NodeMaterialBlockTargets["VertexAndFragment"] = 3] = "VertexAndFragment";
})($d88e45bb4d5e4d23$export$9d76d5923f9110a7 || ($d88e45bb4d5e4d23$export$9d76d5923f9110a7 = {}));

});


parcelRegister("2k2yr", function(module, exports) {

$parcel$export(module.exports, "NodeMaterialBuildStateSharedData", () => $1b0f6e4d5977c146$export$3da90b72d83b3c56);
/**
 * Class used to store shared data between 2 NodeMaterialBuildState
 */ class $1b0f6e4d5977c146$export$3da90b72d83b3c56 {
    /** Creates a new shared data */ constructor(){
        /**
         * Gets the list of emitted varyings
         */ this.temps = [];
        /**
         * Gets the list of emitted varyings
         */ this.varyings = [];
        /**
         * Gets the varying declaration string
         */ this.varyingDeclaration = "";
        /**
         * Input blocks
         */ this.inputBlocks = [];
        /**
         * Input blocks
         */ this.textureBlocks = [];
        /**
         * Bindable blocks (Blocks that need to set data to the effect)
         */ this.bindableBlocks = [];
        /**
         * Bindable blocks (Blocks that need to set data to the effect) that will always be called (by bindForSubMesh), contrary to bindableBlocks that won't be called if _mustRebind() returns false
         */ this.forcedBindableBlocks = [];
        /**
         * List of blocks that can provide a compilation fallback
         */ this.blocksWithFallbacks = [];
        /**
         * List of blocks that can provide a define update
         */ this.blocksWithDefines = [];
        /**
         * List of blocks that can provide a repeatable content
         */ this.repeatableContentBlocks = [];
        /**
         * List of blocks that can provide a dynamic list of uniforms
         */ this.dynamicUniformBlocks = [];
        /**
         * List of blocks that can block the isReady function for the material
         */ this.blockingBlocks = [];
        /**
         * Gets the list of animated inputs
         */ this.animatedInputs = [];
        /** List of emitted variables */ this.variableNames = {};
        /** List of emitted defines */ this.defineNames = {};
        /**
         * Gets the compilation hints emitted at compilation time
         */ this.hints = {
            needWorldViewMatrix: false,
            needWorldViewProjectionMatrix: false,
            needAlphaBlending: false,
            needAlphaTesting: false
        };
        /**
         * List of compilation checks
         */ this.checks = {
            emitVertex: false,
            emitFragment: false,
            notConnectedNonOptionalInputs: new Array()
        };
        /**
         * Is vertex program allowed to be empty?
         */ this.allowEmptyVertexProgram = false;
        // Exclude usual attributes from free variable names
        this.variableNames["position"] = 0;
        this.variableNames["normal"] = 0;
        this.variableNames["tangent"] = 0;
        this.variableNames["uv"] = 0;
        this.variableNames["uv2"] = 0;
        this.variableNames["uv3"] = 0;
        this.variableNames["uv4"] = 0;
        this.variableNames["uv5"] = 0;
        this.variableNames["uv6"] = 0;
        this.variableNames["color"] = 0;
        this.variableNames["matricesIndices"] = 0;
        this.variableNames["matricesWeights"] = 0;
        this.variableNames["matricesIndicesExtra"] = 0;
        this.variableNames["matricesWeightsExtra"] = 0;
        this.variableNames["diffuseBase"] = 0;
        this.variableNames["specularBase"] = 0;
        this.variableNames["worldPos"] = 0;
        this.variableNames["shadow"] = 0;
        this.variableNames["view"] = 0;
        // Exclude known varyings
        this.variableNames["vTBN"] = 0;
        // Exclude defines
        this.defineNames["MAINUV0"] = 0;
        this.defineNames["MAINUV1"] = 0;
        this.defineNames["MAINUV2"] = 0;
        this.defineNames["MAINUV3"] = 0;
        this.defineNames["MAINUV4"] = 0;
        this.defineNames["MAINUV5"] = 0;
        this.defineNames["MAINUV6"] = 0;
        this.defineNames["MAINUV7"] = 0;
    }
    /**
     * Emits console errors and exceptions if there is a failing check
     */ emitErrors() {
        let errorMessage = "";
        if (!this.checks.emitVertex && !this.allowEmptyVertexProgram) errorMessage += "NodeMaterial does not have a vertex output. You need to at least add a block that generates a glPosition value.\n";
        if (!this.checks.emitFragment) errorMessage += "NodeMaterial does not have a fragment output. You need to at least add a block that generates a glFragColor value.\n";
        for (const notConnectedInput of this.checks.notConnectedNonOptionalInputs)errorMessage += `input ${notConnectedInput.name} from block ${notConnectedInput.ownerBlock.name}[${notConnectedInput.ownerBlock.getClassName()}] is not connected and is not optional.\n`;
        if (errorMessage) // eslint-disable-next-line no-throw-literal
        throw "Build of NodeMaterial failed:\n" + errorMessage;
    }
}

});

parcelRegister("35xmP", function(module, exports) {

$parcel$export(module.exports, "MaterialDefines", () => $23fbb8c84eee5c40$export$4c55cb8c02c1a25d);
/**
 * Manages the defines for the Material
 */ class $23fbb8c84eee5c40$export$4c55cb8c02c1a25d {
    /**
     * Creates a new instance
     * @param externalProperties list of external properties to inject into the object
     */ constructor(externalProperties){
        /** @internal */ this._keys = [];
        this._isDirty = true;
        /** @internal */ this._areLightsDirty = true;
        /** @internal */ this._areLightsDisposed = false;
        /** @internal */ this._areAttributesDirty = true;
        /** @internal */ this._areTexturesDirty = true;
        /** @internal */ this._areFresnelDirty = true;
        /** @internal */ this._areMiscDirty = true;
        /** @internal */ this._arePrePassDirty = true;
        /** @internal */ this._areImageProcessingDirty = true;
        /** @internal */ this._normals = false;
        /** @internal */ this._uvs = false;
        /** @internal */ this._needNormals = false;
        /** @internal */ this._needUVs = false;
        this._externalProperties = externalProperties;
        // Initialize External Properties
        if (externalProperties) {
            for(const prop in externalProperties)if (Object.prototype.hasOwnProperty.call(externalProperties, prop)) this._setDefaultValue(prop);
        }
    }
    /**
     * Specifies if the material needs to be re-calculated
     */ get isDirty() {
        return this._isDirty;
    }
    /**
     * Marks the material to indicate that it has been re-calculated
     */ markAsProcessed() {
        this._isDirty = false;
        this._areAttributesDirty = false;
        this._areTexturesDirty = false;
        this._areFresnelDirty = false;
        this._areLightsDirty = false;
        this._areLightsDisposed = false;
        this._areMiscDirty = false;
        this._arePrePassDirty = false;
        this._areImageProcessingDirty = false;
    }
    /**
     * Marks the material to indicate that it needs to be re-calculated
     */ markAsUnprocessed() {
        this._isDirty = true;
    }
    /**
     * Marks the material to indicate all of its defines need to be re-calculated
     */ markAllAsDirty() {
        this._areTexturesDirty = true;
        this._areAttributesDirty = true;
        this._areLightsDirty = true;
        this._areFresnelDirty = true;
        this._areMiscDirty = true;
        this._arePrePassDirty = false;
        this._areImageProcessingDirty = true;
        this._isDirty = true;
    }
    /**
     * Marks the material to indicate that image processing needs to be re-calculated
     */ markAsImageProcessingDirty() {
        this._areImageProcessingDirty = true;
        this._isDirty = true;
    }
    /**
     * Marks the material to indicate the lights need to be re-calculated
     * @param disposed Defines whether the light is dirty due to dispose or not
     */ markAsLightDirty(disposed = false) {
        this._areLightsDirty = true;
        this._areLightsDisposed = this._areLightsDisposed || disposed;
        this._isDirty = true;
    }
    /**
     * Marks the attribute state as changed
     */ markAsAttributesDirty() {
        this._areAttributesDirty = true;
        this._isDirty = true;
    }
    /**
     * Marks the texture state as changed
     */ markAsTexturesDirty() {
        this._areTexturesDirty = true;
        this._isDirty = true;
    }
    /**
     * Marks the fresnel state as changed
     */ markAsFresnelDirty() {
        this._areFresnelDirty = true;
        this._isDirty = true;
    }
    /**
     * Marks the misc state as changed
     */ markAsMiscDirty() {
        this._areMiscDirty = true;
        this._isDirty = true;
    }
    /**
     * Marks the prepass state as changed
     */ markAsPrePassDirty() {
        this._arePrePassDirty = true;
        this._isDirty = true;
    }
    /**
     * Rebuilds the material defines
     */ rebuild() {
        this._keys.length = 0;
        for (const key of Object.keys(this)){
            if (key[0] === "_") continue;
            this._keys.push(key);
        }
        if (this._externalProperties) {
            for(const name in this._externalProperties)if (this._keys.indexOf(name) === -1) this._keys.push(name);
        }
    }
    /**
     * Specifies if two material defines are equal
     * @param other - A material define instance to compare to
     * @returns - Boolean indicating if the material defines are equal (true) or not (false)
     */ isEqual(other) {
        if (this._keys.length !== other._keys.length) return false;
        for(let index = 0; index < this._keys.length; index++){
            const prop = this._keys[index];
            if (this[prop] !== other[prop]) return false;
        }
        return true;
    }
    /**
     * Clones this instance's defines to another instance
     * @param other - material defines to clone values to
     */ cloneTo(other) {
        if (this._keys.length !== other._keys.length) other._keys = this._keys.slice(0);
        for(let index = 0; index < this._keys.length; index++){
            const prop = this._keys[index];
            other[prop] = this[prop];
        }
    }
    /**
     * Resets the material define values
     */ reset() {
        this._keys.forEach((prop)=>this._setDefaultValue(prop));
    }
    _setDefaultValue(prop) {
        const type = this._externalProperties?.[prop]?.type ?? typeof this[prop];
        const defValue = this._externalProperties?.[prop]?.default;
        switch(type){
            case "number":
                this[prop] = defValue ?? 0;
                break;
            case "string":
                this[prop] = defValue ?? "";
                break;
            default:
                this[prop] = defValue ?? false;
                break;
        }
    }
    /**
     * Converts the material define values to a string
     * @returns - String of material define information
     */ toString() {
        let result = "";
        for(let index = 0; index < this._keys.length; index++){
            const prop = this._keys[index];
            const value = this[prop];
            const type = typeof value;
            switch(type){
                case "number":
                case "string":
                    result += "#define " + prop + " " + value + "\n";
                    break;
                default:
                    if (value) result += "#define " + prop + "\n";
                    break;
            }
        }
        return result;
    }
}

});

parcelRegister("cFAzb", function(module, exports) {

$parcel$export(module.exports, "TransformBlock", () => $9395adb1777e8969$export$eb31f68b79e6275c);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $9395adb1777e8969$export$eb31f68b79e6275c extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new TransformBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        /**
         * Defines the value to use to complement W value to transform it to a Vector4
         */ this.complementW = 1;
        /**
         * Defines the value to use to complement z value to transform it to a Vector4
         */ this.complementZ = 0;
        this.target = (0, $iAIIe.NodeMaterialBlockTargets).Vertex;
        this.registerInput("vector", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerInput("transform", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4);
        this.registerOutput("xyz", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3);
        this._inputs[0].onConnectionObservable.add((other)=>{
            if (other.ownerBlock.isInput) {
                const otherAsInput = other.ownerBlock;
                if (otherAsInput.name === "normal" || otherAsInput.name === "tangent") this.complementW = 0;
            }
        });
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "TransformBlock";
    }
    /**
     * Gets the vector input
     */ get vector() {
        return this._inputs[0];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    /**
     * Gets the xyz output component
     */ get xyz() {
        return this._outputs[1];
    }
    /**
     * Gets the matrix transform input
     */ get transform() {
        return this._inputs[1];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const vector = this.vector;
        const transform = this.transform;
        if (vector.connectedPoint) {
            // None uniform scaling case.
            if (this.complementW === 0) {
                const comments = `//${this.name}`;
                state._emitFunctionFromInclude("helperFunctions", comments);
                state.sharedData.blocksWithDefines.push(this);
                const transformName = state._getFreeVariableName(`${transform.associatedVariableName}_NUS`);
                state.compilationString += `mat3 ${transformName} = mat3(${transform.associatedVariableName});\n`;
                state.compilationString += `#ifdef NONUNIFORMSCALING\n`;
                state.compilationString += `${transformName} = transposeMat3(inverseMat3(${transformName}));\n`;
                state.compilationString += `#endif\n`;
                switch(vector.connectedPoint.type){
                    case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2:
                        state.compilationString += this._declareOutput(this.output, state) + ` = vec4(${transformName} * vec3(${vector.associatedVariableName}, ${this._writeFloat(this.complementZ)}), ${this._writeFloat(this.complementW)});\n`;
                        break;
                    case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3:
                    case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3:
                        state.compilationString += this._declareOutput(this.output, state) + ` = vec4(${transformName} * ${vector.associatedVariableName}, ${this._writeFloat(this.complementW)});\n`;
                        break;
                    default:
                        state.compilationString += this._declareOutput(this.output, state) + ` = vec4(${transformName} * ${vector.associatedVariableName}.xyz, ${this._writeFloat(this.complementW)});\n`;
                        break;
                }
            } else {
                const transformName = transform.associatedVariableName;
                switch(vector.connectedPoint.type){
                    case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2:
                        state.compilationString += this._declareOutput(this.output, state) + ` = ${transformName} * vec4(${vector.associatedVariableName}, ${this._writeFloat(this.complementZ)}, ${this._writeFloat(this.complementW)});\n`;
                        break;
                    case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3:
                    case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3:
                        state.compilationString += this._declareOutput(this.output, state) + ` = ${transformName} * vec4(${vector.associatedVariableName}, ${this._writeFloat(this.complementW)});\n`;
                        break;
                    default:
                        state.compilationString += this._declareOutput(this.output, state) + ` = ${transformName} * ${vector.associatedVariableName};\n`;
                        break;
                }
            }
            if (this.xyz.hasEndpoints) state.compilationString += this._declareOutput(this.xyz, state) + ` = ${this.output.associatedVariableName}.xyz;\n`;
        }
        return this;
    }
    /**
     * Update defines for shader compilation
     * @param mesh defines the mesh to be rendered
     * @param nodeMaterial defines the node material requesting the update
     * @param defines defines the material defines to update
     */ prepareDefines(mesh, nodeMaterial, defines) {
        // Do nothing
        if (mesh.nonUniformScaling) defines.setValue("NONUNIFORMSCALING", true);
    }
    serialize() {
        const serializationObject = super.serialize();
        serializationObject.complementZ = this.complementZ;
        serializationObject.complementW = this.complementW;
        return serializationObject;
    }
    _deserialize(serializationObject, scene, rootUrl) {
        super._deserialize(serializationObject, scene, rootUrl);
        this.complementZ = serializationObject.complementZ !== undefined ? serializationObject.complementZ : 0.0;
        this.complementW = serializationObject.complementW !== undefined ? serializationObject.complementW : 1.0;
    }
    _dumpPropertiesCode() {
        let codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.complementZ = ${this.complementZ};\n`;
        codeString += `${this._codeVariableName}.complementW = ${this.complementW};\n`;
        return codeString;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.TransformBlock", $9395adb1777e8969$export$eb31f68b79e6275c);

});
parcelRegister("kpKE2", function(module, exports) {

$parcel$export(module.exports, "NodeMaterialBlock", () => $edca532048a424b6$export$47d862da46cf773b);

var $3mKw5 = parcelRequire("3mKw5");

var $g92b7 = parcelRequire("g92b7");

var $iAIIe = parcelRequire("iAIIe");

var $3u0QC = parcelRequire("3u0QC");

var $8DoUR = parcelRequire("8DoUR");

var $kVtWi = parcelRequire("kVtWi");
class $edca532048a424b6$export$47d862da46cf773b {
    /**
     * Gets the name of the block
     */ get name() {
        return this._name;
    }
    /**
     * Sets the name of the block. Will check if the name is valid.
     */ set name(newName) {
        if (!this.validateBlockName(newName)) return;
        this._name = newName;
    }
    /**
     * Gets a boolean indicating that this block can only be used once per NodeMaterial
     */ get isUnique() {
        return this._isUnique;
    }
    /**
     * Gets a boolean indicating that this block is an end block (e.g. it is generating a system value)
     */ get isFinalMerger() {
        return this._isFinalMerger;
    }
    /**
     * Gets a boolean indicating that this block is an input (e.g. it sends data to the shader)
     */ get isInput() {
        return this._isInput;
    }
    /**
     * Gets a boolean indicating if this block is a teleport out
     */ get isTeleportOut() {
        return this._isTeleportOut;
    }
    /**
     * Gets a boolean indicating if this block is a teleport in
     */ get isTeleportIn() {
        return this._isTeleportIn;
    }
    /**
     * Gets or sets the build Id
     */ get buildId() {
        return this._buildId;
    }
    set buildId(value) {
        this._buildId = value;
    }
    /**
     * Gets or sets the target of the block
     */ get target() {
        return this._target;
    }
    set target(value) {
        if ((this._target & value) !== 0) return;
        this._target = value;
    }
    /**
     * Gets the list of input points
     */ get inputs() {
        return this._inputs;
    }
    /** Gets the list of output points */ get outputs() {
        return this._outputs;
    }
    /**
     * Find an input by its name
     * @param name defines the name of the input to look for
     * @returns the input or null if not found
     */ getInputByName(name) {
        const filter = this._inputs.filter((e)=>e.name === name);
        if (filter.length) return filter[0];
        return null;
    }
    /**
     * Find an output by its name
     * @param name defines the name of the output to look for
     * @returns the output or null if not found
     */ getOutputByName(name) {
        const filter = this._outputs.filter((e)=>e.name === name);
        if (filter.length) return filter[0];
        return null;
    }
    /**
     * Creates a new NodeMaterialBlock
     * @param name defines the block name
     * @param target defines the target of that block (Vertex by default)
     * @param isFinalMerger defines a boolean indicating that this block is an end block (e.g. it is generating a system value). Default is false
     */ constructor(name, target = (0, $iAIIe.NodeMaterialBlockTargets).Vertex, isFinalMerger = false){
        this._isFinalMerger = false;
        this._isInput = false;
        this._isTeleportOut = false;
        this._isTeleportIn = false;
        this._name = "";
        this._isUnique = false;
        /** Gets or sets a boolean indicating that only one input can be connected at a time */ this.inputsAreExclusive = false;
        /** @internal */ this._codeVariableName = "";
        /** @internal */ this._inputs = new Array();
        /** @internal */ this._outputs = new Array();
        /**
         * Gets or sets the comments associated with this block
         */ this.comments = "";
        /** Gets or sets a boolean indicating that this input can be edited in the Inspector (false by default) */ this.visibleInInspector = false;
        /** Gets or sets a boolean indicating that this input can be edited from a collapsed frame */ this.visibleOnFrame = false;
        this._target = target;
        this._originalTargetIsNeutral = target === (0, $iAIIe.NodeMaterialBlockTargets).Neutral;
        this._isFinalMerger = isFinalMerger;
        this._isInput = this.getClassName() === "InputBlock";
        this._isTeleportOut = this.getClassName() === "NodeMaterialTeleportOutBlock";
        this._isTeleportIn = this.getClassName() === "NodeMaterialTeleportInBlock";
        this._name = name;
        this.uniqueId = (0, $3u0QC.UniqueIdGenerator).UniqueId;
    }
    /** @internal */ _setInitialTarget(target) {
        this._target = target;
        this._originalTargetIsNeutral = target === (0, $iAIIe.NodeMaterialBlockTargets).Neutral;
    }
    /**
     * Initialize the block and prepare the context for build
     * @param state defines the state that will be used for the build
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    initialize(state) {
    // Do nothing
    }
    /**
     * Bind data to effect. Will only be called for blocks with isBindable === true
     * @param effect defines the effect to bind data to
     * @param nodeMaterial defines the hosting NodeMaterial
     * @param mesh defines the mesh that will be rendered
     * @param subMesh defines the submesh that will be rendered
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    bind(effect, nodeMaterial, mesh, subMesh) {
    // Do nothing
    }
    _declareOutput(output, state) {
        return `${state._getGLType(output.type)} ${output.associatedVariableName}`;
    }
    _writeVariable(currentPoint) {
        const connectionPoint = currentPoint.connectedPoint;
        if (connectionPoint) return `${currentPoint.associatedVariableName}`;
        return `0.`;
    }
    _writeFloat(value) {
        let stringVersion = value.toString();
        if (stringVersion.indexOf(".") === -1) stringVersion += ".0";
        return `${stringVersion}`;
    }
    /**
     * Gets the current class name e.g. "NodeMaterialBlock"
     * @returns the class name
     */ getClassName() {
        return "NodeMaterialBlock";
    }
    /** Gets a boolean indicating that this connection will be used in the fragment shader
     * @returns true if connected in fragment shader
     */ isConnectedInFragmentShader() {
        return this.outputs.some((o)=>o.isConnectedInFragmentShader);
    }
    /**
     * Register a new input. Must be called inside a block constructor
     * @param name defines the connection point name
     * @param type defines the connection point type
     * @param isOptional defines a boolean indicating that this input can be omitted
     * @param target defines the target to use to limit the connection point (will be VertexAndFragment by default)
     * @param point an already created connection point. If not provided, create a new one
     * @returns the current block
     */ registerInput(name, type, isOptional = false, target, point) {
        point = point ?? new (0, $g92b7.NodeMaterialConnectionPoint)(name, this, (0, $g92b7.NodeMaterialConnectionPointDirection).Input);
        point.type = type;
        point.isOptional = isOptional;
        if (target) point.target = target;
        this._inputs.push(point);
        return this;
    }
    /**
     * Register a new output. Must be called inside a block constructor
     * @param name defines the connection point name
     * @param type defines the connection point type
     * @param target defines the target to use to limit the connection point (will be VertexAndFragment by default)
     * @param point an already created connection point. If not provided, create a new one
     * @returns the current block
     */ registerOutput(name, type, target, point) {
        point = point ?? new (0, $g92b7.NodeMaterialConnectionPoint)(name, this, (0, $g92b7.NodeMaterialConnectionPointDirection).Output);
        point.type = type;
        if (target) point.target = target;
        this._outputs.push(point);
        return this;
    }
    /**
     * Will return the first available input e.g. the first one which is not an uniform or an attribute
     * @param forOutput defines an optional connection point to check compatibility with
     * @returns the first available input or null
     */ getFirstAvailableInput(forOutput = null) {
        for (const input of this._inputs)if (!input.connectedPoint) {
            if (!forOutput || forOutput.type === input.type || input.type === (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect) return input;
        }
        return null;
    }
    /**
     * Will return the first available output e.g. the first one which is not yet connected and not a varying
     * @param forBlock defines an optional block to check compatibility with
     * @returns the first available input or null
     */ getFirstAvailableOutput(forBlock = null) {
        for (const output of this._outputs){
            if (!forBlock || !forBlock.target || forBlock.target === (0, $iAIIe.NodeMaterialBlockTargets).Neutral || (forBlock.target & output.target) !== 0) return output;
        }
        return null;
    }
    /**
     * Gets the sibling of the given output
     * @param current defines the current output
     * @returns the next output in the list or null
     */ getSiblingOutput(current) {
        const index = this._outputs.indexOf(current);
        if (index === -1 || index >= this._outputs.length) return null;
        return this._outputs[index + 1];
    }
    /**
     * Checks if the current block is an ancestor of a given block
     * @param block defines the potential descendant block to check
     * @returns true if block is a descendant
     */ isAnAncestorOf(block) {
        for (const output of this._outputs){
            if (!output.hasEndpoints) continue;
            for (const endpoint of output.endpoints){
                if (endpoint.ownerBlock === block) return true;
                if (endpoint.ownerBlock.isAnAncestorOf(block)) return true;
            }
        }
        return false;
    }
    /**
     * Connect current block with another block
     * @param other defines the block to connect with
     * @param options define the various options to help pick the right connections
     * @param options.input
     * @param options.output
     * @param options.outputSwizzle
     * @returns the current block
     */ connectTo(other, options) {
        if (this._outputs.length === 0) return;
        let output = options && options.output ? this.getOutputByName(options.output) : this.getFirstAvailableOutput(other);
        let notFound = true;
        while(notFound){
            const input = options && options.input ? other.getInputByName(options.input) : other.getFirstAvailableInput(output);
            if (output && input && output.canConnectTo(input)) {
                output.connectTo(input);
                notFound = false;
            } else if (!output) // eslint-disable-next-line no-throw-literal
            throw "Unable to find a compatible match";
            else output = this.getSiblingOutput(output);
        }
        return this;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _buildBlock(state) {
    // Empty. Must be defined by child nodes
    }
    /**
     * Add uniforms, samplers and uniform buffers at compilation time
     * @param state defines the state to update
     * @param nodeMaterial defines the node material requesting the update
     * @param defines defines the material defines to update
     * @param uniformBuffers defines the list of uniform buffer names
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    updateUniformsAndSamples(state, nodeMaterial, defines, uniformBuffers) {
    // Do nothing
    }
    /**
     * Add potential fallbacks if shader compilation fails
     * @param mesh defines the mesh to be rendered
     * @param fallbacks defines the current prioritized list of fallbacks
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    provideFallbacks(mesh, fallbacks) {
    // Do nothing
    }
    /**
     * Initialize defines for shader compilation
     * @param mesh defines the mesh to be rendered
     * @param nodeMaterial defines the node material requesting the update
     * @param defines defines the material defines to update
     * @param useInstances specifies that instances should be used
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    initializeDefines(mesh, nodeMaterial, defines, useInstances = false) {}
    /**
     * Update defines for shader compilation
     * @param mesh defines the mesh to be rendered
     * @param nodeMaterial defines the node material requesting the update
     * @param defines defines the material defines to update
     * @param useInstances specifies that instances should be used
     * @param subMesh defines which submesh to render
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    prepareDefines(mesh, nodeMaterial, defines, useInstances = false, subMesh) {
    // Do nothing
    }
    /**
     * Lets the block try to connect some inputs automatically
     * @param material defines the hosting NodeMaterial
     * @param additionalFilteringInfo optional additional filtering condition when looking for compatible blocks
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    autoConfigure(material, additionalFilteringInfo = ()=>true) {
    // Do nothing
    }
    /**
     * Function called when a block is declared as repeatable content generator
     * @param vertexShaderState defines the current compilation state for the vertex shader
     * @param fragmentShaderState defines the current compilation state for the fragment shader
     * @param mesh defines the mesh to be rendered
     * @param defines defines the material defines to update
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    replaceRepeatableContent(vertexShaderState, fragmentShaderState, mesh, defines) {
    // Do nothing
    }
    /** Gets a boolean indicating that the code of this block will be promoted to vertex shader even if connected to fragment output */ get willBeGeneratedIntoVertexShaderFromFragmentShader() {
        if (this.isInput || this.isFinalMerger) return false;
        if (this._outputs.some((o)=>o.isDirectlyConnectedToVertexOutput)) return false;
        if (this.target === (0, $iAIIe.NodeMaterialBlockTargets).Vertex) return false;
        if (this.target === (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment || this.target === (0, $iAIIe.NodeMaterialBlockTargets).Neutral) {
            if (this._outputs.some((o)=>o.isConnectedInVertexShader)) return true;
        }
        return false;
    }
    /**
     * Checks if the block is ready
     * @param mesh defines the mesh to be rendered
     * @param nodeMaterial defines the node material requesting the update
     * @param defines defines the material defines to update
     * @param useInstances specifies that instances should be used
     * @returns true if the block is ready
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isReady(mesh, nodeMaterial, defines, useInstances = false) {
        return true;
    }
    _linkConnectionTypes(inputIndex0, inputIndex1, looseCoupling = false) {
        if (looseCoupling) this._inputs[inputIndex1]._acceptedConnectionPointType = this._inputs[inputIndex0];
        else this._inputs[inputIndex0]._linkedConnectionSource = this._inputs[inputIndex1];
        this._inputs[inputIndex1]._linkedConnectionSource = this._inputs[inputIndex0];
    }
    _processBuild(block, state, input, activeBlocks) {
        block.build(state, activeBlocks);
        const localBlockIsFragment = state._vertexState != null;
        const otherBlockWasGeneratedInVertexShader = block._buildTarget === (0, $iAIIe.NodeMaterialBlockTargets).Vertex && block.target !== (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment;
        if (localBlockIsFragment && ((block.target & block._buildTarget) === 0 || (block.target & input.target) === 0 || this.target !== (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment && otherBlockWasGeneratedInVertexShader)) // context switch! We need a varying
        {
            if (!block.isInput && state.target !== block._buildTarget || // block was already emitted by vertex shader
            block.isInput && block.isAttribute && !block._noContextSwitch // block is an attribute
            ) {
                const connectedPoint = input.connectedPoint;
                if (state._vertexState._emitVaryingFromString("v_" + connectedPoint.associatedVariableName, state._getGLType(connectedPoint.type))) state._vertexState.compilationString += `${"v_" + connectedPoint.associatedVariableName} = ${connectedPoint.associatedVariableName};\n`;
                input.associatedVariableName = "v_" + connectedPoint.associatedVariableName;
                input._enforceAssociatedVariableName = true;
            }
        }
    }
    /**
     * Validates the new name for the block node.
     * @param newName the new name to be given to the node.
     * @returns false if the name is a reserve word, else true.
     */ validateBlockName(newName) {
        const reservedNames = [
            "position",
            "normal",
            "tangent",
            "particle_positionw",
            "uv",
            "uv2",
            "uv3",
            "uv4",
            "uv5",
            "uv6",
            "position2d",
            "particle_uv",
            "matricesIndices",
            "matricesWeights",
            "world0",
            "world1",
            "world2",
            "world3",
            "particle_color",
            "particle_texturemask"
        ];
        for (const reservedName of reservedNames){
            if (newName === reservedName) return false;
        }
        return true;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _customBuildStep(state, activeBlocks) {
    // Must be implemented by children
    }
    /**
     * Compile the current node and generate the shader code
     * @param state defines the current compilation state (uniforms, samplers, current string)
     * @param activeBlocks defines the list of active blocks (i.e. blocks to compile)
     * @returns true if already built
     */ build(state, activeBlocks) {
        if (this._buildId === state.sharedData.buildId) return true;
        if (!this.isInput) {
            /** Prepare outputs */ for (const output of this._outputs)if (!output.associatedVariableName) output.associatedVariableName = state._getFreeVariableName(output.name);
        }
        // Check if "parent" blocks are compiled
        for (const input of this._inputs){
            if (!input.connectedPoint) {
                if (!input.isOptional) // Emit a warning
                state.sharedData.checks.notConnectedNonOptionalInputs.push(input);
                continue;
            }
            if (this.target !== (0, $iAIIe.NodeMaterialBlockTargets).Neutral) {
                if ((input.target & this.target) === 0) continue;
                if ((input.target & state.target) === 0) continue;
            }
            const block = input.connectedPoint.ownerBlock;
            if (block && block !== this) this._processBuild(block, state, input, activeBlocks);
        }
        this._customBuildStep(state, activeBlocks);
        if (this._buildId === state.sharedData.buildId) return true; // Need to check again as inputs can be connected multiple time to this endpoint
        // Logs
        if (state.sharedData.verbose) (0, $kVtWi.Logger).Log(`${state.target === (0, $iAIIe.NodeMaterialBlockTargets).Vertex ? "Vertex shader" : "Fragment shader"}: Building ${this.name} [${this.getClassName()}]`);
        // Checks final outputs
        if (this.isFinalMerger) switch(state.target){
            case (0, $iAIIe.NodeMaterialBlockTargets).Vertex:
                state.sharedData.checks.emitVertex = true;
                break;
            case (0, $iAIIe.NodeMaterialBlockTargets).Fragment:
                state.sharedData.checks.emitFragment = true;
                break;
        }
        if (!this.isInput && state.sharedData.emitComments) state.compilationString += `\n//${this.name}\n`;
        this._buildBlock(state);
        this._buildId = state.sharedData.buildId;
        this._buildTarget = state.target;
        // Compile connected blocks
        for (const output of this._outputs){
            if ((output.target & state.target) === 0) continue;
            for (const endpoint of output.endpoints){
                const block = endpoint.ownerBlock;
                if (block && (block.target & state.target) !== 0 && activeBlocks.indexOf(block) !== -1) this._processBuild(block, state, endpoint, activeBlocks);
            }
        }
        return false;
    }
    _inputRename(name) {
        return name;
    }
    _outputRename(name) {
        return name;
    }
    _dumpPropertiesCode() {
        const variableName = this._codeVariableName;
        return `${variableName}.visibleInInspector = ${this.visibleInInspector};\n${variableName}.visibleOnFrame = ${this.visibleOnFrame};\n${variableName}.target = ${this.target};\n`;
    }
    /**
     * @internal
     */ _dumpCode(uniqueNames, alreadyDumped) {
        alreadyDumped.push(this);
        // Get unique name
        const nameAsVariableName = this.name.replace(/[^A-Za-z_]+/g, "");
        this._codeVariableName = nameAsVariableName || `${this.getClassName()}_${this.uniqueId}`;
        if (uniqueNames.indexOf(this._codeVariableName) !== -1) {
            let index = 0;
            do {
                index++;
                this._codeVariableName = nameAsVariableName + index;
            }while (uniqueNames.indexOf(this._codeVariableName) !== -1);
        }
        uniqueNames.push(this._codeVariableName);
        // Declaration
        let codeString = `\n// ${this.getClassName()}\n`;
        if (this.comments) codeString += `// ${this.comments}\n`;
        codeString += `var ${this._codeVariableName} = new BABYLON.${this.getClassName()}("${this.name}");\n`;
        // Properties
        codeString += this._dumpPropertiesCode();
        // Inputs
        for (const input of this.inputs){
            if (!input.isConnected) continue;
            const connectedOutput = input.connectedPoint;
            const connectedBlock = connectedOutput.ownerBlock;
            if (alreadyDumped.indexOf(connectedBlock) === -1) codeString += connectedBlock._dumpCode(uniqueNames, alreadyDumped);
        }
        // Outputs
        for (const output of this.outputs){
            if (!output.hasEndpoints) continue;
            for (const endpoint of output.endpoints){
                const connectedBlock = endpoint.ownerBlock;
                if (connectedBlock && alreadyDumped.indexOf(connectedBlock) === -1) codeString += connectedBlock._dumpCode(uniqueNames, alreadyDumped);
            }
        }
        return codeString;
    }
    /**
     * @internal
     */ _dumpCodeForOutputConnections(alreadyDumped) {
        let codeString = "";
        if (alreadyDumped.indexOf(this) !== -1) return codeString;
        alreadyDumped.push(this);
        for (const input of this.inputs){
            if (!input.isConnected) continue;
            const connectedOutput = input.connectedPoint;
            const connectedBlock = connectedOutput.ownerBlock;
            codeString += connectedBlock._dumpCodeForOutputConnections(alreadyDumped);
            codeString += `${connectedBlock._codeVariableName}.${connectedBlock._outputRename(connectedOutput.name)}.connectTo(${this._codeVariableName}.${this._inputRename(input.name)});\n`;
        }
        return codeString;
    }
    /**
     * Clone the current block to a new identical block
     * @param scene defines the hosting scene
     * @param rootUrl defines the root URL to use to load textures and relative dependencies
     * @returns a copy of the current block
     */ clone(scene, rootUrl = "") {
        const serializationObject = this.serialize();
        const blockType = (0, $8DoUR.GetClass)(serializationObject.customType);
        if (blockType) {
            const block = new blockType();
            block._deserialize(serializationObject, scene, rootUrl);
            return block;
        }
        return null;
    }
    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */ serialize() {
        const serializationObject = {};
        serializationObject.customType = "BABYLON." + this.getClassName();
        serializationObject.id = this.uniqueId;
        serializationObject.name = this.name;
        serializationObject.comments = this.comments;
        serializationObject.visibleInInspector = this.visibleInInspector;
        serializationObject.visibleOnFrame = this.visibleOnFrame;
        serializationObject.target = this.target;
        serializationObject.inputs = [];
        serializationObject.outputs = [];
        for (const input of this.inputs)serializationObject.inputs.push(input.serialize());
        for (const output of this.outputs)serializationObject.outputs.push(output.serialize(false));
        return serializationObject;
    }
    /**
     * @internal
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _deserialize(serializationObject, scene, rootUrl) {
        this.name = serializationObject.name;
        this.comments = serializationObject.comments;
        this.visibleInInspector = !!serializationObject.visibleInInspector;
        this.visibleOnFrame = !!serializationObject.visibleOnFrame;
        this._target = serializationObject.target ?? this.target;
        this._deserializePortDisplayNamesAndExposedOnFrame(serializationObject);
    }
    _deserializePortDisplayNamesAndExposedOnFrame(serializationObject) {
        const serializedInputs = serializationObject.inputs;
        const serializedOutputs = serializationObject.outputs;
        if (serializedInputs) serializedInputs.forEach((port, i)=>{
            if (port.displayName) this.inputs[i].displayName = port.displayName;
            if (port.isExposedOnFrame) {
                this.inputs[i].isExposedOnFrame = port.isExposedOnFrame;
                this.inputs[i].exposedPortPosition = port.exposedPortPosition;
            }
        });
        if (serializedOutputs) serializedOutputs.forEach((port, i)=>{
            if (port.displayName) this.outputs[i].displayName = port.displayName;
            if (port.isExposedOnFrame) {
                this.outputs[i].isExposedOnFrame = port.isExposedOnFrame;
                this.outputs[i].exposedPortPosition = port.exposedPortPosition;
            }
        });
    }
    /**
     * Release resources
     */ dispose() {
        for (const input of this.inputs)input.dispose();
        for (const output of this.outputs)output.dispose();
    }
}

});
parcelRegister("g92b7", function(module, exports) {

$parcel$export(module.exports, "NodeMaterialConnectionPointCompatibilityStates", () => $bc0f2d27c9563ab4$export$8a4b8af2ae55f0ad);
$parcel$export(module.exports, "NodeMaterialConnectionPointDirection", () => $bc0f2d27c9563ab4$export$aac74254cb193b3e);
$parcel$export(module.exports, "NodeMaterialConnectionPoint", () => $bc0f2d27c9563ab4$export$2b05dee0c578b3a7);

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $diGQf = parcelRequire("diGQf");
var $bc0f2d27c9563ab4$export$8a4b8af2ae55f0ad;
(function(NodeMaterialConnectionPointCompatibilityStates) {
    /** Points are compatibles */ NodeMaterialConnectionPointCompatibilityStates[NodeMaterialConnectionPointCompatibilityStates["Compatible"] = 0] = "Compatible";
    /** Points are incompatible because of their types */ NodeMaterialConnectionPointCompatibilityStates[NodeMaterialConnectionPointCompatibilityStates["TypeIncompatible"] = 1] = "TypeIncompatible";
    /** Points are incompatible because of their targets (vertex vs fragment) */ NodeMaterialConnectionPointCompatibilityStates[NodeMaterialConnectionPointCompatibilityStates["TargetIncompatible"] = 2] = "TargetIncompatible";
    /** Points are incompatible because they are in the same hierarchy **/ NodeMaterialConnectionPointCompatibilityStates[NodeMaterialConnectionPointCompatibilityStates["HierarchyIssue"] = 3] = "HierarchyIssue";
})($bc0f2d27c9563ab4$export$8a4b8af2ae55f0ad || ($bc0f2d27c9563ab4$export$8a4b8af2ae55f0ad = {}));
var $bc0f2d27c9563ab4$export$aac74254cb193b3e;
(function(NodeMaterialConnectionPointDirection) {
    /** Input */ NodeMaterialConnectionPointDirection[NodeMaterialConnectionPointDirection["Input"] = 0] = "Input";
    /** Output */ NodeMaterialConnectionPointDirection[NodeMaterialConnectionPointDirection["Output"] = 1] = "Output";
})($bc0f2d27c9563ab4$export$aac74254cb193b3e || ($bc0f2d27c9563ab4$export$aac74254cb193b3e = {}));
class $bc0f2d27c9563ab4$export$2b05dee0c578b3a7 {
    /**
     * Checks if two types are equivalent
     * @param type1 type 1 to check
     * @param type2 type 2 to check
     * @returns true if both types are equivalent, else false
     */ static AreEquivalentTypes(type1, type2) {
        switch(type1){
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3:
                if (type2 === (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3) return true;
                break;
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4:
                if (type2 === (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4) return true;
                break;
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3:
                if (type2 === (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3) return true;
                break;
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4:
                if (type2 === (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4) return true;
                break;
        }
        return false;
    }
    /** Gets the direction of the point */ get direction() {
        return this._direction;
    }
    /**
     * Gets or sets the associated variable name in the shader
     */ get associatedVariableName() {
        if (this._ownerBlock.isInput) return this._ownerBlock.associatedVariableName;
        if ((!this._enforceAssociatedVariableName || !this._associatedVariableName) && this._connectedPoint) return this._connectedPoint.associatedVariableName;
        return this._associatedVariableName;
    }
    set associatedVariableName(value) {
        this._associatedVariableName = value;
    }
    /** Get the inner type (ie AutoDetect for instance instead of the inferred one) */ get innerType() {
        if (this._linkedConnectionSource && this._linkedConnectionSource.isConnected) return this.type;
        return this._type;
    }
    /**
     * Gets or sets the connection point type (default is float)
     */ get type() {
        if (this._type === (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect) {
            if (this._ownerBlock.isInput) return this._ownerBlock.type;
            if (this._connectedPoint) return this._connectedPoint.type;
            if (this._linkedConnectionSource && this._linkedConnectionSource.isConnected) return this._linkedConnectionSource.type;
        }
        if (this._type === (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).BasedOnInput) {
            if (this._typeConnectionSource) {
                if (!this._typeConnectionSource.isConnected && this._defaultConnectionPointType) return this._defaultConnectionPointType;
                return this._typeConnectionSource.type;
            } else if (this._defaultConnectionPointType) return this._defaultConnectionPointType;
        }
        return this._type;
    }
    set type(value) {
        this._type = value;
    }
    /** Gets or sets the target of that connection point */ get target() {
        if (!this._prioritizeVertex || !this._ownerBlock) return this._target;
        if (this._target !== (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment) return this._target;
        if (this._ownerBlock.target === (0, $iAIIe.NodeMaterialBlockTargets).Fragment) return (0, $iAIIe.NodeMaterialBlockTargets).Fragment;
        return (0, $iAIIe.NodeMaterialBlockTargets).Vertex;
    }
    set target(value) {
        this._target = value;
    }
    /**
     * Gets a boolean indicating that the current point is connected to another NodeMaterialBlock
     */ get isConnected() {
        return this.connectedPoint !== null || this.hasEndpoints;
    }
    /**
     * Gets a boolean indicating that the current point is connected to an input block
     */ get isConnectedToInputBlock() {
        return this.connectedPoint !== null && this.connectedPoint.ownerBlock.isInput;
    }
    /**
     * Gets a the connected input block (if any)
     */ get connectInputBlock() {
        if (!this.isConnectedToInputBlock) return null;
        return this.connectedPoint.ownerBlock;
    }
    /** Get the other side of the connection (if any) */ get connectedPoint() {
        return this._connectedPoint;
    }
    /** Get the block that owns this connection point */ get ownerBlock() {
        return this._ownerBlock;
    }
    /** Get the block connected on the other side of this connection (if any) */ get sourceBlock() {
        if (!this._connectedPoint) return null;
        return this._connectedPoint.ownerBlock;
    }
    /** Get the block connected on the endpoints of this connection (if any) */ get connectedBlocks() {
        if (this._endpoints.length === 0) return [];
        return this._endpoints.map((e)=>e.ownerBlock);
    }
    /** Gets the list of connected endpoints */ get endpoints() {
        return this._endpoints;
    }
    /** Gets a boolean indicating if that output point is connected to at least one input */ get hasEndpoints() {
        return this._endpoints && this._endpoints.length > 0;
    }
    /** Gets a boolean indicating that this connection has a path to the vertex output*/ get isDirectlyConnectedToVertexOutput() {
        if (!this.hasEndpoints) return false;
        for (const endpoint of this._endpoints){
            if (endpoint.ownerBlock.target === (0, $iAIIe.NodeMaterialBlockTargets).Vertex) return true;
            if (endpoint.ownerBlock.target === (0, $iAIIe.NodeMaterialBlockTargets).Neutral || endpoint.ownerBlock.target === (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment) {
                if (endpoint.ownerBlock.outputs.some((o)=>o.isDirectlyConnectedToVertexOutput)) return true;
            }
        }
        return false;
    }
    /** Gets a boolean indicating that this connection will be used in the vertex shader */ get isConnectedInVertexShader() {
        if (this.target === (0, $iAIIe.NodeMaterialBlockTargets).Vertex) return true;
        if (!this.hasEndpoints) return false;
        for (const endpoint of this._endpoints){
            if (endpoint.ownerBlock.target === (0, $iAIIe.NodeMaterialBlockTargets).Vertex) return true;
            if (endpoint.target === (0, $iAIIe.NodeMaterialBlockTargets).Vertex) return true;
            if (endpoint.ownerBlock.target === (0, $iAIIe.NodeMaterialBlockTargets).Neutral || endpoint.ownerBlock.target === (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment) {
                if (endpoint.ownerBlock.outputs.some((o)=>o.isConnectedInVertexShader)) return true;
            }
        }
        return false;
    }
    /** Gets a boolean indicating that this connection will be used in the fragment shader */ get isConnectedInFragmentShader() {
        if (this.target === (0, $iAIIe.NodeMaterialBlockTargets).Fragment) return true;
        if (!this.hasEndpoints) return false;
        for (const endpoint of this._endpoints){
            if (endpoint.ownerBlock.target === (0, $iAIIe.NodeMaterialBlockTargets).Fragment) return true;
            if (endpoint.ownerBlock.target === (0, $iAIIe.NodeMaterialBlockTargets).Neutral || endpoint.ownerBlock.target === (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment) {
                if (endpoint.ownerBlock.isConnectedInFragmentShader()) return true;
            }
        }
        return false;
    }
    /**
     * Creates a block suitable to be used as an input for this input point.
     * If null is returned, a block based on the point type will be created.
     * @returns The returned string parameter is the name of the output point of NodeMaterialBlock (first parameter of the returned array) that can be connected to the input
     */ createCustomInputBlock() {
        return null;
    }
    /**
     * Creates a new connection point
     * @param name defines the connection point name
     * @param ownerBlock defines the block hosting this connection point
     * @param direction defines the direction of the connection point
     */ constructor(name, ownerBlock, direction){
        /** @internal */ this._connectedPoint = null;
        this._endpoints = new Array();
        /** @internal */ this._typeConnectionSource = null;
        /** @internal */ this._defaultConnectionPointType = null;
        /** @internal */ this._linkedConnectionSource = null;
        /** @internal */ this._acceptedConnectionPointType = null;
        this._type = (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float;
        /** @internal */ this._enforceAssociatedVariableName = false;
        /** Indicates that this connection point needs dual validation before being connected to another point */ this.needDualDirectionValidation = false;
        /**
         * Gets or sets the additional types supported by this connection point
         */ this.acceptedConnectionPointTypes = [];
        /**
         * Gets or sets the additional types excluded by this connection point
         */ this.excludedConnectionPointTypes = [];
        /**
         * Observable triggered when this point is connected
         */ this.onConnectionObservable = new (0, $diGQf.Observable)();
        /**
         * Gets or sets a boolean indicating that this connection point is exposed on a frame
         */ this.isExposedOnFrame = false;
        /**
         * Gets or sets number indicating the position that the port is exposed to on a frame
         */ this.exposedPortPosition = -1;
        /** @internal */ this._prioritizeVertex = false;
        this._target = (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment;
        this._ownerBlock = ownerBlock;
        this.name = name;
        this._direction = direction;
    }
    /**
     * Gets the current class name e.g. "NodeMaterialConnectionPoint"
     * @returns the class name
     */ getClassName() {
        return "NodeMaterialConnectionPoint";
    }
    /**
     * Gets a boolean indicating if the current point can be connected to another point
     * @param connectionPoint defines the other connection point
     * @returns a boolean
     */ canConnectTo(connectionPoint) {
        return this.checkCompatibilityState(connectionPoint) === $bc0f2d27c9563ab4$export$8a4b8af2ae55f0ad.Compatible;
    }
    /**
     * Gets a number indicating if the current point can be connected to another point
     * @param connectionPoint defines the other connection point
     * @returns a number defining the compatibility state
     */ checkCompatibilityState(connectionPoint) {
        const ownerBlock = this._ownerBlock;
        const otherBlock = connectionPoint.ownerBlock;
        if (ownerBlock.target === (0, $iAIIe.NodeMaterialBlockTargets).Fragment) {
            // Let's check we are not going reverse
            if (otherBlock.target === (0, $iAIIe.NodeMaterialBlockTargets).Vertex) return $bc0f2d27c9563ab4$export$8a4b8af2ae55f0ad.TargetIncompatible;
            for (const output of otherBlock.outputs){
                if (output.ownerBlock.target != (0, $iAIIe.NodeMaterialBlockTargets).Neutral && output.isConnectedInVertexShader) return $bc0f2d27c9563ab4$export$8a4b8af2ae55f0ad.TargetIncompatible;
            }
        }
        if (this.type !== connectionPoint.type && connectionPoint.innerType !== (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect) {
            // Equivalents
            if ($bc0f2d27c9563ab4$export$2b05dee0c578b3a7.AreEquivalentTypes(this.type, connectionPoint.type)) return $bc0f2d27c9563ab4$export$8a4b8af2ae55f0ad.Compatible;
            // Accepted types
            if (connectionPoint.acceptedConnectionPointTypes && connectionPoint.acceptedConnectionPointTypes.indexOf(this.type) !== -1 || connectionPoint._acceptedConnectionPointType && $bc0f2d27c9563ab4$export$2b05dee0c578b3a7.AreEquivalentTypes(connectionPoint._acceptedConnectionPointType.type, this.type)) return $bc0f2d27c9563ab4$export$8a4b8af2ae55f0ad.Compatible;
            else return $bc0f2d27c9563ab4$export$8a4b8af2ae55f0ad.TypeIncompatible;
        }
        // Excluded
        if (connectionPoint.excludedConnectionPointTypes && connectionPoint.excludedConnectionPointTypes.indexOf(this.type) !== -1) return $bc0f2d27c9563ab4$export$8a4b8af2ae55f0ad.TypeIncompatible;
        // Check hierarchy
        let targetBlock = otherBlock;
        let sourceBlock = ownerBlock;
        if (this.direction === $bc0f2d27c9563ab4$export$aac74254cb193b3e.Input) {
            targetBlock = ownerBlock;
            sourceBlock = otherBlock;
        }
        if (targetBlock.isAnAncestorOf(sourceBlock)) return $bc0f2d27c9563ab4$export$8a4b8af2ae55f0ad.HierarchyIssue;
        return $bc0f2d27c9563ab4$export$8a4b8af2ae55f0ad.Compatible;
    }
    /**
     * Connect this point to another connection point
     * @param connectionPoint defines the other connection point
     * @param ignoreConstraints defines if the system will ignore connection type constraints (default is false)
     * @returns the current connection point
     */ connectTo(connectionPoint, ignoreConstraints = false) {
        if (!ignoreConstraints && !this.canConnectTo(connectionPoint)) // eslint-disable-next-line no-throw-literal
        throw "Cannot connect these two connectors.";
        this._endpoints.push(connectionPoint);
        connectionPoint._connectedPoint = this;
        this._enforceAssociatedVariableName = false;
        this.onConnectionObservable.notifyObservers(connectionPoint);
        connectionPoint.onConnectionObservable.notifyObservers(this);
        return this;
    }
    /**
     * Disconnect this point from one of his endpoint
     * @param endpoint defines the other connection point
     * @returns the current connection point
     */ disconnectFrom(endpoint) {
        const index = this._endpoints.indexOf(endpoint);
        if (index === -1) return this;
        this._endpoints.splice(index, 1);
        endpoint._connectedPoint = null;
        this._enforceAssociatedVariableName = false;
        endpoint._enforceAssociatedVariableName = false;
        return this;
    }
    /**
     * Fill the list of excluded connection point types with all types other than those passed in the parameter
     * @param mask Types (ORed values of NodeMaterialBlockConnectionPointTypes) that are allowed, and thus will not be pushed to the excluded list
     */ addExcludedConnectionPointFromAllowedTypes(mask) {
        let bitmask = 1;
        while(bitmask < (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).All){
            if (!(mask & bitmask)) this.excludedConnectionPointTypes.push(bitmask);
            bitmask = bitmask << 1;
        }
    }
    /**
     * Serializes this point in a JSON representation
     * @param isInput defines if the connection point is an input (default is true)
     * @returns the serialized point object
     */ serialize(isInput = true) {
        const serializationObject = {};
        serializationObject.name = this.name;
        serializationObject.displayName = this.displayName;
        if (isInput && this.connectedPoint) {
            serializationObject.inputName = this.name;
            serializationObject.targetBlockId = this.connectedPoint.ownerBlock.uniqueId;
            serializationObject.targetConnectionName = this.connectedPoint.name;
            serializationObject.isExposedOnFrame = true;
            serializationObject.exposedPortPosition = this.exposedPortPosition;
        }
        if (this.isExposedOnFrame || this.exposedPortPosition >= 0) {
            serializationObject.isExposedOnFrame = true;
            serializationObject.exposedPortPosition = this.exposedPortPosition;
        }
        return serializationObject;
    }
    /**
     * Release resources
     */ dispose() {
        this.onConnectionObservable.clear();
    }
}

});



parcelRegister("eH9s9", function(module, exports) {

$parcel$export(module.exports, "VertexOutputBlock", () => $ab2c69ff6c2f3d71$export$af1357f1f99c86a2);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $ab2c69ff6c2f3d71$export$af1357f1f99c86a2 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new VertexOutputBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Vertex, true);
        this.registerInput("vector", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "VertexOutputBlock";
    }
    /**
     * Gets the vector input component
     */ get vector() {
        return this._inputs[0];
    }
    _isLogarithmicDepthEnabled(nodeList, useLogarithmicDepth) {
        if (useLogarithmicDepth) return true;
        for (const node of nodeList){
            if (node.useLogarithmicDepth) return true;
        }
        return false;
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const input = this.vector;
        state.compilationString += `gl_Position = ${input.associatedVariableName};\n`;
        if (this._isLogarithmicDepthEnabled(state.sharedData.fragmentOutputNodes, state.sharedData.nodeMaterial.useLogarithmicDepth)) {
            state._emitUniformFromString("logarithmicDepthConstant", "float");
            state._emitVaryingFromString("vFragmentDepth", "float");
            state.compilationString += `vFragmentDepth = 1.0 + gl_Position.w;\n`;
            state.compilationString += `gl_Position.z = log2(max(0.000001, vFragmentDepth)) * logarithmicDepthConstant;\n`;
        }
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.VertexOutputBlock", $ab2c69ff6c2f3d71$export$af1357f1f99c86a2);

});

parcelRegister("9d6MD", function(module, exports) {

$parcel$export(module.exports, "FragmentOutputBlock", () => $6b4a96fd5563d469$export$6b5494b7857928ca);

var $e0Suo = parcelRequire("e0Suo");

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");

var $1aXVF = parcelRequire("1aXVF");

var $alPCh = parcelRequire("alPCh");
class $6b4a96fd5563d469$export$6b5494b7857928ca extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Create a new FragmentOutputBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Fragment, true);
        /** Gets or sets a boolean indicating if content needs to be converted to gamma space */ this.convertToGammaSpace = false;
        /** Gets or sets a boolean indicating if content needs to be converted to linear space */ this.convertToLinearSpace = false;
        /** Gets or sets a boolean indicating if logarithmic depth should be used */ this.useLogarithmicDepth = false;
        this.registerInput("rgba", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4, true);
        this.registerInput("rgb", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect, true);
        this.registerInput("a", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true);
        this.rgb.addExcludedConnectionPointFromAllowedTypes((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "FragmentOutputBlock";
    }
    /**
     * Initialize the block and prepare the context for build
     * @param state defines the state that will be used for the build
     */ initialize(state) {
        state._excludeVariableName("logarithmicDepthConstant");
        state._excludeVariableName("vFragmentDepth");
    }
    /**
     * Gets the rgba input component
     */ get rgba() {
        return this._inputs[0];
    }
    /**
     * Gets the rgb input component
     */ get rgb() {
        return this._inputs[1];
    }
    /**
     * Gets the a input component
     */ get a() {
        return this._inputs[2];
    }
    prepareDefines(mesh, nodeMaterial, defines) {
        defines.setValue(this._linearDefineName, this.convertToLinearSpace, true);
        defines.setValue(this._gammaDefineName, this.convertToGammaSpace, true);
    }
    bind(effect, nodeMaterial, mesh) {
        if ((this.useLogarithmicDepth || nodeMaterial.useLogarithmicDepth) && mesh) (0, $alPCh.BindLogDepth)(undefined, effect, mesh.getScene());
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const rgba = this.rgba;
        const rgb = this.rgb;
        const a = this.a;
        state.sharedData.hints.needAlphaBlending = rgba.isConnected || a.isConnected;
        state.sharedData.blocksWithDefines.push(this);
        if (this.useLogarithmicDepth || state.sharedData.nodeMaterial.useLogarithmicDepth) {
            state._emitUniformFromString("logarithmicDepthConstant", "float");
            state._emitVaryingFromString("vFragmentDepth", "float");
            state.sharedData.bindableBlocks.push(this);
        }
        this._linearDefineName = state._getFreeDefineName("CONVERTTOLINEAR");
        this._gammaDefineName = state._getFreeDefineName("CONVERTTOGAMMA");
        const comments = `//${this.name}`;
        state._emitFunctionFromInclude("helperFunctions", comments);
        if (rgba.connectedPoint) {
            if (a.isConnected) state.compilationString += `gl_FragColor = vec4(${rgba.associatedVariableName}.rgb, ${a.associatedVariableName});\n`;
            else state.compilationString += `gl_FragColor = ${rgba.associatedVariableName};\n`;
        } else if (rgb.connectedPoint) {
            let aValue = "1.0";
            if (a.connectedPoint) aValue = a.associatedVariableName;
            if (rgb.connectedPoint.type === (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float) state.compilationString += `gl_FragColor = vec4(${rgb.associatedVariableName}, ${rgb.associatedVariableName}, ${rgb.associatedVariableName}, ${aValue});\n`;
            else state.compilationString += `gl_FragColor = vec4(${rgb.associatedVariableName}, ${aValue});\n`;
        } else state.sharedData.checks.notConnectedNonOptionalInputs.push(rgba);
        state.compilationString += `#ifdef ${this._linearDefineName}\n`;
        state.compilationString += `gl_FragColor = toLinearSpace(gl_FragColor);\n`;
        state.compilationString += `#endif\n`;
        state.compilationString += `#ifdef ${this._gammaDefineName}\n`;
        state.compilationString += `gl_FragColor = toGammaSpace(gl_FragColor);\n`;
        state.compilationString += `#endif\n`;
        if (this.useLogarithmicDepth || state.sharedData.nodeMaterial.useLogarithmicDepth) state.compilationString += `gl_FragDepthEXT = log2(vFragmentDepth) * logarithmicDepthConstant * 0.5;\n`;
        state.compilationString += `#if defined(PREPASS)\r\n`;
        state.compilationString += `gl_FragData[0] = gl_FragColor;\r\n`;
        state.compilationString += `#endif\r\n`;
        return this;
    }
    _dumpPropertiesCode() {
        let codeString = super._dumpPropertiesCode();
        codeString += `${this._codeVariableName}.convertToGammaSpace = ${this.convertToGammaSpace};\n`;
        codeString += `${this._codeVariableName}.convertToLinearSpace = ${this.convertToLinearSpace};\n`;
        codeString += `${this._codeVariableName}.useLogarithmicDepth = ${this.useLogarithmicDepth};\n`;
        return codeString;
    }
    serialize() {
        const serializationObject = super.serialize();
        serializationObject.convertToGammaSpace = this.convertToGammaSpace;
        serializationObject.convertToLinearSpace = this.convertToLinearSpace;
        serializationObject.useLogarithmicDepth = this.useLogarithmicDepth;
        return serializationObject;
    }
    _deserialize(serializationObject, scene, rootUrl) {
        super._deserialize(serializationObject, scene, rootUrl);
        this.convertToGammaSpace = serializationObject.convertToGammaSpace;
        this.convertToLinearSpace = serializationObject.convertToLinearSpace;
        this.useLogarithmicDepth = serializationObject.useLogarithmicDepth ?? false;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Convert to gamma space", (0, $1aXVF.PropertyTypeForEdition).Boolean, "PROPERTIES", {
        notifiers: {
            update: true
        }
    })
], $6b4a96fd5563d469$export$6b5494b7857928ca.prototype, "convertToGammaSpace", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Convert to linear space", (0, $1aXVF.PropertyTypeForEdition).Boolean, "PROPERTIES", {
        notifiers: {
            update: true
        }
    })
], $6b4a96fd5563d469$export$6b5494b7857928ca.prototype, "convertToLinearSpace", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Use logarithmic depth", (0, $1aXVF.PropertyTypeForEdition).Boolean, "PROPERTIES")
], $6b4a96fd5563d469$export$6b5494b7857928ca.prototype, "useLogarithmicDepth", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.FragmentOutputBlock", $6b4a96fd5563d469$export$6b5494b7857928ca);

});
parcelRegister("1aXVF", function(module, exports) {

$parcel$export(module.exports, "PropertyTypeForEdition", () => $0db5364452925c73$export$1dfc1192c49ff49e);
$parcel$export(module.exports, "editableInPropertyPage", () => $0db5364452925c73$export$f7d0792b67ad719);
/**
 * Enum defining the type of properties that can be edited in the property pages in the node editor
 */ var $0db5364452925c73$export$1dfc1192c49ff49e;
(function(PropertyTypeForEdition) {
    /** property is a boolean */ PropertyTypeForEdition[PropertyTypeForEdition["Boolean"] = 0] = "Boolean";
    /** property is a float */ PropertyTypeForEdition[PropertyTypeForEdition["Float"] = 1] = "Float";
    /** property is a int */ PropertyTypeForEdition[PropertyTypeForEdition["Int"] = 2] = "Int";
    /** property is a Vector2 */ PropertyTypeForEdition[PropertyTypeForEdition["Vector2"] = 3] = "Vector2";
    /** property is a list of values */ PropertyTypeForEdition[PropertyTypeForEdition["List"] = 4] = "List";
})($0db5364452925c73$export$1dfc1192c49ff49e || ($0db5364452925c73$export$1dfc1192c49ff49e = {}));
function $0db5364452925c73$export$f7d0792b67ad719(displayName, propertyType = $0db5364452925c73$export$1dfc1192c49ff49e.Boolean, groupName = "PROPERTIES", options) {
    return (target, propertyKey)=>{
        let propStore = target._propStore;
        if (!propStore) {
            propStore = [];
            target._propStore = propStore;
        }
        propStore.push({
            propertyName: propertyKey,
            displayName: displayName,
            type: propertyType,
            groupName: groupName,
            options: options ?? {}
        });
    };
}

});


parcelRegister("aKEh2", function(module, exports) {

$parcel$export(module.exports, "InputBlock", () => $7d3d70cafec7761a$export$83678641c7770fa5);
/* eslint-disable @typescript-eslint/naming-convention */ 
var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $g9kSQ = parcelRequire("g9kSQ");

var $7qH6c = parcelRequire("7qH6c");

var $ha1VO = parcelRequire("ha1VO");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
parcelRequire("6rxfP");
var $7etnY = parcelRequire("7etnY");

var $apsYB = parcelRequire("apsYB");

var $diGQf = parcelRequire("diGQf");

var $blHSI = parcelRequire("blHSI");
const $7d3d70cafec7761a$var$remapAttributeName = {
    position2d: "position",
    particle_uv: "vUV",
    particle_color: "vColor",
    particle_texturemask: "textureMask",
    particle_positionw: "vPositionW"
};
const $7d3d70cafec7761a$var$attributeInFragmentOnly = {
    particle_uv: true,
    particle_color: true,
    particle_texturemask: true,
    particle_positionw: true
};
const $7d3d70cafec7761a$var$attributeAsUniform = {
    particle_texturemask: true
};
class $7d3d70cafec7761a$export$83678641c7770fa5 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Gets or sets the connection point type (default is float)
     */ get type() {
        if (this._type === (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect) {
            if (this.isUniform && this.value != null) {
                if (!isNaN(this.value)) {
                    this._type = (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float;
                    return this._type;
                }
                switch(this.value.getClassName()){
                    case "Vector2":
                        this._type = (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2;
                        return this._type;
                    case "Vector3":
                        this._type = (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3;
                        return this._type;
                    case "Vector4":
                        this._type = (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4;
                        return this._type;
                    case "Color3":
                        this._type = (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3;
                        return this._type;
                    case "Color4":
                        this._type = (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4;
                        return this._type;
                    case "Matrix":
                        this._type = (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix;
                        return this._type;
                }
            }
            if (this.isAttribute) switch(this.name){
                case "position":
                case "normal":
                case "particle_positionw":
                    this._type = (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3;
                    return this._type;
                case "uv":
                case "uv2":
                case "uv3":
                case "uv4":
                case "uv5":
                case "uv6":
                case "position2d":
                case "particle_uv":
                    this._type = (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2;
                    return this._type;
                case "matricesIndices":
                case "matricesWeights":
                case "matricesIndicesExtra":
                case "matricesWeightsExtra":
                case "world0":
                case "world1":
                case "world2":
                case "world3":
                case "tangent":
                    this._type = (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4;
                    return this._type;
                case "color":
                case "instanceColor":
                case "particle_color":
                case "particle_texturemask":
                    this._type = (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4;
                    return this._type;
            }
            if (this.isSystemValue) switch(this._systemValue){
                case (0, $7qH6c.NodeMaterialSystemValues).World:
                case (0, $7qH6c.NodeMaterialSystemValues).WorldView:
                case (0, $7qH6c.NodeMaterialSystemValues).WorldViewProjection:
                case (0, $7qH6c.NodeMaterialSystemValues).View:
                case (0, $7qH6c.NodeMaterialSystemValues).ViewProjection:
                case (0, $7qH6c.NodeMaterialSystemValues).Projection:
                    this._type = (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix;
                    return this._type;
                case (0, $7qH6c.NodeMaterialSystemValues).CameraPosition:
                    this._type = (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3;
                    return this._type;
                case (0, $7qH6c.NodeMaterialSystemValues).FogColor:
                    this._type = (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3;
                    return this._type;
                case (0, $7qH6c.NodeMaterialSystemValues).DeltaTime:
                case (0, $7qH6c.NodeMaterialSystemValues).MaterialAlpha:
                    this._type = (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float;
                    return this._type;
                case (0, $7qH6c.NodeMaterialSystemValues).CameraParameters:
                    this._type = (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4;
                    return this._type;
            }
        }
        return this._type;
    }
    /**
     * Creates a new InputBlock
     * @param name defines the block name
     * @param target defines the target of that block (Vertex by default)
     * @param type defines the type of the input (can be set to NodeMaterialBlockConnectionPointTypes.AutoDetect)
     */ constructor(name, target = (0, $iAIIe.NodeMaterialBlockTargets).Vertex, type = (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect){
        super(name, target, false);
        this._mode = (0, $g9kSQ.NodeMaterialBlockConnectionPointMode).Undefined;
        this._animationType = (0, $apsYB.AnimatedInputBlockTypes).None;
        /** Gets or set a value used to limit the range of float values */ this.min = 0;
        /** Gets or set a value used to limit the range of float values */ this.max = 0;
        /** Gets or set a value indicating that this input can only get 0 and 1 values */ this.isBoolean = false;
        /** Gets or sets a value used by the Node Material editor to determine how to configure the current value if it is a matrix */ this.matrixMode = 0;
        /** @internal */ this._systemValue = null;
        /** Gets or sets a boolean indicating that the value of this input will not change after a build */ this.isConstant = false;
        /** Gets or sets the group to use to display this block in the Inspector */ this.groupInInspector = "";
        /** Gets an observable raised when the value is changed */ this.onValueChangedObservable = new (0, $diGQf.Observable)();
        /** Gets or sets a boolean indicating if content needs to be converted to gamma space (for color3/4 only) */ this.convertToGammaSpace = false;
        /** Gets or sets a boolean indicating if content needs to be converted to linear space (for color3/4 only) */ this.convertToLinearSpace = false;
        this._type = type;
        this.setDefaultValue();
        this.registerOutput("output", type);
    }
    /**
     * Validates if a name is a reserve word.
     * @param newName the new name to be given to the node.
     * @returns false if the name is a reserve word, else true.
     */ validateBlockName(newName) {
        if (!this.isAttribute) return super.validateBlockName(newName);
        return true;
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    /**
     * Set the source of this connection point to a vertex attribute
     * @param attributeName defines the attribute name (position, uv, normal, etc...). If not specified it will take the connection point name
     * @returns the current connection point
     */ setAsAttribute(attributeName) {
        this._mode = (0, $g9kSQ.NodeMaterialBlockConnectionPointMode).Attribute;
        if (attributeName) this.name = attributeName;
        return this;
    }
    /**
     * Set the source of this connection point to a system value
     * @param value define the system value to use (world, view, etc...) or null to switch to manual value
     * @returns the current connection point
     */ setAsSystemValue(value) {
        this.systemValue = value;
        return this;
    }
    /**
     * Gets or sets the value of that point.
     * Please note that this value will be ignored if valueCallback is defined
     */ get value() {
        return this._storedValue;
    }
    set value(value) {
        if (this.type === (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float) {
            if (this.isBoolean) value = value ? 1 : 0;
            else if (this.min !== this.max) {
                value = Math.max(this.min, value);
                value = Math.min(this.max, value);
            }
        }
        this._storedValue = value;
        this._mode = (0, $g9kSQ.NodeMaterialBlockConnectionPointMode).Uniform;
        this.onValueChangedObservable.notifyObservers(this);
    }
    /**
     * Gets or sets a callback used to get the value of that point.
     * Please note that setting this value will force the connection point to ignore the value property
     */ get valueCallback() {
        return this._valueCallback;
    }
    set valueCallback(value) {
        this._valueCallback = value;
        this._mode = (0, $g9kSQ.NodeMaterialBlockConnectionPointMode).Uniform;
    }
    /**
     * Gets or sets the associated variable name in the shader
     */ get associatedVariableName() {
        return this._associatedVariableName;
    }
    set associatedVariableName(value) {
        this._associatedVariableName = value;
    }
    /** Gets or sets the type of animation applied to the input */ get animationType() {
        return this._animationType;
    }
    set animationType(value) {
        this._animationType = value;
    }
    /**
     * Gets a boolean indicating that this connection point not defined yet
     */ get isUndefined() {
        return this._mode === (0, $g9kSQ.NodeMaterialBlockConnectionPointMode).Undefined;
    }
    /**
     * Gets or sets a boolean indicating that this connection point is coming from an uniform.
     * In this case the connection point name must be the name of the uniform to use.
     * Can only be set on inputs
     */ get isUniform() {
        return this._mode === (0, $g9kSQ.NodeMaterialBlockConnectionPointMode).Uniform;
    }
    set isUniform(value) {
        this._mode = value ? (0, $g9kSQ.NodeMaterialBlockConnectionPointMode).Uniform : (0, $g9kSQ.NodeMaterialBlockConnectionPointMode).Undefined;
        this.associatedVariableName = "";
    }
    /**
     * Gets or sets a boolean indicating that this connection point is coming from an attribute.
     * In this case the connection point name must be the name of the attribute to use
     * Can only be set on inputs
     */ get isAttribute() {
        return this._mode === (0, $g9kSQ.NodeMaterialBlockConnectionPointMode).Attribute;
    }
    set isAttribute(value) {
        this._mode = value ? (0, $g9kSQ.NodeMaterialBlockConnectionPointMode).Attribute : (0, $g9kSQ.NodeMaterialBlockConnectionPointMode).Undefined;
        this.associatedVariableName = "";
    }
    /**
     * Gets or sets a boolean indicating that this connection point is generating a varying variable.
     * Can only be set on exit points
     */ get isVarying() {
        return this._mode === (0, $g9kSQ.NodeMaterialBlockConnectionPointMode).Varying;
    }
    set isVarying(value) {
        this._mode = value ? (0, $g9kSQ.NodeMaterialBlockConnectionPointMode).Varying : (0, $g9kSQ.NodeMaterialBlockConnectionPointMode).Undefined;
        this.associatedVariableName = "";
    }
    /**
     * Gets a boolean indicating that the current connection point is a system value
     */ get isSystemValue() {
        return this._systemValue != null;
    }
    /**
     * Gets or sets the current well known value or null if not defined as a system value
     */ get systemValue() {
        return this._systemValue;
    }
    set systemValue(value) {
        this._mode = (0, $g9kSQ.NodeMaterialBlockConnectionPointMode).Uniform;
        this.associatedVariableName = "";
        this._systemValue = value;
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "InputBlock";
    }
    /**
     * Animate the input if animationType !== None
     * @param scene defines the rendering scene
     */ animate(scene) {
        switch(this._animationType){
            case (0, $apsYB.AnimatedInputBlockTypes).Time:
                if (this.type === (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float) this.value += scene.getAnimationRatio() * 0.01;
                break;
            case (0, $apsYB.AnimatedInputBlockTypes).RealTime:
                if (this.type === (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float) this.value = ((0, $blHSI.PrecisionDate).Now - scene.getEngine().startTime) / 1000;
                break;
        }
    }
    _emitDefine(define) {
        if (define[0] === "!") return `#ifndef ${define.substring(1)}\n`;
        return `#ifdef ${define}\n`;
    }
    initialize() {
        this.associatedVariableName = "";
    }
    /**
     * Set the input block to its default value (based on its type)
     */ setDefaultValue() {
        switch(this.type){
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float:
                this.value = 0;
                break;
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2:
                this.value = (0, $ha1VO.Vector2).Zero();
                break;
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3:
                this.value = (0, $ha1VO.Vector3).Zero();
                break;
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4:
                this.value = (0, $ha1VO.Vector4).Zero();
                break;
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3:
                this.value = (0, $7etnY.Color3).White();
                break;
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4:
                this.value = new (0, $7etnY.Color4)(1, 1, 1, 1);
                break;
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix:
                this.value = (0, $ha1VO.Matrix).Identity();
                break;
        }
    }
    _emitConstant(state) {
        switch(this.type){
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float:
                return `${state._emitFloat(this.value)}`;
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2:
                return `vec2(${this.value.x}, ${this.value.y})`;
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3:
                return `vec3(${this.value.x}, ${this.value.y}, ${this.value.z})`;
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4:
                return `vec4(${this.value.x}, ${this.value.y}, ${this.value.z}, ${this.value.w})`;
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3:
                (0, $7etnY.TmpColors).Color3[0].set(this.value.r, this.value.g, this.value.b);
                if (this.convertToGammaSpace) (0, $7etnY.TmpColors).Color3[0].toGammaSpaceToRef((0, $7etnY.TmpColors).Color3[0], state.sharedData.scene.getEngine().useExactSrgbConversions);
                if (this.convertToLinearSpace) (0, $7etnY.TmpColors).Color3[0].toLinearSpaceToRef((0, $7etnY.TmpColors).Color3[0], state.sharedData.scene.getEngine().useExactSrgbConversions);
                return `vec3(${(0, $7etnY.TmpColors).Color3[0].r}, ${(0, $7etnY.TmpColors).Color3[0].g}, ${(0, $7etnY.TmpColors).Color3[0].b})`;
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4:
                (0, $7etnY.TmpColors).Color4[0].set(this.value.r, this.value.g, this.value.b, this.value.a);
                if (this.convertToGammaSpace) (0, $7etnY.TmpColors).Color4[0].toGammaSpaceToRef((0, $7etnY.TmpColors).Color4[0], state.sharedData.scene.getEngine().useExactSrgbConversions);
                if (this.convertToLinearSpace) (0, $7etnY.TmpColors).Color4[0].toLinearSpaceToRef((0, $7etnY.TmpColors).Color4[0], state.sharedData.scene.getEngine().useExactSrgbConversions);
                return `vec4(${(0, $7etnY.TmpColors).Color4[0].r}, ${(0, $7etnY.TmpColors).Color4[0].g}, ${(0, $7etnY.TmpColors).Color4[0].b}, ${(0, $7etnY.TmpColors).Color4[0].a})`;
        }
        return "";
    }
    /** @internal */ get _noContextSwitch() {
        return $7d3d70cafec7761a$var$attributeInFragmentOnly[this.name];
    }
    _emit(state, define) {
        // Uniforms
        if (this.isUniform) {
            if (!this.associatedVariableName) this.associatedVariableName = state._getFreeVariableName("u_" + this.name);
            if (this.isConstant) {
                if (state.constants.indexOf(this.associatedVariableName) !== -1) return;
                state.constants.push(this.associatedVariableName);
                state._constantDeclaration += this._declareOutput(this.output, state) + ` = ${this._emitConstant(state)};\n`;
                return;
            }
            if (state.uniforms.indexOf(this.associatedVariableName) !== -1) return;
            state.uniforms.push(this.associatedVariableName);
            if (define) state._uniformDeclaration += this._emitDefine(define);
            state._uniformDeclaration += `uniform ${state._getGLType(this.type)} ${this.associatedVariableName};\n`;
            if (define) state._uniformDeclaration += `#endif\n`;
            // well known
            const hints = state.sharedData.hints;
            if (this._systemValue !== null && this._systemValue !== undefined) switch(this._systemValue){
                case (0, $7qH6c.NodeMaterialSystemValues).WorldView:
                    hints.needWorldViewMatrix = true;
                    break;
                case (0, $7qH6c.NodeMaterialSystemValues).WorldViewProjection:
                    hints.needWorldViewProjectionMatrix = true;
                    break;
            }
            else if (this._animationType !== (0, $apsYB.AnimatedInputBlockTypes).None) state.sharedData.animatedInputs.push(this);
            return;
        }
        // Attribute
        if (this.isAttribute) {
            this.associatedVariableName = $7d3d70cafec7761a$var$remapAttributeName[this.name] ?? this.name;
            if (this.target === (0, $iAIIe.NodeMaterialBlockTargets).Vertex && state._vertexState) {
                // Attribute for fragment need to be carried over by varyings
                if ($7d3d70cafec7761a$var$attributeInFragmentOnly[this.name]) {
                    if ($7d3d70cafec7761a$var$attributeAsUniform[this.name]) state._emitUniformFromString(this.associatedVariableName, state._getGLType(this.type), define);
                    else state._emitVaryingFromString(this.associatedVariableName, state._getGLType(this.type), define);
                } else this._emit(state._vertexState, define);
                return;
            }
            if (state.attributes.indexOf(this.associatedVariableName) !== -1) return;
            state.attributes.push(this.associatedVariableName);
            if ($7d3d70cafec7761a$var$attributeInFragmentOnly[this.name]) {
                if ($7d3d70cafec7761a$var$attributeAsUniform[this.name]) state._emitUniformFromString(this.associatedVariableName, state._getGLType(this.type), define);
                else state._emitVaryingFromString(this.associatedVariableName, state._getGLType(this.type), define);
            } else {
                if (define) state._attributeDeclaration += this._emitDefine(define);
                state._attributeDeclaration += `attribute ${state._getGLType(this.type)} ${this.associatedVariableName};\n`;
                if (define) state._attributeDeclaration += `#endif\n`;
            }
        }
    }
    /**
     * @internal
     */ _transmitWorld(effect, world, worldView, worldViewProjection) {
        if (!this._systemValue) return;
        const variableName = this.associatedVariableName;
        switch(this._systemValue){
            case (0, $7qH6c.NodeMaterialSystemValues).World:
                effect.setMatrix(variableName, world);
                break;
            case (0, $7qH6c.NodeMaterialSystemValues).WorldView:
                effect.setMatrix(variableName, worldView);
                break;
            case (0, $7qH6c.NodeMaterialSystemValues).WorldViewProjection:
                effect.setMatrix(variableName, worldViewProjection);
                break;
        }
    }
    /**
     * @internal
     */ _transmit(effect, scene, material) {
        if (this.isAttribute) return;
        const variableName = this.associatedVariableName;
        if (this._systemValue) {
            switch(this._systemValue){
                case (0, $7qH6c.NodeMaterialSystemValues).World:
                case (0, $7qH6c.NodeMaterialSystemValues).WorldView:
                case (0, $7qH6c.NodeMaterialSystemValues).WorldViewProjection:
                    return;
                case (0, $7qH6c.NodeMaterialSystemValues).View:
                    effect.setMatrix(variableName, scene.getViewMatrix());
                    break;
                case (0, $7qH6c.NodeMaterialSystemValues).Projection:
                    effect.setMatrix(variableName, scene.getProjectionMatrix());
                    break;
                case (0, $7qH6c.NodeMaterialSystemValues).ViewProjection:
                    effect.setMatrix(variableName, scene.getTransformMatrix());
                    break;
                case (0, $7qH6c.NodeMaterialSystemValues).CameraPosition:
                    scene.bindEyePosition(effect, variableName, true);
                    break;
                case (0, $7qH6c.NodeMaterialSystemValues).FogColor:
                    effect.setColor3(variableName, scene.fogColor);
                    break;
                case (0, $7qH6c.NodeMaterialSystemValues).DeltaTime:
                    effect.setFloat(variableName, scene.deltaTime / 1000.0);
                    break;
                case (0, $7qH6c.NodeMaterialSystemValues).CameraParameters:
                    if (scene.activeCamera) effect.setFloat4(variableName, scene.getEngine().hasOriginBottomLeft ? -1 : 1, scene.activeCamera.minZ, scene.activeCamera.maxZ, 1 / scene.activeCamera.maxZ);
                    break;
                case (0, $7qH6c.NodeMaterialSystemValues).MaterialAlpha:
                    effect.setFloat(variableName, material.alpha);
                    break;
            }
            return;
        }
        const value = this._valueCallback ? this._valueCallback() : this._storedValue;
        if (value === null) return;
        switch(this.type){
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float:
                effect.setFloat(variableName, value);
                break;
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Int:
                effect.setInt(variableName, value);
                break;
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3:
                (0, $7etnY.TmpColors).Color3[0].set(this.value.r, this.value.g, this.value.b);
                if (this.convertToGammaSpace) (0, $7etnY.TmpColors).Color3[0].toGammaSpaceToRef((0, $7etnY.TmpColors).Color3[0], scene.getEngine().useExactSrgbConversions);
                if (this.convertToLinearSpace) (0, $7etnY.TmpColors).Color3[0].toLinearSpaceToRef((0, $7etnY.TmpColors).Color3[0], scene.getEngine().useExactSrgbConversions);
                effect.setColor3(variableName, (0, $7etnY.TmpColors).Color3[0]);
                break;
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4:
                (0, $7etnY.TmpColors).Color4[0].set(this.value.r, this.value.g, this.value.b, this.value.a);
                if (this.convertToGammaSpace) (0, $7etnY.TmpColors).Color4[0].toGammaSpaceToRef((0, $7etnY.TmpColors).Color4[0], scene.getEngine().useExactSrgbConversions);
                if (this.convertToLinearSpace) (0, $7etnY.TmpColors).Color4[0].toLinearSpaceToRef((0, $7etnY.TmpColors).Color4[0], scene.getEngine().useExactSrgbConversions);
                effect.setDirectColor4(variableName, (0, $7etnY.TmpColors).Color4[0]);
                break;
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2:
                effect.setVector2(variableName, value);
                break;
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3:
                effect.setVector3(variableName, value);
                break;
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4:
                effect.setVector4(variableName, value);
                break;
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix:
                effect.setMatrix(variableName, value);
                break;
        }
    }
    _buildBlock(state) {
        super._buildBlock(state);
        if (this.isUniform || this.isSystemValue) state.sharedData.inputBlocks.push(this);
        this._emit(state);
    }
    _dumpPropertiesCode() {
        const variableName = this._codeVariableName;
        if (this.isAttribute) return super._dumpPropertiesCode() + `${variableName}.setAsAttribute("${this.name}");\n`;
        if (this.isSystemValue) return super._dumpPropertiesCode() + `${variableName}.setAsSystemValue(BABYLON.NodeMaterialSystemValues.${(0, $7qH6c.NodeMaterialSystemValues)[this._systemValue]});\n`;
        if (this.isUniform) {
            const codes = [];
            let valueString = "";
            switch(this.type){
                case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float:
                    valueString = `${this.value}`;
                    break;
                case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2:
                    valueString = `new BABYLON.Vector2(${this.value.x}, ${this.value.y})`;
                    break;
                case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3:
                    valueString = `new BABYLON.Vector3(${this.value.x}, ${this.value.y}, ${this.value.z})`;
                    break;
                case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4:
                    valueString = `new BABYLON.Vector4(${this.value.x}, ${this.value.y}, ${this.value.z}, ${this.value.w})`;
                    break;
                case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3:
                    valueString = `new BABYLON.Color3(${this.value.r}, ${this.value.g}, ${this.value.b})`;
                    if (this.convertToGammaSpace) valueString += ".toGammaSpace()";
                    if (this.convertToLinearSpace) valueString += ".toLinearSpace()";
                    break;
                case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4:
                    valueString = `new BABYLON.Color4(${this.value.r}, ${this.value.g}, ${this.value.b}, ${this.value.a})`;
                    if (this.convertToGammaSpace) valueString += ".toGammaSpace()";
                    if (this.convertToLinearSpace) valueString += ".toLinearSpace()";
                    break;
                case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix:
                    valueString = `BABYLON.Matrix.FromArray([${this.value.m}])`;
                    break;
            }
            // Common Property "Value"
            codes.push(`${variableName}.value = ${valueString}`);
            // Float-Value-Specific Properties
            if (this.type === (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float) codes.push(`${variableName}.min = ${this.min}`, `${variableName}.max = ${this.max}`, `${variableName}.isBoolean = ${this.isBoolean}`, `${variableName}.matrixMode = ${this.matrixMode}`, `${variableName}.animationType = BABYLON.AnimatedInputBlockTypes.${(0, $apsYB.AnimatedInputBlockTypes)[this.animationType]}`);
            // Common Property "Type"
            codes.push(`${variableName}.isConstant = ${this.isConstant}`);
            codes.push("");
            return super._dumpPropertiesCode() + codes.join(";\n");
        }
        return super._dumpPropertiesCode();
    }
    dispose() {
        this.onValueChangedObservable.clear();
        super.dispose();
    }
    serialize() {
        const serializationObject = super.serialize();
        serializationObject.type = this.type;
        serializationObject.mode = this._mode;
        serializationObject.systemValue = this._systemValue;
        serializationObject.animationType = this._animationType;
        serializationObject.min = this.min;
        serializationObject.max = this.max;
        serializationObject.isBoolean = this.isBoolean;
        serializationObject.matrixMode = this.matrixMode;
        serializationObject.isConstant = this.isConstant;
        serializationObject.groupInInspector = this.groupInInspector;
        serializationObject.convertToGammaSpace = this.convertToGammaSpace;
        serializationObject.convertToLinearSpace = this.convertToLinearSpace;
        if (this._storedValue != null && this._mode === (0, $g9kSQ.NodeMaterialBlockConnectionPointMode).Uniform) {
            if (this._storedValue.asArray) {
                serializationObject.valueType = "BABYLON." + this._storedValue.getClassName();
                serializationObject.value = this._storedValue.asArray();
            } else {
                serializationObject.valueType = "number";
                serializationObject.value = this._storedValue;
            }
        }
        return serializationObject;
    }
    _deserialize(serializationObject, scene, rootUrl) {
        this._mode = serializationObject.mode;
        super._deserialize(serializationObject, scene, rootUrl);
        this._type = serializationObject.type;
        this._systemValue = serializationObject.systemValue || serializationObject.wellKnownValue;
        this._animationType = serializationObject.animationType;
        this.min = serializationObject.min || 0;
        this.max = serializationObject.max || 0;
        this.isBoolean = !!serializationObject.isBoolean;
        this.matrixMode = serializationObject.matrixMode || 0;
        this.isConstant = !!serializationObject.isConstant;
        this.groupInInspector = serializationObject.groupInInspector || "";
        this.convertToGammaSpace = !!serializationObject.convertToGammaSpace;
        this.convertToLinearSpace = !!serializationObject.convertToLinearSpace;
        // Tangents back compat
        if (serializationObject.name === "tangent" && serializationObject.mode === (0, $g9kSQ.NodeMaterialBlockConnectionPointMode).Attribute && serializationObject.type === (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3) this._type = (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4;
        if (!serializationObject.valueType) return;
        if (serializationObject.valueType === "number") this._storedValue = serializationObject.value;
        else {
            const valueType = (0, $8DoUR.GetClass)(serializationObject.valueType);
            if (valueType) this._storedValue = valueType.FromArray(serializationObject.value);
        }
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.InputBlock", $7d3d70cafec7761a$export$83678641c7770fa5);

});
parcelRegister("g9kSQ", function(module, exports) {

$parcel$export(module.exports, "NodeMaterialBlockConnectionPointMode", () => $bc1dafa947e07398$export$3900e380d3f808af);
/**
 * Enum defining the mode of a NodeMaterialBlockConnectionPoint
 */ var $bc1dafa947e07398$export$3900e380d3f808af;
(function(NodeMaterialBlockConnectionPointMode) {
    /** Value is an uniform */ NodeMaterialBlockConnectionPointMode[NodeMaterialBlockConnectionPointMode["Uniform"] = 0] = "Uniform";
    /** Value is a mesh attribute */ NodeMaterialBlockConnectionPointMode[NodeMaterialBlockConnectionPointMode["Attribute"] = 1] = "Attribute";
    /** Value is a varying between vertex and fragment shaders */ NodeMaterialBlockConnectionPointMode[NodeMaterialBlockConnectionPointMode["Varying"] = 2] = "Varying";
    /** Mode is undefined */ NodeMaterialBlockConnectionPointMode[NodeMaterialBlockConnectionPointMode["Undefined"] = 3] = "Undefined";
})($bc1dafa947e07398$export$3900e380d3f808af || ($bc1dafa947e07398$export$3900e380d3f808af = {}));

});

parcelRegister("7qH6c", function(module, exports) {

$parcel$export(module.exports, "NodeMaterialSystemValues", () => $568c64b0b5b69255$export$d5dbb3918d226ea2);
/**
 * Enum used to define system values e.g. values automatically provided by the system
 */ var $568c64b0b5b69255$export$d5dbb3918d226ea2;
(function(NodeMaterialSystemValues) {
    /** World */ NodeMaterialSystemValues[NodeMaterialSystemValues["World"] = 1] = "World";
    /** View */ NodeMaterialSystemValues[NodeMaterialSystemValues["View"] = 2] = "View";
    /** Projection */ NodeMaterialSystemValues[NodeMaterialSystemValues["Projection"] = 3] = "Projection";
    /** ViewProjection */ NodeMaterialSystemValues[NodeMaterialSystemValues["ViewProjection"] = 4] = "ViewProjection";
    /** WorldView */ NodeMaterialSystemValues[NodeMaterialSystemValues["WorldView"] = 5] = "WorldView";
    /** WorldViewProjection */ NodeMaterialSystemValues[NodeMaterialSystemValues["WorldViewProjection"] = 6] = "WorldViewProjection";
    /** CameraPosition */ NodeMaterialSystemValues[NodeMaterialSystemValues["CameraPosition"] = 7] = "CameraPosition";
    /** Fog Color */ NodeMaterialSystemValues[NodeMaterialSystemValues["FogColor"] = 8] = "FogColor";
    /** Delta time */ NodeMaterialSystemValues[NodeMaterialSystemValues["DeltaTime"] = 9] = "DeltaTime";
    /** Camera parameters */ NodeMaterialSystemValues[NodeMaterialSystemValues["CameraParameters"] = 10] = "CameraParameters";
    /** Material alpha */ NodeMaterialSystemValues[NodeMaterialSystemValues["MaterialAlpha"] = 11] = "MaterialAlpha";
})($568c64b0b5b69255$export$d5dbb3918d226ea2 || ($568c64b0b5b69255$export$d5dbb3918d226ea2 = {}));

});

parcelRegister("6rxfP", function(module, exports) {

var $dbxbu = parcelRequire("dbxbu");

var $7etnY = parcelRequire("7etnY");

var $53VPf = parcelRequire("53VPf");

var $9sPMJ = parcelRequire("9sPMJ");

var $fm2C6 = parcelRequire("fm2C6");

var $23POp = parcelRequire("23POp");

var $93o7r = parcelRequire("93o7r");

var $ha1VO = parcelRequire("ha1VO");

var $g13hK = parcelRequire("g13hK");

var $191mA = parcelRequire("191mA");
$parcel$exportWildcard(module.exports, $dbxbu);
$parcel$exportWildcard(module.exports, $7etnY);
$parcel$exportWildcard(module.exports, $53VPf);
$parcel$exportWildcard(module.exports, $9sPMJ);
$parcel$exportWildcard(module.exports, $fm2C6);
$parcel$exportWildcard(module.exports, $23POp);
$parcel$exportWildcard(module.exports, $93o7r);
$parcel$exportWildcard(module.exports, $ha1VO);
$parcel$exportWildcard(module.exports, $g13hK);
$parcel$exportWildcard(module.exports, $191mA);

});
parcelRegister("g13hK", function(module, exports) {

$parcel$export(module.exports, "PositionNormalVertex", () => $ba8f49b7445ee893$export$7060026f20f731a4);
$parcel$export(module.exports, "PositionNormalTextureVertex", () => $ba8f49b7445ee893$export$e40add16394b9bff);

var $ha1VO = parcelRequire("ha1VO");
class $ba8f49b7445ee893$export$7060026f20f731a4 {
    /**
     * Creates a PositionNormalVertex
     * @param position the position of the vertex (defaut: 0,0,0)
     * @param normal the normal of the vertex (defaut: 0,1,0)
     */ constructor(/** the position of the vertex (defaut: 0,0,0) */ position = (0, $ha1VO.Vector3).Zero(), /** the normal of the vertex (defaut: 0,1,0) */ normal = (0, $ha1VO.Vector3).Up()){
        this.position = position;
        this.normal = normal;
    }
    /**
     * Clones the PositionNormalVertex
     * @returns the cloned PositionNormalVertex
     */ clone() {
        return new $ba8f49b7445ee893$export$7060026f20f731a4(this.position.clone(), this.normal.clone());
    }
}
class $ba8f49b7445ee893$export$e40add16394b9bff {
    /**
     * Creates a PositionNormalTextureVertex
     * @param position the position of the vertex (defaut: 0,0,0)
     * @param normal the normal of the vertex (defaut: 0,1,0)
     * @param uv the uv of the vertex (default: 0,0)
     */ constructor(/** the position of the vertex (defaut: 0,0,0) */ position = (0, $ha1VO.Vector3).Zero(), /** the normal of the vertex (defaut: 0,1,0) */ normal = (0, $ha1VO.Vector3).Up(), /** the uv of the vertex (default: 0,0) */ uv = (0, $ha1VO.Vector2).Zero()){
        this.position = position;
        this.normal = normal;
        this.uv = uv;
    }
    /**
     * Clones the PositionNormalTextureVertex
     * @returns the cloned PositionNormalTextureVertex
     */ clone() {
        return new $ba8f49b7445ee893$export$e40add16394b9bff(this.position.clone(), this.normal.clone(), this.uv.clone());
    }
}

});


parcelRegister("apsYB", function(module, exports) {

$parcel$export(module.exports, "AnimatedInputBlockTypes", () => $7942b753ee8927e7$export$2a701ff8dbbbad05);
/**
 * Enum defining the type of animations supported by InputBlock
 */ var $7942b753ee8927e7$export$2a701ff8dbbbad05;
(function(AnimatedInputBlockTypes) {
    /** No animation */ AnimatedInputBlockTypes[AnimatedInputBlockTypes["None"] = 0] = "None";
    /** Time based animation (is incremented by 0.6 each second). Will only work for floats */ AnimatedInputBlockTypes[AnimatedInputBlockTypes["Time"] = 1] = "Time";
    /** Time elapsed (in seconds) since the engine was initialized. Will only work for floats */ AnimatedInputBlockTypes[AnimatedInputBlockTypes["RealTime"] = 2] = "RealTime";
})($7942b753ee8927e7$export$2a701ff8dbbbad05 || ($7942b753ee8927e7$export$2a701ff8dbbbad05 = {}));

});


parcelRegister("h62fU", function(module, exports) {

$parcel$export(module.exports, "CurrentScreenBlock", () => $c724bf22e263e389$export$58d3e1106d18805f);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");

var $j2mX5 = parcelRequire("j2mX5");
class $c724bf22e263e389$export$58d3e1106d18805f extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Create a new CurrentScreenBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment);
        this._samplerName = "textureSampler";
        /**
         * Gets or sets a boolean indicating if content needs to be converted to gamma space
         */ this.convertToGammaSpace = false;
        /**
         * Gets or sets a boolean indicating if content needs to be converted to linear space
         */ this.convertToLinearSpace = false;
        this._isUnique = false;
        this.registerInput("uv", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect, false, (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment);
        this.registerOutput("rgba", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerOutput("rgb", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerOutput("r", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerOutput("g", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerOutput("b", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerOutput("a", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this._inputs[0].addExcludedConnectionPointFromAllowedTypes((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4);
        this._inputs[0]._prioritizeVertex = false;
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "CurrentScreenBlock";
    }
    /**
     * Gets the uv input component
     */ get uv() {
        return this._inputs[0];
    }
    /**
     * Gets the rgba output component
     */ get rgba() {
        return this._outputs[0];
    }
    /**
     * Gets the rgb output component
     */ get rgb() {
        return this._outputs[1];
    }
    /**
     * Gets the r output component
     */ get r() {
        return this._outputs[2];
    }
    /**
     * Gets the g output component
     */ get g() {
        return this._outputs[3];
    }
    /**
     * Gets the b output component
     */ get b() {
        return this._outputs[4];
    }
    /**
     * Gets the a output component
     */ get a() {
        return this._outputs[5];
    }
    /**
     * Initialize the block and prepare the context for build
     * @param state defines the state that will be used for the build
     */ initialize(state) {
        state._excludeVariableName("textureSampler");
    }
    get target() {
        if (!this.uv.isConnected) return (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment;
        if (this.uv.sourceBlock.isInput) return (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment;
        return (0, $iAIIe.NodeMaterialBlockTargets).Fragment;
    }
    prepareDefines(mesh, nodeMaterial, defines) {
        defines.setValue(this._linearDefineName, this.convertToGammaSpace, true);
        defines.setValue(this._gammaDefineName, this.convertToLinearSpace, true);
    }
    isReady() {
        if (this.texture && !this.texture.isReadyOrNotBlocking()) return false;
        return true;
    }
    _injectVertexCode(state) {
        const uvInput = this.uv;
        if (uvInput.connectedPoint.ownerBlock.isInput) {
            const uvInputOwnerBlock = uvInput.connectedPoint.ownerBlock;
            if (!uvInputOwnerBlock.isAttribute) state._emitUniformFromString(uvInput.associatedVariableName, "vec2");
        }
        this._mainUVName = "vMain" + uvInput.associatedVariableName;
        state._emitVaryingFromString(this._mainUVName, "vec2");
        state.compilationString += `${this._mainUVName} = ${uvInput.associatedVariableName}.xy;\n`;
        if (!this._outputs.some((o)=>o.isConnectedInVertexShader)) return;
        this._writeTextureRead(state, true);
        for (const output of this._outputs)if (output.hasEndpoints) this._writeOutput(state, output, output.name, true);
    }
    _writeTextureRead(state, vertexMode = false) {
        const uvInput = this.uv;
        if (vertexMode) {
            if (state.target === (0, $iAIIe.NodeMaterialBlockTargets).Fragment) return;
            state.compilationString += `vec4 ${this._tempTextureRead} = texture2D(${this._samplerName}, ${uvInput.associatedVariableName});\n`;
            return;
        }
        if (this.uv.ownerBlock.target === (0, $iAIIe.NodeMaterialBlockTargets).Fragment) {
            state.compilationString += `vec4 ${this._tempTextureRead} = texture2D(${this._samplerName}, ${uvInput.associatedVariableName});\n`;
            return;
        }
        state.compilationString += `vec4 ${this._tempTextureRead} = texture2D(${this._samplerName}, ${this._mainUVName});\n`;
    }
    _writeOutput(state, output, swizzle, vertexMode = false) {
        if (vertexMode) {
            if (state.target === (0, $iAIIe.NodeMaterialBlockTargets).Fragment) return;
            state.compilationString += `${this._declareOutput(output, state)} = ${this._tempTextureRead}.${swizzle};\n`;
            return;
        }
        if (this.uv.ownerBlock.target === (0, $iAIIe.NodeMaterialBlockTargets).Fragment) {
            state.compilationString += `${this._declareOutput(output, state)} = ${this._tempTextureRead}.${swizzle};\n`;
            return;
        }
        state.compilationString += `${this._declareOutput(output, state)} = ${this._tempTextureRead}.${swizzle};\n`;
        state.compilationString += `#ifdef ${this._linearDefineName}\n`;
        state.compilationString += `${output.associatedVariableName} = toGammaSpace(${output.associatedVariableName});\n`;
        state.compilationString += `#endif\n`;
        state.compilationString += `#ifdef ${this._gammaDefineName}\n`;
        state.compilationString += `${output.associatedVariableName} = toLinearSpace(${output.associatedVariableName});\n`;
        state.compilationString += `#endif\n`;
    }
    _buildBlock(state) {
        super._buildBlock(state);
        this._tempTextureRead = state._getFreeVariableName("tempTextureRead");
        if (state.sharedData.blockingBlocks.indexOf(this) < 0) state.sharedData.blockingBlocks.push(this);
        if (state.sharedData.textureBlocks.indexOf(this) < 0) state.sharedData.textureBlocks.push(this);
        if (state.sharedData.blocksWithDefines.indexOf(this) < 0) state.sharedData.blocksWithDefines.push(this);
        if (state.target !== (0, $iAIIe.NodeMaterialBlockTargets).Fragment) {
            // Vertex
            state._emit2DSampler(this._samplerName);
            this._injectVertexCode(state);
            return;
        }
        // Fragment
        if (!this._outputs.some((o)=>o.isConnectedInFragmentShader)) return;
        state._emit2DSampler(this._samplerName);
        this._linearDefineName = state._getFreeDefineName("ISLINEAR");
        this._gammaDefineName = state._getFreeDefineName("ISGAMMA");
        const comments = `//${this.name}`;
        state._emitFunctionFromInclude("helperFunctions", comments);
        this._writeTextureRead(state);
        for (const output of this._outputs)if (output.hasEndpoints) this._writeOutput(state, output, output.name);
        return this;
    }
    serialize() {
        const serializationObject = super.serialize();
        serializationObject.convertToGammaSpace = this.convertToGammaSpace;
        serializationObject.convertToLinearSpace = this.convertToLinearSpace;
        if (this.texture && !this.texture.isRenderTarget) serializationObject.texture = this.texture.serialize();
        return serializationObject;
    }
    _deserialize(serializationObject, scene, rootUrl) {
        super._deserialize(serializationObject, scene, rootUrl);
        this.convertToGammaSpace = serializationObject.convertToGammaSpace;
        this.convertToLinearSpace = !!serializationObject.convertToLinearSpace;
        if (serializationObject.texture) {
            rootUrl = serializationObject.texture.url.indexOf("data:") === 0 ? "" : rootUrl;
            this.texture = (0, $j2mX5.Texture).Parse(serializationObject.texture, scene, rootUrl);
        }
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.CurrentScreenBlock", $c724bf22e263e389$export$58d3e1106d18805f);

});

parcelRegister("hExiF", function(module, exports) {

$parcel$export(module.exports, "ParticleTextureBlock", () => $cda000cc394702d0$export$ab5a5c6d4d30e41b);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $aKEh2 = parcelRequire("aKEh2");

var $8DoUR = parcelRequire("8DoUR");

var $j2mX5 = parcelRequire("j2mX5");
class $cda000cc394702d0$export$ab5a5c6d4d30e41b extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Create a new ParticleTextureBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this._samplerName = "diffuseSampler";
        /**
         * Gets or sets a boolean indicating if content needs to be converted to gamma space
         */ this.convertToGammaSpace = false;
        /**
         * Gets or sets a boolean indicating if content needs to be converted to linear space
         */ this.convertToLinearSpace = false;
        this._isUnique = false;
        this.registerInput("uv", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect, false, (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment);
        this.registerOutput("rgba", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerOutput("rgb", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerOutput("r", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerOutput("g", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerOutput("b", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerOutput("a", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this._inputs[0].addExcludedConnectionPointFromAllowedTypes((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "ParticleTextureBlock";
    }
    /**
     * Gets the uv input component
     */ get uv() {
        return this._inputs[0];
    }
    /**
     * Gets the rgba output component
     */ get rgba() {
        return this._outputs[0];
    }
    /**
     * Gets the rgb output component
     */ get rgb() {
        return this._outputs[1];
    }
    /**
     * Gets the r output component
     */ get r() {
        return this._outputs[2];
    }
    /**
     * Gets the g output component
     */ get g() {
        return this._outputs[3];
    }
    /**
     * Gets the b output component
     */ get b() {
        return this._outputs[4];
    }
    /**
     * Gets the a output component
     */ get a() {
        return this._outputs[5];
    }
    /**
     * Initialize the block and prepare the context for build
     * @param state defines the state that will be used for the build
     */ initialize(state) {
        state._excludeVariableName("diffuseSampler");
    }
    autoConfigure(material, additionalFilteringInfo = ()=>true) {
        if (!this.uv.isConnected) {
            let uvInput = material.getInputBlockByPredicate((b)=>b.isAttribute && b.name === "particle_uv" && additionalFilteringInfo(b));
            if (!uvInput) {
                uvInput = new (0, $aKEh2.InputBlock)("uv");
                uvInput.setAsAttribute("particle_uv");
            }
            uvInput.output.connectTo(this.uv);
        }
    }
    prepareDefines(mesh, nodeMaterial, defines) {
        defines.setValue(this._linearDefineName, this.convertToGammaSpace, true);
        defines.setValue(this._gammaDefineName, this.convertToLinearSpace, true);
    }
    isReady() {
        if (this.texture && !this.texture.isReadyOrNotBlocking()) return false;
        return true;
    }
    _writeOutput(state, output, swizzle) {
        state.compilationString += `${this._declareOutput(output, state)} = ${this._tempTextureRead}.${swizzle};\n`;
        state.compilationString += `#ifdef ${this._linearDefineName}\n`;
        state.compilationString += `${output.associatedVariableName} = toGammaSpace(${output.associatedVariableName});\n`;
        state.compilationString += `#endif\n`;
        state.compilationString += `#ifdef ${this._gammaDefineName}\n`;
        state.compilationString += `${output.associatedVariableName} = toLinearSpace(${output.associatedVariableName});\n`;
        state.compilationString += `#endif\n`;
    }
    _buildBlock(state) {
        super._buildBlock(state);
        if (state.target === (0, $iAIIe.NodeMaterialBlockTargets).Vertex) return;
        this._tempTextureRead = state._getFreeVariableName("tempTextureRead");
        state._emit2DSampler(this._samplerName);
        state.sharedData.blockingBlocks.push(this);
        state.sharedData.textureBlocks.push(this);
        state.sharedData.blocksWithDefines.push(this);
        this._linearDefineName = state._getFreeDefineName("ISLINEAR");
        this._gammaDefineName = state._getFreeDefineName("ISGAMMA");
        const comments = `//${this.name}`;
        state._emitFunctionFromInclude("helperFunctions", comments);
        state.compilationString += `vec4 ${this._tempTextureRead} = texture2D(${this._samplerName}, ${this.uv.associatedVariableName});\n`;
        for (const output of this._outputs)if (output.hasEndpoints) this._writeOutput(state, output, output.name);
        return this;
    }
    serialize() {
        const serializationObject = super.serialize();
        serializationObject.convertToGammaSpace = this.convertToGammaSpace;
        serializationObject.convertToLinearSpace = this.convertToLinearSpace;
        if (this.texture && !this.texture.isRenderTarget) serializationObject.texture = this.texture.serialize();
        return serializationObject;
    }
    _deserialize(serializationObject, scene, rootUrl) {
        super._deserialize(serializationObject, scene, rootUrl);
        this.convertToGammaSpace = serializationObject.convertToGammaSpace;
        this.convertToLinearSpace = !!serializationObject.convertToLinearSpace;
        if (serializationObject.texture) {
            rootUrl = serializationObject.texture.url.indexOf("data:") === 0 ? "" : rootUrl;
            this.texture = (0, $j2mX5.Texture).Parse(serializationObject.texture, scene, rootUrl);
        }
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.ParticleTextureBlock", $cda000cc394702d0$export$ab5a5c6d4d30e41b);

});

parcelRegister("ejSsy", function(module, exports) {

$parcel$export(module.exports, "ParticleRampGradientBlock", () => $a6cd158c3f20d290$export$be327d4f94d399e3);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $a6cd158c3f20d290$export$be327d4f94d399e3 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Create a new ParticleRampGradientBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this._isUnique = true;
        this.registerInput("color", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4, false, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("rampColor", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "ParticleRampGradientBlock";
    }
    /**
     * Gets the color input component
     */ get color() {
        return this._inputs[0];
    }
    /**
     * Gets the rampColor output component
     */ get rampColor() {
        return this._outputs[0];
    }
    /**
     * Initialize the block and prepare the context for build
     * @param state defines the state that will be used for the build
     */ initialize(state) {
        state._excludeVariableName("remapRanges");
        state._excludeVariableName("rampSampler");
        state._excludeVariableName("baseColor");
        state._excludeVariableName("alpha");
        state._excludeVariableName("remappedColorIndex");
        state._excludeVariableName("rampColor");
        state._excludeVariableName("finalAlpha");
    }
    _buildBlock(state) {
        super._buildBlock(state);
        if (state.target === (0, $iAIIe.NodeMaterialBlockTargets).Vertex) return;
        state._emit2DSampler("rampSampler");
        state._emitVaryingFromString("remapRanges", "vec4", "RAMPGRADIENT");
        state.compilationString += `
            #ifdef RAMPGRADIENT
                vec4 baseColor = ${this.color.associatedVariableName};
                float alpha = ${this.color.associatedVariableName}.a;

                float remappedColorIndex = clamp((alpha - remapRanges.x) / remapRanges.y, 0.0, 1.0);

                vec4 rampColor = texture2D(rampSampler, vec2(1.0 - remappedColorIndex, 0.));
                baseColor.rgb *= rampColor.rgb;

                // Remapped alpha
                float finalAlpha = baseColor.a;
                baseColor.a = clamp((alpha * rampColor.a - remapRanges.z) / remapRanges.w, 0.0, 1.0);

                ${this._declareOutput(this.rampColor, state)} = baseColor;
            #else
                ${this._declareOutput(this.rampColor, state)} = ${this.color.associatedVariableName};
            #endif
        `;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.ParticleRampGradientBlock", $a6cd158c3f20d290$export$be327d4f94d399e3);

});

parcelRegister("h7sVv", function(module, exports) {

$parcel$export(module.exports, "ParticleBlendMultiplyBlock", () => $c769875625e2c475$export$54225dc42619ca91);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $c769875625e2c475$export$54225dc42619ca91 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Create a new ParticleBlendMultiplyBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this._isUnique = true;
        this.registerInput("color", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4, false, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("alphaTexture", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, false, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("alphaColor", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, false, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("blendColor", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "ParticleBlendMultiplyBlock";
    }
    /**
     * Gets the color input component
     */ get color() {
        return this._inputs[0];
    }
    /**
     * Gets the alphaTexture input component
     */ get alphaTexture() {
        return this._inputs[1];
    }
    /**
     * Gets the alphaColor input component
     */ get alphaColor() {
        return this._inputs[2];
    }
    /**
     * Gets the blendColor output component
     */ get blendColor() {
        return this._outputs[0];
    }
    /**
     * Initialize the block and prepare the context for build
     * @param state defines the state that will be used for the build
     */ initialize(state) {
        state._excludeVariableName("sourceAlpha");
    }
    _buildBlock(state) {
        super._buildBlock(state);
        if (state.target === (0, $iAIIe.NodeMaterialBlockTargets).Vertex) return;
        state.compilationString += `
            #ifdef BLENDMULTIPLYMODE
                ${this._declareOutput(this.blendColor, state)};
                float sourceAlpha = ${this.alphaColor.associatedVariableName} * ${this.alphaTexture.associatedVariableName};
                ${this.blendColor.associatedVariableName}.rgb = ${this.color.associatedVariableName}.rgb * sourceAlpha + vec3(1.0) * (1.0 - sourceAlpha);
                ${this.blendColor.associatedVariableName}.a = ${this.color.associatedVariableName}.a;
            #else
                ${this._declareOutput(this.blendColor, state)} = ${this.color.associatedVariableName};
            #endif
        `;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.ParticleBlendMultiplyBlock", $c769875625e2c475$export$54225dc42619ca91);

});

parcelRegister("gc8Ja", function(module, exports) {

$parcel$export(module.exports, "EffectFallbacks", () => $bca4896819e5389c$export$3e78d35a7e1b5710);
/**
 * EffectFallbacks can be used to add fallbacks (properties to disable) to certain properties when desired to improve performance.
 * (Eg. Start at high quality with reflection and fog, if fps is low, remove reflection, if still low remove fog)
 */ class $bca4896819e5389c$export$3e78d35a7e1b5710 {
    constructor(){
        this._defines = {};
        this._currentRank = 32;
        this._maxRank = -1;
        this._mesh = null;
    }
    /**
     * Removes the fallback from the bound mesh.
     */ unBindMesh() {
        this._mesh = null;
    }
    /**
     * Adds a fallback on the specified property.
     * @param rank The rank of the fallback (Lower ranks will be fallbacked to first)
     * @param define The name of the define in the shader
     */ addFallback(rank, define) {
        if (!this._defines[rank]) {
            if (rank < this._currentRank) this._currentRank = rank;
            if (rank > this._maxRank) this._maxRank = rank;
            this._defines[rank] = new Array();
        }
        this._defines[rank].push(define);
    }
    /**
     * Sets the mesh to use CPU skinning when needing to fallback.
     * @param rank The rank of the fallback (Lower ranks will be fallbacked to first)
     * @param mesh The mesh to use the fallbacks.
     */ addCPUSkinningFallback(rank, mesh) {
        this._mesh = mesh;
        if (rank < this._currentRank) this._currentRank = rank;
        if (rank > this._maxRank) this._maxRank = rank;
    }
    /**
     * Checks to see if more fallbacks are still available.
     */ get hasMoreFallbacks() {
        return this._currentRank <= this._maxRank;
    }
    /**
     * Removes the defines that should be removed when falling back.
     * @param currentDefines defines the current define statements for the shader.
     * @param effect defines the current effect we try to compile
     * @returns The resulting defines with defines of the current rank removed.
     */ reduce(currentDefines, effect) {
        // First we try to switch to CPU skinning
        if (this._mesh && this._mesh.computeBonesUsingShaders && this._mesh.numBoneInfluencers > 0) {
            this._mesh.computeBonesUsingShaders = false;
            currentDefines = currentDefines.replace("#define NUM_BONE_INFLUENCERS " + this._mesh.numBoneInfluencers, "#define NUM_BONE_INFLUENCERS 0");
            effect._bonesComputationForcedToCPU = true;
            const scene = this._mesh.getScene();
            for(let index = 0; index < scene.meshes.length; index++){
                const otherMesh = scene.meshes[index];
                if (!otherMesh.material) {
                    if (!this._mesh.material && otherMesh.computeBonesUsingShaders && otherMesh.numBoneInfluencers > 0) otherMesh.computeBonesUsingShaders = false;
                    continue;
                }
                if (!otherMesh.computeBonesUsingShaders || otherMesh.numBoneInfluencers === 0) continue;
                if (otherMesh.material.getEffect() === effect) otherMesh.computeBonesUsingShaders = false;
                else if (otherMesh.subMeshes) for (const subMesh of otherMesh.subMeshes){
                    const subMeshEffect = subMesh.effect;
                    if (subMeshEffect === effect) {
                        otherMesh.computeBonesUsingShaders = false;
                        break;
                    }
                }
            }
        } else {
            const currentFallbacks = this._defines[this._currentRank];
            if (currentFallbacks) for(let index = 0; index < currentFallbacks.length; index++)currentDefines = currentDefines.replace("#define " + currentFallbacks[index], "");
            this._currentRank++;
        }
        return currentDefines;
    }
}

});

parcelRegister("cFdBb", function(module, exports) {

$parcel$export(module.exports, "PostProcess", () => $9383dcc74058dbdc$export$f2e2be0a47b5edf8);

var $e0Suo = parcelRequire("e0Suo");

var $57onU = parcelRequire("57onU");

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");
parcelRequire("cr88r");

var $5YkyR = parcelRequire("5YkyR");
parcelRequire("4PdZs");

var $ir0rz = parcelRequire("ir0rz");

var $6Ho1L = parcelRequire("6Ho1L");

var $8DoUR = parcelRequire("8DoUR");

var $hOyoX = parcelRequire("hOyoX");

var $8WI3I = parcelRequire("8WI3I");
class $9383dcc74058dbdc$export$f2e2be0a47b5edf8 {
    /**
     * Registers a shader code processing with a post process name.
     * @param postProcessName name of the post process. Use null for the fallback shader code processing. This is the shader code processing that will be used in case no specific shader code processing has been associated to a post process name
     * @param customShaderCodeProcessing shader code processing to associate to the post process name
     */ static RegisterShaderCodeProcessing(postProcessName, customShaderCodeProcessing) {
        if (!customShaderCodeProcessing) {
            delete $9383dcc74058dbdc$export$f2e2be0a47b5edf8._CustomShaderCodeProcessing[postProcessName ?? ""];
            return;
        }
        $9383dcc74058dbdc$export$f2e2be0a47b5edf8._CustomShaderCodeProcessing[postProcessName ?? ""] = customShaderCodeProcessing;
    }
    static _GetShaderCodeProcessing(postProcessName) {
        return $9383dcc74058dbdc$export$f2e2be0a47b5edf8._CustomShaderCodeProcessing[postProcessName] ?? $9383dcc74058dbdc$export$f2e2be0a47b5edf8._CustomShaderCodeProcessing[""];
    }
    /**
     * Number of sample textures (default: 1)
     */ get samples() {
        return this._samples;
    }
    set samples(n) {
        this._samples = Math.min(n, this._engine.getCaps().maxMSAASamples);
        this._textures.forEach((texture)=>{
            texture.setSamples(this._samples);
        });
    }
    /**
     * Returns the fragment url or shader name used in the post process.
     * @returns the fragment url or name in the shader store.
     */ getEffectName() {
        return this._fragmentUrl;
    }
    /**
     * A function that is added to the onActivateObservable
     */ set onActivate(callback) {
        if (this._onActivateObserver) this.onActivateObservable.remove(this._onActivateObserver);
        if (callback) this._onActivateObserver = this.onActivateObservable.add(callback);
    }
    /**
     * A function that is added to the onSizeChangedObservable
     */ set onSizeChanged(callback) {
        if (this._onSizeChangedObserver) this.onSizeChangedObservable.remove(this._onSizeChangedObserver);
        this._onSizeChangedObserver = this.onSizeChangedObservable.add(callback);
    }
    /**
     * A function that is added to the onApplyObservable
     */ set onApply(callback) {
        if (this._onApplyObserver) this.onApplyObservable.remove(this._onApplyObserver);
        this._onApplyObserver = this.onApplyObservable.add(callback);
    }
    /**
     * A function that is added to the onBeforeRenderObservable
     */ set onBeforeRender(callback) {
        if (this._onBeforeRenderObserver) this.onBeforeRenderObservable.remove(this._onBeforeRenderObserver);
        this._onBeforeRenderObserver = this.onBeforeRenderObservable.add(callback);
    }
    /**
     * A function that is added to the onAfterRenderObservable
     */ set onAfterRender(callback) {
        if (this._onAfterRenderObserver) this.onAfterRenderObservable.remove(this._onAfterRenderObserver);
        this._onAfterRenderObserver = this.onAfterRenderObservable.add(callback);
    }
    /**
     * The input texture for this post process and the output texture of the previous post process. When added to a pipeline the previous post process will
     * render it's output into this texture and this texture will be used as textureSampler in the fragment shader of this post process.
     */ get inputTexture() {
        return this._textures.data[this._currentRenderTextureInd];
    }
    set inputTexture(value) {
        this._forcedOutputTexture = value;
    }
    /**
     * Since inputTexture should always be defined, if we previously manually set `inputTexture`,
     * the only way to unset it is to use this function to restore its internal state
     */ restoreDefaultInputTexture() {
        if (this._forcedOutputTexture) {
            this._forcedOutputTexture = null;
            this.markTextureDirty();
        }
    }
    /**
     * Gets the camera which post process is applied to.
     * @returns The camera the post process is applied to.
     */ getCamera() {
        return this._camera;
    }
    /**
     * Gets the texel size of the postprocess.
     * See https://en.wikipedia.org/wiki/Texel_(graphics)
     */ get texelSize() {
        if (this._shareOutputWithPostProcess) return this._shareOutputWithPostProcess.texelSize;
        if (this._forcedOutputTexture) this._texelSize.copyFromFloats(1.0 / this._forcedOutputTexture.width, 1.0 / this._forcedOutputTexture.height);
        return this._texelSize;
    }
    /** @internal */ constructor(name, fragmentUrl, parameters, samplers, _size, camera, samplingMode = 1, engine, reusable, defines = null, textureType = 0, vertexUrl = "postprocess", indexParameters, blockCompilation = false, textureFormat = 5, shaderLanguage = (0, $8WI3I.ShaderLanguage).GLSL){
        /** @internal */ this._parentContainer = null;
        /**
         * Width of the texture to apply the post process on
         */ this.width = -1;
        /**
         * Height of the texture to apply the post process on
         */ this.height = -1;
        /**
         * Gets the node material used to create this postprocess (null if the postprocess was manually created)
         */ this.nodeMaterialSource = null;
        /**
         * Internal, reference to the location where this postprocess was output to. (Typically the texture on the next postprocess in the chain)
         * @internal
         */ this._outputTexture = null;
        /**
         * If the buffer needs to be cleared before applying the post process. (default: true)
         * Should be set to false if shader will overwrite all previous pixels.
         */ this.autoClear = true;
        /**
         * If clearing the buffer should be forced in autoClear mode, even when alpha mode is enabled (default: false).
         * By default, the buffer will only be cleared if alpha mode is disabled (and autoClear is true).
         */ this.forceAutoClearInAlphaMode = false;
        /**
         * Type of alpha mode to use when performing the post process (default: Engine.ALPHA_DISABLE)
         */ this.alphaMode = 0;
        /**
         * Animations to be used for the post processing
         */ this.animations = [];
        /**
         * Enable Pixel Perfect mode where texture is not scaled to be power of 2.
         * Can only be used on a single postprocess or on the last one of a chain. (default: false)
         */ this.enablePixelPerfectMode = false;
        /**
         * Force the postprocess to be applied without taking in account viewport
         */ this.forceFullscreenViewport = true;
        /**
         * Scale mode for the post process (default: Engine.SCALEMODE_FLOOR)
         *
         * | Value | Type                                | Description |
         * | ----- | ----------------------------------- | ----------- |
         * | 1     | SCALEMODE_FLOOR                     | [engine.scalemode_floor](https://doc.babylonjs.com/api/classes/babylon.engine#scalemode_floor) |
         * | 2     | SCALEMODE_NEAREST                   | [engine.scalemode_nearest](https://doc.babylonjs.com/api/classes/babylon.engine#scalemode_nearest) |
         * | 3     | SCALEMODE_CEILING                   | [engine.scalemode_ceiling](https://doc.babylonjs.com/api/classes/babylon.engine#scalemode_ceiling) |
         *
         */ this.scaleMode = 1;
        /**
         * Force textures to be a power of two (default: false)
         */ this.alwaysForcePOT = false;
        this._samples = 1;
        /**
         * Modify the scale of the post process to be the same as the viewport (default: false)
         */ this.adaptScaleToCurrentViewport = false;
        this._reusable = false;
        this._renderId = 0;
        /**
         * if externalTextureSamplerBinding is true, the "apply" method won't bind the textureSampler texture, it is expected to be done by the "outside" (by the onApplyObservable observer most probably).
         * counter-productive in some cases because if the texture bound by "apply" is different from the currently texture bound, (the one set by the onApplyObservable observer, for eg) some
         * internal structures (materialContext) will be dirtified, which may impact performances
         */ this.externalTextureSamplerBinding = false;
        /**
         * Smart array of input and output textures for the post process.
         * @internal
         */ this._textures = new (0, $57onU.SmartArray)(2);
        /**
         * Smart array of input and output textures for the post process.
         * @internal
         */ this._textureCache = [];
        /**
         * The index in _textures that corresponds to the output texture.
         * @internal
         */ this._currentRenderTextureInd = 0;
        this._scaleRatio = new (0, $ha1VO.Vector2)(1, 1);
        this._texelSize = (0, $ha1VO.Vector2).Zero();
        // Events
        /**
         * An event triggered when the postprocess is activated.
         */ this.onActivateObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the postprocess changes its size.
         */ this.onSizeChangedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the postprocess applies its effect.
         */ this.onApplyObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered before rendering the postprocess
         */ this.onBeforeRenderObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered after rendering the postprocess
         */ this.onAfterRenderObservable = new (0, $diGQf.Observable)();
        this.name = name;
        let size = 1;
        let uniformBuffers = null;
        if (parameters && !Array.isArray(parameters)) {
            const options = parameters;
            parameters = options.uniforms ?? null;
            samplers = options.samplers ?? null;
            size = options.size ?? 1;
            camera = options.camera ?? null;
            samplingMode = options.samplingMode ?? 1;
            engine = options.engine;
            reusable = options.reusable;
            defines = options.defines ?? null;
            textureType = options.textureType ?? 0;
            vertexUrl = options.vertexUrl ?? "postprocess";
            indexParameters = options.indexParameters;
            blockCompilation = options.blockCompilation ?? false;
            textureFormat = options.textureFormat ?? 5;
            shaderLanguage = options.shaderLanguage ?? (0, $8WI3I.ShaderLanguage).GLSL;
            uniformBuffers = options.uniformBuffers ?? null;
        } else if (_size) {
            if (typeof _size === "number") size = _size;
            else size = {
                width: _size.width,
                height: _size.height
            };
        }
        if (camera != null) {
            this._camera = camera;
            this._scene = camera.getScene();
            camera.attachPostProcess(this);
            this._engine = this._scene.getEngine();
            this._scene.postProcesses.push(this);
            this.uniqueId = this._scene.getUniqueId();
        } else if (engine) {
            this._engine = engine;
            this._engine.postProcesses.push(this);
        }
        this._options = size;
        this.renderTargetSamplingMode = samplingMode ? samplingMode : 1;
        this._reusable = reusable || false;
        this._textureType = textureType;
        this._textureFormat = textureFormat;
        this._shaderLanguage = shaderLanguage;
        this._samplers = samplers || [];
        this._samplers.push("textureSampler");
        this._fragmentUrl = fragmentUrl;
        this._vertexUrl = vertexUrl;
        this._parameters = parameters || [];
        this._parameters.push("scale");
        this._uniformBuffers = uniformBuffers || [];
        this._indexParameters = indexParameters;
        this._drawWrapper = new (0, $hOyoX.DrawWrapper)(this._engine);
        if (!blockCompilation) this.updateEffect(defines);
    }
    /**
     * Gets a string identifying the name of the class
     * @returns "PostProcess" string
     */ getClassName() {
        return "PostProcess";
    }
    /**
     * Gets the engine which this post process belongs to.
     * @returns The engine the post process was enabled with.
     */ getEngine() {
        return this._engine;
    }
    /**
     * The effect that is created when initializing the post process.
     * @returns The created effect corresponding the postprocess.
     */ getEffect() {
        return this._drawWrapper.effect;
    }
    /**
     * To avoid multiple redundant textures for multiple post process, the output the output texture for this post process can be shared with another.
     * @param postProcess The post process to share the output with.
     * @returns This post process.
     */ shareOutputWith(postProcess) {
        this._disposeTextures();
        this._shareOutputWithPostProcess = postProcess;
        return this;
    }
    /**
     * Reverses the effect of calling shareOutputWith and returns the post process back to its original state.
     * This should be called if the post process that shares output with this post process is disabled/disposed.
     */ useOwnOutput() {
        if (this._textures.length == 0) this._textures = new (0, $57onU.SmartArray)(2);
        this._shareOutputWithPostProcess = null;
    }
    /**
     * Updates the effect with the current post process compile time values and recompiles the shader.
     * @param defines Define statements that should be added at the beginning of the shader. (default: null)
     * @param uniforms Set of uniform variables that will be passed to the shader. (default: null)
     * @param samplers Set of Texture2D variables that will be passed to the shader. (default: null)
     * @param indexParameters The index parameters to be used for babylons include syntax "#include<kernelBlurVaryingDeclaration>[0..varyingCount]". (default: undefined) See usage in babylon.blurPostProcess.ts and kernelBlur.vertex.fx
     * @param onCompiled Called when the shader has been compiled.
     * @param onError Called if there is an error when compiling a shader.
     * @param vertexUrl The url of the vertex shader to be used (default: the one given at construction time)
     * @param fragmentUrl The url of the fragment shader to be used (default: the one given at construction time)
     */ updateEffect(defines = null, uniforms = null, samplers = null, indexParameters, onCompiled, onError, vertexUrl, fragmentUrl) {
        const customShaderCodeProcessing = $9383dcc74058dbdc$export$f2e2be0a47b5edf8._GetShaderCodeProcessing(this.name);
        if (customShaderCodeProcessing?.defineCustomBindings) {
            const newUniforms = uniforms?.slice() ?? [];
            newUniforms.push(...this._parameters);
            const newSamplers = samplers?.slice() ?? [];
            newSamplers.push(...this._samplers);
            defines = customShaderCodeProcessing.defineCustomBindings(this.name, defines, newUniforms, newSamplers);
            uniforms = newUniforms;
            samplers = newSamplers;
        }
        this._postProcessDefines = defines;
        this._drawWrapper.effect = this._engine.createEffect({
            vertex: vertexUrl ?? this._vertexUrl,
            fragment: fragmentUrl ?? this._fragmentUrl
        }, {
            attributes: [
                "position"
            ],
            uniformsNames: uniforms || this._parameters,
            uniformBuffersNames: this._uniformBuffers,
            samplers: samplers || this._samplers,
            defines: defines !== null ? defines : "",
            fallbacks: null,
            onCompiled: onCompiled ?? null,
            onError: onError ?? null,
            indexParameters: indexParameters || this._indexParameters,
            processCodeAfterIncludes: customShaderCodeProcessing?.processCodeAfterIncludes ? (shaderType, code)=>customShaderCodeProcessing.processCodeAfterIncludes(this.name, shaderType, code) : null,
            processFinalCode: customShaderCodeProcessing?.processFinalCode ? (shaderType, code)=>customShaderCodeProcessing.processFinalCode(this.name, shaderType, code) : null,
            shaderLanguage: this._shaderLanguage
        }, this._engine);
    }
    /**
     * The post process is reusable if it can be used multiple times within one frame.
     * @returns If the post process is reusable
     */ isReusable() {
        return this._reusable;
    }
    /** invalidate frameBuffer to hint the postprocess to create a depth buffer */ markTextureDirty() {
        this.width = -1;
    }
    _createRenderTargetTexture(textureSize, textureOptions, channel = 0) {
        for(let i = 0; i < this._textureCache.length; i++){
            if (this._textureCache[i].texture.width === textureSize.width && this._textureCache[i].texture.height === textureSize.height && this._textureCache[i].postProcessChannel === channel && this._textureCache[i].texture._generateDepthBuffer === textureOptions.generateDepthBuffer && this._textureCache[i].texture.samples === textureOptions.samples) return this._textureCache[i].texture;
        }
        const tex = this._engine.createRenderTargetTexture(textureSize, textureOptions);
        this._textureCache.push({
            texture: tex,
            postProcessChannel: channel,
            lastUsedRenderId: -1
        });
        return tex;
    }
    _flushTextureCache() {
        const currentRenderId = this._renderId;
        for(let i = this._textureCache.length - 1; i >= 0; i--)if (currentRenderId - this._textureCache[i].lastUsedRenderId > 100) {
            let currentlyUsed = false;
            for(let j = 0; j < this._textures.length; j++)if (this._textures.data[j] === this._textureCache[i].texture) {
                currentlyUsed = true;
                break;
            }
            if (!currentlyUsed) {
                this._textureCache[i].texture.dispose();
                this._textureCache.splice(i, 1);
            }
        }
    }
    /**
     * Resizes the post-process texture
     * @param width Width of the texture
     * @param height Height of the texture
     * @param camera The camera this post-process is applied to. Pass null if the post-process is used outside the context of a camera post-process chain (default: null)
     * @param needMipMaps True if mip maps need to be generated after render (default: false)
     * @param forceDepthStencil True to force post-process texture creation with stencil depth and buffer (default: false)
     */ resize(width, height, camera = null, needMipMaps = false, forceDepthStencil = false) {
        if (this._textures.length > 0) this._textures.reset();
        this.width = width;
        this.height = height;
        let firstPP = null;
        if (camera) {
            for(let i = 0; i < camera._postProcesses.length; i++)if (camera._postProcesses[i] !== null) {
                firstPP = camera._postProcesses[i];
                break;
            }
        }
        const textureSize = {
            width: this.width,
            height: this.height
        };
        const textureOptions = {
            generateMipMaps: needMipMaps,
            generateDepthBuffer: forceDepthStencil || firstPP === this,
            generateStencilBuffer: (forceDepthStencil || firstPP === this) && this._engine.isStencilEnable,
            samplingMode: this.renderTargetSamplingMode,
            type: this._textureType,
            format: this._textureFormat,
            samples: this._samples,
            label: "PostProcessRTT-" + this.name
        };
        this._textures.push(this._createRenderTargetTexture(textureSize, textureOptions, 0));
        if (this._reusable) this._textures.push(this._createRenderTargetTexture(textureSize, textureOptions, 1));
        this._texelSize.copyFromFloats(1.0 / this.width, 1.0 / this.height);
        this.onSizeChangedObservable.notifyObservers(this);
    }
    _getTarget() {
        let target;
        if (this._shareOutputWithPostProcess) target = this._shareOutputWithPostProcess.inputTexture;
        else if (this._forcedOutputTexture) {
            target = this._forcedOutputTexture;
            this.width = this._forcedOutputTexture.width;
            this.height = this._forcedOutputTexture.height;
        } else {
            target = this.inputTexture;
            let cache;
            for(let i = 0; i < this._textureCache.length; i++)if (this._textureCache[i].texture === target) {
                cache = this._textureCache[i];
                break;
            }
            if (cache) cache.lastUsedRenderId = this._renderId;
        }
        return target;
    }
    /**
     * Activates the post process by intializing the textures to be used when executed. Notifies onActivateObservable.
     * When this post process is used in a pipeline, this is call will bind the input texture of this post process to the output of the previous.
     * @param camera The camera that will be used in the post process. This camera will be used when calling onActivateObservable.
     * @param sourceTexture The source texture to be inspected to get the width and height if not specified in the post process constructor. (default: null)
     * @param forceDepthStencil If true, a depth and stencil buffer will be generated. (default: false)
     * @returns The render target wrapper that was bound to be written to.
     */ activate(camera, sourceTexture = null, forceDepthStencil) {
        camera = camera || this._camera;
        const scene = camera.getScene();
        const engine = scene.getEngine();
        const maxSize = engine.getCaps().maxTextureSize;
        const requiredWidth = (sourceTexture ? sourceTexture.width : this._engine.getRenderWidth(true)) * this._options | 0;
        const requiredHeight = (sourceTexture ? sourceTexture.height : this._engine.getRenderHeight(true)) * this._options | 0;
        let desiredWidth = this._options.width || requiredWidth;
        let desiredHeight = this._options.height || requiredHeight;
        const needMipMaps = this.renderTargetSamplingMode !== 7 && this.renderTargetSamplingMode !== 1 && this.renderTargetSamplingMode !== 2;
        let target = null;
        if (!this._shareOutputWithPostProcess && !this._forcedOutputTexture) {
            if (this.adaptScaleToCurrentViewport) {
                const currentViewport = engine.currentViewport;
                if (currentViewport) {
                    desiredWidth *= currentViewport.width;
                    desiredHeight *= currentViewport.height;
                }
            }
            if (needMipMaps || this.alwaysForcePOT) {
                if (!this._options.width) desiredWidth = engine.needPOTTextures ? (0, $5YkyR.Engine).GetExponentOfTwo(desiredWidth, maxSize, this.scaleMode) : desiredWidth;
                if (!this._options.height) desiredHeight = engine.needPOTTextures ? (0, $5YkyR.Engine).GetExponentOfTwo(desiredHeight, maxSize, this.scaleMode) : desiredHeight;
            }
            if (this.width !== desiredWidth || this.height !== desiredHeight || !(target = this._getTarget())) this.resize(desiredWidth, desiredHeight, camera, needMipMaps, forceDepthStencil);
            this._textures.forEach((texture)=>{
                if (texture.samples !== this.samples) this._engine.updateRenderTargetTextureSampleCount(texture, this.samples);
            });
            this._flushTextureCache();
            this._renderId++;
        }
        if (!target) target = this._getTarget();
        // Bind the input of this post process to be used as the output of the previous post process.
        if (this.enablePixelPerfectMode) {
            this._scaleRatio.copyFromFloats(requiredWidth / desiredWidth, requiredHeight / desiredHeight);
            this._engine.bindFramebuffer(target, 0, requiredWidth, requiredHeight, this.forceFullscreenViewport);
        } else {
            this._scaleRatio.copyFromFloats(1, 1);
            this._engine.bindFramebuffer(target, 0, undefined, undefined, this.forceFullscreenViewport);
        }
        this._engine._debugInsertMarker?.(`post process ${this.name} input`);
        this.onActivateObservable.notifyObservers(camera);
        // Clear
        if (this.autoClear && (this.alphaMode === 0 || this.forceAutoClearInAlphaMode)) this._engine.clear(this.clearColor ? this.clearColor : scene.clearColor, scene._allowPostProcessClearColor, true, true);
        if (this._reusable) this._currentRenderTextureInd = (this._currentRenderTextureInd + 1) % 2;
        return target;
    }
    /**
     * If the post process is supported.
     */ get isSupported() {
        return this._drawWrapper.effect.isSupported;
    }
    /**
     * The aspect ratio of the output texture.
     */ get aspectRatio() {
        if (this._shareOutputWithPostProcess) return this._shareOutputWithPostProcess.aspectRatio;
        if (this._forcedOutputTexture) return this._forcedOutputTexture.width / this._forcedOutputTexture.height;
        return this.width / this.height;
    }
    /**
     * Get a value indicating if the post-process is ready to be used
     * @returns true if the post-process is ready (shader is compiled)
     */ isReady() {
        return this._drawWrapper.effect?.isReady() ?? false;
    }
    /**
     * Binds all textures and uniforms to the shader, this will be run on every pass.
     * @returns the effect corresponding to this post process. Null if not compiled or not ready.
     */ apply() {
        // Check
        if (!this._drawWrapper.effect?.isReady()) return null;
        // States
        this._engine.enableEffect(this._drawWrapper);
        this._engine.setState(false);
        this._engine.setDepthBuffer(false);
        this._engine.setDepthWrite(false);
        // Alpha
        this._engine.setAlphaMode(this.alphaMode);
        if (this.alphaConstants) this.getEngine().setAlphaConstants(this.alphaConstants.r, this.alphaConstants.g, this.alphaConstants.b, this.alphaConstants.a);
        // Bind the output texture of the preivous post process as the input to this post process.
        let source;
        if (this._shareOutputWithPostProcess) source = this._shareOutputWithPostProcess.inputTexture;
        else if (this._forcedOutputTexture) source = this._forcedOutputTexture;
        else source = this.inputTexture;
        if (!this.externalTextureSamplerBinding) this._drawWrapper.effect._bindTexture("textureSampler", source?.texture);
        // Parameters
        this._drawWrapper.effect.setVector2("scale", this._scaleRatio);
        this.onApplyObservable.notifyObservers(this._drawWrapper.effect);
        $9383dcc74058dbdc$export$f2e2be0a47b5edf8._GetShaderCodeProcessing(this.name)?.bindCustomBindings?.(this.name, this._drawWrapper.effect);
        return this._drawWrapper.effect;
    }
    _disposeTextures() {
        if (this._shareOutputWithPostProcess || this._forcedOutputTexture) {
            this._disposeTextureCache();
            return;
        }
        this._disposeTextureCache();
        this._textures.dispose();
    }
    _disposeTextureCache() {
        for(let i = this._textureCache.length - 1; i >= 0; i--)this._textureCache[i].texture.dispose();
        this._textureCache.length = 0;
    }
    /**
     * Sets the required values to the prepass renderer.
     * @param prePassRenderer defines the prepass renderer to setup.
     * @returns true if the pre pass is needed.
     */ setPrePassRenderer(prePassRenderer) {
        if (this._prePassEffectConfiguration) {
            this._prePassEffectConfiguration = prePassRenderer.addEffectConfiguration(this._prePassEffectConfiguration);
            this._prePassEffectConfiguration.enabled = true;
            return true;
        }
        return false;
    }
    /**
     * Disposes the post process.
     * @param camera The camera to dispose the post process on.
     */ dispose(camera) {
        camera = camera || this._camera;
        this._disposeTextures();
        let index;
        if (this._scene) {
            index = this._scene.postProcesses.indexOf(this);
            if (index !== -1) this._scene.postProcesses.splice(index, 1);
        }
        if (this._parentContainer) {
            const index = this._parentContainer.postProcesses.indexOf(this);
            if (index > -1) this._parentContainer.postProcesses.splice(index, 1);
            this._parentContainer = null;
        }
        index = this._engine.postProcesses.indexOf(this);
        if (index !== -1) this._engine.postProcesses.splice(index, 1);
        if (!camera) return;
        camera.detachPostProcess(this);
        index = camera._postProcesses.indexOf(this);
        if (index === 0 && camera._postProcesses.length > 0) {
            const firstPostProcess = this._camera._getFirstPostProcess();
            if (firstPostProcess) firstPostProcess.markTextureDirty();
        }
        this.onActivateObservable.clear();
        this.onAfterRenderObservable.clear();
        this.onApplyObservable.clear();
        this.onBeforeRenderObservable.clear();
        this.onSizeChangedObservable.clear();
    }
    /**
     * Serializes the post process to a JSON object
     * @returns the JSON object
     */ serialize() {
        const serializationObject = (0, $6Ho1L.SerializationHelper).Serialize(this);
        const camera = this.getCamera() || this._scene && this._scene.activeCamera;
        serializationObject.customType = "BABYLON." + this.getClassName();
        serializationObject.cameraId = camera ? camera.id : null;
        serializationObject.reusable = this._reusable;
        serializationObject.textureType = this._textureType;
        serializationObject.fragmentUrl = this._fragmentUrl;
        serializationObject.parameters = this._parameters;
        serializationObject.samplers = this._samplers;
        serializationObject.options = this._options;
        serializationObject.defines = this._postProcessDefines;
        serializationObject.textureFormat = this._textureFormat;
        serializationObject.vertexUrl = this._vertexUrl;
        serializationObject.indexParameters = this._indexParameters;
        return serializationObject;
    }
    /**
     * Clones this post process
     * @returns a new post process similar to this one
     */ clone() {
        const serializationObject = this.serialize();
        serializationObject._engine = this._engine;
        serializationObject.cameraId = null;
        const result = $9383dcc74058dbdc$export$f2e2be0a47b5edf8.Parse(serializationObject, this._scene, "");
        if (!result) return null;
        result.onActivateObservable = this.onActivateObservable.clone();
        result.onSizeChangedObservable = this.onSizeChangedObservable.clone();
        result.onApplyObservable = this.onApplyObservable.clone();
        result.onBeforeRenderObservable = this.onBeforeRenderObservable.clone();
        result.onAfterRenderObservable = this.onAfterRenderObservable.clone();
        result._prePassEffectConfiguration = this._prePassEffectConfiguration;
        return result;
    }
    /**
     * Creates a material from parsed material data
     * @param parsedPostProcess defines parsed post process data
     * @param scene defines the hosting scene
     * @param rootUrl defines the root URL to use to load textures
     * @returns a new post process
     */ static Parse(parsedPostProcess, scene, rootUrl) {
        const postProcessType = (0, $8DoUR.GetClass)(parsedPostProcess.customType);
        if (!postProcessType || !postProcessType._Parse) return null;
        const camera = scene ? scene.getCameraById(parsedPostProcess.cameraId) : null;
        return postProcessType._Parse(parsedPostProcess, camera, scene, rootUrl);
    }
    /**
     * @internal
     */ static _Parse(parsedPostProcess, targetCamera, scene, rootUrl) {
        return (0, $6Ho1L.SerializationHelper).Parse(()=>{
            return new $9383dcc74058dbdc$export$f2e2be0a47b5edf8(parsedPostProcess.name, parsedPostProcess.fragmentUrl, parsedPostProcess.parameters, parsedPostProcess.samplers, parsedPostProcess.options, targetCamera, parsedPostProcess.renderTargetSamplingMode, parsedPostProcess._engine, parsedPostProcess.reusable, parsedPostProcess.defines, parsedPostProcess.textureType, parsedPostProcess.vertexUrl, parsedPostProcess.indexParameters, false, parsedPostProcess.textureFormat);
        }, parsedPostProcess, scene, rootUrl);
    }
}
$9383dcc74058dbdc$export$f2e2be0a47b5edf8._CustomShaderCodeProcessing = {};
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9383dcc74058dbdc$export$f2e2be0a47b5edf8.prototype, "uniqueId", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9383dcc74058dbdc$export$f2e2be0a47b5edf8.prototype, "name", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9383dcc74058dbdc$export$f2e2be0a47b5edf8.prototype, "width", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9383dcc74058dbdc$export$f2e2be0a47b5edf8.prototype, "height", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9383dcc74058dbdc$export$f2e2be0a47b5edf8.prototype, "renderTargetSamplingMode", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor4)()
], $9383dcc74058dbdc$export$f2e2be0a47b5edf8.prototype, "clearColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9383dcc74058dbdc$export$f2e2be0a47b5edf8.prototype, "autoClear", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9383dcc74058dbdc$export$f2e2be0a47b5edf8.prototype, "forceAutoClearInAlphaMode", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9383dcc74058dbdc$export$f2e2be0a47b5edf8.prototype, "alphaMode", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9383dcc74058dbdc$export$f2e2be0a47b5edf8.prototype, "alphaConstants", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9383dcc74058dbdc$export$f2e2be0a47b5edf8.prototype, "enablePixelPerfectMode", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9383dcc74058dbdc$export$f2e2be0a47b5edf8.prototype, "forceFullscreenViewport", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9383dcc74058dbdc$export$f2e2be0a47b5edf8.prototype, "scaleMode", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9383dcc74058dbdc$export$f2e2be0a47b5edf8.prototype, "alwaysForcePOT", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("samples")
], $9383dcc74058dbdc$export$f2e2be0a47b5edf8.prototype, "_samples", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9383dcc74058dbdc$export$f2e2be0a47b5edf8.prototype, "adaptScaleToCurrentViewport", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.PostProcess", $9383dcc74058dbdc$export$f2e2be0a47b5edf8);

});
parcelRegister("cr88r", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $90de512353ac9a9d$var$name = "postprocessVertexShader";
const $90de512353ac9a9d$var$shader = `attribute vec2 position;uniform vec2 scale;varying vec2 vUV;const vec2 madd=vec2(0.5,0.5);
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
vUV=(position*madd+madd)*scale;gl_Position=vec4(position,0.0,1.0);
#define CUSTOM_VERTEX_MAIN_END
}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$90de512353ac9a9d$var$name] = $90de512353ac9a9d$var$shader;
const $90de512353ac9a9d$export$5141e57baab30e29 = {
    name: $90de512353ac9a9d$var$name,
    shader: $90de512353ac9a9d$var$shader
};

});

parcelRegister("4PdZs", function(module, exports) {

var $b9e4a = parcelRequire("b9e4a");

var $kVtWi = parcelRequire("kVtWi");

var $2h5JR = parcelRequire("2h5JR");

var $7Hi8b = parcelRequire("7Hi8b");
(0, $2h5JR.ThinEngine).prototype._createHardwareRenderTargetWrapper = function(isMulti, isCube, size) {
    const rtWrapper = new (0, $7Hi8b.WebGLRenderTargetWrapper)(isMulti, isCube, size, this, this._gl);
    this._renderTargetWrapperCache.push(rtWrapper);
    return rtWrapper;
};
(0, $2h5JR.ThinEngine).prototype.createRenderTargetTexture = function(size, options) {
    const rtWrapper = this._createHardwareRenderTargetWrapper(false, false, size);
    let generateDepthBuffer = true;
    let generateStencilBuffer = false;
    let noColorAttachment = false;
    let colorAttachment = undefined;
    let samples = 1;
    let label = undefined;
    if (options !== undefined && typeof options === "object") {
        generateDepthBuffer = options.generateDepthBuffer ?? true;
        generateStencilBuffer = !!options.generateStencilBuffer;
        noColorAttachment = !!options.noColorAttachment;
        colorAttachment = options.colorAttachment;
        samples = options.samples ?? 1;
        label = options.label;
    }
    const texture = colorAttachment || (noColorAttachment ? null : this._createInternalTexture(size, options, true, (0, $b9e4a.InternalTextureSource).RenderTarget));
    const width = size.width || size;
    const height = size.height || size;
    const currentFrameBuffer = this._currentFramebuffer;
    const gl = this._gl;
    // Create the framebuffer
    const framebuffer = gl.createFramebuffer();
    this._bindUnboundFramebuffer(framebuffer);
    rtWrapper._depthStencilBuffer = this._setupFramebufferDepthAttachments(generateStencilBuffer, generateDepthBuffer, width, height);
    // No need to rebind on every frame
    if (texture && !texture.is2DArray) gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture._hardwareTexture.underlyingResource, 0);
    this._bindUnboundFramebuffer(currentFrameBuffer);
    rtWrapper.label = label ?? "RenderTargetWrapper";
    rtWrapper._framebuffer = framebuffer;
    rtWrapper._generateDepthBuffer = generateDepthBuffer;
    rtWrapper._generateStencilBuffer = generateStencilBuffer;
    rtWrapper.setTextures(texture);
    this.updateRenderTargetTextureSampleCount(rtWrapper, samples);
    return rtWrapper;
};
(0, $2h5JR.ThinEngine).prototype.createDepthStencilTexture = function(size, options, rtWrapper) {
    if (options.isCube) {
        const width = size.width || size;
        return this._createDepthStencilCubeTexture(width, options);
    } else return this._createDepthStencilTexture(size, options, rtWrapper);
};
(0, $2h5JR.ThinEngine).prototype._createDepthStencilTexture = function(size, options) {
    const gl = this._gl;
    const layers = size.layers || 0;
    const target = layers !== 0 ? gl.TEXTURE_2D_ARRAY : gl.TEXTURE_2D;
    const internalTexture = new (0, $b9e4a.InternalTexture)(this, (0, $b9e4a.InternalTextureSource).DepthStencil);
    internalTexture.label = options.label;
    if (!this._caps.depthTextureExtension) {
        (0, $kVtWi.Logger).Error("Depth texture is not supported by your browser or hardware.");
        return internalTexture;
    }
    const internalOptions = {
        bilinearFiltering: false,
        comparisonFunction: 0,
        generateStencil: false,
        ...options
    };
    this._bindTextureDirectly(target, internalTexture, true);
    this._setupDepthStencilTexture(internalTexture, size, internalOptions.generateStencil, internalOptions.comparisonFunction === 0 ? false : internalOptions.bilinearFiltering, internalOptions.comparisonFunction, internalOptions.samples);
    if (internalOptions.depthTextureFormat !== undefined) {
        if (internalOptions.depthTextureFormat !== 15 && internalOptions.depthTextureFormat !== 16 && internalOptions.depthTextureFormat !== 17 && internalOptions.depthTextureFormat !== 13 && internalOptions.depthTextureFormat !== 14 && internalOptions.depthTextureFormat !== 18) {
            (0, $kVtWi.Logger).Error("Depth texture format is not supported.");
            return internalTexture;
        }
        internalTexture.format = internalOptions.depthTextureFormat;
    } else internalTexture.format = internalOptions.generateStencil ? 13 : 16;
    const hasStencil = internalTexture.format === 17 || internalTexture.format === 13 || internalTexture.format === 18;
    let type = gl.UNSIGNED_INT;
    if (internalTexture.format === 15) type = gl.UNSIGNED_SHORT;
    else if (internalTexture.format === 17 || internalTexture.format === 13) type = gl.UNSIGNED_INT_24_8;
    else if (internalTexture.format === 14) type = gl.FLOAT;
    else if (internalTexture.format === 18) type = gl.FLOAT_32_UNSIGNED_INT_24_8_REV;
    const format = hasStencil ? gl.DEPTH_STENCIL : gl.DEPTH_COMPONENT;
    let internalFormat = format;
    if (this.webGLVersion > 1) {
        if (internalTexture.format === 15) internalFormat = gl.DEPTH_COMPONENT16;
        else if (internalTexture.format === 16) internalFormat = gl.DEPTH_COMPONENT24;
        else if (internalTexture.format === 17 || internalTexture.format === 13) internalFormat = gl.DEPTH24_STENCIL8;
        else if (internalTexture.format === 14) internalFormat = gl.DEPTH_COMPONENT32F;
        else if (internalTexture.format === 18) internalFormat = gl.DEPTH32F_STENCIL8;
    }
    if (internalTexture.is2DArray) gl.texImage3D(target, 0, internalFormat, internalTexture.width, internalTexture.height, layers, 0, format, type, null);
    else gl.texImage2D(target, 0, internalFormat, internalTexture.width, internalTexture.height, 0, format, type, null);
    this._bindTextureDirectly(target, null);
    this._internalTexturesCache.push(internalTexture);
    return internalTexture;
};
(0, $2h5JR.ThinEngine).prototype.updateRenderTargetTextureSampleCount = function(rtWrapper, samples) {
    if (this.webGLVersion < 2 || !rtWrapper || !rtWrapper.texture) return 1;
    if (rtWrapper.samples === samples) return samples;
    const gl = this._gl;
    samples = Math.min(samples, this.getCaps().maxMSAASamples);
    // Dispose previous render buffers
    if (rtWrapper._depthStencilBuffer) {
        gl.deleteRenderbuffer(rtWrapper._depthStencilBuffer);
        rtWrapper._depthStencilBuffer = null;
    }
    if (rtWrapper._MSAAFramebuffer) {
        gl.deleteFramebuffer(rtWrapper._MSAAFramebuffer);
        rtWrapper._MSAAFramebuffer = null;
    }
    const hardwareTexture = rtWrapper.texture._hardwareTexture;
    hardwareTexture.releaseMSAARenderBuffers();
    if (samples > 1 && typeof gl.renderbufferStorageMultisample === "function") {
        const framebuffer = gl.createFramebuffer();
        if (!framebuffer) throw new Error("Unable to create multi sampled framebuffer");
        rtWrapper._MSAAFramebuffer = framebuffer;
        this._bindUnboundFramebuffer(rtWrapper._MSAAFramebuffer);
        const colorRenderbuffer = this._createRenderBuffer(rtWrapper.texture.width, rtWrapper.texture.height, samples, -1 /* not used */ , this._getRGBABufferInternalSizedFormat(rtWrapper.texture.type, rtWrapper.texture.format, rtWrapper.texture._useSRGBBuffer), gl.COLOR_ATTACHMENT0, false);
        if (!colorRenderbuffer) throw new Error("Unable to create multi sampled framebuffer");
        hardwareTexture.addMSAARenderBuffer(colorRenderbuffer);
    } else this._bindUnboundFramebuffer(rtWrapper._framebuffer);
    rtWrapper.texture.samples = samples;
    rtWrapper._samples = samples;
    rtWrapper._depthStencilBuffer = this._setupFramebufferDepthAttachments(rtWrapper._generateStencilBuffer, rtWrapper._generateDepthBuffer, rtWrapper.texture.width, rtWrapper.texture.height, samples);
    this._bindUnboundFramebuffer(null);
    return samples;
};

});
parcelRegister("7Hi8b", function(module, exports) {

$parcel$export(module.exports, "WebGLRenderTargetWrapper", () => $59aa9cfe4ef7785f$export$71fff2fc651795c2);

var $3QmEA = parcelRequire("3QmEA");
class $59aa9cfe4ef7785f$export$71fff2fc651795c2 extends (0, $3QmEA.RenderTargetWrapper) {
    constructor(isMulti, isCube, size, engine, context){
        super(isMulti, isCube, size, engine);
        /**
         * @internal
         */ this._framebuffer = null;
        /**
         * @internal
         */ this._depthStencilBuffer = null;
        // eslint-disable-next-line @typescript-eslint/naming-convention
        /**
         * @internal
         */ // eslint-disable-next-line @typescript-eslint/naming-convention
        this._MSAAFramebuffer = null;
        // Multiview
        /**
         * @internal
         */ this._colorTextureArray = null;
        /**
         * @internal
         */ this._depthStencilTextureArray = null;
        /**
         * @internal
         */ this._disposeOnlyFramebuffers = false;
        /**
         * @internal
         */ this._currentLOD = 0;
        this._context = context;
    }
    _cloneRenderTargetWrapper() {
        let rtw = null;
        if (this._colorTextureArray && this._depthStencilTextureArray) {
            rtw = this._engine.createMultiviewRenderTargetTexture(this.width, this.height);
            rtw.texture.isReady = true;
        } else rtw = super._cloneRenderTargetWrapper();
        return rtw;
    }
    _swapRenderTargetWrapper(target) {
        super._swapRenderTargetWrapper(target);
        target._framebuffer = this._framebuffer;
        target._depthStencilBuffer = this._depthStencilBuffer;
        target._MSAAFramebuffer = this._MSAAFramebuffer;
        target._colorTextureArray = this._colorTextureArray;
        target._depthStencilTextureArray = this._depthStencilTextureArray;
        this._framebuffer = this._depthStencilBuffer = this._MSAAFramebuffer = this._colorTextureArray = this._depthStencilTextureArray = null;
    }
    /**
     * Creates the depth/stencil texture
     * @param comparisonFunction Comparison function to use for the texture
     * @param bilinearFiltering true if bilinear filtering should be used when sampling the texture
     * @param generateStencil true if the stencil aspect should also be created
     * @param samples sample count to use when creating the texture
     * @param format format of the depth texture
     * @param label defines the label to use for the texture (for debugging purpose only)
     * @returns the depth/stencil created texture
     */ createDepthStencilTexture(comparisonFunction = 0, bilinearFiltering = true, generateStencil = false, samples = 1, format = 14, label) {
        if (this._depthStencilBuffer) {
            // Dispose previous depth/stencil render buffers and clear the corresponding attachment.
            // Next time this framebuffer is bound, the new depth/stencil texture will be attached.
            const currentFrameBuffer = this._engine._currentFramebuffer;
            const gl = this._context;
            this._engine._bindUnboundFramebuffer(this._framebuffer);
            gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_STENCIL_ATTACHMENT, gl.RENDERBUFFER, null);
            gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.DEPTH_ATTACHMENT, gl.RENDERBUFFER, null);
            gl.framebufferRenderbuffer(gl.FRAMEBUFFER, gl.STENCIL_ATTACHMENT, gl.RENDERBUFFER, null);
            this._engine._bindUnboundFramebuffer(currentFrameBuffer);
            gl.deleteRenderbuffer(this._depthStencilBuffer);
            this._depthStencilBuffer = null;
        }
        return super.createDepthStencilTexture(comparisonFunction, bilinearFiltering, generateStencil, samples, format, label);
    }
    /**
     * Shares the depth buffer of this render target with another render target.
     * @internal
     * @param renderTarget Destination renderTarget
     */ _shareDepth(renderTarget) {
        super._shareDepth(renderTarget);
        const gl = this._context;
        const depthbuffer = this._depthStencilBuffer;
        const framebuffer = renderTarget._MSAAFramebuffer || renderTarget._framebuffer;
        if (renderTarget._depthStencilBuffer && renderTarget._depthStencilBuffer !== depthbuffer) gl.deleteRenderbuffer(renderTarget._depthStencilBuffer);
        renderTarget._depthStencilBuffer = depthbuffer;
        const attachment = renderTarget._generateStencilBuffer ? gl.DEPTH_STENCIL_ATTACHMENT : gl.DEPTH_ATTACHMENT;
        this._engine._bindUnboundFramebuffer(framebuffer);
        gl.framebufferRenderbuffer(gl.FRAMEBUFFER, attachment, gl.RENDERBUFFER, depthbuffer);
        this._engine._bindUnboundFramebuffer(null);
    }
    /**
     * Binds a texture to this render target on a specific attachment
     * @param texture The texture to bind to the framebuffer
     * @param attachmentIndex Index of the attachment
     * @param faceIndexOrLayer The face or layer of the texture to render to in case of cube texture or array texture
     * @param lodLevel defines the lod level to bind to the frame buffer
     */ _bindTextureRenderTarget(texture, attachmentIndex = 0, faceIndexOrLayer, lodLevel = 0) {
        if (!texture._hardwareTexture) return;
        const framebuffer = this._framebuffer;
        const currentFB = this._engine._currentFramebuffer;
        this._engine._bindUnboundFramebuffer(framebuffer);
        if (this._engine.webGLVersion > 1) {
            const gl = this._context;
            const attachment = gl["COLOR_ATTACHMENT" + attachmentIndex];
            if (texture.is2DArray || texture.is3D) {
                faceIndexOrLayer = faceIndexOrLayer ?? this.layerIndices?.[attachmentIndex] ?? 0;
                gl.framebufferTextureLayer(gl.FRAMEBUFFER, attachment, texture._hardwareTexture.underlyingResource, lodLevel, faceIndexOrLayer);
            } else if (texture.isCube) {
                // if face index is not specified, try to query it from faceIndices
                // default is face 0
                faceIndexOrLayer = faceIndexOrLayer ?? this.faceIndices?.[attachmentIndex] ?? 0;
                gl.framebufferTexture2D(gl.FRAMEBUFFER, attachment, gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndexOrLayer, texture._hardwareTexture.underlyingResource, lodLevel);
            } else gl.framebufferTexture2D(gl.FRAMEBUFFER, attachment, gl.TEXTURE_2D, texture._hardwareTexture.underlyingResource, lodLevel);
        } else {
            // Default behavior (WebGL)
            const gl = this._context;
            const attachment = gl["COLOR_ATTACHMENT" + attachmentIndex + "_WEBGL"];
            const target = faceIndexOrLayer !== undefined ? gl.TEXTURE_CUBE_MAP_POSITIVE_X + faceIndexOrLayer : gl.TEXTURE_2D;
            gl.framebufferTexture2D(gl.FRAMEBUFFER, attachment, target, texture._hardwareTexture.underlyingResource, lodLevel);
        }
        this._engine._bindUnboundFramebuffer(currentFB);
    }
    /**
     * Set a texture in the textures array
     * @param texture the texture to set
     * @param index the index in the textures array to set
     * @param disposePrevious If this function should dispose the previous texture
     */ setTexture(texture, index = 0, disposePrevious = true) {
        super.setTexture(texture, index, disposePrevious);
        this._bindTextureRenderTarget(texture, index);
    }
    /**
     * Sets the layer and face indices of every render target texture
     * @param layers The layer of the texture to be set (make negative to not modify)
     * @param faces The face of the texture to be set (make negative to not modify)
     */ setLayerAndFaceIndices(layers, faces) {
        super.setLayerAndFaceIndices(layers, faces);
        if (!this.textures || !this.layerIndices || !this.faceIndices) return;
        // the length of this._attachments is the right one as it does not count the depth texture, in case we generated it
        const textureCount = this._attachments?.length ?? this.textures.length;
        for(let index = 0; index < textureCount; index++){
            const texture = this.textures[index];
            if (!texture) continue;
            if (texture.is2DArray || texture.is3D) this._bindTextureRenderTarget(texture, index, this.layerIndices[index]);
            else if (texture.isCube) this._bindTextureRenderTarget(texture, index, this.faceIndices[index]);
            else this._bindTextureRenderTarget(texture, index);
        }
    }
    /**
     * Set the face and layer indices of a texture in the textures array
     * @param index The index of the texture in the textures array to modify
     * @param layer The layer of the texture to be set
     * @param face The face of the texture to be set
     */ setLayerAndFaceIndex(index = 0, layer, face) {
        super.setLayerAndFaceIndex(index, layer, face);
        if (!this.textures || !this.layerIndices || !this.faceIndices) return;
        const texture = this.textures[index];
        if (texture.is2DArray || texture.is3D) this._bindTextureRenderTarget(this.textures[index], index, this.layerIndices[index]);
        else if (texture.isCube) this._bindTextureRenderTarget(this.textures[index], index, this.faceIndices[index]);
    }
    dispose(disposeOnlyFramebuffers = this._disposeOnlyFramebuffers) {
        const gl = this._context;
        if (!disposeOnlyFramebuffers) {
            if (this._colorTextureArray) {
                this._context.deleteTexture(this._colorTextureArray);
                this._colorTextureArray = null;
            }
            if (this._depthStencilTextureArray) {
                this._context.deleteTexture(this._depthStencilTextureArray);
                this._depthStencilTextureArray = null;
            }
        }
        if (this._framebuffer) {
            gl.deleteFramebuffer(this._framebuffer);
            this._framebuffer = null;
        }
        if (this._depthStencilBuffer) {
            gl.deleteRenderbuffer(this._depthStencilBuffer);
            this._depthStencilBuffer = null;
        }
        if (this._MSAAFramebuffer) {
            gl.deleteFramebuffer(this._MSAAFramebuffer);
            this._MSAAFramebuffer = null;
        }
        super.dispose(disposeOnlyFramebuffers);
    }
}

});
parcelRegister("3QmEA", function(module, exports) {

$parcel$export(module.exports, "RenderTargetWrapper", () => $2cc7ccf7db7cd53e$export$a2afcb74070ce2ba);

var $b9e4a = parcelRequire("b9e4a");
class $2cc7ccf7db7cd53e$export$a2afcb74070ce2ba {
    /**
     * Gets the depth/stencil texture (if created by a createDepthStencilTexture() call)
     */ get depthStencilTexture() {
        return this._depthStencilTexture;
    }
    /**
     * Indicates if the depth/stencil texture has a stencil aspect
     */ get depthStencilTextureWithStencil() {
        return this._depthStencilTextureWithStencil;
    }
    /**
     * Defines if the render target wrapper is for a cube texture or if false a 2d texture
     */ get isCube() {
        return this._isCube;
    }
    /**
     * Defines if the render target wrapper is for a single or multi target render wrapper
     */ get isMulti() {
        return this._isMulti;
    }
    /**
     * Defines if the render target wrapper is for a single or an array of textures
     */ get is2DArray() {
        return this.layers > 0;
    }
    /**
     * Gets the size of the render target wrapper (used for cubes, as width=height in this case)
     */ get size() {
        return this.width;
    }
    /**
     * Gets the width of the render target wrapper
     */ get width() {
        return this._size.width || this._size;
    }
    /**
     * Gets the height of the render target wrapper
     */ get height() {
        return this._size.height || this._size;
    }
    /**
     * Gets the number of layers of the render target wrapper (only used if is2DArray is true and wrapper is not a multi render target)
     */ get layers() {
        return this._size.layers || 0;
    }
    /**
     * Gets the render texture. If this is a multi render target, gets the first texture
     */ get texture() {
        return this._textures?.[0] ?? null;
    }
    /**
     * Gets the list of render textures. If we are not in a multi render target, the list will be null (use the texture getter instead)
     */ get textures() {
        return this._textures;
    }
    /**
     * Gets the face indices that correspond to the list of render textures. If we are not in a multi render target, the list will be null
     */ get faceIndices() {
        return this._faceIndices;
    }
    /**
     * Gets the layer indices that correspond to the list of render textures. If we are not in a multi render target, the list will be null
     */ get layerIndices() {
        return this._layerIndices;
    }
    /**
     * Gets the sample count of the render target
     */ get samples() {
        return this._samples;
    }
    /**
     * Sets the sample count of the render target
     * @param value sample count
     * @param initializeBuffers If set to true, the engine will make an initializing call to drawBuffers (only used when isMulti=true).
     * @param force true to force calling the update sample count engine function even if the current sample count is equal to value
     * @returns the sample count that has been set
     */ setSamples(value, initializeBuffers = true, force = false) {
        if (this.samples === value && !force) return value;
        const result = this._isMulti ? this._engine.updateMultipleRenderTargetTextureSampleCount(this, value, initializeBuffers) : this._engine.updateRenderTargetTextureSampleCount(this, value);
        this._samples = value;
        return result;
    }
    /**
     * Initializes the render target wrapper
     * @param isMulti true if the wrapper is a multi render target
     * @param isCube true if the wrapper should render to a cube texture
     * @param size size of the render target (width/height/layers)
     * @param engine engine used to create the render target
     * @param label defines the label to use for the wrapper (for debugging purpose only)
     */ constructor(isMulti, isCube, size, engine, label){
        this._textures = null;
        this._faceIndices = null;
        this._layerIndices = null;
        /** @internal */ this._samples = 1;
        /** @internal */ this._attachments = null;
        /** @internal */ this._generateStencilBuffer = false;
        /** @internal */ this._generateDepthBuffer = false;
        /** @internal */ this._depthStencilTextureWithStencil = false;
        this._isMulti = isMulti;
        this._isCube = isCube;
        this._size = size;
        this._engine = engine;
        this._depthStencilTexture = null;
        this.label = label;
    }
    /**
     * Sets the render target texture(s)
     * @param textures texture(s) to set
     */ setTextures(textures) {
        if (Array.isArray(textures)) this._textures = textures;
        else if (textures) this._textures = [
            textures
        ];
        else this._textures = null;
    }
    /**
     * Set a texture in the textures array
     * @param texture The texture to set
     * @param index The index in the textures array to set
     * @param disposePrevious If this function should dispose the previous texture
     */ setTexture(texture, index = 0, disposePrevious = true) {
        if (!this._textures) this._textures = [];
        if (this._textures[index] === texture) return;
        if (this._textures[index] && disposePrevious) this._textures[index].dispose();
        this._textures[index] = texture;
    }
    /**
     * Sets the layer and face indices of every render target texture bound to each color attachment
     * @param layers The layers of each texture to be set
     * @param faces The faces of each texture to be set
     */ setLayerAndFaceIndices(layers, faces) {
        this._layerIndices = layers;
        this._faceIndices = faces;
    }
    /**
     * Sets the layer and face indices of a texture in the textures array that should be bound to each color attachment
     * @param index The index of the texture in the textures array to modify
     * @param layer The layer of the texture to be set
     * @param face The face of the texture to be set
     */ setLayerAndFaceIndex(index = 0, layer, face) {
        if (!this._layerIndices) this._layerIndices = [];
        if (!this._faceIndices) this._faceIndices = [];
        if (layer !== undefined && layer >= 0) this._layerIndices[index] = layer;
        if (face !== undefined && face >= 0) this._faceIndices[index] = face;
    }
    /**
     * Creates the depth/stencil texture
     * @param comparisonFunction Comparison function to use for the texture
     * @param bilinearFiltering true if bilinear filtering should be used when sampling the texture
     * @param generateStencil true if the stencil aspect should also be created
     * @param samples sample count to use when creating the texture
     * @param format format of the depth texture
     * @param label defines the label to use for the texture (for debugging purpose only)
     * @returns the depth/stencil created texture
     */ createDepthStencilTexture(comparisonFunction = 0, bilinearFiltering = true, generateStencil = false, samples = 1, format = 14, label) {
        this._depthStencilTexture?.dispose();
        this._depthStencilTextureWithStencil = generateStencil;
        this._depthStencilTextureLabel = label;
        this._depthStencilTexture = this._engine.createDepthStencilTexture(this._size, {
            bilinearFiltering: bilinearFiltering,
            comparisonFunction: comparisonFunction,
            generateStencil: generateStencil,
            isCube: this._isCube,
            samples: samples,
            depthTextureFormat: format,
            label: label
        }, this);
        return this._depthStencilTexture;
    }
    /**
     * Shares the depth buffer of this render target with another render target.
     * @internal
     * @param renderTarget Destination renderTarget
     */ _shareDepth(renderTarget) {
        if (this._depthStencilTexture) {
            if (renderTarget._depthStencilTexture) renderTarget._depthStencilTexture.dispose();
            renderTarget._depthStencilTexture = this._depthStencilTexture;
            this._depthStencilTexture.incrementReferences();
        }
    }
    /**
     * @internal
     */ _swapAndDie(target) {
        if (this.texture) this.texture._swapAndDie(target);
        this._textures = null;
        this.dispose(true);
    }
    _cloneRenderTargetWrapper() {
        let rtw = null;
        if (this._isMulti) {
            const textureArray = this.textures;
            if (textureArray && textureArray.length > 0) {
                let generateDepthTexture = false;
                let textureCount = textureArray.length;
                let depthTextureFormat = -1;
                const lastTextureSource = textureArray[textureArray.length - 1]._source;
                if (lastTextureSource === (0, $b9e4a.InternalTextureSource).Depth || lastTextureSource === (0, $b9e4a.InternalTextureSource).DepthStencil) {
                    generateDepthTexture = true;
                    depthTextureFormat = textureArray[textureArray.length - 1].format;
                    textureCount--;
                }
                const samplingModes = [];
                const types = [];
                const formats = [];
                const targetTypes = [];
                const faceIndex = [];
                const layerIndex = [];
                const layerCounts = [];
                const internalTexture2Index = {};
                for(let i = 0; i < textureCount; ++i){
                    const texture = textureArray[i];
                    samplingModes.push(texture.samplingMode);
                    types.push(texture.type);
                    formats.push(texture.format);
                    const index = internalTexture2Index[texture.uniqueId];
                    if (index !== undefined) {
                        targetTypes.push(-1);
                        layerCounts.push(0);
                    } else {
                        internalTexture2Index[texture.uniqueId] = i;
                        if (texture.is2DArray) {
                            targetTypes.push(35866);
                            layerCounts.push(texture.depth);
                        } else if (texture.isCube) {
                            targetTypes.push(34067);
                            layerCounts.push(0);
                        } else if (texture.is3D) {
                            targetTypes.push(32879);
                            layerCounts.push(texture.depth);
                        } else {
                            targetTypes.push(3553);
                            layerCounts.push(0);
                        }
                    }
                    if (this._faceIndices) faceIndex.push(this._faceIndices[i] ?? 0);
                    if (this._layerIndices) layerIndex.push(this._layerIndices[i] ?? 0);
                }
                const optionsMRT = {
                    samplingModes: samplingModes,
                    generateMipMaps: textureArray[0].generateMipMaps,
                    generateDepthBuffer: this._generateDepthBuffer,
                    generateStencilBuffer: this._generateStencilBuffer,
                    generateDepthTexture: generateDepthTexture,
                    depthTextureFormat: depthTextureFormat,
                    types: types,
                    formats: formats,
                    textureCount: textureCount,
                    targetTypes: targetTypes,
                    faceIndex: faceIndex,
                    layerIndex: layerIndex,
                    layerCounts: layerCounts,
                    label: this.label
                };
                const size = {
                    width: this.width,
                    height: this.height
                };
                rtw = this._engine.createMultipleRenderTarget(size, optionsMRT);
                for(let i = 0; i < textureCount; ++i){
                    if (targetTypes[i] !== -1) continue;
                    const index = internalTexture2Index[textureArray[i].uniqueId];
                    rtw.setTexture(rtw.textures[index], i);
                }
            }
        } else {
            const options = {};
            options.generateDepthBuffer = this._generateDepthBuffer;
            options.generateMipMaps = this.texture?.generateMipMaps ?? false;
            options.generateStencilBuffer = this._generateStencilBuffer;
            options.samplingMode = this.texture?.samplingMode;
            options.type = this.texture?.type;
            options.format = this.texture?.format;
            options.noColorAttachment = !this._textures;
            options.label = this.label;
            if (this.isCube) rtw = this._engine.createRenderTargetCubeTexture(this.width, options);
            else {
                const size = {
                    width: this.width,
                    height: this.height,
                    layers: this.is2DArray ? this.texture?.depth : undefined
                };
                rtw = this._engine.createRenderTargetTexture(size, options);
            }
            if (rtw.texture) rtw.texture.isReady = true;
        }
        return rtw;
    }
    _swapRenderTargetWrapper(target) {
        if (this._textures && target._textures) for(let i = 0; i < this._textures.length; ++i){
            this._textures[i]._swapAndDie(target._textures[i], false);
            target._textures[i].isReady = true;
        }
        if (this._depthStencilTexture && target._depthStencilTexture) {
            this._depthStencilTexture._swapAndDie(target._depthStencilTexture);
            target._depthStencilTexture.isReady = true;
        }
        this._textures = null;
        this._depthStencilTexture = null;
    }
    /** @internal */ _rebuild() {
        const rtw = this._cloneRenderTargetWrapper();
        if (!rtw) return;
        if (this._depthStencilTexture) {
            const samplingMode = this._depthStencilTexture.samplingMode;
            const format = this._depthStencilTexture.format;
            const bilinear = samplingMode === 2 || samplingMode === 3 || samplingMode === 11;
            rtw.createDepthStencilTexture(this._depthStencilTexture._comparisonFunction, bilinear, this._depthStencilTextureWithStencil, this._depthStencilTexture.samples, format, this._depthStencilTextureLabel);
        }
        if (this.samples > 1) rtw.setSamples(this.samples);
        rtw._swapRenderTargetWrapper(this);
        rtw.dispose();
    }
    /**
     * Releases the internal render textures
     */ releaseTextures() {
        if (this._textures) for(let i = 0; (i < this._textures?.length) ?? 0; ++i)this._textures[i].dispose();
        this._textures = null;
    }
    /**
     * Disposes the whole render target wrapper
     * @param disposeOnlyFramebuffers true if only the frame buffers should be released (used for the WebGL engine). If false, all the textures will also be released
     */ dispose(disposeOnlyFramebuffers = false) {
        if (!disposeOnlyFramebuffers) {
            this._depthStencilTexture?.dispose();
            this._depthStencilTexture = null;
            this.releaseTextures();
        }
        this._engine._releaseRenderTargetWrapper(this);
    }
}

});




parcelRegister("jnIu6", function(module, exports) {

$parcel$export(module.exports, "VectorMergerBlock", () => $e1c2abfd3a97a36b$export$fd226f9533f998f7);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $e1c2abfd3a97a36b$export$fd226f9533f998f7 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Create a new VectorMergerBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        /**
         * Gets or sets the swizzle for x (meaning which component to affect to the output.x)
         */ this.xSwizzle = "x";
        /**
         * Gets or sets the swizzle for y (meaning which component to affect to the output.y)
         */ this.ySwizzle = "y";
        /**
         * Gets or sets the swizzle for z (meaning which component to affect to the output.z)
         */ this.zSwizzle = "z";
        /**
         * Gets or sets the swizzle for w (meaning which component to affect to the output.w)
         */ this.wSwizzle = "w";
        this.registerInput("xyzw ", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4, true);
        this.registerInput("xyz ", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3, true);
        this.registerInput("xy ", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2, true);
        this.registerInput("zw ", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2, true);
        this.registerInput("x", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true);
        this.registerInput("y", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true);
        this.registerInput("z", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true);
        this.registerInput("w", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true);
        this.registerOutput("xyzw", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4);
        this.registerOutput("xyz", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3);
        this.registerOutput("xy", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2);
        this.registerOutput("zw", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "VectorMergerBlock";
    }
    /**
     * Gets the xyzw component (input)
     */ get xyzwIn() {
        return this._inputs[0];
    }
    /**
     * Gets the xyz component (input)
     */ get xyzIn() {
        return this._inputs[1];
    }
    /**
     * Gets the xy component (input)
     */ get xyIn() {
        return this._inputs[2];
    }
    /**
     * Gets the zw component (input)
     */ get zwIn() {
        return this._inputs[3];
    }
    /**
     * Gets the x component (input)
     */ get x() {
        return this._inputs[4];
    }
    /**
     * Gets the y component (input)
     */ get y() {
        return this._inputs[5];
    }
    /**
     * Gets the z component (input)
     */ get z() {
        return this._inputs[6];
    }
    /**
     * Gets the w component (input)
     */ get w() {
        return this._inputs[7];
    }
    /**
     * Gets the xyzw component (output)
     */ get xyzw() {
        return this._outputs[0];
    }
    /**
     * Gets the xyz component (output)
     */ get xyzOut() {
        return this._outputs[1];
    }
    /**
     * Gets the xy component (output)
     */ get xyOut() {
        return this._outputs[2];
    }
    /**
     * Gets the zw component (output)
     */ get zwOut() {
        return this._outputs[3];
    }
    /**
     * Gets the xy component (output)
     * @deprecated Please use xyOut instead.
     */ get xy() {
        return this.xyOut;
    }
    /**
     * Gets the xyz component (output)
     * @deprecated Please use xyzOut instead.
     */ get xyz() {
        return this.xyzOut;
    }
    _inputRename(name) {
        if (name === "xyzw ") return "xyzwIn";
        if (name === "xyz ") return "xyzIn";
        if (name === "xy ") return "xyIn";
        if (name === "zw ") return "zwIn";
        return name;
    }
    _buildSwizzle(len) {
        const swizzle = this.xSwizzle + this.ySwizzle + this.zSwizzle + this.wSwizzle;
        return "." + swizzle.substr(0, len);
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const xInput = this.x;
        const yInput = this.y;
        const zInput = this.z;
        const wInput = this.w;
        const xyInput = this.xyIn;
        const zwInput = this.zwIn;
        const xyzInput = this.xyzIn;
        const xyzwInput = this.xyzwIn;
        const v4Output = this._outputs[0];
        const v3Output = this._outputs[1];
        const v2Output = this._outputs[2];
        const v2CompOutput = this._outputs[3];
        if (xyzwInput.isConnected) {
            if (v4Output.hasEndpoints) state.compilationString += this._declareOutput(v4Output, state) + ` = ${xyzwInput.associatedVariableName}${this._buildSwizzle(4)};\n`;
            if (v3Output.hasEndpoints) state.compilationString += this._declareOutput(v3Output, state) + ` = ${xyzwInput.associatedVariableName}${this._buildSwizzle(3)};\n`;
            if (v2Output.hasEndpoints) state.compilationString += this._declareOutput(v2Output, state) + ` = ${xyzwInput.associatedVariableName}${this._buildSwizzle(2)};\n`;
        } else if (xyzInput.isConnected) {
            if (v4Output.hasEndpoints) state.compilationString += this._declareOutput(v4Output, state) + ` = vec4(${xyzInput.associatedVariableName}, ${wInput.isConnected ? this._writeVariable(wInput) : "0.0"})${this._buildSwizzle(4)};\n`;
            if (v3Output.hasEndpoints) state.compilationString += this._declareOutput(v3Output, state) + ` = ${xyzInput.associatedVariableName}${this._buildSwizzle(3)};\n`;
            if (v2Output.hasEndpoints) state.compilationString += this._declareOutput(v2Output, state) + ` = ${xyzInput.associatedVariableName}${this._buildSwizzle(2)};\n`;
        } else if (xyInput.isConnected) {
            if (v4Output.hasEndpoints) {
                if (zwInput.isConnected) state.compilationString += this._declareOutput(v4Output, state) + ` = vec4(${xyInput.associatedVariableName}, ${zwInput.associatedVariableName})${this._buildSwizzle(4)};\n`;
                else state.compilationString += this._declareOutput(v4Output, state) + ` = vec4(${xyInput.associatedVariableName}, ${zInput.isConnected ? this._writeVariable(zInput) : "0.0"}, ${wInput.isConnected ? this._writeVariable(wInput) : "0.0"})${this._buildSwizzle(4)};\n`;
            }
            if (v3Output.hasEndpoints) state.compilationString += this._declareOutput(v3Output, state) + ` = vec3(${xyInput.associatedVariableName}, ${zInput.isConnected ? this._writeVariable(zInput) : "0.0"})${this._buildSwizzle(3)};\n`;
            if (v2Output.hasEndpoints) state.compilationString += this._declareOutput(v2Output, state) + ` = ${xyInput.associatedVariableName}${this._buildSwizzle(2)};\n`;
            if (v2CompOutput.hasEndpoints) {
                if (zwInput.isConnected) state.compilationString += this._declareOutput(v2CompOutput, state) + ` = ${zwInput.associatedVariableName}${this._buildSwizzle(2)};\n`;
                else state.compilationString += this._declareOutput(v2CompOutput, state) + ` = vec2(${zInput.isConnected ? this._writeVariable(zInput) : "0.0"}, ${wInput.isConnected ? this._writeVariable(wInput) : "0.0"})${this._buildSwizzle(2)};\n`;
            }
        } else {
            if (v4Output.hasEndpoints) {
                if (zwInput.isConnected) state.compilationString += this._declareOutput(v4Output, state) + ` = vec4(${xInput.isConnected ? this._writeVariable(xInput) : "0.0"}, ${yInput.isConnected ? this._writeVariable(yInput) : "0.0"}, ${zwInput.associatedVariableName})${this._buildSwizzle(4)};\n`;
                else state.compilationString += this._declareOutput(v4Output, state) + ` = vec4(${xInput.isConnected ? this._writeVariable(xInput) : "0.0"}, ${yInput.isConnected ? this._writeVariable(yInput) : "0.0"}, ${zInput.isConnected ? this._writeVariable(zInput) : "0.0"}, ${wInput.isConnected ? this._writeVariable(wInput) : "0.0"})${this._buildSwizzle(4)};\n`;
            }
            if (v3Output.hasEndpoints) state.compilationString += this._declareOutput(v3Output, state) + ` = vec3(${xInput.isConnected ? this._writeVariable(xInput) : "0.0"}, ${yInput.isConnected ? this._writeVariable(yInput) : "0.0"}, ${zInput.isConnected ? this._writeVariable(zInput) : "0.0"})${this._buildSwizzle(3)};\n`;
            if (v2Output.hasEndpoints) state.compilationString += this._declareOutput(v2Output, state) + ` = vec2(${xInput.isConnected ? this._writeVariable(xInput) : "0.0"}, ${yInput.isConnected ? this._writeVariable(yInput) : "0.0"})${this._buildSwizzle(2)};\n`;
            if (v2CompOutput.hasEndpoints) {
                if (zwInput.isConnected) state.compilationString += this._declareOutput(v2CompOutput, state) + ` = ${zwInput.associatedVariableName}${this._buildSwizzle(2)};\n`;
                else state.compilationString += this._declareOutput(v2CompOutput, state) + ` = vec2(${zInput.isConnected ? this._writeVariable(zInput) : "0.0"}, ${wInput.isConnected ? this._writeVariable(wInput) : "0.0"})${this._buildSwizzle(2)};\n`;
            }
        }
        return this;
    }
    serialize() {
        const serializationObject = super.serialize();
        serializationObject.xSwizzle = this.xSwizzle;
        serializationObject.ySwizzle = this.ySwizzle;
        serializationObject.zSwizzle = this.zSwizzle;
        serializationObject.wSwizzle = this.wSwizzle;
        return serializationObject;
    }
    _deserialize(serializationObject, scene, rootUrl) {
        super._deserialize(serializationObject, scene, rootUrl);
        this.xSwizzle = serializationObject.xSwizzle ?? "x";
        this.ySwizzle = serializationObject.ySwizzle ?? "y";
        this.zSwizzle = serializationObject.zSwizzle ?? "z";
        this.wSwizzle = serializationObject.wSwizzle ?? "w";
    }
    _dumpPropertiesCode() {
        let codeString = super._dumpPropertiesCode();
        codeString += `${this._codeVariableName}.xSwizzle = "${this.xSwizzle}";\n`;
        codeString += `${this._codeVariableName}.ySwizzle = "${this.ySwizzle}";\n`;
        codeString += `${this._codeVariableName}.zSwizzle = "${this.zSwizzle}";\n`;
        codeString += `${this._codeVariableName}.wSwizzle = "${this.wSwizzle}";\n`;
        return codeString;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.VectorMergerBlock", $e1c2abfd3a97a36b$export$fd226f9533f998f7);

});

parcelRegister("dIpWY", function(module, exports) {

$parcel$export(module.exports, "RemapBlock", () => $9fc383937c2702b9$export$55640372b1511806);

var $e0Suo = parcelRequire("e0Suo");

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");

var $ha1VO = parcelRequire("ha1VO");

var $1aXVF = parcelRequire("1aXVF");
class $9fc383937c2702b9$export$55640372b1511806 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new RemapBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        /**
         * Gets or sets the source range
         */ this.sourceRange = new (0, $ha1VO.Vector2)(-1, 1);
        /**
         * Gets or sets the target range
         */ this.targetRange = new (0, $ha1VO.Vector2)(0, 1);
        this.registerInput("input", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerInput("sourceMin", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true);
        this.registerInput("sourceMax", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true);
        this.registerInput("targetMin", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true);
        this.registerInput("targetMax", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "RemapBlock";
    }
    /**
     * Gets the input component
     */ get input() {
        return this._inputs[0];
    }
    /**
     * Gets the source min input component
     */ get sourceMin() {
        return this._inputs[1];
    }
    /**
     * Gets the source max input component
     */ get sourceMax() {
        return this._inputs[2];
    }
    /**
     * Gets the target min input component
     */ get targetMin() {
        return this._inputs[3];
    }
    /**
     * Gets the target max input component
     */ get targetMax() {
        return this._inputs[4];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        const sourceMin = this.sourceMin.isConnected ? this.sourceMin.associatedVariableName : this._writeFloat(this.sourceRange.x);
        const sourceMax = this.sourceMax.isConnected ? this.sourceMax.associatedVariableName : this._writeFloat(this.sourceRange.y);
        const targetMin = this.targetMin.isConnected ? this.targetMin.associatedVariableName : this._writeFloat(this.targetRange.x);
        const targetMax = this.targetMax.isConnected ? this.targetMax.associatedVariableName : this._writeFloat(this.targetRange.y);
        state.compilationString += this._declareOutput(output, state) + ` = ${targetMin} + (${this._inputs[0].associatedVariableName} - ${sourceMin}) * (${targetMax} - ${targetMin}) / (${sourceMax} - ${sourceMin});\n`;
        return this;
    }
    _dumpPropertiesCode() {
        let codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.sourceRange = new BABYLON.Vector2(${this.sourceRange.x}, ${this.sourceRange.y});\n`;
        codeString += `${this._codeVariableName}.targetRange = new BABYLON.Vector2(${this.targetRange.x}, ${this.targetRange.y});\n`;
        return codeString;
    }
    serialize() {
        const serializationObject = super.serialize();
        serializationObject.sourceRange = this.sourceRange.asArray();
        serializationObject.targetRange = this.targetRange.asArray();
        return serializationObject;
    }
    _deserialize(serializationObject, scene, rootUrl) {
        super._deserialize(serializationObject, scene, rootUrl);
        this.sourceRange = (0, $ha1VO.Vector2).FromArray(serializationObject.sourceRange);
        this.targetRange = (0, $ha1VO.Vector2).FromArray(serializationObject.targetRange);
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("From", (0, $1aXVF.PropertyTypeForEdition).Vector2)
], $9fc383937c2702b9$export$55640372b1511806.prototype, "sourceRange", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("To", (0, $1aXVF.PropertyTypeForEdition).Vector2)
], $9fc383937c2702b9$export$55640372b1511806.prototype, "targetRange", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.RemapBlock", $9fc383937c2702b9$export$55640372b1511806);

});

parcelRegister("fTSHo", function(module, exports) {

$parcel$export(module.exports, "MultiplyBlock", () => $b9366c25e076ae71$export$191fe08e159616b5);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $b9366c25e076ae71$export$191fe08e159616b5 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new MultiplyBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("left", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerInput("right", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
        this._linkConnectionTypes(0, 1, true);
        this._inputs[0].acceptedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this._inputs[1].acceptedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "MultiplyBlock";
    }
    /**
     * Gets the left operand input component
     */ get left() {
        return this._inputs[0];
    }
    /**
     * Gets the right operand input component
     */ get right() {
        return this._inputs[1];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        state.compilationString += this._declareOutput(output, state) + ` = ${this.left.associatedVariableName} * ${this.right.associatedVariableName};\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.MultiplyBlock", $b9366c25e076ae71$export$191fe08e159616b5);

});

parcelRegister("5oHv1", function(module, exports) {

$parcel$export(module.exports, "NodeMaterialModes", () => $3ee0efb0a2bd0fd4$export$3dde319a5c334acb);
/**
 * Enum used to define the material modes
 */ var $3ee0efb0a2bd0fd4$export$3dde319a5c334acb;
(function(NodeMaterialModes) {
    /** Regular material */ NodeMaterialModes[NodeMaterialModes["Material"] = 0] = "Material";
    /** For post process */ NodeMaterialModes[NodeMaterialModes["PostProcess"] = 1] = "PostProcess";
    /** For particle system */ NodeMaterialModes[NodeMaterialModes["Particle"] = 2] = "Particle";
    /** For procedural texture */ NodeMaterialModes[NodeMaterialModes["ProceduralTexture"] = 3] = "ProceduralTexture";
})($3ee0efb0a2bd0fd4$export$3dde319a5c334acb || ($3ee0efb0a2bd0fd4$export$3dde319a5c334acb = {}));

});

parcelRegister("1iaDW", function(module, exports) {

$parcel$export(module.exports, "BaseParticleSystem", () => $0f0fba623f54307f$export$27e68fd8fa9be86e);

var $ha1VO = parcelRequire("ha1VO");

var $2w6xm = parcelRequire("2w6xm");

var $7etnY = parcelRequire("7etnY");
parcelRequire("7G59J");
class $0f0fba623f54307f$export$27e68fd8fa9be86e {
    /**
     * Gets or sets a texture used to add random noise to particle positions
     */ get noiseTexture() {
        return this._noiseTexture;
    }
    set noiseTexture(value) {
        if (this._noiseTexture === value) return;
        this._noiseTexture = value;
        this._reset();
    }
    /**
     * Gets or sets whether an animation sprite sheet is enabled or not on the particle system
     */ get isAnimationSheetEnabled() {
        return this._isAnimationSheetEnabled;
    }
    set isAnimationSheetEnabled(value) {
        if (this._isAnimationSheetEnabled == value) return;
        this._isAnimationSheetEnabled = value;
        this._reset();
    }
    /**
     * Gets or sets a boolean enabling the use of logarithmic depth buffers, which is good for wide depth buffers.
     */ get useLogarithmicDepth() {
        return this._useLogarithmicDepth;
    }
    set useLogarithmicDepth(value) {
        this._useLogarithmicDepth = value && this.getScene().getEngine().getCaps().fragmentDepthSupported;
    }
    /**
     * Get hosting scene
     * @returns the scene
     */ getScene() {
        return this._scene;
    }
    _hasTargetStopDurationDependantGradient() {
        return this._startSizeGradients && this._startSizeGradients.length > 0 || this._emitRateGradients && this._emitRateGradients.length > 0 || this._lifeTimeGradients && this._lifeTimeGradients.length > 0;
    }
    /**
     * Gets the current list of drag gradients.
     * You must use addDragGradient and removeDragGradient to update this list
     * @returns the list of drag gradients
     */ getDragGradients() {
        return this._dragGradients;
    }
    /**
     * Gets the current list of limit velocity gradients.
     * You must use addLimitVelocityGradient and removeLimitVelocityGradient to update this list
     * @returns the list of limit velocity gradients
     */ getLimitVelocityGradients() {
        return this._limitVelocityGradients;
    }
    /**
     * Gets the current list of color gradients.
     * You must use addColorGradient and removeColorGradient to update this list
     * @returns the list of color gradients
     */ getColorGradients() {
        return this._colorGradients;
    }
    /**
     * Gets the current list of size gradients.
     * You must use addSizeGradient and removeSizeGradient to update this list
     * @returns the list of size gradients
     */ getSizeGradients() {
        return this._sizeGradients;
    }
    /**
     * Gets the current list of color remap gradients.
     * You must use addColorRemapGradient and removeColorRemapGradient to update this list
     * @returns the list of color remap gradients
     */ getColorRemapGradients() {
        return this._colorRemapGradients;
    }
    /**
     * Gets the current list of alpha remap gradients.
     * You must use addAlphaRemapGradient and removeAlphaRemapGradient to update this list
     * @returns the list of alpha remap gradients
     */ getAlphaRemapGradients() {
        return this._alphaRemapGradients;
    }
    /**
     * Gets the current list of life time gradients.
     * You must use addLifeTimeGradient and removeLifeTimeGradient to update this list
     * @returns the list of life time gradients
     */ getLifeTimeGradients() {
        return this._lifeTimeGradients;
    }
    /**
     * Gets the current list of angular speed gradients.
     * You must use addAngularSpeedGradient and removeAngularSpeedGradient to update this list
     * @returns the list of angular speed gradients
     */ getAngularSpeedGradients() {
        return this._angularSpeedGradients;
    }
    /**
     * Gets the current list of velocity gradients.
     * You must use addVelocityGradient and removeVelocityGradient to update this list
     * @returns the list of velocity gradients
     */ getVelocityGradients() {
        return this._velocityGradients;
    }
    /**
     * Gets the current list of start size gradients.
     * You must use addStartSizeGradient and removeStartSizeGradient to update this list
     * @returns the list of start size gradients
     */ getStartSizeGradients() {
        return this._startSizeGradients;
    }
    /**
     * Gets the current list of emit rate gradients.
     * You must use addEmitRateGradient and removeEmitRateGradient to update this list
     * @returns the list of emit rate gradients
     */ getEmitRateGradients() {
        return this._emitRateGradients;
    }
    /**
     * Random direction of each particle after it has been emitted, between direction1 and direction2 vectors.
     * This only works when particleEmitterTyps is a BoxParticleEmitter
     */ get direction1() {
        if (this.particleEmitterType.direction1) return this.particleEmitterType.direction1;
        return (0, $ha1VO.Vector3).Zero();
    }
    set direction1(value) {
        if (this.particleEmitterType.direction1) this.particleEmitterType.direction1 = value;
    }
    /**
     * Random direction of each particle after it has been emitted, between direction1 and direction2 vectors.
     * This only works when particleEmitterTyps is a BoxParticleEmitter
     */ get direction2() {
        if (this.particleEmitterType.direction2) return this.particleEmitterType.direction2;
        return (0, $ha1VO.Vector3).Zero();
    }
    set direction2(value) {
        if (this.particleEmitterType.direction2) this.particleEmitterType.direction2 = value;
    }
    /**
     * Minimum box point around our emitter. Our emitter is the center of particles source, but if you want your particles to emit from more than one point, then you can tell it to do so.
     * This only works when particleEmitterTyps is a BoxParticleEmitter
     */ get minEmitBox() {
        if (this.particleEmitterType.minEmitBox) return this.particleEmitterType.minEmitBox;
        return (0, $ha1VO.Vector3).Zero();
    }
    set minEmitBox(value) {
        if (this.particleEmitterType.minEmitBox) this.particleEmitterType.minEmitBox = value;
    }
    /**
     * Maximum box point around our emitter. Our emitter is the center of particles source, but if you want your particles to emit from more than one point, then you can tell it to do so.
     * This only works when particleEmitterTyps is a BoxParticleEmitter
     */ get maxEmitBox() {
        if (this.particleEmitterType.maxEmitBox) return this.particleEmitterType.maxEmitBox;
        return (0, $ha1VO.Vector3).Zero();
    }
    set maxEmitBox(value) {
        if (this.particleEmitterType.maxEmitBox) this.particleEmitterType.maxEmitBox = value;
    }
    /**
     * Gets or sets the billboard mode to use when isBillboardBased = true.
     * Value can be: ParticleSystem.BILLBOARDMODE_ALL, ParticleSystem.BILLBOARDMODE_Y, ParticleSystem.BILLBOARDMODE_STRETCHED
     */ get billboardMode() {
        return this._billboardMode;
    }
    set billboardMode(value) {
        if (this._billboardMode === value) return;
        this._billboardMode = value;
        this._reset();
    }
    /**
     * Gets or sets a boolean indicating if the particles must be rendered as billboard or aligned with the direction
     */ get isBillboardBased() {
        return this._isBillboardBased;
    }
    set isBillboardBased(value) {
        if (this._isBillboardBased === value) return;
        this._isBillboardBased = value;
        this._reset();
    }
    /**
     * Gets the image processing configuration used either in this material.
     */ get imageProcessingConfiguration() {
        return this._imageProcessingConfiguration;
    }
    /**
     * Sets the Default image processing configuration used either in the this material.
     *
     * If sets to null, the scene one is in use.
     */ set imageProcessingConfiguration(value) {
        this._attachImageProcessingConfiguration(value);
    }
    /**
     * Attaches a new image processing configuration to the Standard Material.
     * @param configuration
     */ _attachImageProcessingConfiguration(configuration) {
        if (configuration === this._imageProcessingConfiguration) return;
        // Pick the scene configuration if needed.
        if (!configuration && this._scene) this._imageProcessingConfiguration = this._scene.imageProcessingConfiguration;
        else this._imageProcessingConfiguration = configuration;
    }
    /** @internal */ _reset() {}
    /**
     * @internal
     */ _removeGradientAndTexture(gradient, gradients, texture) {
        if (!gradients) return this;
        let index = 0;
        for (const valueGradient of gradients){
            if (valueGradient.gradient === gradient) {
                gradients.splice(index, 1);
                break;
            }
            index++;
        }
        if (texture) texture.dispose();
        return this;
    }
    /**
     * Instantiates a particle system.
     * Particles are often small sprites used to simulate hard-to-reproduce phenomena like fire, smoke, water, or abstract visual effects like magic glitter and faery dust.
     * @param name The name of the particle system
     */ constructor(name){
        /**
         * List of animations used by the particle system.
         */ this.animations = [];
        /**
         * The rendering group used by the Particle system to chose when to render.
         */ this.renderingGroupId = 0;
        /**
         * The emitter represents the Mesh or position we are attaching the particle system to.
         */ this.emitter = (0, $ha1VO.Vector3).Zero();
        /**
         * The maximum number of particles to emit per frame
         */ this.emitRate = 10;
        /**
         * If you want to launch only a few particles at once, that can be done, as well.
         */ this.manualEmitCount = -1;
        /**
         * The overall motion speed (0.01 is default update speed, faster updates = faster animation)
         */ this.updateSpeed = 0.01;
        /**
         * The amount of time the particle system is running (depends of the overall update speed).
         */ this.targetStopDuration = 0;
        /**
         * Specifies whether the particle system will be disposed once it reaches the end of the animation.
         */ this.disposeOnStop = false;
        /**
         * Minimum power of emitting particles.
         */ this.minEmitPower = 1;
        /**
         * Maximum power of emitting particles.
         */ this.maxEmitPower = 1;
        /**
         * Minimum life time of emitting particles.
         */ this.minLifeTime = 1;
        /**
         * Maximum life time of emitting particles.
         */ this.maxLifeTime = 1;
        /**
         * Minimum Size of emitting particles.
         */ this.minSize = 1;
        /**
         * Maximum Size of emitting particles.
         */ this.maxSize = 1;
        /**
         * Minimum scale of emitting particles on X axis.
         */ this.minScaleX = 1;
        /**
         * Maximum scale of emitting particles on X axis.
         */ this.maxScaleX = 1;
        /**
         * Minimum scale of emitting particles on Y axis.
         */ this.minScaleY = 1;
        /**
         * Maximum scale of emitting particles on Y axis.
         */ this.maxScaleY = 1;
        /**
         * Gets or sets the minimal initial rotation in radians.
         */ this.minInitialRotation = 0;
        /**
         * Gets or sets the maximal initial rotation in radians.
         */ this.maxInitialRotation = 0;
        /**
         * Minimum angular speed of emitting particles (Z-axis rotation for each particle).
         */ this.minAngularSpeed = 0;
        /**
         * Maximum angular speed of emitting particles (Z-axis rotation for each particle).
         */ this.maxAngularSpeed = 0;
        /**
         * The layer mask we are rendering the particles through.
         */ this.layerMask = 0x0fffffff;
        /**
         * This can help using your own shader to render the particle system.
         * The according effect will be created
         */ this.customShader = null;
        /**
         * By default particle system starts as soon as they are created. This prevents the
         * automatic start to happen and let you decide when to start emitting particles.
         */ this.preventAutoStart = false;
        /**
         * Gets or sets a boolean indicating that this particle system will allow fog to be rendered on it (false by default)
         */ this.applyFog = false;
        /** @internal */ this._wasDispatched = false;
        this._rootUrl = "";
        /** Gets or sets the strength to apply to the noise value (default is (10, 10, 10)) */ this.noiseStrength = new (0, $ha1VO.Vector3)(10, 10, 10);
        /**
         * Callback triggered when the particle animation is ending.
         */ this.onAnimationEnd = null;
        /**
         * Blend mode use to render the particle, it can be either ParticleSystem.BLENDMODE_ONEONE or ParticleSystem.BLENDMODE_STANDARD.
         */ this.blendMode = $0f0fba623f54307f$export$27e68fd8fa9be86e.BLENDMODE_ONEONE;
        /**
         * Forces the particle to write their depth information to the depth buffer. This can help preventing other draw calls
         * to override the particles.
         */ this.forceDepthWrite = false;
        /** Gets or sets a value indicating how many cycles (or frames) must be executed before first rendering (this value has to be set before starting the system). Default is 0 */ this.preWarmCycles = 0;
        /** Gets or sets a value indicating the time step multiplier to use in pre-warm mode (default is 1) */ this.preWarmStepOffset = 1;
        /**
         * If using a spritesheet (isAnimationSheetEnabled) defines the speed of the sprite loop (default is 1 meaning the animation will play once during the entire particle lifetime)
         */ this.spriteCellChangeSpeed = 1;
        /**
         * If using a spritesheet (isAnimationSheetEnabled) defines the first sprite cell to display
         */ this.startSpriteCellID = 0;
        /**
         * If using a spritesheet (isAnimationSheetEnabled) defines the last sprite cell to display
         */ this.endSpriteCellID = 0;
        /**
         * If using a spritesheet (isAnimationSheetEnabled), defines the sprite cell width to use
         */ this.spriteCellWidth = 0;
        /**
         * If using a spritesheet (isAnimationSheetEnabled), defines the sprite cell height to use
         */ this.spriteCellHeight = 0;
        /**
         * If using a spritesheet (isAnimationSheetEnabled), defines wether the sprite animation is looping
         */ this.spriteCellLoop = true;
        /**
         * This allows the system to random pick the start cell ID between startSpriteCellID and endSpriteCellID
         */ this.spriteRandomStartCell = false;
        /** Gets or sets a Vector2 used to move the pivot (by default (0,0)) */ this.translationPivot = new (0, $ha1VO.Vector2)(0, 0);
        /**
         * Gets or sets a boolean indicating that hosted animations (in the system.animations array) must be started when system.start() is called
         */ this.beginAnimationOnStart = false;
        /**
         * Gets or sets the frame to start the animation from when beginAnimationOnStart is true
         */ this.beginAnimationFrom = 0;
        /**
         * Gets or sets the frame to end the animation on when beginAnimationOnStart is true
         */ this.beginAnimationTo = 60;
        /**
         * Gets or sets a boolean indicating if animations must loop when beginAnimationOnStart is true
         */ this.beginAnimationLoop = false;
        /**
         * Gets or sets a world offset applied to all particles
         */ this.worldOffset = new (0, $ha1VO.Vector3)(0, 0, 0);
        this._useLogarithmicDepth = false;
        /**
         * You can use gravity if you want to give an orientation to your particles.
         */ this.gravity = (0, $ha1VO.Vector3).Zero();
        this._colorGradients = null;
        this._sizeGradients = null;
        this._lifeTimeGradients = null;
        this._angularSpeedGradients = null;
        this._velocityGradients = null;
        this._limitVelocityGradients = null;
        this._dragGradients = null;
        this._emitRateGradients = null;
        this._startSizeGradients = null;
        this._rampGradients = null;
        this._colorRemapGradients = null;
        this._alphaRemapGradients = null;
        /**
         * Defines the delay in milliseconds before starting the system (0 by default)
         */ this.startDelay = 0;
        /** Gets or sets a value indicating the damping to apply if the limit velocity factor is reached */ this.limitVelocityDamping = 0.4;
        /**
         * Random color of each particle after it has been emitted, between color1 and color2 vectors
         */ this.color1 = new (0, $7etnY.Color4)(1.0, 1.0, 1.0, 1.0);
        /**
         * Random color of each particle after it has been emitted, between color1 and color2 vectors
         */ this.color2 = new (0, $7etnY.Color4)(1.0, 1.0, 1.0, 1.0);
        /**
         * Color the particle will have at the end of its lifetime
         */ this.colorDead = new (0, $7etnY.Color4)(0, 0, 0, 1.0);
        /**
         * An optional mask to filter some colors out of the texture, or filter a part of the alpha channel
         */ this.textureMask = new (0, $7etnY.Color4)(1.0, 1.0, 1.0, 1.0);
        /** @internal */ this._isSubEmitter = false;
        /** @internal */ this._billboardMode = 7;
        /** @internal */ this._isBillboardBased = true;
        /**
         * Local cache of defines for image processing.
         */ this._imageProcessingConfigurationDefines = new (0, $2w6xm.ImageProcessingConfigurationDefines)();
        this.id = name;
        this.name = name;
    }
    /**
     * Creates a Point Emitter for the particle system (emits directly from the emitter position)
     * @param direction1 Particles are emitted between the direction1 and direction2 from within the box
     * @param direction2 Particles are emitted between the direction1 and direction2 from within the box
     */ createPointEmitter(direction1, direction2) {
        throw new Error("Method not implemented.");
    }
    /**
     * Creates a Hemisphere Emitter for the particle system (emits along the hemisphere radius)
     * @param radius The radius of the hemisphere to emit from
     * @param radiusRange The range of the hemisphere to emit from [0-1] 0 Surface Only, 1 Entire Radius
     */ createHemisphericEmitter(radius = 1, radiusRange = 1) {
        throw new Error("Method not implemented.");
    }
    /**
     * Creates a Sphere Emitter for the particle system (emits along the sphere radius)
     * @param radius The radius of the sphere to emit from
     * @param radiusRange The range of the sphere to emit from [0-1] 0 Surface Only, 1 Entire Radius
     */ createSphereEmitter(radius = 1, radiusRange = 1) {
        throw new Error("Method not implemented.");
    }
    /**
     * Creates a Directed Sphere Emitter for the particle system (emits between direction1 and direction2)
     * @param radius The radius of the sphere to emit from
     * @param direction1 Particles are emitted between the direction1 and direction2 from within the sphere
     * @param direction2 Particles are emitted between the direction1 and direction2 from within the sphere
     */ createDirectedSphereEmitter(radius = 1, direction1 = new (0, $ha1VO.Vector3)(0, 1.0, 0), direction2 = new (0, $ha1VO.Vector3)(0, 1.0, 0)) {
        throw new Error("Method not implemented.");
    }
    /**
     * Creates a Cylinder Emitter for the particle system (emits from the cylinder to the particle position)
     * @param radius The radius of the emission cylinder
     * @param height The height of the emission cylinder
     * @param radiusRange The range of emission [0-1] 0 Surface only, 1 Entire Radius
     * @param directionRandomizer How much to randomize the particle direction [0-1]
     */ createCylinderEmitter(radius = 1, height = 1, radiusRange = 1, directionRandomizer = 0) {
        throw new Error("Method not implemented.");
    }
    /**
     * Creates a Directed Cylinder Emitter for the particle system (emits between direction1 and direction2)
     * @param radius The radius of the cylinder to emit from
     * @param height The height of the emission cylinder
     * @param radiusRange the range of the emission cylinder [0-1] 0 Surface only, 1 Entire Radius (1 by default)
     * @param direction1 Particles are emitted between the direction1 and direction2 from within the cylinder
     * @param direction2 Particles are emitted between the direction1 and direction2 from within the cylinder
     */ createDirectedCylinderEmitter(radius = 1, height = 1, radiusRange = 1, direction1 = new (0, $ha1VO.Vector3)(0, 1.0, 0), direction2 = new (0, $ha1VO.Vector3)(0, 1.0, 0)) {
        throw new Error("Method not implemented.");
    }
    /**
     * Creates a Cone Emitter for the particle system (emits from the cone to the particle position)
     * @param radius The radius of the cone to emit from
     * @param angle The base angle of the cone
     */ createConeEmitter(radius = 1, angle = Math.PI / 4) {
        throw new Error("Method not implemented.");
    }
    /**
     * Creates a Box Emitter for the particle system. (emits between direction1 and direction2 from withing the box defined by minEmitBox and maxEmitBox)
     * @param direction1 Particles are emitted between the direction1 and direction2 from within the box
     * @param direction2 Particles are emitted between the direction1 and direction2 from within the box
     * @param minEmitBox Particles are emitted from the box between minEmitBox and maxEmitBox
     * @param maxEmitBox  Particles are emitted from the box between minEmitBox and maxEmitBox
     */ createBoxEmitter(direction1, direction2, minEmitBox, maxEmitBox) {
        throw new Error("Method not implemented.");
    }
}
/**
 * Source color is added to the destination color without alpha affecting the result
 */ $0f0fba623f54307f$export$27e68fd8fa9be86e.BLENDMODE_ONEONE = 0;
/**
 * Blend current color and particle color using particle’s alpha
 */ $0f0fba623f54307f$export$27e68fd8fa9be86e.BLENDMODE_STANDARD = 1;
/**
 * Add current color and particle color multiplied by particle’s alpha
 */ $0f0fba623f54307f$export$27e68fd8fa9be86e.BLENDMODE_ADD = 2;
/**
 * Multiply current color with particle color
 */ $0f0fba623f54307f$export$27e68fd8fa9be86e.BLENDMODE_MULTIPLY = 3;
/**
 * Multiply current color with particle color then add current color and particle color multiplied by particle’s alpha
 */ $0f0fba623f54307f$export$27e68fd8fa9be86e.BLENDMODE_MULTIPLYADD = 4;

});
parcelRegister("2w6xm", function(module, exports) {

$parcel$export(module.exports, "ImageProcessingConfigurationDefines", () => $1d53a40ac71847cf$export$b62a68c027a48d03);

var $35xmP = parcelRequire("35xmP");
class $1d53a40ac71847cf$export$b62a68c027a48d03 extends (0, $35xmP.MaterialDefines) {
    constructor(){
        super();
        this.IMAGEPROCESSING = false;
        this.VIGNETTE = false;
        this.VIGNETTEBLENDMODEMULTIPLY = false;
        this.VIGNETTEBLENDMODEOPAQUE = false;
        this.TONEMAPPING = false;
        this.TONEMAPPING_ACES = false;
        this.CONTRAST = false;
        this.COLORCURVES = false;
        this.COLORGRADING = false;
        this.COLORGRADING3D = false;
        this.SAMPLER3DGREENDEPTH = false;
        this.SAMPLER3DBGRMAP = false;
        this.DITHER = false;
        this.IMAGEPROCESSINGPOSTPROCESS = false;
        this.EXPOSURE = false;
        this.SKIPFINALCOLORCLAMP = false;
        this.rebuild();
    }
}

});


parcelRegister("6XqNB", function(module, exports) {

$parcel$export(module.exports, "ColorSplitterBlock", () => $510d0a807e44bf97$export$3434d2794c75187f);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $510d0a807e44bf97$export$3434d2794c75187f extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Create a new ColorSplitterBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("rgba", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4, true);
        this.registerInput("rgb ", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3, true);
        this.registerOutput("rgb", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3);
        this.registerOutput("r", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.registerOutput("g", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.registerOutput("b", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.registerOutput("a", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.inputsAreExclusive = true;
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "ColorSplitterBlock";
    }
    /**
     * Gets the rgba component (input)
     */ get rgba() {
        return this._inputs[0];
    }
    /**
     * Gets the rgb component (input)
     */ get rgbIn() {
        return this._inputs[1];
    }
    /**
     * Gets the rgb component (output)
     */ get rgbOut() {
        return this._outputs[0];
    }
    /**
     * Gets the r component (output)
     */ get r() {
        return this._outputs[1];
    }
    /**
     * Gets the g component (output)
     */ get g() {
        return this._outputs[2];
    }
    /**
     * Gets the b component (output)
     */ get b() {
        return this._outputs[3];
    }
    /**
     * Gets the a component (output)
     */ get a() {
        return this._outputs[4];
    }
    _inputRename(name) {
        if (name === "rgb ") return "rgbIn";
        return name;
    }
    _outputRename(name) {
        if (name === "rgb") return "rgbOut";
        return name;
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const input = this.rgba.isConnected ? this.rgba : this.rgbIn;
        if (!input.isConnected) return;
        const rgbOutput = this._outputs[0];
        const rOutput = this._outputs[1];
        const gOutput = this._outputs[2];
        const bOutput = this._outputs[3];
        const aOutput = this._outputs[4];
        if (rgbOutput.hasEndpoints) state.compilationString += this._declareOutput(rgbOutput, state) + ` = ${input.associatedVariableName}.rgb;\n`;
        if (rOutput.hasEndpoints) state.compilationString += this._declareOutput(rOutput, state) + ` = ${input.associatedVariableName}.r;\n`;
        if (gOutput.hasEndpoints) state.compilationString += this._declareOutput(gOutput, state) + ` = ${input.associatedVariableName}.g;\n`;
        if (bOutput.hasEndpoints) state.compilationString += this._declareOutput(bOutput, state) + ` = ${input.associatedVariableName}.b;\n`;
        if (aOutput.hasEndpoints) state.compilationString += this._declareOutput(aOutput, state) + ` = ${input.associatedVariableName}.a;\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.ColorSplitterBlock", $510d0a807e44bf97$export$3434d2794c75187f);

});

parcelRegister("bds6B", function(module, exports) {

$parcel$export(module.exports, "ProceduralTexture", () => $82a6b5c7589d466c$export$f727015479027316);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $diGQf = parcelRequire("diGQf");

var $b4i1f = parcelRequire("b4i1f");

var $bv05l = parcelRequire("bv05l");

var $54229 = parcelRequire("54229");

var $j2mX5 = parcelRequire("j2mX5");

var $gQtNK = parcelRequire("gQtNK");

var $3BZkj = parcelRequire("3BZkj");
parcelRequire("4PdZs");
parcelRequire("gfE2b");
parcelRequire("96Nay");

var $8DoUR = parcelRequire("8DoUR");

var $ejQPp = parcelRequire("ejQPp");

var $hOyoX = parcelRequire("hOyoX");
class $82a6b5c7589d466c$export$f727015479027316 extends (0, $j2mX5.Texture) {
    /**
     * Instantiates a new procedural texture.
     * Procedural texturing is a way to programmatically create a texture. There are 2 types of procedural textures: code-only, and code that references some classic 2D images, sometimes called 'refMaps' or 'sampler' images.
     * This is the base class of any Procedural texture and contains most of the shareable code.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/proceduralTextures
     * @param name  Define the name of the texture
     * @param size Define the size of the texture to create
     * @param fragment Define the fragment shader to use to generate the texture or null if it is defined later:
     *  * object: \{ fragmentElement: "fragmentShaderCode" \}, used with shader code in script tags
     *  * object: \{ fragmentSource: "fragment shader code string" \}, the string contains the shader code
     *  * string: the string contains a name "XXX" to lookup in Effect.ShadersStore["XXXFragmentShader"]
     * @param scene Define the scene the texture belongs to
     * @param fallbackTexture Define a fallback texture in case there were issues to create the custom texture
     * @param generateMipMaps Define if the texture should creates mip maps or not
     * @param isCube Define if the texture is a cube texture or not (this will render each faces of the cube)
     * @param textureType The FBO internal texture type
     */ constructor(name, size, fragment, scene, fallbackTexture = null, generateMipMaps = true, isCube = false, textureType = 0){
        super(null, scene, !generateMipMaps);
        /**
         * Define if the texture is enabled or not (disabled texture will not render)
         */ this.isEnabled = true;
        /**
         * Define if the texture must be cleared before rendering (default is true)
         */ this.autoClear = true;
        /**
         * Event raised when the texture is generated
         */ this.onGeneratedObservable = new (0, $diGQf.Observable)();
        /**
         * Event raised before the texture is generated
         */ this.onBeforeGenerationObservable = new (0, $diGQf.Observable)();
        /**
         * Gets or sets the node material used to create this texture (null if the texture was manually created)
         */ this.nodeMaterialSource = null;
        /** @internal */ this._textures = {};
        this._currentRefreshId = -1;
        this._frameId = -1;
        this._refreshRate = 1;
        this._vertexBuffers = {};
        this._uniforms = new Array();
        this._samplers = new Array();
        this._floats = {};
        this._ints = {};
        this._floatsArrays = {};
        this._colors3 = {};
        this._colors4 = {};
        this._vectors2 = {};
        this._vectors3 = {};
        this._matrices = {};
        this._fallbackTextureUsed = false;
        this._cachedDefines = null;
        this._contentUpdateId = -1;
        this._rtWrapper = null;
        if (fallbackTexture !== null && !(fallbackTexture instanceof (0, $j2mX5.Texture))) {
            this._options = fallbackTexture;
            this._fallbackTexture = fallbackTexture.fallbackTexture ?? null;
        } else {
            this._options = {};
            this._fallbackTexture = fallbackTexture;
        }
        scene = this.getScene() || (0, $ejQPp.EngineStore).LastCreatedScene;
        let component = scene._getComponent((0, $bv05l.SceneComponentConstants).NAME_PROCEDURALTEXTURE);
        if (!component) {
            component = new (0, $3BZkj.ProceduralTextureSceneComponent)(scene);
            scene._addComponent(component);
        }
        scene.proceduralTextures.push(this);
        this._fullEngine = scene.getEngine();
        this.name = name;
        this.isRenderTarget = true;
        this._size = size;
        this._textureType = textureType;
        this._generateMipMaps = generateMipMaps;
        this._drawWrapper = new (0, $hOyoX.DrawWrapper)(this._fullEngine);
        this.setFragment(fragment);
        const rtWrapper = this._createRtWrapper(isCube, size, generateMipMaps, textureType);
        this._texture = rtWrapper.texture;
        // VBO
        const vertices = [];
        vertices.push(1, 1);
        vertices.push(-1, 1);
        vertices.push(-1, -1);
        vertices.push(1, -1);
        this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind] = new (0, $b4i1f.VertexBuffer)(this._fullEngine, vertices, (0, $b4i1f.VertexBuffer).PositionKind, false, false, 2);
        this._createIndexBuffer();
    }
    _createRtWrapper(isCube, size, generateMipMaps, textureType) {
        if (isCube) {
            this._rtWrapper = this._fullEngine.createRenderTargetCubeTexture(size, {
                generateMipMaps: generateMipMaps,
                generateDepthBuffer: false,
                generateStencilBuffer: false,
                type: textureType,
                ...this._options
            });
            this.setFloat("face", 0);
        } else this._rtWrapper = this._fullEngine.createRenderTargetTexture(size, {
            generateMipMaps: generateMipMaps,
            generateDepthBuffer: false,
            generateStencilBuffer: false,
            type: textureType,
            ...this._options
        });
        return this._rtWrapper;
    }
    /**
     * The effect that is created when initializing the post process.
     * @returns The created effect corresponding the postprocess.
     */ getEffect() {
        return this._drawWrapper.effect;
    }
    /**
     * @internal
     */ _setEffect(effect) {
        this._drawWrapper.effect = effect;
    }
    /**
     * Gets texture content (Use this function wisely as reading from a texture can be slow)
     * @returns an ArrayBufferView promise (Uint8Array or Float32Array)
     */ getContent() {
        if (this._contentData && this._frameId === this._contentUpdateId) return this._contentData;
        if (this._contentData) this._contentData.then((buffer)=>{
            this._contentData = this.readPixels(0, 0, buffer);
            this._contentUpdateId = this._frameId;
        });
        else {
            this._contentData = this.readPixels(0, 0);
            this._contentUpdateId = this._frameId;
        }
        return this._contentData;
    }
    _createIndexBuffer() {
        const engine = this._fullEngine;
        // Indices
        const indices = [];
        indices.push(0);
        indices.push(1);
        indices.push(2);
        indices.push(0);
        indices.push(2);
        indices.push(3);
        this._indexBuffer = engine.createIndexBuffer(indices);
    }
    /** @internal */ _rebuild() {
        const vb = this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind];
        if (vb) vb._rebuild();
        this._createIndexBuffer();
        if (this.refreshRate === (0, $gQtNK.RenderTargetTexture).REFRESHRATE_RENDER_ONCE) this.refreshRate = (0, $gQtNK.RenderTargetTexture).REFRESHRATE_RENDER_ONCE;
    }
    /**
     * Resets the texture in order to recreate its associated resources.
     * This can be called in case of context loss or if you change the shader code and need to regenerate the texture with the new code
     */ reset() {
        this._drawWrapper.effect?.dispose();
        this._drawWrapper.effect = null;
        this._cachedDefines = null;
    }
    _getDefines() {
        return "";
    }
    /**
     * Executes a function when the texture will be ready to be drawn.
     * @param func The callback to be used.
     */ executeWhenReady(func) {
        if (this.isReady()) {
            func(this);
            return;
        }
        const effect = this.getEffect();
        if (effect) effect.executeWhenCompiled(()=>{
            func(this);
        });
    }
    /**
     * Is the texture ready to be used ? (rendered at least once)
     * @returns true if ready, otherwise, false.
     */ isReady() {
        const engine = this._fullEngine;
        if (this.nodeMaterialSource) return this._drawWrapper.effect.isReady();
        if (!this._fragment) return false;
        if (this._fallbackTextureUsed) return true;
        if (!this._texture) return false;
        const defines = this._getDefines();
        if (this._drawWrapper.effect && defines === this._cachedDefines && this._drawWrapper.effect.isReady()) return true;
        const shaders = {
            vertex: "procedural",
            fragmentElement: this._fragment.fragmentElement,
            fragmentSource: this._fragment.fragmentSource,
            fragment: typeof this._fragment === "string" ? this._fragment : undefined
        };
        if (this._cachedDefines !== defines) {
            this._cachedDefines = defines;
            this._drawWrapper.effect = engine.createEffect(shaders, [
                (0, $b4i1f.VertexBuffer).PositionKind
            ], this._uniforms, this._samplers, defines, undefined, undefined, ()=>{
                this._rtWrapper?.dispose();
                this._rtWrapper = this._texture = null;
                if (this._fallbackTexture) {
                    this._texture = this._fallbackTexture._texture;
                    if (this._texture) this._texture.incrementReferences();
                }
                this._fallbackTextureUsed = true;
            });
        }
        return this._drawWrapper.effect.isReady();
    }
    /**
     * Resets the refresh counter of the texture and start bak from scratch.
     * Could be useful to regenerate the texture if it is setup to render only once.
     */ resetRefreshCounter() {
        this._currentRefreshId = -1;
    }
    /**
     * Set the fragment shader to use in order to render the texture.
     * @param fragment This can be set to a path (into the shader store) or to a json object containing a fragmentElement property.
     */ setFragment(fragment) {
        this._fragment = fragment;
    }
    /**
     * Define the refresh rate of the texture or the rendering frequency.
     * Use 0 to render just once, 1 to render on every frame, 2 to render every two frames and so on...
     */ get refreshRate() {
        return this._refreshRate;
    }
    set refreshRate(value) {
        this._refreshRate = value;
        this.resetRefreshCounter();
    }
    /** @internal */ _shouldRender() {
        if (!this.isEnabled || !this.isReady() || !this._texture) {
            if (this._texture) this._texture.isReady = false;
            return false;
        }
        if (this._fallbackTextureUsed) return false;
        if (this._currentRefreshId === -1) {
            // At least render once
            this._currentRefreshId = 1;
            this._frameId++;
            return true;
        }
        if (this.refreshRate === this._currentRefreshId) {
            this._currentRefreshId = 1;
            this._frameId++;
            return true;
        }
        this._currentRefreshId++;
        return false;
    }
    /**
     * Get the size the texture is rendering at.
     * @returns the size (on cube texture it is always squared)
     */ getRenderSize() {
        return this._size;
    }
    /**
     * Resize the texture to new value.
     * @param size Define the new size the texture should have
     * @param generateMipMaps Define whether the new texture should create mip maps
     */ resize(size, generateMipMaps) {
        if (this._fallbackTextureUsed || !this._rtWrapper || !this._texture) return;
        const isCube = this._texture.isCube;
        this._rtWrapper.dispose();
        const rtWrapper = this._createRtWrapper(isCube, size, generateMipMaps, this._textureType);
        this._texture = rtWrapper.texture;
        // Update properties
        this._size = size;
        this._generateMipMaps = generateMipMaps;
    }
    _checkUniform(uniformName) {
        if (this._uniforms.indexOf(uniformName) === -1) this._uniforms.push(uniformName);
    }
    /**
     * Set a texture in the shader program used to render.
     * @param name Define the name of the uniform samplers as defined in the shader
     * @param texture Define the texture to bind to this sampler
     * @returns the texture itself allowing "fluent" like uniform updates
     */ setTexture(name, texture) {
        if (this._samplers.indexOf(name) === -1) this._samplers.push(name);
        this._textures[name] = texture;
        return this;
    }
    /**
     * Set a float in the shader.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the texture itself allowing "fluent" like uniform updates
     */ setFloat(name, value) {
        this._checkUniform(name);
        this._floats[name] = value;
        return this;
    }
    /**
     * Set a int in the shader.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the texture itself allowing "fluent" like uniform updates
     */ setInt(name, value) {
        this._checkUniform(name);
        this._ints[name] = value;
        return this;
    }
    /**
     * Set an array of floats in the shader.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the texture itself allowing "fluent" like uniform updates
     */ setFloats(name, value) {
        this._checkUniform(name);
        this._floatsArrays[name] = value;
        return this;
    }
    /**
     * Set a vec3 in the shader from a Color3.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the texture itself allowing "fluent" like uniform updates
     */ setColor3(name, value) {
        this._checkUniform(name);
        this._colors3[name] = value;
        return this;
    }
    /**
     * Set a vec4 in the shader from a Color4.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the texture itself allowing "fluent" like uniform updates
     */ setColor4(name, value) {
        this._checkUniform(name);
        this._colors4[name] = value;
        return this;
    }
    /**
     * Set a vec2 in the shader from a Vector2.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the texture itself allowing "fluent" like uniform updates
     */ setVector2(name, value) {
        this._checkUniform(name);
        this._vectors2[name] = value;
        return this;
    }
    /**
     * Set a vec3 in the shader from a Vector3.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the texture itself allowing "fluent" like uniform updates
     */ setVector3(name, value) {
        this._checkUniform(name);
        this._vectors3[name] = value;
        return this;
    }
    /**
     * Set a mat4 in the shader from a MAtrix.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the texture itself allowing "fluent" like uniform updates
     */ setMatrix(name, value) {
        this._checkUniform(name);
        this._matrices[name] = value;
        return this;
    }
    /**
     * Render the texture to its associated render target.
     * @param useCameraPostProcess Define if camera post process should be applied to the texture
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    render(useCameraPostProcess) {
        const scene = this.getScene();
        if (!scene) return;
        const engine = this._fullEngine;
        // Render
        engine.enableEffect(this._drawWrapper);
        this.onBeforeGenerationObservable.notifyObservers(this);
        engine.setState(false);
        if (!this.nodeMaterialSource) {
            // Texture
            for(const name in this._textures)this._drawWrapper.effect.setTexture(name, this._textures[name]);
            // Float
            for(const name in this._ints)this._drawWrapper.effect.setInt(name, this._ints[name]);
            // Float
            for(const name in this._floats)this._drawWrapper.effect.setFloat(name, this._floats[name]);
            // Floats
            for(const name in this._floatsArrays)this._drawWrapper.effect.setArray(name, this._floatsArrays[name]);
            // Color3
            for(const name in this._colors3)this._drawWrapper.effect.setColor3(name, this._colors3[name]);
            // Color4
            for(const name in this._colors4){
                const color = this._colors4[name];
                this._drawWrapper.effect.setFloat4(name, color.r, color.g, color.b, color.a);
            }
            // Vector2
            for(const name in this._vectors2)this._drawWrapper.effect.setVector2(name, this._vectors2[name]);
            // Vector3
            for(const name in this._vectors3)this._drawWrapper.effect.setVector3(name, this._vectors3[name]);
            // Matrix
            for(const name in this._matrices)this._drawWrapper.effect.setMatrix(name, this._matrices[name]);
        }
        if (!this._texture || !this._rtWrapper) return;
        engine._debugPushGroup?.(`procedural texture generation for ${this.name}`, 1);
        const viewPort = engine.currentViewport;
        if (this.isCube) for(let face = 0; face < 6; face++){
            engine.bindFramebuffer(this._rtWrapper, face, undefined, undefined, true);
            // VBOs
            engine.bindBuffers(this._vertexBuffers, this._indexBuffer, this._drawWrapper.effect);
            this._drawWrapper.effect.setFloat("face", face);
            // Clear
            if (this.autoClear) engine.clear(scene.clearColor, true, false, false);
            // Draw order
            engine.drawElementsType((0, $54229.Material).TriangleFillMode, 0, 6);
        }
        else {
            engine.bindFramebuffer(this._rtWrapper, 0, undefined, undefined, true);
            // VBOs
            engine.bindBuffers(this._vertexBuffers, this._indexBuffer, this._drawWrapper.effect);
            // Clear
            if (this.autoClear) engine.clear(scene.clearColor, true, false, false);
            // Draw order
            engine.drawElementsType((0, $54229.Material).TriangleFillMode, 0, 6);
        }
        // Unbind and restore viewport
        engine.unBindFramebuffer(this._rtWrapper, this.isCube);
        if (viewPort) engine.setViewport(viewPort);
        // Mipmaps
        if (this.isCube) engine.generateMipMapsForCubemap(this._texture);
        engine._debugPopGroup?.(1);
        if (this.onGenerated) this.onGenerated();
        this.onGeneratedObservable.notifyObservers(this);
    }
    /**
     * Clone the texture.
     * @returns the cloned texture
     */ clone() {
        const textureSize = this.getSize();
        const newTexture = new $82a6b5c7589d466c$export$f727015479027316(this.name, textureSize.width, this._fragment, this.getScene(), this._fallbackTexture, this._generateMipMaps);
        // Base texture
        newTexture.hasAlpha = this.hasAlpha;
        newTexture.level = this.level;
        // RenderTarget Texture
        newTexture.coordinatesMode = this.coordinatesMode;
        return newTexture;
    }
    /**
     * Dispose the texture and release its associated resources.
     */ dispose() {
        const scene = this.getScene();
        if (!scene) return;
        const index = scene.proceduralTextures.indexOf(this);
        if (index >= 0) scene.proceduralTextures.splice(index, 1);
        const vertexBuffer = this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind];
        if (vertexBuffer) {
            vertexBuffer.dispose();
            this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind] = null;
        }
        if (this._indexBuffer && this._fullEngine._releaseBuffer(this._indexBuffer)) this._indexBuffer = null;
        this.onGeneratedObservable.clear();
        this.onBeforeGenerationObservable.clear();
        super.dispose();
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $82a6b5c7589d466c$export$f727015479027316.prototype, "isEnabled", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $82a6b5c7589d466c$export$f727015479027316.prototype, "autoClear", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $82a6b5c7589d466c$export$f727015479027316.prototype, "_generateMipMaps", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $82a6b5c7589d466c$export$f727015479027316.prototype, "_size", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $82a6b5c7589d466c$export$f727015479027316.prototype, "refreshRate", null);
(0, $8DoUR.RegisterClass)("BABYLON.ProceduralTexture", $82a6b5c7589d466c$export$f727015479027316);

});
parcelRegister("gQtNK", function(module, exports) {

$parcel$export(module.exports, "RenderTargetTexture", () => $c4389e997f107173$export$3b9cb0a05fe91e82);

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $j2mX5 = parcelRequire("j2mX5");

var $8MhbJ = parcelRequire("8MhbJ");

var $jJNg8 = parcelRequire("jJNg8");
parcelRequire("4PdZs");
parcelRequire("gfE2b");

var $5YkyR = parcelRequire("5YkyR");

var $opFp4 = parcelRequire("opFp4");

var $4dKnp = parcelRequire("4dKnp");
class $c4389e997f107173$export$3b9cb0a05fe91e82 extends (0, $j2mX5.Texture) {
    /**
     * Use this list to define the list of mesh you want to render.
     */ get renderList() {
        return this._renderList;
    }
    set renderList(value) {
        if (this._unObserveRenderList) {
            this._unObserveRenderList();
            this._unObserveRenderList = null;
        }
        if (value) this._unObserveRenderList = (0, $opFp4._ObserveArray)(value, this._renderListHasChanged);
        this._renderList = value;
    }
    /**
     * Post-processes for this render target
     */ get postProcesses() {
        return this._postProcesses;
    }
    get _prePassEnabled() {
        return !!this._prePassRenderTarget && this._prePassRenderTarget.enabled;
    }
    /**
     * Set a after unbind callback in the texture.
     * This has been kept for backward compatibility and use of onAfterUnbindObservable is recommended.
     */ set onAfterUnbind(callback) {
        if (this._onAfterUnbindObserver) this.onAfterUnbindObservable.remove(this._onAfterUnbindObserver);
        this._onAfterUnbindObserver = this.onAfterUnbindObservable.add(callback);
    }
    /**
     * Set a before render callback in the texture.
     * This has been kept for backward compatibility and use of onBeforeRenderObservable is recommended.
     */ set onBeforeRender(callback) {
        if (this._onBeforeRenderObserver) this.onBeforeRenderObservable.remove(this._onBeforeRenderObserver);
        this._onBeforeRenderObserver = this.onBeforeRenderObservable.add(callback);
    }
    /**
     * Set a after render callback in the texture.
     * This has been kept for backward compatibility and use of onAfterRenderObservable is recommended.
     */ set onAfterRender(callback) {
        if (this._onAfterRenderObserver) this.onAfterRenderObservable.remove(this._onAfterRenderObserver);
        this._onAfterRenderObserver = this.onAfterRenderObservable.add(callback);
    }
    /**
     * Set a clear callback in the texture.
     * This has been kept for backward compatibility and use of onClearObservable is recommended.
     */ set onClear(callback) {
        if (this._onClearObserver) this.onClearObservable.remove(this._onClearObserver);
        this._onClearObserver = this.onClearObservable.add(callback);
    }
    /**
     * Gets the render pass ids used by the render target texture. For a single render target the array length will be 1, for a cube texture it will be 6 and for
     * a 2D texture array it will return an array of ids the size of the 2D texture array
     */ get renderPassIds() {
        return this._renderPassIds;
    }
    /**
     * Gets the current value of the refreshId counter
     */ get currentRefreshId() {
        return this._currentRefreshId;
    }
    /**
     * Sets a specific material to be used to render a mesh/a list of meshes in this render target texture
     * @param mesh mesh or array of meshes
     * @param material material or array of materials to use for this render pass. If undefined is passed, no specific material will be used but the regular material instead (mesh.material). It's possible to provide an array of materials to use a different material for each rendering in the case of a cube texture (6 rendering) and a 2D texture array (as many rendering as the length of the array)
     */ setMaterialForRendering(mesh, material) {
        let meshes;
        if (!Array.isArray(mesh)) meshes = [
            mesh
        ];
        else meshes = mesh;
        for(let j = 0; j < meshes.length; ++j)for(let i = 0; i < this._renderPassIds.length; ++i)meshes[j].setMaterialForRenderPass(this._renderPassIds[i], material !== undefined ? Array.isArray(material) ? material[i] : material : undefined);
    }
    /**
     * Define if the texture has multiple draw buffers or if false a single draw buffer.
     */ get isMulti() {
        return this._renderTarget?.isMulti ?? false;
    }
    /**
     * Gets render target creation options that were used.
     */ get renderTargetOptions() {
        return this._renderTargetOptions;
    }
    /**
     * Gets the render target wrapper associated with this render target
     */ get renderTarget() {
        return this._renderTarget;
    }
    _onRatioRescale() {
        if (this._sizeRatio) this.resize(this._initialSizeParameter);
    }
    /**
     * Gets or sets the size of the bounding box associated with the texture (when in cube mode)
     * When defined, the cubemap will switch to local mode
     * @see https://community.arm.com/graphics/b/blog/posts/reflections-based-on-local-cubemaps-in-unity
     * @example https://www.babylonjs-playground.com/#RNASML
     */ set boundingBoxSize(value) {
        if (this._boundingBoxSize && this._boundingBoxSize.equals(value)) return;
        this._boundingBoxSize = value;
        const scene = this.getScene();
        if (scene) scene.markAllMaterialsAsDirty(1);
    }
    get boundingBoxSize() {
        return this._boundingBoxSize;
    }
    /**
     * In case the RTT has been created with a depth texture, get the associated
     * depth texture.
     * Otherwise, return null.
     */ get depthStencilTexture() {
        return this._renderTarget?._depthStencilTexture ?? null;
    }
    /** @internal */ constructor(name, size, scene, generateMipMaps = false, doNotChangeAspectRatio = true, type = 0, isCube = false, samplingMode = (0, $j2mX5.Texture).TRILINEAR_SAMPLINGMODE, generateDepthBuffer = true, generateStencilBuffer = false, isMulti = false, format = 5, delayAllocation = false, samples, creationFlags, noColorAttachment = false, useSRGBBuffer = false){
        let colorAttachment = undefined;
        let gammaSpace = true;
        if (typeof generateMipMaps === "object") {
            const options = generateMipMaps;
            generateMipMaps = !!options.generateMipMaps;
            doNotChangeAspectRatio = options.doNotChangeAspectRatio ?? true;
            type = options.type ?? 0;
            isCube = !!options.isCube;
            samplingMode = options.samplingMode ?? (0, $j2mX5.Texture).TRILINEAR_SAMPLINGMODE;
            generateDepthBuffer = options.generateDepthBuffer ?? true;
            generateStencilBuffer = !!options.generateStencilBuffer;
            isMulti = !!options.isMulti;
            format = options.format ?? 5;
            delayAllocation = !!options.delayAllocation;
            samples = options.samples;
            creationFlags = options.creationFlags;
            noColorAttachment = !!options.noColorAttachment;
            useSRGBBuffer = !!options.useSRGBBuffer;
            colorAttachment = options.colorAttachment;
            gammaSpace = options.gammaSpace ?? gammaSpace;
        }
        super(null, scene, !generateMipMaps, undefined, samplingMode, undefined, undefined, undefined, undefined, format);
        this._unObserveRenderList = null;
        this._renderListHasChanged = (_functionName, previousLength)=>{
            const newLength = this._renderList ? this._renderList.length : 0;
            if (previousLength === 0 && newLength > 0 || newLength === 0) this.getScene()?.meshes.forEach((mesh)=>{
                mesh._markSubMeshesAsLightDirty();
            });
        };
        /**
         * Define if particles should be rendered in your texture.
         */ this.renderParticles = true;
        /**
         * Define if sprites should be rendered in your texture.
         */ this.renderSprites = false;
        /**
         * Force checking the layerMask property even if a custom list of meshes is provided (ie. if renderList is not undefined)
         */ this.forceLayerMaskCheck = false;
        /**
         * Define if the camera viewport should be respected while rendering the texture or if the render should be done to the entire texture.
         */ this.ignoreCameraViewport = false;
        /**
         * An event triggered when the texture is unbind.
         */ this.onBeforeBindObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the texture is unbind.
         */ this.onAfterUnbindObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered before rendering the texture
         */ this.onBeforeRenderObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered after rendering the texture
         */ this.onAfterRenderObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered after the texture clear
         */ this.onClearObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the texture is resized.
         */ this.onResizeObservable = new (0, $diGQf.Observable)();
        /** @internal */ this._cleared = false;
        /**
         * Skip the initial clear of the rtt at the beginning of the frame render loop
         */ this.skipInitialClear = false;
        this._currentRefreshId = -1;
        this._refreshRate = 1;
        this._samples = 1;
        this._canRescale = true;
        this._renderTarget = null;
        /**
         * Gets or sets the center of the bounding box associated with the texture (when in cube mode)
         * It must define where the camera used to render the texture is set
         */ this.boundingBoxPosition = (0, $ha1VO.Vector3).Zero();
        scene = this.getScene();
        if (!scene) return;
        const engine = this.getScene().getEngine();
        this._gammaSpace = gammaSpace;
        this._coordinatesMode = (0, $j2mX5.Texture).PROJECTION_MODE;
        this.renderList = [];
        this.name = name;
        this.isRenderTarget = true;
        this._initialSizeParameter = size;
        this._renderPassIds = [];
        this._isCubeData = isCube;
        this._processSizeParameter(size);
        this.renderPassId = this._renderPassIds[0];
        this._resizeObserver = engine.onResizeObservable.add(()=>{});
        this._generateMipMaps = generateMipMaps ? true : false;
        this._doNotChangeAspectRatio = doNotChangeAspectRatio;
        // Rendering groups
        this._renderingManager = new (0, $jJNg8.RenderingManager)(scene);
        this._renderingManager._useSceneAutoClearSetup = true;
        if (isMulti) return;
        this._renderTargetOptions = {
            generateMipMaps: generateMipMaps,
            type: type,
            format: this._format ?? undefined,
            samplingMode: this.samplingMode,
            generateDepthBuffer: generateDepthBuffer,
            generateStencilBuffer: generateStencilBuffer,
            samples: samples,
            creationFlags: creationFlags,
            noColorAttachment: noColorAttachment,
            useSRGBBuffer: useSRGBBuffer,
            colorAttachment: colorAttachment,
            label: this.name
        };
        if (this.samplingMode === (0, $j2mX5.Texture).NEAREST_SAMPLINGMODE) {
            this.wrapU = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
            this.wrapV = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        }
        if (!delayAllocation) {
            if (isCube) {
                this._renderTarget = scene.getEngine().createRenderTargetCubeTexture(this.getRenderSize(), this._renderTargetOptions);
                this.coordinatesMode = (0, $j2mX5.Texture).INVCUBIC_MODE;
                this._textureMatrix = (0, $ha1VO.Matrix).Identity();
            } else this._renderTarget = scene.getEngine().createRenderTargetTexture(this._size, this._renderTargetOptions);
            this._texture = this._renderTarget.texture;
            if (samples !== undefined) this.samples = samples;
        }
    }
    /**
     * Creates a depth stencil texture.
     * This is only available in WebGL 2 or with the depth texture extension available.
     * @param comparisonFunction Specifies the comparison function to set on the texture. If 0 or undefined, the texture is not in comparison mode (default: 0)
     * @param bilinearFiltering Specifies whether or not bilinear filtering is enable on the texture (default: true)
     * @param generateStencil Specifies whether or not a stencil should be allocated in the texture (default: false)
     * @param samples sample count of the depth/stencil texture (default: 1)
     * @param format format of the depth texture (default: 14)
     */ createDepthStencilTexture(comparisonFunction = 0, bilinearFiltering = true, generateStencil = false, samples = 1, format = 14) {
        this._renderTarget?.createDepthStencilTexture(comparisonFunction, bilinearFiltering, generateStencil, samples, format);
    }
    _releaseRenderPassId() {
        if (this._scene) {
            const engine = this._scene.getEngine();
            for(let i = 0; i < this._renderPassIds.length; ++i)engine.releaseRenderPassId(this._renderPassIds[i]);
        }
        this._renderPassIds = [];
    }
    _createRenderPassId() {
        this._releaseRenderPassId();
        const engine = this._scene.getEngine(); // scene can't be null in a RenderTargetTexture, see constructor
        const numPasses = this._isCubeData ? 6 : this.getRenderLayers() || 1;
        for(let i = 0; i < numPasses; ++i)this._renderPassIds[i] = engine.createRenderPassId(`RenderTargetTexture - ${this.name}#${i}`);
    }
    _processSizeParameter(size, createRenderPassIds = true) {
        if (size.ratio) {
            this._sizeRatio = size.ratio;
            const engine = this._getEngine();
            this._size = {
                width: this._bestReflectionRenderTargetDimension(engine.getRenderWidth(), this._sizeRatio),
                height: this._bestReflectionRenderTargetDimension(engine.getRenderHeight(), this._sizeRatio)
            };
        } else this._size = size;
        if (createRenderPassIds) this._createRenderPassId();
    }
    /**
     * Define the number of samples to use in case of MSAA.
     * It defaults to one meaning no MSAA has been enabled.
     */ get samples() {
        return this._renderTarget?.samples ?? this._samples;
    }
    set samples(value) {
        if (this._renderTarget) this._samples = this._renderTarget.setSamples(value);
    }
    /**
     * Resets the refresh counter of the texture and start bak from scratch.
     * Could be useful to regenerate the texture if it is setup to render only once.
     */ resetRefreshCounter() {
        this._currentRefreshId = -1;
    }
    /**
     * Define the refresh rate of the texture or the rendering frequency.
     * Use 0 to render just once, 1 to render on every frame, 2 to render every two frames and so on...
     */ get refreshRate() {
        return this._refreshRate;
    }
    set refreshRate(value) {
        this._refreshRate = value;
        this.resetRefreshCounter();
    }
    /**
     * Adds a post process to the render target rendering passes.
     * @param postProcess define the post process to add
     */ addPostProcess(postProcess) {
        if (!this._postProcessManager) {
            const scene = this.getScene();
            if (!scene) return;
            this._postProcessManager = new (0, $8MhbJ.PostProcessManager)(scene);
            this._postProcesses = new Array();
        }
        this._postProcesses.push(postProcess);
        this._postProcesses[0].autoClear = false;
    }
    /**
     * Clear all the post processes attached to the render target
     * @param dispose define if the cleared post processes should also be disposed (false by default)
     */ clearPostProcesses(dispose = false) {
        if (!this._postProcesses) return;
        if (dispose) for (const postProcess of this._postProcesses)postProcess.dispose();
        this._postProcesses = [];
    }
    /**
     * Remove one of the post process from the list of attached post processes to the texture
     * @param postProcess define the post process to remove from the list
     */ removePostProcess(postProcess) {
        if (!this._postProcesses) return;
        const index = this._postProcesses.indexOf(postProcess);
        if (index === -1) return;
        this._postProcesses.splice(index, 1);
        if (this._postProcesses.length > 0) this._postProcesses[0].autoClear = false;
    }
    /** @internal */ _shouldRender() {
        if (this._currentRefreshId === -1) {
            // At least render once
            this._currentRefreshId = 1;
            return true;
        }
        if (this.refreshRate === this._currentRefreshId) {
            this._currentRefreshId = 1;
            return true;
        }
        this._currentRefreshId++;
        return false;
    }
    /**
     * Gets the actual render size of the texture.
     * @returns the width of the render size
     */ getRenderSize() {
        return this.getRenderWidth();
    }
    /**
     * Gets the actual render width of the texture.
     * @returns the width of the render size
     */ getRenderWidth() {
        if (this._size.width) return this._size.width;
        return this._size;
    }
    /**
     * Gets the actual render height of the texture.
     * @returns the height of the render size
     */ getRenderHeight() {
        if (this._size.width) return this._size.height;
        return this._size;
    }
    /**
     * Gets the actual number of layers of the texture.
     * @returns the number of layers
     */ getRenderLayers() {
        const layers = this._size.layers;
        if (layers) return layers;
        return 0;
    }
    /**
     * Don't allow this render target texture to rescale. Mainly used to prevent rescaling by the scene optimizer.
     */ disableRescaling() {
        this._canRescale = false;
    }
    /**
     * Get if the texture can be rescaled or not.
     */ get canRescale() {
        return this._canRescale;
    }
    /**
     * Resize the texture using a ratio.
     * @param ratio the ratio to apply to the texture size in order to compute the new target size
     */ scale(ratio) {
        const newSize = Math.max(1, this.getRenderSize() * ratio);
        this.resize(newSize);
    }
    /**
     * Get the texture reflection matrix used to rotate/transform the reflection.
     * @returns the reflection matrix
     */ getReflectionTextureMatrix() {
        if (this.isCube) return this._textureMatrix;
        return super.getReflectionTextureMatrix();
    }
    /**
     * Resize the texture to a new desired size.
     * Be careful as it will recreate all the data in the new texture.
     * @param size Define the new size. It can be:
     *   - a number for squared texture,
     *   - an object containing { width: number, height: number }
     *   - or an object containing a ratio { ratio: number }
     */ resize(size) {
        const wasCube = this.isCube;
        this._renderTarget?.dispose();
        this._renderTarget = null;
        const scene = this.getScene();
        if (!scene) return;
        this._processSizeParameter(size, false);
        if (wasCube) this._renderTarget = scene.getEngine().createRenderTargetCubeTexture(this.getRenderSize(), this._renderTargetOptions);
        else this._renderTarget = scene.getEngine().createRenderTargetTexture(this._size, this._renderTargetOptions);
        this._texture = this._renderTarget.texture;
        if (this._renderTargetOptions.samples !== undefined) this.samples = this._renderTargetOptions.samples;
        if (this.onResizeObservable.hasObservers()) this.onResizeObservable.notifyObservers(this);
    }
    /**
     * Renders all the objects from the render list into the texture.
     * @param useCameraPostProcess Define if camera post processes should be used during the rendering
     * @param dumpForDebug Define if the rendering result should be dumped (copied) for debugging purpose
     */ render(useCameraPostProcess = false, dumpForDebug = false) {
        this._render(useCameraPostProcess, dumpForDebug);
    }
    /**
     * This function will check if the render target texture can be rendered (textures are loaded, shaders are compiled)
     * @returns true if all required resources are ready
     */ isReadyForRendering() {
        return this._render(false, false, true);
    }
    _render(useCameraPostProcess = false, dumpForDebug = false, checkReadiness = false) {
        const scene = this.getScene();
        if (!scene) return checkReadiness;
        const engine = scene.getEngine();
        if (this.useCameraPostProcesses !== undefined) useCameraPostProcess = this.useCameraPostProcesses;
        if (this._waitingRenderList) {
            if (!this.renderListPredicate) {
                this.renderList = [];
                for(let index = 0; index < this._waitingRenderList.length; index++){
                    const id = this._waitingRenderList[index];
                    const mesh = scene.getMeshById(id);
                    if (mesh) this.renderList.push(mesh);
                }
            }
            this._waitingRenderList = undefined;
        }
        // Is predicate defined?
        if (this.renderListPredicate) {
            if (this.renderList) this.renderList.length = 0; // Clear previous renderList
            else this.renderList = [];
            const scene = this.getScene();
            if (!scene) return checkReadiness;
            const sceneMeshes = scene.meshes;
            for(let index = 0; index < sceneMeshes.length; index++){
                const mesh = sceneMeshes[index];
                if (this.renderListPredicate(mesh)) this.renderList.push(mesh);
            }
        }
        const currentRenderPassId = engine.currentRenderPassId;
        this.onBeforeBindObservable.notifyObservers(this);
        // Set custom projection.
        // Needs to be before binding to prevent changing the aspect ratio.
        const camera = this.activeCamera ?? scene.activeCamera;
        const sceneCamera = scene.activeCamera;
        if (camera) {
            if (camera !== scene.activeCamera) {
                scene.setTransformMatrix(camera.getViewMatrix(), camera.getProjectionMatrix(true));
                scene.activeCamera = camera;
            }
            engine.setViewport(camera.rigParent ? camera.rigParent.viewport : camera.viewport, this.getRenderWidth(), this.getRenderHeight());
        }
        this._defaultRenderListPrepared = false;
        let returnValue = checkReadiness;
        if (!checkReadiness) {
            if (this.is2DArray && !this.isMulti) for(let layer = 0; layer < this.getRenderLayers(); layer++){
                this._renderToTarget(0, useCameraPostProcess, dumpForDebug, layer, camera);
                scene.incrementRenderId();
                scene.resetCachedMaterial();
            }
            else if (this.isCube && !this.isMulti) for(let face = 0; face < 6; face++){
                this._renderToTarget(face, useCameraPostProcess, dumpForDebug, undefined, camera);
                scene.incrementRenderId();
                scene.resetCachedMaterial();
            }
            else this._renderToTarget(0, useCameraPostProcess, dumpForDebug, undefined, camera);
        } else {
            if (!scene.getViewMatrix()) // We probably didn't execute scene.render() yet, so make sure we have a view/projection matrix setup for the scene
            scene.updateTransformMatrix();
            const numLayers = this.is2DArray ? this.getRenderLayers() : this.isCube ? 6 : 1;
            for(let layer = 0; layer < numLayers && returnValue; layer++){
                let currentRenderList = null;
                const defaultRenderList = this.renderList ? this.renderList : scene.getActiveMeshes().data;
                const defaultRenderListLength = this.renderList ? this.renderList.length : scene.getActiveMeshes().length;
                engine.currentRenderPassId = this._renderPassIds[layer];
                this.onBeforeRenderObservable.notifyObservers(layer);
                if (this.getCustomRenderList) currentRenderList = this.getCustomRenderList(layer, defaultRenderList, defaultRenderListLength);
                if (!currentRenderList) currentRenderList = defaultRenderList;
                if (!this._doNotChangeAspectRatio) scene.updateTransformMatrix(true);
                for(let i = 0; i < currentRenderList.length && returnValue; ++i){
                    const mesh = currentRenderList[i];
                    if (!mesh.isEnabled() || mesh.isBlocked || !mesh.isVisible || !mesh.subMeshes) continue;
                    if (this.customIsReadyFunction) {
                        if (!this.customIsReadyFunction(mesh, this.refreshRate, checkReadiness)) {
                            returnValue = false;
                            continue;
                        }
                    } else if (!mesh.isReady(true)) {
                        returnValue = false;
                        continue;
                    }
                }
                this.onAfterRenderObservable.notifyObservers(layer);
                if (this.is2DArray || this.isCube) {
                    scene.incrementRenderId();
                    scene.resetCachedMaterial();
                }
            }
        }
        this.onAfterUnbindObservable.notifyObservers(this);
        engine.currentRenderPassId = currentRenderPassId;
        if (sceneCamera) {
            scene.activeCamera = sceneCamera;
            if (this.activeCamera && this.activeCamera !== scene.activeCamera) scene.setTransformMatrix(scene.activeCamera.getViewMatrix(), scene.activeCamera.getProjectionMatrix(true));
            engine.setViewport(scene.activeCamera.viewport);
        }
        scene.resetCachedMaterial();
        return returnValue;
    }
    _bestReflectionRenderTargetDimension(renderDimension, scale) {
        const minimum = 128;
        const x = renderDimension * scale;
        const curved = (0, $5YkyR.Engine).NearestPOT(x + minimum * minimum / (minimum + x));
        // Ensure we don't exceed the render dimension (while staying POT)
        return Math.min((0, $5YkyR.Engine).FloorPOT(renderDimension), curved);
    }
    _prepareRenderingManager(currentRenderList, currentRenderListLength, camera, checkLayerMask) {
        const scene = this.getScene();
        if (!scene) return;
        this._renderingManager.reset();
        const sceneRenderId = scene.getRenderId();
        for(let meshIndex = 0; meshIndex < currentRenderListLength; meshIndex++){
            const mesh = currentRenderList[meshIndex];
            if (mesh && !mesh.isBlocked) {
                if (this.customIsReadyFunction) {
                    if (!this.customIsReadyFunction(mesh, this.refreshRate, false)) {
                        this.resetRefreshCounter();
                        continue;
                    }
                } else if (!mesh.isReady(this.refreshRate === 0)) {
                    this.resetRefreshCounter();
                    continue;
                }
                if (!mesh._internalAbstractMeshDataInfo._currentLODIsUpToDate && scene.activeCamera) {
                    mesh._internalAbstractMeshDataInfo._currentLOD = scene.customLODSelector ? scene.customLODSelector(mesh, this.activeCamera || scene.activeCamera) : mesh.getLOD(this.activeCamera || scene.activeCamera);
                    mesh._internalAbstractMeshDataInfo._currentLODIsUpToDate = true;
                }
                if (!mesh._internalAbstractMeshDataInfo._currentLOD) continue;
                let meshToRender = mesh._internalAbstractMeshDataInfo._currentLOD;
                meshToRender._preActivateForIntermediateRendering(sceneRenderId);
                let isMasked;
                if (checkLayerMask && camera) isMasked = (mesh.layerMask & camera.layerMask) === 0;
                else isMasked = false;
                if (mesh.isEnabled() && mesh.isVisible && mesh.subMeshes && !isMasked) {
                    if (meshToRender !== mesh) meshToRender._activate(sceneRenderId, true);
                    if (mesh._activate(sceneRenderId, true) && mesh.subMeshes.length) {
                        if (!mesh.isAnInstance) meshToRender._internalAbstractMeshDataInfo._onlyForInstancesIntermediate = false;
                        else if (mesh._internalAbstractMeshDataInfo._actAsRegularMesh) meshToRender = mesh;
                        meshToRender._internalAbstractMeshDataInfo._isActiveIntermediate = true;
                        for(let subIndex = 0; subIndex < meshToRender.subMeshes.length; subIndex++){
                            const subMesh = meshToRender.subMeshes[subIndex];
                            this._renderingManager.dispatch(subMesh, meshToRender);
                        }
                    }
                }
            }
        }
        for(let particleIndex = 0; particleIndex < scene.particleSystems.length; particleIndex++){
            const particleSystem = scene.particleSystems[particleIndex];
            const emitter = particleSystem.emitter;
            if (!particleSystem.isStarted() || !emitter || emitter.position && !emitter.isEnabled()) continue;
            this._renderingManager.dispatchParticles(particleSystem);
        }
    }
    /**
     * @internal
     * @param faceIndex face index to bind to if this is a cubetexture
     * @param layer defines the index of the texture to bind in the array
     */ _bindFrameBuffer(faceIndex = 0, layer = 0) {
        const scene = this.getScene();
        if (!scene) return;
        const engine = scene.getEngine();
        if (this._renderTarget) engine.bindFramebuffer(this._renderTarget, this.isCube ? faceIndex : undefined, undefined, undefined, this.ignoreCameraViewport, 0, layer);
    }
    _unbindFrameBuffer(engine, faceIndex) {
        if (!this._renderTarget) return;
        engine.unBindFramebuffer(this._renderTarget, this.isCube, ()=>{
            this.onAfterRenderObservable.notifyObservers(faceIndex);
        });
    }
    /**
     * @internal
     */ _prepareFrame(scene, faceIndex, layer, useCameraPostProcess) {
        if (this._postProcessManager) {
            if (!this._prePassEnabled) this._postProcessManager._prepareFrame(this._texture, this._postProcesses);
        } else if (!useCameraPostProcess || !scene.postProcessManager._prepareFrame(this._texture)) this._bindFrameBuffer(faceIndex, layer);
    }
    _renderToTarget(faceIndex, useCameraPostProcess, dumpForDebug, layer = 0, camera = null) {
        const scene = this.getScene();
        if (!scene) return;
        const engine = scene.getEngine();
        engine._debugPushGroup?.(`render to face #${faceIndex} layer #${layer}`, 1);
        // Bind
        this._prepareFrame(scene, faceIndex, layer, useCameraPostProcess);
        if (this.is2DArray) {
            engine.currentRenderPassId = this._renderPassIds[layer];
            this.onBeforeRenderObservable.notifyObservers(layer);
        } else {
            engine.currentRenderPassId = this._renderPassIds[faceIndex];
            this.onBeforeRenderObservable.notifyObservers(faceIndex);
        }
        const fastPath = engine.snapshotRendering && engine.snapshotRenderingMode === 1;
        if (!fastPath) {
            // Get the list of meshes to render
            let currentRenderList = null;
            const defaultRenderList = this.renderList ? this.renderList : scene.getActiveMeshes().data;
            const defaultRenderListLength = this.renderList ? this.renderList.length : scene.getActiveMeshes().length;
            if (this.getCustomRenderList) currentRenderList = this.getCustomRenderList(this.is2DArray ? layer : faceIndex, defaultRenderList, defaultRenderListLength);
            if (!currentRenderList) {
                // No custom render list provided, we prepare the rendering for the default list, but check
                // first if we did not already performed the preparation before so as to avoid re-doing it several times
                if (!this._defaultRenderListPrepared) {
                    this._prepareRenderingManager(defaultRenderList, defaultRenderListLength, camera, !this.renderList || this.forceLayerMaskCheck);
                    this._defaultRenderListPrepared = true;
                }
                currentRenderList = defaultRenderList;
            } else // Prepare the rendering for the custom render list provided
            this._prepareRenderingManager(currentRenderList, currentRenderList.length, camera, this.forceLayerMaskCheck);
            // Before clear
            for (const step of scene._beforeRenderTargetClearStage)step.action(this, faceIndex, layer);
            // Clear
            if (this.onClearObservable.hasObservers()) this.onClearObservable.notifyObservers(engine);
            else if (!this.skipInitialClear) engine.clear(this.clearColor || scene.clearColor, true, true, true);
            if (!this._doNotChangeAspectRatio) scene.updateTransformMatrix(true);
            // Before Camera Draw
            for (const step of scene._beforeRenderTargetDrawStage)step.action(this, faceIndex, layer);
            // Render
            this._renderingManager.render(this.customRenderFunction, currentRenderList, this.renderParticles, this.renderSprites);
            // After Camera Draw
            for (const step of scene._afterRenderTargetDrawStage)step.action(this, faceIndex, layer);
            const saveGenerateMipMaps = this._texture?.generateMipMaps ?? false;
            if (this._texture) this._texture.generateMipMaps = false; // if left true, the mipmaps will be generated (if this._texture.generateMipMaps = true) when the first post process binds its own RTT: by doing so it will unbind the current RTT,
            if (this._postProcessManager) this._postProcessManager._finalizeFrame(false, this._renderTarget ?? undefined, faceIndex, this._postProcesses, this.ignoreCameraViewport);
            else if (useCameraPostProcess) scene.postProcessManager._finalizeFrame(false, this._renderTarget ?? undefined, faceIndex);
            for (const step of scene._afterRenderTargetPostProcessStage)step.action(this, faceIndex, layer);
            if (this._texture) this._texture.generateMipMaps = saveGenerateMipMaps;
            if (!this._doNotChangeAspectRatio) scene.updateTransformMatrix(true);
            // Dump ?
            if (dumpForDebug) (0, $4dKnp.DumpTools).DumpFramebuffer(this.getRenderWidth(), this.getRenderHeight(), engine);
        } else {
            // Clear
            if (this.onClearObservable.hasObservers()) this.onClearObservable.notifyObservers(engine);
            else if (!this.skipInitialClear) engine.clear(this.clearColor || scene.clearColor, true, true, true);
        }
        // Unbind
        this._unbindFrameBuffer(engine, faceIndex);
        if (this._texture && this.isCube && faceIndex === 5) engine.generateMipMapsForCubemap(this._texture);
        engine._debugPopGroup?.(1);
    }
    /**
     * Overrides the default sort function applied in the rendering group to prepare the meshes.
     * This allowed control for front to back rendering or reversely depending of the special needs.
     *
     * @param renderingGroupId The rendering group id corresponding to its index
     * @param opaqueSortCompareFn The opaque queue comparison function use to sort.
     * @param alphaTestSortCompareFn The alpha test queue comparison function use to sort.
     * @param transparentSortCompareFn The transparent queue comparison function use to sort.
     */ setRenderingOrder(renderingGroupId, opaqueSortCompareFn = null, alphaTestSortCompareFn = null, transparentSortCompareFn = null) {
        this._renderingManager.setRenderingOrder(renderingGroupId, opaqueSortCompareFn, alphaTestSortCompareFn, transparentSortCompareFn);
    }
    /**
     * Specifies whether or not the stencil and depth buffer are cleared between two rendering groups.
     *
     * @param renderingGroupId The rendering group id corresponding to its index
     * @param autoClearDepthStencil Automatically clears depth and stencil between groups if true.
     */ setRenderingAutoClearDepthStencil(renderingGroupId, autoClearDepthStencil) {
        this._renderingManager.setRenderingAutoClearDepthStencil(renderingGroupId, autoClearDepthStencil);
        this._renderingManager._useSceneAutoClearSetup = false;
    }
    /**
     * Clones the texture.
     * @returns the cloned texture
     */ clone() {
        const textureSize = this.getSize();
        const newTexture = new $c4389e997f107173$export$3b9cb0a05fe91e82(this.name, textureSize, this.getScene(), this._renderTargetOptions.generateMipMaps, this._doNotChangeAspectRatio, this._renderTargetOptions.type, this.isCube, this._renderTargetOptions.samplingMode, this._renderTargetOptions.generateDepthBuffer, this._renderTargetOptions.generateStencilBuffer, undefined, this._renderTargetOptions.format, undefined, this._renderTargetOptions.samples);
        // Base texture
        newTexture.hasAlpha = this.hasAlpha;
        newTexture.level = this.level;
        // RenderTarget Texture
        newTexture.coordinatesMode = this.coordinatesMode;
        if (this.renderList) newTexture.renderList = this.renderList.slice(0);
        return newTexture;
    }
    /**
     * Serialize the texture to a JSON representation we can easily use in the respective Parse function.
     * @returns The JSON representation of the texture
     */ serialize() {
        if (!this.name) return null;
        const serializationObject = super.serialize();
        serializationObject.renderTargetSize = this.getRenderSize();
        serializationObject.renderList = [];
        if (this.renderList) for(let index = 0; index < this.renderList.length; index++)serializationObject.renderList.push(this.renderList[index].id);
        return serializationObject;
    }
    /**
     *  This will remove the attached framebuffer objects. The texture will not be able to be used as render target anymore
     */ disposeFramebufferObjects() {
        this._renderTarget?.dispose(true);
    }
    /**
     * Release and destroy the underlying lower level texture aka internalTexture.
     */ releaseInternalTexture() {
        this._renderTarget?.releaseTextures();
        this._texture = null;
    }
    /**
     * Dispose the texture and release its associated resources.
     */ dispose() {
        this.onResizeObservable.clear();
        this.onClearObservable.clear();
        this.onAfterRenderObservable.clear();
        this.onAfterUnbindObservable.clear();
        this.onBeforeBindObservable.clear();
        this.onBeforeRenderObservable.clear();
        if (this._postProcessManager) {
            this._postProcessManager.dispose();
            this._postProcessManager = null;
        }
        if (this._prePassRenderTarget) this._prePassRenderTarget.dispose();
        this._releaseRenderPassId();
        this.clearPostProcesses(true);
        if (this._resizeObserver) {
            this.getScene().getEngine().onResizeObservable.remove(this._resizeObserver);
            this._resizeObserver = null;
        }
        this.renderList = null;
        // Remove from custom render targets
        const scene = this.getScene();
        if (!scene) return;
        let index = scene.customRenderTargets.indexOf(this);
        if (index >= 0) scene.customRenderTargets.splice(index, 1);
        for (const camera of scene.cameras){
            index = camera.customRenderTargets.indexOf(this);
            if (index >= 0) camera.customRenderTargets.splice(index, 1);
        }
        this._renderTarget?.dispose();
        this._renderTarget = null;
        this._texture = null;
        super.dispose();
    }
    /** @internal */ _rebuild() {
        if (this.refreshRate === $c4389e997f107173$export$3b9cb0a05fe91e82.REFRESHRATE_RENDER_ONCE) this.refreshRate = $c4389e997f107173$export$3b9cb0a05fe91e82.REFRESHRATE_RENDER_ONCE;
        if (this._postProcessManager) this._postProcessManager._rebuild();
    }
    /**
     * Clear the info related to rendering groups preventing retention point in material dispose.
     */ freeRenderingGroups() {
        if (this._renderingManager) this._renderingManager.freeRenderingGroups();
    }
    /**
     * Gets the number of views the corresponding to the texture (eg. a MultiviewRenderTarget will have > 1)
     * @returns the view count
     */ getViewCount() {
        return 1;
    }
}
/**
 * The texture will only be rendered once which can be useful to improve performance if everything in your render is static for instance.
 */ $c4389e997f107173$export$3b9cb0a05fe91e82.REFRESHRATE_RENDER_ONCE = 0;
/**
 * The texture will only be rendered rendered every frame and is recommended for dynamic contents.
 */ $c4389e997f107173$export$3b9cb0a05fe91e82.REFRESHRATE_RENDER_ONEVERYFRAME = 1;
/**
 * The texture will be rendered every 2 frames which could be enough if your dynamic objects are not
 * the central point of your effect and can save a lot of performances.
 */ $c4389e997f107173$export$3b9cb0a05fe91e82.REFRESHRATE_RENDER_ONEVERYTWOFRAMES = 2;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
(0, $j2mX5.Texture)._CreateRenderTargetTexture = (name, renderTargetSize, scene, generateMipMaps, creationFlags)=>{
    return new $c4389e997f107173$export$3b9cb0a05fe91e82(name, renderTargetSize, scene, generateMipMaps);
};

});
parcelRegister("gfE2b", function(module, exports) {

var $b9e4a = parcelRequire("b9e4a");

var $kVtWi = parcelRequire("kVtWi");

var $2h5JR = parcelRequire("2h5JR");
(0, $2h5JR.ThinEngine).prototype.createRenderTargetCubeTexture = function(size, options) {
    const rtWrapper = this._createHardwareRenderTargetWrapper(false, true, size);
    const fullOptions = {
        generateMipMaps: true,
        generateDepthBuffer: true,
        generateStencilBuffer: false,
        type: 0,
        samplingMode: 3,
        format: 5,
        ...options
    };
    fullOptions.generateStencilBuffer = fullOptions.generateDepthBuffer && fullOptions.generateStencilBuffer;
    if (fullOptions.type === 1 && !this._caps.textureFloatLinearFiltering) // if floating point linear (gl.FLOAT) then force to NEAREST_SAMPLINGMODE
    fullOptions.samplingMode = 1;
    else if (fullOptions.type === 2 && !this._caps.textureHalfFloatLinearFiltering) // if floating point linear (HALF_FLOAT) then force to NEAREST_SAMPLINGMODE
    fullOptions.samplingMode = 1;
    const gl = this._gl;
    const texture = new (0, $b9e4a.InternalTexture)(this, (0, $b9e4a.InternalTextureSource).RenderTarget);
    this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, texture, true);
    const filters = this._getSamplingParameters(fullOptions.samplingMode, fullOptions.generateMipMaps);
    if (fullOptions.type === 1 && !this._caps.textureFloat) {
        fullOptions.type = 0;
        (0, $kVtWi.Logger).Warn("Float textures are not supported. Cube render target forced to TEXTURETYPE_UNESIGNED_BYTE type");
    }
    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAG_FILTER, filters.mag);
    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MIN_FILTER, filters.min);
    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    for(let face = 0; face < 6; face++)gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + face, 0, this._getRGBABufferInternalSizedFormat(fullOptions.type, fullOptions.format), size, size, 0, this._getInternalFormat(fullOptions.format), this._getWebGLTextureType(fullOptions.type), null);
    // Create the framebuffer
    const framebuffer = gl.createFramebuffer();
    this._bindUnboundFramebuffer(framebuffer);
    rtWrapper._depthStencilBuffer = this._setupFramebufferDepthAttachments(fullOptions.generateStencilBuffer, fullOptions.generateDepthBuffer, size, size);
    // MipMaps
    if (fullOptions.generateMipMaps) gl.generateMipmap(gl.TEXTURE_CUBE_MAP);
    // Unbind
    this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, null);
    this._bindUnboundFramebuffer(null);
    rtWrapper._framebuffer = framebuffer;
    rtWrapper._generateDepthBuffer = fullOptions.generateDepthBuffer;
    rtWrapper._generateStencilBuffer = fullOptions.generateStencilBuffer;
    texture.width = size;
    texture.height = size;
    texture.isReady = true;
    texture.isCube = true;
    texture.samples = 1;
    texture.generateMipMaps = fullOptions.generateMipMaps;
    texture.samplingMode = fullOptions.samplingMode;
    texture.type = fullOptions.type;
    texture.format = fullOptions.format;
    this._internalTexturesCache.push(texture);
    rtWrapper.setTextures(texture);
    return rtWrapper;
};

});

parcelRegister("4dKnp", function(module, exports) {

$parcel$export(module.exports, "DumpTools", () => $312c59b93536f656$export$552d5f6c588e840d);

var $2h5JR = parcelRequire("2h5JR");

var $iYGpr = parcelRequire("iYGpr");

var $bOhSV = parcelRequire("bOhSV");

var $dWQWp = parcelRequire("dWQWp");

var $1VEEL = parcelRequire("1VEEL");
class $312c59b93536f656$export$552d5f6c588e840d {
    static _CreateDumpRenderer() {
        if (!$312c59b93536f656$export$552d5f6c588e840d._DumpToolsEngine) {
            let canvas;
            let engine = null;
            const options = {
                preserveDrawingBuffer: true,
                depth: false,
                stencil: false,
                alpha: true,
                premultipliedAlpha: false,
                antialias: false,
                failIfMajorPerformanceCaveat: false
            };
            try {
                canvas = new OffscreenCanvas(100, 100); // will be resized later
                engine = new (0, $2h5JR.ThinEngine)(canvas, false, options);
            } catch (e) {
                // The browser either does not support OffscreenCanvas or WebGL context in OffscreenCanvas, fallback on a regular canvas
                canvas = document.createElement("canvas");
                engine = new (0, $2h5JR.ThinEngine)(canvas, false, options);
            }
            engine.getCaps().parallelShaderCompile = undefined;
            const renderer = new (0, $iYGpr.EffectRenderer)(engine);
            const wrapper = new (0, $iYGpr.EffectWrapper)({
                engine: engine,
                name: (0, $dWQWp.passPixelShader).name,
                fragmentShader: (0, $dWQWp.passPixelShader).shader,
                samplerNames: [
                    "textureSampler"
                ]
            });
            $312c59b93536f656$export$552d5f6c588e840d._DumpToolsEngine = {
                canvas: canvas,
                engine: engine,
                renderer: renderer,
                wrapper: wrapper
            };
        }
        return $312c59b93536f656$export$552d5f6c588e840d._DumpToolsEngine;
    }
    /**
     * Dumps the current bound framebuffer
     * @param width defines the rendering width
     * @param height defines the rendering height
     * @param engine defines the hosting engine
     * @param successCallback defines the callback triggered once the data are available
     * @param mimeType defines the mime type of the result
     * @param fileName defines the filename to download. If present, the result will automatically be downloaded
     * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
     * @returns a void promise
     */ static async DumpFramebuffer(width, height, engine, successCallback, mimeType = "image/png", fileName, quality) {
        // Read the contents of the framebuffer
        const bufferView = await engine.readPixels(0, 0, width, height);
        const data = new Uint8Array(bufferView.buffer);
        $312c59b93536f656$export$552d5f6c588e840d.DumpData(width, height, data, successCallback, mimeType, fileName, true, undefined, quality);
    }
    /**
     * Dumps an array buffer
     * @param width defines the rendering width
     * @param height defines the rendering height
     * @param data the data array
     * @param mimeType defines the mime type of the result
     * @param fileName defines the filename to download. If present, the result will automatically be downloaded
     * @param invertY true to invert the picture in the Y dimension
     * @param toArrayBuffer true to convert the data to an ArrayBuffer (encoded as `mimeType`) instead of a base64 string
     * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
     * @returns a promise that resolve to the final data
     */ static DumpDataAsync(width, height, data, mimeType = "image/png", fileName, invertY = false, toArrayBuffer = false, quality) {
        return new Promise((resolve)=>{
            $312c59b93536f656$export$552d5f6c588e840d.DumpData(width, height, data, (result)=>resolve(result), mimeType, fileName, invertY, toArrayBuffer, quality);
        });
    }
    /**
     * Dumps an array buffer
     * @param width defines the rendering width
     * @param height defines the rendering height
     * @param data the data array
     * @param successCallback defines the callback triggered once the data are available
     * @param mimeType defines the mime type of the result
     * @param fileName defines the filename to download. If present, the result will automatically be downloaded
     * @param invertY true to invert the picture in the Y dimension
     * @param toArrayBuffer true to convert the data to an ArrayBuffer (encoded as `mimeType`) instead of a base64 string
     * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
     */ static DumpData(width, height, data, successCallback, mimeType = "image/png", fileName, invertY = false, toArrayBuffer = false, quality) {
        const renderer = $312c59b93536f656$export$552d5f6c588e840d._CreateDumpRenderer();
        renderer.engine.setSize(width, height, true);
        // Convert if data are float32
        if (data instanceof Float32Array) {
            const data2 = new Uint8Array(data.length);
            let n = data.length;
            while(n--){
                const v = data[n];
                data2[n] = Math.round((0, $1VEEL.Scalar).Clamp(v) * 255);
            }
            data = data2;
        }
        // Create the image
        const texture = renderer.engine.createRawTexture(data, width, height, 5, false, !invertY, 1);
        renderer.renderer.setViewport();
        renderer.renderer.applyEffectWrapper(renderer.wrapper);
        renderer.wrapper.effect._bindTexture("textureSampler", texture);
        renderer.renderer.draw();
        if (toArrayBuffer) (0, $bOhSV.Tools).ToBlob(renderer.canvas, (blob)=>{
            const fileReader = new FileReader();
            fileReader.onload = (event)=>{
                const arrayBuffer = event.target.result;
                if (successCallback) successCallback(arrayBuffer);
            };
            fileReader.readAsArrayBuffer(blob);
        }, mimeType, quality);
        else (0, $bOhSV.Tools).EncodeScreenshotCanvasData(renderer.canvas, successCallback, mimeType, fileName, quality);
        texture.dispose();
    }
    /**
     * Dispose the dump tools associated resources
     */ static Dispose() {
        if ($312c59b93536f656$export$552d5f6c588e840d._DumpToolsEngine) {
            $312c59b93536f656$export$552d5f6c588e840d._DumpToolsEngine.wrapper.dispose();
            $312c59b93536f656$export$552d5f6c588e840d._DumpToolsEngine.renderer.dispose();
            $312c59b93536f656$export$552d5f6c588e840d._DumpToolsEngine.engine.dispose();
        }
        $312c59b93536f656$export$552d5f6c588e840d._DumpToolsEngine = null;
    }
}
/**
 * This will be executed automatically for UMD and es5.
 * If esm dev wants the side effects to execute they will have to run it manually
 * Once we build native modules those need to be exported.
 * @internal
 */ const $312c59b93536f656$var$initSideEffects = ()=>{
    // References the dependencies.
    (0, $bOhSV.Tools).DumpData = $312c59b93536f656$export$552d5f6c588e840d.DumpData;
    (0, $bOhSV.Tools).DumpDataAsync = $312c59b93536f656$export$552d5f6c588e840d.DumpDataAsync;
    (0, $bOhSV.Tools).DumpFramebuffer = $312c59b93536f656$export$552d5f6c588e840d.DumpFramebuffer;
};
$312c59b93536f656$var$initSideEffects();

});
parcelRegister("iYGpr", function(module, exports) {

$parcel$export(module.exports, "EffectRenderer", () => $dd0eba39da5b41c9$export$68f948415c5722f2);
$parcel$export(module.exports, "EffectWrapper", () => $dd0eba39da5b41c9$export$b901a4b52520d353);

var $b4i1f = parcelRequire("b4i1f");

var $191mA = parcelRequire("191mA");

var $diGQf = parcelRequire("diGQf");

var $lUDWq = parcelRequire("lUDWq");

var $hOyoX = parcelRequire("hOyoX");
parcelRequire("cr88r");
// Fullscreen quad buffers by default.
const $dd0eba39da5b41c9$var$defaultOptions = {
    positions: [
        1,
        1,
        -1,
        1,
        -1,
        -1,
        1,
        -1
    ],
    indices: [
        0,
        1,
        2,
        0,
        2,
        3
    ]
};
class $dd0eba39da5b41c9$export$68f948415c5722f2 {
    /**
     * Creates an effect renderer
     * @param engine the engine to use for rendering
     * @param options defines the options of the effect renderer
     */ constructor(engine, options = $dd0eba39da5b41c9$var$defaultOptions){
        this._fullscreenViewport = new (0, $191mA.Viewport)(0, 0, 1, 1);
        const positions = options.positions ?? $dd0eba39da5b41c9$var$defaultOptions.positions;
        const indices = options.indices ?? $dd0eba39da5b41c9$var$defaultOptions.indices;
        this.engine = engine;
        this._vertexBuffers = {
            [(0, $b4i1f.VertexBuffer).PositionKind]: new (0, $b4i1f.VertexBuffer)(engine, positions, (0, $b4i1f.VertexBuffer).PositionKind, false, false, 2)
        };
        this._indexBuffer = engine.createIndexBuffer(indices);
        this._onContextRestoredObserver = engine.onContextRestoredObservable.add(()=>{
            this._indexBuffer = engine.createIndexBuffer(indices);
            for(const key in this._vertexBuffers){
                const vertexBuffer = this._vertexBuffers[key];
                vertexBuffer._rebuild();
            }
        });
    }
    /**
     * Sets the current viewport in normalized coordinates 0-1
     * @param viewport Defines the viewport to set (defaults to 0 0 1 1)
     */ setViewport(viewport = this._fullscreenViewport) {
        this.engine.setViewport(viewport);
    }
    /**
     * Binds the embedded attributes buffer to the effect.
     * @param effect Defines the effect to bind the attributes for
     */ bindBuffers(effect) {
        this.engine.bindBuffers(this._vertexBuffers, this._indexBuffer, effect);
    }
    /**
     * Sets the current effect wrapper to use during draw.
     * The effect needs to be ready before calling this api.
     * This also sets the default full screen position attribute.
     * @param effectWrapper Defines the effect to draw with
     */ applyEffectWrapper(effectWrapper) {
        this.engine.setState(true);
        this.engine.depthCullingState.depthTest = false;
        this.engine.stencilState.stencilTest = false;
        this.engine.enableEffect(effectWrapper._drawWrapper);
        this.bindBuffers(effectWrapper.effect);
        effectWrapper.onApplyObservable.notifyObservers({});
    }
    /**
     * Saves engine states
     */ saveStates() {
        this._savedStateDepthTest = this.engine.depthCullingState.depthTest;
        this._savedStateStencilTest = this.engine.stencilState.stencilTest;
    }
    /**
     * Restores engine states
     */ restoreStates() {
        this.engine.depthCullingState.depthTest = this._savedStateDepthTest;
        this.engine.stencilState.stencilTest = this._savedStateStencilTest;
    }
    /**
     * Draws a full screen quad.
     */ draw() {
        this.engine.drawElementsType(0, 0, 6);
    }
    _isRenderTargetTexture(texture) {
        return texture.renderTarget !== undefined;
    }
    /**
     * renders one or more effects to a specified texture
     * @param effectWrapper the effect to renderer
     * @param outputTexture texture to draw to, if null it will render to the screen.
     */ render(effectWrapper, outputTexture = null) {
        // Ensure effect is ready
        if (!effectWrapper.effect.isReady()) return;
        this.saveStates();
        // Reset state
        this.setViewport();
        const out = outputTexture === null ? null : this._isRenderTargetTexture(outputTexture) ? outputTexture.renderTarget : outputTexture;
        if (out) this.engine.bindFramebuffer(out);
        this.applyEffectWrapper(effectWrapper);
        this.draw();
        if (out) this.engine.unBindFramebuffer(out);
        this.restoreStates();
    }
    /**
     * Disposes of the effect renderer
     */ dispose() {
        const vertexBuffer = this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind];
        if (vertexBuffer) {
            vertexBuffer.dispose();
            delete this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind];
        }
        if (this._indexBuffer) this.engine._releaseBuffer(this._indexBuffer);
        if (this._onContextRestoredObserver) {
            this.engine.onContextRestoredObservable.remove(this._onContextRestoredObserver);
            this._onContextRestoredObserver = null;
        }
    }
}
class $dd0eba39da5b41c9$export$b901a4b52520d353 {
    /**
     * The underlying effect
     */ get effect() {
        return this._drawWrapper.effect;
    }
    set effect(effect) {
        this._drawWrapper.effect = effect;
    }
    /**
     * Creates an effect to be renderer
     * @param creationOptions options to create the effect
     */ constructor(creationOptions){
        /**
         * Event that is fired right before the effect is drawn (should be used to update uniforms)
         */ this.onApplyObservable = new (0, $diGQf.Observable)();
        let effectCreationOptions;
        const uniformNames = creationOptions.uniformNames || [];
        if (creationOptions.vertexShader) effectCreationOptions = {
            fragmentSource: creationOptions.fragmentShader,
            vertexSource: creationOptions.vertexShader,
            spectorName: creationOptions.name || "effectWrapper"
        };
        else {
            // Default scale to use in post process vertex shader.
            uniformNames.push("scale");
            effectCreationOptions = {
                fragmentSource: creationOptions.fragmentShader,
                vertex: "postprocess",
                spectorName: creationOptions.name || "effectWrapper"
            };
            // Sets the default scale to identity for the post process vertex shader.
            this.onApplyObservable.add(()=>{
                this.effect.setFloat2("scale", 1, 1);
            });
        }
        const defines = creationOptions.defines ? creationOptions.defines.join("\n") : "";
        this._drawWrapper = new (0, $hOyoX.DrawWrapper)(creationOptions.engine);
        if (creationOptions.useShaderStore) {
            effectCreationOptions.fragment = effectCreationOptions.fragmentSource;
            if (!effectCreationOptions.vertex) effectCreationOptions.vertex = effectCreationOptions.vertexSource;
            delete effectCreationOptions.fragmentSource;
            delete effectCreationOptions.vertexSource;
            this.effect = creationOptions.engine.createEffect(effectCreationOptions, creationOptions.attributeNames || [
                "position"
            ], uniformNames, creationOptions.samplerNames, defines, undefined, creationOptions.onCompiled, undefined, undefined, creationOptions.shaderLanguage);
        } else {
            this.effect = new (0, $lUDWq.Effect)(effectCreationOptions, creationOptions.attributeNames || [
                "position"
            ], uniformNames, creationOptions.samplerNames, creationOptions.engine, defines, undefined, creationOptions.onCompiled, undefined, undefined, undefined, creationOptions.shaderLanguage);
            this._onContextRestoredObserver = creationOptions.engine.onContextRestoredObservable.add(()=>{
                this.effect._pipelineContext = null; // because _prepareEffect will try to dispose this pipeline before recreating it and that would lead to webgl errors
                this.effect._prepareEffect();
            });
        }
    }
    /**
     * Disposes of the effect wrapper
     */ dispose() {
        if (this._onContextRestoredObserver) {
            this.effect.getEngine().onContextRestoredObservable.remove(this._onContextRestoredObserver);
            this._onContextRestoredObserver = null;
        }
        this.effect.dispose();
    }
}

});

parcelRegister("dWQWp", function(module, exports) {

$parcel$export(module.exports, "passPixelShader", () => $a279c2201492041f$export$15b2ed99465f95a6);
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $a279c2201492041f$var$name = "passPixelShader";
const $a279c2201492041f$var$shader = `varying vec2 vUV;uniform sampler2D textureSampler;
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) 
{gl_FragColor=texture2D(textureSampler,vUV);}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$a279c2201492041f$var$name] = $a279c2201492041f$var$shader;
const $a279c2201492041f$export$15b2ed99465f95a6 = {
    name: $a279c2201492041f$var$name,
    shader: $a279c2201492041f$var$shader
};

});



parcelRegister("3BZkj", function(module, exports) {

$parcel$export(module.exports, "ProceduralTextureSceneComponent", () => $2a1465fa83996deb$export$ea1e706b1159849a);

var $bOhSV = parcelRequire("bOhSV");

var $bv05l = parcelRequire("bv05l");
class $2a1465fa83996deb$export$ea1e706b1159849a {
    /**
     * Creates a new instance of the component for the given scene
     * @param scene Defines the scene to register the component in
     */ constructor(scene){
        /**
         * The component name helpful to identify the component in the list of scene components.
         */ this.name = (0, $bv05l.SceneComponentConstants).NAME_PROCEDURALTEXTURE;
        this.scene = scene;
        this.scene.proceduralTextures = [];
    }
    /**
     * Registers the component in a given scene
     */ register() {
        this.scene._beforeClearStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_BEFORECLEAR_PROCEDURALTEXTURE, this, this._beforeClear);
    }
    /**
     * Rebuilds the elements related to this component in case of
     * context lost for instance.
     */ rebuild() {
    // Nothing to do here.
    }
    /**
     * Disposes the component and the associated resources.
     */ dispose() {
    // Nothing to do here.
    }
    _beforeClear() {
        if (this.scene.proceduralTexturesEnabled) {
            (0, $bOhSV.Tools).StartPerformanceCounter("Procedural textures", this.scene.proceduralTextures.length > 0);
            for(let proceduralIndex = 0; proceduralIndex < this.scene.proceduralTextures.length; proceduralIndex++){
                const proceduralTexture = this.scene.proceduralTextures[proceduralIndex];
                if (proceduralTexture._shouldRender()) proceduralTexture.render();
            }
            (0, $bOhSV.Tools).EndPerformanceCounter("Procedural textures", this.scene.proceduralTextures.length > 0);
        }
    }
}

});

parcelRegister("96Nay", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $6a1ad093c5ec97ef$var$name = "proceduralVertexShader";
const $6a1ad093c5ec97ef$var$shader = `attribute vec2 position;varying vec2 vPosition;varying vec2 vUV;const vec2 madd=vec2(0.5,0.5);
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
vPosition=position;vUV=position*madd+madd;gl_Position=vec4(position,0.0,1.0);
#define CUSTOM_VERTEX_MAIN_END
}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$6a1ad093c5ec97ef$var$name] = $6a1ad093c5ec97ef$var$shader;
const $6a1ad093c5ec97ef$export$ad7526e420e8e4e = {
    name: $6a1ad093c5ec97ef$var$name,
    shader: $6a1ad093c5ec97ef$var$shader
};

});


parcelRegister("3hVDe", function(module, exports) {

$parcel$export(module.exports, "TrigonometryBlockOperations", () => $264faa12affb8311$export$23c9dc040b1ae547);
$parcel$export(module.exports, "TrigonometryBlock", () => $264faa12affb8311$export$cf8ef2e7ce52c3fb);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
var $264faa12affb8311$export$23c9dc040b1ae547;
(function(TrigonometryBlockOperations) {
    /** Cos */ TrigonometryBlockOperations[TrigonometryBlockOperations["Cos"] = 0] = "Cos";
    /** Sin */ TrigonometryBlockOperations[TrigonometryBlockOperations["Sin"] = 1] = "Sin";
    /** Abs */ TrigonometryBlockOperations[TrigonometryBlockOperations["Abs"] = 2] = "Abs";
    /** Exp */ TrigonometryBlockOperations[TrigonometryBlockOperations["Exp"] = 3] = "Exp";
    /** Exp2 */ TrigonometryBlockOperations[TrigonometryBlockOperations["Exp2"] = 4] = "Exp2";
    /** Round */ TrigonometryBlockOperations[TrigonometryBlockOperations["Round"] = 5] = "Round";
    /** Floor */ TrigonometryBlockOperations[TrigonometryBlockOperations["Floor"] = 6] = "Floor";
    /** Ceiling */ TrigonometryBlockOperations[TrigonometryBlockOperations["Ceiling"] = 7] = "Ceiling";
    /** Square root */ TrigonometryBlockOperations[TrigonometryBlockOperations["Sqrt"] = 8] = "Sqrt";
    /** Log */ TrigonometryBlockOperations[TrigonometryBlockOperations["Log"] = 9] = "Log";
    /** Tangent */ TrigonometryBlockOperations[TrigonometryBlockOperations["Tan"] = 10] = "Tan";
    /** Arc tangent */ TrigonometryBlockOperations[TrigonometryBlockOperations["ArcTan"] = 11] = "ArcTan";
    /** Arc cosinus */ TrigonometryBlockOperations[TrigonometryBlockOperations["ArcCos"] = 12] = "ArcCos";
    /** Arc sinus */ TrigonometryBlockOperations[TrigonometryBlockOperations["ArcSin"] = 13] = "ArcSin";
    /** Fraction */ TrigonometryBlockOperations[TrigonometryBlockOperations["Fract"] = 14] = "Fract";
    /** Sign */ TrigonometryBlockOperations[TrigonometryBlockOperations["Sign"] = 15] = "Sign";
    /** To radians (from degrees) */ TrigonometryBlockOperations[TrigonometryBlockOperations["Radians"] = 16] = "Radians";
    /** To degrees (from radians) */ TrigonometryBlockOperations[TrigonometryBlockOperations["Degrees"] = 17] = "Degrees";
})($264faa12affb8311$export$23c9dc040b1ae547 || ($264faa12affb8311$export$23c9dc040b1ae547 = {}));
class $264faa12affb8311$export$cf8ef2e7ce52c3fb extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new TrigonometryBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        /**
         * Gets or sets the operation applied by the block
         */ this.operation = $264faa12affb8311$export$23c9dc040b1ae547.Cos;
        this.registerInput("input", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "TrigonometryBlock";
    }
    /**
     * Gets the input component
     */ get input() {
        return this._inputs[0];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        let operation = "";
        switch(this.operation){
            case $264faa12affb8311$export$23c9dc040b1ae547.Cos:
                operation = "cos";
                break;
            case $264faa12affb8311$export$23c9dc040b1ae547.Sin:
                operation = "sin";
                break;
            case $264faa12affb8311$export$23c9dc040b1ae547.Abs:
                operation = "abs";
                break;
            case $264faa12affb8311$export$23c9dc040b1ae547.Exp:
                operation = "exp";
                break;
            case $264faa12affb8311$export$23c9dc040b1ae547.Exp2:
                operation = "exp2";
                break;
            case $264faa12affb8311$export$23c9dc040b1ae547.Round:
                operation = "round";
                break;
            case $264faa12affb8311$export$23c9dc040b1ae547.Floor:
                operation = "floor";
                break;
            case $264faa12affb8311$export$23c9dc040b1ae547.Ceiling:
                operation = "ceil";
                break;
            case $264faa12affb8311$export$23c9dc040b1ae547.Sqrt:
                operation = "sqrt";
                break;
            case $264faa12affb8311$export$23c9dc040b1ae547.Log:
                operation = "log";
                break;
            case $264faa12affb8311$export$23c9dc040b1ae547.Tan:
                operation = "tan";
                break;
            case $264faa12affb8311$export$23c9dc040b1ae547.ArcTan:
                operation = "atan";
                break;
            case $264faa12affb8311$export$23c9dc040b1ae547.ArcCos:
                operation = "acos";
                break;
            case $264faa12affb8311$export$23c9dc040b1ae547.ArcSin:
                operation = "asin";
                break;
            case $264faa12affb8311$export$23c9dc040b1ae547.Fract:
                operation = "fract";
                break;
            case $264faa12affb8311$export$23c9dc040b1ae547.Sign:
                operation = "sign";
                break;
            case $264faa12affb8311$export$23c9dc040b1ae547.Radians:
                operation = "radians";
                break;
            case $264faa12affb8311$export$23c9dc040b1ae547.Degrees:
                operation = "degrees";
                break;
        }
        state.compilationString += this._declareOutput(output, state) + ` = ${operation}(${this.input.associatedVariableName});\n`;
        return this;
    }
    serialize() {
        const serializationObject = super.serialize();
        serializationObject.operation = this.operation;
        return serializationObject;
    }
    _deserialize(serializationObject, scene, rootUrl) {
        super._deserialize(serializationObject, scene, rootUrl);
        this.operation = serializationObject.operation;
    }
    _dumpPropertiesCode() {
        const codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.operation = BABYLON.TrigonometryBlockOperations.${$264faa12affb8311$export$23c9dc040b1ae547[this.operation]};\n`;
        return codeString;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.TrigonometryBlock", $264faa12affb8311$export$cf8ef2e7ce52c3fb);

});


parcelRegister("g3tvW", function(module, exports) {

$parcel$export(module.exports, "CreateIcoSphereVertexData", () => $bb03d208aef23781$export$f71122fae51601ba);
$parcel$export(module.exports, "CreateIcoSphere", () => $bb03d208aef23781$export$2bceb0111207e85d);
$parcel$export(module.exports, "IcoSphereBuilder", () => $bb03d208aef23781$export$ecc833c0c02ed574);

var $ha1VO = parcelRequire("ha1VO");

var $fbuqw = parcelRequire("fbuqw");

var $5v6ry = parcelRequire("5v6ry");

var $fGXjI = parcelRequire("fGXjI");
function $bb03d208aef23781$export$f71122fae51601ba(options) {
    const sideOrientation = options.sideOrientation || (0, $5v6ry.VertexData).DEFAULTSIDE;
    const radius = options.radius || 1;
    const flat = options.flat === undefined ? true : options.flat;
    const subdivisions = (options.subdivisions || 4) | 0;
    const radiusX = options.radiusX || radius;
    const radiusY = options.radiusY || radius;
    const radiusZ = options.radiusZ || radius;
    const t = (1 + Math.sqrt(5)) / 2;
    // 12 vertex x,y,z
    const icoVertices = [
        -1,
        t,
        -0,
        1,
        t,
        0,
        -1,
        -t,
        0,
        1,
        -t,
        0,
        0,
        -1,
        -t,
        0,
        1,
        -t,
        0,
        -1,
        t,
        0,
        1,
        t,
        t,
        0,
        1,
        t,
        0,
        -1,
        -t,
        0,
        1,
        -t,
        0,
        -1
    ];
    // index of 3 vertex makes a face of icopshere
    const ico_indices = [
        0,
        11,
        5,
        0,
        5,
        1,
        0,
        1,
        7,
        0,
        7,
        10,
        12,
        22,
        23,
        1,
        5,
        20,
        5,
        11,
        4,
        23,
        22,
        13,
        22,
        18,
        6,
        7,
        1,
        8,
        14,
        21,
        4,
        14,
        4,
        2,
        16,
        13,
        6,
        15,
        6,
        19,
        3,
        8,
        9,
        4,
        21,
        5,
        13,
        17,
        23,
        6,
        13,
        22,
        19,
        6,
        18,
        9,
        8,
        1
    ];
    // vertex for uv have aliased position, not for UV
    const vertices_unalias_id = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        // vertex alias
        0,
        2,
        3,
        3,
        3,
        4,
        7,
        8,
        9,
        9,
        10,
        11
    ];
    // uv as integer step (not pixels !)
    const ico_vertexuv = [
        5,
        1,
        3,
        1,
        6,
        4,
        0,
        0,
        5,
        3,
        4,
        2,
        2,
        2,
        4,
        0,
        2,
        0,
        1,
        1,
        6,
        0,
        6,
        2,
        // vertex alias (for same vertex on different faces)
        0,
        4,
        3,
        3,
        4,
        4,
        3,
        1,
        4,
        2,
        4,
        4,
        0,
        2,
        1,
        1,
        2,
        2,
        3,
        3,
        1,
        3,
        2,
        4
    ];
    // Vertices[0, 1, ...9, A, B] : position on UV plane
    // '+' indicate duplicate position to be fixed (3,9:0,2,3,4,7,8,A,B)
    // First island of uv mapping
    // v = 4h          3+  2
    // v = 3h        9+  4
    // v = 2h      9+  5   B
    // v = 1h    9   1   0
    // v = 0h  3   8   7   A
    //     u = 0 1 2 3 4 5 6  *a
    // Second island of uv mapping
    // v = 4h  0+  B+  4+
    // v = 3h    A+  2+
    // v = 2h  7+  6   3+
    // v = 1h    8+  3+
    // v = 0h
    //     u = 0 1 2 3 4 5 6  *a
    // Face layout on texture UV mapping
    // ============
    // \ 4  /\ 16 /   ======
    //  \  /  \  /   /\ 11 /
    //   \/ 7  \/   /  \  /
    //    =======  / 10 \/
    //   /\ 17 /\  =======
    //  /  \  /  \ \ 15 /\
    // / 8  \/ 12 \ \  /  \
    // ============  \/ 6  \
    // \ 18 /\  ============
    //  \  /  \ \ 5  /\ 0  /
    //   \/ 13 \ \  /  \  /
    //   =======  \/ 1  \/
    //       =============
    //      /\ 19 /\  2 /\
    //     /  \  /  \  /  \
    //    / 14 \/ 9  \/  3 \
    //   ===================
    // uv step is u:1 or 0.5, v:cos(30)=sqrt(3)/2, ratio approx is 84/97
    const ustep = 138 / 1024;
    const vstep = 239 / 1024;
    const uoffset = 60 / 1024;
    const voffset = 26 / 1024;
    // Second island should have margin, not to touch the first island
    // avoid any borderline artefact in pixel rounding
    const island_u_offset = -40 / 1024;
    const island_v_offset = 20 / 1024;
    // face is either island 0 or 1 :
    // second island is for faces : [4, 7, 8, 12, 13, 16, 17, 18]
    const island = [
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        1,
        1,
        0,
        0,
        0,
        1,
        1,
        0,
        0,
        1,
        1,
        1,
        0
    ];
    const indices = [];
    const positions = [];
    const normals = [];
    const uvs = [];
    let current_indice = 0;
    // prepare array of 3 vector (empty) (to be worked in place, shared for each face)
    const face_vertex_pos = new Array(3);
    const face_vertex_uv = new Array(3);
    let v012;
    for(v012 = 0; v012 < 3; v012++){
        face_vertex_pos[v012] = (0, $ha1VO.Vector3).Zero();
        face_vertex_uv[v012] = (0, $ha1VO.Vector2).Zero();
    }
    // create all with normals
    for(let face = 0; face < 20; face++){
        // 3 vertex per face
        for(v012 = 0; v012 < 3; v012++){
            // look up vertex 0,1,2 to its index in 0 to 11 (or 23 including alias)
            const v_id = ico_indices[3 * face + v012];
            // vertex have 3D position (x,y,z)
            face_vertex_pos[v012].copyFromFloats(icoVertices[3 * vertices_unalias_id[v_id]], icoVertices[3 * vertices_unalias_id[v_id] + 1], icoVertices[3 * vertices_unalias_id[v_id] + 2]);
            // Normalize to get normal
            face_vertex_pos[v012].normalize();
            // uv Coordinates from vertex ID
            face_vertex_uv[v012].copyFromFloats(ico_vertexuv[2 * v_id] * ustep + uoffset + island[face] * island_u_offset, ico_vertexuv[2 * v_id + 1] * vstep + voffset + island[face] * island_v_offset);
        }
        // Subdivide the face (interpolate pos, norm, uv)
        // - pos is linear interpolation, then projected to sphere (converge polyhedron to sphere)
        // - norm is linear interpolation of vertex corner normal
        //   (to be checked if better to re-calc from face vertex, or if approximation is OK ??? )
        // - uv is linear interpolation
        //
        // Topology is as below for sub-divide by 2
        // vertex shown as v0,v1,v2
        // interp index is i1 to progress in range [v0,v1[
        // interp index is i2 to progress in range [v0,v2[
        // face index as  (i1,i2)  for /\  : (i1,i2),(i1+1,i2),(i1,i2+1)
        //            and (i1,i2)' for \/  : (i1+1,i2),(i1+1,i2+1),(i1,i2+1)
        //
        //
        //                    i2    v2
        //                    ^    ^
        //                   /    / \
        //                  /    /   \
        //                 /    /     \
        //                /    / (0,1) \
        //               /    #---------\
        //              /    / \ (0,0)'/ \
        //             /    /   \     /   \
        //            /    /     \   /     \
        //           /    / (0,0) \ / (1,0) \
        //          /    #---------#---------\
        //              v0                    v1
        //
        //              --------------------> i1
        //
        // interp of (i1,i2):
        //  along i2 :  x0=lerp(v0,v2, i2/S) <---> x1=lerp(v1,v2, i2/S)
        //  along i1 :  lerp(x0,x1, i1/(S-i2))
        //
        // centroid of triangle is needed to get help normal computation
        //  (c1,c2) are used for centroid location
        const interp_vertex = (i1, i2, c1, c2)=>{
            // vertex is interpolated from
            //   - face_vertex_pos[0..2]
            //   - face_vertex_uv[0..2]
            const pos_x0 = (0, $ha1VO.Vector3).Lerp(face_vertex_pos[0], face_vertex_pos[2], i2 / subdivisions);
            const pos_x1 = (0, $ha1VO.Vector3).Lerp(face_vertex_pos[1], face_vertex_pos[2], i2 / subdivisions);
            const pos_interp = subdivisions === i2 ? face_vertex_pos[2] : (0, $ha1VO.Vector3).Lerp(pos_x0, pos_x1, i1 / (subdivisions - i2));
            pos_interp.normalize();
            let vertex_normal;
            if (flat) {
                // in flat mode, recalculate normal as face centroid normal
                const centroid_x0 = (0, $ha1VO.Vector3).Lerp(face_vertex_pos[0], face_vertex_pos[2], c2 / subdivisions);
                const centroid_x1 = (0, $ha1VO.Vector3).Lerp(face_vertex_pos[1], face_vertex_pos[2], c2 / subdivisions);
                vertex_normal = (0, $ha1VO.Vector3).Lerp(centroid_x0, centroid_x1, c1 / (subdivisions - c2));
            } else // in smooth mode, recalculate normal from each single vertex position
            vertex_normal = new (0, $ha1VO.Vector3)(pos_interp.x, pos_interp.y, pos_interp.z);
            // Vertex normal need correction due to X,Y,Z radius scaling
            vertex_normal.x /= radiusX;
            vertex_normal.y /= radiusY;
            vertex_normal.z /= radiusZ;
            vertex_normal.normalize();
            const uv_x0 = (0, $ha1VO.Vector2).Lerp(face_vertex_uv[0], face_vertex_uv[2], i2 / subdivisions);
            const uv_x1 = (0, $ha1VO.Vector2).Lerp(face_vertex_uv[1], face_vertex_uv[2], i2 / subdivisions);
            const uv_interp = subdivisions === i2 ? face_vertex_uv[2] : (0, $ha1VO.Vector2).Lerp(uv_x0, uv_x1, i1 / (subdivisions - i2));
            positions.push(pos_interp.x * radiusX, pos_interp.y * radiusY, pos_interp.z * radiusZ);
            normals.push(vertex_normal.x, vertex_normal.y, vertex_normal.z);
            uvs.push(uv_interp.x, (0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? 1.0 - uv_interp.y : uv_interp.y);
            // push each vertex has member of a face
            // Same vertex can belong to multiple face, it is pushed multiple time (duplicate vertex are present)
            indices.push(current_indice);
            current_indice++;
        };
        for(let i2 = 0; i2 < subdivisions; i2++)for(let i1 = 0; i1 + i2 < subdivisions; i1++){
            // face : (i1,i2)  for /\  :
            // interp for : (i1,i2),(i1+1,i2),(i1,i2+1)
            interp_vertex(i1, i2, i1 + 1.0 / 3, i2 + 1.0 / 3);
            interp_vertex(i1 + 1, i2, i1 + 1.0 / 3, i2 + 1.0 / 3);
            interp_vertex(i1, i2 + 1, i1 + 1.0 / 3, i2 + 1.0 / 3);
            if (i1 + i2 + 1 < subdivisions) {
                // face : (i1,i2)' for \/  :
                // interp for (i1+1,i2),(i1+1,i2+1),(i1,i2+1)
                interp_vertex(i1 + 1, i2, i1 + 2.0 / 3, i2 + 2.0 / 3);
                interp_vertex(i1 + 1, i2 + 1, i1 + 2.0 / 3, i2 + 2.0 / 3);
                interp_vertex(i1, i2 + 1, i1 + 2.0 / 3, i2 + 2.0 / 3);
            }
        }
    }
    // Sides
    (0, $5v6ry.VertexData)._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
    // Result
    const vertexData = new (0, $5v6ry.VertexData)();
    vertexData.indices = indices;
    vertexData.positions = positions;
    vertexData.normals = normals;
    vertexData.uvs = uvs;
    return vertexData;
}
function $bb03d208aef23781$export$2bceb0111207e85d(name, options = {}, scene = null) {
    const sphere = new (0, $fbuqw.Mesh)(name, scene);
    options.sideOrientation = (0, $fbuqw.Mesh)._GetDefaultSideOrientation(options.sideOrientation);
    sphere._originalBuilderSideOrientation = options.sideOrientation;
    const vertexData = $bb03d208aef23781$export$f71122fae51601ba(options);
    vertexData.applyToMesh(sphere, options.updatable);
    return sphere;
}
const $bb03d208aef23781$export$ecc833c0c02ed574 = {
    CreateIcoSphere: // eslint-disable-next-line @typescript-eslint/naming-convention
    $bb03d208aef23781$export$2bceb0111207e85d
};
(0, $5v6ry.VertexData).CreateIcoSphere = $bb03d208aef23781$export$f71122fae51601ba;
(0, $fbuqw.Mesh).CreateIcoSphere = (name, options, scene)=>{
    return $bb03d208aef23781$export$2bceb0111207e85d(name, options, scene);
};

});





parcelRegister("eeqmf", function(module, exports) {

var $g6X9E = parcelRequire("g6X9E");

var $e6cbP = parcelRequire("e6cbP");

var $ho2ic = parcelRequire("ho2ic");

var $3RnX0 = parcelRequire("3RnX0");
$parcel$exportWildcard(module.exports, $g6X9E);
$parcel$exportWildcard(module.exports, $e6cbP);
$parcel$exportWildcard(module.exports, $ho2ic);
$parcel$exportWildcard(module.exports, $3RnX0);

});
parcelRegister("e6cbP", function(module, exports) {

$parcel$export(module.exports, "BoneIKController", () => $a43b14dc2732ae28$export$bc354fc79a91ed68);

var $ha1VO = parcelRequire("ha1VO");

var $dbxbu = parcelRequire("dbxbu");

var $kVtWi = parcelRequire("kVtWi");
class $a43b14dc2732ae28$export$bc354fc79a91ed68 {
    /**
     * Gets or sets maximum allowed angle
     */ get maxAngle() {
        return this._maxAngle;
    }
    set maxAngle(value) {
        this._setMaxAngle(value);
    }
    /**
     * Creates a new BoneIKController
     * @param mesh defines the TransformNode to control
     * @param bone defines the bone to control. The bone needs to have a parent bone. It also needs to have a length greater than 0 or a children we can use to infer its length.
     * @param options defines options to set up the controller
     * @param options.targetMesh
     * @param options.poleTargetMesh
     * @param options.poleTargetBone
     * @param options.poleTargetLocalOffset
     * @param options.poleAngle
     * @param options.bendAxis
     * @param options.maxAngle
     * @param options.slerpAmount
     */ constructor(mesh, bone, options){
        /**
         * Gets or sets the target position
         */ this.targetPosition = (0, $ha1VO.Vector3).Zero();
        /**
         * Gets or sets the pole target position
         */ this.poleTargetPosition = (0, $ha1VO.Vector3).Zero();
        /**
         * Gets or sets the pole target local offset
         */ this.poleTargetLocalOffset = (0, $ha1VO.Vector3).Zero();
        /**
         * Gets or sets the pole angle
         */ this.poleAngle = 0;
        /**
         * The amount to slerp (spherical linear interpolation) to the target.  Set this to a value between 0 and 1 (a value of 1 disables slerp)
         */ this.slerpAmount = 1;
        this._bone1Quat = (0, $ha1VO.Quaternion).Identity();
        this._bone1Mat = (0, $ha1VO.Matrix).Identity();
        this._bone2Ang = Math.PI;
        this._maxAngle = Math.PI;
        this._rightHandedSystem = false;
        this._bendAxis = (0, $ha1VO.Vector3).Right();
        this._slerping = false;
        this._adjustRoll = 0;
        this._notEnoughInformation = false;
        this._bone2 = bone;
        const bone1 = bone.getParent();
        if (!bone1) {
            this._notEnoughInformation = true;
            (0, $kVtWi.Logger).Error("BoneIKController: bone must have a parent for IK to work.");
            return;
        }
        this._bone1 = bone1;
        if (this._bone2.children.length === 0 && !this._bone2.length) {
            this._notEnoughInformation = true;
            (0, $kVtWi.Logger).Error("BoneIKController: bone must not be a leaf or it should have a length for IK to work.");
            return;
        }
        this.mesh = mesh;
        bone.getSkeleton().computeAbsoluteMatrices();
        const bonePos = bone.getPosition();
        if (bone.getAbsoluteMatrix().determinant() > 0) {
            this._rightHandedSystem = true;
            this._bendAxis.x = 0;
            this._bendAxis.y = 0;
            this._bendAxis.z = -1;
            if (bonePos.x > bonePos.y && bonePos.x > bonePos.z) {
                this._adjustRoll = Math.PI * 0.5;
                this._bendAxis.z = 1;
            }
        }
        if (this._bone1.length && this._bone2.length) {
            const boneScale1 = this._bone1.getScale();
            const boneScale2 = this._bone2.getScale();
            this._bone1Length = this._bone1.length * boneScale1.y * this.mesh.scaling.y;
            this._bone2Length = this._bone2.length * boneScale2.y * this.mesh.scaling.y;
        } else if (this._bone2.children[0]) {
            mesh.computeWorldMatrix(true);
            const pos1 = this._bone2.children[0].getAbsolutePosition(mesh);
            const pos2 = this._bone2.getAbsolutePosition(mesh);
            const pos3 = this._bone1.getAbsolutePosition(mesh);
            this._bone2Length = (0, $ha1VO.Vector3).Distance(pos1, pos2);
            this._bone1Length = (0, $ha1VO.Vector3).Distance(pos2, pos3);
        } else {
            mesh.computeWorldMatrix(true);
            const boneScale2 = this._bone2.getScale();
            this._bone2Length = this._bone2.length * boneScale2.y * this.mesh.scaling.y;
            const pos2 = this._bone2.getAbsolutePosition(mesh);
            const pos3 = this._bone1.getAbsolutePosition(mesh);
            this._bone1Length = (0, $ha1VO.Vector3).Distance(pos2, pos3);
        }
        this._bone1.getRotationMatrixToRef((0, $dbxbu.Space).WORLD, mesh, this._bone1Mat);
        this.maxAngle = Math.PI;
        if (options) {
            if (options.targetMesh) {
                this.targetMesh = options.targetMesh;
                this.targetMesh.computeWorldMatrix(true);
            }
            if (options.poleTargetMesh) {
                this.poleTargetMesh = options.poleTargetMesh;
                this.poleTargetMesh.computeWorldMatrix(true);
            } else if (options.poleTargetBone) this.poleTargetBone = options.poleTargetBone;
            else if (this._bone1.getParent()) this.poleTargetBone = this._bone1.getParent();
            if (options.poleTargetLocalOffset) this.poleTargetLocalOffset.copyFrom(options.poleTargetLocalOffset);
            if (options.poleAngle) this.poleAngle = options.poleAngle;
            if (options.bendAxis) this._bendAxis.copyFrom(options.bendAxis);
            if (options.maxAngle) this.maxAngle = options.maxAngle;
            if (options.slerpAmount) this.slerpAmount = options.slerpAmount;
        }
    }
    _setMaxAngle(ang) {
        if (ang < 0) ang = 0;
        if (ang > Math.PI || ang == undefined) ang = Math.PI;
        this._maxAngle = ang;
        const a = this._bone1Length;
        const b = this._bone2Length;
        this._maxReach = Math.sqrt(a * a + b * b - 2 * a * b * Math.cos(ang));
    }
    /**
     * Force the controller to update the bones
     */ update() {
        if (this._notEnoughInformation) return;
        const target = this.targetPosition;
        const poleTarget = this.poleTargetPosition;
        const mat1 = $a43b14dc2732ae28$export$bc354fc79a91ed68._TmpMats[0];
        const mat2 = $a43b14dc2732ae28$export$bc354fc79a91ed68._TmpMats[1];
        if (this.targetMesh) target.copyFrom(this.targetMesh.getAbsolutePosition());
        if (this.poleTargetBone) this.poleTargetBone.getAbsolutePositionFromLocalToRef(this.poleTargetLocalOffset, this.mesh, poleTarget);
        else if (this.poleTargetMesh) (0, $ha1VO.Vector3).TransformCoordinatesToRef(this.poleTargetLocalOffset, this.poleTargetMesh.getWorldMatrix(), poleTarget);
        const bonePos = $a43b14dc2732ae28$export$bc354fc79a91ed68._TmpVecs[0];
        const zaxis = $a43b14dc2732ae28$export$bc354fc79a91ed68._TmpVecs[1];
        const xaxis = $a43b14dc2732ae28$export$bc354fc79a91ed68._TmpVecs[2];
        const yaxis = $a43b14dc2732ae28$export$bc354fc79a91ed68._TmpVecs[3];
        const upAxis = $a43b14dc2732ae28$export$bc354fc79a91ed68._TmpVecs[4];
        const tmpQuat = $a43b14dc2732ae28$export$bc354fc79a91ed68._TmpQuat;
        this._bone1.getAbsolutePositionToRef(this.mesh, bonePos);
        poleTarget.subtractToRef(bonePos, upAxis);
        if (upAxis.x == 0 && upAxis.y == 0 && upAxis.z == 0) upAxis.y = 1;
        else upAxis.normalize();
        target.subtractToRef(bonePos, yaxis);
        yaxis.normalize();
        (0, $ha1VO.Vector3).CrossToRef(yaxis, upAxis, zaxis);
        zaxis.normalize();
        (0, $ha1VO.Vector3).CrossToRef(yaxis, zaxis, xaxis);
        xaxis.normalize();
        (0, $ha1VO.Matrix).FromXYZAxesToRef(xaxis, yaxis, zaxis, mat1);
        const a = this._bone1Length;
        const b = this._bone2Length;
        let c = (0, $ha1VO.Vector3).Distance(bonePos, target);
        if (this._maxReach > 0) c = Math.min(this._maxReach, c);
        let acosa = (b * b + c * c - a * a) / (2 * b * c);
        let acosb = (c * c + a * a - b * b) / (2 * c * a);
        if (acosa > 1) acosa = 1;
        if (acosb > 1) acosb = 1;
        if (acosa < -1) acosa = -1;
        if (acosb < -1) acosb = -1;
        const angA = Math.acos(acosa);
        const angB = Math.acos(acosb);
        let angC = -angA - angB;
        if (this._rightHandedSystem) {
            (0, $ha1VO.Matrix).RotationYawPitchRollToRef(0, 0, this._adjustRoll, mat2);
            mat2.multiplyToRef(mat1, mat1);
            (0, $ha1VO.Matrix).RotationAxisToRef(this._bendAxis, angB, mat2);
            mat2.multiplyToRef(mat1, mat1);
        } else {
            const _tmpVec = $a43b14dc2732ae28$export$bc354fc79a91ed68._TmpVecs[5];
            _tmpVec.copyFrom(this._bendAxis);
            _tmpVec.x *= -1;
            (0, $ha1VO.Matrix).RotationAxisToRef(_tmpVec, -angB, mat2);
            mat2.multiplyToRef(mat1, mat1);
        }
        if (this.poleAngle) {
            (0, $ha1VO.Matrix).RotationAxisToRef(yaxis, this.poleAngle, mat2);
            mat1.multiplyToRef(mat2, mat1);
        }
        if (this._bone1) {
            if (this.slerpAmount < 1) {
                if (!this._slerping) (0, $ha1VO.Quaternion).FromRotationMatrixToRef(this._bone1Mat, this._bone1Quat);
                (0, $ha1VO.Quaternion).FromRotationMatrixToRef(mat1, tmpQuat);
                (0, $ha1VO.Quaternion).SlerpToRef(this._bone1Quat, tmpQuat, this.slerpAmount, this._bone1Quat);
                angC = this._bone2Ang * (1.0 - this.slerpAmount) + angC * this.slerpAmount;
                this._bone1.setRotationQuaternion(this._bone1Quat, (0, $dbxbu.Space).WORLD, this.mesh);
                this._slerping = true;
            } else {
                this._bone1.setRotationMatrix(mat1, (0, $dbxbu.Space).WORLD, this.mesh);
                this._bone1Mat.copyFrom(mat1);
                this._slerping = false;
            }
            this._updateLinkedTransformRotation(this._bone1);
        }
        this._bone2.setAxisAngle(this._bendAxis, angC, (0, $dbxbu.Space).LOCAL);
        this._updateLinkedTransformRotation(this._bone2);
        this._bone2Ang = angC;
    }
    _updateLinkedTransformRotation(bone) {
        if (bone._linkedTransformNode) {
            if (!bone._linkedTransformNode.rotationQuaternion) bone._linkedTransformNode.rotationQuaternion = new (0, $ha1VO.Quaternion)();
            bone.getRotationQuaternionToRef((0, $dbxbu.Space).LOCAL, null, bone._linkedTransformNode.rotationQuaternion);
        }
    }
}
$a43b14dc2732ae28$export$bc354fc79a91ed68._TmpVecs = [
    (0, $ha1VO.Vector3).Zero(),
    (0, $ha1VO.Vector3).Zero(),
    (0, $ha1VO.Vector3).Zero(),
    (0, $ha1VO.Vector3).Zero(),
    (0, $ha1VO.Vector3).Zero(),
    (0, $ha1VO.Vector3).Zero()
];
$a43b14dc2732ae28$export$bc354fc79a91ed68._TmpQuat = (0, $ha1VO.Quaternion).Identity();
$a43b14dc2732ae28$export$bc354fc79a91ed68._TmpMats = [
    (0, $ha1VO.Matrix).Identity(),
    (0, $ha1VO.Matrix).Identity()
];

});

parcelRegister("ho2ic", function(module, exports) {

$parcel$export(module.exports, "BoneLookController", () => $ca8674ced570be27$export$522335dccacd09c6);

var $opFp4 = parcelRequire("opFp4");

var $ha1VO = parcelRequire("ha1VO");

var $dbxbu = parcelRequire("dbxbu");
class $ca8674ced570be27$export$522335dccacd09c6 {
    /**
     * Gets or sets the minimum yaw angle that the bone can look to
     */ get minYaw() {
        return this._minYaw;
    }
    set minYaw(value) {
        this._minYaw = value;
        this._minYawSin = Math.sin(value);
        this._minYawCos = Math.cos(value);
        if (this._maxYaw != null) {
            this._midYawConstraint = this._getAngleDiff(this._minYaw, this._maxYaw) * 0.5 + this._minYaw;
            this._yawRange = this._maxYaw - this._minYaw;
        }
    }
    /**
     * Gets or sets the maximum yaw angle that the bone can look to
     */ get maxYaw() {
        return this._maxYaw;
    }
    set maxYaw(value) {
        this._maxYaw = value;
        this._maxYawSin = Math.sin(value);
        this._maxYawCos = Math.cos(value);
        if (this._minYaw != null) {
            this._midYawConstraint = this._getAngleDiff(this._minYaw, this._maxYaw) * 0.5 + this._minYaw;
            this._yawRange = this._maxYaw - this._minYaw;
        }
    }
    /**
     * Gets or sets the minimum pitch angle that the bone can look to
     */ get minPitch() {
        return this._minPitch;
    }
    set minPitch(value) {
        this._minPitch = value;
        this._minPitchTan = Math.tan(value);
    }
    /**
     * Gets or sets the maximum pitch angle that the bone can look to
     */ get maxPitch() {
        return this._maxPitch;
    }
    set maxPitch(value) {
        this._maxPitch = value;
        this._maxPitchTan = Math.tan(value);
    }
    /**
     * Create a BoneLookController
     * @param mesh the TransformNode that the bone belongs to
     * @param bone the bone that will be looking to the target
     * @param target the target Vector3 to look at
     * @param options optional settings:
     * * maxYaw: the maximum angle the bone will yaw to
     * * minYaw: the minimum angle the bone will yaw to
     * * maxPitch: the maximum angle the bone will pitch to
     * * minPitch: the minimum angle the bone will yaw to
     * * slerpAmount: set the between 0 and 1 to make the bone slerp to the target.
     * * upAxis: the up axis of the coordinate system
     * * upAxisSpace: the space that the up axis is in - Space.BONE, Space.LOCAL (default), or Space.WORLD.
     * * yawAxis: set yawAxis if the bone does not yaw on the y axis
     * * pitchAxis: set pitchAxis if the bone does not pitch on the x axis
     * * adjustYaw: used to make an adjustment to the yaw of the bone
     * * adjustPitch: used to make an adjustment to the pitch of the bone
     * * adjustRoll: used to make an adjustment to the roll of the bone
     * @param options.maxYaw
     * @param options.minYaw
     * @param options.maxPitch
     * @param options.minPitch
     * @param options.slerpAmount
     * @param options.upAxis
     * @param options.upAxisSpace
     * @param options.yawAxis
     * @param options.pitchAxis
     * @param options.adjustYaw
     * @param options.adjustPitch
     * @param options.adjustRoll
     **/ constructor(mesh, bone, target, options){
        /**
         * The up axis of the coordinate system that is used when the bone is rotated
         */ this.upAxis = (0, $ha1VO.Vector3).Up();
        /**
         * The space that the up axis is in - Space.BONE, Space.LOCAL (default), or Space.WORLD
         */ this.upAxisSpace = (0, $dbxbu.Space).LOCAL;
        /**
         * Used to make an adjustment to the yaw of the bone
         */ this.adjustYaw = 0;
        /**
         * Used to make an adjustment to the pitch of the bone
         */ this.adjustPitch = 0;
        /**
         * Used to make an adjustment to the roll of the bone
         */ this.adjustRoll = 0;
        /**
         * The amount to slerp (spherical linear interpolation) to the target.  Set this to a value between 0 and 1 (a value of 1 disables slerp)
         */ this.slerpAmount = 1;
        this._boneQuat = (0, $ha1VO.Quaternion).Identity();
        this._slerping = false;
        this._firstFrameSkipped = false;
        this._fowardAxis = (0, $ha1VO.Vector3).Forward();
        /**
         * Use the absolute value for yaw when checking the min/max constraints
         */ this.useAbsoluteValueForYaw = false;
        this.mesh = mesh;
        this.bone = bone;
        this.target = target;
        if (options) {
            if (options.adjustYaw) this.adjustYaw = options.adjustYaw;
            if (options.adjustPitch) this.adjustPitch = options.adjustPitch;
            if (options.adjustRoll) this.adjustRoll = options.adjustRoll;
            if (options.maxYaw != null) this.maxYaw = options.maxYaw;
            else this.maxYaw = Math.PI;
            if (options.minYaw != null) this.minYaw = options.minYaw;
            else this.minYaw = -Math.PI;
            if (options.maxPitch != null) this.maxPitch = options.maxPitch;
            else this.maxPitch = Math.PI;
            if (options.minPitch != null) this.minPitch = options.minPitch;
            else this.minPitch = -Math.PI;
            if (options.slerpAmount != null) this.slerpAmount = options.slerpAmount;
            if (options.upAxis != null) this.upAxis = options.upAxis;
            if (options.upAxisSpace != null) this.upAxisSpace = options.upAxisSpace;
            if (options.yawAxis != null || options.pitchAxis != null) {
                let newYawAxis = (0, $dbxbu.Axis).Y;
                let newPitchAxis = (0, $dbxbu.Axis).X;
                if (options.yawAxis != null) {
                    newYawAxis = options.yawAxis.clone();
                    newYawAxis.normalize();
                }
                if (options.pitchAxis != null) {
                    newPitchAxis = options.pitchAxis.clone();
                    newPitchAxis.normalize();
                }
                const newRollAxis = (0, $ha1VO.Vector3).Cross(newPitchAxis, newYawAxis);
                this._transformYawPitch = (0, $ha1VO.Matrix).Identity();
                (0, $ha1VO.Matrix).FromXYZAxesToRef(newPitchAxis, newYawAxis, newRollAxis, this._transformYawPitch);
                this._transformYawPitchInv = this._transformYawPitch.clone();
                this._transformYawPitch.invert();
            }
            if (options.useAbsoluteValueForYaw !== undefined) this.useAbsoluteValueForYaw = options.useAbsoluteValueForYaw;
        }
        if (!bone.getParent() && this.upAxisSpace == (0, $dbxbu.Space).BONE) this.upAxisSpace = (0, $dbxbu.Space).LOCAL;
    }
    /**
     * Update the bone to look at the target.  This should be called before the scene is rendered (use scene.registerBeforeRender())
     */ update() {
        //skip the first frame when slerping so that the TransformNode rotation is correct
        if (this.slerpAmount < 1 && !this._firstFrameSkipped) {
            this._firstFrameSkipped = true;
            return;
        }
        const bone = this.bone;
        const bonePos = $ca8674ced570be27$export$522335dccacd09c6._TmpVecs[0];
        bone.getAbsolutePositionToRef(this.mesh, bonePos);
        let target = this.target;
        const _tmpMat1 = $ca8674ced570be27$export$522335dccacd09c6._TmpMats[0];
        const _tmpMat2 = $ca8674ced570be27$export$522335dccacd09c6._TmpMats[1];
        const mesh = this.mesh;
        const parentBone = bone.getParent();
        const upAxis = $ca8674ced570be27$export$522335dccacd09c6._TmpVecs[1];
        upAxis.copyFrom(this.upAxis);
        if (this.upAxisSpace == (0, $dbxbu.Space).BONE && parentBone) {
            if (this._transformYawPitch) (0, $ha1VO.Vector3).TransformCoordinatesToRef(upAxis, this._transformYawPitchInv, upAxis);
            parentBone.getDirectionToRef(upAxis, this.mesh, upAxis);
        } else if (this.upAxisSpace == (0, $dbxbu.Space).LOCAL) {
            mesh.getDirectionToRef(upAxis, upAxis);
            if (mesh.scaling.x != 1 || mesh.scaling.y != 1 || mesh.scaling.z != 1) upAxis.normalize();
        }
        let checkYaw = false;
        let checkPitch = false;
        if (this._maxYaw != Math.PI || this._minYaw != -Math.PI) checkYaw = true;
        if (this._maxPitch != Math.PI || this._minPitch != -Math.PI) checkPitch = true;
        if (checkYaw || checkPitch) {
            const spaceMat = $ca8674ced570be27$export$522335dccacd09c6._TmpMats[2];
            const spaceMatInv = $ca8674ced570be27$export$522335dccacd09c6._TmpMats[3];
            if (this.upAxisSpace == (0, $dbxbu.Space).BONE && upAxis.y == 1 && parentBone) parentBone.getRotationMatrixToRef((0, $dbxbu.Space).WORLD, this.mesh, spaceMat);
            else if (this.upAxisSpace == (0, $dbxbu.Space).LOCAL && upAxis.y == 1 && !parentBone) spaceMat.copyFrom(mesh.getWorldMatrix());
            else {
                let forwardAxis = $ca8674ced570be27$export$522335dccacd09c6._TmpVecs[2];
                forwardAxis.copyFrom(this._fowardAxis);
                if (this._transformYawPitch) (0, $ha1VO.Vector3).TransformCoordinatesToRef(forwardAxis, this._transformYawPitchInv, forwardAxis);
                if (parentBone) parentBone.getDirectionToRef(forwardAxis, this.mesh, forwardAxis);
                else mesh.getDirectionToRef(forwardAxis, forwardAxis);
                const rightAxis = (0, $ha1VO.Vector3).Cross(upAxis, forwardAxis);
                rightAxis.normalize();
                forwardAxis = (0, $ha1VO.Vector3).Cross(rightAxis, upAxis);
                (0, $ha1VO.Matrix).FromXYZAxesToRef(rightAxis, upAxis, forwardAxis, spaceMat);
            }
            spaceMat.invertToRef(spaceMatInv);
            let xzlen = null;
            if (checkPitch) {
                const localTarget = $ca8674ced570be27$export$522335dccacd09c6._TmpVecs[3];
                target.subtractToRef(bonePos, localTarget);
                (0, $ha1VO.Vector3).TransformCoordinatesToRef(localTarget, spaceMatInv, localTarget);
                xzlen = Math.sqrt(localTarget.x * localTarget.x + localTarget.z * localTarget.z);
                const pitch = Math.atan2(localTarget.y, xzlen);
                let newPitch = pitch;
                if (pitch > this._maxPitch) {
                    localTarget.y = this._maxPitchTan * xzlen;
                    newPitch = this._maxPitch;
                } else if (pitch < this._minPitch) {
                    localTarget.y = this._minPitchTan * xzlen;
                    newPitch = this._minPitch;
                }
                if (pitch != newPitch) {
                    (0, $ha1VO.Vector3).TransformCoordinatesToRef(localTarget, spaceMat, localTarget);
                    localTarget.addInPlace(bonePos);
                    target = localTarget;
                }
            }
            if (checkYaw) {
                const localTarget = $ca8674ced570be27$export$522335dccacd09c6._TmpVecs[4];
                target.subtractToRef(bonePos, localTarget);
                (0, $ha1VO.Vector3).TransformCoordinatesToRef(localTarget, spaceMatInv, localTarget);
                const yaw = Math.atan2(localTarget.x, localTarget.z);
                const yawCheck = this.useAbsoluteValueForYaw ? Math.abs(yaw) : yaw;
                let newYaw = yaw;
                if (yawCheck > this._maxYaw || yawCheck < this._minYaw) {
                    if (xzlen == null) xzlen = Math.sqrt(localTarget.x * localTarget.x + localTarget.z * localTarget.z);
                    if (this._yawRange > Math.PI) {
                        if (this._isAngleBetween(yaw, this._maxYaw, this._midYawConstraint)) {
                            localTarget.z = this._maxYawCos * xzlen;
                            localTarget.x = this._maxYawSin * xzlen;
                            newYaw = this._maxYaw;
                        } else if (this._isAngleBetween(yaw, this._midYawConstraint, this._minYaw)) {
                            localTarget.z = this._minYawCos * xzlen;
                            localTarget.x = this._minYawSin * xzlen;
                            newYaw = this._minYaw;
                        }
                    } else {
                        if (yawCheck > this._maxYaw) {
                            localTarget.z = this._maxYawCos * xzlen;
                            localTarget.x = this._maxYawSin * xzlen;
                            if (yaw < 0 && this.useAbsoluteValueForYaw) localTarget.x *= -1;
                            newYaw = this._maxYaw;
                        } else if (yawCheck < this._minYaw) {
                            localTarget.z = this._minYawCos * xzlen;
                            localTarget.x = this._minYawSin * xzlen;
                            if (yaw < 0 && this.useAbsoluteValueForYaw) localTarget.x *= -1;
                            newYaw = this._minYaw;
                        }
                    }
                }
                if (this._slerping && this._yawRange > Math.PI) {
                    //are we going to be crossing into the min/max region?
                    const boneFwd = $ca8674ced570be27$export$522335dccacd09c6._TmpVecs[8];
                    boneFwd.copyFrom((0, $dbxbu.Axis).Z);
                    if (this._transformYawPitch) (0, $ha1VO.Vector3).TransformCoordinatesToRef(boneFwd, this._transformYawPitchInv, boneFwd);
                    const boneRotMat = $ca8674ced570be27$export$522335dccacd09c6._TmpMats[4];
                    this._boneQuat.toRotationMatrix(boneRotMat);
                    this.mesh.getWorldMatrix().multiplyToRef(boneRotMat, boneRotMat);
                    (0, $ha1VO.Vector3).TransformCoordinatesToRef(boneFwd, boneRotMat, boneFwd);
                    (0, $ha1VO.Vector3).TransformCoordinatesToRef(boneFwd, spaceMatInv, boneFwd);
                    const boneYaw = Math.atan2(boneFwd.x, boneFwd.z);
                    const angBtwTar = this._getAngleBetween(boneYaw, yaw);
                    const angBtwMidYaw = this._getAngleBetween(boneYaw, this._midYawConstraint);
                    if (angBtwTar > angBtwMidYaw) {
                        if (xzlen == null) xzlen = Math.sqrt(localTarget.x * localTarget.x + localTarget.z * localTarget.z);
                        const angBtwMax = this._getAngleBetween(boneYaw, this._maxYaw);
                        const angBtwMin = this._getAngleBetween(boneYaw, this._minYaw);
                        if (angBtwMin < angBtwMax) {
                            newYaw = boneYaw + Math.PI * 0.75;
                            localTarget.z = Math.cos(newYaw) * xzlen;
                            localTarget.x = Math.sin(newYaw) * xzlen;
                        } else {
                            newYaw = boneYaw - Math.PI * 0.75;
                            localTarget.z = Math.cos(newYaw) * xzlen;
                            localTarget.x = Math.sin(newYaw) * xzlen;
                        }
                    }
                }
                if (yaw != newYaw) {
                    (0, $ha1VO.Vector3).TransformCoordinatesToRef(localTarget, spaceMat, localTarget);
                    localTarget.addInPlace(bonePos);
                    target = localTarget;
                }
            }
        }
        const zaxis = $ca8674ced570be27$export$522335dccacd09c6._TmpVecs[5];
        const xaxis = $ca8674ced570be27$export$522335dccacd09c6._TmpVecs[6];
        const yaxis = $ca8674ced570be27$export$522335dccacd09c6._TmpVecs[7];
        const tmpQuat = $ca8674ced570be27$export$522335dccacd09c6._TmpQuat;
        target.subtractToRef(bonePos, zaxis);
        zaxis.normalize();
        (0, $ha1VO.Vector3).CrossToRef(upAxis, zaxis, xaxis);
        xaxis.normalize();
        (0, $ha1VO.Vector3).CrossToRef(zaxis, xaxis, yaxis);
        yaxis.normalize();
        (0, $ha1VO.Matrix).FromXYZAxesToRef(xaxis, yaxis, zaxis, _tmpMat1);
        if (xaxis.x === 0 && xaxis.y === 0 && xaxis.z === 0) return;
        if (yaxis.x === 0 && yaxis.y === 0 && yaxis.z === 0) return;
        if (zaxis.x === 0 && zaxis.y === 0 && zaxis.z === 0) return;
        if (this.adjustYaw || this.adjustPitch || this.adjustRoll) {
            (0, $ha1VO.Matrix).RotationYawPitchRollToRef(this.adjustYaw, this.adjustPitch, this.adjustRoll, _tmpMat2);
            _tmpMat2.multiplyToRef(_tmpMat1, _tmpMat1);
        }
        if (this.slerpAmount < 1) {
            if (!this._slerping) this.bone.getRotationQuaternionToRef((0, $dbxbu.Space).WORLD, this.mesh, this._boneQuat);
            if (this._transformYawPitch) this._transformYawPitch.multiplyToRef(_tmpMat1, _tmpMat1);
            (0, $ha1VO.Quaternion).FromRotationMatrixToRef(_tmpMat1, tmpQuat);
            (0, $ha1VO.Quaternion).SlerpToRef(this._boneQuat, tmpQuat, this.slerpAmount, this._boneQuat);
            this.bone.setRotationQuaternion(this._boneQuat, (0, $dbxbu.Space).WORLD, this.mesh);
            this._slerping = true;
        } else {
            if (this._transformYawPitch) this._transformYawPitch.multiplyToRef(_tmpMat1, _tmpMat1);
            this.bone.setRotationMatrix(_tmpMat1, (0, $dbxbu.Space).WORLD, this.mesh);
            this._slerping = false;
        }
        this._updateLinkedTransformRotation();
    }
    _getAngleDiff(ang1, ang2) {
        let angDiff = ang2 - ang1;
        angDiff %= Math.PI * 2;
        if (angDiff > Math.PI) angDiff -= Math.PI * 2;
        else if (angDiff < -Math.PI) angDiff += Math.PI * 2;
        return angDiff;
    }
    _getAngleBetween(ang1, ang2) {
        ang1 %= 2 * Math.PI;
        ang1 = ang1 < 0 ? ang1 + 2 * Math.PI : ang1;
        ang2 %= 2 * Math.PI;
        ang2 = ang2 < 0 ? ang2 + 2 * Math.PI : ang2;
        let ab = 0;
        if (ang1 < ang2) ab = ang2 - ang1;
        else ab = ang1 - ang2;
        if (ab > Math.PI) ab = Math.PI * 2 - ab;
        return ab;
    }
    _isAngleBetween(ang, ang1, ang2) {
        ang %= 2 * Math.PI;
        ang = ang < 0 ? ang + 2 * Math.PI : ang;
        ang1 %= 2 * Math.PI;
        ang1 = ang1 < 0 ? ang1 + 2 * Math.PI : ang1;
        ang2 %= 2 * Math.PI;
        ang2 = ang2 < 0 ? ang2 + 2 * Math.PI : ang2;
        if (ang1 < ang2) {
            if (ang > ang1 && ang < ang2) return true;
        } else {
            if (ang > ang2 && ang < ang1) return true;
        }
        return false;
    }
    _updateLinkedTransformRotation() {
        const bone = this.bone;
        if (bone._linkedTransformNode) {
            if (!bone._linkedTransformNode.rotationQuaternion) bone._linkedTransformNode.rotationQuaternion = new (0, $ha1VO.Quaternion)();
            bone.getRotationQuaternionToRef((0, $dbxbu.Space).LOCAL, null, bone._linkedTransformNode.rotationQuaternion);
        }
    }
}
$ca8674ced570be27$export$522335dccacd09c6._TmpVecs = (0, $opFp4.ArrayTools).BuildArray(10, (0, $ha1VO.Vector3).Zero);
$ca8674ced570be27$export$522335dccacd09c6._TmpQuat = (0, $ha1VO.Quaternion).Identity();
$ca8674ced570be27$export$522335dccacd09c6._TmpMats = (0, $opFp4.ArrayTools).BuildArray(5, (0, $ha1VO.Matrix).Identity);

});


parcelRegister("fH5IN", function(module, exports) {

var $b4i1f = parcelRequire("b4i1f");

var $6zPKs = parcelRequire("6zPKs");

var $87EOs = parcelRequire("87EOs");
parcelRequire("5gISp");
$parcel$exportWildcard(module.exports, $b4i1f);
$parcel$exportWildcard(module.exports, $6zPKs);
$parcel$exportWildcard(module.exports, $87EOs);

});
parcelRegister("87EOs", function(module, exports) {

$parcel$export(module.exports, "StorageBuffer", () => $5e9ea2beee16e041$export$6e04c0cf5714eff8);
/**
 * This class is a small wrapper around a native buffer that can be read and/or written
 */ class $5e9ea2beee16e041$export$6e04c0cf5714eff8 {
    /**
     * Creates a new storage buffer instance
     * @param engine The engine the buffer will be created inside
     * @param size The size of the buffer in bytes
     * @param creationFlags flags to use when creating the buffer (see undefined). The BUFFER_CREATIONFLAG_STORAGE flag will be automatically added.
     * @param label defines the label of the buffer (for debug purpose)
     */ constructor(engine, size, creationFlags = 3, label){
        this._engine = engine;
        this._label = label;
        this._engine._storageBuffers.push(this);
        this._create(size, creationFlags);
    }
    _create(size, creationFlags) {
        this._bufferSize = size;
        this._creationFlags = creationFlags;
        this._buffer = this._engine.createStorageBuffer(size, creationFlags, this._label);
    }
    /** @internal */ _rebuild() {
        this._create(this._bufferSize, this._creationFlags);
    }
    /**
     * Gets underlying native buffer
     * @returns underlying native buffer
     */ getBuffer() {
        return this._buffer;
    }
    /**
     * Updates the storage buffer
     * @param data the data used to update the storage buffer
     * @param byteOffset the byte offset of the data (optional)
     * @param byteLength the byte length of the data (optional)
     */ update(data, byteOffset, byteLength) {
        if (!this._buffer) return;
        this._engine.updateStorageBuffer(this._buffer, data, byteOffset, byteLength);
    }
    /**
     * Reads data from the storage buffer
     * @param offset The offset in the storage buffer to start reading from (default: 0)
     * @param size  The number of bytes to read from the storage buffer (default: capacity of the buffer)
     * @param buffer The buffer to write the data we have read from the storage buffer to (optional)
     * @param noDelay If true, a call to flushFramebuffer will be issued so that the data can be read back immediately. This can speed up data retrieval, at the cost of a small perf penalty (default: false).
     * @returns If not undefined, returns the (promise) buffer (as provided by the 4th parameter) filled with the data, else it returns a (promise) Uint8Array with the data read from the storage buffer
     */ read(offset, size, buffer, noDelay) {
        return this._engine.readFromStorageBuffer(this._buffer, offset, size, buffer, noDelay);
    }
    /**
     * Disposes the storage buffer
     */ dispose() {
        const storageBuffers = this._engine._storageBuffers;
        const index = storageBuffers.indexOf(this);
        if (index !== -1) {
            storageBuffers[index] = storageBuffers[storageBuffers.length - 1];
            storageBuffers.pop();
        }
        this._engine._releaseBuffer(this._buffer);
        this._buffer = null;
    }
}

});

parcelRegister("5gISp", function(module, exports) {

var $b4i1f = parcelRequire("b4i1f");
const $3d6141f10014c31f$var$isLittleEndian = (()=>{
    const array = new Uint8Array(4);
    const view = new Uint32Array(array.buffer);
    return !!((view[0] = 1) & array[0]);
})();
Object.defineProperty((0, $b4i1f.VertexBuffer).prototype, "effectiveByteStride", {
    get: function() {
        return this._alignedBuffer && this._alignedBuffer.byteStride || this.byteStride;
    },
    enumerable: true,
    configurable: true
});
Object.defineProperty((0, $b4i1f.VertexBuffer).prototype, "effectiveByteOffset", {
    get: function() {
        return this._alignedBuffer ? 0 : this.byteOffset;
    },
    enumerable: true,
    configurable: true
});
Object.defineProperty((0, $b4i1f.VertexBuffer).prototype, "effectiveBuffer", {
    get: function() {
        return this._alignedBuffer && this._alignedBuffer.getBuffer() || this._buffer.getBuffer();
    },
    enumerable: true,
    configurable: true
});
(0, $b4i1f.VertexBuffer).prototype._rebuild = function() {
    this._buffer?._rebuild();
    this._alignedBuffer?._rebuild();
};
(0, $b4i1f.VertexBuffer).prototype.dispose = function() {
    if (this._ownsBuffer) this._buffer.dispose();
    this._alignedBuffer?.dispose();
    this._alignedBuffer = undefined;
    this._isDisposed = true;
};
(0, $b4i1f.VertexBuffer).prototype.getWrapperBuffer = function() {
    return this._alignedBuffer || this._buffer;
};
(0, $b4i1f.VertexBuffer).prototype._alignBuffer = function() {
    const data = this._buffer.getData();
    if (!this.engine._features.forceVertexBufferStrideAndOffsetMultiple4Bytes || this.byteStride % 4 === 0 && this.byteOffset % 4 === 0 || !data) return;
    const typeByteLength = (0, $b4i1f.VertexBuffer).GetTypeByteLength(this.type);
    const alignedByteStride = this.byteStride + 3 & -4;
    const alignedSize = alignedByteStride / typeByteLength;
    const totalVertices = this._maxVerticesCount;
    const totalByteLength = totalVertices * alignedByteStride;
    const totalLength = totalByteLength / typeByteLength;
    let sourceData;
    if (Array.isArray(data)) {
        const sourceDataAsFloat = new Float32Array(data);
        sourceData = new DataView(sourceDataAsFloat.buffer, sourceDataAsFloat.byteOffset, sourceDataAsFloat.byteLength);
    } else if (data instanceof ArrayBuffer) sourceData = new DataView(data, 0, data.byteLength);
    else sourceData = new DataView(data.buffer, data.byteOffset, data.byteLength);
    let alignedData;
    if (this.type === (0, $b4i1f.VertexBuffer).BYTE) alignedData = new Int8Array(totalLength);
    else if (this.type === (0, $b4i1f.VertexBuffer).UNSIGNED_BYTE) alignedData = new Uint8Array(totalLength);
    else if (this.type === (0, $b4i1f.VertexBuffer).SHORT) alignedData = new Int16Array(totalLength);
    else if (this.type === (0, $b4i1f.VertexBuffer).UNSIGNED_SHORT) alignedData = new Uint16Array(totalLength);
    else if (this.type === (0, $b4i1f.VertexBuffer).INT) alignedData = new Int32Array(totalLength);
    else if (this.type === (0, $b4i1f.VertexBuffer).UNSIGNED_INT) alignedData = new Uint32Array(totalLength);
    else alignedData = new Float32Array(totalLength);
    const numComponents = this.getSize();
    let sourceOffset = this.byteOffset;
    for(let i = 0; i < totalVertices; ++i){
        for(let j = 0; j < numComponents; ++j)switch(this.type){
            case (0, $b4i1f.VertexBuffer).BYTE:
                alignedData[i * alignedSize + j] = sourceData.getInt8(sourceOffset + j);
                break;
            case (0, $b4i1f.VertexBuffer).UNSIGNED_BYTE:
                alignedData[i * alignedSize + j] = sourceData.getUint8(sourceOffset + j);
                break;
            case (0, $b4i1f.VertexBuffer).SHORT:
                alignedData[i * alignedSize + j] = sourceData.getInt16(sourceOffset + j * 2, $3d6141f10014c31f$var$isLittleEndian);
                break;
            case (0, $b4i1f.VertexBuffer).UNSIGNED_SHORT:
                alignedData[i * alignedSize + j] = sourceData.getUint16(sourceOffset + j * 2, $3d6141f10014c31f$var$isLittleEndian);
                break;
            case (0, $b4i1f.VertexBuffer).INT:
                alignedData[i * alignedSize + j] = sourceData.getInt32(sourceOffset + j * 4, $3d6141f10014c31f$var$isLittleEndian);
                break;
            case (0, $b4i1f.VertexBuffer).UNSIGNED_INT:
                alignedData[i * alignedSize + j] = sourceData.getUint32(sourceOffset + j * 4, $3d6141f10014c31f$var$isLittleEndian);
                break;
            case (0, $b4i1f.VertexBuffer).FLOAT:
                alignedData[i * alignedSize + j] = sourceData.getFloat32(sourceOffset + j * 4, $3d6141f10014c31f$var$isLittleEndian);
                break;
        }
        sourceOffset += this.byteStride;
    }
    this._alignedBuffer?.dispose();
    this._alignedBuffer = new (0, $b4i1f.Buffer)(this.engine, alignedData, false, alignedByteStride, false, this.getIsInstanced(), true, this.instanceDivisor, (this._label ?? "VertexBuffer") + "_aligned");
};

});


parcelRegister("eCR42", function(module, exports) {
/* eslint-disable import/no-internal-modules */ 
var $lXeMW = parcelRequire("lXeMW");

var $29K1K = parcelRequire("29K1K");

var $74SKQ = parcelRequire("74SKQ");

var $fJj0G = parcelRequire("fJj0G");

var $gSOV5 = parcelRequire("gSOV5");

var $8TToC = parcelRequire("8TToC");

var $8i1MZ = parcelRequire("8i1MZ");

var $jIhlp = parcelRequire("jIhlp");

var $gotsS = parcelRequire("gotsS");

var $aR7MK = parcelRequire("aR7MK");

var $guHki = parcelRequire("guHki");

var $23cQH = parcelRequire("23cQH");

var $7Ipbr = parcelRequire("7Ipbr");

var $9fOIU = parcelRequire("9fOIU");

var $3ilrw = parcelRequire("3ilrw");

var $2ewkx = parcelRequire("2ewkx");

var $765rp = parcelRequire("765rp");

var $awxsD = parcelRequire("awxsD");

var $evQP9 = parcelRequire("evQP9");

var $asrBe = parcelRequire("asrBe");
$parcel$exportWildcard(module.exports, $lXeMW);
$parcel$exportWildcard(module.exports, $29K1K);
$parcel$exportWildcard(module.exports, $74SKQ);
$parcel$exportWildcard(module.exports, $fJj0G);
$parcel$exportWildcard(module.exports, $gSOV5);
$parcel$exportWildcard(module.exports, $8TToC);
$parcel$exportWildcard(module.exports, $8i1MZ);
$parcel$exportWildcard(module.exports, $jIhlp);
$parcel$exportWildcard(module.exports, $gotsS);
$parcel$exportWildcard(module.exports, $aR7MK);
$parcel$exportWildcard(module.exports, $guHki);
$parcel$exportWildcard(module.exports, $23cQH);
$parcel$exportWildcard(module.exports, $7Ipbr);
$parcel$exportWildcard(module.exports, $9fOIU);
$parcel$exportWildcard(module.exports, $3ilrw);
$parcel$exportWildcard(module.exports, $2ewkx);
$parcel$exportWildcard(module.exports, $765rp);
$parcel$exportWildcard(module.exports, $awxsD);
$parcel$exportWildcard(module.exports, $evQP9);
$parcel$exportWildcard(module.exports, $asrBe);

});
parcelRegister("lXeMW", function(module, exports) {

var $dsLI0 = parcelRequire("dsLI0");

var $clSi5 = parcelRequire("clSi5");

var $lQrRY = parcelRequire("lQrRY");

var $24jKF = parcelRequire("24jKF");

var $asLJx = parcelRequire("asLJx");

var $fIdF0 = parcelRequire("fIdF0");

var $6NXHI = parcelRequire("6NXHI");

var $9gxDr = parcelRequire("9gxDr");

var $loMVr = parcelRequire("loMVr");

var $2CmKi = parcelRequire("2CmKi");

var $8SQek = parcelRequire("8SQek");

var $eDb6Y = parcelRequire("eDb6Y");

var $gAphd = parcelRequire("gAphd");

var $kFqWT = parcelRequire("kFqWT");

var $9BJw0 = parcelRequire("9BJw0");

var $bowiC = parcelRequire("bowiC");

var $85CSv = parcelRequire("85CSv");

var $3T1za = parcelRequire("3T1za");

var $8xWbe = parcelRequire("8xWbe");
$parcel$exportWildcard(module.exports, $dsLI0);
$parcel$exportWildcard(module.exports, $clSi5);
$parcel$exportWildcard(module.exports, $lQrRY);
$parcel$exportWildcard(module.exports, $24jKF);
$parcel$exportWildcard(module.exports, $asLJx);
$parcel$exportWildcard(module.exports, $fIdF0);
$parcel$exportWildcard(module.exports, $6NXHI);
$parcel$exportWildcard(module.exports, $9gxDr);
$parcel$exportWildcard(module.exports, $loMVr);
$parcel$exportWildcard(module.exports, $2CmKi);
$parcel$exportWildcard(module.exports, $8SQek);
$parcel$exportWildcard(module.exports, $eDb6Y);
$parcel$exportWildcard(module.exports, $gAphd);
$parcel$exportWildcard(module.exports, $kFqWT);
$parcel$exportWildcard(module.exports, $9BJw0);
$parcel$exportWildcard(module.exports, $bowiC);
$parcel$exportWildcard(module.exports, $85CSv);
$parcel$exportWildcard(module.exports, $3T1za);
$parcel$exportWildcard(module.exports, $8xWbe);

});
parcelRegister("dsLI0", function(module, exports) {

$parcel$export(module.exports, "BaseCameraMouseWheelInput", () => $9cd2e5e0a45e9624$export$b760dc6f96448299);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $diGQf = parcelRequire("diGQf");

var $cfkw4 = parcelRequire("cfkw4");

var $jzXHO = parcelRequire("jzXHO");

var $bOhSV = parcelRequire("bOhSV");
class $9cd2e5e0a45e9624$export$b760dc6f96448299 {
    constructor(){
        /**
         * How fast is the camera moves in relation to X axis mouseWheel events.
         * Use negative value to reverse direction.
         */ this.wheelPrecisionX = 3.0;
        /**
         * How fast is the camera moves in relation to Y axis mouseWheel events.
         * Use negative value to reverse direction.
         */ this.wheelPrecisionY = 3.0;
        /**
         * How fast is the camera moves in relation to Z axis mouseWheel events.
         * Use negative value to reverse direction.
         */ this.wheelPrecisionZ = 3.0;
        /**
         * Observable for when a mouse wheel move event occurs.
         */ this.onChangedObservable = new (0, $diGQf.Observable)();
        /**
         * Incremental value of multiple mouse wheel movements of the X axis.
         * Should be zero-ed when read.
         */ this._wheelDeltaX = 0;
        /**
         * Incremental value of multiple mouse wheel movements of the Y axis.
         * Should be zero-ed when read.
         */ this._wheelDeltaY = 0;
        /**
         * Incremental value of multiple mouse wheel movements of the Z axis.
         * Should be zero-ed when read.
         */ this._wheelDeltaZ = 0;
        /**
         * Firefox uses a different scheme to report scroll distances to other
         * browsers. Rather than use complicated methods to calculate the exact
         * multiple we need to apply, let's just cheat and use a constant.
         * https://developer.mozilla.org/en-US/docs/Web/API/WheelEvent/deltaMode
         * https://stackoverflow.com/questions/20110224/what-is-the-height-of-a-line-in-a-wheel-event-deltamode-dom-delta-line
         */ this._ffMultiplier = 12;
        /**
         * Different event attributes for wheel data fall into a few set ranges.
         * Some relevant but dated date here:
         * https://stackoverflow.com/questions/5527601/normalizing-mousewheel-speed-across-browsers
         */ this._normalize = 120;
    }
    /**
     * Attach the input controls to a specific dom element to get the input from.
     * @param noPreventDefault Defines whether event caught by the controls
     *   should call preventdefault().
     *   (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
     */ attachControl(noPreventDefault) {
        noPreventDefault = (0, $bOhSV.Tools).BackCompatCameraNoPreventDefault(arguments);
        this._wheel = (pointer)=>{
            // sanity check - this should be a PointerWheel event.
            if (pointer.type !== (0, $cfkw4.PointerEventTypes).POINTERWHEEL) return;
            const event = pointer.event;
            const platformScale = event.deltaMode === (0, $jzXHO.EventConstants).DOM_DELTA_LINE ? this._ffMultiplier : 1; // If this happens to be set to DOM_DELTA_LINE, adjust accordingly
            this._wheelDeltaX += this.wheelPrecisionX * platformScale * event.deltaX / this._normalize;
            this._wheelDeltaY -= this.wheelPrecisionY * platformScale * event.deltaY / this._normalize;
            this._wheelDeltaZ += this.wheelPrecisionZ * platformScale * event.deltaZ / this._normalize;
            if (event.preventDefault) {
                if (!noPreventDefault) event.preventDefault();
            }
        };
        this._observer = this.camera.getScene()._inputManager._addCameraPointerObserver(this._wheel, (0, $cfkw4.PointerEventTypes).POINTERWHEEL);
    }
    /**
     * Detach the current controls from the specified dom element.
     */ detachControl() {
        if (this._observer) {
            this.camera.getScene()._inputManager._removeCameraPointerObserver(this._observer);
            this._observer = null;
            this._wheel = null;
        }
        if (this.onChangedObservable) this.onChangedObservable.clear();
    }
    /**
     * Called for each rendered frame.
     */ checkInputs() {
        this.onChangedObservable.notifyObservers({
            wheelDeltaX: this._wheelDeltaX,
            wheelDeltaY: this._wheelDeltaY,
            wheelDeltaZ: this._wheelDeltaZ
        });
        // Clear deltas.
        this._wheelDeltaX = 0;
        this._wheelDeltaY = 0;
        this._wheelDeltaZ = 0;
    }
    /**
     * Gets the class name of the current input.
     * @returns the class name
     */ getClassName() {
        return "BaseCameraMouseWheelInput";
    }
    /**
     * Get the friendly name associated with the input class.
     * @returns the input friendly name
     */ getSimpleName() {
        return "mousewheel";
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9cd2e5e0a45e9624$export$b760dc6f96448299.prototype, "wheelPrecisionX", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9cd2e5e0a45e9624$export$b760dc6f96448299.prototype, "wheelPrecisionY", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9cd2e5e0a45e9624$export$b760dc6f96448299.prototype, "wheelPrecisionZ", void 0);

});

parcelRegister("clSi5", function(module, exports) {

$parcel$export(module.exports, "BaseCameraPointersInput", () => $8fe18f34372a4966$export$7aa7850931793f07);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $bOhSV = parcelRequire("bOhSV");

var $cfkw4 = parcelRequire("cfkw4");
class $8fe18f34372a4966$export$7aa7850931793f07 {
    constructor(){
        this._currentActiveButton = -1;
        /**
         * Defines the buttons associated with the input to handle camera move.
         */ this.buttons = [
            0,
            1,
            2
        ];
    }
    /**
     * Attach the input controls to a specific dom element to get the input from.
     * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
     */ attachControl(noPreventDefault) {
        // eslint-disable-next-line prefer-rest-params
        noPreventDefault = (0, $bOhSV.Tools).BackCompatCameraNoPreventDefault(arguments);
        const engine = this.camera.getEngine();
        const element = engine.getInputElement();
        let previousPinchSquaredDistance = 0;
        let previousMultiTouchPanPosition = null;
        this._pointA = null;
        this._pointB = null;
        this._altKey = false;
        this._ctrlKey = false;
        this._metaKey = false;
        this._shiftKey = false;
        this._buttonsPressed = 0;
        this._pointerInput = (p)=>{
            const evt = p.event;
            const isTouch = evt.pointerType === "touch";
            if (p.type !== (0, $cfkw4.PointerEventTypes).POINTERMOVE && this.buttons.indexOf(evt.button) === -1) return;
            const srcElement = evt.target;
            this._altKey = evt.altKey;
            this._ctrlKey = evt.ctrlKey;
            this._metaKey = evt.metaKey;
            this._shiftKey = evt.shiftKey;
            this._buttonsPressed = evt.buttons;
            if (engine.isPointerLock) {
                const offsetX = evt.movementX;
                const offsetY = evt.movementY;
                this.onTouch(null, offsetX, offsetY);
                this._pointA = null;
                this._pointB = null;
            } else if (p.type !== (0, $cfkw4.PointerEventTypes).POINTERDOWN && isTouch && this._pointA?.pointerId !== evt.pointerId && this._pointB?.pointerId !== evt.pointerId) return; // If we get a non-down event for a touch that we're not tracking, ignore it
            else if (p.type === (0, $cfkw4.PointerEventTypes).POINTERDOWN && (this._currentActiveButton === -1 || isTouch)) {
                try {
                    srcElement?.setPointerCapture(evt.pointerId);
                } catch (e) {
                //Nothing to do with the error. Execution will continue.
                }
                if (this._pointA === null) this._pointA = {
                    x: evt.clientX,
                    y: evt.clientY,
                    pointerId: evt.pointerId,
                    type: evt.pointerType
                };
                else if (this._pointB === null) this._pointB = {
                    x: evt.clientX,
                    y: evt.clientY,
                    pointerId: evt.pointerId,
                    type: evt.pointerType
                };
                else return; // We are already tracking two pointers so ignore this one
                if (this._currentActiveButton === -1 && !isTouch) this._currentActiveButton = evt.button;
                this.onButtonDown(evt);
                if (!noPreventDefault) {
                    evt.preventDefault();
                    element && element.focus();
                }
            } else if (p.type === (0, $cfkw4.PointerEventTypes).POINTERDOUBLETAP) this.onDoubleTap(evt.pointerType);
            else if (p.type === (0, $cfkw4.PointerEventTypes).POINTERUP && (this._currentActiveButton === evt.button || isTouch)) {
                try {
                    srcElement?.releasePointerCapture(evt.pointerId);
                } catch (e) {
                //Nothing to do with the error.
                }
                if (!isTouch) this._pointB = null; // Mouse and pen are mono pointer
                //would be better to use pointers.remove(evt.pointerId) for multitouch gestures,
                //but emptying completely pointers collection is required to fix a bug on iPhone :
                //when changing orientation while pinching camera,
                //one pointer stay pressed forever if we don't release all pointers
                //will be ok to put back pointers.remove(evt.pointerId); when iPhone bug corrected
                if (engine._badOS) this._pointA = this._pointB = null;
                else {
                    //only remove the impacted pointer in case of multitouch allowing on most
                    //platforms switching from rotate to zoom and pan seamlessly.
                    if (this._pointB && this._pointA && this._pointA.pointerId == evt.pointerId) {
                        this._pointA = this._pointB;
                        this._pointB = null;
                    } else if (this._pointA && this._pointB && this._pointB.pointerId == evt.pointerId) this._pointB = null;
                    else this._pointA = this._pointB = null;
                }
                if (previousPinchSquaredDistance !== 0 || previousMultiTouchPanPosition) {
                    // Previous pinch data is populated but a button has been lifted
                    // so pinch has ended.
                    this.onMultiTouch(this._pointA, this._pointB, previousPinchSquaredDistance, 0, previousMultiTouchPanPosition, null // multiTouchPanPosition
                    );
                    previousPinchSquaredDistance = 0;
                    previousMultiTouchPanPosition = null;
                }
                this._currentActiveButton = -1;
                this.onButtonUp(evt);
                if (!noPreventDefault) evt.preventDefault();
            } else if (p.type === (0, $cfkw4.PointerEventTypes).POINTERMOVE) {
                if (!noPreventDefault) evt.preventDefault();
                // One button down
                if (this._pointA && this._pointB === null) {
                    const offsetX = evt.clientX - this._pointA.x;
                    const offsetY = evt.clientY - this._pointA.y;
                    this.onTouch(this._pointA, offsetX, offsetY);
                    this._pointA.x = evt.clientX;
                    this._pointA.y = evt.clientY;
                } else if (this._pointA && this._pointB) {
                    const ed = this._pointA.pointerId === evt.pointerId ? this._pointA : this._pointB;
                    ed.x = evt.clientX;
                    ed.y = evt.clientY;
                    const distX = this._pointA.x - this._pointB.x;
                    const distY = this._pointA.y - this._pointB.y;
                    const pinchSquaredDistance = distX * distX + distY * distY;
                    const multiTouchPanPosition = {
                        x: (this._pointA.x + this._pointB.x) / 2,
                        y: (this._pointA.y + this._pointB.y) / 2,
                        pointerId: evt.pointerId,
                        type: p.type
                    };
                    this.onMultiTouch(this._pointA, this._pointB, previousPinchSquaredDistance, pinchSquaredDistance, previousMultiTouchPanPosition, multiTouchPanPosition);
                    previousMultiTouchPanPosition = multiTouchPanPosition;
                    previousPinchSquaredDistance = pinchSquaredDistance;
                }
            }
        };
        this._observer = this.camera.getScene()._inputManager._addCameraPointerObserver(this._pointerInput, (0, $cfkw4.PointerEventTypes).POINTERDOWN | (0, $cfkw4.PointerEventTypes).POINTERUP | (0, $cfkw4.PointerEventTypes).POINTERMOVE | (0, $cfkw4.PointerEventTypes).POINTERDOUBLETAP);
        this._onLostFocus = ()=>{
            this._pointA = this._pointB = null;
            previousPinchSquaredDistance = 0;
            previousMultiTouchPanPosition = null;
            this.onLostFocus();
        };
        this._contextMenuBind = (evt)=>this.onContextMenu(evt);
        element && element.addEventListener("contextmenu", this._contextMenuBind, false);
        const hostWindow = this.camera.getScene().getEngine().getHostWindow();
        if (hostWindow) (0, $bOhSV.Tools).RegisterTopRootEvents(hostWindow, [
            {
                name: "blur",
                handler: this._onLostFocus
            }
        ]);
    }
    /**
     * Detach the current controls from the specified dom element.
     */ detachControl() {
        if (this._onLostFocus) {
            const hostWindow = this.camera.getScene().getEngine().getHostWindow();
            if (hostWindow) (0, $bOhSV.Tools).UnregisterTopRootEvents(hostWindow, [
                {
                    name: "blur",
                    handler: this._onLostFocus
                }
            ]);
        }
        if (this._observer) {
            this.camera.getScene()._inputManager._removeCameraPointerObserver(this._observer);
            this._observer = null;
            if (this._contextMenuBind) {
                const inputElement = this.camera.getScene().getEngine().getInputElement();
                inputElement && inputElement.removeEventListener("contextmenu", this._contextMenuBind);
            }
            this._onLostFocus = null;
        }
        this._altKey = false;
        this._ctrlKey = false;
        this._metaKey = false;
        this._shiftKey = false;
        this._buttonsPressed = 0;
        this._currentActiveButton = -1;
    }
    /**
     * Gets the class name of the current input.
     * @returns the class name
     */ getClassName() {
        return "BaseCameraPointersInput";
    }
    /**
     * Get the friendly name associated with the input class.
     * @returns the input friendly name
     */ getSimpleName() {
        return "pointers";
    }
    /**
     * Called on pointer POINTERDOUBLETAP event.
     * Override this method to provide functionality on POINTERDOUBLETAP event.
     * @param type type of event
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onDoubleTap(type) {}
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    /**
     * Called on pointer POINTERMOVE event if only a single touch is active.
     * Override this method to provide functionality.
     * @param point The current position of the pointer
     * @param offsetX The offsetX of the pointer when the event occurred
     * @param offsetY The offsetY of the pointer when the event occurred
     */ onTouch(point, offsetX, offsetY) {}
    /**
     * Called on pointer POINTERMOVE event if multiple touches are active.
     * Override this method to provide functionality.
     * @param _pointA First point in the pair
     * @param _pointB Second point in the pair
     * @param previousPinchSquaredDistance Sqr Distance between the points the last time this event was fired (by this input)
     * @param pinchSquaredDistance Sqr Distance between the points this time
     * @param previousMultiTouchPanPosition Previous center point between the points
     * @param multiTouchPanPosition Current center point between the points
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onMultiTouch(_pointA, _pointB, previousPinchSquaredDistance, pinchSquaredDistance, previousMultiTouchPanPosition, multiTouchPanPosition) {}
    /**
     * Called on JS contextmenu event.
     * Override this method to provide functionality.
     * @param evt the event to be handled
     */ onContextMenu(evt) {
        evt.preventDefault();
    }
    /**
     * Called each time a new POINTERDOWN event occurs. Ie, for each button
     * press.
     * Override this method to provide functionality.
     * @param _evt Defines the event to track
     */ onButtonDown(_evt) {}
    /**
     * Called each time a new POINTERUP event occurs. Ie, for each button
     * release.
     * Override this method to provide functionality.
     * @param _evt Defines the event to track
     */ onButtonUp(_evt) {}
    /**
     * Called when window becomes inactive.
     * Override this method to provide functionality.
     */ onLostFocus() {}
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $8fe18f34372a4966$export$7aa7850931793f07.prototype, "buttons", void 0);

});

parcelRegister("lQrRY", function(module, exports) {

$parcel$export(module.exports, "ArcRotateCameraGamepadInput", () => $fe7412a381f8ded2$export$2fb98b9564541b8b);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $29K1K = parcelRequire("29K1K");

var $6gZ9Y = parcelRequire("6gZ9Y");
class $fe7412a381f8ded2$export$2fb98b9564541b8b {
    constructor(){
        /**
         * Defines the gamepad rotation sensibility.
         * This is the threshold from when rotation starts to be accounted for to prevent jittering.
         */ this.gamepadRotationSensibility = 80;
        /**
         * Defines the gamepad move sensibility.
         * This is the threshold from when moving starts to be accounted for for to prevent jittering.
         */ this.gamepadMoveSensibility = 40;
        this._yAxisScale = 1.0;
    }
    /**
     * Gets or sets a boolean indicating that Yaxis (for right stick) should be inverted
     */ get invertYAxis() {
        return this._yAxisScale !== 1.0;
    }
    set invertYAxis(value) {
        this._yAxisScale = value ? -1 : 1.0;
    }
    /**
     * Attach the input controls to a specific dom element to get the input from.
     */ attachControl() {
        const manager = this.camera.getScene().gamepadManager;
        this._onGamepadConnectedObserver = manager.onGamepadConnectedObservable.add((gamepad)=>{
            if (gamepad.type !== (0, $6gZ9Y.Gamepad).POSE_ENABLED) // prioritize XBOX gamepads.
            {
                if (!this.gamepad || gamepad.type === (0, $6gZ9Y.Gamepad).XBOX) this.gamepad = gamepad;
            }
        });
        this._onGamepadDisconnectedObserver = manager.onGamepadDisconnectedObservable.add((gamepad)=>{
            if (this.gamepad === gamepad) this.gamepad = null;
        });
        this.gamepad = manager.getGamepadByType((0, $6gZ9Y.Gamepad).XBOX);
        // if no xbox controller was found, but there are gamepad controllers, take the first one
        if (!this.gamepad && manager.gamepads.length) this.gamepad = manager.gamepads[0];
    }
    /**
     * Detach the current controls from the specified dom element.
     */ detachControl() {
        this.camera.getScene().gamepadManager.onGamepadConnectedObservable.remove(this._onGamepadConnectedObserver);
        this.camera.getScene().gamepadManager.onGamepadDisconnectedObservable.remove(this._onGamepadDisconnectedObserver);
        this.gamepad = null;
    }
    /**
     * Update the current camera state depending on the inputs that have been used this frame.
     * This is a dynamically created lambda to avoid the performance penalty of looping for inputs in the render loop.
     */ checkInputs() {
        if (this.gamepad) {
            const camera = this.camera;
            const rsValues = this.gamepad.rightStick;
            if (rsValues) {
                if (rsValues.x != 0) {
                    const normalizedRX = rsValues.x / this.gamepadRotationSensibility;
                    if (normalizedRX != 0 && Math.abs(normalizedRX) > 0.005) camera.inertialAlphaOffset += normalizedRX;
                }
                if (rsValues.y != 0) {
                    const normalizedRY = rsValues.y / this.gamepadRotationSensibility * this._yAxisScale;
                    if (normalizedRY != 0 && Math.abs(normalizedRY) > 0.005) camera.inertialBetaOffset += normalizedRY;
                }
            }
            const lsValues = this.gamepad.leftStick;
            if (lsValues && lsValues.y != 0) {
                const normalizedLY = lsValues.y / this.gamepadMoveSensibility;
                if (normalizedLY != 0 && Math.abs(normalizedLY) > 0.005) this.camera.inertialRadiusOffset -= normalizedLY;
            }
        }
    }
    /**
     * Gets the class name of the current intput.
     * @returns the class name
     */ getClassName() {
        return "ArcRotateCameraGamepadInput";
    }
    /**
     * Get the friendly name associated with the input class.
     * @returns the input friendly name
     */ getSimpleName() {
        return "gamepad";
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $fe7412a381f8ded2$export$2fb98b9564541b8b.prototype, "gamepadRotationSensibility", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $fe7412a381f8ded2$export$2fb98b9564541b8b.prototype, "gamepadMoveSensibility", void 0);
(0, $29K1K.CameraInputTypes)["ArcRotateCameraGamepadInput"] = $fe7412a381f8ded2$export$2fb98b9564541b8b;

});
parcelRegister("29K1K", function(module, exports) {

$parcel$export(module.exports, "CameraInputTypes", () => $1920200f7582fd1d$export$19a2c4de0d3d218f);
$parcel$export(module.exports, "CameraInputsManager", () => $1920200f7582fd1d$export$6f455b9fd6012781);

var $kVtWi = parcelRequire("kVtWi");

var $6Ho1L = parcelRequire("6Ho1L");

var $74SKQ = parcelRequire("74SKQ");
var $1920200f7582fd1d$export$19a2c4de0d3d218f = {};
class $1920200f7582fd1d$export$6f455b9fd6012781 {
    /**
     * Instantiate a new Camera Input Manager.
     * @param camera Defines the camera the input manager belongs to
     */ constructor(camera){
        /**
         * Defines the dom element the camera is collecting inputs from.
         * This is null if the controls have not been attached.
         */ this.attachedToElement = false;
        this.attached = {};
        this.camera = camera;
        this.checkInputs = ()=>{};
    }
    /**
     * Add an input method to a camera
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/customizingCameraInputs
     * @param input Camera input method
     */ add(input) {
        const type = input.getSimpleName();
        if (this.attached[type]) {
            (0, $kVtWi.Logger).Warn("camera input of type " + type + " already exists on camera");
            return;
        }
        this.attached[type] = input;
        input.camera = this.camera;
        // for checkInputs, we are dynamically creating a function
        // the goal is to avoid the performance penalty of looping for inputs in the render loop
        if (input.checkInputs) this.checkInputs = this._addCheckInputs(input.checkInputs.bind(input));
        if (this.attachedToElement) input.attachControl(this.noPreventDefault);
    }
    /**
     * Remove a specific input method from a camera
     * example: camera.inputs.remove(camera.inputs.attached.mouse);
     * @param inputToRemove camera input method
     */ remove(inputToRemove) {
        for(const cam in this.attached){
            const input = this.attached[cam];
            if (input === inputToRemove) {
                input.detachControl();
                input.camera = null;
                delete this.attached[cam];
                this.rebuildInputCheck();
                return;
            }
        }
    }
    /**
     * Remove a specific input type from a camera
     * example: camera.inputs.remove("ArcRotateCameraGamepadInput");
     * @param inputType the type of the input to remove
     */ removeByType(inputType) {
        for(const cam in this.attached){
            const input = this.attached[cam];
            if (input.getClassName() === inputType) {
                input.detachControl();
                input.camera = null;
                delete this.attached[cam];
                this.rebuildInputCheck();
            }
        }
    }
    _addCheckInputs(fn) {
        const current = this.checkInputs;
        return ()=>{
            current();
            fn();
        };
    }
    /**
     * Attach the input controls to the currently attached dom element to listen the events from.
     * @param input Defines the input to attach
     */ attachInput(input) {
        if (this.attachedToElement) input.attachControl(this.noPreventDefault);
    }
    /**
     * Attach the current manager inputs controls to a specific dom element to listen the events from.
     * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
     */ attachElement(noPreventDefault = false) {
        if (this.attachedToElement) return;
        noPreventDefault = (0, $74SKQ.Camera).ForceAttachControlToAlwaysPreventDefault ? false : noPreventDefault;
        this.attachedToElement = true;
        this.noPreventDefault = noPreventDefault;
        for(const cam in this.attached)this.attached[cam].attachControl(noPreventDefault);
    }
    /**
     * Detach the current manager inputs controls from a specific dom element.
     * @param disconnect Defines whether the input should be removed from the current list of attached inputs
     */ detachElement(disconnect = false) {
        for(const cam in this.attached){
            this.attached[cam].detachControl();
            if (disconnect) this.attached[cam].camera = null;
        }
        this.attachedToElement = false;
    }
    /**
     * Rebuild the dynamic inputCheck function from the current list of
     * defined inputs in the manager.
     */ rebuildInputCheck() {
        this.checkInputs = ()=>{};
        for(const cam in this.attached){
            const input = this.attached[cam];
            if (input.checkInputs) this.checkInputs = this._addCheckInputs(input.checkInputs.bind(input));
        }
    }
    /**
     * Remove all attached input methods from a camera
     */ clear() {
        if (this.attachedToElement) this.detachElement(true);
        this.attached = {};
        this.attachedToElement = false;
        this.checkInputs = ()=>{};
    }
    /**
     * Serialize the current input manager attached to a camera.
     * This ensures than once parsed,
     * the input associated to the camera will be identical to the current ones
     * @param serializedCamera Defines the camera serialization JSON the input serialization should write to
     */ serialize(serializedCamera) {
        const inputs = {};
        for(const cam in this.attached){
            const input = this.attached[cam];
            const res = (0, $6Ho1L.SerializationHelper).Serialize(input);
            inputs[input.getClassName()] = res;
        }
        serializedCamera.inputsmgr = inputs;
    }
    /**
     * Parses an input manager serialized JSON to restore the previous list of inputs
     * and states associated to a camera.
     * @param parsedCamera Defines the JSON to parse
     */ parse(parsedCamera) {
        const parsedInputs = parsedCamera.inputsmgr;
        if (parsedInputs) {
            this.clear();
            for(const n in parsedInputs){
                const construct = $1920200f7582fd1d$export$19a2c4de0d3d218f[n];
                if (construct) {
                    const parsedinput = parsedInputs[n];
                    const input = (0, $6Ho1L.SerializationHelper).Parse(()=>{
                        return new construct();
                    }, parsedinput, null);
                    this.add(input);
                }
            }
        } else //2016-03-08 this part is for managing backward compatibility
        for(const n in this.attached){
            const construct = $1920200f7582fd1d$export$19a2c4de0d3d218f[this.attached[n].getClassName()];
            if (construct) {
                const input = (0, $6Ho1L.SerializationHelper).Parse(()=>{
                    return new construct();
                }, parsedCamera, null);
                this.remove(this.attached[n]);
                this.add(input);
            }
        }
    }
}

});

parcelRegister("6gZ9Y", function(module, exports) {

$parcel$export(module.exports, "StickValues", () => $4913adc2837bfd2c$export$748ca82849e9a09b);
$parcel$export(module.exports, "Gamepad", () => $4913adc2837bfd2c$export$27a9cd7ebdd38262);
$parcel$export(module.exports, "GenericPad", () => $4913adc2837bfd2c$export$ac27c62e8e13ce4b);

var $diGQf = parcelRequire("diGQf");
class $4913adc2837bfd2c$export$748ca82849e9a09b {
    /**
     * Initializes the gamepad x and y control stick values
     * @param x The x component of the gamepad control stick value
     * @param y The y component of the gamepad control stick value
     */ constructor(/**
     * The x component of the control stick
     */ x, /**
     * The y component of the control stick
     */ y){
        this.x = x;
        this.y = y;
    }
}
class $4913adc2837bfd2c$export$27a9cd7ebdd38262 {
    /**
     * Specifies if the gamepad has been connected
     */ get isConnected() {
        return this._isConnected;
    }
    /**
     * Initializes the gamepad
     * @param id The id of the gamepad
     * @param index The index of the gamepad
     * @param browserGamepad The browser gamepad
     * @param leftStickX The x component of the left joystick
     * @param leftStickY The y component of the left joystick
     * @param rightStickX The x component of the right joystick
     * @param rightStickY The y component of the right joystick
     */ constructor(/**
     * The id of the gamepad
     */ id, /**
     * The index of the gamepad
     */ index, /**
     * The browser gamepad
     */ browserGamepad, leftStickX = 0, leftStickY = 1, rightStickX = 2, rightStickY = 3){
        this.id = id;
        this.index = index;
        this.browserGamepad = browserGamepad;
        this._leftStick = {
            x: 0,
            y: 0
        };
        this._rightStick = {
            x: 0,
            y: 0
        };
        /** @internal */ this._isConnected = true;
        /**
         * Specifies whether the left control stick should be Y-inverted
         */ this._invertLeftStickY = false;
        this.type = $4913adc2837bfd2c$export$27a9cd7ebdd38262.GAMEPAD;
        this._leftStickAxisX = leftStickX;
        this._leftStickAxisY = leftStickY;
        this._rightStickAxisX = rightStickX;
        this._rightStickAxisY = rightStickY;
        if (this.browserGamepad.axes.length >= 2) this._leftStick = {
            x: this.browserGamepad.axes[this._leftStickAxisX],
            y: this.browserGamepad.axes[this._leftStickAxisY]
        };
        if (this.browserGamepad.axes.length >= 4) this._rightStick = {
            x: this.browserGamepad.axes[this._rightStickAxisX],
            y: this.browserGamepad.axes[this._rightStickAxisY]
        };
    }
    /**
     * Callback triggered when the left joystick has changed
     * @param callback callback to trigger
     */ onleftstickchanged(callback) {
        this._onleftstickchanged = callback;
    }
    /**
     * Callback triggered when the right joystick has changed
     * @param callback callback to trigger
     */ onrightstickchanged(callback) {
        this._onrightstickchanged = callback;
    }
    /**
     * Gets the left joystick
     */ get leftStick() {
        return this._leftStick;
    }
    /**
     * Sets the left joystick values
     */ set leftStick(newValues) {
        if (this._onleftstickchanged && (this._leftStick.x !== newValues.x || this._leftStick.y !== newValues.y)) this._onleftstickchanged(newValues);
        this._leftStick = newValues;
    }
    /**
     * Gets the right joystick
     */ get rightStick() {
        return this._rightStick;
    }
    /**
     * Sets the right joystick value
     */ set rightStick(newValues) {
        if (this._onrightstickchanged && (this._rightStick.x !== newValues.x || this._rightStick.y !== newValues.y)) this._onrightstickchanged(newValues);
        this._rightStick = newValues;
    }
    /**
     * Updates the gamepad joystick positions
     */ update() {
        if (this._leftStick) {
            this.leftStick = {
                x: this.browserGamepad.axes[this._leftStickAxisX],
                y: this.browserGamepad.axes[this._leftStickAxisY]
            };
            if (this._invertLeftStickY) this.leftStick.y *= -1;
        }
        if (this._rightStick) this.rightStick = {
            x: this.browserGamepad.axes[this._rightStickAxisX],
            y: this.browserGamepad.axes[this._rightStickAxisY]
        };
    }
    /**
     * Disposes the gamepad
     */ dispose() {}
}
/**
 * Represents a gamepad controller
 */ $4913adc2837bfd2c$export$27a9cd7ebdd38262.GAMEPAD = 0;
/**
 * Represents a generic controller
 */ $4913adc2837bfd2c$export$27a9cd7ebdd38262.GENERIC = 1;
/**
 * Represents an XBox controller
 */ $4913adc2837bfd2c$export$27a9cd7ebdd38262.XBOX = 2;
/**
 * Represents a pose-enabled controller
 */ $4913adc2837bfd2c$export$27a9cd7ebdd38262.POSE_ENABLED = 3;
/**
 * Represents an Dual Shock controller
 */ $4913adc2837bfd2c$export$27a9cd7ebdd38262.DUALSHOCK = 4;
class $4913adc2837bfd2c$export$ac27c62e8e13ce4b extends $4913adc2837bfd2c$export$27a9cd7ebdd38262 {
    /**
     * Callback triggered when a button has been pressed
     * @param callback Called when a button has been pressed
     */ onbuttondown(callback) {
        this._onbuttondown = callback;
    }
    /**
     * Callback triggered when a button has been released
     * @param callback Called when a button has been released
     */ onbuttonup(callback) {
        this._onbuttonup = callback;
    }
    /**
     * Initializes the generic gamepad
     * @param id The id of the generic gamepad
     * @param index The index of the generic gamepad
     * @param browserGamepad The browser gamepad
     */ constructor(id, index, browserGamepad){
        super(id, index, browserGamepad);
        /**
         * Observable triggered when a button has been pressed
         */ this.onButtonDownObservable = new (0, $diGQf.Observable)();
        /**
         * Observable triggered when a button has been released
         */ this.onButtonUpObservable = new (0, $diGQf.Observable)();
        this.type = $4913adc2837bfd2c$export$27a9cd7ebdd38262.GENERIC;
        this._buttons = new Array(browserGamepad.buttons.length);
    }
    _setButtonValue(newValue, currentValue, buttonIndex) {
        if (newValue !== currentValue) {
            if (newValue === 1) {
                if (this._onbuttondown) this._onbuttondown(buttonIndex);
                this.onButtonDownObservable.notifyObservers(buttonIndex);
            }
            if (newValue === 0) {
                if (this._onbuttonup) this._onbuttonup(buttonIndex);
                this.onButtonUpObservable.notifyObservers(buttonIndex);
            }
        }
        return newValue;
    }
    /**
     * Updates the generic gamepad
     */ update() {
        super.update();
        for(let index = 0; index < this._buttons.length; index++)this._buttons[index] = this._setButtonValue(this.browserGamepad.buttons[index].value, this._buttons[index], index);
    }
    /**
     * Disposes the generic gamepad
     */ dispose() {
        super.dispose();
        this.onButtonDownObservable.clear();
        this.onButtonUpObservable.clear();
    }
}

});


parcelRegister("24jKF", function(module, exports) {

$parcel$export(module.exports, "ArcRotateCameraKeyboardMoveInput", () => $181b46c40b28cc66$export$5968949a47534c31);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $29K1K = parcelRequire("29K1K");

var $bcFoB = parcelRequire("bcFoB");

var $bOhSV = parcelRequire("bOhSV");
class $181b46c40b28cc66$export$5968949a47534c31 {
    constructor(){
        /**
         * Defines the list of key codes associated with the up action (increase alpha)
         */ this.keysUp = [
            38
        ];
        /**
         * Defines the list of key codes associated with the down action (decrease alpha)
         */ this.keysDown = [
            40
        ];
        /**
         * Defines the list of key codes associated with the left action (increase beta)
         */ this.keysLeft = [
            37
        ];
        /**
         * Defines the list of key codes associated with the right action (decrease beta)
         */ this.keysRight = [
            39
        ];
        /**
         * Defines the list of key codes associated with the reset action.
         * Those keys reset the camera to its last stored state (with the method camera.storeState())
         */ this.keysReset = [
            220
        ];
        /**
         * Defines the panning sensibility of the inputs.
         * (How fast is the camera panning)
         */ this.panningSensibility = 50.0;
        /**
         * Defines the zooming sensibility of the inputs.
         * (How fast is the camera zooming)
         */ this.zoomingSensibility = 25.0;
        /**
         * Defines whether maintaining the alt key down switch the movement mode from
         * orientation to zoom.
         */ this.useAltToZoom = true;
        /**
         * Rotation speed of the camera
         */ this.angularSpeed = 0.01;
        this._keys = new Array();
    }
    /**
     * Attach the input controls to a specific dom element to get the input from.
     * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
     */ attachControl(noPreventDefault) {
        // was there a second variable defined?
        // eslint-disable-next-line prefer-rest-params
        noPreventDefault = (0, $bOhSV.Tools).BackCompatCameraNoPreventDefault(arguments);
        if (this._onCanvasBlurObserver) return;
        this._scene = this.camera.getScene();
        this._engine = this._scene.getEngine();
        this._onCanvasBlurObserver = this._engine.onCanvasBlurObservable.add(()=>{
            this._keys.length = 0;
        });
        this._onKeyboardObserver = this._scene.onKeyboardObservable.add((info)=>{
            const evt = info.event;
            if (!evt.metaKey) {
                if (info.type === (0, $bcFoB.KeyboardEventTypes).KEYDOWN) {
                    this._ctrlPressed = evt.ctrlKey;
                    this._altPressed = evt.altKey;
                    if (this.keysUp.indexOf(evt.keyCode) !== -1 || this.keysDown.indexOf(evt.keyCode) !== -1 || this.keysLeft.indexOf(evt.keyCode) !== -1 || this.keysRight.indexOf(evt.keyCode) !== -1 || this.keysReset.indexOf(evt.keyCode) !== -1) {
                        const index = this._keys.indexOf(evt.keyCode);
                        if (index === -1) this._keys.push(evt.keyCode);
                        if (evt.preventDefault) {
                            if (!noPreventDefault) evt.preventDefault();
                        }
                    }
                } else if (this.keysUp.indexOf(evt.keyCode) !== -1 || this.keysDown.indexOf(evt.keyCode) !== -1 || this.keysLeft.indexOf(evt.keyCode) !== -1 || this.keysRight.indexOf(evt.keyCode) !== -1 || this.keysReset.indexOf(evt.keyCode) !== -1) {
                    const index = this._keys.indexOf(evt.keyCode);
                    if (index >= 0) this._keys.splice(index, 1);
                    if (evt.preventDefault) {
                        if (!noPreventDefault) evt.preventDefault();
                    }
                }
            }
        });
    }
    /**
     * Detach the current controls from the specified dom element.
     */ detachControl() {
        if (this._scene) {
            if (this._onKeyboardObserver) this._scene.onKeyboardObservable.remove(this._onKeyboardObserver);
            if (this._onCanvasBlurObserver) this._engine.onCanvasBlurObservable.remove(this._onCanvasBlurObserver);
            this._onKeyboardObserver = null;
            this._onCanvasBlurObserver = null;
        }
        this._keys.length = 0;
    }
    /**
     * Update the current camera state depending on the inputs that have been used this frame.
     * This is a dynamically created lambda to avoid the performance penalty of looping for inputs in the render loop.
     */ checkInputs() {
        if (this._onKeyboardObserver) {
            const camera = this.camera;
            for(let index = 0; index < this._keys.length; index++){
                const keyCode = this._keys[index];
                if (this.keysLeft.indexOf(keyCode) !== -1) {
                    if (this._ctrlPressed && this.camera._useCtrlForPanning) camera.inertialPanningX -= 1 / this.panningSensibility;
                    else camera.inertialAlphaOffset -= this.angularSpeed;
                } else if (this.keysUp.indexOf(keyCode) !== -1) {
                    if (this._ctrlPressed && this.camera._useCtrlForPanning) camera.inertialPanningY += 1 / this.panningSensibility;
                    else if (this._altPressed && this.useAltToZoom) camera.inertialRadiusOffset += 1 / this.zoomingSensibility;
                    else camera.inertialBetaOffset -= this.angularSpeed;
                } else if (this.keysRight.indexOf(keyCode) !== -1) {
                    if (this._ctrlPressed && this.camera._useCtrlForPanning) camera.inertialPanningX += 1 / this.panningSensibility;
                    else camera.inertialAlphaOffset += this.angularSpeed;
                } else if (this.keysDown.indexOf(keyCode) !== -1) {
                    if (this._ctrlPressed && this.camera._useCtrlForPanning) camera.inertialPanningY -= 1 / this.panningSensibility;
                    else if (this._altPressed && this.useAltToZoom) camera.inertialRadiusOffset -= 1 / this.zoomingSensibility;
                    else camera.inertialBetaOffset += this.angularSpeed;
                } else if (this.keysReset.indexOf(keyCode) !== -1) {
                    if (camera.useInputToRestoreState) camera.restoreState();
                }
            }
        }
    }
    /**
     * Gets the class name of the current input.
     * @returns the class name
     */ getClassName() {
        return "ArcRotateCameraKeyboardMoveInput";
    }
    /**
     * Get the friendly name associated with the input class.
     * @returns the input friendly name
     */ getSimpleName() {
        return "keyboard";
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $181b46c40b28cc66$export$5968949a47534c31.prototype, "keysUp", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $181b46c40b28cc66$export$5968949a47534c31.prototype, "keysDown", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $181b46c40b28cc66$export$5968949a47534c31.prototype, "keysLeft", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $181b46c40b28cc66$export$5968949a47534c31.prototype, "keysRight", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $181b46c40b28cc66$export$5968949a47534c31.prototype, "keysReset", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $181b46c40b28cc66$export$5968949a47534c31.prototype, "panningSensibility", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $181b46c40b28cc66$export$5968949a47534c31.prototype, "zoomingSensibility", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $181b46c40b28cc66$export$5968949a47534c31.prototype, "useAltToZoom", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $181b46c40b28cc66$export$5968949a47534c31.prototype, "angularSpeed", void 0);
(0, $29K1K.CameraInputTypes)["ArcRotateCameraKeyboardMoveInput"] = $181b46c40b28cc66$export$5968949a47534c31;

});

parcelRegister("asLJx", function(module, exports) {

$parcel$export(module.exports, "ArcRotateCameraMouseWheelInput", () => $79e18bc39470cd29$export$6603ac392977df4);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $29K1K = parcelRequire("29K1K");

var $cfkw4 = parcelRequire("cfkw4");

var $23POp = parcelRequire("23POp");

var $ha1VO = parcelRequire("ha1VO");

var $53VPf = parcelRequire("53VPf");

var $jzXHO = parcelRequire("jzXHO");

var $1VEEL = parcelRequire("1VEEL");

var $bOhSV = parcelRequire("bOhSV");
/**
 * Firefox uses a different scheme to report scroll distances to other
 * browsers. Rather than use complicated methods to calculate the exact
 * multiple we need to apply, let's just cheat and use a constant.
 * https://developer.mozilla.org/en-US/docs/Web/API/WheelEvent/deltaMode
 * https://stackoverflow.com/questions/20110224/what-is-the-height-of-a-line-in-a-wheel-event-deltamode-dom-delta-line
 */ const $79e18bc39470cd29$var$ffMultiplier = 40;
class $79e18bc39470cd29$export$6603ac392977df4 {
    constructor(){
        /**
         * Gets or Set the mouse wheel precision or how fast is the camera zooming.
         */ this.wheelPrecision = 3.0;
        /**
         * Gets or Set the boolean value that controls whether or not the mouse wheel
         * zooms to the location of the mouse pointer or not.  The default is false.
         */ this.zoomToMouseLocation = false;
        /**
         * wheelDeltaPercentage will be used instead of wheelPrecision if different from 0.
         * It defines the percentage of current camera.radius to use as delta when wheel is used.
         */ this.wheelDeltaPercentage = 0;
        /**
         * If set, this function will be used to set the radius delta that will be added to the current camera radius
         */ this.customComputeDeltaFromMouseWheel = null;
        this._viewOffset = new (0, $ha1VO.Vector3)(0, 0, 0);
        this._globalOffset = new (0, $ha1VO.Vector3)(0, 0, 0);
        this._inertialPanning = (0, $ha1VO.Vector3).Zero();
    }
    _computeDeltaFromMouseWheelLegacyEvent(mouseWheelDelta, radius) {
        let delta = 0;
        const wheelDelta = mouseWheelDelta * 0.01 * this.wheelDeltaPercentage * radius;
        if (mouseWheelDelta > 0) delta = wheelDelta / (1.0 + this.wheelDeltaPercentage);
        else delta = wheelDelta * (1.0 + this.wheelDeltaPercentage);
        return delta;
    }
    /**
     * Attach the input controls to a specific dom element to get the input from.
     * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
     */ attachControl(noPreventDefault) {
        noPreventDefault = (0, $bOhSV.Tools).BackCompatCameraNoPreventDefault(arguments);
        this._wheel = (p)=>{
            //sanity check - this should be a PointerWheel event.
            if (p.type !== (0, $cfkw4.PointerEventTypes).POINTERWHEEL) return;
            const event = p.event;
            let delta = 0;
            const platformScale = event.deltaMode === (0, $jzXHO.EventConstants).DOM_DELTA_LINE ? $79e18bc39470cd29$var$ffMultiplier : 1; // If this happens to be set to DOM_DELTA_LINE, adjust accordingly
            const wheelDelta = -(event.deltaY * platformScale);
            if (this.customComputeDeltaFromMouseWheel) delta = this.customComputeDeltaFromMouseWheel(wheelDelta, this, event);
            else if (this.wheelDeltaPercentage) {
                delta = this._computeDeltaFromMouseWheelLegacyEvent(wheelDelta, this.camera.radius);
                // If zooming in, estimate the target radius and use that to compute the delta for inertia
                // this will stop multiple scroll events zooming in from adding too much inertia
                if (delta > 0) {
                    let estimatedTargetRadius = this.camera.radius;
                    let targetInertia = this.camera.inertialRadiusOffset + delta;
                    for(let i = 0; i < 20 && Math.abs(targetInertia) > 0.001; i++){
                        estimatedTargetRadius -= targetInertia;
                        targetInertia *= this.camera.inertia;
                    }
                    estimatedTargetRadius = (0, $1VEEL.Scalar).Clamp(estimatedTargetRadius, 0, Number.MAX_VALUE);
                    delta = this._computeDeltaFromMouseWheelLegacyEvent(wheelDelta, estimatedTargetRadius);
                }
            } else delta = wheelDelta / (this.wheelPrecision * 40);
            if (delta) {
                if (this.zoomToMouseLocation) {
                    // If we are zooming to the mouse location, then we need to get the hit plane at the start of the zoom gesture if it doesn't exist
                    // The hit plane is normally calculated after the first motion and each time there's motion so if we don't do this first,
                    // the first zoom will be to the center of the screen
                    if (!this._hitPlane) this._updateHitPlane();
                    this._zoomToMouse(delta);
                } else this.camera.inertialRadiusOffset += delta;
            }
            if (event.preventDefault) {
                if (!noPreventDefault) event.preventDefault();
            }
        };
        this._observer = this.camera.getScene()._inputManager._addCameraPointerObserver(this._wheel, (0, $cfkw4.PointerEventTypes).POINTERWHEEL);
        if (this.zoomToMouseLocation) this._inertialPanning.setAll(0);
    }
    /**
     * Detach the current controls from the specified dom element.
     */ detachControl() {
        if (this._observer) {
            this.camera.getScene()._inputManager._removeCameraPointerObserver(this._observer);
            this._observer = null;
            this._wheel = null;
        }
    }
    /**
     * Update the current camera state depending on the inputs that have been used this frame.
     * This is a dynamically created lambda to avoid the performance penalty of looping for inputs in the render loop.
     */ checkInputs() {
        if (!this.zoomToMouseLocation) return;
        const camera = this.camera;
        const motion = 0.0 + camera.inertialAlphaOffset + camera.inertialBetaOffset + camera.inertialRadiusOffset;
        if (motion) {
            // if zooming is still happening as a result of inertia, then we also need to update
            // the hit plane.
            this._updateHitPlane();
            // Note we cannot  use arcRotateCamera.inertialPlanning here because arcRotateCamera panning
            // uses a different panningInertia which could cause this panning to get out of sync with
            // the zooming, and for this to work they must be exactly in sync.
            camera.target.addInPlace(this._inertialPanning);
            this._inertialPanning.scaleInPlace(camera.inertia);
            this._zeroIfClose(this._inertialPanning);
        }
    }
    /**
     * Gets the class name of the current input.
     * @returns the class name
     */ getClassName() {
        return "ArcRotateCameraMouseWheelInput";
    }
    /**
     * Get the friendly name associated with the input class.
     * @returns the input friendly name
     */ getSimpleName() {
        return "mousewheel";
    }
    _updateHitPlane() {
        const camera = this.camera;
        const direction = camera.target.subtract(camera.position);
        this._hitPlane = (0, $23POp.Plane).FromPositionAndNormal(camera.target, direction);
    }
    // Get position on the hit plane
    _getPosition() {
        const camera = this.camera;
        const scene = camera.getScene();
        // since the _hitPlane is always updated to be orthogonal to the camera position vector
        // we don't have to worry about this ray shooting off to infinity. This ray creates
        // a vector defining where we want to zoom to.
        const ray = scene.createPickingRay(scene.pointerX, scene.pointerY, (0, $ha1VO.Matrix).Identity(), camera, false);
        // Since the camera is the origin of the picking ray, we need to offset it by the camera's offset manually
        // Because the offset is in view space, we need to convert it to world space first
        if (camera.targetScreenOffset.x !== 0 || camera.targetScreenOffset.y !== 0) {
            this._viewOffset.set(camera.targetScreenOffset.x, camera.targetScreenOffset.y, 0);
            camera.getViewMatrix().invertToRef(camera._cameraTransformMatrix);
            this._globalOffset = (0, $ha1VO.Vector3).TransformNormal(this._viewOffset, camera._cameraTransformMatrix);
            ray.origin.addInPlace(this._globalOffset);
        }
        let distance = 0;
        if (this._hitPlane) distance = ray.intersectsPlane(this._hitPlane) ?? 0;
        // not using this ray again, so modifying its vectors here is fine
        return ray.origin.addInPlace(ray.direction.scaleInPlace(distance));
    }
    _zoomToMouse(delta) {
        const camera = this.camera;
        const inertiaComp = 1 - camera.inertia;
        if (camera.lowerRadiusLimit) {
            const lowerLimit = camera.lowerRadiusLimit ?? 0;
            if (camera.radius - (camera.inertialRadiusOffset + delta) / inertiaComp < lowerLimit) delta = (camera.radius - lowerLimit) * inertiaComp - camera.inertialRadiusOffset;
        }
        if (camera.upperRadiusLimit) {
            const upperLimit = camera.upperRadiusLimit ?? 0;
            if (camera.radius - (camera.inertialRadiusOffset + delta) / inertiaComp > upperLimit) delta = (camera.radius - upperLimit) * inertiaComp - camera.inertialRadiusOffset;
        }
        const zoomDistance = delta / inertiaComp;
        const ratio = zoomDistance / camera.radius;
        const vec = this._getPosition();
        // Now this vector tells us how much we also need to pan the camera
        // so the targeted mouse location becomes the center of zooming.
        const directionToZoomLocation = (0, $ha1VO.TmpVectors).Vector3[6];
        vec.subtractToRef(camera.target, directionToZoomLocation);
        directionToZoomLocation.scaleInPlace(ratio);
        directionToZoomLocation.scaleInPlace(inertiaComp);
        this._inertialPanning.addInPlace(directionToZoomLocation);
        camera.inertialRadiusOffset += delta;
    }
    // Sets x y or z of passed in vector to zero if less than Epsilon.
    _zeroIfClose(vec) {
        if (Math.abs(vec.x) < (0, $53VPf.Epsilon)) vec.x = 0;
        if (Math.abs(vec.y) < (0, $53VPf.Epsilon)) vec.y = 0;
        if (Math.abs(vec.z) < (0, $53VPf.Epsilon)) vec.z = 0;
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $79e18bc39470cd29$export$6603ac392977df4.prototype, "wheelPrecision", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $79e18bc39470cd29$export$6603ac392977df4.prototype, "zoomToMouseLocation", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $79e18bc39470cd29$export$6603ac392977df4.prototype, "wheelDeltaPercentage", void 0);
(0, $29K1K.CameraInputTypes)["ArcRotateCameraMouseWheelInput"] = $79e18bc39470cd29$export$6603ac392977df4;

});

parcelRegister("fIdF0", function(module, exports) {

$parcel$export(module.exports, "ArcRotateCameraPointersInput", () => $b7058fc4c829024a$export$3c1d686c016ce91b);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $29K1K = parcelRequire("29K1K");

var $clSi5 = parcelRequire("clSi5");
class $b7058fc4c829024a$export$3c1d686c016ce91b extends (0, $clSi5.BaseCameraPointersInput) {
    constructor(){
        super(...arguments);
        /**
         * Defines the buttons associated with the input to handle camera move.
         */ this.buttons = [
            0,
            1,
            2
        ];
        /**
         * Defines the pointer angular sensibility  along the X axis or how fast is
         * the camera rotating.
         */ this.angularSensibilityX = 1000.0;
        /**
         * Defines the pointer angular sensibility along the Y axis or how fast is
         * the camera rotating.
         */ this.angularSensibilityY = 1000.0;
        /**
         * Defines the pointer pinch precision or how fast is the camera zooming.
         */ this.pinchPrecision = 12.0;
        /**
         * pinchDeltaPercentage will be used instead of pinchPrecision if different
         * from 0.
         * It defines the percentage of current camera.radius to use as delta when
         * pinch zoom is used.
         */ this.pinchDeltaPercentage = 0;
        /**
         * When useNaturalPinchZoom is true, multi touch zoom will zoom in such
         * that any object in the plane at the camera's target point will scale
         * perfectly with finger motion.
         * Overrides pinchDeltaPercentage and pinchPrecision.
         */ this.useNaturalPinchZoom = false;
        /**
         * Defines whether zoom (2 fingers pinch) is enabled through multitouch
         */ this.pinchZoom = true;
        /**
         * Defines the pointer panning sensibility or how fast is the camera moving.
         */ this.panningSensibility = 1000.0;
        /**
         * Defines whether panning (2 fingers swipe) is enabled through multitouch.
         */ this.multiTouchPanning = true;
        /**
         * Defines whether panning is enabled for both pan (2 fingers swipe) and
         * zoom (pinch) through multitouch.
         */ this.multiTouchPanAndZoom = true;
        /**
         * Revers pinch action direction.
         */ this.pinchInwards = true;
        this._isPanClick = false;
        this._twoFingerActivityCount = 0;
        this._isPinching = false;
    }
    /**
     * Gets the class name of the current input.
     * @returns the class name
     */ getClassName() {
        return "ArcRotateCameraPointersInput";
    }
    /**
     * Move camera from multi touch panning positions.
     * @param previousMultiTouchPanPosition
     * @param multiTouchPanPosition
     */ _computeMultiTouchPanning(previousMultiTouchPanPosition, multiTouchPanPosition) {
        if (this.panningSensibility !== 0 && previousMultiTouchPanPosition && multiTouchPanPosition) {
            const moveDeltaX = multiTouchPanPosition.x - previousMultiTouchPanPosition.x;
            const moveDeltaY = multiTouchPanPosition.y - previousMultiTouchPanPosition.y;
            this.camera.inertialPanningX += -moveDeltaX / this.panningSensibility;
            this.camera.inertialPanningY += moveDeltaY / this.panningSensibility;
        }
    }
    /**
     * Move camera from pinch zoom distances.
     * @param previousPinchSquaredDistance
     * @param pinchSquaredDistance
     */ _computePinchZoom(previousPinchSquaredDistance, pinchSquaredDistance) {
        const radius = this.camera.radius || $b7058fc4c829024a$export$3c1d686c016ce91b.MinimumRadiusForPinch;
        if (this.useNaturalPinchZoom) this.camera.radius = radius * Math.sqrt(previousPinchSquaredDistance) / Math.sqrt(pinchSquaredDistance);
        else if (this.pinchDeltaPercentage) this.camera.inertialRadiusOffset += (pinchSquaredDistance - previousPinchSquaredDistance) * 0.001 * radius * this.pinchDeltaPercentage;
        else this.camera.inertialRadiusOffset += (pinchSquaredDistance - previousPinchSquaredDistance) / (this.pinchPrecision * (this.pinchInwards ? 1 : -1) * (this.angularSensibilityX + this.angularSensibilityY) / 2);
    }
    /**
     * Called on pointer POINTERMOVE event if only a single touch is active.
     * @param point current touch point
     * @param offsetX offset on X
     * @param offsetY offset on Y
     */ onTouch(point, offsetX, offsetY) {
        if (this.panningSensibility !== 0 && (this._ctrlKey && this.camera._useCtrlForPanning || this._isPanClick)) {
            this.camera.inertialPanningX += -offsetX / this.panningSensibility;
            this.camera.inertialPanningY += offsetY / this.panningSensibility;
        } else {
            this.camera.inertialAlphaOffset -= offsetX / this.angularSensibilityX;
            this.camera.inertialBetaOffset -= offsetY / this.angularSensibilityY;
        }
    }
    /**
     * Called on pointer POINTERDOUBLETAP event.
     */ onDoubleTap() {
        if (this.camera.useInputToRestoreState) this.camera.restoreState();
    }
    /**
     * Called on pointer POINTERMOVE event if multiple touches are active.
     * @param pointA point A
     * @param pointB point B
     * @param previousPinchSquaredDistance distance between points in previous pinch
     * @param pinchSquaredDistance distance between points in current pinch
     * @param previousMultiTouchPanPosition multi-touch position in previous step
     * @param multiTouchPanPosition multi-touch position in current step
     */ onMultiTouch(pointA, pointB, previousPinchSquaredDistance, pinchSquaredDistance, previousMultiTouchPanPosition, multiTouchPanPosition) {
        if (previousPinchSquaredDistance === 0 && previousMultiTouchPanPosition === null) // First time this method is called for new pinch.
        // Next time this is called there will be a
        // previousPinchSquaredDistance and pinchSquaredDistance to compare.
        return;
        if (pinchSquaredDistance === 0 && multiTouchPanPosition === null) // Last time this method is called at the end of a pinch.
        return;
        // Zoom and panning enabled together
        if (this.multiTouchPanAndZoom) {
            this._computePinchZoom(previousPinchSquaredDistance, pinchSquaredDistance);
            this._computeMultiTouchPanning(previousMultiTouchPanPosition, multiTouchPanPosition);
        // Zoom and panning enabled but only one at a time
        } else if (this.multiTouchPanning && this.pinchZoom) {
            this._twoFingerActivityCount++;
            if (this._isPinching || this._twoFingerActivityCount < 20 && Math.abs(Math.sqrt(pinchSquaredDistance) - Math.sqrt(previousPinchSquaredDistance)) > this.camera.pinchToPanMaxDistance) {
                // Since pinch has not been active long, assume we intend to zoom.
                this._computePinchZoom(previousPinchSquaredDistance, pinchSquaredDistance);
                // Since we are pinching, remain pinching on next iteration.
                this._isPinching = true;
            } else // Pause between pinch starting and moving implies not a zoom event. Pan instead.
            this._computeMultiTouchPanning(previousMultiTouchPanPosition, multiTouchPanPosition);
        // Panning enabled, zoom disabled
        } else if (this.multiTouchPanning) this._computeMultiTouchPanning(previousMultiTouchPanPosition, multiTouchPanPosition);
        else if (this.pinchZoom) this._computePinchZoom(previousPinchSquaredDistance, pinchSquaredDistance);
    }
    /**
     * Called each time a new POINTERDOWN event occurs. Ie, for each button
     * press.
     * @param evt Defines the event to track
     */ onButtonDown(evt) {
        this._isPanClick = evt.button === this.camera._panningMouseButton;
    }
    /**
     * Called each time a new POINTERUP event occurs. Ie, for each button
     * release.
     * @param _evt Defines the event to track
     */ onButtonUp(_evt) {
        this._twoFingerActivityCount = 0;
        this._isPinching = false;
    }
    /**
     * Called when window becomes inactive.
     */ onLostFocus() {
        this._isPanClick = false;
        this._twoFingerActivityCount = 0;
        this._isPinching = false;
    }
}
/**
 * The minimum radius used for pinch, to avoid radius lock at 0
 */ $b7058fc4c829024a$export$3c1d686c016ce91b.MinimumRadiusForPinch = 0.001;
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b7058fc4c829024a$export$3c1d686c016ce91b.prototype, "buttons", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b7058fc4c829024a$export$3c1d686c016ce91b.prototype, "angularSensibilityX", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b7058fc4c829024a$export$3c1d686c016ce91b.prototype, "angularSensibilityY", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b7058fc4c829024a$export$3c1d686c016ce91b.prototype, "pinchPrecision", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b7058fc4c829024a$export$3c1d686c016ce91b.prototype, "pinchDeltaPercentage", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b7058fc4c829024a$export$3c1d686c016ce91b.prototype, "useNaturalPinchZoom", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b7058fc4c829024a$export$3c1d686c016ce91b.prototype, "pinchZoom", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b7058fc4c829024a$export$3c1d686c016ce91b.prototype, "panningSensibility", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b7058fc4c829024a$export$3c1d686c016ce91b.prototype, "multiTouchPanning", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b7058fc4c829024a$export$3c1d686c016ce91b.prototype, "multiTouchPanAndZoom", void 0);
(0, $29K1K.CameraInputTypes)["ArcRotateCameraPointersInput"] = $b7058fc4c829024a$export$3c1d686c016ce91b;

});

parcelRegister("6NXHI", function(module, exports) {

$parcel$export(module.exports, "ArcRotateCameraVRDeviceOrientationInput", () => $4f45a1b050397b2f$export$5e9bd5d378b8f31d);

var $29K1K = parcelRequire("29K1K");

var $gotsS = parcelRequire("gotsS");

var $bOhSV = parcelRequire("bOhSV");
/**
 * Add orientation input support to the input manager.
 * @returns the current input manager
 */ (0, $gotsS.ArcRotateCameraInputsManager).prototype.addVRDeviceOrientation = function() {
    this.add(new $4f45a1b050397b2f$export$5e9bd5d378b8f31d());
    return this;
};
class $4f45a1b050397b2f$export$5e9bd5d378b8f31d {
    /**
     * Instantiate a new ArcRotateCameraVRDeviceOrientationInput.
     */ constructor(){
        /**
         * Defines a correction factor applied on the alpha value retrieved from the orientation events.
         */ this.alphaCorrection = 1;
        /**
         * Defines a correction factor applied on the gamma value retrieved from the orientation events.
         */ this.gammaCorrection = 1;
        this._alpha = 0;
        this._gamma = 0;
        this._dirty = false;
        this._deviceOrientationHandler = (evt)=>this._onOrientationEvent(evt);
    }
    /**
     * Attach the input controls to a specific dom element to get the input from.
     * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
     */ attachControl(noPreventDefault) {
        // eslint-disable-next-line prefer-rest-params
        noPreventDefault = (0, $bOhSV.Tools).BackCompatCameraNoPreventDefault(arguments);
        this.camera.attachControl(noPreventDefault);
        const hostWindow = this.camera.getScene().getEngine().getHostWindow();
        if (hostWindow) {
            // check iOS 13+ support
            if (typeof DeviceOrientationEvent !== "undefined" && typeof DeviceOrientationEvent.requestPermission === "function") DeviceOrientationEvent.requestPermission().then((response)=>{
                if (response === "granted") hostWindow.addEventListener("deviceorientation", this._deviceOrientationHandler);
                else (0, $bOhSV.Tools).Warn("Permission not granted.");
            }).catch((error)=>{
                (0, $bOhSV.Tools).Error(error);
            });
            else hostWindow.addEventListener("deviceorientation", this._deviceOrientationHandler);
        }
    }
    /**
     * @internal
     */ _onOrientationEvent(evt) {
        if (evt.alpha !== null) this._alpha = (+evt.alpha | 0) * this.alphaCorrection;
        if (evt.gamma !== null) this._gamma = (+evt.gamma | 0) * this.gammaCorrection;
        this._dirty = true;
    }
    /**
     * Update the current camera state depending on the inputs that have been used this frame.
     * This is a dynamically created lambda to avoid the performance penalty of looping for inputs in the render loop.
     */ checkInputs() {
        if (this._dirty) {
            this._dirty = false;
            if (this._gamma < 0) this._gamma = 180 + this._gamma;
            this.camera.alpha = -this._alpha / 180.0 * Math.PI % Math.PI * 2;
            this.camera.beta = this._gamma / 180.0 * Math.PI;
        }
    }
    /**
     * Detach the current controls from the specified dom element.
     */ detachControl() {
        window.removeEventListener("deviceorientation", this._deviceOrientationHandler);
    }
    /**
     * Gets the class name of the current input.
     * @returns the class name
     */ getClassName() {
        return "ArcRotateCameraVRDeviceOrientationInput";
    }
    /**
     * Get the friendly name associated with the input class.
     * @returns the input friendly name
     */ getSimpleName() {
        return "VRDeviceOrientation";
    }
}
(0, $29K1K.CameraInputTypes)["ArcRotateCameraVRDeviceOrientationInput"] = $4f45a1b050397b2f$export$5e9bd5d378b8f31d;

});
parcelRegister("gotsS", function(module, exports) {

$parcel$export(module.exports, "ArcRotateCameraInputsManager", () => $bef5be55ba1ec18a$export$cbf1896b2dde8a14);

var $fIdF0 = parcelRequire("fIdF0");

var $24jKF = parcelRequire("24jKF");

var $asLJx = parcelRequire("asLJx");

var $29K1K = parcelRequire("29K1K");
class $bef5be55ba1ec18a$export$cbf1896b2dde8a14 extends (0, $29K1K.CameraInputsManager) {
    /**
     * Instantiates a new ArcRotateCameraInputsManager.
     * @param camera Defines the camera the inputs belong to
     */ constructor(camera){
        super(camera);
    }
    /**
     * Add mouse wheel input support to the input manager.
     * @returns the current input manager
     */ addMouseWheel() {
        this.add(new (0, $asLJx.ArcRotateCameraMouseWheelInput)());
        return this;
    }
    /**
     * Add pointers input support to the input manager.
     * @returns the current input manager
     */ addPointers() {
        this.add(new (0, $fIdF0.ArcRotateCameraPointersInput)());
        return this;
    }
    /**
     * Add keyboard input support to the input manager.
     * @returns the current input manager
     */ addKeyboard() {
        this.add(new (0, $24jKF.ArcRotateCameraKeyboardMoveInput)());
        return this;
    }
}

});


parcelRegister("9gxDr", function(module, exports) {

$parcel$export(module.exports, "FlyCameraKeyboardInput", () => $6befb2f060e92168$export$7a67d80309c6aad7);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $29K1K = parcelRequire("29K1K");

var $bcFoB = parcelRequire("bcFoB");

var $ha1VO = parcelRequire("ha1VO");

var $bOhSV = parcelRequire("bOhSV");
class $6befb2f060e92168$export$7a67d80309c6aad7 {
    constructor(){
        /**
         * The list of keyboard keys used to control the forward move of the camera.
         */ this.keysForward = [
            87
        ];
        /**
         * The list of keyboard keys used to control the backward move of the camera.
         */ this.keysBackward = [
            83
        ];
        /**
         * The list of keyboard keys used to control the forward move of the camera.
         */ this.keysUp = [
            69
        ];
        /**
         * The list of keyboard keys used to control the backward move of the camera.
         */ this.keysDown = [
            81
        ];
        /**
         * The list of keyboard keys used to control the right strafe move of the camera.
         */ this.keysRight = [
            68
        ];
        /**
         * The list of keyboard keys used to control the left strafe move of the camera.
         */ this.keysLeft = [
            65
        ];
        this._keys = new Array();
    }
    /**
     * Attach the input controls to a specific dom element to get the input from.
     * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
     */ attachControl(noPreventDefault) {
        // eslint-disable-next-line prefer-rest-params
        noPreventDefault = (0, $bOhSV.Tools).BackCompatCameraNoPreventDefault(arguments);
        if (this._onCanvasBlurObserver) return;
        this._scene = this.camera.getScene();
        this._engine = this._scene.getEngine();
        this._onCanvasBlurObserver = this._engine.onCanvasBlurObservable.add(()=>{
            this._keys.length = 0;
        });
        this._onKeyboardObserver = this._scene.onKeyboardObservable.add((info)=>{
            const evt = info.event;
            if (info.type === (0, $bcFoB.KeyboardEventTypes).KEYDOWN) {
                if (this.keysForward.indexOf(evt.keyCode) !== -1 || this.keysBackward.indexOf(evt.keyCode) !== -1 || this.keysUp.indexOf(evt.keyCode) !== -1 || this.keysDown.indexOf(evt.keyCode) !== -1 || this.keysLeft.indexOf(evt.keyCode) !== -1 || this.keysRight.indexOf(evt.keyCode) !== -1) {
                    const index = this._keys.indexOf(evt.keyCode);
                    if (index === -1) this._keys.push(evt.keyCode);
                    if (!noPreventDefault) evt.preventDefault();
                }
            } else if (this.keysForward.indexOf(evt.keyCode) !== -1 || this.keysBackward.indexOf(evt.keyCode) !== -1 || this.keysUp.indexOf(evt.keyCode) !== -1 || this.keysDown.indexOf(evt.keyCode) !== -1 || this.keysLeft.indexOf(evt.keyCode) !== -1 || this.keysRight.indexOf(evt.keyCode) !== -1) {
                const index = this._keys.indexOf(evt.keyCode);
                if (index >= 0) this._keys.splice(index, 1);
                if (!noPreventDefault) evt.preventDefault();
            }
        });
    }
    /**
     * Detach the current controls from the specified dom element.
     */ detachControl() {
        if (this._scene) {
            if (this._onKeyboardObserver) this._scene.onKeyboardObservable.remove(this._onKeyboardObserver);
            if (this._onCanvasBlurObserver) this._engine.onCanvasBlurObservable.remove(this._onCanvasBlurObserver);
            this._onKeyboardObserver = null;
            this._onCanvasBlurObserver = null;
        }
        this._keys.length = 0;
    }
    /**
     * Gets the class name of the current input.
     * @returns the class name
     */ getClassName() {
        return "FlyCameraKeyboardInput";
    }
    /**
     * @internal
     */ _onLostFocus() {
        this._keys.length = 0;
    }
    /**
     * Get the friendly name associated with the input class.
     * @returns the input friendly name
     */ getSimpleName() {
        return "keyboard";
    }
    /**
     * Update the current camera state depending on the inputs that have been used this frame.
     * This is a dynamically created lambda to avoid the performance penalty of looping for inputs in the render loop.
     */ checkInputs() {
        if (this._onKeyboardObserver) {
            const camera = this.camera;
            // Keyboard
            for(let index = 0; index < this._keys.length; index++){
                const keyCode = this._keys[index];
                const speed = camera._computeLocalCameraSpeed();
                if (this.keysForward.indexOf(keyCode) !== -1) camera._localDirection.copyFromFloats(0, 0, speed);
                else if (this.keysBackward.indexOf(keyCode) !== -1) camera._localDirection.copyFromFloats(0, 0, -speed);
                else if (this.keysUp.indexOf(keyCode) !== -1) camera._localDirection.copyFromFloats(0, speed, 0);
                else if (this.keysDown.indexOf(keyCode) !== -1) camera._localDirection.copyFromFloats(0, -speed, 0);
                else if (this.keysRight.indexOf(keyCode) !== -1) camera._localDirection.copyFromFloats(speed, 0, 0);
                else if (this.keysLeft.indexOf(keyCode) !== -1) camera._localDirection.copyFromFloats(-speed, 0, 0);
                if (camera.getScene().useRightHandedSystem) camera._localDirection.z *= -1;
                camera.getViewMatrix().invertToRef(camera._cameraTransformMatrix);
                (0, $ha1VO.Vector3).TransformNormalToRef(camera._localDirection, camera._cameraTransformMatrix, camera._transformedDirection);
                camera.cameraDirection.addInPlace(camera._transformedDirection);
            }
        }
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6befb2f060e92168$export$7a67d80309c6aad7.prototype, "keysForward", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6befb2f060e92168$export$7a67d80309c6aad7.prototype, "keysBackward", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6befb2f060e92168$export$7a67d80309c6aad7.prototype, "keysUp", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6befb2f060e92168$export$7a67d80309c6aad7.prototype, "keysDown", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6befb2f060e92168$export$7a67d80309c6aad7.prototype, "keysRight", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6befb2f060e92168$export$7a67d80309c6aad7.prototype, "keysLeft", void 0);
(0, $29K1K.CameraInputTypes)["FlyCameraKeyboardInput"] = $6befb2f060e92168$export$7a67d80309c6aad7;

});

parcelRegister("loMVr", function(module, exports) {

$parcel$export(module.exports, "FlyCameraMouseInput", () => $f941ca6e72e0e996$export$bb720463a987624d);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $29K1K = parcelRequire("29K1K");

var $cfkw4 = parcelRequire("cfkw4");

var $ha1VO = parcelRequire("ha1VO");

var $dbxbu = parcelRequire("dbxbu");

var $bOhSV = parcelRequire("bOhSV");
class $f941ca6e72e0e996$export$bb720463a987624d {
    /**
     * Listen to mouse events to control the camera.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/customizingCameraInputs
     */ constructor(){
        /**
         * Defines the buttons associated with the input to handle camera rotation.
         */ this.buttons = [
            0,
            1,
            2
        ];
        /**
         * Assign buttons for Yaw control.
         */ this.buttonsYaw = [
            -1,
            0,
            1
        ];
        /**
         * Assign buttons for Pitch control.
         */ this.buttonsPitch = [
            -1,
            0,
            1
        ];
        /**
         * Assign buttons for Roll control.
         */ this.buttonsRoll = [
            2
        ];
        /**
         * Detect if any button is being pressed while mouse is moved.
         * -1 = Mouse locked.
         * 0 = Left button.
         * 1 = Middle Button.
         * 2 = Right Button.
         */ this.activeButton = -1;
        /**
         * Defines the pointer's angular sensibility, to control the camera rotation speed.
         * Higher values reduce its sensitivity.
         */ this.angularSensibility = 1000.0;
        this._previousPosition = null;
    }
    /**
     * Attach the mouse control to the HTML DOM element.
     * @param noPreventDefault Defines whether events caught by the controls should call preventdefault().
     */ attachControl(noPreventDefault) {
        // eslint-disable-next-line prefer-rest-params
        noPreventDefault = (0, $bOhSV.Tools).BackCompatCameraNoPreventDefault(arguments);
        this._noPreventDefault = noPreventDefault;
        this._observer = this.camera.getScene()._inputManager._addCameraPointerObserver((p)=>{
            this._pointerInput(p);
        }, (0, $cfkw4.PointerEventTypes).POINTERDOWN | (0, $cfkw4.PointerEventTypes).POINTERUP | (0, $cfkw4.PointerEventTypes).POINTERMOVE);
        // Correct Roll by rate, if enabled.
        this._rollObserver = this.camera.getScene().onBeforeRenderObservable.add(()=>{
            if (this.camera.rollCorrect) this.camera.restoreRoll(this.camera.rollCorrect);
        });
    }
    /**
     * Detach the current controls from the specified dom element.
     */ detachControl() {
        if (this._observer) {
            this.camera.getScene()._inputManager._removeCameraPointerObserver(this._observer);
            this.camera.getScene().onBeforeRenderObservable.remove(this._rollObserver);
            this._observer = null;
            this._rollObserver = null;
            this._previousPosition = null;
            this._noPreventDefault = undefined;
        }
    }
    /**
     * Gets the class name of the current input.
     * @returns the class name.
     */ getClassName() {
        return "FlyCameraMouseInput";
    }
    /**
     * Get the friendly name associated with the input class.
     * @returns the input's friendly name.
     */ getSimpleName() {
        return "mouse";
    }
    // Track mouse movement, when the pointer is not locked.
    _pointerInput(p) {
        const e = p.event;
        const camera = this.camera;
        const engine = camera.getEngine();
        if (!this.touchEnabled && e.pointerType === "touch") return;
        // Mouse is moved but an unknown mouse button is pressed.
        if (p.type !== (0, $cfkw4.PointerEventTypes).POINTERMOVE && this.buttons.indexOf(e.button) === -1) return;
        const srcElement = e.target;
        // Mouse down.
        if (p.type === (0, $cfkw4.PointerEventTypes).POINTERDOWN) {
            try {
                srcElement?.setPointerCapture(e.pointerId);
            } catch (e) {
            // Nothing to do with the error. Execution continues.
            }
            this._previousPosition = {
                x: e.clientX,
                y: e.clientY
            };
            this.activeButton = e.button;
            if (!this._noPreventDefault) {
                e.preventDefault();
                this._element.focus();
            }
            // This is required to move while pointer button is down
            if (engine.isPointerLock) this._onMouseMove(p.event);
        } else if (p.type === (0, $cfkw4.PointerEventTypes).POINTERUP) {
            try {
                srcElement?.releasePointerCapture(e.pointerId);
            } catch (e) {
            // Nothing to do with the error. Execution continues.
            }
            this.activeButton = -1;
            this._previousPosition = null;
            if (!this._noPreventDefault) e.preventDefault();
        } else if (p.type === (0, $cfkw4.PointerEventTypes).POINTERMOVE) {
            if (!this._previousPosition) {
                if (engine.isPointerLock) this._onMouseMove(p.event);
                return;
            }
            const offsetX = e.clientX - this._previousPosition.x;
            const offsetY = e.clientY - this._previousPosition.y;
            this._rotateCamera(offsetX, offsetY);
            this._previousPosition = {
                x: e.clientX,
                y: e.clientY
            };
            if (!this._noPreventDefault) e.preventDefault();
        }
    }
    // Track mouse movement, when pointer is locked.
    _onMouseMove(e) {
        const camera = this.camera;
        const engine = camera.getEngine();
        if (!engine.isPointerLock) return;
        const offsetX = e.movementX;
        const offsetY = e.movementY;
        this._rotateCamera(offsetX, offsetY);
        this._previousPosition = null;
        if (!this._noPreventDefault) e.preventDefault();
    }
    /**
     * Rotate camera by mouse offset.
     * @param offsetX
     * @param offsetY
     */ _rotateCamera(offsetX, offsetY) {
        const camera = this.camera;
        const handednessMultiplier = camera._calculateHandednessMultiplier();
        offsetX *= handednessMultiplier;
        const x = offsetX / this.angularSensibility;
        const y = offsetY / this.angularSensibility;
        // Initialize to current rotation.
        const currentRotation = (0, $ha1VO.Quaternion).RotationYawPitchRoll(camera.rotation.y, camera.rotation.x, camera.rotation.z);
        let rotationChange;
        // Pitch.
        if (this.buttonsPitch.some((v)=>{
            return v === this.activeButton;
        })) {
            // Apply change in Radians to vector Angle.
            rotationChange = (0, $ha1VO.Quaternion).RotationAxis((0, $dbxbu.Axis).X, y);
            // Apply Pitch to quaternion.
            currentRotation.multiplyInPlace(rotationChange);
        }
        // Yaw.
        if (this.buttonsYaw.some((v)=>{
            return v === this.activeButton;
        })) {
            // Apply change in Radians to vector Angle.
            rotationChange = (0, $ha1VO.Quaternion).RotationAxis((0, $dbxbu.Axis).Y, x);
            // Apply Yaw to quaternion.
            currentRotation.multiplyInPlace(rotationChange);
            // Add Roll, if banked turning is enabled, within Roll limit.
            const limit = camera.bankedTurnLimit + camera._trackRoll; // Defaults to 90° plus manual roll.
            if (camera.bankedTurn && -limit < camera.rotation.z && camera.rotation.z < limit) {
                const bankingDelta = camera.bankedTurnMultiplier * -x;
                // Apply change in Radians to vector Angle.
                rotationChange = (0, $ha1VO.Quaternion).RotationAxis((0, $dbxbu.Axis).Z, bankingDelta);
                // Apply Yaw to quaternion.
                currentRotation.multiplyInPlace(rotationChange);
            }
        }
        // Roll.
        if (this.buttonsRoll.some((v)=>{
            return v === this.activeButton;
        })) {
            // Apply change in Radians to vector Angle.
            rotationChange = (0, $ha1VO.Quaternion).RotationAxis((0, $dbxbu.Axis).Z, -x);
            // Track Rolling.
            camera._trackRoll -= x;
            // Apply Pitch to quaternion.
            currentRotation.multiplyInPlace(rotationChange);
        }
        // Apply rotationQuaternion to Euler camera.rotation.
        currentRotation.toEulerAnglesToRef(camera.rotation);
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $f941ca6e72e0e996$export$bb720463a987624d.prototype, "buttons", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $f941ca6e72e0e996$export$bb720463a987624d.prototype, "angularSensibility", void 0);
(0, $29K1K.CameraInputTypes)["FlyCameraMouseInput"] = $f941ca6e72e0e996$export$bb720463a987624d;

});

parcelRegister("2CmKi", function(module, exports) {

$parcel$export(module.exports, "FollowCameraKeyboardMoveInput", () => $1e80c62e407304af$export$94da179cd1c0e8d9);

var $e0Suo = parcelRequire("e0Suo");

var $29K1K = parcelRequire("29K1K");

var $ir0rz = parcelRequire("ir0rz");

var $bcFoB = parcelRequire("bcFoB");

var $bOhSV = parcelRequire("bOhSV");
class $1e80c62e407304af$export$94da179cd1c0e8d9 {
    constructor(){
        /**
         * Defines the list of key codes associated with the up action (increase heightOffset)
         */ this.keysHeightOffsetIncr = [
            38
        ];
        /**
         * Defines the list of key codes associated with the down action (decrease heightOffset)
         */ this.keysHeightOffsetDecr = [
            40
        ];
        /**
         * Defines whether the Alt modifier key is required to move up/down (alter heightOffset)
         */ this.keysHeightOffsetModifierAlt = false;
        /**
         * Defines whether the Ctrl modifier key is required to move up/down (alter heightOffset)
         */ this.keysHeightOffsetModifierCtrl = false;
        /**
         * Defines whether the Shift modifier key is required to move up/down (alter heightOffset)
         */ this.keysHeightOffsetModifierShift = false;
        /**
         * Defines the list of key codes associated with the left action (increase rotationOffset)
         */ this.keysRotationOffsetIncr = [
            37
        ];
        /**
         * Defines the list of key codes associated with the right action (decrease rotationOffset)
         */ this.keysRotationOffsetDecr = [
            39
        ];
        /**
         * Defines whether the Alt modifier key is required to move left/right (alter rotationOffset)
         */ this.keysRotationOffsetModifierAlt = false;
        /**
         * Defines whether the Ctrl modifier key is required to move left/right (alter rotationOffset)
         */ this.keysRotationOffsetModifierCtrl = false;
        /**
         * Defines whether the Shift modifier key is required to move left/right (alter rotationOffset)
         */ this.keysRotationOffsetModifierShift = false;
        /**
         * Defines the list of key codes associated with the zoom-in action (decrease radius)
         */ this.keysRadiusIncr = [
            40
        ];
        /**
         * Defines the list of key codes associated with the zoom-out action (increase radius)
         */ this.keysRadiusDecr = [
            38
        ];
        /**
         * Defines whether the Alt modifier key is required to zoom in/out (alter radius value)
         */ this.keysRadiusModifierAlt = true;
        /**
         * Defines whether the Ctrl modifier key is required to zoom in/out (alter radius value)
         */ this.keysRadiusModifierCtrl = false;
        /**
         * Defines whether the Shift modifier key is required to zoom in/out (alter radius value)
         */ this.keysRadiusModifierShift = false;
        /**
         * Defines the rate of change of heightOffset.
         */ this.heightSensibility = 1;
        /**
         * Defines the rate of change of rotationOffset.
         */ this.rotationSensibility = 1;
        /**
         * Defines the rate of change of radius.
         */ this.radiusSensibility = 1;
        this._keys = new Array();
    }
    /**
     * Attach the input controls to a specific dom element to get the input from.
     * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
     */ attachControl(noPreventDefault) {
        // eslint-disable-next-line prefer-rest-params
        noPreventDefault = (0, $bOhSV.Tools).BackCompatCameraNoPreventDefault(arguments);
        if (this._onCanvasBlurObserver) return;
        this._scene = this.camera.getScene();
        this._engine = this._scene.getEngine();
        this._onCanvasBlurObserver = this._engine.onCanvasBlurObservable.add(()=>{
            this._keys.length = 0;
        });
        this._onKeyboardObserver = this._scene.onKeyboardObservable.add((info)=>{
            const evt = info.event;
            if (!evt.metaKey) {
                if (info.type === (0, $bcFoB.KeyboardEventTypes).KEYDOWN) {
                    this._ctrlPressed = evt.ctrlKey;
                    this._altPressed = evt.altKey;
                    this._shiftPressed = evt.shiftKey;
                    if (this.keysHeightOffsetIncr.indexOf(evt.keyCode) !== -1 || this.keysHeightOffsetDecr.indexOf(evt.keyCode) !== -1 || this.keysRotationOffsetIncr.indexOf(evt.keyCode) !== -1 || this.keysRotationOffsetDecr.indexOf(evt.keyCode) !== -1 || this.keysRadiusIncr.indexOf(evt.keyCode) !== -1 || this.keysRadiusDecr.indexOf(evt.keyCode) !== -1) {
                        const index = this._keys.indexOf(evt.keyCode);
                        if (index === -1) this._keys.push(evt.keyCode);
                        if (evt.preventDefault) {
                            if (!noPreventDefault) evt.preventDefault();
                        }
                    }
                } else if (this.keysHeightOffsetIncr.indexOf(evt.keyCode) !== -1 || this.keysHeightOffsetDecr.indexOf(evt.keyCode) !== -1 || this.keysRotationOffsetIncr.indexOf(evt.keyCode) !== -1 || this.keysRotationOffsetDecr.indexOf(evt.keyCode) !== -1 || this.keysRadiusIncr.indexOf(evt.keyCode) !== -1 || this.keysRadiusDecr.indexOf(evt.keyCode) !== -1) {
                    const index = this._keys.indexOf(evt.keyCode);
                    if (index >= 0) this._keys.splice(index, 1);
                    if (evt.preventDefault) {
                        if (!noPreventDefault) evt.preventDefault();
                    }
                }
            }
        });
    }
    /**
     * Detach the current controls from the specified dom element.
     */ detachControl() {
        if (this._scene) {
            if (this._onKeyboardObserver) this._scene.onKeyboardObservable.remove(this._onKeyboardObserver);
            if (this._onCanvasBlurObserver) this._engine.onCanvasBlurObservable.remove(this._onCanvasBlurObserver);
            this._onKeyboardObserver = null;
            this._onCanvasBlurObserver = null;
        }
        this._keys.length = 0;
    }
    /**
     * Update the current camera state depending on the inputs that have been used this frame.
     * This is a dynamically created lambda to avoid the performance penalty of looping for inputs in the render loop.
     */ checkInputs() {
        if (this._onKeyboardObserver) this._keys.forEach((keyCode)=>{
            if (this.keysHeightOffsetIncr.indexOf(keyCode) !== -1 && this._modifierHeightOffset()) this.camera.heightOffset += this.heightSensibility;
            else if (this.keysHeightOffsetDecr.indexOf(keyCode) !== -1 && this._modifierHeightOffset()) this.camera.heightOffset -= this.heightSensibility;
            else if (this.keysRotationOffsetIncr.indexOf(keyCode) !== -1 && this._modifierRotationOffset()) {
                this.camera.rotationOffset += this.rotationSensibility;
                this.camera.rotationOffset %= 360;
            } else if (this.keysRotationOffsetDecr.indexOf(keyCode) !== -1 && this._modifierRotationOffset()) {
                this.camera.rotationOffset -= this.rotationSensibility;
                this.camera.rotationOffset %= 360;
            } else if (this.keysRadiusIncr.indexOf(keyCode) !== -1 && this._modifierRadius()) this.camera.radius += this.radiusSensibility;
            else if (this.keysRadiusDecr.indexOf(keyCode) !== -1 && this._modifierRadius()) this.camera.radius -= this.radiusSensibility;
        });
    }
    /**
     * Gets the class name of the current input.
     * @returns the class name
     */ getClassName() {
        return "FollowCameraKeyboardMoveInput";
    }
    /**
     * Get the friendly name associated with the input class.
     * @returns the input friendly name
     */ getSimpleName() {
        return "keyboard";
    }
    /**
     * Check if the pressed modifier keys (Alt/Ctrl/Shift) match those configured to
     * allow modification of the heightOffset value.
     * @returns true if modifier keys match
     */ _modifierHeightOffset() {
        return this.keysHeightOffsetModifierAlt === this._altPressed && this.keysHeightOffsetModifierCtrl === this._ctrlPressed && this.keysHeightOffsetModifierShift === this._shiftPressed;
    }
    /**
     * Check if the pressed modifier keys (Alt/Ctrl/Shift) match those configured to
     * allow modification of the rotationOffset value.
     * @returns true if modifier keys match
     */ _modifierRotationOffset() {
        return this.keysRotationOffsetModifierAlt === this._altPressed && this.keysRotationOffsetModifierCtrl === this._ctrlPressed && this.keysRotationOffsetModifierShift === this._shiftPressed;
    }
    /**
     * Check if the pressed modifier keys (Alt/Ctrl/Shift) match those configured to
     * allow modification of the radius value.
     * @returns true if modifier keys match
     */ _modifierRadius() {
        return this.keysRadiusModifierAlt === this._altPressed && this.keysRadiusModifierCtrl === this._ctrlPressed && this.keysRadiusModifierShift === this._shiftPressed;
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $1e80c62e407304af$export$94da179cd1c0e8d9.prototype, "keysHeightOffsetIncr", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $1e80c62e407304af$export$94da179cd1c0e8d9.prototype, "keysHeightOffsetDecr", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $1e80c62e407304af$export$94da179cd1c0e8d9.prototype, "keysHeightOffsetModifierAlt", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $1e80c62e407304af$export$94da179cd1c0e8d9.prototype, "keysHeightOffsetModifierCtrl", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $1e80c62e407304af$export$94da179cd1c0e8d9.prototype, "keysHeightOffsetModifierShift", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $1e80c62e407304af$export$94da179cd1c0e8d9.prototype, "keysRotationOffsetIncr", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $1e80c62e407304af$export$94da179cd1c0e8d9.prototype, "keysRotationOffsetDecr", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $1e80c62e407304af$export$94da179cd1c0e8d9.prototype, "keysRotationOffsetModifierAlt", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $1e80c62e407304af$export$94da179cd1c0e8d9.prototype, "keysRotationOffsetModifierCtrl", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $1e80c62e407304af$export$94da179cd1c0e8d9.prototype, "keysRotationOffsetModifierShift", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $1e80c62e407304af$export$94da179cd1c0e8d9.prototype, "keysRadiusIncr", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $1e80c62e407304af$export$94da179cd1c0e8d9.prototype, "keysRadiusDecr", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $1e80c62e407304af$export$94da179cd1c0e8d9.prototype, "keysRadiusModifierAlt", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $1e80c62e407304af$export$94da179cd1c0e8d9.prototype, "keysRadiusModifierCtrl", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $1e80c62e407304af$export$94da179cd1c0e8d9.prototype, "keysRadiusModifierShift", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $1e80c62e407304af$export$94da179cd1c0e8d9.prototype, "heightSensibility", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $1e80c62e407304af$export$94da179cd1c0e8d9.prototype, "rotationSensibility", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $1e80c62e407304af$export$94da179cd1c0e8d9.prototype, "radiusSensibility", void 0);
(0, $29K1K.CameraInputTypes)["FollowCameraKeyboardMoveInput"] = $1e80c62e407304af$export$94da179cd1c0e8d9;

});

parcelRegister("8SQek", function(module, exports) {

$parcel$export(module.exports, "FollowCameraMouseWheelInput", () => $677be1af2f5ec8c0$export$5f76c53f117f3f04);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $29K1K = parcelRequire("29K1K");

var $cfkw4 = parcelRequire("cfkw4");

var $bOhSV = parcelRequire("bOhSV");

var $kVtWi = parcelRequire("kVtWi");
class $677be1af2f5ec8c0$export$5f76c53f117f3f04 {
    constructor(){
        /**
         * Moue wheel controls zoom. (Mouse wheel modifies camera.radius value.)
         */ this.axisControlRadius = true;
        /**
         * Moue wheel controls height. (Mouse wheel modifies camera.heightOffset value.)
         */ this.axisControlHeight = false;
        /**
         * Moue wheel controls angle. (Mouse wheel modifies camera.rotationOffset value.)
         */ this.axisControlRotation = false;
        /**
         * Gets or Set the mouse wheel precision or how fast is the camera moves in
         * relation to mouseWheel events.
         */ this.wheelPrecision = 3.0;
        /**
         * wheelDeltaPercentage will be used instead of wheelPrecision if different from 0.
         * It defines the percentage of current camera.radius to use as delta when wheel is used.
         */ this.wheelDeltaPercentage = 0;
    }
    /**
     * Attach the input controls to a specific dom element to get the input from.
     * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
     */ attachControl(noPreventDefault) {
        noPreventDefault = (0, $bOhSV.Tools).BackCompatCameraNoPreventDefault(arguments);
        this._wheel = (p)=>{
            // sanity check - this should be a PointerWheel event.
            if (p.type !== (0, $cfkw4.PointerEventTypes).POINTERWHEEL) return;
            const event = p.event;
            let delta = 0;
            const wheelDelta = Math.max(-1, Math.min(1, event.deltaY));
            if (this.wheelDeltaPercentage) {
                if (+this.axisControlRadius + +this.axisControlHeight + +this.axisControlRotation) (0, $kVtWi.Logger).Warn("wheelDeltaPercentage only usable when mouse wheel controls ONE axis. Currently enabled: axisControlRadius: " + this.axisControlRadius + ", axisControlHeightOffset: " + this.axisControlHeight + ", axisControlRotationOffset: " + this.axisControlRotation);
                if (this.axisControlRadius) delta = wheelDelta * 0.01 * this.wheelDeltaPercentage * this.camera.radius;
                else if (this.axisControlHeight) delta = wheelDelta * 0.01 * this.wheelDeltaPercentage * this.camera.heightOffset;
                else if (this.axisControlRotation) delta = wheelDelta * 0.01 * this.wheelDeltaPercentage * this.camera.rotationOffset;
            } else delta = wheelDelta * this.wheelPrecision;
            if (delta) {
                if (this.axisControlRadius) this.camera.radius += delta;
                else if (this.axisControlHeight) this.camera.heightOffset -= delta;
                else if (this.axisControlRotation) this.camera.rotationOffset -= delta;
            }
            if (event.preventDefault) {
                if (!noPreventDefault) event.preventDefault();
            }
        };
        this._observer = this.camera.getScene()._inputManager._addCameraPointerObserver(this._wheel, (0, $cfkw4.PointerEventTypes).POINTERWHEEL);
    }
    /**
     * Detach the current controls from the specified dom element.
     */ detachControl() {
        if (this._observer) {
            this.camera.getScene()._inputManager._removeCameraPointerObserver(this._observer);
            this._observer = null;
            this._wheel = null;
        }
    }
    /**
     * Gets the class name of the current input.
     * @returns the class name
     */ getClassName() {
        return "ArcRotateCameraMouseWheelInput";
    }
    /**
     * Get the friendly name associated with the input class.
     * @returns the input friendly name
     */ getSimpleName() {
        return "mousewheel";
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $677be1af2f5ec8c0$export$5f76c53f117f3f04.prototype, "axisControlRadius", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $677be1af2f5ec8c0$export$5f76c53f117f3f04.prototype, "axisControlHeight", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $677be1af2f5ec8c0$export$5f76c53f117f3f04.prototype, "axisControlRotation", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $677be1af2f5ec8c0$export$5f76c53f117f3f04.prototype, "wheelPrecision", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $677be1af2f5ec8c0$export$5f76c53f117f3f04.prototype, "wheelDeltaPercentage", void 0);
(0, $29K1K.CameraInputTypes)["FollowCameraMouseWheelInput"] = $677be1af2f5ec8c0$export$5f76c53f117f3f04;

});

parcelRegister("eDb6Y", function(module, exports) {

$parcel$export(module.exports, "FollowCameraPointersInput", () => $aa6d53b0d3fa33d1$export$f266c8626cb58f63);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $29K1K = parcelRequire("29K1K");

var $clSi5 = parcelRequire("clSi5");

var $kVtWi = parcelRequire("kVtWi");
class $aa6d53b0d3fa33d1$export$f266c8626cb58f63 extends (0, $clSi5.BaseCameraPointersInput) {
    constructor(){
        super(...arguments);
        /**
         * Defines the pointer angular sensibility along the X axis or how fast is
         * the camera rotating.
         * A negative number will reverse the axis direction.
         */ this.angularSensibilityX = 1;
        /**
         * Defines the pointer angular sensibility along the Y axis or how fast is
         * the camera rotating.
         * A negative number will reverse the axis direction.
         */ this.angularSensibilityY = 1;
        /**
         * Defines the pointer pinch precision or how fast is the camera zooming.
         * A negative number will reverse the axis direction.
         */ this.pinchPrecision = 10000.0;
        /**
         * pinchDeltaPercentage will be used instead of pinchPrecision if different
         * from 0.
         * It defines the percentage of current camera.radius to use as delta when
         * pinch zoom is used.
         */ this.pinchDeltaPercentage = 0;
        /**
         * Pointer X axis controls zoom. (X axis modifies camera.radius value.)
         */ this.axisXControlRadius = false;
        /**
         * Pointer X axis controls height. (X axis modifies camera.heightOffset value.)
         */ this.axisXControlHeight = false;
        /**
         * Pointer X axis controls angle. (X axis modifies camera.rotationOffset value.)
         */ this.axisXControlRotation = true;
        /**
         * Pointer Y axis controls zoom. (Y axis modifies camera.radius value.)
         */ this.axisYControlRadius = false;
        /**
         * Pointer Y axis controls height. (Y axis modifies camera.heightOffset value.)
         */ this.axisYControlHeight = true;
        /**
         * Pointer Y axis controls angle. (Y axis modifies camera.rotationOffset value.)
         */ this.axisYControlRotation = false;
        /**
         * Pinch controls zoom. (Pinch modifies camera.radius value.)
         */ this.axisPinchControlRadius = true;
        /**
         * Pinch controls height. (Pinch modifies camera.heightOffset value.)
         */ this.axisPinchControlHeight = false;
        /**
         * Pinch controls angle. (Pinch modifies camera.rotationOffset value.)
         */ this.axisPinchControlRotation = false;
        /**
         * Log error messages if basic misconfiguration has occurred.
         */ this.warningEnable = true;
        /* Check for obvious misconfiguration. */ this._warningCounter = 0;
    }
    /**
     * Gets the class name of the current input.
     * @returns the class name
     */ getClassName() {
        return "FollowCameraPointersInput";
    }
    onTouch(pointA, offsetX, offsetY) {
        this._warning();
        if (this.axisXControlRotation) this.camera.rotationOffset += offsetX / this.angularSensibilityX;
        else if (this.axisYControlRotation) this.camera.rotationOffset += offsetY / this.angularSensibilityX;
        if (this.axisXControlHeight) this.camera.heightOffset += offsetX / this.angularSensibilityY;
        else if (this.axisYControlHeight) this.camera.heightOffset += offsetY / this.angularSensibilityY;
        if (this.axisXControlRadius) this.camera.radius -= offsetX / this.angularSensibilityY;
        else if (this.axisYControlRadius) this.camera.radius -= offsetY / this.angularSensibilityY;
    }
    onMultiTouch(pointA, pointB, previousPinchSquaredDistance, pinchSquaredDistance, previousMultiTouchPanPosition, multiTouchPanPosition) {
        if (previousPinchSquaredDistance === 0 && previousMultiTouchPanPosition === null) // First time this method is called for new pinch.
        // Next time this is called there will be a
        // previousPinchSquaredDistance and pinchSquaredDistance to compare.
        return;
        if (pinchSquaredDistance === 0 && multiTouchPanPosition === null) // Last time this method is called at the end of a pinch.
        return;
        let pinchDelta = (pinchSquaredDistance - previousPinchSquaredDistance) / (this.pinchPrecision * (this.angularSensibilityX + this.angularSensibilityY) / 2);
        if (this.pinchDeltaPercentage) {
            pinchDelta *= 0.01 * this.pinchDeltaPercentage;
            if (this.axisPinchControlRotation) this.camera.rotationOffset += pinchDelta * this.camera.rotationOffset;
            if (this.axisPinchControlHeight) this.camera.heightOffset += pinchDelta * this.camera.heightOffset;
            if (this.axisPinchControlRadius) this.camera.radius -= pinchDelta * this.camera.radius;
        } else {
            if (this.axisPinchControlRotation) this.camera.rotationOffset += pinchDelta;
            if (this.axisPinchControlHeight) this.camera.heightOffset += pinchDelta;
            if (this.axisPinchControlRadius) this.camera.radius -= pinchDelta;
        }
    }
    _warning() {
        if (!this.warningEnable || this._warningCounter++ % 100 !== 0) return;
        const warn = "It probably only makes sense to control ONE camera property with each pointer axis. Set 'warningEnable = false' if you are sure. Currently enabled: ";
        if (+this.axisXControlRotation + +this.axisXControlHeight + +this.axisXControlRadius <= 1) (0, $kVtWi.Logger).Warn(warn + "axisXControlRotation: " + this.axisXControlRotation + ", axisXControlHeight: " + this.axisXControlHeight + ", axisXControlRadius: " + this.axisXControlRadius);
        if (+this.axisYControlRotation + +this.axisYControlHeight + +this.axisYControlRadius <= 1) (0, $kVtWi.Logger).Warn(warn + "axisYControlRotation: " + this.axisYControlRotation + ", axisYControlHeight: " + this.axisYControlHeight + ", axisYControlRadius: " + this.axisYControlRadius);
        if (+this.axisPinchControlRotation + +this.axisPinchControlHeight + +this.axisPinchControlRadius <= 1) (0, $kVtWi.Logger).Warn(warn + "axisPinchControlRotation: " + this.axisPinchControlRotation + ", axisPinchControlHeight: " + this.axisPinchControlHeight + ", axisPinchControlRadius: " + this.axisPinchControlRadius);
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $aa6d53b0d3fa33d1$export$f266c8626cb58f63.prototype, "angularSensibilityX", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $aa6d53b0d3fa33d1$export$f266c8626cb58f63.prototype, "angularSensibilityY", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $aa6d53b0d3fa33d1$export$f266c8626cb58f63.prototype, "pinchPrecision", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $aa6d53b0d3fa33d1$export$f266c8626cb58f63.prototype, "pinchDeltaPercentage", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $aa6d53b0d3fa33d1$export$f266c8626cb58f63.prototype, "axisXControlRadius", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $aa6d53b0d3fa33d1$export$f266c8626cb58f63.prototype, "axisXControlHeight", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $aa6d53b0d3fa33d1$export$f266c8626cb58f63.prototype, "axisXControlRotation", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $aa6d53b0d3fa33d1$export$f266c8626cb58f63.prototype, "axisYControlRadius", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $aa6d53b0d3fa33d1$export$f266c8626cb58f63.prototype, "axisYControlHeight", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $aa6d53b0d3fa33d1$export$f266c8626cb58f63.prototype, "axisYControlRotation", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $aa6d53b0d3fa33d1$export$f266c8626cb58f63.prototype, "axisPinchControlRadius", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $aa6d53b0d3fa33d1$export$f266c8626cb58f63.prototype, "axisPinchControlHeight", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $aa6d53b0d3fa33d1$export$f266c8626cb58f63.prototype, "axisPinchControlRotation", void 0);
(0, $29K1K.CameraInputTypes)["FollowCameraPointersInput"] = $aa6d53b0d3fa33d1$export$f266c8626cb58f63;

});

parcelRegister("gAphd", function(module, exports) {

$parcel$export(module.exports, "FreeCameraDeviceOrientationInput", () => $c1339d89b0e3429f$export$34f37d3cce11e5d1);

var $29K1K = parcelRequire("29K1K");

var $ha1VO = parcelRequire("ha1VO");

var $bOhSV = parcelRequire("bOhSV");

var $8TToC = parcelRequire("8TToC");

var $diGQf = parcelRequire("diGQf");
/**
 * Add orientation input support to the input manager.
 * @param smoothFactor deviceOrientation smoothing. 0: no smoothing, 1: new data ignored, 0.9 recommended for smoothing
 * @returns the current input manager
 */ (0, $8TToC.FreeCameraInputsManager).prototype.addDeviceOrientation = function(smoothFactor) {
    if (!this._deviceOrientationInput) {
        this._deviceOrientationInput = new $c1339d89b0e3429f$export$34f37d3cce11e5d1();
        if (smoothFactor) this._deviceOrientationInput.smoothFactor = smoothFactor;
        this.add(this._deviceOrientationInput);
    }
    return this;
};
class $c1339d89b0e3429f$export$34f37d3cce11e5d1 {
    /**
     * Can be used to detect if a device orientation sensor is available on a device
     * @param timeout amount of time in milliseconds to wait for a response from the sensor (default: infinite)
     * @returns a promise that will resolve on orientation change
     */ static WaitForOrientationChangeAsync(timeout) {
        return new Promise((res, rej)=>{
            let gotValue = false;
            const eventHandler = ()=>{
                window.removeEventListener("deviceorientation", eventHandler);
                gotValue = true;
                res();
            };
            // If timeout is populated reject the promise
            if (timeout) setTimeout(()=>{
                if (!gotValue) {
                    window.removeEventListener("deviceorientation", eventHandler);
                    rej("WaitForOrientationChangeAsync timed out");
                }
            }, timeout);
            if (typeof DeviceOrientationEvent !== "undefined" && typeof DeviceOrientationEvent.requestPermission === "function") DeviceOrientationEvent.requestPermission().then((response)=>{
                if (response == "granted") window.addEventListener("deviceorientation", eventHandler);
                else (0, $bOhSV.Tools).Warn("Permission not granted.");
            }).catch((error)=>{
                (0, $bOhSV.Tools).Error(error);
            });
            else window.addEventListener("deviceorientation", eventHandler);
        });
    }
    /**
     * Instantiates a new input
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/customizingCameraInputs
     */ constructor(){
        this._screenOrientationAngle = 0;
        this._screenQuaternion = new (0, $ha1VO.Quaternion)();
        this._alpha = 0;
        this._beta = 0;
        this._gamma = 0;
        /** alpha+beta+gamma smoothing. 0: no smoothing, 1: new data ignored, 0.9 recommended for smoothing */ this.smoothFactor = 0;
        /**
         * @internal
         */ this._onDeviceOrientationChangedObservable = new (0, $diGQf.Observable)();
        this._orientationChanged = ()=>{
            this._screenOrientationAngle = window.orientation !== undefined ? +window.orientation : window.screen.orientation && window.screen.orientation["angle"] ? window.screen.orientation.angle : 0;
            this._screenOrientationAngle = -(0, $bOhSV.Tools).ToRadians(this._screenOrientationAngle / 2);
            this._screenQuaternion.copyFromFloats(0, Math.sin(this._screenOrientationAngle), 0, Math.cos(this._screenOrientationAngle));
        };
        this._deviceOrientation = (evt)=>{
            if (this.smoothFactor) {
                this._alpha = evt.alpha !== null ? (0, $bOhSV.Tools).SmoothAngleChange(this._alpha, evt.alpha, this.smoothFactor) : 0;
                this._beta = evt.beta !== null ? (0, $bOhSV.Tools).SmoothAngleChange(this._beta, evt.beta, this.smoothFactor) : 0;
                this._gamma = evt.gamma !== null ? (0, $bOhSV.Tools).SmoothAngleChange(this._gamma, evt.gamma, this.smoothFactor) : 0;
            } else {
                this._alpha = evt.alpha !== null ? evt.alpha : 0;
                this._beta = evt.beta !== null ? evt.beta : 0;
                this._gamma = evt.gamma !== null ? evt.gamma : 0;
            }
            if (evt.alpha !== null) this._onDeviceOrientationChangedObservable.notifyObservers();
        };
        this._constantTranform = new (0, $ha1VO.Quaternion)(-Math.sqrt(0.5), 0, 0, Math.sqrt(0.5));
        this._orientationChanged();
    }
    /**
     * Define the camera controlled by the input.
     */ get camera() {
        return this._camera;
    }
    set camera(camera) {
        this._camera = camera;
        if (this._camera != null && !this._camera.rotationQuaternion) this._camera.rotationQuaternion = new (0, $ha1VO.Quaternion)();
        if (this._camera) this._camera.onDisposeObservable.add(()=>{
            this._onDeviceOrientationChangedObservable.clear();
        });
    }
    /**
     * Attach the input controls to a specific dom element to get the input from.
     */ attachControl() {
        const hostWindow = this.camera.getScene().getEngine().getHostWindow();
        if (hostWindow) {
            const eventHandler = ()=>{
                hostWindow.addEventListener("orientationchange", this._orientationChanged);
                hostWindow.addEventListener("deviceorientation", this._deviceOrientation);
                //In certain cases, the attach control is called AFTER orientation was changed,
                //So this is needed.
                this._orientationChanged();
            };
            if (typeof DeviceOrientationEvent !== "undefined" && typeof DeviceOrientationEvent.requestPermission === "function") DeviceOrientationEvent.requestPermission().then((response)=>{
                if (response === "granted") eventHandler();
                else (0, $bOhSV.Tools).Warn("Permission not granted.");
            }).catch((error)=>{
                (0, $bOhSV.Tools).Error(error);
            });
            else eventHandler();
        }
    }
    /**
     * Detach the current controls from the specified dom element.
     */ detachControl() {
        window.removeEventListener("orientationchange", this._orientationChanged);
        window.removeEventListener("deviceorientation", this._deviceOrientation);
        this._alpha = 0;
    }
    /**
     * Update the current camera state depending on the inputs that have been used this frame.
     * This is a dynamically created lambda to avoid the performance penalty of looping for inputs in the render loop.
     */ checkInputs() {
        //if no device orientation provided, don't update the rotation.
        //Only testing against alpha under the assumption thatnorientation will never be so exact when set.
        if (!this._alpha) return;
        (0, $ha1VO.Quaternion).RotationYawPitchRollToRef((0, $bOhSV.Tools).ToRadians(this._alpha), (0, $bOhSV.Tools).ToRadians(this._beta), -(0, $bOhSV.Tools).ToRadians(this._gamma), this.camera.rotationQuaternion);
        this._camera.rotationQuaternion.multiplyInPlace(this._screenQuaternion);
        this._camera.rotationQuaternion.multiplyInPlace(this._constantTranform);
        //Mirror on XY Plane
        this._camera.rotationQuaternion.z *= -1;
        this._camera.rotationQuaternion.w *= -1;
    }
    /**
     * Gets the class name of the current input.
     * @returns the class name
     */ getClassName() {
        return "FreeCameraDeviceOrientationInput";
    }
    /**
     * Get the friendly name associated with the input class.
     * @returns the input friendly name
     */ getSimpleName() {
        return "deviceOrientation";
    }
}
(0, $29K1K.CameraInputTypes)["FreeCameraDeviceOrientationInput"] = $c1339d89b0e3429f$export$34f37d3cce11e5d1;

});
parcelRegister("8TToC", function(module, exports) {

$parcel$export(module.exports, "FreeCameraInputsManager", () => $67ae6e4d4c9b9347$export$603842236157aac9);

var $29K1K = parcelRequire("29K1K");

var $9BJw0 = parcelRequire("9BJw0");

var $bowiC = parcelRequire("bowiC");

var $85CSv = parcelRequire("85CSv");

var $3T1za = parcelRequire("3T1za");
class $67ae6e4d4c9b9347$export$603842236157aac9 extends (0, $29K1K.CameraInputsManager) {
    /**
     * Instantiates a new FreeCameraInputsManager.
     * @param camera Defines the camera the inputs belong to
     */ constructor(camera){
        super(camera);
        /**
         * @internal
         */ this._mouseInput = null;
        /**
         * @internal
         */ this._mouseWheelInput = null;
    }
    /**
     * Add keyboard input support to the input manager.
     * @returns the current input manager
     */ addKeyboard() {
        this.add(new (0, $9BJw0.FreeCameraKeyboardMoveInput)());
        return this;
    }
    /**
     * Add mouse input support to the input manager.
     * @param touchEnabled if the FreeCameraMouseInput should support touch (default: true)
     * @returns the current input manager
     */ addMouse(touchEnabled = true) {
        if (!this._mouseInput) {
            this._mouseInput = new (0, $bowiC.FreeCameraMouseInput)(touchEnabled);
            this.add(this._mouseInput);
        }
        return this;
    }
    /**
     * Removes the mouse input support from the manager
     * @returns the current input manager
     */ removeMouse() {
        if (this._mouseInput) this.remove(this._mouseInput);
        return this;
    }
    /**
     * Add mouse wheel input support to the input manager.
     * @returns the current input manager
     */ addMouseWheel() {
        if (!this._mouseWheelInput) {
            this._mouseWheelInput = new (0, $85CSv.FreeCameraMouseWheelInput)();
            this.add(this._mouseWheelInput);
        }
        return this;
    }
    /**
     * Removes the mouse wheel input support from the manager
     * @returns the current input manager
     */ removeMouseWheel() {
        if (this._mouseWheelInput) this.remove(this._mouseWheelInput);
        return this;
    }
    /**
     * Add touch input support to the input manager.
     * @returns the current input manager
     */ addTouch() {
        this.add(new (0, $3T1za.FreeCameraTouchInput)());
        return this;
    }
    /**
     * Remove all attached input methods from a camera
     */ clear() {
        super.clear();
        this._mouseInput = null;
    }
}

});
parcelRegister("9BJw0", function(module, exports) {

$parcel$export(module.exports, "FreeCameraKeyboardMoveInput", () => $6feae01bbcb1664b$export$305b6c32b531d902);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $29K1K = parcelRequire("29K1K");

var $bcFoB = parcelRequire("bcFoB");

var $ha1VO = parcelRequire("ha1VO");

var $bOhSV = parcelRequire("bOhSV");
class $6feae01bbcb1664b$export$305b6c32b531d902 {
    constructor(){
        /**
         * Gets or Set the list of keyboard keys used to control the forward move of the camera.
         */ this.keysUp = [
            38
        ];
        /**
         * Gets or Set the list of keyboard keys used to control the upward move of the camera.
         */ this.keysUpward = [
            33
        ];
        /**
         * Gets or Set the list of keyboard keys used to control the backward move of the camera.
         */ this.keysDown = [
            40
        ];
        /**
         * Gets or Set the list of keyboard keys used to control the downward move of the camera.
         */ this.keysDownward = [
            34
        ];
        /**
         * Gets or Set the list of keyboard keys used to control the left strafe move of the camera.
         */ this.keysLeft = [
            37
        ];
        /**
         * Gets or Set the list of keyboard keys used to control the right strafe move of the camera.
         */ this.keysRight = [
            39
        ];
        /**
         * Defines the pointer angular sensibility  along the X and Y axis or how fast is the camera rotating.
         */ this.rotationSpeed = 0.5;
        /**
         * Gets or Set the list of keyboard keys used to control the left rotation move of the camera.
         */ this.keysRotateLeft = [];
        /**
         * Gets or Set the list of keyboard keys used to control the right rotation move of the camera.
         */ this.keysRotateRight = [];
        /**
         * Gets or Set the list of keyboard keys used to control the up rotation move of the camera.
         */ this.keysRotateUp = [];
        /**
         * Gets or Set the list of keyboard keys used to control the down rotation move of the camera.
         */ this.keysRotateDown = [];
        this._keys = new Array();
    }
    /**
     * Attach the input controls to a specific dom element to get the input from.
     * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
     */ attachControl(noPreventDefault) {
        // eslint-disable-next-line prefer-rest-params
        noPreventDefault = (0, $bOhSV.Tools).BackCompatCameraNoPreventDefault(arguments);
        if (this._onCanvasBlurObserver) return;
        this._scene = this.camera.getScene();
        this._engine = this._scene.getEngine();
        this._onCanvasBlurObserver = this._engine.onCanvasBlurObservable.add(()=>{
            this._keys.length = 0;
        });
        this._onKeyboardObserver = this._scene.onKeyboardObservable.add((info)=>{
            const evt = info.event;
            if (!evt.metaKey) {
                if (info.type === (0, $bcFoB.KeyboardEventTypes).KEYDOWN) {
                    if (this.keysUp.indexOf(evt.keyCode) !== -1 || this.keysDown.indexOf(evt.keyCode) !== -1 || this.keysLeft.indexOf(evt.keyCode) !== -1 || this.keysRight.indexOf(evt.keyCode) !== -1 || this.keysUpward.indexOf(evt.keyCode) !== -1 || this.keysDownward.indexOf(evt.keyCode) !== -1 || this.keysRotateLeft.indexOf(evt.keyCode) !== -1 || this.keysRotateRight.indexOf(evt.keyCode) !== -1 || this.keysRotateUp.indexOf(evt.keyCode) !== -1 || this.keysRotateDown.indexOf(evt.keyCode) !== -1) {
                        const index = this._keys.indexOf(evt.keyCode);
                        if (index === -1) this._keys.push(evt.keyCode);
                        if (!noPreventDefault) evt.preventDefault();
                    }
                } else if (this.keysUp.indexOf(evt.keyCode) !== -1 || this.keysDown.indexOf(evt.keyCode) !== -1 || this.keysLeft.indexOf(evt.keyCode) !== -1 || this.keysRight.indexOf(evt.keyCode) !== -1 || this.keysUpward.indexOf(evt.keyCode) !== -1 || this.keysDownward.indexOf(evt.keyCode) !== -1 || this.keysRotateLeft.indexOf(evt.keyCode) !== -1 || this.keysRotateRight.indexOf(evt.keyCode) !== -1 || this.keysRotateUp.indexOf(evt.keyCode) !== -1 || this.keysRotateDown.indexOf(evt.keyCode) !== -1) {
                    const index = this._keys.indexOf(evt.keyCode);
                    if (index >= 0) this._keys.splice(index, 1);
                    if (!noPreventDefault) evt.preventDefault();
                }
            }
        });
    }
    /**
     * Detach the current controls from the specified dom element.
     */ detachControl() {
        if (this._scene) {
            if (this._onKeyboardObserver) this._scene.onKeyboardObservable.remove(this._onKeyboardObserver);
            if (this._onCanvasBlurObserver) this._engine.onCanvasBlurObservable.remove(this._onCanvasBlurObserver);
            this._onKeyboardObserver = null;
            this._onCanvasBlurObserver = null;
        }
        this._keys.length = 0;
    }
    /**
     * Update the current camera state depending on the inputs that have been used this frame.
     * This is a dynamically created lambda to avoid the performance penalty of looping for inputs in the render loop.
     */ checkInputs() {
        if (this._onKeyboardObserver) {
            const camera = this.camera;
            // Keyboard
            for(let index = 0; index < this._keys.length; index++){
                const keyCode = this._keys[index];
                const speed = camera._computeLocalCameraSpeed();
                if (this.keysLeft.indexOf(keyCode) !== -1) camera._localDirection.copyFromFloats(-speed, 0, 0);
                else if (this.keysUp.indexOf(keyCode) !== -1) camera._localDirection.copyFromFloats(0, 0, speed);
                else if (this.keysRight.indexOf(keyCode) !== -1) camera._localDirection.copyFromFloats(speed, 0, 0);
                else if (this.keysDown.indexOf(keyCode) !== -1) camera._localDirection.copyFromFloats(0, 0, -speed);
                else if (this.keysUpward.indexOf(keyCode) !== -1) camera._localDirection.copyFromFloats(0, speed, 0);
                else if (this.keysDownward.indexOf(keyCode) !== -1) camera._localDirection.copyFromFloats(0, -speed, 0);
                else if (this.keysRotateLeft.indexOf(keyCode) !== -1) {
                    camera._localDirection.copyFromFloats(0, 0, 0);
                    camera.cameraRotation.y -= this._getLocalRotation();
                } else if (this.keysRotateRight.indexOf(keyCode) !== -1) {
                    camera._localDirection.copyFromFloats(0, 0, 0);
                    camera.cameraRotation.y += this._getLocalRotation();
                } else if (this.keysRotateUp.indexOf(keyCode) !== -1) {
                    camera._localDirection.copyFromFloats(0, 0, 0);
                    camera.cameraRotation.x -= this._getLocalRotation();
                } else if (this.keysRotateDown.indexOf(keyCode) !== -1) {
                    camera._localDirection.copyFromFloats(0, 0, 0);
                    camera.cameraRotation.x += this._getLocalRotation();
                }
                if (camera.getScene().useRightHandedSystem) camera._localDirection.z *= -1;
                camera.getViewMatrix().invertToRef(camera._cameraTransformMatrix);
                (0, $ha1VO.Vector3).TransformNormalToRef(camera._localDirection, camera._cameraTransformMatrix, camera._transformedDirection);
                camera.cameraDirection.addInPlace(camera._transformedDirection);
            }
        }
    }
    /**
     * Gets the class name of the current input.
     * @returns the class name
     */ getClassName() {
        return "FreeCameraKeyboardMoveInput";
    }
    /** @internal */ _onLostFocus() {
        this._keys.length = 0;
    }
    /**
     * Get the friendly name associated with the input class.
     * @returns the input friendly name
     */ getSimpleName() {
        return "keyboard";
    }
    _getLocalRotation() {
        const handednessMultiplier = this.camera._calculateHandednessMultiplier();
        const rotation = this.rotationSpeed * this._engine.getDeltaTime() / 1000 * handednessMultiplier;
        return rotation;
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6feae01bbcb1664b$export$305b6c32b531d902.prototype, "keysUp", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6feae01bbcb1664b$export$305b6c32b531d902.prototype, "keysUpward", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6feae01bbcb1664b$export$305b6c32b531d902.prototype, "keysDown", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6feae01bbcb1664b$export$305b6c32b531d902.prototype, "keysDownward", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6feae01bbcb1664b$export$305b6c32b531d902.prototype, "keysLeft", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6feae01bbcb1664b$export$305b6c32b531d902.prototype, "keysRight", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6feae01bbcb1664b$export$305b6c32b531d902.prototype, "rotationSpeed", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6feae01bbcb1664b$export$305b6c32b531d902.prototype, "keysRotateLeft", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6feae01bbcb1664b$export$305b6c32b531d902.prototype, "keysRotateRight", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6feae01bbcb1664b$export$305b6c32b531d902.prototype, "keysRotateUp", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6feae01bbcb1664b$export$305b6c32b531d902.prototype, "keysRotateDown", void 0);
(0, $29K1K.CameraInputTypes)["FreeCameraKeyboardMoveInput"] = $6feae01bbcb1664b$export$305b6c32b531d902;

});

parcelRegister("bowiC", function(module, exports) {

$parcel$export(module.exports, "FreeCameraMouseInput", () => $84bafd8ee25f9248$export$e4394c458ad439f0);

var $e0Suo = parcelRequire("e0Suo");

var $diGQf = parcelRequire("diGQf");

var $ir0rz = parcelRequire("ir0rz");

var $29K1K = parcelRequire("29K1K");

var $cfkw4 = parcelRequire("cfkw4");

var $bOhSV = parcelRequire("bOhSV");
class $84bafd8ee25f9248$export$e4394c458ad439f0 {
    /**
     * Manage the mouse inputs to control the movement of a free camera.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/customizingCameraInputs
     * @param touchEnabled Defines if touch is enabled or not
     */ constructor(/**
     * Define if touch is enabled in the mouse input
     */ touchEnabled = true){
        this.touchEnabled = touchEnabled;
        /**
         * Defines the buttons associated with the input to handle camera move.
         */ this.buttons = [
            0,
            1,
            2
        ];
        /**
         * Defines the pointer angular sensibility  along the X and Y axis or how fast is the camera rotating.
         */ this.angularSensibility = 2000.0;
        this._previousPosition = null;
        /**
         * Observable for when a pointer move event occurs containing the move offset
         */ this.onPointerMovedObservable = new (0, $diGQf.Observable)();
        /**
         * @internal
         * If the camera should be rotated automatically based on pointer movement
         */ this._allowCameraRotation = true;
        this._currentActiveButton = -1;
        this._activePointerId = -1;
    }
    /**
     * Attach the input controls to a specific dom element to get the input from.
     * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
     */ attachControl(noPreventDefault) {
        // eslint-disable-next-line prefer-rest-params
        noPreventDefault = (0, $bOhSV.Tools).BackCompatCameraNoPreventDefault(arguments);
        const engine = this.camera.getEngine();
        const element = engine.getInputElement();
        if (!this._pointerInput) this._pointerInput = (p)=>{
            const evt = p.event;
            const isTouch = evt.pointerType === "touch";
            if (!this.touchEnabled && isTouch) return;
            if (p.type !== (0, $cfkw4.PointerEventTypes).POINTERMOVE && this.buttons.indexOf(evt.button) === -1) return;
            const srcElement = evt.target;
            if (p.type === (0, $cfkw4.PointerEventTypes).POINTERDOWN) {
                // If the input is touch with more than one touch OR if the input is mouse and there is already an active button, return
                if (isTouch && this._activePointerId !== -1 || !isTouch && this._currentActiveButton !== -1) return;
                this._activePointerId = evt.pointerId;
                try {
                    srcElement?.setPointerCapture(evt.pointerId);
                } catch (e) {
                //Nothing to do with the error. Execution will continue.
                }
                if (this._currentActiveButton === -1) this._currentActiveButton = evt.button;
                this._previousPosition = {
                    x: evt.clientX,
                    y: evt.clientY
                };
                if (!noPreventDefault) {
                    evt.preventDefault();
                    element && element.focus();
                }
                // This is required to move while pointer button is down
                if (engine.isPointerLock && this._onMouseMove) this._onMouseMove(p.event);
            } else if (p.type === (0, $cfkw4.PointerEventTypes).POINTERUP) {
                // If input is touch with a different touch id OR if input is mouse with a different button, return
                if (isTouch && this._activePointerId !== evt.pointerId || !isTouch && this._currentActiveButton !== evt.button) return;
                try {
                    srcElement?.releasePointerCapture(evt.pointerId);
                } catch (e) {
                //Nothing to do with the error.
                }
                this._currentActiveButton = -1;
                this._previousPosition = null;
                if (!noPreventDefault) evt.preventDefault();
                this._activePointerId = -1;
            } else if (p.type === (0, $cfkw4.PointerEventTypes).POINTERMOVE && (this._activePointerId === evt.pointerId || !isTouch)) {
                if (engine.isPointerLock && this._onMouseMove) this._onMouseMove(p.event);
                else if (this._previousPosition) {
                    const handednessMultiplier = this.camera._calculateHandednessMultiplier();
                    const offsetX = (evt.clientX - this._previousPosition.x) * handednessMultiplier;
                    const offsetY = evt.clientY - this._previousPosition.y;
                    if (this._allowCameraRotation) {
                        this.camera.cameraRotation.y += offsetX / this.angularSensibility;
                        this.camera.cameraRotation.x += offsetY / this.angularSensibility;
                    }
                    this.onPointerMovedObservable.notifyObservers({
                        offsetX: offsetX,
                        offsetY: offsetY
                    });
                    this._previousPosition = {
                        x: evt.clientX,
                        y: evt.clientY
                    };
                    if (!noPreventDefault) evt.preventDefault();
                }
            }
        };
        this._onMouseMove = (evt)=>{
            if (!engine.isPointerLock) return;
            const handednessMultiplier = this.camera._calculateHandednessMultiplier();
            const offsetX = evt.movementX * handednessMultiplier;
            this.camera.cameraRotation.y += offsetX / this.angularSensibility;
            const offsetY = evt.movementY;
            this.camera.cameraRotation.x += offsetY / this.angularSensibility;
            this._previousPosition = null;
            if (!noPreventDefault) evt.preventDefault();
        };
        this._observer = this.camera.getScene()._inputManager._addCameraPointerObserver(this._pointerInput, (0, $cfkw4.PointerEventTypes).POINTERDOWN | (0, $cfkw4.PointerEventTypes).POINTERUP | (0, $cfkw4.PointerEventTypes).POINTERMOVE);
        if (element) {
            this._contextMenuBind = (evt)=>this.onContextMenu(evt);
            element.addEventListener("contextmenu", this._contextMenuBind, false); // TODO: We need to figure out how to handle this for Native
        }
    }
    /**
     * Called on JS contextmenu event.
     * Override this method to provide functionality.
     * @param evt the context menu event
     */ onContextMenu(evt) {
        evt.preventDefault();
    }
    /**
     * Detach the current controls from the specified dom element.
     */ detachControl() {
        if (this._observer) {
            this.camera.getScene()._inputManager._removeCameraPointerObserver(this._observer);
            if (this._contextMenuBind) {
                const engine = this.camera.getEngine();
                const element = engine.getInputElement();
                element && element.removeEventListener("contextmenu", this._contextMenuBind);
            }
            if (this.onPointerMovedObservable) this.onPointerMovedObservable.clear();
            this._observer = null;
            this._onMouseMove = null;
            this._previousPosition = null;
        }
        this._activePointerId = -1;
        this._currentActiveButton = -1;
    }
    /**
     * Gets the class name of the current input.
     * @returns the class name
     */ getClassName() {
        return "FreeCameraMouseInput";
    }
    /**
     * Get the friendly name associated with the input class.
     * @returns the input friendly name
     */ getSimpleName() {
        return "mouse";
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $84bafd8ee25f9248$export$e4394c458ad439f0.prototype, "buttons", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $84bafd8ee25f9248$export$e4394c458ad439f0.prototype, "angularSensibility", void 0);
(0, $29K1K.CameraInputTypes)["FreeCameraMouseInput"] = $84bafd8ee25f9248$export$e4394c458ad439f0;

});

parcelRegister("85CSv", function(module, exports) {

$parcel$export(module.exports, "FreeCameraMouseWheelInput", () => $5e3cf2c501e5d878$export$c445413aa086ebe7);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $29K1K = parcelRequire("29K1K");

var $dsLI0 = parcelRequire("dsLI0");

var $ha1VO = parcelRequire("ha1VO");

var $dbxbu = parcelRequire("dbxbu");
// eslint-disable-next-line @typescript-eslint/naming-convention
var $5e3cf2c501e5d878$var$_CameraProperty;
(function(_CameraProperty) {
    _CameraProperty[_CameraProperty["MoveRelative"] = 0] = "MoveRelative";
    _CameraProperty[_CameraProperty["RotateRelative"] = 1] = "RotateRelative";
    _CameraProperty[_CameraProperty["MoveScene"] = 2] = "MoveScene";
})($5e3cf2c501e5d878$var$_CameraProperty || ($5e3cf2c501e5d878$var$_CameraProperty = {}));
class $5e3cf2c501e5d878$export$c445413aa086ebe7 extends (0, $dsLI0.BaseCameraMouseWheelInput) {
    constructor(){
        super(...arguments);
        this._moveRelative = (0, $ha1VO.Vector3).Zero();
        this._rotateRelative = (0, $ha1VO.Vector3).Zero();
        this._moveScene = (0, $ha1VO.Vector3).Zero();
        /**
         * These are set to the desired default behaviour.
         */ this._wheelXAction = $5e3cf2c501e5d878$var$_CameraProperty.MoveRelative;
        this._wheelXActionCoordinate = (0, $dbxbu.Coordinate).X;
        this._wheelYAction = $5e3cf2c501e5d878$var$_CameraProperty.MoveRelative;
        this._wheelYActionCoordinate = (0, $dbxbu.Coordinate).Z;
        this._wheelZAction = null;
        this._wheelZActionCoordinate = null;
    }
    /**
     * Gets the class name of the current input.
     * @returns the class name
     */ getClassName() {
        return "FreeCameraMouseWheelInput";
    }
    /**
     * Set which movement axis (relative to camera's orientation) the mouse
     * wheel's X axis controls.
     * @param axis The axis to be moved. Set null to clear.
     */ set wheelXMoveRelative(axis) {
        if (axis === null && this._wheelXAction !== $5e3cf2c501e5d878$var$_CameraProperty.MoveRelative) // Attempting to clear different _wheelXAction.
        return;
        this._wheelXAction = $5e3cf2c501e5d878$var$_CameraProperty.MoveRelative;
        this._wheelXActionCoordinate = axis;
    }
    /**
     * Get the configured movement axis (relative to camera's orientation) the
     * mouse wheel's X axis controls.
     * @returns The configured axis or null if none.
     */ get wheelXMoveRelative() {
        if (this._wheelXAction !== $5e3cf2c501e5d878$var$_CameraProperty.MoveRelative) return null;
        return this._wheelXActionCoordinate;
    }
    /**
     * Set which movement axis (relative to camera's orientation) the mouse
     * wheel's Y axis controls.
     * @param axis The axis to be moved. Set null to clear.
     */ set wheelYMoveRelative(axis) {
        if (axis === null && this._wheelYAction !== $5e3cf2c501e5d878$var$_CameraProperty.MoveRelative) // Attempting to clear different _wheelYAction.
        return;
        this._wheelYAction = $5e3cf2c501e5d878$var$_CameraProperty.MoveRelative;
        this._wheelYActionCoordinate = axis;
    }
    /**
     * Get the configured movement axis (relative to camera's orientation) the
     * mouse wheel's Y axis controls.
     * @returns The configured axis or null if none.
     */ get wheelYMoveRelative() {
        if (this._wheelYAction !== $5e3cf2c501e5d878$var$_CameraProperty.MoveRelative) return null;
        return this._wheelYActionCoordinate;
    }
    /**
     * Set which movement axis (relative to camera's orientation) the mouse
     * wheel's Z axis controls.
     * @param axis The axis to be moved. Set null to clear.
     */ set wheelZMoveRelative(axis) {
        if (axis === null && this._wheelZAction !== $5e3cf2c501e5d878$var$_CameraProperty.MoveRelative) // Attempting to clear different _wheelZAction.
        return;
        this._wheelZAction = $5e3cf2c501e5d878$var$_CameraProperty.MoveRelative;
        this._wheelZActionCoordinate = axis;
    }
    /**
     * Get the configured movement axis (relative to camera's orientation) the
     * mouse wheel's Z axis controls.
     * @returns The configured axis or null if none.
     */ get wheelZMoveRelative() {
        if (this._wheelZAction !== $5e3cf2c501e5d878$var$_CameraProperty.MoveRelative) return null;
        return this._wheelZActionCoordinate;
    }
    /**
     * Set which rotation axis (relative to camera's orientation) the mouse
     * wheel's X axis controls.
     * @param axis The axis to be moved. Set null to clear.
     */ set wheelXRotateRelative(axis) {
        if (axis === null && this._wheelXAction !== $5e3cf2c501e5d878$var$_CameraProperty.RotateRelative) // Attempting to clear different _wheelXAction.
        return;
        this._wheelXAction = $5e3cf2c501e5d878$var$_CameraProperty.RotateRelative;
        this._wheelXActionCoordinate = axis;
    }
    /**
     * Get the configured rotation axis (relative to camera's orientation) the
     * mouse wheel's X axis controls.
     * @returns The configured axis or null if none.
     */ get wheelXRotateRelative() {
        if (this._wheelXAction !== $5e3cf2c501e5d878$var$_CameraProperty.RotateRelative) return null;
        return this._wheelXActionCoordinate;
    }
    /**
     * Set which rotation axis (relative to camera's orientation) the mouse
     * wheel's Y axis controls.
     * @param axis The axis to be moved. Set null to clear.
     */ set wheelYRotateRelative(axis) {
        if (axis === null && this._wheelYAction !== $5e3cf2c501e5d878$var$_CameraProperty.RotateRelative) // Attempting to clear different _wheelYAction.
        return;
        this._wheelYAction = $5e3cf2c501e5d878$var$_CameraProperty.RotateRelative;
        this._wheelYActionCoordinate = axis;
    }
    /**
     * Get the configured rotation axis (relative to camera's orientation) the
     * mouse wheel's Y axis controls.
     * @returns The configured axis or null if none.
     */ get wheelYRotateRelative() {
        if (this._wheelYAction !== $5e3cf2c501e5d878$var$_CameraProperty.RotateRelative) return null;
        return this._wheelYActionCoordinate;
    }
    /**
     * Set which rotation axis (relative to camera's orientation) the mouse
     * wheel's Z axis controls.
     * @param axis The axis to be moved. Set null to clear.
     */ set wheelZRotateRelative(axis) {
        if (axis === null && this._wheelZAction !== $5e3cf2c501e5d878$var$_CameraProperty.RotateRelative) // Attempting to clear different _wheelZAction.
        return;
        this._wheelZAction = $5e3cf2c501e5d878$var$_CameraProperty.RotateRelative;
        this._wheelZActionCoordinate = axis;
    }
    /**
     * Get the configured rotation axis (relative to camera's orientation) the
     * mouse wheel's Z axis controls.
     * @returns The configured axis or null if none.
     */ get wheelZRotateRelative() {
        if (this._wheelZAction !== $5e3cf2c501e5d878$var$_CameraProperty.RotateRelative) return null;
        return this._wheelZActionCoordinate;
    }
    /**
     * Set which movement axis (relative to the scene) the mouse wheel's X axis
     * controls.
     * @param axis The axis to be moved. Set null to clear.
     */ set wheelXMoveScene(axis) {
        if (axis === null && this._wheelXAction !== $5e3cf2c501e5d878$var$_CameraProperty.MoveScene) // Attempting to clear different _wheelXAction.
        return;
        this._wheelXAction = $5e3cf2c501e5d878$var$_CameraProperty.MoveScene;
        this._wheelXActionCoordinate = axis;
    }
    /**
     * Get the configured movement axis (relative to the scene) the mouse wheel's
     * X axis controls.
     * @returns The configured axis or null if none.
     */ get wheelXMoveScene() {
        if (this._wheelXAction !== $5e3cf2c501e5d878$var$_CameraProperty.MoveScene) return null;
        return this._wheelXActionCoordinate;
    }
    /**
     * Set which movement axis (relative to the scene) the mouse wheel's Y axis
     * controls.
     * @param axis The axis to be moved. Set null to clear.
     */ set wheelYMoveScene(axis) {
        if (axis === null && this._wheelYAction !== $5e3cf2c501e5d878$var$_CameraProperty.MoveScene) // Attempting to clear different _wheelYAction.
        return;
        this._wheelYAction = $5e3cf2c501e5d878$var$_CameraProperty.MoveScene;
        this._wheelYActionCoordinate = axis;
    }
    /**
     * Get the configured movement axis (relative to the scene) the mouse wheel's
     * Y axis controls.
     * @returns The configured axis or null if none.
     */ get wheelYMoveScene() {
        if (this._wheelYAction !== $5e3cf2c501e5d878$var$_CameraProperty.MoveScene) return null;
        return this._wheelYActionCoordinate;
    }
    /**
     * Set which movement axis (relative to the scene) the mouse wheel's Z axis
     * controls.
     * @param axis The axis to be moved. Set null to clear.
     */ set wheelZMoveScene(axis) {
        if (axis === null && this._wheelZAction !== $5e3cf2c501e5d878$var$_CameraProperty.MoveScene) // Attempting to clear different _wheelZAction.
        return;
        this._wheelZAction = $5e3cf2c501e5d878$var$_CameraProperty.MoveScene;
        this._wheelZActionCoordinate = axis;
    }
    /**
     * Get the configured movement axis (relative to the scene) the mouse wheel's
     * Z axis controls.
     * @returns The configured axis or null if none.
     */ get wheelZMoveScene() {
        if (this._wheelZAction !== $5e3cf2c501e5d878$var$_CameraProperty.MoveScene) return null;
        return this._wheelZActionCoordinate;
    }
    /**
     * Called for each rendered frame.
     */ checkInputs() {
        if (this._wheelDeltaX === 0 && this._wheelDeltaY === 0 && this._wheelDeltaZ == 0) return;
        // Clear the camera properties that we might be updating.
        this._moveRelative.setAll(0);
        this._rotateRelative.setAll(0);
        this._moveScene.setAll(0);
        // Set the camera properties that are to be updated.
        this._updateCamera();
        if (this.camera.getScene().useRightHandedSystem) // TODO: Does this need done for worldUpdate too?
        this._moveRelative.z *= -1;
        // Convert updates relative to camera to world position update.
        const cameraTransformMatrix = (0, $ha1VO.Matrix).Zero();
        this.camera.getViewMatrix().invertToRef(cameraTransformMatrix);
        const transformedDirection = (0, $ha1VO.Vector3).Zero();
        (0, $ha1VO.Vector3).TransformNormalToRef(this._moveRelative, cameraTransformMatrix, transformedDirection);
        // Apply updates to camera position.
        this.camera.cameraRotation.x += this._rotateRelative.x / 200;
        this.camera.cameraRotation.y += this._rotateRelative.y / 200;
        this.camera.cameraDirection.addInPlace(transformedDirection);
        this.camera.cameraDirection.addInPlace(this._moveScene);
        // Call the base class implementation to handle observers and do cleanup.
        super.checkInputs();
    }
    /**
     * Update the camera according to any configured properties for the 3
     * mouse-wheel axis.
     */ _updateCamera() {
        // Do the camera updates for each of the 3 touch-wheel axis.
        this._updateCameraProperty(this._wheelDeltaX, this._wheelXAction, this._wheelXActionCoordinate);
        this._updateCameraProperty(this._wheelDeltaY, this._wheelYAction, this._wheelYActionCoordinate);
        this._updateCameraProperty(this._wheelDeltaZ, this._wheelZAction, this._wheelZActionCoordinate);
    }
    /**
     * Update one property of the camera.
     * @param value
     * @param cameraProperty
     * @param coordinate
     */ _updateCameraProperty(/* Mouse-wheel delta. */ value, /* Camera property to be changed. */ cameraProperty, /* Axis of Camera property to be changed. */ coordinate) {
        if (value === 0) // Mouse wheel has not moved.
        return;
        if (cameraProperty === null || coordinate === null) // Mouse wheel axis not configured.
        return;
        let action = null;
        switch(cameraProperty){
            case $5e3cf2c501e5d878$var$_CameraProperty.MoveRelative:
                action = this._moveRelative;
                break;
            case $5e3cf2c501e5d878$var$_CameraProperty.RotateRelative:
                action = this._rotateRelative;
                break;
            case $5e3cf2c501e5d878$var$_CameraProperty.MoveScene:
                action = this._moveScene;
                break;
        }
        switch(coordinate){
            case (0, $dbxbu.Coordinate).X:
                action.set(value, 0, 0);
                break;
            case (0, $dbxbu.Coordinate).Y:
                action.set(0, value, 0);
                break;
            case (0, $dbxbu.Coordinate).Z:
                action.set(0, 0, value);
                break;
        }
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $5e3cf2c501e5d878$export$c445413aa086ebe7.prototype, "wheelXMoveRelative", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $5e3cf2c501e5d878$export$c445413aa086ebe7.prototype, "wheelYMoveRelative", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $5e3cf2c501e5d878$export$c445413aa086ebe7.prototype, "wheelZMoveRelative", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $5e3cf2c501e5d878$export$c445413aa086ebe7.prototype, "wheelXRotateRelative", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $5e3cf2c501e5d878$export$c445413aa086ebe7.prototype, "wheelYRotateRelative", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $5e3cf2c501e5d878$export$c445413aa086ebe7.prototype, "wheelZRotateRelative", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $5e3cf2c501e5d878$export$c445413aa086ebe7.prototype, "wheelXMoveScene", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $5e3cf2c501e5d878$export$c445413aa086ebe7.prototype, "wheelYMoveScene", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $5e3cf2c501e5d878$export$c445413aa086ebe7.prototype, "wheelZMoveScene", null);
(0, $29K1K.CameraInputTypes)["FreeCameraMouseWheelInput"] = $5e3cf2c501e5d878$export$c445413aa086ebe7;

});

parcelRegister("3T1za", function(module, exports) {

$parcel$export(module.exports, "FreeCameraTouchInput", () => $2d47b927b0c6f3c0$export$c193961c52a1d438);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $29K1K = parcelRequire("29K1K");

var $cfkw4 = parcelRequire("cfkw4");

var $ha1VO = parcelRequire("ha1VO");

var $bOhSV = parcelRequire("bOhSV");
class $2d47b927b0c6f3c0$export$c193961c52a1d438 {
    /**
     * Manage the touch inputs to control the movement of a free camera.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/customizingCameraInputs
     * @param allowMouse Defines if mouse events can be treated as touch events
     */ constructor(/**
     * Define if mouse events can be treated as touch events
     */ allowMouse = false){
        this.allowMouse = allowMouse;
        /**
         * Defines the touch sensibility for rotation.
         * The lower the faster.
         */ this.touchAngularSensibility = 200000.0;
        /**
         * Defines the touch sensibility for move.
         * The lower the faster.
         */ this.touchMoveSensibility = 250.0;
        /**
         * Swap touch actions so that one touch is used for rotation and multiple for movement
         */ this.singleFingerRotate = false;
        this._offsetX = null;
        this._offsetY = null;
        this._pointerPressed = new Array();
        this._isSafari = (0, $bOhSV.Tools).IsSafari();
    }
    /**
     * Attach the input controls to a specific dom element to get the input from.
     * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
     */ attachControl(noPreventDefault) {
        // eslint-disable-next-line prefer-rest-params
        noPreventDefault = (0, $bOhSV.Tools).BackCompatCameraNoPreventDefault(arguments);
        let previousPosition = null;
        if (this._pointerInput === undefined) {
            this._onLostFocus = ()=>{
                this._offsetX = null;
                this._offsetY = null;
            };
            this._pointerInput = (p)=>{
                const evt = p.event;
                const isMouseEvent = evt.pointerType === "mouse" || this._isSafari && typeof evt.pointerType === "undefined";
                if (!this.allowMouse && isMouseEvent) return;
                if (p.type === (0, $cfkw4.PointerEventTypes).POINTERDOWN) {
                    if (!noPreventDefault) evt.preventDefault();
                    this._pointerPressed.push(evt.pointerId);
                    if (this._pointerPressed.length !== 1) return;
                    previousPosition = {
                        x: evt.clientX,
                        y: evt.clientY
                    };
                } else if (p.type === (0, $cfkw4.PointerEventTypes).POINTERUP) {
                    if (!noPreventDefault) evt.preventDefault();
                    const index = this._pointerPressed.indexOf(evt.pointerId);
                    if (index === -1) return;
                    this._pointerPressed.splice(index, 1);
                    if (index != 0) return;
                    previousPosition = null;
                    this._offsetX = null;
                    this._offsetY = null;
                } else if (p.type === (0, $cfkw4.PointerEventTypes).POINTERMOVE) {
                    if (!noPreventDefault) evt.preventDefault();
                    if (!previousPosition) return;
                    const index = this._pointerPressed.indexOf(evt.pointerId);
                    if (index != 0) return;
                    this._offsetX = evt.clientX - previousPosition.x;
                    this._offsetY = -(evt.clientY - previousPosition.y);
                }
            };
        }
        this._observer = this.camera.getScene()._inputManager._addCameraPointerObserver(this._pointerInput, (0, $cfkw4.PointerEventTypes).POINTERDOWN | (0, $cfkw4.PointerEventTypes).POINTERUP | (0, $cfkw4.PointerEventTypes).POINTERMOVE);
        if (this._onLostFocus) {
            const engine = this.camera.getEngine();
            const element = engine.getInputElement();
            element && element.addEventListener("blur", this._onLostFocus);
        }
    }
    /**
     * Detach the current controls from the specified dom element.
     */ detachControl() {
        if (this._pointerInput) {
            if (this._observer) {
                this.camera.getScene()._inputManager._removeCameraPointerObserver(this._observer);
                this._observer = null;
            }
            if (this._onLostFocus) {
                const engine = this.camera.getEngine();
                const element = engine.getInputElement();
                element && element.removeEventListener("blur", this._onLostFocus);
                this._onLostFocus = null;
            }
            this._pointerPressed.length = 0;
            this._offsetX = null;
            this._offsetY = null;
        }
    }
    /**
     * Update the current camera state depending on the inputs that have been used this frame.
     * This is a dynamically created lambda to avoid the performance penalty of looping for inputs in the render loop.
     */ checkInputs() {
        if (this._offsetX === null || this._offsetY === null) return;
        if (this._offsetX === 0 && this._offsetY === 0) return;
        const camera = this.camera;
        const handednessMultiplier = camera._calculateHandednessMultiplier();
        camera.cameraRotation.y = handednessMultiplier * this._offsetX / this.touchAngularSensibility;
        const rotateCamera = this.singleFingerRotate && this._pointerPressed.length === 1 || !this.singleFingerRotate && this._pointerPressed.length > 1;
        if (rotateCamera) camera.cameraRotation.x = -this._offsetY / this.touchAngularSensibility;
        else {
            const speed = camera._computeLocalCameraSpeed();
            const direction = new (0, $ha1VO.Vector3)(0, 0, this.touchMoveSensibility !== 0 ? speed * this._offsetY / this.touchMoveSensibility : 0);
            (0, $ha1VO.Matrix).RotationYawPitchRollToRef(camera.rotation.y, camera.rotation.x, 0, camera._cameraRotationMatrix);
            camera.cameraDirection.addInPlace((0, $ha1VO.Vector3).TransformCoordinates(direction, camera._cameraRotationMatrix));
        }
    }
    /**
     * Gets the class name of the current input.
     * @returns the class name
     */ getClassName() {
        return "FreeCameraTouchInput";
    }
    /**
     * Get the friendly name associated with the input class.
     * @returns the input friendly name
     */ getSimpleName() {
        return "touch";
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $2d47b927b0c6f3c0$export$c193961c52a1d438.prototype, "touchAngularSensibility", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $2d47b927b0c6f3c0$export$c193961c52a1d438.prototype, "touchMoveSensibility", void 0);
(0, $29K1K.CameraInputTypes)["FreeCameraTouchInput"] = $2d47b927b0c6f3c0$export$c193961c52a1d438;

});



parcelRegister("kFqWT", function(module, exports) {

$parcel$export(module.exports, "FreeCameraGamepadInput", () => $f0bc8a78aa3f92e6$export$5bd4dd479ea647ae);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $29K1K = parcelRequire("29K1K");

var $ha1VO = parcelRequire("ha1VO");

var $6gZ9Y = parcelRequire("6gZ9Y");
class $f0bc8a78aa3f92e6$export$5bd4dd479ea647ae {
    constructor(){
        /**
         * Defines the gamepad rotation sensibility.
         * This is the threshold from when rotation starts to be accounted for to prevent jittering.
         */ this.gamepadAngularSensibility = 200;
        /**
         * Defines the gamepad move sensibility.
         * This is the threshold from when moving starts to be accounted for for to prevent jittering.
         */ this.gamepadMoveSensibility = 40;
        /**
         * Defines the minimum value at which any analog stick input is ignored.
         * Note: This value should only be a value between 0 and 1.
         */ this.deadzoneDelta = 0.1;
        this._yAxisScale = 1.0;
        this._cameraTransform = (0, $ha1VO.Matrix).Identity();
        this._deltaTransform = (0, $ha1VO.Vector3).Zero();
        this._vector3 = (0, $ha1VO.Vector3).Zero();
        this._vector2 = (0, $ha1VO.Vector2).Zero();
    }
    /**
     * Gets or sets a boolean indicating that Yaxis (for right stick) should be inverted
     */ get invertYAxis() {
        return this._yAxisScale !== 1.0;
    }
    set invertYAxis(value) {
        this._yAxisScale = value ? -1 : 1.0;
    }
    /**
     * Attach the input controls to a specific dom element to get the input from.
     */ attachControl() {
        const manager = this.camera.getScene().gamepadManager;
        this._onGamepadConnectedObserver = manager.onGamepadConnectedObservable.add((gamepad)=>{
            if (gamepad.type !== (0, $6gZ9Y.Gamepad).POSE_ENABLED) // prioritize XBOX gamepads.
            {
                if (!this.gamepad || gamepad.type === (0, $6gZ9Y.Gamepad).XBOX) this.gamepad = gamepad;
            }
        });
        this._onGamepadDisconnectedObserver = manager.onGamepadDisconnectedObservable.add((gamepad)=>{
            if (this.gamepad === gamepad) this.gamepad = null;
        });
        // check if there are already other controllers connected
        this.gamepad = manager.getGamepadByType((0, $6gZ9Y.Gamepad).XBOX);
        // if no xbox controller was found, but there are gamepad controllers, take the first one
        if (!this.gamepad && manager.gamepads.length) this.gamepad = manager.gamepads[0];
    }
    /**
     * Detach the current controls from the specified dom element.
     */ detachControl() {
        this.camera.getScene().gamepadManager.onGamepadConnectedObservable.remove(this._onGamepadConnectedObserver);
        this.camera.getScene().gamepadManager.onGamepadDisconnectedObservable.remove(this._onGamepadDisconnectedObserver);
        this.gamepad = null;
    }
    /**
     * Update the current camera state depending on the inputs that have been used this frame.
     * This is a dynamically created lambda to avoid the performance penalty of looping for inputs in the render loop.
     */ checkInputs() {
        if (this.gamepad && this.gamepad.leftStick) {
            const camera = this.camera;
            const lsValues = this.gamepad.leftStick;
            if (this.gamepadMoveSensibility !== 0) {
                lsValues.x = Math.abs(lsValues.x) > this.deadzoneDelta ? lsValues.x / this.gamepadMoveSensibility : 0;
                lsValues.y = Math.abs(lsValues.y) > this.deadzoneDelta ? lsValues.y / this.gamepadMoveSensibility : 0;
            }
            let rsValues = this.gamepad.rightStick;
            if (rsValues && this.gamepadAngularSensibility !== 0) {
                rsValues.x = Math.abs(rsValues.x) > this.deadzoneDelta ? rsValues.x / this.gamepadAngularSensibility : 0;
                rsValues.y = (Math.abs(rsValues.y) > this.deadzoneDelta ? rsValues.y / this.gamepadAngularSensibility : 0) * this._yAxisScale;
            } else rsValues = {
                x: 0,
                y: 0
            };
            if (!camera.rotationQuaternion) (0, $ha1VO.Matrix).RotationYawPitchRollToRef(camera.rotation.y, camera.rotation.x, 0, this._cameraTransform);
            else camera.rotationQuaternion.toRotationMatrix(this._cameraTransform);
            const speed = camera._computeLocalCameraSpeed() * 50.0;
            this._vector3.copyFromFloats(lsValues.x * speed, 0, -lsValues.y * speed);
            (0, $ha1VO.Vector3).TransformCoordinatesToRef(this._vector3, this._cameraTransform, this._deltaTransform);
            camera.cameraDirection.addInPlace(this._deltaTransform);
            this._vector2.copyFromFloats(rsValues.y, rsValues.x);
            camera.cameraRotation.addInPlace(this._vector2);
        }
    }
    /**
     * Gets the class name of the current input.
     * @returns the class name
     */ getClassName() {
        return "FreeCameraGamepadInput";
    }
    /**
     * Get the friendly name associated with the input class.
     * @returns the input friendly name
     */ getSimpleName() {
        return "gamepad";
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $f0bc8a78aa3f92e6$export$5bd4dd479ea647ae.prototype, "gamepadAngularSensibility", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $f0bc8a78aa3f92e6$export$5bd4dd479ea647ae.prototype, "gamepadMoveSensibility", void 0);
(0, $29K1K.CameraInputTypes)["FreeCameraGamepadInput"] = $f0bc8a78aa3f92e6$export$5bd4dd479ea647ae;

});

parcelRegister("8xWbe", function(module, exports) {

$parcel$export(module.exports, "FreeCameraVirtualJoystickInput", () => $638e892f0e354986$export$96a5a75d561964ca);

var $5MhAr = parcelRequire("5MhAr");

var $29K1K = parcelRequire("29K1K");

var $ha1VO = parcelRequire("ha1VO");

var $8TToC = parcelRequire("8TToC");
/**
 * Add virtual joystick input support to the input manager.
 * @returns the current input manager
 */ (0, $8TToC.FreeCameraInputsManager).prototype.addVirtualJoystick = function() {
    this.add(new $638e892f0e354986$export$96a5a75d561964ca());
    return this;
};
class $638e892f0e354986$export$96a5a75d561964ca {
    /**
     * Gets the left stick of the virtual joystick.
     * @returns The virtual Joystick
     */ getLeftJoystick() {
        return this._leftjoystick;
    }
    /**
     * Gets the right stick of the virtual joystick.
     * @returns The virtual Joystick
     */ getRightJoystick() {
        return this._rightjoystick;
    }
    /**
     * Update the current camera state depending on the inputs that have been used this frame.
     * This is a dynamically created lambda to avoid the performance penalty of looping for inputs in the render loop.
     */ checkInputs() {
        if (this._leftjoystick) {
            const camera = this.camera;
            const speed = camera._computeLocalCameraSpeed() * 50;
            const cameraTransform = (0, $ha1VO.Matrix).RotationYawPitchRoll(camera.rotation.y, camera.rotation.x, 0);
            const deltaTransform = (0, $ha1VO.Vector3).TransformCoordinates(new (0, $ha1VO.Vector3)(this._leftjoystick.deltaPosition.x * speed, this._leftjoystick.deltaPosition.y * speed, this._leftjoystick.deltaPosition.z * speed), cameraTransform);
            camera.cameraDirection = camera.cameraDirection.add(deltaTransform);
            camera.cameraRotation = camera.cameraRotation.addVector3(this._rightjoystick.deltaPosition);
            if (!this._leftjoystick.pressed) this._leftjoystick.deltaPosition = this._leftjoystick.deltaPosition.scale(0.9);
            if (!this._rightjoystick.pressed) this._rightjoystick.deltaPosition = this._rightjoystick.deltaPosition.scale(0.9);
        }
    }
    /**
     * Attach the input controls to a specific dom element to get the input from.
     */ attachControl() {
        this._leftjoystick = new (0, $5MhAr.VirtualJoystick)(true);
        this._leftjoystick.setAxisForUpDown((0, $5MhAr.JoystickAxis).Z);
        this._leftjoystick.setAxisForLeftRight((0, $5MhAr.JoystickAxis).X);
        this._leftjoystick.setJoystickSensibility(0.15);
        this._rightjoystick = new (0, $5MhAr.VirtualJoystick)(false);
        this._rightjoystick.setAxisForUpDown((0, $5MhAr.JoystickAxis).X);
        this._rightjoystick.setAxisForLeftRight((0, $5MhAr.JoystickAxis).Y);
        this._rightjoystick.reverseUpDown = true;
        this._rightjoystick.setJoystickSensibility(0.05);
        this._rightjoystick.setJoystickColor("yellow");
    }
    /**
     * Detach the current controls from the specified dom element.
     */ detachControl() {
        this._leftjoystick.releaseCanvas();
        this._rightjoystick.releaseCanvas();
    }
    /**
     * Gets the class name of the current input.
     * @returns the class name
     */ getClassName() {
        return "FreeCameraVirtualJoystickInput";
    }
    /**
     * Get the friendly name associated with the input class.
     * @returns the input friendly name
     */ getSimpleName() {
        return "virtualJoystick";
    }
}
(0, $29K1K.CameraInputTypes)["FreeCameraVirtualJoystickInput"] = $638e892f0e354986$export$96a5a75d561964ca;

});
parcelRegister("5MhAr", function(module, exports) {

$parcel$export(module.exports, "JoystickAxis", () => $434f13cef104f7ce$export$af35be171daa0fd4);
$parcel$export(module.exports, "VirtualJoystick", () => $434f13cef104f7ce$export$9e3234f70c75e444);

var $ha1VO = parcelRequire("ha1VO");

var $895IS = parcelRequire("895IS");
var $434f13cef104f7ce$export$af35be171daa0fd4;
(function(JoystickAxis) {
    /** X axis */ JoystickAxis[JoystickAxis["X"] = 0] = "X";
    /** Y axis */ JoystickAxis[JoystickAxis["Y"] = 1] = "Y";
    /** Z axis */ JoystickAxis[JoystickAxis["Z"] = 2] = "Z";
})($434f13cef104f7ce$export$af35be171daa0fd4 || ($434f13cef104f7ce$export$af35be171daa0fd4 = {}));
class $434f13cef104f7ce$export$9e3234f70c75e444 {
    static _GetDefaultOptions() {
        return {
            puckSize: 40,
            containerSize: 60,
            color: "cyan",
            puckImage: undefined,
            containerImage: undefined,
            position: undefined,
            alwaysVisible: false,
            limitToContainer: false
        };
    }
    /**
     * Creates a new virtual joystick
     * @param leftJoystick defines that the joystick is for left hand (false by default)
     * @param customizations Defines the options we want to customize the VirtualJoystick
     */ constructor(leftJoystick, customizations){
        this._released = false;
        const options = {
            ...$434f13cef104f7ce$export$9e3234f70c75e444._GetDefaultOptions(),
            ...customizations
        };
        if (leftJoystick) this._leftJoystick = true;
        else this._leftJoystick = false;
        $434f13cef104f7ce$export$9e3234f70c75e444._GlobalJoystickIndex++;
        // By default left & right arrow keys are moving the X
        // and up & down keys are moving the Y
        this._axisTargetedByLeftAndRight = $434f13cef104f7ce$export$af35be171daa0fd4.X;
        this._axisTargetedByUpAndDown = $434f13cef104f7ce$export$af35be171daa0fd4.Y;
        this.reverseLeftRight = false;
        this.reverseUpDown = false;
        // collections of pointers
        this._touches = new (0, $895IS.StringDictionary)();
        this.deltaPosition = (0, $ha1VO.Vector3).Zero();
        this._joystickSensibility = 25;
        this._inversedSensibility = 1 / (this._joystickSensibility / 1000);
        this._onResize = ()=>{
            $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasWidth = window.innerWidth;
            $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasHeight = window.innerHeight;
            if ($434f13cef104f7ce$export$9e3234f70c75e444.Canvas) {
                $434f13cef104f7ce$export$9e3234f70c75e444.Canvas.width = $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasWidth;
                $434f13cef104f7ce$export$9e3234f70c75e444.Canvas.height = $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasHeight;
            }
            $434f13cef104f7ce$export$9e3234f70c75e444._HalfWidth = $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasWidth / 2;
        };
        // injecting a canvas element on top of the canvas 3D game
        if (!$434f13cef104f7ce$export$9e3234f70c75e444.Canvas) {
            window.addEventListener("resize", this._onResize, false);
            $434f13cef104f7ce$export$9e3234f70c75e444.Canvas = document.createElement("canvas");
            $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasWidth = window.innerWidth;
            $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasHeight = window.innerHeight;
            $434f13cef104f7ce$export$9e3234f70c75e444.Canvas.width = window.innerWidth;
            $434f13cef104f7ce$export$9e3234f70c75e444.Canvas.height = window.innerHeight;
            $434f13cef104f7ce$export$9e3234f70c75e444.Canvas.style.width = "100%";
            $434f13cef104f7ce$export$9e3234f70c75e444.Canvas.style.height = "100%";
            $434f13cef104f7ce$export$9e3234f70c75e444.Canvas.style.position = "absolute";
            $434f13cef104f7ce$export$9e3234f70c75e444.Canvas.style.backgroundColor = "transparent";
            $434f13cef104f7ce$export$9e3234f70c75e444.Canvas.style.top = "0px";
            $434f13cef104f7ce$export$9e3234f70c75e444.Canvas.style.left = "0px";
            $434f13cef104f7ce$export$9e3234f70c75e444.Canvas.style.zIndex = "5";
            $434f13cef104f7ce$export$9e3234f70c75e444.Canvas.style.touchAction = "none"; // fix https://forum.babylonjs.com/t/virtualjoystick-needs-to-set-style-touch-action-none-explicitly/9562
            // Support for jQuery PEP polyfill
            $434f13cef104f7ce$export$9e3234f70c75e444.Canvas.setAttribute("touch-action", "none");
            const context = $434f13cef104f7ce$export$9e3234f70c75e444.Canvas.getContext("2d");
            if (!context) throw new Error("Unable to create canvas for virtual joystick");
            $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasContext = context;
            $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasContext.strokeStyle = "#ffffff";
            $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasContext.lineWidth = 2;
            document.body.appendChild($434f13cef104f7ce$export$9e3234f70c75e444.Canvas);
        }
        $434f13cef104f7ce$export$9e3234f70c75e444._HalfWidth = $434f13cef104f7ce$export$9e3234f70c75e444.Canvas.width / 2;
        this.pressed = false;
        this.limitToContainer = options.limitToContainer;
        // default joystick color
        this._joystickColor = options.color;
        // default joystick size
        this.containerSize = options.containerSize;
        this.puckSize = options.puckSize;
        if (options.position) this.setPosition(options.position.x, options.position.y);
        if (options.puckImage) this.setPuckImage(options.puckImage);
        if (options.containerImage) this.setContainerImage(options.containerImage);
        if (options.alwaysVisible) $434f13cef104f7ce$export$9e3234f70c75e444._AlwaysVisibleSticks++;
        // must come after position potentially set
        this.alwaysVisible = options.alwaysVisible;
        this._joystickPointerId = -1;
        // current joystick position
        this._joystickPointerPos = new (0, $ha1VO.Vector2)(0, 0);
        this._joystickPreviousPointerPos = new (0, $ha1VO.Vector2)(0, 0);
        // origin joystick position
        this._joystickPointerStartPos = new (0, $ha1VO.Vector2)(0, 0);
        this._deltaJoystickVector = new (0, $ha1VO.Vector2)(0, 0);
        this._onPointerDownHandlerRef = (evt)=>{
            this._onPointerDown(evt);
        };
        this._onPointerMoveHandlerRef = (evt)=>{
            this._onPointerMove(evt);
        };
        this._onPointerUpHandlerRef = (evt)=>{
            this._onPointerUp(evt);
        };
        $434f13cef104f7ce$export$9e3234f70c75e444.Canvas.addEventListener("pointerdown", this._onPointerDownHandlerRef, false);
        $434f13cef104f7ce$export$9e3234f70c75e444.Canvas.addEventListener("pointermove", this._onPointerMoveHandlerRef, false);
        $434f13cef104f7ce$export$9e3234f70c75e444.Canvas.addEventListener("pointerup", this._onPointerUpHandlerRef, false);
        $434f13cef104f7ce$export$9e3234f70c75e444.Canvas.addEventListener("pointerout", this._onPointerUpHandlerRef, false);
        $434f13cef104f7ce$export$9e3234f70c75e444.Canvas.addEventListener("contextmenu", (evt)=>{
            evt.preventDefault(); // Disables system menu
        }, false);
        requestAnimationFrame(()=>{
            this._drawVirtualJoystick();
        });
    }
    /**
     * Defines joystick sensibility (ie. the ratio between a physical move and virtual joystick position change)
     * @param newJoystickSensibility defines the new sensibility
     */ setJoystickSensibility(newJoystickSensibility) {
        this._joystickSensibility = newJoystickSensibility;
        this._inversedSensibility = 1 / (this._joystickSensibility / 1000);
    }
    _onPointerDown(e) {
        let positionOnScreenCondition;
        e.preventDefault();
        if (this._leftJoystick === true) positionOnScreenCondition = e.clientX < $434f13cef104f7ce$export$9e3234f70c75e444._HalfWidth;
        else positionOnScreenCondition = e.clientX > $434f13cef104f7ce$export$9e3234f70c75e444._HalfWidth;
        if (positionOnScreenCondition && this._joystickPointerId < 0) {
            // First contact will be dedicated to the virtual joystick
            this._joystickPointerId = e.pointerId;
            if (this._joystickPosition) {
                this._joystickPointerStartPos = this._joystickPosition.clone();
                this._joystickPointerPos = this._joystickPosition.clone();
                this._joystickPreviousPointerPos = this._joystickPosition.clone();
                // in case the user only clicks down && doesn't move:
                // this ensures the delta is properly set
                this._onPointerMove(e);
            } else {
                this._joystickPointerStartPos.x = e.clientX;
                this._joystickPointerStartPos.y = e.clientY;
                this._joystickPointerPos = this._joystickPointerStartPos.clone();
                this._joystickPreviousPointerPos = this._joystickPointerStartPos.clone();
            }
            this._deltaJoystickVector.x = 0;
            this._deltaJoystickVector.y = 0;
            this.pressed = true;
            this._touches.add(e.pointerId.toString(), e);
        } else // You can only trigger the action buttons with a joystick declared
        if ($434f13cef104f7ce$export$9e3234f70c75e444._GlobalJoystickIndex < 2 && this._action) {
            this._action();
            this._touches.add(e.pointerId.toString(), {
                x: e.clientX,
                y: e.clientY,
                prevX: e.clientX,
                prevY: e.clientY
            });
        }
    }
    _onPointerMove(e) {
        // If the current pointer is the one associated to the joystick (first touch contact)
        if (this._joystickPointerId == e.pointerId) {
            // limit to container if need be
            if (this.limitToContainer) {
                const vector = new (0, $ha1VO.Vector2)(e.clientX - this._joystickPointerStartPos.x, e.clientY - this._joystickPointerStartPos.y);
                const distance = vector.length();
                if (distance > this.containerSize) vector.scaleInPlace(this.containerSize / distance);
                this._joystickPointerPos.x = this._joystickPointerStartPos.x + vector.x;
                this._joystickPointerPos.y = this._joystickPointerStartPos.y + vector.y;
            } else {
                this._joystickPointerPos.x = e.clientX;
                this._joystickPointerPos.y = e.clientY;
            }
            // create delta vector
            this._deltaJoystickVector = this._joystickPointerPos.clone();
            this._deltaJoystickVector = this._deltaJoystickVector.subtract(this._joystickPointerStartPos);
            // if a joystick is always visible, there will be clipping issues if
            // you drag the puck from one over the container of the other
            if (0 < $434f13cef104f7ce$export$9e3234f70c75e444._AlwaysVisibleSticks) {
                if (this._leftJoystick) this._joystickPointerPos.x = Math.min($434f13cef104f7ce$export$9e3234f70c75e444._HalfWidth, this._joystickPointerPos.x);
                else this._joystickPointerPos.x = Math.max($434f13cef104f7ce$export$9e3234f70c75e444._HalfWidth, this._joystickPointerPos.x);
            }
            const directionLeftRight = this.reverseLeftRight ? -1 : 1;
            const deltaJoystickX = directionLeftRight * this._deltaJoystickVector.x / this._inversedSensibility;
            switch(this._axisTargetedByLeftAndRight){
                case $434f13cef104f7ce$export$af35be171daa0fd4.X:
                    this.deltaPosition.x = Math.min(1, Math.max(-1, deltaJoystickX));
                    break;
                case $434f13cef104f7ce$export$af35be171daa0fd4.Y:
                    this.deltaPosition.y = Math.min(1, Math.max(-1, deltaJoystickX));
                    break;
                case $434f13cef104f7ce$export$af35be171daa0fd4.Z:
                    this.deltaPosition.z = Math.min(1, Math.max(-1, deltaJoystickX));
                    break;
            }
            const directionUpDown = this.reverseUpDown ? 1 : -1;
            const deltaJoystickY = directionUpDown * this._deltaJoystickVector.y / this._inversedSensibility;
            switch(this._axisTargetedByUpAndDown){
                case $434f13cef104f7ce$export$af35be171daa0fd4.X:
                    this.deltaPosition.x = Math.min(1, Math.max(-1, deltaJoystickY));
                    break;
                case $434f13cef104f7ce$export$af35be171daa0fd4.Y:
                    this.deltaPosition.y = Math.min(1, Math.max(-1, deltaJoystickY));
                    break;
                case $434f13cef104f7ce$export$af35be171daa0fd4.Z:
                    this.deltaPosition.z = Math.min(1, Math.max(-1, deltaJoystickY));
                    break;
            }
        } else {
            const data = this._touches.get(e.pointerId.toString());
            if (data) {
                data.x = e.clientX;
                data.y = e.clientY;
            }
        }
    }
    _onPointerUp(e) {
        if (this._joystickPointerId == e.pointerId) {
            this._clearPreviousDraw();
            this._joystickPointerId = -1;
            this.pressed = false;
        } else {
            const touch = this._touches.get(e.pointerId.toString());
            if (touch) $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasContext.clearRect(touch.prevX - 44, touch.prevY - 44, 88, 88);
        }
        this._deltaJoystickVector.x = 0;
        this._deltaJoystickVector.y = 0;
        this._touches.remove(e.pointerId.toString());
    }
    /**
     * Change the color of the virtual joystick
     * @param newColor a string that must be a CSS color value (like "red") or the hexa value (like "#FF0000")
     */ setJoystickColor(newColor) {
        this._joystickColor = newColor;
    }
    /**
     * Size of the joystick's container
     */ set containerSize(newSize) {
        this._joystickContainerSize = newSize;
        this._clearContainerSize = ~~(this._joystickContainerSize * 2.1);
        this._clearContainerSizeOffset = ~~(this._clearContainerSize / 2);
    }
    get containerSize() {
        return this._joystickContainerSize;
    }
    /**
     * Size of the joystick's puck
     */ set puckSize(newSize) {
        this._joystickPuckSize = newSize;
        this._clearPuckSize = ~~(this._joystickPuckSize * 2.1);
        this._clearPuckSizeOffset = ~~(this._clearPuckSize / 2);
    }
    get puckSize() {
        return this._joystickPuckSize;
    }
    /**
     * Clears the set position of the joystick
     */ clearPosition() {
        this.alwaysVisible = false;
        this._joystickPosition = null;
    }
    /**
     * Defines whether or not the joystick container is always visible
     */ set alwaysVisible(value) {
        if (this._alwaysVisible === value) return;
        if (value && this._joystickPosition) {
            $434f13cef104f7ce$export$9e3234f70c75e444._AlwaysVisibleSticks++;
            this._alwaysVisible = true;
        } else {
            $434f13cef104f7ce$export$9e3234f70c75e444._AlwaysVisibleSticks--;
            this._alwaysVisible = false;
        }
    }
    get alwaysVisible() {
        return this._alwaysVisible;
    }
    /**
     * Sets the constant position of the Joystick container
     * @param x X axis coordinate
     * @param y Y axis coordinate
     */ setPosition(x, y) {
        // just in case position is moved while the container is visible
        if (this._joystickPointerStartPos) this._clearPreviousDraw();
        this._joystickPosition = new (0, $ha1VO.Vector2)(x, y);
    }
    /**
     * Defines a callback to call when the joystick is touched
     * @param action defines the callback
     */ setActionOnTouch(action) {
        this._action = action;
    }
    /**
     * Defines which axis you'd like to control for left & right
     * @param axis defines the axis to use
     */ setAxisForLeftRight(axis) {
        switch(axis){
            case $434f13cef104f7ce$export$af35be171daa0fd4.X:
            case $434f13cef104f7ce$export$af35be171daa0fd4.Y:
            case $434f13cef104f7ce$export$af35be171daa0fd4.Z:
                this._axisTargetedByLeftAndRight = axis;
                break;
            default:
                this._axisTargetedByLeftAndRight = $434f13cef104f7ce$export$af35be171daa0fd4.X;
                break;
        }
    }
    /**
     * Defines which axis you'd like to control for up & down
     * @param axis defines the axis to use
     */ setAxisForUpDown(axis) {
        switch(axis){
            case $434f13cef104f7ce$export$af35be171daa0fd4.X:
            case $434f13cef104f7ce$export$af35be171daa0fd4.Y:
            case $434f13cef104f7ce$export$af35be171daa0fd4.Z:
                this._axisTargetedByUpAndDown = axis;
                break;
            default:
                this._axisTargetedByUpAndDown = $434f13cef104f7ce$export$af35be171daa0fd4.Y;
                break;
        }
    }
    /**
     * Clears the canvas from the previous puck / container draw
     */ _clearPreviousDraw() {
        const jp = this._joystickPosition || this._joystickPointerStartPos;
        // clear container pixels
        $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasContext.clearRect(jp.x - this._clearContainerSizeOffset, jp.y - this._clearContainerSizeOffset, this._clearContainerSize, this._clearContainerSize);
        // clear puck pixels + 1 pixel for the change made before it moved
        $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasContext.clearRect(this._joystickPreviousPointerPos.x - this._clearPuckSizeOffset - 1, this._joystickPreviousPointerPos.y - this._clearPuckSizeOffset - 1, this._clearPuckSize + 2, this._clearPuckSize + 2);
    }
    /**
     * Loads `urlPath` to be used for the container's image
     * @param urlPath defines the urlPath of an image to use
     */ setContainerImage(urlPath) {
        const image = new Image();
        image.src = urlPath;
        image.onload = ()=>this._containerImage = image;
    }
    /**
     * Loads `urlPath` to be used for the puck's image
     * @param urlPath defines the urlPath of an image to use
     */ setPuckImage(urlPath) {
        const image = new Image();
        image.src = urlPath;
        image.onload = ()=>this._puckImage = image;
    }
    /**
     * Draws the Virtual Joystick's container
     */ _drawContainer() {
        const jp = this._joystickPosition || this._joystickPointerStartPos;
        this._clearPreviousDraw();
        if (this._containerImage) $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasContext.drawImage(this._containerImage, jp.x - this.containerSize, jp.y - this.containerSize, this.containerSize * 2, this.containerSize * 2);
        else {
            // outer container
            $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasContext.beginPath();
            $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasContext.strokeStyle = this._joystickColor;
            $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasContext.lineWidth = 2;
            $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasContext.arc(jp.x, jp.y, this.containerSize, 0, Math.PI * 2, true);
            $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasContext.stroke();
            $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasContext.closePath();
            // inner container
            $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasContext.beginPath();
            $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasContext.lineWidth = 6;
            $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasContext.strokeStyle = this._joystickColor;
            $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasContext.arc(jp.x, jp.y, this.puckSize, 0, Math.PI * 2, true);
            $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasContext.stroke();
            $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasContext.closePath();
        }
    }
    /**
     * Draws the Virtual Joystick's puck
     */ _drawPuck() {
        if (this._puckImage) $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasContext.drawImage(this._puckImage, this._joystickPointerPos.x - this.puckSize, this._joystickPointerPos.y - this.puckSize, this.puckSize * 2, this.puckSize * 2);
        else {
            $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasContext.beginPath();
            $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasContext.strokeStyle = this._joystickColor;
            $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasContext.lineWidth = 2;
            $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasContext.arc(this._joystickPointerPos.x, this._joystickPointerPos.y, this.puckSize, 0, Math.PI * 2, true);
            $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasContext.stroke();
            $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasContext.closePath();
        }
    }
    _drawVirtualJoystick() {
        // canvas released? don't continue iterating
        if (this._released) return;
        if (this.alwaysVisible) this._drawContainer();
        if (this.pressed) this._touches.forEach((key, touch)=>{
            if (touch.pointerId === this._joystickPointerId) {
                if (!this.alwaysVisible) this._drawContainer();
                this._drawPuck();
                // store current pointer for next clear
                this._joystickPreviousPointerPos = this._joystickPointerPos.clone();
            } else {
                $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasContext.clearRect(touch.prevX - 44, touch.prevY - 44, 88, 88);
                $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasContext.beginPath();
                $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasContext.fillStyle = "white";
                $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasContext.beginPath();
                $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasContext.strokeStyle = "red";
                $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasContext.lineWidth = 6;
                $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasContext.arc(touch.x, touch.y, 40, 0, Math.PI * 2, true);
                $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasContext.stroke();
                $434f13cef104f7ce$export$9e3234f70c75e444._VJCanvasContext.closePath();
                touch.prevX = touch.x;
                touch.prevY = touch.y;
            }
        });
        requestAnimationFrame(()=>{
            this._drawVirtualJoystick();
        });
    }
    /**
     * Release internal HTML canvas
     */ releaseCanvas() {
        if ($434f13cef104f7ce$export$9e3234f70c75e444.Canvas) {
            $434f13cef104f7ce$export$9e3234f70c75e444.Canvas.removeEventListener("pointerdown", this._onPointerDownHandlerRef);
            $434f13cef104f7ce$export$9e3234f70c75e444.Canvas.removeEventListener("pointermove", this._onPointerMoveHandlerRef);
            $434f13cef104f7ce$export$9e3234f70c75e444.Canvas.removeEventListener("pointerup", this._onPointerUpHandlerRef);
            $434f13cef104f7ce$export$9e3234f70c75e444.Canvas.removeEventListener("pointerout", this._onPointerUpHandlerRef);
            window.removeEventListener("resize", this._onResize);
            document.body.removeChild($434f13cef104f7ce$export$9e3234f70c75e444.Canvas);
            $434f13cef104f7ce$export$9e3234f70c75e444.Canvas = null;
        }
        this._released = true;
    }
}
// Used to draw the virtual joystick inside a 2D canvas on top of the WebGL rendering canvas
$434f13cef104f7ce$export$9e3234f70c75e444._GlobalJoystickIndex = 0;
$434f13cef104f7ce$export$9e3234f70c75e444._AlwaysVisibleSticks = 0;

});



parcelRegister("fJj0G", function(module, exports) {

$parcel$export(module.exports, "TargetCamera", () => $b739cdf8d675d7c2$export$afbb020f06951903);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $74SKQ = parcelRequire("74SKQ");

var $ha1VO = parcelRequire("ha1VO");

var $53VPf = parcelRequire("53VPf");

var $dbxbu = parcelRequire("dbxbu");

var $bgssx = parcelRequire("bgssx");
(0, $bgssx.Node).AddNodeConstructor("TargetCamera", (name, scene)=>{
    return ()=>new $b739cdf8d675d7c2$export$afbb020f06951903(name, (0, $ha1VO.Vector3).Zero(), scene);
});
class $b739cdf8d675d7c2$export$afbb020f06951903 extends (0, $74SKQ.Camera) {
    /**
     * Instantiates a target camera that takes a mesh or position as a target and continues to look at it while it moves.
     * This is the base of the follow, arc rotate cameras and Free camera
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras
     * @param name Defines the name of the camera in the scene
     * @param position Defines the start position of the camera in the scene
     * @param scene Defines the scene the camera belongs to
     * @param setActiveOnSceneIfNoneActive Defines whether the camera should be marked as active if not other active cameras have been defined
     */ constructor(name, position, scene, setActiveOnSceneIfNoneActive = true){
        super(name, position, scene, setActiveOnSceneIfNoneActive);
        this._tmpUpVector = (0, $ha1VO.Vector3).Zero();
        this._tmpTargetVector = (0, $ha1VO.Vector3).Zero();
        /**
         * Define the current direction the camera is moving to
         */ this.cameraDirection = new (0, $ha1VO.Vector3)(0, 0, 0);
        /**
         * Define the current rotation the camera is rotating to
         */ this.cameraRotation = new (0, $ha1VO.Vector2)(0, 0);
        /** Gets or sets a boolean indicating that the scaling of the parent hierarchy will not be taken in account by the camera */ this.ignoreParentScaling = false;
        /**
         * When set, the up vector of the camera will be updated by the rotation of the camera
         */ this.updateUpVectorFromRotation = false;
        this._tmpQuaternion = new (0, $ha1VO.Quaternion)();
        /**
         * Define the current rotation of the camera
         */ this.rotation = new (0, $ha1VO.Vector3)(0, 0, 0);
        /**
         * Define the current speed of the camera
         */ this.speed = 2.0;
        /**
         * Add constraint to the camera to prevent it to move freely in all directions and
         * around all axis.
         */ this.noRotationConstraint = false;
        /**
         * Reverses mouselook direction to 'natural' panning as opposed to traditional direct
         * panning
         */ this.invertRotation = false;
        /**
         * Speed multiplier for inverse camera panning
         */ this.inverseRotationSpeed = 0.2;
        /**
         * Define the current target of the camera as an object or a position.
         * Please note that locking a target will disable panning.
         */ this.lockedTarget = null;
        /** @internal */ this._currentTarget = (0, $ha1VO.Vector3).Zero();
        /** @internal */ this._initialFocalDistance = 1;
        /** @internal */ this._viewMatrix = (0, $ha1VO.Matrix).Zero();
        /** @internal */ this._camMatrix = (0, $ha1VO.Matrix).Zero();
        /** @internal */ this._cameraTransformMatrix = (0, $ha1VO.Matrix).Zero();
        /** @internal */ this._cameraRotationMatrix = (0, $ha1VO.Matrix).Zero();
        /** @internal */ this._referencePoint = new (0, $ha1VO.Vector3)(0, 0, 1);
        /** @internal */ this._transformedReferencePoint = (0, $ha1VO.Vector3).Zero();
        this._deferredPositionUpdate = new (0, $ha1VO.Vector3)();
        this._deferredRotationQuaternionUpdate = new (0, $ha1VO.Quaternion)();
        this._deferredRotationUpdate = new (0, $ha1VO.Vector3)();
        this._deferredUpdated = false;
        this._deferOnly = false;
        this._defaultUp = (0, $ha1VO.Vector3).Up();
        this._cachedRotationZ = 0;
        this._cachedQuaternionRotationZ = 0;
    }
    /**
     * Gets the position in front of the camera at a given distance.
     * @param distance The distance from the camera we want the position to be
     * @returns the position
     */ getFrontPosition(distance) {
        this.getWorldMatrix();
        const direction = this.getTarget().subtract(this.position);
        direction.normalize();
        direction.scaleInPlace(distance);
        return this.globalPosition.add(direction);
    }
    /** @internal */ _getLockedTargetPosition() {
        if (!this.lockedTarget) return null;
        if (this.lockedTarget.absolutePosition) {
            const lockedTarget = this.lockedTarget;
            const m = lockedTarget.computeWorldMatrix();
            // in some cases the absolute position resets externally, but doesn't update since the matrix is cached.
            m.getTranslationToRef(lockedTarget.absolutePosition);
        }
        return this.lockedTarget.absolutePosition || this.lockedTarget;
    }
    /**
     * Store current camera state of the camera (fov, position, rotation, etc..)
     * @returns the camera
     */ storeState() {
        this._storedPosition = this.position.clone();
        this._storedRotation = this.rotation.clone();
        if (this.rotationQuaternion) this._storedRotationQuaternion = this.rotationQuaternion.clone();
        return super.storeState();
    }
    /**
     * Restored camera state. You must call storeState() first
     * @returns whether it was successful or not
     * @internal
     */ _restoreStateValues() {
        if (!super._restoreStateValues()) return false;
        this.position = this._storedPosition.clone();
        this.rotation = this._storedRotation.clone();
        if (this.rotationQuaternion) this.rotationQuaternion = this._storedRotationQuaternion.clone();
        this.cameraDirection.copyFromFloats(0, 0, 0);
        this.cameraRotation.copyFromFloats(0, 0);
        return true;
    }
    /** @internal */ _initCache() {
        super._initCache();
        this._cache.lockedTarget = new (0, $ha1VO.Vector3)(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
        this._cache.rotation = new (0, $ha1VO.Vector3)(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
        this._cache.rotationQuaternion = new (0, $ha1VO.Quaternion)(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
    }
    /**
     * @internal
     */ _updateCache(ignoreParentClass) {
        if (!ignoreParentClass) super._updateCache();
        const lockedTargetPosition = this._getLockedTargetPosition();
        if (!lockedTargetPosition) this._cache.lockedTarget = null;
        else if (!this._cache.lockedTarget) this._cache.lockedTarget = lockedTargetPosition.clone();
        else this._cache.lockedTarget.copyFrom(lockedTargetPosition);
        this._cache.rotation.copyFrom(this.rotation);
        if (this.rotationQuaternion) this._cache.rotationQuaternion.copyFrom(this.rotationQuaternion);
    }
    // Synchronized
    /** @internal */ _isSynchronizedViewMatrix() {
        if (!super._isSynchronizedViewMatrix()) return false;
        const lockedTargetPosition = this._getLockedTargetPosition();
        return (this._cache.lockedTarget ? this._cache.lockedTarget.equals(lockedTargetPosition) : !lockedTargetPosition) && (this.rotationQuaternion ? this.rotationQuaternion.equals(this._cache.rotationQuaternion) : this._cache.rotation.equals(this.rotation));
    }
    // Methods
    /** @internal */ _computeLocalCameraSpeed() {
        const engine = this.getEngine();
        return this.speed * Math.sqrt(engine.getDeltaTime() / (engine.getFps() * 100.0));
    }
    // Target
    /**
     * Defines the target the camera should look at.
     * @param target Defines the new target as a Vector
     */ setTarget(target) {
        this.upVector.normalize();
        this._initialFocalDistance = target.subtract(this.position).length();
        if (this.position.z === target.z) this.position.z += (0, $53VPf.Epsilon);
        this._referencePoint.normalize().scaleInPlace(this._initialFocalDistance);
        (0, $ha1VO.Matrix).LookAtLHToRef(this.position, target, this._defaultUp, this._camMatrix);
        this._camMatrix.invert();
        this.rotation.x = Math.atan(this._camMatrix.m[6] / this._camMatrix.m[10]);
        const vDir = target.subtract(this.position);
        if (vDir.x >= 0.0) this.rotation.y = -Math.atan(vDir.z / vDir.x) + Math.PI / 2.0;
        else this.rotation.y = -Math.atan(vDir.z / vDir.x) - Math.PI / 2.0;
        this.rotation.z = 0;
        if (isNaN(this.rotation.x)) this.rotation.x = 0;
        if (isNaN(this.rotation.y)) this.rotation.y = 0;
        if (isNaN(this.rotation.z)) this.rotation.z = 0;
        if (this.rotationQuaternion) (0, $ha1VO.Quaternion).RotationYawPitchRollToRef(this.rotation.y, this.rotation.x, this.rotation.z, this.rotationQuaternion);
    }
    /**
     * Defines the target point of the camera.
     * The camera looks towards it form the radius distance.
     */ get target() {
        return this.getTarget();
    }
    set target(value) {
        this.setTarget(value);
    }
    /**
     * Return the current target position of the camera. This value is expressed in local space.
     * @returns the target position
     */ getTarget() {
        return this._currentTarget;
    }
    /** @internal */ _decideIfNeedsToMove() {
        return Math.abs(this.cameraDirection.x) > 0 || Math.abs(this.cameraDirection.y) > 0 || Math.abs(this.cameraDirection.z) > 0;
    }
    /** @internal */ _updatePosition() {
        if (this.parent) {
            this.parent.getWorldMatrix().invertToRef((0, $ha1VO.TmpVectors).Matrix[0]);
            (0, $ha1VO.Vector3).TransformNormalToRef(this.cameraDirection, (0, $ha1VO.TmpVectors).Matrix[0], (0, $ha1VO.TmpVectors).Vector3[0]);
            this._deferredPositionUpdate.addInPlace((0, $ha1VO.TmpVectors).Vector3[0]);
            if (!this._deferOnly) this.position.copyFrom(this._deferredPositionUpdate);
            else this._deferredUpdated = true;
            return;
        }
        this._deferredPositionUpdate.addInPlace(this.cameraDirection);
        if (!this._deferOnly) this.position.copyFrom(this._deferredPositionUpdate);
        else this._deferredUpdated = true;
    }
    /** @internal */ _checkInputs() {
        const directionMultiplier = this.invertRotation ? -this.inverseRotationSpeed : 1.0;
        const needToMove = this._decideIfNeedsToMove();
        const needToRotate = this.cameraRotation.x || this.cameraRotation.y;
        this._deferredUpdated = false;
        this._deferredRotationUpdate.copyFrom(this.rotation);
        this._deferredPositionUpdate.copyFrom(this.position);
        if (this.rotationQuaternion) this._deferredRotationQuaternionUpdate.copyFrom(this.rotationQuaternion);
        // Move
        if (needToMove) this._updatePosition();
        // Rotate
        if (needToRotate) {
            //rotate, if quaternion is set and rotation was used
            if (this.rotationQuaternion) this.rotationQuaternion.toEulerAnglesToRef(this._deferredRotationUpdate);
            this._deferredRotationUpdate.x += this.cameraRotation.x * directionMultiplier;
            this._deferredRotationUpdate.y += this.cameraRotation.y * directionMultiplier;
            // Apply constraints
            if (!this.noRotationConstraint) {
                const limit = 1.570796;
                if (this._deferredRotationUpdate.x > limit) this._deferredRotationUpdate.x = limit;
                if (this._deferredRotationUpdate.x < -limit) this._deferredRotationUpdate.x = -limit;
            }
            if (!this._deferOnly) this.rotation.copyFrom(this._deferredRotationUpdate);
            else this._deferredUpdated = true;
            //rotate, if quaternion is set and rotation was used
            if (this.rotationQuaternion) {
                const len = this._deferredRotationUpdate.lengthSquared();
                if (len) {
                    (0, $ha1VO.Quaternion).RotationYawPitchRollToRef(this._deferredRotationUpdate.y, this._deferredRotationUpdate.x, this._deferredRotationUpdate.z, this._deferredRotationQuaternionUpdate);
                    if (!this._deferOnly) this.rotationQuaternion.copyFrom(this._deferredRotationQuaternionUpdate);
                    else this._deferredUpdated = true;
                }
            }
        }
        // Inertia
        if (needToMove) {
            if (Math.abs(this.cameraDirection.x) < this.speed * (0, $53VPf.Epsilon)) this.cameraDirection.x = 0;
            if (Math.abs(this.cameraDirection.y) < this.speed * (0, $53VPf.Epsilon)) this.cameraDirection.y = 0;
            if (Math.abs(this.cameraDirection.z) < this.speed * (0, $53VPf.Epsilon)) this.cameraDirection.z = 0;
            this.cameraDirection.scaleInPlace(this.inertia);
        }
        if (needToRotate) {
            if (Math.abs(this.cameraRotation.x) < this.speed * (0, $53VPf.Epsilon)) this.cameraRotation.x = 0;
            if (Math.abs(this.cameraRotation.y) < this.speed * (0, $53VPf.Epsilon)) this.cameraRotation.y = 0;
            this.cameraRotation.scaleInPlace(this.inertia);
        }
        super._checkInputs();
    }
    _updateCameraRotationMatrix() {
        if (this.rotationQuaternion) this.rotationQuaternion.toRotationMatrix(this._cameraRotationMatrix);
        else (0, $ha1VO.Matrix).RotationYawPitchRollToRef(this.rotation.y, this.rotation.x, this.rotation.z, this._cameraRotationMatrix);
    }
    /**
     * Update the up vector to apply the rotation of the camera (So if you changed the camera rotation.z this will let you update the up vector as well)
     * @returns the current camera
     */ _rotateUpVectorWithCameraRotationMatrix() {
        (0, $ha1VO.Vector3).TransformNormalToRef(this._defaultUp, this._cameraRotationMatrix, this.upVector);
        return this;
    }
    /** @internal */ _getViewMatrix() {
        if (this.lockedTarget) this.setTarget(this._getLockedTargetPosition());
        // Compute
        this._updateCameraRotationMatrix();
        // Apply the changed rotation to the upVector
        if (this.rotationQuaternion && this._cachedQuaternionRotationZ != this.rotationQuaternion.z) {
            this._rotateUpVectorWithCameraRotationMatrix();
            this._cachedQuaternionRotationZ = this.rotationQuaternion.z;
        } else if (this._cachedRotationZ !== this.rotation.z) {
            this._rotateUpVectorWithCameraRotationMatrix();
            this._cachedRotationZ = this.rotation.z;
        }
        (0, $ha1VO.Vector3).TransformCoordinatesToRef(this._referencePoint, this._cameraRotationMatrix, this._transformedReferencePoint);
        // Computing target and final matrix
        this.position.addToRef(this._transformedReferencePoint, this._currentTarget);
        if (this.updateUpVectorFromRotation) {
            if (this.rotationQuaternion) (0, $dbxbu.Axis).Y.rotateByQuaternionToRef(this.rotationQuaternion, this.upVector);
            else {
                (0, $ha1VO.Quaternion).FromEulerVectorToRef(this.rotation, this._tmpQuaternion);
                (0, $dbxbu.Axis).Y.rotateByQuaternionToRef(this._tmpQuaternion, this.upVector);
            }
        }
        this._computeViewMatrix(this.position, this._currentTarget, this.upVector);
        return this._viewMatrix;
    }
    _computeViewMatrix(position, target, up) {
        if (this.ignoreParentScaling) {
            if (this.parent) {
                const parentWorldMatrix = this.parent.getWorldMatrix();
                (0, $ha1VO.Vector3).TransformCoordinatesToRef(position, parentWorldMatrix, this._globalPosition);
                (0, $ha1VO.Vector3).TransformCoordinatesToRef(target, parentWorldMatrix, this._tmpTargetVector);
                (0, $ha1VO.Vector3).TransformNormalToRef(up, parentWorldMatrix, this._tmpUpVector);
                this._markSyncedWithParent();
            } else {
                this._globalPosition.copyFrom(position);
                this._tmpTargetVector.copyFrom(target);
                this._tmpUpVector.copyFrom(up);
            }
            if (this.getScene().useRightHandedSystem) (0, $ha1VO.Matrix).LookAtRHToRef(this._globalPosition, this._tmpTargetVector, this._tmpUpVector, this._viewMatrix);
            else (0, $ha1VO.Matrix).LookAtLHToRef(this._globalPosition, this._tmpTargetVector, this._tmpUpVector, this._viewMatrix);
            return;
        }
        if (this.getScene().useRightHandedSystem) (0, $ha1VO.Matrix).LookAtRHToRef(position, target, up, this._viewMatrix);
        else (0, $ha1VO.Matrix).LookAtLHToRef(position, target, up, this._viewMatrix);
        if (this.parent) {
            const parentWorldMatrix = this.parent.getWorldMatrix();
            this._viewMatrix.invert();
            this._viewMatrix.multiplyToRef(parentWorldMatrix, this._viewMatrix);
            this._viewMatrix.getTranslationToRef(this._globalPosition);
            this._viewMatrix.invert();
            this._markSyncedWithParent();
        } else this._globalPosition.copyFrom(position);
    }
    /**
     * @internal
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    createRigCamera(name, cameraIndex) {
        if (this.cameraRigMode !== (0, $74SKQ.Camera).RIG_MODE_NONE) {
            const rigCamera = new $b739cdf8d675d7c2$export$afbb020f06951903(name, this.position.clone(), this.getScene());
            rigCamera.isRigCamera = true;
            rigCamera.rigParent = this;
            if (this.cameraRigMode === (0, $74SKQ.Camera).RIG_MODE_VR) {
                if (!this.rotationQuaternion) this.rotationQuaternion = new (0, $ha1VO.Quaternion)();
                rigCamera._cameraRigParams = {};
                rigCamera.rotationQuaternion = new (0, $ha1VO.Quaternion)();
            }
            rigCamera.mode = this.mode;
            rigCamera.orthoLeft = this.orthoLeft;
            rigCamera.orthoRight = this.orthoRight;
            rigCamera.orthoTop = this.orthoTop;
            rigCamera.orthoBottom = this.orthoBottom;
            return rigCamera;
        }
        return null;
    }
    /**
     * @internal
     */ _updateRigCameras() {
        const camLeft = this._rigCameras[0];
        const camRight = this._rigCameras[1];
        this.computeWorldMatrix();
        switch(this.cameraRigMode){
            case (0, $74SKQ.Camera).RIG_MODE_STEREOSCOPIC_ANAGLYPH:
            case (0, $74SKQ.Camera).RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_PARALLEL:
            case (0, $74SKQ.Camera).RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_CROSSEYED:
            case (0, $74SKQ.Camera).RIG_MODE_STEREOSCOPIC_OVERUNDER:
            case (0, $74SKQ.Camera).RIG_MODE_STEREOSCOPIC_INTERLACED:
                {
                    //provisionnaly using _cameraRigParams.stereoHalfAngle instead of calculations based on _cameraRigParams.interaxialDistance:
                    const leftSign = this.cameraRigMode === (0, $74SKQ.Camera).RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_CROSSEYED ? 1 : -1;
                    const rightSign = this.cameraRigMode === (0, $74SKQ.Camera).RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_CROSSEYED ? -1 : 1;
                    this._getRigCamPositionAndTarget(this._cameraRigParams.stereoHalfAngle * leftSign, camLeft);
                    this._getRigCamPositionAndTarget(this._cameraRigParams.stereoHalfAngle * rightSign, camRight);
                    break;
                }
            case (0, $74SKQ.Camera).RIG_MODE_VR:
                if (camLeft.rotationQuaternion) {
                    camLeft.rotationQuaternion.copyFrom(this.rotationQuaternion);
                    camRight.rotationQuaternion.copyFrom(this.rotationQuaternion);
                } else {
                    camLeft.rotation.copyFrom(this.rotation);
                    camRight.rotation.copyFrom(this.rotation);
                }
                camLeft.position.copyFrom(this.position);
                camRight.position.copyFrom(this.position);
                break;
        }
        super._updateRigCameras();
    }
    _getRigCamPositionAndTarget(halfSpace, rigCamera) {
        const target = this.getTarget();
        target.subtractToRef(this.position, $b739cdf8d675d7c2$export$afbb020f06951903._TargetFocalPoint);
        $b739cdf8d675d7c2$export$afbb020f06951903._TargetFocalPoint.normalize().scaleInPlace(this._initialFocalDistance);
        const newFocalTarget = $b739cdf8d675d7c2$export$afbb020f06951903._TargetFocalPoint.addInPlace(this.position);
        (0, $ha1VO.Matrix).TranslationToRef(-newFocalTarget.x, -newFocalTarget.y, -newFocalTarget.z, $b739cdf8d675d7c2$export$afbb020f06951903._TargetTransformMatrix);
        $b739cdf8d675d7c2$export$afbb020f06951903._TargetTransformMatrix.multiplyToRef((0, $ha1VO.Matrix).RotationAxis(rigCamera.upVector, halfSpace), $b739cdf8d675d7c2$export$afbb020f06951903._RigCamTransformMatrix);
        (0, $ha1VO.Matrix).TranslationToRef(newFocalTarget.x, newFocalTarget.y, newFocalTarget.z, $b739cdf8d675d7c2$export$afbb020f06951903._TargetTransformMatrix);
        $b739cdf8d675d7c2$export$afbb020f06951903._RigCamTransformMatrix.multiplyToRef($b739cdf8d675d7c2$export$afbb020f06951903._TargetTransformMatrix, $b739cdf8d675d7c2$export$afbb020f06951903._RigCamTransformMatrix);
        (0, $ha1VO.Vector3).TransformCoordinatesToRef(this.position, $b739cdf8d675d7c2$export$afbb020f06951903._RigCamTransformMatrix, rigCamera.position);
        rigCamera.setTarget(newFocalTarget);
    }
    /**
     * Gets the current object class name.
     * @returns the class name
     */ getClassName() {
        return "TargetCamera";
    }
}
$b739cdf8d675d7c2$export$afbb020f06951903._RigCamTransformMatrix = new (0, $ha1VO.Matrix)();
$b739cdf8d675d7c2$export$afbb020f06951903._TargetTransformMatrix = new (0, $ha1VO.Matrix)();
$b739cdf8d675d7c2$export$afbb020f06951903._TargetFocalPoint = new (0, $ha1VO.Vector3)();
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsVector3)()
], $b739cdf8d675d7c2$export$afbb020f06951903.prototype, "rotation", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b739cdf8d675d7c2$export$afbb020f06951903.prototype, "speed", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsMeshReference)("lockedTargetId")
], $b739cdf8d675d7c2$export$afbb020f06951903.prototype, "lockedTarget", void 0);

});

parcelRegister("gSOV5", function(module, exports) {

$parcel$export(module.exports, "FreeCamera", () => $c4a930146473c331$export$14302a6d2c2d8b66);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $ha1VO = parcelRequire("ha1VO");

var $5YkyR = parcelRequire("5YkyR");

var $fJj0G = parcelRequire("fJj0G");

var $8TToC = parcelRequire("8TToC");

var $bOhSV = parcelRequire("bOhSV");
class $c4a930146473c331$export$14302a6d2c2d8b66 extends (0, $fJj0G.TargetCamera) {
    /**
     * Gets the input sensibility for a mouse input. (default is 2000.0)
     * Higher values reduce sensitivity.
     */ get angularSensibility() {
        const mouse = this.inputs.attached["mouse"];
        if (mouse) return mouse.angularSensibility;
        return 0;
    }
    /**
     * Sets the input sensibility for a mouse input. (default is 2000.0)
     * Higher values reduce sensitivity.
     */ set angularSensibility(value) {
        const mouse = this.inputs.attached["mouse"];
        if (mouse) mouse.angularSensibility = value;
    }
    /**
     * Gets or Set the list of keyboard keys used to control the forward move of the camera.
     */ get keysUp() {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) return keyboard.keysUp;
        return [];
    }
    set keysUp(value) {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) keyboard.keysUp = value;
    }
    /**
     * Gets or Set the list of keyboard keys used to control the upward move of the camera.
     */ get keysUpward() {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) return keyboard.keysUpward;
        return [];
    }
    set keysUpward(value) {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) keyboard.keysUpward = value;
    }
    /**
     * Gets or Set the list of keyboard keys used to control the backward move of the camera.
     */ get keysDown() {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) return keyboard.keysDown;
        return [];
    }
    set keysDown(value) {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) keyboard.keysDown = value;
    }
    /**
     * Gets or Set the list of keyboard keys used to control the downward move of the camera.
     */ get keysDownward() {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) return keyboard.keysDownward;
        return [];
    }
    set keysDownward(value) {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) keyboard.keysDownward = value;
    }
    /**
     * Gets or Set the list of keyboard keys used to control the left strafe move of the camera.
     */ get keysLeft() {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) return keyboard.keysLeft;
        return [];
    }
    set keysLeft(value) {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) keyboard.keysLeft = value;
    }
    /**
     * Gets or Set the list of keyboard keys used to control the right strafe move of the camera.
     */ get keysRight() {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) return keyboard.keysRight;
        return [];
    }
    set keysRight(value) {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) keyboard.keysRight = value;
    }
    /**
     * Gets or Set the list of keyboard keys used to control the left rotation move of the camera.
     */ get keysRotateLeft() {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) return keyboard.keysRotateLeft;
        return [];
    }
    set keysRotateLeft(value) {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) keyboard.keysRotateLeft = value;
    }
    /**
     * Gets or Set the list of keyboard keys used to control the right rotation move of the camera.
     */ get keysRotateRight() {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) return keyboard.keysRotateRight;
        return [];
    }
    set keysRotateRight(value) {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) keyboard.keysRotateRight = value;
    }
    /**
     * Gets or Set the list of keyboard keys used to control the up rotation move of the camera.
     */ get keysRotateUp() {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) return keyboard.keysRotateUp;
        return [];
    }
    set keysRotateUp(value) {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) keyboard.keysRotateUp = value;
    }
    /**
     * Gets or Set the list of keyboard keys used to control the down rotation move of the camera.
     */ get keysRotateDown() {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) return keyboard.keysRotateDown;
        return [];
    }
    set keysRotateDown(value) {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) keyboard.keysRotateDown = value;
    }
    /**
     * Instantiates a Free Camera.
     * This represents a free type of camera. It can be useful in First Person Shooter game for instance.
     * Please consider using the new UniversalCamera instead as it adds more functionality like touch to this camera.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_introduction#universal-camera
     * @param name Define the name of the camera in the scene
     * @param position Define the start position of the camera in the scene
     * @param scene Define the scene the camera belongs to
     * @param setActiveOnSceneIfNoneActive Defines whether the camera should be marked as active if not other active cameras have been defined
     */ constructor(name, position, scene, setActiveOnSceneIfNoneActive = true){
        super(name, position, scene, setActiveOnSceneIfNoneActive);
        /**
         * Define the collision ellipsoid of the camera.
         * This is helpful to simulate a camera body like the player body around the camera
         * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_collisions#arcrotatecamera
         */ this.ellipsoid = new (0, $ha1VO.Vector3)(0.5, 1, 0.5);
        /**
         * Define an offset for the position of the ellipsoid around the camera.
         * This can be helpful to determine the center of the body near the gravity center of the body
         * instead of its head.
         */ this.ellipsoidOffset = new (0, $ha1VO.Vector3)(0, 0, 0);
        /**
         * Enable or disable collisions of the camera with the rest of the scene objects.
         */ this.checkCollisions = false;
        /**
         * Enable or disable gravity on the camera.
         */ this.applyGravity = false;
        this._needMoveForGravity = false;
        this._oldPosition = (0, $ha1VO.Vector3).Zero();
        this._diffPosition = (0, $ha1VO.Vector3).Zero();
        this._newPosition = (0, $ha1VO.Vector3).Zero();
        // Collisions
        this._collisionMask = -1;
        this._onCollisionPositionChange = (collisionId, newPosition, collidedMesh = null)=>{
            this._newPosition.copyFrom(newPosition);
            this._newPosition.subtractToRef(this._oldPosition, this._diffPosition);
            if (this._diffPosition.length() > (0, $5YkyR.Engine).CollisionsEpsilon) {
                this.position.addToRef(this._diffPosition, this._deferredPositionUpdate);
                if (!this._deferOnly) this.position.copyFrom(this._deferredPositionUpdate);
                else this._deferredUpdated = true;
                // call onCollide, if defined. Note that in case of deferred update, the actual position change might happen in the next frame.
                if (this.onCollide && collidedMesh) this.onCollide(collidedMesh);
            }
        };
        this.inputs = new (0, $8TToC.FreeCameraInputsManager)(this);
        this.inputs.addKeyboard().addMouse();
    }
    /**
     * Attached controls to the current camera.
     * @param ignored defines an ignored parameter kept for backward compatibility.
     * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
     */ attachControl(ignored, noPreventDefault) {
        // eslint-disable-next-line prefer-rest-params
        noPreventDefault = (0, $bOhSV.Tools).BackCompatCameraNoPreventDefault(arguments);
        this.inputs.attachElement(noPreventDefault);
    }
    /**
     * Detach the current controls from the specified dom element.
     */ detachControl() {
        this.inputs.detachElement();
        this.cameraDirection = new (0, $ha1VO.Vector3)(0, 0, 0);
        this.cameraRotation = new (0, $ha1VO.Vector2)(0, 0);
    }
    /**
     * Define a collision mask to limit the list of object the camera can collide with
     */ get collisionMask() {
        return this._collisionMask;
    }
    set collisionMask(mask) {
        this._collisionMask = !isNaN(mask) ? mask : -1;
    }
    /**
     * @internal
     */ _collideWithWorld(displacement) {
        let globalPosition;
        if (this.parent) globalPosition = (0, $ha1VO.Vector3).TransformCoordinates(this.position, this.parent.getWorldMatrix());
        else globalPosition = this.position;
        globalPosition.subtractFromFloatsToRef(0, this.ellipsoid.y, 0, this._oldPosition);
        this._oldPosition.addInPlace(this.ellipsoidOffset);
        const coordinator = this.getScene().collisionCoordinator;
        if (!this._collider) this._collider = coordinator.createCollider();
        this._collider._radius = this.ellipsoid;
        this._collider.collisionMask = this._collisionMask;
        //no need for clone, as long as gravity is not on.
        let actualDisplacement = displacement;
        //add gravity to the direction to prevent the dual-collision checking
        if (this.applyGravity) //this prevents mending with cameraDirection, a global variable of the free camera class.
        actualDisplacement = displacement.add(this.getScene().gravity);
        coordinator.getNewPosition(this._oldPosition, actualDisplacement, this._collider, 3, null, this._onCollisionPositionChange, this.uniqueId);
    }
    /** @internal */ _checkInputs() {
        if (!this._localDirection) {
            this._localDirection = (0, $ha1VO.Vector3).Zero();
            this._transformedDirection = (0, $ha1VO.Vector3).Zero();
        }
        this.inputs.checkInputs();
        super._checkInputs();
    }
    /**
     * Enable movement without a user input. This allows gravity to always be applied.
     */ set needMoveForGravity(value) {
        this._needMoveForGravity = value;
    }
    /**
     * When true, gravity is applied whether there is user input or not.
     */ get needMoveForGravity() {
        return this._needMoveForGravity;
    }
    /** @internal */ _decideIfNeedsToMove() {
        return this._needMoveForGravity || Math.abs(this.cameraDirection.x) > 0 || Math.abs(this.cameraDirection.y) > 0 || Math.abs(this.cameraDirection.z) > 0;
    }
    /** @internal */ _updatePosition() {
        if (this.checkCollisions && this.getScene().collisionsEnabled) this._collideWithWorld(this.cameraDirection);
        else super._updatePosition();
    }
    /**
     * Destroy the camera and release the current resources hold by it.
     */ dispose() {
        this.inputs.clear();
        super.dispose();
    }
    /**
     * Gets the current object class name.
     * @returns the class name
     */ getClassName() {
        return "FreeCamera";
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsVector3)()
], $c4a930146473c331$export$14302a6d2c2d8b66.prototype, "ellipsoid", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsVector3)()
], $c4a930146473c331$export$14302a6d2c2d8b66.prototype, "ellipsoidOffset", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $c4a930146473c331$export$14302a6d2c2d8b66.prototype, "checkCollisions", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $c4a930146473c331$export$14302a6d2c2d8b66.prototype, "applyGravity", void 0);

});

parcelRegister("8i1MZ", function(module, exports) {

$parcel$export(module.exports, "TouchCamera", () => $609164748b445ce2$export$ad83d8f4f89ba36b);

var $gSOV5 = parcelRequire("gSOV5");

var $ha1VO = parcelRequire("ha1VO");

var $bgssx = parcelRequire("bgssx");
(0, $bgssx.Node).AddNodeConstructor("TouchCamera", (name, scene)=>{
    return ()=>new $609164748b445ce2$export$ad83d8f4f89ba36b(name, (0, $ha1VO.Vector3).Zero(), scene);
});
class $609164748b445ce2$export$ad83d8f4f89ba36b extends (0, $gSOV5.FreeCamera) {
    /**
     * Defines the touch sensibility for rotation.
     * The higher the faster.
     */ get touchAngularSensibility() {
        const touch = this.inputs.attached["touch"];
        if (touch) return touch.touchAngularSensibility;
        return 0;
    }
    set touchAngularSensibility(value) {
        const touch = this.inputs.attached["touch"];
        if (touch) touch.touchAngularSensibility = value;
    }
    /**
     * Defines the touch sensibility for move.
     * The higher the faster.
     */ get touchMoveSensibility() {
        const touch = this.inputs.attached["touch"];
        if (touch) return touch.touchMoveSensibility;
        return 0;
    }
    set touchMoveSensibility(value) {
        const touch = this.inputs.attached["touch"];
        if (touch) touch.touchMoveSensibility = value;
    }
    /**
     * Instantiates a new touch camera.
     * This represents a FPS type of camera controlled by touch.
     * This is like a universal camera minus the Gamepad controls.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_introduction#universal-camera
     * @param name Define the name of the camera in the scene
     * @param position Define the start position of the camera in the scene
     * @param scene Define the scene the camera belongs to
     */ constructor(name, position, scene){
        super(name, position, scene);
        this.inputs.addTouch();
        this._setupInputs();
    }
    /**
     * Gets the current object class name.
     * @returns the class name
     */ getClassName() {
        return "TouchCamera";
    }
    /** @internal */ _setupInputs() {
        const touch = this.inputs.attached["touch"];
        const mouse = this.inputs.attached["mouse"];
        if (mouse) mouse.touchEnabled = false;
        else touch.allowMouse = true;
    }
}

});

parcelRegister("jIhlp", function(module, exports) {

$parcel$export(module.exports, "ArcRotateCamera", () => $e59f949a590d8aa8$export$8438041bb8e406c8);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $bgssx = parcelRequire("bgssx");

var $fbuqw = parcelRequire("fbuqw");

var $7gmZD = parcelRequire("7gmZD");

var $b01pG = parcelRequire("b01pG");

var $jM85r = parcelRequire("jM85r");

var $74SKQ = parcelRequire("74SKQ");

var $fJj0G = parcelRequire("fJj0G");

var $gotsS = parcelRequire("gotsS");

var $53VPf = parcelRequire("53VPf");

var $bOhSV = parcelRequire("bOhSV");
(0, $bgssx.Node).AddNodeConstructor("ArcRotateCamera", (name, scene)=>{
    return ()=>new $e59f949a590d8aa8$export$8438041bb8e406c8(name, 0, 0, 1.0, (0, $ha1VO.Vector3).Zero(), scene);
});
class $e59f949a590d8aa8$export$8438041bb8e406c8 extends (0, $fJj0G.TargetCamera) {
    /**
     * Defines the target point of the camera.
     * The camera looks towards it from the radius distance.
     */ get target() {
        return this._target;
    }
    set target(value) {
        this.setTarget(value);
    }
    /**
     * Defines the target transform node of the camera.
     * The camera looks towards it from the radius distance.
     * Please note that setting a target host will disable panning.
     */ get targetHost() {
        return this._targetHost;
    }
    set targetHost(value) {
        if (value) this.setTarget(value);
    }
    /**
     * Return the current target position of the camera. This value is expressed in local space.
     * @returns the target position
     */ getTarget() {
        return this.target;
    }
    /**
     * Define the current local position of the camera in the scene
     */ get position() {
        return this._position;
    }
    set position(newPosition) {
        this.setPosition(newPosition);
    }
    /**
     * The vector the camera should consider as up. (default is Vector3(0, 1, 0) as returned by Vector3.Up())
     * Setting this will copy the given vector to the camera's upVector, and set rotation matrices to and from Y up.
     * DO NOT set the up vector using copyFrom or copyFromFloats, as this bypasses setting the above matrices.
     */ set upVector(vec) {
        if (!this._upToYMatrix) {
            this._yToUpMatrix = new (0, $ha1VO.Matrix)();
            this._upToYMatrix = new (0, $ha1VO.Matrix)();
            this._upVector = (0, $ha1VO.Vector3).Zero();
        }
        vec.normalize();
        this._upVector.copyFrom(vec);
        this.setMatUp();
    }
    get upVector() {
        return this._upVector;
    }
    /**
     * Sets the Y-up to camera up-vector rotation matrix, and the up-vector to Y-up rotation matrix.
     */ setMatUp() {
        // from y-up to custom-up (used in _getViewMatrix)
        (0, $ha1VO.Matrix).RotationAlignToRef((0, $ha1VO.Vector3).UpReadOnly, this._upVector, this._yToUpMatrix);
        // from custom-up to y-up (used in rebuildAnglesAndRadius)
        (0, $ha1VO.Matrix).RotationAlignToRef(this._upVector, (0, $ha1VO.Vector3).UpReadOnly, this._upToYMatrix);
    }
    //-- begin properties for backward compatibility for inputs
    /**
     * Gets or Set the pointer angular sensibility  along the X axis or how fast is the camera rotating.
     */ get angularSensibilityX() {
        const pointers = this.inputs.attached["pointers"];
        if (pointers) return pointers.angularSensibilityX;
        return 0;
    }
    set angularSensibilityX(value) {
        const pointers = this.inputs.attached["pointers"];
        if (pointers) pointers.angularSensibilityX = value;
    }
    /**
     * Gets or Set the pointer angular sensibility along the Y axis or how fast is the camera rotating.
     */ get angularSensibilityY() {
        const pointers = this.inputs.attached["pointers"];
        if (pointers) return pointers.angularSensibilityY;
        return 0;
    }
    set angularSensibilityY(value) {
        const pointers = this.inputs.attached["pointers"];
        if (pointers) pointers.angularSensibilityY = value;
    }
    /**
     * Gets or Set the pointer pinch precision or how fast is the camera zooming.
     */ get pinchPrecision() {
        const pointers = this.inputs.attached["pointers"];
        if (pointers) return pointers.pinchPrecision;
        return 0;
    }
    set pinchPrecision(value) {
        const pointers = this.inputs.attached["pointers"];
        if (pointers) pointers.pinchPrecision = value;
    }
    /**
     * Gets or Set the pointer pinch delta percentage or how fast is the camera zooming.
     * It will be used instead of pinchPrecision if different from 0.
     * It defines the percentage of current camera.radius to use as delta when pinch zoom is used.
     */ get pinchDeltaPercentage() {
        const pointers = this.inputs.attached["pointers"];
        if (pointers) return pointers.pinchDeltaPercentage;
        return 0;
    }
    set pinchDeltaPercentage(value) {
        const pointers = this.inputs.attached["pointers"];
        if (pointers) pointers.pinchDeltaPercentage = value;
    }
    /**
     * Gets or Set the pointer use natural pinch zoom to override the pinch precision
     * and pinch delta percentage.
     * When useNaturalPinchZoom is true, multi touch zoom will zoom in such
     * that any object in the plane at the camera's target point will scale
     * perfectly with finger motion.
     */ get useNaturalPinchZoom() {
        const pointers = this.inputs.attached["pointers"];
        if (pointers) return pointers.useNaturalPinchZoom;
        return false;
    }
    set useNaturalPinchZoom(value) {
        const pointers = this.inputs.attached["pointers"];
        if (pointers) pointers.useNaturalPinchZoom = value;
    }
    /**
     * Gets or Set the pointer panning sensibility or how fast is the camera moving.
     */ get panningSensibility() {
        const pointers = this.inputs.attached["pointers"];
        if (pointers) return pointers.panningSensibility;
        return 0;
    }
    set panningSensibility(value) {
        const pointers = this.inputs.attached["pointers"];
        if (pointers) pointers.panningSensibility = value;
    }
    /**
     * Gets or Set the list of keyboard keys used to control beta angle in a positive direction.
     */ get keysUp() {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) return keyboard.keysUp;
        return [];
    }
    set keysUp(value) {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) keyboard.keysUp = value;
    }
    /**
     * Gets or Set the list of keyboard keys used to control beta angle in a negative direction.
     */ get keysDown() {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) return keyboard.keysDown;
        return [];
    }
    set keysDown(value) {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) keyboard.keysDown = value;
    }
    /**
     * Gets or Set the list of keyboard keys used to control alpha angle in a negative direction.
     */ get keysLeft() {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) return keyboard.keysLeft;
        return [];
    }
    set keysLeft(value) {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) keyboard.keysLeft = value;
    }
    /**
     * Gets or Set the list of keyboard keys used to control alpha angle in a positive direction.
     */ get keysRight() {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) return keyboard.keysRight;
        return [];
    }
    set keysRight(value) {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) keyboard.keysRight = value;
    }
    /**
     * Gets or Set the mouse wheel precision or how fast is the camera zooming.
     */ get wheelPrecision() {
        const mousewheel = this.inputs.attached["mousewheel"];
        if (mousewheel) return mousewheel.wheelPrecision;
        return 0;
    }
    set wheelPrecision(value) {
        const mousewheel = this.inputs.attached["mousewheel"];
        if (mousewheel) mousewheel.wheelPrecision = value;
    }
    /**
     * Gets or Set the boolean value that controls whether or not the mouse wheel
     * zooms to the location of the mouse pointer or not.  The default is false.
     */ get zoomToMouseLocation() {
        const mousewheel = this.inputs.attached["mousewheel"];
        if (mousewheel) return mousewheel.zoomToMouseLocation;
        return false;
    }
    set zoomToMouseLocation(value) {
        const mousewheel = this.inputs.attached["mousewheel"];
        if (mousewheel) mousewheel.zoomToMouseLocation = value;
    }
    /**
     * Gets or Set the mouse wheel delta percentage or how fast is the camera zooming.
     * It will be used instead of wheelPrecision if different from 0.
     * It defines the percentage of current camera.radius to use as delta when wheel zoom is used.
     */ get wheelDeltaPercentage() {
        const mousewheel = this.inputs.attached["mousewheel"];
        if (mousewheel) return mousewheel.wheelDeltaPercentage;
        return 0;
    }
    set wheelDeltaPercentage(value) {
        const mousewheel = this.inputs.attached["mousewheel"];
        if (mousewheel) mousewheel.wheelDeltaPercentage = value;
    }
    /**
     * Gets the bouncing behavior of the camera if it has been enabled.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors/cameraBehaviors#bouncing-behavior
     */ get bouncingBehavior() {
        return this._bouncingBehavior;
    }
    /**
     * Defines if the bouncing behavior of the camera is enabled on the camera.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors/cameraBehaviors#bouncing-behavior
     */ get useBouncingBehavior() {
        return this._bouncingBehavior != null;
    }
    set useBouncingBehavior(value) {
        if (value === this.useBouncingBehavior) return;
        if (value) {
            this._bouncingBehavior = new (0, $b01pG.BouncingBehavior)();
            this.addBehavior(this._bouncingBehavior);
        } else if (this._bouncingBehavior) {
            this.removeBehavior(this._bouncingBehavior);
            this._bouncingBehavior = null;
        }
    }
    /**
     * Gets the framing behavior of the camera if it has been enabled.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors/cameraBehaviors#framing-behavior
     */ get framingBehavior() {
        return this._framingBehavior;
    }
    /**
     * Defines if the framing behavior of the camera is enabled on the camera.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors/cameraBehaviors#framing-behavior
     */ get useFramingBehavior() {
        return this._framingBehavior != null;
    }
    set useFramingBehavior(value) {
        if (value === this.useFramingBehavior) return;
        if (value) {
            this._framingBehavior = new (0, $jM85r.FramingBehavior)();
            this.addBehavior(this._framingBehavior);
        } else if (this._framingBehavior) {
            this.removeBehavior(this._framingBehavior);
            this._framingBehavior = null;
        }
    }
    /**
     * Gets the auto rotation behavior of the camera if it has been enabled.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors/cameraBehaviors#autorotation-behavior
     */ get autoRotationBehavior() {
        return this._autoRotationBehavior;
    }
    /**
     * Defines if the auto rotation behavior of the camera is enabled on the camera.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/behaviors/cameraBehaviors#autorotation-behavior
     */ get useAutoRotationBehavior() {
        return this._autoRotationBehavior != null;
    }
    set useAutoRotationBehavior(value) {
        if (value === this.useAutoRotationBehavior) return;
        if (value) {
            this._autoRotationBehavior = new (0, $7gmZD.AutoRotationBehavior)();
            this.addBehavior(this._autoRotationBehavior);
        } else if (this._autoRotationBehavior) {
            this.removeBehavior(this._autoRotationBehavior);
            this._autoRotationBehavior = null;
        }
    }
    /**
     * Instantiates a new ArcRotateCamera in a given scene
     * @param name Defines the name of the camera
     * @param alpha Defines the camera rotation along the longitudinal axis
     * @param beta Defines the camera rotation along the latitudinal axis
     * @param radius Defines the camera distance from its target
     * @param target Defines the camera target
     * @param scene Defines the scene the camera belongs to
     * @param setActiveOnSceneIfNoneActive Defines whether the camera should be marked as active if not other active cameras have been defined
     */ constructor(name, alpha, beta, radius, target, scene, setActiveOnSceneIfNoneActive = true){
        super(name, (0, $ha1VO.Vector3).Zero(), scene, setActiveOnSceneIfNoneActive);
        /**
         * Current inertia value on the longitudinal axis.
         * The bigger this number the longer it will take for the camera to stop.
         */ this.inertialAlphaOffset = 0;
        /**
         * Current inertia value on the latitudinal axis.
         * The bigger this number the longer it will take for the camera to stop.
         */ this.inertialBetaOffset = 0;
        /**
         * Current inertia value on the radius axis.
         * The bigger this number the longer it will take for the camera to stop.
         */ this.inertialRadiusOffset = 0;
        /**
         * Minimum allowed angle on the longitudinal axis.
         * This can help limiting how the Camera is able to move in the scene.
         */ this.lowerAlphaLimit = null;
        /**
         * Maximum allowed angle on the longitudinal axis.
         * This can help limiting how the Camera is able to move in the scene.
         */ this.upperAlphaLimit = null;
        /**
         * Minimum allowed angle on the latitudinal axis.
         * This can help limiting how the Camera is able to move in the scene.
         */ this.lowerBetaLimit = 0.01;
        /**
         * Maximum allowed angle on the latitudinal axis.
         * This can help limiting how the Camera is able to move in the scene.
         */ this.upperBetaLimit = Math.PI - 0.01;
        /**
         * Minimum allowed distance of the camera to the target (The camera can not get closer).
         * This can help limiting how the Camera is able to move in the scene.
         */ this.lowerRadiusLimit = null;
        /**
         * Maximum allowed distance of the camera to the target (The camera can not get further).
         * This can help limiting how the Camera is able to move in the scene.
         */ this.upperRadiusLimit = null;
        /**
         * Defines the current inertia value used during panning of the camera along the X axis.
         */ this.inertialPanningX = 0;
        /**
         * Defines the current inertia value used during panning of the camera along the Y axis.
         */ this.inertialPanningY = 0;
        /**
         * Defines the distance used to consider the camera in pan mode vs pinch/zoom.
         * Basically if your fingers moves away from more than this distance you will be considered
         * in pinch mode.
         */ this.pinchToPanMaxDistance = 20;
        /**
         * Defines the maximum distance the camera can pan.
         * This could help keeping the camera always in your scene.
         */ this.panningDistanceLimit = null;
        /**
         * Defines the target of the camera before panning.
         */ this.panningOriginTarget = (0, $ha1VO.Vector3).Zero();
        /**
         * Defines the value of the inertia used during panning.
         * 0 would mean stop inertia and one would mean no deceleration at all.
         */ this.panningInertia = 0.9;
        //-- end properties for backward compatibility for inputs
        /**
         * Defines how much the radius should be scaled while zooming on a particular mesh (through the zoomOn function)
         */ this.zoomOnFactor = 1;
        /**
         * Defines a screen offset for the camera position.
         */ this.targetScreenOffset = (0, $ha1VO.Vector2).Zero();
        /**
         * Allows the camera to be completely reversed.
         * If false the camera can not arrive upside down.
         */ this.allowUpsideDown = true;
        /**
         * Define if double tap/click is used to restore the previously saved state of the camera.
         */ this.useInputToRestoreState = true;
        /** @internal */ this._viewMatrix = new (0, $ha1VO.Matrix)();
        /**
         * Defines the allowed panning axis.
         */ this.panningAxis = new (0, $ha1VO.Vector3)(1, 1, 0);
        this._transformedDirection = new (0, $ha1VO.Vector3)();
        /**
         * Defines if camera will eliminate transform on y axis.
         */ this.mapPanning = false;
        /**
         * Observable triggered when the transform node target has been changed on the camera.
         */ this.onMeshTargetChangedObservable = new (0, $diGQf.Observable)();
        /**
         * Defines whether the camera should check collision with the objects oh the scene.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_collisions#how-can-i-do-this-
         */ this.checkCollisions = false;
        /**
         * Defines the collision radius of the camera.
         * This simulates a sphere around the camera.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_collisions#arcrotatecamera
         */ this.collisionRadius = new (0, $ha1VO.Vector3)(0.5, 0.5, 0.5);
        this._previousPosition = (0, $ha1VO.Vector3).Zero();
        this._collisionVelocity = (0, $ha1VO.Vector3).Zero();
        this._newPosition = (0, $ha1VO.Vector3).Zero();
        this._computationVector = (0, $ha1VO.Vector3).Zero();
        this._onCollisionPositionChange = (collisionId, newPosition, collidedMesh = null)=>{
            if (!collidedMesh) this._previousPosition.copyFrom(this._position);
            else {
                this.setPosition(newPosition);
                if (this.onCollide) this.onCollide(collidedMesh);
            }
            // Recompute because of constraints
            const cosa = Math.cos(this.alpha);
            const sina = Math.sin(this.alpha);
            const cosb = Math.cos(this.beta);
            let sinb = Math.sin(this.beta);
            if (sinb === 0) sinb = 0.0001;
            const target = this._getTargetPosition();
            this._computationVector.copyFromFloats(this.radius * cosa * sinb, this.radius * cosb, this.radius * sina * sinb);
            target.addToRef(this._computationVector, this._newPosition);
            this._position.copyFrom(this._newPosition);
            let up = this.upVector;
            if (this.allowUpsideDown && this.beta < 0) {
                up = up.clone();
                up = up.negate();
            }
            this._computeViewMatrix(this._position, target, up);
            this._viewMatrix.addAtIndex(12, this.targetScreenOffset.x);
            this._viewMatrix.addAtIndex(13, this.targetScreenOffset.y);
            this._collisionTriggered = false;
        };
        this._target = (0, $ha1VO.Vector3).Zero();
        if (target) this.setTarget(target);
        this.alpha = alpha;
        this.beta = beta;
        this.radius = radius;
        this.getViewMatrix();
        this.inputs = new (0, $gotsS.ArcRotateCameraInputsManager)(this);
        this.inputs.addKeyboard().addMouseWheel().addPointers();
    }
    // Cache
    /** @internal */ _initCache() {
        super._initCache();
        this._cache._target = new (0, $ha1VO.Vector3)(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
        this._cache.alpha = undefined;
        this._cache.beta = undefined;
        this._cache.radius = undefined;
        this._cache.targetScreenOffset = (0, $ha1VO.Vector2).Zero();
    }
    /**
     * @internal
     */ _updateCache(ignoreParentClass) {
        if (!ignoreParentClass) super._updateCache();
        this._cache._target.copyFrom(this._getTargetPosition());
        this._cache.alpha = this.alpha;
        this._cache.beta = this.beta;
        this._cache.radius = this.radius;
        this._cache.targetScreenOffset.copyFrom(this.targetScreenOffset);
    }
    _getTargetPosition() {
        if (this._targetHost && this._targetHost.getAbsolutePosition) {
            const pos = this._targetHost.getAbsolutePosition();
            if (this._targetBoundingCenter) pos.addToRef(this._targetBoundingCenter, this._target);
            else this._target.copyFrom(pos);
        }
        const lockedTargetPosition = this._getLockedTargetPosition();
        if (lockedTargetPosition) return lockedTargetPosition;
        return this._target;
    }
    /**
     * Stores the current state of the camera (alpha, beta, radius and target)
     * @returns the camera itself
     */ storeState() {
        this._storedAlpha = this.alpha;
        this._storedBeta = this.beta;
        this._storedRadius = this.radius;
        this._storedTarget = this._getTargetPosition().clone();
        this._storedTargetScreenOffset = this.targetScreenOffset.clone();
        return super.storeState();
    }
    /**
     * @internal
     * Restored camera state. You must call storeState() first
     */ _restoreStateValues() {
        if (!super._restoreStateValues()) return false;
        this.setTarget(this._storedTarget.clone());
        this.alpha = this._storedAlpha;
        this.beta = this._storedBeta;
        this.radius = this._storedRadius;
        this.targetScreenOffset = this._storedTargetScreenOffset.clone();
        this.inertialAlphaOffset = 0;
        this.inertialBetaOffset = 0;
        this.inertialRadiusOffset = 0;
        this.inertialPanningX = 0;
        this.inertialPanningY = 0;
        return true;
    }
    // Synchronized
    /** @internal */ _isSynchronizedViewMatrix() {
        if (!super._isSynchronizedViewMatrix()) return false;
        return this._cache._target.equals(this._getTargetPosition()) && this._cache.alpha === this.alpha && this._cache.beta === this.beta && this._cache.radius === this.radius && this._cache.targetScreenOffset.equals(this.targetScreenOffset);
    }
    /**
     * Attached controls to the current camera.
     * @param ignored defines an ignored parameter kept for backward compatibility.
     * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
     * @param useCtrlForPanning  Defines whether ctrl is used for panning within the controls
     * @param panningMouseButton Defines whether panning is allowed through mouse click button
     */ attachControl(ignored, noPreventDefault, useCtrlForPanning = true, panningMouseButton = 2) {
        // eslint-disable-next-line prefer-rest-params
        const args = arguments;
        noPreventDefault = (0, $bOhSV.Tools).BackCompatCameraNoPreventDefault(args);
        this._useCtrlForPanning = useCtrlForPanning;
        this._panningMouseButton = panningMouseButton;
        // backwards compatibility
        if (typeof args[0] === "boolean") {
            if (args.length > 1) this._useCtrlForPanning = args[1];
            if (args.length > 2) this._panningMouseButton = args[2];
        }
        this.inputs.attachElement(noPreventDefault);
        this._reset = ()=>{
            this.inertialAlphaOffset = 0;
            this.inertialBetaOffset = 0;
            this.inertialRadiusOffset = 0;
            this.inertialPanningX = 0;
            this.inertialPanningY = 0;
        };
    }
    /**
     * Detach the current controls from the specified dom element.
     */ detachControl() {
        this.inputs.detachElement();
        if (this._reset) this._reset();
    }
    /** @internal */ _checkInputs() {
        //if (async) collision inspection was triggered, don't update the camera's position - until the collision callback was called.
        if (this._collisionTriggered) return;
        this.inputs.checkInputs();
        // Inertia
        if (this.inertialAlphaOffset !== 0 || this.inertialBetaOffset !== 0 || this.inertialRadiusOffset !== 0) {
            const directionModifier = this.invertRotation ? -1 : 1;
            const handednessMultiplier = this._calculateHandednessMultiplier();
            let inertialAlphaOffset = this.inertialAlphaOffset * handednessMultiplier;
            if (this.beta < 0) inertialAlphaOffset *= -1;
            this.alpha += inertialAlphaOffset * directionModifier;
            this.beta += this.inertialBetaOffset * directionModifier;
            this.radius -= this.inertialRadiusOffset;
            this.inertialAlphaOffset *= this.inertia;
            this.inertialBetaOffset *= this.inertia;
            this.inertialRadiusOffset *= this.inertia;
            if (Math.abs(this.inertialAlphaOffset) < (0, $53VPf.Epsilon)) this.inertialAlphaOffset = 0;
            if (Math.abs(this.inertialBetaOffset) < (0, $53VPf.Epsilon)) this.inertialBetaOffset = 0;
            if (Math.abs(this.inertialRadiusOffset) < this.speed * (0, $53VPf.Epsilon)) this.inertialRadiusOffset = 0;
        }
        // Panning inertia
        if (this.inertialPanningX !== 0 || this.inertialPanningY !== 0) {
            const localDirection = new (0, $ha1VO.Vector3)(this.inertialPanningX, this.inertialPanningY, this.inertialPanningY);
            this._viewMatrix.invertToRef(this._cameraTransformMatrix);
            localDirection.multiplyInPlace(this.panningAxis);
            (0, $ha1VO.Vector3).TransformNormalToRef(localDirection, this._cameraTransformMatrix, this._transformedDirection);
            // If mapPanning is enabled, we need to take the upVector into account and
            // make sure we're not panning in the y direction
            if (this.mapPanning) {
                const up = this.upVector;
                const right = (0, $ha1VO.Vector3).CrossToRef(this._transformedDirection, up, this._transformedDirection);
                (0, $ha1VO.Vector3).CrossToRef(up, right, this._transformedDirection);
            } else if (!this.panningAxis.y) this._transformedDirection.y = 0;
            if (!this._targetHost) {
                if (this.panningDistanceLimit) {
                    this._transformedDirection.addInPlace(this._target);
                    const distanceSquared = (0, $ha1VO.Vector3).DistanceSquared(this._transformedDirection, this.panningOriginTarget);
                    if (distanceSquared <= this.panningDistanceLimit * this.panningDistanceLimit) this._target.copyFrom(this._transformedDirection);
                } else {
                    if (this.parent) {
                        const m = (0, $ha1VO.TmpVectors).Matrix[0];
                        this.parent.getWorldMatrix().getRotationMatrixToRef(m);
                        m.transposeToRef(m);
                        (0, $ha1VO.Vector3).TransformCoordinatesToRef(this._transformedDirection, m, this._transformedDirection);
                    }
                    this._target.addInPlace(this._transformedDirection);
                }
            }
            this.inertialPanningX *= this.panningInertia;
            this.inertialPanningY *= this.panningInertia;
            if (Math.abs(this.inertialPanningX) < this.speed * (0, $53VPf.Epsilon)) this.inertialPanningX = 0;
            if (Math.abs(this.inertialPanningY) < this.speed * (0, $53VPf.Epsilon)) this.inertialPanningY = 0;
        }
        // Limits
        this._checkLimits();
        super._checkInputs();
    }
    _checkLimits() {
        if (this.lowerBetaLimit === null || this.lowerBetaLimit === undefined) {
            if (this.allowUpsideDown && this.beta > Math.PI) this.beta = this.beta - 2 * Math.PI;
        } else if (this.beta < this.lowerBetaLimit) this.beta = this.lowerBetaLimit;
        if (this.upperBetaLimit === null || this.upperBetaLimit === undefined) {
            if (this.allowUpsideDown && this.beta < -Math.PI) this.beta = this.beta + 2 * Math.PI;
        } else if (this.beta > this.upperBetaLimit) this.beta = this.upperBetaLimit;
        if (this.lowerAlphaLimit !== null && this.alpha < this.lowerAlphaLimit) this.alpha = this.lowerAlphaLimit;
        if (this.upperAlphaLimit !== null && this.alpha > this.upperAlphaLimit) this.alpha = this.upperAlphaLimit;
        if (this.lowerRadiusLimit !== null && this.radius < this.lowerRadiusLimit) {
            this.radius = this.lowerRadiusLimit;
            this.inertialRadiusOffset = 0;
        }
        if (this.upperRadiusLimit !== null && this.radius > this.upperRadiusLimit) {
            this.radius = this.upperRadiusLimit;
            this.inertialRadiusOffset = 0;
        }
    }
    /**
     * Rebuilds angles (alpha, beta) and radius from the give position and target
     */ rebuildAnglesAndRadius() {
        this._position.subtractToRef(this._getTargetPosition(), this._computationVector);
        // need to rotate to Y up equivalent if up vector not Axis.Y
        if (this._upVector.x !== 0 || this._upVector.y !== 1.0 || this._upVector.z !== 0) (0, $ha1VO.Vector3).TransformCoordinatesToRef(this._computationVector, this._upToYMatrix, this._computationVector);
        this.radius = this._computationVector.length();
        if (this.radius === 0) this.radius = 0.0001; // Just to avoid division by zero
        // Alpha
        const previousAlpha = this.alpha;
        if (this._computationVector.x === 0 && this._computationVector.z === 0) this.alpha = Math.PI / 2; // avoid division by zero when looking along up axis, and set to acos(0)
        else this.alpha = Math.acos(this._computationVector.x / Math.sqrt(Math.pow(this._computationVector.x, 2) + Math.pow(this._computationVector.z, 2)));
        if (this._computationVector.z < 0) this.alpha = 2 * Math.PI - this.alpha;
        // Calculate the number of revolutions between the new and old alpha values.
        const alphaCorrectionTurns = Math.round((previousAlpha - this.alpha) / (2.0 * Math.PI));
        // Adjust alpha so that its numerical representation is the closest one to the old value.
        this.alpha += alphaCorrectionTurns * 2.0 * Math.PI;
        // Beta
        this.beta = Math.acos(this._computationVector.y / this.radius);
        this._checkLimits();
    }
    /**
     * Use a position to define the current camera related information like alpha, beta and radius
     * @param position Defines the position to set the camera at
     */ setPosition(position) {
        if (this._position.equals(position)) return;
        this._position.copyFrom(position);
        this.rebuildAnglesAndRadius();
    }
    /**
     * Defines the target the camera should look at.
     * This will automatically adapt alpha beta and radius to fit within the new target.
     * Please note that setting a target as a mesh will disable panning.
     * @param target Defines the new target as a Vector or a transform node
     * @param toBoundingCenter In case of a mesh target, defines whether to target the mesh position or its bounding information center
     * @param allowSamePosition If false, prevents reapplying the new computed position if it is identical to the current one (optim)
     * @param cloneAlphaBetaRadius If true, replicate the current setup (alpha, beta, radius) on the new target
     */ setTarget(target, toBoundingCenter = false, allowSamePosition = false, cloneAlphaBetaRadius = false) {
        cloneAlphaBetaRadius = this.overrideCloneAlphaBetaRadius ?? cloneAlphaBetaRadius;
        if (target.computeWorldMatrix) {
            if (toBoundingCenter && target.getBoundingInfo) this._targetBoundingCenter = target.getBoundingInfo().boundingBox.centerWorld.clone();
            else this._targetBoundingCenter = null;
            target.computeWorldMatrix();
            this._targetHost = target;
            this._target = this._getTargetPosition();
            this.onMeshTargetChangedObservable.notifyObservers(this._targetHost);
        } else {
            const newTarget = target;
            const currentTarget = this._getTargetPosition();
            if (currentTarget && !allowSamePosition && currentTarget.equals(newTarget)) return;
            this._targetHost = null;
            this._target = newTarget;
            this._targetBoundingCenter = null;
            this.onMeshTargetChangedObservable.notifyObservers(null);
        }
        if (!cloneAlphaBetaRadius) this.rebuildAnglesAndRadius();
    }
    /** @internal */ _getViewMatrix() {
        // Compute
        const cosa = Math.cos(this.alpha);
        const sina = Math.sin(this.alpha);
        const cosb = Math.cos(this.beta);
        let sinb = Math.sin(this.beta);
        if (sinb === 0) sinb = 0.0001;
        if (this.radius === 0) this.radius = 0.0001; // Just to avoid division by zero
        const target = this._getTargetPosition();
        this._computationVector.copyFromFloats(this.radius * cosa * sinb, this.radius * cosb, this.radius * sina * sinb);
        // Rotate according to up vector
        if (this._upVector.x !== 0 || this._upVector.y !== 1.0 || this._upVector.z !== 0) (0, $ha1VO.Vector3).TransformCoordinatesToRef(this._computationVector, this._yToUpMatrix, this._computationVector);
        target.addToRef(this._computationVector, this._newPosition);
        if (this.getScene().collisionsEnabled && this.checkCollisions) {
            const coordinator = this.getScene().collisionCoordinator;
            if (!this._collider) this._collider = coordinator.createCollider();
            this._collider._radius = this.collisionRadius;
            this._newPosition.subtractToRef(this._position, this._collisionVelocity);
            this._collisionTriggered = true;
            coordinator.getNewPosition(this._position, this._collisionVelocity, this._collider, 3, null, this._onCollisionPositionChange, this.uniqueId);
        } else {
            this._position.copyFrom(this._newPosition);
            let up = this.upVector;
            if (this.allowUpsideDown && sinb < 0) up = up.negate();
            this._computeViewMatrix(this._position, target, up);
            this._viewMatrix.addAtIndex(12, this.targetScreenOffset.x);
            this._viewMatrix.addAtIndex(13, this.targetScreenOffset.y);
        }
        this._currentTarget = target;
        return this._viewMatrix;
    }
    /**
     * Zooms on a mesh to be at the min distance where we could see it fully in the current viewport.
     * @param meshes Defines the mesh to zoom on
     * @param doNotUpdateMaxZ Defines whether or not maxZ should be updated whilst zooming on the mesh (this can happen if the mesh is big and the maxradius pretty small for instance)
     */ zoomOn(meshes, doNotUpdateMaxZ = false) {
        meshes = meshes || this.getScene().meshes;
        const minMaxVector = (0, $fbuqw.Mesh).MinMax(meshes);
        let distance = this._calculateLowerRadiusFromModelBoundingSphere(minMaxVector.min, minMaxVector.max);
        // If there are defined limits, we need to take them into account
        distance = Math.max(Math.min(distance, this.upperRadiusLimit || Number.MAX_VALUE), this.lowerRadiusLimit || 0);
        this.radius = distance * this.zoomOnFactor;
        this.focusOn({
            min: minMaxVector.min,
            max: minMaxVector.max,
            distance: distance
        }, doNotUpdateMaxZ);
    }
    /**
     * Focus on a mesh or a bounding box. This adapts the target and maxRadius if necessary but does not update the current radius.
     * The target will be changed but the radius
     * @param meshesOrMinMaxVectorAndDistance Defines the mesh or bounding info to focus on
     * @param doNotUpdateMaxZ Defines whether or not maxZ should be updated whilst zooming on the mesh (this can happen if the mesh is big and the maxradius pretty small for instance)
     */ focusOn(meshesOrMinMaxVectorAndDistance, doNotUpdateMaxZ = false) {
        let meshesOrMinMaxVector;
        let distance;
        if (meshesOrMinMaxVectorAndDistance.min === undefined) {
            // meshes
            const meshes = meshesOrMinMaxVectorAndDistance || this.getScene().meshes;
            meshesOrMinMaxVector = (0, $fbuqw.Mesh).MinMax(meshes);
            distance = (0, $ha1VO.Vector3).Distance(meshesOrMinMaxVector.min, meshesOrMinMaxVector.max);
        } else {
            //minMaxVector and distance
            const minMaxVectorAndDistance = meshesOrMinMaxVectorAndDistance;
            meshesOrMinMaxVector = minMaxVectorAndDistance;
            distance = minMaxVectorAndDistance.distance;
        }
        this._target = (0, $fbuqw.Mesh).Center(meshesOrMinMaxVector);
        if (!doNotUpdateMaxZ) this.maxZ = distance * 2;
    }
    /**
     * @override
     * Override Camera.createRigCamera
     * @param name the name of the camera
     * @param cameraIndex the index of the camera in the rig cameras array
     */ createRigCamera(name, cameraIndex) {
        let alphaShift = 0;
        switch(this.cameraRigMode){
            case (0, $74SKQ.Camera).RIG_MODE_STEREOSCOPIC_ANAGLYPH:
            case (0, $74SKQ.Camera).RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_PARALLEL:
            case (0, $74SKQ.Camera).RIG_MODE_STEREOSCOPIC_OVERUNDER:
            case (0, $74SKQ.Camera).RIG_MODE_STEREOSCOPIC_INTERLACED:
            case (0, $74SKQ.Camera).RIG_MODE_VR:
                alphaShift = this._cameraRigParams.stereoHalfAngle * (cameraIndex === 0 ? 1 : -1);
                break;
            case (0, $74SKQ.Camera).RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_CROSSEYED:
                alphaShift = this._cameraRigParams.stereoHalfAngle * (cameraIndex === 0 ? -1 : 1);
                break;
        }
        const rigCam = new $e59f949a590d8aa8$export$8438041bb8e406c8(name, this.alpha + alphaShift, this.beta, this.radius, this._target, this.getScene());
        rigCam._cameraRigParams = {};
        rigCam.isRigCamera = true;
        rigCam.rigParent = this;
        rigCam.upVector = this.upVector;
        rigCam.mode = this.mode;
        rigCam.orthoLeft = this.orthoLeft;
        rigCam.orthoRight = this.orthoRight;
        rigCam.orthoBottom = this.orthoBottom;
        rigCam.orthoTop = this.orthoTop;
        return rigCam;
    }
    /**
     * @internal
     * @override
     * Override Camera._updateRigCameras
     */ _updateRigCameras() {
        const camLeft = this._rigCameras[0];
        const camRight = this._rigCameras[1];
        camLeft.beta = camRight.beta = this.beta;
        switch(this.cameraRigMode){
            case (0, $74SKQ.Camera).RIG_MODE_STEREOSCOPIC_ANAGLYPH:
            case (0, $74SKQ.Camera).RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_PARALLEL:
            case (0, $74SKQ.Camera).RIG_MODE_STEREOSCOPIC_OVERUNDER:
            case (0, $74SKQ.Camera).RIG_MODE_STEREOSCOPIC_INTERLACED:
            case (0, $74SKQ.Camera).RIG_MODE_VR:
                camLeft.alpha = this.alpha - this._cameraRigParams.stereoHalfAngle;
                camRight.alpha = this.alpha + this._cameraRigParams.stereoHalfAngle;
                break;
            case (0, $74SKQ.Camera).RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_CROSSEYED:
                camLeft.alpha = this.alpha + this._cameraRigParams.stereoHalfAngle;
                camRight.alpha = this.alpha - this._cameraRigParams.stereoHalfAngle;
                break;
        }
        super._updateRigCameras();
    }
    /**
     * @internal
     */ _calculateLowerRadiusFromModelBoundingSphere(minimumWorld, maximumWorld, radiusScale = 1) {
        const boxVectorGlobalDiagonal = (0, $ha1VO.Vector3).Distance(minimumWorld, maximumWorld);
        // Get aspect ratio in order to calculate frustum slope
        const engine = this.getScene().getEngine();
        const aspectRatio = engine.getAspectRatio(this);
        const frustumSlopeY = Math.tan(this.fov / 2);
        const frustumSlopeX = frustumSlopeY * aspectRatio;
        // Formula for setting distance
        // (Good explanation: http://stackoverflow.com/questions/2866350/move-camera-to-fit-3d-scene)
        const radiusWithoutFraming = boxVectorGlobalDiagonal * 0.5;
        // Horizon distance
        const radius = radiusWithoutFraming * radiusScale;
        const distanceForHorizontalFrustum = radius * Math.sqrt(1.0 + 1.0 / (frustumSlopeX * frustumSlopeX));
        const distanceForVerticalFrustum = radius * Math.sqrt(1.0 + 1.0 / (frustumSlopeY * frustumSlopeY));
        return Math.max(distanceForHorizontalFrustum, distanceForVerticalFrustum);
    }
    /**
     * Destroy the camera and release the current resources hold by it.
     */ dispose() {
        this.inputs.clear();
        super.dispose();
    }
    /**
     * Gets the current object class name.
     * @returns the class name
     */ getClassName() {
        return "ArcRotateCamera";
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "alpha", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "beta", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "radius", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "overrideCloneAlphaBetaRadius", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsVector3)("target")
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "_target", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsMeshReference)("targetHost")
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "_targetHost", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "inertialAlphaOffset", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "inertialBetaOffset", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "inertialRadiusOffset", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "lowerAlphaLimit", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "upperAlphaLimit", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "lowerBetaLimit", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "upperBetaLimit", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "lowerRadiusLimit", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "upperRadiusLimit", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "inertialPanningX", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "inertialPanningY", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "pinchToPanMaxDistance", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "panningDistanceLimit", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsVector3)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "panningOriginTarget", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "panningInertia", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "zoomToMouseLocation", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "zoomOnFactor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsVector2)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "targetScreenOffset", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "allowUpsideDown", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e59f949a590d8aa8$export$8438041bb8e406c8.prototype, "useInputToRestoreState", void 0);

});

parcelRegister("aR7MK", function(module, exports) {

$parcel$export(module.exports, "DeviceOrientationCamera", () => $7e74e49712201f70$export$a76c9c8d2647f04);

var $gSOV5 = parcelRequire("gSOV5");

var $ha1VO = parcelRequire("ha1VO");

var $bgssx = parcelRequire("bgssx");
parcelRequire("gAphd");

var $dbxbu = parcelRequire("dbxbu");
(0, $bgssx.Node).AddNodeConstructor("DeviceOrientationCamera", (name, scene)=>{
    return ()=>new $7e74e49712201f70$export$a76c9c8d2647f04(name, (0, $ha1VO.Vector3).Zero(), scene);
});
class $7e74e49712201f70$export$a76c9c8d2647f04 extends (0, $gSOV5.FreeCamera) {
    /**
     * Creates a new device orientation camera
     * @param name The name of the camera
     * @param position The start position camera
     * @param scene The scene the camera belongs to
     */ constructor(name, position, scene){
        super(name, position, scene);
        this._tmpDragQuaternion = new (0, $ha1VO.Quaternion)();
        this._disablePointerInputWhenUsingDeviceOrientation = true;
        this._dragFactor = 0;
        this._quaternionCache = new (0, $ha1VO.Quaternion)();
        this.inputs.addDeviceOrientation();
        // When the orientation sensor fires it's first event, disable mouse input
        if (this.inputs._deviceOrientationInput) this.inputs._deviceOrientationInput._onDeviceOrientationChangedObservable.addOnce(()=>{
            if (this._disablePointerInputWhenUsingDeviceOrientation) {
                if (this.inputs._mouseInput) {
                    this.inputs._mouseInput._allowCameraRotation = false;
                    this.inputs._mouseInput.onPointerMovedObservable.add((e)=>{
                        if (this._dragFactor != 0) {
                            if (!this._initialQuaternion) this._initialQuaternion = new (0, $ha1VO.Quaternion)();
                            // Rotate the initial space around the y axis to allow users to "turn around" via touch/mouse
                            (0, $ha1VO.Quaternion).FromEulerAnglesToRef(0, e.offsetX * this._dragFactor, 0, this._tmpDragQuaternion);
                            this._initialQuaternion.multiplyToRef(this._tmpDragQuaternion, this._initialQuaternion);
                        }
                    });
                }
            }
        });
    }
    /**
     * Gets or sets a boolean indicating that pointer input must be disabled on first orientation sensor update (Default: true)
     */ get disablePointerInputWhenUsingDeviceOrientation() {
        return this._disablePointerInputWhenUsingDeviceOrientation;
    }
    set disablePointerInputWhenUsingDeviceOrientation(value) {
        this._disablePointerInputWhenUsingDeviceOrientation = value;
    }
    /**
     * Enabled turning on the y axis when the orientation sensor is active
     * @param dragFactor the factor that controls the turn speed (default: 1/300)
     */ enableHorizontalDragging(dragFactor = 1 / 300) {
        this._dragFactor = dragFactor;
    }
    /**
     * Gets the current instance class name ("DeviceOrientationCamera").
     * This helps avoiding instanceof at run time.
     * @returns the class name
     */ getClassName() {
        return "DeviceOrientationCamera";
    }
    /**
     * @internal
     * Checks and applies the current values of the inputs to the camera. (Internal use only)
     */ _checkInputs() {
        super._checkInputs();
        this._quaternionCache.copyFrom(this.rotationQuaternion);
        if (this._initialQuaternion) this._initialQuaternion.multiplyToRef(this.rotationQuaternion, this.rotationQuaternion);
    }
    /**
     * Reset the camera to its default orientation on the specified axis only.
     * @param axis The axis to reset
     */ resetToCurrentRotation(axis = (0, $dbxbu.Axis).Y) {
        //can only work if this camera has a rotation quaternion already.
        if (!this.rotationQuaternion) return;
        if (!this._initialQuaternion) this._initialQuaternion = new (0, $ha1VO.Quaternion)();
        this._initialQuaternion.copyFrom(this._quaternionCache || this.rotationQuaternion);
        [
            "x",
            "y",
            "z"
        ].forEach((axisName)=>{
            if (!axis[axisName]) this._initialQuaternion[axisName] = 0;
            else this._initialQuaternion[axisName] *= -1;
        });
        this._initialQuaternion.normalize();
        //force rotation update
        this._initialQuaternion.multiplyToRef(this.rotationQuaternion, this.rotationQuaternion);
    }
}

});

parcelRegister("guHki", function(module, exports) {

$parcel$export(module.exports, "FlyCamera", () => $c0210e5fdda4081b$export$7a60e92629d633a3);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $ha1VO = parcelRequire("ha1VO");

var $5YkyR = parcelRequire("5YkyR");

var $fJj0G = parcelRequire("fJj0G");

var $23cQH = parcelRequire("23cQH");

var $bOhSV = parcelRequire("bOhSV");
class $c0210e5fdda4081b$export$7a60e92629d633a3 extends (0, $fJj0G.TargetCamera) {
    /**
     * Gets the input sensibility for mouse input.
     * Higher values reduce sensitivity.
     */ get angularSensibility() {
        const mouse = this.inputs.attached["mouse"];
        if (mouse) return mouse.angularSensibility;
        return 0;
    }
    /**
     * Sets the input sensibility for a mouse input.
     * Higher values reduce sensitivity.
     */ set angularSensibility(value) {
        const mouse = this.inputs.attached["mouse"];
        if (mouse) mouse.angularSensibility = value;
    }
    /**
     * Get the keys for camera movement forward.
     */ get keysForward() {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) return keyboard.keysForward;
        return [];
    }
    /**
     * Set the keys for camera movement forward.
     */ set keysForward(value) {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) keyboard.keysForward = value;
    }
    /**
     * Get the keys for camera movement backward.
     */ get keysBackward() {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) return keyboard.keysBackward;
        return [];
    }
    set keysBackward(value) {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) keyboard.keysBackward = value;
    }
    /**
     * Get the keys for camera movement up.
     */ get keysUp() {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) return keyboard.keysUp;
        return [];
    }
    /**
     * Set the keys for camera movement up.
     */ set keysUp(value) {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) keyboard.keysUp = value;
    }
    /**
     * Get the keys for camera movement down.
     */ get keysDown() {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) return keyboard.keysDown;
        return [];
    }
    /**
     * Set the keys for camera movement down.
     */ set keysDown(value) {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) keyboard.keysDown = value;
    }
    /**
     * Get the keys for camera movement left.
     */ get keysLeft() {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) return keyboard.keysLeft;
        return [];
    }
    /**
     * Set the keys for camera movement left.
     */ set keysLeft(value) {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) keyboard.keysLeft = value;
    }
    /**
     * Set the keys for camera movement right.
     */ get keysRight() {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) return keyboard.keysRight;
        return [];
    }
    /**
     * Set the keys for camera movement right.
     */ set keysRight(value) {
        const keyboard = this.inputs.attached["keyboard"];
        if (keyboard) keyboard.keysRight = value;
    }
    /**
     * Instantiates a FlyCamera.
     * This is a flying camera, designed for 3D movement and rotation in all directions,
     * such as in a 3D Space Shooter or a Flight Simulator.
     * @param name Define the name of the camera in the scene.
     * @param position Define the starting position of the camera in the scene.
     * @param scene Define the scene the camera belongs to.
     * @param setActiveOnSceneIfNoneActive Defines whether the camera should be marked as active, if no other camera has been defined as active.
     */ constructor(name, position, scene, setActiveOnSceneIfNoneActive = true){
        super(name, position, scene, setActiveOnSceneIfNoneActive);
        /**
         * Define the collision ellipsoid of the camera.
         * This is helpful for simulating a camera body, like a player's body.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_collisions#arcrotatecamera
         */ this.ellipsoid = new (0, $ha1VO.Vector3)(1, 1, 1);
        /**
         * Define an offset for the position of the ellipsoid around the camera.
         * This can be helpful if the camera is attached away from the player's body center,
         * such as at its head.
         */ this.ellipsoidOffset = new (0, $ha1VO.Vector3)(0, 0, 0);
        /**
         * Enable or disable collisions of the camera with the rest of the scene objects.
         */ this.checkCollisions = false;
        /**
         * Enable or disable gravity on the camera.
         */ this.applyGravity = false;
        /**
         * Define the current direction the camera is moving to.
         */ this.cameraDirection = (0, $ha1VO.Vector3).Zero();
        /**
         * Track Roll to maintain the wanted Rolling when looking around.
         */ this._trackRoll = 0;
        /**
         * Slowly correct the Roll to its original value after a Pitch+Yaw rotation.
         */ this.rollCorrect = 100;
        /**
         * Mimic a banked turn, Rolling the camera when Yawing.
         * It's recommended to use rollCorrect = 10 for faster banking correction.
         */ this.bankedTurn = false;
        /**
         * Limit in radians for how much Roll banking will add. (Default: 90°)
         */ this.bankedTurnLimit = Math.PI / 2;
        /**
         * Value of 0 disables the banked Roll.
         * Value of 1 is equal to the Yaw angle in radians.
         */ this.bankedTurnMultiplier = 1;
        this._needMoveForGravity = false;
        this._oldPosition = (0, $ha1VO.Vector3).Zero();
        this._diffPosition = (0, $ha1VO.Vector3).Zero();
        this._newPosition = (0, $ha1VO.Vector3).Zero();
        // Collisions.
        this._collisionMask = -1;
        /**
         * @internal
         */ this._onCollisionPositionChange = (collisionId, newPosition, collidedMesh = null)=>{
            const updatePosition = (newPos)=>{
                this._newPosition.copyFrom(newPos);
                this._newPosition.subtractToRef(this._oldPosition, this._diffPosition);
                if (this._diffPosition.length() > (0, $5YkyR.Engine).CollisionsEpsilon) {
                    this.position.addInPlace(this._diffPosition);
                    if (this.onCollide && collidedMesh) this.onCollide(collidedMesh);
                }
            };
            updatePosition(newPosition);
        };
        this.inputs = new (0, $23cQH.FlyCameraInputsManager)(this);
        this.inputs.addKeyboard().addMouse();
    }
    /**
     * Attached controls to the current camera.
     * @param ignored defines an ignored parameter kept for backward compatibility.
     * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
     */ attachControl(ignored, noPreventDefault) {
        // eslint-disable-next-line prefer-rest-params
        noPreventDefault = (0, $bOhSV.Tools).BackCompatCameraNoPreventDefault(arguments);
        this.inputs.attachElement(noPreventDefault);
    }
    /**
     * Detach a control from the HTML DOM element.
     * The camera will stop reacting to that input.
     */ detachControl() {
        this.inputs.detachElement();
        this.cameraDirection = new (0, $ha1VO.Vector3)(0, 0, 0);
    }
    /**
     * Get the mask that the camera ignores in collision events.
     */ get collisionMask() {
        return this._collisionMask;
    }
    /**
     * Set the mask that the camera ignores in collision events.
     */ set collisionMask(mask) {
        this._collisionMask = !isNaN(mask) ? mask : -1;
    }
    /**
     * @internal
     */ _collideWithWorld(displacement) {
        let globalPosition;
        if (this.parent) globalPosition = (0, $ha1VO.Vector3).TransformCoordinates(this.position, this.parent.getWorldMatrix());
        else globalPosition = this.position;
        globalPosition.subtractFromFloatsToRef(0, this.ellipsoid.y, 0, this._oldPosition);
        this._oldPosition.addInPlace(this.ellipsoidOffset);
        const coordinator = this.getScene().collisionCoordinator;
        if (!this._collider) this._collider = coordinator.createCollider();
        this._collider._radius = this.ellipsoid;
        this._collider.collisionMask = this._collisionMask;
        // No need for clone, as long as gravity is not on.
        let actualDisplacement = displacement;
        // Add gravity to direction to prevent dual-collision checking.
        if (this.applyGravity) // This prevents mending with cameraDirection, a global variable of the fly camera class.
        actualDisplacement = displacement.add(this.getScene().gravity);
        coordinator.getNewPosition(this._oldPosition, actualDisplacement, this._collider, 3, null, this._onCollisionPositionChange, this.uniqueId);
    }
    /** @internal */ _checkInputs() {
        if (!this._localDirection) {
            this._localDirection = (0, $ha1VO.Vector3).Zero();
            this._transformedDirection = (0, $ha1VO.Vector3).Zero();
        }
        this.inputs.checkInputs();
        super._checkInputs();
    }
    /**
     * Enable movement without a user input. This allows gravity to always be applied.
     */ set needMoveForGravity(value) {
        this._needMoveForGravity = value;
    }
    /**
     * When true, gravity is applied whether there is user input or not.
     */ get needMoveForGravity() {
        return this._needMoveForGravity;
    }
    /** @internal */ _decideIfNeedsToMove() {
        return this._needMoveForGravity || Math.abs(this.cameraDirection.x) > 0 || Math.abs(this.cameraDirection.y) > 0 || Math.abs(this.cameraDirection.z) > 0;
    }
    /** @internal */ _updatePosition() {
        if (this.checkCollisions && this.getScene().collisionsEnabled) this._collideWithWorld(this.cameraDirection);
        else super._updatePosition();
    }
    /**
     * Restore the Roll to its target value at the rate specified.
     * @param rate - Higher means slower restoring.
     * @internal
     */ restoreRoll(rate) {
        const limit = this._trackRoll; // Target Roll.
        const z = this.rotation.z; // Current Roll.
        const delta = limit - z; // Difference in Roll.
        const minRad = 0.001; // Tenth of a radian is a barely noticable difference.
        // If the difference is noticable, restore the Roll.
        if (Math.abs(delta) >= minRad) {
            // Change Z rotation towards the target Roll.
            this.rotation.z += delta / rate;
            // Match when near enough.
            if (Math.abs(limit - this.rotation.z) <= minRad) this.rotation.z = limit;
        }
    }
    /**
     * Destroy the camera and release the current resources held by it.
     */ dispose() {
        this.inputs.clear();
        super.dispose();
    }
    /**
     * Get the current object class name.
     * @returns the class name.
     */ getClassName() {
        return "FlyCamera";
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsVector3)()
], $c0210e5fdda4081b$export$7a60e92629d633a3.prototype, "ellipsoid", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsVector3)()
], $c0210e5fdda4081b$export$7a60e92629d633a3.prototype, "ellipsoidOffset", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $c0210e5fdda4081b$export$7a60e92629d633a3.prototype, "checkCollisions", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $c0210e5fdda4081b$export$7a60e92629d633a3.prototype, "applyGravity", void 0);

});
parcelRegister("23cQH", function(module, exports) {

$parcel$export(module.exports, "FlyCameraInputsManager", () => $17e5d4258f01e5dc$export$1aa43aedaaeadf1);

var $29K1K = parcelRequire("29K1K");

var $loMVr = parcelRequire("loMVr");

var $9gxDr = parcelRequire("9gxDr");
class $17e5d4258f01e5dc$export$1aa43aedaaeadf1 extends (0, $29K1K.CameraInputsManager) {
    /**
     * Instantiates a new FlyCameraInputsManager.
     * @param camera Defines the camera the inputs belong to.
     */ constructor(camera){
        super(camera);
    }
    /**
     * Add keyboard input support to the input manager.
     * @returns the new FlyCameraKeyboardMoveInput().
     */ addKeyboard() {
        this.add(new (0, $9gxDr.FlyCameraKeyboardInput)());
        return this;
    }
    /**
     * Add mouse input support to the input manager.
     * @returns the new FlyCameraMouseInput().
     */ addMouse() {
        this.add(new (0, $loMVr.FlyCameraMouseInput)());
        return this;
    }
}

});


parcelRegister("7Ipbr", function(module, exports) {

$parcel$export(module.exports, "FollowCamera", () => $59e02d6a409c8813$export$8cec341106520756);
$parcel$export(module.exports, "ArcFollowCamera", () => $59e02d6a409c8813$export$bb279e40284b71e9);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $bOhSV = parcelRequire("bOhSV");

var $fJj0G = parcelRequire("fJj0G");

var $ha1VO = parcelRequire("ha1VO");

var $bgssx = parcelRequire("bgssx");

var $9fOIU = parcelRequire("9fOIU");
(0, $bgssx.Node).AddNodeConstructor("FollowCamera", (name, scene)=>{
    return ()=>new $59e02d6a409c8813$export$8cec341106520756(name, (0, $ha1VO.Vector3).Zero(), scene);
});
(0, $bgssx.Node).AddNodeConstructor("ArcFollowCamera", (name, scene)=>{
    return ()=>new $59e02d6a409c8813$export$bb279e40284b71e9(name, 0, 0, 1.0, null, scene);
});
class $59e02d6a409c8813$export$8cec341106520756 extends (0, $fJj0G.TargetCamera) {
    /**
     * Instantiates the follow camera.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_introduction#followcamera
     * @param name Define the name of the camera in the scene
     * @param position Define the position of the camera
     * @param scene Define the scene the camera belong to
     * @param lockedTarget Define the target of the camera
     */ constructor(name, position, scene, lockedTarget = null){
        super(name, position, scene);
        /**
         * Distance the follow camera should follow an object at
         */ this.radius = 12;
        /**
         * Minimum allowed distance of the camera to the axis of rotation
         * (The camera can not get closer).
         * This can help limiting how the Camera is able to move in the scene.
         */ this.lowerRadiusLimit = null;
        /**
         * Maximum allowed distance of the camera to the axis of rotation
         * (The camera can not get further).
         * This can help limiting how the Camera is able to move in the scene.
         */ this.upperRadiusLimit = null;
        /**
         * Define a rotation offset between the camera and the object it follows
         */ this.rotationOffset = 0;
        /**
         * Minimum allowed angle to camera position relative to target object.
         * This can help limiting how the Camera is able to move in the scene.
         */ this.lowerRotationOffsetLimit = null;
        /**
         * Maximum allowed angle to camera position relative to target object.
         * This can help limiting how the Camera is able to move in the scene.
         */ this.upperRotationOffsetLimit = null;
        /**
         * Define a height offset between the camera and the object it follows.
         * It can help following an object from the top (like a car chasing a plane)
         */ this.heightOffset = 4;
        /**
         * Minimum allowed height of camera position relative to target object.
         * This can help limiting how the Camera is able to move in the scene.
         */ this.lowerHeightOffsetLimit = null;
        /**
         * Maximum allowed height of camera position relative to target object.
         * This can help limiting how the Camera is able to move in the scene.
         */ this.upperHeightOffsetLimit = null;
        /**
         * Define how fast the camera can accelerate to follow it s target.
         */ this.cameraAcceleration = 0.05;
        /**
         * Define the speed limit of the camera following an object.
         */ this.maxCameraSpeed = 20;
        this.lockedTarget = lockedTarget;
        this.inputs = new (0, $9fOIU.FollowCameraInputsManager)(this);
        this.inputs.addKeyboard().addMouseWheel().addPointers();
    // Uncomment the following line when the relevant handlers have been implemented.
    // this.inputs.addKeyboard().addMouseWheel().addPointers().addVRDeviceOrientation();
    }
    _follow(cameraTarget) {
        if (!cameraTarget) return;
        const rotMatrix = (0, $ha1VO.TmpVectors).Matrix[0];
        cameraTarget.absoluteRotationQuaternion.toRotationMatrix(rotMatrix);
        const yRotation = Math.atan2(rotMatrix.m[8], rotMatrix.m[10]);
        const radians = (0, $bOhSV.Tools).ToRadians(this.rotationOffset) + yRotation;
        const targetPosition = cameraTarget.getAbsolutePosition();
        const targetX = targetPosition.x + Math.sin(radians) * this.radius;
        const targetZ = targetPosition.z + Math.cos(radians) * this.radius;
        const dx = targetX - this.position.x;
        const dy = targetPosition.y + this.heightOffset - this.position.y;
        const dz = targetZ - this.position.z;
        let vx = dx * this.cameraAcceleration * 2; //this is set to .05
        let vy = dy * this.cameraAcceleration;
        let vz = dz * this.cameraAcceleration * 2;
        if (vx > this.maxCameraSpeed || vx < -this.maxCameraSpeed) vx = vx < 1 ? -this.maxCameraSpeed : this.maxCameraSpeed;
        if (vy > this.maxCameraSpeed || vy < -this.maxCameraSpeed) vy = vy < 1 ? -this.maxCameraSpeed : this.maxCameraSpeed;
        if (vz > this.maxCameraSpeed || vz < -this.maxCameraSpeed) vz = vz < 1 ? -this.maxCameraSpeed : this.maxCameraSpeed;
        this.position = new (0, $ha1VO.Vector3)(this.position.x + vx, this.position.y + vy, this.position.z + vz);
        this.setTarget(targetPosition);
    }
    /**
     * Attached controls to the current camera.
     * @param ignored defines an ignored parameter kept for backward compatibility.
     * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
     */ attachControl(ignored, noPreventDefault) {
        // eslint-disable-next-line prefer-rest-params
        noPreventDefault = (0, $bOhSV.Tools).BackCompatCameraNoPreventDefault(arguments);
        this.inputs.attachElement(noPreventDefault);
        this._reset = ()=>{};
    }
    /**
     * Detach the current controls from the specified dom element.
     */ detachControl() {
        this.inputs.detachElement();
        if (this._reset) this._reset();
    }
    /** @internal */ _checkInputs() {
        this.inputs.checkInputs();
        this._checkLimits();
        super._checkInputs();
        if (this.lockedTarget) this._follow(this.lockedTarget);
    }
    _checkLimits() {
        if (this.lowerRadiusLimit !== null && this.radius < this.lowerRadiusLimit) this.radius = this.lowerRadiusLimit;
        if (this.upperRadiusLimit !== null && this.radius > this.upperRadiusLimit) this.radius = this.upperRadiusLimit;
        if (this.lowerHeightOffsetLimit !== null && this.heightOffset < this.lowerHeightOffsetLimit) this.heightOffset = this.lowerHeightOffsetLimit;
        if (this.upperHeightOffsetLimit !== null && this.heightOffset > this.upperHeightOffsetLimit) this.heightOffset = this.upperHeightOffsetLimit;
        if (this.lowerRotationOffsetLimit !== null && this.rotationOffset < this.lowerRotationOffsetLimit) this.rotationOffset = this.lowerRotationOffsetLimit;
        if (this.upperRotationOffsetLimit !== null && this.rotationOffset > this.upperRotationOffsetLimit) this.rotationOffset = this.upperRotationOffsetLimit;
    }
    /**
     * Gets the camera class name.
     * @returns the class name
     */ getClassName() {
        return "FollowCamera";
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $59e02d6a409c8813$export$8cec341106520756.prototype, "radius", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $59e02d6a409c8813$export$8cec341106520756.prototype, "lowerRadiusLimit", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $59e02d6a409c8813$export$8cec341106520756.prototype, "upperRadiusLimit", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $59e02d6a409c8813$export$8cec341106520756.prototype, "rotationOffset", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $59e02d6a409c8813$export$8cec341106520756.prototype, "lowerRotationOffsetLimit", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $59e02d6a409c8813$export$8cec341106520756.prototype, "upperRotationOffsetLimit", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $59e02d6a409c8813$export$8cec341106520756.prototype, "heightOffset", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $59e02d6a409c8813$export$8cec341106520756.prototype, "lowerHeightOffsetLimit", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $59e02d6a409c8813$export$8cec341106520756.prototype, "upperHeightOffsetLimit", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $59e02d6a409c8813$export$8cec341106520756.prototype, "cameraAcceleration", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $59e02d6a409c8813$export$8cec341106520756.prototype, "maxCameraSpeed", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsMeshReference)("lockedTargetId")
], $59e02d6a409c8813$export$8cec341106520756.prototype, "lockedTarget", void 0);
class $59e02d6a409c8813$export$bb279e40284b71e9 extends (0, $fJj0G.TargetCamera) {
    /**
     * Instantiates a new ArcFollowCamera
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_introduction#followcamera
     * @param name Define the name of the camera
     * @param alpha Define the rotation angle of the camera around the longitudinal axis
     * @param beta Define the rotation angle of the camera around the elevation axis
     * @param radius Define the radius of the camera from its target point
     * @param target Define the target of the camera
     * @param scene Define the scene the camera belongs to
     */ constructor(name, /** The longitudinal angle of the camera */ alpha, /** The latitudinal angle of the camera */ beta, /** The radius of the camera from its target */ radius, /** Define the camera target (the mesh it should follow) */ target, scene){
        super(name, (0, $ha1VO.Vector3).Zero(), scene);
        this.alpha = alpha;
        this.beta = beta;
        this.radius = radius;
        this._cartesianCoordinates = (0, $ha1VO.Vector3).Zero();
        this.setMeshTarget(target);
    }
    /**
     * Sets the mesh to follow with this camera.
     * @param target the target to follow
     */ setMeshTarget(target) {
        this._meshTarget = target;
        this._follow();
    }
    _follow() {
        if (!this._meshTarget) return;
        this._cartesianCoordinates.x = this.radius * Math.cos(this.alpha) * Math.cos(this.beta);
        this._cartesianCoordinates.y = this.radius * Math.sin(this.beta);
        this._cartesianCoordinates.z = this.radius * Math.sin(this.alpha) * Math.cos(this.beta);
        const targetPosition = this._meshTarget.getAbsolutePosition();
        this.position = targetPosition.add(this._cartesianCoordinates);
        this.setTarget(targetPosition);
    }
    /** @internal */ _checkInputs() {
        super._checkInputs();
        this._follow();
    }
    /**
     * Returns the class name of the object.
     * It is mostly used internally for serialization purposes.
     * @returns the class name
     */ getClassName() {
        return "ArcFollowCamera";
    }
}

});
parcelRegister("9fOIU", function(module, exports) {

$parcel$export(module.exports, "FollowCameraInputsManager", () => $6bccdc6257932153$export$12aeb89cfbbffb83);

var $kVtWi = parcelRequire("kVtWi");

var $29K1K = parcelRequire("29K1K");

var $2CmKi = parcelRequire("2CmKi");

var $8SQek = parcelRequire("8SQek");

var $eDb6Y = parcelRequire("eDb6Y");
class $6bccdc6257932153$export$12aeb89cfbbffb83 extends (0, $29K1K.CameraInputsManager) {
    /**
     * Instantiates a new FollowCameraInputsManager.
     * @param camera Defines the camera the inputs belong to
     */ constructor(camera){
        super(camera);
    }
    /**
     * Add keyboard input support to the input manager.
     * @returns the current input manager
     */ addKeyboard() {
        this.add(new (0, $2CmKi.FollowCameraKeyboardMoveInput)());
        return this;
    }
    /**
     * Add mouse wheel input support to the input manager.
     * @returns the current input manager
     */ addMouseWheel() {
        this.add(new (0, $8SQek.FollowCameraMouseWheelInput)());
        return this;
    }
    /**
     * Add pointers input support to the input manager.
     * @returns the current input manager
     */ addPointers() {
        this.add(new (0, $eDb6Y.FollowCameraPointersInput)());
        return this;
    }
    /**
     * Add orientation input support to the input manager.
     * @returns the current input manager
     */ addVRDeviceOrientation() {
        (0, $kVtWi.Logger).Warn("DeviceOrientation support not yet implemented for FollowCamera.");
        return this;
    }
}

});


parcelRegister("3ilrw", function(module, exports) {

$parcel$export(module.exports, "GamepadCamera", () => $2663afa0df7482ff$export$b4afc4a0ce3c9130);

var $765rp = parcelRequire("765rp");

var $ha1VO = parcelRequire("ha1VO");

var $bgssx = parcelRequire("bgssx");
(0, $bgssx.Node).AddNodeConstructor("GamepadCamera", (name, scene)=>{
    return ()=>new $2663afa0df7482ff$export$b4afc4a0ce3c9130(name, (0, $ha1VO.Vector3).Zero(), scene);
});
class $2663afa0df7482ff$export$b4afc4a0ce3c9130 extends (0, $765rp.UniversalCamera) {
    /**
     * Instantiates a new Gamepad Camera
     * This represents a FPS type of camera. This is only here for back compat purpose.
     * Please use the UniversalCamera instead as both are identical.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_introduction#universal-camera
     * @param name Define the name of the camera in the scene
     * @param position Define the start position of the camera in the scene
     * @param scene Define the scene the camera belongs to
     */ constructor(name, position, scene){
        super(name, position, scene);
    }
    /**
     * Gets the current object class name.
     * @returns the class name
     */ getClassName() {
        return "GamepadCamera";
    }
}

});
parcelRegister("765rp", function(module, exports) {

$parcel$export(module.exports, "UniversalCamera", () => $52ad5073807df447$export$3a4752d663d87d1a);

var $8i1MZ = parcelRequire("8i1MZ");

var $bgssx = parcelRequire("bgssx");

var $ha1VO = parcelRequire("ha1VO");

var $74SKQ = parcelRequire("74SKQ");
parcelRequire("6VDMQ");
(0, $bgssx.Node).AddNodeConstructor("FreeCamera", (name, scene)=>{
    // Forcing to use the Universal camera
    return ()=>new $52ad5073807df447$export$3a4752d663d87d1a(name, (0, $ha1VO.Vector3).Zero(), scene);
});
class $52ad5073807df447$export$3a4752d663d87d1a extends (0, $8i1MZ.TouchCamera) {
    /**
     * Defines the gamepad rotation sensibility.
     * This is the threshold from when rotation starts to be accounted for to prevent jittering.
     */ get gamepadAngularSensibility() {
        const gamepad = this.inputs.attached["gamepad"];
        if (gamepad) return gamepad.gamepadAngularSensibility;
        return 0;
    }
    set gamepadAngularSensibility(value) {
        const gamepad = this.inputs.attached["gamepad"];
        if (gamepad) gamepad.gamepadAngularSensibility = value;
    }
    /**
     * Defines the gamepad move sensibility.
     * This is the threshold from when moving starts to be accounted for to prevent jittering.
     */ get gamepadMoveSensibility() {
        const gamepad = this.inputs.attached["gamepad"];
        if (gamepad) return gamepad.gamepadMoveSensibility;
        return 0;
    }
    set gamepadMoveSensibility(value) {
        const gamepad = this.inputs.attached["gamepad"];
        if (gamepad) gamepad.gamepadMoveSensibility = value;
    }
    /**
     * The Universal Camera is the one to choose for first person shooter type games, and works with all the keyboard, mouse, touch and gamepads. This replaces the earlier Free Camera,
     * which still works and will still be found in many Playgrounds.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_introduction#universal-camera
     * @param name Define the name of the camera in the scene
     * @param position Define the start position of the camera in the scene
     * @param scene Define the scene the camera belongs to
     */ constructor(name, position, scene){
        super(name, position, scene);
        this.inputs.addGamepad();
    }
    /**
     * Gets the current object class name.
     * @returns the class name
     */ getClassName() {
        return "UniversalCamera";
    }
}
(0, $74SKQ.Camera)._CreateDefaultParsedCamera = (name, scene)=>{
    return new $52ad5073807df447$export$3a4752d663d87d1a(name, (0, $ha1VO.Vector3).Zero(), scene);
};

});
parcelRegister("6VDMQ", function(module, exports) {

$parcel$export(module.exports, "GamepadSystemSceneComponent", () => $50b6edc5685bb992$export$895deb43ba314b20);

var $gmbCk = parcelRequire("gmbCk");

var $bv05l = parcelRequire("bv05l");

var $eIug0 = parcelRequire("eIug0");

var $8TToC = parcelRequire("8TToC");

var $kFqWT = parcelRequire("kFqWT");

var $gotsS = parcelRequire("gotsS");

var $lQrRY = parcelRequire("lQrRY");
Object.defineProperty((0, $gmbCk.Scene).prototype, "gamepadManager", {
    get: function() {
        if (!this._gamepadManager) {
            this._gamepadManager = new (0, $eIug0.GamepadManager)(this);
            let component = this._getComponent((0, $bv05l.SceneComponentConstants).NAME_GAMEPAD);
            if (!component) {
                component = new $50b6edc5685bb992$export$895deb43ba314b20(this);
                this._addComponent(component);
            }
        }
        return this._gamepadManager;
    },
    enumerable: true,
    configurable: true
});
/**
 * Adds a gamepad to the free camera inputs manager
 * @returns the FreeCameraInputsManager
 */ (0, $8TToC.FreeCameraInputsManager).prototype.addGamepad = function() {
    this.add(new (0, $kFqWT.FreeCameraGamepadInput)());
    return this;
};
/**
 * Adds a gamepad to the arc rotate camera inputs manager
 * @returns the camera inputs manager
 */ (0, $gotsS.ArcRotateCameraInputsManager).prototype.addGamepad = function() {
    this.add(new (0, $lQrRY.ArcRotateCameraGamepadInput)());
    return this;
};
class $50b6edc5685bb992$export$895deb43ba314b20 {
    /**
     * Creates a new instance of the component for the given scene
     * @param scene Defines the scene to register the component in
     */ constructor(scene){
        /**
         * The component name helpfull to identify the component in the list of scene components.
         */ this.name = (0, $bv05l.SceneComponentConstants).NAME_GAMEPAD;
        this.scene = scene;
    }
    /**
     * Registers the component in a given scene
     */ register() {
        this.scene._beforeCameraUpdateStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_BEFORECAMERAUPDATE_GAMEPAD, this, this._beforeCameraUpdate);
    }
    /**
     * Rebuilds the elements related to this component in case of
     * context lost for instance.
     */ rebuild() {
    // Nothing to do for gamepads
    }
    /**
     * Disposes the component and the associated resources
     */ dispose() {
        const gamepadManager = this.scene._gamepadManager;
        if (gamepadManager) {
            gamepadManager.dispose();
            this.scene._gamepadManager = null;
        }
    }
    _beforeCameraUpdate() {
        const gamepadManager = this.scene._gamepadManager;
        if (gamepadManager && gamepadManager._isMonitoring) gamepadManager._checkGamepadsStatus();
    }
}

});
parcelRegister("eIug0", function(module, exports) {

$parcel$export(module.exports, "GamepadManager", () => $ab6ca53589740f17$export$58de03bd41c27b2e);

var $diGQf = parcelRequire("diGQf");

var $jFz47 = parcelRequire("jFz47");

var $3OBdT = parcelRequire("3OBdT");

var $6gZ9Y = parcelRequire("6gZ9Y");

var $5YkyR = parcelRequire("5YkyR");

var $hndSS = parcelRequire("hndSS");

var $bOhSV = parcelRequire("bOhSV");
class $ab6ca53589740f17$export$58de03bd41c27b2e {
    /**
     * Initializes the gamepad manager
     * @param _scene BabylonJS scene
     */ constructor(_scene){
        this._scene = _scene;
        this._babylonGamepads = [];
        this._oneGamepadConnected = false;
        /** @internal */ this._isMonitoring = false;
        /**
         * observable to be triggered when the gamepad controller has been disconnected
         */ this.onGamepadDisconnectedObservable = new (0, $diGQf.Observable)();
        if (!(0, $jFz47.IsWindowObjectExist)()) this._gamepadEventSupported = false;
        else {
            this._gamepadEventSupported = "GamepadEvent" in window;
            this._gamepadSupport = navigator && navigator.getGamepads;
        }
        this.onGamepadConnectedObservable = new (0, $diGQf.Observable)((observer)=>{
            // This will be used to raise the onGamepadConnected for all gamepads ALREADY connected
            for(const i in this._babylonGamepads){
                const gamepad = this._babylonGamepads[i];
                if (gamepad && gamepad._isConnected) this.onGamepadConnectedObservable.notifyObserver(observer, gamepad);
            }
        });
        this._onGamepadConnectedEvent = (evt)=>{
            const gamepad = evt.gamepad;
            if (gamepad.index in this._babylonGamepads) {
                if (this._babylonGamepads[gamepad.index].isConnected) return;
            }
            let newGamepad;
            if (this._babylonGamepads[gamepad.index]) {
                newGamepad = this._babylonGamepads[gamepad.index];
                newGamepad.browserGamepad = gamepad;
                newGamepad._isConnected = true;
            } else newGamepad = this._addNewGamepad(gamepad);
            this.onGamepadConnectedObservable.notifyObservers(newGamepad);
            this._startMonitoringGamepads();
        };
        this._onGamepadDisconnectedEvent = (evt)=>{
            const gamepad = evt.gamepad;
            // Remove the gamepad from the list of gamepads to monitor.
            for(const i in this._babylonGamepads)if (this._babylonGamepads[i].index === gamepad.index) {
                const disconnectedGamepad = this._babylonGamepads[i];
                disconnectedGamepad._isConnected = false;
                this.onGamepadDisconnectedObservable.notifyObservers(disconnectedGamepad);
                disconnectedGamepad.dispose && disconnectedGamepad.dispose();
                break;
            }
        };
        if (this._gamepadSupport) {
            //first add already-connected gamepads
            this._updateGamepadObjects();
            if (this._babylonGamepads.length) this._startMonitoringGamepads();
            // Checking if the gamepad connected event is supported (like in Firefox)
            if (this._gamepadEventSupported) {
                const hostWindow = this._scene ? this._scene.getEngine().getHostWindow() : window;
                if (hostWindow) {
                    hostWindow.addEventListener("gamepadconnected", this._onGamepadConnectedEvent, false);
                    hostWindow.addEventListener("gamepaddisconnected", this._onGamepadDisconnectedEvent, false);
                }
            } else this._startMonitoringGamepads();
        }
    }
    /**
     * The gamepads in the game pad manager
     */ get gamepads() {
        return this._babylonGamepads;
    }
    /**
     * Get the gamepad controllers based on type
     * @param type The type of gamepad controller
     * @returns Nullable gamepad
     */ getGamepadByType(type = (0, $6gZ9Y.Gamepad).XBOX) {
        for (const gamepad of this._babylonGamepads){
            if (gamepad && gamepad.type === type) return gamepad;
        }
        return null;
    }
    /**
     * Disposes the gamepad manager
     */ dispose() {
        if (this._gamepadEventSupported) {
            if (this._onGamepadConnectedEvent) window.removeEventListener("gamepadconnected", this._onGamepadConnectedEvent);
            if (this._onGamepadDisconnectedEvent) window.removeEventListener("gamepaddisconnected", this._onGamepadDisconnectedEvent);
            this._onGamepadConnectedEvent = null;
            this._onGamepadDisconnectedEvent = null;
        }
        this._babylonGamepads.forEach((gamepad)=>{
            gamepad.dispose();
        });
        this.onGamepadConnectedObservable.clear();
        this.onGamepadDisconnectedObservable.clear();
        this._oneGamepadConnected = false;
        this._stopMonitoringGamepads();
        this._babylonGamepads = [];
    }
    _addNewGamepad(gamepad) {
        if (!this._oneGamepadConnected) this._oneGamepadConnected = true;
        let newGamepad;
        const dualShock = gamepad.id.search("054c") !== -1 && gamepad.id.search("0ce6") === -1;
        const xboxOne = gamepad.id.search("Xbox One") !== -1;
        if (xboxOne || gamepad.id.search("Xbox 360") !== -1 || gamepad.id.search("xinput") !== -1 || gamepad.id.search("045e") !== -1 && gamepad.id.search("Surface Dock") === -1) // make sure the Surface Dock Extender is not detected as an xbox controller
        newGamepad = new (0, $3OBdT.Xbox360Pad)(gamepad.id, gamepad.index, gamepad, xboxOne);
        else if (dualShock) newGamepad = new (0, $hndSS.DualShockPad)(gamepad.id, gamepad.index, gamepad);
        else newGamepad = new (0, $6gZ9Y.GenericPad)(gamepad.id, gamepad.index, gamepad);
        this._babylonGamepads[newGamepad.index] = newGamepad;
        return newGamepad;
    }
    _startMonitoringGamepads() {
        if (!this._isMonitoring) {
            this._isMonitoring = true;
            //back-comp
            this._checkGamepadsStatus();
        }
    }
    _stopMonitoringGamepads() {
        this._isMonitoring = false;
    }
    /** @internal */ _checkGamepadsStatus() {
        // Hack to be compatible Chrome
        this._updateGamepadObjects();
        for(const i in this._babylonGamepads){
            const gamepad = this._babylonGamepads[i];
            if (!gamepad || !gamepad.isConnected) continue;
            try {
                gamepad.update();
            } catch  {
                if (this._loggedErrors.indexOf(gamepad.index) === -1) {
                    (0, $bOhSV.Tools).Warn(`Error updating gamepad ${gamepad.id}`);
                    this._loggedErrors.push(gamepad.index);
                }
            }
        }
        if (this._isMonitoring) (0, $5YkyR.Engine).QueueNewFrame(()=>{
            this._checkGamepadsStatus();
        });
    }
    // This function is called only on Chrome, which does not properly support
    // connection/disconnection events and forces you to recopy again the gamepad object
    _updateGamepadObjects() {
        const gamepads = navigator.getGamepads ? navigator.getGamepads() : [];
        for(let i = 0; i < gamepads.length; i++){
            const gamepad = gamepads[i];
            if (gamepad) {
                if (!this._babylonGamepads[gamepad.index]) {
                    const newGamepad = this._addNewGamepad(gamepad);
                    this.onGamepadConnectedObservable.notifyObservers(newGamepad);
                } else {
                    // Forced to copy again this object for Chrome for unknown reason
                    this._babylonGamepads[i].browserGamepad = gamepad;
                    if (!this._babylonGamepads[i].isConnected) {
                        this._babylonGamepads[i]._isConnected = true;
                        this.onGamepadConnectedObservable.notifyObservers(this._babylonGamepads[i]);
                    }
                }
            }
        }
    }
}

});
parcelRegister("3OBdT", function(module, exports) {

$parcel$export(module.exports, "Xbox360Button", () => $2c72ea576472b0fa$export$29893bfa4a7ecda9);
$parcel$export(module.exports, "Xbox360Dpad", () => $2c72ea576472b0fa$export$e31b65f6020cc54f);
$parcel$export(module.exports, "Xbox360Pad", () => $2c72ea576472b0fa$export$837aa5833406d764);

var $diGQf = parcelRequire("diGQf");

var $6gZ9Y = parcelRequire("6gZ9Y");
var $2c72ea576472b0fa$export$29893bfa4a7ecda9;
(function(Xbox360Button) {
    /** A */ Xbox360Button[Xbox360Button["A"] = 0] = "A";
    /** B */ Xbox360Button[Xbox360Button["B"] = 1] = "B";
    /** X */ Xbox360Button[Xbox360Button["X"] = 2] = "X";
    /** Y */ Xbox360Button[Xbox360Button["Y"] = 3] = "Y";
    /** Left button */ Xbox360Button[Xbox360Button["LB"] = 4] = "LB";
    /** Right button */ Xbox360Button[Xbox360Button["RB"] = 5] = "RB";
    /** Back */ Xbox360Button[Xbox360Button["Back"] = 8] = "Back";
    /** Start */ Xbox360Button[Xbox360Button["Start"] = 9] = "Start";
    /** Left stick */ Xbox360Button[Xbox360Button["LeftStick"] = 10] = "LeftStick";
    /** Right stick */ Xbox360Button[Xbox360Button["RightStick"] = 11] = "RightStick";
})($2c72ea576472b0fa$export$29893bfa4a7ecda9 || ($2c72ea576472b0fa$export$29893bfa4a7ecda9 = {}));
var $2c72ea576472b0fa$export$e31b65f6020cc54f;
(function(Xbox360Dpad) {
    /** Up */ Xbox360Dpad[Xbox360Dpad["Up"] = 12] = "Up";
    /** Down */ Xbox360Dpad[Xbox360Dpad["Down"] = 13] = "Down";
    /** Left */ Xbox360Dpad[Xbox360Dpad["Left"] = 14] = "Left";
    /** Right */ Xbox360Dpad[Xbox360Dpad["Right"] = 15] = "Right";
})($2c72ea576472b0fa$export$e31b65f6020cc54f || ($2c72ea576472b0fa$export$e31b65f6020cc54f = {}));
class $2c72ea576472b0fa$export$837aa5833406d764 extends (0, $6gZ9Y.Gamepad) {
    /**
     * Creates a new XBox360 gamepad object
     * @param id defines the id of this gamepad
     * @param index defines its index
     * @param gamepad defines the internal HTML gamepad object
     * @param xboxOne defines if it is a XBox One gamepad
     */ constructor(id, index, gamepad, xboxOne = false){
        super(id, index, gamepad, 0, 1, 2, 3);
        this._leftTrigger = 0;
        this._rightTrigger = 0;
        /** Observable raised when a button is pressed */ this.onButtonDownObservable = new (0, $diGQf.Observable)();
        /** Observable raised when a button is released */ this.onButtonUpObservable = new (0, $diGQf.Observable)();
        /** Observable raised when a pad is pressed */ this.onPadDownObservable = new (0, $diGQf.Observable)();
        /** Observable raised when a pad is released */ this.onPadUpObservable = new (0, $diGQf.Observable)();
        this._buttonA = 0;
        this._buttonB = 0;
        this._buttonX = 0;
        this._buttonY = 0;
        this._buttonBack = 0;
        this._buttonStart = 0;
        this._buttonLB = 0;
        this._buttonRB = 0;
        this._buttonLeftStick = 0;
        this._buttonRightStick = 0;
        this._dPadUp = 0;
        this._dPadDown = 0;
        this._dPadLeft = 0;
        this._dPadRight = 0;
        this._isXboxOnePad = false;
        this.type = (0, $6gZ9Y.Gamepad).XBOX;
        this._isXboxOnePad = xboxOne;
    }
    /**
     * Defines the callback to call when left trigger is pressed
     * @param callback defines the callback to use
     */ onlefttriggerchanged(callback) {
        this._onlefttriggerchanged = callback;
    }
    /**
     * Defines the callback to call when right trigger is pressed
     * @param callback defines the callback to use
     */ onrighttriggerchanged(callback) {
        this._onrighttriggerchanged = callback;
    }
    /**
     * Gets the left trigger value
     */ get leftTrigger() {
        return this._leftTrigger;
    }
    /**
     * Sets the left trigger value
     */ set leftTrigger(newValue) {
        if (this._onlefttriggerchanged && this._leftTrigger !== newValue) this._onlefttriggerchanged(newValue);
        this._leftTrigger = newValue;
    }
    /**
     * Gets the right trigger value
     */ get rightTrigger() {
        return this._rightTrigger;
    }
    /**
     * Sets the right trigger value
     */ set rightTrigger(newValue) {
        if (this._onrighttriggerchanged && this._rightTrigger !== newValue) this._onrighttriggerchanged(newValue);
        this._rightTrigger = newValue;
    }
    /**
     * Defines the callback to call when a button is pressed
     * @param callback defines the callback to use
     */ onbuttondown(callback) {
        this._onbuttondown = callback;
    }
    /**
     * Defines the callback to call when a button is released
     * @param callback defines the callback to use
     */ onbuttonup(callback) {
        this._onbuttonup = callback;
    }
    /**
     * Defines the callback to call when a pad is pressed
     * @param callback defines the callback to use
     */ ondpaddown(callback) {
        this._ondpaddown = callback;
    }
    /**
     * Defines the callback to call when a pad is released
     * @param callback defines the callback to use
     */ ondpadup(callback) {
        this._ondpadup = callback;
    }
    _setButtonValue(newValue, currentValue, buttonType) {
        if (newValue !== currentValue) {
            if (newValue === 1) {
                if (this._onbuttondown) this._onbuttondown(buttonType);
                this.onButtonDownObservable.notifyObservers(buttonType);
            }
            if (newValue === 0) {
                if (this._onbuttonup) this._onbuttonup(buttonType);
                this.onButtonUpObservable.notifyObservers(buttonType);
            }
        }
        return newValue;
    }
    _setDPadValue(newValue, currentValue, buttonType) {
        if (newValue !== currentValue) {
            if (newValue === 1) {
                if (this._ondpaddown) this._ondpaddown(buttonType);
                this.onPadDownObservable.notifyObservers(buttonType);
            }
            if (newValue === 0) {
                if (this._ondpadup) this._ondpadup(buttonType);
                this.onPadUpObservable.notifyObservers(buttonType);
            }
        }
        return newValue;
    }
    /**
     * Gets the value of the `A` button
     */ get buttonA() {
        return this._buttonA;
    }
    /**
     * Sets the value of the `A` button
     */ set buttonA(value) {
        this._buttonA = this._setButtonValue(value, this._buttonA, $2c72ea576472b0fa$export$29893bfa4a7ecda9.A);
    }
    /**
     * Gets the value of the `B` button
     */ get buttonB() {
        return this._buttonB;
    }
    /**
     * Sets the value of the `B` button
     */ set buttonB(value) {
        this._buttonB = this._setButtonValue(value, this._buttonB, $2c72ea576472b0fa$export$29893bfa4a7ecda9.B);
    }
    /**
     * Gets the value of the `X` button
     */ get buttonX() {
        return this._buttonX;
    }
    /**
     * Sets the value of the `X` button
     */ set buttonX(value) {
        this._buttonX = this._setButtonValue(value, this._buttonX, $2c72ea576472b0fa$export$29893bfa4a7ecda9.X);
    }
    /**
     * Gets the value of the `Y` button
     */ get buttonY() {
        return this._buttonY;
    }
    /**
     * Sets the value of the `Y` button
     */ set buttonY(value) {
        this._buttonY = this._setButtonValue(value, this._buttonY, $2c72ea576472b0fa$export$29893bfa4a7ecda9.Y);
    }
    /**
     * Gets the value of the `Start` button
     */ get buttonStart() {
        return this._buttonStart;
    }
    /**
     * Sets the value of the `Start` button
     */ set buttonStart(value) {
        this._buttonStart = this._setButtonValue(value, this._buttonStart, $2c72ea576472b0fa$export$29893bfa4a7ecda9.Start);
    }
    /**
     * Gets the value of the `Back` button
     */ get buttonBack() {
        return this._buttonBack;
    }
    /**
     * Sets the value of the `Back` button
     */ set buttonBack(value) {
        this._buttonBack = this._setButtonValue(value, this._buttonBack, $2c72ea576472b0fa$export$29893bfa4a7ecda9.Back);
    }
    /**
     * Gets the value of the `Left` button
     */ get buttonLB() {
        return this._buttonLB;
    }
    /**
     * Sets the value of the `Left` button
     */ set buttonLB(value) {
        this._buttonLB = this._setButtonValue(value, this._buttonLB, $2c72ea576472b0fa$export$29893bfa4a7ecda9.LB);
    }
    /**
     * Gets the value of the `Right` button
     */ get buttonRB() {
        return this._buttonRB;
    }
    /**
     * Sets the value of the `Right` button
     */ set buttonRB(value) {
        this._buttonRB = this._setButtonValue(value, this._buttonRB, $2c72ea576472b0fa$export$29893bfa4a7ecda9.RB);
    }
    /**
     * Gets the value of the Left joystick
     */ get buttonLeftStick() {
        return this._buttonLeftStick;
    }
    /**
     * Sets the value of the Left joystick
     */ set buttonLeftStick(value) {
        this._buttonLeftStick = this._setButtonValue(value, this._buttonLeftStick, $2c72ea576472b0fa$export$29893bfa4a7ecda9.LeftStick);
    }
    /**
     * Gets the value of the Right joystick
     */ get buttonRightStick() {
        return this._buttonRightStick;
    }
    /**
     * Sets the value of the Right joystick
     */ set buttonRightStick(value) {
        this._buttonRightStick = this._setButtonValue(value, this._buttonRightStick, $2c72ea576472b0fa$export$29893bfa4a7ecda9.RightStick);
    }
    /**
     * Gets the value of D-pad up
     */ get dPadUp() {
        return this._dPadUp;
    }
    /**
     * Sets the value of D-pad up
     */ set dPadUp(value) {
        this._dPadUp = this._setDPadValue(value, this._dPadUp, $2c72ea576472b0fa$export$e31b65f6020cc54f.Up);
    }
    /**
     * Gets the value of D-pad down
     */ get dPadDown() {
        return this._dPadDown;
    }
    /**
     * Sets the value of D-pad down
     */ set dPadDown(value) {
        this._dPadDown = this._setDPadValue(value, this._dPadDown, $2c72ea576472b0fa$export$e31b65f6020cc54f.Down);
    }
    /**
     * Gets the value of D-pad left
     */ get dPadLeft() {
        return this._dPadLeft;
    }
    /**
     * Sets the value of D-pad left
     */ set dPadLeft(value) {
        this._dPadLeft = this._setDPadValue(value, this._dPadLeft, $2c72ea576472b0fa$export$e31b65f6020cc54f.Left);
    }
    /**
     * Gets the value of D-pad right
     */ get dPadRight() {
        return this._dPadRight;
    }
    /**
     * Sets the value of D-pad right
     */ set dPadRight(value) {
        this._dPadRight = this._setDPadValue(value, this._dPadRight, $2c72ea576472b0fa$export$e31b65f6020cc54f.Right);
    }
    /**
     * Force the gamepad to synchronize with device values
     */ update() {
        super.update();
        if (this._isXboxOnePad) {
            this.buttonA = this.browserGamepad.buttons[0].value;
            this.buttonB = this.browserGamepad.buttons[1].value;
            this.buttonX = this.browserGamepad.buttons[2].value;
            this.buttonY = this.browserGamepad.buttons[3].value;
            this.buttonLB = this.browserGamepad.buttons[4].value;
            this.buttonRB = this.browserGamepad.buttons[5].value;
            this.leftTrigger = this.browserGamepad.buttons[6].value;
            this.rightTrigger = this.browserGamepad.buttons[7].value;
            this.buttonBack = this.browserGamepad.buttons[8].value;
            this.buttonStart = this.browserGamepad.buttons[9].value;
            this.buttonLeftStick = this.browserGamepad.buttons[10].value;
            this.buttonRightStick = this.browserGamepad.buttons[11].value;
            this.dPadUp = this.browserGamepad.buttons[12].value;
            this.dPadDown = this.browserGamepad.buttons[13].value;
            this.dPadLeft = this.browserGamepad.buttons[14].value;
            this.dPadRight = this.browserGamepad.buttons[15].value;
        } else {
            this.buttonA = this.browserGamepad.buttons[0].value;
            this.buttonB = this.browserGamepad.buttons[1].value;
            this.buttonX = this.browserGamepad.buttons[2].value;
            this.buttonY = this.browserGamepad.buttons[3].value;
            this.buttonLB = this.browserGamepad.buttons[4].value;
            this.buttonRB = this.browserGamepad.buttons[5].value;
            this.leftTrigger = this.browserGamepad.buttons[6].value;
            this.rightTrigger = this.browserGamepad.buttons[7].value;
            this.buttonBack = this.browserGamepad.buttons[8].value;
            this.buttonStart = this.browserGamepad.buttons[9].value;
            this.buttonLeftStick = this.browserGamepad.buttons[10].value;
            this.buttonRightStick = this.browserGamepad.buttons[11].value;
            this.dPadUp = this.browserGamepad.buttons[12].value;
            this.dPadDown = this.browserGamepad.buttons[13].value;
            this.dPadLeft = this.browserGamepad.buttons[14].value;
            this.dPadRight = this.browserGamepad.buttons[15].value;
        }
    }
    /**
     * Disposes the gamepad
     */ dispose() {
        super.dispose();
        this.onButtonDownObservable.clear();
        this.onButtonUpObservable.clear();
        this.onPadDownObservable.clear();
        this.onPadUpObservable.clear();
    }
}

});

parcelRegister("hndSS", function(module, exports) {

$parcel$export(module.exports, "DualShockButton", () => $ca5f5abac3e9b713$export$e9a088793c3dd817);
$parcel$export(module.exports, "DualShockDpad", () => $ca5f5abac3e9b713$export$c66ef8d75a8724ce);
$parcel$export(module.exports, "DualShockPad", () => $ca5f5abac3e9b713$export$ed279e5193a6bba);

var $diGQf = parcelRequire("diGQf");

var $6gZ9Y = parcelRequire("6gZ9Y");
var $ca5f5abac3e9b713$export$e9a088793c3dd817;
(function(DualShockButton) {
    /** Cross */ DualShockButton[DualShockButton["Cross"] = 0] = "Cross";
    /** Circle */ DualShockButton[DualShockButton["Circle"] = 1] = "Circle";
    /** Square */ DualShockButton[DualShockButton["Square"] = 2] = "Square";
    /** Triangle */ DualShockButton[DualShockButton["Triangle"] = 3] = "Triangle";
    /** L1 */ DualShockButton[DualShockButton["L1"] = 4] = "L1";
    /** R1 */ DualShockButton[DualShockButton["R1"] = 5] = "R1";
    /** Share */ DualShockButton[DualShockButton["Share"] = 8] = "Share";
    /** Options */ DualShockButton[DualShockButton["Options"] = 9] = "Options";
    /** Left stick */ DualShockButton[DualShockButton["LeftStick"] = 10] = "LeftStick";
    /** Right stick */ DualShockButton[DualShockButton["RightStick"] = 11] = "RightStick";
})($ca5f5abac3e9b713$export$e9a088793c3dd817 || ($ca5f5abac3e9b713$export$e9a088793c3dd817 = {}));
var $ca5f5abac3e9b713$export$c66ef8d75a8724ce;
(function(DualShockDpad) {
    /** Up */ DualShockDpad[DualShockDpad["Up"] = 12] = "Up";
    /** Down */ DualShockDpad[DualShockDpad["Down"] = 13] = "Down";
    /** Left */ DualShockDpad[DualShockDpad["Left"] = 14] = "Left";
    /** Right */ DualShockDpad[DualShockDpad["Right"] = 15] = "Right";
})($ca5f5abac3e9b713$export$c66ef8d75a8724ce || ($ca5f5abac3e9b713$export$c66ef8d75a8724ce = {}));
class $ca5f5abac3e9b713$export$ed279e5193a6bba extends (0, $6gZ9Y.Gamepad) {
    /**
     * Creates a new DualShock gamepad object
     * @param id defines the id of this gamepad
     * @param index defines its index
     * @param gamepad defines the internal HTML gamepad object
     */ constructor(id, index, gamepad){
        super(id.replace("STANDARD GAMEPAD", "SONY PLAYSTATION DUALSHOCK"), index, gamepad, 0, 1, 2, 3);
        this._leftTrigger = 0;
        this._rightTrigger = 0;
        /** Observable raised when a button is pressed */ this.onButtonDownObservable = new (0, $diGQf.Observable)();
        /** Observable raised when a button is released */ this.onButtonUpObservable = new (0, $diGQf.Observable)();
        /** Observable raised when a pad is pressed */ this.onPadDownObservable = new (0, $diGQf.Observable)();
        /** Observable raised when a pad is released */ this.onPadUpObservable = new (0, $diGQf.Observable)();
        this._buttonCross = 0;
        this._buttonCircle = 0;
        this._buttonSquare = 0;
        this._buttonTriangle = 0;
        this._buttonShare = 0;
        this._buttonOptions = 0;
        this._buttonL1 = 0;
        this._buttonR1 = 0;
        this._buttonLeftStick = 0;
        this._buttonRightStick = 0;
        this._dPadUp = 0;
        this._dPadDown = 0;
        this._dPadLeft = 0;
        this._dPadRight = 0;
        this.type = (0, $6gZ9Y.Gamepad).DUALSHOCK;
    }
    /**
     * Defines the callback to call when left trigger is pressed
     * @param callback defines the callback to use
     */ onlefttriggerchanged(callback) {
        this._onlefttriggerchanged = callback;
    }
    /**
     * Defines the callback to call when right trigger is pressed
     * @param callback defines the callback to use
     */ onrighttriggerchanged(callback) {
        this._onrighttriggerchanged = callback;
    }
    /**
     * Gets the left trigger value
     */ get leftTrigger() {
        return this._leftTrigger;
    }
    /**
     * Sets the left trigger value
     */ set leftTrigger(newValue) {
        if (this._onlefttriggerchanged && this._leftTrigger !== newValue) this._onlefttriggerchanged(newValue);
        this._leftTrigger = newValue;
    }
    /**
     * Gets the right trigger value
     */ get rightTrigger() {
        return this._rightTrigger;
    }
    /**
     * Sets the right trigger value
     */ set rightTrigger(newValue) {
        if (this._onrighttriggerchanged && this._rightTrigger !== newValue) this._onrighttriggerchanged(newValue);
        this._rightTrigger = newValue;
    }
    /**
     * Defines the callback to call when a button is pressed
     * @param callback defines the callback to use
     */ onbuttondown(callback) {
        this._onbuttondown = callback;
    }
    /**
     * Defines the callback to call when a button is released
     * @param callback defines the callback to use
     */ onbuttonup(callback) {
        this._onbuttonup = callback;
    }
    /**
     * Defines the callback to call when a pad is pressed
     * @param callback defines the callback to use
     */ ondpaddown(callback) {
        this._ondpaddown = callback;
    }
    /**
     * Defines the callback to call when a pad is released
     * @param callback defines the callback to use
     */ ondpadup(callback) {
        this._ondpadup = callback;
    }
    _setButtonValue(newValue, currentValue, buttonType) {
        if (newValue !== currentValue) {
            if (newValue === 1) {
                if (this._onbuttondown) this._onbuttondown(buttonType);
                this.onButtonDownObservable.notifyObservers(buttonType);
            }
            if (newValue === 0) {
                if (this._onbuttonup) this._onbuttonup(buttonType);
                this.onButtonUpObservable.notifyObservers(buttonType);
            }
        }
        return newValue;
    }
    _setDPadValue(newValue, currentValue, buttonType) {
        if (newValue !== currentValue) {
            if (newValue === 1) {
                if (this._ondpaddown) this._ondpaddown(buttonType);
                this.onPadDownObservable.notifyObservers(buttonType);
            }
            if (newValue === 0) {
                if (this._ondpadup) this._ondpadup(buttonType);
                this.onPadUpObservable.notifyObservers(buttonType);
            }
        }
        return newValue;
    }
    /**
     * Gets the value of the `Cross` button
     */ get buttonCross() {
        return this._buttonCross;
    }
    /**
     * Sets the value of the `Cross` button
     */ set buttonCross(value) {
        this._buttonCross = this._setButtonValue(value, this._buttonCross, $ca5f5abac3e9b713$export$e9a088793c3dd817.Cross);
    }
    /**
     * Gets the value of the `Circle` button
     */ get buttonCircle() {
        return this._buttonCircle;
    }
    /**
     * Sets the value of the `Circle` button
     */ set buttonCircle(value) {
        this._buttonCircle = this._setButtonValue(value, this._buttonCircle, $ca5f5abac3e9b713$export$e9a088793c3dd817.Circle);
    }
    /**
     * Gets the value of the `Square` button
     */ get buttonSquare() {
        return this._buttonSquare;
    }
    /**
     * Sets the value of the `Square` button
     */ set buttonSquare(value) {
        this._buttonSquare = this._setButtonValue(value, this._buttonSquare, $ca5f5abac3e9b713$export$e9a088793c3dd817.Square);
    }
    /**
     * Gets the value of the `Triangle` button
     */ get buttonTriangle() {
        return this._buttonTriangle;
    }
    /**
     * Sets the value of the `Triangle` button
     */ set buttonTriangle(value) {
        this._buttonTriangle = this._setButtonValue(value, this._buttonTriangle, $ca5f5abac3e9b713$export$e9a088793c3dd817.Triangle);
    }
    /**
     * Gets the value of the `Options` button
     */ get buttonOptions() {
        return this._buttonOptions;
    }
    /**
     * Sets the value of the `Options` button
     */ set buttonOptions(value) {
        this._buttonOptions = this._setButtonValue(value, this._buttonOptions, $ca5f5abac3e9b713$export$e9a088793c3dd817.Options);
    }
    /**
     * Gets the value of the `Share` button
     */ get buttonShare() {
        return this._buttonShare;
    }
    /**
     * Sets the value of the `Share` button
     */ set buttonShare(value) {
        this._buttonShare = this._setButtonValue(value, this._buttonShare, $ca5f5abac3e9b713$export$e9a088793c3dd817.Share);
    }
    /**
     * Gets the value of the `L1` button
     */ get buttonL1() {
        return this._buttonL1;
    }
    /**
     * Sets the value of the `L1` button
     */ set buttonL1(value) {
        this._buttonL1 = this._setButtonValue(value, this._buttonL1, $ca5f5abac3e9b713$export$e9a088793c3dd817.L1);
    }
    /**
     * Gets the value of the `R1` button
     */ get buttonR1() {
        return this._buttonR1;
    }
    /**
     * Sets the value of the `R1` button
     */ set buttonR1(value) {
        this._buttonR1 = this._setButtonValue(value, this._buttonR1, $ca5f5abac3e9b713$export$e9a088793c3dd817.R1);
    }
    /**
     * Gets the value of the Left joystick
     */ get buttonLeftStick() {
        return this._buttonLeftStick;
    }
    /**
     * Sets the value of the Left joystick
     */ set buttonLeftStick(value) {
        this._buttonLeftStick = this._setButtonValue(value, this._buttonLeftStick, $ca5f5abac3e9b713$export$e9a088793c3dd817.LeftStick);
    }
    /**
     * Gets the value of the Right joystick
     */ get buttonRightStick() {
        return this._buttonRightStick;
    }
    /**
     * Sets the value of the Right joystick
     */ set buttonRightStick(value) {
        this._buttonRightStick = this._setButtonValue(value, this._buttonRightStick, $ca5f5abac3e9b713$export$e9a088793c3dd817.RightStick);
    }
    /**
     * Gets the value of D-pad up
     */ get dPadUp() {
        return this._dPadUp;
    }
    /**
     * Sets the value of D-pad up
     */ set dPadUp(value) {
        this._dPadUp = this._setDPadValue(value, this._dPadUp, $ca5f5abac3e9b713$export$c66ef8d75a8724ce.Up);
    }
    /**
     * Gets the value of D-pad down
     */ get dPadDown() {
        return this._dPadDown;
    }
    /**
     * Sets the value of D-pad down
     */ set dPadDown(value) {
        this._dPadDown = this._setDPadValue(value, this._dPadDown, $ca5f5abac3e9b713$export$c66ef8d75a8724ce.Down);
    }
    /**
     * Gets the value of D-pad left
     */ get dPadLeft() {
        return this._dPadLeft;
    }
    /**
     * Sets the value of D-pad left
     */ set dPadLeft(value) {
        this._dPadLeft = this._setDPadValue(value, this._dPadLeft, $ca5f5abac3e9b713$export$c66ef8d75a8724ce.Left);
    }
    /**
     * Gets the value of D-pad right
     */ get dPadRight() {
        return this._dPadRight;
    }
    /**
     * Sets the value of D-pad right
     */ set dPadRight(value) {
        this._dPadRight = this._setDPadValue(value, this._dPadRight, $ca5f5abac3e9b713$export$c66ef8d75a8724ce.Right);
    }
    /**
     * Force the gamepad to synchronize with device values
     */ update() {
        super.update();
        this.buttonCross = this.browserGamepad.buttons[0].value;
        this.buttonCircle = this.browserGamepad.buttons[1].value;
        this.buttonSquare = this.browserGamepad.buttons[2].value;
        this.buttonTriangle = this.browserGamepad.buttons[3].value;
        this.buttonL1 = this.browserGamepad.buttons[4].value;
        this.buttonR1 = this.browserGamepad.buttons[5].value;
        this.leftTrigger = this.browserGamepad.buttons[6].value;
        this.rightTrigger = this.browserGamepad.buttons[7].value;
        this.buttonShare = this.browserGamepad.buttons[8].value;
        this.buttonOptions = this.browserGamepad.buttons[9].value;
        this.buttonLeftStick = this.browserGamepad.buttons[10].value;
        this.buttonRightStick = this.browserGamepad.buttons[11].value;
        this.dPadUp = this.browserGamepad.buttons[12].value;
        this.dPadDown = this.browserGamepad.buttons[13].value;
        this.dPadLeft = this.browserGamepad.buttons[14].value;
        this.dPadRight = this.browserGamepad.buttons[15].value;
    }
    /**
     * Disposes the gamepad
     */ dispose() {
        super.dispose();
        this.onButtonDownObservable.clear();
        this.onButtonUpObservable.clear();
        this.onPadDownObservable.clear();
        this.onPadUpObservable.clear();
    }
}

});





parcelRegister("2ewkx", function(module, exports) {

var $gzIoF = parcelRequire("gzIoF");

var $8vrnd = parcelRequire("8vrnd");

var $fGPEU = parcelRequire("fGPEU");

var $9fUa8 = parcelRequire("9fUa8");

var $kKXe9 = parcelRequire("kKXe9");

var $8HsPn = parcelRequire("8HsPn");

var $gT8zv = parcelRequire("gT8zv");

var $36SmB = parcelRequire("36SmB");

var $87Oz7 = parcelRequire("87Oz7");
$parcel$exportWildcard(module.exports, $gzIoF);
$parcel$exportWildcard(module.exports, $8vrnd);
$parcel$exportWildcard(module.exports, $fGPEU);
$parcel$exportWildcard(module.exports, $9fUa8);
$parcel$exportWildcard(module.exports, $kKXe9);
$parcel$exportWildcard(module.exports, $8HsPn);
$parcel$exportWildcard(module.exports, $gT8zv);
$parcel$exportWildcard(module.exports, $36SmB);
$parcel$exportWildcard(module.exports, $87Oz7);

});
parcelRegister("gzIoF", function(module, exports) {

$parcel$export(module.exports, "AnaglyphArcRotateCamera", () => $c1125a87bb9c7121$export$eab29231dca3aedc);

var $74SKQ = parcelRequire("74SKQ");

var $jIhlp = parcelRequire("jIhlp");

var $ha1VO = parcelRequire("ha1VO");

var $bgssx = parcelRequire("bgssx");

var $5NLSr = parcelRequire("5NLSr");
(0, $bgssx.Node).AddNodeConstructor("AnaglyphArcRotateCamera", (name, scene, options)=>{
    return ()=>new $c1125a87bb9c7121$export$eab29231dca3aedc(name, 0, 0, 1.0, (0, $ha1VO.Vector3).Zero(), options.interaxial_distance, scene);
});
class $c1125a87bb9c7121$export$eab29231dca3aedc extends (0, $jIhlp.ArcRotateCamera) {
    /**
     * Creates a new AnaglyphArcRotateCamera
     * @param name defines camera name
     * @param alpha defines alpha angle (in radians)
     * @param beta defines beta angle (in radians)
     * @param radius defines radius
     * @param target defines camera target
     * @param interaxialDistance defines distance between each color axis
     * @param scene defines the hosting scene
     */ constructor(name, alpha, beta, radius, target, interaxialDistance, scene){
        super(name, alpha, beta, radius, target, scene);
        this._setRigMode = ()=>(0, $5NLSr.setStereoscopicAnaglyphRigMode)(this);
        this.interaxialDistance = interaxialDistance;
        this.setCameraRigMode((0, $74SKQ.Camera).RIG_MODE_STEREOSCOPIC_ANAGLYPH, {
            interaxialDistance: interaxialDistance
        });
    }
    /**
     * Gets camera class name
     * @returns AnaglyphArcRotateCamera
     */ getClassName() {
        return "AnaglyphArcRotateCamera";
    }
}

});
parcelRegister("5NLSr", function(module, exports) {

$parcel$export(module.exports, "setStereoscopicAnaglyphRigMode", () => $4396aac31475b6bc$export$1bacc560c6be56cc);

var $c7c1r = parcelRequire("c7c1r");

var $khOYP = parcelRequire("khOYP");
function $4396aac31475b6bc$export$1bacc560c6be56cc(camera) {
    camera._rigCameras[0]._rigPostProcess = new (0, $c7c1r.PassPostProcess)(camera.name + "_passthru", 1.0, camera._rigCameras[0]);
    camera._rigCameras[1]._rigPostProcess = new (0, $khOYP.AnaglyphPostProcess)(camera.name + "_anaglyph", 1.0, camera._rigCameras);
}

});
parcelRegister("c7c1r", function(module, exports) {

$parcel$export(module.exports, "PassPostProcess", () => $8d1f76ddd54eda7f$export$751d07bd234f514b);
$parcel$export(module.exports, "PassCubePostProcess", () => $8d1f76ddd54eda7f$export$949839013afb9580);

var $cFdBb = parcelRequire("cFdBb");

var $5YkyR = parcelRequire("5YkyR");
parcelRequire("dWQWp");
parcelRequire("fpsqh");

var $8DoUR = parcelRequire("8DoUR");

var $6Ho1L = parcelRequire("6Ho1L");
class $8d1f76ddd54eda7f$export$751d07bd234f514b extends (0, $cFdBb.PostProcess) {
    /**
     * Gets a string identifying the name of the class
     * @returns "PassPostProcess" string
     */ getClassName() {
        return "PassPostProcess";
    }
    /**
     * Creates the PassPostProcess
     * @param name The name of the effect.
     * @param options The required width/height ratio to downsize to before computing the render pass.
     * @param camera The camera to apply the render pass to.
     * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
     * @param engine The engine which the post process will be applied. (default: current engine)
     * @param reusable If the post process can be reused on the same frame. (default: false)
     * @param textureType The type of texture to be used when performing the post processing.
     * @param blockCompilation If compilation of the shader should not be done in the constructor. The updateEffect method can be used to compile the shader at a later time. (default: false)
     */ constructor(name, options, camera = null, samplingMode, engine, reusable, textureType = 0, blockCompilation = false){
        super(name, "pass", null, null, options, camera, samplingMode, engine, reusable, undefined, textureType, undefined, null, blockCompilation);
    }
    /**
     * @internal
     */ static _Parse(parsedPostProcess, targetCamera, scene, rootUrl) {
        return (0, $6Ho1L.SerializationHelper).Parse(()=>{
            return new $8d1f76ddd54eda7f$export$751d07bd234f514b(parsedPostProcess.name, parsedPostProcess.options, targetCamera, parsedPostProcess.renderTargetSamplingMode, parsedPostProcess._engine, parsedPostProcess.reusable);
        }, parsedPostProcess, scene, rootUrl);
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.PassPostProcess", $8d1f76ddd54eda7f$export$751d07bd234f514b);
class $8d1f76ddd54eda7f$export$949839013afb9580 extends (0, $cFdBb.PostProcess) {
    /**
     * Gets or sets the cube face to display.
     *  * 0 is +X
     *  * 1 is -X
     *  * 2 is +Y
     *  * 3 is -Y
     *  * 4 is +Z
     *  * 5 is -Z
     */ get face() {
        return this._face;
    }
    set face(value) {
        if (value < 0 || value > 5) return;
        this._face = value;
        switch(this._face){
            case 0:
                this.updateEffect("#define POSITIVEX");
                break;
            case 1:
                this.updateEffect("#define NEGATIVEX");
                break;
            case 2:
                this.updateEffect("#define POSITIVEY");
                break;
            case 3:
                this.updateEffect("#define NEGATIVEY");
                break;
            case 4:
                this.updateEffect("#define POSITIVEZ");
                break;
            case 5:
                this.updateEffect("#define NEGATIVEZ");
                break;
        }
    }
    /**
     * Gets a string identifying the name of the class
     * @returns "PassCubePostProcess" string
     */ getClassName() {
        return "PassCubePostProcess";
    }
    /**
     * Creates the PassCubePostProcess
     * @param name The name of the effect.
     * @param options The required width/height ratio to downsize to before computing the render pass.
     * @param camera The camera to apply the render pass to.
     * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
     * @param engine The engine which the post process will be applied. (default: current engine)
     * @param reusable If the post process can be reused on the same frame. (default: false)
     * @param textureType The type of texture to be used when performing the post processing.
     * @param blockCompilation If compilation of the shader should not be done in the constructor. The updateEffect method can be used to compile the shader at a later time. (default: false)
     */ constructor(name, options, camera = null, samplingMode, engine, reusable, textureType = 0, blockCompilation = false){
        super(name, "passCube", null, null, options, camera, samplingMode, engine, reusable, "#define POSITIVEX", textureType, undefined, null, blockCompilation);
        this._face = 0;
    }
    /**
     * @internal
     */ static _Parse(parsedPostProcess, targetCamera, scene, rootUrl) {
        return (0, $6Ho1L.SerializationHelper).Parse(()=>{
            return new $8d1f76ddd54eda7f$export$949839013afb9580(parsedPostProcess.name, parsedPostProcess.options, targetCamera, parsedPostProcess.renderTargetSamplingMode, parsedPostProcess._engine, parsedPostProcess.reusable);
        }, parsedPostProcess, scene, rootUrl);
    }
}
(0, $5YkyR.Engine)._RescalePostProcessFactory = (engine)=>{
    return new $8d1f76ddd54eda7f$export$751d07bd234f514b("rescale", 1, null, 2, engine, false, 0);
};

});
parcelRegister("fpsqh", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $b37f3d023b1c3d81$var$name = "passCubePixelShader";
const $b37f3d023b1c3d81$var$shader = `varying vec2 vUV;uniform samplerCube textureSampler;
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) 
{vec2 uv=vUV*2.0-1.0;
#ifdef POSITIVEX
gl_FragColor=textureCube(textureSampler,vec3(1.001,uv.y,uv.x));
#endif
#ifdef NEGATIVEX
gl_FragColor=textureCube(textureSampler,vec3(-1.001,uv.y,uv.x));
#endif
#ifdef POSITIVEY
gl_FragColor=textureCube(textureSampler,vec3(uv.y,1.001,uv.x));
#endif
#ifdef NEGATIVEY
gl_FragColor=textureCube(textureSampler,vec3(uv.y,-1.001,uv.x));
#endif
#ifdef POSITIVEZ
gl_FragColor=textureCube(textureSampler,vec3(uv,1.001));
#endif
#ifdef NEGATIVEZ
gl_FragColor=textureCube(textureSampler,vec3(uv,-1.001));
#endif
}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$b37f3d023b1c3d81$var$name] = $b37f3d023b1c3d81$var$shader;
const $b37f3d023b1c3d81$export$7cdd9054a33482f6 = {
    name: $b37f3d023b1c3d81$var$name,
    shader: $b37f3d023b1c3d81$var$shader
};

});


parcelRegister("khOYP", function(module, exports) {

$parcel$export(module.exports, "AnaglyphPostProcess", () => $ec4cf0c1d4d7c7bc$export$8454a2911a1fbaad);

var $cFdBb = parcelRequire("cFdBb");
parcelRequire("3jCgS");

var $8DoUR = parcelRequire("8DoUR");
class $ec4cf0c1d4d7c7bc$export$8454a2911a1fbaad extends (0, $cFdBb.PostProcess) {
    /**
     * Gets a string identifying the name of the class
     * @returns "AnaglyphPostProcess" string
     */ getClassName() {
        return "AnaglyphPostProcess";
    }
    /**
     * Creates a new AnaglyphPostProcess
     * @param name defines postprocess name
     * @param options defines creation options or target ratio scale
     * @param rigCameras defines cameras using this postprocess
     * @param samplingMode defines required sampling mode (BABYLON.Texture.NEAREST_SAMPLINGMODE by default)
     * @param engine defines hosting engine
     * @param reusable defines if the postprocess will be reused multiple times per frame
     */ constructor(name, options, rigCameras, samplingMode, engine, reusable){
        super(name, "anaglyph", null, [
            "leftSampler"
        ], options, rigCameras[1], samplingMode, engine, reusable);
        this._passedProcess = rigCameras[0]._rigPostProcess;
        this.onApplyObservable.add((effect)=>{
            effect.setTextureFromPostProcess("leftSampler", this._passedProcess);
        });
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.AnaglyphPostProcess", $ec4cf0c1d4d7c7bc$export$8454a2911a1fbaad);

});
parcelRegister("3jCgS", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $26a0d5519c17b36c$var$name = "anaglyphPixelShader";
const $26a0d5519c17b36c$var$shader = `varying vec2 vUV;uniform sampler2D textureSampler;uniform sampler2D leftSampler;
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{vec4 leftFrag=texture2D(leftSampler,vUV);leftFrag=vec4(1.0,leftFrag.g,leftFrag.b,1.0);vec4 rightFrag=texture2D(textureSampler,vUV);rightFrag=vec4(rightFrag.r,1.0,1.0,1.0);gl_FragColor=vec4(rightFrag.rgb*leftFrag.rgb,1.0);}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$26a0d5519c17b36c$var$name] = $26a0d5519c17b36c$var$shader;
const $26a0d5519c17b36c$export$9d5b6f19deebc054 = {
    name: $26a0d5519c17b36c$var$name,
    shader: $26a0d5519c17b36c$var$shader
};

});




parcelRegister("8vrnd", function(module, exports) {

$parcel$export(module.exports, "AnaglyphFreeCamera", () => $631673c326d9791e$export$74bc5f0f79b3d9ef);

var $74SKQ = parcelRequire("74SKQ");

var $gSOV5 = parcelRequire("gSOV5");

var $ha1VO = parcelRequire("ha1VO");

var $bgssx = parcelRequire("bgssx");

var $5NLSr = parcelRequire("5NLSr");
(0, $bgssx.Node).AddNodeConstructor("AnaglyphFreeCamera", (name, scene, options)=>{
    return ()=>new $631673c326d9791e$export$74bc5f0f79b3d9ef(name, (0, $ha1VO.Vector3).Zero(), options.interaxial_distance, scene);
});
class $631673c326d9791e$export$74bc5f0f79b3d9ef extends (0, $gSOV5.FreeCamera) {
    /**
     * Creates a new AnaglyphFreeCamera
     * @param name defines camera name
     * @param position defines initial position
     * @param interaxialDistance defines distance between each color axis
     * @param scene defines the hosting scene
     */ constructor(name, position, interaxialDistance, scene){
        super(name, position, scene);
        this._setRigMode = ()=>(0, $5NLSr.setStereoscopicAnaglyphRigMode)(this);
        this.interaxialDistance = interaxialDistance;
        this.setCameraRigMode((0, $74SKQ.Camera).RIG_MODE_STEREOSCOPIC_ANAGLYPH, {
            interaxialDistance: interaxialDistance
        });
    }
    /**
     * Gets camera class name
     * @returns AnaglyphFreeCamera
     */ getClassName() {
        return "AnaglyphFreeCamera";
    }
}

});

parcelRegister("fGPEU", function(module, exports) {

$parcel$export(module.exports, "AnaglyphGamepadCamera", () => $b6c2d9a38cd6ea04$export$30a1fb0d31259de);

var $74SKQ = parcelRequire("74SKQ");

var $3ilrw = parcelRequire("3ilrw");

var $ha1VO = parcelRequire("ha1VO");

var $bgssx = parcelRequire("bgssx");

var $5NLSr = parcelRequire("5NLSr");
(0, $bgssx.Node).AddNodeConstructor("AnaglyphGamepadCamera", (name, scene, options)=>{
    return ()=>new $b6c2d9a38cd6ea04$export$30a1fb0d31259de(name, (0, $ha1VO.Vector3).Zero(), options.interaxial_distance, scene);
});
class $b6c2d9a38cd6ea04$export$30a1fb0d31259de extends (0, $3ilrw.GamepadCamera) {
    /**
     * Creates a new AnaglyphGamepadCamera
     * @param name defines camera name
     * @param position defines initial position
     * @param interaxialDistance defines distance between each color axis
     * @param scene defines the hosting scene
     */ constructor(name, position, interaxialDistance, scene){
        super(name, position, scene);
        this._setRigMode = ()=>(0, $5NLSr.setStereoscopicAnaglyphRigMode)(this);
        this.interaxialDistance = interaxialDistance;
        this.setCameraRigMode((0, $74SKQ.Camera).RIG_MODE_STEREOSCOPIC_ANAGLYPH, {
            interaxialDistance: interaxialDistance
        });
    }
    /**
     * Gets camera class name
     * @returns AnaglyphGamepadCamera
     */ getClassName() {
        return "AnaglyphGamepadCamera";
    }
}

});

parcelRegister("9fUa8", function(module, exports) {

$parcel$export(module.exports, "AnaglyphUniversalCamera", () => $6bd11472848b2615$export$e2e8039e5c59e2dd);

var $74SKQ = parcelRequire("74SKQ");

var $765rp = parcelRequire("765rp");

var $ha1VO = parcelRequire("ha1VO");

var $bgssx = parcelRequire("bgssx");

var $5NLSr = parcelRequire("5NLSr");
(0, $bgssx.Node).AddNodeConstructor("AnaglyphUniversalCamera", (name, scene, options)=>{
    return ()=>new $6bd11472848b2615$export$e2e8039e5c59e2dd(name, (0, $ha1VO.Vector3).Zero(), options.interaxial_distance, scene);
});
class $6bd11472848b2615$export$e2e8039e5c59e2dd extends (0, $765rp.UniversalCamera) {
    /**
     * Creates a new AnaglyphUniversalCamera
     * @param name defines camera name
     * @param position defines initial position
     * @param interaxialDistance defines distance between each color axis
     * @param scene defines the hosting scene
     */ constructor(name, position, interaxialDistance, scene){
        super(name, position, scene);
        this._setRigMode = ()=>(0, $5NLSr.setStereoscopicAnaglyphRigMode)(this);
        this.interaxialDistance = interaxialDistance;
        this.setCameraRigMode((0, $74SKQ.Camera).RIG_MODE_STEREOSCOPIC_ANAGLYPH, {
            interaxialDistance: interaxialDistance
        });
    }
    /**
     * Gets camera class name
     * @returns AnaglyphUniversalCamera
     */ getClassName() {
        return "AnaglyphUniversalCamera";
    }
}

});

parcelRegister("kKXe9", function(module, exports) {

$parcel$export(module.exports, "StereoscopicArcRotateCamera", () => $f1c60bcfa1482c3a$export$afe495fcf5aa8317);

var $74SKQ = parcelRequire("74SKQ");

var $jIhlp = parcelRequire("jIhlp");

var $ha1VO = parcelRequire("ha1VO");

var $bgssx = parcelRequire("bgssx");

var $2ZWLA = parcelRequire("2ZWLA");
(0, $bgssx.Node).AddNodeConstructor("StereoscopicArcRotateCamera", (name, scene, options)=>{
    return ()=>new $f1c60bcfa1482c3a$export$afe495fcf5aa8317(name, 0, 0, 1.0, (0, $ha1VO.Vector3).Zero(), options.interaxial_distance, options.isStereoscopicSideBySide, scene);
});
class $f1c60bcfa1482c3a$export$afe495fcf5aa8317 extends (0, $jIhlp.ArcRotateCamera) {
    /**
     * Creates a new StereoscopicArcRotateCamera
     * @param name defines camera name
     * @param alpha defines alpha angle (in radians)
     * @param beta defines beta angle (in radians)
     * @param radius defines radius
     * @param target defines camera target
     * @param interaxialDistance defines distance between each color axis
     * @param isStereoscopicSideBySide defines is stereoscopic is done side by side or over under
     * @param scene defines the hosting scene
     */ constructor(name, alpha, beta, radius, target, interaxialDistance, isStereoscopicSideBySide, scene){
        super(name, alpha, beta, radius, target, scene);
        this._setRigMode = ()=>(0, $2ZWLA.setStereoscopicRigMode)(this);
        this.interaxialDistance = interaxialDistance;
        this.isStereoscopicSideBySide = isStereoscopicSideBySide;
        this.setCameraRigMode(isStereoscopicSideBySide ? (0, $74SKQ.Camera).RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_PARALLEL : (0, $74SKQ.Camera).RIG_MODE_STEREOSCOPIC_OVERUNDER, {
            interaxialDistance: interaxialDistance
        });
    }
    /**
     * Gets camera class name
     * @returns StereoscopicArcRotateCamera
     */ getClassName() {
        return "StereoscopicArcRotateCamera";
    }
}

});
parcelRegister("2ZWLA", function(module, exports) {

$parcel$export(module.exports, "setStereoscopicRigMode", () => $22eedd13ce965583$export$9db9c068f33065b2);

var $74SKQ = parcelRequire("74SKQ");

var $191mA = parcelRequire("191mA");

var $c7c1r = parcelRequire("c7c1r");

var $02MSE = parcelRequire("02MSE");
function $22eedd13ce965583$export$9db9c068f33065b2(camera) {
    const isStereoscopicHoriz = camera.cameraRigMode === (0, $74SKQ.Camera).RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_PARALLEL || camera.cameraRigMode === (0, $74SKQ.Camera).RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_CROSSEYED;
    const isCrossEye = camera.cameraRigMode === (0, $74SKQ.Camera).RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_CROSSEYED;
    const isInterlaced = camera.cameraRigMode === (0, $74SKQ.Camera).RIG_MODE_STEREOSCOPIC_INTERLACED;
    // Use post-processors for interlacing
    if (isInterlaced) {
        camera._rigCameras[0]._rigPostProcess = new (0, $c7c1r.PassPostProcess)(camera.name + "_passthru", 1.0, camera._rigCameras[0]);
        camera._rigCameras[1]._rigPostProcess = new (0, $02MSE.StereoscopicInterlacePostProcessI)(camera.name + "_stereoInterlace", camera._rigCameras, false, true);
    } else {
        camera._rigCameras[isCrossEye ? 1 : 0].viewport = new (0, $191mA.Viewport)(0, 0, isStereoscopicHoriz ? 0.5 : 1.0, isStereoscopicHoriz ? 1.0 : 0.5);
        camera._rigCameras[isCrossEye ? 0 : 1].viewport = new (0, $191mA.Viewport)(isStereoscopicHoriz ? 0.5 : 0, isStereoscopicHoriz ? 0 : 0.5, isStereoscopicHoriz ? 0.5 : 1.0, isStereoscopicHoriz ? 1.0 : 0.5);
    }
}

});
parcelRegister("02MSE", function(module, exports) {

$parcel$export(module.exports, "StereoscopicInterlacePostProcessI", () => $00861aaf319f9af0$export$ce4746c485787b91);
$parcel$export(module.exports, "StereoscopicInterlacePostProcess", () => $00861aaf319f9af0$export$56183ff991dc6fd8);

var $ha1VO = parcelRequire("ha1VO");

var $cFdBb = parcelRequire("cFdBb");
parcelRequire("aYa7M");
class $00861aaf319f9af0$export$ce4746c485787b91 extends (0, $cFdBb.PostProcess) {
    /**
     * Gets a string identifying the name of the class
     * @returns "StereoscopicInterlacePostProcessI" string
     */ getClassName() {
        return "StereoscopicInterlacePostProcessI";
    }
    /**
     * Initializes a StereoscopicInterlacePostProcessI
     * @param name The name of the effect.
     * @param rigCameras The rig cameras to be applied to the post process
     * @param isStereoscopicHoriz If the rendered results are horizontal or vertical
     * @param isStereoscopicInterlaced If the rendered results are alternate line interlaced
     * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
     * @param engine The engine which the post process will be applied. (default: current engine)
     * @param reusable If the post process can be reused on the same frame. (default: false)
     */ constructor(name, rigCameras, isStereoscopicHoriz, isStereoscopicInterlaced, samplingMode, engine, reusable){
        super(name, "stereoscopicInterlace", [
            "stepSize"
        ], [
            "camASampler"
        ], 1, rigCameras[1], samplingMode, engine, reusable, isStereoscopicInterlaced ? "#define IS_STEREOSCOPIC_INTERLACED 1" : isStereoscopicHoriz ? "#define IS_STEREOSCOPIC_HORIZ 1" : undefined);
        this._passedProcess = rigCameras[0]._rigPostProcess;
        this._stepSize = new (0, $ha1VO.Vector2)(1 / this.width, 1 / this.height);
        this.onSizeChangedObservable.add(()=>{
            this._stepSize = new (0, $ha1VO.Vector2)(1 / this.width, 1 / this.height);
        });
        this.onApplyObservable.add((effect)=>{
            effect.setTextureFromPostProcess("camASampler", this._passedProcess);
            effect.setFloat2("stepSize", this._stepSize.x, this._stepSize.y);
        });
    }
}
class $00861aaf319f9af0$export$56183ff991dc6fd8 extends (0, $cFdBb.PostProcess) {
    /**
     * Gets a string identifying the name of the class
     * @returns "StereoscopicInterlacePostProcess" string
     */ getClassName() {
        return "StereoscopicInterlacePostProcess";
    }
    /**
     * Initializes a StereoscopicInterlacePostProcess
     * @param name The name of the effect.
     * @param rigCameras The rig cameras to be applied to the post process
     * @param isStereoscopicHoriz If the rendered results are horizontal or vertical
     * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
     * @param engine The engine which the post process will be applied. (default: current engine)
     * @param reusable If the post process can be reused on the same frame. (default: false)
     */ constructor(name, rigCameras, isStereoscopicHoriz, samplingMode, engine, reusable){
        super(name, "stereoscopicInterlace", [
            "stepSize"
        ], [
            "camASampler"
        ], 1, rigCameras[1], samplingMode, engine, reusable, isStereoscopicHoriz ? "#define IS_STEREOSCOPIC_HORIZ 1" : undefined);
        this._passedProcess = rigCameras[0]._rigPostProcess;
        this._stepSize = new (0, $ha1VO.Vector2)(1 / this.width, 1 / this.height);
        this.onSizeChangedObservable.add(()=>{
            this._stepSize = new (0, $ha1VO.Vector2)(1 / this.width, 1 / this.height);
        });
        this.onApplyObservable.add((effect)=>{
            effect.setTextureFromPostProcess("camASampler", this._passedProcess);
            effect.setFloat2("stepSize", this._stepSize.x, this._stepSize.y);
        });
    }
}

});
parcelRegister("aYa7M", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $7fc75c83bdd234eb$var$name = "stereoscopicInterlacePixelShader";
const $7fc75c83bdd234eb$var$shader = `const vec3 TWO=vec3(2.0,2.0,2.0);varying vec2 vUV;uniform sampler2D camASampler;uniform sampler2D textureSampler;uniform vec2 stepSize;
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{bool useCamA;bool useCamB;vec2 texCoord1;vec2 texCoord2;vec3 frag1;vec3 frag2;
#ifdef IS_STEREOSCOPIC_HORIZ
useCamB=vUV.x>0.5;useCamA=!useCamB;texCoord1=vec2(useCamB ? (vUV.x-0.5)*2.0 : vUV.x*2.0,vUV.y);texCoord2=vec2(texCoord1.x+stepSize.x,vUV.y);
#else
#ifdef IS_STEREOSCOPIC_INTERLACED
float rowNum=floor(vUV.y/stepSize.y);useCamA=mod(rowNum,2.0)==1.0;useCamB=mod(rowNum,2.0)==0.0;texCoord1=vec2(vUV.x,vUV.y);texCoord2=vec2(vUV.x,vUV.y);
#else
useCamB=vUV.y>0.5;useCamA=!useCamB;texCoord1=vec2(vUV.x,useCamB ? (vUV.y-0.5)*2.0 : vUV.y*2.0);texCoord2=vec2(vUV.x,texCoord1.y+stepSize.y);
#endif
#endif
if (useCamB){frag1=texture2D(textureSampler,texCoord1).rgb;frag2=texture2D(textureSampler,texCoord2).rgb;}else if (useCamA){frag1=texture2D(camASampler ,texCoord1).rgb;frag2=texture2D(camASampler ,texCoord2).rgb;}else {discard;}
gl_FragColor=vec4((frag1+frag2)/TWO,1.0);}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$7fc75c83bdd234eb$var$name] = $7fc75c83bdd234eb$var$shader;
const $7fc75c83bdd234eb$export$2222d5df43b4a3a2 = {
    name: $7fc75c83bdd234eb$var$name,
    shader: $7fc75c83bdd234eb$var$shader
};

});




parcelRegister("8HsPn", function(module, exports) {

$parcel$export(module.exports, "StereoscopicFreeCamera", () => $6558b3703707d01d$export$d3000915f8ab2b5a);

var $74SKQ = parcelRequire("74SKQ");

var $gSOV5 = parcelRequire("gSOV5");

var $ha1VO = parcelRequire("ha1VO");

var $bgssx = parcelRequire("bgssx");

var $2ZWLA = parcelRequire("2ZWLA");
(0, $bgssx.Node).AddNodeConstructor("StereoscopicFreeCamera", (name, scene, options)=>{
    return ()=>new $6558b3703707d01d$export$d3000915f8ab2b5a(name, (0, $ha1VO.Vector3).Zero(), options.interaxial_distance, options.isStereoscopicSideBySide, scene);
});
class $6558b3703707d01d$export$d3000915f8ab2b5a extends (0, $gSOV5.FreeCamera) {
    /**
     * Creates a new StereoscopicFreeCamera
     * @param name defines camera name
     * @param position defines initial position
     * @param interaxialDistance defines distance between each color axis
     * @param isStereoscopicSideBySide defines is stereoscopic is done side by side or over under
     * @param scene defines the hosting scene
     */ constructor(name, position, interaxialDistance, isStereoscopicSideBySide, scene){
        super(name, position, scene);
        this._setRigMode = ()=>(0, $2ZWLA.setStereoscopicRigMode)(this);
        this.interaxialDistance = interaxialDistance;
        this.isStereoscopicSideBySide = isStereoscopicSideBySide;
        this.setCameraRigMode(isStereoscopicSideBySide ? (0, $74SKQ.Camera).RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_PARALLEL : (0, $74SKQ.Camera).RIG_MODE_STEREOSCOPIC_OVERUNDER, {
            interaxialDistance: interaxialDistance
        });
    }
    /**
     * Gets camera class name
     * @returns StereoscopicFreeCamera
     */ getClassName() {
        return "StereoscopicFreeCamera";
    }
}

});

parcelRegister("gT8zv", function(module, exports) {

$parcel$export(module.exports, "StereoscopicGamepadCamera", () => $c4b86e8e73d2b253$export$aa61f0d1a97d9939);

var $74SKQ = parcelRequire("74SKQ");

var $3ilrw = parcelRequire("3ilrw");

var $ha1VO = parcelRequire("ha1VO");

var $bgssx = parcelRequire("bgssx");

var $2ZWLA = parcelRequire("2ZWLA");
(0, $bgssx.Node).AddNodeConstructor("StereoscopicGamepadCamera", (name, scene, options)=>{
    return ()=>new $c4b86e8e73d2b253$export$aa61f0d1a97d9939(name, (0, $ha1VO.Vector3).Zero(), options.interaxial_distance, options.isStereoscopicSideBySide, scene);
});
class $c4b86e8e73d2b253$export$aa61f0d1a97d9939 extends (0, $3ilrw.GamepadCamera) {
    /**
     * Creates a new StereoscopicGamepadCamera
     * @param name defines camera name
     * @param position defines initial position
     * @param interaxialDistance defines distance between each color axis
     * @param isStereoscopicSideBySide defines is stereoscopic is done side by side or over under
     * @param scene defines the hosting scene
     */ constructor(name, position, interaxialDistance, isStereoscopicSideBySide, scene){
        super(name, position, scene);
        this._setRigMode = ()=>(0, $2ZWLA.setStereoscopicRigMode)(this);
        this.interaxialDistance = interaxialDistance;
        this.isStereoscopicSideBySide = isStereoscopicSideBySide;
        this.setCameraRigMode(isStereoscopicSideBySide ? (0, $74SKQ.Camera).RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_PARALLEL : (0, $74SKQ.Camera).RIG_MODE_STEREOSCOPIC_OVERUNDER, {
            interaxialDistance: interaxialDistance
        });
    }
    /**
     * Gets camera class name
     * @returns StereoscopicGamepadCamera
     */ getClassName() {
        return "StereoscopicGamepadCamera";
    }
}

});

parcelRegister("36SmB", function(module, exports) {

$parcel$export(module.exports, "StereoscopicUniversalCamera", () => $243c1a1fe3ecfca1$export$bd6c3e436ad9ed2f);

var $74SKQ = parcelRequire("74SKQ");

var $765rp = parcelRequire("765rp");

var $ha1VO = parcelRequire("ha1VO");

var $bgssx = parcelRequire("bgssx");

var $2ZWLA = parcelRequire("2ZWLA");
(0, $bgssx.Node).AddNodeConstructor("StereoscopicFreeCamera", (name, scene, options)=>{
    return ()=>new $243c1a1fe3ecfca1$export$bd6c3e436ad9ed2f(name, (0, $ha1VO.Vector3).Zero(), options.interaxial_distance, options.isStereoscopicSideBySide, scene);
});
class $243c1a1fe3ecfca1$export$bd6c3e436ad9ed2f extends (0, $765rp.UniversalCamera) {
    /**
     * Creates a new StereoscopicUniversalCamera
     * @param name defines camera name
     * @param position defines initial position
     * @param interaxialDistance defines distance between each color axis
     * @param isStereoscopicSideBySide defines is stereoscopic is done side by side or over under
     * @param scene defines the hosting scene
     */ constructor(name, position, interaxialDistance, isStereoscopicSideBySide, scene){
        super(name, position, scene);
        this._setRigMode = ()=>(0, $2ZWLA.setStereoscopicRigMode)(this);
        this.interaxialDistance = interaxialDistance;
        this.isStereoscopicSideBySide = isStereoscopicSideBySide;
        this.setCameraRigMode(isStereoscopicSideBySide ? (0, $74SKQ.Camera).RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_PARALLEL : (0, $74SKQ.Camera).RIG_MODE_STEREOSCOPIC_OVERUNDER, {
            interaxialDistance: interaxialDistance
        });
    }
    /**
     * Gets camera class name
     * @returns StereoscopicUniversalCamera
     */ getClassName() {
        return "StereoscopicUniversalCamera";
    }
}

});

parcelRegister("87Oz7", function(module, exports) {

$parcel$export(module.exports, "StereoscopicScreenUniversalCamera", () => $5ea63369a7240566$export$aa9f071fb5c9544e);

var $74SKQ = parcelRequire("74SKQ");

var $765rp = parcelRequire("765rp");

var $ha1VO = parcelRequire("ha1VO");

var $fJj0G = parcelRequire("fJj0G");

var $klshO = parcelRequire("klshO");

var $191mA = parcelRequire("191mA");
class $5ea63369a7240566$export$aa9f071fb5c9544e extends (0, $765rp.UniversalCamera) {
    set distanceBetweenEyes(newValue) {
        this._distanceBetweenEyes = newValue;
    }
    /**
     * distance between the eyes
     */ get distanceBetweenEyes() {
        return this._distanceBetweenEyes;
    }
    set distanceToProjectionPlane(newValue) {
        this._distanceToProjectionPlane = newValue;
    }
    /**
     * Distance to projection plane (should be the same units the like distance between the eyes)
     */ get distanceToProjectionPlane() {
        return this._distanceToProjectionPlane;
    }
    /**
     * Creates a new StereoscopicScreenUniversalCamera
     * @param name defines camera name
     * @param position defines initial position
     * @param scene defines the hosting scene
     * @param distanceToProjectionPlane defines distance between each color axis. The rig cameras will receive this as their negative z position!
     * @param distanceBetweenEyes defines is stereoscopic is done side by side or over under
     */ constructor(name, position, scene, distanceToProjectionPlane = 1, distanceBetweenEyes = 0.065){
        super(name, position, scene);
        this._distanceBetweenEyes = distanceBetweenEyes;
        this._distanceToProjectionPlane = distanceToProjectionPlane;
        this.setCameraRigMode((0, $74SKQ.Camera).RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_PARALLEL, {
            stereoHalfAngle: 0
        });
        this._cameraRigParams.stereoHalfAngle = 0;
        this._cameraRigParams.interaxialDistance = distanceBetweenEyes;
    }
    /**
     * Gets camera class name
     * @returns StereoscopicScreenUniversalCamera
     */ getClassName() {
        return "StereoscopicUniversalCamera";
    }
    /**
     * @internal
     */ createRigCamera(name) {
        const camera = new (0, $fJj0G.TargetCamera)(name, (0, $ha1VO.Vector3).Zero(), this.getScene());
        const transform = new (0, $klshO.TransformNode)("tm_" + name, this.getScene());
        camera.parent = transform;
        transform.setPivotMatrix((0, $ha1VO.Matrix).Identity(), false);
        camera.isRigCamera = true;
        camera.rigParent = this;
        return camera;
    }
    /**
     * @internal
     */ _updateRigCameras() {
        for(let cameraIndex = 0; cameraIndex < this._rigCameras.length; cameraIndex++){
            const cam = this._rigCameras[cameraIndex];
            cam.minZ = this.minZ;
            cam.maxZ = this.maxZ;
            cam.fov = this.fov;
            cam.upVector.copyFrom(this.upVector);
            if (cam.rotationQuaternion) cam.rotationQuaternion.copyFrom(this.rotationQuaternion);
            else cam.rotation.copyFrom(this.rotation);
            this._updateCamera(this._rigCameras[cameraIndex], cameraIndex);
        }
    }
    _updateCamera(camera, cameraIndex) {
        const b = this.distanceBetweenEyes / 2;
        const z = b / this.distanceToProjectionPlane;
        camera.position.copyFrom(this.position);
        camera.position.addInPlaceFromFloats(cameraIndex === 0 ? -b : b, 0, -this._distanceToProjectionPlane);
        const transform = camera.parent;
        const m = transform.getPivotMatrix();
        m.setTranslationFromFloats(cameraIndex === 0 ? b : -b, 0, 0);
        m.setRowFromFloats(2, cameraIndex === 0 ? z : -z, 0, 1, 0);
        transform.setPivotMatrix(m, false);
    }
    _setRigMode() {
        this._rigCameras[0].viewport = new (0, $191mA.Viewport)(0, 0, 0.5, 1);
        this._rigCameras[1].viewport = new (0, $191mA.Viewport)(0.5, 0, 0.5, 1.0);
        for(let cameraIndex = 0; cameraIndex < this._rigCameras.length; cameraIndex++)this._updateCamera(this._rigCameras[cameraIndex], cameraIndex);
    }
}

});


parcelRegister("awxsD", function(module, exports) {

$parcel$export(module.exports, "VirtualJoysticksCamera", () => $7a96d9284c207e45$export$e2e188cf66a99c63);

var $gSOV5 = parcelRequire("gSOV5");

var $ha1VO = parcelRequire("ha1VO");

var $bgssx = parcelRequire("bgssx");
parcelRequire("8xWbe");
(0, $bgssx.Node).AddNodeConstructor("VirtualJoysticksCamera", (name, scene)=>{
    return ()=>new $7a96d9284c207e45$export$e2e188cf66a99c63(name, (0, $ha1VO.Vector3).Zero(), scene);
});
class $7a96d9284c207e45$export$e2e188cf66a99c63 extends (0, $gSOV5.FreeCamera) {
    /**
     * Instantiates a VirtualJoysticksCamera. It can be useful in First Person Shooter game for instance.
     * It is identical to the Free Camera and simply adds by default a virtual joystick.
     * Virtual Joysticks are on-screen 2D graphics that are used to control the camera or other scene items.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/cameras/camera_introduction#virtual-joysticks-camera
     * @param name Define the name of the camera in the scene
     * @param position Define the start position of the camera in the scene
     * @param scene Define the scene the camera belongs to
     */ constructor(name, position, scene){
        super(name, position, scene);
        this.inputs.addVirtualJoystick();
    }
    /**
     * Gets the current object class name.
     * @returns the class name
     */ getClassName() {
        return "VirtualJoysticksCamera";
    }
}

});

parcelRegister("evQP9", function(module, exports) {

var $9ZOCK = parcelRequire("9ZOCK");

var $9V0iQ = parcelRequire("9V0iQ");

var $1nWIF = parcelRequire("1nWIF");

var $g7esv = parcelRequire("g7esv");

var $hLYkZ = parcelRequire("hLYkZ");
$parcel$exportWildcard(module.exports, $9ZOCK);
$parcel$exportWildcard(module.exports, $9V0iQ);
$parcel$exportWildcard(module.exports, $1nWIF);
$parcel$exportWildcard(module.exports, $g7esv);
$parcel$exportWildcard(module.exports, $hLYkZ);

});
parcelRegister("9ZOCK", function(module, exports) {

$parcel$export(module.exports, "VRCameraMetrics", () => $7471146cb331d799$export$d1bdf971bd7c152);

var $ha1VO = parcelRequire("ha1VO");
class $7471146cb331d799$export$d1bdf971bd7c152 {
    constructor(){
        /**
         * Define if the current vr camera should compensate the distortion of the lens or not.
         */ this.compensateDistortion = true;
        /**
         * Defines if multiview should be enabled when rendering (Default: false)
         */ this.multiviewEnabled = false;
    }
    /**
     * Gets the rendering aspect ratio based on the provided resolutions.
     */ get aspectRatio() {
        return this.hResolution / (2 * this.vResolution);
    }
    /**
     * Gets the aspect ratio based on the FOV, scale factors, and real screen sizes.
     */ get aspectRatioFov() {
        return 2 * Math.atan(this.postProcessScaleFactor * this.vScreenSize / (2 * this.eyeToScreenDistance));
    }
    /**
     * @internal
     */ get leftHMatrix() {
        const meters = this.hScreenSize / 4 - this.lensSeparationDistance / 2;
        const h = 4 * meters / this.hScreenSize;
        return (0, $ha1VO.Matrix).Translation(h, 0, 0);
    }
    /**
     * @internal
     */ get rightHMatrix() {
        const meters = this.hScreenSize / 4 - this.lensSeparationDistance / 2;
        const h = 4 * meters / this.hScreenSize;
        return (0, $ha1VO.Matrix).Translation(-h, 0, 0);
    }
    /**
     * @internal
     */ get leftPreViewMatrix() {
        return (0, $ha1VO.Matrix).Translation(0.5 * this.interpupillaryDistance, 0, 0);
    }
    /**
     * @internal
     */ get rightPreViewMatrix() {
        return (0, $ha1VO.Matrix).Translation(-0.5 * this.interpupillaryDistance, 0, 0);
    }
    /**
     * Get the default VRMetrics based on the most generic setup.
     * @returns the default vr metrics
     */ static GetDefault() {
        const result = new $7471146cb331d799$export$d1bdf971bd7c152();
        result.hResolution = 1280;
        result.vResolution = 800;
        result.hScreenSize = 0.149759993;
        result.vScreenSize = 0.0935999975;
        result.vScreenCenter = 0.0467999987;
        result.eyeToScreenDistance = 0.0410000011;
        result.lensSeparationDistance = 0.063500002;
        result.interpupillaryDistance = 0.064000003;
        result.distortionK = [
            1.0,
            0.219999999,
            0.239999995,
            0.0
        ];
        result.chromaAbCorrection = [
            0.995999992,
            -0.00400000019,
            1.01400006,
            0.0
        ];
        result.postProcessScaleFactor = 1.714605507808412;
        result.lensCenterOffset = 0.151976421;
        return result;
    }
}

});

parcelRegister("9V0iQ", function(module, exports) {

$parcel$export(module.exports, "VRDeviceOrientationArcRotateCamera", () => $7389ac1898cfe64a$export$16b5d4813fb3d61c);

var $74SKQ = parcelRequire("74SKQ");

var $jIhlp = parcelRequire("jIhlp");

var $9ZOCK = parcelRequire("9ZOCK");

var $ha1VO = parcelRequire("ha1VO");

var $bgssx = parcelRequire("bgssx");

var $iAaRG = parcelRequire("iAaRG");
parcelRequire("6NXHI");
(0, $bgssx.Node).AddNodeConstructor("VRDeviceOrientationArcRotateCamera", (name, scene)=>{
    return ()=>new $7389ac1898cfe64a$export$16b5d4813fb3d61c(name, 0, 0, 1.0, (0, $ha1VO.Vector3).Zero(), scene);
});
class $7389ac1898cfe64a$export$16b5d4813fb3d61c extends (0, $jIhlp.ArcRotateCamera) {
    /**
     * Creates a new VRDeviceOrientationArcRotateCamera
     * @param name defines camera name
     * @param alpha defines the camera rotation along the longitudinal axis
     * @param beta defines the camera rotation along the latitudinal axis
     * @param radius defines the camera distance from its target
     * @param target defines the camera target
     * @param scene defines the scene the camera belongs to
     * @param compensateDistortion defines if the camera needs to compensate the lens distortion
     * @param vrCameraMetrics defines the vr metrics associated to the camera
     */ constructor(name, alpha, beta, radius, target, scene, compensateDistortion = true, vrCameraMetrics = (0, $9ZOCK.VRCameraMetrics).GetDefault()){
        super(name, alpha, beta, radius, target, scene);
        this._setRigMode = (rigParams)=>(0, $iAaRG.setVRRigMode)(this, rigParams);
        vrCameraMetrics.compensateDistortion = compensateDistortion;
        this.setCameraRigMode((0, $74SKQ.Camera).RIG_MODE_VR, {
            vrCameraMetrics: vrCameraMetrics
        });
        this.inputs.addVRDeviceOrientation();
    }
    /**
     * Gets camera class name
     * @returns VRDeviceOrientationArcRotateCamera
     */ getClassName() {
        return "VRDeviceOrientationArcRotateCamera";
    }
}

});
parcelRegister("iAaRG", function(module, exports) {

$parcel$export(module.exports, "setVRRigMode", () => $d874045240e2b941$export$5099bdaa883ac95f);

var $ha1VO = parcelRequire("ha1VO");

var $d4vo4 = parcelRequire("d4vo4");

var $8zuLY = parcelRequire("8zuLY");

var $9ZOCK = parcelRequire("9ZOCK");

var $kVtWi = parcelRequire("kVtWi");

var $191mA = parcelRequire("191mA");
function $d874045240e2b941$export$5099bdaa883ac95f(camera, rigParams) {
    const metrics = rigParams.vrCameraMetrics || (0, $9ZOCK.VRCameraMetrics).GetDefault();
    camera._rigCameras[0]._cameraRigParams.vrMetrics = metrics;
    camera._rigCameras[0].viewport = new (0, $191mA.Viewport)(0, 0, 0.5, 1.0);
    camera._rigCameras[0]._cameraRigParams.vrWorkMatrix = new (0, $ha1VO.Matrix)();
    camera._rigCameras[0]._cameraRigParams.vrHMatrix = metrics.leftHMatrix;
    camera._rigCameras[0]._cameraRigParams.vrPreViewMatrix = metrics.leftPreViewMatrix;
    camera._rigCameras[0].getProjectionMatrix = camera._rigCameras[0]._getVRProjectionMatrix;
    camera._rigCameras[1]._cameraRigParams.vrMetrics = metrics;
    camera._rigCameras[1].viewport = new (0, $191mA.Viewport)(0.5, 0, 0.5, 1.0);
    camera._rigCameras[1]._cameraRigParams.vrWorkMatrix = new (0, $ha1VO.Matrix)();
    camera._rigCameras[1]._cameraRigParams.vrHMatrix = metrics.rightHMatrix;
    camera._rigCameras[1]._cameraRigParams.vrPreViewMatrix = metrics.rightPreViewMatrix;
    camera._rigCameras[1].getProjectionMatrix = camera._rigCameras[1]._getVRProjectionMatrix;
    // For multiview camera
    // First multiview will be rendered to camera._multiviewTexture
    // Then this postprocess will run on each eye to copy the right texture to each eye
    if (metrics.multiviewEnabled) {
        if (!camera.getScene().getEngine().getCaps().multiview) {
            (0, $kVtWi.Logger).Warn("Multiview is not supported, falling back to standard rendering");
            metrics.multiviewEnabled = false;
        } else {
            camera._useMultiviewToSingleView = true;
            camera._rigPostProcess = new (0, $8zuLY.VRMultiviewToSingleviewPostProcess)("VRMultiviewToSingleview", camera, metrics.postProcessScaleFactor);
        }
    }
    if (metrics.compensateDistortion) {
        camera._rigCameras[0]._rigPostProcess = new (0, $d4vo4.VRDistortionCorrectionPostProcess)("VR_Distort_Compensation_Left", camera._rigCameras[0], false, metrics);
        camera._rigCameras[1]._rigPostProcess = new (0, $d4vo4.VRDistortionCorrectionPostProcess)("VR_Distort_Compensation_Right", camera._rigCameras[1], true, metrics);
    }
}

});
parcelRegister("d4vo4", function(module, exports) {

$parcel$export(module.exports, "VRDistortionCorrectionPostProcess", () => $9843feeaa910ba0c$export$7ae46e029e21bf2f);

var $ha1VO = parcelRequire("ha1VO");

var $j2mX5 = parcelRequire("j2mX5");

var $cFdBb = parcelRequire("cFdBb");
parcelRequire("6lQpr");
class $9843feeaa910ba0c$export$7ae46e029e21bf2f extends (0, $cFdBb.PostProcess) {
    /**
     * Gets a string identifying the name of the class
     * @returns "VRDistortionCorrectionPostProcess" string
     */ getClassName() {
        return "VRDistortionCorrectionPostProcess";
    }
    /**
     * Initializes the VRDistortionCorrectionPostProcess
     * @param name The name of the effect.
     * @param camera The camera to apply the render pass to.
     * @param isRightEye If this is for the right eye distortion
     * @param vrMetrics All the required metrics for the VR camera
     */ constructor(name, camera, isRightEye, vrMetrics){
        super(name, "vrDistortionCorrection", [
            "LensCenter",
            "Scale",
            "ScaleIn",
            "HmdWarpParam"
        ], null, vrMetrics.postProcessScaleFactor, camera, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE);
        this._isRightEye = isRightEye;
        this._distortionFactors = vrMetrics.distortionK;
        this._postProcessScaleFactor = vrMetrics.postProcessScaleFactor;
        this._lensCenterOffset = vrMetrics.lensCenterOffset;
        this.adaptScaleToCurrentViewport = true;
        this.onSizeChangedObservable.add(()=>{
            this._scaleIn = new (0, $ha1VO.Vector2)(2, 2 / this.aspectRatio);
            this._scaleFactor = new (0, $ha1VO.Vector2)(0.5 * (1 / this._postProcessScaleFactor), 0.5 * (1 / this._postProcessScaleFactor) * this.aspectRatio);
            this._lensCenter = new (0, $ha1VO.Vector2)(this._isRightEye ? 0.5 - this._lensCenterOffset * 0.5 : 0.5 + this._lensCenterOffset * 0.5, 0.5);
        });
        this.onApplyObservable.add((effect)=>{
            effect.setFloat2("LensCenter", this._lensCenter.x, this._lensCenter.y);
            effect.setFloat2("Scale", this._scaleFactor.x, this._scaleFactor.y);
            effect.setFloat2("ScaleIn", this._scaleIn.x, this._scaleIn.y);
            effect.setFloat4("HmdWarpParam", this._distortionFactors[0], this._distortionFactors[1], this._distortionFactors[2], this._distortionFactors[3]);
        });
    }
}

});
parcelRegister("6lQpr", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $49fd5ba9a8adcd7e$var$name = "vrDistortionCorrectionPixelShader";
const $49fd5ba9a8adcd7e$var$shader = `varying vec2 vUV;uniform sampler2D textureSampler;uniform vec2 LensCenter;uniform vec2 Scale;uniform vec2 ScaleIn;uniform vec4 HmdWarpParam;vec2 HmdWarp(vec2 in01) {vec2 theta=(in01-LensCenter)*ScaleIn; 
float rSq=theta.x*theta.x+theta.y*theta.y;vec2 rvector=theta*(HmdWarpParam.x+HmdWarpParam.y*rSq+HmdWarpParam.z*rSq*rSq+HmdWarpParam.w*rSq*rSq*rSq);return LensCenter+Scale*rvector;}
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{vec2 tc=HmdWarp(vUV);if (tc.x <0.0 || tc.x>1.0 || tc.y<0.0 || tc.y>1.0)
gl_FragColor=vec4(0.0,0.0,0.0,0.0);else{gl_FragColor=texture2D(textureSampler,tc);}}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$49fd5ba9a8adcd7e$var$name] = $49fd5ba9a8adcd7e$var$shader;
const $49fd5ba9a8adcd7e$export$9b8e76020ac527bc = {
    name: $49fd5ba9a8adcd7e$var$name,
    shader: $49fd5ba9a8adcd7e$var$shader
};

});


parcelRegister("8zuLY", function(module, exports) {

$parcel$export(module.exports, "VRMultiviewToSingleviewPostProcess", () => $63d9767624af80a0$export$6c970232ff7c1b5b);

var $j2mX5 = parcelRequire("j2mX5");

var $cFdBb = parcelRequire("cFdBb");
parcelRequire("3Kjdd");
parcelRequire("hHHx5");
class $63d9767624af80a0$export$6c970232ff7c1b5b extends (0, $cFdBb.PostProcess) {
    /**
     * Gets a string identifying the name of the class
     * @returns "VRMultiviewToSingleviewPostProcess" string
     */ getClassName() {
        return "VRMultiviewToSingleviewPostProcess";
    }
    /**
     * Initializes a VRMultiviewToSingleview
     * @param name name of the post process
     * @param camera camera to be applied to
     * @param scaleFactor scaling factor to the size of the output texture
     */ constructor(name, camera, scaleFactor){
        super(name, "vrMultiviewToSingleview", [
            "imageIndex"
        ], [
            "multiviewSampler"
        ], scaleFactor, camera, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE);
        const cam = camera ?? this.getCamera();
        this.onSizeChangedObservable.add(()=>{});
        this.onApplyObservable.add((effect)=>{
            if (cam._scene.activeCamera && cam._scene.activeCamera.isLeftCamera) effect.setInt("imageIndex", 0);
            else effect.setInt("imageIndex", 1);
            effect.setTexture("multiviewSampler", cam._multiviewTexture);
        });
    }
}

});
parcelRegister("3Kjdd", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $2ba492162eaaf31b$var$name = "vrMultiviewToSingleviewPixelShader";
const $2ba492162eaaf31b$var$shader = `precision mediump sampler2DArray;varying vec2 vUV;uniform sampler2DArray multiviewSampler;uniform int imageIndex;
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{gl_FragColor=texture2D(multiviewSampler,vec3(vUV,imageIndex));}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$2ba492162eaaf31b$var$name] = $2ba492162eaaf31b$var$shader;
const $2ba492162eaaf31b$export$1131ca1cb3be4b6a = {
    name: $2ba492162eaaf31b$var$name,
    shader: $2ba492162eaaf31b$var$shader
};

});

parcelRegister("hHHx5", function(module, exports) {

var $74SKQ = parcelRequire("74SKQ");

var $5YkyR = parcelRequire("5YkyR");

var $gmbCk = parcelRequire("gmbCk");

var $b9e4a = parcelRequire("b9e4a");

var $ha1VO = parcelRequire("ha1VO");

var $ghoTi = parcelRequire("ghoTi");

var $3pccG = parcelRequire("3pccG");

var $9sPMJ = parcelRequire("9sPMJ");
(0, $5YkyR.Engine).prototype.createMultiviewRenderTargetTexture = function(width, height, colorTexture, depthStencilTexture) {
    const gl = this._gl;
    if (!this.getCaps().multiview) // eslint-disable-next-line no-throw-literal
    throw "Multiview is not supported";
    const rtWrapper = this._createHardwareRenderTargetWrapper(false, false, {
        width: width,
        height: height
    });
    rtWrapper._framebuffer = gl.createFramebuffer();
    const internalTexture = new (0, $b9e4a.InternalTexture)(this, (0, $b9e4a.InternalTextureSource).Unknown, true);
    internalTexture.width = width;
    internalTexture.height = height;
    internalTexture.isMultiview = true;
    if (!colorTexture) {
        colorTexture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D_ARRAY, colorTexture);
        gl.texStorage3D(gl.TEXTURE_2D_ARRAY, 1, gl.RGBA8, width, height, 2);
    }
    rtWrapper._colorTextureArray = colorTexture;
    if (!depthStencilTexture) {
        depthStencilTexture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D_ARRAY, depthStencilTexture);
        gl.texStorage3D(gl.TEXTURE_2D_ARRAY, 1, gl.DEPTH24_STENCIL8, width, height, 2);
    }
    rtWrapper._depthStencilTextureArray = depthStencilTexture;
    internalTexture.isReady = true;
    rtWrapper.setTextures(internalTexture);
    rtWrapper._depthStencilTexture = internalTexture;
    return rtWrapper;
};
(0, $5YkyR.Engine).prototype.bindMultiviewFramebuffer = function(_multiviewTexture) {
    const multiviewTexture = _multiviewTexture;
    const gl = this._gl;
    const ext = this.getCaps().oculusMultiview || this.getCaps().multiview;
    this.bindFramebuffer(multiviewTexture, undefined, undefined, undefined, true);
    gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, multiviewTexture._framebuffer);
    if (multiviewTexture._colorTextureArray && multiviewTexture._depthStencilTextureArray) {
        if (this.getCaps().oculusMultiview) {
            ext.framebufferTextureMultisampleMultiviewOVR(gl.DRAW_FRAMEBUFFER, gl.COLOR_ATTACHMENT0, multiviewTexture._colorTextureArray, 0, multiviewTexture.samples, 0, 2);
            ext.framebufferTextureMultisampleMultiviewOVR(gl.DRAW_FRAMEBUFFER, gl.DEPTH_STENCIL_ATTACHMENT, multiviewTexture._depthStencilTextureArray, 0, multiviewTexture.samples, 0, 2);
        } else {
            ext.framebufferTextureMultiviewOVR(gl.DRAW_FRAMEBUFFER, gl.COLOR_ATTACHMENT0, multiviewTexture._colorTextureArray, 0, 0, 2);
            ext.framebufferTextureMultiviewOVR(gl.DRAW_FRAMEBUFFER, gl.DEPTH_STENCIL_ATTACHMENT, multiviewTexture._depthStencilTextureArray, 0, 0, 2);
        }
    } else // eslint-disable-next-line no-throw-literal
    throw "Invalid multiview frame buffer";
};
(0, $5YkyR.Engine).prototype.bindSpaceWarpFramebuffer = function(_spaceWarpTexture) {
    const spaceWarpTexture = _spaceWarpTexture;
    const gl = this._gl;
    const ext = this.getCaps().oculusMultiview || this.getCaps().multiview;
    this.bindFramebuffer(spaceWarpTexture, undefined, undefined, undefined, true);
    gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, spaceWarpTexture._framebuffer);
    if (spaceWarpTexture._colorTextureArray && spaceWarpTexture._depthStencilTextureArray) {
        ext.framebufferTextureMultiviewOVR(gl.DRAW_FRAMEBUFFER, gl.COLOR_ATTACHMENT0, spaceWarpTexture._colorTextureArray, 0, 0, 2);
        ext.framebufferTextureMultiviewOVR(gl.DRAW_FRAMEBUFFER, gl.DEPTH_ATTACHMENT, spaceWarpTexture._depthStencilTextureArray, 0, 0, 2);
    } else throw new Error("Invalid Space Warp framebuffer");
};
(0, $74SKQ.Camera).prototype._useMultiviewToSingleView = false;
(0, $74SKQ.Camera).prototype._multiviewTexture = null;
(0, $74SKQ.Camera).prototype._resizeOrCreateMultiviewTexture = function(width, height) {
    if (!this._multiviewTexture) this._multiviewTexture = new (0, $3pccG.MultiviewRenderTarget)(this.getScene(), {
        width: width,
        height: height
    });
    else if (this._multiviewTexture.getRenderWidth() != width || this._multiviewTexture.getRenderHeight() != height) {
        this._multiviewTexture.dispose();
        this._multiviewTexture = new (0, $3pccG.MultiviewRenderTarget)(this.getScene(), {
            width: width,
            height: height
        });
    }
};
function $ce383885d13a47fa$var$createMultiviewUbo(engine, name) {
    const ubo = new (0, $ghoTi.UniformBuffer)(engine, undefined, true, name);
    ubo.addUniform("viewProjection", 16);
    ubo.addUniform("viewProjectionR", 16);
    ubo.addUniform("view", 16);
    ubo.addUniform("projection", 16);
    ubo.addUniform("vEyePosition", 4);
    return ubo;
}
const $ce383885d13a47fa$var$currentCreateSceneUniformBuffer = (0, $gmbCk.Scene).prototype.createSceneUniformBuffer;
(0, $gmbCk.Scene).prototype._transformMatrixR = (0, $ha1VO.Matrix).Zero();
(0, $gmbCk.Scene).prototype._multiviewSceneUbo = null;
(0, $gmbCk.Scene).prototype._createMultiviewUbo = function() {
    this._multiviewSceneUbo = $ce383885d13a47fa$var$createMultiviewUbo(this.getEngine(), "scene_multiview");
};
(0, $gmbCk.Scene).prototype.createSceneUniformBuffer = function(name) {
    if (this._multiviewSceneUbo) return $ce383885d13a47fa$var$createMultiviewUbo(this.getEngine(), name);
    return $ce383885d13a47fa$var$currentCreateSceneUniformBuffer.bind(this)(name);
};
(0, $gmbCk.Scene).prototype._updateMultiviewUbo = function(viewR, projectionR) {
    if (viewR && projectionR) viewR.multiplyToRef(projectionR, this._transformMatrixR);
    if (viewR && projectionR) {
        viewR.multiplyToRef(projectionR, (0, $ha1VO.TmpVectors).Matrix[0]);
        (0, $9sPMJ.Frustum).GetRightPlaneToRef((0, $ha1VO.TmpVectors).Matrix[0], this._frustumPlanes[3]); // Replace right plane by second camera right plane
    }
    if (this._multiviewSceneUbo) {
        this._multiviewSceneUbo.updateMatrix("viewProjection", this.getTransformMatrix());
        this._multiviewSceneUbo.updateMatrix("viewProjectionR", this._transformMatrixR);
        this._multiviewSceneUbo.updateMatrix("view", this._viewMatrix);
        this._multiviewSceneUbo.updateMatrix("projection", this._projectionMatrix);
    }
};
(0, $gmbCk.Scene).prototype._renderMultiviewToSingleView = function(camera) {
    // Multiview is only able to be displayed directly for API's such as webXR
    // This displays a multiview image by rendering to the multiview image and then
    // copying the result into the sub cameras instead of rendering them and proceeding as normal from there
    // Render to a multiview texture
    camera._resizeOrCreateMultiviewTexture(camera._rigPostProcess && camera._rigPostProcess && camera._rigPostProcess.width > 0 ? camera._rigPostProcess.width : this.getEngine().getRenderWidth(true), camera._rigPostProcess && camera._rigPostProcess && camera._rigPostProcess.height > 0 ? camera._rigPostProcess.height : this.getEngine().getRenderHeight(true));
    if (!this._multiviewSceneUbo) this._createMultiviewUbo();
    camera.outputRenderTarget = camera._multiviewTexture;
    this._renderForCamera(camera);
    camera.outputRenderTarget = null;
    // Consume the multiview texture through a shader for each eye
    for(let index = 0; index < camera._rigCameras.length; index++){
        const engine = this.getEngine();
        this._activeCamera = camera._rigCameras[index];
        engine.setViewport(this._activeCamera.viewport);
        if (this.postProcessManager) {
            this.postProcessManager._prepareFrame();
            this.postProcessManager._finalizeFrame(this._activeCamera.isIntermediate);
        }
    }
};

});
parcelRegister("3pccG", function(module, exports) {

$parcel$export(module.exports, "MultiviewRenderTarget", () => $27ad2c49202734de$export$a76ccd6a1413d8eb);

var $gQtNK = parcelRequire("gQtNK");
class $27ad2c49202734de$export$a76ccd6a1413d8eb extends (0, $gQtNK.RenderTargetTexture) {
    set samples(value) {
        // We override this setter because multisampling is handled by framebufferTextureMultisampleMultiviewOVR
        this._samples = value;
    }
    get samples() {
        return this._samples;
    }
    /**
     * Creates a multiview render target
     * @param scene scene used with the render target
     * @param size the size of the render target (used for each view)
     */ constructor(scene, size = 512){
        super("multiview rtt", size, scene, false, true, 0, false, undefined, false, false, true, undefined, true);
        this._renderTarget = this.getScene().getEngine().createMultiviewRenderTargetTexture(this.getRenderWidth(), this.getRenderHeight());
        this._texture = this._renderTarget.texture;
        this._texture.isMultiview = true;
        this._texture.format = 5;
        this.samples = this._getEngine().getCaps().maxSamples || this.samples;
        this._texture.samples = this._samples;
    }
    /**
     * @internal
     */ _bindFrameBuffer() {
        if (!this._renderTarget) return;
        this.getScene().getEngine().bindMultiviewFramebuffer(this._renderTarget);
    }
    /**
     * Gets the number of views the corresponding to the texture (eg. a MultiviewRenderTarget will have > 1)
     * @returns the view count
     */ getViewCount() {
        return 2;
    }
}

});





parcelRegister("1nWIF", function(module, exports) {

$parcel$export(module.exports, "VRDeviceOrientationFreeCamera", () => $10257cdffd3c72dc$export$ddeb2296e6bdf5d8);

var $74SKQ = parcelRequire("74SKQ");

var $aR7MK = parcelRequire("aR7MK");

var $9ZOCK = parcelRequire("9ZOCK");

var $ha1VO = parcelRequire("ha1VO");

var $bgssx = parcelRequire("bgssx");

var $iAaRG = parcelRequire("iAaRG");
(0, $bgssx.Node).AddNodeConstructor("VRDeviceOrientationFreeCamera", (name, scene)=>{
    return ()=>new $10257cdffd3c72dc$export$ddeb2296e6bdf5d8(name, (0, $ha1VO.Vector3).Zero(), scene);
});
class $10257cdffd3c72dc$export$ddeb2296e6bdf5d8 extends (0, $aR7MK.DeviceOrientationCamera) {
    /**
     * Creates a new VRDeviceOrientationFreeCamera
     * @param name defines camera name
     * @param position defines the start position of the camera
     * @param scene defines the scene the camera belongs to
     * @param compensateDistortion defines if the camera needs to compensate the lens distortion
     * @param vrCameraMetrics defines the vr metrics associated to the camera
     */ constructor(name, position, scene, compensateDistortion = true, vrCameraMetrics = (0, $9ZOCK.VRCameraMetrics).GetDefault()){
        super(name, position, scene);
        this._setRigMode = (rigParams)=>(0, $iAaRG.setVRRigMode)(this, rigParams);
        vrCameraMetrics.compensateDistortion = compensateDistortion;
        this.setCameraRigMode((0, $74SKQ.Camera).RIG_MODE_VR, {
            vrCameraMetrics: vrCameraMetrics
        });
    }
    /**
     * Gets camera class name
     * @returns VRDeviceOrientationFreeCamera
     */ getClassName() {
        return "VRDeviceOrientationFreeCamera";
    }
}

});

parcelRegister("g7esv", function(module, exports) {

$parcel$export(module.exports, "VRDeviceOrientationGamepadCamera", () => $bbb8840275395f1b$export$af05f5977096ed23);

var $1nWIF = parcelRequire("1nWIF");

var $9ZOCK = parcelRequire("9ZOCK");

var $ha1VO = parcelRequire("ha1VO");

var $bgssx = parcelRequire("bgssx");

var $iAaRG = parcelRequire("iAaRG");
parcelRequire("6VDMQ");
(0, $bgssx.Node).AddNodeConstructor("VRDeviceOrientationGamepadCamera", (name, scene)=>{
    return ()=>new $bbb8840275395f1b$export$af05f5977096ed23(name, (0, $ha1VO.Vector3).Zero(), scene);
});
class $bbb8840275395f1b$export$af05f5977096ed23 extends (0, $1nWIF.VRDeviceOrientationFreeCamera) {
    /**
     * Creates a new VRDeviceOrientationGamepadCamera
     * @param name defines camera name
     * @param position defines the start position of the camera
     * @param scene defines the scene the camera belongs to
     * @param compensateDistortion defines if the camera needs to compensate the lens distortion
     * @param vrCameraMetrics defines the vr metrics associated to the camera
     */ constructor(name, position, scene, compensateDistortion = true, vrCameraMetrics = (0, $9ZOCK.VRCameraMetrics).GetDefault()){
        super(name, position, scene, compensateDistortion, vrCameraMetrics);
        this._setRigMode = (rigParams)=>(0, $iAaRG.setVRRigMode)(this, rigParams);
        this.inputs.addGamepad();
    }
    /**
     * Gets camera class name
     * @returns VRDeviceOrientationGamepadCamera
     */ getClassName() {
        return "VRDeviceOrientationGamepadCamera";
    }
}

});

parcelRegister("hLYkZ", function(module, exports) {

$parcel$export(module.exports, "OnAfterEnteringVRObservableEvent", () => $cf05a141461916bb$export$408e53ea716531c5);
$parcel$export(module.exports, "VRExperienceHelper", () => $cf05a141461916bb$export$a18a2ae66d6c0fab);

var $kVtWi = parcelRequire("kVtWi");

var $diGQf = parcelRequire("diGQf");

var $gSOV5 = parcelRequire("gSOV5");

var $fJj0G = parcelRequire("fJj0G");

var $aR7MK = parcelRequire("aR7MK");

var $1nWIF = parcelRequire("1nWIF");

var $cfkw4 = parcelRequire("cfkw4");

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $6gZ9Y = parcelRequire("6gZ9Y");

var $3OBdT = parcelRequire("3OBdT");

var $3kez7 = parcelRequire("3kez7");

var $dG1pf = parcelRequire("dG1pf");

var $gAH3H = parcelRequire("gAH3H");

var $fJfwX = parcelRequire("fJfwX");

var $01TD7 = parcelRequire("01TD7");

var $lWogh = parcelRequire("lWogh");
parcelRequire("6VDMQ");
parcelRequire("aAGn3");

var $2isQc = parcelRequire("2isQc");

var $jknux = parcelRequire("jknux");

var $8CiHO = parcelRequire("8CiHO");

var $bCJrn = parcelRequire("bCJrn");
class $cf05a141461916bb$var$VRExperienceHelperGazer {
    constructor(scene, gazeTrackerToClone = null){
        this.scene = scene;
        /** @internal */ this._pointerDownOnMeshAsked = false;
        /** @internal */ this._isActionableMesh = false;
        /** @internal */ this._teleportationRequestInitiated = false;
        /** @internal */ this._teleportationBackRequestInitiated = false;
        /** @internal */ this._rotationRightAsked = false;
        /** @internal */ this._rotationLeftAsked = false;
        /** @internal */ this._dpadPressed = true;
        /** @internal */ this._activePointer = false;
        this._id = $cf05a141461916bb$var$VRExperienceHelperGazer._IdCounter++;
        // Gaze tracker
        if (!gazeTrackerToClone) {
            this._gazeTracker = (0, $bCJrn.CreateTorus)("gazeTracker", {
                diameter: 0.0035,
                thickness: 0.0025,
                tessellation: 20,
                updatable: false
            }, scene);
            this._gazeTracker.bakeCurrentTransformIntoVertices();
            this._gazeTracker.isPickable = false;
            this._gazeTracker.isVisible = false;
            const targetMat = new (0, $gAH3H.StandardMaterial)("targetMat", scene);
            targetMat.specularColor = (0, $7etnY.Color3).Black();
            targetMat.emissiveColor = new (0, $7etnY.Color3)(0.7, 0.7, 0.7);
            targetMat.backFaceCulling = false;
            this._gazeTracker.material = targetMat;
        } else this._gazeTracker = gazeTrackerToClone.clone("gazeTracker");
    }
    /**
     * @internal
     */ _getForwardRay(length) {
        return new (0, $3kez7.Ray)((0, $ha1VO.Vector3).Zero(), new (0, $ha1VO.Vector3)(0, 0, length));
    }
    /** @internal */ _selectionPointerDown() {
        this._pointerDownOnMeshAsked = true;
        if (this._currentHit) this.scene.simulatePointerDown(this._currentHit, {
            pointerId: this._id
        });
    }
    /** @internal */ _selectionPointerUp() {
        if (this._currentHit) this.scene.simulatePointerUp(this._currentHit, {
            pointerId: this._id
        });
        this._pointerDownOnMeshAsked = false;
    }
    /** @internal */ _activatePointer() {
        this._activePointer = true;
    }
    /** @internal */ _deactivatePointer() {
        this._activePointer = false;
    }
    /**
     * @internal
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _updatePointerDistance(distance = 100) {}
    dispose() {
        this._interactionsEnabled = false;
        this._teleportationEnabled = false;
        if (this._gazeTracker) this._gazeTracker.dispose();
    }
}
$cf05a141461916bb$var$VRExperienceHelperGazer._IdCounter = 0;
class $cf05a141461916bb$var$VRExperienceHelperCameraGazer extends $cf05a141461916bb$var$VRExperienceHelperGazer {
    constructor(_getCamera, scene){
        super(scene);
        this._getCamera = _getCamera;
    }
    _getForwardRay(length) {
        const camera = this._getCamera();
        if (camera) return camera.getForwardRay(length);
        else return new (0, $3kez7.Ray)((0, $ha1VO.Vector3).Zero(), (0, $ha1VO.Vector3).Forward());
    }
}
class $cf05a141461916bb$export$408e53ea716531c5 {
}
class $cf05a141461916bb$export$a18a2ae66d6c0fab {
    /** Return this.onEnteringVRObservable
     * Note: This one is for backward compatibility. Please use onEnteringVRObservable directly
     */ get onEnteringVR() {
        return this.onEnteringVRObservable;
    }
    /** Return this.onExitingVRObservable
     * Note: This one is for backward compatibility. Please use onExitingVRObservable directly
     */ get onExitingVR() {
        return this.onExitingVRObservable;
    }
    /**
     * The mesh used to display where the user is going to teleport.
     */ get teleportationTarget() {
        return this._teleportationTarget;
    }
    /**
     * Sets the mesh to be used to display where the user is going to teleport.
     */ set teleportationTarget(value) {
        if (value) {
            value.name = "teleportationTarget";
            this._isDefaultTeleportationTarget = false;
            this._teleportationTarget = value;
        }
    }
    /**
     * The mesh used to display where the user is selecting, this mesh will be cloned and set as the gazeTracker for the left and right controller
     * when set bakeCurrentTransformIntoVertices will be called on the mesh.
     * See https://doc.babylonjs.com/features/featuresDeepDive/mesh/transforms/center_origin/bakingTransforms
     */ get gazeTrackerMesh() {
        return this._cameraGazer._gazeTracker;
    }
    set gazeTrackerMesh(value) {
        if (value) {
            // Dispose of existing meshes
            if (this._cameraGazer._gazeTracker) this._cameraGazer._gazeTracker.dispose();
            // Set and create gaze trackers on head and controllers
            this._cameraGazer._gazeTracker = value;
            this._cameraGazer._gazeTracker.bakeCurrentTransformIntoVertices();
            this._cameraGazer._gazeTracker.isPickable = false;
            this._cameraGazer._gazeTracker.isVisible = false;
            this._cameraGazer._gazeTracker.name = "gazeTracker";
        }
    }
    /**
     * If the ray of the gaze should be displayed.
     */ get displayGaze() {
        return this._displayGaze;
    }
    /**
     * Sets if the ray of the gaze should be displayed.
     */ set displayGaze(value) {
        this._displayGaze = value;
        if (!value) this._cameraGazer._gazeTracker.isVisible = false;
    }
    /**
     * If the ray of the LaserPointer should be displayed.
     */ get displayLaserPointer() {
        return this._displayLaserPointer;
    }
    /**
     * Sets if the ray of the LaserPointer should be displayed.
     */ set displayLaserPointer(value) {
        this._displayLaserPointer = value;
    }
    /**
     * The deviceOrientationCamera used as the camera when not in VR.
     */ get deviceOrientationCamera() {
        return this._deviceOrientationCamera;
    }
    /**
     * Based on the current WebVR support, returns the current VR camera used.
     */ get currentVRCamera() {
        return this._scene.activeCamera;
    }
    /**
     * The deviceOrientationCamera that is used as a fallback when vr device is not connected.
     */ get vrDeviceOrientationCamera() {
        return this._vrDeviceOrientationCamera;
    }
    /**
     * The html button that is used to trigger entering into VR.
     */ get vrButton() {
        return this._btnVR;
    }
    get _teleportationRequestInitiated() {
        return this._cameraGazer._teleportationRequestInitiated;
    }
    /**
     * Instantiates a VRExperienceHelper.
     * Helps to quickly add VR support to an existing scene.
     * @param scene The scene the VRExperienceHelper belongs to.
     * @param webVROptions Options to modify the vr experience helper's behavior.
     */ constructor(scene, /** Options to modify the vr experience helper's behavior. */ webVROptions = {}){
        this.webVROptions = webVROptions;
        // Are we presenting in the fullscreen fallback?
        this._fullscreenVRpresenting = false;
        /**
         * Gets or sets a boolean indicating that gaze can be enabled even if pointer lock is not engage (useful on iOS where fullscreen mode and pointer lock are not supported)
         */ this.enableGazeEvenWhenNoPointerLock = false;
        /**
         * Gets or sets a boolean indicating that the VREXperienceHelper will exit VR if double tap is detected
         */ this.exitVROnDoubleTap = true;
        /**
         * Observable raised right before entering VR.
         */ this.onEnteringVRObservable = new (0, $diGQf.Observable)();
        /**
         * Observable raised when entering VR has completed.
         */ this.onAfterEnteringVRObservable = new (0, $diGQf.Observable)();
        /**
         * Observable raised when exiting VR.
         */ this.onExitingVRObservable = new (0, $diGQf.Observable)();
        this._useCustomVRButton = false;
        this._teleportActive = false;
        this._floorMeshesCollection = [];
        this._teleportationMode = $cf05a141461916bb$export$a18a2ae66d6c0fab.TELEPORTATIONMODE_CONSTANTTIME;
        this._teleportationTime = 122;
        this._teleportationSpeed = 20;
        this._rotationAllowed = true;
        this._teleportBackwardsVector = new (0, $ha1VO.Vector3)(0, -1, -1);
        this._isDefaultTeleportationTarget = true;
        this._teleportationFillColor = "#444444";
        this._teleportationBorderColor = "#FFFFFF";
        this._rotationAngle = 0;
        this._haloCenter = new (0, $ha1VO.Vector3)(0, 0, 0);
        this._padSensibilityUp = 0.65;
        this._padSensibilityDown = 0.35;
        this._pickedLaserColor = new (0, $7etnY.Color3)(0.2, 0.2, 1);
        this._pickedGazeColor = new (0, $7etnY.Color3)(0, 0, 1);
        /**
         * Observable raised when a new mesh is selected based on meshSelectionPredicate
         */ this.onNewMeshSelected = new (0, $diGQf.Observable)();
        /**
         * Observable raised when a new mesh is picked based on meshSelectionPredicate
         */ this.onNewMeshPicked = new (0, $diGQf.Observable)();
        /**
         * Observable raised before camera teleportation
         */ this.onBeforeCameraTeleport = new (0, $diGQf.Observable)();
        /**
         *  Observable raised after camera teleportation
         */ this.onAfterCameraTeleport = new (0, $diGQf.Observable)();
        /**
         * Observable raised when current selected mesh gets unselected
         */ this.onSelectedMeshUnselected = new (0, $diGQf.Observable)();
        /**
         * Set teleportation enabled. If set to false camera teleportation will be disabled but camera rotation will be kept.
         */ this.teleportationEnabled = true;
        this._teleportationInitialized = false;
        this._interactionsEnabled = false;
        this._displayGaze = true;
        this._displayLaserPointer = true;
        /**
         * If the gaze trackers scale should be updated to be constant size when pointing at near/far meshes
         */ this.updateGazeTrackerScale = true;
        /**
         * If the gaze trackers color should be updated when selecting meshes
         */ this.updateGazeTrackerColor = true;
        /**
         * If the controller laser color should be updated when selecting meshes
         */ this.updateControllerLaserColor = true;
        /**
         * Defines whether or not Pointer lock should be requested when switching to
         * full screen.
         */ this.requestPointerLockOnFullScreen = true;
        /**
         * Was the XR test done already. If this is true AND this.xr exists, xr is initialized.
         * If this is true and no this.xr, xr exists but is not supported, using WebVR.
         */ this.xrTestDone = false;
        this._onResize = ()=>{
            this._moveButtonToBottomRight();
        };
        this._onFullscreenChange = ()=>{
            this._fullscreenVRpresenting = !!document.fullscreenElement;
            if (!this._fullscreenVRpresenting && this._inputElement) {
                this.exitVR();
                if (!this._useCustomVRButton && this._btnVR) {
                    this._btnVR.style.top = this._inputElement.offsetTop + this._inputElement.offsetHeight - 70 + "px";
                    this._btnVR.style.left = this._inputElement.offsetLeft + this._inputElement.offsetWidth - 100 + "px";
                    // make sure the button is visible after setting its position
                    this._updateButtonVisibility();
                }
            }
        };
        this._cachedAngularSensibility = {
            angularSensibilityX: null,
            angularSensibilityY: null,
            angularSensibility: null
        };
        this._beforeRender = ()=>{
            if (this._scene.getEngine().isPointerLock || this.enableGazeEvenWhenNoPointerLock) ;
            else this._cameraGazer._gazeTracker.isVisible = false;
        };
        this._onNewGamepadConnected = (gamepad)=>{
            if (gamepad.type !== (0, $6gZ9Y.Gamepad).POSE_ENABLED) {
                if (gamepad.leftStick) gamepad.onleftstickchanged((stickValues)=>{
                    if (this._teleportationInitialized && this.teleportationEnabled) {
                        // Listening to classic/xbox gamepad only if no VR controller is active
                        this._checkTeleportWithRay(stickValues, this._cameraGazer);
                        this._checkTeleportBackwards(stickValues, this._cameraGazer);
                    }
                });
                if (gamepad.rightStick) gamepad.onrightstickchanged((stickValues)=>{
                    if (this._teleportationInitialized) this._checkRotate(stickValues, this._cameraGazer);
                });
                if (gamepad.type === (0, $6gZ9Y.Gamepad).XBOX) {
                    gamepad.onbuttondown((buttonPressed)=>{
                        if (this._interactionsEnabled && buttonPressed === (0, $3OBdT.Xbox360Button).A) this._cameraGazer._selectionPointerDown();
                    });
                    gamepad.onbuttonup((buttonPressed)=>{
                        if (this._interactionsEnabled && buttonPressed === (0, $3OBdT.Xbox360Button).A) this._cameraGazer._selectionPointerUp();
                    });
                }
            }
        };
        this._workingVector = (0, $ha1VO.Vector3).Zero();
        this._workingQuaternion = (0, $ha1VO.Quaternion).Identity();
        this._workingMatrix = (0, $ha1VO.Matrix).Identity();
        (0, $kVtWi.Logger).Warn("WebVR is deprecated. Please avoid using this experience helper and use the WebXR experience helper instead");
        this._scene = scene;
        this._inputElement = scene.getEngine().getInputElement();
        // check for VR support:
        const vrSupported = "getVRDisplays" in navigator;
        // no VR support? force XR but only when it is not set because web vr can work without the getVRDisplays
        if (!vrSupported && webVROptions.useXR === undefined) webVROptions.useXR = true;
        // Parse options
        if (webVROptions.createFallbackVRDeviceOrientationFreeCamera === undefined) webVROptions.createFallbackVRDeviceOrientationFreeCamera = true;
        if (webVROptions.createDeviceOrientationCamera === undefined) webVROptions.createDeviceOrientationCamera = true;
        if (webVROptions.laserToggle === undefined) webVROptions.laserToggle = true;
        this._hasEnteredVR = false;
        // Set position
        if (this._scene.activeCamera) this._position = this._scene.activeCamera.position.clone();
        else this._position = new (0, $ha1VO.Vector3)(0, this._defaultHeight, 0);
        // Set non-vr camera
        if (webVROptions.createDeviceOrientationCamera || !this._scene.activeCamera) {
            this._deviceOrientationCamera = new (0, $aR7MK.DeviceOrientationCamera)("deviceOrientationVRHelper", this._position.clone(), scene);
            // Copy data from existing camera
            if (this._scene.activeCamera) {
                this._deviceOrientationCamera.minZ = this._scene.activeCamera.minZ;
                this._deviceOrientationCamera.maxZ = this._scene.activeCamera.maxZ;
                // Set rotation from previous camera
                if (this._scene.activeCamera instanceof (0, $fJj0G.TargetCamera) && this._scene.activeCamera.rotation) {
                    const targetCamera = this._scene.activeCamera;
                    if (targetCamera.rotationQuaternion) this._deviceOrientationCamera.rotationQuaternion.copyFrom(targetCamera.rotationQuaternion);
                    else this._deviceOrientationCamera.rotationQuaternion.copyFrom((0, $ha1VO.Quaternion).RotationYawPitchRoll(targetCamera.rotation.y, targetCamera.rotation.x, targetCamera.rotation.z));
                    this._deviceOrientationCamera.rotation = targetCamera.rotation.clone();
                }
            }
            this._scene.activeCamera = this._deviceOrientationCamera;
            if (this._inputElement) this._scene.activeCamera.attachControl();
        } else this._existingCamera = this._scene.activeCamera;
        if (this.webVROptions.useXR && navigator.xr) // force-check XR session support
        (0, $2isQc.WebXRSessionManager).IsSessionSupportedAsync("immersive-vr").then((supported)=>{
            if (supported) {
                (0, $kVtWi.Logger).Log("Using WebXR. It is recommended to use the WebXRDefaultExperience directly");
                // it is possible to use XR, let's do it!
                scene.createDefaultXRExperienceAsync({
                    floorMeshes: webVROptions.floorMeshes || []
                }).then((xr)=>{
                    this.xr = xr;
                    // connect observables
                    this.xrTestDone = true;
                    this._cameraGazer = new $cf05a141461916bb$var$VRExperienceHelperCameraGazer(()=>{
                        return this.xr.baseExperience.camera;
                    }, scene);
                    this.xr.baseExperience.onStateChangedObservable.add((state)=>{
                        // support for entering / exiting
                        switch(state){
                            case (0, $jknux.WebXRState).ENTERING_XR:
                                this.onEnteringVRObservable.notifyObservers(this);
                                if (!this._interactionsEnabled) this.xr.pointerSelection.detach();
                                this.xr.pointerSelection.displayLaserPointer = this._displayLaserPointer;
                                break;
                            case (0, $jknux.WebXRState).EXITING_XR:
                                this.onExitingVRObservable.notifyObservers(this);
                                // resize to update width and height when exiting vr exits fullscreen
                                this._scene.getEngine().resize();
                                break;
                            case (0, $jknux.WebXRState).IN_XR:
                                this._hasEnteredVR = true;
                                break;
                            case (0, $jknux.WebXRState).NOT_IN_XR:
                                this._hasEnteredVR = false;
                                break;
                        }
                    });
                });
            } else // XR not supported (thou exists), continue WebVR init
            this._completeVRInit(scene, webVROptions);
        });
        else // no XR, continue init synchronous
        this._completeVRInit(scene, webVROptions);
    }
    _completeVRInit(scene, webVROptions) {
        this.xrTestDone = true;
        // Create VR cameras
        if (webVROptions.createFallbackVRDeviceOrientationFreeCamera) {
            this._vrDeviceOrientationCamera = new (0, $1nWIF.VRDeviceOrientationFreeCamera)("VRDeviceOrientationVRHelper", this._position, this._scene, true, webVROptions.vrDeviceOrientationCameraMetrics);
            this._vrDeviceOrientationCamera.angularSensibility = Number.MAX_VALUE;
        }
        this._cameraGazer = new $cf05a141461916bb$var$VRExperienceHelperCameraGazer(()=>{
            return this.currentVRCamera;
        }, scene);
        // Create default button
        if (!this._useCustomVRButton) {
            this._btnVR = document.createElement("BUTTON");
            this._btnVR.className = "babylonVRicon";
            this._btnVR.id = "babylonVRiconbtn";
            this._btnVR.title = "Click to switch to VR";
            const url = !window.SVGSVGElement ? "https://cdn.babylonjs.com/Assets/vrButton.png" : "data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%222048%22%20height%3D%221152%22%20viewBox%3D%220%200%202048%201152%22%20version%3D%221.1%22%3E%3Cpath%20transform%3D%22rotate%28180%201024%2C576.0000000000001%29%22%20d%3D%22m1109%2C896q17%2C0%2030%2C-12t13%2C-30t-12.5%2C-30.5t-30.5%2C-12.5l-170%2C0q-18%2C0%20-30.5%2C12.5t-12.5%2C30.5t13%2C30t30%2C12l170%2C0zm-85%2C256q59%2C0%20132.5%2C-1.5t154.5%2C-5.5t164.5%2C-11.5t163%2C-20t150%2C-30t124.5%2C-41.5q23%2C-11%2042%2C-24t38%2C-30q27%2C-25%2041%2C-61.5t14%2C-72.5l0%2C-257q0%2C-123%20-47%2C-232t-128%2C-190t-190%2C-128t-232%2C-47l-81%2C0q-37%2C0%20-68.5%2C14t-60.5%2C34.5t-55.5%2C45t-53%2C45t-53%2C34.5t-55.5%2C14t-55.5%2C-14t-53%2C-34.5t-53%2C-45t-55.5%2C-45t-60.5%2C-34.5t-68.5%2C-14l-81%2C0q-123%2C0%20-232%2C47t-190%2C128t-128%2C190t-47%2C232l0%2C257q0%2C68%2038%2C115t97%2C73q54%2C24%20124.5%2C41.5t150%2C30t163%2C20t164.5%2C11.5t154.5%2C5.5t132.5%2C1.5zm939%2C-298q0%2C39%20-24.5%2C67t-58.5%2C42q-54%2C23%20-122%2C39.5t-143.5%2C28t-155.5%2C19t-157%2C11t-148.5%2C5t-129.5%2C1.5q-59%2C0%20-130%2C-1.5t-148%2C-5t-157%2C-11t-155.5%2C-19t-143.5%2C-28t-122%2C-39.5q-34%2C-14%20-58.5%2C-42t-24.5%2C-67l0%2C-257q0%2C-106%2040.5%2C-199t110%2C-162.5t162.5%2C-109.5t199%2C-40l81%2C0q27%2C0%2052%2C14t50%2C34.5t51%2C44.5t55.5%2C44.5t63.5%2C34.5t74%2C14t74%2C-14t63.5%2C-34.5t55.5%2C-44.5t51%2C-44.5t50%2C-34.5t52%2C-14l14%2C0q37%2C0%2070%2C0.5t64.5%2C4.5t63.5%2C12t68%2C23q71%2C30%20128.5%2C78.5t98.5%2C110t63.5%2C133.5t22.5%2C149l0%2C257z%22%20fill%3D%22white%22%20/%3E%3C/svg%3E%0A";
            let css = ".babylonVRicon { position: absolute; right: 20px; height: 50px; width: 80px; background-color: rgba(51,51,51,0.7); background-image: url(" + url + "); background-size: 80%; background-repeat:no-repeat; background-position: center; border: none; outline: none; transition: transform 0.125s ease-out } .babylonVRicon:hover { transform: scale(1.05) } .babylonVRicon:active {background-color: rgba(51,51,51,1) } .babylonVRicon:focus {background-color: rgba(51,51,51,1) }";
            css += ".babylonVRicon.vrdisplaypresenting { display: none; }";
            // TODO: Add user feedback so that they know what state the VRDisplay is in (disconnected, connected, entering-VR)
            // css += ".babylonVRicon.vrdisplaysupported { }";
            // css += ".babylonVRicon.vrdisplayready { }";
            // css += ".babylonVRicon.vrdisplayrequesting { }";
            const style = document.createElement("style");
            style.appendChild(document.createTextNode(css));
            document.getElementsByTagName("head")[0].appendChild(style);
            this._moveButtonToBottomRight();
        }
        // VR button click event
        if (this._btnVR) this._btnVR.addEventListener("click", ()=>{
            if (!this.isInVRMode) this.enterVR();
        });
        // Window events
        const hostWindow = this._scene.getEngine().getHostWindow();
        if (!hostWindow) return;
        hostWindow.addEventListener("resize", this._onResize);
        document.addEventListener("fullscreenchange", this._onFullscreenChange, false);
        // Display vr button when headset is connected
        if (webVROptions.createFallbackVRDeviceOrientationFreeCamera) this._displayVRButton();
        // Exiting VR mode using 'ESC' key on desktop
        this._onKeyDown = (event)=>{
            if (event.keyCode === 27 && this.isInVRMode) this.exitVR();
        };
        document.addEventListener("keydown", this._onKeyDown);
        // Exiting VR mode double tapping the touch screen
        this._scene.onPrePointerObservable.add(()=>{
            if (this._hasEnteredVR && this.exitVROnDoubleTap) {
                this.exitVR();
                if (this._fullscreenVRpresenting) this._scene.getEngine().exitFullscreen();
            }
        }, (0, $cfkw4.PointerEventTypes).POINTERDOUBLETAP, false);
        scene.onDisposeObservable.add(()=>{
            this.dispose();
        });
        this._updateButtonVisibility();
        //create easing functions
        this._circleEase = new (0, $01TD7.CircleEase)();
        this._circleEase.setEasingMode((0, $01TD7.EasingFunction).EASINGMODE_EASEINOUT);
        this._teleportationEasing = this._circleEase;
        // Allow clicking in the vrDeviceOrientationCamera
        scene.onPointerObservable.add((e)=>{
            if (this._interactionsEnabled) {
                if (scene.activeCamera === this.vrDeviceOrientationCamera && e.event.pointerType === "mouse") {
                    if (e.type === (0, $cfkw4.PointerEventTypes).POINTERDOWN) this._cameraGazer._selectionPointerDown();
                    else if (e.type === (0, $cfkw4.PointerEventTypes).POINTERUP) this._cameraGazer._selectionPointerUp();
                }
            }
        });
        if (this.webVROptions.floorMeshes) this.enableTeleportation({
            floorMeshes: this.webVROptions.floorMeshes
        });
    }
    /**
     * Gets a value indicating if we are currently in VR mode.
     */ get isInVRMode() {
        return this.xr && this.webVROptions.useXR && this.xr.baseExperience.state === (0, $jknux.WebXRState).IN_XR || this._fullscreenVRpresenting;
    }
    _moveButtonToBottomRight() {
        if (this._inputElement && !this._useCustomVRButton && this._btnVR) {
            const rect = this._inputElement.getBoundingClientRect();
            this._btnVR.style.top = rect.top + rect.height - 70 + "px";
            this._btnVR.style.left = rect.left + rect.width - 100 + "px";
        }
    }
    _displayVRButton() {
        if (!this._useCustomVRButton && !this._btnVRDisplayed && this._btnVR) {
            document.body.appendChild(this._btnVR);
            this._btnVRDisplayed = true;
        }
    }
    _updateButtonVisibility() {
        if (!this._btnVR || this._useCustomVRButton) return;
        this._btnVR.className = "babylonVRicon";
        if (this.isInVRMode) this._btnVR.className += " vrdisplaypresenting";
    }
    /**
     * Attempt to enter VR. If a headset is connected and ready, will request present on that.
     * Otherwise, will use the fullscreen API.
     */ enterVR() {
        if (this.xr) {
            this.xr.baseExperience.enterXRAsync("immersive-vr", "local-floor", this.xr.renderTarget);
            return;
        }
        if (this.onEnteringVRObservable) try {
            this.onEnteringVRObservable.notifyObservers(this);
        } catch (err) {
            (0, $kVtWi.Logger).Warn("Error in your custom logic onEnteringVR: " + err);
        }
        if (this._scene.activeCamera) {
            this._position = this._scene.activeCamera.position.clone();
            if (this.vrDeviceOrientationCamera) {
                this.vrDeviceOrientationCamera.rotation = (0, $ha1VO.Quaternion).FromRotationMatrix(this._scene.activeCamera.getWorldMatrix().getRotationMatrix()).toEulerAngles();
                this.vrDeviceOrientationCamera.angularSensibility = 2000;
            }
            // make sure that we return to the last active camera
            this._existingCamera = this._scene.activeCamera;
            // Remove and cache angular sensability to avoid camera rotation when in VR
            if (this._existingCamera.angularSensibilityX) {
                this._cachedAngularSensibility.angularSensibilityX = this._existingCamera.angularSensibilityX;
                this._existingCamera.angularSensibilityX = Number.MAX_VALUE;
            }
            if (this._existingCamera.angularSensibilityY) {
                this._cachedAngularSensibility.angularSensibilityY = this._existingCamera.angularSensibilityY;
                this._existingCamera.angularSensibilityY = Number.MAX_VALUE;
            }
            if (this._existingCamera.angularSensibility) {
                this._cachedAngularSensibility.angularSensibility = this._existingCamera.angularSensibility;
                this._existingCamera.angularSensibility = Number.MAX_VALUE;
            }
        }
        // If WebVR is supported and a headset is connected
        if (this._vrDeviceOrientationCamera) {
            this._vrDeviceOrientationCamera.position = this._position;
            if (this._scene.activeCamera) this._vrDeviceOrientationCamera.minZ = this._scene.activeCamera.minZ;
            this._scene.activeCamera = this._vrDeviceOrientationCamera;
            this._scene.getEngine().enterFullscreen(this.requestPointerLockOnFullScreen);
            this._updateButtonVisibility();
            this._vrDeviceOrientationCamera.onViewMatrixChangedObservable.addOnce(()=>{
                this.onAfterEnteringVRObservable.notifyObservers({
                    success: true
                });
            });
        }
        if (this._scene.activeCamera && this._inputElement) this._scene.activeCamera.attachControl();
        if (this._interactionsEnabled) this._scene.registerBeforeRender(this._beforeRender);
        this._hasEnteredVR = true;
    }
    /**
     * Attempt to exit VR, or fullscreen.
     */ exitVR() {
        if (this.xr) {
            this.xr.baseExperience.exitXRAsync();
            return;
        }
        if (this._hasEnteredVR) {
            if (this.onExitingVRObservable) try {
                this.onExitingVRObservable.notifyObservers(this);
            } catch (err) {
                (0, $kVtWi.Logger).Warn("Error in your custom logic onExitingVR: " + err);
            }
            if (this._scene.activeCamera) this._position = this._scene.activeCamera.position.clone();
            if (this.vrDeviceOrientationCamera) this.vrDeviceOrientationCamera.angularSensibility = Number.MAX_VALUE;
            if (this._deviceOrientationCamera) {
                this._deviceOrientationCamera.position = this._position;
                this._scene.activeCamera = this._deviceOrientationCamera;
                // Restore angular sensibility
                if (this._cachedAngularSensibility.angularSensibilityX) {
                    this._deviceOrientationCamera.angularSensibilityX = this._cachedAngularSensibility.angularSensibilityX;
                    this._cachedAngularSensibility.angularSensibilityX = null;
                }
                if (this._cachedAngularSensibility.angularSensibilityY) {
                    this._deviceOrientationCamera.angularSensibilityY = this._cachedAngularSensibility.angularSensibilityY;
                    this._cachedAngularSensibility.angularSensibilityY = null;
                }
                if (this._cachedAngularSensibility.angularSensibility) {
                    this._deviceOrientationCamera.angularSensibility = this._cachedAngularSensibility.angularSensibility;
                    this._cachedAngularSensibility.angularSensibility = null;
                }
            } else if (this._existingCamera) {
                this._existingCamera.position = this._position;
                this._scene.activeCamera = this._existingCamera;
                if (this._inputElement) this._scene.activeCamera.attachControl();
                // Restore angular sensibility
                if (this._cachedAngularSensibility.angularSensibilityX) {
                    this._existingCamera.angularSensibilityX = this._cachedAngularSensibility.angularSensibilityX;
                    this._cachedAngularSensibility.angularSensibilityX = null;
                }
                if (this._cachedAngularSensibility.angularSensibilityY) {
                    this._existingCamera.angularSensibilityY = this._cachedAngularSensibility.angularSensibilityY;
                    this._cachedAngularSensibility.angularSensibilityY = null;
                }
                if (this._cachedAngularSensibility.angularSensibility) {
                    this._existingCamera.angularSensibility = this._cachedAngularSensibility.angularSensibility;
                    this._cachedAngularSensibility.angularSensibility = null;
                }
            }
            this._updateButtonVisibility();
            if (this._interactionsEnabled) {
                this._scene.unregisterBeforeRender(this._beforeRender);
                this._cameraGazer._gazeTracker.isVisible = false;
            }
            // resize to update width and height when exiting vr exits fullscreen
            this._scene.getEngine().resize();
            this._hasEnteredVR = false;
        }
    }
    /**
     * The position of the vr experience helper.
     */ get position() {
        return this._position;
    }
    /**
     * Sets the position of the vr experience helper.
     */ set position(value) {
        this._position = value;
        if (this._scene.activeCamera) this._scene.activeCamera.position = value;
    }
    /**
     * Enables controllers and user interactions such as selecting and object or clicking on an object.
     */ enableInteractions() {
        if (!this._interactionsEnabled) {
            // in XR it is enabled by default, but just to make sure, re-attach
            if (this.xr) {
                if (this.xr.baseExperience.state === (0, $jknux.WebXRState).IN_XR) this.xr.pointerSelection.attach();
                return;
            }
            this.raySelectionPredicate = (mesh)=>{
                return mesh.isVisible && (mesh.isPickable || mesh.name === this._floorMeshName);
            };
            this.meshSelectionPredicate = ()=>{
                return true;
            };
            this._raySelectionPredicate = (mesh)=>{
                if (this._isTeleportationFloor(mesh) || mesh.name.indexOf("gazeTracker") === -1 && mesh.name.indexOf("teleportationTarget") === -1 && mesh.name.indexOf("torusTeleportation") === -1) return this.raySelectionPredicate(mesh);
                return false;
            };
            this._interactionsEnabled = true;
        }
    }
    _isTeleportationFloor(mesh) {
        for(let i = 0; i < this._floorMeshesCollection.length; i++){
            if (this._floorMeshesCollection[i].id === mesh.id) return true;
        }
        if (this._floorMeshName && mesh.name === this._floorMeshName) return true;
        return false;
    }
    /**
     * Adds a floor mesh to be used for teleportation.
     * @param floorMesh the mesh to be used for teleportation.
     */ addFloorMesh(floorMesh) {
        if (!this._floorMeshesCollection) return;
        if (this._floorMeshesCollection.indexOf(floorMesh) > -1) return;
        this._floorMeshesCollection.push(floorMesh);
    }
    /**
     * Removes a floor mesh from being used for teleportation.
     * @param floorMesh the mesh to be removed.
     */ removeFloorMesh(floorMesh) {
        if (!this._floorMeshesCollection) return;
        const meshIndex = this._floorMeshesCollection.indexOf(floorMesh);
        if (meshIndex !== -1) this._floorMeshesCollection.splice(meshIndex, 1);
    }
    /**
     * Enables interactions and teleportation using the VR controllers and gaze.
     * @param vrTeleportationOptions options to modify teleportation behavior.
     */ enableTeleportation(vrTeleportationOptions = {}) {
        if (!this._teleportationInitialized) {
            this.enableInteractions();
            if (this.webVROptions.useXR && (vrTeleportationOptions.floorMeshes || vrTeleportationOptions.floorMeshName)) {
                const floorMeshes = vrTeleportationOptions.floorMeshes || [];
                if (!floorMeshes.length) {
                    const floorMesh = this._scene.getMeshByName(vrTeleportationOptions.floorMeshName);
                    if (floorMesh) floorMeshes.push(floorMesh);
                }
                if (this.xr) {
                    floorMeshes.forEach((mesh)=>{
                        this.xr.teleportation.addFloorMesh(mesh);
                    });
                    if (!this.xr.teleportation.attached) this.xr.teleportation.attach();
                    return;
                } else if (!this.xrTestDone) {
                    const waitForXr = ()=>{
                        if (this.xrTestDone) {
                            this._scene.unregisterBeforeRender(waitForXr);
                            if (this.xr) {
                                if (!this.xr.teleportation.attached) this.xr.teleportation.attach();
                            } else this.enableTeleportation(vrTeleportationOptions);
                        }
                    };
                    this._scene.registerBeforeRender(waitForXr);
                    return;
                }
            }
            if (vrTeleportationOptions.floorMeshName) this._floorMeshName = vrTeleportationOptions.floorMeshName;
            if (vrTeleportationOptions.floorMeshes) this._floorMeshesCollection = vrTeleportationOptions.floorMeshes;
            if (vrTeleportationOptions.teleportationMode) this._teleportationMode = vrTeleportationOptions.teleportationMode;
            if (vrTeleportationOptions.teleportationTime && vrTeleportationOptions.teleportationTime > 0) this._teleportationTime = vrTeleportationOptions.teleportationTime;
            if (vrTeleportationOptions.teleportationSpeed && vrTeleportationOptions.teleportationSpeed > 0) this._teleportationSpeed = vrTeleportationOptions.teleportationSpeed;
            if (vrTeleportationOptions.easingFunction !== undefined) this._teleportationEasing = vrTeleportationOptions.easingFunction;
            // Creates an image processing post process for the vignette not relying
            // on the main scene configuration for image processing to reduce setup and spaces
            // (gamma/linear) conflicts.
            const imageProcessingConfiguration = new (0, $dG1pf.ImageProcessingConfiguration)();
            imageProcessingConfiguration.vignetteColor = new (0, $7etnY.Color4)(0, 0, 0, 0);
            imageProcessingConfiguration.vignetteEnabled = true;
            this._teleportationInitialized = true;
            if (this._isDefaultTeleportationTarget) this._createTeleportationCircles();
        }
    }
    _checkTeleportWithRay(stateObject, gazer) {
        // Dont teleport if another gaze already requested teleportation
        if (this._teleportationRequestInitiated && !gazer._teleportationRequestInitiated) return;
        if (!gazer._teleportationRequestInitiated) {
            if (stateObject.y < -this._padSensibilityUp && gazer._dpadPressed) {
                gazer._activatePointer();
                gazer._teleportationRequestInitiated = true;
            }
        } else // Listening to the proper controller values changes to confirm teleportation
        if (Math.sqrt(stateObject.y * stateObject.y + stateObject.x * stateObject.x) < this._padSensibilityDown) {
            if (this._teleportActive) this.teleportCamera(this._haloCenter);
            gazer._teleportationRequestInitiated = false;
        }
    }
    _checkRotate(stateObject, gazer) {
        // Only rotate when user is not currently selecting a teleportation location
        if (gazer._teleportationRequestInitiated) return;
        if (!gazer._rotationLeftAsked) {
            if (stateObject.x < -this._padSensibilityUp && gazer._dpadPressed) {
                gazer._rotationLeftAsked = true;
                if (this._rotationAllowed) this._rotateCamera(false);
            }
        } else if (stateObject.x > -this._padSensibilityDown) gazer._rotationLeftAsked = false;
        if (!gazer._rotationRightAsked) {
            if (stateObject.x > this._padSensibilityUp && gazer._dpadPressed) {
                gazer._rotationRightAsked = true;
                if (this._rotationAllowed) this._rotateCamera(true);
            }
        } else if (stateObject.x < this._padSensibilityDown) gazer._rotationRightAsked = false;
    }
    _checkTeleportBackwards(stateObject, gazer) {
        // Only teleport backwards when user is not currently selecting a teleportation location
        if (gazer._teleportationRequestInitiated) return;
        // Teleport backwards
        if (stateObject.y > this._padSensibilityUp && gazer._dpadPressed) {
            if (!gazer._teleportationBackRequestInitiated) {
                if (!this.currentVRCamera) return;
                // Get rotation and position of the current camera
                const rotation = (0, $ha1VO.Quaternion).FromRotationMatrix(this.currentVRCamera.getWorldMatrix().getRotationMatrix());
                const position = this.currentVRCamera.position;
                // Get matrix with only the y rotation of the device rotation
                rotation.toEulerAnglesToRef(this._workingVector);
                this._workingVector.z = 0;
                this._workingVector.x = 0;
                (0, $ha1VO.Quaternion).RotationYawPitchRollToRef(this._workingVector.y, this._workingVector.x, this._workingVector.z, this._workingQuaternion);
                this._workingQuaternion.toRotationMatrix(this._workingMatrix);
                // Rotate backwards ray by device rotation to cast at the ground behind the user
                (0, $ha1VO.Vector3).TransformCoordinatesToRef(this._teleportBackwardsVector, this._workingMatrix, this._workingVector);
                // Teleport if ray hit the ground and is not to far away eg. backwards off a cliff
                const ray = new (0, $3kez7.Ray)(position, this._workingVector);
                const hit = this._scene.pickWithRay(ray, this._raySelectionPredicate);
                if (hit && hit.pickedPoint && hit.pickedMesh && this._isTeleportationFloor(hit.pickedMesh) && hit.distance < 5) this.teleportCamera(hit.pickedPoint);
                gazer._teleportationBackRequestInitiated = true;
            }
        } else gazer._teleportationBackRequestInitiated = false;
    }
    _createTeleportationCircles() {
        this._teleportationTarget = (0, $8CiHO.CreateGround)("teleportationTarget", {
            width: 2,
            height: 2,
            subdivisions: 2
        }, this._scene);
        this._teleportationTarget.isPickable = false;
        const length = 512;
        const dynamicTexture = new (0, $fJfwX.DynamicTexture)("DynamicTexture", length, this._scene, true);
        dynamicTexture.hasAlpha = true;
        const context = dynamicTexture.getContext();
        const centerX = length / 2;
        const centerY = length / 2;
        const radius = 200;
        context.beginPath();
        context.arc(centerX, centerY, radius, 0, 2 * Math.PI, false);
        context.fillStyle = this._teleportationFillColor;
        context.fill();
        context.lineWidth = 10;
        context.strokeStyle = this._teleportationBorderColor;
        context.stroke();
        context.closePath();
        dynamicTexture.update();
        const teleportationCircleMaterial = new (0, $gAH3H.StandardMaterial)("TextPlaneMaterial", this._scene);
        teleportationCircleMaterial.diffuseTexture = dynamicTexture;
        this._teleportationTarget.material = teleportationCircleMaterial;
        const torus = (0, $bCJrn.CreateTorus)("torusTeleportation", {
            diameter: 0.75,
            thickness: 0.1,
            tessellation: 25,
            updatable: false
        }, this._scene);
        torus.isPickable = false;
        torus.parent = this._teleportationTarget;
        const animationInnerCircle = new (0, $lWogh.Animation)("animationInnerCircle", "position.y", 30, (0, $lWogh.Animation).ANIMATIONTYPE_FLOAT, (0, $lWogh.Animation).ANIMATIONLOOPMODE_CYCLE);
        const keys = [];
        keys.push({
            frame: 0,
            value: 0
        });
        keys.push({
            frame: 30,
            value: 0.4
        });
        keys.push({
            frame: 60,
            value: 0
        });
        animationInnerCircle.setKeys(keys);
        const easingFunction = new (0, $01TD7.SineEase)();
        easingFunction.setEasingMode((0, $01TD7.EasingFunction).EASINGMODE_EASEINOUT);
        animationInnerCircle.setEasingFunction(easingFunction);
        torus.animations = [];
        torus.animations.push(animationInnerCircle);
        this._scene.beginAnimation(torus, 0, 60, true);
        this._hideTeleportationTarget();
    }
    _hideTeleportationTarget() {
        this._teleportActive = false;
        if (this._teleportationInitialized) {
            this._teleportationTarget.isVisible = false;
            if (this._isDefaultTeleportationTarget) this._teleportationTarget.getChildren()[0].isVisible = false;
        }
    }
    _rotateCamera(right) {
        if (!(this.currentVRCamera instanceof (0, $gSOV5.FreeCamera))) return;
        if (right) this._rotationAngle++;
        else this._rotationAngle--;
        this.currentVRCamera.animations = [];
        const target = (0, $ha1VO.Quaternion).FromRotationMatrix((0, $ha1VO.Matrix).RotationY(Math.PI / 4 * this._rotationAngle));
        const animationRotation = new (0, $lWogh.Animation)("animationRotation", "rotationQuaternion", 90, (0, $lWogh.Animation).ANIMATIONTYPE_QUATERNION, (0, $lWogh.Animation).ANIMATIONLOOPMODE_CONSTANT);
        const animationRotationKeys = [];
        animationRotationKeys.push({
            frame: 0,
            value: this.currentVRCamera.rotationQuaternion
        });
        animationRotationKeys.push({
            frame: 6,
            value: target
        });
        animationRotation.setKeys(animationRotationKeys);
        animationRotation.setEasingFunction(this._circleEase);
        this.currentVRCamera.animations.push(animationRotation);
        this._postProcessMove.animations = [];
        const animationPP = new (0, $lWogh.Animation)("animationPP", "vignetteWeight", 90, (0, $lWogh.Animation).ANIMATIONTYPE_FLOAT, (0, $lWogh.Animation).ANIMATIONLOOPMODE_CONSTANT);
        const vignetteWeightKeys = [];
        vignetteWeightKeys.push({
            frame: 0,
            value: 0
        });
        vignetteWeightKeys.push({
            frame: 3,
            value: 4
        });
        vignetteWeightKeys.push({
            frame: 6,
            value: 0
        });
        animationPP.setKeys(vignetteWeightKeys);
        animationPP.setEasingFunction(this._circleEase);
        this._postProcessMove.animations.push(animationPP);
        const animationPP2 = new (0, $lWogh.Animation)("animationPP2", "vignetteStretch", 90, (0, $lWogh.Animation).ANIMATIONTYPE_FLOAT, (0, $lWogh.Animation).ANIMATIONLOOPMODE_CONSTANT);
        const vignetteStretchKeys = [];
        vignetteStretchKeys.push({
            frame: 0,
            value: 0
        });
        vignetteStretchKeys.push({
            frame: 3,
            value: 10
        });
        vignetteStretchKeys.push({
            frame: 6,
            value: 0
        });
        animationPP2.setKeys(vignetteStretchKeys);
        animationPP2.setEasingFunction(this._circleEase);
        this._postProcessMove.animations.push(animationPP2);
        this._postProcessMove.imageProcessingConfiguration.vignetteWeight = 0;
        this._postProcessMove.imageProcessingConfiguration.vignetteStretch = 0;
        this._postProcessMove.samples = 4;
        this._scene.beginAnimation(this.currentVRCamera, 0, 6, false, 1);
    }
    /**
     * Teleports the users feet to the desired location
     * @param location The location where the user's feet should be placed
     */ teleportCamera(location) {
        if (!(this.currentVRCamera instanceof (0, $gSOV5.FreeCamera))) return;
        // Teleport the hmd to where the user is looking by moving the anchor to where they are looking minus the
        // offset of the headset from the anchor.
        this._workingVector.copyFrom(location);
        // Add height to account for user's height offset
        if (this.isInVRMode) ;
        else this._workingVector.y += this._defaultHeight;
        this.onBeforeCameraTeleport.notifyObservers(this._workingVector);
        // Animations FPS
        const FPS = 90;
        let speedRatio, lastFrame;
        if (this._teleportationMode == $cf05a141461916bb$export$a18a2ae66d6c0fab.TELEPORTATIONMODE_CONSTANTSPEED) {
            lastFrame = FPS;
            const dist = (0, $ha1VO.Vector3).Distance(this.currentVRCamera.position, this._workingVector);
            speedRatio = this._teleportationSpeed / dist;
        } else {
            // teleportationMode is TELEPORTATIONMODE_CONSTANTTIME
            lastFrame = Math.round(this._teleportationTime * FPS / 1000);
            speedRatio = 1;
        }
        // Create animation from the camera's position to the new location
        this.currentVRCamera.animations = [];
        const animationCameraTeleportation = new (0, $lWogh.Animation)("animationCameraTeleportation", "position", FPS, (0, $lWogh.Animation).ANIMATIONTYPE_VECTOR3, (0, $lWogh.Animation).ANIMATIONLOOPMODE_CONSTANT);
        const animationCameraTeleportationKeys = [
            {
                frame: 0,
                value: this.currentVRCamera.position
            },
            {
                frame: lastFrame,
                value: this._workingVector
            }
        ];
        animationCameraTeleportation.setKeys(animationCameraTeleportationKeys);
        animationCameraTeleportation.setEasingFunction(this._teleportationEasing);
        this.currentVRCamera.animations.push(animationCameraTeleportation);
        this._postProcessMove.animations = [];
        // Calculate the mid frame for vignette animations
        const midFrame = Math.round(lastFrame / 2);
        const animationPP = new (0, $lWogh.Animation)("animationPP", "vignetteWeight", FPS, (0, $lWogh.Animation).ANIMATIONTYPE_FLOAT, (0, $lWogh.Animation).ANIMATIONLOOPMODE_CONSTANT);
        const vignetteWeightKeys = [];
        vignetteWeightKeys.push({
            frame: 0,
            value: 0
        });
        vignetteWeightKeys.push({
            frame: midFrame,
            value: 8
        });
        vignetteWeightKeys.push({
            frame: lastFrame,
            value: 0
        });
        animationPP.setKeys(vignetteWeightKeys);
        this._postProcessMove.animations.push(animationPP);
        const animationPP2 = new (0, $lWogh.Animation)("animationPP2", "vignetteStretch", FPS, (0, $lWogh.Animation).ANIMATIONTYPE_FLOAT, (0, $lWogh.Animation).ANIMATIONLOOPMODE_CONSTANT);
        const vignetteStretchKeys = [];
        vignetteStretchKeys.push({
            frame: 0,
            value: 0
        });
        vignetteStretchKeys.push({
            frame: midFrame,
            value: 10
        });
        vignetteStretchKeys.push({
            frame: lastFrame,
            value: 0
        });
        animationPP2.setKeys(vignetteStretchKeys);
        this._postProcessMove.animations.push(animationPP2);
        this._postProcessMove.imageProcessingConfiguration.vignetteWeight = 0;
        this._postProcessMove.imageProcessingConfiguration.vignetteStretch = 0;
        this._scene.beginAnimation(this.currentVRCamera, 0, lastFrame, false, speedRatio, ()=>{
            this.onAfterCameraTeleport.notifyObservers(this._workingVector);
        });
        this._hideTeleportationTarget();
    }
    /**
     * Permanently set new colors for the laser pointer
     * @param color the new laser color
     * @param pickedColor the new laser color when picked mesh detected
     */ setLaserColor(color, pickedColor = this._pickedLaserColor) {
        this._pickedLaserColor = pickedColor;
    }
    /**
     * Set lighting enabled / disabled on the laser pointer of both controllers
     * @param _enabled should the lighting be enabled on the laser pointer
     */ setLaserLightingState(_enabled = true) {
    // no-op
    }
    /**
     * Permanently set new colors for the gaze pointer
     * @param color the new gaze color
     * @param pickedColor the new gaze color when picked mesh detected
     */ setGazeColor(color, pickedColor = this._pickedGazeColor) {
        this._pickedGazeColor = pickedColor;
    }
    /**
     * Sets the color of the laser ray from the vr controllers.
     * @param _color new color for the ray.
     */ changeLaserColor(_color) {
        if (!this.updateControllerLaserColor) return;
    }
    /**
     * Sets the color of the ray from the vr headsets gaze.
     * @param color new color for the ray.
     */ changeGazeColor(color) {
        if (!this.updateGazeTrackerColor) return;
        if (!this._cameraGazer._gazeTracker.material) return;
        this._cameraGazer._gazeTracker.material.emissiveColor = color;
    }
    /**
     * Exits VR and disposes of the vr experience helper
     */ dispose() {
        if (this.isInVRMode) this.exitVR();
        if (this._postProcessMove) this._postProcessMove.dispose();
        if (this._vrDeviceOrientationCamera) this._vrDeviceOrientationCamera.dispose();
        if (!this._useCustomVRButton && this._btnVR && this._btnVR.parentNode) document.body.removeChild(this._btnVR);
        if (this._deviceOrientationCamera && this._scene.activeCamera != this._deviceOrientationCamera) this._deviceOrientationCamera.dispose();
        if (this._cameraGazer) this._cameraGazer.dispose();
        if (this._teleportationTarget) this._teleportationTarget.dispose();
        if (this.xr) this.xr.dispose();
        this._floorMeshesCollection.length = 0;
        document.removeEventListener("keydown", this._onKeyDown);
        window.removeEventListener("vrdisplaypresentchange", this._onVrDisplayPresentChangeBind);
        window.removeEventListener("resize", this._onResize);
        document.removeEventListener("fullscreenchange", this._onFullscreenChange);
        this._scene.gamepadManager.onGamepadConnectedObservable.removeCallback(this._onNewGamepadConnected);
        this._scene.unregisterBeforeRender(this._beforeRender);
    }
    /**
     * Gets the name of the VRExperienceHelper class
     * @returns "VRExperienceHelper"
     */ getClassName() {
        return "VRExperienceHelper";
    }
}
/**
 * Time Constant Teleportation Mode
 */ $cf05a141461916bb$export$a18a2ae66d6c0fab.TELEPORTATIONMODE_CONSTANTTIME = 0;
/**
 * Speed Constant Teleportation Mode
 */ $cf05a141461916bb$export$a18a2ae66d6c0fab.TELEPORTATIONMODE_CONSTANTSPEED = 1;

});
parcelRegister("gAH3H", function(module, exports) {

$parcel$export(module.exports, "StandardMaterialDefines", () => $c14168b02f7bcc00$export$8a3963f3d5f6315f);
$parcel$export(module.exports, "StandardMaterial", () => $c14168b02f7bcc00$export$cb949309547a0dd7);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $57onU = parcelRequire("57onU");

var $gmbCk = parcelRequire("gmbCk");

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $b4i1f = parcelRequire("b4i1f");

var $dqWqq = parcelRequire("dqWqq");

var $dG1pf = parcelRequire("dG1pf");

var $54229 = parcelRequire("54229");

var $7HBDq = parcelRequire("7HBDq");

var $35xmP = parcelRequire("35xmP");

var $atHN2 = parcelRequire("atHN2");

var $j2mX5 = parcelRequire("j2mX5");

var $8DoUR = parcelRequire("8DoUR");

var $2hKx5 = parcelRequire("2hKx5");
parcelRequire("5rZFU");
parcelRequire("fn9QB");

var $gc8Ja = parcelRequire("gc8Ja");

var $bRVvK = parcelRequire("bRVvK");

var $aAFeM = parcelRequire("aAFeM");

var $alPCh = parcelRequire("alPCh");

var $6Ho1L = parcelRequire("6Ho1L");
const $c14168b02f7bcc00$var$onCreatedEffectParameters = {
    effect: null,
    subMesh: null
};
class $c14168b02f7bcc00$export$8a3963f3d5f6315f extends (0, $35xmP.MaterialDefines) {
    /**
     * Initializes the Standard Material defines.
     * @param externalProperties The external properties
     */ constructor(externalProperties){
        super(externalProperties);
        this.MAINUV1 = false;
        this.MAINUV2 = false;
        this.MAINUV3 = false;
        this.MAINUV4 = false;
        this.MAINUV5 = false;
        this.MAINUV6 = false;
        this.DIFFUSE = false;
        this.DIFFUSEDIRECTUV = 0;
        this.BAKED_VERTEX_ANIMATION_TEXTURE = false;
        this.AMBIENT = false;
        this.AMBIENTDIRECTUV = 0;
        this.OPACITY = false;
        this.OPACITYDIRECTUV = 0;
        this.OPACITYRGB = false;
        this.REFLECTION = false;
        this.EMISSIVE = false;
        this.EMISSIVEDIRECTUV = 0;
        this.SPECULAR = false;
        this.SPECULARDIRECTUV = 0;
        this.BUMP = false;
        this.BUMPDIRECTUV = 0;
        this.PARALLAX = false;
        this.PARALLAX_RHS = false;
        this.PARALLAXOCCLUSION = false;
        this.SPECULAROVERALPHA = false;
        this.CLIPPLANE = false;
        this.CLIPPLANE2 = false;
        this.CLIPPLANE3 = false;
        this.CLIPPLANE4 = false;
        this.CLIPPLANE5 = false;
        this.CLIPPLANE6 = false;
        this.ALPHATEST = false;
        this.DEPTHPREPASS = false;
        this.ALPHAFROMDIFFUSE = false;
        this.POINTSIZE = false;
        this.FOG = false;
        this.SPECULARTERM = false;
        this.DIFFUSEFRESNEL = false;
        this.OPACITYFRESNEL = false;
        this.REFLECTIONFRESNEL = false;
        this.REFRACTIONFRESNEL = false;
        this.EMISSIVEFRESNEL = false;
        this.FRESNEL = false;
        this.NORMAL = false;
        this.TANGENT = false;
        this.UV1 = false;
        this.UV2 = false;
        this.UV3 = false;
        this.UV4 = false;
        this.UV5 = false;
        this.UV6 = false;
        this.VERTEXCOLOR = false;
        this.VERTEXALPHA = false;
        this.NUM_BONE_INFLUENCERS = 0;
        this.BonesPerMesh = 0;
        this.BONETEXTURE = false;
        this.BONES_VELOCITY_ENABLED = false;
        this.INSTANCES = false;
        this.THIN_INSTANCES = false;
        this.INSTANCESCOLOR = false;
        this.GLOSSINESS = false;
        this.ROUGHNESS = false;
        this.EMISSIVEASILLUMINATION = false;
        this.LINKEMISSIVEWITHDIFFUSE = false;
        this.REFLECTIONFRESNELFROMSPECULAR = false;
        this.LIGHTMAP = false;
        this.LIGHTMAPDIRECTUV = 0;
        this.OBJECTSPACE_NORMALMAP = false;
        this.USELIGHTMAPASSHADOWMAP = false;
        this.REFLECTIONMAP_3D = false;
        this.REFLECTIONMAP_SPHERICAL = false;
        this.REFLECTIONMAP_PLANAR = false;
        this.REFLECTIONMAP_CUBIC = false;
        this.USE_LOCAL_REFLECTIONMAP_CUBIC = false;
        this.USE_LOCAL_REFRACTIONMAP_CUBIC = false;
        this.REFLECTIONMAP_PROJECTION = false;
        this.REFLECTIONMAP_SKYBOX = false;
        this.REFLECTIONMAP_EXPLICIT = false;
        this.REFLECTIONMAP_EQUIRECTANGULAR = false;
        this.REFLECTIONMAP_EQUIRECTANGULAR_FIXED = false;
        this.REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED = false;
        this.REFLECTIONMAP_OPPOSITEZ = false;
        this.INVERTCUBICMAP = false;
        this.LOGARITHMICDEPTH = false;
        this.REFRACTION = false;
        this.REFRACTIONMAP_3D = false;
        this.REFLECTIONOVERALPHA = false;
        this.TWOSIDEDLIGHTING = false;
        this.SHADOWFLOAT = false;
        this.MORPHTARGETS = false;
        this.MORPHTARGETS_NORMAL = false;
        this.MORPHTARGETS_TANGENT = false;
        this.MORPHTARGETS_UV = false;
        this.NUM_MORPH_INFLUENCERS = 0;
        this.MORPHTARGETS_TEXTURE = false;
        this.NONUNIFORMSCALING = false; // https://playground.babylonjs.com#V6DWIH
        this.PREMULTIPLYALPHA = false; // https://playground.babylonjs.com#LNVJJ7
        this.ALPHATEST_AFTERALLALPHACOMPUTATIONS = false;
        this.ALPHABLEND = true;
        this.PREPASS = false;
        this.PREPASS_IRRADIANCE = false;
        this.PREPASS_IRRADIANCE_INDEX = -1;
        this.PREPASS_ALBEDO_SQRT = false;
        this.PREPASS_ALBEDO_SQRT_INDEX = -1;
        this.PREPASS_DEPTH = false;
        this.PREPASS_DEPTH_INDEX = -1;
        this.PREPASS_NORMAL = false;
        this.PREPASS_NORMAL_INDEX = -1;
        this.PREPASS_NORMAL_WORLDSPACE = false;
        this.PREPASS_POSITION = false;
        this.PREPASS_POSITION_INDEX = -1;
        this.PREPASS_VELOCITY = false;
        this.PREPASS_VELOCITY_INDEX = -1;
        this.PREPASS_REFLECTIVITY = false;
        this.PREPASS_REFLECTIVITY_INDEX = -1;
        this.SCENE_MRT_COUNT = 0;
        this.RGBDLIGHTMAP = false;
        this.RGBDREFLECTION = false;
        this.RGBDREFRACTION = false;
        this.IMAGEPROCESSING = false;
        this.VIGNETTE = false;
        this.VIGNETTEBLENDMODEMULTIPLY = false;
        this.VIGNETTEBLENDMODEOPAQUE = false;
        this.TONEMAPPING = false;
        this.TONEMAPPING_ACES = false;
        this.CONTRAST = false;
        this.COLORCURVES = false;
        this.COLORGRADING = false;
        this.COLORGRADING3D = false;
        this.SAMPLER3DGREENDEPTH = false;
        this.SAMPLER3DBGRMAP = false;
        this.DITHER = false;
        this.IMAGEPROCESSINGPOSTPROCESS = false;
        this.SKIPFINALCOLORCLAMP = false;
        this.MULTIVIEW = false;
        this.ORDER_INDEPENDENT_TRANSPARENCY = false;
        this.ORDER_INDEPENDENT_TRANSPARENCY_16BITS = false;
        this.CAMERA_ORTHOGRAPHIC = false;
        this.CAMERA_PERSPECTIVE = false;
        /**
         * If the reflection texture on this material is in linear color space
         * @internal
         */ this.IS_REFLECTION_LINEAR = false;
        /**
         * If the refraction texture on this material is in linear color space
         * @internal
         */ this.IS_REFRACTION_LINEAR = false;
        this.EXPOSURE = false;
        this.DECAL_AFTER_DETAIL = false;
        this.rebuild();
    }
    setReflectionMode(modeToEnable) {
        const modes = [
            "REFLECTIONMAP_CUBIC",
            "REFLECTIONMAP_EXPLICIT",
            "REFLECTIONMAP_PLANAR",
            "REFLECTIONMAP_PROJECTION",
            "REFLECTIONMAP_PROJECTION",
            "REFLECTIONMAP_SKYBOX",
            "REFLECTIONMAP_SPHERICAL",
            "REFLECTIONMAP_EQUIRECTANGULAR",
            "REFLECTIONMAP_EQUIRECTANGULAR_FIXED",
            "REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED"
        ];
        for (const mode of modes)this[mode] = mode === modeToEnable;
    }
}
class $c14168b02f7bcc00$export$cb949309547a0dd7 extends (0, $atHN2.PushMaterial) {
    /**
     * Gets the image processing configuration used either in this material.
     */ get imageProcessingConfiguration() {
        return this._imageProcessingConfiguration;
    }
    /**
     * Sets the Default image processing configuration used either in the this material.
     *
     * If sets to null, the scene one is in use.
     */ set imageProcessingConfiguration(value) {
        this._attachImageProcessingConfiguration(value);
        // Ensure the effect will be rebuilt.
        this._markAllSubMeshesAsTexturesDirty();
    }
    /**
     * Attaches a new image processing configuration to the Standard Material.
     * @param configuration
     */ _attachImageProcessingConfiguration(configuration) {
        if (configuration === this._imageProcessingConfiguration) return;
        // Detaches observer
        if (this._imageProcessingConfiguration && this._imageProcessingObserver) this._imageProcessingConfiguration.onUpdateParameters.remove(this._imageProcessingObserver);
        // Pick the scene configuration if needed
        if (!configuration) this._imageProcessingConfiguration = this.getScene().imageProcessingConfiguration;
        else this._imageProcessingConfiguration = configuration;
        // Attaches observer
        if (this._imageProcessingConfiguration) this._imageProcessingObserver = this._imageProcessingConfiguration.onUpdateParameters.add(()=>{
            this._markAllSubMeshesAsImageProcessingDirty();
        });
    }
    /**
     * Can this material render to prepass
     */ get isPrePassCapable() {
        return !this.disableDepthWrite;
    }
    /**
     * Gets whether the color curves effect is enabled.
     */ get cameraColorCurvesEnabled() {
        return this.imageProcessingConfiguration.colorCurvesEnabled;
    }
    /**
     * Sets whether the color curves effect is enabled.
     */ set cameraColorCurvesEnabled(value) {
        this.imageProcessingConfiguration.colorCurvesEnabled = value;
    }
    /**
     * Gets whether the color grading effect is enabled.
     */ get cameraColorGradingEnabled() {
        return this.imageProcessingConfiguration.colorGradingEnabled;
    }
    /**
     * Gets whether the color grading effect is enabled.
     */ set cameraColorGradingEnabled(value) {
        this.imageProcessingConfiguration.colorGradingEnabled = value;
    }
    /**
     * Gets whether tonemapping is enabled or not.
     */ get cameraToneMappingEnabled() {
        return this._imageProcessingConfiguration.toneMappingEnabled;
    }
    /**
     * Sets whether tonemapping is enabled or not
     */ set cameraToneMappingEnabled(value) {
        this._imageProcessingConfiguration.toneMappingEnabled = value;
    }
    /**
     * The camera exposure used on this material.
     * This property is here and not in the camera to allow controlling exposure without full screen post process.
     * This corresponds to a photographic exposure.
     */ get cameraExposure() {
        return this._imageProcessingConfiguration.exposure;
    }
    /**
     * The camera exposure used on this material.
     * This property is here and not in the camera to allow controlling exposure without full screen post process.
     * This corresponds to a photographic exposure.
     */ set cameraExposure(value) {
        this._imageProcessingConfiguration.exposure = value;
    }
    /**
     * Gets The camera contrast used on this material.
     */ get cameraContrast() {
        return this._imageProcessingConfiguration.contrast;
    }
    /**
     * Sets The camera contrast used on this material.
     */ set cameraContrast(value) {
        this._imageProcessingConfiguration.contrast = value;
    }
    /**
     * Gets the Color Grading 2D Lookup Texture.
     */ get cameraColorGradingTexture() {
        return this._imageProcessingConfiguration.colorGradingTexture;
    }
    /**
     * Sets the Color Grading 2D Lookup Texture.
     */ set cameraColorGradingTexture(value) {
        this._imageProcessingConfiguration.colorGradingTexture = value;
    }
    /**
     * The color grading curves provide additional color adjustmnent that is applied after any color grading transform (3D LUT).
     * They allow basic adjustment of saturation and small exposure adjustments, along with color filter tinting to provide white balance adjustment or more stylistic effects.
     * These are similar to controls found in many professional imaging or colorist software. The global controls are applied to the entire image. For advanced tuning, extra controls are provided to adjust the shadow, midtone and highlight areas of the image;
     * corresponding to low luminance, medium luminance, and high luminance areas respectively.
     */ get cameraColorCurves() {
        return this._imageProcessingConfiguration.colorCurves;
    }
    /**
     * The color grading curves provide additional color adjustment that is applied after any color grading transform (3D LUT).
     * They allow basic adjustment of saturation and small exposure adjustments, along with color filter tinting to provide white balance adjustment or more stylistic effects.
     * These are similar to controls found in many professional imaging or colorist software. The global controls are applied to the entire image. For advanced tuning, extra controls are provided to adjust the shadow, midtone and highlight areas of the image;
     * corresponding to low luminance, medium luminance, and high luminance areas respectively.
     */ set cameraColorCurves(value) {
        this._imageProcessingConfiguration.colorCurves = value;
    }
    /**
     * Can this material render to several textures at once
     */ get canRenderToMRT() {
        return true;
    }
    /**
     * Instantiates a new standard material.
     * This is the default material used in Babylon. It is the best trade off between quality
     * and performances.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/materials_introduction
     * @param name Define the name of the material in the scene
     * @param scene Define the scene the material belong to
     */ constructor(name, scene){
        super(name, scene);
        this._diffuseTexture = null;
        this._ambientTexture = null;
        this._opacityTexture = null;
        this._reflectionTexture = null;
        this._emissiveTexture = null;
        this._specularTexture = null;
        this._bumpTexture = null;
        this._lightmapTexture = null;
        this._refractionTexture = null;
        /**
         * The color of the material lit by the environmental background lighting.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/materials_introduction#ambient-color-example
         */ this.ambientColor = new (0, $7etnY.Color3)(0, 0, 0);
        /**
         * The basic color of the material as viewed under a light.
         */ this.diffuseColor = new (0, $7etnY.Color3)(1, 1, 1);
        /**
         * Define how the color and intensity of the highlight given by the light in the material.
         */ this.specularColor = new (0, $7etnY.Color3)(1, 1, 1);
        /**
         * Define the color of the material as if self lit.
         * This will be mixed in the final result even in the absence of light.
         */ this.emissiveColor = new (0, $7etnY.Color3)(0, 0, 0);
        /**
         * Defines how sharp are the highlights in the material.
         * The bigger the value the sharper giving a more glossy feeling to the result.
         * Reversely, the smaller the value the blurrier giving a more rough feeling to the result.
         */ this.specularPower = 64;
        this._useAlphaFromDiffuseTexture = false;
        this._useEmissiveAsIllumination = false;
        this._linkEmissiveWithDiffuse = false;
        this._useSpecularOverAlpha = false;
        this._useReflectionOverAlpha = false;
        this._disableLighting = false;
        this._useObjectSpaceNormalMap = false;
        this._useParallax = false;
        this._useParallaxOcclusion = false;
        /**
         * Apply a scaling factor that determine which "depth" the height map should reprensent. A value between 0.05 and 0.1 is reasonnable in Parallax, you can reach 0.2 using Parallax Occlusion.
         */ this.parallaxScaleBias = 0.05;
        this._roughness = 0;
        /**
         * In case of refraction, define the value of the index of refraction.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/reflectionTexture#how-to-obtain-reflections-and-refractions
         */ this.indexOfRefraction = 0.98;
        /**
         * Invert the refraction texture alongside the y axis.
         * It can be useful with procedural textures or probe for instance.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/reflectionTexture#how-to-obtain-reflections-and-refractions
         */ this.invertRefractionY = true;
        /**
         * Defines the alpha limits in alpha test mode.
         */ this.alphaCutOff = 0.4;
        this._useLightmapAsShadowmap = false;
        this._useReflectionFresnelFromSpecular = false;
        this._useGlossinessFromSpecularMapAlpha = false;
        this._maxSimultaneousLights = 4;
        this._invertNormalMapX = false;
        this._invertNormalMapY = false;
        this._twoSidedLighting = false;
        this._applyDecalMapAfterDetailMap = false;
        this._renderTargets = new (0, $57onU.SmartArray)(16);
        this._worldViewProjectionMatrix = (0, $ha1VO.Matrix).Zero();
        this._globalAmbientColor = new (0, $7etnY.Color3)(0, 0, 0);
        this._cacheHasRenderTargetTextures = false;
        this.detailMap = new (0, $bRVvK.DetailMapConfiguration)(this);
        // Setup the default processing configuration to the scene.
        this._attachImageProcessingConfiguration(null);
        this.prePassConfiguration = new (0, $dqWqq.PrePassConfiguration)();
        this.getRenderTargetTextures = ()=>{
            this._renderTargets.reset();
            if ($c14168b02f7bcc00$export$cb949309547a0dd7.ReflectionTextureEnabled && this._reflectionTexture && this._reflectionTexture.isRenderTarget) this._renderTargets.push(this._reflectionTexture);
            if ($c14168b02f7bcc00$export$cb949309547a0dd7.RefractionTextureEnabled && this._refractionTexture && this._refractionTexture.isRenderTarget) this._renderTargets.push(this._refractionTexture);
            this._eventInfo.renderTargets = this._renderTargets;
            this._callbackPluginEventFillRenderTargetTextures(this._eventInfo);
            return this._renderTargets;
        };
    }
    /**
     * Gets a boolean indicating that current material needs to register RTT
     */ get hasRenderTargetTextures() {
        if ($c14168b02f7bcc00$export$cb949309547a0dd7.ReflectionTextureEnabled && this._reflectionTexture && this._reflectionTexture.isRenderTarget) return true;
        if ($c14168b02f7bcc00$export$cb949309547a0dd7.RefractionTextureEnabled && this._refractionTexture && this._refractionTexture.isRenderTarget) return true;
        return this._cacheHasRenderTargetTextures;
    }
    /**
     * Gets the current class name of the material e.g. "StandardMaterial"
     * Mainly use in serialization.
     * @returns the class name
     */ getClassName() {
        return "StandardMaterial";
    }
    /**
     * Specifies if the material will require alpha blending
     * @returns a boolean specifying if alpha blending is needed
     */ needAlphaBlending() {
        if (this._disableAlphaBlending) return false;
        return this.alpha < 1.0 || this._opacityTexture != null || this._shouldUseAlphaFromDiffuseTexture() || this._opacityFresnelParameters && this._opacityFresnelParameters.isEnabled;
    }
    /**
     * Specifies if this material should be rendered in alpha test mode
     * @returns a boolean specifying if an alpha test is needed.
     */ needAlphaTesting() {
        if (this._forceAlphaTest) return true;
        return this._hasAlphaChannel() && (this._transparencyMode == null || this._transparencyMode === (0, $54229.Material).MATERIAL_ALPHATEST);
    }
    /**
     * @returns whether or not the alpha value of the diffuse texture should be used for alpha blending.
     */ _shouldUseAlphaFromDiffuseTexture() {
        return this._diffuseTexture != null && this._diffuseTexture.hasAlpha && this._useAlphaFromDiffuseTexture && this._transparencyMode !== (0, $54229.Material).MATERIAL_OPAQUE;
    }
    /**
     * @returns whether or not there is a usable alpha channel for transparency.
     */ _hasAlphaChannel() {
        return this._diffuseTexture != null && this._diffuseTexture.hasAlpha || this._opacityTexture != null;
    }
    /**
     * Get the texture used for alpha test purpose.
     * @returns the diffuse texture in case of the standard material.
     */ getAlphaTestTexture() {
        return this._diffuseTexture;
    }
    /**
     * Get if the submesh is ready to be used and all its information available.
     * Child classes can use it to update shaders
     * @param mesh defines the mesh to check
     * @param subMesh defines which submesh to check
     * @param useInstances specifies that instances should be used
     * @returns a boolean indicating that the submesh is ready or not
     */ isReadyForSubMesh(mesh, subMesh, useInstances = false) {
        if (!this._uniformBufferLayoutBuilt) this.buildUniformLayout();
        const drawWrapper = subMesh._drawWrapper;
        if (drawWrapper.effect && this.isFrozen) {
            if (drawWrapper._wasPreviouslyReady && drawWrapper._wasPreviouslyUsingInstances === useInstances) return true;
        }
        if (!subMesh.materialDefines) {
            this._callbackPluginEventGeneric((0, $7HBDq.MaterialPluginEvent).GetDefineNames, this._eventInfo);
            subMesh.materialDefines = new $c14168b02f7bcc00$export$8a3963f3d5f6315f(this._eventInfo.defineNames);
        }
        const scene = this.getScene();
        const defines = subMesh.materialDefines;
        if (this._isReadyForSubMesh(subMesh)) return true;
        const engine = scene.getEngine();
        // Lights
        defines._needNormals = (0, $alPCh.PrepareDefinesForLights)(scene, mesh, defines, true, this._maxSimultaneousLights, this._disableLighting);
        // Multiview
        (0, $alPCh.PrepareDefinesForMultiview)(scene, defines);
        // PrePass
        const oit = this.needAlphaBlendingForMesh(mesh) && this.getScene().useOrderIndependentTransparency;
        (0, $alPCh.PrepareDefinesForPrePass)(scene, defines, this.canRenderToMRT && !oit);
        // Order independant transparency
        (0, $alPCh.PrepareDefinesForOIT)(scene, defines, oit);
        // Textures
        if (defines._areTexturesDirty) {
            this._eventInfo.hasRenderTargetTextures = false;
            this._callbackPluginEventHasRenderTargetTextures(this._eventInfo);
            this._cacheHasRenderTargetTextures = this._eventInfo.hasRenderTargetTextures;
            defines._needUVs = false;
            for(let i = 1; i <= 6; ++i)defines["MAINUV" + i] = false;
            if (scene.texturesEnabled) {
                defines.DIFFUSEDIRECTUV = 0;
                defines.BUMPDIRECTUV = 0;
                defines.AMBIENTDIRECTUV = 0;
                defines.OPACITYDIRECTUV = 0;
                defines.EMISSIVEDIRECTUV = 0;
                defines.SPECULARDIRECTUV = 0;
                defines.LIGHTMAPDIRECTUV = 0;
                if (this._diffuseTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.DiffuseTextureEnabled) {
                    if (!this._diffuseTexture.isReadyOrNotBlocking()) return false;
                    else (0, $alPCh.PrepareDefinesForMergedUV)(this._diffuseTexture, defines, "DIFFUSE");
                } else defines.DIFFUSE = false;
                if (this._ambientTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.AmbientTextureEnabled) {
                    if (!this._ambientTexture.isReadyOrNotBlocking()) return false;
                    else (0, $alPCh.PrepareDefinesForMergedUV)(this._ambientTexture, defines, "AMBIENT");
                } else defines.AMBIENT = false;
                if (this._opacityTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.OpacityTextureEnabled) {
                    if (!this._opacityTexture.isReadyOrNotBlocking()) return false;
                    else {
                        (0, $alPCh.PrepareDefinesForMergedUV)(this._opacityTexture, defines, "OPACITY");
                        defines.OPACITYRGB = this._opacityTexture.getAlphaFromRGB;
                    }
                } else defines.OPACITY = false;
                if (this._reflectionTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.ReflectionTextureEnabled) {
                    if (!this._reflectionTexture.isReadyOrNotBlocking()) return false;
                    else {
                        defines._needNormals = true;
                        defines.REFLECTION = true;
                        defines.ROUGHNESS = this._roughness > 0;
                        defines.REFLECTIONOVERALPHA = this._useReflectionOverAlpha;
                        defines.INVERTCUBICMAP = this._reflectionTexture.coordinatesMode === (0, $j2mX5.Texture).INVCUBIC_MODE;
                        defines.REFLECTIONMAP_3D = this._reflectionTexture.isCube;
                        defines.REFLECTIONMAP_OPPOSITEZ = defines.REFLECTIONMAP_3D && this.getScene().useRightHandedSystem ? !this._reflectionTexture.invertZ : this._reflectionTexture.invertZ;
                        defines.RGBDREFLECTION = this._reflectionTexture.isRGBD;
                        switch(this._reflectionTexture.coordinatesMode){
                            case (0, $j2mX5.Texture).EXPLICIT_MODE:
                                defines.setReflectionMode("REFLECTIONMAP_EXPLICIT");
                                break;
                            case (0, $j2mX5.Texture).PLANAR_MODE:
                                defines.setReflectionMode("REFLECTIONMAP_PLANAR");
                                break;
                            case (0, $j2mX5.Texture).PROJECTION_MODE:
                                defines.setReflectionMode("REFLECTIONMAP_PROJECTION");
                                break;
                            case (0, $j2mX5.Texture).SKYBOX_MODE:
                                defines.setReflectionMode("REFLECTIONMAP_SKYBOX");
                                break;
                            case (0, $j2mX5.Texture).SPHERICAL_MODE:
                                defines.setReflectionMode("REFLECTIONMAP_SPHERICAL");
                                break;
                            case (0, $j2mX5.Texture).EQUIRECTANGULAR_MODE:
                                defines.setReflectionMode("REFLECTIONMAP_EQUIRECTANGULAR");
                                break;
                            case (0, $j2mX5.Texture).FIXED_EQUIRECTANGULAR_MODE:
                                defines.setReflectionMode("REFLECTIONMAP_EQUIRECTANGULAR_FIXED");
                                break;
                            case (0, $j2mX5.Texture).FIXED_EQUIRECTANGULAR_MIRRORED_MODE:
                                defines.setReflectionMode("REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED");
                                break;
                            case (0, $j2mX5.Texture).CUBIC_MODE:
                            case (0, $j2mX5.Texture).INVCUBIC_MODE:
                            default:
                                defines.setReflectionMode("REFLECTIONMAP_CUBIC");
                                break;
                        }
                        defines.USE_LOCAL_REFLECTIONMAP_CUBIC = this._reflectionTexture.boundingBoxSize ? true : false;
                    }
                } else {
                    defines.REFLECTION = false;
                    defines.REFLECTIONMAP_OPPOSITEZ = false;
                }
                if (this._emissiveTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.EmissiveTextureEnabled) {
                    if (!this._emissiveTexture.isReadyOrNotBlocking()) return false;
                    else (0, $alPCh.PrepareDefinesForMergedUV)(this._emissiveTexture, defines, "EMISSIVE");
                } else defines.EMISSIVE = false;
                if (this._lightmapTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.LightmapTextureEnabled) {
                    if (!this._lightmapTexture.isReadyOrNotBlocking()) return false;
                    else {
                        (0, $alPCh.PrepareDefinesForMergedUV)(this._lightmapTexture, defines, "LIGHTMAP");
                        defines.USELIGHTMAPASSHADOWMAP = this._useLightmapAsShadowmap;
                        defines.RGBDLIGHTMAP = this._lightmapTexture.isRGBD;
                    }
                } else defines.LIGHTMAP = false;
                if (this._specularTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.SpecularTextureEnabled) {
                    if (!this._specularTexture.isReadyOrNotBlocking()) return false;
                    else {
                        (0, $alPCh.PrepareDefinesForMergedUV)(this._specularTexture, defines, "SPECULAR");
                        defines.GLOSSINESS = this._useGlossinessFromSpecularMapAlpha;
                    }
                } else defines.SPECULAR = false;
                if (scene.getEngine().getCaps().standardDerivatives && this._bumpTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.BumpTextureEnabled) {
                    // Bump texture can not be not blocking.
                    if (!this._bumpTexture.isReady()) return false;
                    else {
                        (0, $alPCh.PrepareDefinesForMergedUV)(this._bumpTexture, defines, "BUMP");
                        defines.PARALLAX = this._useParallax;
                        defines.PARALLAX_RHS = scene.useRightHandedSystem;
                        defines.PARALLAXOCCLUSION = this._useParallaxOcclusion;
                    }
                    defines.OBJECTSPACE_NORMALMAP = this._useObjectSpaceNormalMap;
                } else {
                    defines.BUMP = false;
                    defines.PARALLAX = false;
                    defines.PARALLAX_RHS = false;
                    defines.PARALLAXOCCLUSION = false;
                }
                if (this._refractionTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.RefractionTextureEnabled) {
                    if (!this._refractionTexture.isReadyOrNotBlocking()) return false;
                    else {
                        defines._needUVs = true;
                        defines.REFRACTION = true;
                        defines.REFRACTIONMAP_3D = this._refractionTexture.isCube;
                        defines.RGBDREFRACTION = this._refractionTexture.isRGBD;
                        defines.USE_LOCAL_REFRACTIONMAP_CUBIC = this._refractionTexture.boundingBoxSize ? true : false;
                    }
                } else defines.REFRACTION = false;
                defines.TWOSIDEDLIGHTING = !this._backFaceCulling && this._twoSidedLighting;
            } else {
                defines.DIFFUSE = false;
                defines.AMBIENT = false;
                defines.OPACITY = false;
                defines.REFLECTION = false;
                defines.EMISSIVE = false;
                defines.LIGHTMAP = false;
                defines.BUMP = false;
                defines.REFRACTION = false;
            }
            defines.ALPHAFROMDIFFUSE = this._shouldUseAlphaFromDiffuseTexture();
            defines.EMISSIVEASILLUMINATION = this._useEmissiveAsIllumination;
            defines.LINKEMISSIVEWITHDIFFUSE = this._linkEmissiveWithDiffuse;
            defines.SPECULAROVERALPHA = this._useSpecularOverAlpha;
            defines.PREMULTIPLYALPHA = this.alphaMode === 7 || this.alphaMode === 8;
            defines.ALPHATEST_AFTERALLALPHACOMPUTATIONS = this.transparencyMode !== null;
            defines.ALPHABLEND = this.transparencyMode === null || this.needAlphaBlendingForMesh(mesh); // check on null for backward compatibility
        }
        this._eventInfo.isReadyForSubMesh = true;
        this._eventInfo.defines = defines;
        this._eventInfo.subMesh = subMesh;
        this._callbackPluginEventIsReadyForSubMesh(this._eventInfo);
        if (!this._eventInfo.isReadyForSubMesh) return false;
        if (defines._areImageProcessingDirty && this._imageProcessingConfiguration) {
            if (!this._imageProcessingConfiguration.isReady()) return false;
            this._imageProcessingConfiguration.prepareDefines(defines);
            defines.IS_REFLECTION_LINEAR = this.reflectionTexture != null && !this.reflectionTexture.gammaSpace;
            defines.IS_REFRACTION_LINEAR = this.refractionTexture != null && !this.refractionTexture.gammaSpace;
        }
        if (defines._areFresnelDirty) {
            if ($c14168b02f7bcc00$export$cb949309547a0dd7.FresnelEnabled) // Fresnel
            {
                if (this._diffuseFresnelParameters || this._opacityFresnelParameters || this._emissiveFresnelParameters || this._refractionFresnelParameters || this._reflectionFresnelParameters) {
                    defines.DIFFUSEFRESNEL = this._diffuseFresnelParameters && this._diffuseFresnelParameters.isEnabled;
                    defines.OPACITYFRESNEL = this._opacityFresnelParameters && this._opacityFresnelParameters.isEnabled;
                    defines.REFLECTIONFRESNEL = this._reflectionFresnelParameters && this._reflectionFresnelParameters.isEnabled;
                    defines.REFLECTIONFRESNELFROMSPECULAR = this._useReflectionFresnelFromSpecular;
                    defines.REFRACTIONFRESNEL = this._refractionFresnelParameters && this._refractionFresnelParameters.isEnabled;
                    defines.EMISSIVEFRESNEL = this._emissiveFresnelParameters && this._emissiveFresnelParameters.isEnabled;
                    defines._needNormals = true;
                    defines.FRESNEL = true;
                }
            } else defines.FRESNEL = false;
        }
        // Misc.
        (0, $alPCh.PrepareDefinesForMisc)(mesh, scene, this._useLogarithmicDepth, this.pointsCloud, this.fogEnabled, this._shouldTurnAlphaTestOn(mesh) || this._forceAlphaTest, defines, this._applyDecalMapAfterDetailMap);
        // Values that need to be evaluated on every frame
        (0, $alPCh.PrepareDefinesForFrameBoundValues)(scene, engine, this, defines, useInstances, null, subMesh.getRenderingMesh().hasThinInstances);
        // External config
        this._eventInfo.defines = defines;
        this._eventInfo.mesh = mesh;
        this._callbackPluginEventPrepareDefinesBeforeAttributes(this._eventInfo);
        // Attribs
        (0, $alPCh.PrepareDefinesForAttributes)(mesh, defines, true, true, true);
        // External config
        this._callbackPluginEventPrepareDefines(this._eventInfo);
        // Get correct effect
        let forceWasNotReadyPreviously = false;
        if (defines.isDirty) {
            const lightDisposed = defines._areLightsDisposed;
            defines.markAsProcessed();
            // Fallbacks
            const fallbacks = new (0, $gc8Ja.EffectFallbacks)();
            if (defines.REFLECTION) fallbacks.addFallback(0, "REFLECTION");
            if (defines.SPECULAR) fallbacks.addFallback(0, "SPECULAR");
            if (defines.BUMP) fallbacks.addFallback(0, "BUMP");
            if (defines.PARALLAX) fallbacks.addFallback(1, "PARALLAX");
            if (defines.PARALLAX_RHS) fallbacks.addFallback(1, "PARALLAX_RHS");
            if (defines.PARALLAXOCCLUSION) fallbacks.addFallback(0, "PARALLAXOCCLUSION");
            if (defines.SPECULAROVERALPHA) fallbacks.addFallback(0, "SPECULAROVERALPHA");
            if (defines.FOG) fallbacks.addFallback(1, "FOG");
            if (defines.POINTSIZE) fallbacks.addFallback(0, "POINTSIZE");
            if (defines.LOGARITHMICDEPTH) fallbacks.addFallback(0, "LOGARITHMICDEPTH");
            (0, $alPCh.HandleFallbacksForShadows)(defines, fallbacks, this._maxSimultaneousLights);
            if (defines.SPECULARTERM) fallbacks.addFallback(0, "SPECULARTERM");
            if (defines.DIFFUSEFRESNEL) fallbacks.addFallback(1, "DIFFUSEFRESNEL");
            if (defines.OPACITYFRESNEL) fallbacks.addFallback(2, "OPACITYFRESNEL");
            if (defines.REFLECTIONFRESNEL) fallbacks.addFallback(3, "REFLECTIONFRESNEL");
            if (defines.EMISSIVEFRESNEL) fallbacks.addFallback(4, "EMISSIVEFRESNEL");
            if (defines.FRESNEL) fallbacks.addFallback(4, "FRESNEL");
            if (defines.MULTIVIEW) fallbacks.addFallback(0, "MULTIVIEW");
            //Attributes
            const attribs = [
                (0, $b4i1f.VertexBuffer).PositionKind
            ];
            if (defines.NORMAL) attribs.push((0, $b4i1f.VertexBuffer).NormalKind);
            if (defines.TANGENT) attribs.push((0, $b4i1f.VertexBuffer).TangentKind);
            for(let i = 1; i <= 6; ++i)if (defines["UV" + i]) attribs.push(`uv${i === 1 ? "" : i}`);
            if (defines.VERTEXCOLOR) attribs.push((0, $b4i1f.VertexBuffer).ColorKind);
            (0, $alPCh.PrepareAttributesForBones)(attribs, mesh, defines, fallbacks);
            (0, $alPCh.PrepareAttributesForInstances)(attribs, defines);
            (0, $alPCh.PrepareAttributesForMorphTargets)(attribs, mesh, defines);
            (0, $alPCh.PrepareAttributesForBakedVertexAnimation)(attribs, mesh, defines);
            let shaderName = "default";
            const uniforms = [
                "world",
                "view",
                "viewProjection",
                "vEyePosition",
                "vLightsType",
                "vAmbientColor",
                "vDiffuseColor",
                "vSpecularColor",
                "vEmissiveColor",
                "visibility",
                "vFogInfos",
                "vFogColor",
                "pointSize",
                "vDiffuseInfos",
                "vAmbientInfos",
                "vOpacityInfos",
                "vReflectionInfos",
                "vEmissiveInfos",
                "vSpecularInfos",
                "vBumpInfos",
                "vLightmapInfos",
                "vRefractionInfos",
                "mBones",
                "diffuseMatrix",
                "ambientMatrix",
                "opacityMatrix",
                "reflectionMatrix",
                "emissiveMatrix",
                "specularMatrix",
                "bumpMatrix",
                "normalMatrix",
                "lightmapMatrix",
                "refractionMatrix",
                "diffuseLeftColor",
                "diffuseRightColor",
                "opacityParts",
                "reflectionLeftColor",
                "reflectionRightColor",
                "emissiveLeftColor",
                "emissiveRightColor",
                "refractionLeftColor",
                "refractionRightColor",
                "vReflectionPosition",
                "vReflectionSize",
                "vRefractionPosition",
                "vRefractionSize",
                "logarithmicDepthConstant",
                "vTangentSpaceParams",
                "alphaCutOff",
                "boneTextureWidth",
                "morphTargetTextureInfo",
                "morphTargetTextureIndices"
            ];
            const samplers = [
                "diffuseSampler",
                "ambientSampler",
                "opacitySampler",
                "reflectionCubeSampler",
                "reflection2DSampler",
                "emissiveSampler",
                "specularSampler",
                "bumpSampler",
                "lightmapSampler",
                "refractionCubeSampler",
                "refraction2DSampler",
                "boneSampler",
                "morphTargets",
                "oitDepthSampler",
                "oitFrontColorSampler"
            ];
            const uniformBuffers = [
                "Material",
                "Scene",
                "Mesh"
            ];
            const indexParameters = {
                maxSimultaneousLights: this._maxSimultaneousLights,
                maxSimultaneousMorphTargets: defines.NUM_MORPH_INFLUENCERS
            };
            this._eventInfo.fallbacks = fallbacks;
            this._eventInfo.fallbackRank = 0;
            this._eventInfo.defines = defines;
            this._eventInfo.uniforms = uniforms;
            this._eventInfo.attributes = attribs;
            this._eventInfo.samplers = samplers;
            this._eventInfo.uniformBuffersNames = uniformBuffers;
            this._eventInfo.customCode = undefined;
            this._eventInfo.mesh = mesh;
            this._eventInfo.indexParameters = indexParameters;
            this._callbackPluginEventGeneric((0, $7HBDq.MaterialPluginEvent).PrepareEffect, this._eventInfo);
            (0, $dqWqq.PrePassConfiguration).AddUniforms(uniforms);
            (0, $dqWqq.PrePassConfiguration).AddSamplers(samplers);
            if (0, $dG1pf.ImageProcessingConfiguration) {
                (0, $dG1pf.ImageProcessingConfiguration).PrepareUniforms(uniforms, defines);
                (0, $dG1pf.ImageProcessingConfiguration).PrepareSamplers(samplers, defines);
            }
            (0, $alPCh.PrepareUniformsAndSamplersList)({
                uniformsNames: uniforms,
                uniformBuffersNames: uniformBuffers,
                samplers: samplers,
                defines: defines,
                maxSimultaneousLights: this._maxSimultaneousLights
            });
            (0, $aAFeM.addClipPlaneUniforms)(uniforms);
            const csnrOptions = {};
            if (this.customShaderNameResolve) shaderName = this.customShaderNameResolve(shaderName, uniforms, uniformBuffers, samplers, defines, attribs, csnrOptions);
            const join = defines.toString();
            const previousEffect = subMesh.effect;
            let effect = scene.getEngine().createEffect(shaderName, {
                attributes: attribs,
                uniformsNames: uniforms,
                uniformBuffersNames: uniformBuffers,
                samplers: samplers,
                defines: join,
                fallbacks: fallbacks,
                onCompiled: this.onCompiled,
                onError: this.onError,
                indexParameters: indexParameters,
                processFinalCode: csnrOptions.processFinalCode,
                processCodeAfterIncludes: this._eventInfo.customCode,
                multiTarget: defines.PREPASS
            }, engine);
            this._eventInfo.customCode = undefined;
            if (effect) {
                if (this._onEffectCreatedObservable) {
                    $c14168b02f7bcc00$var$onCreatedEffectParameters.effect = effect;
                    $c14168b02f7bcc00$var$onCreatedEffectParameters.subMesh = subMesh;
                    this._onEffectCreatedObservable.notifyObservers($c14168b02f7bcc00$var$onCreatedEffectParameters);
                }
                // Use previous effect while new one is compiling
                if (this.allowShaderHotSwapping && previousEffect && !effect.isReady()) {
                    effect = previousEffect;
                    defines.markAsUnprocessed();
                    forceWasNotReadyPreviously = this.isFrozen;
                    if (lightDisposed) {
                        // re register in case it takes more than one frame.
                        defines._areLightsDisposed = true;
                        return false;
                    }
                } else {
                    scene.resetCachedMaterial();
                    subMesh.setEffect(effect, defines, this._materialContext);
                }
            }
        }
        if (!subMesh.effect || !subMesh.effect.isReady()) return false;
        defines._renderId = scene.getRenderId();
        drawWrapper._wasPreviouslyReady = forceWasNotReadyPreviously ? false : true;
        drawWrapper._wasPreviouslyUsingInstances = useInstances;
        this._checkScenePerformancePriority();
        return true;
    }
    /**
     * Builds the material UBO layouts.
     * Used internally during the effect preparation.
     */ buildUniformLayout() {
        // Order is important !
        const ubo = this._uniformBuffer;
        ubo.addUniform("diffuseLeftColor", 4);
        ubo.addUniform("diffuseRightColor", 4);
        ubo.addUniform("opacityParts", 4);
        ubo.addUniform("reflectionLeftColor", 4);
        ubo.addUniform("reflectionRightColor", 4);
        ubo.addUniform("refractionLeftColor", 4);
        ubo.addUniform("refractionRightColor", 4);
        ubo.addUniform("emissiveLeftColor", 4);
        ubo.addUniform("emissiveRightColor", 4);
        ubo.addUniform("vDiffuseInfos", 2);
        ubo.addUniform("vAmbientInfos", 2);
        ubo.addUniform("vOpacityInfos", 2);
        ubo.addUniform("vReflectionInfos", 2);
        ubo.addUniform("vReflectionPosition", 3);
        ubo.addUniform("vReflectionSize", 3);
        ubo.addUniform("vEmissiveInfos", 2);
        ubo.addUniform("vLightmapInfos", 2);
        ubo.addUniform("vSpecularInfos", 2);
        ubo.addUniform("vBumpInfos", 3);
        ubo.addUniform("diffuseMatrix", 16);
        ubo.addUniform("ambientMatrix", 16);
        ubo.addUniform("opacityMatrix", 16);
        ubo.addUniform("reflectionMatrix", 16);
        ubo.addUniform("emissiveMatrix", 16);
        ubo.addUniform("lightmapMatrix", 16);
        ubo.addUniform("specularMatrix", 16);
        ubo.addUniform("bumpMatrix", 16);
        ubo.addUniform("vTangentSpaceParams", 2);
        ubo.addUniform("pointSize", 1);
        ubo.addUniform("alphaCutOff", 1);
        ubo.addUniform("refractionMatrix", 16);
        ubo.addUniform("vRefractionInfos", 4);
        ubo.addUniform("vRefractionPosition", 3);
        ubo.addUniform("vRefractionSize", 3);
        ubo.addUniform("vSpecularColor", 4);
        ubo.addUniform("vEmissiveColor", 3);
        ubo.addUniform("vDiffuseColor", 4);
        ubo.addUniform("vAmbientColor", 3);
        super.buildUniformLayout();
    }
    /**
     * Binds the submesh to this material by preparing the effect and shader to draw
     * @param world defines the world transformation matrix
     * @param mesh defines the mesh containing the submesh
     * @param subMesh defines the submesh to bind the material to
     */ bindForSubMesh(world, mesh, subMesh) {
        const scene = this.getScene();
        const defines = subMesh.materialDefines;
        if (!defines) return;
        const effect = subMesh.effect;
        if (!effect) return;
        this._activeEffect = effect;
        // Matrices Mesh.
        mesh.getMeshUniformBuffer().bindToEffect(effect, "Mesh");
        mesh.transferToEffect(world);
        // Binding unconditionally
        this._uniformBuffer.bindToEffect(effect, "Material");
        this.prePassConfiguration.bindForSubMesh(this._activeEffect, scene, mesh, world, this.isFrozen);
        this._eventInfo.subMesh = subMesh;
        this._callbackPluginEventHardBindForSubMesh(this._eventInfo);
        // Normal Matrix
        if (defines.OBJECTSPACE_NORMALMAP) {
            world.toNormalMatrix(this._normalMatrix);
            this.bindOnlyNormalMatrix(this._normalMatrix);
        }
        const mustRebind = this._mustRebind(scene, effect, subMesh, mesh.visibility);
        // Bones
        (0, $alPCh.BindBonesParameters)(mesh, effect);
        const ubo = this._uniformBuffer;
        if (mustRebind) {
            this.bindViewProjection(effect);
            if (!ubo.useUbo || !this.isFrozen || !ubo.isSync || subMesh._drawWrapper._forceRebindOnNextCall) {
                if ($c14168b02f7bcc00$export$cb949309547a0dd7.FresnelEnabled && defines.FRESNEL) {
                    // Fresnel
                    if (this.diffuseFresnelParameters && this.diffuseFresnelParameters.isEnabled) {
                        ubo.updateColor4("diffuseLeftColor", this.diffuseFresnelParameters.leftColor, this.diffuseFresnelParameters.power);
                        ubo.updateColor4("diffuseRightColor", this.diffuseFresnelParameters.rightColor, this.diffuseFresnelParameters.bias);
                    }
                    if (this.opacityFresnelParameters && this.opacityFresnelParameters.isEnabled) ubo.updateColor4("opacityParts", new (0, $7etnY.Color3)(this.opacityFresnelParameters.leftColor.toLuminance(), this.opacityFresnelParameters.rightColor.toLuminance(), this.opacityFresnelParameters.bias), this.opacityFresnelParameters.power);
                    if (this.reflectionFresnelParameters && this.reflectionFresnelParameters.isEnabled) {
                        ubo.updateColor4("reflectionLeftColor", this.reflectionFresnelParameters.leftColor, this.reflectionFresnelParameters.power);
                        ubo.updateColor4("reflectionRightColor", this.reflectionFresnelParameters.rightColor, this.reflectionFresnelParameters.bias);
                    }
                    if (this.refractionFresnelParameters && this.refractionFresnelParameters.isEnabled) {
                        ubo.updateColor4("refractionLeftColor", this.refractionFresnelParameters.leftColor, this.refractionFresnelParameters.power);
                        ubo.updateColor4("refractionRightColor", this.refractionFresnelParameters.rightColor, this.refractionFresnelParameters.bias);
                    }
                    if (this.emissiveFresnelParameters && this.emissiveFresnelParameters.isEnabled) {
                        ubo.updateColor4("emissiveLeftColor", this.emissiveFresnelParameters.leftColor, this.emissiveFresnelParameters.power);
                        ubo.updateColor4("emissiveRightColor", this.emissiveFresnelParameters.rightColor, this.emissiveFresnelParameters.bias);
                    }
                }
                // Textures
                if (scene.texturesEnabled) {
                    if (this._diffuseTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.DiffuseTextureEnabled) {
                        ubo.updateFloat2("vDiffuseInfos", this._diffuseTexture.coordinatesIndex, this._diffuseTexture.level);
                        (0, $alPCh.BindTextureMatrix)(this._diffuseTexture, ubo, "diffuse");
                    }
                    if (this._ambientTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.AmbientTextureEnabled) {
                        ubo.updateFloat2("vAmbientInfos", this._ambientTexture.coordinatesIndex, this._ambientTexture.level);
                        (0, $alPCh.BindTextureMatrix)(this._ambientTexture, ubo, "ambient");
                    }
                    if (this._opacityTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.OpacityTextureEnabled) {
                        ubo.updateFloat2("vOpacityInfos", this._opacityTexture.coordinatesIndex, this._opacityTexture.level);
                        (0, $alPCh.BindTextureMatrix)(this._opacityTexture, ubo, "opacity");
                    }
                    if (this._hasAlphaChannel()) ubo.updateFloat("alphaCutOff", this.alphaCutOff);
                    if (this._reflectionTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.ReflectionTextureEnabled) {
                        ubo.updateFloat2("vReflectionInfos", this._reflectionTexture.level, this.roughness);
                        ubo.updateMatrix("reflectionMatrix", this._reflectionTexture.getReflectionTextureMatrix());
                        if (this._reflectionTexture.boundingBoxSize) {
                            const cubeTexture = this._reflectionTexture;
                            ubo.updateVector3("vReflectionPosition", cubeTexture.boundingBoxPosition);
                            ubo.updateVector3("vReflectionSize", cubeTexture.boundingBoxSize);
                        }
                    }
                    if (this._emissiveTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.EmissiveTextureEnabled) {
                        ubo.updateFloat2("vEmissiveInfos", this._emissiveTexture.coordinatesIndex, this._emissiveTexture.level);
                        (0, $alPCh.BindTextureMatrix)(this._emissiveTexture, ubo, "emissive");
                    }
                    if (this._lightmapTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.LightmapTextureEnabled) {
                        ubo.updateFloat2("vLightmapInfos", this._lightmapTexture.coordinatesIndex, this._lightmapTexture.level);
                        (0, $alPCh.BindTextureMatrix)(this._lightmapTexture, ubo, "lightmap");
                    }
                    if (this._specularTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.SpecularTextureEnabled) {
                        ubo.updateFloat2("vSpecularInfos", this._specularTexture.coordinatesIndex, this._specularTexture.level);
                        (0, $alPCh.BindTextureMatrix)(this._specularTexture, ubo, "specular");
                    }
                    if (this._bumpTexture && scene.getEngine().getCaps().standardDerivatives && $c14168b02f7bcc00$export$cb949309547a0dd7.BumpTextureEnabled) {
                        ubo.updateFloat3("vBumpInfos", this._bumpTexture.coordinatesIndex, 1.0 / this._bumpTexture.level, this.parallaxScaleBias);
                        (0, $alPCh.BindTextureMatrix)(this._bumpTexture, ubo, "bump");
                        if (scene._mirroredCameraPosition) ubo.updateFloat2("vTangentSpaceParams", this._invertNormalMapX ? 1.0 : -1, this._invertNormalMapY ? 1.0 : -1);
                        else ubo.updateFloat2("vTangentSpaceParams", this._invertNormalMapX ? -1 : 1.0, this._invertNormalMapY ? -1 : 1.0);
                    }
                    if (this._refractionTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.RefractionTextureEnabled) {
                        let depth = 1.0;
                        if (!this._refractionTexture.isCube) {
                            ubo.updateMatrix("refractionMatrix", this._refractionTexture.getReflectionTextureMatrix());
                            if (this._refractionTexture.depth) depth = this._refractionTexture.depth;
                        }
                        ubo.updateFloat4("vRefractionInfos", this._refractionTexture.level, this.indexOfRefraction, depth, this.invertRefractionY ? -1 : 1);
                        if (this._refractionTexture.boundingBoxSize) {
                            const cubeTexture = this._refractionTexture;
                            ubo.updateVector3("vRefractionPosition", cubeTexture.boundingBoxPosition);
                            ubo.updateVector3("vRefractionSize", cubeTexture.boundingBoxSize);
                        }
                    }
                }
                // Point size
                if (this.pointsCloud) ubo.updateFloat("pointSize", this.pointSize);
                if (defines.SPECULARTERM) ubo.updateColor4("vSpecularColor", this.specularColor, this.specularPower);
                ubo.updateColor3("vEmissiveColor", $c14168b02f7bcc00$export$cb949309547a0dd7.EmissiveTextureEnabled ? this.emissiveColor : (0, $7etnY.Color3).BlackReadOnly);
                ubo.updateColor4("vDiffuseColor", this.diffuseColor, this.alpha);
                scene.ambientColor.multiplyToRef(this.ambientColor, this._globalAmbientColor);
                ubo.updateColor3("vAmbientColor", this._globalAmbientColor);
            }
            // Textures
            if (scene.texturesEnabled) {
                if (this._diffuseTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.DiffuseTextureEnabled) effect.setTexture("diffuseSampler", this._diffuseTexture);
                if (this._ambientTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.AmbientTextureEnabled) effect.setTexture("ambientSampler", this._ambientTexture);
                if (this._opacityTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.OpacityTextureEnabled) effect.setTexture("opacitySampler", this._opacityTexture);
                if (this._reflectionTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.ReflectionTextureEnabled) {
                    if (this._reflectionTexture.isCube) effect.setTexture("reflectionCubeSampler", this._reflectionTexture);
                    else effect.setTexture("reflection2DSampler", this._reflectionTexture);
                }
                if (this._emissiveTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.EmissiveTextureEnabled) effect.setTexture("emissiveSampler", this._emissiveTexture);
                if (this._lightmapTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.LightmapTextureEnabled) effect.setTexture("lightmapSampler", this._lightmapTexture);
                if (this._specularTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.SpecularTextureEnabled) effect.setTexture("specularSampler", this._specularTexture);
                if (this._bumpTexture && scene.getEngine().getCaps().standardDerivatives && $c14168b02f7bcc00$export$cb949309547a0dd7.BumpTextureEnabled) effect.setTexture("bumpSampler", this._bumpTexture);
                if (this._refractionTexture && $c14168b02f7bcc00$export$cb949309547a0dd7.RefractionTextureEnabled) {
                    if (this._refractionTexture.isCube) effect.setTexture("refractionCubeSampler", this._refractionTexture);
                    else effect.setTexture("refraction2DSampler", this._refractionTexture);
                }
            }
            // OIT with depth peeling
            if (this.getScene().useOrderIndependentTransparency && this.needAlphaBlendingForMesh(mesh)) this.getScene().depthPeelingRenderer.bind(effect);
            this._eventInfo.subMesh = subMesh;
            this._callbackPluginEventBindForSubMesh(this._eventInfo);
            // Clip plane
            (0, $aAFeM.bindClipPlane)(effect, this, scene);
            // Colors
            this.bindEyePosition(effect);
        } else if (scene.getEngine()._features.needToAlwaysBindUniformBuffers) this._needToBindSceneUbo = true;
        if (mustRebind || !this.isFrozen) {
            // Lights
            if (scene.lightsEnabled && !this._disableLighting) (0, $alPCh.BindLights)(scene, mesh, effect, defines, this._maxSimultaneousLights);
            // View
            if (scene.fogEnabled && mesh.applyFog && scene.fogMode !== (0, $gmbCk.Scene).FOGMODE_NONE || this._reflectionTexture || this._refractionTexture || mesh.receiveShadows || defines.PREPASS) this.bindView(effect);
            // Fog
            (0, $alPCh.BindFogParameters)(scene, mesh, effect);
            // Morph targets
            if (defines.NUM_MORPH_INFLUENCERS) (0, $alPCh.BindMorphTargetParameters)(mesh, effect);
            if (defines.BAKED_VERTEX_ANIMATION_TEXTURE) mesh.bakedVertexAnimationManager?.bind(effect, defines.INSTANCES);
            // Log. depth
            if (this.useLogarithmicDepth) (0, $alPCh.BindLogDepth)(defines, effect, scene);
            // image processing
            if (this._imageProcessingConfiguration && !this._imageProcessingConfiguration.applyByPostProcess) this._imageProcessingConfiguration.bind(this._activeEffect);
        }
        this._afterBind(mesh, this._activeEffect, subMesh);
        ubo.update();
    }
    /**
     * Get the list of animatables in the material.
     * @returns the list of animatables object used in the material
     */ getAnimatables() {
        const results = super.getAnimatables();
        if (this._diffuseTexture && this._diffuseTexture.animations && this._diffuseTexture.animations.length > 0) results.push(this._diffuseTexture);
        if (this._ambientTexture && this._ambientTexture.animations && this._ambientTexture.animations.length > 0) results.push(this._ambientTexture);
        if (this._opacityTexture && this._opacityTexture.animations && this._opacityTexture.animations.length > 0) results.push(this._opacityTexture);
        if (this._reflectionTexture && this._reflectionTexture.animations && this._reflectionTexture.animations.length > 0) results.push(this._reflectionTexture);
        if (this._emissiveTexture && this._emissiveTexture.animations && this._emissiveTexture.animations.length > 0) results.push(this._emissiveTexture);
        if (this._specularTexture && this._specularTexture.animations && this._specularTexture.animations.length > 0) results.push(this._specularTexture);
        if (this._bumpTexture && this._bumpTexture.animations && this._bumpTexture.animations.length > 0) results.push(this._bumpTexture);
        if (this._lightmapTexture && this._lightmapTexture.animations && this._lightmapTexture.animations.length > 0) results.push(this._lightmapTexture);
        if (this._refractionTexture && this._refractionTexture.animations && this._refractionTexture.animations.length > 0) results.push(this._refractionTexture);
        return results;
    }
    /**
     * Gets the active textures from the material
     * @returns an array of textures
     */ getActiveTextures() {
        const activeTextures = super.getActiveTextures();
        if (this._diffuseTexture) activeTextures.push(this._diffuseTexture);
        if (this._ambientTexture) activeTextures.push(this._ambientTexture);
        if (this._opacityTexture) activeTextures.push(this._opacityTexture);
        if (this._reflectionTexture) activeTextures.push(this._reflectionTexture);
        if (this._emissiveTexture) activeTextures.push(this._emissiveTexture);
        if (this._specularTexture) activeTextures.push(this._specularTexture);
        if (this._bumpTexture) activeTextures.push(this._bumpTexture);
        if (this._lightmapTexture) activeTextures.push(this._lightmapTexture);
        if (this._refractionTexture) activeTextures.push(this._refractionTexture);
        return activeTextures;
    }
    /**
     * Specifies if the material uses a texture
     * @param texture defines the texture to check against the material
     * @returns a boolean specifying if the material uses the texture
     */ hasTexture(texture) {
        if (super.hasTexture(texture)) return true;
        if (this._diffuseTexture === texture) return true;
        if (this._ambientTexture === texture) return true;
        if (this._opacityTexture === texture) return true;
        if (this._reflectionTexture === texture) return true;
        if (this._emissiveTexture === texture) return true;
        if (this._specularTexture === texture) return true;
        if (this._bumpTexture === texture) return true;
        if (this._lightmapTexture === texture) return true;
        if (this._refractionTexture === texture) return true;
        return false;
    }
    /**
     * Disposes the material
     * @param forceDisposeEffect specifies if effects should be forcefully disposed
     * @param forceDisposeTextures specifies if textures should be forcefully disposed
     */ dispose(forceDisposeEffect, forceDisposeTextures) {
        if (forceDisposeTextures) {
            this._diffuseTexture?.dispose();
            this._ambientTexture?.dispose();
            this._opacityTexture?.dispose();
            this._reflectionTexture?.dispose();
            this._emissiveTexture?.dispose();
            this._specularTexture?.dispose();
            this._bumpTexture?.dispose();
            this._lightmapTexture?.dispose();
            this._refractionTexture?.dispose();
        }
        if (this._imageProcessingConfiguration && this._imageProcessingObserver) this._imageProcessingConfiguration.onUpdateParameters.remove(this._imageProcessingObserver);
        super.dispose(forceDisposeEffect, forceDisposeTextures);
    }
    /**
     * Makes a duplicate of the material, and gives it a new name
     * @param name defines the new name for the duplicated material
     * @param cloneTexturesOnlyOnce - if a texture is used in more than one channel (e.g diffuse and opacity), only clone it once and reuse it on the other channels. Default false.
     * @param rootUrl defines the root URL to use to load textures
     * @returns the cloned material
     */ clone(name, cloneTexturesOnlyOnce = true, rootUrl = "") {
        const result = (0, $6Ho1L.SerializationHelper).Clone(()=>new $c14168b02f7bcc00$export$cb949309547a0dd7(name, this.getScene()), this, {
            cloneTexturesOnlyOnce: cloneTexturesOnlyOnce
        });
        result.name = name;
        result.id = name;
        this.stencil.copyTo(result.stencil);
        this._clonePlugins(result, rootUrl);
        return result;
    }
    /**
     * Creates a standard material from parsed material data
     * @param source defines the JSON representation of the material
     * @param scene defines the hosting scene
     * @param rootUrl defines the root URL to use to load textures and relative dependencies
     * @returns a new standard material
     */ static Parse(source, scene, rootUrl) {
        const material = (0, $6Ho1L.SerializationHelper).Parse(()=>new $c14168b02f7bcc00$export$cb949309547a0dd7(source.name, scene), source, scene, rootUrl);
        if (source.stencil) material.stencil.parse(source.stencil, scene, rootUrl);
        (0, $54229.Material)._ParsePlugins(source, material, scene, rootUrl);
        return material;
    }
    // Flags used to enable or disable a type of texture for all Standard Materials
    /**
     * Are diffuse textures enabled in the application.
     */ static get DiffuseTextureEnabled() {
        return (0, $2hKx5.MaterialFlags).DiffuseTextureEnabled;
    }
    static set DiffuseTextureEnabled(value) {
        (0, $2hKx5.MaterialFlags).DiffuseTextureEnabled = value;
    }
    /**
     * Are detail textures enabled in the application.
     */ static get DetailTextureEnabled() {
        return (0, $2hKx5.MaterialFlags).DetailTextureEnabled;
    }
    static set DetailTextureEnabled(value) {
        (0, $2hKx5.MaterialFlags).DetailTextureEnabled = value;
    }
    /**
     * Are ambient textures enabled in the application.
     */ static get AmbientTextureEnabled() {
        return (0, $2hKx5.MaterialFlags).AmbientTextureEnabled;
    }
    static set AmbientTextureEnabled(value) {
        (0, $2hKx5.MaterialFlags).AmbientTextureEnabled = value;
    }
    /**
     * Are opacity textures enabled in the application.
     */ static get OpacityTextureEnabled() {
        return (0, $2hKx5.MaterialFlags).OpacityTextureEnabled;
    }
    static set OpacityTextureEnabled(value) {
        (0, $2hKx5.MaterialFlags).OpacityTextureEnabled = value;
    }
    /**
     * Are reflection textures enabled in the application.
     */ static get ReflectionTextureEnabled() {
        return (0, $2hKx5.MaterialFlags).ReflectionTextureEnabled;
    }
    static set ReflectionTextureEnabled(value) {
        (0, $2hKx5.MaterialFlags).ReflectionTextureEnabled = value;
    }
    /**
     * Are emissive textures enabled in the application.
     */ static get EmissiveTextureEnabled() {
        return (0, $2hKx5.MaterialFlags).EmissiveTextureEnabled;
    }
    static set EmissiveTextureEnabled(value) {
        (0, $2hKx5.MaterialFlags).EmissiveTextureEnabled = value;
    }
    /**
     * Are specular textures enabled in the application.
     */ static get SpecularTextureEnabled() {
        return (0, $2hKx5.MaterialFlags).SpecularTextureEnabled;
    }
    static set SpecularTextureEnabled(value) {
        (0, $2hKx5.MaterialFlags).SpecularTextureEnabled = value;
    }
    /**
     * Are bump textures enabled in the application.
     */ static get BumpTextureEnabled() {
        return (0, $2hKx5.MaterialFlags).BumpTextureEnabled;
    }
    static set BumpTextureEnabled(value) {
        (0, $2hKx5.MaterialFlags).BumpTextureEnabled = value;
    }
    /**
     * Are lightmap textures enabled in the application.
     */ static get LightmapTextureEnabled() {
        return (0, $2hKx5.MaterialFlags).LightmapTextureEnabled;
    }
    static set LightmapTextureEnabled(value) {
        (0, $2hKx5.MaterialFlags).LightmapTextureEnabled = value;
    }
    /**
     * Are refraction textures enabled in the application.
     */ static get RefractionTextureEnabled() {
        return (0, $2hKx5.MaterialFlags).RefractionTextureEnabled;
    }
    static set RefractionTextureEnabled(value) {
        (0, $2hKx5.MaterialFlags).RefractionTextureEnabled = value;
    }
    /**
     * Are color grading textures enabled in the application.
     */ static get ColorGradingTextureEnabled() {
        return (0, $2hKx5.MaterialFlags).ColorGradingTextureEnabled;
    }
    static set ColorGradingTextureEnabled(value) {
        (0, $2hKx5.MaterialFlags).ColorGradingTextureEnabled = value;
    }
    /**
     * Are fresnels enabled in the application.
     */ static get FresnelEnabled() {
        return (0, $2hKx5.MaterialFlags).FresnelEnabled;
    }
    static set FresnelEnabled(value) {
        (0, $2hKx5.MaterialFlags).FresnelEnabled = value;
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)("diffuseTexture")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_diffuseTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesAndMiscDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "diffuseTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)("ambientTexture")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_ambientTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "ambientTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)("opacityTexture")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_opacityTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesAndMiscDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "opacityTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)("reflectionTexture")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_reflectionTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "reflectionTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)("emissiveTexture")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_emissiveTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "emissiveTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)("specularTexture")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_specularTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "specularTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)("bumpTexture")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_bumpTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "bumpTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)("lightmapTexture")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_lightmapTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "lightmapTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)("refractionTexture")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_refractionTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "refractionTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor3)("ambient")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "ambientColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor3)("diffuse")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "diffuseColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor3)("specular")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "specularColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor3)("emissive")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "emissiveColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "specularPower", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("useAlphaFromDiffuseTexture")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_useAlphaFromDiffuseTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesAndMiscDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "useAlphaFromDiffuseTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("useEmissiveAsIllumination")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_useEmissiveAsIllumination", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "useEmissiveAsIllumination", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("linkEmissiveWithDiffuse")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_linkEmissiveWithDiffuse", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "linkEmissiveWithDiffuse", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("useSpecularOverAlpha")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_useSpecularOverAlpha", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "useSpecularOverAlpha", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("useReflectionOverAlpha")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_useReflectionOverAlpha", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "useReflectionOverAlpha", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("disableLighting")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_disableLighting", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsLightsDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "disableLighting", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("useObjectSpaceNormalMap")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_useObjectSpaceNormalMap", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "useObjectSpaceNormalMap", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("useParallax")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_useParallax", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "useParallax", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("useParallaxOcclusion")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_useParallaxOcclusion", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "useParallaxOcclusion", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "parallaxScaleBias", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("roughness")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_roughness", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "roughness", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "indexOfRefraction", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "invertRefractionY", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "alphaCutOff", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("useLightmapAsShadowmap")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_useLightmapAsShadowmap", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "useLightmapAsShadowmap", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsFresnelParameters)("diffuseFresnelParameters")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_diffuseFresnelParameters", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsFresnelDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "diffuseFresnelParameters", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsFresnelParameters)("opacityFresnelParameters")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_opacityFresnelParameters", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsFresnelAndMiscDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "opacityFresnelParameters", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsFresnelParameters)("reflectionFresnelParameters")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_reflectionFresnelParameters", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsFresnelDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "reflectionFresnelParameters", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsFresnelParameters)("refractionFresnelParameters")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_refractionFresnelParameters", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsFresnelDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "refractionFresnelParameters", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsFresnelParameters)("emissiveFresnelParameters")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_emissiveFresnelParameters", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsFresnelDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "emissiveFresnelParameters", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("useReflectionFresnelFromSpecular")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_useReflectionFresnelFromSpecular", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsFresnelDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "useReflectionFresnelFromSpecular", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("useGlossinessFromSpecularMapAlpha")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_useGlossinessFromSpecularMapAlpha", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "useGlossinessFromSpecularMapAlpha", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("maxSimultaneousLights")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_maxSimultaneousLights", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsLightsDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "maxSimultaneousLights", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("invertNormalMapX")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_invertNormalMapX", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "invertNormalMapX", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("invertNormalMapY")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_invertNormalMapY", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "invertNormalMapY", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("twoSidedLighting")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_twoSidedLighting", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "twoSidedLighting", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("applyDecalMapAfterDetailMap")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "_applyDecalMapAfterDetailMap", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsMiscDirty")
], $c14168b02f7bcc00$export$cb949309547a0dd7.prototype, "applyDecalMapAfterDetailMap", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.StandardMaterial", $c14168b02f7bcc00$export$cb949309547a0dd7);
(0, $gmbCk.Scene).DefaultMaterialFactory = (scene)=>{
    return new $c14168b02f7bcc00$export$cb949309547a0dd7("default material", scene);
};

});
parcelRegister("dqWqq", function(module, exports) {

$parcel$export(module.exports, "PrePassConfiguration", () => $9c7b0616b7e91126$export$ccd4486ebb81b39a);
/**
 * Configuration needed for prepass-capable materials
 */ class $9c7b0616b7e91126$export$ccd4486ebb81b39a {
    constructor(){
        /**
         * Previous world matrices of meshes carrying this material
         * Used for computing velocity
         */ this.previousWorldMatrices = {};
        /**
         * Previous bones of meshes carrying this material
         * Used for computing velocity
         */ this.previousBones = {};
    }
    /**
     * Add the required uniforms to the current list.
     * @param uniforms defines the current uniform list.
     */ static AddUniforms(uniforms) {
        uniforms.push("previousWorld", "previousViewProjection", "mPreviousBones");
    }
    /**
     * Add the required samplers to the current list.
     * @param samplers defines the current sampler list.
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    static AddSamplers(samplers) {
    // pass
    }
    /**
     * Binds the material data.
     * @param effect defines the effect to update
     * @param scene defines the scene the material belongs to.
     * @param mesh The mesh
     * @param world World matrix of this mesh
     * @param isFrozen Is the material frozen
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    bindForSubMesh(effect, scene, mesh, world, isFrozen) {
        if (scene.prePassRenderer && scene.prePassRenderer.enabled && scene.prePassRenderer.currentRTisSceneRT) {
            if (scene.prePassRenderer.getIndex(2) !== -1) {
                if (!this.previousWorldMatrices[mesh.uniqueId]) this.previousWorldMatrices[mesh.uniqueId] = world.clone();
                if (!this.previousViewProjection) {
                    this.previousViewProjection = scene.getTransformMatrix().clone();
                    this.currentViewProjection = scene.getTransformMatrix().clone();
                }
                const engine = scene.getEngine();
                if (this.currentViewProjection.updateFlag !== scene.getTransformMatrix().updateFlag) {
                    // First update of the prepass configuration for this rendering pass
                    this._lastUpdateFrameId = engine.frameId;
                    this.previousViewProjection.copyFrom(this.currentViewProjection);
                    this.currentViewProjection.copyFrom(scene.getTransformMatrix());
                } else if (this._lastUpdateFrameId !== engine.frameId) {
                    // The scene transformation did not change from the previous frame (so no camera motion), we must update previousViewProjection accordingly
                    this._lastUpdateFrameId = engine.frameId;
                    this.previousViewProjection.copyFrom(this.currentViewProjection);
                }
                effect.setMatrix("previousWorld", this.previousWorldMatrices[mesh.uniqueId]);
                effect.setMatrix("previousViewProjection", this.previousViewProjection);
                this.previousWorldMatrices[mesh.uniqueId] = world.clone();
            }
        }
    }
}

});

parcelRegister("2hKx5", function(module, exports) {

$parcel$export(module.exports, "MaterialFlags", () => $1aa143b647fe12a5$export$cf9c31ce2002efcc);

var $5YkyR = parcelRequire("5YkyR");
class $1aa143b647fe12a5$export$cf9c31ce2002efcc {
    /**
     * Are diffuse textures enabled in the application.
     */ static get DiffuseTextureEnabled() {
        return this._DiffuseTextureEnabled;
    }
    static set DiffuseTextureEnabled(value) {
        if (this._DiffuseTextureEnabled === value) return;
        this._DiffuseTextureEnabled = value;
        (0, $5YkyR.Engine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are detail textures enabled in the application.
     */ static get DetailTextureEnabled() {
        return this._DetailTextureEnabled;
    }
    static set DetailTextureEnabled(value) {
        if (this._DetailTextureEnabled === value) return;
        this._DetailTextureEnabled = value;
        (0, $5YkyR.Engine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are decal maps enabled in the application.
     */ static get DecalMapEnabled() {
        return this._DecalMapEnabled;
    }
    static set DecalMapEnabled(value) {
        if (this._DecalMapEnabled === value) return;
        this._DecalMapEnabled = value;
        (0, $5YkyR.Engine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are ambient textures enabled in the application.
     */ static get AmbientTextureEnabled() {
        return this._AmbientTextureEnabled;
    }
    static set AmbientTextureEnabled(value) {
        if (this._AmbientTextureEnabled === value) return;
        this._AmbientTextureEnabled = value;
        (0, $5YkyR.Engine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are opacity textures enabled in the application.
     */ static get OpacityTextureEnabled() {
        return this._OpacityTextureEnabled;
    }
    static set OpacityTextureEnabled(value) {
        if (this._OpacityTextureEnabled === value) return;
        this._OpacityTextureEnabled = value;
        (0, $5YkyR.Engine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are reflection textures enabled in the application.
     */ static get ReflectionTextureEnabled() {
        return this._ReflectionTextureEnabled;
    }
    static set ReflectionTextureEnabled(value) {
        if (this._ReflectionTextureEnabled === value) return;
        this._ReflectionTextureEnabled = value;
        (0, $5YkyR.Engine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are emissive textures enabled in the application.
     */ static get EmissiveTextureEnabled() {
        return this._EmissiveTextureEnabled;
    }
    static set EmissiveTextureEnabled(value) {
        if (this._EmissiveTextureEnabled === value) return;
        this._EmissiveTextureEnabled = value;
        (0, $5YkyR.Engine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are specular textures enabled in the application.
     */ static get SpecularTextureEnabled() {
        return this._SpecularTextureEnabled;
    }
    static set SpecularTextureEnabled(value) {
        if (this._SpecularTextureEnabled === value) return;
        this._SpecularTextureEnabled = value;
        (0, $5YkyR.Engine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are bump textures enabled in the application.
     */ static get BumpTextureEnabled() {
        return this._BumpTextureEnabled;
    }
    static set BumpTextureEnabled(value) {
        if (this._BumpTextureEnabled === value) return;
        this._BumpTextureEnabled = value;
        (0, $5YkyR.Engine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are lightmap textures enabled in the application.
     */ static get LightmapTextureEnabled() {
        return this._LightmapTextureEnabled;
    }
    static set LightmapTextureEnabled(value) {
        if (this._LightmapTextureEnabled === value) return;
        this._LightmapTextureEnabled = value;
        (0, $5YkyR.Engine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are refraction textures enabled in the application.
     */ static get RefractionTextureEnabled() {
        return this._RefractionTextureEnabled;
    }
    static set RefractionTextureEnabled(value) {
        if (this._RefractionTextureEnabled === value) return;
        this._RefractionTextureEnabled = value;
        (0, $5YkyR.Engine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are color grading textures enabled in the application.
     */ static get ColorGradingTextureEnabled() {
        return this._ColorGradingTextureEnabled;
    }
    static set ColorGradingTextureEnabled(value) {
        if (this._ColorGradingTextureEnabled === value) return;
        this._ColorGradingTextureEnabled = value;
        (0, $5YkyR.Engine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are fresnels enabled in the application.
     */ static get FresnelEnabled() {
        return this._FresnelEnabled;
    }
    static set FresnelEnabled(value) {
        if (this._FresnelEnabled === value) return;
        this._FresnelEnabled = value;
        (0, $5YkyR.Engine).MarkAllMaterialsAsDirty(4);
    }
    /**
     * Are clear coat textures enabled in the application.
     */ static get ClearCoatTextureEnabled() {
        return this._ClearCoatTextureEnabled;
    }
    static set ClearCoatTextureEnabled(value) {
        if (this._ClearCoatTextureEnabled === value) return;
        this._ClearCoatTextureEnabled = value;
        (0, $5YkyR.Engine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are clear coat bump textures enabled in the application.
     */ static get ClearCoatBumpTextureEnabled() {
        return this._ClearCoatBumpTextureEnabled;
    }
    static set ClearCoatBumpTextureEnabled(value) {
        if (this._ClearCoatBumpTextureEnabled === value) return;
        this._ClearCoatBumpTextureEnabled = value;
        (0, $5YkyR.Engine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are clear coat tint textures enabled in the application.
     */ static get ClearCoatTintTextureEnabled() {
        return this._ClearCoatTintTextureEnabled;
    }
    static set ClearCoatTintTextureEnabled(value) {
        if (this._ClearCoatTintTextureEnabled === value) return;
        this._ClearCoatTintTextureEnabled = value;
        (0, $5YkyR.Engine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are sheen textures enabled in the application.
     */ static get SheenTextureEnabled() {
        return this._SheenTextureEnabled;
    }
    static set SheenTextureEnabled(value) {
        if (this._SheenTextureEnabled === value) return;
        this._SheenTextureEnabled = value;
        (0, $5YkyR.Engine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are anisotropic textures enabled in the application.
     */ static get AnisotropicTextureEnabled() {
        return this._AnisotropicTextureEnabled;
    }
    static set AnisotropicTextureEnabled(value) {
        if (this._AnisotropicTextureEnabled === value) return;
        this._AnisotropicTextureEnabled = value;
        (0, $5YkyR.Engine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are thickness textures enabled in the application.
     */ static get ThicknessTextureEnabled() {
        return this._ThicknessTextureEnabled;
    }
    static set ThicknessTextureEnabled(value) {
        if (this._ThicknessTextureEnabled === value) return;
        this._ThicknessTextureEnabled = value;
        (0, $5YkyR.Engine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are refraction intensity textures enabled in the application.
     */ static get RefractionIntensityTextureEnabled() {
        return this._ThicknessTextureEnabled;
    }
    static set RefractionIntensityTextureEnabled(value) {
        if (this._RefractionIntensityTextureEnabled === value) return;
        this._RefractionIntensityTextureEnabled = value;
        (0, $5YkyR.Engine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are translucency intensity textures enabled in the application.
     */ static get TranslucencyIntensityTextureEnabled() {
        return this._ThicknessTextureEnabled;
    }
    static set TranslucencyIntensityTextureEnabled(value) {
        if (this._TranslucencyIntensityTextureEnabled === value) return;
        this._TranslucencyIntensityTextureEnabled = value;
        (0, $5YkyR.Engine).MarkAllMaterialsAsDirty(1);
    }
    /**
     * Are translucency intensity textures enabled in the application.
     */ static get IridescenceTextureEnabled() {
        return this._IridescenceTextureEnabled;
    }
    static set IridescenceTextureEnabled(value) {
        if (this._IridescenceTextureEnabled === value) return;
        this._IridescenceTextureEnabled = value;
        (0, $5YkyR.Engine).MarkAllMaterialsAsDirty(1);
    }
}
// Flags used to enable or disable a type of texture for all Standard Materials
$1aa143b647fe12a5$export$cf9c31ce2002efcc._DiffuseTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._DetailTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._DecalMapEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._AmbientTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._OpacityTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._ReflectionTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._EmissiveTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._SpecularTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._BumpTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._LightmapTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._RefractionTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._ColorGradingTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._FresnelEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._ClearCoatTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._ClearCoatBumpTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._ClearCoatTintTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._SheenTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._AnisotropicTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._ThicknessTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._RefractionIntensityTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._TranslucencyIntensityTextureEnabled = true;
$1aa143b647fe12a5$export$cf9c31ce2002efcc._IridescenceTextureEnabled = true;

});

parcelRegister("5rZFU", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("53H4c");
parcelRequire("dcSpY");
parcelRequire("aYEjM");
parcelRequire("7RpqZ");
parcelRequire("5lMLg");
parcelRequire("7Hs3g");
parcelRequire("7UkOz");
parcelRequire("gi9Sf");
parcelRequire("eFnxQ");
parcelRequire("lcI5C");
parcelRequire("b4ZX6");
parcelRequire("6zQZ5");
parcelRequire("6vG1y");
parcelRequire("jtwq6");
parcelRequire("cRFSM");
parcelRequire("lnIOB");
parcelRequire("2KL02");
parcelRequire("82O8L");
parcelRequire("4kipo");
parcelRequire("hvLF9");
parcelRequire("kg1CD");
parcelRequire("F4hvB");
parcelRequire("lP7hO");
parcelRequire("6bTUi");
parcelRequire("4ycgE");
parcelRequire("izyqw");
parcelRequire("110hr");
parcelRequire("b21vU");
const $3f7f50b7f7e4e635$var$name = "defaultPixelShader";
const $3f7f50b7f7e4e635$var$shader = `#include<__decl__defaultFragment>
#if defined(BUMP) || !defined(NORMAL)
#extension GL_OES_standard_derivatives : enable
#endif
#include<prePassDeclaration>[SCENE_MRT_COUNT]
#include<oitDeclaration>
#define CUSTOM_FRAGMENT_BEGIN
#ifdef LOGARITHMICDEPTH
#extension GL_EXT_frag_depth : enable
#endif
varying vec3 vPositionW;
#ifdef NORMAL
varying vec3 vNormalW;
#endif
#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
varying vec4 vColor;
#endif
#include<mainUVVaryingDeclaration>[1..7]
#include<helperFunctions>
#include<__decl__lightFragment>[0..maxSimultaneousLights]
#include<lightsFragmentFunctions>
#include<shadowsFragmentFunctions>
#include<samplerFragmentDeclaration>(_DEFINENAME_,DIFFUSE,_VARYINGNAME_,Diffuse,_SAMPLERNAME_,diffuse)
#include<samplerFragmentDeclaration>(_DEFINENAME_,AMBIENT,_VARYINGNAME_,Ambient,_SAMPLERNAME_,ambient)
#include<samplerFragmentDeclaration>(_DEFINENAME_,OPACITY,_VARYINGNAME_,Opacity,_SAMPLERNAME_,opacity)
#include<samplerFragmentDeclaration>(_DEFINENAME_,EMISSIVE,_VARYINGNAME_,Emissive,_SAMPLERNAME_,emissive)
#include<samplerFragmentDeclaration>(_DEFINENAME_,LIGHTMAP,_VARYINGNAME_,Lightmap,_SAMPLERNAME_,lightmap)
#include<samplerFragmentDeclaration>(_DEFINENAME_,DECAL,_VARYINGNAME_,Decal,_SAMPLERNAME_,decal)
#ifdef REFRACTION
#ifdef REFRACTIONMAP_3D
uniform samplerCube refractionCubeSampler;
#else
uniform sampler2D refraction2DSampler;
#endif
#endif
#if defined(SPECULARTERM)
#include<samplerFragmentDeclaration>(_DEFINENAME_,SPECULAR,_VARYINGNAME_,Specular,_SAMPLERNAME_,specular)
#endif
#include<fresnelFunction>
#ifdef REFLECTION
#ifdef REFLECTIONMAP_3D
uniform samplerCube reflectionCubeSampler;
#else
uniform sampler2D reflection2DSampler;
#endif
#ifdef REFLECTIONMAP_SKYBOX
varying vec3 vPositionUVW;
#else
#if defined(REFLECTIONMAP_EQUIRECTANGULAR_FIXED) || defined(REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED)
varying vec3 vDirectionW;
#endif
#endif
#include<reflectionFunction>
#endif
#include<imageProcessingDeclaration>
#include<imageProcessingFunctions>
#include<bumpFragmentMainFunctions>
#include<bumpFragmentFunctions>
#include<clipPlaneFragmentDeclaration>
#include<logDepthDeclaration>
#include<fogFragmentDeclaration>
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) {
#define CUSTOM_FRAGMENT_MAIN_BEGIN
#include<clipPlaneFragment>
vec3 viewDirectionW=normalize(vEyePosition.xyz-vPositionW);vec4 baseColor=vec4(1.,1.,1.,1.);vec3 diffuseColor=vDiffuseColor.rgb;float alpha=vDiffuseColor.a;
#ifdef NORMAL
vec3 normalW=normalize(vNormalW);
#else
vec3 normalW=normalize(-cross(dFdx(vPositionW),dFdy(vPositionW)));
#endif
#include<bumpFragment>
#ifdef TWOSIDEDLIGHTING
normalW=gl_FrontFacing ? normalW : -normalW;
#endif
#ifdef DIFFUSE
baseColor=texture2D(diffuseSampler,vDiffuseUV+uvOffset);
#if defined(ALPHATEST) && !defined(ALPHATEST_AFTERALLALPHACOMPUTATIONS)
if (baseColor.a<alphaCutOff)
discard;
#endif
#ifdef ALPHAFROMDIFFUSE
alpha*=baseColor.a;
#endif
#define CUSTOM_FRAGMENT_UPDATE_ALPHA
baseColor.rgb*=vDiffuseInfos.y;
#endif
#if defined(DECAL) && !defined(DECAL_AFTER_DETAIL)
vec4 decalColor=texture2D(decalSampler,vDecalUV+uvOffset);
#include<decalFragment>(surfaceAlbedo,baseColor,GAMMADECAL,_GAMMADECAL_NOTUSED_)
#endif
#include<depthPrePass>
#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
baseColor.rgb*=vColor.rgb;
#endif
#ifdef DETAIL
baseColor.rgb=baseColor.rgb*2.0*mix(0.5,detailColor.r,vDetailInfos.y);
#endif
#if defined(DECAL) && defined(DECAL_AFTER_DETAIL)
vec4 decalColor=texture2D(decalSampler,vDecalUV+uvOffset);
#include<decalFragment>(surfaceAlbedo,baseColor,GAMMADECAL,_GAMMADECAL_NOTUSED_)
#endif
#define CUSTOM_FRAGMENT_UPDATE_DIFFUSE
vec3 baseAmbientColor=vec3(1.,1.,1.);
#ifdef AMBIENT
baseAmbientColor=texture2D(ambientSampler,vAmbientUV+uvOffset).rgb*vAmbientInfos.y;
#endif
#define CUSTOM_FRAGMENT_BEFORE_LIGHTS
#ifdef SPECULARTERM
float glossiness=vSpecularColor.a;vec3 specularColor=vSpecularColor.rgb;
#ifdef SPECULAR
vec4 specularMapColor=texture2D(specularSampler,vSpecularUV+uvOffset);specularColor=specularMapColor.rgb;
#ifdef GLOSSINESS
glossiness=glossiness*specularMapColor.a;
#endif
#endif
#else
float glossiness=0.;
#endif
vec3 diffuseBase=vec3(0.,0.,0.);lightingInfo info;
#ifdef SPECULARTERM
vec3 specularBase=vec3(0.,0.,0.);
#endif
float shadow=1.;float aggShadow=0.;float numLights=0.;
#ifdef LIGHTMAP
vec4 lightmapColor=texture2D(lightmapSampler,vLightmapUV+uvOffset);
#ifdef RGBDLIGHTMAP
lightmapColor.rgb=fromRGBD(lightmapColor);
#endif
lightmapColor.rgb*=vLightmapInfos.y;
#endif
#include<lightFragment>[0..maxSimultaneousLights]
aggShadow=aggShadow/numLights;vec4 refractionColor=vec4(0.,0.,0.,1.);
#ifdef REFRACTION
vec3 refractionVector=normalize(refract(-viewDirectionW,normalW,vRefractionInfos.y));
#ifdef REFRACTIONMAP_3D
#ifdef USE_LOCAL_REFRACTIONMAP_CUBIC
refractionVector=parallaxCorrectNormal(vPositionW,refractionVector,vRefractionSize,vRefractionPosition);
#endif
refractionVector.y=refractionVector.y*vRefractionInfos.w;vec4 refractionLookup=textureCube(refractionCubeSampler,refractionVector);if (dot(refractionVector,viewDirectionW)<1.0) {refractionColor=refractionLookup;}
#else
vec3 vRefractionUVW=vec3(refractionMatrix*(view*vec4(vPositionW+refractionVector*vRefractionInfos.z,1.0)));vec2 refractionCoords=vRefractionUVW.xy/vRefractionUVW.z;refractionCoords.y=1.0-refractionCoords.y;refractionColor=texture2D(refraction2DSampler,refractionCoords);
#endif
#ifdef RGBDREFRACTION
refractionColor.rgb=fromRGBD(refractionColor);
#endif
#ifdef IS_REFRACTION_LINEAR
refractionColor.rgb=toGammaSpace(refractionColor.rgb);
#endif
refractionColor.rgb*=vRefractionInfos.x;
#endif
vec4 reflectionColor=vec4(0.,0.,0.,1.);
#ifdef REFLECTION
vec3 vReflectionUVW=computeReflectionCoords(vec4(vPositionW,1.0),normalW);
#ifdef REFLECTIONMAP_OPPOSITEZ
vReflectionUVW.z*=-1.0;
#endif
#ifdef REFLECTIONMAP_3D
#ifdef ROUGHNESS
float bias=vReflectionInfos.y;
#ifdef SPECULARTERM
#ifdef SPECULAR
#ifdef GLOSSINESS
bias*=(1.0-specularMapColor.a);
#endif
#endif
#endif
reflectionColor=textureCube(reflectionCubeSampler,vReflectionUVW,bias);
#else
reflectionColor=textureCube(reflectionCubeSampler,vReflectionUVW);
#endif
#else
vec2 coords=vReflectionUVW.xy;
#ifdef REFLECTIONMAP_PROJECTION
coords/=vReflectionUVW.z;
#endif
coords.y=1.0-coords.y;reflectionColor=texture2D(reflection2DSampler,coords);
#endif
#ifdef RGBDREFLECTION
reflectionColor.rgb=fromRGBD(reflectionColor);
#endif
#ifdef IS_REFLECTION_LINEAR
reflectionColor.rgb=toGammaSpace(reflectionColor.rgb);
#endif
reflectionColor.rgb*=vReflectionInfos.x;
#ifdef REFLECTIONFRESNEL
float reflectionFresnelTerm=computeFresnelTerm(viewDirectionW,normalW,reflectionRightColor.a,reflectionLeftColor.a);
#ifdef REFLECTIONFRESNELFROMSPECULAR
#ifdef SPECULARTERM
reflectionColor.rgb*=specularColor.rgb*(1.0-reflectionFresnelTerm)+reflectionFresnelTerm*reflectionRightColor.rgb;
#else
reflectionColor.rgb*=reflectionLeftColor.rgb*(1.0-reflectionFresnelTerm)+reflectionFresnelTerm*reflectionRightColor.rgb;
#endif
#else
reflectionColor.rgb*=reflectionLeftColor.rgb*(1.0-reflectionFresnelTerm)+reflectionFresnelTerm*reflectionRightColor.rgb;
#endif
#endif
#endif
#ifdef REFRACTIONFRESNEL
float refractionFresnelTerm=computeFresnelTerm(viewDirectionW,normalW,refractionRightColor.a,refractionLeftColor.a);refractionColor.rgb*=refractionLeftColor.rgb*(1.0-refractionFresnelTerm)+refractionFresnelTerm*refractionRightColor.rgb;
#endif
#ifdef OPACITY
vec4 opacityMap=texture2D(opacitySampler,vOpacityUV+uvOffset);
#ifdef OPACITYRGB
opacityMap.rgb=opacityMap.rgb*vec3(0.3,0.59,0.11);alpha*=(opacityMap.x+opacityMap.y+opacityMap.z)* vOpacityInfos.y;
#else
alpha*=opacityMap.a*vOpacityInfos.y;
#endif
#endif
#if defined(VERTEXALPHA) || defined(INSTANCESCOLOR) && defined(INSTANCES)
alpha*=vColor.a;
#endif
#ifdef OPACITYFRESNEL
float opacityFresnelTerm=computeFresnelTerm(viewDirectionW,normalW,opacityParts.z,opacityParts.w);alpha+=opacityParts.x*(1.0-opacityFresnelTerm)+opacityFresnelTerm*opacityParts.y;
#endif
#ifdef ALPHATEST
#ifdef ALPHATEST_AFTERALLALPHACOMPUTATIONS
if (alpha<alphaCutOff)
discard;
#endif
#ifndef ALPHABLEND
alpha=1.0;
#endif
#endif
vec3 emissiveColor=vEmissiveColor;
#ifdef EMISSIVE
emissiveColor+=texture2D(emissiveSampler,vEmissiveUV+uvOffset).rgb*vEmissiveInfos.y;
#endif
#ifdef EMISSIVEFRESNEL
float emissiveFresnelTerm=computeFresnelTerm(viewDirectionW,normalW,emissiveRightColor.a,emissiveLeftColor.a);emissiveColor*=emissiveLeftColor.rgb*(1.0-emissiveFresnelTerm)+emissiveFresnelTerm*emissiveRightColor.rgb;
#endif
#ifdef DIFFUSEFRESNEL
float diffuseFresnelTerm=computeFresnelTerm(viewDirectionW,normalW,diffuseRightColor.a,diffuseLeftColor.a);diffuseBase*=diffuseLeftColor.rgb*(1.0-diffuseFresnelTerm)+diffuseFresnelTerm*diffuseRightColor.rgb;
#endif
#ifdef EMISSIVEASILLUMINATION
vec3 finalDiffuse=clamp(diffuseBase*diffuseColor+vAmbientColor,0.0,1.0)*baseColor.rgb;
#else
#ifdef LINKEMISSIVEWITHDIFFUSE
vec3 finalDiffuse=clamp((diffuseBase+emissiveColor)*diffuseColor+vAmbientColor,0.0,1.0)*baseColor.rgb;
#else
vec3 finalDiffuse=clamp(diffuseBase*diffuseColor+emissiveColor+vAmbientColor,0.0,1.0)*baseColor.rgb;
#endif
#endif
#ifdef SPECULARTERM
vec3 finalSpecular=specularBase*specularColor;
#ifdef SPECULAROVERALPHA
alpha=clamp(alpha+dot(finalSpecular,vec3(0.3,0.59,0.11)),0.,1.);
#endif
#else
vec3 finalSpecular=vec3(0.0);
#endif
#ifdef REFLECTIONOVERALPHA
alpha=clamp(alpha+dot(reflectionColor.rgb,vec3(0.3,0.59,0.11)),0.,1.);
#endif
#ifdef EMISSIVEASILLUMINATION
vec4 color=vec4(clamp(finalDiffuse*baseAmbientColor+finalSpecular+reflectionColor.rgb+emissiveColor+refractionColor.rgb,0.0,1.0),alpha);
#else
vec4 color=vec4(finalDiffuse*baseAmbientColor+finalSpecular+reflectionColor.rgb+refractionColor.rgb,alpha);
#endif
#ifdef LIGHTMAP
#ifndef LIGHTMAPEXCLUDED
#ifdef USELIGHTMAPASSHADOWMAP
color.rgb*=lightmapColor.rgb;
#else
color.rgb+=lightmapColor.rgb;
#endif
#endif
#endif
#define CUSTOM_FRAGMENT_BEFORE_FOG
color.rgb=max(color.rgb,0.);
#include<logDepthFragment>
#include<fogFragment>
#ifdef IMAGEPROCESSINGPOSTPROCESS
color.rgb=toLinearSpace(color.rgb);
#else
#ifdef IMAGEPROCESSING
color.rgb=toLinearSpace(color.rgb);color=applyImageProcessing(color);
#endif
#endif
color.a*=visibility;
#ifdef PREMULTIPLYALPHA
color.rgb*=color.a;
#endif
#define CUSTOM_FRAGMENT_BEFORE_FRAGCOLOR
#ifdef PREPASS
float writeGeometryInfo=color.a>0.4 ? 1.0 : 0.0;gl_FragData[0]=color; 
#ifdef PREPASS_POSITION
gl_FragData[PREPASS_POSITION_INDEX]=vec4(vPositionW,writeGeometryInfo);
#endif
#ifdef PREPASS_VELOCITY
vec2 a=(vCurrentPosition.xy/vCurrentPosition.w)*0.5+0.5;vec2 b=(vPreviousPosition.xy/vPreviousPosition.w)*0.5+0.5;vec2 velocity=abs(a-b);velocity=vec2(pow(velocity.x,1.0/3.0),pow(velocity.y,1.0/3.0))*sign(a-b)*0.5+0.5;gl_FragData[PREPASS_VELOCITY_INDEX]=vec4(velocity,0.0,writeGeometryInfo);
#endif
#ifdef PREPASS_IRRADIANCE
gl_FragData[PREPASS_IRRADIANCE_INDEX]=vec4(0.0,0.0,0.0,writeGeometryInfo); 
#endif
#ifdef PREPASS_DEPTH
gl_FragData[PREPASS_DEPTH_INDEX]=vec4(vViewPos.z,0.0,0.0,writeGeometryInfo); 
#endif
#ifdef PREPASS_NORMAL
#ifdef PREPASS_NORMAL_WORLDSPACE
gl_FragData[PREPASS_NORMAL_INDEX]=vec4(normalW,writeGeometryInfo); 
#else
gl_FragData[PREPASS_NORMAL_INDEX]=vec4(normalize((view*vec4(normalW,0.0)).rgb),writeGeometryInfo); 
#endif
#endif
#ifdef PREPASS_ALBEDO_SQRT
gl_FragData[PREPASS_ALBEDO_SQRT_INDEX]=vec4(0.0,0.0,0.0,writeGeometryInfo); 
#endif
#ifdef PREPASS_REFLECTIVITY
#if defined(SPECULARTERM)
#if defined(SPECULAR)
gl_FragData[PREPASS_REFLECTIVITY_INDEX]=vec4(toLinearSpace(specularMapColor))*writeGeometryInfo; 
#else
gl_FragData[PREPASS_REFLECTIVITY_INDEX]=vec4(toLinearSpace(specularColor),1.0)*writeGeometryInfo;
#endif
#else
gl_FragData[PREPASS_REFLECTIVITY_INDEX]=vec4(0.0,0.0,0.0,1.0)*writeGeometryInfo;
#endif
#endif
#endif
#if !defined(PREPASS) || defined(WEBGL2)
gl_FragColor=color;
#endif
#include<oitFragment>
#if ORDER_INDEPENDENT_TRANSPARENCY
if (fragDepth==nearestDepth) {frontColor.rgb+=color.rgb*color.a*alphaMultiplier;frontColor.a=1.0-alphaMultiplier*(1.0-color.a);} else {backColor+=color;}
#endif
#define CUSTOM_FRAGMENT_MAIN_END
}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$3f7f50b7f7e4e635$var$name] = $3f7f50b7f7e4e635$var$shader;
const $3f7f50b7f7e4e635$export$cc7b573577d674e6 = {
    name: $3f7f50b7f7e4e635$var$name,
    shader: $3f7f50b7f7e4e635$var$shader
};

});
parcelRegister("53H4c", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("hbX2w");
const $3aeea3b541097fa2$var$name = "defaultFragmentDeclaration";
const $3aeea3b541097fa2$var$shader = `uniform vec4 vEyePosition;uniform vec4 vDiffuseColor;
#ifdef SPECULARTERM
uniform vec4 vSpecularColor;
#endif
uniform vec3 vEmissiveColor;uniform vec3 vAmbientColor;uniform float visibility;
#ifdef DIFFUSE
uniform vec2 vDiffuseInfos;
#endif
#ifdef AMBIENT
uniform vec2 vAmbientInfos;
#endif
#ifdef OPACITY 
uniform vec2 vOpacityInfos;
#endif
#ifdef EMISSIVE
uniform vec2 vEmissiveInfos;
#endif
#ifdef LIGHTMAP
uniform vec2 vLightmapInfos;
#endif
#ifdef BUMP
uniform vec3 vBumpInfos;uniform vec2 vTangentSpaceParams;
#endif
#ifdef ALPHATEST
uniform float alphaCutOff;
#endif
#if defined(REFLECTIONMAP_SPHERICAL) || defined(REFLECTIONMAP_PROJECTION) || defined(REFRACTION) || defined(PREPASS)
uniform mat4 view;
#endif
#ifdef REFRACTION
uniform vec4 vRefractionInfos;
#ifndef REFRACTIONMAP_3D
uniform mat4 refractionMatrix;
#endif
#ifdef REFRACTIONFRESNEL
uniform vec4 refractionLeftColor;uniform vec4 refractionRightColor;
#endif
#if defined(USE_LOCAL_REFRACTIONMAP_CUBIC) && defined(REFRACTIONMAP_3D)
uniform vec3 vRefractionPosition;uniform vec3 vRefractionSize; 
#endif
#endif
#if defined(SPECULAR) && defined(SPECULARTERM)
uniform vec2 vSpecularInfos;
#endif
#ifdef DIFFUSEFRESNEL
uniform vec4 diffuseLeftColor;uniform vec4 diffuseRightColor;
#endif
#ifdef OPACITYFRESNEL
uniform vec4 opacityParts;
#endif
#ifdef EMISSIVEFRESNEL
uniform vec4 emissiveLeftColor;uniform vec4 emissiveRightColor;
#endif
#ifdef REFLECTION
uniform vec2 vReflectionInfos;
#if defined(REFLECTIONMAP_PLANAR) || defined(REFLECTIONMAP_CUBIC) || defined(REFLECTIONMAP_PROJECTION) || defined(REFLECTIONMAP_EQUIRECTANGULAR) || defined(REFLECTIONMAP_SPHERICAL) || defined(REFLECTIONMAP_SKYBOX)
uniform mat4 reflectionMatrix;
#endif
#ifndef REFLECTIONMAP_SKYBOX
#if defined(USE_LOCAL_REFLECTIONMAP_CUBIC) && defined(REFLECTIONMAP_CUBIC)
uniform vec3 vReflectionPosition;uniform vec3 vReflectionSize; 
#endif
#endif
#ifdef REFLECTIONFRESNEL
uniform vec4 reflectionLeftColor;uniform vec4 reflectionRightColor;
#endif
#endif
#ifdef DETAIL
uniform vec4 vDetailInfos;
#endif
#include<decalFragmentDeclaration>
#define ADDITIONAL_FRAGMENT_DECLARATION
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$3aeea3b541097fa2$var$name] = $3aeea3b541097fa2$var$shader;
const $3aeea3b541097fa2$export$373cd818a5adc946 = {
    name: $3aeea3b541097fa2$var$name,
    shader: $3aeea3b541097fa2$var$shader
};

});
parcelRegister("hbX2w", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $c84142c6e9b067d3$var$name = "decalFragmentDeclaration";
const $c84142c6e9b067d3$var$shader = `#ifdef DECAL
uniform vec4 vDecalInfos;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$c84142c6e9b067d3$var$name] = $c84142c6e9b067d3$var$shader;
const $c84142c6e9b067d3$export$6af07c32231b6bd1 = {
    name: $c84142c6e9b067d3$var$name,
    shader: $c84142c6e9b067d3$var$shader
};

});


parcelRegister("dcSpY", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("eZlZI");
parcelRequire("4u6lu");
const $99d69ba084b7d7da$var$name = "defaultUboDeclaration";
const $99d69ba084b7d7da$var$shader = `layout(std140,column_major) uniform;uniform Material
{vec4 diffuseLeftColor;vec4 diffuseRightColor;vec4 opacityParts;vec4 reflectionLeftColor;vec4 reflectionRightColor;vec4 refractionLeftColor;vec4 refractionRightColor;vec4 emissiveLeftColor;vec4 emissiveRightColor;vec2 vDiffuseInfos;vec2 vAmbientInfos;vec2 vOpacityInfos;vec2 vReflectionInfos;vec3 vReflectionPosition;vec3 vReflectionSize;vec2 vEmissiveInfos;vec2 vLightmapInfos;vec2 vSpecularInfos;vec3 vBumpInfos;mat4 diffuseMatrix;mat4 ambientMatrix;mat4 opacityMatrix;mat4 reflectionMatrix;mat4 emissiveMatrix;mat4 lightmapMatrix;mat4 specularMatrix;mat4 bumpMatrix;vec2 vTangentSpaceParams;float pointSize;float alphaCutOff;mat4 refractionMatrix;vec4 vRefractionInfos;vec3 vRefractionPosition;vec3 vRefractionSize;vec4 vSpecularColor;vec3 vEmissiveColor;vec4 vDiffuseColor;vec3 vAmbientColor;
#define ADDITIONAL_UBO_DECLARATION
};
#include<sceneUboDeclaration>
#include<meshUboDeclaration>
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$99d69ba084b7d7da$var$name] = $99d69ba084b7d7da$var$shader;
const $99d69ba084b7d7da$export$c2e57b57f6e813a4 = {
    name: $99d69ba084b7d7da$var$name,
    shader: $99d69ba084b7d7da$var$shader
};

});
parcelRegister("eZlZI", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $ae97d2ce74ca59f4$var$name = "sceneUboDeclaration";
const $ae97d2ce74ca59f4$var$shader = `layout(std140,column_major) uniform;uniform Scene {mat4 viewProjection;
#ifdef MULTIVIEW
mat4 viewProjectionR;
#endif 
mat4 view;mat4 projection;vec4 vEyePosition;};
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$ae97d2ce74ca59f4$var$name] = $ae97d2ce74ca59f4$var$shader;
const $ae97d2ce74ca59f4$export$89e49482cbc67f19 = {
    name: $ae97d2ce74ca59f4$var$name,
    shader: $ae97d2ce74ca59f4$var$shader
};

});

parcelRegister("4u6lu", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $343ee2dddd497bd6$var$name = "meshUboDeclaration";
const $343ee2dddd497bd6$var$shader = `#ifdef WEBGL2
uniform mat4 world;uniform float visibility;
#else
layout(std140,column_major) uniform;uniform Mesh
{mat4 world;float visibility;};
#endif
#define WORLD_UBO
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$343ee2dddd497bd6$var$name] = $343ee2dddd497bd6$var$shader;
const $343ee2dddd497bd6$export$7c5f228ba674c3fe = {
    name: $343ee2dddd497bd6$var$name,
    shader: $343ee2dddd497bd6$var$shader
};

});


parcelRegister("aYEjM", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $7fdec849d6454f7a$var$name = "prePassDeclaration";
const $7fdec849d6454f7a$var$shader = `#ifdef PREPASS
#extension GL_EXT_draw_buffers : require
layout(location=0) out highp vec4 glFragData[{X}];highp vec4 gl_FragColor;
#ifdef PREPASS_DEPTH
varying highp vec3 vViewPos;
#endif
#ifdef PREPASS_VELOCITY
varying highp vec4 vCurrentPosition;varying highp vec4 vPreviousPosition;
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$7fdec849d6454f7a$var$name] = $7fdec849d6454f7a$var$shader;
const $7fdec849d6454f7a$export$f53a51f7ec35381 = {
    name: $7fdec849d6454f7a$var$name,
    shader: $7fdec849d6454f7a$var$shader
};

});

parcelRegister("7RpqZ", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $5b91365b765d37d0$var$name = "oitDeclaration";
const $5b91365b765d37d0$var$shader = `#ifdef ORDER_INDEPENDENT_TRANSPARENCY
#extension GL_EXT_draw_buffers : require
layout(location=0) out vec2 depth; 
layout(location=1) out vec4 frontColor;layout(location=2) out vec4 backColor;
#define MAX_DEPTH 99999.0
highp vec4 gl_FragColor;uniform sampler2D oitDepthSampler;uniform sampler2D oitFrontColorSampler;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$5b91365b765d37d0$var$name] = $5b91365b765d37d0$var$shader;
const $5b91365b765d37d0$export$a68b3050a640b11a = {
    name: $5b91365b765d37d0$var$name,
    shader: $5b91365b765d37d0$var$shader
};

});

parcelRegister("5lMLg", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $3e54bce5d98c5a59$var$name = "mainUVVaryingDeclaration";
const $3e54bce5d98c5a59$var$shader = `#ifdef MAINUV{X}
varying vec2 vMainUV{X};
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$3e54bce5d98c5a59$var$name] = $3e54bce5d98c5a59$var$shader;
const $3e54bce5d98c5a59$export$44745f0433a780d2 = {
    name: $3e54bce5d98c5a59$var$name,
    shader: $3e54bce5d98c5a59$var$shader
};

});

parcelRegister("7Hs3g", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $59b24f0424d3f607$var$name = "helperFunctions";
const $59b24f0424d3f607$var$shader = `const float PI=3.1415926535897932384626433832795;const float RECIPROCAL_PI=0.3183098861837907;const float RECIPROCAL_PI2=0.15915494309189535;const float HALF_MIN=5.96046448e-08; 
const float LinearEncodePowerApprox=2.2;const float GammaEncodePowerApprox=1.0/LinearEncodePowerApprox;const vec3 LuminanceEncodeApprox=vec3(0.2126,0.7152,0.0722);const float Epsilon=0.0000001;
#define saturate(x) clamp(x,0.0,1.0)
#define absEps(x) abs(x)+Epsilon
#define maxEps(x) max(x,Epsilon)
#define saturateEps(x) clamp(x,Epsilon,1.0)
mat3 transposeMat3(mat3 inMatrix) {vec3 i0=inMatrix[0];vec3 i1=inMatrix[1];vec3 i2=inMatrix[2];mat3 outMatrix=mat3(
vec3(i0.x,i1.x,i2.x),
vec3(i0.y,i1.y,i2.y),
vec3(i0.z,i1.z,i2.z)
);return outMatrix;}
mat3 inverseMat3(mat3 inMatrix) {float a00=inMatrix[0][0],a01=inMatrix[0][1],a02=inMatrix[0][2];float a10=inMatrix[1][0],a11=inMatrix[1][1],a12=inMatrix[1][2];float a20=inMatrix[2][0],a21=inMatrix[2][1],a22=inMatrix[2][2];float b01=a22*a11-a12*a21;float b11=-a22*a10+a12*a20;float b21=a21*a10-a11*a20;float det=a00*b01+a01*b11+a02*b21;return mat3(b01,(-a22*a01+a02*a21),(a12*a01-a02*a11),
b11,(a22*a00-a02*a20),(-a12*a00+a02*a10),
b21,(-a21*a00+a01*a20),(a11*a00-a01*a10))/det;}
#if USE_EXACT_SRGB_CONVERSIONS
vec3 toLinearSpaceExact(vec3 color)
{vec3 nearZeroSection=0.0773993808*color;vec3 remainingSection=pow(0.947867299*(color+vec3(0.055)),vec3(2.4));
#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
return mix(remainingSection,nearZeroSection,lessThanEqual(color,vec3(0.04045)));
#else
return
vec3(
color.r<=0.04045 ? nearZeroSection.r : remainingSection.r,
color.g<=0.04045 ? nearZeroSection.g : remainingSection.g,
color.b<=0.04045 ? nearZeroSection.b : remainingSection.b);
#endif
}
vec3 toGammaSpaceExact(vec3 color)
{vec3 nearZeroSection=12.92*color;vec3 remainingSection=1.055*pow(color,vec3(0.41666))-vec3(0.055);
#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
return mix(remainingSection,nearZeroSection,lessThanEqual(color,vec3(0.0031308)));
#else
return
vec3(
color.r<=0.0031308 ? nearZeroSection.r : remainingSection.r,
color.g<=0.0031308 ? nearZeroSection.g : remainingSection.g,
color.b<=0.0031308 ? nearZeroSection.b : remainingSection.b);
#endif
}
#endif
float toLinearSpace(float color)
{
#if USE_EXACT_SRGB_CONVERSIONS
float nearZeroSection=0.0773993808*color;float remainingSection=pow(0.947867299*(color+0.055),2.4);return color<=0.04045 ? nearZeroSection : remainingSection;
#else
return pow(color,LinearEncodePowerApprox);
#endif
}
vec3 toLinearSpace(vec3 color)
{
#if USE_EXACT_SRGB_CONVERSIONS
return toLinearSpaceExact(color);
#else
return pow(color,vec3(LinearEncodePowerApprox));
#endif
}
vec4 toLinearSpace(vec4 color)
{
#if USE_EXACT_SRGB_CONVERSIONS
return vec4(toLinearSpaceExact(color.rgb),color.a);
#else
return vec4(pow(color.rgb,vec3(LinearEncodePowerApprox)),color.a);
#endif
}
float toGammaSpace(float color)
{
#if USE_EXACT_SRGB_CONVERSIONS
float nearZeroSection=12.92*color;float remainingSection=1.055*pow(color,0.41666)-0.055;return color<=0.0031308 ? nearZeroSection : remainingSection;
#else
return pow(color,GammaEncodePowerApprox);
#endif
}
vec3 toGammaSpace(vec3 color)
{
#if USE_EXACT_SRGB_CONVERSIONS
return toGammaSpaceExact(color);
#else
return pow(color,vec3(GammaEncodePowerApprox));
#endif
}
vec4 toGammaSpace(vec4 color)
{
#if USE_EXACT_SRGB_CONVERSIONS
return vec4(toGammaSpaceExact(color.rgb),color.a);
#else
return vec4(pow(color.rgb,vec3(GammaEncodePowerApprox)),color.a);
#endif
}
float square(float value)
{return value*value;}
vec3 square(vec3 value)
{return value*value;}
float pow5(float value) {float sq=value*value;return sq*sq*value;}
float getLuminance(vec3 color)
{return clamp(dot(color,LuminanceEncodeApprox),0.,1.);}
float getRand(vec2 seed) {return fract(sin(dot(seed.xy ,vec2(12.9898,78.233)))*43758.5453);}
float dither(vec2 seed,float varianceAmount) {float rand=getRand(seed);float normVariance=varianceAmount/255.0;float dither=mix(-normVariance,normVariance,rand);return dither;}
const float rgbdMaxRange=255.0;vec4 toRGBD(vec3 color) {float maxRGB=maxEps(max(color.r,max(color.g,color.b)));float D =max(rgbdMaxRange/maxRGB,1.);D =clamp(floor(D)/255.0,0.,1.);vec3 rgb=color.rgb*D;rgb=toGammaSpace(rgb);return vec4(clamp(rgb,0.,1.),D); }
vec3 fromRGBD(vec4 rgbd) {rgbd.rgb=toLinearSpace(rgbd.rgb);return rgbd.rgb/rgbd.a;}
vec3 parallaxCorrectNormal( vec3 vertexPos,vec3 origVec,vec3 cubeSize,vec3 cubePos ) {vec3 invOrigVec=vec3(1.0,1.0,1.0)/origVec;vec3 halfSize=cubeSize*0.5;vec3 intersecAtMaxPlane=(cubePos+halfSize-vertexPos)*invOrigVec;vec3 intersecAtMinPlane=(cubePos-halfSize-vertexPos)*invOrigVec;vec3 largestIntersec=max(intersecAtMaxPlane,intersecAtMinPlane);float distance=min(min(largestIntersec.x,largestIntersec.y),largestIntersec.z);vec3 intersectPositionWS=vertexPos+origVec*distance;return intersectPositionWS-cubePos;}
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$59b24f0424d3f607$var$name] = $59b24f0424d3f607$var$shader;
const $59b24f0424d3f607$export$89304a25b58dd7ab = {
    name: $59b24f0424d3f607$var$name,
    shader: $59b24f0424d3f607$var$shader
};

});

parcelRegister("7UkOz", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $5c1de8bf6014eee5$var$name = "lightFragmentDeclaration";
const $5c1de8bf6014eee5$var$shader = `#ifdef LIGHT{X}
uniform vec4 vLightData{X};uniform vec4 vLightDiffuse{X};
#ifdef SPECULARTERM
uniform vec4 vLightSpecular{X};
#else
vec4 vLightSpecular{X}=vec4(0.);
#endif
#ifdef SHADOW{X}
#ifdef SHADOWCSM{X}
uniform mat4 lightMatrix{X}[SHADOWCSMNUM_CASCADES{X}];uniform float viewFrustumZ{X}[SHADOWCSMNUM_CASCADES{X}];uniform float frustumLengths{X}[SHADOWCSMNUM_CASCADES{X}];uniform float cascadeBlendFactor{X};varying vec4 vPositionFromLight{X}[SHADOWCSMNUM_CASCADES{X}];varying float vDepthMetric{X}[SHADOWCSMNUM_CASCADES{X}];varying vec4 vPositionFromCamera{X};
#if defined(SHADOWPCSS{X})
uniform highp sampler2DArrayShadow shadowSampler{X};uniform highp sampler2DArray depthSampler{X};uniform vec2 lightSizeUVCorrection{X}[SHADOWCSMNUM_CASCADES{X}];uniform float depthCorrection{X}[SHADOWCSMNUM_CASCADES{X}];uniform float penumbraDarkness{X};
#elif defined(SHADOWPCF{X})
uniform highp sampler2DArrayShadow shadowSampler{X};
#else
uniform highp sampler2DArray shadowSampler{X};
#endif
#ifdef SHADOWCSMDEBUG{X}
const vec3 vCascadeColorsMultiplier{X}[8]=vec3[8]
(
vec3 ( 1.5,0.0,0.0 ),
vec3 ( 0.0,1.5,0.0 ),
vec3 ( 0.0,0.0,5.5 ),
vec3 ( 1.5,0.0,5.5 ),
vec3 ( 1.5,1.5,0.0 ),
vec3 ( 1.0,1.0,1.0 ),
vec3 ( 0.0,1.0,5.5 ),
vec3 ( 0.5,3.5,0.75 )
);vec3 shadowDebug{X};
#endif
#ifdef SHADOWCSMUSESHADOWMAXZ{X}
int index{X}=-1;
#else
int index{X}=SHADOWCSMNUM_CASCADES{X}-1;
#endif
float diff{X}=0.;
#elif defined(SHADOWCUBE{X})
uniform samplerCube shadowSampler{X};
#else
varying vec4 vPositionFromLight{X};varying float vDepthMetric{X};
#if defined(SHADOWPCSS{X})
uniform highp sampler2DShadow shadowSampler{X};uniform highp sampler2D depthSampler{X};
#elif defined(SHADOWPCF{X})
uniform highp sampler2DShadow shadowSampler{X};
#else
uniform sampler2D shadowSampler{X};
#endif
uniform mat4 lightMatrix{X};
#endif
uniform vec4 shadowsInfo{X};uniform vec2 depthValues{X};
#endif
#ifdef SPOTLIGHT{X}
uniform vec4 vLightDirection{X};uniform vec4 vLightFalloff{X};
#elif defined(POINTLIGHT{X})
uniform vec4 vLightFalloff{X};
#elif defined(HEMILIGHT{X})
uniform vec3 vLightGround{X};
#endif
#ifdef PROJECTEDLIGHTTEXTURE{X}
uniform mat4 textureProjectionMatrix{X};uniform sampler2D projectionLightSampler{X};
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$5c1de8bf6014eee5$var$name] = $5c1de8bf6014eee5$var$shader;
const $5c1de8bf6014eee5$export$9bfdb41ce338dd35 = {
    name: $5c1de8bf6014eee5$var$name,
    shader: $5c1de8bf6014eee5$var$shader
};

});

parcelRegister("gi9Sf", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $030f9496d337dbf4$var$name = "lightUboDeclaration";
const $030f9496d337dbf4$var$shader = `#ifdef LIGHT{X}
uniform Light{X}
{vec4 vLightData;vec4 vLightDiffuse;vec4 vLightSpecular;
#ifdef SPOTLIGHT{X}
vec4 vLightDirection;vec4 vLightFalloff;
#elif defined(POINTLIGHT{X})
vec4 vLightFalloff;
#elif defined(HEMILIGHT{X})
vec3 vLightGround;
#endif
vec4 shadowsInfo;vec2 depthValues;} light{X};
#ifdef PROJECTEDLIGHTTEXTURE{X}
uniform mat4 textureProjectionMatrix{X};uniform sampler2D projectionLightSampler{X};
#endif
#ifdef SHADOW{X}
#ifdef SHADOWCSM{X}
uniform mat4 lightMatrix{X}[SHADOWCSMNUM_CASCADES{X}];uniform float viewFrustumZ{X}[SHADOWCSMNUM_CASCADES{X}];uniform float frustumLengths{X}[SHADOWCSMNUM_CASCADES{X}];uniform float cascadeBlendFactor{X};varying vec4 vPositionFromLight{X}[SHADOWCSMNUM_CASCADES{X}];varying float vDepthMetric{X}[SHADOWCSMNUM_CASCADES{X}];varying vec4 vPositionFromCamera{X};
#if defined(SHADOWPCSS{X})
uniform highp sampler2DArrayShadow shadowSampler{X};uniform highp sampler2DArray depthSampler{X};uniform vec2 lightSizeUVCorrection{X}[SHADOWCSMNUM_CASCADES{X}];uniform float depthCorrection{X}[SHADOWCSMNUM_CASCADES{X}];uniform float penumbraDarkness{X};
#elif defined(SHADOWPCF{X})
uniform highp sampler2DArrayShadow shadowSampler{X};
#else
uniform highp sampler2DArray shadowSampler{X};
#endif
#ifdef SHADOWCSMDEBUG{X}
const vec3 vCascadeColorsMultiplier{X}[8]=vec3[8]
(
vec3 ( 1.5,0.0,0.0 ),
vec3 ( 0.0,1.5,0.0 ),
vec3 ( 0.0,0.0,5.5 ),
vec3 ( 1.5,0.0,5.5 ),
vec3 ( 1.5,1.5,0.0 ),
vec3 ( 1.0,1.0,1.0 ),
vec3 ( 0.0,1.0,5.5 ),
vec3 ( 0.5,3.5,0.75 )
);vec3 shadowDebug{X};
#endif
#ifdef SHADOWCSMUSESHADOWMAXZ{X}
int index{X}=-1;
#else
int index{X}=SHADOWCSMNUM_CASCADES{X}-1;
#endif
float diff{X}=0.;
#elif defined(SHADOWCUBE{X})
uniform samplerCube shadowSampler{X}; 
#else
varying vec4 vPositionFromLight{X};varying float vDepthMetric{X};
#if defined(SHADOWPCSS{X})
uniform highp sampler2DShadow shadowSampler{X};uniform highp sampler2D depthSampler{X};
#elif defined(SHADOWPCF{X})
uniform highp sampler2DShadow shadowSampler{X};
#else
uniform sampler2D shadowSampler{X};
#endif
uniform mat4 lightMatrix{X};
#endif
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$030f9496d337dbf4$var$name] = $030f9496d337dbf4$var$shader;
const $030f9496d337dbf4$export$a5838adc27ee95d9 = {
    name: $030f9496d337dbf4$var$name,
    shader: $030f9496d337dbf4$var$shader
};

});

parcelRegister("eFnxQ", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $aad728922284e6d6$var$name = "lightsFragmentFunctions";
const $aad728922284e6d6$var$shader = `struct lightingInfo
{vec3 diffuse;
#ifdef SPECULARTERM
vec3 specular;
#endif
#ifdef NDOTL
float ndl;
#endif
};lightingInfo computeLighting(vec3 viewDirectionW,vec3 vNormal,vec4 lightData,vec3 diffuseColor,vec3 specularColor,float range,float glossiness) {lightingInfo result;vec3 lightVectorW;float attenuation=1.0;if (lightData.w==0.)
{vec3 direction=lightData.xyz-vPositionW;attenuation=max(0.,1.0-length(direction)/range);lightVectorW=normalize(direction);}
else
{lightVectorW=normalize(-lightData.xyz);}
float ndl=max(0.,dot(vNormal,lightVectorW));
#ifdef NDOTL
result.ndl=ndl;
#endif
result.diffuse=ndl*diffuseColor*attenuation;
#ifdef SPECULARTERM
vec3 angleW=normalize(viewDirectionW+lightVectorW);float specComp=max(0.,dot(vNormal,angleW));specComp=pow(specComp,max(1.,glossiness));result.specular=specComp*specularColor*attenuation;
#endif
return result;}
lightingInfo computeSpotLighting(vec3 viewDirectionW,vec3 vNormal,vec4 lightData,vec4 lightDirection,vec3 diffuseColor,vec3 specularColor,float range,float glossiness) {lightingInfo result;vec3 direction=lightData.xyz-vPositionW;vec3 lightVectorW=normalize(direction);float attenuation=max(0.,1.0-length(direction)/range);float cosAngle=max(0.,dot(lightDirection.xyz,-lightVectorW));if (cosAngle>=lightDirection.w)
{cosAngle=max(0.,pow(cosAngle,lightData.w));attenuation*=cosAngle;float ndl=max(0.,dot(vNormal,lightVectorW));
#ifdef NDOTL
result.ndl=ndl;
#endif
result.diffuse=ndl*diffuseColor*attenuation;
#ifdef SPECULARTERM
vec3 angleW=normalize(viewDirectionW+lightVectorW);float specComp=max(0.,dot(vNormal,angleW));specComp=pow(specComp,max(1.,glossiness));result.specular=specComp*specularColor*attenuation;
#endif
return result;}
result.diffuse=vec3(0.);
#ifdef SPECULARTERM
result.specular=vec3(0.);
#endif
#ifdef NDOTL
result.ndl=0.;
#endif
return result;}
lightingInfo computeHemisphericLighting(vec3 viewDirectionW,vec3 vNormal,vec4 lightData,vec3 diffuseColor,vec3 specularColor,vec3 groundColor,float glossiness) {lightingInfo result;float ndl=dot(vNormal,lightData.xyz)*0.5+0.5;
#ifdef NDOTL
result.ndl=ndl;
#endif
result.diffuse=mix(groundColor,diffuseColor,ndl);
#ifdef SPECULARTERM
vec3 angleW=normalize(viewDirectionW+lightData.xyz);float specComp=max(0.,dot(vNormal,angleW));specComp=pow(specComp,max(1.,glossiness));result.specular=specComp*specularColor;
#endif
return result;}
#define inline
vec3 computeProjectionTextureDiffuseLighting(sampler2D projectionLightSampler,mat4 textureProjectionMatrix){vec4 strq=textureProjectionMatrix*vec4(vPositionW,1.0);strq/=strq.w;vec3 textureColor=texture2D(projectionLightSampler,strq.xy).rgb;return textureColor;}`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$aad728922284e6d6$var$name] = $aad728922284e6d6$var$shader;
const $aad728922284e6d6$export$da90bc947c387180 = {
    name: $aad728922284e6d6$var$name,
    shader: $aad728922284e6d6$var$shader
};

});

parcelRegister("lcI5C", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $f6fceb41179b2191$var$name = "shadowsFragmentFunctions";
const $f6fceb41179b2191$var$shader = `#ifdef SHADOWS
#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
#define TEXTUREFUNC(s,c,l) texture2DLodEXT(s,c,l)
#else
#define TEXTUREFUNC(s,c,b) texture2D(s,c,b)
#endif
#ifndef SHADOWFLOAT
float unpack(vec4 color)
{const vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(color,bit_shift);}
#endif
float computeFallOff(float value,vec2 clipSpace,float frustumEdgeFalloff)
{float mask=smoothstep(1.0-frustumEdgeFalloff,1.00000012,clamp(dot(clipSpace,clipSpace),0.,1.));return mix(value,1.0,mask);}
#define inline
float computeShadowCube(vec3 worldPos,vec3 lightPosition,samplerCube shadowSampler,float darkness,vec2 depthValues)
{vec3 directionToLight=worldPos-lightPosition;float depth=length(directionToLight);depth=(depth+depthValues.x)/(depthValues.y);depth=clamp(depth,0.,1.0);directionToLight=normalize(directionToLight);directionToLight.y=-directionToLight.y;
#ifndef SHADOWFLOAT
float shadow=unpack(textureCube(shadowSampler,directionToLight));
#else
float shadow=textureCube(shadowSampler,directionToLight).x;
#endif
return depth>shadow ? darkness : 1.0;}
#define inline
float computeShadowWithPoissonSamplingCube(vec3 worldPos,vec3 lightPosition,samplerCube shadowSampler,float mapSize,float darkness,vec2 depthValues)
{vec3 directionToLight=worldPos-lightPosition;float depth=length(directionToLight);depth=(depth+depthValues.x)/(depthValues.y);depth=clamp(depth,0.,1.0);directionToLight=normalize(directionToLight);directionToLight.y=-directionToLight.y;float visibility=1.;vec3 poissonDisk[4];poissonDisk[0]=vec3(-1.0,1.0,-1.0);poissonDisk[1]=vec3(1.0,-1.0,-1.0);poissonDisk[2]=vec3(-1.0,-1.0,-1.0);poissonDisk[3]=vec3(1.0,-1.0,1.0);
#ifndef SHADOWFLOAT
if (unpack(textureCube(shadowSampler,directionToLight+poissonDisk[0]*mapSize))<depth) visibility-=0.25;if (unpack(textureCube(shadowSampler,directionToLight+poissonDisk[1]*mapSize))<depth) visibility-=0.25;if (unpack(textureCube(shadowSampler,directionToLight+poissonDisk[2]*mapSize))<depth) visibility-=0.25;if (unpack(textureCube(shadowSampler,directionToLight+poissonDisk[3]*mapSize))<depth) visibility-=0.25;
#else
if (textureCube(shadowSampler,directionToLight+poissonDisk[0]*mapSize).x<depth) visibility-=0.25;if (textureCube(shadowSampler,directionToLight+poissonDisk[1]*mapSize).x<depth) visibility-=0.25;if (textureCube(shadowSampler,directionToLight+poissonDisk[2]*mapSize).x<depth) visibility-=0.25;if (textureCube(shadowSampler,directionToLight+poissonDisk[3]*mapSize).x<depth) visibility-=0.25;
#endif
return min(1.0,visibility+darkness);}
#define inline
float computeShadowWithESMCube(vec3 worldPos,vec3 lightPosition,samplerCube shadowSampler,float darkness,float depthScale,vec2 depthValues)
{vec3 directionToLight=worldPos-lightPosition;float depth=length(directionToLight);depth=(depth+depthValues.x)/(depthValues.y);float shadowPixelDepth=clamp(depth,0.,1.0);directionToLight=normalize(directionToLight);directionToLight.y=-directionToLight.y;
#ifndef SHADOWFLOAT
float shadowMapSample=unpack(textureCube(shadowSampler,directionToLight));
#else
float shadowMapSample=textureCube(shadowSampler,directionToLight).x;
#endif
float esm=1.0-clamp(exp(min(87.,depthScale*shadowPixelDepth))*shadowMapSample,0.,1.-darkness);return esm;}
#define inline
float computeShadowWithCloseESMCube(vec3 worldPos,vec3 lightPosition,samplerCube shadowSampler,float darkness,float depthScale,vec2 depthValues)
{vec3 directionToLight=worldPos-lightPosition;float depth=length(directionToLight);depth=(depth+depthValues.x)/(depthValues.y);float shadowPixelDepth=clamp(depth,0.,1.0);directionToLight=normalize(directionToLight);directionToLight.y=-directionToLight.y;
#ifndef SHADOWFLOAT
float shadowMapSample=unpack(textureCube(shadowSampler,directionToLight));
#else
float shadowMapSample=textureCube(shadowSampler,directionToLight).x;
#endif
float esm=clamp(exp(min(87.,-depthScale*(shadowPixelDepth-shadowMapSample))),darkness,1.);return esm;}
#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
#define inline
float computeShadowCSM(float layer,vec4 vPositionFromLight,float depthMetric,highp sampler2DArray shadowSampler,float darkness,float frustumEdgeFalloff)
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec2 uv=0.5*clipSpace.xy+vec2(0.5);vec3 uvLayer=vec3(uv.x,uv.y,layer);float shadowPixelDepth=clamp(depthMetric,0.,1.0);
#ifndef SHADOWFLOAT
float shadow=unpack(texture2D(shadowSampler,uvLayer));
#else
float shadow=texture2D(shadowSampler,uvLayer).x;
#endif
return shadowPixelDepth>shadow ? computeFallOff(darkness,clipSpace.xy,frustumEdgeFalloff) : 1.;}
#endif
#define inline
float computeShadow(vec4 vPositionFromLight,float depthMetric,sampler2D shadowSampler,float darkness,float frustumEdgeFalloff)
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec2 uv=0.5*clipSpace.xy+vec2(0.5);if (uv.x<0. || uv.x>1.0 || uv.y<0. || uv.y>1.0)
{return 1.0;}
else
{float shadowPixelDepth=clamp(depthMetric,0.,1.0);
#ifndef SHADOWFLOAT
float shadow=unpack(TEXTUREFUNC(shadowSampler,uv,0.));
#else
float shadow=TEXTUREFUNC(shadowSampler,uv,0.).x;
#endif
return shadowPixelDepth>shadow ? computeFallOff(darkness,clipSpace.xy,frustumEdgeFalloff) : 1.;}}
#define inline
float computeShadowWithPoissonSampling(vec4 vPositionFromLight,float depthMetric,sampler2D shadowSampler,float mapSize,float darkness,float frustumEdgeFalloff)
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec2 uv=0.5*clipSpace.xy+vec2(0.5);if (uv.x<0. || uv.x>1.0 || uv.y<0. || uv.y>1.0)
{return 1.0;}
else
{float shadowPixelDepth=clamp(depthMetric,0.,1.0);float visibility=1.;vec2 poissonDisk[4];poissonDisk[0]=vec2(-0.94201624,-0.39906216);poissonDisk[1]=vec2(0.94558609,-0.76890725);poissonDisk[2]=vec2(-0.094184101,-0.92938870);poissonDisk[3]=vec2(0.34495938,0.29387760);
#ifndef SHADOWFLOAT
if (unpack(TEXTUREFUNC(shadowSampler,uv+poissonDisk[0]*mapSize,0.))<shadowPixelDepth) visibility-=0.25;if (unpack(TEXTUREFUNC(shadowSampler,uv+poissonDisk[1]*mapSize,0.))<shadowPixelDepth) visibility-=0.25;if (unpack(TEXTUREFUNC(shadowSampler,uv+poissonDisk[2]*mapSize,0.))<shadowPixelDepth) visibility-=0.25;if (unpack(TEXTUREFUNC(shadowSampler,uv+poissonDisk[3]*mapSize,0.))<shadowPixelDepth) visibility-=0.25;
#else
if (TEXTUREFUNC(shadowSampler,uv+poissonDisk[0]*mapSize,0.).x<shadowPixelDepth) visibility-=0.25;if (TEXTUREFUNC(shadowSampler,uv+poissonDisk[1]*mapSize,0.).x<shadowPixelDepth) visibility-=0.25;if (TEXTUREFUNC(shadowSampler,uv+poissonDisk[2]*mapSize,0.).x<shadowPixelDepth) visibility-=0.25;if (TEXTUREFUNC(shadowSampler,uv+poissonDisk[3]*mapSize,0.).x<shadowPixelDepth) visibility-=0.25;
#endif
return computeFallOff(min(1.0,visibility+darkness),clipSpace.xy,frustumEdgeFalloff);}}
#define inline
float computeShadowWithESM(vec4 vPositionFromLight,float depthMetric,sampler2D shadowSampler,float darkness,float depthScale,float frustumEdgeFalloff)
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec2 uv=0.5*clipSpace.xy+vec2(0.5);if (uv.x<0. || uv.x>1.0 || uv.y<0. || uv.y>1.0)
{return 1.0;}
else
{float shadowPixelDepth=clamp(depthMetric,0.,1.0);
#ifndef SHADOWFLOAT
float shadowMapSample=unpack(TEXTUREFUNC(shadowSampler,uv,0.));
#else
float shadowMapSample=TEXTUREFUNC(shadowSampler,uv,0.).x;
#endif
float esm=1.0-clamp(exp(min(87.,depthScale*shadowPixelDepth))*shadowMapSample,0.,1.-darkness);return computeFallOff(esm,clipSpace.xy,frustumEdgeFalloff);}}
#define inline
float computeShadowWithCloseESM(vec4 vPositionFromLight,float depthMetric,sampler2D shadowSampler,float darkness,float depthScale,float frustumEdgeFalloff)
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec2 uv=0.5*clipSpace.xy+vec2(0.5);if (uv.x<0. || uv.x>1.0 || uv.y<0. || uv.y>1.0)
{return 1.0;}
else
{float shadowPixelDepth=clamp(depthMetric,0.,1.0); 
#ifndef SHADOWFLOAT
float shadowMapSample=unpack(TEXTUREFUNC(shadowSampler,uv,0.));
#else
float shadowMapSample=TEXTUREFUNC(shadowSampler,uv,0.).x;
#endif
float esm=clamp(exp(min(87.,-depthScale*(shadowPixelDepth-shadowMapSample))),darkness,1.);return computeFallOff(esm,clipSpace.xy,frustumEdgeFalloff);}}
#ifdef IS_NDC_HALF_ZRANGE
#define ZINCLIP clipSpace.z
#else
#define ZINCLIP uvDepth.z
#endif
#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
#define GREATEST_LESS_THAN_ONE 0.99999994
/* disable_uniformity_analysis */
#define inline
float computeShadowWithCSMPCF1(float layer,vec4 vPositionFromLight,float depthMetric,highp sampler2DArrayShadow shadowSampler,float darkness,float frustumEdgeFalloff)
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec3 uvDepth=vec3(0.5*clipSpace.xyz+vec3(0.5));uvDepth.z=clamp(ZINCLIP,0.,GREATEST_LESS_THAN_ONE);vec4 uvDepthLayer=vec4(uvDepth.x,uvDepth.y,layer,uvDepth.z);float shadow=texture2D(shadowSampler,uvDepthLayer);shadow=mix(darkness,1.,shadow);return computeFallOff(shadow,clipSpace.xy,frustumEdgeFalloff);}
#define inline
float computeShadowWithCSMPCF3(float layer,vec4 vPositionFromLight,float depthMetric,highp sampler2DArrayShadow shadowSampler,vec2 shadowMapSizeAndInverse,float darkness,float frustumEdgeFalloff)
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec3 uvDepth=vec3(0.5*clipSpace.xyz+vec3(0.5));uvDepth.z=clamp(ZINCLIP,0.,GREATEST_LESS_THAN_ONE);vec2 uv=uvDepth.xy*shadowMapSizeAndInverse.x; 
uv+=0.5; 
vec2 st=fract(uv); 
vec2 base_uv=floor(uv)-0.5; 
base_uv*=shadowMapSizeAndInverse.y; 
vec2 uvw0=3.-2.*st;vec2 uvw1=1.+2.*st;vec2 u=vec2((2.-st.x)/uvw0.x-1.,st.x/uvw1.x+1.)*shadowMapSizeAndInverse.y;vec2 v=vec2((2.-st.y)/uvw0.y-1.,st.y/uvw1.y+1.)*shadowMapSizeAndInverse.y;float shadow=0.;shadow+=uvw0.x*uvw0.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[0],v[0]),layer,uvDepth.z));shadow+=uvw1.x*uvw0.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[1],v[0]),layer,uvDepth.z));shadow+=uvw0.x*uvw1.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[0],v[1]),layer,uvDepth.z));shadow+=uvw1.x*uvw1.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[1],v[1]),layer,uvDepth.z));shadow=shadow/16.;shadow=mix(darkness,1.,shadow);return computeFallOff(shadow,clipSpace.xy,frustumEdgeFalloff);}
#define inline
float computeShadowWithCSMPCF5(float layer,vec4 vPositionFromLight,float depthMetric,highp sampler2DArrayShadow shadowSampler,vec2 shadowMapSizeAndInverse,float darkness,float frustumEdgeFalloff)
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec3 uvDepth=vec3(0.5*clipSpace.xyz+vec3(0.5));uvDepth.z=clamp(ZINCLIP,0.,GREATEST_LESS_THAN_ONE);vec2 uv=uvDepth.xy*shadowMapSizeAndInverse.x; 
uv+=0.5; 
vec2 st=fract(uv); 
vec2 base_uv=floor(uv)-0.5; 
base_uv*=shadowMapSizeAndInverse.y; 
vec2 uvw0=4.-3.*st;vec2 uvw1=vec2(7.);vec2 uvw2=1.+3.*st;vec3 u=vec3((3.-2.*st.x)/uvw0.x-2.,(3.+st.x)/uvw1.x,st.x/uvw2.x+2.)*shadowMapSizeAndInverse.y;vec3 v=vec3((3.-2.*st.y)/uvw0.y-2.,(3.+st.y)/uvw1.y,st.y/uvw2.y+2.)*shadowMapSizeAndInverse.y;float shadow=0.;shadow+=uvw0.x*uvw0.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[0],v[0]),layer,uvDepth.z));shadow+=uvw1.x*uvw0.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[1],v[0]),layer,uvDepth.z));shadow+=uvw2.x*uvw0.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[2],v[0]),layer,uvDepth.z));shadow+=uvw0.x*uvw1.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[0],v[1]),layer,uvDepth.z));shadow+=uvw1.x*uvw1.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[1],v[1]),layer,uvDepth.z));shadow+=uvw2.x*uvw1.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[2],v[1]),layer,uvDepth.z));shadow+=uvw0.x*uvw2.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[0],v[2]),layer,uvDepth.z));shadow+=uvw1.x*uvw2.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[1],v[2]),layer,uvDepth.z));shadow+=uvw2.x*uvw2.y*texture2D(shadowSampler,vec4(base_uv.xy+vec2(u[2],v[2]),layer,uvDepth.z));shadow=shadow/144.;shadow=mix(darkness,1.,shadow);return computeFallOff(shadow,clipSpace.xy,frustumEdgeFalloff);}
#define inline
float computeShadowWithPCF1(vec4 vPositionFromLight,float depthMetric,highp sampler2DShadow shadowSampler,float darkness,float frustumEdgeFalloff)
{if (depthMetric>1.0 || depthMetric<0.0) {return 1.0;}
else
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec3 uvDepth=vec3(0.5*clipSpace.xyz+vec3(0.5));uvDepth.z=ZINCLIP;float shadow=TEXTUREFUNC(shadowSampler,uvDepth,0.);shadow=mix(darkness,1.,shadow);return computeFallOff(shadow,clipSpace.xy,frustumEdgeFalloff);}}
#define inline
float computeShadowWithPCF3(vec4 vPositionFromLight,float depthMetric,highp sampler2DShadow shadowSampler,vec2 shadowMapSizeAndInverse,float darkness,float frustumEdgeFalloff)
{if (depthMetric>1.0 || depthMetric<0.0) {return 1.0;}
else
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec3 uvDepth=vec3(0.5*clipSpace.xyz+vec3(0.5));uvDepth.z=ZINCLIP;vec2 uv=uvDepth.xy*shadowMapSizeAndInverse.x; 
uv+=0.5; 
vec2 st=fract(uv); 
vec2 base_uv=floor(uv)-0.5; 
base_uv*=shadowMapSizeAndInverse.y; 
vec2 uvw0=3.-2.*st;vec2 uvw1=1.+2.*st;vec2 u=vec2((2.-st.x)/uvw0.x-1.,st.x/uvw1.x+1.)*shadowMapSizeAndInverse.y;vec2 v=vec2((2.-st.y)/uvw0.y-1.,st.y/uvw1.y+1.)*shadowMapSizeAndInverse.y;float shadow=0.;shadow+=uvw0.x*uvw0.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[0],v[0]),uvDepth.z),0.);shadow+=uvw1.x*uvw0.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[1],v[0]),uvDepth.z),0.);shadow+=uvw0.x*uvw1.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[0],v[1]),uvDepth.z),0.);shadow+=uvw1.x*uvw1.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[1],v[1]),uvDepth.z),0.);shadow=shadow/16.;shadow=mix(darkness,1.,shadow);return computeFallOff(shadow,clipSpace.xy,frustumEdgeFalloff);}}
#define inline
float computeShadowWithPCF5(vec4 vPositionFromLight,float depthMetric,highp sampler2DShadow shadowSampler,vec2 shadowMapSizeAndInverse,float darkness,float frustumEdgeFalloff)
{if (depthMetric>1.0 || depthMetric<0.0) {return 1.0;}
else
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec3 uvDepth=vec3(0.5*clipSpace.xyz+vec3(0.5));uvDepth.z=ZINCLIP;vec2 uv=uvDepth.xy*shadowMapSizeAndInverse.x; 
uv+=0.5; 
vec2 st=fract(uv); 
vec2 base_uv=floor(uv)-0.5; 
base_uv*=shadowMapSizeAndInverse.y; 
vec2 uvw0=4.-3.*st;vec2 uvw1=vec2(7.);vec2 uvw2=1.+3.*st;vec3 u=vec3((3.-2.*st.x)/uvw0.x-2.,(3.+st.x)/uvw1.x,st.x/uvw2.x+2.)*shadowMapSizeAndInverse.y;vec3 v=vec3((3.-2.*st.y)/uvw0.y-2.,(3.+st.y)/uvw1.y,st.y/uvw2.y+2.)*shadowMapSizeAndInverse.y;float shadow=0.;shadow+=uvw0.x*uvw0.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[0],v[0]),uvDepth.z),0.);shadow+=uvw1.x*uvw0.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[1],v[0]),uvDepth.z),0.);shadow+=uvw2.x*uvw0.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[2],v[0]),uvDepth.z),0.);shadow+=uvw0.x*uvw1.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[0],v[1]),uvDepth.z),0.);shadow+=uvw1.x*uvw1.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[1],v[1]),uvDepth.z),0.);shadow+=uvw2.x*uvw1.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[2],v[1]),uvDepth.z),0.);shadow+=uvw0.x*uvw2.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[0],v[2]),uvDepth.z),0.);shadow+=uvw1.x*uvw2.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[1],v[2]),uvDepth.z),0.);shadow+=uvw2.x*uvw2.y*TEXTUREFUNC(shadowSampler,vec3(base_uv.xy+vec2(u[2],v[2]),uvDepth.z),0.);shadow=shadow/144.;shadow=mix(darkness,1.,shadow);return computeFallOff(shadow,clipSpace.xy,frustumEdgeFalloff);}}
const vec3 PoissonSamplers32[64]=vec3[64](
vec3(0.06407013,0.05409927,0.),
vec3(0.7366577,0.5789394,0.),
vec3(-0.6270542,-0.5320278,0.),
vec3(-0.4096107,0.8411095,0.),
vec3(0.6849564,-0.4990818,0.),
vec3(-0.874181,-0.04579735,0.),
vec3(0.9989998,0.0009880066,0.),
vec3(-0.004920578,-0.9151649,0.),
vec3(0.1805763,0.9747483,0.),
vec3(-0.2138451,0.2635818,0.),
vec3(0.109845,0.3884785,0.),
vec3(0.06876755,-0.3581074,0.),
vec3(0.374073,-0.7661266,0.),
vec3(0.3079132,-0.1216763,0.),
vec3(-0.3794335,-0.8271583,0.),
vec3(-0.203878,-0.07715034,0.),
vec3(0.5912697,0.1469799,0.),
vec3(-0.88069,0.3031784,0.),
vec3(0.5040108,0.8283722,0.),
vec3(-0.5844124,0.5494877,0.),
vec3(0.6017799,-0.1726654,0.),
vec3(-0.5554981,0.1559997,0.),
vec3(-0.3016369,-0.3900928,0.),
vec3(-0.5550632,-0.1723762,0.),
vec3(0.925029,0.2995041,0.),
vec3(-0.2473137,0.5538505,0.),
vec3(0.9183037,-0.2862392,0.),
vec3(0.2469421,0.6718712,0.),
vec3(0.3916397,-0.4328209,0.),
vec3(-0.03576927,-0.6220032,0.),
vec3(-0.04661255,0.7995201,0.),
vec3(0.4402924,0.3640312,0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.),
vec3(0.)
);const vec3 PoissonSamplers64[64]=vec3[64](
vec3(-0.613392,0.617481,0.),
vec3(0.170019,-0.040254,0.),
vec3(-0.299417,0.791925,0.),
vec3(0.645680,0.493210,0.),
vec3(-0.651784,0.717887,0.),
vec3(0.421003,0.027070,0.),
vec3(-0.817194,-0.271096,0.),
vec3(-0.705374,-0.668203,0.),
vec3(0.977050,-0.108615,0.),
vec3(0.063326,0.142369,0.),
vec3(0.203528,0.214331,0.),
vec3(-0.667531,0.326090,0.),
vec3(-0.098422,-0.295755,0.),
vec3(-0.885922,0.215369,0.),
vec3(0.566637,0.605213,0.),
vec3(0.039766,-0.396100,0.),
vec3(0.751946,0.453352,0.),
vec3(0.078707,-0.715323,0.),
vec3(-0.075838,-0.529344,0.),
vec3(0.724479,-0.580798,0.),
vec3(0.222999,-0.215125,0.),
vec3(-0.467574,-0.405438,0.),
vec3(-0.248268,-0.814753,0.),
vec3(0.354411,-0.887570,0.),
vec3(0.175817,0.382366,0.),
vec3(0.487472,-0.063082,0.),
vec3(-0.084078,0.898312,0.),
vec3(0.488876,-0.783441,0.),
vec3(0.470016,0.217933,0.),
vec3(-0.696890,-0.549791,0.),
vec3(-0.149693,0.605762,0.),
vec3(0.034211,0.979980,0.),
vec3(0.503098,-0.308878,0.),
vec3(-0.016205,-0.872921,0.),
vec3(0.385784,-0.393902,0.),
vec3(-0.146886,-0.859249,0.),
vec3(0.643361,0.164098,0.),
vec3(0.634388,-0.049471,0.),
vec3(-0.688894,0.007843,0.),
vec3(0.464034,-0.188818,0.),
vec3(-0.440840,0.137486,0.),
vec3(0.364483,0.511704,0.),
vec3(0.034028,0.325968,0.),
vec3(0.099094,-0.308023,0.),
vec3(0.693960,-0.366253,0.),
vec3(0.678884,-0.204688,0.),
vec3(0.001801,0.780328,0.),
vec3(0.145177,-0.898984,0.),
vec3(0.062655,-0.611866,0.),
vec3(0.315226,-0.604297,0.),
vec3(-0.780145,0.486251,0.),
vec3(-0.371868,0.882138,0.),
vec3(0.200476,0.494430,0.),
vec3(-0.494552,-0.711051,0.),
vec3(0.612476,0.705252,0.),
vec3(-0.578845,-0.768792,0.),
vec3(-0.772454,-0.090976,0.),
vec3(0.504440,0.372295,0.),
vec3(0.155736,0.065157,0.),
vec3(0.391522,0.849605,0.),
vec3(-0.620106,-0.328104,0.),
vec3(0.789239,-0.419965,0.),
vec3(-0.545396,0.538133,0.),
vec3(-0.178564,-0.596057,0.)
);
#define inline
float computeShadowWithCSMPCSS(float layer,vec4 vPositionFromLight,float depthMetric,highp sampler2DArray depthSampler,highp sampler2DArrayShadow shadowSampler,float shadowMapSizeInverse,float lightSizeUV,float darkness,float frustumEdgeFalloff,int searchTapCount,int pcfTapCount,vec3[64] poissonSamplers,vec2 lightSizeUVCorrection,float depthCorrection,float penumbraDarkness)
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec3 uvDepth=vec3(0.5*clipSpace.xyz+vec3(0.5));uvDepth.z=clamp(ZINCLIP,0.,GREATEST_LESS_THAN_ONE);vec4 uvDepthLayer=vec4(uvDepth.x,uvDepth.y,layer,uvDepth.z);float blockerDepth=0.0;float sumBlockerDepth=0.0;float numBlocker=0.0;for (int i=0; i<searchTapCount; i ++) {blockerDepth=texture2D(depthSampler,vec3(uvDepth.xy+(lightSizeUV*lightSizeUVCorrection*shadowMapSizeInverse*PoissonSamplers32[i].xy),layer)).r;if (blockerDepth<depthMetric) {sumBlockerDepth+=blockerDepth;numBlocker++;}}
float avgBlockerDepth=sumBlockerDepth/numBlocker;float AAOffset=shadowMapSizeInverse*10.;float penumbraRatio=((depthMetric-avgBlockerDepth)*depthCorrection+AAOffset);vec4 filterRadius=vec4(penumbraRatio*lightSizeUV*lightSizeUVCorrection*shadowMapSizeInverse,0.,0.);float random=getRand(vPositionFromLight.xy);float rotationAngle=random*3.1415926;vec2 rotationVector=vec2(cos(rotationAngle),sin(rotationAngle));float shadow=0.;for (int i=0; i<pcfTapCount; i++) {vec4 offset=vec4(poissonSamplers[i],0.);offset=vec4(offset.x*rotationVector.x-offset.y*rotationVector.y,offset.y*rotationVector.x+offset.x*rotationVector.y,0.,0.);shadow+=texture2D(shadowSampler,uvDepthLayer+offset*filterRadius);}
shadow/=float(pcfTapCount);shadow=mix(shadow,1.,min((depthMetric-avgBlockerDepth)*depthCorrection*penumbraDarkness,1.));shadow=mix(darkness,1.,shadow);if (numBlocker<1.0) {return 1.0;}
else
{return computeFallOff(shadow,clipSpace.xy,frustumEdgeFalloff);}}
#define inline
float computeShadowWithPCSS(vec4 vPositionFromLight,float depthMetric,sampler2D depthSampler,highp sampler2DShadow shadowSampler,float shadowMapSizeInverse,float lightSizeUV,float darkness,float frustumEdgeFalloff,int searchTapCount,int pcfTapCount,vec3[64] poissonSamplers)
{if (depthMetric>1.0 || depthMetric<0.0) {return 1.0;}
else
{vec3 clipSpace=vPositionFromLight.xyz/vPositionFromLight.w;vec3 uvDepth=vec3(0.5*clipSpace.xyz+vec3(0.5));uvDepth.z=ZINCLIP;float blockerDepth=0.0;float sumBlockerDepth=0.0;float numBlocker=0.0;for (int i=0; i<searchTapCount; i ++) {blockerDepth=TEXTUREFUNC(depthSampler,uvDepth.xy+(lightSizeUV*shadowMapSizeInverse*PoissonSamplers32[i].xy),0.).r;if (blockerDepth<depthMetric) {sumBlockerDepth+=blockerDepth;numBlocker++;}}
if (numBlocker<1.0) {return 1.0;}
else
{float avgBlockerDepth=sumBlockerDepth/numBlocker;float AAOffset=shadowMapSizeInverse*10.;float penumbraRatio=((depthMetric-avgBlockerDepth)+AAOffset);float filterRadius=penumbraRatio*lightSizeUV*shadowMapSizeInverse;float random=getRand(vPositionFromLight.xy);float rotationAngle=random*3.1415926;vec2 rotationVector=vec2(cos(rotationAngle),sin(rotationAngle));float shadow=0.;for (int i=0; i<pcfTapCount; i++) {vec3 offset=poissonSamplers[i];offset=vec3(offset.x*rotationVector.x-offset.y*rotationVector.y,offset.y*rotationVector.x+offset.x*rotationVector.y,0.);shadow+=TEXTUREFUNC(shadowSampler,uvDepth+offset*filterRadius,0.);}
shadow/=float(pcfTapCount);shadow=mix(shadow,1.,depthMetric-avgBlockerDepth);shadow=mix(darkness,1.,shadow);return computeFallOff(shadow,clipSpace.xy,frustumEdgeFalloff);}}}
#define inline
float computeShadowWithPCSS16(vec4 vPositionFromLight,float depthMetric,sampler2D depthSampler,highp sampler2DShadow shadowSampler,float shadowMapSizeInverse,float lightSizeUV,float darkness,float frustumEdgeFalloff)
{return computeShadowWithPCSS(vPositionFromLight,depthMetric,depthSampler,shadowSampler,shadowMapSizeInverse,lightSizeUV,darkness,frustumEdgeFalloff,16,16,PoissonSamplers32);}
#define inline
float computeShadowWithPCSS32(vec4 vPositionFromLight,float depthMetric,sampler2D depthSampler,highp sampler2DShadow shadowSampler,float shadowMapSizeInverse,float lightSizeUV,float darkness,float frustumEdgeFalloff)
{return computeShadowWithPCSS(vPositionFromLight,depthMetric,depthSampler,shadowSampler,shadowMapSizeInverse,lightSizeUV,darkness,frustumEdgeFalloff,16,32,PoissonSamplers32);}
#define inline
float computeShadowWithPCSS64(vec4 vPositionFromLight,float depthMetric,sampler2D depthSampler,highp sampler2DShadow shadowSampler,float shadowMapSizeInverse,float lightSizeUV,float darkness,float frustumEdgeFalloff)
{return computeShadowWithPCSS(vPositionFromLight,depthMetric,depthSampler,shadowSampler,shadowMapSizeInverse,lightSizeUV,darkness,frustumEdgeFalloff,32,64,PoissonSamplers64);}
#define inline
float computeShadowWithCSMPCSS16(float layer,vec4 vPositionFromLight,float depthMetric,highp sampler2DArray depthSampler,highp sampler2DArrayShadow shadowSampler,float shadowMapSizeInverse,float lightSizeUV,float darkness,float frustumEdgeFalloff,vec2 lightSizeUVCorrection,float depthCorrection,float penumbraDarkness)
{return computeShadowWithCSMPCSS(layer,vPositionFromLight,depthMetric,depthSampler,shadowSampler,shadowMapSizeInverse,lightSizeUV,darkness,frustumEdgeFalloff,16,16,PoissonSamplers32,lightSizeUVCorrection,depthCorrection,penumbraDarkness);}
#define inline
float computeShadowWithCSMPCSS32(float layer,vec4 vPositionFromLight,float depthMetric,highp sampler2DArray depthSampler,highp sampler2DArrayShadow shadowSampler,float shadowMapSizeInverse,float lightSizeUV,float darkness,float frustumEdgeFalloff,vec2 lightSizeUVCorrection,float depthCorrection,float penumbraDarkness)
{return computeShadowWithCSMPCSS(layer,vPositionFromLight,depthMetric,depthSampler,shadowSampler,shadowMapSizeInverse,lightSizeUV,darkness,frustumEdgeFalloff,16,32,PoissonSamplers32,lightSizeUVCorrection,depthCorrection,penumbraDarkness);}
#define inline
float computeShadowWithCSMPCSS64(float layer,vec4 vPositionFromLight,float depthMetric,highp sampler2DArray depthSampler,highp sampler2DArrayShadow shadowSampler,float shadowMapSizeInverse,float lightSizeUV,float darkness,float frustumEdgeFalloff,vec2 lightSizeUVCorrection,float depthCorrection,float penumbraDarkness)
{return computeShadowWithCSMPCSS(layer,vPositionFromLight,depthMetric,depthSampler,shadowSampler,shadowMapSizeInverse,lightSizeUV,darkness,frustumEdgeFalloff,32,64,PoissonSamplers64,lightSizeUVCorrection,depthCorrection,penumbraDarkness);}
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$f6fceb41179b2191$var$name] = $f6fceb41179b2191$var$shader;
const $f6fceb41179b2191$export$65c03943b6a4e3c4 = {
    name: $f6fceb41179b2191$var$name,
    shader: $f6fceb41179b2191$var$shader
};

});

parcelRegister("b4ZX6", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $81101fda09a52120$var$name = "samplerFragmentDeclaration";
const $81101fda09a52120$var$shader = `#ifdef _DEFINENAME_
#if _DEFINENAME_DIRECTUV==1
#define v_VARYINGNAME_UV vMainUV1
#elif _DEFINENAME_DIRECTUV==2
#define v_VARYINGNAME_UV vMainUV2
#elif _DEFINENAME_DIRECTUV==3
#define v_VARYINGNAME_UV vMainUV3
#elif _DEFINENAME_DIRECTUV==4
#define v_VARYINGNAME_UV vMainUV4
#elif _DEFINENAME_DIRECTUV==5
#define v_VARYINGNAME_UV vMainUV5
#elif _DEFINENAME_DIRECTUV==6
#define v_VARYINGNAME_UV vMainUV6
#else
varying vec2 v_VARYINGNAME_UV;
#endif
uniform sampler2D _SAMPLERNAME_Sampler;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$81101fda09a52120$var$name] = $81101fda09a52120$var$shader;
const $81101fda09a52120$export$8b4ee44f0f64e626 = {
    name: $81101fda09a52120$var$name,
    shader: $81101fda09a52120$var$shader
};

});

parcelRegister("6zQZ5", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $4c9f1c8df46ed1c8$var$name = "fresnelFunction";
const $4c9f1c8df46ed1c8$var$shader = `#ifdef FRESNEL
float computeFresnelTerm(vec3 viewDirection,vec3 worldNormal,float bias,float power)
{float fresnelTerm=pow(bias+abs(dot(viewDirection,worldNormal)),power);return clamp(fresnelTerm,0.,1.);}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$4c9f1c8df46ed1c8$var$name] = $4c9f1c8df46ed1c8$var$shader;
const $4c9f1c8df46ed1c8$export$e2a0701410c42cbf = {
    name: $4c9f1c8df46ed1c8$var$name,
    shader: $4c9f1c8df46ed1c8$var$shader
};

});

parcelRegister("6vG1y", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $4bd63c684de26b99$var$name = "reflectionFunction";
const $4bd63c684de26b99$var$shader = `vec3 computeFixedEquirectangularCoords(vec4 worldPos,vec3 worldNormal,vec3 direction)
{float lon=atan(direction.z,direction.x);float lat=acos(direction.y);vec2 sphereCoords=vec2(lon,lat)*RECIPROCAL_PI2*2.0;float s=sphereCoords.x*0.5+0.5;float t=sphereCoords.y;return vec3(s,t,0); }
vec3 computeMirroredFixedEquirectangularCoords(vec4 worldPos,vec3 worldNormal,vec3 direction)
{float lon=atan(direction.z,direction.x);float lat=acos(direction.y);vec2 sphereCoords=vec2(lon,lat)*RECIPROCAL_PI2*2.0;float s=sphereCoords.x*0.5+0.5;float t=sphereCoords.y;return vec3(1.0-s,t,0); }
vec3 computeEquirectangularCoords(vec4 worldPos,vec3 worldNormal,vec3 eyePosition,mat4 reflectionMatrix)
{vec3 cameraToVertex=normalize(worldPos.xyz-eyePosition);vec3 r=normalize(reflect(cameraToVertex,worldNormal));r=vec3(reflectionMatrix*vec4(r,0));float lon=atan(r.z,r.x);float lat=acos(r.y);vec2 sphereCoords=vec2(lon,lat)*RECIPROCAL_PI2*2.0;float s=sphereCoords.x*0.5+0.5;float t=sphereCoords.y;return vec3(s,t,0);}
vec3 computeSphericalCoords(vec4 worldPos,vec3 worldNormal,mat4 view,mat4 reflectionMatrix)
{vec3 viewDir=normalize(vec3(view*worldPos));vec3 viewNormal=normalize(vec3(view*vec4(worldNormal,0.0)));vec3 r=reflect(viewDir,viewNormal);r=vec3(reflectionMatrix*vec4(r,0));r.z=r.z-1.0;float m=2.0*length(r);return vec3(r.x/m+0.5,1.0-r.y/m-0.5,0);}
vec3 computePlanarCoords(vec4 worldPos,vec3 worldNormal,vec3 eyePosition,mat4 reflectionMatrix)
{vec3 viewDir=worldPos.xyz-eyePosition;vec3 coords=normalize(reflect(viewDir,worldNormal));return vec3(reflectionMatrix*vec4(coords,1));}
vec3 computeCubicCoords(vec4 worldPos,vec3 worldNormal,vec3 eyePosition,mat4 reflectionMatrix)
{vec3 viewDir=normalize(worldPos.xyz-eyePosition);vec3 coords=reflect(viewDir,worldNormal);coords=vec3(reflectionMatrix*vec4(coords,0));
#ifdef INVERTCUBICMAP
coords.y*=-1.0;
#endif
return coords;}
vec3 computeCubicLocalCoords(vec4 worldPos,vec3 worldNormal,vec3 eyePosition,mat4 reflectionMatrix,vec3 reflectionSize,vec3 reflectionPosition)
{vec3 viewDir=normalize(worldPos.xyz-eyePosition);vec3 coords=reflect(viewDir,worldNormal);coords=parallaxCorrectNormal(worldPos.xyz,coords,reflectionSize,reflectionPosition);coords=vec3(reflectionMatrix*vec4(coords,0));
#ifdef INVERTCUBICMAP
coords.y*=-1.0;
#endif
return coords;}
vec3 computeProjectionCoords(vec4 worldPos,mat4 view,mat4 reflectionMatrix)
{return vec3(reflectionMatrix*(view*worldPos));}
vec3 computeSkyBoxCoords(vec3 positionW,mat4 reflectionMatrix)
{return vec3(reflectionMatrix*vec4(positionW,1.));}
#ifdef REFLECTION
vec3 computeReflectionCoords(vec4 worldPos,vec3 worldNormal)
{
#ifdef REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED
vec3 direction=normalize(vDirectionW);return computeMirroredFixedEquirectangularCoords(worldPos,worldNormal,direction);
#endif
#ifdef REFLECTIONMAP_EQUIRECTANGULAR_FIXED
vec3 direction=normalize(vDirectionW);return computeFixedEquirectangularCoords(worldPos,worldNormal,direction);
#endif
#ifdef REFLECTIONMAP_EQUIRECTANGULAR
return computeEquirectangularCoords(worldPos,worldNormal,vEyePosition.xyz,reflectionMatrix);
#endif
#ifdef REFLECTIONMAP_SPHERICAL
return computeSphericalCoords(worldPos,worldNormal,view,reflectionMatrix);
#endif
#ifdef REFLECTIONMAP_PLANAR
return computePlanarCoords(worldPos,worldNormal,vEyePosition.xyz,reflectionMatrix);
#endif
#ifdef REFLECTIONMAP_CUBIC
#ifdef USE_LOCAL_REFLECTIONMAP_CUBIC
return computeCubicLocalCoords(worldPos,worldNormal,vEyePosition.xyz,reflectionMatrix,vReflectionSize,vReflectionPosition);
#else
return computeCubicCoords(worldPos,worldNormal,vEyePosition.xyz,reflectionMatrix);
#endif
#endif
#ifdef REFLECTIONMAP_PROJECTION
return computeProjectionCoords(worldPos,view,reflectionMatrix);
#endif
#ifdef REFLECTIONMAP_SKYBOX
return computeSkyBoxCoords(vPositionUVW,reflectionMatrix);
#endif
#ifdef REFLECTIONMAP_EXPLICIT
return vec3(0,0,0);
#endif
}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$4bd63c684de26b99$var$name] = $4bd63c684de26b99$var$shader;
const $4bd63c684de26b99$export$83a38c4d3ad33c8 = {
    name: $4bd63c684de26b99$var$name,
    shader: $4bd63c684de26b99$var$shader
};

});

parcelRegister("jtwq6", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $e2d9dfb14971d2a5$var$name = "imageProcessingDeclaration";
const $e2d9dfb14971d2a5$var$shader = `#ifdef EXPOSURE
uniform float exposureLinear;
#endif
#ifdef CONTRAST
uniform float contrast;
#endif
#if defined(VIGNETTE) || defined(DITHER)
uniform vec2 vInverseScreenSize;
#endif
#ifdef VIGNETTE
uniform vec4 vignetteSettings1;uniform vec4 vignetteSettings2;
#endif
#ifdef COLORCURVES
uniform vec4 vCameraColorCurveNegative;uniform vec4 vCameraColorCurveNeutral;uniform vec4 vCameraColorCurvePositive;
#endif
#ifdef COLORGRADING
#ifdef COLORGRADING3D
uniform highp sampler3D txColorTransform;
#else
uniform sampler2D txColorTransform;
#endif
uniform vec4 colorTransformSettings;
#endif
#ifdef DITHER
uniform float ditherIntensity;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$e2d9dfb14971d2a5$var$name] = $e2d9dfb14971d2a5$var$shader;
const $e2d9dfb14971d2a5$export$ef7bf3c32ad02e4 = {
    name: $e2d9dfb14971d2a5$var$name,
    shader: $e2d9dfb14971d2a5$var$shader
};

});

parcelRegister("cRFSM", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $95daec48b0f946d8$var$name = "imageProcessingFunctions";
const $95daec48b0f946d8$var$shader = `#if defined(COLORGRADING) && !defined(COLORGRADING3D)
/** 
* Polyfill for SAMPLE_TEXTURE_3D,which is unsupported in WebGL.
* sampler3dSetting.x=textureOffset (0.5/textureSize).
* sampler3dSetting.y=textureSize.
*/
#define inline
vec3 sampleTexture3D(sampler2D colorTransform,vec3 color,vec2 sampler3dSetting)
{float sliceSize=2.0*sampler3dSetting.x; 
#ifdef SAMPLER3DGREENDEPTH
float sliceContinuous=(color.g-sampler3dSetting.x)*sampler3dSetting.y;
#else
float sliceContinuous=(color.b-sampler3dSetting.x)*sampler3dSetting.y;
#endif
float sliceInteger=floor(sliceContinuous);float sliceFraction=sliceContinuous-sliceInteger;
#ifdef SAMPLER3DGREENDEPTH
vec2 sliceUV=color.rb;
#else
vec2 sliceUV=color.rg;
#endif
sliceUV.x*=sliceSize;sliceUV.x+=sliceInteger*sliceSize;sliceUV=saturate(sliceUV);vec4 slice0Color=texture2D(colorTransform,sliceUV);sliceUV.x+=sliceSize;sliceUV=saturate(sliceUV);vec4 slice1Color=texture2D(colorTransform,sliceUV);vec3 result=mix(slice0Color.rgb,slice1Color.rgb,sliceFraction);
#ifdef SAMPLER3DBGRMAP
color.rgb=result.rgb;
#else
color.rgb=result.bgr;
#endif
return color;}
#endif
#ifdef TONEMAPPING_ACES
const mat3 ACESInputMat=mat3(
vec3(0.59719,0.07600,0.02840),
vec3(0.35458,0.90834,0.13383),
vec3(0.04823,0.01566,0.83777)
);const mat3 ACESOutputMat=mat3(
vec3( 1.60475,-0.10208,-0.00327),
vec3(-0.53108, 1.10813,-0.07276),
vec3(-0.07367,-0.00605, 1.07602)
);vec3 RRTAndODTFit(vec3 v)
{vec3 a=v*(v+0.0245786)-0.000090537;vec3 b=v*(0.983729*v+0.4329510)+0.238081;return a/b;}
vec3 ACESFitted(vec3 color)
{color=ACESInputMat*color;color=RRTAndODTFit(color);color=ACESOutputMat*color;color=saturate(color);return color;}
#endif
#define CUSTOM_IMAGEPROCESSINGFUNCTIONS_DEFINITIONS
vec4 applyImageProcessing(vec4 result) {
#define CUSTOM_IMAGEPROCESSINGFUNCTIONS_UPDATERESULT_ATSTART
#ifdef EXPOSURE
result.rgb*=exposureLinear;
#endif
#ifdef VIGNETTE
vec2 viewportXY=gl_FragCoord.xy*vInverseScreenSize;viewportXY=viewportXY*2.0-1.0;vec3 vignetteXY1=vec3(viewportXY*vignetteSettings1.xy+vignetteSettings1.zw,1.0);float vignetteTerm=dot(vignetteXY1,vignetteXY1);float vignette=pow(vignetteTerm,vignetteSettings2.w);vec3 vignetteColor=vignetteSettings2.rgb;
#ifdef VIGNETTEBLENDMODEMULTIPLY
vec3 vignetteColorMultiplier=mix(vignetteColor,vec3(1,1,1),vignette);result.rgb*=vignetteColorMultiplier;
#endif
#ifdef VIGNETTEBLENDMODEOPAQUE
result.rgb=mix(vignetteColor,result.rgb,vignette);
#endif
#endif
#ifdef TONEMAPPING
#ifdef TONEMAPPING_ACES
result.rgb=ACESFitted(result.rgb);
#else
const float tonemappingCalibration=1.590579;result.rgb=1.0-exp2(-tonemappingCalibration*result.rgb);
#endif
#endif
result.rgb=toGammaSpace(result.rgb);result.rgb=saturate(result.rgb);
#ifdef CONTRAST
vec3 resultHighContrast=result.rgb*result.rgb*(3.0-2.0*result.rgb);if (contrast<1.0) {result.rgb=mix(vec3(0.5,0.5,0.5),result.rgb,contrast);} else {result.rgb=mix(result.rgb,resultHighContrast,contrast-1.0);}
#endif
#ifdef COLORGRADING
vec3 colorTransformInput=result.rgb*colorTransformSettings.xxx+colorTransformSettings.yyy;
#ifdef COLORGRADING3D
vec3 colorTransformOutput=texture(txColorTransform,colorTransformInput).rgb;
#else
vec3 colorTransformOutput=sampleTexture3D(txColorTransform,colorTransformInput,colorTransformSettings.yz).rgb;
#endif
result.rgb=mix(result.rgb,colorTransformOutput,colorTransformSettings.www);
#endif
#ifdef COLORCURVES
float luma=getLuminance(result.rgb);vec2 curveMix=clamp(vec2(luma*3.0-1.5,luma*-3.0+1.5),vec2(0.0),vec2(1.0));vec4 colorCurve=vCameraColorCurveNeutral+curveMix.x*vCameraColorCurvePositive-curveMix.y*vCameraColorCurveNegative;result.rgb*=colorCurve.rgb;result.rgb=mix(vec3(luma),result.rgb,colorCurve.a);
#endif
#ifdef DITHER
float rand=getRand(gl_FragCoord.xy*vInverseScreenSize);float dither=mix(-ditherIntensity,ditherIntensity,rand);result.rgb=saturate(result.rgb+vec3(dither));
#endif
#define CUSTOM_IMAGEPROCESSINGFUNCTIONS_UPDATERESULT_ATEND
return result;}`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$95daec48b0f946d8$var$name] = $95daec48b0f946d8$var$shader;
const $95daec48b0f946d8$export$45e67855eef1d7b7 = {
    name: $95daec48b0f946d8$var$name,
    shader: $95daec48b0f946d8$var$shader
};

});

parcelRegister("lnIOB", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $f90e8252b460407d$var$name = "bumpFragmentMainFunctions";
const $f90e8252b460407d$var$shader = `#if defined(BUMP) || defined(CLEARCOAT_BUMP) || defined(ANISOTROPIC) || defined(DETAIL)
#if defined(TANGENT) && defined(NORMAL) 
varying mat3 vTBN;
#endif
#ifdef OBJECTSPACE_NORMALMAP
uniform mat4 normalMatrix;
#if defined(WEBGL2) || defined(WEBGPU)
mat4 toNormalMatrix(mat4 wMatrix)
{mat4 ret=inverse(wMatrix);ret=transpose(ret);ret[0][3]=0.;ret[1][3]=0.;ret[2][3]=0.;ret[3]=vec4(0.,0.,0.,1.);return ret;}
#else
mat4 toNormalMatrix(mat4 m)
{float
a00=m[0][0],a01=m[0][1],a02=m[0][2],a03=m[0][3],
a10=m[1][0],a11=m[1][1],a12=m[1][2],a13=m[1][3],
a20=m[2][0],a21=m[2][1],a22=m[2][2],a23=m[2][3],
a30=m[3][0],a31=m[3][1],a32=m[3][2],a33=m[3][3],
b00=a00*a11-a01*a10,
b01=a00*a12-a02*a10,
b02=a00*a13-a03*a10,
b03=a01*a12-a02*a11,
b04=a01*a13-a03*a11,
b05=a02*a13-a03*a12,
b06=a20*a31-a21*a30,
b07=a20*a32-a22*a30,
b08=a20*a33-a23*a30,
b09=a21*a32-a22*a31,
b10=a21*a33-a23*a31,
b11=a22*a33-a23*a32,
det=b00*b11-b01*b10+b02*b09+b03*b08-b04*b07+b05*b06;mat4 mi=mat4(
a11*b11-a12*b10+a13*b09,
a02*b10-a01*b11-a03*b09,
a31*b05-a32*b04+a33*b03,
a22*b04-a21*b05-a23*b03,
a12*b08-a10*b11-a13*b07,
a00*b11-a02*b08+a03*b07,
a32*b02-a30*b05-a33*b01,
a20*b05-a22*b02+a23*b01,
a10*b10-a11*b08+a13*b06,
a01*b08-a00*b10-a03*b06,
a30*b04-a31*b02+a33*b00,
a21*b02-a20*b04-a23*b00,
a11*b07-a10*b09-a12*b06,
a00*b09-a01*b07+a02*b06,
a31*b01-a30*b03-a32*b00,
a20*b03-a21*b01+a22*b00)/det;return mat4(mi[0][0],mi[1][0],mi[2][0],mi[3][0],
mi[0][1],mi[1][1],mi[2][1],mi[3][1],
mi[0][2],mi[1][2],mi[2][2],mi[3][2],
mi[0][3],mi[1][3],mi[2][3],mi[3][3]);}
#endif
#endif
vec3 perturbNormalBase(mat3 cotangentFrame,vec3 normal,float scale)
{
#ifdef NORMALXYSCALE
normal=normalize(normal*vec3(scale,scale,1.0));
#endif
return normalize(cotangentFrame*normal);}
vec3 perturbNormal(mat3 cotangentFrame,vec3 textureSample,float scale)
{return perturbNormalBase(cotangentFrame,textureSample*2.0-1.0,scale);}
mat3 cotangent_frame(vec3 normal,vec3 p,vec2 uv,vec2 tangentSpaceParams)
{vec3 dp1=dFdx(p);vec3 dp2=dFdy(p);vec2 duv1=dFdx(uv);vec2 duv2=dFdy(uv);vec3 dp2perp=cross(dp2,normal);vec3 dp1perp=cross(normal,dp1);vec3 tangent=dp2perp*duv1.x+dp1perp*duv2.x;vec3 bitangent=dp2perp*duv1.y+dp1perp*duv2.y;tangent*=tangentSpaceParams.x;bitangent*=tangentSpaceParams.y;float det=max(dot(tangent,tangent),dot(bitangent,bitangent));float invmax=det==0.0 ? 0.0 : inversesqrt(det);return mat3(tangent*invmax,bitangent*invmax,normal);}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$f90e8252b460407d$var$name] = $f90e8252b460407d$var$shader;
const $f90e8252b460407d$export$627d4672083e63a1 = {
    name: $f90e8252b460407d$var$name,
    shader: $f90e8252b460407d$var$shader
};

});

parcelRegister("2KL02", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("b4ZX6");
const $201455cce0aad236$var$name = "bumpFragmentFunctions";
const $201455cce0aad236$var$shader = `#if defined(BUMP)
#include<samplerFragmentDeclaration>(_DEFINENAME_,BUMP,_VARYINGNAME_,Bump,_SAMPLERNAME_,bump)
#endif
#if defined(DETAIL)
#include<samplerFragmentDeclaration>(_DEFINENAME_,DETAIL,_VARYINGNAME_,Detail,_SAMPLERNAME_,detail)
#endif
#if defined(BUMP) && defined(PARALLAX)
const float minSamples=4.;const float maxSamples=15.;const int iMaxSamples=15;vec2 parallaxOcclusion(vec3 vViewDirCoT,vec3 vNormalCoT,vec2 texCoord,float parallaxScale) {float parallaxLimit=length(vViewDirCoT.xy)/vViewDirCoT.z;parallaxLimit*=parallaxScale;vec2 vOffsetDir=normalize(vViewDirCoT.xy);vec2 vMaxOffset=vOffsetDir*parallaxLimit;float numSamples=maxSamples+(dot(vViewDirCoT,vNormalCoT)*(minSamples-maxSamples));float stepSize=1.0/numSamples;float currRayHeight=1.0;vec2 vCurrOffset=vec2(0,0);vec2 vLastOffset=vec2(0,0);float lastSampledHeight=1.0;float currSampledHeight=1.0;bool keepWorking=true;for (int i=0; i<iMaxSamples; i++)
{currSampledHeight=texture2D(bumpSampler,texCoord+vCurrOffset).w;if (!keepWorking)
{}
else if (currSampledHeight>currRayHeight)
{float delta1=currSampledHeight-currRayHeight;float delta2=(currRayHeight+stepSize)-lastSampledHeight;float ratio=delta1/(delta1+delta2);vCurrOffset=(ratio)* vLastOffset+(1.0-ratio)*vCurrOffset;keepWorking=false;}
else
{currRayHeight-=stepSize;vLastOffset=vCurrOffset;
#ifdef PARALLAX_RHS
vCurrOffset-=stepSize*vMaxOffset;
#else
vCurrOffset+=stepSize*vMaxOffset;
#endif
lastSampledHeight=currSampledHeight;}}
return vCurrOffset;}
vec2 parallaxOffset(vec3 viewDir,float heightScale)
{float height=texture2D(bumpSampler,vBumpUV).w;vec2 texCoordOffset=heightScale*viewDir.xy*height;
#ifdef PARALLAX_RHS
return texCoordOffset;
#else
return -texCoordOffset;
#endif
}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$201455cce0aad236$var$name] = $201455cce0aad236$var$shader;
const $201455cce0aad236$export$66987c692cc9b754 = {
    name: $201455cce0aad236$var$name,
    shader: $201455cce0aad236$var$shader
};

});

parcelRegister("82O8L", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $5db56776664de2cf$var$name = "clipPlaneFragmentDeclaration";
const $5db56776664de2cf$var$shader = `#ifdef CLIPPLANE
varying float fClipDistance;
#endif
#ifdef CLIPPLANE2
varying float fClipDistance2;
#endif
#ifdef CLIPPLANE3
varying float fClipDistance3;
#endif
#ifdef CLIPPLANE4
varying float fClipDistance4;
#endif
#ifdef CLIPPLANE5
varying float fClipDistance5;
#endif
#ifdef CLIPPLANE6
varying float fClipDistance6;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$5db56776664de2cf$var$name] = $5db56776664de2cf$var$shader;
const $5db56776664de2cf$export$a7ada6d6747eac28 = {
    name: $5db56776664de2cf$var$name,
    shader: $5db56776664de2cf$var$shader
};

});

parcelRegister("4kipo", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $32674f36d644b329$var$name = "logDepthDeclaration";
const $32674f36d644b329$var$shader = `#ifdef LOGARITHMICDEPTH
uniform float logarithmicDepthConstant;varying float vFragmentDepth;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$32674f36d644b329$var$name] = $32674f36d644b329$var$shader;
const $32674f36d644b329$export$d504a825a83b203c = {
    name: $32674f36d644b329$var$name,
    shader: $32674f36d644b329$var$shader
};

});

parcelRegister("hvLF9", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $cbfa4db95c1c73de$var$name = "fogFragmentDeclaration";
const $cbfa4db95c1c73de$var$shader = `#ifdef FOG
#define FOGMODE_NONE 0.
#define FOGMODE_EXP 1.
#define FOGMODE_EXP2 2.
#define FOGMODE_LINEAR 3.
#define E 2.71828
uniform vec4 vFogInfos;uniform vec3 vFogColor;varying vec3 vFogDistance;float CalcFogFactor()
{float fogCoeff=1.0;float fogStart=vFogInfos.y;float fogEnd=vFogInfos.z;float fogDensity=vFogInfos.w;float fogDistance=length(vFogDistance);if (FOGMODE_LINEAR==vFogInfos.x)
{fogCoeff=(fogEnd-fogDistance)/(fogEnd-fogStart);}
else if (FOGMODE_EXP==vFogInfos.x)
{fogCoeff=1.0/pow(E,fogDistance*fogDensity);}
else if (FOGMODE_EXP2==vFogInfos.x)
{fogCoeff=1.0/pow(E,fogDistance*fogDistance*fogDensity*fogDensity);}
return clamp(fogCoeff,0.0,1.0);}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$cbfa4db95c1c73de$var$name] = $cbfa4db95c1c73de$var$shader;
const $cbfa4db95c1c73de$export$c129e0757f70bb62 = {
    name: $cbfa4db95c1c73de$var$name,
    shader: $cbfa4db95c1c73de$var$shader
};

});

parcelRegister("kg1CD", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $ebf68f61df8100fb$var$name = "clipPlaneFragment";
const $ebf68f61df8100fb$var$shader = `#if defined(CLIPPLANE) || defined(CLIPPLANE2) || defined(CLIPPLANE3) || defined(CLIPPLANE4) || defined(CLIPPLANE5) || defined(CLIPPLANE6)
if (false) {}
#endif
#ifdef CLIPPLANE
else if (fClipDistance>0.0)
{discard;}
#endif
#ifdef CLIPPLANE2
else if (fClipDistance2>0.0)
{discard;}
#endif
#ifdef CLIPPLANE3
else if (fClipDistance3>0.0)
{discard;}
#endif
#ifdef CLIPPLANE4
else if (fClipDistance4>0.0)
{discard;}
#endif
#ifdef CLIPPLANE5
else if (fClipDistance5>0.0)
{discard;}
#endif
#ifdef CLIPPLANE6
else if (fClipDistance6>0.0)
{discard;}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$ebf68f61df8100fb$var$name] = $ebf68f61df8100fb$var$shader;
const $ebf68f61df8100fb$export$6a64aed91bad4543 = {
    name: $ebf68f61df8100fb$var$name,
    shader: $ebf68f61df8100fb$var$shader
};

});

parcelRegister("F4hvB", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $07b726a5a0c28fda$var$name = "bumpFragment";
const $07b726a5a0c28fda$var$shader = `vec2 uvOffset=vec2(0.0,0.0);
#if defined(BUMP) || defined(PARALLAX) || defined(DETAIL)
#ifdef NORMALXYSCALE
float normalScale=1.0;
#elif defined(BUMP)
float normalScale=vBumpInfos.y;
#else
float normalScale=1.0;
#endif
#if defined(TANGENT) && defined(NORMAL)
mat3 TBN=vTBN;
#elif defined(BUMP)
vec2 TBNUV=gl_FrontFacing ? vBumpUV : -vBumpUV;mat3 TBN=cotangent_frame(normalW*normalScale,vPositionW,TBNUV,vTangentSpaceParams);
#else
vec2 TBNUV=gl_FrontFacing ? vDetailUV : -vDetailUV;mat3 TBN=cotangent_frame(normalW*normalScale,vPositionW,TBNUV,vec2(1.,1.));
#endif
#elif defined(ANISOTROPIC)
#if defined(TANGENT) && defined(NORMAL)
mat3 TBN=vTBN;
#else
vec2 TBNUV=gl_FrontFacing ? vMainUV1 : -vMainUV1;mat3 TBN=cotangent_frame(normalW,vPositionW,TBNUV,vec2(1.,1.));
#endif
#endif
#ifdef PARALLAX
mat3 invTBN=transposeMat3(TBN);
#ifdef PARALLAXOCCLUSION
uvOffset=parallaxOcclusion(invTBN*-viewDirectionW,invTBN*normalW,vBumpUV,vBumpInfos.z);
#else
uvOffset=parallaxOffset(invTBN*viewDirectionW,vBumpInfos.z);
#endif
#endif
#ifdef DETAIL
vec4 detailColor=texture2D(detailSampler,vDetailUV+uvOffset);vec2 detailNormalRG=detailColor.wy*2.0-1.0;float detailNormalB=sqrt(1.-saturate(dot(detailNormalRG,detailNormalRG)));vec3 detailNormal=vec3(detailNormalRG,detailNormalB);
#endif
#ifdef BUMP
#ifdef OBJECTSPACE_NORMALMAP
#define CUSTOM_FRAGMENT_BUMP_FRAGMENT
normalW=normalize(texture2D(bumpSampler,vBumpUV).xyz *2.0-1.0);normalW=normalize(mat3(normalMatrix)*normalW);
#elif !defined(DETAIL)
normalW=perturbNormal(TBN,texture2D(bumpSampler,vBumpUV+uvOffset).xyz,vBumpInfos.y);
#else
vec3 bumpNormal=texture2D(bumpSampler,vBumpUV+uvOffset).xyz*2.0-1.0;
#if DETAIL_NORMALBLENDMETHOD==0 
detailNormal.xy*=vDetailInfos.z;vec3 blendedNormal=normalize(vec3(bumpNormal.xy+detailNormal.xy,bumpNormal.z*detailNormal.z));
#elif DETAIL_NORMALBLENDMETHOD==1 
detailNormal.xy*=vDetailInfos.z;bumpNormal+=vec3(0.0,0.0,1.0);detailNormal*=vec3(-1.0,-1.0,1.0);vec3 blendedNormal=bumpNormal*dot(bumpNormal,detailNormal)/bumpNormal.z-detailNormal;
#endif
normalW=perturbNormalBase(TBN,blendedNormal,vBumpInfos.y);
#endif
#elif defined(DETAIL)
detailNormal.xy*=vDetailInfos.z;normalW=perturbNormalBase(TBN,detailNormal,vDetailInfos.z);
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$07b726a5a0c28fda$var$name] = $07b726a5a0c28fda$var$shader;
const $07b726a5a0c28fda$export$88c28ea974c27396 = {
    name: $07b726a5a0c28fda$var$name,
    shader: $07b726a5a0c28fda$var$shader
};

});

parcelRegister("lP7hO", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $fe34034d7922ea34$var$name = "decalFragment";
const $fe34034d7922ea34$var$shader = `#ifdef DECAL
#ifdef GAMMADECAL
decalColor.rgb=toLinearSpace(decalColor.rgb);
#endif
#ifdef DECAL_SMOOTHALPHA
decalColor.a*=decalColor.a;
#endif
surfaceAlbedo.rgb=mix(surfaceAlbedo.rgb,decalColor.rgb,decalColor.a);
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$fe34034d7922ea34$var$name] = $fe34034d7922ea34$var$shader;
const $fe34034d7922ea34$export$f8be594596399f23 = {
    name: $fe34034d7922ea34$var$name,
    shader: $fe34034d7922ea34$var$shader
};

});

parcelRegister("6bTUi", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $481f23229197b00f$var$name = "depthPrePass";
const $481f23229197b00f$var$shader = `#ifdef DEPTHPREPASS
gl_FragColor=vec4(0.,0.,0.,1.0);return;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$481f23229197b00f$var$name] = $481f23229197b00f$var$shader;
const $481f23229197b00f$export$48196b5a939e97d = {
    name: $481f23229197b00f$var$name,
    shader: $481f23229197b00f$var$shader
};

});

parcelRegister("4ycgE", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $3503da7f5b0d2323$var$name = "lightFragment";
const $3503da7f5b0d2323$var$shader = `#ifdef LIGHT{X}
#if defined(SHADOWONLY) || defined(LIGHTMAP) && defined(LIGHTMAPEXCLUDED{X}) && defined(LIGHTMAPNOSPECULAR{X})
#else
#ifdef PBR
#ifdef SPOTLIGHT{X}
preInfo=computePointAndSpotPreLightingInfo(light{X}.vLightData,viewDirectionW,normalW);
#elif defined(POINTLIGHT{X})
preInfo=computePointAndSpotPreLightingInfo(light{X}.vLightData,viewDirectionW,normalW);
#elif defined(HEMILIGHT{X})
preInfo=computeHemisphericPreLightingInfo(light{X}.vLightData,viewDirectionW,normalW);
#elif defined(DIRLIGHT{X})
preInfo=computeDirectionalPreLightingInfo(light{X}.vLightData,viewDirectionW,normalW);
#endif
preInfo.NdotV=NdotV;
#ifdef SPOTLIGHT{X}
#ifdef LIGHT_FALLOFF_GLTF{X}
preInfo.attenuation=computeDistanceLightFalloff_GLTF(preInfo.lightDistanceSquared,light{X}.vLightFalloff.y);preInfo.attenuation*=computeDirectionalLightFalloff_GLTF(light{X}.vLightDirection.xyz,preInfo.L,light{X}.vLightFalloff.z,light{X}.vLightFalloff.w);
#elif defined(LIGHT_FALLOFF_PHYSICAL{X})
preInfo.attenuation=computeDistanceLightFalloff_Physical(preInfo.lightDistanceSquared);preInfo.attenuation*=computeDirectionalLightFalloff_Physical(light{X}.vLightDirection.xyz,preInfo.L,light{X}.vLightDirection.w);
#elif defined(LIGHT_FALLOFF_STANDARD{X})
preInfo.attenuation=computeDistanceLightFalloff_Standard(preInfo.lightOffset,light{X}.vLightFalloff.x);preInfo.attenuation*=computeDirectionalLightFalloff_Standard(light{X}.vLightDirection.xyz,preInfo.L,light{X}.vLightDirection.w,light{X}.vLightData.w);
#else
preInfo.attenuation=computeDistanceLightFalloff(preInfo.lightOffset,preInfo.lightDistanceSquared,light{X}.vLightFalloff.x,light{X}.vLightFalloff.y);preInfo.attenuation*=computeDirectionalLightFalloff(light{X}.vLightDirection.xyz,preInfo.L,light{X}.vLightDirection.w,light{X}.vLightData.w,light{X}.vLightFalloff.z,light{X}.vLightFalloff.w);
#endif
#elif defined(POINTLIGHT{X})
#ifdef LIGHT_FALLOFF_GLTF{X}
preInfo.attenuation=computeDistanceLightFalloff_GLTF(preInfo.lightDistanceSquared,light{X}.vLightFalloff.y);
#elif defined(LIGHT_FALLOFF_PHYSICAL{X})
preInfo.attenuation=computeDistanceLightFalloff_Physical(preInfo.lightDistanceSquared);
#elif defined(LIGHT_FALLOFF_STANDARD{X})
preInfo.attenuation=computeDistanceLightFalloff_Standard(preInfo.lightOffset,light{X}.vLightFalloff.x);
#else
preInfo.attenuation=computeDistanceLightFalloff(preInfo.lightOffset,preInfo.lightDistanceSquared,light{X}.vLightFalloff.x,light{X}.vLightFalloff.y);
#endif
#else
preInfo.attenuation=1.0;
#endif
#ifdef HEMILIGHT{X}
preInfo.roughness=roughness;
#else
preInfo.roughness=adjustRoughnessFromLightProperties(roughness,light{X}.vLightSpecular.a,preInfo.lightDistance);
#endif
#ifdef IRIDESCENCE
preInfo.iridescenceIntensity=iridescenceIntensity;
#endif
#ifdef HEMILIGHT{X}
info.diffuse=computeHemisphericDiffuseLighting(preInfo,light{X}.vLightDiffuse.rgb,light{X}.vLightGround);
#elif defined(SS_TRANSLUCENCY)
info.diffuse=computeDiffuseAndTransmittedLighting(preInfo,light{X}.vLightDiffuse.rgb,subSurfaceOut.transmittance);
#else
info.diffuse=computeDiffuseLighting(preInfo,light{X}.vLightDiffuse.rgb);
#endif
#ifdef SPECULARTERM
#ifdef ANISOTROPIC
info.specular=computeAnisotropicSpecularLighting(preInfo,viewDirectionW,normalW,anisotropicOut.anisotropicTangent,anisotropicOut.anisotropicBitangent,anisotropicOut.anisotropy,clearcoatOut.specularEnvironmentR0,specularEnvironmentR90,AARoughnessFactors.x,light{X}.vLightDiffuse.rgb);
#else
info.specular=computeSpecularLighting(preInfo,normalW,clearcoatOut.specularEnvironmentR0,specularEnvironmentR90,AARoughnessFactors.x,light{X}.vLightDiffuse.rgb);
#endif
#endif
#ifdef SHEEN
#ifdef SHEEN_LINKWITHALBEDO
preInfo.roughness=sheenOut.sheenIntensity;
#else
#ifdef HEMILIGHT{X}
preInfo.roughness=sheenOut.sheenRoughness;
#else
preInfo.roughness=adjustRoughnessFromLightProperties(sheenOut.sheenRoughness,light{X}.vLightSpecular.a,preInfo.lightDistance);
#endif
#endif
info.sheen=computeSheenLighting(preInfo,normalW,sheenOut.sheenColor,specularEnvironmentR90,AARoughnessFactors.x,light{X}.vLightDiffuse.rgb);
#endif
#ifdef CLEARCOAT
#ifdef HEMILIGHT{X}
preInfo.roughness=clearcoatOut.clearCoatRoughness;
#else
preInfo.roughness=adjustRoughnessFromLightProperties(clearcoatOut.clearCoatRoughness,light{X}.vLightSpecular.a,preInfo.lightDistance);
#endif
info.clearCoat=computeClearCoatLighting(preInfo,clearcoatOut.clearCoatNormalW,clearcoatOut.clearCoatAARoughnessFactors.x,clearcoatOut.clearCoatIntensity,light{X}.vLightDiffuse.rgb);
#ifdef CLEARCOAT_TINT
absorption=computeClearCoatLightingAbsorption(clearcoatOut.clearCoatNdotVRefract,preInfo.L,clearcoatOut.clearCoatNormalW,clearcoatOut.clearCoatColor,clearcoatOut.clearCoatThickness,clearcoatOut.clearCoatIntensity);info.diffuse*=absorption;
#ifdef SPECULARTERM
info.specular*=absorption;
#endif
#endif
info.diffuse*=info.clearCoat.w;
#ifdef SPECULARTERM
info.specular*=info.clearCoat.w;
#endif
#ifdef SHEEN
info.sheen*=info.clearCoat.w;
#endif
#endif
#else
#ifdef SPOTLIGHT{X}
info=computeSpotLighting(viewDirectionW,normalW,light{X}.vLightData,light{X}.vLightDirection,light{X}.vLightDiffuse.rgb,light{X}.vLightSpecular.rgb,light{X}.vLightDiffuse.a,glossiness);
#elif defined(HEMILIGHT{X})
info=computeHemisphericLighting(viewDirectionW,normalW,light{X}.vLightData,light{X}.vLightDiffuse.rgb,light{X}.vLightSpecular.rgb,light{X}.vLightGround,glossiness);
#elif defined(POINTLIGHT{X}) || defined(DIRLIGHT{X})
info=computeLighting(viewDirectionW,normalW,light{X}.vLightData,light{X}.vLightDiffuse.rgb,light{X}.vLightSpecular.rgb,light{X}.vLightDiffuse.a,glossiness);
#endif
#endif
#ifdef PROJECTEDLIGHTTEXTURE{X}
info.diffuse*=computeProjectionTextureDiffuseLighting(projectionLightSampler{X},textureProjectionMatrix{X});
#endif
#endif
#ifdef SHADOW{X}
#ifdef SHADOWCSM{X}
for (int i=0; i<SHADOWCSMNUM_CASCADES{X}; i++) 
{
#ifdef SHADOWCSM_RIGHTHANDED{X}
diff{X}=viewFrustumZ{X}[i]+vPositionFromCamera{X}.z;
#else
diff{X}=viewFrustumZ{X}[i]-vPositionFromCamera{X}.z;
#endif
if (diff{X}>=0.) {index{X}=i;break;}}
#ifdef SHADOWCSMUSESHADOWMAXZ{X}
if (index{X}>=0)
#endif
{
#if defined(SHADOWPCF{X})
#if defined(SHADOWLOWQUALITY{X})
shadow=computeShadowWithCSMPCF1(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],shadowSampler{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#elif defined(SHADOWMEDIUMQUALITY{X})
shadow=computeShadowWithCSMPCF3(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],shadowSampler{X},light{X}.shadowsInfo.yz,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#else
shadow=computeShadowWithCSMPCF5(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],shadowSampler{X},light{X}.shadowsInfo.yz,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#endif
#elif defined(SHADOWPCSS{X})
#if defined(SHADOWLOWQUALITY{X})
shadow=computeShadowWithCSMPCSS16(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],depthSampler{X},shadowSampler{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.z,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w,lightSizeUVCorrection{X}[index{X}],depthCorrection{X}[index{X}],penumbraDarkness{X});
#elif defined(SHADOWMEDIUMQUALITY{X})
shadow=computeShadowWithCSMPCSS32(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],depthSampler{X},shadowSampler{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.z,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w,lightSizeUVCorrection{X}[index{X}],depthCorrection{X}[index{X}],penumbraDarkness{X});
#else
shadow=computeShadowWithCSMPCSS64(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],depthSampler{X},shadowSampler{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.z,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w,lightSizeUVCorrection{X}[index{X}],depthCorrection{X}[index{X}],penumbraDarkness{X});
#endif
#else
shadow=computeShadowCSM(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],shadowSampler{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#endif
#ifdef SHADOWCSMDEBUG{X}
shadowDebug{X}=vec3(shadow)*vCascadeColorsMultiplier{X}[index{X}];
#endif
#ifndef SHADOWCSMNOBLEND{X}
float frustumLength=frustumLengths{X}[index{X}];float diffRatio=clamp(diff{X}/frustumLength,0.,1.)*cascadeBlendFactor{X};if (index{X}<(SHADOWCSMNUM_CASCADES{X}-1) && diffRatio<1.)
{index{X}+=1;float nextShadow=0.;
#if defined(SHADOWPCF{X})
#if defined(SHADOWLOWQUALITY{X})
nextShadow=computeShadowWithCSMPCF1(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],shadowSampler{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#elif defined(SHADOWMEDIUMQUALITY{X})
nextShadow=computeShadowWithCSMPCF3(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],shadowSampler{X},light{X}.shadowsInfo.yz,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#else
nextShadow=computeShadowWithCSMPCF5(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],shadowSampler{X},light{X}.shadowsInfo.yz,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#endif
#elif defined(SHADOWPCSS{X})
#if defined(SHADOWLOWQUALITY{X})
nextShadow=computeShadowWithCSMPCSS16(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],depthSampler{X},shadowSampler{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.z,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w,lightSizeUVCorrection{X}[index{X}],depthCorrection{X}[index{X}],penumbraDarkness{X});
#elif defined(SHADOWMEDIUMQUALITY{X})
nextShadow=computeShadowWithCSMPCSS32(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],depthSampler{X},shadowSampler{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.z,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w,lightSizeUVCorrection{X}[index{X}],depthCorrection{X}[index{X}],penumbraDarkness{X});
#else
nextShadow=computeShadowWithCSMPCSS64(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],depthSampler{X},shadowSampler{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.z,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w,lightSizeUVCorrection{X}[index{X}],depthCorrection{X}[index{X}],penumbraDarkness{X});
#endif
#else
nextShadow=computeShadowCSM(float(index{X}),vPositionFromLight{X}[index{X}],vDepthMetric{X}[index{X}],shadowSampler{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#endif
shadow=mix(nextShadow,shadow,diffRatio);
#ifdef SHADOWCSMDEBUG{X}
shadowDebug{X}=mix(vec3(nextShadow)*vCascadeColorsMultiplier{X}[index{X}],shadowDebug{X},diffRatio);
#endif
}
#endif
}
#elif defined(SHADOWCLOSEESM{X})
#if defined(SHADOWCUBE{X})
shadow=computeShadowWithCloseESMCube(vPositionW,light{X}.vLightData.xyz,shadowSampler{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.z,light{X}.depthValues);
#else
shadow=computeShadowWithCloseESM(vPositionFromLight{X},vDepthMetric{X},shadowSampler{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.z,light{X}.shadowsInfo.w);
#endif
#elif defined(SHADOWESM{X})
#if defined(SHADOWCUBE{X})
shadow=computeShadowWithESMCube(vPositionW,light{X}.vLightData.xyz,shadowSampler{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.z,light{X}.depthValues);
#else
shadow=computeShadowWithESM(vPositionFromLight{X},vDepthMetric{X},shadowSampler{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.z,light{X}.shadowsInfo.w);
#endif
#elif defined(SHADOWPOISSON{X})
#if defined(SHADOWCUBE{X})
shadow=computeShadowWithPoissonSamplingCube(vPositionW,light{X}.vLightData.xyz,shadowSampler{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.x,light{X}.depthValues);
#else
shadow=computeShadowWithPoissonSampling(vPositionFromLight{X},vDepthMetric{X},shadowSampler{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#endif
#elif defined(SHADOWPCF{X})
#if defined(SHADOWLOWQUALITY{X})
shadow=computeShadowWithPCF1(vPositionFromLight{X},vDepthMetric{X},shadowSampler{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#elif defined(SHADOWMEDIUMQUALITY{X})
shadow=computeShadowWithPCF3(vPositionFromLight{X},vDepthMetric{X},shadowSampler{X},light{X}.shadowsInfo.yz,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#else
shadow=computeShadowWithPCF5(vPositionFromLight{X},vDepthMetric{X},shadowSampler{X},light{X}.shadowsInfo.yz,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#endif
#elif defined(SHADOWPCSS{X})
#if defined(SHADOWLOWQUALITY{X})
shadow=computeShadowWithPCSS16(vPositionFromLight{X},vDepthMetric{X},depthSampler{X},shadowSampler{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.z,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#elif defined(SHADOWMEDIUMQUALITY{X})
shadow=computeShadowWithPCSS32(vPositionFromLight{X},vDepthMetric{X},depthSampler{X},shadowSampler{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.z,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#else
shadow=computeShadowWithPCSS64(vPositionFromLight{X},vDepthMetric{X},depthSampler{X},shadowSampler{X},light{X}.shadowsInfo.y,light{X}.shadowsInfo.z,light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#endif
#else
#if defined(SHADOWCUBE{X})
shadow=computeShadowCube(vPositionW,light{X}.vLightData.xyz,shadowSampler{X},light{X}.shadowsInfo.x,light{X}.depthValues);
#else
shadow=computeShadow(vPositionFromLight{X},vDepthMetric{X},shadowSampler{X},light{X}.shadowsInfo.x,light{X}.shadowsInfo.w);
#endif
#endif
#ifdef SHADOWONLY
#ifndef SHADOWINUSE
#define SHADOWINUSE
#endif
globalShadow+=shadow;shadowLightCount+=1.0;
#endif
#else
shadow=1.;
#endif
aggShadow+=shadow;numLights+=1.0;
#ifndef SHADOWONLY
#ifdef CUSTOMUSERLIGHTING
diffuseBase+=computeCustomDiffuseLighting(info,diffuseBase,shadow);
#ifdef SPECULARTERM
specularBase+=computeCustomSpecularLighting(info,specularBase,shadow);
#endif
#elif defined(LIGHTMAP) && defined(LIGHTMAPEXCLUDED{X})
diffuseBase+=lightmapColor.rgb*shadow;
#ifdef SPECULARTERM
#ifndef LIGHTMAPNOSPECULAR{X}
specularBase+=info.specular*shadow*lightmapColor.rgb;
#endif
#endif
#ifdef CLEARCOAT
#ifndef LIGHTMAPNOSPECULAR{X}
clearCoatBase+=info.clearCoat.rgb*shadow*lightmapColor.rgb;
#endif
#endif
#ifdef SHEEN
#ifndef LIGHTMAPNOSPECULAR{X}
sheenBase+=info.sheen.rgb*shadow;
#endif
#endif
#else
#ifdef SHADOWCSMDEBUG{X}
diffuseBase+=info.diffuse*shadowDebug{X};
#else 
diffuseBase+=info.diffuse*shadow;
#endif
#ifdef SPECULARTERM
specularBase+=info.specular*shadow;
#endif
#ifdef CLEARCOAT
clearCoatBase+=info.clearCoat.rgb*shadow;
#endif
#ifdef SHEEN
sheenBase+=info.sheen.rgb*shadow;
#endif
#endif
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$3503da7f5b0d2323$var$name] = $3503da7f5b0d2323$var$shader;
const $3503da7f5b0d2323$export$a6a1062295ac262 = {
    name: $3503da7f5b0d2323$var$name,
    shader: $3503da7f5b0d2323$var$shader
};

});

parcelRegister("izyqw", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $d8563351d2d0cb76$var$name = "logDepthFragment";
const $d8563351d2d0cb76$var$shader = `#ifdef LOGARITHMICDEPTH
gl_FragDepthEXT=log2(vFragmentDepth)*logarithmicDepthConstant*0.5;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$d8563351d2d0cb76$var$name] = $d8563351d2d0cb76$var$shader;
const $d8563351d2d0cb76$export$dee12c5553ea23e = {
    name: $d8563351d2d0cb76$var$name,
    shader: $d8563351d2d0cb76$var$shader
};

});

parcelRegister("110hr", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $0bd61a144baa494f$var$name = "fogFragment";
const $0bd61a144baa494f$var$shader = `#ifdef FOG
float fog=CalcFogFactor();
#ifdef PBR
fog=toLinearSpace(fog);
#endif
color.rgb=mix(vFogColor,color.rgb,fog);
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$0bd61a144baa494f$var$name] = $0bd61a144baa494f$var$shader;
const $0bd61a144baa494f$export$f800f8f0095c9706 = {
    name: $0bd61a144baa494f$var$name,
    shader: $0bd61a144baa494f$var$shader
};

});

parcelRegister("b21vU", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $80810e30c3f42af7$var$name = "oitFragment";
const $80810e30c3f42af7$var$shader = `#ifdef ORDER_INDEPENDENT_TRANSPARENCY
float fragDepth=gl_FragCoord.z; 
#ifdef ORDER_INDEPENDENT_TRANSPARENCY_16BITS
uint halfFloat=packHalf2x16(vec2(fragDepth));vec2 full=unpackHalf2x16(halfFloat);fragDepth=full.x;
#endif
ivec2 fragCoord=ivec2(gl_FragCoord.xy);vec2 lastDepth=texelFetch(oitDepthSampler,fragCoord,0).rg;vec4 lastFrontColor=texelFetch(oitFrontColorSampler,fragCoord,0);depth.rg=vec2(-MAX_DEPTH);frontColor=lastFrontColor;backColor=vec4(0.0);
#ifdef USE_REVERSE_DEPTHBUFFER
float furthestDepth=-lastDepth.x;float nearestDepth=lastDepth.y;
#else
float nearestDepth=-lastDepth.x;float furthestDepth=lastDepth.y;
#endif
float alphaMultiplier=1.0-lastFrontColor.a;
#ifdef USE_REVERSE_DEPTHBUFFER
if (fragDepth>nearestDepth || fragDepth<furthestDepth) {
#else
if (fragDepth<nearestDepth || fragDepth>furthestDepth) {
#endif
return;}
#ifdef USE_REVERSE_DEPTHBUFFER
if (fragDepth<nearestDepth && fragDepth>furthestDepth) {
#else
if (fragDepth>nearestDepth && fragDepth<furthestDepth) {
#endif
depth.rg=vec2(-fragDepth,fragDepth);return;}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$80810e30c3f42af7$var$name] = $80810e30c3f42af7$var$shader;
const $80810e30c3f42af7$export$4bd6e7789ff39c0e = {
    name: $80810e30c3f42af7$var$name,
    shader: $80810e30c3f42af7$var$shader
};

});


parcelRegister("fn9QB", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("5g9r7");
parcelRequire("dcSpY");
parcelRequire("1ZoxO");
parcelRequire("7Hs3g");
parcelRequire("7PW7m");
parcelRequire("8kYMw");
parcelRequire("k3wwH");
parcelRequire("cdubm");
parcelRequire("5lMLg");
parcelRequire("eiwUK");
parcelRequire("hgGYG");
parcelRequire("4A4MM");
parcelRequire("bdABV");
parcelRequire("1yLBX");
parcelRequire("c0VT2");
parcelRequire("5Eb4I");
parcelRequire("9H5jp");
parcelRequire("4kipo");
parcelRequire("9ulLS");
parcelRequire("LFrAO");
parcelRequire("apKdp");
parcelRequire("4idCt");
parcelRequire("cIweX");
parcelRequire("f7nPp");
parcelRequire("i4Zbf");
parcelRequire("9N2ej");
parcelRequire("4GjUR");
parcelRequire("kqCfW");
parcelRequire("1pV7g");
parcelRequire("5sP5F");
parcelRequire("jl3r6");
parcelRequire("2NtPW");
parcelRequire("a111f");
const $b310a47bffd39c6d$var$name = "defaultVertexShader";
const $b310a47bffd39c6d$var$shader = `#include<__decl__defaultVertex>
#define CUSTOM_VERTEX_BEGIN
attribute vec3 position;
#ifdef NORMAL
attribute vec3 normal;
#endif
#ifdef TANGENT
attribute vec4 tangent;
#endif
#ifdef UV1
attribute vec2 uv;
#endif
#include<uvAttributeDeclaration>[2..7]
#ifdef VERTEXCOLOR
attribute vec4 color;
#endif
#include<helperFunctions>
#include<bonesDeclaration>
#include<bakedVertexAnimationDeclaration>
#include<instancesDeclaration>
#include<prePassVertexDeclaration>
#include<mainUVVaryingDeclaration>[1..7]
#include<samplerVertexDeclaration>(_DEFINENAME_,DIFFUSE,_VARYINGNAME_,Diffuse)
#include<samplerVertexDeclaration>(_DEFINENAME_,DETAIL,_VARYINGNAME_,Detail)
#include<samplerVertexDeclaration>(_DEFINENAME_,AMBIENT,_VARYINGNAME_,Ambient)
#include<samplerVertexDeclaration>(_DEFINENAME_,OPACITY,_VARYINGNAME_,Opacity)
#include<samplerVertexDeclaration>(_DEFINENAME_,EMISSIVE,_VARYINGNAME_,Emissive)
#include<samplerVertexDeclaration>(_DEFINENAME_,LIGHTMAP,_VARYINGNAME_,Lightmap)
#if defined(SPECULARTERM)
#include<samplerVertexDeclaration>(_DEFINENAME_,SPECULAR,_VARYINGNAME_,Specular)
#endif
#include<samplerVertexDeclaration>(_DEFINENAME_,BUMP,_VARYINGNAME_,Bump)
#include<samplerVertexDeclaration>(_DEFINENAME_,DECAL,_VARYINGNAME_,Decal)
varying vec3 vPositionW;
#ifdef NORMAL
varying vec3 vNormalW;
#endif
#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
varying vec4 vColor;
#endif
#include<bumpVertexDeclaration>
#include<clipPlaneVertexDeclaration>
#include<fogVertexDeclaration>
#include<__decl__lightVxFragment>[0..maxSimultaneousLights]
#include<morphTargetsVertexGlobalDeclaration>
#include<morphTargetsVertexDeclaration>[0..maxSimultaneousMorphTargets]
#ifdef REFLECTIONMAP_SKYBOX
varying vec3 vPositionUVW;
#endif
#if defined(REFLECTIONMAP_EQUIRECTANGULAR_FIXED) || defined(REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED)
varying vec3 vDirectionW;
#endif
#include<logDepthDeclaration>
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
vec3 positionUpdated=position;
#ifdef NORMAL
vec3 normalUpdated=normal;
#endif
#ifdef TANGENT
vec4 tangentUpdated=tangent;
#endif
#ifdef UV1
vec2 uvUpdated=uv;
#endif
#include<morphTargetsVertexGlobal>
#include<morphTargetsVertex>[0..maxSimultaneousMorphTargets]
#ifdef REFLECTIONMAP_SKYBOX
vPositionUVW=positionUpdated;
#endif
#define CUSTOM_VERTEX_UPDATE_POSITION
#define CUSTOM_VERTEX_UPDATE_NORMAL
#include<instancesVertex>
#if defined(PREPASS) && defined(PREPASS_VELOCITY) && !defined(BONES_VELOCITY_ENABLED)
vCurrentPosition=viewProjection*finalWorld*vec4(positionUpdated,1.0);vPreviousPosition=previousViewProjection*finalPreviousWorld*vec4(positionUpdated,1.0);
#endif
#include<bonesVertex>
#include<bakedVertexAnimation>
vec4 worldPos=finalWorld*vec4(positionUpdated,1.0);
#ifdef NORMAL
mat3 normalWorld=mat3(finalWorld);
#if defined(INSTANCES) && defined(THIN_INSTANCES)
vNormalW=normalUpdated/vec3(dot(normalWorld[0],normalWorld[0]),dot(normalWorld[1],normalWorld[1]),dot(normalWorld[2],normalWorld[2]));vNormalW=normalize(normalWorld*vNormalW);
#else
#ifdef NONUNIFORMSCALING
normalWorld=transposeMat3(inverseMat3(normalWorld));
#endif
vNormalW=normalize(normalWorld*normalUpdated);
#endif
#endif
#define CUSTOM_VERTEX_UPDATE_WORLDPOS
#ifdef MULTIVIEW
if (gl_ViewID_OVR==0u) {gl_Position=viewProjection*worldPos;} else {gl_Position=viewProjectionR*worldPos;}
#else
gl_Position=viewProjection*worldPos;
#endif
vPositionW=vec3(worldPos);
#include<prePassVertex>
#if defined(REFLECTIONMAP_EQUIRECTANGULAR_FIXED) || defined(REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED)
vDirectionW=normalize(vec3(finalWorld*vec4(positionUpdated,0.0)));
#endif
#ifndef UV1
vec2 uvUpdated=vec2(0.,0.);
#endif
#ifdef MAINUV1
vMainUV1=uvUpdated;
#endif
#include<uvVariableDeclaration>[2..7]
#include<samplerVertexImplementation>(_DEFINENAME_,DIFFUSE,_VARYINGNAME_,Diffuse,_MATRIXNAME_,diffuse,_INFONAME_,DiffuseInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,DETAIL,_VARYINGNAME_,Detail,_MATRIXNAME_,detail,_INFONAME_,DetailInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,AMBIENT,_VARYINGNAME_,Ambient,_MATRIXNAME_,ambient,_INFONAME_,AmbientInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,OPACITY,_VARYINGNAME_,Opacity,_MATRIXNAME_,opacity,_INFONAME_,OpacityInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,EMISSIVE,_VARYINGNAME_,Emissive,_MATRIXNAME_,emissive,_INFONAME_,EmissiveInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,LIGHTMAP,_VARYINGNAME_,Lightmap,_MATRIXNAME_,lightmap,_INFONAME_,LightmapInfos.x)
#if defined(SPECULARTERM)
#include<samplerVertexImplementation>(_DEFINENAME_,SPECULAR,_VARYINGNAME_,Specular,_MATRIXNAME_,specular,_INFONAME_,SpecularInfos.x)
#endif
#include<samplerVertexImplementation>(_DEFINENAME_,BUMP,_VARYINGNAME_,Bump,_MATRIXNAME_,bump,_INFONAME_,BumpInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,DECAL,_VARYINGNAME_,Decal,_MATRIXNAME_,decal,_INFONAME_,DecalInfos.x)
#include<bumpVertex>
#include<clipPlaneVertex>
#include<fogVertex>
#include<shadowsVertex>[0..maxSimultaneousLights]
#include<vertexColorMixing>
#include<pointCloudVertex>
#include<logDepthVertex>
#define CUSTOM_VERTEX_MAIN_END
}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$b310a47bffd39c6d$var$name] = $b310a47bffd39c6d$var$shader;
const $b310a47bffd39c6d$export$664d1877a3009ae4 = {
    name: $b310a47bffd39c6d$var$name,
    shader: $b310a47bffd39c6d$var$shader
};

});
parcelRegister("5g9r7", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("jsAPu");
const $3d45c43af5a07787$var$name = "defaultVertexDeclaration";
const $3d45c43af5a07787$var$shader = `uniform mat4 viewProjection;uniform mat4 view;
#ifdef DIFFUSE
uniform mat4 diffuseMatrix;uniform vec2 vDiffuseInfos;
#endif
#ifdef AMBIENT
uniform mat4 ambientMatrix;uniform vec2 vAmbientInfos;
#endif
#ifdef OPACITY
uniform mat4 opacityMatrix;uniform vec2 vOpacityInfos;
#endif
#ifdef EMISSIVE
uniform vec2 vEmissiveInfos;uniform mat4 emissiveMatrix;
#endif
#ifdef LIGHTMAP
uniform vec2 vLightmapInfos;uniform mat4 lightmapMatrix;
#endif
#if defined(SPECULAR) && defined(SPECULARTERM)
uniform vec2 vSpecularInfos;uniform mat4 specularMatrix;
#endif
#ifdef BUMP
uniform vec3 vBumpInfos;uniform mat4 bumpMatrix;
#endif
#ifdef REFLECTION
uniform mat4 reflectionMatrix;
#endif
#ifdef POINTSIZE
uniform float pointSize;
#endif
#ifdef DETAIL
uniform vec4 vDetailInfos;uniform mat4 detailMatrix;
#endif
#include<decalVertexDeclaration>
#define ADDITIONAL_VERTEX_DECLARATION
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$3d45c43af5a07787$var$name] = $3d45c43af5a07787$var$shader;
const $3d45c43af5a07787$export$fc31011eec8bfe53 = {
    name: $3d45c43af5a07787$var$name,
    shader: $3d45c43af5a07787$var$shader
};

});
parcelRegister("jsAPu", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $e2ad336efd48eba2$var$name = "decalVertexDeclaration";
const $e2ad336efd48eba2$var$shader = `#ifdef DECAL
uniform vec4 vDecalInfos;uniform mat4 decalMatrix;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$e2ad336efd48eba2$var$name] = $e2ad336efd48eba2$var$shader;
const $e2ad336efd48eba2$export$1df775727dc5ccda = {
    name: $e2ad336efd48eba2$var$name,
    shader: $e2ad336efd48eba2$var$shader
};

});


parcelRegister("1ZoxO", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $172e86f68a6d323d$var$name = "uvAttributeDeclaration";
const $172e86f68a6d323d$var$shader = `#ifdef UV{X}
attribute vec2 uv{X};
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$172e86f68a6d323d$var$name] = $172e86f68a6d323d$var$shader;
const $172e86f68a6d323d$export$6414608d9aaf5df = {
    name: $172e86f68a6d323d$var$name,
    shader: $172e86f68a6d323d$var$shader
};

});

parcelRegister("7PW7m", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $5b4a60c90ba31b5f$var$name = "bonesDeclaration";
const $5b4a60c90ba31b5f$var$shader = `#if NUM_BONE_INFLUENCERS>0
attribute vec4 matricesIndices;attribute vec4 matricesWeights;
#if NUM_BONE_INFLUENCERS>4
attribute vec4 matricesIndicesExtra;attribute vec4 matricesWeightsExtra;
#endif
#ifndef BAKED_VERTEX_ANIMATION_TEXTURE
#ifdef BONETEXTURE
uniform highp sampler2D boneSampler;uniform float boneTextureWidth;
#else
uniform mat4 mBones[BonesPerMesh];
#endif
#ifdef BONES_VELOCITY_ENABLED
uniform mat4 mPreviousBones[BonesPerMesh];
#endif
#ifdef BONETEXTURE
#define inline
mat4 readMatrixFromRawSampler(sampler2D smp,float index)
{float offset=index *4.0;float dx=1.0/boneTextureWidth;vec4 m0=texture2D(smp,vec2(dx*(offset+0.5),0.));vec4 m1=texture2D(smp,vec2(dx*(offset+1.5),0.));vec4 m2=texture2D(smp,vec2(dx*(offset+2.5),0.));vec4 m3=texture2D(smp,vec2(dx*(offset+3.5),0.));return mat4(m0,m1,m2,m3);}
#endif
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$5b4a60c90ba31b5f$var$name] = $5b4a60c90ba31b5f$var$shader;
const $5b4a60c90ba31b5f$export$d4e06f9ec8a1a3b9 = {
    name: $5b4a60c90ba31b5f$var$name,
    shader: $5b4a60c90ba31b5f$var$shader
};

});

parcelRegister("8kYMw", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $611f56f6f6f0bece$var$name = "bakedVertexAnimationDeclaration";
const $611f56f6f6f0bece$var$shader = `#ifdef BAKED_VERTEX_ANIMATION_TEXTURE
uniform float bakedVertexAnimationTime;uniform vec2 bakedVertexAnimationTextureSizeInverted;uniform vec4 bakedVertexAnimationSettings;uniform sampler2D bakedVertexAnimationTexture;
#ifdef INSTANCES
attribute vec4 bakedVertexAnimationSettingsInstanced;
#endif
#define inline
mat4 readMatrixFromRawSamplerVAT(sampler2D smp,float index,float frame)
{float offset=index*4.0;float frameUV=(frame+0.5)*bakedVertexAnimationTextureSizeInverted.y;float dx=bakedVertexAnimationTextureSizeInverted.x;vec4 m0=texture2D(smp,vec2(dx*(offset+0.5),frameUV));vec4 m1=texture2D(smp,vec2(dx*(offset+1.5),frameUV));vec4 m2=texture2D(smp,vec2(dx*(offset+2.5),frameUV));vec4 m3=texture2D(smp,vec2(dx*(offset+3.5),frameUV));return mat4(m0,m1,m2,m3);}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$611f56f6f6f0bece$var$name] = $611f56f6f6f0bece$var$shader;
const $611f56f6f6f0bece$export$9942938b957c1c75 = {
    name: $611f56f6f6f0bece$var$name,
    shader: $611f56f6f6f0bece$var$shader
};

});

parcelRegister("k3wwH", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $e99d51826f18505b$var$name = "instancesDeclaration";
const $e99d51826f18505b$var$shader = `#ifdef INSTANCES
attribute vec4 world0;attribute vec4 world1;attribute vec4 world2;attribute vec4 world3;
#ifdef INSTANCESCOLOR
attribute vec4 instanceColor;
#endif
#if defined(THIN_INSTANCES) && !defined(WORLD_UBO)
uniform mat4 world;
#endif
#if defined(VELOCITY) || defined(PREPASS_VELOCITY)
attribute vec4 previousWorld0;attribute vec4 previousWorld1;attribute vec4 previousWorld2;attribute vec4 previousWorld3;
#ifdef THIN_INSTANCES
uniform mat4 previousWorld;
#endif
#endif
#else
#if !defined(WORLD_UBO)
uniform mat4 world;
#endif
#if defined(VELOCITY) || defined(PREPASS_VELOCITY)
uniform mat4 previousWorld;
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$e99d51826f18505b$var$name] = $e99d51826f18505b$var$shader;
const $e99d51826f18505b$export$9b0ca2b8078a529 = {
    name: $e99d51826f18505b$var$name,
    shader: $e99d51826f18505b$var$shader
};

});

parcelRegister("cdubm", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $8e4e1c8037d53585$var$name = "prePassVertexDeclaration";
const $8e4e1c8037d53585$var$shader = `#ifdef PREPASS
#ifdef PREPASS_DEPTH
varying vec3 vViewPos;
#endif
#ifdef PREPASS_VELOCITY
uniform mat4 previousViewProjection;varying vec4 vCurrentPosition;varying vec4 vPreviousPosition;
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$8e4e1c8037d53585$var$name] = $8e4e1c8037d53585$var$shader;
const $8e4e1c8037d53585$export$4ec55bfc69889e15 = {
    name: $8e4e1c8037d53585$var$name,
    shader: $8e4e1c8037d53585$var$shader
};

});

parcelRegister("eiwUK", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $a68c47331f8d8cf4$var$name = "samplerVertexDeclaration";
const $a68c47331f8d8cf4$var$shader = `#if defined(_DEFINENAME_) && _DEFINENAME_DIRECTUV==0
varying vec2 v_VARYINGNAME_UV;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$a68c47331f8d8cf4$var$name] = $a68c47331f8d8cf4$var$shader;
const $a68c47331f8d8cf4$export$6b00e48b18c6bdcf = {
    name: $a68c47331f8d8cf4$var$name,
    shader: $a68c47331f8d8cf4$var$shader
};

});

parcelRegister("hgGYG", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $c92544cce48e2dec$var$name = "bumpVertexDeclaration";
const $c92544cce48e2dec$var$shader = `#if defined(BUMP) || defined(PARALLAX) || defined(CLEARCOAT_BUMP) || defined(ANISOTROPIC)
#if defined(TANGENT) && defined(NORMAL) 
varying mat3 vTBN;
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$c92544cce48e2dec$var$name] = $c92544cce48e2dec$var$shader;
const $c92544cce48e2dec$export$51cb49746cf68044 = {
    name: $c92544cce48e2dec$var$name,
    shader: $c92544cce48e2dec$var$shader
};

});

parcelRegister("4A4MM", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $355e3c8ecba8d2d6$var$name = "clipPlaneVertexDeclaration";
const $355e3c8ecba8d2d6$var$shader = `#ifdef CLIPPLANE
uniform vec4 vClipPlane;varying float fClipDistance;
#endif
#ifdef CLIPPLANE2
uniform vec4 vClipPlane2;varying float fClipDistance2;
#endif
#ifdef CLIPPLANE3
uniform vec4 vClipPlane3;varying float fClipDistance3;
#endif
#ifdef CLIPPLANE4
uniform vec4 vClipPlane4;varying float fClipDistance4;
#endif
#ifdef CLIPPLANE5
uniform vec4 vClipPlane5;varying float fClipDistance5;
#endif
#ifdef CLIPPLANE6
uniform vec4 vClipPlane6;varying float fClipDistance6;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$355e3c8ecba8d2d6$var$name] = $355e3c8ecba8d2d6$var$shader;
const $355e3c8ecba8d2d6$export$61ce3e39b95f6070 = {
    name: $355e3c8ecba8d2d6$var$name,
    shader: $355e3c8ecba8d2d6$var$shader
};

});

parcelRegister("bdABV", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $82ad4ebfc53513dc$var$name = "fogVertexDeclaration";
const $82ad4ebfc53513dc$var$shader = `#ifdef FOG
varying vec3 vFogDistance;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$82ad4ebfc53513dc$var$name] = $82ad4ebfc53513dc$var$shader;
const $82ad4ebfc53513dc$export$a192dee6a001eb2d = {
    name: $82ad4ebfc53513dc$var$name,
    shader: $82ad4ebfc53513dc$var$shader
};

});

parcelRegister("1yLBX", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $122de601600398fe$var$name = "lightVxFragmentDeclaration";
const $122de601600398fe$var$shader = `#ifdef LIGHT{X}
uniform vec4 vLightData{X};uniform vec4 vLightDiffuse{X};
#ifdef SPECULARTERM
uniform vec4 vLightSpecular{X};
#else
vec4 vLightSpecular{X}=vec4(0.);
#endif
#ifdef SHADOW{X}
#ifdef SHADOWCSM{X}
uniform mat4 lightMatrix{X}[SHADOWCSMNUM_CASCADES{X}];varying vec4 vPositionFromLight{X}[SHADOWCSMNUM_CASCADES{X}];varying float vDepthMetric{X}[SHADOWCSMNUM_CASCADES{X}];varying vec4 vPositionFromCamera{X};
#elif defined(SHADOWCUBE{X})
#else
varying vec4 vPositionFromLight{X};varying float vDepthMetric{X};uniform mat4 lightMatrix{X};
#endif
uniform vec4 shadowsInfo{X};uniform vec2 depthValues{X};
#endif
#ifdef SPOTLIGHT{X}
uniform vec4 vLightDirection{X};uniform vec4 vLightFalloff{X};
#elif defined(POINTLIGHT{X})
uniform vec4 vLightFalloff{X};
#elif defined(HEMILIGHT{X})
uniform vec3 vLightGround{X};
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$122de601600398fe$var$name] = $122de601600398fe$var$shader;
const $122de601600398fe$export$40bda2b1eeb332f0 = {
    name: $122de601600398fe$var$name,
    shader: $122de601600398fe$var$shader
};

});

parcelRegister("c0VT2", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $8bf26339340bd8a9$var$name = "lightVxUboDeclaration";
const $8bf26339340bd8a9$var$shader = `#ifdef LIGHT{X}
uniform Light{X}
{vec4 vLightData;vec4 vLightDiffuse;vec4 vLightSpecular;
#ifdef SPOTLIGHT{X}
vec4 vLightDirection;vec4 vLightFalloff;
#elif defined(POINTLIGHT{X})
vec4 vLightFalloff;
#elif defined(HEMILIGHT{X})
vec3 vLightGround;
#endif
vec4 shadowsInfo;vec2 depthValues;} light{X};
#ifdef SHADOW{X}
#ifdef SHADOWCSM{X}
uniform mat4 lightMatrix{X}[SHADOWCSMNUM_CASCADES{X}];varying vec4 vPositionFromLight{X}[SHADOWCSMNUM_CASCADES{X}];varying float vDepthMetric{X}[SHADOWCSMNUM_CASCADES{X}];varying vec4 vPositionFromCamera{X};
#elif defined(SHADOWCUBE{X})
#else
varying vec4 vPositionFromLight{X};varying float vDepthMetric{X};uniform mat4 lightMatrix{X};
#endif
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$8bf26339340bd8a9$var$name] = $8bf26339340bd8a9$var$shader;
const $8bf26339340bd8a9$export$6083bacb6a93516e = {
    name: $8bf26339340bd8a9$var$name,
    shader: $8bf26339340bd8a9$var$shader
};

});

parcelRegister("5Eb4I", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $41c9477483c07583$var$name = "morphTargetsVertexGlobalDeclaration";
const $41c9477483c07583$var$shader = `#ifdef MORPHTARGETS
uniform float morphTargetInfluences[NUM_MORPH_INFLUENCERS];
#ifdef MORPHTARGETS_TEXTURE 
uniform float morphTargetTextureIndices[NUM_MORPH_INFLUENCERS];uniform vec3 morphTargetTextureInfo;uniform highp sampler2DArray morphTargets;vec3 readVector3FromRawSampler(int targetIndex,float vertexIndex)
{ 
float y=floor(vertexIndex/morphTargetTextureInfo.y);float x=vertexIndex-y*morphTargetTextureInfo.y;vec3 textureUV=vec3((x+0.5)/morphTargetTextureInfo.y,(y+0.5)/morphTargetTextureInfo.z,morphTargetTextureIndices[targetIndex]);return texture(morphTargets,textureUV).xyz;}
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$41c9477483c07583$var$name] = $41c9477483c07583$var$shader;
const $41c9477483c07583$export$d8c22cd8cb3e4149 = {
    name: $41c9477483c07583$var$name,
    shader: $41c9477483c07583$var$shader
};

});

parcelRegister("9H5jp", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $70ec40154a05b269$var$name = "morphTargetsVertexDeclaration";
const $70ec40154a05b269$var$shader = `#ifdef MORPHTARGETS
#ifndef MORPHTARGETS_TEXTURE
attribute vec3 position{X};
#ifdef MORPHTARGETS_NORMAL
attribute vec3 normal{X};
#endif
#ifdef MORPHTARGETS_TANGENT
attribute vec3 tangent{X};
#endif
#ifdef MORPHTARGETS_UV
attribute vec2 uv_{X};
#endif
#elif {X}==0
uniform int morphTargetCount;
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$70ec40154a05b269$var$name] = $70ec40154a05b269$var$shader;
const $70ec40154a05b269$export$695a00cfa0b745dc = {
    name: $70ec40154a05b269$var$name,
    shader: $70ec40154a05b269$var$shader
};

});

parcelRegister("9ulLS", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $6e87cdb772071107$var$name = "morphTargetsVertexGlobal";
const $6e87cdb772071107$var$shader = `#ifdef MORPHTARGETS
#ifdef MORPHTARGETS_TEXTURE
float vertexID;
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$6e87cdb772071107$var$name] = $6e87cdb772071107$var$shader;
const $6e87cdb772071107$export$f1ab5e2472bd1f4 = {
    name: $6e87cdb772071107$var$name,
    shader: $6e87cdb772071107$var$shader
};

});

parcelRegister("LFrAO", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $08f489d34029abd4$var$name = "morphTargetsVertex";
const $08f489d34029abd4$var$shader = `#ifdef MORPHTARGETS
#ifdef MORPHTARGETS_TEXTURE
#if {X}==0
for (int i=0; i<NUM_MORPH_INFLUENCERS; i++) {if (i>=morphTargetCount) break;vertexID=float(gl_VertexID)*morphTargetTextureInfo.x;positionUpdated+=(readVector3FromRawSampler(i,vertexID)-position)*morphTargetInfluences[i];vertexID+=1.0;
#ifdef MORPHTARGETS_NORMAL
normalUpdated+=(readVector3FromRawSampler(i,vertexID) -normal)*morphTargetInfluences[i];vertexID+=1.0;
#endif
#ifdef MORPHTARGETS_UV
uvUpdated+=(readVector3FromRawSampler(i,vertexID).xy-uv)*morphTargetInfluences[i];vertexID+=1.0;
#endif
#ifdef MORPHTARGETS_TANGENT
tangentUpdated.xyz+=(readVector3FromRawSampler(i,vertexID) -tangent.xyz)*morphTargetInfluences[i];
#endif
}
#endif
#else
positionUpdated+=(position{X}-position)*morphTargetInfluences[{X}];
#ifdef MORPHTARGETS_NORMAL
normalUpdated+=(normal{X}-normal)*morphTargetInfluences[{X}];
#endif
#ifdef MORPHTARGETS_TANGENT
tangentUpdated.xyz+=(tangent{X}-tangent.xyz)*morphTargetInfluences[{X}];
#endif
#ifdef MORPHTARGETS_UV
uvUpdated+=(uv_{X}-uv)*morphTargetInfluences[{X}];
#endif
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$08f489d34029abd4$var$name] = $08f489d34029abd4$var$shader;
const $08f489d34029abd4$export$b897b5fdf807d651 = {
    name: $08f489d34029abd4$var$name,
    shader: $08f489d34029abd4$var$shader
};

});

parcelRegister("apKdp", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $7950168e67292231$var$name = "instancesVertex";
const $7950168e67292231$var$shader = `#ifdef INSTANCES
mat4 finalWorld=mat4(world0,world1,world2,world3);
#if defined(PREPASS_VELOCITY) || defined(VELOCITY)
mat4 finalPreviousWorld=mat4(previousWorld0,previousWorld1,previousWorld2,previousWorld3);
#endif
#ifdef THIN_INSTANCES
finalWorld=world*finalWorld;
#if defined(PREPASS_VELOCITY) || defined(VELOCITY)
finalPreviousWorld=previousWorld*finalPreviousWorld;
#endif
#endif
#else
mat4 finalWorld=world;
#if defined(PREPASS_VELOCITY) || defined(VELOCITY)
mat4 finalPreviousWorld=previousWorld;
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$7950168e67292231$var$name] = $7950168e67292231$var$shader;
const $7950168e67292231$export$306861c24aa7eac7 = {
    name: $7950168e67292231$var$name,
    shader: $7950168e67292231$var$shader
};

});

parcelRegister("4idCt", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $320368658d08a66f$var$name = "bonesVertex";
const $320368658d08a66f$var$shader = `#ifndef BAKED_VERTEX_ANIMATION_TEXTURE
#if NUM_BONE_INFLUENCERS>0
mat4 influence;
#ifdef BONETEXTURE
influence=readMatrixFromRawSampler(boneSampler,matricesIndices[0])*matricesWeights[0];
#if NUM_BONE_INFLUENCERS>1
influence+=readMatrixFromRawSampler(boneSampler,matricesIndices[1])*matricesWeights[1];
#endif
#if NUM_BONE_INFLUENCERS>2
influence+=readMatrixFromRawSampler(boneSampler,matricesIndices[2])*matricesWeights[2];
#endif
#if NUM_BONE_INFLUENCERS>3
influence+=readMatrixFromRawSampler(boneSampler,matricesIndices[3])*matricesWeights[3];
#endif
#if NUM_BONE_INFLUENCERS>4
influence+=readMatrixFromRawSampler(boneSampler,matricesIndicesExtra[0])*matricesWeightsExtra[0];
#endif
#if NUM_BONE_INFLUENCERS>5
influence+=readMatrixFromRawSampler(boneSampler,matricesIndicesExtra[1])*matricesWeightsExtra[1];
#endif
#if NUM_BONE_INFLUENCERS>6
influence+=readMatrixFromRawSampler(boneSampler,matricesIndicesExtra[2])*matricesWeightsExtra[2];
#endif
#if NUM_BONE_INFLUENCERS>7
influence+=readMatrixFromRawSampler(boneSampler,matricesIndicesExtra[3])*matricesWeightsExtra[3];
#endif
#else
influence=mBones[int(matricesIndices[0])]*matricesWeights[0];
#if NUM_BONE_INFLUENCERS>1
influence+=mBones[int(matricesIndices[1])]*matricesWeights[1];
#endif
#if NUM_BONE_INFLUENCERS>2
influence+=mBones[int(matricesIndices[2])]*matricesWeights[2];
#endif
#if NUM_BONE_INFLUENCERS>3
influence+=mBones[int(matricesIndices[3])]*matricesWeights[3];
#endif
#if NUM_BONE_INFLUENCERS>4
influence+=mBones[int(matricesIndicesExtra[0])]*matricesWeightsExtra[0];
#endif
#if NUM_BONE_INFLUENCERS>5
influence+=mBones[int(matricesIndicesExtra[1])]*matricesWeightsExtra[1];
#endif
#if NUM_BONE_INFLUENCERS>6
influence+=mBones[int(matricesIndicesExtra[2])]*matricesWeightsExtra[2];
#endif
#if NUM_BONE_INFLUENCERS>7
influence+=mBones[int(matricesIndicesExtra[3])]*matricesWeightsExtra[3];
#endif
#endif
finalWorld=finalWorld*influence;
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$320368658d08a66f$var$name] = $320368658d08a66f$var$shader;
const $320368658d08a66f$export$e7045d19c7a271ba = {
    name: $320368658d08a66f$var$name,
    shader: $320368658d08a66f$var$shader
};

});

parcelRegister("cIweX", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $94229a5aab918704$var$name = "bakedVertexAnimation";
const $94229a5aab918704$var$shader = `#ifdef BAKED_VERTEX_ANIMATION_TEXTURE
{
#ifdef INSTANCES
#define BVASNAME bakedVertexAnimationSettingsInstanced
#else
#define BVASNAME bakedVertexAnimationSettings
#endif
float VATStartFrame=BVASNAME.x;float VATEndFrame=BVASNAME.y;float VATOffsetFrame=BVASNAME.z;float VATSpeed=BVASNAME.w;float totalFrames=VATEndFrame-VATStartFrame+1.0;float time=bakedVertexAnimationTime*VATSpeed/totalFrames;float frameCorrection=time<1.0 ? 0.0 : 1.0;float numOfFrames=totalFrames-frameCorrection;float VATFrameNum=fract(time)*numOfFrames;VATFrameNum=mod(VATFrameNum+VATOffsetFrame,numOfFrames);VATFrameNum=floor(VATFrameNum);VATFrameNum+=VATStartFrame+frameCorrection;mat4 VATInfluence;VATInfluence=readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,matricesIndices[0],VATFrameNum)*matricesWeights[0];
#if NUM_BONE_INFLUENCERS>1
VATInfluence+=readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,matricesIndices[1],VATFrameNum)*matricesWeights[1];
#endif
#if NUM_BONE_INFLUENCERS>2
VATInfluence+=readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,matricesIndices[2],VATFrameNum)*matricesWeights[2];
#endif
#if NUM_BONE_INFLUENCERS>3
VATInfluence+=readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,matricesIndices[3],VATFrameNum)*matricesWeights[3];
#endif
#if NUM_BONE_INFLUENCERS>4
VATInfluence+=readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,matricesIndicesExtra[0],VATFrameNum)*matricesWeightsExtra[0];
#endif
#if NUM_BONE_INFLUENCERS>5
VATInfluence+=readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,matricesIndicesExtra[1],VATFrameNum)*matricesWeightsExtra[1];
#endif
#if NUM_BONE_INFLUENCERS>6
VATInfluence+=readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,matricesIndicesExtra[2],VATFrameNum)*matricesWeightsExtra[2];
#endif
#if NUM_BONE_INFLUENCERS>7
VATInfluence+=readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,matricesIndicesExtra[3],VATFrameNum)*matricesWeightsExtra[3];
#endif
finalWorld=finalWorld*VATInfluence;}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$94229a5aab918704$var$name] = $94229a5aab918704$var$shader;
const $94229a5aab918704$export$ea1166af1e79822a = {
    name: $94229a5aab918704$var$name,
    shader: $94229a5aab918704$var$shader
};

});

parcelRegister("f7nPp", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $b019fe3f67f05961$var$name = "prePassVertex";
const $b019fe3f67f05961$var$shader = `#ifdef PREPASS_DEPTH
vViewPos=(view*worldPos).rgb;
#endif
#if defined(PREPASS_VELOCITY) && defined(BONES_VELOCITY_ENABLED)
vCurrentPosition=viewProjection*worldPos;
#if NUM_BONE_INFLUENCERS>0
mat4 previousInfluence;previousInfluence=mPreviousBones[int(matricesIndices[0])]*matricesWeights[0];
#if NUM_BONE_INFLUENCERS>1
previousInfluence+=mPreviousBones[int(matricesIndices[1])]*matricesWeights[1];
#endif 
#if NUM_BONE_INFLUENCERS>2
previousInfluence+=mPreviousBones[int(matricesIndices[2])]*matricesWeights[2];
#endif 
#if NUM_BONE_INFLUENCERS>3
previousInfluence+=mPreviousBones[int(matricesIndices[3])]*matricesWeights[3];
#endif
#if NUM_BONE_INFLUENCERS>4
previousInfluence+=mPreviousBones[int(matricesIndicesExtra[0])]*matricesWeightsExtra[0];
#endif 
#if NUM_BONE_INFLUENCERS>5
previousInfluence+=mPreviousBones[int(matricesIndicesExtra[1])]*matricesWeightsExtra[1];
#endif 
#if NUM_BONE_INFLUENCERS>6
previousInfluence+=mPreviousBones[int(matricesIndicesExtra[2])]*matricesWeightsExtra[2];
#endif 
#if NUM_BONE_INFLUENCERS>7
previousInfluence+=mPreviousBones[int(matricesIndicesExtra[3])]*matricesWeightsExtra[3];
#endif
vPreviousPosition=previousViewProjection*finalPreviousWorld*previousInfluence*vec4(positionUpdated,1.0);
#else
vPreviousPosition=previousViewProjection*finalPreviousWorld*vec4(positionUpdated,1.0);
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$b019fe3f67f05961$var$name] = $b019fe3f67f05961$var$shader;
const $b019fe3f67f05961$export$66ea9e487dae2e8b = {
    name: $b019fe3f67f05961$var$name,
    shader: $b019fe3f67f05961$var$shader
};

});

parcelRegister("i4Zbf", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $d2980ede809e2f06$var$name = "uvVariableDeclaration";
const $d2980ede809e2f06$var$shader = `#if !defined(UV{X}) && defined(MAINUV{X})
vec2 uv{X}=vec2(0.,0.);
#endif
#ifdef MAINUV{X}
vMainUV{X}=uv{X};
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$d2980ede809e2f06$var$name] = $d2980ede809e2f06$var$shader;
const $d2980ede809e2f06$export$868e2ac23cbabdec = {
    name: $d2980ede809e2f06$var$name,
    shader: $d2980ede809e2f06$var$shader
};

});

parcelRegister("9N2ej", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $720a6b71b0e07637$var$name = "samplerVertexImplementation";
const $720a6b71b0e07637$var$shader = `#if defined(_DEFINENAME_) && _DEFINENAME_DIRECTUV==0
if (v_INFONAME_==0.)
{v_VARYINGNAME_UV=vec2(_MATRIXNAME_Matrix*vec4(uvUpdated,1.0,0.0));}
#ifdef UV2
else if (v_INFONAME_==1.)
{v_VARYINGNAME_UV=vec2(_MATRIXNAME_Matrix*vec4(uv2,1.0,0.0));}
#endif
#ifdef UV3
else if (v_INFONAME_==2.)
{v_VARYINGNAME_UV=vec2(_MATRIXNAME_Matrix*vec4(uv3,1.0,0.0));}
#endif
#ifdef UV4
else if (v_INFONAME_==3.)
{v_VARYINGNAME_UV=vec2(_MATRIXNAME_Matrix*vec4(uv4,1.0,0.0));}
#endif
#ifdef UV5
else if (v_INFONAME_==4.)
{v_VARYINGNAME_UV=vec2(_MATRIXNAME_Matrix*vec4(uv5,1.0,0.0));}
#endif
#ifdef UV6
else if (v_INFONAME_==5.)
{v_VARYINGNAME_UV=vec2(_MATRIXNAME_Matrix*vec4(uv6,1.0,0.0));}
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$720a6b71b0e07637$var$name] = $720a6b71b0e07637$var$shader;
const $720a6b71b0e07637$export$f5166e5920e55738 = {
    name: $720a6b71b0e07637$var$name,
    shader: $720a6b71b0e07637$var$shader
};

});

parcelRegister("4GjUR", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $368a8896fba5b04e$var$name = "bumpVertex";
const $368a8896fba5b04e$var$shader = `#if defined(BUMP) || defined(PARALLAX) || defined(CLEARCOAT_BUMP) || defined(ANISOTROPIC)
#if defined(TANGENT) && defined(NORMAL)
vec3 tbnNormal=normalize(normalUpdated);vec3 tbnTangent=normalize(tangentUpdated.xyz);vec3 tbnBitangent=cross(tbnNormal,tbnTangent)*tangentUpdated.w;vTBN=mat3(finalWorld)*mat3(tbnTangent,tbnBitangent,tbnNormal);
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$368a8896fba5b04e$var$name] = $368a8896fba5b04e$var$shader;
const $368a8896fba5b04e$export$71c60d5bee6037f3 = {
    name: $368a8896fba5b04e$var$name,
    shader: $368a8896fba5b04e$var$shader
};

});

parcelRegister("kqCfW", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $edf3e934e04c583c$var$name = "clipPlaneVertex";
const $edf3e934e04c583c$var$shader = `#ifdef CLIPPLANE
fClipDistance=dot(worldPos,vClipPlane);
#endif
#ifdef CLIPPLANE2
fClipDistance2=dot(worldPos,vClipPlane2);
#endif
#ifdef CLIPPLANE3
fClipDistance3=dot(worldPos,vClipPlane3);
#endif
#ifdef CLIPPLANE4
fClipDistance4=dot(worldPos,vClipPlane4);
#endif
#ifdef CLIPPLANE5
fClipDistance5=dot(worldPos,vClipPlane5);
#endif
#ifdef CLIPPLANE6
fClipDistance6=dot(worldPos,vClipPlane6);
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$edf3e934e04c583c$var$name] = $edf3e934e04c583c$var$shader;
const $edf3e934e04c583c$export$c701d17f7fcd46e7 = {
    name: $edf3e934e04c583c$var$name,
    shader: $edf3e934e04c583c$var$shader
};

});

parcelRegister("1pV7g", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $10846e4e5aac614e$var$name = "fogVertex";
const $10846e4e5aac614e$var$shader = `#ifdef FOG
vFogDistance=(view*worldPos).xyz;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$10846e4e5aac614e$var$name] = $10846e4e5aac614e$var$shader;
const $10846e4e5aac614e$export$e9ea39cff335dceb = {
    name: $10846e4e5aac614e$var$name,
    shader: $10846e4e5aac614e$var$shader
};

});

parcelRegister("5sP5F", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $3fa732ca74cf0e3d$var$name = "shadowsVertex";
const $3fa732ca74cf0e3d$var$shader = `#ifdef SHADOWS
#if defined(SHADOWCSM{X})
vPositionFromCamera{X}=view*worldPos;for (int i=0; i<SHADOWCSMNUM_CASCADES{X}; i++) {vPositionFromLight{X}[i]=lightMatrix{X}[i]*worldPos;
#ifdef USE_REVERSE_DEPTHBUFFER
vDepthMetric{X}[i]=(-vPositionFromLight{X}[i].z+light{X}.depthValues.x)/light{X}.depthValues.y;
#else
vDepthMetric{X}[i]=(vPositionFromLight{X}[i].z+light{X}.depthValues.x)/light{X}.depthValues.y;
#endif
}
#elif defined(SHADOW{X}) && !defined(SHADOWCUBE{X})
vPositionFromLight{X}=lightMatrix{X}*worldPos;
#ifdef USE_REVERSE_DEPTHBUFFER
vDepthMetric{X}=(-vPositionFromLight{X}.z+light{X}.depthValues.x)/light{X}.depthValues.y;
#else
vDepthMetric{X}=(vPositionFromLight{X}.z+light{X}.depthValues.x)/light{X}.depthValues.y;
#endif
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$3fa732ca74cf0e3d$var$name] = $3fa732ca74cf0e3d$var$shader;
const $3fa732ca74cf0e3d$export$c21d1499746c24a1 = {
    name: $3fa732ca74cf0e3d$var$name,
    shader: $3fa732ca74cf0e3d$var$shader
};

});

parcelRegister("jl3r6", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $e142a4cea4626059$var$name = "vertexColorMixing";
const $e142a4cea4626059$var$shader = `#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
vColor=vec4(1.0);
#ifdef VERTEXCOLOR
#ifdef VERTEXALPHA
vColor*=color;
#else
vColor.rgb*=color.rgb;
#endif
#endif
#ifdef INSTANCESCOLOR
vColor*=instanceColor;
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$e142a4cea4626059$var$name] = $e142a4cea4626059$var$shader;
const $e142a4cea4626059$export$6deafe11f2c8fd78 = {
    name: $e142a4cea4626059$var$name,
    shader: $e142a4cea4626059$var$shader
};

});

parcelRegister("2NtPW", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $20974d57ca4b1987$var$name = "pointCloudVertex";
const $20974d57ca4b1987$var$shader = `#if defined(POINTSIZE) && !defined(WEBGPU)
gl_PointSize=pointSize;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$20974d57ca4b1987$var$name] = $20974d57ca4b1987$var$shader;
const $20974d57ca4b1987$export$1987bee044ebe2eb = {
    name: $20974d57ca4b1987$var$name,
    shader: $20974d57ca4b1987$var$shader
};

});

parcelRegister("a111f", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $74aac9c067b83b9c$var$name = "logDepthVertex";
const $74aac9c067b83b9c$var$shader = `#ifdef LOGARITHMICDEPTH
vFragmentDepth=1.0+gl_Position.w;gl_Position.z=log2(max(0.000001,vFragmentDepth))*logarithmicDepthConstant;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$74aac9c067b83b9c$var$name] = $74aac9c067b83b9c$var$shader;
const $74aac9c067b83b9c$export$d165856bf33dc3a5 = {
    name: $74aac9c067b83b9c$var$name,
    shader: $74aac9c067b83b9c$var$shader
};

});


parcelRegister("bRVvK", function(module, exports) {

$parcel$export(module.exports, "MaterialDetailMapDefines", () => $8a41416de02c81e4$export$e59daebb20f46cc8);
$parcel$export(module.exports, "DetailMapConfiguration", () => $8a41416de02c81e4$export$37c50da823378b6e);

var $e0Suo = parcelRequire("e0Suo");

var $54229 = parcelRequire("54229");

var $ir0rz = parcelRequire("ir0rz");

var $2hKx5 = parcelRequire("2hKx5");

var $35xmP = parcelRequire("35xmP");

var $8XNAC = parcelRequire("8XNAC");

var $alPCh = parcelRequire("alPCh");
class $8a41416de02c81e4$export$e59daebb20f46cc8 extends (0, $35xmP.MaterialDefines) {
    constructor(){
        super(...arguments);
        this.DETAIL = false;
        this.DETAILDIRECTUV = 0;
        this.DETAIL_NORMALBLENDMETHOD = 0;
    }
}
class $8a41416de02c81e4$export$37c50da823378b6e extends (0, $8XNAC.MaterialPluginBase) {
    /** @internal */ _markAllSubMeshesAsTexturesDirty() {
        this._enable(this._isEnabled);
        this._internalMarkAllSubMeshesAsTexturesDirty();
    }
    constructor(material, addToPluginList = true){
        super(material, "DetailMap", 140, new $8a41416de02c81e4$export$e59daebb20f46cc8(), addToPluginList);
        this._texture = null;
        /**
         * Defines how strongly the detail diffuse/albedo channel is blended with the regular diffuse/albedo texture
         * Bigger values mean stronger blending
         */ this.diffuseBlendLevel = 1;
        /**
         * Defines how strongly the detail roughness channel is blended with the regular roughness value
         * Bigger values mean stronger blending. Only used with PBR materials
         */ this.roughnessBlendLevel = 1;
        /**
         * Defines how strong the bump effect from the detail map is
         * Bigger values mean stronger effect
         */ this.bumpLevel = 1;
        this._normalBlendMethod = (0, $54229.Material).MATERIAL_NORMALBLENDMETHOD_WHITEOUT;
        this._isEnabled = false;
        /**
         * Enable or disable the detail map on this material
         */ this.isEnabled = false;
        this._internalMarkAllSubMeshesAsTexturesDirty = material._dirtyCallbacks[1];
    }
    isReadyForSubMesh(defines, scene, engine) {
        if (!this._isEnabled) return true;
        if (defines._areTexturesDirty && scene.texturesEnabled) {
            if (engine.getCaps().standardDerivatives && this._texture && (0, $2hKx5.MaterialFlags).DetailTextureEnabled) {
                // Detail texture cannot be not blocking.
                if (!this._texture.isReady()) return false;
            }
        }
        return true;
    }
    prepareDefines(defines, scene) {
        if (this._isEnabled) {
            defines.DETAIL_NORMALBLENDMETHOD = this._normalBlendMethod;
            const engine = scene.getEngine();
            if (defines._areTexturesDirty) {
                if (engine.getCaps().standardDerivatives && this._texture && (0, $2hKx5.MaterialFlags).DetailTextureEnabled && this._isEnabled) {
                    (0, $alPCh.PrepareDefinesForMergedUV)(this._texture, defines, "DETAIL");
                    defines.DETAIL_NORMALBLENDMETHOD = this._normalBlendMethod;
                } else defines.DETAIL = false;
            }
        } else defines.DETAIL = false;
    }
    bindForSubMesh(uniformBuffer, scene) {
        if (!this._isEnabled) return;
        const isFrozen = this._material.isFrozen;
        if (!uniformBuffer.useUbo || !isFrozen || !uniformBuffer.isSync) {
            if (this._texture && (0, $2hKx5.MaterialFlags).DetailTextureEnabled) {
                uniformBuffer.updateFloat4("vDetailInfos", this._texture.coordinatesIndex, this.diffuseBlendLevel, this.bumpLevel, this.roughnessBlendLevel);
                (0, $alPCh.BindTextureMatrix)(this._texture, uniformBuffer, "detail");
            }
        }
        // Textures
        if (scene.texturesEnabled) {
            if (this._texture && (0, $2hKx5.MaterialFlags).DetailTextureEnabled) uniformBuffer.setTexture("detailSampler", this._texture);
        }
    }
    hasTexture(texture) {
        if (this._texture === texture) return true;
        return false;
    }
    getActiveTextures(activeTextures) {
        if (this._texture) activeTextures.push(this._texture);
    }
    getAnimatables(animatables) {
        if (this._texture && this._texture.animations && this._texture.animations.length > 0) animatables.push(this._texture);
    }
    dispose(forceDisposeTextures) {
        if (forceDisposeTextures) this._texture?.dispose();
    }
    getClassName() {
        return "DetailMapConfiguration";
    }
    getSamplers(samplers) {
        samplers.push("detailSampler");
    }
    getUniforms() {
        return {
            ubo: [
                {
                    name: "vDetailInfos",
                    size: 4,
                    type: "vec4"
                },
                {
                    name: "detailMatrix",
                    size: 16,
                    type: "mat4"
                }
            ]
        };
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)("detailTexture"),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $8a41416de02c81e4$export$37c50da823378b6e.prototype, "texture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $8a41416de02c81e4$export$37c50da823378b6e.prototype, "diffuseBlendLevel", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $8a41416de02c81e4$export$37c50da823378b6e.prototype, "roughnessBlendLevel", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $8a41416de02c81e4$export$37c50da823378b6e.prototype, "bumpLevel", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $8a41416de02c81e4$export$37c50da823378b6e.prototype, "normalBlendMethod", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $8a41416de02c81e4$export$37c50da823378b6e.prototype, "isEnabled", void 0);

});
parcelRegister("8XNAC", function(module, exports) {

$parcel$export(module.exports, "MaterialPluginBase", () => $686a4ce3c70ae4d4$export$2e779f428b78d16a);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $hvV64 = parcelRequire("hvV64");

var $6Ho1L = parcelRequire("6Ho1L");
class $686a4ce3c70ae4d4$export$2e779f428b78d16a {
    _enable(enable) {
        if (enable) this._pluginManager._activatePlugin(this);
    }
    /**
     * Creates a new material plugin
     * @param material parent material of the plugin
     * @param name name of the plugin
     * @param priority priority of the plugin
     * @param defines list of defines used by the plugin. The value of the property is the default value for this property
     * @param addToPluginList true to add the plugin to the list of plugins managed by the material plugin manager of the material (default: true)
     * @param enable true to enable the plugin (it is handy if the plugin does not handle properties to switch its current activation)
     * @param resolveIncludes Indicates that any #include directive in the plugin code must be replaced by the corresponding code (default: false)
     */ constructor(material, name, priority, defines, addToPluginList = true, enable = false, resolveIncludes = false){
        /**
         * Defines the priority of the plugin. Lower numbers run first.
         */ this.priority = 500;
        /**
         * Indicates that any #include directive in the plugin code must be replaced by the corresponding code.
         */ this.resolveIncludes = false;
        /**
         * Indicates that this plugin should be notified for the extra events (HasRenderTargetTextures / FillRenderTargetTextures / HardBindForSubMesh)
         */ this.registerForExtraEvents = false;
        this._material = material;
        this.name = name;
        this.priority = priority;
        this.resolveIncludes = resolveIncludes;
        if (!material.pluginManager) {
            material.pluginManager = new (0, $hvV64.MaterialPluginManager)(material);
            material.onDisposeObservable.add(()=>{
                material.pluginManager = undefined;
            });
        }
        this._pluginDefineNames = defines;
        this._pluginManager = material.pluginManager;
        if (addToPluginList) this._pluginManager._addPlugin(this);
        if (enable) this._enable(true);
        this.markAllDefinesAsDirty = material._dirtyCallbacks[63];
    }
    /**
     * Gets the current class name useful for serialization or dynamic coding.
     * @returns The class name.
     */ getClassName() {
        return "MaterialPluginBase";
    }
    /**
     * Specifies that the submesh is ready to be used.
     * @param defines the list of "defines" to update.
     * @param scene defines the scene the material belongs to.
     * @param engine the engine this scene belongs to.
     * @param subMesh the submesh to check for readiness
     * @returns - boolean indicating that the submesh is ready or not.
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isReadyForSubMesh(defines, scene, engine, subMesh) {
        return true;
    }
    /**
     * Binds the material data (this function is called even if mustRebind() returns false)
     * @param uniformBuffer defines the Uniform buffer to fill in.
     * @param scene defines the scene the material belongs to.
     * @param engine defines the engine the material belongs to.
     * @param subMesh the submesh to bind data for
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    hardBindForSubMesh(uniformBuffer, scene, engine, subMesh) {}
    /**
     * Binds the material data.
     * @param uniformBuffer defines the Uniform buffer to fill in.
     * @param scene defines the scene the material belongs to.
     * @param engine the engine this scene belongs to.
     * @param subMesh the submesh to bind data for
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    bindForSubMesh(uniformBuffer, scene, engine, subMesh) {}
    /**
     * Disposes the resources of the material.
     * @param forceDisposeTextures - Forces the disposal of all textures.
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    dispose(forceDisposeTextures) {}
    /**
     * Returns a list of custom shader code fragments to customize the shader.
     * @param shaderType "vertex" or "fragment"
     * @returns null if no code to be added, or a list of pointName =\> code.
     * Note that `pointName` can also be a regular expression if it starts with a `!`.
     * In that case, the string found by the regular expression (if any) will be
     * replaced by the code provided.
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getCustomCode(shaderType) {
        return null;
    }
    /**
     * Collects all defines.
     * @param defines The object to append to.
     */ collectDefines(defines) {
        if (!this._pluginDefineNames) return;
        for (const key of Object.keys(this._pluginDefineNames)){
            if (key[0] === "_") continue;
            const type = typeof this._pluginDefineNames[key];
            defines[key] = {
                type: type === "number" ? "number" : type === "string" ? "string" : type === "boolean" ? "boolean" : "object",
                default: this._pluginDefineNames[key]
            };
        }
    }
    /**
     * Sets the defines for the next rendering. Called before PrepareDefinesForAttributes is called.
     * @param defines the list of "defines" to update.
     * @param scene defines the scene to the material belongs to.
     * @param mesh the mesh being rendered
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    prepareDefinesBeforeAttributes(defines, scene, mesh) {}
    /**
     * Sets the defines for the next rendering
     * @param defines the list of "defines" to update.
     * @param scene defines the scene to the material belongs to.
     * @param mesh the mesh being rendered
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    prepareDefines(defines, scene, mesh) {}
    /**
     * Checks to see if a texture is used in the material.
     * @param texture - Base texture to use.
     * @returns - Boolean specifying if a texture is used in the material.
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    hasTexture(texture) {
        return false;
    }
    /**
     * Gets a boolean indicating that current material needs to register RTT
     * @returns true if this uses a render target otherwise false.
     */ hasRenderTargetTextures() {
        return false;
    }
    /**
     * Fills the list of render target textures.
     * @param renderTargets the list of render targets to update
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    fillRenderTargetTextures(renderTargets) {}
    /**
     * Returns an array of the actively used textures.
     * @param activeTextures Array of BaseTextures
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getActiveTextures(activeTextures) {}
    /**
     * Returns the animatable textures.
     * @param animatables Array of animatable textures.
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getAnimatables(animatables) {}
    /**
     * Add fallbacks to the effect fallbacks list.
     * @param defines defines the Base texture to use.
     * @param fallbacks defines the current fallback list.
     * @param currentRank defines the current fallback rank.
     * @returns the new fallback rank.
     */ addFallbacks(defines, fallbacks, currentRank) {
        return currentRank;
    }
    /**
     * Gets the samplers used by the plugin.
     * @param samplers list that the sampler names should be added to.
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getSamplers(samplers) {}
    /**
     * Gets the attributes used by the plugin.
     * @param attributes list that the attribute names should be added to.
     * @param scene the scene that the material belongs to.
     * @param mesh the mesh being rendered.
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getAttributes(attributes, scene, mesh) {}
    /**
     * Gets the uniform buffers names added by the plugin.
     * @param ubos list that the ubo names should be added to.
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getUniformBuffersNames(ubos) {}
    /**
     * Gets the description of the uniforms to add to the ubo (if engine supports ubos) or to inject directly in the vertex/fragment shaders (if engine does not support ubos)
     * @returns the description of the uniforms
     */ getUniforms() {
        return {};
    }
    /**
     * Makes a duplicate of the current configuration into another one.
     * @param plugin define the config where to copy the info
     */ copyTo(plugin) {
        (0, $6Ho1L.SerializationHelper).Clone(()=>plugin, this);
    }
    /**
     * Serializes this plugin configuration.
     * @returns - An object with the serialized config.
     */ serialize() {
        return (0, $6Ho1L.SerializationHelper).Serialize(this);
    }
    /**
     * Parses a plugin configuration from a serialized object.
     * @param source - Serialized object.
     * @param scene Defines the scene we are parsing for
     * @param rootUrl Defines the rootUrl to load from
     */ parse(source, scene, rootUrl) {
        (0, $6Ho1L.SerializationHelper).Parse(()=>this, source, scene, rootUrl);
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $686a4ce3c70ae4d4$export$2e779f428b78d16a.prototype, "name", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $686a4ce3c70ae4d4$export$2e779f428b78d16a.prototype, "priority", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $686a4ce3c70ae4d4$export$2e779f428b78d16a.prototype, "resolveIncludes", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $686a4ce3c70ae4d4$export$2e779f428b78d16a.prototype, "registerForExtraEvents", void 0);

});
parcelRegister("hvV64", function(module, exports) {

$parcel$export(module.exports, "MaterialPluginManager", () => $cc019f276676254c$export$cfed4346ad531eca);
$parcel$export(module.exports, "UnregisterAllMaterialPlugins", () => $cc019f276676254c$export$6f779d17b215c2fa);
$parcel$export(module.exports, "RegisterMaterialPlugin", () => $cc019f276676254c$export$787415a59e199b09);
$parcel$export(module.exports, "UnregisterMaterialPlugin", () => $cc019f276676254c$export$c603bda0a41a9e24);

var $54229 = parcelRequire("54229");

var $7HBDq = parcelRequire("7HBDq");

var $ejQPp = parcelRequire("ejQPp");

var $kbQ0z = parcelRequire("kbQ0z");

var $8WI3I = parcelRequire("8WI3I");

var $68BIi = parcelRequire("68BIi");
const $cc019f276676254c$var$rxOption = new RegExp("^([gimus]+)!");
class $cc019f276676254c$export$cfed4346ad531eca {
    /**
     * Creates a new instance of the plugin manager
     * @param material material that this manager will manage the plugins for
     */ constructor(material){
        /** @internal */ this._plugins = [];
        this._activePlugins = [];
        this._activePluginsForExtraEvents = [];
        this._material = material;
        this._scene = material.getScene();
        this._engine = this._scene.getEngine();
    }
    /**
     * @internal
     */ _addPlugin(plugin) {
        for(let i = 0; i < this._plugins.length; ++i){
            if (this._plugins[i].name === plugin.name) return false;
        }
        if (this._material._uniformBufferLayoutBuilt) // eslint-disable-next-line no-throw-literal
        throw `The plugin "${plugin.name}" can't be added to the material "${this._material.name}" because this material has already been used for rendering! Please add plugins to materials before any rendering with this material occurs.`;
        const pluginClassName = plugin.getClassName();
        if (!$cc019f276676254c$export$cfed4346ad531eca._MaterialPluginClassToMainDefine[pluginClassName]) $cc019f276676254c$export$cfed4346ad531eca._MaterialPluginClassToMainDefine[pluginClassName] = "MATERIALPLUGIN_" + ++$cc019f276676254c$export$cfed4346ad531eca._MaterialPluginCounter;
        this._material._callbackPluginEventGeneric = (id, info)=>this._handlePluginEvent(id, info);
        this._plugins.push(plugin);
        this._plugins.sort((a, b)=>a.priority - b.priority);
        this._codeInjectionPoints = {};
        const defineNamesFromPlugins = {};
        defineNamesFromPlugins[$cc019f276676254c$export$cfed4346ad531eca._MaterialPluginClassToMainDefine[pluginClassName]] = {
            type: "boolean",
            default: true
        };
        for (const plugin of this._plugins){
            plugin.collectDefines(defineNamesFromPlugins);
            this._collectPointNames("vertex", plugin.getCustomCode("vertex"));
            this._collectPointNames("fragment", plugin.getCustomCode("fragment"));
        }
        this._defineNamesFromPlugins = defineNamesFromPlugins;
        return true;
    }
    /**
     * @internal
     */ _activatePlugin(plugin) {
        if (this._activePlugins.indexOf(plugin) === -1) {
            this._activePlugins.push(plugin);
            this._activePlugins.sort((a, b)=>a.priority - b.priority);
            this._material._callbackPluginEventIsReadyForSubMesh = this._handlePluginEventIsReadyForSubMesh.bind(this);
            this._material._callbackPluginEventPrepareDefinesBeforeAttributes = this._handlePluginEventPrepareDefinesBeforeAttributes.bind(this);
            this._material._callbackPluginEventPrepareDefines = this._handlePluginEventPrepareDefines.bind(this);
            this._material._callbackPluginEventBindForSubMesh = this._handlePluginEventBindForSubMesh.bind(this);
            if (plugin.registerForExtraEvents) {
                this._activePluginsForExtraEvents.push(plugin);
                this._activePluginsForExtraEvents.sort((a, b)=>a.priority - b.priority);
                this._material._callbackPluginEventHasRenderTargetTextures = this._handlePluginEventHasRenderTargetTextures.bind(this);
                this._material._callbackPluginEventFillRenderTargetTextures = this._handlePluginEventFillRenderTargetTextures.bind(this);
                this._material._callbackPluginEventHardBindForSubMesh = this._handlePluginEventHardBindForSubMesh.bind(this);
            }
        }
    }
    /**
     * Gets a plugin from the list of plugins managed by this manager
     * @param name name of the plugin
     * @returns the plugin if found, else null
     */ getPlugin(name) {
        for(let i = 0; i < this._plugins.length; ++i){
            if (this._plugins[i].name === name) return this._plugins[i];
        }
        return null;
    }
    _handlePluginEventIsReadyForSubMesh(eventData) {
        let isReady = true;
        for (const plugin of this._activePlugins)isReady = isReady && plugin.isReadyForSubMesh(eventData.defines, this._scene, this._engine, eventData.subMesh);
        eventData.isReadyForSubMesh = isReady;
    }
    _handlePluginEventPrepareDefinesBeforeAttributes(eventData) {
        for (const plugin of this._activePlugins)plugin.prepareDefinesBeforeAttributes(eventData.defines, this._scene, eventData.mesh);
    }
    _handlePluginEventPrepareDefines(eventData) {
        for (const plugin of this._activePlugins)plugin.prepareDefines(eventData.defines, this._scene, eventData.mesh);
    }
    _handlePluginEventHardBindForSubMesh(eventData) {
        for (const plugin of this._activePluginsForExtraEvents)plugin.hardBindForSubMesh(this._material._uniformBuffer, this._scene, this._engine, eventData.subMesh);
    }
    _handlePluginEventBindForSubMesh(eventData) {
        for (const plugin of this._activePlugins)plugin.bindForSubMesh(this._material._uniformBuffer, this._scene, this._engine, eventData.subMesh);
    }
    _handlePluginEventHasRenderTargetTextures(eventData) {
        let hasRenderTargetTextures = false;
        for (const plugin of this._activePluginsForExtraEvents){
            hasRenderTargetTextures = plugin.hasRenderTargetTextures();
            if (hasRenderTargetTextures) break;
        }
        eventData.hasRenderTargetTextures = hasRenderTargetTextures;
    }
    _handlePluginEventFillRenderTargetTextures(eventData) {
        for (const plugin of this._activePluginsForExtraEvents)plugin.fillRenderTargetTextures(eventData.renderTargets);
    }
    _handlePluginEvent(id, info) {
        switch(id){
            case (0, $7HBDq.MaterialPluginEvent).GetActiveTextures:
                {
                    const eventData = info;
                    for (const plugin of this._activePlugins)plugin.getActiveTextures(eventData.activeTextures);
                    break;
                }
            case (0, $7HBDq.MaterialPluginEvent).GetAnimatables:
                {
                    const eventData = info;
                    for (const plugin of this._activePlugins)plugin.getAnimatables(eventData.animatables);
                    break;
                }
            case (0, $7HBDq.MaterialPluginEvent).HasTexture:
                {
                    const eventData = info;
                    let hasTexture = false;
                    for (const plugin of this._activePlugins){
                        hasTexture = plugin.hasTexture(eventData.texture);
                        if (hasTexture) break;
                    }
                    eventData.hasTexture = hasTexture;
                    break;
                }
            case (0, $7HBDq.MaterialPluginEvent).Disposed:
                {
                    const eventData = info;
                    for (const plugin of this._plugins)plugin.dispose(eventData.forceDisposeTextures);
                    break;
                }
            case (0, $7HBDq.MaterialPluginEvent).GetDefineNames:
                {
                    const eventData = info;
                    eventData.defineNames = this._defineNamesFromPlugins;
                    break;
                }
            case (0, $7HBDq.MaterialPluginEvent).PrepareEffect:
                {
                    const eventData = info;
                    for (const plugin of this._activePlugins){
                        eventData.fallbackRank = plugin.addFallbacks(eventData.defines, eventData.fallbacks, eventData.fallbackRank);
                        plugin.getAttributes(eventData.attributes, this._scene, eventData.mesh);
                    }
                    if (this._uniformList.length > 0) eventData.uniforms.push(...this._uniformList);
                    if (this._samplerList.length > 0) eventData.samplers.push(...this._samplerList);
                    if (this._uboList.length > 0) eventData.uniformBuffersNames.push(...this._uboList);
                    eventData.customCode = this._injectCustomCode(eventData, eventData.customCode);
                    break;
                }
            case (0, $7HBDq.MaterialPluginEvent).PrepareUniformBuffer:
                {
                    const eventData = info;
                    this._uboDeclaration = "";
                    this._vertexDeclaration = "";
                    this._fragmentDeclaration = "";
                    this._uniformList = [];
                    this._samplerList = [];
                    this._uboList = [];
                    for (const plugin of this._plugins){
                        const uniforms = plugin.getUniforms();
                        if (uniforms) {
                            if (uniforms.ubo) for (const uniform of uniforms.ubo){
                                if (uniform.size && uniform.type) {
                                    const arraySize = uniform.arraySize ?? 0;
                                    eventData.ubo.addUniform(uniform.name, uniform.size, arraySize);
                                    this._uboDeclaration += `${uniform.type} ${uniform.name}${arraySize > 0 ? `[${arraySize}]` : ""};\n`;
                                }
                                this._uniformList.push(uniform.name);
                            }
                            if (uniforms.vertex) this._vertexDeclaration += uniforms.vertex + "\n";
                            if (uniforms.fragment) this._fragmentDeclaration += uniforms.fragment + "\n";
                        }
                        plugin.getSamplers(this._samplerList);
                        plugin.getUniformBuffersNames(this._uboList);
                    }
                    break;
                }
        }
    }
    _collectPointNames(shaderType, customCode) {
        if (!customCode) return;
        for(const pointName in customCode){
            if (!this._codeInjectionPoints[shaderType]) this._codeInjectionPoints[shaderType] = {};
            this._codeInjectionPoints[shaderType][pointName] = true;
        }
    }
    _injectCustomCode(eventData, existingCallback) {
        return (shaderType, code)=>{
            if (existingCallback) code = existingCallback(shaderType, code);
            if (this._uboDeclaration) code = code.replace("#define ADDITIONAL_UBO_DECLARATION", this._uboDeclaration);
            if (this._vertexDeclaration) code = code.replace("#define ADDITIONAL_VERTEX_DECLARATION", this._vertexDeclaration);
            if (this._fragmentDeclaration) code = code.replace("#define ADDITIONAL_FRAGMENT_DECLARATION", this._fragmentDeclaration);
            const points = this._codeInjectionPoints?.[shaderType];
            if (!points) return code;
            let processorOptions = null;
            for(let pointName in points){
                let injectedCode = "";
                for (const plugin of this._activePlugins){
                    let customCode = plugin.getCustomCode(shaderType)?.[pointName];
                    if (!customCode) continue;
                    if (plugin.resolveIncludes) {
                        if (processorOptions === null) {
                            const shaderLanguage = (0, $8WI3I.ShaderLanguage).GLSL;
                            processorOptions = {
                                defines: [],
                                indexParameters: eventData.indexParameters,
                                isFragment: false,
                                shouldUseHighPrecisionShader: this._engine._shouldUseHighPrecisionShader,
                                processor: undefined,
                                supportsUniformBuffers: this._engine.supportsUniformBuffers,
                                shadersRepository: (0, $68BIi.ShaderStore).GetShadersRepository(shaderLanguage),
                                includesShadersStore: (0, $68BIi.ShaderStore).GetIncludesShadersStore(shaderLanguage),
                                version: undefined,
                                platformName: this._engine.shaderPlatformName,
                                processingContext: undefined,
                                isNDCHalfZRange: this._engine.isNDCHalfZRange,
                                useReverseDepthBuffer: this._engine.useReverseDepthBuffer,
                                processCodeAfterIncludes: undefined
                            };
                        }
                        processorOptions.isFragment = shaderType === "fragment";
                        (0, $kbQ0z.ShaderProcessor)._ProcessIncludes(customCode, processorOptions, (code)=>customCode = code);
                    }
                    injectedCode += customCode + "\n";
                }
                if (injectedCode.length > 0) {
                    if (pointName.charAt(0) === "!") {
                        // pointName is a regular expression
                        pointName = pointName.substring(1);
                        let regexFlags = "g";
                        if (pointName.charAt(0) === "!") {
                            // no flags
                            regexFlags = "";
                            pointName = pointName.substring(1);
                        } else {
                            // get the flag(s)
                            const matchOption = $cc019f276676254c$var$rxOption.exec(pointName);
                            if (matchOption && matchOption.length >= 2) {
                                regexFlags = matchOption[1];
                                pointName = pointName.substring(regexFlags.length + 1);
                            }
                        }
                        if (regexFlags.indexOf("g") < 0) // we force the "g" flag so that the regexp object is stateful!
                        regexFlags += "g";
                        const sourceCode = code;
                        const rx = new RegExp(pointName, regexFlags);
                        let match = rx.exec(sourceCode);
                        while(match !== null){
                            let newCode = injectedCode;
                            for(let i = 0; i < match.length; ++i)newCode = newCode.replace("$" + i, match[i]);
                            code = code.replace(match[0], newCode);
                            match = rx.exec(sourceCode);
                        }
                    } else {
                        const fullPointName = "#define " + pointName;
                        code = code.replace(fullPointName, "\n" + injectedCode + "\n" + fullPointName);
                    }
                }
            }
            return code;
        };
    }
}
/** Map a plugin class name to a #define name (used in the vertex/fragment shaders as a marker of the plugin usage) */ $cc019f276676254c$export$cfed4346ad531eca._MaterialPluginClassToMainDefine = {};
$cc019f276676254c$export$cfed4346ad531eca._MaterialPluginCounter = 0;
(()=>{
    (0, $ejQPp.EngineStore).OnEnginesDisposedObservable.add(()=>{
        $cc019f276676254c$export$6f779d17b215c2fa();
    });
})();
const $cc019f276676254c$var$plugins = [];
let $cc019f276676254c$var$inited = false;
let $cc019f276676254c$var$observer = null;
function $cc019f276676254c$export$787415a59e199b09(pluginName, factory) {
    if (!$cc019f276676254c$var$inited) {
        $cc019f276676254c$var$observer = (0, $54229.Material).OnEventObservable.add((material)=>{
            for (const [, factory] of $cc019f276676254c$var$plugins)factory(material);
        }, (0, $7HBDq.MaterialPluginEvent).Created);
        $cc019f276676254c$var$inited = true;
    }
    const existing = $cc019f276676254c$var$plugins.filter(([name, _factory])=>name === pluginName);
    if (existing.length > 0) existing[0][1] = factory;
    else $cc019f276676254c$var$plugins.push([
        pluginName,
        factory
    ]);
}
function $cc019f276676254c$export$c603bda0a41a9e24(pluginName) {
    for(let i = 0; i < $cc019f276676254c$var$plugins.length; ++i)if ($cc019f276676254c$var$plugins[i][0] === pluginName) {
        $cc019f276676254c$var$plugins.splice(i, 1);
        if ($cc019f276676254c$var$plugins.length === 0) $cc019f276676254c$export$6f779d17b215c2fa();
        return true;
    }
    return false;
}
function $cc019f276676254c$export$6f779d17b215c2fa() {
    $cc019f276676254c$var$plugins.length = 0;
    $cc019f276676254c$var$inited = false;
    (0, $54229.Material).OnEventObservable.remove($cc019f276676254c$var$observer);
    $cc019f276676254c$var$observer = null;
}

});




parcelRegister("fJfwX", function(module, exports) {

$parcel$export(module.exports, "DynamicTexture", () => $b7371b076ec25b92$export$da80c28953472f54);

var $kVtWi = parcelRequire("kVtWi");

var $j2mX5 = parcelRequire("j2mX5");
parcelRequire("2yVdu");
class $b7371b076ec25b92$export$da80c28953472f54 extends (0, $j2mX5.Texture) {
    /**
     * Creates a DynamicTexture
     * @param name defines the name of the texture
     * @param options provides 3 alternatives for width and height of texture, a canvas, object with width and height properties, number for both width and height
     * @param scene defines the scene where you want the texture
     * @param generateMipMaps defines the use of MinMaps or not (default is false)
     * @param samplingMode defines the sampling mode to use (default is Texture.TRILINEAR_SAMPLINGMODE)
     * @param format defines the texture format to use (default is Engine.TEXTUREFORMAT_RGBA)
     * @param invertY defines if the texture needs to be inverted on the y axis during loading
     */ constructor(name, options, scene = null, generateMipMaps = false, samplingMode = 3, format = 5, invertY){
        super(null, scene, !generateMipMaps, invertY, samplingMode, undefined, undefined, undefined, undefined, format);
        this.name = name;
        this.wrapU = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        this.wrapV = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        this._generateMipMaps = generateMipMaps;
        const engine = this._getEngine();
        if (!engine) return;
        if (options.getContext) {
            this._canvas = options;
            this._ownCanvas = false;
            this._texture = engine.createDynamicTexture(options.width, options.height, generateMipMaps, samplingMode);
        } else {
            this._canvas = engine.createCanvas(1, 1);
            this._ownCanvas = true;
            if (options.width || options.width === 0) this._texture = engine.createDynamicTexture(options.width, options.height, generateMipMaps, samplingMode);
            else this._texture = engine.createDynamicTexture(options, options, generateMipMaps, samplingMode);
        }
        const textureSize = this.getSize();
        if (this._canvas.width !== textureSize.width) this._canvas.width = textureSize.width;
        if (this._canvas.height !== textureSize.height) this._canvas.height = textureSize.height;
        this._context = this._canvas.getContext("2d");
    }
    /**
     * Get the current class name of the texture useful for serialization or dynamic coding.
     * @returns "DynamicTexture"
     */ getClassName() {
        return "DynamicTexture";
    }
    /**
     * Gets the current state of canRescale
     */ get canRescale() {
        return true;
    }
    _recreate(textureSize) {
        this._canvas.width = textureSize.width;
        this._canvas.height = textureSize.height;
        this.releaseInternalTexture();
        this._texture = this._getEngine().createDynamicTexture(textureSize.width, textureSize.height, this._generateMipMaps, this.samplingMode);
    }
    /**
     * Scales the texture
     * @param ratio the scale factor to apply to both width and height
     */ scale(ratio) {
        const textureSize = this.getSize();
        textureSize.width *= ratio;
        textureSize.height *= ratio;
        this._recreate(textureSize);
    }
    /**
     * Resizes the texture
     * @param width the new width
     * @param height the new height
     */ scaleTo(width, height) {
        const textureSize = this.getSize();
        textureSize.width = width;
        textureSize.height = height;
        this._recreate(textureSize);
    }
    /**
     * Gets the context of the canvas used by the texture
     * @returns the canvas context of the dynamic texture
     */ getContext() {
        return this._context;
    }
    /**
     * Clears the texture
     * @param clearColor Defines the clear color to use
     */ clear(clearColor) {
        const size = this.getSize();
        if (clearColor) this._context.fillStyle = clearColor;
        this._context.clearRect(0, 0, size.width, size.height);
    }
    /**
     * Updates the texture
     * @param invertY defines the direction for the Y axis (default is true - y increases downwards)
     * @param premulAlpha defines if alpha is stored as premultiplied (default is false)
     * @param allowGPUOptimization true to allow some specific GPU optimizations (subject to engine feature "allowGPUOptimizationsForGUI" being true)
     */ update(invertY, premulAlpha = false, allowGPUOptimization = false) {
        this._getEngine().updateDynamicTexture(this._texture, this._canvas, invertY === undefined ? true : invertY, premulAlpha, this._format || undefined, undefined, allowGPUOptimization);
    }
    /**
     * Draws text onto the texture
     * @param text defines the text to be drawn
     * @param x defines the placement of the text from the left
     * @param y defines the placement of the text from the top when invertY is true and from the bottom when false
     * @param font defines the font to be used with font-style, font-size, font-name
     * @param color defines the color used for the text
     * @param fillColor defines the color for the canvas, use null to not overwrite canvas (this bleands with the background to replace, use the clear function)
     * @param invertY defines the direction for the Y axis (default is true - y increases downwards)
     * @param update defines whether texture is immediately update (default is true)
     */ drawText(text, x, y, font, color, fillColor, invertY, update = true) {
        const size = this.getSize();
        if (fillColor) {
            this._context.fillStyle = fillColor;
            this._context.fillRect(0, 0, size.width, size.height);
        }
        this._context.font = font;
        if (x === null || x === undefined) {
            const textSize = this._context.measureText(text);
            x = (size.width - textSize.width) / 2;
        }
        if (y === null || y === undefined) {
            const fontSize = parseInt(font.replace(/\D/g, ""));
            y = size.height / 2 + fontSize / 3.65;
        }
        this._context.fillStyle = color || "";
        this._context.fillText(text, x, y);
        if (update) this.update(invertY);
    }
    /**
     * Disposes the dynamic texture.
     */ dispose() {
        super.dispose();
        if (this._ownCanvas) this._canvas?.remove?.();
        this._canvas = null;
        this._context = null;
    }
    /**
     * Clones the texture
     * @returns the clone of the texture.
     */ clone() {
        const scene = this.getScene();
        if (!scene) return this;
        const textureSize = this.getSize();
        const newTexture = new $b7371b076ec25b92$export$da80c28953472f54(this.name, textureSize, scene, this._generateMipMaps);
        // Base texture
        newTexture.hasAlpha = this.hasAlpha;
        newTexture.level = this.level;
        // Dynamic Texture
        newTexture.wrapU = this.wrapU;
        newTexture.wrapV = this.wrapV;
        return newTexture;
    }
    /**
     * Serializes the dynamic texture.  The scene should be ready before the dynamic texture is serialized
     * @returns a serialized dynamic texture object
     */ serialize() {
        const scene = this.getScene();
        if (scene && !scene.isReady()) (0, $kVtWi.Logger).Warn("The scene must be ready before serializing the dynamic texture");
        const serializationObject = super.serialize();
        if ($b7371b076ec25b92$export$da80c28953472f54._IsCanvasElement(this._canvas)) serializationObject.base64String = this._canvas.toDataURL();
        serializationObject.invertY = this._invertY;
        serializationObject.samplingMode = this.samplingMode;
        return serializationObject;
    }
    static _IsCanvasElement(canvas) {
        return canvas.toDataURL !== undefined;
    }
    /** @internal */ _rebuild() {
        this.update();
    }
}

});
parcelRegister("2yVdu", function(module, exports) {

var $2h5JR = parcelRequire("2h5JR");

var $b9e4a = parcelRequire("b9e4a");
(0, $2h5JR.ThinEngine).prototype.createDynamicTexture = function(width, height, generateMipMaps, samplingMode) {
    const texture = new (0, $b9e4a.InternalTexture)(this, (0, $b9e4a.InternalTextureSource).Dynamic);
    texture.baseWidth = width;
    texture.baseHeight = height;
    if (generateMipMaps) {
        width = this.needPOTTextures ? (0, $2h5JR.ThinEngine).GetExponentOfTwo(width, this._caps.maxTextureSize) : width;
        height = this.needPOTTextures ? (0, $2h5JR.ThinEngine).GetExponentOfTwo(height, this._caps.maxTextureSize) : height;
    }
    //  this.resetTextureCache();
    texture.width = width;
    texture.height = height;
    texture.isReady = false;
    texture.generateMipMaps = generateMipMaps;
    texture.samplingMode = samplingMode;
    this.updateTextureSamplingMode(samplingMode, texture);
    this._internalTexturesCache.push(texture);
    return texture;
};
(0, $2h5JR.ThinEngine).prototype.updateDynamicTexture = function(texture, source, invertY, premulAlpha = false, format, forceBindTexture = false, // eslint-disable-next-line @typescript-eslint/no-unused-vars
allowGPUOptimization = false) {
    if (!texture) return;
    const gl = this._gl;
    const target = gl.TEXTURE_2D;
    const wasPreviouslyBound = this._bindTextureDirectly(target, texture, true, forceBindTexture);
    this._unpackFlipY(invertY === undefined ? texture.invertY : invertY);
    if (premulAlpha) gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, 1);
    const textureType = this._getWebGLTextureType(texture.type);
    const glformat = this._getInternalFormat(format ? format : texture.format);
    const internalFormat = this._getRGBABufferInternalSizedFormat(texture.type, glformat);
    gl.texImage2D(target, 0, internalFormat, glformat, textureType, source);
    if (texture.generateMipMaps) gl.generateMipmap(target);
    if (!wasPreviouslyBound) this._bindTextureDirectly(target, null);
    if (premulAlpha) gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, 0);
    if (format) texture.format = format;
    texture._dynamicTextureSource = source;
    texture._premulAlpha = premulAlpha;
    texture.invertY = invertY || false;
    texture.isReady = true;
};

});


parcelRegister("2isQc", function(module, exports) {

$parcel$export(module.exports, "WebXRSessionManager", () => $1ac3a2659049327a$export$c94f00ae1b570291);

var $kVtWi = parcelRequire("kVtWi");

var $diGQf = parcelRequire("diGQf");

var $7zPjk = parcelRequire("7zPjk");

var $25QTM = parcelRequire("25QTM");

var $3xmzr = parcelRequire("3xmzr");
class $1ac3a2659049327a$export$c94f00ae1b570291 {
    /**
     * Scale factor to apply to all XR-related elements (camera, controllers)
     */ get worldScalingFactor() {
        return this._worldScalingFactor;
    }
    set worldScalingFactor(value) {
        const oldValue = this._worldScalingFactor;
        this._worldScalingFactor = value;
        this.onWorldScaleFactorChangedObservable.notifyObservers({
            previousScaleFactor: oldValue,
            newScaleFactor: value
        });
    }
    /**
     * Constructs a WebXRSessionManager, this must be initialized within a user action before usage
     * @param scene The scene which the session should be created for
     */ constructor(/** The scene which the session should be created for */ scene){
        this.scene = scene;
        /** WebXR timestamp updated every frame */ this.currentTimestamp = -1;
        /**
         * Used just in case of a failure to initialize an immersive session.
         * The viewer reference space is compensated using this height, creating a kind of "viewer-floor" reference space
         */ this.defaultHeightCompensation = 1.7;
        /**
         * Fires every time a new xrFrame arrives which can be used to update the camera
         */ this.onXRFrameObservable = new (0, $diGQf.Observable)();
        /**
         * Fires when the reference space changed
         */ this.onXRReferenceSpaceChanged = new (0, $diGQf.Observable)();
        /**
         * Fires when the xr session is ended either by the device or manually done
         */ this.onXRSessionEnded = new (0, $diGQf.Observable)();
        /**
         * Fires when the xr session is initialized: right after requestSession was called and returned with a successful result
         */ this.onXRSessionInit = new (0, $diGQf.Observable)();
        /**
         * Fires when the xr reference space has been initialized
         */ this.onXRReferenceSpaceInitialized = new (0, $diGQf.Observable)();
        /**
         * Fires when the session manager is rendering the first frame
         */ this.onXRReady = new (0, $diGQf.Observable)();
        /**
         * Are we currently in the XR loop?
         */ this.inXRFrameLoop = false;
        /**
         * Are we in an XR session?
         */ this.inXRSession = false;
        this._worldScalingFactor = 1;
        /**
         * Observable raised when the world scale has changed
         */ this.onWorldScaleFactorChangedObservable = new (0, $diGQf.Observable)(undefined, true);
        this._engine = scene.getEngine();
        this._onEngineDisposedObserver = this._engine.onDisposeObservable.addOnce(()=>{
            this._engine = null;
        });
        scene.onDisposeObservable.addOnce(()=>{
            this.dispose();
        });
    }
    /**
     * The current reference space used in this session. This reference space can constantly change!
     * It is mainly used to offset the camera's position.
     */ get referenceSpace() {
        return this._referenceSpace;
    }
    /**
     * Set a new reference space and triggers the observable
     */ set referenceSpace(newReferenceSpace) {
        this._referenceSpace = newReferenceSpace;
        this.onXRReferenceSpaceChanged.notifyObservers(this._referenceSpace);
    }
    /**
     * The mode for the managed XR session
     */ get sessionMode() {
        return this._sessionMode;
    }
    /**
     * Disposes of the session manager
     * This should be called explicitly by the dev, if required.
     */ dispose() {
        // disposing without leaving XR? Exit XR first
        if (this.inXRSession) this.exitXRAsync();
        this.onXRFrameObservable.clear();
        this.onXRSessionEnded.clear();
        this.onXRReferenceSpaceChanged.clear();
        this.onXRSessionInit.clear();
        this.onWorldScaleFactorChangedObservable.clear();
        this._engine?.onDisposeObservable.remove(this._onEngineDisposedObserver);
        this._engine = null;
    }
    /**
     * Stops the xrSession and restores the render loop
     * @returns Promise which resolves after it exits XR
     */ async exitXRAsync() {
        if (this.session && this.inXRSession) {
            this.inXRSession = false;
            try {
                return await this.session.end();
            } catch  {
                (0, $kVtWi.Logger).Warn("Could not end XR session.");
            }
        }
        return Promise.resolve();
    }
    /**
     * Attempts to set the framebuffer-size-normalized viewport to be rendered this frame for this view.
     * In the event of a failure, the supplied viewport is not updated.
     * @param viewport the viewport to which the view will be rendered
     * @param view the view for which to set the viewport
     * @returns whether the operation was successful
     */ trySetViewportForView(viewport, view) {
        return this._baseLayerRTTProvider?.trySetViewportForView(viewport, view) || false;
    }
    /**
     * Gets the correct render target texture to be rendered this frame for this eye
     * @param eye the eye for which to get the render target
     * @returns the render target for the specified eye or null if not available
     */ getRenderTargetTextureForEye(eye) {
        return this._baseLayerRTTProvider?.getRenderTargetTextureForEye(eye) || null;
    }
    /**
     * Gets the correct render target texture to be rendered this frame for this view
     * @param view the view for which to get the render target
     * @returns the render target for the specified view or null if not available
     */ getRenderTargetTextureForView(view) {
        return this._baseLayerRTTProvider?.getRenderTargetTextureForView(view) || null;
    }
    /**
     * Creates a WebXRRenderTarget object for the XR session
     * @param options optional options to provide when creating a new render target
     * @returns a WebXR render target to which the session can render
     */ getWebXRRenderTarget(options) {
        const engine = this.scene.getEngine();
        if (this._xrNavigator.xr.native) return new (0, $25QTM.NativeXRRenderTarget)(this);
        else {
            options = options || (0, $7zPjk.WebXRManagedOutputCanvasOptions).GetDefaults(engine);
            options.canvasElement = options.canvasElement || engine.getRenderingCanvas() || undefined;
            return new (0, $7zPjk.WebXRManagedOutputCanvas)(this, options);
        }
    }
    /**
     * Initializes the manager
     * After initialization enterXR can be called to start an XR session
     * @returns Promise which resolves after it is initialized
     */ initializeAsync() {
        // Check if the browser supports webXR
        this._xrNavigator = navigator;
        if (!this._xrNavigator.xr) return Promise.reject("WebXR not available");
        return Promise.resolve();
    }
    /**
     * Initializes an xr session
     * @param xrSessionMode mode to initialize
     * @param xrSessionInit defines optional and required values to pass to the session builder
     * @returns a promise which will resolve once the session has been initialized
     */ initializeSessionAsync(xrSessionMode = "immersive-vr", xrSessionInit = {}) {
        return this._xrNavigator.xr.requestSession(xrSessionMode, xrSessionInit).then((session)=>{
            this.session = session;
            this._sessionMode = xrSessionMode;
            this.inXRSession = true;
            this.onXRSessionInit.notifyObservers(session);
            // handle when the session is ended (By calling session.end or device ends its own session eg. pressing home button on phone)
            this.session.addEventListener("end", ()=>{
                this.inXRSession = false;
                // Notify frame observers
                this.onXRSessionEnded.notifyObservers(null);
                if (this._engine) {
                    // make sure dimensions object is restored
                    this._engine.framebufferDimensionsObject = null;
                    // Restore frame buffer to avoid clear on xr framebuffer after session end
                    this._engine.restoreDefaultFramebuffer();
                    // Need to restart render loop as after the session is ended the last request for new frame will never call callback
                    this._engine.customAnimationFrameRequester = null;
                    this._engine._renderLoop();
                }
                // Dispose render target textures.
                // Only dispose on native because we can't destroy opaque textures on browser.
                if (this.isNative) this._baseLayerRTTProvider?.dispose();
                this._baseLayerRTTProvider = null;
                this._baseLayerWrapper = null;
            }, {
                once: true
            });
            return this.session;
        });
    }
    /**
     * Checks if a session would be supported for the creation options specified
     * @param sessionMode session mode to check if supported eg. immersive-vr
     * @returns A Promise that resolves to true if supported and false if not
     */ isSessionSupportedAsync(sessionMode) {
        return $1ac3a2659049327a$export$c94f00ae1b570291.IsSessionSupportedAsync(sessionMode);
    }
    /**
     * Resets the reference space to the one started the session
     */ resetReferenceSpace() {
        this.referenceSpace = this.baseReferenceSpace;
    }
    /**
     * Starts rendering to the xr layer
     */ runXRRenderLoop() {
        if (!this.inXRSession || !this._engine) return;
        // Tell the engine's render loop to be driven by the xr session's refresh rate and provide xr pose information
        this._engine.customAnimationFrameRequester = {
            requestAnimationFrame: (callback)=>this.session.requestAnimationFrame(callback),
            renderFunction: (timestamp, xrFrame)=>{
                if (!this.inXRSession || !this._engine) return;
                // Store the XR frame and timestamp in the session manager
                this.currentFrame = xrFrame;
                this.currentTimestamp = timestamp;
                if (xrFrame) {
                    this.inXRFrameLoop = true;
                    const framebufferDimensionsObject = this._baseLayerRTTProvider?.getFramebufferDimensions() || null;
                    // equality can be tested as it should be the same object
                    if (this._engine.framebufferDimensionsObject !== framebufferDimensionsObject) this._engine.framebufferDimensionsObject = framebufferDimensionsObject;
                    this.onXRFrameObservable.notifyObservers(xrFrame);
                    this._engine._renderLoop();
                    this._engine.framebufferDimensionsObject = null;
                    this.inXRFrameLoop = false;
                }
            }
        };
        this._engine.framebufferDimensionsObject = this._baseLayerRTTProvider?.getFramebufferDimensions() || null;
        this.onXRFrameObservable.addOnce(()=>{
            this.onXRReady.notifyObservers(this);
        });
        // Stop window's animation frame and trigger sessions animation frame
        if (typeof window !== "undefined" && window.cancelAnimationFrame) window.cancelAnimationFrame(this._engine._frameHandler);
        this._engine._renderLoop();
    }
    /**
     * Sets the reference space on the xr session
     * @param referenceSpaceType space to set
     * @returns a promise that will resolve once the reference space has been set
     */ setReferenceSpaceTypeAsync(referenceSpaceType = "local-floor") {
        return this.session.requestReferenceSpace(referenceSpaceType).then((referenceSpace)=>{
            return referenceSpace;
        }, (rejectionReason)=>{
            (0, $kVtWi.Logger).Error("XR.requestReferenceSpace failed for the following reason: ");
            (0, $kVtWi.Logger).Error(rejectionReason);
            (0, $kVtWi.Logger).Log('Defaulting to universally-supported "viewer" reference space type.');
            return this.session.requestReferenceSpace("viewer").then((referenceSpace)=>{
                const heightCompensation = new XRRigidTransform({
                    x: 0,
                    y: -this.defaultHeightCompensation,
                    z: 0
                });
                return referenceSpace.getOffsetReferenceSpace(heightCompensation);
            }, (rejectionReason)=>{
                (0, $kVtWi.Logger).Error(rejectionReason);
                // eslint-disable-next-line no-throw-literal
                throw 'XR initialization failed: required "viewer" reference space type not supported.';
            });
        }).then((referenceSpace)=>{
            // create viewer reference space before setting the first reference space
            return this.session.requestReferenceSpace("viewer").then((viewerReferenceSpace)=>{
                this.viewerReferenceSpace = viewerReferenceSpace;
                return referenceSpace;
            });
        }).then((referenceSpace)=>{
            // initialize the base and offset (currently the same)
            this.referenceSpace = this.baseReferenceSpace = referenceSpace;
            this.onXRReferenceSpaceInitialized.notifyObservers(referenceSpace);
            return this.referenceSpace;
        });
    }
    /**
     * Updates the render state of the session.
     * Note that this is deprecated in favor of WebXRSessionManager.updateRenderState().
     * @param state state to set
     * @returns a promise that resolves once the render state has been updated
     * @deprecated Use updateRenderState() instead.
     */ updateRenderStateAsync(state) {
        return Promise.resolve(this.session.updateRenderState(state));
    }
    /**
     * @internal
     */ _setBaseLayerWrapper(baseLayerWrapper) {
        if (this.isNative) this._baseLayerRTTProvider?.dispose();
        this._baseLayerWrapper = baseLayerWrapper;
        this._baseLayerRTTProvider = this._baseLayerWrapper?.createRenderTargetTextureProvider(this) || null;
    }
    /**
     * @internal
     */ _getBaseLayerWrapper() {
        return this._baseLayerWrapper;
    }
    /**
     * Updates the render state of the session
     * @param state state to set
     */ updateRenderState(state) {
        if (state.baseLayer) this._setBaseLayerWrapper(this.isNative ? new (0, $25QTM.NativeXRLayerWrapper)(state.baseLayer) : new (0, $3xmzr.WebXRWebGLLayerWrapper)(state.baseLayer));
        this.session.updateRenderState(state);
    }
    /**
     * Returns a promise that resolves with a boolean indicating if the provided session mode is supported by this browser
     * @param sessionMode defines the session to test
     * @returns a promise with boolean as final value
     */ static IsSessionSupportedAsync(sessionMode) {
        if (!navigator.xr) return Promise.resolve(false);
        // When the specs are final, remove supportsSession!
        const functionToUse = navigator.xr.isSessionSupported || navigator.xr.supportsSession;
        if (!functionToUse) return Promise.resolve(false);
        else return functionToUse.call(navigator.xr, sessionMode).then((result)=>{
            const returnValue = typeof result === "undefined" ? true : result;
            return Promise.resolve(returnValue);
        }).catch((e)=>{
            (0, $kVtWi.Logger).Warn(e);
            return Promise.resolve(false);
        });
    }
    /**
     * Returns true if Babylon.js is using the BabylonNative backend, otherwise false
     */ get isNative() {
        return this._xrNavigator.xr.native ?? false;
    }
    /**
     * The current frame rate as reported by the device
     */ get currentFrameRate() {
        return this.session?.frameRate;
    }
    /**
     * A list of supported frame rates (only available in-session!
     */ get supportedFrameRates() {
        return this.session?.supportedFrameRates;
    }
    /**
     * Set the framerate of the session.
     * @param rate the new framerate. This value needs to be in the supportedFrameRates array
     * @returns a promise that resolves once the framerate has been set
     */ updateTargetFrameRate(rate) {
        return this.session.updateTargetFrameRate(rate);
    }
    /**
     * Run a callback in the xr render loop
     * @param callback the callback to call when in XR Frame
     * @param ignoreIfNotInSession if no session is currently running, run it first thing on the next session
     */ runInXRFrame(callback, ignoreIfNotInSession = true) {
        if (this.inXRFrameLoop) callback();
        else if (this.inXRSession || !ignoreIfNotInSession) this.onXRFrameObservable.addOnce(callback);
    }
    /**
     * Check if fixed foveation is supported on this device
     */ get isFixedFoveationSupported() {
        return this._baseLayerWrapper?.isFixedFoveationSupported || false;
    }
    /**
     * Get the fixed foveation currently set, as specified by the webxr specs
     * If this returns null, then fixed foveation is not supported
     */ get fixedFoveation() {
        return this._baseLayerWrapper?.fixedFoveation || null;
    }
    /**
     * Set the fixed foveation to the specified value, as specified by the webxr specs
     * This value will be normalized to be between 0 and 1, 1 being max foveation, 0 being no foveation
     */ set fixedFoveation(value) {
        const val = Math.max(0, Math.min(1, value || 0));
        if (this._baseLayerWrapper) this._baseLayerWrapper.fixedFoveation = val;
    }
    /**
     * Get the features enabled on the current session
     * This is only available in-session!
     * @see https://www.w3.org/TR/webxr/#dom-xrsession-enabledfeatures
     */ get enabledFeatures() {
        return this.session?.enabledFeatures ?? null;
    }
}

});
parcelRegister("7zPjk", function(module, exports) {

$parcel$export(module.exports, "WebXRManagedOutputCanvasOptions", () => $58439a8c83f81ac9$export$445f680c82cb1f7f);
$parcel$export(module.exports, "WebXRManagedOutputCanvas", () => $58439a8c83f81ac9$export$b5d82b36ea8b44a9);

var $diGQf = parcelRequire("diGQf");

var $bOhSV = parcelRequire("bOhSV");

var $3xmzr = parcelRequire("3xmzr");
class $58439a8c83f81ac9$export$445f680c82cb1f7f {
    /**
     * Get the default values of the configuration object
     * @param engine defines the engine to use (can be null)
     * @returns default values of this configuration object
     */ static GetDefaults(engine) {
        const defaults = new $58439a8c83f81ac9$export$445f680c82cb1f7f();
        defaults.canvasOptions = {
            antialias: true,
            depth: true,
            stencil: engine ? engine.isStencilEnable : true,
            alpha: true,
            framebufferScaleFactor: 1
        };
        defaults.newCanvasCssStyle = "position:absolute; bottom:0px;right:0px;z-index:10;width:90%;height:100%;background-color: #000000;";
        return defaults;
    }
}
class $58439a8c83f81ac9$export$b5d82b36ea8b44a9 {
    /**
     * Initializes the canvas to be added/removed upon entering/exiting xr
     * @param _xrSessionManager The XR Session manager
     * @param _options optional configuration for this canvas output. defaults will be used if not provided
     */ constructor(_xrSessionManager, _options = $58439a8c83f81ac9$export$445f680c82cb1f7f.GetDefaults()){
        this._options = _options;
        this._canvas = null;
        this._engine = null;
        /**
         * xr layer for the canvas
         */ this.xrLayer = null;
        this._xrLayerWrapper = null;
        /**
         * Observers registered here will be triggered when the xr layer was initialized
         */ this.onXRLayerInitObservable = new (0, $diGQf.Observable)();
        this._engine = _xrSessionManager.scene.getEngine();
        this._engine.onDisposeObservable.addOnce(()=>{
            this._engine = null;
        });
        if (!_options.canvasElement) {
            const canvas = document.createElement("canvas");
            canvas.style.cssText = this._options.newCanvasCssStyle || "position:absolute; bottom:0px;right:0px;";
            this._setManagedOutputCanvas(canvas);
        } else this._setManagedOutputCanvas(_options.canvasElement);
        _xrSessionManager.onXRSessionInit.add(()=>{
            this._addCanvas();
        });
        _xrSessionManager.onXRSessionEnded.add(()=>{
            this._removeCanvas();
        });
    }
    /**
     * Disposes of the object
     */ dispose() {
        this._removeCanvas();
        this._setManagedOutputCanvas(null);
    }
    /**
     * Initializes a XRWebGLLayer to be used as the session's baseLayer.
     * @param xrSession xr session
     * @returns a promise that will resolve once the XR Layer has been created
     */ async initializeXRLayerAsync(xrSession) {
        const createLayer = ()=>{
            this.xrLayer = new XRWebGLLayer(xrSession, this.canvasContext, this._options.canvasOptions);
            this._xrLayerWrapper = new (0, $3xmzr.WebXRWebGLLayerWrapper)(this.xrLayer);
            this.onXRLayerInitObservable.notifyObservers(this.xrLayer);
            return this.xrLayer;
        };
        // support canvases without makeXRCompatible
        if (!this.canvasContext.makeXRCompatible) return Promise.resolve(createLayer());
        return this.canvasContext.makeXRCompatible().then(// catch any error and continue. When using the emulator is throws this error for no apparent reason.
        ()=>{}, ()=>{
            // log the error, continue nonetheless!
            (0, $bOhSV.Tools).Warn("Error executing makeXRCompatible. This does not mean that the session will work incorrectly.");
        }).then(()=>{
            return createLayer();
        });
    }
    _addCanvas() {
        if (this._canvas && this._engine && this._canvas !== this._engine.getRenderingCanvas()) document.body.appendChild(this._canvas);
        if (this.xrLayer) this._setCanvasSize(true);
        else this.onXRLayerInitObservable.addOnce(()=>{
            this._setCanvasSize(true);
        });
    }
    _removeCanvas() {
        if (this._canvas && this._engine && document.body.contains(this._canvas) && this._canvas !== this._engine.getRenderingCanvas()) document.body.removeChild(this._canvas);
        this._setCanvasSize(false);
    }
    _setCanvasSize(init = true, xrLayer = this._xrLayerWrapper) {
        if (!this._canvas || !this._engine) return;
        if (init) {
            if (xrLayer) {
                if (this._canvas !== this._engine.getRenderingCanvas()) {
                    this._canvas.style.width = xrLayer.getWidth() + "px";
                    this._canvas.style.height = xrLayer.getHeight() + "px";
                } else this._engine.setSize(xrLayer.getWidth(), xrLayer.getHeight());
            }
        } else if (this._originalCanvasSize) {
            if (this._canvas !== this._engine.getRenderingCanvas()) {
                this._canvas.style.width = this._originalCanvasSize.width + "px";
                this._canvas.style.height = this._originalCanvasSize.height + "px";
            } else this._engine.setSize(this._originalCanvasSize.width, this._originalCanvasSize.height);
        }
    }
    _setManagedOutputCanvas(canvas) {
        this._removeCanvas();
        if (!canvas) {
            this._canvas = null;
            this.canvasContext = null;
        } else {
            this._originalCanvasSize = {
                width: canvas.offsetWidth,
                height: canvas.offsetHeight
            };
            this._canvas = canvas;
            this.canvasContext = this._canvas.getContext("webgl2");
            if (!this.canvasContext) this.canvasContext = this._canvas.getContext("webgl");
        }
    }
}

});
parcelRegister("3xmzr", function(module, exports) {

$parcel$export(module.exports, "WebXRWebGLLayerWrapper", () => $2935f63ae5584cb0$export$e05ac9f6234f1c80);

var $lx5nJ = parcelRequire("lx5nJ");

var $6PNKl = parcelRequire("6PNKl");
class $2935f63ae5584cb0$export$e05ac9f6234f1c80 extends (0, $lx5nJ.WebXRLayerWrapper) {
    /**
     * @param layer is the layer to be wrapped.
     * @returns a new WebXRLayerWrapper wrapping the provided XRWebGLLayer.
     */ constructor(layer){
        super(()=>layer.framebufferWidth, ()=>layer.framebufferHeight, layer, "XRWebGLLayer", (sessionManager)=>new $2935f63ae5584cb0$export$7319ab85a208bf0a(sessionManager.scene, this));
        this.layer = layer;
    }
}
class $2935f63ae5584cb0$export$7319ab85a208bf0a extends (0, $6PNKl.WebXRLayerRenderTargetTextureProvider) {
    constructor(scene, layerWrapper){
        super(scene, layerWrapper);
        this.layerWrapper = layerWrapper;
        this._layer = layerWrapper.layer;
        this._framebufferDimensions = {
            framebufferWidth: this._layer.framebufferWidth,
            framebufferHeight: this._layer.framebufferHeight
        };
    }
    trySetViewportForView(viewport, view) {
        const xrViewport = this._layer.getViewport(view);
        if (!xrViewport) return false;
        const framebufferWidth = this._framebufferDimensions.framebufferWidth;
        const framebufferHeight = this._framebufferDimensions.framebufferHeight;
        viewport.x = xrViewport.x / framebufferWidth;
        viewport.y = xrViewport.y / framebufferHeight;
        viewport.width = xrViewport.width / framebufferWidth;
        viewport.height = xrViewport.height / framebufferHeight;
        return true;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getRenderTargetTextureForEye(eye) {
        const layerWidth = this._layer.framebufferWidth;
        const layerHeight = this._layer.framebufferHeight;
        const framebuffer = this._layer.framebuffer;
        if (!this._rtt || layerWidth !== this._framebufferDimensions.framebufferWidth || layerHeight !== this._framebufferDimensions.framebufferHeight || framebuffer !== this._framebuffer) {
            this._rtt = this._createRenderTargetTexture(layerWidth, layerHeight, framebuffer);
            this._framebufferDimensions.framebufferWidth = layerWidth;
            this._framebufferDimensions.framebufferHeight = layerHeight;
            this._framebuffer = framebuffer;
        }
        return this._rtt;
    }
    getRenderTargetTextureForView(view) {
        return this.getRenderTargetTextureForEye(view.eye);
    }
}

});
parcelRegister("lx5nJ", function(module, exports) {

$parcel$export(module.exports, "WebXRLayerWrapper", () => $fad0dac43a359712$export$c21a5c419247cecd);
/**
 * Wrapper over subclasses of XRLayer.
 * @internal
 */ class $fad0dac43a359712$export$c21a5c419247cecd {
    /**
     * Check if fixed foveation is supported on this device
     */ get isFixedFoveationSupported() {
        return this.layerType == "XRWebGLLayer" && typeof this.layer.fixedFoveation == "number";
    }
    /**
     * Get the fixed foveation currently set, as specified by the webxr specs
     * If this returns null, then fixed foveation is not supported
     */ get fixedFoveation() {
        if (this.isFixedFoveationSupported) return this.layer.fixedFoveation;
        return null;
    }
    /**
     * Set the fixed foveation to the specified value, as specified by the webxr specs
     * This value will be normalized to be between 0 and 1, 1 being max foveation, 0 being no foveation
     */ set fixedFoveation(value) {
        if (this.isFixedFoveationSupported) {
            const val = Math.max(0, Math.min(1, value || 0));
            this.layer.fixedFoveation = val;
        }
    }
    /**
     * Create a render target provider for the wrapped layer.
     * @param xrSessionManager The XR Session Manager
     * @returns A new render target texture provider for the wrapped layer.
     */ createRenderTargetTextureProvider(xrSessionManager) {
        this._rttWrapper = this._createRenderTargetTextureProvider(xrSessionManager);
        return this._rttWrapper;
    }
    dispose() {
        if (this._rttWrapper) {
            this._rttWrapper.dispose();
            this._rttWrapper = null;
        }
    }
    constructor(/** The width of the layer's framebuffer. */ getWidth, /** The height of the layer's framebuffer. */ getHeight, /** The XR layer that this WebXRLayerWrapper wraps. */ layer, /** The type of XR layer that is being wrapped. */ layerType, /** Create a render target provider for the wrapped layer. */ _createRenderTargetTextureProvider){
        this.getWidth = getWidth;
        this.getHeight = getHeight;
        this.layer = layer;
        this.layerType = layerType;
        this._createRenderTargetTextureProvider = _createRenderTargetTextureProvider;
        this._rttWrapper = null;
    }
}

});

parcelRegister("6PNKl", function(module, exports) {

$parcel$export(module.exports, "WebXRLayerRenderTargetTextureProvider", () => $4f9e181d07bd5038$export$9ace06c638f7a343);

var $8ClRi = parcelRequire("8ClRi");

var $b9e4a = parcelRequire("b9e4a");

var $3pccG = parcelRequire("3pccG");

var $gQtNK = parcelRequire("gQtNK");
class $4f9e181d07bd5038$export$9ace06c638f7a343 {
    constructor(_scene, layerWrapper){
        this._scene = _scene;
        this.layerWrapper = layerWrapper;
        this._renderTargetTextures = new Array();
        this._engine = _scene.getEngine();
    }
    _createInternalTexture(textureSize, texture) {
        const internalTexture = new (0, $b9e4a.InternalTexture)(this._engine, (0, $b9e4a.InternalTextureSource).Unknown, true);
        internalTexture.width = textureSize.width;
        internalTexture.height = textureSize.height;
        internalTexture._hardwareTexture = new (0, $8ClRi.WebGLHardwareTexture)(texture, this._engine._gl);
        internalTexture.isReady = true;
        return internalTexture;
    }
    _createRenderTargetTexture(width, height, framebuffer, colorTexture, depthStencilTexture, multiview) {
        if (!this._engine) throw new Error("Engine is disposed");
        const textureSize = {
            width: width,
            height: height
        };
        // Create render target texture from the internal texture
        const renderTargetTexture = multiview ? new (0, $3pccG.MultiviewRenderTarget)(this._scene, textureSize) : new (0, $gQtNK.RenderTargetTexture)("XR renderTargetTexture", textureSize, this._scene);
        const renderTargetWrapper = renderTargetTexture.renderTarget;
        renderTargetWrapper._samples = renderTargetTexture.samples;
        // Set the framebuffer, make sure it works in all scenarios - emulator, no layers and layers
        if (framebuffer || !colorTexture) renderTargetWrapper._framebuffer = framebuffer;
        // Create internal texture
        if (colorTexture) {
            if (multiview) renderTargetWrapper._colorTextureArray = colorTexture;
            else {
                const internalTexture = this._createInternalTexture(textureSize, colorTexture);
                renderTargetWrapper.setTexture(internalTexture, 0);
                renderTargetTexture._texture = internalTexture;
            }
        }
        if (depthStencilTexture) {
            if (multiview) renderTargetWrapper._depthStencilTextureArray = depthStencilTexture;
            else renderTargetWrapper._depthStencilTexture = this._createInternalTexture(textureSize, depthStencilTexture);
        }
        renderTargetTexture.disableRescaling();
        this._renderTargetTextures.push(renderTargetTexture);
        return renderTargetTexture;
    }
    _destroyRenderTargetTexture(renderTargetTexture) {
        this._renderTargetTextures.splice(this._renderTargetTextures.indexOf(renderTargetTexture), 1);
        renderTargetTexture.dispose();
    }
    getFramebufferDimensions() {
        return this._framebufferDimensions;
    }
    dispose() {
        this._renderTargetTextures.forEach((rtt)=>rtt.dispose());
        this._renderTargetTextures.length = 0;
    }
}

});



parcelRegister("25QTM", function(module, exports) {

$parcel$export(module.exports, "NativeXRLayerWrapper", () => $186514f643baa381$export$8807eab6afa150ab);
$parcel$export(module.exports, "NativeXRLayerRenderTargetTextureProvider", () => $186514f643baa381$export$c1800d4d3f07e679);
$parcel$export(module.exports, "NativeXRRenderTarget", () => $186514f643baa381$export$d2419dc490f72d37);

var $lx5nJ = parcelRequire("lx5nJ");

var $6PNKl = parcelRequire("6PNKl");
class $186514f643baa381$export$8807eab6afa150ab extends (0, $lx5nJ.WebXRLayerWrapper) {
    constructor(layer){
        super(()=>layer.framebufferWidth, ()=>layer.framebufferHeight, layer, "XRWebGLLayer", (sessionManager)=>new $186514f643baa381$export$c1800d4d3f07e679(sessionManager, this));
        this.layer = layer;
    }
}
class $186514f643baa381$export$c1800d4d3f07e679 extends (0, $6PNKl.WebXRLayerRenderTargetTextureProvider) {
    constructor(sessionManager, layerWrapper){
        super(sessionManager.scene, layerWrapper);
        this.layerWrapper = layerWrapper;
        this._nativeRTTProvider = navigator.xr.getNativeRenderTargetProvider(sessionManager.session, this._createRenderTargetTexture.bind(this), this._destroyRenderTargetTexture.bind(this));
        this._nativeLayer = layerWrapper.layer;
    }
    trySetViewportForView(viewport) {
        viewport.x = 0;
        viewport.y = 0;
        viewport.width = 1;
        viewport.height = 1;
        return true;
    }
    getRenderTargetTextureForEye(eye) {
        // TODO (rgerd): Update the contract on the BabylonNative side to call this "getRenderTargetTextureForEye"
        return this._nativeRTTProvider.getRenderTargetForEye(eye);
    }
    getRenderTargetTextureForView(view) {
        return this._nativeRTTProvider.getRenderTargetForEye(view.eye);
    }
    getFramebufferDimensions() {
        return {
            framebufferWidth: this._nativeLayer.framebufferWidth,
            framebufferHeight: this._nativeLayer.framebufferHeight
        };
    }
}
class $186514f643baa381$export$d2419dc490f72d37 {
    constructor(_xrSessionManager){
        this._nativeRenderTarget = navigator.xr.getWebXRRenderTarget(_xrSessionManager.scene.getEngine());
    }
    async initializeXRLayerAsync(xrSession) {
        await this._nativeRenderTarget.initializeXRLayerAsync(xrSession);
        this.xrLayer = this._nativeRenderTarget.xrLayer;
        return this.xrLayer;
    }
    dispose() {
    /* empty */ }
}

});


parcelRegister("jknux", function(module, exports) {

$parcel$export(module.exports, "WebXRState", () => $e1221b866111c498$export$997d9f3958241e1f);
$parcel$export(module.exports, "WebXRTrackingState", () => $e1221b866111c498$export$c1cfe8f11f2af8d1);
/**
 * States of the webXR experience
 */ var $e1221b866111c498$export$997d9f3958241e1f;
(function(WebXRState) {
    /**
     * Transitioning to being in XR mode
     */ WebXRState[WebXRState["ENTERING_XR"] = 0] = "ENTERING_XR";
    /**
     * Transitioning to non XR mode
     */ WebXRState[WebXRState["EXITING_XR"] = 1] = "EXITING_XR";
    /**
     * In XR mode and presenting
     */ WebXRState[WebXRState["IN_XR"] = 2] = "IN_XR";
    /**
     * Not entered XR mode
     */ WebXRState[WebXRState["NOT_IN_XR"] = 3] = "NOT_IN_XR";
})($e1221b866111c498$export$997d9f3958241e1f || ($e1221b866111c498$export$997d9f3958241e1f = {}));
var $e1221b866111c498$export$c1cfe8f11f2af8d1;
(function(WebXRTrackingState) {
    /**
     * No transformation received, device is not being tracked
     */ WebXRTrackingState[WebXRTrackingState["NOT_TRACKING"] = 0] = "NOT_TRACKING";
    /**
     * Tracking lost - using emulated position
     */ WebXRTrackingState[WebXRTrackingState["TRACKING_LOST"] = 1] = "TRACKING_LOST";
    /**
     * Transformation tracking works normally
     */ WebXRTrackingState[WebXRTrackingState["TRACKING"] = 2] = "TRACKING";
})($e1221b866111c498$export$c1cfe8f11f2af8d1 || ($e1221b866111c498$export$c1cfe8f11f2af8d1 = {}));

});

parcelRegister("8CiHO", function(module, exports) {

$parcel$export(module.exports, "CreateGroundVertexData", () => $646061de4fd29ff7$export$ae47f6dc1ba8f3ec);
$parcel$export(module.exports, "CreateTiledGroundVertexData", () => $646061de4fd29ff7$export$af0f3de94a9367a1);
$parcel$export(module.exports, "CreateGroundFromHeightMapVertexData", () => $646061de4fd29ff7$export$ea9d2c5bab487ab0);
$parcel$export(module.exports, "CreateGround", () => $646061de4fd29ff7$export$36f42a4c5f351a31);
$parcel$export(module.exports, "CreateTiledGround", () => $646061de4fd29ff7$export$c78da18d8c5de609);
$parcel$export(module.exports, "CreateGroundFromHeightMap", () => $646061de4fd29ff7$export$1106a851f720f529);
$parcel$export(module.exports, "GroundBuilder", () => $646061de4fd29ff7$export$517861b98adbb032);

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $fbuqw = parcelRequire("fbuqw");

var $5v6ry = parcelRequire("5v6ry");

var $1cCRP = parcelRequire("1cCRP");

var $bOhSV = parcelRequire("bOhSV");

var $ejQPp = parcelRequire("ejQPp");

var $53VPf = parcelRequire("53VPf");

var $fGXjI = parcelRequire("fGXjI");
function $646061de4fd29ff7$export$ae47f6dc1ba8f3ec(options) {
    const indices = [];
    const positions = [];
    const normals = [];
    const uvs = [];
    let row, col;
    const width = options.width || 1;
    const height = options.height || 1;
    const subdivisionsX = (options.subdivisionsX || options.subdivisions || 1) | 0;
    const subdivisionsY = (options.subdivisionsY || options.subdivisions || 1) | 0;
    for(row = 0; row <= subdivisionsY; row++)for(col = 0; col <= subdivisionsX; col++){
        const position = new (0, $ha1VO.Vector3)(col * width / subdivisionsX - width / 2.0, 0, (subdivisionsY - row) * height / subdivisionsY - height / 2.0);
        const normal = new (0, $ha1VO.Vector3)(0, 1.0, 0);
        positions.push(position.x, position.y, position.z);
        normals.push(normal.x, normal.y, normal.z);
        uvs.push(col / subdivisionsX, (0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? row / subdivisionsY : 1.0 - row / subdivisionsY);
    }
    for(row = 0; row < subdivisionsY; row++)for(col = 0; col < subdivisionsX; col++){
        indices.push(col + 1 + (row + 1) * (subdivisionsX + 1));
        indices.push(col + 1 + row * (subdivisionsX + 1));
        indices.push(col + row * (subdivisionsX + 1));
        indices.push(col + (row + 1) * (subdivisionsX + 1));
        indices.push(col + 1 + (row + 1) * (subdivisionsX + 1));
        indices.push(col + row * (subdivisionsX + 1));
    }
    // Result
    const vertexData = new (0, $5v6ry.VertexData)();
    vertexData.indices = indices;
    vertexData.positions = positions;
    vertexData.normals = normals;
    vertexData.uvs = uvs;
    return vertexData;
}
function $646061de4fd29ff7$export$af0f3de94a9367a1(options) {
    const xmin = options.xmin !== undefined && options.xmin !== null ? options.xmin : -1;
    const zmin = options.zmin !== undefined && options.zmin !== null ? options.zmin : -1;
    const xmax = options.xmax !== undefined && options.xmax !== null ? options.xmax : 1.0;
    const zmax = options.zmax !== undefined && options.zmax !== null ? options.zmax : 1.0;
    const subdivisions = options.subdivisions || {
        w: 1,
        h: 1
    };
    const precision = options.precision || {
        w: 1,
        h: 1
    };
    const indices = [];
    const positions = [];
    const normals = [];
    const uvs = [];
    let row, col, tileRow, tileCol;
    subdivisions.h = subdivisions.h < 1 ? 1 : subdivisions.h;
    subdivisions.w = subdivisions.w < 1 ? 1 : subdivisions.w;
    precision.w = precision.w < 1 ? 1 : precision.w;
    precision.h = precision.h < 1 ? 1 : precision.h;
    const tileSize = {
        w: (xmax - xmin) / subdivisions.w,
        h: (zmax - zmin) / subdivisions.h
    };
    function applyTile(xTileMin, zTileMin, xTileMax, zTileMax) {
        // Indices
        const base = positions.length / 3;
        const rowLength = precision.w + 1;
        for(row = 0; row < precision.h; row++)for(col = 0; col < precision.w; col++){
            const square = [
                base + col + row * rowLength,
                base + (col + 1) + row * rowLength,
                base + (col + 1) + (row + 1) * rowLength,
                base + col + (row + 1) * rowLength
            ];
            indices.push(square[1]);
            indices.push(square[2]);
            indices.push(square[3]);
            indices.push(square[0]);
            indices.push(square[1]);
            indices.push(square[3]);
        }
        // Position, normals and uvs
        const position = (0, $ha1VO.Vector3).Zero();
        const normal = new (0, $ha1VO.Vector3)(0, 1.0, 0);
        for(row = 0; row <= precision.h; row++){
            position.z = row * (zTileMax - zTileMin) / precision.h + zTileMin;
            for(col = 0; col <= precision.w; col++){
                position.x = col * (xTileMax - xTileMin) / precision.w + xTileMin;
                position.y = 0;
                positions.push(position.x, position.y, position.z);
                normals.push(normal.x, normal.y, normal.z);
                uvs.push(col / precision.w, row / precision.h);
            }
        }
    }
    for(tileRow = 0; tileRow < subdivisions.h; tileRow++)for(tileCol = 0; tileCol < subdivisions.w; tileCol++)applyTile(xmin + tileCol * tileSize.w, zmin + tileRow * tileSize.h, xmin + (tileCol + 1) * tileSize.w, zmin + (tileRow + 1) * tileSize.h);
    // Result
    const vertexData = new (0, $5v6ry.VertexData)();
    vertexData.indices = indices;
    vertexData.positions = positions;
    vertexData.normals = normals;
    vertexData.uvs = uvs;
    return vertexData;
}
function $646061de4fd29ff7$export$ea9d2c5bab487ab0(options) {
    const indices = [];
    const positions = [];
    const normals = [];
    const uvs = [];
    let row, col;
    const filter = options.colorFilter || new (0, $7etnY.Color3)(0.3, 0.59, 0.11);
    const alphaFilter = options.alphaFilter || 0.0;
    let invert = false;
    if (options.minHeight > options.maxHeight) {
        invert = true;
        const temp = options.maxHeight;
        options.maxHeight = options.minHeight;
        options.minHeight = temp;
    }
    // Vertices
    for(row = 0; row <= options.subdivisions; row++)for(col = 0; col <= options.subdivisions; col++){
        const position = new (0, $ha1VO.Vector3)(col * options.width / options.subdivisions - options.width / 2.0, 0, (options.subdivisions - row) * options.height / options.subdivisions - options.height / 2.0);
        // Compute height
        const heightMapX = (position.x + options.width / 2) / options.width * (options.bufferWidth - 1) | 0;
        const heightMapY = (1.0 - (position.z + options.height / 2) / options.height) * (options.bufferHeight - 1) | 0;
        const pos = (heightMapX + heightMapY * options.bufferWidth) * 4;
        let r = options.buffer[pos] / 255.0;
        let g = options.buffer[pos + 1] / 255.0;
        let b = options.buffer[pos + 2] / 255.0;
        const a = options.buffer[pos + 3] / 255.0;
        if (invert) {
            r = 1.0 - r;
            g = 1.0 - g;
            b = 1.0 - b;
        }
        const gradient = r * filter.r + g * filter.g + b * filter.b;
        // If our alpha channel is not within our filter then we will assign a 'special' height
        // Then when building the indices, we will ignore any vertex that is using the special height
        if (a >= alphaFilter) position.y = options.minHeight + (options.maxHeight - options.minHeight) * gradient;
        else position.y = options.minHeight - (0, $53VPf.Epsilon); // We can't have a height below minHeight, normally.
        if (options.heightBuffer) // set the height buffer information in row major order.
        options.heightBuffer[row * (options.subdivisions + 1) + col] = position.y;
        // Add  vertex
        positions.push(position.x, position.y, position.z);
        normals.push(0, 0, 0);
        uvs.push(col / options.subdivisions, 1.0 - row / options.subdivisions);
    }
    // Indices
    for(row = 0; row < options.subdivisions; row++)for(col = 0; col < options.subdivisions; col++){
        // Calculate Indices
        const idx1 = col + 1 + (row + 1) * (options.subdivisions + 1);
        const idx2 = col + 1 + row * (options.subdivisions + 1);
        const idx3 = col + row * (options.subdivisions + 1);
        const idx4 = col + (row + 1) * (options.subdivisions + 1);
        // Check that all indices are visible (based on our special height)
        // Only display the vertex if all Indices are visible
        // Positions are stored x,y,z for each vertex, hence the * 3 and + 1 for height
        const isVisibleIdx1 = positions[idx1 * 3 + 1] >= options.minHeight;
        const isVisibleIdx2 = positions[idx2 * 3 + 1] >= options.minHeight;
        const isVisibleIdx3 = positions[idx3 * 3 + 1] >= options.minHeight;
        if (isVisibleIdx1 && isVisibleIdx2 && isVisibleIdx3) {
            indices.push(idx1);
            indices.push(idx2);
            indices.push(idx3);
        }
        const isVisibleIdx4 = positions[idx4 * 3 + 1] >= options.minHeight;
        if (isVisibleIdx4 && isVisibleIdx1 && isVisibleIdx3) {
            indices.push(idx4);
            indices.push(idx1);
            indices.push(idx3);
        }
    }
    // Normals
    (0, $5v6ry.VertexData).ComputeNormals(positions, indices, normals);
    // Result
    const vertexData = new (0, $5v6ry.VertexData)();
    vertexData.indices = indices;
    vertexData.positions = positions;
    vertexData.normals = normals;
    vertexData.uvs = uvs;
    return vertexData;
}
function $646061de4fd29ff7$export$36f42a4c5f351a31(name, options = {}, scene) {
    const ground = new (0, $1cCRP.GroundMesh)(name, scene);
    ground._setReady(false);
    ground._subdivisionsX = options.subdivisionsX || options.subdivisions || 1;
    ground._subdivisionsY = options.subdivisionsY || options.subdivisions || 1;
    ground._width = options.width || 1;
    ground._height = options.height || 1;
    ground._maxX = ground._width / 2;
    ground._maxZ = ground._height / 2;
    ground._minX = -ground._maxX;
    ground._minZ = -ground._maxZ;
    const vertexData = $646061de4fd29ff7$export$ae47f6dc1ba8f3ec(options);
    vertexData.applyToMesh(ground, options.updatable);
    ground._setReady(true);
    return ground;
}
function $646061de4fd29ff7$export$c78da18d8c5de609(name, options, scene = null) {
    const tiledGround = new (0, $fbuqw.Mesh)(name, scene);
    const vertexData = $646061de4fd29ff7$export$af0f3de94a9367a1(options);
    vertexData.applyToMesh(tiledGround, options.updatable);
    return tiledGround;
}
function $646061de4fd29ff7$export$1106a851f720f529(name, url, options = {}, scene = null) {
    const width = options.width || 10.0;
    const height = options.height || 10.0;
    const subdivisions = options.subdivisions || 1;
    const minHeight = options.minHeight || 0.0;
    const maxHeight = options.maxHeight || 1.0;
    const filter = options.colorFilter || new (0, $7etnY.Color3)(0.3, 0.59, 0.11);
    const alphaFilter = options.alphaFilter || 0.0;
    const updatable = options.updatable;
    const onReady = options.onReady;
    scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
    const ground = new (0, $1cCRP.GroundMesh)(name, scene);
    ground._subdivisionsX = subdivisions;
    ground._subdivisionsY = subdivisions;
    ground._width = width;
    ground._height = height;
    ground._maxX = ground._width / 2.0;
    ground._maxZ = ground._height / 2.0;
    ground._minX = -ground._maxX;
    ground._minZ = -ground._maxZ;
    ground._setReady(false);
    let heightBuffer;
    if (options.passHeightBufferInCallback) heightBuffer = new Float32Array((subdivisions + 1) * (subdivisions + 1));
    const onBufferLoaded = (buffer, bufferWidth, bufferHeight)=>{
        const vertexData = $646061de4fd29ff7$export$ea9d2c5bab487ab0({
            width: width,
            height: height,
            subdivisions: subdivisions,
            minHeight: minHeight,
            maxHeight: maxHeight,
            colorFilter: filter,
            buffer: buffer,
            bufferWidth: bufferWidth,
            bufferHeight: bufferHeight,
            alphaFilter: alphaFilter,
            heightBuffer: heightBuffer
        });
        vertexData.applyToMesh(ground, updatable);
        //execute ready callback, if set
        if (onReady) onReady(ground, heightBuffer);
        ground._setReady(true);
    };
    if (typeof url === "string") {
        const onload = (img)=>{
            const bufferWidth = img.width;
            const bufferHeight = img.height;
            if (scene.isDisposed) return;
            const buffer = scene?.getEngine().resizeImageBitmap(img, bufferWidth, bufferHeight);
            onBufferLoaded(buffer, bufferWidth, bufferHeight);
        };
        (0, $bOhSV.Tools).LoadImage(url, onload, options.onError ? options.onError : ()=>{}, scene.offlineProvider);
    } else onBufferLoaded(url.data, url.width, url.height);
    return ground;
}
const $646061de4fd29ff7$export$517861b98adbb032 = {
    CreateGround: // eslint-disable-next-line @typescript-eslint/naming-convention
    $646061de4fd29ff7$export$36f42a4c5f351a31,
    CreateGroundFromHeightMap: // eslint-disable-next-line @typescript-eslint/naming-convention
    $646061de4fd29ff7$export$1106a851f720f529,
    CreateTiledGround: // eslint-disable-next-line @typescript-eslint/naming-convention
    $646061de4fd29ff7$export$c78da18d8c5de609
};
(0, $5v6ry.VertexData).CreateGround = $646061de4fd29ff7$export$ae47f6dc1ba8f3ec;
(0, $5v6ry.VertexData).CreateTiledGround = $646061de4fd29ff7$export$af0f3de94a9367a1;
(0, $5v6ry.VertexData).CreateGroundFromHeightMap = $646061de4fd29ff7$export$ea9d2c5bab487ab0;
(0, $fbuqw.Mesh).CreateGround = (name, width, height, subdivisions, scene, updatable)=>{
    const options = {
        width: width,
        height: height,
        subdivisions: subdivisions,
        updatable: updatable
    };
    return $646061de4fd29ff7$export$36f42a4c5f351a31(name, options, scene);
};
(0, $fbuqw.Mesh).CreateTiledGround = (name, xmin, zmin, xmax, zmax, subdivisions, precision, scene, updatable)=>{
    const options = {
        xmin: xmin,
        zmin: zmin,
        xmax: xmax,
        zmax: zmax,
        subdivisions: subdivisions,
        precision: precision,
        updatable: updatable
    };
    return $646061de4fd29ff7$export$c78da18d8c5de609(name, options, scene);
};
(0, $fbuqw.Mesh).CreateGroundFromHeightMap = (name, url, width, height, subdivisions, minHeight, maxHeight, scene, updatable, onReady, alphaFilter)=>{
    const options = {
        width: width,
        height: height,
        subdivisions: subdivisions,
        minHeight: minHeight,
        maxHeight: maxHeight,
        updatable: updatable,
        onReady: onReady,
        alphaFilter: alphaFilter
    };
    return $646061de4fd29ff7$export$1106a851f720f529(name, url, options, scene);
};

});
parcelRegister("1cCRP", function(module, exports) {

$parcel$export(module.exports, "GroundMesh", () => $0e050fa3c8fa4c95$export$c798fdfefb9e9068);

var $ha1VO = parcelRequire("ha1VO");

var $b4i1f = parcelRequire("b4i1f");

var $fbuqw = parcelRequire("fbuqw");
(0, $fbuqw.Mesh)._GroundMeshParser = (parsedMesh, scene)=>{
    return $0e050fa3c8fa4c95$export$c798fdfefb9e9068.Parse(parsedMesh, scene);
};
class $0e050fa3c8fa4c95$export$c798fdfefb9e9068 extends (0, $fbuqw.Mesh) {
    constructor(name, scene){
        super(name, scene);
        /** If octree should be generated */ this.generateOctree = false;
    }
    /**
     * "GroundMesh"
     * @returns "GroundMesh"
     */ getClassName() {
        return "GroundMesh";
    }
    /**
     * The minimum of x and y subdivisions
     */ get subdivisions() {
        return Math.min(this._subdivisionsX, this._subdivisionsY);
    }
    /**
     * X subdivisions
     */ get subdivisionsX() {
        return this._subdivisionsX;
    }
    /**
     * Y subdivisions
     */ get subdivisionsY() {
        return this._subdivisionsY;
    }
    /**
     * This function will divide the mesh into submeshes and update an octree to help to select the right submeshes
     * for rendering, picking and collision computations. Please note that you must have a decent number of submeshes
     * to get performance improvements when using an octree.
     * @param chunksCount the number of submeshes the mesh will be divided into
     * @param octreeBlocksSize the maximum size of the octree blocks (Default: 32)
     */ optimize(chunksCount, octreeBlocksSize = 32) {
        this._subdivisionsX = chunksCount;
        this._subdivisionsY = chunksCount;
        this.subdivide(chunksCount);
        // Call the octree system optimization if it is defined.
        const thisAsAny = this;
        if (thisAsAny.createOrUpdateSubmeshesOctree) thisAsAny.createOrUpdateSubmeshesOctree(octreeBlocksSize);
    }
    /**
     * Returns a height (y) value in the World system :
     * the ground altitude at the coordinates (x, z) expressed in the World system.
     * @param x x coordinate
     * @param z z coordinate
     * @returns the ground y position if (x, z) are outside the ground surface.
     */ getHeightAtCoordinates(x, z) {
        const world = this.getWorldMatrix();
        const invMat = (0, $ha1VO.TmpVectors).Matrix[5];
        world.invertToRef(invMat);
        const tmpVect = (0, $ha1VO.TmpVectors).Vector3[8];
        (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(x, 0.0, z, invMat, tmpVect); // transform x,z in the mesh local space
        x = tmpVect.x;
        z = tmpVect.z;
        if (x < this._minX || x >= this._maxX || z <= this._minZ || z > this._maxZ) return this.position.y;
        if (!this._heightQuads || this._heightQuads.length == 0) {
            this._initHeightQuads();
            this._computeHeightQuads();
        }
        const facet = this._getFacetAt(x, z);
        const y = -(facet.x * x + facet.z * z + facet.w) / facet.y;
        // return y in the World system
        (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(0.0, y, 0.0, world, tmpVect);
        return tmpVect.y;
    }
    /**
     * Returns a normalized vector (Vector3) orthogonal to the ground
     * at the ground coordinates (x, z) expressed in the World system.
     * @param x x coordinate
     * @param z z coordinate
     * @returns Vector3(0.0, 1.0, 0.0) if (x, z) are outside the ground surface.
     */ getNormalAtCoordinates(x, z) {
        const normal = new (0, $ha1VO.Vector3)(0.0, 1.0, 0.0);
        this.getNormalAtCoordinatesToRef(x, z, normal);
        return normal;
    }
    /**
     * Updates the Vector3 passed a reference with a normalized vector orthogonal to the ground
     * at the ground coordinates (x, z) expressed in the World system.
     * Doesn't update the reference Vector3 if (x, z) are outside the ground surface.
     * @param x x coordinate
     * @param z z coordinate
     * @param ref vector to store the result
     * @returns the GroundMesh.
     */ getNormalAtCoordinatesToRef(x, z, ref) {
        const world = this.getWorldMatrix();
        const tmpMat = (0, $ha1VO.TmpVectors).Matrix[5];
        world.invertToRef(tmpMat);
        const tmpVect = (0, $ha1VO.TmpVectors).Vector3[8];
        (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(x, 0.0, z, tmpMat, tmpVect); // transform x,z in the mesh local space
        x = tmpVect.x;
        z = tmpVect.z;
        if (x < this._minX || x > this._maxX || z < this._minZ || z > this._maxZ) return this;
        if (!this._heightQuads || this._heightQuads.length == 0) {
            this._initHeightQuads();
            this._computeHeightQuads();
        }
        const facet = this._getFacetAt(x, z);
        (0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(facet.x, facet.y, facet.z, world, ref);
        return this;
    }
    /**
     * Force the heights to be recomputed for getHeightAtCoordinates() or getNormalAtCoordinates()
     * if the ground has been updated.
     * This can be used in the render loop.
     * @returns the GroundMesh.
     */ updateCoordinateHeights() {
        if (!this._heightQuads || this._heightQuads.length == 0) this._initHeightQuads();
        this._computeHeightQuads();
        return this;
    }
    // Returns the element "facet" from the heightQuads array relative to (x, z) local coordinates
    _getFacetAt(x, z) {
        // retrieve col and row from x, z coordinates in the ground local system
        const col = Math.floor((x + this._maxX) * this._subdivisionsX / this._width);
        const row = Math.floor(-(z + this._maxZ) * this._subdivisionsY / this._height + this._subdivisionsY);
        const quad = this._heightQuads[row * this._subdivisionsX + col];
        let facet;
        if (z < quad.slope.x * x + quad.slope.y) facet = quad.facet1;
        else facet = quad.facet2;
        return facet;
    }
    //  Creates and populates the heightMap array with "facet" elements :
    // a quad is two triangular facets separated by a slope, so a "facet" element is 1 slope + 2 facets
    // slope : Vector2(c, h) = 2D diagonal line equation setting apart two triangular facets in a quad : z = cx + h
    // facet1 : Vector4(a, b, c, d) = first facet 3D plane equation : ax + by + cz + d = 0
    // facet2 :  Vector4(a, b, c, d) = second facet 3D plane equation : ax + by + cz + d = 0
    // Returns the GroundMesh.
    _initHeightQuads() {
        const subdivisionsX = this._subdivisionsX;
        const subdivisionsY = this._subdivisionsY;
        this._heightQuads = new Array();
        for(let row = 0; row < subdivisionsY; row++)for(let col = 0; col < subdivisionsX; col++){
            const quad = {
                slope: (0, $ha1VO.Vector2).Zero(),
                facet1: new (0, $ha1VO.Vector4)(0.0, 0.0, 0.0, 0.0),
                facet2: new (0, $ha1VO.Vector4)(0.0, 0.0, 0.0, 0.0)
            };
            this._heightQuads[row * subdivisionsX + col] = quad;
        }
        return this;
    }
    // Compute each quad element values and update the heightMap array :
    // slope : Vector2(c, h) = 2D diagonal line equation setting apart two triangular facets in a quad : z = cx + h
    // facet1 : Vector4(a, b, c, d) = first facet 3D plane equation : ax + by + cz + d = 0
    // facet2 :  Vector4(a, b, c, d) = second facet 3D plane equation : ax + by + cz + d = 0
    // Returns the GroundMesh.
    _computeHeightQuads() {
        const positions = this.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        if (!positions) return this;
        const v1 = (0, $ha1VO.TmpVectors).Vector3[3];
        const v2 = (0, $ha1VO.TmpVectors).Vector3[2];
        const v3 = (0, $ha1VO.TmpVectors).Vector3[1];
        const v4 = (0, $ha1VO.TmpVectors).Vector3[0];
        const v1v2 = (0, $ha1VO.TmpVectors).Vector3[4];
        const v1v3 = (0, $ha1VO.TmpVectors).Vector3[5];
        const v1v4 = (0, $ha1VO.TmpVectors).Vector3[6];
        const norm1 = (0, $ha1VO.TmpVectors).Vector3[7];
        const norm2 = (0, $ha1VO.TmpVectors).Vector3[8];
        let i = 0;
        let j = 0;
        let k = 0;
        let cd = 0; // 2D slope coefficient : z = cd * x + h
        let h = 0;
        let d1 = 0; // facet plane equation : ax + by + cz + d = 0
        let d2 = 0;
        const subdivisionsX = this._subdivisionsX;
        const subdivisionsY = this._subdivisionsY;
        for(let row = 0; row < subdivisionsY; row++)for(let col = 0; col < subdivisionsX; col++){
            i = col * 3;
            j = row * (subdivisionsX + 1) * 3;
            k = (row + 1) * (subdivisionsX + 1) * 3;
            v1.x = positions[j + i];
            v1.y = positions[j + i + 1];
            v1.z = positions[j + i + 2];
            v2.x = positions[j + i + 3];
            v2.y = positions[j + i + 4];
            v2.z = positions[j + i + 5];
            v3.x = positions[k + i];
            v3.y = positions[k + i + 1];
            v3.z = positions[k + i + 2];
            v4.x = positions[k + i + 3];
            v4.y = positions[k + i + 4];
            v4.z = positions[k + i + 5];
            // 2D slope V1V4
            cd = (v4.z - v1.z) / (v4.x - v1.x);
            h = v1.z - cd * v1.x; // v1 belongs to the slope
            // facet equations :
            // we compute each facet normal vector
            // the equation of the facet plane is : norm.x * x + norm.y * y + norm.z * z + d = 0
            // we compute the value d by applying the equation to v1 which belongs to the plane
            // then we store the facet equation in a Vector4
            v2.subtractToRef(v1, v1v2);
            v3.subtractToRef(v1, v1v3);
            v4.subtractToRef(v1, v1v4);
            (0, $ha1VO.Vector3).CrossToRef(v1v4, v1v3, norm1); // caution : CrossToRef uses the Tmp class
            (0, $ha1VO.Vector3).CrossToRef(v1v2, v1v4, norm2);
            norm1.normalize();
            norm2.normalize();
            d1 = -(norm1.x * v1.x + norm1.y * v1.y + norm1.z * v1.z);
            d2 = -(norm2.x * v2.x + norm2.y * v2.y + norm2.z * v2.z);
            const quad = this._heightQuads[row * subdivisionsX + col];
            quad.slope.copyFromFloats(cd, h);
            quad.facet1.copyFromFloats(norm1.x, norm1.y, norm1.z, d1);
            quad.facet2.copyFromFloats(norm2.x, norm2.y, norm2.z, d2);
        }
        return this;
    }
    /**
     * Serializes this ground mesh
     * @param serializationObject object to write serialization to
     */ serialize(serializationObject) {
        super.serialize(serializationObject);
        serializationObject.subdivisionsX = this._subdivisionsX;
        serializationObject.subdivisionsY = this._subdivisionsY;
        serializationObject.minX = this._minX;
        serializationObject.maxX = this._maxX;
        serializationObject.minZ = this._minZ;
        serializationObject.maxZ = this._maxZ;
        serializationObject.width = this._width;
        serializationObject.height = this._height;
    }
    /**
     * Parses a serialized ground mesh
     * @param parsedMesh the serialized mesh
     * @param scene the scene to create the ground mesh in
     * @returns the created ground mesh
     */ static Parse(parsedMesh, scene) {
        const result = new $0e050fa3c8fa4c95$export$c798fdfefb9e9068(parsedMesh.name, scene);
        result._subdivisionsX = parsedMesh.subdivisionsX || 1;
        result._subdivisionsY = parsedMesh.subdivisionsY || 1;
        result._minX = parsedMesh.minX;
        result._maxX = parsedMesh.maxX;
        result._minZ = parsedMesh.minZ;
        result._maxZ = parsedMesh.maxZ;
        result._width = parsedMesh.width;
        result._height = parsedMesh.height;
        return result;
    }
}

});


parcelRegister("bCJrn", function(module, exports) {

$parcel$export(module.exports, "CreateTorusVertexData", () => $87667de2ca334d5c$export$9d57ec7ebb41da6e);
$parcel$export(module.exports, "CreateTorus", () => $87667de2ca334d5c$export$51ab2f2e5b6ce5fb);
$parcel$export(module.exports, "TorusBuilder", () => $87667de2ca334d5c$export$f0867b191e0a11e);

var $ha1VO = parcelRequire("ha1VO");

var $fbuqw = parcelRequire("fbuqw");

var $5v6ry = parcelRequire("5v6ry");

var $fGXjI = parcelRequire("fGXjI");
function $87667de2ca334d5c$export$9d57ec7ebb41da6e(options) {
    const indices = [];
    const positions = [];
    const normals = [];
    const uvs = [];
    const diameter = options.diameter || 1;
    const thickness = options.thickness || 0.5;
    const tessellation = (options.tessellation || 16) | 0;
    const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || (0, $5v6ry.VertexData).DEFAULTSIDE;
    const stride = tessellation + 1;
    for(let i = 0; i <= tessellation; i++){
        const u = i / tessellation;
        const outerAngle = i * Math.PI * 2.0 / tessellation - Math.PI / 2.0;
        const transform = (0, $ha1VO.Matrix).Translation(diameter / 2.0, 0, 0).multiply((0, $ha1VO.Matrix).RotationY(outerAngle));
        for(let j = 0; j <= tessellation; j++){
            const v = 1 - j / tessellation;
            const innerAngle = j * Math.PI * 2.0 / tessellation + Math.PI;
            const dx = Math.cos(innerAngle);
            const dy = Math.sin(innerAngle);
            // Create a vertex.
            let normal = new (0, $ha1VO.Vector3)(dx, dy, 0);
            let position = normal.scale(thickness / 2);
            const textureCoordinate = new (0, $ha1VO.Vector2)(u, v);
            position = (0, $ha1VO.Vector3).TransformCoordinates(position, transform);
            normal = (0, $ha1VO.Vector3).TransformNormal(normal, transform);
            positions.push(position.x, position.y, position.z);
            normals.push(normal.x, normal.y, normal.z);
            uvs.push(textureCoordinate.x, (0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? 1.0 - textureCoordinate.y : textureCoordinate.y);
            // And create indices for two triangles.
            const nextI = (i + 1) % stride;
            const nextJ = (j + 1) % stride;
            indices.push(i * stride + j);
            indices.push(i * stride + nextJ);
            indices.push(nextI * stride + j);
            indices.push(i * stride + nextJ);
            indices.push(nextI * stride + nextJ);
            indices.push(nextI * stride + j);
        }
    }
    // Sides
    (0, $5v6ry.VertexData)._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
    // Result
    const vertexData = new (0, $5v6ry.VertexData)();
    vertexData.indices = indices;
    vertexData.positions = positions;
    vertexData.normals = normals;
    vertexData.uvs = uvs;
    return vertexData;
}
function $87667de2ca334d5c$export$51ab2f2e5b6ce5fb(name, options = {}, scene) {
    const torus = new (0, $fbuqw.Mesh)(name, scene);
    options.sideOrientation = (0, $fbuqw.Mesh)._GetDefaultSideOrientation(options.sideOrientation);
    torus._originalBuilderSideOrientation = options.sideOrientation;
    const vertexData = $87667de2ca334d5c$export$9d57ec7ebb41da6e(options);
    vertexData.applyToMesh(torus, options.updatable);
    return torus;
}
const $87667de2ca334d5c$export$f0867b191e0a11e = {
    CreateTorus: // eslint-disable-next-line @typescript-eslint/naming-convention
    $87667de2ca334d5c$export$51ab2f2e5b6ce5fb
};
(0, $5v6ry.VertexData).CreateTorus = $87667de2ca334d5c$export$9d57ec7ebb41da6e;
(0, $fbuqw.Mesh).CreateTorus = (name, diameter, thickness, tessellation, scene, updatable, sideOrientation)=>{
    const options = {
        diameter: diameter,
        thickness: thickness,
        tessellation: tessellation,
        sideOrientation: sideOrientation,
        updatable: updatable
    };
    return $87667de2ca334d5c$export$51ab2f2e5b6ce5fb(name, options, scene);
};

});



parcelRegister("asrBe", function(module, exports) {

var $5NLSr = parcelRequire("5NLSr");

var $2ZWLA = parcelRequire("2ZWLA");

var $iAaRG = parcelRequire("iAaRG");
$parcel$exportWildcard(module.exports, $5NLSr);
$parcel$exportWildcard(module.exports, $2ZWLA);
$parcel$exportWildcard(module.exports, $iAaRG);

});


parcelRegister("1aZcZ", function(module, exports) {

var $dZ6LB = parcelRequire("dZ6LB");

var $6aMne = parcelRequire("6aMne");

var $gzCma = parcelRequire("gzCma");

var $iKm71 = parcelRequire("iKm71");

var $dng66 = parcelRequire("dng66");
$parcel$exportWildcard(module.exports, $dZ6LB);
$parcel$exportWildcard(module.exports, $6aMne);
$parcel$exportWildcard(module.exports, $gzCma);
$parcel$exportWildcard(module.exports, $iKm71);
$parcel$exportWildcard(module.exports, $dng66);

});
parcelRegister("dZ6LB", function(module, exports) {

$parcel$export(module.exports, "Collider", () => $a2e638976456fac9$export$b7c6eef0ebb06133);

var $ha1VO = parcelRequire("ha1VO");

var $23POp = parcelRequire("23POp");
const $a2e638976456fac9$var$intersectBoxAASphere = (boxMin, boxMax, sphereCenter, sphereRadius)=>{
    if (boxMin.x > sphereCenter.x + sphereRadius) return false;
    if (sphereCenter.x - sphereRadius > boxMax.x) return false;
    if (boxMin.y > sphereCenter.y + sphereRadius) return false;
    if (sphereCenter.y - sphereRadius > boxMax.y) return false;
    if (boxMin.z > sphereCenter.z + sphereRadius) return false;
    if (sphereCenter.z - sphereRadius > boxMax.z) return false;
    return true;
};
const $a2e638976456fac9$var$getLowestRoot = function() {
    const result = {
        root: 0,
        found: false
    };
    return function(a, b, c, maxR) {
        result.root = 0;
        result.found = false;
        const determinant = b * b - 4.0 * a * c;
        if (determinant < 0) return result;
        const sqrtD = Math.sqrt(determinant);
        let r1 = (-b - sqrtD) / (2.0 * a);
        let r2 = (-b + sqrtD) / (2.0 * a);
        if (r1 > r2) {
            const temp = r2;
            r2 = r1;
            r1 = temp;
        }
        if (r1 > 0 && r1 < maxR) {
            result.root = r1;
            result.found = true;
            return result;
        }
        if (r2 > 0 && r2 < maxR) {
            result.root = r2;
            result.found = true;
            return result;
        }
        return result;
    };
}();
class $a2e638976456fac9$export$b7c6eef0ebb06133 {
    constructor(){
        // Implementation of the "Improved Collision detection and Response" algorithm proposed by Kasper Fauerby
        // https://www.peroxide.dk/papers/collision/collision.pdf
        this._collisionPoint = (0, $ha1VO.Vector3).Zero();
        this._planeIntersectionPoint = (0, $ha1VO.Vector3).Zero();
        this._tempVector = (0, $ha1VO.Vector3).Zero();
        this._tempVector2 = (0, $ha1VO.Vector3).Zero();
        this._tempVector3 = (0, $ha1VO.Vector3).Zero();
        this._tempVector4 = (0, $ha1VO.Vector3).Zero();
        this._edge = (0, $ha1VO.Vector3).Zero();
        this._baseToVertex = (0, $ha1VO.Vector3).Zero();
        this._destinationPoint = (0, $ha1VO.Vector3).Zero();
        this._slidePlaneNormal = (0, $ha1VO.Vector3).Zero();
        this._displacementVector = (0, $ha1VO.Vector3).Zero();
        /** @internal */ this._radius = (0, $ha1VO.Vector3).One();
        /** @internal */ this._retry = 0;
        /** @internal */ this._basePointWorld = (0, $ha1VO.Vector3).Zero();
        this._velocityWorld = (0, $ha1VO.Vector3).Zero();
        this._normalizedVelocity = (0, $ha1VO.Vector3).Zero();
        this._collisionMask = -1;
    }
    get collisionMask() {
        return this._collisionMask;
    }
    set collisionMask(mask) {
        this._collisionMask = !isNaN(mask) ? mask : -1;
    }
    /**
     * Gets the plane normal used to compute the sliding response (in local space)
     */ get slidePlaneNormal() {
        return this._slidePlaneNormal;
    }
    // Methods
    /**
     * @internal
     */ _initialize(source, dir, e) {
        this._velocity = dir;
        this._velocitySquaredLength = this._velocity.lengthSquared();
        const len = Math.sqrt(this._velocitySquaredLength);
        if (len === 0 || len === 1.0) this._normalizedVelocity.copyFromFloats(dir._x, dir._y, dir._z);
        else dir.scaleToRef(1.0 / len, this._normalizedVelocity);
        this._basePoint = source;
        source.multiplyToRef(this._radius, this._basePointWorld);
        dir.multiplyToRef(this._radius, this._velocityWorld);
        this._velocityWorldLength = this._velocityWorld.length();
        this._epsilon = e;
        this.collisionFound = false;
    }
    /**
     * @internal
     */ _checkPointInTriangle(point, pa, pb, pc, n) {
        pa.subtractToRef(point, this._tempVector);
        pb.subtractToRef(point, this._tempVector2);
        (0, $ha1VO.Vector3).CrossToRef(this._tempVector, this._tempVector2, this._tempVector4);
        let d = (0, $ha1VO.Vector3).Dot(this._tempVector4, n);
        if (d < 0) return false;
        pc.subtractToRef(point, this._tempVector3);
        (0, $ha1VO.Vector3).CrossToRef(this._tempVector2, this._tempVector3, this._tempVector4);
        d = (0, $ha1VO.Vector3).Dot(this._tempVector4, n);
        if (d < 0) return false;
        (0, $ha1VO.Vector3).CrossToRef(this._tempVector3, this._tempVector, this._tempVector4);
        d = (0, $ha1VO.Vector3).Dot(this._tempVector4, n);
        return d >= 0;
    }
    /**
     * @internal
     */ _canDoCollision(sphereCenter, sphereRadius, vecMin, vecMax) {
        const distance = (0, $ha1VO.Vector3).Distance(this._basePointWorld, sphereCenter);
        const max = Math.max(this._radius.x, this._radius.y, this._radius.z);
        if (distance > this._velocityWorldLength + max + sphereRadius) return false;
        if (!$a2e638976456fac9$var$intersectBoxAASphere(vecMin, vecMax, this._basePointWorld, this._velocityWorldLength + max)) return false;
        return true;
    }
    /**
     * @internal
     */ _testTriangle(faceIndex, trianglePlaneArray, p1, p2, p3, hasMaterial, hostMesh) {
        let t0;
        let embeddedInPlane = false;
        //defensive programming, actually not needed.
        if (!trianglePlaneArray) trianglePlaneArray = [];
        if (!trianglePlaneArray[faceIndex]) {
            trianglePlaneArray[faceIndex] = new (0, $23POp.Plane)(0, 0, 0, 0);
            trianglePlaneArray[faceIndex].copyFromPoints(p1, p2, p3);
        }
        const trianglePlane = trianglePlaneArray[faceIndex];
        if (!hasMaterial && !trianglePlane.isFrontFacingTo(this._normalizedVelocity, 0)) return;
        const signedDistToTrianglePlane = trianglePlane.signedDistanceTo(this._basePoint);
        const normalDotVelocity = (0, $ha1VO.Vector3).Dot(trianglePlane.normal, this._velocity);
        // if DoubleSidedCheck is false(default), a double sided face will be consided 2 times.
        // if true, it discard the faces having normal not facing velocity
        if ($a2e638976456fac9$export$b7c6eef0ebb06133.DoubleSidedCheck && normalDotVelocity > 0.0001) return;
        if (normalDotVelocity == 0) {
            if (Math.abs(signedDistToTrianglePlane) >= 1.0) return;
            embeddedInPlane = true;
            t0 = 0;
        } else {
            t0 = (-1 - signedDistToTrianglePlane) / normalDotVelocity;
            let t1 = (1.0 - signedDistToTrianglePlane) / normalDotVelocity;
            if (t0 > t1) {
                const temp = t1;
                t1 = t0;
                t0 = temp;
            }
            if (t0 > 1.0 || t1 < 0.0) return;
            if (t0 < 0) t0 = 0;
            if (t0 > 1.0) t0 = 1.0;
        }
        this._collisionPoint.copyFromFloats(0, 0, 0);
        let found = false;
        let t = 1.0;
        if (!embeddedInPlane) {
            this._basePoint.subtractToRef(trianglePlane.normal, this._planeIntersectionPoint);
            this._velocity.scaleToRef(t0, this._tempVector);
            this._planeIntersectionPoint.addInPlace(this._tempVector);
            if (this._checkPointInTriangle(this._planeIntersectionPoint, p1, p2, p3, trianglePlane.normal)) {
                found = true;
                t = t0;
                this._collisionPoint.copyFrom(this._planeIntersectionPoint);
            }
        }
        if (!found) {
            let a = this._velocitySquaredLength;
            this._basePoint.subtractToRef(p1, this._tempVector);
            let b = 2.0 * (0, $ha1VO.Vector3).Dot(this._velocity, this._tempVector);
            let c = this._tempVector.lengthSquared() - 1.0;
            let lowestRoot = $a2e638976456fac9$var$getLowestRoot(a, b, c, t);
            if (lowestRoot.found) {
                t = lowestRoot.root;
                found = true;
                this._collisionPoint.copyFrom(p1);
            }
            this._basePoint.subtractToRef(p2, this._tempVector);
            b = 2.0 * (0, $ha1VO.Vector3).Dot(this._velocity, this._tempVector);
            c = this._tempVector.lengthSquared() - 1.0;
            lowestRoot = $a2e638976456fac9$var$getLowestRoot(a, b, c, t);
            if (lowestRoot.found) {
                t = lowestRoot.root;
                found = true;
                this._collisionPoint.copyFrom(p2);
            }
            this._basePoint.subtractToRef(p3, this._tempVector);
            b = 2.0 * (0, $ha1VO.Vector3).Dot(this._velocity, this._tempVector);
            c = this._tempVector.lengthSquared() - 1.0;
            lowestRoot = $a2e638976456fac9$var$getLowestRoot(a, b, c, t);
            if (lowestRoot.found) {
                t = lowestRoot.root;
                found = true;
                this._collisionPoint.copyFrom(p3);
            }
            p2.subtractToRef(p1, this._edge);
            p1.subtractToRef(this._basePoint, this._baseToVertex);
            let edgeSquaredLength = this._edge.lengthSquared();
            let edgeDotVelocity = (0, $ha1VO.Vector3).Dot(this._edge, this._velocity);
            let edgeDotBaseToVertex = (0, $ha1VO.Vector3).Dot(this._edge, this._baseToVertex);
            a = edgeSquaredLength * -this._velocitySquaredLength + edgeDotVelocity * edgeDotVelocity;
            b = 2 * (edgeSquaredLength * (0, $ha1VO.Vector3).Dot(this._velocity, this._baseToVertex) - edgeDotVelocity * edgeDotBaseToVertex);
            c = edgeSquaredLength * (1.0 - this._baseToVertex.lengthSquared()) + edgeDotBaseToVertex * edgeDotBaseToVertex;
            lowestRoot = $a2e638976456fac9$var$getLowestRoot(a, b, c, t);
            if (lowestRoot.found) {
                const f = (edgeDotVelocity * lowestRoot.root - edgeDotBaseToVertex) / edgeSquaredLength;
                if (f >= 0.0 && f <= 1.0) {
                    t = lowestRoot.root;
                    found = true;
                    this._edge.scaleInPlace(f);
                    p1.addToRef(this._edge, this._collisionPoint);
                }
            }
            p3.subtractToRef(p2, this._edge);
            p2.subtractToRef(this._basePoint, this._baseToVertex);
            edgeSquaredLength = this._edge.lengthSquared();
            edgeDotVelocity = (0, $ha1VO.Vector3).Dot(this._edge, this._velocity);
            edgeDotBaseToVertex = (0, $ha1VO.Vector3).Dot(this._edge, this._baseToVertex);
            a = edgeSquaredLength * -this._velocitySquaredLength + edgeDotVelocity * edgeDotVelocity;
            b = 2 * (edgeSquaredLength * (0, $ha1VO.Vector3).Dot(this._velocity, this._baseToVertex) - edgeDotVelocity * edgeDotBaseToVertex);
            c = edgeSquaredLength * (1.0 - this._baseToVertex.lengthSquared()) + edgeDotBaseToVertex * edgeDotBaseToVertex;
            lowestRoot = $a2e638976456fac9$var$getLowestRoot(a, b, c, t);
            if (lowestRoot.found) {
                const f = (edgeDotVelocity * lowestRoot.root - edgeDotBaseToVertex) / edgeSquaredLength;
                if (f >= 0.0 && f <= 1.0) {
                    t = lowestRoot.root;
                    found = true;
                    this._edge.scaleInPlace(f);
                    p2.addToRef(this._edge, this._collisionPoint);
                }
            }
            p1.subtractToRef(p3, this._edge);
            p3.subtractToRef(this._basePoint, this._baseToVertex);
            edgeSquaredLength = this._edge.lengthSquared();
            edgeDotVelocity = (0, $ha1VO.Vector3).Dot(this._edge, this._velocity);
            edgeDotBaseToVertex = (0, $ha1VO.Vector3).Dot(this._edge, this._baseToVertex);
            a = edgeSquaredLength * -this._velocitySquaredLength + edgeDotVelocity * edgeDotVelocity;
            b = 2 * (edgeSquaredLength * (0, $ha1VO.Vector3).Dot(this._velocity, this._baseToVertex) - edgeDotVelocity * edgeDotBaseToVertex);
            c = edgeSquaredLength * (1.0 - this._baseToVertex.lengthSquared()) + edgeDotBaseToVertex * edgeDotBaseToVertex;
            lowestRoot = $a2e638976456fac9$var$getLowestRoot(a, b, c, t);
            if (lowestRoot.found) {
                const f = (edgeDotVelocity * lowestRoot.root - edgeDotBaseToVertex) / edgeSquaredLength;
                if (f >= 0.0 && f <= 1.0) {
                    t = lowestRoot.root;
                    found = true;
                    this._edge.scaleInPlace(f);
                    p3.addToRef(this._edge, this._collisionPoint);
                }
            }
        }
        if (found) {
            const distToCollisionSquared = t * t * this._velocitySquaredLength;
            if (!this.collisionFound || distToCollisionSquared < this._nearestDistanceSquared) {
                // if collisionResponse is false, collision is not found but the collidedMesh is set anyway.
                // onCollide observable are triggered if collideMesh is set
                // this allow trigger volumes to be created.
                if (hostMesh.collisionResponse) {
                    if (!this.intersectionPoint) this.intersectionPoint = this._collisionPoint.clone();
                    else this.intersectionPoint.copyFrom(this._collisionPoint);
                    this._nearestDistanceSquared = distToCollisionSquared;
                    this._nearestDistance = Math.sqrt(distToCollisionSquared);
                    this.collisionFound = true;
                }
                this.collidedMesh = hostMesh;
            }
        }
    }
    /**
     * @internal
     */ _collide(trianglePlaneArray, pts, indices, indexStart, indexEnd, decal, hasMaterial, hostMesh, invertTriangles, triangleStrip = false) {
        if (triangleStrip) {
            if (!indices || indices.length === 0) for(let i = 0; i < pts.length - 2; i += 1){
                const p1 = pts[i];
                const p2 = pts[i + 1];
                const p3 = pts[i + 2];
                // stay defensive and don't check against undefined positions.
                if (!p1 || !p2 || !p3) continue;
                // Handles strip faces one on two is reversed
                if ((invertTriangles ? 1 : 0) ^ i % 2) this._testTriangle(i, trianglePlaneArray, p1, p2, p3, hasMaterial, hostMesh);
                else this._testTriangle(i, trianglePlaneArray, p2, p1, p3, hasMaterial, hostMesh);
            }
            else for(let i = indexStart; i < indexEnd - 2; i += 1){
                const indexA = indices[i];
                const indexB = indices[i + 1];
                const indexC = indices[i + 2];
                if (indexC === 0xffffffff) {
                    i += 2;
                    continue;
                }
                const p1 = pts[indexA];
                const p2 = pts[indexB];
                const p3 = pts[indexC];
                // stay defensive and don't check against undefined positions.
                if (!p1 || !p2 || !p3) continue;
                // Handles strip faces one on two is reversed
                if ((invertTriangles ? 1 : 0) ^ i % 2) this._testTriangle(i, trianglePlaneArray, p1, p2, p3, hasMaterial, hostMesh);
                else this._testTriangle(i, trianglePlaneArray, p2, p1, p3, hasMaterial, hostMesh);
            }
        } else if (!indices || indices.length === 0) for(let i = 0; i < pts.length; i += 3){
            const p1 = pts[i];
            const p2 = pts[i + 1];
            const p3 = pts[i + 2];
            if (invertTriangles) this._testTriangle(i, trianglePlaneArray, p1, p2, p3, hasMaterial, hostMesh);
            else this._testTriangle(i, trianglePlaneArray, p3, p2, p1, hasMaterial, hostMesh);
        }
        else for(let i = indexStart; i < indexEnd; i += 3){
            const p1 = pts[indices[i] - decal];
            const p2 = pts[indices[i + 1] - decal];
            const p3 = pts[indices[i + 2] - decal];
            if (invertTriangles) this._testTriangle(i, trianglePlaneArray, p1, p2, p3, hasMaterial, hostMesh);
            else this._testTriangle(i, trianglePlaneArray, p3, p2, p1, hasMaterial, hostMesh);
        }
    }
    /**
     * @internal
     */ _getResponse(pos, vel) {
        pos.addToRef(vel, this._destinationPoint);
        vel.scaleInPlace(this._nearestDistance / vel.length());
        this._basePoint.addToRef(vel, pos);
        pos.subtractToRef(this.intersectionPoint, this._slidePlaneNormal);
        this._slidePlaneNormal.normalize();
        this._slidePlaneNormal.scaleToRef(this._epsilon, this._displacementVector);
        pos.addInPlace(this._displacementVector);
        this.intersectionPoint.addInPlace(this._displacementVector);
        this._slidePlaneNormal.scaleInPlace((0, $23POp.Plane).SignedDistanceToPlaneFromPositionAndNormal(this.intersectionPoint, this._slidePlaneNormal, this._destinationPoint));
        this._destinationPoint.subtractInPlace(this._slidePlaneNormal);
        this._destinationPoint.subtractToRef(this.intersectionPoint, vel);
    }
}
/**
 * If true, it check for double sided faces and only returns 1 collision instead of 2
 */ $a2e638976456fac9$export$b7c6eef0ebb06133.DoubleSidedCheck = false;

});

parcelRegister("6aMne", function(module, exports) {

$parcel$export(module.exports, "DefaultCollisionCoordinator", () => $47e9333e7216e460$export$566aa2f840dbb766);

var $gmbCk = parcelRequire("gmbCk");

var $ha1VO = parcelRequire("ha1VO");

var $5YkyR = parcelRequire("5YkyR");

var $dZ6LB = parcelRequire("dZ6LB");
class $47e9333e7216e460$export$566aa2f840dbb766 {
    constructor(){
        this._scaledPosition = (0, $ha1VO.Vector3).Zero();
        this._scaledVelocity = (0, $ha1VO.Vector3).Zero();
        this._finalPosition = (0, $ha1VO.Vector3).Zero();
    }
    getNewPosition(position, displacement, collider, maximumRetry, excludedMesh, onNewPosition, collisionIndex) {
        position.divideToRef(collider._radius, this._scaledPosition);
        displacement.divideToRef(collider._radius, this._scaledVelocity);
        collider.collidedMesh = null;
        collider._retry = 0;
        collider._initialVelocity = this._scaledVelocity;
        collider._initialPosition = this._scaledPosition;
        this._collideWithWorld(this._scaledPosition, this._scaledVelocity, collider, maximumRetry, this._finalPosition, excludedMesh);
        this._finalPosition.multiplyInPlace(collider._radius);
        //run the callback
        onNewPosition(collisionIndex, this._finalPosition, collider.collidedMesh);
    }
    createCollider() {
        return new (0, $dZ6LB.Collider)();
    }
    init(scene) {
        this._scene = scene;
    }
    _collideWithWorld(position, velocity, collider, maximumRetry, finalPosition, excludedMesh = null) {
        const closeDistance = (0, $5YkyR.Engine).CollisionsEpsilon * 10.0;
        if (collider._retry >= maximumRetry) {
            finalPosition.copyFrom(position);
            return;
        }
        // Check if this is a mesh else camera or -1
        const collisionMask = excludedMesh ? excludedMesh.collisionMask : collider.collisionMask;
        collider._initialize(position, velocity, closeDistance);
        // Check if collision detection should happen against specified list of meshes or,
        // if not specified, against all meshes in the scene
        const meshes = excludedMesh && excludedMesh.surroundingMeshes || this._scene.meshes;
        for(let index = 0; index < meshes.length; index++){
            const mesh = meshes[index];
            if (mesh.isEnabled() && mesh.checkCollisions && mesh.subMeshes && mesh !== excludedMesh && (collisionMask & mesh.collisionGroup) !== 0) mesh._checkCollision(collider);
        }
        if (!collider.collisionFound) {
            position.addToRef(velocity, finalPosition);
            return;
        }
        if (velocity.x !== 0 || velocity.y !== 0 || velocity.z !== 0) collider._getResponse(position, velocity);
        if (velocity.length() <= closeDistance) {
            finalPosition.copyFrom(position);
            return;
        }
        collider._retry++;
        this._collideWithWorld(position, velocity, collider, maximumRetry, finalPosition, excludedMesh);
    }
}
(0, $gmbCk.Scene).CollisionCoordinatorFactory = ()=>{
    return new $47e9333e7216e460$export$566aa2f840dbb766();
};

});


parcelRegister("iZjJh", function(module, exports) {

var $1chVU = parcelRequire("1chVU");

var $iX4ps = parcelRequire("iX4ps");
$parcel$exportWildcard(module.exports, $1chVU);
$parcel$exportWildcard(module.exports, $iX4ps);

});
parcelRegister("1chVU", function(module, exports) {

$parcel$export(module.exports, "ComputeEffect", () => $0df4d2888999b1e8$export$8e3ae81883c7695c);

var $kVtWi = parcelRequire("kVtWi");

var $diGQf = parcelRequire("diGQf");

var $jFz47 = parcelRequire("jFz47");

var $kbQ0z = parcelRequire("kbQ0z");

var $68BIi = parcelRequire("68BIi");

var $8WI3I = parcelRequire("8WI3I");
class $0df4d2888999b1e8$export$8e3ae81883c7695c {
    /**
     * Creates a compute effect that can be used to execute a compute shader
     * @param baseName Name of the effect
     * @param options Set of all options to create the effect
     * @param engine The engine the effect is created for
     * @param key Effect Key identifying uniquely compiled shader variants
     */ constructor(baseName, options, engine, key = ""){
        /**
         * Name of the effect.
         */ this.name = null;
        /**
         * String container all the define statements that should be set on the shader.
         */ this.defines = "";
        /**
         * Callback that will be called when the shader is compiled.
         */ this.onCompiled = null;
        /**
         * Callback that will be called if an error occurs during shader compilation.
         */ this.onError = null;
        /**
         * Unique ID of the effect.
         */ this.uniqueId = 0;
        /**
         * Observable that will be called when the shader is compiled.
         * It is recommended to use executeWhenCompile() or to make sure that scene.isReady() is called to get this observable raised.
         */ this.onCompileObservable = new (0, $diGQf.Observable)();
        /**
         * Observable that will be called if an error occurs during shader compilation.
         */ this.onErrorObservable = new (0, $diGQf.Observable)();
        /**
         * Observable that will be called when effect is bound.
         */ this.onBindObservable = new (0, $diGQf.Observable)();
        /**
         * @internal
         * Specifies if the effect was previously ready
         */ this._wasPreviouslyReady = false;
        this._isReady = false;
        this._compilationError = "";
        /** @internal */ this._key = "";
        this._computeSourceCodeOverride = "";
        /** @internal */ this._pipelineContext = null;
        /** @internal */ this._computeSourceCode = "";
        this._rawComputeSourceCode = "";
        this._shaderLanguage = (0, $8WI3I.ShaderLanguage).WGSL;
        this.name = baseName;
        this._key = key;
        this._engine = engine;
        this.uniqueId = $0df4d2888999b1e8$export$8e3ae81883c7695c._UniqueIdSeed++;
        this.defines = options.defines ?? "";
        this.onError = options.onError;
        this.onCompiled = options.onCompiled;
        this._entryPoint = options.entryPoint ?? "main";
        this._shaderStore = (0, $68BIi.ShaderStore).GetShadersStore(this._shaderLanguage);
        this._shaderRepository = (0, $68BIi.ShaderStore).GetShadersRepository(this._shaderLanguage);
        this._includeShaderStore = (0, $68BIi.ShaderStore).GetIncludesShadersStore(this._shaderLanguage);
        let computeSource;
        const hostDocument = (0, $jFz47.IsWindowObjectExist)() ? this._engine.getHostDocument() : null;
        if (baseName.computeSource) computeSource = "source:" + baseName.computeSource;
        else if (baseName.computeElement) {
            computeSource = hostDocument ? hostDocument.getElementById(baseName.computeElement) : null;
            if (!computeSource) computeSource = baseName.computeElement;
        } else computeSource = baseName.compute || baseName;
        const processorOptions = {
            defines: this.defines.split("\n"),
            indexParameters: undefined,
            isFragment: false,
            shouldUseHighPrecisionShader: false,
            processor: null,
            supportsUniformBuffers: this._engine.supportsUniformBuffers,
            shadersRepository: this._shaderRepository,
            includesShadersStore: this._includeShaderStore,
            version: (this._engine.version * 100).toString(),
            platformName: this._engine.shaderPlatformName,
            processingContext: null,
            isNDCHalfZRange: this._engine.isNDCHalfZRange,
            useReverseDepthBuffer: this._engine.useReverseDepthBuffer
        };
        this._loadShader(computeSource, "Compute", "", (computeCode)=>{
            (0, $kbQ0z.ShaderProcessor).Initialize(processorOptions);
            (0, $kbQ0z.ShaderProcessor).PreProcess(computeCode, processorOptions, (migratedCommputeCode)=>{
                this._rawComputeSourceCode = computeCode;
                if (options.processFinalCode) migratedCommputeCode = options.processFinalCode(migratedCommputeCode);
                const finalShaders = (0, $kbQ0z.ShaderProcessor).Finalize(migratedCommputeCode, "", processorOptions);
                this._useFinalCode(finalShaders.vertexCode, baseName);
            }, this._engine);
        });
    }
    _useFinalCode(migratedCommputeCode, baseName) {
        if (baseName) {
            const compute = baseName.computeElement || baseName.compute || baseName.spectorName || baseName;
            this._computeSourceCode = "//#define SHADER_NAME compute:" + compute + "\n" + migratedCommputeCode;
        } else this._computeSourceCode = migratedCommputeCode;
        this._prepareEffect();
    }
    /**
     * Unique key for this effect
     */ get key() {
        return this._key;
    }
    /**
     * If the effect has been compiled and prepared.
     * @returns if the effect is compiled and prepared.
     */ isReady() {
        try {
            return this._isReadyInternal();
        } catch  {
            return false;
        }
    }
    _isReadyInternal() {
        if (this._isReady) return true;
        if (this._pipelineContext) return this._pipelineContext.isReady;
        return false;
    }
    /**
     * The engine the effect was initialized with.
     * @returns the engine.
     */ getEngine() {
        return this._engine;
    }
    /**
     * The pipeline context for this effect
     * @returns the associated pipeline context
     */ getPipelineContext() {
        return this._pipelineContext;
    }
    /**
     * The error from the last compilation.
     * @returns the error string.
     */ getCompilationError() {
        return this._compilationError;
    }
    /**
     * Adds a callback to the onCompiled observable and call the callback immediately if already ready.
     * @param func The callback to be used.
     */ executeWhenCompiled(func) {
        if (this.isReady()) {
            func(this);
            return;
        }
        this.onCompileObservable.add((effect)=>{
            func(effect);
        });
        if (!this._pipelineContext || this._pipelineContext.isAsync) setTimeout(()=>{
            this._checkIsReady(null);
        }, 16);
    }
    _checkIsReady(previousPipelineContext) {
        try {
            if (this._isReadyInternal()) return;
        } catch (e) {
            this._processCompilationErrors(e, previousPipelineContext);
            return;
        }
        setTimeout(()=>{
            this._checkIsReady(previousPipelineContext);
        }, 16);
    }
    _loadShader(shader, key, optionalKey, callback) {
        if (typeof HTMLElement !== "undefined") // DOM element ?
        {
            if (shader instanceof HTMLElement) {
                const shaderCode = (0, $jFz47.GetDOMTextContent)(shader);
                callback(shaderCode);
                return;
            }
        }
        // Direct source ?
        if (shader.substr(0, 7) === "source:") {
            callback(shader.substr(7));
            return;
        }
        // Base64 encoded ?
        if (shader.substr(0, 7) === "base64:") {
            const shaderBinary = window.atob(shader.substr(7));
            callback(shaderBinary);
            return;
        }
        // Is in local store ?
        if (this._shaderStore[shader + key + "Shader"]) {
            callback(this._shaderStore[shader + key + "Shader"]);
            return;
        }
        if (optionalKey && this._shaderStore[shader + optionalKey + "Shader"]) {
            callback(this._shaderStore[shader + optionalKey + "Shader"]);
            return;
        }
        let shaderUrl;
        if (shader[0] === "." || shader[0] === "/" || shader.indexOf("http") > -1) shaderUrl = shader;
        else shaderUrl = this._shaderRepository + shader;
        this._engine._loadFile(shaderUrl + "." + key.toLowerCase() + ".fx", callback);
    }
    /**
     * Gets the compute shader source code of this effect
     */ get computeSourceCode() {
        return this._computeSourceCodeOverride ? this._computeSourceCodeOverride : this._pipelineContext?._getComputeShaderCode() ?? this._computeSourceCode;
    }
    /**
     * Gets the compute shader source code before it has been processed by the preprocessor
     */ get rawComputeSourceCode() {
        return this._rawComputeSourceCode;
    }
    /**
     * Prepares the effect
     * @internal
     */ _prepareEffect() {
        const defines = this.defines;
        const previousPipelineContext = this._pipelineContext;
        this._isReady = false;
        try {
            const engine = this._engine;
            this._pipelineContext = engine.createComputePipelineContext();
            this._pipelineContext._name = this._key;
            engine._prepareComputePipelineContext(this._pipelineContext, this._computeSourceCodeOverride ? this._computeSourceCodeOverride : this._computeSourceCode, this._rawComputeSourceCode, this._computeSourceCodeOverride ? null : defines, this._entryPoint);
            engine._executeWhenComputeStateIsCompiled(this._pipelineContext, ()=>{
                this._compilationError = "";
                this._isReady = true;
                if (this.onCompiled) this.onCompiled(this);
                this.onCompileObservable.notifyObservers(this);
                this.onCompileObservable.clear();
                if (previousPipelineContext) this.getEngine()._deleteComputePipelineContext(previousPipelineContext);
            });
            if (this._pipelineContext.isAsync) this._checkIsReady(previousPipelineContext);
        } catch (e) {
            this._processCompilationErrors(e, previousPipelineContext);
        }
    }
    _getShaderCodeAndErrorLine(code, error) {
        const regexp = /COMPUTE SHADER ERROR: 0:(\d+?):/;
        let errorLine = null;
        if (error && code) {
            const res = error.match(regexp);
            if (res && res.length === 2) {
                const lineNumber = parseInt(res[1]);
                const lines = code.split("\n", -1);
                if (lines.length >= lineNumber) errorLine = `Offending line [${lineNumber}] in compute code: ${lines[lineNumber - 1]}`;
            }
        }
        return [
            code,
            errorLine
        ];
    }
    _processCompilationErrors(e, previousPipelineContext = null) {
        this._compilationError = e.message;
        // Let's go through fallbacks then
        (0, $kVtWi.Logger).Error("Unable to compile compute effect:");
        (0, $kVtWi.Logger).Error("Defines:\n" + this.defines);
        if ($0df4d2888999b1e8$export$8e3ae81883c7695c.LogShaderCodeOnCompilationError) {
            let lineErrorVertex = null, code = null;
            if (this._pipelineContext?._getComputeShaderCode()) {
                [code, lineErrorVertex] = this._getShaderCodeAndErrorLine(this._pipelineContext._getComputeShaderCode(), this._compilationError);
                if (code) {
                    (0, $kVtWi.Logger).Error("Compute code:");
                    (0, $kVtWi.Logger).Error(code);
                }
            }
            if (lineErrorVertex) (0, $kVtWi.Logger).Error(lineErrorVertex);
        }
        (0, $kVtWi.Logger).Error("Error: " + this._compilationError);
        if (previousPipelineContext) {
            this._pipelineContext = previousPipelineContext;
            this._isReady = true;
            if (this.onError) this.onError(this, this._compilationError);
            this.onErrorObservable.notifyObservers(this);
        }
    }
    /**
     * Release all associated resources.
     **/ dispose() {
        if (this._pipelineContext) this._pipelineContext.dispose();
        this._engine._releaseComputeEffect(this);
    }
    /**
     * This function will add a new compute shader to the shader store
     * @param name the name of the shader
     * @param computeShader compute shader content
     */ static RegisterShader(name, computeShader) {
        (0, $68BIi.ShaderStore).GetShadersStore((0, $8WI3I.ShaderLanguage).WGSL)[`${name}ComputeShader`] = computeShader;
    }
}
$0df4d2888999b1e8$export$8e3ae81883c7695c._UniqueIdSeed = 0;
/**
 * Enable logging of the shader code when a compilation error occurs
 */ $0df4d2888999b1e8$export$8e3ae81883c7695c.LogShaderCodeOnCompilationError = true;

});

parcelRegister("iX4ps", function(module, exports) {

$parcel$export(module.exports, "ComputeShader", () => $dcc1285106db05d7$export$cdde5429dd049099);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $6Ho1L = parcelRequire("6Ho1L");

var $8DoUR = parcelRequire("8DoUR");

var $fDq5D = parcelRequire("fDq5D");

var $j2mX5 = parcelRequire("j2mX5");

var $3u0QC = parcelRequire("3u0QC");

var $kVtWi = parcelRequire("kVtWi");

var $bEkJJ = parcelRequire("bEkJJ");

var $8tOka = parcelRequire("8tOka");
class $dcc1285106db05d7$export$cdde5429dd049099 {
    /**
     * The options used to create the shader
     */ get options() {
        return this._options;
    }
    /**
     * The shaderPath used to create the shader
     */ get shaderPath() {
        return this._shaderPath;
    }
    /**
     * Instantiates a new compute shader.
     * @param name Defines the name of the compute shader in the scene
     * @param engine Defines the engine the compute shader belongs to
     * @param shaderPath Defines  the route to the shader code in one of three ways:
     *  * object: \{ compute: "custom" \}, used with ShaderStore.ShadersStoreWGSL["customComputeShader"]
     *  * object: \{ computeElement: "HTMLElementId" \}, used with shader code in script tags
     *  * object: \{ computeSource: "compute shader code string" \}, where the string contains the shader code
     *  * string: try first to find the code in ShaderStore.ShadersStoreWGSL[shaderPath + "ComputeShader"]. If not, assumes it is a file with name shaderPath.compute.fx in index.html folder.
     * @param options Define the options used to create the shader
     */ constructor(name, engine, shaderPath, options = {}){
        this._bindings = {};
        this._samplers = {};
        this._contextIsDirty = false;
        /**
         * When set to true, dispatch won't call isReady anymore and won't check if the underlying GPU resources should be (re)created because of a change in the inputs (texture, uniform buffer, etc.)
         * If you know that your inputs did not change since last time dispatch was called and that isReady() returns true, set this flag to true to improve performance
         */ this.fastMode = false;
        /**
         * Callback triggered when the shader is compiled
         */ this.onCompiled = null;
        /**
         * Callback triggered when an error occurs
         */ this.onError = null;
        this.name = name;
        this._engine = engine;
        this.uniqueId = (0, $3u0QC.UniqueIdGenerator).UniqueId;
        if (engine.enableGPUTimingMeasurements) this.gpuTimeInFrame = new (0, $8tOka.WebGPUPerfCounter)();
        if (!this._engine.getCaps().supportComputeShaders) {
            (0, $kVtWi.Logger).Error("This engine does not support compute shaders!");
            return;
        }
        if (!options.bindingsMapping) {
            (0, $kVtWi.Logger).Error("You must provide the binding mappings as browsers don't support reflection for wgsl shaders yet!");
            return;
        }
        this._context = engine.createComputeContext();
        this._shaderPath = shaderPath;
        this._options = {
            bindingsMapping: {},
            defines: [],
            ...options
        };
    }
    /**
     * Gets the current class name of the material e.g. "ComputeShader"
     * Mainly use in serialization.
     * @returns the class name
     */ getClassName() {
        return "ComputeShader";
    }
    /**
     * Binds a texture to the shader
     * @param name Binding name of the texture
     * @param texture Texture to bind
     * @param bindSampler Bind the sampler corresponding to the texture (default: true). The sampler will be bound just before the binding index of the texture
     */ setTexture(name, texture, bindSampler = true) {
        const current = this._bindings[name];
        this._bindings[name] = {
            type: bindSampler ? (0, $fDq5D.ComputeBindingType).Texture : (0, $fDq5D.ComputeBindingType).TextureWithoutSampler,
            object: texture,
            indexInGroupEntries: current?.indexInGroupEntries
        };
        this._contextIsDirty || (this._contextIsDirty = !current || current.object !== texture || current.type !== this._bindings[name].type);
    }
    /**
     * Binds a storage texture to the shader
     * @param name Binding name of the texture
     * @param texture Texture to bind
     */ setStorageTexture(name, texture) {
        const current = this._bindings[name];
        this._contextIsDirty || (this._contextIsDirty = !current || current.object !== texture);
        this._bindings[name] = {
            type: (0, $fDq5D.ComputeBindingType).StorageTexture,
            object: texture,
            indexInGroupEntries: current?.indexInGroupEntries
        };
    }
    /**
     * Binds an external texture to the shader
     * @param name Binding name of the texture
     * @param texture Texture to bind
     */ setExternalTexture(name, texture) {
        const current = this._bindings[name];
        this._contextIsDirty || (this._contextIsDirty = !current || current.object !== texture);
        this._bindings[name] = {
            type: (0, $fDq5D.ComputeBindingType).ExternalTexture,
            object: texture,
            indexInGroupEntries: current?.indexInGroupEntries
        };
    }
    /**
     * Binds a video texture to the shader (by binding the external texture attached to this video)
     * @param name Binding name of the texture
     * @param texture Texture to bind
     * @returns true if the video texture was successfully bound, else false. false will be returned if the current engine does not support external textures
     */ setVideoTexture(name, texture) {
        if (texture.externalTexture) {
            this.setExternalTexture(name, texture.externalTexture);
            return true;
        }
        return false;
    }
    /**
     * Binds a uniform buffer to the shader
     * @param name Binding name of the buffer
     * @param buffer Buffer to bind
     */ setUniformBuffer(name, buffer) {
        const current = this._bindings[name];
        this._contextIsDirty || (this._contextIsDirty = !current || current.object !== buffer);
        this._bindings[name] = {
            type: $dcc1285106db05d7$export$cdde5429dd049099._BufferIsDataBuffer(buffer) ? (0, $fDq5D.ComputeBindingType).DataBuffer : (0, $fDq5D.ComputeBindingType).UniformBuffer,
            object: buffer,
            indexInGroupEntries: current?.indexInGroupEntries
        };
    }
    /**
     * Binds a storage buffer to the shader
     * @param name Binding name of the buffer
     * @param buffer Buffer to bind
     */ setStorageBuffer(name, buffer) {
        const current = this._bindings[name];
        this._contextIsDirty || (this._contextIsDirty = !current || current.object !== buffer);
        this._bindings[name] = {
            type: $dcc1285106db05d7$export$cdde5429dd049099._BufferIsDataBuffer(buffer) ? (0, $fDq5D.ComputeBindingType).DataBuffer : (0, $fDq5D.ComputeBindingType).StorageBuffer,
            object: buffer,
            indexInGroupEntries: current?.indexInGroupEntries
        };
    }
    /**
     * Binds a texture sampler to the shader
     * @param name Binding name of the sampler
     * @param sampler Sampler to bind
     */ setTextureSampler(name, sampler) {
        const current = this._bindings[name];
        this._contextIsDirty || (this._contextIsDirty = !current || !sampler.compareSampler(current.object));
        this._bindings[name] = {
            type: (0, $fDq5D.ComputeBindingType).Sampler,
            object: sampler,
            indexInGroupEntries: current?.indexInGroupEntries
        };
    }
    /**
     * Specifies that the compute shader is ready to be executed (the compute effect and all the resources are ready)
     * @returns true if the compute shader is ready to be executed
     */ isReady() {
        let effect = this._effect;
        for(const key in this._bindings){
            const binding = this._bindings[key], type = binding.type, object = binding.object;
            switch(type){
                case (0, $fDq5D.ComputeBindingType).Texture:
                case (0, $fDq5D.ComputeBindingType).TextureWithoutSampler:
                case (0, $fDq5D.ComputeBindingType).StorageTexture:
                    {
                        const texture = object;
                        if (!texture.isReady()) return false;
                        break;
                    }
                case (0, $fDq5D.ComputeBindingType).ExternalTexture:
                    {
                        const texture = object;
                        if (!texture.isReady()) return false;
                        break;
                    }
            }
        }
        const defines = [];
        const shaderName = this._shaderPath;
        if (this._options.defines) for(let index = 0; index < this._options.defines.length; index++)defines.push(this._options.defines[index]);
        const join = defines.join("\n");
        if (this._cachedDefines !== join) {
            this._cachedDefines = join;
            effect = this._engine.createComputeEffect(shaderName, {
                defines: join,
                entryPoint: this._options.entryPoint,
                onCompiled: this.onCompiled,
                onError: this.onError
            });
            this._effect = effect;
        }
        if (!effect.isReady()) return false;
        return true;
    }
    /**
     * Dispatches (executes) the compute shader
     * @param x Number of workgroups to execute on the X dimension
     * @param y Number of workgroups to execute on the Y dimension (default: 1)
     * @param z Number of workgroups to execute on the Z dimension (default: 1)
     * @returns True if the dispatch could be done, else false (meaning either the compute effect or at least one of the bound resources was not ready)
     */ dispatch(x, y, z) {
        if (!this.fastMode) {
            if (!this.isReady()) return false;
            // If the sampling parameters of a texture bound to the shader have changed, we must clear the compute context so that it is recreated with the updated values
            // Also, if the actual (gpu) buffer used by a uniform buffer has changed, we must clear the compute context so that it is recreated with the updated value
            for(const key in this._bindings){
                const binding = this._bindings[key];
                if (!this._options.bindingsMapping[key]) throw new Error("ComputeShader ('" + this.name + "'): No binding mapping has been provided for the property '" + key + "'");
                switch(binding.type){
                    case (0, $fDq5D.ComputeBindingType).Texture:
                        {
                            const sampler = this._samplers[key];
                            const texture = binding.object;
                            if (!sampler || !texture._texture || !sampler.compareSampler(texture._texture)) {
                                this._samplers[key] = new (0, $bEkJJ.TextureSampler)().setParameters(texture.wrapU, texture.wrapV, texture.wrapR, texture.anisotropicFilteringLevel, texture._texture.samplingMode, texture._texture?._comparisonFunction);
                                this._contextIsDirty = true;
                            }
                            break;
                        }
                    case (0, $fDq5D.ComputeBindingType).ExternalTexture:
                        // we must recreate the bind groups each time if there's an external texture, because device.importExternalTexture must be called each frame
                        this._contextIsDirty = true;
                        break;
                    case (0, $fDq5D.ComputeBindingType).UniformBuffer:
                        {
                            const ubo = binding.object;
                            if (ubo.getBuffer() !== binding.buffer) {
                                binding.buffer = ubo.getBuffer();
                                this._contextIsDirty = true;
                            }
                            break;
                        }
                }
            }
            if (this._contextIsDirty) {
                this._contextIsDirty = false;
                this._context.clear();
            }
        }
        this._engine.computeDispatch(this._effect, this._context, this._bindings, x, y, z, this._options.bindingsMapping, this.gpuTimeInFrame);
        return true;
    }
    /**
     * Waits for the compute shader to be ready and executes it
     * @param x Number of workgroups to execute on the X dimension
     * @param y Number of workgroups to execute on the Y dimension (default: 1)
     * @param z Number of workgroups to execute on the Z dimension (default: 1)
     * @param delay Delay between the retries while the shader is not ready (in milliseconds - 10 by default)
     * @returns A promise that is resolved once the shader has been sent to the GPU. Note that it does not mean that the shader execution itself is finished!
     */ dispatchWhenReady(x, y, z, delay = 10) {
        return new Promise((resolve)=>{
            const check = ()=>{
                if (!this.dispatch(x, y, z)) setTimeout(check, delay);
                else resolve();
            };
            check();
        });
    }
    /**
     * Serializes this compute shader in a JSON representation
     * @returns the serialized compute shader object
     */ serialize() {
        const serializationObject = (0, $6Ho1L.SerializationHelper).Serialize(this);
        serializationObject.options = this._options;
        serializationObject.shaderPath = this._shaderPath;
        serializationObject.bindings = {};
        serializationObject.textures = {};
        for(const key in this._bindings){
            const binding = this._bindings[key];
            const object = binding.object;
            switch(binding.type){
                case (0, $fDq5D.ComputeBindingType).Texture:
                case (0, $fDq5D.ComputeBindingType).TextureWithoutSampler:
                case (0, $fDq5D.ComputeBindingType).StorageTexture:
                    {
                        const serializedData = object.serialize();
                        if (serializedData) {
                            serializationObject.textures[key] = serializedData;
                            serializationObject.bindings[key] = {
                                type: binding.type
                            };
                        }
                        break;
                    }
                case (0, $fDq5D.ComputeBindingType).UniformBuffer:
                    break;
            }
        }
        return serializationObject;
    }
    /**
     * Creates a compute shader from parsed compute shader data
     * @param source defines the JSON representation of the compute shader
     * @param scene defines the hosting scene
     * @param rootUrl defines the root URL to use to load textures and relative dependencies
     * @returns a new compute shader
     */ static Parse(source, scene, rootUrl) {
        const compute = (0, $6Ho1L.SerializationHelper).Parse(()=>new $dcc1285106db05d7$export$cdde5429dd049099(source.name, scene.getEngine(), source.shaderPath, source.options), source, scene, rootUrl);
        for(const key in source.textures){
            const binding = source.bindings[key];
            const texture = (0, $j2mX5.Texture).Parse(source.textures[key], scene, rootUrl);
            if (binding.type === (0, $fDq5D.ComputeBindingType).Texture) compute.setTexture(key, texture);
            else if (binding.type === (0, $fDq5D.ComputeBindingType).TextureWithoutSampler) compute.setTexture(key, texture, false);
            else compute.setStorageTexture(key, texture);
        }
        return compute;
    }
    static _BufferIsDataBuffer(buffer) {
        return buffer.underlyingResource !== undefined;
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $dcc1285106db05d7$export$cdde5429dd049099.prototype, "name", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $dcc1285106db05d7$export$cdde5429dd049099.prototype, "fastMode", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.ComputeShader", $dcc1285106db05d7$export$cdde5429dd049099);

});
parcelRegister("fDq5D", function(module, exports) {

$parcel$export(module.exports, "ComputeBindingType", () => $b61ebc6d71d63996$export$50e4bca4844d8eca);

var $2h5JR = parcelRequire("2h5JR");
var $b61ebc6d71d63996$export$50e4bca4844d8eca;
(function(ComputeBindingType) {
    ComputeBindingType[ComputeBindingType["Texture"] = 0] = "Texture";
    ComputeBindingType[ComputeBindingType["StorageTexture"] = 1] = "StorageTexture";
    ComputeBindingType[ComputeBindingType["UniformBuffer"] = 2] = "UniformBuffer";
    ComputeBindingType[ComputeBindingType["StorageBuffer"] = 3] = "StorageBuffer";
    ComputeBindingType[ComputeBindingType["TextureWithoutSampler"] = 4] = "TextureWithoutSampler";
    ComputeBindingType[ComputeBindingType["Sampler"] = 5] = "Sampler";
    ComputeBindingType[ComputeBindingType["ExternalTexture"] = 6] = "ExternalTexture";
    ComputeBindingType[ComputeBindingType["DataBuffer"] = 7] = "DataBuffer";
})($b61ebc6d71d63996$export$50e4bca4844d8eca || ($b61ebc6d71d63996$export$50e4bca4844d8eca = {}));
(0, $2h5JR.ThinEngine).prototype.createComputeEffect = function(baseName, options) {
    throw new Error("createComputeEffect: This engine does not support compute shaders!");
};
(0, $2h5JR.ThinEngine).prototype.createComputePipelineContext = function() {
    throw new Error("createComputePipelineContext: This engine does not support compute shaders!");
};
(0, $2h5JR.ThinEngine).prototype.createComputeContext = function() {
    return undefined;
};
(0, $2h5JR.ThinEngine).prototype.computeDispatch = function(effect, context, bindings, x, y, z, bindingsMapping) {
    throw new Error("computeDispatch: This engine does not support compute shaders!");
};
(0, $2h5JR.ThinEngine).prototype.areAllComputeEffectsReady = function() {
    return true;
};
(0, $2h5JR.ThinEngine).prototype.releaseComputeEffects = function() {};
(0, $2h5JR.ThinEngine).prototype._prepareComputePipelineContext = function(pipelineContext, computeSourceCode, rawComputeSourceCode, defines, entryPoint) {};
(0, $2h5JR.ThinEngine).prototype._rebuildComputeEffects = function() {};
(0, $2h5JR.ThinEngine).prototype._executeWhenComputeStateIsCompiled = function(pipelineContext, action) {
    action();
};
(0, $2h5JR.ThinEngine).prototype._releaseComputeEffect = function(effect) {};
(0, $2h5JR.ThinEngine).prototype._deleteComputePipelineContext = function(pipelineContext) {};

});

parcelRegister("8tOka", function(module, exports) {

$parcel$export(module.exports, "WebGPUPerfCounter", () => $62c8118728c819af$export$62343a2ed08c6d82);

var $2Fclq = parcelRequire("2Fclq");
class $62c8118728c819af$export$62343a2ed08c6d82 {
    constructor(){
        this._gpuTimeInFrameId = -1;
        /**
         * The GPU time in nanoseconds spent in the last frame
         */ this.counter = new (0, $2Fclq.PerfCounter)();
    }
    /**
     * @internal
     */ _addDuration(currentFrameId, duration) {
        if (currentFrameId < this._gpuTimeInFrameId) return;
        if (this._gpuTimeInFrameId !== currentFrameId) {
            this.counter._fetchResult();
            this.counter.fetchNewFrame();
            this.counter.addCount(duration, false);
            this._gpuTimeInFrameId = currentFrameId;
        } else this.counter.addCount(duration, false);
    }
}

});



parcelRegister("1aVAP", function(module, exports) {
/* eslint-disable import/no-internal-modules */ 
var $7iRaI = parcelRequire("7iRaI");

var $ef012 = parcelRequire("ef012");

var $aC4Bv = parcelRequire("aC4Bv");

var $foTaM = parcelRequire("foTaM");

var $3kez7 = parcelRequire("3kez7");
$parcel$exportWildcard(module.exports, $7iRaI);
$parcel$exportWildcard(module.exports, $ef012);
$parcel$exportWildcard(module.exports, $aC4Bv);
$parcel$exportWildcard(module.exports, $foTaM);
$parcel$exportWildcard(module.exports, $3kez7);

});
parcelRegister("foTaM", function(module, exports) {

var $eGlbD = parcelRequire("eGlbD");

var $1kdF2 = parcelRequire("1kdF2");

var $43toS = parcelRequire("43toS");
$parcel$exportWildcard(module.exports, $eGlbD);
$parcel$exportWildcard(module.exports, $1kdF2);
$parcel$exportWildcard(module.exports, $43toS);

});
parcelRegister("eGlbD", function(module, exports) {

$parcel$export(module.exports, "Octree", () => $ab056c2a3a751d72$export$496119a8707366b3);

var $57onU = parcelRequire("57onU");

var $1kdF2 = parcelRequire("1kdF2");
class $ab056c2a3a751d72$export$496119a8707366b3 {
    /**
     * Creates a octree
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/optimizeOctrees
     * @param creationFunc function to be used to instantiate the octree
     * @param maxBlockCapacity defines the maximum number of meshes you want on your octree's leaves (default: 64)
     * @param maxDepth defines the maximum depth (sub-levels) for your octree. Default value is 2, which means 8 8 8 = 512 blocks :) (This parameter takes precedence over capacity.)
     */ constructor(creationFunc, maxBlockCapacity, /** Defines the maximum depth (sub-levels) for your octree. Default value is 2, which means 8 8 8 = 512 blocks :) (This parameter takes precedence over capacity.) */ maxDepth = 2){
        this.maxDepth = maxDepth;
        /**
         * Content stored in the octree
         */ this.dynamicContent = [];
        this._maxBlockCapacity = maxBlockCapacity || 64;
        this._selectionContent = new (0, $57onU.SmartArrayNoDuplicate)(1024);
        this._creationFunc = creationFunc;
    }
    // Methods
    /**
     * Updates the octree by adding blocks for the passed in meshes within the min and max world parameters
     * @param worldMin worldMin for the octree blocks var blockSize = new Vector3((worldMax.x - worldMin.x) / 2, (worldMax.y - worldMin.y) / 2, (worldMax.z - worldMin.z) / 2);
     * @param worldMax worldMax for the octree blocks var blockSize = new Vector3((worldMax.x - worldMin.x) / 2, (worldMax.y - worldMin.y) / 2, (worldMax.z - worldMin.z) / 2);
     * @param entries meshes to be added to the octree blocks
     */ update(worldMin, worldMax, entries) {
        (0, $1kdF2.OctreeBlock)._CreateBlocks(worldMin, worldMax, entries, this._maxBlockCapacity, 0, this.maxDepth, this, this._creationFunc);
    }
    /**
     * Adds a mesh to the octree
     * @param entry Mesh to add to the octree
     */ addMesh(entry) {
        for(let index = 0; index < this.blocks.length; index++){
            const block = this.blocks[index];
            block.addEntry(entry);
        }
    }
    /**
     * Remove an element from the octree
     * @param entry defines the element to remove
     */ removeMesh(entry) {
        for(let index = 0; index < this.blocks.length; index++){
            const block = this.blocks[index];
            block.removeEntry(entry);
        }
    }
    /**
     * Selects an array of meshes within the frustum
     * @param frustumPlanes The frustum planes to use which will select all meshes within it
     * @param allowDuplicate If duplicate objects are allowed in the resulting object array
     * @returns array of meshes within the frustum
     */ select(frustumPlanes, allowDuplicate) {
        this._selectionContent.reset();
        for(let index = 0; index < this.blocks.length; index++){
            const block = this.blocks[index];
            block.select(frustumPlanes, this._selectionContent, allowDuplicate);
        }
        if (allowDuplicate) this._selectionContent.concat(this.dynamicContent);
        else this._selectionContent.concatWithNoDuplicate(this.dynamicContent);
        return this._selectionContent;
    }
    /**
     * Test if the octree intersect with the given bounding sphere and if yes, then add its content to the selection array
     * @param sphereCenter defines the bounding sphere center
     * @param sphereRadius defines the bounding sphere radius
     * @param allowDuplicate defines if the selection array can contains duplicated entries
     * @returns an array of objects that intersect the sphere
     */ intersects(sphereCenter, sphereRadius, allowDuplicate) {
        this._selectionContent.reset();
        for(let index = 0; index < this.blocks.length; index++){
            const block = this.blocks[index];
            block.intersects(sphereCenter, sphereRadius, this._selectionContent, allowDuplicate);
        }
        if (allowDuplicate) this._selectionContent.concat(this.dynamicContent);
        else this._selectionContent.concatWithNoDuplicate(this.dynamicContent);
        return this._selectionContent;
    }
    /**
     * Test if the octree intersect with the given ray and if yes, then add its content to resulting array
     * @param ray defines the ray to test with
     * @returns array of intersected objects
     */ intersectsRay(ray) {
        this._selectionContent.reset();
        for(let index = 0; index < this.blocks.length; index++){
            const block = this.blocks[index];
            block.intersectsRay(ray, this._selectionContent);
        }
        this._selectionContent.concatWithNoDuplicate(this.dynamicContent);
        return this._selectionContent;
    }
}
/**
 * Adds a mesh into the octree block if it intersects the block
 * @param entry defines the mesh to try to add to the block
 * @param block defines the block where the mesh should be added
 */ $ab056c2a3a751d72$export$496119a8707366b3.CreationFuncForMeshes = (entry, block)=>{
    const boundingInfo = entry.getBoundingInfo();
    if (!entry.isBlocked && boundingInfo.boundingBox.intersectsMinMax(block.minPoint, block.maxPoint)) block.entries.push(entry);
};
/**
 * Adds a submesh into the octree block if it intersects the block
 * @param entry defines the submesh to try to add to the block
 * @param block defines the block where the submesh should be added
 */ $ab056c2a3a751d72$export$496119a8707366b3.CreationFuncForSubMeshes = (entry, block)=>{
    const boundingInfo = entry.getBoundingInfo();
    if (boundingInfo.boundingBox.intersectsMinMax(block.minPoint, block.maxPoint)) block.entries.push(entry);
};

});
parcelRegister("1kdF2", function(module, exports) {

$parcel$export(module.exports, "OctreeBlock", () => $0f724176a6367d2b$export$99a264c649a8d0c4);

var $ha1VO = parcelRequire("ha1VO");

var $7iRaI = parcelRequire("7iRaI");
class $0f724176a6367d2b$export$99a264c649a8d0c4 {
    /**
     * Creates a new block
     * @param minPoint defines the minimum vector (in world space) of the block's bounding box
     * @param maxPoint defines the maximum vector (in world space) of the block's bounding box
     * @param capacity defines the maximum capacity of this block (if capacity is reached the block will be split into sub blocks)
     * @param depth defines the current depth of this block in the octree
     * @param maxDepth defines the maximal depth allowed (beyond this value, the capacity is ignored)
     * @param creationFunc defines a callback to call when an element is added to the block
     */ constructor(minPoint, maxPoint, capacity, depth, maxDepth, creationFunc){
        /**
         * Gets the content of the current block
         */ this.entries = [];
        this._boundingVectors = new Array();
        this._capacity = capacity;
        this._depth = depth;
        this._maxDepth = maxDepth;
        this._creationFunc = creationFunc;
        this._minPoint = minPoint;
        this._maxPoint = maxPoint;
        this._boundingVectors.push(minPoint.clone());
        this._boundingVectors.push(maxPoint.clone());
        this._boundingVectors.push(minPoint.clone());
        this._boundingVectors[2].x = maxPoint.x;
        this._boundingVectors.push(minPoint.clone());
        this._boundingVectors[3].y = maxPoint.y;
        this._boundingVectors.push(minPoint.clone());
        this._boundingVectors[4].z = maxPoint.z;
        this._boundingVectors.push(maxPoint.clone());
        this._boundingVectors[5].z = minPoint.z;
        this._boundingVectors.push(maxPoint.clone());
        this._boundingVectors[6].x = minPoint.x;
        this._boundingVectors.push(maxPoint.clone());
        this._boundingVectors[7].y = minPoint.y;
    }
    // Property
    /**
     * Gets the maximum capacity of this block (if capacity is reached the block will be split into sub blocks)
     */ get capacity() {
        return this._capacity;
    }
    /**
     * Gets the minimum vector (in world space) of the block's bounding box
     */ get minPoint() {
        return this._minPoint;
    }
    /**
     * Gets the maximum vector (in world space) of the block's bounding box
     */ get maxPoint() {
        return this._maxPoint;
    }
    // Methods
    /**
     * Add a new element to this block
     * @param entry defines the element to add
     */ addEntry(entry) {
        if (this.blocks) {
            for(let index = 0; index < this.blocks.length; index++){
                const block = this.blocks[index];
                block.addEntry(entry);
            }
            return;
        }
        this._creationFunc(entry, this);
        if (this.entries.length > this.capacity && this._depth < this._maxDepth) this.createInnerBlocks();
    }
    /**
     * Remove an element from this block
     * @param entry defines the element to remove
     */ removeEntry(entry) {
        if (this.blocks) {
            for(let index = 0; index < this.blocks.length; index++){
                const block = this.blocks[index];
                block.removeEntry(entry);
            }
            return;
        }
        const entryIndex = this.entries.indexOf(entry);
        if (entryIndex > -1) this.entries.splice(entryIndex, 1);
    }
    /**
     * Add an array of elements to this block
     * @param entries defines the array of elements to add
     */ addEntries(entries) {
        for(let index = 0; index < entries.length; index++){
            const mesh = entries[index];
            this.addEntry(mesh);
        }
    }
    /**
     * Test if the current block intersects the frustum planes and if yes, then add its content to the selection array
     * @param frustumPlanes defines the frustum planes to test
     * @param selection defines the array to store current content if selection is positive
     * @param allowDuplicate defines if the selection array can contains duplicated entries
     */ select(frustumPlanes, selection, allowDuplicate) {
        if ((0, $7iRaI.BoundingBox).IsInFrustum(this._boundingVectors, frustumPlanes)) {
            if (this.blocks) {
                for(let index = 0; index < this.blocks.length; index++){
                    const block = this.blocks[index];
                    block.select(frustumPlanes, selection, allowDuplicate);
                }
                return;
            }
            if (allowDuplicate) selection.concat(this.entries);
            else selection.concatWithNoDuplicate(this.entries);
        }
    }
    /**
     * Test if the current block intersect with the given bounding sphere and if yes, then add its content to the selection array
     * @param sphereCenter defines the bounding sphere center
     * @param sphereRadius defines the bounding sphere radius
     * @param selection defines the array to store current content if selection is positive
     * @param allowDuplicate defines if the selection array can contains duplicated entries
     */ intersects(sphereCenter, sphereRadius, selection, allowDuplicate) {
        if ((0, $7iRaI.BoundingBox).IntersectsSphere(this._minPoint, this._maxPoint, sphereCenter, sphereRadius)) {
            if (this.blocks) {
                for(let index = 0; index < this.blocks.length; index++){
                    const block = this.blocks[index];
                    block.intersects(sphereCenter, sphereRadius, selection, allowDuplicate);
                }
                return;
            }
            if (allowDuplicate) selection.concat(this.entries);
            else selection.concatWithNoDuplicate(this.entries);
        }
    }
    /**
     * Test if the current block intersect with the given ray and if yes, then add its content to the selection array
     * @param ray defines the ray to test with
     * @param selection defines the array to store current content if selection is positive
     */ intersectsRay(ray, selection) {
        if (ray.intersectsBoxMinMax(this._minPoint, this._maxPoint)) {
            if (this.blocks) {
                for(let index = 0; index < this.blocks.length; index++){
                    const block = this.blocks[index];
                    block.intersectsRay(ray, selection);
                }
                return;
            }
            selection.concatWithNoDuplicate(this.entries);
        }
    }
    /**
     * Subdivide the content into child blocks (this block will then be empty)
     */ createInnerBlocks() {
        $0f724176a6367d2b$export$99a264c649a8d0c4._CreateBlocks(this._minPoint, this._maxPoint, this.entries, this._capacity, this._depth, this._maxDepth, this, this._creationFunc);
        this.entries.splice(0);
    }
    /**
     * @internal
     */ static _CreateBlocks(worldMin, worldMax, entries, maxBlockCapacity, currentDepth, maxDepth, target, creationFunc) {
        target.blocks = new Array();
        const blockSize = new (0, $ha1VO.Vector3)((worldMax.x - worldMin.x) / 2, (worldMax.y - worldMin.y) / 2, (worldMax.z - worldMin.z) / 2);
        // Segmenting space
        for(let x = 0; x < 2; x++){
            for(let y = 0; y < 2; y++)for(let z = 0; z < 2; z++){
                const localMin = worldMin.add(blockSize.multiplyByFloats(x, y, z));
                const localMax = worldMin.add(blockSize.multiplyByFloats(x + 1, y + 1, z + 1));
                const block = new $0f724176a6367d2b$export$99a264c649a8d0c4(localMin, localMax, maxBlockCapacity, currentDepth + 1, maxDepth, creationFunc);
                block.addEntries(entries);
                target.blocks.push(block);
            }
        }
    }
}

});


parcelRegister("43toS", function(module, exports) {

$parcel$export(module.exports, "OctreeSceneComponent", () => $2f3e3f7cc1bb8a6c$export$33fa977801aeb4a7);

var $gmbCk = parcelRequire("gmbCk");

var $ha1VO = parcelRequire("ha1VO");

var $0cHNL = parcelRequire("0cHNL");

var $3kez7 = parcelRequire("3kez7");

var $bv05l = parcelRequire("bv05l");

var $eGlbD = parcelRequire("eGlbD");

var $ejQPp = parcelRequire("ejQPp");
(0, $gmbCk.Scene).prototype.createOrUpdateSelectionOctree = function(maxCapacity = 64, maxDepth = 2) {
    let component = this._getComponent((0, $bv05l.SceneComponentConstants).NAME_OCTREE);
    if (!component) {
        component = new $2f3e3f7cc1bb8a6c$export$33fa977801aeb4a7(this);
        this._addComponent(component);
    }
    if (!this._selectionOctree) this._selectionOctree = new (0, $eGlbD.Octree)((0, $eGlbD.Octree).CreationFuncForMeshes, maxCapacity, maxDepth);
    const worldExtends = this.getWorldExtends();
    // Update octree
    this._selectionOctree.update(worldExtends.min, worldExtends.max, this.meshes);
    return this._selectionOctree;
};
Object.defineProperty((0, $gmbCk.Scene).prototype, "selectionOctree", {
    get: function() {
        return this._selectionOctree;
    },
    enumerable: true,
    configurable: true
});
/**
 * This function will create an octree to help to select the right submeshes for rendering, picking and collision computations.
 * Please note that you must have a decent number of submeshes to get performance improvements when using an octree
 * @param maxCapacity defines the maximum size of each block (64 by default)
 * @param maxDepth defines the maximum depth to use (no more than 2 levels by default)
 * @returns the new octree
 * @see https://www.babylonjs-playground.com/#NA4OQ#12
 * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/optimizeOctrees
 */ (0, $0cHNL.AbstractMesh).prototype.createOrUpdateSubmeshesOctree = function(maxCapacity = 64, maxDepth = 2) {
    const scene = this.getScene();
    let component = scene._getComponent((0, $bv05l.SceneComponentConstants).NAME_OCTREE);
    if (!component) {
        component = new $2f3e3f7cc1bb8a6c$export$33fa977801aeb4a7(scene);
        scene._addComponent(component);
    }
    if (!this._submeshesOctree) this._submeshesOctree = new (0, $eGlbD.Octree)((0, $eGlbD.Octree).CreationFuncForSubMeshes, maxCapacity, maxDepth);
    this.computeWorldMatrix(true);
    const boundingInfo = this.getBoundingInfo();
    // Update octree
    const bbox = boundingInfo.boundingBox;
    this._submeshesOctree.update(bbox.minimumWorld, bbox.maximumWorld, this.subMeshes);
    return this._submeshesOctree;
};
class $2f3e3f7cc1bb8a6c$export$33fa977801aeb4a7 {
    /**
     * Creates a new instance of the component for the given scene
     * @param scene Defines the scene to register the component in
     */ constructor(scene){
        /**
         * The component name help to identify the component in the list of scene components.
         */ this.name = (0, $bv05l.SceneComponentConstants).NAME_OCTREE;
        /**
         * Indicates if the meshes have been checked to make sure they are isEnabled()
         */ this.checksIsEnabled = true;
        this._tempRay = new (0, $3kez7.Ray)((0, $ha1VO.Vector3).Zero(), new (0, $ha1VO.Vector3)(1, 1, 1));
        scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        if (!scene) return;
        this.scene = scene;
        this.scene.getActiveMeshCandidates = ()=>this.getActiveMeshCandidates();
        this.scene.getActiveSubMeshCandidates = (mesh)=>this.getActiveSubMeshCandidates(mesh);
        this.scene.getCollidingSubMeshCandidates = (mesh, collider)=>this.getCollidingSubMeshCandidates(mesh, collider);
        this.scene.getIntersectingSubMeshCandidates = (mesh, localRay)=>this.getIntersectingSubMeshCandidates(mesh, localRay);
    }
    /**
     * Registers the component in a given scene
     */ register() {
        this.scene.onMeshRemovedObservable.add((mesh)=>{
            const sceneOctree = this.scene.selectionOctree;
            if (sceneOctree !== undefined && sceneOctree !== null) {
                const index = sceneOctree.dynamicContent.indexOf(mesh);
                if (index !== -1) sceneOctree.dynamicContent.splice(index, 1);
            }
        });
        this.scene.onMeshImportedObservable.add((mesh)=>{
            const sceneOctree = this.scene.selectionOctree;
            if (sceneOctree !== undefined && sceneOctree !== null) sceneOctree.addMesh(mesh);
        });
    }
    /**
     * Return the list of active meshes
     * @returns the list of active meshes
     */ getActiveMeshCandidates() {
        return this.scene._selectionOctree?.select(this.scene.frustumPlanes) || this.scene._getDefaultMeshCandidates();
    }
    /**
     * Return the list of active sub meshes
     * @param mesh The mesh to get the candidates sub meshes from
     * @returns the list of active sub meshes
     */ getActiveSubMeshCandidates(mesh) {
        if (mesh._submeshesOctree && mesh.useOctreeForRenderingSelection) {
            const intersections = mesh._submeshesOctree.select(this.scene.frustumPlanes);
            return intersections;
        }
        return this.scene._getDefaultSubMeshCandidates(mesh);
    }
    /**
     * Return the list of sub meshes intersecting with a given local ray
     * @param mesh defines the mesh to find the submesh for
     * @param localRay defines the ray in local space
     * @returns the list of intersecting sub meshes
     */ getIntersectingSubMeshCandidates(mesh, localRay) {
        if (mesh._submeshesOctree && mesh.useOctreeForPicking) {
            (0, $3kez7.Ray).TransformToRef(localRay, mesh.getWorldMatrix(), this._tempRay);
            const intersections = mesh._submeshesOctree.intersectsRay(this._tempRay);
            return intersections;
        }
        return this.scene._getDefaultSubMeshCandidates(mesh);
    }
    /**
     * Return the list of sub meshes colliding with a collider
     * @param mesh defines the mesh to find the submesh for
     * @param collider defines the collider to evaluate the collision against
     * @returns the list of colliding sub meshes
     */ getCollidingSubMeshCandidates(mesh, collider) {
        if (mesh._submeshesOctree && mesh.useOctreeForCollisions) {
            const radius = collider._velocityWorldLength + Math.max(collider._radius.x, collider._radius.y, collider._radius.z);
            const intersections = mesh._submeshesOctree.intersects(collider._basePointWorld, radius);
            return intersections;
        }
        return this.scene._getDefaultSubMeshCandidates(mesh);
    }
    /**
     * Rebuilds the elements related to this component in case of
     * context lost for instance.
     */ rebuild() {
    // Nothing to do here.
    }
    /**
     * Disposes the component and the associated resources.
     */ dispose() {
    // Nothing to do here.
    }
}

});



parcelRegister("lxwQt", function(module, exports) {

var $6ir1c = parcelRequire("6ir1c");

var $lnMr4 = parcelRequire("lnMr4");

var $gRt7v = parcelRequire("gRt7v");

var $dCaGf = parcelRequire("dCaGf");

var $esPUB = parcelRequire("esPUB");

var $hsoby = parcelRequire("hsoby");

var $cwP3a = parcelRequire("cwP3a");

var $iauJn = parcelRequire("iauJn");
$parcel$exportWildcard(module.exports, $6ir1c);
$parcel$exportWildcard(module.exports, $lnMr4);
$parcel$exportWildcard(module.exports, $gRt7v);
$parcel$exportWildcard(module.exports, $dCaGf);
$parcel$exportWildcard(module.exports, $esPUB);
$parcel$exportWildcard(module.exports, $hsoby);
$parcel$exportWildcard(module.exports, $cwP3a);
$parcel$exportWildcard(module.exports, $iauJn);

});
parcelRegister("6ir1c", function(module, exports) {

$parcel$export(module.exports, "AxesViewer", () => $495961cf5998251f$export$b6d6e23155263647);

var $ha1VO = parcelRequire("ha1VO");

var $gAH3H = parcelRequire("gAH3H");

var $iCzFv = parcelRequire("iCzFv");

var $7etnY = parcelRequire("7etnY");

var $ejQPp = parcelRequire("ejQPp");
class $495961cf5998251f$export$b6d6e23155263647 {
    /**
     * Gets or sets a number used to scale line length
     */ get scaleLines() {
        return this._scaleLines;
    }
    set scaleLines(value) {
        this._scaleLines = value;
        this._xAxis.scaling.setAll(this._scaleLines * this._scaleLinesFactor);
        this._yAxis.scaling.setAll(this._scaleLines * this._scaleLinesFactor);
        this._zAxis.scaling.setAll(this._scaleLines * this._scaleLinesFactor);
    }
    /** Gets the node hierarchy used to render x-axis */ get xAxis() {
        return this._xAxis;
    }
    /** Gets the node hierarchy used to render y-axis */ get yAxis() {
        return this._yAxis;
    }
    /** Gets the node hierarchy used to render z-axis */ get zAxis() {
        return this._zAxis;
    }
    /**
     * Creates a new AxesViewer
     * @param scene defines the hosting scene
     * @param scaleLines defines a number used to scale line length (1 by default)
     * @param renderingGroupId defines a number used to set the renderingGroupId of the meshes (2 by default)
     * @param xAxis defines the node hierarchy used to render the x-axis
     * @param yAxis defines the node hierarchy used to render the y-axis
     * @param zAxis defines the node hierarchy used to render the z-axis
     * @param lineThickness The line thickness to use when creating the arrow. defaults to 1.
     */ constructor(scene, scaleLines = 1, renderingGroupId = 2, xAxis, yAxis, zAxis, lineThickness = 1){
        this._scaleLinesFactor = 4;
        this._instanced = false;
        /**
         * Gets the hosting scene
         */ this.scene = null;
        this._scaleLines = 1;
        scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        if (!scene) return;
        if (!xAxis) {
            const redColoredMaterial = new (0, $gAH3H.StandardMaterial)("xAxisMaterial", scene);
            redColoredMaterial.disableLighting = true;
            redColoredMaterial.emissiveColor = (0, $7etnY.Color3).Red().scale(0.5);
            xAxis = (0, $iCzFv.AxisDragGizmo)._CreateArrow(scene, redColoredMaterial, lineThickness);
        }
        if (!yAxis) {
            const greenColoredMaterial = new (0, $gAH3H.StandardMaterial)("yAxisMaterial", scene);
            greenColoredMaterial.disableLighting = true;
            greenColoredMaterial.emissiveColor = (0, $7etnY.Color3).Green().scale(0.5);
            yAxis = (0, $iCzFv.AxisDragGizmo)._CreateArrow(scene, greenColoredMaterial, lineThickness);
        }
        if (!zAxis) {
            const blueColoredMaterial = new (0, $gAH3H.StandardMaterial)("zAxisMaterial", scene);
            blueColoredMaterial.disableLighting = true;
            blueColoredMaterial.emissiveColor = (0, $7etnY.Color3).Blue().scale(0.5);
            zAxis = (0, $iCzFv.AxisDragGizmo)._CreateArrow(scene, blueColoredMaterial, lineThickness);
        }
        this._xAxis = xAxis;
        this._yAxis = yAxis;
        this._zAxis = zAxis;
        this.scaleLines = scaleLines;
        if (renderingGroupId != null) {
            $495961cf5998251f$export$b6d6e23155263647._SetRenderingGroupId(this._xAxis, renderingGroupId);
            $495961cf5998251f$export$b6d6e23155263647._SetRenderingGroupId(this._yAxis, renderingGroupId);
            $495961cf5998251f$export$b6d6e23155263647._SetRenderingGroupId(this._zAxis, renderingGroupId);
        }
        this.scene = scene;
        this.update(new (0, $ha1VO.Vector3)(), (0, $ha1VO.Vector3).Right(), (0, $ha1VO.Vector3).Up(), (0, $ha1VO.Vector3).Forward());
    }
    /**
     * Force the viewer to update
     * @param position defines the position of the viewer
     * @param xaxis defines the x axis of the viewer
     * @param yaxis defines the y axis of the viewer
     * @param zaxis defines the z axis of the viewer
     */ update(position, xaxis, yaxis, zaxis) {
        this._xAxis.position.copyFrom(position);
        this._xAxis.setDirection(xaxis);
        this._yAxis.position.copyFrom(position);
        this._yAxis.setDirection(yaxis);
        this._zAxis.position.copyFrom(position);
        this._zAxis.setDirection(zaxis);
    }
    /**
     * Creates an instance of this axes viewer.
     * @returns a new axes viewer with instanced meshes
     */ createInstance() {
        const xAxis = (0, $iCzFv.AxisDragGizmo)._CreateArrowInstance(this.scene, this._xAxis);
        const yAxis = (0, $iCzFv.AxisDragGizmo)._CreateArrowInstance(this.scene, this._yAxis);
        const zAxis = (0, $iCzFv.AxisDragGizmo)._CreateArrowInstance(this.scene, this._zAxis);
        const axesViewer = new $495961cf5998251f$export$b6d6e23155263647(this.scene, this.scaleLines, null, xAxis, yAxis, zAxis);
        axesViewer._instanced = true;
        return axesViewer;
    }
    /** Releases resources */ dispose() {
        if (this._xAxis) this._xAxis.dispose(false, !this._instanced);
        if (this._yAxis) this._yAxis.dispose(false, !this._instanced);
        if (this._zAxis) this._zAxis.dispose(false, !this._instanced);
        this.scene = null;
    }
    static _SetRenderingGroupId(node, id) {
        node.getChildMeshes().forEach((mesh)=>{
            mesh.renderingGroupId = id;
        });
    }
}

});
parcelRegister("iCzFv", function(module, exports) {

$parcel$export(module.exports, "AxisDragGizmo", () => $d8e771a375467878$export$870f2c9298febf27);

var $diGQf = parcelRequire("diGQf");

var $klshO = parcelRequire("klshO");

var $fbuqw = parcelRequire("fbuqw");

var $9zY5k = parcelRequire("9zY5k");

var $dnn9Q = parcelRequire("dnn9Q");

var $5ETkU = parcelRequire("5ETkU");

var $6mCYU = parcelRequire("6mCYU");

var $gAH3H = parcelRequire("gAH3H");

var $7etnY = parcelRequire("7etnY");

var $ha1VO = parcelRequire("ha1VO");
class $d8e771a375467878$export$870f2c9298febf27 extends (0, $5ETkU.Gizmo) {
    /** Default material used to render when gizmo is not disabled or hovered */ get coloredMaterial() {
        return this._coloredMaterial;
    }
    /** Material used to render when gizmo is hovered with mouse*/ get hoverMaterial() {
        return this._hoverMaterial;
    }
    /** Material used to render when gizmo is disabled. typically grey.*/ get disableMaterial() {
        return this._disableMaterial;
    }
    /**
     * @internal
     */ static _CreateArrow(scene, material, thickness = 1, isCollider = false) {
        const arrow = new (0, $klshO.TransformNode)("arrow", scene);
        const cylinder = (0, $9zY5k.CreateCylinder)("cylinder", {
            diameterTop: 0,
            height: 0.075,
            diameterBottom: 0.0375 * (1 + (thickness - 1) / 4),
            tessellation: 96
        }, scene);
        const line = (0, $9zY5k.CreateCylinder)("cylinder", {
            diameterTop: 0.005 * thickness,
            height: 0.275,
            diameterBottom: 0.005 * thickness,
            tessellation: 96
        }, scene);
        // Position arrow pointing in its drag axis
        cylinder.parent = arrow;
        cylinder.material = material;
        cylinder.rotation.x = Math.PI / 2;
        cylinder.position.z += 0.3;
        line.parent = arrow;
        line.material = material;
        line.position.z += 0.1375;
        line.rotation.x = Math.PI / 2;
        if (isCollider) {
            line.visibility = 0;
            cylinder.visibility = 0;
        }
        return arrow;
    }
    /**
     * @internal
     */ static _CreateArrowInstance(scene, arrow) {
        const instance = new (0, $klshO.TransformNode)("arrow", scene);
        for (const mesh of arrow.getChildMeshes()){
            const childInstance = mesh.createInstance(mesh.name);
            childInstance.parent = instance;
        }
        return instance;
    }
    /**
     * Creates an AxisDragGizmo
     * @param dragAxis The axis which the gizmo will be able to drag on
     * @param color The color of the gizmo
     * @param gizmoLayer The utility layer the gizmo will be added to
     * @param parent
     * @param thickness display gizmo axis thickness
     * @param hoverColor The color of the gizmo when hovering over and dragging
     * @param disableColor The Color of the gizmo when its disabled
     */ constructor(dragAxis, color = (0, $7etnY.Color3).Gray(), gizmoLayer = (0, $6mCYU.UtilityLayerRenderer).DefaultUtilityLayer, parent = null, thickness = 1, hoverColor = (0, $7etnY.Color3).Yellow(), disableColor = (0, $7etnY.Color3).Gray()){
        super(gizmoLayer);
        this._pointerObserver = null;
        /**
         * Drag distance in babylon units that the gizmo will snap to when dragged (Default: 0)
         */ this.snapDistance = 0;
        /**
         * Event that fires each time the gizmo snaps to a new location.
         * * snapDistance is the change in distance
         */ this.onSnapObservable = new (0, $diGQf.Observable)();
        this._isEnabled = true;
        this._parent = null;
        this._dragging = false;
        this._parent = parent;
        // Create Material
        this._coloredMaterial = new (0, $gAH3H.StandardMaterial)("", gizmoLayer.utilityLayerScene);
        this._coloredMaterial.diffuseColor = color;
        this._coloredMaterial.specularColor = color.subtract(new (0, $7etnY.Color3)(0.1, 0.1, 0.1));
        this._hoverMaterial = new (0, $gAH3H.StandardMaterial)("", gizmoLayer.utilityLayerScene);
        this._hoverMaterial.diffuseColor = hoverColor;
        this._disableMaterial = new (0, $gAH3H.StandardMaterial)("", gizmoLayer.utilityLayerScene);
        this._disableMaterial.diffuseColor = disableColor;
        this._disableMaterial.alpha = 0.4;
        // Build Mesh + Collider
        const arrow = $d8e771a375467878$export$870f2c9298febf27._CreateArrow(gizmoLayer.utilityLayerScene, this._coloredMaterial, thickness);
        const collider = $d8e771a375467878$export$870f2c9298febf27._CreateArrow(gizmoLayer.utilityLayerScene, this._coloredMaterial, thickness + 4, true);
        // Add to Root Node
        this._gizmoMesh = new (0, $fbuqw.Mesh)("", gizmoLayer.utilityLayerScene);
        this._gizmoMesh.addChild(arrow);
        this._gizmoMesh.addChild(collider);
        this._gizmoMesh.lookAt(this._rootMesh.position.add(dragAxis));
        this._gizmoMesh.scaling.scaleInPlace(1 / 3);
        this._gizmoMesh.parent = this._rootMesh;
        let currentSnapDragDistance = 0;
        const tmpSnapEvent = {
            snapDistance: 0
        };
        // Add drag behavior to handle events when the gizmo is dragged
        this.dragBehavior = new (0, $dnn9Q.PointerDragBehavior)({
            dragAxis: dragAxis
        });
        this.dragBehavior.moveAttached = false;
        this.dragBehavior.updateDragPlane = false;
        this._rootMesh.addBehavior(this.dragBehavior);
        this.dragBehavior.onDragObservable.add((event)=>{
            if (this.attachedNode) {
                // Keep world translation and use it to update world transform
                // if the node has parent, the local transform properties (position, rotation, scale)
                // will be recomputed in _matrixChanged function
                let matrixChanged = false;
                // Snapping logic
                if (this.snapDistance == 0) {
                    this.attachedNode.getWorldMatrix().getTranslationToRef((0, $ha1VO.TmpVectors).Vector3[2]);
                    (0, $ha1VO.TmpVectors).Vector3[2].addInPlace(event.delta);
                    if (this.dragBehavior.validateDrag((0, $ha1VO.TmpVectors).Vector3[2])) {
                        if (this.attachedNode.position) // Required for nodes like lights
                        this.attachedNode.position.addInPlaceFromFloats(event.delta.x, event.delta.y, event.delta.z);
                        // use _worldMatrix to not force a matrix update when calling GetWorldMatrix especially with Cameras
                        this.attachedNode.getWorldMatrix().addTranslationFromFloats(event.delta.x, event.delta.y, event.delta.z);
                        this.attachedNode.updateCache();
                        matrixChanged = true;
                    }
                } else {
                    currentSnapDragDistance += event.dragDistance;
                    if (Math.abs(currentSnapDragDistance) > this.snapDistance) {
                        const dragSteps = Math.floor(Math.abs(currentSnapDragDistance) / this.snapDistance);
                        currentSnapDragDistance = currentSnapDragDistance % this.snapDistance;
                        event.delta.normalizeToRef((0, $ha1VO.TmpVectors).Vector3[1]);
                        (0, $ha1VO.TmpVectors).Vector3[1].scaleInPlace(this.snapDistance * dragSteps);
                        this.attachedNode.getWorldMatrix().getTranslationToRef((0, $ha1VO.TmpVectors).Vector3[2]);
                        (0, $ha1VO.TmpVectors).Vector3[2].addInPlace((0, $ha1VO.TmpVectors).Vector3[1]);
                        if (this.dragBehavior.validateDrag((0, $ha1VO.TmpVectors).Vector3[2])) {
                            this.attachedNode.getWorldMatrix().addTranslationFromFloats((0, $ha1VO.TmpVectors).Vector3[1].x, (0, $ha1VO.TmpVectors).Vector3[1].y, (0, $ha1VO.TmpVectors).Vector3[1].z);
                            this.attachedNode.updateCache();
                            tmpSnapEvent.snapDistance = this.snapDistance * dragSteps * Math.sign(currentSnapDragDistance);
                            this.onSnapObservable.notifyObservers(tmpSnapEvent);
                            matrixChanged = true;
                        }
                    }
                }
                if (matrixChanged) this._matrixChanged();
            }
        });
        this.dragBehavior.onDragStartObservable.add(()=>{
            this._dragging = true;
        });
        this.dragBehavior.onDragEndObservable.add(()=>{
            this._dragging = false;
        });
        const light = gizmoLayer._getSharedGizmoLight();
        light.includedOnlyMeshes = light.includedOnlyMeshes.concat(this._rootMesh.getChildMeshes(false));
        const cache = {
            gizmoMeshes: arrow.getChildMeshes(),
            colliderMeshes: collider.getChildMeshes(),
            material: this._coloredMaterial,
            hoverMaterial: this._hoverMaterial,
            disableMaterial: this._disableMaterial,
            active: false,
            dragBehavior: this.dragBehavior
        };
        this._parent?.addToAxisCache(collider, cache);
        this._pointerObserver = gizmoLayer.utilityLayerScene.onPointerObservable.add((pointerInfo)=>{
            if (this._customMeshSet) return;
            this._isHovered = !!(cache.colliderMeshes.indexOf(pointerInfo?.pickInfo?.pickedMesh) != -1);
            if (!this._parent) {
                const material = this.dragBehavior.enabled ? this._isHovered || this._dragging ? this._hoverMaterial : this._coloredMaterial : this._disableMaterial;
                this._setGizmoMeshMaterial(cache.gizmoMeshes, material);
            }
        });
        this.dragBehavior.onEnabledObservable.add((newState)=>{
            this._setGizmoMeshMaterial(cache.gizmoMeshes, newState ? cache.material : cache.disableMaterial);
        });
    }
    _attachedNodeChanged(value) {
        if (this.dragBehavior) this.dragBehavior.enabled = value ? true : false;
    }
    /**
     * If the gizmo is enabled
     */ set isEnabled(value) {
        this._isEnabled = value;
        if (!value) {
            this.attachedMesh = null;
            this.attachedNode = null;
        } else if (this._parent) {
            this.attachedMesh = this._parent.attachedMesh;
            this.attachedNode = this._parent.attachedNode;
        }
    }
    get isEnabled() {
        return this._isEnabled;
    }
    /**
     * Disposes of the gizmo
     */ dispose() {
        this.onSnapObservable.clear();
        this.gizmoLayer.utilityLayerScene.onPointerObservable.remove(this._pointerObserver);
        this.dragBehavior.detach();
        if (this._gizmoMesh) this._gizmoMesh.dispose();
        [
            this._coloredMaterial,
            this._hoverMaterial,
            this._disableMaterial
        ].forEach((matl)=>{
            if (matl) matl.dispose();
        });
        super.dispose();
    }
}

});
parcelRegister("9zY5k", function(module, exports) {

$parcel$export(module.exports, "CreateCylinderVertexData", () => $6f95fd90f7c5af1a$export$621338c722a68fde);
$parcel$export(module.exports, "CreateCylinder", () => $6f95fd90f7c5af1a$export$c71239caf0e43983);
$parcel$export(module.exports, "CylinderBuilder", () => $6f95fd90f7c5af1a$export$16476d5921a767a8);

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $fbuqw = parcelRequire("fbuqw");

var $5v6ry = parcelRequire("5v6ry");

var $gmbCk = parcelRequire("gmbCk");

var $dbxbu = parcelRequire("dbxbu");

var $fGXjI = parcelRequire("fGXjI");
function $6f95fd90f7c5af1a$export$621338c722a68fde(options) {
    const height = options.height || 2;
    let diameterTop = options.diameterTop === 0 ? 0 : options.diameterTop || options.diameter || 1;
    let diameterBottom = options.diameterBottom === 0 ? 0 : options.diameterBottom || options.diameter || 1;
    diameterTop = diameterTop || 0.00001; // Prevent broken normals
    diameterBottom = diameterBottom || 0.00001; // Prevent broken normals
    const tessellation = (options.tessellation || 24) | 0;
    const subdivisions = (options.subdivisions || 1) | 0;
    const hasRings = options.hasRings ? true : false;
    const enclose = options.enclose ? true : false;
    const cap = options.cap === 0 ? 0 : options.cap || (0, $fbuqw.Mesh).CAP_ALL;
    const arc = options.arc && (options.arc <= 0 || options.arc > 1) ? 1.0 : options.arc || 1.0;
    const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || (0, $5v6ry.VertexData).DEFAULTSIDE;
    const faceUV = options.faceUV || new Array(3);
    const faceColors = options.faceColors;
    // default face colors and UV if undefined
    const quadNb = arc !== 1 && enclose ? 2 : 0;
    const ringNb = hasRings ? subdivisions : 1;
    const surfaceNb = 2 + (1 + quadNb) * ringNb;
    let f;
    for(f = 0; f < surfaceNb; f++)if (faceColors && faceColors[f] === undefined) faceColors[f] = new (0, $7etnY.Color4)(1, 1, 1, 1);
    for(f = 0; f < surfaceNb; f++)if (faceUV && faceUV[f] === undefined) faceUV[f] = new (0, $ha1VO.Vector4)(0, 0, 1, 1);
    const indices = [];
    const positions = [];
    const normals = [];
    const uvs = [];
    const colors = [];
    const angleStep = Math.PI * 2 * arc / tessellation;
    let angle;
    let h;
    let radius;
    const tan = (diameterBottom - diameterTop) / 2 / height;
    const ringVertex = (0, $ha1VO.Vector3).Zero();
    const ringNormal = (0, $ha1VO.Vector3).Zero();
    const ringFirstVertex = (0, $ha1VO.Vector3).Zero();
    const ringFirstNormal = (0, $ha1VO.Vector3).Zero();
    const quadNormal = (0, $ha1VO.Vector3).Zero();
    const Y = (0, $dbxbu.Axis).Y;
    // positions, normals, uvs
    let i;
    let j;
    let r;
    let ringIdx = 1;
    let s = 1; // surface index
    let cs = 0;
    let v = 0;
    for(i = 0; i <= subdivisions; i++){
        h = i / subdivisions;
        radius = (h * (diameterTop - diameterBottom) + diameterBottom) / 2;
        ringIdx = hasRings && i !== 0 && i !== subdivisions ? 2 : 1;
        for(r = 0; r < ringIdx; r++){
            if (hasRings) s += r;
            if (enclose) s += 2 * r;
            for(j = 0; j <= tessellation; j++){
                angle = j * angleStep;
                // position
                ringVertex.x = Math.cos(-angle) * radius;
                ringVertex.y = -height / 2 + h * height;
                ringVertex.z = Math.sin(-angle) * radius;
                // normal
                if (diameterTop === 0 && i === subdivisions) {
                    // if no top cap, reuse former normals
                    ringNormal.x = normals[normals.length - (tessellation + 1) * 3];
                    ringNormal.y = normals[normals.length - (tessellation + 1) * 3 + 1];
                    ringNormal.z = normals[normals.length - (tessellation + 1) * 3 + 2];
                } else {
                    ringNormal.x = ringVertex.x;
                    ringNormal.z = ringVertex.z;
                    ringNormal.y = Math.sqrt(ringNormal.x * ringNormal.x + ringNormal.z * ringNormal.z) * tan;
                    ringNormal.normalize();
                }
                // keep first ring vertex values for enclose
                if (j === 0) {
                    ringFirstVertex.copyFrom(ringVertex);
                    ringFirstNormal.copyFrom(ringNormal);
                }
                positions.push(ringVertex.x, ringVertex.y, ringVertex.z);
                normals.push(ringNormal.x, ringNormal.y, ringNormal.z);
                if (hasRings) v = cs !== s ? faceUV[s].y : faceUV[s].w;
                else v = faceUV[s].y + (faceUV[s].w - faceUV[s].y) * h;
                uvs.push(faceUV[s].x + (faceUV[s].z - faceUV[s].x) * j / tessellation, (0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? 1 - v : v);
                if (faceColors) colors.push(faceColors[s].r, faceColors[s].g, faceColors[s].b, faceColors[s].a);
            }
            // if enclose, add four vertices and their dedicated normals
            if (arc !== 1 && enclose) {
                positions.push(ringVertex.x, ringVertex.y, ringVertex.z);
                positions.push(0, ringVertex.y, 0);
                positions.push(0, ringVertex.y, 0);
                positions.push(ringFirstVertex.x, ringFirstVertex.y, ringFirstVertex.z);
                (0, $ha1VO.Vector3).CrossToRef(Y, ringNormal, quadNormal);
                quadNormal.normalize();
                normals.push(quadNormal.x, quadNormal.y, quadNormal.z, quadNormal.x, quadNormal.y, quadNormal.z);
                (0, $ha1VO.Vector3).CrossToRef(ringFirstNormal, Y, quadNormal);
                quadNormal.normalize();
                normals.push(quadNormal.x, quadNormal.y, quadNormal.z, quadNormal.x, quadNormal.y, quadNormal.z);
                if (hasRings) v = cs !== s ? faceUV[s + 1].y : faceUV[s + 1].w;
                else v = faceUV[s + 1].y + (faceUV[s + 1].w - faceUV[s + 1].y) * h;
                uvs.push(faceUV[s + 1].x, (0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? 1 - v : v);
                uvs.push(faceUV[s + 1].z, (0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? 1 - v : v);
                if (hasRings) v = cs !== s ? faceUV[s + 2].y : faceUV[s + 2].w;
                else v = faceUV[s + 2].y + (faceUV[s + 2].w - faceUV[s + 2].y) * h;
                uvs.push(faceUV[s + 2].x, (0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? 1 - v : v);
                uvs.push(faceUV[s + 2].z, (0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? 1 - v : v);
                if (faceColors) {
                    colors.push(faceColors[s + 1].r, faceColors[s + 1].g, faceColors[s + 1].b, faceColors[s + 1].a);
                    colors.push(faceColors[s + 1].r, faceColors[s + 1].g, faceColors[s + 1].b, faceColors[s + 1].a);
                    colors.push(faceColors[s + 2].r, faceColors[s + 2].g, faceColors[s + 2].b, faceColors[s + 2].a);
                    colors.push(faceColors[s + 2].r, faceColors[s + 2].g, faceColors[s + 2].b, faceColors[s + 2].a);
                }
            }
            if (cs !== s) cs = s;
        }
    }
    // indices
    const e = arc !== 1 && enclose ? tessellation + 4 : tessellation; // correction of number of iteration if enclose
    i = 0;
    for(s = 0; s < subdivisions; s++){
        let i0 = 0;
        let i1 = 0;
        let i2 = 0;
        let i3 = 0;
        for(j = 0; j < tessellation; j++){
            i0 = i * (e + 1) + j;
            i1 = (i + 1) * (e + 1) + j;
            i2 = i * (e + 1) + (j + 1);
            i3 = (i + 1) * (e + 1) + (j + 1);
            indices.push(i0, i1, i2);
            indices.push(i3, i2, i1);
        }
        if (arc !== 1 && enclose) {
            // if enclose, add two quads
            indices.push(i0 + 2, i1 + 2, i2 + 2);
            indices.push(i3 + 2, i2 + 2, i1 + 2);
            indices.push(i0 + 4, i1 + 4, i2 + 4);
            indices.push(i3 + 4, i2 + 4, i1 + 4);
        }
        i = hasRings ? i + 2 : i + 1;
    }
    // Caps
    const createCylinderCap = (isTop)=>{
        const radius = isTop ? diameterTop / 2 : diameterBottom / 2;
        if (radius === 0) return;
        // Cap positions, normals & uvs
        let angle;
        let circleVector;
        let i;
        const u = isTop ? faceUV[surfaceNb - 1] : faceUV[0];
        let c = null;
        if (faceColors) c = isTop ? faceColors[surfaceNb - 1] : faceColors[0];
        // cap center
        const vbase = positions.length / 3;
        const offset = isTop ? height / 2 : -height / 2;
        const center = new (0, $ha1VO.Vector3)(0, offset, 0);
        positions.push(center.x, center.y, center.z);
        normals.push(0, isTop ? 1 : -1, 0);
        const v = u.y + (u.w - u.y) * 0.5;
        uvs.push(u.x + (u.z - u.x) * 0.5, (0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? 1 - v : v);
        if (c) colors.push(c.r, c.g, c.b, c.a);
        const textureScale = new (0, $ha1VO.Vector2)(0.5, 0.5);
        for(i = 0; i <= tessellation; i++){
            angle = Math.PI * 2 * i * arc / tessellation;
            const cos = Math.cos(-angle);
            const sin = Math.sin(-angle);
            circleVector = new (0, $ha1VO.Vector3)(cos * radius, offset, sin * radius);
            const textureCoordinate = new (0, $ha1VO.Vector2)(cos * textureScale.x + 0.5, sin * textureScale.y + 0.5);
            positions.push(circleVector.x, circleVector.y, circleVector.z);
            normals.push(0, isTop ? 1 : -1, 0);
            const v = u.y + (u.w - u.y) * textureCoordinate.y;
            uvs.push(u.x + (u.z - u.x) * textureCoordinate.x, (0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? 1 - v : v);
            if (c) colors.push(c.r, c.g, c.b, c.a);
        }
        // Cap indices
        for(i = 0; i < tessellation; i++)if (!isTop) {
            indices.push(vbase);
            indices.push(vbase + (i + 1));
            indices.push(vbase + (i + 2));
        } else {
            indices.push(vbase);
            indices.push(vbase + (i + 2));
            indices.push(vbase + (i + 1));
        }
    };
    // add caps to geometry based on cap parameter
    if (cap === (0, $fbuqw.Mesh).CAP_START || cap === (0, $fbuqw.Mesh).CAP_ALL) createCylinderCap(false);
    if (cap === (0, $fbuqw.Mesh).CAP_END || cap === (0, $fbuqw.Mesh).CAP_ALL) createCylinderCap(true);
    // Sides
    (0, $5v6ry.VertexData)._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
    const vertexData = new (0, $5v6ry.VertexData)();
    vertexData.indices = indices;
    vertexData.positions = positions;
    vertexData.normals = normals;
    vertexData.uvs = uvs;
    if (faceColors) vertexData.colors = colors;
    return vertexData;
}
function $6f95fd90f7c5af1a$export$c71239caf0e43983(name, options = {}, scene) {
    const cylinder = new (0, $fbuqw.Mesh)(name, scene);
    options.sideOrientation = (0, $fbuqw.Mesh)._GetDefaultSideOrientation(options.sideOrientation);
    cylinder._originalBuilderSideOrientation = options.sideOrientation;
    const vertexData = $6f95fd90f7c5af1a$export$621338c722a68fde(options);
    vertexData.applyToMesh(cylinder, options.updatable);
    return cylinder;
}
const $6f95fd90f7c5af1a$export$16476d5921a767a8 = {
    CreateCylinder: // eslint-disable-next-line @typescript-eslint/naming-convention
    $6f95fd90f7c5af1a$export$c71239caf0e43983
};
(0, $5v6ry.VertexData).CreateCylinder = $6f95fd90f7c5af1a$export$621338c722a68fde;
(0, $fbuqw.Mesh).CreateCylinder = (name, height, diameterTop, diameterBottom, tessellation, subdivisions, scene, updatable, sideOrientation)=>{
    if (scene === undefined || !(scene instanceof (0, $gmbCk.Scene))) {
        if (scene !== undefined) {
            sideOrientation = updatable || (0, $fbuqw.Mesh).DEFAULTSIDE;
            updatable = scene;
        }
        scene = subdivisions;
        subdivisions = 1;
    }
    const options = {
        height: height,
        diameterTop: diameterTop,
        diameterBottom: diameterBottom,
        tessellation: tessellation,
        subdivisions: subdivisions,
        sideOrientation: sideOrientation,
        updatable: updatable
    };
    return $6f95fd90f7c5af1a$export$c71239caf0e43983(name, options, scene);
};

});

parcelRegister("5ETkU", function(module, exports) {

$parcel$export(module.exports, "GizmoAnchorPoint", () => $41eb9ccb92782126$export$87f472014b06d5f2);
$parcel$export(module.exports, "GizmoCoordinatesMode", () => $41eb9ccb92782126$export$8ffa7d0201a2e9a6);
$parcel$export(module.exports, "Gizmo", () => $41eb9ccb92782126$export$c8cc3dd925ca4fe5);

var $ha1VO = parcelRequire("ha1VO");

var $fbuqw = parcelRequire("fbuqw");

var $74SKQ = parcelRequire("74SKQ");

var $6mCYU = parcelRequire("6mCYU");

var $cfkw4 = parcelRequire("cfkw4");

var $c6YWJ = parcelRequire("c6YWJ");
var $41eb9ccb92782126$export$87f472014b06d5f2;
(function(GizmoAnchorPoint) {
    /** The origin of the attached node */ GizmoAnchorPoint[GizmoAnchorPoint["Origin"] = 0] = "Origin";
    /** The pivot point of the attached node*/ GizmoAnchorPoint[GizmoAnchorPoint["Pivot"] = 1] = "Pivot";
})($41eb9ccb92782126$export$87f472014b06d5f2 || ($41eb9ccb92782126$export$87f472014b06d5f2 = {}));
var $41eb9ccb92782126$export$8ffa7d0201a2e9a6;
(function(GizmoCoordinatesMode) {
    GizmoCoordinatesMode[GizmoCoordinatesMode["World"] = 0] = "World";
    GizmoCoordinatesMode[GizmoCoordinatesMode["Local"] = 1] = "Local";
})($41eb9ccb92782126$export$8ffa7d0201a2e9a6 || ($41eb9ccb92782126$export$8ffa7d0201a2e9a6 = {}));
class $41eb9ccb92782126$export$c8cc3dd925ca4fe5 {
    /**
     * Ratio for the scale of the gizmo (Default: 1)
     */ set scaleRatio(value) {
        this._scaleRatio = value;
    }
    get scaleRatio() {
        return this._scaleRatio;
    }
    /**
     * True when the mouse pointer is hovered a gizmo mesh
     */ get isHovered() {
        return this._isHovered;
    }
    /**
     * Mesh that the gizmo will be attached to. (eg. on a drag gizmo the mesh that will be dragged)
     * * When set, interactions will be enabled
     */ get attachedMesh() {
        return this._attachedMesh;
    }
    set attachedMesh(value) {
        this._attachedMesh = value;
        if (value) this._attachedNode = value;
        this._rootMesh.setEnabled(value ? true : false);
        this._attachedNodeChanged(value);
    }
    /**
     * Node that the gizmo will be attached to. (eg. on a drag gizmo the mesh, bone or NodeTransform that will be dragged)
     * * When set, interactions will be enabled
     */ get attachedNode() {
        return this._attachedNode;
    }
    set attachedNode(value) {
        this._attachedNode = value;
        this._attachedMesh = null;
        this._rootMesh.setEnabled(value ? true : false);
        this._attachedNodeChanged(value);
    }
    /**
     * Disposes and replaces the current meshes in the gizmo with the specified mesh
     * @param mesh The mesh to replace the default mesh of the gizmo
     */ setCustomMesh(mesh) {
        if (mesh.getScene() != this.gizmoLayer.utilityLayerScene) // eslint-disable-next-line no-throw-literal
        throw "When setting a custom mesh on a gizmo, the custom meshes scene must be the same as the gizmos (eg. gizmo.gizmoLayer.utilityLayerScene)";
        this._rootMesh.getChildMeshes().forEach((c)=>{
            c.dispose();
        });
        mesh.parent = this._rootMesh;
        this._customMeshSet = true;
    }
    /**
     * Additional transform applied to the gizmo.
     * It's useful when the gizmo is attached to a bone: if the bone is part of a skeleton attached to a mesh, you should define the mesh as additionalTransformNode if you want the gizmo to be displayed at the bone's correct location.
     * Otherwise, as the gizmo is relative to the skeleton root, the mesh transformation will not be taken into account.
     */ get additionalTransformNode() {
        return this._additionalTransformNode;
    }
    set additionalTransformNode(value) {
        this._additionalTransformNode = value;
    }
    /**
     * If set the gizmo's rotation will be updated to match the attached mesh each frame (Default: true)
     * NOTE: This is only possible for meshes with uniform scaling, as otherwise it's not possible to decompose the rotation
     */ set updateGizmoRotationToMatchAttachedMesh(value) {
        this._updateGizmoRotationToMatchAttachedMesh = value;
    }
    get updateGizmoRotationToMatchAttachedMesh() {
        return this._updateGizmoRotationToMatchAttachedMesh;
    }
    /**
     * If set the gizmo's position will be updated to match the attached mesh each frame (Default: true)
     */ set updateGizmoPositionToMatchAttachedMesh(value) {
        this._updateGizmoPositionToMatchAttachedMesh = value;
    }
    get updateGizmoPositionToMatchAttachedMesh() {
        return this._updateGizmoPositionToMatchAttachedMesh;
    }
    /**
     * Defines where the gizmo will be positioned if `updateGizmoPositionToMatchAttachedMesh` is enabled.
     * (Default: GizmoAnchorPoint.Origin)
     */ set anchorPoint(value) {
        this._anchorPoint = value;
    }
    get anchorPoint() {
        return this._anchorPoint;
    }
    /**
     * Set the coordinate system to use. By default it's local.
     * But it's possible for a user to tweak so its local for translation and world for rotation.
     * In that case, setting the coordinate system will change `updateGizmoRotationToMatchAttachedMesh` and `updateGizmoPositionToMatchAttachedMesh`
     */ set coordinatesMode(coordinatesMode) {
        this._coordinatesMode = coordinatesMode;
        const local = coordinatesMode == $41eb9ccb92782126$export$8ffa7d0201a2e9a6.Local;
        this.updateGizmoRotationToMatchAttachedMesh = local;
        this.updateGizmoPositionToMatchAttachedMesh = true;
    }
    get coordinatesMode() {
        return this._coordinatesMode;
    }
    /**
     * When set, the gizmo will always appear the same size no matter where the camera is (default: true)
     */ set updateScale(value) {
        this._updateScale = value;
    }
    get updateScale() {
        return this._updateScale;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _attachedNodeChanged(value) {}
    /**
     * Creates a gizmo
     * @param gizmoLayer The utility layer the gizmo will be added to
     */ constructor(/** The utility layer the gizmo will be added to */ gizmoLayer = (0, $6mCYU.UtilityLayerRenderer).DefaultUtilityLayer){
        this.gizmoLayer = gizmoLayer;
        this._attachedMesh = null;
        this._attachedNode = null;
        this._customRotationQuaternion = null;
        /**
         * Ratio for the scale of the gizmo (Default: 1)
         */ this._scaleRatio = 1;
        /**
         * boolean updated by pointermove when a gizmo mesh is hovered
         */ this._isHovered = false;
        /**
         * If a custom mesh has been set (Default: false)
         */ this._customMeshSet = false;
        this._updateGizmoRotationToMatchAttachedMesh = true;
        this._updateGizmoPositionToMatchAttachedMesh = true;
        this._anchorPoint = $41eb9ccb92782126$export$87f472014b06d5f2.Origin;
        this._updateScale = true;
        this._coordinatesMode = $41eb9ccb92782126$export$8ffa7d0201a2e9a6.Local;
        this._interactionsEnabled = true;
        this._rightHandtoLeftHandMatrix = (0, $ha1VO.Matrix).RotationY(Math.PI);
        this._rootMesh = new (0, $fbuqw.Mesh)("gizmoRootNode", gizmoLayer.utilityLayerScene);
        this._rootMesh.rotationQuaternion = (0, $ha1VO.Quaternion).Identity();
        this._beforeRenderObserver = this.gizmoLayer.utilityLayerScene.onBeforeRenderObservable.add(()=>{
            this._update();
        });
    }
    /**
     * posture that the gizmo will be display
     * When set null, default value will be used (Quaternion(0, 0, 0, 1))
     */ get customRotationQuaternion() {
        return this._customRotationQuaternion;
    }
    set customRotationQuaternion(customRotationQuaternion) {
        this._customRotationQuaternion = customRotationQuaternion;
    }
    /**
     * Updates the gizmo to match the attached mesh's position/rotation
     */ _update() {
        if (this.attachedNode) {
            let effectiveNode = this.attachedNode;
            if (this.attachedMesh) effectiveNode = this.attachedMesh || this.attachedNode;
            // Position
            if (this.updateGizmoPositionToMatchAttachedMesh) {
                if (this.anchorPoint == $41eb9ccb92782126$export$87f472014b06d5f2.Pivot && effectiveNode.getAbsolutePivotPoint) {
                    const position = effectiveNode.getAbsolutePivotPoint();
                    this._rootMesh.position.copyFrom(position);
                } else {
                    const row = effectiveNode.getWorldMatrix().getRow(3);
                    const position = row ? row.toVector3() : new (0, $ha1VO.Vector3)(0, 0, 0);
                    this._rootMesh.position.copyFrom(position);
                }
            }
            // Rotation
            if (this.updateGizmoRotationToMatchAttachedMesh) {
                const supportedNode = effectiveNode._isMesh || effectiveNode.getClassName() === "AbstractMesh" || effectiveNode.getClassName() === "TransformNode" || effectiveNode.getClassName() === "InstancedMesh";
                const transformNode = supportedNode ? effectiveNode : undefined;
                effectiveNode.getWorldMatrix().decompose(undefined, this._rootMesh.rotationQuaternion, undefined, $41eb9ccb92782126$export$c8cc3dd925ca4fe5.PreserveScaling ? transformNode : undefined);
                this._rootMesh.rotationQuaternion.normalize();
            } else if (this._customRotationQuaternion) this._rootMesh.rotationQuaternion.copyFrom(this._customRotationQuaternion);
            else this._rootMesh.rotationQuaternion.set(0, 0, 0, 1);
            // Scale
            if (this.updateScale) {
                const activeCamera = this.gizmoLayer.utilityLayerScene.activeCamera;
                const cameraPosition = activeCamera.globalPosition;
                this._rootMesh.position.subtractToRef(cameraPosition, (0, $ha1VO.TmpVectors).Vector3[0]);
                let scale = this.scaleRatio;
                if (activeCamera.mode == (0, $74SKQ.Camera).ORTHOGRAPHIC_CAMERA) {
                    if (activeCamera.orthoTop && activeCamera.orthoBottom) {
                        const orthoHeight = activeCamera.orthoTop - activeCamera.orthoBottom;
                        scale *= orthoHeight;
                    }
                } else {
                    const camForward = activeCamera.getScene().useRightHandedSystem ? (0, $ha1VO.Vector3).RightHandedForwardReadOnly : (0, $ha1VO.Vector3).LeftHandedForwardReadOnly;
                    const direction = activeCamera.getDirection(camForward);
                    scale *= (0, $ha1VO.Vector3).Dot((0, $ha1VO.TmpVectors).Vector3[0], direction);
                }
                this._rootMesh.scaling.setAll(scale);
                // Account for handedness, similar to Matrix.decompose
                if (effectiveNode._getWorldMatrixDeterminant() < 0 && !$41eb9ccb92782126$export$c8cc3dd925ca4fe5.PreserveScaling) this._rootMesh.scaling.y *= -1;
            } else this._rootMesh.scaling.setAll(this.scaleRatio);
        }
        if (this.additionalTransformNode) {
            this._rootMesh.computeWorldMatrix(true);
            this._rootMesh.getWorldMatrix().multiplyToRef(this.additionalTransformNode.getWorldMatrix(), (0, $ha1VO.TmpVectors).Matrix[0]);
            (0, $ha1VO.TmpVectors).Matrix[0].decompose(this._rootMesh.scaling, this._rootMesh.rotationQuaternion, this._rootMesh.position);
        }
    }
    /**
     * if transform has a pivot and is not using PostMultiplyPivotMatrix, then the worldMatrix contains the pivot matrix (it's not cancelled at the end)
     * so, when extracting the world matrix component, the translation (and other components) is containing the pivot translation.
     * And the pivot is applied each frame. Removing it anyway here makes it applied only in computeWorldMatrix.
     * @param transform local transform that needs to be transform by the pivot inverse matrix
     * @param localMatrix local matrix that needs to be transform by the pivot inverse matrix
     * @param result resulting matrix transformed by pivot inverse if the transform node is using pivot without using post Multiply Pivot Matrix
     */ _handlePivotMatrixInverse(transform, localMatrix, result) {
        if (transform.isUsingPivotMatrix() && !transform.isUsingPostMultiplyPivotMatrix()) {
            transform.getPivotMatrix().invertToRef((0, $ha1VO.TmpVectors).Matrix[5]);
            (0, $ha1VO.TmpVectors).Matrix[5].multiplyToRef(localMatrix, result);
            return;
        }
        result.copyFrom(localMatrix);
    }
    /**
     * computes the rotation/scaling/position of the transform once the Node world matrix has changed.
     */ _matrixChanged() {
        if (!this._attachedNode) return;
        if (this._attachedNode._isCamera) {
            const camera = this._attachedNode;
            let worldMatrix;
            let worldMatrixUC;
            if (camera.parent) {
                const parentInv = (0, $ha1VO.TmpVectors).Matrix[1];
                camera.parent._worldMatrix.invertToRef(parentInv);
                this._attachedNode._worldMatrix.multiplyToRef(parentInv, (0, $ha1VO.TmpVectors).Matrix[0]);
                worldMatrix = (0, $ha1VO.TmpVectors).Matrix[0];
            } else worldMatrix = this._attachedNode._worldMatrix;
            if (camera.getScene().useRightHandedSystem) {
                // avoid desync with RH matrix computation. Otherwise, rotation of PI around Y axis happens each frame resulting in axis flipped because worldMatrix is computed as inverse of viewMatrix.
                this._rightHandtoLeftHandMatrix.multiplyToRef(worldMatrix, (0, $ha1VO.TmpVectors).Matrix[1]);
                worldMatrixUC = (0, $ha1VO.TmpVectors).Matrix[1];
            } else worldMatrixUC = worldMatrix;
            worldMatrixUC.decompose((0, $ha1VO.TmpVectors).Vector3[1], (0, $ha1VO.TmpVectors).Quaternion[0], (0, $ha1VO.TmpVectors).Vector3[0]);
            const inheritsTargetCamera = this._attachedNode.getClassName() === "FreeCamera" || this._attachedNode.getClassName() === "FlyCamera" || this._attachedNode.getClassName() === "ArcFollowCamera" || this._attachedNode.getClassName() === "TargetCamera" || this._attachedNode.getClassName() === "TouchCamera" || this._attachedNode.getClassName() === "UniversalCamera";
            if (inheritsTargetCamera) {
                const targetCamera = this._attachedNode;
                targetCamera.rotation = (0, $ha1VO.TmpVectors).Quaternion[0].toEulerAngles();
                if (targetCamera.rotationQuaternion) {
                    targetCamera.rotationQuaternion.copyFrom((0, $ha1VO.TmpVectors).Quaternion[0]);
                    targetCamera.rotationQuaternion.normalize();
                }
            }
            camera.position.copyFrom((0, $ha1VO.TmpVectors).Vector3[0]);
        } else if (this._attachedNode._isMesh || this._attachedNode.getClassName() === "AbstractMesh" || this._attachedNode.getClassName() === "TransformNode" || this._attachedNode.getClassName() === "InstancedMesh") {
            const transform = this._attachedNode;
            if (transform.parent) {
                const parentInv = (0, $ha1VO.TmpVectors).Matrix[0];
                const localMat = (0, $ha1VO.TmpVectors).Matrix[1];
                transform.parent.getWorldMatrix().invertToRef(parentInv);
                this._attachedNode.getWorldMatrix().multiplyToRef(parentInv, localMat);
                const matrixToDecompose = (0, $ha1VO.TmpVectors).Matrix[4];
                this._handlePivotMatrixInverse(transform, localMat, matrixToDecompose);
                matrixToDecompose.decompose((0, $ha1VO.TmpVectors).Vector3[0], (0, $ha1VO.TmpVectors).Quaternion[0], transform.position, $41eb9ccb92782126$export$c8cc3dd925ca4fe5.PreserveScaling ? transform : undefined, $41eb9ccb92782126$export$c8cc3dd925ca4fe5.UseAbsoluteScaling);
                (0, $ha1VO.TmpVectors).Quaternion[0].normalize();
                if (transform.isUsingPivotMatrix()) {
                    // Calculate the local matrix without the translation.
                    // Copied from TranslateNode.computeWorldMatrix
                    const r = (0, $ha1VO.TmpVectors).Quaternion[1];
                    (0, $ha1VO.Quaternion).RotationYawPitchRollToRef(transform.rotation.y, transform.rotation.x, transform.rotation.z, r);
                    const scaleMatrix = (0, $ha1VO.TmpVectors).Matrix[2];
                    (0, $ha1VO.Matrix).ScalingToRef(transform.scaling.x, transform.scaling.y, transform.scaling.z, scaleMatrix);
                    const rotationMatrix = (0, $ha1VO.TmpVectors).Matrix[2];
                    r.toRotationMatrix(rotationMatrix);
                    const pivotMatrix = transform.getPivotMatrix();
                    const invPivotMatrix = (0, $ha1VO.TmpVectors).Matrix[3];
                    pivotMatrix.invertToRef(invPivotMatrix);
                    pivotMatrix.multiplyToRef(scaleMatrix, (0, $ha1VO.TmpVectors).Matrix[4]);
                    (0, $ha1VO.TmpVectors).Matrix[4].multiplyToRef(rotationMatrix, (0, $ha1VO.TmpVectors).Matrix[5]);
                    (0, $ha1VO.TmpVectors).Matrix[5].multiplyToRef(invPivotMatrix, (0, $ha1VO.TmpVectors).Matrix[6]);
                    (0, $ha1VO.TmpVectors).Matrix[6].getTranslationToRef((0, $ha1VO.TmpVectors).Vector3[1]);
                    transform.position.subtractInPlace((0, $ha1VO.TmpVectors).Vector3[1]);
                }
            } else {
                const matrixToDecompose = (0, $ha1VO.TmpVectors).Matrix[4];
                this._handlePivotMatrixInverse(transform, this._attachedNode._worldMatrix, matrixToDecompose);
                matrixToDecompose.decompose((0, $ha1VO.TmpVectors).Vector3[0], (0, $ha1VO.TmpVectors).Quaternion[0], transform.position, $41eb9ccb92782126$export$c8cc3dd925ca4fe5.PreserveScaling ? transform : undefined, $41eb9ccb92782126$export$c8cc3dd925ca4fe5.UseAbsoluteScaling);
            }
            (0, $ha1VO.TmpVectors).Vector3[0].scaleInPlace(1.0 / transform.scalingDeterminant);
            transform.scaling.copyFrom((0, $ha1VO.TmpVectors).Vector3[0]);
            if (!transform.billboardMode) {
                if (transform.rotationQuaternion) {
                    transform.rotationQuaternion.copyFrom((0, $ha1VO.TmpVectors).Quaternion[0]);
                    transform.rotationQuaternion.normalize();
                } else transform.rotation = (0, $ha1VO.TmpVectors).Quaternion[0].toEulerAngles();
            }
        } else if (this._attachedNode.getClassName() === "Bone") {
            const bone = this._attachedNode;
            const parent = bone.getParent();
            if (parent) {
                const invParent = (0, $ha1VO.TmpVectors).Matrix[0];
                const boneLocalMatrix = (0, $ha1VO.TmpVectors).Matrix[1];
                parent.getFinalMatrix().invertToRef(invParent);
                bone.getFinalMatrix().multiplyToRef(invParent, boneLocalMatrix);
                const lmat = bone.getLocalMatrix();
                lmat.copyFrom(boneLocalMatrix);
            } else {
                const lmat = bone.getLocalMatrix();
                lmat.copyFrom(bone.getFinalMatrix());
            }
            bone.markAsDirty();
        } else {
            const light = this._attachedNode;
            if (light.getTypeID) {
                const type = light.getTypeID();
                if (type === (0, $c6YWJ.Light).LIGHTTYPEID_DIRECTIONALLIGHT || type === (0, $c6YWJ.Light).LIGHTTYPEID_SPOTLIGHT || type === (0, $c6YWJ.Light).LIGHTTYPEID_POINTLIGHT) {
                    const parent = light.parent;
                    if (parent) {
                        const invParent = (0, $ha1VO.TmpVectors).Matrix[0];
                        const nodeLocalMatrix = (0, $ha1VO.TmpVectors).Matrix[1];
                        parent.getWorldMatrix().invertToRef(invParent);
                        light.getWorldMatrix().multiplyToRef(invParent, nodeLocalMatrix);
                        nodeLocalMatrix.decompose(undefined, (0, $ha1VO.TmpVectors).Quaternion[0], (0, $ha1VO.TmpVectors).Vector3[0]);
                    } else this._attachedNode._worldMatrix.decompose(undefined, (0, $ha1VO.TmpVectors).Quaternion[0], (0, $ha1VO.TmpVectors).Vector3[0]);
                    // setter doesn't copy values. Need a new Vector3
                    light.position = new (0, $ha1VO.Vector3)((0, $ha1VO.TmpVectors).Vector3[0].x, (0, $ha1VO.TmpVectors).Vector3[0].y, (0, $ha1VO.TmpVectors).Vector3[0].z);
                    if (light.direction) light.direction = new (0, $ha1VO.Vector3)(light.direction.x, light.direction.y, light.direction.z);
                }
            }
        }
    }
    /**
     * refresh gizmo mesh material
     * @param gizmoMeshes
     * @param material material to apply
     */ _setGizmoMeshMaterial(gizmoMeshes, material) {
        if (gizmoMeshes) gizmoMeshes.forEach((m)=>{
            m.material = material;
            if (m.color) m.color = material.diffuseColor;
        });
    }
    /**
     * Subscribes to pointer up, down, and hover events. Used for responsive gizmos.
     * @param gizmoLayer The utility layer the gizmo will be added to
     * @param gizmoAxisCache Gizmo axis definition used for reactive gizmo UI
     * @returns {Observer<PointerInfo>} pointerObserver
     */ static GizmoAxisPointerObserver(gizmoLayer, gizmoAxisCache) {
        let dragging = false;
        const pointerObserver = gizmoLayer.utilityLayerScene.onPointerObservable.add((pointerInfo)=>{
            if (pointerInfo.pickInfo) {
                // On Hover Logic
                if (pointerInfo.type === (0, $cfkw4.PointerEventTypes).POINTERMOVE) {
                    if (dragging) return;
                    gizmoAxisCache.forEach((cache)=>{
                        if (cache.colliderMeshes && cache.gizmoMeshes) {
                            const isHovered = cache.colliderMeshes?.indexOf(pointerInfo?.pickInfo?.pickedMesh) != -1;
                            const material = cache.dragBehavior.enabled ? isHovered || cache.active ? cache.hoverMaterial : cache.material : cache.disableMaterial;
                            cache.gizmoMeshes.forEach((m)=>{
                                m.material = material;
                                if (m.color) m.color = material.diffuseColor;
                            });
                        }
                    });
                }
                // On Mouse Down
                if (pointerInfo.type === (0, $cfkw4.PointerEventTypes).POINTERDOWN) // If user Clicked Gizmo
                {
                    if (gizmoAxisCache.has(pointerInfo.pickInfo.pickedMesh?.parent)) {
                        dragging = true;
                        const statusMap = gizmoAxisCache.get(pointerInfo.pickInfo.pickedMesh?.parent);
                        statusMap.active = true;
                        gizmoAxisCache.forEach((cache)=>{
                            const isHovered = cache.colliderMeshes?.indexOf(pointerInfo?.pickInfo?.pickedMesh) != -1;
                            const material = (isHovered || cache.active) && cache.dragBehavior.enabled ? cache.hoverMaterial : cache.disableMaterial;
                            cache.gizmoMeshes.forEach((m)=>{
                                m.material = material;
                                if (m.color) m.color = material.diffuseColor;
                            });
                        });
                    }
                }
                // On Mouse Up
                if (pointerInfo.type === (0, $cfkw4.PointerEventTypes).POINTERUP) gizmoAxisCache.forEach((cache)=>{
                    cache.active = false;
                    dragging = false;
                    cache.gizmoMeshes.forEach((m)=>{
                        m.material = cache.dragBehavior.enabled ? cache.material : cache.disableMaterial;
                        if (m.color) m.color = cache.material.diffuseColor;
                    });
                });
            }
        });
        return pointerObserver;
    }
    /**
     * Disposes of the gizmo
     */ dispose() {
        this._rootMesh.dispose();
        if (this._beforeRenderObserver) this.gizmoLayer.utilityLayerScene.onBeforeRenderObservable.remove(this._beforeRenderObserver);
    }
}
/**
 * When enabled, any gizmo operation will perserve scaling sign. Default is off.
 * Only valid for TransformNode derived classes (Mesh, AbstractMesh, ...)
 */ $41eb9ccb92782126$export$c8cc3dd925ca4fe5.PreserveScaling = false;
/**
 * There are 2 ways to preserve scaling: using mesh scaling or absolute scaling. Depending of hierarchy, non uniform scaling and LH or RH coordinates. One is preferable than the other.
 * If the scaling to be preserved is the local scaling, then set this value to false.
 * Default is true which means scaling to be preserved is absolute one (with hierarchy applied)
 */ $41eb9ccb92782126$export$c8cc3dd925ca4fe5.UseAbsoluteScaling = true;

});
parcelRegister("6mCYU", function(module, exports) {

$parcel$export(module.exports, "UtilityLayerRenderer", () => $4a23090e1e5b9fda$export$45d11a7c817b34eb);

var $gmbCk = parcelRequire("gmbCk");

var $diGQf = parcelRequire("diGQf");

var $cfkw4 = parcelRequire("cfkw4");

var $gzCma = parcelRequire("gzCma");

var $ejQPp = parcelRequire("ejQPp");

var $lgdKn = parcelRequire("lgdKn");

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");
class $4a23090e1e5b9fda$export$45d11a7c817b34eb {
    /**
     * Gets the camera that is used to render the utility layer (when not set, this will be the last active camera)
     * @param getRigParentIfPossible if the current active camera is a rig camera, should its parent camera be returned
     * @returns the camera that is used when rendering the utility layer
     */ getRenderCamera(getRigParentIfPossible) {
        if (this._renderCamera) return this._renderCamera;
        else {
            let activeCam;
            if (this.originalScene.activeCameras && this.originalScene.activeCameras.length > 1) activeCam = this.originalScene.activeCameras[this.originalScene.activeCameras.length - 1];
            else activeCam = this.originalScene.activeCamera;
            if (getRigParentIfPossible && activeCam && activeCam.isRigCamera) return activeCam.rigParent;
            return activeCam;
        }
    }
    /**
     * Sets the camera that should be used when rendering the utility layer (If set to null the last active camera will be used)
     * @param cam the camera that should be used when rendering the utility layer
     */ setRenderCamera(cam) {
        this._renderCamera = cam;
    }
    /**
     * @internal
     * Light which used by gizmos to get light shading
     */ _getSharedGizmoLight() {
        if (!this._sharedGizmoLight) {
            this._sharedGizmoLight = new (0, $lgdKn.HemisphericLight)("shared gizmo light", new (0, $ha1VO.Vector3)(0, 1, 0), this.utilityLayerScene);
            this._sharedGizmoLight.intensity = 2;
            this._sharedGizmoLight.groundColor = (0, $7etnY.Color3).Gray();
        }
        return this._sharedGizmoLight;
    }
    /**
     * A shared utility layer that can be used to overlay objects into a scene (Depth map of the previous scene is cleared before drawing on top of it)
     */ static get DefaultUtilityLayer() {
        if ($4a23090e1e5b9fda$export$45d11a7c817b34eb._DefaultUtilityLayer == null) return $4a23090e1e5b9fda$export$45d11a7c817b34eb._CreateDefaultUtilityLayerFromScene((0, $ejQPp.EngineStore).LastCreatedScene);
        return $4a23090e1e5b9fda$export$45d11a7c817b34eb._DefaultUtilityLayer;
    }
    /**
     * Creates an utility layer, and set it as a default utility layer
     * @param scene associated scene
     * @internal
     */ static _CreateDefaultUtilityLayerFromScene(scene) {
        $4a23090e1e5b9fda$export$45d11a7c817b34eb._DefaultUtilityLayer = new $4a23090e1e5b9fda$export$45d11a7c817b34eb(scene);
        $4a23090e1e5b9fda$export$45d11a7c817b34eb._DefaultUtilityLayer.originalScene.onDisposeObservable.addOnce(()=>{
            $4a23090e1e5b9fda$export$45d11a7c817b34eb._DefaultUtilityLayer = null;
        });
        return $4a23090e1e5b9fda$export$45d11a7c817b34eb._DefaultUtilityLayer;
    }
    /**
     * A shared utility layer that can be used to embed objects into a scene (Depth map of the previous scene is not cleared before drawing on top of it)
     */ static get DefaultKeepDepthUtilityLayer() {
        if ($4a23090e1e5b9fda$export$45d11a7c817b34eb._DefaultKeepDepthUtilityLayer == null) {
            $4a23090e1e5b9fda$export$45d11a7c817b34eb._DefaultKeepDepthUtilityLayer = new $4a23090e1e5b9fda$export$45d11a7c817b34eb((0, $ejQPp.EngineStore).LastCreatedScene);
            $4a23090e1e5b9fda$export$45d11a7c817b34eb._DefaultKeepDepthUtilityLayer.utilityLayerScene.autoClearDepthAndStencil = false;
            $4a23090e1e5b9fda$export$45d11a7c817b34eb._DefaultKeepDepthUtilityLayer.originalScene.onDisposeObservable.addOnce(()=>{
                $4a23090e1e5b9fda$export$45d11a7c817b34eb._DefaultKeepDepthUtilityLayer = null;
            });
        }
        return $4a23090e1e5b9fda$export$45d11a7c817b34eb._DefaultKeepDepthUtilityLayer;
    }
    /**
     * Instantiates a UtilityLayerRenderer
     * @param originalScene the original scene that will be rendered on top of
     * @param handleEvents boolean indicating if the utility layer should handle events
     */ constructor(/** the original scene that will be rendered on top of */ originalScene, handleEvents = true){
        this.originalScene = originalScene;
        this._pointerCaptures = {};
        this._lastPointerEvents = {};
        this._sharedGizmoLight = null;
        this._renderCamera = null;
        /**
         * If the picking should be done on the utility layer prior to the actual scene (Default: true)
         */ this.pickUtilitySceneFirst = true;
        /**
         *  If the utility layer should automatically be rendered on top of existing scene
         */ this.shouldRender = true;
        /**
         * If set to true, only pointer down onPointerObservable events will be blocked when picking is occluded by original scene
         */ this.onlyCheckPointerDownEvents = true;
        /**
         * If set to false, only pointerUp, pointerDown and pointerMove will be sent to the utilityLayerScene (false by default)
         */ this.processAllEvents = false;
        /**
         * Set to false to disable picking
         */ this.pickingEnabled = true;
        /**
         * Observable raised when the pointer moves from the utility layer scene to the main scene
         */ this.onPointerOutObservable = new (0, $diGQf.Observable)();
        // Create scene which will be rendered in the foreground and remove it from being referenced by engine to avoid interfering with existing app
        this.utilityLayerScene = new (0, $gmbCk.Scene)(originalScene.getEngine(), {
            virtual: true
        });
        this.utilityLayerScene.useRightHandedSystem = originalScene.useRightHandedSystem;
        this.utilityLayerScene._allowPostProcessClearColor = false;
        // Deactivate post processes
        this.utilityLayerScene.postProcessesEnabled = false;
        // Detach controls on utility scene, events will be fired by logic below to handle picking priority
        this.utilityLayerScene.detachControl();
        if (handleEvents) {
            this._originalPointerObserver = originalScene.onPrePointerObservable.add((prePointerInfo)=>{
                if (!this.utilityLayerScene.activeCamera) return;
                if (!this.pickingEnabled) return;
                if (!this.processAllEvents) {
                    if (prePointerInfo.type !== (0, $cfkw4.PointerEventTypes).POINTERMOVE && prePointerInfo.type !== (0, $cfkw4.PointerEventTypes).POINTERUP && prePointerInfo.type !== (0, $cfkw4.PointerEventTypes).POINTERDOWN && prePointerInfo.type !== (0, $cfkw4.PointerEventTypes).POINTERDOUBLETAP) return;
                }
                this.utilityLayerScene.pointerX = originalScene.pointerX;
                this.utilityLayerScene.pointerY = originalScene.pointerY;
                const pointerEvent = prePointerInfo.event;
                if (originalScene.isPointerCaptured(pointerEvent.pointerId)) {
                    this._pointerCaptures[pointerEvent.pointerId] = false;
                    return;
                }
                const getNearPickDataForScene = (scene)=>{
                    let scenePick = null;
                    if (prePointerInfo.nearInteractionPickingInfo) {
                        if (prePointerInfo.nearInteractionPickingInfo.pickedMesh.getScene() == scene) scenePick = prePointerInfo.nearInteractionPickingInfo;
                        else scenePick = new (0, $gzCma.PickingInfo)();
                    } else if (scene !== this.utilityLayerScene && prePointerInfo.originalPickingInfo) scenePick = prePointerInfo.originalPickingInfo;
                    else {
                        let previousActiveCamera = null;
                        // If a camera is set for rendering with this layer
                        // it will also be used for the ray computation
                        // To preserve back compat and because scene.pick always use activeCamera
                        // it's substituted temporarily and a new scenePick is forced.
                        // otherwise, the ray with previously active camera is always used.
                        // It's set back to previous activeCamera after operation.
                        if (this._renderCamera) {
                            previousActiveCamera = scene._activeCamera;
                            scene._activeCamera = this._renderCamera;
                            prePointerInfo.ray = null;
                        }
                        scenePick = prePointerInfo.ray ? scene.pickWithRay(prePointerInfo.ray) : scene.pick(originalScene.pointerX, originalScene.pointerY);
                        if (previousActiveCamera) scene._activeCamera = previousActiveCamera;
                    }
                    return scenePick;
                };
                const utilityScenePick = getNearPickDataForScene(this.utilityLayerScene);
                if (!prePointerInfo.ray && utilityScenePick) prePointerInfo.ray = utilityScenePick.ray;
                // always fire the prepointer observable
                this.utilityLayerScene.onPrePointerObservable.notifyObservers(prePointerInfo);
                // allow every non pointer down event to flow to the utility layer
                if (this.onlyCheckPointerDownEvents && prePointerInfo.type != (0, $cfkw4.PointerEventTypes).POINTERDOWN) {
                    if (!prePointerInfo.skipOnPointerObservable) this.utilityLayerScene.onPointerObservable.notifyObservers(new (0, $cfkw4.PointerInfo)(prePointerInfo.type, prePointerInfo.event, utilityScenePick), prePointerInfo.type);
                    if (prePointerInfo.type === (0, $cfkw4.PointerEventTypes).POINTERUP && this._pointerCaptures[pointerEvent.pointerId]) this._pointerCaptures[pointerEvent.pointerId] = false;
                    return;
                }
                if (this.utilityLayerScene.autoClearDepthAndStencil || this.pickUtilitySceneFirst) // If this layer is an overlay, check if this layer was hit and if so, skip pointer events for the main scene
                {
                    if (utilityScenePick && utilityScenePick.hit) {
                        if (!prePointerInfo.skipOnPointerObservable) this.utilityLayerScene.onPointerObservable.notifyObservers(new (0, $cfkw4.PointerInfo)(prePointerInfo.type, prePointerInfo.event, utilityScenePick), prePointerInfo.type);
                        prePointerInfo.skipOnPointerObservable = true;
                    }
                } else {
                    const originalScenePick = getNearPickDataForScene(originalScene);
                    const pointerEvent = prePointerInfo.event;
                    // If the layer can be occluded by the original scene, only fire pointer events to the first layer that hit they ray
                    if (originalScenePick && utilityScenePick) {
                        // No pick in utility scene
                        if (utilityScenePick.distance === 0 && originalScenePick.pickedMesh) {
                            if (this.mainSceneTrackerPredicate && this.mainSceneTrackerPredicate(originalScenePick.pickedMesh)) {
                                // We touched an utility mesh present in the main scene
                                this._notifyObservers(prePointerInfo, originalScenePick, pointerEvent);
                                prePointerInfo.skipOnPointerObservable = true;
                            } else if (prePointerInfo.type === (0, $cfkw4.PointerEventTypes).POINTERDOWN) this._pointerCaptures[pointerEvent.pointerId] = true;
                            else if (prePointerInfo.type === (0, $cfkw4.PointerEventTypes).POINTERMOVE || prePointerInfo.type === (0, $cfkw4.PointerEventTypes).POINTERUP) {
                                if (this._lastPointerEvents[pointerEvent.pointerId]) {
                                    // We need to send a last pointerup to the utilityLayerScene to make sure animations can complete
                                    this.onPointerOutObservable.notifyObservers(pointerEvent.pointerId);
                                    delete this._lastPointerEvents[pointerEvent.pointerId];
                                }
                                this._notifyObservers(prePointerInfo, originalScenePick, pointerEvent);
                            }
                        } else if (!this._pointerCaptures[pointerEvent.pointerId] && (utilityScenePick.distance < originalScenePick.distance || originalScenePick.distance === 0)) {
                            // We pick something in utility scene or the pick in utility is closer than the one in main scene
                            this._notifyObservers(prePointerInfo, utilityScenePick, pointerEvent);
                            // If a previous utility layer set this, do not unset this
                            if (!prePointerInfo.skipOnPointerObservable) prePointerInfo.skipOnPointerObservable = utilityScenePick.distance > 0;
                        } else if (!this._pointerCaptures[pointerEvent.pointerId] && utilityScenePick.distance >= originalScenePick.distance) {
                            // We have a pick in both scenes but main is closer than utility
                            // We touched an utility mesh present in the main scene
                            if (this.mainSceneTrackerPredicate && this.mainSceneTrackerPredicate(originalScenePick.pickedMesh)) {
                                this._notifyObservers(prePointerInfo, originalScenePick, pointerEvent);
                                prePointerInfo.skipOnPointerObservable = true;
                            } else {
                                if (prePointerInfo.type === (0, $cfkw4.PointerEventTypes).POINTERMOVE || prePointerInfo.type === (0, $cfkw4.PointerEventTypes).POINTERUP) {
                                    if (this._lastPointerEvents[pointerEvent.pointerId]) {
                                        // We need to send a last pointerup to the utilityLayerScene to make sure animations can complete
                                        this.onPointerOutObservable.notifyObservers(pointerEvent.pointerId);
                                        delete this._lastPointerEvents[pointerEvent.pointerId];
                                    }
                                }
                                this._notifyObservers(prePointerInfo, utilityScenePick, pointerEvent);
                            }
                        }
                        if (prePointerInfo.type === (0, $cfkw4.PointerEventTypes).POINTERUP && this._pointerCaptures[pointerEvent.pointerId]) this._pointerCaptures[pointerEvent.pointerId] = false;
                    }
                }
            });
            // As a newly added utility layer will be rendered over the screen last, it's pointer events should be processed first
            if (this._originalPointerObserver) originalScene.onPrePointerObservable.makeObserverTopPriority(this._originalPointerObserver);
        }
        // Render directly on top of existing scene without clearing
        this.utilityLayerScene.autoClear = false;
        this._afterRenderObserver = this.originalScene.onAfterRenderCameraObservable.add((camera)=>{
            // Only render when the render camera finishes rendering
            if (this.shouldRender && camera == this.getRenderCamera()) this.render();
        });
        this._sceneDisposeObserver = this.originalScene.onDisposeObservable.add(()=>{
            this.dispose();
        });
        this._updateCamera();
    }
    _notifyObservers(prePointerInfo, pickInfo, pointerEvent) {
        if (!prePointerInfo.skipOnPointerObservable) {
            this.utilityLayerScene.onPointerObservable.notifyObservers(new (0, $cfkw4.PointerInfo)(prePointerInfo.type, prePointerInfo.event, pickInfo), prePointerInfo.type);
            this._lastPointerEvents[pointerEvent.pointerId] = true;
        }
    }
    /**
     * Renders the utility layers scene on top of the original scene
     */ render() {
        this._updateCamera();
        if (this.utilityLayerScene.activeCamera) {
            // Set the camera's scene to utility layers scene
            const oldScene = this.utilityLayerScene.activeCamera.getScene();
            const camera = this.utilityLayerScene.activeCamera;
            camera._scene = this.utilityLayerScene;
            if (camera.leftCamera) camera.leftCamera._scene = this.utilityLayerScene;
            if (camera.rightCamera) camera.rightCamera._scene = this.utilityLayerScene;
            this.utilityLayerScene.render(false);
            // Reset camera's scene back to original
            camera._scene = oldScene;
            if (camera.leftCamera) camera.leftCamera._scene = oldScene;
            if (camera.rightCamera) camera.rightCamera._scene = oldScene;
        }
    }
    /**
     * Disposes of the renderer
     */ dispose() {
        this.onPointerOutObservable.clear();
        if (this._afterRenderObserver) this.originalScene.onAfterCameraRenderObservable.remove(this._afterRenderObserver);
        if (this._sceneDisposeObserver) this.originalScene.onDisposeObservable.remove(this._sceneDisposeObserver);
        if (this._originalPointerObserver) this.originalScene.onPrePointerObservable.remove(this._originalPointerObserver);
        this.utilityLayerScene.dispose();
    }
    _updateCamera() {
        this.utilityLayerScene.cameraToUseForPointers = this.getRenderCamera();
        this.utilityLayerScene.activeCamera = this.getRenderCamera();
    }
}
/** @internal */ $4a23090e1e5b9fda$export$45d11a7c817b34eb._DefaultUtilityLayer = null;
/** @internal */ $4a23090e1e5b9fda$export$45d11a7c817b34eb._DefaultKeepDepthUtilityLayer = null;

});
parcelRegister("lgdKn", function(module, exports) {

$parcel$export(module.exports, "HemisphericLight", () => $f7a5c17b44f59088$export$2c4b0826fc11cb0e);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $bgssx = parcelRequire("bgssx");

var $c6YWJ = parcelRequire("c6YWJ");
(0, $bgssx.Node).AddNodeConstructor("Light_Type_3", (name, scene)=>{
    return ()=>new $f7a5c17b44f59088$export$2c4b0826fc11cb0e(name, (0, $ha1VO.Vector3).Zero(), scene);
});
class $f7a5c17b44f59088$export$2c4b0826fc11cb0e extends (0, $c6YWJ.Light) {
    /**
     * Creates a HemisphericLight object in the scene according to the passed direction (Vector3).
     * The HemisphericLight simulates the ambient environment light, so the passed direction is the light reflection direction, not the incoming direction.
     * The HemisphericLight can't cast shadows.
     * Documentation : https://doc.babylonjs.com/features/featuresDeepDive/lights/lights_introduction
     * @param name The friendly name of the light
     * @param direction The direction of the light reflection
     * @param scene The scene the light belongs to
     */ constructor(name, direction, scene){
        super(name, scene);
        /**
         * The groundColor is the light in the opposite direction to the one specified during creation.
         * You can think of the diffuse and specular light as coming from the centre of the object in the given direction and the groundColor light in the opposite direction.
         */ this.groundColor = new (0, $7etnY.Color3)(0.0, 0.0, 0.0);
        this.direction = direction || (0, $ha1VO.Vector3).Up();
    }
    _buildUniformLayout() {
        this._uniformBuffer.addUniform("vLightData", 4);
        this._uniformBuffer.addUniform("vLightDiffuse", 4);
        this._uniformBuffer.addUniform("vLightSpecular", 4);
        this._uniformBuffer.addUniform("vLightGround", 3);
        this._uniformBuffer.addUniform("shadowsInfo", 3);
        this._uniformBuffer.addUniform("depthValues", 2);
        this._uniformBuffer.create();
    }
    /**
     * Returns the string "HemisphericLight".
     * @returns The class name
     */ getClassName() {
        return "HemisphericLight";
    }
    /**
     * Sets the HemisphericLight direction towards the passed target (Vector3).
     * Returns the updated direction.
     * @param target The target the direction should point to
     * @returns The computed direction
     */ setDirectionToTarget(target) {
        this.direction = (0, $ha1VO.Vector3).Normalize(target.subtract((0, $ha1VO.Vector3).Zero()));
        return this.direction;
    }
    /**
     * Returns the shadow generator associated to the light.
     * @returns Always null for hemispheric lights because it does not support shadows.
     */ getShadowGenerator() {
        return null;
    }
    /**
     * Sets the passed Effect object with the HemisphericLight normalized direction and color and the passed name (string).
     * @param _effect The effect to update
     * @param lightIndex The index of the light in the effect to update
     * @returns The hemispheric light
     */ transferToEffect(_effect, lightIndex) {
        const normalizeDirection = (0, $ha1VO.Vector3).Normalize(this.direction);
        this._uniformBuffer.updateFloat4("vLightData", normalizeDirection.x, normalizeDirection.y, normalizeDirection.z, 0.0, lightIndex);
        this._uniformBuffer.updateColor3("vLightGround", this.groundColor.scale(this.intensity), lightIndex);
        return this;
    }
    transferToNodeMaterialEffect(effect, lightDataUniformName) {
        const normalizeDirection = (0, $ha1VO.Vector3).Normalize(this.direction);
        effect.setFloat3(lightDataUniformName, normalizeDirection.x, normalizeDirection.y, normalizeDirection.z);
        return this;
    }
    /**
     * Computes the world matrix of the node
     * @returns the world matrix
     */ computeWorldMatrix() {
        if (!this._worldMatrix) this._worldMatrix = (0, $ha1VO.Matrix).Identity();
        return this._worldMatrix;
    }
    /**
     * Returns the integer 3.
     * @returns The light Type id as a constant defines in Light.LIGHTTYPEID_x
     */ getTypeID() {
        return (0, $c6YWJ.Light).LIGHTTYPEID_HEMISPHERICLIGHT;
    }
    /**
     * Prepares the list of defines specific to the light type.
     * @param defines the list of defines
     * @param lightIndex defines the index of the light for the effect
     */ prepareLightSpecificDefines(defines, lightIndex) {
        defines["HEMILIGHT" + lightIndex] = true;
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor3)()
], $f7a5c17b44f59088$export$2c4b0826fc11cb0e.prototype, "groundColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsVector3)()
], $f7a5c17b44f59088$export$2c4b0826fc11cb0e.prototype, "direction", void 0);

});





parcelRegister("lnMr4", function(module, exports) {

$parcel$export(module.exports, "BoneAxesViewer", () => $f911513ea2140534$export$e3bce6f3642e6b01);

var $6ir1c = parcelRequire("6ir1c");

var $ha1VO = parcelRequire("ha1VO");

var $dbxbu = parcelRequire("dbxbu");
class $f911513ea2140534$export$e3bce6f3642e6b01 extends (0, $6ir1c.AxesViewer) {
    /**
     * Creates a new BoneAxesViewer
     * @param scene defines the hosting scene
     * @param bone defines the target bone
     * @param mesh defines the target mesh
     * @param scaleLines defines a scaling factor for line length (1 by default)
     */ constructor(scene, bone, mesh, scaleLines = 1){
        super(scene, scaleLines);
        /** Gets current position */ this.pos = (0, $ha1VO.Vector3).Zero();
        /** Gets direction of X axis */ this.xaxis = (0, $ha1VO.Vector3).Zero();
        /** Gets direction of Y axis */ this.yaxis = (0, $ha1VO.Vector3).Zero();
        /** Gets direction of Z axis */ this.zaxis = (0, $ha1VO.Vector3).Zero();
        this.mesh = mesh;
        this.bone = bone;
    }
    /**
     * Force the viewer to update
     */ update() {
        if (!this.mesh || !this.bone) return;
        const bone = this.bone;
        bone.getAbsolutePositionToRef(this.mesh, this.pos);
        bone.getDirectionToRef((0, $dbxbu.Axis).X, this.mesh, this.xaxis);
        bone.getDirectionToRef((0, $dbxbu.Axis).Y, this.mesh, this.yaxis);
        bone.getDirectionToRef((0, $dbxbu.Axis).Z, this.mesh, this.zaxis);
        super.update(this.pos, this.xaxis, this.yaxis, this.zaxis);
    }
    /** Releases resources */ dispose() {
        if (this.mesh) {
            this.mesh = null;
            this.bone = null;
            super.dispose();
        }
    }
}

});

parcelRegister("gRt7v", function(module, exports) {

$parcel$export(module.exports, "DebugLayer", () => $c4682f36763eb536$export$a3a55c500f36819a);
$parcel$export(module.exports, "DebugLayerTab", () => $c4682f36763eb536$export$4c8bd946c02f7f07);

var $bOhSV = parcelRequire("bOhSV");

var $diGQf = parcelRequire("diGQf");

var $gmbCk = parcelRequire("gmbCk");

var $5YkyR = parcelRequire("5YkyR");

var $ejQPp = parcelRequire("ejQPp");
Object.defineProperty((0, $gmbCk.Scene).prototype, "debugLayer", {
    get: function() {
        if (!this._debugLayer) this._debugLayer = new $c4682f36763eb536$export$a3a55c500f36819a(this);
        return this._debugLayer;
    },
    enumerable: true,
    configurable: true
});
var $c4682f36763eb536$export$4c8bd946c02f7f07;
(function(DebugLayerTab) {
    /**
     * Properties tag (default)
     */ DebugLayerTab[DebugLayerTab["Properties"] = 0] = "Properties";
    /**
     * Debug tab
     */ DebugLayerTab[DebugLayerTab["Debug"] = 1] = "Debug";
    /**
     * Statistics tab
     */ DebugLayerTab[DebugLayerTab["Statistics"] = 2] = "Statistics";
    /**
     * Tools tab
     */ DebugLayerTab[DebugLayerTab["Tools"] = 3] = "Tools";
    /**
     * Settings tab
     */ DebugLayerTab[DebugLayerTab["Settings"] = 4] = "Settings";
})($c4682f36763eb536$export$4c8bd946c02f7f07 || ($c4682f36763eb536$export$4c8bd946c02f7f07 = {}));
class $c4682f36763eb536$export$a3a55c500f36819a {
    /**
     * Observable triggered when a property is changed through the inspector.
     */ get onPropertyChangedObservable() {
        if (this.BJSINSPECTOR && this.BJSINSPECTOR.Inspector) return this.BJSINSPECTOR.Inspector.OnPropertyChangedObservable;
        if (!this._onPropertyChangedObservable) this._onPropertyChangedObservable = new (0, $diGQf.Observable)();
        return this._onPropertyChangedObservable;
    }
    /**
     * Observable triggered when the selection is changed through the inspector.
     */ get onSelectionChangedObservable() {
        if (this.BJSINSPECTOR && this.BJSINSPECTOR.Inspector) return this.BJSINSPECTOR.Inspector.OnSelectionChangeObservable;
        if (!this._onSelectionChangedObservable) this._onSelectionChangedObservable = new (0, $diGQf.Observable)();
        return this._onSelectionChangedObservable;
    }
    /**
     * Instantiates a new debug layer.
     * The debug layer (aka Inspector) is the go to tool in order to better understand
     * what is happening in your scene
     * @see https://doc.babylonjs.com/toolsAndResources/inspector
     * @param scene Defines the scene to inspect
     */ constructor(scene){
        // eslint-disable-next-line @typescript-eslint/naming-convention
        this.BJSINSPECTOR = this._getGlobalInspector();
        this._scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        if (!this._scene) return;
        this._scene.onDisposeObservable.add(()=>{
            // Debug layer
            if (this._scene._debugLayer) this._scene._debugLayer.hide();
        });
    }
    /**
     * Creates the inspector window.
     * @param config
     */ _createInspector(config) {
        if (this.isVisible()) return;
        if (this._onPropertyChangedObservable) {
            for (const observer of this._onPropertyChangedObservable.observers)this.BJSINSPECTOR.Inspector.OnPropertyChangedObservable.add(observer);
            this._onPropertyChangedObservable.clear();
            this._onPropertyChangedObservable = undefined;
        }
        if (this._onSelectionChangedObservable) {
            for (const observer of this._onSelectionChangedObservable.observers)this.BJSINSPECTOR.Inspector.OnSelectionChangedObservable.add(observer);
            this._onSelectionChangedObservable.clear();
            this._onSelectionChangedObservable = undefined;
        }
        const userOptions = {
            ...$c4682f36763eb536$export$a3a55c500f36819a.Config,
            ...config
        };
        this.BJSINSPECTOR = this.BJSINSPECTOR || this._getGlobalInspector();
        this.BJSINSPECTOR.Inspector.Show(this._scene, userOptions);
    }
    /**
     * Select a specific entity in the scene explorer and highlight a specific block in that entity property grid
     * @param entity defines the entity to select
     * @param lineContainerTitles defines the specific blocks to highlight (could be a string or an array of strings)
     */ select(entity, lineContainerTitles) {
        if (this.BJSINSPECTOR) {
            if (lineContainerTitles) {
                if (Object.prototype.toString.call(lineContainerTitles) == "[object String]") this.BJSINSPECTOR.Inspector.MarkLineContainerTitleForHighlighting(lineContainerTitles);
                else this.BJSINSPECTOR.Inspector.MarkMultipleLineContainerTitlesForHighlighting(lineContainerTitles);
            }
            this.BJSINSPECTOR.Inspector.OnSelectionChangeObservable.notifyObservers(entity);
        }
    }
    /**
     * Get the inspector from bundle or global
     * @returns the inspector instance if found otherwise, null
     */ _getGlobalInspector() {
        // UMD Global name detection from Webpack Bundle UMD Name.
        if (typeof INSPECTOR !== "undefined") return INSPECTOR;
        // In case of module let s check the global emitted from the Inspector entry point.
        if (typeof BABYLON !== "undefined" && typeof BABYLON.Inspector !== "undefined") return BABYLON;
        return undefined;
    }
    /**
     * Get if the inspector is visible or not.
     * @returns true if visible otherwise, false
     */ isVisible() {
        return this.BJSINSPECTOR && this.BJSINSPECTOR.Inspector.IsVisible;
    }
    /**
     * Hide the inspector and close its window.
     */ hide() {
        if (this.BJSINSPECTOR) this.BJSINSPECTOR.Inspector.Hide();
    }
    /**
     * Update the scene in the inspector
     */ setAsActiveScene() {
        if (this.BJSINSPECTOR) this.BJSINSPECTOR.Inspector._SetNewScene(this._scene);
    }
    /**
     * Launch the debugLayer.
     * @param config Define the configuration of the inspector
     * @returns a promise fulfilled when the debug layer is visible
     */ show(config) {
        return new Promise((resolve)=>{
            if (typeof this.BJSINSPECTOR == "undefined") {
                const inspectorUrl = config && config.inspectorURL ? config.inspectorURL : $c4682f36763eb536$export$a3a55c500f36819a.InspectorURL;
                // Load inspector and add it to the DOM
                (0, $bOhSV.Tools).LoadBabylonScript(inspectorUrl, ()=>{
                    this._createInspector(config);
                    resolve(this);
                });
            } else {
                // Otherwise creates the inspector
                this._createInspector(config);
                resolve(this);
            }
        });
    }
}
/**
 * Define the url to get the inspector script from.
 * By default it uses the babylonjs CDN.
 * @ignoreNaming
 */ $c4682f36763eb536$export$a3a55c500f36819a.InspectorURL = `${(0, $bOhSV.Tools)._DefaultCdnUrl}/v${(0, $5YkyR.Engine).Version}/inspector/babylon.inspector.bundle.js`;
/**
 * The default configuration of the inspector
 */ $c4682f36763eb536$export$a3a55c500f36819a.Config = {
    overlay: false,
    showExplorer: true,
    showInspector: true,
    embedMode: false,
    handleResize: true,
    enablePopup: true
};

});

parcelRegister("dCaGf", function(module, exports) {

$parcel$export(module.exports, "PhysicsViewer", () => $9e971bddd3fb9bf3$export$7f262915bd4200bd);

var $fbuqw = parcelRequire("fbuqw");

var $4C7Qm = parcelRequire("4C7Qm");

var $8KqOo = parcelRequire("8KqOo");

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $ejQPp = parcelRequire("ejQPp");

var $gAH3H = parcelRequire("gAH3H");

var $iz3U8 = parcelRequire("iz3U8");

var $6mCYU = parcelRequire("6mCYU");

var $9zY5k = parcelRequire("9zY5k");

var $22sXo = parcelRequire("22sXo");

var $kVtWi = parcelRequire("kVtWi");

var $5v6ry = parcelRequire("5v6ry");

var $dls1y = parcelRequire("dls1y");

var $6ir1c = parcelRequire("6ir1c");

var $klshO = parcelRequire("klshO");

var $53VPf = parcelRequire("53VPf");
class $9e971bddd3fb9bf3$export$7f262915bd4200bd {
    /**
     * Creates a new PhysicsViewer
     * @param scene defines the hosting scene
     */ constructor(scene){
        /** @internal */ this._impostors = [];
        /** @internal */ this._meshes = [];
        /** @internal */ this._bodies = [];
        /** @internal */ this._inertiaBodies = [];
        /** @internal */ this._constraints = [];
        /** @internal */ this._bodyMeshes = [];
        /** @internal */ this._inertiaMeshes = [];
        /** @internal */ this._constraintMeshes = [];
        /** @internal */ this._numMeshes = 0;
        /** @internal */ this._numBodies = 0;
        /** @internal */ this._numInertiaBodies = 0;
        /** @internal */ this._numConstraints = 0;
        this._debugMeshMeshes = new Array();
        this._constraintAxesSize = 0.4;
        this._scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        if (!this._scene) return;
        const physicEngine = this._scene.getPhysicsEngine();
        if (physicEngine) this._physicsEnginePlugin = physicEngine.getPhysicsPlugin();
        this._utilityLayer = new (0, $6mCYU.UtilityLayerRenderer)(this._scene, false);
        this._utilityLayer.pickUtilitySceneFirst = false;
        this._utilityLayer.utilityLayerScene.autoClearDepthAndStencil = true;
    }
    /**
     * Updates the debug meshes of the physics engine.
     *
     * This code is useful for synchronizing the debug meshes of the physics engine with the physics impostor and mesh.
     * It checks if the impostor is disposed and if the plugin version is 1, then it syncs the mesh with the impostor.
     * This ensures that the debug meshes are up to date with the physics engine.
     */ _updateDebugMeshes() {
        const plugin = this._physicsEnginePlugin;
        if (plugin?.getPluginVersion() === 1) this._updateDebugMeshesV1();
        else this._updateDebugMeshesV2();
    }
    /**
     * Updates the debug meshes of the physics engine.
     *
     * This method is useful for synchronizing the debug meshes with the physics impostors.
     * It iterates through the impostors and meshes, and if the plugin version is 1, it syncs the mesh with the impostor.
     * This ensures that the debug meshes accurately reflect the physics impostors, which is important for debugging the physics engine.
     */ _updateDebugMeshesV1() {
        const plugin = this._physicsEnginePlugin;
        for(let i = 0; i < this._numMeshes; i++){
            const impostor = this._impostors[i];
            if (!impostor) continue;
            if (impostor.isDisposed) this.hideImpostor(this._impostors[i--]);
            else {
                if (impostor.type === (0, $iz3U8.PhysicsImpostor).MeshImpostor) continue;
                const mesh = this._meshes[i];
                if (mesh && plugin) plugin.syncMeshWithImpostor(mesh, impostor);
            }
        }
    }
    /**
     * Updates the debug meshes of the physics engine for V2 plugin.
     *
     * This method is useful for synchronizing the debug meshes of the physics engine with the current state of the bodies.
     * It iterates through the bodies array and updates the debug meshes with the current transform of each body.
     * This ensures that the debug meshes accurately reflect the current state of the physics engine.
     */ _updateDebugMeshesV2() {
        const plugin = this._physicsEnginePlugin;
        for(let i = 0; i < this._numBodies; i++){
            const body = this._bodies[i];
            const transform = this._bodyMeshes[i];
            if (body && transform) plugin.syncTransform(body, transform);
        }
    }
    _updateInertiaMeshes() {
        for(let i = 0; i < this._numInertiaBodies; i++){
            const body = this._inertiaBodies[i];
            const mesh = this._inertiaMeshes[i];
            if (body && mesh) this._updateDebugInertia(body, mesh);
        }
    }
    _updateDebugInertia(body, inertiaMesh) {
        const inertiaMatrixRef = (0, $ha1VO.Matrix).Identity();
        const transformMatrixRef = (0, $ha1VO.Matrix).Identity();
        const finalMatrixRef = (0, $ha1VO.Matrix).Identity();
        if (body._pluginDataInstances.length) {
            const inertiaAsMesh = inertiaMesh;
            const inertiaMeshMatrixData = inertiaAsMesh._thinInstanceDataStorage.matrixData;
            const bodyTransformMatrixData = body.transformNode._thinInstanceDataStorage.matrixData;
            for(let i = 0; i < body._pluginDataInstances.length; i++){
                const props = body.getMassProperties(i);
                this._getMeshDebugInertiaMatrixToRef(props, inertiaMatrixRef);
                (0, $ha1VO.Matrix).FromArrayToRef(bodyTransformMatrixData, i * 16, transformMatrixRef);
                inertiaMatrixRef.multiplyToRef(transformMatrixRef, finalMatrixRef);
                finalMatrixRef.copyToArray(inertiaMeshMatrixData, i * 16);
            }
            inertiaAsMesh.thinInstanceBufferUpdated("matrix");
        } else {
            const props = body.getMassProperties();
            this._getMeshDebugInertiaMatrixToRef(props, inertiaMatrixRef);
            body.transformNode.rotationQuaternion?.toRotationMatrix(transformMatrixRef);
            transformMatrixRef.setTranslation(body.transformNode.position);
            if (body.transformNode.parent) {
                const parentTransform = body.transformNode.parent.computeWorldMatrix(true);
                transformMatrixRef.multiplyToRef(parentTransform, transformMatrixRef);
            }
            inertiaMatrixRef.multiplyToRef(transformMatrixRef, inertiaMatrixRef);
            inertiaMatrixRef.decomposeToTransformNode(inertiaMesh);
        }
    }
    _updateDebugConstraints() {
        for(let i = 0; i < this._numConstraints; i++){
            const constraint = this._constraints[i];
            const mesh = this._constraintMeshes[i];
            if (constraint && mesh) this._updateDebugConstraint(constraint, mesh);
        }
    }
    /**
     * Given a scaling vector, make all of its components
     * 1, preserving the sign
     * @param scaling
     */ _makeScalingUnitInPlace(scaling) {
        if (Math.abs(scaling.x - 1) > (0, $53VPf.Epsilon)) scaling.x = 1 * Math.sign(scaling.x);
        if (Math.abs(scaling.y - 1) > (0, $53VPf.Epsilon)) scaling.y = 1 * Math.sign(scaling.y);
        if (Math.abs(scaling.z - 1) > (0, $53VPf.Epsilon)) scaling.z = 1 * Math.sign(scaling.z);
    }
    _updateDebugConstraint(constraint, parentingMesh) {
        if (!constraint._initOptions) return;
        // Get constraint pivot and axes
        const { pivotA: pivotA, pivotB: pivotB, axisA: axisA, axisB: axisB, perpAxisA: perpAxisA, perpAxisB: perpAxisB } = constraint._initOptions;
        if (!pivotA || !pivotB || !axisA || !axisB || !perpAxisA || !perpAxisB) return;
        parentingMesh.getDescendants(true).forEach((parentConstraintMesh)=>{
            // Get the parent transform
            const parentCoordSystemNode = parentConstraintMesh.getDescendants(true)[0];
            const childCoordSystemNode = parentConstraintMesh.getDescendants(true)[1];
            const { parentBody: parentBody, parentBodyIndex: parentBodyIndex } = parentCoordSystemNode.metadata;
            const { childBody: childBody, childBodyIndex: childBodyIndex } = childCoordSystemNode.metadata;
            const parentTransform = this._getTransformFromBodyToRef(parentBody, (0, $ha1VO.TmpVectors).Matrix[0], parentBodyIndex);
            const childTransform = this._getTransformFromBodyToRef(childBody, (0, $ha1VO.TmpVectors).Matrix[1], childBodyIndex);
            parentTransform.decomposeToTransformNode(parentCoordSystemNode);
            this._makeScalingUnitInPlace(parentCoordSystemNode.scaling);
            childTransform.decomposeToTransformNode(childCoordSystemNode);
            this._makeScalingUnitInPlace(childCoordSystemNode.scaling);
            // Create a transform node and set its matrix
            const parentTransformNode = parentCoordSystemNode.getDescendants(true)[0];
            parentTransformNode.position.copyFrom(pivotA);
            const childTransformNode = childCoordSystemNode.getDescendants(true)[0];
            childTransformNode.position.copyFrom(pivotB);
            // Get the transform to align the XYZ axes to the constraint axes
            (0, $ha1VO.Quaternion).FromRotationMatrixToRef((0, $ha1VO.Matrix).FromXYZAxesToRef(axisA, perpAxisA, (0, $ha1VO.Vector3).CrossToRef(axisA, perpAxisA, (0, $ha1VO.TmpVectors).Vector3[0]), (0, $ha1VO.TmpVectors).Matrix[0]), parentTransformNode.rotationQuaternion);
            (0, $ha1VO.Quaternion).FromRotationMatrixToRef((0, $ha1VO.Matrix).FromXYZAxesToRef(axisB, perpAxisB, (0, $ha1VO.Vector3).CrossToRef(axisB, perpAxisB, (0, $ha1VO.TmpVectors).Vector3[1]), (0, $ha1VO.TmpVectors).Matrix[1]), childTransformNode.rotationQuaternion);
        });
    }
    /**
     * Renders a specified physic impostor
     * @param impostor defines the impostor to render
     * @param targetMesh defines the mesh represented by the impostor
     * @returns the new debug mesh used to render the impostor
     */ showImpostor(impostor, targetMesh) {
        if (!this._scene) return null;
        for(let i = 0; i < this._numMeshes; i++){
            if (this._impostors[i] == impostor) return null;
        }
        const debugMesh = this._getDebugMesh(impostor, targetMesh);
        if (debugMesh) {
            this._impostors[this._numMeshes] = impostor;
            this._meshes[this._numMeshes] = debugMesh;
            if (this._numMeshes === 0) {
                this._renderFunction = ()=>this._updateDebugMeshes();
                this._scene.registerBeforeRender(this._renderFunction);
            }
            this._numMeshes++;
        }
        return debugMesh;
    }
    /**
     * Shows a debug mesh for a given physics body.
     * @param body The physics body to show.
     * @returns The debug mesh, or null if the body is already shown.
     *
     * This function is useful for visualizing the physics body in the scene.
     * It creates a debug mesh for the given body and adds it to the scene.
     * It also registers a before render function to update the debug mesh position and rotation.
     */ showBody(body) {
        if (!this._scene) return null;
        for(let i = 0; i < this._numBodies; i++){
            if (this._bodies[i] == body) return null;
        }
        const debugMesh = this._getDebugBodyMesh(body);
        if (debugMesh) {
            this._bodies[this._numBodies] = body;
            this._bodyMeshes[this._numBodies] = debugMesh;
            if (this._numBodies === 0) {
                this._renderFunction = ()=>this._updateDebugMeshes();
                this._scene.registerBeforeRender(this._renderFunction);
            }
            this._numBodies++;
        }
        return debugMesh;
    }
    /**
     * Shows a debug box corresponding to the inertia of a given body
     * @param body the physics body used to get the inertia
     * @returns the debug mesh used to show the inertia, or null if the body is already shown
     */ showInertia(body) {
        if (!this._scene) return null;
        for(let i = 0; i < this._numInertiaBodies; i++){
            if (this._inertiaBodies[i] == body) return null;
        }
        const debugMesh = this._getDebugInertiaMesh(body);
        if (debugMesh) {
            this._inertiaBodies[this._numInertiaBodies] = body;
            this._inertiaMeshes[this._numInertiaBodies] = debugMesh;
            if (this._numInertiaBodies === 0) {
                this._inertiaRenderFunction = ()=>this._updateInertiaMeshes();
                this._scene.registerBeforeRender(this._inertiaRenderFunction);
            }
            this._numInertiaBodies++;
        }
        return debugMesh;
    }
    /**
     * Shows a debug mesh for a given physics constraint.
     * @param constraint the physics constraint to show
     * @returns the debug mesh, or null if the constraint is already shown
     */ showConstraint(constraint) {
        if (!this._scene) return null;
        for(let i = 0; i < this._numConstraints; i++){
            if (this._constraints[i] == constraint) return null;
        }
        const debugMesh = this._getDebugConstraintMesh(constraint);
        if (debugMesh) {
            this._constraints[this._numConstraints] = constraint;
            this._constraintMeshes[this._numConstraints] = debugMesh;
            if (this._numConstraints === 0) {
                this._constraintRenderFunction = ()=>this._updateDebugConstraints();
                this._scene.registerBeforeRender(this._constraintRenderFunction);
            }
            this._numConstraints++;
        }
        return debugMesh;
    }
    /**
     * Hides an impostor from the scene.
     * @param impostor - The impostor to hide.
     *
     * This method is useful for hiding an impostor from the scene. It removes the
     * impostor from the utility layer scene, disposes the mesh, and removes the
     * impostor from the list of impostors. If the impostor is the last one in the
     * list, it also unregisters the render function.
     */ hideImpostor(impostor) {
        if (!impostor || !this._scene || !this._utilityLayer) return;
        let removed = false;
        const utilityLayerScene = this._utilityLayer.utilityLayerScene;
        for(let i = 0; i < this._numMeshes; i++)if (this._impostors[i] == impostor) {
            const mesh = this._meshes[i];
            if (!mesh) continue;
            utilityLayerScene.removeMesh(mesh);
            mesh.dispose();
            const index = this._debugMeshMeshes.indexOf(mesh);
            if (index > -1) this._debugMeshMeshes.splice(index, 1);
            this._numMeshes--;
            if (this._numMeshes > 0) {
                this._meshes[i] = this._meshes[this._numMeshes];
                this._impostors[i] = this._impostors[this._numMeshes];
                this._meshes[this._numMeshes] = null;
                this._impostors[this._numMeshes] = null;
            } else {
                this._meshes[0] = null;
                this._impostors[0] = null;
            }
            removed = true;
            break;
        }
        if (removed && this._numMeshes === 0) this._scene.unregisterBeforeRender(this._renderFunction);
    }
    /**
     * Hides a body from the physics engine.
     * @param body - The body to hide.
     *
     * This function is useful for hiding a body from the physics engine.
     * It removes the body from the utility layer scene and disposes the mesh associated with it.
     * It also unregisters the render function if the number of bodies is 0.
     * This is useful for hiding a body from the physics engine without deleting it.
     */ hideBody(body) {
        if (!body || !this._scene || !this._utilityLayer) return;
        let removed = false;
        const utilityLayerScene = this._utilityLayer.utilityLayerScene;
        for(let i = 0; i < this._numBodies; i++)if (this._bodies[i] === body) {
            const mesh = this._bodyMeshes[i];
            if (!mesh) continue;
            utilityLayerScene.removeMesh(mesh);
            mesh.dispose();
            this._numBodies--;
            if (this._numBodies > 0) {
                this._bodyMeshes[i] = this._bodyMeshes[this._numBodies];
                this._bodies[i] = this._bodies[this._numBodies];
                this._bodyMeshes[this._numBodies] = null;
                this._bodies[this._numBodies] = null;
            } else {
                this._bodyMeshes[0] = null;
                this._bodies[0] = null;
            }
            removed = true;
            break;
        }
        if (removed && this._numBodies === 0) this._scene.unregisterBeforeRender(this._renderFunction);
    }
    /**
     * Hides a body's inertia from the viewer utility layer
     * @param body the body to hide
     */ hideInertia(body) {
        if (!body || !this._scene || !this._utilityLayer) return;
        let removed = false;
        const utilityLayerScene = this._utilityLayer.utilityLayerScene;
        for(let i = 0; i < this._numInertiaBodies; i++)if (this._inertiaBodies[i] === body) {
            const mesh = this._inertiaMeshes[i];
            if (!mesh) continue;
            utilityLayerScene.removeMesh(mesh);
            mesh.dispose();
            this._inertiaBodies.splice(i, 1);
            this._inertiaMeshes.splice(i, 1);
            this._numInertiaBodies--;
            removed = true;
            break;
        }
        if (removed && this._numInertiaBodies === 0) this._scene.unregisterBeforeRender(this._inertiaRenderFunction);
    }
    /**
     * Hide a physics constraint from the viewer utility layer
     * @param constraint the constraint to hide
     */ hideConstraint(constraint) {
        if (!constraint || !this._scene || !this._utilityLayer) return;
        let removed = false;
        const utilityLayerScene = this._utilityLayer.utilityLayerScene;
        for(let i = 0; i < this._numConstraints; i++)if (this._constraints[i] === constraint) {
            const mesh = this._constraintMeshes[i];
            if (!mesh) continue;
            utilityLayerScene.removeMesh(mesh);
            mesh.dispose();
            this._constraints.splice(i, 1);
            this._constraintMeshes.splice(i, 1);
            this._numConstraints--;
            if (this._numConstraints > 0) {
                this._constraints[i] = this._constraints[this._numConstraints];
                this._constraintMeshes[i] = this._constraintMeshes[this._numConstraints];
                this._constraints[this._numConstraints] = null;
                this._constraintMeshes[this._numConstraints] = null;
            } else {
                this._constraints[0] = null;
                this._constraintMeshes[0] = null;
            }
            removed = true;
            break;
        }
        if (removed && this._numConstraints === 0) this._scene.unregisterBeforeRender(this._constraintRenderFunction);
    }
    _getDebugMaterial(scene) {
        if (!this._debugMaterial) {
            this._debugMaterial = new (0, $gAH3H.StandardMaterial)("", scene);
            this._debugMaterial.wireframe = true;
            this._debugMaterial.emissiveColor = (0, $7etnY.Color3).White();
            this._debugMaterial.disableLighting = true;
        }
        return this._debugMaterial;
    }
    _getDebugInertiaMaterial(scene) {
        if (!this._debugInertiaMaterial) {
            this._debugInertiaMaterial = new (0, $gAH3H.StandardMaterial)("", scene);
            this._debugInertiaMaterial.disableLighting = true;
            this._debugInertiaMaterial.alpha = 0.0;
        }
        return this._debugInertiaMaterial;
    }
    _getDebugBoxMesh(scene) {
        if (!this._debugBoxMesh) {
            this._debugBoxMesh = (0, $4C7Qm.CreateBox)("physicsBodyBoxViewMesh", {
                size: 1
            }, scene);
            this._debugBoxMesh.rotationQuaternion = (0, $ha1VO.Quaternion).Identity();
            this._debugBoxMesh.material = this._getDebugMaterial(scene);
            this._debugBoxMesh.setEnabled(false);
        }
        return this._debugBoxMesh.createInstance("physicsBodyBoxViewInstance");
    }
    _getDebugSphereMesh(scene) {
        if (!this._debugSphereMesh) {
            this._debugSphereMesh = (0, $8KqOo.CreateSphere)("physicsBodySphereViewMesh", {
                diameter: 1
            }, scene);
            this._debugSphereMesh.rotationQuaternion = (0, $ha1VO.Quaternion).Identity();
            this._debugSphereMesh.material = this._getDebugMaterial(scene);
            this._debugSphereMesh.setEnabled(false);
        }
        return this._debugSphereMesh.createInstance("physicsBodySphereViewInstance");
    }
    _getDebugCapsuleMesh(scene) {
        if (!this._debugCapsuleMesh) {
            this._debugCapsuleMesh = (0, $22sXo.CreateCapsule)("physicsBodyCapsuleViewMesh", {
                height: 1
            }, scene);
            this._debugCapsuleMesh.rotationQuaternion = (0, $ha1VO.Quaternion).Identity();
            this._debugCapsuleMesh.material = this._getDebugMaterial(scene);
            this._debugCapsuleMesh.setEnabled(false);
        }
        return this._debugCapsuleMesh.createInstance("physicsBodyCapsuleViewInstance");
    }
    _getDebugCylinderMesh(scene) {
        if (!this._debugCylinderMesh) {
            this._debugCylinderMesh = (0, $9zY5k.CreateCylinder)("physicsBodyCylinderViewMesh", {
                diameterTop: 1,
                diameterBottom: 1,
                height: 1
            }, scene);
            this._debugCylinderMesh.rotationQuaternion = (0, $ha1VO.Quaternion).Identity();
            this._debugCylinderMesh.material = this._getDebugMaterial(scene);
            this._debugCylinderMesh.setEnabled(false);
        }
        return this._debugCylinderMesh.createInstance("physicsBodyCylinderViewInstance");
    }
    _getDebugMeshMesh(mesh, scene) {
        const wireframeOver = new (0, $fbuqw.Mesh)(mesh.name, scene, null, mesh);
        wireframeOver.setParent(mesh);
        wireframeOver.position = (0, $ha1VO.Vector3).Zero();
        wireframeOver.material = this._getDebugMaterial(scene);
        this._debugMeshMeshes.push(wireframeOver);
        return wireframeOver;
    }
    _getDebugMesh(impostor, targetMesh) {
        if (!this._utilityLayer) return null;
        // Only create child impostor debug meshes when evaluating the parent
        if (targetMesh && targetMesh.parent && targetMesh.parent.physicsImpostor) return null;
        let mesh = null;
        const utilityLayerScene = this._utilityLayer.utilityLayerScene;
        if (!impostor.physicsBody) {
            (0, $kVtWi.Logger).Warn("Unable to get physicsBody of impostor. It might be initialized later by its parent's impostor.");
            return null;
        }
        switch(impostor.type){
            case (0, $iz3U8.PhysicsImpostor).BoxImpostor:
                mesh = this._getDebugBoxMesh(utilityLayerScene);
                impostor.getBoxSizeToRef(mesh.scaling);
                break;
            case (0, $iz3U8.PhysicsImpostor).SphereImpostor:
                {
                    mesh = this._getDebugSphereMesh(utilityLayerScene);
                    const radius = impostor.getRadius();
                    mesh.scaling.x = radius * 2;
                    mesh.scaling.y = radius * 2;
                    mesh.scaling.z = radius * 2;
                    break;
                }
            case (0, $iz3U8.PhysicsImpostor).CapsuleImpostor:
                {
                    mesh = this._getDebugCapsuleMesh(utilityLayerScene);
                    const bi = impostor.object.getBoundingInfo();
                    mesh.scaling.x = (bi.boundingBox.maximum.x - bi.boundingBox.minimum.x) * 2 * impostor.object.scaling.x;
                    mesh.scaling.y = (bi.boundingBox.maximum.y - bi.boundingBox.minimum.y) * impostor.object.scaling.y;
                    mesh.scaling.z = (bi.boundingBox.maximum.z - bi.boundingBox.minimum.z) * 2 * impostor.object.scaling.z;
                    break;
                }
            case (0, $iz3U8.PhysicsImpostor).MeshImpostor:
                if (targetMesh) mesh = this._getDebugMeshMesh(targetMesh, utilityLayerScene);
                break;
            case (0, $iz3U8.PhysicsImpostor).NoImpostor:
                if (targetMesh) {
                    // Handle compound impostors
                    const childMeshes = targetMesh.getChildMeshes().filter((c)=>{
                        return c.physicsImpostor ? 1 : 0;
                    });
                    childMeshes.forEach((m)=>{
                        if (m.physicsImpostor && m.getClassName() === "Mesh") {
                            const boundingInfo = m.getBoundingInfo();
                            const min = boundingInfo.boundingBox.minimum;
                            const max = boundingInfo.boundingBox.maximum;
                            switch(m.physicsImpostor.type){
                                case (0, $iz3U8.PhysicsImpostor).BoxImpostor:
                                    mesh = this._getDebugBoxMesh(utilityLayerScene);
                                    mesh.position.copyFrom(min);
                                    mesh.position.addInPlace(max);
                                    mesh.position.scaleInPlace(0.5);
                                    break;
                                case (0, $iz3U8.PhysicsImpostor).SphereImpostor:
                                    mesh = this._getDebugSphereMesh(utilityLayerScene);
                                    break;
                                case (0, $iz3U8.PhysicsImpostor).CylinderImpostor:
                                    mesh = this._getDebugCylinderMesh(utilityLayerScene);
                                    break;
                                default:
                                    mesh = null;
                                    break;
                            }
                            if (mesh) {
                                mesh.scaling.x = max.x - min.x;
                                mesh.scaling.y = max.y - min.y;
                                mesh.scaling.z = max.z - min.z;
                                mesh.parent = m;
                            }
                        }
                    });
                } else (0, $kVtWi.Logger).Warn("No target mesh parameter provided for NoImpostor. Skipping.");
                mesh = null;
                break;
            case (0, $iz3U8.PhysicsImpostor).CylinderImpostor:
                {
                    mesh = this._getDebugCylinderMesh(utilityLayerScene);
                    const bi = impostor.object.getBoundingInfo();
                    mesh.scaling.x = (bi.boundingBox.maximum.x - bi.boundingBox.minimum.x) * impostor.object.scaling.x;
                    mesh.scaling.y = (bi.boundingBox.maximum.y - bi.boundingBox.minimum.y) * impostor.object.scaling.y;
                    mesh.scaling.z = (bi.boundingBox.maximum.z - bi.boundingBox.minimum.z) * impostor.object.scaling.z;
                    break;
                }
        }
        return mesh;
    }
    /**
     * Creates a debug mesh for a given physics body
     * @param body The physics body to create the debug mesh for
     * @returns The created debug mesh or null if the utility layer is not available
     *
     * This code is useful for creating a debug mesh for a given physics body.
     * It creates a Mesh object with a VertexData object containing the positions and indices
     * of the geometry of the body. The mesh is then assigned a debug material from the utility layer scene.
     * This allows for visualizing the physics body in the scene.
     */ _getDebugBodyMesh(body) {
        if (!this._utilityLayer) return null;
        const utilityLayerScene = this._utilityLayer.utilityLayerScene;
        const mesh = new (0, $fbuqw.Mesh)("custom", utilityLayerScene);
        const vertexData = new (0, $5v6ry.VertexData)();
        const geometry = body.getGeometry();
        vertexData.positions = geometry.positions;
        vertexData.indices = geometry.indices;
        vertexData.applyToMesh(mesh);
        if (body._pluginDataInstances) {
            const instanceBuffer = new Float32Array(body._pluginDataInstances.length * 16);
            mesh.thinInstanceSetBuffer("matrix", instanceBuffer, 16, false);
        }
        mesh.material = this._getDebugMaterial(utilityLayerScene);
        return mesh;
    }
    _getMeshDebugInertiaMatrixToRef(massProps, matrix) {
        const orientation = massProps.inertiaOrientation ?? (0, $ha1VO.Quaternion).Identity();
        const inertiaLocal = massProps.inertia ?? (0, $ha1VO.Vector3).Zero();
        const center = massProps.centerOfMass ?? (0, $ha1VO.Vector3).Zero();
        const betaSqrd = (inertiaLocal.x - inertiaLocal.y + inertiaLocal.z) * 6;
        const beta = Math.sqrt(Math.max(betaSqrd, 0)); // Safety check for zeroed elements!
        const gammaSqrd = inertiaLocal.x * 12 - betaSqrd;
        const gamma = Math.sqrt(Math.max(gammaSqrd, 0)); // Safety check for zeroed elements!
        const alphaSqrd = inertiaLocal.z * 12 - betaSqrd;
        const alpha = Math.sqrt(Math.max(alphaSqrd, 0)); // Safety check for zeroed elements!
        const extents = (0, $ha1VO.TmpVectors).Vector3[0];
        extents.set(alpha, beta, gamma);
        const scaling = (0, $ha1VO.Matrix).ScalingToRef(extents.x, extents.y, extents.z, (0, $ha1VO.TmpVectors).Matrix[0]);
        const rotation = orientation.toRotationMatrix((0, $ha1VO.TmpVectors).Matrix[1]);
        const translation = (0, $ha1VO.Matrix).TranslationToRef(center.x, center.y, center.z, (0, $ha1VO.TmpVectors).Matrix[2]);
        scaling.multiplyToRef(rotation, matrix);
        matrix.multiplyToRef(translation, matrix);
        return matrix;
    }
    _getDebugInertiaMesh(body) {
        if (!this._utilityLayer) return null;
        const utilityLayerScene = this._utilityLayer.utilityLayerScene;
        // The base inertia mesh is going to be a 1x1 cube that's scaled and rotated according to the inertia
        const inertiaBoxMesh = (0, $dls1y.MeshBuilder).CreateBox("custom", {
            size: 1
        }, utilityLayerScene);
        const matrixRef = (0, $ha1VO.Matrix).Identity();
        if (body._pluginDataInstances.length) {
            const instanceBuffer = new Float32Array(body._pluginDataInstances.length * 16);
            for(let i = 0; i < body._pluginDataInstances.length; ++i){
                const props = body.getMassProperties(i);
                this._getMeshDebugInertiaMatrixToRef(props, matrixRef);
                matrixRef.copyToArray(instanceBuffer, i * 16);
            }
            inertiaBoxMesh.thinInstanceSetBuffer("matrix", instanceBuffer, 16, false);
        } else {
            const props = body.getMassProperties();
            this._getMeshDebugInertiaMatrixToRef(props, matrixRef);
            matrixRef.decomposeToTransformNode(inertiaBoxMesh);
        }
        inertiaBoxMesh.enableEdgesRendering();
        inertiaBoxMesh.edgesWidth = 2.0;
        inertiaBoxMesh.edgesColor = new (0, $7etnY.Color4)(1, 0, 1, 1);
        inertiaBoxMesh.material = this._getDebugInertiaMaterial(utilityLayerScene);
        return inertiaBoxMesh;
    }
    _getTransformFromBodyToRef(body, matrix, instanceIndex) {
        const tnode = body.transformNode;
        if (instanceIndex && instanceIndex >= 0) return (0, $ha1VO.Matrix).FromArrayToRef(tnode._thinInstanceDataStorage.matrixData, instanceIndex, matrix);
        else return matrix.copyFrom(tnode.getWorldMatrix());
    }
    _getDebugConstraintMesh(constraint) {
        if (!this._utilityLayer) return null;
        const utilityLayerScene = this._utilityLayer.utilityLayerScene;
        if (!constraint._initOptions) return null;
        // Get constraint pivot and axes
        const { pivotA: pivotA, pivotB: pivotB, axisA: axisA, axisB: axisB, perpAxisA: perpAxisA, perpAxisB: perpAxisB } = constraint._initOptions;
        if (!pivotA || !pivotB || !axisA || !axisB || !perpAxisA || !perpAxisB) return null;
        // Create a mesh to parent all the constraint debug meshes to
        const parentingMesh = new (0, $fbuqw.Mesh)("parentingDebugConstraint", utilityLayerScene);
        // First, get a reference to all physic bodies that are using this constraint
        const bodiesUsingConstraint = constraint.getBodiesUsingConstraint();
        for (const bodyPairInfo of bodiesUsingConstraint){
            // Create a mesh to keep the pair of constraint axes
            const parentOfPair = new (0, $klshO.TransformNode)("parentOfPair", utilityLayerScene);
            parentOfPair.parent = parentingMesh;
            const { parentBody: parentBody, parentBodyIndex: parentBodyIndex, childBody: childBody, childBodyIndex: childBodyIndex } = bodyPairInfo;
            // Get the parent transform
            const parentTransform = this._getTransformFromBodyToRef(parentBody, (0, $ha1VO.TmpVectors).Matrix[0], parentBodyIndex);
            const childTransform = this._getTransformFromBodyToRef(childBody, (0, $ha1VO.TmpVectors).Matrix[1], childBodyIndex);
            const parentCoordSystemNode = new (0, $klshO.TransformNode)("parentCoordSystem", utilityLayerScene);
            // parentCoordSystemNode.parent = parentingMesh;
            parentCoordSystemNode.parent = parentOfPair;
            // Save parent and index here to be able to get the transform on update
            parentCoordSystemNode.metadata = {
                parentBody: parentBody,
                parentBodyIndex: parentBodyIndex
            };
            parentTransform.decomposeToTransformNode(parentCoordSystemNode);
            const childCoordSystemNode = new (0, $klshO.TransformNode)("childCoordSystem", utilityLayerScene);
            // childCoordSystemNode.parent = parentingMesh;
            childCoordSystemNode.parent = parentOfPair;
            // Save child and index here to be able to get the transform on update
            childCoordSystemNode.metadata = {
                childBody: childBody,
                childBodyIndex: childBodyIndex
            };
            childTransform.decomposeToTransformNode(childCoordSystemNode);
            // Get the transform to align the XYZ axes to the constraint axes
            const rotTransformParent = (0, $ha1VO.Quaternion).FromRotationMatrix((0, $ha1VO.Matrix).FromXYZAxesToRef(axisA, perpAxisA, axisA.cross(perpAxisA), (0, $ha1VO.TmpVectors).Matrix[0]));
            const rotTransformChild = (0, $ha1VO.Quaternion).FromRotationMatrix((0, $ha1VO.Matrix).FromXYZAxesToRef(axisB, perpAxisB, axisB.cross(perpAxisB), (0, $ha1VO.TmpVectors).Matrix[0]));
            const translateTransformParent = pivotA;
            const translateTransformChild = pivotB;
            // Create a transform node and set its matrix
            const parentTransformNode = new (0, $klshO.TransformNode)("constraint_parent", utilityLayerScene);
            parentTransformNode.position.copyFrom(translateTransformParent);
            parentTransformNode.rotationQuaternion = rotTransformParent;
            parentTransformNode.parent = parentCoordSystemNode;
            const childTransformNode = new (0, $klshO.TransformNode)("constraint_child", utilityLayerScene);
            childTransformNode.parent = childCoordSystemNode;
            childTransformNode.position.copyFrom(translateTransformChild);
            childTransformNode.rotationQuaternion = rotTransformChild;
            // Create axes for the constraint
            const parentAxes = new (0, $6ir1c.AxesViewer)(utilityLayerScene, this._constraintAxesSize);
            parentAxes.xAxis.parent = parentTransformNode;
            parentAxes.yAxis.parent = parentTransformNode;
            parentAxes.zAxis.parent = parentTransformNode;
            const childAxes = new (0, $6ir1c.AxesViewer)(utilityLayerScene, this._constraintAxesSize);
            childAxes.xAxis.parent = childTransformNode;
            childAxes.yAxis.parent = childTransformNode;
            childAxes.zAxis.parent = childTransformNode;
        }
        return parentingMesh;
    }
    /**
     * Clean up physics debug display
     */ dispose() {
        // impostors
        for(let index = this._numMeshes - 1; index >= 0; index--)this.hideImpostor(this._impostors[0]);
        // bodies
        for(let index = this._numBodies - 1; index >= 0; index--)this.hideBody(this._bodies[0]);
        // inertia
        for(let index = this._numInertiaBodies - 1; index >= 0; index--)this.hideInertia(this._inertiaBodies[0]);
        if (this._debugBoxMesh) this._debugBoxMesh.dispose();
        if (this._debugSphereMesh) this._debugSphereMesh.dispose();
        if (this._debugCylinderMesh) this._debugCylinderMesh.dispose();
        if (this._debugMaterial) this._debugMaterial.dispose();
        this._impostors.length = 0;
        this._scene = null;
        this._physicsEnginePlugin = null;
        if (this._utilityLayer) {
            this._utilityLayer.dispose();
            this._utilityLayer = null;
        }
    }
}

});
parcelRegister("4C7Qm", function(module, exports) {

$parcel$export(module.exports, "CreateBoxVertexData", () => $35c0cb96afcabbf6$export$61e48839003b8044);
$parcel$export(module.exports, "CreateSegmentedBoxVertexData", () => $35c0cb96afcabbf6$export$39179513b98c3e7);
$parcel$export(module.exports, "CreateBox", () => $35c0cb96afcabbf6$export$37ca2b0c6cbdecde);
$parcel$export(module.exports, "BoxBuilder", () => $35c0cb96afcabbf6$export$fadfc01d7a04cecf);

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $fbuqw = parcelRequire("fbuqw");

var $5v6ry = parcelRequire("5v6ry");

var $fGXjI = parcelRequire("fGXjI");

var $8CiHO = parcelRequire("8CiHO");
function $35c0cb96afcabbf6$export$61e48839003b8044(options) {
    const nbFaces = 6;
    let indices = [
        0,
        1,
        2,
        0,
        2,
        3,
        4,
        5,
        6,
        4,
        6,
        7,
        8,
        9,
        10,
        8,
        10,
        11,
        12,
        13,
        14,
        12,
        14,
        15,
        16,
        17,
        18,
        16,
        18,
        19,
        20,
        21,
        22,
        20,
        22,
        23
    ];
    const normals = [
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        -1,
        0,
        0,
        -1,
        0,
        0,
        -1,
        0,
        0,
        -1,
        1,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        -1,
        0,
        0,
        -1,
        0,
        0,
        -1,
        0,
        0,
        -1,
        0,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        1,
        0,
        0,
        -1,
        0,
        0,
        -1,
        0,
        0,
        -1,
        0,
        0,
        -1,
        0
    ];
    const uvs = [];
    let positions = [];
    const width = options.width || options.size || 1;
    const height = options.height || options.size || 1;
    const depth = options.depth || options.size || 1;
    const wrap = options.wrap || false;
    let topBaseAt = options.topBaseAt === void 0 ? 1 : options.topBaseAt;
    let bottomBaseAt = options.bottomBaseAt === void 0 ? 0 : options.bottomBaseAt;
    topBaseAt = (topBaseAt + 4) % 4; // places values as 0 to 3
    bottomBaseAt = (bottomBaseAt + 4) % 4; // places values as 0 to 3
    const topOrder = [
        2,
        0,
        3,
        1
    ];
    const bottomOrder = [
        2,
        0,
        1,
        3
    ];
    let topIndex = topOrder[topBaseAt];
    let bottomIndex = bottomOrder[bottomBaseAt];
    let basePositions = [
        1,
        -1,
        1,
        -1,
        -1,
        1,
        -1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        -1,
        -1,
        1,
        -1,
        -1,
        -1,
        -1,
        1,
        -1,
        -1,
        1,
        1,
        -1,
        1,
        -1,
        -1,
        1,
        -1,
        1,
        1,
        1,
        1,
        -1,
        1,
        1,
        -1,
        -1,
        1,
        -1,
        -1,
        -1,
        -1,
        1,
        -1,
        -1,
        1,
        1,
        -1,
        1,
        -1,
        1,
        1,
        -1,
        1,
        1,
        1,
        1,
        -1,
        1,
        1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        1
    ];
    if (wrap) {
        indices = [
            2,
            3,
            0,
            2,
            0,
            1,
            4,
            5,
            6,
            4,
            6,
            7,
            9,
            10,
            11,
            9,
            11,
            8,
            12,
            14,
            15,
            12,
            13,
            14
        ];
        basePositions = [
            -1,
            1,
            1,
            1,
            1,
            1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1
        ];
        let topFaceBase = [
            [
                1,
                1,
                1
            ],
            [
                -1,
                1,
                1
            ],
            [
                -1,
                1,
                -1
            ],
            [
                1,
                1,
                -1
            ]
        ];
        let bottomFaceBase = [
            [
                -1,
                -1,
                1
            ],
            [
                1,
                -1,
                1
            ],
            [
                1,
                -1,
                -1
            ],
            [
                -1,
                -1,
                -1
            ]
        ];
        const topFaceOrder = [
            17,
            18,
            19,
            16
        ];
        const bottomFaceOrder = [
            22,
            23,
            20,
            21
        ];
        while(topIndex > 0){
            topFaceBase.unshift(topFaceBase.pop());
            topFaceOrder.unshift(topFaceOrder.pop());
            topIndex--;
        }
        while(bottomIndex > 0){
            bottomFaceBase.unshift(bottomFaceBase.pop());
            bottomFaceOrder.unshift(bottomFaceOrder.pop());
            bottomIndex--;
        }
        topFaceBase = topFaceBase.flat();
        bottomFaceBase = bottomFaceBase.flat();
        basePositions = basePositions.concat(topFaceBase).concat(bottomFaceBase);
        indices.push(topFaceOrder[0], topFaceOrder[2], topFaceOrder[3], topFaceOrder[0], topFaceOrder[1], topFaceOrder[2]);
        indices.push(bottomFaceOrder[0], bottomFaceOrder[2], bottomFaceOrder[3], bottomFaceOrder[0], bottomFaceOrder[1], bottomFaceOrder[2]);
    }
    const scaleArray = [
        width / 2,
        height / 2,
        depth / 2
    ];
    positions = basePositions.reduce((accumulator, currentValue, currentIndex)=>accumulator.concat(currentValue * scaleArray[currentIndex % 3]), []);
    const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || (0, $5v6ry.VertexData).DEFAULTSIDE;
    const faceUV = options.faceUV || new Array(6);
    const faceColors = options.faceColors;
    const colors = [];
    // default face colors and UV if undefined
    for(let f = 0; f < 6; f++){
        if (faceUV[f] === undefined) faceUV[f] = new (0, $ha1VO.Vector4)(0, 0, 1, 1);
        if (faceColors && faceColors[f] === undefined) faceColors[f] = new (0, $7etnY.Color4)(1, 1, 1, 1);
    }
    // Create each face in turn.
    for(let index = 0; index < nbFaces; index++){
        uvs.push(faceUV[index].z, (0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? 1.0 - faceUV[index].w : faceUV[index].w);
        uvs.push(faceUV[index].x, (0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? 1.0 - faceUV[index].w : faceUV[index].w);
        uvs.push(faceUV[index].x, (0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? 1.0 - faceUV[index].y : faceUV[index].y);
        uvs.push(faceUV[index].z, (0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? 1.0 - faceUV[index].y : faceUV[index].y);
        if (faceColors) for(let c = 0; c < 4; c++)colors.push(faceColors[index].r, faceColors[index].g, faceColors[index].b, faceColors[index].a);
    }
    // sides
    (0, $5v6ry.VertexData)._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
    // Result
    const vertexData = new (0, $5v6ry.VertexData)();
    vertexData.indices = indices;
    vertexData.positions = positions;
    vertexData.normals = normals;
    vertexData.uvs = uvs;
    if (faceColors) {
        const totalColors = sideOrientation === (0, $5v6ry.VertexData).DOUBLESIDE ? colors.concat(colors) : colors;
        vertexData.colors = totalColors;
    }
    return vertexData;
}
function $35c0cb96afcabbf6$export$39179513b98c3e7(options) {
    const width = options.width || options.size || 1;
    const height = options.height || options.size || 1;
    const depth = options.depth || options.size || 1;
    const widthSegments = (options.widthSegments || options.segments || 1) | 0;
    const heightSegments = (options.heightSegments || options.segments || 1) | 0;
    const depthSegments = (options.depthSegments || options.segments || 1) | 0;
    const rotationMatrix = new (0, $ha1VO.Matrix)();
    const translationMatrix = new (0, $ha1VO.Matrix)();
    const transformMatrix = new (0, $ha1VO.Matrix)();
    const bottomPlane = (0, $8CiHO.CreateGroundVertexData)({
        width: width,
        height: depth,
        subdivisionsX: widthSegments,
        subdivisionsY: depthSegments
    });
    (0, $ha1VO.Matrix).TranslationToRef(0, -height / 2, 0, translationMatrix);
    (0, $ha1VO.Matrix).RotationZToRef(Math.PI, rotationMatrix);
    rotationMatrix.multiplyToRef(translationMatrix, transformMatrix);
    bottomPlane.transform(transformMatrix);
    const topPlane = (0, $8CiHO.CreateGroundVertexData)({
        width: width,
        height: depth,
        subdivisionsX: widthSegments,
        subdivisionsY: depthSegments
    });
    (0, $ha1VO.Matrix).TranslationToRef(0, height / 2, 0, transformMatrix);
    topPlane.transform(transformMatrix);
    const negXPlane = (0, $8CiHO.CreateGroundVertexData)({
        width: height,
        height: depth,
        subdivisionsX: heightSegments,
        subdivisionsY: depthSegments
    });
    (0, $ha1VO.Matrix).TranslationToRef(-width / 2, 0, 0, translationMatrix);
    (0, $ha1VO.Matrix).RotationZToRef(Math.PI / 2, rotationMatrix);
    rotationMatrix.multiplyToRef(translationMatrix, transformMatrix);
    negXPlane.transform(transformMatrix);
    const posXPlane = (0, $8CiHO.CreateGroundVertexData)({
        width: height,
        height: depth,
        subdivisionsX: heightSegments,
        subdivisionsY: depthSegments
    });
    (0, $ha1VO.Matrix).TranslationToRef(width / 2, 0, 0, translationMatrix);
    (0, $ha1VO.Matrix).RotationZToRef(-Math.PI / 2, rotationMatrix);
    rotationMatrix.multiplyToRef(translationMatrix, transformMatrix);
    posXPlane.transform(transformMatrix);
    const negZPlane = (0, $8CiHO.CreateGroundVertexData)({
        width: width,
        height: height,
        subdivisionsX: widthSegments,
        subdivisionsY: heightSegments
    });
    (0, $ha1VO.Matrix).TranslationToRef(0, 0, -depth / 2, translationMatrix);
    (0, $ha1VO.Matrix).RotationXToRef(-Math.PI / 2, rotationMatrix);
    rotationMatrix.multiplyToRef(translationMatrix, transformMatrix);
    negZPlane.transform(transformMatrix);
    const posZPlane = (0, $8CiHO.CreateGroundVertexData)({
        width: width,
        height: height,
        subdivisionsX: widthSegments,
        subdivisionsY: heightSegments
    });
    (0, $ha1VO.Matrix).TranslationToRef(0, 0, depth / 2, translationMatrix);
    (0, $ha1VO.Matrix).RotationXToRef(Math.PI / 2, rotationMatrix);
    rotationMatrix.multiplyToRef(translationMatrix, transformMatrix);
    posZPlane.transform(transformMatrix);
    // Result
    bottomPlane.merge([
        topPlane,
        posXPlane,
        negXPlane,
        negZPlane,
        posZPlane
    ], true);
    return bottomPlane;
}
function $35c0cb96afcabbf6$export$37ca2b0c6cbdecde(name, options = {}, scene = null) {
    const box = new (0, $fbuqw.Mesh)(name, scene);
    options.sideOrientation = (0, $fbuqw.Mesh)._GetDefaultSideOrientation(options.sideOrientation);
    box._originalBuilderSideOrientation = options.sideOrientation;
    const vertexData = $35c0cb96afcabbf6$export$61e48839003b8044(options);
    vertexData.applyToMesh(box, options.updatable);
    return box;
}
const $35c0cb96afcabbf6$export$fadfc01d7a04cecf = {
    CreateBox: // eslint-disable-next-line @typescript-eslint/naming-convention
    $35c0cb96afcabbf6$export$37ca2b0c6cbdecde
};
// Side effects
(0, $5v6ry.VertexData).CreateBox = $35c0cb96afcabbf6$export$61e48839003b8044;
(0, $fbuqw.Mesh).CreateBox = (name, size, scene = null, updatable, sideOrientation)=>{
    const options = {
        size: size,
        sideOrientation: sideOrientation,
        updatable: updatable
    };
    return $35c0cb96afcabbf6$export$37ca2b0c6cbdecde(name, options, scene);
};

});

parcelRegister("8KqOo", function(module, exports) {

$parcel$export(module.exports, "CreateSphereVertexData", () => $65e76adba60735aa$export$9639f6f681cdb12);
$parcel$export(module.exports, "CreateSphere", () => $65e76adba60735aa$export$7d1fdd0805366e9b);
$parcel$export(module.exports, "SphereBuilder", () => $65e76adba60735aa$export$3be740db72ac9cf4);

var $ha1VO = parcelRequire("ha1VO");

var $fbuqw = parcelRequire("fbuqw");

var $5v6ry = parcelRequire("5v6ry");

var $fGXjI = parcelRequire("fGXjI");
function $65e76adba60735aa$export$9639f6f681cdb12(options) {
    const segments = (options.segments || 32) | 0;
    const diameterX = options.diameterX || options.diameter || 1;
    const diameterY = options.diameterY || options.diameter || 1;
    const diameterZ = options.diameterZ || options.diameter || 1;
    const arc = options.arc && (options.arc <= 0 || options.arc > 1) ? 1.0 : options.arc || 1.0;
    const slice = options.slice && options.slice <= 0 ? 1.0 : options.slice || 1.0;
    const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || (0, $5v6ry.VertexData).DEFAULTSIDE;
    const dedupTopBottomIndices = !!options.dedupTopBottomIndices;
    const radius = new (0, $ha1VO.Vector3)(diameterX / 2, diameterY / 2, diameterZ / 2);
    const totalZRotationSteps = 2 + segments;
    const totalYRotationSteps = 2 * totalZRotationSteps;
    const indices = [];
    const positions = [];
    const normals = [];
    const uvs = [];
    for(let zRotationStep = 0; zRotationStep <= totalZRotationSteps; zRotationStep++){
        const normalizedZ = zRotationStep / totalZRotationSteps;
        const angleZ = normalizedZ * Math.PI * slice;
        for(let yRotationStep = 0; yRotationStep <= totalYRotationSteps; yRotationStep++){
            const normalizedY = yRotationStep / totalYRotationSteps;
            const angleY = normalizedY * Math.PI * 2 * arc;
            const rotationZ = (0, $ha1VO.Matrix).RotationZ(-angleZ);
            const rotationY = (0, $ha1VO.Matrix).RotationY(angleY);
            const afterRotZ = (0, $ha1VO.Vector3).TransformCoordinates((0, $ha1VO.Vector3).Up(), rotationZ);
            const complete = (0, $ha1VO.Vector3).TransformCoordinates(afterRotZ, rotationY);
            const vertex = complete.multiply(radius);
            const normal = complete.divide(radius).normalize();
            positions.push(vertex.x, vertex.y, vertex.z);
            normals.push(normal.x, normal.y, normal.z);
            uvs.push(normalizedY, (0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? 1.0 - normalizedZ : normalizedZ);
        }
        if (zRotationStep > 0) {
            const verticesCount = positions.length / 3;
            for(let firstIndex = verticesCount - 2 * (totalYRotationSteps + 1); firstIndex + totalYRotationSteps + 2 < verticesCount; firstIndex++)if (dedupTopBottomIndices) {
                if (zRotationStep > 1) {
                    indices.push(firstIndex);
                    indices.push(firstIndex + 1);
                    indices.push(firstIndex + totalYRotationSteps + 1);
                }
                if (zRotationStep < totalZRotationSteps || slice < 1.0) {
                    indices.push(firstIndex + totalYRotationSteps + 1);
                    indices.push(firstIndex + 1);
                    indices.push(firstIndex + totalYRotationSteps + 2);
                }
            } else {
                indices.push(firstIndex);
                indices.push(firstIndex + 1);
                indices.push(firstIndex + totalYRotationSteps + 1);
                indices.push(firstIndex + totalYRotationSteps + 1);
                indices.push(firstIndex + 1);
                indices.push(firstIndex + totalYRotationSteps + 2);
            }
        }
    }
    // Sides
    (0, $5v6ry.VertexData)._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
    // Result
    const vertexData = new (0, $5v6ry.VertexData)();
    vertexData.indices = indices;
    vertexData.positions = positions;
    vertexData.normals = normals;
    vertexData.uvs = uvs;
    return vertexData;
}
function $65e76adba60735aa$export$7d1fdd0805366e9b(name, options = {}, scene = null) {
    const sphere = new (0, $fbuqw.Mesh)(name, scene);
    options.sideOrientation = (0, $fbuqw.Mesh)._GetDefaultSideOrientation(options.sideOrientation);
    sphere._originalBuilderSideOrientation = options.sideOrientation;
    const vertexData = $65e76adba60735aa$export$9639f6f681cdb12(options);
    vertexData.applyToMesh(sphere, options.updatable);
    return sphere;
}
const $65e76adba60735aa$export$3be740db72ac9cf4 = {
    CreateSphere: // eslint-disable-next-line @typescript-eslint/naming-convention
    $65e76adba60735aa$export$7d1fdd0805366e9b
};
(0, $5v6ry.VertexData).CreateSphere = $65e76adba60735aa$export$9639f6f681cdb12;
(0, $fbuqw.Mesh).CreateSphere = (name, segments, diameter, scene, updatable, sideOrientation)=>{
    const options = {
        segments: segments,
        diameterX: diameter,
        diameterY: diameter,
        diameterZ: diameter,
        sideOrientation: sideOrientation,
        updatable: updatable
    };
    return $65e76adba60735aa$export$7d1fdd0805366e9b(name, options, scene);
};

});

parcelRegister("22sXo", function(module, exports) {

$parcel$export(module.exports, "CreateCapsuleVertexData", () => $17c23aeaa7b72fc3$export$b6cc02d55f5d27b2);
$parcel$export(module.exports, "CreateCapsule", () => $17c23aeaa7b72fc3$export$509367f6dcf345a3);
$parcel$export(module.exports, "CapsuleBuilder", () => $17c23aeaa7b72fc3$export$275401f3d9833758);

var $5v6ry = parcelRequire("5v6ry");

var $ha1VO = parcelRequire("ha1VO");

var $fbuqw = parcelRequire("fbuqw");

var $fGXjI = parcelRequire("fGXjI");
function $17c23aeaa7b72fc3$export$b6cc02d55f5d27b2(options = {
    subdivisions: 2,
    tessellation: 16,
    height: 1,
    radius: 0.25,
    capSubdivisions: 6
}) {
    const subdivisions = Math.max(options.subdivisions ? options.subdivisions : 2, 1) | 0;
    const tessellation = Math.max(options.tessellation ? options.tessellation : 16, 3) | 0;
    const height = Math.max(options.height ? options.height : 1, 0);
    const radius = Math.max(options.radius ? options.radius : 0.25, 0);
    const capDetail = Math.max(options.capSubdivisions ? options.capSubdivisions : 6, 1) | 0;
    const radialSegments = tessellation;
    const heightSegments = subdivisions;
    const radiusTop = Math.max(options.radiusTop ? options.radiusTop : radius, 0);
    const radiusBottom = Math.max(options.radiusBottom ? options.radiusBottom : radius, 0);
    const heightMinusCaps = height - (radiusTop + radiusBottom);
    const thetaStart = 0.0;
    const thetaLength = 2.0 * Math.PI;
    const capsTopSegments = Math.max(options.topCapSubdivisions ? options.topCapSubdivisions : capDetail, 1);
    const capsBottomSegments = Math.max(options.bottomCapSubdivisions ? options.bottomCapSubdivisions : capDetail, 1);
    const alpha = Math.acos((radiusBottom - radiusTop) / height);
    let indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    let index = 0;
    const indexArray = [], halfHeight = heightMinusCaps * 0.5;
    const pi2 = Math.PI * 0.5;
    let x, y;
    const normal = (0, $ha1VO.Vector3).Zero();
    const vertex = (0, $ha1VO.Vector3).Zero();
    const cosAlpha = Math.cos(alpha);
    const sinAlpha = Math.sin(alpha);
    const coneLength = new (0, $ha1VO.Vector2)(radiusTop * sinAlpha, halfHeight + radiusTop * cosAlpha).subtract(new (0, $ha1VO.Vector2)(radiusBottom * sinAlpha, -halfHeight + radiusBottom * cosAlpha)).length();
    // Total length for v texture coord
    const vl = radiusTop * alpha + coneLength + radiusBottom * (pi2 - alpha);
    let v = 0;
    for(y = 0; y <= capsTopSegments; y++){
        const indexRow = [];
        const a = pi2 - alpha * (y / capsTopSegments);
        v += radiusTop * alpha / capsTopSegments;
        const cosA = Math.cos(a);
        const sinA = Math.sin(a);
        // calculate the radius of the current row
        const _radius = cosA * radiusTop;
        for(x = 0; x <= radialSegments; x++){
            const u = x / radialSegments;
            const theta = u * thetaLength + thetaStart;
            const sinTheta = Math.sin(theta);
            const cosTheta = Math.cos(theta);
            // vertex
            vertex.x = _radius * sinTheta;
            vertex.y = halfHeight + sinA * radiusTop;
            vertex.z = _radius * cosTheta;
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normal.set(cosA * sinTheta, sinA, cosA * cosTheta);
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(u, (0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? v / vl : 1 - v / vl);
            // save index of vertex in respective row
            indexRow.push(index);
            // increase index
            index++;
        }
        // now save vertices of the row in our index array
        indexArray.push(indexRow);
    }
    const coneHeight = height - radiusTop - radiusBottom + cosAlpha * radiusTop - cosAlpha * radiusBottom;
    const slope = sinAlpha * (radiusBottom - radiusTop) / coneHeight;
    for(y = 1; y <= heightSegments; y++){
        const indexRow = [];
        v += coneLength / heightSegments;
        // calculate the radius of the current row
        const _radius = sinAlpha * (y * (radiusBottom - radiusTop) / heightSegments + radiusTop);
        for(x = 0; x <= radialSegments; x++){
            const u = x / radialSegments;
            const theta = u * thetaLength + thetaStart;
            const sinTheta = Math.sin(theta);
            const cosTheta = Math.cos(theta);
            // vertex
            vertex.x = _radius * sinTheta;
            vertex.y = halfHeight + cosAlpha * radiusTop - y * coneHeight / heightSegments;
            vertex.z = _radius * cosTheta;
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normal.set(sinTheta, slope, cosTheta).normalize();
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(u, (0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? v / vl : 1 - v / vl);
            // save index of vertex in respective row
            indexRow.push(index);
            // increase index
            index++;
        }
        // now save vertices of the row in our index array
        indexArray.push(indexRow);
    }
    for(y = 1; y <= capsBottomSegments; y++){
        const indexRow = [];
        const a = pi2 - alpha - (Math.PI - alpha) * (y / capsBottomSegments);
        v += radiusBottom * alpha / capsBottomSegments;
        const cosA = Math.cos(a);
        const sinA = Math.sin(a);
        // calculate the radius of the current row
        const _radius = cosA * radiusBottom;
        for(x = 0; x <= radialSegments; x++){
            const u = x / radialSegments;
            const theta = u * thetaLength + thetaStart;
            const sinTheta = Math.sin(theta);
            const cosTheta = Math.cos(theta);
            // vertex
            vertex.x = _radius * sinTheta;
            vertex.y = -halfHeight + sinA * radiusBottom;
            vertex.z = _radius * cosTheta;
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normal.set(cosA * sinTheta, sinA, cosA * cosTheta);
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(u, (0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? v / vl : 1 - v / vl);
            // save index of vertex in respective row
            indexRow.push(index);
            // increase index
            index++;
        }
        // now save vertices of the row in our index array
        indexArray.push(indexRow);
    }
    // generate indices
    for(x = 0; x < radialSegments; x++)for(y = 0; y < capsTopSegments + heightSegments + capsBottomSegments; y++){
        // we use the index array to access the correct indices
        const i1 = indexArray[y][x];
        const i2 = indexArray[y + 1][x];
        const i3 = indexArray[y + 1][x + 1];
        const i4 = indexArray[y][x + 1];
        // face one
        indices.push(i1);
        indices.push(i2);
        indices.push(i4);
        // face two
        indices.push(i2);
        indices.push(i3);
        indices.push(i4);
    }
    indices = indices.reverse();
    if (options.orientation && !options.orientation.equals((0, $ha1VO.Vector3).Up())) {
        const m = new (0, $ha1VO.Matrix)();
        options.orientation.clone().scale(Math.PI * 0.5).cross((0, $ha1VO.Vector3).Up()).toQuaternion().toRotationMatrix(m);
        const v = (0, $ha1VO.Vector3).Zero();
        for(let i = 0; i < vertices.length; i += 3){
            v.set(vertices[i], vertices[i + 1], vertices[i + 2]);
            (0, $ha1VO.Vector3).TransformCoordinatesToRef(v.clone(), m, v);
            vertices[i] = v.x;
            vertices[i + 1] = v.y;
            vertices[i + 2] = v.z;
        }
    }
    const vDat = new (0, $5v6ry.VertexData)();
    vDat.positions = vertices;
    vDat.normals = normals;
    vDat.uvs = uvs;
    vDat.indices = indices;
    return vDat;
}
function $17c23aeaa7b72fc3$export$509367f6dcf345a3(name, options = {
    orientation: (0, $ha1VO.Vector3).Up(),
    subdivisions: 2,
    tessellation: 16,
    height: 1,
    radius: 0.25,
    capSubdivisions: 6,
    updatable: false
}, scene = null) {
    const capsule = new (0, $fbuqw.Mesh)(name, scene);
    const vertexData = $17c23aeaa7b72fc3$export$b6cc02d55f5d27b2(options);
    vertexData.applyToMesh(capsule, options.updatable);
    return capsule;
}
const $17c23aeaa7b72fc3$export$275401f3d9833758 = {
    CreateCapsule: // eslint-disable-next-line @typescript-eslint/naming-convention
    $17c23aeaa7b72fc3$export$509367f6dcf345a3
};
/**
 * Creates a capsule or a pill mesh
 * @param name defines the name of the mesh.
 * @param options the constructors options used to shape the mesh.
 * @param scene defines the scene the mesh is scoped to.
 * @returns the capsule mesh
 * @see https://doc.babylonjs.com/how_to/capsule_shape
 */ (0, $fbuqw.Mesh).CreateCapsule = (name, options, scene)=>{
    return $17c23aeaa7b72fc3$export$509367f6dcf345a3(name, options, scene);
};
(0, $5v6ry.VertexData).CreateCapsule = $17c23aeaa7b72fc3$export$b6cc02d55f5d27b2;

});

parcelRegister("dls1y", function(module, exports) {

$parcel$export(module.exports, "MeshBuilder", () => $9b72f98286da73ed$export$b65e9a89c410ca15);
/* eslint-disable @typescript-eslint/naming-convention */ 
var $aFflY = parcelRequire("aFflY");

var $fWMvm = parcelRequire("fWMvm");

var $4C7Qm = parcelRequire("4C7Qm");

var $fPX0M = parcelRequire("fPX0M");

var $8KqOo = parcelRequire("8KqOo");

var $9zY5k = parcelRequire("9zY5k");

var $bCJrn = parcelRequire("bCJrn");

var $geytg = parcelRequire("geytg");

var $8Eyol = parcelRequire("8Eyol");

var $a2Hja = parcelRequire("a2Hja");

var $l411O = parcelRequire("l411O");

var $g8AI7 = parcelRequire("g8AI7");

var $kt6s5 = parcelRequire("kt6s5");

var $li5Nf = parcelRequire("li5Nf");

var $8CiHO = parcelRequire("8CiHO");

var $4gG1w = parcelRequire("4gG1w");

var $2vSVS = parcelRequire("2vSVS");

var $g3tvW = parcelRequire("g3tvW");

var $1ewDO = parcelRequire("1ewDO");

var $22sXo = parcelRequire("22sXo");

var $kZzg0 = parcelRequire("kZzg0");

var $5EAju = parcelRequire("5EAju");

var $dBltS = parcelRequire("dBltS");
const $9b72f98286da73ed$export$b65e9a89c410ca15 = {
    CreateBox: $4C7Qm.CreateBox,
    CreateTiledBox: $fPX0M.CreateTiledBox,
    CreateSphere: $8KqOo.CreateSphere,
    CreateDisc: $fWMvm.CreateDisc,
    CreateIcoSphere: $g3tvW.CreateIcoSphere,
    CreateRibbon: $aFflY.CreateRibbon,
    CreateCylinder: $9zY5k.CreateCylinder,
    CreateTorus: $bCJrn.CreateTorus,
    CreateTorusKnot: $geytg.CreateTorusKnot,
    CreateLineSystem: $8Eyol.CreateLineSystem,
    CreateLines: $8Eyol.CreateLines,
    CreateDashedLines: $8Eyol.CreateDashedLines,
    ExtrudeShape: $l411O.ExtrudeShape,
    ExtrudeShapeCustom: $l411O.ExtrudeShapeCustom,
    CreateLathe: $g8AI7.CreateLathe,
    CreateTiledPlane: $li5Nf.CreateTiledPlane,
    CreatePlane: $kt6s5.CreatePlane,
    CreateGround: $8CiHO.CreateGround,
    CreateTiledGround: $8CiHO.CreateTiledGround,
    CreateGroundFromHeightMap: $8CiHO.CreateGroundFromHeightMap,
    CreatePolygon: $a2Hja.CreatePolygon,
    ExtrudePolygon: $a2Hja.ExtrudePolygon,
    CreateTube: $4gG1w.CreateTube,
    CreatePolyhedron: $2vSVS.CreatePolyhedron,
    CreateGeodesic: $kZzg0.CreateGeodesic,
    CreateGoldberg: $5EAju.CreateGoldberg,
    CreateDecal: $1ewDO.CreateDecal,
    CreateCapsule: $22sXo.CreateCapsule,
    CreateText: $dBltS.CreateText
};

});
parcelRegister("aFflY", function(module, exports) {

$parcel$export(module.exports, "CreateRibbonVertexData", () => $7c39a49659d9e77f$export$8bfbd062631af8b2);
$parcel$export(module.exports, "CreateRibbon", () => $7c39a49659d9e77f$export$821dd8d5c9753978);
$parcel$export(module.exports, "RibbonBuilder", () => $7c39a49659d9e77f$export$17914ccb395fb032);

var $ha1VO = parcelRequire("ha1VO");

var $fbuqw = parcelRequire("fbuqw");

var $b4i1f = parcelRequire("b4i1f");

var $5v6ry = parcelRequire("5v6ry");

var $fGXjI = parcelRequire("fGXjI");
function $7c39a49659d9e77f$export$8bfbd062631af8b2(options) {
    let pathArray = options.pathArray;
    const closeArray = options.closeArray || false;
    const closePath = options.closePath || false;
    const invertUV = options.invertUV || false;
    const defaultOffset = Math.floor(pathArray[0].length / 2);
    let offset = options.offset || defaultOffset;
    offset = offset > defaultOffset ? defaultOffset : Math.floor(offset); // offset max allowed : defaultOffset
    const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || (0, $5v6ry.VertexData).DEFAULTSIDE;
    const customUV = options.uvs;
    const customColors = options.colors;
    const positions = [];
    const indices = [];
    const normals = [];
    const uvs = [];
    const us = []; // us[path_id] = [uDist1, uDist2, uDist3 ... ] distances between points on path path_id
    const vs = []; // vs[i] = [vDist1, vDist2, vDist3, ... ] distances between points i of consecutive paths from pathArray
    const uTotalDistance = []; // uTotalDistance[p] : total distance of path p
    const vTotalDistance = []; //  vTotalDistance[i] : total distance between points i of first and last path from pathArray
    let minlg; // minimal length among all paths from pathArray
    const lg = []; // array of path lengths : nb of vertex per path
    const idx = []; // array of path indexes : index of each path (first vertex) in the total vertex number
    let p; // path iterator
    let i; // point iterator
    let j; // point iterator
    // if single path in pathArray
    if (pathArray.length < 2) {
        const ar1 = [];
        const ar2 = [];
        for(i = 0; i < pathArray[0].length - offset; i++){
            ar1.push(pathArray[0][i]);
            ar2.push(pathArray[0][i + offset]);
        }
        pathArray = [
            ar1,
            ar2
        ];
    }
    // positions and horizontal distances (u)
    let idc = 0;
    const closePathCorr = closePath ? 1 : 0; // the final index will be +1 if closePath
    let path;
    let l;
    minlg = pathArray[0].length;
    let vectlg;
    let dist;
    for(p = 0; p < pathArray.length; p++){
        uTotalDistance[p] = 0;
        us[p] = [
            0
        ];
        path = pathArray[p];
        l = path.length;
        minlg = minlg < l ? minlg : l;
        j = 0;
        while(j < l){
            positions.push(path[j].x, path[j].y, path[j].z);
            if (j > 0) {
                vectlg = path[j].subtract(path[j - 1]).length();
                dist = vectlg + uTotalDistance[p];
                us[p].push(dist);
                uTotalDistance[p] = dist;
            }
            j++;
        }
        if (closePath) {
            // an extra hidden vertex is added in the "positions" array
            j--;
            positions.push(path[0].x, path[0].y, path[0].z);
            vectlg = path[j].subtract(path[0]).length();
            dist = vectlg + uTotalDistance[p];
            us[p].push(dist);
            uTotalDistance[p] = dist;
        }
        lg[p] = l + closePathCorr;
        idx[p] = idc;
        idc += l + closePathCorr;
    }
    // vertical distances (v)
    let path1;
    let path2;
    let vertex1 = null;
    let vertex2 = null;
    for(i = 0; i < minlg + closePathCorr; i++){
        vTotalDistance[i] = 0;
        vs[i] = [
            0
        ];
        for(p = 0; p < pathArray.length - 1; p++){
            path1 = pathArray[p];
            path2 = pathArray[p + 1];
            if (i === minlg) {
                // closePath
                vertex1 = path1[0];
                vertex2 = path2[0];
            } else {
                vertex1 = path1[i];
                vertex2 = path2[i];
            }
            vectlg = vertex2.subtract(vertex1).length();
            dist = vectlg + vTotalDistance[i];
            vs[i].push(dist);
            vTotalDistance[i] = dist;
        }
        if (closeArray && vertex2 && vertex1) {
            path1 = pathArray[p];
            path2 = pathArray[0];
            if (i === minlg) // closePath
            vertex2 = path2[0];
            vectlg = vertex2.subtract(vertex1).length();
            dist = vectlg + vTotalDistance[i];
            vTotalDistance[i] = dist;
        }
    }
    // uvs
    let u;
    let v;
    if (customUV) for(p = 0; p < customUV.length; p++)uvs.push(customUV[p].x, (0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? 1.0 - customUV[p].y : customUV[p].y);
    else {
        for(p = 0; p < pathArray.length; p++)for(i = 0; i < minlg + closePathCorr; i++){
            u = uTotalDistance[p] != 0.0 ? us[p][i] / uTotalDistance[p] : 0.0;
            v = vTotalDistance[i] != 0.0 ? vs[i][p] / vTotalDistance[i] : 0.0;
            if (invertUV) uvs.push(v, u);
            else uvs.push(u, (0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? 1.0 - v : v);
        }
    }
    // indices
    p = 0; // path index
    let pi = 0; // positions array index
    let l1 = lg[p] - 1; // path1 length
    let l2 = lg[p + 1] - 1; // path2 length
    let min = l1 < l2 ? l1 : l2; // current path stop index
    let shft = idx[1] - idx[0]; // shift
    const path1nb = closeArray ? lg.length : lg.length - 1; // number of path1 to iterate	on
    while(pi <= min && p < path1nb){
        //  stay under min and don't go over next to last path
        // draw two triangles between path1 (p1) and path2 (p2) : (p1.pi, p2.pi, p1.pi+1) and (p2.pi+1, p1.pi+1, p2.pi) clockwise
        indices.push(pi, pi + shft, pi + 1);
        indices.push(pi + shft + 1, pi + 1, pi + shft);
        pi += 1;
        if (pi === min) {
            // if end of one of two consecutive paths reached, go to next existing path
            p++;
            if (p === lg.length - 1) {
                // last path of pathArray reached <=> closeArray == true
                shft = idx[0] - idx[p];
                l1 = lg[p] - 1;
                l2 = lg[0] - 1;
            } else {
                shft = idx[p + 1] - idx[p];
                l1 = lg[p] - 1;
                l2 = lg[p + 1] - 1;
            }
            pi = idx[p];
            min = l1 < l2 ? l1 + pi : l2 + pi;
        }
    }
    // normals
    (0, $5v6ry.VertexData).ComputeNormals(positions, indices, normals);
    if (closePath) {
        // update both the first and last vertex normals to their average value
        let indexFirst = 0;
        let indexLast = 0;
        for(p = 0; p < pathArray.length; p++){
            indexFirst = idx[p] * 3;
            if (p + 1 < pathArray.length) indexLast = (idx[p + 1] - 1) * 3;
            else indexLast = normals.length - 3;
            normals[indexFirst] = (normals[indexFirst] + normals[indexLast]) * 0.5;
            normals[indexFirst + 1] = (normals[indexFirst + 1] + normals[indexLast + 1]) * 0.5;
            normals[indexFirst + 2] = (normals[indexFirst + 2] + normals[indexLast + 2]) * 0.5;
            normals[indexLast] = normals[indexFirst];
            normals[indexLast + 1] = normals[indexFirst + 1];
            normals[indexLast + 2] = normals[indexFirst + 2];
        }
    }
    // sides
    (0, $5v6ry.VertexData)._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
    // Colors
    let colors = null;
    if (customColors) {
        colors = new Float32Array(customColors.length * 4);
        for(let c = 0; c < customColors.length; c++){
            colors[c * 4] = customColors[c].r;
            colors[c * 4 + 1] = customColors[c].g;
            colors[c * 4 + 2] = customColors[c].b;
            colors[c * 4 + 3] = customColors[c].a;
        }
    }
    // Result
    const vertexData = new (0, $5v6ry.VertexData)();
    const positions32 = new Float32Array(positions);
    const normals32 = new Float32Array(normals);
    const uvs32 = new Float32Array(uvs);
    vertexData.indices = indices;
    vertexData.positions = positions32;
    vertexData.normals = normals32;
    vertexData.uvs = uvs32;
    if (colors) vertexData.set(colors, (0, $b4i1f.VertexBuffer).ColorKind);
    if (closePath) vertexData._idx = idx;
    return vertexData;
}
function $7c39a49659d9e77f$export$821dd8d5c9753978(name, options, scene = null) {
    const pathArray = options.pathArray;
    const closeArray = options.closeArray;
    const closePath = options.closePath;
    const sideOrientation = (0, $fbuqw.Mesh)._GetDefaultSideOrientation(options.sideOrientation);
    const instance = options.instance;
    const updatable = options.updatable;
    if (instance) {
        // existing ribbon instance update
        // positionFunction : ribbon case
        // only pathArray and sideOrientation parameters are taken into account for positions update
        const minimum = (0, $ha1VO.TmpVectors).Vector3[0].setAll(Number.MAX_VALUE);
        const maximum = (0, $ha1VO.TmpVectors).Vector3[1].setAll(-Number.MAX_VALUE);
        const positionFunction = (positions)=>{
            let minlg = pathArray[0].length;
            const mesh = instance;
            let i = 0;
            const ns = mesh._originalBuilderSideOrientation === (0, $fbuqw.Mesh).DOUBLESIDE ? 2 : 1;
            for(let si = 1; si <= ns; ++si)for(let p = 0; p < pathArray.length; ++p){
                const path = pathArray[p];
                const l = path.length;
                minlg = minlg < l ? minlg : l;
                for(let j = 0; j < minlg; ++j){
                    const pathPoint = path[j];
                    positions[i] = pathPoint.x;
                    positions[i + 1] = pathPoint.y;
                    positions[i + 2] = pathPoint.z;
                    minimum.minimizeInPlaceFromFloats(pathPoint.x, pathPoint.y, pathPoint.z);
                    maximum.maximizeInPlaceFromFloats(pathPoint.x, pathPoint.y, pathPoint.z);
                    i += 3;
                }
                if (mesh._creationDataStorage && mesh._creationDataStorage.closePath) {
                    const pathPoint = path[0];
                    positions[i] = pathPoint.x;
                    positions[i + 1] = pathPoint.y;
                    positions[i + 2] = pathPoint.z;
                    i += 3;
                }
            }
        };
        const positions = instance.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        positionFunction(positions);
        if (instance.hasBoundingInfo) instance.getBoundingInfo().reConstruct(minimum, maximum, instance._worldMatrix);
        else instance.buildBoundingInfo(minimum, maximum, instance._worldMatrix);
        instance.updateVerticesData((0, $b4i1f.VertexBuffer).PositionKind, positions, false, false);
        if (options.colors) {
            const colors = instance.getVerticesData((0, $b4i1f.VertexBuffer).ColorKind);
            for(let c = 0, colorIndex = 0; c < options.colors.length; c++, colorIndex += 4){
                const color = options.colors[c];
                colors[colorIndex] = color.r;
                colors[colorIndex + 1] = color.g;
                colors[colorIndex + 2] = color.b;
                colors[colorIndex + 3] = color.a;
            }
            instance.updateVerticesData((0, $b4i1f.VertexBuffer).ColorKind, colors, false, false);
        }
        if (options.uvs) {
            const uvs = instance.getVerticesData((0, $b4i1f.VertexBuffer).UVKind);
            for(let i = 0; i < options.uvs.length; i++){
                uvs[i * 2] = options.uvs[i].x;
                uvs[i * 2 + 1] = (0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? 1.0 - options.uvs[i].y : options.uvs[i].y;
            }
            instance.updateVerticesData((0, $b4i1f.VertexBuffer).UVKind, uvs, false, false);
        }
        if (!instance.areNormalsFrozen || instance.isFacetDataEnabled) {
            const indices = instance.getIndices();
            const normals = instance.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind);
            const params = instance.isFacetDataEnabled ? instance.getFacetDataParameters() : null;
            (0, $5v6ry.VertexData).ComputeNormals(positions, indices, normals, params);
            if (instance._creationDataStorage && instance._creationDataStorage.closePath) {
                let indexFirst = 0;
                let indexLast = 0;
                for(let p = 0; p < pathArray.length; p++){
                    indexFirst = instance._creationDataStorage.idx[p] * 3;
                    if (p + 1 < pathArray.length) indexLast = (instance._creationDataStorage.idx[p + 1] - 1) * 3;
                    else indexLast = normals.length - 3;
                    normals[indexFirst] = (normals[indexFirst] + normals[indexLast]) * 0.5;
                    normals[indexFirst + 1] = (normals[indexFirst + 1] + normals[indexLast + 1]) * 0.5;
                    normals[indexFirst + 2] = (normals[indexFirst + 2] + normals[indexLast + 2]) * 0.5;
                    normals[indexLast] = normals[indexFirst];
                    normals[indexLast + 1] = normals[indexFirst + 1];
                    normals[indexLast + 2] = normals[indexFirst + 2];
                }
            }
            if (!instance.areNormalsFrozen) instance.updateVerticesData((0, $b4i1f.VertexBuffer).NormalKind, normals, false, false);
        }
        return instance;
    } else {
        // new ribbon creation
        const ribbon = new (0, $fbuqw.Mesh)(name, scene);
        ribbon._originalBuilderSideOrientation = sideOrientation;
        ribbon._creationDataStorage = new (0, $fbuqw._CreationDataStorage)();
        const vertexData = $7c39a49659d9e77f$export$8bfbd062631af8b2(options);
        if (closePath) ribbon._creationDataStorage.idx = vertexData._idx;
        ribbon._creationDataStorage.closePath = closePath;
        ribbon._creationDataStorage.closeArray = closeArray;
        vertexData.applyToMesh(ribbon, updatable);
        return ribbon;
    }
}
const $7c39a49659d9e77f$export$17914ccb395fb032 = {
    CreateRibbon: // eslint-disable-next-line @typescript-eslint/naming-convention
    $7c39a49659d9e77f$export$821dd8d5c9753978
};
(0, $5v6ry.VertexData).CreateRibbon = $7c39a49659d9e77f$export$8bfbd062631af8b2;
(0, $fbuqw.Mesh).CreateRibbon = (name, pathArray, closeArray = false, closePath, offset, scene, updatable = false, sideOrientation, instance)=>{
    return $7c39a49659d9e77f$export$821dd8d5c9753978(name, {
        pathArray: pathArray,
        closeArray: closeArray,
        closePath: closePath,
        offset: offset,
        updatable: updatable,
        sideOrientation: sideOrientation,
        instance: instance
    }, scene);
};

});

parcelRegister("fWMvm", function(module, exports) {

$parcel$export(module.exports, "CreateDiscVertexData", () => $b9c1e5d353ae02eb$export$22f9ddef46ce85f7);
$parcel$export(module.exports, "CreateDisc", () => $b9c1e5d353ae02eb$export$1ad3b05eb0bcfa7f);
$parcel$export(module.exports, "DiscBuilder", () => $b9c1e5d353ae02eb$export$ea7bd162c220cdb3);

var $fbuqw = parcelRequire("fbuqw");

var $5v6ry = parcelRequire("5v6ry");

var $fGXjI = parcelRequire("fGXjI");
function $b9c1e5d353ae02eb$export$22f9ddef46ce85f7(options) {
    const positions = [];
    const indices = [];
    const normals = [];
    const uvs = [];
    const radius = options.radius || 0.5;
    const tessellation = options.tessellation || 64;
    const arc = options.arc && (options.arc <= 0 || options.arc > 1) ? 1.0 : options.arc || 1.0;
    const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || (0, $5v6ry.VertexData).DEFAULTSIDE;
    // positions and uvs
    positions.push(0, 0, 0); // disc center first
    uvs.push(0.5, 0.5);
    const theta = Math.PI * 2 * arc;
    const step = arc === 1 ? theta / tessellation : theta / (tessellation - 1);
    let a = 0;
    for(let t = 0; t < tessellation; t++){
        const x = Math.cos(a);
        const y = Math.sin(a);
        const u = (x + 1) / 2;
        const v = (1 - y) / 2;
        positions.push(radius * x, radius * y, 0);
        uvs.push(u, (0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? 1 - v : v);
        a += step;
    }
    if (arc === 1) {
        positions.push(positions[3], positions[4], positions[5]); // close the circle
        uvs.push(uvs[2], (0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? 1 - uvs[3] : uvs[3]);
    }
    //indices
    const vertexNb = positions.length / 3;
    for(let i = 1; i < vertexNb - 1; i++)indices.push(i + 1, 0, i);
    // result
    (0, $5v6ry.VertexData).ComputeNormals(positions, indices, normals);
    (0, $5v6ry.VertexData)._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
    const vertexData = new (0, $5v6ry.VertexData)();
    vertexData.indices = indices;
    vertexData.positions = positions;
    vertexData.normals = normals;
    vertexData.uvs = uvs;
    return vertexData;
}
function $b9c1e5d353ae02eb$export$1ad3b05eb0bcfa7f(name, options = {}, scene = null) {
    const disc = new (0, $fbuqw.Mesh)(name, scene);
    options.sideOrientation = (0, $fbuqw.Mesh)._GetDefaultSideOrientation(options.sideOrientation);
    disc._originalBuilderSideOrientation = options.sideOrientation;
    const vertexData = $b9c1e5d353ae02eb$export$22f9ddef46ce85f7(options);
    vertexData.applyToMesh(disc, options.updatable);
    return disc;
}
const $b9c1e5d353ae02eb$export$ea7bd162c220cdb3 = {
    CreateDisc: // eslint-disable-next-line @typescript-eslint/naming-convention
    $b9c1e5d353ae02eb$export$1ad3b05eb0bcfa7f
};
(0, $5v6ry.VertexData).CreateDisc = $b9c1e5d353ae02eb$export$22f9ddef46ce85f7;
(0, $fbuqw.Mesh).CreateDisc = (name, radius, tessellation, scene = null, updatable, sideOrientation)=>{
    const options = {
        radius: radius,
        tessellation: tessellation,
        sideOrientation: sideOrientation,
        updatable: updatable
    };
    return $b9c1e5d353ae02eb$export$1ad3b05eb0bcfa7f(name, options, scene);
};

});

parcelRegister("fPX0M", function(module, exports) {

$parcel$export(module.exports, "CreateTiledBoxVertexData", () => $b87964e9a5a0cd0a$export$3d751018f73de3b6);
$parcel$export(module.exports, "CreateTiledBox", () => $b87964e9a5a0cd0a$export$1fb6e45d350ad273);
$parcel$export(module.exports, "TiledBoxBuilder", () => $b87964e9a5a0cd0a$export$381da3590f80f043);

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $fbuqw = parcelRequire("fbuqw");

var $5v6ry = parcelRequire("5v6ry");

var $li5Nf = parcelRequire("li5Nf");

var $fGXjI = parcelRequire("fGXjI");
function $b87964e9a5a0cd0a$export$3d751018f73de3b6(options) {
    const nbFaces = 6;
    const faceUV = options.faceUV || new Array(6);
    const faceColors = options.faceColors;
    const flipTile = options.pattern || (0, $fbuqw.Mesh).NO_FLIP;
    const width = options.width || options.size || 1;
    const height = options.height || options.size || 1;
    const depth = options.depth || options.size || 1;
    const tileWidth = options.tileWidth || options.tileSize || 1;
    const tileHeight = options.tileHeight || options.tileSize || 1;
    const alignH = options.alignHorizontal || 0;
    const alignV = options.alignVertical || 0;
    const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || (0, $5v6ry.VertexData).DEFAULTSIDE;
    // default face colors and UV if undefined
    for(let f = 0; f < nbFaces; f++){
        if (faceUV[f] === undefined) faceUV[f] = new (0, $ha1VO.Vector4)(0, 0, 1, 1);
        if (faceColors && faceColors[f] === undefined) faceColors[f] = new (0, $7etnY.Color4)(1, 1, 1, 1);
    }
    const halfWidth = width / 2;
    const halfHeight = height / 2;
    const halfDepth = depth / 2;
    const faceVertexData = [];
    for(let f = 0; f < 2; f++)//front and back
    faceVertexData[f] = (0, $li5Nf.CreateTiledPlaneVertexData)({
        pattern: flipTile,
        tileWidth: tileWidth,
        tileHeight: tileHeight,
        width: width,
        height: height,
        alignVertical: alignV,
        alignHorizontal: alignH,
        sideOrientation: sideOrientation
    });
    for(let f = 2; f < 4; f++)//sides
    faceVertexData[f] = (0, $li5Nf.CreateTiledPlaneVertexData)({
        pattern: flipTile,
        tileWidth: tileWidth,
        tileHeight: tileHeight,
        width: depth,
        height: height,
        alignVertical: alignV,
        alignHorizontal: alignH,
        sideOrientation: sideOrientation
    });
    let baseAlignV = alignV;
    if (alignV === (0, $fbuqw.Mesh).BOTTOM) baseAlignV = (0, $fbuqw.Mesh).TOP;
    else if (alignV === (0, $fbuqw.Mesh).TOP) baseAlignV = (0, $fbuqw.Mesh).BOTTOM;
    for(let f = 4; f < 6; f++)//top and bottom
    faceVertexData[f] = (0, $li5Nf.CreateTiledPlaneVertexData)({
        pattern: flipTile,
        tileWidth: tileWidth,
        tileHeight: tileHeight,
        width: width,
        height: depth,
        alignVertical: baseAlignV,
        alignHorizontal: alignH,
        sideOrientation: sideOrientation
    });
    let positions = [];
    let normals = [];
    let uvs = [];
    let indices = [];
    const colors = [];
    const facePositions = [];
    const faceNormals = [];
    const newFaceUV = [];
    let lu = 0;
    let li = 0;
    for(let f = 0; f < nbFaces; f++){
        const len = faceVertexData[f].positions.length;
        facePositions[f] = [];
        faceNormals[f] = [];
        for(let p = 0; p < len / 3; p++){
            facePositions[f].push(new (0, $ha1VO.Vector3)(faceVertexData[f].positions[3 * p], faceVertexData[f].positions[3 * p + 1], faceVertexData[f].positions[3 * p + 2]));
            faceNormals[f].push(new (0, $ha1VO.Vector3)(faceVertexData[f].normals[3 * p], faceVertexData[f].normals[3 * p + 1], faceVertexData[f].normals[3 * p + 2]));
        }
        // uvs
        lu = faceVertexData[f].uvs.length;
        newFaceUV[f] = [];
        for(let i = 0; i < lu; i += 2){
            newFaceUV[f][i] = faceUV[f].x + (faceUV[f].z - faceUV[f].x) * faceVertexData[f].uvs[i];
            newFaceUV[f][i + 1] = faceUV[f].y + (faceUV[f].w - faceUV[f].y) * faceVertexData[f].uvs[i + 1];
            if ((0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV) newFaceUV[f][i + 1] = 1.0 - newFaceUV[f][i + 1];
        }
        uvs = uvs.concat(newFaceUV[f]);
        indices = indices.concat(faceVertexData[f].indices.map((x)=>x + li));
        li += facePositions[f].length;
        if (faceColors) for(let c = 0; c < 4; c++)colors.push(faceColors[f].r, faceColors[f].g, faceColors[f].b, faceColors[f].a);
    }
    const vec0 = new (0, $ha1VO.Vector3)(0, 0, halfDepth);
    const mtrx0 = (0, $ha1VO.Matrix).RotationY(Math.PI);
    positions = facePositions[0].map((entry)=>(0, $ha1VO.Vector3).TransformNormal(entry, mtrx0).add(vec0)).map((entry)=>[
            entry.x,
            entry.y,
            entry.z
        ]).reduce((accumulator, currentValue)=>accumulator.concat(currentValue), []);
    normals = faceNormals[0].map((entry)=>(0, $ha1VO.Vector3).TransformNormal(entry, mtrx0)).map((entry)=>[
            entry.x,
            entry.y,
            entry.z
        ]).reduce((accumulator, currentValue)=>accumulator.concat(currentValue), []);
    positions = positions.concat(facePositions[1].map((entry)=>entry.subtract(vec0)).map((entry)=>[
            entry.x,
            entry.y,
            entry.z
        ]).reduce((accumulator, currentValue)=>accumulator.concat(currentValue), []));
    normals = normals.concat(faceNormals[1].map((entry)=>[
            entry.x,
            entry.y,
            entry.z
        ]).reduce((accumulator, currentValue)=>accumulator.concat(currentValue), []));
    const vec2 = new (0, $ha1VO.Vector3)(halfWidth, 0, 0);
    const mtrx2 = (0, $ha1VO.Matrix).RotationY(-Math.PI / 2);
    positions = positions.concat(facePositions[2].map((entry)=>(0, $ha1VO.Vector3).TransformNormal(entry, mtrx2).add(vec2)).map((entry)=>[
            entry.x,
            entry.y,
            entry.z
        ]).reduce((accumulator, currentValue)=>accumulator.concat(currentValue), []));
    normals = normals.concat(faceNormals[2].map((entry)=>(0, $ha1VO.Vector3).TransformNormal(entry, mtrx2)).map((entry)=>[
            entry.x,
            entry.y,
            entry.z
        ]).reduce((accumulator, currentValue)=>accumulator.concat(currentValue), []));
    const mtrx3 = (0, $ha1VO.Matrix).RotationY(Math.PI / 2);
    positions = positions.concat(facePositions[3].map((entry)=>(0, $ha1VO.Vector3).TransformNormal(entry, mtrx3).subtract(vec2)).map((entry)=>[
            entry.x,
            entry.y,
            entry.z
        ]).reduce((accumulator, currentValue)=>accumulator.concat(currentValue), []));
    normals = normals.concat(faceNormals[3].map((entry)=>(0, $ha1VO.Vector3).TransformNormal(entry, mtrx3)).map((entry)=>[
            entry.x,
            entry.y,
            entry.z
        ]).reduce((accumulator, currentValue)=>accumulator.concat(currentValue), []));
    const vec4 = new (0, $ha1VO.Vector3)(0, halfHeight, 0);
    const mtrx4 = (0, $ha1VO.Matrix).RotationX(Math.PI / 2);
    positions = positions.concat(facePositions[4].map((entry)=>(0, $ha1VO.Vector3).TransformNormal(entry, mtrx4).add(vec4)).map((entry)=>[
            entry.x,
            entry.y,
            entry.z
        ]).reduce((accumulator, currentValue)=>accumulator.concat(currentValue), []));
    normals = normals.concat(faceNormals[4].map((entry)=>(0, $ha1VO.Vector3).TransformNormal(entry, mtrx4)).map((entry)=>[
            entry.x,
            entry.y,
            entry.z
        ]).reduce((accumulator, currentValue)=>accumulator.concat(currentValue), []));
    const mtrx5 = (0, $ha1VO.Matrix).RotationX(-Math.PI / 2);
    positions = positions.concat(facePositions[5].map((entry)=>(0, $ha1VO.Vector3).TransformNormal(entry, mtrx5).subtract(vec4)).map((entry)=>[
            entry.x,
            entry.y,
            entry.z
        ]).reduce((accumulator, currentValue)=>accumulator.concat(currentValue), []));
    normals = normals.concat(faceNormals[5].map((entry)=>(0, $ha1VO.Vector3).TransformNormal(entry, mtrx5)).map((entry)=>[
            entry.x,
            entry.y,
            entry.z
        ]).reduce((accumulator, currentValue)=>accumulator.concat(currentValue), []));
    // sides
    (0, $5v6ry.VertexData)._ComputeSides(sideOrientation, positions, indices, normals, uvs);
    // Result
    const vertexData = new (0, $5v6ry.VertexData)();
    vertexData.indices = indices;
    vertexData.positions = positions;
    vertexData.normals = normals;
    vertexData.uvs = uvs;
    if (faceColors) {
        const totalColors = sideOrientation === (0, $5v6ry.VertexData).DOUBLESIDE ? colors.concat(colors) : colors;
        vertexData.colors = totalColors;
    }
    return vertexData;
}
function $b87964e9a5a0cd0a$export$1fb6e45d350ad273(name, options, scene = null) {
    const box = new (0, $fbuqw.Mesh)(name, scene);
    options.sideOrientation = (0, $fbuqw.Mesh)._GetDefaultSideOrientation(options.sideOrientation);
    box._originalBuilderSideOrientation = options.sideOrientation;
    const vertexData = $b87964e9a5a0cd0a$export$3d751018f73de3b6(options);
    vertexData.applyToMesh(box, options.updatable);
    return box;
}
const $b87964e9a5a0cd0a$export$381da3590f80f043 = {
    CreateTiledBox: // eslint-disable-next-line @typescript-eslint/naming-convention
    $b87964e9a5a0cd0a$export$1fb6e45d350ad273
};
(0, $5v6ry.VertexData).CreateTiledBox = $b87964e9a5a0cd0a$export$3d751018f73de3b6;

});
parcelRegister("li5Nf", function(module, exports) {

$parcel$export(module.exports, "CreateTiledPlaneVertexData", () => $f7ffc5db927c078f$export$ecaceef85ee00d8e);
$parcel$export(module.exports, "CreateTiledPlane", () => $f7ffc5db927c078f$export$5d0c250509e3dc5f);
$parcel$export(module.exports, "TiledPlaneBuilder", () => $f7ffc5db927c078f$export$b40b2cde2e4016b);

var $fbuqw = parcelRequire("fbuqw");

var $5v6ry = parcelRequire("5v6ry");
function $f7ffc5db927c078f$export$ecaceef85ee00d8e(options) {
    const flipTile = options.pattern || (0, $fbuqw.Mesh).NO_FLIP;
    const tileWidth = options.tileWidth || options.tileSize || 1;
    const tileHeight = options.tileHeight || options.tileSize || 1;
    const alignH = options.alignHorizontal || 0;
    const alignV = options.alignVertical || 0;
    const width = options.width || options.size || 1;
    const tilesX = Math.floor(width / tileWidth);
    let offsetX = width - tilesX * tileWidth;
    const height = options.height || options.size || 1;
    const tilesY = Math.floor(height / tileHeight);
    let offsetY = height - tilesY * tileHeight;
    const halfWidth = tileWidth * tilesX / 2;
    const halfHeight = tileHeight * tilesY / 2;
    let adjustX = 0;
    let adjustY = 0;
    let startX = 0;
    let startY = 0;
    let endX = 0;
    let endY = 0;
    //Part Tiles
    if (offsetX > 0 || offsetY > 0) {
        startX = -halfWidth;
        startY = -halfHeight;
        endX = halfWidth;
        endY = halfHeight;
        switch(alignH){
            case (0, $fbuqw.Mesh).CENTER:
                offsetX /= 2;
                startX -= offsetX;
                endX += offsetX;
                break;
            case (0, $fbuqw.Mesh).LEFT:
                endX += offsetX;
                adjustX = -offsetX / 2;
                break;
            case (0, $fbuqw.Mesh).RIGHT:
                startX -= offsetX;
                adjustX = offsetX / 2;
                break;
        }
        switch(alignV){
            case (0, $fbuqw.Mesh).CENTER:
                offsetY /= 2;
                startY -= offsetY;
                endY += offsetY;
                break;
            case (0, $fbuqw.Mesh).BOTTOM:
                endY += offsetY;
                adjustY = -offsetY / 2;
                break;
            case (0, $fbuqw.Mesh).TOP:
                startY -= offsetY;
                adjustY = offsetY / 2;
                break;
        }
    }
    const positions = [];
    const normals = [];
    const uvBase = [];
    uvBase[0] = [
        0,
        0,
        1,
        0,
        1,
        1,
        0,
        1
    ];
    uvBase[1] = [
        0,
        0,
        1,
        0,
        1,
        1,
        0,
        1
    ];
    if (flipTile === (0, $fbuqw.Mesh).ROTATE_TILE || flipTile === (0, $fbuqw.Mesh).ROTATE_ROW) uvBase[1] = [
        1,
        1,
        0,
        1,
        0,
        0,
        1,
        0
    ];
    if (flipTile === (0, $fbuqw.Mesh).FLIP_TILE || flipTile === (0, $fbuqw.Mesh).FLIP_ROW) uvBase[1] = [
        1,
        0,
        0,
        0,
        0,
        1,
        1,
        1
    ];
    if (flipTile === (0, $fbuqw.Mesh).FLIP_N_ROTATE_TILE || flipTile === (0, $fbuqw.Mesh).FLIP_N_ROTATE_ROW) uvBase[1] = [
        0,
        1,
        1,
        1,
        1,
        0,
        0,
        0
    ];
    let uvs = [];
    const colors = [];
    const indices = [];
    let index = 0;
    for(let y = 0; y < tilesY; y++)for(let x = 0; x < tilesX; x++){
        positions.push(-halfWidth + x * tileWidth + adjustX, -halfHeight + y * tileHeight + adjustY, 0);
        positions.push(-halfWidth + (x + 1) * tileWidth + adjustX, -halfHeight + y * tileHeight + adjustY, 0);
        positions.push(-halfWidth + (x + 1) * tileWidth + adjustX, -halfHeight + (y + 1) * tileHeight + adjustY, 0);
        positions.push(-halfWidth + x * tileWidth + adjustX, -halfHeight + (y + 1) * tileHeight + adjustY, 0);
        indices.push(index, index + 1, index + 3, index + 1, index + 2, index + 3);
        if (flipTile === (0, $fbuqw.Mesh).FLIP_TILE || flipTile === (0, $fbuqw.Mesh).ROTATE_TILE || flipTile === (0, $fbuqw.Mesh).FLIP_N_ROTATE_TILE) uvs = uvs.concat(uvBase[(x % 2 + y % 2) % 2]);
        else if (flipTile === (0, $fbuqw.Mesh).FLIP_ROW || flipTile === (0, $fbuqw.Mesh).ROTATE_ROW || flipTile === (0, $fbuqw.Mesh).FLIP_N_ROTATE_ROW) uvs = uvs.concat(uvBase[y % 2]);
        else uvs = uvs.concat(uvBase[0]);
        colors.push(1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1);
        normals.push(0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1);
        index += 4;
    }
    //Part Tiles
    if (offsetX > 0 || offsetY > 0) {
        const partialBottomRow = offsetY > 0 && (alignV === (0, $fbuqw.Mesh).CENTER || alignV === (0, $fbuqw.Mesh).TOP);
        const partialTopRow = offsetY > 0 && (alignV === (0, $fbuqw.Mesh).CENTER || alignV === (0, $fbuqw.Mesh).BOTTOM);
        const partialLeftCol = offsetX > 0 && (alignH === (0, $fbuqw.Mesh).CENTER || alignH === (0, $fbuqw.Mesh).RIGHT);
        const partialRightCol = offsetX > 0 && (alignH === (0, $fbuqw.Mesh).CENTER || alignH === (0, $fbuqw.Mesh).LEFT);
        let uvPart = [];
        let a, b, c, d;
        //corners
        if (partialBottomRow && partialLeftCol) {
            //bottom left corner
            positions.push(startX + adjustX, startY + adjustY, 0);
            positions.push(-halfWidth + adjustX, startY + adjustY, 0);
            positions.push(-halfWidth + adjustX, startY + offsetY + adjustY, 0);
            positions.push(startX + adjustX, startY + offsetY + adjustY, 0);
            indices.push(index, index + 1, index + 3, index + 1, index + 2, index + 3);
            index += 4;
            a = 1 - offsetX / tileWidth;
            b = 1 - offsetY / tileHeight;
            c = 1;
            d = 1;
            uvPart = [
                a,
                b,
                c,
                b,
                c,
                d,
                a,
                d
            ];
            if (flipTile === (0, $fbuqw.Mesh).ROTATE_ROW) uvPart = [
                1 - a,
                1 - b,
                1 - c,
                1 - b,
                1 - c,
                1 - d,
                1 - a,
                1 - d
            ];
            if (flipTile === (0, $fbuqw.Mesh).FLIP_ROW) uvPart = [
                1 - a,
                b,
                1 - c,
                b,
                1 - c,
                d,
                1 - a,
                d
            ];
            if (flipTile === (0, $fbuqw.Mesh).FLIP_N_ROTATE_ROW) uvPart = [
                a,
                1 - b,
                c,
                1 - b,
                c,
                1 - d,
                a,
                1 - d
            ];
            uvs = uvs.concat(uvPart);
            colors.push(1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1);
            normals.push(0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1);
        }
        if (partialBottomRow && partialRightCol) {
            //bottom right corner
            positions.push(halfWidth + adjustX, startY + adjustY, 0);
            positions.push(endX + adjustX, startY + adjustY, 0);
            positions.push(endX + adjustX, startY + offsetY + adjustY, 0);
            positions.push(halfWidth + adjustX, startY + offsetY + adjustY, 0);
            indices.push(index, index + 1, index + 3, index + 1, index + 2, index + 3);
            index += 4;
            a = 0;
            b = 1 - offsetY / tileHeight;
            c = offsetX / tileWidth;
            d = 1;
            uvPart = [
                a,
                b,
                c,
                b,
                c,
                d,
                a,
                d
            ];
            if (flipTile === (0, $fbuqw.Mesh).ROTATE_ROW || flipTile === (0, $fbuqw.Mesh).ROTATE_TILE && tilesX % 2 === 0) uvPart = [
                1 - a,
                1 - b,
                1 - c,
                1 - b,
                1 - c,
                1 - d,
                1 - a,
                1 - d
            ];
            if (flipTile === (0, $fbuqw.Mesh).FLIP_ROW || flipTile === (0, $fbuqw.Mesh).FLIP_TILE && tilesX % 2 === 0) uvPart = [
                1 - a,
                b,
                1 - c,
                b,
                1 - c,
                d,
                1 - a,
                d
            ];
            if (flipTile === (0, $fbuqw.Mesh).FLIP_N_ROTATE_ROW || flipTile === (0, $fbuqw.Mesh).FLIP_N_ROTATE_TILE && tilesX % 2 === 0) uvPart = [
                a,
                1 - b,
                c,
                1 - b,
                c,
                1 - d,
                a,
                1 - d
            ];
            uvs = uvs.concat(uvPart);
            colors.push(1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1);
            normals.push(0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1);
        }
        if (partialTopRow && partialLeftCol) {
            //top left corner
            positions.push(startX + adjustX, halfHeight + adjustY, 0);
            positions.push(-halfWidth + adjustX, halfHeight + adjustY, 0);
            positions.push(-halfWidth + adjustX, endY + adjustY, 0);
            positions.push(startX + adjustX, endY + adjustY, 0);
            indices.push(index, index + 1, index + 3, index + 1, index + 2, index + 3);
            index += 4;
            a = 1 - offsetX / tileWidth;
            b = 0;
            c = 1;
            d = offsetY / tileHeight;
            uvPart = [
                a,
                b,
                c,
                b,
                c,
                d,
                a,
                d
            ];
            if (flipTile === (0, $fbuqw.Mesh).ROTATE_ROW && tilesY % 2 === 1 || flipTile === (0, $fbuqw.Mesh).ROTATE_TILE && tilesY % 1 === 0) uvPart = [
                1 - a,
                1 - b,
                1 - c,
                1 - b,
                1 - c,
                1 - d,
                1 - a,
                1 - d
            ];
            if (flipTile === (0, $fbuqw.Mesh).FLIP_ROW && tilesY % 2 === 1 || flipTile === (0, $fbuqw.Mesh).FLIP_TILE && tilesY % 2 === 0) uvPart = [
                1 - a,
                b,
                1 - c,
                b,
                1 - c,
                d,
                1 - a,
                d
            ];
            if (flipTile === (0, $fbuqw.Mesh).FLIP_N_ROTATE_ROW && tilesY % 2 === 1 || flipTile === (0, $fbuqw.Mesh).FLIP_N_ROTATE_TILE && tilesY % 2 === 0) uvPart = [
                a,
                1 - b,
                c,
                1 - b,
                c,
                1 - d,
                a,
                1 - d
            ];
            uvs = uvs.concat(uvPart);
            colors.push(1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1);
            normals.push(0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1);
        }
        if (partialTopRow && partialRightCol) {
            //top right corner
            positions.push(halfWidth + adjustX, halfHeight + adjustY, 0);
            positions.push(endX + adjustX, halfHeight + adjustY, 0);
            positions.push(endX + adjustX, endY + adjustY, 0);
            positions.push(halfWidth + adjustX, endY + adjustY, 0);
            indices.push(index, index + 1, index + 3, index + 1, index + 2, index + 3);
            index += 4;
            a = 0;
            b = 0;
            c = offsetX / tileWidth;
            d = offsetY / tileHeight;
            uvPart = [
                a,
                b,
                c,
                b,
                c,
                d,
                a,
                d
            ];
            if (flipTile === (0, $fbuqw.Mesh).ROTATE_ROW && tilesY % 2 === 1 || flipTile === (0, $fbuqw.Mesh).ROTATE_TILE && (tilesY + tilesX) % 2 === 1) uvPart = [
                1 - a,
                1 - b,
                1 - c,
                1 - b,
                1 - c,
                1 - d,
                1 - a,
                1 - d
            ];
            if (flipTile === (0, $fbuqw.Mesh).FLIP_ROW && tilesY % 2 === 1 || flipTile === (0, $fbuqw.Mesh).FLIP_TILE && (tilesY + tilesX) % 2 === 1) uvPart = [
                1 - a,
                b,
                1 - c,
                b,
                1 - c,
                d,
                1 - a,
                d
            ];
            if (flipTile === (0, $fbuqw.Mesh).FLIP_N_ROTATE_ROW && tilesY % 2 === 1 || flipTile === (0, $fbuqw.Mesh).FLIP_N_ROTATE_TILE && (tilesY + tilesX) % 2 === 1) uvPart = [
                a,
                1 - b,
                c,
                1 - b,
                c,
                1 - d,
                a,
                1 - d
            ];
            uvs = uvs.concat(uvPart);
            colors.push(1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1);
            normals.push(0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1);
        }
        //part rows
        if (partialBottomRow) {
            const uvBaseBR = [];
            a = 0;
            b = 1 - offsetY / tileHeight;
            c = 1;
            d = 1;
            uvBaseBR[0] = [
                a,
                b,
                c,
                b,
                c,
                d,
                a,
                d
            ];
            uvBaseBR[1] = [
                a,
                b,
                c,
                b,
                c,
                d,
                a,
                d
            ];
            if (flipTile === (0, $fbuqw.Mesh).ROTATE_TILE || flipTile === (0, $fbuqw.Mesh).ROTATE_ROW) uvBaseBR[1] = [
                1 - a,
                1 - b,
                1 - c,
                1 - b,
                1 - c,
                1 - d,
                1 - a,
                1 - d
            ];
            if (flipTile === (0, $fbuqw.Mesh).FLIP_TILE || flipTile === (0, $fbuqw.Mesh).FLIP_ROW) uvBaseBR[1] = [
                1 - a,
                b,
                1 - c,
                b,
                1 - c,
                d,
                1 - a,
                d
            ];
            if (flipTile === (0, $fbuqw.Mesh).FLIP_N_ROTATE_TILE || flipTile === (0, $fbuqw.Mesh).FLIP_N_ROTATE_ROW) uvBaseBR[1] = [
                a,
                1 - b,
                c,
                1 - b,
                c,
                1 - d,
                a,
                1 - d
            ];
            for(let x = 0; x < tilesX; x++){
                positions.push(-halfWidth + x * tileWidth + adjustX, startY + adjustY, 0);
                positions.push(-halfWidth + (x + 1) * tileWidth + adjustX, startY + adjustY, 0);
                positions.push(-halfWidth + (x + 1) * tileWidth + adjustX, startY + offsetY + adjustY, 0);
                positions.push(-halfWidth + x * tileWidth + adjustX, startY + offsetY + adjustY, 0);
                indices.push(index, index + 1, index + 3, index + 1, index + 2, index + 3);
                index += 4;
                if (flipTile === (0, $fbuqw.Mesh).FLIP_TILE || flipTile === (0, $fbuqw.Mesh).ROTATE_TILE || flipTile === (0, $fbuqw.Mesh).FLIP_N_ROTATE_TILE) uvs = uvs.concat(uvBaseBR[(x + 1) % 2]);
                else if (flipTile === (0, $fbuqw.Mesh).FLIP_ROW || flipTile === (0, $fbuqw.Mesh).ROTATE_ROW || flipTile === (0, $fbuqw.Mesh).FLIP_N_ROTATE_ROW) uvs = uvs.concat(uvBaseBR[1]);
                else uvs = uvs.concat(uvBaseBR[0]);
                colors.push(1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1);
                normals.push(0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1);
            }
        }
        if (partialTopRow) {
            const uvBaseTR = [];
            a = 0;
            b = 0;
            c = 1;
            d = offsetY / tileHeight;
            uvBaseTR[0] = [
                a,
                b,
                c,
                b,
                c,
                d,
                a,
                d
            ];
            uvBaseTR[1] = [
                a,
                b,
                c,
                b,
                c,
                d,
                a,
                d
            ];
            if (flipTile === (0, $fbuqw.Mesh).ROTATE_TILE || flipTile === (0, $fbuqw.Mesh).ROTATE_ROW) uvBaseTR[1] = [
                1 - a,
                1 - b,
                1 - c,
                1 - b,
                1 - c,
                1 - d,
                1 - a,
                1 - d
            ];
            if (flipTile === (0, $fbuqw.Mesh).FLIP_TILE || flipTile === (0, $fbuqw.Mesh).FLIP_ROW) uvBaseTR[1] = [
                1 - a,
                b,
                1 - c,
                b,
                1 - c,
                d,
                1 - a,
                d
            ];
            if (flipTile === (0, $fbuqw.Mesh).FLIP_N_ROTATE_TILE || flipTile === (0, $fbuqw.Mesh).FLIP_N_ROTATE_ROW) uvBaseTR[1] = [
                a,
                1 - b,
                c,
                1 - b,
                c,
                1 - d,
                a,
                1 - d
            ];
            for(let x = 0; x < tilesX; x++){
                positions.push(-halfWidth + x * tileWidth + adjustX, endY - offsetY + adjustY, 0);
                positions.push(-halfWidth + (x + 1) * tileWidth + adjustX, endY - offsetY + adjustY, 0);
                positions.push(-halfWidth + (x + 1) * tileWidth + adjustX, endY + adjustY, 0);
                positions.push(-halfWidth + x * tileWidth + adjustX, endY + adjustY, 0);
                indices.push(index, index + 1, index + 3, index + 1, index + 2, index + 3);
                index += 4;
                if (flipTile === (0, $fbuqw.Mesh).FLIP_TILE || flipTile === (0, $fbuqw.Mesh).ROTATE_TILE || flipTile === (0, $fbuqw.Mesh).FLIP_N_ROTATE_TILE) uvs = uvs.concat(uvBaseTR[(x + tilesY) % 2]);
                else if (flipTile === (0, $fbuqw.Mesh).FLIP_ROW || flipTile === (0, $fbuqw.Mesh).ROTATE_ROW || flipTile === (0, $fbuqw.Mesh).FLIP_N_ROTATE_ROW) uvs = uvs.concat(uvBaseTR[tilesY % 2]);
                else uvs = uvs.concat(uvBaseTR[0]);
                colors.push(1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1);
                normals.push(0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1);
            }
        }
        if (partialLeftCol) {
            const uvBaseLC = [];
            a = 1 - offsetX / tileWidth;
            b = 0;
            c = 1;
            d = 1;
            uvBaseLC[0] = [
                a,
                b,
                c,
                b,
                c,
                d,
                a,
                d
            ];
            uvBaseLC[1] = [
                a,
                b,
                c,
                b,
                c,
                d,
                a,
                d
            ];
            if (flipTile === (0, $fbuqw.Mesh).ROTATE_TILE || flipTile === (0, $fbuqw.Mesh).ROTATE_ROW) uvBaseLC[1] = [
                1 - a,
                1 - b,
                1 - c,
                1 - b,
                1 - c,
                1 - d,
                1 - a,
                1 - d
            ];
            if (flipTile === (0, $fbuqw.Mesh).FLIP_TILE || flipTile === (0, $fbuqw.Mesh).FLIP_ROW) uvBaseLC[1] = [
                1 - a,
                b,
                1 - c,
                b,
                1 - c,
                d,
                1 - a,
                d
            ];
            if (flipTile === (0, $fbuqw.Mesh).FLIP_N_ROTATE_TILE || flipTile === (0, $fbuqw.Mesh).FLIP_N_ROTATE_ROW) uvBaseLC[1] = [
                a,
                1 - b,
                c,
                1 - b,
                c,
                1 - d,
                a,
                1 - d
            ];
            for(let y = 0; y < tilesY; y++){
                positions.push(startX + adjustX, -halfHeight + y * tileHeight + adjustY, 0);
                positions.push(startX + offsetX + adjustX, -halfHeight + y * tileHeight + adjustY, 0);
                positions.push(startX + offsetX + adjustX, -halfHeight + (y + 1) * tileHeight + adjustY, 0);
                positions.push(startX + adjustX, -halfHeight + (y + 1) * tileHeight + adjustY, 0);
                indices.push(index, index + 1, index + 3, index + 1, index + 2, index + 3);
                index += 4;
                if (flipTile === (0, $fbuqw.Mesh).FLIP_TILE || flipTile === (0, $fbuqw.Mesh).ROTATE_TILE || flipTile === (0, $fbuqw.Mesh).FLIP_N_ROTATE_TILE) uvs = uvs.concat(uvBaseLC[(y + 1) % 2]);
                else if (flipTile === (0, $fbuqw.Mesh).FLIP_ROW || flipTile === (0, $fbuqw.Mesh).ROTATE_ROW || flipTile === (0, $fbuqw.Mesh).FLIP_N_ROTATE_ROW) uvs = uvs.concat(uvBaseLC[y % 2]);
                else uvs = uvs.concat(uvBaseLC[0]);
                colors.push(1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1);
                normals.push(0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1);
            }
        }
        if (partialRightCol) {
            const uvBaseRC = [];
            a = 0;
            b = 0;
            c = offsetX / tileHeight;
            d = 1;
            uvBaseRC[0] = [
                a,
                b,
                c,
                b,
                c,
                d,
                a,
                d
            ];
            uvBaseRC[1] = [
                a,
                b,
                c,
                b,
                c,
                d,
                a,
                d
            ];
            if (flipTile === (0, $fbuqw.Mesh).ROTATE_TILE || flipTile === (0, $fbuqw.Mesh).ROTATE_ROW) uvBaseRC[1] = [
                1 - a,
                1 - b,
                1 - c,
                1 - b,
                1 - c,
                1 - d,
                1 - a,
                1 - d
            ];
            if (flipTile === (0, $fbuqw.Mesh).FLIP_TILE || flipTile === (0, $fbuqw.Mesh).FLIP_ROW) uvBaseRC[1] = [
                1 - a,
                b,
                1 - c,
                b,
                1 - c,
                d,
                1 - a,
                d
            ];
            if (flipTile === (0, $fbuqw.Mesh).FLIP_N_ROTATE_TILE || flipTile === (0, $fbuqw.Mesh).FLIP_N_ROTATE_ROW) uvBaseRC[1] = [
                a,
                1 - b,
                c,
                1 - b,
                c,
                1 - d,
                a,
                1 - d
            ];
            for(let y = 0; y < tilesY; y++){
                positions.push(endX - offsetX + adjustX, -halfHeight + y * tileHeight + adjustY, 0);
                positions.push(endX + adjustX, -halfHeight + y * tileHeight + adjustY, 0);
                positions.push(endX + adjustX, -halfHeight + (y + 1) * tileHeight + adjustY, 0);
                positions.push(endX - offsetX + adjustX, -halfHeight + (y + 1) * tileHeight + adjustY, 0);
                indices.push(index, index + 1, index + 3, index + 1, index + 2, index + 3);
                index += 4;
                if (flipTile === (0, $fbuqw.Mesh).FLIP_TILE || flipTile === (0, $fbuqw.Mesh).ROTATE_TILE || flipTile === (0, $fbuqw.Mesh).FLIP_N_ROTATE_TILE) uvs = uvs.concat(uvBaseRC[(y + tilesX) % 2]);
                else if (flipTile === (0, $fbuqw.Mesh).FLIP_ROW || flipTile === (0, $fbuqw.Mesh).ROTATE_ROW || flipTile === (0, $fbuqw.Mesh).FLIP_N_ROTATE_ROW) uvs = uvs.concat(uvBaseRC[y % 2]);
                else uvs = uvs.concat(uvBaseRC[0]);
                colors.push(1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1);
                normals.push(0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1);
            }
        }
    }
    const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || (0, $5v6ry.VertexData).DEFAULTSIDE;
    // sides
    (0, $5v6ry.VertexData)._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
    // Result
    const vertexData = new (0, $5v6ry.VertexData)();
    vertexData.indices = indices;
    vertexData.positions = positions;
    vertexData.normals = normals;
    vertexData.uvs = uvs;
    const totalColors = sideOrientation === (0, $5v6ry.VertexData).DOUBLESIDE ? colors.concat(colors) : colors;
    vertexData.colors = totalColors;
    return vertexData;
}
function $f7ffc5db927c078f$export$5d0c250509e3dc5f(name, options, scene = null) {
    const plane = new (0, $fbuqw.Mesh)(name, scene);
    options.sideOrientation = (0, $fbuqw.Mesh)._GetDefaultSideOrientation(options.sideOrientation);
    plane._originalBuilderSideOrientation = options.sideOrientation;
    const vertexData = $f7ffc5db927c078f$export$ecaceef85ee00d8e(options);
    vertexData.applyToMesh(plane, options.updatable);
    return plane;
}
const $f7ffc5db927c078f$export$b40b2cde2e4016b = {
    CreateTiledPlane: // eslint-disable-next-line @typescript-eslint/naming-convention
    $f7ffc5db927c078f$export$5d0c250509e3dc5f
};
(0, $5v6ry.VertexData).CreateTiledPlane = $f7ffc5db927c078f$export$ecaceef85ee00d8e;

});


parcelRegister("geytg", function(module, exports) {

$parcel$export(module.exports, "CreateTorusKnotVertexData", () => $bd18b164246d46e4$export$8b2c43e1ab8fcb89);
$parcel$export(module.exports, "CreateTorusKnot", () => $bd18b164246d46e4$export$15125c50b1408b05);
$parcel$export(module.exports, "TorusKnotBuilder", () => $bd18b164246d46e4$export$36acfe2c554e8f81);

var $ha1VO = parcelRequire("ha1VO");

var $fbuqw = parcelRequire("fbuqw");

var $5v6ry = parcelRequire("5v6ry");

var $fGXjI = parcelRequire("fGXjI");
function $bd18b164246d46e4$export$8b2c43e1ab8fcb89(options) {
    const indices = [];
    const positions = [];
    const normals = [];
    const uvs = [];
    const radius = options.radius || 2;
    const tube = options.tube || 0.5;
    const radialSegments = options.radialSegments || 32;
    const tubularSegments = options.tubularSegments || 32;
    const p = options.p || 2;
    const q = options.q || 3;
    const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || (0, $5v6ry.VertexData).DEFAULTSIDE;
    // Helper
    const getPos = (angle)=>{
        const cu = Math.cos(angle);
        const su = Math.sin(angle);
        const quOverP = q / p * angle;
        const cs = Math.cos(quOverP);
        const tx = radius * (2 + cs) * 0.5 * cu;
        const ty = radius * (2 + cs) * su * 0.5;
        const tz = radius * Math.sin(quOverP) * 0.5;
        return new (0, $ha1VO.Vector3)(tx, ty, tz);
    };
    // Vertices
    let i;
    let j;
    for(i = 0; i <= radialSegments; i++){
        const modI = i % radialSegments;
        const u = modI / radialSegments * 2 * p * Math.PI;
        const p1 = getPos(u);
        const p2 = getPos(u + 0.01);
        const tang = p2.subtract(p1);
        let n = p2.add(p1);
        const bitan = (0, $ha1VO.Vector3).Cross(tang, n);
        n = (0, $ha1VO.Vector3).Cross(bitan, tang);
        bitan.normalize();
        n.normalize();
        for(j = 0; j < tubularSegments; j++){
            const modJ = j % tubularSegments;
            const v = modJ / tubularSegments * 2 * Math.PI;
            const cx = -tube * Math.cos(v);
            const cy = tube * Math.sin(v);
            positions.push(p1.x + cx * n.x + cy * bitan.x);
            positions.push(p1.y + cx * n.y + cy * bitan.y);
            positions.push(p1.z + cx * n.z + cy * bitan.z);
            uvs.push(i / radialSegments);
            uvs.push((0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? 1.0 - j / tubularSegments : j / tubularSegments);
        }
    }
    for(i = 0; i < radialSegments; i++)for(j = 0; j < tubularSegments; j++){
        const jNext = (j + 1) % tubularSegments;
        const a = i * tubularSegments + j;
        const b = (i + 1) * tubularSegments + j;
        const c = (i + 1) * tubularSegments + jNext;
        const d = i * tubularSegments + jNext;
        indices.push(d);
        indices.push(b);
        indices.push(a);
        indices.push(d);
        indices.push(c);
        indices.push(b);
    }
    // Normals
    (0, $5v6ry.VertexData).ComputeNormals(positions, indices, normals);
    // Sides
    (0, $5v6ry.VertexData)._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
    // Result
    const vertexData = new (0, $5v6ry.VertexData)();
    vertexData.indices = indices;
    vertexData.positions = positions;
    vertexData.normals = normals;
    vertexData.uvs = uvs;
    return vertexData;
}
function $bd18b164246d46e4$export$15125c50b1408b05(name, options = {}, scene) {
    const torusKnot = new (0, $fbuqw.Mesh)(name, scene);
    options.sideOrientation = (0, $fbuqw.Mesh)._GetDefaultSideOrientation(options.sideOrientation);
    torusKnot._originalBuilderSideOrientation = options.sideOrientation;
    const vertexData = $bd18b164246d46e4$export$8b2c43e1ab8fcb89(options);
    vertexData.applyToMesh(torusKnot, options.updatable);
    return torusKnot;
}
const $bd18b164246d46e4$export$36acfe2c554e8f81 = {
    CreateTorusKnot: // eslint-disable-next-line @typescript-eslint/naming-convention
    $bd18b164246d46e4$export$15125c50b1408b05
};
(0, $5v6ry.VertexData).CreateTorusKnot = $bd18b164246d46e4$export$8b2c43e1ab8fcb89;
(0, $fbuqw.Mesh).CreateTorusKnot = (name, radius, tube, radialSegments, tubularSegments, p, q, scene, updatable, sideOrientation)=>{
    const options = {
        radius: radius,
        tube: tube,
        radialSegments: radialSegments,
        tubularSegments: tubularSegments,
        p: p,
        q: q,
        sideOrientation: sideOrientation,
        updatable: updatable
    };
    return $bd18b164246d46e4$export$15125c50b1408b05(name, options, scene);
};

});

parcelRegister("8Eyol", function(module, exports) {

$parcel$export(module.exports, "CreateLineSystemVertexData", () => $64ccbca0cbde8de7$export$a5883ab4872ed73d);
$parcel$export(module.exports, "CreateDashedLinesVertexData", () => $64ccbca0cbde8de7$export$258b4b1be50025);
$parcel$export(module.exports, "CreateLineSystem", () => $64ccbca0cbde8de7$export$d2e386952db4e290);
$parcel$export(module.exports, "CreateLines", () => $64ccbca0cbde8de7$export$5c8430a92ff1a8d2);
$parcel$export(module.exports, "CreateDashedLines", () => $64ccbca0cbde8de7$export$1a25fda3f613818a);
$parcel$export(module.exports, "LinesBuilder", () => $64ccbca0cbde8de7$export$9cd2aadbd9dffed);
/* eslint-disable @typescript-eslint/naming-convention */ 
var $ha1VO = parcelRequire("ha1VO");

var $fbuqw = parcelRequire("fbuqw");

var $5v6ry = parcelRequire("5v6ry");

var $abjAz = parcelRequire("abjAz");

var $b4i1f = parcelRequire("b4i1f");

var $kVtWi = parcelRequire("kVtWi");
function $64ccbca0cbde8de7$export$a5883ab4872ed73d(options) {
    const indices = [];
    const positions = [];
    const lines = options.lines;
    const colors = options.colors;
    const vertexColors = [];
    let idx = 0;
    for(let l = 0; l < lines.length; l++){
        const points = lines[l];
        for(let index = 0; index < points.length; index++){
            const { x: x, y: y, z: z } = points[index];
            positions.push(x, y, z);
            if (colors) {
                const color = colors[l];
                const { r: r, g: g, b: b, a: a } = color[index];
                vertexColors.push(r, g, b, a);
            }
            if (index > 0) {
                indices.push(idx - 1);
                indices.push(idx);
            }
            idx++;
        }
    }
    const vertexData = new (0, $5v6ry.VertexData)();
    vertexData.indices = indices;
    vertexData.positions = positions;
    if (colors) vertexData.colors = vertexColors;
    return vertexData;
}
function $64ccbca0cbde8de7$export$258b4b1be50025(options) {
    const dashSize = options.dashSize || 3;
    const gapSize = options.gapSize || 1;
    const dashNb = options.dashNb || 200;
    const points = options.points;
    const positions = [];
    const indices = [];
    const curvect = (0, $ha1VO.Vector3).Zero();
    let lg = 0;
    let nb = 0;
    let shft = 0;
    let dashshft = 0;
    let curshft = 0;
    let idx = 0;
    let i = 0;
    for(i = 0; i < points.length - 1; i++){
        points[i + 1].subtractToRef(points[i], curvect);
        lg += curvect.length();
    }
    shft = lg / dashNb;
    dashshft = dashSize * shft / (dashSize + gapSize);
    for(i = 0; i < points.length - 1; i++){
        points[i + 1].subtractToRef(points[i], curvect);
        nb = Math.floor(curvect.length() / shft);
        curvect.normalize();
        for(let j = 0; j < nb; j++){
            curshft = shft * j;
            positions.push(points[i].x + curshft * curvect.x, points[i].y + curshft * curvect.y, points[i].z + curshft * curvect.z);
            positions.push(points[i].x + (curshft + dashshft) * curvect.x, points[i].y + (curshft + dashshft) * curvect.y, points[i].z + (curshft + dashshft) * curvect.z);
            indices.push(idx, idx + 1);
            idx += 2;
        }
    }
    // Result
    const vertexData = new (0, $5v6ry.VertexData)();
    vertexData.positions = positions;
    vertexData.indices = indices;
    return vertexData;
}
function $64ccbca0cbde8de7$export$d2e386952db4e290(name, options, scene = null) {
    const instance = options.instance;
    const lines = options.lines;
    const colors = options.colors;
    if (instance) {
        // lines update
        const positions = instance.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        let vertexColor;
        let lineColors;
        if (colors) vertexColor = instance.getVerticesData((0, $b4i1f.VertexBuffer).ColorKind);
        let i = 0;
        let c = 0;
        for(let l = 0; l < lines.length; l++){
            const points = lines[l];
            for(let p = 0; p < points.length; p++){
                positions[i] = points[p].x;
                positions[i + 1] = points[p].y;
                positions[i + 2] = points[p].z;
                if (colors && vertexColor) {
                    lineColors = colors[l];
                    vertexColor[c] = lineColors[p].r;
                    vertexColor[c + 1] = lineColors[p].g;
                    vertexColor[c + 2] = lineColors[p].b;
                    vertexColor[c + 3] = lineColors[p].a;
                    c += 4;
                }
                i += 3;
            }
        }
        instance.updateVerticesData((0, $b4i1f.VertexBuffer).PositionKind, positions, false, false);
        if (colors && vertexColor) instance.updateVerticesData((0, $b4i1f.VertexBuffer).ColorKind, vertexColor, false, false);
        return instance;
    }
    // line system creation
    const useVertexColor = colors ? true : false;
    const lineSystem = new (0, $abjAz.LinesMesh)(name, scene, null, undefined, undefined, useVertexColor, options.useVertexAlpha, options.material);
    const vertexData = $64ccbca0cbde8de7$export$a5883ab4872ed73d(options);
    vertexData.applyToMesh(lineSystem, options.updatable);
    return lineSystem;
}
function $64ccbca0cbde8de7$export$5c8430a92ff1a8d2(name, options, scene = null) {
    const colors = options.colors ? [
        options.colors
    ] : null;
    const lines = $64ccbca0cbde8de7$export$d2e386952db4e290(name, {
        lines: [
            options.points
        ],
        updatable: options.updatable,
        instance: options.instance,
        colors: colors,
        useVertexAlpha: options.useVertexAlpha,
        material: options.material
    }, scene);
    return lines;
}
function $64ccbca0cbde8de7$export$1a25fda3f613818a(name, options, scene = null) {
    const points = options.points;
    const instance = options.instance;
    const gapSize = options.gapSize || 1;
    const dashSize = options.dashSize || 3;
    if (instance) {
        //  dashed lines update
        const positionFunction = (positions)=>{
            const curvect = (0, $ha1VO.Vector3).Zero();
            const nbSeg = positions.length / 6;
            let lg = 0;
            let nb = 0;
            let shft = 0;
            let dashshft = 0;
            let curshft = 0;
            let p = 0;
            let i = 0;
            let j = 0;
            for(i = 0; i < points.length - 1; i++){
                points[i + 1].subtractToRef(points[i], curvect);
                lg += curvect.length();
            }
            shft = lg / nbSeg;
            const dashSize = instance._creationDataStorage.dashSize;
            const gapSize = instance._creationDataStorage.gapSize;
            dashshft = dashSize * shft / (dashSize + gapSize);
            for(i = 0; i < points.length - 1; i++){
                points[i + 1].subtractToRef(points[i], curvect);
                nb = Math.floor(curvect.length() / shft);
                curvect.normalize();
                j = 0;
                while(j < nb && p < positions.length){
                    curshft = shft * j;
                    positions[p] = points[i].x + curshft * curvect.x;
                    positions[p + 1] = points[i].y + curshft * curvect.y;
                    positions[p + 2] = points[i].z + curshft * curvect.z;
                    positions[p + 3] = points[i].x + (curshft + dashshft) * curvect.x;
                    positions[p + 4] = points[i].y + (curshft + dashshft) * curvect.y;
                    positions[p + 5] = points[i].z + (curshft + dashshft) * curvect.z;
                    p += 6;
                    j++;
                }
            }
            while(p < positions.length){
                positions[p] = points[i].x;
                positions[p + 1] = points[i].y;
                positions[p + 2] = points[i].z;
                p += 3;
            }
        };
        if (options.dashNb || options.dashSize || options.gapSize || options.useVertexAlpha || options.material) (0, $kVtWi.Logger).Warn("You have used an option other than points with the instance option. Please be aware that these other options will be ignored.");
        instance.updateMeshPositions(positionFunction, false);
        return instance;
    }
    // dashed lines creation
    const dashedLines = new (0, $abjAz.LinesMesh)(name, scene, null, undefined, undefined, undefined, options.useVertexAlpha, options.material);
    const vertexData = $64ccbca0cbde8de7$export$258b4b1be50025(options);
    vertexData.applyToMesh(dashedLines, options.updatable);
    dashedLines._creationDataStorage = new (0, $fbuqw._CreationDataStorage)();
    dashedLines._creationDataStorage.dashSize = dashSize;
    dashedLines._creationDataStorage.gapSize = gapSize;
    return dashedLines;
}
const $64ccbca0cbde8de7$export$9cd2aadbd9dffed = {
    CreateDashedLines: $64ccbca0cbde8de7$export$1a25fda3f613818a,
    CreateLineSystem: $64ccbca0cbde8de7$export$d2e386952db4e290,
    CreateLines: $64ccbca0cbde8de7$export$5c8430a92ff1a8d2
};
(0, $5v6ry.VertexData).CreateLineSystem = $64ccbca0cbde8de7$export$a5883ab4872ed73d;
(0, $5v6ry.VertexData).CreateDashedLines = $64ccbca0cbde8de7$export$258b4b1be50025;
(0, $fbuqw.Mesh).CreateLines = (name, points, scene = null, updatable = false, instance = null)=>{
    const options = {
        points: points,
        updatable: updatable,
        instance: instance
    };
    return $64ccbca0cbde8de7$export$5c8430a92ff1a8d2(name, options, scene);
};
(0, $fbuqw.Mesh).CreateDashedLines = (name, points, dashSize, gapSize, dashNb, scene = null, updatable, instance)=>{
    const options = {
        points: points,
        dashSize: dashSize,
        gapSize: gapSize,
        dashNb: dashNb,
        updatable: updatable,
        instance: instance
    };
    return $64ccbca0cbde8de7$export$1a25fda3f613818a(name, options, scene);
};

});
parcelRegister("abjAz", function(module, exports) {

$parcel$export(module.exports, "LinesMesh", () => $769a2062ec6bae3f$export$9955070e3d6299);
$parcel$export(module.exports, "InstancedLinesMesh", () => $769a2062ec6bae3f$export$59ce9705b5ce8121);

var $7etnY = parcelRequire("7etnY");

var $b4i1f = parcelRequire("b4i1f");

var $fbuqw = parcelRequire("fbuqw");

var $9Xybp = parcelRequire("9Xybp");

var $54229 = parcelRequire("54229");

var $4I7rl = parcelRequire("4I7rl");
parcelRequire("kqZxW");
parcelRequire("7Z1KU");
(0, $fbuqw.Mesh)._LinesMeshParser = (parsedMesh, scene)=>{
    return $769a2062ec6bae3f$export$9955070e3d6299.Parse(parsedMesh, scene);
};
class $769a2062ec6bae3f$export$9955070e3d6299 extends (0, $fbuqw.Mesh) {
    _isShaderMaterial(shader) {
        return shader.getClassName() === "ShaderMaterial";
    }
    /**
     * Creates a new LinesMesh
     * @param name defines the name
     * @param scene defines the hosting scene
     * @param parent defines the parent mesh if any
     * @param source defines the optional source LinesMesh used to clone data from
     * @param doNotCloneChildren When cloning, skip cloning child meshes of source, default False.
     * When false, achieved by calling a clone(), also passing False.
     * This will make creation of children, recursive.
     * @param useVertexColor defines if this LinesMesh supports vertex color
     * @param useVertexAlpha defines if this LinesMesh supports vertex alpha
     * @param material material to use to draw the line. If not provided, will create a new one
     */ constructor(name, scene = null, parent = null, source = null, doNotCloneChildren, /**
     * If vertex color should be applied to the mesh
     */ useVertexColor, /**
     * If vertex alpha should be applied to the mesh
     */ useVertexAlpha, material){
        super(name, scene, parent, source, doNotCloneChildren);
        this.useVertexColor = useVertexColor;
        this.useVertexAlpha = useVertexAlpha;
        /**
         * Color of the line (Default: White)
         */ this.color = new (0, $7etnY.Color3)(1, 1, 1);
        /**
         * Alpha of the line (Default: 1)
         */ this.alpha = 1;
        if (source) {
            this.color = source.color.clone();
            this.alpha = source.alpha;
            this.useVertexColor = source.useVertexColor;
            this.useVertexAlpha = source.useVertexAlpha;
        }
        this.intersectionThreshold = 0.1;
        const defines = [];
        const options = {
            attributes: [
                (0, $b4i1f.VertexBuffer).PositionKind
            ],
            uniforms: [
                "world",
                "viewProjection"
            ],
            needAlphaBlending: true,
            defines: defines,
            useClipPlane: null
        };
        if (useVertexAlpha === false) options.needAlphaBlending = false;
        else options.defines.push("#define VERTEXALPHA");
        if (!useVertexColor) {
            options.uniforms.push("color");
            this._color4 = new (0, $7etnY.Color4)();
        } else {
            options.defines.push("#define VERTEXCOLOR");
            options.attributes.push((0, $b4i1f.VertexBuffer).ColorKind);
        }
        if (material) this.material = material;
        else {
            this.material = new (0, $4I7rl.ShaderMaterial)("colorShader", this.getScene(), "color", options, false);
            this.material.doNotSerialize = true;
        }
    }
    isReady() {
        if (!this._lineMaterial.isReady(this, !!this._userInstancedBuffersStorage || this.hasThinInstances)) return false;
        return super.isReady();
    }
    /**
     * @returns the string "LineMesh"
     */ getClassName() {
        return "LinesMesh";
    }
    /**
     * @internal
     */ get material() {
        return this._lineMaterial;
    }
    /**
     * @internal
     */ set material(value) {
        this._lineMaterial = value;
        this._lineMaterial.fillMode = (0, $54229.Material).LineListDrawMode;
    }
    /**
     * @internal
     */ get checkCollisions() {
        return false;
    }
    set checkCollisions(value) {
    // Just ignore it
    }
    /**
     * @internal
     */ _bind(_subMesh, colorEffect) {
        if (!this._geometry) return this;
        // VBOs
        const indexToBind = this.isUnIndexed ? null : this._geometry.getIndexBuffer();
        if (!this._userInstancedBuffersStorage || this.hasThinInstances) this._geometry._bind(colorEffect, indexToBind);
        else this._geometry._bind(colorEffect, indexToBind, this._userInstancedBuffersStorage.vertexBuffers, this._userInstancedBuffersStorage.vertexArrayObjects);
        // Color
        if (!this.useVertexColor && this._isShaderMaterial(this._lineMaterial)) {
            const { r: r, g: g, b: b } = this.color;
            this._color4.set(r, g, b, this.alpha);
            this._lineMaterial.setColor4("color", this._color4);
        }
        return this;
    }
    /**
     * @internal
     */ _draw(subMesh, fillMode, instancesCount) {
        if (!this._geometry || !this._geometry.getVertexBuffers() || !this._unIndexed && !this._geometry.getIndexBuffer()) return this;
        const engine = this.getScene().getEngine();
        // Draw order
        if (this._unIndexed) engine.drawArraysType((0, $54229.Material).LineListDrawMode, subMesh.verticesStart, subMesh.verticesCount, instancesCount);
        else engine.drawElementsType((0, $54229.Material).LineListDrawMode, subMesh.indexStart, subMesh.indexCount, instancesCount);
        return this;
    }
    /**
     * Disposes of the line mesh
     * @param doNotRecurse If children should be disposed
     * @param disposeMaterialAndTextures This parameter is not used by the LineMesh class
     * @param doNotDisposeMaterial If the material should not be disposed (default: false, meaning the material is disposed)
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    dispose(doNotRecurse, disposeMaterialAndTextures = false, doNotDisposeMaterial) {
        if (!doNotDisposeMaterial) this._lineMaterial.dispose(false, false, true);
        super.dispose(doNotRecurse);
    }
    /**
     * Returns a new LineMesh object cloned from the current one.
     * @param name defines the cloned mesh name
     * @param newParent defines the new mesh parent
     * @param doNotCloneChildren if set to true, none of the mesh children are cloned (false by default)
     * @returns the new mesh
     */ clone(name, newParent = null, doNotCloneChildren) {
        return new $769a2062ec6bae3f$export$9955070e3d6299(name, this.getScene(), newParent, this, doNotCloneChildren);
    }
    /**
     * Creates a new InstancedLinesMesh object from the mesh model.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/copies/instances
     * @param name defines the name of the new instance
     * @returns a new InstancedLinesMesh
     */ createInstance(name) {
        const instance = new $769a2062ec6bae3f$export$59ce9705b5ce8121(name, this);
        if (this.instancedBuffers) {
            instance.instancedBuffers = {};
            for(const key in this.instancedBuffers)instance.instancedBuffers[key] = this.instancedBuffers[key];
        }
        return instance;
    }
    /**
     * Serializes this ground mesh
     * @param serializationObject object to write serialization to
     */ serialize(serializationObject) {
        super.serialize(serializationObject);
        serializationObject.color = this.color.asArray();
        serializationObject.alpha = this.alpha;
    }
    /**
     * Parses a serialized ground mesh
     * @param parsedMesh the serialized mesh
     * @param scene the scene to create the ground mesh in
     * @returns the created ground mesh
     */ static Parse(parsedMesh, scene) {
        const result = new $769a2062ec6bae3f$export$9955070e3d6299(parsedMesh.name, scene);
        result.color = (0, $7etnY.Color3).FromArray(parsedMesh.color);
        result.alpha = parsedMesh.alpha;
        return result;
    }
}
class $769a2062ec6bae3f$export$59ce9705b5ce8121 extends (0, $9Xybp.InstancedMesh) {
    constructor(name, source){
        super(name, source);
        this.intersectionThreshold = source.intersectionThreshold;
    }
    /**
     * @returns the string "InstancedLinesMesh".
     */ getClassName() {
        return "InstancedLinesMesh";
    }
}

});
parcelRegister("4I7rl", function(module, exports) {

$parcel$export(module.exports, "ShaderMaterial", () => $36e10aeb8f79d080$export$83c7d75d550a8b0d);

var $6Ho1L = parcelRequire("6Ho1L");

var $gmbCk = parcelRequire("gmbCk");

var $ha1VO = parcelRequire("ha1VO");

var $b4i1f = parcelRequire("b4i1f");

var $j2mX5 = parcelRequire("j2mX5");

var $8DoUR = parcelRequire("8DoUR");

var $7etnY = parcelRequire("7etnY");

var $gc8Ja = parcelRequire("gc8Ja");

var $hUzEl = parcelRequire("hUzEl");

var $atHN2 = parcelRequire("atHN2");

var $ejQPp = parcelRequire("ejQPp");

var $aAFeM = parcelRequire("aAFeM");

var $alPCh = parcelRequire("alPCh");
const $36e10aeb8f79d080$var$onCreatedEffectParameters = {
    effect: null,
    subMesh: null
};
class $36e10aeb8f79d080$export$83c7d75d550a8b0d extends (0, $atHN2.PushMaterial) {
    /**
     * Instantiate a new shader material.
     * The ShaderMaterial object has the necessary methods to pass data from your scene to the Vertex and Fragment Shaders and returns a material that can be applied to any mesh.
     * This returned material effects how the mesh will look based on the code in the shaders.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/shaders/shaderMaterial
     * @param name Define the name of the material in the scene
     * @param scene Define the scene the material belongs to
     * @param shaderPath Defines  the route to the shader code in one of three ways:
     *  * object: \{ vertex: "custom", fragment: "custom" \}, used with Effect.ShadersStore["customVertexShader"] and Effect.ShadersStore["customFragmentShader"]
     *  * object: \{ vertexElement: "vertexShaderCode", fragmentElement: "fragmentShaderCode" \}, used with shader code in script tags
     *  * object: \{ vertexSource: "vertex shader code string", fragmentSource: "fragment shader code string" \} using with strings containing the shaders code
     *  * string: "./COMMON_NAME", used with external files COMMON_NAME.vertex.fx and COMMON_NAME.fragment.fx in index.html folder.
     * @param options Define the options used to create the shader
     * @param storeEffectOnSubMeshes true to store effect on submeshes, false to store the effect directly in the material class.
     */ constructor(name, scene, shaderPath, options = {}, storeEffectOnSubMeshes = true){
        super(name, scene, storeEffectOnSubMeshes);
        this._textures = {};
        this._textureArrays = {};
        this._externalTextures = {};
        this._floats = {};
        this._ints = {};
        this._uints = {};
        this._floatsArrays = {};
        this._colors3 = {};
        this._colors3Arrays = {};
        this._colors4 = {};
        this._colors4Arrays = {};
        this._vectors2 = {};
        this._vectors3 = {};
        this._vectors4 = {};
        this._quaternions = {};
        this._quaternionsArrays = {};
        this._matrices = {};
        this._matrixArrays = {};
        this._matrices3x3 = {};
        this._matrices2x2 = {};
        this._vectors2Arrays = {};
        this._vectors3Arrays = {};
        this._vectors4Arrays = {};
        this._uniformBuffers = {};
        this._textureSamplers = {};
        this._storageBuffers = {};
        this._cachedWorldViewMatrix = new (0, $ha1VO.Matrix)();
        this._cachedWorldViewProjectionMatrix = new (0, $ha1VO.Matrix)();
        this._multiview = false;
        /**
         * @internal
         */ this._materialHelperNeedsPreviousMatrices = false;
        this._shaderPath = shaderPath;
        this._options = {
            needAlphaBlending: false,
            needAlphaTesting: false,
            attributes: [
                "position",
                "normal",
                "uv"
            ],
            uniforms: [
                "worldViewProjection"
            ],
            uniformBuffers: [],
            samplers: [],
            externalTextures: [],
            samplerObjects: [],
            storageBuffers: [],
            defines: [],
            useClipPlane: false,
            ...options
        };
    }
    /**
     * Gets the shader path used to define the shader code
     * It can be modified to trigger a new compilation
     */ get shaderPath() {
        return this._shaderPath;
    }
    /**
     * Sets the shader path used to define the shader code
     * It can be modified to trigger a new compilation
     */ set shaderPath(shaderPath) {
        this._shaderPath = shaderPath;
    }
    /**
     * Gets the options used to compile the shader.
     * They can be modified to trigger a new compilation
     */ get options() {
        return this._options;
    }
    /**
     * is multiview set to true?
     */ get isMultiview() {
        return this._multiview;
    }
    /**
     * Gets the current class name of the material e.g. "ShaderMaterial"
     * Mainly use in serialization.
     * @returns the class name
     */ getClassName() {
        return "ShaderMaterial";
    }
    /**
     * Specifies if the material will require alpha blending
     * @returns a boolean specifying if alpha blending is needed
     */ needAlphaBlending() {
        return this.alpha < 1.0 || this._options.needAlphaBlending;
    }
    /**
     * Specifies if this material should be rendered in alpha test mode
     * @returns a boolean specifying if an alpha test is needed.
     */ needAlphaTesting() {
        return this._options.needAlphaTesting;
    }
    _checkUniform(uniformName) {
        if (this._options.uniforms.indexOf(uniformName) === -1) this._options.uniforms.push(uniformName);
    }
    /**
     * Set a texture in the shader.
     * @param name Define the name of the uniform samplers as defined in the shader
     * @param texture Define the texture to bind to this sampler
     * @returns the material itself allowing "fluent" like uniform updates
     */ setTexture(name, texture) {
        if (this._options.samplers.indexOf(name) === -1) this._options.samplers.push(name);
        this._textures[name] = texture;
        return this;
    }
    /**
     * Set a texture array in the shader.
     * @param name Define the name of the uniform sampler array as defined in the shader
     * @param textures Define the list of textures to bind to this sampler
     * @returns the material itself allowing "fluent" like uniform updates
     */ setTextureArray(name, textures) {
        if (this._options.samplers.indexOf(name) === -1) this._options.samplers.push(name);
        this._checkUniform(name);
        this._textureArrays[name] = textures;
        return this;
    }
    /**
     * Set an internal texture in the shader.
     * @param name Define the name of the uniform samplers as defined in the shader
     * @param texture Define the texture to bind to this sampler
     * @returns the material itself allowing "fluent" like uniform updates
     */ setExternalTexture(name, texture) {
        if (this._options.externalTextures.indexOf(name) === -1) this._options.externalTextures.push(name);
        this._externalTextures[name] = texture;
        return this;
    }
    /**
     * Set a float in the shader.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setFloat(name, value) {
        this._checkUniform(name);
        this._floats[name] = value;
        return this;
    }
    /**
     * Set a int in the shader.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setInt(name, value) {
        this._checkUniform(name);
        this._ints[name] = value;
        return this;
    }
    /**
     * Set a unsigned int in the shader.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setUInt(name, value) {
        this._checkUniform(name);
        this._uints[name] = value;
        return this;
    }
    /**
     * Set an array of floats in the shader.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setFloats(name, value) {
        this._checkUniform(name);
        this._floatsArrays[name] = value;
        return this;
    }
    /**
     * Set a vec3 in the shader from a Color3.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setColor3(name, value) {
        this._checkUniform(name);
        this._colors3[name] = value;
        return this;
    }
    /**
     * Set a vec3 array in the shader from a Color3 array.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setColor3Array(name, value) {
        this._checkUniform(name);
        this._colors3Arrays[name] = value.reduce((arr, color)=>{
            color.toArray(arr, arr.length);
            return arr;
        }, []);
        return this;
    }
    /**
     * Set a vec4 in the shader from a Color4.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setColor4(name, value) {
        this._checkUniform(name);
        this._colors4[name] = value;
        return this;
    }
    /**
     * Set a vec4 array in the shader from a Color4 array.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setColor4Array(name, value) {
        this._checkUniform(name);
        this._colors4Arrays[name] = value.reduce((arr, color)=>{
            color.toArray(arr, arr.length);
            return arr;
        }, []);
        return this;
    }
    /**
     * Set a vec2 in the shader from a Vector2.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setVector2(name, value) {
        this._checkUniform(name);
        this._vectors2[name] = value;
        return this;
    }
    /**
     * Set a vec3 in the shader from a Vector3.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setVector3(name, value) {
        this._checkUniform(name);
        this._vectors3[name] = value;
        return this;
    }
    /**
     * Set a vec4 in the shader from a Vector4.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setVector4(name, value) {
        this._checkUniform(name);
        this._vectors4[name] = value;
        return this;
    }
    /**
     * Set a vec4 in the shader from a Quaternion.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setQuaternion(name, value) {
        this._checkUniform(name);
        this._quaternions[name] = value;
        return this;
    }
    /**
     * Set a vec4 array in the shader from a Quaternion array.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setQuaternionArray(name, value) {
        this._checkUniform(name);
        this._quaternionsArrays[name] = value.reduce((arr, quaternion)=>{
            quaternion.toArray(arr, arr.length);
            return arr;
        }, []);
        return this;
    }
    /**
     * Set a mat4 in the shader from a Matrix.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setMatrix(name, value) {
        this._checkUniform(name);
        this._matrices[name] = value;
        return this;
    }
    /**
     * Set a float32Array in the shader from a matrix array.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setMatrices(name, value) {
        this._checkUniform(name);
        const float32Array = new Float32Array(value.length * 16);
        for(let index = 0; index < value.length; index++){
            const matrix = value[index];
            matrix.copyToArray(float32Array, index * 16);
        }
        this._matrixArrays[name] = float32Array;
        return this;
    }
    /**
     * Set a mat3 in the shader from a Float32Array.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setMatrix3x3(name, value) {
        this._checkUniform(name);
        this._matrices3x3[name] = value;
        return this;
    }
    /**
     * Set a mat2 in the shader from a Float32Array.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setMatrix2x2(name, value) {
        this._checkUniform(name);
        this._matrices2x2[name] = value;
        return this;
    }
    /**
     * Set a vec2 array in the shader from a number array.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setArray2(name, value) {
        this._checkUniform(name);
        this._vectors2Arrays[name] = value;
        return this;
    }
    /**
     * Set a vec3 array in the shader from a number array.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setArray3(name, value) {
        this._checkUniform(name);
        this._vectors3Arrays[name] = value;
        return this;
    }
    /**
     * Set a vec4 array in the shader from a number array.
     * @param name Define the name of the uniform as defined in the shader
     * @param value Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setArray4(name, value) {
        this._checkUniform(name);
        this._vectors4Arrays[name] = value;
        return this;
    }
    /**
     * Set a uniform buffer in the shader
     * @param name Define the name of the uniform as defined in the shader
     * @param buffer Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setUniformBuffer(name, buffer) {
        if (this._options.uniformBuffers.indexOf(name) === -1) this._options.uniformBuffers.push(name);
        this._uniformBuffers[name] = buffer;
        return this;
    }
    /**
     * Set a texture sampler in the shader
     * @param name Define the name of the uniform as defined in the shader
     * @param sampler Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setTextureSampler(name, sampler) {
        if (this._options.samplerObjects.indexOf(name) === -1) this._options.samplerObjects.push(name);
        this._textureSamplers[name] = sampler;
        return this;
    }
    /**
     * Set a storage buffer in the shader
     * @param name Define the name of the storage buffer as defined in the shader
     * @param buffer Define the value to give to the uniform
     * @returns the material itself allowing "fluent" like uniform updates
     */ setStorageBuffer(name, buffer) {
        if (this._options.storageBuffers.indexOf(name) === -1) this._options.storageBuffers.push(name);
        this._storageBuffers[name] = buffer;
        return this;
    }
    /**
     * Adds, removes, or replaces the specified shader define and value.
     * * setDefine("MY_DEFINE", true); // enables a boolean define
     * * setDefine("MY_DEFINE", "0.5"); // adds "#define MY_DEFINE 0.5" to the shader (or sets and replaces the value of any existing define with that name)
     * * setDefine("MY_DEFINE", false); // disables and removes the define
     * Note if the active defines do change, the shader will be recompiled and this can be expensive.
     * @param define the define name e.g., "OUTPUT_TO_SRGB" or "#define OUTPUT_TO_SRGB". If the define was passed into the constructor already, the version used should match that, and in either case, it should not include any appended value.
     * @param value either the value of the define (e.g. a numerical value) or for booleans, true if the define should be enabled or false if it should be disabled
     * @returns the material itself allowing "fluent" like uniform updates
     */ setDefine(define, value) {
        // First remove any existing define with this name.
        const defineName = define.trimEnd() + " ";
        const existingDefineIdx = this.options.defines.findIndex((x)=>x === define || x.startsWith(defineName));
        if (existingDefineIdx >= 0) this.options.defines.splice(existingDefineIdx, 1);
        // Then add the new define value. (If it's a boolean value and false, don't add it.)
        if (typeof value !== "boolean" || value) this.options.defines.push(defineName + value);
        return this;
    }
    /**
     * Specifies that the submesh is ready to be used
     * @param mesh defines the mesh to check
     * @param subMesh defines which submesh to check
     * @param useInstances specifies that instances should be used
     * @returns a boolean indicating that the submesh is ready or not
     */ isReadyForSubMesh(mesh, subMesh, useInstances) {
        return this.isReady(mesh, useInstances, subMesh);
    }
    /**
     * Checks if the material is ready to render the requested mesh
     * @param mesh Define the mesh to render
     * @param useInstances Define whether or not the material is used with instances
     * @param subMesh defines which submesh to render
     * @returns true if ready, otherwise false
     */ isReady(mesh, useInstances, subMesh) {
        const storeEffectOnSubMeshes = subMesh && this._storeEffectOnSubMeshes;
        if (this.isFrozen) {
            const drawWrapper = storeEffectOnSubMeshes ? subMesh._drawWrapper : this._drawWrapper;
            if (drawWrapper.effect && drawWrapper._wasPreviouslyReady && drawWrapper._wasPreviouslyUsingInstances === useInstances) return true;
        }
        const scene = this.getScene();
        const engine = scene.getEngine();
        // Instances
        const defines = [];
        const attribs = [];
        const fallbacks = new (0, $gc8Ja.EffectFallbacks)();
        let shaderName = this._shaderPath, uniforms = this._options.uniforms, uniformBuffers = this._options.uniformBuffers, samplers = this._options.samplers;
        // global multiview
        if (engine.getCaps().multiview && scene.activeCamera && scene.activeCamera.outputRenderTarget && scene.activeCamera.outputRenderTarget.getViewCount() > 1) {
            this._multiview = true;
            defines.push("#define MULTIVIEW");
            if (uniforms.indexOf("viewProjection") !== -1 && uniforms.indexOf("viewProjectionR") === -1) uniforms.push("viewProjectionR");
        }
        for(let index = 0; index < this._options.defines.length; index++){
            const defineToAdd = this._options.defines[index].indexOf("#define") === 0 ? this._options.defines[index] : `#define ${this._options.defines[index]}`;
            defines.push(defineToAdd);
        }
        for(let index = 0; index < this._options.attributes.length; index++)attribs.push(this._options.attributes[index]);
        if (mesh && mesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).ColorKind)) {
            if (attribs.indexOf((0, $b4i1f.VertexBuffer).ColorKind) === -1) attribs.push((0, $b4i1f.VertexBuffer).ColorKind);
            defines.push("#define VERTEXCOLOR");
        }
        if (useInstances) {
            defines.push("#define INSTANCES");
            (0, $alPCh.PushAttributesForInstances)(attribs, this._materialHelperNeedsPreviousMatrices);
            if (mesh?.hasThinInstances) {
                defines.push("#define THIN_INSTANCES");
                if (mesh && mesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).ColorInstanceKind)) {
                    attribs.push((0, $b4i1f.VertexBuffer).ColorInstanceKind);
                    defines.push("#define INSTANCESCOLOR");
                }
            }
        }
        // Bones
        if (mesh && mesh.useBones && mesh.computeBonesUsingShaders && mesh.skeleton) {
            attribs.push((0, $b4i1f.VertexBuffer).MatricesIndicesKind);
            attribs.push((0, $b4i1f.VertexBuffer).MatricesWeightsKind);
            if (mesh.numBoneInfluencers > 4) {
                attribs.push((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind);
                attribs.push((0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind);
            }
            const skeleton = mesh.skeleton;
            defines.push("#define NUM_BONE_INFLUENCERS " + mesh.numBoneInfluencers);
            fallbacks.addCPUSkinningFallback(0, mesh);
            if (skeleton.isUsingTextureForMatrices) {
                defines.push("#define BONETEXTURE");
                if (uniforms.indexOf("boneTextureWidth") === -1) uniforms.push("boneTextureWidth");
                if (this._options.samplers.indexOf("boneSampler") === -1) this._options.samplers.push("boneSampler");
            } else {
                defines.push("#define BonesPerMesh " + (skeleton.bones.length + 1));
                if (uniforms.indexOf("mBones") === -1) uniforms.push("mBones");
            }
        } else defines.push("#define NUM_BONE_INFLUENCERS 0");
        // Morph
        let numInfluencers = 0;
        const manager = mesh ? mesh.morphTargetManager : null;
        if (manager) {
            const uv = manager.supportsUVs && defines.indexOf("#define UV1") !== -1;
            const tangent = manager.supportsTangents && defines.indexOf("#define TANGENT") !== -1;
            const normal = manager.supportsNormals && defines.indexOf("#define NORMAL") !== -1;
            numInfluencers = manager.numMaxInfluencers || manager.numInfluencers;
            if (uv) defines.push("#define MORPHTARGETS_UV");
            if (tangent) defines.push("#define MORPHTARGETS_TANGENT");
            if (normal) defines.push("#define MORPHTARGETS_NORMAL");
            if (numInfluencers > 0) defines.push("#define MORPHTARGETS");
            if (manager.isUsingTextureForTargets) {
                defines.push("#define MORPHTARGETS_TEXTURE");
                if (uniforms.indexOf("morphTargetTextureIndices") === -1) uniforms.push("morphTargetTextureIndices");
                if (this._options.samplers.indexOf("morphTargets") === -1) this._options.samplers.push("morphTargets");
            }
            defines.push("#define NUM_MORPH_INFLUENCERS " + numInfluencers);
            for(let index = 0; index < numInfluencers; index++){
                attribs.push((0, $b4i1f.VertexBuffer).PositionKind + index);
                if (normal) attribs.push((0, $b4i1f.VertexBuffer).NormalKind + index);
                if (tangent) attribs.push((0, $b4i1f.VertexBuffer).TangentKind + index);
                if (uv) attribs.push((0, $b4i1f.VertexBuffer).UVKind + "_" + index);
            }
            if (numInfluencers > 0) {
                uniforms = uniforms.slice();
                uniforms.push("morphTargetInfluences");
                uniforms.push("morphTargetCount");
                uniforms.push("morphTargetTextureInfo");
                uniforms.push("morphTargetTextureIndices");
            }
        } else defines.push("#define NUM_MORPH_INFLUENCERS 0");
        // Baked Vertex Animation
        if (mesh) {
            const bvaManager = mesh.bakedVertexAnimationManager;
            if (bvaManager && bvaManager.isEnabled) {
                defines.push("#define BAKED_VERTEX_ANIMATION_TEXTURE");
                if (uniforms.indexOf("bakedVertexAnimationSettings") === -1) uniforms.push("bakedVertexAnimationSettings");
                if (uniforms.indexOf("bakedVertexAnimationTextureSizeInverted") === -1) uniforms.push("bakedVertexAnimationTextureSizeInverted");
                if (uniforms.indexOf("bakedVertexAnimationTime") === -1) uniforms.push("bakedVertexAnimationTime");
                if (this._options.samplers.indexOf("bakedVertexAnimationTexture") === -1) this._options.samplers.push("bakedVertexAnimationTexture");
            }
            (0, $alPCh.PrepareAttributesForBakedVertexAnimation)(attribs, mesh, defines);
        }
        // Textures
        for(const name in this._textures){
            if (!this._textures[name].isReady()) return false;
        }
        // Alpha test
        if (mesh && this._shouldTurnAlphaTestOn(mesh)) defines.push("#define ALPHATEST");
        // Clip planes
        if (this._options.useClipPlane !== false) {
            (0, $aAFeM.addClipPlaneUniforms)(uniforms);
            (0, $aAFeM.prepareStringDefinesForClipPlanes)(this, scene, defines);
        }
        // Fog
        if (scene.fogEnabled && mesh?.applyFog && scene.fogMode !== (0, $gmbCk.Scene).FOGMODE_NONE) {
            defines.push("#define FOG");
            if (uniforms.indexOf("view") === -1) uniforms.push("view");
            if (uniforms.indexOf("vFogInfos") === -1) uniforms.push("vFogInfos");
            if (uniforms.indexOf("vFogColor") === -1) uniforms.push("vFogColor");
        }
        // Misc
        if (this._useLogarithmicDepth) {
            defines.push("#define LOGARITHMICDEPTH");
            if (uniforms.indexOf("logarithmicDepthConstant") === -1) uniforms.push("logarithmicDepthConstant");
        }
        if (this.customShaderNameResolve) {
            uniforms = uniforms.slice();
            uniformBuffers = uniformBuffers.slice();
            samplers = samplers.slice();
            shaderName = this.customShaderNameResolve(shaderName, uniforms, uniformBuffers, samplers, defines, attribs);
        }
        const drawWrapper = storeEffectOnSubMeshes ? subMesh._getDrawWrapper(undefined, true) : this._drawWrapper;
        const previousEffect = drawWrapper?.effect ?? null;
        const previousDefines = drawWrapper?.defines ?? null;
        const join = defines.join("\n");
        let effect = previousEffect;
        if (previousDefines !== join) {
            effect = engine.createEffect(shaderName, {
                attributes: attribs,
                uniformsNames: uniforms,
                uniformBuffersNames: uniformBuffers,
                samplers: samplers,
                defines: join,
                fallbacks: fallbacks,
                onCompiled: this.onCompiled,
                onError: this.onError,
                indexParameters: {
                    maxSimultaneousMorphTargets: numInfluencers
                },
                shaderLanguage: this._options.shaderLanguage
            }, engine);
            if (storeEffectOnSubMeshes) subMesh.setEffect(effect, join, this._materialContext);
            else if (drawWrapper) drawWrapper.setEffect(effect, join);
            if (this._onEffectCreatedObservable) {
                $36e10aeb8f79d080$var$onCreatedEffectParameters.effect = effect;
                $36e10aeb8f79d080$var$onCreatedEffectParameters.subMesh = subMesh ?? mesh?.subMeshes[0] ?? null;
                this._onEffectCreatedObservable.notifyObservers($36e10aeb8f79d080$var$onCreatedEffectParameters);
            }
        }
        drawWrapper._wasPreviouslyUsingInstances = !!useInstances;
        if (!effect?.isReady() ?? true) return false;
        if (previousEffect !== effect) scene.resetCachedMaterial();
        drawWrapper._wasPreviouslyReady = true;
        return true;
    }
    /**
     * Binds the world matrix to the material
     * @param world defines the world transformation matrix
     * @param effectOverride - If provided, use this effect instead of internal effect
     */ bindOnlyWorldMatrix(world, effectOverride) {
        const scene = this.getScene();
        const effect = effectOverride ?? this.getEffect();
        if (!effect) return;
        if (this._options.uniforms.indexOf("world") !== -1) effect.setMatrix("world", world);
        if (this._options.uniforms.indexOf("worldView") !== -1) {
            world.multiplyToRef(scene.getViewMatrix(), this._cachedWorldViewMatrix);
            effect.setMatrix("worldView", this._cachedWorldViewMatrix);
        }
        if (this._options.uniforms.indexOf("worldViewProjection") !== -1) {
            world.multiplyToRef(scene.getTransformMatrix(), this._cachedWorldViewProjectionMatrix);
            effect.setMatrix("worldViewProjection", this._cachedWorldViewProjectionMatrix);
        }
        if (this._options.uniforms.indexOf("view") !== -1) effect.setMatrix("view", scene.getViewMatrix());
    }
    /**
     * Binds the submesh to this material by preparing the effect and shader to draw
     * @param world defines the world transformation matrix
     * @param mesh defines the mesh containing the submesh
     * @param subMesh defines the submesh to bind the material to
     */ bindForSubMesh(world, mesh, subMesh) {
        this.bind(world, mesh, subMesh._drawWrapperOverride?.effect, subMesh);
    }
    /**
     * Binds the material to the mesh
     * @param world defines the world transformation matrix
     * @param mesh defines the mesh to bind the material to
     * @param effectOverride - If provided, use this effect instead of internal effect
     * @param subMesh defines the submesh to bind the material to
     */ bind(world, mesh, effectOverride, subMesh) {
        // Std values
        const storeEffectOnSubMeshes = subMesh && this._storeEffectOnSubMeshes;
        const effect = effectOverride ?? (storeEffectOnSubMeshes ? subMesh.effect : this.getEffect());
        if (!effect) return;
        const scene = this.getScene();
        this._activeEffect = effect;
        this.bindOnlyWorldMatrix(world, effectOverride);
        const uniformBuffers = this._options.uniformBuffers;
        let useSceneUBO = false;
        if (effect && uniformBuffers && uniformBuffers.length > 0 && scene.getEngine().supportsUniformBuffers) for(let i = 0; i < uniformBuffers.length; ++i){
            const bufferName = uniformBuffers[i];
            switch(bufferName){
                case "Mesh":
                    if (mesh) {
                        mesh.getMeshUniformBuffer().bindToEffect(effect, "Mesh");
                        mesh.transferToEffect(world);
                    }
                    break;
                case "Scene":
                    (0, $alPCh.BindSceneUniformBuffer)(effect, scene.getSceneUniformBuffer());
                    scene.finalizeSceneUbo();
                    useSceneUBO = true;
                    break;
            }
        }
        const mustRebind = mesh && storeEffectOnSubMeshes ? this._mustRebind(scene, effect, subMesh, mesh.visibility) : scene.getCachedMaterial() !== this;
        if (effect && mustRebind) {
            if (!useSceneUBO && this._options.uniforms.indexOf("view") !== -1) effect.setMatrix("view", scene.getViewMatrix());
            if (!useSceneUBO && this._options.uniforms.indexOf("projection") !== -1) effect.setMatrix("projection", scene.getProjectionMatrix());
            if (!useSceneUBO && this._options.uniforms.indexOf("viewProjection") !== -1) {
                effect.setMatrix("viewProjection", scene.getTransformMatrix());
                if (this._multiview) effect.setMatrix("viewProjectionR", scene._transformMatrixR);
            }
            if (scene.activeCamera && this._options.uniforms.indexOf("cameraPosition") !== -1) effect.setVector3("cameraPosition", scene.activeCamera.globalPosition);
            // Bones
            (0, $alPCh.BindBonesParameters)(mesh, effect);
            // Clip plane
            (0, $aAFeM.bindClipPlane)(effect, this, scene);
            // Misc
            if (this._useLogarithmicDepth) (0, $alPCh.BindLogDepth)(storeEffectOnSubMeshes ? subMesh.materialDefines : effect.defines, effect, scene);
            // Fog
            if (mesh) (0, $alPCh.BindFogParameters)(scene, mesh, effect);
            let name;
            // Texture
            for(name in this._textures)effect.setTexture(name, this._textures[name]);
            // Texture arrays
            for(name in this._textureArrays)effect.setTextureArray(name, this._textureArrays[name]);
            // External texture
            for(name in this._externalTextures)effect.setExternalTexture(name, this._externalTextures[name]);
            // Int
            for(name in this._ints)effect.setInt(name, this._ints[name]);
            // UInt
            for(name in this._uints)effect.setUInt(name, this._uints[name]);
            // Float
            for(name in this._floats)effect.setFloat(name, this._floats[name]);
            // Floats
            for(name in this._floatsArrays)effect.setArray(name, this._floatsArrays[name]);
            // Color3
            for(name in this._colors3)effect.setColor3(name, this._colors3[name]);
            // Color3Array
            for(name in this._colors3Arrays)effect.setArray3(name, this._colors3Arrays[name]);
            // Color4
            for(name in this._colors4){
                const color = this._colors4[name];
                effect.setFloat4(name, color.r, color.g, color.b, color.a);
            }
            // Color4Array
            for(name in this._colors4Arrays)effect.setArray4(name, this._colors4Arrays[name]);
            // Vector2
            for(name in this._vectors2)effect.setVector2(name, this._vectors2[name]);
            // Vector3
            for(name in this._vectors3)effect.setVector3(name, this._vectors3[name]);
            // Vector4
            for(name in this._vectors4)effect.setVector4(name, this._vectors4[name]);
            // Quaternion
            for(name in this._quaternions)effect.setQuaternion(name, this._quaternions[name]);
            // Matrix
            for(name in this._matrices)effect.setMatrix(name, this._matrices[name]);
            // MatrixArray
            for(name in this._matrixArrays)effect.setMatrices(name, this._matrixArrays[name]);
            // Matrix 3x3
            for(name in this._matrices3x3)effect.setMatrix3x3(name, this._matrices3x3[name]);
            // Matrix 2x2
            for(name in this._matrices2x2)effect.setMatrix2x2(name, this._matrices2x2[name]);
            // Vector2Array
            for(name in this._vectors2Arrays)effect.setArray2(name, this._vectors2Arrays[name]);
            // Vector3Array
            for(name in this._vectors3Arrays)effect.setArray3(name, this._vectors3Arrays[name]);
            // Vector4Array
            for(name in this._vectors4Arrays)effect.setArray4(name, this._vectors4Arrays[name]);
            // QuaternionArray
            for(name in this._quaternionsArrays)effect.setArray4(name, this._quaternionsArrays[name]);
            // Uniform buffers
            for(name in this._uniformBuffers){
                const buffer = this._uniformBuffers[name].getBuffer();
                if (buffer) effect.bindUniformBuffer(buffer, name);
            }
            // Samplers
            for(name in this._textureSamplers)effect.setTextureSampler(name, this._textureSamplers[name]);
            // Storage buffers
            for(name in this._storageBuffers)effect.setStorageBuffer(name, this._storageBuffers[name]);
        }
        if (effect && mesh && (mustRebind || !this.isFrozen)) {
            // Morph targets
            const manager = mesh.morphTargetManager;
            if (manager && manager.numInfluencers > 0) (0, $alPCh.BindMorphTargetParameters)(mesh, effect);
            const bvaManager = mesh.bakedVertexAnimationManager;
            if (bvaManager && bvaManager.isEnabled) {
                const drawWrapper = storeEffectOnSubMeshes ? subMesh._drawWrapper : this._drawWrapper;
                mesh.bakedVertexAnimationManager?.bind(effect, !!drawWrapper._wasPreviouslyUsingInstances);
            }
        }
        this._afterBind(mesh, effect, subMesh);
    }
    /**
     * Gets the active textures from the material
     * @returns an array of textures
     */ getActiveTextures() {
        const activeTextures = super.getActiveTextures();
        for(const name in this._textures)activeTextures.push(this._textures[name]);
        for(const name in this._textureArrays){
            const array = this._textureArrays[name];
            for(let index = 0; index < array.length; index++)activeTextures.push(array[index]);
        }
        return activeTextures;
    }
    /**
     * Specifies if the material uses a texture
     * @param texture defines the texture to check against the material
     * @returns a boolean specifying if the material uses the texture
     */ hasTexture(texture) {
        if (super.hasTexture(texture)) return true;
        for(const name in this._textures){
            if (this._textures[name] === texture) return true;
        }
        for(const name in this._textureArrays){
            const array = this._textureArrays[name];
            for(let index = 0; index < array.length; index++){
                if (array[index] === texture) return true;
            }
        }
        return false;
    }
    /**
     * Makes a duplicate of the material, and gives it a new name
     * @param name defines the new name for the duplicated material
     * @returns the cloned material
     */ clone(name) {
        const result = (0, $6Ho1L.SerializationHelper).Clone(()=>new $36e10aeb8f79d080$export$83c7d75d550a8b0d(name, this.getScene(), this._shaderPath, this._options, this._storeEffectOnSubMeshes), this);
        result.name = name;
        result.id = name;
        // Shader code path
        if (typeof result._shaderPath === "object") result._shaderPath = {
            ...result._shaderPath
        };
        // Options
        this._options = {
            ...this._options
        };
        Object.keys(this._options).forEach((propName)=>{
            const propValue = this._options[propName];
            if (Array.isArray(propValue)) this._options[propName] = propValue.slice(0);
        });
        // Stencil
        this.stencil.copyTo(result.stencil);
        // Texture
        for(const key in this._textures)result.setTexture(key, this._textures[key]);
        // TextureArray
        for(const key in this._textureArrays)result.setTextureArray(key, this._textureArrays[key]);
        // External texture
        for(const key in this._externalTextures)result.setExternalTexture(key, this._externalTextures[key]);
        // Int
        for(const key in this._ints)result.setInt(key, this._ints[key]);
        // UInt
        for(const key in this._uints)result.setUInt(key, this._uints[key]);
        // Float
        for(const key in this._floats)result.setFloat(key, this._floats[key]);
        // Floats
        for(const key in this._floatsArrays)result.setFloats(key, this._floatsArrays[key]);
        // Color3
        for(const key in this._colors3)result.setColor3(key, this._colors3[key]);
        // Color3Array
        for(const key in this._colors3Arrays)result._colors3Arrays[key] = this._colors3Arrays[key];
        // Color4
        for(const key in this._colors4)result.setColor4(key, this._colors4[key]);
        // Color4Array
        for(const key in this._colors4Arrays)result._colors4Arrays[key] = this._colors4Arrays[key];
        // Vector2
        for(const key in this._vectors2)result.setVector2(key, this._vectors2[key]);
        // Vector3
        for(const key in this._vectors3)result.setVector3(key, this._vectors3[key]);
        // Vector4
        for(const key in this._vectors4)result.setVector4(key, this._vectors4[key]);
        // Quaternion
        for(const key in this._quaternions)result.setQuaternion(key, this._quaternions[key]);
        // QuaternionArray
        for(const key in this._quaternionsArrays)result._quaternionsArrays[key] = this._quaternionsArrays[key];
        // Matrix
        for(const key in this._matrices)result.setMatrix(key, this._matrices[key]);
        // MatrixArray
        for(const key in this._matrixArrays)result._matrixArrays[key] = this._matrixArrays[key].slice();
        // Matrix 3x3
        for(const key in this._matrices3x3)result.setMatrix3x3(key, this._matrices3x3[key]);
        // Matrix 2x2
        for(const key in this._matrices2x2)result.setMatrix2x2(key, this._matrices2x2[key]);
        // Vector2Array
        for(const key in this._vectors2Arrays)result.setArray2(key, this._vectors2Arrays[key]);
        // Vector3Array
        for(const key in this._vectors3Arrays)result.setArray3(key, this._vectors3Arrays[key]);
        // Vector4Array
        for(const key in this._vectors4Arrays)result.setArray4(key, this._vectors4Arrays[key]);
        // Uniform buffers
        for(const key in this._uniformBuffers)result.setUniformBuffer(key, this._uniformBuffers[key]);
        // Samplers
        for(const key in this._textureSamplers)result.setTextureSampler(key, this._textureSamplers[key]);
        // Storag buffers
        for(const key in this._storageBuffers)result.setStorageBuffer(key, this._storageBuffers[key]);
        return result;
    }
    /**
     * Disposes the material
     * @param forceDisposeEffect specifies if effects should be forcefully disposed
     * @param forceDisposeTextures specifies if textures should be forcefully disposed
     * @param notBoundToMesh specifies if the material that is being disposed is known to be not bound to any mesh
     */ dispose(forceDisposeEffect, forceDisposeTextures, notBoundToMesh) {
        if (forceDisposeTextures) {
            let name;
            for(name in this._textures)this._textures[name].dispose();
            for(name in this._textureArrays){
                const array = this._textureArrays[name];
                for(let index = 0; index < array.length; index++)array[index].dispose();
            }
        }
        this._textures = {};
        super.dispose(forceDisposeEffect, forceDisposeTextures, notBoundToMesh);
    }
    /**
     * Serializes this material in a JSON representation
     * @returns the serialized material object
     */ serialize() {
        const serializationObject = (0, $6Ho1L.SerializationHelper).Serialize(this);
        serializationObject.customType = "BABYLON.ShaderMaterial";
        serializationObject.uniqueId = this.uniqueId;
        serializationObject.options = this._options;
        serializationObject.shaderPath = this._shaderPath;
        serializationObject.storeEffectOnSubMeshes = this._storeEffectOnSubMeshes;
        let name;
        // Stencil
        serializationObject.stencil = this.stencil.serialize();
        // Texture
        serializationObject.textures = {};
        for(name in this._textures)serializationObject.textures[name] = this._textures[name].serialize();
        // Texture arrays
        serializationObject.textureArrays = {};
        for(name in this._textureArrays){
            serializationObject.textureArrays[name] = [];
            const array = this._textureArrays[name];
            for(let index = 0; index < array.length; index++)serializationObject.textureArrays[name].push(array[index].serialize());
        }
        // Int
        serializationObject.ints = {};
        for(name in this._ints)serializationObject.ints[name] = this._ints[name];
        // UInt
        serializationObject.uints = {};
        for(name in this._uints)serializationObject.uints[name] = this._uints[name];
        // Float
        serializationObject.floats = {};
        for(name in this._floats)serializationObject.floats[name] = this._floats[name];
        // Floats
        serializationObject.floatsArrays = {};
        for(name in this._floatsArrays)serializationObject.floatsArrays[name] = this._floatsArrays[name];
        // Color3
        serializationObject.colors3 = {};
        for(name in this._colors3)serializationObject.colors3[name] = this._colors3[name].asArray();
        // Color3 array
        serializationObject.colors3Arrays = {};
        for(name in this._colors3Arrays)serializationObject.colors3Arrays[name] = this._colors3Arrays[name];
        // Color4
        serializationObject.colors4 = {};
        for(name in this._colors4)serializationObject.colors4[name] = this._colors4[name].asArray();
        // Color4 array
        serializationObject.colors4Arrays = {};
        for(name in this._colors4Arrays)serializationObject.colors4Arrays[name] = this._colors4Arrays[name];
        // Vector2
        serializationObject.vectors2 = {};
        for(name in this._vectors2)serializationObject.vectors2[name] = this._vectors2[name].asArray();
        // Vector3
        serializationObject.vectors3 = {};
        for(name in this._vectors3)serializationObject.vectors3[name] = this._vectors3[name].asArray();
        // Vector4
        serializationObject.vectors4 = {};
        for(name in this._vectors4)serializationObject.vectors4[name] = this._vectors4[name].asArray();
        // Quaternion
        serializationObject.quaternions = {};
        for(name in this._quaternions)serializationObject.quaternions[name] = this._quaternions[name].asArray();
        // Matrix
        serializationObject.matrices = {};
        for(name in this._matrices)serializationObject.matrices[name] = this._matrices[name].asArray();
        // MatrixArray
        serializationObject.matrixArray = {};
        for(name in this._matrixArrays)serializationObject.matrixArray[name] = this._matrixArrays[name];
        // Matrix 3x3
        serializationObject.matrices3x3 = {};
        for(name in this._matrices3x3)serializationObject.matrices3x3[name] = this._matrices3x3[name];
        // Matrix 2x2
        serializationObject.matrices2x2 = {};
        for(name in this._matrices2x2)serializationObject.matrices2x2[name] = this._matrices2x2[name];
        // Vector2Array
        serializationObject.vectors2Arrays = {};
        for(name in this._vectors2Arrays)serializationObject.vectors2Arrays[name] = this._vectors2Arrays[name];
        // Vector3Array
        serializationObject.vectors3Arrays = {};
        for(name in this._vectors3Arrays)serializationObject.vectors3Arrays[name] = this._vectors3Arrays[name];
        // Vector4Array
        serializationObject.vectors4Arrays = {};
        for(name in this._vectors4Arrays)serializationObject.vectors4Arrays[name] = this._vectors4Arrays[name];
        // QuaternionArray
        serializationObject.quaternionsArrays = {};
        for(name in this._quaternionsArrays)serializationObject.quaternionsArrays[name] = this._quaternionsArrays[name];
        return serializationObject;
    }
    /**
     * Creates a shader material from parsed shader material data
     * @param source defines the JSON representation of the material
     * @param scene defines the hosting scene
     * @param rootUrl defines the root URL to use to load textures and relative dependencies
     * @returns a new material
     */ static Parse(source, scene, rootUrl) {
        const material = (0, $6Ho1L.SerializationHelper).Parse(()=>new $36e10aeb8f79d080$export$83c7d75d550a8b0d(source.name, scene, source.shaderPath, source.options, source.storeEffectOnSubMeshes), source, scene, rootUrl);
        let name;
        // Stencil
        if (source.stencil) material.stencil.parse(source.stencil, scene, rootUrl);
        // Texture
        for(name in source.textures)material.setTexture(name, (0, $j2mX5.Texture).Parse(source.textures[name], scene, rootUrl));
        // Texture arrays
        for(name in source.textureArrays){
            const array = source.textureArrays[name];
            const textureArray = [];
            for(let index = 0; index < array.length; index++)textureArray.push((0, $j2mX5.Texture).Parse(array[index], scene, rootUrl));
            material.setTextureArray(name, textureArray);
        }
        // Int
        for(name in source.ints)material.setInt(name, source.ints[name]);
        // UInt
        for(name in source.uints)material.setUInt(name, source.uints[name]);
        // Float
        for(name in source.floats)material.setFloat(name, source.floats[name]);
        // Floats
        for(name in source.floatsArrays)material.setFloats(name, source.floatsArrays[name]);
        // Color3
        for(name in source.colors3)material.setColor3(name, (0, $7etnY.Color3).FromArray(source.colors3[name]));
        // Color3 arrays
        for(name in source.colors3Arrays){
            const colors = source.colors3Arrays[name].reduce((arr, num, i)=>{
                if (i % 3 === 0) arr.push([
                    num
                ]);
                else arr[arr.length - 1].push(num);
                return arr;
            }, []).map((color)=>(0, $7etnY.Color3).FromArray(color));
            material.setColor3Array(name, colors);
        }
        // Color4
        for(name in source.colors4)material.setColor4(name, (0, $7etnY.Color4).FromArray(source.colors4[name]));
        // Color4 arrays
        for(name in source.colors4Arrays){
            const colors = source.colors4Arrays[name].reduce((arr, num, i)=>{
                if (i % 4 === 0) arr.push([
                    num
                ]);
                else arr[arr.length - 1].push(num);
                return arr;
            }, []).map((color)=>(0, $7etnY.Color4).FromArray(color));
            material.setColor4Array(name, colors);
        }
        // Vector2
        for(name in source.vectors2)material.setVector2(name, (0, $ha1VO.Vector2).FromArray(source.vectors2[name]));
        // Vector3
        for(name in source.vectors3)material.setVector3(name, (0, $ha1VO.Vector3).FromArray(source.vectors3[name]));
        // Vector4
        for(name in source.vectors4)material.setVector4(name, (0, $ha1VO.Vector4).FromArray(source.vectors4[name]));
        // Quaternion
        for(name in source.quaternions)material.setQuaternion(name, (0, $ha1VO.Quaternion).FromArray(source.quaternions[name]));
        // Matrix
        for(name in source.matrices)material.setMatrix(name, (0, $ha1VO.Matrix).FromArray(source.matrices[name]));
        // MatrixArray
        for(name in source.matrixArray)material._matrixArrays[name] = new Float32Array(source.matrixArray[name]);
        // Matrix 3x3
        for(name in source.matrices3x3)material.setMatrix3x3(name, source.matrices3x3[name]);
        // Matrix 2x2
        for(name in source.matrices2x2)material.setMatrix2x2(name, source.matrices2x2[name]);
        // Vector2Array
        for(name in source.vectors2Arrays)material.setArray2(name, source.vectors2Arrays[name]);
        // Vector3Array
        for(name in source.vectors3Arrays)material.setArray3(name, source.vectors3Arrays[name]);
        // Vector4Array
        for(name in source.vectors4Arrays)material.setArray4(name, source.vectors4Arrays[name]);
        // QuaternionArray
        for(name in source.quaternionsArrays)material.setArray4(name, source.quaternionsArrays[name]);
        return material;
    }
    /**
     * Creates a new ShaderMaterial from a snippet saved in a remote file
     * @param name defines the name of the ShaderMaterial to create (can be null or empty to use the one from the json data)
     * @param url defines the url to load from
     * @param scene defines the hosting scene
     * @param rootUrl defines the root URL to use to load textures and relative dependencies
     * @returns a promise that will resolve to the new ShaderMaterial
     */ static ParseFromFileAsync(name, url, scene, rootUrl = "") {
        return new Promise((resolve, reject)=>{
            const request = new (0, $hUzEl.WebRequest)();
            request.addEventListener("readystatechange", ()=>{
                if (request.readyState == 4) {
                    if (request.status == 200) {
                        const serializationObject = JSON.parse(request.responseText);
                        const output = this.Parse(serializationObject, scene || (0, $ejQPp.EngineStore).LastCreatedScene, rootUrl);
                        if (name) output.name = name;
                        resolve(output);
                    } else reject("Unable to load the ShaderMaterial");
                }
            });
            request.open("GET", url);
            request.send();
        });
    }
    /**
     * Creates a ShaderMaterial from a snippet saved by the Inspector
     * @param snippetId defines the snippet to load
     * @param scene defines the hosting scene
     * @param rootUrl defines the root URL to use to load textures and relative dependencies
     * @returns a promise that will resolve to the new ShaderMaterial
     */ static ParseFromSnippetAsync(snippetId, scene, rootUrl = "") {
        return new Promise((resolve, reject)=>{
            const request = new (0, $hUzEl.WebRequest)();
            request.addEventListener("readystatechange", ()=>{
                if (request.readyState == 4) {
                    if (request.status == 200) {
                        const snippet = JSON.parse(JSON.parse(request.responseText).jsonPayload);
                        const serializationObject = JSON.parse(snippet.shaderMaterial);
                        const output = this.Parse(serializationObject, scene || (0, $ejQPp.EngineStore).LastCreatedScene, rootUrl);
                        output.snippetId = snippetId;
                        resolve(output);
                    } else reject("Unable to load the snippet " + snippetId);
                }
            });
            request.open("GET", this.SnippetUrl + "/" + snippetId.replace(/#/g, "/"));
            request.send();
        });
    }
}
/** Define the Url to load snippets */ $36e10aeb8f79d080$export$83c7d75d550a8b0d.SnippetUrl = `https://snippet.babylonjs.com`;
/**
 * Creates a ShaderMaterial from a snippet saved by the Inspector
 * @deprecated Please use ParseFromSnippetAsync instead
 * @param snippetId defines the snippet to load
 * @param scene defines the hosting scene
 * @param rootUrl defines the root URL to use to load textures and relative dependencies
 * @returns a promise that will resolve to the new ShaderMaterial
 */ $36e10aeb8f79d080$export$83c7d75d550a8b0d.CreateFromSnippetAsync = $36e10aeb8f79d080$export$83c7d75d550a8b0d.ParseFromSnippetAsync;
(0, $8DoUR.RegisterClass)("BABYLON.ShaderMaterial", $36e10aeb8f79d080$export$83c7d75d550a8b0d);

});

parcelRegister("kqZxW", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("82O8L");
parcelRequire("hvLF9");
parcelRequire("kg1CD");
parcelRequire("110hr");
const $ee05fa2e6b4d574b$var$name = "colorPixelShader";
const $ee05fa2e6b4d574b$var$shader = `#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
#define VERTEXCOLOR
varying vec4 vColor;
#else
uniform vec4 color;
#endif
#include<clipPlaneFragmentDeclaration>
#include<fogFragmentDeclaration>
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) {
#define CUSTOM_FRAGMENT_MAIN_BEGIN
#include<clipPlaneFragment>
#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
gl_FragColor=vColor;
#else
gl_FragColor=color;
#endif
#include<fogFragment>(color,gl_FragColor)
#define CUSTOM_FRAGMENT_MAIN_END
}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$ee05fa2e6b4d574b$var$name] = $ee05fa2e6b4d574b$var$shader;
const $ee05fa2e6b4d574b$export$529370c0f05ebde9 = {
    name: $ee05fa2e6b4d574b$var$name,
    shader: $ee05fa2e6b4d574b$var$shader
};

});

parcelRegister("7Z1KU", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("7PW7m");
parcelRequire("8kYMw");
parcelRequire("4A4MM");
parcelRequire("bdABV");
parcelRequire("k3wwH");
parcelRequire("apKdp");
parcelRequire("4idCt");
parcelRequire("cIweX");
parcelRequire("kqCfW");
parcelRequire("1pV7g");
parcelRequire("jl3r6");
const $5cff9789bf9b40c1$var$name = "colorVertexShader";
const $5cff9789bf9b40c1$var$shader = `attribute vec3 position;
#ifdef VERTEXCOLOR
attribute vec4 color;
#endif
#include<bonesDeclaration>
#include<bakedVertexAnimationDeclaration>
#include<clipPlaneVertexDeclaration>
#include<fogVertexDeclaration>
#ifdef FOG
uniform mat4 view;
#endif
#include<instancesDeclaration>
uniform mat4 viewProjection;
#ifdef MULTIVIEW
uniform mat4 viewProjectionR;
#endif
#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
varying vec4 vColor;
#endif
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
#include<instancesVertex>
#include<bonesVertex>
#include<bakedVertexAnimation>
vec4 worldPos=finalWorld*vec4(position,1.0);
#ifdef MULTIVIEW
if (gl_ViewID_OVR==0u) {gl_Position=viewProjection*worldPos;} else {gl_Position=viewProjectionR*worldPos;}
#else
gl_Position=viewProjection*worldPos;
#endif
#include<clipPlaneVertex>
#include<fogVertex>
#include<vertexColorMixing>
#define CUSTOM_VERTEX_MAIN_END
}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$5cff9789bf9b40c1$var$name] = $5cff9789bf9b40c1$var$shader;
const $5cff9789bf9b40c1$export$5683df4a89288503 = {
    name: $5cff9789bf9b40c1$var$name,
    shader: $5cff9789bf9b40c1$var$shader
};

});



parcelRegister("a2Hja", function(module, exports) {

$parcel$export(module.exports, "CreatePolygonVertexData", () => $74fbaf67623e82ac$export$8b0a0fcd41a39f4b);
$parcel$export(module.exports, "CreatePolygon", () => $74fbaf67623e82ac$export$2076f2784b460eb2);
$parcel$export(module.exports, "ExtrudePolygon", () => $74fbaf67623e82ac$export$7ab7ef8f70a7afeb);
$parcel$export(module.exports, "PolygonBuilder", () => $74fbaf67623e82ac$export$ab2e43fdbfddd162);

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $fbuqw = parcelRequire("fbuqw");

var $5v6ry = parcelRequire("5v6ry");

var $a4MLb = parcelRequire("a4MLb");

var $b4i1f = parcelRequire("b4i1f");

var $ejQPp = parcelRequire("ejQPp");

var $fGXjI = parcelRequire("fGXjI");
function $74fbaf67623e82ac$export$8b0a0fcd41a39f4b(polygon, sideOrientation, fUV, fColors, frontUVs, backUVs, wrp) {
    const faceUV = fUV || new Array(3);
    const faceColors = fColors;
    const colors = [];
    const wrap = wrp || false;
    // default face colors and UV if undefined
    for(let f = 0; f < 3; f++){
        if (faceUV[f] === undefined) faceUV[f] = new (0, $ha1VO.Vector4)(0, 0, 1, 1);
        if (faceColors && faceColors[f] === undefined) faceColors[f] = new (0, $7etnY.Color4)(1, 1, 1, 1);
    }
    const positions = polygon.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
    const normals = polygon.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind);
    const uvs = polygon.getVerticesData((0, $b4i1f.VertexBuffer).UVKind);
    const indices = polygon.getIndices();
    const startIndex = positions.length / 9;
    let disp = 0;
    let distX = 0;
    let distZ = 0;
    let dist = 0;
    let totalLen = 0;
    const cumulate = [
        0
    ];
    if (wrap) for(let idx = startIndex; idx < positions.length / 3; idx += 4){
        distX = positions[3 * (idx + 2)] - positions[3 * idx];
        distZ = positions[3 * (idx + 2) + 2] - positions[3 * idx + 2];
        dist = Math.sqrt(distX * distX + distZ * distZ);
        totalLen += dist;
        cumulate.push(totalLen);
    }
    // set face colours and textures
    let idx = 0;
    let face = 0;
    for(let index = 0; index < normals.length; index += 3){
        //Edge Face  no. 1
        if (Math.abs(normals[index + 1]) < 0.001) face = 1;
        //Top Face  no. 0
        if (Math.abs(normals[index + 1] - 1) < 0.001) face = 0;
        //Bottom Face  no. 2
        if (Math.abs(normals[index + 1] + 1) < 0.001) face = 2;
        idx = index / 3;
        if (face === 1) {
            disp = idx - startIndex;
            if (disp % 4 < 1.5) {
                if (wrap) uvs[2 * idx] = faceUV[face].x + (faceUV[face].z - faceUV[face].x) * cumulate[Math.floor(disp / 4)] / totalLen;
                else uvs[2 * idx] = faceUV[face].x;
            } else if (wrap) uvs[2 * idx] = faceUV[face].x + (faceUV[face].z - faceUV[face].x) * cumulate[Math.floor(disp / 4) + 1] / totalLen;
            else uvs[2 * idx] = faceUV[face].z;
            if (disp % 2 === 0) uvs[2 * idx + 1] = (0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? 1.0 - faceUV[face].w : faceUV[face].w;
            else uvs[2 * idx + 1] = (0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? 1.0 - faceUV[face].y : faceUV[face].y;
        } else {
            uvs[2 * idx] = (1 - uvs[2 * idx]) * faceUV[face].x + uvs[2 * idx] * faceUV[face].z;
            uvs[2 * idx + 1] = (1 - uvs[2 * idx + 1]) * faceUV[face].y + uvs[2 * idx + 1] * faceUV[face].w;
            if ((0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV) uvs[2 * idx + 1] = 1.0 - uvs[2 * idx + 1];
        }
        if (faceColors) colors.push(faceColors[face].r, faceColors[face].g, faceColors[face].b, faceColors[face].a);
    }
    // sides
    (0, $5v6ry.VertexData)._ComputeSides(sideOrientation, positions, indices, normals, uvs, frontUVs, backUVs);
    // Result
    const vertexData = new (0, $5v6ry.VertexData)();
    vertexData.indices = indices;
    vertexData.positions = positions;
    vertexData.normals = normals;
    vertexData.uvs = uvs;
    if (faceColors) {
        const totalColors = sideOrientation === (0, $5v6ry.VertexData).DOUBLESIDE ? colors.concat(colors) : colors;
        vertexData.colors = totalColors;
    }
    return vertexData;
}
function $74fbaf67623e82ac$export$2076f2784b460eb2(name, options, scene = null, earcutInjection = earcut) {
    options.sideOrientation = (0, $fbuqw.Mesh)._GetDefaultSideOrientation(options.sideOrientation);
    const shape = options.shape;
    const holes = options.holes || [];
    const depth = options.depth || 0;
    const smoothingThreshold = options.smoothingThreshold || 2;
    const contours = [];
    let hole = [];
    for(let i = 0; i < shape.length; i++)contours[i] = new (0, $ha1VO.Vector2)(shape[i].x, shape[i].z);
    const epsilon = 0.00000001;
    if (contours[0].equalsWithEpsilon(contours[contours.length - 1], epsilon)) contours.pop();
    const polygonTriangulation = new (0, $a4MLb.PolygonMeshBuilder)(name, contours, scene || (0, $ejQPp.EngineStore).LastCreatedScene, earcutInjection);
    for(let hNb = 0; hNb < holes.length; hNb++){
        hole = [];
        for(let hPoint = 0; hPoint < holes[hNb].length; hPoint++)hole.push(new (0, $ha1VO.Vector2)(holes[hNb][hPoint].x, holes[hNb][hPoint].z));
        polygonTriangulation.addHole(hole);
    }
    //updatability is set during applyToMesh; setting to true in triangulation build produces errors
    const polygon = polygonTriangulation.build(false, depth, smoothingThreshold);
    polygon._originalBuilderSideOrientation = options.sideOrientation;
    const vertexData = $74fbaf67623e82ac$export$8b0a0fcd41a39f4b(polygon, options.sideOrientation, options.faceUV, options.faceColors, options.frontUVs, options.backUVs, options.wrap);
    vertexData.applyToMesh(polygon, options.updatable);
    return polygon;
}
function $74fbaf67623e82ac$export$7ab7ef8f70a7afeb(name, options, scene = null, earcutInjection = earcut) {
    return $74fbaf67623e82ac$export$2076f2784b460eb2(name, options, scene, earcutInjection);
}
const $74fbaf67623e82ac$export$ab2e43fdbfddd162 = {
    ExtrudePolygon: $74fbaf67623e82ac$export$7ab7ef8f70a7afeb,
    CreatePolygon: $74fbaf67623e82ac$export$2076f2784b460eb2
};
(0, $5v6ry.VertexData).CreatePolygon = $74fbaf67623e82ac$export$8b0a0fcd41a39f4b;
(0, $fbuqw.Mesh).CreatePolygon = (name, shape, scene, holes, updatable, sideOrientation, earcutInjection = earcut)=>{
    const options = {
        shape: shape,
        holes: holes,
        updatable: updatable,
        sideOrientation: sideOrientation
    };
    return $74fbaf67623e82ac$export$2076f2784b460eb2(name, options, scene, earcutInjection);
};
(0, $fbuqw.Mesh).ExtrudePolygon = (name, shape, depth, scene, holes, updatable, sideOrientation, earcutInjection = earcut)=>{
    const options = {
        shape: shape,
        holes: holes,
        depth: depth,
        updatable: updatable,
        sideOrientation: sideOrientation
    };
    return $74fbaf67623e82ac$export$7ab7ef8f70a7afeb(name, options, scene, earcutInjection);
};

});
parcelRegister("a4MLb", function(module, exports) {

$parcel$export(module.exports, "Polygon", () => $756019cf1144be99$export$7d31b617c820d435);
$parcel$export(module.exports, "PolygonMeshBuilder", () => $756019cf1144be99$export$b8a40edac54f9787);

var $kVtWi = parcelRequire("kVtWi");

var $ha1VO = parcelRequire("ha1VO");

var $b4i1f = parcelRequire("b4i1f");

var $fbuqw = parcelRequire("fbuqw");

var $5v6ry = parcelRequire("5v6ry");

var $fm2C6 = parcelRequire("fm2C6");

var $53VPf = parcelRequire("53VPf");

var $ejQPp = parcelRequire("ejQPp");
/**
 * Vector2 wth index property
 */ class $756019cf1144be99$var$IndexedVector2 extends (0, $ha1VO.Vector2) {
    constructor(original, /** Index of the vector2 */ index){
        super(original.x, original.y);
        this.index = index;
    }
}
/**
 * Defines points to create a polygon
 */ class $756019cf1144be99$var$PolygonPoints {
    constructor(){
        this.elements = [];
    }
    add(originalPoints) {
        const result = [];
        originalPoints.forEach((point)=>{
            const newPoint = new $756019cf1144be99$var$IndexedVector2(point, this.elements.length);
            result.push(newPoint);
            this.elements.push(newPoint);
        });
        return result;
    }
    computeBounds() {
        const lmin = new (0, $ha1VO.Vector2)(this.elements[0].x, this.elements[0].y);
        const lmax = new (0, $ha1VO.Vector2)(this.elements[0].x, this.elements[0].y);
        this.elements.forEach((point)=>{
            // x
            if (point.x < lmin.x) lmin.x = point.x;
            else if (point.x > lmax.x) lmax.x = point.x;
            // y
            if (point.y < lmin.y) lmin.y = point.y;
            else if (point.y > lmax.y) lmax.y = point.y;
        });
        return {
            min: lmin,
            max: lmax,
            width: lmax.x - lmin.x,
            height: lmax.y - lmin.y
        };
    }
}
class $756019cf1144be99$export$7d31b617c820d435 {
    /**
     * Creates a rectangle
     * @param xmin bottom X coord
     * @param ymin bottom Y coord
     * @param xmax top X coord
     * @param ymax top Y coord
     * @returns points that make the resulting rectangle
     */ static Rectangle(xmin, ymin, xmax, ymax) {
        return [
            new (0, $ha1VO.Vector2)(xmin, ymin),
            new (0, $ha1VO.Vector2)(xmax, ymin),
            new (0, $ha1VO.Vector2)(xmax, ymax),
            new (0, $ha1VO.Vector2)(xmin, ymax)
        ];
    }
    /**
     * Creates a circle
     * @param radius radius of circle
     * @param cx scale in x
     * @param cy scale in y
     * @param numberOfSides number of sides that make up the circle
     * @returns points that make the resulting circle
     */ static Circle(radius, cx = 0, cy = 0, numberOfSides = 32) {
        const result = [];
        let angle = 0;
        const increment = Math.PI * 2 / numberOfSides;
        for(let i = 0; i < numberOfSides; i++){
            result.push(new (0, $ha1VO.Vector2)(cx + Math.cos(angle) * radius, cy + Math.sin(angle) * radius));
            angle -= increment;
        }
        return result;
    }
    /**
     * Creates a polygon from input string
     * @param input Input polygon data
     * @returns the parsed points
     */ static Parse(input) {
        const floats = input.split(/[^-+eE.\d]+/).map(parseFloat).filter((val)=>!isNaN(val));
        let i;
        const result = [];
        for(i = 0; i < (floats.length & 0x7ffffffe); i += 2)result.push(new (0, $ha1VO.Vector2)(floats[i], floats[i + 1]));
        return result;
    }
    /**
     * Starts building a polygon from x and y coordinates
     * @param x x coordinate
     * @param y y coordinate
     * @returns the started path2
     */ static StartingAt(x, y) {
        return (0, $fm2C6.Path2).StartingAt(x, y);
    }
}
class $756019cf1144be99$export$b8a40edac54f9787 {
    _addToepoint(points) {
        for (const p of points)this._epoints.push(p.x, p.y);
    }
    /**
     * Creates a PolygonMeshBuilder
     * @param name name of the builder
     * @param contours Path of the polygon
     * @param scene scene to add to when creating the mesh
     * @param earcutInjection can be used to inject your own earcut reference
     */ constructor(name, contours, scene, earcutInjection = earcut){
        this._points = new $756019cf1144be99$var$PolygonPoints();
        this._outlinepoints = new $756019cf1144be99$var$PolygonPoints();
        this._holes = new Array();
        this._epoints = new Array();
        this._eholes = new Array();
        this.bjsEarcut = earcutInjection;
        this._name = name;
        this._scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        let points;
        if (contours instanceof (0, $fm2C6.Path2)) points = contours.getPoints();
        else points = contours;
        this._addToepoint(points);
        this._points.add(points);
        this._outlinepoints.add(points);
        if (typeof this.bjsEarcut === "undefined") (0, $kVtWi.Logger).Warn("Earcut was not found, the polygon will not be built.");
    }
    /**
     * Adds a hole within the polygon
     * @param hole Array of points defining the hole
     * @returns this
     */ addHole(hole) {
        this._points.add(hole);
        const holepoints = new $756019cf1144be99$var$PolygonPoints();
        holepoints.add(hole);
        this._holes.push(holepoints);
        this._eholes.push(this._epoints.length / 2);
        this._addToepoint(hole);
        return this;
    }
    /**
     * Creates the polygon
     * @param updatable If the mesh should be updatable
     * @param depth The depth of the mesh created
     * @param smoothingThreshold Dot product threshold for smoothed normals
     * @returns the created mesh
     */ build(updatable = false, depth = 0, smoothingThreshold = 2) {
        const result = new (0, $fbuqw.Mesh)(this._name, this._scene);
        const vertexData = this.buildVertexData(depth, smoothingThreshold);
        result.setVerticesData((0, $b4i1f.VertexBuffer).PositionKind, vertexData.positions, updatable);
        result.setVerticesData((0, $b4i1f.VertexBuffer).NormalKind, vertexData.normals, updatable);
        result.setVerticesData((0, $b4i1f.VertexBuffer).UVKind, vertexData.uvs, updatable);
        result.setIndices(vertexData.indices);
        return result;
    }
    /**
     * Creates the polygon
     * @param depth The depth of the mesh created
     * @param smoothingThreshold Dot product threshold for smoothed normals
     * @returns the created VertexData
     */ buildVertexData(depth = 0, smoothingThreshold = 2) {
        const result = new (0, $5v6ry.VertexData)();
        const normals = [];
        const positions = [];
        const uvs = [];
        const bounds = this._points.computeBounds();
        this._points.elements.forEach((p)=>{
            normals.push(0, 1.0, 0);
            positions.push(p.x, 0, p.y);
            uvs.push((p.x - bounds.min.x) / bounds.width, (p.y - bounds.min.y) / bounds.height);
        });
        const indices = [];
        const res = this.bjsEarcut(this._epoints, this._eholes, 2);
        for(let i = 0; i < res.length; i++)indices.push(res[i]);
        if (depth > 0) {
            const positionscount = positions.length / 3; //get the current pointcount
            this._points.elements.forEach((p)=>{
                //add the elements at the depth
                normals.push(0, -1, 0);
                positions.push(p.x, -depth, p.y);
                uvs.push(1 - (p.x - bounds.min.x) / bounds.width, 1 - (p.y - bounds.min.y) / bounds.height);
            });
            const totalCount = indices.length;
            for(let i = 0; i < totalCount; i += 3){
                const i0 = indices[i + 0];
                const i1 = indices[i + 1];
                const i2 = indices[i + 2];
                indices.push(i2 + positionscount);
                indices.push(i1 + positionscount);
                indices.push(i0 + positionscount);
            }
            //Add the sides
            this._addSide(positions, normals, uvs, indices, bounds, this._outlinepoints, depth, false, smoothingThreshold);
            this._holes.forEach((hole)=>{
                this._addSide(positions, normals, uvs, indices, bounds, hole, depth, true, smoothingThreshold);
            });
        }
        result.indices = indices;
        result.positions = positions;
        result.normals = normals;
        result.uvs = uvs;
        return result;
    }
    /**
     * Adds a side to the polygon
     * @param positions points that make the polygon
     * @param normals normals of the polygon
     * @param uvs uvs of the polygon
     * @param indices indices of the polygon
     * @param bounds bounds of the polygon
     * @param points points of the polygon
     * @param depth depth of the polygon
     * @param flip flip of the polygon
     * @param smoothingThreshold
     */ _addSide(positions, normals, uvs, indices, bounds, points, depth, flip, smoothingThreshold) {
        let startIndex = positions.length / 3;
        let ulength = 0;
        for(let i = 0; i < points.elements.length; i++){
            const p = points.elements[i];
            const p1 = points.elements[(i + 1) % points.elements.length];
            positions.push(p.x, 0, p.y);
            positions.push(p.x, -depth, p.y);
            positions.push(p1.x, 0, p1.y);
            positions.push(p1.x, -depth, p1.y);
            const p0 = points.elements[(i + points.elements.length - 1) % points.elements.length];
            const p2 = points.elements[(i + 2) % points.elements.length];
            let vc = new (0, $ha1VO.Vector3)(-(p1.y - p.y), 0, p1.x - p.x);
            let vp = new (0, $ha1VO.Vector3)(-(p.y - p0.y), 0, p.x - p0.x);
            let vn = new (0, $ha1VO.Vector3)(-(p2.y - p1.y), 0, p2.x - p1.x);
            if (!flip) {
                vc = vc.scale(-1);
                vp = vp.scale(-1);
                vn = vn.scale(-1);
            }
            const vc_norm = vc.normalizeToNew();
            let vp_norm = vp.normalizeToNew();
            let vn_norm = vn.normalizeToNew();
            const dotp = (0, $ha1VO.Vector3).Dot(vp_norm, vc_norm);
            if (dotp > smoothingThreshold) {
                if (dotp < (0, $53VPf.Epsilon) - 1) vp_norm = new (0, $ha1VO.Vector3)(p.x, 0, p.y).subtract(new (0, $ha1VO.Vector3)(p1.x, 0, p1.y)).normalize();
                else // cheap average weighed by side length
                vp_norm = vp.add(vc).normalize();
            } else vp_norm = vc_norm;
            const dotn = (0, $ha1VO.Vector3).Dot(vn, vc);
            if (dotn > smoothingThreshold) {
                if (dotn < (0, $53VPf.Epsilon) - 1) // back to back
                vn_norm = new (0, $ha1VO.Vector3)(p1.x, 0, p1.y).subtract(new (0, $ha1VO.Vector3)(p.x, 0, p.y)).normalize();
                else // cheap average weighed by side length
                vn_norm = vn.add(vc).normalize();
            } else vn_norm = vc_norm;
            uvs.push(ulength / bounds.width, 0);
            uvs.push(ulength / bounds.width, 1);
            ulength += vc.length();
            uvs.push(ulength / bounds.width, 0);
            uvs.push(ulength / bounds.width, 1);
            normals.push(vp_norm.x, vp_norm.y, vp_norm.z);
            normals.push(vp_norm.x, vp_norm.y, vp_norm.z);
            normals.push(vn_norm.x, vn_norm.y, vn_norm.z);
            normals.push(vn_norm.x, vn_norm.y, vn_norm.z);
            if (!flip) {
                indices.push(startIndex);
                indices.push(startIndex + 1);
                indices.push(startIndex + 2);
                indices.push(startIndex + 1);
                indices.push(startIndex + 3);
                indices.push(startIndex + 2);
            } else {
                indices.push(startIndex);
                indices.push(startIndex + 2);
                indices.push(startIndex + 1);
                indices.push(startIndex + 1);
                indices.push(startIndex + 2);
                indices.push(startIndex + 3);
            }
            startIndex += 4;
        }
    }
}

});


parcelRegister("l411O", function(module, exports) {

$parcel$export(module.exports, "ExtrudeShape", () => $f55ac4e07ca7f06f$export$154977f2a337af53);
$parcel$export(module.exports, "ExtrudeShapeCustom", () => $f55ac4e07ca7f06f$export$a1fecad8b97fcfc3);
$parcel$export(module.exports, "ShapeBuilder", () => $f55ac4e07ca7f06f$export$db37cc886555ba45);

var $ha1VO = parcelRequire("ha1VO");

var $fbuqw = parcelRequire("fbuqw");

var $aFflY = parcelRequire("aFflY");

var $fm2C6 = parcelRequire("fm2C6");
function $f55ac4e07ca7f06f$export$154977f2a337af53(name, options, scene = null) {
    const path = options.path;
    const shape = options.shape;
    const scale = options.scale || 1;
    const rotation = options.rotation || 0;
    const cap = options.cap === 0 ? 0 : options.cap || (0, $fbuqw.Mesh).NO_CAP;
    const updatable = options.updatable;
    const sideOrientation = (0, $fbuqw.Mesh)._GetDefaultSideOrientation(options.sideOrientation);
    const instance = options.instance || null;
    const invertUV = options.invertUV || false;
    const closeShape = options.closeShape || false;
    const closePath = options.closePath || false;
    return $f55ac4e07ca7f06f$var$_ExtrudeShapeGeneric(name, shape, path, scale, rotation, null, null, closePath, closeShape, cap, false, scene, updatable ? true : false, sideOrientation, instance, invertUV, options.frontUVs || null, options.backUVs || null, options.firstNormal || null, options.adjustFrame ? true : false);
}
function $f55ac4e07ca7f06f$export$a1fecad8b97fcfc3(name, options, scene = null) {
    const path = options.path;
    const shape = options.shape;
    const scaleFunction = options.scaleFunction || (()=>{
        return 1;
    });
    const rotationFunction = options.rotationFunction || (()=>{
        return 0;
    });
    const ribbonCloseArray = options.closePath || options.ribbonCloseArray || false;
    const ribbonClosePath = options.closeShape || options.ribbonClosePath || false;
    const cap = options.cap === 0 ? 0 : options.cap || (0, $fbuqw.Mesh).NO_CAP;
    const updatable = options.updatable;
    const firstNormal = options.firstNormal || null;
    const adjustFrame = options.adjustFrame || false;
    const sideOrientation = (0, $fbuqw.Mesh)._GetDefaultSideOrientation(options.sideOrientation);
    const instance = options.instance;
    const invertUV = options.invertUV || false;
    return $f55ac4e07ca7f06f$var$_ExtrudeShapeGeneric(name, shape, path, null, null, scaleFunction, rotationFunction, ribbonCloseArray, ribbonClosePath, cap, true, scene, updatable ? true : false, sideOrientation, instance || null, invertUV, options.frontUVs || null, options.backUVs || null, firstNormal, adjustFrame);
}
function $f55ac4e07ca7f06f$var$_ExtrudeShapeGeneric(name, shape, curve, scale, rotation, scaleFunction, rotateFunction, rbCA, rbCP, cap, custom, scene, updtbl, side, instance, invertUV, frontUVs, backUVs, firstNormal, adjustFrame) {
    // extrusion geometry
    const extrusionPathArray = (shape, curve, path3D, shapePaths, scale, rotation, scaleFunction, rotateFunction, cap, custom, adjustFrame)=>{
        const tangents = path3D.getTangents();
        const normals = path3D.getNormals();
        const binormals = path3D.getBinormals();
        const distances = path3D.getDistances();
        if (adjustFrame) /* fix tangents,normals, binormals */ for(let i = 0; i < tangents.length; i++){
            if (tangents[i].x == 0 && tangents[i].y == 0 && tangents[i].z == 0) tangents[i].copyFrom(tangents[i - 1]);
            if (normals[i].x == 0 && normals[i].y == 0 && normals[i].z == 0) normals[i].copyFrom(normals[i - 1]);
            if (binormals[i].x == 0 && binormals[i].y == 0 && binormals[i].z == 0) binormals[i].copyFrom(binormals[i - 1]);
            if (i > 0) {
                let v = tangents[i - 1];
                if ((0, $ha1VO.Vector3).Dot(v, tangents[i]) < 0) tangents[i].scaleInPlace(-1);
                v = normals[i - 1];
                if ((0, $ha1VO.Vector3).Dot(v, normals[i]) < 0) normals[i].scaleInPlace(-1);
                v = binormals[i - 1];
                if ((0, $ha1VO.Vector3).Dot(v, binormals[i]) < 0) binormals[i].scaleInPlace(-1);
            }
        }
        let angle = 0;
        const returnScale = ()=>{
            return scale !== null ? scale : 1;
        };
        const returnRotation = ()=>{
            return rotation !== null ? rotation : 0;
        };
        const rotate = custom && rotateFunction ? rotateFunction : returnRotation;
        const scl = custom && scaleFunction ? scaleFunction : returnScale;
        let index = cap === (0, $fbuqw.Mesh).NO_CAP || cap === (0, $fbuqw.Mesh).CAP_END ? 0 : 2;
        const rotationMatrix = (0, $ha1VO.TmpVectors).Matrix[0];
        for(let i = 0; i < curve.length; i++){
            const shapePath = [];
            const angleStep = rotate(i, distances[i]);
            const scaleRatio = scl(i, distances[i]);
            (0, $ha1VO.Matrix).RotationAxisToRef(tangents[i], angle, rotationMatrix);
            for(let p = 0; p < shape.length; p++){
                const planed = tangents[i].scale(shape[p].z).add(normals[i].scale(shape[p].x)).add(binormals[i].scale(shape[p].y));
                const rotated = (0, $ha1VO.Vector3).Zero();
                (0, $ha1VO.Vector3).TransformCoordinatesToRef(planed, rotationMatrix, rotated);
                rotated.scaleInPlace(scaleRatio).addInPlace(curve[i]);
                shapePath[p] = rotated;
            }
            shapePaths[index] = shapePath;
            angle += angleStep;
            index++;
        }
        // cap
        const capPath = (shapePath)=>{
            const pointCap = Array();
            const barycenter = (0, $ha1VO.Vector3).Zero();
            let i;
            for(i = 0; i < shapePath.length; i++)barycenter.addInPlace(shapePath[i]);
            barycenter.scaleInPlace(1.0 / shapePath.length);
            for(i = 0; i < shapePath.length; i++)pointCap.push(barycenter);
            return pointCap;
        };
        switch(cap){
            case (0, $fbuqw.Mesh).NO_CAP:
                break;
            case (0, $fbuqw.Mesh).CAP_START:
                shapePaths[0] = capPath(shapePaths[2]);
                shapePaths[1] = shapePaths[2];
                break;
            case (0, $fbuqw.Mesh).CAP_END:
                shapePaths[index] = shapePaths[index - 1];
                shapePaths[index + 1] = capPath(shapePaths[index - 1]);
                break;
            case (0, $fbuqw.Mesh).CAP_ALL:
                shapePaths[0] = capPath(shapePaths[2]);
                shapePaths[1] = shapePaths[2];
                shapePaths[index] = shapePaths[index - 1];
                shapePaths[index + 1] = capPath(shapePaths[index - 1]);
                break;
            default:
                break;
        }
        return shapePaths;
    };
    let path3D;
    let pathArray;
    if (instance) {
        // instance update
        const storage = instance._creationDataStorage;
        path3D = firstNormal ? storage.path3D.update(curve, firstNormal) : storage.path3D.update(curve);
        pathArray = extrusionPathArray(shape, curve, storage.path3D, storage.pathArray, scale, rotation, scaleFunction, rotateFunction, storage.cap, custom, adjustFrame);
        instance = (0, $aFflY.CreateRibbon)("", {
            pathArray: pathArray,
            closeArray: false,
            closePath: false,
            offset: 0,
            updatable: false,
            sideOrientation: 0,
            instance: instance
        }, scene || undefined);
        return instance;
    }
    // extruded shape creation
    path3D = firstNormal ? new (0, $fm2C6.Path3D)(curve, firstNormal) : new (0, $fm2C6.Path3D)(curve);
    const newShapePaths = new Array();
    cap = cap < 0 || cap > 3 ? 0 : cap;
    pathArray = extrusionPathArray(shape, curve, path3D, newShapePaths, scale, rotation, scaleFunction, rotateFunction, cap, custom, adjustFrame);
    const extrudedGeneric = (0, $aFflY.CreateRibbon)(name, {
        pathArray: pathArray,
        closeArray: rbCA,
        closePath: rbCP,
        updatable: updtbl,
        sideOrientation: side,
        invertUV: invertUV,
        frontUVs: frontUVs || undefined,
        backUVs: backUVs || undefined
    }, scene);
    extrudedGeneric._creationDataStorage.pathArray = pathArray;
    extrudedGeneric._creationDataStorage.path3D = path3D;
    extrudedGeneric._creationDataStorage.cap = cap;
    return extrudedGeneric;
}
const $f55ac4e07ca7f06f$export$db37cc886555ba45 = {
    ExtrudeShape: // eslint-disable-next-line @typescript-eslint/naming-convention
    $f55ac4e07ca7f06f$export$154977f2a337af53,
    ExtrudeShapeCustom: // eslint-disable-next-line @typescript-eslint/naming-convention
    $f55ac4e07ca7f06f$export$a1fecad8b97fcfc3
};
(0, $fbuqw.Mesh).ExtrudeShape = (name, shape, path, scale, rotation, cap, scene = null, updatable, sideOrientation, instance)=>{
    const options = {
        shape: shape,
        path: path,
        scale: scale,
        rotation: rotation,
        cap: cap === 0 ? 0 : cap || (0, $fbuqw.Mesh).NO_CAP,
        sideOrientation: sideOrientation,
        instance: instance,
        updatable: updatable
    };
    return $f55ac4e07ca7f06f$export$154977f2a337af53(name, options, scene);
};
(0, $fbuqw.Mesh).ExtrudeShapeCustom = (name, shape, path, scaleFunction, rotationFunction, ribbonCloseArray, ribbonClosePath, cap, scene, updatable, sideOrientation, instance)=>{
    const options = {
        shape: shape,
        path: path,
        scaleFunction: scaleFunction,
        rotationFunction: rotationFunction,
        ribbonCloseArray: ribbonCloseArray,
        ribbonClosePath: ribbonClosePath,
        cap: cap === 0 ? 0 : cap || (0, $fbuqw.Mesh).NO_CAP,
        sideOrientation: sideOrientation,
        instance: instance,
        updatable: updatable
    };
    return $f55ac4e07ca7f06f$export$a1fecad8b97fcfc3(name, options, scene);
};

});

parcelRegister("g8AI7", function(module, exports) {

$parcel$export(module.exports, "CreateLathe", () => $bbf9dea6106419fd$export$1aa598e2d5431c62);
$parcel$export(module.exports, "LatheBuilder", () => $bbf9dea6106419fd$export$fb6a5c9c9babfdfd);

var $ha1VO = parcelRequire("ha1VO");

var $fbuqw = parcelRequire("fbuqw");

var $aFflY = parcelRequire("aFflY");
function $bbf9dea6106419fd$export$1aa598e2d5431c62(name, options, scene = null) {
    const arc = options.arc ? options.arc <= 0 || options.arc > 1 ? 1.0 : options.arc : 1.0;
    const closed = options.closed === undefined ? true : options.closed;
    const shape = options.shape;
    const radius = options.radius || 1;
    const tessellation = options.tessellation || 64;
    const clip = options.clip || 0;
    const updatable = options.updatable;
    const sideOrientation = (0, $fbuqw.Mesh)._GetDefaultSideOrientation(options.sideOrientation);
    const cap = options.cap || (0, $fbuqw.Mesh).NO_CAP;
    const pi2 = Math.PI * 2;
    const paths = [];
    const invertUV = options.invertUV || false;
    let i = 0;
    let p = 0;
    const step = pi2 / tessellation * arc;
    let rotated;
    let path;
    for(i = 0; i <= tessellation - clip; i++){
        path = [];
        if (cap == (0, $fbuqw.Mesh).CAP_START || cap == (0, $fbuqw.Mesh).CAP_ALL) {
            path.push(new (0, $ha1VO.Vector3)(0, shape[0].y, 0));
            path.push(new (0, $ha1VO.Vector3)(Math.cos(i * step) * shape[0].x * radius, shape[0].y, Math.sin(i * step) * shape[0].x * radius));
        }
        for(p = 0; p < shape.length; p++){
            rotated = new (0, $ha1VO.Vector3)(Math.cos(i * step) * shape[p].x * radius, shape[p].y, Math.sin(i * step) * shape[p].x * radius);
            path.push(rotated);
        }
        if (cap == (0, $fbuqw.Mesh).CAP_END || cap == (0, $fbuqw.Mesh).CAP_ALL) {
            path.push(new (0, $ha1VO.Vector3)(Math.cos(i * step) * shape[shape.length - 1].x * radius, shape[shape.length - 1].y, Math.sin(i * step) * shape[shape.length - 1].x * radius));
            path.push(new (0, $ha1VO.Vector3)(0, shape[shape.length - 1].y, 0));
        }
        paths.push(path);
    }
    // lathe ribbon
    const lathe = (0, $aFflY.CreateRibbon)(name, {
        pathArray: paths,
        closeArray: closed,
        sideOrientation: sideOrientation,
        updatable: updatable,
        invertUV: invertUV,
        frontUVs: options.frontUVs,
        backUVs: options.backUVs
    }, scene);
    return lathe;
}
const $bbf9dea6106419fd$export$fb6a5c9c9babfdfd = {
    CreateLathe: // eslint-disable-next-line @typescript-eslint/naming-convention
    $bbf9dea6106419fd$export$1aa598e2d5431c62
};
(0, $fbuqw.Mesh).CreateLathe = (name, shape, radius, tessellation, scene, updatable, sideOrientation)=>{
    const options = {
        shape: shape,
        radius: radius,
        tessellation: tessellation,
        sideOrientation: sideOrientation,
        updatable: updatable
    };
    return $bbf9dea6106419fd$export$1aa598e2d5431c62(name, options, scene);
};

});

parcelRegister("4gG1w", function(module, exports) {

$parcel$export(module.exports, "CreateTube", () => $31b9410618830924$export$e35b4d126241f338);
$parcel$export(module.exports, "TubeBuilder", () => $31b9410618830924$export$b20f6b29ce4ae5fc);

var $ha1VO = parcelRequire("ha1VO");

var $fbuqw = parcelRequire("fbuqw");

var $aFflY = parcelRequire("aFflY");

var $fm2C6 = parcelRequire("fm2C6");
function $31b9410618830924$export$e35b4d126241f338(name, options, scene = null) {
    const path = options.path;
    let instance = options.instance;
    let radius = 1.0;
    if (options.radius !== undefined) radius = options.radius;
    else if (instance) radius = instance._creationDataStorage.radius;
    const tessellation = options.tessellation || 64;
    const radiusFunction = options.radiusFunction || null;
    let cap = options.cap || (0, $fbuqw.Mesh).NO_CAP;
    const invertUV = options.invertUV || false;
    const updatable = options.updatable;
    const sideOrientation = (0, $fbuqw.Mesh)._GetDefaultSideOrientation(options.sideOrientation);
    options.arc = options.arc && (options.arc <= 0.0 || options.arc > 1.0) ? 1.0 : options.arc || 1.0;
    // tube geometry
    const tubePathArray = (path, path3D, circlePaths, radius, tessellation, radiusFunction, cap, arc)=>{
        const tangents = path3D.getTangents();
        const normals = path3D.getNormals();
        const distances = path3D.getDistances();
        const pi2 = Math.PI * 2;
        const step = pi2 / tessellation * arc;
        const returnRadius = ()=>radius;
        const radiusFunctionFinal = radiusFunction || returnRadius;
        let circlePath;
        let rad;
        let normal;
        let rotated;
        const rotationMatrix = (0, $ha1VO.TmpVectors).Matrix[0];
        let index = cap === (0, $fbuqw.Mesh).NO_CAP || cap === (0, $fbuqw.Mesh).CAP_END ? 0 : 2;
        for(let i = 0; i < path.length; i++){
            rad = radiusFunctionFinal(i, distances[i]); // current radius
            circlePath = Array(); // current circle array
            normal = normals[i]; // current normal
            for(let t = 0; t < tessellation; t++){
                (0, $ha1VO.Matrix).RotationAxisToRef(tangents[i], step * t, rotationMatrix);
                rotated = circlePath[t] ? circlePath[t] : (0, $ha1VO.Vector3).Zero();
                (0, $ha1VO.Vector3).TransformCoordinatesToRef(normal, rotationMatrix, rotated);
                rotated.scaleInPlace(rad).addInPlace(path[i]);
                circlePath[t] = rotated;
            }
            circlePaths[index] = circlePath;
            index++;
        }
        // cap
        const capPath = (nbPoints, pathIndex)=>{
            const pointCap = Array();
            for(let i = 0; i < nbPoints; i++)pointCap.push(path[pathIndex]);
            return pointCap;
        };
        switch(cap){
            case (0, $fbuqw.Mesh).NO_CAP:
                break;
            case (0, $fbuqw.Mesh).CAP_START:
                circlePaths[0] = capPath(tessellation, 0);
                circlePaths[1] = circlePaths[2].slice(0);
                break;
            case (0, $fbuqw.Mesh).CAP_END:
                circlePaths[index] = circlePaths[index - 1].slice(0);
                circlePaths[index + 1] = capPath(tessellation, path.length - 1);
                break;
            case (0, $fbuqw.Mesh).CAP_ALL:
                circlePaths[0] = capPath(tessellation, 0);
                circlePaths[1] = circlePaths[2].slice(0);
                circlePaths[index] = circlePaths[index - 1].slice(0);
                circlePaths[index + 1] = capPath(tessellation, path.length - 1);
                break;
            default:
                break;
        }
        return circlePaths;
    };
    let path3D;
    let pathArray;
    if (instance) {
        // tube update
        const storage = instance._creationDataStorage;
        const arc = options.arc || storage.arc;
        path3D = storage.path3D.update(path);
        pathArray = tubePathArray(path, path3D, storage.pathArray, radius, storage.tessellation, radiusFunction, storage.cap, arc);
        instance = (0, $aFflY.CreateRibbon)("", {
            pathArray: pathArray,
            instance: instance
        });
        // Update mode, no need to recreate the storage.
        storage.path3D = path3D;
        storage.pathArray = pathArray;
        storage.arc = arc;
        storage.radius = radius;
        return instance;
    }
    // tube creation
    path3D = new (0, $fm2C6.Path3D)(path);
    const newPathArray = new Array();
    cap = cap < 0 || cap > 3 ? 0 : cap;
    pathArray = tubePathArray(path, path3D, newPathArray, radius, tessellation, radiusFunction, cap, options.arc);
    const tube = (0, $aFflY.CreateRibbon)(name, {
        pathArray: pathArray,
        closePath: true,
        closeArray: false,
        updatable: updatable,
        sideOrientation: sideOrientation,
        invertUV: invertUV,
        frontUVs: options.frontUVs,
        backUVs: options.backUVs
    }, scene);
    tube._creationDataStorage.pathArray = pathArray;
    tube._creationDataStorage.path3D = path3D;
    tube._creationDataStorage.tessellation = tessellation;
    tube._creationDataStorage.cap = cap;
    tube._creationDataStorage.arc = options.arc;
    tube._creationDataStorage.radius = radius;
    return tube;
}
const $31b9410618830924$export$b20f6b29ce4ae5fc = {
    CreateTube: // eslint-disable-next-line @typescript-eslint/naming-convention
    $31b9410618830924$export$e35b4d126241f338
};
(0, $fbuqw.Mesh).CreateTube = (name, path, radius, tessellation, radiusFunction, cap, scene, updatable, sideOrientation, instance)=>{
    const options = {
        path: path,
        radius: radius,
        tessellation: tessellation,
        radiusFunction: radiusFunction,
        arc: 1,
        cap: cap,
        updatable: updatable,
        sideOrientation: sideOrientation,
        instance: instance
    };
    return $31b9410618830924$export$e35b4d126241f338(name, options, scene);
};

});

parcelRegister("2vSVS", function(module, exports) {

$parcel$export(module.exports, "CreatePolyhedronVertexData", () => $1d49167c5ec927a7$export$c72e10f5a1c9dc82);
$parcel$export(module.exports, "CreatePolyhedron", () => $1d49167c5ec927a7$export$1cb5c9516e55bfc7);
$parcel$export(module.exports, "PolyhedronBuilder", () => $1d49167c5ec927a7$export$ccaedb7c99deedc1);

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $fbuqw = parcelRequire("fbuqw");

var $5v6ry = parcelRequire("5v6ry");

var $fGXjI = parcelRequire("fGXjI");
function $1d49167c5ec927a7$export$c72e10f5a1c9dc82(options) {
    // provided polyhedron types :
    // 0 : Tetrahedron, 1 : Octahedron, 2 : Dodecahedron, 3 : Icosahedron, 4 : Rhombicuboctahedron, 5 : Triangular Prism, 6 : Pentagonal Prism, 7 : Hexagonal Prism, 8 : Square Pyramid (J1)
    // 9 : Pentagonal Pyramid (J2), 10 : Triangular Dipyramid (J12), 11 : Pentagonal Dipyramid (J13), 12 : Elongated Square Dipyramid (J15), 13 : Elongated Pentagonal Dipyramid (J16), 14 : Elongated Pentagonal Cupola (J20)
    const polyhedra = [];
    polyhedra[0] = {
        vertex: [
            [
                0,
                0,
                1.732051
            ],
            [
                1.632993,
                0,
                -0.5773503
            ],
            [
                -0.8164966,
                1.414214,
                -0.5773503
            ],
            [
                -0.8164966,
                -1.414214,
                -0.5773503
            ]
        ],
        face: [
            [
                0,
                1,
                2
            ],
            [
                0,
                2,
                3
            ],
            [
                0,
                3,
                1
            ],
            [
                1,
                3,
                2
            ]
        ]
    };
    polyhedra[1] = {
        vertex: [
            [
                0,
                0,
                1.414214
            ],
            [
                1.414214,
                0,
                0
            ],
            [
                0,
                1.414214,
                0
            ],
            [
                -1.414214,
                0,
                0
            ],
            [
                0,
                -1.414214,
                0
            ],
            [
                0,
                0,
                -1.414214
            ]
        ],
        face: [
            [
                0,
                1,
                2
            ],
            [
                0,
                2,
                3
            ],
            [
                0,
                3,
                4
            ],
            [
                0,
                4,
                1
            ],
            [
                1,
                4,
                5
            ],
            [
                1,
                5,
                2
            ],
            [
                2,
                5,
                3
            ],
            [
                3,
                5,
                4
            ]
        ]
    };
    polyhedra[2] = {
        vertex: [
            [
                0,
                0,
                1.070466
            ],
            [
                0.7136442,
                0,
                0.7978784
            ],
            [
                -0.3568221,
                0.618034,
                0.7978784
            ],
            [
                -0.3568221,
                -0.618034,
                0.7978784
            ],
            [
                0.7978784,
                0.618034,
                0.3568221
            ],
            [
                0.7978784,
                -0.618034,
                0.3568221
            ],
            [
                -0.9341724,
                0.381966,
                0.3568221
            ],
            [
                0.1362939,
                1,
                0.3568221
            ],
            [
                0.1362939,
                -1,
                0.3568221
            ],
            [
                -0.9341724,
                -0.381966,
                0.3568221
            ],
            [
                0.9341724,
                0.381966,
                -0.3568221
            ],
            [
                0.9341724,
                -0.381966,
                -0.3568221
            ],
            [
                -0.7978784,
                0.618034,
                -0.3568221
            ],
            [
                -0.1362939,
                1,
                -0.3568221
            ],
            [
                -0.1362939,
                -1,
                -0.3568221
            ],
            [
                -0.7978784,
                -0.618034,
                -0.3568221
            ],
            [
                0.3568221,
                0.618034,
                -0.7978784
            ],
            [
                0.3568221,
                -0.618034,
                -0.7978784
            ],
            [
                -0.7136442,
                0,
                -0.7978784
            ],
            [
                0,
                0,
                -1.070466
            ]
        ],
        face: [
            [
                0,
                1,
                4,
                7,
                2
            ],
            [
                0,
                2,
                6,
                9,
                3
            ],
            [
                0,
                3,
                8,
                5,
                1
            ],
            [
                1,
                5,
                11,
                10,
                4
            ],
            [
                2,
                7,
                13,
                12,
                6
            ],
            [
                3,
                9,
                15,
                14,
                8
            ],
            [
                4,
                10,
                16,
                13,
                7
            ],
            [
                5,
                8,
                14,
                17,
                11
            ],
            [
                6,
                12,
                18,
                15,
                9
            ],
            [
                10,
                11,
                17,
                19,
                16
            ],
            [
                12,
                13,
                16,
                19,
                18
            ],
            [
                14,
                15,
                18,
                19,
                17
            ]
        ]
    };
    polyhedra[3] = {
        vertex: [
            [
                0,
                0,
                1.175571
            ],
            [
                1.051462,
                0,
                0.5257311
            ],
            [
                0.3249197,
                1,
                0.5257311
            ],
            [
                -0.8506508,
                0.618034,
                0.5257311
            ],
            [
                -0.8506508,
                -0.618034,
                0.5257311
            ],
            [
                0.3249197,
                -1,
                0.5257311
            ],
            [
                0.8506508,
                0.618034,
                -0.5257311
            ],
            [
                0.8506508,
                -0.618034,
                -0.5257311
            ],
            [
                -0.3249197,
                1,
                -0.5257311
            ],
            [
                -1.051462,
                0,
                -0.5257311
            ],
            [
                -0.3249197,
                -1,
                -0.5257311
            ],
            [
                0,
                0,
                -1.175571
            ]
        ],
        face: [
            [
                0,
                1,
                2
            ],
            [
                0,
                2,
                3
            ],
            [
                0,
                3,
                4
            ],
            [
                0,
                4,
                5
            ],
            [
                0,
                5,
                1
            ],
            [
                1,
                5,
                7
            ],
            [
                1,
                7,
                6
            ],
            [
                1,
                6,
                2
            ],
            [
                2,
                6,
                8
            ],
            [
                2,
                8,
                3
            ],
            [
                3,
                8,
                9
            ],
            [
                3,
                9,
                4
            ],
            [
                4,
                9,
                10
            ],
            [
                4,
                10,
                5
            ],
            [
                5,
                10,
                7
            ],
            [
                6,
                7,
                11
            ],
            [
                6,
                11,
                8
            ],
            [
                7,
                10,
                11
            ],
            [
                8,
                11,
                9
            ],
            [
                9,
                11,
                10
            ]
        ]
    };
    polyhedra[4] = {
        vertex: [
            [
                0,
                0,
                1.070722
            ],
            [
                0.7148135,
                0,
                0.7971752
            ],
            [
                -0.104682,
                0.7071068,
                0.7971752
            ],
            [
                -0.6841528,
                0.2071068,
                0.7971752
            ],
            [
                -0.104682,
                -0.7071068,
                0.7971752
            ],
            [
                0.6101315,
                0.7071068,
                0.5236279
            ],
            [
                1.04156,
                0.2071068,
                0.1367736
            ],
            [
                0.6101315,
                -0.7071068,
                0.5236279
            ],
            [
                -0.3574067,
                1,
                0.1367736
            ],
            [
                -0.7888348,
                -0.5,
                0.5236279
            ],
            [
                -0.9368776,
                0.5,
                0.1367736
            ],
            [
                -0.3574067,
                -1,
                0.1367736
            ],
            [
                0.3574067,
                1,
                -0.1367736
            ],
            [
                0.9368776,
                -0.5,
                -0.1367736
            ],
            [
                0.7888348,
                0.5,
                -0.5236279
            ],
            [
                0.3574067,
                -1,
                -0.1367736
            ],
            [
                -0.6101315,
                0.7071068,
                -0.5236279
            ],
            [
                -1.04156,
                -0.2071068,
                -0.1367736
            ],
            [
                -0.6101315,
                -0.7071068,
                -0.5236279
            ],
            [
                0.104682,
                0.7071068,
                -0.7971752
            ],
            [
                0.6841528,
                -0.2071068,
                -0.7971752
            ],
            [
                0.104682,
                -0.7071068,
                -0.7971752
            ],
            [
                -0.7148135,
                0,
                -0.7971752
            ],
            [
                0,
                0,
                -1.070722
            ]
        ],
        face: [
            [
                0,
                2,
                3
            ],
            [
                1,
                6,
                5
            ],
            [
                4,
                9,
                11
            ],
            [
                7,
                15,
                13
            ],
            [
                8,
                16,
                10
            ],
            [
                12,
                14,
                19
            ],
            [
                17,
                22,
                18
            ],
            [
                20,
                21,
                23
            ],
            [
                0,
                1,
                5,
                2
            ],
            [
                0,
                3,
                9,
                4
            ],
            [
                0,
                4,
                7,
                1
            ],
            [
                1,
                7,
                13,
                6
            ],
            [
                2,
                5,
                12,
                8
            ],
            [
                2,
                8,
                10,
                3
            ],
            [
                3,
                10,
                17,
                9
            ],
            [
                4,
                11,
                15,
                7
            ],
            [
                5,
                6,
                14,
                12
            ],
            [
                6,
                13,
                20,
                14
            ],
            [
                8,
                12,
                19,
                16
            ],
            [
                9,
                17,
                18,
                11
            ],
            [
                10,
                16,
                22,
                17
            ],
            [
                11,
                18,
                21,
                15
            ],
            [
                13,
                15,
                21,
                20
            ],
            [
                14,
                20,
                23,
                19
            ],
            [
                16,
                19,
                23,
                22
            ],
            [
                18,
                22,
                23,
                21
            ]
        ]
    };
    polyhedra[5] = {
        vertex: [
            [
                0,
                0,
                1.322876
            ],
            [
                1.309307,
                0,
                0.1889822
            ],
            [
                -0.9819805,
                0.8660254,
                0.1889822
            ],
            [
                0.1636634,
                -1.299038,
                0.1889822
            ],
            [
                0.3273268,
                0.8660254,
                -0.9449112
            ],
            [
                -0.8183171,
                -0.4330127,
                -0.9449112
            ]
        ],
        face: [
            [
                0,
                3,
                1
            ],
            [
                2,
                4,
                5
            ],
            [
                0,
                1,
                4,
                2
            ],
            [
                0,
                2,
                5,
                3
            ],
            [
                1,
                3,
                5,
                4
            ]
        ]
    };
    polyhedra[6] = {
        vertex: [
            [
                0,
                0,
                1.159953
            ],
            [
                1.013464,
                0,
                0.5642542
            ],
            [
                -0.3501431,
                0.9510565,
                0.5642542
            ],
            [
                -0.7715208,
                -0.6571639,
                0.5642542
            ],
            [
                0.6633206,
                0.9510565,
                -0.03144481
            ],
            [
                0.8682979,
                -0.6571639,
                -0.3996071
            ],
            [
                -1.121664,
                0.2938926,
                -0.03144481
            ],
            [
                -0.2348831,
                -1.063314,
                -0.3996071
            ],
            [
                0.5181548,
                0.2938926,
                -0.9953061
            ],
            [
                -0.5850262,
                -0.112257,
                -0.9953061
            ]
        ],
        face: [
            [
                0,
                1,
                4,
                2
            ],
            [
                0,
                2,
                6,
                3
            ],
            [
                1,
                5,
                8,
                4
            ],
            [
                3,
                6,
                9,
                7
            ],
            [
                5,
                7,
                9,
                8
            ],
            [
                0,
                3,
                7,
                5,
                1
            ],
            [
                2,
                4,
                8,
                9,
                6
            ]
        ]
    };
    polyhedra[7] = {
        vertex: [
            [
                0,
                0,
                1.118034
            ],
            [
                0.8944272,
                0,
                0.6708204
            ],
            [
                -0.2236068,
                0.8660254,
                0.6708204
            ],
            [
                -0.7826238,
                -0.4330127,
                0.6708204
            ],
            [
                0.6708204,
                0.8660254,
                0.2236068
            ],
            [
                1.006231,
                -0.4330127,
                -0.2236068
            ],
            [
                -1.006231,
                0.4330127,
                0.2236068
            ],
            [
                -0.6708204,
                -0.8660254,
                -0.2236068
            ],
            [
                0.7826238,
                0.4330127,
                -0.6708204
            ],
            [
                0.2236068,
                -0.8660254,
                -0.6708204
            ],
            [
                -0.8944272,
                0,
                -0.6708204
            ],
            [
                0,
                0,
                -1.118034
            ]
        ],
        face: [
            [
                0,
                1,
                4,
                2
            ],
            [
                0,
                2,
                6,
                3
            ],
            [
                1,
                5,
                8,
                4
            ],
            [
                3,
                6,
                10,
                7
            ],
            [
                5,
                9,
                11,
                8
            ],
            [
                7,
                10,
                11,
                9
            ],
            [
                0,
                3,
                7,
                9,
                5,
                1
            ],
            [
                2,
                4,
                8,
                11,
                10,
                6
            ]
        ]
    };
    polyhedra[8] = {
        vertex: [
            [
                -0.729665,
                0.670121,
                0.319155
            ],
            [
                -0.655235,
                -0.29213,
                -0.754096
            ],
            [
                -0.093922,
                -0.607123,
                0.537818
            ],
            [
                0.702196,
                0.595691,
                0.485187
            ],
            [
                0.776626,
                -0.36656,
                -0.588064
            ]
        ],
        face: [
            [
                1,
                4,
                2
            ],
            [
                0,
                1,
                2
            ],
            [
                3,
                0,
                2
            ],
            [
                4,
                3,
                2
            ],
            [
                4,
                1,
                0,
                3
            ]
        ]
    };
    polyhedra[9] = {
        vertex: [
            [
                -0.868849,
                -0.100041,
                0.61257
            ],
            [
                -0.329458,
                0.976099,
                0.28078
            ],
            [
                -0.26629,
                -0.013796,
                -0.477654
            ],
            [
                -0.13392,
                -1.034115,
                0.229829
            ],
            [
                0.738834,
                0.707117,
                -0.307018
            ],
            [
                0.859683,
                -0.535264,
                -0.338508
            ]
        ],
        face: [
            [
                3,
                0,
                2
            ],
            [
                5,
                3,
                2
            ],
            [
                4,
                5,
                2
            ],
            [
                1,
                4,
                2
            ],
            [
                0,
                1,
                2
            ],
            [
                0,
                3,
                5,
                4,
                1
            ]
        ]
    };
    polyhedra[10] = {
        vertex: [
            [
                -0.610389,
                0.243975,
                0.531213
            ],
            [
                -0.187812,
                -0.48795,
                -0.664016
            ],
            [
                -0.187812,
                0.9759,
                -0.664016
            ],
            [
                0.187812,
                -0.9759,
                0.664016
            ],
            [
                0.798201,
                0.243975,
                0.132803
            ]
        ],
        face: [
            [
                1,
                3,
                0
            ],
            [
                3,
                4,
                0
            ],
            [
                3,
                1,
                4
            ],
            [
                0,
                2,
                1
            ],
            [
                0,
                4,
                2
            ],
            [
                2,
                4,
                1
            ]
        ]
    };
    polyhedra[11] = {
        vertex: [
            [
                -1.028778,
                0.392027,
                -0.048786
            ],
            [
                -0.640503,
                -0.646161,
                0.621837
            ],
            [
                -0.125162,
                -0.395663,
                -0.540059
            ],
            [
                0.004683,
                0.888447,
                -0.651988
            ],
            [
                0.125161,
                0.395663,
                0.540059
            ],
            [
                0.632925,
                -0.791376,
                0.433102
            ],
            [
                1.031672,
                0.157063,
                -0.354165
            ]
        ],
        face: [
            [
                3,
                2,
                0
            ],
            [
                2,
                1,
                0
            ],
            [
                2,
                5,
                1
            ],
            [
                0,
                4,
                3
            ],
            [
                0,
                1,
                4
            ],
            [
                4,
                1,
                5
            ],
            [
                2,
                3,
                6
            ],
            [
                3,
                4,
                6
            ],
            [
                5,
                2,
                6
            ],
            [
                4,
                5,
                6
            ]
        ]
    };
    polyhedra[12] = {
        vertex: [
            [
                -0.669867,
                0.334933,
                -0.529576
            ],
            [
                -0.669867,
                0.334933,
                0.529577
            ],
            [
                -0.4043,
                1.212901,
                0
            ],
            [
                -0.334933,
                -0.669867,
                -0.529576
            ],
            [
                -0.334933,
                -0.669867,
                0.529577
            ],
            [
                0.334933,
                0.669867,
                -0.529576
            ],
            [
                0.334933,
                0.669867,
                0.529577
            ],
            [
                0.4043,
                -1.212901,
                0
            ],
            [
                0.669867,
                -0.334933,
                -0.529576
            ],
            [
                0.669867,
                -0.334933,
                0.529577
            ]
        ],
        face: [
            [
                8,
                9,
                7
            ],
            [
                6,
                5,
                2
            ],
            [
                3,
                8,
                7
            ],
            [
                5,
                0,
                2
            ],
            [
                4,
                3,
                7
            ],
            [
                0,
                1,
                2
            ],
            [
                9,
                4,
                7
            ],
            [
                1,
                6,
                2
            ],
            [
                9,
                8,
                5,
                6
            ],
            [
                8,
                3,
                0,
                5
            ],
            [
                3,
                4,
                1,
                0
            ],
            [
                4,
                9,
                6,
                1
            ]
        ]
    };
    polyhedra[13] = {
        vertex: [
            [
                -0.931836,
                0.219976,
                -0.264632
            ],
            [
                -0.636706,
                0.318353,
                0.692816
            ],
            [
                -0.613483,
                -0.735083,
                -0.264632
            ],
            [
                -0.326545,
                0.979634,
                0
            ],
            [
                -0.318353,
                -0.636706,
                0.692816
            ],
            [
                -0.159176,
                0.477529,
                -0.856368
            ],
            [
                0.159176,
                -0.477529,
                -0.856368
            ],
            [
                0.318353,
                0.636706,
                0.692816
            ],
            [
                0.326545,
                -0.979634,
                0
            ],
            [
                0.613482,
                0.735082,
                -0.264632
            ],
            [
                0.636706,
                -0.318353,
                0.692816
            ],
            [
                0.931835,
                -0.219977,
                -0.264632
            ]
        ],
        face: [
            [
                11,
                10,
                8
            ],
            [
                7,
                9,
                3
            ],
            [
                6,
                11,
                8
            ],
            [
                9,
                5,
                3
            ],
            [
                2,
                6,
                8
            ],
            [
                5,
                0,
                3
            ],
            [
                4,
                2,
                8
            ],
            [
                0,
                1,
                3
            ],
            [
                10,
                4,
                8
            ],
            [
                1,
                7,
                3
            ],
            [
                10,
                11,
                9,
                7
            ],
            [
                11,
                6,
                5,
                9
            ],
            [
                6,
                2,
                0,
                5
            ],
            [
                2,
                4,
                1,
                0
            ],
            [
                4,
                10,
                7,
                1
            ]
        ]
    };
    polyhedra[14] = {
        vertex: [
            [
                -0.93465,
                0.300459,
                -0.271185
            ],
            [
                -0.838689,
                -0.260219,
                -0.516017
            ],
            [
                -0.711319,
                0.717591,
                0.128359
            ],
            [
                -0.710334,
                -0.156922,
                0.080946
            ],
            [
                -0.599799,
                0.556003,
                -0.725148
            ],
            [
                -0.503838,
                -0.004675,
                -0.969981
            ],
            [
                -0.487004,
                0.26021,
                0.48049
            ],
            [
                -0.460089,
                -0.750282,
                -0.512622
            ],
            [
                -0.376468,
                0.973135,
                -0.325605
            ],
            [
                -0.331735,
                -0.646985,
                0.084342
            ],
            [
                -0.254001,
                0.831847,
                0.530001
            ],
            [
                -0.125239,
                -0.494738,
                -0.966586
            ],
            [
                0.029622,
                0.027949,
                0.730817
            ],
            [
                0.056536,
                -0.982543,
                -0.262295
            ],
            [
                0.08085,
                1.087391,
                0.076037
            ],
            [
                0.125583,
                -0.532729,
                0.485984
            ],
            [
                0.262625,
                0.599586,
                0.780328
            ],
            [
                0.391387,
                -0.726999,
                -0.716259
            ],
            [
                0.513854,
                -0.868287,
                0.139347
            ],
            [
                0.597475,
                0.85513,
                0.326364
            ],
            [
                0.641224,
                0.109523,
                0.783723
            ],
            [
                0.737185,
                -0.451155,
                0.538891
            ],
            [
                0.848705,
                -0.612742,
                -0.314616
            ],
            [
                0.976075,
                0.365067,
                0.32976
            ],
            [
                1.072036,
                -0.19561,
                0.084927
            ]
        ],
        face: [
            [
                15,
                18,
                21
            ],
            [
                12,
                20,
                16
            ],
            [
                6,
                10,
                2
            ],
            [
                3,
                0,
                1
            ],
            [
                9,
                7,
                13
            ],
            [
                2,
                8,
                4,
                0
            ],
            [
                0,
                4,
                5,
                1
            ],
            [
                1,
                5,
                11,
                7
            ],
            [
                7,
                11,
                17,
                13
            ],
            [
                13,
                17,
                22,
                18
            ],
            [
                18,
                22,
                24,
                21
            ],
            [
                21,
                24,
                23,
                20
            ],
            [
                20,
                23,
                19,
                16
            ],
            [
                16,
                19,
                14,
                10
            ],
            [
                10,
                14,
                8,
                2
            ],
            [
                15,
                9,
                13,
                18
            ],
            [
                12,
                15,
                21,
                20
            ],
            [
                6,
                12,
                16,
                10
            ],
            [
                3,
                6,
                2,
                0
            ],
            [
                9,
                3,
                1,
                7
            ],
            [
                9,
                15,
                12,
                6,
                3
            ],
            [
                22,
                17,
                11,
                5,
                4,
                8,
                14,
                19,
                23,
                24
            ]
        ]
    };
    const type = options.type && (options.type < 0 || options.type >= polyhedra.length) ? 0 : options.type || 0;
    const size = options.size;
    const sizeX = options.sizeX || size || 1;
    const sizeY = options.sizeY || size || 1;
    const sizeZ = options.sizeZ || size || 1;
    const data = options.custom || polyhedra[type];
    const nbfaces = data.face.length;
    const faceUV = options.faceUV || new Array(nbfaces);
    const faceColors = options.faceColors;
    const flat = options.flat === undefined ? true : options.flat;
    const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || (0, $5v6ry.VertexData).DEFAULTSIDE;
    const positions = [];
    const indices = [];
    const normals = [];
    const uvs = [];
    const colors = [];
    let index = 0;
    let faceIdx = 0; // face cursor in the array "indexes"
    const indexes = [];
    let i = 0;
    let f = 0;
    let u, v, ang, x, y, tmp;
    // default face colors and UV if undefined
    if (flat) for(f = 0; f < nbfaces; f++){
        if (faceColors && faceColors[f] === undefined) faceColors[f] = new (0, $7etnY.Color4)(1, 1, 1, 1);
        if (faceUV && faceUV[f] === undefined) faceUV[f] = new (0, $ha1VO.Vector4)(0, 0, 1, 1);
    }
    if (!flat) {
        for(i = 0; i < data.vertex.length; i++){
            positions.push(data.vertex[i][0] * sizeX, data.vertex[i][1] * sizeY, data.vertex[i][2] * sizeZ);
            uvs.push(0, (0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? 1.0 : 0);
        }
        for(f = 0; f < nbfaces; f++)for(i = 0; i < data.face[f].length - 2; i++)indices.push(data.face[f][0], data.face[f][i + 2], data.face[f][i + 1]);
    } else for(f = 0; f < nbfaces; f++){
        const fl = data.face[f].length; // number of vertices of the current face
        ang = 2 * Math.PI / fl;
        x = 0.5 * Math.tan(ang / 2);
        y = 0.5;
        // positions, uvs, colors
        for(i = 0; i < fl; i++){
            // positions
            positions.push(data.vertex[data.face[f][i]][0] * sizeX, data.vertex[data.face[f][i]][1] * sizeY, data.vertex[data.face[f][i]][2] * sizeZ);
            indexes.push(index);
            index++;
            // uvs
            u = faceUV[f].x + (faceUV[f].z - faceUV[f].x) * (0.5 + x);
            v = faceUV[f].y + (faceUV[f].w - faceUV[f].y) * (y - 0.5);
            uvs.push(u, (0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? 1.0 - v : v);
            tmp = x * Math.cos(ang) - y * Math.sin(ang);
            y = x * Math.sin(ang) + y * Math.cos(ang);
            x = tmp;
            // colors
            if (faceColors) colors.push(faceColors[f].r, faceColors[f].g, faceColors[f].b, faceColors[f].a);
        }
        // indices from indexes
        for(i = 0; i < fl - 2; i++)indices.push(indexes[0 + faceIdx], indexes[i + 2 + faceIdx], indexes[i + 1 + faceIdx]);
        faceIdx += fl;
    }
    (0, $5v6ry.VertexData).ComputeNormals(positions, indices, normals);
    (0, $5v6ry.VertexData)._ComputeSides(sideOrientation, positions, indices, normals, uvs, options.frontUVs, options.backUVs);
    const vertexData = new (0, $5v6ry.VertexData)();
    vertexData.positions = positions;
    vertexData.indices = indices;
    vertexData.normals = normals;
    vertexData.uvs = uvs;
    if (faceColors && flat) vertexData.colors = colors;
    return vertexData;
}
function $1d49167c5ec927a7$export$1cb5c9516e55bfc7(name, options = {}, scene = null) {
    const polyhedron = new (0, $fbuqw.Mesh)(name, scene);
    options.sideOrientation = (0, $fbuqw.Mesh)._GetDefaultSideOrientation(options.sideOrientation);
    polyhedron._originalBuilderSideOrientation = options.sideOrientation;
    const vertexData = $1d49167c5ec927a7$export$c72e10f5a1c9dc82(options);
    vertexData.applyToMesh(polyhedron, options.updatable);
    return polyhedron;
}
const $1d49167c5ec927a7$export$ccaedb7c99deedc1 = {
    CreatePolyhedron: // eslint-disable-next-line @typescript-eslint/naming-convention
    $1d49167c5ec927a7$export$1cb5c9516e55bfc7
};
(0, $5v6ry.VertexData).CreatePolyhedron = $1d49167c5ec927a7$export$c72e10f5a1c9dc82;
(0, $fbuqw.Mesh).CreatePolyhedron = (name, options, scene)=>{
    return $1d49167c5ec927a7$export$1cb5c9516e55bfc7(name, options, scene);
};

});

parcelRegister("1ewDO", function(module, exports) {

$parcel$export(module.exports, "CreateDecal", () => $0e606b1f6b3f9d8d$export$dd4b92dd7bd2e8);
$parcel$export(module.exports, "DecalBuilder", () => $0e606b1f6b3f9d8d$export$400e42794e248371);

var $ha1VO = parcelRequire("ha1VO");

var $1VEEL = parcelRequire("1VEEL");

var $fbuqw = parcelRequire("fbuqw");

var $b4i1f = parcelRequire("b4i1f");

var $5v6ry = parcelRequire("5v6ry");

var $fGXjI = parcelRequire("fGXjI");
const $0e606b1f6b3f9d8d$var$xpAxis = new (0, $ha1VO.Vector3)(1, 0, 0);
const $0e606b1f6b3f9d8d$var$xnAxis = new (0, $ha1VO.Vector3)(-1, 0, 0);
const $0e606b1f6b3f9d8d$var$ypAxis = new (0, $ha1VO.Vector3)(0, 1, 0);
const $0e606b1f6b3f9d8d$var$ynAxis = new (0, $ha1VO.Vector3)(0, -1, 0);
const $0e606b1f6b3f9d8d$var$zpAxis = new (0, $ha1VO.Vector3)(0, 0, 1);
const $0e606b1f6b3f9d8d$var$znAxis = new (0, $ha1VO.Vector3)(0, 0, -1);
/** @internal */ class $0e606b1f6b3f9d8d$var$DecalVertex {
    constructor(position = (0, $ha1VO.Vector3).Zero(), normal = (0, $ha1VO.Vector3).Up(), uv = (0, $ha1VO.Vector2).Zero(), vertexIdx = 0, vertexIdxForBones = 0, localPositionOverride = null, localNormalOverride = null, matrixIndicesOverride = null, matrixWeightsOverride = null){
        this.position = position;
        this.normal = normal;
        this.uv = uv;
        this.vertexIdx = vertexIdx;
        this.vertexIdxForBones = vertexIdxForBones;
        this.localPositionOverride = localPositionOverride;
        this.localNormalOverride = localNormalOverride;
        this.matrixIndicesOverride = matrixIndicesOverride;
        this.matrixWeightsOverride = matrixWeightsOverride;
    }
    clone() {
        return new $0e606b1f6b3f9d8d$var$DecalVertex(this.position.clone(), this.normal.clone(), this.uv.clone(), this.vertexIdx, this.vertexIdxForBones, this.localPositionOverride?.slice(), this.localNormalOverride?.slice(), this.matrixIndicesOverride?.slice(), this.matrixWeightsOverride?.slice());
    }
}
function $0e606b1f6b3f9d8d$export$dd4b92dd7bd2e8(name, sourceMesh, options) {
    const hasSkeleton = !!sourceMesh.skeleton;
    const useLocalComputation = options.localMode || hasSkeleton;
    const meshHasOverridenMaterial = sourceMesh.overrideMaterialSideOrientation !== null && sourceMesh.overrideMaterialSideOrientation !== undefined;
    const indices = sourceMesh.getIndices();
    const positions = hasSkeleton ? sourceMesh.getPositionData(true, true) : sourceMesh.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
    const normals = hasSkeleton ? sourceMesh.getNormalsData(true, true) : sourceMesh.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind);
    const localPositions = useLocalComputation ? hasSkeleton ? sourceMesh.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind) : positions : null;
    const localNormals = useLocalComputation ? hasSkeleton ? sourceMesh.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind) : normals : null;
    const uvs = sourceMesh.getVerticesData((0, $b4i1f.VertexBuffer).UVKind);
    const matIndices = hasSkeleton ? sourceMesh.getVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesKind) : null;
    const matWeights = hasSkeleton ? sourceMesh.getVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsKind) : null;
    const matIndicesExtra = hasSkeleton ? sourceMesh.getVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind) : null;
    const matWeightsExtra = hasSkeleton ? sourceMesh.getVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind) : null;
    const position = options.position || (0, $ha1VO.Vector3).Zero();
    let normal = options.normal || (0, $ha1VO.Vector3).Up();
    const size = options.size || (0, $ha1VO.Vector3).One();
    const angle = options.angle || 0;
    // Getting correct rotation
    if (!normal) {
        const target = new (0, $ha1VO.Vector3)(0, 0, 1);
        const camera = sourceMesh.getScene().activeCamera;
        const cameraWorldTarget = (0, $ha1VO.Vector3).TransformCoordinates(target, camera.getWorldMatrix());
        normal = camera.globalPosition.subtract(cameraWorldTarget);
    }
    const yaw = -Math.atan2(normal.z, normal.x) - Math.PI / 2;
    const len = Math.sqrt(normal.x * normal.x + normal.z * normal.z);
    const pitch = Math.atan2(normal.y, len);
    const vertexData = new (0, $5v6ry.VertexData)();
    vertexData.indices = [];
    vertexData.positions = [];
    vertexData.normals = [];
    vertexData.uvs = [];
    vertexData.matricesIndices = hasSkeleton ? [] : null;
    vertexData.matricesWeights = hasSkeleton ? [] : null;
    vertexData.matricesIndicesExtra = matIndicesExtra ? [] : null;
    vertexData.matricesWeightsExtra = matWeightsExtra ? [] : null;
    let currentVertexDataIndex = 0;
    const extractDecalVector3 = (indexId, transformMatrix)=>{
        const result = new $0e606b1f6b3f9d8d$var$DecalVertex();
        if (!indices || !positions || !normals) return result;
        const vertexId = indices[indexId];
        result.vertexIdx = vertexId * 3;
        result.vertexIdxForBones = vertexId * 4;
        // Send vector to decal local world
        result.position = new (0, $ha1VO.Vector3)(positions[vertexId * 3], positions[vertexId * 3 + 1], positions[vertexId * 3 + 2]);
        (0, $ha1VO.Vector3).TransformCoordinatesToRef(result.position, transformMatrix, result.position);
        // Get normal
        result.normal = new (0, $ha1VO.Vector3)(normals[vertexId * 3], normals[vertexId * 3 + 1], normals[vertexId * 3 + 2]);
        (0, $ha1VO.Vector3).TransformNormalToRef(result.normal, transformMatrix, result.normal);
        if (options.captureUVS && uvs) {
            const v = uvs[vertexId * 2 + 1];
            result.uv = new (0, $ha1VO.Vector2)(uvs[vertexId * 2], (0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? 1 - v : v);
        }
        return result;
    };
    const emptyArray = [
        0,
        0,
        0,
        0
    ];
    // Inspired by https://github.com/mrdoob/three.js/blob/eee231960882f6f3b6113405f524956145148146/examples/js/geometries/DecalGeometry.js
    const clip = (vertices, axis)=>{
        if (vertices.length === 0) return vertices;
        const clipSize = 0.5 * Math.abs((0, $ha1VO.Vector3).Dot(size, axis));
        const indexOf = (arr, val, start, num)=>{
            for(let i = 0; i < num; ++i){
                if (arr[start + i] === val) return start + i;
            }
            return -1;
        };
        const clipVertices = (v0, v1)=>{
            const clipFactor = (0, $ha1VO.Vector3).GetClipFactor(v0.position, v1.position, axis, clipSize);
            let indices = emptyArray;
            let weights = emptyArray;
            if (matIndices && matWeights) {
                const mat0Index = v0.matrixIndicesOverride ? 0 : v0.vertexIdxForBones;
                const v0Indices = v0.matrixIndicesOverride ?? matIndices;
                const v0Weights = v0.matrixWeightsOverride ?? matWeights;
                const mat1Index = v1.matrixIndicesOverride ? 0 : v1.vertexIdxForBones;
                const v1Indices = v1.matrixIndicesOverride ?? matIndices;
                const v1Weights = v1.matrixWeightsOverride ?? matWeights;
                indices = [
                    0,
                    0,
                    0,
                    0
                ];
                weights = [
                    0,
                    0,
                    0,
                    0
                ];
                let index = 0;
                for(let i = 0; i < 4; ++i)if (v0Weights[mat0Index + i] > 0) {
                    const idx = indexOf(v1Indices, v0Indices[mat0Index + i], mat1Index, 4);
                    indices[index] = v0Indices[mat0Index + i];
                    weights[index] = (0, $1VEEL.Scalar).Lerp(v0Weights[mat0Index + i], idx >= 0 ? v1Weights[idx] : 0, clipFactor);
                    index++;
                }
                for(let i = 0; i < 4 && index < 4; ++i){
                    const ind = v1Indices[mat1Index + i];
                    if (indexOf(v0Indices, ind, mat0Index, 4) !== -1) continue;
                    indices[index] = ind;
                    weights[index] = (0, $1VEEL.Scalar).Lerp(0, v1Weights[mat1Index + i], clipFactor);
                    index++;
                }
                const sumw = weights[0] + weights[1] + weights[2] + weights[3];
                weights[0] /= sumw;
                weights[1] /= sumw;
                weights[2] /= sumw;
                weights[3] /= sumw;
            }
            const v0LocalPositionX = v0.localPositionOverride ? v0.localPositionOverride[0] : localPositions?.[v0.vertexIdx] ?? 0;
            const v0LocalPositionY = v0.localPositionOverride ? v0.localPositionOverride[1] : localPositions?.[v0.vertexIdx + 1] ?? 0;
            const v0LocalPositionZ = v0.localPositionOverride ? v0.localPositionOverride[2] : localPositions?.[v0.vertexIdx + 2] ?? 0;
            const v1LocalPositionX = v1.localPositionOverride ? v1.localPositionOverride[0] : localPositions?.[v1.vertexIdx] ?? 0;
            const v1LocalPositionY = v1.localPositionOverride ? v1.localPositionOverride[1] : localPositions?.[v1.vertexIdx + 1] ?? 0;
            const v1LocalPositionZ = v1.localPositionOverride ? v1.localPositionOverride[2] : localPositions?.[v1.vertexIdx + 2] ?? 0;
            const v0LocalNormalX = v0.localNormalOverride ? v0.localNormalOverride[0] : localNormals?.[v0.vertexIdx] ?? 0;
            const v0LocalNormalY = v0.localNormalOverride ? v0.localNormalOverride[1] : localNormals?.[v0.vertexIdx + 1] ?? 0;
            const v0LocalNormalZ = v0.localNormalOverride ? v0.localNormalOverride[2] : localNormals?.[v0.vertexIdx + 2] ?? 0;
            const v1LocalNormalX = v1.localNormalOverride ? v1.localNormalOverride[0] : localNormals?.[v1.vertexIdx] ?? 0;
            const v1LocalNormalY = v1.localNormalOverride ? v1.localNormalOverride[1] : localNormals?.[v1.vertexIdx + 1] ?? 0;
            const v1LocalNormalZ = v1.localNormalOverride ? v1.localNormalOverride[2] : localNormals?.[v1.vertexIdx + 2] ?? 0;
            const interpNormalX = v0LocalNormalX + (v1LocalNormalX - v0LocalNormalX) * clipFactor;
            const interpNormalY = v0LocalNormalY + (v1LocalNormalY - v0LocalNormalY) * clipFactor;
            const interpNormalZ = v0LocalNormalZ + (v1LocalNormalZ - v0LocalNormalZ) * clipFactor;
            const norm = Math.sqrt(interpNormalX * interpNormalX + interpNormalY * interpNormalY + interpNormalZ * interpNormalZ);
            return new $0e606b1f6b3f9d8d$var$DecalVertex((0, $ha1VO.Vector3).Lerp(v0.position, v1.position, clipFactor), (0, $ha1VO.Vector3).Lerp(v0.normal, v1.normal, clipFactor).normalize(), (0, $ha1VO.Vector2).Lerp(v0.uv, v1.uv, clipFactor), -1, -1, localPositions ? [
                v0LocalPositionX + (v1LocalPositionX - v0LocalPositionX) * clipFactor,
                v0LocalPositionY + (v1LocalPositionY - v0LocalPositionY) * clipFactor,
                v0LocalPositionZ + (v1LocalPositionZ - v0LocalPositionZ) * clipFactor
            ] : null, localNormals ? [
                interpNormalX / norm,
                interpNormalY / norm,
                interpNormalZ / norm
            ] : null, indices, weights);
        };
        let clipResult = null;
        if (vertices.length > 3) clipResult = [];
        for(let index = 0; index < vertices.length; index += 3){
            let total = 0;
            let nV1 = null;
            let nV2 = null;
            let nV3 = null;
            let nV4 = null;
            const d1 = (0, $ha1VO.Vector3).Dot(vertices[index].position, axis) - clipSize;
            const d2 = (0, $ha1VO.Vector3).Dot(vertices[index + 1].position, axis) - clipSize;
            const d3 = (0, $ha1VO.Vector3).Dot(vertices[index + 2].position, axis) - clipSize;
            const v1Out = d1 > 0;
            const v2Out = d2 > 0;
            const v3Out = d3 > 0;
            total = (v1Out ? 1 : 0) + (v2Out ? 1 : 0) + (v3Out ? 1 : 0);
            switch(total){
                case 0:
                    if (vertices.length > 3) {
                        clipResult.push(vertices[index]);
                        clipResult.push(vertices[index + 1]);
                        clipResult.push(vertices[index + 2]);
                    } else clipResult = vertices;
                    break;
                case 1:
                    clipResult = clipResult ?? new Array();
                    if (v1Out) {
                        nV1 = vertices[index + 1];
                        nV2 = vertices[index + 2];
                        nV3 = clipVertices(vertices[index], nV1);
                        nV4 = clipVertices(vertices[index], nV2);
                    }
                    if (v2Out) {
                        nV1 = vertices[index];
                        nV2 = vertices[index + 2];
                        nV3 = clipVertices(vertices[index + 1], nV1);
                        nV4 = clipVertices(vertices[index + 1], nV2);
                        clipResult.push(nV3);
                        clipResult.push(nV2.clone());
                        clipResult.push(nV1.clone());
                        clipResult.push(nV2.clone());
                        clipResult.push(nV3.clone());
                        clipResult.push(nV4);
                        break;
                    }
                    if (v3Out) {
                        nV1 = vertices[index];
                        nV2 = vertices[index + 1];
                        nV3 = clipVertices(vertices[index + 2], nV1);
                        nV4 = clipVertices(vertices[index + 2], nV2);
                    }
                    if (nV1 && nV2 && nV3 && nV4) {
                        clipResult.push(nV1.clone());
                        clipResult.push(nV2.clone());
                        clipResult.push(nV3);
                        clipResult.push(nV4);
                        clipResult.push(nV3.clone());
                        clipResult.push(nV2.clone());
                    }
                    break;
                case 2:
                    clipResult = clipResult ?? new Array();
                    if (!v1Out) {
                        nV1 = vertices[index].clone();
                        nV2 = clipVertices(nV1, vertices[index + 1]);
                        nV3 = clipVertices(nV1, vertices[index + 2]);
                        clipResult.push(nV1);
                        clipResult.push(nV2);
                        clipResult.push(nV3);
                    }
                    if (!v2Out) {
                        nV1 = vertices[index + 1].clone();
                        nV2 = clipVertices(nV1, vertices[index + 2]);
                        nV3 = clipVertices(nV1, vertices[index]);
                        clipResult.push(nV1);
                        clipResult.push(nV2);
                        clipResult.push(nV3);
                    }
                    if (!v3Out) {
                        nV1 = vertices[index + 2].clone();
                        nV2 = clipVertices(nV1, vertices[index]);
                        nV3 = clipVertices(nV1, vertices[index + 1]);
                        clipResult.push(nV1);
                        clipResult.push(nV2);
                        clipResult.push(nV3);
                    }
                    break;
                case 3:
                    break;
            }
        }
        return clipResult;
    };
    const sourceMeshAsMesh = sourceMesh instanceof (0, $fbuqw.Mesh) ? sourceMesh : null;
    const matrixData = sourceMeshAsMesh?._thinInstanceDataStorage.matrixData;
    const numMatrices = sourceMeshAsMesh?.thinInstanceCount || 1;
    const thinInstanceMatrix = (0, $ha1VO.TmpVectors).Matrix[0];
    thinInstanceMatrix.copyFrom((0, $ha1VO.Matrix).IdentityReadOnly);
    for(let m = 0; m < numMatrices; ++m){
        if (sourceMeshAsMesh?.hasThinInstances && matrixData) {
            const ofst = m * 16;
            thinInstanceMatrix.setRowFromFloats(0, matrixData[ofst + 0], matrixData[ofst + 1], matrixData[ofst + 2], matrixData[ofst + 3]);
            thinInstanceMatrix.setRowFromFloats(1, matrixData[ofst + 4], matrixData[ofst + 5], matrixData[ofst + 6], matrixData[ofst + 7]);
            thinInstanceMatrix.setRowFromFloats(2, matrixData[ofst + 8], matrixData[ofst + 9], matrixData[ofst + 10], matrixData[ofst + 11]);
            thinInstanceMatrix.setRowFromFloats(3, matrixData[ofst + 12], matrixData[ofst + 13], matrixData[ofst + 14], matrixData[ofst + 15]);
        }
        // Matrix
        const decalWorldMatrix = (0, $ha1VO.Matrix).RotationYawPitchRoll(yaw, pitch, angle).multiply((0, $ha1VO.Matrix).Translation(position.x, position.y, position.z));
        const inverseDecalWorldMatrix = (0, $ha1VO.Matrix).Invert(decalWorldMatrix);
        const meshWorldMatrix = sourceMesh.getWorldMatrix();
        const transformMatrix = thinInstanceMatrix.multiply(meshWorldMatrix).multiply(inverseDecalWorldMatrix);
        const oneFaceVertices = new Array(3);
        for(let index = 0; index < indices.length; index += 3){
            let faceVertices = oneFaceVertices;
            faceVertices[0] = extractDecalVector3(index, transformMatrix);
            if (meshHasOverridenMaterial && useLocalComputation) {
                faceVertices[1] = extractDecalVector3(index + 2, transformMatrix);
                faceVertices[2] = extractDecalVector3(index + 1, transformMatrix);
            } else {
                faceVertices[1] = extractDecalVector3(index + 1, transformMatrix);
                faceVertices[2] = extractDecalVector3(index + 2, transformMatrix);
            }
            if (options.cullBackFaces) {
                // If all the normals of the vertices of the face are pointing away from the view direction we discard the face.
                // As computations are done in the decal coordinate space, the viewDirection is (0,0,1), so when dot(vertexNormal, -viewDirection) <= 0 the vertex is culled
                if (-faceVertices[0].normal.z <= 0 && -faceVertices[1].normal.z <= 0 && -faceVertices[2].normal.z <= 0) continue;
            }
            // Clip
            faceVertices = clip(faceVertices, $0e606b1f6b3f9d8d$var$xpAxis);
            if (!faceVertices) continue;
            faceVertices = clip(faceVertices, $0e606b1f6b3f9d8d$var$xnAxis);
            if (!faceVertices) continue;
            faceVertices = clip(faceVertices, $0e606b1f6b3f9d8d$var$ypAxis);
            if (!faceVertices) continue;
            faceVertices = clip(faceVertices, $0e606b1f6b3f9d8d$var$ynAxis);
            if (!faceVertices) continue;
            faceVertices = clip(faceVertices, $0e606b1f6b3f9d8d$var$zpAxis);
            if (!faceVertices) continue;
            faceVertices = clip(faceVertices, $0e606b1f6b3f9d8d$var$znAxis);
            if (!faceVertices) continue;
            // Add UVs and get back to world
            for(let vIndex = 0; vIndex < faceVertices.length; vIndex++){
                const vertex = faceVertices[vIndex];
                //TODO check for Int32Array | Uint32Array | Uint16Array
                vertexData.indices.push(currentVertexDataIndex);
                if (useLocalComputation) {
                    if (vertex.localPositionOverride) {
                        vertexData.positions[currentVertexDataIndex * 3] = vertex.localPositionOverride[0];
                        vertexData.positions[currentVertexDataIndex * 3 + 1] = vertex.localPositionOverride[1];
                        vertexData.positions[currentVertexDataIndex * 3 + 2] = vertex.localPositionOverride[2];
                    } else if (localPositions) {
                        vertexData.positions[currentVertexDataIndex * 3] = localPositions[vertex.vertexIdx];
                        vertexData.positions[currentVertexDataIndex * 3 + 1] = localPositions[vertex.vertexIdx + 1];
                        vertexData.positions[currentVertexDataIndex * 3 + 2] = localPositions[vertex.vertexIdx + 2];
                    }
                    if (vertex.localNormalOverride) {
                        vertexData.normals[currentVertexDataIndex * 3] = vertex.localNormalOverride[0];
                        vertexData.normals[currentVertexDataIndex * 3 + 1] = vertex.localNormalOverride[1];
                        vertexData.normals[currentVertexDataIndex * 3 + 2] = vertex.localNormalOverride[2];
                    } else if (localNormals) {
                        vertexData.normals[currentVertexDataIndex * 3] = localNormals[vertex.vertexIdx];
                        vertexData.normals[currentVertexDataIndex * 3 + 1] = localNormals[vertex.vertexIdx + 1];
                        vertexData.normals[currentVertexDataIndex * 3 + 2] = localNormals[vertex.vertexIdx + 2];
                    }
                } else {
                    vertex.position.toArray(vertexData.positions, currentVertexDataIndex * 3);
                    vertex.normal.toArray(vertexData.normals, currentVertexDataIndex * 3);
                }
                if (vertexData.matricesIndices && vertexData.matricesWeights) {
                    if (vertex.matrixIndicesOverride) {
                        vertexData.matricesIndices[currentVertexDataIndex * 4] = vertex.matrixIndicesOverride[0];
                        vertexData.matricesIndices[currentVertexDataIndex * 4 + 1] = vertex.matrixIndicesOverride[1];
                        vertexData.matricesIndices[currentVertexDataIndex * 4 + 2] = vertex.matrixIndicesOverride[2];
                        vertexData.matricesIndices[currentVertexDataIndex * 4 + 3] = vertex.matrixIndicesOverride[3];
                    } else {
                        if (matIndices) {
                            vertexData.matricesIndices[currentVertexDataIndex * 4] = matIndices[vertex.vertexIdxForBones];
                            vertexData.matricesIndices[currentVertexDataIndex * 4 + 1] = matIndices[vertex.vertexIdxForBones + 1];
                            vertexData.matricesIndices[currentVertexDataIndex * 4 + 2] = matIndices[vertex.vertexIdxForBones + 2];
                            vertexData.matricesIndices[currentVertexDataIndex * 4 + 3] = matIndices[vertex.vertexIdxForBones + 3];
                        }
                        if (matIndicesExtra && vertexData.matricesIndicesExtra) {
                            vertexData.matricesIndicesExtra[currentVertexDataIndex * 4] = matIndicesExtra[vertex.vertexIdxForBones];
                            vertexData.matricesIndicesExtra[currentVertexDataIndex * 4 + 1] = matIndicesExtra[vertex.vertexIdxForBones + 1];
                            vertexData.matricesIndicesExtra[currentVertexDataIndex * 4 + 2] = matIndicesExtra[vertex.vertexIdxForBones + 2];
                            vertexData.matricesIndicesExtra[currentVertexDataIndex * 4 + 3] = matIndicesExtra[vertex.vertexIdxForBones + 3];
                        }
                    }
                    if (vertex.matrixWeightsOverride) {
                        vertexData.matricesWeights[currentVertexDataIndex * 4] = vertex.matrixWeightsOverride[0];
                        vertexData.matricesWeights[currentVertexDataIndex * 4 + 1] = vertex.matrixWeightsOverride[1];
                        vertexData.matricesWeights[currentVertexDataIndex * 4 + 2] = vertex.matrixWeightsOverride[2];
                        vertexData.matricesWeights[currentVertexDataIndex * 4 + 3] = vertex.matrixWeightsOverride[3];
                    } else {
                        if (matWeights) {
                            vertexData.matricesWeights[currentVertexDataIndex * 4] = matWeights[vertex.vertexIdxForBones];
                            vertexData.matricesWeights[currentVertexDataIndex * 4 + 1] = matWeights[vertex.vertexIdxForBones + 1];
                            vertexData.matricesWeights[currentVertexDataIndex * 4 + 2] = matWeights[vertex.vertexIdxForBones + 2];
                            vertexData.matricesWeights[currentVertexDataIndex * 4 + 3] = matWeights[vertex.vertexIdxForBones + 3];
                        }
                        if (matWeightsExtra && vertexData.matricesWeightsExtra) {
                            vertexData.matricesWeightsExtra[currentVertexDataIndex * 4] = matWeightsExtra[vertex.vertexIdxForBones];
                            vertexData.matricesWeightsExtra[currentVertexDataIndex * 4 + 1] = matWeightsExtra[vertex.vertexIdxForBones + 1];
                            vertexData.matricesWeightsExtra[currentVertexDataIndex * 4 + 2] = matWeightsExtra[vertex.vertexIdxForBones + 2];
                            vertexData.matricesWeightsExtra[currentVertexDataIndex * 4 + 3] = matWeightsExtra[vertex.vertexIdxForBones + 3];
                        }
                    }
                }
                if (!options.captureUVS) {
                    vertexData.uvs.push(0.5 + vertex.position.x / size.x);
                    const v = 0.5 + vertex.position.y / size.y;
                    vertexData.uvs.push((0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? 1 - v : v);
                } else vertex.uv.toArray(vertexData.uvs, currentVertexDataIndex * 2);
                currentVertexDataIndex++;
            }
        }
    }
    // Avoid the "Setting vertex data kind 'XXX' with an empty array" warning when calling vertexData.applyToMesh
    if (vertexData.indices.length === 0) vertexData.indices = null;
    if (vertexData.positions.length === 0) vertexData.positions = null;
    if (vertexData.normals.length === 0) vertexData.normals = null;
    if (vertexData.uvs.length === 0) vertexData.uvs = null;
    if (vertexData.matricesIndices?.length === 0) vertexData.matricesIndices = null;
    if (vertexData.matricesWeights?.length === 0) vertexData.matricesWeights = null;
    if (vertexData.matricesIndicesExtra?.length === 0) vertexData.matricesIndicesExtra = null;
    if (vertexData.matricesWeightsExtra?.length === 0) vertexData.matricesWeightsExtra = null;
    // Return mesh
    const decal = new (0, $fbuqw.Mesh)(name, sourceMesh.getScene());
    vertexData.applyToMesh(decal);
    if (useLocalComputation) {
        decal.skeleton = sourceMesh.skeleton;
        decal.parent = sourceMesh;
    } else {
        decal.position = position.clone();
        decal.rotation = new (0, $ha1VO.Vector3)(pitch, yaw, angle);
    }
    decal.computeWorldMatrix(true);
    decal.refreshBoundingInfo(true, true);
    return decal;
}
const $0e606b1f6b3f9d8d$export$400e42794e248371 = {
    CreateDecal: // eslint-disable-next-line @typescript-eslint/naming-convention
    $0e606b1f6b3f9d8d$export$dd4b92dd7bd2e8
};
(0, $fbuqw.Mesh).CreateDecal = (name, sourceMesh, position, normal, size, angle)=>{
    const options = {
        position: position,
        normal: normal,
        size: size,
        angle: angle
    };
    return $0e606b1f6b3f9d8d$export$dd4b92dd7bd2e8(name, sourceMesh, options);
};

});

parcelRegister("kZzg0", function(module, exports) {

$parcel$export(module.exports, "CreateGeodesic", () => $f484da790f7b4a54$export$616f62b64ab14d82);

var $2vSVS = parcelRequire("2vSVS");

var $kVtWi = parcelRequire("kVtWi");

var $ip6UH = parcelRequire("ip6UH");
function $f484da790f7b4a54$export$616f62b64ab14d82(name, options, scene = null) {
    let m = options.m || 1;
    if (m !== Math.floor(m)) {
        m;
        (0, $kVtWi.Logger).Warn("m not an integer only floor(m) used");
    }
    let n = options.n || 0;
    if (n !== Math.floor(n)) {
        n;
        (0, $kVtWi.Logger).Warn("n not an integer only floor(n) used");
    }
    if (n > m) {
        const temp = n;
        n = m;
        m = temp;
        (0, $kVtWi.Logger).Warn("n > m therefore m and n swapped");
    }
    const primTri = new (0, $ip6UH._PrimaryIsoTriangle)();
    primTri.build(m, n);
    const geodesicData = (0, $ip6UH.GeodesicData).BuildGeodesicData(primTri);
    const geoOptions = {
        custom: geodesicData,
        size: options.size,
        sizeX: options.sizeX,
        sizeY: options.sizeY,
        sizeZ: options.sizeZ,
        faceUV: options.faceUV,
        faceColors: options.faceColors,
        flat: options.flat,
        updatable: options.updatable,
        sideOrientation: options.sideOrientation,
        frontUVs: options.frontUVs,
        backUVs: options.backUVs
    };
    const geodesic = (0, $2vSVS.CreatePolyhedron)(name, geoOptions, scene);
    return geodesic;
}

});
parcelRegister("ip6UH", function(module, exports) {

$parcel$export(module.exports, "_PrimaryIsoTriangle", () => $d65feca8fd77fc63$export$242532ea034459b);
$parcel$export(module.exports, "PolyhedronData", () => $d65feca8fd77fc63$export$5e1fb625f5ac029c);
$parcel$export(module.exports, "GeodesicData", () => $d65feca8fd77fc63$export$f97f132d55c4fea9);

var $ha1VO = parcelRequire("ha1VO");

var $1VEEL = parcelRequire("1VEEL");

var $53VPf = parcelRequire("53VPf");

var $5osYn = parcelRequire("5osYn");
class $d65feca8fd77fc63$export$242532ea034459b {
    constructor(){
        this.cartesian = [];
        this.vertices = [];
        this.max = [];
        this.min = [];
        this.closestTo = [];
        this.innerFacets = [];
        this.isoVecsABOB = [];
        this.isoVecsOBOA = [];
        this.isoVecsBAOA = [];
        this.vertexTypes = [];
        // eslint-disable-next-line @typescript-eslint/naming-convention
        this.IDATA = new $d65feca8fd77fc63$export$5e1fb625f5ac029c("icosahedron", "Regular", [
            [
                0,
                (0, $53VPf.PHI),
                -1
            ],
            [
                -(0, $53VPf.PHI),
                1,
                0
            ],
            [
                -1,
                0,
                -(0, $53VPf.PHI)
            ],
            [
                1,
                0,
                -(0, $53VPf.PHI)
            ],
            [
                (0, $53VPf.PHI),
                1,
                0
            ],
            [
                0,
                (0, $53VPf.PHI),
                1
            ],
            [
                -1,
                0,
                (0, $53VPf.PHI)
            ],
            [
                -(0, $53VPf.PHI),
                -1,
                0
            ],
            [
                0,
                -(0, $53VPf.PHI),
                -1
            ],
            [
                (0, $53VPf.PHI),
                -1,
                0
            ],
            [
                1,
                0,
                (0, $53VPf.PHI)
            ],
            [
                0,
                -(0, $53VPf.PHI),
                1
            ]
        ], [
            [
                0,
                2,
                1
            ],
            [
                0,
                3,
                2
            ],
            [
                0,
                4,
                3
            ],
            [
                0,
                5,
                4
            ],
            [
                0,
                1,
                5
            ],
            [
                7,
                6,
                1
            ],
            [
                8,
                7,
                2
            ],
            [
                9,
                8,
                3
            ],
            [
                10,
                9,
                4
            ],
            [
                6,
                10,
                5
            ],
            [
                2,
                7,
                1
            ],
            [
                3,
                8,
                2
            ],
            [
                4,
                9,
                3
            ],
            [
                5,
                10,
                4
            ],
            [
                1,
                6,
                5
            ],
            [
                11,
                6,
                7
            ],
            [
                11,
                7,
                8
            ],
            [
                11,
                8,
                9
            ],
            [
                11,
                9,
                10
            ],
            [
                11,
                10,
                6
            ]
        ]);
    }
    /**
     * Creates the PrimaryIsoTriangle Triangle OAB
     * @param m an integer
     * @param n an integer
     */ //operators
    setIndices() {
        let indexCount = 12; // 12 vertices already assigned
        const vecToidx = {}; //maps iso-vectors to indexCount;
        const m = this.m;
        const n = this.n;
        let g = m; // hcf of m, n when n != 0
        let m1 = 1;
        let n1 = 0;
        if (n !== 0) g = (0, $1VEEL.Scalar).HCF(m, n);
        m1 = m / g;
        n1 = n / g;
        let fr; //face to the right of current face
        let rot; //rotation about which vertex for fr
        let O;
        let A;
        let B;
        const oVec = (0, $5osYn._IsoVector).Zero();
        const aVec = new (0, $5osYn._IsoVector)(m, n);
        const bVec = new (0, $5osYn._IsoVector)(-n, m + n);
        const oaVec = (0, $5osYn._IsoVector).Zero();
        const abVec = (0, $5osYn._IsoVector).Zero();
        const obVec = (0, $5osYn._IsoVector).Zero();
        let verts = [];
        let idx;
        let idxR;
        let isoId;
        let isoIdR;
        const closestTo = [];
        const vDist = this.vertByDist;
        const matchIdx = (f, fr, isoId, isoIdR)=>{
            idx = f + "|" + isoId;
            idxR = fr + "|" + isoIdR;
            if (!(idx in vecToidx || idxR in vecToidx)) {
                vecToidx[idx] = indexCount;
                vecToidx[idxR] = indexCount;
                indexCount++;
            } else if (idx in vecToidx && !(idxR in vecToidx)) vecToidx[idxR] = vecToidx[idx];
            else if (idxR in vecToidx && !(idx in vecToidx)) vecToidx[idx] = vecToidx[idxR];
            if (vDist[isoId][0] > 2) closestTo[vecToidx[idx]] = [
                -vDist[isoId][0],
                vDist[isoId][1],
                vecToidx[idx]
            ];
            else closestTo[vecToidx[idx]] = [
                verts[vDist[isoId][0]],
                vDist[isoId][1],
                vecToidx[idx]
            ];
        };
        this.IDATA.edgematch = [
            [
                1,
                "B"
            ],
            [
                2,
                "B"
            ],
            [
                3,
                "B"
            ],
            [
                4,
                "B"
            ],
            [
                0,
                "B"
            ],
            [
                10,
                "O",
                14,
                "A"
            ],
            [
                11,
                "O",
                10,
                "A"
            ],
            [
                12,
                "O",
                11,
                "A"
            ],
            [
                13,
                "O",
                12,
                "A"
            ],
            [
                14,
                "O",
                13,
                "A"
            ],
            [
                0,
                "O"
            ],
            [
                1,
                "O"
            ],
            [
                2,
                "O"
            ],
            [
                3,
                "O"
            ],
            [
                4,
                "O"
            ],
            [
                19,
                "B",
                5,
                "A"
            ],
            [
                15,
                "B",
                6,
                "A"
            ],
            [
                16,
                "B",
                7,
                "A"
            ],
            [
                17,
                "B",
                8,
                "A"
            ],
            [
                18,
                "B",
                9,
                "A"
            ]
        ];
        /***edges AB to OB***** rotation about B*/ for(let f = 0; f < 20; f++){
            //f current face
            verts = this.IDATA.face[f];
            O = verts[2];
            A = verts[1];
            B = verts[0];
            isoId = oVec.x + "|" + oVec.y;
            idx = f + "|" + isoId;
            if (!(idx in vecToidx)) {
                vecToidx[idx] = O;
                closestTo[O] = [
                    verts[vDist[isoId][0]],
                    vDist[isoId][1]
                ];
            }
            isoId = aVec.x + "|" + aVec.y;
            idx = f + "|" + isoId;
            if (!(idx in vecToidx)) {
                vecToidx[idx] = A;
                closestTo[A] = [
                    verts[vDist[isoId][0]],
                    vDist[isoId][1]
                ];
            }
            isoId = bVec.x + "|" + bVec.y;
            idx = f + "|" + isoId;
            if (!(idx in vecToidx)) {
                vecToidx[idx] = B;
                closestTo[B] = [
                    verts[vDist[isoId][0]],
                    vDist[isoId][1]
                ];
            }
            //for edge vertices
            fr = this.IDATA.edgematch[f][0];
            rot = this.IDATA.edgematch[f][1];
            if (rot === "B") for(let i = 1; i < g; i++){
                abVec.x = m - i * (m1 + n1);
                abVec.y = n + i * m1;
                obVec.x = -i * n1;
                obVec.y = i * (m1 + n1);
                isoId = abVec.x + "|" + abVec.y;
                isoIdR = obVec.x + "|" + obVec.y;
                matchIdx(f, fr, isoId, isoIdR);
            }
            if (rot === "O") for(let i = 1; i < g; i++){
                obVec.x = -i * n1;
                obVec.y = i * (m1 + n1);
                oaVec.x = i * m1;
                oaVec.y = i * n1;
                isoId = obVec.x + "|" + obVec.y;
                isoIdR = oaVec.x + "|" + oaVec.y;
                matchIdx(f, fr, isoId, isoIdR);
            }
            fr = this.IDATA.edgematch[f][2];
            rot = this.IDATA.edgematch[f][3];
            if (rot && rot === "A") for(let i = 1; i < g; i++){
                oaVec.x = i * m1;
                oaVec.y = i * n1;
                abVec.x = m - (g - i) * (m1 + n1); //reversed for BA
                abVec.y = n + (g - i) * m1; //reversed for BA
                isoId = oaVec.x + "|" + oaVec.y;
                isoIdR = abVec.x + "|" + abVec.y;
                matchIdx(f, fr, isoId, isoIdR);
            }
            for(let i = 0; i < this.vertices.length; i++){
                isoId = this.vertices[i].x + "|" + this.vertices[i].y;
                idx = f + "|" + isoId;
                if (!(idx in vecToidx)) {
                    vecToidx[idx] = indexCount++;
                    if (vDist[isoId][0] > 2) closestTo[vecToidx[idx]] = [
                        -vDist[isoId][0],
                        vDist[isoId][1],
                        vecToidx[idx]
                    ];
                    else closestTo[vecToidx[idx]] = [
                        verts[vDist[isoId][0]],
                        vDist[isoId][1],
                        vecToidx[idx]
                    ];
                }
            }
        }
        this.closestTo = closestTo;
        this.vecToidx = vecToidx;
    }
    calcCoeffs() {
        const m = this.m;
        const n = this.n;
        const thirdR3 = Math.sqrt(3) / 3;
        const LSQD = m * m + n * n + m * n;
        this.coau = (m + n) / LSQD;
        this.cobu = -n / LSQD;
        this.coav = -thirdR3 * (m - n) / LSQD;
        this.cobv = thirdR3 * (2 * m + n) / LSQD;
    }
    createInnerFacets() {
        const m = this.m;
        const n = this.n;
        for(let y = 0; y < n + m + 1; y++)for(let x = this.min[y]; x < this.max[y] + 1; x++){
            if (x < this.max[y] && x < this.max[y + 1] + 1) this.innerFacets.push([
                "|" + x + "|" + y,
                "|" + x + "|" + (y + 1),
                "|" + (x + 1) + "|" + y
            ]);
            if (y > 0 && x < this.max[y - 1] && x + 1 < this.max[y] + 1) this.innerFacets.push([
                "|" + x + "|" + y,
                "|" + (x + 1) + "|" + y,
                "|" + (x + 1) + "|" + (y - 1)
            ]);
        }
    }
    edgeVecsABOB() {
        const m = this.m;
        const n = this.n;
        const B = new (0, $5osYn._IsoVector)(-n, m + n);
        for(let y = 1; y < m + n; y++){
            const point = new (0, $5osYn._IsoVector)(this.min[y], y);
            const prev = new (0, $5osYn._IsoVector)(this.min[y - 1], y - 1);
            const next = new (0, $5osYn._IsoVector)(this.min[y + 1], y + 1);
            const pointR = point.clone();
            const prevR = prev.clone();
            const nextR = next.clone();
            pointR.rotate60About(B);
            prevR.rotate60About(B);
            nextR.rotate60About(B);
            const maxPoint = new (0, $5osYn._IsoVector)(this.max[pointR.y], pointR.y);
            const maxPrev = new (0, $5osYn._IsoVector)(this.max[pointR.y - 1], pointR.y - 1);
            const maxLeftPrev = new (0, $5osYn._IsoVector)(this.max[pointR.y - 1] - 1, pointR.y - 1);
            if (pointR.x !== maxPoint.x || pointR.y !== maxPoint.y) {
                if (pointR.x !== maxPrev.x) {
                    // type2
                    //up
                    this.vertexTypes.push([
                        1,
                        0,
                        0
                    ]);
                    this.isoVecsABOB.push([
                        point,
                        maxPrev,
                        maxLeftPrev
                    ]);
                    //down
                    this.vertexTypes.push([
                        1,
                        0,
                        0
                    ]);
                    this.isoVecsABOB.push([
                        point,
                        maxLeftPrev,
                        maxPoint
                    ]);
                } else if (pointR.y === nextR.y) {
                    // type1
                    //up
                    this.vertexTypes.push([
                        1,
                        1,
                        0
                    ]);
                    this.isoVecsABOB.push([
                        point,
                        prev,
                        maxPrev
                    ]);
                    //down
                    this.vertexTypes.push([
                        1,
                        0,
                        1
                    ]);
                    this.isoVecsABOB.push([
                        point,
                        maxPrev,
                        next
                    ]);
                } else {
                    // type 0
                    //up
                    this.vertexTypes.push([
                        1,
                        1,
                        0
                    ]);
                    this.isoVecsABOB.push([
                        point,
                        prev,
                        maxPrev
                    ]);
                    //down
                    this.vertexTypes.push([
                        1,
                        0,
                        0
                    ]);
                    this.isoVecsABOB.push([
                        point,
                        maxPrev,
                        maxPoint
                    ]);
                }
            }
        }
    }
    mapABOBtoOBOA() {
        const point = new (0, $5osYn._IsoVector)(0, 0);
        for(let i = 0; i < this.isoVecsABOB.length; i++){
            const temp = [];
            for(let j = 0; j < 3; j++){
                point.x = this.isoVecsABOB[i][j].x;
                point.y = this.isoVecsABOB[i][j].y;
                if (this.vertexTypes[i][j] === 0) point.rotateNeg120(this.m, this.n);
                temp.push(point.clone());
            }
            this.isoVecsOBOA.push(temp);
        }
    }
    mapABOBtoBAOA() {
        const point = new (0, $5osYn._IsoVector)(0, 0);
        for(let i = 0; i < this.isoVecsABOB.length; i++){
            const temp = [];
            for(let j = 0; j < 3; j++){
                point.x = this.isoVecsABOB[i][j].x;
                point.y = this.isoVecsABOB[i][j].y;
                if (this.vertexTypes[i][j] === 1) point.rotate120(this.m, this.n);
                temp.push(point.clone());
            }
            this.isoVecsBAOA.push(temp);
        }
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    MapToFace(faceNb, geodesicData) {
        const F = this.IDATA.face[faceNb];
        const oidx = F[2];
        const aidx = F[1];
        const bidx = F[0];
        const O = (0, $ha1VO.Vector3).FromArray(this.IDATA.vertex[oidx]);
        const A = (0, $ha1VO.Vector3).FromArray(this.IDATA.vertex[aidx]);
        const B = (0, $ha1VO.Vector3).FromArray(this.IDATA.vertex[bidx]);
        const OA = A.subtract(O);
        const OB = B.subtract(O);
        const x = OA.scale(this.coau).add(OB.scale(this.cobu));
        const y = OA.scale(this.coav).add(OB.scale(this.cobv));
        const mapped = [];
        let idx;
        let tempVec = (0, $ha1VO.TmpVectors).Vector3[0];
        for(let i = 0; i < this.cartesian.length; i++){
            tempVec = x.scale(this.cartesian[i].x).add(y.scale(this.cartesian[i].y)).add(O);
            mapped[i] = [
                tempVec.x,
                tempVec.y,
                tempVec.z
            ];
            idx = faceNb + "|" + this.vertices[i].x + "|" + this.vertices[i].y;
            geodesicData.vertex[this.vecToidx[idx]] = [
                tempVec.x,
                tempVec.y,
                tempVec.z
            ];
        }
    }
    //statics
    /**Creates a primary triangle
     * @internal
     */ build(m, n) {
        const vertices = [];
        const O = (0, $5osYn._IsoVector).Zero();
        const A = new (0, $5osYn._IsoVector)(m, n);
        const B = new (0, $5osYn._IsoVector)(-n, m + n);
        vertices.push(O, A, B);
        //max internal isoceles triangle vertices
        for(let y = n; y < m + 1; y++)for(let x = 0; x < m + 1 - y; x++)vertices.push(new (0, $5osYn._IsoVector)(x, y));
        //shared vertices along edges when needed
        if (n > 0) {
            const g = (0, $1VEEL.Scalar).HCF(m, n);
            const m1 = m / g;
            const n1 = n / g;
            for(let i = 1; i < g; i++){
                vertices.push(new (0, $5osYn._IsoVector)(i * m1, i * n1)); //OA
                vertices.push(new (0, $5osYn._IsoVector)(-i * n1, i * (m1 + n1))); //OB
                vertices.push(new (0, $5osYn._IsoVector)(m - i * (m1 + n1), n + i * m1)); // AB
            }
            //lower rows vertices and their rotations
            const ratio = m / n;
            for(let y = 1; y < n; y++)for(let x = 0; x < y * ratio; x++){
                vertices.push(new (0, $5osYn._IsoVector)(x, y));
                vertices.push(new (0, $5osYn._IsoVector)(x, y).rotate120(m, n));
                vertices.push(new (0, $5osYn._IsoVector)(x, y).rotateNeg120(m, n));
            }
        }
        //order vertices by x and then y
        vertices.sort((a, b)=>{
            return a.x - b.x;
        });
        vertices.sort((a, b)=>{
            return a.y - b.y;
        });
        const min = new Array(m + n + 1);
        const max = new Array(m + n + 1);
        for(let i = 0; i < min.length; i++){
            min[i] = Infinity;
            max[i] = -Infinity;
        }
        let y = 0;
        let x = 0;
        const len = vertices.length;
        for(let i = 0; i < len; i++){
            x = vertices[i].x;
            y = vertices[i].y;
            min[y] = Math.min(x, min[y]);
            max[y] = Math.max(x, max[y]);
        }
        //calculates the distance of a vertex from a given primary vertex
        const distFrom = (vert, primVert)=>{
            const v = vert.clone();
            if (primVert === "A") v.rotateNeg120(m, n);
            if (primVert === "B") v.rotate120(m, n);
            if (v.x < 0) return v.y;
            return v.x + v.y;
        };
        const cartesian = [];
        const distFromO = [];
        const distFromA = [];
        const distFromB = [];
        const vertByDist = {};
        const vertData = [];
        let closest = -1;
        let dist = -1;
        for(let i = 0; i < len; i++){
            cartesian[i] = vertices[i].toCartesianOrigin(new (0, $5osYn._IsoVector)(0, 0), 0.5);
            distFromO[i] = distFrom(vertices[i], "O");
            distFromA[i] = distFrom(vertices[i], "A");
            distFromB[i] = distFrom(vertices[i], "B");
            if (distFromO[i] === distFromA[i] && distFromA[i] === distFromB[i]) {
                closest = 3;
                dist = distFromO[i];
            } else if (distFromO[i] === distFromA[i]) {
                closest = 4;
                dist = distFromO[i];
            } else if (distFromA[i] === distFromB[i]) {
                closest = 5;
                dist = distFromA[i];
            } else if (distFromB[i] === distFromO[i]) {
                closest = 6;
                dist = distFromO[i];
            }
            if (distFromO[i] < distFromA[i] && distFromO[i] < distFromB[i]) {
                closest = 2;
                dist = distFromO[i];
            }
            if (distFromA[i] < distFromO[i] && distFromA[i] < distFromB[i]) {
                closest = 1;
                dist = distFromA[i];
            }
            if (distFromB[i] < distFromA[i] && distFromB[i] < distFromO[i]) {
                closest = 0;
                dist = distFromB[i];
            }
            vertData.push([
                closest,
                dist,
                vertices[i].x,
                vertices[i].y
            ]);
        }
        vertData.sort((a, b)=>{
            return a[2] - b[2];
        });
        vertData.sort((a, b)=>{
            return a[3] - b[3];
        });
        vertData.sort((a, b)=>{
            return a[1] - b[1];
        });
        vertData.sort((a, b)=>{
            return a[0] - b[0];
        });
        for(let v = 0; v < vertData.length; v++)vertByDist[vertData[v][2] + "|" + vertData[v][3]] = [
            vertData[v][0],
            vertData[v][1],
            v
        ];
        this.m = m;
        this.n = n;
        this.vertices = vertices;
        this.vertByDist = vertByDist;
        this.cartesian = cartesian;
        this.min = min;
        this.max = max;
        return this;
    }
}
class $d65feca8fd77fc63$export$5e1fb625f5ac029c {
    constructor(/**
     * The name of the polyhedron
     */ name, /**
     * The category of the polyhedron
     */ category, /**
     * vertex data
     */ vertex, /**
     * face data
     */ face){
        this.name = name;
        this.category = category;
        this.vertex = vertex;
        this.face = face;
    }
}
class $d65feca8fd77fc63$export$f97f132d55c4fea9 extends $d65feca8fd77fc63$export$5e1fb625f5ac029c {
    /**
     * @internal
     */ innerToData(face, primTri) {
        for(let i = 0; i < primTri.innerFacets.length; i++)this.face.push(primTri.innerFacets[i].map((el)=>primTri.vecToidx[face + el]));
    }
    /**
     * @internal
     */ mapABOBtoDATA(faceNb, primTri) {
        const fr = primTri.IDATA.edgematch[faceNb][0];
        for(let i = 0; i < primTri.isoVecsABOB.length; i++){
            const temp = [];
            for(let j = 0; j < 3; j++)if (primTri.vertexTypes[i][j] === 0) temp.push(faceNb + "|" + primTri.isoVecsABOB[i][j].x + "|" + primTri.isoVecsABOB[i][j].y);
            else temp.push(fr + "|" + primTri.isoVecsABOB[i][j].x + "|" + primTri.isoVecsABOB[i][j].y);
            this.face.push([
                primTri.vecToidx[temp[0]],
                primTri.vecToidx[temp[1]],
                primTri.vecToidx[temp[2]]
            ]);
        }
    }
    /**
     * @internal
     */ mapOBOAtoDATA(faceNb, primTri) {
        const fr = primTri.IDATA.edgematch[faceNb][0];
        for(let i = 0; i < primTri.isoVecsOBOA.length; i++){
            const temp = [];
            for(let j = 0; j < 3; j++)if (primTri.vertexTypes[i][j] === 1) temp.push(faceNb + "|" + primTri.isoVecsOBOA[i][j].x + "|" + primTri.isoVecsOBOA[i][j].y);
            else temp.push(fr + "|" + primTri.isoVecsOBOA[i][j].x + "|" + primTri.isoVecsOBOA[i][j].y);
            this.face.push([
                primTri.vecToidx[temp[0]],
                primTri.vecToidx[temp[1]],
                primTri.vecToidx[temp[2]]
            ]);
        }
    }
    /**
     * @internal
     */ mapBAOAtoDATA(faceNb, primTri) {
        const fr = primTri.IDATA.edgematch[faceNb][2];
        for(let i = 0; i < primTri.isoVecsBAOA.length; i++){
            const temp = [];
            for(let j = 0; j < 3; j++)if (primTri.vertexTypes[i][j] === 1) temp.push(faceNb + "|" + primTri.isoVecsBAOA[i][j].x + "|" + primTri.isoVecsBAOA[i][j].y);
            else temp.push(fr + "|" + primTri.isoVecsBAOA[i][j].x + "|" + primTri.isoVecsBAOA[i][j].y);
            this.face.push([
                primTri.vecToidx[temp[0]],
                primTri.vecToidx[temp[1]],
                primTri.vecToidx[temp[2]]
            ]);
        }
    }
    /**
     * @internal
     */ orderData(primTri) {
        const nearTo = [];
        for(let i = 0; i < 13; i++)nearTo[i] = [];
        const close = primTri.closestTo;
        for(let i = 0; i < close.length; i++){
            if (close[i][0] > -1) {
                if (close[i][1] > 0) nearTo[close[i][0]].push([
                    i,
                    close[i][1]
                ]);
            } else nearTo[12].push([
                i,
                close[i][0]
            ]);
        }
        const near = [];
        for(let i = 0; i < 12; i++)near[i] = i;
        let nearIndex = 12;
        for(let i = 0; i < 12; i++){
            nearTo[i].sort((a, b)=>{
                return a[1] - b[1];
            });
            for(let j = 0; j < nearTo[i].length; j++)near[nearTo[i][j][0]] = nearIndex++;
        }
        for(let j = 0; j < nearTo[12].length; j++)near[nearTo[12][j][0]] = nearIndex++;
        for(let i = 0; i < this.vertex.length; i++)this.vertex[i].push(near[i]);
        this.vertex.sort((a, b)=>{
            return a[3] - b[3];
        });
        for(let i = 0; i < this.vertex.length; i++)this.vertex[i].pop();
        for(let i = 0; i < this.face.length; i++)for(let j = 0; j < this.face[i].length; j++)this.face[i][j] = near[this.face[i][j]];
        this.sharedNodes = nearTo[12].length;
        this.poleNodes = this.vertex.length - this.sharedNodes;
    }
    /**
     * @internal
     */ setOrder(m, faces) {
        const adjVerts = [];
        const dualFaces = [];
        let face = faces.pop();
        dualFaces.push(face);
        let index = this.face[face].indexOf(m);
        index = (index + 2) % 3;
        let v = this.face[face][index];
        adjVerts.push(v);
        let f = 0;
        while(faces.length > 0){
            face = faces[f];
            if (this.face[face].indexOf(v) > -1) {
                // v is a vertex of face f
                index = (this.face[face].indexOf(v) + 1) % 3;
                v = this.face[face][index];
                adjVerts.push(v);
                dualFaces.push(face);
                faces.splice(f, 1);
                f = 0;
            } else f++;
        }
        this.adjacentFaces.push(adjVerts);
        return dualFaces;
    }
    /**
     * @internal
     */ toGoldbergPolyhedronData() {
        const goldbergPolyhedronData = new $d65feca8fd77fc63$export$5e1fb625f5ac029c("GeoDual", "Goldberg", [], []);
        goldbergPolyhedronData.name = "GD dual";
        const verticesNb = this.vertex.length;
        const map = new Array(verticesNb);
        for(let v = 0; v < verticesNb; v++)map[v] = [];
        for(let f = 0; f < this.face.length; f++)for(let i = 0; i < 3; i++)map[this.face[f][i]].push(f);
        let cx = 0;
        let cy = 0;
        let cz = 0;
        let face = [];
        let vertex = [];
        this.adjacentFaces = [];
        for(let m = 0; m < map.length; m++){
            goldbergPolyhedronData.face[m] = this.setOrder(m, map[m].concat([]));
            map[m].forEach((el)=>{
                cx = 0;
                cy = 0;
                cz = 0;
                face = this.face[el];
                for(let i = 0; i < 3; i++){
                    vertex = this.vertex[face[i]];
                    cx += vertex[0];
                    cy += vertex[1];
                    cz += vertex[2];
                }
                goldbergPolyhedronData.vertex[el] = [
                    cx / 3,
                    cy / 3,
                    cz / 3
                ];
            });
        }
        return goldbergPolyhedronData;
    }
    //statics
    /**Builds the data for a Geodesic Polyhedron from a primary triangle
     * @param primTri the primary triangle
     * @internal
     */ static BuildGeodesicData(primTri) {
        const geodesicData = new $d65feca8fd77fc63$export$f97f132d55c4fea9("Geodesic-m-n", "Geodesic", [
            [
                0,
                (0, $53VPf.PHI),
                -1
            ],
            [
                -(0, $53VPf.PHI),
                1,
                0
            ],
            [
                -1,
                0,
                -(0, $53VPf.PHI)
            ],
            [
                1,
                0,
                -(0, $53VPf.PHI)
            ],
            [
                (0, $53VPf.PHI),
                1,
                0
            ],
            [
                0,
                (0, $53VPf.PHI),
                1
            ],
            [
                -1,
                0,
                (0, $53VPf.PHI)
            ],
            [
                -(0, $53VPf.PHI),
                -1,
                0
            ],
            [
                0,
                -(0, $53VPf.PHI),
                -1
            ],
            [
                (0, $53VPf.PHI),
                -1,
                0
            ],
            [
                1,
                0,
                (0, $53VPf.PHI)
            ],
            [
                0,
                -(0, $53VPf.PHI),
                1
            ]
        ], []);
        primTri.setIndices();
        primTri.calcCoeffs();
        primTri.createInnerFacets();
        primTri.edgeVecsABOB();
        primTri.mapABOBtoOBOA();
        primTri.mapABOBtoBAOA();
        for(let f = 0; f < primTri.IDATA.face.length; f++){
            primTri.MapToFace(f, geodesicData);
            geodesicData.innerToData(f, primTri);
            if (primTri.IDATA.edgematch[f][1] === "B") geodesicData.mapABOBtoDATA(f, primTri);
            if (primTri.IDATA.edgematch[f][1] === "O") geodesicData.mapOBOAtoDATA(f, primTri);
            if (primTri.IDATA.edgematch[f][3] === "A") geodesicData.mapBAOAtoDATA(f, primTri);
        }
        geodesicData.orderData(primTri);
        const radius = 1;
        geodesicData.vertex = geodesicData.vertex.map(function(el) {
            const a = el[0];
            const b = el[1];
            const c = el[2];
            const d = Math.sqrt(a * a + b * b + c * c);
            el[0] *= radius / d;
            el[1] *= radius / d;
            el[2] *= radius / d;
            return el;
        });
        return geodesicData;
    }
}

});
parcelRegister("5osYn", function(module, exports) {

$parcel$export(module.exports, "_IsoVector", () => $3ed5ab04dea8673e$export$6d3da39d626954f1);

var $kVtWi = parcelRequire("kVtWi");

var $ha1VO = parcelRequire("ha1VO");
class $3ed5ab04dea8673e$export$6d3da39d626954f1 {
    /**
     * Creates a new isovector from the given x and y coordinates
     * @param x defines the first coordinate, must be an integer
     * @param y defines the second coordinate, must be an integer
     */ constructor(/** defines the first coordinate */ x = 0, /** defines the second coordinate */ y = 0){
        this.x = x;
        this.y = y;
        if (x !== Math.floor(x)) {
            x;
            (0, $kVtWi.Logger).Warn("x is not an integer, floor(x) used");
        }
        if (y !== Math.floor(y)) {
            y;
            (0, $kVtWi.Logger).Warn("y is not an integer, floor(y) used");
        }
    }
    // Operators
    /**
     * Gets a new IsoVector copied from the IsoVector
     * @returns a new IsoVector
     */ clone() {
        return new $3ed5ab04dea8673e$export$6d3da39d626954f1(this.x, this.y);
    }
    /**
     * Rotates one IsoVector 60 degrees counter clockwise about another
     * Please note that this is an in place operation
     * @param other an IsoVector a center of rotation
     * @returns the rotated IsoVector
     */ rotate60About(other) {
        //other IsoVector
        const x = this.x;
        this.x = other.x + other.y - this.y;
        this.y = x + this.y - other.x;
        return this;
    }
    /**
     * Rotates one IsoVector 60 degrees clockwise about another
     * Please note that this is an in place operation
     * @param other an IsoVector as center of rotation
     * @returns the rotated IsoVector
     */ rotateNeg60About(other) {
        const x = this.x;
        this.x = x + this.y - other.y;
        this.y = other.x + other.y - x;
        return this;
    }
    /**
     * For an equilateral triangle OAB with O at isovector (0, 0) and A at isovector (m, n)
     * Rotates one IsoVector 120 degrees counter clockwise about the center of the triangle
     * Please note that this is an in place operation
     * @param m integer a measure a Primary triangle of order (m, n) m > n
     * @param n >= 0 integer a measure for a Primary triangle of order (m, n)
     * @returns the rotated IsoVector
     */ rotate120(m, n) {
        //m, n integers
        if (m !== Math.floor(m)) {
            m;
            (0, $kVtWi.Logger).Warn("m not an integer only floor(m) used");
        }
        if (n !== Math.floor(n)) {
            n;
            (0, $kVtWi.Logger).Warn("n not an integer only floor(n) used");
        }
        const x = this.x;
        this.x = m - x - this.y;
        this.y = n + x;
        return this;
    }
    /**
     * For an equilateral triangle OAB with O at isovector (0, 0) and A at isovector (m, n)
     * Rotates one IsoVector 120 degrees clockwise about the center of the triangle
     * Please note that this is an in place operation
     * @param m integer a measure a Primary triangle of order (m, n) m > n
     * @param n >= 0 integer a measure for a Primary triangle of order (m, n)
     * @returns the rotated IsoVector
     */ rotateNeg120(m, n) {
        //m, n integers
        if (m !== Math.floor(m)) {
            m;
            (0, $kVtWi.Logger).Warn("m is not an integer, floor(m) used");
        }
        if (n !== Math.floor(n)) {
            n;
            (0, $kVtWi.Logger).Warn("n is not an integer,   floor(n) used");
        }
        const x = this.x;
        this.x = this.y - n;
        this.y = m + n - x - this.y;
        return this;
    }
    /**
     * Transforms an IsoVector to one in Cartesian 3D space based on an isovector
     * @param origin an IsoVector
     * @param isoGridSize
     * @returns Point as a Vector3
     */ toCartesianOrigin(origin, isoGridSize) {
        const point = (0, $ha1VO.Vector3).Zero();
        point.x = origin.x + 2 * this.x * isoGridSize + this.y * isoGridSize;
        point.y = origin.y + Math.sqrt(3) * this.y * isoGridSize;
        return point;
    }
    // Statics
    /**
     * Gets a new IsoVector(0, 0)
     * @returns a new IsoVector
     */ static Zero() {
        return new $3ed5ab04dea8673e$export$6d3da39d626954f1(0, 0);
    }
}

});



parcelRegister("5EAju", function(module, exports) {

$parcel$export(module.exports, "CreateGoldbergVertexData", () => $41dcdb4627c57f34$export$e4bb3982c9d1679d);
$parcel$export(module.exports, "CreateGoldberg", () => $41dcdb4627c57f34$export$5f8a698e30111661);

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $fbuqw = parcelRequire("fbuqw");

var $5v6ry = parcelRequire("5v6ry");

var $kVtWi = parcelRequire("kVtWi");

var $ip6UH = parcelRequire("ip6UH");

var $c0aRk = parcelRequire("c0aRk");

var $fGXjI = parcelRequire("fGXjI");
function $41dcdb4627c57f34$export$e4bb3982c9d1679d(options, goldbergData) {
    const size = options.size;
    const sizeX = options.sizeX || size || 1;
    const sizeY = options.sizeY || size || 1;
    const sizeZ = options.sizeZ || size || 1;
    const sideOrientation = options.sideOrientation === 0 ? 0 : options.sideOrientation || (0, $5v6ry.VertexData).DEFAULTSIDE;
    const positions = [];
    const indices = [];
    const normals = [];
    const uvs = [];
    let minX = Infinity;
    let maxX = -Infinity;
    let minY = Infinity;
    let maxY = -Infinity;
    for(let v = 0; v < goldbergData.vertex.length; v++){
        minX = Math.min(minX, goldbergData.vertex[v][0] * sizeX);
        maxX = Math.max(maxX, goldbergData.vertex[v][0] * sizeX);
        minY = Math.min(minY, goldbergData.vertex[v][1] * sizeY);
        maxY = Math.max(maxY, goldbergData.vertex[v][1] * sizeY);
    }
    let index = 0;
    for(let f = 0; f < goldbergData.face.length; f++){
        const verts = goldbergData.face[f];
        const a = (0, $ha1VO.Vector3).FromArray(goldbergData.vertex[verts[0]]);
        const b = (0, $ha1VO.Vector3).FromArray(goldbergData.vertex[verts[2]]);
        const c = (0, $ha1VO.Vector3).FromArray(goldbergData.vertex[verts[1]]);
        const ba = b.subtract(a);
        const ca = c.subtract(a);
        const norm = (0, $ha1VO.Vector3).Cross(ca, ba).normalize();
        for(let v = 0; v < verts.length; v++){
            normals.push(norm.x, norm.y, norm.z);
            const pdata = goldbergData.vertex[verts[v]];
            positions.push(pdata[0] * sizeX, pdata[1] * sizeY, pdata[2] * sizeZ);
            const vCoord = (pdata[1] * sizeY - minY) / (maxY - minY);
            uvs.push((pdata[0] * sizeX - minX) / (maxX - minX), (0, $fGXjI.CompatibilityOptions).UseOpenGLOrientationForUV ? 1 - vCoord : vCoord);
        }
        for(let v = 0; v < verts.length - 2; v++)indices.push(index, index + v + 2, index + v + 1);
        index += verts.length;
    }
    (0, $5v6ry.VertexData)._ComputeSides(sideOrientation, positions, indices, normals, uvs);
    const vertexData = new (0, $5v6ry.VertexData)();
    vertexData.positions = positions;
    vertexData.indices = indices;
    vertexData.normals = normals;
    vertexData.uvs = uvs;
    return vertexData;
}
function $41dcdb4627c57f34$export$5f8a698e30111661(name, options, scene = null) {
    const size = options.size;
    const sizeX = options.sizeX || size || 1;
    const sizeY = options.sizeY || size || 1;
    const sizeZ = options.sizeZ || size || 1;
    let m = options.m || 1;
    if (m !== Math.floor(m)) {
        m;
        (0, $kVtWi.Logger).Warn("m not an integer only floor(m) used");
    }
    let n = options.n || 0;
    if (n !== Math.floor(n)) {
        n;
        (0, $kVtWi.Logger).Warn("n not an integer only floor(n) used");
    }
    if (n > m) {
        const temp = n;
        n = m;
        m = temp;
        (0, $kVtWi.Logger).Warn("n > m therefore m and n swapped");
    }
    const primTri = new (0, $ip6UH._PrimaryIsoTriangle)();
    primTri.build(m, n);
    const geodesicData = (0, $ip6UH.GeodesicData).BuildGeodesicData(primTri);
    const goldbergData = geodesicData.toGoldbergPolyhedronData();
    const goldberg = new (0, $c0aRk.GoldbergMesh)(name, scene);
    options.sideOrientation = (0, $fbuqw.Mesh)._GetDefaultSideOrientation(options.sideOrientation);
    goldberg._originalBuilderSideOrientation = options.sideOrientation;
    const vertexData = $41dcdb4627c57f34$export$e4bb3982c9d1679d(options, goldbergData);
    vertexData.applyToMesh(goldberg, options.updatable);
    goldberg.goldbergData.nbSharedFaces = geodesicData.sharedNodes;
    goldberg.goldbergData.nbUnsharedFaces = geodesicData.poleNodes;
    goldberg.goldbergData.adjacentFaces = geodesicData.adjacentFaces;
    goldberg.goldbergData.nbFaces = goldberg.goldbergData.nbSharedFaces + goldberg.goldbergData.nbUnsharedFaces;
    goldberg.goldbergData.nbFacesAtPole = (goldberg.goldbergData.nbUnsharedFaces - 12) / 12;
    for(let f = 0; f < geodesicData.vertex.length; f++){
        goldberg.goldbergData.faceCenters.push((0, $ha1VO.Vector3).FromArray(geodesicData.vertex[f]));
        goldberg.goldbergData.faceCenters[f].x *= sizeX;
        goldberg.goldbergData.faceCenters[f].y *= sizeY;
        goldberg.goldbergData.faceCenters[f].z *= sizeZ;
        goldberg.goldbergData.faceColors.push(new (0, $7etnY.Color4)(1, 1, 1, 1));
    }
    for(let f = 0; f < goldbergData.face.length; f++){
        const verts = goldbergData.face[f];
        const a = (0, $ha1VO.Vector3).FromArray(goldbergData.vertex[verts[0]]);
        const b = (0, $ha1VO.Vector3).FromArray(goldbergData.vertex[verts[2]]);
        const c = (0, $ha1VO.Vector3).FromArray(goldbergData.vertex[verts[1]]);
        const ba = b.subtract(a);
        const ca = c.subtract(a);
        const norm = (0, $ha1VO.Vector3).Cross(ca, ba).normalize();
        const z = (0, $ha1VO.Vector3).Cross(ca, norm).normalize();
        goldberg.goldbergData.faceXaxis.push(ca.normalize());
        goldberg.goldbergData.faceYaxis.push(norm);
        goldberg.goldbergData.faceZaxis.push(z);
    }
    return goldberg;
}

});
parcelRegister("c0aRk", function(module, exports) {

$parcel$export(module.exports, "GoldbergMesh", () => $8bcde881235d9b6b$export$33c9f07b719e61e4);

var $ha1VO = parcelRequire("ha1VO");

var $b4i1f = parcelRequire("b4i1f");

var $fbuqw = parcelRequire("fbuqw");

var $7etnY = parcelRequire("7etnY");

var $kVtWi = parcelRequire("kVtWi");
(0, $fbuqw.Mesh)._GoldbergMeshParser = (parsedMesh, scene)=>{
    return $8bcde881235d9b6b$export$33c9f07b719e61e4.Parse(parsedMesh, scene);
};
class $8bcde881235d9b6b$export$33c9f07b719e61e4 extends (0, $fbuqw.Mesh) {
    constructor(){
        super(...arguments);
        /**
         * Defines the specific Goldberg data used in this mesh construction.
         */ this.goldbergData = {
            faceColors: [],
            faceCenters: [],
            faceZaxis: [],
            faceXaxis: [],
            faceYaxis: [],
            nbSharedFaces: 0,
            nbUnsharedFaces: 0,
            nbFaces: 0,
            nbFacesAtPole: 0,
            adjacentFaces: []
        };
    }
    /**
     * Gets the related Goldberg face from pole infos
     * @param poleOrShared Defines the pole index or the shared face index if the fromPole parameter is passed in
     * @param fromPole Defines an optional pole index to find the related info from
     * @returns the goldberg face number
     */ relatedGoldbergFace(poleOrShared, fromPole) {
        if (fromPole === void 0) {
            if (poleOrShared > this.goldbergData.nbUnsharedFaces - 1) {
                (0, $kVtWi.Logger).Warn("Maximum number of unshared faces used");
                poleOrShared = this.goldbergData.nbUnsharedFaces - 1;
            }
            return this.goldbergData.nbUnsharedFaces + poleOrShared;
        }
        if (poleOrShared > 11) {
            (0, $kVtWi.Logger).Warn("Last pole used");
            poleOrShared = 11;
        }
        if (fromPole > this.goldbergData.nbFacesAtPole - 1) {
            (0, $kVtWi.Logger).Warn("Maximum number of faces at a pole used");
            fromPole = this.goldbergData.nbFacesAtPole - 1;
        }
        return 12 + poleOrShared * this.goldbergData.nbFacesAtPole + fromPole;
    }
    _changeGoldbergFaceColors(colorRange) {
        for(let i = 0; i < colorRange.length; i++){
            const min = colorRange[i][0];
            const max = colorRange[i][1];
            const col = colorRange[i][2];
            for(let f = min; f < max + 1; f++)this.goldbergData.faceColors[f] = col;
        }
        const newCols = [];
        for(let f = 0; f < 12; f++)for(let i = 0; i < 5; i++)newCols.push(this.goldbergData.faceColors[f].r, this.goldbergData.faceColors[f].g, this.goldbergData.faceColors[f].b, this.goldbergData.faceColors[f].a);
        for(let f = 12; f < this.goldbergData.faceColors.length; f++)for(let i = 0; i < 6; i++)newCols.push(this.goldbergData.faceColors[f].r, this.goldbergData.faceColors[f].g, this.goldbergData.faceColors[f].b, this.goldbergData.faceColors[f].a);
        return newCols;
    }
    /**
     * Set new goldberg face colors
     * @param colorRange the new color to apply to the mesh
     */ setGoldbergFaceColors(colorRange) {
        const newCols = this._changeGoldbergFaceColors(colorRange);
        this.setVerticesData((0, $b4i1f.VertexBuffer).ColorKind, newCols);
    }
    /**
     * Updates new goldberg face colors
     * @param colorRange the new color to apply to the mesh
     */ updateGoldbergFaceColors(colorRange) {
        const newCols = this._changeGoldbergFaceColors(colorRange);
        this.updateVerticesData((0, $b4i1f.VertexBuffer).ColorKind, newCols);
    }
    _changeGoldbergFaceUVs(uvRange) {
        const uvs = this.getVerticesData((0, $b4i1f.VertexBuffer).UVKind);
        for(let i = 0; i < uvRange.length; i++){
            const min = uvRange[i][0];
            const max = uvRange[i][1];
            const center = uvRange[i][2];
            const radius = uvRange[i][3];
            const angle = uvRange[i][4];
            const points5 = [];
            const points6 = [];
            let u;
            let v;
            for(let p = 0; p < 5; p++){
                u = center.x + radius * Math.cos(angle + p * Math.PI / 2.5);
                v = center.y + radius * Math.sin(angle + p * Math.PI / 2.5);
                if (u < 0) u = 0;
                if (u > 1) u = 1;
                points5.push(u, v);
            }
            for(let p = 0; p < 6; p++){
                u = center.x + radius * Math.cos(angle + p * Math.PI / 3);
                v = center.y + radius * Math.sin(angle + p * Math.PI / 3);
                if (u < 0) u = 0;
                if (u > 1) u = 1;
                points6.push(u, v);
            }
            for(let f = min; f < Math.min(12, max + 1); f++)for(let p = 0; p < 5; p++){
                uvs[10 * f + 2 * p] = points5[2 * p];
                uvs[10 * f + 2 * p + 1] = points5[2 * p + 1];
            }
            for(let f = Math.max(12, min); f < max + 1; f++)for(let p = 0; p < 6; p++){
                //120 + 12 * (f - 12) = 12 * f - 24
                uvs[12 * f - 24 + 2 * p] = points6[2 * p];
                uvs[12 * f - 23 + 2 * p] = points6[2 * p + 1];
            }
        }
        return uvs;
    }
    /**
     * set new goldberg face UVs
     * @param uvRange the new UVs to apply to the mesh
     */ setGoldbergFaceUVs(uvRange) {
        const newUVs = this._changeGoldbergFaceUVs(uvRange);
        this.setVerticesData((0, $b4i1f.VertexBuffer).UVKind, newUVs);
    }
    /**
     * Updates new goldberg face UVs
     * @param uvRange the new UVs to apply to the mesh
     */ updateGoldbergFaceUVs(uvRange) {
        const newUVs = this._changeGoldbergFaceUVs(uvRange);
        this.updateVerticesData((0, $b4i1f.VertexBuffer).UVKind, newUVs);
    }
    /**
     * Places a mesh on a particular face of the goldberg polygon
     * @param mesh Defines the mesh to position
     * @param face Defines the face to position onto
     * @param position Defines the position relative to the face we are positioning the mesh onto
     */ placeOnGoldbergFaceAt(mesh, face, position) {
        const orientation = (0, $ha1VO.Vector3).RotationFromAxis(this.goldbergData.faceXaxis[face], this.goldbergData.faceYaxis[face], this.goldbergData.faceZaxis[face]);
        mesh.rotation = orientation;
        mesh.position = this.goldbergData.faceCenters[face].add(this.goldbergData.faceXaxis[face].scale(position.x)).add(this.goldbergData.faceYaxis[face].scale(position.y)).add(this.goldbergData.faceZaxis[face].scale(position.z));
    }
    /**
     * Serialize current mesh
     * @param serializationObject defines the object which will receive the serialization data
     */ serialize(serializationObject) {
        super.serialize(serializationObject);
        serializationObject.type = "GoldbergMesh";
        const goldbergData = {};
        goldbergData.adjacentFaces = this.goldbergData.adjacentFaces;
        goldbergData.nbSharedFaces = this.goldbergData.nbSharedFaces;
        goldbergData.nbUnsharedFaces = this.goldbergData.nbUnsharedFaces;
        goldbergData.nbFaces = this.goldbergData.nbFaces;
        goldbergData.nbFacesAtPole = this.goldbergData.nbFacesAtPole;
        if (this.goldbergData.faceColors) {
            goldbergData.faceColors = [];
            for (const color of this.goldbergData.faceColors)goldbergData.faceColors.push(color.asArray());
        }
        if (this.goldbergData.faceCenters) {
            goldbergData.faceCenters = [];
            for (const vector of this.goldbergData.faceCenters)goldbergData.faceCenters.push(vector.asArray());
        }
        if (this.goldbergData.faceZaxis) {
            goldbergData.faceZaxis = [];
            for (const vector of this.goldbergData.faceZaxis)goldbergData.faceZaxis.push(vector.asArray());
        }
        if (this.goldbergData.faceYaxis) {
            goldbergData.faceYaxis = [];
            for (const vector of this.goldbergData.faceYaxis)goldbergData.faceYaxis.push(vector.asArray());
        }
        if (this.goldbergData.faceXaxis) {
            goldbergData.faceXaxis = [];
            for (const vector of this.goldbergData.faceXaxis)goldbergData.faceXaxis.push(vector.asArray());
        }
        serializationObject.goldbergData = goldbergData;
    }
    /**
     * Parses a serialized goldberg mesh
     * @param parsedMesh the serialized mesh
     * @param scene the scene to create the goldberg mesh in
     * @returns the created goldberg mesh
     */ static Parse(parsedMesh, scene) {
        const goldbergData = parsedMesh.goldbergData;
        goldbergData.faceColors = goldbergData.faceColors.map((el)=>(0, $7etnY.Color4).FromArray(el));
        goldbergData.faceCenters = goldbergData.faceCenters.map((el)=>(0, $ha1VO.Vector3).FromArray(el));
        goldbergData.faceZaxis = goldbergData.faceZaxis.map((el)=>(0, $ha1VO.Vector3).FromArray(el));
        goldbergData.faceXaxis = goldbergData.faceXaxis.map((el)=>(0, $ha1VO.Vector3).FromArray(el));
        goldbergData.faceYaxis = goldbergData.faceYaxis.map((el)=>(0, $ha1VO.Vector3).FromArray(el));
        const goldberg = new $8bcde881235d9b6b$export$33c9f07b719e61e4(parsedMesh.name, scene);
        goldberg.goldbergData = goldbergData;
        return goldberg;
    }
}

});


parcelRegister("dBltS", function(module, exports) {

$parcel$export(module.exports, "CreateTextShapePaths", () => $9e6f64b8b89708c8$export$9a18c13a50e752ce);
$parcel$export(module.exports, "CreateText", () => $9e6f64b8b89708c8$export$1d5955fa6cbe384b);

var $fm2C6 = parcelRequire("fm2C6");

var $ha1VO = parcelRequire("ha1VO");

var $fbuqw = parcelRequire("fbuqw");

var $klshO = parcelRequire("klshO");

var $a2Hja = parcelRequire("a2Hja");
// Shape functions
class $9e6f64b8b89708c8$var$ShapePath {
    /** Create the ShapePath used to support glyphs
     * @param resolution defines the resolution used to determine the number of points per curve (default is 4)
     */ constructor(resolution){
        this._paths = [];
        this._tempPaths = [];
        this._holes = [];
        this._resolution = resolution;
    }
    /** Move the virtual cursor to a coordinate
     * @param x defines the x coordinate
     * @param y defines the y coordinate
     */ moveTo(x, y) {
        this._currentPath = new (0, $fm2C6.Path2)(x, y);
        this._tempPaths.push(this._currentPath);
    }
    /** Draw a line from the virtual cursor to a given coordinate
     * @param x defines the x coordinate
     * @param y defines the y coordinate
     */ lineTo(x, y) {
        this._currentPath.addLineTo(x, y);
    }
    /** Create a quadratic curve from the virtual cursor to a given coordinate
     * @param cpx defines the x coordinate of the control point
     * @param cpy defines the y coordinate of the control point
     * @param x defines the x coordinate of the end point
     * @param y defines the y coordinate of the end point
     */ quadraticCurveTo(cpx, cpy, x, y) {
        this._currentPath.addQuadraticCurveTo(cpx, cpy, x, y, this._resolution);
    }
    /**
     * Create a bezier curve from the virtual cursor to a given coordinate
     * @param cpx1 defines the x coordinate of the first control point
     * @param cpy1 defines the y coordinate of the first control point
     * @param cpx2 defines the x coordinate of the second control point
     * @param cpy2 defines the y coordinate of the second control point
     * @param x defines the x coordinate of the end point
     * @param y defines the y coordinate of the end point
     */ bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x, y) {
        this._currentPath.addBezierCurveTo(cpx1, cpy1, cpx2, cpy2, x, y, this._resolution);
    }
    /** Extract holes based on CW / CCW */ extractHoles() {
        for (const path of this._tempPaths)if (path.area() > 0) this._holes.push(path);
        else this._paths.push(path);
        if (!this._paths.length && this._holes.length) {
            const temp = this._holes;
            this._holes = this._paths;
            this._paths = temp;
        }
        this._tempPaths.length = 0;
    }
    /** Gets the list of paths */ get paths() {
        return this._paths;
    }
    /** Gets the list of holes */ get holes() {
        return this._holes;
    }
}
// Utility functions
function $9e6f64b8b89708c8$var$CreateShapePath(char, scale, offsetX, offsetY, resolution, fontData) {
    const glyph = fontData.glyphs[char] || fontData.glyphs["?"];
    if (!glyph) // return if there is no glyph data
    return null;
    const shapePath = new $9e6f64b8b89708c8$var$ShapePath(resolution);
    if (glyph.o) {
        const outline = glyph.o.split(" ");
        for(let i = 0, l = outline.length; i < l;){
            const action = outline[i++];
            switch(action){
                case "m":
                    {
                        // moveTo
                        const x = parseInt(outline[i++]) * scale + offsetX;
                        const y = parseInt(outline[i++]) * scale + offsetY;
                        shapePath.moveTo(x, y);
                        break;
                    }
                case "l":
                    {
                        // lineTo
                        const x = parseInt(outline[i++]) * scale + offsetX;
                        const y = parseInt(outline[i++]) * scale + offsetY;
                        shapePath.lineTo(x, y);
                        break;
                    }
                case "q":
                    {
                        // quadraticCurveTo
                        const cpx = parseInt(outline[i++]) * scale + offsetX;
                        const cpy = parseInt(outline[i++]) * scale + offsetY;
                        const cpx1 = parseInt(outline[i++]) * scale + offsetX;
                        const cpy1 = parseInt(outline[i++]) * scale + offsetY;
                        shapePath.quadraticCurveTo(cpx1, cpy1, cpx, cpy);
                        break;
                    }
                case "b":
                    {
                        // bezierCurveTo
                        const cpx = parseInt(outline[i++]) * scale + offsetX;
                        const cpy = parseInt(outline[i++]) * scale + offsetY;
                        const cpx1 = parseInt(outline[i++]) * scale + offsetX;
                        const cpy1 = parseInt(outline[i++]) * scale + offsetY;
                        const cpx2 = parseInt(outline[i++]) * scale + offsetX;
                        const cpy2 = parseInt(outline[i++]) * scale + offsetY;
                        shapePath.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, cpx, cpy);
                        break;
                    }
            }
        }
    }
    // Extract holes (based on clockwise data)
    shapePath.extractHoles();
    return {
        offsetX: glyph.ha * scale,
        shapePath: shapePath
    };
}
function $9e6f64b8b89708c8$export$9a18c13a50e752ce(text, size, resolution, fontData) {
    const chars = Array.from(text);
    const scale = size / fontData.resolution;
    const line_height = (fontData.boundingBox.yMax - fontData.boundingBox.yMin + fontData.underlineThickness) * scale;
    const shapePaths = [];
    let offsetX = 0, offsetY = 0;
    for(let i = 0; i < chars.length; i++){
        const char = chars[i];
        if (char === "\n") {
            offsetX = 0;
            offsetY -= line_height;
        } else {
            const ret = $9e6f64b8b89708c8$var$CreateShapePath(char, scale, offsetX, offsetY, resolution, fontData);
            if (ret) {
                offsetX += ret.offsetX;
                shapePaths.push(ret.shapePath);
            }
        }
    }
    return shapePaths;
}
function $9e6f64b8b89708c8$export$1d5955fa6cbe384b(name, text, fontData, options = {
    size: 50,
    resolution: 8,
    depth: 1.0
}, scene = null, earcutInjection = earcut) {
    // First we need to generate the paths
    const shapePaths = $9e6f64b8b89708c8$export$9a18c13a50e752ce(text, options.size || 50, options.resolution || 8, fontData);
    // And extrude them
    const meshes = [];
    let letterIndex = 0;
    for (const shapePath of shapePaths){
        if (!shapePath.paths.length) continue;
        const holes = shapePath.holes.slice(); // Copy it as we will update the copy
        for (const path of shapePath.paths){
            const holeVectors = [];
            const shapeVectors = [];
            const points = path.getPoints();
            for (const point of points)shapeVectors.push(new (0, $ha1VO.Vector3)(point.x, 0, point.y)); // ExtrudePolygon expects data on the xz plane
            // Holes
            const localHolesCopy = holes.slice();
            for (const hole of localHolesCopy){
                const points = hole.getPoints();
                let found = false;
                for (const point of points)if (path.isPointInside(point)) {
                    found = true;
                    break;
                }
                if (!found) continue;
                const holePoints = [];
                for (const point of points)holePoints.push(new (0, $ha1VO.Vector3)(point.x, 0, point.y)); // ExtrudePolygon expects data on the xz plane
                holeVectors.push(holePoints);
                // Remove the hole as it was already used
                holes.splice(holes.indexOf(hole), 1);
            }
            // There is at least a hole but it was unaffected
            if (!holeVectors.length && holes.length) for (const hole of holes){
                const points = hole.getPoints();
                const holePoints = [];
                for (const point of points)holePoints.push(new (0, $ha1VO.Vector3)(point.x, 0, point.y)); // ExtrudePolygon expects data on the xz plane
                holeVectors.push(holePoints);
            }
            // Extrusion!
            const mesh = (0, $a2Hja.ExtrudePolygon)(name, {
                shape: shapeVectors,
                holes: holeVectors.length ? holeVectors : undefined,
                depth: options.depth || 1.0,
                faceUV: options.faceUV || options.perLetterFaceUV?.(letterIndex),
                faceColors: options.faceColors || options.perLetterFaceColors?.(letterIndex),
                sideOrientation: (0, $fbuqw.Mesh)._GetDefaultSideOrientation(options.sideOrientation || (0, $fbuqw.Mesh).DOUBLESIDE)
            }, scene, earcutInjection);
            meshes.push(mesh);
            letterIndex++;
        }
    }
    // Then we can merge everyone into one single mesh
    const newMesh = (0, $fbuqw.Mesh).MergeMeshes(meshes, true, true);
    if (newMesh) {
        // Move pivot to desired center / bottom / center position
        const bbox = newMesh.getBoundingInfo().boundingBox;
        newMesh.position.x += -(bbox.minimumWorld.x + bbox.maximumWorld.x) / 2; // Mid X
        newMesh.position.y += -(bbox.minimumWorld.y + bbox.maximumWorld.y) / 2; // Mid Z as it will rotate
        newMesh.position.z += -(bbox.minimumWorld.z + bbox.maximumWorld.z) / 2 + bbox.extendSize.z; // Bottom Y as it will rotate
        newMesh.name = name;
        // Rotate 90° Up
        const pivot = new (0, $klshO.TransformNode)("pivot", scene);
        pivot.rotation.x = -Math.PI / 2;
        newMesh.parent = pivot;
        newMesh.bakeCurrentTransformIntoVertices();
        // Remove the pivot
        newMesh.parent = null;
        pivot.dispose();
    }
    return newMesh;
}

});



parcelRegister("esPUB", function(module, exports) {

$parcel$export(module.exports, "RayHelper", () => $a87bf2d4e7a93a24$export$6f7dfd58c96ae979);

var $ha1VO = parcelRequire("ha1VO");

var $8Eyol = parcelRequire("8Eyol");
class $a87bf2d4e7a93a24$export$6f7dfd58c96ae979 {
    /**
     * Helper function to create a colored helper in a scene in one line.
     * @param ray Defines the ray we are currently trying to visualize
     * @param scene Defines the scene the ray is used in
     * @param color Defines the color we want to see the ray in
     * @returns The newly created ray helper.
     */ static CreateAndShow(ray, scene, color) {
        const helper = new $a87bf2d4e7a93a24$export$6f7dfd58c96ae979(ray);
        helper.show(scene, color);
        return helper;
    }
    /**
     * Instantiate a new ray helper.
     * As raycast might be hard to debug, the RayHelper can help rendering the different rays
     * in order to better appreciate the issue one might have.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/mesh/interactions/picking_collisions#debugging
     * @param ray Defines the ray we are currently trying to visualize
     */ constructor(ray){
        this.ray = ray;
    }
    /**
     * Shows the ray we are willing to debug.
     * @param scene Defines the scene the ray needs to be rendered in
     * @param color Defines the color the ray needs to be rendered in
     */ show(scene, color) {
        if (!this._renderFunction && this.ray) {
            const ray = this.ray;
            this._renderFunction = ()=>this._render();
            this._scene = scene;
            this._renderPoints = [
                ray.origin,
                ray.origin.add(ray.direction.scale(ray.length))
            ];
            this._renderLine = (0, $8Eyol.CreateLines)("ray", {
                points: this._renderPoints,
                updatable: true
            }, scene);
            this._renderLine.isPickable = false;
            if (this._renderFunction) this._scene.registerBeforeRender(this._renderFunction);
        }
        if (color && this._renderLine) this._renderLine.color.copyFrom(color);
    }
    /**
     * Hides the ray we are debugging.
     */ hide() {
        if (this._renderFunction && this._scene) {
            this._scene.unregisterBeforeRender(this._renderFunction);
            this._scene = null;
            this._renderFunction = null;
            if (this._renderLine) {
                this._renderLine.dispose();
                this._renderLine = null;
            }
            this._renderPoints = [];
        }
    }
    _render() {
        const ray = this.ray;
        if (!ray) return;
        const point = this._renderPoints[1];
        const len = Math.min(ray.length, 1000000);
        point.copyFrom(ray.direction);
        point.scaleInPlace(len);
        point.addInPlace(ray.origin);
        this._renderPoints[0].copyFrom(ray.origin);
        (0, $8Eyol.CreateLines)("ray", {
            points: this._renderPoints,
            updatable: true,
            instance: this._renderLine
        }, this._scene);
        this._renderLine?.refreshBoundingInfo();
    }
    /**
     * Attach a ray helper to a mesh so that we can easily see its orientation for instance or information like its normals.
     * @param mesh Defines the mesh we want the helper attached to
     * @param meshSpaceDirection Defines the direction of the Ray in mesh space (local space of the mesh node)
     * @param meshSpaceOrigin Defines the origin of the Ray in mesh space (local space of the mesh node)
     * @param length Defines the length of the ray
     */ attachToMesh(mesh, meshSpaceDirection, meshSpaceOrigin, length) {
        this._attachedToMesh = mesh;
        const ray = this.ray;
        if (!ray) return;
        if (!ray.direction) ray.direction = (0, $ha1VO.Vector3).Zero();
        if (!ray.origin) ray.origin = (0, $ha1VO.Vector3).Zero();
        if (length) ray.length = length;
        if (!meshSpaceOrigin) meshSpaceOrigin = (0, $ha1VO.Vector3).Zero();
        if (!meshSpaceDirection) // -1 so that this will work with Mesh.lookAt
        meshSpaceDirection = new (0, $ha1VO.Vector3)(0, 0, -1);
        if (!this._scene) this._scene = mesh.getScene();
        if (!this._meshSpaceDirection) {
            this._meshSpaceDirection = meshSpaceDirection.clone();
            this._meshSpaceOrigin = meshSpaceOrigin.clone();
        } else {
            this._meshSpaceDirection.copyFrom(meshSpaceDirection);
            this._meshSpaceOrigin.copyFrom(meshSpaceOrigin);
        }
        if (!this._onAfterRenderObserver) {
            this._onAfterRenderObserver = this._scene.onBeforeRenderObservable.add(()=>this._updateToMesh());
            this._onAfterStepObserver = this._scene.onAfterStepObservable.add(()=>this._updateToMesh());
        }
        // force world matrix computation before the first ray helper computation
        this._attachedToMesh.computeWorldMatrix(true);
        this._updateToMesh();
    }
    /**
     * Detach the ray helper from the mesh it has previously been attached to.
     */ detachFromMesh() {
        if (this._attachedToMesh && this._scene) {
            if (this._onAfterRenderObserver) {
                this._scene.onBeforeRenderObservable.remove(this._onAfterRenderObserver);
                this._scene.onAfterStepObservable.remove(this._onAfterStepObserver);
            }
            this._attachedToMesh = null;
            this._onAfterRenderObserver = null;
            this._onAfterStepObserver = null;
            this._scene = null;
        }
    }
    _updateToMesh() {
        const ray = this.ray;
        if (!this._attachedToMesh || !ray) return;
        if (this._attachedToMesh.isDisposed()) {
            this.detachFromMesh();
            return;
        }
        this._attachedToMesh.getDirectionToRef(this._meshSpaceDirection, ray.direction);
        (0, $ha1VO.Vector3).TransformCoordinatesToRef(this._meshSpaceOrigin, this._attachedToMesh.getWorldMatrix(), ray.origin);
    }
    /**
     * Dispose the helper and release its associated resources.
     */ dispose() {
        this.hide();
        this.detachFromMesh();
        this.ray = null;
    }
}

});

parcelRegister("hsoby", function(module, exports) {

$parcel$export(module.exports, "SkeletonViewer", () => $cb57cfe5a354ad8e$export$e0295953727bee23);

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $fbuqw = parcelRequire("fbuqw");

var $8Eyol = parcelRequire("8Eyol");

var $6mCYU = parcelRequire("6mCYU");

var $54229 = parcelRequire("54229");

var $4I7rl = parcelRequire("4I7rl");

var $fJfwX = parcelRequire("fJfwX");

var $b4i1f = parcelRequire("b4i1f");

var $lUDWq = parcelRequire("lUDWq");

var $8KqOo = parcelRequire("8KqOo");

var $l411O = parcelRequire("l411O");

var $klshO = parcelRequire("klshO");

var $kVtWi = parcelRequire("kVtWi");
class $cb57cfe5a354ad8e$export$e0295953727bee23 {
    /** public static method to create a BoneWeight Shader
     * @param options The constructor options
     * @param scene The scene that the shader is scoped to
     * @returns The created ShaderMaterial
     * @see http://www.babylonjs-playground.com/#1BZJVJ#395
     */ static CreateBoneWeightShader(options, scene) {
        const skeleton = options.skeleton;
        const colorBase = options.colorBase ?? (0, $7etnY.Color3).Black();
        const colorZero = options.colorZero ?? (0, $7etnY.Color3).Blue();
        const colorQuarter = options.colorQuarter ?? (0, $7etnY.Color3).Green();
        const colorHalf = options.colorHalf ?? (0, $7etnY.Color3).Yellow();
        const colorFull = options.colorFull ?? (0, $7etnY.Color3).Red();
        const targetBoneIndex = options.targetBoneIndex ?? 0;
        (0, $lUDWq.Effect).ShadersStore["boneWeights:" + skeleton.name + "VertexShader"] = `precision highp float;

        attribute vec3 position;
        attribute vec2 uv;

        uniform mat4 view;
        uniform mat4 projection;
        uniform mat4 worldViewProjection;

        #include<bonesDeclaration>
        #if NUM_BONE_INFLUENCERS == 0
            attribute vec4 matricesIndices;
            attribute vec4 matricesWeights;
        #endif
        #include<bakedVertexAnimationDeclaration>

        #include<instancesDeclaration>

        varying vec3 vColor;

        uniform vec3 colorBase;
        uniform vec3 colorZero;
        uniform vec3 colorQuarter;
        uniform vec3 colorHalf;
        uniform vec3 colorFull;

        uniform float targetBoneIndex;

        void main() {
            vec3 positionUpdated = position;

            #include<instancesVertex>
            #include<bonesVertex>
            #include<bakedVertexAnimation>

            vec4 worldPos = finalWorld * vec4(positionUpdated, 1.0);

            vec3 color = colorBase;
            float totalWeight = 0.;
            if(matricesIndices[0] == targetBoneIndex && matricesWeights[0] > 0.){
                totalWeight += matricesWeights[0];
            }
            if(matricesIndices[1] == targetBoneIndex && matricesWeights[1] > 0.){
                totalWeight += matricesWeights[1];
            }
            if(matricesIndices[2] == targetBoneIndex && matricesWeights[2] > 0.){
                totalWeight += matricesWeights[2];
            }
            if(matricesIndices[3] == targetBoneIndex && matricesWeights[3] > 0.){
                totalWeight += matricesWeights[3];
            }

            color = mix(color, colorZero, smoothstep(0., 0.25, totalWeight));
            color = mix(color, colorQuarter, smoothstep(0.25, 0.5, totalWeight));
            color = mix(color, colorHalf, smoothstep(0.5, 0.75, totalWeight));
            color = mix(color, colorFull, smoothstep(0.75, 1.0, totalWeight));
            vColor = color;

        gl_Position = projection * view * worldPos;
        }`;
        (0, $lUDWq.Effect).ShadersStore["boneWeights:" + skeleton.name + "FragmentShader"] = `
            precision highp float;
            varying vec3 vPosition;

            varying vec3 vColor;

            void main() {
                vec4 color = vec4(vColor, 1.0);
                gl_FragColor = color;
            }
        `;
        const shader = new (0, $4I7rl.ShaderMaterial)("boneWeight:" + skeleton.name, scene, {
            vertex: "boneWeights:" + skeleton.name,
            fragment: "boneWeights:" + skeleton.name
        }, {
            attributes: [
                "position",
                "normal",
                "matricesIndices",
                "matricesWeights"
            ],
            uniforms: [
                "world",
                "worldView",
                "worldViewProjection",
                "view",
                "projection",
                "viewProjection",
                "colorBase",
                "colorZero",
                "colorQuarter",
                "colorHalf",
                "colorFull",
                "targetBoneIndex"
            ]
        });
        shader.setColor3("colorBase", colorBase);
        shader.setColor3("colorZero", colorZero);
        shader.setColor3("colorQuarter", colorQuarter);
        shader.setColor3("colorHalf", colorHalf);
        shader.setColor3("colorFull", colorFull);
        shader.setFloat("targetBoneIndex", targetBoneIndex);
        shader.getClassName = ()=>{
            return "BoneWeightShader";
        };
        shader.transparencyMode = (0, $54229.Material).MATERIAL_OPAQUE;
        return shader;
    }
    /** public static method to create a BoneWeight Shader
     * @param options The constructor options
     * @param scene The scene that the shader is scoped to
     * @returns The created ShaderMaterial
     */ static CreateSkeletonMapShader(options, scene) {
        const skeleton = options.skeleton;
        const colorMap = options.colorMap ?? [
            {
                color: new (0, $7etnY.Color3)(1, 0.38, 0.18),
                location: 0
            },
            {
                color: new (0, $7etnY.Color3)(0.59, 0.18, 1.0),
                location: 0.2
            },
            {
                color: new (0, $7etnY.Color3)(0.59, 1, 0.18),
                location: 0.4
            },
            {
                color: new (0, $7etnY.Color3)(1, 0.87, 0.17),
                location: 0.6
            },
            {
                color: new (0, $7etnY.Color3)(1, 0.17, 0.42),
                location: 0.8
            },
            {
                color: new (0, $7etnY.Color3)(0.17, 0.68, 1.0),
                location: 1.0
            }
        ];
        const bufferWidth = skeleton.bones.length + 1;
        const colorMapBuffer = $cb57cfe5a354ad8e$export$e0295953727bee23._CreateBoneMapColorBuffer(bufferWidth, colorMap, scene);
        const shader = new (0, $4I7rl.ShaderMaterial)("boneWeights:" + skeleton.name, scene, {
            vertexSource: `precision highp float;

            attribute vec3 position;
            attribute vec2 uv;

            uniform mat4 view;
            uniform mat4 projection;
            uniform mat4 worldViewProjection;
            uniform float colorMap[` + skeleton.bones.length * 4 + `];

            #include<bonesDeclaration>
            #if NUM_BONE_INFLUENCERS == 0
                attribute vec4 matricesIndices;
                attribute vec4 matricesWeights;
            #endif
            #include<bakedVertexAnimationDeclaration>
            #include<instancesDeclaration>

            varying vec3 vColor;

            void main() {
                vec3 positionUpdated = position;

                #include<instancesVertex>
                #include<bonesVertex>
                #include<bakedVertexAnimation>

                vec3 color = vec3(0.);
                bool first = true;

                for (int i = 0; i < 4; i++) {
                    int boneIdx = int(matricesIndices[i]);
                    float boneWgt = matricesWeights[i];

                    vec3 c = vec3(colorMap[boneIdx * 4 + 0], colorMap[boneIdx * 4 + 1], colorMap[boneIdx * 4 + 2]);

                    if (boneWgt > 0.) {
                        if (first) {
                            first = false;
                            color = c;
                        } else {
                            color = mix(color, c, boneWgt);
                        }
                    }
                }

                vColor = color;

                vec4 worldPos = finalWorld * vec4(positionUpdated, 1.0);

                gl_Position = projection * view * worldPos;
            }`,
            fragmentSource: `
            precision highp float;
            varying vec3 vColor;

            void main() {
                vec4 color = vec4( vColor, 1.0 );
                gl_FragColor = color;
            }
            `
        }, {
            attributes: [
                "position",
                "normal",
                "matricesIndices",
                "matricesWeights"
            ],
            uniforms: [
                "world",
                "worldView",
                "worldViewProjection",
                "view",
                "projection",
                "viewProjection",
                "colorMap"
            ]
        });
        shader.setFloats("colorMap", colorMapBuffer);
        shader.getClassName = ()=>{
            return "SkeletonMapShader";
        };
        shader.transparencyMode = (0, $54229.Material).MATERIAL_OPAQUE;
        return shader;
    }
    /** private static method to create a BoneWeight Shader
     * @param size The size of the buffer to create (usually the bone count)
     * @param colorMap The gradient data to generate
     * @param scene The scene that the shader is scoped to
     * @returns an Array of floats from the color gradient values
     */ static _CreateBoneMapColorBuffer(size, colorMap, scene) {
        const tempGrad = new (0, $fJfwX.DynamicTexture)("temp", {
            width: size,
            height: 1
        }, scene, false);
        const ctx = tempGrad.getContext();
        const grad = ctx.createLinearGradient(0, 0, size, 0);
        colorMap.forEach((stop)=>{
            grad.addColorStop(stop.location, stop.color.toHexString());
        });
        ctx.fillStyle = grad;
        ctx.fillRect(0, 0, size, 1);
        tempGrad.update();
        const buffer = [];
        const data = ctx.getImageData(0, 0, size, 1).data;
        const rUnit = 1 / 255;
        for(let i = 0; i < data.length; i++)buffer.push(data[i] * rUnit);
        tempGrad.dispose();
        return buffer;
    }
    /** Gets the Scene. */ get scene() {
        return this._scene;
    }
    /** Gets the utilityLayer. */ get utilityLayer() {
        return this._utilityLayer;
    }
    /** Checks Ready Status. */ get isReady() {
        return this._ready;
    }
    /** Sets Ready Status. */ set ready(value) {
        this._ready = value;
    }
    /** Gets the debugMesh */ get debugMesh() {
        return this._debugMesh;
    }
    /** Sets the debugMesh */ set debugMesh(value) {
        this._debugMesh = value;
    }
    /** Gets the displayMode */ get displayMode() {
        return this.options.displayMode || $cb57cfe5a354ad8e$export$e0295953727bee23.DISPLAY_LINES;
    }
    /** Sets the displayMode */ set displayMode(value) {
        if (value > $cb57cfe5a354ad8e$export$e0295953727bee23.DISPLAY_SPHERE_AND_SPURS) value = $cb57cfe5a354ad8e$export$e0295953727bee23.DISPLAY_LINES;
        this.options.displayMode = value;
    }
    /**
     * Creates a new SkeletonViewer
     * @param skeleton defines the skeleton to render
     * @param mesh defines the mesh attached to the skeleton
     * @param scene defines the hosting scene
     * @param autoUpdateBonesMatrices defines a boolean indicating if bones matrices must be forced to update before rendering (true by default)
     * @param renderingGroupId defines the rendering group id to use with the viewer
     * @param options All of the extra constructor options for the SkeletonViewer
     */ constructor(/** defines the skeleton to render */ skeleton, /** defines the mesh attached to the skeleton */ mesh, /** The Scene scope*/ scene, /** defines a boolean indicating if bones matrices must be forced to update before rendering (true by default)  */ autoUpdateBonesMatrices = true, /** defines the rendering group id to use with the viewer */ renderingGroupId = 3, /** is the options for the viewer */ options = {}){
        this.skeleton = skeleton;
        this.mesh = mesh;
        this.autoUpdateBonesMatrices = autoUpdateBonesMatrices;
        this.renderingGroupId = renderingGroupId;
        this.options = options;
        /** Gets or sets the color used to render the skeleton */ this.color = (0, $7etnY.Color3).White();
        /** Array of the points of the skeleton fo the line view. */ this._debugLines = new Array();
        /** The local axes Meshes. */ this._localAxes = null;
        /** If SkeletonViewer is enabled. */ this._isEnabled = true;
        /** SkeletonViewer render observable. */ this._obs = null;
        this._scene = scene;
        this._ready = false;
        //Defaults
        options.pauseAnimations = options.pauseAnimations ?? true;
        options.returnToRest = options.returnToRest ?? false;
        options.displayMode = options.displayMode ?? $cb57cfe5a354ad8e$export$e0295953727bee23.DISPLAY_LINES;
        options.displayOptions = options.displayOptions ?? {};
        options.displayOptions.midStep = options.displayOptions.midStep ?? 0.235;
        options.displayOptions.midStepFactor = options.displayOptions.midStepFactor ?? 0.155;
        options.displayOptions.sphereBaseSize = options.displayOptions.sphereBaseSize ?? 0.15;
        options.displayOptions.sphereScaleUnit = options.displayOptions.sphereScaleUnit ?? 2;
        options.displayOptions.sphereFactor = options.displayOptions.sphereFactor ?? 0.865;
        options.displayOptions.spurFollowsChild = options.displayOptions.spurFollowsChild ?? false;
        options.displayOptions.showLocalAxes = options.displayOptions.showLocalAxes ?? false;
        options.displayOptions.localAxesSize = options.displayOptions.localAxesSize ?? 0.075;
        options.computeBonesUsingShaders = options.computeBonesUsingShaders ?? true;
        options.useAllBones = options.useAllBones ?? true;
        this._boneIndices = new Set();
        if (!options.useAllBones) {
            const initialMeshBoneIndices = mesh?.getVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesKind);
            const initialMeshBoneWeights = mesh?.getVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsKind);
            if (initialMeshBoneIndices && initialMeshBoneWeights) for(let i = 0; i < initialMeshBoneIndices.length; ++i){
                const index = initialMeshBoneIndices[i], weight = initialMeshBoneWeights[i];
                if (weight !== 0) this._boneIndices.add(index);
            }
        }
        /* Create Utility Layer */ this._utilityLayer = new (0, $6mCYU.UtilityLayerRenderer)(this._scene, false);
        this._utilityLayer.pickUtilitySceneFirst = false;
        this._utilityLayer.utilityLayerScene.autoClearDepthAndStencil = true;
        let displayMode = this.options.displayMode || 0;
        if (displayMode > $cb57cfe5a354ad8e$export$e0295953727bee23.DISPLAY_SPHERE_AND_SPURS) displayMode = $cb57cfe5a354ad8e$export$e0295953727bee23.DISPLAY_LINES;
        this.displayMode = displayMode;
        //Prep the Systems
        this.update();
        this._bindObs();
    }
    /** The Dynamic bindings for the update functions */ _bindObs() {
        switch(this.displayMode){
            case $cb57cfe5a354ad8e$export$e0295953727bee23.DISPLAY_LINES:
                this._obs = this.scene.onBeforeRenderObservable.add(()=>{
                    this._displayLinesUpdate();
                });
                break;
        }
    }
    /** Update the viewer to sync with current skeleton state, only used to manually update. */ update() {
        switch(this.displayMode){
            case $cb57cfe5a354ad8e$export$e0295953727bee23.DISPLAY_LINES:
                this._displayLinesUpdate();
                break;
            case $cb57cfe5a354ad8e$export$e0295953727bee23.DISPLAY_SPHERES:
                this._buildSpheresAndSpurs(true);
                break;
            case $cb57cfe5a354ad8e$export$e0295953727bee23.DISPLAY_SPHERE_AND_SPURS:
                this._buildSpheresAndSpurs(false);
                break;
        }
        this._buildLocalAxes();
    }
    /** Gets or sets a boolean indicating if the viewer is enabled */ set isEnabled(value) {
        if (this.isEnabled === value) return;
        this._isEnabled = value;
        if (this.debugMesh) this.debugMesh.setEnabled(value);
        if (value && !this._obs) this._bindObs();
        else if (!value && this._obs) {
            this.scene.onBeforeRenderObservable.remove(this._obs);
            this._obs = null;
        }
    }
    get isEnabled() {
        return this._isEnabled;
    }
    _getBonePosition(position, bone, meshMat, x = 0, y = 0, z = 0) {
        const tmat = (0, $ha1VO.TmpVectors).Matrix[0];
        const parentBone = bone.getParent();
        tmat.copyFrom(bone.getLocalMatrix());
        if (x !== 0 || y !== 0 || z !== 0) {
            const tmat2 = (0, $ha1VO.TmpVectors).Matrix[1];
            (0, $ha1VO.Matrix).IdentityToRef(tmat2);
            tmat2.setTranslationFromFloats(x, y, z);
            tmat2.multiplyToRef(tmat, tmat);
        }
        if (parentBone) tmat.multiplyToRef(parentBone.getAbsoluteMatrix(), tmat);
        tmat.multiplyToRef(meshMat, tmat);
        position.x = tmat.m[12];
        position.y = tmat.m[13];
        position.z = tmat.m[14];
    }
    _getLinesForBonesWithLength(bones, mesh) {
        const len = bones.length;
        let matrix;
        let meshPos;
        if (mesh) {
            matrix = mesh.getWorldMatrix();
            meshPos = mesh.position;
        } else {
            matrix = new (0, $ha1VO.Matrix)();
            meshPos = bones[0].position;
        }
        let idx = 0;
        for(let i = 0; i < len; i++){
            const bone = bones[i];
            let points = this._debugLines[idx];
            if (bone._index === -1 || !this._boneIndices.has(bone.getIndex()) && !this.options.useAllBones) continue;
            if (!points) {
                points = [
                    (0, $ha1VO.Vector3).Zero(),
                    (0, $ha1VO.Vector3).Zero()
                ];
                this._debugLines[idx] = points;
            }
            this._getBonePosition(points[0], bone, matrix);
            this._getBonePosition(points[1], bone, matrix, 0, bone.length, 0);
            points[0].subtractInPlace(meshPos);
            points[1].subtractInPlace(meshPos);
            idx++;
        }
    }
    _getLinesForBonesNoLength(bones) {
        const len = bones.length;
        let boneNum = 0;
        const mesh = this.mesh;
        let transformNode;
        let meshPos;
        if (mesh) {
            transformNode = mesh;
            meshPos = mesh.position;
        } else {
            transformNode = new (0, $klshO.TransformNode)("");
            meshPos = bones[0].position;
        }
        for(let i = len - 1; i >= 0; i--){
            const childBone = bones[i];
            const parentBone = childBone.getParent();
            if (!parentBone || !this._boneIndices.has(childBone.getIndex()) && !this.options.useAllBones) continue;
            let points = this._debugLines[boneNum];
            if (!points) {
                points = [
                    (0, $ha1VO.Vector3).Zero(),
                    (0, $ha1VO.Vector3).Zero()
                ];
                this._debugLines[boneNum] = points;
            }
            childBone.getAbsolutePositionToRef(transformNode, points[0]);
            parentBone.getAbsolutePositionToRef(transformNode, points[1]);
            points[0].subtractInPlace(meshPos);
            points[1].subtractInPlace(meshPos);
            boneNum++;
        }
        if (!mesh) transformNode.dispose();
    }
    /**
     * function to revert the mesh and scene back to the initial state.
     * @param animationState
     */ _revert(animationState) {
        if (this.options.pauseAnimations) {
            this.scene.animationsEnabled = animationState;
            this.utilityLayer.utilityLayerScene.animationsEnabled = animationState;
        }
    }
    /**
     * function to get the absolute bind pose of a bone by accumulating transformations up the bone hierarchy.
     * @param bone
     * @param matrix
     */ _getAbsoluteBindPoseToRef(bone, matrix) {
        if (bone === null || bone._index === -1) {
            matrix.copyFrom((0, $ha1VO.Matrix).Identity());
            return;
        }
        this._getAbsoluteBindPoseToRef(bone.getParent(), matrix);
        bone.getBindMatrix().multiplyToRef(matrix, matrix);
        return;
    }
    _createSpur(anchorPoint, bone, childPoint, childBone, displayOptions, utilityLayerScene) {
        const dir = childPoint.subtract(anchorPoint);
        const h = dir.length();
        const up = dir.normalize().scale(h);
        const midStep = displayOptions.midStep || 0.165;
        const midStepFactor = displayOptions.midStepFactor || 0.215;
        const up0 = up.scale(midStep);
        const spur = (0, $l411O.ExtrudeShapeCustom)("skeletonViewer", {
            shape: [
                new (0, $ha1VO.Vector3)(1, -1, 0),
                new (0, $ha1VO.Vector3)(1, 1, 0),
                new (0, $ha1VO.Vector3)(-1, 1, 0),
                new (0, $ha1VO.Vector3)(-1, -1, 0),
                new (0, $ha1VO.Vector3)(1, -1, 0)
            ],
            path: [
                (0, $ha1VO.Vector3).Zero(),
                up0,
                up
            ],
            scaleFunction: (i)=>{
                switch(i){
                    case 0:
                    case 2:
                        return 0;
                    case 1:
                        return h * midStepFactor;
                }
                return 0;
            },
            sideOrientation: (0, $fbuqw.Mesh).DEFAULTSIDE,
            updatable: false
        }, utilityLayerScene);
        const numVertices = spur.getTotalVertices();
        const mwk = [], mik = [];
        for(let i = 0; i < numVertices; i++){
            mwk.push(1, 0, 0, 0);
            // Select verts at end of spur (ie vert 10 to 14) and bind to child
            // bone if spurFollowsChild is enabled.
            if (childBone && displayOptions.spurFollowsChild && i > 9) mik.push(childBone.getIndex(), 0, 0, 0);
            else mik.push(bone.getIndex(), 0, 0, 0);
        }
        spur.position = anchorPoint.clone();
        spur.setVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsKind, mwk, false);
        spur.setVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesKind, mik, false);
        spur.convertToFlatShadedMesh();
        return spur;
    }
    _getBoundingSphereForBone(boneIndex) {
        if (!this.mesh) return null;
        const positions = this.mesh.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        const indices = this.mesh.getIndices();
        const boneWeights = this.mesh.getVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsKind);
        const boneIndices = this.mesh.getVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesKind);
        if (!positions || !indices || !boneWeights || !boneIndices) return null;
        const min = new (0, $ha1VO.Vector3)(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
        const max = new (0, $ha1VO.Vector3)(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
        let found = 0;
        for(let i = 0; i < indices.length; ++i){
            const vertexIndex = indices[i];
            for(let b = 0; b < 4; ++b){
                const bIndex = boneIndices[vertexIndex * 4 + b];
                const bWeight = boneWeights[vertexIndex * 4 + b];
                if (bIndex === boneIndex && bWeight > 1e-5) {
                    (0, $ha1VO.Vector3).FromArrayToRef(positions, vertexIndex * 3, (0, $ha1VO.TmpVectors).Vector3[0]);
                    min.minimizeInPlace((0, $ha1VO.TmpVectors).Vector3[0]);
                    max.maximizeInPlace((0, $ha1VO.TmpVectors).Vector3[0]);
                    found++;
                    break;
                }
            }
        }
        return found > 1 ? {
            center: (0, $ha1VO.Vector3).Center(min, max),
            radius: (0, $ha1VO.Vector3).Distance(min, max) / 2
        } : null;
    }
    /**
     * function to build and bind sphere joint points and spur bone representations.
     * @param spheresOnly
     */ _buildSpheresAndSpurs(spheresOnly = true) {
        if (this._debugMesh) {
            this._debugMesh.dispose();
            this._debugMesh = null;
            this.ready = false;
        }
        this._ready = false;
        const utilityLayerScene = this.utilityLayer?.utilityLayerScene;
        const bones = this.skeleton.bones;
        const spheres = [];
        const spurs = [];
        const animationState = this.scene.animationsEnabled;
        try {
            if (this.options.pauseAnimations) {
                this.scene.animationsEnabled = false;
                utilityLayerScene.animationsEnabled = false;
            }
            if (this.options.returnToRest) this.skeleton.returnToRest();
            if (this.autoUpdateBonesMatrices) this.skeleton.computeAbsoluteMatrices();
            let longestBoneLength = Number.NEGATIVE_INFINITY;
            const displayOptions = this.options.displayOptions || {};
            for(let i = 0; i < bones.length; i++){
                const bone = bones[i];
                if (bone._index === -1 || !this._boneIndices.has(bone.getIndex()) && !this.options.useAllBones) continue;
                const boneAbsoluteBindPoseTransform = new (0, $ha1VO.Matrix)();
                this._getAbsoluteBindPoseToRef(bone, boneAbsoluteBindPoseTransform);
                const anchorPoint = new (0, $ha1VO.Vector3)();
                boneAbsoluteBindPoseTransform.decompose(undefined, undefined, anchorPoint);
                if (bone.children.length > 0) bone.children.forEach((bc)=>{
                    const childAbsoluteBindPoseTransform = new (0, $ha1VO.Matrix)();
                    bc.getLocalMatrix().multiplyToRef(boneAbsoluteBindPoseTransform, childAbsoluteBindPoseTransform);
                    const childPoint = new (0, $ha1VO.Vector3)();
                    childAbsoluteBindPoseTransform.decompose(undefined, undefined, childPoint);
                    const distanceFromParent = (0, $ha1VO.Vector3).Distance(anchorPoint, childPoint);
                    if (distanceFromParent > longestBoneLength) longestBoneLength = distanceFromParent;
                    if (spheresOnly) return;
                    spurs.push(this._createSpur(anchorPoint, bone, childPoint, bc, displayOptions, utilityLayerScene));
                });
                else {
                    const boundingSphere = this._getBoundingSphereForBone(bone.getIndex());
                    if (boundingSphere) {
                        if (boundingSphere.radius > longestBoneLength) longestBoneLength = boundingSphere.radius;
                        if (!spheresOnly) {
                            let childPoint;
                            const parentBone = bone.getParent();
                            if (parentBone) {
                                this._getAbsoluteBindPoseToRef(parentBone, boneAbsoluteBindPoseTransform);
                                boneAbsoluteBindPoseTransform.decompose(undefined, undefined, (0, $ha1VO.TmpVectors).Vector3[0]);
                                childPoint = anchorPoint.subtract((0, $ha1VO.TmpVectors).Vector3[0]).normalize().scale(boundingSphere.radius).add(anchorPoint);
                            } else childPoint = boundingSphere.center.subtract(anchorPoint).normalize().scale(boundingSphere.radius).add(anchorPoint);
                            spurs.push(this._createSpur(anchorPoint, bone, childPoint, null, displayOptions, utilityLayerScene));
                        }
                    }
                }
                const sphereBaseSize = displayOptions.sphereBaseSize || 0.2;
                const sphere = (0, $8KqOo.CreateSphere)("skeletonViewer", {
                    segments: 6,
                    diameter: sphereBaseSize,
                    updatable: true
                }, utilityLayerScene);
                const numVertices = sphere.getTotalVertices();
                const mwk = [], mik = [];
                for(let i = 0; i < numVertices; i++){
                    mwk.push(1, 0, 0, 0);
                    mik.push(bone.getIndex(), 0, 0, 0);
                }
                sphere.setVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsKind, mwk, false);
                sphere.setVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesKind, mik, false);
                sphere.position = anchorPoint.clone();
                spheres.push([
                    sphere,
                    bone
                ]);
            }
            const sphereScaleUnit = displayOptions.sphereScaleUnit || 2;
            const sphereFactor = displayOptions.sphereFactor || 0.85;
            const meshes = [];
            for(let i = 0; i < spheres.length; i++){
                const [sphere, bone] = spheres[i];
                const scale = 1 / (sphereScaleUnit / longestBoneLength);
                let _stepsOut = 0;
                let _b = bone;
                while(_b.getParent() && _b.getParent().getIndex() !== -1){
                    _stepsOut++;
                    _b = _b.getParent();
                }
                sphere.scaling.scaleInPlace(scale * Math.pow(sphereFactor, _stepsOut));
                meshes.push(sphere);
            }
            this.debugMesh = (0, $fbuqw.Mesh).MergeMeshes(meshes.concat(spurs), true, true);
            if (this.debugMesh) {
                this.debugMesh.renderingGroupId = this.renderingGroupId;
                this.debugMesh.skeleton = this.skeleton;
                this.debugMesh.parent = this.mesh;
                this.debugMesh.computeBonesUsingShaders = this.options.computeBonesUsingShaders ?? true;
                this.debugMesh.alwaysSelectAsActiveMesh = true;
            }
            const light = this.utilityLayer._getSharedGizmoLight();
            light.intensity = 0.7;
            this._revert(animationState);
            this.ready = true;
        } catch (err) {
            (0, $kVtWi.Logger).Error(err);
            this._revert(animationState);
            this.dispose();
        }
    }
    _buildLocalAxes() {
        if (this._localAxes) this._localAxes.dispose();
        this._localAxes = null;
        const displayOptions = this.options.displayOptions || {};
        if (!displayOptions.showLocalAxes) return;
        const targetScene = this._utilityLayer.utilityLayerScene;
        const size = displayOptions.localAxesSize || 0.075;
        const lines = [];
        const colors = [];
        const red = new (0, $7etnY.Color4)(1, 0, 0, 1);
        const green = new (0, $7etnY.Color4)(0, 1, 0, 1);
        const blue = new (0, $7etnY.Color4)(0, 0, 1, 1);
        const mwk = [];
        const mik = [];
        const vertsPerBone = 6;
        for(const i in this.skeleton.bones){
            const bone = this.skeleton.bones[i];
            if (bone._index === -1 || !this._boneIndices.has(bone.getIndex()) && !this.options.useAllBones) continue;
            const boneAbsoluteBindPoseTransform = new (0, $ha1VO.Matrix)();
            const boneOrigin = new (0, $ha1VO.Vector3)();
            this._getAbsoluteBindPoseToRef(bone, boneAbsoluteBindPoseTransform);
            boneAbsoluteBindPoseTransform.decompose(undefined, (0, $ha1VO.TmpVectors).Quaternion[0], boneOrigin);
            const m = new (0, $ha1VO.Matrix)();
            (0, $ha1VO.TmpVectors).Quaternion[0].toRotationMatrix(m);
            const boneAxisX = (0, $ha1VO.Vector3).TransformCoordinates(new (0, $ha1VO.Vector3)(0 + size, 0, 0), m);
            const boneAxisY = (0, $ha1VO.Vector3).TransformCoordinates(new (0, $ha1VO.Vector3)(0, 0 + size, 0), m);
            const boneAxisZ = (0, $ha1VO.Vector3).TransformCoordinates(new (0, $ha1VO.Vector3)(0, 0, 0 + size), m);
            const axisX = [
                boneOrigin,
                boneOrigin.add(boneAxisX)
            ];
            const axisY = [
                boneOrigin,
                boneOrigin.add(boneAxisY)
            ];
            const axisZ = [
                boneOrigin,
                boneOrigin.add(boneAxisZ)
            ];
            const linePoints = [
                axisX,
                axisY,
                axisZ
            ];
            const lineColors = [
                [
                    red,
                    red
                ],
                [
                    green,
                    green
                ],
                [
                    blue,
                    blue
                ]
            ];
            lines.push(...linePoints);
            colors.push(...lineColors);
            for(let j = 0; j < vertsPerBone; j++){
                mwk.push(1, 0, 0, 0);
                mik.push(bone.getIndex(), 0, 0, 0);
            }
        }
        this._localAxes = (0, $8Eyol.CreateLineSystem)("localAxes", {
            lines: lines,
            colors: colors,
            updatable: true
        }, targetScene);
        this._localAxes.setVerticesData((0, $b4i1f.VertexBuffer).MatricesWeightsKind, mwk, false);
        this._localAxes.setVerticesData((0, $b4i1f.VertexBuffer).MatricesIndicesKind, mik, false);
        this._localAxes.skeleton = this.skeleton;
        this._localAxes.renderingGroupId = this.renderingGroupId + 1;
        this._localAxes.parent = this.mesh;
        this._localAxes.computeBonesUsingShaders = this.options.computeBonesUsingShaders ?? true;
    }
    /** Update the viewer to sync with current skeleton state, only used for the line display. */ _displayLinesUpdate() {
        if (!this._utilityLayer) return;
        if (this.autoUpdateBonesMatrices) this.skeleton.computeAbsoluteMatrices();
        if (this.skeleton.bones[0].length === undefined) this._getLinesForBonesNoLength(this.skeleton.bones);
        else this._getLinesForBonesWithLength(this.skeleton.bones, this.mesh);
        const targetScene = this._utilityLayer.utilityLayerScene;
        if (targetScene) {
            if (!this._debugMesh) {
                this._debugMesh = (0, $8Eyol.CreateLineSystem)("", {
                    lines: this._debugLines,
                    updatable: true,
                    instance: null
                }, targetScene);
                this._debugMesh.renderingGroupId = this.renderingGroupId;
            } else (0, $8Eyol.CreateLineSystem)("", {
                lines: this._debugLines,
                updatable: true,
                instance: this._debugMesh
            }, targetScene);
            if (this.mesh) this._debugMesh.position.copyFrom(this.mesh.position);
            else this._debugMesh.position.copyFrom(this.skeleton.bones[0].position);
            this._debugMesh.color = this.color;
        }
    }
    /** Changes the displayMode of the skeleton viewer
     * @param mode The displayMode numerical value
     */ changeDisplayMode(mode) {
        const wasEnabled = this.isEnabled ? true : false;
        if (this.displayMode !== mode) {
            this.isEnabled = false;
            if (this._debugMesh) {
                this._debugMesh.dispose();
                this._debugMesh = null;
                this.ready = false;
            }
            this.displayMode = mode;
            this.update();
            this._bindObs();
            this.isEnabled = wasEnabled;
        }
    }
    /** Sets a display option of the skeleton viewer
     *
     * | Option           | Type    | Default | Description |
     * | ---------------- | ------- | ------- | ----------- |
     * | midStep          | float   | 0.235   | A percentage between a bone and its child that determines the widest part of a spur. Only used when `displayMode` is set to `DISPLAY_SPHERE_AND_SPURS`. |
     * | midStepFactor    | float   | 0.15    | Mid step width expressed as a factor of the length. A value of 0.5 makes the spur width half of the spur length. Only used when `displayMode` is set to `DISPLAY_SPHERE_AND_SPURS`. |
     * | sphereBaseSize   | float   | 2       | Sphere base size. Only used when `displayMode` is set to `DISPLAY_SPHERE_AND_SPURS`. |
     * | sphereScaleUnit  | float   | 0.865   | Sphere scale factor used to scale spheres in relation to the longest bone. Only used when `displayMode` is set to `DISPLAY_SPHERE_AND_SPURS`. |
     * | spurFollowsChild | boolean | false   | Whether a spur should attach its far end to the child bone. |
     * | showLocalAxes    | boolean | false   | Displays local axes on all bones. |
     * | localAxesSize    | float   | 0.075   | Determines the length of each local axis. |
     *
     * @param option String of the option name
     * @param value The numerical option value
     */ changeDisplayOptions(option, value) {
        const wasEnabled = this.isEnabled ? true : false;
        this.options.displayOptions[option] = value;
        this.isEnabled = false;
        if (this._debugMesh) {
            this._debugMesh.dispose();
            this._debugMesh = null;
            this.ready = false;
        }
        this.update();
        this._bindObs();
        this.isEnabled = wasEnabled;
    }
    /** Release associated resources */ dispose() {
        this.isEnabled = false;
        if (this._debugMesh) {
            this._debugMesh.dispose();
            this._debugMesh = null;
        }
        if (this._utilityLayer) {
            this._utilityLayer.dispose();
            this._utilityLayer = null;
        }
        this.ready = false;
    }
}
/** public Display constants BABYLON.SkeletonViewer.DISPLAY_LINES */ $cb57cfe5a354ad8e$export$e0295953727bee23.DISPLAY_LINES = 0;
/** public Display constants BABYLON.SkeletonViewer.DISPLAY_SPHERES */ $cb57cfe5a354ad8e$export$e0295953727bee23.DISPLAY_SPHERES = 1;
/** public Display constants BABYLON.SkeletonViewer.DISPLAY_SPHERE_AND_SPURS */ $cb57cfe5a354ad8e$export$e0295953727bee23.DISPLAY_SPHERE_AND_SPURS = 2;

});

parcelRegister("cwP3a", function(module, exports) {

});

parcelRegister("iauJn", function(module, exports) {

$parcel$export(module.exports, "DirectionalLightFrustumViewer", () => $d3a0ffa9d93206bc$export$2ab21732d5c232c1);

var $gAH3H = parcelRequire("gAH3H");

var $7etnY = parcelRequire("7etnY");

var $ha1VO = parcelRequire("ha1VO");

var $8Eyol = parcelRequire("8Eyol");

var $fbuqw = parcelRequire("fbuqw");

var $5v6ry = parcelRequire("5v6ry");

var $klshO = parcelRequire("klshO");
class $d3a0ffa9d93206bc$export$2ab21732d5c232c1 {
    /**
     * Gets or sets the transparency of the frustum planes
     */ get transparency() {
        return this._transparency;
    }
    set transparency(alpha) {
        this._transparency = alpha;
        for(let i = 6; i < 12; ++i)this._lightHelperFrustumMeshes[i].material.alpha = alpha;
    }
    /**
     * true to display the edges of the frustum
     */ get showLines() {
        return this._showLines;
    }
    set showLines(show) {
        if (this._showLines === show) return;
        this._showLines = show;
        for(let i = 0; i < 6; ++i)this._lightHelperFrustumMeshes[i].setEnabled(show);
    }
    /**
     * true to display the planes of the frustum
     */ get showPlanes() {
        return this._showPlanes;
    }
    set showPlanes(show) {
        if (this._showPlanes === show) return;
        this._showPlanes = show;
        for(let i = 6; i < 12; ++i)this._lightHelperFrustumMeshes[i].setEnabled(show);
    }
    /**
     * Creates a new frustum viewer
     * @param light directional light to display the frustum for
     * @param camera camera used to retrieve the minZ / maxZ values if the shadowMinZ/shadowMaxZ values of the light are not setup
     */ constructor(light, camera){
        this._oldPosition = new (0, $ha1VO.Vector3)(Number.NaN, Number.NaN, Number.NaN);
        this._oldDirection = new (0, $ha1VO.Vector3)(Number.NaN, Number.NaN, Number.NaN);
        this._transparency = 0.3;
        this._showLines = true;
        this._showPlanes = true;
        this._scene = light.getScene();
        this._light = light;
        this._camera = camera;
        this._inverseViewMatrix = (0, $ha1VO.Matrix).Identity();
        this._lightHelperFrustumMeshes = [];
        this._createGeometry();
        this.show();
        this.update();
    }
    /**
     * Shows the frustum
     */ show() {
        this._lightHelperFrustumMeshes.forEach((mesh, index)=>{
            mesh.setEnabled(index < 6 && this._showLines || index >= 6 && this._showPlanes);
        });
        this._oldPosition.set(Number.NaN, Number.NaN, Number.NaN);
        this._visible = true;
    }
    /**
     * Hides the frustum
     */ hide() {
        this._lightHelperFrustumMeshes.forEach((mesh)=>{
            mesh.setEnabled(false);
        });
        this._visible = false;
    }
    /**
     * Updates the frustum.
     * Call this method to update the frustum view if the light has changed position/direction
     */ update() {
        if (!this._visible) return;
        if (this._oldPosition.equals(this._light.position) && this._oldDirection.equals(this._light.direction) && this._oldAutoCalc === this._light.autoCalcShadowZBounds && this._oldMinZ === this._light.shadowMinZ && this._oldMaxZ === this._light.shadowMaxZ) return;
        this._oldPosition.copyFrom(this._light.position);
        this._oldDirection.copyFrom(this._light.direction);
        this._oldAutoCalc = this._light.autoCalcShadowZBounds;
        this._oldMinZ = this._light.shadowMinZ;
        this._oldMaxZ = this._light.shadowMaxZ;
        (0, $ha1VO.TmpVectors).Vector3[0].set(this._light.orthoLeft, this._light.orthoBottom, this._light.shadowMinZ !== undefined ? this._light.shadowMinZ : this._camera.minZ); // min light extents
        (0, $ha1VO.TmpVectors).Vector3[1].set(this._light.orthoRight, this._light.orthoTop, this._light.shadowMaxZ !== undefined ? this._light.shadowMaxZ : this._camera.maxZ); // max light extents
        const invLightView = this._getInvertViewMatrix();
        (0, $ha1VO.TmpVectors).Vector3[2].copyFromFloats((0, $ha1VO.TmpVectors).Vector3[1].x, (0, $ha1VO.TmpVectors).Vector3[1].y, (0, $ha1VO.TmpVectors).Vector3[0].z); // n1
        (0, $ha1VO.TmpVectors).Vector3[3].copyFromFloats((0, $ha1VO.TmpVectors).Vector3[1].x, (0, $ha1VO.TmpVectors).Vector3[0].y, (0, $ha1VO.TmpVectors).Vector3[0].z); // n2
        (0, $ha1VO.TmpVectors).Vector3[4].copyFromFloats((0, $ha1VO.TmpVectors).Vector3[0].x, (0, $ha1VO.TmpVectors).Vector3[0].y, (0, $ha1VO.TmpVectors).Vector3[0].z); // n3
        (0, $ha1VO.TmpVectors).Vector3[5].copyFromFloats((0, $ha1VO.TmpVectors).Vector3[0].x, (0, $ha1VO.TmpVectors).Vector3[1].y, (0, $ha1VO.TmpVectors).Vector3[0].z); // n4
        (0, $ha1VO.Vector3).TransformCoordinatesToRef((0, $ha1VO.TmpVectors).Vector3[2], invLightView, (0, $ha1VO.TmpVectors).Vector3[2]); // near1
        (0, $ha1VO.Vector3).TransformCoordinatesToRef((0, $ha1VO.TmpVectors).Vector3[3], invLightView, (0, $ha1VO.TmpVectors).Vector3[3]); // near2
        (0, $ha1VO.Vector3).TransformCoordinatesToRef((0, $ha1VO.TmpVectors).Vector3[4], invLightView, (0, $ha1VO.TmpVectors).Vector3[4]); // near3
        (0, $ha1VO.Vector3).TransformCoordinatesToRef((0, $ha1VO.TmpVectors).Vector3[5], invLightView, (0, $ha1VO.TmpVectors).Vector3[5]); // near4
        (0, $ha1VO.TmpVectors).Vector3[6].copyFromFloats((0, $ha1VO.TmpVectors).Vector3[1].x, (0, $ha1VO.TmpVectors).Vector3[1].y, (0, $ha1VO.TmpVectors).Vector3[1].z); // f1
        (0, $ha1VO.TmpVectors).Vector3[7].copyFromFloats((0, $ha1VO.TmpVectors).Vector3[1].x, (0, $ha1VO.TmpVectors).Vector3[0].y, (0, $ha1VO.TmpVectors).Vector3[1].z); // f2
        (0, $ha1VO.TmpVectors).Vector3[8].copyFromFloats((0, $ha1VO.TmpVectors).Vector3[0].x, (0, $ha1VO.TmpVectors).Vector3[0].y, (0, $ha1VO.TmpVectors).Vector3[1].z); // f3
        (0, $ha1VO.TmpVectors).Vector3[9].copyFromFloats((0, $ha1VO.TmpVectors).Vector3[0].x, (0, $ha1VO.TmpVectors).Vector3[1].y, (0, $ha1VO.TmpVectors).Vector3[1].z); // f4
        (0, $ha1VO.Vector3).TransformCoordinatesToRef((0, $ha1VO.TmpVectors).Vector3[6], invLightView, (0, $ha1VO.TmpVectors).Vector3[6]); // far1
        (0, $ha1VO.Vector3).TransformCoordinatesToRef((0, $ha1VO.TmpVectors).Vector3[7], invLightView, (0, $ha1VO.TmpVectors).Vector3[7]); // far2
        (0, $ha1VO.Vector3).TransformCoordinatesToRef((0, $ha1VO.TmpVectors).Vector3[8], invLightView, (0, $ha1VO.TmpVectors).Vector3[8]); // far3
        (0, $ha1VO.Vector3).TransformCoordinatesToRef((0, $ha1VO.TmpVectors).Vector3[9], invLightView, (0, $ha1VO.TmpVectors).Vector3[9]); // far4
        (0, $8Eyol.CreateLines)("nearlines", {
            updatable: true,
            points: this._nearLinesPoints,
            instance: this._lightHelperFrustumMeshes[0]
        }, this._scene);
        (0, $8Eyol.CreateLines)("farlines", {
            updatable: true,
            points: this._farLinesPoints,
            instance: this._lightHelperFrustumMeshes[1]
        }, this._scene);
        (0, $8Eyol.CreateLines)("trlines", {
            updatable: true,
            points: this._trLinesPoints,
            instance: this._lightHelperFrustumMeshes[2]
        }, this._scene);
        (0, $8Eyol.CreateLines)("brlines", {
            updatable: true,
            points: this._brLinesPoints,
            instance: this._lightHelperFrustumMeshes[3]
        }, this._scene);
        (0, $8Eyol.CreateLines)("tllines", {
            updatable: true,
            points: this._tlLinesPoints,
            instance: this._lightHelperFrustumMeshes[4]
        }, this._scene);
        (0, $8Eyol.CreateLines)("bllines", {
            updatable: true,
            points: this._blLinesPoints,
            instance: this._lightHelperFrustumMeshes[5]
        }, this._scene);
        (0, $ha1VO.TmpVectors).Vector3[2].toArray(this._nearPlaneVertices, 0);
        (0, $ha1VO.TmpVectors).Vector3[3].toArray(this._nearPlaneVertices, 3);
        (0, $ha1VO.TmpVectors).Vector3[4].toArray(this._nearPlaneVertices, 6);
        (0, $ha1VO.TmpVectors).Vector3[5].toArray(this._nearPlaneVertices, 9);
        this._lightHelperFrustumMeshes[6].geometry?.updateVerticesDataDirectly("position", this._nearPlaneVertices, 0);
        (0, $ha1VO.TmpVectors).Vector3[6].toArray(this._farPlaneVertices, 0);
        (0, $ha1VO.TmpVectors).Vector3[7].toArray(this._farPlaneVertices, 3);
        (0, $ha1VO.TmpVectors).Vector3[8].toArray(this._farPlaneVertices, 6);
        (0, $ha1VO.TmpVectors).Vector3[9].toArray(this._farPlaneVertices, 9);
        this._lightHelperFrustumMeshes[7].geometry?.updateVerticesDataDirectly("position", this._farPlaneVertices, 0);
        (0, $ha1VO.TmpVectors).Vector3[2].toArray(this._rightPlaneVertices, 0);
        (0, $ha1VO.TmpVectors).Vector3[6].toArray(this._rightPlaneVertices, 3);
        (0, $ha1VO.TmpVectors).Vector3[7].toArray(this._rightPlaneVertices, 6);
        (0, $ha1VO.TmpVectors).Vector3[3].toArray(this._rightPlaneVertices, 9);
        this._lightHelperFrustumMeshes[8].geometry?.updateVerticesDataDirectly("position", this._rightPlaneVertices, 0);
        (0, $ha1VO.TmpVectors).Vector3[5].toArray(this._leftPlaneVertices, 0);
        (0, $ha1VO.TmpVectors).Vector3[9].toArray(this._leftPlaneVertices, 3);
        (0, $ha1VO.TmpVectors).Vector3[8].toArray(this._leftPlaneVertices, 6);
        (0, $ha1VO.TmpVectors).Vector3[4].toArray(this._leftPlaneVertices, 9);
        this._lightHelperFrustumMeshes[9].geometry?.updateVerticesDataDirectly("position", this._leftPlaneVertices, 0);
        (0, $ha1VO.TmpVectors).Vector3[2].toArray(this._topPlaneVertices, 0);
        (0, $ha1VO.TmpVectors).Vector3[6].toArray(this._topPlaneVertices, 3);
        (0, $ha1VO.TmpVectors).Vector3[9].toArray(this._topPlaneVertices, 6);
        (0, $ha1VO.TmpVectors).Vector3[5].toArray(this._topPlaneVertices, 9);
        this._lightHelperFrustumMeshes[10].geometry?.updateVerticesDataDirectly("position", this._topPlaneVertices, 0);
        (0, $ha1VO.TmpVectors).Vector3[3].toArray(this._bottomPlaneVertices, 0);
        (0, $ha1VO.TmpVectors).Vector3[7].toArray(this._bottomPlaneVertices, 3);
        (0, $ha1VO.TmpVectors).Vector3[8].toArray(this._bottomPlaneVertices, 6);
        (0, $ha1VO.TmpVectors).Vector3[4].toArray(this._bottomPlaneVertices, 9);
        this._lightHelperFrustumMeshes[11].geometry?.updateVerticesDataDirectly("position", this._bottomPlaneVertices, 0);
    }
    /**
     * Dispose of the class / remove the frustum view
     */ dispose() {
        this._lightHelperFrustumMeshes.forEach((mesh)=>{
            mesh.material?.dispose();
            mesh.dispose();
        });
        this._rootNode.dispose();
    }
    _createGeometry() {
        this._rootNode = new (0, $klshO.TransformNode)("directionalLightHelperRoot_" + this._light.name, this._scene);
        this._rootNode.parent = this._light.parent;
        this._nearLinesPoints = [
            (0, $ha1VO.TmpVectors).Vector3[0],
            (0, $ha1VO.TmpVectors).Vector3[1],
            (0, $ha1VO.TmpVectors).Vector3[2],
            (0, $ha1VO.TmpVectors).Vector3[3],
            (0, $ha1VO.TmpVectors).Vector3[4]
        ];
        const nearLines = (0, $8Eyol.CreateLines)("nearlines", {
            updatable: true,
            points: this._nearLinesPoints
        }, this._scene);
        nearLines.parent = this._rootNode;
        nearLines.alwaysSelectAsActiveMesh = true;
        this._farLinesPoints = [
            (0, $ha1VO.TmpVectors).Vector3[5],
            (0, $ha1VO.TmpVectors).Vector3[6],
            (0, $ha1VO.TmpVectors).Vector3[7],
            (0, $ha1VO.TmpVectors).Vector3[8],
            (0, $ha1VO.TmpVectors).Vector3[9]
        ];
        const farLines = (0, $8Eyol.CreateLines)("farlines", {
            updatable: true,
            points: this._farLinesPoints
        }, this._scene);
        farLines.parent = this._rootNode;
        farLines.alwaysSelectAsActiveMesh = true;
        this._trLinesPoints = [
            (0, $ha1VO.TmpVectors).Vector3[10],
            (0, $ha1VO.TmpVectors).Vector3[11]
        ];
        const trLines = (0, $8Eyol.CreateLines)("trlines", {
            updatable: true,
            points: this._trLinesPoints
        }, this._scene);
        trLines.parent = this._rootNode;
        trLines.alwaysSelectAsActiveMesh = true;
        this._brLinesPoints = [
            (0, $ha1VO.TmpVectors).Vector3[12],
            (0, $ha1VO.TmpVectors).Vector3[0]
        ];
        const brLines = (0, $8Eyol.CreateLines)("brlines", {
            updatable: true,
            points: this._brLinesPoints
        }, this._scene);
        brLines.parent = this._rootNode;
        brLines.alwaysSelectAsActiveMesh = true;
        this._tlLinesPoints = [
            (0, $ha1VO.TmpVectors).Vector3[1],
            (0, $ha1VO.TmpVectors).Vector3[2]
        ];
        const tlLines = (0, $8Eyol.CreateLines)("tllines", {
            updatable: true,
            points: this._tlLinesPoints
        }, this._scene);
        tlLines.parent = this._rootNode;
        tlLines.alwaysSelectAsActiveMesh = true;
        this._blLinesPoints = [
            (0, $ha1VO.TmpVectors).Vector3[3],
            (0, $ha1VO.TmpVectors).Vector3[4]
        ];
        const blLines = (0, $8Eyol.CreateLines)("bllines", {
            updatable: true,
            points: this._blLinesPoints
        }, this._scene);
        blLines.parent = this._rootNode;
        blLines.alwaysSelectAsActiveMesh = true;
        this._lightHelperFrustumMeshes.push(nearLines, farLines, trLines, brLines, tlLines, blLines);
        const makePlane = (name, color, positions)=>{
            const plane = new (0, $fbuqw.Mesh)(name + "plane", this._scene);
            const mat = new (0, $gAH3H.StandardMaterial)(name + "PlaneMat", this._scene);
            plane.material = mat;
            plane.parent = this._rootNode;
            plane.alwaysSelectAsActiveMesh = true;
            mat.emissiveColor = color;
            mat.alpha = this.transparency;
            mat.backFaceCulling = false;
            mat.disableLighting = true;
            const indices = [
                0,
                1,
                2,
                0,
                2,
                3
            ];
            const vertexData = new (0, $5v6ry.VertexData)();
            vertexData.positions = positions;
            vertexData.indices = indices;
            vertexData.applyToMesh(plane, true);
            this._lightHelperFrustumMeshes.push(plane);
        };
        this._nearPlaneVertices = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        this._farPlaneVertices = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        this._rightPlaneVertices = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        this._leftPlaneVertices = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        this._topPlaneVertices = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        this._bottomPlaneVertices = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        makePlane("near", new (0, $7etnY.Color3)(1, 0, 0), this._nearPlaneVertices);
        makePlane("far", new (0, $7etnY.Color3)(0.3, 0, 0), this._farPlaneVertices);
        makePlane("right", new (0, $7etnY.Color3)(0, 1, 0), this._rightPlaneVertices);
        makePlane("left", new (0, $7etnY.Color3)(0, 0.3, 0), this._leftPlaneVertices);
        makePlane("top", new (0, $7etnY.Color3)(0, 0, 1), this._topPlaneVertices);
        makePlane("bottom", new (0, $7etnY.Color3)(0, 0, 0.3), this._bottomPlaneVertices);
        this._nearLinesPoints[0] = (0, $ha1VO.TmpVectors).Vector3[2];
        this._nearLinesPoints[1] = (0, $ha1VO.TmpVectors).Vector3[3];
        this._nearLinesPoints[2] = (0, $ha1VO.TmpVectors).Vector3[4];
        this._nearLinesPoints[3] = (0, $ha1VO.TmpVectors).Vector3[5];
        this._nearLinesPoints[4] = (0, $ha1VO.TmpVectors).Vector3[2];
        this._farLinesPoints[0] = (0, $ha1VO.TmpVectors).Vector3[6];
        this._farLinesPoints[1] = (0, $ha1VO.TmpVectors).Vector3[7];
        this._farLinesPoints[2] = (0, $ha1VO.TmpVectors).Vector3[8];
        this._farLinesPoints[3] = (0, $ha1VO.TmpVectors).Vector3[9];
        this._farLinesPoints[4] = (0, $ha1VO.TmpVectors).Vector3[6];
        this._trLinesPoints[0] = (0, $ha1VO.TmpVectors).Vector3[2];
        this._trLinesPoints[1] = (0, $ha1VO.TmpVectors).Vector3[6];
        this._brLinesPoints[0] = (0, $ha1VO.TmpVectors).Vector3[3];
        this._brLinesPoints[1] = (0, $ha1VO.TmpVectors).Vector3[7];
        this._tlLinesPoints[0] = (0, $ha1VO.TmpVectors).Vector3[4];
        this._tlLinesPoints[1] = (0, $ha1VO.TmpVectors).Vector3[8];
        this._blLinesPoints[0] = (0, $ha1VO.TmpVectors).Vector3[5];
        this._blLinesPoints[1] = (0, $ha1VO.TmpVectors).Vector3[9];
    }
    _getInvertViewMatrix() {
        (0, $ha1VO.Matrix).LookAtLHToRef(this._light.position, this._light.position.add(this._light.direction), (0, $ha1VO.Vector3).UpReadOnly, this._inverseViewMatrix);
        this._inverseViewMatrix.invertToRef(this._inverseViewMatrix);
        return this._inverseViewMatrix;
    }
}

});


parcelRegister("6Ggn5", function(module, exports) {

var $1orLO = parcelRequire("1orLO");

var $5MqNc = parcelRequire("5MqNc");

var $akBjT = parcelRequire("akBjT");

var $gAZ7u = parcelRequire("gAZ7u");
$parcel$exportWildcard(module.exports, $1orLO);
$parcel$exportWildcard(module.exports, $5MqNc);
$parcel$exportWildcard(module.exports, $akBjT);
$parcel$exportWildcard(module.exports, $gAZ7u);

});
parcelRegister("5MqNc", function(module, exports) {

});


parcelRegister("aq3hd", function(module, exports) {
/* eslint-disable import/no-internal-modules */ 
var $gfKB2 = parcelRequire("gfKB2");

var $fuwv8 = parcelRequire("fuwv8");

var $dl5bv = parcelRequire("dl5bv");

var $2h5JR = parcelRequire("2h5JR");

var $5YkyR = parcelRequire("5YkyR");

var $ejQPp = parcelRequire("ejQPp");

var $3io4i = parcelRequire("3io4i");

var $4UXK1 = parcelRequire("4UXK1");

var $51AOQ = parcelRequire("51AOQ");

var $aKJV6 = parcelRequire("aKJV6");

var $g6G8S = parcelRequire("g6G8S");

var $kh9jw = parcelRequire("kh9jw");

var $d6QZE = parcelRequire("d6QZE");

var $8ClRi = parcelRequire("8ClRi");

var $hR6HG = parcelRequire("hR6HG");

var $64Ihk = parcelRequire("64Ihk");

var $UCDD1 = parcelRequire("UCDD1");

var $6dQQy = parcelRequire("6dQQy");

var $3rO3H = parcelRequire("3rO3H");

var $6okLJ = parcelRequire("6okLJ");

var $eFVmp = parcelRequire("eFVmp");

var $cvwvi = parcelRequire("cvwvi");

var $kBotW = parcelRequire("kBotW");

var $i1R6L = parcelRequire("i1R6L");

var $3DmnG = parcelRequire("3DmnG");

var $lh6wJ = parcelRequire("lh6wJ");

var $3agwF = parcelRequire("3agwF");

var $6WXVG = parcelRequire("6WXVG");

var $gcPFY = parcelRequire("gcPFY");

var $hygeI = parcelRequire("hygeI");

var $iDct0 = parcelRequire("iDct0");

var $68BIi = parcelRequire("68BIi");

var $3QmEA = parcelRequire("3QmEA");

var $f3wFg = parcelRequire("f3wFg");
$parcel$exportWildcard(module.exports, $gfKB2);
$parcel$exportWildcard(module.exports, $fuwv8);
$parcel$exportWildcard(module.exports, $dl5bv);
$parcel$exportWildcard(module.exports, $2h5JR);
$parcel$exportWildcard(module.exports, $5YkyR);
$parcel$exportWildcard(module.exports, $ejQPp);
$parcel$exportWildcard(module.exports, $3io4i);
$parcel$exportWildcard(module.exports, $4UXK1);
$parcel$exportWildcard(module.exports, $51AOQ);
$parcel$exportWildcard(module.exports, $aKJV6);
$parcel$exportWildcard(module.exports, $g6G8S);
$parcel$exportWildcard(module.exports, $kh9jw);
$parcel$exportWildcard(module.exports, $d6QZE);
$parcel$exportWildcard(module.exports, $8ClRi);
$parcel$exportWildcard(module.exports, $hR6HG);
$parcel$exportWildcard(module.exports, $64Ihk);
$parcel$exportWildcard(module.exports, $UCDD1);
$parcel$exportWildcard(module.exports, $6dQQy);
$parcel$exportWildcard(module.exports, $3rO3H);
$parcel$exportWildcard(module.exports, $6okLJ);
$parcel$exportWildcard(module.exports, $eFVmp);
$parcel$exportWildcard(module.exports, $cvwvi);
$parcel$exportWildcard(module.exports, $kBotW);
$parcel$exportWildcard(module.exports, $i1R6L);
$parcel$exportWildcard(module.exports, $3DmnG);
$parcel$exportWildcard(module.exports, $lh6wJ);
$parcel$exportWildcard(module.exports, $3agwF);
$parcel$exportWildcard(module.exports, $6WXVG);
$parcel$exportWildcard(module.exports, $gcPFY);
$parcel$exportWildcard(module.exports, $hygeI);
$parcel$exportWildcard(module.exports, $iDct0);
$parcel$exportWildcard(module.exports, $68BIi);
$parcel$exportWildcard(module.exports, $3QmEA);
$parcel$exportWildcard(module.exports, $f3wFg);

});
parcelRegister("gfKB2", function(module, exports) {

$parcel$export(module.exports, "Constants", () => $bd523120f282dc29$export$a002182e51710d39);
/* eslint-disable @typescript-eslint/naming-convention */ /** Defines the cross module used constants to avoid circular dependencies */ class $bd523120f282dc29$export$a002182e51710d39 {
}
/** Defines that alpha blending is disabled */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_DISABLE = 0;
/** Defines that alpha blending is SRC ALPHA * SRC + DEST */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_ADD = 1;
/** Defines that alpha blending is SRC ALPHA * SRC + (1 - SRC ALPHA) * DEST */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_COMBINE = 2;
/** Defines that alpha blending is DEST - SRC * DEST */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_SUBTRACT = 3;
/** Defines that alpha blending is SRC * DEST */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_MULTIPLY = 4;
/** Defines that alpha blending is SRC ALPHA * SRC + (1 - SRC) * DEST */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_MAXIMIZED = 5;
/** Defines that alpha blending is SRC + DEST */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_ONEONE = 6;
/** Defines that alpha blending is SRC + (1 - SRC ALPHA) * DEST */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_PREMULTIPLIED = 7;
/**
 * Defines that alpha blending is SRC + (1 - SRC ALPHA) * DEST
 * Alpha will be set to (1 - SRC ALPHA) * DEST ALPHA
 */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_PREMULTIPLIED_PORTERDUFF = 8;
/** Defines that alpha blending is CST * SRC + (1 - CST) * DEST */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_INTERPOLATE = 9;
/**
 * Defines that alpha blending is SRC + (1 - SRC) * DEST
 * Alpha will be set to SRC ALPHA + (1 - SRC ALPHA) * DEST ALPHA
 */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_SCREENMODE = 10;
/**
 * Defines that alpha blending is SRC + DST
 * Alpha will be set to SRC ALPHA + DST ALPHA
 */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_ONEONE_ONEONE = 11;
/**
 * Defines that alpha blending is SRC * DST ALPHA + DST
 * Alpha will be set to 0
 */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_ALPHATOCOLOR = 12;
/**
 * Defines that alpha blending is SRC * (1 - DST) + DST * (1 - SRC)
 */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_REVERSEONEMINUS = 13;
/**
 * Defines that alpha blending is SRC + DST * (1 - SRC ALPHA)
 * Alpha will be set to SRC ALPHA + DST ALPHA * (1 - SRC ALPHA)
 */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_SRC_DSTONEMINUSSRCALPHA = 14;
/**
 * Defines that alpha blending is SRC + DST
 * Alpha will be set to SRC ALPHA
 */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_ONEONE_ONEZERO = 15;
/**
 * Defines that alpha blending is SRC * (1 - DST) + DST * (1 - SRC)
 * Alpha will be set to DST ALPHA
 */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_EXCLUSION = 16;
/**
 * Defines that alpha blending is SRC * SRC ALPHA + DST * (1 - SRC ALPHA)
 * Alpha will be set to SRC ALPHA + (1 - SRC ALPHA) * DST ALPHA
 */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_LAYER_ACCUMULATE = 17;
/** Defines that alpha blending equation a SUM */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_EQUATION_ADD = 0;
/** Defines that alpha blending equation a SUBSTRACTION */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_EQUATION_SUBSTRACT = 1;
/** Defines that alpha blending equation a REVERSE SUBSTRACTION */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_EQUATION_REVERSE_SUBTRACT = 2;
/** Defines that alpha blending equation a MAX operation */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_EQUATION_MAX = 3;
/** Defines that alpha blending equation a MIN operation */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_EQUATION_MIN = 4;
/**
 * Defines that alpha blending equation a DARKEN operation:
 * It takes the min of the src and sums the alpha channels.
 */ $bd523120f282dc29$export$a002182e51710d39.ALPHA_EQUATION_DARKEN = 5;
/** Defines that the resource is not delayed*/ $bd523120f282dc29$export$a002182e51710d39.DELAYLOADSTATE_NONE = 0;
/** Defines that the resource was successfully delay loaded */ $bd523120f282dc29$export$a002182e51710d39.DELAYLOADSTATE_LOADED = 1;
/** Defines that the resource is currently delay loading */ $bd523120f282dc29$export$a002182e51710d39.DELAYLOADSTATE_LOADING = 2;
/** Defines that the resource is delayed and has not started loading */ $bd523120f282dc29$export$a002182e51710d39.DELAYLOADSTATE_NOTLOADED = 4;
// Depth or Stencil test Constants.
/** Passed to depthFunction or stencilFunction to specify depth or stencil tests will never pass. i.e. Nothing will be drawn */ $bd523120f282dc29$export$a002182e51710d39.NEVER = 0x0200;
/** Passed to depthFunction or stencilFunction to specify depth or stencil tests will always pass. i.e. Pixels will be drawn in the order they are drawn */ $bd523120f282dc29$export$a002182e51710d39.ALWAYS = 0x0207;
/** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is less than the stored value */ $bd523120f282dc29$export$a002182e51710d39.LESS = 0x0201;
/** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is equals to the stored value */ $bd523120f282dc29$export$a002182e51710d39.EQUAL = 0x0202;
/** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is less than or equal to the stored value */ $bd523120f282dc29$export$a002182e51710d39.LEQUAL = 0x0203;
/** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is greater than the stored value */ $bd523120f282dc29$export$a002182e51710d39.GREATER = 0x0204;
/** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is greater than or equal to the stored value */ $bd523120f282dc29$export$a002182e51710d39.GEQUAL = 0x0206;
/** Passed to depthFunction or stencilFunction to specify depth or stencil tests will pass if the new depth value is not equal to the stored value */ $bd523120f282dc29$export$a002182e51710d39.NOTEQUAL = 0x0205;
// Stencil Actions Constants.
/** Passed to stencilOperation to specify that stencil value must be kept */ $bd523120f282dc29$export$a002182e51710d39.KEEP = 0x1e00;
/** Passed to stencilOperation to specify that stencil value must be zero */ $bd523120f282dc29$export$a002182e51710d39.ZERO = 0x0000;
/** Passed to stencilOperation to specify that stencil value must be replaced */ $bd523120f282dc29$export$a002182e51710d39.REPLACE = 0x1e01;
/** Passed to stencilOperation to specify that stencil value must be incremented */ $bd523120f282dc29$export$a002182e51710d39.INCR = 0x1e02;
/** Passed to stencilOperation to specify that stencil value must be decremented */ $bd523120f282dc29$export$a002182e51710d39.DECR = 0x1e03;
/** Passed to stencilOperation to specify that stencil value must be inverted */ $bd523120f282dc29$export$a002182e51710d39.INVERT = 0x150a;
/** Passed to stencilOperation to specify that stencil value must be incremented with wrapping */ $bd523120f282dc29$export$a002182e51710d39.INCR_WRAP = 0x8507;
/** Passed to stencilOperation to specify that stencil value must be decremented with wrapping */ $bd523120f282dc29$export$a002182e51710d39.DECR_WRAP = 0x8508;
/** Texture is not repeating outside of 0..1 UVs */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_CLAMP_ADDRESSMODE = 0;
/** Texture is repeating outside of 0..1 UVs */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_WRAP_ADDRESSMODE = 1;
/** Texture is repeating and mirrored */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_MIRROR_ADDRESSMODE = 2;
/** Flag to create a storage texture */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_CREATIONFLAG_STORAGE = 1;
/** ALPHA */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_ALPHA = 0;
/** LUMINANCE */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_LUMINANCE = 1;
/** LUMINANCE_ALPHA */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_LUMINANCE_ALPHA = 2;
/** RGB */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_RGB = 4;
/** RGBA */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_RGBA = 5;
/** RED */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_RED = 6;
/** RED (2nd reference) */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_R = 6;
/** RG */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_RG = 7;
/** RED_INTEGER */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_RED_INTEGER = 8;
/** RED_INTEGER (2nd reference) */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_R_INTEGER = 8;
/** RG_INTEGER */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_RG_INTEGER = 9;
/** RGB_INTEGER */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_RGB_INTEGER = 10;
/** RGBA_INTEGER */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_RGBA_INTEGER = 11;
/** BGRA */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_BGRA = 12;
/** Depth 24 bits + Stencil 8 bits */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_DEPTH24_STENCIL8 = 13;
/** Depth 32 bits float */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_DEPTH32_FLOAT = 14;
/** Depth 16 bits */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_DEPTH16 = 15;
/** Depth 24 bits */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_DEPTH24 = 16;
/** Depth 24 bits unorm + Stencil 8 bits */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_DEPTH24UNORM_STENCIL8 = 17;
/** Depth 32 bits float + Stencil 8 bits */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_DEPTH32FLOAT_STENCIL8 = 18;
/** Stencil 8 bits */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_STENCIL8 = 19;
/** UNDEFINED */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_UNDEFINED = 0xffffffff;
/** Compressed BC7 */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_RGBA_BPTC_UNORM = 36492;
/** Compressed BC7 (SRGB) */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_SRGB_ALPHA_BPTC_UNORM = 36493;
/** Compressed BC6 unsigned float */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT = 36495;
/** Compressed BC6 signed float */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_RGB_BPTC_SIGNED_FLOAT = 36494;
/** Compressed BC3 */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_RGBA_S3TC_DXT5 = 33779;
/** Compressed BC3 (SRGB) */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT = 35919;
/** Compressed BC2 */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_RGBA_S3TC_DXT3 = 33778;
/** Compressed BC2 (SRGB) */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT = 35918;
/** Compressed BC1 (RGBA) */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_RGBA_S3TC_DXT1 = 33777;
/** Compressed BC1 (RGB) */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_RGB_S3TC_DXT1 = 33776;
/** Compressed BC1 (SRGB+A) */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT = 35917;
/** Compressed BC1 (SRGB) */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_SRGB_S3TC_DXT1_EXT = 35916;
/** Compressed ASTC 4x4 */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_RGBA_ASTC_4x4 = 37808;
/** Compressed ASTC 4x4 (SRGB) */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR = 37840;
/** Compressed ETC1 (RGB) */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_RGB_ETC1_WEBGL = 36196;
/** Compressed ETC2 (RGB) */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_RGB8_ETC2 = 37492;
/** Compressed ETC2 (SRGB) */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_SRGB8_ETC2 = 37493;
/** Compressed ETC2 (RGB+A1) */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_RGB8_PUNCHTHROUGH_ALPHA1_ETC2 = 37494;
/** Compressed ETC2 (SRGB+A1)*/ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_SRGB8_PUNCHTHROUGH_ALPHA1_ETC2 = 37495;
/** Compressed ETC2 (RGB+A) */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_RGBA8_ETC2_EAC = 37496;
/** Compressed ETC2 (SRGB+1) */ $bd523120f282dc29$export$a002182e51710d39.TEXTUREFORMAT_COMPRESSED_SRGB8_ALPHA8_ETC2_EAC = 37497;
/** UNSIGNED_BYTE */ $bd523120f282dc29$export$a002182e51710d39.TEXTURETYPE_UNSIGNED_BYTE = 0;
/** UNSIGNED_BYTE (2nd reference) */ $bd523120f282dc29$export$a002182e51710d39.TEXTURETYPE_UNSIGNED_INT = 0;
/** FLOAT */ $bd523120f282dc29$export$a002182e51710d39.TEXTURETYPE_FLOAT = 1;
/** HALF_FLOAT */ $bd523120f282dc29$export$a002182e51710d39.TEXTURETYPE_HALF_FLOAT = 2;
/** BYTE */ $bd523120f282dc29$export$a002182e51710d39.TEXTURETYPE_BYTE = 3;
/** SHORT */ $bd523120f282dc29$export$a002182e51710d39.TEXTURETYPE_SHORT = 4;
/** UNSIGNED_SHORT */ $bd523120f282dc29$export$a002182e51710d39.TEXTURETYPE_UNSIGNED_SHORT = 5;
/** INT */ $bd523120f282dc29$export$a002182e51710d39.TEXTURETYPE_INT = 6;
/** UNSIGNED_INT */ $bd523120f282dc29$export$a002182e51710d39.TEXTURETYPE_UNSIGNED_INTEGER = 7;
/** UNSIGNED_SHORT_4_4_4_4 */ $bd523120f282dc29$export$a002182e51710d39.TEXTURETYPE_UNSIGNED_SHORT_4_4_4_4 = 8;
/** UNSIGNED_SHORT_5_5_5_1 */ $bd523120f282dc29$export$a002182e51710d39.TEXTURETYPE_UNSIGNED_SHORT_5_5_5_1 = 9;
/** UNSIGNED_SHORT_5_6_5 */ $bd523120f282dc29$export$a002182e51710d39.TEXTURETYPE_UNSIGNED_SHORT_5_6_5 = 10;
/** UNSIGNED_INT_2_10_10_10_REV */ $bd523120f282dc29$export$a002182e51710d39.TEXTURETYPE_UNSIGNED_INT_2_10_10_10_REV = 11;
/** UNSIGNED_INT_24_8 */ $bd523120f282dc29$export$a002182e51710d39.TEXTURETYPE_UNSIGNED_INT_24_8 = 12;
/** UNSIGNED_INT_10F_11F_11F_REV */ $bd523120f282dc29$export$a002182e51710d39.TEXTURETYPE_UNSIGNED_INT_10F_11F_11F_REV = 13;
/** UNSIGNED_INT_5_9_9_9_REV */ $bd523120f282dc29$export$a002182e51710d39.TEXTURETYPE_UNSIGNED_INT_5_9_9_9_REV = 14;
/** FLOAT_32_UNSIGNED_INT_24_8_REV */ $bd523120f282dc29$export$a002182e51710d39.TEXTURETYPE_FLOAT_32_UNSIGNED_INT_24_8_REV = 15;
/** UNDEFINED */ $bd523120f282dc29$export$a002182e51710d39.TEXTURETYPE_UNDEFINED = 16;
/** 2D Texture target*/ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_2D = 3553;
/** 2D Array Texture target */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_2D_ARRAY = 35866;
/** Cube Map Texture target */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_CUBE_MAP = 34067;
/** Cube Map Array Texture target */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_CUBE_MAP_ARRAY = 0xdeadbeef;
/** 3D Texture target */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_3D = 32879;
/** nearest is mag = nearest and min = nearest and no mip */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_NEAREST_SAMPLINGMODE = 1;
/** mag = nearest and min = nearest and mip = none */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_NEAREST_NEAREST = 1;
/** Bilinear is mag = linear and min = linear and no mip */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_BILINEAR_SAMPLINGMODE = 2;
/** mag = linear and min = linear and mip = none */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_LINEAR_LINEAR = 2;
/** Trilinear is mag = linear and min = linear and mip = linear */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_TRILINEAR_SAMPLINGMODE = 3;
/** Trilinear is mag = linear and min = linear and mip = linear */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_LINEAR_LINEAR_MIPLINEAR = 3;
/** mag = nearest and min = nearest and mip = nearest */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_NEAREST_NEAREST_MIPNEAREST = 4;
/** mag = nearest and min = linear and mip = nearest */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_NEAREST_LINEAR_MIPNEAREST = 5;
/** mag = nearest and min = linear and mip = linear */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_NEAREST_LINEAR_MIPLINEAR = 6;
/** mag = nearest and min = linear and mip = none */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_NEAREST_LINEAR = 7;
/** nearest is mag = nearest and min = nearest and mip = linear */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_NEAREST_NEAREST_MIPLINEAR = 8;
/** mag = linear and min = nearest and mip = nearest */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_LINEAR_NEAREST_MIPNEAREST = 9;
/** mag = linear and min = nearest and mip = linear */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_LINEAR_NEAREST_MIPLINEAR = 10;
/** Bilinear is mag = linear and min = linear and mip = nearest */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_LINEAR_LINEAR_MIPNEAREST = 11;
/** mag = linear and min = nearest and mip = none */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_LINEAR_NEAREST = 12;
/** Explicit coordinates mode */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_EXPLICIT_MODE = 0;
/** Spherical coordinates mode */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_SPHERICAL_MODE = 1;
/** Planar coordinates mode */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_PLANAR_MODE = 2;
/** Cubic coordinates mode */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_CUBIC_MODE = 3;
/** Projection coordinates mode */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_PROJECTION_MODE = 4;
/** Skybox coordinates mode */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_SKYBOX_MODE = 5;
/** Inverse Cubic coordinates mode */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_INVCUBIC_MODE = 6;
/** Equirectangular coordinates mode */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_EQUIRECTANGULAR_MODE = 7;
/** Equirectangular Fixed coordinates mode */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_FIXED_EQUIRECTANGULAR_MODE = 8;
/** Equirectangular Fixed Mirrored coordinates mode */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_FIXED_EQUIRECTANGULAR_MIRRORED_MODE = 9;
/** Offline (baking) quality for texture filtering */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_FILTERING_QUALITY_OFFLINE = 4096;
/** High quality for texture filtering */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_FILTERING_QUALITY_HIGH = 64;
/** Medium quality for texture filtering */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_FILTERING_QUALITY_MEDIUM = 16;
/** Low quality for texture filtering */ $bd523120f282dc29$export$a002182e51710d39.TEXTURE_FILTERING_QUALITY_LOW = 8;
// Texture rescaling mode
/** Defines that texture rescaling will use a floor to find the closer power of 2 size */ $bd523120f282dc29$export$a002182e51710d39.SCALEMODE_FLOOR = 1;
/** Defines that texture rescaling will look for the nearest power of 2 size */ $bd523120f282dc29$export$a002182e51710d39.SCALEMODE_NEAREST = 2;
/** Defines that texture rescaling will use a ceil to find the closer power of 2 size */ $bd523120f282dc29$export$a002182e51710d39.SCALEMODE_CEILING = 3;
/**
 * The dirty texture flag value
 */ $bd523120f282dc29$export$a002182e51710d39.MATERIAL_TextureDirtyFlag = 1;
/**
 * The dirty light flag value
 */ $bd523120f282dc29$export$a002182e51710d39.MATERIAL_LightDirtyFlag = 2;
/**
 * The dirty fresnel flag value
 */ $bd523120f282dc29$export$a002182e51710d39.MATERIAL_FresnelDirtyFlag = 4;
/**
 * The dirty attribute flag value
 */ $bd523120f282dc29$export$a002182e51710d39.MATERIAL_AttributesDirtyFlag = 8;
/**
 * The dirty misc flag value
 */ $bd523120f282dc29$export$a002182e51710d39.MATERIAL_MiscDirtyFlag = 16;
/**
 * The dirty prepass flag value
 */ $bd523120f282dc29$export$a002182e51710d39.MATERIAL_PrePassDirtyFlag = 32;
/**
 * The all dirty flag value
 */ $bd523120f282dc29$export$a002182e51710d39.MATERIAL_AllDirtyFlag = 63;
/**
 * Returns the triangle fill mode
 */ $bd523120f282dc29$export$a002182e51710d39.MATERIAL_TriangleFillMode = 0;
/**
 * Returns the wireframe mode
 */ $bd523120f282dc29$export$a002182e51710d39.MATERIAL_WireFrameFillMode = 1;
/**
 * Returns the point fill mode
 */ $bd523120f282dc29$export$a002182e51710d39.MATERIAL_PointFillMode = 2;
/**
 * Returns the point list draw mode
 */ $bd523120f282dc29$export$a002182e51710d39.MATERIAL_PointListDrawMode = 3;
/**
 * Returns the line list draw mode
 */ $bd523120f282dc29$export$a002182e51710d39.MATERIAL_LineListDrawMode = 4;
/**
 * Returns the line loop draw mode
 */ $bd523120f282dc29$export$a002182e51710d39.MATERIAL_LineLoopDrawMode = 5;
/**
 * Returns the line strip draw mode
 */ $bd523120f282dc29$export$a002182e51710d39.MATERIAL_LineStripDrawMode = 6;
/**
 * Returns the triangle strip draw mode
 */ $bd523120f282dc29$export$a002182e51710d39.MATERIAL_TriangleStripDrawMode = 7;
/**
 * Returns the triangle fan draw mode
 */ $bd523120f282dc29$export$a002182e51710d39.MATERIAL_TriangleFanDrawMode = 8;
/**
 * Stores the clock-wise side orientation
 */ $bd523120f282dc29$export$a002182e51710d39.MATERIAL_ClockWiseSideOrientation = 0;
/**
 * Stores the counter clock-wise side orientation
 */ $bd523120f282dc29$export$a002182e51710d39.MATERIAL_CounterClockWiseSideOrientation = 1;
/**
 * Nothing
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $bd523120f282dc29$export$a002182e51710d39.ACTION_NothingTrigger = 0;
/**
 * On pick
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $bd523120f282dc29$export$a002182e51710d39.ACTION_OnPickTrigger = 1;
/**
 * On left pick
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $bd523120f282dc29$export$a002182e51710d39.ACTION_OnLeftPickTrigger = 2;
/**
 * On right pick
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $bd523120f282dc29$export$a002182e51710d39.ACTION_OnRightPickTrigger = 3;
/**
 * On center pick
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $bd523120f282dc29$export$a002182e51710d39.ACTION_OnCenterPickTrigger = 4;
/**
 * On pick down
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $bd523120f282dc29$export$a002182e51710d39.ACTION_OnPickDownTrigger = 5;
/**
 * On double pick
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $bd523120f282dc29$export$a002182e51710d39.ACTION_OnDoublePickTrigger = 6;
/**
 * On pick up
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $bd523120f282dc29$export$a002182e51710d39.ACTION_OnPickUpTrigger = 7;
/**
 * On pick out.
 * This trigger will only be raised if you also declared a OnPickDown
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $bd523120f282dc29$export$a002182e51710d39.ACTION_OnPickOutTrigger = 16;
/**
 * On long press
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $bd523120f282dc29$export$a002182e51710d39.ACTION_OnLongPressTrigger = 8;
/**
 * On pointer over
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $bd523120f282dc29$export$a002182e51710d39.ACTION_OnPointerOverTrigger = 9;
/**
 * On pointer out
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $bd523120f282dc29$export$a002182e51710d39.ACTION_OnPointerOutTrigger = 10;
/**
 * On every frame
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $bd523120f282dc29$export$a002182e51710d39.ACTION_OnEveryFrameTrigger = 11;
/**
 * On intersection enter
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $bd523120f282dc29$export$a002182e51710d39.ACTION_OnIntersectionEnterTrigger = 12;
/**
 * On intersection exit
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $bd523120f282dc29$export$a002182e51710d39.ACTION_OnIntersectionExitTrigger = 13;
/**
 * On key down
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $bd523120f282dc29$export$a002182e51710d39.ACTION_OnKeyDownTrigger = 14;
/**
 * On key up
 * @see https://doc.babylonjs.com/features/featuresDeepDive/events/actions#triggers
 */ $bd523120f282dc29$export$a002182e51710d39.ACTION_OnKeyUpTrigger = 15;
/**
 * Billboard mode will only apply to Y axis
 */ $bd523120f282dc29$export$a002182e51710d39.PARTICLES_BILLBOARDMODE_Y = 2;
/**
 * Billboard mode will apply to all axes
 */ $bd523120f282dc29$export$a002182e51710d39.PARTICLES_BILLBOARDMODE_ALL = 7;
/**
 * Special billboard mode where the particle will be biilboard to the camera but rotated to align with direction
 */ $bd523120f282dc29$export$a002182e51710d39.PARTICLES_BILLBOARDMODE_STRETCHED = 8;
/**
 * Special billboard mode where the particle will be billboard to the camera but only around the axis of the direction of particle emission
 */ $bd523120f282dc29$export$a002182e51710d39.PARTICLES_BILLBOARDMODE_STRETCHED_LOCAL = 9;
/** Default culling strategy : this is an exclusion test and it's the more accurate.
 *  Test order :
 *  Is the bounding sphere outside the frustum ?
 *  If not, are the bounding box vertices outside the frustum ?
 *  It not, then the cullable object is in the frustum.
 */ $bd523120f282dc29$export$a002182e51710d39.MESHES_CULLINGSTRATEGY_STANDARD = 0;
/** Culling strategy : Bounding Sphere Only.
 *  This is an exclusion test. It's faster than the standard strategy because the bounding box is not tested.
 *  It's also less accurate than the standard because some not visible objects can still be selected.
 *  Test : is the bounding sphere outside the frustum ?
 *  If not, then the cullable object is in the frustum.
 */ $bd523120f282dc29$export$a002182e51710d39.MESHES_CULLINGSTRATEGY_BOUNDINGSPHERE_ONLY = 1;
/** Culling strategy : Optimistic Inclusion.
 *  This in an inclusion test first, then the standard exclusion test.
 *  This can be faster when a cullable object is expected to be almost always in the camera frustum.
 *  This could also be a little slower than the standard test when the tested object center is not the frustum but one of its bounding box vertex is still inside.
 *  Anyway, it's as accurate as the standard strategy.
 *  Test :
 *  Is the cullable object bounding sphere center in the frustum ?
 *  If not, apply the default culling strategy.
 */ $bd523120f282dc29$export$a002182e51710d39.MESHES_CULLINGSTRATEGY_OPTIMISTIC_INCLUSION = 2;
/** Culling strategy : Optimistic Inclusion then Bounding Sphere Only.
 *  This in an inclusion test first, then the bounding sphere only exclusion test.
 *  This can be the fastest test when a cullable object is expected to be almost always in the camera frustum.
 *  This could also be a little slower than the BoundingSphereOnly strategy when the tested object center is not in the frustum but its bounding sphere still intersects it.
 *  It's less accurate than the standard strategy and as accurate as the BoundingSphereOnly strategy.
 *  Test :
 *  Is the cullable object bounding sphere center in the frustum ?
 *  If not, apply the Bounding Sphere Only strategy. No Bounding Box is tested here.
 */ $bd523120f282dc29$export$a002182e51710d39.MESHES_CULLINGSTRATEGY_OPTIMISTIC_INCLUSION_THEN_BSPHERE_ONLY = 3;
/**
 * No logging while loading
 */ $bd523120f282dc29$export$a002182e51710d39.SCENELOADER_NO_LOGGING = 0;
/**
 * Minimal logging while loading
 */ $bd523120f282dc29$export$a002182e51710d39.SCENELOADER_MINIMAL_LOGGING = 1;
/**
 * Summary logging while loading
 */ $bd523120f282dc29$export$a002182e51710d39.SCENELOADER_SUMMARY_LOGGING = 2;
/**
 * Detailed logging while loading
 */ $bd523120f282dc29$export$a002182e51710d39.SCENELOADER_DETAILED_LOGGING = 3;
/**
 * Constant used to retrieve the irradiance texture index in the textures array in the prepass
 * using getIndex(Constants.PREPASS_IRRADIANCE_TEXTURE_TYPE)
 */ $bd523120f282dc29$export$a002182e51710d39.PREPASS_IRRADIANCE_TEXTURE_TYPE = 0;
/**
 * Constant used to retrieve the position texture index in the textures array in the prepass
 * using getIndex(Constants.PREPASS_POSITION_TEXTURE_INDEX)
 */ $bd523120f282dc29$export$a002182e51710d39.PREPASS_POSITION_TEXTURE_TYPE = 1;
/**
 * Constant used to retrieve the velocity texture index in the textures array in the prepass
 * using getIndex(Constants.PREPASS_VELOCITY_TEXTURE_INDEX)
 */ $bd523120f282dc29$export$a002182e51710d39.PREPASS_VELOCITY_TEXTURE_TYPE = 2;
/**
 * Constant used to retrieve the reflectivity texture index in the textures array in the prepass
 * using the getIndex(Constants.PREPASS_REFLECTIVITY_TEXTURE_TYPE)
 */ $bd523120f282dc29$export$a002182e51710d39.PREPASS_REFLECTIVITY_TEXTURE_TYPE = 3;
/**
 * Constant used to retrieve the lit color texture index in the textures array in the prepass
 * using the getIndex(Constants.PREPASS_COLOR_TEXTURE_TYPE)
 */ $bd523120f282dc29$export$a002182e51710d39.PREPASS_COLOR_TEXTURE_TYPE = 4;
/**
 * Constant used to retrieve depth index in the textures array in the prepass
 * using the getIndex(Constants.PREPASS_DEPTH_TEXTURE_TYPE)
 */ $bd523120f282dc29$export$a002182e51710d39.PREPASS_DEPTH_TEXTURE_TYPE = 5;
/**
 * Constant used to retrieve normal index in the textures array in the prepass
 * using the getIndex(Constants.PREPASS_NORMAL_TEXTURE_TYPE)
 */ $bd523120f282dc29$export$a002182e51710d39.PREPASS_NORMAL_TEXTURE_TYPE = 6;
/**
 * Constant used to retrieve albedo index in the textures array in the prepass
 * using the getIndex(Constants.PREPASS_ALBEDO_SQRT_TEXTURE_TYPE)
 */ $bd523120f282dc29$export$a002182e51710d39.PREPASS_ALBEDO_SQRT_TEXTURE_TYPE = 7;
/** Flag to create a readable buffer (the buffer can be the source of a copy) */ $bd523120f282dc29$export$a002182e51710d39.BUFFER_CREATIONFLAG_READ = 1;
/** Flag to create a writable buffer (the buffer can be the destination of a copy) */ $bd523120f282dc29$export$a002182e51710d39.BUFFER_CREATIONFLAG_WRITE = 2;
/** Flag to create a readable and writable buffer */ $bd523120f282dc29$export$a002182e51710d39.BUFFER_CREATIONFLAG_READWRITE = 3;
/** Flag to create a buffer suitable to be used as a uniform buffer */ $bd523120f282dc29$export$a002182e51710d39.BUFFER_CREATIONFLAG_UNIFORM = 4;
/** Flag to create a buffer suitable to be used as a vertex buffer */ $bd523120f282dc29$export$a002182e51710d39.BUFFER_CREATIONFLAG_VERTEX = 8;
/** Flag to create a buffer suitable to be used as an index buffer */ $bd523120f282dc29$export$a002182e51710d39.BUFFER_CREATIONFLAG_INDEX = 16;
/** Flag to create a buffer suitable to be used as a storage buffer */ $bd523120f282dc29$export$a002182e51710d39.BUFFER_CREATIONFLAG_STORAGE = 32;
/**
 * Prefixes used by the engine for sub mesh draw wrappers
 */ /** @internal */ $bd523120f282dc29$export$a002182e51710d39.RENDERPASS_MAIN = 0;
/**
 * Constant used as key code for Alt key
 */ $bd523120f282dc29$export$a002182e51710d39.INPUT_ALT_KEY = 18;
/**
 * Constant used as key code for Ctrl key
 */ $bd523120f282dc29$export$a002182e51710d39.INPUT_CTRL_KEY = 17;
/**
 * Constant used as key code for Meta key (Left Win, Left Cmd)
 */ $bd523120f282dc29$export$a002182e51710d39.INPUT_META_KEY1 = 91;
/**
 * Constant used as key code for Meta key (Right Win)
 */ $bd523120f282dc29$export$a002182e51710d39.INPUT_META_KEY2 = 92;
/**
 * Constant used as key code for Meta key (Right Win, Right Cmd)
 */ $bd523120f282dc29$export$a002182e51710d39.INPUT_META_KEY3 = 93;
/**
 * Constant used as key code for Shift key
 */ $bd523120f282dc29$export$a002182e51710d39.INPUT_SHIFT_KEY = 16;
/** Standard snapshot rendering. In this mode, some form of dynamic behavior is possible (for eg, uniform buffers are still updated) */ $bd523120f282dc29$export$a002182e51710d39.SNAPSHOTRENDERING_STANDARD = 0;
/** Fast snapshot rendering. In this mode, everything is static and only some limited form of dynamic behaviour is possible */ $bd523120f282dc29$export$a002182e51710d39.SNAPSHOTRENDERING_FAST = 1;
/**
 * This is the default projection mode used by the cameras.
 * It helps recreating a feeling of perspective and better appreciate depth.
 * This is the best way to simulate real life cameras.
 */ $bd523120f282dc29$export$a002182e51710d39.PERSPECTIVE_CAMERA = 0;
/**
 * This helps creating camera with an orthographic mode.
 * Orthographic is commonly used in engineering as a means to produce object specifications that communicate dimensions unambiguously, each line of 1 unit length (cm, meter..whatever) will appear to have the same length everywhere on the drawing. This allows the drafter to dimension only a subset of lines and let the reader know that other lines of that length on the drawing are also that length in reality. Every parallel line in the drawing is also parallel in the object.
 */ $bd523120f282dc29$export$a002182e51710d39.ORTHOGRAPHIC_CAMERA = 1;
/**
 * This is the default FOV mode for perspective cameras.
 * This setting aligns the upper and lower bounds of the viewport to the upper and lower bounds of the camera frustum.
 */ $bd523120f282dc29$export$a002182e51710d39.FOVMODE_VERTICAL_FIXED = 0;
/**
 * This setting aligns the left and right bounds of the viewport to the left and right bounds of the camera frustum.
 */ $bd523120f282dc29$export$a002182e51710d39.FOVMODE_HORIZONTAL_FIXED = 1;
/**
 * This specifies there is no need for a camera rig.
 * Basically only one eye is rendered corresponding to the camera.
 */ $bd523120f282dc29$export$a002182e51710d39.RIG_MODE_NONE = 0;
/**
 * Simulates a camera Rig with one blue eye and one red eye.
 * This can be use with 3d blue and red glasses.
 */ $bd523120f282dc29$export$a002182e51710d39.RIG_MODE_STEREOSCOPIC_ANAGLYPH = 10;
/**
 * Defines that both eyes of the camera will be rendered side by side with a parallel target.
 */ $bd523120f282dc29$export$a002182e51710d39.RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_PARALLEL = 11;
/**
 * Defines that both eyes of the camera will be rendered side by side with a none parallel target.
 */ $bd523120f282dc29$export$a002182e51710d39.RIG_MODE_STEREOSCOPIC_SIDEBYSIDE_CROSSEYED = 12;
/**
 * Defines that both eyes of the camera will be rendered over under each other.
 */ $bd523120f282dc29$export$a002182e51710d39.RIG_MODE_STEREOSCOPIC_OVERUNDER = 13;
/**
 * Defines that both eyes of the camera will be rendered on successive lines interlaced for passive 3d monitors.
 */ $bd523120f282dc29$export$a002182e51710d39.RIG_MODE_STEREOSCOPIC_INTERLACED = 14;
/**
 * Defines that both eyes of the camera should be renderered in a VR mode (carbox).
 */ $bd523120f282dc29$export$a002182e51710d39.RIG_MODE_VR = 20;
/**
 * Custom rig mode allowing rig cameras to be populated manually with any number of cameras
 */ $bd523120f282dc29$export$a002182e51710d39.RIG_MODE_CUSTOM = 22;
/**
 * Maximum number of uv sets supported
 */ $bd523120f282dc29$export$a002182e51710d39.MAX_SUPPORTED_UV_SETS = 6;
/**
 * GL constants
 */ /** Alpha blend equation: ADD */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_EQUATION_ADD = 0x8006;
/** Alpha equation: MIN */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_EQUATION_MIN = 0x8007;
/** Alpha equation: MAX */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_EQUATION_MAX = 0x8008;
/** Alpha equation: SUBTRACT */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_EQUATION_SUBTRACT = 0x800a;
/** Alpha equation: REVERSE_SUBTRACT */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_EQUATION_REVERSE_SUBTRACT = 0x800b;
/** Alpha blend function: SRC */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_FUNCTION_SRC = 0x0300;
/** Alpha blend function: ONE_MINUS_SRC */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_FUNCTION_ONE_MINUS_SRC_COLOR = 0x0301;
/** Alpha blend function: SRC_ALPHA */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_FUNCTION_SRC_ALPHA = 0x0302;
/** Alpha blend function: ONE_MINUS_SRC_ALPHA */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_FUNCTION_ONE_MINUS_SRC_ALPHA = 0x0303;
/** Alpha blend function: DST_ALPHA */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_FUNCTION_DST_ALPHA = 0x0304;
/** Alpha blend function: ONE_MINUS_DST_ALPHA */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_FUNCTION_ONE_MINUS_DST_ALPHA = 0x0305;
/** Alpha blend function: ONE_MINUS_DST */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_FUNCTION_DST_COLOR = 0x0306;
/** Alpha blend function: ONE_MINUS_DST */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_FUNCTION_ONE_MINUS_DST_COLOR = 0x0307;
/** Alpha blend function: SRC_ALPHA_SATURATED */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_FUNCTION_SRC_ALPHA_SATURATED = 0x0308;
/** Alpha blend function: CONSTANT */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_FUNCTION_CONSTANT_COLOR = 0x8001;
/** Alpha blend function: ONE_MINUS_CONSTANT */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_FUNCTION_ONE_MINUS_CONSTANT_COLOR = 0x8002;
/** Alpha blend function: CONSTANT_ALPHA */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_FUNCTION_CONSTANT_ALPHA = 0x8003;
/** Alpha blend function: ONE_MINUS_CONSTANT_ALPHA */ $bd523120f282dc29$export$a002182e51710d39.GL_ALPHA_FUNCTION_ONE_MINUS_CONSTANT_ALPHA = 0x8004;
/** URL to the snippet server. Points to the public snippet server by default */ $bd523120f282dc29$export$a002182e51710d39.SnippetUrl = "https://snippet.babylonjs.com";
/** The fog is deactivated */ $bd523120f282dc29$export$a002182e51710d39.FOGMODE_NONE = 0;
/** The fog density is following an exponential function */ $bd523120f282dc29$export$a002182e51710d39.FOGMODE_EXP = 1;
/** The fog density is following an exponential function faster than FOGMODE_EXP */ $bd523120f282dc29$export$a002182e51710d39.FOGMODE_EXP2 = 2;
/** The fog density is following a linear function. */ $bd523120f282dc29$export$a002182e51710d39.FOGMODE_LINEAR = 3;
/**
 * The byte type.
 */ $bd523120f282dc29$export$a002182e51710d39.BYTE = 5120;
/**
 * The unsigned byte type.
 */ $bd523120f282dc29$export$a002182e51710d39.UNSIGNED_BYTE = 5121;
/**
 * The short type.
 */ $bd523120f282dc29$export$a002182e51710d39.SHORT = 5122;
/**
 * The unsigned short type.
 */ $bd523120f282dc29$export$a002182e51710d39.UNSIGNED_SHORT = 5123;
/**
 * The integer type.
 */ $bd523120f282dc29$export$a002182e51710d39.INT = 5124;
/**
 * The unsigned integer type.
 */ $bd523120f282dc29$export$a002182e51710d39.UNSIGNED_INT = 5125;
/**
 * The float type.
 */ $bd523120f282dc29$export$a002182e51710d39.FLOAT = 5126;
/**
 * Positions
 */ $bd523120f282dc29$export$a002182e51710d39.PositionKind = "position";
/**
 * Normals
 */ $bd523120f282dc29$export$a002182e51710d39.NormalKind = "normal";
/**
 * Tangents
 */ $bd523120f282dc29$export$a002182e51710d39.TangentKind = "tangent";
/**
 * Texture coordinates
 */ $bd523120f282dc29$export$a002182e51710d39.UVKind = "uv";
/**
 * Texture coordinates 2
 */ $bd523120f282dc29$export$a002182e51710d39.UV2Kind = "uv2";
/**
 * Texture coordinates 3
 */ $bd523120f282dc29$export$a002182e51710d39.UV3Kind = "uv3";
/**
 * Texture coordinates 4
 */ $bd523120f282dc29$export$a002182e51710d39.UV4Kind = "uv4";
/**
 * Texture coordinates 5
 */ $bd523120f282dc29$export$a002182e51710d39.UV5Kind = "uv5";
/**
 * Texture coordinates 6
 */ $bd523120f282dc29$export$a002182e51710d39.UV6Kind = "uv6";
/**
 * Colors
 */ $bd523120f282dc29$export$a002182e51710d39.ColorKind = "color";
/**
 * Instance Colors
 */ $bd523120f282dc29$export$a002182e51710d39.ColorInstanceKind = "instanceColor";
/**
 * Matrix indices (for bones)
 */ $bd523120f282dc29$export$a002182e51710d39.MatricesIndicesKind = "matricesIndices";
/**
 * Matrix weights (for bones)
 */ $bd523120f282dc29$export$a002182e51710d39.MatricesWeightsKind = "matricesWeights";
/**
 * Additional matrix indices (for bones)
 */ $bd523120f282dc29$export$a002182e51710d39.MatricesIndicesExtraKind = "matricesIndicesExtra";
/**
 * Additional matrix weights (for bones)
 */ $bd523120f282dc29$export$a002182e51710d39.MatricesWeightsExtraKind = "matricesWeightsExtra";

});

parcelRegister("fuwv8", function(module, exports) {

});

parcelRegister("dl5bv", function(module, exports) {

});

parcelRegister("3io4i", function(module, exports) {

$parcel$export(module.exports, "NullEngineOptions", () => $2665b904a92ddd20$export$3ac22131d8f2fbc0);
$parcel$export(module.exports, "NullEngine", () => $2665b904a92ddd20$export$1fb9075dc700fe0b);
/* eslint-disable @typescript-eslint/no-unused-vars */ 
var $kVtWi = parcelRequire("kVtWi");

var $5YkyR = parcelRequire("5YkyR");

var $b9e4a = parcelRequire("b9e4a");

var $6zPKs = parcelRequire("6zPKs");

var $3agwF = parcelRequire("3agwF");

var $hOyoX = parcelRequire("hOyoX");

var $3QmEA = parcelRequire("3QmEA");
class $2665b904a92ddd20$export$3ac22131d8f2fbc0 {
    constructor(){
        /**
         * Render width (Default: 512)
         */ this.renderWidth = 512;
        /**
         * Render height (Default: 256)
         */ this.renderHeight = 256;
        /**
         * Texture size (Default: 512)
         */ this.textureSize = 512;
        /**
         * If delta time between frames should be constant
         * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#deterministic-lockstep
         */ this.deterministicLockstep = false;
        /**
         * Maximum about of steps between frames (Default: 4)
         * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#deterministic-lockstep
         */ this.lockstepMaxSteps = 4;
    }
}
class $2665b904a92ddd20$export$1fb9075dc700fe0b extends (0, $5YkyR.Engine) {
    /**
     * Gets a boolean indicating that the engine is running in deterministic lock step mode
     * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#deterministic-lockstep
     * @returns true if engine is in deterministic lock step mode
     */ isDeterministicLockStep() {
        return this._options.deterministicLockstep;
    }
    /**
     * Gets the max steps when engine is running in deterministic lock step
     * @see https://doc.babylonjs.com/features/featuresDeepDive/animation/advanced_animations#deterministic-lockstep
     * @returns the max steps
     */ getLockstepMaxSteps() {
        return this._options.lockstepMaxSteps;
    }
    /**
     * Gets the current hardware scaling level.
     * By default the hardware scaling level is computed from the window device ratio.
     * if level = 1 then the engine will render at the exact resolution of the canvas. If level = 0.5 then the engine will render at twice the size of the canvas.
     * @returns a number indicating the current hardware scaling level
     */ getHardwareScalingLevel() {
        return 1.0;
    }
    constructor(options = new $2665b904a92ddd20$export$3ac22131d8f2fbc0()){
        super(null);
        (0, $5YkyR.Engine).Instances.push(this);
        if (options.deterministicLockstep === undefined) options.deterministicLockstep = false;
        if (options.timeStep !== undefined) this._timeStep = options.timeStep;
        if (options.lockstepMaxSteps === undefined) options.lockstepMaxSteps = 4;
        this._options = options;
        (0, $3agwF.PerformanceConfigurator).SetMatrixPrecision(!!options.useHighPrecisionMatrix);
        // Init caps
        // We consider we are on a webgl1 capable device
        this._caps = {
            maxTexturesImageUnits: 16,
            maxVertexTextureImageUnits: 16,
            maxCombinedTexturesImageUnits: 32,
            maxTextureSize: 512,
            maxCubemapTextureSize: 512,
            maxRenderTextureSize: 512,
            maxVertexAttribs: 16,
            maxVaryingVectors: 16,
            maxFragmentUniformVectors: 16,
            maxVertexUniformVectors: 16,
            standardDerivatives: false,
            astc: null,
            pvrtc: null,
            etc1: null,
            etc2: null,
            bptc: null,
            maxAnisotropy: 0,
            uintIndices: false,
            fragmentDepthSupported: false,
            highPrecisionShaderSupported: true,
            colorBufferFloat: false,
            supportFloatTexturesResolve: false,
            rg11b10ufColorRenderable: false,
            textureFloat: false,
            textureFloatLinearFiltering: false,
            textureFloatRender: false,
            textureHalfFloat: false,
            textureHalfFloatLinearFiltering: false,
            textureHalfFloatRender: false,
            textureLOD: false,
            texelFetch: false,
            drawBuffersExtension: false,
            depthTextureExtension: false,
            vertexArrayObject: false,
            instancedArrays: false,
            supportOcclusionQuery: false,
            canUseTimestampForTimerQuery: false,
            maxMSAASamples: 1,
            blendMinMax: false,
            canUseGLInstanceID: false,
            canUseGLVertexID: false,
            supportComputeShaders: false,
            supportSRGBBuffers: false,
            supportTransformFeedbacks: false,
            textureMaxLevel: false,
            texture2DArrayMaxLayerCount: 128,
            disableMorphTargetTexture: false
        };
        this._features = {
            forceBitmapOverHTMLImageElement: false,
            supportRenderAndCopyToLodForFloatTextures: false,
            supportDepthStencilTexture: false,
            supportShadowSamplers: false,
            uniformBufferHardCheckMatrix: false,
            allowTexturePrefiltering: false,
            trackUbosInFrame: false,
            checkUbosContentBeforeUpload: false,
            supportCSM: false,
            basisNeedsPOT: false,
            support3DTextures: false,
            needTypeSuffixInShaderConstants: false,
            supportMSAA: false,
            supportSSAO2: false,
            supportExtendedTextureFormats: false,
            supportSwitchCaseInShader: false,
            supportSyncTextureRead: false,
            needsInvertingBitmap: false,
            useUBOBindingCache: false,
            needShaderCodeInlining: false,
            needToAlwaysBindUniformBuffers: false,
            supportRenderPasses: true,
            supportSpriteInstancing: false,
            forceVertexBufferStrideAndOffsetMultiple4Bytes: false,
            _collectUbosUpdatedInFrame: false
        };
        (0, $kVtWi.Logger).Log(`Babylon.js v${(0, $5YkyR.Engine).Version} - Null engine`);
        // Wrappers
        const theCurrentGlobal = typeof self !== "undefined" ? self : typeof $parcel$global !== "undefined" ? $parcel$global : window;
        if (typeof URL === "undefined") theCurrentGlobal.URL = {
            createObjectURL: function() {},
            revokeObjectURL: function() {}
        };
        if (typeof Blob === "undefined") theCurrentGlobal.Blob = function() {};
    }
    /**
     * Creates a vertex buffer
     * @param vertices the data for the vertex buffer
     * @returns the new WebGL static buffer
     */ createVertexBuffer(vertices) {
        const buffer = new (0, $6zPKs.DataBuffer)();
        buffer.references = 1;
        return buffer;
    }
    /**
     * Creates a new index buffer
     * @param indices defines the content of the index buffer
     * @returns a new webGL buffer
     */ createIndexBuffer(indices) {
        const buffer = new (0, $6zPKs.DataBuffer)();
        buffer.references = 1;
        return buffer;
    }
    /**
     * Clear the current render buffer or the current render target (if any is set up)
     * @param color defines the color to use
     * @param backBuffer defines if the back buffer must be cleared
     * @param depth defines if the depth buffer must be cleared
     * @param stencil defines if the stencil buffer must be cleared
     */ clear(color, backBuffer, depth, stencil = false) {}
    /**
     * Gets the current render width
     * @param useScreen defines if screen size must be used (or the current render target if any)
     * @returns a number defining the current render width
     */ getRenderWidth(useScreen = false) {
        if (!useScreen && this._currentRenderTarget) return this._currentRenderTarget.width;
        return this._options.renderWidth;
    }
    /**
     * Gets the current render height
     * @param useScreen defines if screen size must be used (or the current render target if any)
     * @returns a number defining the current render height
     */ getRenderHeight(useScreen = false) {
        if (!useScreen && this._currentRenderTarget) return this._currentRenderTarget.height;
        return this._options.renderHeight;
    }
    /**
     * Set the WebGL's viewport
     * @param viewport defines the viewport element to be used
     * @param requiredWidth defines the width required for rendering. If not provided the rendering canvas' width is used
     * @param requiredHeight defines the height required for rendering. If not provided the rendering canvas' height is used
     */ setViewport(viewport, requiredWidth, requiredHeight) {
        this._cachedViewport = viewport;
    }
    createShaderProgram(pipelineContext, vertexCode, fragmentCode, defines, context) {
        return {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            __SPECTOR_rebuildProgram: null
        };
    }
    /**
     * Gets the list of webGL uniform locations associated with a specific program based on a list of uniform names
     * @param pipelineContext defines the pipeline context to use
     * @param uniformsNames defines the list of uniform names
     * @returns an array of webGL uniform locations
     */ getUniforms(pipelineContext, uniformsNames) {
        return [];
    }
    /**
     * Gets the lsit of active attributes for a given webGL program
     * @param pipelineContext defines the pipeline context to use
     * @param attributesNames defines the list of attribute names to get
     * @returns an array of indices indicating the offset of each attribute
     */ getAttributes(pipelineContext, attributesNames) {
        return [];
    }
    /**
     * Binds an effect to the webGL context
     * @param effect defines the effect to bind
     */ bindSamplers(effect) {
        this._currentEffect = null;
    }
    /**
     * Activates an effect, making it the current one (ie. the one used for rendering)
     * @param effect defines the effect to activate
     */ enableEffect(effect) {
        effect = effect !== null && (0, $hOyoX.DrawWrapper).IsWrapper(effect) ? effect.effect : effect; // get only the effect, we don't need a Wrapper in the WebGL engine
        this._currentEffect = effect;
        if (!effect) return;
        if (effect.onBind) effect.onBind(effect);
        if (effect._onBindObservable) effect._onBindObservable.notifyObservers(effect);
    }
    /**
     * Set various states to the webGL context
     * @param culling defines culling state: true to enable culling, false to disable it
     * @param zOffset defines the value to apply to zOffset (0 by default)
     * @param force defines if states must be applied even if cache is up to date
     * @param reverseSide defines if culling must be reversed (CCW if false, CW if true)
     * @param cullBackFaces true to cull back faces, false to cull front faces (if culling is enabled)
     * @param stencil stencil states to set
     * @param zOffsetUnits defines the value to apply to zOffsetUnits (0 by default)
     */ setState(culling, zOffset = 0, force, reverseSide = false, cullBackFaces, stencil, zOffsetUnits = 0) {}
    /**
     * Set the value of an uniform to an array of int32
     * @param uniform defines the webGL uniform location where to store the value
     * @param array defines the array of int32 to store
     * @returns true if value was set
     */ setIntArray(uniform, array) {
        return true;
    }
    /**
     * Set the value of an uniform to an array of int32 (stored as vec2)
     * @param uniform defines the webGL uniform location where to store the value
     * @param array defines the array of int32 to store
     * @returns true if value was set
     */ setIntArray2(uniform, array) {
        return true;
    }
    /**
     * Set the value of an uniform to an array of int32 (stored as vec3)
     * @param uniform defines the webGL uniform location where to store the value
     * @param array defines the array of int32 to store
     * @returns true if value was set
     */ setIntArray3(uniform, array) {
        return true;
    }
    /**
     * Set the value of an uniform to an array of int32 (stored as vec4)
     * @param uniform defines the webGL uniform location where to store the value
     * @param array defines the array of int32 to store
     * @returns true if value was set
     */ setIntArray4(uniform, array) {
        return true;
    }
    /**
     * Set the value of an uniform to an array of float32
     * @param uniform defines the webGL uniform location where to store the value
     * @param array defines the array of float32 to store
     * @returns true if value was set
     */ setFloatArray(uniform, array) {
        return true;
    }
    /**
     * Set the value of an uniform to an array of float32 (stored as vec2)
     * @param uniform defines the webGL uniform location where to store the value
     * @param array defines the array of float32 to store
     * @returns true if value was set
     */ setFloatArray2(uniform, array) {
        return true;
    }
    /**
     * Set the value of an uniform to an array of float32 (stored as vec3)
     * @param uniform defines the webGL uniform location where to store the value
     * @param array defines the array of float32 to store
     * @returns true if value was set
     */ setFloatArray3(uniform, array) {
        return true;
    }
    /**
     * Set the value of an uniform to an array of float32 (stored as vec4)
     * @param uniform defines the webGL uniform location where to store the value
     * @param array defines the array of float32 to store
     * @returns true if value was set
     */ setFloatArray4(uniform, array) {
        return true;
    }
    /**
     * Set the value of an uniform to an array of number
     * @param uniform defines the webGL uniform location where to store the value
     * @param array defines the array of number to store
     * @returns true if value was set
     */ setArray(uniform, array) {
        return true;
    }
    /**
     * Set the value of an uniform to an array of number (stored as vec2)
     * @param uniform defines the webGL uniform location where to store the value
     * @param array defines the array of number to store
     * @returns true if value was set
     */ setArray2(uniform, array) {
        return true;
    }
    /**
     * Set the value of an uniform to an array of number (stored as vec3)
     * @param uniform defines the webGL uniform location where to store the value
     * @param array defines the array of number to store
     * @returns true if value was set
     */ setArray3(uniform, array) {
        return true;
    }
    /**
     * Set the value of an uniform to an array of number (stored as vec4)
     * @param uniform defines the webGL uniform location where to store the value
     * @param array defines the array of number to store
     * @returns true if value was set
     */ setArray4(uniform, array) {
        return true;
    }
    /**
     * Set the value of an uniform to an array of float32 (stored as matrices)
     * @param uniform defines the webGL uniform location where to store the value
     * @param matrices defines the array of float32 to store
     * @returns true if value was set
     */ setMatrices(uniform, matrices) {
        return true;
    }
    /**
     * Set the value of an uniform to a matrix (3x3)
     * @param uniform defines the webGL uniform location where to store the value
     * @param matrix defines the Float32Array representing the 3x3 matrix to store
     * @returns true if value was set
     */ setMatrix3x3(uniform, matrix) {
        return true;
    }
    /**
     * Set the value of an uniform to a matrix (2x2)
     * @param uniform defines the webGL uniform location where to store the value
     * @param matrix defines the Float32Array representing the 2x2 matrix to store
     * @returns true if value was set
     */ setMatrix2x2(uniform, matrix) {
        return true;
    }
    /**
     * Set the value of an uniform to a number (float)
     * @param uniform defines the webGL uniform location where to store the value
     * @param value defines the float number to store
     * @returns true if value was set
     */ setFloat(uniform, value) {
        return true;
    }
    /**
     * Set the value of an uniform to a vec2
     * @param uniform defines the webGL uniform location where to store the value
     * @param x defines the 1st component of the value
     * @param y defines the 2nd component of the value
     * @returns true if value was set
     */ setFloat2(uniform, x, y) {
        return true;
    }
    /**
     * Set the value of an uniform to a vec3
     * @param uniform defines the webGL uniform location where to store the value
     * @param x defines the 1st component of the value
     * @param y defines the 2nd component of the value
     * @param z defines the 3rd component of the value
     * @returns true if value was set
     */ setFloat3(uniform, x, y, z) {
        return true;
    }
    /**
     * Set the value of an uniform to a boolean
     * @param uniform defines the webGL uniform location where to store the value
     * @param bool defines the boolean to store
     * @returns true if value was set
     */ setBool(uniform, bool) {
        return true;
    }
    /**
     * Set the value of an uniform to a vec4
     * @param uniform defines the webGL uniform location where to store the value
     * @param x defines the 1st component of the value
     * @param y defines the 2nd component of the value
     * @param z defines the 3rd component of the value
     * @param w defines the 4th component of the value
     * @returns true if value was set
     */ setFloat4(uniform, x, y, z, w) {
        return true;
    }
    /**
     * Sets the current alpha mode
     * @param mode defines the mode to use (one of the Engine.ALPHA_XXX)
     * @param noDepthWriteChange defines if depth writing state should remains unchanged (false by default)
     * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/advanced/transparent_rendering
     */ setAlphaMode(mode, noDepthWriteChange = false) {
        if (this._alphaMode === mode) return;
        this.alphaState.alphaBlend = mode !== 0;
        if (!noDepthWriteChange) this.setDepthWrite(mode === 0);
        this._alphaMode = mode;
    }
    /**
     * Bind webGl buffers directly to the webGL context
     * @param vertexBuffers defines the vertex buffer to bind
     * @param indexBuffer defines the index buffer to bind
     * @param effect defines the effect associated with the vertex buffer
     */ bindBuffers(vertexBuffers, indexBuffer, effect) {}
    /**
     * Force the entire cache to be cleared
     * You should not have to use this function unless your engine needs to share the webGL context with another engine
     * @param bruteForce defines a boolean to force clearing ALL caches (including stencil, detoh and alpha states)
     */ wipeCaches(bruteForce) {
        if (this.preventCacheWipeBetweenFrames) return;
        this.resetTextureCache();
        this._currentEffect = null;
        if (bruteForce) {
            this._currentProgram = null;
            this._stencilStateComposer.reset();
            this.depthCullingState.reset();
            this.alphaState.reset();
        }
        this._cachedVertexBuffers = null;
        this._cachedIndexBuffer = null;
        this._cachedEffectForVertexBuffers = null;
    }
    /**
     * Send a draw order
     * @param useTriangles defines if triangles must be used to draw (else wireframe will be used)
     * @param indexStart defines the starting index
     * @param indexCount defines the number of index to draw
     * @param instancesCount defines the number of instances to draw (if instantiation is enabled)
     */ draw(useTriangles, indexStart, indexCount, instancesCount) {}
    /**
     * Draw a list of indexed primitives
     * @param fillMode defines the primitive to use
     * @param indexStart defines the starting index
     * @param indexCount defines the number of index to draw
     * @param instancesCount defines the number of instances to draw (if instantiation is enabled)
     */ drawElementsType(fillMode, indexStart, indexCount, instancesCount) {}
    /**
     * Draw a list of unindexed primitives
     * @param fillMode defines the primitive to use
     * @param verticesStart defines the index of first vertex to draw
     * @param verticesCount defines the count of vertices to draw
     * @param instancesCount defines the number of instances to draw (if instantiation is enabled)
     */ drawArraysType(fillMode, verticesStart, verticesCount, instancesCount) {}
    /** @internal */ _createTexture() {
        return {};
    }
    /**
     * @internal
     */ _releaseTexture(texture) {}
    /**
     * Usually called from Texture.ts.
     * Passed information to create a WebGLTexture
     * @param urlArg defines a value which contains one of the following:
     * * A conventional http URL, e.g. 'http://...' or 'file://...'
     * * A base64 string of in-line texture data, e.g. 'data:image/jpg;base64,/...'
     * * An indicator that data being passed using the buffer parameter, e.g. 'data:mytexture.jpg'
     * @param noMipmap defines a boolean indicating that no mipmaps shall be generated.  Ignored for compressed textures.  They must be in the file
     * @param invertY when true, image is flipped when loaded.  You probably want true. Certain compressed textures may invert this if their default is inverted (eg. ktx)
     * @param scene needed for loading to the correct scene
     * @param samplingMode mode with should be used sample / access the texture (Default: Texture.TRILINEAR_SAMPLINGMODE)
     * @param onLoad optional callback to be called upon successful completion
     * @param onError optional callback to be called upon failure
     * @param buffer a source of a file previously fetched as either a base64 string, an ArrayBuffer (compressed or image format), HTMLImageElement (image format), or a Blob
     * @param fallback an internal argument in case the function must be called again, due to etc1 not having alpha capabilities
     * @param format internal format.  Default: RGB when extension is '.jpg' else RGBA.  Ignored for compressed textures
     * @param forcedExtension defines the extension to use to pick the right loader
     * @param mimeType defines an optional mime type
     * @returns a InternalTexture for assignment back into BABYLON.Texture
     */ createTexture(urlArg, noMipmap, invertY, scene, samplingMode = 3, onLoad = null, onError = null, buffer = null, fallback = null, format = null, forcedExtension = null, mimeType) {
        const texture = new (0, $b9e4a.InternalTexture)(this, (0, $b9e4a.InternalTextureSource).Url);
        const url = String(urlArg);
        texture.url = url;
        texture.generateMipMaps = !noMipmap;
        texture.samplingMode = samplingMode;
        texture.invertY = invertY;
        texture.baseWidth = this._options.textureSize;
        texture.baseHeight = this._options.textureSize;
        texture.width = this._options.textureSize;
        texture.height = this._options.textureSize;
        if (format) texture.format = format;
        texture.isReady = true;
        if (onLoad) setTimeout(()=>{
            onLoad(texture);
        });
        this._internalTexturesCache.push(texture);
        return texture;
    }
    /**
     * @internal
     */ _createHardwareRenderTargetWrapper(isMulti, isCube, size) {
        const rtWrapper = new (0, $3QmEA.RenderTargetWrapper)(isMulti, isCube, size, this);
        this._renderTargetWrapperCache.push(rtWrapper);
        return rtWrapper;
    }
    /**
     * Creates a new render target wrapper
     * @param size defines the size of the texture
     * @param options defines the options used to create the texture
     * @returns a new render target wrapper
     */ createRenderTargetTexture(size, options) {
        const rtWrapper = this._createHardwareRenderTargetWrapper(false, false, size);
        const fullOptions = {};
        if (options !== undefined && typeof options === "object") {
            fullOptions.generateMipMaps = options.generateMipMaps;
            fullOptions.generateDepthBuffer = options.generateDepthBuffer === undefined ? true : options.generateDepthBuffer;
            fullOptions.generateStencilBuffer = fullOptions.generateDepthBuffer && options.generateStencilBuffer;
            fullOptions.type = options.type === undefined ? 0 : options.type;
            fullOptions.samplingMode = options.samplingMode === undefined ? 3 : options.samplingMode;
        } else {
            fullOptions.generateMipMaps = options;
            fullOptions.generateDepthBuffer = true;
            fullOptions.generateStencilBuffer = false;
            fullOptions.type = 0;
            fullOptions.samplingMode = 3;
        }
        const texture = new (0, $b9e4a.InternalTexture)(this, (0, $b9e4a.InternalTextureSource).RenderTarget);
        const width = size.width || size;
        const height = size.height || size;
        rtWrapper._generateDepthBuffer = fullOptions.generateDepthBuffer;
        rtWrapper._generateStencilBuffer = fullOptions.generateStencilBuffer ? true : false;
        texture.baseWidth = width;
        texture.baseHeight = height;
        texture.width = width;
        texture.height = height;
        texture.isReady = true;
        texture.samples = 1;
        texture.generateMipMaps = fullOptions.generateMipMaps ? true : false;
        texture.samplingMode = fullOptions.samplingMode;
        texture.type = fullOptions.type;
        this._internalTexturesCache.push(texture);
        return rtWrapper;
    }
    /**
     * Creates a new render target wrapper
     * @param size defines the size of the texture
     * @param options defines the options used to create the texture
     * @returns a new render target wrapper
     */ createRenderTargetCubeTexture(size, options) {
        const rtWrapper = this._createHardwareRenderTargetWrapper(false, true, size);
        const fullOptions = {
            generateMipMaps: true,
            generateDepthBuffer: true,
            generateStencilBuffer: false,
            type: 0,
            samplingMode: 3,
            format: 5,
            ...options
        };
        fullOptions.generateStencilBuffer = fullOptions.generateDepthBuffer && fullOptions.generateStencilBuffer;
        if (fullOptions.type === 1 && !this._caps.textureFloatLinearFiltering) // if floating point linear (gl.FLOAT) then force to NEAREST_SAMPLINGMODE
        fullOptions.samplingMode = 1;
        else if (fullOptions.type === 2 && !this._caps.textureHalfFloatLinearFiltering) // if floating point linear (HALF_FLOAT) then force to NEAREST_SAMPLINGMODE
        fullOptions.samplingMode = 1;
        rtWrapper._generateDepthBuffer = fullOptions.generateDepthBuffer;
        rtWrapper._generateStencilBuffer = fullOptions.generateStencilBuffer ? true : false;
        const texture = new (0, $b9e4a.InternalTexture)(this, (0, $b9e4a.InternalTextureSource).RenderTarget);
        texture.baseWidth = size;
        texture.baseHeight = size;
        texture.width = size;
        texture.height = size;
        texture.isReady = true;
        texture.isCube = true;
        texture.samples = 1;
        texture.generateMipMaps = fullOptions.generateMipMaps ? true : false;
        texture.samplingMode = fullOptions.samplingMode;
        texture.type = fullOptions.type;
        this._internalTexturesCache.push(texture);
        return rtWrapper;
    }
    /**
     * Update the sampling mode of a given texture
     * @param samplingMode defines the required sampling mode
     * @param texture defines the texture to update
     */ updateTextureSamplingMode(samplingMode, texture) {
        texture.samplingMode = samplingMode;
    }
    /**
     * Creates a raw texture
     * @param data defines the data to store in the texture
     * @param width defines the width of the texture
     * @param height defines the height of the texture
     * @param format defines the format of the data
     * @param generateMipMaps defines if the engine should generate the mip levels
     * @param invertY defines if data must be stored with Y axis inverted
     * @param samplingMode defines the required sampling mode (Texture.NEAREST_SAMPLINGMODE by default)
     * @param compression defines the compression used (null by default)
     * @param type defines the type fo the data (Engine.TEXTURETYPE_UNSIGNED_INT by default)
     * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
     * @param useSRGBBuffer defines if the texture must be loaded in a sRGB GPU buffer (if supported by the GPU).
     * @returns the raw texture inside an InternalTexture
     */ createRawTexture(data, width, height, format, generateMipMaps, invertY, samplingMode, compression = null, type = 0, creationFlags = 0, useSRGBBuffer = false) {
        const texture = new (0, $b9e4a.InternalTexture)(this, (0, $b9e4a.InternalTextureSource).Raw);
        texture.baseWidth = width;
        texture.baseHeight = height;
        texture.width = width;
        texture.height = height;
        texture.format = format;
        texture.generateMipMaps = generateMipMaps;
        texture.samplingMode = samplingMode;
        texture.invertY = invertY;
        texture._compression = compression;
        texture.type = type;
        texture._useSRGBBuffer = useSRGBBuffer;
        if (!this._doNotHandleContextLost) texture._bufferView = data;
        return texture;
    }
    /**
     * Update a raw texture
     * @param texture defines the texture to update
     * @param data defines the data to store in the texture
     * @param format defines the format of the data
     * @param invertY defines if data must be stored with Y axis inverted
     * @param compression defines the compression used (null by default)
     * @param type defines the type fo the data (Engine.TEXTURETYPE_UNSIGNED_INT by default)
     * @param useSRGBBuffer defines if the texture must be loaded in a sRGB GPU buffer (if supported by the GPU).
     */ updateRawTexture(texture, data, format, invertY, compression = null, type = 0, useSRGBBuffer = false) {
        if (texture) {
            texture._bufferView = data;
            texture.format = format;
            texture.invertY = invertY;
            texture._compression = compression;
            texture.type = type;
            texture._useSRGBBuffer = useSRGBBuffer;
        }
    }
    /**
     * Binds the frame buffer to the specified texture.
     * @param rtWrapper The render target wrapper to render to
     * @param faceIndex The face of the texture to render to in case of cube texture
     * @param requiredWidth The width of the target to render to
     * @param requiredHeight The height of the target to render to
     * @param forceFullscreenViewport Forces the viewport to be the entire texture/screen if true
     */ bindFramebuffer(rtWrapper, faceIndex, requiredWidth, requiredHeight, forceFullscreenViewport) {
        if (this._currentRenderTarget) this.unBindFramebuffer(this._currentRenderTarget);
        this._currentRenderTarget = rtWrapper;
        this._currentFramebuffer = null;
        if (this._cachedViewport && !forceFullscreenViewport) this.setViewport(this._cachedViewport, requiredWidth, requiredHeight);
    }
    /**
     * Unbind the current render target texture from the webGL context
     * @param rtWrapper defines the render target wrapper to unbind
     * @param disableGenerateMipMaps defines a boolean indicating that mipmaps must not be generated
     * @param onBeforeUnbind defines a function which will be called before the effective unbind
     */ unBindFramebuffer(rtWrapper, disableGenerateMipMaps = false, onBeforeUnbind) {
        this._currentRenderTarget = null;
        if (onBeforeUnbind) onBeforeUnbind();
        this._currentFramebuffer = null;
    }
    /**
     * Creates a dynamic vertex buffer
     * @param vertices the data for the dynamic vertex buffer
     * @returns the new WebGL dynamic buffer
     */ createDynamicVertexBuffer(vertices) {
        const buffer = new (0, $6zPKs.DataBuffer)();
        buffer.references = 1;
        buffer.capacity = 1;
        return buffer;
    }
    /**
     * Update the content of a dynamic texture
     * @param texture defines the texture to update
     * @param canvas defines the canvas containing the source
     * @param invertY defines if data must be stored with Y axis inverted
     * @param premulAlpha defines if alpha is stored as premultiplied
     * @param format defines the format of the data
     */ updateDynamicTexture(texture, canvas, invertY, premulAlpha = false, format) {}
    /**
     * Gets a boolean indicating if all created effects are ready
     * @returns true if all effects are ready
     */ areAllEffectsReady() {
        return true;
    }
    /**
     * @internal
     * Get the current error code of the webGL context
     * @returns the error code
     * @see https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/getError
     */ getError() {
        return 0;
    }
    /** @internal */ _getUnpackAlignement() {
        return 1;
    }
    /**
     * @internal
     */ _unpackFlipY(value) {}
    /**
     * Update a dynamic index buffer
     * @param indexBuffer defines the target index buffer
     * @param indices defines the data to update
     * @param offset defines the offset in the target index buffer where update should start
     */ updateDynamicIndexBuffer(indexBuffer, indices, offset = 0) {}
    /**
     * Updates a dynamic vertex buffer.
     * @param vertexBuffer the vertex buffer to update
     * @param vertices the data used to update the vertex buffer
     * @param byteOffset the byte offset of the data (optional)
     * @param byteLength the byte length of the data (optional)
     */ updateDynamicVertexBuffer(vertexBuffer, vertices, byteOffset, byteLength) {}
    /**
     * @internal
     */ _bindTextureDirectly(target, texture) {
        if (this._boundTexturesCache[this._activeChannel] !== texture) {
            this._boundTexturesCache[this._activeChannel] = texture;
            return true;
        }
        return false;
    }
    /**
     * @internal
     */ _bindTexture(channel, texture) {
        if (channel < 0) return;
        this._bindTextureDirectly(0, texture);
    }
    _deleteBuffer(buffer) {}
    /**
     * Force the engine to release all cached effects. This means that next effect compilation will have to be done completely even if a similar effect was already compiled
     */ releaseEffects() {}
    displayLoadingUI() {}
    hideLoadingUI() {}
    set loadingUIText(_) {}
    /**
     * @internal
     */ _uploadCompressedDataToTextureDirectly(texture, internalFormat, width, height, data, faceIndex = 0, lod = 0) {}
    /**
     * @internal
     */ _uploadDataToTextureDirectly(texture, imageData, faceIndex = 0, lod = 0) {}
    /**
     * @internal
     */ _uploadArrayBufferViewToTexture(texture, imageData, faceIndex = 0, lod = 0) {}
    /**
     * @internal
     */ _uploadImageToTexture(texture, image, faceIndex = 0, lod = 0) {}
}

});

parcelRegister("4UXK1", function(module, exports) {
/* eslint-disable import/export */ 
var $emm58 = parcelRequire("emm58");

var $8b3a2 = parcelRequire("8b3a2");

var $7quXy = parcelRequire("7quXy");

var $b843b = parcelRequire("b843b");

var $hHHx5 = parcelRequire("hHHx5");

var $e7NUJ = parcelRequire("e7NUJ");

var $2yVdu = parcelRequire("2yVdu");

var $bZTNp = parcelRequire("bZTNp");

var $ahLMi = parcelRequire("ahLMi");

var $1uz5x = parcelRequire("1uz5x");

var $5jUKR = parcelRequire("5jUKR");

var $4PdZs = parcelRequire("4PdZs");

var $gfE2b = parcelRequire("gfE2b");

var $cKdXJ = parcelRequire("cKdXJ");

var $jo5qL = parcelRequire("jo5qL");

var $7G59J = parcelRequire("7G59J");

var $hzTPR = parcelRequire("hzTPR");

var $k0sxV = parcelRequire("k0sxV");

var $fDq5D = parcelRequire("fDq5D");

var $l56Q1 = parcelRequire("l56Q1");

var $63C6E = parcelRequire("63C6E");
$parcel$exportWildcard(module.exports, $emm58);
$parcel$exportWildcard(module.exports, $8b3a2);
$parcel$exportWildcard(module.exports, $7quXy);
$parcel$exportWildcard(module.exports, $b843b);
$parcel$exportWildcard(module.exports, $hHHx5);
$parcel$exportWildcard(module.exports, $e7NUJ);
$parcel$exportWildcard(module.exports, $2yVdu);
$parcel$exportWildcard(module.exports, $bZTNp);
$parcel$exportWildcard(module.exports, $ahLMi);
$parcel$exportWildcard(module.exports, $1uz5x);
$parcel$exportWildcard(module.exports, $5jUKR);
$parcel$exportWildcard(module.exports, $4PdZs);
$parcel$exportWildcard(module.exports, $gfE2b);
$parcel$exportWildcard(module.exports, $cKdXJ);
$parcel$exportWildcard(module.exports, $jo5qL);
$parcel$exportWildcard(module.exports, $7G59J);
$parcel$exportWildcard(module.exports, $hzTPR);
$parcel$exportWildcard(module.exports, $k0sxV);
$parcel$exportWildcard(module.exports, $fDq5D);
$parcel$exportWildcard(module.exports, $l56Q1);
$parcel$exportWildcard(module.exports, $63C6E);

});
parcelRegister("8b3a2", function(module, exports) {
/* eslint-disable @typescript-eslint/no-unused-vars */ 
var $2h5JR = parcelRequire("2h5JR");
(0, $2h5JR.ThinEngine).prototype._debugPushGroup = function(groupName, targetObject) {};
(0, $2h5JR.ThinEngine).prototype._debugPopGroup = function(targetObject) {};
(0, $2h5JR.ThinEngine).prototype._debugInsertMarker = function(text, targetObject) {};
(0, $2h5JR.ThinEngine).prototype._debugFlushPendingCommands = function() {};

});

parcelRegister("7quXy", function(module, exports) {

$parcel$export(module.exports, "_OcclusionDataStorage", () => $5682fa0d6e49d811$export$6ff74c71a4f319c7);

var $5YkyR = parcelRequire("5YkyR");

var $0cHNL = parcelRequire("0cHNL");

var $8NQGp = parcelRequire("8NQGp");

var $2Fclq = parcelRequire("2Fclq");
class $5682fa0d6e49d811$export$6ff74c71a4f319c7 {
    constructor(){
        /** @internal */ this.occlusionInternalRetryCounter = 0;
        /** @internal */ this.isOcclusionQueryInProgress = false;
        /** @internal */ this.isOccluded = false;
        /** @internal */ this.occlusionRetryCount = -1;
        /** @internal */ this.occlusionType = (0, $0cHNL.AbstractMesh).OCCLUSION_TYPE_NONE;
        /** @internal */ this.occlusionQueryAlgorithmType = (0, $0cHNL.AbstractMesh).OCCLUSION_ALGORITHM_TYPE_CONSERVATIVE;
        /** @internal */ this.forceRenderingWhenOccluded = false;
    }
}
(0, $5YkyR.Engine).prototype.createQuery = function() {
    const query = this._gl.createQuery();
    if (!query) throw new Error("Unable to create Occlusion Query");
    return query;
};
(0, $5YkyR.Engine).prototype.deleteQuery = function(query) {
    this._gl.deleteQuery(query);
    return this;
};
(0, $5YkyR.Engine).prototype.isQueryResultAvailable = function(query) {
    return this._gl.getQueryParameter(query, this._gl.QUERY_RESULT_AVAILABLE);
};
(0, $5YkyR.Engine).prototype.getQueryResult = function(query) {
    return this._gl.getQueryParameter(query, this._gl.QUERY_RESULT);
};
(0, $5YkyR.Engine).prototype.beginOcclusionQuery = function(algorithmType, query) {
    const glAlgorithm = this._getGlAlgorithmType(algorithmType);
    this._gl.beginQuery(glAlgorithm, query);
    return true;
};
(0, $5YkyR.Engine).prototype.endOcclusionQuery = function(algorithmType) {
    const glAlgorithm = this._getGlAlgorithmType(algorithmType);
    this._gl.endQuery(glAlgorithm);
    return this;
};
(0, $5YkyR.Engine).prototype._createTimeQuery = function() {
    const timerQuery = this.getCaps().timerQuery;
    if (timerQuery.createQueryEXT) return timerQuery.createQueryEXT();
    return this.createQuery();
};
(0, $5YkyR.Engine).prototype._deleteTimeQuery = function(query) {
    const timerQuery = this.getCaps().timerQuery;
    if (timerQuery.deleteQueryEXT) {
        timerQuery.deleteQueryEXT(query);
        return;
    }
    this.deleteQuery(query);
};
(0, $5YkyR.Engine).prototype._getTimeQueryResult = function(query) {
    const timerQuery = this.getCaps().timerQuery;
    if (timerQuery.getQueryObjectEXT) return timerQuery.getQueryObjectEXT(query, timerQuery.QUERY_RESULT_EXT);
    return this.getQueryResult(query);
};
(0, $5YkyR.Engine).prototype._getTimeQueryAvailability = function(query) {
    const timerQuery = this.getCaps().timerQuery;
    if (timerQuery.getQueryObjectEXT) return timerQuery.getQueryObjectEXT(query, timerQuery.QUERY_RESULT_AVAILABLE_EXT);
    return this.isQueryResultAvailable(query);
};
(0, $5YkyR.Engine).prototype.startTimeQuery = function() {
    const caps = this.getCaps();
    const timerQuery = caps.timerQuery;
    if (!timerQuery) return null;
    const token = new (0, $8NQGp._TimeToken)();
    this._gl.getParameter(timerQuery.GPU_DISJOINT_EXT);
    if (caps.canUseTimestampForTimerQuery) {
        token._startTimeQuery = this._createTimeQuery();
        timerQuery.queryCounterEXT(token._startTimeQuery, timerQuery.TIMESTAMP_EXT);
    } else {
        if (this._currentNonTimestampToken) return this._currentNonTimestampToken;
        token._timeElapsedQuery = this._createTimeQuery();
        if (timerQuery.beginQueryEXT) timerQuery.beginQueryEXT(timerQuery.TIME_ELAPSED_EXT, token._timeElapsedQuery);
        else this._gl.beginQuery(timerQuery.TIME_ELAPSED_EXT, token._timeElapsedQuery);
        this._currentNonTimestampToken = token;
    }
    return token;
};
(0, $5YkyR.Engine).prototype.endTimeQuery = function(token) {
    const caps = this.getCaps();
    const timerQuery = caps.timerQuery;
    if (!timerQuery || !token) return -1;
    if (caps.canUseTimestampForTimerQuery) {
        if (!token._startTimeQuery) return -1;
        if (!token._endTimeQuery) {
            token._endTimeQuery = this._createTimeQuery();
            timerQuery.queryCounterEXT(token._endTimeQuery, timerQuery.TIMESTAMP_EXT);
        }
    } else if (!token._timeElapsedQueryEnded) {
        if (!token._timeElapsedQuery) return -1;
        if (timerQuery.endQueryEXT) timerQuery.endQueryEXT(timerQuery.TIME_ELAPSED_EXT);
        else {
            this._gl.endQuery(timerQuery.TIME_ELAPSED_EXT);
            this._currentNonTimestampToken = null;
        }
        token._timeElapsedQueryEnded = true;
    }
    const disjoint = this._gl.getParameter(timerQuery.GPU_DISJOINT_EXT);
    let available = false;
    if (token._endTimeQuery) available = this._getTimeQueryAvailability(token._endTimeQuery);
    else if (token._timeElapsedQuery) available = this._getTimeQueryAvailability(token._timeElapsedQuery);
    if (available && !disjoint) {
        let result = 0;
        if (caps.canUseTimestampForTimerQuery) {
            if (!token._startTimeQuery || !token._endTimeQuery) return -1;
            const timeStart = this._getTimeQueryResult(token._startTimeQuery);
            const timeEnd = this._getTimeQueryResult(token._endTimeQuery);
            result = timeEnd - timeStart;
            this._deleteTimeQuery(token._startTimeQuery);
            this._deleteTimeQuery(token._endTimeQuery);
            token._startTimeQuery = null;
            token._endTimeQuery = null;
        } else {
            if (!token._timeElapsedQuery) return -1;
            result = this._getTimeQueryResult(token._timeElapsedQuery);
            this._deleteTimeQuery(token._timeElapsedQuery);
            token._timeElapsedQuery = null;
            token._timeElapsedQueryEnded = false;
        }
        return result;
    }
    return -1;
};
(0, $5YkyR.Engine).prototype._captureGPUFrameTime = false;
(0, $5YkyR.Engine).prototype._gpuFrameTime = new (0, $2Fclq.PerfCounter)();
(0, $5YkyR.Engine).prototype.getGPUFrameTimeCounter = function() {
    return this._gpuFrameTime;
};
(0, $5YkyR.Engine).prototype.captureGPUFrameTime = function(value) {
    if (value === this._captureGPUFrameTime) return;
    this._captureGPUFrameTime = value;
    if (value) {
        this._onBeginFrameObserver = this.onBeginFrameObservable.add(()=>{
            if (!this._gpuFrameTimeToken) this._gpuFrameTimeToken = this.startTimeQuery();
        });
        this._onEndFrameObserver = this.onEndFrameObservable.add(()=>{
            if (!this._gpuFrameTimeToken) return;
            const time = this.endTimeQuery(this._gpuFrameTimeToken);
            if (time > -1) {
                this._gpuFrameTimeToken = null;
                this._gpuFrameTime.fetchNewFrame();
                this._gpuFrameTime.addCount(time, true);
            }
        });
    } else {
        this.onBeginFrameObservable.remove(this._onBeginFrameObserver);
        this._onBeginFrameObserver = null;
        this.onEndFrameObservable.remove(this._onEndFrameObserver);
        this._onEndFrameObserver = null;
    }
};
(0, $5YkyR.Engine).prototype._getGlAlgorithmType = function(algorithmType) {
    return algorithmType === (0, $0cHNL.AbstractMesh).OCCLUSION_ALGORITHM_TYPE_CONSERVATIVE ? this._gl.ANY_SAMPLES_PASSED_CONSERVATIVE : this._gl.ANY_SAMPLES_PASSED;
};
Object.defineProperty((0, $0cHNL.AbstractMesh).prototype, "isOcclusionQueryInProgress", {
    get: function() {
        return this._occlusionDataStorage.isOcclusionQueryInProgress;
    },
    set: function(value) {
        this._occlusionDataStorage.isOcclusionQueryInProgress = value;
    },
    enumerable: false,
    configurable: true
});
Object.defineProperty((0, $0cHNL.AbstractMesh).prototype, "_occlusionDataStorage", {
    get: function() {
        if (!this.__occlusionDataStorage) this.__occlusionDataStorage = new $5682fa0d6e49d811$export$6ff74c71a4f319c7();
        return this.__occlusionDataStorage;
    },
    enumerable: false,
    configurable: true
});
Object.defineProperty((0, $0cHNL.AbstractMesh).prototype, "isOccluded", {
    get: function() {
        return this._occlusionDataStorage.isOccluded;
    },
    set: function(value) {
        this._occlusionDataStorage.isOccluded = value;
    },
    enumerable: true,
    configurable: true
});
Object.defineProperty((0, $0cHNL.AbstractMesh).prototype, "occlusionQueryAlgorithmType", {
    get: function() {
        return this._occlusionDataStorage.occlusionQueryAlgorithmType;
    },
    set: function(value) {
        this._occlusionDataStorage.occlusionQueryAlgorithmType = value;
    },
    enumerable: true,
    configurable: true
});
Object.defineProperty((0, $0cHNL.AbstractMesh).prototype, "occlusionType", {
    get: function() {
        return this._occlusionDataStorage.occlusionType;
    },
    set: function(value) {
        this._occlusionDataStorage.occlusionType = value;
    },
    enumerable: true,
    configurable: true
});
Object.defineProperty((0, $0cHNL.AbstractMesh).prototype, "occlusionRetryCount", {
    get: function() {
        return this._occlusionDataStorage.occlusionRetryCount;
    },
    set: function(value) {
        this._occlusionDataStorage.occlusionRetryCount = value;
    },
    enumerable: true,
    configurable: true
});
Object.defineProperty((0, $0cHNL.AbstractMesh).prototype, "forceRenderingWhenOccluded", {
    get: function() {
        return this._occlusionDataStorage.forceRenderingWhenOccluded;
    },
    set: function(value) {
        this._occlusionDataStorage.forceRenderingWhenOccluded = value;
    },
    enumerable: true,
    configurable: true
});
// We also need to update AbstractMesh as there is a portion of the code there
(0, $0cHNL.AbstractMesh).prototype._checkOcclusionQuery = function() {
    const dataStorage = this._occlusionDataStorage;
    if (dataStorage.occlusionType === (0, $0cHNL.AbstractMesh).OCCLUSION_TYPE_NONE) {
        dataStorage.isOccluded = false;
        return false;
    }
    const engine = this.getEngine();
    if (!engine.getCaps().supportOcclusionQuery) {
        dataStorage.isOccluded = false;
        return false;
    }
    if (!engine.isQueryResultAvailable) {
        // Occlusion query where not referenced
        dataStorage.isOccluded = false;
        return false;
    }
    if (this.isOcclusionQueryInProgress && this._occlusionQuery !== null && this._occlusionQuery !== undefined) {
        const isOcclusionQueryAvailable = engine.isQueryResultAvailable(this._occlusionQuery);
        if (isOcclusionQueryAvailable) {
            const occlusionQueryResult = engine.getQueryResult(this._occlusionQuery);
            dataStorage.isOcclusionQueryInProgress = false;
            dataStorage.occlusionInternalRetryCounter = 0;
            dataStorage.isOccluded = occlusionQueryResult > 0 ? false : true;
        } else {
            dataStorage.occlusionInternalRetryCounter++;
            if (dataStorage.occlusionRetryCount !== -1 && dataStorage.occlusionInternalRetryCounter > dataStorage.occlusionRetryCount) {
                dataStorage.isOcclusionQueryInProgress = false;
                dataStorage.occlusionInternalRetryCounter = 0;
                // if optimistic set isOccluded to false regardless of the status of isOccluded. (Render in the current render loop)
                // if strict continue the last state of the object.
                dataStorage.isOccluded = dataStorage.occlusionType === (0, $0cHNL.AbstractMesh).OCCLUSION_TYPE_OPTIMISTIC ? false : dataStorage.isOccluded;
            } else return dataStorage.occlusionType === (0, $0cHNL.AbstractMesh).OCCLUSION_TYPE_OPTIMISTIC ? false : dataStorage.isOccluded;
        }
    }
    const scene = this.getScene();
    if (scene.getBoundingBoxRenderer) {
        const occlusionBoundingBoxRenderer = scene.getBoundingBoxRenderer();
        if (this._occlusionQuery === null) this._occlusionQuery = engine.createQuery();
        if (engine.beginOcclusionQuery(dataStorage.occlusionQueryAlgorithmType, this._occlusionQuery)) {
            occlusionBoundingBoxRenderer.renderOcclusionBoundingBox(this);
            engine.endOcclusionQuery(dataStorage.occlusionQueryAlgorithmType);
            this._occlusionDataStorage.isOcclusionQueryInProgress = true;
        }
    }
    return dataStorage.isOccluded;
};

});
parcelRegister("8NQGp", function(module, exports) {

$parcel$export(module.exports, "_TimeToken", () => $668bc4174faf56bb$export$db35389215cac5f7);
/**
 * @internal
 **/ // eslint-disable-next-line @typescript-eslint/naming-convention
class $668bc4174faf56bb$export$db35389215cac5f7 {
    constructor(){
        this._timeElapsedQueryEnded = false;
    }
}

});


parcelRegister("b843b", function(module, exports) {

$parcel$export(module.exports, "_forceTransformFeedbackToBundle", () => $81a39564f9953bfa$export$ddca18d4c57558ba);

var $5YkyR = parcelRequire("5YkyR");
var $81a39564f9953bfa$export$ddca18d4c57558ba = true;
(0, $5YkyR.Engine).prototype.createTransformFeedback = function() {
    const transformFeedback = this._gl.createTransformFeedback();
    if (!transformFeedback) throw new Error("Unable to create Transform Feedback");
    return transformFeedback;
};
(0, $5YkyR.Engine).prototype.deleteTransformFeedback = function(value) {
    this._gl.deleteTransformFeedback(value);
};
(0, $5YkyR.Engine).prototype.bindTransformFeedback = function(value) {
    this._gl.bindTransformFeedback(this._gl.TRANSFORM_FEEDBACK, value);
};
(0, $5YkyR.Engine).prototype.beginTransformFeedback = function(usePoints = true) {
    this._gl.beginTransformFeedback(usePoints ? this._gl.POINTS : this._gl.TRIANGLES);
};
(0, $5YkyR.Engine).prototype.endTransformFeedback = function() {
    this._gl.endTransformFeedback();
};
(0, $5YkyR.Engine).prototype.setTranformFeedbackVaryings = function(program, value) {
    this._gl.transformFeedbackVaryings(program, value, this._gl.INTERLEAVED_ATTRIBS);
};
(0, $5YkyR.Engine).prototype.bindTransformFeedbackBuffer = function(value) {
    this._gl.bindBufferBase(this._gl.TRANSFORM_FEEDBACK_BUFFER, 0, value ? value.underlyingResource : null);
};

});

parcelRegister("bZTNp", function(module, exports) {

var $2h5JR = parcelRequire("2h5JR");
// eslint-disable-next-line @typescript-eslint/no-unused-vars
(0, $2h5JR.ThinEngine).prototype.createExternalTexture = function(video) {
    return null;
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
(0, $2h5JR.ThinEngine).prototype.setExternalTexture = function(name, texture) {
    throw new Error("setExternalTexture: This engine does not support external textures!");
};

});

parcelRegister("ahLMi", function(module, exports) {

var $2h5JR = parcelRequire("2h5JR");
(0, $2h5JR.ThinEngine).prototype.updateVideoTexture = function(texture, video, invertY) {
    if (!texture || texture._isDisabled) return;
    const glformat = this._getInternalFormat(texture.format);
    const internalFormat = this._getRGBABufferInternalSizedFormat(0, texture.format);
    const wasPreviouslyBound = this._bindTextureDirectly(this._gl.TEXTURE_2D, texture, true);
    this._unpackFlipY(!invertY); // Video are upside down by default
    try {
        // Testing video texture support
        if (this._videoTextureSupported === undefined) {
            // clear old errors just in case.
            this._gl.getError();
            this._gl.texImage2D(this._gl.TEXTURE_2D, 0, internalFormat, glformat, this._gl.UNSIGNED_BYTE, video);
            if (this._gl.getError() !== 0) this._videoTextureSupported = false;
            else this._videoTextureSupported = true;
        }
        // Copy video through the current working canvas if video texture is not supported
        if (!this._videoTextureSupported) {
            if (!texture._workingCanvas) {
                texture._workingCanvas = this.createCanvas(texture.width, texture.height);
                const context = texture._workingCanvas.getContext("2d");
                if (!context) throw new Error("Unable to get 2d context");
                texture._workingContext = context;
                texture._workingCanvas.width = texture.width;
                texture._workingCanvas.height = texture.height;
            }
            texture._workingContext.clearRect(0, 0, texture.width, texture.height);
            texture._workingContext.drawImage(video, 0, 0, video.videoWidth, video.videoHeight, 0, 0, texture.width, texture.height);
            this._gl.texImage2D(this._gl.TEXTURE_2D, 0, internalFormat, glformat, this._gl.UNSIGNED_BYTE, texture._workingCanvas);
        } else this._gl.texImage2D(this._gl.TEXTURE_2D, 0, internalFormat, glformat, this._gl.UNSIGNED_BYTE, video);
        if (texture.generateMipMaps) this._gl.generateMipmap(this._gl.TEXTURE_2D);
        if (!wasPreviouslyBound) this._bindTextureDirectly(this._gl.TEXTURE_2D, null);
        //    this.resetTextureCache();
        texture.isReady = true;
    } catch (ex) {
        // Something unexpected
        // Let's disable the texture
        texture._isDisabled = true;
    }
};

});

parcelRegister("1uz5x", function(module, exports) {

var $b9e4a = parcelRequire("b9e4a");

var $kVtWi = parcelRequire("kVtWi");

var $2h5JR = parcelRequire("2h5JR");
(0, $2h5JR.ThinEngine).prototype.restoreSingleAttachment = function() {
    const gl = this._gl;
    this.bindAttachments([
        gl.BACK
    ]);
};
(0, $2h5JR.ThinEngine).prototype.restoreSingleAttachmentForRenderTarget = function() {
    const gl = this._gl;
    this.bindAttachments([
        gl.COLOR_ATTACHMENT0
    ]);
};
(0, $2h5JR.ThinEngine).prototype.buildTextureLayout = function(textureStatus) {
    const gl = this._gl;
    const result = [];
    for(let i = 0; i < textureStatus.length; i++)if (textureStatus[i]) result.push(gl["COLOR_ATTACHMENT" + i]);
    else result.push(gl.NONE);
    return result;
};
(0, $2h5JR.ThinEngine).prototype.bindAttachments = function(attachments) {
    const gl = this._gl;
    gl.drawBuffers(attachments);
};
(0, $2h5JR.ThinEngine).prototype.unBindMultiColorAttachmentFramebuffer = function(rtWrapper, disableGenerateMipMaps = false, onBeforeUnbind) {
    this._currentRenderTarget = null;
    // If MSAA, we need to bitblt back to main texture
    const gl = this._gl;
    const attachments = rtWrapper._attachments;
    const count = attachments.length;
    if (rtWrapper._MSAAFramebuffer) {
        gl.bindFramebuffer(gl.READ_FRAMEBUFFER, rtWrapper._MSAAFramebuffer);
        gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, rtWrapper._framebuffer);
        for(let i = 0; i < count; i++){
            const texture = rtWrapper.textures[i];
            for(let j = 0; j < count; j++)attachments[j] = gl.NONE;
            attachments[i] = gl[this.webGLVersion > 1 ? "COLOR_ATTACHMENT" + i : "COLOR_ATTACHMENT" + i + "_WEBGL"];
            gl.readBuffer(attachments[i]);
            gl.drawBuffers(attachments);
            gl.blitFramebuffer(0, 0, texture.width, texture.height, 0, 0, texture.width, texture.height, gl.COLOR_BUFFER_BIT, gl.NEAREST);
        }
        for(let i = 0; i < count; i++)attachments[i] = gl[this.webGLVersion > 1 ? "COLOR_ATTACHMENT" + i : "COLOR_ATTACHMENT" + i + "_WEBGL"];
        gl.drawBuffers(attachments);
    }
    for(let i = 0; i < count; i++){
        const texture = rtWrapper.textures[i];
        if (texture?.generateMipMaps && !disableGenerateMipMaps && !texture.isCube) {
            this._bindTextureDirectly(gl.TEXTURE_2D, texture, true);
            gl.generateMipmap(gl.TEXTURE_2D);
            this._bindTextureDirectly(gl.TEXTURE_2D, null);
        }
    }
    if (onBeforeUnbind) {
        if (rtWrapper._MSAAFramebuffer) // Bind the correct framebuffer
        this._bindUnboundFramebuffer(rtWrapper._framebuffer);
        onBeforeUnbind();
    }
    this._bindUnboundFramebuffer(null);
};
(0, $2h5JR.ThinEngine).prototype.createMultipleRenderTarget = function(size, options, initializeBuffers = true) {
    let generateMipMaps = false;
    let generateDepthBuffer = true;
    let generateStencilBuffer = false;
    let generateDepthTexture = false;
    let depthTextureFormat = 15;
    let textureCount = 1;
    const defaultType = 0;
    const defaultSamplingMode = 3;
    const defaultUseSRGBBuffer = false;
    const defaultFormat = 5;
    const defaultTarget = 3553;
    let types = [];
    let samplingModes = [];
    let useSRGBBuffers = [];
    let formats = [];
    let targets = [];
    let faceIndex = [];
    let layerIndex = [];
    let layers = [];
    const rtWrapper = this._createHardwareRenderTargetWrapper(true, false, size);
    if (options !== undefined) {
        generateMipMaps = options.generateMipMaps === undefined ? false : options.generateMipMaps;
        generateDepthBuffer = options.generateDepthBuffer === undefined ? true : options.generateDepthBuffer;
        generateStencilBuffer = options.generateStencilBuffer === undefined ? false : options.generateStencilBuffer;
        generateDepthTexture = options.generateDepthTexture === undefined ? false : options.generateDepthTexture;
        textureCount = options.textureCount || 1;
        if (options.types) types = options.types;
        if (options.samplingModes) samplingModes = options.samplingModes;
        if (options.useSRGBBuffers) useSRGBBuffers = options.useSRGBBuffers;
        if (options.formats) formats = options.formats;
        if (options.targetTypes) targets = options.targetTypes;
        if (options.faceIndex) faceIndex = options.faceIndex;
        if (options.layerIndex) layerIndex = options.layerIndex;
        if (options.layerCounts) layers = options.layerCounts;
        if (this.webGLVersion > 1 && (options.depthTextureFormat === 13 || options.depthTextureFormat === 17 || options.depthTextureFormat === 16 || options.depthTextureFormat === 14 || options.depthTextureFormat === 18)) depthTextureFormat = options.depthTextureFormat;
    }
    rtWrapper.label = options?.label ?? "MultiRenderTargetWrapper";
    const gl = this._gl;
    // Create the framebuffer
    const framebuffer = gl.createFramebuffer();
    this._bindUnboundFramebuffer(framebuffer);
    const width = size.width || size;
    const height = size.height || size;
    const textures = [];
    const attachments = [];
    const useStencilTexture = this.webGLVersion > 1 && generateDepthTexture && (options.depthTextureFormat === 13 || options.depthTextureFormat === 17 || options.depthTextureFormat === 18);
    const depthStencilBuffer = this._setupFramebufferDepthAttachments(!useStencilTexture && generateStencilBuffer, !generateDepthTexture && generateDepthBuffer, width, height);
    rtWrapper._framebuffer = framebuffer;
    rtWrapper._depthStencilBuffer = depthStencilBuffer;
    rtWrapper._generateDepthBuffer = !generateDepthTexture && generateDepthBuffer;
    rtWrapper._generateStencilBuffer = !useStencilTexture && generateStencilBuffer;
    rtWrapper._attachments = attachments;
    for(let i = 0; i < textureCount; i++){
        let samplingMode = samplingModes[i] || defaultSamplingMode;
        let type = types[i] || defaultType;
        let useSRGBBuffer = useSRGBBuffers[i] || defaultUseSRGBBuffer;
        const format = formats[i] || defaultFormat;
        const target = targets[i] || defaultTarget;
        const layerCount = layers[i] ?? 1;
        if (type === 1 && !this._caps.textureFloatLinearFiltering) // if floating point linear (gl.FLOAT) then force to NEAREST_SAMPLINGMODE
        samplingMode = 1;
        else if (type === 2 && !this._caps.textureHalfFloatLinearFiltering) // if floating point linear (HALF_FLOAT) then force to NEAREST_SAMPLINGMODE
        samplingMode = 1;
        const filters = this._getSamplingParameters(samplingMode, generateMipMaps);
        if (type === 1 && !this._caps.textureFloat) {
            type = 0;
            (0, $kVtWi.Logger).Warn("Float textures are not supported. Render target forced to TEXTURETYPE_UNSIGNED_BYTE type");
        }
        useSRGBBuffer = useSRGBBuffer && this._caps.supportSRGBBuffers && (this.webGLVersion > 1 || this.isWebGPU);
        const isWebGL2 = this.webGLVersion > 1;
        const attachment = gl[isWebGL2 ? "COLOR_ATTACHMENT" + i : "COLOR_ATTACHMENT" + i + "_WEBGL"];
        attachments.push(attachment);
        if (target === -1) continue;
        const texture = new (0, $b9e4a.InternalTexture)(this, (0, $b9e4a.InternalTextureSource).MultiRenderTarget);
        textures[i] = texture;
        gl.activeTexture(gl["TEXTURE" + i]);
        gl.bindTexture(target, texture._hardwareTexture.underlyingResource);
        gl.texParameteri(target, gl.TEXTURE_MAG_FILTER, filters.mag);
        gl.texParameteri(target, gl.TEXTURE_MIN_FILTER, filters.min);
        gl.texParameteri(target, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(target, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        const internalSizedFormat = this._getRGBABufferInternalSizedFormat(type, format, useSRGBBuffer);
        const internalFormat = this._getInternalFormat(format);
        const webGLTextureType = this._getWebGLTextureType(type);
        if (isWebGL2 && (target === 35866 || target === 32879)) {
            if (target === 35866) texture.is2DArray = true;
            else texture.is3D = true;
            texture.baseDepth = texture.depth = layerCount;
            gl.texImage3D(target, 0, internalSizedFormat, width, height, layerCount, 0, internalFormat, webGLTextureType, null);
        } else if (target === 34067) {
            // We have to generate all faces to complete the framebuffer
            for(let i = 0; i < 6; i++)gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, internalSizedFormat, width, height, 0, internalFormat, webGLTextureType, null);
            texture.isCube = true;
        } else gl.texImage2D(gl.TEXTURE_2D, 0, internalSizedFormat, width, height, 0, internalFormat, webGLTextureType, null);
        if (generateMipMaps) gl.generateMipmap(target);
        // Unbind
        this._bindTextureDirectly(target, null);
        texture.baseWidth = width;
        texture.baseHeight = height;
        texture.width = width;
        texture.height = height;
        texture.isReady = true;
        texture.samples = 1;
        texture.generateMipMaps = generateMipMaps;
        texture.samplingMode = samplingMode;
        texture.type = type;
        texture._useSRGBBuffer = useSRGBBuffer;
        texture.format = format;
        this._internalTexturesCache.push(texture);
    }
    if (generateDepthTexture && this._caps.depthTextureExtension) {
        // Depth texture
        const depthTexture = new (0, $b9e4a.InternalTexture)(this, (0, $b9e4a.InternalTextureSource).Depth);
        let depthTextureType = 5;
        let glDepthTextureInternalFormat = gl.DEPTH_COMPONENT16;
        let glDepthTextureFormat = gl.DEPTH_COMPONENT;
        let glDepthTextureType = gl.UNSIGNED_SHORT;
        let glDepthTextureAttachment = gl.DEPTH_ATTACHMENT;
        if (this.webGLVersion < 2) glDepthTextureInternalFormat = gl.DEPTH_COMPONENT;
        else {
            if (depthTextureFormat === 14) {
                depthTextureType = 1;
                glDepthTextureType = gl.FLOAT;
                glDepthTextureInternalFormat = gl.DEPTH_COMPONENT32F;
            } else if (depthTextureFormat === 18) {
                depthTextureType = 0;
                glDepthTextureType = gl.FLOAT_32_UNSIGNED_INT_24_8_REV;
                glDepthTextureInternalFormat = gl.DEPTH32F_STENCIL8;
                glDepthTextureFormat = gl.DEPTH_STENCIL;
                glDepthTextureAttachment = gl.DEPTH_STENCIL_ATTACHMENT;
            } else if (depthTextureFormat === 16) {
                depthTextureType = 0;
                glDepthTextureType = gl.UNSIGNED_INT;
                glDepthTextureInternalFormat = gl.DEPTH_COMPONENT24;
                glDepthTextureAttachment = gl.DEPTH_ATTACHMENT;
            } else if (depthTextureFormat === 13 || depthTextureFormat === 17) {
                depthTextureType = 12;
                glDepthTextureType = gl.UNSIGNED_INT_24_8;
                glDepthTextureInternalFormat = gl.DEPTH24_STENCIL8;
                glDepthTextureFormat = gl.DEPTH_STENCIL;
                glDepthTextureAttachment = gl.DEPTH_STENCIL_ATTACHMENT;
            }
        }
        gl.activeTexture(gl.TEXTURE0);
        gl.bindTexture(gl.TEXTURE_2D, depthTexture._hardwareTexture.underlyingResource);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texImage2D(gl.TEXTURE_2D, 0, glDepthTextureInternalFormat, width, height, 0, glDepthTextureFormat, glDepthTextureType, null);
        gl.framebufferTexture2D(gl.FRAMEBUFFER, glDepthTextureAttachment, gl.TEXTURE_2D, depthTexture._hardwareTexture.underlyingResource, 0);
        depthTexture.baseWidth = width;
        depthTexture.baseHeight = height;
        depthTexture.width = width;
        depthTexture.height = height;
        depthTexture.isReady = true;
        depthTexture.samples = 1;
        depthTexture.generateMipMaps = generateMipMaps;
        depthTexture.samplingMode = 1;
        depthTexture.format = depthTextureFormat;
        depthTexture.type = depthTextureType;
        textures[textureCount] = depthTexture;
        this._internalTexturesCache.push(depthTexture);
    }
    rtWrapper.setTextures(textures);
    if (initializeBuffers) gl.drawBuffers(attachments);
    this._bindUnboundFramebuffer(null);
    rtWrapper.setLayerAndFaceIndices(layerIndex, faceIndex);
    this.resetTextureCache();
    return rtWrapper;
};
(0, $2h5JR.ThinEngine).prototype.updateMultipleRenderTargetTextureSampleCount = function(rtWrapper, samples, initializeBuffers = true) {
    if (this.webGLVersion < 2 || !rtWrapper || !rtWrapper.texture) return 1;
    if (rtWrapper.samples === samples) return samples;
    const count = rtWrapper._attachments.length;
    if (count === 0) return 1;
    const gl = this._gl;
    samples = Math.min(samples, this.getCaps().maxMSAASamples);
    // Dispose previous render buffers
    const useDepthStencil = !!rtWrapper._depthStencilBuffer;
    if (useDepthStencil) {
        gl.deleteRenderbuffer(rtWrapper._depthStencilBuffer);
        rtWrapper._depthStencilBuffer = null;
    }
    if (rtWrapper._MSAAFramebuffer) {
        gl.deleteFramebuffer(rtWrapper._MSAAFramebuffer);
        rtWrapper._MSAAFramebuffer = null;
    }
    if (samples > 1 && typeof gl.renderbufferStorageMultisample === "function") {
        const framebuffer = gl.createFramebuffer();
        if (!framebuffer) throw new Error("Unable to create multi sampled framebuffer");
        rtWrapper._MSAAFramebuffer = framebuffer;
        this._bindUnboundFramebuffer(framebuffer);
        const attachments = [];
        for(let i = 0; i < count; i++){
            const texture = rtWrapper.textures[i];
            const hardwareTexture = texture._hardwareTexture;
            hardwareTexture.releaseMSAARenderBuffers();
        }
        for(let i = 0; i < count; i++){
            const texture = rtWrapper.textures[i];
            const hardwareTexture = texture._hardwareTexture;
            const attachment = gl[this.webGLVersion > 1 ? "COLOR_ATTACHMENT" + i : "COLOR_ATTACHMENT" + i + "_WEBGL"];
            const colorRenderbuffer = this._createRenderBuffer(texture.width, texture.height, samples, -1 /* not used */ , this._getRGBABufferInternalSizedFormat(texture.type, texture.format, texture._useSRGBBuffer), attachment);
            if (!colorRenderbuffer) throw new Error("Unable to create multi sampled framebuffer");
            hardwareTexture.addMSAARenderBuffer(colorRenderbuffer);
            texture.samples = samples;
            attachments.push(attachment);
        }
        if (initializeBuffers) gl.drawBuffers(attachments);
    } else this._bindUnboundFramebuffer(rtWrapper._framebuffer);
    if (useDepthStencil) rtWrapper._depthStencilBuffer = this._setupFramebufferDepthAttachments(rtWrapper._generateStencilBuffer, rtWrapper._generateDepthBuffer, rtWrapper.texture.width, rtWrapper.texture.height, samples);
    this._bindUnboundFramebuffer(null);
    return samples;
};

});

parcelRegister("5jUKR", function(module, exports) {

var $2h5JR = parcelRequire("2h5JR");

var $b9e4a = parcelRequire("b9e4a");

var $kVtWi = parcelRequire("kVtWi");

var $EOxw7 = parcelRequire("EOxw7");

var $321Uk = parcelRequire("321Uk");
(0, $2h5JR.ThinEngine).prototype._createDepthStencilCubeTexture = function(size, options) {
    const internalTexture = new (0, $b9e4a.InternalTexture)(this, (0, $b9e4a.InternalTextureSource).DepthStencil);
    internalTexture.isCube = true;
    if (this.webGLVersion === 1) {
        (0, $kVtWi.Logger).Error("Depth cube texture is not supported by WebGL 1.");
        return internalTexture;
    }
    const internalOptions = {
        bilinearFiltering: false,
        comparisonFunction: 0,
        generateStencil: false,
        ...options
    };
    const gl = this._gl;
    this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, internalTexture, true);
    this._setupDepthStencilTexture(internalTexture, size, internalOptions.generateStencil, internalOptions.bilinearFiltering, internalOptions.comparisonFunction);
    // Create the depth/stencil buffer
    for(let face = 0; face < 6; face++)if (internalOptions.generateStencil) gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + face, 0, gl.DEPTH24_STENCIL8, size, size, 0, gl.DEPTH_STENCIL, gl.UNSIGNED_INT_24_8, null);
    else gl.texImage2D(gl.TEXTURE_CUBE_MAP_POSITIVE_X + face, 0, gl.DEPTH_COMPONENT24, size, size, 0, gl.DEPTH_COMPONENT, gl.UNSIGNED_INT, null);
    this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, null);
    this._internalTexturesCache.push(internalTexture);
    return internalTexture;
};
(0, $2h5JR.ThinEngine).prototype._partialLoadFile = function(url, index, loadedFiles, onfinish, onErrorCallBack = null) {
    const onload = (data)=>{
        loadedFiles[index] = data;
        loadedFiles._internalCount++;
        if (loadedFiles._internalCount === 6) onfinish(loadedFiles);
    };
    const onerror = (request, exception)=>{
        if (onErrorCallBack && request) onErrorCallBack(request.status + " " + request.statusText, exception);
    };
    this._loadFile(url, onload, undefined, undefined, true, onerror);
};
(0, $2h5JR.ThinEngine).prototype._cascadeLoadFiles = function(scene, onfinish, files, onError = null) {
    const loadedFiles = [];
    loadedFiles._internalCount = 0;
    for(let index = 0; index < 6; index++)this._partialLoadFile(files[index], index, loadedFiles, onfinish, onError);
};
(0, $2h5JR.ThinEngine).prototype._cascadeLoadImgs = function(scene, texture, onfinish, files, onError = null, mimeType) {
    const loadedImages = [];
    loadedImages._internalCount = 0;
    for(let index = 0; index < 6; index++)this._partialLoadImg(files[index], index, loadedImages, scene, texture, onfinish, onError, mimeType);
};
(0, $2h5JR.ThinEngine).prototype._partialLoadImg = function(url, index, loadedImages, scene, texture, onfinish, onErrorCallBack = null, mimeType) {
    const tokenPendingData = (0, $321Uk.RandomGUID)();
    const onload = (img)=>{
        loadedImages[index] = img;
        loadedImages._internalCount++;
        if (scene) scene.removePendingData(tokenPendingData);
        if (loadedImages._internalCount === 6 && onfinish) onfinish(texture, loadedImages);
    };
    const onerror = (message, exception)=>{
        if (scene) scene.removePendingData(tokenPendingData);
        if (onErrorCallBack) onErrorCallBack(message, exception);
    };
    (0, $EOxw7.LoadImage)(url, onload, onerror, scene ? scene.offlineProvider : null, mimeType);
    if (scene) scene.addPendingData(tokenPendingData);
};
(0, $2h5JR.ThinEngine).prototype._setCubeMapTextureParams = function(texture, loadMipmap, maxLevel) {
    const gl = this._gl;
    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MIN_FILTER, loadMipmap ? gl.LINEAR_MIPMAP_LINEAR : gl.LINEAR);
    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    texture.samplingMode = loadMipmap ? 3 : 2;
    if (loadMipmap && this.getCaps().textureMaxLevel && maxLevel !== undefined && maxLevel > 0) {
        gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAX_LEVEL, maxLevel);
        texture._maxLodLevel = maxLevel;
    }
    this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, null);
};
(0, $2h5JR.ThinEngine).prototype.createCubeTextureBase = function(rootUrl, scene, files, noMipmap, onLoad = null, onError = null, format, forcedExtension = null, createPolynomials = false, lodScale = 0, lodOffset = 0, fallback = null, beforeLoadCubeDataCallback = null, imageHandler = null, useSRGBBuffer = false) {
    const texture = fallback ? fallback : new (0, $b9e4a.InternalTexture)(this, (0, $b9e4a.InternalTextureSource).Cube);
    texture.isCube = true;
    texture.url = rootUrl;
    texture.generateMipMaps = !noMipmap;
    texture._lodGenerationScale = lodScale;
    texture._lodGenerationOffset = lodOffset;
    texture._useSRGBBuffer = !!useSRGBBuffer && this._caps.supportSRGBBuffers && (this.webGLVersion > 1 || this.isWebGPU || !!noMipmap);
    if (texture !== fallback) texture.label = rootUrl.substring(0, 60); // default label, can be overriden by the caller
    if (!this._doNotHandleContextLost) {
        texture._extension = forcedExtension;
        texture._files = files;
    }
    const originalRootUrl = rootUrl;
    if (this._transformTextureUrl && !fallback) rootUrl = this._transformTextureUrl(rootUrl);
    const rootUrlWithoutUriParams = rootUrl.split("?")[0];
    const lastDot = rootUrlWithoutUriParams.lastIndexOf(".");
    const extension = forcedExtension ? forcedExtension : lastDot > -1 ? rootUrlWithoutUriParams.substring(lastDot).toLowerCase() : "";
    let loader = null;
    for (const availableLoader of (0, $2h5JR.ThinEngine)._TextureLoaders)if (availableLoader.canLoad(extension)) {
        loader = availableLoader;
        break;
    }
    const onInternalError = (request, exception)=>{
        if (rootUrl === originalRootUrl) {
            if (onError && request) onError(request.status + " " + request.statusText, exception);
        } else {
            // fall back to the original url if the transformed url fails to load
            (0, $kVtWi.Logger).Warn(`Failed to load ${rootUrl}, falling back to the ${originalRootUrl}`);
            this.createCubeTextureBase(originalRootUrl, scene, files, !!noMipmap, onLoad, onError, format, forcedExtension, createPolynomials, lodScale, lodOffset, texture, beforeLoadCubeDataCallback, imageHandler, useSRGBBuffer);
        }
    };
    if (loader) {
        const onloaddata = (data)=>{
            if (beforeLoadCubeDataCallback) beforeLoadCubeDataCallback(texture, data);
            loader.loadCubeData(data, texture, createPolynomials, onLoad, onError);
        };
        if (files && files.length === 6) {
            if (loader.supportCascades) this._cascadeLoadFiles(scene, (images)=>onloaddata(images.map((image)=>new Uint8Array(image))), files, onError);
            else if (onError) onError("Textures type does not support cascades.");
            else (0, $kVtWi.Logger).Warn("Texture loader does not support cascades.");
        } else this._loadFile(rootUrl, (data)=>onloaddata(new Uint8Array(data)), undefined, undefined, true, onInternalError);
    } else {
        if (!files || files.length === 0) throw new Error("Cannot load cubemap because files were not defined, or the correct loader was not found.");
        this._cascadeLoadImgs(scene, texture, (texture, imgs)=>{
            if (imageHandler) imageHandler(texture, imgs);
        }, files, onError);
    }
    this._internalTexturesCache.push(texture);
    return texture;
};
(0, $2h5JR.ThinEngine).prototype.createCubeTexture = function(rootUrl, scene, files, noMipmap, onLoad = null, onError = null, format, forcedExtension = null, createPolynomials = false, lodScale = 0, lodOffset = 0, fallback = null, loaderOptions, useSRGBBuffer = false) {
    const gl = this._gl;
    return this.createCubeTextureBase(rootUrl, scene, files, !!noMipmap, onLoad, onError, format, forcedExtension, createPolynomials, lodScale, lodOffset, fallback, (texture)=>this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, texture, true), (texture, imgs)=>{
        const width = this.needPOTTextures ? (0, $2h5JR.ThinEngine).GetExponentOfTwo(imgs[0].width, this._caps.maxCubemapTextureSize) : imgs[0].width;
        const height = width;
        const faces = [
            gl.TEXTURE_CUBE_MAP_POSITIVE_X,
            gl.TEXTURE_CUBE_MAP_POSITIVE_Y,
            gl.TEXTURE_CUBE_MAP_POSITIVE_Z,
            gl.TEXTURE_CUBE_MAP_NEGATIVE_X,
            gl.TEXTURE_CUBE_MAP_NEGATIVE_Y,
            gl.TEXTURE_CUBE_MAP_NEGATIVE_Z
        ];
        this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, texture, true);
        this._unpackFlipY(false);
        const internalFormat = format ? this._getInternalFormat(format, texture._useSRGBBuffer) : texture._useSRGBBuffer ? this._glSRGBExtensionValues.SRGB8_ALPHA8 : gl.RGBA;
        let texelFormat = format ? this._getInternalFormat(format) : gl.RGBA;
        if (texture._useSRGBBuffer && this.webGLVersion === 1) texelFormat = internalFormat;
        for(let index = 0; index < faces.length; index++)if (imgs[index].width !== width || imgs[index].height !== height) {
            this._prepareWorkingCanvas();
            if (!this._workingCanvas || !this._workingContext) {
                (0, $kVtWi.Logger).Warn("Cannot create canvas to resize texture.");
                return;
            }
            this._workingCanvas.width = width;
            this._workingCanvas.height = height;
            this._workingContext.drawImage(imgs[index], 0, 0, imgs[index].width, imgs[index].height, 0, 0, width, height);
            gl.texImage2D(faces[index], 0, internalFormat, texelFormat, gl.UNSIGNED_BYTE, this._workingCanvas);
        } else gl.texImage2D(faces[index], 0, internalFormat, texelFormat, gl.UNSIGNED_BYTE, imgs[index]);
        if (!noMipmap) gl.generateMipmap(gl.TEXTURE_CUBE_MAP);
        this._setCubeMapTextureParams(texture, !noMipmap);
        texture.width = width;
        texture.height = height;
        texture.isReady = true;
        if (format) texture.format = format;
        texture.onLoadedObservable.notifyObservers(texture);
        texture.onLoadedObservable.clear();
        if (onLoad) onLoad();
    }, !!useSRGBBuffer);
};

});

parcelRegister("cKdXJ", function(module, exports) {

var $2h5JR = parcelRequire("2h5JR");
// eslint-disable-next-line @typescript-eslint/no-unused-vars
(0, $2h5JR.ThinEngine).prototype.setTextureSampler = function(name, sampler) {
    throw new Error("setTextureSampler: This engine does not support separate texture sampler objects!");
};

});

parcelRegister("hzTPR", function(module, exports) {

$parcel$export(module.exports, "EngineView", () => $ccc104557a581716$export$2dffd77aabbe5e28);

var $5YkyR = parcelRequire("5YkyR");

var $diGQf = parcelRequire("diGQf");
class $ccc104557a581716$export$2dffd77aabbe5e28 {
}
const $ccc104557a581716$var$_onBeforeViewRenderObservable = new (0, $diGQf.Observable)();
const $ccc104557a581716$var$_onAfterViewRenderObservable = new (0, $diGQf.Observable)();
Object.defineProperty((0, $5YkyR.Engine).prototype, "onBeforeViewRenderObservable", {
    get: function() {
        return $ccc104557a581716$var$_onBeforeViewRenderObservable;
    }
});
Object.defineProperty((0, $5YkyR.Engine).prototype, "onAfterViewRenderObservable", {
    get: function() {
        return $ccc104557a581716$var$_onAfterViewRenderObservable;
    }
});
Object.defineProperty((0, $5YkyR.Engine).prototype, "inputElement", {
    get: function() {
        return this._inputElement;
    },
    set: function(value) {
        if (this._inputElement !== value) {
            this._inputElement = value;
            this._onEngineViewChanged?.();
        }
    }
});
(0, $5YkyR.Engine).prototype.getInputElement = function() {
    return this.inputElement || this.getRenderingCanvas();
};
(0, $5YkyR.Engine).prototype.registerView = function(canvas, camera, clearBeforeCopy) {
    if (!this.views) this.views = [];
    for (const view of this.views){
        if (view.target === canvas) return view;
    }
    const masterCanvas = this.getRenderingCanvas();
    if (masterCanvas) {
        canvas.width = masterCanvas.width;
        canvas.height = masterCanvas.height;
    }
    const newView = {
        target: canvas,
        camera: camera,
        clearBeforeCopy: clearBeforeCopy,
        enabled: true,
        id: (Math.random() * 100000).toFixed()
    };
    this.views.push(newView);
    if (camera && !Array.isArray(camera)) camera.onDisposeObservable.add(()=>{
        this.unRegisterView(canvas);
    });
    return newView;
};
(0, $5YkyR.Engine).prototype.unRegisterView = function(canvas) {
    if (!this.views || this.views.length === 0) return this;
    for (const view of this.views)if (view.target === canvas) {
        const index = this.views.indexOf(view);
        if (index !== -1) this.views.splice(index, 1);
        break;
    }
    return this;
};
(0, $5YkyR.Engine).prototype._renderViewStep = function(view) {
    const canvas = view.target;
    const context = canvas.getContext("2d");
    if (!context) return true;
    const parent = this.getRenderingCanvas();
    $ccc104557a581716$var$_onBeforeViewRenderObservable.notifyObservers(view);
    const camera = view.camera;
    let previewCamera = null;
    let previewCameras = null;
    let scene = null;
    if (camera) {
        scene = Array.isArray(camera) ? camera[0].getScene() : camera.getScene();
        previewCamera = scene.activeCamera;
        previewCameras = scene.activeCameras;
        this.activeView = view;
        if (Array.isArray(camera)) scene.activeCameras = camera;
        else {
            scene.activeCamera = camera;
            scene.activeCameras = null;
        }
    }
    if (view.customResize) view.customResize(canvas);
    else {
        // Set sizes
        const width = Math.floor(canvas.clientWidth / this._hardwareScalingLevel);
        const height = Math.floor(canvas.clientHeight / this._hardwareScalingLevel);
        const dimsChanged = width !== canvas.width || parent.width !== canvas.width || height !== canvas.height || parent.height !== canvas.height;
        if (canvas.clientWidth && canvas.clientHeight && dimsChanged) {
            canvas.width = width;
            canvas.height = height;
            this.setSize(width, height);
        }
    }
    if (!parent.width || !parent.height) return false;
    // Render the frame
    this._renderFrame();
    this.flushFramebuffer();
    // Copy to target
    if (view.clearBeforeCopy) context.clearRect(0, 0, parent.width, parent.height);
    context.drawImage(parent, 0, 0);
    // Restore
    if (scene) {
        scene.activeCameras = previewCameras;
        scene.activeCamera = previewCamera;
    }
    $ccc104557a581716$var$_onAfterViewRenderObservable.notifyObservers(view);
    return true;
};
(0, $5YkyR.Engine).prototype._renderViews = function() {
    if (!this.views || this.views.length === 0) return false;
    const parent = this.getRenderingCanvas();
    if (!parent) return false;
    let inputElementView;
    for (const view of this.views){
        if (!view.enabled) continue;
        const canvas = view.target;
        // Always render the view correspondent to the inputElement for last
        if (canvas === this.inputElement) {
            inputElementView = view;
            continue;
        }
        if (!this._renderViewStep(view)) return false;
    }
    if (inputElementView) {
        if (!this._renderViewStep(inputElementView)) return false;
    }
    this.activeView = null;
    return true;
};

});

parcelRegister("l56Q1", function(module, exports) {

var $2h5JR = parcelRequire("2h5JR");
// eslint-disable-next-line @typescript-eslint/no-unused-vars
(0, $2h5JR.ThinEngine).prototype.createStorageBuffer = function(data, creationFlags) {
    throw new Error("createStorageBuffer: Unsupported method in this engine!");
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
(0, $2h5JR.ThinEngine).prototype.updateStorageBuffer = function(buffer, data, byteOffset, byteLength) {};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
(0, $2h5JR.ThinEngine).prototype.readFromStorageBuffer = function(storageBuffer, offset, size, buffer) {
    throw new Error("readFromStorageBuffer: Unsupported method in this engine!");
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
(0, $2h5JR.ThinEngine).prototype.setStorageBuffer = function(name, buffer) {
    throw new Error("setStorageBuffer: Unsupported method in this engine!");
};

});

parcelRegister("63C6E", function(module, exports) {

var $5YkyR = parcelRequire("5YkyR");
function $46909503fc038ed8$var$transformTextureUrl(url) {
    const excludeFn = (entry)=>{
        const strRegExPattern = "\\b" + entry + "\\b";
        return url && (url === entry || url.match(new RegExp(strRegExPattern, "g")));
    };
    if (this._excludedCompressedTextures && this._excludedCompressedTextures.some(excludeFn)) return url;
    const lastDot = url.lastIndexOf(".");
    const lastQuestionMark = url.lastIndexOf("?");
    const querystring = lastQuestionMark > -1 ? url.substring(lastQuestionMark, url.length) : "";
    return (lastDot > -1 ? url.substring(0, lastDot) : url) + this._textureFormatInUse + querystring;
}
Object.defineProperty((0, $5YkyR.Engine).prototype, "texturesSupported", {
    get: function() {
        // Intelligently add supported compressed formats in order to check for.
        // Check for ASTC support first as it is most powerful and to be very cross platform.
        // Next PVRTC & DXT, which are probably superior to ETC1/2.
        // Likely no hardware which supports both PVR & DXT, so order matters little.
        // ETC2 is newer and handles ETC1 (no alpha capability), so check for first.
        const texturesSupported = [];
        if (this._caps.astc) texturesSupported.push("-astc.ktx");
        if (this._caps.s3tc) texturesSupported.push("-dxt.ktx");
        if (this._caps.pvrtc) texturesSupported.push("-pvrtc.ktx");
        if (this._caps.etc2) texturesSupported.push("-etc2.ktx");
        if (this._caps.etc1) texturesSupported.push("-etc1.ktx");
        return texturesSupported;
    },
    enumerable: true,
    configurable: true
});
Object.defineProperty((0, $5YkyR.Engine).prototype, "textureFormatInUse", {
    get: function() {
        return this._textureFormatInUse || null;
    },
    enumerable: true,
    configurable: true
});
(0, $5YkyR.Engine).prototype.setCompressedTextureExclusions = function(skippedFiles) {
    this._excludedCompressedTextures = skippedFiles;
};
(0, $5YkyR.Engine).prototype.setTextureFormatToUse = function(formatsAvailable) {
    const texturesSupported = this.texturesSupported;
    for(let i = 0, len1 = texturesSupported.length; i < len1; i++){
        for(let j = 0, len2 = formatsAvailable.length; j < len2; j++)if (texturesSupported[i] === formatsAvailable[j].toLowerCase()) {
            this._transformTextureUrl = $46909503fc038ed8$var$transformTextureUrl.bind(this);
            return this._textureFormatInUse = texturesSupported[i];
        }
    }
    // actively set format to nothing, to allow this to be called more than once
    // and possibly fail the 2nd time
    this._textureFormatInUse = "";
    this._transformTextureUrl = null;
    return null;
};

});


parcelRegister("51AOQ", function(module, exports) {

var $74qEN = parcelRequire("74qEN");

var $8BHRw = parcelRequire("8BHRw");
$parcel$exportWildcard(module.exports, $74qEN);
$parcel$exportWildcard(module.exports, $8BHRw);

});
parcelRegister("74qEN", function(module, exports) {

$parcel$export(module.exports, "NativeDataStream", () => $525d95a5aaa42cbf$export$adac9ceb8b84678e);
/** @internal */ class $525d95a5aaa42cbf$export$adac9ceb8b84678e {
    constructor(){
        const buffer = new ArrayBuffer($525d95a5aaa42cbf$export$adac9ceb8b84678e.DEFAULT_BUFFER_SIZE);
        this._uint32s = new Uint32Array(buffer);
        this._int32s = new Int32Array(buffer);
        this._float32s = new Float32Array(buffer);
        this._length = $525d95a5aaa42cbf$export$adac9ceb8b84678e.DEFAULT_BUFFER_SIZE / 4;
        this._position = 0;
        this._nativeDataStream = new _native.NativeDataStream(()=>{
            this._flush();
        });
    }
    /**
     * Writes a uint32 to the stream
     * @param value the value to write
     */ writeUint32(value) {
        this._flushIfNecessary(1);
        this._uint32s[this._position++] = value;
    }
    /**
     * Writes an int32 to the stream
     * @param value the value to write
     */ writeInt32(value) {
        this._flushIfNecessary(1);
        this._int32s[this._position++] = value;
    }
    /**
     * Writes a float32 to the stream
     * @param value the value to write
     */ writeFloat32(value) {
        this._flushIfNecessary(1);
        this._float32s[this._position++] = value;
    }
    /**
     * Writes a uint32 array to the stream
     * @param values the values to write
     */ writeUint32Array(values) {
        this._flushIfNecessary(1 + values.length);
        this._uint32s[this._position++] = values.length;
        this._uint32s.set(values, this._position);
        this._position += values.length;
    }
    /**
     * Writes an int32 array to the stream
     * @param values the values to write
     */ writeInt32Array(values) {
        this._flushIfNecessary(1 + values.length);
        this._uint32s[this._position++] = values.length;
        this._int32s.set(values, this._position);
        this._position += values.length;
    }
    /**
     * Writes a float32 array to the stream
     * @param values the values to write
     */ writeFloat32Array(values) {
        this._flushIfNecessary(1 + values.length);
        this._uint32s[this._position++] = values.length;
        this._float32s.set(values, this._position);
        this._position += values.length;
    }
    /**
     * Writes native data to the stream
     * @param handle the handle to the native data
     */ writeNativeData(handle) {
        this._flushIfNecessary(handle.length);
        this._uint32s.set(handle, this._position);
        this._position += handle.length;
    }
    /**
     * Writes a boolean to the stream
     * @param value the value to write
     */ writeBoolean(value) {
        this.writeUint32(value ? 1 : 0);
    }
    _flushIfNecessary(required) {
        if (this._position + required > this._length) this._flush();
    }
    _flush() {
        this._nativeDataStream.writeBuffer(this._uint32s.buffer, this._position);
        this._position = 0;
    }
}
// Must be multiple of 4!
// eslint-disable-next-line @typescript-eslint/naming-convention
$525d95a5aaa42cbf$export$adac9ceb8b84678e.DEFAULT_BUFFER_SIZE = 65536;

});

parcelRegister("8BHRw", function(module, exports) {

$parcel$export(module.exports, "ValidatedNativeDataStream", () => $6443cd959c221a19$export$1a2677dfe278058c);

var $3DmnG = parcelRequire("3DmnG");

var $74qEN = parcelRequire("74qEN");
(0, $3DmnG.NativeEngine)._createNativeDataStream = function() {
    if (_native.NativeDataStream.VALIDATION_ENABLED) return new $6443cd959c221a19$export$1a2677dfe278058c();
    else return new (0, $74qEN.NativeDataStream)();
};
class $6443cd959c221a19$export$1a2677dfe278058c extends (0, $74qEN.NativeDataStream) {
    constructor(){
        super();
    }
    writeUint32(value) {
        super.writeUint32(_native.NativeDataStream.VALIDATION_UINT_32);
        super.writeUint32(value);
    }
    writeInt32(value) {
        super.writeUint32(_native.NativeDataStream.VALIDATION_INT_32);
        super.writeInt32(value);
    }
    writeFloat32(value) {
        super.writeUint32(_native.NativeDataStream.VALIDATION_FLOAT_32);
        super.writeFloat32(value);
    }
    writeUint32Array(values) {
        super.writeUint32(_native.NativeDataStream.VALIDATION_UINT_32_ARRAY);
        super.writeUint32Array(values);
    }
    writeInt32Array(values) {
        super.writeUint32(_native.NativeDataStream.VALIDATION_INT_32_ARRAY);
        super.writeInt32Array(values);
    }
    writeFloat32Array(values) {
        super.writeUint32(_native.NativeDataStream.VALIDATION_FLOAT_32_ARRAY);
        super.writeFloat32Array(values);
    }
    writeNativeData(handle) {
        super.writeUint32(_native.NativeDataStream.VALIDATION_NATIVE_DATA);
        super.writeNativeData(handle);
    }
    writeBoolean(value) {
        super.writeUint32(_native.NativeDataStream.VALIDATION_BOOLEAN);
        super.writeBoolean(value);
    }
}

});
parcelRegister("3DmnG", function(module, exports) {

$parcel$export(module.exports, "AcquireNativeObjectAsync", () => $2a56600675bb9bbf$export$da6a3cf7915f33b6);
$parcel$export(module.exports, "RegisterNativeTypeAsync", () => $2a56600675bb9bbf$export$852dd5a0aa8f8185);
$parcel$export(module.exports, "NativeEngine", () => $2a56600675bb9bbf$export$74c04c8441198a85);

var $5YkyR = parcelRequire("5YkyR");

var $b9e4a = parcelRequire("b9e4a");

var $j2mX5 = parcelRequire("j2mX5");

var $6zPKs = parcelRequire("6zPKs");

var $bOhSV = parcelRequire("bOhSV");

var $diGQf = parcelRequire("diGQf");

var $6XNeg = parcelRequire("6XNeg");

var $kVtWi = parcelRequire("kVtWi");

var $2h5JR = parcelRequire("2h5JR");

var $ejQPp = parcelRequire("ejQPp");

var $lh6wJ = parcelRequire("lh6wJ");

var $i1R6L = parcelRequire("i1R6L");

var $74qEN = parcelRequire("74qEN");

var $bxCN4 = parcelRequire("bxCN4");

var $1M3z8 = parcelRequire("1M3z8");

var $336js = parcelRequire("336js");

var $iYZjK = parcelRequire("iYZjK");
const $2a56600675bb9bbf$var$onNativeObjectInitialized = new (0, $diGQf.Observable)();
if (typeof self !== "undefined" && !Object.prototype.hasOwnProperty.call(self, "_native")) {
    let __native;
    Object.defineProperty(self, "_native", {
        get: ()=>__native,
        set: (value)=>{
            __native = value;
            if (__native) $2a56600675bb9bbf$var$onNativeObjectInitialized.notifyObservers(__native);
        }
    });
}
function $2a56600675bb9bbf$export$da6a3cf7915f33b6() {
    return new Promise((resolve)=>{
        if (typeof _native === "undefined") $2a56600675bb9bbf$var$onNativeObjectInitialized.addOnce((nativeObject)=>resolve(nativeObject));
        else resolve(_native);
    });
}
async function $2a56600675bb9bbf$export$852dd5a0aa8f8185(typeName, constructor) {
    (await $2a56600675bb9bbf$export$da6a3cf7915f33b6())[typeName] = constructor;
}
/**
 * Container for accessors for natively-stored mesh data buffers.
 */ class $2a56600675bb9bbf$var$NativeDataBuffer extends (0, $6zPKs.DataBuffer) {
}
/** @internal */ class $2a56600675bb9bbf$var$CommandBufferEncoder {
    constructor(_engine){
        this._engine = _engine;
        this._pending = new Array();
        this._isCommandBufferScopeActive = false;
        this._commandStream = $2a56600675bb9bbf$export$74c04c8441198a85._createNativeDataStream();
        this._engine.setCommandDataStream(this._commandStream);
    }
    beginCommandScope() {
        if (this._isCommandBufferScopeActive) throw new Error("Command scope already active.");
        this._isCommandBufferScopeActive = true;
    }
    endCommandScope() {
        if (!this._isCommandBufferScopeActive) throw new Error("Command scope is not active.");
        this._isCommandBufferScopeActive = false;
        this._submit();
    }
    startEncodingCommand(command) {
        this._commandStream.writeNativeData(command);
    }
    encodeCommandArgAsUInt32(commandArg) {
        this._commandStream.writeUint32(commandArg);
    }
    encodeCommandArgAsUInt32s(commandArg) {
        this._commandStream.writeUint32Array(commandArg);
    }
    encodeCommandArgAsInt32(commandArg) {
        this._commandStream.writeInt32(commandArg);
    }
    encodeCommandArgAsInt32s(commandArg) {
        this._commandStream.writeInt32Array(commandArg);
    }
    encodeCommandArgAsFloat32(commandArg) {
        this._commandStream.writeFloat32(commandArg);
    }
    encodeCommandArgAsFloat32s(commandArg) {
        this._commandStream.writeFloat32Array(commandArg);
    }
    encodeCommandArgAsNativeData(commandArg) {
        this._commandStream.writeNativeData(commandArg);
        this._pending.push(commandArg);
    }
    finishEncodingCommand() {
        if (!this._isCommandBufferScopeActive) this._submit();
    }
    _submit() {
        this._engine.submitCommands();
        this._pending.length = 0;
    }
}
class $2a56600675bb9bbf$export$74c04c8441198a85 extends (0, $5YkyR.Engine) {
    setHardwareScalingLevel(level) {
        super.setHardwareScalingLevel(level);
        this._engine.setHardwareScalingLevel(level);
    }
    constructor(options = {}){
        super(null, false, undefined, options.adaptToDeviceRatio);
        this._engine = new _native.Engine();
        this._camera = _native.Camera ? new _native.Camera() : null;
        this._commandBufferEncoder = new $2a56600675bb9bbf$var$CommandBufferEncoder(this._engine);
        this._boundBuffersVertexArray = null;
        this._currentDepthTest = _native.Engine.DEPTH_TEST_LEQUAL;
        this._stencilTest = false;
        this._stencilMask = 255;
        this._stencilFunc = 519;
        this._stencilFuncRef = 0;
        this._stencilFuncMask = 255;
        this._stencilOpStencilFail = 7680;
        this._stencilOpDepthFail = 7680;
        this._stencilOpStencilDepthPass = 7681;
        this._zOffset = 0;
        this._zOffsetUnits = 0;
        this._depthWrite = true;
        if (_native.Engine.PROTOCOL_VERSION !== $2a56600675bb9bbf$export$74c04c8441198a85.PROTOCOL_VERSION) throw new Error(`Protocol version mismatch: ${_native.Engine.PROTOCOL_VERSION} (Native) !== ${$2a56600675bb9bbf$export$74c04c8441198a85.PROTOCOL_VERSION} (JS)`);
        if (this._engine.setDeviceLostCallback) this._engine.setDeviceLostCallback(()=>{
            this.onContextLostObservable.notifyObservers(this);
            this._contextWasLost = true;
            this._restoreEngineAfterContextLost();
        });
        this._webGLVersion = 2;
        this.disableUniformBuffers = true;
        this._shaderPlatformName = "NATIVE";
        // TODO: Initialize this more correctly based on the hardware capabilities.
        // Init caps
        this._caps = {
            maxTexturesImageUnits: 16,
            maxVertexTextureImageUnits: 16,
            maxCombinedTexturesImageUnits: 32,
            maxTextureSize: _native.Engine.CAPS_LIMITS_MAX_TEXTURE_SIZE,
            maxCubemapTextureSize: 512,
            maxRenderTextureSize: 512,
            maxVertexAttribs: 16,
            maxVaryingVectors: 16,
            maxFragmentUniformVectors: 16,
            maxVertexUniformVectors: 16,
            standardDerivatives: true,
            astc: null,
            pvrtc: null,
            etc1: null,
            etc2: null,
            bptc: null,
            maxAnisotropy: 16,
            uintIndices: true,
            fragmentDepthSupported: false,
            highPrecisionShaderSupported: true,
            colorBufferFloat: false,
            supportFloatTexturesResolve: false,
            rg11b10ufColorRenderable: false,
            textureFloat: true,
            textureFloatLinearFiltering: false,
            textureFloatRender: true,
            textureHalfFloat: true,
            textureHalfFloatLinearFiltering: false,
            textureHalfFloatRender: true,
            textureLOD: true,
            texelFetch: false,
            drawBuffersExtension: false,
            depthTextureExtension: false,
            vertexArrayObject: true,
            instancedArrays: true,
            supportOcclusionQuery: false,
            canUseTimestampForTimerQuery: false,
            blendMinMax: false,
            maxMSAASamples: 16,
            canUseGLInstanceID: true,
            canUseGLVertexID: true,
            supportComputeShaders: false,
            supportSRGBBuffers: true,
            supportTransformFeedbacks: false,
            textureMaxLevel: false,
            texture2DArrayMaxLayerCount: _native.Engine.CAPS_LIMITS_MAX_TEXTURE_LAYERS,
            disableMorphTargetTexture: false,
            parallelShaderCompile: {
                COMPLETION_STATUS_KHR: 0
            }
        };
        this._features = {
            forceBitmapOverHTMLImageElement: true,
            supportRenderAndCopyToLodForFloatTextures: false,
            supportDepthStencilTexture: false,
            supportShadowSamplers: false,
            uniformBufferHardCheckMatrix: false,
            allowTexturePrefiltering: false,
            trackUbosInFrame: false,
            checkUbosContentBeforeUpload: false,
            supportCSM: false,
            basisNeedsPOT: false,
            support3DTextures: false,
            needTypeSuffixInShaderConstants: false,
            supportMSAA: true,
            supportSSAO2: false,
            supportExtendedTextureFormats: false,
            supportSwitchCaseInShader: false,
            supportSyncTextureRead: false,
            needsInvertingBitmap: true,
            useUBOBindingCache: true,
            needShaderCodeInlining: true,
            needToAlwaysBindUniformBuffers: false,
            supportRenderPasses: true,
            supportSpriteInstancing: false,
            forceVertexBufferStrideAndOffsetMultiple4Bytes: false,
            _collectUbosUpdatedInFrame: false
        };
        (0, $bOhSV.Tools).Log("Babylon Native (v" + (0, $5YkyR.Engine).Version + ") launched");
        (0, $bOhSV.Tools).LoadScript = function(scriptUrl, onSuccess, onError, scriptId) {
            (0, $bOhSV.Tools).LoadFile(scriptUrl, (data)=>{
                Function(data).apply(null);
                if (onSuccess) onSuccess();
            }, undefined, undefined, false, (request, exception)=>{
                if (onError) onError("LoadScript Error", exception);
            });
        };
        // Wrappers
        if (typeof URL === "undefined") window.URL = {
            createObjectURL: function() {},
            revokeObjectURL: function() {}
        };
        if (typeof Blob === "undefined") window.Blob = function(v) {
            return v;
        };
        // polyfill for Chakra
        if (!Array.prototype.flat) Object.defineProperty(Array.prototype, "flat", {
            configurable: true,
            value: function flat() {
                const depth = isNaN(arguments[0]) ? 1 : Number(arguments[0]);
                return depth ? Array.prototype.reduce.call(this, function(acc, cur) {
                    if (Array.isArray(cur)) acc.push.apply(acc, flat.call(cur, depth - 1));
                    else acc.push(cur);
                    return acc;
                }, []) : Array.prototype.slice.call(this);
            },
            writable: true
        });
        // Currently we do not fully configure the ThinEngine on construction of NativeEngine.
        // Setup resolution scaling based on display settings.
        const devicePixelRatio = window ? window.devicePixelRatio || 1.0 : 1.0;
        this._hardwareScalingLevel = options.adaptToDeviceRatio ? 1.0 / devicePixelRatio : 1.0;
        this._engine.setHardwareScalingLevel(this._hardwareScalingLevel);
        this._lastDevicePixelRatio = devicePixelRatio;
        this.resize();
        const currentDepthFunction = this.getDepthFunction();
        if (currentDepthFunction) this.setDepthFunction(currentDepthFunction);
        // Shader processor
        this._shaderProcessor = new (0, $i1R6L.WebGL2ShaderProcessor)();
        this.onNewSceneAddedObservable.add((scene)=>{
            const originalRender = scene.render;
            scene.render = (...args)=>{
                this._commandBufferEncoder.beginCommandScope();
                originalRender.apply(scene, args);
                this._commandBufferEncoder.endCommandScope();
            };
        });
    }
    dispose() {
        super.dispose();
        if (this._boundBuffersVertexArray) this._deleteVertexArray(this._boundBuffersVertexArray);
        this._engine.dispose();
    }
    /** @internal */ static _createNativeDataStream() {
        return new (0, $74qEN.NativeDataStream)();
    }
    /**
     * Can be used to override the current requestAnimationFrame requester.
     * @internal
     */ _queueNewFrame(bindedRenderFunction, requester) {
        // Use the provided requestAnimationFrame, unless the requester is the window. In that case, we will default to the Babylon Native version of requestAnimationFrame.
        if (requester.requestAnimationFrame && requester !== window) requester.requestAnimationFrame(bindedRenderFunction);
        else this._engine.requestAnimationFrame(bindedRenderFunction);
        return 0;
    }
    _restoreEngineAfterContextLost() {
        this._clearEmptyResources();
        const depthTest = this._depthCullingState.depthTest; // backup those values because the call to initEngine / wipeCaches will reset them
        const depthFunc = this._depthCullingState.depthFunc;
        const depthMask = this._depthCullingState.depthMask;
        const stencilTest = this._stencilState.stencilTest;
        this._rebuildGraphicsResources();
        this._depthCullingState.depthTest = depthTest;
        this._depthCullingState.depthFunc = depthFunc;
        this._depthCullingState.depthMask = depthMask;
        this._stencilState.stencilTest = stencilTest;
        this._flagContextRestored();
    }
    /**
     * Override default engine behavior.
     * @param framebuffer
     */ _bindUnboundFramebuffer(framebuffer) {
        if (this._currentFramebuffer !== framebuffer) {
            if (this._currentFramebuffer) {
                this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_UNBINDFRAMEBUFFER);
                this._commandBufferEncoder.encodeCommandArgAsNativeData(this._currentFramebuffer);
                this._commandBufferEncoder.finishEncodingCommand();
            }
            if (framebuffer) {
                this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_BINDFRAMEBUFFER);
                this._commandBufferEncoder.encodeCommandArgAsNativeData(framebuffer);
                this._commandBufferEncoder.finishEncodingCommand();
            }
            this._currentFramebuffer = framebuffer;
        }
    }
    /**
     * Gets host document
     * @returns the host document object
     */ getHostDocument() {
        return null;
    }
    clear(color, backBuffer, depth, stencil = false) {
        if (this.useReverseDepthBuffer) throw new Error("reverse depth buffer is not currently implemented");
        this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_CLEAR);
        this._commandBufferEncoder.encodeCommandArgAsUInt32(backBuffer && color ? 1 : 0);
        this._commandBufferEncoder.encodeCommandArgAsFloat32(color ? color.r : 0);
        this._commandBufferEncoder.encodeCommandArgAsFloat32(color ? color.g : 0);
        this._commandBufferEncoder.encodeCommandArgAsFloat32(color ? color.b : 0);
        this._commandBufferEncoder.encodeCommandArgAsFloat32(color ? color.a : 1);
        this._commandBufferEncoder.encodeCommandArgAsUInt32(depth ? 1 : 0);
        this._commandBufferEncoder.encodeCommandArgAsFloat32(1);
        this._commandBufferEncoder.encodeCommandArgAsUInt32(stencil ? 1 : 0);
        this._commandBufferEncoder.encodeCommandArgAsUInt32(0);
        this._commandBufferEncoder.finishEncodingCommand();
    }
    createIndexBuffer(indices, updateable, _label) {
        const data = this._normalizeIndexData(indices);
        const buffer = new $2a56600675bb9bbf$var$NativeDataBuffer();
        buffer.references = 1;
        buffer.is32Bits = data.BYTES_PER_ELEMENT === 4;
        if (data.byteLength) buffer.nativeIndexBuffer = this._engine.createIndexBuffer(data.buffer, data.byteOffset, data.byteLength, buffer.is32Bits, updateable ?? false);
        return buffer;
    }
    createVertexBuffer(vertices, updateable, _label) {
        const data = ArrayBuffer.isView(vertices) ? vertices : new Float32Array(vertices);
        const buffer = new $2a56600675bb9bbf$var$NativeDataBuffer();
        buffer.references = 1;
        if (data.byteLength) buffer.nativeVertexBuffer = this._engine.createVertexBuffer(data.buffer, data.byteOffset, data.byteLength, updateable ?? false);
        return buffer;
    }
    _recordVertexArrayObject(vertexArray, vertexBuffers, indexBuffer, effect, overrideVertexBuffers) {
        if (indexBuffer) this._engine.recordIndexBuffer(vertexArray, indexBuffer.nativeIndexBuffer);
        const attributes = effect.getAttributesNames();
        for(let index = 0; index < attributes.length; index++){
            const location = effect.getAttributeLocation(index);
            if (location >= 0) {
                const kind = attributes[index];
                let vertexBuffer = null;
                if (overrideVertexBuffers) vertexBuffer = overrideVertexBuffers[kind];
                if (!vertexBuffer) vertexBuffer = vertexBuffers[kind];
                if (vertexBuffer) {
                    const buffer = vertexBuffer.getBuffer();
                    if (buffer && buffer.nativeVertexBuffer) this._engine.recordVertexBuffer(vertexArray, buffer.nativeVertexBuffer, location, vertexBuffer.byteOffset, vertexBuffer.byteStride, vertexBuffer.getSize(), (0, $iYZjK.getNativeAttribType)(vertexBuffer.type), vertexBuffer.normalized, vertexBuffer.getInstanceDivisor());
                }
            }
        }
    }
    bindBuffers(vertexBuffers, indexBuffer, effect) {
        if (this._boundBuffersVertexArray) this._deleteVertexArray(this._boundBuffersVertexArray);
        this._boundBuffersVertexArray = this._engine.createVertexArray();
        this._recordVertexArrayObject(this._boundBuffersVertexArray, vertexBuffers, indexBuffer, effect);
        this.bindVertexArrayObject(this._boundBuffersVertexArray);
    }
    recordVertexArrayObject(vertexBuffers, indexBuffer, effect, overrideVertexBuffers) {
        const vertexArray = this._engine.createVertexArray();
        this._recordVertexArrayObject(vertexArray, vertexBuffers, indexBuffer, effect, overrideVertexBuffers);
        return vertexArray;
    }
    _deleteVertexArray(vertexArray) {
        this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_DELETEVERTEXARRAY);
        this._commandBufferEncoder.encodeCommandArgAsNativeData(vertexArray);
        this._commandBufferEncoder.finishEncodingCommand();
    }
    bindVertexArrayObject(vertexArray) {
        this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_BINDVERTEXARRAY);
        this._commandBufferEncoder.encodeCommandArgAsNativeData(vertexArray);
        this._commandBufferEncoder.finishEncodingCommand();
    }
    releaseVertexArrayObject(vertexArray) {
        this._deleteVertexArray(vertexArray);
    }
    getAttributes(pipelineContext, attributesNames) {
        const nativePipelineContext = pipelineContext;
        return this._engine.getAttributes(nativePipelineContext.program, attributesNames);
    }
    /**
     * Draw a list of indexed primitives
     * @param fillMode defines the primitive to use
     * @param indexStart defines the starting index
     * @param indexCount defines the number of index to draw
     * @param instancesCount defines the number of instances to draw (if instantiation is enabled)
     */ drawElementsType(fillMode, indexStart, indexCount, instancesCount) {
        // Apply states
        this._drawCalls.addCount(1, false);
        if (instancesCount && _native.Engine.COMMAND_DRAWINDEXEDINSTANCED) {
            this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_DRAWINDEXEDINSTANCED);
            this._commandBufferEncoder.encodeCommandArgAsUInt32(fillMode);
            this._commandBufferEncoder.encodeCommandArgAsUInt32(indexStart);
            this._commandBufferEncoder.encodeCommandArgAsUInt32(indexCount);
            this._commandBufferEncoder.encodeCommandArgAsUInt32(instancesCount);
        } else {
            this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_DRAWINDEXED);
            this._commandBufferEncoder.encodeCommandArgAsUInt32(fillMode);
            this._commandBufferEncoder.encodeCommandArgAsUInt32(indexStart);
            this._commandBufferEncoder.encodeCommandArgAsUInt32(indexCount);
        }
        this._commandBufferEncoder.finishEncodingCommand();
    // }
    }
    /**
     * Draw a list of unindexed primitives
     * @param fillMode defines the primitive to use
     * @param verticesStart defines the index of first vertex to draw
     * @param verticesCount defines the count of vertices to draw
     * @param instancesCount defines the number of instances to draw (if instantiation is enabled)
     */ drawArraysType(fillMode, verticesStart, verticesCount, instancesCount) {
        // Apply states
        this._drawCalls.addCount(1, false);
        if (instancesCount && _native.Engine.COMMAND_DRAWINSTANCED) {
            this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_DRAWINSTANCED);
            this._commandBufferEncoder.encodeCommandArgAsUInt32(fillMode);
            this._commandBufferEncoder.encodeCommandArgAsUInt32(verticesStart);
            this._commandBufferEncoder.encodeCommandArgAsUInt32(verticesCount);
            this._commandBufferEncoder.encodeCommandArgAsUInt32(instancesCount);
        } else {
            this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_DRAW);
            this._commandBufferEncoder.encodeCommandArgAsUInt32(fillMode);
            this._commandBufferEncoder.encodeCommandArgAsUInt32(verticesStart);
            this._commandBufferEncoder.encodeCommandArgAsUInt32(verticesCount);
        }
        this._commandBufferEncoder.finishEncodingCommand();
    // }
    }
    createPipelineContext() {
        const isAsync = !!(this._caps.parallelShaderCompile && this._engine.createProgramAsync);
        return new (0, $bxCN4.NativePipelineContext)(this, isAsync);
    }
    createMaterialContext() {
        return undefined;
    }
    createDrawContext() {
        return undefined;
    }
    /**
     * @internal
     */ _preparePipelineContext(pipelineContext, vertexSourceCode, fragmentSourceCode, createAsRaw, _rawVertexSourceCode, _rawFragmentSourceCode, _rebuildRebind, defines) {
        if (createAsRaw) this.createRawShaderProgram();
        else this.createShaderProgram(pipelineContext, vertexSourceCode, fragmentSourceCode, defines);
    }
    /**
     * @internal
     */ _executeWhenRenderingStateIsCompiled(pipelineContext, action) {
        const nativePipelineContext = pipelineContext;
        if (nativePipelineContext.isAsync) {
            if (nativePipelineContext.onCompiled) {
                const oldHandler = nativePipelineContext.onCompiled;
                nativePipelineContext.onCompiled = ()=>{
                    oldHandler();
                    action();
                };
            } else nativePipelineContext.onCompiled = action;
        } else action();
    }
    createRawShaderProgram() {
        throw new Error("Not Supported");
    }
    createShaderProgram(pipelineContext, vertexCode, fragmentCode, defines) {
        const nativePipelineContext = pipelineContext;
        this.onBeforeShaderCompilationObservable.notifyObservers(this);
        const vertexInliner = new (0, $lh6wJ.ShaderCodeInliner)(vertexCode);
        vertexInliner.processCode();
        vertexCode = vertexInliner.code;
        const fragmentInliner = new (0, $lh6wJ.ShaderCodeInliner)(fragmentCode);
        fragmentInliner.processCode();
        fragmentCode = fragmentInliner.code;
        vertexCode = (0, $2h5JR.ThinEngine)._ConcatenateShader(vertexCode, defines);
        fragmentCode = (0, $2h5JR.ThinEngine)._ConcatenateShader(fragmentCode, defines);
        const onSuccess = ()=>{
            nativePipelineContext.isCompiled = true;
            nativePipelineContext.onCompiled?.();
            this.onAfterShaderCompilationObservable.notifyObservers(this);
        };
        if (pipelineContext.isAsync) nativePipelineContext.program = this._engine.createProgramAsync(vertexCode, fragmentCode, onSuccess, (error)=>{
            nativePipelineContext.compilationError = error;
        });
        else try {
            nativePipelineContext.program = this._engine.createProgram(vertexCode, fragmentCode);
            onSuccess();
        } catch (e) {
            const message = e?.message;
            throw new Error("SHADER ERROR" + (typeof message === "string" ? "\n" + message : ""));
        }
        return nativePipelineContext.program;
    }
    /**
     * Inline functions in shader code that are marked to be inlined
     * @param code code to inline
     * @returns inlined code
     */ inlineShaderCode(code) {
        const sci = new (0, $lh6wJ.ShaderCodeInliner)(code);
        sci.debug = false;
        sci.processCode();
        return sci.code;
    }
    _setProgram(program) {
        if (this._currentProgram !== program) {
            this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_SETPROGRAM);
            this._commandBufferEncoder.encodeCommandArgAsNativeData(program);
            this._commandBufferEncoder.finishEncodingCommand();
            this._currentProgram = program;
        }
    }
    _deletePipelineContext(pipelineContext) {
        const nativePipelineContext = pipelineContext;
        if (nativePipelineContext && nativePipelineContext.program) {
            this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_DELETEPROGRAM);
            this._commandBufferEncoder.encodeCommandArgAsNativeData(nativePipelineContext.program);
            this._commandBufferEncoder.finishEncodingCommand();
        }
    }
    getUniforms(pipelineContext, uniformsNames) {
        const nativePipelineContext = pipelineContext;
        return this._engine.getUniforms(nativePipelineContext.program, uniformsNames);
    }
    bindUniformBlock(pipelineContext, blockName, index) {
        // TODO
        throw new Error("Not Implemented");
    }
    bindSamplers(effect) {
        const nativePipelineContext = effect.getPipelineContext();
        this._setProgram(nativePipelineContext.program);
        // TODO: share this with engine?
        const samplers = effect.getSamplers();
        for(let index = 0; index < samplers.length; index++){
            const uniform = effect.getUniform(samplers[index]);
            if (uniform) this._boundUniforms[index] = uniform;
        }
        this._currentEffect = null;
    }
    getRenderWidth(useScreen = false) {
        if (!useScreen && this._currentRenderTarget) return this._currentRenderTarget.width;
        return this._engine.getRenderWidth();
    }
    getRenderHeight(useScreen = false) {
        if (!useScreen && this._currentRenderTarget) return this._currentRenderTarget.height;
        return this._engine.getRenderHeight();
    }
    setViewport(viewport, requiredWidth, requiredHeight) {
        this._cachedViewport = viewport;
        this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_SETVIEWPORT);
        this._commandBufferEncoder.encodeCommandArgAsFloat32(viewport.x);
        this._commandBufferEncoder.encodeCommandArgAsFloat32(viewport.y);
        this._commandBufferEncoder.encodeCommandArgAsFloat32(viewport.width);
        this._commandBufferEncoder.encodeCommandArgAsFloat32(viewport.height);
        this._commandBufferEncoder.finishEncodingCommand();
    }
    enableScissor(x, y, width, height) {
        this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_SETSCISSOR);
        this._commandBufferEncoder.encodeCommandArgAsFloat32(x);
        this._commandBufferEncoder.encodeCommandArgAsFloat32(y);
        this._commandBufferEncoder.encodeCommandArgAsFloat32(width);
        this._commandBufferEncoder.encodeCommandArgAsFloat32(height);
        this._commandBufferEncoder.finishEncodingCommand();
    }
    disableScissor() {
        this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_SETSCISSOR);
        this._commandBufferEncoder.encodeCommandArgAsFloat32(0);
        this._commandBufferEncoder.encodeCommandArgAsFloat32(0);
        this._commandBufferEncoder.encodeCommandArgAsFloat32(0);
        this._commandBufferEncoder.encodeCommandArgAsFloat32(0);
        this._commandBufferEncoder.finishEncodingCommand();
    }
    setState(culling, zOffset = 0, force, reverseSide = false, cullBackFaces, stencil, zOffsetUnits = 0) {
        this._zOffset = zOffset;
        this._zOffsetUnits = zOffsetUnits;
        if (this._zOffset !== 0) (0, $bOhSV.Tools).Warn("zOffset is not supported in Native engine.");
        this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_SETSTATE);
        this._commandBufferEncoder.encodeCommandArgAsUInt32(culling ? 1 : 0);
        this._commandBufferEncoder.encodeCommandArgAsFloat32(zOffset);
        this._commandBufferEncoder.encodeCommandArgAsFloat32(zOffsetUnits);
        this._commandBufferEncoder.encodeCommandArgAsUInt32(this.cullBackFaces ?? cullBackFaces ?? true ? 1 : 0);
        this._commandBufferEncoder.encodeCommandArgAsUInt32(reverseSide ? 1 : 0);
        this._commandBufferEncoder.finishEncodingCommand();
    }
    /**
     * Gets the client rect of native canvas.  Needed for InputManager.
     * @returns a client rectangle
     */ getInputElementClientRect() {
        const rect = {
            bottom: this.getRenderHeight(),
            height: this.getRenderHeight(),
            left: 0,
            right: this.getRenderWidth(),
            top: 0,
            width: this.getRenderWidth(),
            x: 0,
            y: 0,
            toJSON: ()=>{}
        };
        return rect;
    }
    /**
     * Set the z offset Factor to apply to current rendering
     * @param value defines the offset to apply
     */ setZOffset(value) {
        if (value !== this._zOffset) {
            this._zOffset = value;
            this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_SETZOFFSET);
            this._commandBufferEncoder.encodeCommandArgAsFloat32(this.useReverseDepthBuffer ? -value : value);
            this._commandBufferEncoder.finishEncodingCommand();
        }
    }
    /**
     * Gets the current value of the zOffset Factor
     * @returns the current zOffset Factor state
     */ getZOffset() {
        return this._zOffset;
    }
    /**
     * Set the z offset Units to apply to current rendering
     * @param value defines the offset to apply
     */ setZOffsetUnits(value) {
        if (value !== this._zOffsetUnits) {
            this._zOffsetUnits = value;
            this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_SETZOFFSETUNITS);
            this._commandBufferEncoder.encodeCommandArgAsFloat32(this.useReverseDepthBuffer ? -value : value);
            this._commandBufferEncoder.finishEncodingCommand();
        }
    }
    /**
     * Gets the current value of the zOffset Units
     * @returns the current zOffset Units state
     */ getZOffsetUnits() {
        return this._zOffsetUnits;
    }
    /**
     * Enable or disable depth buffering
     * @param enable defines the state to set
     */ setDepthBuffer(enable) {
        this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_SETDEPTHTEST);
        this._commandBufferEncoder.encodeCommandArgAsUInt32(enable ? this._currentDepthTest : _native.Engine.DEPTH_TEST_ALWAYS);
        this._commandBufferEncoder.finishEncodingCommand();
    }
    /**
     * Gets a boolean indicating if depth writing is enabled
     * @returns the current depth writing state
     */ getDepthWrite() {
        return this._depthWrite;
    }
    getDepthFunction() {
        switch(this._currentDepthTest){
            case _native.Engine.DEPTH_TEST_NEVER:
                return 512;
            case _native.Engine.DEPTH_TEST_ALWAYS:
                return 519;
            case _native.Engine.DEPTH_TEST_GREATER:
                return 516;
            case _native.Engine.DEPTH_TEST_GEQUAL:
                return 518;
            case _native.Engine.DEPTH_TEST_NOTEQUAL:
                return 517;
            case _native.Engine.DEPTH_TEST_EQUAL:
                return 514;
            case _native.Engine.DEPTH_TEST_LESS:
                return 513;
            case _native.Engine.DEPTH_TEST_LEQUAL:
                return 515;
        }
        return null;
    }
    setDepthFunction(depthFunc) {
        let nativeDepthFunc = 0;
        switch(depthFunc){
            case 512:
                nativeDepthFunc = _native.Engine.DEPTH_TEST_NEVER;
                break;
            case 519:
                nativeDepthFunc = _native.Engine.DEPTH_TEST_ALWAYS;
                break;
            case 516:
                nativeDepthFunc = _native.Engine.DEPTH_TEST_GREATER;
                break;
            case 518:
                nativeDepthFunc = _native.Engine.DEPTH_TEST_GEQUAL;
                break;
            case 517:
                nativeDepthFunc = _native.Engine.DEPTH_TEST_NOTEQUAL;
                break;
            case 514:
                nativeDepthFunc = _native.Engine.DEPTH_TEST_EQUAL;
                break;
            case 513:
                nativeDepthFunc = _native.Engine.DEPTH_TEST_LESS;
                break;
            case 515:
                nativeDepthFunc = _native.Engine.DEPTH_TEST_LEQUAL;
                break;
        }
        this._currentDepthTest = nativeDepthFunc;
        this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_SETDEPTHTEST);
        this._commandBufferEncoder.encodeCommandArgAsUInt32(this._currentDepthTest);
        this._commandBufferEncoder.finishEncodingCommand();
    }
    /**
     * Enable or disable depth writing
     * @param enable defines the state to set
     */ setDepthWrite(enable) {
        this._depthWrite = enable;
        this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_SETDEPTHWRITE);
        this._commandBufferEncoder.encodeCommandArgAsUInt32(Number(enable));
        this._commandBufferEncoder.finishEncodingCommand();
    }
    /**
     * Enable or disable color writing
     * @param enable defines the state to set
     */ setColorWrite(enable) {
        this._colorWrite = enable;
        this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_SETCOLORWRITE);
        this._commandBufferEncoder.encodeCommandArgAsUInt32(Number(enable));
        this._commandBufferEncoder.finishEncodingCommand();
    }
    /**
     * Gets a boolean indicating if color writing is enabled
     * @returns the current color writing state
     */ getColorWrite() {
        return this._colorWrite;
    }
    applyStencil() {
        this._setStencil(this._stencilMask, (0, $iYZjK.getNativeStencilOpFail)(this._stencilOpStencilFail), (0, $iYZjK.getNativeStencilDepthFail)(this._stencilOpDepthFail), (0, $iYZjK.getNativeStencilDepthPass)(this._stencilOpStencilDepthPass), (0, $iYZjK.getNativeStencilFunc)(this._stencilFunc), this._stencilFuncRef);
    }
    _setStencil(mask, stencilOpFail, depthOpFail, depthOpPass, func, ref) {
        this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_SETSTENCIL);
        this._commandBufferEncoder.encodeCommandArgAsUInt32(mask);
        this._commandBufferEncoder.encodeCommandArgAsUInt32(stencilOpFail);
        this._commandBufferEncoder.encodeCommandArgAsUInt32(depthOpFail);
        this._commandBufferEncoder.encodeCommandArgAsUInt32(depthOpPass);
        this._commandBufferEncoder.encodeCommandArgAsUInt32(func);
        this._commandBufferEncoder.encodeCommandArgAsUInt32(ref);
        this._commandBufferEncoder.finishEncodingCommand();
    }
    /**
     * Enable or disable the stencil buffer
     * @param enable defines if the stencil buffer must be enabled or disabled
     */ setStencilBuffer(enable) {
        this._stencilTest = enable;
        if (enable) this.applyStencil();
        else this._setStencil(255, _native.Engine.STENCIL_OP_FAIL_S_KEEP, _native.Engine.STENCIL_OP_FAIL_Z_KEEP, _native.Engine.STENCIL_OP_PASS_Z_KEEP, _native.Engine.STENCIL_TEST_ALWAYS, 0);
    }
    /**
     * Gets a boolean indicating if stencil buffer is enabled
     * @returns the current stencil buffer state
     */ getStencilBuffer() {
        return this._stencilTest;
    }
    /**
     * Gets the current stencil operation when stencil passes
     * @returns a number defining stencil operation to use when stencil passes
     */ getStencilOperationPass() {
        return this._stencilOpStencilDepthPass;
    }
    /**
     * Sets the stencil operation to use when stencil passes
     * @param operation defines the stencil operation to use when stencil passes
     */ setStencilOperationPass(operation) {
        this._stencilOpStencilDepthPass = operation;
        this.applyStencil();
    }
    /**
     * Sets the current stencil mask
     * @param mask defines the new stencil mask to use
     */ setStencilMask(mask) {
        this._stencilMask = mask;
        this.applyStencil();
    }
    /**
     * Sets the current stencil function
     * @param stencilFunc defines the new stencil function to use
     */ setStencilFunction(stencilFunc) {
        this._stencilFunc = stencilFunc;
        this.applyStencil();
    }
    /**
     * Sets the current stencil reference
     * @param reference defines the new stencil reference to use
     */ setStencilFunctionReference(reference) {
        this._stencilFuncRef = reference;
        this.applyStencil();
    }
    /**
     * Sets the current stencil mask
     * @param mask defines the new stencil mask to use
     */ setStencilFunctionMask(mask) {
        this._stencilFuncMask = mask;
    }
    /**
     * Sets the stencil operation to use when stencil fails
     * @param operation defines the stencil operation to use when stencil fails
     */ setStencilOperationFail(operation) {
        this._stencilOpStencilFail = operation;
        this.applyStencil();
    }
    /**
     * Sets the stencil operation to use when depth fails
     * @param operation defines the stencil operation to use when depth fails
     */ setStencilOperationDepthFail(operation) {
        this._stencilOpDepthFail = operation;
        this.applyStencil();
    }
    /**
     * Gets the current stencil mask
     * @returns a number defining the new stencil mask to use
     */ getStencilMask() {
        return this._stencilMask;
    }
    /**
     * Gets the current stencil function
     * @returns a number defining the stencil function to use
     */ getStencilFunction() {
        return this._stencilFunc;
    }
    /**
     * Gets the current stencil reference value
     * @returns a number defining the stencil reference value to use
     */ getStencilFunctionReference() {
        return this._stencilFuncRef;
    }
    /**
     * Gets the current stencil mask
     * @returns a number defining the stencil mask to use
     */ getStencilFunctionMask() {
        return this._stencilFuncMask;
    }
    /**
     * Gets the current stencil operation when stencil fails
     * @returns a number defining stencil operation to use when stencil fails
     */ getStencilOperationFail() {
        return this._stencilOpStencilFail;
    }
    /**
     * Gets the current stencil operation when depth fails
     * @returns a number defining stencil operation to use when depth fails
     */ getStencilOperationDepthFail() {
        return this._stencilOpDepthFail;
    }
    /**
     * Sets alpha constants used by some alpha blending modes
     * @param r defines the red component
     * @param g defines the green component
     * @param b defines the blue component
     * @param a defines the alpha component
     */ setAlphaConstants(r, g, b, a) {
        throw new Error("Setting alpha blend constant color not yet implemented.");
    }
    /**
     * Sets the current alpha mode
     * @param mode defines the mode to use (one of the BABYLON.undefined)
     * @param noDepthWriteChange defines if depth writing state should remains unchanged (false by default)
     * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/advanced/transparent_rendering
     */ setAlphaMode(mode, noDepthWriteChange = false) {
        if (this._alphaMode === mode) return;
        const nativeMode = (0, $iYZjK.getNativeAlphaMode)(mode);
        this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_SETBLENDMODE);
        this._commandBufferEncoder.encodeCommandArgAsUInt32(nativeMode);
        this._commandBufferEncoder.finishEncodingCommand();
        if (!noDepthWriteChange) this.setDepthWrite(mode === 0);
        this._alphaMode = mode;
    }
    /**
     * Gets the current alpha mode
     * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/advanced/transparent_rendering
     * @returns the current alpha mode
     */ getAlphaMode() {
        return this._alphaMode;
    }
    setInt(uniform, int) {
        if (!uniform) return false;
        this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_SETINT);
        this._commandBufferEncoder.encodeCommandArgAsNativeData(uniform);
        this._commandBufferEncoder.encodeCommandArgAsInt32(int);
        this._commandBufferEncoder.finishEncodingCommand();
        return true;
    }
    setIntArray(uniform, array) {
        if (!uniform) return false;
        this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_SETINTARRAY);
        this._commandBufferEncoder.encodeCommandArgAsNativeData(uniform);
        this._commandBufferEncoder.encodeCommandArgAsInt32s(array);
        this._commandBufferEncoder.finishEncodingCommand();
        return true;
    }
    setIntArray2(uniform, array) {
        if (!uniform) return false;
        this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_SETINTARRAY2);
        this._commandBufferEncoder.encodeCommandArgAsNativeData(uniform);
        this._commandBufferEncoder.encodeCommandArgAsInt32s(array);
        this._commandBufferEncoder.finishEncodingCommand();
        return true;
    }
    setIntArray3(uniform, array) {
        if (!uniform) return false;
        this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_SETINTARRAY3);
        this._commandBufferEncoder.encodeCommandArgAsNativeData(uniform);
        this._commandBufferEncoder.encodeCommandArgAsInt32s(array);
        this._commandBufferEncoder.finishEncodingCommand();
        return true;
    }
    setIntArray4(uniform, array) {
        if (!uniform) return false;
        this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_SETINTARRAY4);
        this._commandBufferEncoder.encodeCommandArgAsNativeData(uniform);
        this._commandBufferEncoder.encodeCommandArgAsInt32s(array);
        this._commandBufferEncoder.finishEncodingCommand();
        return true;
    }
    setFloatArray(uniform, array) {
        if (!uniform) return false;
        this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_SETFLOATARRAY);
        this._commandBufferEncoder.encodeCommandArgAsNativeData(uniform);
        this._commandBufferEncoder.encodeCommandArgAsFloat32s(array);
        this._commandBufferEncoder.finishEncodingCommand();
        return true;
    }
    setFloatArray2(uniform, array) {
        if (!uniform) return false;
        this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_SETFLOATARRAY2);
        this._commandBufferEncoder.encodeCommandArgAsNativeData(uniform);
        this._commandBufferEncoder.encodeCommandArgAsFloat32s(array);
        this._commandBufferEncoder.finishEncodingCommand();
        return true;
    }
    setFloatArray3(uniform, array) {
        if (!uniform) return false;
        this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_SETFLOATARRAY3);
        this._commandBufferEncoder.encodeCommandArgAsNativeData(uniform);
        this._commandBufferEncoder.encodeCommandArgAsFloat32s(array);
        this._commandBufferEncoder.finishEncodingCommand();
        return true;
    }
    setFloatArray4(uniform, array) {
        if (!uniform) return false;
        this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_SETFLOATARRAY4);
        this._commandBufferEncoder.encodeCommandArgAsNativeData(uniform);
        this._commandBufferEncoder.encodeCommandArgAsFloat32s(array);
        this._commandBufferEncoder.finishEncodingCommand();
        return true;
    }
    setArray(uniform, array) {
        if (!uniform) return false;
        return this.setFloatArray(uniform, new Float32Array(array));
    }
    setArray2(uniform, array) {
        if (!uniform) return false;
        return this.setFloatArray2(uniform, new Float32Array(array));
    }
    setArray3(uniform, array) {
        if (!uniform) return false;
        return this.setFloatArray3(uniform, new Float32Array(array));
    }
    setArray4(uniform, array) {
        if (!uniform) return false;
        return this.setFloatArray4(uniform, new Float32Array(array));
    }
    setMatrices(uniform, matrices) {
        if (!uniform) return false;
        this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_SETMATRICES);
        this._commandBufferEncoder.encodeCommandArgAsNativeData(uniform);
        this._commandBufferEncoder.encodeCommandArgAsFloat32s(matrices);
        this._commandBufferEncoder.finishEncodingCommand();
        return true;
    }
    setMatrix3x3(uniform, matrix) {
        if (!uniform) return false;
        this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_SETMATRIX3X3);
        this._commandBufferEncoder.encodeCommandArgAsNativeData(uniform);
        this._commandBufferEncoder.encodeCommandArgAsFloat32s(matrix);
        this._commandBufferEncoder.finishEncodingCommand();
        return true;
    }
    setMatrix2x2(uniform, matrix) {
        if (!uniform) return false;
        this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_SETMATRIX2X2);
        this._commandBufferEncoder.encodeCommandArgAsNativeData(uniform);
        this._commandBufferEncoder.encodeCommandArgAsFloat32s(matrix);
        this._commandBufferEncoder.finishEncodingCommand();
        return true;
    }
    setFloat(uniform, value) {
        if (!uniform) return false;
        this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_SETFLOAT);
        this._commandBufferEncoder.encodeCommandArgAsNativeData(uniform);
        this._commandBufferEncoder.encodeCommandArgAsFloat32(value);
        this._commandBufferEncoder.finishEncodingCommand();
        return true;
    }
    setFloat2(uniform, x, y) {
        if (!uniform) return false;
        this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_SETFLOAT2);
        this._commandBufferEncoder.encodeCommandArgAsNativeData(uniform);
        this._commandBufferEncoder.encodeCommandArgAsFloat32(x);
        this._commandBufferEncoder.encodeCommandArgAsFloat32(y);
        this._commandBufferEncoder.finishEncodingCommand();
        return true;
    }
    setFloat3(uniform, x, y, z) {
        if (!uniform) return false;
        this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_SETFLOAT3);
        this._commandBufferEncoder.encodeCommandArgAsNativeData(uniform);
        this._commandBufferEncoder.encodeCommandArgAsFloat32(x);
        this._commandBufferEncoder.encodeCommandArgAsFloat32(y);
        this._commandBufferEncoder.encodeCommandArgAsFloat32(z);
        this._commandBufferEncoder.finishEncodingCommand();
        return true;
    }
    setFloat4(uniform, x, y, z, w) {
        if (!uniform) return false;
        this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_SETFLOAT4);
        this._commandBufferEncoder.encodeCommandArgAsNativeData(uniform);
        this._commandBufferEncoder.encodeCommandArgAsFloat32(x);
        this._commandBufferEncoder.encodeCommandArgAsFloat32(y);
        this._commandBufferEncoder.encodeCommandArgAsFloat32(z);
        this._commandBufferEncoder.encodeCommandArgAsFloat32(w);
        this._commandBufferEncoder.finishEncodingCommand();
        return true;
    }
    setColor3(uniform, color3) {
        if (!uniform) return false;
        this.setFloat3(uniform, color3.r, color3.g, color3.b);
        return true;
    }
    setColor4(uniform, color3, alpha) {
        if (!uniform) return false;
        this.setFloat4(uniform, color3.r, color3.g, color3.b, alpha);
        return true;
    }
    wipeCaches(bruteForce) {
        if (this.preventCacheWipeBetweenFrames) return;
        this.resetTextureCache();
        this._currentEffect = null;
        if (bruteForce) {
            this._currentProgram = null;
            this._stencilStateComposer.reset();
            this._depthCullingState.reset();
            this._alphaState.reset();
        }
        this._cachedVertexBuffers = null;
        this._cachedIndexBuffer = null;
        this._cachedEffectForVertexBuffers = null;
    }
    _createTexture() {
        return this._engine.createTexture();
    }
    _deleteTexture(texture) {
        if (texture) this._engine.deleteTexture(texture);
    }
    /**
     * Update the content of a dynamic texture
     * @param texture defines the texture to update
     * @param canvas defines the canvas containing the source
     * @param invertY defines if data must be stored with Y axis inverted
     * @param premulAlpha defines if alpha is stored as premultiplied
     * @param format defines the format of the data
     */ updateDynamicTexture(texture, canvas, invertY, premulAlpha = false, format) {
        if (premulAlpha === void 0) premulAlpha = false;
        if (!!texture && !!texture._hardwareTexture) {
            const source = canvas.getCanvasTexture();
            const destination = texture._hardwareTexture.underlyingResource;
            this._engine.copyTexture(destination, source);
            texture.isReady = true;
        }
    }
    createDynamicTexture(width, height, generateMipMaps, samplingMode) {
        // it's not possible to create 0x0 texture sized. Many bgfx methods assume texture size is at least 1x1(best case).
        // Worst case is getting a crash/assert.
        width = Math.max(width, 1);
        height = Math.max(height, 1);
        return this.createRawTexture(new Uint8Array(width * height * 4), width, height, 5, false, false, samplingMode);
    }
    createVideoElement(constraints) {
        // create native object depending on stream. Only NativeCamera is supported for now.
        if (this._camera) return this._camera.createVideo(constraints);
        return null;
    }
    updateVideoTexture(texture, video, invertY) {
        if (texture && texture._hardwareTexture && this._camera) {
            const webGLTexture = texture._hardwareTexture.underlyingResource;
            this._camera.updateVideoTexture(webGLTexture, video, invertY);
        }
    }
    createRawTexture(data, width, height, format, generateMipMaps, invertY, samplingMode, compression = null, type = 0, creationFlags = 0, useSRGBBuffer = false) {
        const texture = new (0, $b9e4a.InternalTexture)(this, (0, $b9e4a.InternalTextureSource).Raw);
        texture.format = format;
        texture.generateMipMaps = generateMipMaps;
        texture.samplingMode = samplingMode;
        texture.invertY = invertY;
        texture.baseWidth = width;
        texture.baseHeight = height;
        texture.width = texture.baseWidth;
        texture.height = texture.baseHeight;
        texture._compression = compression;
        texture.type = type;
        texture._useSRGBBuffer = this._getUseSRGBBuffer(useSRGBBuffer, !generateMipMaps);
        this.updateRawTexture(texture, data, format, invertY, compression, type, texture._useSRGBBuffer);
        if (texture._hardwareTexture) {
            const webGLTexture = texture._hardwareTexture.underlyingResource;
            const filter = (0, $iYZjK.getNativeSamplingMode)(samplingMode);
            this._setTextureSampling(webGLTexture, filter);
        }
        this._internalTexturesCache.push(texture);
        return texture;
    }
    createRawTexture2DArray(data, width, height, depth, format, generateMipMaps, invertY, samplingMode, compression = null, textureType = 0) {
        const texture = new (0, $b9e4a.InternalTexture)(this, (0, $b9e4a.InternalTextureSource).Raw2DArray);
        texture.baseWidth = width;
        texture.baseHeight = height;
        texture.baseDepth = depth;
        texture.width = width;
        texture.height = height;
        texture.depth = depth;
        texture.format = format;
        texture.type = textureType;
        texture.generateMipMaps = generateMipMaps;
        texture.samplingMode = samplingMode;
        texture.is2DArray = true;
        if (texture._hardwareTexture) {
            const nativeTexture = texture._hardwareTexture.underlyingResource;
            this._engine.loadRawTexture2DArray(nativeTexture, data, width, height, depth, (0, $iYZjK.getNativeTextureFormat)(format, textureType), generateMipMaps, invertY);
            const filter = (0, $iYZjK.getNativeSamplingMode)(samplingMode);
            this._setTextureSampling(nativeTexture, filter);
        }
        texture.isReady = true;
        this._internalTexturesCache.push(texture);
        return texture;
    }
    updateRawTexture(texture, bufferView, format, invertY, compression = null, type = 0, useSRGBBuffer = false) {
        if (!texture) return;
        if (bufferView && texture._hardwareTexture) {
            const underlyingResource = texture._hardwareTexture.underlyingResource;
            this._engine.loadRawTexture(underlyingResource, bufferView, texture.width, texture.height, (0, $iYZjK.getNativeTextureFormat)(format, type), texture.generateMipMaps, texture.invertY);
        }
        texture.isReady = true;
    }
    // TODO: Refactor to share more logic with babylon.engine.ts version.
    /**
     * Usually called from Texture.ts.
     * Passed information to create a NativeTexture
     * @param url defines a value which contains one of the following:
     * * A conventional http URL, e.g. 'http://...' or 'file://...'
     * * A base64 string of in-line texture data, e.g. 'data:image/jpg;base64,/...'
     * * An indicator that data being passed using the buffer parameter, e.g. 'data:mytexture.jpg'
     * @param noMipmap defines a boolean indicating that no mipmaps shall be generated.  Ignored for compressed textures.  They must be in the file
     * @param invertY when true, image is flipped when loaded.  You probably want true. Certain compressed textures may invert this if their default is inverted (eg. ktx)
     * @param scene needed for loading to the correct scene
     * @param samplingMode mode with should be used sample / access the texture (Default: Texture.TRILINEAR_SAMPLINGMODE)
     * @param onLoad optional callback to be called upon successful completion
     * @param onError optional callback to be called upon failure
     * @param buffer a source of a file previously fetched as either a base64 string, an ArrayBuffer (compressed or image format), HTMLImageElement (image format), or a Blob
     * @param fallback an internal argument in case the function must be called again, due to etc1 not having alpha capabilities
     * @param format internal format.  Default: RGB when extension is '.jpg' else RGBA.  Ignored for compressed textures
     * @param forcedExtension defines the extension to use to pick the right loader
     * @param mimeType defines an optional mime type
     * @param loaderOptions options to be passed to the loader
     * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
     * @param useSRGBBuffer defines if the texture must be loaded in a sRGB GPU buffer (if supported by the GPU).
     * @returns a InternalTexture for assignment back into BABYLON.Texture
     */ createTexture(url, noMipmap, invertY, scene, samplingMode = 3, onLoad = null, onError = null, buffer = null, fallback = null, format = null, forcedExtension = null, mimeType, loaderOptions, creationFlags, useSRGBBuffer = false) {
        url = url || "";
        const fromData = url.substr(0, 5) === "data:";
        //const fromBlob = url.substr(0, 5) === "blob:";
        const isBase64 = fromData && url.indexOf(";base64,") !== -1;
        const texture = fallback ? fallback : new (0, $b9e4a.InternalTexture)(this, (0, $b9e4a.InternalTextureSource).Url);
        const originalUrl = url;
        if (this._transformTextureUrl && !isBase64 && !fallback && !buffer) url = this._transformTextureUrl(url);
        // establish the file extension, if possible
        const lastDot = url.lastIndexOf(".");
        const extension = forcedExtension ? forcedExtension : lastDot > -1 ? url.substring(lastDot).toLowerCase() : "";
        let loader = null;
        for (const availableLoader of (0, $5YkyR.Engine)._TextureLoaders)if (availableLoader.canLoad(extension)) {
            loader = availableLoader;
            break;
        }
        if (scene) scene.addPendingData(texture);
        texture.url = url;
        texture.generateMipMaps = !noMipmap;
        texture.samplingMode = samplingMode;
        texture.invertY = invertY;
        texture._useSRGBBuffer = this._getUseSRGBBuffer(useSRGBBuffer, noMipmap);
        if (!this.doNotHandleContextLost) // Keep a link to the buffer only if we plan to handle context lost
        texture._buffer = buffer;
        let onLoadObserver = null;
        if (onLoad && !fallback) onLoadObserver = texture.onLoadedObservable.add(onLoad);
        if (!fallback) this._internalTexturesCache.push(texture);
        const onInternalError = (message, exception)=>{
            if (scene) scene.removePendingData(texture);
            if (url === originalUrl) {
                if (onLoadObserver) texture.onLoadedObservable.remove(onLoadObserver);
                if ((0, $ejQPp.EngineStore).UseFallbackTexture) this.createTexture((0, $ejQPp.EngineStore).FallbackTexture, noMipmap, texture.invertY, scene, samplingMode, null, onError, buffer, texture);
                if (onError) onError((message || "Unknown error") + ((0, $ejQPp.EngineStore).UseFallbackTexture ? " - Fallback texture was used" : ""), exception);
            } else {
                // fall back to the original url if the transformed url fails to load
                (0, $kVtWi.Logger).Warn(`Failed to load ${url}, falling back to ${originalUrl}`);
                this.createTexture(originalUrl, noMipmap, texture.invertY, scene, samplingMode, onLoad, onError, buffer, texture, format, forcedExtension, mimeType, loaderOptions);
            }
        };
        // processing for non-image formats
        if (loader) throw new Error("Loading textures from IInternalTextureLoader not yet implemented.");
        else {
            const onload = (data)=>{
                if (!texture._hardwareTexture) {
                    if (scene) scene.removePendingData(texture);
                    return;
                }
                const underlyingResource = texture._hardwareTexture.underlyingResource;
                this._engine.loadTexture(underlyingResource, data, !noMipmap, invertY, texture._useSRGBBuffer, ()=>{
                    texture.baseWidth = this._engine.getTextureWidth(underlyingResource);
                    texture.baseHeight = this._engine.getTextureHeight(underlyingResource);
                    texture.width = texture.baseWidth;
                    texture.height = texture.baseHeight;
                    texture.isReady = true;
                    const filter = (0, $iYZjK.getNativeSamplingMode)(samplingMode);
                    this._setTextureSampling(underlyingResource, filter);
                    if (scene) scene.removePendingData(texture);
                    texture.onLoadedObservable.notifyObservers(texture);
                    texture.onLoadedObservable.clear();
                }, ()=>{
                    throw new Error("Could not load a native texture.");
                });
            };
            if (fromData && buffer) {
                if (buffer instanceof ArrayBuffer) onload(new Uint8Array(buffer));
                else if (ArrayBuffer.isView(buffer)) onload(buffer);
                else if (typeof buffer === "string") onload(new Uint8Array((0, $bOhSV.Tools).DecodeBase64(buffer)));
                else throw new Error("Unsupported buffer type");
            } else if (isBase64) onload(new Uint8Array((0, $bOhSV.Tools).DecodeBase64(url)));
            else this._loadFile(url, (data)=>onload(new Uint8Array(data)), undefined, undefined, true, (request, exception)=>{
                onInternalError("Unable to load " + (request ? request.responseURL : url, exception));
            });
        }
        return texture;
    }
    /**
     * Wraps an external native texture in a Babylon texture.
     * @param texture defines the external texture
     * @param hasMipMaps defines whether the external texture has mip maps
     * @param samplingMode defines the sampling mode for the external texture (default: 3)
     * @returns the babylon internal texture
     */ wrapNativeTexture(texture, hasMipMaps = false, samplingMode = 3) {
        const hardwareTexture = new (0, $336js.NativeHardwareTexture)(texture, this._engine);
        const internalTexture = new (0, $b9e4a.InternalTexture)(this, (0, $b9e4a.InternalTextureSource).Unknown, true);
        internalTexture._hardwareTexture = hardwareTexture;
        internalTexture.baseWidth = this._engine.getTextureWidth(texture);
        internalTexture.baseHeight = this._engine.getTextureHeight(texture);
        internalTexture.width = internalTexture.baseWidth;
        internalTexture.height = internalTexture.baseHeight;
        internalTexture.isReady = true;
        internalTexture.useMipMaps = hasMipMaps;
        this.updateTextureSamplingMode(samplingMode, internalTexture);
        return internalTexture;
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Wraps an external web gl texture in a Babylon texture.
     * @returns the babylon internal texture
     */ wrapWebGLTexture() {
        throw new Error("wrapWebGLTexture is not supported, use wrapNativeTexture instead.");
    }
    _createDepthStencilTexture(size, options, rtWrapper) {
        // TODO: handle other options?
        const generateStencil = options.generateStencil || false;
        const samples = options.samples || 1;
        const nativeRTWrapper = rtWrapper;
        const texture = new (0, $b9e4a.InternalTexture)(this, (0, $b9e4a.InternalTextureSource).DepthStencil);
        const width = size.width ?? size;
        const height = size.height ?? size;
        const framebuffer = this._engine.createFrameBuffer(texture._hardwareTexture.underlyingResource, width, height, generateStencil, true, samples);
        nativeRTWrapper._framebufferDepthStencil = framebuffer;
        return texture;
    }
    /**
     * @internal
     */ _releaseFramebufferObjects(framebuffer) {
        if (framebuffer) {
            this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_DELETEFRAMEBUFFER);
            this._commandBufferEncoder.encodeCommandArgAsNativeData(framebuffer);
            this._commandBufferEncoder.finishEncodingCommand();
        }
    }
    /**
     * @internal Engine abstraction for loading and creating an image bitmap from a given source string.
     * @param imageSource source to load the image from.
     * @param options An object that sets options for the image's extraction.
     * @returns ImageBitmap
     */ _createImageBitmapFromSource(imageSource, options) {
        const promise = new Promise((resolve, reject)=>{
            const image = this.createCanvasImage();
            image.onload = ()=>{
                try {
                    const imageBitmap = this._engine.createImageBitmap(image);
                    resolve(imageBitmap);
                } catch (error) {
                    reject(`Error loading image ${image.src} with exception: ${error}`);
                }
            };
            image.onerror = (error)=>{
                reject(`Error loading image ${image.src} with exception: ${error}`);
            };
            image.src = imageSource;
        });
        return promise;
    }
    /**
     * Engine abstraction for createImageBitmap
     * @param image source for image
     * @param options An object that sets options for the image's extraction.
     * @returns ImageBitmap
     */ createImageBitmap(image, options) {
        return new Promise((resolve, reject)=>{
            if (Array.isArray(image)) {
                const arr = image;
                if (arr.length) {
                    const image = this._engine.createImageBitmap(arr[0]);
                    if (image) {
                        resolve(image);
                        return;
                    }
                }
            }
            reject(`Unsupported data for createImageBitmap.`);
        });
    }
    /**
     * Resize an image and returns the image data as an uint8array
     * @param image image to resize
     * @param bufferWidth destination buffer width
     * @param bufferHeight destination buffer height
     * @returns an uint8array containing RGBA values of bufferWidth * bufferHeight size
     */ resizeImageBitmap(image, bufferWidth, bufferHeight) {
        return this._engine.resizeImageBitmap(image, bufferWidth, bufferHeight);
    }
    /**
     * Creates a cube texture
     * @param rootUrl defines the url where the files to load is located
     * @param scene defines the current scene
     * @param files defines the list of files to load (1 per face)
     * @param noMipmap defines a boolean indicating that no mipmaps shall be generated (false by default)
     * @param onLoad defines an optional callback raised when the texture is loaded
     * @param onError defines an optional callback raised if there is an issue to load the texture
     * @param format defines the format of the data
     * @param forcedExtension defines the extension to use to pick the right loader
     * @param createPolynomials if a polynomial sphere should be created for the cube texture
     * @param lodScale defines the scale applied to environment texture. This manages the range of LOD level used for IBL according to the roughness
     * @param lodOffset defines the offset applied to environment texture. This manages first LOD level used for IBL according to the roughness
     * @param fallback defines texture to use while falling back when (compressed) texture file not found.
     * @param loaderOptions options to be passed to the loader
     * @param useSRGBBuffer defines if the texture must be loaded in a sRGB GPU buffer (if supported by the GPU).
     * @returns the cube texture as an InternalTexture
     */ createCubeTexture(rootUrl, scene, files, noMipmap, onLoad = null, onError = null, format, forcedExtension = null, createPolynomials = false, lodScale = 0, lodOffset = 0, fallback = null, loaderOptions, useSRGBBuffer = false) {
        const texture = fallback ? fallback : new (0, $b9e4a.InternalTexture)(this, (0, $b9e4a.InternalTextureSource).Cube);
        texture.isCube = true;
        texture.url = rootUrl;
        texture.generateMipMaps = !noMipmap;
        texture._lodGenerationScale = lodScale;
        texture._lodGenerationOffset = lodOffset;
        texture._useSRGBBuffer = this._getUseSRGBBuffer(useSRGBBuffer, !!noMipmap);
        if (!this._doNotHandleContextLost) {
            texture._extension = forcedExtension;
            texture._files = files;
        }
        const lastDot = rootUrl.lastIndexOf(".");
        const extension = forcedExtension ? forcedExtension : lastDot > -1 ? rootUrl.substring(lastDot).toLowerCase() : "";
        // TODO: use texture loader to load env files?
        if (extension === ".env") {
            const onloaddata = (data)=>{
                const info = (0, $6XNeg.GetEnvInfo)(data);
                texture.width = info.width;
                texture.height = info.width;
                (0, $6XNeg.UploadEnvSpherical)(texture, info);
                const specularInfo = info.specular;
                if (!specularInfo) throw new Error(`Nothing else parsed so far`);
                texture._lodGenerationScale = specularInfo.lodGenerationScale;
                const imageData = (0, $6XNeg.CreateImageDataArrayBufferViews)(data, info);
                texture.format = 5;
                texture.type = 0;
                texture.generateMipMaps = true;
                texture.getEngine().updateTextureSamplingMode((0, $j2mX5.Texture).TRILINEAR_SAMPLINGMODE, texture);
                texture._isRGBD = true;
                texture.invertY = true;
                this._engine.loadCubeTextureWithMips(texture._hardwareTexture.underlyingResource, imageData, false, texture._useSRGBBuffer, ()=>{
                    texture.isReady = true;
                    if (onLoad) onLoad();
                }, ()=>{
                    throw new Error("Could not load a native cube texture.");
                });
            };
            if (files && files.length === 6) throw new Error(`Multi-file loading not allowed on env files.`);
            else {
                const onInternalError = (request, exception)=>{
                    if (onError && request) onError(request.status + " " + request.statusText, exception);
                };
                this._loadFile(rootUrl, (data)=>{
                    onloaddata(new Uint8Array(data, 0, data.byteLength));
                }, undefined, undefined, true, onInternalError);
            }
        } else {
            if (!files || files.length !== 6) throw new Error("Cannot load cubemap because 6 files were not defined");
            // Reorder from [+X, +Y, +Z, -X, -Y, -Z] to [+X, -X, +Y, -Y, +Z, -Z].
            const reorderedFiles = [
                files[0],
                files[3],
                files[1],
                files[4],
                files[2],
                files[5]
            ];
            Promise.all(reorderedFiles.map((file)=>this._loadFileAsync(file, undefined, true).then((data)=>new Uint8Array(data, 0, data.byteLength)))).then((data)=>{
                return new Promise((resolve, reject)=>{
                    this._engine.loadCubeTexture(texture._hardwareTexture.underlyingResource, data, !noMipmap, true, texture._useSRGBBuffer, resolve, reject);
                });
            }).then(()=>{
                texture.isReady = true;
                if (onLoad) onLoad();
            }, (error)=>{
                if (onError) onError(`Failed to load cubemap: ${error.message}`, error);
            });
        }
        this._internalTexturesCache.push(texture);
        return texture;
    }
    /** @internal */ _createHardwareTexture() {
        return new (0, $336js.NativeHardwareTexture)(this._createTexture(), this._engine);
    }
    /** @internal */ _createHardwareRenderTargetWrapper(isMulti, isCube, size) {
        const rtWrapper = new (0, $1M3z8.NativeRenderTargetWrapper)(isMulti, isCube, size, this);
        this._renderTargetWrapperCache.push(rtWrapper);
        return rtWrapper;
    }
    /** @internal */ _createInternalTexture(size, options, _delayGPUTextureCreation = true, source = (0, $b9e4a.InternalTextureSource).Unknown) {
        let generateMipMaps = false;
        let type = 0;
        let samplingMode = 3;
        let format = 5;
        let useSRGBBuffer = false;
        let samples = 1;
        let label;
        if (options !== undefined && typeof options === "object") {
            generateMipMaps = !!options.generateMipMaps;
            type = options.type === undefined ? 0 : options.type;
            samplingMode = options.samplingMode === undefined ? 3 : options.samplingMode;
            format = options.format === undefined ? 5 : options.format;
            useSRGBBuffer = options.useSRGBBuffer === undefined ? false : options.useSRGBBuffer;
            samples = options.samples ?? 1;
            label = options.label;
        } else generateMipMaps = !!options;
        useSRGBBuffer = this._getUseSRGBBuffer(useSRGBBuffer, !generateMipMaps);
        if (type === 1 && !this._caps.textureFloatLinearFiltering) // if floating point linear (gl.FLOAT) then force to NEAREST_SAMPLINGMODE
        samplingMode = 1;
        else if (type === 2 && !this._caps.textureHalfFloatLinearFiltering) // if floating point linear (HALF_FLOAT) then force to NEAREST_SAMPLINGMODE
        samplingMode = 1;
        if (type === 1 && !this._caps.textureFloat) {
            type = 0;
            (0, $kVtWi.Logger).Warn("Float textures are not supported. Type forced to TEXTURETYPE_UNSIGNED_BYTE");
        }
        const texture = new (0, $b9e4a.InternalTexture)(this, source);
        const width = size.width ?? size;
        const height = size.height ?? size;
        const layers = size.layers || 0;
        if (layers !== 0) throw new Error("Texture layers are not supported in Babylon Native");
        const nativeTexture = texture._hardwareTexture.underlyingResource;
        const nativeTextureFormat = (0, $iYZjK.getNativeTextureFormat)(format, type);
        // REVIEW: We are always setting the renderTarget flag as we don't know whether the texture will be used as a render target.
        this._engine.initializeTexture(nativeTexture, width, height, generateMipMaps, nativeTextureFormat, true, useSRGBBuffer, samples);
        this._setTextureSampling(nativeTexture, (0, $iYZjK.getNativeSamplingMode)(samplingMode));
        texture._useSRGBBuffer = useSRGBBuffer;
        texture.baseWidth = width;
        texture.baseHeight = height;
        texture.width = width;
        texture.height = height;
        texture.depth = layers;
        texture.isReady = true;
        texture.samples = samples;
        texture.generateMipMaps = generateMipMaps;
        texture.samplingMode = samplingMode;
        texture.type = type;
        texture.format = format;
        texture.label = label;
        this._internalTexturesCache.push(texture);
        return texture;
    }
    createRenderTargetTexture(size, options) {
        const rtWrapper = this._createHardwareRenderTargetWrapper(false, false, size);
        let generateDepthBuffer = true;
        let generateStencilBuffer = false;
        let noColorAttachment = false;
        let colorAttachment = undefined;
        let samples = 1;
        if (options !== undefined && typeof options === "object") {
            generateDepthBuffer = options.generateDepthBuffer ?? true;
            generateStencilBuffer = !!options.generateStencilBuffer;
            noColorAttachment = !!options.noColorAttachment;
            colorAttachment = options.colorAttachment;
            samples = options.samples ?? 1;
        }
        const texture = colorAttachment || (noColorAttachment ? null : this._createInternalTexture(size, options, true, (0, $b9e4a.InternalTextureSource).RenderTarget));
        const width = size.width ?? size;
        const height = size.height ?? size;
        const framebuffer = this._engine.createFrameBuffer(texture ? texture._hardwareTexture.underlyingResource : null, width, height, generateStencilBuffer, generateDepthBuffer, samples);
        rtWrapper._framebuffer = framebuffer;
        rtWrapper._generateDepthBuffer = generateDepthBuffer;
        rtWrapper._generateStencilBuffer = generateStencilBuffer;
        rtWrapper._samples = samples;
        rtWrapper.setTextures(texture);
        return rtWrapper;
    }
    updateRenderTargetTextureSampleCount(rtWrapper, samples) {
        (0, $kVtWi.Logger).Warn("Updating render target sample count is not currently supported");
        return rtWrapper.samples;
    }
    updateTextureSamplingMode(samplingMode, texture) {
        if (texture._hardwareTexture) {
            const filter = (0, $iYZjK.getNativeSamplingMode)(samplingMode);
            this._setTextureSampling(texture._hardwareTexture.underlyingResource, filter);
        }
        texture.samplingMode = samplingMode;
    }
    bindFramebuffer(texture, faceIndex, requiredWidth, requiredHeight, forceFullscreenViewport) {
        const nativeRTWrapper = texture;
        if (this._currentRenderTarget) this.unBindFramebuffer(this._currentRenderTarget);
        this._currentRenderTarget = texture;
        if (faceIndex) throw new Error("Cuboid frame buffers are not yet supported in NativeEngine.");
        if (requiredWidth || requiredHeight) throw new Error("Required width/height for frame buffers not yet supported in NativeEngine.");
        forceFullscreenViewport;
        if (nativeRTWrapper._framebufferDepthStencil) this._bindUnboundFramebuffer(nativeRTWrapper._framebufferDepthStencil);
        else this._bindUnboundFramebuffer(nativeRTWrapper._framebuffer);
    }
    unBindFramebuffer(texture, disableGenerateMipMaps = false, onBeforeUnbind) {
        // NOTE: Disabling mipmap generation is not yet supported in NativeEngine.
        this._currentRenderTarget = null;
        if (onBeforeUnbind) onBeforeUnbind();
        this._bindUnboundFramebuffer(null);
    }
    createDynamicVertexBuffer(data) {
        return this.createVertexBuffer(data, true);
    }
    updateDynamicIndexBuffer(indexBuffer, indices, offset = 0) {
        const buffer = indexBuffer;
        const data = this._normalizeIndexData(indices);
        buffer.is32Bits = data.BYTES_PER_ELEMENT === 4;
        this._engine.updateDynamicIndexBuffer(buffer.nativeIndexBuffer, data.buffer, data.byteOffset, data.byteLength, offset);
    }
    updateDynamicVertexBuffer(vertexBuffer, data, byteOffset = 0, byteLength) {
        const buffer = vertexBuffer;
        const dataView = data instanceof Array ? new Float32Array(data) : data instanceof ArrayBuffer ? new Uint8Array(data) : data;
        const byteView = new Uint8Array(dataView.buffer, dataView.byteOffset, byteLength ?? dataView.byteLength);
        this._engine.updateDynamicVertexBuffer(buffer.nativeVertexBuffer, byteView.buffer, byteView.byteOffset, byteView.byteLength, byteOffset);
    }
    // TODO: Refactor to share more logic with base Engine implementation.
    _setTexture(channel, texture, isPartOfTextureArray = false, depthStencilTexture = false) {
        const uniform = this._boundUniforms[channel];
        if (!uniform) return false;
        // Not ready?
        if (!texture) {
            if (this._boundTexturesCache[channel] != null) {
                this._activeChannel = channel;
                this._boundTexturesCache[channel] = null;
            }
            return false;
        }
        // Video
        if (texture.video) {
            this._activeChannel = channel;
            texture.update();
        } else if (texture.delayLoadState === 4) {
            // Delay loading
            texture.delayLoad();
            return false;
        }
        let internalTexture;
        if (depthStencilTexture) internalTexture = texture.depthStencilTexture;
        else if (texture.isReady()) internalTexture = texture.getInternalTexture();
        else if (texture.isCube) internalTexture = this.emptyCubeTexture;
        else if (texture.is3D) internalTexture = this.emptyTexture3D;
        else if (texture.is2DArray) internalTexture = this.emptyTexture2DArray;
        else internalTexture = this.emptyTexture;
        this._activeChannel = channel;
        if (!internalTexture || !internalTexture._hardwareTexture) return false;
        this._setTextureWrapMode(internalTexture._hardwareTexture.underlyingResource, (0, $iYZjK.getNativeAddressMode)(texture.wrapU), (0, $iYZjK.getNativeAddressMode)(texture.wrapV), (0, $iYZjK.getNativeAddressMode)(texture.wrapR));
        this._updateAnisotropicLevel(texture);
        this._setTextureCore(uniform, internalTexture._hardwareTexture.underlyingResource);
        return true;
    }
    // filter is a NativeFilter.XXXX value.
    _setTextureSampling(texture, filter) {
        this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_SETTEXTURESAMPLING);
        this._commandBufferEncoder.encodeCommandArgAsNativeData(texture);
        this._commandBufferEncoder.encodeCommandArgAsUInt32(filter);
        this._commandBufferEncoder.finishEncodingCommand();
    }
    // addressModes are NativeAddressMode.XXXX values.
    _setTextureWrapMode(texture, addressModeU, addressModeV, addressModeW) {
        this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_SETTEXTUREWRAPMODE);
        this._commandBufferEncoder.encodeCommandArgAsNativeData(texture);
        this._commandBufferEncoder.encodeCommandArgAsUInt32(addressModeU);
        this._commandBufferEncoder.encodeCommandArgAsUInt32(addressModeV);
        this._commandBufferEncoder.encodeCommandArgAsUInt32(addressModeW);
        this._commandBufferEncoder.finishEncodingCommand();
    }
    _setTextureCore(uniform, texture) {
        this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_SETTEXTURE);
        this._commandBufferEncoder.encodeCommandArgAsNativeData(uniform);
        this._commandBufferEncoder.encodeCommandArgAsNativeData(texture);
        this._commandBufferEncoder.finishEncodingCommand();
    }
    // TODO: Share more of this logic with the base implementation.
    // TODO: Rename to match naming in base implementation once refactoring allows different parameters.
    _updateAnisotropicLevel(texture) {
        const internalTexture = texture.getInternalTexture();
        const value = texture.anisotropicFilteringLevel;
        if (!internalTexture || !internalTexture._hardwareTexture) return;
        if (internalTexture._cachedAnisotropicFilteringLevel !== value) {
            this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_SETTEXTUREANISOTROPICLEVEL);
            this._commandBufferEncoder.encodeCommandArgAsNativeData(internalTexture._hardwareTexture.underlyingResource);
            this._commandBufferEncoder.encodeCommandArgAsUInt32(value);
            this._commandBufferEncoder.finishEncodingCommand();
            internalTexture._cachedAnisotropicFilteringLevel = value;
        }
    }
    /**
     * @internal
     */ _bindTexture(channel, texture) {
        const uniform = this._boundUniforms[channel];
        if (!uniform) return;
        if (texture && texture._hardwareTexture) {
            const underlyingResource = texture._hardwareTexture.underlyingResource;
            this._setTextureCore(uniform, underlyingResource);
        }
    }
    _deleteBuffer(buffer) {
        if (buffer.nativeIndexBuffer) {
            this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_DELETEINDEXBUFFER);
            this._commandBufferEncoder.encodeCommandArgAsNativeData(buffer.nativeIndexBuffer);
            this._commandBufferEncoder.finishEncodingCommand();
            delete buffer.nativeIndexBuffer;
        }
        if (buffer.nativeVertexBuffer) {
            this._commandBufferEncoder.startEncodingCommand(_native.Engine.COMMAND_DELETEVERTEXBUFFER);
            this._commandBufferEncoder.encodeCommandArgAsNativeData(buffer.nativeVertexBuffer);
            this._commandBufferEncoder.finishEncodingCommand();
            delete buffer.nativeVertexBuffer;
        }
    }
    /**
     * Create a canvas
     * @param width width
     * @param height height
     * @returns ICanvas interface
     */ createCanvas(width, height) {
        if (!_native.Canvas) throw new Error("Native Canvas plugin not available.");
        const canvas = new _native.Canvas();
        canvas.width = width;
        canvas.height = height;
        return canvas;
    }
    /**
     * Create an image to use with canvas
     * @returns IImage interface
     */ createCanvasImage() {
        if (!_native.Canvas) throw new Error("Native Canvas plugin not available.");
        const image = new _native.Image();
        return image;
    }
    /**
     * Update a portion of an internal texture
     * @param texture defines the texture to update
     * @param imageData defines the data to store into the texture
     * @param xOffset defines the x coordinates of the update rectangle
     * @param yOffset defines the y coordinates of the update rectangle
     * @param width defines the width of the update rectangle
     * @param height defines the height of the update rectangle
     * @param faceIndex defines the face index if texture is a cube (0 by default)
     * @param lod defines the lod level to update (0 by default)
     * @param generateMipMaps defines whether to generate mipmaps or not
     */ updateTextureData(texture, imageData, xOffset, yOffset, width, height, faceIndex = 0, lod = 0, generateMipMaps = false) {
        throw new Error("updateTextureData not implemented.");
    }
    /**
     * @internal
     */ _uploadCompressedDataToTextureDirectly(texture, internalFormat, width, height, data, faceIndex = 0, lod = 0) {
        throw new Error("_uploadCompressedDataToTextureDirectly not implemented.");
    }
    /**
     * @internal
     */ _uploadDataToTextureDirectly(texture, imageData, faceIndex = 0, lod = 0) {
        throw new Error("_uploadDataToTextureDirectly not implemented.");
    }
    /**
     * @internal
     */ _uploadArrayBufferViewToTexture(texture, imageData, faceIndex = 0, lod = 0) {
        throw new Error("_uploadArrayBufferViewToTexture not implemented.");
    }
    /**
     * @internal
     */ _uploadImageToTexture(texture, image, faceIndex = 0, lod = 0) {
        throw new Error("_uploadArrayBufferViewToTexture not implemented.");
    }
    getFontOffset(font) {
        // TODO
        const result = {
            ascent: 0,
            height: 0,
            descent: 0
        };
        return result;
    }
    /**
     * No equivalent for native. Do nothing.
     */ flushFramebuffer() {}
    _readTexturePixels(texture, width, height, faceIndex, level, buffer, _flushRenderer, _noDataConversion, x, y) {
        if (faceIndex !== undefined && faceIndex !== -1) throw new Error(`Reading cubemap faces is not supported, but faceIndex is ${faceIndex}.`);
        return this._engine.readTexture(texture._hardwareTexture?.underlyingResource, level ?? 0, x ?? 0, y ?? 0, width, height, buffer?.buffer ?? null, buffer?.byteOffset ?? 0, buffer?.byteLength ?? 0).then((rawBuffer)=>{
            if (!buffer) buffer = new Uint8Array(rawBuffer);
            return buffer;
        });
    }
}
// This must match the protocol version in NativeEngine.cpp
$2a56600675bb9bbf$export$74c04c8441198a85.PROTOCOL_VERSION = 8;

});
parcelRegister("6XNeg", function(module, exports) {

$parcel$export(module.exports, "GetEnvInfo", () => $014ef14cf6d867c5$export$8b1a8c26c9fdce30);
$parcel$export(module.exports, "normalizeEnvInfo", () => $014ef14cf6d867c5$export$4bb07527dbffd5d);
$parcel$export(module.exports, "CreateEnvTextureAsync", () => $014ef14cf6d867c5$export$dfc045575bbc57ce);
$parcel$export(module.exports, "CreateImageDataArrayBufferViews", () => $014ef14cf6d867c5$export$54dfcd286e56f3ba);
$parcel$export(module.exports, "UploadEnvLevelsAsync", () => $014ef14cf6d867c5$export$83f80da9a5e7195a);
$parcel$export(module.exports, "UploadLevelsAsync", () => $014ef14cf6d867c5$export$e078c68575d7d919);
$parcel$export(module.exports, "UploadEnvSpherical", () => $014ef14cf6d867c5$export$972e1fd8b74c3586);
$parcel$export(module.exports, "_UpdateRGBDAsync", () => $014ef14cf6d867c5$export$6df31312d4ab470e);
$parcel$export(module.exports, "EnvironmentTextureTools", () => $014ef14cf6d867c5$export$75c1009fdcfc451f);

var $bOhSV = parcelRequire("bOhSV");

var $ha1VO = parcelRequire("ha1VO");

var $1VEEL = parcelRequire("1VEEL");

var $f3g09 = parcelRequire("f3g09");

var $b9e4a = parcelRequire("b9e4a");

var $akOl3 = parcelRequire("akOl3");

var $gmbCk = parcelRequire("gmbCk");

var $cFdBb = parcelRequire("cFdBb");

var $kVtWi = parcelRequire("kVtWi");

var $ezAJn = parcelRequire("ezAJn");
parcelRequire("gfE2b");
parcelRequire("k0sxV");
parcelRequire("90OM8");
parcelRequire("67vjG");
parcelRequire("iga8F");

var $4dKnp = parcelRequire("4dKnp");
const $014ef14cf6d867c5$var$DefaultEnvironmentTextureImageType = "image/png";
const $014ef14cf6d867c5$var$CurrentVersion = 2;
/**
 * Magic number identifying the env file.
 */ const $014ef14cf6d867c5$var$MagicBytes = [
    0x86,
    0x16,
    0x87,
    0x96,
    0xf6,
    0xd6,
    0x96,
    0x36
];
function $014ef14cf6d867c5$export$8b1a8c26c9fdce30(data) {
    const dataView = new DataView(data.buffer, data.byteOffset, data.byteLength);
    let pos = 0;
    for(let i = 0; i < $014ef14cf6d867c5$var$MagicBytes.length; i++)if (dataView.getUint8(pos++) !== $014ef14cf6d867c5$var$MagicBytes[i]) {
        (0, $kVtWi.Logger).Error("Not a babylon environment map");
        return null;
    }
    // Read json manifest - collect characters up to null terminator
    let manifestString = "";
    let charCode = 0x00;
    while(charCode = dataView.getUint8(pos++))manifestString += String.fromCharCode(charCode);
    let manifest = JSON.parse(manifestString);
    manifest = $014ef14cf6d867c5$export$4bb07527dbffd5d(manifest);
    if (manifest.specular) {
        // Extend the header with the position of the payload.
        manifest.specular.specularDataPosition = pos;
        // Fallback to 0.8 exactly if lodGenerationScale is not defined for backward compatibility.
        manifest.specular.lodGenerationScale = manifest.specular.lodGenerationScale || 0.8;
    }
    return manifest;
}
function $014ef14cf6d867c5$export$4bb07527dbffd5d(info) {
    if (info.version > $014ef14cf6d867c5$var$CurrentVersion) throw new Error(`Unsupported babylon environment map version "${info.version}". Latest supported version is "${$014ef14cf6d867c5$var$CurrentVersion}".`);
    if (info.version === 2) return info;
    // Migrate a v1 info to v2
    info = {
        ...info,
        version: 2,
        imageType: $014ef14cf6d867c5$var$DefaultEnvironmentTextureImageType
    };
    return info;
}
async function $014ef14cf6d867c5$export$dfc045575bbc57ce(texture, options = {}) {
    const internalTexture = texture.getInternalTexture();
    if (!internalTexture) return Promise.reject("The cube texture is invalid.");
    const imageType = options.imageType ?? $014ef14cf6d867c5$var$DefaultEnvironmentTextureImageType;
    const engine = internalTexture.getEngine();
    if (texture.textureType !== 2 && texture.textureType !== 1 && texture.textureType !== 0 && texture.textureType !== 0 && texture.textureType !== 7 && texture.textureType !== -1) return Promise.reject("The cube texture should allow HDR (Full Float or Half Float).");
    let textureType = 1;
    if (!engine.getCaps().textureFloatRender) {
        textureType = 2;
        if (!engine.getCaps().textureHalfFloatRender) return Promise.reject("Env texture can only be created when the browser supports half float or full float rendering.");
    }
    // sphericalPolynomial is lazy loaded so simply accessing it should trigger the computation.
    texture.sphericalPolynomial;
    // Lets keep track of the polynomial promise so we can wait for it to be ready before generating the pixels.
    const sphericalPolynomialPromise = texture.getInternalTexture()?._sphericalPolynomialPromise;
    const cubeWidth = internalTexture.width;
    const hostingScene = new (0, $gmbCk.Scene)(engine);
    const specularTextures = {};
    // As we are going to readPixels the faces of the cube, make sure the drawing/update commands for the cube texture are fully sent to the GPU in case it is drawn for the first time in this very frame!
    engine.flushFramebuffer();
    // Read and collect all mipmaps data from the cube.
    const mipmapsCount = (0, $1VEEL.Scalar).ILog2(internalTexture.width);
    for(let i = 0; i <= mipmapsCount; i++){
        const faceWidth = Math.pow(2, mipmapsCount - i);
        // All faces of the cube.
        for(let face = 0; face < 6; face++){
            let faceData = await texture.readPixels(face, i, undefined, false);
            if (faceData && faceData.byteLength === faceData.length) {
                const faceDataFloat = new Float32Array(faceData.byteLength * 4);
                for(let i = 0; i < faceData.byteLength; i++){
                    faceDataFloat[i] = faceData[i] / 255;
                    // Gamma to linear
                    faceDataFloat[i] = Math.pow(faceDataFloat[i], 2.2);
                }
                faceData = faceDataFloat;
            } else if (faceData && texture.gammaSpace) {
                const floatData = faceData;
                for(let i = 0; i < floatData.length; i++)// Gamma to linear
                floatData[i] = Math.pow(floatData[i], 2.2);
            }
            const tempTexture = engine.createRawTexture(faceData, faceWidth, faceWidth, 5, false, true, 1, null, textureType);
            await (0, $ezAJn.RGBDTextureTools).EncodeTextureToRGBD(tempTexture, hostingScene, textureType);
            const rgbdEncodedData = await engine._readTexturePixels(tempTexture, faceWidth, faceWidth);
            const imageEncodedData = await (0, $4dKnp.DumpTools).DumpDataAsync(faceWidth, faceWidth, rgbdEncodedData, imageType, undefined, false, true, options.imageQuality);
            specularTextures[i * 6 + face] = imageEncodedData;
            tempTexture.dispose();
        }
    }
    // We can delete the hosting scene keeping track of all the creation objects
    hostingScene.dispose();
    // Ensure completion of the polynomial creation promise.
    if (sphericalPolynomialPromise) await sphericalPolynomialPromise;
    // Creates the json header for the env texture
    const info = {
        version: $014ef14cf6d867c5$var$CurrentVersion,
        width: cubeWidth,
        imageType: imageType,
        irradiance: $014ef14cf6d867c5$var$_CreateEnvTextureIrradiance(texture),
        specular: {
            mipmaps: [],
            lodGenerationScale: texture.lodGenerationScale
        }
    };
    // Sets the specular image data information
    let position = 0;
    for(let i = 0; i <= mipmapsCount; i++)for(let face = 0; face < 6; face++){
        const byteLength = specularTextures[i * 6 + face].byteLength;
        info.specular.mipmaps.push({
            length: byteLength,
            position: position
        });
        position += byteLength;
    }
    // Encode the JSON as an array buffer
    const infoString = JSON.stringify(info);
    const infoBuffer = new ArrayBuffer(infoString.length + 1);
    const infoView = new Uint8Array(infoBuffer); // Limited to ascii subset matching unicode.
    for(let i = 0, strLen = infoString.length; i < strLen; i++)infoView[i] = infoString.charCodeAt(i);
    // Ends up with a null terminator for easier parsing
    infoView[infoString.length] = 0x00;
    // Computes the final required size and creates the storage
    const totalSize = $014ef14cf6d867c5$var$MagicBytes.length + position + infoBuffer.byteLength;
    const finalBuffer = new ArrayBuffer(totalSize);
    const finalBufferView = new Uint8Array(finalBuffer);
    const dataView = new DataView(finalBuffer);
    // Copy the magic bytes identifying the file in
    let pos = 0;
    for(let i = 0; i < $014ef14cf6d867c5$var$MagicBytes.length; i++)dataView.setUint8(pos++, $014ef14cf6d867c5$var$MagicBytes[i]);
    // Add the json info
    finalBufferView.set(new Uint8Array(infoBuffer), pos);
    pos += infoBuffer.byteLength;
    // Finally inserts the texture data
    for(let i = 0; i <= mipmapsCount; i++)for(let face = 0; face < 6; face++){
        const dataBuffer = specularTextures[i * 6 + face];
        finalBufferView.set(new Uint8Array(dataBuffer), pos);
        pos += dataBuffer.byteLength;
    }
    // Voila
    return finalBuffer;
}
/**
 * Creates a JSON representation of the spherical data.
 * @param texture defines the texture containing the polynomials
 * @returns the JSON representation of the spherical info
 */ function $014ef14cf6d867c5$var$_CreateEnvTextureIrradiance(texture) {
    const polynmials = texture.sphericalPolynomial;
    if (polynmials == null) return null;
    return {
        x: [
            polynmials.x.x,
            polynmials.x.y,
            polynmials.x.z
        ],
        y: [
            polynmials.y.x,
            polynmials.y.y,
            polynmials.y.z
        ],
        z: [
            polynmials.z.x,
            polynmials.z.y,
            polynmials.z.z
        ],
        xx: [
            polynmials.xx.x,
            polynmials.xx.y,
            polynmials.xx.z
        ],
        yy: [
            polynmials.yy.x,
            polynmials.yy.y,
            polynmials.yy.z
        ],
        zz: [
            polynmials.zz.x,
            polynmials.zz.y,
            polynmials.zz.z
        ],
        yz: [
            polynmials.yz.x,
            polynmials.yz.y,
            polynmials.yz.z
        ],
        zx: [
            polynmials.zx.x,
            polynmials.zx.y,
            polynmials.zx.z
        ],
        xy: [
            polynmials.xy.x,
            polynmials.xy.y,
            polynmials.xy.z
        ]
    };
}
function $014ef14cf6d867c5$export$54dfcd286e56f3ba(data, info) {
    info = $014ef14cf6d867c5$export$4bb07527dbffd5d(info);
    const specularInfo = info.specular;
    // Double checks the enclosed info
    let mipmapsCount = (0, $1VEEL.Scalar).Log2(info.width);
    mipmapsCount = Math.round(mipmapsCount) + 1;
    if (specularInfo.mipmaps.length !== 6 * mipmapsCount) throw new Error(`Unsupported specular mipmaps number "${specularInfo.mipmaps.length}"`);
    const imageData = new Array(mipmapsCount);
    for(let i = 0; i < mipmapsCount; i++){
        imageData[i] = new Array(6);
        for(let face = 0; face < 6; face++){
            const imageInfo = specularInfo.mipmaps[i * 6 + face];
            imageData[i][face] = new Uint8Array(data.buffer, data.byteOffset + specularInfo.specularDataPosition + imageInfo.position, imageInfo.length);
        }
    }
    return imageData;
}
function $014ef14cf6d867c5$export$83f80da9a5e7195a(texture, data, info) {
    info = $014ef14cf6d867c5$export$4bb07527dbffd5d(info);
    const specularInfo = info.specular;
    if (!specularInfo) // Nothing else parsed so far
    return Promise.resolve();
    texture._lodGenerationScale = specularInfo.lodGenerationScale;
    const imageData = $014ef14cf6d867c5$export$54dfcd286e56f3ba(data, info);
    return $014ef14cf6d867c5$export$e078c68575d7d919(texture, imageData, info.imageType);
}
function $014ef14cf6d867c5$var$_OnImageReadyAsync(image, engine, expandTexture, rgbdPostProcess, url, face, i, generateNonLODTextures, lodTextures, cubeRtt, texture) {
    return new Promise((resolve, reject)=>{
        if (expandTexture) {
            const tempTexture = engine.createTexture(null, true, true, null, 1, null, (message)=>{
                reject(message);
            }, image);
            rgbdPostProcess.getEffect().executeWhenCompiled(()=>{
                // Uncompress the data to a RTT
                rgbdPostProcess.externalTextureSamplerBinding = true;
                rgbdPostProcess.onApply = (effect)=>{
                    effect._bindTexture("textureSampler", tempTexture);
                    effect.setFloat2("scale", 1, engine._features.needsInvertingBitmap && image instanceof ImageBitmap ? -1 : 1);
                };
                if (!engine.scenes.length) return;
                engine.scenes[0].postProcessManager.directRender([
                    rgbdPostProcess
                ], cubeRtt, true, face, i);
                // Cleanup
                engine.restoreDefaultFramebuffer();
                tempTexture.dispose();
                URL.revokeObjectURL(url);
                resolve();
            });
        } else {
            engine._uploadImageToTexture(texture, image, face, i);
            // Upload the face to the non lod texture support
            if (generateNonLODTextures) {
                const lodTexture = lodTextures[i];
                if (lodTexture) engine._uploadImageToTexture(lodTexture._texture, image, face, 0);
            }
            resolve();
        }
    });
}
function $014ef14cf6d867c5$export$e078c68575d7d919(texture, imageData, imageType = $014ef14cf6d867c5$var$DefaultEnvironmentTextureImageType) {
    if (!(0, $bOhSV.Tools).IsExponentOfTwo(texture.width)) throw new Error("Texture size must be a power of two");
    const mipmapsCount = (0, $1VEEL.Scalar).ILog2(texture.width) + 1;
    // Gets everything ready.
    const engine = texture.getEngine();
    let expandTexture = false;
    let generateNonLODTextures = false;
    let rgbdPostProcess = null;
    let cubeRtt = null;
    let lodTextures = null;
    const caps = engine.getCaps();
    texture.format = 5;
    texture.type = 0;
    texture.generateMipMaps = true;
    texture._cachedAnisotropicFilteringLevel = null;
    engine.updateTextureSamplingMode(3, texture);
    // Add extra process if texture lod is not supported
    if (!caps.textureLOD) {
        expandTexture = false;
        generateNonLODTextures = true;
        lodTextures = {};
    } else if (!engine._features.supportRenderAndCopyToLodForFloatTextures) expandTexture = false;
    else if (caps.textureHalfFloatRender && caps.textureHalfFloatLinearFiltering) {
        expandTexture = true;
        texture.type = 2;
    } else if (caps.textureFloatRender && caps.textureFloatLinearFiltering) {
        expandTexture = true;
        texture.type = 1;
    }
    // Expand the texture if possible
    if (expandTexture) {
        // Simply run through the decode PP
        rgbdPostProcess = new (0, $cFdBb.PostProcess)("rgbdDecode", "rgbdDecode", null, null, 1, null, 3, engine, false, undefined, texture.type, undefined, null, false);
        texture._isRGBD = false;
        texture.invertY = false;
        cubeRtt = engine.createRenderTargetCubeTexture(texture.width, {
            generateDepthBuffer: false,
            generateMipMaps: true,
            generateStencilBuffer: false,
            samplingMode: 3,
            type: texture.type,
            format: 5
        });
    } else {
        texture._isRGBD = true;
        texture.invertY = true;
        // In case of missing support, applies the same patch than DDS files.
        if (generateNonLODTextures) {
            const mipSlices = 3;
            const scale = texture._lodGenerationScale;
            const offset = texture._lodGenerationOffset;
            for(let i = 0; i < mipSlices; i++){
                //compute LOD from even spacing in smoothness (matching shader calculation)
                const smoothness = i / (mipSlices - 1);
                const roughness = 1 - smoothness;
                const minLODIndex = offset; // roughness = 0
                const maxLODIndex = (mipmapsCount - 1) * scale + offset; // roughness = 1 (mipmaps start from 0)
                const lodIndex = minLODIndex + (maxLODIndex - minLODIndex) * roughness;
                const mipmapIndex = Math.round(Math.min(Math.max(lodIndex, 0), maxLODIndex));
                const glTextureFromLod = new (0, $b9e4a.InternalTexture)(engine, (0, $b9e4a.InternalTextureSource).Temp);
                glTextureFromLod.isCube = true;
                glTextureFromLod.invertY = true;
                glTextureFromLod.generateMipMaps = false;
                engine.updateTextureSamplingMode(2, glTextureFromLod);
                // Wrap in a base texture for easy binding.
                const lodTexture = new (0, $akOl3.BaseTexture)(null);
                lodTexture._isCube = true;
                lodTexture._texture = glTextureFromLod;
                lodTextures[mipmapIndex] = lodTexture;
                switch(i){
                    case 0:
                        texture._lodTextureLow = lodTexture;
                        break;
                    case 1:
                        texture._lodTextureMid = lodTexture;
                        break;
                    case 2:
                        texture._lodTextureHigh = lodTexture;
                        break;
                }
            }
        }
    }
    const promises = [];
    // All mipmaps up to provided number of images
    for(let i = 0; i < imageData.length; i++)// All faces
    for(let face = 0; face < 6; face++){
        // Constructs an image element from image data
        const bytes = imageData[i][face];
        const blob = new Blob([
            bytes
        ], {
            type: imageType
        });
        const url = URL.createObjectURL(blob);
        let promise;
        if (engine._features.forceBitmapOverHTMLImageElement) promise = engine.createImageBitmap(blob, {
            premultiplyAlpha: "none"
        }).then((img)=>{
            return $014ef14cf6d867c5$var$_OnImageReadyAsync(img, engine, expandTexture, rgbdPostProcess, url, face, i, generateNonLODTextures, lodTextures, cubeRtt, texture);
        });
        else {
            const image = new Image();
            image.src = url;
            // Enqueue promise to upload to the texture.
            promise = new Promise((resolve, reject)=>{
                image.onload = ()=>{
                    $014ef14cf6d867c5$var$_OnImageReadyAsync(image, engine, expandTexture, rgbdPostProcess, url, face, i, generateNonLODTextures, lodTextures, cubeRtt, texture).then(()=>resolve()).catch((reason)=>{
                        reject(reason);
                    });
                };
                image.onerror = (error)=>{
                    reject(error);
                };
            });
        }
        promises.push(promise);
    }
    // Fill remaining mipmaps with black textures.
    if (imageData.length < mipmapsCount) {
        let data;
        const size = Math.pow(2, mipmapsCount - 1 - imageData.length);
        const dataLength = size * size * 4;
        switch(texture.type){
            case 0:
                data = new Uint8Array(dataLength);
                break;
            case 2:
                data = new Uint16Array(dataLength);
                break;
            case 1:
                data = new Float32Array(dataLength);
                break;
        }
        for(let i = imageData.length; i < mipmapsCount; i++)for(let face = 0; face < 6; face++)engine._uploadArrayBufferViewToTexture(texture, data, face, i);
    }
    // Once all done, finishes the cleanup and return
    return Promise.all(promises).then(()=>{
        // Release temp RTT.
        if (cubeRtt) {
            engine._releaseTexture(texture);
            cubeRtt._swapAndDie(texture);
        }
        // Release temp Post Process.
        if (rgbdPostProcess) rgbdPostProcess.dispose();
        // Flag internal texture as ready in case they are in use.
        if (generateNonLODTextures) {
            if (texture._lodTextureHigh && texture._lodTextureHigh._texture) texture._lodTextureHigh._texture.isReady = true;
            if (texture._lodTextureMid && texture._lodTextureMid._texture) texture._lodTextureMid._texture.isReady = true;
            if (texture._lodTextureLow && texture._lodTextureLow._texture) texture._lodTextureLow._texture.isReady = true;
        }
    });
}
function $014ef14cf6d867c5$export$972e1fd8b74c3586(texture, info) {
    info = $014ef14cf6d867c5$export$4bb07527dbffd5d(info);
    const irradianceInfo = info.irradiance;
    if (!irradianceInfo) return;
    const sp = new (0, $f3g09.SphericalPolynomial)();
    (0, $ha1VO.Vector3).FromArrayToRef(irradianceInfo.x, 0, sp.x);
    (0, $ha1VO.Vector3).FromArrayToRef(irradianceInfo.y, 0, sp.y);
    (0, $ha1VO.Vector3).FromArrayToRef(irradianceInfo.z, 0, sp.z);
    (0, $ha1VO.Vector3).FromArrayToRef(irradianceInfo.xx, 0, sp.xx);
    (0, $ha1VO.Vector3).FromArrayToRef(irradianceInfo.yy, 0, sp.yy);
    (0, $ha1VO.Vector3).FromArrayToRef(irradianceInfo.zz, 0, sp.zz);
    (0, $ha1VO.Vector3).FromArrayToRef(irradianceInfo.yz, 0, sp.yz);
    (0, $ha1VO.Vector3).FromArrayToRef(irradianceInfo.zx, 0, sp.zx);
    (0, $ha1VO.Vector3).FromArrayToRef(irradianceInfo.xy, 0, sp.xy);
    texture._sphericalPolynomial = sp;
}
function $014ef14cf6d867c5$export$6df31312d4ab470e(internalTexture, data, sphericalPolynomial, lodScale, lodOffset) {
    const proxy = internalTexture.getEngine().createRawCubeTexture(null, internalTexture.width, internalTexture.format, internalTexture.type, internalTexture.generateMipMaps, internalTexture.invertY, internalTexture.samplingMode, internalTexture._compression);
    const proxyPromise = $014ef14cf6d867c5$export$e078c68575d7d919(proxy, data).then(()=>internalTexture);
    internalTexture.onRebuildCallback = (_internalTexture)=>{
        return {
            proxy: proxyPromise,
            isReady: true,
            isAsync: true
        };
    };
    internalTexture._source = (0, $b9e4a.InternalTextureSource).CubeRawRGBD;
    internalTexture._bufferViewArrayArray = data;
    internalTexture._lodGenerationScale = lodScale;
    internalTexture._lodGenerationOffset = lodOffset;
    internalTexture._sphericalPolynomial = sphericalPolynomial;
    return $014ef14cf6d867c5$export$e078c68575d7d919(internalTexture, data).then(()=>{
        internalTexture.isReady = true;
        return internalTexture;
    });
}
const $014ef14cf6d867c5$export$75c1009fdcfc451f = {
    GetEnvInfo: /**
     * Gets the environment info from an env file.
     * @param data The array buffer containing the .env bytes.
     * @returns the environment file info (the json header) if successfully parsed, normalized to the latest supported version.
     */ $014ef14cf6d867c5$export$8b1a8c26c9fdce30,
    CreateEnvTextureAsync: /**
     * Creates an environment texture from a loaded cube texture.
     * @param texture defines the cube texture to convert in env file
     * @param options options for the conversion process
     * @param options.imageType the mime type for the encoded images, with support for "image/png" (default) and "image/webp"
     * @param options.imageQuality the image quality of encoded WebP images.
     * @returns a promise containing the environment data if successful.
     */ $014ef14cf6d867c5$export$dfc045575bbc57ce,
    CreateImageDataArrayBufferViews: /**
     * Creates the ArrayBufferViews used for initializing environment texture image data.
     * @param data the image data
     * @param info parameters that determine what views will be created for accessing the underlying buffer
     * @returns the views described by info providing access to the underlying buffer
     */ $014ef14cf6d867c5$export$54dfcd286e56f3ba,
    UploadEnvLevelsAsync: /**
     * Uploads the texture info contained in the env file to the GPU.
     * @param texture defines the internal texture to upload to
     * @param data defines the data to load
     * @param info defines the texture info retrieved through the GetEnvInfo method
     * @returns a promise
     */ $014ef14cf6d867c5$export$83f80da9a5e7195a,
    UploadLevelsAsync: /**
     * Uploads the levels of image data to the GPU.
     * @param texture defines the internal texture to upload to
     * @param imageData defines the array buffer views of image data [mipmap][face]
     * @param imageType the mime type of the image data
     * @returns a promise
     */ $014ef14cf6d867c5$export$e078c68575d7d919,
    UploadEnvSpherical: /**
     * Uploads spherical polynomials information to the texture.
     * @param texture defines the texture we are trying to upload the information to
     * @param info defines the environment texture info retrieved through the GetEnvInfo method
     */ $014ef14cf6d867c5$export$972e1fd8b74c3586
};

});
parcelRegister("f3g09", function(module, exports) {

$parcel$export(module.exports, "SphericalHarmonics", () => $af538c62014b132a$export$a11ccd906ebcd67c);
$parcel$export(module.exports, "SphericalPolynomial", () => $af538c62014b132a$export$df22d3e5758589d2);
/* eslint-disable @typescript-eslint/naming-convention */ 
var $ha1VO = parcelRequire("ha1VO");
parcelRequire("6rxfP");
var $ha1VO = parcelRequire("ha1VO");
// https://dickyjim.wordpress.com/2013/09/04/spherical-harmonics-for-beginners/
// http://silviojemma.com/public/papers/lighting/spherical-harmonic-lighting.pdf
// https://www.ppsloan.org/publications/StupidSH36.pdf
// http://cseweb.ucsd.edu/~ravir/papers/envmap/envmap.pdf
// https://www.ppsloan.org/publications/SHJCGT.pdf
// https://www.ppsloan.org/publications/shdering.pdf
// https://google.github.io/filament/Filament.md.html#annex/sphericalharmonics
// https://patapom.com/blog/SHPortal/
// https://imdoingitwrong.wordpress.com/2011/04/14/spherical-harmonics-wtf/
// Using real SH basis:
//  m>0             m   m
// y   = sqrt(2) * K * P * cos(m*phi) * cos(theta)
//  l               l   l
//
//  m<0             m   |m|
// y   = sqrt(2) * K * P * sin(m*phi) * cos(theta)
//  l               l   l
//
//  m=0   0   0
// y   = K * P * trigono terms
//  l     l   l
//
//  m       (2l + 1)(l - |m|)!
// K = sqrt(------------------)
//  l           4pi(l + |m|)!
//
// and P by recursion:
//
// P00(x) = 1
// P01(x) = x
// Pll(x) = (-1^l)(2l - 1)!!(1-x*x)^(1/2)
//          ((2l - 1)x[Pl-1/m]-(l + m - 1)[Pl-2/m])
// Plm(x) = ---------------------------------------
//                         l - m
// Leaving the trigonometric terms aside we can precompute the constants to :
const $af538c62014b132a$var$SH3ylmBasisConstants = [
    Math.sqrt(1 / (4 * Math.PI)),
    -Math.sqrt(3 / (4 * Math.PI)),
    Math.sqrt(3 / (4 * Math.PI)),
    -Math.sqrt(3 / (4 * Math.PI)),
    Math.sqrt(15 / (4 * Math.PI)),
    -Math.sqrt(15 / (4 * Math.PI)),
    Math.sqrt(5 / (16 * Math.PI)),
    -Math.sqrt(15 / (4 * Math.PI)),
    Math.sqrt(15 / (16 * Math.PI))
];
// cm = cos(m * phi)
// sm = sin(m * phi)
// {x,y,z} = {cos(phi)sin(theta), sin(phi)sin(theta), cos(theta)}
// By recursion on using trigo identities:
const $af538c62014b132a$var$SH3ylmBasisTrigonometricTerms = [
    ()=>1,
    (direction)=>direction.y,
    (direction)=>direction.z,
    (direction)=>direction.x,
    (direction)=>direction.x * direction.y,
    (direction)=>direction.y * direction.z,
    (direction)=>3 * direction.z * direction.z - 1,
    (direction)=>direction.x * direction.z,
    (direction)=>direction.x * direction.x - direction.y * direction.y
];
// Wrap the full compute
const $af538c62014b132a$var$applySH3 = (lm, direction)=>{
    return $af538c62014b132a$var$SH3ylmBasisConstants[lm] * $af538c62014b132a$var$SH3ylmBasisTrigonometricTerms[lm](direction);
};
// Derived from the integration of the a kernel convolution to SH.
// Great explanation here: https://patapom.com/blog/SHPortal/#about-distant-radiance-and-irradiance-environments
const $af538c62014b132a$var$SHCosKernelConvolution = [
    Math.PI,
    2 * Math.PI / 3,
    2 * Math.PI / 3,
    2 * Math.PI / 3,
    Math.PI / 4,
    Math.PI / 4,
    Math.PI / 4,
    Math.PI / 4,
    Math.PI / 4
];
class $af538c62014b132a$export$a11ccd906ebcd67c {
    constructor(){
        /**
         * Defines whether or not the harmonics have been prescaled for rendering.
         */ this.preScaled = false;
        /**
         * The l0,0 coefficients of the spherical harmonics
         */ this.l00 = (0, $ha1VO.Vector3).Zero();
        /**
         * The l1,-1 coefficients of the spherical harmonics
         */ this.l1_1 = (0, $ha1VO.Vector3).Zero();
        /**
         * The l1,0 coefficients of the spherical harmonics
         */ this.l10 = (0, $ha1VO.Vector3).Zero();
        /**
         * The l1,1 coefficients of the spherical harmonics
         */ this.l11 = (0, $ha1VO.Vector3).Zero();
        /**
         * The l2,-2 coefficients of the spherical harmonics
         */ this.l2_2 = (0, $ha1VO.Vector3).Zero();
        /**
         * The l2,-1 coefficients of the spherical harmonics
         */ this.l2_1 = (0, $ha1VO.Vector3).Zero();
        /**
         * The l2,0 coefficients of the spherical harmonics
         */ this.l20 = (0, $ha1VO.Vector3).Zero();
        /**
         * The l2,1 coefficients of the spherical harmonics
         */ this.l21 = (0, $ha1VO.Vector3).Zero();
        /**
         * The l2,2 coefficients of the spherical harmonics
         */ this.l22 = (0, $ha1VO.Vector3).Zero();
    }
    /**
     * Adds a light to the spherical harmonics
     * @param direction the direction of the light
     * @param color the color of the light
     * @param deltaSolidAngle the delta solid angle of the light
     */ addLight(direction, color, deltaSolidAngle) {
        (0, $ha1VO.TmpVectors).Vector3[0].set(color.r, color.g, color.b);
        const colorVector = (0, $ha1VO.TmpVectors).Vector3[0];
        const c = (0, $ha1VO.TmpVectors).Vector3[1];
        colorVector.scaleToRef(deltaSolidAngle, c);
        c.scaleToRef($af538c62014b132a$var$applySH3(0, direction), (0, $ha1VO.TmpVectors).Vector3[2]);
        this.l00.addInPlace((0, $ha1VO.TmpVectors).Vector3[2]);
        c.scaleToRef($af538c62014b132a$var$applySH3(1, direction), (0, $ha1VO.TmpVectors).Vector3[2]);
        this.l1_1.addInPlace((0, $ha1VO.TmpVectors).Vector3[2]);
        c.scaleToRef($af538c62014b132a$var$applySH3(2, direction), (0, $ha1VO.TmpVectors).Vector3[2]);
        this.l10.addInPlace((0, $ha1VO.TmpVectors).Vector3[2]);
        c.scaleToRef($af538c62014b132a$var$applySH3(3, direction), (0, $ha1VO.TmpVectors).Vector3[2]);
        this.l11.addInPlace((0, $ha1VO.TmpVectors).Vector3[2]);
        c.scaleToRef($af538c62014b132a$var$applySH3(4, direction), (0, $ha1VO.TmpVectors).Vector3[2]);
        this.l2_2.addInPlace((0, $ha1VO.TmpVectors).Vector3[2]);
        c.scaleToRef($af538c62014b132a$var$applySH3(5, direction), (0, $ha1VO.TmpVectors).Vector3[2]);
        this.l2_1.addInPlace((0, $ha1VO.TmpVectors).Vector3[2]);
        c.scaleToRef($af538c62014b132a$var$applySH3(6, direction), (0, $ha1VO.TmpVectors).Vector3[2]);
        this.l20.addInPlace((0, $ha1VO.TmpVectors).Vector3[2]);
        c.scaleToRef($af538c62014b132a$var$applySH3(7, direction), (0, $ha1VO.TmpVectors).Vector3[2]);
        this.l21.addInPlace((0, $ha1VO.TmpVectors).Vector3[2]);
        c.scaleToRef($af538c62014b132a$var$applySH3(8, direction), (0, $ha1VO.TmpVectors).Vector3[2]);
        this.l22.addInPlace((0, $ha1VO.TmpVectors).Vector3[2]);
    }
    /**
     * Scales the spherical harmonics by the given amount
     * @param scale the amount to scale
     */ scaleInPlace(scale) {
        this.l00.scaleInPlace(scale);
        this.l1_1.scaleInPlace(scale);
        this.l10.scaleInPlace(scale);
        this.l11.scaleInPlace(scale);
        this.l2_2.scaleInPlace(scale);
        this.l2_1.scaleInPlace(scale);
        this.l20.scaleInPlace(scale);
        this.l21.scaleInPlace(scale);
        this.l22.scaleInPlace(scale);
    }
    /**
     * Convert from incident radiance (Li) to irradiance (E) by applying convolution with the cosine-weighted hemisphere.
     *
     * ```
     * E_lm = A_l * L_lm
     * ```
     *
     * In spherical harmonics this convolution amounts to scaling factors for each frequency band.
     * This corresponds to equation 5 in "An Efficient Representation for Irradiance Environment Maps", where
     * the scaling factors are given in equation 9.
     */ convertIncidentRadianceToIrradiance() {
        // Constant (Band 0)
        this.l00.scaleInPlace($af538c62014b132a$var$SHCosKernelConvolution[0]);
        // Linear (Band 1)
        this.l1_1.scaleInPlace($af538c62014b132a$var$SHCosKernelConvolution[1]);
        this.l10.scaleInPlace($af538c62014b132a$var$SHCosKernelConvolution[2]);
        this.l11.scaleInPlace($af538c62014b132a$var$SHCosKernelConvolution[3]);
        // Quadratic (Band 2)
        this.l2_2.scaleInPlace($af538c62014b132a$var$SHCosKernelConvolution[4]);
        this.l2_1.scaleInPlace($af538c62014b132a$var$SHCosKernelConvolution[5]);
        this.l20.scaleInPlace($af538c62014b132a$var$SHCosKernelConvolution[6]);
        this.l21.scaleInPlace($af538c62014b132a$var$SHCosKernelConvolution[7]);
        this.l22.scaleInPlace($af538c62014b132a$var$SHCosKernelConvolution[8]);
    }
    /**
     * Convert from irradiance to outgoing radiance for Lambertian BDRF, suitable for efficient shader evaluation.
     *
     * ```
     * L = (1/pi) * E * rho
     * ```
     *
     * This is done by an additional scale by 1/pi, so is a fairly trivial operation but important conceptually.
     */ convertIrradianceToLambertianRadiance() {
        this.scaleInPlace(1.0 / Math.PI);
    // The resultant SH now represents outgoing radiance, so includes the Lambert 1/pi normalisation factor but without albedo (rho) applied
    // (The pixel shader must apply albedo after texture fetches, etc).
    }
    /**
     * Integrates the reconstruction coefficients directly in to the SH preventing further
     * required operations at run time.
     *
     * This is simply done by scaling back the SH with Ylm constants parameter.
     * The trigonometric part being applied by the shader at run time.
     */ preScaleForRendering() {
        this.preScaled = true;
        this.l00.scaleInPlace($af538c62014b132a$var$SH3ylmBasisConstants[0]);
        this.l1_1.scaleInPlace($af538c62014b132a$var$SH3ylmBasisConstants[1]);
        this.l10.scaleInPlace($af538c62014b132a$var$SH3ylmBasisConstants[2]);
        this.l11.scaleInPlace($af538c62014b132a$var$SH3ylmBasisConstants[3]);
        this.l2_2.scaleInPlace($af538c62014b132a$var$SH3ylmBasisConstants[4]);
        this.l2_1.scaleInPlace($af538c62014b132a$var$SH3ylmBasisConstants[5]);
        this.l20.scaleInPlace($af538c62014b132a$var$SH3ylmBasisConstants[6]);
        this.l21.scaleInPlace($af538c62014b132a$var$SH3ylmBasisConstants[7]);
        this.l22.scaleInPlace($af538c62014b132a$var$SH3ylmBasisConstants[8]);
    }
    /**
     * update the spherical harmonics coefficients from the given array
     * @param data defines the 9x3 coefficients (l00, l1-1, l10, l11, l2-2, l2-1, l20, l21, l22)
     * @returns the spherical harmonics (this)
     */ updateFromArray(data) {
        (0, $ha1VO.Vector3).FromArrayToRef(data[0], 0, this.l00);
        (0, $ha1VO.Vector3).FromArrayToRef(data[1], 0, this.l1_1);
        (0, $ha1VO.Vector3).FromArrayToRef(data[2], 0, this.l10);
        (0, $ha1VO.Vector3).FromArrayToRef(data[3], 0, this.l11);
        (0, $ha1VO.Vector3).FromArrayToRef(data[4], 0, this.l2_2);
        (0, $ha1VO.Vector3).FromArrayToRef(data[5], 0, this.l2_1);
        (0, $ha1VO.Vector3).FromArrayToRef(data[6], 0, this.l20);
        (0, $ha1VO.Vector3).FromArrayToRef(data[7], 0, this.l21);
        (0, $ha1VO.Vector3).FromArrayToRef(data[8], 0, this.l22);
        return this;
    }
    /**
     * update the spherical harmonics coefficients from the given floats array
     * @param data defines the 9x3 coefficients (l00, l1-1, l10, l11, l2-2, l2-1, l20, l21, l22)
     * @returns the spherical harmonics (this)
     */ updateFromFloatsArray(data) {
        (0, $ha1VO.Vector3).FromFloatsToRef(data[0], data[1], data[2], this.l00);
        (0, $ha1VO.Vector3).FromFloatsToRef(data[3], data[4], data[5], this.l1_1);
        (0, $ha1VO.Vector3).FromFloatsToRef(data[6], data[7], data[8], this.l10);
        (0, $ha1VO.Vector3).FromFloatsToRef(data[9], data[10], data[11], this.l11);
        (0, $ha1VO.Vector3).FromFloatsToRef(data[12], data[13], data[14], this.l2_2);
        (0, $ha1VO.Vector3).FromFloatsToRef(data[15], data[16], data[17], this.l2_1);
        (0, $ha1VO.Vector3).FromFloatsToRef(data[18], data[19], data[20], this.l20);
        (0, $ha1VO.Vector3).FromFloatsToRef(data[21], data[22], data[23], this.l21);
        (0, $ha1VO.Vector3).FromFloatsToRef(data[24], data[25], data[26], this.l22);
        return this;
    }
    /**
     * Constructs a spherical harmonics from an array.
     * @param data defines the 9x3 coefficients (l00, l1-1, l10, l11, l2-2, l2-1, l20, l21, l22)
     * @returns the spherical harmonics
     */ static FromArray(data) {
        const sh = new $af538c62014b132a$export$a11ccd906ebcd67c();
        return sh.updateFromArray(data);
    }
    // Keep for references.
    /**
     * Gets the spherical harmonics from polynomial
     * @param polynomial the spherical polynomial
     * @returns the spherical harmonics
     */ static FromPolynomial(polynomial) {
        const result = new $af538c62014b132a$export$a11ccd906ebcd67c();
        result.l00 = polynomial.xx.scale(0.376127).add(polynomial.yy.scale(0.376127)).add(polynomial.zz.scale(0.376126));
        result.l1_1 = polynomial.y.scale(0.977204);
        result.l10 = polynomial.z.scale(0.977204);
        result.l11 = polynomial.x.scale(0.977204);
        result.l2_2 = polynomial.xy.scale(1.16538);
        result.l2_1 = polynomial.yz.scale(1.16538);
        result.l20 = polynomial.zz.scale(1.34567).subtract(polynomial.xx.scale(0.672834)).subtract(polynomial.yy.scale(0.672834));
        result.l21 = polynomial.zx.scale(1.16538);
        result.l22 = polynomial.xx.scale(1.16538).subtract(polynomial.yy.scale(1.16538));
        result.l1_1.scaleInPlace(-1);
        result.l11.scaleInPlace(-1);
        result.l2_1.scaleInPlace(-1);
        result.l21.scaleInPlace(-1);
        result.scaleInPlace(Math.PI);
        return result;
    }
}
class $af538c62014b132a$export$df22d3e5758589d2 {
    constructor(){
        /**
         * The x coefficients of the spherical polynomial
         */ this.x = (0, $ha1VO.Vector3).Zero();
        /**
         * The y coefficients of the spherical polynomial
         */ this.y = (0, $ha1VO.Vector3).Zero();
        /**
         * The z coefficients of the spherical polynomial
         */ this.z = (0, $ha1VO.Vector3).Zero();
        /**
         * The xx coefficients of the spherical polynomial
         */ this.xx = (0, $ha1VO.Vector3).Zero();
        /**
         * The yy coefficients of the spherical polynomial
         */ this.yy = (0, $ha1VO.Vector3).Zero();
        /**
         * The zz coefficients of the spherical polynomial
         */ this.zz = (0, $ha1VO.Vector3).Zero();
        /**
         * The xy coefficients of the spherical polynomial
         */ this.xy = (0, $ha1VO.Vector3).Zero();
        /**
         * The yz coefficients of the spherical polynomial
         */ this.yz = (0, $ha1VO.Vector3).Zero();
        /**
         * The zx coefficients of the spherical polynomial
         */ this.zx = (0, $ha1VO.Vector3).Zero();
    }
    /**
     * The spherical harmonics used to create the polynomials.
     */ get preScaledHarmonics() {
        if (!this._harmonics) this._harmonics = $af538c62014b132a$export$a11ccd906ebcd67c.FromPolynomial(this);
        if (!this._harmonics.preScaled) this._harmonics.preScaleForRendering();
        return this._harmonics;
    }
    /**
     * Adds an ambient color to the spherical polynomial
     * @param color the color to add
     */ addAmbient(color) {
        (0, $ha1VO.TmpVectors).Vector3[0].copyFromFloats(color.r, color.g, color.b);
        const colorVector = (0, $ha1VO.TmpVectors).Vector3[0];
        this.xx.addInPlace(colorVector);
        this.yy.addInPlace(colorVector);
        this.zz.addInPlace(colorVector);
    }
    /**
     * Scales the spherical polynomial by the given amount
     * @param scale the amount to scale
     */ scaleInPlace(scale) {
        this.x.scaleInPlace(scale);
        this.y.scaleInPlace(scale);
        this.z.scaleInPlace(scale);
        this.xx.scaleInPlace(scale);
        this.yy.scaleInPlace(scale);
        this.zz.scaleInPlace(scale);
        this.yz.scaleInPlace(scale);
        this.zx.scaleInPlace(scale);
        this.xy.scaleInPlace(scale);
    }
    /**
     * Updates the spherical polynomial from harmonics
     * @param harmonics the spherical harmonics
     * @returns the spherical polynomial
     */ updateFromHarmonics(harmonics) {
        this._harmonics = harmonics;
        this.x.copyFrom(harmonics.l11);
        this.x.scaleInPlace(1.02333).scaleInPlace(-1);
        this.y.copyFrom(harmonics.l1_1);
        this.y.scaleInPlace(1.02333).scaleInPlace(-1);
        this.z.copyFrom(harmonics.l10);
        this.z.scaleInPlace(1.02333);
        this.xx.copyFrom(harmonics.l00);
        (0, $ha1VO.TmpVectors).Vector3[0].copyFrom(harmonics.l20).scaleInPlace(0.247708);
        (0, $ha1VO.TmpVectors).Vector3[1].copyFrom(harmonics.l22).scaleInPlace(0.429043);
        this.xx.scaleInPlace(0.886277).subtractInPlace((0, $ha1VO.TmpVectors).Vector3[0]).addInPlace((0, $ha1VO.TmpVectors).Vector3[1]);
        this.yy.copyFrom(harmonics.l00);
        this.yy.scaleInPlace(0.886277).subtractInPlace((0, $ha1VO.TmpVectors).Vector3[0]).subtractInPlace((0, $ha1VO.TmpVectors).Vector3[1]);
        this.zz.copyFrom(harmonics.l00);
        (0, $ha1VO.TmpVectors).Vector3[0].copyFrom(harmonics.l20).scaleInPlace(0.495417);
        this.zz.scaleInPlace(0.886277).addInPlace((0, $ha1VO.TmpVectors).Vector3[0]);
        this.yz.copyFrom(harmonics.l2_1);
        this.yz.scaleInPlace(0.858086).scaleInPlace(-1);
        this.zx.copyFrom(harmonics.l21);
        this.zx.scaleInPlace(0.858086).scaleInPlace(-1);
        this.xy.copyFrom(harmonics.l2_2);
        this.xy.scaleInPlace(0.858086);
        this.scaleInPlace(1.0 / Math.PI);
        return this;
    }
    /**
     * Gets the spherical polynomial from harmonics
     * @param harmonics the spherical harmonics
     * @returns the spherical polynomial
     */ static FromHarmonics(harmonics) {
        const result = new $af538c62014b132a$export$df22d3e5758589d2();
        return result.updateFromHarmonics(harmonics);
    }
    /**
     * Constructs a spherical polynomial from an array.
     * @param data defines the 9x3 coefficients (x, y, z, xx, yy, zz, yz, zx, xy)
     * @returns the spherical polynomial
     */ static FromArray(data) {
        const sp = new $af538c62014b132a$export$df22d3e5758589d2();
        (0, $ha1VO.Vector3).FromArrayToRef(data[0], 0, sp.x);
        (0, $ha1VO.Vector3).FromArrayToRef(data[1], 0, sp.y);
        (0, $ha1VO.Vector3).FromArrayToRef(data[2], 0, sp.z);
        (0, $ha1VO.Vector3).FromArrayToRef(data[3], 0, sp.xx);
        (0, $ha1VO.Vector3).FromArrayToRef(data[4], 0, sp.yy);
        (0, $ha1VO.Vector3).FromArrayToRef(data[5], 0, sp.zz);
        (0, $ha1VO.Vector3).FromArrayToRef(data[6], 0, sp.yz);
        (0, $ha1VO.Vector3).FromArrayToRef(data[7], 0, sp.zx);
        (0, $ha1VO.Vector3).FromArrayToRef(data[8], 0, sp.xy);
        return sp;
    }
}

});

parcelRegister("ezAJn", function(module, exports) {

$parcel$export(module.exports, "RGBDTextureTools", () => $a9c0d3953d157ad8$export$830af874ede28300);

var $cFdBb = parcelRequire("cFdBb");
parcelRequire("iga8F");
parcelRequire("4PdZs");

var $3a58A = parcelRequire("3a58A");
class $a9c0d3953d157ad8$export$830af874ede28300 {
    /**
     * Expand the RGBD Texture from RGBD to Half Float if possible.
     * @param texture the texture to expand.
     */ static ExpandRGBDTexture(texture) {
        const internalTexture = texture._texture;
        if (!internalTexture || !texture.isRGBD) return;
        // Gets everything ready.
        const engine = internalTexture.getEngine();
        const caps = engine.getCaps();
        const isReady = internalTexture.isReady;
        let expandTexture = false;
        // If half float available we can uncompress the texture
        if (caps.textureHalfFloatRender && caps.textureHalfFloatLinearFiltering) {
            expandTexture = true;
            internalTexture.type = 2;
        } else if (caps.textureFloatRender && caps.textureFloatLinearFiltering) {
            expandTexture = true;
            internalTexture.type = 1;
        }
        if (expandTexture) {
            // Do not use during decode.
            internalTexture.isReady = false;
            internalTexture._isRGBD = false;
            internalTexture.invertY = false;
        }
        const expandRGBDTexture = ()=>{
            // Expand the texture if possible
            // Simply run through the decode PP.
            const rgbdPostProcess = new (0, $cFdBb.PostProcess)("rgbdDecode", "rgbdDecode", null, null, 1, null, 3, engine, false, undefined, internalTexture.type, undefined, null, false);
            rgbdPostProcess.externalTextureSamplerBinding = true;
            // Hold the output of the decoding.
            const expandedTexture = engine.createRenderTargetTexture(internalTexture.width, {
                generateDepthBuffer: false,
                generateMipMaps: false,
                generateStencilBuffer: false,
                samplingMode: internalTexture.samplingMode,
                type: internalTexture.type,
                format: 5
            });
            rgbdPostProcess.getEffect().executeWhenCompiled(()=>{
                // PP Render Pass
                rgbdPostProcess.onApply = (effect)=>{
                    effect._bindTexture("textureSampler", internalTexture);
                    effect.setFloat2("scale", 1, 1);
                };
                texture.getScene().postProcessManager.directRender([
                    rgbdPostProcess
                ], expandedTexture, true);
                // Cleanup
                engine.restoreDefaultFramebuffer();
                engine._releaseTexture(internalTexture);
                if (rgbdPostProcess) rgbdPostProcess.dispose();
                // Internal Swap
                expandedTexture._swapAndDie(internalTexture);
                // Ready to get rolling again.
                internalTexture.isReady = true;
            });
        };
        if (expandTexture) {
            if (isReady) expandRGBDTexture();
            else texture.onLoadObservable.addOnce(expandRGBDTexture);
        }
    }
    /**
     * Encode the texture to RGBD if possible.
     * @param internalTexture the texture to encode
     * @param scene the scene hosting the texture
     * @param outputTextureType type of the texture in which the encoding is performed
     * @returns a promise with the internalTexture having its texture replaced by the result of the processing
     */ static EncodeTextureToRGBD(internalTexture, scene, outputTextureType = 0) {
        return (0, $3a58A.ApplyPostProcess)("rgbdEncode", internalTexture, scene, outputTextureType, 1, 5);
    }
}

});
parcelRegister("iga8F", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("7Hs3g");
const $d4b195fb9291603e$var$name = "rgbdDecodePixelShader";
const $d4b195fb9291603e$var$shader = `varying vec2 vUV;uniform sampler2D textureSampler;
#include<helperFunctions>
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) 
{gl_FragColor=vec4(fromRGBD(texture2D(textureSampler,vUV)),1.0);}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$d4b195fb9291603e$var$name] = $d4b195fb9291603e$var$shader;
const $d4b195fb9291603e$export$d316ba7544f9a819 = {
    name: $d4b195fb9291603e$var$name,
    shader: $d4b195fb9291603e$var$shader
};

});

parcelRegister("3a58A", function(module, exports) {

$parcel$export(module.exports, "CreateResizedCopy", () => $24d64a7d7323dd8e$export$f5f561941aa9097e);
$parcel$export(module.exports, "ApplyPostProcess", () => $24d64a7d7323dd8e$export$50c14c27a16a988);
$parcel$export(module.exports, "ToHalfFloat", () => $24d64a7d7323dd8e$export$f9247396957e683e);
$parcel$export(module.exports, "FromHalfFloat", () => $24d64a7d7323dd8e$export$852641ed6d1954c7);
$parcel$export(module.exports, "GetTextureDataAsync", () => $24d64a7d7323dd8e$export$834f41e8012cbf57);
$parcel$export(module.exports, "TextureTools", () => $24d64a7d7323dd8e$export$fe09fd150f745687);

var $j2mX5 = parcelRequire("j2mX5");

var $gQtNK = parcelRequire("gQtNK");

var $c7c1r = parcelRequire("c7c1r");

var $cFdBb = parcelRequire("cFdBb");
function $24d64a7d7323dd8e$export$f5f561941aa9097e(texture, width, height, useBilinearMode = true) {
    const scene = texture.getScene();
    const engine = scene.getEngine();
    const rtt = new (0, $gQtNK.RenderTargetTexture)("resized" + texture.name, {
        width: width,
        height: height
    }, scene, !texture.noMipmap, true, texture._texture.type, false, texture.samplingMode, false);
    rtt.wrapU = texture.wrapU;
    rtt.wrapV = texture.wrapV;
    rtt.uOffset = texture.uOffset;
    rtt.vOffset = texture.vOffset;
    rtt.uScale = texture.uScale;
    rtt.vScale = texture.vScale;
    rtt.uAng = texture.uAng;
    rtt.vAng = texture.vAng;
    rtt.wAng = texture.wAng;
    rtt.coordinatesIndex = texture.coordinatesIndex;
    rtt.level = texture.level;
    rtt.anisotropicFilteringLevel = texture.anisotropicFilteringLevel;
    rtt._texture.isReady = false;
    texture.wrapU = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
    texture.wrapV = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
    const passPostProcess = new (0, $c7c1r.PassPostProcess)("pass", 1, null, useBilinearMode ? (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE : (0, $j2mX5.Texture).NEAREST_SAMPLINGMODE, engine, false, 0);
    passPostProcess.externalTextureSamplerBinding = true;
    passPostProcess.getEffect().executeWhenCompiled(()=>{
        passPostProcess.onApply = function(effect) {
            effect.setTexture("textureSampler", texture);
        };
        const internalTexture = rtt.renderTarget;
        if (internalTexture) {
            scene.postProcessManager.directRender([
                passPostProcess
            ], internalTexture);
            engine.unBindFramebuffer(internalTexture);
            rtt.disposeFramebufferObjects();
            passPostProcess.dispose();
            rtt.getInternalTexture().isReady = true;
        }
    });
    return rtt;
}
function $24d64a7d7323dd8e$export$50c14c27a16a988(postProcessName, internalTexture, scene, type, samplingMode, format, width, height) {
    // Gets everything ready.
    const engine = internalTexture.getEngine();
    internalTexture.isReady = false;
    samplingMode = samplingMode ?? internalTexture.samplingMode;
    type = type ?? internalTexture.type;
    format = format ?? internalTexture.format;
    width = width ?? internalTexture.width;
    height = height ?? internalTexture.height;
    if (type === -1) type = 0;
    return new Promise((resolve)=>{
        // Create the post process
        const postProcess = new (0, $cFdBb.PostProcess)("postprocess", postProcessName, null, null, 1, null, samplingMode, engine, false, undefined, type, undefined, null, false, format);
        postProcess.externalTextureSamplerBinding = true;
        // Hold the output of the decoding.
        const encodedTexture = engine.createRenderTargetTexture({
            width: width,
            height: height
        }, {
            generateDepthBuffer: false,
            generateMipMaps: false,
            generateStencilBuffer: false,
            samplingMode: samplingMode,
            type: type,
            format: format
        });
        postProcess.getEffect().executeWhenCompiled(()=>{
            // PP Render Pass
            postProcess.onApply = (effect)=>{
                effect._bindTexture("textureSampler", internalTexture);
                effect.setFloat2("scale", 1, 1);
            };
            scene.postProcessManager.directRender([
                postProcess
            ], encodedTexture, true);
            // Cleanup
            engine.restoreDefaultFramebuffer();
            engine._releaseTexture(internalTexture);
            if (postProcess) postProcess.dispose();
            // Internal Swap
            encodedTexture._swapAndDie(internalTexture);
            // Ready to get rolling again.
            internalTexture.type = type;
            internalTexture.format = 5;
            internalTexture.isReady = true;
            resolve(internalTexture);
        });
    });
}
// ref: http://stackoverflow.com/questions/32633585/how-do-you-convert-to-half-floats-in-javascript
let $24d64a7d7323dd8e$var$floatView;
let $24d64a7d7323dd8e$var$int32View;
function $24d64a7d7323dd8e$export$f9247396957e683e(value) {
    if (!$24d64a7d7323dd8e$var$floatView) {
        $24d64a7d7323dd8e$var$floatView = new Float32Array(1);
        $24d64a7d7323dd8e$var$int32View = new Int32Array($24d64a7d7323dd8e$var$floatView.buffer);
    }
    $24d64a7d7323dd8e$var$floatView[0] = value;
    const x = $24d64a7d7323dd8e$var$int32View[0];
    let bits = x >> 16 & 0x8000; /* Get the sign */ 
    let m = x >> 12 & 0x07ff; /* Keep one extra bit for rounding */ 
    const e = x >> 23 & 0xff; /* Using int is faster here */ 
    /* If zero, or denormal, or exponent underflows too much for a denormal
     * half, return signed zero. */ if (e < 103) return bits;
    /* If NaN, return NaN. If Inf or exponent overflow, return Inf. */ if (e > 142) {
        bits |= 0x7c00;
        /* If exponent was 0xff and one mantissa bit was set, it means NaN,
         * not Inf, so make sure we set one mantissa bit too. */ bits |= (e == 255 ? 0 : 1) && x & 0x007fffff;
        return bits;
    }
    /* If exponent underflows but not too much, return a denormal */ if (e < 113) {
        m |= 0x0800;
        /* Extra rounding may overflow and set mantissa to 0 and exponent
         * to 1, which is OK. */ bits |= (m >> 114 - e) + (m >> 113 - e & 1);
        return bits;
    }
    bits |= e - 112 << 10 | m >> 1;
    bits += m & 1;
    return bits;
}
function $24d64a7d7323dd8e$export$852641ed6d1954c7(value) {
    const s = (value & 0x8000) >> 15;
    const e = (value & 0x7c00) >> 10;
    const f = value & 0x03ff;
    if (e === 0) return (s ? -1 : 1) * Math.pow(2, -14) * (f / Math.pow(2, 10));
    else if (e == 0x1f) return f ? NaN : (s ? -1 : 1) * Infinity;
    return (s ? -1 : 1) * Math.pow(2, e - 15) * (1 + f / Math.pow(2, 10));
}
const $24d64a7d7323dd8e$var$ProcessAsync = async (texture, width, height, face, lod)=>{
    const scene = texture.getScene();
    const engine = scene.getEngine();
    let lodPostProcess;
    if (!texture.isCube) lodPostProcess = new (0, $cFdBb.PostProcess)("lod", "lod", [
        "lod",
        "gamma"
    ], null, 1.0, null, (0, $j2mX5.Texture).NEAREST_NEAREST_MIPNEAREST, engine);
    else {
        const faceDefines = [
            "#define POSITIVEX",
            "#define NEGATIVEX",
            "#define POSITIVEY",
            "#define NEGATIVEY",
            "#define POSITIVEZ",
            "#define NEGATIVEZ"
        ];
        lodPostProcess = new (0, $cFdBb.PostProcess)("lodCube", "lodCube", [
            "lod",
            "gamma"
        ], null, 1.0, null, (0, $j2mX5.Texture).NEAREST_NEAREST_MIPNEAREST, engine, false, faceDefines[face]);
    }
    await new Promise((resolve)=>{
        lodPostProcess.getEffect().executeWhenCompiled(()=>{
            resolve(0);
        });
    });
    const rtt = new (0, $gQtNK.RenderTargetTexture)("temp", {
        width: width,
        height: height
    }, scene, false);
    lodPostProcess.onApply = function(effect) {
        effect.setTexture("textureSampler", texture);
        effect.setFloat("lod", lod);
        effect.setBool("gamma", texture.gammaSpace);
    };
    const internalTexture = texture.getInternalTexture();
    try {
        if (rtt.renderTarget && internalTexture) {
            const samplingMode = internalTexture.samplingMode;
            if (lod !== 0) texture.updateSamplingMode((0, $j2mX5.Texture).NEAREST_NEAREST_MIPNEAREST);
            else texture.updateSamplingMode((0, $j2mX5.Texture).NEAREST_NEAREST);
            scene.postProcessManager.directRender([
                lodPostProcess
            ], rtt.renderTarget, true);
            texture.updateSamplingMode(samplingMode);
            //Reading datas from WebGL
            const bufferView = await engine.readPixels(0, 0, width, height);
            const data = new Uint8Array(bufferView.buffer, 0, bufferView.byteLength);
            // Unbind
            engine.unBindFramebuffer(rtt.renderTarget);
            return data;
        } else throw Error("Render to texture failed.");
    } finally{
        rtt.dispose();
        lodPostProcess.dispose();
    }
};
async function $24d64a7d7323dd8e$export$834f41e8012cbf57(texture, width, height, face = 0, lod = 0) {
    if (!texture.isReady() && texture._texture) await new Promise((resolve, reject)=>{
        if (texture._texture === null) {
            reject(0);
            return;
        }
        texture._texture.onLoadedObservable.addOnce(()=>{
            resolve(0);
        });
    });
    return await $24d64a7d7323dd8e$var$ProcessAsync(texture, width, height, face, lod);
}
const $24d64a7d7323dd8e$export$fe09fd150f745687 = {
    CreateResizedCopy: /**
     * Uses the GPU to create a copy texture rescaled at a given size
     * @param texture Texture to copy from
     * @param width defines the desired width
     * @param height defines the desired height
     * @param useBilinearMode defines if bilinear mode has to be used
     * @returns the generated texture
     */ $24d64a7d7323dd8e$export$f5f561941aa9097e,
    ApplyPostProcess: /**
     * Apply a post process to a texture
     * @param postProcessName name of the fragment post process
     * @param internalTexture the texture to encode
     * @param scene the scene hosting the texture
     * @param type type of the output texture. If not provided, use the one from internalTexture
     * @param samplingMode sampling mode to use to sample the source texture. If not provided, use the one from internalTexture
     * @param format format of the output texture. If not provided, use the one from internalTexture
     * @returns a promise with the internalTexture having its texture replaced by the result of the processing
     */ $24d64a7d7323dd8e$export$50c14c27a16a988,
    ToHalfFloat: /**
     * Converts a number to half float
     * @param value number to convert
     * @returns converted number
     */ $24d64a7d7323dd8e$export$f9247396957e683e,
    FromHalfFloat: /**
     * Converts a half float to a number
     * @param value half float to convert
     * @returns converted half float
     */ $24d64a7d7323dd8e$export$852641ed6d1954c7,
    GetTextureDataAsync: /**
     * Gets the data of the specified texture by rendering it to an intermediate RGBA texture and retrieving the bytes from it.
     * This is convienent to get 8-bit RGBA values for a texture in a GPU compressed format.
     * @param texture the source texture
     * @param width the width of the result, which does not have to match the source texture width
     * @param height the height of the result, which does not have to match the source texture height
     * @param face if the texture has multiple faces, the face index to use for the source
     * @param channels a filter for which of the RGBA channels to return in the result
     * @param lod if the texture has multiple LODs, the lod index to use for the source
     * @returns the 8-bit texture data
     */ $24d64a7d7323dd8e$export$834f41e8012cbf57
};

});


parcelRegister("90OM8", function(module, exports) {

var $4p0qs = parcelRequire("4p0qs");

var $akOl3 = parcelRequire("akOl3");
(0, $akOl3.BaseTexture).prototype.forceSphericalPolynomialsRecompute = function() {
    if (this._texture) {
        this._texture._sphericalPolynomial = null;
        this._texture._sphericalPolynomialPromise = null;
        this._texture._sphericalPolynomialComputed = false;
    }
};
Object.defineProperty((0, $akOl3.BaseTexture).prototype, "sphericalPolynomial", {
    get: function() {
        if (this._texture) {
            if (this._texture._sphericalPolynomial || this._texture._sphericalPolynomialComputed) return this._texture._sphericalPolynomial;
            if (this._texture.isReady) {
                if (!this._texture._sphericalPolynomialPromise) {
                    this._texture._sphericalPolynomialPromise = (0, $4p0qs.CubeMapToSphericalPolynomialTools).ConvertCubeMapTextureToSphericalPolynomial(this);
                    if (this._texture._sphericalPolynomialPromise === null) this._texture._sphericalPolynomialComputed = true;
                    else this._texture._sphericalPolynomialPromise.then((sphericalPolynomial)=>{
                        this._texture._sphericalPolynomial = sphericalPolynomial;
                        this._texture._sphericalPolynomialComputed = true;
                    });
                }
                return null;
            }
        }
        return null;
    },
    set: function(value) {
        if (this._texture) this._texture._sphericalPolynomial = value;
    },
    enumerable: true,
    configurable: true
});

});
parcelRegister("4p0qs", function(module, exports) {

$parcel$export(module.exports, "CubeMapToSphericalPolynomialTools", () => $3349d3bf3eefb30b$export$d730b573f70c0bf1);

var $ha1VO = parcelRequire("ha1VO");

var $1VEEL = parcelRequire("1VEEL");

var $f3g09 = parcelRequire("f3g09");

var $53VPf = parcelRequire("53VPf");

var $7etnY = parcelRequire("7etnY");
class $3349d3bf3eefb30b$var$FileFaceOrientation {
    constructor(name, worldAxisForNormal, worldAxisForFileX, worldAxisForFileY){
        this.name = name;
        this.worldAxisForNormal = worldAxisForNormal;
        this.worldAxisForFileX = worldAxisForFileX;
        this.worldAxisForFileY = worldAxisForFileY;
    }
}
class $3349d3bf3eefb30b$export$d730b573f70c0bf1 {
    /**
     * Converts a texture to the according Spherical Polynomial data.
     * This extracts the first 3 orders only as they are the only one used in the lighting.
     *
     * @param texture The texture to extract the information from.
     * @returns The Spherical Polynomial data.
     */ static ConvertCubeMapTextureToSphericalPolynomial(texture) {
        if (!texture.isCube) // Only supports cube Textures currently.
        return null;
        texture.getScene()?.getEngine().flushFramebuffer();
        const size = texture.getSize().width;
        const rightPromise = texture.readPixels(0, undefined, undefined, false);
        const leftPromise = texture.readPixels(1, undefined, undefined, false);
        let upPromise;
        let downPromise;
        if (texture.isRenderTarget) {
            upPromise = texture.readPixels(3, undefined, undefined, false);
            downPromise = texture.readPixels(2, undefined, undefined, false);
        } else {
            upPromise = texture.readPixels(2, undefined, undefined, false);
            downPromise = texture.readPixels(3, undefined, undefined, false);
        }
        const frontPromise = texture.readPixels(4, undefined, undefined, false);
        const backPromise = texture.readPixels(5, undefined, undefined, false);
        const gammaSpace = texture.gammaSpace;
        // Always read as RGBA.
        const format = 5;
        let type = 0;
        if (texture.textureType == 1 || texture.textureType == 2) type = 1;
        return new Promise((resolve)=>{
            Promise.all([
                leftPromise,
                rightPromise,
                upPromise,
                downPromise,
                frontPromise,
                backPromise
            ]).then(([left, right, up, down, front, back])=>{
                const cubeInfo = {
                    size: size,
                    right: right,
                    left: left,
                    up: up,
                    down: down,
                    front: front,
                    back: back,
                    format: format,
                    type: type,
                    gammaSpace: gammaSpace
                };
                resolve(this.ConvertCubeMapToSphericalPolynomial(cubeInfo));
            });
        });
    }
    /**
     * Compute the area on the unit sphere of the rectangle defined by (x,y) and the origin
     * See https://www.rorydriscoll.com/2012/01/15/cubemap-texel-solid-angle/
     * @param x
     * @param y
     * @returns the area
     */ static _AreaElement(x, y) {
        return Math.atan2(x * y, Math.sqrt(x * x + y * y + 1));
    }
    /**
     * Converts a cubemap to the according Spherical Polynomial data.
     * This extracts the first 3 orders only as they are the only one used in the lighting.
     *
     * @param cubeInfo The Cube map to extract the information from.
     * @returns The Spherical Polynomial data.
     */ static ConvertCubeMapToSphericalPolynomial(cubeInfo) {
        const sphericalHarmonics = new (0, $f3g09.SphericalHarmonics)();
        let totalSolidAngle = 0.0;
        // The (u,v) range is [-1,+1], so the distance between each texel is 2/Size.
        const du = 2.0 / cubeInfo.size;
        const dv = du;
        const halfTexel = 0.5 * du;
        // The (u,v) of the first texel is half a texel from the corner (-1,-1).
        const minUV = halfTexel - 1.0;
        for(let faceIndex = 0; faceIndex < 6; faceIndex++){
            const fileFace = this._FileFaces[faceIndex];
            const dataArray = cubeInfo[fileFace.name];
            let v = minUV;
            // TODO: we could perform the summation directly into a SphericalPolynomial (SP), which is more efficient than SphericalHarmonic (SH).
            // This is possible because during the summation we do not need the SH-specific properties, e.g. orthogonality.
            // Because SP is still linear, so summation is fine in that basis.
            const stride = cubeInfo.format === 5 ? 4 : 3;
            for(let y = 0; y < cubeInfo.size; y++){
                let u = minUV;
                for(let x = 0; x < cubeInfo.size; x++){
                    // World direction (not normalised)
                    const worldDirection = fileFace.worldAxisForFileX.scale(u).add(fileFace.worldAxisForFileY.scale(v)).add(fileFace.worldAxisForNormal);
                    worldDirection.normalize();
                    const deltaSolidAngle = this._AreaElement(u - halfTexel, v - halfTexel) - this._AreaElement(u - halfTexel, v + halfTexel) - this._AreaElement(u + halfTexel, v - halfTexel) + this._AreaElement(u + halfTexel, v + halfTexel);
                    let r = dataArray[y * cubeInfo.size * stride + x * stride + 0];
                    let g = dataArray[y * cubeInfo.size * stride + x * stride + 1];
                    let b = dataArray[y * cubeInfo.size * stride + x * stride + 2];
                    // Prevent NaN harmonics with extreme HDRI data.
                    if (isNaN(r)) r = 0;
                    if (isNaN(g)) g = 0;
                    if (isNaN(b)) b = 0;
                    // Handle Integer types.
                    if (cubeInfo.type === 0) {
                        r /= 255;
                        g /= 255;
                        b /= 255;
                    }
                    // Handle Gamma space textures.
                    if (cubeInfo.gammaSpace) {
                        r = Math.pow((0, $1VEEL.Scalar).Clamp(r), (0, $53VPf.ToLinearSpace));
                        g = Math.pow((0, $1VEEL.Scalar).Clamp(g), (0, $53VPf.ToLinearSpace));
                        b = Math.pow((0, $1VEEL.Scalar).Clamp(b), (0, $53VPf.ToLinearSpace));
                    }
                    // Prevent to explode in case of really high dynamic ranges.
                    // sh 3 would not be enough to accurately represent it.
                    const max = this.MAX_HDRI_VALUE;
                    if (this.PRESERVE_CLAMPED_COLORS) {
                        const currentMax = Math.max(r, g, b);
                        if (currentMax > max) {
                            const factor = max / currentMax;
                            r *= factor;
                            g *= factor;
                            b *= factor;
                        }
                    } else {
                        r = (0, $1VEEL.Scalar).Clamp(r, 0, max);
                        g = (0, $1VEEL.Scalar).Clamp(g, 0, max);
                        b = (0, $1VEEL.Scalar).Clamp(b, 0, max);
                    }
                    const color = new (0, $7etnY.Color3)(r, g, b);
                    sphericalHarmonics.addLight(worldDirection, color, deltaSolidAngle);
                    totalSolidAngle += deltaSolidAngle;
                    u += du;
                }
                v += dv;
            }
        }
        // Solid angle for entire sphere is 4*pi
        const sphereSolidAngle = 4.0 * Math.PI;
        // Adjust the solid angle to allow for how many faces we processed.
        const facesProcessed = 6.0;
        const expectedSolidAngle = sphereSolidAngle * facesProcessed / 6.0;
        // Adjust the harmonics so that the accumulated solid angle matches the expected solid angle.
        // This is needed because the numerical integration over the cube uses a
        // small angle approximation of solid angle for each texel (see deltaSolidAngle),
        // and also to compensate for accumulative error due to float precision in the summation.
        const correctionFactor = expectedSolidAngle / totalSolidAngle;
        sphericalHarmonics.scaleInPlace(correctionFactor);
        sphericalHarmonics.convertIncidentRadianceToIrradiance();
        sphericalHarmonics.convertIrradianceToLambertianRadiance();
        return (0, $f3g09.SphericalPolynomial).FromHarmonics(sphericalHarmonics);
    }
}
$3349d3bf3eefb30b$export$d730b573f70c0bf1._FileFaces = [
    new $3349d3bf3eefb30b$var$FileFaceOrientation("right", new (0, $ha1VO.Vector3)(1, 0, 0), new (0, $ha1VO.Vector3)(0, 0, -1), new (0, $ha1VO.Vector3)(0, -1, 0)),
    new $3349d3bf3eefb30b$var$FileFaceOrientation("left", new (0, $ha1VO.Vector3)(-1, 0, 0), new (0, $ha1VO.Vector3)(0, 0, 1), new (0, $ha1VO.Vector3)(0, -1, 0)),
    new $3349d3bf3eefb30b$var$FileFaceOrientation("up", new (0, $ha1VO.Vector3)(0, 1, 0), new (0, $ha1VO.Vector3)(1, 0, 0), new (0, $ha1VO.Vector3)(0, 0, 1)),
    new $3349d3bf3eefb30b$var$FileFaceOrientation("down", new (0, $ha1VO.Vector3)(0, -1, 0), new (0, $ha1VO.Vector3)(1, 0, 0), new (0, $ha1VO.Vector3)(0, 0, -1)),
    new $3349d3bf3eefb30b$var$FileFaceOrientation("front", new (0, $ha1VO.Vector3)(0, 0, 1), new (0, $ha1VO.Vector3)(1, 0, 0), new (0, $ha1VO.Vector3)(0, -1, 0)),
    new $3349d3bf3eefb30b$var$FileFaceOrientation("back", new (0, $ha1VO.Vector3)(0, 0, -1), new (0, $ha1VO.Vector3)(-1, 0, 0), new (0, $ha1VO.Vector3)(0, -1, 0))
];
/** @internal */ $3349d3bf3eefb30b$export$d730b573f70c0bf1.MAX_HDRI_VALUE = 4096;
/** @internal */ $3349d3bf3eefb30b$export$d730b573f70c0bf1.PRESERVE_CLAMPED_COLORS = false;

});


parcelRegister("67vjG", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("7Hs3g");
const $474bb04f518d20f4$var$name = "rgbdEncodePixelShader";
const $474bb04f518d20f4$var$shader = `varying vec2 vUV;uniform sampler2D textureSampler;
#include<helperFunctions>
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) 
{gl_FragColor=toRGBD(texture2D(textureSampler,vUV).rgb);}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$474bb04f518d20f4$var$name] = $474bb04f518d20f4$var$shader;
const $474bb04f518d20f4$export$c0964b10a9bed276 = {
    name: $474bb04f518d20f4$var$name,
    shader: $474bb04f518d20f4$var$shader
};

});


parcelRegister("lh6wJ", function(module, exports) {

$parcel$export(module.exports, "ShaderCodeInliner", () => $f7d03fa12c82de68$export$941ad394a556e13a);

var $kVtWi = parcelRequire("kVtWi");

var $kjb7H = parcelRequire("kjb7H");
class $f7d03fa12c82de68$export$941ad394a556e13a {
    /** Gets the code after the inlining process */ get code() {
        return this._sourceCode;
    }
    /**
     * Initializes the inliner
     * @param sourceCode shader code source to inline
     * @param numMaxIterations maximum number of iterations (used to detect recursive calls)
     */ constructor(sourceCode, numMaxIterations = 20){
        /** Gets or sets the debug mode */ this.debug = false;
        this._sourceCode = sourceCode;
        this._numMaxIterations = numMaxIterations;
        this._functionDescr = [];
        this.inlineToken = "#define inline";
    }
    /**
     * Start the processing of the shader code
     */ processCode() {
        if (this.debug) (0, $kVtWi.Logger).Log(`Start inlining process (code size=${this._sourceCode.length})...`);
        this._collectFunctions();
        this._processInlining(this._numMaxIterations);
        if (this.debug) (0, $kVtWi.Logger).Log("End of inlining process.");
    }
    _collectFunctions() {
        let startIndex = 0;
        while(startIndex < this._sourceCode.length){
            // locate the function to inline and extract its name
            const inlineTokenIndex = this._sourceCode.indexOf(this.inlineToken, startIndex);
            if (inlineTokenIndex < 0) break;
            const funcParamsStartIndex = this._sourceCode.indexOf("(", inlineTokenIndex + this.inlineToken.length);
            if (funcParamsStartIndex < 0) {
                if (this.debug) (0, $kVtWi.Logger).Warn(`Could not find the opening parenthesis after the token. startIndex=${startIndex}`);
                startIndex = inlineTokenIndex + this.inlineToken.length;
                continue;
            }
            const funcNameMatch = $f7d03fa12c82de68$export$941ad394a556e13a._RegexpFindFunctionNameAndType.exec(this._sourceCode.substring(inlineTokenIndex + this.inlineToken.length, funcParamsStartIndex));
            if (!funcNameMatch) {
                if (this.debug) (0, $kVtWi.Logger).Warn(`Could not extract the name/type of the function from: ${this._sourceCode.substring(inlineTokenIndex + this.inlineToken.length, funcParamsStartIndex)}`);
                startIndex = inlineTokenIndex + this.inlineToken.length;
                continue;
            }
            const [funcType, funcName] = [
                funcNameMatch[3],
                funcNameMatch[4]
            ];
            // extract the parameters of the function as a whole string (without the leading / trailing parenthesis)
            const funcParamsEndIndex = (0, $kjb7H.ExtractBetweenMarkers)("(", ")", this._sourceCode, funcParamsStartIndex);
            if (funcParamsEndIndex < 0) {
                if (this.debug) (0, $kVtWi.Logger).Warn(`Could not extract the parameters the function '${funcName}' (type=${funcType}). funcParamsStartIndex=${funcParamsStartIndex}`);
                startIndex = inlineTokenIndex + this.inlineToken.length;
                continue;
            }
            const funcParams = this._sourceCode.substring(funcParamsStartIndex + 1, funcParamsEndIndex);
            // extract the body of the function (with the curly brackets)
            const funcBodyStartIndex = (0, $kjb7H.SkipWhitespaces)(this._sourceCode, funcParamsEndIndex + 1);
            if (funcBodyStartIndex === this._sourceCode.length) {
                if (this.debug) (0, $kVtWi.Logger).Warn(`Could not extract the body of the function '${funcName}' (type=${funcType}). funcParamsEndIndex=${funcParamsEndIndex}`);
                startIndex = inlineTokenIndex + this.inlineToken.length;
                continue;
            }
            const funcBodyEndIndex = (0, $kjb7H.ExtractBetweenMarkers)("{", "}", this._sourceCode, funcBodyStartIndex);
            if (funcBodyEndIndex < 0) {
                if (this.debug) (0, $kVtWi.Logger).Warn(`Could not extract the body of the function '${funcName}' (type=${funcType}). funcBodyStartIndex=${funcBodyStartIndex}`);
                startIndex = inlineTokenIndex + this.inlineToken.length;
                continue;
            }
            const funcBody = this._sourceCode.substring(funcBodyStartIndex, funcBodyEndIndex + 1);
            // process the parameters: extract each names
            const params = (0, $kjb7H.RemoveComments)(funcParams).split(",");
            const paramNames = [];
            for(let p = 0; p < params.length; ++p){
                const param = params[p].trim();
                const idx = param.lastIndexOf(" ");
                if (idx >= 0) paramNames.push(param.substring(idx + 1));
            }
            if (funcType !== "void") // for functions that return a value, we will replace "return" by "tempvarname = ", tempvarname being a unique generated name
            paramNames.push("return");
            // collect the function
            this._functionDescr.push({
                name: funcName,
                type: funcType,
                parameters: paramNames,
                body: funcBody,
                callIndex: 0
            });
            startIndex = funcBodyEndIndex + 1;
            // remove the function from the source code
            const partBefore = inlineTokenIndex > 0 ? this._sourceCode.substring(0, inlineTokenIndex) : "";
            const partAfter = funcBodyEndIndex + 1 < this._sourceCode.length - 1 ? this._sourceCode.substring(funcBodyEndIndex + 1) : "";
            this._sourceCode = partBefore + partAfter;
            startIndex -= funcBodyEndIndex + 1 - inlineTokenIndex;
        }
        if (this.debug) (0, $kVtWi.Logger).Log(`Collect functions: ${this._functionDescr.length} functions found. functionDescr=${this._functionDescr}`);
    }
    _processInlining(numMaxIterations = 20) {
        while(numMaxIterations-- >= 0){
            if (!this._replaceFunctionCallsByCode()) break;
        }
        if (this.debug) (0, $kVtWi.Logger).Log(`numMaxIterations is ${numMaxIterations} after inlining process`);
        return numMaxIterations >= 0;
    }
    _replaceFunctionCallsByCode() {
        let doAgain = false;
        for (const func of this._functionDescr){
            const { name: name, type: type, parameters: parameters, body: body } = func;
            let startIndex = 0;
            while(startIndex < this._sourceCode.length){
                // Look for the function name in the source code
                const functionCallIndex = this._sourceCode.indexOf(name, startIndex);
                if (functionCallIndex < 0) break;
                // Make sure "name" is not part of a bigger string
                if (functionCallIndex === 0 || (0, $kjb7H.IsIdentifierChar)(this._sourceCode.charAt(functionCallIndex - 1))) {
                    startIndex = functionCallIndex + name.length;
                    continue;
                }
                // Find the opening parenthesis
                const callParamsStartIndex = (0, $kjb7H.SkipWhitespaces)(this._sourceCode, functionCallIndex + name.length);
                if (callParamsStartIndex === this._sourceCode.length || this._sourceCode.charAt(callParamsStartIndex) !== "(") {
                    startIndex = functionCallIndex + name.length;
                    continue;
                }
                // extract the parameters of the function call as a whole string (without the leading / trailing parenthesis)
                const callParamsEndIndex = (0, $kjb7H.ExtractBetweenMarkers)("(", ")", this._sourceCode, callParamsStartIndex);
                if (callParamsEndIndex < 0) {
                    if (this.debug) (0, $kVtWi.Logger).Warn(`Could not extract the parameters of the function call. Function '${name}' (type=${type}). callParamsStartIndex=${callParamsStartIndex}`);
                    startIndex = functionCallIndex + name.length;
                    continue;
                }
                const callParams = this._sourceCode.substring(callParamsStartIndex + 1, callParamsEndIndex);
                // process the parameter call: extract each names
                // this function split the parameter list used in the function call at ',' boundaries by taking care of potential parenthesis like in:
                //      myfunc(a, vec2(1., 0.), 4.)
                const splitParameterCall = (s)=>{
                    const parameters = [];
                    let curIdx = 0, startParamIdx = 0;
                    while(curIdx < s.length){
                        if (s.charAt(curIdx) === "(") {
                            const idx2 = (0, $kjb7H.ExtractBetweenMarkers)("(", ")", s, curIdx);
                            if (idx2 < 0) return null;
                            curIdx = idx2;
                        } else if (s.charAt(curIdx) === ",") {
                            parameters.push(s.substring(startParamIdx, curIdx));
                            startParamIdx = curIdx + 1;
                        }
                        curIdx++;
                    }
                    if (startParamIdx < curIdx) parameters.push(s.substring(startParamIdx, curIdx));
                    return parameters;
                };
                const params = splitParameterCall((0, $kjb7H.RemoveComments)(callParams));
                if (params === null) {
                    if (this.debug) (0, $kVtWi.Logger).Warn(`Invalid function call: can't extract the parameters of the function call. Function '${name}' (type=${type}). callParamsStartIndex=${callParamsStartIndex}, callParams=` + callParams);
                    startIndex = functionCallIndex + name.length;
                    continue;
                }
                const paramNames = [];
                for(let p = 0; p < params.length; ++p){
                    const param = params[p].trim();
                    paramNames.push(param);
                }
                const retParamName = type !== "void" ? name + "_" + func.callIndex++ : null;
                if (retParamName) paramNames.push(retParamName + " =");
                if (paramNames.length !== parameters.length) {
                    if (this.debug) (0, $kVtWi.Logger).Warn(`Invalid function call: not the same number of parameters for the call than the number expected by the function. Function '${name}' (type=${type}). function parameters=${parameters}, call parameters=${paramNames}`);
                    startIndex = functionCallIndex + name.length;
                    continue;
                }
                startIndex = callParamsEndIndex + 1;
                // replace the function call by the body function
                const funcBody = this._replaceNames(body, parameters, paramNames);
                let partBefore = functionCallIndex > 0 ? this._sourceCode.substring(0, functionCallIndex) : "";
                const partAfter = callParamsEndIndex + 1 < this._sourceCode.length - 1 ? this._sourceCode.substring(callParamsEndIndex + 1) : "";
                if (retParamName) {
                    // case where the function returns a value. We generate:
                    // FUNCTYPE retParamName;
                    // {function body}
                    // and replace the function call by retParamName
                    const injectDeclarationIndex = (0, $kjb7H.FindBackward)(this._sourceCode, functionCallIndex - 1, "\n", "{");
                    partBefore = this._sourceCode.substring(0, injectDeclarationIndex + 1);
                    const partBetween = this._sourceCode.substring(injectDeclarationIndex + 1, functionCallIndex);
                    this._sourceCode = partBefore + type + " " + retParamName + ";\n" + funcBody + "\n" + partBetween + retParamName + partAfter;
                    if (this.debug) (0, $kVtWi.Logger).Log(`Replace function call by code. Function '${name}' (type=${type}). injectDeclarationIndex=${injectDeclarationIndex}, call parameters=${paramNames}`);
                } else {
                    // simple case where the return value of the function is "void"
                    this._sourceCode = partBefore + funcBody + partAfter;
                    startIndex += funcBody.length - (callParamsEndIndex + 1 - functionCallIndex);
                    if (this.debug) (0, $kVtWi.Logger).Log(`Replace function call by code. Function '${name}' (type=${type}). functionCallIndex=${functionCallIndex}, call parameters=${paramNames}`);
                }
                doAgain = true;
            }
        }
        return doAgain;
    }
    _replaceNames(code, sources, destinations) {
        for(let i = 0; i < sources.length; ++i){
            const source = new RegExp((0, $kjb7H.EscapeRegExp)(sources[i]), "g"), sourceLen = sources[i].length, destination = destinations[i];
            code = code.replace(source, (match, ...args)=>{
                const offset = args[0];
                // Make sure "source" is not part of a bigger identifier (for eg, if source=view and we matched it with viewDirection)
                if ((0, $kjb7H.IsIdentifierChar)(code.charAt(offset - 1)) || (0, $kjb7H.IsIdentifierChar)(code.charAt(offset + sourceLen))) return sources[i];
                return destination;
            });
        }
        return code;
    }
}
$f7d03fa12c82de68$export$941ad394a556e13a._RegexpFindFunctionNameAndType = /((\s+?)(\w+)\s+(\w+)\s*?)$/;

});
parcelRegister("kjb7H", function(module, exports) {

$parcel$export(module.exports, "ExtractBetweenMarkers", () => $ec8e35da3bbafb6d$export$9e4cb59cc3d72e89);
$parcel$export(module.exports, "SkipWhitespaces", () => $ec8e35da3bbafb6d$export$ba306e682f968f2a);
$parcel$export(module.exports, "IsIdentifierChar", () => $ec8e35da3bbafb6d$export$2bee1fea10f57673);
$parcel$export(module.exports, "RemoveComments", () => $ec8e35da3bbafb6d$export$cc1ca74468765ca4);
$parcel$export(module.exports, "FindBackward", () => $ec8e35da3bbafb6d$export$f4549d6cd3476ec5);
$parcel$export(module.exports, "EscapeRegExp", () => $ec8e35da3bbafb6d$export$17e5f578a789572c);
/**
 * Extracts the characters between two markers (for eg, between "(" and ")"). The function handles nested markers as well as markers inside strings (delimited by ", ' or `) and comments
 * @param markerOpen opening marker
 * @param markerClose closing marker
 * @param block code block to parse
 * @param startIndex starting index in block where the extraction must start. The character at block[startIndex] should be the markerOpen character!
 * @returns index of the last character for the extraction (or -1 if the string is invalid - no matching closing marker found). The string to extract (without the markers) is the string between startIndex + 1 and the returned value (exclusive)
 */ function $ec8e35da3bbafb6d$export$9e4cb59cc3d72e89(markerOpen, markerClose, block, startIndex) {
    let currPos = startIndex, openMarkers = 0, waitForChar = "";
    while(currPos < block.length){
        const currChar = block.charAt(currPos);
        if (!waitForChar) switch(currChar){
            case markerOpen:
                openMarkers++;
                break;
            case markerClose:
                openMarkers--;
                break;
            case '"':
            case "'":
            case "`":
                waitForChar = currChar;
                break;
            case "/":
                if (currPos + 1 < block.length) {
                    const nextChar = block.charAt(currPos + 1);
                    if (nextChar === "/") waitForChar = "\n";
                    else if (nextChar === "*") waitForChar = "*/";
                }
                break;
        }
        else {
            if (currChar === waitForChar) {
                if (waitForChar === '"' || waitForChar === "'") block.charAt(currPos - 1) !== "\\" && (waitForChar = "");
                else waitForChar = "";
            } else if (waitForChar === "*/" && currChar === "*" && currPos + 1 < block.length) {
                block.charAt(currPos + 1) === "/" && (waitForChar = "");
                if (waitForChar === "") currPos++;
            }
        }
        currPos++;
        if (openMarkers === 0) break;
    }
    return openMarkers === 0 ? currPos - 1 : -1;
}
function $ec8e35da3bbafb6d$export$ba306e682f968f2a(s, index) {
    while(index < s.length){
        const c = s[index];
        if (c !== " " && c !== "\n" && c !== "\r" && c !== "\t" && c !== "\u000a" && c !== "\u00a0") break;
        index++;
    }
    return index;
}
function $ec8e35da3bbafb6d$export$2bee1fea10f57673(c) {
    const v = c.charCodeAt(0);
    return v >= 48 && v <= 57 || // 0-9
    v >= 65 && v <= 90 || // A-Z
    v >= 97 && v <= 122 || // a-z
    v == 95; // _
}
function $ec8e35da3bbafb6d$export$cc1ca74468765ca4(block) {
    let currPos = 0, waitForChar = "", inComments = false;
    const s = [];
    while(currPos < block.length){
        const currChar = block.charAt(currPos);
        if (!waitForChar) {
            switch(currChar){
                case '"':
                case "'":
                case "`":
                    waitForChar = currChar;
                    break;
                case "/":
                    if (currPos + 1 < block.length) {
                        const nextChar = block.charAt(currPos + 1);
                        if (nextChar === "/") {
                            waitForChar = "\n";
                            inComments = true;
                        } else if (nextChar === "*") {
                            waitForChar = "*/";
                            inComments = true;
                        }
                    }
                    break;
            }
            if (!inComments) s.push(currChar);
        } else {
            if (currChar === waitForChar) {
                if (waitForChar === '"' || waitForChar === "'") {
                    block.charAt(currPos - 1) !== "\\" && (waitForChar = "");
                    s.push(currChar);
                } else {
                    waitForChar = "";
                    inComments = false;
                }
            } else if (waitForChar === "*/" && currChar === "*" && currPos + 1 < block.length) {
                block.charAt(currPos + 1) === "/" && (waitForChar = "");
                if (waitForChar === "") {
                    inComments = false;
                    currPos++;
                }
            } else if (!inComments) s.push(currChar);
        }
        currPos++;
    }
    return s.join("");
}
function $ec8e35da3bbafb6d$export$f4549d6cd3476ec5(s, index, c, c2) {
    while(index >= 0 && s.charAt(index) !== c && (!c2 || s.charAt(index) !== c2))index--;
    return index;
}
function $ec8e35da3bbafb6d$export$17e5f578a789572c(s) {
    return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

});


parcelRegister("bxCN4", function(module, exports) {

$parcel$export(module.exports, "NativePipelineContext", () => $8670ddc4fd83fc0e$export$6d966eb6bb3ea0a6);
class $8670ddc4fd83fc0e$export$6d966eb6bb3ea0a6 {
    get isReady() {
        if (this.compilationError) {
            const message = this.compilationError.message;
            throw new Error("SHADER ERROR" + (typeof message === "string" ? "\n" + message : ""));
        }
        return this.isCompiled;
    }
    _getVertexShaderCode() {
        return null;
    }
    _getFragmentShaderCode() {
        return null;
    }
    constructor(engine, isAsync){
        this.isCompiled = false;
        this._valueCache = {};
        this._engine = engine;
        this.isAsync = isAsync;
    }
    _fillEffectInformation(effect, uniformBuffersNames, uniformsNames, uniforms, samplerList, samplers, attributesNames, attributes) {
        const engine = this._engine;
        if (engine.supportsUniformBuffers) for(const name in uniformBuffersNames)effect.bindUniformBlock(name, uniformBuffersNames[name]);
        const effectAvailableUniforms = this._engine.getUniforms(this, uniformsNames);
        effectAvailableUniforms.forEach((uniform, index)=>{
            uniforms[uniformsNames[index]] = uniform;
        });
        this._uniforms = uniforms;
        let index;
        for(index = 0; index < samplerList.length; index++){
            const sampler = effect.getUniform(samplerList[index]);
            if (sampler == null) {
                samplerList.splice(index, 1);
                index--;
            }
        }
        samplerList.forEach((name, index)=>{
            samplers[name] = index;
        });
        attributes.push(...engine.getAttributes(this, attributesNames));
    }
    /**
     * Release all associated resources.
     **/ dispose() {
        this._uniforms = {};
    }
    /**
     * @internal
     */ _cacheMatrix(uniformName, matrix) {
        const cache = this._valueCache[uniformName];
        const flag = matrix.updateFlag;
        if (cache !== undefined && cache === flag) return false;
        this._valueCache[uniformName] = flag;
        return true;
    }
    /**
     * @internal
     */ _cacheFloat2(uniformName, x, y) {
        let cache = this._valueCache[uniformName];
        if (!cache) {
            cache = [
                x,
                y
            ];
            this._valueCache[uniformName] = cache;
            return true;
        }
        let changed = false;
        if (cache[0] !== x) {
            cache[0] = x;
            changed = true;
        }
        if (cache[1] !== y) {
            cache[1] = y;
            changed = true;
        }
        return changed;
    }
    /**
     * @internal
     */ _cacheFloat3(uniformName, x, y, z) {
        let cache = this._valueCache[uniformName];
        if (!cache) {
            cache = [
                x,
                y,
                z
            ];
            this._valueCache[uniformName] = cache;
            return true;
        }
        let changed = false;
        if (cache[0] !== x) {
            cache[0] = x;
            changed = true;
        }
        if (cache[1] !== y) {
            cache[1] = y;
            changed = true;
        }
        if (cache[2] !== z) {
            cache[2] = z;
            changed = true;
        }
        return changed;
    }
    /**
     * @internal
     */ _cacheFloat4(uniformName, x, y, z, w) {
        let cache = this._valueCache[uniformName];
        if (!cache) {
            cache = [
                x,
                y,
                z,
                w
            ];
            this._valueCache[uniformName] = cache;
            return true;
        }
        let changed = false;
        if (cache[0] !== x) {
            cache[0] = x;
            changed = true;
        }
        if (cache[1] !== y) {
            cache[1] = y;
            changed = true;
        }
        if (cache[2] !== z) {
            cache[2] = z;
            changed = true;
        }
        if (cache[3] !== w) {
            cache[3] = w;
            changed = true;
        }
        return changed;
    }
    /**
     * Sets an integer value on a uniform variable.
     * @param uniformName Name of the variable.
     * @param value Value to be set.
     */ setInt(uniformName, value) {
        const cache = this._valueCache[uniformName];
        if (cache !== undefined && cache === value) return;
        if (this._engine.setInt(this._uniforms[uniformName], value)) this._valueCache[uniformName] = value;
    }
    /**
     * Sets a int2 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First int in int2.
     * @param y Second int in int2.
     */ setInt2(uniformName, x, y) {
        if (this._cacheFloat2(uniformName, x, y)) {
            if (!this._engine.setInt2(this._uniforms[uniformName], x, y)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a int3 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First int in int3.
     * @param y Second int in int3.
     * @param z Third int in int3.
     */ setInt3(uniformName, x, y, z) {
        if (this._cacheFloat3(uniformName, x, y, z)) {
            if (!this._engine.setInt3(this._uniforms[uniformName], x, y, z)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a int4 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First int in int4.
     * @param y Second int in int4.
     * @param z Third int in int4.
     * @param w Fourth int in int4.
     */ setInt4(uniformName, x, y, z, w) {
        if (this._cacheFloat4(uniformName, x, y, z, w)) {
            if (!this._engine.setInt4(this._uniforms[uniformName], x, y, z, w)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets an int array on a uniform variable.
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setIntArray(uniformName, array) {
        this._valueCache[uniformName] = null;
        this._engine.setIntArray(this._uniforms[uniformName], array);
    }
    /**
     * Sets an int array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setIntArray2(uniformName, array) {
        this._valueCache[uniformName] = null;
        this._engine.setIntArray2(this._uniforms[uniformName], array);
    }
    /**
     * Sets an int array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setIntArray3(uniformName, array) {
        this._valueCache[uniformName] = null;
        this._engine.setIntArray3(this._uniforms[uniformName], array);
    }
    /**
     * Sets an int array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setIntArray4(uniformName, array) {
        this._valueCache[uniformName] = null;
        this._engine.setIntArray4(this._uniforms[uniformName], array);
    }
    /**
     * Sets an unsigned integer value on a uniform variable.
     * @param uniformName Name of the variable.
     * @param value Value to be set.
     */ setUInt(uniformName, value) {
        const cache = this._valueCache[uniformName];
        if (cache !== undefined && cache === value) return;
        if (this._engine.setUInt(this._uniforms[uniformName], value)) this._valueCache[uniformName] = value;
    }
    /**
     * Sets a unsigned int2 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First unsigned int in uint2.
     * @param y Second unsigned int in uint2.
     */ setUInt2(uniformName, x, y) {
        if (this._cacheFloat2(uniformName, x, y)) {
            if (!this._engine.setUInt2(this._uniforms[uniformName], x, y)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a unsigned int3 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First unsigned int in uint3.
     * @param y Second unsigned int in uint3.
     * @param z Third unsigned int in uint3.
     */ setUInt3(uniformName, x, y, z) {
        if (this._cacheFloat3(uniformName, x, y, z)) {
            if (!this._engine.setUInt3(this._uniforms[uniformName], x, y, z)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a unsigned int4 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First unsigned int in uint4.
     * @param y Second unsigned int in uint4.
     * @param z Third unsigned int in uint4.
     * @param w Fourth unsigned int in uint4.
     */ setUInt4(uniformName, x, y, z, w) {
        if (this._cacheFloat4(uniformName, x, y, z, w)) {
            if (!this._engine.setUInt4(this._uniforms[uniformName], x, y, z, w)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets an unsigned int array on a uniform variable.
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setUIntArray(uniformName, array) {
        this._valueCache[uniformName] = null;
        this._engine.setUIntArray(this._uniforms[uniformName], array);
    }
    /**
     * Sets an unsigned int array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setUIntArray2(uniformName, array) {
        this._valueCache[uniformName] = null;
        this._engine.setUIntArray2(this._uniforms[uniformName], array);
    }
    /**
     * Sets an unsigned int array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setUIntArray3(uniformName, array) {
        this._valueCache[uniformName] = null;
        this._engine.setUIntArray3(this._uniforms[uniformName], array);
    }
    /**
     * Sets an unsigned int array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setUIntArray4(uniformName, array) {
        this._valueCache[uniformName] = null;
        this._engine.setUIntArray4(this._uniforms[uniformName], array);
    }
    /**
     * Sets an float array on a uniform variable.
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setFloatArray(uniformName, array) {
        this._valueCache[uniformName] = null;
        this._engine.setFloatArray(this._uniforms[uniformName], array);
    }
    /**
     * Sets an float array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setFloatArray2(uniformName, array) {
        this._valueCache[uniformName] = null;
        this._engine.setFloatArray2(this._uniforms[uniformName], array);
    }
    /**
     * Sets an float array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setFloatArray3(uniformName, array) {
        this._valueCache[uniformName] = null;
        this._engine.setFloatArray3(this._uniforms[uniformName], array);
    }
    /**
     * Sets an float array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setFloatArray4(uniformName, array) {
        this._valueCache[uniformName] = null;
        this._engine.setFloatArray4(this._uniforms[uniformName], array);
    }
    /**
     * Sets an array on a uniform variable.
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setArray(uniformName, array) {
        this._valueCache[uniformName] = null;
        this._engine.setArray(this._uniforms[uniformName], array);
    }
    /**
     * Sets an array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setArray2(uniformName, array) {
        this._valueCache[uniformName] = null;
        this._engine.setArray2(this._uniforms[uniformName], array);
    }
    /**
     * Sets an array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setArray3(uniformName, array) {
        this._valueCache[uniformName] = null;
        this._engine.setArray3(this._uniforms[uniformName], array);
    }
    /**
     * Sets an array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setArray4(uniformName, array) {
        this._valueCache[uniformName] = null;
        this._engine.setArray4(this._uniforms[uniformName], array);
    }
    /**
     * Sets matrices on a uniform variable.
     * @param uniformName Name of the variable.
     * @param matrices matrices to be set.
     */ setMatrices(uniformName, matrices) {
        if (!matrices) return;
        this._valueCache[uniformName] = null;
        this._engine.setMatrices(this._uniforms[uniformName], matrices);
    }
    /**
     * Sets matrix on a uniform variable.
     * @param uniformName Name of the variable.
     * @param matrix matrix to be set.
     */ setMatrix(uniformName, matrix) {
        if (this._cacheMatrix(uniformName, matrix)) {
            if (!this._engine.setMatrices(this._uniforms[uniformName], matrix.asArray())) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a 3x3 matrix on a uniform variable. (Specified as [1,2,3,4,5,6,7,8,9] will result in [1,2,3][4,5,6][7,8,9] matrix)
     * @param uniformName Name of the variable.
     * @param matrix matrix to be set.
     */ setMatrix3x3(uniformName, matrix) {
        this._valueCache[uniformName] = null;
        this._engine.setMatrix3x3(this._uniforms[uniformName], matrix);
    }
    /**
     * Sets a 2x2 matrix on a uniform variable. (Specified as [1,2,3,4] will result in [1,2][3,4] matrix)
     * @param uniformName Name of the variable.
     * @param matrix matrix to be set.
     */ setMatrix2x2(uniformName, matrix) {
        this._valueCache[uniformName] = null;
        this._engine.setMatrix2x2(this._uniforms[uniformName], matrix);
    }
    /**
     * Sets a float on a uniform variable.
     * @param uniformName Name of the variable.
     * @param value value to be set.
     */ setFloat(uniformName, value) {
        const cache = this._valueCache[uniformName];
        if (cache !== undefined && cache === value) return;
        if (this._engine.setFloat(this._uniforms[uniformName], value)) this._valueCache[uniformName] = value;
    }
    /**
     * Sets a boolean on a uniform variable.
     * @param uniformName Name of the variable.
     * @param bool value to be set.
     */ setBool(uniformName, bool) {
        const cache = this._valueCache[uniformName];
        if (cache !== undefined && cache === bool) return;
        if (this._engine.setInt(this._uniforms[uniformName], bool ? 1 : 0)) this._valueCache[uniformName] = bool ? 1 : 0;
    }
    /**
     * Sets a Vector2 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param vector2 vector2 to be set.
     */ setVector2(uniformName, vector2) {
        if (this._cacheFloat2(uniformName, vector2.x, vector2.y)) {
            if (!this._engine.setFloat2(this._uniforms[uniformName], vector2.x, vector2.y)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a float2 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First float in float2.
     * @param y Second float in float2.
     */ setFloat2(uniformName, x, y) {
        if (this._cacheFloat2(uniformName, x, y)) {
            if (!this._engine.setFloat2(this._uniforms[uniformName], x, y)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a Vector3 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param vector3 Value to be set.
     */ setVector3(uniformName, vector3) {
        if (this._cacheFloat3(uniformName, vector3.x, vector3.y, vector3.z)) {
            if (!this._engine.setFloat3(this._uniforms[uniformName], vector3.x, vector3.y, vector3.z)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a float3 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First float in float3.
     * @param y Second float in float3.
     * @param z Third float in float3.
     */ setFloat3(uniformName, x, y, z) {
        if (this._cacheFloat3(uniformName, x, y, z)) {
            if (!this._engine.setFloat3(this._uniforms[uniformName], x, y, z)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a Vector4 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param vector4 Value to be set.
     */ setVector4(uniformName, vector4) {
        if (this._cacheFloat4(uniformName, vector4.x, vector4.y, vector4.z, vector4.w)) {
            if (!this._engine.setFloat4(this._uniforms[uniformName], vector4.x, vector4.y, vector4.z, vector4.w)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a Quaternion on a uniform variable.
     * @param uniformName Name of the variable.
     * @param quaternion Value to be set.
     */ setQuaternion(uniformName, quaternion) {
        if (this._cacheFloat4(uniformName, quaternion.x, quaternion.y, quaternion.z, quaternion.w)) {
            if (!this._engine.setFloat4(this._uniforms[uniformName], quaternion.x, quaternion.y, quaternion.z, quaternion.w)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a float4 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First float in float4.
     * @param y Second float in float4.
     * @param z Third float in float4.
     * @param w Fourth float in float4.
     */ setFloat4(uniformName, x, y, z, w) {
        if (this._cacheFloat4(uniformName, x, y, z, w)) {
            if (!this._engine.setFloat4(this._uniforms[uniformName], x, y, z, w)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a Color3 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param color3 Value to be set.
     */ setColor3(uniformName, color3) {
        if (this._cacheFloat3(uniformName, color3.r, color3.g, color3.b)) {
            if (!this._engine.setFloat3(this._uniforms[uniformName], color3.r, color3.g, color3.b)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a Color4 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param color3 Value to be set.
     * @param alpha Alpha value to be set.
     */ setColor4(uniformName, color3, alpha) {
        if (this._cacheFloat4(uniformName, color3.r, color3.g, color3.b, alpha)) {
            if (!this._engine.setFloat4(this._uniforms[uniformName], color3.r, color3.g, color3.b, alpha)) this._valueCache[uniformName] = null;
        }
    }
    /**
     * Sets a Color4 on a uniform variable
     * @param uniformName defines the name of the variable
     * @param color4 defines the value to be set
     */ setDirectColor4(uniformName, color4) {
        if (this._cacheFloat4(uniformName, color4.r, color4.g, color4.b, color4.a)) {
            if (!this._engine.setFloat4(this._uniforms[uniformName], color4.r, color4.g, color4.b, color4.a)) this._valueCache[uniformName] = null;
        }
    }
}

});

parcelRegister("1M3z8", function(module, exports) {

$parcel$export(module.exports, "NativeRenderTargetWrapper", () => $14ad0a353b0e8940$export$6b4982dfcca27284);

var $3QmEA = parcelRequire("3QmEA");
class $14ad0a353b0e8940$export$6b4982dfcca27284 extends (0, $3QmEA.RenderTargetWrapper) {
    get _framebuffer() {
        return this.__framebuffer;
    }
    set _framebuffer(framebuffer) {
        if (this.__framebuffer) this._engine._releaseFramebufferObjects(this.__framebuffer);
        this.__framebuffer = framebuffer;
    }
    get _framebufferDepthStencil() {
        return this.__framebufferDepthStencil;
    }
    set _framebufferDepthStencil(framebufferDepthStencil) {
        if (this.__framebufferDepthStencil) this._engine._releaseFramebufferObjects(this.__framebufferDepthStencil);
        this.__framebufferDepthStencil = framebufferDepthStencil;
    }
    constructor(isMulti, isCube, size, engine){
        super(isMulti, isCube, size, engine);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        this.__framebuffer = null;
        // eslint-disable-next-line @typescript-eslint/naming-convention
        this.__framebufferDepthStencil = null;
        this._engine = engine;
    }
    dispose(disposeOnlyFramebuffers = false) {
        this._framebuffer = null;
        this._framebufferDepthStencil = null;
        super.dispose(disposeOnlyFramebuffers);
    }
}

});

parcelRegister("336js", function(module, exports) {

$parcel$export(module.exports, "NativeHardwareTexture", () => $23868c7e0ffc27a0$export$55ce27c06a19d36e);
/** @internal */ class $23868c7e0ffc27a0$export$55ce27c06a19d36e {
    get underlyingResource() {
        return this._nativeTexture;
    }
    constructor(existingTexture, engine){
        this._engine = engine;
        this.set(existingTexture);
    }
    setUsage() {}
    set(hardwareTexture) {
        this._nativeTexture = hardwareTexture;
    }
    reset() {
        this._nativeTexture = null;
    }
    release() {
        if (this._nativeTexture) this._engine.deleteTexture(this._nativeTexture);
        this.reset();
    }
}

});

parcelRegister("iYZjK", function(module, exports) {

$parcel$export(module.exports, "getNativeTextureFormat", () => $dd1d64fc5be985f2$export$9da7197cc0c55e2c);
$parcel$export(module.exports, "getNativeSamplingMode", () => $dd1d64fc5be985f2$export$ba315484b2d92d08);
$parcel$export(module.exports, "getNativeAddressMode", () => $dd1d64fc5be985f2$export$8870b5f14b4ddf29);
$parcel$export(module.exports, "getNativeStencilFunc", () => $dd1d64fc5be985f2$export$efab98cbacbb6541);
$parcel$export(module.exports, "getNativeStencilOpFail", () => $dd1d64fc5be985f2$export$e7a1f810a003ee97);
$parcel$export(module.exports, "getNativeStencilDepthFail", () => $dd1d64fc5be985f2$export$4e3f06f1f7f93b4c);
$parcel$export(module.exports, "getNativeStencilDepthPass", () => $dd1d64fc5be985f2$export$fe90642980fb81fd);
$parcel$export(module.exports, "getNativeAlphaMode", () => $dd1d64fc5be985f2$export$cf10851d9bc46377);
$parcel$export(module.exports, "getNativeAttribType", () => $dd1d64fc5be985f2$export$b906cbf2a159934e);

var $1FkG9 = parcelRequire("1FkG9");

var $b4i1f = parcelRequire("b4i1f");
function $dd1d64fc5be985f2$export$9da7197cc0c55e2c(format, type) {
    switch(format){
        // Depth (type is ignored)
        case 15:
            return _native.Engine.TEXTURE_FORMAT_D16;
        case 16:
            return _native.Engine.TEXTURE_FORMAT_D24;
        case 13:
            return _native.Engine.TEXTURE_FORMAT_D24S8;
        case 14:
            return _native.Engine.TEXTURE_FORMAT_D32F;
        // Compressed (type is ignored)
        case 36492:
            return _native.Engine.TEXTURE_FORMAT_BC7;
        case 36494:
            return _native.Engine.TEXTURE_FORMAT_BC6H;
        case 33779:
            return _native.Engine.TEXTURE_FORMAT_BC3;
        case 33778:
            return _native.Engine.TEXTURE_FORMAT_BC2;
        case 33777:
            return _native.Engine.TEXTURE_FORMAT_BC1;
        case 33776:
            return _native.Engine.TEXTURE_FORMAT_BC1;
        case 37808:
            return _native.Engine.TEXTURE_FORMAT_ASTC4x4;
        case 36196:
            return _native.Engine.TEXTURE_FORMAT_ETC1;
        case 37492:
            return _native.Engine.TEXTURE_FORMAT_ETC2;
        case 37496:
            return _native.Engine.TEXTURE_FORMAT_ETC2A;
        case 4:
            switch(type){
                case 0:
                    return _native.Engine.TEXTURE_FORMAT_RGB8;
                case 3:
                    return _native.Engine.TEXTURE_FORMAT_RGB8S;
                case 6:
                    return _native.Engine.TEXTURE_FORMAT_RGB8I;
                case 7:
                    return _native.Engine.TEXTURE_FORMAT_RGB8U;
            }
            break;
        case 5:
            switch(type){
                case 0:
                    return _native.Engine.TEXTURE_FORMAT_RGBA8;
                case 1:
                    return _native.Engine.TEXTURE_FORMAT_RGBA32F;
                case 2:
                    return _native.Engine.TEXTURE_FORMAT_RGBA16F;
                case 3:
                    return _native.Engine.TEXTURE_FORMAT_RGBA8S;
                case 4:
                    return _native.Engine.TEXTURE_FORMAT_RGBA16I;
                case 5:
                    return _native.Engine.TEXTURE_FORMAT_RGBA16U;
                case 6:
                    return _native.Engine.TEXTURE_FORMAT_RGBA32I;
                case 7:
                    return _native.Engine.TEXTURE_FORMAT_RGBA32U;
            }
            break;
        case 6:
            switch(type){
                case 0:
                    return _native.Engine.TEXTURE_FORMAT_R8;
                case 1:
                    return _native.Engine.TEXTURE_FORMAT_R32F;
                case 2:
                    return _native.Engine.TEXTURE_FORMAT_R16F;
                case 3:
                    return _native.Engine.TEXTURE_FORMAT_R8S;
                case 4:
                    return _native.Engine.TEXTURE_FORMAT_R16S;
                case 5:
                    return _native.Engine.TEXTURE_FORMAT_R16U;
                case 6:
                    return _native.Engine.TEXTURE_FORMAT_R32I;
                case 7:
                    return _native.Engine.TEXTURE_FORMAT_R32U;
            }
            break;
        case 7:
            switch(type){
                case 0:
                    return _native.Engine.TEXTURE_FORMAT_RG8;
                case 1:
                    return _native.Engine.TEXTURE_FORMAT_RG32F;
                case 2:
                    return _native.Engine.TEXTURE_FORMAT_RG16F;
                case 3:
                    return _native.Engine.TEXTURE_FORMAT_RG8S;
                case 4:
                    return _native.Engine.TEXTURE_FORMAT_RG16S;
                case 5:
                    return _native.Engine.TEXTURE_FORMAT_RG16U;
                case 6:
                    return _native.Engine.TEXTURE_FORMAT_RG32I;
                case 7:
                    return _native.Engine.TEXTURE_FORMAT_RG32U;
            }
            break;
        case 12:
            switch(type){
                case 0:
                    return _native.Engine.TEXTURE_FORMAT_BGRA8;
            }
            break;
    }
    throw new (0, $1FkG9.RuntimeError)(`Unsupported texture format or type: format ${format}, type ${type}.`, (0, $1FkG9.ErrorCodes).UnsupportedTextureError);
}
function $dd1d64fc5be985f2$export$ba315484b2d92d08(samplingMode) {
    switch(samplingMode){
        case 1:
            return _native.Engine.TEXTURE_NEAREST_NEAREST;
        case 2:
            return _native.Engine.TEXTURE_LINEAR_LINEAR;
        case 3:
            return _native.Engine.TEXTURE_LINEAR_LINEAR_MIPLINEAR;
        case 4:
            return _native.Engine.TEXTURE_NEAREST_NEAREST_MIPNEAREST;
        case 5:
            return _native.Engine.TEXTURE_NEAREST_LINEAR_MIPNEAREST;
        case 6:
            return _native.Engine.TEXTURE_NEAREST_LINEAR_MIPLINEAR;
        case 7:
            return _native.Engine.TEXTURE_NEAREST_LINEAR;
        case 8:
            return _native.Engine.TEXTURE_NEAREST_NEAREST_MIPLINEAR;
        case 9:
            return _native.Engine.TEXTURE_LINEAR_NEAREST_MIPNEAREST;
        case 10:
            return _native.Engine.TEXTURE_LINEAR_NEAREST_MIPLINEAR;
        case 11:
            return _native.Engine.TEXTURE_LINEAR_LINEAR_MIPNEAREST;
        case 12:
            return _native.Engine.TEXTURE_LINEAR_NEAREST;
        default:
            throw new Error(`Unsupported sampling mode: ${samplingMode}.`);
    }
}
function $dd1d64fc5be985f2$export$8870b5f14b4ddf29(wrapMode) {
    switch(wrapMode){
        case 1:
            return _native.Engine.ADDRESS_MODE_WRAP;
        case 0:
            return _native.Engine.ADDRESS_MODE_CLAMP;
        case 2:
            return _native.Engine.ADDRESS_MODE_MIRROR;
        default:
            throw new Error("Unexpected wrap mode: " + wrapMode + ".");
    }
}
function $dd1d64fc5be985f2$export$efab98cbacbb6541(func) {
    switch(func){
        case 513:
            return _native.Engine.STENCIL_TEST_LESS;
        case 515:
            return _native.Engine.STENCIL_TEST_LEQUAL;
        case 514:
            return _native.Engine.STENCIL_TEST_EQUAL;
        case 518:
            return _native.Engine.STENCIL_TEST_GEQUAL;
        case 516:
            return _native.Engine.STENCIL_TEST_GREATER;
        case 517:
            return _native.Engine.STENCIL_TEST_NOTEQUAL;
        case 512:
            return _native.Engine.STENCIL_TEST_NEVER;
        case 519:
            return _native.Engine.STENCIL_TEST_ALWAYS;
        default:
            throw new Error(`Unsupported stencil func mode: ${func}.`);
    }
}
function $dd1d64fc5be985f2$export$e7a1f810a003ee97(opFail) {
    switch(opFail){
        case 7680:
            return _native.Engine.STENCIL_OP_FAIL_S_KEEP;
        case 0:
            return _native.Engine.STENCIL_OP_FAIL_S_ZERO;
        case 7681:
            return _native.Engine.STENCIL_OP_FAIL_S_REPLACE;
        case 7682:
            return _native.Engine.STENCIL_OP_FAIL_S_INCR;
        case 7683:
            return _native.Engine.STENCIL_OP_FAIL_S_DECR;
        case 5386:
            return _native.Engine.STENCIL_OP_FAIL_S_INVERT;
        case 34055:
            return _native.Engine.STENCIL_OP_FAIL_S_INCRSAT;
        case 34056:
            return _native.Engine.STENCIL_OP_FAIL_S_DECRSAT;
        default:
            throw new Error(`Unsupported stencil OpFail mode: ${opFail}.`);
    }
}
function $dd1d64fc5be985f2$export$4e3f06f1f7f93b4c(depthFail) {
    switch(depthFail){
        case 7680:
            return _native.Engine.STENCIL_OP_FAIL_Z_KEEP;
        case 0:
            return _native.Engine.STENCIL_OP_FAIL_Z_ZERO;
        case 7681:
            return _native.Engine.STENCIL_OP_FAIL_Z_REPLACE;
        case 7682:
            return _native.Engine.STENCIL_OP_FAIL_Z_INCR;
        case 7683:
            return _native.Engine.STENCIL_OP_FAIL_Z_DECR;
        case 5386:
            return _native.Engine.STENCIL_OP_FAIL_Z_INVERT;
        case 34055:
            return _native.Engine.STENCIL_OP_FAIL_Z_INCRSAT;
        case 34056:
            return _native.Engine.STENCIL_OP_FAIL_Z_DECRSAT;
        default:
            throw new Error(`Unsupported stencil depthFail mode: ${depthFail}.`);
    }
}
function $dd1d64fc5be985f2$export$fe90642980fb81fd(opPass) {
    switch(opPass){
        case 7680:
            return _native.Engine.STENCIL_OP_PASS_Z_KEEP;
        case 0:
            return _native.Engine.STENCIL_OP_PASS_Z_ZERO;
        case 7681:
            return _native.Engine.STENCIL_OP_PASS_Z_REPLACE;
        case 7682:
            return _native.Engine.STENCIL_OP_PASS_Z_INCR;
        case 7683:
            return _native.Engine.STENCIL_OP_PASS_Z_DECR;
        case 5386:
            return _native.Engine.STENCIL_OP_PASS_Z_INVERT;
        case 34055:
            return _native.Engine.STENCIL_OP_PASS_Z_INCRSAT;
        case 34056:
            return _native.Engine.STENCIL_OP_PASS_Z_DECRSAT;
        default:
            throw new Error(`Unsupported stencil opPass mode: ${opPass}.`);
    }
}
function $dd1d64fc5be985f2$export$cf10851d9bc46377(mode) {
    switch(mode){
        case 0:
            return _native.Engine.ALPHA_DISABLE;
        case 1:
            return _native.Engine.ALPHA_ADD;
        case 2:
            return _native.Engine.ALPHA_COMBINE;
        case 3:
            return _native.Engine.ALPHA_SUBTRACT;
        case 4:
            return _native.Engine.ALPHA_MULTIPLY;
        case 5:
            return _native.Engine.ALPHA_MAXIMIZED;
        case 6:
            return _native.Engine.ALPHA_ONEONE;
        case 7:
            return _native.Engine.ALPHA_PREMULTIPLIED;
        case 8:
            return _native.Engine.ALPHA_PREMULTIPLIED_PORTERDUFF;
        case 9:
            return _native.Engine.ALPHA_INTERPOLATE;
        case 10:
            return _native.Engine.ALPHA_SCREENMODE;
        default:
            throw new Error(`Unsupported alpha mode: ${mode}.`);
    }
}
function $dd1d64fc5be985f2$export$b906cbf2a159934e(type) {
    switch(type){
        case (0, $b4i1f.VertexBuffer).BYTE:
            return _native.Engine.ATTRIB_TYPE_INT8;
        case (0, $b4i1f.VertexBuffer).UNSIGNED_BYTE:
            return _native.Engine.ATTRIB_TYPE_UINT8;
        case (0, $b4i1f.VertexBuffer).SHORT:
            return _native.Engine.ATTRIB_TYPE_INT16;
        case (0, $b4i1f.VertexBuffer).UNSIGNED_SHORT:
            return _native.Engine.ATTRIB_TYPE_UINT16;
        case (0, $b4i1f.VertexBuffer).FLOAT:
            return _native.Engine.ATTRIB_TYPE_FLOAT;
        default:
            throw new Error(`Unsupported attribute type: ${type}.`);
    }
}

});




parcelRegister("aKJV6", function(module, exports) {
parcelRequire("8qHxY");
parcelRequire("lLafQ");
parcelRequire("gtfq1");
parcelRequire("iTVoy");
parcelRequire("i7fzv");
parcelRequire("acB3O");
parcelRequire("jHBNz");
parcelRequire("8Hu74");
parcelRequire("cnp1v");
parcelRequire("f7RML");
parcelRequire("lwP3W");
parcelRequire("lvGT2");
parcelRequire("hBD6p");
parcelRequire("c9O9c");
parcelRequire("g1ImJ");

});
parcelRegister("8qHxY", function(module, exports) {

var $5YkyR = parcelRequire("5YkyR");

var $64Ihk = parcelRequire("64Ihk");
(0, $64Ihk.WebGPUEngine).prototype.setAlphaMode = function(mode, noDepthWriteChange = false) {
    if (this._alphaMode === mode && (mode === 0 && !this._alphaState.alphaBlend || mode !== 0 && this._alphaState.alphaBlend)) {
        if (!noDepthWriteChange) {
            // Make sure we still have the correct depth mask according to the alpha mode (a transparent material could have forced writting to the depth buffer, for instance)
            const depthMask = mode === 0;
            if (this.depthCullingState.depthMask !== depthMask) {
                this.setDepthWrite(depthMask);
                this._cacheRenderPipeline.setDepthWriteEnabled(depthMask);
            }
        }
        return;
    }
    switch(mode){
        case 0:
            this._alphaState.alphaBlend = false;
            break;
        case 7:
            this._alphaState.setAlphaBlendFunctionParameters(1, 771, 1, 1);
            this._alphaState.alphaBlend = true;
            break;
        case 8:
            this._alphaState.setAlphaBlendFunctionParameters(1, 771, 1, 771);
            this._alphaState.alphaBlend = true;
            break;
        case 2:
            this._alphaState.setAlphaBlendFunctionParameters(770, 771, 1, 1);
            this._alphaState.alphaBlend = true;
            break;
        case 6:
            this._alphaState.setAlphaBlendFunctionParameters(1, 1, 0, 1);
            this._alphaState.alphaBlend = true;
            break;
        case 1:
            this._alphaState.setAlphaBlendFunctionParameters(770, 1, 0, 1);
            this._alphaState.alphaBlend = true;
            break;
        case 3:
            this._alphaState.setAlphaBlendFunctionParameters(0, 769, 1, 1);
            this._alphaState.alphaBlend = true;
            break;
        case 4:
            this._alphaState.setAlphaBlendFunctionParameters(774, 0, 1, 1);
            this._alphaState.alphaBlend = true;
            break;
        case 5:
            this._alphaState.setAlphaBlendFunctionParameters(770, 769, 1, 1);
            this._alphaState.alphaBlend = true;
            break;
        case 9:
            this._alphaState.setAlphaBlendFunctionParameters(32769, 32770, 32771, 32772);
            this._alphaState.alphaBlend = true;
            break;
        case 10:
            this._alphaState.setAlphaBlendFunctionParameters(1, 769, 1, 771);
            this._alphaState.alphaBlend = true;
            break;
        case 11:
            this._alphaState.setAlphaBlendFunctionParameters(1, 1, 1, 1);
            this._alphaState.alphaBlend = true;
            break;
        case 12:
            this._alphaState.setAlphaBlendFunctionParameters(772, 1, 0, 0);
            this._alphaState.alphaBlend = true;
            break;
        case 13:
            this._alphaState.setAlphaBlendFunctionParameters(775, 769, 773, 771);
            this._alphaState.alphaBlend = true;
            break;
        case 14:
            this._alphaState.setAlphaBlendFunctionParameters(1, 771, 1, 771);
            this._alphaState.alphaBlend = true;
            break;
        case 15:
            this._alphaState.setAlphaBlendFunctionParameters(1, 1, 1, 0);
            this._alphaState.alphaBlend = true;
            break;
        case 16:
            this._alphaState.setAlphaBlendFunctionParameters(775, 769, 0, 1);
            this._alphaState.alphaBlend = true;
            break;
        case 17:
            // Same as ALPHA_COMBINE but accumulates (1 - alpha) values in the alpha channel for a later readout in order independant transparency
            this._alphaState.setAlphaBlendFunctionParameters(770, 771, 1, 771);
            this._alphaState.alphaBlend = true;
            break;
    }
    if (!noDepthWriteChange) {
        this.setDepthWrite(mode === (0, $5YkyR.Engine).ALPHA_DISABLE);
        this._cacheRenderPipeline.setDepthWriteEnabled(mode === (0, $5YkyR.Engine).ALPHA_DISABLE);
    }
    this._alphaMode = mode;
    this._cacheRenderPipeline.setAlphaBlendEnabled(this._alphaState.alphaBlend);
    this._cacheRenderPipeline.setAlphaBlendFactors(this._alphaState._blendFunctionParameters, this._alphaState._blendEquationParameters);
};
(0, $64Ihk.WebGPUEngine).prototype.setAlphaEquation = function(equation) {
    (0, $5YkyR.Engine).prototype.setAlphaEquation.call(this, equation);
    this._cacheRenderPipeline.setAlphaBlendFactors(this._alphaState._blendFunctionParameters, this._alphaState._blendEquationParameters);
};

});
parcelRegister("64Ihk", function(module, exports) {

$parcel$export(module.exports, "WebGPUEngine", () => $46c576986b3f1f6c$export$20da89723e6780ae);
/* eslint-disable babylonjs/available */ 
var $kVtWi = parcelRequire("kVtWi");
parcelRequire("6rxfP");
var $7etnY = parcelRequire("7etnY");

var $5YkyR = parcelRequire("5YkyR");

var $b9e4a = parcelRequire("b9e4a");

var $lUDWq = parcelRequire("lUDWq");

var $hR6HG = parcelRequire("hR6HG");

var $b4i1f = parcelRequire("b4i1f");

var $iVtp9 = parcelRequire("iVtp9");

var $8rh4q = parcelRequire("8rh4q");

var $lJAHK = parcelRequire("lJAHK");

var $g5vsw = parcelRequire("g5vsw");

var $bOhSV = parcelRequire("bOhSV");

var $l46cr = parcelRequire("l46cr");

var $4ObYT = parcelRequire("4ObYT");

var $8U3Lx = parcelRequire("8U3Lx");

var $4JXMh = parcelRequire("4JXMh");

var $ghoTi = parcelRequire("ghoTi");

var $6okLJ = parcelRequire("6okLJ");

var $6dQQy = parcelRequire("6dQQy");

var $7dZYU = parcelRequire("7dZYU");

var $4MBPD = parcelRequire("4MBPD");

var $hOyoX = parcelRequire("hOyoX");

var $gJSsf = parcelRequire("gJSsf");

var $eFVmp = parcelRequire("eFVmp");

var $3rO3H = parcelRequire("3rO3H");

var $2yTFf = parcelRequire("2yTFf");

var $6HEDe = parcelRequire("6HEDe");

var $hECLP = parcelRequire("hECLP");

var $jynN8 = parcelRequire("jynN8");

var $lh6wJ = parcelRequire("lh6wJ");

var $kBotW = parcelRequire("kBotW");

var $jXMwB = parcelRequire("jXMwB");

var $8WI3I = parcelRequire("8WI3I");

var $7CgyA = parcelRequire("7CgyA");
parcelRequire("5gISp");
parcelRequire("4z1y7");

var $8tOka = parcelRequire("8tOka");
const $46c576986b3f1f6c$var$viewDescriptorSwapChainAntialiasing = {
    label: `TextureView_SwapChain_ResolveTarget`,
    dimension: $hR6HG.TextureDimension.E2d,
    format: undefined,
    mipLevelCount: 1,
    arrayLayerCount: 1
};
const $46c576986b3f1f6c$var$viewDescriptorSwapChain = {
    label: `TextureView_SwapChain`,
    dimension: $hR6HG.TextureDimension.E2d,
    format: undefined,
    mipLevelCount: 1,
    arrayLayerCount: 1
};
const $46c576986b3f1f6c$var$disableUniformityAnalysisMarker = "/* disable_uniformity_analysis */";
const $46c576986b3f1f6c$var$tempColor4 = new (0, $7etnY.Color4)();
class $46c576986b3f1f6c$export$20da89723e6780ae extends (0, $5YkyR.Engine) {
    /**
     * Gets or sets the snapshot rendering mode
     */ get snapshotRenderingMode() {
        return this._snapshotRendering.mode;
    }
    set snapshotRenderingMode(mode) {
        this._snapshotRendering.mode = mode;
    }
    /**
     * Creates a new snapshot at the next frame using the current snapshotRenderingMode
     */ snapshotRenderingReset() {
        this._snapshotRendering.reset();
    }
    /**
     * Enables or disables the snapshot rendering mode
     * Note that the WebGL engine does not support snapshot rendering so setting the value won't have any effect for this engine
     */ get snapshotRendering() {
        return this._snapshotRendering.enabled;
    }
    set snapshotRendering(activate) {
        this._snapshotRendering.enabled = activate;
    }
    /**
     * Sets this to true to disable the cache for the samplers. You should do it only for testing purpose!
     */ get disableCacheSamplers() {
        return this._cacheSampler ? this._cacheSampler.disabled : false;
    }
    set disableCacheSamplers(disable) {
        if (this._cacheSampler) this._cacheSampler.disabled = disable;
    }
    /**
     * Sets this to true to disable the cache for the render pipelines. You should do it only for testing purpose!
     */ get disableCacheRenderPipelines() {
        return this._cacheRenderPipeline ? this._cacheRenderPipeline.disabled : false;
    }
    set disableCacheRenderPipelines(disable) {
        if (this._cacheRenderPipeline) this._cacheRenderPipeline.disabled = disable;
    }
    /**
     * Sets this to true to disable the cache for the bind groups. You should do it only for testing purpose!
     */ get disableCacheBindGroups() {
        return this._cacheBindGroups ? this._cacheBindGroups.disabled : false;
    }
    set disableCacheBindGroups(disable) {
        if (this._cacheBindGroups) this._cacheBindGroups.disabled = disable;
    }
    /**
     * Gets a Promise<boolean> indicating if the engine can be instantiated (ie. if a WebGPU context can be found)
     */ static get IsSupportedAsync() {
        return !navigator.gpu ? Promise.resolve(false) : navigator.gpu.requestAdapter().then((adapter)=>!!adapter, ()=>false).catch(()=>false);
    }
    /**
     * Not supported by WebGPU, you should call IsSupportedAsync instead!
     */ static get IsSupported() {
        (0, $kVtWi.Logger).Warn("You must call IsSupportedAsync for WebGPU!");
        return false;
    }
    /**
     * Gets a boolean indicating that the engine supports uniform buffers
     */ get supportsUniformBuffers() {
        return true;
    }
    /** Gets the supported extensions by the WebGPU adapter */ get supportedExtensions() {
        return this._adapterSupportedExtensions;
    }
    /** Gets the currently enabled extensions on the WebGPU device */ get enabledExtensions() {
        return this._deviceEnabledExtensions;
    }
    /** Gets the supported limits by the WebGPU adapter */ get supportedLimits() {
        return this._adapterSupportedLimits;
    }
    /** Gets the current limits of the WebGPU device */ get currentLimits() {
        return this._deviceLimits;
    }
    /**
     * Returns a string describing the current engine
     */ get description() {
        const description = this.name + this.version;
        return description;
    }
    /**
     * Returns the version of the engine
     */ get version() {
        return 1;
    }
    /**
     * Gets an object containing information about the current engine context
     * @returns an object containing the vendor, the renderer and the version of the current engine context
     */ getInfo() {
        return {
            vendor: this._adapterInfo.vendor || "unknown vendor",
            renderer: this._adapterInfo.architecture || "unknown renderer",
            version: this._adapterInfo.description || "unknown version"
        };
    }
    /**
     * (WebGPU only) True (default) to be in compatibility mode, meaning rendering all existing scenes without artifacts (same rendering than WebGL).
     * Setting the property to false will improve performances but may not work in some scenes if some precautions are not taken.
     * See https://doc.babylonjs.com/setup/support/webGPU/webGPUOptimization/webGPUNonCompatibilityMode for more details
     */ get compatibilityMode() {
        return this._compatibilityMode;
    }
    set compatibilityMode(mode) {
        this._compatibilityMode = mode;
    }
    /**
     * Enables or disables GPU timing measurements.
     * Note that this is only supported if the "timestamp-query" extension is enabled in the options.
     */ get enableGPUTimingMeasurements() {
        return this._timestampQuery.enable;
    }
    set enableGPUTimingMeasurements(enable) {
        if (this._timestampQuery.enable === enable) return;
        this.gpuTimeInFrameForMainPass = enable ? new (0, $8tOka.WebGPUPerfCounter)() : undefined;
        this._timestampQuery.enable = enable;
    }
    /** @internal */ get currentSampleCount() {
        return this._currentRenderTarget ? this._currentRenderTarget.samples : this._mainPassSampleCount;
    }
    /**
     * Create a new instance of the gpu engine asynchronously
     * @param canvas Defines the canvas to use to display the result
     * @param options Defines the options passed to the engine to create the GPU context dependencies
     * @returns a promise that resolves with the created engine
     */ static CreateAsync(canvas, options = {}) {
        const engine = new $46c576986b3f1f6c$export$20da89723e6780ae(canvas, options);
        return new Promise((resolve)=>{
            engine.initAsync(options.glslangOptions, options.twgslOptions).then(()=>resolve(engine));
        });
    }
    /**
     * Create a new instance of the gpu engine.
     * @param canvas Defines the canvas to use to display the result
     * @param options Defines the options passed to the engine to create the GPU context dependencies
     */ constructor(canvas, options = {}){
        super(null, options.antialias ?? true, options);
        /** A unique id to identify this instance */ this.uniqueId = -1;
        // Page Life cycle and constants
        this._uploadEncoderDescriptor = {
            label: "upload"
        };
        this._renderEncoderDescriptor = {
            label: "render"
        };
        /** @internal */ this._clearDepthValue = 1;
        /** @internal */ this._clearReverseDepthValue = 0;
        /** @internal */ this._clearStencilValue = 0;
        this._defaultSampleCount = 4; // Only supported value for now.
        this._glslang = null;
        this._tintWASM = null;
        this._adapterInfo = {
            vendor: "",
            architecture: "",
            device: "",
            description: ""
        };
        /** @internal */ this._timestampIndex = 0;
        /** @internal */ this._compiledComputeEffects = {};
        /** @internal */ this._counters = {
            numEnableEffects: 0,
            numEnableDrawWrapper: 0,
            numBundleCreationNonCompatMode: 0,
            numBundleReuseNonCompatMode: 0
        };
        /**
         * Counters from last frame
         */ this.countersLastFrame = {
            numEnableEffects: 0,
            numEnableDrawWrapper: 0,
            numBundleCreationNonCompatMode: 0,
            numBundleReuseNonCompatMode: 0
        };
        /**
         * Max number of uncaptured error messages to log
         */ this.numMaxUncapturedErrors = 20;
        this._commandBuffers = [
            null,
            null
        ];
        // Frame Buffer Life Cycle (recreated for each render target pass)
        /** @internal */ this._currentRenderPass = null;
        this._mainRenderPassWrapper = {
            renderPassDescriptor: null,
            colorAttachmentViewDescriptor: null,
            depthAttachmentViewDescriptor: null,
            colorAttachmentGPUTextures: [],
            depthTextureFormat: undefined
        };
        this._rttRenderPassWrapper = {
            renderPassDescriptor: null,
            colorAttachmentViewDescriptor: null,
            depthAttachmentViewDescriptor: null,
            colorAttachmentGPUTextures: [],
            depthTextureFormat: undefined
        };
        /** @internal */ this._pendingDebugCommands = [];
        this._currentOverrideVertexBuffers = null;
        this._currentIndexBuffer = null;
        this._colorWriteLocal = true;
        this._forceEnableEffect = false;
        // TODO WEBGPU remove those variables when code stabilized
        /** @internal */ this.dbgShowShaderCode = false;
        /** @internal */ this.dbgSanityChecks = true;
        /** @internal */ this.dbgVerboseLogsForFirstFrames = false;
        /** @internal */ this.dbgVerboseLogsNumFrames = 10;
        /** @internal */ this.dbgLogIfNotDrawWrapper = true;
        /** @internal */ this.dbgShowEmptyEnableEffectCalls = true;
        /**
         * Indicates if the z range in NDC space is 0..1 (value: true) or -1..1 (value: false)
         */ this.isNDCHalfZRange = true;
        /**
         * Indicates that the origin of the texture/framebuffer space is the bottom left corner. If false, the origin is top left
         */ this.hasOriginBottomLeft = false;
        //------------------------------------------------------------------------------
        //                              Dynamic WebGPU States
        //------------------------------------------------------------------------------
        // index 0 is for main render pass, 1 for RTT render pass
        this._viewportsCurrent = {
            x: 0,
            y: 0,
            w: 0,
            h: 0
        };
        this._scissorsCurrent = {
            x: 0,
            y: 0,
            w: 0,
            h: 0
        };
        this._scissorCached = {
            x: 0,
            y: 0,
            z: 0,
            w: 0
        };
        this._stencilRefsCurrent = -1;
        this._blendColorsCurrent = [
            null,
            null,
            null,
            null
        ];
        this._name = "WebGPU";
        options.deviceDescriptor = options.deviceDescriptor || {};
        options.enableGPUDebugMarkers = options.enableGPUDebugMarkers ?? false;
        (0, $kVtWi.Logger).Log(`Babylon.js v${(0, $5YkyR.Engine).Version} - ${this.description} engine`);
        if (!navigator.gpu) {
            (0, $kVtWi.Logger).Error("WebGPU is not supported by your browser.");
            return;
        }
        options.swapChainFormat = options.swapChainFormat || navigator.gpu.getPreferredCanvasFormat();
        this._isWebGPU = true;
        this._shaderPlatformName = "WEBGPU";
        this._renderingCanvas = canvas;
        this._options = options;
        this._mainPassSampleCount = options.antialias ? this._defaultSampleCount : 1;
        this._setupMobileChecks();
        this._sharedInit(this._renderingCanvas);
        this._shaderProcessor = new (0, $8rh4q.WebGPUShaderProcessorGLSL)();
        this._shaderProcessorWGSL = new (0, $lJAHK.WebGPUShaderProcessorWGSL)();
    }
    //------------------------------------------------------------------------------
    //                              Initialization
    //------------------------------------------------------------------------------
    /**
     * Initializes the WebGPU context and dependencies.
     * @param glslangOptions Defines the GLSLang compiler options if necessary
     * @param twgslOptions Defines the Twgsl compiler options if necessary
     * @returns a promise notifying the readiness of the engine.
     */ initAsync(glslangOptions, twgslOptions) {
        this.uniqueId = $46c576986b3f1f6c$export$20da89723e6780ae._InstanceId++;
        this._glslangOptions = glslangOptions;
        this._twgslOptions = twgslOptions;
        return this._initGlslang(glslangOptions ?? this._options?.glslangOptions).then((glslang)=>{
            this._glslang = glslang;
            this._tintWASM = $46c576986b3f1f6c$export$20da89723e6780ae.UseTWGSL ? new (0, $kBotW.WebGPUTintWASM)() : null;
            return this._tintWASM ? this._tintWASM.initTwgsl(twgslOptions ?? this._options?.twgslOptions).then(()=>{
                return navigator.gpu.requestAdapter(this._options);
            }) : navigator.gpu.requestAdapter(this._options);
        }).then((adapter)=>{
            if (!adapter) // eslint-disable-next-line no-throw-literal
            throw "Could not retrieve a WebGPU adapter (adapter is null).";
            else {
                this._adapter = adapter;
                this._adapterSupportedExtensions = [];
                this._adapter.features?.forEach((feature)=>this._adapterSupportedExtensions.push(feature));
                this._adapterSupportedLimits = this._adapter.limits;
                this._adapter.requestAdapterInfo().then((adapterInfo)=>{
                    this._adapterInfo = adapterInfo;
                });
                const deviceDescriptor = this._options.deviceDescriptor ?? {};
                const requiredFeatures = deviceDescriptor?.requiredFeatures ?? (this._options.enableAllFeatures ? this._adapterSupportedExtensions : undefined);
                if (requiredFeatures) {
                    const requestedExtensions = requiredFeatures;
                    const validExtensions = [];
                    for (const extension of requestedExtensions)if (this._adapterSupportedExtensions.indexOf(extension) !== -1) validExtensions.push(extension);
                    deviceDescriptor.requiredFeatures = validExtensions;
                }
                if (this._options.setMaximumLimits && !deviceDescriptor.requiredLimits) {
                    deviceDescriptor.requiredLimits = {};
                    for(const name in this._adapterSupportedLimits){
                        if (name === "minSubgroupSize" || name === "maxSubgroupSize") continue;
                        deviceDescriptor.requiredLimits[name] = this._adapterSupportedLimits[name];
                    }
                }
                deviceDescriptor.label = `BabylonWebGPUDevice${this.uniqueId}`;
                return this._adapter.requestDevice(deviceDescriptor);
            }
        }).then((device)=>{
            this._device = device;
            this._deviceEnabledExtensions = [];
            this._device.features?.forEach((feature)=>this._deviceEnabledExtensions.push(feature));
            this._deviceLimits = device.limits;
            let numUncapturedErrors = -1;
            this._device.addEventListener("uncapturederror", (event)=>{
                if (++numUncapturedErrors < this.numMaxUncapturedErrors) (0, $kVtWi.Logger).Warn(`WebGPU uncaptured error (${numUncapturedErrors + 1}): ${event.error} - ${event.error.message}`);
                else if (numUncapturedErrors++ === this.numMaxUncapturedErrors) (0, $kVtWi.Logger).Warn(`WebGPU uncaptured error: too many warnings (${this.numMaxUncapturedErrors}), no more warnings will be reported to the console for this engine.`);
            });
            if (!this._doNotHandleContextLost) this._device.lost?.then((info)=>{
                if (this._isDisposed) return;
                this._contextWasLost = true;
                (0, $kVtWi.Logger).Warn("WebGPU context lost. " + info);
                this.onContextLostObservable.notifyObservers(this);
                this._restoreEngineAfterContextLost(async ()=>{
                    const snapshotRenderingMode = this.snapshotRenderingMode;
                    const snapshotRendering = this.snapshotRendering;
                    const disableCacheSamplers = this.disableCacheSamplers;
                    const disableCacheRenderPipelines = this.disableCacheRenderPipelines;
                    const disableCacheBindGroups = this.disableCacheBindGroups;
                    const enableGPUTimingMeasurements = this.enableGPUTimingMeasurements;
                    await this.initAsync(this._glslangOptions ?? this._options?.glslangOptions, this._twgslOptions ?? this._options?.twgslOptions);
                    this.snapshotRenderingMode = snapshotRenderingMode;
                    this.snapshotRendering = snapshotRendering;
                    this.disableCacheSamplers = disableCacheSamplers;
                    this.disableCacheRenderPipelines = disableCacheRenderPipelines;
                    this.disableCacheBindGroups = disableCacheBindGroups;
                    this.enableGPUTimingMeasurements = enableGPUTimingMeasurements;
                    this._currentRenderPass = null;
                });
            });
        }).then(()=>{
            this._bufferManager = new (0, $8U3Lx.WebGPUBufferManager)(this, this._device);
            this._textureHelper = new (0, $4ObYT.WebGPUTextureManager)(this, this._device, this._glslang, this._tintWASM, this._bufferManager, this._deviceEnabledExtensions);
            this._cacheSampler = new (0, $6okLJ.WebGPUCacheSampler)(this._device);
            this._cacheBindGroups = new (0, $3rO3H.WebGPUCacheBindGroups)(this._device, this._cacheSampler, this);
            this._timestampQuery = new (0, $hECLP.WebGPUTimestampQuery)(this, this._device, this._bufferManager);
            this._occlusionQuery = this._device.createQuerySet ? new (0, $jynN8.WebGPUOcclusionQuery)(this, this._device, this._bufferManager) : undefined;
            this._bundleList = new (0, $6HEDe.WebGPUBundleList)(this._device);
            this._snapshotRendering = new (0, $7CgyA.WebGPUSnapshotRendering)(this, this._snapshotRenderingMode, this._bundleList);
            this._ubInvertY = this._bufferManager.createBuffer(new Float32Array([
                -1,
                0
            ]), $hR6HG.BufferUsage.Uniform | $hR6HG.BufferUsage.CopyDst, "UBInvertY");
            this._ubDontInvertY = this._bufferManager.createBuffer(new Float32Array([
                1,
                0
            ]), $hR6HG.BufferUsage.Uniform | $hR6HG.BufferUsage.CopyDst, "UBDontInvertY");
            if (this.dbgVerboseLogsForFirstFrames) {
                if (this._count === undefined) {
                    this._count = 0;
                    (0, $kVtWi.Logger).Log([
                        "%c frame #" + this._count + " - begin",
                        "background: #ffff00"
                    ]);
                }
            }
            this._uploadEncoder = this._device.createCommandEncoder(this._uploadEncoderDescriptor);
            this._renderEncoder = this._device.createCommandEncoder(this._renderEncoderDescriptor);
            this._initializeLimits();
            this._emptyVertexBuffer = new (0, $b4i1f.VertexBuffer)(this, [
                0
            ], "", {
                stride: 1,
                offset: 0,
                size: 1,
                label: "EmptyVertexBuffer"
            });
            this._cacheRenderPipeline = new (0, $6dQQy.WebGPUCacheRenderPipelineTree)(this._device, this._emptyVertexBuffer);
            this._depthCullingState = new (0, $4MBPD.WebGPUDepthCullingState)(this._cacheRenderPipeline);
            this._stencilStateComposer = new (0, $7dZYU.WebGPUStencilStateComposer)(this._cacheRenderPipeline);
            this._stencilStateComposer.stencilGlobal = this._stencilState;
            this._depthCullingState.depthTest = true;
            this._depthCullingState.depthFunc = 515;
            this._depthCullingState.depthMask = true;
            this._textureHelper.setCommandEncoder(this._uploadEncoder);
            this._clearQuad = new (0, $2yTFf.WebGPUClearQuad)(this._device, this, this._emptyVertexBuffer);
            this._defaultDrawContext = this.createDrawContext();
            this._currentDrawContext = this._defaultDrawContext;
            this._defaultMaterialContext = this.createMaterialContext();
            this._currentMaterialContext = this._defaultMaterialContext;
            this._initializeContextAndSwapChain();
            this._initializeMainAttachments();
            this.resize();
        }).catch((e)=>{
            (0, $kVtWi.Logger).Error("A fatal error occurred during WebGPU creation/initialization.");
            throw e;
        });
    }
    _initGlslang(glslangOptions) {
        glslangOptions = glslangOptions || {};
        glslangOptions = {
            ...$46c576986b3f1f6c$export$20da89723e6780ae._GLSLslangDefaultOptions,
            ...glslangOptions
        };
        if (glslangOptions.glslang) return Promise.resolve(glslangOptions.glslang);
        if (self.glslang) return self.glslang(glslangOptions.wasmPath);
        if (glslangOptions.jsPath && glslangOptions.wasmPath) return (0, $bOhSV.Tools).LoadBabylonScriptAsync(glslangOptions.jsPath).then(()=>{
            return self.glslang((0, $bOhSV.Tools).GetBabylonScriptURL(glslangOptions.wasmPath));
        });
        return Promise.reject("gslang is not available.");
    }
    _initializeLimits() {
        // Init caps
        // TODO WEBGPU Real Capability check once limits will be working.
        this._caps = {
            maxTexturesImageUnits: this._deviceLimits.maxSampledTexturesPerShaderStage,
            maxVertexTextureImageUnits: this._deviceLimits.maxSampledTexturesPerShaderStage,
            maxCombinedTexturesImageUnits: this._deviceLimits.maxSampledTexturesPerShaderStage * 2,
            maxTextureSize: this._deviceLimits.maxTextureDimension2D,
            maxCubemapTextureSize: this._deviceLimits.maxTextureDimension2D,
            maxRenderTextureSize: this._deviceLimits.maxTextureDimension2D,
            maxVertexAttribs: this._deviceLimits.maxVertexAttributes,
            maxVaryingVectors: this._deviceLimits.maxInterStageShaderVariables,
            maxFragmentUniformVectors: Math.floor(this._deviceLimits.maxUniformBufferBindingSize / 4),
            maxVertexUniformVectors: Math.floor(this._deviceLimits.maxUniformBufferBindingSize / 4),
            standardDerivatives: true,
            astc: this._deviceEnabledExtensions.indexOf($hR6HG.FeatureName.TextureCompressionASTC) >= 0 ? true : undefined,
            s3tc: this._deviceEnabledExtensions.indexOf($hR6HG.FeatureName.TextureCompressionBC) >= 0 ? true : undefined,
            pvrtc: null,
            etc1: null,
            etc2: this._deviceEnabledExtensions.indexOf($hR6HG.FeatureName.TextureCompressionETC2) >= 0 ? true : undefined,
            bptc: this._deviceEnabledExtensions.indexOf($hR6HG.FeatureName.TextureCompressionBC) >= 0 ? true : undefined,
            maxAnisotropy: 16,
            uintIndices: true,
            fragmentDepthSupported: true,
            highPrecisionShaderSupported: true,
            colorBufferFloat: true,
            supportFloatTexturesResolve: false,
            rg11b10ufColorRenderable: this._deviceEnabledExtensions.indexOf($hR6HG.FeatureName.RG11B10UFloatRenderable) >= 0,
            textureFloat: true,
            textureFloatLinearFiltering: this._deviceEnabledExtensions.indexOf($hR6HG.FeatureName.Float32Filterable) >= 0,
            textureFloatRender: true,
            textureHalfFloat: true,
            textureHalfFloatLinearFiltering: true,
            textureHalfFloatRender: true,
            textureLOD: true,
            texelFetch: true,
            drawBuffersExtension: true,
            depthTextureExtension: true,
            vertexArrayObject: false,
            instancedArrays: true,
            timerQuery: typeof BigUint64Array !== "undefined" && this._deviceEnabledExtensions.indexOf($hR6HG.FeatureName.TimestampQuery) !== -1 ? true : undefined,
            supportOcclusionQuery: typeof BigUint64Array !== "undefined",
            canUseTimestampForTimerQuery: true,
            multiview: false,
            oculusMultiview: false,
            parallelShaderCompile: undefined,
            blendMinMax: true,
            maxMSAASamples: 4,
            canUseGLInstanceID: true,
            canUseGLVertexID: true,
            supportComputeShaders: true,
            supportSRGBBuffers: true,
            supportTransformFeedbacks: false,
            textureMaxLevel: true,
            texture2DArrayMaxLayerCount: this._deviceLimits.maxTextureArrayLayers,
            disableMorphTargetTexture: false
        };
        this._features = {
            forceBitmapOverHTMLImageElement: true,
            supportRenderAndCopyToLodForFloatTextures: true,
            supportDepthStencilTexture: true,
            supportShadowSamplers: true,
            uniformBufferHardCheckMatrix: false,
            allowTexturePrefiltering: true,
            trackUbosInFrame: true,
            checkUbosContentBeforeUpload: true,
            supportCSM: true,
            basisNeedsPOT: false,
            support3DTextures: true,
            needTypeSuffixInShaderConstants: true,
            supportMSAA: true,
            supportSSAO2: true,
            supportExtendedTextureFormats: true,
            supportSwitchCaseInShader: true,
            supportSyncTextureRead: false,
            needsInvertingBitmap: false,
            useUBOBindingCache: false,
            needShaderCodeInlining: true,
            needToAlwaysBindUniformBuffers: true,
            supportRenderPasses: true,
            supportSpriteInstancing: true,
            forceVertexBufferStrideAndOffsetMultiple4Bytes: true,
            _collectUbosUpdatedInFrame: false
        };
    }
    _initializeContextAndSwapChain() {
        if (!this._renderingCanvas) // eslint-disable-next-line no-throw-literal
        throw "The rendering canvas has not been set!";
        this._context = this._renderingCanvas.getContext("webgpu");
        this._configureContext();
        this._colorFormat = this._options.swapChainFormat;
        this._mainRenderPassWrapper.colorAttachmentGPUTextures = [
            new (0, $4JXMh.WebGPUHardwareTexture)()
        ];
        this._mainRenderPassWrapper.colorAttachmentGPUTextures[0].format = this._colorFormat;
        this._setColorFormat(this._mainRenderPassWrapper);
    }
    // Set default values as WebGL with depth and stencil attachment for the broadest Compat.
    _initializeMainAttachments() {
        if (!this._bufferManager) return;
        this.flushFramebuffer();
        this._mainTextureExtends = {
            width: this.getRenderWidth(true),
            height: this.getRenderHeight(true),
            depthOrArrayLayers: 1
        };
        const bufferDataUpdate = new Float32Array([
            this.getRenderHeight(true)
        ]);
        this._bufferManager.setSubData(this._ubInvertY, 4, bufferDataUpdate);
        this._bufferManager.setSubData(this._ubDontInvertY, 4, bufferDataUpdate);
        let mainColorAttachments;
        if (this._options.antialias) {
            const mainTextureDescriptor = {
                label: `Texture_MainColor_${this._mainTextureExtends.width}x${this._mainTextureExtends.height}_antialiasing`,
                size: this._mainTextureExtends,
                mipLevelCount: 1,
                sampleCount: this._mainPassSampleCount,
                dimension: $hR6HG.TextureDimension.E2d,
                format: this._options.swapChainFormat,
                usage: $hR6HG.TextureUsage.RenderAttachment
            };
            if (this._mainTexture) this._textureHelper.releaseTexture(this._mainTexture);
            this._mainTexture = this._device.createTexture(mainTextureDescriptor);
            mainColorAttachments = [
                {
                    view: this._mainTexture.createView({
                        label: "TextureView_MainColor_antialiasing",
                        dimension: $hR6HG.TextureDimension.E2d,
                        format: this._options.swapChainFormat,
                        mipLevelCount: 1,
                        arrayLayerCount: 1
                    }),
                    clearValue: new (0, $7etnY.Color4)(0, 0, 0, 1),
                    loadOp: $hR6HG.LoadOp.Clear,
                    storeOp: $hR6HG.StoreOp.Store
                }
            ];
        } else mainColorAttachments = [
            {
                view: undefined,
                clearValue: new (0, $7etnY.Color4)(0, 0, 0, 1),
                loadOp: $hR6HG.LoadOp.Clear,
                storeOp: $hR6HG.StoreOp.Store
            }
        ];
        this._mainRenderPassWrapper.depthTextureFormat = this.isStencilEnable ? $hR6HG.TextureFormat.Depth24PlusStencil8 : $hR6HG.TextureFormat.Depth32Float;
        this._setDepthTextureFormat(this._mainRenderPassWrapper);
        this._setColorFormat(this._mainRenderPassWrapper);
        const depthTextureDescriptor = {
            label: `Texture_MainDepthStencil_${this._mainTextureExtends.width}x${this._mainTextureExtends.height}`,
            size: this._mainTextureExtends,
            mipLevelCount: 1,
            sampleCount: this._mainPassSampleCount,
            dimension: $hR6HG.TextureDimension.E2d,
            format: this._mainRenderPassWrapper.depthTextureFormat,
            usage: $hR6HG.TextureUsage.RenderAttachment
        };
        if (this._depthTexture) this._textureHelper.releaseTexture(this._depthTexture);
        this._depthTexture = this._device.createTexture(depthTextureDescriptor);
        const mainDepthAttachment = {
            view: this._depthTexture.createView({
                label: `TextureView_MainDepthStencil_${this._mainTextureExtends.width}x${this._mainTextureExtends.height}`,
                dimension: $hR6HG.TextureDimension.E2d,
                format: this._depthTexture.format,
                mipLevelCount: 1,
                arrayLayerCount: 1
            }),
            depthClearValue: this._clearDepthValue,
            depthLoadOp: $hR6HG.LoadOp.Clear,
            depthStoreOp: $hR6HG.StoreOp.Store,
            stencilClearValue: this._clearStencilValue,
            stencilLoadOp: !this.isStencilEnable ? undefined : $hR6HG.LoadOp.Clear,
            stencilStoreOp: !this.isStencilEnable ? undefined : $hR6HG.StoreOp.Store
        };
        this._mainRenderPassWrapper.renderPassDescriptor = {
            label: "MainRenderPass",
            colorAttachments: mainColorAttachments,
            depthStencilAttachment: mainDepthAttachment
        };
    }
    _configureContext() {
        this._context.configure({
            device: this._device,
            format: this._options.swapChainFormat,
            usage: $hR6HG.TextureUsage.RenderAttachment | $hR6HG.TextureUsage.CopySrc,
            alphaMode: this.premultipliedAlpha ? $hR6HG.CanvasAlphaMode.Premultiplied : $hR6HG.CanvasAlphaMode.Opaque
        });
    }
    _rebuildBuffers() {
        super._rebuildBuffers();
        for (const storageBuffer of this._storageBuffers)// The buffer can already be rebuilt by the call to _rebuildGeometries(), which recreates the storage buffers for the ComputeShaderParticleSystem
        if (storageBuffer.getBuffer().engineId !== this.uniqueId) storageBuffer._rebuild();
    }
    _restoreEngineAfterContextLost(initEngine) {
        (0, $6dQQy.WebGPUCacheRenderPipelineTree).ResetCache();
        (0, $3rO3H.WebGPUCacheBindGroups).ResetCache();
        // Clear the draw wrappers and material contexts
        const cleanScenes = (scenes)=>{
            for (const scene of scenes){
                for (const mesh of scene.meshes){
                    const subMeshes = mesh.subMeshes;
                    if (!subMeshes) continue;
                    for (const subMesh of subMeshes)subMesh._drawWrappers = [];
                }
                for (const material of scene.materials)material._materialContext?.reset();
            }
        };
        cleanScenes(this.scenes);
        cleanScenes(this._virtualScenes);
        // The leftOver uniform buffers are removed from the list because they will be recreated when we rebuild the effects
        const uboList = [];
        for (const uniformBuffer of this._uniformBuffers)if (uniformBuffer.name.indexOf("leftOver") < 0) uboList.push(uniformBuffer);
        this._uniformBuffers = uboList;
        super._restoreEngineAfterContextLost(initEngine);
    }
    /**
     * Force a specific size of the canvas
     * @param width defines the new canvas' width
     * @param height defines the new canvas' height
     * @param forceSetSize true to force setting the sizes of the underlying canvas
     * @returns true if the size was changed
     */ setSize(width, height, forceSetSize = false) {
        if (!super.setSize(width, height, forceSetSize)) return false;
        if (this.dbgVerboseLogsForFirstFrames) {
            if (this._count === undefined) this._count = 0;
            if (!this._count || this._count < this.dbgVerboseLogsNumFrames) (0, $kVtWi.Logger).Log([
                "frame #" + this._count + " - setSize -",
                width,
                height
            ]);
        }
        this._initializeMainAttachments();
        if (this.snapshotRendering) // reset snapshot rendering so that the next frame will record a new list of bundles
        this.snapshotRenderingReset();
        return true;
    }
    /**
     * @internal
     */ _getShaderProcessor(shaderLanguage) {
        if (shaderLanguage === (0, $8WI3I.ShaderLanguage).WGSL) return this._shaderProcessorWGSL;
        return this._shaderProcessor;
    }
    /**
     * @internal
     */ _getShaderProcessingContext(shaderLanguage) {
        return new (0, $g5vsw.WebGPUShaderProcessingContext)(shaderLanguage);
    }
    _currentPassIsMainPass() {
        return this._currentRenderTarget === null;
    }
    _getCurrentRenderPass() {
        if (this._currentRenderTarget && !this._currentRenderPass) // delayed creation of the render target pass, but we now need to create it as we are requested the render pass
        this._startRenderTargetRenderPass(this._currentRenderTarget, false, null, false, false);
        else if (!this._currentRenderPass) this._startMainRenderPass(false);
        return this._currentRenderPass;
    }
    /** @internal */ _getCurrentRenderPassWrapper() {
        return this._currentRenderTarget ? this._rttRenderPassWrapper : this._mainRenderPassWrapper;
    }
    //------------------------------------------------------------------------------
    //                          Static Pipeline WebGPU States
    //------------------------------------------------------------------------------
    /** @internal */ applyStates() {
        this._stencilStateComposer.apply();
        this._cacheRenderPipeline.setAlphaBlendEnabled(this._alphaState.alphaBlend);
    }
    /**
     * Force the entire cache to be cleared
     * You should not have to use this function unless your engine needs to share the WebGPU context with another engine
     * @param bruteForce defines a boolean to force clearing ALL caches (including stencil, detoh and alpha states)
     */ wipeCaches(bruteForce) {
        if (this.preventCacheWipeBetweenFrames && !bruteForce) return;
        //this._currentEffect = null; // can't reset _currentEffect, else some crashes can occur (for eg in ProceduralTexture which calls bindFrameBuffer (which calls wipeCaches) after having called enableEffect and before drawing into the texture)
        // _forceEnableEffect = true assumes the role of _currentEffect = null
        this._forceEnableEffect = true;
        this._currentIndexBuffer = null;
        this._currentOverrideVertexBuffers = null;
        this._cacheRenderPipeline.setBuffers(null, null, null);
        if (bruteForce) {
            this._stencilStateComposer.reset();
            this._depthCullingState.reset();
            this._depthCullingState.depthFunc = 515;
            this._alphaState.reset();
            this._alphaMode = 1;
            this._alphaEquation = 0;
            this._cacheRenderPipeline.setAlphaBlendFactors(this._alphaState._blendFunctionParameters, this._alphaState._blendEquationParameters);
            this._cacheRenderPipeline.setAlphaBlendEnabled(false);
            this.setColorWrite(true);
        }
        this._cachedVertexBuffers = null;
        this._cachedIndexBuffer = null;
        this._cachedEffectForVertexBuffers = null;
    }
    /**
     * Enable or disable color writing
     * @param enable defines the state to set
     */ setColorWrite(enable) {
        this._colorWriteLocal = enable;
        this._cacheRenderPipeline.setWriteMask(enable ? 0xf : 0);
    }
    /**
     * Gets a boolean indicating if color writing is enabled
     * @returns the current color writing state
     */ getColorWrite() {
        return this._colorWriteLocal;
    }
    _mustUpdateViewport() {
        const x = this._viewportCached.x, y = this._viewportCached.y, w = this._viewportCached.z, h = this._viewportCached.w;
        const update = this._viewportsCurrent.x !== x || this._viewportsCurrent.y !== y || this._viewportsCurrent.w !== w || this._viewportsCurrent.h !== h;
        if (update) {
            this._viewportsCurrent.x = this._viewportCached.x;
            this._viewportsCurrent.y = this._viewportCached.y;
            this._viewportsCurrent.w = this._viewportCached.z;
            this._viewportsCurrent.h = this._viewportCached.w;
        }
        return update;
    }
    _applyViewport(bundleList) {
        const x = Math.floor(this._viewportCached.x);
        const w = Math.floor(this._viewportCached.z);
        const h = Math.floor(this._viewportCached.w);
        let y = Math.floor(this._viewportCached.y);
        if (!this._currentRenderTarget) y = this.getRenderHeight(true) - y - h;
        if (bundleList) bundleList.addItem(new (0, $6HEDe.WebGPURenderItemViewport)(x, y, w, h));
        else this._getCurrentRenderPass().setViewport(x, y, w, h, 0, 1);
        if (this.dbgVerboseLogsForFirstFrames) {
            if (this._count === undefined) this._count = 0;
            if (!this._count || this._count < this.dbgVerboseLogsNumFrames) (0, $kVtWi.Logger).Log([
                "frame #" + this._count + " - viewport applied - (",
                this._viewportCached.x,
                this._viewportCached.y,
                this._viewportCached.z,
                this._viewportCached.w,
                ") current pass is main pass=" + this._currentPassIsMainPass()
            ]);
        }
    }
    /**
     * @internal
     */ _viewport(x, y, width, height) {
        this._viewportCached.x = x;
        this._viewportCached.y = y;
        this._viewportCached.z = width;
        this._viewportCached.w = height;
    }
    _mustUpdateScissor() {
        const x = this._scissorCached.x, y = this._scissorCached.y, w = this._scissorCached.z, h = this._scissorCached.w;
        const update = this._scissorsCurrent.x !== x || this._scissorsCurrent.y !== y || this._scissorsCurrent.w !== w || this._scissorsCurrent.h !== h;
        if (update) {
            this._scissorsCurrent.x = this._scissorCached.x;
            this._scissorsCurrent.y = this._scissorCached.y;
            this._scissorsCurrent.w = this._scissorCached.z;
            this._scissorsCurrent.h = this._scissorCached.w;
        }
        return update;
    }
    _applyScissor(bundleList) {
        const y = this._currentRenderTarget ? this._scissorCached.y : this.getRenderHeight() - this._scissorCached.w - this._scissorCached.y;
        if (bundleList) bundleList.addItem(new (0, $6HEDe.WebGPURenderItemScissor)(this._scissorCached.x, y, this._scissorCached.z, this._scissorCached.w));
        else this._getCurrentRenderPass().setScissorRect(this._scissorCached.x, y, this._scissorCached.z, this._scissorCached.w);
        if (this.dbgVerboseLogsForFirstFrames) {
            if (this._count === undefined) this._count = 0;
            if (!this._count || this._count < this.dbgVerboseLogsNumFrames) (0, $kVtWi.Logger).Log([
                "frame #" + this._count + " - scissor applied - (",
                this._scissorCached.x,
                this._scissorCached.y,
                this._scissorCached.z,
                this._scissorCached.w,
                ") current pass is main pass=" + this._currentPassIsMainPass()
            ]);
        }
    }
    _scissorIsActive() {
        return this._scissorCached.x !== 0 || this._scissorCached.y !== 0 || this._scissorCached.z !== 0 || this._scissorCached.w !== 0;
    }
    enableScissor(x, y, width, height) {
        this._scissorCached.x = x;
        this._scissorCached.y = y;
        this._scissorCached.z = width;
        this._scissorCached.w = height;
    }
    disableScissor() {
        this._scissorCached.x = this._scissorCached.y = this._scissorCached.z = this._scissorCached.w = 0;
        this._scissorsCurrent.x = this._scissorsCurrent.y = this._scissorsCurrent.w = this._scissorsCurrent.h = 0;
    }
    _mustUpdateStencilRef() {
        const update = this._stencilStateComposer.funcRef !== this._stencilRefsCurrent;
        if (update) this._stencilRefsCurrent = this._stencilStateComposer.funcRef;
        return update;
    }
    _applyStencilRef(bundleList) {
        if (bundleList) bundleList.addItem(new (0, $6HEDe.WebGPURenderItemStencilRef)(this._stencilStateComposer.funcRef ?? 0));
        else this._getCurrentRenderPass().setStencilReference(this._stencilStateComposer.funcRef ?? 0);
    }
    _mustUpdateBlendColor() {
        const colorBlend = this._alphaState._blendConstants;
        const update = colorBlend[0] !== this._blendColorsCurrent[0] || colorBlend[1] !== this._blendColorsCurrent[1] || colorBlend[2] !== this._blendColorsCurrent[2] || colorBlend[3] !== this._blendColorsCurrent[3];
        if (update) {
            this._blendColorsCurrent[0] = colorBlend[0];
            this._blendColorsCurrent[1] = colorBlend[1];
            this._blendColorsCurrent[2] = colorBlend[2];
            this._blendColorsCurrent[3] = colorBlend[3];
        }
        return update;
    }
    _applyBlendColor(bundleList) {
        if (bundleList) bundleList.addItem(new (0, $6HEDe.WebGPURenderItemBlendColor)(this._alphaState._blendConstants.slice()));
        else this._getCurrentRenderPass().setBlendConstant(this._alphaState._blendConstants);
    }
    _resetRenderPassStates() {
        this._viewportsCurrent.x = this._viewportsCurrent.y = this._viewportsCurrent.w = this._viewportsCurrent.h = 0;
        this._scissorsCurrent.x = this._scissorsCurrent.y = this._scissorsCurrent.w = this._scissorsCurrent.h = 0;
        this._stencilRefsCurrent = -1;
        this._blendColorsCurrent[0] = this._blendColorsCurrent[1] = this._blendColorsCurrent[2] = this._blendColorsCurrent[3] = null;
    }
    /**
     * Clear the current render buffer or the current render target (if any is set up)
     * @param color defines the color to use
     * @param backBuffer defines if the back buffer must be cleared
     * @param depth defines if the depth buffer must be cleared
     * @param stencil defines if the stencil buffer must be cleared
     */ clear(color, backBuffer, depth, stencil = false) {
        // Some PGs are using color3...
        if (color && color.a === undefined) color.a = 1;
        const hasScissor = this._scissorIsActive();
        if (this.dbgVerboseLogsForFirstFrames) {
            if (this._count === undefined) this._count = 0;
            if (!this._count || this._count < this.dbgVerboseLogsNumFrames) (0, $kVtWi.Logger).Log([
                "frame #" + this._count + " - clear - backBuffer=",
                backBuffer,
                " depth=",
                depth,
                " stencil=",
                stencil,
                " scissor is active=",
                hasScissor
            ]);
        }
        // We need to recreate the render pass so that the new parameters for clear color / depth / stencil are taken into account
        if (this._currentRenderTarget) {
            if (hasScissor) {
                if (!this._currentRenderPass) this._startRenderTargetRenderPass(this._currentRenderTarget, false, backBuffer ? color : null, depth, stencil);
                this._applyScissor(!this.compatibilityMode ? this._bundleList : null);
                this._clearFullQuad(backBuffer ? color : null, depth, stencil);
            } else {
                if (this._currentRenderPass) this._endCurrentRenderPass();
                this._startRenderTargetRenderPass(this._currentRenderTarget, true, backBuffer ? color : null, depth, stencil);
            }
        } else {
            if (!this._currentRenderPass || !hasScissor) this._startMainRenderPass(!hasScissor, backBuffer ? color : null, depth, stencil);
            if (hasScissor) {
                this._applyScissor(!this.compatibilityMode ? this._bundleList : null);
                this._clearFullQuad(backBuffer ? color : null, depth, stencil);
            }
        }
    }
    _clearFullQuad(clearColor, clearDepth, clearStencil) {
        const renderPass = !this.compatibilityMode ? null : this._getCurrentRenderPass();
        this._clearQuad.setColorFormat(this._colorFormat);
        this._clearQuad.setDepthStencilFormat(this._depthTextureFormat);
        this._clearQuad.setMRTAttachments(this._cacheRenderPipeline.mrtAttachments ?? [], this._cacheRenderPipeline.mrtTextureArray ?? [], this._cacheRenderPipeline.mrtTextureCount);
        if (!this.compatibilityMode) this._bundleList.addItem(new (0, $6HEDe.WebGPURenderItemStencilRef)(this._clearStencilValue));
        else renderPass.setStencilReference(this._clearStencilValue);
        const bundle = this._clearQuad.clear(renderPass, clearColor, clearDepth, clearStencil, this.currentSampleCount);
        if (!this.compatibilityMode) {
            this._bundleList.addBundle(bundle);
            this._applyStencilRef(this._bundleList);
            this._reportDrawCall();
        } else this._applyStencilRef(null);
    }
    //------------------------------------------------------------------------------
    //                              Vertex/Index/Storage Buffers
    //------------------------------------------------------------------------------
    /**
     * Creates a vertex buffer
     * @param data the data or the size for the vertex buffer
     * @param _updatable whether the buffer should be created as updatable
     * @param label defines the label of the buffer (for debug purpose)
     * @returns the new buffer
     */ createVertexBuffer(data, _updatable, label) {
        let view;
        if (data instanceof Array) view = new Float32Array(data);
        else if (data instanceof ArrayBuffer) view = new Uint8Array(data);
        else view = data;
        const dataBuffer = this._bufferManager.createBuffer(view, $hR6HG.BufferUsage.Vertex | $hR6HG.BufferUsage.CopyDst, label);
        return dataBuffer;
    }
    /**
     * Creates a vertex buffer
     * @param data the data for the dynamic vertex buffer
     * @param label defines the label of the buffer (for debug purpose)
     * @returns the new buffer
     */ createDynamicVertexBuffer(data, label) {
        return this.createVertexBuffer(data, undefined, label);
    }
    /**
     * Creates a new index buffer
     * @param indices defines the content of the index buffer
     * @param _updatable defines if the index buffer must be updatable
     * @param label defines the label of the buffer (for debug purpose)
     * @returns a new buffer
     */ createIndexBuffer(indices, _updatable, label) {
        let is32Bits = true;
        let view;
        if (indices instanceof Uint32Array || indices instanceof Int32Array) view = indices;
        else if (indices instanceof Uint16Array) {
            view = indices;
            is32Bits = false;
        } else if (indices.length > 65535) view = new Uint32Array(indices);
        else {
            view = new Uint16Array(indices);
            is32Bits = false;
        }
        const dataBuffer = this._bufferManager.createBuffer(view, $hR6HG.BufferUsage.Index | $hR6HG.BufferUsage.CopyDst, label);
        dataBuffer.is32Bits = is32Bits;
        return dataBuffer;
    }
    /**
     * Update a dynamic index buffer
     * @param indexBuffer defines the target index buffer
     * @param indices defines the data to update
     * @param offset defines the offset in the target index buffer where update should start
     */ updateDynamicIndexBuffer(indexBuffer, indices, offset = 0) {
        const gpuBuffer = indexBuffer;
        let view;
        if (indexBuffer.is32Bits) view = indices instanceof Uint32Array ? indices : new Uint32Array(indices);
        else view = indices instanceof Uint16Array ? indices : new Uint16Array(indices);
        this._bufferManager.setSubData(gpuBuffer, offset, view);
    }
    /**
     * Updates a dynamic vertex buffer.
     * @param vertexBuffer the vertex buffer to update
     * @param data the data used to update the vertex buffer
     * @param byteOffset the byte offset of the data
     * @param byteLength the byte length of the data
     */ updateDynamicVertexBuffer(vertexBuffer, data, byteOffset, byteLength) {
        const dataBuffer = vertexBuffer;
        if (byteOffset === undefined) byteOffset = 0;
        let view;
        if (byteLength === undefined) {
            if (data instanceof Array) view = new Float32Array(data);
            else if (data instanceof ArrayBuffer) view = new Uint8Array(data);
            else view = data;
            byteLength = view.byteLength;
        } else {
            if (data instanceof Array) view = new Float32Array(data);
            else if (data instanceof ArrayBuffer) view = new Uint8Array(data);
            else view = data;
        }
        this._bufferManager.setSubData(dataBuffer, byteOffset, view, 0, byteLength);
    }
    /**
     * @internal
     */ _createBuffer(data, creationFlags, label) {
        let view;
        if (data instanceof Array) view = new Float32Array(data);
        else if (data instanceof ArrayBuffer) view = new Uint8Array(data);
        else view = data;
        let flags = 0;
        if (creationFlags & 1) flags |= $hR6HG.BufferUsage.CopySrc;
        if (creationFlags & 2) flags |= $hR6HG.BufferUsage.CopyDst;
        if (creationFlags & 4) flags |= $hR6HG.BufferUsage.Uniform;
        if (creationFlags & 8) flags |= $hR6HG.BufferUsage.Vertex;
        if (creationFlags & 16) flags |= $hR6HG.BufferUsage.Index;
        if (creationFlags & 32) flags |= $hR6HG.BufferUsage.Storage;
        return this._bufferManager.createBuffer(view, flags, label);
    }
    /**
     * @internal
     */ bindBuffersDirectly() {
        // eslint-disable-next-line no-throw-literal
        throw "Not implemented on WebGPU";
    }
    /**
     * @internal
     */ updateAndBindInstancesBuffer() {
        // eslint-disable-next-line no-throw-literal
        throw "Not implemented on WebGPU";
    }
    /**
     * Bind a list of vertex buffers with the engine
     * @param vertexBuffers defines the list of vertex buffers to bind
     * @param indexBuffer defines the index buffer to bind
     * @param effect defines the effect associated with the vertex buffers
     * @param overrideVertexBuffers defines optional list of avertex buffers that overrides the entries in vertexBuffers
     */ bindBuffers(vertexBuffers, indexBuffer, effect, overrideVertexBuffers) {
        this._currentIndexBuffer = indexBuffer;
        this._currentOverrideVertexBuffers = overrideVertexBuffers ?? null;
        this._cacheRenderPipeline.setBuffers(vertexBuffers, indexBuffer, this._currentOverrideVertexBuffers);
    }
    /**
     * @internal
     */ _releaseBuffer(buffer) {
        return this._bufferManager.releaseBuffer(buffer);
    }
    //------------------------------------------------------------------------------
    //                              Uniform Buffers
    //------------------------------------------------------------------------------
    /**
     * Create an uniform buffer
     * @see https://doc.babylonjs.com/setup/support/webGL2#uniform-buffer-objets
     * @param elements defines the content of the uniform buffer
     * @param label defines a name for the buffer (for debugging purpose)
     * @returns the webGL uniform buffer
     */ createUniformBuffer(elements, label) {
        let view;
        if (elements instanceof Array) view = new Float32Array(elements);
        else view = elements;
        const dataBuffer = this._bufferManager.createBuffer(view, $hR6HG.BufferUsage.Uniform | $hR6HG.BufferUsage.CopyDst, label);
        return dataBuffer;
    }
    /**
     * Create a dynamic uniform buffer (no different from a non dynamic uniform buffer in WebGPU)
     * @see https://doc.babylonjs.com/setup/support/webGL2#uniform-buffer-objets
     * @param elements defines the content of the uniform buffer
     * @param label defines a name for the buffer (for debugging purpose)
     * @returns the webGL uniform buffer
     */ createDynamicUniformBuffer(elements, label) {
        return this.createUniformBuffer(elements, label);
    }
    /**
     * Update an existing uniform buffer
     * @see https://doc.babylonjs.com/setup/support/webGL2#uniform-buffer-objets
     * @param uniformBuffer defines the target uniform buffer
     * @param elements defines the content to update
     * @param offset defines the offset in the uniform buffer where update should start
     * @param count defines the size of the data to update
     */ updateUniformBuffer(uniformBuffer, elements, offset, count) {
        if (offset === undefined) offset = 0;
        const dataBuffer = uniformBuffer;
        let view;
        if (count === undefined) {
            if (elements instanceof Float32Array) view = elements;
            else view = new Float32Array(elements);
            count = view.byteLength;
        } else if (elements instanceof Float32Array) view = elements;
        else view = new Float32Array(elements);
        this._bufferManager.setSubData(dataBuffer, offset, view, 0, count);
    }
    /**
     * Bind a buffer to the current draw context
     * @param buffer defines the buffer to bind
     * @param _location not used in WebGPU
     * @param name Name of the uniform variable to bind
     */ bindUniformBufferBase(buffer, _location, name) {
        this._currentDrawContext.setBuffer(name, buffer);
    }
    /**
     * Unused in WebGPU
     */ bindUniformBlock() {}
    //------------------------------------------------------------------------------
    //                              Effects
    //------------------------------------------------------------------------------
    /**
     * Create a new effect (used to store vertex/fragment shaders)
     * @param baseName defines the base name of the effect (The name of file without .fragment.fx or .vertex.fx)
     * @param attributesNamesOrOptions defines either a list of attribute names or an IEffectCreationOptions object
     * @param uniformsNamesOrEngine defines either a list of uniform names or the engine to use
     * @param samplers defines an array of string used to represent textures
     * @param defines defines the string containing the defines to use to compile the shaders
     * @param fallbacks defines the list of potential fallbacks to use if shader compilation fails
     * @param onCompiled defines a function to call when the effect creation is successful
     * @param onError defines a function to call when the effect creation has failed
     * @param indexParameters defines an object containing the index values to use to compile shaders (like the maximum number of simultaneous lights)
     * @param shaderLanguage the language the shader is written in (default: GLSL)
     * @returns the new Effect
     */ createEffect(baseName, attributesNamesOrOptions, uniformsNamesOrEngine, samplers, defines, fallbacks, onCompiled, onError, indexParameters, shaderLanguage = (0, $8WI3I.ShaderLanguage).GLSL) {
        const vertex = baseName.vertexElement || baseName.vertex || baseName.vertexToken || baseName.vertexSource || baseName;
        const fragment = baseName.fragmentElement || baseName.fragment || baseName.fragmentToken || baseName.fragmentSource || baseName;
        const globalDefines = this._getGlobalDefines();
        let fullDefines = defines ?? attributesNamesOrOptions.defines ?? "";
        if (globalDefines) fullDefines += "\n" + globalDefines;
        const name = vertex + "+" + fragment + "@" + fullDefines;
        if (this._compiledEffects[name]) {
            const compiledEffect = this._compiledEffects[name];
            if (onCompiled && compiledEffect.isReady()) onCompiled(compiledEffect);
            return compiledEffect;
        }
        const effect = new (0, $lUDWq.Effect)(baseName, attributesNamesOrOptions, uniformsNamesOrEngine, samplers, this, defines, fallbacks, onCompiled, onError, indexParameters, name, shaderLanguage);
        this._compiledEffects[name] = effect;
        return effect;
    }
    _compileRawShaderToSpirV(source, type) {
        return this._glslang.compileGLSL(source, type);
    }
    _compileShaderToSpirV(source, type, defines, shaderVersion) {
        return this._compileRawShaderToSpirV(shaderVersion + (defines ? defines + "\n" : "") + source, type);
    }
    _getWGSLShader(source, type, defines) {
        if (defines) defines = "//" + defines.split("\n").join("\n//") + "\n";
        else defines = "";
        return defines + source;
    }
    _createPipelineStageDescriptor(vertexShader, fragmentShader, shaderLanguage, disableUniformityAnalysisInVertex, disableUniformityAnalysisInFragment) {
        if (this._tintWASM && shaderLanguage === (0, $8WI3I.ShaderLanguage).GLSL) {
            vertexShader = this._tintWASM.convertSpirV2WGSL(vertexShader, disableUniformityAnalysisInVertex);
            fragmentShader = this._tintWASM.convertSpirV2WGSL(fragmentShader, disableUniformityAnalysisInFragment);
        }
        return {
            vertexStage: {
                module: this._device.createShaderModule({
                    code: vertexShader
                }),
                entryPoint: "main"
            },
            fragmentStage: {
                module: this._device.createShaderModule({
                    code: fragmentShader
                }),
                entryPoint: "main"
            }
        };
    }
    _compileRawPipelineStageDescriptor(vertexCode, fragmentCode, shaderLanguage) {
        const disableUniformityAnalysisInVertex = vertexCode.indexOf($46c576986b3f1f6c$var$disableUniformityAnalysisMarker) >= 0;
        const disableUniformityAnalysisInFragment = fragmentCode.indexOf($46c576986b3f1f6c$var$disableUniformityAnalysisMarker) >= 0;
        const vertexShader = shaderLanguage === (0, $8WI3I.ShaderLanguage).GLSL ? this._compileRawShaderToSpirV(vertexCode, "vertex") : vertexCode;
        const fragmentShader = shaderLanguage === (0, $8WI3I.ShaderLanguage).GLSL ? this._compileRawShaderToSpirV(fragmentCode, "fragment") : fragmentCode;
        return this._createPipelineStageDescriptor(vertexShader, fragmentShader, shaderLanguage, disableUniformityAnalysisInVertex, disableUniformityAnalysisInFragment);
    }
    _compilePipelineStageDescriptor(vertexCode, fragmentCode, defines, shaderLanguage) {
        this.onBeforeShaderCompilationObservable.notifyObservers(this);
        const disableUniformityAnalysisInVertex = vertexCode.indexOf($46c576986b3f1f6c$var$disableUniformityAnalysisMarker) >= 0;
        const disableUniformityAnalysisInFragment = fragmentCode.indexOf($46c576986b3f1f6c$var$disableUniformityAnalysisMarker) >= 0;
        const shaderVersion = "#version 450\n";
        const vertexShader = shaderLanguage === (0, $8WI3I.ShaderLanguage).GLSL ? this._compileShaderToSpirV(vertexCode, "vertex", defines, shaderVersion) : this._getWGSLShader(vertexCode, "vertex", defines);
        const fragmentShader = shaderLanguage === (0, $8WI3I.ShaderLanguage).GLSL ? this._compileShaderToSpirV(fragmentCode, "fragment", defines, shaderVersion) : this._getWGSLShader(fragmentCode, "fragment", defines);
        const program = this._createPipelineStageDescriptor(vertexShader, fragmentShader, shaderLanguage, disableUniformityAnalysisInVertex, disableUniformityAnalysisInFragment);
        this.onAfterShaderCompilationObservable.notifyObservers(this);
        return program;
    }
    /**
     * @internal
     */ createRawShaderProgram() {
        // eslint-disable-next-line no-throw-literal
        throw "Not available on WebGPU";
    }
    /**
     * @internal
     */ createShaderProgram() {
        // eslint-disable-next-line no-throw-literal
        throw "Not available on WebGPU";
    }
    /**
     * Inline functions in shader code that are marked to be inlined
     * @param code code to inline
     * @returns inlined code
     */ inlineShaderCode(code) {
        const sci = new (0, $lh6wJ.ShaderCodeInliner)(code);
        sci.debug = false;
        sci.processCode();
        return sci.code;
    }
    /**
     * Creates a new pipeline context
     * @param shaderProcessingContext defines the shader processing context used during the processing if available
     * @returns the new pipeline
     */ createPipelineContext(shaderProcessingContext) {
        return new (0, $iVtp9.WebGPUPipelineContext)(shaderProcessingContext, this);
    }
    /**
     * Creates a new material context
     * @returns the new context
     */ createMaterialContext() {
        return new (0, $gJSsf.WebGPUMaterialContext)();
    }
    /**
     * Creates a new draw context
     * @returns the new context
     */ createDrawContext() {
        return new (0, $eFVmp.WebGPUDrawContext)(this._bufferManager);
    }
    /**
     * @internal
     */ _preparePipelineContext(pipelineContext, vertexSourceCode, fragmentSourceCode, createAsRaw, rawVertexSourceCode, rawFragmentSourceCode, rebuildRebind, defines) {
        const webGpuContext = pipelineContext;
        const shaderLanguage = webGpuContext.shaderProcessingContext.shaderLanguage;
        if (this.dbgShowShaderCode) {
            (0, $kVtWi.Logger).Log([
                "defines",
                defines
            ]);
            (0, $kVtWi.Logger).Log(vertexSourceCode);
            (0, $kVtWi.Logger).Log(fragmentSourceCode);
            (0, $kVtWi.Logger).Log("***********************************************");
        }
        webGpuContext.sources = {
            fragment: fragmentSourceCode,
            vertex: vertexSourceCode,
            rawVertex: rawVertexSourceCode,
            rawFragment: rawFragmentSourceCode
        };
        if (createAsRaw) webGpuContext.stages = this._compileRawPipelineStageDescriptor(vertexSourceCode, fragmentSourceCode, shaderLanguage);
        else webGpuContext.stages = this._compilePipelineStageDescriptor(vertexSourceCode, fragmentSourceCode, defines, shaderLanguage);
    }
    /**
     * Gets the list of active attributes for a given WebGPU program
     * @param pipelineContext defines the pipeline context to use
     * @param attributesNames defines the list of attribute names to get
     * @returns an array of indices indicating the offset of each attribute
     */ getAttributes(pipelineContext, attributesNames) {
        const results = new Array(attributesNames.length);
        const gpuPipelineContext = pipelineContext;
        for(let i = 0; i < attributesNames.length; i++){
            const attributeName = attributesNames[i];
            const attributeLocation = gpuPipelineContext.shaderProcessingContext.availableAttributes[attributeName];
            if (attributeLocation === undefined) continue;
            results[i] = attributeLocation;
        }
        return results;
    }
    /**
     * Activates an effect, making it the current one (ie. the one used for rendering)
     * @param effect defines the effect to activate
     */ enableEffect(effect) {
        if (!effect) return;
        if (!(0, $hOyoX.DrawWrapper).IsWrapper(effect)) {
            this._currentEffect = effect;
            this._currentMaterialContext = this._defaultMaterialContext;
            this._currentDrawContext = this._defaultDrawContext;
            this._counters.numEnableEffects++;
            if (this.dbgLogIfNotDrawWrapper) (0, $kVtWi.Logger).Warn(`enableEffect has been called with an Effect and not a Wrapper! effect.uniqueId=${effect.uniqueId}, effect.name=${effect.name}, effect.name.vertex=${effect.name.vertex}, effect.name.fragment=${effect.name.fragment}`, 10);
        } else if (!effect.effect || effect.effect === this._currentEffect && effect.materialContext === this._currentMaterialContext && effect.drawContext === this._currentDrawContext && !this._forceEnableEffect) {
            if (!effect.effect && this.dbgShowEmptyEnableEffectCalls) {
                (0, $kVtWi.Logger).Log([
                    "drawWrapper=",
                    effect
                ]);
                // eslint-disable-next-line no-throw-literal
                throw "Invalid call to enableEffect: the effect property is empty!";
            }
            return;
        } else {
            this._currentEffect = effect.effect;
            this._currentMaterialContext = effect.materialContext;
            this._currentDrawContext = effect.drawContext;
            this._counters.numEnableDrawWrapper++;
            if (!this._currentMaterialContext) {
                (0, $kVtWi.Logger).Log([
                    "drawWrapper=",
                    effect
                ]);
                // eslint-disable-next-line no-throw-literal
                throw `Invalid call to enableEffect: the materialContext property is empty!`;
            }
        }
        this._stencilStateComposer.stencilMaterial = undefined;
        this._forceEnableEffect = false;
        if (this._currentEffect.onBind) this._currentEffect.onBind(this._currentEffect);
        if (this._currentEffect._onBindObservable) this._currentEffect._onBindObservable.notifyObservers(this._currentEffect);
    }
    /**
     * @internal
     */ _releaseEffect(effect) {
        if (this._compiledEffects[effect._key]) {
            delete this._compiledEffects[effect._key];
            this._deletePipelineContext(effect.getPipelineContext());
        }
    }
    /**
     * Force the engine to release all cached effects. This means that next effect compilation will have to be done completely even if a similar effect was already compiled
     */ releaseEffects() {
        for(const name in this._compiledEffects){
            const webGPUPipelineContext = this._compiledEffects[name].getPipelineContext();
            this._deletePipelineContext(webGPUPipelineContext);
        }
        this._compiledEffects = {};
    }
    _deletePipelineContext(pipelineContext) {
        const webgpuPipelineContext = pipelineContext;
        if (webgpuPipelineContext) pipelineContext.dispose();
    }
    //------------------------------------------------------------------------------
    //                              Textures
    //------------------------------------------------------------------------------
    /**
     * Gets a boolean indicating that only power of 2 textures are supported
     * Please note that you can still use non power of 2 textures but in this case the engine will forcefully convert them
     */ get needPOTTextures() {
        return false;
    }
    /** @internal */ _createHardwareTexture() {
        return new (0, $4JXMh.WebGPUHardwareTexture)();
    }
    /**
     * @internal
     */ _releaseTexture(texture) {
        const index = this._internalTexturesCache.indexOf(texture);
        if (index !== -1) this._internalTexturesCache.splice(index, 1);
        this._textureHelper.releaseTexture(texture);
    }
    /**
     * @internal
     */ _getRGBABufferInternalSizedFormat() {
        return 5;
    }
    updateTextureComparisonFunction(texture, comparisonFunction) {
        texture._comparisonFunction = comparisonFunction;
    }
    /**
     * Creates an internal texture without binding it to a framebuffer
     * @internal
     * @param size defines the size of the texture
     * @param options defines the options used to create the texture
     * @param delayGPUTextureCreation true to delay the texture creation the first time it is really needed. false to create it right away
     * @param source source type of the texture
     * @returns a new internal texture
     */ _createInternalTexture(size, options, delayGPUTextureCreation = true, source = (0, $b9e4a.InternalTextureSource).Unknown) {
        const fullOptions = {};
        if (options !== undefined && typeof options === "object") {
            fullOptions.generateMipMaps = options.generateMipMaps;
            fullOptions.type = options.type === undefined ? 0 : options.type;
            fullOptions.samplingMode = options.samplingMode === undefined ? 3 : options.samplingMode;
            fullOptions.format = options.format === undefined ? 5 : options.format;
            fullOptions.samples = options.samples ?? 1;
            fullOptions.creationFlags = options.creationFlags ?? 0;
            fullOptions.useSRGBBuffer = options.useSRGBBuffer ?? false;
            fullOptions.label = options.label;
        } else {
            fullOptions.generateMipMaps = options;
            fullOptions.type = 0;
            fullOptions.samplingMode = 3;
            fullOptions.format = 5;
            fullOptions.samples = 1;
            fullOptions.creationFlags = 0;
            fullOptions.useSRGBBuffer = false;
        }
        if (fullOptions.type === 1 && !this._caps.textureFloatLinearFiltering) fullOptions.samplingMode = 1;
        else if (fullOptions.type === 2 && !this._caps.textureHalfFloatLinearFiltering) fullOptions.samplingMode = 1;
        if (fullOptions.type === 1 && !this._caps.textureFloat) {
            fullOptions.type = 0;
            (0, $kVtWi.Logger).Warn("Float textures are not supported. Type forced to TEXTURETYPE_UNSIGNED_BYTE");
        }
        const texture = new (0, $b9e4a.InternalTexture)(this, source);
        const width = size.width || size;
        const height = size.height || size;
        const layers = size.layers || 0;
        texture.baseWidth = width;
        texture.baseHeight = height;
        texture.width = width;
        texture.height = height;
        texture.depth = layers;
        texture.isReady = true;
        texture.samples = fullOptions.samples;
        texture.generateMipMaps = fullOptions.generateMipMaps ? true : false;
        texture.samplingMode = fullOptions.samplingMode;
        texture.type = fullOptions.type;
        texture.format = fullOptions.format;
        texture.is2DArray = layers > 0;
        texture._cachedWrapU = 0;
        texture._cachedWrapV = 0;
        texture._useSRGBBuffer = fullOptions.useSRGBBuffer;
        texture.label = fullOptions.label;
        this._internalTexturesCache.push(texture);
        if (!delayGPUTextureCreation) this._textureHelper.createGPUTextureForInternalTexture(texture, width, height, layers || 1, fullOptions.creationFlags);
        return texture;
    }
    /**
     * Usually called from Texture.ts.
     * Passed information to create a hardware texture
     * @param url defines a value which contains one of the following:
     * * A conventional http URL, e.g. 'http://...' or 'file://...'
     * * A base64 string of in-line texture data, e.g. 'data:image/jpg;base64,/...'
     * * An indicator that data being passed using the buffer parameter, e.g. 'data:mytexture.jpg'
     * @param noMipmap defines a boolean indicating that no mipmaps shall be generated.  Ignored for compressed textures.  They must be in the file
     * @param invertY when true, image is flipped when loaded.  You probably want true. Certain compressed textures may invert this if their default is inverted (eg. ktx)
     * @param scene needed for loading to the correct scene
     * @param samplingMode mode with should be used sample / access the texture (Default: Texture.TRILINEAR_SAMPLINGMODE)
     * @param onLoad optional callback to be called upon successful completion
     * @param onError optional callback to be called upon failure
     * @param buffer a source of a file previously fetched as either a base64 string, an ArrayBuffer (compressed or image format), HTMLImageElement (image format), or a Blob
     * @param fallback an internal argument in case the function must be called again, due to etc1 not having alpha capabilities
     * @param format internal format.  Default: RGB when extension is '.jpg' else RGBA.  Ignored for compressed textures
     * @param forcedExtension defines the extension to use to pick the right loader
     * @param mimeType defines an optional mime type
     * @param loaderOptions options to be passed to the loader
     * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
     * @param useSRGBBuffer defines if the texture must be loaded in a sRGB GPU buffer (if supported by the GPU).
     * @returns a InternalTexture for assignment back into BABYLON.Texture
     */ createTexture(url, noMipmap, invertY, scene, samplingMode = 3, onLoad = null, onError = null, buffer = null, fallback = null, format = null, forcedExtension = null, mimeType, loaderOptions, creationFlags, useSRGBBuffer) {
        return this._createTextureBase(url, noMipmap, invertY, scene, samplingMode, onLoad, onError, (texture, extension, scene, img, invertY, noMipmap, isCompressed, processFunction)=>{
            const imageBitmap = img; // we will never get an HTMLImageElement in WebGPU
            texture.baseWidth = imageBitmap.width;
            texture.baseHeight = imageBitmap.height;
            texture.width = imageBitmap.width;
            texture.height = imageBitmap.height;
            texture.format = texture.format !== -1 ? texture.format : format ?? 5;
            texture.type = texture.type !== -1 ? texture.type : 0;
            texture._creationFlags = creationFlags ?? 0;
            processFunction(texture.width, texture.height, imageBitmap, extension, texture, ()=>{});
            if (!texture._hardwareTexture?.underlyingResource) {
                // the texture could have been created before reaching this point so don't recreate it if already existing
                const gpuTextureWrapper = this._textureHelper.createGPUTextureForInternalTexture(texture, imageBitmap.width, imageBitmap.height, undefined, creationFlags);
                if ((0, $l46cr.WebGPUTextureHelper).IsImageBitmap(imageBitmap)) {
                    this._textureHelper.updateTexture(imageBitmap, texture, imageBitmap.width, imageBitmap.height, texture.depth, gpuTextureWrapper.format, 0, 0, invertY, false, 0, 0);
                    if (!noMipmap && !isCompressed) this._generateMipmaps(texture, this._uploadEncoder);
                }
            } else if (!noMipmap && !isCompressed) this._generateMipmaps(texture, this._uploadEncoder);
            if (scene) scene.removePendingData(texture);
            texture.isReady = true;
            texture.onLoadedObservable.notifyObservers(texture);
            texture.onLoadedObservable.clear();
        }, ()=>false, buffer, fallback, format, forcedExtension, mimeType, loaderOptions, useSRGBBuffer);
    }
    /**
     * Wraps an external web gpu texture in a Babylon texture.
     * @param texture defines the external texture
     * @returns the babylon internal texture
     */ wrapWebGPUTexture(texture) {
        const hardwareTexture = new (0, $4JXMh.WebGPUHardwareTexture)(texture);
        const internalTexture = new (0, $b9e4a.InternalTexture)(this, (0, $b9e4a.InternalTextureSource).Unknown, true);
        internalTexture._hardwareTexture = hardwareTexture;
        internalTexture.isReady = true;
        return internalTexture;
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Wraps an external web gl texture in a Babylon texture.
     * @returns the babylon internal texture
     */ wrapWebGLTexture() {
        throw new Error("wrapWebGLTexture is not supported, use wrapWebGPUTexture instead.");
    }
    generateMipMapsForCubemap(texture) {
        if (texture.generateMipMaps) {
            const gpuTexture = texture._hardwareTexture?.underlyingResource;
            if (!gpuTexture) this._textureHelper.createGPUTextureForInternalTexture(texture);
            this._generateMipmaps(texture);
        }
    }
    /**
     * Update the sampling mode of a given texture
     * @param samplingMode defines the required sampling mode
     * @param texture defines the texture to update
     * @param generateMipMaps defines whether to generate mipmaps for the texture
     */ updateTextureSamplingMode(samplingMode, texture, generateMipMaps = false) {
        if (generateMipMaps) {
            texture.generateMipMaps = true;
            this._generateMipmaps(texture);
        }
        texture.samplingMode = samplingMode;
    }
    /**
     * Update the sampling mode of a given texture
     * @param texture defines the texture to update
     * @param wrapU defines the texture wrap mode of the u coordinates
     * @param wrapV defines the texture wrap mode of the v coordinates
     * @param wrapR defines the texture wrap mode of the r coordinates
     */ updateTextureWrappingMode(texture, wrapU, wrapV = null, wrapR = null) {
        if (wrapU !== null) texture._cachedWrapU = wrapU;
        if (wrapV !== null) texture._cachedWrapV = wrapV;
        if ((texture.is2DArray || texture.is3D) && wrapR !== null) texture._cachedWrapR = wrapR;
    }
    /**
     * Update the dimensions of a texture
     * @param texture texture to update
     * @param width new width of the texture
     * @param height new height of the texture
     * @param depth new depth of the texture
     */ updateTextureDimensions(texture, width, height, depth = 1) {
        if (!texture._hardwareTexture) // the gpu texture is not created yet, so when it is it will be created with the right dimensions
        return;
        if (texture.width === width && texture.height === height && texture.depth === depth) return;
        const additionalUsages = texture._hardwareTexture.textureAdditionalUsages;
        texture._hardwareTexture.release(); // don't defer the releasing! Else we will release at the end of this frame the gpu texture we are about to create in the next line...
        this._textureHelper.createGPUTextureForInternalTexture(texture, width, height, depth, additionalUsages);
    }
    /**
     * @internal
     */ _setInternalTexture(name, texture, baseName) {
        baseName = baseName ?? name;
        if (this._currentEffect) {
            const webgpuPipelineContext = this._currentEffect._pipelineContext;
            const availableTexture = webgpuPipelineContext.shaderProcessingContext.availableTextures[baseName];
            this._currentMaterialContext.setTexture(name, texture);
            if (availableTexture && availableTexture.autoBindSampler) {
                const samplerName = baseName + (0, $jXMwB.WebGPUShaderProcessor).AutoSamplerSuffix;
                this._currentMaterialContext.setSampler(samplerName, texture); // we can safely cast to InternalTexture because ExternalTexture always has autoBindSampler = false
            }
        }
    }
    /**
     * Sets a texture to the according uniform.
     * @param channel The texture channel
     * @param unused unused parameter
     * @param texture The texture to apply
     * @param name The name of the uniform in the effect
     */ setTexture(channel, unused, texture, name) {
        this._setTexture(channel, texture, false, false, name, name);
    }
    /**
     * Sets an array of texture to the WebGPU context
     * @param channel defines the channel where the texture array must be set
     * @param unused unused parameter
     * @param textures defines the array of textures to bind
     * @param name name of the channel
     */ setTextureArray(channel, unused, textures, name) {
        for(let index = 0; index < textures.length; index++)this._setTexture(-1, textures[index], true, false, name + index.toString(), name);
    }
    _setTexture(channel, texture, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isPartOfTextureArray = false, depthStencilTexture = false, name = "", baseName) {
        // name == baseName for a texture that is not part of a texture array
        // Else, name is something like 'myTexture0' / 'myTexture1' / ... and baseName is 'myTexture'
        // baseName is used to look up the texture in the shaderProcessingContext.availableTextures map
        // name is used to look up the texture in the _currentMaterialContext.textures map
        baseName = baseName ?? name;
        if (this._currentEffect) {
            if (!texture) {
                this._currentMaterialContext.setTexture(name, null);
                return false;
            }
            // Video
            if (texture.video) texture.update();
            else if (texture.delayLoadState === 4) {
                // Delay loading
                texture.delayLoad();
                return false;
            }
            let internalTexture = null;
            if (depthStencilTexture) internalTexture = texture.depthStencilTexture;
            else if (texture.isReady()) internalTexture = texture.getInternalTexture();
            else if (texture.isCube) internalTexture = this.emptyCubeTexture;
            else if (texture.is3D) internalTexture = this.emptyTexture3D;
            else if (texture.is2DArray) internalTexture = this.emptyTexture2DArray;
            else internalTexture = this.emptyTexture;
            if (internalTexture && !internalTexture.isMultiview) {
                // CUBIC_MODE and SKYBOX_MODE both require CLAMP_TO_EDGE.  All other modes use REPEAT.
                if (internalTexture.isCube && internalTexture._cachedCoordinatesMode !== texture.coordinatesMode) {
                    internalTexture._cachedCoordinatesMode = texture.coordinatesMode;
                    const textureWrapMode = texture.coordinatesMode !== 3 && texture.coordinatesMode !== 5 ? 1 : 0;
                    texture.wrapU = textureWrapMode;
                    texture.wrapV = textureWrapMode;
                }
                internalTexture._cachedWrapU = texture.wrapU;
                internalTexture._cachedWrapV = texture.wrapV;
                if (internalTexture.is3D) internalTexture._cachedWrapR = texture.wrapR;
                this._setAnisotropicLevel(0, internalTexture, texture.anisotropicFilteringLevel);
            }
            this._setInternalTexture(name, internalTexture, baseName);
        } else if (this.dbgVerboseLogsForFirstFrames) {
            if (this._count === undefined) this._count = 0;
            if (!this._count || this._count < this.dbgVerboseLogsNumFrames) (0, $kVtWi.Logger).Log([
                "frame #" + this._count + " - _setTexture called with a null _currentEffect! texture=",
                texture
            ]);
        }
        return true;
    }
    /**
     * @internal
     */ _setAnisotropicLevel(target, internalTexture, anisotropicFilteringLevel) {
        if (internalTexture._cachedAnisotropicFilteringLevel !== anisotropicFilteringLevel) internalTexture._cachedAnisotropicFilteringLevel = Math.min(anisotropicFilteringLevel, this._caps.maxAnisotropy);
    }
    /**
     * @internal
     */ _bindTexture(channel, texture, name) {
        if (channel === undefined) return;
        this._setInternalTexture(name, texture);
    }
    /**
     * Generates the mipmaps for a texture
     * @param texture texture to generate the mipmaps for
     */ generateMipmaps(texture) {
        this._generateMipmaps(texture);
    }
    /**
     * @internal
     */ _generateMipmaps(texture, commandEncoder) {
        commandEncoder = commandEncoder ?? this._renderEncoder;
        const gpuHardwareTexture = texture._hardwareTexture;
        if (!gpuHardwareTexture) return;
        if (commandEncoder === this._renderEncoder) // We must close the current pass (if any) because we are going to use the render encoder to generate the mipmaps (so, we are going to create a new render pass)
        this._endCurrentRenderPass();
        const format = texture._hardwareTexture.format;
        const mipmapCount = (0, $l46cr.WebGPUTextureHelper).ComputeNumMipmapLevels(texture.width, texture.height);
        if (this.dbgVerboseLogsForFirstFrames) {
            if (this._count === undefined) this._count = 0;
            if (!this._count || this._count < this.dbgVerboseLogsNumFrames) (0, $kVtWi.Logger).Log("frame #" + this._count + " - generate mipmaps - width=" + texture.width + ", height=" + texture.height + ", isCube=" + texture.isCube + ", command encoder=" + (commandEncoder === this._renderEncoder ? "render" : "copy"));
        }
        if (texture.isCube) this._textureHelper.generateCubeMipmaps(gpuHardwareTexture, format, mipmapCount, commandEncoder);
        else this._textureHelper.generateMipmaps(gpuHardwareTexture, format, mipmapCount, 0, commandEncoder);
    }
    /**
     * Update a portion of an internal texture
     * @param texture defines the texture to update
     * @param imageData defines the data to store into the texture
     * @param xOffset defines the x coordinates of the update rectangle
     * @param yOffset defines the y coordinates of the update rectangle
     * @param width defines the width of the update rectangle
     * @param height defines the height of the update rectangle
     * @param faceIndex defines the face index if texture is a cube (0 by default)
     * @param lod defines the lod level to update (0 by default)
     * @param generateMipMaps defines whether to generate mipmaps or not
     */ updateTextureData(texture, imageData, xOffset, yOffset, width, height, faceIndex = 0, lod = 0, generateMipMaps = false) {
        let gpuTextureWrapper = texture._hardwareTexture;
        if (!texture._hardwareTexture?.underlyingResource) gpuTextureWrapper = this._textureHelper.createGPUTextureForInternalTexture(texture);
        const data = new Uint8Array(imageData.buffer, imageData.byteOffset, imageData.byteLength);
        this._textureHelper.updateTexture(data, texture, width, height, texture.depth, gpuTextureWrapper.format, faceIndex, lod, texture.invertY, false, xOffset, yOffset);
        if (generateMipMaps) this._generateMipmaps(texture);
    }
    /**
     * @internal
     */ _uploadCompressedDataToTextureDirectly(texture, internalFormat, width, height, imageData, faceIndex = 0, lod = 0) {
        let gpuTextureWrapper = texture._hardwareTexture;
        if (!texture._hardwareTexture?.underlyingResource) {
            texture.format = internalFormat;
            gpuTextureWrapper = this._textureHelper.createGPUTextureForInternalTexture(texture, width, height);
        }
        const data = new Uint8Array(imageData.buffer, imageData.byteOffset, imageData.byteLength);
        this._textureHelper.updateTexture(data, texture, width, height, texture.depth, gpuTextureWrapper.format, faceIndex, lod, false, false, 0, 0);
    }
    /**
     * @internal
     */ _uploadDataToTextureDirectly(texture, imageData, faceIndex = 0, lod = 0, babylonInternalFormat, useTextureWidthAndHeight = false) {
        const lodMaxWidth = Math.round(Math.log(texture.width) * Math.LOG2E);
        const lodMaxHeight = Math.round(Math.log(texture.height) * Math.LOG2E);
        const width = useTextureWidthAndHeight ? texture.width : Math.pow(2, Math.max(lodMaxWidth - lod, 0));
        const height = useTextureWidthAndHeight ? texture.height : Math.pow(2, Math.max(lodMaxHeight - lod, 0));
        let gpuTextureWrapper = texture._hardwareTexture;
        if (!texture._hardwareTexture?.underlyingResource) gpuTextureWrapper = this._textureHelper.createGPUTextureForInternalTexture(texture, width, height);
        const data = new Uint8Array(imageData.buffer, imageData.byteOffset, imageData.byteLength);
        this._textureHelper.updateTexture(data, texture, width, height, texture.depth, gpuTextureWrapper.format, faceIndex, lod, texture.invertY, false, 0, 0);
    }
    /**
     * @internal
     */ _uploadArrayBufferViewToTexture(texture, imageData, faceIndex = 0, lod = 0) {
        this._uploadDataToTextureDirectly(texture, imageData, faceIndex, lod);
    }
    /**
     * @internal
     */ _uploadImageToTexture(texture, image, faceIndex = 0, lod = 0) {
        let gpuTextureWrapper = texture._hardwareTexture;
        if (!texture._hardwareTexture?.underlyingResource) gpuTextureWrapper = this._textureHelper.createGPUTextureForInternalTexture(texture);
        if (image instanceof HTMLImageElement) // eslint-disable-next-line no-throw-literal
        throw "WebGPU engine: HTMLImageElement not supported in _uploadImageToTexture!";
        const bitmap = image; // in WebGPU we will always get an ImageBitmap, not an HTMLImageElement
        const width = Math.ceil(texture.width / (1 << lod));
        const height = Math.ceil(texture.height / (1 << lod));
        this._textureHelper.updateTexture(bitmap, texture, width, height, texture.depth, gpuTextureWrapper.format, faceIndex, lod, texture.invertY, false, 0, 0);
    }
    /**
     * Reads pixels from the current frame buffer. Please note that this function can be slow
     * @param x defines the x coordinate of the rectangle where pixels must be read
     * @param y defines the y coordinate of the rectangle where pixels must be read
     * @param width defines the width of the rectangle where pixels must be read
     * @param height defines the height of the rectangle where pixels must be read
     * @param hasAlpha defines whether the output should have alpha or not (defaults to true)
     * @param flushRenderer true to flush the renderer from the pending commands before reading the pixels
     * @returns a ArrayBufferView promise (Uint8Array) containing RGBA colors
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    readPixels(x, y, width, height, hasAlpha = true, flushRenderer = true) {
        const renderPassWrapper = this._getCurrentRenderPassWrapper();
        const hardwareTexture = renderPassWrapper.colorAttachmentGPUTextures[0];
        if (!hardwareTexture) // we are calling readPixels for a render pass with no color texture bound
        return Promise.resolve(new Uint8Array(0));
        const gpuTexture = hardwareTexture.underlyingResource;
        const gpuTextureFormat = hardwareTexture.format;
        if (!gpuTexture) // we are calling readPixels before startMainRenderPass has been called and no RTT is bound, so swapChainTexture is not setup yet!
        return Promise.resolve(new Uint8Array(0));
        if (flushRenderer) this.flushFramebuffer();
        return this._textureHelper.readPixels(gpuTexture, x, y, width, height, gpuTextureFormat);
    }
    //------------------------------------------------------------------------------
    //                              Frame management
    //------------------------------------------------------------------------------
    /**
     * Begin a new frame
     */ beginFrame() {
        super.beginFrame();
    }
    /**
     * End the current frame
     */ endFrame() {
        this._endCurrentRenderPass();
        this._snapshotRendering.endFrame();
        this._timestampQuery.endFrame(this._renderEncoder);
        this._timestampIndex = 0;
        this.flushFramebuffer();
        this._textureHelper.destroyDeferredTextures();
        this._bufferManager.destroyDeferredBuffers();
        if (this._features._collectUbosUpdatedInFrame) {
            if (this.dbgVerboseLogsForFirstFrames) {
                if (this._count === undefined) this._count = 0;
                if (!this._count || this._count < this.dbgVerboseLogsNumFrames) {
                    const list = [];
                    for(const name in (0, $ghoTi.UniformBuffer)._UpdatedUbosInFrame)list.push(name + ":" + (0, $ghoTi.UniformBuffer)._UpdatedUbosInFrame[name]);
                    (0, $kVtWi.Logger).Log([
                        "frame #" + this._count + " - updated ubos -",
                        list.join(", ")
                    ]);
                }
            }
            (0, $ghoTi.UniformBuffer)._UpdatedUbosInFrame = {};
        }
        this.countersLastFrame.numEnableEffects = this._counters.numEnableEffects;
        this.countersLastFrame.numEnableDrawWrapper = this._counters.numEnableDrawWrapper;
        this.countersLastFrame.numBundleCreationNonCompatMode = this._counters.numBundleCreationNonCompatMode;
        this.countersLastFrame.numBundleReuseNonCompatMode = this._counters.numBundleReuseNonCompatMode;
        this._counters.numEnableEffects = 0;
        this._counters.numEnableDrawWrapper = 0;
        this._counters.numBundleCreationNonCompatMode = 0;
        this._counters.numBundleReuseNonCompatMode = 0;
        this._cacheRenderPipeline.endFrame();
        this._cacheBindGroups.endFrame();
        this._pendingDebugCommands.length = 0;
        super.endFrame();
        if (this.dbgVerboseLogsForFirstFrames) {
            if (this._count === undefined) this._count = 0;
            if (this._count < this.dbgVerboseLogsNumFrames) (0, $kVtWi.Logger).Log([
                "%c frame #" + this._count + " - end",
                "background: #ffff00"
            ]);
            if (this._count < this.dbgVerboseLogsNumFrames) {
                this._count++;
                if (this._count !== this.dbgVerboseLogsNumFrames) (0, $kVtWi.Logger).Log([
                    "%c frame #" + this._count + " - begin",
                    "background: #ffff00"
                ]);
            }
        }
    }
    /**
     * Force a WebGPU flush (ie. a flush of all waiting commands)
     */ flushFramebuffer() {
        // we need to end the current render pass (main or rtt) if any as we are not allowed to submit the command buffers when being in a pass
        this._endCurrentRenderPass();
        this._commandBuffers[0] = this._uploadEncoder.finish();
        this._commandBuffers[1] = this._renderEncoder.finish();
        this._device.queue.submit(this._commandBuffers);
        this._uploadEncoder = this._device.createCommandEncoder(this._uploadEncoderDescriptor);
        this._renderEncoder = this._device.createCommandEncoder(this._renderEncoderDescriptor);
        this._timestampQuery.startFrame(this._uploadEncoder);
        this._textureHelper.setCommandEncoder(this._uploadEncoder);
        this._bundleList.reset();
    }
    /** @internal */ _currentFrameBufferIsDefaultFrameBuffer() {
        return this._currentPassIsMainPass();
    }
    //------------------------------------------------------------------------------
    //                              Render Pass
    //------------------------------------------------------------------------------
    _startRenderTargetRenderPass(renderTargetWrapper, setClearStates, clearColor, clearDepth, clearStencil) {
        this._endCurrentRenderPass();
        const rtWrapper = renderTargetWrapper;
        const depthStencilTexture = rtWrapper._depthStencilTexture;
        const gpuDepthStencilWrapper = depthStencilTexture?._hardwareTexture;
        const gpuDepthStencilTexture = gpuDepthStencilWrapper?.underlyingResource;
        const gpuDepthStencilMSAATexture = gpuDepthStencilWrapper?.getMSAATexture();
        const depthTextureView = gpuDepthStencilTexture?.createView(this._rttRenderPassWrapper.depthAttachmentViewDescriptor);
        const depthMSAATextureView = gpuDepthStencilMSAATexture?.createView(this._rttRenderPassWrapper.depthAttachmentViewDescriptor);
        const depthTextureHasStencil = gpuDepthStencilWrapper ? (0, $l46cr.WebGPUTextureHelper).HasStencilAspect(gpuDepthStencilWrapper.format) : false;
        const colorAttachments = [];
        if (this.useReverseDepthBuffer) this.setDepthFunctionToGreaterOrEqual();
        const clearColorForIntegerRT = $46c576986b3f1f6c$var$tempColor4;
        if (clearColor) {
            clearColorForIntegerRT.r = clearColor.r * 255;
            clearColorForIntegerRT.g = clearColor.g * 255;
            clearColorForIntegerRT.b = clearColor.b * 255;
            clearColorForIntegerRT.a = clearColor.a * 255;
        }
        const mustClearColor = setClearStates && clearColor;
        const mustClearDepth = setClearStates && clearDepth;
        const mustClearStencil = setClearStates && clearStencil;
        if (rtWrapper._attachments && rtWrapper.isMulti) {
            // multi render targets
            if (!this._mrtAttachments || this._mrtAttachments.length === 0) this._mrtAttachments = rtWrapper._defaultAttachments;
            for(let i = 0; i < this._mrtAttachments.length; ++i){
                const index = this._mrtAttachments[i]; // if index == 0 it means the texture should not be written to => at render pass creation time, it means we should not clear it
                const mrtTexture = rtWrapper.textures[i];
                const gpuMRTWrapper = mrtTexture?._hardwareTexture;
                const gpuMRTTexture = gpuMRTWrapper?.underlyingResource;
                if (gpuMRTWrapper && gpuMRTTexture) {
                    const gpuMSAATexture = gpuMRTWrapper.getMSAATexture(i);
                    const layerIndex = rtWrapper.layerIndices?.[i] ?? 0;
                    const faceIndex = rtWrapper.faceIndices?.[i] ?? 0;
                    const viewDescriptor = {
                        ...this._rttRenderPassWrapper.colorAttachmentViewDescriptor,
                        format: gpuMRTWrapper.format,
                        baseArrayLayer: mrtTexture.isCube ? layerIndex * 6 + faceIndex : layerIndex
                    };
                    const msaaViewDescriptor = {
                        ...this._rttRenderPassWrapper.colorAttachmentViewDescriptor,
                        format: gpuMRTWrapper.format,
                        baseArrayLayer: 0
                    };
                    const isRTInteger = mrtTexture.type === 7 || mrtTexture.type === 5;
                    const colorTextureView = gpuMRTTexture.createView(viewDescriptor);
                    const colorMSAATextureView = gpuMSAATexture?.createView(msaaViewDescriptor);
                    colorAttachments.push({
                        view: colorMSAATextureView ? colorMSAATextureView : colorTextureView,
                        resolveTarget: gpuMSAATexture ? colorTextureView : undefined,
                        clearValue: index !== 0 && mustClearColor ? isRTInteger ? clearColorForIntegerRT : clearColor : undefined,
                        loadOp: index !== 0 && mustClearColor ? $hR6HG.LoadOp.Clear : $hR6HG.LoadOp.Load,
                        storeOp: $hR6HG.StoreOp.Store
                    });
                }
            }
            this._cacheRenderPipeline.setMRT(rtWrapper.textures, this._mrtAttachments.length);
            this._cacheRenderPipeline.setMRTAttachments(this._mrtAttachments);
        } else {
            // single render target
            const internalTexture = rtWrapper.texture;
            if (internalTexture) {
                const gpuWrapper = internalTexture._hardwareTexture;
                const gpuTexture = gpuWrapper.underlyingResource;
                const gpuMSAATexture = gpuWrapper.getMSAATexture();
                const colorTextureView = gpuTexture.createView(this._rttRenderPassWrapper.colorAttachmentViewDescriptor);
                const colorMSAATextureView = gpuMSAATexture?.createView(this._rttRenderPassWrapper.colorAttachmentViewDescriptor);
                const isRTInteger = internalTexture.type === 7 || internalTexture.type === 5;
                colorAttachments.push({
                    view: colorMSAATextureView ? colorMSAATextureView : colorTextureView,
                    resolveTarget: gpuMSAATexture ? colorTextureView : undefined,
                    clearValue: mustClearColor ? isRTInteger ? clearColorForIntegerRT : clearColor : undefined,
                    loadOp: mustClearColor ? $hR6HG.LoadOp.Clear : $hR6HG.LoadOp.Load,
                    storeOp: $hR6HG.StoreOp.Store
                });
            } else colorAttachments.push(null);
        }
        this._debugPushGroup?.("render target pass" + (renderTargetWrapper.label ? " (" + renderTargetWrapper.label + ")" : ""), 1);
        this._rttRenderPassWrapper.renderPassDescriptor = {
            label: (renderTargetWrapper.label ?? "RTT") + "RenderPass",
            colorAttachments: colorAttachments,
            depthStencilAttachment: depthStencilTexture && gpuDepthStencilTexture ? {
                view: depthMSAATextureView ? depthMSAATextureView : depthTextureView,
                depthClearValue: mustClearDepth ? this.useReverseDepthBuffer ? this._clearReverseDepthValue : this._clearDepthValue : undefined,
                depthLoadOp: mustClearDepth ? $hR6HG.LoadOp.Clear : $hR6HG.LoadOp.Load,
                depthStoreOp: $hR6HG.StoreOp.Store,
                stencilClearValue: rtWrapper._depthStencilTextureWithStencil && mustClearStencil ? this._clearStencilValue : undefined,
                stencilLoadOp: !depthTextureHasStencil ? undefined : rtWrapper._depthStencilTextureWithStencil && mustClearStencil ? $hR6HG.LoadOp.Clear : $hR6HG.LoadOp.Load,
                stencilStoreOp: !depthTextureHasStencil ? undefined : $hR6HG.StoreOp.Store
            } : undefined,
            occlusionQuerySet: this._occlusionQuery?.hasQueries ? this._occlusionQuery.querySet : undefined
        };
        this._timestampQuery.startPass(this._rttRenderPassWrapper.renderPassDescriptor, this._timestampIndex);
        this._currentRenderPass = this._renderEncoder.beginRenderPass(this._rttRenderPassWrapper.renderPassDescriptor);
        if (this.dbgVerboseLogsForFirstFrames) {
            if (this._count === undefined) this._count = 0;
            if (!this._count || this._count < this.dbgVerboseLogsNumFrames) {
                const internalTexture = rtWrapper.texture;
                (0, $kVtWi.Logger).Log([
                    "frame #" + this._count + " - render target begin pass - rtt name=" + renderTargetWrapper.label + ", internalTexture.uniqueId=" + internalTexture.uniqueId + ", width=" + internalTexture.width + ", height=" + internalTexture.height + ", setClearStates=" + setClearStates,
                    "renderPassDescriptor=",
                    this._rttRenderPassWrapper.renderPassDescriptor
                ]);
            }
        }
        this._debugFlushPendingCommands?.();
        this._resetRenderPassStates();
        if (!gpuDepthStencilWrapper || !(0, $l46cr.WebGPUTextureHelper).HasStencilAspect(gpuDepthStencilWrapper.format)) this._stencilStateComposer.enabled = false;
    }
    _startMainRenderPass(setClearStates, clearColor, clearDepth, clearStencil) {
        this._endCurrentRenderPass();
        if (this.useReverseDepthBuffer) this.setDepthFunctionToGreaterOrEqual();
        const mustClearColor = setClearStates && clearColor;
        const mustClearDepth = setClearStates && clearDepth;
        const mustClearStencil = setClearStates && clearStencil;
        this._mainRenderPassWrapper.renderPassDescriptor.colorAttachments[0].clearValue = mustClearColor ? clearColor : undefined;
        this._mainRenderPassWrapper.renderPassDescriptor.colorAttachments[0].loadOp = mustClearColor ? $hR6HG.LoadOp.Clear : $hR6HG.LoadOp.Load;
        this._mainRenderPassWrapper.renderPassDescriptor.depthStencilAttachment.depthClearValue = mustClearDepth ? this.useReverseDepthBuffer ? this._clearReverseDepthValue : this._clearDepthValue : undefined;
        this._mainRenderPassWrapper.renderPassDescriptor.depthStencilAttachment.depthLoadOp = mustClearDepth ? $hR6HG.LoadOp.Clear : $hR6HG.LoadOp.Load;
        this._mainRenderPassWrapper.renderPassDescriptor.depthStencilAttachment.stencilClearValue = mustClearStencil ? this._clearStencilValue : undefined;
        this._mainRenderPassWrapper.renderPassDescriptor.depthStencilAttachment.stencilLoadOp = !this.isStencilEnable ? undefined : mustClearStencil ? $hR6HG.LoadOp.Clear : $hR6HG.LoadOp.Load;
        this._mainRenderPassWrapper.renderPassDescriptor.occlusionQuerySet = this._occlusionQuery?.hasQueries ? this._occlusionQuery.querySet : undefined;
        const swapChainTexture = this._context.getCurrentTexture();
        this._mainRenderPassWrapper.colorAttachmentGPUTextures[0].set(swapChainTexture);
        // Resolve in case of MSAA
        if (this._options.antialias) {
            $46c576986b3f1f6c$var$viewDescriptorSwapChainAntialiasing.format = swapChainTexture.format;
            this._mainRenderPassWrapper.renderPassDescriptor.colorAttachments[0].resolveTarget = swapChainTexture.createView($46c576986b3f1f6c$var$viewDescriptorSwapChainAntialiasing);
        } else {
            $46c576986b3f1f6c$var$viewDescriptorSwapChain.format = swapChainTexture.format;
            this._mainRenderPassWrapper.renderPassDescriptor.colorAttachments[0].view = swapChainTexture.createView($46c576986b3f1f6c$var$viewDescriptorSwapChain);
        }
        if (this.dbgVerboseLogsForFirstFrames) {
            if (this._count === undefined) this._count = 0;
            if (!this._count || this._count < this.dbgVerboseLogsNumFrames) (0, $kVtWi.Logger).Log([
                "frame #" + this._count + " - main begin pass - texture width=" + this._mainTextureExtends.width,
                " height=" + this._mainTextureExtends.height + ", setClearStates=" + setClearStates,
                "renderPassDescriptor=",
                this._mainRenderPassWrapper.renderPassDescriptor
            ]);
        }
        this._debugPushGroup?.("main pass", 0);
        this._timestampQuery.startPass(this._mainRenderPassWrapper.renderPassDescriptor, this._timestampIndex);
        this._currentRenderPass = this._renderEncoder.beginRenderPass(this._mainRenderPassWrapper.renderPassDescriptor);
        this._setDepthTextureFormat(this._mainRenderPassWrapper);
        this._setColorFormat(this._mainRenderPassWrapper);
        this._debugFlushPendingCommands?.();
        this._resetRenderPassStates();
        if (!this._isStencilEnable) this._stencilStateComposer.enabled = false;
    }
    /** @internal */ _endCurrentRenderPass() {
        if (!this._currentRenderPass) return 0;
        const currentPassIndex = this._currentPassIsMainPass() ? 2 : 1;
        if (!this._snapshotRendering.endRenderPass(this._currentRenderPass) && !this.compatibilityMode) {
            this._bundleList.run(this._currentRenderPass);
            this._bundleList.reset();
        }
        this._currentRenderPass.end();
        this._timestampQuery.endPass(this._timestampIndex, this._currentRenderTarget && this._currentRenderTarget.gpuTimeInFrame ? this._currentRenderTarget.gpuTimeInFrame : this.gpuTimeInFrameForMainPass);
        this._timestampIndex += 2;
        if (this.dbgVerboseLogsForFirstFrames) {
            if (this._count === undefined) this._count = 0;
            if (!this._count || this._count < this.dbgVerboseLogsNumFrames) (0, $kVtWi.Logger).Log("frame #" + this._count + " - " + (currentPassIndex === 2 ? "main" : "render target") + " end pass" + (currentPassIndex === 1 ? " - internalTexture.uniqueId=" + this._currentRenderTarget?.texture?.uniqueId : ""));
        }
        this._debugPopGroup?.(0);
        this._currentRenderPass = null;
        return currentPassIndex;
    }
    /**
     * Binds the frame buffer to the specified texture.
     * @param texture The render target wrapper to render to
     * @param faceIndex The face of the texture to render to in case of cube texture
     * @param requiredWidth The width of the target to render to
     * @param requiredHeight The height of the target to render to
     * @param forceFullscreenViewport Forces the viewport to be the entire texture/screen if true
     * @param lodLevel defines the lod level to bind to the frame buffer
     * @param layer defines the 2d array index to bind to frame buffer to
     */ bindFramebuffer(texture, faceIndex = 0, requiredWidth, requiredHeight, forceFullscreenViewport, lodLevel = 0, layer = 0) {
        const hardwareTexture = texture.texture?._hardwareTexture;
        if (this._currentRenderTarget) this.unBindFramebuffer(this._currentRenderTarget);
        else this._endCurrentRenderPass();
        this._currentRenderTarget = texture;
        this._rttRenderPassWrapper.colorAttachmentGPUTextures[0] = hardwareTexture;
        this._rttRenderPassWrapper.depthTextureFormat = this._currentRenderTarget._depthStencilTexture ? (0, $l46cr.WebGPUTextureHelper).GetWebGPUTextureFormat(-1, this._currentRenderTarget._depthStencilTexture.format) : undefined;
        this._setDepthTextureFormat(this._rttRenderPassWrapper);
        this._setColorFormat(this._rttRenderPassWrapper);
        this._rttRenderPassWrapper.colorAttachmentViewDescriptor = {
            format: this._colorFormat,
            dimension: $hR6HG.TextureViewDimension.E2d,
            mipLevelCount: 1,
            baseArrayLayer: texture.isCube ? layer * 6 + faceIndex : layer,
            baseMipLevel: lodLevel,
            arrayLayerCount: 1,
            aspect: $hR6HG.TextureAspect.All
        };
        this._rttRenderPassWrapper.depthAttachmentViewDescriptor = {
            format: this._depthTextureFormat,
            dimension: $hR6HG.TextureViewDimension.E2d,
            mipLevelCount: 1,
            baseArrayLayer: texture.isCube ? layer * 6 + faceIndex : layer,
            baseMipLevel: 0,
            arrayLayerCount: 1,
            aspect: $hR6HG.TextureAspect.All
        };
        if (this.dbgVerboseLogsForFirstFrames) {
            if (this._count === undefined) this._count = 0;
            if (!this._count || this._count < this.dbgVerboseLogsNumFrames) (0, $kVtWi.Logger).Log([
                "frame #" + this._count + " - bindFramebuffer - rtt name=" + texture.label + ", internalTexture.uniqueId=" + texture.texture?.uniqueId + ", face=" + faceIndex + ", lodLevel=" + lodLevel + ", layer=" + layer,
                "colorAttachmentViewDescriptor=",
                this._rttRenderPassWrapper.colorAttachmentViewDescriptor,
                "depthAttachmentViewDescriptor=",
                this._rttRenderPassWrapper.depthAttachmentViewDescriptor
            ]);
        }
        // We don't create the render pass just now, we do a lazy creation of the render pass, hoping the render pass will be created by a call to clear()...
        if (this._cachedViewport && !forceFullscreenViewport) this.setViewport(this._cachedViewport, requiredWidth, requiredHeight);
        else {
            if (!requiredWidth) {
                requiredWidth = texture.width;
                if (lodLevel) requiredWidth = requiredWidth / Math.pow(2, lodLevel);
            }
            if (!requiredHeight) {
                requiredHeight = texture.height;
                if (lodLevel) requiredHeight = requiredHeight / Math.pow(2, lodLevel);
            }
            this._viewport(0, 0, requiredWidth, requiredHeight);
        }
        this.wipeCaches();
    }
    /**
     * Unbind the current render target texture from the WebGPU context
     * @param texture defines the render target wrapper to unbind
     * @param disableGenerateMipMaps defines a boolean indicating that mipmaps must not be generated
     * @param onBeforeUnbind defines a function which will be called before the effective unbind
     */ unBindFramebuffer(texture, disableGenerateMipMaps = false, onBeforeUnbind) {
        const saveCRT = this._currentRenderTarget;
        this._currentRenderTarget = null; // to be iso with thinEngine, this._currentRenderTarget must be null when onBeforeUnbind is called
        if (onBeforeUnbind) onBeforeUnbind();
        this._currentRenderTarget = saveCRT;
        this._endCurrentRenderPass();
        if (texture.texture?.generateMipMaps && !disableGenerateMipMaps && !texture.isCube) this._generateMipmaps(texture.texture);
        this._currentRenderTarget = null;
        if (this.dbgVerboseLogsForFirstFrames) {
            if (this._count === undefined) this._count = 0;
            if (!this._count || this._count < this.dbgVerboseLogsNumFrames) (0, $kVtWi.Logger).Log("frame #" + this._count + " - unBindFramebuffer - rtt name=" + texture.label + ", internalTexture.uniqueId=", texture.texture?.uniqueId);
        }
        this._mrtAttachments = [];
        this._cacheRenderPipeline.setMRT([]);
        this._cacheRenderPipeline.setMRTAttachments(this._mrtAttachments);
    }
    /**
     * Unbind the current render target and bind the default framebuffer
     */ restoreDefaultFramebuffer() {
        if (this._currentRenderTarget) this.unBindFramebuffer(this._currentRenderTarget);
        else if (!this._currentRenderPass) this._startMainRenderPass(false);
        if (this._cachedViewport) this.setViewport(this._cachedViewport);
        this.wipeCaches();
    }
    //------------------------------------------------------------------------------
    //                              Render
    //------------------------------------------------------------------------------
    /**
     * @internal
     */ _setColorFormat(wrapper) {
        const format = wrapper.colorAttachmentGPUTextures[0]?.format ?? null;
        this._cacheRenderPipeline.setColorFormat(format);
        if (this._colorFormat === format) return;
        this._colorFormat = format;
    }
    /**
     * @internal
     */ _setDepthTextureFormat(wrapper) {
        this._cacheRenderPipeline.setDepthStencilFormat(wrapper.depthTextureFormat);
        if (this._depthTextureFormat === wrapper.depthTextureFormat) return;
        this._depthTextureFormat = wrapper.depthTextureFormat;
    }
    setDitheringState() {
    // Does not exist in WebGPU
    }
    setRasterizerState() {
    // Does not exist in WebGPU
    }
    /**
     * Set various states to the webGL context
     * @param culling defines culling state: true to enable culling, false to disable it
     * @param zOffset defines the value to apply to zOffset (0 by default)
     * @param force defines if states must be applied even if cache is up to date
     * @param reverseSide defines if culling must be reversed (CCW if false, CW if true)
     * @param cullBackFaces true to cull back faces, false to cull front faces (if culling is enabled)
     * @param stencil stencil states to set
     * @param zOffsetUnits defines the value to apply to zOffsetUnits (0 by default)
     */ setState(culling, zOffset = 0, force, reverseSide = false, cullBackFaces, stencil, zOffsetUnits = 0) {
        // Culling
        if (this._depthCullingState.cull !== culling || force) this._depthCullingState.cull = culling;
        // Cull face
        const cullFace = this.cullBackFaces ?? cullBackFaces ?? true ? 1 : 2;
        if (this._depthCullingState.cullFace !== cullFace || force) this._depthCullingState.cullFace = cullFace;
        // Z offset
        this.setZOffset(zOffset);
        this.setZOffsetUnits(zOffsetUnits);
        // Front face
        const frontFace = reverseSide ? this._currentRenderTarget ? 1 : 2 : this._currentRenderTarget ? 2 : 1;
        if (this._depthCullingState.frontFace !== frontFace || force) this._depthCullingState.frontFace = frontFace;
        this._stencilStateComposer.stencilMaterial = stencil;
    }
    _applyRenderPassChanges(bundleList) {
        const mustUpdateStencilRef = !this._stencilStateComposer.enabled ? false : this._mustUpdateStencilRef();
        const mustUpdateBlendColor = !this._alphaState.alphaBlend ? false : this._mustUpdateBlendColor();
        if (this._mustUpdateViewport()) this._applyViewport(bundleList);
        if (this._mustUpdateScissor()) this._applyScissor(bundleList);
        if (mustUpdateStencilRef) this._applyStencilRef(bundleList);
        if (mustUpdateBlendColor) this._applyBlendColor(bundleList);
    }
    _draw(drawType, fillMode, start, count, instancesCount) {
        const renderPass = this._getCurrentRenderPass();
        const bundleList = this._bundleList;
        this.applyStates();
        const webgpuPipelineContext = this._currentEffect._pipelineContext;
        this.bindUniformBufferBase(this._currentRenderTarget ? this._ubInvertY : this._ubDontInvertY, 0, (0, $jXMwB.WebGPUShaderProcessor).InternalsUBOName);
        if (webgpuPipelineContext.uniformBuffer) {
            webgpuPipelineContext.uniformBuffer.update();
            this.bindUniformBufferBase(webgpuPipelineContext.uniformBuffer.getBuffer(), 0, (0, $jXMwB.WebGPUShaderProcessor).LeftOvertUBOName);
        }
        if (this._snapshotRendering.play) {
            this._reportDrawCall();
            return;
        }
        if (!this.compatibilityMode && (this._currentDrawContext.isDirty(this._currentMaterialContext.updateId) || this._currentMaterialContext.isDirty || this._currentMaterialContext.forceBindGroupCreation)) this._currentDrawContext.fastBundle = undefined;
        const useFastPath = !this.compatibilityMode && this._currentDrawContext.fastBundle;
        let renderPass2 = renderPass;
        if (useFastPath || this._snapshotRendering.record) {
            this._applyRenderPassChanges(bundleList);
            if (!this._snapshotRendering.record) {
                this._counters.numBundleReuseNonCompatMode++;
                if (this._currentDrawContext.indirectDrawBuffer) this._currentDrawContext.setIndirectData(count, instancesCount || 1, start);
                bundleList.addBundle(this._currentDrawContext.fastBundle);
                this._reportDrawCall();
                return;
            }
            renderPass2 = bundleList.getBundleEncoder(this._cacheRenderPipeline.colorFormats, this._depthTextureFormat, this.currentSampleCount); // for snapshot recording mode
            bundleList.numDrawCalls++;
        }
        let textureState = 0;
        if (this._currentMaterialContext.hasFloatOrDepthTextures) {
            let bitVal = 1;
            for(let i = 0; i < webgpuPipelineContext.shaderProcessingContext.textureNames.length; ++i){
                const textureName = webgpuPipelineContext.shaderProcessingContext.textureNames[i];
                const texture = this._currentMaterialContext.textures[textureName]?.texture;
                const textureIsDepth = texture && texture.format >= 13 && texture.format <= 18;
                if (texture?.type === 1 && !this._caps.textureFloatLinearFiltering || textureIsDepth) textureState |= bitVal;
                bitVal = bitVal << 1;
            }
        }
        this._currentMaterialContext.textureState = textureState;
        const pipeline = this._cacheRenderPipeline.getRenderPipeline(fillMode, this._currentEffect, this.currentSampleCount, textureState);
        const bindGroups = this._cacheBindGroups.getBindGroups(webgpuPipelineContext, this._currentDrawContext, this._currentMaterialContext);
        if (!this._snapshotRendering.record) {
            this._applyRenderPassChanges(!this.compatibilityMode ? bundleList : null);
            if (!this.compatibilityMode) {
                this._counters.numBundleCreationNonCompatMode++;
                renderPass2 = this._device.createRenderBundleEncoder({
                    colorFormats: this._cacheRenderPipeline.colorFormats,
                    depthStencilFormat: this._depthTextureFormat,
                    sampleCount: (0, $l46cr.WebGPUTextureHelper).GetSample(this.currentSampleCount)
                });
            }
        }
        // bind pipeline
        renderPass2.setPipeline(pipeline);
        // bind index/vertex buffers
        if (this._currentIndexBuffer) renderPass2.setIndexBuffer(this._currentIndexBuffer.underlyingResource, this._currentIndexBuffer.is32Bits ? $hR6HG.IndexFormat.Uint32 : $hR6HG.IndexFormat.Uint16, 0);
        const vertexBuffers = this._cacheRenderPipeline.vertexBuffers;
        for(let index = 0; index < vertexBuffers.length; index++){
            const vertexBuffer = vertexBuffers[index];
            const buffer = vertexBuffer.effectiveBuffer;
            if (buffer) renderPass2.setVertexBuffer(index, buffer.underlyingResource, vertexBuffer._validOffsetRange ? 0 : vertexBuffer.byteOffset);
        }
        // bind bind groups
        for(let i = 0; i < bindGroups.length; i++)renderPass2.setBindGroup(i, bindGroups[i]);
        // draw
        const nonCompatMode = !this.compatibilityMode && !this._snapshotRendering.record;
        if (nonCompatMode && this._currentDrawContext.indirectDrawBuffer) {
            this._currentDrawContext.setIndirectData(count, instancesCount || 1, start);
            if (drawType === 0) renderPass2.drawIndexedIndirect(this._currentDrawContext.indirectDrawBuffer, 0);
            else renderPass2.drawIndirect(this._currentDrawContext.indirectDrawBuffer, 0);
        } else if (drawType === 0) renderPass2.drawIndexed(count, instancesCount || 1, start, 0, 0);
        else renderPass2.draw(count, instancesCount || 1, start, 0);
        if (nonCompatMode) {
            this._currentDrawContext.fastBundle = renderPass2.finish();
            bundleList.addBundle(this._currentDrawContext.fastBundle);
        }
        this._reportDrawCall();
    }
    /**
     * Draw a list of indexed primitives
     * @param fillMode defines the primitive to use
     * @param indexStart defines the starting index
     * @param indexCount defines the number of index to draw
     * @param instancesCount defines the number of instances to draw (if instantiation is enabled)
     */ drawElementsType(fillMode, indexStart, indexCount, instancesCount = 1) {
        this._draw(0, fillMode, indexStart, indexCount, instancesCount);
    }
    /**
     * Draw a list of unindexed primitives
     * @param fillMode defines the primitive to use
     * @param verticesStart defines the index of first vertex to draw
     * @param verticesCount defines the count of vertices to draw
     * @param instancesCount defines the number of instances to draw (if instantiation is enabled)
     */ drawArraysType(fillMode, verticesStart, verticesCount, instancesCount = 1) {
        this._currentIndexBuffer = null;
        this._draw(1, fillMode, verticesStart, verticesCount, instancesCount);
    }
    //------------------------------------------------------------------------------
    //                              Dispose
    //------------------------------------------------------------------------------
    /**
     * Dispose and release all associated resources
     */ dispose() {
        this._isDisposed = true;
        this._timestampQuery.dispose();
        this._mainTexture?.destroy();
        this._depthTexture?.destroy();
        this._textureHelper.destroyDeferredTextures();
        this._bufferManager.destroyDeferredBuffers();
        this._device.destroy();
        super.dispose();
    }
    //------------------------------------------------------------------------------
    //                              Misc
    //------------------------------------------------------------------------------
    /**
     * Gets the current render width
     * @param useScreen defines if screen size must be used (or the current render target if any)
     * @returns a number defining the current render width
     */ getRenderWidth(useScreen = false) {
        if (!useScreen && this._currentRenderTarget) return this._currentRenderTarget.width;
        return this._renderingCanvas?.width ?? 0;
    }
    /**
     * Gets the current render height
     * @param useScreen defines if screen size must be used (or the current render target if any)
     * @returns a number defining the current render height
     */ getRenderHeight(useScreen = false) {
        if (!useScreen && this._currentRenderTarget) return this._currentRenderTarget.height;
        return this._renderingCanvas?.height ?? 0;
    }
    //------------------------------------------------------------------------------
    //                              Errors
    //------------------------------------------------------------------------------
    /**
     * Get the current error code of the WebGPU context
     * @returns the error code
     */ getError() {
        // TODO WEBGPU. from the webgpu errors.
        return 0;
    }
    //------------------------------------------------------------------------------
    //                              Unused WebGPU
    //------------------------------------------------------------------------------
    /**
     * @internal
     */ bindSamplers() {}
    /**
     * @internal
     */ _bindTextureDirectly() {
        return false;
    }
    /**
     * Gets a boolean indicating if all created effects are ready
     * @returns always true - No parallel shader compilation
     */ areAllEffectsReady() {
        return true;
    }
    /**
     * @internal
     */ _executeWhenRenderingStateIsCompiled(pipelineContext, action) {
        // No parallel shader compilation.
        // No Async, so direct launch
        action();
    }
    /**
     * @internal
     */ _isRenderingStateCompiled() {
        // No parallel shader compilation.
        return true;
    }
    /** @internal */ _getUnpackAlignement() {
        return 1;
    }
    /**
     * @internal
     */ _unpackFlipY() {}
    /**
     * @internal
     */ _bindUnboundFramebuffer() {
        // eslint-disable-next-line no-throw-literal
        throw "_bindUnboundFramebuffer is not implementedin WebGPU! You probably want to use restoreDefaultFramebuffer or unBindFramebuffer instead";
    }
    // TODO WEBGPU. All of the below should go once engine split with baseEngine.
    /**
     * @internal
     */ _getSamplingParameters() {
        // eslint-disable-next-line no-throw-literal
        throw "_getSamplingParameters is not available in WebGPU";
    }
    /**
     * @internal
     */ getUniforms() {
        return [];
    }
    /**
     * @internal
     */ setIntArray() {
        return false;
    }
    /**
     * @internal
     */ setIntArray2() {
        return false;
    }
    /**
     * @internal
     */ setIntArray3() {
        return false;
    }
    /**
     * @internal
     */ setIntArray4() {
        return false;
    }
    /**
     * @internal
     */ setArray() {
        return false;
    }
    /**
     * @internal
     */ setArray2() {
        return false;
    }
    /**
     * @internal
     */ setArray3() {
        return false;
    }
    /**
     * @internal
     */ setArray4() {
        return false;
    }
    /**
     * @internal
     */ setMatrices() {
        return false;
    }
    /**
     * @internal
     */ setMatrix3x3() {
        return false;
    }
    /**
     * @internal
     */ setMatrix2x2() {
        return false;
    }
    /**
     * @internal
     */ setFloat() {
        return false;
    }
    /**
     * @internal
     */ setFloat2() {
        return false;
    }
    /**
     * @internal
     */ setFloat3() {
        return false;
    }
    /**
     * @internal
     */ setFloat4() {
        return false;
    }
}
// Default glslang options.
$46c576986b3f1f6c$export$20da89723e6780ae._GLSLslangDefaultOptions = {
    jsPath: `${(0, $bOhSV.Tools)._DefaultCdnUrl}/glslang/glslang.js`,
    wasmPath: `${(0, $bOhSV.Tools)._DefaultCdnUrl}/glslang/glslang.wasm`
};
$46c576986b3f1f6c$export$20da89723e6780ae._InstanceId = 0;
/** true to enable using TintWASM to convert Spir-V to WGSL */ $46c576986b3f1f6c$export$20da89723e6780ae.UseTWGSL = true;

});
parcelRegister("hR6HG", function(module, exports) {

$parcel$export(module.exports, "PowerPreference", () => $cffc961b0a53d32d$export$6b5b70a539bfa98f);
$parcel$export(module.exports, "FeatureName", () => $cffc961b0a53d32d$export$98c28634739cb1e);
$parcel$export(module.exports, "BufferMapState", () => $cffc961b0a53d32d$export$ff14600f43caac28);
$parcel$export(module.exports, "BufferUsage", () => $cffc961b0a53d32d$export$f8deb2be8632fd10);
$parcel$export(module.exports, "MapMode", () => $cffc961b0a53d32d$export$39cf3280165f92aa);
$parcel$export(module.exports, "TextureDimension", () => $cffc961b0a53d32d$export$e5aeb6ef1c1c1cc3);
$parcel$export(module.exports, "TextureUsage", () => $cffc961b0a53d32d$export$6bf4bd1b6beb0bfd);
$parcel$export(module.exports, "TextureViewDimension", () => $cffc961b0a53d32d$export$63248c08ccb37ce);
$parcel$export(module.exports, "TextureAspect", () => $cffc961b0a53d32d$export$9b9aa78ab43fe647);
$parcel$export(module.exports, "TextureFormat", () => $cffc961b0a53d32d$export$dc883f154a4e460);
$parcel$export(module.exports, "AddressMode", () => $cffc961b0a53d32d$export$6a8be5eb52748b2);
$parcel$export(module.exports, "FilterMode", () => $cffc961b0a53d32d$export$ec1e12eead838acf);
$parcel$export(module.exports, "MipmapFilterMode", () => $cffc961b0a53d32d$export$f42fbbad1f339e12);
$parcel$export(module.exports, "CompareFunction", () => $cffc961b0a53d32d$export$6a3012d75694341);
$parcel$export(module.exports, "ShaderStage", () => $cffc961b0a53d32d$export$34a0cafc5a97ef31);
$parcel$export(module.exports, "BufferBindingType", () => $cffc961b0a53d32d$export$e06f7d585cd47903);
$parcel$export(module.exports, "SamplerBindingType", () => $cffc961b0a53d32d$export$452acb246163fc0f);
$parcel$export(module.exports, "TextureSampleType", () => $cffc961b0a53d32d$export$3412a92146500d9c);
$parcel$export(module.exports, "StorageTextureAccess", () => $cffc961b0a53d32d$export$6100f5da7cb70e4e);
$parcel$export(module.exports, "CompilationMessageType", () => $cffc961b0a53d32d$export$309dda1fb65a3d66);
$parcel$export(module.exports, "PipelineErrorReason", () => $cffc961b0a53d32d$export$8a7fc25f552f18dd);
$parcel$export(module.exports, "AutoLayoutMode", () => $cffc961b0a53d32d$export$5ec697dff2a8c57b);
$parcel$export(module.exports, "PrimitiveTopology", () => $cffc961b0a53d32d$export$d7ed99041b8ef170);
$parcel$export(module.exports, "FrontFace", () => $cffc961b0a53d32d$export$679f3f3b5a8d62d6);
$parcel$export(module.exports, "CullMode", () => $cffc961b0a53d32d$export$1a0b789f38d2ca0);
$parcel$export(module.exports, "ColorWrite", () => $cffc961b0a53d32d$export$7fd968bb08b9ea8f);
$parcel$export(module.exports, "BlendFactor", () => $cffc961b0a53d32d$export$5cf4e6634f4552ed);
$parcel$export(module.exports, "BlendOperation", () => $cffc961b0a53d32d$export$b30758a4c2091299);
$parcel$export(module.exports, "StencilOperation", () => $cffc961b0a53d32d$export$759712bc1a607204);
$parcel$export(module.exports, "IndexFormat", () => $cffc961b0a53d32d$export$7e69498c860874e3);
$parcel$export(module.exports, "VertexFormat", () => $cffc961b0a53d32d$export$7bf32a35280264dc);
$parcel$export(module.exports, "VertexStepMode", () => $cffc961b0a53d32d$export$8f888188787ab458);
$parcel$export(module.exports, "ComputePassTimestampLocation", () => $cffc961b0a53d32d$export$6a3d2765f00afec8);
$parcel$export(module.exports, "RenderPassTimestampLocation", () => $cffc961b0a53d32d$export$a340949a7274f232);
$parcel$export(module.exports, "LoadOp", () => $cffc961b0a53d32d$export$21d1072802a792e);
$parcel$export(module.exports, "StoreOp", () => $cffc961b0a53d32d$export$3714bb81b7c12a17);
$parcel$export(module.exports, "QueryType", () => $cffc961b0a53d32d$export$7c8e26efb80b90e8);
$parcel$export(module.exports, "CanvasAlphaMode", () => $cffc961b0a53d32d$export$d45173d18f3722e2);
$parcel$export(module.exports, "DeviceLostReason", () => $cffc961b0a53d32d$export$22b8e2f1ae7c94a7);
$parcel$export(module.exports, "ErrorFilter", () => $cffc961b0a53d32d$export$e6d016280aba0115);
/** @internal */ // eslint-disable-next-line import/export
var $cffc961b0a53d32d$export$6b5b70a539bfa98f;
(function(PowerPreference) {
    PowerPreference["LowPower"] = "low-power";
    PowerPreference["HighPerformance"] = "high-performance";
})($cffc961b0a53d32d$export$6b5b70a539bfa98f || ($cffc961b0a53d32d$export$6b5b70a539bfa98f = {}));
var $cffc961b0a53d32d$export$98c28634739cb1e;
(function(FeatureName) {
    FeatureName["DepthClipControl"] = "depth-clip-control";
    FeatureName["Depth32FloatStencil8"] = "depth32float-stencil8";
    FeatureName["TextureCompressionBC"] = "texture-compression-bc";
    FeatureName["TextureCompressionETC2"] = "texture-compression-etc2";
    FeatureName["TextureCompressionASTC"] = "texture-compression-astc";
    FeatureName["TimestampQuery"] = "timestamp-query";
    FeatureName["IndirectFirstInstance"] = "indirect-first-instance";
    FeatureName["ShaderF16"] = "shader-f16";
    FeatureName["RG11B10UFloatRenderable"] = "rg11b10ufloat-renderable";
    FeatureName["BGRA8UnormStorage"] = "bgra8unorm-storage";
    FeatureName["Float32Filterable"] = "float32-filterable";
})($cffc961b0a53d32d$export$98c28634739cb1e || ($cffc961b0a53d32d$export$98c28634739cb1e = {}));
var $cffc961b0a53d32d$export$ff14600f43caac28;
(function(BufferMapState) {
    BufferMapState["Unmapped"] = "unmapped";
    BufferMapState["Pending"] = "pending";
    BufferMapState["Mapped"] = "mapped";
})($cffc961b0a53d32d$export$ff14600f43caac28 || ($cffc961b0a53d32d$export$ff14600f43caac28 = {}));
var $cffc961b0a53d32d$export$f8deb2be8632fd10;
(function(BufferUsage) {
    BufferUsage[BufferUsage["MapRead"] = 1] = "MapRead";
    BufferUsage[BufferUsage["MapWrite"] = 2] = "MapWrite";
    BufferUsage[BufferUsage["CopySrc"] = 4] = "CopySrc";
    BufferUsage[BufferUsage["CopyDst"] = 8] = "CopyDst";
    BufferUsage[BufferUsage["Index"] = 16] = "Index";
    BufferUsage[BufferUsage["Vertex"] = 32] = "Vertex";
    BufferUsage[BufferUsage["Uniform"] = 64] = "Uniform";
    BufferUsage[BufferUsage["Storage"] = 128] = "Storage";
    BufferUsage[BufferUsage["Indirect"] = 256] = "Indirect";
    BufferUsage[BufferUsage["QueryResolve"] = 512] = "QueryResolve";
})($cffc961b0a53d32d$export$f8deb2be8632fd10 || ($cffc961b0a53d32d$export$f8deb2be8632fd10 = {}));
var $cffc961b0a53d32d$export$39cf3280165f92aa;
(function(MapMode) {
    MapMode[MapMode["Read"] = 1] = "Read";
    MapMode[MapMode["Write"] = 2] = "Write";
})($cffc961b0a53d32d$export$39cf3280165f92aa || ($cffc961b0a53d32d$export$39cf3280165f92aa = {}));
var $cffc961b0a53d32d$export$e5aeb6ef1c1c1cc3;
(function(TextureDimension) {
    TextureDimension["E1d"] = "1d";
    TextureDimension["E2d"] = "2d";
    TextureDimension["E3d"] = "3d";
})($cffc961b0a53d32d$export$e5aeb6ef1c1c1cc3 || ($cffc961b0a53d32d$export$e5aeb6ef1c1c1cc3 = {}));
var $cffc961b0a53d32d$export$6bf4bd1b6beb0bfd;
(function(TextureUsage) {
    TextureUsage[TextureUsage["CopySrc"] = 1] = "CopySrc";
    TextureUsage[TextureUsage["CopyDst"] = 2] = "CopyDst";
    TextureUsage[TextureUsage["TextureBinding"] = 4] = "TextureBinding";
    TextureUsage[TextureUsage["StorageBinding"] = 8] = "StorageBinding";
    TextureUsage[TextureUsage["RenderAttachment"] = 16] = "RenderAttachment";
})($cffc961b0a53d32d$export$6bf4bd1b6beb0bfd || ($cffc961b0a53d32d$export$6bf4bd1b6beb0bfd = {}));
var $cffc961b0a53d32d$export$63248c08ccb37ce;
(function(TextureViewDimension) {
    TextureViewDimension["E1d"] = "1d";
    TextureViewDimension["E2d"] = "2d";
    TextureViewDimension["E2dArray"] = "2d-array";
    TextureViewDimension["Cube"] = "cube";
    TextureViewDimension["CubeArray"] = "cube-array";
    TextureViewDimension["E3d"] = "3d";
})($cffc961b0a53d32d$export$63248c08ccb37ce || ($cffc961b0a53d32d$export$63248c08ccb37ce = {}));
var $cffc961b0a53d32d$export$9b9aa78ab43fe647;
(function(TextureAspect) {
    TextureAspect["All"] = "all";
    TextureAspect["StencilOnly"] = "stencil-only";
    TextureAspect["DepthOnly"] = "depth-only";
})($cffc961b0a53d32d$export$9b9aa78ab43fe647 || ($cffc961b0a53d32d$export$9b9aa78ab43fe647 = {}));
var $cffc961b0a53d32d$export$dc883f154a4e460;
(function(TextureFormat) {
    // 8-bit formats
    TextureFormat["R8Unorm"] = "r8unorm";
    TextureFormat["R8Snorm"] = "r8snorm";
    TextureFormat["R8Uint"] = "r8uint";
    TextureFormat["R8Sint"] = "r8sint";
    // 16-bit formats
    TextureFormat["R16Uint"] = "r16uint";
    TextureFormat["R16Sint"] = "r16sint";
    TextureFormat["R16Float"] = "r16float";
    TextureFormat["RG8Unorm"] = "rg8unorm";
    TextureFormat["RG8Snorm"] = "rg8snorm";
    TextureFormat["RG8Uint"] = "rg8uint";
    TextureFormat["RG8Sint"] = "rg8sint";
    // 32-bit formats
    TextureFormat["R32Uint"] = "r32uint";
    TextureFormat["R32Sint"] = "r32sint";
    TextureFormat["R32Float"] = "r32float";
    TextureFormat["RG16Uint"] = "rg16uint";
    TextureFormat["RG16Sint"] = "rg16sint";
    TextureFormat["RG16Float"] = "rg16float";
    TextureFormat["RGBA8Unorm"] = "rgba8unorm";
    TextureFormat["RGBA8UnormSRGB"] = "rgba8unorm-srgb";
    TextureFormat["RGBA8Snorm"] = "rgba8snorm";
    TextureFormat["RGBA8Uint"] = "rgba8uint";
    TextureFormat["RGBA8Sint"] = "rgba8sint";
    TextureFormat["BGRA8Unorm"] = "bgra8unorm";
    TextureFormat["BGRA8UnormSRGB"] = "bgra8unorm-srgb";
    // Packed 32-bit formats
    TextureFormat["RGB9E5UFloat"] = "rgb9e5ufloat";
    TextureFormat["RGB10A2UINT"] = "rgb10a2uint";
    TextureFormat["RGB10A2Unorm"] = "rgb10a2unorm";
    TextureFormat["RG11B10UFloat"] = "rg11b10ufloat";
    // 64-bit formats
    TextureFormat["RG32Uint"] = "rg32uint";
    TextureFormat["RG32Sint"] = "rg32sint";
    TextureFormat["RG32Float"] = "rg32float";
    TextureFormat["RGBA16Uint"] = "rgba16uint";
    TextureFormat["RGBA16Sint"] = "rgba16sint";
    TextureFormat["RGBA16Float"] = "rgba16float";
    // 128-bit formats
    TextureFormat["RGBA32Uint"] = "rgba32uint";
    TextureFormat["RGBA32Sint"] = "rgba32sint";
    TextureFormat["RGBA32Float"] = "rgba32float";
    // Depth and stencil formats
    TextureFormat["Stencil8"] = "stencil8";
    TextureFormat["Depth16Unorm"] = "depth16unorm";
    TextureFormat["Depth24Plus"] = "depth24plus";
    TextureFormat["Depth24PlusStencil8"] = "depth24plus-stencil8";
    TextureFormat["Depth32Float"] = "depth32float";
    // BC compressed formats usable if "texture-compression-bc" is both
    // supported by the device/user agent and enabled in requestDevice.
    TextureFormat["BC1RGBAUnorm"] = "bc1-rgba-unorm";
    TextureFormat["BC1RGBAUnormSRGB"] = "bc1-rgba-unorm-srgb";
    TextureFormat["BC2RGBAUnorm"] = "bc2-rgba-unorm";
    TextureFormat["BC2RGBAUnormSRGB"] = "bc2-rgba-unorm-srgb";
    TextureFormat["BC3RGBAUnorm"] = "bc3-rgba-unorm";
    TextureFormat["BC3RGBAUnormSRGB"] = "bc3-rgba-unorm-srgb";
    TextureFormat["BC4RUnorm"] = "bc4-r-unorm";
    TextureFormat["BC4RSnorm"] = "bc4-r-snorm";
    TextureFormat["BC5RGUnorm"] = "bc5-rg-unorm";
    TextureFormat["BC5RGSnorm"] = "bc5-rg-snorm";
    TextureFormat["BC6HRGBUFloat"] = "bc6h-rgb-ufloat";
    TextureFormat["BC6HRGBFloat"] = "bc6h-rgb-float";
    TextureFormat["BC7RGBAUnorm"] = "bc7-rgba-unorm";
    TextureFormat["BC7RGBAUnormSRGB"] = "bc7-rgba-unorm-srgb";
    // ETC2 compressed formats usable if "texture-compression-etc2" is both
    // supported by the device/user agent and enabled in requestDevice.
    TextureFormat["ETC2RGB8Unorm"] = "etc2-rgb8unorm";
    TextureFormat["ETC2RGB8UnormSRGB"] = "etc2-rgb8unorm-srgb";
    TextureFormat["ETC2RGB8A1Unorm"] = "etc2-rgb8a1unorm";
    TextureFormat["ETC2RGB8A1UnormSRGB"] = "etc2-rgb8a1unorm-srgb";
    TextureFormat["ETC2RGBA8Unorm"] = "etc2-rgba8unorm";
    TextureFormat["ETC2RGBA8UnormSRGB"] = "etc2-rgba8unorm-srgb";
    TextureFormat["EACR11Unorm"] = "eac-r11unorm";
    TextureFormat["EACR11Snorm"] = "eac-r11snorm";
    TextureFormat["EACRG11Unorm"] = "eac-rg11unorm";
    TextureFormat["EACRG11Snorm"] = "eac-rg11snorm";
    // ASTC compressed formats usable if "texture-compression-astc" is both
    // supported by the device/user agent and enabled in requestDevice.
    TextureFormat["ASTC4x4Unorm"] = "astc-4x4-unorm";
    TextureFormat["ASTC4x4UnormSRGB"] = "astc-4x4-unorm-srgb";
    TextureFormat["ASTC5x4Unorm"] = "astc-5x4-unorm";
    TextureFormat["ASTC5x4UnormSRGB"] = "astc-5x4-unorm-srgb";
    TextureFormat["ASTC5x5Unorm"] = "astc-5x5-unorm";
    TextureFormat["ASTC5x5UnormSRGB"] = "astc-5x5-unorm-srgb";
    TextureFormat["ASTC6x5Unorm"] = "astc-6x5-unorm";
    TextureFormat["ASTC6x5UnormSRGB"] = "astc-6x5-unorm-srgb";
    TextureFormat["ASTC6x6Unorm"] = "astc-6x6-unorm";
    TextureFormat["ASTC6x6UnormSRGB"] = "astc-6x6-unorm-srgb";
    TextureFormat["ASTC8x5Unorm"] = "astc-8x5-unorm";
    TextureFormat["ASTC8x5UnormSRGB"] = "astc-8x5-unorm-srgb";
    TextureFormat["ASTC8x6Unorm"] = "astc-8x6-unorm";
    TextureFormat["ASTC8x6UnormSRGB"] = "astc-8x6-unorm-srgb";
    TextureFormat["ASTC8x8Unorm"] = "astc-8x8-unorm";
    TextureFormat["ASTC8x8UnormSRGB"] = "astc-8x8-unorm-srgb";
    TextureFormat["ASTC10x5Unorm"] = "astc-10x5-unorm";
    TextureFormat["ASTC10x5UnormSRGB"] = "astc-10x5-unorm-srgb";
    TextureFormat["ASTC10x6Unorm"] = "astc-10x6-unorm";
    TextureFormat["ASTC10x6UnormSRGB"] = "astc-10x6-unorm-srgb";
    TextureFormat["ASTC10x8Unorm"] = "astc-10x8-unorm";
    TextureFormat["ASTC10x8UnormSRGB"] = "astc-10x8-unorm-srgb";
    TextureFormat["ASTC10x10Unorm"] = "astc-10x10-unorm";
    TextureFormat["ASTC10x10UnormSRGB"] = "astc-10x10-unorm-srgb";
    TextureFormat["ASTC12x10Unorm"] = "astc-12x10-unorm";
    TextureFormat["ASTC12x10UnormSRGB"] = "astc-12x10-unorm-srgb";
    TextureFormat["ASTC12x12Unorm"] = "astc-12x12-unorm";
    TextureFormat["ASTC12x12UnormSRGB"] = "astc-12x12-unorm-srgb";
    // "depth32float-stencil8" feature
    TextureFormat["Depth32FloatStencil8"] = "depth32float-stencil8";
})($cffc961b0a53d32d$export$dc883f154a4e460 || ($cffc961b0a53d32d$export$dc883f154a4e460 = {}));
var $cffc961b0a53d32d$export$6a8be5eb52748b2;
(function(AddressMode) {
    AddressMode["ClampToEdge"] = "clamp-to-edge";
    AddressMode["Repeat"] = "repeat";
    AddressMode["MirrorRepeat"] = "mirror-repeat";
})($cffc961b0a53d32d$export$6a8be5eb52748b2 || ($cffc961b0a53d32d$export$6a8be5eb52748b2 = {}));
var $cffc961b0a53d32d$export$ec1e12eead838acf;
(function(FilterMode) {
    FilterMode["Nearest"] = "nearest";
    FilterMode["Linear"] = "linear";
})($cffc961b0a53d32d$export$ec1e12eead838acf || ($cffc961b0a53d32d$export$ec1e12eead838acf = {}));
var $cffc961b0a53d32d$export$f42fbbad1f339e12;
(function(MipmapFilterMode) {
    MipmapFilterMode["Nearest"] = "nearest";
    MipmapFilterMode["Linear"] = "linear";
})($cffc961b0a53d32d$export$f42fbbad1f339e12 || ($cffc961b0a53d32d$export$f42fbbad1f339e12 = {}));
var $cffc961b0a53d32d$export$6a3012d75694341;
(function(CompareFunction) {
    CompareFunction["Never"] = "never";
    CompareFunction["Less"] = "less";
    CompareFunction["Equal"] = "equal";
    CompareFunction["LessEqual"] = "less-equal";
    CompareFunction["Greater"] = "greater";
    CompareFunction["NotEqual"] = "not-equal";
    CompareFunction["GreaterEqual"] = "greater-equal";
    CompareFunction["Always"] = "always";
})($cffc961b0a53d32d$export$6a3012d75694341 || ($cffc961b0a53d32d$export$6a3012d75694341 = {}));
var $cffc961b0a53d32d$export$34a0cafc5a97ef31;
(function(ShaderStage) {
    ShaderStage[ShaderStage["Vertex"] = 1] = "Vertex";
    ShaderStage[ShaderStage["Fragment"] = 2] = "Fragment";
    ShaderStage[ShaderStage["Compute"] = 4] = "Compute";
})($cffc961b0a53d32d$export$34a0cafc5a97ef31 || ($cffc961b0a53d32d$export$34a0cafc5a97ef31 = {}));
var $cffc961b0a53d32d$export$e06f7d585cd47903;
(function(BufferBindingType) {
    BufferBindingType["Uniform"] = "uniform";
    BufferBindingType["Storage"] = "storage";
    BufferBindingType["ReadOnlyStorage"] = "read-only-storage";
})($cffc961b0a53d32d$export$e06f7d585cd47903 || ($cffc961b0a53d32d$export$e06f7d585cd47903 = {}));
var $cffc961b0a53d32d$export$452acb246163fc0f;
(function(SamplerBindingType) {
    SamplerBindingType["Filtering"] = "filtering";
    SamplerBindingType["NonFiltering"] = "non-filtering";
    SamplerBindingType["Comparison"] = "comparison";
})($cffc961b0a53d32d$export$452acb246163fc0f || ($cffc961b0a53d32d$export$452acb246163fc0f = {}));
var $cffc961b0a53d32d$export$3412a92146500d9c;
(function(TextureSampleType) {
    TextureSampleType["Float"] = "float";
    TextureSampleType["UnfilterableFloat"] = "unfilterable-float";
    TextureSampleType["Depth"] = "depth";
    TextureSampleType["Sint"] = "sint";
    TextureSampleType["Uint"] = "uint";
})($cffc961b0a53d32d$export$3412a92146500d9c || ($cffc961b0a53d32d$export$3412a92146500d9c = {}));
var $cffc961b0a53d32d$export$6100f5da7cb70e4e;
(function(StorageTextureAccess) {
    StorageTextureAccess["WriteOnly"] = "write-only";
    StorageTextureAccess["ReadOnly"] = "read-only";
    StorageTextureAccess["ReadWrite"] = "read-write";
})($cffc961b0a53d32d$export$6100f5da7cb70e4e || ($cffc961b0a53d32d$export$6100f5da7cb70e4e = {}));
var $cffc961b0a53d32d$export$309dda1fb65a3d66;
(function(CompilationMessageType) {
    CompilationMessageType["Error"] = "error";
    CompilationMessageType["Warning"] = "warning";
    CompilationMessageType["Info"] = "info";
})($cffc961b0a53d32d$export$309dda1fb65a3d66 || ($cffc961b0a53d32d$export$309dda1fb65a3d66 = {}));
var $cffc961b0a53d32d$export$8a7fc25f552f18dd;
(function(PipelineErrorReason) {
    PipelineErrorReason["Validation"] = "validation";
    PipelineErrorReason["Internal"] = "internal";
})($cffc961b0a53d32d$export$8a7fc25f552f18dd || ($cffc961b0a53d32d$export$8a7fc25f552f18dd = {}));
var $cffc961b0a53d32d$export$5ec697dff2a8c57b;
(function(AutoLayoutMode) {
    AutoLayoutMode["Auto"] = "auto";
})($cffc961b0a53d32d$export$5ec697dff2a8c57b || ($cffc961b0a53d32d$export$5ec697dff2a8c57b = {}));
var $cffc961b0a53d32d$export$d7ed99041b8ef170;
(function(PrimitiveTopology) {
    PrimitiveTopology["PointList"] = "point-list";
    PrimitiveTopology["LineList"] = "line-list";
    PrimitiveTopology["LineStrip"] = "line-strip";
    PrimitiveTopology["TriangleList"] = "triangle-list";
    PrimitiveTopology["TriangleStrip"] = "triangle-strip";
})($cffc961b0a53d32d$export$d7ed99041b8ef170 || ($cffc961b0a53d32d$export$d7ed99041b8ef170 = {}));
var $cffc961b0a53d32d$export$679f3f3b5a8d62d6;
(function(FrontFace) {
    FrontFace["CCW"] = "ccw";
    FrontFace["CW"] = "cw";
})($cffc961b0a53d32d$export$679f3f3b5a8d62d6 || ($cffc961b0a53d32d$export$679f3f3b5a8d62d6 = {}));
var $cffc961b0a53d32d$export$1a0b789f38d2ca0;
(function(CullMode) {
    CullMode["None"] = "none";
    CullMode["Front"] = "front";
    CullMode["Back"] = "back";
})($cffc961b0a53d32d$export$1a0b789f38d2ca0 || ($cffc961b0a53d32d$export$1a0b789f38d2ca0 = {}));
var $cffc961b0a53d32d$export$7fd968bb08b9ea8f;
(function(ColorWrite) {
    ColorWrite[ColorWrite["Red"] = 1] = "Red";
    ColorWrite[ColorWrite["Green"] = 2] = "Green";
    ColorWrite[ColorWrite["Blue"] = 4] = "Blue";
    ColorWrite[ColorWrite["Alpha"] = 8] = "Alpha";
    ColorWrite[ColorWrite["All"] = 15] = "All";
})($cffc961b0a53d32d$export$7fd968bb08b9ea8f || ($cffc961b0a53d32d$export$7fd968bb08b9ea8f = {}));
var $cffc961b0a53d32d$export$5cf4e6634f4552ed;
(function(BlendFactor) {
    BlendFactor["Zero"] = "zero";
    BlendFactor["One"] = "one";
    BlendFactor["Src"] = "src";
    BlendFactor["OneMinusSrc"] = "one-minus-src";
    BlendFactor["SrcAlpha"] = "src-alpha";
    BlendFactor["OneMinusSrcAlpha"] = "one-minus-src-alpha";
    BlendFactor["Dst"] = "dst";
    BlendFactor["OneMinusDst"] = "one-minus-dst";
    BlendFactor["DstAlpha"] = "dst-alpha";
    BlendFactor["OneMinusDstAlpha"] = "one-minus-dst-alpha";
    BlendFactor["SrcAlphaSaturated"] = "src-alpha-saturated";
    BlendFactor["Constant"] = "constant";
    BlendFactor["OneMinusConstant"] = "one-minus-constant";
})($cffc961b0a53d32d$export$5cf4e6634f4552ed || ($cffc961b0a53d32d$export$5cf4e6634f4552ed = {}));
var $cffc961b0a53d32d$export$b30758a4c2091299;
(function(BlendOperation) {
    BlendOperation["Add"] = "add";
    BlendOperation["Subtract"] = "subtract";
    BlendOperation["ReverseSubtract"] = "reverse-subtract";
    BlendOperation["Min"] = "min";
    BlendOperation["Max"] = "max";
})($cffc961b0a53d32d$export$b30758a4c2091299 || ($cffc961b0a53d32d$export$b30758a4c2091299 = {}));
var $cffc961b0a53d32d$export$759712bc1a607204;
(function(StencilOperation) {
    StencilOperation["Keep"] = "keep";
    StencilOperation["Zero"] = "zero";
    StencilOperation["Replace"] = "replace";
    StencilOperation["Invert"] = "invert";
    StencilOperation["IncrementClamp"] = "increment-clamp";
    StencilOperation["DecrementClamp"] = "decrement-clamp";
    StencilOperation["IncrementWrap"] = "increment-wrap";
    StencilOperation["DecrementWrap"] = "decrement-wrap";
})($cffc961b0a53d32d$export$759712bc1a607204 || ($cffc961b0a53d32d$export$759712bc1a607204 = {}));
var $cffc961b0a53d32d$export$7e69498c860874e3;
(function(IndexFormat) {
    IndexFormat["Uint16"] = "uint16";
    IndexFormat["Uint32"] = "uint32";
})($cffc961b0a53d32d$export$7e69498c860874e3 || ($cffc961b0a53d32d$export$7e69498c860874e3 = {}));
var $cffc961b0a53d32d$export$7bf32a35280264dc;
(function(VertexFormat) {
    VertexFormat["Uint8x2"] = "uint8x2";
    VertexFormat["Uint8x4"] = "uint8x4";
    VertexFormat["Sint8x2"] = "sint8x2";
    VertexFormat["Sint8x4"] = "sint8x4";
    VertexFormat["Unorm8x2"] = "unorm8x2";
    VertexFormat["Unorm8x4"] = "unorm8x4";
    VertexFormat["Snorm8x2"] = "snorm8x2";
    VertexFormat["Snorm8x4"] = "snorm8x4";
    VertexFormat["Uint16x2"] = "uint16x2";
    VertexFormat["Uint16x4"] = "uint16x4";
    VertexFormat["Sint16x2"] = "sint16x2";
    VertexFormat["Sint16x4"] = "sint16x4";
    VertexFormat["Unorm16x2"] = "unorm16x2";
    VertexFormat["Unorm16x4"] = "unorm16x4";
    VertexFormat["Snorm16x2"] = "snorm16x2";
    VertexFormat["Snorm16x4"] = "snorm16x4";
    VertexFormat["Float16x2"] = "float16x2";
    VertexFormat["Float16x4"] = "float16x4";
    VertexFormat["Float32"] = "float32";
    VertexFormat["Float32x2"] = "float32x2";
    VertexFormat["Float32x3"] = "float32x3";
    VertexFormat["Float32x4"] = "float32x4";
    VertexFormat["Uint32"] = "uint32";
    VertexFormat["Uint32x2"] = "uint32x2";
    VertexFormat["Uint32x3"] = "uint32x3";
    VertexFormat["Uint32x4"] = "uint32x4";
    VertexFormat["Sint32"] = "sint32";
    VertexFormat["Sint32x2"] = "sint32x2";
    VertexFormat["Sint32x3"] = "sint32x3";
    VertexFormat["Sint32x4"] = "sint32x4";
    VertexFormat["UNORM10x10x10x2"] = "unorm10-10-10-2";
})($cffc961b0a53d32d$export$7bf32a35280264dc || ($cffc961b0a53d32d$export$7bf32a35280264dc = {}));
var $cffc961b0a53d32d$export$8f888188787ab458;
(function(VertexStepMode) {
    VertexStepMode["Vertex"] = "vertex";
    VertexStepMode["Instance"] = "instance";
})($cffc961b0a53d32d$export$8f888188787ab458 || ($cffc961b0a53d32d$export$8f888188787ab458 = {}));
var $cffc961b0a53d32d$export$6a3d2765f00afec8;
(function(ComputePassTimestampLocation) {
    ComputePassTimestampLocation["Beginning"] = "beginning";
    ComputePassTimestampLocation["End"] = "end";
})($cffc961b0a53d32d$export$6a3d2765f00afec8 || ($cffc961b0a53d32d$export$6a3d2765f00afec8 = {}));
var $cffc961b0a53d32d$export$a340949a7274f232;
(function(RenderPassTimestampLocation) {
    RenderPassTimestampLocation["Beginning"] = "beginning";
    RenderPassTimestampLocation["End"] = "end";
})($cffc961b0a53d32d$export$a340949a7274f232 || ($cffc961b0a53d32d$export$a340949a7274f232 = {}));
var $cffc961b0a53d32d$export$21d1072802a792e;
(function(LoadOp) {
    LoadOp["Load"] = "load";
    LoadOp["Clear"] = "clear";
})($cffc961b0a53d32d$export$21d1072802a792e || ($cffc961b0a53d32d$export$21d1072802a792e = {}));
var $cffc961b0a53d32d$export$3714bb81b7c12a17;
(function(StoreOp) {
    StoreOp["Store"] = "store";
    StoreOp["Discard"] = "discard";
})($cffc961b0a53d32d$export$3714bb81b7c12a17 || ($cffc961b0a53d32d$export$3714bb81b7c12a17 = {}));
var $cffc961b0a53d32d$export$7c8e26efb80b90e8;
(function(QueryType) {
    QueryType["Occlusion"] = "occlusion";
    QueryType["Timestamp"] = "timestamp";
})($cffc961b0a53d32d$export$7c8e26efb80b90e8 || ($cffc961b0a53d32d$export$7c8e26efb80b90e8 = {}));
var $cffc961b0a53d32d$export$d45173d18f3722e2;
(function(CanvasAlphaMode) {
    CanvasAlphaMode["Opaque"] = "opaque";
    CanvasAlphaMode["Premultiplied"] = "premultiplied";
})($cffc961b0a53d32d$export$d45173d18f3722e2 || ($cffc961b0a53d32d$export$d45173d18f3722e2 = {}));
var $cffc961b0a53d32d$export$22b8e2f1ae7c94a7;
(function(DeviceLostReason) {
    DeviceLostReason["Unknown"] = "unknown";
    DeviceLostReason["Destroyed"] = "destroyed";
})($cffc961b0a53d32d$export$22b8e2f1ae7c94a7 || ($cffc961b0a53d32d$export$22b8e2f1ae7c94a7 = {}));
var $cffc961b0a53d32d$export$e6d016280aba0115;
(function(ErrorFilter) {
    ErrorFilter["Validation"] = "validation";
    ErrorFilter["OutOfMemory"] = "out-of-memory";
    ErrorFilter["Internal"] = "internal";
})($cffc961b0a53d32d$export$e6d016280aba0115 || ($cffc961b0a53d32d$export$e6d016280aba0115 = {}));

});

parcelRegister("iVtp9", function(module, exports) {

$parcel$export(module.exports, "WebGPUPipelineContext", () => $dc745c0a43e67998$export$c962fd404309a495);

var $ghoTi = parcelRequire("ghoTi");

var $jXMwB = parcelRequire("jXMwB");
class $dc745c0a43e67998$export$c962fd404309a495 {
    get isAsync() {
        return false;
    }
    get isReady() {
        if (this.stages) return true;
        return false;
    }
    constructor(shaderProcessingContext, engine){
        // The field is indexed by textureState. See @WebGPUMaterialContext.textureState for more information.
        this.bindGroupLayouts = {};
        this._name = "unnamed";
        this.shaderProcessingContext = shaderProcessingContext;
        this._leftOverUniformsByName = {};
        this.engine = engine;
        this.vertexBufferKindToType = {};
    }
    _handlesSpectorRebuildCallback() {
    // Nothing to do yet for spector.
    }
    _fillEffectInformation(effect, uniformBuffersNames, uniformsNames, uniforms, samplerList, samplers, attributesNames, attributes) {
        const engine = this.engine;
        if (engine._doNotHandleContextLost) {
            effect._fragmentSourceCode = "";
            effect._vertexSourceCode = "";
        }
        const foundSamplers = this.shaderProcessingContext.availableTextures;
        let index;
        for(index = 0; index < samplerList.length; index++){
            const name = samplerList[index];
            const sampler = foundSamplers[samplerList[index]];
            if (sampler == null || sampler == undefined) {
                samplerList.splice(index, 1);
                index--;
            } else samplers[name] = index;
        }
        for (const attr of engine.getAttributes(this, attributesNames))attributes.push(attr);
        // Build the uniform layout for the left over uniforms.
        this.buildUniformLayout();
        const attributeNamesFromEffect = [];
        const attributeLocationsFromEffect = [];
        for(index = 0; index < attributesNames.length; index++){
            const location = attributes[index];
            if (location >= 0) {
                attributeNamesFromEffect.push(attributesNames[index]);
                attributeLocationsFromEffect.push(location);
            }
        }
        this.shaderProcessingContext.attributeNamesFromEffect = attributeNamesFromEffect;
        this.shaderProcessingContext.attributeLocationsFromEffect = attributeLocationsFromEffect;
    }
    /** @internal */ /**
     * Build the uniform buffer used in the material.
     */ buildUniformLayout() {
        if (!this.shaderProcessingContext.leftOverUniforms.length) return;
        this.uniformBuffer = new (0, $ghoTi.UniformBuffer)(this.engine, undefined, undefined, "leftOver-" + this._name);
        for (const leftOverUniform of this.shaderProcessingContext.leftOverUniforms){
            const type = leftOverUniform.type.replace(/^(.*?)(<.*>)?$/, "$1");
            const size = (0, $jXMwB.WebGPUShaderProcessor).UniformSizes[type];
            this.uniformBuffer.addUniform(leftOverUniform.name, size, leftOverUniform.length);
            this._leftOverUniformsByName[leftOverUniform.name] = leftOverUniform.type;
        }
        this.uniformBuffer.create();
    }
    /**
     * Release all associated resources.
     **/ dispose() {
        if (this.uniformBuffer) this.uniformBuffer.dispose();
    }
    /**
     * Sets an integer value on a uniform variable.
     * @param uniformName Name of the variable.
     * @param value Value to be set.
     */ setInt(uniformName, value) {
        if (!this.uniformBuffer || !this._leftOverUniformsByName[uniformName]) return;
        this.uniformBuffer.updateInt(uniformName, value);
    }
    /**
     * Sets an int2 value on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First int in int2.
     * @param y Second int in int2.
     */ setInt2(uniformName, x, y) {
        if (!this.uniformBuffer || !this._leftOverUniformsByName[uniformName]) return;
        this.uniformBuffer.updateInt2(uniformName, x, y);
    }
    /**
     * Sets an int3 value on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First int in int3.
     * @param y Second int in int3.
     * @param z Third int in int3.
     */ setInt3(uniformName, x, y, z) {
        if (!this.uniformBuffer || !this._leftOverUniformsByName[uniformName]) return;
        this.uniformBuffer.updateInt3(uniformName, x, y, z);
    }
    /**
     * Sets an int4 value on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First int in int4.
     * @param y Second int in int4.
     * @param z Third int in int4.
     * @param w Fourth int in int4.
     */ setInt4(uniformName, x, y, z, w) {
        if (!this.uniformBuffer || !this._leftOverUniformsByName[uniformName]) return;
        this.uniformBuffer.updateInt4(uniformName, x, y, z, w);
    }
    /**
     * Sets an int array on a uniform variable.
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setIntArray(uniformName, array) {
        if (!this.uniformBuffer || !this._leftOverUniformsByName[uniformName]) return;
        this.uniformBuffer.updateIntArray(uniformName, array);
    }
    /**
     * Sets an int array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setIntArray2(uniformName, array) {
        this.setIntArray(uniformName, array);
    }
    /**
     * Sets an int array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setIntArray3(uniformName, array) {
        this.setIntArray(uniformName, array);
    }
    /**
     * Sets an int array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setIntArray4(uniformName, array) {
        this.setIntArray(uniformName, array);
    }
    /**
     * Sets an unsigned integer value on a uniform variable.
     * @param uniformName Name of the variable.
     * @param value Value to be set.
     */ setUInt(uniformName, value) {
        if (!this.uniformBuffer || !this._leftOverUniformsByName[uniformName]) return;
        this.uniformBuffer.updateUInt(uniformName, value);
    }
    /**
     * Sets an unsigned int2 value on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First unsigned int in uint2.
     * @param y Second unsigned int in uint2.
     */ setUInt2(uniformName, x, y) {
        if (!this.uniformBuffer || !this._leftOverUniformsByName[uniformName]) return;
        this.uniformBuffer.updateUInt2(uniformName, x, y);
    }
    /**
     * Sets an unsigned int3 value on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First unsigned int in uint3.
     * @param y Second unsigned int in uint3.
     * @param z Third unsigned int in uint3.
     */ setUInt3(uniformName, x, y, z) {
        if (!this.uniformBuffer || !this._leftOverUniformsByName[uniformName]) return;
        this.uniformBuffer.updateUInt3(uniformName, x, y, z);
    }
    /**
     * Sets an unsigned int4 value on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First unsigned int in uint4.
     * @param y Second unsigned int in uint4.
     * @param z Third unsigned int in uint4.
     * @param w Fourth unsigned int in uint4.
     */ setUInt4(uniformName, x, y, z, w) {
        if (!this.uniformBuffer || !this._leftOverUniformsByName[uniformName]) return;
        this.uniformBuffer.updateUInt4(uniformName, x, y, z, w);
    }
    /**
     * Sets an unsigned int array on a uniform variable.
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setUIntArray(uniformName, array) {
        if (!this.uniformBuffer || !this._leftOverUniformsByName[uniformName]) return;
        this.uniformBuffer.updateUIntArray(uniformName, array);
    }
    /**
     * Sets an unsigned int array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setUIntArray2(uniformName, array) {
        this.setUIntArray(uniformName, array);
    }
    /**
     * Sets an unsigned int array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setUIntArray3(uniformName, array) {
        this.setUIntArray(uniformName, array);
    }
    /**
     * Sets an unsigned int array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setUIntArray4(uniformName, array) {
        this.setUIntArray(uniformName, array);
    }
    /**
     * Sets an array on a uniform variable.
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setArray(uniformName, array) {
        if (!this.uniformBuffer || !this._leftOverUniformsByName[uniformName]) return;
        this.uniformBuffer.updateArray(uniformName, array);
    }
    /**
     * Sets an array 2 on a uniform variable. (Array is specified as single array eg. [1,2,3,4] will result in [[1,2],[3,4]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setArray2(uniformName, array) {
        this.setArray(uniformName, array);
    }
    /**
     * Sets an array 3 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6] will result in [[1,2,3],[4,5,6]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setArray3(uniformName, array) {
        this.setArray(uniformName, array);
    }
    /**
     * Sets an array 4 on a uniform variable. (Array is specified as single array eg. [1,2,3,4,5,6,7,8] will result in [[1,2,3,4],[5,6,7,8]] in the shader)
     * @param uniformName Name of the variable.
     * @param array array to be set.
     */ setArray4(uniformName, array) {
        this.setArray(uniformName, array);
    }
    /**
     * Sets matrices on a uniform variable.
     * @param uniformName Name of the variable.
     * @param matrices matrices to be set.
     */ setMatrices(uniformName, matrices) {
        if (!this.uniformBuffer || !this._leftOverUniformsByName[uniformName]) return;
        this.uniformBuffer.updateMatrices(uniformName, matrices);
    }
    /**
     * Sets matrix on a uniform variable.
     * @param uniformName Name of the variable.
     * @param matrix matrix to be set.
     */ setMatrix(uniformName, matrix) {
        if (!this.uniformBuffer || !this._leftOverUniformsByName[uniformName]) return;
        this.uniformBuffer.updateMatrix(uniformName, matrix);
    }
    /**
     * Sets a 3x3 matrix on a uniform variable. (Specified as [1,2,3,4,5,6,7,8,9] will result in [1,2,3][4,5,6][7,8,9] matrix)
     * @param uniformName Name of the variable.
     * @param matrix matrix to be set.
     */ setMatrix3x3(uniformName, matrix) {
        if (!this.uniformBuffer || !this._leftOverUniformsByName[uniformName]) return;
        this.uniformBuffer.updateMatrix3x3(uniformName, matrix);
    }
    /**
     * Sets a 2x2 matrix on a uniform variable. (Specified as [1,2,3,4] will result in [1,2][3,4] matrix)
     * @param uniformName Name of the variable.
     * @param matrix matrix to be set.
     */ setMatrix2x2(uniformName, matrix) {
        if (!this.uniformBuffer || !this._leftOverUniformsByName[uniformName]) return;
        this.uniformBuffer.updateMatrix2x2(uniformName, matrix);
    }
    /**
     * Sets a float on a uniform variable.
     * @param uniformName Name of the variable.
     * @param value value to be set.
     */ setFloat(uniformName, value) {
        if (!this.uniformBuffer || !this._leftOverUniformsByName[uniformName]) return;
        this.uniformBuffer.updateFloat(uniformName, value);
    }
    /**
     * Sets a Vector2 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param vector2 vector2 to be set.
     */ setVector2(uniformName, vector2) {
        this.setFloat2(uniformName, vector2.x, vector2.y);
    }
    /**
     * Sets a float2 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First float in float2.
     * @param y Second float in float2.
     */ setFloat2(uniformName, x, y) {
        if (!this.uniformBuffer || !this._leftOverUniformsByName[uniformName]) return;
        this.uniformBuffer.updateFloat2(uniformName, x, y);
    }
    /**
     * Sets a Vector3 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param vector3 Value to be set.
     */ setVector3(uniformName, vector3) {
        this.setFloat3(uniformName, vector3.x, vector3.y, vector3.z);
    }
    /**
     * Sets a float3 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First float in float3.
     * @param y Second float in float3.
     * @param z Third float in float3.
     */ setFloat3(uniformName, x, y, z) {
        if (!this.uniformBuffer || !this._leftOverUniformsByName[uniformName]) return;
        this.uniformBuffer.updateFloat3(uniformName, x, y, z);
    }
    /**
     * Sets a Vector4 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param vector4 Value to be set.
     */ setVector4(uniformName, vector4) {
        this.setFloat4(uniformName, vector4.x, vector4.y, vector4.z, vector4.w);
    }
    /**
     * Sets a Quaternion on a uniform variable.
     * @param uniformName Name of the variable.
     * @param quaternion Value to be set.
     */ setQuaternion(uniformName, quaternion) {
        this.setFloat4(uniformName, quaternion.x, quaternion.y, quaternion.z, quaternion.w);
    }
    /**
     * Sets a float4 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param x First float in float4.
     * @param y Second float in float4.
     * @param z Third float in float4.
     * @param w Fourth float in float4.
     */ setFloat4(uniformName, x, y, z, w) {
        if (!this.uniformBuffer || !this._leftOverUniformsByName[uniformName]) return;
        this.uniformBuffer.updateFloat4(uniformName, x, y, z, w);
    }
    /**
     * Sets a Color3 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param color3 Value to be set.
     */ setColor3(uniformName, color3) {
        this.setFloat3(uniformName, color3.r, color3.g, color3.b);
    }
    /**
     * Sets a Color4 on a uniform variable.
     * @param uniformName Name of the variable.
     * @param color3 Value to be set.
     * @param alpha Alpha value to be set.
     */ setColor4(uniformName, color3, alpha) {
        this.setFloat4(uniformName, color3.r, color3.g, color3.b, alpha);
    }
    /**
     * Sets a Color4 on a uniform variable
     * @param uniformName defines the name of the variable
     * @param color4 defines the value to be set
     */ setDirectColor4(uniformName, color4) {
        this.setFloat4(uniformName, color4.r, color4.g, color4.b, color4.a);
    }
    _getVertexShaderCode() {
        return this.sources?.vertex;
    }
    _getFragmentShaderCode() {
        return this.sources?.fragment;
    }
}

});
parcelRegister("jXMwB", function(module, exports) {

$parcel$export(module.exports, "WebGPUShaderProcessor", () => $e8892b06212737af$export$7fd2ef523aa2e166);
/* eslint-disable babylonjs/available */ /* eslint-disable jsdoc/require-jsdoc */ 
var $kVtWi = parcelRequire("kVtWi");

var $8WI3I = parcelRequire("8WI3I");

var $hR6HG = parcelRequire("hR6HG");
class $e8892b06212737af$export$7fd2ef523aa2e166 {
    constructor(){
        this.shaderLanguage = (0, $8WI3I.ShaderLanguage).GLSL;
        // this object is populated only with vertex kinds known by the engine (position, uv, ...) and only if the type of the corresponding vertex buffer is an integer type)
        // if the type is a signed type, the value is negated
        this.vertexBufferKindToNumberOfComponents = {};
    }
    _addUniformToLeftOverUBO(name, uniformType, preProcessors) {
        let length = 0;
        [name, uniformType, length] = this._getArraySize(name, uniformType, preProcessors);
        for(let i = 0; i < this._webgpuProcessingContext.leftOverUniforms.length; i++){
            if (this._webgpuProcessingContext.leftOverUniforms[i].name === name) return;
        }
        this._webgpuProcessingContext.leftOverUniforms.push({
            name: name,
            type: uniformType,
            length: length
        });
    }
    _buildLeftOverUBO() {
        if (!this._webgpuProcessingContext.leftOverUniforms.length) return "";
        const name = $e8892b06212737af$export$7fd2ef523aa2e166.LeftOvertUBOName;
        let availableUBO = this._webgpuProcessingContext.availableBuffers[name];
        if (!availableUBO) {
            availableUBO = {
                binding: this._webgpuProcessingContext.getNextFreeUBOBinding()
            };
            this._webgpuProcessingContext.availableBuffers[name] = availableUBO;
            this._addBufferBindingDescription(name, availableUBO, $hR6HG.BufferBindingType.Uniform, true);
            this._addBufferBindingDescription(name, availableUBO, $hR6HG.BufferBindingType.Uniform, false);
        }
        return this._generateLeftOverUBOCode(name, availableUBO);
    }
    _collectBindingNames() {
        // collect all the binding names for faster processing in WebGPUCacheBindGroup
        for(let i = 0; i < this._webgpuProcessingContext.bindGroupLayoutEntries.length; i++){
            const setDefinition = this._webgpuProcessingContext.bindGroupLayoutEntries[i];
            if (setDefinition === undefined) {
                this._webgpuProcessingContext.bindGroupLayoutEntries[i] = [];
                continue;
            }
            for(let j = 0; j < setDefinition.length; j++){
                const entry = this._webgpuProcessingContext.bindGroupLayoutEntries[i][j];
                const name = this._webgpuProcessingContext.bindGroupLayoutEntryInfo[i][entry.binding].name;
                const nameInArrayOfTexture = this._webgpuProcessingContext.bindGroupLayoutEntryInfo[i][entry.binding].nameInArrayOfTexture;
                if (entry) {
                    if (entry.texture || entry.externalTexture || entry.storageTexture) this._webgpuProcessingContext.textureNames.push(nameInArrayOfTexture);
                    else if (entry.sampler) this._webgpuProcessingContext.samplerNames.push(name);
                    else if (entry.buffer) this._webgpuProcessingContext.bufferNames.push(name);
                }
            }
        }
    }
    _preCreateBindGroupEntries() {
        const bindGroupEntries = this._webgpuProcessingContext.bindGroupEntries;
        for(let i = 0; i < this._webgpuProcessingContext.bindGroupLayoutEntries.length; i++){
            const setDefinition = this._webgpuProcessingContext.bindGroupLayoutEntries[i];
            const entries = [];
            for(let j = 0; j < setDefinition.length; j++){
                const entry = this._webgpuProcessingContext.bindGroupLayoutEntries[i][j];
                if (entry.sampler || entry.texture || entry.storageTexture || entry.externalTexture) entries.push({
                    binding: entry.binding,
                    resource: undefined
                });
                else if (entry.buffer) entries.push({
                    binding: entry.binding,
                    resource: {
                        buffer: undefined,
                        offset: 0,
                        size: 0
                    }
                });
            }
            bindGroupEntries[i] = entries;
        }
    }
    _addTextureBindingDescription(name, textureInfo, textureIndex, dimension, format, isVertex) {
        // eslint-disable-next-line prefer-const
        let { groupIndex: groupIndex, bindingIndex: bindingIndex } = textureInfo.textures[textureIndex];
        if (!this._webgpuProcessingContext.bindGroupLayoutEntries[groupIndex]) {
            this._webgpuProcessingContext.bindGroupLayoutEntries[groupIndex] = [];
            this._webgpuProcessingContext.bindGroupLayoutEntryInfo[groupIndex] = [];
        }
        if (!this._webgpuProcessingContext.bindGroupLayoutEntryInfo[groupIndex][bindingIndex]) {
            let len;
            if (dimension === null) len = this._webgpuProcessingContext.bindGroupLayoutEntries[groupIndex].push({
                binding: bindingIndex,
                visibility: 0,
                externalTexture: {}
            });
            else if (format) len = this._webgpuProcessingContext.bindGroupLayoutEntries[groupIndex].push({
                binding: bindingIndex,
                visibility: 0,
                storageTexture: {
                    access: $hR6HG.StorageTextureAccess.WriteOnly,
                    format: format,
                    viewDimension: dimension
                }
            });
            else len = this._webgpuProcessingContext.bindGroupLayoutEntries[groupIndex].push({
                binding: bindingIndex,
                visibility: 0,
                texture: {
                    sampleType: textureInfo.sampleType,
                    viewDimension: dimension,
                    multisampled: false
                }
            });
            const textureName = textureInfo.isTextureArray ? name + textureIndex : name;
            this._webgpuProcessingContext.bindGroupLayoutEntryInfo[groupIndex][bindingIndex] = {
                name: name,
                index: len - 1,
                nameInArrayOfTexture: textureName
            };
        }
        bindingIndex = this._webgpuProcessingContext.bindGroupLayoutEntryInfo[groupIndex][bindingIndex].index;
        if (isVertex) this._webgpuProcessingContext.bindGroupLayoutEntries[groupIndex][bindingIndex].visibility |= $hR6HG.ShaderStage.Vertex;
        else this._webgpuProcessingContext.bindGroupLayoutEntries[groupIndex][bindingIndex].visibility |= $hR6HG.ShaderStage.Fragment;
    }
    _addSamplerBindingDescription(name, samplerInfo, isVertex) {
        // eslint-disable-next-line prefer-const
        let { groupIndex: groupIndex, bindingIndex: bindingIndex } = samplerInfo.binding;
        if (!this._webgpuProcessingContext.bindGroupLayoutEntries[groupIndex]) {
            this._webgpuProcessingContext.bindGroupLayoutEntries[groupIndex] = [];
            this._webgpuProcessingContext.bindGroupLayoutEntryInfo[groupIndex] = [];
        }
        if (!this._webgpuProcessingContext.bindGroupLayoutEntryInfo[groupIndex][bindingIndex]) {
            const len = this._webgpuProcessingContext.bindGroupLayoutEntries[groupIndex].push({
                binding: bindingIndex,
                visibility: 0,
                sampler: {
                    type: samplerInfo.type
                }
            });
            this._webgpuProcessingContext.bindGroupLayoutEntryInfo[groupIndex][bindingIndex] = {
                name: name,
                index: len - 1
            };
        }
        bindingIndex = this._webgpuProcessingContext.bindGroupLayoutEntryInfo[groupIndex][bindingIndex].index;
        if (isVertex) this._webgpuProcessingContext.bindGroupLayoutEntries[groupIndex][bindingIndex].visibility |= $hR6HG.ShaderStage.Vertex;
        else this._webgpuProcessingContext.bindGroupLayoutEntries[groupIndex][bindingIndex].visibility |= $hR6HG.ShaderStage.Fragment;
    }
    _addBufferBindingDescription(name, uniformBufferInfo, bufferType, isVertex) {
        // eslint-disable-next-line prefer-const
        let { groupIndex: groupIndex, bindingIndex: bindingIndex } = uniformBufferInfo.binding;
        if (!this._webgpuProcessingContext.bindGroupLayoutEntries[groupIndex]) {
            this._webgpuProcessingContext.bindGroupLayoutEntries[groupIndex] = [];
            this._webgpuProcessingContext.bindGroupLayoutEntryInfo[groupIndex] = [];
        }
        if (!this._webgpuProcessingContext.bindGroupLayoutEntryInfo[groupIndex][bindingIndex]) {
            const len = this._webgpuProcessingContext.bindGroupLayoutEntries[groupIndex].push({
                binding: bindingIndex,
                visibility: 0,
                buffer: {
                    type: bufferType
                }
            });
            this._webgpuProcessingContext.bindGroupLayoutEntryInfo[groupIndex][bindingIndex] = {
                name: name,
                index: len - 1
            };
        }
        bindingIndex = this._webgpuProcessingContext.bindGroupLayoutEntryInfo[groupIndex][bindingIndex].index;
        if (isVertex) this._webgpuProcessingContext.bindGroupLayoutEntries[groupIndex][bindingIndex].visibility |= $hR6HG.ShaderStage.Vertex;
        else this._webgpuProcessingContext.bindGroupLayoutEntries[groupIndex][bindingIndex].visibility |= $hR6HG.ShaderStage.Fragment;
    }
    _injectStartingAndEndingCode(code, mainFuncDecl, startingCode, endingCode) {
        let idx = code.indexOf(mainFuncDecl);
        if (idx < 0) {
            (0, $kVtWi.Logger).Error(`No "main" function found in shader code! Processing aborted.`);
            return code;
        }
        if (startingCode) {
            // eslint-disable-next-line no-empty
            while(idx++ < code.length && code.charAt(idx) != "{");
            if (idx < code.length) {
                const part1 = code.substring(0, idx + 1);
                const part2 = code.substring(idx + 1);
                code = part1 + startingCode + part2;
            }
        }
        if (endingCode) {
            const lastClosingCurly = code.lastIndexOf("}");
            code = code.substring(0, lastClosingCurly);
            code += endingCode + "\n}";
        }
        return code;
    }
}
$e8892b06212737af$export$7fd2ef523aa2e166.AutoSamplerSuffix = "Sampler";
$e8892b06212737af$export$7fd2ef523aa2e166.LeftOvertUBOName = "LeftOver";
$e8892b06212737af$export$7fd2ef523aa2e166.InternalsUBOName = "Internals";
$e8892b06212737af$export$7fd2ef523aa2e166.UniformSizes = {
    // GLSL types
    bool: 1,
    int: 1,
    float: 1,
    vec2: 2,
    ivec2: 2,
    uvec2: 2,
    vec3: 3,
    ivec3: 3,
    uvec3: 3,
    vec4: 4,
    ivec4: 4,
    uvec4: 4,
    mat2: 4,
    mat3: 12,
    mat4: 16,
    // WGSL types
    i32: 1,
    u32: 1,
    f32: 1,
    mat2x2: 4,
    mat3x3: 12,
    mat4x4: 16
};
// eslint-disable-next-line @typescript-eslint/naming-convention
$e8892b06212737af$export$7fd2ef523aa2e166._SamplerFunctionByWebGLSamplerType = {
    sampler2D: "sampler2D",
    sampler2DArray: "sampler2DArray",
    sampler2DShadow: "sampler2DShadow",
    sampler2DArrayShadow: "sampler2DArrayShadow",
    samplerCube: "samplerCube",
    sampler3D: "sampler3D"
};
// eslint-disable-next-line @typescript-eslint/naming-convention
$e8892b06212737af$export$7fd2ef523aa2e166._TextureTypeByWebGLSamplerType = {
    sampler2D: "texture2D",
    sampler2DArray: "texture2DArray",
    sampler2DShadow: "texture2D",
    sampler2DArrayShadow: "texture2DArray",
    samplerCube: "textureCube",
    samplerCubeArray: "textureCubeArray",
    sampler3D: "texture3D"
};
// eslint-disable-next-line @typescript-eslint/naming-convention
$e8892b06212737af$export$7fd2ef523aa2e166._GpuTextureViewDimensionByWebGPUTextureType = {
    textureCube: $hR6HG.TextureViewDimension.Cube,
    textureCubeArray: $hR6HG.TextureViewDimension.CubeArray,
    texture2D: $hR6HG.TextureViewDimension.E2d,
    texture2DArray: $hR6HG.TextureViewDimension.E2dArray,
    texture3D: $hR6HG.TextureViewDimension.E3d
};
// if the webgl sampler type is not listed in this array, "sampler" is taken by default
// eslint-disable-next-line @typescript-eslint/naming-convention
$e8892b06212737af$export$7fd2ef523aa2e166._SamplerTypeByWebGLSamplerType = {
    sampler2DShadow: "samplerShadow",
    sampler2DArrayShadow: "samplerShadow"
};
// eslint-disable-next-line @typescript-eslint/naming-convention
$e8892b06212737af$export$7fd2ef523aa2e166._IsComparisonSamplerByWebGPUSamplerType = {
    samplerShadow: true,
    samplerArrayShadow: true,
    sampler: false
};

});


parcelRegister("8rh4q", function(module, exports) {

$parcel$export(module.exports, "WebGPUShaderProcessorGLSL", () => $624e16285def9bde$export$20740960a83e3567);

var $g5vsw = parcelRequire("g5vsw");

var $hR6HG = parcelRequire("hR6HG");

var $kVtWi = parcelRequire("kVtWi");

var $jXMwB = parcelRequire("jXMwB");

var $8WI3I = parcelRequire("8WI3I");
class $624e16285def9bde$export$20740960a83e3567 extends (0, $jXMwB.WebGPUShaderProcessor) {
    constructor(){
        super(...arguments);
        this._missingVaryings = [];
        this._textureArrayProcessing = [];
        this._vertexIsGLES3 = false;
        this._fragmentIsGLES3 = false;
        this.shaderLanguage = (0, $8WI3I.ShaderLanguage).GLSL;
        this.parseGLES3 = true;
    }
    _getArraySize(name, type, preProcessors) {
        let length = 0;
        const startArray = name.indexOf("[");
        const endArray = name.indexOf("]");
        if (startArray > 0 && endArray > 0) {
            const lengthInString = name.substring(startArray + 1, endArray);
            length = +lengthInString;
            if (isNaN(length)) length = +preProcessors[lengthInString.trim()];
            name = name.substr(0, startArray);
        }
        return [
            name,
            type,
            length
        ];
    }
    initializeShaders(processingContext) {
        this._webgpuProcessingContext = processingContext;
        this._missingVaryings.length = 0;
        this._textureArrayProcessing.length = 0;
        this.attributeKeywordName = undefined;
        this.varyingVertexKeywordName = undefined;
        this.varyingFragmentKeywordName = undefined;
    }
    preProcessShaderCode(code, isFragment) {
        const ubDeclaration = `// Internals UBO\nuniform ${(0, $jXMwB.WebGPUShaderProcessor).InternalsUBOName} {\nfloat yFactor_;\nfloat textureOutputHeight_;\n};\n`;
        const alreadyInjected = code.indexOf("// Internals UBO") !== -1;
        if (isFragment) {
            this._fragmentIsGLES3 = code.indexOf("#version 3") !== -1;
            if (this._fragmentIsGLES3) this.varyingFragmentKeywordName = "in";
            return alreadyInjected ? code : ubDeclaration + "##INJECTCODE##\n" + code;
        }
        this._vertexIsGLES3 = code.indexOf("#version 3") !== -1;
        if (this._vertexIsGLES3) {
            this.attributeKeywordName = "in";
            this.varyingVertexKeywordName = "out";
        }
        return alreadyInjected ? code : ubDeclaration + code;
    }
    varyingCheck(varying, isFragment) {
        const outRegex = /(flat\s)?\s*\bout\b/;
        const inRegex = /(flat\s)?\s*\bin\b/;
        const varyingRegex = /(flat\s)?\s*\bvarying\b/;
        const regex = isFragment && this._fragmentIsGLES3 ? inRegex : !isFragment && this._vertexIsGLES3 ? outRegex : varyingRegex;
        return regex.test(varying);
    }
    varyingProcessor(varying, isFragment, preProcessors) {
        this._preProcessors = preProcessors;
        const outRegex = /\s*(flat)?\s*out\s+(?:(?:highp)?|(?:lowp)?)\s*(\S+)\s+(\S+)\s*;/gm;
        const inRegex = /\s*(flat)?\s*in\s+(?:(?:highp)?|(?:lowp)?)\s*(\S+)\s+(\S+)\s*;/gm;
        const varyingRegex = /\s*(flat)?\s*varying\s+(?:(?:highp)?|(?:lowp)?)\s*(\S+)\s+(\S+)\s*;/gm;
        const regex = isFragment && this._fragmentIsGLES3 ? inRegex : !isFragment && this._vertexIsGLES3 ? outRegex : varyingRegex;
        const match = regex.exec(varying);
        if (match !== null) {
            const interpolationQualifier = match[1] ?? "";
            const varyingType = match[2];
            const name = match[3];
            let location;
            if (isFragment) {
                location = this._webgpuProcessingContext.availableVaryings[name];
                this._missingVaryings[location] = "";
                if (location === undefined) (0, $kVtWi.Logger).Warn(`Invalid fragment shader: The varying named "${name}" is not declared in the vertex shader! This declaration will be ignored.`);
            } else {
                location = this._webgpuProcessingContext.getVaryingNextLocation(varyingType, this._getArraySize(name, varyingType, preProcessors)[2]);
                this._webgpuProcessingContext.availableVaryings[name] = location;
                this._missingVaryings[location] = `layout(location = ${location}) ${interpolationQualifier} in ${varyingType} ${name};`;
            }
            varying = varying.replace(match[0], location === undefined ? "" : `layout(location = ${location}) ${interpolationQualifier} ${isFragment ? "in" : "out"} ${varyingType} ${name};`);
        }
        return varying;
    }
    attributeProcessor(attribute, preProcessors) {
        this._preProcessors = preProcessors;
        const inRegex = /\s*in\s+(\S+)\s+(\S+)\s*;/gm;
        const attribRegex = /\s*attribute\s+(\S+)\s+(\S+)\s*;/gm;
        const regex = this._vertexIsGLES3 ? inRegex : attribRegex;
        const match = regex.exec(attribute);
        if (match !== null) {
            const attributeType = match[1];
            const name = match[2];
            const location = this._webgpuProcessingContext.getAttributeNextLocation(attributeType, this._getArraySize(name, attributeType, preProcessors)[2]);
            this._webgpuProcessingContext.availableAttributes[name] = location;
            this._webgpuProcessingContext.orderedAttributes[location] = name;
            const numComponents = this.vertexBufferKindToNumberOfComponents[name];
            if (numComponents !== undefined) {
                // Special case for an int/ivecX vertex buffer that is used as a float/vecX attribute in the shader.
                const newType = numComponents < 0 ? numComponents === -1 ? "int" : "ivec" + -numComponents : numComponents === 1 ? "uint" : "uvec" + numComponents;
                const newName = `_int_${name}_`;
                attribute = attribute.replace(match[0], `layout(location = ${location}) in ${newType} ${newName}; ${attributeType} ${name} = ${attributeType}(${newName});`);
            } else attribute = attribute.replace(match[0], `layout(location = ${location}) in ${attributeType} ${name};`);
        }
        return attribute;
    }
    uniformProcessor(uniform, isFragment, preProcessors) {
        this._preProcessors = preProcessors;
        const uniformRegex = /\s*uniform\s+(?:(?:highp)?|(?:lowp)?)\s*(\S+)\s+(\S+)\s*;/gm;
        const match = uniformRegex.exec(uniform);
        if (match !== null) {
            let uniformType = match[1];
            let name = match[2];
            if (uniformType.indexOf("sampler") === 0 || uniformType.indexOf("sampler") === 1) {
                let arraySize = 0; // 0 means the texture is not declared as an array
                [name, uniformType, arraySize] = this._getArraySize(name, uniformType, preProcessors);
                let textureInfo = this._webgpuProcessingContext.availableTextures[name];
                if (!textureInfo) {
                    textureInfo = {
                        autoBindSampler: true,
                        isTextureArray: arraySize > 0,
                        isStorageTexture: false,
                        textures: [],
                        sampleType: $hR6HG.TextureSampleType.Float
                    };
                    for(let i = 0; i < (arraySize || 1); ++i)textureInfo.textures.push(this._webgpuProcessingContext.getNextFreeUBOBinding());
                }
                const samplerType = (0, $jXMwB.WebGPUShaderProcessor)._SamplerTypeByWebGLSamplerType[uniformType] ?? "sampler";
                const isComparisonSampler = !!(0, $jXMwB.WebGPUShaderProcessor)._IsComparisonSamplerByWebGPUSamplerType[samplerType];
                const samplerBindingType = isComparisonSampler ? $hR6HG.SamplerBindingType.Comparison : $hR6HG.SamplerBindingType.Filtering;
                const samplerName = name + (0, $jXMwB.WebGPUShaderProcessor).AutoSamplerSuffix;
                let samplerInfo = this._webgpuProcessingContext.availableSamplers[samplerName];
                if (!samplerInfo) samplerInfo = {
                    binding: this._webgpuProcessingContext.getNextFreeUBOBinding(),
                    type: samplerBindingType
                };
                const componentType = uniformType.charAt(0) === "u" ? "u" : uniformType.charAt(0) === "i" ? "i" : "";
                if (componentType) uniformType = uniformType.substr(1);
                const sampleType = isComparisonSampler ? $hR6HG.TextureSampleType.Depth : componentType === "u" ? $hR6HG.TextureSampleType.Uint : componentType === "i" ? $hR6HG.TextureSampleType.Sint : $hR6HG.TextureSampleType.Float;
                textureInfo.sampleType = sampleType;
                const isTextureArray = arraySize > 0;
                const samplerGroupIndex = samplerInfo.binding.groupIndex;
                const samplerBindingIndex = samplerInfo.binding.bindingIndex;
                const samplerFunction = (0, $jXMwB.WebGPUShaderProcessor)._SamplerFunctionByWebGLSamplerType[uniformType];
                const textureType = (0, $jXMwB.WebGPUShaderProcessor)._TextureTypeByWebGLSamplerType[uniformType];
                const textureDimension = (0, $jXMwB.WebGPUShaderProcessor)._GpuTextureViewDimensionByWebGPUTextureType[textureType];
                // Manage textures and samplers.
                if (!isTextureArray) {
                    arraySize = 1;
                    uniform = `layout(set = ${samplerGroupIndex}, binding = ${samplerBindingIndex}) uniform ${samplerType} ${samplerName};
                        layout(set = ${textureInfo.textures[0].groupIndex}, binding = ${textureInfo.textures[0].bindingIndex}) uniform ${componentType}${textureType} ${name}Texture;
                        #define ${name} ${componentType}${samplerFunction}(${name}Texture, ${samplerName})`;
                } else {
                    const layouts = [];
                    layouts.push(`layout(set = ${samplerGroupIndex}, binding = ${samplerBindingIndex}) uniform ${componentType}${samplerType} ${samplerName};`);
                    uniform = `\n`;
                    for(let i = 0; i < arraySize; ++i){
                        const textureSetIndex = textureInfo.textures[i].groupIndex;
                        const textureBindingIndex = textureInfo.textures[i].bindingIndex;
                        layouts.push(`layout(set = ${textureSetIndex}, binding = ${textureBindingIndex}) uniform ${textureType} ${name}Texture${i};`);
                        uniform += `${i > 0 ? "\n" : ""}#define ${name}${i} ${componentType}${samplerFunction}(${name}Texture${i}, ${samplerName})`;
                    }
                    uniform = layouts.join("\n") + uniform;
                    this._textureArrayProcessing.push(name);
                }
                this._webgpuProcessingContext.availableTextures[name] = textureInfo;
                this._webgpuProcessingContext.availableSamplers[samplerName] = samplerInfo;
                this._addSamplerBindingDescription(samplerName, samplerInfo, !isFragment);
                for(let i = 0; i < arraySize; ++i)this._addTextureBindingDescription(name, textureInfo, i, textureDimension, null, !isFragment);
            } else {
                this._addUniformToLeftOverUBO(name, uniformType, preProcessors);
                uniform = "";
            }
        }
        return uniform;
    }
    uniformBufferProcessor(uniformBuffer, isFragment) {
        const uboRegex = /uniform\s+(\w+)/gm;
        const match = uboRegex.exec(uniformBuffer);
        if (match !== null) {
            const name = match[1];
            let uniformBufferInfo = this._webgpuProcessingContext.availableBuffers[name];
            if (!uniformBufferInfo) {
                const knownUBO = (0, $g5vsw.WebGPUShaderProcessingContext).KnownUBOs[name];
                let binding;
                if (knownUBO && knownUBO.binding.groupIndex !== -1) binding = knownUBO.binding;
                else binding = this._webgpuProcessingContext.getNextFreeUBOBinding();
                uniformBufferInfo = {
                    binding: binding
                };
                this._webgpuProcessingContext.availableBuffers[name] = uniformBufferInfo;
            }
            this._addBufferBindingDescription(name, uniformBufferInfo, $hR6HG.BufferBindingType.Uniform, !isFragment);
            uniformBuffer = uniformBuffer.replace("uniform", `layout(set = ${uniformBufferInfo.binding.groupIndex}, binding = ${uniformBufferInfo.binding.bindingIndex}) uniform`);
        }
        return uniformBuffer;
    }
    postProcessor(code, defines, isFragment, processingContext, engine) {
        const hasDrawBuffersExtension = code.search(/#extension.+GL_EXT_draw_buffers.+require/) !== -1;
        // Remove extensions
        const regex = /#extension.+(GL_OVR_multiview2|GL_OES_standard_derivatives|GL_EXT_shader_texture_lod|GL_EXT_frag_depth|GL_EXT_draw_buffers).+(enable|require)/g;
        code = code.replace(regex, "");
        // Replace instructions
        code = code.replace(/texture2D\s*\(/g, "texture(");
        if (isFragment) {
            const hasFragCoord = code.indexOf("gl_FragCoord") >= 0;
            const fragCoordCode = `
                glFragCoord_ = gl_FragCoord;
                if (yFactor_ == 1.) {
                    glFragCoord_.y = textureOutputHeight_ - glFragCoord_.y;
                }
            `;
            const injectCode = hasFragCoord ? "vec4 glFragCoord_;\n" : "";
            const hasOutput = code.search(/layout *\(location *= *0\) *out/g) !== -1;
            code = code.replace(/texture2DLodEXT\s*\(/g, "textureLod(");
            code = code.replace(/textureCubeLodEXT\s*\(/g, "textureLod(");
            code = code.replace(/textureCube\s*\(/g, "texture(");
            code = code.replace(/gl_FragDepthEXT/g, "gl_FragDepth");
            code = code.replace(/gl_FragColor/g, "glFragColor");
            code = code.replace(/gl_FragData/g, "glFragData");
            code = code.replace(/gl_FragCoord/g, "glFragCoord_");
            if (!this._fragmentIsGLES3) code = code.replace(/void\s+?main\s*\(/g, (hasDrawBuffersExtension || hasOutput ? "" : "layout(location = 0) out vec4 glFragColor;\n") + "void main(");
            else {
                const match = /^\s*out\s+\S+\s+\S+\s*;/gm.exec(code);
                if (match !== null) code = code.substring(0, match.index) + "layout(location = 0) " + code.substring(match.index);
            }
            code = code.replace(/dFdy/g, "(-yFactor_)*dFdy"); // will also handle dFdyCoarse and dFdyFine
            code = code.replace("##INJECTCODE##", injectCode);
            if (hasFragCoord) code = this._injectStartingAndEndingCode(code, "void main", fragCoordCode);
        } else {
            code = code.replace(/gl_InstanceID/g, "gl_InstanceIndex");
            code = code.replace(/gl_VertexID/g, "gl_VertexIndex");
            const hasMultiviewExtension = defines.indexOf("#define MULTIVIEW") !== -1;
            if (hasMultiviewExtension) return "#extension GL_OVR_multiview2 : require\nlayout (num_views = 2) in;\n" + code;
        }
        // Flip Y + convert z range from [-1,1] to [0,1]
        if (!isFragment) {
            const lastClosingCurly = code.lastIndexOf("}");
            code = code.substring(0, lastClosingCurly);
            code += "gl_Position.y *= yFactor_;\n";
            if (!engine.isNDCHalfZRange) code += "gl_Position.z = (gl_Position.z + gl_Position.w) / 2.0;\n";
            code += "}";
        }
        return code;
    }
    _applyTextureArrayProcessing(code, name) {
        // Replaces the occurrences of name[XX] by nameXX
        const regex = new RegExp(name + "\\s*\\[(.+)?\\]", "gm");
        let match = regex.exec(code);
        while(match !== null){
            const index = match[1];
            let iindex = +index;
            if (this._preProcessors && isNaN(iindex)) iindex = +this._preProcessors[index.trim()];
            code = code.replace(match[0], name + iindex);
            match = regex.exec(code);
        }
        return code;
    }
    _generateLeftOverUBOCode(name, uniformBufferDescription) {
        let ubo = `layout(set = ${uniformBufferDescription.binding.groupIndex}, binding = ${uniformBufferDescription.binding.bindingIndex}) uniform ${name} {\n    `;
        for (const leftOverUniform of this._webgpuProcessingContext.leftOverUniforms)if (leftOverUniform.length > 0) ubo += `    ${leftOverUniform.type} ${leftOverUniform.name}[${leftOverUniform.length}];\n`;
        else ubo += `    ${leftOverUniform.type} ${leftOverUniform.name};\n`;
        ubo += "};\n\n";
        return ubo;
    }
    finalizeShaders(vertexCode, fragmentCode) {
        // make replacements for texture names in the texture array case
        for(let i = 0; i < this._textureArrayProcessing.length; ++i){
            const name = this._textureArrayProcessing[i];
            vertexCode = this._applyTextureArrayProcessing(vertexCode, name);
            fragmentCode = this._applyTextureArrayProcessing(fragmentCode, name);
        }
        // inject the missing varying in the fragment shader
        for(let i = 0; i < this._missingVaryings.length; ++i){
            const decl = this._missingVaryings[i];
            if (decl && decl.length > 0) fragmentCode = decl + "\n" + fragmentCode;
        }
        // Builds the leftover UBOs.
        const leftOverUBO = this._buildLeftOverUBO();
        vertexCode = leftOverUBO + vertexCode;
        fragmentCode = leftOverUBO + fragmentCode;
        this._collectBindingNames();
        this._preCreateBindGroupEntries();
        this._preProcessors = null;
        this.vertexBufferKindToNumberOfComponents = {};
        return {
            vertexCode: vertexCode,
            fragmentCode: fragmentCode
        };
    }
}

});
parcelRegister("g5vsw", function(module, exports) {

$parcel$export(module.exports, "WebGPUShaderProcessingContext", () => $bb65841a1b2cff68$export$a69e21efeda91967);
const $bb65841a1b2cff68$var$_maxGroups = 4;
const $bb65841a1b2cff68$var$_maxBindingsPerGroup = 65536;
// all types not listed are assumed to consume 1 location
const $bb65841a1b2cff68$var$_typeToLocationSize = {
    // GLSL types
    mat2: 2,
    mat3: 3,
    mat4: 4,
    // WGSL types
    mat2x2: 2,
    mat3x3: 3,
    mat4x4: 4
};
class $bb65841a1b2cff68$export$a69e21efeda91967 {
    static get KnownUBOs() {
        return $bb65841a1b2cff68$export$a69e21efeda91967._SimplifiedKnownBindings ? $bb65841a1b2cff68$export$a69e21efeda91967._SimplifiedKnownUBOs : $bb65841a1b2cff68$export$a69e21efeda91967._KnownUBOs;
    }
    constructor(shaderLanguage){
        this.shaderLanguage = shaderLanguage;
        this._attributeNextLocation = 0;
        this._varyingNextLocation = 0;
        this.freeGroupIndex = 0;
        this.freeBindingIndex = 0;
        this.availableVaryings = {};
        this.availableAttributes = {};
        this.availableBuffers = {};
        this.availableTextures = {};
        this.availableSamplers = {};
        this.orderedAttributes = [];
        this.bindGroupLayoutEntries = [];
        this.bindGroupLayoutEntryInfo = [];
        this.bindGroupEntries = [];
        this.bufferNames = [];
        this.textureNames = [];
        this.samplerNames = [];
        this.leftOverUniforms = [];
        this._findStartingGroupBinding();
    }
    _findStartingGroupBinding() {
        const knownUBOs = $bb65841a1b2cff68$export$a69e21efeda91967.KnownUBOs;
        const groups = [];
        for(const name in knownUBOs){
            const binding = knownUBOs[name].binding;
            if (binding.groupIndex === -1) continue;
            if (groups[binding.groupIndex] === undefined) groups[binding.groupIndex] = binding.bindingIndex;
            else groups[binding.groupIndex] = Math.max(groups[binding.groupIndex], binding.bindingIndex);
        }
        this.freeGroupIndex = groups.length - 1;
        if (this.freeGroupIndex === 0) {
            this.freeGroupIndex++;
            this.freeBindingIndex = 0;
        } else this.freeBindingIndex = groups[groups.length - 1] + 1;
    }
    getAttributeNextLocation(dataType, arrayLength = 0) {
        const index = this._attributeNextLocation;
        this._attributeNextLocation += ($bb65841a1b2cff68$var$_typeToLocationSize[dataType] ?? 1) * (arrayLength || 1);
        return index;
    }
    getVaryingNextLocation(dataType, arrayLength = 0) {
        const index = this._varyingNextLocation;
        this._varyingNextLocation += ($bb65841a1b2cff68$var$_typeToLocationSize[dataType] ?? 1) * (arrayLength || 1);
        return index;
    }
    getNextFreeUBOBinding() {
        return this._getNextFreeBinding(1);
    }
    _getNextFreeBinding(bindingCount) {
        if (this.freeBindingIndex > $bb65841a1b2cff68$var$_maxBindingsPerGroup - bindingCount) {
            this.freeGroupIndex++;
            this.freeBindingIndex = 0;
        }
        if (this.freeGroupIndex === $bb65841a1b2cff68$var$_maxGroups) // eslint-disable-next-line no-throw-literal
        throw "Too many textures or UBOs have been declared and it is not supported in WebGPU.";
        const returnValue = {
            groupIndex: this.freeGroupIndex,
            bindingIndex: this.freeBindingIndex
        };
        this.freeBindingIndex += bindingCount;
        return returnValue;
    }
}
/** @internal */ $bb65841a1b2cff68$export$a69e21efeda91967._SimplifiedKnownBindings = true; // if true, use only group=0,binding=0 as a known group/binding for the Scene ubo and use group=1,binding=X for all other bindings
// if false, see _KnownUBOs for the known groups/bindings used
$bb65841a1b2cff68$export$a69e21efeda91967._SimplifiedKnownUBOs = {
    Scene: {
        binding: {
            groupIndex: 0,
            bindingIndex: 0
        }
    },
    Light0: {
        binding: {
            groupIndex: -1,
            bindingIndex: -1
        }
    },
    Light1: {
        binding: {
            groupIndex: -1,
            bindingIndex: -1
        }
    },
    Light2: {
        binding: {
            groupIndex: -1,
            bindingIndex: -1
        }
    },
    Light3: {
        binding: {
            groupIndex: -1,
            bindingIndex: -1
        }
    },
    Light4: {
        binding: {
            groupIndex: -1,
            bindingIndex: -1
        }
    },
    Light5: {
        binding: {
            groupIndex: -1,
            bindingIndex: -1
        }
    },
    Light6: {
        binding: {
            groupIndex: -1,
            bindingIndex: -1
        }
    },
    Light7: {
        binding: {
            groupIndex: -1,
            bindingIndex: -1
        }
    },
    Light8: {
        binding: {
            groupIndex: -1,
            bindingIndex: -1
        }
    },
    Light9: {
        binding: {
            groupIndex: -1,
            bindingIndex: -1
        }
    },
    Light10: {
        binding: {
            groupIndex: -1,
            bindingIndex: -1
        }
    },
    Light11: {
        binding: {
            groupIndex: -1,
            bindingIndex: -1
        }
    },
    Light12: {
        binding: {
            groupIndex: -1,
            bindingIndex: -1
        }
    },
    Light13: {
        binding: {
            groupIndex: -1,
            bindingIndex: -1
        }
    },
    Light14: {
        binding: {
            groupIndex: -1,
            bindingIndex: -1
        }
    },
    Light15: {
        binding: {
            groupIndex: -1,
            bindingIndex: -1
        }
    },
    Light16: {
        binding: {
            groupIndex: -1,
            bindingIndex: -1
        }
    },
    Light17: {
        binding: {
            groupIndex: -1,
            bindingIndex: -1
        }
    },
    Light18: {
        binding: {
            groupIndex: -1,
            bindingIndex: -1
        }
    },
    Light19: {
        binding: {
            groupIndex: -1,
            bindingIndex: -1
        }
    },
    Light20: {
        binding: {
            groupIndex: -1,
            bindingIndex: -1
        }
    },
    Light21: {
        binding: {
            groupIndex: -1,
            bindingIndex: -1
        }
    },
    Light22: {
        binding: {
            groupIndex: -1,
            bindingIndex: -1
        }
    },
    Light23: {
        binding: {
            groupIndex: -1,
            bindingIndex: -1
        }
    },
    Light24: {
        binding: {
            groupIndex: -1,
            bindingIndex: -1
        }
    },
    Light25: {
        binding: {
            groupIndex: -1,
            bindingIndex: -1
        }
    },
    Light26: {
        binding: {
            groupIndex: -1,
            bindingIndex: -1
        }
    },
    Light27: {
        binding: {
            groupIndex: -1,
            bindingIndex: -1
        }
    },
    Light28: {
        binding: {
            groupIndex: -1,
            bindingIndex: -1
        }
    },
    Light29: {
        binding: {
            groupIndex: -1,
            bindingIndex: -1
        }
    },
    Light30: {
        binding: {
            groupIndex: -1,
            bindingIndex: -1
        }
    },
    Light31: {
        binding: {
            groupIndex: -1,
            bindingIndex: -1
        }
    },
    Material: {
        binding: {
            groupIndex: -1,
            bindingIndex: -1
        }
    },
    Mesh: {
        binding: {
            groupIndex: -1,
            bindingIndex: -1
        }
    },
    Internals: {
        binding: {
            groupIndex: -1,
            bindingIndex: -1
        }
    }
};
$bb65841a1b2cff68$export$a69e21efeda91967._KnownUBOs = {
    Scene: {
        binding: {
            groupIndex: 0,
            bindingIndex: 0
        }
    },
    Light0: {
        binding: {
            groupIndex: 1,
            bindingIndex: 0
        }
    },
    Light1: {
        binding: {
            groupIndex: 1,
            bindingIndex: 1
        }
    },
    Light2: {
        binding: {
            groupIndex: 1,
            bindingIndex: 2
        }
    },
    Light3: {
        binding: {
            groupIndex: 1,
            bindingIndex: 3
        }
    },
    Light4: {
        binding: {
            groupIndex: 1,
            bindingIndex: 4
        }
    },
    Light5: {
        binding: {
            groupIndex: 1,
            bindingIndex: 5
        }
    },
    Light6: {
        binding: {
            groupIndex: 1,
            bindingIndex: 6
        }
    },
    Light7: {
        binding: {
            groupIndex: 1,
            bindingIndex: 7
        }
    },
    Light8: {
        binding: {
            groupIndex: 1,
            bindingIndex: 8
        }
    },
    Light9: {
        binding: {
            groupIndex: 1,
            bindingIndex: 9
        }
    },
    Light10: {
        binding: {
            groupIndex: 1,
            bindingIndex: 10
        }
    },
    Light11: {
        binding: {
            groupIndex: 1,
            bindingIndex: 11
        }
    },
    Light12: {
        binding: {
            groupIndex: 1,
            bindingIndex: 12
        }
    },
    Light13: {
        binding: {
            groupIndex: 1,
            bindingIndex: 13
        }
    },
    Light14: {
        binding: {
            groupIndex: 1,
            bindingIndex: 14
        }
    },
    Light15: {
        binding: {
            groupIndex: 1,
            bindingIndex: 15
        }
    },
    Light16: {
        binding: {
            groupIndex: 1,
            bindingIndex: 16
        }
    },
    Light17: {
        binding: {
            groupIndex: 1,
            bindingIndex: 17
        }
    },
    Light18: {
        binding: {
            groupIndex: 1,
            bindingIndex: 18
        }
    },
    Light19: {
        binding: {
            groupIndex: 1,
            bindingIndex: 19
        }
    },
    Light20: {
        binding: {
            groupIndex: 1,
            bindingIndex: 20
        }
    },
    Light21: {
        binding: {
            groupIndex: 1,
            bindingIndex: 21
        }
    },
    Light22: {
        binding: {
            groupIndex: 1,
            bindingIndex: 22
        }
    },
    Light23: {
        binding: {
            groupIndex: 1,
            bindingIndex: 23
        }
    },
    Light24: {
        binding: {
            groupIndex: 1,
            bindingIndex: 24
        }
    },
    Light25: {
        binding: {
            groupIndex: 1,
            bindingIndex: 25
        }
    },
    Light26: {
        binding: {
            groupIndex: 1,
            bindingIndex: 26
        }
    },
    Light27: {
        binding: {
            groupIndex: 1,
            bindingIndex: 27
        }
    },
    Light28: {
        binding: {
            groupIndex: 1,
            bindingIndex: 28
        }
    },
    Light29: {
        binding: {
            groupIndex: 1,
            bindingIndex: 29
        }
    },
    Light30: {
        binding: {
            groupIndex: 1,
            bindingIndex: 30
        }
    },
    Light31: {
        binding: {
            groupIndex: 1,
            bindingIndex: 31
        }
    },
    Material: {
        binding: {
            groupIndex: 2,
            bindingIndex: 0
        }
    },
    Mesh: {
        binding: {
            groupIndex: 2,
            bindingIndex: 1
        }
    },
    Internals: {
        binding: {
            groupIndex: 2,
            bindingIndex: 2
        }
    }
};

});


parcelRegister("lJAHK", function(module, exports) {

$parcel$export(module.exports, "WebGPUShaderProcessorWGSL", () => $fd2a45b95d9171b0$export$ea849a46377ba48f);

var $g5vsw = parcelRequire("g5vsw");

var $hR6HG = parcelRequire("hR6HG");

var $kVtWi = parcelRequire("kVtWi");

var $jXMwB = parcelRequire("jXMwB");

var $kjb7H = parcelRequire("kjb7H");
parcelRequire("4DIZX");
parcelRequire("2dqm9");
parcelRequire("2aTYB");
parcelRequire("iEviM");
parcelRequire("dAsvp");
parcelRequire("jF33o");
parcelRequire("7KhrV");
parcelRequire("lOX6y");
parcelRequire("dbUUJ");
parcelRequire("hA838");
parcelRequire("6zaN7");
parcelRequire("5RNRI");
parcelRequire("41sCl");
parcelRequire("5Y5iW");
parcelRequire("cbn3S");
parcelRequire("kiX3E");

var $8WI3I = parcelRequire("8WI3I");
const $fd2a45b95d9171b0$var$builtInName_frag_depth = "fragmentOutputs.fragDepth";
const $fd2a45b95d9171b0$var$leftOverVarName = "uniforms";
const $fd2a45b95d9171b0$var$internalsVarName = "internals";
const $fd2a45b95d9171b0$var$gpuTextureViewDimensionByWebGPUTextureFunction = {
    texture_1d: $hR6HG.TextureViewDimension.E1d,
    texture_2d: $hR6HG.TextureViewDimension.E2d,
    texture_2d_array: $hR6HG.TextureViewDimension.E2dArray,
    texture_3d: $hR6HG.TextureViewDimension.E3d,
    texture_cube: $hR6HG.TextureViewDimension.Cube,
    texture_cube_array: $hR6HG.TextureViewDimension.CubeArray,
    texture_multisampled_2d: $hR6HG.TextureViewDimension.E2d,
    texture_depth_2d: $hR6HG.TextureViewDimension.E2d,
    texture_depth_2d_array: $hR6HG.TextureViewDimension.E2dArray,
    texture_depth_cube: $hR6HG.TextureViewDimension.Cube,
    texture_depth_cube_array: $hR6HG.TextureViewDimension.CubeArray,
    texture_depth_multisampled_2d: $hR6HG.TextureViewDimension.E2d,
    texture_storage_1d: $hR6HG.TextureViewDimension.E1d,
    texture_storage_2d: $hR6HG.TextureViewDimension.E2d,
    texture_storage_2d_array: $hR6HG.TextureViewDimension.E2dArray,
    texture_storage_3d: $hR6HG.TextureViewDimension.E3d,
    texture_external: null
};
class $fd2a45b95d9171b0$export$ea849a46377ba48f extends (0, $jXMwB.WebGPUShaderProcessor) {
    constructor(){
        super(...arguments);
        this.shaderLanguage = (0, $8WI3I.ShaderLanguage).WGSL;
        this.uniformRegexp = /uniform\s+(\w+)\s*:\s*(.+)\s*;/;
        this.textureRegexp = /var\s+(\w+)\s*:\s*((array<\s*)?(texture_\w+)\s*(<\s*(.+)\s*>)?\s*(,\s*\w+\s*>\s*)?);/;
        this.noPrecision = true;
    }
    _getArraySize(name, uniformType, preProcessors) {
        let length = 0;
        const endArray = uniformType.lastIndexOf(">");
        if (uniformType.indexOf("array") >= 0 && endArray > 0) {
            let startArray = endArray;
            while(startArray > 0 && uniformType.charAt(startArray) !== " " && uniformType.charAt(startArray) !== ",")startArray--;
            const lengthInString = uniformType.substring(startArray + 1, endArray);
            length = +lengthInString;
            if (isNaN(length)) length = +preProcessors[lengthInString.trim()];
            while(startArray > 0 && (uniformType.charAt(startArray) === " " || uniformType.charAt(startArray) === ","))startArray--;
            uniformType = uniformType.substring(uniformType.indexOf("<") + 1, startArray + 1);
        }
        return [
            name,
            uniformType,
            length
        ];
    }
    initializeShaders(processingContext) {
        this._webgpuProcessingContext = processingContext;
        this._attributesInputWGSL = [];
        this._attributesWGSL = [];
        this._attributesConversionCodeWGSL = [];
        this._hasNonFloatAttribute = false;
        this._varyingsWGSL = [];
        this._varyingNamesWGSL = [];
        this._stridedUniformArrays = [];
    }
    preProcessShaderCode(code) {
        // Same check as in webgpuShaderProcessorsGLSL to avoid same ubDelcaration to be injected twice.
        const ubDeclaration = `struct ${(0, $jXMwB.WebGPUShaderProcessor).InternalsUBOName} {\n  yFactor_: f32,\n  textureOutputHeight_: f32,\n};\nvar<uniform> ${$fd2a45b95d9171b0$var$internalsVarName} : ${(0, $jXMwB.WebGPUShaderProcessor).InternalsUBOName};\n`;
        const alreadyInjected = code.indexOf(ubDeclaration) !== -1;
        return alreadyInjected ? code : ubDeclaration + (0, $kjb7H.RemoveComments)(code);
    }
    varyingProcessor(varying, isFragment, preProcessors) {
        const varyingRegex = /\s*(flat|linear|perspective)?\s*(center|centroid|sample)?\s*varying\s+(?:(?:highp)?|(?:lowp)?)\s*(\S+)\s*:\s*(.+)\s*;/gm;
        const match = varyingRegex.exec(varying);
        if (match !== null) {
            const interpolationType = match[1] ?? "perspective";
            const interpolationSampling = match[2] ?? "center";
            const varyingType = match[4];
            const name = match[3];
            let location;
            if (isFragment) {
                location = this._webgpuProcessingContext.availableVaryings[name];
                if (location === undefined) (0, $kVtWi.Logger).Warn(`Invalid fragment shader: The varying named "${name}" is not declared in the vertex shader! This declaration will be ignored.`);
            } else {
                location = this._webgpuProcessingContext.getVaryingNextLocation(varyingType, this._getArraySize(name, varyingType, preProcessors)[2]);
                this._webgpuProcessingContext.availableVaryings[name] = location;
                this._varyingsWGSL.push(`  @location(${location}) @interpolate(${interpolationType}, ${interpolationSampling}) ${name} : ${varyingType},`);
                this._varyingNamesWGSL.push(name);
            }
            varying = "";
        }
        return varying;
    }
    attributeProcessor(attribute, preProcessors) {
        const attribRegex = /\s*attribute\s+(\S+)\s*:\s*(.+)\s*;/gm;
        const match = attribRegex.exec(attribute);
        if (match !== null) {
            const attributeType = match[2];
            const name = match[1];
            const location = this._webgpuProcessingContext.getAttributeNextLocation(attributeType, this._getArraySize(name, attributeType, preProcessors)[2]);
            this._webgpuProcessingContext.availableAttributes[name] = location;
            this._webgpuProcessingContext.orderedAttributes[location] = name;
            const numComponents = this.vertexBufferKindToNumberOfComponents[name];
            if (numComponents !== undefined) {
                // Special case for an int/ivecX vertex buffer that is used as a float/vecX attribute in the shader.
                const newType = numComponents < 0 ? numComponents === -1 ? "i32" : "vec" + -numComponents + "<i32>" : numComponents === 1 ? "u32" : "vec" + numComponents + "<u32>";
                const newName = `_int_${name}_`;
                this._attributesInputWGSL.push(`@location(${location}) ${newName} : ${newType},`);
                this._attributesWGSL.push(`${name} : ${attributeType},`);
                this._attributesConversionCodeWGSL.push(`vertexInputs.${name} = ${attributeType}(vertexInputs_.${newName});`);
                this._hasNonFloatAttribute = true;
            } else {
                this._attributesInputWGSL.push(`@location(${location}) ${name} : ${attributeType},`);
                this._attributesWGSL.push(`${name} : ${attributeType},`);
                this._attributesConversionCodeWGSL.push(`vertexInputs.${name} = vertexInputs_.${name};`);
            }
            attribute = "";
        }
        return attribute;
    }
    uniformProcessor(uniform, isFragment, preProcessors) {
        const match = this.uniformRegexp.exec(uniform);
        if (match !== null) {
            const uniformType = match[2];
            const name = match[1];
            this._addUniformToLeftOverUBO(name, uniformType, preProcessors);
            uniform = "";
        }
        return uniform;
    }
    textureProcessor(texture, isFragment, preProcessors) {
        const match = this.textureRegexp.exec(texture);
        if (match !== null) {
            const name = match[1]; // name of the variable
            const type = match[2]; // texture_2d<f32> or array<texture_2d_array<f32>, 5> for eg
            const isArrayOfTexture = !!match[3];
            const textureFunc = match[4]; // texture_2d, texture_depth_2d, etc
            const isStorageTexture = textureFunc.indexOf("storage") > 0;
            const componentType = match[6]; // f32 or i32 or u32 or undefined
            const storageTextureFormat = isStorageTexture ? componentType.substring(0, componentType.indexOf(",")).trim() : null;
            let arraySize = isArrayOfTexture ? this._getArraySize(name, type, preProcessors)[2] : 0;
            let textureInfo = this._webgpuProcessingContext.availableTextures[name];
            if (!textureInfo) {
                textureInfo = {
                    isTextureArray: arraySize > 0,
                    isStorageTexture: isStorageTexture,
                    textures: [],
                    sampleType: $hR6HG.TextureSampleType.Float
                };
                arraySize = arraySize || 1;
                for(let i = 0; i < arraySize; ++i)textureInfo.textures.push(this._webgpuProcessingContext.getNextFreeUBOBinding());
            } else arraySize = textureInfo.textures.length;
            this._webgpuProcessingContext.availableTextures[name] = textureInfo;
            const isDepthTexture = textureFunc.indexOf("depth") > 0;
            const textureDimension = $fd2a45b95d9171b0$var$gpuTextureViewDimensionByWebGPUTextureFunction[textureFunc];
            const sampleType = isDepthTexture ? $hR6HG.TextureSampleType.Depth : componentType === "u32" ? $hR6HG.TextureSampleType.Uint : componentType === "i32" ? $hR6HG.TextureSampleType.Sint : $hR6HG.TextureSampleType.Float;
            textureInfo.sampleType = sampleType;
            if (textureDimension === undefined) // eslint-disable-next-line no-throw-literal
            throw `Can't get the texture dimension corresponding to the texture function "${textureFunc}"!`;
            for(let i = 0; i < arraySize; ++i){
                const { groupIndex: groupIndex, bindingIndex: bindingIndex } = textureInfo.textures[i];
                if (i === 0) texture = `@group(${groupIndex}) @binding(${bindingIndex}) ${texture}`;
                this._addTextureBindingDescription(name, textureInfo, i, textureDimension, storageTextureFormat, !isFragment);
            }
        }
        return texture;
    }
    postProcessor(code, defines) {
        const defineToValue = {};
        for (const define of defines){
            const parts = define.split(/ +/);
            defineToValue[parts[1]] = parts.length > 2 ? parts[2] : "";
        }
        return code.replace(/\$(\w+)\$/g, (_, p1)=>{
            return defineToValue[p1] ?? p1;
        });
    }
    finalizeShaders(vertexCode, fragmentCode) {
        const fragCoordCode = fragmentCode.indexOf("fragmentInputs.position") >= 0 ? `
            if (internals.yFactor_ == 1.) {
                fragmentInputs.position.y = internals.textureOutputHeight_ - fragmentInputs.position.y;
            }
        ` : "";
        // Add the group/binding info to the sampler declaration (var xxx: sampler|sampler_comparison)
        vertexCode = this._processSamplers(vertexCode, true);
        fragmentCode = this._processSamplers(fragmentCode, false);
        // Add the group/binding info to the uniform/storage buffer declarations (var<uniform> XXX:YYY or var<storage(,read_write|read)> XXX:YYY)
        vertexCode = this._processCustomBuffers(vertexCode, true);
        fragmentCode = this._processCustomBuffers(fragmentCode, false);
        // Builds the leftover UBOs.
        const leftOverUBO = this._buildLeftOverUBO();
        vertexCode = leftOverUBO + vertexCode;
        fragmentCode = leftOverUBO + fragmentCode;
        // Vertex code
        vertexCode = vertexCode.replace(/#define /g, "//#define ");
        vertexCode = this._processStridedUniformArrays(vertexCode);
        let vertexInputs = "struct VertexInputs {\n  @builtin(vertex_index) vertexIndex : u32,\n  @builtin(instance_index) instanceIndex : u32,\n";
        if (this._attributesInputWGSL.length > 0) vertexInputs += this._attributesInputWGSL.join("\n");
        vertexInputs += "\n};\nvar<private> vertexInputs" + (this._hasNonFloatAttribute ? "_" : "") + " : VertexInputs;\n";
        if (this._hasNonFloatAttribute) {
            vertexInputs += "struct VertexInputs_ {\n  vertexIndex : u32, instanceIndex : u32,\n";
            vertexInputs += this._attributesWGSL.join("\n");
            vertexInputs += "\n};\nvar<private> vertexInputs : VertexInputs_;\n";
        }
        let vertexOutputs = "struct FragmentInputs {\n  @builtin(position) position : vec4<f32>,\n";
        if (this._varyingsWGSL.length > 0) vertexOutputs += this._varyingsWGSL.join("\n");
        vertexOutputs += "\n};\nvar<private> vertexOutputs : FragmentInputs;\n";
        vertexCode = vertexInputs + vertexOutputs + vertexCode;
        let vertexMainStartingCode = `\n  vertexInputs${this._hasNonFloatAttribute ? "_" : ""} = input;\n`;
        if (this._hasNonFloatAttribute) {
            vertexMainStartingCode += "vertexInputs.vertexIndex = vertexInputs_.vertexIndex;\nvertexInputs.instanceIndex = vertexInputs_.instanceIndex;\n";
            vertexMainStartingCode += this._attributesConversionCodeWGSL.join("\n");
            vertexMainStartingCode += "\n";
        }
        const vertexMainEndingCode = `  vertexOutputs.position.y = vertexOutputs.position.y * internals.yFactor_;\n  return vertexOutputs;`;
        vertexCode = this._injectStartingAndEndingCode(vertexCode, "fn main", vertexMainStartingCode, vertexMainEndingCode);
        // fragment code
        fragmentCode = fragmentCode.replace(/#define /g, "//#define ");
        fragmentCode = this._processStridedUniformArrays(fragmentCode);
        fragmentCode = fragmentCode.replace(/dpdy/g, "(-internals.yFactor_)*dpdy"); // will also handle dpdyCoarse and dpdyFine
        let fragmentInputs = "struct FragmentInputs {\n  @builtin(position) position : vec4<f32>,\n  @builtin(front_facing) frontFacing : bool,\n";
        if (this._varyingsWGSL.length > 0) fragmentInputs += this._varyingsWGSL.join("\n");
        fragmentInputs += "\n};\nvar<private> fragmentInputs : FragmentInputs;\n";
        let fragmentOutputs = "struct FragmentOutputs {\n  @location(0) color : vec4<f32>,\n";
        let hasFragDepth = false;
        let idx = 0;
        while(!hasFragDepth){
            idx = fragmentCode.indexOf($fd2a45b95d9171b0$var$builtInName_frag_depth, idx);
            if (idx < 0) break;
            const saveIndex = idx;
            hasFragDepth = true;
            while(idx > 1 && fragmentCode.charAt(idx) !== "\n"){
                if (fragmentCode.charAt(idx) === "/" && fragmentCode.charAt(idx - 1) === "/") {
                    hasFragDepth = false;
                    break;
                }
                idx--;
            }
            idx = saveIndex + $fd2a45b95d9171b0$var$builtInName_frag_depth.length;
        }
        if (hasFragDepth) fragmentOutputs += "  @builtin(frag_depth) fragDepth: f32,\n";
        fragmentOutputs += "};\nvar<private> fragmentOutputs : FragmentOutputs;\n";
        fragmentCode = fragmentInputs + fragmentOutputs + fragmentCode;
        const fragmentStartingCode = "  fragmentInputs = input;\n  " + fragCoordCode;
        const fragmentEndingCode = "  return fragmentOutputs;";
        fragmentCode = this._injectStartingAndEndingCode(fragmentCode, "fn main", fragmentStartingCode, fragmentEndingCode);
        this._collectBindingNames();
        this._preCreateBindGroupEntries();
        this.vertexBufferKindToNumberOfComponents = {};
        return {
            vertexCode: vertexCode,
            fragmentCode: fragmentCode
        };
    }
    _generateLeftOverUBOCode(name, uniformBufferDescription) {
        let stridedArrays = "";
        let ubo = `struct ${name} {\n`;
        for (const leftOverUniform of this._webgpuProcessingContext.leftOverUniforms){
            const type = leftOverUniform.type.replace(/^(.*?)(<.*>)?$/, "$1");
            const size = (0, $jXMwB.WebGPUShaderProcessor).UniformSizes[type];
            if (leftOverUniform.length > 0) {
                if (size <= 2) {
                    const stridedArrayType = `${name}_${this._stridedUniformArrays.length}_strided_arr`;
                    stridedArrays += `struct ${stridedArrayType} {
                        @size(16)
                        el: ${type},
                    }`;
                    this._stridedUniformArrays.push(leftOverUniform.name);
                    ubo += ` @align(16) ${leftOverUniform.name} : array<${stridedArrayType}, ${leftOverUniform.length}>,\n`;
                } else ubo += ` ${leftOverUniform.name} : array<${leftOverUniform.type}, ${leftOverUniform.length}>,\n`;
            } else ubo += `  ${leftOverUniform.name} : ${leftOverUniform.type},\n`;
        }
        ubo += "};\n";
        ubo = `${stridedArrays}\n${ubo}`;
        ubo += `@group(${uniformBufferDescription.binding.groupIndex}) @binding(${uniformBufferDescription.binding.bindingIndex}) var<uniform> ${$fd2a45b95d9171b0$var$leftOverVarName} : ${name};\n`;
        return ubo;
    }
    _processSamplers(code, isVertex) {
        const samplerRegexp = /var\s+(\w+Sampler)\s*:\s*(sampler|sampler_comparison)\s*;/gm;
        // eslint-disable-next-line no-constant-condition
        while(true){
            const match = samplerRegexp.exec(code);
            if (match === null) break;
            const name = match[1]; // name of the variable
            const samplerType = match[2]; // sampler or sampler_comparison
            const textureName = name.indexOf((0, $jXMwB.WebGPUShaderProcessor).AutoSamplerSuffix) === name.length - (0, $jXMwB.WebGPUShaderProcessor).AutoSamplerSuffix.length ? name.substring(0, name.indexOf((0, $jXMwB.WebGPUShaderProcessor).AutoSamplerSuffix)) : null;
            const samplerBindingType = samplerType === "sampler_comparison" ? $hR6HG.SamplerBindingType.Comparison : $hR6HG.SamplerBindingType.Filtering;
            if (textureName) {
                const textureInfo = this._webgpuProcessingContext.availableTextures[textureName];
                if (textureInfo) textureInfo.autoBindSampler = true;
            }
            let samplerInfo = this._webgpuProcessingContext.availableSamplers[name];
            if (!samplerInfo) {
                samplerInfo = {
                    binding: this._webgpuProcessingContext.getNextFreeUBOBinding(),
                    type: samplerBindingType
                };
                this._webgpuProcessingContext.availableSamplers[name] = samplerInfo;
            }
            this._addSamplerBindingDescription(name, samplerInfo, isVertex);
            const part1 = code.substring(0, match.index);
            const insertPart = `@group(${samplerInfo.binding.groupIndex}) @binding(${samplerInfo.binding.bindingIndex}) `;
            const part2 = code.substring(match.index);
            code = part1 + insertPart + part2;
            samplerRegexp.lastIndex += insertPart.length;
        }
        return code;
    }
    _processCustomBuffers(code, isVertex) {
        const instantiateBufferRegexp = /var<\s*(uniform|storage)\s*(,\s*(read|read_write)\s*)?>\s+(\S+)\s*:\s*(\S+)\s*;/gm;
        // eslint-disable-next-line no-constant-condition
        while(true){
            const match = instantiateBufferRegexp.exec(code);
            if (match === null) break;
            const type = match[1];
            const decoration = match[3];
            let name = match[4];
            const structName = match[5];
            let bufferInfo = this._webgpuProcessingContext.availableBuffers[name];
            if (!bufferInfo) {
                const knownUBO = type === "uniform" ? (0, $g5vsw.WebGPUShaderProcessingContext).KnownUBOs[structName] : null;
                let binding;
                if (knownUBO) {
                    name = structName;
                    binding = knownUBO.binding;
                    if (binding.groupIndex === -1) binding = this._webgpuProcessingContext.getNextFreeUBOBinding();
                } else binding = this._webgpuProcessingContext.getNextFreeUBOBinding();
                bufferInfo = {
                    binding: binding
                };
                this._webgpuProcessingContext.availableBuffers[name] = bufferInfo;
            }
            this._addBufferBindingDescription(name, this._webgpuProcessingContext.availableBuffers[name], decoration === "read_write" ? $hR6HG.BufferBindingType.Storage : type === "storage" ? $hR6HG.BufferBindingType.ReadOnlyStorage : $hR6HG.BufferBindingType.Uniform, isVertex);
            const groupIndex = bufferInfo.binding.groupIndex;
            const bindingIndex = bufferInfo.binding.bindingIndex;
            const part1 = code.substring(0, match.index);
            const insertPart = `@group(${groupIndex}) @binding(${bindingIndex}) `;
            const part2 = code.substring(match.index);
            code = part1 + insertPart + part2;
            instantiateBufferRegexp.lastIndex += insertPart.length;
        }
        return code;
    }
    _processStridedUniformArrays(code) {
        for (const uniformArrayName of this._stridedUniformArrays)code = code.replace(new RegExp(`${uniformArrayName}\\s*\\[(.*)\\]`, "g"), `${uniformArrayName}[$1].el`);
        return code;
    }
}

});
parcelRegister("4DIZX", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $360db5ac60efdfce$var$name = "bonesDeclaration";
const $360db5ac60efdfce$var$shader = `#if NUM_BONE_INFLUENCERS>0
attribute matricesIndices : vec4<f32>;attribute matricesWeights : vec4<f32>;
#if NUM_BONE_INFLUENCERS>4
attribute matricesIndicesExtra : vec4<f32>;attribute matricesWeightsExtra : vec4<f32>;
#endif
#ifndef BAKED_VERTEX_ANIMATION_TEXTURE
#ifdef BONETEXTURE
var boneSampler : texture_2d<f32>;uniform boneTextureWidth : f32;
#else
uniform mBones : array<mat4x4,BonesPerMesh>;
#ifdef BONES_VELOCITY_ENABLED
uniform mPreviousBones : array<mat4x4,BonesPerMesh>;
#endif
#endif
#ifdef BONETEXTURE
fn readMatrixFromRawSampler(smp : texture_2d<f32>,index : f32)->mat4x4<f32>
{let offset=i32(index) *4; 
let m0=textureLoad(smp,vec2<i32>(offset+0,0),0);let m1=textureLoad(smp,vec2<i32>(offset+1,0),0);let m2=textureLoad(smp,vec2<i32>(offset+2,0),0);let m3=textureLoad(smp,vec2<i32>(offset+3,0),0);return mat4x4<f32>(m0,m1,m2,m3);}
#endif
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStoreWGSL[$360db5ac60efdfce$var$name] = $360db5ac60efdfce$var$shader;
const $360db5ac60efdfce$export$d4e06f9ec8a1a3b9 = {
    name: $360db5ac60efdfce$var$name,
    shader: $360db5ac60efdfce$var$shader
};

});

parcelRegister("2dqm9", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $19d13d73f5ee3205$var$name = "bonesVertex";
const $19d13d73f5ee3205$var$shader = `#ifndef BAKED_VERTEX_ANIMATION_TEXTURE
#if NUM_BONE_INFLUENCERS>0
var influence : mat4x4<f32>;
#ifdef BONETEXTURE
influence=readMatrixFromRawSampler(boneSampler,vertexInputs.matricesIndices[0])*vertexInputs.matricesWeights[0];
#if NUM_BONE_INFLUENCERS>1
influence=influence+readMatrixFromRawSampler(boneSampler,vertexInputs.matricesIndices[1])*vertexInputs.matricesWeights[1];
#endif 
#if NUM_BONE_INFLUENCERS>2
influence=influence+readMatrixFromRawSampler(boneSampler,vertexInputs.matricesIndices[2])*vertexInputs.matricesWeights[2];
#endif 
#if NUM_BONE_INFLUENCERS>3
influence=influence+readMatrixFromRawSampler(boneSampler,vertexInputs.matricesIndices[3])*vertexInputs.matricesWeights[3];
#endif 
#if NUM_BONE_INFLUENCERS>4
influence=influence+readMatrixFromRawSampler(boneSampler,vertexInputs.matricesIndicesExtra[0])*vertexInputs.matricesWeightsExtra[0];
#endif 
#if NUM_BONE_INFLUENCERS>5
influence=influence+readMatrixFromRawSampler(boneSampler,vertexInputs.matricesIndicesExtra[1])*vertexInputs.matricesWeightsExtra[1];
#endif 
#if NUM_BONE_INFLUENCERS>6
influence=influence+readMatrixFromRawSampler(boneSampler,vertexInputs.matricesIndicesExtra[2])*vertexInputs.matricesWeightsExtra[2];
#endif 
#if NUM_BONE_INFLUENCERS>7
influence=influence+readMatrixFromRawSampler(boneSampler,vertexInputs.matricesIndicesExtra[3])*vertexInputs.matricesWeightsExtra[3];
#endif 
#else 
influence=uniforms.mBones[int(vertexInputs.matricesIndices[0])]*vertexInputs.matricesWeights[0];
#if NUM_BONE_INFLUENCERS>1
influence=influence+uniforms.mBones[int(vertexInputs.matricesIndices[1])]*vertexInputs.matricesWeights[1];
#endif 
#if NUM_BONE_INFLUENCERS>2
influence=influence+uniforms.mBones[int(vertexInputs.matricesIndices[2])]*vertexInputs.matricesWeights[2];
#endif 
#if NUM_BONE_INFLUENCERS>3
influence=influence+uniforms.mBones[int(vertexInputs.matricesIndices[3])]*vertexInputs.matricesWeights[3];
#endif 
#if NUM_BONE_INFLUENCERS>4
influence=influence+uniforms.mBones[int(vertexInputs.matricesIndicesExtra[0])]*vertexInputs.matricesWeightsExtra[0];
#endif 
#if NUM_BONE_INFLUENCERS>5
influence=influence+uniforms.mBones[int(vertexInputs.matricesIndicesExtra[1])]*vertexInputs.matricesWeightsExtra[1];
#endif 
#if NUM_BONE_INFLUENCERS>6
influence=influence+uniforms.mBones[int(vertexInputs.matricesIndicesExtra[2])]*vertexInputs.matricesWeightsExtra[2];
#endif 
#if NUM_BONE_INFLUENCERS>7
influence=influence+uniforms.mBones[int(vertexInputs.matricesIndicesExtra[3])]*vertexInputs.matricesWeightsExtra[3];
#endif 
#endif
finalWorld=finalWorld*influence;
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStoreWGSL[$19d13d73f5ee3205$var$name] = $19d13d73f5ee3205$var$shader;
const $19d13d73f5ee3205$export$e7045d19c7a271ba = {
    name: $19d13d73f5ee3205$var$name,
    shader: $19d13d73f5ee3205$var$shader
};

});

parcelRegister("2aTYB", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $1957efae42201e21$var$name = "bakedVertexAnimationDeclaration";
const $1957efae42201e21$var$shader = `#ifdef BAKED_VERTEX_ANIMATION_TEXTURE
uniform bakedVertexAnimationTime: f32;uniform bakedVertexAnimationTextureSizeInverted: vec2<f32>;uniform bakedVertexAnimationSettings: vec4<f32>;var bakedVertexAnimationTexture : texture_2d<f32>;
#ifdef INSTANCES
attribute bakedVertexAnimationSettingsInstanced : vec4<f32>;
#endif
fn readMatrixFromRawSamplerVAT(smp : texture_2d<f32>,index : f32,frame : f32)->mat4x4<f32>
{let offset=i32(index)*4;let frameUV=i32(frame);let m0=textureLoad(smp,vec2<i32>(offset+0,frameUV),0);let m1=textureLoad(smp,vec2<i32>(offset+1,frameUV),0);let m2=textureLoad(smp,vec2<i32>(offset+2,frameUV),0);let m3=textureLoad(smp,vec2<i32>(offset+3,frameUV),0);return mat4x4<f32>(m0,m1,m2,m3);}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStoreWGSL[$1957efae42201e21$var$name] = $1957efae42201e21$var$shader;
const $1957efae42201e21$export$9942938b957c1c75 = {
    name: $1957efae42201e21$var$name,
    shader: $1957efae42201e21$var$shader
};

});

parcelRegister("iEviM", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $d9443e56267246e2$var$name = "bakedVertexAnimation";
const $d9443e56267246e2$var$shader = `#ifdef BAKED_VERTEX_ANIMATION_TEXTURE
{
#ifdef INSTANCES
let VATStartFrame: f32=vertexInputs.bakedVertexAnimationSettingsInstanced.x;let VATEndFrame: f32=vertexInputs.bakedVertexAnimationSettingsInstanced.y;let VATOffsetFrame: f32=vertexInputs.bakedVertexAnimationSettingsInstanced.z;let VATSpeed: f32=vertexInputs.bakedVertexAnimationSettingsInstanced.w;
#else
let VATStartFrame: f32=uniforms.bakedVertexAnimationSettings.x;let VATEndFrame: f32=uniforms.bakedVertexAnimationSettings.y;let VATOffsetFrame: f32=uniforms.bakedVertexAnimationSettings.z;let VATSpeed: f32=uniforms.bakedVertexAnimationSettings.w;
#endif
let totalFrames: f32=VATEndFrame-VATStartFrame+1.0;let time: f32=uniforms.bakedVertexAnimationTime*VATSpeed/totalFrames;let frameCorrection: f32=select(1.0,0.0,time<1.0);let numOfFrames: f32=totalFrames-frameCorrection;var VATFrameNum: f32=fract(time)*numOfFrames;VATFrameNum=(VATFrameNum+VATOffsetFrame) % numOfFrames;VATFrameNum=floor(VATFrameNum);VATFrameNum=VATFrameNum+VATStartFrame+frameCorrection;var VATInfluence : mat4x4<f32>;VATInfluence=readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,vertexInputs.matricesIndices[0],VATFrameNum)*vertexInputs.matricesWeights[0];
#if NUM_BONE_INFLUENCERS>1
VATInfluence=VATInfluence+readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,vertexInputs.matricesIndices[1],VATFrameNum)*vertexInputs.matricesWeights[1];
#endif
#if NUM_BONE_INFLUENCERS>2
VATInfluence=VATInfluence+readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,vertexInputs.matricesIndices[2],VATFrameNum)*vertexInputs.matricesWeights[2];
#endif
#if NUM_BONE_INFLUENCERS>3
VATInfluence=VATInfluence+readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,vertexInputs.matricesIndices[3],VATFrameNum)*vertexInputs.matricesWeights[3];
#endif
#if NUM_BONE_INFLUENCERS>4
VATInfluence=VATInfluence+readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,vertexInputs.matricesIndicesExtra[0],VATFrameNum)*vertexInputs.matricesWeightsExtra[0];
#endif
#if NUM_BONE_INFLUENCERS>5
VATInfluence=VATInfluence+readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,vertexInputs.matricesIndicesExtra[1],VATFrameNum)*vertexInputs.matricesWeightsExtra[1];
#endif
#if NUM_BONE_INFLUENCERS>6
VATInfluence=VATInfluence+readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,vertexInputs.matricesIndicesExtra[2],VATFrameNum)*vertexInputs.matricesWeightsExtra[2];
#endif
#if NUM_BONE_INFLUENCERS>7
VATInfluence=VATInfluence+readMatrixFromRawSamplerVAT(bakedVertexAnimationTexture,vertexInputs.matricesIndicesExtra[3],VATFrameNum)*vertexInputs.matricesWeightsExtra[3];
#endif
finalWorld=finalWorld*VATInfluence;}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStoreWGSL[$d9443e56267246e2$var$name] = $d9443e56267246e2$var$shader;
const $d9443e56267246e2$export$ea1166af1e79822a = {
    name: $d9443e56267246e2$var$name,
    shader: $d9443e56267246e2$var$shader
};

});

parcelRegister("dAsvp", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $9e44bfc3a513efdd$var$name = "clipPlaneFragment";
const $9e44bfc3a513efdd$var$shader = `#if defined(CLIPPLANE) || defined(CLIPPLANE2) || defined(CLIPPLANE3) || defined(CLIPPLANE4) || defined(CLIPPLANE5) || defined(CLIPPLANE6)
if (false) {}
#endif
#ifdef CLIPPLANE
else if (fragmentInputs.fClipDistance>0.0)
{discard;}
#endif
#ifdef CLIPPLANE2
else if (fragmentInputs.fClipDistance2>0.0)
{discard;}
#endif
#ifdef CLIPPLANE3
else if (fragmentInputs.fClipDistance3>0.0)
{discard;}
#endif
#ifdef CLIPPLANE4
else if (fragmentInputs.fClipDistance4>0.0)
{discard;}
#endif
#ifdef CLIPPLANE5
else if (fragmentInputs.fClipDistance5>0.0)
{discard;}
#endif
#ifdef CLIPPLANE6
else if (fragmentInputs.fClipDistance6>0.0)
{discard;}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStoreWGSL[$9e44bfc3a513efdd$var$name] = $9e44bfc3a513efdd$var$shader;
const $9e44bfc3a513efdd$export$6a64aed91bad4543 = {
    name: $9e44bfc3a513efdd$var$name,
    shader: $9e44bfc3a513efdd$var$shader
};

});

parcelRegister("jF33o", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $e5043715ad960c7a$var$name = "clipPlaneFragmentDeclaration";
const $e5043715ad960c7a$var$shader = `#ifdef CLIPPLANE
varying fClipDistance: f32;
#endif
#ifdef CLIPPLANE2
varying fClipDistance2: f32;
#endif
#ifdef CLIPPLANE3
varying fClipDistance3: f32;
#endif
#ifdef CLIPPLANE4
varying fClipDistance4: f32;
#endif
#ifdef CLIPPLANE5
varying fClipDistance5: f32;
#endif
#ifdef CLIPPLANE6
varying fClipDistance6: f32;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStoreWGSL[$e5043715ad960c7a$var$name] = $e5043715ad960c7a$var$shader;
const $e5043715ad960c7a$export$a7ada6d6747eac28 = {
    name: $e5043715ad960c7a$var$name,
    shader: $e5043715ad960c7a$var$shader
};

});

parcelRegister("7KhrV", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $5a3a5d61e24771b1$var$name = "clipPlaneVertex";
const $5a3a5d61e24771b1$var$shader = `#ifdef CLIPPLANE
vertexOutputs.fClipDistance=dot(worldPos,uniforms.vClipPlane);
#endif
#ifdef CLIPPLANE2
vertexOutputs.fClipDistance2=dot(worldPos,uniforms.vClipPlane2);
#endif
#ifdef CLIPPLANE3
vertexOutputs.fClipDistance3=dot(worldPos,uniforms.vClipPlane3);
#endif
#ifdef CLIPPLANE4
vertexOutputs.fClipDistance4=dot(worldPos,uniforms.vClipPlane4);
#endif
#ifdef CLIPPLANE5
vertexOutputs.fClipDistance5=dot(worldPos,uniforms.vClipPlane5);
#endif
#ifdef CLIPPLANE6
vertexOutputs.fClipDistance6=dot(worldPos,uniforms.vClipPlane6);
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStoreWGSL[$5a3a5d61e24771b1$var$name] = $5a3a5d61e24771b1$var$shader;
const $5a3a5d61e24771b1$export$c701d17f7fcd46e7 = {
    name: $5a3a5d61e24771b1$var$name,
    shader: $5a3a5d61e24771b1$var$shader
};

});

parcelRegister("lOX6y", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $fe2c1d6d770e5506$var$name = "clipPlaneVertexDeclaration";
const $fe2c1d6d770e5506$var$shader = `#ifdef CLIPPLANE
uniform vClipPlane: vec4<f32>;varying fClipDistance: f32;
#endif
#ifdef CLIPPLANE2
uniform vClipPlane2: vec4<f32>;varying fClipDistance2: f32;
#endif
#ifdef CLIPPLANE3
uniform vClipPlane3: vec4<f32>;varying fClipDistance3: f32;
#endif
#ifdef CLIPPLANE4
uniform vClipPlane4: vec4<f32>;varying fClipDistance4: f32;
#endif
#ifdef CLIPPLANE5
uniform vClipPlane5: vec4<f32>;varying fClipDistance5: f32;
#endif
#ifdef CLIPPLANE6
uniform vClipPlane6: vec4<f32>;varying fClipDistance6: f32;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStoreWGSL[$fe2c1d6d770e5506$var$name] = $fe2c1d6d770e5506$var$shader;
const $fe2c1d6d770e5506$export$61ce3e39b95f6070 = {
    name: $fe2c1d6d770e5506$var$name,
    shader: $fe2c1d6d770e5506$var$shader
};

});

parcelRegister("dbUUJ", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $027a757954d69746$var$name = "instancesDeclaration";
const $027a757954d69746$var$shader = `#ifdef INSTANCES
attribute world0 : vec4<f32>;attribute world1 : vec4<f32>;attribute world2 : vec4<f32>;attribute world3 : vec4<f32>;
#ifdef INSTANCESCOLOR
attribute instanceColor : vec4<f32>;
#endif
#if defined(THIN_INSTANCES) && !defined(WORLD_UBO)
uniform world : mat4x4<f32>;
#endif
#if defined(VELOCITY) || defined(PREPASS_VELOCITY)
attribute previousWorld0 : vec4<f32>;attribute previousWorld1 : vec4<f32>;attribute previousWorld2 : vec4<f32>;attribute previousWorld3 : vec4<f32>;
#ifdef THIN_INSTANCES
uniform previousWorld : mat4x4<f32>;
#endif
#endif
#else
#if !defined(WORLD_UBO)
uniform world : mat4x4<f32>;
#endif
#if defined(VELOCITY) || defined(PREPASS_VELOCITY)
uniform previousWorld : mat4x4<f32>;
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStoreWGSL[$027a757954d69746$var$name] = $027a757954d69746$var$shader;
const $027a757954d69746$export$9b0ca2b8078a529 = {
    name: $027a757954d69746$var$name,
    shader: $027a757954d69746$var$shader
};

});

parcelRegister("hA838", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $cccc0aed8a5a331e$var$name = "instancesVertex";
const $cccc0aed8a5a331e$var$shader = `#ifdef INSTANCES
var finalWorld=mat4x4<f32>(vertexInputs.world0,vertexInputs.world1,vertexInputs.world2,vertexInputs.world3);
#if defined(PREPASS_VELOCITY) || defined(VELOCITY)
var finalPreviousWorld=mat4x4<f32>(previousWorld0,previousWorld1,previousWorld2,previousWorld3);
#endif
#ifdef THIN_INSTANCES
#if !defined(WORLD_UBO)
finalWorld=uniforms.world*finalWorld;
#else
finalWorld=mesh.world*finalWorld;
#endif
#if defined(PREPASS_VELOCITY) || defined(VELOCITY)
finalPreviousWorld=previousWorld*finalPreviousWorld;
#endif
#endif
#else
#if !defined(WORLD_UBO)
var finalWorld=uniforms.world;
#else
var finalWorld=mesh.world;
#endif
#if defined(PREPASS_VELOCITY) || defined(VELOCITY)
var finalPreviousWorld=previousWorld;
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStoreWGSL[$cccc0aed8a5a331e$var$name] = $cccc0aed8a5a331e$var$shader;
const $cccc0aed8a5a331e$export$306861c24aa7eac7 = {
    name: $cccc0aed8a5a331e$var$name,
    shader: $cccc0aed8a5a331e$var$shader
};

});

parcelRegister("6zaN7", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $4c7e61e1091db455$var$name = "meshUboDeclaration";
const $4c7e61e1091db455$var$shader = `struct Mesh {world : mat4x4<f32>,
visibility : f32,};var<uniform> mesh : Mesh;
#define WORLD_UBO
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStoreWGSL[$4c7e61e1091db455$var$name] = $4c7e61e1091db455$var$shader;
const $4c7e61e1091db455$export$7c5f228ba674c3fe = {
    name: $4c7e61e1091db455$var$name,
    shader: $4c7e61e1091db455$var$shader
};

});

parcelRegister("5RNRI", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $4458953a54621ebd$var$name = "morphTargetsVertex";
const $4458953a54621ebd$var$shader = `#ifdef MORPHTARGETS
#ifdef MORPHTARGETS_TEXTURE
#if {X}==0
for (var i=0; i<$NUM_MORPH_INFLUENCERS$; i=i+1) {if (i>=uniforms.morphTargetCount) {break;}
vertexID=f32(vertexInputs.vertexIndex)*uniforms.morphTargetTextureInfo.x;positionUpdated=positionUpdated+(readVector3FromRawSampler({X},vertexID)-vertexInputs.position)*uniforms.morphTargetInfluences[{X}];vertexID=vertexID+1.0;
#ifdef MORPHTARGETS_NORMAL
normalUpdated=normalUpdated+(readVector3FromRawSampler({X},vertexID) -vertexInputs.normal)*uniforms.morphTargetInfluences[{X}];vertexID=vertexID+1.0;
#endif
#ifdef MORPHTARGETS_UV
uvUpdated=uvUpdated+(readVector3FromRawSampler({X},vertexID).xy-vertexInputs.uv)*uniforms.morphTargetInfluences[{X}];vertexID=vertexID+1.0;
#endif
#ifdef MORPHTARGETS_TANGENT
tangentUpdated.xyz=tangentUpdated.xyz+(readVector3FromRawSampler({X},vertexID) -vertexInputs.tangent.xyz)*uniforms.morphTargetInfluences[{X}];
#endif
}
#endif
#else
positionUpdated=positionUpdated+(position{X}-vertexInputs.position)*uniforms.morphTargetInfluences[{X}];
#ifdef MORPHTARGETS_NORMAL
normalUpdated+=(normal{X}-vertexInputs.normal)*uniforms.morphTargetInfluences[{X}];
#endif
#ifdef MORPHTARGETS_TANGENT
tangentUpdated.xyz=tangentUpdated.xyz+(tangent{X}-vertexInputs.tangent.xyz)*uniforms.morphTargetInfluences[{X}];
#endif
#ifdef MORPHTARGETS_UV
uvUpdated=uvUpdated+(uv_{X}-vertexInputs.uv)*uniforms.morphTargetInfluences[{X}];
#endif
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStoreWGSL[$4458953a54621ebd$var$name] = $4458953a54621ebd$var$shader;
const $4458953a54621ebd$export$b897b5fdf807d651 = {
    name: $4458953a54621ebd$var$name,
    shader: $4458953a54621ebd$var$shader
};

});

parcelRegister("41sCl", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $2edd743f8ad295d8$var$name = "morphTargetsVertexDeclaration";
const $2edd743f8ad295d8$var$shader = `#ifdef MORPHTARGETS
#ifndef MORPHTARGETS_TEXTURE
attribute position{X} : vec3<f32>;
#ifdef MORPHTARGETS_NORMAL
attribute normal{X} : vec3<f32>;
#endif
#ifdef MORPHTARGETS_TANGENT
attribute tangent{X} : vec3<f32>;
#endif
#ifdef MORPHTARGETS_UV
attribute uv_{X} : vec2<f32>;
#endif
#elif {X}==0
uniform morphTargetCount: i32;
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStoreWGSL[$2edd743f8ad295d8$var$name] = $2edd743f8ad295d8$var$shader;
const $2edd743f8ad295d8$export$695a00cfa0b745dc = {
    name: $2edd743f8ad295d8$var$name,
    shader: $2edd743f8ad295d8$var$shader
};

});

parcelRegister("5Y5iW", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $4586abbc4a0a9a6c$var$name = "morphTargetsVertexGlobal";
const $4586abbc4a0a9a6c$var$shader = `#ifdef MORPHTARGETS
#ifdef MORPHTARGETS_TEXTURE
var vertexID : f32;
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStoreWGSL[$4586abbc4a0a9a6c$var$name] = $4586abbc4a0a9a6c$var$shader;
const $4586abbc4a0a9a6c$export$f1ab5e2472bd1f4 = {
    name: $4586abbc4a0a9a6c$var$name,
    shader: $4586abbc4a0a9a6c$var$shader
};

});

parcelRegister("cbn3S", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $0249f123c538cb5d$var$name = "morphTargetsVertexGlobalDeclaration";
const $0249f123c538cb5d$var$shader = `#ifdef MORPHTARGETS
uniform morphTargetInfluences : array<f32,NUM_MORPH_INFLUENCERS>;
#ifdef MORPHTARGETS_TEXTURE 
uniform morphTargetTextureIndices : array<f32,NUM_MORPH_INFLUENCERS>;uniform morphTargetTextureInfo : vec3<f32>;var morphTargets : texture_2d_array<f32>;var morphTargetsSampler : sampler;fn readVector3FromRawSampler(targetIndex : i32,vertexIndex : f32)->vec3<f32>
{ 
let y=floor(vertexIndex/uniforms.morphTargetTextureInfo.y);let x=vertexIndex-y*uniforms.morphTargetTextureInfo.y;let textureUV=vec2<f32>((x+0.5)/uniforms.morphTargetTextureInfo.y,(y+0.5)/uniforms.morphTargetTextureInfo.z);return textureSampleLevel(morphTargets,morphTargetsSampler,textureUV,i32(uniforms.morphTargetTextureIndices[targetIndex]),0.0).xyz;}
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStoreWGSL[$0249f123c538cb5d$var$name] = $0249f123c538cb5d$var$shader;
const $0249f123c538cb5d$export$d8c22cd8cb3e4149 = {
    name: $0249f123c538cb5d$var$name,
    shader: $0249f123c538cb5d$var$shader
};

});

parcelRegister("kiX3E", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $ec834cc0ffc737c2$var$name = "sceneUboDeclaration";
const $ec834cc0ffc737c2$var$shader = `struct Scene {viewProjection : mat4x4<f32>,
#ifdef MULTIVIEW
viewProjectionR : mat4x4<f32>,
#endif 
view : mat4x4<f32>,
projection : mat4x4<f32>,
vEyePosition : vec4<f32>,};var<uniform> scene : Scene;
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStoreWGSL[$ec834cc0ffc737c2$var$name] = $ec834cc0ffc737c2$var$shader;
const $ec834cc0ffc737c2$export$89e49482cbc67f19 = {
    name: $ec834cc0ffc737c2$var$name,
    shader: $ec834cc0ffc737c2$var$shader
};

});


parcelRegister("l46cr", function(module, exports) {

$parcel$export(module.exports, "WebGPUTextureHelper", () => $f55ec7d7c889030e$export$97a6075701ba9668);
/* eslint-disable babylonjs/available */ // eslint-disable-next-line @typescript-eslint/naming-convention

var $hR6HG = parcelRequire("hR6HG");

var $1VEEL = parcelRequire("1VEEL");
class $f55ec7d7c889030e$export$97a6075701ba9668 {
    static ComputeNumMipmapLevels(width, height) {
        return (0, $1VEEL.Scalar).ILog2(Math.max(width, height)) + 1;
    }
    static GetTextureTypeFromFormat(format) {
        switch(format){
            // One Component = 8 bits
            case $hR6HG.TextureFormat.R8Unorm:
            case $hR6HG.TextureFormat.R8Snorm:
            case $hR6HG.TextureFormat.R8Uint:
            case $hR6HG.TextureFormat.R8Sint:
            case $hR6HG.TextureFormat.RG8Unorm:
            case $hR6HG.TextureFormat.RG8Snorm:
            case $hR6HG.TextureFormat.RG8Uint:
            case $hR6HG.TextureFormat.RG8Sint:
            case $hR6HG.TextureFormat.RGBA8Unorm:
            case $hR6HG.TextureFormat.RGBA8UnormSRGB:
            case $hR6HG.TextureFormat.RGBA8Snorm:
            case $hR6HG.TextureFormat.RGBA8Uint:
            case $hR6HG.TextureFormat.RGBA8Sint:
            case $hR6HG.TextureFormat.BGRA8Unorm:
            case $hR6HG.TextureFormat.BGRA8UnormSRGB:
            case $hR6HG.TextureFormat.RGB10A2UINT:
            case $hR6HG.TextureFormat.RGB10A2Unorm:
            case $hR6HG.TextureFormat.RGB9E5UFloat:
            case $hR6HG.TextureFormat.RG11B10UFloat:
            case $hR6HG.TextureFormat.BC7RGBAUnorm:
            case $hR6HG.TextureFormat.BC7RGBAUnormSRGB:
            case $hR6HG.TextureFormat.BC6HRGBUFloat:
            case $hR6HG.TextureFormat.BC6HRGBFloat:
            case $hR6HG.TextureFormat.BC5RGUnorm:
            case $hR6HG.TextureFormat.BC5RGSnorm:
            case $hR6HG.TextureFormat.BC3RGBAUnorm:
            case $hR6HG.TextureFormat.BC3RGBAUnormSRGB:
            case $hR6HG.TextureFormat.BC2RGBAUnorm:
            case $hR6HG.TextureFormat.BC2RGBAUnormSRGB:
            case $hR6HG.TextureFormat.BC4RUnorm:
            case $hR6HG.TextureFormat.BC4RSnorm:
            case $hR6HG.TextureFormat.BC1RGBAUnorm:
            case $hR6HG.TextureFormat.BC1RGBAUnormSRGB:
            case $hR6HG.TextureFormat.ETC2RGB8Unorm:
            case $hR6HG.TextureFormat.ETC2RGB8UnormSRGB:
            case $hR6HG.TextureFormat.ETC2RGB8A1Unorm:
            case $hR6HG.TextureFormat.ETC2RGB8A1UnormSRGB:
            case $hR6HG.TextureFormat.ETC2RGBA8Unorm:
            case $hR6HG.TextureFormat.ETC2RGBA8UnormSRGB:
            case $hR6HG.TextureFormat.EACR11Unorm:
            case $hR6HG.TextureFormat.EACR11Snorm:
            case $hR6HG.TextureFormat.EACRG11Unorm:
            case $hR6HG.TextureFormat.EACRG11Snorm:
            case $hR6HG.TextureFormat.ASTC4x4Unorm:
            case $hR6HG.TextureFormat.ASTC4x4UnormSRGB:
            case $hR6HG.TextureFormat.ASTC5x4Unorm:
            case $hR6HG.TextureFormat.ASTC5x4UnormSRGB:
            case $hR6HG.TextureFormat.ASTC5x5Unorm:
            case $hR6HG.TextureFormat.ASTC5x5UnormSRGB:
            case $hR6HG.TextureFormat.ASTC6x5Unorm:
            case $hR6HG.TextureFormat.ASTC6x5UnormSRGB:
            case $hR6HG.TextureFormat.ASTC6x6Unorm:
            case $hR6HG.TextureFormat.ASTC6x6UnormSRGB:
            case $hR6HG.TextureFormat.ASTC8x5Unorm:
            case $hR6HG.TextureFormat.ASTC8x5UnormSRGB:
            case $hR6HG.TextureFormat.ASTC8x6Unorm:
            case $hR6HG.TextureFormat.ASTC8x6UnormSRGB:
            case $hR6HG.TextureFormat.ASTC8x8Unorm:
            case $hR6HG.TextureFormat.ASTC8x8UnormSRGB:
            case $hR6HG.TextureFormat.ASTC10x5Unorm:
            case $hR6HG.TextureFormat.ASTC10x5UnormSRGB:
            case $hR6HG.TextureFormat.ASTC10x6Unorm:
            case $hR6HG.TextureFormat.ASTC10x6UnormSRGB:
            case $hR6HG.TextureFormat.ASTC10x8Unorm:
            case $hR6HG.TextureFormat.ASTC10x8UnormSRGB:
            case $hR6HG.TextureFormat.ASTC10x10Unorm:
            case $hR6HG.TextureFormat.ASTC10x10UnormSRGB:
            case $hR6HG.TextureFormat.ASTC12x10Unorm:
            case $hR6HG.TextureFormat.ASTC12x10UnormSRGB:
            case $hR6HG.TextureFormat.ASTC12x12Unorm:
            case $hR6HG.TextureFormat.ASTC12x12UnormSRGB:
            case $hR6HG.TextureFormat.Stencil8:
                return 0;
            // One component = 16 bits
            case $hR6HG.TextureFormat.R16Uint:
            case $hR6HG.TextureFormat.R16Sint:
            case $hR6HG.TextureFormat.RG16Uint:
            case $hR6HG.TextureFormat.RG16Sint:
            case $hR6HG.TextureFormat.RGBA16Uint:
            case $hR6HG.TextureFormat.RGBA16Sint:
            case $hR6HG.TextureFormat.Depth16Unorm:
                return 5;
            case $hR6HG.TextureFormat.R16Float:
            case $hR6HG.TextureFormat.RG16Float:
            case $hR6HG.TextureFormat.RGBA16Float:
                return 2;
            // One component = 32 bits
            case $hR6HG.TextureFormat.R32Uint:
            case $hR6HG.TextureFormat.R32Sint:
            case $hR6HG.TextureFormat.RG32Uint:
            case $hR6HG.TextureFormat.RG32Sint:
            case $hR6HG.TextureFormat.RGBA32Uint:
            case $hR6HG.TextureFormat.RGBA32Sint:
                return 7;
            case $hR6HG.TextureFormat.R32Float:
            case $hR6HG.TextureFormat.RG32Float:
            case $hR6HG.TextureFormat.RGBA32Float:
            case $hR6HG.TextureFormat.Depth32Float:
            case $hR6HG.TextureFormat.Depth32FloatStencil8:
            case $hR6HG.TextureFormat.Depth24Plus:
            case $hR6HG.TextureFormat.Depth24PlusStencil8:
                return 1;
        }
        return 0;
    }
    static GetBlockInformationFromFormat(format) {
        switch(format){
            // 8 bits formats
            case $hR6HG.TextureFormat.R8Unorm:
            case $hR6HG.TextureFormat.R8Snorm:
            case $hR6HG.TextureFormat.R8Uint:
            case $hR6HG.TextureFormat.R8Sint:
                return {
                    width: 1,
                    height: 1,
                    length: 1
                };
            // 16 bits formats
            case $hR6HG.TextureFormat.R16Uint:
            case $hR6HG.TextureFormat.R16Sint:
            case $hR6HG.TextureFormat.R16Float:
            case $hR6HG.TextureFormat.RG8Unorm:
            case $hR6HG.TextureFormat.RG8Snorm:
            case $hR6HG.TextureFormat.RG8Uint:
            case $hR6HG.TextureFormat.RG8Sint:
                return {
                    width: 1,
                    height: 1,
                    length: 2
                };
            // 32 bits formats
            case $hR6HG.TextureFormat.R32Uint:
            case $hR6HG.TextureFormat.R32Sint:
            case $hR6HG.TextureFormat.R32Float:
            case $hR6HG.TextureFormat.RG16Uint:
            case $hR6HG.TextureFormat.RG16Sint:
            case $hR6HG.TextureFormat.RG16Float:
            case $hR6HG.TextureFormat.RGBA8Unorm:
            case $hR6HG.TextureFormat.RGBA8UnormSRGB:
            case $hR6HG.TextureFormat.RGBA8Snorm:
            case $hR6HG.TextureFormat.RGBA8Uint:
            case $hR6HG.TextureFormat.RGBA8Sint:
            case $hR6HG.TextureFormat.BGRA8Unorm:
            case $hR6HG.TextureFormat.BGRA8UnormSRGB:
            case $hR6HG.TextureFormat.RGB9E5UFloat:
            case $hR6HG.TextureFormat.RGB10A2UINT:
            case $hR6HG.TextureFormat.RGB10A2Unorm:
            case $hR6HG.TextureFormat.RG11B10UFloat:
                return {
                    width: 1,
                    height: 1,
                    length: 4
                };
            // 64 bits formats
            case $hR6HG.TextureFormat.RG32Uint:
            case $hR6HG.TextureFormat.RG32Sint:
            case $hR6HG.TextureFormat.RG32Float:
            case $hR6HG.TextureFormat.RGBA16Uint:
            case $hR6HG.TextureFormat.RGBA16Sint:
            case $hR6HG.TextureFormat.RGBA16Float:
                return {
                    width: 1,
                    height: 1,
                    length: 8
                };
            // 128 bits formats
            case $hR6HG.TextureFormat.RGBA32Uint:
            case $hR6HG.TextureFormat.RGBA32Sint:
            case $hR6HG.TextureFormat.RGBA32Float:
                return {
                    width: 1,
                    height: 1,
                    length: 16
                };
            // Depth and stencil formats
            case $hR6HG.TextureFormat.Stencil8:
                // eslint-disable-next-line no-throw-literal
                throw "No fixed size for Stencil8 format!";
            case $hR6HG.TextureFormat.Depth16Unorm:
                return {
                    width: 1,
                    height: 1,
                    length: 2
                };
            case $hR6HG.TextureFormat.Depth24Plus:
                // eslint-disable-next-line no-throw-literal
                throw "No fixed size for Depth24Plus format!";
            case $hR6HG.TextureFormat.Depth24PlusStencil8:
                // eslint-disable-next-line no-throw-literal
                throw "No fixed size for Depth24PlusStencil8 format!";
            case $hR6HG.TextureFormat.Depth32Float:
                return {
                    width: 1,
                    height: 1,
                    length: 4
                };
            case $hR6HG.TextureFormat.Depth32FloatStencil8:
                return {
                    width: 1,
                    height: 1,
                    length: 5
                };
            // BC compressed formats usable if "texture-compression-bc" is both
            // supported by the device/user agent and enabled in requestDevice.
            case $hR6HG.TextureFormat.BC7RGBAUnorm:
            case $hR6HG.TextureFormat.BC7RGBAUnormSRGB:
            case $hR6HG.TextureFormat.BC6HRGBUFloat:
            case $hR6HG.TextureFormat.BC6HRGBFloat:
            case $hR6HG.TextureFormat.BC5RGUnorm:
            case $hR6HG.TextureFormat.BC5RGSnorm:
            case $hR6HG.TextureFormat.BC3RGBAUnorm:
            case $hR6HG.TextureFormat.BC3RGBAUnormSRGB:
            case $hR6HG.TextureFormat.BC2RGBAUnorm:
            case $hR6HG.TextureFormat.BC2RGBAUnormSRGB:
                return {
                    width: 4,
                    height: 4,
                    length: 16
                };
            case $hR6HG.TextureFormat.BC4RUnorm:
            case $hR6HG.TextureFormat.BC4RSnorm:
            case $hR6HG.TextureFormat.BC1RGBAUnorm:
            case $hR6HG.TextureFormat.BC1RGBAUnormSRGB:
                return {
                    width: 4,
                    height: 4,
                    length: 8
                };
            // ETC2 compressed formats usable if "texture-compression-etc2" is both
            // supported by the device/user agent and enabled in requestDevice.
            case $hR6HG.TextureFormat.ETC2RGB8Unorm:
            case $hR6HG.TextureFormat.ETC2RGB8UnormSRGB:
            case $hR6HG.TextureFormat.ETC2RGB8A1Unorm:
            case $hR6HG.TextureFormat.ETC2RGB8A1UnormSRGB:
            case $hR6HG.TextureFormat.EACR11Unorm:
            case $hR6HG.TextureFormat.EACR11Snorm:
                return {
                    width: 4,
                    height: 4,
                    length: 8
                };
            case $hR6HG.TextureFormat.ETC2RGBA8Unorm:
            case $hR6HG.TextureFormat.ETC2RGBA8UnormSRGB:
            case $hR6HG.TextureFormat.EACRG11Unorm:
            case $hR6HG.TextureFormat.EACRG11Snorm:
                return {
                    width: 4,
                    height: 4,
                    length: 16
                };
            // ASTC compressed formats usable if "texture-compression-astc" is both
            // supported by the device/user agent and enabled in requestDevice.
            case $hR6HG.TextureFormat.ASTC4x4Unorm:
            case $hR6HG.TextureFormat.ASTC4x4UnormSRGB:
                return {
                    width: 4,
                    height: 4,
                    length: 16
                };
            case $hR6HG.TextureFormat.ASTC5x4Unorm:
            case $hR6HG.TextureFormat.ASTC5x4UnormSRGB:
                return {
                    width: 5,
                    height: 4,
                    length: 16
                };
            case $hR6HG.TextureFormat.ASTC5x5Unorm:
            case $hR6HG.TextureFormat.ASTC5x5UnormSRGB:
                return {
                    width: 5,
                    height: 5,
                    length: 16
                };
            case $hR6HG.TextureFormat.ASTC6x5Unorm:
            case $hR6HG.TextureFormat.ASTC6x5UnormSRGB:
                return {
                    width: 6,
                    height: 5,
                    length: 16
                };
            case $hR6HG.TextureFormat.ASTC6x6Unorm:
            case $hR6HG.TextureFormat.ASTC6x6UnormSRGB:
                return {
                    width: 6,
                    height: 6,
                    length: 16
                };
            case $hR6HG.TextureFormat.ASTC8x5Unorm:
            case $hR6HG.TextureFormat.ASTC8x5UnormSRGB:
                return {
                    width: 8,
                    height: 5,
                    length: 16
                };
            case $hR6HG.TextureFormat.ASTC8x6Unorm:
            case $hR6HG.TextureFormat.ASTC8x6UnormSRGB:
                return {
                    width: 8,
                    height: 6,
                    length: 16
                };
            case $hR6HG.TextureFormat.ASTC8x8Unorm:
            case $hR6HG.TextureFormat.ASTC8x8UnormSRGB:
                return {
                    width: 8,
                    height: 8,
                    length: 16
                };
            case $hR6HG.TextureFormat.ASTC10x5Unorm:
            case $hR6HG.TextureFormat.ASTC10x5UnormSRGB:
                return {
                    width: 10,
                    height: 5,
                    length: 16
                };
            case $hR6HG.TextureFormat.ASTC10x6Unorm:
            case $hR6HG.TextureFormat.ASTC10x6UnormSRGB:
                return {
                    width: 10,
                    height: 6,
                    length: 16
                };
            case $hR6HG.TextureFormat.ASTC10x8Unorm:
            case $hR6HG.TextureFormat.ASTC10x8UnormSRGB:
                return {
                    width: 10,
                    height: 8,
                    length: 16
                };
            case $hR6HG.TextureFormat.ASTC10x10Unorm:
            case $hR6HG.TextureFormat.ASTC10x10UnormSRGB:
                return {
                    width: 10,
                    height: 10,
                    length: 16
                };
            case $hR6HG.TextureFormat.ASTC12x10Unorm:
            case $hR6HG.TextureFormat.ASTC12x10UnormSRGB:
                return {
                    width: 12,
                    height: 10,
                    length: 16
                };
            case $hR6HG.TextureFormat.ASTC12x12Unorm:
            case $hR6HG.TextureFormat.ASTC12x12UnormSRGB:
                return {
                    width: 12,
                    height: 12,
                    length: 16
                };
        }
        return {
            width: 1,
            height: 1,
            length: 4
        };
    }
    static IsHardwareTexture(texture) {
        return !!texture.release;
    }
    static IsInternalTexture(texture) {
        return !!texture.dispose;
    }
    static IsImageBitmap(imageBitmap) {
        return imageBitmap.close !== undefined;
    }
    static IsImageBitmapArray(imageBitmap) {
        return Array.isArray(imageBitmap) && imageBitmap[0].close !== undefined;
    }
    static IsCompressedFormat(format) {
        switch(format){
            case $hR6HG.TextureFormat.BC7RGBAUnormSRGB:
            case $hR6HG.TextureFormat.BC7RGBAUnorm:
            case $hR6HG.TextureFormat.BC6HRGBFloat:
            case $hR6HG.TextureFormat.BC6HRGBUFloat:
            case $hR6HG.TextureFormat.BC5RGSnorm:
            case $hR6HG.TextureFormat.BC5RGUnorm:
            case $hR6HG.TextureFormat.BC4RSnorm:
            case $hR6HG.TextureFormat.BC4RUnorm:
            case $hR6HG.TextureFormat.BC3RGBAUnormSRGB:
            case $hR6HG.TextureFormat.BC3RGBAUnorm:
            case $hR6HG.TextureFormat.BC2RGBAUnormSRGB:
            case $hR6HG.TextureFormat.BC2RGBAUnorm:
            case $hR6HG.TextureFormat.BC1RGBAUnormSRGB:
            case $hR6HG.TextureFormat.BC1RGBAUnorm:
            case $hR6HG.TextureFormat.ETC2RGB8Unorm:
            case $hR6HG.TextureFormat.ETC2RGB8UnormSRGB:
            case $hR6HG.TextureFormat.ETC2RGB8A1Unorm:
            case $hR6HG.TextureFormat.ETC2RGB8A1UnormSRGB:
            case $hR6HG.TextureFormat.ETC2RGBA8Unorm:
            case $hR6HG.TextureFormat.ETC2RGBA8UnormSRGB:
            case $hR6HG.TextureFormat.EACR11Unorm:
            case $hR6HG.TextureFormat.EACR11Snorm:
            case $hR6HG.TextureFormat.EACRG11Unorm:
            case $hR6HG.TextureFormat.EACRG11Snorm:
            case $hR6HG.TextureFormat.ASTC4x4Unorm:
            case $hR6HG.TextureFormat.ASTC4x4UnormSRGB:
            case $hR6HG.TextureFormat.ASTC5x4Unorm:
            case $hR6HG.TextureFormat.ASTC5x4UnormSRGB:
            case $hR6HG.TextureFormat.ASTC5x5Unorm:
            case $hR6HG.TextureFormat.ASTC5x5UnormSRGB:
            case $hR6HG.TextureFormat.ASTC6x5Unorm:
            case $hR6HG.TextureFormat.ASTC6x5UnormSRGB:
            case $hR6HG.TextureFormat.ASTC6x6Unorm:
            case $hR6HG.TextureFormat.ASTC6x6UnormSRGB:
            case $hR6HG.TextureFormat.ASTC8x5Unorm:
            case $hR6HG.TextureFormat.ASTC8x5UnormSRGB:
            case $hR6HG.TextureFormat.ASTC8x6Unorm:
            case $hR6HG.TextureFormat.ASTC8x6UnormSRGB:
            case $hR6HG.TextureFormat.ASTC8x8Unorm:
            case $hR6HG.TextureFormat.ASTC8x8UnormSRGB:
            case $hR6HG.TextureFormat.ASTC10x5Unorm:
            case $hR6HG.TextureFormat.ASTC10x5UnormSRGB:
            case $hR6HG.TextureFormat.ASTC10x6Unorm:
            case $hR6HG.TextureFormat.ASTC10x6UnormSRGB:
            case $hR6HG.TextureFormat.ASTC10x8Unorm:
            case $hR6HG.TextureFormat.ASTC10x8UnormSRGB:
            case $hR6HG.TextureFormat.ASTC10x10Unorm:
            case $hR6HG.TextureFormat.ASTC10x10UnormSRGB:
            case $hR6HG.TextureFormat.ASTC12x10Unorm:
            case $hR6HG.TextureFormat.ASTC12x10UnormSRGB:
            case $hR6HG.TextureFormat.ASTC12x12Unorm:
            case $hR6HG.TextureFormat.ASTC12x12UnormSRGB:
                return true;
        }
        return false;
    }
    static GetWebGPUTextureFormat(type, format, useSRGBBuffer = false) {
        switch(format){
            case 15:
                return $hR6HG.TextureFormat.Depth16Unorm;
            case 16:
                return $hR6HG.TextureFormat.Depth24Plus;
            case 13:
                return $hR6HG.TextureFormat.Depth24PlusStencil8;
            case 14:
                return $hR6HG.TextureFormat.Depth32Float;
            case 18:
                return $hR6HG.TextureFormat.Depth32FloatStencil8;
            case 19:
                return $hR6HG.TextureFormat.Stencil8;
            case 36492:
                return useSRGBBuffer ? $hR6HG.TextureFormat.BC7RGBAUnormSRGB : $hR6HG.TextureFormat.BC7RGBAUnorm;
            case 36495:
                return $hR6HG.TextureFormat.BC6HRGBUFloat;
            case 36494:
                return $hR6HG.TextureFormat.BC6HRGBFloat;
            case 33779:
                return useSRGBBuffer ? $hR6HG.TextureFormat.BC3RGBAUnormSRGB : $hR6HG.TextureFormat.BC3RGBAUnorm;
            case 33778:
                return useSRGBBuffer ? $hR6HG.TextureFormat.BC2RGBAUnormSRGB : $hR6HG.TextureFormat.BC2RGBAUnorm;
            case 33777:
            case 33776:
                return useSRGBBuffer ? $hR6HG.TextureFormat.BC1RGBAUnormSRGB : $hR6HG.TextureFormat.BC1RGBAUnorm;
            case 37808:
                return useSRGBBuffer ? $hR6HG.TextureFormat.ASTC4x4UnormSRGB : $hR6HG.TextureFormat.ASTC4x4Unorm;
            case 36196:
            case 37492:
                return useSRGBBuffer ? $hR6HG.TextureFormat.ETC2RGB8UnormSRGB : $hR6HG.TextureFormat.ETC2RGB8Unorm;
            case 37496:
                return useSRGBBuffer ? $hR6HG.TextureFormat.ETC2RGBA8UnormSRGB : $hR6HG.TextureFormat.ETC2RGBA8Unorm;
        }
        switch(type){
            case 3:
                switch(format){
                    case 6:
                        return $hR6HG.TextureFormat.R8Snorm;
                    case 7:
                        return $hR6HG.TextureFormat.RG8Snorm;
                    case 4:
                        // eslint-disable-next-line no-throw-literal
                        throw "RGB format not supported in WebGPU";
                    case 8:
                        return $hR6HG.TextureFormat.R8Sint;
                    case 9:
                        return $hR6HG.TextureFormat.RG8Sint;
                    case 10:
                        // eslint-disable-next-line no-throw-literal
                        throw "RGB_INTEGER format not supported in WebGPU";
                    case 11:
                        return $hR6HG.TextureFormat.RGBA8Sint;
                    default:
                        return $hR6HG.TextureFormat.RGBA8Snorm;
                }
            case 0:
                switch(format){
                    case 6:
                        return $hR6HG.TextureFormat.R8Unorm;
                    case 7:
                        return $hR6HG.TextureFormat.RG8Unorm;
                    case 4:
                        // eslint-disable-next-line no-throw-literal
                        throw "TEXTUREFORMAT_RGB format not supported in WebGPU";
                    case 5:
                        return useSRGBBuffer ? $hR6HG.TextureFormat.RGBA8UnormSRGB : $hR6HG.TextureFormat.RGBA8Unorm;
                    case 12:
                        return useSRGBBuffer ? $hR6HG.TextureFormat.BGRA8UnormSRGB : $hR6HG.TextureFormat.BGRA8Unorm;
                    case 8:
                        return $hR6HG.TextureFormat.R8Uint;
                    case 9:
                        return $hR6HG.TextureFormat.RG8Uint;
                    case 10:
                        // eslint-disable-next-line no-throw-literal
                        throw "RGB_INTEGER format not supported in WebGPU";
                    case 11:
                        return $hR6HG.TextureFormat.RGBA8Uint;
                    case 0:
                        // eslint-disable-next-line no-throw-literal
                        throw "TEXTUREFORMAT_ALPHA format not supported in WebGPU";
                    case 1:
                        // eslint-disable-next-line no-throw-literal
                        throw "TEXTUREFORMAT_LUMINANCE format not supported in WebGPU";
                    case 2:
                        // eslint-disable-next-line no-throw-literal
                        throw "TEXTUREFORMAT_LUMINANCE_ALPHA format not supported in WebGPU";
                    default:
                        return $hR6HG.TextureFormat.RGBA8Unorm;
                }
            case 4:
                switch(format){
                    case 8:
                        return $hR6HG.TextureFormat.R16Sint;
                    case 9:
                        return $hR6HG.TextureFormat.RG16Sint;
                    case 10:
                        // eslint-disable-next-line no-throw-literal
                        throw "TEXTUREFORMAT_RGB_INTEGER format not supported in WebGPU";
                    case 11:
                        return $hR6HG.TextureFormat.RGBA16Sint;
                    default:
                        return $hR6HG.TextureFormat.RGBA16Sint;
                }
            case 5:
                switch(format){
                    case 8:
                        return $hR6HG.TextureFormat.R16Uint;
                    case 9:
                        return $hR6HG.TextureFormat.RG16Uint;
                    case 10:
                        // eslint-disable-next-line no-throw-literal
                        throw "TEXTUREFORMAT_RGB_INTEGER format not supported in WebGPU";
                    case 11:
                        return $hR6HG.TextureFormat.RGBA16Uint;
                    default:
                        return $hR6HG.TextureFormat.RGBA16Uint;
                }
            case 6:
                switch(format){
                    case 8:
                        return $hR6HG.TextureFormat.R32Sint;
                    case 9:
                        return $hR6HG.TextureFormat.RG32Sint;
                    case 10:
                        // eslint-disable-next-line no-throw-literal
                        throw "TEXTUREFORMAT_RGB_INTEGER format not supported in WebGPU";
                    case 11:
                        return $hR6HG.TextureFormat.RGBA32Sint;
                    default:
                        return $hR6HG.TextureFormat.RGBA32Sint;
                }
            case 7:
                switch(format){
                    case 8:
                        return $hR6HG.TextureFormat.R32Uint;
                    case 9:
                        return $hR6HG.TextureFormat.RG32Uint;
                    case 10:
                        // eslint-disable-next-line no-throw-literal
                        throw "TEXTUREFORMAT_RGB_INTEGER format not supported in WebGPU";
                    case 11:
                        return $hR6HG.TextureFormat.RGBA32Uint;
                    default:
                        return $hR6HG.TextureFormat.RGBA32Uint;
                }
            case 1:
                switch(format){
                    case 6:
                        return $hR6HG.TextureFormat.R32Float; // By default. Other possibility is R16Float.
                    case 7:
                        return $hR6HG.TextureFormat.RG32Float; // By default. Other possibility is RG16Float.
                    case 4:
                        // eslint-disable-next-line no-throw-literal
                        throw "TEXTUREFORMAT_RGB format not supported in WebGPU";
                    case 5:
                        return $hR6HG.TextureFormat.RGBA32Float; // By default. Other possibility is RGBA16Float.
                    default:
                        return $hR6HG.TextureFormat.RGBA32Float;
                }
            case 2:
                switch(format){
                    case 6:
                        return $hR6HG.TextureFormat.R16Float;
                    case 7:
                        return $hR6HG.TextureFormat.RG16Float;
                    case 4:
                        // eslint-disable-next-line no-throw-literal
                        throw "TEXTUREFORMAT_RGB format not supported in WebGPU";
                    case 5:
                        return $hR6HG.TextureFormat.RGBA16Float;
                    default:
                        return $hR6HG.TextureFormat.RGBA16Float;
                }
            case 10:
                // eslint-disable-next-line no-throw-literal
                throw "TEXTURETYPE_UNSIGNED_SHORT_5_6_5 format not supported in WebGPU";
            case 13:
                switch(format){
                    case 5:
                        return $hR6HG.TextureFormat.RG11B10UFloat;
                    case 11:
                        // eslint-disable-next-line no-throw-literal
                        throw "TEXTUREFORMAT_RGBA_INTEGER format not supported in WebGPU when type is TEXTURETYPE_UNSIGNED_INT_10F_11F_11F_REV";
                    default:
                        return $hR6HG.TextureFormat.RG11B10UFloat;
                }
            case 14:
                switch(format){
                    case 5:
                        return $hR6HG.TextureFormat.RGB9E5UFloat;
                    case 11:
                        // eslint-disable-next-line no-throw-literal
                        throw "TEXTUREFORMAT_RGBA_INTEGER format not supported in WebGPU when type is TEXTURETYPE_UNSIGNED_INT_5_9_9_9_REV";
                    default:
                        return $hR6HG.TextureFormat.RGB9E5UFloat;
                }
            case 8:
                // eslint-disable-next-line no-throw-literal
                throw "TEXTURETYPE_UNSIGNED_SHORT_4_4_4_4 format not supported in WebGPU";
            case 9:
                // eslint-disable-next-line no-throw-literal
                throw "TEXTURETYPE_UNSIGNED_SHORT_5_5_5_1 format not supported in WebGPU";
            case 11:
                switch(format){
                    case 5:
                        return $hR6HG.TextureFormat.RGB10A2Unorm;
                    case 11:
                        return $hR6HG.TextureFormat.RGB10A2UINT;
                    default:
                        return $hR6HG.TextureFormat.RGB10A2Unorm;
                }
        }
        return useSRGBBuffer ? $hR6HG.TextureFormat.RGBA8UnormSRGB : $hR6HG.TextureFormat.RGBA8Unorm;
    }
    static GetNumChannelsFromWebGPUTextureFormat(format) {
        switch(format){
            case $hR6HG.TextureFormat.R8Unorm:
            case $hR6HG.TextureFormat.R8Snorm:
            case $hR6HG.TextureFormat.R8Uint:
            case $hR6HG.TextureFormat.R8Sint:
            case $hR6HG.TextureFormat.BC4RUnorm:
            case $hR6HG.TextureFormat.BC4RSnorm:
            case $hR6HG.TextureFormat.R16Uint:
            case $hR6HG.TextureFormat.R16Sint:
            case $hR6HG.TextureFormat.Depth16Unorm:
            case $hR6HG.TextureFormat.R16Float:
            case $hR6HG.TextureFormat.R32Uint:
            case $hR6HG.TextureFormat.R32Sint:
            case $hR6HG.TextureFormat.R32Float:
            case $hR6HG.TextureFormat.Depth32Float:
            case $hR6HG.TextureFormat.Stencil8:
            case $hR6HG.TextureFormat.Depth24Plus:
            case $hR6HG.TextureFormat.EACR11Unorm:
            case $hR6HG.TextureFormat.EACR11Snorm:
                return 1;
            case $hR6HG.TextureFormat.RG8Unorm:
            case $hR6HG.TextureFormat.RG8Snorm:
            case $hR6HG.TextureFormat.RG8Uint:
            case $hR6HG.TextureFormat.RG8Sint:
            case $hR6HG.TextureFormat.Depth32FloatStencil8:
            case $hR6HG.TextureFormat.BC5RGUnorm:
            case $hR6HG.TextureFormat.BC5RGSnorm:
            case $hR6HG.TextureFormat.RG16Uint:
            case $hR6HG.TextureFormat.RG16Sint:
            case $hR6HG.TextureFormat.RG16Float:
            case $hR6HG.TextureFormat.RG32Uint:
            case $hR6HG.TextureFormat.RG32Sint:
            case $hR6HG.TextureFormat.RG32Float:
            case $hR6HG.TextureFormat.Depth24PlusStencil8:
            case $hR6HG.TextureFormat.EACRG11Unorm:
            case $hR6HG.TextureFormat.EACRG11Snorm:
                return 2;
            case $hR6HG.TextureFormat.RGB9E5UFloat:
            case $hR6HG.TextureFormat.RG11B10UFloat:
            case $hR6HG.TextureFormat.BC6HRGBUFloat:
            case $hR6HG.TextureFormat.BC6HRGBFloat:
            case $hR6HG.TextureFormat.ETC2RGB8Unorm:
            case $hR6HG.TextureFormat.ETC2RGB8UnormSRGB:
                return 3;
            case $hR6HG.TextureFormat.RGBA8Unorm:
            case $hR6HG.TextureFormat.RGBA8UnormSRGB:
            case $hR6HG.TextureFormat.RGBA8Snorm:
            case $hR6HG.TextureFormat.RGBA8Uint:
            case $hR6HG.TextureFormat.RGBA8Sint:
            case $hR6HG.TextureFormat.BGRA8Unorm:
            case $hR6HG.TextureFormat.BGRA8UnormSRGB:
            case $hR6HG.TextureFormat.RGB10A2UINT:
            case $hR6HG.TextureFormat.RGB10A2Unorm:
            case $hR6HG.TextureFormat.BC7RGBAUnorm:
            case $hR6HG.TextureFormat.BC7RGBAUnormSRGB:
            case $hR6HG.TextureFormat.BC3RGBAUnorm:
            case $hR6HG.TextureFormat.BC3RGBAUnormSRGB:
            case $hR6HG.TextureFormat.BC2RGBAUnorm:
            case $hR6HG.TextureFormat.BC2RGBAUnormSRGB:
            case $hR6HG.TextureFormat.BC1RGBAUnorm:
            case $hR6HG.TextureFormat.BC1RGBAUnormSRGB:
            case $hR6HG.TextureFormat.RGBA16Uint:
            case $hR6HG.TextureFormat.RGBA16Sint:
            case $hR6HG.TextureFormat.RGBA16Float:
            case $hR6HG.TextureFormat.RGBA32Uint:
            case $hR6HG.TextureFormat.RGBA32Sint:
            case $hR6HG.TextureFormat.RGBA32Float:
            case $hR6HG.TextureFormat.ETC2RGB8A1Unorm:
            case $hR6HG.TextureFormat.ETC2RGB8A1UnormSRGB:
            case $hR6HG.TextureFormat.ETC2RGBA8Unorm:
            case $hR6HG.TextureFormat.ETC2RGBA8UnormSRGB:
            case $hR6HG.TextureFormat.ASTC4x4Unorm:
            case $hR6HG.TextureFormat.ASTC4x4UnormSRGB:
            case $hR6HG.TextureFormat.ASTC5x4Unorm:
            case $hR6HG.TextureFormat.ASTC5x4UnormSRGB:
            case $hR6HG.TextureFormat.ASTC5x5Unorm:
            case $hR6HG.TextureFormat.ASTC5x5UnormSRGB:
            case $hR6HG.TextureFormat.ASTC6x5Unorm:
            case $hR6HG.TextureFormat.ASTC6x5UnormSRGB:
            case $hR6HG.TextureFormat.ASTC6x6Unorm:
            case $hR6HG.TextureFormat.ASTC6x6UnormSRGB:
            case $hR6HG.TextureFormat.ASTC8x5Unorm:
            case $hR6HG.TextureFormat.ASTC8x5UnormSRGB:
            case $hR6HG.TextureFormat.ASTC8x6Unorm:
            case $hR6HG.TextureFormat.ASTC8x6UnormSRGB:
            case $hR6HG.TextureFormat.ASTC8x8Unorm:
            case $hR6HG.TextureFormat.ASTC8x8UnormSRGB:
            case $hR6HG.TextureFormat.ASTC10x5Unorm:
            case $hR6HG.TextureFormat.ASTC10x5UnormSRGB:
            case $hR6HG.TextureFormat.ASTC10x6Unorm:
            case $hR6HG.TextureFormat.ASTC10x6UnormSRGB:
            case $hR6HG.TextureFormat.ASTC10x8Unorm:
            case $hR6HG.TextureFormat.ASTC10x8UnormSRGB:
            case $hR6HG.TextureFormat.ASTC10x10Unorm:
            case $hR6HG.TextureFormat.ASTC10x10UnormSRGB:
            case $hR6HG.TextureFormat.ASTC12x10Unorm:
            case $hR6HG.TextureFormat.ASTC12x10UnormSRGB:
            case $hR6HG.TextureFormat.ASTC12x12Unorm:
            case $hR6HG.TextureFormat.ASTC12x12UnormSRGB:
                return 4;
        }
        // eslint-disable-next-line no-throw-literal
        throw `Unknown format ${format}!`;
    }
    static HasStencilAspect(format) {
        switch(format){
            case $hR6HG.TextureFormat.Stencil8:
            case $hR6HG.TextureFormat.Depth32FloatStencil8:
            case $hR6HG.TextureFormat.Depth24PlusStencil8:
                return true;
        }
        return false;
    }
    static HasDepthAndStencilAspects(format) {
        switch(format){
            case $hR6HG.TextureFormat.Depth32FloatStencil8:
            case $hR6HG.TextureFormat.Depth24PlusStencil8:
                return true;
        }
        return false;
    }
    static GetDepthFormatOnly(format) {
        switch(format){
            case $hR6HG.TextureFormat.Depth16Unorm:
                return $hR6HG.TextureFormat.Depth16Unorm;
            case $hR6HG.TextureFormat.Depth24Plus:
                return $hR6HG.TextureFormat.Depth24Plus;
            case $hR6HG.TextureFormat.Depth24PlusStencil8:
                return $hR6HG.TextureFormat.Depth24Plus;
            case $hR6HG.TextureFormat.Depth32Float:
                return $hR6HG.TextureFormat.Depth32Float;
            case $hR6HG.TextureFormat.Depth32FloatStencil8:
                return $hR6HG.TextureFormat.Depth32Float;
        }
        return format;
    }
    static GetSample(sampleCount) {
        // WebGPU only supports 1 or 4
        return sampleCount > 1 ? 4 : 1;
    }
}

});

parcelRegister("4ObYT", function(module, exports) {

$parcel$export(module.exports, "renderableTextureFormatToIndex", () => $38052020172c3691$export$eede4bbe1ec19c42);
$parcel$export(module.exports, "WebGPUTextureManager", () => $38052020172c3691$export$cfd7b9871d9e8b83);
/* eslint-disable @typescript-eslint/naming-convention */ /* eslint-disable babylonjs/available */ /* eslint-disable jsdoc/require-jsdoc */ // License for the mipmap generation code:
//
// Copyright 2020 Brandon Jones
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.

var $hR6HG = parcelRequire("hR6HG");

var $b9e4a = parcelRequire("b9e4a");

var $4JXMh = parcelRequire("4JXMh");

var $l46cr = parcelRequire("l46cr");
// TODO WEBGPU improve mipmap generation by using compute shaders
// TODO WEBGPU use WGSL instead of GLSL
const $38052020172c3691$var$mipmapVertexSource = `
    const vec2 pos[4] = vec2[4](vec2(-1.0f, 1.0f), vec2(1.0f, 1.0f), vec2(-1.0f, -1.0f), vec2(1.0f, -1.0f));
    const vec2 tex[4] = vec2[4](vec2(0.0f, 0.0f), vec2(1.0f, 0.0f), vec2(0.0f, 1.0f), vec2(1.0f, 1.0f));

    layout(location = 0) out vec2 vTex;

    void main() {
        vTex = tex[gl_VertexIndex];
        gl_Position = vec4(pos[gl_VertexIndex], 0.0, 1.0);
    }
    `;
const $38052020172c3691$var$mipmapFragmentSource = `
    layout(set = 0, binding = 0) uniform sampler imgSampler;
    layout(set = 0, binding = 1) uniform texture2D img;

    layout(location = 0) in vec2 vTex;
    layout(location = 0) out vec4 outColor;

    void main() {
        outColor = texture(sampler2D(img, imgSampler), vTex);
    }
    `;
const $38052020172c3691$var$invertYPreMultiplyAlphaVertexSource = `
    #extension GL_EXT_samplerless_texture_functions : enable

    const vec2 pos[4] = vec2[4](vec2(-1.0f, 1.0f), vec2(1.0f, 1.0f), vec2(-1.0f, -1.0f), vec2(1.0f, -1.0f));
    const vec2 tex[4] = vec2[4](vec2(0.0f, 0.0f), vec2(1.0f, 0.0f), vec2(0.0f, 1.0f), vec2(1.0f, 1.0f));

    layout(set = 0, binding = 0) uniform texture2D img;

    #ifdef INVERTY
        layout(location = 0) out flat ivec2 vTextureSize;
    #endif

    void main() {
        #ifdef INVERTY
            vTextureSize = textureSize(img, 0);
        #endif
        gl_Position = vec4(pos[gl_VertexIndex], 0.0, 1.0);
    }
    `;
const $38052020172c3691$var$invertYPreMultiplyAlphaFragmentSource = `
    #extension GL_EXT_samplerless_texture_functions : enable

    layout(set = 0, binding = 0) uniform texture2D img;

    #ifdef INVERTY
        layout(location = 0) in flat ivec2 vTextureSize;
    #endif
    layout(location = 0) out vec4 outColor;

    void main() {
    #ifdef INVERTY
        vec4 color = texelFetch(img, ivec2(gl_FragCoord.x, vTextureSize.y - gl_FragCoord.y), 0);
    #else
        vec4 color = texelFetch(img, ivec2(gl_FragCoord.xy), 0);
    #endif
    #ifdef PREMULTIPLYALPHA
        color.rgb *= color.a;
    #endif
        outColor = color;
    }
    `;
const $38052020172c3691$var$invertYPreMultiplyAlphaWithOfstVertexSource = $38052020172c3691$var$invertYPreMultiplyAlphaVertexSource;
const $38052020172c3691$var$invertYPreMultiplyAlphaWithOfstFragmentSource = `
    #extension GL_EXT_samplerless_texture_functions : enable

    layout(set = 0, binding = 0) uniform texture2D img;
    layout(set = 0, binding = 1) uniform Params {
        float ofstX;
        float ofstY;
        float width;
        float height;
    };

    #ifdef INVERTY
        layout(location = 0) in flat ivec2 vTextureSize;
    #endif
    layout(location = 0) out vec4 outColor;

    void main() {
        if (gl_FragCoord.x < ofstX || gl_FragCoord.x >= ofstX + width) {
            discard;
        }
        if (gl_FragCoord.y < ofstY || gl_FragCoord.y >= ofstY + height) {
            discard;
        }
    #ifdef INVERTY
        vec4 color = texelFetch(img, ivec2(gl_FragCoord.x, ofstY + height - (gl_FragCoord.y - ofstY)), 0);
    #else
        vec4 color = texelFetch(img, ivec2(gl_FragCoord.xy), 0);
    #endif
    #ifdef PREMULTIPLYALPHA
        color.rgb *= color.a;
    #endif
        outColor = color;
    }
    `;
const $38052020172c3691$var$clearVertexSource = `
    const vec2 pos[4] = vec2[4](vec2(-1.0f, 1.0f), vec2(1.0f, 1.0f), vec2(-1.0f, -1.0f), vec2(1.0f, -1.0f));

    void main() {
        gl_Position = vec4(pos[gl_VertexIndex], 0.0, 1.0);
    }
    `;
const $38052020172c3691$var$clearFragmentSource = `
    layout(set = 0, binding = 0) uniform Uniforms {
        uniform vec4 color;
    };

    layout(location = 0) out vec4 outColor;

    void main() {
        outColor = color;
    }
    `;
const $38052020172c3691$var$copyVideoToTextureVertexSource = `
    struct VertexOutput {
        @builtin(position) Position : vec4<f32>,
        @location(0) fragUV : vec2<f32>
    }

    @vertex
    fn main(
        @builtin(vertex_index) VertexIndex : u32
    ) -> VertexOutput {
        var pos = array<vec2<f32>, 4>(
            vec2(-1.0,  1.0),
            vec2( 1.0,  1.0),
            vec2(-1.0, -1.0),
            vec2( 1.0, -1.0)
        );
        var tex = array<vec2<f32>, 4>(
            vec2(0.0, 0.0),
            vec2(1.0, 0.0),
            vec2(0.0, 1.0),
            vec2(1.0, 1.0)
        );

        var output: VertexOutput;

        output.Position = vec4<f32>(pos[VertexIndex], 0.0, 1.0);
        output.fragUV = tex[VertexIndex];

        return output;
    }
    `;
const $38052020172c3691$var$copyVideoToTextureFragmentSource = `
    @group(0) @binding(0) var videoSampler: sampler;
    @group(0) @binding(1) var videoTexture: texture_external;

    @fragment
    fn main(
        @location(0) fragUV: vec2<f32>
    ) -> @location(0) vec4<f32> {
        return textureSampleBaseClampToEdge(videoTexture, videoSampler, fragUV);
    }
    `;
const $38052020172c3691$var$copyVideoToTextureInvertYFragmentSource = `
    @group(0) @binding(0) var videoSampler: sampler;
    @group(0) @binding(1) var videoTexture: texture_external;

    @fragment
    fn main(
        @location(0) fragUV: vec2<f32>
    ) -> @location(0) vec4<f32> {
        return textureSampleBaseClampToEdge(videoTexture, videoSampler, vec2<f32>(fragUV.x, 1.0 - fragUV.y));
    }
    `;
var $38052020172c3691$var$PipelineType;
(function(PipelineType) {
    PipelineType[PipelineType["MipMap"] = 0] = "MipMap";
    PipelineType[PipelineType["InvertYPremultiplyAlpha"] = 1] = "InvertYPremultiplyAlpha";
    PipelineType[PipelineType["Clear"] = 2] = "Clear";
    PipelineType[PipelineType["InvertYPremultiplyAlphaWithOfst"] = 3] = "InvertYPremultiplyAlphaWithOfst";
})($38052020172c3691$var$PipelineType || ($38052020172c3691$var$PipelineType = {}));
var $38052020172c3691$var$VideoPipelineType;
(function(VideoPipelineType) {
    VideoPipelineType[VideoPipelineType["DontInvertY"] = 0] = "DontInvertY";
    VideoPipelineType[VideoPipelineType["InvertY"] = 1] = "InvertY";
})($38052020172c3691$var$VideoPipelineType || ($38052020172c3691$var$VideoPipelineType = {}));
const $38052020172c3691$var$shadersForPipelineType = [
    {
        vertex: $38052020172c3691$var$mipmapVertexSource,
        fragment: $38052020172c3691$var$mipmapFragmentSource
    },
    {
        vertex: $38052020172c3691$var$invertYPreMultiplyAlphaVertexSource,
        fragment: $38052020172c3691$var$invertYPreMultiplyAlphaFragmentSource
    },
    {
        vertex: $38052020172c3691$var$clearVertexSource,
        fragment: $38052020172c3691$var$clearFragmentSource
    },
    {
        vertex: $38052020172c3691$var$invertYPreMultiplyAlphaWithOfstVertexSource,
        fragment: $38052020172c3691$var$invertYPreMultiplyAlphaWithOfstFragmentSource
    }
];
const $38052020172c3691$export$eede4bbe1ec19c42 = {
    "": 0,
    r8unorm: 1,
    r8uint: 2,
    r8sint: 3,
    r16uint: 4,
    r16sint: 5,
    r16float: 6,
    rg8unorm: 7,
    rg8uint: 8,
    rg8sint: 9,
    r32uint: 10,
    r32sint: 11,
    r32float: 12,
    rg16uint: 13,
    rg16sint: 14,
    rg16float: 15,
    rgba8unorm: 16,
    "rgba8unorm-srgb": 17,
    rgba8uint: 18,
    rgba8sint: 19,
    bgra8unorm: 20,
    "bgra8unorm-srgb": 21,
    rgb10a2uint: 22,
    rgb10a2unorm: 23,
    /* rg11b10ufloat: this entry is dynamically added if the "RG11B10UFloatRenderable" extension is supported */ rg32uint: 24,
    rg32sint: 25,
    rg32float: 26,
    rgba16uint: 27,
    rgba16sint: 28,
    rgba16float: 29,
    rgba32uint: 30,
    rgba32sint: 31,
    rgba32float: 32,
    stencil8: 33,
    depth16unorm: 34,
    depth24plus: 35,
    "depth24plus-stencil8": 36,
    depth32float: 37,
    "depth32float-stencil8": 38
};
class $38052020172c3691$export$cfd7b9871d9e8b83 {
    //------------------------------------------------------------------------------
    //                         Initialization / Helpers
    //------------------------------------------------------------------------------
    constructor(engine, device, glslang, tintWASM, bufferManager, enabledExtensions){
        this._pipelines = {};
        this._compiledShaders = [];
        this._videoPipelines = {};
        this._videoCompiledShaders = [];
        this._deferredReleaseTextures = [];
        this._engine = engine;
        this._device = device;
        this._glslang = glslang;
        this._tintWASM = tintWASM;
        this._bufferManager = bufferManager;
        if (enabledExtensions.indexOf($hR6HG.FeatureName.RG11B10UFloatRenderable) !== -1) {
            const keys = Object.keys($38052020172c3691$export$eede4bbe1ec19c42);
            $38052020172c3691$export$eede4bbe1ec19c42[$hR6HG.TextureFormat.RG11B10UFloat] = $38052020172c3691$export$eede4bbe1ec19c42[keys[keys.length - 1]] + 1;
        }
        this._mipmapSampler = device.createSampler({
            minFilter: $hR6HG.FilterMode.Linear
        });
        this._videoSampler = device.createSampler({
            minFilter: $hR6HG.FilterMode.Linear
        });
        this._ubCopyWithOfst = this._bufferManager.createBuffer(16, $hR6HG.BufferUsage.Uniform | $hR6HG.BufferUsage.CopyDst, "UBCopyWithOffset").underlyingResource;
        this._getPipeline($hR6HG.TextureFormat.RGBA8Unorm);
        this._getVideoPipeline($hR6HG.TextureFormat.RGBA8Unorm);
    }
    _getPipeline(format, type = $38052020172c3691$var$PipelineType.MipMap, params) {
        const index = type === $38052020172c3691$var$PipelineType.MipMap ? 1 : type === $38052020172c3691$var$PipelineType.InvertYPremultiplyAlpha ? ((params.invertY ? 1 : 0) << 1) + ((params.premultiplyAlpha ? 1 : 0) << 2) : type === $38052020172c3691$var$PipelineType.Clear ? 8 : type === $38052020172c3691$var$PipelineType.InvertYPremultiplyAlphaWithOfst ? ((params.invertY ? 1 : 0) << 4) + ((params.premultiplyAlpha ? 1 : 0) << 5) : 0;
        if (!this._pipelines[format]) this._pipelines[format] = [];
        let pipelineAndBGL = this._pipelines[format][index];
        if (!pipelineAndBGL) {
            let defines = "#version 450\n";
            if (type === $38052020172c3691$var$PipelineType.InvertYPremultiplyAlpha || type === $38052020172c3691$var$PipelineType.InvertYPremultiplyAlphaWithOfst) {
                if (params.invertY) defines += "#define INVERTY\n";
                if (params.premultiplyAlpha) defines += "#define PREMULTIPLYALPHA\n";
            }
            let modules = this._compiledShaders[index];
            if (!modules) {
                let vertexCode = this._glslang.compileGLSL(defines + $38052020172c3691$var$shadersForPipelineType[type].vertex, "vertex");
                let fragmentCode = this._glslang.compileGLSL(defines + $38052020172c3691$var$shadersForPipelineType[type].fragment, "fragment");
                if (this._tintWASM) {
                    vertexCode = this._tintWASM.convertSpirV2WGSL(vertexCode);
                    fragmentCode = this._tintWASM.convertSpirV2WGSL(fragmentCode);
                }
                const vertexModule = this._device.createShaderModule({
                    code: vertexCode
                });
                const fragmentModule = this._device.createShaderModule({
                    code: fragmentCode
                });
                modules = this._compiledShaders[index] = [
                    vertexModule,
                    fragmentModule
                ];
            }
            const pipeline = this._device.createRenderPipeline({
                layout: $hR6HG.AutoLayoutMode.Auto,
                vertex: {
                    module: modules[0],
                    entryPoint: "main"
                },
                fragment: {
                    module: modules[1],
                    entryPoint: "main",
                    targets: [
                        {
                            format: format
                        }
                    ]
                },
                primitive: {
                    topology: $hR6HG.PrimitiveTopology.TriangleStrip,
                    stripIndexFormat: $hR6HG.IndexFormat.Uint16
                }
            });
            pipelineAndBGL = this._pipelines[format][index] = [
                pipeline,
                pipeline.getBindGroupLayout(0)
            ];
        }
        return pipelineAndBGL;
    }
    _getVideoPipeline(format, type = $38052020172c3691$var$VideoPipelineType.DontInvertY) {
        const index = type === $38052020172c3691$var$VideoPipelineType.InvertY ? 1 : 0;
        if (!this._videoPipelines[format]) this._videoPipelines[format] = [];
        let pipelineAndBGL = this._videoPipelines[format][index];
        if (!pipelineAndBGL) {
            let modules = this._videoCompiledShaders[index];
            if (!modules) {
                const vertexModule = this._device.createShaderModule({
                    code: $38052020172c3691$var$copyVideoToTextureVertexSource
                });
                const fragmentModule = this._device.createShaderModule({
                    code: index === 0 ? $38052020172c3691$var$copyVideoToTextureFragmentSource : $38052020172c3691$var$copyVideoToTextureInvertYFragmentSource
                });
                modules = this._videoCompiledShaders[index] = [
                    vertexModule,
                    fragmentModule
                ];
            }
            const pipeline = this._device.createRenderPipeline({
                label: `BabylonWebGPUDevice${this._engine.uniqueId}_CopyVideoToTexture_${format}_${index === 0 ? "DontInvertY" : "InvertY"}`,
                layout: $hR6HG.AutoLayoutMode.Auto,
                vertex: {
                    module: modules[0],
                    entryPoint: "main"
                },
                fragment: {
                    module: modules[1],
                    entryPoint: "main",
                    targets: [
                        {
                            format: format
                        }
                    ]
                },
                primitive: {
                    topology: $hR6HG.PrimitiveTopology.TriangleStrip,
                    stripIndexFormat: $hR6HG.IndexFormat.Uint16
                }
            });
            pipelineAndBGL = this._videoPipelines[format][index] = [
                pipeline,
                pipeline.getBindGroupLayout(0)
            ];
        }
        return pipelineAndBGL;
    }
    setCommandEncoder(encoder) {
        this._commandEncoderForCreation = encoder;
    }
    copyVideoToTexture(video, texture, format, invertY = false, commandEncoder) {
        const useOwnCommandEncoder = commandEncoder === undefined;
        const [pipeline, bindGroupLayout] = this._getVideoPipeline(format, invertY ? $38052020172c3691$var$VideoPipelineType.InvertY : $38052020172c3691$var$VideoPipelineType.DontInvertY);
        if (useOwnCommandEncoder) commandEncoder = this._device.createCommandEncoder({});
        commandEncoder.pushDebugGroup?.(`copy video to texture - invertY=${invertY}`);
        const webgpuHardwareTexture = texture._hardwareTexture;
        const renderPassDescriptor = {
            label: `BabylonWebGPUDevice${this._engine.uniqueId}_copyVideoToTexture_${format}_${invertY ? "InvertY" : "DontInvertY"}${texture.label ? "_" + texture.label : ""}`,
            colorAttachments: [
                {
                    view: webgpuHardwareTexture.underlyingResource.createView({
                        format: format,
                        dimension: $hR6HG.TextureViewDimension.E2d,
                        mipLevelCount: 1,
                        baseArrayLayer: 0,
                        baseMipLevel: 0,
                        arrayLayerCount: 1,
                        aspect: $hR6HG.TextureAspect.All
                    }),
                    loadOp: $hR6HG.LoadOp.Load,
                    storeOp: $hR6HG.StoreOp.Store
                }
            ]
        };
        const passEncoder = commandEncoder.beginRenderPass(renderPassDescriptor);
        const descriptor = {
            layout: bindGroupLayout,
            entries: [
                {
                    binding: 0,
                    resource: this._videoSampler
                },
                {
                    binding: 1,
                    resource: this._device.importExternalTexture({
                        source: video.underlyingResource
                    })
                }
            ]
        };
        const bindGroup = this._device.createBindGroup(descriptor);
        passEncoder.setPipeline(pipeline);
        passEncoder.setBindGroup(0, bindGroup);
        passEncoder.draw(4, 1, 0, 0);
        passEncoder.end();
        commandEncoder.popDebugGroup?.();
        if (useOwnCommandEncoder) {
            this._device.queue.submit([
                commandEncoder.finish()
            ]);
            commandEncoder = null;
        }
    }
    invertYPreMultiplyAlpha(gpuOrHdwTexture, width, height, format, invertY = false, premultiplyAlpha = false, faceIndex = 0, mipLevel = 0, layers = 1, ofstX = 0, ofstY = 0, rectWidth = 0, rectHeight = 0, commandEncoder, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    allowGPUOptimization) {
        const useRect = rectWidth !== 0;
        const useOwnCommandEncoder = commandEncoder === undefined;
        const [pipeline, bindGroupLayout] = this._getPipeline(format, useRect ? $38052020172c3691$var$PipelineType.InvertYPremultiplyAlphaWithOfst : $38052020172c3691$var$PipelineType.InvertYPremultiplyAlpha, {
            invertY: invertY,
            premultiplyAlpha: premultiplyAlpha
        });
        faceIndex = Math.max(faceIndex, 0);
        if (useOwnCommandEncoder) commandEncoder = this._device.createCommandEncoder({});
        commandEncoder.pushDebugGroup?.(`internal process texture - invertY=${invertY} premultiplyAlpha=${premultiplyAlpha}`);
        let gpuTexture;
        if ((0, $l46cr.WebGPUTextureHelper).IsHardwareTexture(gpuOrHdwTexture)) {
            gpuTexture = gpuOrHdwTexture.underlyingResource;
            if (!(invertY && !premultiplyAlpha && layers === 1 && faceIndex === 0)) // we optimize only for the most likely case (invertY=true, premultiplyAlpha=false, layers=1, faceIndex=0) to avoid dealing with big caches
            gpuOrHdwTexture = undefined;
        } else {
            gpuTexture = gpuOrHdwTexture;
            gpuOrHdwTexture = undefined;
        }
        if (!gpuTexture) return;
        if (useRect) this._bufferManager.setRawData(this._ubCopyWithOfst, 0, new Float32Array([
            ofstX,
            ofstY,
            rectWidth,
            rectHeight
        ]), 0, 16);
        const webgpuHardwareTexture = gpuOrHdwTexture;
        const outputTexture = webgpuHardwareTexture?._copyInvertYTempTexture ?? this.createTexture({
            width: width,
            height: height,
            layers: 1
        }, false, false, false, false, false, format, 1, commandEncoder, $hR6HG.TextureUsage.CopySrc | $hR6HG.TextureUsage.RenderAttachment | $hR6HG.TextureUsage.TextureBinding, undefined, "TempTextureForCopyWithInvertY");
        const renderPassDescriptor = webgpuHardwareTexture?._copyInvertYRenderPassDescr ?? {
            label: `BabylonWebGPUDevice${this._engine.uniqueId}_invertYPreMultiplyAlpha_${format}_${invertY ? "InvertY" : "DontInvertY"}_${premultiplyAlpha ? "PremultiplyAlpha" : "DontPremultiplyAlpha"}`,
            colorAttachments: [
                {
                    view: outputTexture.createView({
                        format: format,
                        dimension: $hR6HG.TextureViewDimension.E2d,
                        baseMipLevel: 0,
                        mipLevelCount: 1,
                        arrayLayerCount: 1,
                        baseArrayLayer: 0
                    }),
                    loadOp: $hR6HG.LoadOp.Load,
                    storeOp: $hR6HG.StoreOp.Store
                }
            ]
        };
        const passEncoder = commandEncoder.beginRenderPass(renderPassDescriptor);
        let bindGroup = useRect ? webgpuHardwareTexture?._copyInvertYBindGroupWithOfst : webgpuHardwareTexture?._copyInvertYBindGroup;
        if (!bindGroup) {
            const descriptor = {
                layout: bindGroupLayout,
                entries: [
                    {
                        binding: 0,
                        resource: gpuTexture.createView({
                            format: format,
                            dimension: $hR6HG.TextureViewDimension.E2d,
                            baseMipLevel: mipLevel,
                            mipLevelCount: 1,
                            arrayLayerCount: layers,
                            baseArrayLayer: faceIndex
                        })
                    }
                ]
            };
            if (useRect) descriptor.entries.push({
                binding: 1,
                resource: {
                    buffer: this._ubCopyWithOfst
                }
            });
            bindGroup = this._device.createBindGroup(descriptor);
        }
        passEncoder.setPipeline(pipeline);
        passEncoder.setBindGroup(0, bindGroup);
        passEncoder.draw(4, 1, 0, 0);
        passEncoder.end();
        commandEncoder.copyTextureToTexture({
            texture: outputTexture
        }, {
            texture: gpuTexture,
            mipLevel: mipLevel,
            origin: {
                x: 0,
                y: 0,
                z: faceIndex
            }
        }, {
            width: width,
            height: height,
            depthOrArrayLayers: 1
        });
        if (webgpuHardwareTexture) {
            webgpuHardwareTexture._copyInvertYTempTexture = outputTexture;
            webgpuHardwareTexture._copyInvertYRenderPassDescr = renderPassDescriptor;
            if (useRect) webgpuHardwareTexture._copyInvertYBindGroupWithOfst = bindGroup;
            else webgpuHardwareTexture._copyInvertYBindGroup = bindGroup;
        } else this._deferredReleaseTextures.push([
            outputTexture,
            null
        ]);
        commandEncoder.popDebugGroup?.();
        if (useOwnCommandEncoder) {
            this._device.queue.submit([
                commandEncoder.finish()
            ]);
            commandEncoder = null;
        }
    }
    copyWithInvertY(srcTextureView, format, renderPassDescriptor, commandEncoder) {
        const useOwnCommandEncoder = commandEncoder === undefined;
        const [pipeline, bindGroupLayout] = this._getPipeline(format, $38052020172c3691$var$PipelineType.InvertYPremultiplyAlpha, {
            invertY: true,
            premultiplyAlpha: false
        });
        if (useOwnCommandEncoder) commandEncoder = this._device.createCommandEncoder({});
        commandEncoder.pushDebugGroup?.(`internal copy texture with invertY`);
        const passEncoder = commandEncoder.beginRenderPass(renderPassDescriptor);
        const bindGroup = this._device.createBindGroup({
            layout: bindGroupLayout,
            entries: [
                {
                    binding: 0,
                    resource: srcTextureView
                }
            ]
        });
        passEncoder.setPipeline(pipeline);
        passEncoder.setBindGroup(0, bindGroup);
        passEncoder.draw(4, 1, 0, 0);
        passEncoder.end();
        commandEncoder.popDebugGroup?.();
        if (useOwnCommandEncoder) {
            this._device.queue.submit([
                commandEncoder.finish()
            ]);
            commandEncoder = null;
        }
    }
    //------------------------------------------------------------------------------
    //                               Creation
    //------------------------------------------------------------------------------
    createTexture(imageBitmap, hasMipmaps = false, generateMipmaps = false, invertY = false, premultiplyAlpha = false, is3D = false, format = $hR6HG.TextureFormat.RGBA8Unorm, sampleCount = 1, commandEncoder, usage = -1, additionalUsages = 0, label) {
        sampleCount = (0, $l46cr.WebGPUTextureHelper).GetSample(sampleCount);
        const layerCount = imageBitmap.layers || 1;
        const textureSize = {
            width: imageBitmap.width,
            height: imageBitmap.height,
            depthOrArrayLayers: layerCount
        };
        const renderAttachmentFlag = $38052020172c3691$export$eede4bbe1ec19c42[format] ? $hR6HG.TextureUsage.RenderAttachment : 0;
        const isCompressedFormat = (0, $l46cr.WebGPUTextureHelper).IsCompressedFormat(format);
        const mipLevelCount = hasMipmaps ? (0, $l46cr.WebGPUTextureHelper).ComputeNumMipmapLevels(imageBitmap.width, imageBitmap.height) : 1;
        const usages = usage >= 0 ? usage : $hR6HG.TextureUsage.CopySrc | $hR6HG.TextureUsage.CopyDst | $hR6HG.TextureUsage.TextureBinding;
        additionalUsages |= hasMipmaps && !isCompressedFormat ? $hR6HG.TextureUsage.CopySrc | renderAttachmentFlag : 0;
        if (!isCompressedFormat && !is3D) // we don't know in advance if the texture will be updated with copyExternalImageToTexture (which requires to have those flags), so we need to force the flags all the times
        additionalUsages |= renderAttachmentFlag | $hR6HG.TextureUsage.CopyDst;
        const gpuTexture = this._device.createTexture({
            label: `BabylonWebGPUDevice${this._engine.uniqueId}_Texture${is3D ? "3D" : "2D"}_${label ? label + "_" : ""}${textureSize.width}x${textureSize.height}x${textureSize.depthOrArrayLayers}_${hasMipmaps ? "wmips" : "womips"}_${format}_samples${sampleCount}`,
            size: textureSize,
            dimension: is3D ? $hR6HG.TextureDimension.E3d : $hR6HG.TextureDimension.E2d,
            format: format,
            usage: usages | additionalUsages,
            sampleCount: sampleCount,
            mipLevelCount: mipLevelCount
        });
        if ((0, $l46cr.WebGPUTextureHelper).IsImageBitmap(imageBitmap)) {
            this.updateTexture(imageBitmap, gpuTexture, imageBitmap.width, imageBitmap.height, layerCount, format, 0, 0, invertY, premultiplyAlpha, 0, 0);
            if (hasMipmaps && generateMipmaps) this.generateMipmaps(gpuTexture, format, mipLevelCount, 0, commandEncoder);
        }
        return gpuTexture;
    }
    createCubeTexture(imageBitmaps, hasMipmaps = false, generateMipmaps = false, invertY = false, premultiplyAlpha = false, format = $hR6HG.TextureFormat.RGBA8Unorm, sampleCount = 1, commandEncoder, usage = -1, additionalUsages = 0, label) {
        sampleCount = (0, $l46cr.WebGPUTextureHelper).GetSample(sampleCount);
        const width = (0, $l46cr.WebGPUTextureHelper).IsImageBitmapArray(imageBitmaps) ? imageBitmaps[0].width : imageBitmaps.width;
        const height = (0, $l46cr.WebGPUTextureHelper).IsImageBitmapArray(imageBitmaps) ? imageBitmaps[0].height : imageBitmaps.height;
        const renderAttachmentFlag = $38052020172c3691$export$eede4bbe1ec19c42[format] ? $hR6HG.TextureUsage.RenderAttachment : 0;
        const isCompressedFormat = (0, $l46cr.WebGPUTextureHelper).IsCompressedFormat(format);
        const mipLevelCount = hasMipmaps ? (0, $l46cr.WebGPUTextureHelper).ComputeNumMipmapLevels(width, height) : 1;
        const usages = usage >= 0 ? usage : $hR6HG.TextureUsage.CopySrc | $hR6HG.TextureUsage.CopyDst | $hR6HG.TextureUsage.TextureBinding;
        additionalUsages |= hasMipmaps && !isCompressedFormat ? $hR6HG.TextureUsage.CopySrc | renderAttachmentFlag : 0;
        if (!isCompressedFormat) // we don't know in advance if the texture will be updated with copyExternalImageToTexture (which requires to have those flags), so we need to force the flags all the times
        additionalUsages |= renderAttachmentFlag | $hR6HG.TextureUsage.CopyDst;
        const gpuTexture = this._device.createTexture({
            label: `BabylonWebGPUDevice${this._engine.uniqueId}_TextureCube_${label ? label + "_" : ""}${width}x${height}x6_${hasMipmaps ? "wmips" : "womips"}_${format}_samples${sampleCount}`,
            size: {
                width: width,
                height: height,
                depthOrArrayLayers: 6
            },
            dimension: $hR6HG.TextureDimension.E2d,
            format: format,
            usage: usages | additionalUsages,
            sampleCount: sampleCount,
            mipLevelCount: mipLevelCount
        });
        if ((0, $l46cr.WebGPUTextureHelper).IsImageBitmapArray(imageBitmaps)) {
            this.updateCubeTextures(imageBitmaps, gpuTexture, width, height, format, invertY, premultiplyAlpha, 0, 0);
            if (hasMipmaps && generateMipmaps) this.generateCubeMipmaps(gpuTexture, format, mipLevelCount, commandEncoder);
        }
        return gpuTexture;
    }
    generateCubeMipmaps(gpuTexture, format, mipLevelCount, commandEncoder) {
        const useOwnCommandEncoder = commandEncoder === undefined;
        if (useOwnCommandEncoder) commandEncoder = this._device.createCommandEncoder({});
        commandEncoder.pushDebugGroup?.(`create cube mipmaps - ${mipLevelCount} levels`);
        for(let f = 0; f < 6; ++f)this.generateMipmaps(gpuTexture, format, mipLevelCount, f, commandEncoder);
        commandEncoder.popDebugGroup?.();
        if (useOwnCommandEncoder) {
            this._device.queue.submit([
                commandEncoder.finish()
            ]);
            commandEncoder = null;
        }
    }
    generateMipmaps(gpuOrHdwTexture, format, mipLevelCount, faceIndex = 0, commandEncoder) {
        const useOwnCommandEncoder = commandEncoder === undefined;
        const [pipeline, bindGroupLayout] = this._getPipeline(format);
        faceIndex = Math.max(faceIndex, 0);
        if (useOwnCommandEncoder) commandEncoder = this._device.createCommandEncoder({});
        commandEncoder.pushDebugGroup?.(`create mipmaps for face #${faceIndex} - ${mipLevelCount} levels`);
        let gpuTexture;
        if ((0, $l46cr.WebGPUTextureHelper).IsHardwareTexture(gpuOrHdwTexture)) {
            gpuTexture = gpuOrHdwTexture.underlyingResource;
            gpuOrHdwTexture._mipmapGenRenderPassDescr = gpuOrHdwTexture._mipmapGenRenderPassDescr || [];
            gpuOrHdwTexture._mipmapGenBindGroup = gpuOrHdwTexture._mipmapGenBindGroup || [];
        } else {
            gpuTexture = gpuOrHdwTexture;
            gpuOrHdwTexture = undefined;
        }
        if (!gpuTexture) return;
        const webgpuHardwareTexture = gpuOrHdwTexture;
        for(let i = 1; i < mipLevelCount; ++i){
            const renderPassDescriptor = webgpuHardwareTexture?._mipmapGenRenderPassDescr[faceIndex]?.[i - 1] ?? {
                label: `BabylonWebGPUDevice${this._engine.uniqueId}_generateMipmaps_${format}_faceIndex${faceIndex}_level${i}`,
                colorAttachments: [
                    {
                        view: gpuTexture.createView({
                            format: format,
                            dimension: $hR6HG.TextureViewDimension.E2d,
                            baseMipLevel: i,
                            mipLevelCount: 1,
                            arrayLayerCount: 1,
                            baseArrayLayer: faceIndex
                        }),
                        loadOp: $hR6HG.LoadOp.Load,
                        storeOp: $hR6HG.StoreOp.Store
                    }
                ]
            };
            if (webgpuHardwareTexture) {
                webgpuHardwareTexture._mipmapGenRenderPassDescr[faceIndex] = webgpuHardwareTexture._mipmapGenRenderPassDescr[faceIndex] || [];
                webgpuHardwareTexture._mipmapGenRenderPassDescr[faceIndex][i - 1] = renderPassDescriptor;
            }
            const passEncoder = commandEncoder.beginRenderPass(renderPassDescriptor);
            const bindGroup = webgpuHardwareTexture?._mipmapGenBindGroup[faceIndex]?.[i - 1] ?? this._device.createBindGroup({
                layout: bindGroupLayout,
                entries: [
                    {
                        binding: 0,
                        resource: this._mipmapSampler
                    },
                    {
                        binding: 1,
                        resource: gpuTexture.createView({
                            format: format,
                            dimension: $hR6HG.TextureViewDimension.E2d,
                            baseMipLevel: i - 1,
                            mipLevelCount: 1,
                            arrayLayerCount: 1,
                            baseArrayLayer: faceIndex
                        })
                    }
                ]
            });
            if (webgpuHardwareTexture) {
                webgpuHardwareTexture._mipmapGenBindGroup[faceIndex] = webgpuHardwareTexture._mipmapGenBindGroup[faceIndex] || [];
                webgpuHardwareTexture._mipmapGenBindGroup[faceIndex][i - 1] = bindGroup;
            }
            passEncoder.setPipeline(pipeline);
            passEncoder.setBindGroup(0, bindGroup);
            passEncoder.draw(4, 1, 0, 0);
            passEncoder.end();
        }
        commandEncoder.popDebugGroup?.();
        if (useOwnCommandEncoder) {
            this._device.queue.submit([
                commandEncoder.finish()
            ]);
            commandEncoder = null;
        }
    }
    createGPUTextureForInternalTexture(texture, width, height, depth, creationFlags) {
        if (!texture._hardwareTexture) texture._hardwareTexture = new (0, $4JXMh.WebGPUHardwareTexture)();
        if (width === undefined) width = texture.width;
        if (height === undefined) height = texture.height;
        if (depth === undefined) depth = texture.depth;
        const gpuTextureWrapper = texture._hardwareTexture;
        const isStorageTexture = ((creationFlags ?? 0) & 1) !== 0;
        gpuTextureWrapper.format = (0, $l46cr.WebGPUTextureHelper).GetWebGPUTextureFormat(texture.type, texture.format, texture._useSRGBBuffer);
        gpuTextureWrapper.textureUsages = texture._source === (0, $b9e4a.InternalTextureSource).RenderTarget || texture.source === (0, $b9e4a.InternalTextureSource).MultiRenderTarget ? $hR6HG.TextureUsage.TextureBinding | $hR6HG.TextureUsage.CopySrc | $hR6HG.TextureUsage.RenderAttachment : texture._source === (0, $b9e4a.InternalTextureSource).DepthStencil ? $hR6HG.TextureUsage.TextureBinding | $hR6HG.TextureUsage.RenderAttachment : -1;
        gpuTextureWrapper.textureAdditionalUsages = isStorageTexture ? $hR6HG.TextureUsage.StorageBinding : 0;
        const hasMipMaps = texture.generateMipMaps;
        const layerCount = depth || 1;
        let mipmapCount;
        if (texture._maxLodLevel !== null) mipmapCount = texture._maxLodLevel;
        else mipmapCount = hasMipMaps ? (0, $l46cr.WebGPUTextureHelper).ComputeNumMipmapLevels(width, height) : 1;
        if (texture.isCube) {
            const gpuTexture = this.createCubeTexture({
                width: width,
                height: height
            }, texture.generateMipMaps, texture.generateMipMaps, texture.invertY, false, gpuTextureWrapper.format, 1, this._commandEncoderForCreation, gpuTextureWrapper.textureUsages, gpuTextureWrapper.textureAdditionalUsages, texture.label);
            gpuTextureWrapper.set(gpuTexture);
            const arrayLayerCount = texture.is3D ? 1 : layerCount;
            const format = (0, $l46cr.WebGPUTextureHelper).GetDepthFormatOnly(gpuTextureWrapper.format);
            const aspect = (0, $l46cr.WebGPUTextureHelper).HasDepthAndStencilAspects(gpuTextureWrapper.format) ? $hR6HG.TextureAspect.DepthOnly : $hR6HG.TextureAspect.All;
            const dimension = texture.is2DArray ? $hR6HG.TextureViewDimension.CubeArray : $hR6HG.TextureViewDimension.Cube;
            gpuTextureWrapper.createView({
                label: `BabylonWebGPUDevice${this._engine.uniqueId}_TextureViewCube${texture.is2DArray ? "_Array" + arrayLayerCount : ""}_${width}x${height}_${hasMipMaps ? "wmips" : "womips"}_${format}_${dimension}_${aspect}`,
                format: format,
                dimension: dimension,
                mipLevelCount: mipmapCount,
                baseArrayLayer: 0,
                baseMipLevel: 0,
                arrayLayerCount: 6,
                aspect: aspect
            }, isStorageTexture);
        } else {
            const gpuTexture = this.createTexture({
                width: width,
                height: height,
                layers: layerCount
            }, texture.generateMipMaps, texture.generateMipMaps, texture.invertY, false, texture.is3D, gpuTextureWrapper.format, 1, this._commandEncoderForCreation, gpuTextureWrapper.textureUsages, gpuTextureWrapper.textureAdditionalUsages, texture.label);
            gpuTextureWrapper.set(gpuTexture);
            const arrayLayerCount = texture.is3D ? 1 : layerCount;
            const format = (0, $l46cr.WebGPUTextureHelper).GetDepthFormatOnly(gpuTextureWrapper.format);
            const aspect = (0, $l46cr.WebGPUTextureHelper).HasDepthAndStencilAspects(gpuTextureWrapper.format) ? $hR6HG.TextureAspect.DepthOnly : $hR6HG.TextureAspect.All;
            const dimension = texture.is2DArray ? $hR6HG.TextureViewDimension.E2dArray : texture.is3D ? $hR6HG.TextureDimension.E3d : $hR6HG.TextureViewDimension.E2d;
            gpuTextureWrapper.createView({
                label: `BabylonWebGPUDevice${this._engine.uniqueId}_TextureView${texture.is3D ? "3D" : "2D"}${texture.is2DArray ? "_Array" + arrayLayerCount : ""}_${width}x${height}_${hasMipMaps ? "wmips" : "womips"}_${format}_${dimension}_${aspect}`,
                format: format,
                dimension: dimension,
                mipLevelCount: mipmapCount,
                baseArrayLayer: 0,
                baseMipLevel: 0,
                arrayLayerCount: arrayLayerCount,
                aspect: aspect
            }, isStorageTexture);
        }
        texture.width = texture.baseWidth = width;
        texture.height = texture.baseHeight = height;
        texture.depth = texture.baseDepth = depth;
        this.createMSAATexture(texture, texture.samples);
        return gpuTextureWrapper;
    }
    createMSAATexture(texture, samples, releaseExisting = true, index = -1) {
        const gpuTextureWrapper = texture._hardwareTexture;
        if (releaseExisting) gpuTextureWrapper?.releaseMSAATexture();
        if (!gpuTextureWrapper || (samples ?? 1) <= 1) return;
        const width = texture.width;
        const height = texture.height;
        const gpuMSAATexture = this.createTexture({
            width: width,
            height: height,
            layers: 1
        }, false, false, false, false, false, gpuTextureWrapper.format, samples, this._commandEncoderForCreation, $hR6HG.TextureUsage.RenderAttachment, 0, texture.label ? "MSAA" + texture.label : undefined);
        gpuTextureWrapper.setMSAATexture(gpuMSAATexture, index);
    }
    //------------------------------------------------------------------------------
    //                                  Update
    //------------------------------------------------------------------------------
    updateCubeTextures(imageBitmaps, gpuTexture, width, height, format, invertY = false, premultiplyAlpha = false, offsetX = 0, offsetY = 0) {
        const faces = [
            0,
            3,
            1,
            4,
            2,
            5
        ];
        for(let f = 0; f < faces.length; ++f){
            const imageBitmap = imageBitmaps[faces[f]];
            this.updateTexture(imageBitmap, gpuTexture, width, height, 1, format, f, 0, invertY, premultiplyAlpha, offsetX, offsetY);
        }
    }
    // TODO WEBGPU handle data source not being in the same format than the destination texture?
    updateTexture(imageBitmap, texture, width, height, layers, format, faceIndex = 0, mipLevel = 0, invertY = false, premultiplyAlpha = false, offsetX = 0, offsetY = 0, allowGPUOptimization) {
        const gpuTexture = (0, $l46cr.WebGPUTextureHelper).IsInternalTexture(texture) ? texture._hardwareTexture.underlyingResource : texture;
        const blockInformation = (0, $l46cr.WebGPUTextureHelper).GetBlockInformationFromFormat(format);
        const gpuOrHdwTexture = (0, $l46cr.WebGPUTextureHelper).IsInternalTexture(texture) ? texture._hardwareTexture : texture;
        const textureCopyView = {
            texture: gpuTexture,
            origin: {
                x: offsetX,
                y: offsetY,
                z: Math.max(faceIndex, 0)
            },
            mipLevel: mipLevel,
            premultipliedAlpha: premultiplyAlpha
        };
        const textureExtent = {
            width: Math.ceil(width / blockInformation.width) * blockInformation.width,
            height: Math.ceil(height / blockInformation.height) * blockInformation.height,
            depthOrArrayLayers: layers || 1
        };
        if (imageBitmap.byteLength !== undefined) {
            imageBitmap;
            const bytesPerRow = Math.ceil(width / blockInformation.width) * blockInformation.length;
            const aligned = Math.ceil(bytesPerRow / 256) * 256 === bytesPerRow;
            if (aligned) {
                const commandEncoder = this._device.createCommandEncoder({});
                const buffer = this._bufferManager.createRawBuffer(imageBitmap.byteLength, $hR6HG.BufferUsage.MapWrite | $hR6HG.BufferUsage.CopySrc, true, "TempBufferForUpdateTexture" + (gpuTexture ? "_" + gpuTexture.label : ""));
                const arrayBuffer = buffer.getMappedRange();
                new Uint8Array(arrayBuffer).set(imageBitmap);
                buffer.unmap();
                commandEncoder.copyBufferToTexture({
                    buffer: buffer,
                    offset: 0,
                    bytesPerRow: bytesPerRow,
                    rowsPerImage: height
                }, textureCopyView, textureExtent);
                this._device.queue.submit([
                    commandEncoder.finish()
                ]);
                this._bufferManager.releaseBuffer(buffer);
            } else this._device.queue.writeTexture(textureCopyView, imageBitmap, {
                offset: 0,
                bytesPerRow: bytesPerRow,
                rowsPerImage: height
            }, textureExtent);
            if (invertY || premultiplyAlpha) {
                if ((0, $l46cr.WebGPUTextureHelper).IsInternalTexture(texture)) {
                    const dontUseRect = offsetX === 0 && offsetY === 0 && width === texture.width && height === texture.height;
                    this.invertYPreMultiplyAlpha(gpuOrHdwTexture, texture.width, texture.height, format, invertY, premultiplyAlpha, faceIndex, mipLevel, layers || 1, offsetX, offsetY, dontUseRect ? 0 : width, dontUseRect ? 0 : height, undefined, allowGPUOptimization);
                } else // we should never take this code path
                // eslint-disable-next-line no-throw-literal
                throw "updateTexture: Can't process the texture data because a GPUTexture was provided instead of an InternalTexture!";
            }
        } else {
            imageBitmap;
            if (invertY) {
                textureCopyView.premultipliedAlpha = false; // we are going to handle premultiplyAlpha ourselves
                // we must preprocess the image
                if ((0, $l46cr.WebGPUTextureHelper).IsInternalTexture(texture) && offsetX === 0 && offsetY === 0 && width === texture.width && height === texture.height) {
                    // optimization when the source image is the same size than the destination texture and offsets X/Y == 0:
                    // we simply copy the source to the destination and we apply the preprocessing on the destination
                    this._device.queue.copyExternalImageToTexture({
                        source: imageBitmap
                    }, textureCopyView, textureExtent);
                    this.invertYPreMultiplyAlpha(gpuOrHdwTexture, width, height, format, invertY, premultiplyAlpha, faceIndex, mipLevel, layers || 1, 0, 0, 0, 0, undefined, allowGPUOptimization);
                } else {
                    // we must apply the preprocessing on the source image before copying it into the destination texture
                    const commandEncoder = this._device.createCommandEncoder({});
                    // create a temp texture and copy the image to it
                    const srcTexture = this.createTexture({
                        width: width,
                        height: height,
                        layers: 1
                    }, false, false, false, false, false, format, 1, commandEncoder, $hR6HG.TextureUsage.CopySrc | $hR6HG.TextureUsage.TextureBinding, undefined, "TempTextureForUpdateTexture");
                    this._deferredReleaseTextures.push([
                        srcTexture,
                        null
                    ]);
                    textureExtent.depthOrArrayLayers = 1;
                    this._device.queue.copyExternalImageToTexture({
                        source: imageBitmap
                    }, {
                        texture: srcTexture
                    }, textureExtent);
                    textureExtent.depthOrArrayLayers = layers || 1;
                    // apply the preprocessing to this temp texture
                    this.invertYPreMultiplyAlpha(srcTexture, width, height, format, invertY, premultiplyAlpha, faceIndex, mipLevel, layers || 1, 0, 0, 0, 0, commandEncoder, allowGPUOptimization);
                    // copy the temp texture to the destination texture
                    commandEncoder.copyTextureToTexture({
                        texture: srcTexture
                    }, textureCopyView, textureExtent);
                    this._device.queue.submit([
                        commandEncoder.finish()
                    ]);
                }
            } else // no preprocessing: direct copy to destination texture
            this._device.queue.copyExternalImageToTexture({
                source: imageBitmap
            }, textureCopyView, textureExtent);
        }
    }
    readPixels(texture, x, y, width, height, format, faceIndex = 0, mipLevel = 0, buffer = null, noDataConversion = false) {
        const blockInformation = (0, $l46cr.WebGPUTextureHelper).GetBlockInformationFromFormat(format);
        const bytesPerRow = Math.ceil(width / blockInformation.width) * blockInformation.length;
        const bytesPerRowAligned = Math.ceil(bytesPerRow / 256) * 256;
        const size = bytesPerRowAligned * height;
        const gpuBuffer = this._bufferManager.createRawBuffer(size, $hR6HG.BufferUsage.MapRead | $hR6HG.BufferUsage.CopyDst, undefined, "TempBufferForReadPixels" + (texture.label ? "_" + texture.label : ""));
        const commandEncoder = this._device.createCommandEncoder({});
        commandEncoder.copyTextureToBuffer({
            texture: texture,
            mipLevel: mipLevel,
            origin: {
                x: x,
                y: y,
                z: Math.max(faceIndex, 0)
            }
        }, {
            buffer: gpuBuffer,
            offset: 0,
            bytesPerRow: bytesPerRowAligned
        }, {
            width: width,
            height: height,
            depthOrArrayLayers: 1
        });
        this._device.queue.submit([
            commandEncoder.finish()
        ]);
        return this._bufferManager.readDataFromBuffer(gpuBuffer, size, width, height, bytesPerRow, bytesPerRowAligned, (0, $l46cr.WebGPUTextureHelper).GetTextureTypeFromFormat(format), 0, buffer, true, noDataConversion);
    }
    //------------------------------------------------------------------------------
    //                              Dispose
    //------------------------------------------------------------------------------
    releaseTexture(texture) {
        if ((0, $l46cr.WebGPUTextureHelper).IsInternalTexture(texture)) {
            const hardwareTexture = texture._hardwareTexture;
            const irradianceTexture = texture._irradianceTexture;
            // We can't destroy the objects just now because they could be used in the current frame - we delay the destroying after the end of the frame
            this._deferredReleaseTextures.push([
                hardwareTexture,
                irradianceTexture
            ]);
        } else this._deferredReleaseTextures.push([
            texture,
            null
        ]);
    }
    destroyDeferredTextures() {
        for(let i = 0; i < this._deferredReleaseTextures.length; ++i){
            const [hardwareTexture, irradianceTexture] = this._deferredReleaseTextures[i];
            if (hardwareTexture) {
                if ((0, $l46cr.WebGPUTextureHelper).IsHardwareTexture(hardwareTexture)) hardwareTexture.release();
                else hardwareTexture.destroy();
            }
            irradianceTexture?.dispose();
        }
        this._deferredReleaseTextures.length = 0;
    }
}

});
parcelRegister("4JXMh", function(module, exports) {

$parcel$export(module.exports, "WebGPUHardwareTexture", () => $3739bbfbb00a91d4$export$d2b8c447ae88a29f);

var $1VEEL = parcelRequire("1VEEL");

var $hR6HG = parcelRequire("hR6HG");

var $l46cr = parcelRequire("l46cr");
class $3739bbfbb00a91d4$export$d2b8c447ae88a29f {
    get underlyingResource() {
        return this._webgpuTexture;
    }
    getMSAATexture(index = 0) {
        return this._webgpuMSAATexture?.[index] ?? null;
    }
    setMSAATexture(texture, index = -1) {
        if (!this._webgpuMSAATexture) this._webgpuMSAATexture = [];
        if (index === -1) index = this._webgpuMSAATexture.length;
        this._webgpuMSAATexture[index] = texture;
    }
    releaseMSAATexture() {
        if (this._webgpuMSAATexture) {
            for (const texture of this._webgpuMSAATexture)texture?.destroy();
            this._webgpuMSAATexture = null;
        }
    }
    constructor(existingTexture = null){
        this.format = $hR6HG.TextureFormat.RGBA8Unorm;
        this.textureUsages = 0;
        this.textureAdditionalUsages = 0;
        this._webgpuTexture = existingTexture;
        this._webgpuMSAATexture = null;
        this.view = null;
        this.viewForWriting = null;
    }
    set(hardwareTexture) {
        this._webgpuTexture = hardwareTexture;
    }
    setUsage(_textureSource, generateMipMaps, is2DArray, isCube, is3D, width, height, depth) {
        let viewDimension = $hR6HG.TextureViewDimension.E2d;
        let arrayLayerCount = 1;
        if (isCube) {
            viewDimension = is2DArray ? $hR6HG.TextureViewDimension.CubeArray : $hR6HG.TextureViewDimension.Cube;
            arrayLayerCount = 6 * (depth || 1);
        } else if (is3D) viewDimension = $hR6HG.TextureViewDimension.E3d;
        else if (is2DArray) {
            viewDimension = $hR6HG.TextureViewDimension.E2dArray;
            arrayLayerCount = depth;
        }
        const format = (0, $l46cr.WebGPUTextureHelper).GetDepthFormatOnly(this.format);
        const aspect = (0, $l46cr.WebGPUTextureHelper).HasDepthAndStencilAspects(this.format) ? $hR6HG.TextureAspect.DepthOnly : $hR6HG.TextureAspect.All;
        this.createView({
            label: `TextureView${is3D ? "3D" : isCube ? "Cube" : "2D"}${is2DArray ? "_Array" + arrayLayerCount : ""}_${width}x${height}_${generateMipMaps ? "wmips" : "womips"}_${this.format}_${viewDimension}`,
            format: format,
            dimension: viewDimension,
            mipLevelCount: generateMipMaps ? (0, $1VEEL.Scalar).ILog2(Math.max(width, height)) + 1 : 1,
            baseArrayLayer: 0,
            baseMipLevel: 0,
            arrayLayerCount: arrayLayerCount,
            aspect: aspect
        });
    }
    createView(descriptor, createViewForWriting = false) {
        this.view = this._webgpuTexture.createView(descriptor);
        if (createViewForWriting && descriptor) {
            const saveNumMipMaps = descriptor.mipLevelCount;
            descriptor.mipLevelCount = 1;
            this.viewForWriting = this._webgpuTexture.createView(descriptor);
            descriptor.mipLevelCount = saveNumMipMaps;
        }
    }
    reset() {
        this._webgpuTexture = null;
        this._webgpuMSAATexture = null;
        this.view = null;
        this.viewForWriting = null;
    }
    release() {
        this._webgpuTexture?.destroy();
        this.releaseMSAATexture();
        this._copyInvertYTempTexture?.destroy();
        this.reset();
    }
}

});


parcelRegister("8U3Lx", function(module, exports) {

$parcel$export(module.exports, "WebGPUBufferManager", () => $67b6798222ab3c44$export$4855ec976fe39d8a);

var $iRIOb = parcelRequire("iRIOb");

var $3a58A = parcelRequire("3a58A");

var $k0sxV = parcelRequire("k0sxV");

var $hR6HG = parcelRequire("hR6HG");
class $67b6798222ab3c44$export$4855ec976fe39d8a {
    static _IsGPUBuffer(buffer) {
        return buffer.underlyingResource === undefined;
    }
    static _FlagsToString(flags, suffix = "") {
        let result = suffix;
        for(let i = 0; i <= 9; ++i)if (flags & 1 << i) {
            if (result) result += "_";
            result += $hR6HG.BufferUsage[1 << i];
        }
        return result;
    }
    constructor(engine, device){
        this._deferredReleaseBuffers = [];
        this._engine = engine;
        this._device = device;
    }
    createRawBuffer(viewOrSize, flags, mappedAtCreation = false, label) {
        const alignedLength = viewOrSize.byteLength !== undefined ? viewOrSize.byteLength + 3 & -4 : viewOrSize + 3 & -4; // 4 bytes alignments (because of the upload which requires this)
        const verticesBufferDescriptor = {
            label: "BabylonWebGPUDevice" + this._engine.uniqueId + "_" + $67b6798222ab3c44$export$4855ec976fe39d8a._FlagsToString(flags, label ?? "Buffer") + "_size" + alignedLength,
            mappedAtCreation: mappedAtCreation,
            size: alignedLength,
            usage: flags
        };
        return this._device.createBuffer(verticesBufferDescriptor);
    }
    createBuffer(viewOrSize, flags, label) {
        const isView = viewOrSize.byteLength !== undefined;
        const buffer = this.createRawBuffer(viewOrSize, flags, undefined, label);
        const dataBuffer = new (0, $iRIOb.WebGPUDataBuffer)(buffer);
        dataBuffer.references = 1;
        dataBuffer.capacity = isView ? viewOrSize.byteLength : viewOrSize;
        dataBuffer.engineId = this._engine.uniqueId;
        if (isView) this.setSubData(dataBuffer, 0, viewOrSize);
        return dataBuffer;
    }
    setRawData(buffer, dstByteOffset, src, srcByteOffset, byteLength) {
        this._device.queue.writeBuffer(buffer, dstByteOffset, src.buffer, srcByteOffset, byteLength);
    }
    setSubData(dataBuffer, dstByteOffset, src, srcByteOffset = 0, byteLength = 0) {
        const buffer = dataBuffer.underlyingResource;
        byteLength = byteLength || src.byteLength;
        byteLength = Math.min(byteLength, dataBuffer.capacity - dstByteOffset);
        // After Migration to Canary
        let chunkStart = src.byteOffset + srcByteOffset;
        let chunkEnd = chunkStart + byteLength;
        // 4 bytes alignments for upload
        const alignedLength = byteLength + 3 & -4;
        if (alignedLength !== byteLength) {
            const tempView = new Uint8Array(src.buffer.slice(chunkStart, chunkEnd));
            src = new Uint8Array(alignedLength);
            src.set(tempView);
            srcByteOffset = 0;
            chunkStart = 0;
            chunkEnd = alignedLength;
            byteLength = alignedLength;
        }
        // Chunk
        const maxChunk = 15728640;
        let offset = 0;
        while(chunkEnd - (chunkStart + offset) > maxChunk){
            this._device.queue.writeBuffer(buffer, dstByteOffset + offset, src.buffer, chunkStart + offset, maxChunk);
            offset += maxChunk;
        }
        this._device.queue.writeBuffer(buffer, dstByteOffset + offset, src.buffer, chunkStart + offset, byteLength - offset);
    }
    _getHalfFloatAsFloatRGBAArrayBuffer(dataLength, arrayBuffer, destArray) {
        if (!destArray) destArray = new Float32Array(dataLength);
        const srcData = new Uint16Array(arrayBuffer);
        while(dataLength--)destArray[dataLength] = (0, $3a58A.FromHalfFloat)(srcData[dataLength]);
        return destArray;
    }
    readDataFromBuffer(gpuBuffer, size, width, height, bytesPerRow, bytesPerRowAligned, type = 0, offset = 0, buffer = null, destroyBuffer = true, noDataConversion = false) {
        const floatFormat = type === 1 ? 2 : type === 2 ? 1 : 0;
        const engineId = this._engine.uniqueId;
        return new Promise((resolve, reject)=>{
            gpuBuffer.mapAsync($hR6HG.MapMode.Read, offset, size).then(()=>{
                const copyArrayBuffer = gpuBuffer.getMappedRange(offset, size);
                let data = buffer;
                if (noDataConversion) {
                    if (data === null) data = (0, $k0sxV.allocateAndCopyTypedBuffer)(type, size, true, copyArrayBuffer);
                    else data = (0, $k0sxV.allocateAndCopyTypedBuffer)(type, data.buffer, undefined, copyArrayBuffer);
                } else if (data === null) switch(floatFormat){
                    case 0:
                        data = new Uint8Array(size);
                        data.set(new Uint8Array(copyArrayBuffer));
                        break;
                    case 1:
                        // TODO WEBGPU use computer shaders (or render pass) to make the conversion?
                        data = this._getHalfFloatAsFloatRGBAArrayBuffer(size / 2, copyArrayBuffer);
                        break;
                    case 2:
                        data = new Float32Array(size / 4);
                        data.set(new Float32Array(copyArrayBuffer));
                        break;
                }
                else switch(floatFormat){
                    case 0:
                        data = new Uint8Array(data.buffer);
                        data.set(new Uint8Array(copyArrayBuffer));
                        break;
                    case 1:
                        // TODO WEBGPU use computer shaders (or render pass) to make the conversion?
                        data = this._getHalfFloatAsFloatRGBAArrayBuffer(size / 2, copyArrayBuffer, buffer);
                        break;
                    case 2:
                        data = new Float32Array(data.buffer);
                        data.set(new Float32Array(copyArrayBuffer));
                        break;
                }
                if (bytesPerRow !== bytesPerRowAligned) {
                    // TODO WEBGPU use computer shaders (or render pass) to build the final buffer data?
                    if (floatFormat === 1 && !noDataConversion) {
                        // half float have been converted to float above
                        bytesPerRow *= 2;
                        bytesPerRowAligned *= 2;
                    }
                    const data2 = new Uint8Array(data.buffer);
                    let offset = bytesPerRow, offset2 = 0;
                    for(let y = 1; y < height; ++y){
                        offset2 = y * bytesPerRowAligned;
                        for(let x = 0; x < bytesPerRow; ++x)data2[offset++] = data2[offset2++];
                    }
                    if (floatFormat !== 0 && !noDataConversion) data = new Float32Array(data2.buffer, 0, offset / 4);
                    else data = new Uint8Array(data2.buffer, 0, offset);
                }
                gpuBuffer.unmap();
                if (destroyBuffer) this.releaseBuffer(gpuBuffer);
                resolve(data);
            }, (reason)=>{
                if (this._engine.isDisposed || this._engine.uniqueId !== engineId) // The engine was disposed while waiting for the promise, or a context loss/restoration has occurred: don't reject
                resolve(new Uint8Array());
                else reject(reason);
            });
        });
    }
    releaseBuffer(buffer) {
        if ($67b6798222ab3c44$export$4855ec976fe39d8a._IsGPUBuffer(buffer)) {
            this._deferredReleaseBuffers.push(buffer);
            return true;
        }
        buffer.references--;
        if (buffer.references === 0) {
            this._deferredReleaseBuffers.push(buffer.underlyingResource);
            return true;
        }
        return false;
    }
    destroyDeferredBuffers() {
        for(let i = 0; i < this._deferredReleaseBuffers.length; ++i)this._deferredReleaseBuffers[i].destroy();
        this._deferredReleaseBuffers.length = 0;
    }
}

});
parcelRegister("iRIOb", function(module, exports) {

$parcel$export(module.exports, "WebGPUDataBuffer", () => $dbbfef438bb882e3$export$db8a39bb7dbb3158);

var $6zPKs = parcelRequire("6zPKs");
class $dbbfef438bb882e3$export$db8a39bb7dbb3158 extends (0, $6zPKs.DataBuffer) {
    constructor(resource, capacity = 0){
        super();
        // Used to make sure the buffer is not recreated twice after a context loss/restoration
        this.engineId = -1;
        this.capacity = capacity;
        this._buffer = resource;
    }
    get underlyingResource() {
        return this._buffer;
    }
}

});


parcelRegister("6okLJ", function(module, exports) {

$parcel$export(module.exports, "WebGPUCacheSampler", () => $4a75183fa92e3c26$export$7b35b3ae9d6d1117);
/* eslint-disable babylonjs/available */ /* eslint-disable jsdoc/require-jsdoc */ // eslint-disable-next-line @typescript-eslint/naming-convention

var $hR6HG = parcelRequire("hR6HG");
const $4a75183fa92e3c26$var$filterToBits = [
    0,
    0,
    3,
    7,
    0,
    2,
    6,
    2,
    4,
    1,
    5,
    3,
    1
];
// subtract 0x01FF from the comparison function value before indexing this array!
const $4a75183fa92e3c26$var$comparisonFunctionToBits = [
    0,
    64,
    32,
    96,
    16,
    80,
    48,
    112,
    8
];
const $4a75183fa92e3c26$var$filterNoMipToBits = [
    0,
    128,
    128,
    0,
    0,
    0,
    0,
    128,
    0,
    0,
    0,
    0,
    128
];
class $4a75183fa92e3c26$export$7b35b3ae9d6d1117 {
    constructor(device){
        this._samplers = {};
        this._device = device;
        this.disabled = false;
    }
    static GetSamplerHashCode(sampler) {
        // The WebGPU spec currently only allows values 1 and 4 for anisotropy
        const anisotropy = sampler._cachedAnisotropicFilteringLevel && sampler._cachedAnisotropicFilteringLevel > 1 ? 4 : 1;
        const code = $4a75183fa92e3c26$var$filterToBits[sampler.samplingMode] + $4a75183fa92e3c26$var$comparisonFunctionToBits[(sampler._comparisonFunction || 0x0202) - 0x0200 + 1] + $4a75183fa92e3c26$var$filterNoMipToBits[sampler.samplingMode] + // handle the lodMinClamp = lodMaxClamp = 0 case when no filter used for mip mapping
        ((sampler._cachedWrapU ?? 1) << 8) + ((sampler._cachedWrapV ?? 1) << 10) + ((sampler._cachedWrapR ?? 1) << 12) + ((sampler.useMipMaps ? 1 : 0) << 14) + // need to factor this in because _getSamplerFilterDescriptor depends on samplingMode AND useMipMaps!
        (anisotropy << 15);
        return code;
    }
    static _GetSamplerFilterDescriptor(sampler, anisotropy) {
        let magFilter, minFilter, mipmapFilter, lodMinClamp, lodMaxClamp;
        const useMipMaps = sampler.useMipMaps;
        switch(sampler.samplingMode){
            case 11:
                magFilter = $hR6HG.FilterMode.Linear;
                minFilter = $hR6HG.FilterMode.Linear;
                mipmapFilter = $hR6HG.FilterMode.Nearest;
                if (!useMipMaps) lodMinClamp = lodMaxClamp = 0;
                break;
            case 3:
            case 3:
                magFilter = $hR6HG.FilterMode.Linear;
                minFilter = $hR6HG.FilterMode.Linear;
                if (!useMipMaps) {
                    mipmapFilter = $hR6HG.FilterMode.Nearest;
                    lodMinClamp = lodMaxClamp = 0;
                } else mipmapFilter = $hR6HG.FilterMode.Linear;
                break;
            case 8:
                magFilter = $hR6HG.FilterMode.Nearest;
                minFilter = $hR6HG.FilterMode.Nearest;
                if (!useMipMaps) {
                    mipmapFilter = $hR6HG.FilterMode.Nearest;
                    lodMinClamp = lodMaxClamp = 0;
                } else mipmapFilter = $hR6HG.FilterMode.Linear;
                break;
            case 4:
                magFilter = $hR6HG.FilterMode.Nearest;
                minFilter = $hR6HG.FilterMode.Nearest;
                mipmapFilter = $hR6HG.FilterMode.Nearest;
                if (!useMipMaps) lodMinClamp = lodMaxClamp = 0;
                break;
            case 5:
                magFilter = $hR6HG.FilterMode.Nearest;
                minFilter = $hR6HG.FilterMode.Linear;
                mipmapFilter = $hR6HG.FilterMode.Nearest;
                if (!useMipMaps) lodMinClamp = lodMaxClamp = 0;
                break;
            case 6:
                magFilter = $hR6HG.FilterMode.Nearest;
                minFilter = $hR6HG.FilterMode.Linear;
                if (!useMipMaps) {
                    mipmapFilter = $hR6HG.FilterMode.Nearest;
                    lodMinClamp = lodMaxClamp = 0;
                } else mipmapFilter = $hR6HG.FilterMode.Linear;
                break;
            case 7:
                magFilter = $hR6HG.FilterMode.Nearest;
                minFilter = $hR6HG.FilterMode.Linear;
                mipmapFilter = $hR6HG.FilterMode.Nearest;
                lodMinClamp = lodMaxClamp = 0;
                break;
            case 1:
            case 1:
                magFilter = $hR6HG.FilterMode.Nearest;
                minFilter = $hR6HG.FilterMode.Nearest;
                mipmapFilter = $hR6HG.FilterMode.Nearest;
                lodMinClamp = lodMaxClamp = 0;
                break;
            case 9:
                magFilter = $hR6HG.FilterMode.Linear;
                minFilter = $hR6HG.FilterMode.Nearest;
                mipmapFilter = $hR6HG.FilterMode.Nearest;
                if (!useMipMaps) lodMinClamp = lodMaxClamp = 0;
                break;
            case 10:
                magFilter = $hR6HG.FilterMode.Linear;
                minFilter = $hR6HG.FilterMode.Nearest;
                if (!useMipMaps) {
                    mipmapFilter = $hR6HG.FilterMode.Nearest;
                    lodMinClamp = lodMaxClamp = 0;
                } else mipmapFilter = $hR6HG.FilterMode.Linear;
                break;
            case 2:
            case 2:
                magFilter = $hR6HG.FilterMode.Linear;
                minFilter = $hR6HG.FilterMode.Linear;
                mipmapFilter = $hR6HG.FilterMode.Nearest;
                lodMinClamp = lodMaxClamp = 0;
                break;
            case 12:
                magFilter = $hR6HG.FilterMode.Linear;
                minFilter = $hR6HG.FilterMode.Nearest;
                mipmapFilter = $hR6HG.FilterMode.Nearest;
                lodMinClamp = lodMaxClamp = 0;
                break;
            default:
                magFilter = $hR6HG.FilterMode.Nearest;
                minFilter = $hR6HG.FilterMode.Nearest;
                mipmapFilter = $hR6HG.FilterMode.Nearest;
                lodMinClamp = lodMaxClamp = 0;
                break;
        }
        if (anisotropy > 1 && (lodMinClamp !== 0 || lodMaxClamp !== 0) && mipmapFilter !== $hR6HG.FilterMode.Nearest) return {
            magFilter: $hR6HG.FilterMode.Linear,
            minFilter: $hR6HG.FilterMode.Linear,
            mipmapFilter: $hR6HG.FilterMode.Linear,
            anisotropyEnabled: true
        };
        return {
            magFilter: magFilter,
            minFilter: minFilter,
            mipmapFilter: mipmapFilter,
            lodMinClamp: lodMinClamp,
            lodMaxClamp: lodMaxClamp
        };
    }
    static _GetWrappingMode(mode) {
        switch(mode){
            case 1:
                return $hR6HG.AddressMode.Repeat;
            case 0:
                return $hR6HG.AddressMode.ClampToEdge;
            case 2:
                return $hR6HG.AddressMode.MirrorRepeat;
        }
        return $hR6HG.AddressMode.Repeat;
    }
    static _GetSamplerWrappingDescriptor(sampler) {
        return {
            addressModeU: this._GetWrappingMode(sampler._cachedWrapU),
            addressModeV: this._GetWrappingMode(sampler._cachedWrapV),
            addressModeW: this._GetWrappingMode(sampler._cachedWrapR)
        };
    }
    static _GetSamplerDescriptor(sampler, label) {
        // The WebGPU spec currently only allows values 1 and 4 for anisotropy
        const anisotropy = sampler.useMipMaps && sampler._cachedAnisotropicFilteringLevel && sampler._cachedAnisotropicFilteringLevel > 1 ? 4 : 1;
        const filterDescriptor = this._GetSamplerFilterDescriptor(sampler, anisotropy);
        return {
            label: label,
            ...filterDescriptor,
            ...this._GetSamplerWrappingDescriptor(sampler),
            compare: sampler._comparisonFunction ? $4a75183fa92e3c26$export$7b35b3ae9d6d1117.GetCompareFunction(sampler._comparisonFunction) : undefined,
            maxAnisotropy: filterDescriptor.anisotropyEnabled ? anisotropy : 1
        };
    }
    static GetCompareFunction(compareFunction) {
        switch(compareFunction){
            case 519:
                return $hR6HG.CompareFunction.Always;
            case 514:
                return $hR6HG.CompareFunction.Equal;
            case 516:
                return $hR6HG.CompareFunction.Greater;
            case 518:
                return $hR6HG.CompareFunction.GreaterEqual;
            case 513:
                return $hR6HG.CompareFunction.Less;
            case 515:
                return $hR6HG.CompareFunction.LessEqual;
            case 512:
                return $hR6HG.CompareFunction.Never;
            case 517:
                return $hR6HG.CompareFunction.NotEqual;
            default:
                return $hR6HG.CompareFunction.Less;
        }
    }
    getSampler(sampler, bypassCache = false, hash = 0, label) {
        if (this.disabled) return this._device.createSampler($4a75183fa92e3c26$export$7b35b3ae9d6d1117._GetSamplerDescriptor(sampler, label));
        if (bypassCache) hash = 0;
        else if (hash === 0) hash = $4a75183fa92e3c26$export$7b35b3ae9d6d1117.GetSamplerHashCode(sampler);
        let gpuSampler = bypassCache ? undefined : this._samplers[hash];
        if (!gpuSampler) {
            gpuSampler = this._device.createSampler($4a75183fa92e3c26$export$7b35b3ae9d6d1117._GetSamplerDescriptor(sampler, label));
            if (!bypassCache) this._samplers[hash] = gpuSampler;
        }
        return gpuSampler;
    }
}

});

parcelRegister("6dQQy", function(module, exports) {

$parcel$export(module.exports, "WebGPUCacheRenderPipelineTree", () => $487cf33c41bb3c00$export$1fdb5364881fca0a);

var $UCDD1 = parcelRequire("UCDD1");
/** @internal */ class $487cf33c41bb3c00$var$NodeState {
    constructor(){
        this.values = {};
    }
    count() {
        let countNode = 0, countPipeline = this.pipeline ? 1 : 0;
        for(const value in this.values){
            const node = this.values[value];
            const [childCountNodes, childCoundPipeline] = node.count();
            countNode += childCountNodes;
            countPipeline += childCoundPipeline;
            countNode++;
        }
        return [
            countNode,
            countPipeline
        ];
    }
}
class $487cf33c41bb3c00$export$1fdb5364881fca0a extends (0, $UCDD1.WebGPUCacheRenderPipeline) {
    static GetNodeCounts() {
        const counts = $487cf33c41bb3c00$export$1fdb5364881fca0a._Cache.count();
        return {
            nodeCount: counts[0],
            pipelineCount: counts[1]
        };
    }
    static _GetPipelines(node, pipelines, curPath, curPathLen) {
        if (node.pipeline) {
            const path = curPath.slice();
            path.length = curPathLen;
            pipelines.push(path);
        }
        for(const value in node.values){
            const nnode = node.values[value];
            curPath[curPathLen] = parseInt(value);
            $487cf33c41bb3c00$export$1fdb5364881fca0a._GetPipelines(nnode, pipelines, curPath, curPathLen + 1);
        }
    }
    static GetPipelines() {
        const pipelines = [];
        $487cf33c41bb3c00$export$1fdb5364881fca0a._GetPipelines($487cf33c41bb3c00$export$1fdb5364881fca0a._Cache, pipelines, [], 0);
        return pipelines;
    }
    static ResetCache() {
        $487cf33c41bb3c00$export$1fdb5364881fca0a._Cache = new $487cf33c41bb3c00$var$NodeState();
    }
    reset() {
        this._nodeStack = [];
        this._nodeStack[0] = $487cf33c41bb3c00$export$1fdb5364881fca0a._Cache;
        super.reset();
    }
    _getRenderPipeline(param) {
        let node = this._nodeStack[this._stateDirtyLowestIndex];
        for(let i = this._stateDirtyLowestIndex; i < this._statesLength; ++i){
            let nn = node.values[this._states[i]];
            if (!nn) {
                nn = new $487cf33c41bb3c00$var$NodeState();
                node.values[this._states[i]] = nn;
            }
            node = nn;
            this._nodeStack[i + 1] = node;
        }
        param.token = node;
        param.pipeline = node.pipeline;
    }
    _setRenderPipeline(param) {
        param.token.pipeline = param.pipeline;
    }
}
$487cf33c41bb3c00$export$1fdb5364881fca0a._Cache = new $487cf33c41bb3c00$var$NodeState();

});
parcelRegister("UCDD1", function(module, exports) {

$parcel$export(module.exports, "WebGPUCacheRenderPipeline", () => $0aa333cffe805213$export$35f923de455dd7ad);
/* eslint-disable @typescript-eslint/naming-convention */ /* eslint-disable babylonjs/available */ /* eslint-disable jsdoc/require-jsdoc */ 
var $hR6HG = parcelRequire("hR6HG");

var $b4i1f = parcelRequire("b4i1f");

var $jXMwB = parcelRequire("jXMwB");

var $l46cr = parcelRequire("l46cr");

var $4ObYT = parcelRequire("4ObYT");
var $0aa333cffe805213$var$StatePosition;
(function(StatePosition) {
    StatePosition[StatePosition["StencilReadMask"] = 0] = "StencilReadMask";
    StatePosition[StatePosition["StencilWriteMask"] = 1] = "StencilWriteMask";
    //DepthBiasClamp = 1, // not used, so remove it to improve perf
    StatePosition[StatePosition["DepthBias"] = 2] = "DepthBias";
    StatePosition[StatePosition["DepthBiasSlopeScale"] = 3] = "DepthBiasSlopeScale";
    StatePosition[StatePosition["DepthStencilState"] = 4] = "DepthStencilState";
    StatePosition[StatePosition["MRTAttachments1"] = 5] = "MRTAttachments1";
    StatePosition[StatePosition["MRTAttachments2"] = 6] = "MRTAttachments2";
    StatePosition[StatePosition["RasterizationState"] = 7] = "RasterizationState";
    StatePosition[StatePosition["ColorStates"] = 8] = "ColorStates";
    StatePosition[StatePosition["ShaderStage"] = 9] = "ShaderStage";
    StatePosition[StatePosition["TextureStage"] = 10] = "TextureStage";
    StatePosition[StatePosition["VertexState"] = 11] = "VertexState";
    StatePosition[StatePosition["NumStates"] = 12] = "NumStates";
})($0aa333cffe805213$var$StatePosition || ($0aa333cffe805213$var$StatePosition = {}));
const $0aa333cffe805213$var$alphaBlendFactorToIndex = {
    0: 1,
    1: 2,
    0x0300: 3,
    0x0301: 4,
    0x0302: 5,
    0x0303: 6,
    0x0304: 7,
    0x0305: 8,
    0x0306: 9,
    0x0307: 10,
    0x0308: 11,
    0x8001: 12,
    0x8002: 13,
    0x8003: 12,
    0x8004: 13
};
const $0aa333cffe805213$var$stencilOpToIndex = {
    0x0000: 0,
    0x1e00: 1,
    0x1e01: 2,
    0x1e02: 3,
    0x1e03: 4,
    0x150a: 5,
    0x8507: 6,
    0x8508: 7
};
const $0aa333cffe805213$var$vertexBufferKindForNonFloatProcessing = {
    [(0, $b4i1f.VertexBuffer).PositionKind]: true,
    [(0, $b4i1f.VertexBuffer).NormalKind]: true,
    [(0, $b4i1f.VertexBuffer).TangentKind]: true,
    [(0, $b4i1f.VertexBuffer).UVKind]: true,
    [(0, $b4i1f.VertexBuffer).UV2Kind]: true,
    [(0, $b4i1f.VertexBuffer).UV3Kind]: true,
    [(0, $b4i1f.VertexBuffer).UV4Kind]: true,
    [(0, $b4i1f.VertexBuffer).UV5Kind]: true,
    [(0, $b4i1f.VertexBuffer).UV6Kind]: true,
    [(0, $b4i1f.VertexBuffer).ColorKind]: true,
    [(0, $b4i1f.VertexBuffer).ColorInstanceKind]: true,
    [(0, $b4i1f.VertexBuffer).MatricesIndicesKind]: true,
    [(0, $b4i1f.VertexBuffer).MatricesWeightsKind]: true,
    [(0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind]: true,
    [(0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind]: true
};
class $0aa333cffe805213$export$35f923de455dd7ad {
    static _IsSignedType(type) {
        switch(type){
            case (0, $b4i1f.VertexBuffer).BYTE:
            case (0, $b4i1f.VertexBuffer).SHORT:
            case (0, $b4i1f.VertexBuffer).INT:
            case (0, $b4i1f.VertexBuffer).FLOAT:
                return true;
            case (0, $b4i1f.VertexBuffer).UNSIGNED_BYTE:
            case (0, $b4i1f.VertexBuffer).UNSIGNED_SHORT:
            case (0, $b4i1f.VertexBuffer).UNSIGNED_INT:
                return false;
            default:
                throw new Error(`Invalid type '${type}'`);
        }
    }
    constructor(device, emptyVertexBuffer){
        this.mrtTextureCount = 0;
        this._device = device;
        this._useTextureStage = true; // we force usage because we must handle depth textures with "float" filtering, which can't be fixed by a caps (like "textureFloatLinearFiltering" can for float textures)
        this._states = new Array(30); // pre-allocate enough room so that no new allocation will take place afterwards
        this._statesLength = 0;
        this._stateDirtyLowestIndex = 0;
        this._emptyVertexBuffer = emptyVertexBuffer;
        this._mrtFormats = [];
        this._parameter = {
            token: undefined,
            pipeline: null
        };
        this.disabled = false;
        this.vertexBuffers = [];
        this._kMaxVertexBufferStride = device.limits.maxVertexBufferArrayStride || 2048;
        this.reset();
    }
    reset() {
        this._isDirty = true;
        this.vertexBuffers.length = 0;
        this.setAlphaToCoverage(false);
        this.resetDepthCullingState();
        this.setClampDepth(false);
        this.setDepthBias(0);
        //this.setDepthBiasClamp(0);
        this._webgpuColorFormat = [
            $hR6HG.TextureFormat.BGRA8Unorm
        ];
        this.setColorFormat($hR6HG.TextureFormat.BGRA8Unorm);
        this.setMRT([]);
        this.setAlphaBlendEnabled(false);
        this.setAlphaBlendFactors([
            null,
            null,
            null,
            null
        ], [
            null,
            null
        ]);
        this.setWriteMask(0xf);
        this.setDepthStencilFormat($hR6HG.TextureFormat.Depth24PlusStencil8);
        this.setStencilEnabled(false);
        this.resetStencilState();
        this.setBuffers(null, null, null);
        this._setTextureState(0);
    }
    get colorFormats() {
        return this._mrtAttachments1 > 0 ? this._mrtFormats : this._webgpuColorFormat;
    }
    getRenderPipeline(fillMode, effect, sampleCount, textureState = 0) {
        sampleCount = (0, $l46cr.WebGPUTextureHelper).GetSample(sampleCount);
        if (this.disabled) {
            const topology = $0aa333cffe805213$export$35f923de455dd7ad._GetTopology(fillMode);
            this._setVertexState(effect); // to fill this.vertexBuffers with correct data
            this._setTextureState(textureState);
            this._parameter.pipeline = this._createRenderPipeline(effect, topology, sampleCount);
            $0aa333cffe805213$export$35f923de455dd7ad.NumCacheMiss++;
            $0aa333cffe805213$export$35f923de455dd7ad._NumPipelineCreationCurrentFrame++;
            return this._parameter.pipeline;
        }
        this._setShaderStage(effect.uniqueId);
        this._setRasterizationState(fillMode, sampleCount);
        this._setColorStates();
        this._setDepthStencilState();
        this._setVertexState(effect);
        this._setTextureState(textureState);
        this.lastStateDirtyLowestIndex = this._stateDirtyLowestIndex;
        if (!this._isDirty && this._parameter.pipeline) {
            this._stateDirtyLowestIndex = this._statesLength;
            $0aa333cffe805213$export$35f923de455dd7ad.NumCacheHitWithoutHash++;
            return this._parameter.pipeline;
        }
        this._getRenderPipeline(this._parameter);
        this._isDirty = false;
        this._stateDirtyLowestIndex = this._statesLength;
        if (this._parameter.pipeline) {
            $0aa333cffe805213$export$35f923de455dd7ad.NumCacheHitWithHash++;
            return this._parameter.pipeline;
        }
        const topology = $0aa333cffe805213$export$35f923de455dd7ad._GetTopology(fillMode);
        this._parameter.pipeline = this._createRenderPipeline(effect, topology, sampleCount);
        this._setRenderPipeline(this._parameter);
        $0aa333cffe805213$export$35f923de455dd7ad.NumCacheMiss++;
        $0aa333cffe805213$export$35f923de455dd7ad._NumPipelineCreationCurrentFrame++;
        return this._parameter.pipeline;
    }
    endFrame() {
        $0aa333cffe805213$export$35f923de455dd7ad.NumPipelineCreationLastFrame = $0aa333cffe805213$export$35f923de455dd7ad._NumPipelineCreationCurrentFrame;
        $0aa333cffe805213$export$35f923de455dd7ad._NumPipelineCreationCurrentFrame = 0;
    }
    setAlphaToCoverage(enabled) {
        this._alphaToCoverageEnabled = enabled;
    }
    setFrontFace(frontFace) {
        this._frontFace = frontFace;
    }
    setCullEnabled(enabled) {
        this._cullEnabled = enabled;
    }
    setCullFace(cullFace) {
        this._cullFace = cullFace;
    }
    setClampDepth(clampDepth) {
        this._clampDepth = clampDepth;
    }
    resetDepthCullingState() {
        this.setDepthCullingState(false, 2, 1, 0, 0, true, true, 519);
    }
    setDepthCullingState(cullEnabled, frontFace, cullFace, zOffset, zOffsetUnits, depthTestEnabled, depthWriteEnabled, depthCompare) {
        this._depthWriteEnabled = depthWriteEnabled;
        this._depthTestEnabled = depthTestEnabled;
        this._depthCompare = (depthCompare ?? 519) - 0x0200;
        this._cullFace = cullFace;
        this._cullEnabled = cullEnabled;
        this._frontFace = frontFace;
        this.setDepthBiasSlopeScale(zOffset);
        this.setDepthBias(zOffsetUnits);
    }
    setDepthBias(depthBias) {
        if (this._depthBias !== depthBias) {
            this._depthBias = depthBias;
            this._states[$0aa333cffe805213$var$StatePosition.DepthBias] = depthBias;
            this._isDirty = true;
            this._stateDirtyLowestIndex = Math.min(this._stateDirtyLowestIndex, $0aa333cffe805213$var$StatePosition.DepthBias);
        }
    }
    /*public setDepthBiasClamp(depthBiasClamp: number): void {
        if (this._depthBiasClamp !== depthBiasClamp) {
            this._depthBiasClamp = depthBiasClamp;
            this._states[StatePosition.DepthBiasClamp] = depthBiasClamp.toString();
            this._isDirty = true;
        }
    }*/ setDepthBiasSlopeScale(depthBiasSlopeScale) {
        if (this._depthBiasSlopeScale !== depthBiasSlopeScale) {
            this._depthBiasSlopeScale = depthBiasSlopeScale;
            this._states[$0aa333cffe805213$var$StatePosition.DepthBiasSlopeScale] = depthBiasSlopeScale;
            this._isDirty = true;
            this._stateDirtyLowestIndex = Math.min(this._stateDirtyLowestIndex, $0aa333cffe805213$var$StatePosition.DepthBiasSlopeScale);
        }
    }
    setColorFormat(format) {
        this._webgpuColorFormat[0] = format;
        this._colorFormat = (0, $4ObYT.renderableTextureFormatToIndex)[format ?? ""];
    }
    setMRTAttachments(attachments) {
        this.mrtAttachments = attachments;
        let mask = 0;
        for(let i = 0; i < attachments.length; ++i)if (attachments[i] !== 0) mask += 1 << i;
        if (this._mrtEnabledMask !== mask) {
            this._mrtEnabledMask = mask;
            this._isDirty = true;
            this._stateDirtyLowestIndex = Math.min(this._stateDirtyLowestIndex, $0aa333cffe805213$var$StatePosition.MRTAttachments1);
        }
    }
    setMRT(textureArray, textureCount) {
        textureCount = textureCount ?? textureArray.length;
        if (textureCount > 10) // If we want more than 10 attachments we need to change this method (and the StatePosition enum) but 10 seems plenty: note that WebGPU only supports 8 at the time (2021/12/13)!
        // As we need ~39 different values we are using 6 bits to encode a texture format, meaning we can encode 5 texture formats in 32 bits
        // We are using 2x32 bit values to handle 10 textures
        // eslint-disable-next-line no-throw-literal
        throw "Can't handle more than 10 attachments for a MRT in cache render pipeline!";
        this.mrtTextureArray = textureArray;
        this.mrtTextureCount = textureCount;
        this._mrtEnabledMask = 0xffff; // all textures are enabled at start (meaning we can write to them). Calls to setMRTAttachments may disable some
        const bits = [
            0,
            0
        ];
        let indexBits = 0, mask = 0, numRT = 0;
        for(let i = 0; i < textureCount; ++i){
            const texture = textureArray[i];
            const gpuWrapper = texture?._hardwareTexture;
            this._mrtFormats[numRT] = gpuWrapper?.format ?? this._webgpuColorFormat[0];
            bits[indexBits] += (0, $4ObYT.renderableTextureFormatToIndex)[this._mrtFormats[numRT] ?? ""] << mask;
            mask += 6;
            numRT++;
            if (mask >= 32) {
                mask = 0;
                indexBits++;
            }
        }
        this._mrtFormats.length = numRT;
        if (this._mrtAttachments1 !== bits[0] || this._mrtAttachments2 !== bits[1]) {
            this._mrtAttachments1 = bits[0];
            this._mrtAttachments2 = bits[1];
            this._states[$0aa333cffe805213$var$StatePosition.MRTAttachments1] = bits[0];
            this._states[$0aa333cffe805213$var$StatePosition.MRTAttachments2] = bits[1];
            this._isDirty = true;
            this._stateDirtyLowestIndex = Math.min(this._stateDirtyLowestIndex, $0aa333cffe805213$var$StatePosition.MRTAttachments1);
        }
    }
    setAlphaBlendEnabled(enabled) {
        this._alphaBlendEnabled = enabled;
    }
    setAlphaBlendFactors(factors, operations) {
        this._alphaBlendFuncParams = factors;
        this._alphaBlendEqParams = operations;
    }
    setWriteMask(mask) {
        this._writeMask = mask;
    }
    setDepthStencilFormat(format) {
        this._webgpuDepthStencilFormat = format;
        this._depthStencilFormat = format === undefined ? 0 : (0, $4ObYT.renderableTextureFormatToIndex)[format];
    }
    setDepthTestEnabled(enabled) {
        this._depthTestEnabled = enabled;
    }
    setDepthWriteEnabled(enabled) {
        this._depthWriteEnabled = enabled;
    }
    setDepthCompare(func) {
        this._depthCompare = (func ?? 519) - 0x0200;
    }
    setStencilEnabled(enabled) {
        this._stencilEnabled = enabled;
    }
    setStencilCompare(func) {
        this._stencilFrontCompare = (func ?? 519) - 0x0200;
    }
    setStencilDepthFailOp(op) {
        this._stencilFrontDepthFailOp = op === null ? 1 /* KEEP */  : $0aa333cffe805213$var$stencilOpToIndex[op];
    }
    setStencilPassOp(op) {
        this._stencilFrontPassOp = op === null ? 2 /* REPLACE */  : $0aa333cffe805213$var$stencilOpToIndex[op];
    }
    setStencilFailOp(op) {
        this._stencilFrontFailOp = op === null ? 1 /* KEEP */  : $0aa333cffe805213$var$stencilOpToIndex[op];
    }
    setStencilReadMask(mask) {
        if (this._stencilReadMask !== mask) {
            this._stencilReadMask = mask;
            this._states[$0aa333cffe805213$var$StatePosition.StencilReadMask] = mask;
            this._isDirty = true;
            this._stateDirtyLowestIndex = Math.min(this._stateDirtyLowestIndex, $0aa333cffe805213$var$StatePosition.StencilReadMask);
        }
    }
    setStencilWriteMask(mask) {
        if (this._stencilWriteMask !== mask) {
            this._stencilWriteMask = mask;
            this._states[$0aa333cffe805213$var$StatePosition.StencilWriteMask] = mask;
            this._isDirty = true;
            this._stateDirtyLowestIndex = Math.min(this._stateDirtyLowestIndex, $0aa333cffe805213$var$StatePosition.StencilWriteMask);
        }
    }
    resetStencilState() {
        this.setStencilState(false, 519, 7680, 7681, 7680, 0xff, 0xff);
    }
    setStencilState(stencilEnabled, compare, depthFailOp, passOp, failOp, readMask, writeMask) {
        this._stencilEnabled = stencilEnabled;
        this._stencilFrontCompare = (compare ?? 519) - 0x0200;
        this._stencilFrontDepthFailOp = depthFailOp === null ? 1 /* KEEP */  : $0aa333cffe805213$var$stencilOpToIndex[depthFailOp];
        this._stencilFrontPassOp = passOp === null ? 2 /* REPLACE */  : $0aa333cffe805213$var$stencilOpToIndex[passOp];
        this._stencilFrontFailOp = failOp === null ? 1 /* KEEP */  : $0aa333cffe805213$var$stencilOpToIndex[failOp];
        this.setStencilReadMask(readMask);
        this.setStencilWriteMask(writeMask);
    }
    setBuffers(vertexBuffers, indexBuffer, overrideVertexBuffers) {
        this._vertexBuffers = vertexBuffers;
        this._overrideVertexBuffers = overrideVertexBuffers;
        this._indexBuffer = indexBuffer;
    }
    static _GetTopology(fillMode) {
        switch(fillMode){
            // Triangle views
            case 0:
                return $hR6HG.PrimitiveTopology.TriangleList;
            case 2:
                return $hR6HG.PrimitiveTopology.PointList;
            case 1:
                return $hR6HG.PrimitiveTopology.LineList;
            // Draw modes
            case 3:
                return $hR6HG.PrimitiveTopology.PointList;
            case 4:
                return $hR6HG.PrimitiveTopology.LineList;
            case 5:
                // return this._gl.LINE_LOOP;
                // TODO WEBGPU. Line Loop Mode Fallback at buffer load time.
                // eslint-disable-next-line no-throw-literal
                throw "LineLoop is an unsupported fillmode in WebGPU";
            case 6:
                return $hR6HG.PrimitiveTopology.LineStrip;
            case 7:
                return $hR6HG.PrimitiveTopology.TriangleStrip;
            case 8:
                // return this._gl.TRIANGLE_FAN;
                // TODO WEBGPU. Triangle Fan Mode Fallback at buffer load time.
                // eslint-disable-next-line no-throw-literal
                throw "TriangleFan is an unsupported fillmode in WebGPU";
            default:
                return $hR6HG.PrimitiveTopology.TriangleList;
        }
    }
    static _GetAphaBlendOperation(operation) {
        switch(operation){
            case 32774:
                return $hR6HG.BlendOperation.Add;
            case 32778:
                return $hR6HG.BlendOperation.Subtract;
            case 32779:
                return $hR6HG.BlendOperation.ReverseSubtract;
            case 32775:
                return $hR6HG.BlendOperation.Min;
            case 32776:
                return $hR6HG.BlendOperation.Max;
            default:
                return $hR6HG.BlendOperation.Add;
        }
    }
    static _GetAphaBlendFactor(factor) {
        switch(factor){
            case 0:
                return $hR6HG.BlendFactor.Zero;
            case 1:
                return $hR6HG.BlendFactor.One;
            case 768:
                return $hR6HG.BlendFactor.Src;
            case 769:
                return $hR6HG.BlendFactor.OneMinusSrc;
            case 770:
                return $hR6HG.BlendFactor.SrcAlpha;
            case 771:
                return $hR6HG.BlendFactor.OneMinusSrcAlpha;
            case 772:
                return $hR6HG.BlendFactor.DstAlpha;
            case 773:
                return $hR6HG.BlendFactor.OneMinusDstAlpha;
            case 774:
                return $hR6HG.BlendFactor.Dst;
            case 775:
                return $hR6HG.BlendFactor.OneMinusDst;
            case 776:
                return $hR6HG.BlendFactor.SrcAlphaSaturated;
            case 32769:
                return $hR6HG.BlendFactor.Constant;
            case 32770:
                return $hR6HG.BlendFactor.OneMinusConstant;
            case 32771:
                return $hR6HG.BlendFactor.Constant;
            case 32772:
                return $hR6HG.BlendFactor.OneMinusConstant;
            default:
                return $hR6HG.BlendFactor.One;
        }
    }
    static _GetCompareFunction(compareFunction) {
        switch(compareFunction){
            case 0:
                return $hR6HG.CompareFunction.Never;
            case 1:
                return $hR6HG.CompareFunction.Less;
            case 2:
                return $hR6HG.CompareFunction.Equal;
            case 3:
                return $hR6HG.CompareFunction.LessEqual;
            case 4:
                return $hR6HG.CompareFunction.Greater;
            case 5:
                return $hR6HG.CompareFunction.NotEqual;
            case 6:
                return $hR6HG.CompareFunction.GreaterEqual;
            case 7:
                return $hR6HG.CompareFunction.Always;
        }
        return $hR6HG.CompareFunction.Never;
    }
    static _GetStencilOpFunction(operation) {
        switch(operation){
            case 0:
                return $hR6HG.StencilOperation.Zero;
            case 1:
                return $hR6HG.StencilOperation.Keep;
            case 2:
                return $hR6HG.StencilOperation.Replace;
            case 3:
                return $hR6HG.StencilOperation.IncrementClamp;
            case 4:
                return $hR6HG.StencilOperation.DecrementClamp;
            case 5:
                return $hR6HG.StencilOperation.Invert;
            case 6:
                return $hR6HG.StencilOperation.IncrementWrap;
            case 7:
                return $hR6HG.StencilOperation.DecrementWrap;
        }
        return $hR6HG.StencilOperation.Keep;
    }
    static _GetVertexInputDescriptorFormat(vertexBuffer) {
        const type = vertexBuffer.type;
        const normalized = vertexBuffer.normalized;
        const size = vertexBuffer.getSize();
        switch(type){
            case (0, $b4i1f.VertexBuffer).BYTE:
                switch(size){
                    case 1:
                    case 2:
                        return normalized ? $hR6HG.VertexFormat.Snorm8x2 : $hR6HG.VertexFormat.Sint8x2;
                    case 3:
                    case 4:
                        return normalized ? $hR6HG.VertexFormat.Snorm8x4 : $hR6HG.VertexFormat.Sint8x4;
                }
                break;
            case (0, $b4i1f.VertexBuffer).UNSIGNED_BYTE:
                switch(size){
                    case 1:
                    case 2:
                        return normalized ? $hR6HG.VertexFormat.Unorm8x2 : $hR6HG.VertexFormat.Uint8x2;
                    case 3:
                    case 4:
                        return normalized ? $hR6HG.VertexFormat.Unorm8x4 : $hR6HG.VertexFormat.Uint8x4;
                }
                break;
            case (0, $b4i1f.VertexBuffer).SHORT:
                switch(size){
                    case 1:
                    case 2:
                        return normalized ? $hR6HG.VertexFormat.Snorm16x2 : $hR6HG.VertexFormat.Sint16x2;
                    case 3:
                    case 4:
                        return normalized ? $hR6HG.VertexFormat.Snorm16x4 : $hR6HG.VertexFormat.Sint16x4;
                }
                break;
            case (0, $b4i1f.VertexBuffer).UNSIGNED_SHORT:
                switch(size){
                    case 1:
                    case 2:
                        return normalized ? $hR6HG.VertexFormat.Unorm16x2 : $hR6HG.VertexFormat.Uint16x2;
                    case 3:
                    case 4:
                        return normalized ? $hR6HG.VertexFormat.Unorm16x4 : $hR6HG.VertexFormat.Uint16x4;
                }
                break;
            case (0, $b4i1f.VertexBuffer).INT:
                switch(size){
                    case 1:
                        return $hR6HG.VertexFormat.Sint32;
                    case 2:
                        return $hR6HG.VertexFormat.Sint32x2;
                    case 3:
                        return $hR6HG.VertexFormat.Sint32x3;
                    case 4:
                        return $hR6HG.VertexFormat.Sint32x4;
                }
                break;
            case (0, $b4i1f.VertexBuffer).UNSIGNED_INT:
                switch(size){
                    case 1:
                        return $hR6HG.VertexFormat.Uint32;
                    case 2:
                        return $hR6HG.VertexFormat.Uint32x2;
                    case 3:
                        return $hR6HG.VertexFormat.Uint32x3;
                    case 4:
                        return $hR6HG.VertexFormat.Uint32x4;
                }
                break;
            case (0, $b4i1f.VertexBuffer).FLOAT:
                switch(size){
                    case 1:
                        return $hR6HG.VertexFormat.Float32;
                    case 2:
                        return $hR6HG.VertexFormat.Float32x2;
                    case 3:
                        return $hR6HG.VertexFormat.Float32x3;
                    case 4:
                        return $hR6HG.VertexFormat.Float32x4;
                }
                break;
        }
        throw new Error(`Invalid Format '${vertexBuffer.getKind()}' - type=${type}, normalized=${normalized}, size=${size}`);
    }
    _getAphaBlendState() {
        if (!this._alphaBlendEnabled) return null;
        return {
            srcFactor: $0aa333cffe805213$export$35f923de455dd7ad._GetAphaBlendFactor(this._alphaBlendFuncParams[2]),
            dstFactor: $0aa333cffe805213$export$35f923de455dd7ad._GetAphaBlendFactor(this._alphaBlendFuncParams[3]),
            operation: $0aa333cffe805213$export$35f923de455dd7ad._GetAphaBlendOperation(this._alphaBlendEqParams[1])
        };
    }
    _getColorBlendState() {
        if (!this._alphaBlendEnabled) return null;
        return {
            srcFactor: $0aa333cffe805213$export$35f923de455dd7ad._GetAphaBlendFactor(this._alphaBlendFuncParams[0]),
            dstFactor: $0aa333cffe805213$export$35f923de455dd7ad._GetAphaBlendFactor(this._alphaBlendFuncParams[1]),
            operation: $0aa333cffe805213$export$35f923de455dd7ad._GetAphaBlendOperation(this._alphaBlendEqParams[0])
        };
    }
    _setShaderStage(id) {
        if (this._shaderId !== id) {
            this._shaderId = id;
            this._states[$0aa333cffe805213$var$StatePosition.ShaderStage] = id;
            this._isDirty = true;
            this._stateDirtyLowestIndex = Math.min(this._stateDirtyLowestIndex, $0aa333cffe805213$var$StatePosition.ShaderStage);
        }
    }
    _setRasterizationState(topology, sampleCount) {
        const frontFace = this._frontFace;
        const cullMode = this._cullEnabled ? this._cullFace : 0;
        const clampDepth = this._clampDepth ? 1 : 0;
        const alphaToCoverage = this._alphaToCoverageEnabled ? 1 : 0;
        const rasterizationState = frontFace - 1 + (cullMode << 1) + (clampDepth << 3) + (alphaToCoverage << 4) + (topology << 5) + (sampleCount << 8);
        if (this._rasterizationState !== rasterizationState) {
            this._rasterizationState = rasterizationState;
            this._states[$0aa333cffe805213$var$StatePosition.RasterizationState] = this._rasterizationState;
            this._isDirty = true;
            this._stateDirtyLowestIndex = Math.min(this._stateDirtyLowestIndex, $0aa333cffe805213$var$StatePosition.RasterizationState);
        }
    }
    _setColorStates() {
        let colorStates = ((this._writeMask ? 1 : 0) << 22) + (this._colorFormat << 23) + ((this._depthWriteEnabled ? 1 : 0) << 29); // this state has been moved from depthStencilState here because alpha and depth are related (generally when alpha is on, depth write is off and the other way around)
        if (this._alphaBlendEnabled) colorStates += ((this._alphaBlendFuncParams[0] === null ? 2 : $0aa333cffe805213$var$alphaBlendFactorToIndex[this._alphaBlendFuncParams[0]]) << 0) + ((this._alphaBlendFuncParams[1] === null ? 2 : $0aa333cffe805213$var$alphaBlendFactorToIndex[this._alphaBlendFuncParams[1]]) << 4) + ((this._alphaBlendFuncParams[2] === null ? 2 : $0aa333cffe805213$var$alphaBlendFactorToIndex[this._alphaBlendFuncParams[2]]) << 8) + ((this._alphaBlendFuncParams[3] === null ? 2 : $0aa333cffe805213$var$alphaBlendFactorToIndex[this._alphaBlendFuncParams[3]]) << 12) + ((this._alphaBlendEqParams[0] === null ? 1 : this._alphaBlendEqParams[0] - 0x8005) << 16) + ((this._alphaBlendEqParams[1] === null ? 1 : this._alphaBlendEqParams[1] - 0x8005) << 19);
        if (colorStates !== this._colorStates) {
            this._colorStates = colorStates;
            this._states[$0aa333cffe805213$var$StatePosition.ColorStates] = this._colorStates;
            this._isDirty = true;
            this._stateDirtyLowestIndex = Math.min(this._stateDirtyLowestIndex, $0aa333cffe805213$var$StatePosition.ColorStates);
        }
    }
    _setDepthStencilState() {
        const stencilState = !this._stencilEnabled ? 591 : this._stencilFrontCompare + (this._stencilFrontDepthFailOp << 3) + (this._stencilFrontPassOp << 6) + (this._stencilFrontFailOp << 9);
        const depthStencilState = this._depthStencilFormat + ((this._depthTestEnabled ? this._depthCompare : 7) << 6) + (stencilState << 10); // stencil front - stencil back is the same
        if (this._depthStencilState !== depthStencilState) {
            this._depthStencilState = depthStencilState;
            this._states[$0aa333cffe805213$var$StatePosition.DepthStencilState] = this._depthStencilState;
            this._isDirty = true;
            this._stateDirtyLowestIndex = Math.min(this._stateDirtyLowestIndex, $0aa333cffe805213$var$StatePosition.DepthStencilState);
        }
    }
    _setVertexState(effect) {
        const currStateLen = this._statesLength;
        let newNumStates = $0aa333cffe805213$var$StatePosition.VertexState;
        const webgpuPipelineContext = effect._pipelineContext;
        const attributes = webgpuPipelineContext.shaderProcessingContext.attributeNamesFromEffect;
        const locations = webgpuPipelineContext.shaderProcessingContext.attributeLocationsFromEffect;
        let currentGPUBuffer;
        let numVertexBuffers = 0;
        for(let index = 0; index < attributes.length; index++){
            const location = locations[index];
            let vertexBuffer = (this._overrideVertexBuffers && this._overrideVertexBuffers[attributes[index]]) ?? this._vertexBuffers[attributes[index]];
            if (!vertexBuffer) // In WebGL it's valid to not bind a vertex buffer to an attribute, but it's not valid in WebGPU
            // So we must bind a dummy buffer when we are not given one for a specific attribute
            vertexBuffer = this._emptyVertexBuffer;
            const buffer = vertexBuffer.effectiveBuffer?.underlyingResource;
            // We optimize usage of GPUVertexBufferLayout: we will create a single GPUVertexBufferLayout for all the attributes which follow each other and which use the same GPU buffer
            // However, there are some constraints in the attribute.offset value range, so we must check for them before being able to reuse the same GPUVertexBufferLayout
            // See _getVertexInputDescriptor() below
            if (vertexBuffer._validOffsetRange === undefined) {
                const offset = vertexBuffer.effectiveByteOffset;
                const formatSize = vertexBuffer.getSize(true);
                const byteStride = vertexBuffer.effectiveByteStride;
                vertexBuffer._validOffsetRange = offset + formatSize <= this._kMaxVertexBufferStride && byteStride === 0 || byteStride !== 0 && offset + formatSize <= byteStride;
            }
            if (!(currentGPUBuffer && currentGPUBuffer === buffer && vertexBuffer._validOffsetRange)) {
                // we can't combine the previous vertexBuffer with the current one
                this.vertexBuffers[numVertexBuffers++] = vertexBuffer;
                currentGPUBuffer = vertexBuffer._validOffsetRange ? buffer : null;
            }
            const vid = vertexBuffer.hashCode + (location << 7);
            this._isDirty = this._isDirty || this._states[newNumStates] !== vid;
            this._states[newNumStates++] = vid;
        }
        this.vertexBuffers.length = numVertexBuffers;
        this._statesLength = newNumStates;
        this._isDirty = this._isDirty || newNumStates !== currStateLen;
        if (this._isDirty) this._stateDirtyLowestIndex = Math.min(this._stateDirtyLowestIndex, $0aa333cffe805213$var$StatePosition.VertexState);
    }
    _setTextureState(textureState) {
        if (this._textureState !== textureState) {
            this._textureState = textureState;
            this._states[$0aa333cffe805213$var$StatePosition.TextureStage] = this._textureState;
            this._isDirty = true;
            this._stateDirtyLowestIndex = Math.min(this._stateDirtyLowestIndex, $0aa333cffe805213$var$StatePosition.TextureStage);
        }
    }
    _createPipelineLayout(webgpuPipelineContext) {
        if (this._useTextureStage) return this._createPipelineLayoutWithTextureStage(webgpuPipelineContext);
        const bindGroupLayouts = [];
        const bindGroupLayoutEntries = webgpuPipelineContext.shaderProcessingContext.bindGroupLayoutEntries;
        for(let i = 0; i < bindGroupLayoutEntries.length; i++){
            const setDefinition = bindGroupLayoutEntries[i];
            bindGroupLayouts[i] = this._device.createBindGroupLayout({
                entries: setDefinition
            });
        }
        webgpuPipelineContext.bindGroupLayouts[0] = bindGroupLayouts;
        return this._device.createPipelineLayout({
            bindGroupLayouts: bindGroupLayouts
        });
    }
    _createPipelineLayoutWithTextureStage(webgpuPipelineContext) {
        const shaderProcessingContext = webgpuPipelineContext.shaderProcessingContext;
        const bindGroupLayoutEntries = shaderProcessingContext.bindGroupLayoutEntries;
        let bitVal = 1;
        for(let i = 0; i < bindGroupLayoutEntries.length; i++){
            const setDefinition = bindGroupLayoutEntries[i];
            for(let j = 0; j < setDefinition.length; j++){
                const entry = bindGroupLayoutEntries[i][j];
                if (entry.texture) {
                    const name = shaderProcessingContext.bindGroupLayoutEntryInfo[i][entry.binding].name;
                    const textureInfo = shaderProcessingContext.availableTextures[name];
                    const samplerInfo = textureInfo.autoBindSampler ? shaderProcessingContext.availableSamplers[name + (0, $jXMwB.WebGPUShaderProcessor).AutoSamplerSuffix] : null;
                    let sampleType = textureInfo.sampleType;
                    let samplerType = samplerInfo?.type ?? $hR6HG.SamplerBindingType.Filtering;
                    if (this._textureState & bitVal && sampleType !== $hR6HG.TextureSampleType.Depth) {
                        // The texture is a 32 bits float texture but the system does not support linear filtering for them OR the texture is a depth texture with "float" filtering:
                        // we set the sampler to "non-filtering" and the texture sample type to "unfilterable-float"
                        if (textureInfo.autoBindSampler) samplerType = $hR6HG.SamplerBindingType.NonFiltering;
                        sampleType = $hR6HG.TextureSampleType.UnfilterableFloat;
                    }
                    entry.texture.sampleType = sampleType;
                    if (samplerInfo) {
                        const binding = shaderProcessingContext.bindGroupLayoutEntryInfo[samplerInfo.binding.groupIndex][samplerInfo.binding.bindingIndex].index;
                        bindGroupLayoutEntries[samplerInfo.binding.groupIndex][binding].sampler.type = samplerType;
                    }
                    bitVal = bitVal << 1;
                }
            }
        }
        const bindGroupLayouts = [];
        for(let i = 0; i < bindGroupLayoutEntries.length; ++i)bindGroupLayouts[i] = this._device.createBindGroupLayout({
            entries: bindGroupLayoutEntries[i]
        });
        webgpuPipelineContext.bindGroupLayouts[this._textureState] = bindGroupLayouts;
        return this._device.createPipelineLayout({
            bindGroupLayouts: bindGroupLayouts
        });
    }
    _getVertexInputDescriptor(effect) {
        const descriptors = [];
        const webgpuPipelineContext = effect._pipelineContext;
        const attributes = webgpuPipelineContext.shaderProcessingContext.attributeNamesFromEffect;
        const locations = webgpuPipelineContext.shaderProcessingContext.attributeLocationsFromEffect;
        let currentGPUBuffer;
        let currentGPUAttributes;
        for(let index = 0; index < attributes.length; index++){
            const location = locations[index];
            let vertexBuffer = (this._overrideVertexBuffers && this._overrideVertexBuffers[attributes[index]]) ?? this._vertexBuffers[attributes[index]];
            if (!vertexBuffer) // In WebGL it's valid to not bind a vertex buffer to an attribute, but it's not valid in WebGPU
            // So we must bind a dummy buffer when we are not given one for a specific attribute
            vertexBuffer = this._emptyVertexBuffer;
            let buffer = vertexBuffer.effectiveBuffer?.underlyingResource;
            // We reuse the same GPUVertexBufferLayout for all attributes that use the same underlying GPU buffer (and for attributes that follow each other in the attributes array)
            let offset = vertexBuffer.effectiveByteOffset;
            const invalidOffsetRange = !vertexBuffer._validOffsetRange;
            if (!(currentGPUBuffer && currentGPUAttributes && currentGPUBuffer === buffer) || invalidOffsetRange) {
                const vertexBufferDescriptor = {
                    arrayStride: vertexBuffer.effectiveByteStride,
                    stepMode: vertexBuffer.getIsInstanced() ? $hR6HG.VertexStepMode.Instance : $hR6HG.VertexStepMode.Vertex,
                    attributes: []
                };
                descriptors.push(vertexBufferDescriptor);
                currentGPUAttributes = vertexBufferDescriptor.attributes;
                if (invalidOffsetRange) {
                    offset = 0; // the offset will be set directly in the setVertexBuffer call
                    buffer = null; // buffer can't be reused
                }
            }
            currentGPUAttributes.push({
                shaderLocation: location,
                offset: offset,
                format: $0aa333cffe805213$export$35f923de455dd7ad._GetVertexInputDescriptorFormat(vertexBuffer)
            });
            currentGPUBuffer = buffer;
        }
        return descriptors;
    }
    _processNonFloatVertexBuffers(webgpuPipelineContext, effect) {
        const webgpuShaderProcessor = webgpuPipelineContext.engine._getShaderProcessor(webgpuPipelineContext.shaderProcessingContext.shaderLanguage);
        let reprocessShaders = false;
        for(const kind in this._vertexBuffers){
            const currentVertexBuffer = this._vertexBuffers[kind];
            if (!currentVertexBuffer || !$0aa333cffe805213$var$vertexBufferKindForNonFloatProcessing[kind]) continue;
            const currentVertexBufferType = currentVertexBuffer.normalized ? (0, $b4i1f.VertexBuffer).FLOAT : currentVertexBuffer.type;
            const vertexBufferType = webgpuPipelineContext.vertexBufferKindToType[kind];
            if (currentVertexBufferType !== (0, $b4i1f.VertexBuffer).FLOAT && vertexBufferType === undefined || vertexBufferType !== undefined && vertexBufferType !== currentVertexBufferType) {
                reprocessShaders = true;
                webgpuPipelineContext.vertexBufferKindToType[kind] = currentVertexBufferType;
                if (currentVertexBufferType !== (0, $b4i1f.VertexBuffer).FLOAT) {
                    webgpuShaderProcessor.vertexBufferKindToNumberOfComponents[kind] = (0, $b4i1f.VertexBuffer).DeduceStride(kind);
                    if ($0aa333cffe805213$export$35f923de455dd7ad._IsSignedType(currentVertexBufferType)) webgpuShaderProcessor.vertexBufferKindToNumberOfComponents[kind] *= -1;
                }
            }
        }
        if (reprocessShaders) effect._processShaderCode(webgpuShaderProcessor, true);
    }
    _createRenderPipeline(effect, topology, sampleCount) {
        const webgpuPipelineContext = effect._pipelineContext;
        const inputStateDescriptor = this._getVertexInputDescriptor(effect);
        const pipelineLayout = this._createPipelineLayout(webgpuPipelineContext);
        const colorStates = [];
        const alphaBlend = this._getAphaBlendState();
        const colorBlend = this._getColorBlendState();
        this._processNonFloatVertexBuffers(webgpuPipelineContext, effect);
        if (this._mrtAttachments1 > 0) for(let i = 0; i < this._mrtFormats.length; ++i){
            const format = this._mrtFormats[i];
            if (format) {
                const descr = {
                    format: format,
                    writeMask: (this._mrtEnabledMask & 1 << i) !== 0 ? this._writeMask : 0
                };
                if (alphaBlend && colorBlend) descr.blend = {
                    alpha: alphaBlend,
                    color: colorBlend
                };
                colorStates.push(descr);
            } else colorStates.push(null);
        }
        else if (this._webgpuColorFormat[0]) {
            const descr = {
                format: this._webgpuColorFormat[0],
                writeMask: this._writeMask
            };
            if (alphaBlend && colorBlend) descr.blend = {
                alpha: alphaBlend,
                color: colorBlend
            };
            colorStates.push(descr);
        } else colorStates.push(null);
        const stencilFrontBack = {
            compare: $0aa333cffe805213$export$35f923de455dd7ad._GetCompareFunction(this._stencilEnabled ? this._stencilFrontCompare : 7 /* ALWAYS */ ),
            depthFailOp: $0aa333cffe805213$export$35f923de455dd7ad._GetStencilOpFunction(this._stencilEnabled ? this._stencilFrontDepthFailOp : 1 /* KEEP */ ),
            failOp: $0aa333cffe805213$export$35f923de455dd7ad._GetStencilOpFunction(this._stencilEnabled ? this._stencilFrontFailOp : 1 /* KEEP */ ),
            passOp: $0aa333cffe805213$export$35f923de455dd7ad._GetStencilOpFunction(this._stencilEnabled ? this._stencilFrontPassOp : 1 /* KEEP */ )
        };
        let stripIndexFormat = undefined;
        if (topology === $hR6HG.PrimitiveTopology.LineStrip || topology === $hR6HG.PrimitiveTopology.TriangleStrip) stripIndexFormat = !this._indexBuffer || this._indexBuffer.is32Bits ? $hR6HG.IndexFormat.Uint32 : $hR6HG.IndexFormat.Uint16;
        const depthStencilFormatHasStencil = this._webgpuDepthStencilFormat ? (0, $l46cr.WebGPUTextureHelper).HasStencilAspect(this._webgpuDepthStencilFormat) : false;
        return this._device.createRenderPipeline({
            label: `RenderPipeline_${colorStates[0]?.format ?? "nooutput"}_${this._webgpuDepthStencilFormat ?? "nodepth"}_samples${sampleCount}_textureState${this._textureState}`,
            layout: pipelineLayout,
            vertex: {
                module: webgpuPipelineContext.stages.vertexStage.module,
                entryPoint: webgpuPipelineContext.stages.vertexStage.entryPoint,
                buffers: inputStateDescriptor
            },
            primitive: {
                topology: topology,
                stripIndexFormat: stripIndexFormat,
                frontFace: this._frontFace === 1 ? $hR6HG.FrontFace.CCW : $hR6HG.FrontFace.CW,
                cullMode: !this._cullEnabled ? $hR6HG.CullMode.None : this._cullFace === 2 ? $hR6HG.CullMode.Front : $hR6HG.CullMode.Back
            },
            fragment: !webgpuPipelineContext.stages.fragmentStage ? undefined : {
                module: webgpuPipelineContext.stages.fragmentStage.module,
                entryPoint: webgpuPipelineContext.stages.fragmentStage.entryPoint,
                targets: colorStates
            },
            multisample: {
                count: sampleCount
            },
            depthStencil: this._webgpuDepthStencilFormat === undefined ? undefined : {
                depthWriteEnabled: this._depthWriteEnabled,
                depthCompare: this._depthTestEnabled ? $0aa333cffe805213$export$35f923de455dd7ad._GetCompareFunction(this._depthCompare) : $hR6HG.CompareFunction.Always,
                format: this._webgpuDepthStencilFormat,
                stencilFront: this._stencilEnabled && depthStencilFormatHasStencil ? stencilFrontBack : undefined,
                stencilBack: this._stencilEnabled && depthStencilFormatHasStencil ? stencilFrontBack : undefined,
                stencilReadMask: this._stencilEnabled && depthStencilFormatHasStencil ? this._stencilReadMask : undefined,
                stencilWriteMask: this._stencilEnabled && depthStencilFormatHasStencil ? this._stencilWriteMask : undefined,
                depthBias: this._depthBias,
                depthBiasClamp: this._depthBiasClamp,
                depthBiasSlopeScale: this._depthBiasSlopeScale
            }
        });
    }
}
$0aa333cffe805213$export$35f923de455dd7ad.NumCacheHitWithoutHash = 0;
$0aa333cffe805213$export$35f923de455dd7ad.NumCacheHitWithHash = 0;
$0aa333cffe805213$export$35f923de455dd7ad.NumCacheMiss = 0;
$0aa333cffe805213$export$35f923de455dd7ad.NumPipelineCreationLastFrame = 0;
$0aa333cffe805213$export$35f923de455dd7ad._NumPipelineCreationCurrentFrame = 0;

});


parcelRegister("7dZYU", function(module, exports) {

$parcel$export(module.exports, "WebGPUStencilStateComposer", () => $5429d38845f0a9f4$export$8653b97c48dd2f46);

var $cyIBx = parcelRequire("cyIBx");
class $5429d38845f0a9f4$export$8653b97c48dd2f46 extends (0, $cyIBx.StencilStateComposer) {
    constructor(cache){
        super(false);
        this._cache = cache;
        this.reset();
    }
    get func() {
        return this._func;
    }
    set func(value) {
        if (this._func === value) return;
        this._func = value;
        this._cache.setStencilCompare(value);
    }
    get funcMask() {
        return this._funcMask;
    }
    set funcMask(value) {
        if (this._funcMask === value) return;
        this._funcMask = value;
        this._cache.setStencilReadMask(value);
    }
    get opStencilFail() {
        return this._opStencilFail;
    }
    set opStencilFail(value) {
        if (this._opStencilFail === value) return;
        this._opStencilFail = value;
        this._cache.setStencilFailOp(value);
    }
    get opDepthFail() {
        return this._opDepthFail;
    }
    set opDepthFail(value) {
        if (this._opDepthFail === value) return;
        this._opDepthFail = value;
        this._cache.setStencilDepthFailOp(value);
    }
    get opStencilDepthPass() {
        return this._opStencilDepthPass;
    }
    set opStencilDepthPass(value) {
        if (this._opStencilDepthPass === value) return;
        this._opStencilDepthPass = value;
        this._cache.setStencilPassOp(value);
    }
    get mask() {
        return this._mask;
    }
    set mask(value) {
        if (this._mask === value) return;
        this._mask = value;
        this._cache.setStencilWriteMask(value);
    }
    get enabled() {
        return this._enabled;
    }
    set enabled(value) {
        if (this._enabled === value) return;
        this._enabled = value;
        this._cache.setStencilEnabled(value);
    }
    reset() {
        super.reset();
        this._cache.resetStencilState();
    }
    apply() {
        const stencilMaterialEnabled = this.stencilMaterial?.enabled;
        this.enabled = stencilMaterialEnabled ? this.stencilMaterial.enabled : this.stencilGlobal.enabled;
        if (!this.enabled) return;
        this.func = stencilMaterialEnabled ? this.stencilMaterial.func : this.stencilGlobal.func;
        this.funcRef = stencilMaterialEnabled ? this.stencilMaterial.funcRef : this.stencilGlobal.funcRef;
        this.funcMask = stencilMaterialEnabled ? this.stencilMaterial.funcMask : this.stencilGlobal.funcMask;
        this.opStencilFail = stencilMaterialEnabled ? this.stencilMaterial.opStencilFail : this.stencilGlobal.opStencilFail;
        this.opDepthFail = stencilMaterialEnabled ? this.stencilMaterial.opDepthFail : this.stencilGlobal.opDepthFail;
        this.opStencilDepthPass = stencilMaterialEnabled ? this.stencilMaterial.opStencilDepthPass : this.stencilGlobal.opStencilDepthPass;
        this.mask = stencilMaterialEnabled ? this.stencilMaterial.mask : this.stencilGlobal.mask;
    }
}

});

parcelRegister("4MBPD", function(module, exports) {

$parcel$export(module.exports, "WebGPUDepthCullingState", () => $37b8fdbae21deca0$export$37430508743762a6);

var $36XJ5 = parcelRequire("36XJ5");
class $37b8fdbae21deca0$export$37430508743762a6 extends (0, $36XJ5.DepthCullingState) {
    /**
     * Initializes the state.
     * @param cache
     */ constructor(cache){
        super(false);
        this._cache = cache;
        this.reset();
    }
    get zOffset() {
        return this._zOffset;
    }
    set zOffset(value) {
        if (this._zOffset === value) return;
        this._zOffset = value;
        this._isZOffsetDirty = true;
        this._cache.setDepthBiasSlopeScale(value);
    }
    get zOffsetUnits() {
        return this._zOffsetUnits;
    }
    set zOffsetUnits(value) {
        if (this._zOffsetUnits === value) return;
        this._zOffsetUnits = value;
        this._isZOffsetDirty = true;
        this._cache.setDepthBias(value);
    }
    get cullFace() {
        return this._cullFace;
    }
    set cullFace(value) {
        if (this._cullFace === value) return;
        this._cullFace = value;
        this._isCullFaceDirty = true;
        this._cache.setCullFace(value ?? 1);
    }
    get cull() {
        return this._cull;
    }
    set cull(value) {
        if (this._cull === value) return;
        this._cull = value;
        this._isCullDirty = true;
        this._cache.setCullEnabled(!!value);
    }
    get depthFunc() {
        return this._depthFunc;
    }
    set depthFunc(value) {
        if (this._depthFunc === value) return;
        this._depthFunc = value;
        this._isDepthFuncDirty = true;
        this._cache.setDepthCompare(value);
    }
    get depthMask() {
        return this._depthMask;
    }
    set depthMask(value) {
        if (this._depthMask === value) return;
        this._depthMask = value;
        this._isDepthMaskDirty = true;
        this._cache.setDepthWriteEnabled(value);
    }
    get depthTest() {
        return this._depthTest;
    }
    set depthTest(value) {
        if (this._depthTest === value) return;
        this._depthTest = value;
        this._isDepthTestDirty = true;
        this._cache.setDepthTestEnabled(value);
    }
    get frontFace() {
        return this._frontFace;
    }
    set frontFace(value) {
        if (this._frontFace === value) return;
        this._frontFace = value;
        this._isFrontFaceDirty = true;
        this._cache.setFrontFace(value ?? 2);
    }
    reset() {
        super.reset();
        this._cache.resetDepthCullingState();
    }
    apply() {
    // nothing to do
    }
}

});

parcelRegister("gJSsf", function(module, exports) {

$parcel$export(module.exports, "WebGPUMaterialContext", () => $c2fb16dfc3bffc08$export$e84c980ec89a4179);
/* eslint-disable babylonjs/available */ /* eslint-disable jsdoc/require-jsdoc */ 
var $42iIf = parcelRequire("42iIf");

var $6okLJ = parcelRequire("6okLJ");
class $c2fb16dfc3bffc08$export$e84c980ec89a4179 {
    get forceBindGroupCreation() {
        // If there is at least one external texture to bind, we must recreate the bind groups each time
        // because we need to retrieve a new texture each frame (by calling device.importExternalTexture)
        return this._numExternalTextures > 0;
    }
    get hasFloatOrDepthTextures() {
        return this._numFloatOrDepthTextures > 0;
    }
    constructor(){
        this.uniqueId = $c2fb16dfc3bffc08$export$e84c980ec89a4179._Counter++;
        this.updateId = 0;
        this.textureState = 0;
        this.reset();
    }
    reset() {
        this.samplers = {};
        this.textures = {};
        this.isDirty = true;
        this._numFloatOrDepthTextures = 0;
        this._numExternalTextures = 0;
    }
    setSampler(name, sampler) {
        let samplerCache = this.samplers[name];
        let currentHashCode = -1;
        if (!samplerCache) this.samplers[name] = samplerCache = {
            sampler: sampler,
            hashCode: 0
        };
        else currentHashCode = samplerCache.hashCode;
        samplerCache.sampler = sampler;
        samplerCache.hashCode = sampler ? (0, $6okLJ.WebGPUCacheSampler).GetSamplerHashCode(sampler) : 0;
        const isDirty = currentHashCode !== samplerCache.hashCode;
        if (isDirty) this.updateId++;
        this.isDirty || (this.isDirty = isDirty);
    }
    setTexture(name, texture) {
        let textureCache = this.textures[name];
        let currentTextureId = -1;
        if (!textureCache) this.textures[name] = textureCache = {
            texture: texture,
            isFloatOrDepthTexture: false,
            isExternalTexture: false
        };
        else currentTextureId = textureCache.texture?.uniqueId ?? -1;
        if (textureCache.isExternalTexture) this._numExternalTextures--;
        if (textureCache.isFloatOrDepthTexture) this._numFloatOrDepthTextures--;
        if (texture) {
            textureCache.isFloatOrDepthTexture = texture.type === 1 || texture.format >= 13 && texture.format <= 18;
            textureCache.isExternalTexture = (0, $42iIf.ExternalTexture).IsExternalTexture(texture);
            if (textureCache.isFloatOrDepthTexture) this._numFloatOrDepthTextures++;
            if (textureCache.isExternalTexture) this._numExternalTextures++;
        } else {
            textureCache.isFloatOrDepthTexture = false;
            textureCache.isExternalTexture = false;
        }
        textureCache.texture = texture;
        const isDirty = currentTextureId !== (texture?.uniqueId ?? -1);
        if (isDirty) this.updateId++;
        this.isDirty || (this.isDirty = isDirty);
    }
}
$c2fb16dfc3bffc08$export$e84c980ec89a4179._Counter = 0;

});
parcelRegister("42iIf", function(module, exports) {

$parcel$export(module.exports, "ExternalTexture", () => $2f05dd4a29cb6a93$export$cd10147cacf16ab2);

var $b9e4a = parcelRequire("b9e4a");
class $2f05dd4a29cb6a93$export$cd10147cacf16ab2 {
    /**
     * Checks if a texture is an external or internal texture
     * @param texture the external or internal texture
     * @returns true if the texture is an external texture, else false
     */ static IsExternalTexture(texture) {
        return texture.underlyingResource !== undefined;
    }
    /**
     * Get the class name of the texture.
     * @returns "ExternalTexture"
     */ getClassName() {
        return "ExternalTexture";
    }
    /**
     * Gets the underlying texture object
     */ get underlyingResource() {
        return this._video;
    }
    /**
     * Constructs the texture
     * @param video The video the texture should be wrapped around
     */ constructor(video){
        /**
         * Gets a boolean indicating if the texture uses mipmaps
         */ this.useMipMaps = false;
        /**
         * The type of the underlying texture is implementation dependent, so return "UNDEFINED" for the type
         */ this.type = 16;
        /**
         * The format of the underlying texture is implementation dependent, so return "UNDEFINED" for the format
         */ this.format = 4294967295;
        this._video = video;
        this.uniqueId = (0, $b9e4a.InternalTexture)._Counter++;
    }
    /**
     * Get if the texture is ready to be used (downloaded, converted, mip mapped...).
     * @returns true if fully ready
     */ isReady() {
        return this._video.readyState >= this._video.HAVE_CURRENT_DATA;
    }
    /**
     * Dispose the texture and release its associated resources.
     */ dispose() {}
}

});


parcelRegister("eFVmp", function(module, exports) {

$parcel$export(module.exports, "WebGPUDrawContext", () => $aaf163a00c60fba4$export$bc0721ef90740c89);

var $hR6HG = parcelRequire("hR6HG");
class $aaf163a00c60fba4$export$bc0721ef90740c89 {
    isDirty(materialContextUpdateId) {
        return this._isDirty || this._materialContextUpdateId !== materialContextUpdateId;
    }
    resetIsDirty(materialContextUpdateId) {
        this._isDirty = false;
        this._materialContextUpdateId = materialContextUpdateId;
    }
    get useInstancing() {
        return this._useInstancing;
    }
    set useInstancing(use) {
        if (this._useInstancing === use) return;
        if (!use) {
            if (this.indirectDrawBuffer) this._bufferManager.releaseBuffer(this.indirectDrawBuffer);
            this.indirectDrawBuffer = undefined;
            this._indirectDrawData = undefined;
        } else {
            this.indirectDrawBuffer = this._bufferManager.createRawBuffer(20, $hR6HG.BufferUsage.CopyDst | $hR6HG.BufferUsage.Indirect | $hR6HG.BufferUsage.Storage, undefined, "IndirectDrawBuffer");
            this._indirectDrawData = new Uint32Array(5);
            this._indirectDrawData[3] = 0;
            this._indirectDrawData[4] = 0;
        }
        this._useInstancing = use;
        this._currentInstanceCount = -1;
    }
    constructor(bufferManager){
        this._bufferManager = bufferManager;
        this.uniqueId = $aaf163a00c60fba4$export$bc0721ef90740c89._Counter++;
        this._useInstancing = false;
        this._currentInstanceCount = 0;
        this.reset();
    }
    reset() {
        this.buffers = {};
        this._isDirty = true;
        this._materialContextUpdateId = 0;
        this.fastBundle = undefined;
        this.bindGroups = undefined;
    }
    setBuffer(name, buffer) {
        this._isDirty || (this._isDirty = buffer?.uniqueId !== this.buffers[name]?.uniqueId);
        this.buffers[name] = buffer;
    }
    setIndirectData(indexOrVertexCount, instanceCount, firstIndexOrVertex) {
        if (instanceCount === this._currentInstanceCount || !this.indirectDrawBuffer || !this._indirectDrawData) // The current buffer is already up to date so do nothing
        // Note that we only check for instanceCount and not indexOrVertexCount nor firstIndexOrVertex because those values
        // are supposed to not change during the lifetime of a draw context
        return;
        this._currentInstanceCount = instanceCount;
        this._indirectDrawData[0] = indexOrVertexCount;
        this._indirectDrawData[1] = instanceCount;
        this._indirectDrawData[2] = firstIndexOrVertex;
        this._bufferManager.setRawData(this.indirectDrawBuffer, 0, this._indirectDrawData, 0, 20);
    }
    dispose() {
        if (this.indirectDrawBuffer) {
            this._bufferManager.releaseBuffer(this.indirectDrawBuffer);
            this.indirectDrawBuffer = undefined;
            this._indirectDrawData = undefined;
        }
        this.fastBundle = undefined;
        this.bindGroups = undefined;
        this.buffers = undefined;
    }
}
$aaf163a00c60fba4$export$bc0721ef90740c89._Counter = 0;

});

parcelRegister("3rO3H", function(module, exports) {

$parcel$export(module.exports, "WebGPUCacheBindGroups", () => $282ab957c009b331$export$81b864ad76b2a0d);
/* eslint-disable babylonjs/available */ /* eslint-disable jsdoc/require-jsdoc */ 
var $kVtWi = parcelRequire("kVtWi");
class $282ab957c009b331$var$WebGPUBindGroupCacheNode {
    constructor(){
        this.values = {};
    }
}
class $282ab957c009b331$export$81b864ad76b2a0d {
    static get Statistics() {
        return {
            totalCreated: $282ab957c009b331$export$81b864ad76b2a0d.NumBindGroupsCreatedTotal,
            lastFrameCreated: $282ab957c009b331$export$81b864ad76b2a0d.NumBindGroupsCreatedLastFrame,
            lookupLastFrame: $282ab957c009b331$export$81b864ad76b2a0d.NumBindGroupsLookupLastFrame,
            noLookupLastFrame: $282ab957c009b331$export$81b864ad76b2a0d.NumBindGroupsNoLookupLastFrame
        };
    }
    static ResetCache() {
        $282ab957c009b331$export$81b864ad76b2a0d._Cache = new $282ab957c009b331$var$WebGPUBindGroupCacheNode();
        $282ab957c009b331$export$81b864ad76b2a0d.NumBindGroupsCreatedTotal = 0;
        $282ab957c009b331$export$81b864ad76b2a0d.NumBindGroupsCreatedLastFrame = 0;
        $282ab957c009b331$export$81b864ad76b2a0d.NumBindGroupsLookupLastFrame = 0;
        $282ab957c009b331$export$81b864ad76b2a0d.NumBindGroupsNoLookupLastFrame = 0;
        $282ab957c009b331$export$81b864ad76b2a0d._NumBindGroupsCreatedCurrentFrame = 0;
        $282ab957c009b331$export$81b864ad76b2a0d._NumBindGroupsLookupCurrentFrame = 0;
        $282ab957c009b331$export$81b864ad76b2a0d._NumBindGroupsNoLookupCurrentFrame = 0;
    }
    constructor(device, cacheSampler, engine){
        this.disabled = false;
        this._device = device;
        this._cacheSampler = cacheSampler;
        this._engine = engine;
    }
    endFrame() {
        $282ab957c009b331$export$81b864ad76b2a0d.NumBindGroupsCreatedLastFrame = $282ab957c009b331$export$81b864ad76b2a0d._NumBindGroupsCreatedCurrentFrame;
        $282ab957c009b331$export$81b864ad76b2a0d.NumBindGroupsLookupLastFrame = $282ab957c009b331$export$81b864ad76b2a0d._NumBindGroupsLookupCurrentFrame;
        $282ab957c009b331$export$81b864ad76b2a0d.NumBindGroupsNoLookupLastFrame = $282ab957c009b331$export$81b864ad76b2a0d._NumBindGroupsNoLookupCurrentFrame;
        $282ab957c009b331$export$81b864ad76b2a0d._NumBindGroupsCreatedCurrentFrame = 0;
        $282ab957c009b331$export$81b864ad76b2a0d._NumBindGroupsLookupCurrentFrame = 0;
        $282ab957c009b331$export$81b864ad76b2a0d._NumBindGroupsNoLookupCurrentFrame = 0;
    }
    /**
     * Cache is currently based on the uniform/storage buffers, samplers and textures used by the binding groups.
     * Note that all uniform buffers have an offset of 0 in Babylon and we don't have a use case where we would have the same buffer used with different capacity values:
     * that means we don't need to factor in the offset/size of the buffer in the cache, only the id
     * @param webgpuPipelineContext
     * @param drawContext
     * @param materialContext
     * @returns a bind group array
     */ getBindGroups(webgpuPipelineContext, drawContext, materialContext) {
        let bindGroups = undefined;
        let node = $282ab957c009b331$export$81b864ad76b2a0d._Cache;
        const cacheIsDisabled = this.disabled || materialContext.forceBindGroupCreation;
        if (!cacheIsDisabled) {
            if (!drawContext.isDirty(materialContext.updateId) && !materialContext.isDirty) {
                $282ab957c009b331$export$81b864ad76b2a0d._NumBindGroupsNoLookupCurrentFrame++;
                return drawContext.bindGroups;
            }
            for (const bufferName of webgpuPipelineContext.shaderProcessingContext.bufferNames){
                const uboId = drawContext.buffers[bufferName]?.uniqueId ?? 0;
                let nextNode = node.values[uboId];
                if (!nextNode) {
                    nextNode = new $282ab957c009b331$var$WebGPUBindGroupCacheNode();
                    node.values[uboId] = nextNode;
                }
                node = nextNode;
            }
            for (const samplerName of webgpuPipelineContext.shaderProcessingContext.samplerNames){
                const samplerHashCode = materialContext.samplers[samplerName]?.hashCode ?? 0;
                let nextNode = node.values[samplerHashCode];
                if (!nextNode) {
                    nextNode = new $282ab957c009b331$var$WebGPUBindGroupCacheNode();
                    node.values[samplerHashCode] = nextNode;
                }
                node = nextNode;
            }
            for (const textureName of webgpuPipelineContext.shaderProcessingContext.textureNames){
                const textureId = materialContext.textures[textureName]?.texture?.uniqueId ?? 0;
                let nextNode = node.values[textureId];
                if (!nextNode) {
                    nextNode = new $282ab957c009b331$var$WebGPUBindGroupCacheNode();
                    node.values[textureId] = nextNode;
                }
                node = nextNode;
            }
            bindGroups = node.bindGroups;
        }
        drawContext.resetIsDirty(materialContext.updateId);
        materialContext.isDirty = false;
        if (bindGroups) {
            drawContext.bindGroups = bindGroups;
            $282ab957c009b331$export$81b864ad76b2a0d._NumBindGroupsLookupCurrentFrame++;
            return bindGroups;
        }
        bindGroups = [];
        drawContext.bindGroups = bindGroups;
        if (!cacheIsDisabled) node.bindGroups = bindGroups;
        $282ab957c009b331$export$81b864ad76b2a0d.NumBindGroupsCreatedTotal++;
        $282ab957c009b331$export$81b864ad76b2a0d._NumBindGroupsCreatedCurrentFrame++;
        const bindGroupLayouts = webgpuPipelineContext.bindGroupLayouts[materialContext.textureState];
        for(let i = 0; i < webgpuPipelineContext.shaderProcessingContext.bindGroupLayoutEntries.length; i++){
            const setDefinition = webgpuPipelineContext.shaderProcessingContext.bindGroupLayoutEntries[i];
            const entries = webgpuPipelineContext.shaderProcessingContext.bindGroupEntries[i];
            for(let j = 0; j < setDefinition.length; j++){
                const entry = webgpuPipelineContext.shaderProcessingContext.bindGroupLayoutEntries[i][j];
                const entryInfo = webgpuPipelineContext.shaderProcessingContext.bindGroupLayoutEntryInfo[i][entry.binding];
                const name = entryInfo.nameInArrayOfTexture ?? entryInfo.name;
                if (entry.sampler) {
                    const bindingInfo = materialContext.samplers[name];
                    if (bindingInfo) {
                        const sampler = bindingInfo.sampler;
                        if (!sampler) {
                            if (this._engine.dbgSanityChecks) (0, $kVtWi.Logger).Error(`Trying to bind a null sampler! entry=${JSON.stringify(entry)}, name=${name}, bindingInfo=${JSON.stringify(bindingInfo, (key, value)=>key === "texture" ? "<no dump>" : value)}, materialContext.uniqueId=${materialContext.uniqueId}`, 50);
                            continue;
                        }
                        entries[j].resource = this._cacheSampler.getSampler(sampler, false, bindingInfo.hashCode, sampler.label);
                    } else (0, $kVtWi.Logger).Error(`Sampler "${name}" could not be bound. entry=${JSON.stringify(entry)}, materialContext=${JSON.stringify(materialContext, (key, value)=>key === "texture" || key === "sampler" ? "<no dump>" : value)}`, 50);
                } else if (entry.texture || entry.storageTexture) {
                    const bindingInfo = materialContext.textures[name];
                    if (bindingInfo) {
                        if (this._engine.dbgSanityChecks && bindingInfo.texture === null) {
                            (0, $kVtWi.Logger).Error(`Trying to bind a null texture! entry=${JSON.stringify(entry)}, bindingInfo=${JSON.stringify(bindingInfo, (key, value)=>key === "texture" ? "<no dump>" : value)}, materialContext.uniqueId=${materialContext.uniqueId}`, 50);
                            continue;
                        }
                        const hardwareTexture = bindingInfo.texture._hardwareTexture;
                        if (this._engine.dbgSanityChecks && (!hardwareTexture || entry.texture && !hardwareTexture.view || entry.storageTexture && !hardwareTexture.viewForWriting)) {
                            (0, $kVtWi.Logger).Error(`Trying to bind a null gpu texture or view! entry=${JSON.stringify(entry)}, name=${name}, bindingInfo=${JSON.stringify(bindingInfo, (key, value)=>key === "texture" ? "<no dump>" : value)}, isReady=${bindingInfo.texture?.isReady}, materialContext.uniqueId=${materialContext.uniqueId}`, 50);
                            continue;
                        }
                        entries[j].resource = entry.storageTexture ? hardwareTexture.viewForWriting : hardwareTexture.view;
                    } else (0, $kVtWi.Logger).Error(`Texture "${name}" could not be bound. entry=${JSON.stringify(entry)}, materialContext=${JSON.stringify(materialContext, (key, value)=>key === "texture" || key === "sampler" ? "<no dump>" : value)}`, 50);
                } else if (entry.externalTexture) {
                    const bindingInfo = materialContext.textures[name];
                    if (bindingInfo) {
                        if (this._engine.dbgSanityChecks && bindingInfo.texture === null) {
                            (0, $kVtWi.Logger).Error(`Trying to bind a null external texture! entry=${JSON.stringify(entry)}, name=${name}, bindingInfo=${JSON.stringify(bindingInfo, (key, value)=>key === "texture" ? "<no dump>" : value)}, materialContext.uniqueId=${materialContext.uniqueId}`, 50);
                            continue;
                        }
                        const externalTexture = bindingInfo.texture.underlyingResource;
                        if (this._engine.dbgSanityChecks && !externalTexture) {
                            (0, $kVtWi.Logger).Error(`Trying to bind a null gpu external texture! entry=${JSON.stringify(entry)}, name=${name}, bindingInfo=${JSON.stringify(bindingInfo, (key, value)=>key === "texture" ? "<no dump>" : value)}, isReady=${bindingInfo.texture?.isReady}, materialContext.uniqueId=${materialContext.uniqueId}`, 50);
                            continue;
                        }
                        entries[j].resource = this._device.importExternalTexture({
                            source: externalTexture
                        });
                    } else (0, $kVtWi.Logger).Error(`Texture "${name}" could not be bound. entry=${JSON.stringify(entry)}, materialContext=${JSON.stringify(materialContext, (key, value)=>key === "texture" || key === "sampler" ? "<no dump>" : value)}`, 50);
                } else if (entry.buffer) {
                    const dataBuffer = drawContext.buffers[name];
                    if (dataBuffer) {
                        const webgpuBuffer = dataBuffer.underlyingResource;
                        entries[j].resource.buffer = webgpuBuffer;
                        entries[j].resource.size = dataBuffer.capacity;
                    } else (0, $kVtWi.Logger).Error(`Can't find buffer "${name}". entry=${JSON.stringify(entry)}, buffers=${JSON.stringify(drawContext.buffers)}, drawContext.uniqueId=${drawContext.uniqueId}`, 50);
                }
            }
            const groupLayout = bindGroupLayouts[i];
            bindGroups[i] = this._device.createBindGroup({
                layout: groupLayout,
                entries: entries
            });
        }
        return bindGroups;
    }
}
$282ab957c009b331$export$81b864ad76b2a0d.NumBindGroupsCreatedTotal = 0;
$282ab957c009b331$export$81b864ad76b2a0d.NumBindGroupsCreatedLastFrame = 0;
$282ab957c009b331$export$81b864ad76b2a0d.NumBindGroupsLookupLastFrame = 0;
$282ab957c009b331$export$81b864ad76b2a0d.NumBindGroupsNoLookupLastFrame = 0;
$282ab957c009b331$export$81b864ad76b2a0d._Cache = new $282ab957c009b331$var$WebGPUBindGroupCacheNode();
$282ab957c009b331$export$81b864ad76b2a0d._NumBindGroupsCreatedCurrentFrame = 0;
$282ab957c009b331$export$81b864ad76b2a0d._NumBindGroupsLookupCurrentFrame = 0;
$282ab957c009b331$export$81b864ad76b2a0d._NumBindGroupsNoLookupCurrentFrame = 0;

});

parcelRegister("2yTFf", function(module, exports) {

$parcel$export(module.exports, "WebGPUClearQuad", () => $1dd9ef7f04c8d840$export$24f98e87c9771216);

var $6dQQy = parcelRequire("6dQQy");

var $g5vsw = parcelRequire("g5vsw");

var $l46cr = parcelRequire("l46cr");

var $4ObYT = parcelRequire("4ObYT");
parcelRequire("bNNEF");
parcelRequire("3yhJf");
class $1dd9ef7f04c8d840$export$24f98e87c9771216 {
    setDepthStencilFormat(format) {
        this._depthTextureFormat = format;
        this._cacheRenderPipeline.setDepthStencilFormat(format);
    }
    setColorFormat(format) {
        this._cacheRenderPipeline.setColorFormat(format);
    }
    setMRTAttachments(attachments, textureArray, textureCount) {
        this._cacheRenderPipeline.setMRT(textureArray, textureCount);
        this._cacheRenderPipeline.setMRTAttachments(attachments);
    }
    constructor(device, engine, emptyVertexBuffer){
        this._bindGroups = {};
        this._bundleCache = {};
        this._keyTemp = [];
        this._device = device;
        this._engine = engine;
        this._cacheRenderPipeline = new (0, $6dQQy.WebGPUCacheRenderPipelineTree)(this._device, emptyVertexBuffer);
        this._cacheRenderPipeline.setDepthTestEnabled(false);
        this._cacheRenderPipeline.setStencilReadMask(0xff);
        this._effect = engine.createEffect("clearQuad", [], [
            "color",
            "depthValue"
        ]);
    }
    clear(renderPass, clearColor, clearDepth, clearStencil, sampleCount = 1) {
        let renderPass2;
        let bundle = null;
        let bundleKey;
        const isRTTPass = !!this._engine._currentRenderTarget;
        if (renderPass) renderPass2 = renderPass;
        else {
            let idx = 0;
            this._keyTemp.length = 0;
            for(let i = 0; i < this._cacheRenderPipeline.colorFormats.length; ++i)this._keyTemp[idx++] = (0, $4ObYT.renderableTextureFormatToIndex)[this._cacheRenderPipeline.colorFormats[i] ?? ""];
            const depthStencilFormatIndex = (0, $4ObYT.renderableTextureFormatToIndex)[this._depthTextureFormat ?? 0];
            this._keyTemp[idx] = (clearColor ? clearColor.r + clearColor.g * 256 + clearColor.b * 65536 + clearColor.a * 16777216 : 0) + (clearDepth ? 2 ** 32 : 0) + (clearStencil ? 2 ** 33 : 0) + (this._engine.useReverseDepthBuffer ? 2 ** 34 : 0) + (isRTTPass ? 2 ** 35 : 0) + (sampleCount > 1 ? 2 ** 36 : 0) + depthStencilFormatIndex * 2 ** 37;
            bundleKey = this._keyTemp.join("_");
            bundle = this._bundleCache[bundleKey];
            if (bundle) return bundle;
            renderPass2 = this._device.createRenderBundleEncoder({
                colorFormats: this._cacheRenderPipeline.colorFormats,
                depthStencilFormat: this._depthTextureFormat,
                sampleCount: (0, $l46cr.WebGPUTextureHelper).GetSample(sampleCount)
            });
        }
        this._cacheRenderPipeline.setDepthWriteEnabled(!!clearDepth);
        this._cacheRenderPipeline.setStencilEnabled(!!clearStencil && !!this._depthTextureFormat && (0, $l46cr.WebGPUTextureHelper).HasStencilAspect(this._depthTextureFormat));
        this._cacheRenderPipeline.setStencilWriteMask(clearStencil ? 0xff : 0);
        this._cacheRenderPipeline.setStencilCompare(clearStencil ? 519 : 512);
        this._cacheRenderPipeline.setStencilPassOp(clearStencil ? 7681 : 7680);
        this._cacheRenderPipeline.setWriteMask(clearColor ? 0xf : 0);
        const pipeline = this._cacheRenderPipeline.getRenderPipeline(7, this._effect, sampleCount);
        const webgpuPipelineContext = this._effect._pipelineContext;
        if (clearColor) this._effect.setDirectColor4("color", clearColor);
        this._effect.setFloat("depthValue", this._engine.useReverseDepthBuffer ? this._engine._clearReverseDepthValue : this._engine._clearDepthValue);
        webgpuPipelineContext.uniformBuffer.update();
        const bufferInternals = isRTTPass ? this._engine._ubInvertY : this._engine._ubDontInvertY;
        const bufferLeftOver = webgpuPipelineContext.uniformBuffer.getBuffer();
        const key = bufferLeftOver.uniqueId + "-" + bufferInternals.uniqueId;
        let bindGroups = this._bindGroups[key];
        if (!bindGroups) {
            const bindGroupLayouts = webgpuPipelineContext.bindGroupLayouts[0];
            bindGroups = this._bindGroups[key] = [];
            bindGroups.push(this._device.createBindGroup({
                layout: bindGroupLayouts[0],
                entries: []
            }));
            if (!(0, $g5vsw.WebGPUShaderProcessingContext)._SimplifiedKnownBindings) bindGroups.push(this._device.createBindGroup({
                layout: bindGroupLayouts[1],
                entries: []
            }));
            bindGroups.push(this._device.createBindGroup({
                layout: bindGroupLayouts[(0, $g5vsw.WebGPUShaderProcessingContext)._SimplifiedKnownBindings ? 1 : 2],
                entries: [
                    {
                        binding: 0,
                        resource: {
                            buffer: bufferInternals.underlyingResource,
                            size: bufferInternals.capacity
                        }
                    },
                    {
                        binding: 1,
                        resource: {
                            buffer: bufferLeftOver.underlyingResource,
                            size: bufferLeftOver.capacity
                        }
                    }
                ]
            }));
        }
        renderPass2.setPipeline(pipeline);
        for(let i = 0; i < bindGroups.length; ++i)renderPass2.setBindGroup(i, bindGroups[i]);
        renderPass2.draw(4, 1, 0, 0);
        if (!renderPass) {
            bundle = renderPass2.finish();
            this._bundleCache[bundleKey] = bundle;
        }
        return bundle;
    }
}

});
parcelRegister("bNNEF", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $897ac9c3d8d4043e$var$name = "clearQuadVertexShader";
const $897ac9c3d8d4043e$var$shader = `uniform float depthValue;const vec2 pos[4]={vec2(-1.0,1.0),
vec2(1.0,1.0),
vec2(-1.0,-1.0),
vec2(1.0,-1.0)};
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
gl_Position=vec4(pos[gl_VertexID],depthValue,1.0);
#define CUSTOM_VERTEX_MAIN_END
}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$897ac9c3d8d4043e$var$name] = $897ac9c3d8d4043e$var$shader;
const $897ac9c3d8d4043e$export$b2cda91aea77d222 = {
    name: $897ac9c3d8d4043e$var$name,
    shader: $897ac9c3d8d4043e$var$shader
};

});

parcelRegister("3yhJf", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $29624ca3e13f51b1$var$name = "clearQuadPixelShader";
const $29624ca3e13f51b1$var$shader = `uniform vec4 color;void main() {gl_FragColor=color;}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$29624ca3e13f51b1$var$name] = $29624ca3e13f51b1$var$shader;
const $29624ca3e13f51b1$export$4dea9257819aedf5 = {
    name: $29624ca3e13f51b1$var$name,
    shader: $29624ca3e13f51b1$var$shader
};

});


parcelRegister("6HEDe", function(module, exports) {

$parcel$export(module.exports, "WebGPURenderItemViewport", () => $4e1646d5abf655e4$export$f8e0675d7c0ec12f);
$parcel$export(module.exports, "WebGPURenderItemScissor", () => $4e1646d5abf655e4$export$53b6c50c5a294438);
$parcel$export(module.exports, "WebGPURenderItemStencilRef", () => $4e1646d5abf655e4$export$ae69134a2072a6f1);
$parcel$export(module.exports, "WebGPURenderItemBlendColor", () => $4e1646d5abf655e4$export$1bf1d1f5a708e817);
$parcel$export(module.exports, "WebGPURenderItemBeginOcclusionQuery", () => $4e1646d5abf655e4$export$516f7394c439391);
$parcel$export(module.exports, "WebGPURenderItemEndOcclusionQuery", () => $4e1646d5abf655e4$export$ee2ff7203449ca77);
$parcel$export(module.exports, "WebGPUBundleList", () => $4e1646d5abf655e4$export$dd5fcfeabea31c14);

var $l46cr = parcelRequire("l46cr");
class $4e1646d5abf655e4$export$f8e0675d7c0ec12f {
    constructor(x, y, w, h){
        this.x = Math.floor(x);
        this.y = Math.floor(y);
        this.w = Math.floor(w);
        this.h = Math.floor(h);
    }
    run(renderPass) {
        renderPass.setViewport(this.x, this.y, this.w, this.h, 0, 1);
    }
    clone() {
        return new $4e1646d5abf655e4$export$f8e0675d7c0ec12f(this.x, this.y, this.w, this.h);
    }
}
class $4e1646d5abf655e4$export$53b6c50c5a294438 {
    constructor(x, y, w, h){
        this.x = x;
        this.y = y;
        this.w = w;
        this.h = h;
    }
    run(renderPass) {
        renderPass.setScissorRect(this.x, this.y, this.w, this.h);
    }
    clone() {
        return new $4e1646d5abf655e4$export$53b6c50c5a294438(this.x, this.y, this.w, this.h);
    }
}
class $4e1646d5abf655e4$export$ae69134a2072a6f1 {
    constructor(ref){
        this.ref = ref;
    }
    run(renderPass) {
        renderPass.setStencilReference(this.ref);
    }
    clone() {
        return new $4e1646d5abf655e4$export$ae69134a2072a6f1(this.ref);
    }
}
class $4e1646d5abf655e4$export$1bf1d1f5a708e817 {
    constructor(color){
        this.color = color;
    }
    run(renderPass) {
        renderPass.setBlendConstant(this.color);
    }
    clone() {
        return new $4e1646d5abf655e4$export$1bf1d1f5a708e817(this.color);
    }
}
class $4e1646d5abf655e4$export$516f7394c439391 {
    constructor(query){
        this.query = query;
    }
    run(renderPass) {
        renderPass.beginOcclusionQuery(this.query);
    }
    clone() {
        return new $4e1646d5abf655e4$export$516f7394c439391(this.query);
    }
}
class $4e1646d5abf655e4$export$ee2ff7203449ca77 {
    constructor(){}
    run(renderPass) {
        renderPass.endOcclusionQuery();
    }
    clone() {
        return new $4e1646d5abf655e4$export$ee2ff7203449ca77();
    }
}
class $4e1646d5abf655e4$var$WebGPURenderItemBundles {
    constructor(){
        this.bundles = [];
    }
    run(renderPass) {
        renderPass.executeBundles(this.bundles);
    }
    clone() {
        const cloned = new $4e1646d5abf655e4$var$WebGPURenderItemBundles();
        cloned.bundles = this.bundles;
        return cloned;
    }
}
class $4e1646d5abf655e4$export$dd5fcfeabea31c14 {
    constructor(device){
        this.numDrawCalls = 0;
        this._device = device;
        this._list = new Array(10);
        this._listLength = 0;
    }
    addBundle(bundle) {
        if (!this._currentItemIsBundle) {
            const item = new $4e1646d5abf655e4$var$WebGPURenderItemBundles();
            this._list[this._listLength++] = item;
            this._currentBundleList = item.bundles;
            this._currentItemIsBundle = true;
        }
        if (bundle) this._currentBundleList.push(bundle);
    }
    _finishBundle() {
        if (this._currentItemIsBundle && this._bundleEncoder) {
            this._currentBundleList.push(this._bundleEncoder.finish());
            this._bundleEncoder = undefined;
            this._currentItemIsBundle = false;
        }
    }
    addItem(item) {
        this._finishBundle();
        this._list[this._listLength++] = item;
        this._currentItemIsBundle = false;
    }
    getBundleEncoder(colorFormats, depthStencilFormat, sampleCount) {
        if (!this._currentItemIsBundle) {
            this.addBundle();
            this._bundleEncoder = this._device.createRenderBundleEncoder({
                colorFormats: colorFormats,
                depthStencilFormat: depthStencilFormat,
                sampleCount: (0, $l46cr.WebGPUTextureHelper).GetSample(sampleCount)
            });
        }
        return this._bundleEncoder;
    }
    close() {
        this._finishBundle();
    }
    run(renderPass) {
        this.close();
        for(let i = 0; i < this._listLength; ++i)this._list[i].run(renderPass);
    }
    reset() {
        this._listLength = 0;
        this._currentItemIsBundle = false;
        this.numDrawCalls = 0;
    }
    clone() {
        this.close();
        const cloned = new $4e1646d5abf655e4$export$dd5fcfeabea31c14(this._device);
        cloned._list = new Array(this._listLength);
        cloned._listLength = this._listLength;
        cloned.numDrawCalls = this.numDrawCalls;
        for(let i = 0; i < this._listLength; ++i)cloned._list[i] = this._list[i].clone();
        return cloned;
    }
}

});

parcelRegister("hECLP", function(module, exports) {

$parcel$export(module.exports, "WebGPUTimestampQuery", () => $cda43f1d1948c601$export$5fa38500ca551cab);

var $hR6HG = parcelRequire("hR6HG");

var $2Fclq = parcelRequire("2Fclq");

var $fv93L = parcelRequire("fv93L");

var $kVtWi = parcelRequire("kVtWi");
class $cda43f1d1948c601$export$5fa38500ca551cab {
    get gpuFrameTimeCounter() {
        return this._gpuFrameTimeCounter;
    }
    constructor(engine, device, bufferManager){
        this._enabled = false;
        this._gpuFrameTimeCounter = new (0, $2Fclq.PerfCounter)();
        this._measureDurationState = 0;
        this._engine = engine;
        this._device = device;
        this._bufferManager = bufferManager;
    }
    get enable() {
        return this._enabled;
    }
    set enable(value) {
        if (this._enabled === value) return;
        this._enabled = value;
        this._measureDurationState = 0;
        if (value) try {
            this._measureDuration = new $cda43f1d1948c601$export$720b2c47427948af(this._engine, this._device, this._bufferManager, 2000, "QuerySet_TimestampQuery");
        } catch (e) {
            this._enabled = false;
            (0, $kVtWi.Logger).Error("Could not create a WebGPUDurationMeasure!\nError: " + e.message + "\nMake sure timestamp query is supported and enabled in your browser.");
            return;
        }
        else this._measureDuration.dispose();
    }
    startFrame(commandEncoder) {
        if (this._enabled && this._measureDurationState === 0) {
            this._measureDuration.start(commandEncoder);
            this._measureDurationState = 1;
        }
    }
    endFrame(commandEncoder) {
        if (this._measureDurationState === 1) {
            this._measureDurationState = 2;
            this._measureDuration.stop(commandEncoder).then((duration)=>{
                if (duration !== null && duration >= 0) {
                    this._gpuFrameTimeCounter.fetchNewFrame();
                    this._gpuFrameTimeCounter.addCount(duration, true);
                }
                this._measureDurationState = 0;
            });
        }
    }
    startPass(descriptor, index) {
        if (this._enabled) this._measureDuration.startPass(descriptor, index);
        else descriptor.timestampWrites = undefined;
    }
    endPass(index, gpuPerfCounter) {
        if (!this._enabled || !gpuPerfCounter) return;
        const currentFrameId = this._engine.frameId;
        this._measureDuration.stopPass(index).then((duration_)=>{
            gpuPerfCounter._addDuration(currentFrameId, duration_ !== null && duration_ > 0 ? duration_ : 0);
        });
    }
    dispose() {
        this._measureDuration?.dispose();
    }
}
class $cda43f1d1948c601$export$720b2c47427948af {
    constructor(engine, device, bufferManager, count = 2, querySetLabel){
        this._count = count;
        this._querySet = new (0, $fv93L.WebGPUQuerySet)(engine, count, $hR6HG.QueryType.Timestamp, device, bufferManager, true, querySetLabel);
    }
    start(encoder) {
        encoder.writeTimestamp?.(this._querySet.querySet, 0);
    }
    async stop(encoder) {
        encoder.writeTimestamp?.(this._querySet.querySet, 1);
        return encoder.writeTimestamp ? this._querySet.readTwoValuesAndSubtract(0) : 0;
    }
    startPass(descriptor, index) {
        if (index + 3 > this._count) throw new Error("WebGPUDurationMeasure: index out of range (" + index + ")");
        descriptor.timestampWrites = {
            querySet: this._querySet.querySet,
            beginningOfPassWriteIndex: index + 2,
            endOfPassWriteIndex: index + 3
        };
    }
    async stopPass(index) {
        return this._querySet.readTwoValuesAndSubtract(index + 2);
    }
    dispose() {
        this._querySet.dispose();
    }
}

});
parcelRegister("fv93L", function(module, exports) {

$parcel$export(module.exports, "WebGPUQuerySet", () => $b490c75c14850695$export$fd9df13c9c498adc);

var $hR6HG = parcelRequire("hR6HG");
class $b490c75c14850695$export$fd9df13c9c498adc {
    get querySet() {
        return this._querySet;
    }
    constructor(engine, count, type, device, bufferManager, canUseMultipleBuffers = true, label){
        this._dstBuffers = [];
        this._engine = engine;
        this._device = device;
        this._bufferManager = bufferManager;
        this._count = count;
        this._canUseMultipleBuffers = canUseMultipleBuffers;
        this._querySet = device.createQuerySet({
            label: label ?? "QuerySet",
            type: type,
            count: count
        });
        this._queryBuffer = bufferManager.createRawBuffer(8 * count, $hR6HG.BufferUsage.QueryResolve | $hR6HG.BufferUsage.CopySrc, undefined, "QueryBuffer");
        if (!canUseMultipleBuffers) this._dstBuffers.push(this._bufferManager.createRawBuffer(8 * this._count, $hR6HG.BufferUsage.MapRead | $hR6HG.BufferUsage.CopyDst, undefined, "QueryBufferNoMultipleBuffers"));
    }
    _getBuffer(firstQuery, queryCount) {
        if (!this._canUseMultipleBuffers && this._dstBuffers.length === 0) return null;
        const encoderResult = this._device.createCommandEncoder();
        let buffer;
        if (this._dstBuffers.length === 0) buffer = this._bufferManager.createRawBuffer(8 * this._count, $hR6HG.BufferUsage.MapRead | $hR6HG.BufferUsage.CopyDst, undefined, "QueryBufferAdditionalBuffer");
        else {
            buffer = this._dstBuffers[this._dstBuffers.length - 1];
            this._dstBuffers.length--;
        }
        encoderResult.resolveQuerySet(this._querySet, firstQuery, queryCount, this._queryBuffer, 0);
        encoderResult.copyBufferToBuffer(this._queryBuffer, 0, buffer, 0, 8 * queryCount);
        this._device.queue.submit([
            encoderResult.finish()
        ]);
        return buffer;
    }
    async readValues(firstQuery = 0, queryCount = 1) {
        const buffer = this._getBuffer(firstQuery, queryCount);
        if (buffer === null) return null;
        const engineId = this._engine.uniqueId;
        return buffer.mapAsync($hR6HG.MapMode.Read).then(()=>{
            const arrayBuf = new BigUint64Array(buffer.getMappedRange()).slice();
            buffer.unmap();
            this._dstBuffers[this._dstBuffers.length] = buffer;
            return arrayBuf;
        }, (err)=>{
            if (this._engine.isDisposed || this._engine.uniqueId !== engineId) // Engine disposed or context loss/restoration
            return null;
            throw err;
        });
    }
    async readValue(firstQuery = 0) {
        const buffer = this._getBuffer(firstQuery, 1);
        if (buffer === null) return null;
        const engineId = this._engine.uniqueId;
        return buffer.mapAsync($hR6HG.MapMode.Read).then(()=>{
            const arrayBuf = new BigUint64Array(buffer.getMappedRange());
            const value = Number(arrayBuf[0]);
            buffer.unmap();
            this._dstBuffers[this._dstBuffers.length] = buffer;
            return value;
        }, (err)=>{
            if (this._engine.isDisposed || this._engine.uniqueId !== engineId) // Engine disposed or context loss/restoration
            return 0;
            throw err;
        });
    }
    async readTwoValuesAndSubtract(firstQuery = 0) {
        const buffer = this._getBuffer(firstQuery, 2);
        if (buffer === null) return null;
        const engineId = this._engine.uniqueId;
        return buffer.mapAsync($hR6HG.MapMode.Read).then(()=>{
            const arrayBuf = new BigUint64Array(buffer.getMappedRange());
            const value = Number(arrayBuf[1] - arrayBuf[0]);
            buffer.unmap();
            this._dstBuffers[this._dstBuffers.length] = buffer;
            return value;
        }, (err)=>{
            if (this._engine.isDisposed || this._engine.uniqueId !== engineId) // Engine disposed or context loss/restoration
            return 0;
            throw err;
        });
    }
    dispose() {
        this._querySet.destroy();
        this._bufferManager.releaseBuffer(this._queryBuffer);
        for(let i = 0; i < this._dstBuffers.length; ++i)this._bufferManager.releaseBuffer(this._dstBuffers[i]);
    }
}

});


parcelRegister("jynN8", function(module, exports) {

$parcel$export(module.exports, "WebGPUOcclusionQuery", () => $e3c3a5cd8e9c7e04$export$c7cc0bb9ab559cf3);

var $hR6HG = parcelRequire("hR6HG");

var $fv93L = parcelRequire("fv93L");
class $e3c3a5cd8e9c7e04$export$c7cc0bb9ab559cf3 {
    get querySet() {
        return this._querySet.querySet;
    }
    get hasQueries() {
        return this._currentTotalIndices !== this._availableIndices.length;
    }
    canBeginQuery(index) {
        if (this._frameQuerySetIsDirty === this._engine.frameId || this._queryFrameId[index] === this._engine.frameId) return false;
        const canBegin = this._engine._getCurrentRenderPassWrapper().renderPassDescriptor.occlusionQuerySet !== undefined;
        if (canBegin) this._queryFrameId[index] = this._engine.frameId;
        return canBegin;
    }
    constructor(engine, device, bufferManager, startCount = 50, incrementCount = 100){
        this._availableIndices = [];
        this._frameQuerySetIsDirty = -1;
        this._queryFrameId = [];
        this._engine = engine;
        this._device = device;
        this._bufferManager = bufferManager;
        this._frameLastBuffer = -1;
        this._currentTotalIndices = 0;
        this._countIncrement = incrementCount;
        this._allocateNewIndices(startCount);
    }
    createQuery() {
        if (this._availableIndices.length === 0) this._allocateNewIndices();
        const index = this._availableIndices[this._availableIndices.length - 1];
        this._availableIndices.length--;
        return index;
    }
    deleteQuery(index) {
        this._availableIndices[this._availableIndices.length] = index;
    }
    isQueryResultAvailable(index) {
        this._retrieveQueryBuffer();
        return !!this._lastBuffer && index < this._lastBuffer.length;
    }
    getQueryResult(index) {
        return Number(this._lastBuffer?.[index] ?? -1);
    }
    _retrieveQueryBuffer() {
        if (this._lastBuffer && this._frameLastBuffer === this._engine.frameId) return;
        if (this._frameLastBuffer !== this._engine.frameId) {
            this._frameLastBuffer = this._engine.frameId;
            this._querySet.readValues(0, this._currentTotalIndices).then((arrayBuffer)=>{
                this._lastBuffer = arrayBuffer;
            });
        }
    }
    _allocateNewIndices(numIndices) {
        numIndices = numIndices ?? this._countIncrement;
        this._delayQuerySetDispose();
        for(let i = 0; i < numIndices; ++i)this._availableIndices.push(this._currentTotalIndices + i);
        this._currentTotalIndices += numIndices;
        this._querySet = new (0, $fv93L.WebGPUQuerySet)(this._engine, this._currentTotalIndices, $hR6HG.QueryType.Occlusion, this._device, this._bufferManager, false, "QuerySet_OcclusionQuery_count_" + this._currentTotalIndices);
        this._frameQuerySetIsDirty = this._engine.frameId;
    }
    _delayQuerySetDispose() {
        const querySet = this._querySet;
        if (querySet) // Wait a bit before disposing of the queryset, in case some queries are still running for it
        setTimeout(()=>querySet.dispose, 1000);
    }
    dispose() {
        this._querySet?.dispose();
        this._availableIndices.length = 0;
    }
}

});

parcelRegister("kBotW", function(module, exports) {

$parcel$export(module.exports, "WebGPUTintWASM", () => $effa40f3c31bdaca$export$27f853bbeeee2c00);

var $kVtWi = parcelRequire("kVtWi");

var $bOhSV = parcelRequire("bOhSV");
class $effa40f3c31bdaca$export$27f853bbeeee2c00 {
    async initTwgsl(twgslOptions) {
        if ($effa40f3c31bdaca$export$27f853bbeeee2c00._Twgsl) return;
        twgslOptions = twgslOptions || {};
        twgslOptions = {
            ...$effa40f3c31bdaca$export$27f853bbeeee2c00._TWgslDefaultOptions,
            ...twgslOptions
        };
        if (twgslOptions.twgsl) {
            $effa40f3c31bdaca$export$27f853bbeeee2c00._Twgsl = twgslOptions.twgsl;
            return Promise.resolve();
        }
        if (twgslOptions.jsPath && twgslOptions.wasmPath) await (0, $bOhSV.Tools).LoadBabylonScriptAsync(twgslOptions.jsPath);
        if (self.twgsl) {
            $effa40f3c31bdaca$export$27f853bbeeee2c00._Twgsl = await self.twgsl((0, $bOhSV.Tools).GetBabylonScriptURL(twgslOptions.wasmPath));
            return Promise.resolve();
        }
        return Promise.reject("twgsl is not available.");
    }
    convertSpirV2WGSL(code, disableUniformityAnalysis = false) {
        const ccode = $effa40f3c31bdaca$export$27f853bbeeee2c00._Twgsl.convertSpirV2WGSL(code, $effa40f3c31bdaca$export$27f853bbeeee2c00.DisableUniformityAnalysis || disableUniformityAnalysis);
        if ($effa40f3c31bdaca$export$27f853bbeeee2c00.ShowWGSLShaderCode) {
            (0, $kVtWi.Logger).Log(ccode);
            (0, $kVtWi.Logger).Log("***********************************************");
        }
        return $effa40f3c31bdaca$export$27f853bbeeee2c00.DisableUniformityAnalysis || disableUniformityAnalysis ? "diagnostic(off, derivative_uniformity);\n" + ccode : ccode;
    }
}
// Default twgsl options.
$effa40f3c31bdaca$export$27f853bbeeee2c00._TWgslDefaultOptions = {
    jsPath: `${(0, $bOhSV.Tools)._DefaultCdnUrl}/twgsl/twgsl.js`,
    wasmPath: `${(0, $bOhSV.Tools)._DefaultCdnUrl}/twgsl/twgsl.wasm`
};
$effa40f3c31bdaca$export$27f853bbeeee2c00.ShowWGSLShaderCode = false;
$effa40f3c31bdaca$export$27f853bbeeee2c00.DisableUniformityAnalysis = false;
$effa40f3c31bdaca$export$27f853bbeeee2c00._Twgsl = null;

});

parcelRegister("7CgyA", function(module, exports) {

$parcel$export(module.exports, "WebGPUSnapshotRendering", () => $58b8ecde2e3c8d7a$export$f71dc38546478216);
/** @internal */ class $58b8ecde2e3c8d7a$export$f71dc38546478216 {
    constructor(engine, renderingMode, bundleList){
        this._record = false;
        this._play = false;
        this._playBundleListIndex = 0;
        this._allBundleLists = [];
        this._enabled = false;
        this._engine = engine;
        this._mode = renderingMode;
        this._bundleList = bundleList;
    }
    get enabled() {
        return this._enabled;
    }
    get play() {
        return this._play;
    }
    get record() {
        return this._record;
    }
    set enabled(activate) {
        this._allBundleLists.length = 0;
        this._record = this._enabled = activate;
        this._play = false;
        if (activate) {
            this._modeSaved = this._mode;
            this._mode = 0; // need to reset to standard for the recording pass to avoid some code being bypassed
        }
    }
    get mode() {
        return this._mode;
    }
    set mode(mode) {
        if (this._record) this._modeSaved = mode;
        else this._mode = mode;
    }
    endRenderPass(currentRenderPass) {
        if (!this._record && !this._play) // Snapshot rendering mode is not enabled
        return false;
        let bundleList;
        if (this._record) {
            bundleList = this._bundleList.clone();
            this._allBundleLists.push(bundleList);
            this._bundleList.reset();
        } else {
            // We are playing the snapshot
            if (this._playBundleListIndex >= this._allBundleLists.length) throw new Error(`Invalid playBundleListIndex! Your snapshot is no longer valid for the current frame, you should recreate a new one. playBundleListIndex=${this._playBundleListIndex}, allBundleLists.length=${this._allBundleLists.length}}`);
            bundleList = this._allBundleLists[this._playBundleListIndex++];
        }
        bundleList.run(currentRenderPass);
        if (this._mode === 1) this._engine._reportDrawCall(bundleList.numDrawCalls);
        return true;
    }
    endFrame() {
        if (this._record) {
            // We stop recording and switch to replay mode for the next frames
            this._record = false;
            this._play = true;
            this._mode = this._modeSaved;
        }
        this._playBundleListIndex = 0;
    }
    reset() {
        this.enabled = false;
        this.enabled = true;
    }
}

});

parcelRegister("4z1y7", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $352ba1f149056c4b$var$name = "postprocessVertexShader";
const $352ba1f149056c4b$var$shader = `attribute position: vec2<f32>;uniform scale: vec2<f32>;varying vUV: vec2<f32>;const madd=vec2(0.5,0.5);
#define CUSTOM_VERTEX_DEFINITIONS
@vertex
fn main(input : VertexInputs)->FragmentInputs {
#define CUSTOM_VERTEX_MAIN_BEGIN
vertexOutputs.vUV=(vertexInputs.position*madd+madd)*uniforms.scale;vertexOutputs.position=vec4(vertexInputs.position,0.0,1.0);
#define CUSTOM_VERTEX_MAIN_END
}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStoreWGSL[$352ba1f149056c4b$var$name] = $352ba1f149056c4b$var$shader;
const $352ba1f149056c4b$export$5141e57baab30e29 = {
    name: $352ba1f149056c4b$var$name,
    shader: $352ba1f149056c4b$var$shader
};

});



parcelRegister("lLafQ", function(module, exports) {

var $kVtWi = parcelRequire("kVtWi");

var $1chVU = parcelRequire("1chVU");

var $64Ihk = parcelRequire("64Ihk");

var $j90KA = parcelRequire("j90KA");

var $02Yxr = parcelRequire("02Yxr");

var $hR6HG = parcelRequire("hR6HG");
const $fd75f119f956aceb$var$computePassDescriptor = {};
(0, $64Ihk.WebGPUEngine).prototype.createComputeContext = function() {
    return new (0, $j90KA.WebGPUComputeContext)(this._device, this._cacheSampler);
};
(0, $64Ihk.WebGPUEngine).prototype.createComputeEffect = function(baseName, options) {
    const compute = baseName.computeElement || baseName.compute || baseName.computeToken || baseName.computeSource || baseName;
    const name = compute + "@" + options.defines;
    if (this._compiledComputeEffects[name]) {
        const compiledEffect = this._compiledComputeEffects[name];
        if (options.onCompiled && compiledEffect.isReady()) options.onCompiled(compiledEffect);
        return compiledEffect;
    }
    const effect = new (0, $1chVU.ComputeEffect)(baseName, options, this, name);
    this._compiledComputeEffects[name] = effect;
    return effect;
};
(0, $64Ihk.WebGPUEngine).prototype.createComputePipelineContext = function() {
    return new (0, $02Yxr.WebGPUComputePipelineContext)(this);
};
(0, $64Ihk.WebGPUEngine).prototype.areAllComputeEffectsReady = function() {
    for(const key in this._compiledComputeEffects){
        const effect = this._compiledComputeEffects[key];
        if (!effect.isReady()) return false;
    }
    return true;
};
(0, $64Ihk.WebGPUEngine).prototype.computeDispatch = function(effect, context, bindings, x, y = 1, z = 1, bindingsMapping, gpuPerfCounter) {
    this._endCurrentRenderPass();
    const contextPipeline = effect._pipelineContext;
    const computeContext = context;
    if (!contextPipeline.computePipeline) contextPipeline.computePipeline = this._device.createComputePipeline({
        layout: $hR6HG.AutoLayoutMode.Auto,
        compute: contextPipeline.stage
    });
    if (gpuPerfCounter) this._timestampQuery.startPass($fd75f119f956aceb$var$computePassDescriptor, this._timestampIndex);
    const computePass = this._renderEncoder.beginComputePass($fd75f119f956aceb$var$computePassDescriptor);
    computePass.setPipeline(contextPipeline.computePipeline);
    const bindGroups = computeContext.getBindGroups(bindings, contextPipeline.computePipeline, bindingsMapping);
    for(let i = 0; i < bindGroups.length; ++i){
        const bindGroup = bindGroups[i];
        if (!bindGroup) continue;
        computePass.setBindGroup(i, bindGroup);
    }
    if (x + y + z > 0) computePass.dispatchWorkgroups(x, y, z);
    computePass.end();
    if (gpuPerfCounter) {
        this._timestampQuery.endPass(this._timestampIndex, gpuPerfCounter);
        this._timestampIndex += 2;
    }
};
(0, $64Ihk.WebGPUEngine).prototype.releaseComputeEffects = function() {
    for(const name in this._compiledComputeEffects){
        const webGPUPipelineContextCompute = this._compiledComputeEffects[name].getPipelineContext();
        this._deleteComputePipelineContext(webGPUPipelineContextCompute);
    }
    this._compiledComputeEffects = {};
};
(0, $64Ihk.WebGPUEngine).prototype._prepareComputePipelineContext = function(pipelineContext, computeSourceCode, rawComputeSourceCode, defines, entryPoint) {
    const webGpuContext = pipelineContext;
    if (this.dbgShowShaderCode) {
        (0, $kVtWi.Logger).Log(defines);
        (0, $kVtWi.Logger).Log(computeSourceCode);
    }
    webGpuContext.sources = {
        compute: computeSourceCode,
        rawCompute: rawComputeSourceCode
    };
    webGpuContext.stage = this._createComputePipelineStageDescriptor(computeSourceCode, defines, entryPoint);
};
(0, $64Ihk.WebGPUEngine).prototype._releaseComputeEffect = function(effect) {
    if (this._compiledComputeEffects[effect._key]) {
        delete this._compiledComputeEffects[effect._key];
        this._deleteComputePipelineContext(effect.getPipelineContext());
    }
};
(0, $64Ihk.WebGPUEngine).prototype._rebuildComputeEffects = function() {
    for(const key in this._compiledComputeEffects){
        const effect = this._compiledComputeEffects[key];
        effect._pipelineContext = null;
        effect._wasPreviouslyReady = false;
        effect._prepareEffect();
    }
};
(0, $64Ihk.WebGPUEngine).prototype._deleteComputePipelineContext = function(pipelineContext) {
    const webgpuPipelineContext = pipelineContext;
    if (webgpuPipelineContext) pipelineContext.dispose();
};
(0, $64Ihk.WebGPUEngine).prototype._createComputePipelineStageDescriptor = function(computeShader, defines, entryPoint) {
    if (defines) defines = "//" + defines.split("\n").join("\n//") + "\n";
    else defines = "";
    return {
        module: this._device.createShaderModule({
            code: defines + computeShader
        }),
        entryPoint: entryPoint
    };
};

});
parcelRegister("j90KA", function(module, exports) {

$parcel$export(module.exports, "WebGPUComputeContext", () => $deff709d421b2bed$export$a43eea98e97e5084);

var $kVtWi = parcelRequire("kVtWi");

var $fDq5D = parcelRequire("fDq5D");

var $hR6HG = parcelRequire("hR6HG");
class $deff709d421b2bed$export$a43eea98e97e5084 {
    getBindGroups(bindings, computePipeline, bindingsMapping) {
        if (!bindingsMapping) throw new Error("WebGPUComputeContext.getBindGroups: bindingsMapping is required until browsers support reflection for wgsl shaders!");
        if (this._bindGroups.length === 0) {
            const bindGroupEntriesExist = this._bindGroupEntries.length > 0;
            for(const key in bindings){
                const binding = bindings[key], location = bindingsMapping[key], group = location.group, index = location.binding, type = binding.type, object = binding.object;
                let indexInGroupEntries = binding.indexInGroupEntries;
                let entries = this._bindGroupEntries[group];
                if (!entries) entries = this._bindGroupEntries[group] = [];
                switch(type){
                    case (0, $fDq5D.ComputeBindingType).Sampler:
                        {
                            const sampler = object;
                            if (indexInGroupEntries !== undefined && bindGroupEntriesExist) entries[indexInGroupEntries].resource = this._cacheSampler.getSampler(sampler);
                            else {
                                binding.indexInGroupEntries = entries.length;
                                entries.push({
                                    binding: index,
                                    resource: this._cacheSampler.getSampler(sampler)
                                });
                            }
                            break;
                        }
                    case (0, $fDq5D.ComputeBindingType).Texture:
                    case (0, $fDq5D.ComputeBindingType).TextureWithoutSampler:
                        {
                            const texture = object;
                            const hardwareTexture = texture._texture._hardwareTexture;
                            if (indexInGroupEntries !== undefined && bindGroupEntriesExist) {
                                if (type === (0, $fDq5D.ComputeBindingType).Texture) entries[indexInGroupEntries++].resource = this._cacheSampler.getSampler(texture._texture);
                                entries[indexInGroupEntries].resource = hardwareTexture.view;
                            } else {
                                binding.indexInGroupEntries = entries.length;
                                if (type === (0, $fDq5D.ComputeBindingType).Texture) entries.push({
                                    binding: index - 1,
                                    resource: this._cacheSampler.getSampler(texture._texture)
                                });
                                entries.push({
                                    binding: index,
                                    resource: hardwareTexture.view
                                });
                            }
                            break;
                        }
                    case (0, $fDq5D.ComputeBindingType).StorageTexture:
                        {
                            const texture = object;
                            const hardwareTexture = texture._texture._hardwareTexture;
                            if ((hardwareTexture.textureAdditionalUsages & $hR6HG.TextureUsage.StorageBinding) === 0) (0, $kVtWi.Logger).Error(`computeDispatch: The texture (name=${texture.name}, uniqueId=${texture.uniqueId}) is not a storage texture!`, 50);
                            if (indexInGroupEntries !== undefined && bindGroupEntriesExist) entries[indexInGroupEntries].resource = hardwareTexture.viewForWriting;
                            else {
                                binding.indexInGroupEntries = entries.length;
                                entries.push({
                                    binding: index,
                                    resource: hardwareTexture.viewForWriting
                                });
                            }
                            break;
                        }
                    case (0, $fDq5D.ComputeBindingType).ExternalTexture:
                        {
                            const texture = object;
                            const externalTexture = texture.underlyingResource;
                            if (indexInGroupEntries !== undefined && bindGroupEntriesExist) entries[indexInGroupEntries].resource = this._device.importExternalTexture({
                                source: externalTexture
                            });
                            else {
                                binding.indexInGroupEntries = entries.length;
                                entries.push({
                                    binding: index,
                                    resource: this._device.importExternalTexture({
                                        source: externalTexture
                                    })
                                });
                            }
                            break;
                        }
                    case (0, $fDq5D.ComputeBindingType).UniformBuffer:
                    case (0, $fDq5D.ComputeBindingType).StorageBuffer:
                    case (0, $fDq5D.ComputeBindingType).DataBuffer:
                        {
                            const dataBuffer = type === (0, $fDq5D.ComputeBindingType).DataBuffer ? object : type === (0, $fDq5D.ComputeBindingType).UniformBuffer ? object.getBuffer() : object.getBuffer();
                            const webgpuBuffer = dataBuffer.underlyingResource;
                            if (indexInGroupEntries !== undefined && bindGroupEntriesExist) {
                                entries[indexInGroupEntries].resource.buffer = webgpuBuffer;
                                entries[indexInGroupEntries].resource.size = dataBuffer.capacity;
                            } else {
                                binding.indexInGroupEntries = entries.length;
                                entries.push({
                                    binding: index,
                                    resource: {
                                        buffer: webgpuBuffer,
                                        offset: 0,
                                        size: dataBuffer.capacity
                                    }
                                });
                            }
                            break;
                        }
                }
            }
            for(let i = 0; i < this._bindGroupEntries.length; ++i){
                const entries = this._bindGroupEntries[i];
                if (!entries) {
                    this._bindGroups[i] = undefined;
                    continue;
                }
                this._bindGroups[i] = this._device.createBindGroup({
                    layout: computePipeline.getBindGroupLayout(i),
                    entries: entries
                });
            }
            this._bindGroups.length = this._bindGroupEntries.length;
        }
        return this._bindGroups;
    }
    constructor(device, cacheSampler){
        this._device = device;
        this._cacheSampler = cacheSampler;
        this.uniqueId = $deff709d421b2bed$export$a43eea98e97e5084._Counter++;
        this._bindGroupEntries = [];
        this.clear();
    }
    clear() {
        this._bindGroups = [];
    // Don't reset _bindGroupEntries if they have already been created, they are still ok even if we have to clear _bindGroups (the layout of the compute shader can't change once created)
    }
}
$deff709d421b2bed$export$a43eea98e97e5084._Counter = 0;

});

parcelRegister("02Yxr", function(module, exports) {

$parcel$export(module.exports, "WebGPUComputePipelineContext", () => $008f25a8673d9ae4$export$6f82235de310c998);
/** @internal */ class $008f25a8673d9ae4$export$6f82235de310c998 {
    get isAsync() {
        return false;
    }
    get isReady() {
        if (this.stage) return true;
        return false;
    }
    constructor(engine){
        this._name = "unnamed";
        this.engine = engine;
    }
    _getComputeShaderCode() {
        return this.sources?.compute;
    }
    dispose() {}
}

});


parcelRegister("gtfq1", function(module, exports) {

var $b9e4a = parcelRequire("b9e4a");

var $64Ihk = parcelRequire("64Ihk");

var $l46cr = parcelRequire("l46cr");
(0, $64Ihk.WebGPUEngine).prototype._createDepthStencilCubeTexture = function(size, options) {
    const internalTexture = new (0, $b9e4a.InternalTexture)(this, options.generateStencil ? (0, $b9e4a.InternalTextureSource).DepthStencil : (0, $b9e4a.InternalTextureSource).Depth);
    internalTexture.isCube = true;
    internalTexture.label = options.label;
    const internalOptions = {
        bilinearFiltering: false,
        comparisonFunction: 0,
        generateStencil: false,
        samples: 1,
        depthTextureFormat: options.generateStencil ? 13 : 14,
        ...options
    };
    internalTexture.format = internalOptions.depthTextureFormat;
    this._setupDepthStencilTexture(internalTexture, size, internalOptions.generateStencil, internalOptions.bilinearFiltering, internalOptions.comparisonFunction, internalOptions.samples);
    this._textureHelper.createGPUTextureForInternalTexture(internalTexture);
    // Now that the hardware texture is created, we can retrieve the GPU format and set the right type to the internal texture
    const gpuTextureWrapper = internalTexture._hardwareTexture;
    internalTexture.type = (0, $l46cr.WebGPUTextureHelper).GetTextureTypeFromFormat(gpuTextureWrapper.format);
    this._internalTexturesCache.push(internalTexture);
    return internalTexture;
};
(0, $64Ihk.WebGPUEngine).prototype.createCubeTexture = function(rootUrl, scene, files, noMipmap, onLoad = null, onError = null, format, forcedExtension = null, createPolynomials = false, lodScale = 0, lodOffset = 0, fallback = null, useSRGBBuffer = false) {
    return this.createCubeTextureBase(rootUrl, scene, files, !!noMipmap, onLoad, onError, format, forcedExtension, createPolynomials, lodScale, lodOffset, fallback, null, (texture, imgs)=>{
        const imageBitmaps = imgs; // we will always get an ImageBitmap array in WebGPU
        const width = imageBitmaps[0].width;
        const height = width;
        this._setCubeMapTextureParams(texture, !noMipmap);
        texture.format = format ?? -1;
        const gpuTextureWrapper = this._textureHelper.createGPUTextureForInternalTexture(texture, width, height);
        this._textureHelper.updateCubeTextures(imageBitmaps, gpuTextureWrapper.underlyingResource, width, height, gpuTextureWrapper.format, false, false, 0, 0);
        if (!noMipmap) this._generateMipmaps(texture, this._uploadEncoder);
        texture.isReady = true;
        texture.onLoadedObservable.notifyObservers(texture);
        texture.onLoadedObservable.clear();
        if (onLoad) onLoad();
    }, !!useSRGBBuffer);
};
(0, $64Ihk.WebGPUEngine).prototype._setCubeMapTextureParams = function(texture, loadMipmap, maxLevel) {
    texture.samplingMode = loadMipmap ? 3 : 2;
    texture._cachedWrapU = 0;
    texture._cachedWrapV = 0;
    if (maxLevel) texture._maxLodLevel = maxLevel;
};

});

parcelRegister("iTVoy", function(module, exports) {

var $64Ihk = parcelRequire("64Ihk");
(0, $64Ihk.WebGPUEngine).prototype._debugPushGroup = function(groupName, targetObject) {
    if (!this._options.enableGPUDebugMarkers) return;
    if (targetObject === 0 || targetObject === 1) this._renderEncoder.pushDebugGroup(groupName);
    else if (this._currentRenderPass) this._currentRenderPass.pushDebugGroup(groupName);
    else this._pendingDebugCommands.push([
        "push",
        groupName
    ]);
};
(0, $64Ihk.WebGPUEngine).prototype._debugPopGroup = function(targetObject) {
    if (!this._options.enableGPUDebugMarkers) return;
    if (targetObject === 0 || targetObject === 1) this._renderEncoder.popDebugGroup();
    else if (this._currentRenderPass) this._currentRenderPass.popDebugGroup();
    else this._pendingDebugCommands.push([
        "pop",
        null
    ]);
};
(0, $64Ihk.WebGPUEngine).prototype._debugInsertMarker = function(text, targetObject) {
    if (!this._options.enableGPUDebugMarkers) return;
    if (targetObject === 0 || targetObject === 1) this._renderEncoder.insertDebugMarker(text);
    else if (this._currentRenderPass) this._currentRenderPass.insertDebugMarker(text);
    else this._pendingDebugCommands.push([
        "insert",
        text
    ]);
};
(0, $64Ihk.WebGPUEngine).prototype._debugFlushPendingCommands = function() {
    for(let i = 0; i < this._pendingDebugCommands.length; ++i){
        const [name, param] = this._pendingDebugCommands[i];
        switch(name){
            case "push":
                this._debugPushGroup(param);
                break;
            case "pop":
                this._debugPopGroup();
                break;
            case "insert":
                this._debugInsertMarker(param);
                break;
        }
    }
    this._pendingDebugCommands.length = 0;
};

});

parcelRegister("i7fzv", function(module, exports) {

var $2h5JR = parcelRequire("2h5JR");

var $b9e4a = parcelRequire("b9e4a");

var $64Ihk = parcelRequire("64Ihk");
(0, $64Ihk.WebGPUEngine).prototype.createDynamicTexture = function(width, height, generateMipMaps, samplingMode) {
    const texture = new (0, $b9e4a.InternalTexture)(this, (0, $b9e4a.InternalTextureSource).Dynamic);
    texture.baseWidth = width;
    texture.baseHeight = height;
    if (generateMipMaps) {
        width = this.needPOTTextures ? (0, $2h5JR.ThinEngine).GetExponentOfTwo(width, this._caps.maxTextureSize) : width;
        height = this.needPOTTextures ? (0, $2h5JR.ThinEngine).GetExponentOfTwo(height, this._caps.maxTextureSize) : height;
    }
    texture.width = width;
    texture.height = height;
    texture.isReady = false;
    texture.generateMipMaps = generateMipMaps;
    texture.samplingMode = samplingMode;
    this.updateTextureSamplingMode(samplingMode, texture);
    this._internalTexturesCache.push(texture);
    if (width && height) this._textureHelper.createGPUTextureForInternalTexture(texture, width, height);
    return texture;
};
(0, $64Ihk.WebGPUEngine).prototype.updateDynamicTexture = function(texture, source, invertY, premulAlpha = false, format, forceBindTexture, allowGPUOptimization) {
    if (!texture) return;
    const width = source.width, height = source.height;
    let gpuTextureWrapper = texture._hardwareTexture;
    if (!texture._hardwareTexture?.underlyingResource) gpuTextureWrapper = this._textureHelper.createGPUTextureForInternalTexture(texture, width, height);
    this._textureHelper.updateTexture(source, texture, width, height, texture.depth, gpuTextureWrapper.format, 0, 0, invertY, premulAlpha, 0, 0, allowGPUOptimization);
    if (texture.generateMipMaps) this._generateMipmaps(texture);
    texture._dynamicTextureSource = source;
    texture._premulAlpha = premulAlpha;
    texture.invertY = invertY || false;
    texture.isReady = true;
};

});

parcelRegister("acB3O", function(module, exports) {

var $64Ihk = parcelRequire("64Ihk");

var $49SIJ = parcelRequire("49SIJ");

var $lUDWq = parcelRequire("lUDWq");
(0, $lUDWq.Effect).prototype.setExternalTexture = function(name, texture) {
    this._engine.setExternalTexture(name, texture);
};
(0, $64Ihk.WebGPUEngine).prototype.createExternalTexture = function(video) {
    const texture = new (0, $49SIJ.WebGPUExternalTexture)(video);
    return texture;
};
(0, $64Ihk.WebGPUEngine).prototype.setExternalTexture = function(name, texture) {
    if (!texture) {
        this._currentMaterialContext.setTexture(name, null);
        return;
    }
    this._setInternalTexture(name, texture);
};

});
parcelRegister("49SIJ", function(module, exports) {

$parcel$export(module.exports, "WebGPUExternalTexture", () => $30727305d5424083$export$b11e0e4aa03d12c0);

var $42iIf = parcelRequire("42iIf");
class $30727305d5424083$export$b11e0e4aa03d12c0 extends (0, $42iIf.ExternalTexture) {
    constructor(video){
        super(video);
    }
}

});


parcelRegister("jHBNz", function(module, exports) {

var $b9e4a = parcelRequire("b9e4a");

var $kVtWi = parcelRequire("kVtWi");

var $64Ihk = parcelRequire("64Ihk");
(0, $64Ihk.WebGPUEngine).prototype.unBindMultiColorAttachmentFramebuffer = function(rtWrapper, disableGenerateMipMaps = false, onBeforeUnbind) {
    if (onBeforeUnbind) onBeforeUnbind();
    const attachments = rtWrapper._attachments;
    const count = attachments.length;
    this._endCurrentRenderPass();
    for(let i = 0; i < count; i++){
        const texture = rtWrapper.textures[i];
        if (texture.generateMipMaps && !disableGenerateMipMaps && !texture.isCube) this._generateMipmaps(texture);
    }
    this._currentRenderTarget = null;
    this._mrtAttachments = [];
    this._cacheRenderPipeline.setMRT([]);
    this._cacheRenderPipeline.setMRTAttachments(this._mrtAttachments);
};
(0, $64Ihk.WebGPUEngine).prototype.createMultipleRenderTarget = function(size, options, initializeBuffers) {
    let generateMipMaps = false;
    let generateDepthBuffer = true;
    let generateStencilBuffer = false;
    let generateDepthTexture = false;
    let depthTextureFormat = 15;
    let textureCount = 1;
    const defaultType = 0;
    const defaultSamplingMode = 3;
    const defaultUseSRGBBuffer = false;
    const defaultFormat = 5;
    const defaultTarget = 3553;
    let types = [];
    let samplingModes = [];
    let useSRGBBuffers = [];
    let formats = [];
    let targets = [];
    let faceIndex = [];
    let layerIndex = [];
    let layers = [];
    let labels = [];
    const rtWrapper = this._createHardwareRenderTargetWrapper(true, false, size);
    if (options !== undefined) {
        generateMipMaps = options.generateMipMaps === undefined ? false : options.generateMipMaps;
        generateDepthBuffer = options.generateDepthBuffer === undefined ? true : options.generateDepthBuffer;
        generateStencilBuffer = options.generateStencilBuffer === undefined ? false : options.generateStencilBuffer;
        generateDepthTexture = options.generateDepthTexture === undefined ? false : options.generateDepthTexture;
        textureCount = options.textureCount || 1;
        depthTextureFormat = options.depthTextureFormat ?? 15;
        if (options.types) types = options.types;
        if (options.samplingModes) samplingModes = options.samplingModes;
        if (options.useSRGBBuffers) useSRGBBuffers = options.useSRGBBuffers;
        if (options.formats) formats = options.formats;
        if (options.targetTypes) targets = options.targetTypes;
        if (options.faceIndex) faceIndex = options.faceIndex;
        if (options.layerIndex) layerIndex = options.layerIndex;
        if (options.layerCounts) layers = options.layerCounts;
        labels = options.labels ?? labels;
    }
    rtWrapper.label = options?.label ?? "MultiRenderTargetWrapper";
    const width = size.width || size;
    const height = size.height || size;
    let depthStencilTexture = null;
    if (generateDepthBuffer || generateStencilBuffer || generateDepthTexture) {
        if (!generateDepthTexture) {
            // The caller doesn't want a depth texture, so we are free to use the depth texture format we want.
            // So, we will align with what the WebGL engine does
            if (generateDepthBuffer && generateStencilBuffer) depthTextureFormat = 13;
            else if (generateDepthBuffer) depthTextureFormat = 14;
            else depthTextureFormat = 19;
        }
        depthStencilTexture = rtWrapper.createDepthStencilTexture(0, false, generateStencilBuffer, 1, depthTextureFormat, "MultipleRenderTargetDepthStencil");
    }
    const textures = [];
    const attachments = [];
    const defaultAttachments = [];
    rtWrapper._generateDepthBuffer = generateDepthBuffer;
    rtWrapper._generateStencilBuffer = generateStencilBuffer;
    rtWrapper._attachments = attachments;
    rtWrapper._defaultAttachments = defaultAttachments;
    for(let i = 0; i < textureCount; i++){
        let samplingMode = samplingModes[i] || defaultSamplingMode;
        let type = types[i] || defaultType;
        const format = formats[i] || defaultFormat;
        const useSRGBBuffer = (useSRGBBuffers[i] || defaultUseSRGBBuffer) && this._caps.supportSRGBBuffers;
        const target = targets[i] || defaultTarget;
        const layerCount = layers[i] ?? 1;
        if (type === 1 && !this._caps.textureFloatLinearFiltering) // if floating point linear (FLOAT) then force to NEAREST_SAMPLINGMODE
        samplingMode = 1;
        else if (type === 2 && !this._caps.textureHalfFloatLinearFiltering) // if floating point linear (HALF_FLOAT) then force to NEAREST_SAMPLINGMODE
        samplingMode = 1;
        if (type === 1 && !this._caps.textureFloat) {
            type = 0;
            (0, $kVtWi.Logger).Warn("Float textures are not supported. Render target forced to TEXTURETYPE_UNSIGNED_BYTE type");
        }
        attachments.push(i + 1);
        defaultAttachments.push(initializeBuffers ? i + 1 : i === 0 ? 1 : 0);
        if (target === -1) continue;
        const texture = new (0, $b9e4a.InternalTexture)(this, (0, $b9e4a.InternalTextureSource).MultiRenderTarget);
        textures[i] = texture;
        switch(target){
            case 34067:
                texture.isCube = true;
                break;
            case 32879:
                texture.is3D = true;
                texture.baseDepth = texture.depth = layerCount;
                break;
            case 35866:
                texture.is2DArray = true;
                texture.baseDepth = texture.depth = layerCount;
                break;
        }
        texture.baseWidth = width;
        texture.baseHeight = height;
        texture.width = width;
        texture.height = height;
        texture.isReady = true;
        texture.samples = 1;
        texture.generateMipMaps = generateMipMaps;
        texture.samplingMode = samplingMode;
        texture.type = type;
        texture._cachedWrapU = 0;
        texture._cachedWrapV = 0;
        texture._useSRGBBuffer = useSRGBBuffer;
        texture.format = format;
        texture.label = labels[i];
        this._internalTexturesCache.push(texture);
        this._textureHelper.createGPUTextureForInternalTexture(texture);
    }
    if (depthStencilTexture) {
        depthStencilTexture.incrementReferences();
        textures[textureCount] = depthStencilTexture;
        this._internalTexturesCache.push(depthStencilTexture);
    }
    rtWrapper.setTextures(textures);
    rtWrapper.setLayerAndFaceIndices(layerIndex, faceIndex);
    return rtWrapper;
};
(0, $64Ihk.WebGPUEngine).prototype.updateMultipleRenderTargetTextureSampleCount = function(rtWrapper, samples) {
    if (!rtWrapper || !rtWrapper.textures || rtWrapper.textures[0].samples === samples) return samples;
    const count = rtWrapper.textures.length;
    if (count === 0) return 1;
    samples = Math.min(samples, this.getCaps().maxMSAASamples);
    for(let i = 0; i < count; ++i){
        const texture = rtWrapper.textures[i];
        const gpuTextureWrapper = texture._hardwareTexture;
        gpuTextureWrapper?.releaseMSAATexture();
    }
    // Note that rtWrapper.textures can't have null textures, lastTextureIsDepthTexture can't be true if rtWrapper._depthStencilTexture is null
    const lastTextureIsDepthTexture = rtWrapper._depthStencilTexture === rtWrapper.textures[count - 1];
    for(let i = 0; i < count; ++i){
        const texture = rtWrapper.textures[i];
        this._textureHelper.createMSAATexture(texture, samples, false, i === count - 1 && lastTextureIsDepthTexture ? 0 : i);
        texture.samples = samples;
    }
    // Note that the last texture of textures is the depth texture if the depth texture has been generated by the MRT class and so the MSAA texture
    // will be recreated for this texture by the loop above: in that case, there's no need to create the MSAA texture for rtWrapper._depthStencilTexture
    // because rtWrapper._depthStencilTexture is the same texture than the depth texture
    if (rtWrapper._depthStencilTexture && !lastTextureIsDepthTexture) {
        this._textureHelper.createMSAATexture(rtWrapper._depthStencilTexture, samples);
        rtWrapper._depthStencilTexture.samples = samples;
    }
    return samples;
};
(0, $64Ihk.WebGPUEngine).prototype.bindAttachments = function(attachments) {
    if (attachments.length === 0 || !this._currentRenderTarget) return;
    this._mrtAttachments = attachments;
    if (this._currentRenderPass) // the render pass has already been created, we need to call setMRTAttachments to update the state of the attachments
    this._cacheRenderPipeline.setMRTAttachments(attachments);
};
(0, $64Ihk.WebGPUEngine).prototype.buildTextureLayout = function(textureStatus) {
    const result = [];
    for(let i = 0; i < textureStatus.length; i++)if (textureStatus[i]) result.push(i + 1);
    else result.push(0);
    return result;
};
(0, $64Ihk.WebGPUEngine).prototype.restoreSingleAttachment = function() {
// not sure what to do, probably nothing... This function and restoreSingleAttachmentForRenderTarget are not called in Babylon.js so it's hard to know the use case
};
(0, $64Ihk.WebGPUEngine).prototype.restoreSingleAttachmentForRenderTarget = function() {
// not sure what to do, probably nothing... This function and restoreSingleAttachment are not called in Babylon.js so it's hard to know the use case
};

});

parcelRegister("8Hu74", function(module, exports) {

var $64Ihk = parcelRequire("64Ihk");

var $6HEDe = parcelRequire("6HEDe");
(0, $64Ihk.WebGPUEngine).prototype.getGPUFrameTimeCounter = function() {
    return this._timestampQuery.gpuFrameTimeCounter;
};
(0, $64Ihk.WebGPUEngine).prototype.captureGPUFrameTime = function(value) {
    this._timestampQuery.enable = value && !!this._caps.timerQuery;
};
(0, $64Ihk.WebGPUEngine).prototype.createQuery = function() {
    return this._occlusionQuery.createQuery();
};
(0, $64Ihk.WebGPUEngine).prototype.deleteQuery = function(query) {
    this._occlusionQuery.deleteQuery(query);
    return this;
};
(0, $64Ihk.WebGPUEngine).prototype.isQueryResultAvailable = function(query) {
    return this._occlusionQuery.isQueryResultAvailable(query);
};
(0, $64Ihk.WebGPUEngine).prototype.getQueryResult = function(query) {
    return this._occlusionQuery.getQueryResult(query);
};
(0, $64Ihk.WebGPUEngine).prototype.beginOcclusionQuery = function(algorithmType, query) {
    if (this.compatibilityMode) {
        if (this._occlusionQuery.canBeginQuery(query)) {
            this._currentRenderPass?.beginOcclusionQuery(query);
            return true;
        }
    } else {
        this._bundleList.addItem(new (0, $6HEDe.WebGPURenderItemBeginOcclusionQuery)(query));
        return true;
    }
    return false;
};
(0, $64Ihk.WebGPUEngine).prototype.endOcclusionQuery = function() {
    if (this.compatibilityMode) this._currentRenderPass?.endOcclusionQuery();
    else this._bundleList.addItem(new (0, $6HEDe.WebGPURenderItemEndOcclusionQuery)());
    return this;
};

});

parcelRegister("cnp1v", function(module, exports) {

var $b9e4a = parcelRequire("b9e4a");

var $64Ihk = parcelRequire("64Ihk");

var $kVtWi = parcelRequire("kVtWi");
(0, $64Ihk.WebGPUEngine).prototype.createRawTexture = function(data, width, height, format, generateMipMaps, invertY, samplingMode, compression = null, type = 0, creationFlags = 0, useSRGBBuffer = false) {
    const texture = new (0, $b9e4a.InternalTexture)(this, (0, $b9e4a.InternalTextureSource).Raw);
    texture.baseWidth = width;
    texture.baseHeight = height;
    texture.width = width;
    texture.height = height;
    texture.format = format;
    texture.generateMipMaps = generateMipMaps;
    texture.samplingMode = samplingMode;
    texture.invertY = invertY;
    texture._compression = compression;
    texture.type = type;
    texture._creationFlags = creationFlags;
    texture._useSRGBBuffer = useSRGBBuffer;
    if (!this._doNotHandleContextLost) texture._bufferView = data;
    this._textureHelper.createGPUTextureForInternalTexture(texture, width, height, undefined, creationFlags);
    this.updateRawTexture(texture, data, format, invertY, compression, type, useSRGBBuffer);
    this._internalTexturesCache.push(texture);
    return texture;
};
(0, $64Ihk.WebGPUEngine).prototype.updateRawTexture = function(texture, bufferView, format, invertY, compression = null, type = 0, useSRGBBuffer = false) {
    if (!texture) return;
    if (!this._doNotHandleContextLost) {
        texture._bufferView = bufferView;
        texture.invertY = invertY;
        texture._compression = compression;
        texture._useSRGBBuffer = useSRGBBuffer;
    }
    if (bufferView) {
        const gpuTextureWrapper = texture._hardwareTexture;
        const needConversion = format === 4;
        if (needConversion) bufferView = $902b0b211f4a550b$var$_convertRGBtoRGBATextureData(bufferView, texture.width, texture.height, type);
        const data = new Uint8Array(bufferView.buffer, bufferView.byteOffset, bufferView.byteLength);
        this._textureHelper.updateTexture(data, texture, texture.width, texture.height, texture.depth, gpuTextureWrapper.format, 0, 0, invertY, false, 0, 0);
        if (texture.generateMipMaps) this._generateMipmaps(texture, this._uploadEncoder);
    }
    texture.isReady = true;
};
(0, $64Ihk.WebGPUEngine).prototype.createRawCubeTexture = function(data, size, format, type, generateMipMaps, invertY, samplingMode, compression = null) {
    const texture = new (0, $b9e4a.InternalTexture)(this, (0, $b9e4a.InternalTextureSource).CubeRaw);
    if (type === 1 && !this._caps.textureFloatLinearFiltering) {
        generateMipMaps = false;
        samplingMode = 1;
        (0, $kVtWi.Logger).Warn("Float texture filtering is not supported. Mipmap generation and sampling mode are forced to false and TEXTURE_NEAREST_SAMPLINGMODE, respectively.");
    } else if (type === 2 && !this._caps.textureHalfFloatLinearFiltering) {
        generateMipMaps = false;
        samplingMode = 1;
        (0, $kVtWi.Logger).Warn("Half float texture filtering is not supported. Mipmap generation and sampling mode are forced to false and TEXTURE_NEAREST_SAMPLINGMODE, respectively.");
    } else if (type === 1 && !this._caps.textureFloatRender) {
        generateMipMaps = false;
        (0, $kVtWi.Logger).Warn("Render to float textures is not supported. Mipmap generation forced to false.");
    } else if (type === 2 && !this._caps.colorBufferFloat) {
        generateMipMaps = false;
        (0, $kVtWi.Logger).Warn("Render to half float textures is not supported. Mipmap generation forced to false.");
    }
    texture.isCube = true;
    texture._originalFormat = format;
    texture.format = format === 4 ? 5 : format;
    texture.type = type;
    texture.generateMipMaps = generateMipMaps;
    texture.width = size;
    texture.height = size;
    texture.samplingMode = samplingMode;
    if (!this._doNotHandleContextLost) texture._bufferViewArray = data;
    texture.invertY = invertY;
    texture._compression = compression;
    texture._cachedWrapU = 0;
    texture._cachedWrapV = 0;
    this._textureHelper.createGPUTextureForInternalTexture(texture);
    if (data) this.updateRawCubeTexture(texture, data, format, type, invertY, compression);
    texture.isReady = true;
    return texture;
};
(0, $64Ihk.WebGPUEngine).prototype.updateRawCubeTexture = function(texture, bufferView, format, type, invertY, compression = null) {
    texture._bufferViewArray = bufferView;
    texture.invertY = invertY;
    texture._compression = compression;
    const gpuTextureWrapper = texture._hardwareTexture;
    const needConversion = format === 4;
    const data = [];
    for(let i = 0; i < bufferView.length; ++i){
        let faceData = bufferView[i];
        if (needConversion) faceData = $902b0b211f4a550b$var$_convertRGBtoRGBATextureData(bufferView[i], texture.width, texture.height, type);
        data.push(new Uint8Array(faceData.buffer, faceData.byteOffset, faceData.byteLength));
    }
    this._textureHelper.updateCubeTextures(data, gpuTextureWrapper.underlyingResource, texture.width, texture.height, gpuTextureWrapper.format, invertY, false, 0, 0);
    if (texture.generateMipMaps) this._generateMipmaps(texture, this._uploadEncoder);
    texture.isReady = true;
};
(0, $64Ihk.WebGPUEngine).prototype.createRawCubeTextureFromUrl = function(url, scene, size, format, type, noMipmap, callback, mipmapGenerator, onLoad = null, onError = null, samplingMode = 3, invertY = false) {
    const texture = this.createRawCubeTexture(null, size, format, type, !noMipmap, invertY, samplingMode, null);
    scene?.addPendingData(texture);
    texture.url = url;
    this._internalTexturesCache.push(texture);
    const onerror = (request, exception)=>{
        scene?.removePendingData(texture);
        if (onError && request) onError(request.status + " " + request.statusText, exception);
    };
    const internalCallback = (data)=>{
        const width = texture.width;
        const faceDataArrays = callback(data);
        if (!faceDataArrays) return;
        const faces = [
            0,
            2,
            4,
            1,
            3,
            5
        ];
        if (mipmapGenerator) {
            const needConversion = format === 4;
            const mipData = mipmapGenerator(faceDataArrays);
            const gpuTextureWrapper = texture._hardwareTexture;
            const faces = [
                0,
                1,
                2,
                3,
                4,
                5
            ];
            for(let level = 0; level < mipData.length; level++){
                const mipSize = width >> level;
                const allFaces = [];
                for(let faceIndex = 0; faceIndex < 6; faceIndex++){
                    let mipFaceData = mipData[level][faces[faceIndex]];
                    if (needConversion) mipFaceData = $902b0b211f4a550b$var$_convertRGBtoRGBATextureData(mipFaceData, mipSize, mipSize, type);
                    allFaces.push(new Uint8Array(mipFaceData.buffer, mipFaceData.byteOffset, mipFaceData.byteLength));
                }
                this._textureHelper.updateCubeTextures(allFaces, gpuTextureWrapper.underlyingResource, mipSize, mipSize, gpuTextureWrapper.format, invertY, false, 0, 0);
            }
        } else {
            const allFaces = [];
            for(let faceIndex = 0; faceIndex < 6; faceIndex++)allFaces.push(faceDataArrays[faces[faceIndex]]);
            this.updateRawCubeTexture(texture, allFaces, format, type, invertY);
        }
        texture.isReady = true;
        scene?.removePendingData(texture);
        if (onLoad) onLoad();
    };
    this._loadFile(url, (data)=>{
        internalCallback(data);
    }, undefined, scene?.offlineProvider, true, onerror);
    return texture;
};
(0, $64Ihk.WebGPUEngine).prototype.createRawTexture3D = function(data, width, height, depth, format, generateMipMaps, invertY, samplingMode, compression = null, textureType = 0, creationFlags = 0) {
    const source = (0, $b9e4a.InternalTextureSource).Raw3D;
    const texture = new (0, $b9e4a.InternalTexture)(this, source);
    texture.baseWidth = width;
    texture.baseHeight = height;
    texture.baseDepth = depth;
    texture.width = width;
    texture.height = height;
    texture.depth = depth;
    texture.format = format;
    texture.type = textureType;
    texture.generateMipMaps = generateMipMaps;
    texture.samplingMode = samplingMode;
    texture.is3D = true;
    texture._creationFlags = creationFlags;
    if (!this._doNotHandleContextLost) texture._bufferView = data;
    this._textureHelper.createGPUTextureForInternalTexture(texture, width, height, undefined, creationFlags);
    this.updateRawTexture3D(texture, data, format, invertY, compression, textureType);
    this._internalTexturesCache.push(texture);
    return texture;
};
(0, $64Ihk.WebGPUEngine).prototype.updateRawTexture3D = function(texture, bufferView, format, invertY, compression = null, textureType = 0) {
    if (!this._doNotHandleContextLost) {
        texture._bufferView = bufferView;
        texture.format = format;
        texture.invertY = invertY;
        texture._compression = compression;
    }
    if (bufferView) {
        const gpuTextureWrapper = texture._hardwareTexture;
        const needConversion = format === 4;
        if (needConversion) bufferView = $902b0b211f4a550b$var$_convertRGBtoRGBATextureData(bufferView, texture.width, texture.height, textureType);
        const data = new Uint8Array(bufferView.buffer, bufferView.byteOffset, bufferView.byteLength);
        this._textureHelper.updateTexture(data, texture, texture.width, texture.height, texture.depth, gpuTextureWrapper.format, 0, 0, invertY, false, 0, 0);
        if (texture.generateMipMaps) this._generateMipmaps(texture, this._uploadEncoder);
    }
    texture.isReady = true;
};
(0, $64Ihk.WebGPUEngine).prototype.createRawTexture2DArray = function(data, width, height, depth, format, generateMipMaps, invertY, samplingMode, compression = null, textureType = 0, creationFlags = 0) {
    const source = (0, $b9e4a.InternalTextureSource).Raw2DArray;
    const texture = new (0, $b9e4a.InternalTexture)(this, source);
    texture.baseWidth = width;
    texture.baseHeight = height;
    texture.baseDepth = depth;
    texture.width = width;
    texture.height = height;
    texture.depth = depth;
    texture.format = format;
    texture.type = textureType;
    texture.generateMipMaps = generateMipMaps;
    texture.samplingMode = samplingMode;
    texture.is2DArray = true;
    texture._creationFlags = creationFlags;
    if (!this._doNotHandleContextLost) texture._bufferView = data;
    this._textureHelper.createGPUTextureForInternalTexture(texture, width, height, depth, creationFlags);
    this.updateRawTexture2DArray(texture, data, format, invertY, compression, textureType);
    this._internalTexturesCache.push(texture);
    return texture;
};
(0, $64Ihk.WebGPUEngine).prototype.updateRawTexture2DArray = function(texture, bufferView, format, invertY, compression = null, textureType = 0) {
    if (!this._doNotHandleContextLost) {
        texture._bufferView = bufferView;
        texture.format = format;
        texture.invertY = invertY;
        texture._compression = compression;
    }
    if (bufferView) {
        const gpuTextureWrapper = texture._hardwareTexture;
        const needConversion = format === 4;
        if (needConversion) bufferView = $902b0b211f4a550b$var$_convertRGBtoRGBATextureData(bufferView, texture.width, texture.height, textureType);
        const data = new Uint8Array(bufferView.buffer, bufferView.byteOffset, bufferView.byteLength);
        this._textureHelper.updateTexture(data, texture, texture.width, texture.height, texture.depth, gpuTextureWrapper.format, 0, 0, invertY, false, 0, 0);
        if (texture.generateMipMaps) this._generateMipmaps(texture, this._uploadEncoder);
    }
    texture.isReady = true;
};
/**
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/naming-convention
function $902b0b211f4a550b$var$_convertRGBtoRGBATextureData(rgbData, width, height, textureType) {
    // Create new RGBA data container.
    let rgbaData;
    let val1 = 1;
    if (textureType === 1) rgbaData = new Float32Array(width * height * 4);
    else if (textureType === 2) {
        rgbaData = new Uint16Array(width * height * 4);
        val1 = 15360; // 15360 is the encoding of 1 in half float
    } else if (textureType === 7) rgbaData = new Uint32Array(width * height * 4);
    else rgbaData = new Uint8Array(width * height * 4);
    // Convert each pixel.
    for(let x = 0; x < width; x++)for(let y = 0; y < height; y++){
        const index = (y * width + x) * 3;
        const newIndex = (y * width + x) * 4;
        // Map Old Value to new value.
        rgbaData[newIndex + 0] = rgbData[index + 0];
        rgbaData[newIndex + 1] = rgbData[index + 1];
        rgbaData[newIndex + 2] = rgbData[index + 2];
        // Add fully opaque alpha channel.
        rgbaData[newIndex + 3] = val1;
    }
    return rgbaData;
}

});

parcelRegister("f7RML", function(module, exports) {

var $64Ihk = parcelRequire("64Ihk");
(0, $64Ihk.WebGPUEngine).prototype._readTexturePixels = function(texture, width, height, faceIndex = -1, level = 0, buffer = null, flushRenderer = true, noDataConversion = false, x = 0, y = 0) {
    const gpuTextureWrapper = texture._hardwareTexture;
    if (flushRenderer) this.flushFramebuffer();
    return this._textureHelper.readPixels(gpuTextureWrapper.underlyingResource, x, y, width, height, gpuTextureWrapper.format, faceIndex, level, buffer, noDataConversion);
};
(0, $64Ihk.WebGPUEngine).prototype._readTexturePixelsSync = function() {
    // eslint-disable-next-line no-throw-literal
    throw "_readTexturePixelsSync is unsupported in WebGPU!";
};

});

parcelRegister("lwP3W", function(module, exports) {

var $b9e4a = parcelRequire("b9e4a");

var $64Ihk = parcelRequire("64Ihk");

var $cvwvi = parcelRequire("cvwvi");

var $l46cr = parcelRequire("l46cr");
(0, $64Ihk.WebGPUEngine).prototype._createHardwareRenderTargetWrapper = function(isMulti, isCube, size) {
    const rtWrapper = new (0, $cvwvi.WebGPURenderTargetWrapper)(isMulti, isCube, size, this);
    this._renderTargetWrapperCache.push(rtWrapper);
    return rtWrapper;
};
(0, $64Ihk.WebGPUEngine).prototype.createRenderTargetTexture = function(size, options) {
    const rtWrapper = this._createHardwareRenderTargetWrapper(false, false, size);
    const fullOptions = {};
    if (options !== undefined && typeof options === "object") {
        fullOptions.generateMipMaps = options.generateMipMaps;
        fullOptions.generateDepthBuffer = options.generateDepthBuffer === undefined ? true : options.generateDepthBuffer;
        fullOptions.generateStencilBuffer = fullOptions.generateDepthBuffer && options.generateStencilBuffer;
        fullOptions.samplingMode = options.samplingMode === undefined ? 3 : options.samplingMode;
        fullOptions.creationFlags = options.creationFlags ?? 0;
        fullOptions.noColorAttachment = !!options.noColorAttachment;
        fullOptions.samples = options.samples;
        fullOptions.label = options.label;
    } else {
        fullOptions.generateMipMaps = options;
        fullOptions.generateDepthBuffer = true;
        fullOptions.generateStencilBuffer = false;
        fullOptions.samplingMode = 3;
        fullOptions.creationFlags = 0;
        fullOptions.noColorAttachment = false;
    }
    const texture = fullOptions.noColorAttachment ? null : this._createInternalTexture(size, options, true, (0, $b9e4a.InternalTextureSource).RenderTarget);
    rtWrapper.label = fullOptions.label ?? "RenderTargetWrapper";
    rtWrapper._samples = fullOptions.samples ?? 1;
    rtWrapper._generateDepthBuffer = fullOptions.generateDepthBuffer;
    rtWrapper._generateStencilBuffer = fullOptions.generateStencilBuffer ? true : false;
    rtWrapper.setTextures(texture);
    if (rtWrapper._generateDepthBuffer || rtWrapper._generateStencilBuffer) rtWrapper.createDepthStencilTexture(0, false, rtWrapper._generateStencilBuffer, rtWrapper.samples, fullOptions.generateStencilBuffer ? 13 : 14, fullOptions.label ? fullOptions.label + "-DepthStencil" : undefined);
    if (texture) {
        if (options !== undefined && typeof options === "object" && options.createMipMaps && !fullOptions.generateMipMaps) texture.generateMipMaps = true;
        this._textureHelper.createGPUTextureForInternalTexture(texture, undefined, undefined, undefined, fullOptions.creationFlags);
        if (options !== undefined && typeof options === "object" && options.createMipMaps && !fullOptions.generateMipMaps) texture.generateMipMaps = false;
    }
    return rtWrapper;
};
(0, $64Ihk.WebGPUEngine).prototype._createDepthStencilTexture = function(size, options) {
    const internalTexture = new (0, $b9e4a.InternalTexture)(this, options.generateStencil ? (0, $b9e4a.InternalTextureSource).DepthStencil : (0, $b9e4a.InternalTextureSource).Depth);
    internalTexture.label = options.label;
    const internalOptions = {
        bilinearFiltering: false,
        comparisonFunction: 0,
        generateStencil: false,
        samples: 1,
        depthTextureFormat: options.generateStencil ? 13 : 14,
        ...options
    };
    internalTexture.format = internalOptions.depthTextureFormat;
    this._setupDepthStencilTexture(internalTexture, size, internalOptions.generateStencil, internalOptions.bilinearFiltering, internalOptions.comparisonFunction, internalOptions.samples);
    this._textureHelper.createGPUTextureForInternalTexture(internalTexture);
    // Now that the hardware texture is created, we can retrieve the GPU format and set the right type to the internal texture
    const gpuTextureWrapper = internalTexture._hardwareTexture;
    internalTexture.type = (0, $l46cr.WebGPUTextureHelper).GetTextureTypeFromFormat(gpuTextureWrapper.format);
    this._internalTexturesCache.push(internalTexture);
    return internalTexture;
};
(0, $64Ihk.WebGPUEngine).prototype._setupDepthStencilTexture = function(internalTexture, size, generateStencil, bilinearFiltering, comparisonFunction, samples = 1) {
    const width = size.width || size;
    const height = size.height || size;
    const layers = size.layers || 0;
    internalTexture.baseWidth = width;
    internalTexture.baseHeight = height;
    internalTexture.width = width;
    internalTexture.height = height;
    internalTexture.is2DArray = layers > 0;
    internalTexture.depth = layers;
    internalTexture.isReady = true;
    internalTexture.samples = samples;
    internalTexture.generateMipMaps = false;
    internalTexture.samplingMode = bilinearFiltering ? 2 : 1;
    internalTexture.type = 1;
    internalTexture._comparisonFunction = comparisonFunction;
    internalTexture._cachedWrapU = 0;
    internalTexture._cachedWrapV = 0;
};
(0, $64Ihk.WebGPUEngine).prototype.updateRenderTargetTextureSampleCount = function(rtWrapper, samples) {
    if (!rtWrapper || !rtWrapper.texture || rtWrapper.samples === samples) return samples;
    samples = Math.min(samples, this.getCaps().maxMSAASamples);
    this._textureHelper.createMSAATexture(rtWrapper.texture, samples);
    if (rtWrapper._depthStencilTexture) {
        this._textureHelper.createMSAATexture(rtWrapper._depthStencilTexture, samples);
        rtWrapper._depthStencilTexture.samples = samples;
    }
    rtWrapper._samples = samples;
    rtWrapper.texture.samples = samples;
    return samples;
};

});
parcelRegister("cvwvi", function(module, exports) {

$parcel$export(module.exports, "WebGPURenderTargetWrapper", () => $91b197e18afd0d01$export$d2f1bb161dd076e1);

var $3QmEA = parcelRequire("3QmEA");

var $8tOka = parcelRequire("8tOka");
class $91b197e18afd0d01$export$d2f1bb161dd076e1 extends (0, $3QmEA.RenderTargetWrapper) {
    /**
     * Initializes the render target wrapper
     * @param isMulti true if the wrapper is a multi render target
     * @param isCube true if the wrapper should render to a cube texture
     * @param size size of the render target (width/height/layers)
     * @param engine engine used to create the render target
     * @param label defines the label to use for the wrapper (for debugging purpose only)
     */ constructor(isMulti, isCube, size, engine, label){
        super(isMulti, isCube, size, engine, label);
        if (engine.enableGPUTimingMeasurements) this.gpuTimeInFrame = new (0, $8tOka.WebGPUPerfCounter)();
    }
}

});


parcelRegister("lvGT2", function(module, exports) {

var $b9e4a = parcelRequire("b9e4a");

var $64Ihk = parcelRequire("64Ihk");
(0, $64Ihk.WebGPUEngine).prototype.createRenderTargetCubeTexture = function(size, options) {
    const rtWrapper = this._createHardwareRenderTargetWrapper(false, true, size);
    const fullOptions = {
        generateMipMaps: true,
        generateDepthBuffer: true,
        generateStencilBuffer: false,
        type: 0,
        samplingMode: 3,
        format: 5,
        samples: 1,
        ...options
    };
    fullOptions.generateStencilBuffer = fullOptions.generateDepthBuffer && fullOptions.generateStencilBuffer;
    rtWrapper.label = fullOptions.label ?? "RenderTargetWrapper";
    rtWrapper._generateDepthBuffer = fullOptions.generateDepthBuffer;
    rtWrapper._generateStencilBuffer = fullOptions.generateStencilBuffer;
    const texture = new (0, $b9e4a.InternalTexture)(this, (0, $b9e4a.InternalTextureSource).RenderTarget);
    texture.width = size;
    texture.height = size;
    texture.depth = 0;
    texture.isReady = true;
    texture.isCube = true;
    texture.samples = fullOptions.samples;
    texture.generateMipMaps = fullOptions.generateMipMaps;
    texture.samplingMode = fullOptions.samplingMode;
    texture.type = fullOptions.type;
    texture.format = fullOptions.format;
    this._internalTexturesCache.push(texture);
    rtWrapper.setTextures(texture);
    if (rtWrapper._generateDepthBuffer || rtWrapper._generateStencilBuffer) rtWrapper.createDepthStencilTexture(0, fullOptions.samplingMode === undefined || fullOptions.samplingMode === 2 || fullOptions.samplingMode === 2 || fullOptions.samplingMode === 3 || fullOptions.samplingMode === 3 || fullOptions.samplingMode === 5 || fullOptions.samplingMode === 6 || fullOptions.samplingMode === 7 || fullOptions.samplingMode === 11, rtWrapper._generateStencilBuffer, rtWrapper.samples);
    if (options && options.createMipMaps && !fullOptions.generateMipMaps) texture.generateMipMaps = true;
    this._textureHelper.createGPUTextureForInternalTexture(texture);
    if (options && options.createMipMaps && !fullOptions.generateMipMaps) texture.generateMipMaps = false;
    return rtWrapper;
};

});

parcelRegister("hBD6p", function(module, exports) {

var $64Ihk = parcelRequire("64Ihk");

var $lUDWq = parcelRequire("lUDWq");
(0, $lUDWq.Effect).prototype.setTextureSampler = function(name, sampler) {
    this._engine.setTextureSampler(name, sampler);
};
(0, $64Ihk.WebGPUEngine).prototype.setTextureSampler = function(name, sampler) {
    this._currentMaterialContext?.setSampler(name, sampler);
};

});

parcelRegister("c9O9c", function(module, exports) {

var $64Ihk = parcelRequire("64Ihk");

var $hR6HG = parcelRequire("hR6HG");

var $lUDWq = parcelRequire("lUDWq");
(0, $lUDWq.Effect).prototype.setStorageBuffer = function(name, buffer) {
    this._engine.setStorageBuffer(name, buffer);
};
(0, $64Ihk.WebGPUEngine).prototype.createStorageBuffer = function(data, creationFlags, label) {
    return this._createBuffer(data, creationFlags | 32, label);
};
(0, $64Ihk.WebGPUEngine).prototype.updateStorageBuffer = function(buffer, data, byteOffset, byteLength) {
    const dataBuffer = buffer;
    if (byteOffset === undefined) byteOffset = 0;
    let view;
    if (byteLength === undefined) {
        if (data instanceof Array) view = new Float32Array(data);
        else if (data instanceof ArrayBuffer) view = new Uint8Array(data);
        else view = data;
        byteLength = view.byteLength;
    } else {
        if (data instanceof Array) view = new Float32Array(data);
        else if (data instanceof ArrayBuffer) view = new Uint8Array(data);
        else view = data;
    }
    this._bufferManager.setSubData(dataBuffer, byteOffset, view, 0, byteLength);
};
(0, $64Ihk.WebGPUEngine).prototype.readFromStorageBuffer = function(storageBuffer, offset, size, buffer, noDelay) {
    size = size || storageBuffer.capacity;
    const gpuBuffer = this._bufferManager.createRawBuffer(size, $hR6HG.BufferUsage.MapRead | $hR6HG.BufferUsage.CopyDst, undefined, "TempReadFromStorageBuffer");
    this._renderEncoder.copyBufferToBuffer(storageBuffer.underlyingResource, offset ?? 0, gpuBuffer, 0, size);
    return new Promise((resolve, reject)=>{
        const readFromBuffer = ()=>{
            gpuBuffer.mapAsync($hR6HG.MapMode.Read, 0, size).then(()=>{
                const copyArrayBuffer = gpuBuffer.getMappedRange(0, size);
                let data = buffer;
                if (data === undefined) {
                    data = new Uint8Array(size);
                    data.set(new Uint8Array(copyArrayBuffer));
                } else {
                    const ctor = data.constructor; // we want to create result data with the same type as buffer (Uint8Array, Float32Array, ...)
                    data = new ctor(data.buffer);
                    data.set(new ctor(copyArrayBuffer));
                }
                gpuBuffer.unmap();
                this._bufferManager.releaseBuffer(gpuBuffer);
                resolve(data);
            }, (reason)=>{
                if (this.isDisposed) resolve(new Uint8Array());
                else reject(reason);
            });
        };
        if (noDelay) {
            this.flushFramebuffer();
            readFromBuffer();
        } else // we are using onEndFrameObservable because we need to map the gpuBuffer AFTER the command buffers
        // have been submitted, else we get the error: "Buffer used in a submit while mapped"
        this.onEndFrameObservable.addOnce(()=>{
            readFromBuffer();
        });
    });
};
(0, $64Ihk.WebGPUEngine).prototype.setStorageBuffer = function(name, buffer) {
    this._currentDrawContext?.setBuffer(name, buffer?.getBuffer() ?? null);
};

});

parcelRegister("g1ImJ", function(module, exports) {

var $64Ihk = parcelRequire("64Ihk");
function $baaf27726abc173d$var$IsExternalTexture(texture) {
    return texture && texture.underlyingResource !== undefined ? true : false;
}
(0, $64Ihk.WebGPUEngine).prototype.updateVideoTexture = function(texture, video, invertY) {
    if (!texture || texture._isDisabled) return;
    if (this._videoTextureSupported === undefined) this._videoTextureSupported = true;
    let gpuTextureWrapper = texture._hardwareTexture;
    if (!texture._hardwareTexture?.underlyingResource) gpuTextureWrapper = this._textureHelper.createGPUTextureForInternalTexture(texture);
    if ($baaf27726abc173d$var$IsExternalTexture(video)) {
        this._textureHelper.copyVideoToTexture(video, texture, gpuTextureWrapper.format, !invertY);
        if (texture.generateMipMaps) this._generateMipmaps(texture);
        texture.isReady = true;
    } else if (video) this.createImageBitmap(video).then((bitmap)=>{
        this._textureHelper.updateTexture(bitmap, texture, texture.width, texture.height, texture.depth, gpuTextureWrapper.format, 0, 0, !invertY, false, 0, 0);
        if (texture.generateMipMaps) this._generateMipmaps(texture);
        texture.isReady = true;
    }).catch(()=>{
        // Sometimes createImageBitmap(video) fails with "Failed to execute 'createImageBitmap' on 'Window': The provided element's player has no current data."
        // Just keep going on
        texture.isReady = true;
    });
};

});


parcelRegister("g6G8S", function(module, exports) {

});

parcelRegister("kh9jw", function(module, exports) {

});

parcelRegister("6WXVG", function(module, exports) {

});

parcelRegister("gcPFY", function(module, exports) {

$parcel$export(module.exports, "EngineFactory", () => $bcc5da1eb73af33e$export$7fcd34971b91356c);

var $5YkyR = parcelRequire("5YkyR");

var $3io4i = parcelRequire("3io4i");

var $64Ihk = parcelRequire("64Ihk");
class $bcc5da1eb73af33e$export$7fcd34971b91356c {
    /**
     * Creates an engine based on the capabilities of the underlying hardware
     * @param canvas Defines the canvas to use to display the result
     * @param options Defines the options passed to the engine to create the context dependencies
     * @returns a promise that resolves with the created engine
     */ static async CreateAsync(canvas, options) {
        const supported = await (0, $64Ihk.WebGPUEngine).IsSupportedAsync;
        if (supported) return (0, $64Ihk.WebGPUEngine).CreateAsync(canvas, options);
        if ((0, $5YkyR.Engine).IsSupported) return new (0, $5YkyR.Engine)(canvas, undefined, options);
        return new (0, $3io4i.NullEngine)(options);
    }
}

});

parcelRegister("hygeI", function(module, exports) {

});

parcelRegister("iDct0", function(module, exports) {

});

parcelRegister("f3wFg", function(module, exports) {

});


parcelRegister("ebp3Z", function(module, exports) {

var $bcFoB = parcelRequire("bcFoB");

var $cfkw4 = parcelRequire("cfkw4");

var $951mg = parcelRequire("951mg");

var $jzXHO = parcelRequire("jzXHO");
$parcel$exportWildcard(module.exports, $bcFoB);
$parcel$exportWildcard(module.exports, $cfkw4);
$parcel$exportWildcard(module.exports, $951mg);
$parcel$exportWildcard(module.exports, $jzXHO);

});
parcelRegister("951mg", function(module, exports) {

$parcel$export(module.exports, "ClipboardEventTypes", () => $69c5a2609ea6c722$export$1b8ff22bd0e43412);
$parcel$export(module.exports, "ClipboardInfo", () => $69c5a2609ea6c722$export$738268be25b46e31);
/**
 * Gather the list of clipboard event types as constants.
 */ class $69c5a2609ea6c722$export$1b8ff22bd0e43412 {
}
/**
 * The clipboard event is fired when a copy command is active (pressed).
 */ $69c5a2609ea6c722$export$1b8ff22bd0e43412.COPY = 0x01; //
/**
 *  The clipboard event is fired when a cut command is active (pressed).
 */ $69c5a2609ea6c722$export$1b8ff22bd0e43412.CUT = 0x02;
/**
 * The clipboard event is fired when a paste command is active (pressed).
 */ $69c5a2609ea6c722$export$1b8ff22bd0e43412.PASTE = 0x03;
class $69c5a2609ea6c722$export$738268be25b46e31 {
    /**
     *Creates an instance of ClipboardInfo.
     * @param type Defines the type of event (BABYLON.ClipboardEventTypes)
     * @param event Defines the related dom event
     */ constructor(/**
     * Defines the type of event (BABYLON.ClipboardEventTypes)
     */ type, /**
     * Defines the related dom event
     */ event){
        this.type = type;
        this.event = event;
    }
    /**
     *  Get the clipboard event's type from the keycode.
     * @param keyCode Defines the keyCode for the current keyboard event.
     * @returns {number}
     */ static GetTypeFromCharacter(keyCode) {
        const charCode = keyCode;
        //TODO: add codes for extended ASCII
        switch(charCode){
            case 67:
                return $69c5a2609ea6c722$export$1b8ff22bd0e43412.COPY;
            case 86:
                return $69c5a2609ea6c722$export$1b8ff22bd0e43412.PASTE;
            case 88:
                return $69c5a2609ea6c722$export$1b8ff22bd0e43412.CUT;
            default:
                return -1;
        }
    }
}

});


parcelRegister("eIwy1", function(module, exports) {

var $6gZ9Y = parcelRequire("6gZ9Y");

var $eIug0 = parcelRequire("eIug0");

var $6VDMQ = parcelRequire("6VDMQ");

var $3OBdT = parcelRequire("3OBdT");

var $hndSS = parcelRequire("hndSS");
$parcel$exportWildcard(module.exports, $6gZ9Y);
$parcel$exportWildcard(module.exports, $eIug0);
$parcel$exportWildcard(module.exports, $6VDMQ);
$parcel$exportWildcard(module.exports, $3OBdT);
$parcel$exportWildcard(module.exports, $hndSS);

});

parcelRegister("210RJ", function(module, exports) {

var $iCzFv = parcelRequire("iCzFv");

var $27UkL = parcelRequire("27UkL");

var $27QWx = parcelRequire("27QWx");

var $5ETkU = parcelRequire("5ETkU");

var $6e5Zp = parcelRequire("6e5Zp");

var $8Fr9l = parcelRequire("8Fr9l");

var $dKyhl = parcelRequire("dKyhl");

var $i5hok = parcelRequire("i5hok");

var $77AGr = parcelRequire("77AGr");

var $9XGHY = parcelRequire("9XGHY");

var $6m5Bu = parcelRequire("6m5Bu");

var $9fO5H = parcelRequire("9fO5H");
$parcel$exportWildcard(module.exports, $iCzFv);
$parcel$exportWildcard(module.exports, $27UkL);
$parcel$exportWildcard(module.exports, $27QWx);
$parcel$exportWildcard(module.exports, $5ETkU);
$parcel$exportWildcard(module.exports, $6e5Zp);
$parcel$exportWildcard(module.exports, $8Fr9l);
$parcel$exportWildcard(module.exports, $dKyhl);
$parcel$exportWildcard(module.exports, $i5hok);
$parcel$exportWildcard(module.exports, $77AGr);
$parcel$exportWildcard(module.exports, $9XGHY);
$parcel$exportWildcard(module.exports, $6m5Bu);
$parcel$exportWildcard(module.exports, $9fO5H);

});
parcelRegister("27UkL", function(module, exports) {

$parcel$export(module.exports, "AxisScaleGizmo", () => $18c7eef3c126f3ec$export$76f0b3b73c3e3e46);

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $fbuqw = parcelRequire("fbuqw");

var $4C7Qm = parcelRequire("4C7Qm");

var $9zY5k = parcelRequire("9zY5k");

var $gAH3H = parcelRequire("gAH3H");

var $dnn9Q = parcelRequire("dnn9Q");

var $5ETkU = parcelRequire("5ETkU");

var $6mCYU = parcelRequire("6mCYU");

var $7etnY = parcelRequire("7etnY");

var $53VPf = parcelRequire("53VPf");
class $18c7eef3c126f3ec$export$76f0b3b73c3e3e46 extends (0, $5ETkU.Gizmo) {
    /** Default material used to render when gizmo is not disabled or hovered */ get coloredMaterial() {
        return this._coloredMaterial;
    }
    /** Material used to render when gizmo is hovered with mouse*/ get hoverMaterial() {
        return this._hoverMaterial;
    }
    /** Material used to render when gizmo is disabled. typically grey.*/ get disableMaterial() {
        return this._disableMaterial;
    }
    /**
     * Creates an AxisScaleGizmo
     * @param dragAxis The axis which the gizmo will be able to scale on
     * @param color The color of the gizmo
     * @param gizmoLayer The utility layer the gizmo will be added to
     * @param parent
     * @param thickness display gizmo axis thickness
     * @param hoverColor The color of the gizmo when hovering over and dragging
     * @param disableColor The Color of the gizmo when its disabled
     */ constructor(dragAxis, color = (0, $7etnY.Color3).Gray(), gizmoLayer = (0, $6mCYU.UtilityLayerRenderer).DefaultUtilityLayer, parent = null, thickness = 1, hoverColor = (0, $7etnY.Color3).Yellow(), disableColor = (0, $7etnY.Color3).Gray()){
        super(gizmoLayer);
        this._pointerObserver = null;
        /**
         * Scale distance in babylon units that the gizmo will snap to when dragged (Default: 0)
         */ this.snapDistance = 0;
        /**
         * Event that fires each time the gizmo snaps to a new location.
         * * snapDistance is the change in distance
         */ this.onSnapObservable = new (0, $diGQf.Observable)();
        /**
         * If the scaling operation should be done on all axis (default: false)
         */ this.uniformScaling = false;
        /**
         * Custom sensitivity value for the drag strength
         */ this.sensitivity = 1;
        /**
         * The magnitude of the drag strength (scaling factor)
         */ this.dragScale = 1;
        /**
         * Incremental snap scaling (default is false). When true, with a snapDistance of 0.1, scaling will be 1.1,1.2,1.3 instead of, when false: 1.1,1.21,1.33,...
         */ this.incrementalSnap = false;
        this._isEnabled = true;
        this._parent = null;
        this._dragging = false;
        this._tmpVector = new (0, $ha1VO.Vector3)(0, 0, 0);
        this._incrementalStartupValue = (0, $ha1VO.Vector3).Zero();
        this._parent = parent;
        // Create Material
        this._coloredMaterial = new (0, $gAH3H.StandardMaterial)("", gizmoLayer.utilityLayerScene);
        this._coloredMaterial.diffuseColor = color;
        this._coloredMaterial.specularColor = color.subtract(new (0, $7etnY.Color3)(0.1, 0.1, 0.1));
        this._hoverMaterial = new (0, $gAH3H.StandardMaterial)("", gizmoLayer.utilityLayerScene);
        this._hoverMaterial.diffuseColor = hoverColor;
        this._disableMaterial = new (0, $gAH3H.StandardMaterial)("", gizmoLayer.utilityLayerScene);
        this._disableMaterial.diffuseColor = disableColor;
        this._disableMaterial.alpha = 0.4;
        // Build mesh + Collider
        this._gizmoMesh = new (0, $fbuqw.Mesh)("axis", gizmoLayer.utilityLayerScene);
        const { arrowMesh: arrowMesh, arrowTail: arrowTail } = this._createGizmoMesh(this._gizmoMesh, thickness);
        const collider = this._createGizmoMesh(this._gizmoMesh, thickness + 4, true);
        this._gizmoMesh.lookAt(this._rootMesh.position.add(dragAxis));
        this._rootMesh.addChild(this._gizmoMesh, (0, $5ETkU.Gizmo).PreserveScaling);
        this._gizmoMesh.scaling.scaleInPlace(1 / 3);
        // Closure of initial prop values for resetting
        const nodePosition = arrowMesh.position.clone();
        const linePosition = arrowTail.position.clone();
        const lineScale = arrowTail.scaling.clone();
        const increaseGizmoMesh = (dragDistance)=>{
            const dragStrength = dragDistance * (3 / this._rootMesh.scaling.length()) * 6;
            arrowMesh.position.z += dragStrength / 3.5;
            arrowTail.scaling.y += dragStrength;
            this.dragScale = arrowTail.scaling.y;
            arrowTail.position.z = arrowMesh.position.z / 2;
        };
        const resetGizmoMesh = ()=>{
            arrowMesh.position.set(nodePosition.x, nodePosition.y, nodePosition.z);
            arrowTail.position.set(linePosition.x, linePosition.y, linePosition.z);
            arrowTail.scaling.set(lineScale.x, lineScale.y, lineScale.z);
            this.dragScale = arrowTail.scaling.y;
            this._dragging = false;
        };
        // Add drag behavior to handle events when the gizmo is dragged
        this.dragBehavior = new (0, $dnn9Q.PointerDragBehavior)({
            dragAxis: dragAxis
        });
        this.dragBehavior.moveAttached = false;
        this.dragBehavior.updateDragPlane = false;
        this._rootMesh.addBehavior(this.dragBehavior);
        let currentSnapDragDistance = 0;
        let currentSnapDragDistanceIncremental = 0;
        const tmpSnapEvent = {
            snapDistance: 0
        };
        this.dragBehavior.onDragObservable.add((event)=>{
            if (this.attachedNode) {
                // Drag strength is modified by the scale of the gizmo (eg. for small objects like boombox the strength will be increased to match the behavior of larger objects)
                const dragStrength = this.sensitivity * event.dragDistance * (this.scaleRatio * 3 / this._rootMesh.scaling.length());
                const tmpVector = this._tmpVector;
                // Snapping logic
                let snapped = false;
                let dragSteps = 0;
                if (this.uniformScaling) tmpVector.setAll(0.57735); // 1 / sqrt(3)
                else tmpVector.copyFrom(dragAxis);
                if (this.snapDistance == 0) tmpVector.scaleToRef(dragStrength, tmpVector);
                else {
                    currentSnapDragDistance += dragStrength;
                    currentSnapDragDistanceIncremental += dragStrength;
                    const currentSnap = this.incrementalSnap ? currentSnapDragDistanceIncremental : currentSnapDragDistance;
                    if (Math.abs(currentSnap) > this.snapDistance) {
                        dragSteps = Math.floor(Math.abs(currentSnap) / this.snapDistance);
                        if (currentSnap < 0) dragSteps *= -1;
                        currentSnapDragDistance = currentSnapDragDistance % this.snapDistance;
                        tmpVector.scaleToRef(this.snapDistance * dragSteps, tmpVector);
                        snapped = true;
                    } else tmpVector.scaleInPlace(0);
                }
                tmpVector.addInPlaceFromFloats(1, 1, 1);
                // can't use Math.sign here because Math.sign(0) is 0 and it needs to be positive
                tmpVector.x = Math.abs(tmpVector.x) < $18c7eef3c126f3ec$export$76f0b3b73c3e3e46.MinimumAbsoluteScale ? $18c7eef3c126f3ec$export$76f0b3b73c3e3e46.MinimumAbsoluteScale * (tmpVector.x < 0 ? -1 : 1) : tmpVector.x;
                tmpVector.y = Math.abs(tmpVector.y) < $18c7eef3c126f3ec$export$76f0b3b73c3e3e46.MinimumAbsoluteScale ? $18c7eef3c126f3ec$export$76f0b3b73c3e3e46.MinimumAbsoluteScale * (tmpVector.y < 0 ? -1 : 1) : tmpVector.y;
                tmpVector.z = Math.abs(tmpVector.z) < $18c7eef3c126f3ec$export$76f0b3b73c3e3e46.MinimumAbsoluteScale ? $18c7eef3c126f3ec$export$76f0b3b73c3e3e46.MinimumAbsoluteScale * (tmpVector.z < 0 ? -1 : 1) : tmpVector.z;
                const transformNode = this.attachedNode._isMesh ? this.attachedNode : undefined;
                if (Math.abs(this.snapDistance) > 0 && this.incrementalSnap) {
                    // get current scaling
                    this.attachedNode.getWorldMatrix().decompose(undefined, (0, $ha1VO.TmpVectors).Quaternion[0], (0, $ha1VO.TmpVectors).Vector3[2], (0, $5ETkU.Gizmo).PreserveScaling ? transformNode : undefined);
                    // apply incrementaly, without taking care of current scaling value
                    tmpVector.addInPlace(this._incrementalStartupValue);
                    tmpVector.addInPlaceFromFloats(-1, -1, -1);
                    // keep same sign or stretching close to 0 will change orientation at each drag and scaling will oscilate around 0
                    tmpVector.x = Math.abs(tmpVector.x) * (this._incrementalStartupValue.x > 0 ? 1 : -1);
                    tmpVector.y = Math.abs(tmpVector.y) * (this._incrementalStartupValue.y > 0 ? 1 : -1);
                    tmpVector.z = Math.abs(tmpVector.z) * (this._incrementalStartupValue.z > 0 ? 1 : -1);
                    (0, $ha1VO.Matrix).ComposeToRef(tmpVector, (0, $ha1VO.TmpVectors).Quaternion[0], (0, $ha1VO.TmpVectors).Vector3[2], (0, $ha1VO.TmpVectors).Matrix[1]);
                } else {
                    (0, $ha1VO.Matrix).ScalingToRef(tmpVector.x, tmpVector.y, tmpVector.z, (0, $ha1VO.TmpVectors).Matrix[2]);
                    (0, $ha1VO.TmpVectors).Matrix[2].multiplyToRef(this.attachedNode.getWorldMatrix(), (0, $ha1VO.TmpVectors).Matrix[1]);
                }
                // check scaling are not out of bounds. If not, copy resulting temp matrix to node world matrix
                (0, $ha1VO.TmpVectors).Matrix[1].decompose((0, $ha1VO.TmpVectors).Vector3[1], undefined, undefined, (0, $5ETkU.Gizmo).PreserveScaling ? transformNode : undefined);
                const maxScale = 100000;
                if (Math.abs((0, $ha1VO.TmpVectors).Vector3[1].x) < maxScale && Math.abs((0, $ha1VO.TmpVectors).Vector3[1].y) < maxScale && Math.abs((0, $ha1VO.TmpVectors).Vector3[1].z) < maxScale) this.attachedNode.getWorldMatrix().copyFrom((0, $ha1VO.TmpVectors).Matrix[1]);
                // notify observers
                if (snapped) {
                    tmpSnapEvent.snapDistance = this.snapDistance * dragSteps;
                    this.onSnapObservable.notifyObservers(tmpSnapEvent);
                }
                this._matrixChanged();
            }
        });
        // On Drag Listener: to move gizmo mesh with user action
        this.dragBehavior.onDragStartObservable.add(()=>{
            this._dragging = true;
            const transformNode = this.attachedNode._isMesh ? this.attachedNode : undefined;
            this.attachedNode?.getWorldMatrix().decompose(this._incrementalStartupValue, undefined, undefined, (0, $5ETkU.Gizmo).PreserveScaling ? transformNode : undefined);
            currentSnapDragDistance = 0;
            currentSnapDragDistanceIncremental = 0;
        });
        this.dragBehavior.onDragObservable.add((e)=>increaseGizmoMesh(e.dragDistance));
        this.dragBehavior.onDragEndObservable.add(resetGizmoMesh);
        // Listeners for Universal Scalar
        parent?.uniformScaleGizmo?.dragBehavior?.onDragObservable?.add((e)=>increaseGizmoMesh(e.delta.y));
        parent?.uniformScaleGizmo?.dragBehavior?.onDragEndObservable?.add(resetGizmoMesh);
        const cache = {
            gizmoMeshes: [
                arrowMesh,
                arrowTail
            ],
            colliderMeshes: [
                collider.arrowMesh,
                collider.arrowTail
            ],
            material: this._coloredMaterial,
            hoverMaterial: this._hoverMaterial,
            disableMaterial: this._disableMaterial,
            active: false,
            dragBehavior: this.dragBehavior
        };
        this._parent?.addToAxisCache(this._gizmoMesh, cache);
        this._pointerObserver = gizmoLayer.utilityLayerScene.onPointerObservable.add((pointerInfo)=>{
            if (this._customMeshSet) return;
            this._isHovered = !!(cache.colliderMeshes.indexOf(pointerInfo?.pickInfo?.pickedMesh) != -1);
            if (!this._parent) {
                const material = this.dragBehavior.enabled ? this._isHovered || this._dragging ? this._hoverMaterial : this._coloredMaterial : this._disableMaterial;
                this._setGizmoMeshMaterial(cache.gizmoMeshes, material);
            }
        });
        this.dragBehavior.onEnabledObservable.add((newState)=>{
            this._setGizmoMeshMaterial(cache.gizmoMeshes, newState ? this._coloredMaterial : this._disableMaterial);
        });
        const light = gizmoLayer._getSharedGizmoLight();
        light.includedOnlyMeshes = light.includedOnlyMeshes.concat(this._rootMesh.getChildMeshes());
    }
    /**
     * @internal
     * Create Geometry for Gizmo
     * @param parentMesh
     * @param thickness
     * @param isCollider
     * @returns the gizmo mesh
     */ _createGizmoMesh(parentMesh, thickness, isCollider = false) {
        const arrowMesh = (0, $4C7Qm.CreateBox)("yPosMesh", {
            size: 0.4 * (1 + (thickness - 1) / 4)
        }, this.gizmoLayer.utilityLayerScene);
        const arrowTail = (0, $9zY5k.CreateCylinder)("cylinder", {
            diameterTop: 0.005 * thickness,
            height: 0.275,
            diameterBottom: 0.005 * thickness,
            tessellation: 96
        }, this.gizmoLayer.utilityLayerScene);
        // Position arrow pointing in its drag axis
        arrowMesh.scaling.scaleInPlace(0.1);
        arrowMesh.material = this._coloredMaterial;
        arrowMesh.rotation.x = Math.PI / 2;
        arrowMesh.position.z += 0.3;
        arrowTail.material = this._coloredMaterial;
        arrowTail.position.z += 0.1375;
        arrowTail.rotation.x = Math.PI / 2;
        if (isCollider) {
            arrowMesh.visibility = 0;
            arrowTail.visibility = 0;
        }
        parentMesh.addChild(arrowMesh);
        parentMesh.addChild(arrowTail);
        return {
            arrowMesh: arrowMesh,
            arrowTail: arrowTail
        };
    }
    _attachedNodeChanged(value) {
        if (this.dragBehavior) this.dragBehavior.enabled = value ? true : false;
    }
    /**
     * If the gizmo is enabled
     */ set isEnabled(value) {
        this._isEnabled = value;
        if (!value) {
            this.attachedMesh = null;
            this.attachedNode = null;
        } else if (this._parent) {
            this.attachedMesh = this._parent.attachedMesh;
            this.attachedNode = this._parent.attachedNode;
        }
    }
    get isEnabled() {
        return this._isEnabled;
    }
    /**
     * Disposes of the gizmo
     */ dispose() {
        this.onSnapObservable.clear();
        this.gizmoLayer.utilityLayerScene.onPointerObservable.remove(this._pointerObserver);
        this.dragBehavior.detach();
        if (this._gizmoMesh) this._gizmoMesh.dispose();
        [
            this._coloredMaterial,
            this._hoverMaterial,
            this._disableMaterial
        ].forEach((matl)=>{
            if (matl) matl.dispose();
        });
        super.dispose();
    }
    /**
     * Disposes and replaces the current meshes in the gizmo with the specified mesh
     * @param mesh The mesh to replace the default mesh of the gizmo
     * @param useGizmoMaterial If the gizmo's default material should be used (default: false)
     */ setCustomMesh(mesh, useGizmoMaterial = false) {
        super.setCustomMesh(mesh);
        if (useGizmoMaterial) {
            this._rootMesh.getChildMeshes().forEach((m)=>{
                m.material = this._coloredMaterial;
                if (m.color) m.color = this._coloredMaterial.diffuseColor;
            });
            this._customMeshSet = false;
        }
    }
}
/**
 * The minimal absolute scale per component. can be positive or negative but never smaller.
 */ $18c7eef3c126f3ec$export$76f0b3b73c3e3e46.MinimumAbsoluteScale = (0, $53VPf.Epsilon);

});

parcelRegister("27QWx", function(module, exports) {

$parcel$export(module.exports, "BoundingBoxGizmo", () => $18c54d9dab5a41be$export$a975006c46049134);

var $diGQf = parcelRequire("diGQf");

var $kVtWi = parcelRequire("kVtWi");

var $ha1VO = parcelRequire("ha1VO");

var $0cHNL = parcelRequire("0cHNL");

var $8KqOo = parcelRequire("8KqOo");

var $4C7Qm = parcelRequire("4C7Qm");

var $8Eyol = parcelRequire("8Eyol");

var $dnn9Q = parcelRequire("dnn9Q");

var $5ETkU = parcelRequire("5ETkU");

var $6mCYU = parcelRequire("6mCYU");

var $gAH3H = parcelRequire("gAH3H");

var $3Pok5 = parcelRequire("3Pok5");

var $7etnY = parcelRequire("7etnY");

var $53VPf = parcelRequire("53VPf");
class $18c54d9dab5a41be$export$a975006c46049134 extends (0, $5ETkU.Gizmo) {
    /**
     * Sets the axis factor
     * @param factor the Vector3 value
     */ set axisFactor(factor) {
        this._axisFactor = factor;
        // update scale cube visibility
        const scaleBoxes = this._scaleBoxesParent.getChildMeshes();
        let index = 0;
        for(let i = 0; i < 3; i++){
            for(let j = 0; j < 3; j++)for(let k = 0; k < 3; k++){
                const zeroAxisCount = (i === 1 ? 1 : 0) + (j === 1 ? 1 : 0) + (k === 1 ? 1 : 0);
                if (zeroAxisCount === 1 || zeroAxisCount === 3) continue;
                if (scaleBoxes[index]) {
                    const dragAxis = new (0, $ha1VO.Vector3)(i - 1, j - 1, k - 1);
                    dragAxis.multiplyInPlace(this._axisFactor);
                    scaleBoxes[index].setEnabled(dragAxis.lengthSquared() > (0, $53VPf.Epsilon));
                }
                index++;
            }
        }
    }
    /**
     * Gets the axis factor
     * @returns the Vector3 factor value
     */ get axisFactor() {
        return this._axisFactor;
    }
    /**
     * Sets scale drag speed value
     * @param value the new speed value
     */ set scaleDragSpeed(value) {
        this._scaleDragSpeed = value;
    }
    /**
     * Gets scale drag speed
     * @returns the scale speed number
     */ get scaleDragSpeed() {
        return this._scaleDragSpeed;
    }
    /** Default material used to render when gizmo is not disabled or hovered */ get coloredMaterial() {
        return this._coloredMaterial;
    }
    /** Material used to render when gizmo is hovered with mouse*/ get hoverMaterial() {
        return this._hoverColoredMaterial;
    }
    /**
     * Get the pointerDragBehavior
     */ get pointerDragBehavior() {
        return this._pointerDragBehavior;
    }
    /** True when a rotation sphere or scale box or a attached mesh is dragged */ get isDragging() {
        return this._dragging || this._pointerDragBehavior.dragging;
    }
    /**
     * Sets the color of the bounding box gizmo
     * @param color the color to set
     */ setColor(color) {
        this._coloredMaterial.emissiveColor = color;
        this._hoverColoredMaterial.emissiveColor = color.clone().add(new (0, $7etnY.Color3)(0.3, 0.3, 0.3));
        this._lineBoundingBox.getChildren().forEach((l)=>{
            if (l.color) l.color = color;
        });
    }
    /**
     * Creates an BoundingBoxGizmo
     * @param color The color of the gizmo
     * @param gizmoLayer The utility layer the gizmo will be added to
     */ constructor(color = (0, $7etnY.Color3).Gray(), gizmoLayer = (0, $6mCYU.UtilityLayerRenderer).DefaultKeepDepthUtilityLayer){
        super(gizmoLayer);
        this._boundingDimensions = new (0, $ha1VO.Vector3)(1, 1, 1);
        this._renderObserver = null;
        this._pointerObserver = null;
        this._scaleDragSpeed = 0.2;
        /**
         * boolean updated when a rotation sphere or scale box is dragged
         */ this._dragging = false;
        this._tmpQuaternion = new (0, $ha1VO.Quaternion)();
        this._tmpVector = new (0, $ha1VO.Vector3)(0, 0, 0);
        this._tmpRotationMatrix = new (0, $ha1VO.Matrix)();
        this._incrementalStartupValue = (0, $ha1VO.Vector3).Zero();
        this._incrementalAnchorStartupValue = (0, $ha1VO.Vector3).Zero();
        /**
         * If child meshes should be ignored when calculating the bounding box. This should be set to true to avoid perf hits with heavily nested meshes (Default: false)
         */ this.ignoreChildren = false;
        /**
         * Returns true if a descendant should be included when computing the bounding box. When null, all descendants are included. If ignoreChildren is set this will be ignored. (Default: null)
         */ this.includeChildPredicate = null;
        /**
         * The size of the rotation spheres attached to the bounding box (Default: 0.1)
         */ this.rotationSphereSize = 0.1;
        /**
         * The size of the scale boxes attached to the bounding box (Default: 0.1)
         */ this.scaleBoxSize = 0.1;
        /**
         * If set, the rotation spheres and scale boxes will increase in size based on the distance away from the camera to have a consistent screen size (Default: false)
         * Note : fixedDragMeshScreenSize takes precedence over fixedDragMeshBoundsSize if both are true
         */ this.fixedDragMeshScreenSize = false;
        /**
         * If set, the rotation spheres and scale boxes will increase in size based on the size of the bounding box
         * Note : fixedDragMeshScreenSize takes precedence over fixedDragMeshBoundsSize if both are true
         */ this.fixedDragMeshBoundsSize = false;
        /**
         * The distance away from the object which the draggable meshes should appear world sized when fixedDragMeshScreenSize is set to true (default: 10)
         */ this.fixedDragMeshScreenSizeDistanceFactor = 10;
        /**
         * Drag distance in babylon units that the gizmo will snap scaling to when dragged
         */ this.scalingSnapDistance = 0;
        /**
         * Drag distance in babylon units that the gizmo will snap rotation to when dragged
         */ this.rotationSnapDistance = 0;
        /**
         * Fired when a rotation sphere or scale box is dragged
         */ this.onDragStartObservable = new (0, $diGQf.Observable)();
        /**
         * Fired when a scale box is dragged
         */ this.onScaleBoxDragObservable = new (0, $diGQf.Observable)();
        /**
         * Fired when a scale box drag is ended
         */ this.onScaleBoxDragEndObservable = new (0, $diGQf.Observable)();
        /**
         * Fired when a rotation sphere is dragged
         */ this.onRotationSphereDragObservable = new (0, $diGQf.Observable)();
        /**
         * Fired when a rotation sphere drag is ended
         */ this.onRotationSphereDragEndObservable = new (0, $diGQf.Observable)();
        /**
         * Relative bounding box pivot used when scaling the attached node. When null object with scale from the opposite corner. 0.5,0.5,0.5 for center and 0.5,0,0.5 for bottom (Default: null)
         */ this.scalePivot = null;
        /**
         * Scale factor used for masking some axis
         */ this._axisFactor = new (0, $ha1VO.Vector3)(1, 1, 1);
        /**
         * Incremental snap scaling (default is false). When true, with a snapDistance of 0.1, scaling will be 1.1,1.2,1.3 instead of, when false: 1.1,1.21,1.33,...
         */ this.incrementalSnap = false;
        this._existingMeshScale = new (0, $ha1VO.Vector3)();
        // Dragging
        this._dragMesh = null;
        this._pointerDragBehavior = new (0, $dnn9Q.PointerDragBehavior)();
        // Do not update the gizmo's scale so it has a fixed size to the object its attached to
        this.updateScale = false;
        this._anchorMesh = new (0, $0cHNL.AbstractMesh)("anchor", gizmoLayer.utilityLayerScene);
        // Create Materials
        this._coloredMaterial = new (0, $gAH3H.StandardMaterial)("", gizmoLayer.utilityLayerScene);
        this._coloredMaterial.disableLighting = true;
        this._hoverColoredMaterial = new (0, $gAH3H.StandardMaterial)("", gizmoLayer.utilityLayerScene);
        this._hoverColoredMaterial.disableLighting = true;
        // Build bounding box out of lines
        this._lineBoundingBox = new (0, $0cHNL.AbstractMesh)("", gizmoLayer.utilityLayerScene);
        this._lineBoundingBox.rotationQuaternion = new (0, $ha1VO.Quaternion)();
        const lines = [];
        lines.push((0, $8Eyol.CreateLines)("lines", {
            points: [
                new (0, $ha1VO.Vector3)(0, 0, 0),
                new (0, $ha1VO.Vector3)(this._boundingDimensions.x, 0, 0)
            ]
        }, gizmoLayer.utilityLayerScene));
        lines.push((0, $8Eyol.CreateLines)("lines", {
            points: [
                new (0, $ha1VO.Vector3)(0, 0, 0),
                new (0, $ha1VO.Vector3)(0, this._boundingDimensions.y, 0)
            ]
        }, gizmoLayer.utilityLayerScene));
        lines.push((0, $8Eyol.CreateLines)("lines", {
            points: [
                new (0, $ha1VO.Vector3)(0, 0, 0),
                new (0, $ha1VO.Vector3)(0, 0, this._boundingDimensions.z)
            ]
        }, gizmoLayer.utilityLayerScene));
        lines.push((0, $8Eyol.CreateLines)("lines", {
            points: [
                new (0, $ha1VO.Vector3)(this._boundingDimensions.x, 0, 0),
                new (0, $ha1VO.Vector3)(this._boundingDimensions.x, this._boundingDimensions.y, 0)
            ]
        }, gizmoLayer.utilityLayerScene));
        lines.push((0, $8Eyol.CreateLines)("lines", {
            points: [
                new (0, $ha1VO.Vector3)(this._boundingDimensions.x, 0, 0),
                new (0, $ha1VO.Vector3)(this._boundingDimensions.x, 0, this._boundingDimensions.z)
            ]
        }, gizmoLayer.utilityLayerScene));
        lines.push((0, $8Eyol.CreateLines)("lines", {
            points: [
                new (0, $ha1VO.Vector3)(0, this._boundingDimensions.y, 0),
                new (0, $ha1VO.Vector3)(this._boundingDimensions.x, this._boundingDimensions.y, 0)
            ]
        }, gizmoLayer.utilityLayerScene));
        lines.push((0, $8Eyol.CreateLines)("lines", {
            points: [
                new (0, $ha1VO.Vector3)(0, this._boundingDimensions.y, 0),
                new (0, $ha1VO.Vector3)(0, this._boundingDimensions.y, this._boundingDimensions.z)
            ]
        }, gizmoLayer.utilityLayerScene));
        lines.push((0, $8Eyol.CreateLines)("lines", {
            points: [
                new (0, $ha1VO.Vector3)(0, 0, this._boundingDimensions.z),
                new (0, $ha1VO.Vector3)(this._boundingDimensions.x, 0, this._boundingDimensions.z)
            ]
        }, gizmoLayer.utilityLayerScene));
        lines.push((0, $8Eyol.CreateLines)("lines", {
            points: [
                new (0, $ha1VO.Vector3)(0, 0, this._boundingDimensions.z),
                new (0, $ha1VO.Vector3)(0, this._boundingDimensions.y, this._boundingDimensions.z)
            ]
        }, gizmoLayer.utilityLayerScene));
        lines.push((0, $8Eyol.CreateLines)("lines", {
            points: [
                new (0, $ha1VO.Vector3)(this._boundingDimensions.x, this._boundingDimensions.y, this._boundingDimensions.z),
                new (0, $ha1VO.Vector3)(0, this._boundingDimensions.y, this._boundingDimensions.z)
            ]
        }, gizmoLayer.utilityLayerScene));
        lines.push((0, $8Eyol.CreateLines)("lines", {
            points: [
                new (0, $ha1VO.Vector3)(this._boundingDimensions.x, this._boundingDimensions.y, this._boundingDimensions.z),
                new (0, $ha1VO.Vector3)(this._boundingDimensions.x, 0, this._boundingDimensions.z)
            ]
        }, gizmoLayer.utilityLayerScene));
        lines.push((0, $8Eyol.CreateLines)("lines", {
            points: [
                new (0, $ha1VO.Vector3)(this._boundingDimensions.x, this._boundingDimensions.y, this._boundingDimensions.z),
                new (0, $ha1VO.Vector3)(this._boundingDimensions.x, this._boundingDimensions.y, 0)
            ]
        }, gizmoLayer.utilityLayerScene));
        lines.forEach((l)=>{
            l.color = color;
            l.position.addInPlace(new (0, $ha1VO.Vector3)(-this._boundingDimensions.x / 2, -this._boundingDimensions.y / 2, -this._boundingDimensions.z / 2));
            l.isPickable = false;
            this._lineBoundingBox.addChild(l);
        });
        this._rootMesh.addChild(this._lineBoundingBox);
        this.setColor(color);
        // Create rotation spheres
        this._rotateSpheresParent = new (0, $0cHNL.AbstractMesh)("", gizmoLayer.utilityLayerScene);
        this._rotateSpheresParent.rotationQuaternion = new (0, $ha1VO.Quaternion)();
        for(let i = 0; i < 12; i++){
            const sphere = (0, $8KqOo.CreateSphere)("", {
                diameter: 1
            }, gizmoLayer.utilityLayerScene);
            sphere.rotationQuaternion = new (0, $ha1VO.Quaternion)();
            sphere.material = this._coloredMaterial;
            sphere.isNearGrabbable = true;
            // Drag behavior
            this._rotateSpheresDragBehavior = new (0, $dnn9Q.PointerDragBehavior)({});
            this._rotateSpheresDragBehavior.moveAttached = false;
            this._rotateSpheresDragBehavior.updateDragPlane = false;
            sphere.addBehavior(this._rotateSpheresDragBehavior);
            const startingTurnDirection = new (0, $ha1VO.Vector3)(1, 0, 0);
            let totalTurnAmountOfDrag = 0;
            let previousProjectDist = 0;
            this._rotateSpheresDragBehavior.onDragStartObservable.add(()=>{
                startingTurnDirection.copyFrom(sphere.forward);
                totalTurnAmountOfDrag = 0;
                previousProjectDist = 0;
            });
            this._rotateSpheresDragBehavior.onDragObservable.add((event)=>{
                this.onRotationSphereDragObservable.notifyObservers({});
                if (this.attachedMesh) {
                    const originalParent = this.attachedMesh.parent;
                    if (originalParent && originalParent.scaling && originalParent.scaling.isNonUniformWithinEpsilon(0.001)) {
                        (0, $kVtWi.Logger).Warn("BoundingBoxGizmo controls are not supported on child meshes with non-uniform parent scaling");
                        return;
                    }
                    (0, $3Pok5.PivotTools)._RemoveAndStorePivotPoint(this.attachedMesh);
                    const worldDragDirection = startingTurnDirection;
                    // Project the world right on to the drag plane
                    const toSub = event.dragPlaneNormal.scale((0, $ha1VO.Vector3).Dot(event.dragPlaneNormal, worldDragDirection));
                    const dragAxis = worldDragDirection.subtract(toSub).normalizeToNew();
                    // project drag delta on to the resulting drag axis and rotate based on that
                    let projectDist = (0, $ha1VO.Vector3).Dot(dragAxis, event.delta) < 0 ? Math.abs(event.delta.length()) : -Math.abs(event.delta.length());
                    // Make rotation relative to size of mesh.
                    projectDist = projectDist / this._boundingDimensions.length() * this._anchorMesh.scaling.length();
                    // Rotate based on axis
                    if (!this.attachedMesh.rotationQuaternion) this.attachedMesh.rotationQuaternion = (0, $ha1VO.Quaternion).RotationYawPitchRoll(this.attachedMesh.rotation.y, this.attachedMesh.rotation.x, this.attachedMesh.rotation.z);
                    if (!this._anchorMesh.rotationQuaternion) this._anchorMesh.rotationQuaternion = (0, $ha1VO.Quaternion).RotationYawPitchRoll(this._anchorMesh.rotation.y, this._anchorMesh.rotation.x, this._anchorMesh.rotation.z);
                    // Do not allow the object to turn more than a full circle
                    totalTurnAmountOfDrag += projectDist;
                    if (Math.abs(totalTurnAmountOfDrag) <= 2 * Math.PI) {
                        if (this.rotationSnapDistance > 0) {
                            const dragSteps = Math.floor(Math.abs(totalTurnAmountOfDrag) / this.rotationSnapDistance) * (totalTurnAmountOfDrag < 0 ? -1 : 1);
                            const angle = this.rotationSnapDistance * dragSteps;
                            projectDist = angle - previousProjectDist;
                            previousProjectDist = angle;
                        }
                        if (i >= 8) (0, $ha1VO.Quaternion).RotationYawPitchRollToRef(0, 0, projectDist, this._tmpQuaternion);
                        else if (i >= 4) (0, $ha1VO.Quaternion).RotationYawPitchRollToRef(projectDist, 0, 0, this._tmpQuaternion);
                        else (0, $ha1VO.Quaternion).RotationYawPitchRollToRef(0, projectDist, 0, this._tmpQuaternion);
                        // if using pivot, move anchor so mesh will be at relative (0,0,0) when parented
                        if (this.attachedMesh.isUsingPivotMatrix()) this._anchorMesh.position.copyFrom(this.attachedMesh.position);
                        // Rotate around center of bounding box
                        this._anchorMesh.addChild(this.attachedMesh);
                        if (this._anchorMesh.getScene().useRightHandedSystem) this._tmpQuaternion.conjugateInPlace();
                        this._tmpQuaternion.normalize();
                        this._anchorMesh.rotationQuaternion.multiplyToRef(this._tmpQuaternion, this._anchorMesh.rotationQuaternion);
                        this._anchorMesh.rotationQuaternion.normalize();
                        this._anchorMesh.removeChild(this.attachedMesh);
                        this.attachedMesh.setParent(originalParent);
                    }
                    this.updateBoundingBox();
                    (0, $3Pok5.PivotTools)._RestorePivotPoint(this.attachedMesh);
                }
                this._updateDummy();
            });
            // Selection/deselection
            this._rotateSpheresDragBehavior.onDragStartObservable.add(()=>{
                this.onDragStartObservable.notifyObservers({});
                this._dragging = true;
                this._selectNode(sphere);
            });
            this._rotateSpheresDragBehavior.onDragEndObservable.add((event)=>{
                this.onRotationSphereDragEndObservable.notifyObservers({});
                this._dragging = false;
                this._selectNode(null);
                this._updateDummy();
                this._unhoverMeshOnTouchUp(event.pointerInfo, sphere);
            });
            this._rotateSpheresParent.addChild(sphere);
        }
        this._rootMesh.addChild(this._rotateSpheresParent);
        // Create scale cubes
        this._scaleBoxesParent = new (0, $0cHNL.AbstractMesh)("", gizmoLayer.utilityLayerScene);
        this._scaleBoxesParent.rotationQuaternion = new (0, $ha1VO.Quaternion)();
        for(let i = 0; i < 3; i++){
            for(let j = 0; j < 3; j++)for(let k = 0; k < 3; k++){
                // create box for relevant axis
                const zeroAxisCount = (i === 1 ? 1 : 0) + (j === 1 ? 1 : 0) + (k === 1 ? 1 : 0);
                if (zeroAxisCount === 1 || zeroAxisCount === 3) continue;
                const box = (0, $4C7Qm.CreateBox)("", {
                    size: 1
                }, gizmoLayer.utilityLayerScene);
                box.material = this._coloredMaterial;
                box._internalMetadata = zeroAxisCount === 2; // None homogenous scale handle
                box.isNearGrabbable = true;
                // Dragging logic
                const dragAxis = new (0, $ha1VO.Vector3)(i - 1, j - 1, k - 1).normalize();
                this._scaleBoxesDragBehavior = new (0, $dnn9Q.PointerDragBehavior)({
                    dragAxis: dragAxis
                });
                this._scaleBoxesDragBehavior.updateDragPlane = false;
                this._scaleBoxesDragBehavior.moveAttached = false;
                let totalRelativeDragDistance = 0;
                let previousScale = 0;
                box.addBehavior(this._scaleBoxesDragBehavior);
                this._scaleBoxesDragBehavior.onDragObservable.add((event)=>{
                    this.onScaleBoxDragObservable.notifyObservers({});
                    if (this.attachedMesh) {
                        const originalParent = this.attachedMesh.parent;
                        if (originalParent && originalParent.scaling && originalParent.scaling.isNonUniformWithinEpsilon(0.001)) {
                            (0, $kVtWi.Logger).Warn("BoundingBoxGizmo controls are not supported on child meshes with non-uniform parent scaling");
                            return;
                        }
                        (0, $3Pok5.PivotTools)._RemoveAndStorePivotPoint(this.attachedMesh);
                        let relativeDragDistance = event.dragDistance / this._boundingDimensions.length() * this._anchorMesh.scaling.length();
                        totalRelativeDragDistance += relativeDragDistance;
                        if (this.scalingSnapDistance > 0) {
                            const dragSteps = Math.floor(Math.abs(totalRelativeDragDistance) / this.scalingSnapDistance) * (totalRelativeDragDistance < 0 ? -1 : 1);
                            const scale = this.scalingSnapDistance * dragSteps;
                            relativeDragDistance = scale - previousScale;
                            previousScale = scale;
                        }
                        const deltaScale = new (0, $ha1VO.Vector3)(relativeDragDistance, relativeDragDistance, relativeDragDistance);
                        const fullScale = new (0, $ha1VO.Vector3)(previousScale, previousScale, previousScale);
                        if (zeroAxisCount === 2) {
                            // scale on 1 axis when using the anchor box in the face middle
                            deltaScale.x *= Math.abs(dragAxis.x);
                            deltaScale.y *= Math.abs(dragAxis.y);
                            deltaScale.z *= Math.abs(dragAxis.z);
                        }
                        deltaScale.scaleInPlace(this._scaleDragSpeed);
                        deltaScale.multiplyInPlace(this._axisFactor);
                        fullScale.scaleInPlace(this._scaleDragSpeed);
                        fullScale.multiplyInPlace(this._axisFactor);
                        fullScale.addInPlace(this._incrementalStartupValue);
                        this.updateBoundingBox();
                        if (this.scalePivot) {
                            this.attachedMesh.getWorldMatrix().getRotationMatrixToRef(this._tmpRotationMatrix);
                            // Move anchor to desired pivot point (Bottom left corner + dimension/2)
                            this._boundingDimensions.scaleToRef(0.5, this._tmpVector);
                            (0, $ha1VO.Vector3).TransformCoordinatesToRef(this._tmpVector, this._tmpRotationMatrix, this._tmpVector);
                            this._anchorMesh.position.subtractInPlace(this._tmpVector);
                            this._boundingDimensions.multiplyToRef(this.scalePivot, this._tmpVector);
                            (0, $ha1VO.Vector3).TransformCoordinatesToRef(this._tmpVector, this._tmpRotationMatrix, this._tmpVector);
                            this._anchorMesh.position.addInPlace(this._tmpVector);
                        } else {
                            // Scale from the position of the opposite corner
                            box.absolutePosition.subtractToRef(this._anchorMesh.position, this._tmpVector);
                            this._anchorMesh.position.subtractInPlace(this._tmpVector);
                            if (this.attachedMesh.isUsingPivotMatrix()) this._anchorMesh.position.subtractInPlace(this.attachedMesh.getPivotPoint());
                        }
                        this._anchorMesh.addChild(this.attachedMesh);
                        if (this.incrementalSnap) {
                            fullScale.x /= Math.abs(this._incrementalStartupValue.x) < (0, $53VPf.Epsilon) ? 1 : this._incrementalStartupValue.x;
                            fullScale.y /= Math.abs(this._incrementalStartupValue.y) < (0, $53VPf.Epsilon) ? 1 : this._incrementalStartupValue.y;
                            fullScale.z /= Math.abs(this._incrementalStartupValue.z) < (0, $53VPf.Epsilon) ? 1 : this._incrementalStartupValue.z;
                            fullScale.x = Math.max(this._incrementalAnchorStartupValue.x * fullScale.x, this.scalingSnapDistance);
                            fullScale.y = Math.max(this._incrementalAnchorStartupValue.y * fullScale.y, this.scalingSnapDistance);
                            fullScale.z = Math.max(this._incrementalAnchorStartupValue.z * fullScale.z, this.scalingSnapDistance);
                            this._anchorMesh.scaling.x += (fullScale.x - this._anchorMesh.scaling.x) * Math.abs(dragAxis.x);
                            this._anchorMesh.scaling.y += (fullScale.y - this._anchorMesh.scaling.y) * Math.abs(dragAxis.y);
                            this._anchorMesh.scaling.z += (fullScale.z - this._anchorMesh.scaling.z) * Math.abs(dragAxis.z);
                        } else {
                            this._anchorMesh.scaling.addInPlace(deltaScale);
                            if (this._anchorMesh.scaling.x < 0 || this._anchorMesh.scaling.y < 0 || this._anchorMesh.scaling.z < 0) this._anchorMesh.scaling.subtractInPlace(deltaScale);
                        }
                        this._anchorMesh.removeChild(this.attachedMesh);
                        this.attachedMesh.setParent(originalParent);
                        (0, $3Pok5.PivotTools)._RestorePivotPoint(this.attachedMesh);
                    }
                    this._updateDummy();
                });
                // Selection/deselection
                this._scaleBoxesDragBehavior.onDragStartObservable.add(()=>{
                    this.onDragStartObservable.notifyObservers({});
                    this._dragging = true;
                    this._selectNode(box);
                    totalRelativeDragDistance = 0;
                    previousScale = 0;
                    this._incrementalStartupValue.copyFrom(this.attachedMesh.scaling);
                    this._incrementalAnchorStartupValue.copyFrom(this._anchorMesh.scaling);
                });
                this._scaleBoxesDragBehavior.onDragEndObservable.add((event)=>{
                    this.onScaleBoxDragEndObservable.notifyObservers({});
                    this._dragging = false;
                    this._selectNode(null);
                    this._updateDummy();
                    this._unhoverMeshOnTouchUp(event.pointerInfo, box);
                });
                this._scaleBoxesParent.addChild(box);
            }
        }
        this._rootMesh.addChild(this._scaleBoxesParent);
        // Hover color change
        const pointerIds = [];
        this._pointerObserver = gizmoLayer.utilityLayerScene.onPointerObservable.add((pointerInfo)=>{
            if (!pointerIds[pointerInfo.event.pointerId]) this._rotateSpheresParent.getChildMeshes().concat(this._scaleBoxesParent.getChildMeshes()).forEach((mesh)=>{
                if (pointerInfo.pickInfo && pointerInfo.pickInfo.pickedMesh == mesh) {
                    pointerIds[pointerInfo.event.pointerId] = mesh;
                    mesh.material = this._hoverColoredMaterial;
                    this._isHovered = true;
                }
            });
            else if (pointerInfo.pickInfo && pointerInfo.pickInfo.pickedMesh != pointerIds[pointerInfo.event.pointerId]) {
                pointerIds[pointerInfo.event.pointerId].material = this._coloredMaterial;
                delete pointerIds[pointerInfo.event.pointerId];
                this._isHovered = false;
            }
        });
        // Update bounding box positions
        this._renderObserver = this.gizmoLayer.originalScene.onBeforeRenderObservable.add(()=>{
            // Only update the bounding box if scaling has changed
            if (this.attachedMesh && !this._existingMeshScale.equals(this.attachedMesh.scaling)) this.updateBoundingBox();
            else if (this.fixedDragMeshScreenSize || this.fixedDragMeshBoundsSize) {
                this._updateRotationSpheres();
                this._updateScaleBoxes();
            }
            // If drag mesh is enabled and dragging, update the attached mesh pose to match the drag mesh
            if (this._dragMesh && this.attachedMesh && this._pointerDragBehavior.dragging) {
                this._lineBoundingBox.position.rotateByQuaternionToRef(this._rootMesh.rotationQuaternion, this._tmpVector);
                this.attachedMesh.setAbsolutePosition(this._dragMesh.position.add(this._tmpVector.scale(-1)));
            }
        });
        this.updateBoundingBox();
    }
    _attachedNodeChanged(value) {
        if (value) {
            // Reset anchor mesh to match attached mesh's scale
            // This is needed to avoid invalid box/sphere position on first drag
            this._anchorMesh.scaling.setAll(1);
            (0, $3Pok5.PivotTools)._RemoveAndStorePivotPoint(value);
            const originalParent = value.parent;
            this._anchorMesh.addChild(value);
            this._anchorMesh.removeChild(value);
            value.setParent(originalParent);
            (0, $3Pok5.PivotTools)._RestorePivotPoint(value);
            this.updateBoundingBox();
            value.getChildMeshes(false).forEach((m)=>{
                m.markAsDirty("scaling");
            });
            this.gizmoLayer.utilityLayerScene.onAfterRenderObservable.addOnce(()=>{
                this._updateDummy();
            });
        }
    }
    _selectNode(selectedMesh) {
        this._rotateSpheresParent.getChildMeshes().concat(this._scaleBoxesParent.getChildMeshes()).forEach((m)=>{
            m.isVisible = !selectedMesh || m == selectedMesh;
        });
    }
    _unhoverMeshOnTouchUp(pointerInfo, selectedMesh) {
        // force unhover mesh if not a mouse event
        if (pointerInfo?.event instanceof PointerEvent && pointerInfo?.event.pointerType === "touch") selectedMesh.material = this._coloredMaterial;
    }
    /**
     * returns an array containing all boxes used for scaling (in increasing x, y and z orders)
     * @returns array of scaling boxes
     */ getScaleBoxes() {
        return this._scaleBoxesParent.getChildMeshes();
    }
    /**
     * Updates the bounding box information for the Gizmo
     */ updateBoundingBox() {
        if (this.attachedMesh) {
            (0, $3Pok5.PivotTools)._RemoveAndStorePivotPoint(this.attachedMesh);
            // Store original parent
            const originalParent = this.attachedMesh.parent;
            this.attachedMesh.setParent(null);
            this._update();
            // Rotate based on axis
            if (!this.attachedMesh.rotationQuaternion) this.attachedMesh.rotationQuaternion = (0, $ha1VO.Quaternion).RotationYawPitchRoll(this.attachedMesh.rotation.y, this.attachedMesh.rotation.x, this.attachedMesh.rotation.z);
            if (!this._anchorMesh.rotationQuaternion) this._anchorMesh.rotationQuaternion = (0, $ha1VO.Quaternion).RotationYawPitchRoll(this._anchorMesh.rotation.y, this._anchorMesh.rotation.x, this._anchorMesh.rotation.z);
            this._anchorMesh.rotationQuaternion.copyFrom(this.attachedMesh.rotationQuaternion);
            // Store original position and reset mesh to origin before computing the bounding box
            this._tmpQuaternion.copyFrom(this.attachedMesh.rotationQuaternion);
            this._tmpVector.copyFrom(this.attachedMesh.position);
            this.attachedMesh.rotationQuaternion.set(0, 0, 0, 1);
            this.attachedMesh.position.set(0, 0, 0);
            // Update bounding dimensions/positions
            const boundingMinMax = this.attachedMesh.getHierarchyBoundingVectors(!this.ignoreChildren, this.includeChildPredicate);
            boundingMinMax.max.subtractToRef(boundingMinMax.min, this._boundingDimensions);
            // Update gizmo to match bounding box scaling and rotation
            // The position set here is the offset from the origin for the boundingbox when the attached mesh is at the origin
            // The position of the gizmo is then set to the attachedMesh in gizmo._update
            this._lineBoundingBox.scaling.copyFrom(this._boundingDimensions);
            this._lineBoundingBox.position.set((boundingMinMax.max.x + boundingMinMax.min.x) / 2, (boundingMinMax.max.y + boundingMinMax.min.y) / 2, (boundingMinMax.max.z + boundingMinMax.min.z) / 2);
            this._rotateSpheresParent.position.copyFrom(this._lineBoundingBox.position);
            this._scaleBoxesParent.position.copyFrom(this._lineBoundingBox.position);
            this._lineBoundingBox.computeWorldMatrix();
            this._anchorMesh.position.copyFrom(this._lineBoundingBox.absolutePosition);
            // Restore position/rotation values
            this.attachedMesh.rotationQuaternion.copyFrom(this._tmpQuaternion);
            this.attachedMesh.position.copyFrom(this._tmpVector);
            // Restore original parent
            this.attachedMesh.setParent(originalParent);
        }
        this._updateRotationSpheres();
        this._updateScaleBoxes();
        if (this.attachedMesh) {
            this._existingMeshScale.copyFrom(this.attachedMesh.scaling);
            (0, $3Pok5.PivotTools)._RestorePivotPoint(this.attachedMesh);
        }
    }
    _updateRotationSpheres() {
        const rotateSpheres = this._rotateSpheresParent.getChildMeshes();
        for(let i = 0; i < 3; i++){
            for(let j = 0; j < 2; j++)for(let k = 0; k < 2; k++){
                const index = i * 4 + j * 2 + k;
                if (i == 0) {
                    rotateSpheres[index].position.set(this._boundingDimensions.x / 2, this._boundingDimensions.y * j, this._boundingDimensions.z * k);
                    rotateSpheres[index].position.addInPlace(new (0, $ha1VO.Vector3)(-this._boundingDimensions.x / 2, -this._boundingDimensions.y / 2, -this._boundingDimensions.z / 2));
                    rotateSpheres[index].lookAt((0, $ha1VO.Vector3).Cross(rotateSpheres[index].position.normalizeToNew(), (0, $ha1VO.Vector3).Right()).normalizeToNew().add(rotateSpheres[index].position));
                }
                if (i == 1) {
                    rotateSpheres[index].position.set(this._boundingDimensions.x * j, this._boundingDimensions.y / 2, this._boundingDimensions.z * k);
                    rotateSpheres[index].position.addInPlace(new (0, $ha1VO.Vector3)(-this._boundingDimensions.x / 2, -this._boundingDimensions.y / 2, -this._boundingDimensions.z / 2));
                    rotateSpheres[index].lookAt((0, $ha1VO.Vector3).Cross(rotateSpheres[index].position.normalizeToNew(), (0, $ha1VO.Vector3).Up()).normalizeToNew().add(rotateSpheres[index].position));
                }
                if (i == 2) {
                    rotateSpheres[index].position.set(this._boundingDimensions.x * j, this._boundingDimensions.y * k, this._boundingDimensions.z / 2);
                    rotateSpheres[index].position.addInPlace(new (0, $ha1VO.Vector3)(-this._boundingDimensions.x / 2, -this._boundingDimensions.y / 2, -this._boundingDimensions.z / 2));
                    rotateSpheres[index].lookAt((0, $ha1VO.Vector3).Cross(rotateSpheres[index].position.normalizeToNew(), (0, $ha1VO.Vector3).Forward()).normalizeToNew().add(rotateSpheres[index].position));
                }
                if (this.fixedDragMeshScreenSize && this.gizmoLayer.utilityLayerScene.activeCamera) {
                    rotateSpheres[index].absolutePosition.subtractToRef(this.gizmoLayer.utilityLayerScene.activeCamera.position, this._tmpVector);
                    const distanceFromCamera = this.rotationSphereSize * this._tmpVector.length() / this.fixedDragMeshScreenSizeDistanceFactor;
                    rotateSpheres[index].scaling.set(distanceFromCamera, distanceFromCamera, distanceFromCamera);
                } else if (this.fixedDragMeshBoundsSize) rotateSpheres[index].scaling.set(this.rotationSphereSize * this._boundingDimensions.x, this.rotationSphereSize * this._boundingDimensions.y, this.rotationSphereSize * this._boundingDimensions.z);
                else rotateSpheres[index].scaling.set(this.rotationSphereSize, this.rotationSphereSize, this.rotationSphereSize);
            }
        }
    }
    _updateScaleBoxes() {
        const scaleBoxes = this._scaleBoxesParent.getChildMeshes();
        let index = 0;
        for(let i = 0; i < 3; i++){
            for(let j = 0; j < 3; j++)for(let k = 0; k < 3; k++){
                const zeroAxisCount = (i === 1 ? 1 : 0) + (j === 1 ? 1 : 0) + (k === 1 ? 1 : 0);
                if (zeroAxisCount === 1 || zeroAxisCount === 3) continue;
                if (scaleBoxes[index]) {
                    scaleBoxes[index].position.set(this._boundingDimensions.x * (i / 2), this._boundingDimensions.y * (j / 2), this._boundingDimensions.z * (k / 2));
                    scaleBoxes[index].position.addInPlace(new (0, $ha1VO.Vector3)(-this._boundingDimensions.x / 2, -this._boundingDimensions.y / 2, -this._boundingDimensions.z / 2));
                    if (this.fixedDragMeshScreenSize && this.gizmoLayer.utilityLayerScene.activeCamera) {
                        scaleBoxes[index].absolutePosition.subtractToRef(this.gizmoLayer.utilityLayerScene.activeCamera.globalPosition, this._tmpVector);
                        const distanceFromCamera = this.scaleBoxSize * this._tmpVector.length() / this.fixedDragMeshScreenSizeDistanceFactor;
                        scaleBoxes[index].scaling.set(distanceFromCamera, distanceFromCamera, distanceFromCamera);
                    } else if (this.fixedDragMeshBoundsSize) scaleBoxes[index].scaling.set(this.scaleBoxSize * this._boundingDimensions.x, this.scaleBoxSize * this._boundingDimensions.y, this.scaleBoxSize * this._boundingDimensions.z);
                    else scaleBoxes[index].scaling.set(this.scaleBoxSize, this.scaleBoxSize, this.scaleBoxSize);
                }
                index++;
            }
        }
    }
    /**
     * Enables rotation on the specified axis and disables rotation on the others
     * @param axis The list of axis that should be enabled (eg. "xy" or "xyz")
     */ setEnabledRotationAxis(axis) {
        this._rotateSpheresParent.getChildMeshes().forEach((m, i)=>{
            if (i < 4) m.setEnabled(axis.indexOf("x") != -1);
            else if (i < 8) m.setEnabled(axis.indexOf("y") != -1);
            else m.setEnabled(axis.indexOf("z") != -1);
        });
    }
    /**
     * Enables/disables scaling
     * @param enable if scaling should be enabled
     * @param homogeneousScaling defines if scaling should only be homogeneous
     */ setEnabledScaling(enable, homogeneousScaling = false) {
        this._scaleBoxesParent.getChildMeshes().forEach((m)=>{
            let enableMesh = enable;
            // Disable heterogeneous scale handles if requested.
            if (homogeneousScaling && m._internalMetadata === true) enableMesh = false;
            m.setEnabled(enableMesh);
        });
    }
    _updateDummy() {
        if (this._dragMesh) {
            this._dragMesh.position.copyFrom(this._lineBoundingBox.getAbsolutePosition());
            this._dragMesh.scaling.copyFrom(this._lineBoundingBox.scaling);
            this._dragMesh.rotationQuaternion.copyFrom(this._rootMesh.rotationQuaternion);
        }
    }
    /**
     * Enables a pointer drag behavior on the bounding box of the gizmo
     */ enableDragBehavior() {
        this._dragMesh = (0, $4C7Qm.CreateBox)("dummy", {
            size: 1
        }, this.gizmoLayer.utilityLayerScene);
        this._dragMesh.visibility = 0;
        this._dragMesh.rotationQuaternion = new (0, $ha1VO.Quaternion)();
        this._pointerDragBehavior.useObjectOrientationForDragging = false;
        this._dragMesh.addBehavior(this._pointerDragBehavior);
    }
    /**
     * Force release the drag action by code
     */ releaseDrag() {
        this._scaleBoxesDragBehavior.releaseDrag();
        this._rotateSpheresDragBehavior.releaseDrag();
        this._pointerDragBehavior.releaseDrag();
    }
    /**
     * Disposes of the gizmo
     */ dispose() {
        this.gizmoLayer.utilityLayerScene.onPointerObservable.remove(this._pointerObserver);
        this.gizmoLayer.originalScene.onBeforeRenderObservable.remove(this._renderObserver);
        this._lineBoundingBox.dispose();
        this._rotateSpheresParent.dispose();
        this._scaleBoxesParent.dispose();
        if (this._dragMesh) this._dragMesh.dispose();
        super.dispose();
    }
    /**
     * Makes a mesh not pickable and wraps the mesh inside of a bounding box mesh that is pickable. (This is useful to avoid picking within complex geometry)
     * @param mesh the mesh to wrap in the bounding box mesh and make not pickable
     * @returns the bounding box mesh with the passed in mesh as a child
     */ static MakeNotPickableAndWrapInBoundingBox(mesh) {
        const makeNotPickable = (root)=>{
            root.isPickable = false;
            root.getChildMeshes().forEach((c)=>{
                makeNotPickable(c);
            });
        };
        makeNotPickable(mesh);
        // Reset position to get bounding box from origin with no rotation
        if (!mesh.rotationQuaternion) mesh.rotationQuaternion = (0, $ha1VO.Quaternion).RotationYawPitchRoll(mesh.rotation.y, mesh.rotation.x, mesh.rotation.z);
        const oldPos = mesh.position.clone();
        const oldRot = mesh.rotationQuaternion.clone();
        mesh.rotationQuaternion.set(0, 0, 0, 1);
        mesh.position.set(0, 0, 0);
        // Update bounding dimensions/positions
        const box = (0, $4C7Qm.CreateBox)("box", {
            size: 1
        }, mesh.getScene());
        const boundingMinMax = mesh.getHierarchyBoundingVectors();
        boundingMinMax.max.subtractToRef(boundingMinMax.min, box.scaling);
        // Adjust scale to avoid undefined behavior when adding child
        if (box.scaling.y === 0) box.scaling.y = (0, $53VPf.Epsilon);
        if (box.scaling.x === 0) box.scaling.x = (0, $53VPf.Epsilon);
        if (box.scaling.z === 0) box.scaling.z = (0, $53VPf.Epsilon);
        box.position.set((boundingMinMax.max.x + boundingMinMax.min.x) / 2, (boundingMinMax.max.y + boundingMinMax.min.y) / 2, (boundingMinMax.max.z + boundingMinMax.min.z) / 2);
        // Restore original positions
        mesh.addChild(box);
        mesh.rotationQuaternion.copyFrom(oldRot);
        mesh.position.copyFrom(oldPos);
        // Reverse parenting
        mesh.removeChild(box);
        box.addChild(mesh);
        box.visibility = 0;
        return box;
    }
    /**
     * CustomMeshes are not supported by this gizmo
     */ setCustomMesh() {
        (0, $kVtWi.Logger).Error("Custom meshes are not supported on this gizmo");
    }
}

});

parcelRegister("6e5Zp", function(module, exports) {

$parcel$export(module.exports, "GizmoManager", () => $4888b23e973b02c6$export$f5253e8b26f6ffac);

var $diGQf = parcelRequire("diGQf");

var $cfkw4 = parcelRequire("cfkw4");

var $0cHNL = parcelRequire("0cHNL");

var $6mCYU = parcelRequire("6mCYU");

var $7etnY = parcelRequire("7etnY");

var $bJA9r = parcelRequire("bJA9r");

var $5ETkU = parcelRequire("5ETkU");

var $i5hok = parcelRequire("i5hok");

var $dKyhl = parcelRequire("dKyhl");

var $77AGr = parcelRequire("77AGr");

var $27QWx = parcelRequire("27QWx");
class $4888b23e973b02c6$export$f5253e8b26f6ffac {
    /**
     * Utility layer that the bounding box gizmo belongs to
     */ get keepDepthUtilityLayer() {
        return this._defaultKeepDepthUtilityLayer;
    }
    /**
     * Utility layer that all gizmos besides bounding box belong to
     */ get utilityLayer() {
        return this._defaultUtilityLayer;
    }
    /**
     * True when the mouse pointer is hovering a gizmo mesh
     */ get isHovered() {
        let hovered = false;
        for(const key in this.gizmos){
            const gizmo = this.gizmos[key];
            if (gizmo && gizmo.isHovered) {
                hovered = true;
                break;
            }
        }
        return hovered;
    }
    /**
     * True when the mouse pointer is dragging a gizmo mesh
     */ get isDragging() {
        let dragging = false;
        [
            this.gizmos.positionGizmo,
            this.gizmos.rotationGizmo,
            this.gizmos.scaleGizmo,
            this.gizmos.boundingBoxGizmo
        ].forEach((gizmo)=>{
            if (gizmo && gizmo.isDragging) dragging = true;
        });
        return dragging;
    }
    /**
     * Ratio for the scale of the gizmo (Default: 1)
     */ set scaleRatio(value) {
        this._scaleRatio = value;
        [
            this.gizmos.positionGizmo,
            this.gizmos.rotationGizmo,
            this.gizmos.scaleGizmo
        ].forEach((gizmo)=>{
            if (gizmo) gizmo.scaleRatio = value;
        });
    }
    get scaleRatio() {
        return this._scaleRatio;
    }
    /**
     * Set the coordinate system to use. By default it's local.
     * But it's possible for a user to tweak so its local for translation and world for rotation.
     * In that case, setting the coordinate system will change `updateGizmoRotationToMatchAttachedMesh` and `updateGizmoPositionToMatchAttachedMesh`
     */ set coordinatesMode(coordinatesMode) {
        this._coordinatesMode = coordinatesMode;
        [
            this.gizmos.positionGizmo,
            this.gizmos.rotationGizmo,
            this.gizmos.scaleGizmo
        ].forEach((gizmo)=>{
            if (gizmo) gizmo.coordinatesMode = coordinatesMode;
        });
    }
    get coordinatesMode() {
        return this._coordinatesMode;
    }
    /**
     * The mesh the gizmo's is attached to
     */ get attachedMesh() {
        return this._attachedMesh;
    }
    /**
     * The node the gizmo's is attached to
     */ get attachedNode() {
        return this._attachedNode;
    }
    /**
     * Additional transform node that will be used to transform all the gizmos
     */ get additionalTransformNode() {
        return this._additionalTransformNode;
    }
    /**
     * Instantiates a gizmo manager
     * @param _scene the scene to overlay the gizmos on top of
     * @param thickness display gizmo axis thickness
     * @param utilityLayer the layer where gizmos are rendered
     * @param keepDepthUtilityLayer the layer where occluded gizmos are rendered
     */ constructor(_scene, thickness = 1, utilityLayer = (0, $6mCYU.UtilityLayerRenderer).DefaultUtilityLayer, keepDepthUtilityLayer = (0, $6mCYU.UtilityLayerRenderer).DefaultKeepDepthUtilityLayer){
        this._scene = _scene;
        /** When true, the gizmo will be detached from the current object when a pointer down occurs with an empty picked mesh */ this.clearGizmoOnEmptyPointerEvent = false;
        /** When true (default), picking to attach a new mesh is enabled. This works in sync with inspector autopicking. */ this.enableAutoPicking = true;
        /** Fires an event when the manager is attached to a mesh */ this.onAttachedToMeshObservable = new (0, $diGQf.Observable)();
        /** Fires an event when the manager is attached to a node */ this.onAttachedToNodeObservable = new (0, $diGQf.Observable)();
        this._gizmosEnabled = {
            positionGizmo: false,
            rotationGizmo: false,
            scaleGizmo: false,
            boundingBoxGizmo: false
        };
        this._pointerObservers = [];
        this._attachedMesh = null;
        this._attachedNode = null;
        this._boundingBoxColor = (0, $7etnY.Color3).FromHexString("#0984e3");
        this._thickness = 1;
        this._scaleRatio = 1;
        this._coordinatesMode = (0, $5ETkU.GizmoCoordinatesMode).Local;
        /** Node Caching for quick lookup */ this._gizmoAxisCache = new Map();
        /**
         * When bounding box gizmo is enabled, this can be used to track drag/end events
         */ this.boundingBoxDragBehavior = new (0, $bJA9r.SixDofDragBehavior)();
        /**
         * Array of meshes which will have the gizmo attached when a pointer selected them. If null, all meshes are attachable. (Default: null)
         */ this.attachableMeshes = null;
        /**
         * Array of nodes which will have the gizmo attached when a pointer selected them. If null, all nodes are attachable. (Default: null)
         */ this.attachableNodes = null;
        /**
         * If pointer events should perform attaching/detaching a gizmo, if false this can be done manually via attachToMesh/attachToNode. (Default: true)
         */ this.usePointerToAttachGizmos = true;
        this._defaultUtilityLayer = utilityLayer;
        this._defaultKeepDepthUtilityLayer = keepDepthUtilityLayer;
        this._defaultKeepDepthUtilityLayer.utilityLayerScene.autoClearDepthAndStencil = false;
        this._thickness = thickness;
        this.gizmos = {
            positionGizmo: null,
            rotationGizmo: null,
            scaleGizmo: null,
            boundingBoxGizmo: null
        };
        const attachToMeshPointerObserver = this._attachToMeshPointerObserver(_scene);
        const gizmoAxisPointerObserver = (0, $5ETkU.Gizmo).GizmoAxisPointerObserver(this._defaultUtilityLayer, this._gizmoAxisCache);
        this._pointerObservers = [
            attachToMeshPointerObserver,
            gizmoAxisPointerObserver
        ];
    }
    /**
     * @internal
     * Subscribes to pointer down events, for attaching and detaching mesh
     * @param scene The scene layer the observer will be added to
     * @returns the pointer observer
     */ _attachToMeshPointerObserver(scene) {
        // Instantiate/dispose gizmos based on pointer actions
        const pointerObserver = scene.onPointerObservable.add((pointerInfo)=>{
            if (!this.usePointerToAttachGizmos) return;
            if (pointerInfo.type == (0, $cfkw4.PointerEventTypes).POINTERDOWN) {
                if (pointerInfo.pickInfo && pointerInfo.pickInfo.pickedMesh) {
                    if (this.enableAutoPicking) {
                        let node = pointerInfo.pickInfo.pickedMesh;
                        if (this.attachableMeshes == null) // Attach to the most parent node
                        while(node && node.parent != null)node = node.parent;
                        else {
                            // Attach to the parent node that is an attachableMesh
                            let found = false;
                            this.attachableMeshes.forEach((mesh)=>{
                                if (node && (node == mesh || node.isDescendantOf(mesh))) {
                                    node = mesh;
                                    found = true;
                                }
                            });
                            if (!found) node = null;
                        }
                        if (node instanceof (0, $0cHNL.AbstractMesh)) {
                            if (this._attachedMesh != node) this.attachToMesh(node);
                        } else if (this.clearGizmoOnEmptyPointerEvent) this.attachToMesh(null);
                    }
                } else if (this.clearGizmoOnEmptyPointerEvent) this.attachToMesh(null);
            }
        });
        return pointerObserver;
    }
    /**
     * Attaches a set of gizmos to the specified mesh
     * @param mesh The mesh the gizmo's should be attached to
     */ attachToMesh(mesh) {
        if (this._attachedMesh) this._attachedMesh.removeBehavior(this.boundingBoxDragBehavior);
        if (this._attachedNode) this._attachedNode.removeBehavior(this.boundingBoxDragBehavior);
        this._attachedMesh = mesh;
        this._attachedNode = null;
        for(const key in this.gizmos){
            const gizmo = this.gizmos[key];
            if (gizmo && this._gizmosEnabled[key]) gizmo.attachedMesh = mesh;
        }
        if (this.boundingBoxGizmoEnabled && this._attachedMesh) this._attachedMesh.addBehavior(this.boundingBoxDragBehavior);
        this.onAttachedToMeshObservable.notifyObservers(mesh);
    }
    /**
     * Attaches a set of gizmos to the specified node
     * @param node The node the gizmo's should be attached to
     */ attachToNode(node) {
        if (this._attachedMesh) this._attachedMesh.removeBehavior(this.boundingBoxDragBehavior);
        if (this._attachedNode) this._attachedNode.removeBehavior(this.boundingBoxDragBehavior);
        this._attachedMesh = null;
        this._attachedNode = node;
        for(const key in this.gizmos){
            const gizmo = this.gizmos[key];
            if (gizmo && this._gizmosEnabled[key]) gizmo.attachedNode = node;
        }
        if (this.boundingBoxGizmoEnabled && this._attachedNode) this._attachedNode.addBehavior(this.boundingBoxDragBehavior);
        this.onAttachedToNodeObservable.notifyObservers(node);
    }
    /**
     * If the position gizmo is enabled
     */ set positionGizmoEnabled(value) {
        if (value) {
            if (!this.gizmos.positionGizmo) this.gizmos.positionGizmo = new (0, $dKyhl.PositionGizmo)(this._defaultUtilityLayer, this._thickness, this);
            if (this._attachedNode) this.gizmos.positionGizmo.attachedNode = this._attachedNode;
            else this.gizmos.positionGizmo.attachedMesh = this._attachedMesh;
        } else if (this.gizmos.positionGizmo) this.gizmos.positionGizmo.attachedNode = null;
        this._gizmosEnabled.positionGizmo = value;
        this._setAdditionalTransformNode();
    }
    get positionGizmoEnabled() {
        return this._gizmosEnabled.positionGizmo;
    }
    /**
     * If the rotation gizmo is enabled
     */ set rotationGizmoEnabled(value) {
        if (value) {
            if (!this.gizmos.rotationGizmo) this.gizmos.rotationGizmo = new (0, $i5hok.RotationGizmo)(this._defaultUtilityLayer, 32, false, this._thickness, this);
            if (this._attachedNode) this.gizmos.rotationGizmo.attachedNode = this._attachedNode;
            else this.gizmos.rotationGizmo.attachedMesh = this._attachedMesh;
        } else if (this.gizmos.rotationGizmo) this.gizmos.rotationGizmo.attachedNode = null;
        this._gizmosEnabled.rotationGizmo = value;
        this._setAdditionalTransformNode();
    }
    get rotationGizmoEnabled() {
        return this._gizmosEnabled.rotationGizmo;
    }
    /**
     * If the scale gizmo is enabled
     */ set scaleGizmoEnabled(value) {
        if (value) {
            this.gizmos.scaleGizmo = this.gizmos.scaleGizmo || new (0, $77AGr.ScaleGizmo)(this._defaultUtilityLayer, this._thickness, this);
            if (this._attachedNode) this.gizmos.scaleGizmo.attachedNode = this._attachedNode;
            else this.gizmos.scaleGizmo.attachedMesh = this._attachedMesh;
        } else if (this.gizmos.scaleGizmo) this.gizmos.scaleGizmo.attachedNode = null;
        this._gizmosEnabled.scaleGizmo = value;
        this._setAdditionalTransformNode();
    }
    get scaleGizmoEnabled() {
        return this._gizmosEnabled.scaleGizmo;
    }
    /**
     * If the boundingBox gizmo is enabled
     */ set boundingBoxGizmoEnabled(value) {
        if (value) {
            this.gizmos.boundingBoxGizmo = this.gizmos.boundingBoxGizmo || new (0, $27QWx.BoundingBoxGizmo)(this._boundingBoxColor, this._defaultKeepDepthUtilityLayer);
            if (this._attachedMesh) this.gizmos.boundingBoxGizmo.attachedMesh = this._attachedMesh;
            else this.gizmos.boundingBoxGizmo.attachedNode = this._attachedNode;
            if (this._attachedMesh) {
                this._attachedMesh.removeBehavior(this.boundingBoxDragBehavior);
                this._attachedMesh.addBehavior(this.boundingBoxDragBehavior);
            } else if (this._attachedNode) {
                this._attachedNode.removeBehavior(this.boundingBoxDragBehavior);
                this._attachedNode.addBehavior(this.boundingBoxDragBehavior);
            }
        } else if (this.gizmos.boundingBoxGizmo) {
            if (this._attachedMesh) this._attachedMesh.removeBehavior(this.boundingBoxDragBehavior);
            else if (this._attachedNode) this._attachedNode.removeBehavior(this.boundingBoxDragBehavior);
            this.gizmos.boundingBoxGizmo.attachedNode = null;
        }
        this._gizmosEnabled.boundingBoxGizmo = value;
        this._setAdditionalTransformNode();
    }
    get boundingBoxGizmoEnabled() {
        return this._gizmosEnabled.boundingBoxGizmo;
    }
    /**
     * Sets the additional transform applied to all the gizmos.
     * @See Gizmo.additionalTransformNode for more detail
     */ set additionalTransformNode(node) {
        this._additionalTransformNode = node;
        this._setAdditionalTransformNode();
    }
    _setAdditionalTransformNode() {
        for(const key in this.gizmos){
            const gizmo = this.gizmos[key];
            if (gizmo && this._gizmosEnabled[key]) gizmo.additionalTransformNode = this._additionalTransformNode;
        }
    }
    /**
     * Builds Gizmo Axis Cache to enable features such as hover state preservation and graying out other axis during manipulation
     * @param gizmoAxisCache Gizmo axis definition used for reactive gizmo UI
     */ addToAxisCache(gizmoAxisCache) {
        if (gizmoAxisCache.size > 0) gizmoAxisCache.forEach((v, k)=>{
            this._gizmoAxisCache.set(k, v);
        });
    }
    /**
     * Force release the drag action by code
     */ releaseDrag() {
        [
            this.gizmos.positionGizmo,
            this.gizmos.rotationGizmo,
            this.gizmos.scaleGizmo,
            this.gizmos.boundingBoxGizmo
        ].forEach((gizmo)=>{
            gizmo?.releaseDrag();
        });
    }
    /**
     * Disposes of the gizmo manager
     */ dispose() {
        this._pointerObservers.forEach((observer)=>{
            this._scene.onPointerObservable.remove(observer);
        });
        for(const key in this.gizmos){
            const gizmo = this.gizmos[key];
            if (gizmo) gizmo.dispose();
        }
        if (this._defaultKeepDepthUtilityLayer !== (0, $6mCYU.UtilityLayerRenderer)._DefaultKeepDepthUtilityLayer) this._defaultKeepDepthUtilityLayer?.dispose();
        if (this._defaultUtilityLayer !== (0, $6mCYU.UtilityLayerRenderer)._DefaultUtilityLayer) this._defaultUtilityLayer?.dispose();
        this.boundingBoxDragBehavior.detach();
        this.onAttachedToMeshObservable.clear();
    }
}

});
parcelRegister("i5hok", function(module, exports) {

$parcel$export(module.exports, "RotationGizmo", () => $d2a62f2e4d91653b$export$a6242646e3a2cb82);

var $kVtWi = parcelRequire("kVtWi");

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $5ETkU = parcelRequire("5ETkU");

var $8Fr9l = parcelRequire("8Fr9l");

var $6mCYU = parcelRequire("6mCYU");
class $d2a62f2e4d91653b$export$a6242646e3a2cb82 extends (0, $5ETkU.Gizmo) {
    get attachedMesh() {
        return this._meshAttached;
    }
    set attachedMesh(mesh) {
        this._meshAttached = mesh;
        this._nodeAttached = mesh;
        this._checkBillboardTransform();
        [
            this.xGizmo,
            this.yGizmo,
            this.zGizmo
        ].forEach((gizmo)=>{
            if (gizmo.isEnabled) gizmo.attachedMesh = mesh;
            else gizmo.attachedMesh = null;
        });
    }
    get attachedNode() {
        return this._nodeAttached;
    }
    set attachedNode(node) {
        this._meshAttached = null;
        this._nodeAttached = node;
        this._checkBillboardTransform();
        [
            this.xGizmo,
            this.yGizmo,
            this.zGizmo
        ].forEach((gizmo)=>{
            if (gizmo.isEnabled) gizmo.attachedNode = node;
            else gizmo.attachedNode = null;
        });
    }
    _checkBillboardTransform() {
        if (this._nodeAttached && this._nodeAttached.billboardMode) (0, $kVtWi.Logger).Log("Rotation Gizmo will not work with transforms in billboard mode.");
    }
    /**
     * Sensitivity factor for dragging (Default: 1)
     */ set sensitivity(value) {
        this._sensitivity = value;
        [
            this.xGizmo,
            this.yGizmo,
            this.zGizmo
        ].forEach((gizmo)=>{
            if (gizmo) gizmo.sensitivity = value;
        });
    }
    get sensitivity() {
        return this._sensitivity;
    }
    /**
     * True when the mouse pointer is hovering a gizmo mesh
     */ get isHovered() {
        return this.xGizmo.isHovered || this.yGizmo.isHovered || this.zGizmo.isHovered;
    }
    /**
     * True when the mouse pointer is dragging a gizmo mesh
     */ get isDragging() {
        return this.xGizmo.dragBehavior.dragging || this.yGizmo.dragBehavior.dragging || this.zGizmo.dragBehavior.dragging;
    }
    get additionalTransformNode() {
        return this._additionalTransformNode;
    }
    set additionalTransformNode(transformNode) {
        [
            this.xGizmo,
            this.yGizmo,
            this.zGizmo
        ].forEach((gizmo)=>{
            gizmo.additionalTransformNode = transformNode;
        });
    }
    /**
     * Creates a RotationGizmo
     * @param gizmoLayer The utility layer the gizmo will be added to
     * @param tessellation Amount of tessellation to be used when creating rotation circles
     * @param useEulerRotation Use and update Euler angle instead of quaternion
     * @param thickness display gizmo axis thickness
     * @param gizmoManager Gizmo manager
     * @param options More options
     */ constructor(gizmoLayer = (0, $6mCYU.UtilityLayerRenderer).DefaultUtilityLayer, tessellation = 32, useEulerRotation = false, thickness = 1, gizmoManager, options){
        super(gizmoLayer);
        /** Fires an event when any of it's sub gizmos are dragged */ this.onDragStartObservable = new (0, $diGQf.Observable)();
        /** Fires an event when any of it's sub gizmos are being dragged */ this.onDragObservable = new (0, $diGQf.Observable)();
        /** Fires an event when any of it's sub gizmos are released from dragging */ this.onDragEndObservable = new (0, $diGQf.Observable)();
        this._observables = [];
        this._sensitivity = 1;
        /** Node Caching for quick lookup */ this._gizmoAxisCache = new Map();
        const xColor = options && options.xOptions && options.xOptions.color ? options.xOptions.color : (0, $7etnY.Color3).Red().scale(0.5);
        const yColor = options && options.yOptions && options.yOptions.color ? options.yOptions.color : (0, $7etnY.Color3).Green().scale(0.5);
        const zColor = options && options.zOptions && options.zOptions.color ? options.zOptions.color : (0, $7etnY.Color3).Blue().scale(0.5);
        this.xGizmo = new (0, $8Fr9l.PlaneRotationGizmo)(new (0, $ha1VO.Vector3)(1, 0, 0), xColor, gizmoLayer, tessellation, this, useEulerRotation, thickness);
        this.yGizmo = new (0, $8Fr9l.PlaneRotationGizmo)(new (0, $ha1VO.Vector3)(0, 1, 0), yColor, gizmoLayer, tessellation, this, useEulerRotation, thickness);
        this.zGizmo = new (0, $8Fr9l.PlaneRotationGizmo)(new (0, $ha1VO.Vector3)(0, 0, 1), zColor, gizmoLayer, tessellation, this, useEulerRotation, thickness);
        this.additionalTransformNode = options?.additionalTransformNode;
        // Relay drag events and set update scale
        [
            this.xGizmo,
            this.yGizmo,
            this.zGizmo
        ].forEach((gizmo)=>{
            //must set updateScale on each gizmo, as setting it on root RotationGizmo doesnt prevent individual gizmos from updating
            //currently updateScale is a property with no getter/setter, so no good way to override behavior at runtime, so we will at least set it on startup
            if (options && options.updateScale != undefined) gizmo.updateScale = options.updateScale;
            gizmo.dragBehavior.onDragStartObservable.add(()=>{
                this.onDragStartObservable.notifyObservers({});
            });
            gizmo.dragBehavior.onDragObservable.add(()=>{
                this.onDragObservable.notifyObservers({});
            });
            gizmo.dragBehavior.onDragEndObservable.add(()=>{
                this.onDragEndObservable.notifyObservers({});
            });
        });
        this.attachedMesh = null;
        this.attachedNode = null;
        if (gizmoManager) gizmoManager.addToAxisCache(this._gizmoAxisCache);
        else // Only subscribe to pointer event if gizmoManager isnt
        (0, $5ETkU.Gizmo).GizmoAxisPointerObserver(gizmoLayer, this._gizmoAxisCache);
    }
    /**
     * If set the gizmo's rotation will be updated to match the attached mesh each frame (Default: true)
     * NOTE: This is only possible for meshes with uniform scaling, as otherwise it's not possible to decompose the rotation
     */ set updateGizmoRotationToMatchAttachedMesh(value) {
        if (this.xGizmo) {
            this.xGizmo.updateGizmoRotationToMatchAttachedMesh = value;
            this.yGizmo.updateGizmoRotationToMatchAttachedMesh = value;
            this.zGizmo.updateGizmoRotationToMatchAttachedMesh = value;
        }
    }
    get updateGizmoRotationToMatchAttachedMesh() {
        return this.xGizmo.updateGizmoRotationToMatchAttachedMesh;
    }
    set updateGizmoPositionToMatchAttachedMesh(value) {
        if (this.xGizmo) {
            this.xGizmo.updateGizmoPositionToMatchAttachedMesh = value;
            this.yGizmo.updateGizmoPositionToMatchAttachedMesh = value;
            this.zGizmo.updateGizmoPositionToMatchAttachedMesh = value;
        }
    }
    get updateGizmoPositionToMatchAttachedMesh() {
        return this.xGizmo.updateGizmoPositionToMatchAttachedMesh;
    }
    set anchorPoint(value) {
        this._anchorPoint = value;
        [
            this.xGizmo,
            this.yGizmo,
            this.zGizmo
        ].forEach((gizmo)=>{
            gizmo.anchorPoint = value;
        });
    }
    get anchorPoint() {
        return this._anchorPoint;
    }
    /**
     * Set the coordinate system to use. By default it's local.
     * But it's possible for a user to tweak so its local for translation and world for rotation.
     * In that case, setting the coordinate system will change `updateGizmoRotationToMatchAttachedMesh` and `updateGizmoPositionToMatchAttachedMesh`
     */ set coordinatesMode(coordinatesMode) {
        [
            this.xGizmo,
            this.yGizmo,
            this.zGizmo
        ].forEach((gizmo)=>{
            gizmo.coordinatesMode = coordinatesMode;
        });
    }
    set updateScale(value) {
        if (this.xGizmo) {
            this.xGizmo.updateScale = value;
            this.yGizmo.updateScale = value;
            this.zGizmo.updateScale = value;
        }
    }
    get updateScale() {
        return this.xGizmo.updateScale;
    }
    /**
     * Drag distance in babylon units that the gizmo will snap to when dragged (Default: 0)
     */ set snapDistance(value) {
        if (this.xGizmo) {
            this.xGizmo.snapDistance = value;
            this.yGizmo.snapDistance = value;
            this.zGizmo.snapDistance = value;
        }
    }
    get snapDistance() {
        return this.xGizmo.snapDistance;
    }
    /**
     * Ratio for the scale of the gizmo (Default: 1)
     */ set scaleRatio(value) {
        if (this.xGizmo) {
            this.xGizmo.scaleRatio = value;
            this.yGizmo.scaleRatio = value;
            this.zGizmo.scaleRatio = value;
        }
    }
    get scaleRatio() {
        return this.xGizmo.scaleRatio;
    }
    /**
     * posture that the gizmo will be display
     * When set null, default value will be used (Quaternion(0, 0, 0, 1))
     */ get customRotationQuaternion() {
        return this._customRotationQuaternion;
    }
    set customRotationQuaternion(customRotationQuaternion) {
        this._customRotationQuaternion = customRotationQuaternion;
        [
            this.xGizmo,
            this.yGizmo,
            this.zGizmo
        ].forEach((gizmo)=>{
            if (gizmo) gizmo.customRotationQuaternion = customRotationQuaternion;
        });
    }
    /**
     * Builds Gizmo Axis Cache to enable features such as hover state preservation and graying out other axis during manipulation
     * @param mesh Axis gizmo mesh
     * @param cache Gizmo axis definition used for reactive gizmo UI
     */ addToAxisCache(mesh, cache) {
        this._gizmoAxisCache.set(mesh, cache);
    }
    /**
     * Force release the drag action by code
     */ releaseDrag() {
        this.xGizmo.dragBehavior.releaseDrag();
        this.yGizmo.dragBehavior.releaseDrag();
        this.zGizmo.dragBehavior.releaseDrag();
    }
    /**
     * Disposes of the gizmo
     */ dispose() {
        this.xGizmo.dispose();
        this.yGizmo.dispose();
        this.zGizmo.dispose();
        this.onDragStartObservable.clear();
        this.onDragObservable.clear();
        this.onDragEndObservable.clear();
        this._observables.forEach((obs)=>{
            this.gizmoLayer.utilityLayerScene.onPointerObservable.remove(obs);
        });
    }
    /**
     * CustomMeshes are not supported by this gizmo
     */ setCustomMesh() {
        (0, $kVtWi.Logger).Error("Custom meshes are not supported on this gizmo, please set the custom meshes on the gizmos contained within this one (gizmo.xGizmo, gizmo.yGizmo, gizmo.zGizmo)");
    }
}

});
parcelRegister("8Fr9l", function(module, exports) {

$parcel$export(module.exports, "PlaneRotationGizmo", () => $64f73673d7a967cc$export$10e27475247e8dd3);

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");
parcelRequire("8Eyol");

var $fbuqw = parcelRequire("fbuqw");

var $dnn9Q = parcelRequire("dnn9Q");

var $5ETkU = parcelRequire("5ETkU");

var $6mCYU = parcelRequire("6mCYU");

var $gAH3H = parcelRequire("gAH3H");

var $4I7rl = parcelRequire("4I7rl");

var $lUDWq = parcelRequire("lUDWq");

var $kt6s5 = parcelRequire("kt6s5");

var $bCJrn = parcelRequire("bCJrn");

var $53VPf = parcelRequire("53VPf");

var $kVtWi = parcelRequire("kVtWi");
class $64f73673d7a967cc$export$10e27475247e8dd3 extends (0, $5ETkU.Gizmo) {
    /** Default material used to render when gizmo is not disabled or hovered */ get coloredMaterial() {
        return this._coloredMaterial;
    }
    /** Material used to render when gizmo is hovered with mouse */ get hoverMaterial() {
        return this._hoverMaterial;
    }
    /** Color used to render the drag angle sector when gizmo is rotated with mouse */ set rotationColor(color) {
        this._rotationShaderMaterial.setColor3("rotationColor", color);
    }
    /** Material used to render when gizmo is disabled. typically grey. */ get disableMaterial() {
        return this._disableMaterial;
    }
    /**
     * Creates a PlaneRotationGizmo
     * @param planeNormal The normal of the plane which the gizmo will be able to rotate on
     * @param color The color of the gizmo
     * @param gizmoLayer The utility layer the gizmo will be added to
     * @param tessellation Amount of tessellation to be used when creating rotation circles
     * @param parent
     * @param useEulerRotation Use and update Euler angle instead of quaternion
     * @param thickness display gizmo axis thickness
     * @param hoverColor The color of the gizmo when hovering over and dragging
     * @param disableColor The Color of the gizmo when its disabled
     */ constructor(planeNormal, color = (0, $7etnY.Color3).Gray(), gizmoLayer = (0, $6mCYU.UtilityLayerRenderer).DefaultUtilityLayer, tessellation = 32, parent = null, // eslint-disable-next-line @typescript-eslint/no-unused-vars
    useEulerRotation = false, thickness = 1, hoverColor = (0, $7etnY.Color3).Yellow(), disableColor = (0, $7etnY.Color3).Gray()){
        super(gizmoLayer);
        this._pointerObserver = null;
        /**
         * Rotation distance in radians that the gizmo will snap to (Default: 0)
         */ this.snapDistance = 0;
        /**
         * Event that fires each time the gizmo snaps to a new location.
         * * snapDistance is the change in distance
         */ this.onSnapObservable = new (0, $diGQf.Observable)();
        /**
         * Accumulated relative angle value for rotation on the axis. Reset to 0 when a dragStart occurs
         */ this.angle = 0;
        /**
         * Custom sensitivity value for the drag strength
         */ this.sensitivity = 1;
        this._isEnabled = true;
        this._parent = null;
        this._dragging = false;
        this._angles = new (0, $ha1VO.Vector3)();
        this._parent = parent;
        // Create Material
        this._coloredMaterial = new (0, $gAH3H.StandardMaterial)("", gizmoLayer.utilityLayerScene);
        this._coloredMaterial.diffuseColor = color;
        this._coloredMaterial.specularColor = color.subtract(new (0, $7etnY.Color3)(0.1, 0.1, 0.1));
        this._hoverMaterial = new (0, $gAH3H.StandardMaterial)("", gizmoLayer.utilityLayerScene);
        this._hoverMaterial.diffuseColor = hoverColor;
        this._hoverMaterial.specularColor = hoverColor;
        this._disableMaterial = new (0, $gAH3H.StandardMaterial)("", gizmoLayer.utilityLayerScene);
        this._disableMaterial.diffuseColor = disableColor;
        this._disableMaterial.alpha = 0.4;
        // Build mesh on root node
        this._gizmoMesh = new (0, $fbuqw.Mesh)("", gizmoLayer.utilityLayerScene);
        const { rotationMesh: rotationMesh, collider: collider } = this._createGizmoMesh(this._gizmoMesh, thickness, tessellation);
        // Setup Rotation Circle
        this._rotationDisplayPlane = (0, $kt6s5.CreatePlane)("rotationDisplay", {
            size: 0.6,
            updatable: false
        }, this.gizmoLayer.utilityLayerScene);
        this._rotationDisplayPlane.rotation.z = Math.PI * 0.5;
        this._rotationDisplayPlane.parent = this._gizmoMesh;
        this._rotationDisplayPlane.setEnabled(false);
        (0, $lUDWq.Effect).ShadersStore["rotationGizmoVertexShader"] = $64f73673d7a967cc$export$10e27475247e8dd3._RotationGizmoVertexShader;
        (0, $lUDWq.Effect).ShadersStore["rotationGizmoFragmentShader"] = $64f73673d7a967cc$export$10e27475247e8dd3._RotationGizmoFragmentShader;
        this._rotationShaderMaterial = new (0, $4I7rl.ShaderMaterial)("shader", this.gizmoLayer.utilityLayerScene, {
            vertex: "rotationGizmo",
            fragment: "rotationGizmo"
        }, {
            attributes: [
                "position",
                "uv"
            ],
            uniforms: [
                "worldViewProjection",
                "angles",
                "rotationColor"
            ]
        });
        this._rotationShaderMaterial.backFaceCulling = false;
        this.rotationColor = hoverColor;
        this._rotationDisplayPlane.material = this._rotationShaderMaterial;
        this._rotationDisplayPlane.visibility = 0.999;
        this._gizmoMesh.lookAt(this._rootMesh.position.add(planeNormal));
        this._rootMesh.addChild(this._gizmoMesh, (0, $5ETkU.Gizmo).PreserveScaling);
        this._gizmoMesh.scaling.scaleInPlace(1 / 3);
        // Add drag behavior to handle events when the gizmo is dragged
        this.dragBehavior = new (0, $dnn9Q.PointerDragBehavior)({
            dragPlaneNormal: planeNormal
        });
        this.dragBehavior.moveAttached = false;
        this.dragBehavior.maxDragAngle = $64f73673d7a967cc$export$10e27475247e8dd3.MaxDragAngle;
        this.dragBehavior._useAlternatePickedPointAboveMaxDragAngle = true;
        this._rootMesh.addBehavior(this.dragBehavior);
        // Closures for drag logic
        const lastDragPosition = new (0, $ha1VO.Vector3)();
        const rotationMatrix = new (0, $ha1VO.Matrix)();
        const planeNormalTowardsCamera = new (0, $ha1VO.Vector3)();
        let localPlaneNormalTowardsCamera = new (0, $ha1VO.Vector3)();
        this.dragBehavior.onDragStartObservable.add((e)=>{
            if (this.attachedNode) {
                lastDragPosition.copyFrom(e.dragPlanePoint);
                this._rotationDisplayPlane.setEnabled(true);
                this._rotationDisplayPlane.getWorldMatrix().invertToRef(rotationMatrix);
                (0, $ha1VO.Vector3).TransformCoordinatesToRef(e.dragPlanePoint, rotationMatrix, lastDragPosition);
                this._angles.x = Math.atan2(lastDragPosition.y, lastDragPosition.x) + Math.PI;
                this._angles.y = 0;
                this._angles.z = this.updateGizmoRotationToMatchAttachedMesh ? 1 : 0;
                this._dragging = true;
                lastDragPosition.copyFrom(e.dragPlanePoint);
                this._rotationShaderMaterial.setVector3("angles", this._angles);
                this.angle = 0;
            }
        });
        this.dragBehavior.onDragEndObservable.add(()=>{
            this._dragging = false;
            this._rotationDisplayPlane.setEnabled(false);
        });
        const tmpSnapEvent = {
            snapDistance: 0
        };
        let currentSnapDragDistance = 0;
        const tmpMatrix = new (0, $ha1VO.Matrix)();
        const amountToRotate = new (0, $ha1VO.Quaternion)();
        this.dragBehavior.onDragObservable.add((event)=>{
            if (this.attachedNode) {
                // Calc angle over full 360 degree (https://stackoverflow.com/questions/43493711/the-angle-between-two-3d-vectors-with-a-result-range-0-360)
                const nodeScale = new (0, $ha1VO.Vector3)(1, 1, 1);
                const nodeQuaternion = new (0, $ha1VO.Quaternion)(0, 0, 0, 1);
                const nodeTranslation = new (0, $ha1VO.Vector3)(0, 0, 0);
                this.attachedNode.getWorldMatrix().decompose(nodeScale, nodeQuaternion, nodeTranslation);
                // uniform scaling of absolute value of components
                // (-1,1,1) is uniform but (1,1.001,1) is not
                const uniformScaling = Math.abs(Math.abs(nodeScale.x) - Math.abs(nodeScale.y)) <= (0, $53VPf.Epsilon) && Math.abs(Math.abs(nodeScale.x) - Math.abs(nodeScale.z)) <= (0, $53VPf.Epsilon);
                if (!uniformScaling && this.updateGizmoRotationToMatchAttachedMesh) {
                    (0, $kVtWi.Logger).Warn("Unable to use a rotation gizmo matching mesh rotation with non uniform scaling. Use uniform scaling or set updateGizmoRotationToMatchAttachedMesh to false.");
                    return;
                }
                nodeQuaternion.normalize();
                const nodeTranslationForOperation = this.updateGizmoPositionToMatchAttachedMesh ? nodeTranslation : this._rootMesh.absolutePosition;
                const newVector = event.dragPlanePoint.subtract(nodeTranslationForOperation).normalize();
                const originalVector = lastDragPosition.subtract(nodeTranslationForOperation).normalize();
                const cross = (0, $ha1VO.Vector3).Cross(newVector, originalVector);
                const dot = (0, $ha1VO.Vector3).Dot(newVector, originalVector);
                let angle = Math.atan2(cross.length(), dot) * this.sensitivity;
                planeNormalTowardsCamera.copyFrom(planeNormal);
                localPlaneNormalTowardsCamera.copyFrom(planeNormal);
                if (this.updateGizmoRotationToMatchAttachedMesh) {
                    nodeQuaternion.toRotationMatrix(rotationMatrix);
                    localPlaneNormalTowardsCamera = (0, $ha1VO.Vector3).TransformCoordinates(planeNormalTowardsCamera, rotationMatrix);
                }
                // Flip up vector depending on which side the camera is on
                let cameraFlipped = false;
                if (gizmoLayer.utilityLayerScene.activeCamera) {
                    const camVec = gizmoLayer.utilityLayerScene.activeCamera.position.subtract(nodeTranslationForOperation).normalize();
                    if ((0, $ha1VO.Vector3).Dot(camVec, localPlaneNormalTowardsCamera) > 0) {
                        planeNormalTowardsCamera.scaleInPlace(-1);
                        localPlaneNormalTowardsCamera.scaleInPlace(-1);
                        cameraFlipped = true;
                    }
                }
                const halfCircleSide = (0, $ha1VO.Vector3).Dot(localPlaneNormalTowardsCamera, cross) > 0.0;
                if (halfCircleSide) angle = -angle;
                (0, $ha1VO.TmpVectors).Vector3[0].set(angle, 0, 0);
                if (!this.dragBehavior.validateDrag((0, $ha1VO.TmpVectors).Vector3[0])) angle = 0;
                // Snapping logic
                let snapped = false;
                if (this.snapDistance != 0) {
                    currentSnapDragDistance += angle;
                    if (Math.abs(currentSnapDragDistance) > this.snapDistance) {
                        let dragSteps = Math.floor(Math.abs(currentSnapDragDistance) / this.snapDistance);
                        if (currentSnapDragDistance < 0) dragSteps *= -1;
                        currentSnapDragDistance = currentSnapDragDistance % this.snapDistance;
                        angle = this.snapDistance * dragSteps;
                        snapped = true;
                    } else angle = 0;
                }
                // Convert angle and axis to quaternion (http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm)
                const quaternionCoefficient = Math.sin(angle / 2);
                amountToRotate.set(planeNormalTowardsCamera.x * quaternionCoefficient, planeNormalTowardsCamera.y * quaternionCoefficient, planeNormalTowardsCamera.z * quaternionCoefficient, Math.cos(angle / 2));
                // If the meshes local scale is inverted (eg. loaded gltf file parent with z scale of -1) the rotation needs to be inverted on the y axis
                if (tmpMatrix.determinant() > 0) {
                    const tmpVector = new (0, $ha1VO.Vector3)();
                    amountToRotate.toEulerAnglesToRef(tmpVector);
                    (0, $ha1VO.Quaternion).RotationYawPitchRollToRef(tmpVector.y, -tmpVector.x, -tmpVector.z, amountToRotate);
                }
                if (this.updateGizmoRotationToMatchAttachedMesh) {
                    // Rotate selected mesh quaternion over fixed axis
                    nodeQuaternion.multiplyToRef(amountToRotate, nodeQuaternion);
                    nodeQuaternion.normalize();
                    // recompose matrix
                    (0, $ha1VO.Matrix).ComposeToRef(nodeScale, nodeQuaternion, nodeTranslation, this.attachedNode.getWorldMatrix());
                } else {
                    // Rotate selected mesh quaternion over rotated axis
                    amountToRotate.toRotationMatrix((0, $ha1VO.TmpVectors).Matrix[0]);
                    const translation = this.attachedNode.getWorldMatrix().getTranslation();
                    this.attachedNode.getWorldMatrix().multiplyToRef((0, $ha1VO.TmpVectors).Matrix[0], this.attachedNode.getWorldMatrix());
                    this.attachedNode.getWorldMatrix().setTranslation(translation);
                }
                lastDragPosition.copyFrom(event.dragPlanePoint);
                if (snapped) {
                    tmpSnapEvent.snapDistance = angle;
                    this.onSnapObservable.notifyObservers(tmpSnapEvent);
                }
                this._angles.y += angle;
                this.angle += cameraFlipped ? -angle : angle;
                this._rotationShaderMaterial.setVector3("angles", this._angles);
                this._matrixChanged();
            }
        });
        const light = gizmoLayer._getSharedGizmoLight();
        light.includedOnlyMeshes = light.includedOnlyMeshes.concat(this._rootMesh.getChildMeshes(false));
        const cache = {
            colliderMeshes: [
                collider
            ],
            gizmoMeshes: [
                rotationMesh
            ],
            material: this._coloredMaterial,
            hoverMaterial: this._hoverMaterial,
            disableMaterial: this._disableMaterial,
            active: false,
            dragBehavior: this.dragBehavior
        };
        this._parent?.addToAxisCache(this._gizmoMesh, cache);
        this._pointerObserver = gizmoLayer.utilityLayerScene.onPointerObservable.add((pointerInfo)=>{
            if (this._customMeshSet) return;
            // updating here the maxangle because ondragstart is too late (value already used) and the updated value is not taken into account
            this.dragBehavior.maxDragAngle = $64f73673d7a967cc$export$10e27475247e8dd3.MaxDragAngle;
            this._isHovered = !!(cache.colliderMeshes.indexOf(pointerInfo?.pickInfo?.pickedMesh) != -1);
            if (!this._parent) {
                const material = cache.dragBehavior.enabled ? this._isHovered || this._dragging ? this._hoverMaterial : this._coloredMaterial : this._disableMaterial;
                this._setGizmoMeshMaterial(cache.gizmoMeshes, material);
            }
        });
        this.dragBehavior.onEnabledObservable.add((newState)=>{
            this._setGizmoMeshMaterial(cache.gizmoMeshes, newState ? this._coloredMaterial : this._disableMaterial);
        });
    }
    /**
     * @internal
     * Create Geometry for Gizmo
     * @param parentMesh
     * @param thickness
     * @param tessellation
     * @returns
     */ _createGizmoMesh(parentMesh, thickness, tessellation) {
        const collider = (0, $bCJrn.CreateTorus)("ignore", {
            diameter: 0.6,
            thickness: 0.03 * thickness,
            tessellation: tessellation
        }, this.gizmoLayer.utilityLayerScene);
        collider.visibility = 0;
        const rotationMesh = (0, $bCJrn.CreateTorus)("", {
            diameter: 0.6,
            thickness: 0.005 * thickness,
            tessellation: tessellation
        }, this.gizmoLayer.utilityLayerScene);
        rotationMesh.material = this._coloredMaterial;
        // Position arrow pointing in its drag axis
        rotationMesh.rotation.x = Math.PI / 2;
        collider.rotation.x = Math.PI / 2;
        parentMesh.addChild(rotationMesh, (0, $5ETkU.Gizmo).PreserveScaling);
        parentMesh.addChild(collider, (0, $5ETkU.Gizmo).PreserveScaling);
        return {
            rotationMesh: rotationMesh,
            collider: collider
        };
    }
    _attachedNodeChanged(value) {
        if (this.dragBehavior) this.dragBehavior.enabled = value ? true : false;
    }
    /**
     * If the gizmo is enabled
     */ set isEnabled(value) {
        this._isEnabled = value;
        if (!value) this.attachedMesh = null;
        else if (this._parent) this.attachedMesh = this._parent.attachedMesh;
    }
    get isEnabled() {
        return this._isEnabled;
    }
    /**
     * Disposes of the gizmo
     */ dispose() {
        this.onSnapObservable.clear();
        this.gizmoLayer.utilityLayerScene.onPointerObservable.remove(this._pointerObserver);
        this.dragBehavior.detach();
        if (this._gizmoMesh) this._gizmoMesh.dispose();
        if (this._rotationDisplayPlane) this._rotationDisplayPlane.dispose();
        if (this._rotationShaderMaterial) this._rotationShaderMaterial.dispose();
        [
            this._coloredMaterial,
            this._hoverMaterial,
            this._disableMaterial
        ].forEach((matl)=>{
            if (matl) matl.dispose();
        });
        super.dispose();
    }
}
/**
 * The maximum angle between the camera and the rotation allowed for interaction
 * If a rotation plane appears 'flat', a lower value allows interaction.
 */ $64f73673d7a967cc$export$10e27475247e8dd3.MaxDragAngle = Math.PI * 9 / 20;
$64f73673d7a967cc$export$10e27475247e8dd3._RotationGizmoVertexShader = `
        precision highp float;
        attribute vec3 position;
        attribute vec2 uv;
        uniform mat4 worldViewProjection;
        varying vec3 vPosition;
        varying vec2 vUV;

        void main(void) {
            gl_Position = worldViewProjection * vec4(position, 1.0);
            vUV = uv;
        }`;
$64f73673d7a967cc$export$10e27475247e8dd3._RotationGizmoFragmentShader = `
        precision highp float;
        varying vec2 vUV;
        varying vec3 vPosition;
        uniform vec3 angles;
        uniform vec3 rotationColor;

        #define twopi 6.283185307

        void main(void) {
            vec2 uv = vUV - vec2(0.5);
            float angle = atan(uv.y, uv.x) + 3.141592;
            float delta = gl_FrontFacing ? angles.y : -angles.y;
            float begin = angles.x - delta * angles.z;
            float start = (begin < (begin + delta)) ? begin : (begin + delta);
            float end = (begin > (begin + delta)) ? begin : (begin + delta);
            float len = sqrt(dot(uv,uv));
            float opacity = 1. - step(0.5, len);

            float base = abs(floor(start / twopi)) * twopi;
            start += base;
            end += base;

            float intensity = 0.;
            for (int i = 0; i < 5; i++)
            {
                intensity += max(step(start, angle) - step(end, angle), 0.);
                angle += twopi;
            }
            gl_FragColor = vec4(rotationColor, min(intensity * 0.25, 0.8)) * opacity;
        }
    `;

});


parcelRegister("dKyhl", function(module, exports) {

$parcel$export(module.exports, "PositionGizmo", () => $a02a294999183394$export$255e5477c91356ed);

var $kVtWi = parcelRequire("kVtWi");

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $5ETkU = parcelRequire("5ETkU");

var $iCzFv = parcelRequire("iCzFv");

var $9fO5H = parcelRequire("9fO5H");

var $6mCYU = parcelRequire("6mCYU");
class $a02a294999183394$export$255e5477c91356ed extends (0, $5ETkU.Gizmo) {
    get attachedMesh() {
        return this._meshAttached;
    }
    set attachedMesh(mesh) {
        this._meshAttached = mesh;
        this._nodeAttached = mesh;
        [
            this.xGizmo,
            this.yGizmo,
            this.zGizmo,
            this.xPlaneGizmo,
            this.yPlaneGizmo,
            this.zPlaneGizmo
        ].forEach((gizmo)=>{
            if (gizmo.isEnabled) gizmo.attachedMesh = mesh;
            else gizmo.attachedMesh = null;
        });
    }
    get attachedNode() {
        return this._nodeAttached;
    }
    set attachedNode(node) {
        this._meshAttached = null;
        this._nodeAttached = node;
        [
            this.xGizmo,
            this.yGizmo,
            this.zGizmo,
            this.xPlaneGizmo,
            this.yPlaneGizmo,
            this.zPlaneGizmo
        ].forEach((gizmo)=>{
            if (gizmo.isEnabled) gizmo.attachedNode = node;
            else gizmo.attachedNode = null;
        });
    }
    /**
     * True when the mouse pointer is hovering a gizmo mesh
     */ get isHovered() {
        return this.xGizmo.isHovered || this.yGizmo.isHovered || this.zGizmo.isHovered || this.xPlaneGizmo.isHovered || this.yPlaneGizmo.isHovered || this.zPlaneGizmo.isHovered;
    }
    get isDragging() {
        return this.xGizmo.dragBehavior.dragging || this.yGizmo.dragBehavior.dragging || this.zGizmo.dragBehavior.dragging || this.xPlaneGizmo.dragBehavior.dragging || this.yPlaneGizmo.dragBehavior.dragging || this.zPlaneGizmo.dragBehavior.dragging;
    }
    get additionalTransformNode() {
        return this._additionalTransformNode;
    }
    set additionalTransformNode(transformNode) {
        [
            this.xGizmo,
            this.yGizmo,
            this.zGizmo,
            this.xPlaneGizmo,
            this.yPlaneGizmo,
            this.zPlaneGizmo
        ].forEach((gizmo)=>{
            gizmo.additionalTransformNode = transformNode;
        });
    }
    /**
     * Creates a PositionGizmo
     * @param gizmoLayer The utility layer the gizmo will be added to
     * @param thickness display gizmo axis thickness
     * @param gizmoManager
     * @param options More options
     */ constructor(gizmoLayer = (0, $6mCYU.UtilityLayerRenderer).DefaultUtilityLayer, thickness = 1, gizmoManager, options){
        super(gizmoLayer);
        /**
         * protected variables
         */ this._meshAttached = null;
        this._nodeAttached = null;
        this._observables = [];
        /** Node Caching for quick lookup */ this._gizmoAxisCache = new Map();
        /** Fires an event when any of it's sub gizmos are dragged */ this.onDragStartObservable = new (0, $diGQf.Observable)();
        /** Fires an event when any of it's sub gizmos are being dragged */ this.onDragObservable = new (0, $diGQf.Observable)();
        /** Fires an event when any of it's sub gizmos are released from dragging */ this.onDragEndObservable = new (0, $diGQf.Observable)();
        /**
         * If set to true, planar drag is enabled
         */ this._planarGizmoEnabled = false;
        this.xGizmo = new (0, $iCzFv.AxisDragGizmo)(new (0, $ha1VO.Vector3)(1, 0, 0), (0, $7etnY.Color3).Red().scale(0.5), gizmoLayer, this, thickness);
        this.yGizmo = new (0, $iCzFv.AxisDragGizmo)(new (0, $ha1VO.Vector3)(0, 1, 0), (0, $7etnY.Color3).Green().scale(0.5), gizmoLayer, this, thickness);
        this.zGizmo = new (0, $iCzFv.AxisDragGizmo)(new (0, $ha1VO.Vector3)(0, 0, 1), (0, $7etnY.Color3).Blue().scale(0.5), gizmoLayer, this, thickness);
        this.xPlaneGizmo = new (0, $9fO5H.PlaneDragGizmo)(new (0, $ha1VO.Vector3)(1, 0, 0), (0, $7etnY.Color3).Red().scale(0.5), this.gizmoLayer, this);
        this.yPlaneGizmo = new (0, $9fO5H.PlaneDragGizmo)(new (0, $ha1VO.Vector3)(0, 1, 0), (0, $7etnY.Color3).Green().scale(0.5), this.gizmoLayer, this);
        this.zPlaneGizmo = new (0, $9fO5H.PlaneDragGizmo)(new (0, $ha1VO.Vector3)(0, 0, 1), (0, $7etnY.Color3).Blue().scale(0.5), this.gizmoLayer, this);
        this.additionalTransformNode = options?.additionalTransformNode;
        // Relay drag events
        [
            this.xGizmo,
            this.yGizmo,
            this.zGizmo,
            this.xPlaneGizmo,
            this.yPlaneGizmo,
            this.zPlaneGizmo
        ].forEach((gizmo)=>{
            gizmo.dragBehavior.onDragStartObservable.add(()=>{
                this.onDragStartObservable.notifyObservers({});
            });
            gizmo.dragBehavior.onDragObservable.add(()=>{
                this.onDragObservable.notifyObservers({});
            });
            gizmo.dragBehavior.onDragEndObservable.add(()=>{
                this.onDragEndObservable.notifyObservers({});
            });
        });
        this.attachedMesh = null;
        if (gizmoManager) gizmoManager.addToAxisCache(this._gizmoAxisCache);
        else // Only subscribe to pointer event if gizmoManager isnt
        (0, $5ETkU.Gizmo).GizmoAxisPointerObserver(gizmoLayer, this._gizmoAxisCache);
    }
    /**
     * If the planar drag gizmo is enabled
     * setting this will enable/disable XY, XZ and YZ planes regardless of individual gizmo settings.
     */ set planarGizmoEnabled(value) {
        this._planarGizmoEnabled = value;
        [
            this.xPlaneGizmo,
            this.yPlaneGizmo,
            this.zPlaneGizmo
        ].forEach((gizmo)=>{
            if (gizmo) {
                gizmo.isEnabled = value;
                if (value) {
                    if (gizmo.attachedMesh) gizmo.attachedMesh = this.attachedMesh;
                    else gizmo.attachedNode = this.attachedNode;
                }
            }
        }, this);
    }
    get planarGizmoEnabled() {
        return this._planarGizmoEnabled;
    }
    /**
     * posture that the gizmo will be display
     * When set null, default value will be used (Quaternion(0, 0, 0, 1))
     */ get customRotationQuaternion() {
        return this._customRotationQuaternion;
    }
    set customRotationQuaternion(customRotationQuaternion) {
        this._customRotationQuaternion = customRotationQuaternion;
        [
            this.xGizmo,
            this.yGizmo,
            this.zGizmo,
            this.xPlaneGizmo,
            this.yPlaneGizmo,
            this.zPlaneGizmo
        ].forEach((gizmo)=>{
            if (gizmo) gizmo.customRotationQuaternion = customRotationQuaternion;
        });
    }
    /**
     * If set the gizmo's rotation will be updated to match the attached mesh each frame (Default: true)
     * NOTE: This is only possible for meshes with uniform scaling, as otherwise it's not possible to decompose the rotation
     */ set updateGizmoRotationToMatchAttachedMesh(value) {
        this._updateGizmoRotationToMatchAttachedMesh = value;
        [
            this.xGizmo,
            this.yGizmo,
            this.zGizmo,
            this.xPlaneGizmo,
            this.yPlaneGizmo,
            this.zPlaneGizmo
        ].forEach((gizmo)=>{
            if (gizmo) gizmo.updateGizmoRotationToMatchAttachedMesh = value;
        });
    }
    get updateGizmoRotationToMatchAttachedMesh() {
        return this._updateGizmoRotationToMatchAttachedMesh;
    }
    set updateGizmoPositionToMatchAttachedMesh(value) {
        this._updateGizmoPositionToMatchAttachedMesh = value;
        [
            this.xGizmo,
            this.yGizmo,
            this.zGizmo,
            this.xPlaneGizmo,
            this.yPlaneGizmo,
            this.zPlaneGizmo
        ].forEach((gizmo)=>{
            if (gizmo) gizmo.updateGizmoPositionToMatchAttachedMesh = value;
        });
    }
    get updateGizmoPositionToMatchAttachedMesh() {
        return this._updateGizmoPositionToMatchAttachedMesh;
    }
    set anchorPoint(value) {
        this._anchorPoint = value;
        [
            this.xGizmo,
            this.yGizmo,
            this.zGizmo,
            this.xPlaneGizmo,
            this.yPlaneGizmo,
            this.zPlaneGizmo
        ].forEach((gizmo)=>{
            gizmo.anchorPoint = value;
        });
    }
    get anchorPoint() {
        return this._anchorPoint;
    }
    /**
     * Set the coordinate system to use. By default it's local.
     * But it's possible for a user to tweak so its local for translation and world for rotation.
     * In that case, setting the coordinate system will change `updateGizmoRotationToMatchAttachedMesh` and `updateGizmoPositionToMatchAttachedMesh`
     */ set coordinatesMode(coordinatesMode) {
        [
            this.xGizmo,
            this.yGizmo,
            this.zGizmo,
            this.xPlaneGizmo,
            this.yPlaneGizmo,
            this.zPlaneGizmo
        ].forEach((gizmo)=>{
            gizmo.coordinatesMode = coordinatesMode;
        });
    }
    set updateScale(value) {
        if (this.xGizmo) {
            this.xGizmo.updateScale = value;
            this.yGizmo.updateScale = value;
            this.zGizmo.updateScale = value;
        }
    }
    get updateScale() {
        return this.xGizmo.updateScale;
    }
    /**
     * Drag distance in babylon units that the gizmo will snap to when dragged (Default: 0)
     */ set snapDistance(value) {
        this._snapDistance = value;
        [
            this.xGizmo,
            this.yGizmo,
            this.zGizmo,
            this.xPlaneGizmo,
            this.yPlaneGizmo,
            this.zPlaneGizmo
        ].forEach((gizmo)=>{
            if (gizmo) gizmo.snapDistance = value;
        });
    }
    get snapDistance() {
        return this._snapDistance;
    }
    /**
     * Ratio for the scale of the gizmo (Default: 1)
     */ set scaleRatio(value) {
        this._scaleRatio = value;
        [
            this.xGizmo,
            this.yGizmo,
            this.zGizmo,
            this.xPlaneGizmo,
            this.yPlaneGizmo,
            this.zPlaneGizmo
        ].forEach((gizmo)=>{
            if (gizmo) gizmo.scaleRatio = value;
        });
    }
    get scaleRatio() {
        return this._scaleRatio;
    }
    /**
     * Builds Gizmo Axis Cache to enable features such as hover state preservation and graying out other axis during manipulation
     * @param mesh Axis gizmo mesh
     * @param cache Gizmo axis definition used for reactive gizmo UI
     */ addToAxisCache(mesh, cache) {
        this._gizmoAxisCache.set(mesh, cache);
    }
    /**
     * Force release the drag action by code
     */ releaseDrag() {
        this.xGizmo.dragBehavior.releaseDrag();
        this.yGizmo.dragBehavior.releaseDrag();
        this.zGizmo.dragBehavior.releaseDrag();
        this.xPlaneGizmo.dragBehavior.releaseDrag();
        this.yPlaneGizmo.dragBehavior.releaseDrag();
        this.zPlaneGizmo.dragBehavior.releaseDrag();
    }
    /**
     * Disposes of the gizmo
     */ dispose() {
        [
            this.xGizmo,
            this.yGizmo,
            this.zGizmo,
            this.xPlaneGizmo,
            this.yPlaneGizmo,
            this.zPlaneGizmo
        ].forEach((gizmo)=>{
            if (gizmo) gizmo.dispose();
        });
        this._observables.forEach((obs)=>{
            this.gizmoLayer.utilityLayerScene.onPointerObservable.remove(obs);
        });
        this.onDragStartObservable.clear();
        this.onDragObservable.clear();
        this.onDragEndObservable.clear();
    }
    /**
     * CustomMeshes are not supported by this gizmo
     */ setCustomMesh() {
        (0, $kVtWi.Logger).Error("Custom meshes are not supported on this gizmo, please set the custom meshes on the gizmos contained within this one (gizmo.xGizmo, gizmo.yGizmo, gizmo.zGizmo,gizmo.xPlaneGizmo, gizmo.yPlaneGizmo, gizmo.zPlaneGizmo)");
    }
}

});
parcelRegister("9fO5H", function(module, exports) {

$parcel$export(module.exports, "PlaneDragGizmo", () => $6bcc5ec48d04a329$export$b4543cd210a30a75);

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $klshO = parcelRequire("klshO");

var $kt6s5 = parcelRequire("kt6s5");

var $dnn9Q = parcelRequire("dnn9Q");

var $5ETkU = parcelRequire("5ETkU");

var $6mCYU = parcelRequire("6mCYU");

var $gAH3H = parcelRequire("gAH3H");
class $6bcc5ec48d04a329$export$b4543cd210a30a75 extends (0, $5ETkU.Gizmo) {
    /** Default material used to render when gizmo is not disabled or hovered */ get coloredMaterial() {
        return this._coloredMaterial;
    }
    /** Material used to render when gizmo is hovered with mouse*/ get hoverMaterial() {
        return this._hoverMaterial;
    }
    /** Material used to render when gizmo is disabled. typically grey.*/ get disableMaterial() {
        return this._disableMaterial;
    }
    /**
     * @internal
     */ static _CreatePlane(scene, material) {
        const plane = new (0, $klshO.TransformNode)("plane", scene);
        //make sure plane is double sided
        const dragPlane = (0, $kt6s5.CreatePlane)("dragPlane", {
            width: 0.1375,
            height: 0.1375,
            sideOrientation: 2
        }, scene);
        dragPlane.material = material;
        dragPlane.parent = plane;
        return plane;
    }
    /**
     * Creates a PlaneDragGizmo
     * @param dragPlaneNormal The axis normal to which the gizmo will be able to drag on
     * @param color The color of the gizmo
     * @param gizmoLayer The utility layer the gizmo will be added to
     * @param parent
     * @param hoverColor The color of the gizmo when hovering over and dragging
     * @param disableColor The Color of the gizmo when its disabled
     */ constructor(dragPlaneNormal, color = (0, $7etnY.Color3).Gray(), gizmoLayer = (0, $6mCYU.UtilityLayerRenderer).DefaultUtilityLayer, parent = null, hoverColor = (0, $7etnY.Color3).Yellow(), disableColor = (0, $7etnY.Color3).Gray()){
        super(gizmoLayer);
        this._pointerObserver = null;
        /**
         * Drag distance in babylon units that the gizmo will snap to when dragged (Default: 0)
         */ this.snapDistance = 0;
        /**
         * Event that fires each time the gizmo snaps to a new location.
         * * snapDistance is the change in distance
         */ this.onSnapObservable = new (0, $diGQf.Observable)();
        this._isEnabled = false;
        this._parent = null;
        this._dragging = false;
        this._parent = parent;
        // Create Material
        this._coloredMaterial = new (0, $gAH3H.StandardMaterial)("", gizmoLayer.utilityLayerScene);
        this._coloredMaterial.diffuseColor = color;
        this._coloredMaterial.specularColor = color.subtract(new (0, $7etnY.Color3)(0.1, 0.1, 0.1));
        this._hoverMaterial = new (0, $gAH3H.StandardMaterial)("", gizmoLayer.utilityLayerScene);
        this._hoverMaterial.diffuseColor = hoverColor;
        this._disableMaterial = new (0, $gAH3H.StandardMaterial)("", gizmoLayer.utilityLayerScene);
        this._disableMaterial.diffuseColor = disableColor;
        this._disableMaterial.alpha = 0.4;
        // Build plane mesh on root node
        this._gizmoMesh = $6bcc5ec48d04a329$export$b4543cd210a30a75._CreatePlane(gizmoLayer.utilityLayerScene, this._coloredMaterial);
        this._gizmoMesh.lookAt(this._rootMesh.position.add(dragPlaneNormal));
        this._gizmoMesh.scaling.scaleInPlace(1 / 3);
        this._gizmoMesh.parent = this._rootMesh;
        let currentSnapDragDistance = 0;
        const tmpVector = new (0, $ha1VO.Vector3)();
        const tmpSnapEvent = {
            snapDistance: 0
        };
        // Add dragPlaneNormal drag behavior to handle events when the gizmo is dragged
        this.dragBehavior = new (0, $dnn9Q.PointerDragBehavior)({
            dragPlaneNormal: dragPlaneNormal
        });
        this.dragBehavior.moveAttached = false;
        this._rootMesh.addBehavior(this.dragBehavior);
        this.dragBehavior.onDragObservable.add((event)=>{
            if (this.attachedNode) {
                // Keep world translation and use it to update world transform
                // if the node has parent, the local transform properties (position, rotation, scale)
                // will be recomputed in _matrixChanged function
                // Snapping logic
                if (this.snapDistance == 0) {
                    this.attachedNode.getWorldMatrix().getTranslationToRef((0, $ha1VO.TmpVectors).Vector3[0]);
                    (0, $ha1VO.TmpVectors).Vector3[0].addToRef(event.delta, (0, $ha1VO.TmpVectors).Vector3[0]);
                    if (this.dragBehavior.validateDrag((0, $ha1VO.TmpVectors).Vector3[0])) this.attachedNode.getWorldMatrix().addTranslationFromFloats(event.delta.x, event.delta.y, event.delta.z);
                } else {
                    currentSnapDragDistance += event.dragDistance;
                    if (Math.abs(currentSnapDragDistance) > this.snapDistance) {
                        const dragSteps = Math.floor(Math.abs(currentSnapDragDistance) / this.snapDistance);
                        currentSnapDragDistance = currentSnapDragDistance % this.snapDistance;
                        event.delta.normalizeToRef(tmpVector);
                        tmpVector.scaleInPlace(this.snapDistance * dragSteps);
                        this.attachedNode.getWorldMatrix().getTranslationToRef((0, $ha1VO.TmpVectors).Vector3[0]);
                        (0, $ha1VO.TmpVectors).Vector3[0].addToRef(tmpVector, (0, $ha1VO.TmpVectors).Vector3[0]);
                        if (this.dragBehavior.validateDrag((0, $ha1VO.TmpVectors).Vector3[0])) {
                            this.attachedNode.getWorldMatrix().addTranslationFromFloats(tmpVector.x, tmpVector.y, tmpVector.z);
                            tmpSnapEvent.snapDistance = this.snapDistance * dragSteps;
                            this.onSnapObservable.notifyObservers(tmpSnapEvent);
                        }
                    }
                }
                this._matrixChanged();
            }
        });
        this.dragBehavior.onDragStartObservable.add(()=>{
            this._dragging = true;
        });
        this.dragBehavior.onDragEndObservable.add(()=>{
            this._dragging = false;
        });
        const light = gizmoLayer._getSharedGizmoLight();
        light.includedOnlyMeshes = light.includedOnlyMeshes.concat(this._rootMesh.getChildMeshes(false));
        const cache = {
            gizmoMeshes: this._gizmoMesh.getChildMeshes(),
            colliderMeshes: this._gizmoMesh.getChildMeshes(),
            material: this._coloredMaterial,
            hoverMaterial: this._hoverMaterial,
            disableMaterial: this._disableMaterial,
            active: false,
            dragBehavior: this.dragBehavior
        };
        this._parent?.addToAxisCache(this._gizmoMesh, cache);
        this._pointerObserver = gizmoLayer.utilityLayerScene.onPointerObservable.add((pointerInfo)=>{
            if (this._customMeshSet) return;
            this._isHovered = !!(cache.colliderMeshes.indexOf(pointerInfo?.pickInfo?.pickedMesh) != -1);
            if (!this._parent) {
                const material = cache.dragBehavior.enabled ? this._isHovered || this._dragging ? this._hoverMaterial : this._coloredMaterial : this._disableMaterial;
                this._setGizmoMeshMaterial(cache.gizmoMeshes, material);
            }
        });
        this.dragBehavior.onEnabledObservable.add((newState)=>{
            this._setGizmoMeshMaterial(cache.gizmoMeshes, newState ? this._coloredMaterial : this._disableMaterial);
        });
    }
    _attachedNodeChanged(value) {
        if (this.dragBehavior) this.dragBehavior.enabled = value ? true : false;
    }
    /**
     * If the gizmo is enabled
     */ set isEnabled(value) {
        this._isEnabled = value;
        if (!value) this.attachedNode = null;
        else if (this._parent) this.attachedNode = this._parent.attachedNode;
    }
    get isEnabled() {
        return this._isEnabled;
    }
    /**
     * Disposes of the gizmo
     */ dispose() {
        this.onSnapObservable.clear();
        this.gizmoLayer.utilityLayerScene.onPointerObservable.remove(this._pointerObserver);
        this.dragBehavior.detach();
        super.dispose();
        if (this._gizmoMesh) this._gizmoMesh.dispose();
        [
            this._coloredMaterial,
            this._hoverMaterial,
            this._disableMaterial
        ].forEach((matl)=>{
            if (matl) matl.dispose();
        });
    }
}

});


parcelRegister("77AGr", function(module, exports) {

$parcel$export(module.exports, "ScaleGizmo", () => $52f5a46ad3c044fe$export$abfff9b8073a0e84);

var $kVtWi = parcelRequire("kVtWi");

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $2vSVS = parcelRequire("2vSVS");

var $5ETkU = parcelRequire("5ETkU");

var $27UkL = parcelRequire("27UkL");

var $6mCYU = parcelRequire("6mCYU");

var $gAH3H = parcelRequire("gAH3H");
class $52f5a46ad3c044fe$export$abfff9b8073a0e84 extends (0, $5ETkU.Gizmo) {
    /** Default material used to render when gizmo is not disabled or hovered */ get coloredMaterial() {
        return this._coloredMaterial;
    }
    /** Material used to render when gizmo is hovered with mouse*/ get hoverMaterial() {
        return this._hoverMaterial;
    }
    /** Material used to render when gizmo is disabled. typically grey.*/ get disableMaterial() {
        return this._disableMaterial;
    }
    get attachedMesh() {
        return this._meshAttached;
    }
    set attachedMesh(mesh) {
        this._meshAttached = mesh;
        this._nodeAttached = mesh;
        [
            this.xGizmo,
            this.yGizmo,
            this.zGizmo,
            this.uniformScaleGizmo
        ].forEach((gizmo)=>{
            if (gizmo.isEnabled) gizmo.attachedMesh = mesh;
            else gizmo.attachedMesh = null;
        });
    }
    get attachedNode() {
        return this._nodeAttached;
    }
    set attachedNode(node) {
        this._meshAttached = null;
        this._nodeAttached = node;
        [
            this.xGizmo,
            this.yGizmo,
            this.zGizmo,
            this.uniformScaleGizmo
        ].forEach((gizmo)=>{
            if (gizmo.isEnabled) gizmo.attachedNode = node;
            else gizmo.attachedNode = null;
        });
    }
    set updateScale(value) {
        if (this.xGizmo) {
            this.xGizmo.updateScale = value;
            this.yGizmo.updateScale = value;
            this.zGizmo.updateScale = value;
        }
    }
    get updateScale() {
        return this.xGizmo.updateScale;
    }
    /**
     * True when the mouse pointer is hovering a gizmo mesh
     */ get isHovered() {
        return this.xGizmo.isHovered || this.yGizmo.isHovered || this.zGizmo.isHovered;
    }
    /**
     * True when the mouse pointer is dragging a gizmo mesh
     */ get isDragging() {
        return this.xGizmo.dragBehavior.dragging || this.yGizmo.dragBehavior.dragging || this.zGizmo.dragBehavior.dragging || this.uniformScaleGizmo.dragBehavior.dragging;
    }
    get additionalTransformNode() {
        return this._additionalTransformNode;
    }
    set additionalTransformNode(transformNode) {
        [
            this.xGizmo,
            this.yGizmo,
            this.zGizmo,
            this.uniformScaleGizmo
        ].forEach((gizmo)=>{
            gizmo.additionalTransformNode = transformNode;
        });
    }
    /**
     * Creates a ScaleGizmo
     * @param gizmoLayer The utility layer the gizmo will be added to
     * @param thickness display gizmo axis thickness
     * @param gizmoManager
     * @param options More options
     */ constructor(gizmoLayer = (0, $6mCYU.UtilityLayerRenderer).DefaultUtilityLayer, thickness = 1, gizmoManager, options){
        super(gizmoLayer);
        this._meshAttached = null;
        this._nodeAttached = null;
        this._incrementalSnap = false;
        this._sensitivity = 1;
        this._observables = [];
        /** Node Caching for quick lookup */ this._gizmoAxisCache = new Map();
        /** Fires an event when any of it's sub gizmos are dragged */ this.onDragStartObservable = new (0, $diGQf.Observable)();
        /** Fires an event when any of it's sub gizmos are being dragged */ this.onDragObservable = new (0, $diGQf.Observable)();
        /** Fires an event when any of it's sub gizmos are released from dragging */ this.onDragEndObservable = new (0, $diGQf.Observable)();
        this.uniformScaleGizmo = this._createUniformScaleMesh();
        this.xGizmo = new (0, $27UkL.AxisScaleGizmo)(new (0, $ha1VO.Vector3)(1, 0, 0), (0, $7etnY.Color3).Red().scale(0.5), gizmoLayer, this, thickness);
        this.yGizmo = new (0, $27UkL.AxisScaleGizmo)(new (0, $ha1VO.Vector3)(0, 1, 0), (0, $7etnY.Color3).Green().scale(0.5), gizmoLayer, this, thickness);
        this.zGizmo = new (0, $27UkL.AxisScaleGizmo)(new (0, $ha1VO.Vector3)(0, 0, 1), (0, $7etnY.Color3).Blue().scale(0.5), gizmoLayer, this, thickness);
        this.additionalTransformNode = options?.additionalTransformNode;
        // Relay drag events
        [
            this.xGizmo,
            this.yGizmo,
            this.zGizmo,
            this.uniformScaleGizmo
        ].forEach((gizmo)=>{
            gizmo.dragBehavior.onDragStartObservable.add(()=>{
                this.onDragStartObservable.notifyObservers({});
            });
            gizmo.dragBehavior.onDragObservable.add(()=>{
                this.onDragObservable.notifyObservers({});
            });
            gizmo.dragBehavior.onDragEndObservable.add(()=>{
                this.onDragEndObservable.notifyObservers({});
            });
        });
        this.attachedMesh = null;
        this.attachedNode = null;
        if (gizmoManager) gizmoManager.addToAxisCache(this._gizmoAxisCache);
        else // Only subscribe to pointer event if gizmoManager isnt
        (0, $5ETkU.Gizmo).GizmoAxisPointerObserver(gizmoLayer, this._gizmoAxisCache);
    }
    /**
     * @internal
     * Create Geometry for Gizmo
     */ _createUniformScaleMesh() {
        this._coloredMaterial = new (0, $gAH3H.StandardMaterial)("", this.gizmoLayer.utilityLayerScene);
        this._coloredMaterial.diffuseColor = (0, $7etnY.Color3).Gray();
        this._hoverMaterial = new (0, $gAH3H.StandardMaterial)("", this.gizmoLayer.utilityLayerScene);
        this._hoverMaterial.diffuseColor = (0, $7etnY.Color3).Yellow();
        this._disableMaterial = new (0, $gAH3H.StandardMaterial)("", this.gizmoLayer.utilityLayerScene);
        this._disableMaterial.diffuseColor = (0, $7etnY.Color3).Gray();
        this._disableMaterial.alpha = 0.4;
        const uniformScaleGizmo = new (0, $27UkL.AxisScaleGizmo)(new (0, $ha1VO.Vector3)(0, 1, 0), (0, $7etnY.Color3).Gray().scale(0.5), this.gizmoLayer, this);
        uniformScaleGizmo.updateGizmoRotationToMatchAttachedMesh = false;
        uniformScaleGizmo.uniformScaling = true;
        this._uniformScalingMesh = (0, $2vSVS.CreatePolyhedron)("uniform", {
            type: 1
        }, uniformScaleGizmo.gizmoLayer.utilityLayerScene);
        this._uniformScalingMesh.scaling.scaleInPlace(0.01);
        this._uniformScalingMesh.visibility = 0;
        this._octahedron = (0, $2vSVS.CreatePolyhedron)("", {
            type: 1
        }, uniformScaleGizmo.gizmoLayer.utilityLayerScene);
        this._octahedron.scaling.scaleInPlace(0.007);
        this._uniformScalingMesh.addChild(this._octahedron);
        uniformScaleGizmo.setCustomMesh(this._uniformScalingMesh, true);
        const light = this.gizmoLayer._getSharedGizmoLight();
        light.includedOnlyMeshes = light.includedOnlyMeshes.concat(this._octahedron);
        const cache = {
            gizmoMeshes: [
                this._octahedron,
                this._uniformScalingMesh
            ],
            colliderMeshes: [
                this._uniformScalingMesh
            ],
            material: this._coloredMaterial,
            hoverMaterial: this._hoverMaterial,
            disableMaterial: this._disableMaterial,
            active: false,
            dragBehavior: uniformScaleGizmo.dragBehavior
        };
        this.addToAxisCache(uniformScaleGizmo._rootMesh, cache);
        return uniformScaleGizmo;
    }
    set updateGizmoRotationToMatchAttachedMesh(value) {
        if (!value) (0, $kVtWi.Logger).Warn("Setting updateGizmoRotationToMatchAttachedMesh = false on scaling gizmo is not supported.");
        else {
            this._updateGizmoRotationToMatchAttachedMesh = value;
            [
                this.xGizmo,
                this.yGizmo,
                this.zGizmo,
                this.uniformScaleGizmo
            ].forEach((gizmo)=>{
                if (gizmo) gizmo.updateGizmoRotationToMatchAttachedMesh = value;
            });
        }
    }
    get updateGizmoRotationToMatchAttachedMesh() {
        return this._updateGizmoRotationToMatchAttachedMesh;
    }
    set anchorPoint(value) {
        this._anchorPoint = value;
        [
            this.xGizmo,
            this.yGizmo,
            this.zGizmo,
            this.uniformScaleGizmo
        ].forEach((gizmo)=>{
            if (gizmo) gizmo.anchorPoint = value;
        });
    }
    get anchorPoint() {
        return this._anchorPoint;
    }
    /**
     * posture that the gizmo will be display
     * When set null, default value will be used (Quaternion(0, 0, 0, 1))
     */ get customRotationQuaternion() {
        return this._customRotationQuaternion;
    }
    set customRotationQuaternion(customRotationQuaternion) {
        this._customRotationQuaternion = customRotationQuaternion;
        [
            this.xGizmo,
            this.yGizmo,
            this.zGizmo,
            this.uniformScaleGizmo
        ].forEach((gizmo)=>{
            if (gizmo) gizmo.customRotationQuaternion = customRotationQuaternion;
        });
    }
    /**
     * Set the coordinate system to use. By default it's local.
     * But it's possible for a user to tweak so its local for translation and world for rotation.
     * In that case, setting the coordinate system will change `updateGizmoRotationToMatchAttachedMesh` and `updateGizmoPositionToMatchAttachedMesh`
     */ set coordinatesMode(coordinatesMode) {
        if (coordinatesMode == (0, $5ETkU.GizmoCoordinatesMode).World) (0, $kVtWi.Logger).Warn("Setting coordinates Mode to world on scaling gizmo is not supported.");
        [
            this.xGizmo,
            this.yGizmo,
            this.zGizmo,
            this.uniformScaleGizmo
        ].forEach((gizmo)=>{
            gizmo.coordinatesMode = (0, $5ETkU.GizmoCoordinatesMode).Local;
        });
    }
    /**
     * Drag distance in babylon units that the gizmo will snap to when dragged (Default: 0)
     */ set snapDistance(value) {
        this._snapDistance = value;
        [
            this.xGizmo,
            this.yGizmo,
            this.zGizmo,
            this.uniformScaleGizmo
        ].forEach((gizmo)=>{
            if (gizmo) gizmo.snapDistance = value;
        });
    }
    get snapDistance() {
        return this._snapDistance;
    }
    /**
     * Incremental snap scaling (default is false). When true, with a snapDistance of 0.1, scaling will be 1.1,1.2,1.3 instead of, when false: 1.1,1.21,1.33,...
     */ set incrementalSnap(value) {
        this._incrementalSnap = value;
        [
            this.xGizmo,
            this.yGizmo,
            this.zGizmo,
            this.uniformScaleGizmo
        ].forEach((gizmo)=>{
            if (gizmo) gizmo.incrementalSnap = value;
        });
    }
    get incrementalSnap() {
        return this._incrementalSnap;
    }
    /**
     * Ratio for the scale of the gizmo (Default: 1)
     */ set scaleRatio(value) {
        this._scaleRatio = value;
        [
            this.xGizmo,
            this.yGizmo,
            this.zGizmo,
            this.uniformScaleGizmo
        ].forEach((gizmo)=>{
            if (gizmo) gizmo.scaleRatio = value;
        });
    }
    get scaleRatio() {
        return this._scaleRatio;
    }
    /**
     * Sensitivity factor for dragging (Default: 1)
     */ set sensitivity(value) {
        this._sensitivity = value;
        [
            this.xGizmo,
            this.yGizmo,
            this.zGizmo,
            this.uniformScaleGizmo
        ].forEach((gizmo)=>{
            if (gizmo) gizmo.sensitivity = value;
        });
    }
    get sensitivity() {
        return this._sensitivity;
    }
    /**
     * Builds Gizmo Axis Cache to enable features such as hover state preservation and graying out other axis during manipulation
     * @param mesh Axis gizmo mesh
     * @param cache Gizmo axis definition used for reactive gizmo UI
     */ addToAxisCache(mesh, cache) {
        this._gizmoAxisCache.set(mesh, cache);
    }
    /**
     * Force release the drag action by code
     */ releaseDrag() {
        this.xGizmo.dragBehavior.releaseDrag();
        this.yGizmo.dragBehavior.releaseDrag();
        this.zGizmo.dragBehavior.releaseDrag();
        this.uniformScaleGizmo.dragBehavior.releaseDrag();
    }
    /**
     * Disposes of the gizmo
     */ dispose() {
        [
            this.xGizmo,
            this.yGizmo,
            this.zGizmo,
            this.uniformScaleGizmo
        ].forEach((gizmo)=>{
            if (gizmo) gizmo.dispose();
        });
        this._observables.forEach((obs)=>{
            this.gizmoLayer.utilityLayerScene.onPointerObservable.remove(obs);
        });
        this.onDragStartObservable.clear();
        this.onDragObservable.clear();
        this.onDragEndObservable.clear();
        [
            this._uniformScalingMesh,
            this._octahedron
        ].forEach((msh)=>{
            if (msh) msh.dispose();
        });
        [
            this._coloredMaterial,
            this._hoverMaterial,
            this._disableMaterial
        ].forEach((matl)=>{
            if (matl) matl.dispose();
        });
    }
}

});


parcelRegister("9XGHY", function(module, exports) {

$parcel$export(module.exports, "LightGizmo", () => $740ac0b8a10e1b83$export$c770bbe55a89dc50);

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $0cHNL = parcelRequire("0cHNL");

var $fbuqw = parcelRequire("fbuqw");

var $5ETkU = parcelRequire("5ETkU");

var $6mCYU = parcelRequire("6mCYU");

var $gAH3H = parcelRequire("gAH3H");

var $lgdKn = parcelRequire("lgdKn");

var $btpzP = parcelRequire("btpzP");

var $8KqOo = parcelRequire("8KqOo");

var $dRlRf = parcelRequire("dRlRf");

var $aYDyu = parcelRequire("aYDyu");

var $klshO = parcelRequire("klshO");

var $cfkw4 = parcelRequire("cfkw4");

var $diGQf = parcelRequire("diGQf");

var $9zY5k = parcelRequire("9zY5k");

var $kVtWi = parcelRequire("kVtWi");
class $740ac0b8a10e1b83$export$c770bbe55a89dc50 extends (0, $5ETkU.Gizmo) {
    /**
     * Creates a LightGizmo
     * @param gizmoLayer The utility layer the gizmo will be added to
     */ constructor(gizmoLayer = (0, $6mCYU.UtilityLayerRenderer).DefaultUtilityLayer){
        super(gizmoLayer);
        this._cachedPosition = new (0, $ha1VO.Vector3)();
        this._cachedForward = new (0, $ha1VO.Vector3)(0, 0, 1);
        this._pointerObserver = null;
        /**
         * Event that fires each time the gizmo is clicked
         */ this.onClickedObservable = new (0, $diGQf.Observable)();
        this._light = null;
        this.attachedMesh = new (0, $0cHNL.AbstractMesh)("", this.gizmoLayer.utilityLayerScene);
        this._attachedMeshParent = new (0, $klshO.TransformNode)("parent", this.gizmoLayer.utilityLayerScene);
        this.attachedMesh.parent = this._attachedMeshParent;
        this._material = new (0, $gAH3H.StandardMaterial)("light", this.gizmoLayer.utilityLayerScene);
        this._material.diffuseColor = new (0, $7etnY.Color3)(0.5, 0.5, 0.5);
        this._material.specularColor = new (0, $7etnY.Color3)(0.1, 0.1, 0.1);
        this._pointerObserver = gizmoLayer.utilityLayerScene.onPointerObservable.add((pointerInfo)=>{
            if (!this._light) return;
            this._isHovered = !!(pointerInfo.pickInfo && this._rootMesh.getChildMeshes().indexOf(pointerInfo.pickInfo.pickedMesh) != -1);
            if (this._isHovered && pointerInfo.event.button === 0) this.onClickedObservable.notifyObservers(this._light);
        }, (0, $cfkw4.PointerEventTypes).POINTERDOWN);
    }
    /**
     * Override attachedNode because lightgizmo only support attached mesh
     * It will return the attached mesh (if any) and setting an attached node will log
     * a warning
     */ get attachedNode() {
        return this.attachedMesh;
    }
    set attachedNode(value) {
        (0, $kVtWi.Logger).Warn("Nodes cannot be attached to LightGizmo. Attach to a mesh instead.");
    }
    /**
     * The light that the gizmo is attached to
     */ set light(light) {
        this._light = light;
        if (light) {
            // Create the mesh for the given light type
            if (this._lightMesh) this._lightMesh.dispose();
            if (light instanceof (0, $lgdKn.HemisphericLight)) this._lightMesh = $740ac0b8a10e1b83$export$c770bbe55a89dc50._CreateHemisphericLightMesh(this.gizmoLayer.utilityLayerScene);
            else if (light instanceof (0, $btpzP.DirectionalLight)) this._lightMesh = $740ac0b8a10e1b83$export$c770bbe55a89dc50._CreateDirectionalLightMesh(this.gizmoLayer.utilityLayerScene);
            else if (light instanceof (0, $aYDyu.SpotLight)) this._lightMesh = $740ac0b8a10e1b83$export$c770bbe55a89dc50._CreateSpotLightMesh(this.gizmoLayer.utilityLayerScene);
            else this._lightMesh = $740ac0b8a10e1b83$export$c770bbe55a89dc50._CreatePointLightMesh(this.gizmoLayer.utilityLayerScene);
            this._lightMesh.getChildMeshes(false).forEach((m)=>{
                m.material = this._material;
            });
            this._lightMesh.parent = this._rootMesh;
            // Add lighting to the light gizmo
            const gizmoLight = this.gizmoLayer._getSharedGizmoLight();
            gizmoLight.includedOnlyMeshes = gizmoLight.includedOnlyMeshes.concat(this._lightMesh.getChildMeshes(false));
            this._lightMesh.rotationQuaternion = new (0, $ha1VO.Quaternion)();
            if (!this.attachedMesh.reservedDataStore) this.attachedMesh.reservedDataStore = {};
            this.attachedMesh.reservedDataStore.lightGizmo = this;
            if (light.parent) this._attachedMeshParent.freezeWorldMatrix(light.parent.getWorldMatrix());
            // Get update position and direction if the light has it
            if (light.position) {
                this.attachedMesh.position.copyFrom(light.position);
                this.attachedMesh.computeWorldMatrix(true);
                this._cachedPosition.copyFrom(this.attachedMesh.position);
            }
            if (light.direction) {
                this.attachedMesh.setDirection(light.direction);
                this.attachedMesh.computeWorldMatrix(true);
                const forward = this._getMeshForward();
                this._cachedForward.copyFrom(forward);
            }
            this._update();
        }
    }
    get light() {
        return this._light;
    }
    /**
     * Gets the material used to render the light gizmo
     */ get material() {
        return this._material;
    }
    /**
     * @internal
     * returns mesh forward
     */ _getMeshForward() {
        let forward = this.attachedMesh.forward;
        if (this.attachedMesh.getScene().useRightHandedSystem) {
            forward.negateToRef((0, $ha1VO.TmpVectors).Vector3[0]);
            forward = (0, $ha1VO.TmpVectors).Vector3[0];
        }
        return forward;
    }
    /**
     * @internal
     * Updates the gizmo to match the attached mesh's position/rotation
     */ _update() {
        super._update();
        if (!this._light) return;
        if (this._light.parent) this._attachedMeshParent.freezeWorldMatrix(this._light.parent.getWorldMatrix());
        // For light position and direction, a dirty flag is set to true in the setter
        // It means setting values individually or copying values will not call setter and
        // dirty flag will not be set to true. Hence creating a new Vector3.
        if (this._light.position) {
            // If the gizmo is moved update the light otherwise update the gizmo to match the light
            if (!this.attachedMesh.position.equals(this._cachedPosition)) {
                // update light to match gizmo
                const position = this.attachedMesh.position;
                this._light.position = new (0, $ha1VO.Vector3)(position.x, position.y, position.z);
                this._cachedPosition.copyFrom(this.attachedMesh.position);
            } else {
                // update gizmo to match light
                this.attachedMesh.position.copyFrom(this._light.position);
                this.attachedMesh.computeWorldMatrix(true);
                this._cachedPosition.copyFrom(this.attachedMesh.position);
            }
        }
        if (this._light.direction) {
            // If the gizmo is moved update the light otherwise update the gizmo to match the light
            const forward = this._getMeshForward();
            if ((0, $ha1VO.Vector3).DistanceSquared(forward, this._cachedForward) > 0.0001) {
                // update light to match gizmo
                const direction = forward;
                this._light.direction = new (0, $ha1VO.Vector3)(direction.x, direction.y, direction.z);
                this._cachedForward.copyFrom(forward);
            } else if ((0, $ha1VO.Vector3).DistanceSquared(forward, this._light.direction) > 0.0001) {
                // update gizmo to match light
                this.attachedMesh.setDirection(this._light.direction);
                this.attachedMesh.computeWorldMatrix(true);
                this._cachedForward.copyFrom(forward);
            }
        }
    }
    /**
     * Disposes of the light gizmo
     */ dispose() {
        this.onClickedObservable.clear();
        this.gizmoLayer.utilityLayerScene.onPointerObservable.remove(this._pointerObserver);
        this._material.dispose();
        super.dispose();
        this._attachedMeshParent.dispose();
    }
    static _CreateHemisphericLightMesh(scene) {
        const root = new (0, $fbuqw.Mesh)("hemisphereLight", scene);
        const hemisphere = (0, $dRlRf.CreateHemisphere)(root.name, {
            segments: 10,
            diameter: 1
        }, scene);
        hemisphere.position.z = -0.15;
        hemisphere.rotation.x = Math.PI / 2;
        hemisphere.parent = root;
        const lines = this._CreateLightLines(3, scene);
        lines.parent = root;
        root.scaling.scaleInPlace($740ac0b8a10e1b83$export$c770bbe55a89dc50._Scale);
        root.rotation.x = Math.PI / 2;
        return root;
    }
    static _CreatePointLightMesh(scene) {
        const root = new (0, $fbuqw.Mesh)("pointLight", scene);
        const sphere = (0, $8KqOo.CreateSphere)(root.name, {
            segments: 10,
            diameter: 1
        }, scene);
        sphere.rotation.x = Math.PI / 2;
        sphere.parent = root;
        const lines = this._CreateLightLines(5, scene);
        lines.parent = root;
        root.scaling.scaleInPlace($740ac0b8a10e1b83$export$c770bbe55a89dc50._Scale);
        root.rotation.x = Math.PI / 2;
        return root;
    }
    static _CreateSpotLightMesh(scene) {
        const root = new (0, $fbuqw.Mesh)("spotLight", scene);
        const sphere = (0, $8KqOo.CreateSphere)(root.name, {
            segments: 10,
            diameter: 1
        }, scene);
        sphere.parent = root;
        const hemisphere = (0, $dRlRf.CreateHemisphere)(root.name, {
            segments: 10,
            diameter: 2
        }, scene);
        hemisphere.parent = root;
        hemisphere.rotation.x = -Math.PI / 2;
        const lines = this._CreateLightLines(2, scene);
        lines.parent = root;
        root.scaling.scaleInPlace($740ac0b8a10e1b83$export$c770bbe55a89dc50._Scale);
        root.rotation.x = Math.PI / 2;
        return root;
    }
    static _CreateDirectionalLightMesh(scene) {
        const root = new (0, $fbuqw.Mesh)("directionalLight", scene);
        const mesh = new (0, $fbuqw.Mesh)(root.name, scene);
        mesh.parent = root;
        const sphere = (0, $8KqOo.CreateSphere)(root.name, {
            diameter: 1.2,
            segments: 10
        }, scene);
        sphere.parent = mesh;
        const line = (0, $9zY5k.CreateCylinder)(root.name, {
            updatable: false,
            height: 6,
            diameterTop: 0.3,
            diameterBottom: 0.3,
            tessellation: 6,
            subdivisions: 1
        }, scene);
        line.parent = mesh;
        let left = line.clone(root.name);
        left.scaling.y = 0.5;
        left.position.x += 1.25;
        let right = line.clone(root.name);
        right.scaling.y = 0.5;
        right.position.x += -1.25;
        const arrowHead = (0, $9zY5k.CreateCylinder)(root.name, {
            updatable: false,
            height: 1,
            diameterTop: 0,
            diameterBottom: 0.6,
            tessellation: 6,
            subdivisions: 1
        }, scene);
        arrowHead.position.y += 3;
        arrowHead.parent = mesh;
        left = arrowHead.clone(root.name);
        left.position.y = 1.5;
        left.position.x += 1.25;
        right = arrowHead.clone(root.name);
        right.position.y = 1.5;
        right.position.x += -1.25;
        mesh.scaling.scaleInPlace($740ac0b8a10e1b83$export$c770bbe55a89dc50._Scale);
        mesh.rotation.z = Math.PI / 2;
        mesh.rotation.y = Math.PI / 2;
        return root;
    }
}
// Static helper methods
$740ac0b8a10e1b83$export$c770bbe55a89dc50._Scale = 0.007;
/**
 * Creates the lines for a light mesh
 * @param levels
 * @param scene
 * @returns the light lines mesh
 */ $740ac0b8a10e1b83$export$c770bbe55a89dc50._CreateLightLines = (levels, scene)=>{
    const distFromSphere = 1.2;
    const root = new (0, $fbuqw.Mesh)("root", scene);
    root.rotation.x = Math.PI / 2;
    // Create the top line, this will be cloned for all other lines
    const linePivot = new (0, $fbuqw.Mesh)("linePivot", scene);
    linePivot.parent = root;
    const line = (0, $9zY5k.CreateCylinder)("line", {
        updatable: false,
        height: 2,
        diameterTop: 0.2,
        diameterBottom: 0.3,
        tessellation: 6,
        subdivisions: 1
    }, scene);
    line.position.y = line.scaling.y / 2 + distFromSphere;
    line.parent = linePivot;
    if (levels < 2) return linePivot;
    for(let i = 0; i < 4; i++){
        const l = linePivot.clone("lineParentClone");
        l.rotation.z = Math.PI / 4;
        l.rotation.y = Math.PI / 2 + Math.PI / 2 * i;
        l.getChildMeshes()[0].scaling.y = 0.5;
        l.getChildMeshes()[0].scaling.x = l.getChildMeshes()[0].scaling.z = 0.8;
        l.getChildMeshes()[0].position.y = l.getChildMeshes()[0].scaling.y / 2 + distFromSphere;
    }
    if (levels < 3) return root;
    for(let i = 0; i < 4; i++){
        const l = linePivot.clone("linePivotClone");
        l.rotation.z = Math.PI / 2;
        l.rotation.y = Math.PI / 2 * i;
    }
    if (levels < 4) return root;
    for(let i = 0; i < 4; i++){
        const l = linePivot.clone("linePivotClone");
        l.rotation.z = Math.PI + Math.PI / 4;
        l.rotation.y = Math.PI / 2 + Math.PI / 2 * i;
        l.getChildMeshes()[0].scaling.y = 0.5;
        l.getChildMeshes()[0].scaling.x = l.getChildMeshes()[0].scaling.z = 0.8;
        l.getChildMeshes()[0].position.y = l.getChildMeshes()[0].scaling.y / 2 + distFromSphere;
    }
    if (levels < 5) return root;
    const l = linePivot.clone("linePivotClone");
    l.rotation.z = Math.PI;
    return root;
};

});
parcelRegister("btpzP", function(module, exports) {

$parcel$export(module.exports, "DirectionalLight", () => $85a63e33b97cca4e$export$3fea33cc9972c868);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $ha1VO = parcelRequire("ha1VO");

var $bgssx = parcelRequire("bgssx");

var $c6YWJ = parcelRequire("c6YWJ");

var $lso8g = parcelRequire("lso8g");
(0, $bgssx.Node).AddNodeConstructor("Light_Type_1", (name, scene)=>{
    return ()=>new $85a63e33b97cca4e$export$3fea33cc9972c868(name, (0, $ha1VO.Vector3).Zero(), scene);
});
class $85a63e33b97cca4e$export$3fea33cc9972c868 extends (0, $lso8g.ShadowLight) {
    /**
     * Fix frustum size for the shadow generation. This is disabled if the value is 0.
     */ get shadowFrustumSize() {
        return this._shadowFrustumSize;
    }
    /**
     * Specifies a fix frustum size for the shadow generation.
     */ set shadowFrustumSize(value) {
        this._shadowFrustumSize = value;
        this.forceProjectionMatrixCompute();
    }
    /**
     * Gets the shadow projection scale against the optimal computed one.
     * 0.1 by default which means that the projection window is increase by 10% from the optimal size.
     * This does not impact in fixed frustum size (shadowFrustumSize being set)
     */ get shadowOrthoScale() {
        return this._shadowOrthoScale;
    }
    /**
     * Sets the shadow projection scale against the optimal computed one.
     * 0.1 by default which means that the projection window is increase by 10% from the optimal size.
     * This does not impact in fixed frustum size (shadowFrustumSize being set)
     */ set shadowOrthoScale(value) {
        this._shadowOrthoScale = value;
        this.forceProjectionMatrixCompute();
    }
    /**
     * Gets or sets the orthoLeft property used to build the light frustum
     */ get orthoLeft() {
        return this._orthoLeft;
    }
    set orthoLeft(left) {
        this._orthoLeft = left;
    }
    /**
     * Gets or sets the orthoRight property used to build the light frustum
     */ get orthoRight() {
        return this._orthoRight;
    }
    set orthoRight(right) {
        this._orthoRight = right;
    }
    /**
     * Gets or sets the orthoTop property used to build the light frustum
     */ get orthoTop() {
        return this._orthoTop;
    }
    set orthoTop(top) {
        this._orthoTop = top;
    }
    /**
     * Gets or sets the orthoBottom property used to build the light frustum
     */ get orthoBottom() {
        return this._orthoBottom;
    }
    set orthoBottom(bottom) {
        this._orthoBottom = bottom;
    }
    /**
     * Creates a DirectionalLight object in the scene, oriented towards the passed direction (Vector3).
     * The directional light is emitted from everywhere in the given direction.
     * It can cast shadows.
     * Documentation : https://doc.babylonjs.com/features/featuresDeepDive/lights/lights_introduction
     * @param name The friendly name of the light
     * @param direction The direction of the light
     * @param scene The scene the light belongs to
     */ constructor(name, direction, scene){
        super(name, scene);
        this._shadowFrustumSize = 0;
        this._shadowOrthoScale = 0.1;
        /**
         * Automatically compute the projection matrix to best fit (including all the casters)
         * on each frame.
         */ this.autoUpdateExtends = true;
        /**
         * Automatically compute the shadowMinZ and shadowMaxZ for the projection matrix to best fit (including all the casters)
         * on each frame. autoUpdateExtends must be set to true for this to work
         */ this.autoCalcShadowZBounds = false;
        // Cache
        this._orthoLeft = Number.MAX_VALUE;
        this._orthoRight = Number.MIN_VALUE;
        this._orthoTop = Number.MIN_VALUE;
        this._orthoBottom = Number.MAX_VALUE;
        this.position = direction.scale(-1);
        this.direction = direction;
    }
    /**
     * Returns the string "DirectionalLight".
     * @returns The class name
     */ getClassName() {
        return "DirectionalLight";
    }
    /**
     * Returns the integer 1.
     * @returns The light Type id as a constant defines in Light.LIGHTTYPEID_x
     */ getTypeID() {
        return (0, $c6YWJ.Light).LIGHTTYPEID_DIRECTIONALLIGHT;
    }
    /**
     * Sets the passed matrix "matrix" as projection matrix for the shadows cast by the light according to the passed view matrix.
     * Returns the DirectionalLight Shadow projection matrix.
     * @param matrix
     * @param viewMatrix
     * @param renderList
     */ _setDefaultShadowProjectionMatrix(matrix, viewMatrix, renderList) {
        if (this.shadowFrustumSize > 0) this._setDefaultFixedFrustumShadowProjectionMatrix(matrix);
        else this._setDefaultAutoExtendShadowProjectionMatrix(matrix, viewMatrix, renderList);
    }
    /**
     * Sets the passed matrix "matrix" as fixed frustum projection matrix for the shadows cast by the light according to the passed view matrix.
     * Returns the DirectionalLight Shadow projection matrix.
     * @param matrix
     */ _setDefaultFixedFrustumShadowProjectionMatrix(matrix) {
        const activeCamera = this.getScene().activeCamera;
        if (!activeCamera) return;
        (0, $ha1VO.Matrix).OrthoLHToRef(this.shadowFrustumSize, this.shadowFrustumSize, this.shadowMinZ !== undefined ? this.shadowMinZ : activeCamera.minZ, this.shadowMaxZ !== undefined ? this.shadowMaxZ : activeCamera.maxZ, matrix, this.getScene().getEngine().isNDCHalfZRange);
    }
    /**
     * Sets the passed matrix "matrix" as auto extend projection matrix for the shadows cast by the light according to the passed view matrix.
     * Returns the DirectionalLight Shadow projection matrix.
     * @param matrix
     * @param viewMatrix
     * @param renderList
     */ _setDefaultAutoExtendShadowProjectionMatrix(matrix, viewMatrix, renderList) {
        const activeCamera = this.getScene().activeCamera;
        if (!activeCamera) return;
        // Check extends
        if (this.autoUpdateExtends || this._orthoLeft === Number.MAX_VALUE) {
            const tempVector3 = (0, $ha1VO.Vector3).Zero();
            this._orthoLeft = Number.MAX_VALUE;
            this._orthoRight = -Number.MAX_VALUE;
            this._orthoTop = -Number.MAX_VALUE;
            this._orthoBottom = Number.MAX_VALUE;
            let shadowMinZ = Number.MAX_VALUE;
            let shadowMaxZ = -Number.MAX_VALUE;
            for(let meshIndex = 0; meshIndex < renderList.length; meshIndex++){
                const mesh = renderList[meshIndex];
                if (!mesh) continue;
                const boundingInfo = mesh.getBoundingInfo();
                const boundingBox = boundingInfo.boundingBox;
                for(let index = 0; index < boundingBox.vectorsWorld.length; index++){
                    (0, $ha1VO.Vector3).TransformCoordinatesToRef(boundingBox.vectorsWorld[index], viewMatrix, tempVector3);
                    if (tempVector3.x < this._orthoLeft) this._orthoLeft = tempVector3.x;
                    if (tempVector3.y < this._orthoBottom) this._orthoBottom = tempVector3.y;
                    if (tempVector3.x > this._orthoRight) this._orthoRight = tempVector3.x;
                    if (tempVector3.y > this._orthoTop) this._orthoTop = tempVector3.y;
                    if (this.autoCalcShadowZBounds) {
                        if (tempVector3.z < shadowMinZ) shadowMinZ = tempVector3.z;
                        if (tempVector3.z > shadowMaxZ) shadowMaxZ = tempVector3.z;
                    }
                }
            }
            if (this.autoCalcShadowZBounds) {
                this._shadowMinZ = shadowMinZ;
                this._shadowMaxZ = shadowMaxZ;
            }
        }
        const xOffset = this._orthoRight - this._orthoLeft;
        const yOffset = this._orthoTop - this._orthoBottom;
        const minZ = this.shadowMinZ !== undefined ? this.shadowMinZ : activeCamera.minZ;
        const maxZ = this.shadowMaxZ !== undefined ? this.shadowMaxZ : activeCamera.maxZ;
        const useReverseDepthBuffer = this.getScene().getEngine().useReverseDepthBuffer;
        (0, $ha1VO.Matrix).OrthoOffCenterLHToRef(this._orthoLeft - xOffset * this.shadowOrthoScale, this._orthoRight + xOffset * this.shadowOrthoScale, this._orthoBottom - yOffset * this.shadowOrthoScale, this._orthoTop + yOffset * this.shadowOrthoScale, useReverseDepthBuffer ? maxZ : minZ, useReverseDepthBuffer ? minZ : maxZ, matrix, this.getScene().getEngine().isNDCHalfZRange);
    }
    _buildUniformLayout() {
        this._uniformBuffer.addUniform("vLightData", 4);
        this._uniformBuffer.addUniform("vLightDiffuse", 4);
        this._uniformBuffer.addUniform("vLightSpecular", 4);
        this._uniformBuffer.addUniform("shadowsInfo", 3);
        this._uniformBuffer.addUniform("depthValues", 2);
        this._uniformBuffer.create();
    }
    /**
     * Sets the passed Effect object with the DirectionalLight transformed position (or position if not parented) and the passed name.
     * @param effect The effect to update
     * @param lightIndex The index of the light in the effect to update
     * @returns The directional light
     */ transferToEffect(effect, lightIndex) {
        if (this.computeTransformedInformation()) {
            this._uniformBuffer.updateFloat4("vLightData", this.transformedDirection.x, this.transformedDirection.y, this.transformedDirection.z, 1, lightIndex);
            return this;
        }
        this._uniformBuffer.updateFloat4("vLightData", this.direction.x, this.direction.y, this.direction.z, 1, lightIndex);
        return this;
    }
    transferToNodeMaterialEffect(effect, lightDataUniformName) {
        if (this.computeTransformedInformation()) {
            effect.setFloat3(lightDataUniformName, this.transformedDirection.x, this.transformedDirection.y, this.transformedDirection.z);
            return this;
        }
        effect.setFloat3(lightDataUniformName, this.direction.x, this.direction.y, this.direction.z);
        return this;
    }
    /**
     * Gets the minZ used for shadow according to both the scene and the light.
     *
     * Values are fixed on directional lights as it relies on an ortho projection hence the need to convert being
     * -1 and 1 to 0 and 1 doing (depth + min) / (min + max) -> (depth + 1) / (1 + 1) -> (depth * 0.5) + 0.5.
     * (when not using reverse depth buffer / NDC half Z range)
     * @param activeCamera The camera we are returning the min for
     * @returns the depth min z
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getDepthMinZ(activeCamera) {
        const engine = this._scene.getEngine();
        return !engine.useReverseDepthBuffer && engine.isNDCHalfZRange ? 0 : 1;
    }
    /**
     * Gets the maxZ used for shadow according to both the scene and the light.
     *
     * Values are fixed on directional lights as it relies on an ortho projection hence the need to convert being
     * -1 and 1 to 0 and 1 doing (depth + min) / (min + max) -> (depth + 1) / (1 + 1) -> (depth * 0.5) + 0.5.
     * (when not using reverse depth buffer / NDC half Z range)
     * @param activeCamera The camera we are returning the max for
     * @returns the depth max z
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getDepthMaxZ(activeCamera) {
        const engine = this._scene.getEngine();
        return engine.useReverseDepthBuffer && engine.isNDCHalfZRange ? 0 : 1;
    }
    /**
     * Prepares the list of defines specific to the light type.
     * @param defines the list of defines
     * @param lightIndex defines the index of the light for the effect
     */ prepareLightSpecificDefines(defines, lightIndex) {
        defines["DIRLIGHT" + lightIndex] = true;
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $85a63e33b97cca4e$export$3fea33cc9972c868.prototype, "shadowFrustumSize", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $85a63e33b97cca4e$export$3fea33cc9972c868.prototype, "shadowOrthoScale", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $85a63e33b97cca4e$export$3fea33cc9972c868.prototype, "autoUpdateExtends", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $85a63e33b97cca4e$export$3fea33cc9972c868.prototype, "autoCalcShadowZBounds", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("orthoLeft")
], $85a63e33b97cca4e$export$3fea33cc9972c868.prototype, "_orthoLeft", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("orthoRight")
], $85a63e33b97cca4e$export$3fea33cc9972c868.prototype, "_orthoRight", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("orthoTop")
], $85a63e33b97cca4e$export$3fea33cc9972c868.prototype, "_orthoTop", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("orthoBottom")
], $85a63e33b97cca4e$export$3fea33cc9972c868.prototype, "_orthoBottom", void 0);

});
parcelRegister("lso8g", function(module, exports) {

$parcel$export(module.exports, "ShadowLight", () => $f9eeeead02b0c025$export$db3a8d88fb11daf4);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $ha1VO = parcelRequire("ha1VO");

var $c6YWJ = parcelRequire("c6YWJ");

var $dbxbu = parcelRequire("dbxbu");
class $f9eeeead02b0c025$export$db3a8d88fb11daf4 extends (0, $c6YWJ.Light) {
    constructor(){
        super(...arguments);
        this._needProjectionMatrixCompute = true;
        this._viewMatrix = (0, $ha1VO.Matrix).Identity();
        this._projectionMatrix = (0, $ha1VO.Matrix).Identity();
    }
    _setPosition(value) {
        this._position = value;
    }
    /**
     * Sets the position the shadow will be casted from. Also use as the light position for both
     * point and spot lights.
     */ get position() {
        return this._position;
    }
    /**
     * Sets the position the shadow will be casted from. Also use as the light position for both
     * point and spot lights.
     */ set position(value) {
        this._setPosition(value);
    }
    _setDirection(value) {
        this._direction = value;
    }
    /**
     * In 2d mode (needCube being false), gets the direction used to cast the shadow.
     * Also use as the light direction on spot and directional lights.
     */ get direction() {
        return this._direction;
    }
    /**
     * In 2d mode (needCube being false), sets the direction used to cast the shadow.
     * Also use as the light direction on spot and directional lights.
     */ set direction(value) {
        this._setDirection(value);
    }
    /**
     * Gets the shadow projection clipping minimum z value.
     */ get shadowMinZ() {
        return this._shadowMinZ;
    }
    /**
     * Sets the shadow projection clipping minimum z value.
     */ set shadowMinZ(value) {
        this._shadowMinZ = value;
        this.forceProjectionMatrixCompute();
    }
    /**
     * Sets the shadow projection clipping maximum z value.
     */ get shadowMaxZ() {
        return this._shadowMaxZ;
    }
    /**
     * Gets the shadow projection clipping maximum z value.
     */ set shadowMaxZ(value) {
        this._shadowMaxZ = value;
        this.forceProjectionMatrixCompute();
    }
    /**
     * Computes the transformed information (transformedPosition and transformedDirection in World space) of the current light
     * @returns true if the information has been computed, false if it does not need to (no parenting)
     */ computeTransformedInformation() {
        if (this.parent && this.parent.getWorldMatrix) {
            if (!this.transformedPosition) this.transformedPosition = (0, $ha1VO.Vector3).Zero();
            (0, $ha1VO.Vector3).TransformCoordinatesToRef(this.position, this.parent.getWorldMatrix(), this.transformedPosition);
            // In case the direction is present.
            if (this.direction) {
                if (!this.transformedDirection) this.transformedDirection = (0, $ha1VO.Vector3).Zero();
                (0, $ha1VO.Vector3).TransformNormalToRef(this.direction, this.parent.getWorldMatrix(), this.transformedDirection);
            }
            return true;
        }
        return false;
    }
    /**
     * Return the depth scale used for the shadow map.
     * @returns the depth scale.
     */ getDepthScale() {
        return 50.0;
    }
    /**
     * Get the direction to use to render the shadow map. In case of cube texture, the face index can be passed.
     * @param faceIndex The index of the face we are computed the direction to generate shadow
     * @returns The set direction in 2d mode otherwise the direction to the cubemap face if needCube() is true
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getShadowDirection(faceIndex) {
        return this.transformedDirection ? this.transformedDirection : this.direction;
    }
    /**
     * If computeTransformedInformation has been called, returns the ShadowLight absolute position in the world. Otherwise, returns the local position.
     * @returns the position vector in world space
     */ getAbsolutePosition() {
        return this.transformedPosition ? this.transformedPosition : this.position;
    }
    /**
     * Sets the ShadowLight direction toward the passed target.
     * @param target The point to target in local space
     * @returns the updated ShadowLight direction
     */ setDirectionToTarget(target) {
        this.direction = (0, $ha1VO.Vector3).Normalize(target.subtract(this.position));
        return this.direction;
    }
    /**
     * Returns the light rotation in euler definition.
     * @returns the x y z rotation in local space.
     */ getRotation() {
        this.direction.normalize();
        const xaxis = (0, $ha1VO.Vector3).Cross(this.direction, (0, $dbxbu.Axis).Y);
        const yaxis = (0, $ha1VO.Vector3).Cross(xaxis, this.direction);
        return (0, $ha1VO.Vector3).RotationFromAxis(xaxis, yaxis, this.direction);
    }
    /**
     * Returns whether or not the shadow generation require a cube texture or a 2d texture.
     * @returns true if a cube texture needs to be use
     */ needCube() {
        return false;
    }
    /**
     * Detects if the projection matrix requires to be recomputed this frame.
     * @returns true if it requires to be recomputed otherwise, false.
     */ needProjectionMatrixCompute() {
        return this._needProjectionMatrixCompute;
    }
    /**
     * Forces the shadow generator to recompute the projection matrix even if position and direction did not changed.
     */ forceProjectionMatrixCompute() {
        this._needProjectionMatrixCompute = true;
    }
    /** @internal */ _initCache() {
        super._initCache();
        this._cache.position = (0, $ha1VO.Vector3).Zero();
    }
    /** @internal */ _isSynchronized() {
        if (!this._cache.position.equals(this.position)) return false;
        return true;
    }
    /**
     * Computes the world matrix of the node
     * @param force defines if the cache version should be invalidated forcing the world matrix to be created from scratch
     * @returns the world matrix
     */ computeWorldMatrix(force) {
        if (!force && this.isSynchronized()) {
            this._currentRenderId = this.getScene().getRenderId();
            return this._worldMatrix;
        }
        this._updateCache();
        this._cache.position.copyFrom(this.position);
        if (!this._worldMatrix) this._worldMatrix = (0, $ha1VO.Matrix).Identity();
        (0, $ha1VO.Matrix).TranslationToRef(this.position.x, this.position.y, this.position.z, this._worldMatrix);
        if (this.parent && this.parent.getWorldMatrix) {
            this._worldMatrix.multiplyToRef(this.parent.getWorldMatrix(), this._worldMatrix);
            this._markSyncedWithParent();
        }
        // Cache the determinant
        this._worldMatrixDeterminantIsDirty = true;
        return this._worldMatrix;
    }
    /**
     * Gets the minZ used for shadow according to both the scene and the light.
     * @param activeCamera The camera we are returning the min for
     * @returns the depth min z
     */ getDepthMinZ(activeCamera) {
        return this.shadowMinZ !== undefined ? this.shadowMinZ : activeCamera.minZ;
    }
    /**
     * Gets the maxZ used for shadow according to both the scene and the light.
     * @param activeCamera The camera we are returning the max for
     * @returns the depth max z
     */ getDepthMaxZ(activeCamera) {
        return this.shadowMaxZ !== undefined ? this.shadowMaxZ : activeCamera.maxZ;
    }
    /**
     * Sets the shadow projection matrix in parameter to the generated projection matrix.
     * @param matrix The matrix to updated with the projection information
     * @param viewMatrix The transform matrix of the light
     * @param renderList The list of mesh to render in the map
     * @returns The current light
     */ setShadowProjectionMatrix(matrix, viewMatrix, renderList) {
        if (this.customProjectionMatrixBuilder) this.customProjectionMatrixBuilder(viewMatrix, renderList, matrix);
        else this._setDefaultShadowProjectionMatrix(matrix, viewMatrix, renderList);
        return this;
    }
    /** @internal */ _syncParentEnabledState() {
        super._syncParentEnabledState();
        if (!this.parent || !this.parent.getWorldMatrix) {
            this.transformedPosition = null;
            this.transformedDirection = null;
        }
    }
    /**
     * Returns the view matrix.
     * @param faceIndex The index of the face for which we want to extract the view matrix. Only used for point light types.
     * @returns The view matrix. Can be null, if a view matrix cannot be defined for the type of light considered (as for a hemispherical light, for example).
     */ getViewMatrix(faceIndex) {
        const lightDirection = (0, $ha1VO.TmpVectors).Vector3[0];
        let lightPosition = this.position;
        if (this.computeTransformedInformation()) lightPosition = this.transformedPosition;
        (0, $ha1VO.Vector3).NormalizeToRef(this.getShadowDirection(faceIndex), lightDirection);
        if (Math.abs((0, $ha1VO.Vector3).Dot(lightDirection, (0, $ha1VO.Vector3).Up())) === 1.0) lightDirection.z = 0.0000000000001; // Required to avoid perfectly perpendicular light
        const lightTarget = (0, $ha1VO.TmpVectors).Vector3[1];
        lightPosition.addToRef(lightDirection, lightTarget);
        (0, $ha1VO.Matrix).LookAtLHToRef(lightPosition, lightTarget, (0, $ha1VO.Vector3).Up(), this._viewMatrix);
        return this._viewMatrix;
    }
    /**
     * Returns the projection matrix.
     * Note that viewMatrix and renderList are optional and are only used by lights that calculate the projection matrix from a list of meshes (e.g. directional lights with automatic extents calculation).
     * @param viewMatrix The view transform matrix of the light (optional).
     * @param renderList The list of meshes to take into account when calculating the projection matrix (optional).
     * @returns The projection matrix. Can be null, if a projection matrix cannot be defined for the type of light considered (as for a hemispherical light, for example).
     */ getProjectionMatrix(viewMatrix, renderList) {
        this.setShadowProjectionMatrix(this._projectionMatrix, viewMatrix ?? this._viewMatrix, renderList ?? []);
        return this._projectionMatrix;
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsVector3)()
], $f9eeeead02b0c025$export$db3a8d88fb11daf4.prototype, "position", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsVector3)()
], $f9eeeead02b0c025$export$db3a8d88fb11daf4.prototype, "direction", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $f9eeeead02b0c025$export$db3a8d88fb11daf4.prototype, "shadowMinZ", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $f9eeeead02b0c025$export$db3a8d88fb11daf4.prototype, "shadowMaxZ", null);

});


parcelRegister("dRlRf", function(module, exports) {

$parcel$export(module.exports, "CreateHemisphere", () => $a1712e17d315ffd4$export$c9c054ebfd432288);
$parcel$export(module.exports, "HemisphereBuilder", () => $a1712e17d315ffd4$export$76a4e7b6787f72cc);

var $fbuqw = parcelRequire("fbuqw");

var $8KqOo = parcelRequire("8KqOo");

var $fWMvm = parcelRequire("fWMvm");
function $a1712e17d315ffd4$export$c9c054ebfd432288(name, options = {}, scene) {
    if (!options.diameter) options.diameter = 1;
    if (!options.segments) options.segments = 16;
    const halfSphere = (0, $8KqOo.CreateSphere)("", {
        slice: 0.5,
        diameter: options.diameter,
        segments: options.segments
    }, scene);
    const disc = (0, $fWMvm.CreateDisc)("", {
        radius: options.diameter / 2,
        tessellation: options.segments * 3 + (4 - options.segments)
    }, scene);
    disc.rotation.x = -Math.PI / 2;
    disc.parent = halfSphere;
    const merged = (0, $fbuqw.Mesh).MergeMeshes([
        disc,
        halfSphere
    ], true);
    merged.name = name;
    return merged;
}
const $a1712e17d315ffd4$export$76a4e7b6787f72cc = {
    CreateHemisphere: // eslint-disable-next-line @typescript-eslint/naming-convention
    $a1712e17d315ffd4$export$c9c054ebfd432288
};
/**
 * Creates a hemispheric light
 * @param name
 * @param segments
 * @param diameter
 * @param scene
 * @returns the mesh
 */ (0, $fbuqw.Mesh).CreateHemisphere = (name, segments, diameter, scene)=>{
    const options = {
        segments: segments,
        diameter: diameter
    };
    return $a1712e17d315ffd4$export$c9c054ebfd432288(name, options, scene);
};

});

parcelRegister("aYDyu", function(module, exports) {

$parcel$export(module.exports, "SpotLight", () => $7fde30cf8f1757e6$export$81495cbb73897362);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $ha1VO = parcelRequire("ha1VO");

var $bgssx = parcelRequire("bgssx");

var $c6YWJ = parcelRequire("c6YWJ");

var $lso8g = parcelRequire("lso8g");

var $j2mX5 = parcelRequire("j2mX5");
(0, $bgssx.Node).AddNodeConstructor("Light_Type_2", (name, scene)=>{
    return ()=>new $7fde30cf8f1757e6$export$81495cbb73897362(name, (0, $ha1VO.Vector3).Zero(), (0, $ha1VO.Vector3).Zero(), 0, 0, scene);
});
class $7fde30cf8f1757e6$export$81495cbb73897362 extends (0, $lso8g.ShadowLight) {
    /**
     * Gets the cone angle of the spot light in Radians.
     */ get angle() {
        return this._angle;
    }
    /**
     * Sets the cone angle of the spot light in Radians.
     */ set angle(value) {
        this._angle = value;
        this._cosHalfAngle = Math.cos(value * 0.5);
        this._projectionTextureProjectionLightDirty = true;
        this.forceProjectionMatrixCompute();
        this._computeAngleValues();
    }
    /**
     * Only used in gltf falloff mode, this defines the angle where
     * the directional falloff will start before cutting at angle which could be seen
     * as outer angle.
     */ get innerAngle() {
        return this._innerAngle;
    }
    /**
     * Only used in gltf falloff mode, this defines the angle where
     * the directional falloff will start before cutting at angle which could be seen
     * as outer angle.
     */ set innerAngle(value) {
        this._innerAngle = value;
        this._computeAngleValues();
    }
    /**
     * Allows scaling the angle of the light for shadow generation only.
     */ get shadowAngleScale() {
        return this._shadowAngleScale;
    }
    /**
     * Allows scaling the angle of the light for shadow generation only.
     */ set shadowAngleScale(value) {
        this._shadowAngleScale = value;
        this.forceProjectionMatrixCompute();
    }
    /**
     * Allows reading the projection texture
     */ get projectionTextureMatrix() {
        return this._projectionTextureMatrix;
    }
    /**
     * Gets the near clip of the Spotlight for texture projection.
     */ get projectionTextureLightNear() {
        return this._projectionTextureLightNear;
    }
    /**
     * Sets the near clip of the Spotlight for texture projection.
     */ set projectionTextureLightNear(value) {
        this._projectionTextureLightNear = value;
        this._projectionTextureProjectionLightDirty = true;
    }
    /**
     * Gets the far clip of the Spotlight for texture projection.
     */ get projectionTextureLightFar() {
        return this._projectionTextureLightFar;
    }
    /**
     * Sets the far clip of the Spotlight for texture projection.
     */ set projectionTextureLightFar(value) {
        this._projectionTextureLightFar = value;
        this._projectionTextureProjectionLightDirty = true;
    }
    /**
     * Gets the Up vector of the Spotlight for texture projection.
     */ get projectionTextureUpDirection() {
        return this._projectionTextureUpDirection;
    }
    /**
     * Sets the Up vector of the Spotlight for texture projection.
     */ set projectionTextureUpDirection(value) {
        this._projectionTextureUpDirection = value;
        this._projectionTextureProjectionLightDirty = true;
    }
    /**
     * Gets the projection texture of the light.
     */ get projectionTexture() {
        return this._projectionTexture;
    }
    /**
     * Sets the projection texture of the light.
     */ set projectionTexture(value) {
        if (this._projectionTexture === value) return;
        this._projectionTexture = value;
        this._projectionTextureDirty = true;
        if (this._projectionTexture && !this._projectionTexture.isReady()) {
            if ($7fde30cf8f1757e6$export$81495cbb73897362._IsProceduralTexture(this._projectionTexture)) this._projectionTexture.getEffect().executeWhenCompiled(()=>{
                this._markMeshesAsLightDirty();
            });
            else if ($7fde30cf8f1757e6$export$81495cbb73897362._IsTexture(this._projectionTexture)) this._projectionTexture.onLoadObservable.addOnce(()=>{
                this._markMeshesAsLightDirty();
            });
        }
    }
    static _IsProceduralTexture(texture) {
        return texture.onGeneratedObservable !== undefined;
    }
    static _IsTexture(texture) {
        return texture.onLoadObservable !== undefined;
    }
    /**
     * Gets or sets the light projection matrix as used by the projection texture
     */ get projectionTextureProjectionLightMatrix() {
        return this._projectionTextureProjectionLightMatrix;
    }
    set projectionTextureProjectionLightMatrix(projection) {
        this._projectionTextureProjectionLightMatrix = projection;
        this._projectionTextureProjectionLightDirty = false;
        this._projectionTextureDirty = true;
    }
    /**
     * Creates a SpotLight object in the scene. A spot light is a simply light oriented cone.
     * It can cast shadows.
     * Documentation : https://doc.babylonjs.com/features/featuresDeepDive/lights/lights_introduction
     * @param name The light friendly name
     * @param position The position of the spot light in the scene
     * @param direction The direction of the light in the scene
     * @param angle The cone angle of the light in Radians
     * @param exponent The light decay speed with the distance from the emission spot
     * @param scene The scene the lights belongs to
     */ constructor(name, position, direction, angle, exponent, scene){
        super(name, scene);
        this._innerAngle = 0;
        this._projectionTextureMatrix = (0, $ha1VO.Matrix).Zero();
        this._projectionTextureLightNear = 1e-6;
        this._projectionTextureLightFar = 1000.0;
        this._projectionTextureUpDirection = (0, $ha1VO.Vector3).Up();
        this._projectionTextureViewLightDirty = true;
        this._projectionTextureProjectionLightDirty = true;
        this._projectionTextureDirty = true;
        this._projectionTextureViewTargetVector = (0, $ha1VO.Vector3).Zero();
        this._projectionTextureViewLightMatrix = (0, $ha1VO.Matrix).Zero();
        this._projectionTextureProjectionLightMatrix = (0, $ha1VO.Matrix).Zero();
        this._projectionTextureScalingMatrix = (0, $ha1VO.Matrix).FromValues(0.5, 0.0, 0.0, 0.0, 0.0, 0.5, 0.0, 0.0, 0.0, 0.0, 0.5, 0.0, 0.5, 0.5, 0.5, 1.0);
        this.position = position;
        this.direction = direction;
        this.angle = angle;
        this.exponent = exponent;
    }
    /**
     * Returns the string "SpotLight".
     * @returns the class name
     */ getClassName() {
        return "SpotLight";
    }
    /**
     * Returns the integer 2.
     * @returns The light Type id as a constant defines in Light.LIGHTTYPEID_x
     */ getTypeID() {
        return (0, $c6YWJ.Light).LIGHTTYPEID_SPOTLIGHT;
    }
    /**
     * Overrides the direction setter to recompute the projection texture view light Matrix.
     * @param value
     */ _setDirection(value) {
        super._setDirection(value);
        this._projectionTextureViewLightDirty = true;
    }
    /**
     * Overrides the position setter to recompute the projection texture view light Matrix.
     * @param value
     */ _setPosition(value) {
        super._setPosition(value);
        this._projectionTextureViewLightDirty = true;
    }
    /**
     * Sets the passed matrix "matrix" as perspective projection matrix for the shadows and the passed view matrix with the fov equal to the SpotLight angle and and aspect ratio of 1.0.
     * Returns the SpotLight.
     * @param matrix
     * @param viewMatrix
     * @param renderList
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _setDefaultShadowProjectionMatrix(matrix, viewMatrix, renderList) {
        const activeCamera = this.getScene().activeCamera;
        if (!activeCamera) return;
        this._shadowAngleScale = this._shadowAngleScale || 1;
        const angle = this._shadowAngleScale * this._angle;
        const minZ = this.shadowMinZ !== undefined ? this.shadowMinZ : activeCamera.minZ;
        const maxZ = this.shadowMaxZ !== undefined ? this.shadowMaxZ : activeCamera.maxZ;
        const useReverseDepthBuffer = this.getScene().getEngine().useReverseDepthBuffer;
        (0, $ha1VO.Matrix).PerspectiveFovLHToRef(angle, 1.0, useReverseDepthBuffer ? maxZ : minZ, useReverseDepthBuffer ? minZ : maxZ, matrix, true, this._scene.getEngine().isNDCHalfZRange, undefined, useReverseDepthBuffer);
    }
    _computeProjectionTextureViewLightMatrix() {
        this._projectionTextureViewLightDirty = false;
        this._projectionTextureDirty = true;
        this.getAbsolutePosition().addToRef(this.getShadowDirection(), this._projectionTextureViewTargetVector);
        (0, $ha1VO.Matrix).LookAtLHToRef(this.getAbsolutePosition(), this._projectionTextureViewTargetVector, this._projectionTextureUpDirection, this._projectionTextureViewLightMatrix);
    }
    _computeProjectionTextureProjectionLightMatrix() {
        this._projectionTextureProjectionLightDirty = false;
        this._projectionTextureDirty = true;
        const lightFar = this.projectionTextureLightFar;
        const lightNear = this.projectionTextureLightNear;
        const P = lightFar / (lightFar - lightNear);
        const Q = -P * lightNear;
        const S = 1.0 / Math.tan(this._angle / 2.0);
        const A = 1.0;
        (0, $ha1VO.Matrix).FromValuesToRef(S / A, 0.0, 0.0, 0.0, 0.0, S, 0.0, 0.0, 0.0, 0.0, P, 1.0, 0.0, 0.0, Q, 0.0, this._projectionTextureProjectionLightMatrix);
    }
    /**
     * Main function for light texture projection matrix computing.
     */ _computeProjectionTextureMatrix() {
        this._projectionTextureDirty = false;
        this._projectionTextureViewLightMatrix.multiplyToRef(this._projectionTextureProjectionLightMatrix, this._projectionTextureMatrix);
        if (this._projectionTexture instanceof (0, $j2mX5.Texture)) {
            const u = this._projectionTexture.uScale / 2.0;
            const v = this._projectionTexture.vScale / 2.0;
            (0, $ha1VO.Matrix).FromValuesToRef(u, 0.0, 0.0, 0.0, 0.0, v, 0.0, 0.0, 0.0, 0.0, 0.5, 0.0, 0.5, 0.5, 0.5, 1.0, this._projectionTextureScalingMatrix);
        }
        this._projectionTextureMatrix.multiplyToRef(this._projectionTextureScalingMatrix, this._projectionTextureMatrix);
    }
    _buildUniformLayout() {
        this._uniformBuffer.addUniform("vLightData", 4);
        this._uniformBuffer.addUniform("vLightDiffuse", 4);
        this._uniformBuffer.addUniform("vLightSpecular", 4);
        this._uniformBuffer.addUniform("vLightDirection", 3);
        this._uniformBuffer.addUniform("vLightFalloff", 4);
        this._uniformBuffer.addUniform("shadowsInfo", 3);
        this._uniformBuffer.addUniform("depthValues", 2);
        this._uniformBuffer.create();
    }
    _computeAngleValues() {
        this._lightAngleScale = 1.0 / Math.max(0.001, Math.cos(this._innerAngle * 0.5) - this._cosHalfAngle);
        this._lightAngleOffset = -this._cosHalfAngle * this._lightAngleScale;
    }
    /**
     * Sets the passed Effect "effect" with the Light textures.
     * @param effect The effect to update
     * @param lightIndex The index of the light in the effect to update
     * @returns The light
     */ transferTexturesToEffect(effect, lightIndex) {
        if (this.projectionTexture && this.projectionTexture.isReady()) {
            if (this._projectionTextureViewLightDirty) this._computeProjectionTextureViewLightMatrix();
            if (this._projectionTextureProjectionLightDirty) this._computeProjectionTextureProjectionLightMatrix();
            if (this._projectionTextureDirty) this._computeProjectionTextureMatrix();
            effect.setMatrix("textureProjectionMatrix" + lightIndex, this._projectionTextureMatrix);
            effect.setTexture("projectionLightSampler" + lightIndex, this.projectionTexture);
        }
        return this;
    }
    /**
     * Sets the passed Effect object with the SpotLight transformed position (or position if not parented) and normalized direction.
     * @param effect The effect to update
     * @param lightIndex The index of the light in the effect to update
     * @returns The spot light
     */ transferToEffect(effect, lightIndex) {
        let normalizeDirection;
        if (this.computeTransformedInformation()) {
            this._uniformBuffer.updateFloat4("vLightData", this.transformedPosition.x, this.transformedPosition.y, this.transformedPosition.z, this.exponent, lightIndex);
            normalizeDirection = (0, $ha1VO.Vector3).Normalize(this.transformedDirection);
        } else {
            this._uniformBuffer.updateFloat4("vLightData", this.position.x, this.position.y, this.position.z, this.exponent, lightIndex);
            normalizeDirection = (0, $ha1VO.Vector3).Normalize(this.direction);
        }
        this._uniformBuffer.updateFloat4("vLightDirection", normalizeDirection.x, normalizeDirection.y, normalizeDirection.z, this._cosHalfAngle, lightIndex);
        this._uniformBuffer.updateFloat4("vLightFalloff", this.range, this._inverseSquaredRange, this._lightAngleScale, this._lightAngleOffset, lightIndex);
        return this;
    }
    transferToNodeMaterialEffect(effect, lightDataUniformName) {
        let normalizeDirection;
        if (this.computeTransformedInformation()) normalizeDirection = (0, $ha1VO.Vector3).Normalize(this.transformedDirection);
        else normalizeDirection = (0, $ha1VO.Vector3).Normalize(this.direction);
        if (this.getScene().useRightHandedSystem) effect.setFloat3(lightDataUniformName, -normalizeDirection.x, -normalizeDirection.y, -normalizeDirection.z);
        else effect.setFloat3(lightDataUniformName, normalizeDirection.x, normalizeDirection.y, normalizeDirection.z);
        return this;
    }
    /**
     * Disposes the light and the associated resources.
     */ dispose() {
        super.dispose();
        if (this._projectionTexture) this._projectionTexture.dispose();
    }
    /**
     * Gets the minZ used for shadow according to both the scene and the light.
     * @param activeCamera The camera we are returning the min for
     * @returns the depth min z
     */ getDepthMinZ(activeCamera) {
        const engine = this._scene.getEngine();
        const minZ = this.shadowMinZ !== undefined ? this.shadowMinZ : activeCamera.minZ;
        return engine.useReverseDepthBuffer && engine.isNDCHalfZRange ? minZ : this._scene.getEngine().isNDCHalfZRange ? 0 : minZ;
    }
    /**
     * Gets the maxZ used for shadow according to both the scene and the light.
     * @param activeCamera The camera we are returning the max for
     * @returns the depth max z
     */ getDepthMaxZ(activeCamera) {
        const engine = this._scene.getEngine();
        const maxZ = this.shadowMaxZ !== undefined ? this.shadowMaxZ : activeCamera.maxZ;
        return engine.useReverseDepthBuffer && engine.isNDCHalfZRange ? 0 : maxZ;
    }
    /**
     * Prepares the list of defines specific to the light type.
     * @param defines the list of defines
     * @param lightIndex defines the index of the light for the effect
     */ prepareLightSpecificDefines(defines, lightIndex) {
        defines["SPOTLIGHT" + lightIndex] = true;
        defines["PROJECTEDLIGHTTEXTURE" + lightIndex] = this.projectionTexture && this.projectionTexture.isReady() ? true : false;
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7fde30cf8f1757e6$export$81495cbb73897362.prototype, "angle", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7fde30cf8f1757e6$export$81495cbb73897362.prototype, "innerAngle", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7fde30cf8f1757e6$export$81495cbb73897362.prototype, "shadowAngleScale", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7fde30cf8f1757e6$export$81495cbb73897362.prototype, "exponent", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7fde30cf8f1757e6$export$81495cbb73897362.prototype, "projectionTextureLightNear", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7fde30cf8f1757e6$export$81495cbb73897362.prototype, "projectionTextureLightFar", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $7fde30cf8f1757e6$export$81495cbb73897362.prototype, "projectionTextureUpDirection", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)("projectedLightTexture")
], $7fde30cf8f1757e6$export$81495cbb73897362.prototype, "_projectionTexture", void 0);

});


parcelRegister("6m5Bu", function(module, exports) {

$parcel$export(module.exports, "CameraGizmo", () => $4a0924eedc334ca4$export$4ef2404af9e3f660);

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $fbuqw = parcelRequire("fbuqw");

var $5ETkU = parcelRequire("5ETkU");

var $6mCYU = parcelRequire("6mCYU");

var $gAH3H = parcelRequire("gAH3H");

var $4C7Qm = parcelRequire("4C7Qm");

var $9zY5k = parcelRequire("9zY5k");
parcelRequire("6rxfP");
var $ha1VO = parcelRequire("ha1VO");

var $8Eyol = parcelRequire("8Eyol");

var $cfkw4 = parcelRequire("cfkw4");

var $diGQf = parcelRequire("diGQf");
class $4a0924eedc334ca4$export$4ef2404af9e3f660 extends (0, $5ETkU.Gizmo) {
    /**
     * Creates a CameraGizmo
     * @param gizmoLayer The utility layer the gizmo will be added to
     * @param gizmoColor Camera mesh color. Default is Gray
     * @param frustumLinesColor Frustum lines color. Default is White
     */ constructor(gizmoLayer = (0, $6mCYU.UtilityLayerRenderer).DefaultUtilityLayer, gizmoColor, frustumLinesColor){
        super(gizmoLayer);
        this._pointerObserver = null;
        /**
         * Event that fires each time the gizmo is clicked
         */ this.onClickedObservable = new (0, $diGQf.Observable)();
        this._camera = null;
        this._invProjection = new (0, $ha1VO.Matrix)();
        this._material = new (0, $gAH3H.StandardMaterial)("cameraGizmoMaterial", this.gizmoLayer.utilityLayerScene);
        this._frustumLinesColor = frustumLinesColor;
        this._material.diffuseColor = gizmoColor ?? new (0, $7etnY.Color3)(0.5, 0.5, 0.5);
        this._material.specularColor = new (0, $7etnY.Color3)(0.1, 0.1, 0.1);
        this._pointerObserver = gizmoLayer.utilityLayerScene.onPointerObservable.add((pointerInfo)=>{
            if (!this._camera) return;
            this._isHovered = !!(pointerInfo.pickInfo && this._rootMesh.getChildMeshes().indexOf(pointerInfo.pickInfo.pickedMesh) != -1);
            if (this._isHovered && pointerInfo.event.button === 0) this.onClickedObservable.notifyObservers(this._camera);
        }, (0, $cfkw4.PointerEventTypes).POINTERDOWN);
    }
    /** Gets or sets a boolean indicating if frustum lines must be rendered (true by default)) */ get displayFrustum() {
        return this._cameraLinesMesh.isEnabled();
    }
    set displayFrustum(value) {
        this._cameraLinesMesh.setEnabled(value);
    }
    /**
     * The camera that the gizmo is attached to
     */ set camera(camera) {
        this._camera = camera;
        this.attachedNode = camera;
        if (camera) {
            // Create the mesh for the given camera
            if (!this._customMeshSet) {
                if (this._cameraMesh) this._cameraMesh.dispose();
                this._cameraMesh = $4a0924eedc334ca4$export$4ef2404af9e3f660._CreateCameraMesh(this.gizmoLayer.utilityLayerScene);
                this._cameraMesh.getChildMeshes(false).forEach((m)=>{
                    m.material = this._material;
                });
                this._cameraMesh.parent = this._rootMesh;
            }
            if (this._cameraLinesMesh) this._cameraLinesMesh.dispose();
            const linesColor = this._frustumLinesColor?.toColor4(1) ?? new (0, $7etnY.Color4)(1, 1, 1, 1);
            this._cameraLinesMesh = $4a0924eedc334ca4$export$4ef2404af9e3f660._CreateCameraFrustum(this.gizmoLayer.utilityLayerScene, linesColor);
            this._cameraLinesMesh.parent = this._rootMesh;
            if (this.gizmoLayer.utilityLayerScene.activeCamera && this.gizmoLayer.utilityLayerScene.activeCamera.maxZ < camera.maxZ * 1.5) this.gizmoLayer.utilityLayerScene.activeCamera.maxZ = camera.maxZ * 1.5;
            if (!this.attachedNode.reservedDataStore) this.attachedNode.reservedDataStore = {};
            this.attachedNode.reservedDataStore.cameraGizmo = this;
            // Add lighting to the camera gizmo
            const gizmoLight = this.gizmoLayer._getSharedGizmoLight();
            gizmoLight.includedOnlyMeshes = gizmoLight.includedOnlyMeshes.concat(this._cameraMesh.getChildMeshes(false));
            this._update();
        }
    }
    get camera() {
        return this._camera;
    }
    /**
     * Gets the material used to render the camera gizmo
     */ get material() {
        return this._material;
    }
    /**
     * @internal
     * Updates the gizmo to match the attached mesh's position/rotation
     */ _update() {
        super._update();
        if (!this._camera) return;
        // frustum matrix
        this._camera.getProjectionMatrix().invertToRef(this._invProjection);
        this._cameraLinesMesh.setPivotMatrix(this._invProjection, false);
        this._cameraLinesMesh.scaling.x = 1 / this._rootMesh.scaling.x;
        this._cameraLinesMesh.scaling.y = 1 / this._rootMesh.scaling.y;
        this._cameraLinesMesh.scaling.z = 1 / this._rootMesh.scaling.z;
        // take care of coordinate system in camera scene to properly display the mesh with the good Y axis orientation in this scene
        this._cameraMesh.parent = null;
        this._cameraMesh.rotation.y = Math.PI * 0.5 * (this._camera.getScene().useRightHandedSystem ? 1 : -1);
        this._cameraMesh.parent = this._rootMesh;
    }
    /**
     * Disposes and replaces the current camera mesh in the gizmo with the specified mesh
     * @param mesh The mesh to replace the default mesh of the camera gizmo
     */ setCustomMesh(mesh) {
        if (mesh.getScene() != this.gizmoLayer.utilityLayerScene) // eslint-disable-next-line no-throw-literal
        throw "When setting a custom mesh on a gizmo, the custom meshes scene must be the same as the gizmos (eg. gizmo.gizmoLayer.utilityLayerScene)";
        if (this._cameraMesh) this._cameraMesh.dispose();
        this._cameraMesh = mesh;
        this._cameraMesh.parent = this._rootMesh;
        this._customMeshSet = true;
    }
    /**
     * Disposes of the camera gizmo
     */ dispose() {
        this.onClickedObservable.clear();
        this.gizmoLayer.utilityLayerScene.onPointerObservable.remove(this._pointerObserver);
        if (this._cameraMesh) this._cameraMesh.dispose();
        if (this._cameraLinesMesh) this._cameraLinesMesh.dispose();
        this._material.dispose();
        super.dispose();
    }
    static _CreateCameraMesh(scene) {
        const root = new (0, $fbuqw.Mesh)("rootCameraGizmo", scene);
        const mesh = new (0, $fbuqw.Mesh)(root.name, scene);
        mesh.parent = root;
        const box = (0, $4C7Qm.CreateBox)(root.name, {
            width: 1.0,
            height: 0.8,
            depth: 0.5
        }, scene);
        box.parent = mesh;
        const cyl1 = (0, $9zY5k.CreateCylinder)(root.name, {
            height: 0.5,
            diameterTop: 0.8,
            diameterBottom: 0.8
        }, scene);
        cyl1.parent = mesh;
        cyl1.position.y = 0.3;
        cyl1.position.x = -0.6;
        cyl1.rotation.x = Math.PI * 0.5;
        const cyl2 = (0, $9zY5k.CreateCylinder)(root.name, {
            height: 0.5,
            diameterTop: 0.6,
            diameterBottom: 0.6
        }, scene);
        cyl2.parent = mesh;
        cyl2.position.y = 0.5;
        cyl2.position.x = 0.4;
        cyl2.rotation.x = Math.PI * 0.5;
        const cyl3 = (0, $9zY5k.CreateCylinder)(root.name, {
            height: 0.5,
            diameterTop: 0.5,
            diameterBottom: 0.5
        }, scene);
        cyl3.parent = mesh;
        cyl3.position.y = 0.0;
        cyl3.position.x = 0.6;
        cyl3.rotation.z = Math.PI * 0.5;
        root.scaling.scaleInPlace($4a0924eedc334ca4$export$4ef2404af9e3f660._Scale);
        mesh.position.x = -0.9;
        return root;
    }
    static _CreateCameraFrustum(scene, linesColor) {
        const root = new (0, $fbuqw.Mesh)("rootCameraGizmo", scene);
        const mesh = new (0, $fbuqw.Mesh)(root.name, scene);
        mesh.parent = root;
        for(let y = 0; y < 4; y += 2)for(let x = 0; x < 4; x += 2){
            let line = (0, $8Eyol.CreateLines)("lines", {
                points: [
                    new (0, $ha1VO.Vector3)(-1 + x, -1 + y, -1),
                    new (0, $ha1VO.Vector3)(-1 + x, -1 + y, 1)
                ],
                colors: [
                    linesColor,
                    linesColor
                ]
            }, scene);
            line.parent = mesh;
            line.alwaysSelectAsActiveMesh = true;
            line.isPickable = false;
            line = (0, $8Eyol.CreateLines)("lines", {
                points: [
                    new (0, $ha1VO.Vector3)(-1, -1 + x, -1 + y),
                    new (0, $ha1VO.Vector3)(1, -1 + x, -1 + y)
                ],
                colors: [
                    linesColor,
                    linesColor
                ]
            }, scene);
            line.parent = mesh;
            line.alwaysSelectAsActiveMesh = true;
            line.isPickable = false;
            line = (0, $8Eyol.CreateLines)("lines", {
                points: [
                    new (0, $ha1VO.Vector3)(-1 + x, -1, -1 + y),
                    new (0, $ha1VO.Vector3)(-1 + x, 1, -1 + y)
                ],
                colors: [
                    linesColor,
                    linesColor
                ]
            }, scene);
            line.parent = mesh;
            line.alwaysSelectAsActiveMesh = true;
            line.isPickable = false;
        }
        return root;
    }
}
// Static helper methods
$4a0924eedc334ca4$export$4ef2404af9e3f660._Scale = 0.05;

});


parcelRegister("kWvPW", function(module, exports) {

var $eRBiN = parcelRequire("eRBiN");

var $7cG3W = parcelRequire("7cG3W");

var $7jk2q = parcelRequire("7jk2q");

var $1nCYs = parcelRequire("1nCYs");
$parcel$exportWildcard(module.exports, $eRBiN);
$parcel$exportWildcard(module.exports, $7cG3W);
$parcel$exportWildcard(module.exports, $7jk2q);
$parcel$exportWildcard(module.exports, $1nCYs);

});
parcelRegister("eRBiN", function(module, exports) {

$parcel$export(module.exports, "EnvironmentHelper", () => $ad22f35b7c36af1d$export$dfeb54dd5b9491fa);

var $diGQf = parcelRequire("diGQf");

var $jIhlp = parcelRequire("jIhlp");

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $fbuqw = parcelRequire("fbuqw");

var $akOl3 = parcelRequire("akOl3");

var $j2mX5 = parcelRequire("j2mX5");

var $73LGq = parcelRequire("73LGq");

var $iPQLf = parcelRequire("iPQLf");

var $fZkIz = parcelRequire("fZkIz");

var $kt6s5 = parcelRequire("kt6s5");

var $4C7Qm = parcelRequire("4C7Qm");

var $23POp = parcelRequire("23POp");
class $ad22f35b7c36af1d$export$dfeb54dd5b9491fa {
    /**
     * Creates the default options for the helper.
     * @param scene The scene the environment helper belongs to.
     * @returns default options for the helper.
     */ static _GetDefaultOptions(scene) {
        return {
            createGround: true,
            groundSize: 15,
            groundTexture: this._GroundTextureCDNUrl,
            groundColor: new (0, $7etnY.Color3)(0.2, 0.2, 0.3).toLinearSpace(scene.getEngine().useExactSrgbConversions).scale(3),
            groundOpacity: 0.9,
            enableGroundShadow: true,
            groundShadowLevel: 0.5,
            enableGroundMirror: false,
            groundMirrorSizeRatio: 0.3,
            groundMirrorBlurKernel: 64,
            groundMirrorAmount: 1,
            groundMirrorFresnelWeight: 1,
            groundMirrorFallOffDistance: 0,
            groundMirrorTextureType: 0,
            groundYBias: 0.00001,
            createSkybox: true,
            skyboxSize: 20,
            skyboxTexture: this._SkyboxTextureCDNUrl,
            skyboxColor: new (0, $7etnY.Color3)(0.2, 0.2, 0.3).toLinearSpace(scene.getEngine().useExactSrgbConversions).scale(3),
            backgroundYRotation: 0,
            sizeAuto: true,
            rootPosition: (0, $ha1VO.Vector3).Zero(),
            setupImageProcessing: true,
            environmentTexture: this._EnvironmentTextureCDNUrl,
            cameraExposure: 0.8,
            cameraContrast: 1.2,
            toneMappingEnabled: true
        };
    }
    /**
     * Gets the root mesh created by the helper.
     */ get rootMesh() {
        return this._rootMesh;
    }
    /**
     * Gets the skybox created by the helper.
     */ get skybox() {
        return this._skybox;
    }
    /**
     * Gets the skybox texture created by the helper.
     */ get skyboxTexture() {
        return this._skyboxTexture;
    }
    /**
     * Gets the skybox material created by the helper.
     */ get skyboxMaterial() {
        return this._skyboxMaterial;
    }
    /**
     * Gets the ground mesh created by the helper.
     */ get ground() {
        return this._ground;
    }
    /**
     * Gets the ground texture created by the helper.
     */ get groundTexture() {
        return this._groundTexture;
    }
    /**
     * Gets the ground mirror created by the helper.
     */ get groundMirror() {
        return this._groundMirror;
    }
    /**
     * Gets the ground mirror render list to helps pushing the meshes
     * you wish in the ground reflection.
     */ get groundMirrorRenderList() {
        if (this._groundMirror) return this._groundMirror.renderList;
        return null;
    }
    /**
     * Gets the ground material created by the helper.
     */ get groundMaterial() {
        return this._groundMaterial;
    }
    /**
     * constructor
     * @param options Defines the options we want to customize the helper
     * @param scene The scene to add the material to
     */ constructor(options, scene){
        this._errorHandler = (message, exception)=>{
            this.onErrorObservable.notifyObservers({
                message: message,
                exception: exception
            });
        };
        this._options = {
            ...$ad22f35b7c36af1d$export$dfeb54dd5b9491fa._GetDefaultOptions(scene),
            ...options
        };
        this._scene = scene;
        this.onErrorObservable = new (0, $diGQf.Observable)();
        this._setupBackground();
        this._setupImageProcessing();
    }
    /**
     * Updates the environment according to the new options
     * @param options options to configure the helper (IEnvironmentHelperOptions)
     */ updateOptions(options) {
        const newOptions = {
            ...this._options,
            ...options
        };
        if (this._ground && !newOptions.createGround) {
            this._ground.dispose();
            this._ground = null;
        }
        if (this._groundMaterial && !newOptions.createGround) {
            this._groundMaterial.dispose();
            this._groundMaterial = null;
        }
        if (this._groundTexture) {
            if (this._options.groundTexture != newOptions.groundTexture) {
                this._groundTexture.dispose();
                this._groundTexture = null;
            }
        }
        if (this._skybox && !newOptions.createSkybox) {
            this._skybox.dispose();
            this._skybox = null;
        }
        if (this._skyboxMaterial && !newOptions.createSkybox) {
            this._skyboxMaterial.dispose();
            this._skyboxMaterial = null;
        }
        if (this._skyboxTexture) {
            if (this._options.skyboxTexture != newOptions.skyboxTexture) {
                this._skyboxTexture.dispose();
                this._skyboxTexture = null;
            }
        }
        if (this._groundMirror && !newOptions.enableGroundMirror) {
            this._groundMirror.dispose();
            this._groundMirror = null;
        }
        if (this._scene.environmentTexture) {
            if (this._options.environmentTexture != newOptions.environmentTexture) this._scene.environmentTexture.dispose();
        }
        this._options = newOptions;
        this._setupBackground();
        this._setupImageProcessing();
    }
    /**
     * Sets the primary color of all the available elements.
     * @param color the main color to affect to the ground and the background
     */ setMainColor(color) {
        if (this.groundMaterial) this.groundMaterial.primaryColor = color;
        if (this.skyboxMaterial) this.skyboxMaterial.primaryColor = color;
        if (this.groundMirror) this.groundMirror.clearColor = new (0, $7etnY.Color4)(color.r, color.g, color.b, 1.0);
    }
    /**
     * Setup the image processing according to the specified options.
     */ _setupImageProcessing() {
        if (this._options.setupImageProcessing) {
            this._scene.imageProcessingConfiguration.contrast = this._options.cameraContrast;
            this._scene.imageProcessingConfiguration.exposure = this._options.cameraExposure;
            this._scene.imageProcessingConfiguration.toneMappingEnabled = this._options.toneMappingEnabled;
            this._setupEnvironmentTexture();
        }
    }
    /**
     * Setup the environment texture according to the specified options.
     */ _setupEnvironmentTexture() {
        if (this._scene.environmentTexture) return;
        if (this._options.environmentTexture instanceof (0, $akOl3.BaseTexture)) {
            this._scene.environmentTexture = this._options.environmentTexture;
            return;
        }
        const environmentTexture = (0, $iPQLf.CubeTexture).CreateFromPrefilteredData(this._options.environmentTexture, this._scene);
        this._scene.environmentTexture = environmentTexture;
    }
    /**
     * Setup the background according to the specified options.
     */ _setupBackground() {
        if (!this._rootMesh) this._rootMesh = new (0, $fbuqw.Mesh)("BackgroundHelper", this._scene);
        this._rootMesh.rotation.y = this._options.backgroundYRotation;
        const sceneSize = this._getSceneSize();
        if (this._options.createGround) {
            this._setupGround(sceneSize);
            this._setupGroundMaterial();
            this._setupGroundDiffuseTexture();
            if (this._options.enableGroundMirror) this._setupGroundMirrorTexture(sceneSize);
            this._setupMirrorInGroundMaterial();
        }
        if (this._options.createSkybox) {
            this._setupSkybox(sceneSize);
            this._setupSkyboxMaterial();
            this._setupSkyboxReflectionTexture();
        }
        this._rootMesh.position.x = sceneSize.rootPosition.x;
        this._rootMesh.position.z = sceneSize.rootPosition.z;
        this._rootMesh.position.y = sceneSize.rootPosition.y;
    }
    /**
     * Get the scene sizes according to the setup.
     * @returns the different ground and skybox sizes.
     */ _getSceneSize() {
        let groundSize = this._options.groundSize;
        let skyboxSize = this._options.skyboxSize;
        let rootPosition = this._options.rootPosition;
        if (!this._scene.meshes || this._scene.meshes.length === 1) // 1 only means the root of the helper.
        return {
            groundSize: groundSize,
            skyboxSize: skyboxSize,
            rootPosition: rootPosition
        };
        const sceneExtends = this._scene.getWorldExtends((mesh)=>{
            return mesh !== this._ground && mesh !== this._rootMesh && mesh !== this._skybox;
        });
        const sceneDiagonal = sceneExtends.max.subtract(sceneExtends.min);
        if (this._options.sizeAuto) {
            if (this._scene.activeCamera instanceof (0, $jIhlp.ArcRotateCamera) && this._scene.activeCamera.upperRadiusLimit) {
                groundSize = this._scene.activeCamera.upperRadiusLimit * 2;
                skyboxSize = groundSize;
            }
            const sceneDiagonalLenght = sceneDiagonal.length();
            if (sceneDiagonalLenght > groundSize) {
                groundSize = sceneDiagonalLenght * 2;
                skyboxSize = groundSize;
            }
            // 10 % bigger.
            groundSize *= 1.1;
            skyboxSize *= 1.5;
            rootPosition = sceneExtends.min.add(sceneDiagonal.scale(0.5));
            rootPosition.y = sceneExtends.min.y - this._options.groundYBias;
        }
        return {
            groundSize: groundSize,
            skyboxSize: skyboxSize,
            rootPosition: rootPosition
        };
    }
    /**
     * Setup the ground according to the specified options.
     * @param sceneSize
     */ _setupGround(sceneSize) {
        if (!this._ground || this._ground.isDisposed()) {
            this._ground = (0, $kt6s5.CreatePlane)("BackgroundPlane", {
                size: sceneSize.groundSize
            }, this._scene);
            this._ground.rotation.x = Math.PI / 2; // Face up by default.
            this._ground.parent = this._rootMesh;
            this._ground.onDisposeObservable.add(()=>{
                this._ground = null;
            });
        }
        this._ground.receiveShadows = this._options.enableGroundShadow;
    }
    /**
     * Setup the ground material according to the specified options.
     */ _setupGroundMaterial() {
        if (!this._groundMaterial) this._groundMaterial = new (0, $fZkIz.BackgroundMaterial)("BackgroundPlaneMaterial", this._scene);
        this._groundMaterial.alpha = this._options.groundOpacity;
        this._groundMaterial.alphaMode = 8;
        this._groundMaterial.shadowLevel = this._options.groundShadowLevel;
        this._groundMaterial.primaryColor = this._options.groundColor;
        this._groundMaterial.useRGBColor = false;
        this._groundMaterial.enableNoise = true;
        if (this._ground) this._ground.material = this._groundMaterial;
    }
    /**
     * Setup the ground diffuse texture according to the specified options.
     */ _setupGroundDiffuseTexture() {
        if (!this._groundMaterial) return;
        if (this._groundTexture) return;
        if (this._options.groundTexture instanceof (0, $akOl3.BaseTexture)) {
            this._groundMaterial.diffuseTexture = this._options.groundTexture;
            return;
        }
        this._groundTexture = new (0, $j2mX5.Texture)(this._options.groundTexture, this._scene, undefined, undefined, undefined, undefined, this._errorHandler);
        this._groundTexture.gammaSpace = false;
        this._groundTexture.hasAlpha = true;
        this._groundMaterial.diffuseTexture = this._groundTexture;
    }
    /**
     * Setup the ground mirror texture according to the specified options.
     * @param sceneSize
     */ _setupGroundMirrorTexture(sceneSize) {
        const wrapping = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        if (!this._groundMirror) {
            this._groundMirror = new (0, $73LGq.MirrorTexture)("BackgroundPlaneMirrorTexture", {
                ratio: this._options.groundMirrorSizeRatio
            }, this._scene, false, this._options.groundMirrorTextureType, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, true);
            this._groundMirror.mirrorPlane = new (0, $23POp.Plane)(0, -1, 0, sceneSize.rootPosition.y);
            this._groundMirror.anisotropicFilteringLevel = 1;
            this._groundMirror.wrapU = wrapping;
            this._groundMirror.wrapV = wrapping;
            if (this._groundMirror.renderList) for(let i = 0; i < this._scene.meshes.length; i++){
                const mesh = this._scene.meshes[i];
                if (mesh !== this._ground && mesh !== this._skybox && mesh !== this._rootMesh) this._groundMirror.renderList.push(mesh);
            }
        }
        const gammaGround = this._options.groundColor.toGammaSpace(this._scene.getEngine().useExactSrgbConversions);
        this._groundMirror.clearColor = new (0, $7etnY.Color4)(gammaGround.r, gammaGround.g, gammaGround.b, 1);
        this._groundMirror.adaptiveBlurKernel = this._options.groundMirrorBlurKernel;
    }
    /**
     * Setup the ground to receive the mirror texture.
     */ _setupMirrorInGroundMaterial() {
        if (this._groundMaterial) {
            this._groundMaterial.reflectionTexture = this._groundMirror;
            this._groundMaterial.reflectionFresnel = true;
            this._groundMaterial.reflectionAmount = this._options.groundMirrorAmount;
            this._groundMaterial.reflectionStandardFresnelWeight = this._options.groundMirrorFresnelWeight;
            this._groundMaterial.reflectionFalloffDistance = this._options.groundMirrorFallOffDistance;
        }
    }
    /**
     * Setup the skybox according to the specified options.
     * @param sceneSize
     */ _setupSkybox(sceneSize) {
        if (!this._skybox || this._skybox.isDisposed()) {
            this._skybox = (0, $4C7Qm.CreateBox)("BackgroundSkybox", {
                size: sceneSize.skyboxSize,
                sideOrientation: (0, $fbuqw.Mesh).BACKSIDE
            }, this._scene);
            this._skybox.onDisposeObservable.add(()=>{
                this._skybox = null;
            });
        }
        this._skybox.parent = this._rootMesh;
    }
    /**
     * Setup the skybox material according to the specified options.
     */ _setupSkyboxMaterial() {
        if (!this._skybox) return;
        if (!this._skyboxMaterial) this._skyboxMaterial = new (0, $fZkIz.BackgroundMaterial)("BackgroundSkyboxMaterial", this._scene);
        this._skyboxMaterial.useRGBColor = false;
        this._skyboxMaterial.primaryColor = this._options.skyboxColor;
        this._skyboxMaterial.enableNoise = true;
        this._skybox.material = this._skyboxMaterial;
    }
    /**
     * Setup the skybox reflection texture according to the specified options.
     */ _setupSkyboxReflectionTexture() {
        if (!this._skyboxMaterial) return;
        if (this._skyboxTexture) return;
        if (this._options.skyboxTexture instanceof (0, $akOl3.BaseTexture)) {
            this._skyboxMaterial.reflectionTexture = this._options.skyboxTexture;
            return;
        }
        this._skyboxTexture = new (0, $iPQLf.CubeTexture)(this._options.skyboxTexture, this._scene, undefined, undefined, undefined, undefined, this._errorHandler);
        this._skyboxTexture.coordinatesMode = (0, $j2mX5.Texture).SKYBOX_MODE;
        this._skyboxTexture.gammaSpace = false;
        this._skyboxMaterial.reflectionTexture = this._skyboxTexture;
    }
    /**
     * Dispose all the elements created by the Helper.
     */ dispose() {
        if (this._groundMaterial) this._groundMaterial.dispose(true, true);
        if (this._skyboxMaterial) this._skyboxMaterial.dispose(true, true);
        this._rootMesh.dispose(false);
    }
}
/**
 * Default ground texture URL.
 */ $ad22f35b7c36af1d$export$dfeb54dd5b9491fa._GroundTextureCDNUrl = "https://assets.babylonjs.com/environments/backgroundGround.png";
/**
 * Default skybox texture URL.
 */ $ad22f35b7c36af1d$export$dfeb54dd5b9491fa._SkyboxTextureCDNUrl = "https://assets.babylonjs.com/environments/backgroundSkybox.dds";
/**
 * Default environment texture URL.
 */ $ad22f35b7c36af1d$export$dfeb54dd5b9491fa._EnvironmentTextureCDNUrl = "https://assets.babylonjs.com/environments/environmentSpecular.env";

});
parcelRegister("73LGq", function(module, exports) {

$parcel$export(module.exports, "MirrorTexture", () => $523dcd1ed89d12c2$export$8a8abf616fe78953);

var $ha1VO = parcelRequire("ha1VO");

var $j2mX5 = parcelRequire("j2mX5");

var $gQtNK = parcelRequire("gQtNK");

var $8zEq7 = parcelRequire("8zEq7");

var $23POp = parcelRequire("23POp");
class $523dcd1ed89d12c2$export$8a8abf616fe78953 extends (0, $gQtNK.RenderTargetTexture) {
    /**
     * Define the blur ratio used to blur the reflection if needed.
     */ set blurRatio(value) {
        if (this._blurRatio === value) return;
        this._blurRatio = value;
        this._preparePostProcesses();
    }
    get blurRatio() {
        return this._blurRatio;
    }
    /**
     * Define the adaptive blur kernel used to blur the reflection if needed.
     * This will autocompute the closest best match for the `blurKernel`
     */ set adaptiveBlurKernel(value) {
        this._adaptiveBlurKernel = value;
        this._autoComputeBlurKernel();
    }
    /**
     * Define the blur kernel used to blur the reflection if needed.
     * Please consider using `adaptiveBlurKernel` as it could find the closest best value for you.
     */ set blurKernel(value) {
        this.blurKernelX = value;
        this.blurKernelY = value;
    }
    /**
     * Define the blur kernel on the X Axis used to blur the reflection if needed.
     * Please consider using `adaptiveBlurKernel` as it could find the closest best value for you.
     */ set blurKernelX(value) {
        if (this._blurKernelX === value) return;
        this._blurKernelX = value;
        this._preparePostProcesses();
    }
    get blurKernelX() {
        return this._blurKernelX;
    }
    /**
     * Define the blur kernel on the Y Axis used to blur the reflection if needed.
     * Please consider using `adaptiveBlurKernel` as it could find the closest best value for you.
     */ set blurKernelY(value) {
        if (this._blurKernelY === value) return;
        this._blurKernelY = value;
        this._preparePostProcesses();
    }
    get blurKernelY() {
        return this._blurKernelY;
    }
    _autoComputeBlurKernel() {
        const engine = this.getScene().getEngine();
        const dw = this.getRenderWidth() / engine.getRenderWidth();
        const dh = this.getRenderHeight() / engine.getRenderHeight();
        this.blurKernelX = this._adaptiveBlurKernel * dw;
        this.blurKernelY = this._adaptiveBlurKernel * dh;
    }
    _onRatioRescale() {
        if (this._sizeRatio) {
            this.resize(this._initialSizeParameter);
            if (!this._adaptiveBlurKernel) this._preparePostProcesses();
        }
        if (this._adaptiveBlurKernel) this._autoComputeBlurKernel();
    }
    _updateGammaSpace() {
        const scene = this.getScene();
        if (!scene) return;
        this.gammaSpace = !scene.imageProcessingConfiguration.isEnabled || !scene.imageProcessingConfiguration.applyByPostProcess;
    }
    /**
     * Instantiates a Mirror Texture.
     * Mirror texture can be used to simulate the view from a mirror in a scene.
     * It will dynamically be rendered every frame to adapt to the camera point of view.
     * You can then easily use it as a reflectionTexture on a flat surface.
     * In case the surface is not a plane, please consider relying on reflection probes.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/reflectionTexture#mirrors
     * @param name
     * @param size
     * @param scene
     * @param generateMipMaps
     * @param type
     * @param samplingMode
     * @param generateDepthBuffer
     */ constructor(name, size, scene, generateMipMaps, type = 0, samplingMode = (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, generateDepthBuffer = true){
        super(name, size, scene, generateMipMaps, true, type, false, samplingMode, generateDepthBuffer);
        /**
         * Define the reflection plane we want to use. The mirrorPlane is usually set to the constructed reflector.
         * It is possible to directly set the mirrorPlane by directly using a Plane(a, b, c, d) where a, b and c give the plane normal vector (a, b, c) and d is a scalar displacement from the mirrorPlane to the origin. However in all but the very simplest of situations it is more straight forward to set it to the reflector as stated in the doc.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/reflectionTexture#mirrors
         */ this.mirrorPlane = new (0, $23POp.Plane)(0, 1, 0, 1);
        this._transformMatrix = (0, $ha1VO.Matrix).Zero();
        this._mirrorMatrix = (0, $ha1VO.Matrix).Zero();
        this._adaptiveBlurKernel = 0;
        this._blurKernelX = 0;
        this._blurKernelY = 0;
        this._blurRatio = 1.0;
        scene = this.getScene();
        if (!scene) return this;
        this.ignoreCameraViewport = true;
        this._updateGammaSpace();
        this._imageProcessingConfigChangeObserver = scene.imageProcessingConfiguration.onUpdateParameters.add(()=>{
            this._updateGammaSpace();
        });
        const engine = scene.getEngine();
        if (engine.supportsUniformBuffers) this._sceneUBO = scene.createSceneUniformBuffer(`Scene for Mirror Texture (name "${name}")`);
        this.onBeforeBindObservable.add(()=>{
            engine._debugPushGroup?.(`mirror generation for ${name}`, 1);
        });
        this.onAfterUnbindObservable.add(()=>{
            engine._debugPopGroup?.(1);
        });
        let saveClipPlane;
        this.onBeforeRenderObservable.add(()=>{
            if (this._sceneUBO) {
                this._currentSceneUBO = scene.getSceneUniformBuffer();
                scene.setSceneUniformBuffer(this._sceneUBO);
                scene.getSceneUniformBuffer().unbindEffect();
            }
            (0, $ha1VO.Matrix).ReflectionToRef(this.mirrorPlane, this._mirrorMatrix);
            this._mirrorMatrix.multiplyToRef(scene.getViewMatrix(), this._transformMatrix);
            scene.setTransformMatrix(this._transformMatrix, scene.getProjectionMatrix());
            saveClipPlane = scene.clipPlane;
            scene.clipPlane = this.mirrorPlane;
            scene._mirroredCameraPosition = (0, $ha1VO.Vector3).TransformCoordinates(scene.activeCamera.globalPosition, this._mirrorMatrix);
        });
        this.onAfterRenderObservable.add(()=>{
            if (this._sceneUBO) scene.setSceneUniformBuffer(this._currentSceneUBO);
            scene.updateTransformMatrix();
            scene._mirroredCameraPosition = null;
            scene.clipPlane = saveClipPlane;
        });
    }
    _preparePostProcesses() {
        this.clearPostProcesses(true);
        if (this._blurKernelX && this._blurKernelY) {
            const engine = this.getScene().getEngine();
            const textureType = engine.getCaps().textureFloatRender && engine.getCaps().textureFloatLinearFiltering ? 1 : 2;
            this._blurX = new (0, $8zEq7.BlurPostProcess)("horizontal blur", new (0, $ha1VO.Vector2)(1.0, 0), this._blurKernelX, this._blurRatio, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, engine, false, textureType);
            this._blurX.autoClear = false;
            if (this._blurRatio === 1 && this.samples < 2 && this._texture) this._blurX.inputTexture = this._renderTarget;
            else this._blurX.alwaysForcePOT = true;
            this._blurY = new (0, $8zEq7.BlurPostProcess)("vertical blur", new (0, $ha1VO.Vector2)(0, 1.0), this._blurKernelY, this._blurRatio, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, engine, false, textureType);
            this._blurY.autoClear = false;
            this._blurY.alwaysForcePOT = this._blurRatio !== 1;
            this.addPostProcess(this._blurX);
            this.addPostProcess(this._blurY);
        } else {
            if (this._blurY) {
                this.removePostProcess(this._blurY);
                this._blurY.dispose();
                this._blurY = null;
            }
            if (this._blurX) {
                this.removePostProcess(this._blurX);
                this._blurX.dispose();
                this._blurX = null;
            }
        }
    }
    /**
     * Clone the mirror texture.
     * @returns the cloned texture
     */ clone() {
        const scene = this.getScene();
        if (!scene) return this;
        const textureSize = this.getSize();
        const newTexture = new $523dcd1ed89d12c2$export$8a8abf616fe78953(this.name, textureSize.width, scene, this._renderTargetOptions.generateMipMaps, this._renderTargetOptions.type, this._renderTargetOptions.samplingMode, this._renderTargetOptions.generateDepthBuffer);
        // Base texture
        newTexture.hasAlpha = this.hasAlpha;
        newTexture.level = this.level;
        // Mirror Texture
        newTexture.mirrorPlane = this.mirrorPlane.clone();
        if (this.renderList) newTexture.renderList = this.renderList.slice(0);
        return newTexture;
    }
    /**
     * Serialize the texture to a JSON representation you could use in Parse later on
     * @returns the serialized JSON representation
     */ serialize() {
        if (!this.name) return null;
        const serializationObject = super.serialize();
        serializationObject.mirrorPlane = this.mirrorPlane.asArray();
        return serializationObject;
    }
    /**
     * Dispose the texture and release its associated resources.
     */ dispose() {
        super.dispose();
        const scene = this.getScene();
        if (scene) scene.imageProcessingConfiguration.onUpdateParameters.remove(this._imageProcessingConfigChangeObserver);
        this._sceneUBO?.dispose();
    }
}
(0, $j2mX5.Texture)._CreateMirror = (name, renderTargetSize, scene, generateMipMaps)=>{
    return new $523dcd1ed89d12c2$export$8a8abf616fe78953(name, renderTargetSize, scene, generateMipMaps);
};

});
parcelRegister("8zEq7", function(module, exports) {

$parcel$export(module.exports, "BlurPostProcess", () => $63e0f23f4d60836a$export$795ea0a3577bbc67);

var $e0Suo = parcelRequire("e0Suo");

var $cFdBb = parcelRequire("cFdBb");

var $j2mX5 = parcelRequire("j2mX5");
parcelRequire("cYx3A");
parcelRequire("hp1tn");

var $8DoUR = parcelRequire("8DoUR");

var $ir0rz = parcelRequire("ir0rz");

var $6Ho1L = parcelRequire("6Ho1L");
class $63e0f23f4d60836a$export$795ea0a3577bbc67 extends (0, $cFdBb.PostProcess) {
    /**
     * Sets the length in pixels of the blur sample region
     */ set kernel(v) {
        if (this._idealKernel === v) return;
        v = Math.max(v, 1);
        this._idealKernel = v;
        this._kernel = this._nearestBestKernel(v);
        if (!this._blockCompilation) this._updateParameters();
    }
    /**
     * Gets the length in pixels of the blur sample region
     */ get kernel() {
        return this._idealKernel;
    }
    /**
     * Sets whether or not the blur needs to unpack/repack floats
     */ set packedFloat(v) {
        if (this._packedFloat === v) return;
        this._packedFloat = v;
        if (!this._blockCompilation) this._updateParameters();
    }
    /**
     * Gets whether or not the blur is unpacking/repacking floats
     */ get packedFloat() {
        return this._packedFloat;
    }
    /**
     * Gets a string identifying the name of the class
     * @returns "BlurPostProcess" string
     */ getClassName() {
        return "BlurPostProcess";
    }
    /**
     * Creates a new instance BlurPostProcess
     * @param name The name of the effect.
     * @param direction The direction in which to blur the image.
     * @param kernel The size of the kernel to be used when computing the blur. eg. Size of 3 will blur the center pixel by 2 pixels surrounding it.
     * @param options The required width/height ratio to downsize to before computing the render pass. (Use 1.0 for full size)
     * @param camera The camera to apply the render pass to.
     * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
     * @param engine The engine which the post process will be applied. (default: current engine)
     * @param reusable If the post process can be reused on the same frame. (default: false)
     * @param textureType Type of textures used when performing the post process. (default: 0)
     * @param defines
     * @param _blockCompilation If compilation of the shader should not be done in the constructor. The updateEffect method can be used to compile the shader at a later time. (default: false)
     * @param textureFormat Format of textures used when performing the post process. (default: TEXTUREFORMAT_RGBA)
     */ constructor(name, direction, kernel, options, camera, samplingMode = (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, engine, reusable, textureType = 0, defines = "", _blockCompilation = false, textureFormat = 5){
        super(name, "kernelBlur", [
            "delta",
            "direction"
        ], [
            "circleOfConfusionSampler"
        ], options, camera, samplingMode, engine, reusable, null, textureType, "kernelBlur", {
            varyingCount: 0,
            depCount: 0
        }, true, textureFormat);
        this._blockCompilation = _blockCompilation;
        this._packedFloat = false;
        this._staticDefines = "";
        this._staticDefines = defines;
        this.direction = direction;
        this.onApplyObservable.add((effect)=>{
            if (this._outputTexture) effect.setFloat2("delta", 1 / this._outputTexture.width * this.direction.x, 1 / this._outputTexture.height * this.direction.y);
            else effect.setFloat2("delta", 1 / this.width * this.direction.x, 1 / this.height * this.direction.y);
        });
        this.kernel = kernel;
    }
    /**
     * Updates the effect with the current post process compile time values and recompiles the shader.
     * @param defines Define statements that should be added at the beginning of the shader. (default: null)
     * @param uniforms Set of uniform variables that will be passed to the shader. (default: null)
     * @param samplers Set of Texture2D variables that will be passed to the shader. (default: null)
     * @param indexParameters The index parameters to be used for babylons include syntax "#include<kernelBlurVaryingDeclaration>[0..varyingCount]". (default: undefined) See usage in babylon.blurPostProcess.ts and kernelBlur.vertex.fx
     * @param onCompiled Called when the shader has been compiled.
     * @param onError Called if there is an error when compiling a shader.
     */ updateEffect(defines = null, uniforms = null, samplers = null, indexParameters, onCompiled, onError) {
        this._updateParameters(onCompiled, onError);
    }
    _updateParameters(onCompiled, onError) {
        // Generate sampling offsets and weights
        const N = this._kernel;
        const centerIndex = (N - 1) / 2;
        // Generate Gaussian sampling weights over kernel
        let offsets = [];
        let weights = [];
        let totalWeight = 0;
        for(let i = 0; i < N; i++){
            const u = i / (N - 1);
            const w = this._gaussianWeight(u * 2.0 - 1);
            offsets[i] = i - centerIndex;
            weights[i] = w;
            totalWeight += w;
        }
        // Normalize weights
        for(let i = 0; i < weights.length; i++)weights[i] /= totalWeight;
        // Optimize: combine samples to take advantage of hardware linear sampling
        // Walk from left to center, combining pairs (symmetrically)
        const linearSamplingWeights = [];
        const linearSamplingOffsets = [];
        const linearSamplingMap = [];
        for(let i = 0; i <= centerIndex; i += 2){
            const j = Math.min(i + 1, Math.floor(centerIndex));
            const singleCenterSample = i === j;
            if (singleCenterSample) linearSamplingMap.push({
                o: offsets[i],
                w: weights[i]
            });
            else {
                const sharedCell = j === centerIndex;
                const weightLinear = weights[i] + weights[j] * (sharedCell ? 0.5 : 1);
                const offsetLinear = offsets[i] + 1 / (1 + weights[i] / weights[j]);
                if (offsetLinear === 0) {
                    linearSamplingMap.push({
                        o: offsets[i],
                        w: weights[i]
                    });
                    linearSamplingMap.push({
                        o: offsets[i + 1],
                        w: weights[i + 1]
                    });
                } else {
                    linearSamplingMap.push({
                        o: offsetLinear,
                        w: weightLinear
                    });
                    linearSamplingMap.push({
                        o: -offsetLinear,
                        w: weightLinear
                    });
                }
            }
        }
        for(let i = 0; i < linearSamplingMap.length; i++){
            linearSamplingOffsets[i] = linearSamplingMap[i].o;
            linearSamplingWeights[i] = linearSamplingMap[i].w;
        }
        // Replace with optimized
        offsets = linearSamplingOffsets;
        weights = linearSamplingWeights;
        // Generate shaders
        const maxVaryingRows = this.getEngine().getCaps().maxVaryingVectors;
        const freeVaryingVec2 = Math.max(maxVaryingRows, 0) - 1; // Because of sampleCenter
        let varyingCount = Math.min(offsets.length, freeVaryingVec2);
        let defines = "";
        defines += this._staticDefines;
        // The DOF fragment should ignore the center pixel when looping as it is handled manually in the fragment shader.
        if (this._staticDefines.indexOf("DOF") != -1) {
            defines += `#define CENTER_WEIGHT ${this._glslFloat(weights[varyingCount - 1])}\n`;
            varyingCount--;
        }
        for(let i = 0; i < varyingCount; i++){
            defines += `#define KERNEL_OFFSET${i} ${this._glslFloat(offsets[i])}\n`;
            defines += `#define KERNEL_WEIGHT${i} ${this._glslFloat(weights[i])}\n`;
        }
        let depCount = 0;
        for(let i = freeVaryingVec2; i < offsets.length; i++){
            defines += `#define KERNEL_DEP_OFFSET${depCount} ${this._glslFloat(offsets[i])}\n`;
            defines += `#define KERNEL_DEP_WEIGHT${depCount} ${this._glslFloat(weights[i])}\n`;
            depCount++;
        }
        if (this.packedFloat) defines += `#define PACKEDFLOAT 1`;
        this._blockCompilation = false;
        super.updateEffect(defines, null, null, {
            varyingCount: varyingCount,
            depCount: depCount
        }, onCompiled, onError);
    }
    /**
     * Best kernels are odd numbers that when divided by 2, their integer part is even, so 5, 9 or 13.
     * Other odd kernels optimize correctly but require proportionally more samples, even kernels are
     * possible but will produce minor visual artifacts. Since each new kernel requires a new shader we
     * want to minimize kernel changes, having gaps between physical kernels is helpful in that regard.
     * The gaps between physical kernels are compensated for in the weighting of the samples
     * @param idealKernel Ideal blur kernel.
     * @returns Nearest best kernel.
     */ _nearestBestKernel(idealKernel) {
        const v = Math.round(idealKernel);
        for (const k of [
            v,
            v - 1,
            v + 1,
            v - 2,
            v + 2
        ]){
            if (k % 2 !== 0 && Math.floor(k / 2) % 2 === 0 && k > 0) return Math.max(k, 3);
        }
        return Math.max(v, 3);
    }
    /**
     * Calculates the value of a Gaussian distribution with sigma 3 at a given point.
     * @param x The point on the Gaussian distribution to sample.
     * @returns the value of the Gaussian function at x.
     */ _gaussianWeight(x) {
        //reference: Engines/ImageProcessingBlur.cpp #dcc760
        // We are evaluating the Gaussian (normal) distribution over a kernel parameter space of [-1,1],
        // so we truncate at three standard deviations by setting stddev (sigma) to 1/3.
        // The choice of 3-sigma truncation is common but arbitrary, and means that the signal is
        // truncated at around 1.3% of peak strength.
        //the distribution is scaled to account for the difference between the actual kernel size and the requested kernel size
        const sigma = 1 / 3;
        const denominator = Math.sqrt(2.0 * Math.PI) * sigma;
        const exponent = -(x * x / (2.0 * sigma * sigma));
        const weight = 1.0 / denominator * Math.exp(exponent);
        return weight;
    }
    /**
     * Generates a string that can be used as a floating point number in GLSL.
     * @param x Value to print.
     * @param decimalFigures Number of decimal places to print the number to (excluding trailing 0s).
     * @returns GLSL float string.
     */ _glslFloat(x, decimalFigures = 8) {
        return x.toFixed(decimalFigures).replace(/0+$/, "");
    }
    /**
     * @internal
     */ static _Parse(parsedPostProcess, targetCamera, scene, rootUrl) {
        return (0, $6Ho1L.SerializationHelper).Parse(()=>{
            return new $63e0f23f4d60836a$export$795ea0a3577bbc67(parsedPostProcess.name, parsedPostProcess.direction, parsedPostProcess.kernel, parsedPostProcess.options, targetCamera, parsedPostProcess.renderTargetSamplingMode, scene.getEngine(), parsedPostProcess.reusable, parsedPostProcess.textureType, undefined, false);
        }, parsedPostProcess, scene, rootUrl);
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("kernel")
], $63e0f23f4d60836a$export$795ea0a3577bbc67.prototype, "_kernel", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("packedFloat")
], $63e0f23f4d60836a$export$795ea0a3577bbc67.prototype, "_packedFloat", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsVector2)()
], $63e0f23f4d60836a$export$795ea0a3577bbc67.prototype, "direction", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.BlurPostProcess", $63e0f23f4d60836a$export$795ea0a3577bbc67);

});
parcelRegister("cYx3A", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("cF2Or");
parcelRequire("SJ1ad");
parcelRequire("ahLsG");
parcelRequire("lW4Rx");
const $9724bb0734577f6f$var$name = "kernelBlurPixelShader";
const $9724bb0734577f6f$var$shader = `uniform sampler2D textureSampler;uniform vec2 delta;varying vec2 sampleCenter;
#ifdef DOF
uniform sampler2D circleOfConfusionSampler;float sampleCoC(in vec2 offset) {float coc=texture2D(circleOfConfusionSampler,offset).r;return coc; }
#endif
#include<kernelBlurVaryingDeclaration>[0..varyingCount]
#ifdef PACKEDFLOAT
#include<packingFunctions>
#endif
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{float computedWeight=0.0;
#ifdef PACKEDFLOAT
float blend=0.;
#else
vec4 blend=vec4(0.);
#endif
#ifdef DOF
float sumOfWeights=CENTER_WEIGHT; 
float factor=0.0;
#ifdef PACKEDFLOAT
blend+=unpack(texture2D(textureSampler,sampleCenter))*CENTER_WEIGHT;
#else
blend+=texture2D(textureSampler,sampleCenter)*CENTER_WEIGHT;
#endif
#endif
#include<kernelBlurFragment>[0..varyingCount]
#include<kernelBlurFragment2>[0..depCount]
#ifdef PACKEDFLOAT
gl_FragColor=pack(blend);
#else
gl_FragColor=blend;
#endif
#ifdef DOF
gl_FragColor/=sumOfWeights;
#endif
}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$9724bb0734577f6f$var$name] = $9724bb0734577f6f$var$shader;
const $9724bb0734577f6f$export$fdd7271b08c0ca29 = {
    name: $9724bb0734577f6f$var$name,
    shader: $9724bb0734577f6f$var$shader
};

});
parcelRegister("cF2Or", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $937b7ee283259912$var$name = "kernelBlurVaryingDeclaration";
const $937b7ee283259912$var$shader = `varying vec2 sampleCoord{X};`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$937b7ee283259912$var$name] = $937b7ee283259912$var$shader;
const $937b7ee283259912$export$d35844ea5a881bd3 = {
    name: $937b7ee283259912$var$name,
    shader: $937b7ee283259912$var$shader
};

});

parcelRegister("SJ1ad", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $0a47f6da0d9d862c$var$name = "packingFunctions";
const $0a47f6da0d9d862c$var$shader = `vec4 pack(float depth)
{const vec4 bit_shift=vec4(255.0*255.0*255.0,255.0*255.0,255.0,1.0);const vec4 bit_mask=vec4(0.0,1.0/255.0,1.0/255.0,1.0/255.0);vec4 res=fract(depth*bit_shift);res-=res.xxyz*bit_mask;return res;}
float unpack(vec4 color)
{const vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(color,bit_shift);}`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$0a47f6da0d9d862c$var$name] = $0a47f6da0d9d862c$var$shader;
const $0a47f6da0d9d862c$export$7f38cc17ef09a889 = {
    name: $0a47f6da0d9d862c$var$name,
    shader: $0a47f6da0d9d862c$var$shader
};

});

parcelRegister("ahLsG", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $77d04eceb32822e5$var$name = "kernelBlurFragment";
const $77d04eceb32822e5$var$shader = `#ifdef DOF
factor=sampleCoC(sampleCoord{X}); 
computedWeight=KERNEL_WEIGHT{X}*factor;sumOfWeights+=computedWeight;
#else
computedWeight=KERNEL_WEIGHT{X};
#endif
#ifdef PACKEDFLOAT
blend+=unpack(texture2D(textureSampler,sampleCoord{X}))*computedWeight;
#else
blend+=texture2D(textureSampler,sampleCoord{X})*computedWeight;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$77d04eceb32822e5$var$name] = $77d04eceb32822e5$var$shader;
const $77d04eceb32822e5$export$9acf87c41f1a4d90 = {
    name: $77d04eceb32822e5$var$name,
    shader: $77d04eceb32822e5$var$shader
};

});

parcelRegister("lW4Rx", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $ff82c95bd47ca75d$var$name = "kernelBlurFragment2";
const $ff82c95bd47ca75d$var$shader = `#ifdef DOF
factor=sampleCoC(sampleCenter+delta*KERNEL_DEP_OFFSET{X});computedWeight=KERNEL_DEP_WEIGHT{X}*factor;sumOfWeights+=computedWeight;
#else
computedWeight=KERNEL_DEP_WEIGHT{X};
#endif
#ifdef PACKEDFLOAT
blend+=unpack(texture2D(textureSampler,sampleCenter+delta*KERNEL_DEP_OFFSET{X}))*computedWeight;
#else
blend+=texture2D(textureSampler,sampleCenter+delta*KERNEL_DEP_OFFSET{X})*computedWeight;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$ff82c95bd47ca75d$var$name] = $ff82c95bd47ca75d$var$shader;
const $ff82c95bd47ca75d$export$1bf7a6a4217a0c04 = {
    name: $ff82c95bd47ca75d$var$name,
    shader: $ff82c95bd47ca75d$var$shader
};

});


parcelRegister("hp1tn", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("cF2Or");
parcelRequire("bUaJR");
const $cab5e9f4f4b18b87$var$name = "kernelBlurVertexShader";
const $cab5e9f4f4b18b87$var$shader = `attribute vec2 position;uniform vec2 delta;varying vec2 sampleCenter;
#include<kernelBlurVaryingDeclaration>[0..varyingCount]
const vec2 madd=vec2(0.5,0.5);
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
sampleCenter=(position*madd+madd);
#include<kernelBlurVertex>[0..varyingCount]
gl_Position=vec4(position,0.0,1.0);
#define CUSTOM_VERTEX_MAIN_END
}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$cab5e9f4f4b18b87$var$name] = $cab5e9f4f4b18b87$var$shader;
const $cab5e9f4f4b18b87$export$7e79b5e014ad6a9 = {
    name: $cab5e9f4f4b18b87$var$name,
    shader: $cab5e9f4f4b18b87$var$shader
};

});
parcelRegister("bUaJR", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $8aad41250e355cc2$var$name = "kernelBlurVertex";
const $8aad41250e355cc2$var$shader = `sampleCoord{X}=sampleCenter+delta*KERNEL_OFFSET{X};`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$8aad41250e355cc2$var$name] = $8aad41250e355cc2$var$shader;
const $8aad41250e355cc2$export$751be77142e51395 = {
    name: $8aad41250e355cc2$var$name,
    shader: $8aad41250e355cc2$var$shader
};

});




parcelRegister("iPQLf", function(module, exports) {

$parcel$export(module.exports, "CubeTexture", () => $db65eaaef195f2a6$export$ee2e5a18258a4049);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $bOhSV = parcelRequire("bOhSV");

var $ha1VO = parcelRequire("ha1VO");

var $akOl3 = parcelRequire("akOl3");

var $j2mX5 = parcelRequire("j2mX5");

var $8DoUR = parcelRequire("8DoUR");
parcelRequire("5jUKR");

var $diGQf = parcelRequire("diGQf");

var $6Ho1L = parcelRequire("6Ho1L");
class $db65eaaef195f2a6$export$ee2e5a18258a4049 extends (0, $akOl3.BaseTexture) {
    /**
     * Gets or sets the size of the bounding box associated with the cube texture
     * When defined, the cubemap will switch to local mode
     * @see https://community.arm.com/graphics/b/blog/posts/reflections-based-on-local-cubemaps-in-unity
     * @example https://www.babylonjs-playground.com/#RNASML
     */ set boundingBoxSize(value) {
        if (this._boundingBoxSize && this._boundingBoxSize.equals(value)) return;
        this._boundingBoxSize = value;
        const scene = this.getScene();
        if (scene) scene.markAllMaterialsAsDirty(1);
    }
    /**
     * Returns the bounding box size
     * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/reflectionTexture#using-local-cubemap-mode
     */ get boundingBoxSize() {
        return this._boundingBoxSize;
    }
    /**
     * Sets texture matrix rotation angle around Y axis in radians.
     */ set rotationY(value) {
        this._rotationY = value;
        this.setReflectionTextureMatrix((0, $ha1VO.Matrix).RotationY(this._rotationY));
    }
    /**
     * Gets texture matrix rotation angle around Y axis radians.
     */ get rotationY() {
        return this._rotationY;
    }
    /**
     * Are mip maps generated for this texture or not.
     */ get noMipmap() {
        return this._noMipmap;
    }
    /**
     * Gets the forced extension (if any)
     */ get forcedExtension() {
        return this._forcedExtension;
    }
    /**
     * Creates a cube texture from an array of image urls
     * @param files defines an array of image urls
     * @param scene defines the hosting scene
     * @param noMipmap specifies if mip maps are not used
     * @returns a cube texture
     */ static CreateFromImages(files, scene, noMipmap) {
        let rootUrlKey = "";
        files.forEach((url)=>rootUrlKey += url);
        return new $db65eaaef195f2a6$export$ee2e5a18258a4049(rootUrlKey, scene, null, noMipmap, files);
    }
    /**
     * Creates and return a texture created from prefilterd data by tools like IBL Baker or Lys.
     * @param url defines the url of the prefiltered texture
     * @param scene defines the scene the texture is attached to
     * @param forcedExtension defines the extension of the file if different from the url
     * @param createPolynomials defines whether or not to create polynomial harmonics from the texture data if necessary
     * @returns the prefiltered texture
     */ static CreateFromPrefilteredData(url, scene, forcedExtension = null, createPolynomials = true) {
        const oldValue = scene.useDelayedTextureLoading;
        scene.useDelayedTextureLoading = false;
        const result = new $db65eaaef195f2a6$export$ee2e5a18258a4049(url, scene, null, false, null, null, null, undefined, true, forcedExtension, createPolynomials);
        scene.useDelayedTextureLoading = oldValue;
        return result;
    }
    /**
     * Creates a cube texture to use with reflection for instance. It can be based upon dds or six images as well
     * as prefiltered data.
     * @param rootUrl defines the url of the texture or the root name of the six images
     * @param sceneOrEngine defines the scene or engine the texture is attached to
     * @param extensions defines the suffixes add to the picture name in case six images are in use like _px.jpg...
     * @param noMipmap defines if mipmaps should be created or not
     * @param files defines the six files to load for the different faces in that order: px, py, pz, nx, ny, nz
     * @param onLoad defines a callback triggered at the end of the file load if no errors occurred
     * @param onError defines a callback triggered in case of error during load
     * @param format defines the internal format to use for the texture once loaded
     * @param prefiltered defines whether or not the texture is created from prefiltered data
     * @param forcedExtension defines the extensions to use (force a special type of file to load) in case it is different from the file name
     * @param createPolynomials defines whether or not to create polynomial harmonics from the texture data if necessary
     * @param lodScale defines the scale applied to environment texture. This manages the range of LOD level used for IBL according to the roughness
     * @param lodOffset defines the offset applied to environment texture. This manages first LOD level used for IBL according to the roughness
     * @param loaderOptions options to be passed to the loader
     * @param useSRGBBuffer Defines if the texture must be loaded in a sRGB GPU buffer (if supported by the GPU) (default: false)
     * @returns the cube texture
     */ constructor(rootUrl, sceneOrEngine, extensions = null, noMipmap = false, files = null, onLoad = null, onError = null, format = 5, prefiltered = false, forcedExtension = null, createPolynomials = false, lodScale = 0.8, lodOffset = 0, loaderOptions, useSRGBBuffer){
        super(sceneOrEngine);
        this._lodScale = 0.8;
        this._lodOffset = 0;
        /**
         * Observable triggered once the texture has been loaded.
         */ this.onLoadObservable = new (0, $diGQf.Observable)();
        /**
         * Gets or sets the center of the bounding box associated with the cube texture.
         * It must define where the camera used to render the texture was set
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/reflectionTexture#using-local-cubemap-mode
         */ this.boundingBoxPosition = (0, $ha1VO.Vector3).Zero();
        this._rotationY = 0;
        /** @internal */ this._files = null;
        this._forcedExtension = null;
        this._extensions = null;
        this._textureMatrixRefraction = new (0, $ha1VO.Matrix)();
        this.name = rootUrl;
        this.url = rootUrl;
        this._noMipmap = noMipmap;
        this.hasAlpha = false;
        this._format = format;
        this.isCube = true;
        this._textureMatrix = (0, $ha1VO.Matrix).Identity();
        this._createPolynomials = createPolynomials;
        this.coordinatesMode = (0, $j2mX5.Texture).CUBIC_MODE;
        this._extensions = extensions;
        this._files = files;
        this._forcedExtension = forcedExtension;
        this._loaderOptions = loaderOptions;
        this._useSRGBBuffer = useSRGBBuffer;
        this._lodScale = lodScale;
        this._lodOffset = lodOffset;
        if (!rootUrl && !files) return;
        this.updateURL(rootUrl, forcedExtension, onLoad, prefiltered, onError, extensions, this.getScene()?.useDelayedTextureLoading, files);
    }
    /**
     * Get the current class name of the texture useful for serialization or dynamic coding.
     * @returns "CubeTexture"
     */ getClassName() {
        return "CubeTexture";
    }
    /**
     * Update the url (and optional buffer) of this texture if url was null during construction.
     * @param url the url of the texture
     * @param forcedExtension defines the extension to use
     * @param onLoad callback called when the texture is loaded  (defaults to null)
     * @param prefiltered Defines whether the updated texture is prefiltered or not
     * @param onError callback called if there was an error during the loading process (defaults to null)
     * @param extensions defines the suffixes add to the picture name in case six images are in use like _px.jpg...
     * @param delayLoad defines if the texture should be loaded now (false by default)
     * @param files defines the six files to load for the different faces in that order: px, py, pz, nx, ny, nz
     */ updateURL(url, forcedExtension, onLoad = null, prefiltered = false, onError = null, extensions = null, delayLoad = false, files = null) {
        if (!this.name || this.name.startsWith("data:")) this.name = url;
        this.url = url;
        if (forcedExtension) this._forcedExtension = forcedExtension;
        const lastDot = url.lastIndexOf(".");
        const extension = forcedExtension ? forcedExtension : lastDot > -1 ? url.substring(lastDot).toLowerCase() : "";
        const isDDS = extension.indexOf(".dds") === 0;
        const isEnv = extension.indexOf(".env") === 0;
        const isBasis = extension.indexOf(".basis") === 0;
        if (isEnv) {
            this.gammaSpace = false;
            this._prefiltered = false;
            this.anisotropicFilteringLevel = 1;
        } else {
            this._prefiltered = prefiltered;
            if (prefiltered) {
                this.gammaSpace = false;
                this.anisotropicFilteringLevel = 1;
            }
        }
        if (files) this._files = files;
        else {
            if (!isBasis && !isEnv && !isDDS && !extensions) extensions = [
                "_px.jpg",
                "_py.jpg",
                "_pz.jpg",
                "_nx.jpg",
                "_ny.jpg",
                "_nz.jpg"
            ];
            this._files = this._files || [];
            this._files.length = 0;
            if (extensions) {
                for(let index = 0; index < extensions.length; index++)this._files.push(url + extensions[index]);
                this._extensions = extensions;
            }
        }
        if (delayLoad) {
            this.delayLoadState = 4;
            this._delayedOnLoad = onLoad;
            this._delayedOnError = onError;
        } else this._loadTexture(onLoad, onError);
    }
    /**
     * Delays loading of the cube texture
     * @param forcedExtension defines the extension to use
     */ delayLoad(forcedExtension) {
        if (this.delayLoadState !== 4) return;
        if (forcedExtension) this._forcedExtension = forcedExtension;
        this.delayLoadState = 1;
        this._loadTexture(this._delayedOnLoad, this._delayedOnError);
    }
    /**
     * Returns the reflection texture matrix
     * @returns the reflection texture matrix
     */ getReflectionTextureMatrix() {
        return this._textureMatrix;
    }
    /**
     * Sets the reflection texture matrix
     * @param value Reflection texture matrix
     */ setReflectionTextureMatrix(value) {
        if (value.updateFlag === this._textureMatrix.updateFlag) return;
        if (value.isIdentity() !== this._textureMatrix.isIdentity()) this.getScene()?.markAllMaterialsAsDirty(1, (mat)=>mat.getActiveTextures().indexOf(this) !== -1);
        this._textureMatrix = value;
        if (!this.getScene()?.useRightHandedSystem) return;
        const scale = (0, $ha1VO.TmpVectors).Vector3[0];
        const quat = (0, $ha1VO.TmpVectors).Quaternion[0];
        const trans = (0, $ha1VO.TmpVectors).Vector3[1];
        this._textureMatrix.decompose(scale, quat, trans);
        quat.z *= -1; // these two operations correspond to negating the x and y euler angles
        quat.w *= -1;
        (0, $ha1VO.Matrix).ComposeToRef(scale, quat, trans, this._textureMatrixRefraction);
    }
    /**
     * Gets a suitable rotate/transform matrix when the texture is used for refraction.
     * There's a separate function from getReflectionTextureMatrix because refraction requires a special configuration of the matrix in right-handed mode.
     * @returns The refraction matrix
     */ getRefractionTextureMatrix() {
        return this.getScene()?.useRightHandedSystem ? this._textureMatrixRefraction : this._textureMatrix;
    }
    _loadTexture(onLoad = null, onError = null) {
        const scene = this.getScene();
        const oldTexture = this._texture;
        this._texture = this._getFromCache(this.url, this._noMipmap, undefined, undefined, this._useSRGBBuffer, this.isCube);
        const onLoadProcessing = ()=>{
            this.onLoadObservable.notifyObservers(this);
            if (oldTexture) {
                oldTexture.dispose();
                this.getScene()?.markAllMaterialsAsDirty(1);
            }
            if (onLoad) onLoad();
        };
        const errorHandler = (message, exception)=>{
            this._loadingError = true;
            this._errorObject = {
                message: message,
                exception: exception
            };
            if (onError) onError(message, exception);
            (0, $j2mX5.Texture).OnTextureLoadErrorObservable.notifyObservers(this);
        };
        if (!this._texture) {
            if (this._prefiltered) this._texture = this._getEngine().createPrefilteredCubeTexture(this.url, scene, this._lodScale, this._lodOffset, onLoad, errorHandler, this._format, this._forcedExtension, this._createPolynomials);
            else this._texture = this._getEngine().createCubeTexture(this.url, scene, this._files, this._noMipmap, onLoad, errorHandler, this._format, this._forcedExtension, false, this._lodScale, this._lodOffset, null, this._loaderOptions, !!this._useSRGBBuffer);
            this._texture?.onLoadedObservable.add(()=>this.onLoadObservable.notifyObservers(this));
        } else if (this._texture.isReady) (0, $bOhSV.Tools).SetImmediate(()=>onLoadProcessing());
        else this._texture.onLoadedObservable.add(()=>onLoadProcessing());
    }
    /**
     * Parses text to create a cube texture
     * @param parsedTexture define the serialized text to read from
     * @param scene defines the hosting scene
     * @param rootUrl defines the root url of the cube texture
     * @returns a cube texture
     */ static Parse(parsedTexture, scene, rootUrl) {
        const texture = (0, $6Ho1L.SerializationHelper).Parse(()=>{
            let prefiltered = false;
            if (parsedTexture.prefiltered) prefiltered = parsedTexture.prefiltered;
            return new $db65eaaef195f2a6$export$ee2e5a18258a4049(rootUrl + (parsedTexture.url ?? parsedTexture.name), scene, parsedTexture.extensions, false, parsedTexture.files || null, null, null, undefined, prefiltered, parsedTexture.forcedExtension);
        }, parsedTexture, scene);
        // Local Cubemaps
        if (parsedTexture.boundingBoxPosition) texture.boundingBoxPosition = (0, $ha1VO.Vector3).FromArray(parsedTexture.boundingBoxPosition);
        if (parsedTexture.boundingBoxSize) texture.boundingBoxSize = (0, $ha1VO.Vector3).FromArray(parsedTexture.boundingBoxSize);
        // Animations
        if (parsedTexture.animations) for(let animationIndex = 0; animationIndex < parsedTexture.animations.length; animationIndex++){
            const parsedAnimation = parsedTexture.animations[animationIndex];
            const internalClass = (0, $8DoUR.GetClass)("BABYLON.Animation");
            if (internalClass) texture.animations.push(internalClass.Parse(parsedAnimation));
        }
        return texture;
    }
    /**
     * Makes a clone, or deep copy, of the cube texture
     * @returns a new cube texture
     */ clone() {
        let uniqueId = 0;
        const newCubeTexture = (0, $6Ho1L.SerializationHelper).Clone(()=>{
            const cubeTexture = new $db65eaaef195f2a6$export$ee2e5a18258a4049(this.url, this.getScene() || this._getEngine(), this._extensions, this._noMipmap, this._files);
            uniqueId = cubeTexture.uniqueId;
            return cubeTexture;
        }, this);
        newCubeTexture.uniqueId = uniqueId;
        return newCubeTexture;
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $db65eaaef195f2a6$export$ee2e5a18258a4049.prototype, "url", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsVector3)()
], $db65eaaef195f2a6$export$ee2e5a18258a4049.prototype, "boundingBoxPosition", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsVector3)()
], $db65eaaef195f2a6$export$ee2e5a18258a4049.prototype, "boundingBoxSize", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("rotationY")
], $db65eaaef195f2a6$export$ee2e5a18258a4049.prototype, "rotationY", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("files")
], $db65eaaef195f2a6$export$ee2e5a18258a4049.prototype, "_files", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("forcedExtension")
], $db65eaaef195f2a6$export$ee2e5a18258a4049.prototype, "_forcedExtension", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("extensions")
], $db65eaaef195f2a6$export$ee2e5a18258a4049.prototype, "_extensions", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsMatrix)("textureMatrix")
], $db65eaaef195f2a6$export$ee2e5a18258a4049.prototype, "_textureMatrix", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsMatrix)("textureMatrixRefraction")
], $db65eaaef195f2a6$export$ee2e5a18258a4049.prototype, "_textureMatrixRefraction", void 0);
(0, $j2mX5.Texture)._CubeTextureParser = $db65eaaef195f2a6$export$ee2e5a18258a4049.Parse;
// Some exporters relies on Tools.Instantiate
(0, $8DoUR.RegisterClass)("BABYLON.CubeTexture", $db65eaaef195f2a6$export$ee2e5a18258a4049);

});

parcelRegister("fZkIz", function(module, exports) {

$parcel$export(module.exports, "BackgroundMaterial", () => $ba3c9faa90db0947$export$5802ada321111986);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $57onU = parcelRequire("57onU");

var $kVtWi = parcelRequire("kVtWi");

var $ha1VO = parcelRequire("ha1VO");

var $b4i1f = parcelRequire("b4i1f");

var $35xmP = parcelRequire("35xmP");

var $atHN2 = parcelRequire("atHN2");

var $dG1pf = parcelRequire("dG1pf");

var $j2mX5 = parcelRequire("j2mX5");

var $8DoUR = parcelRequire("8DoUR");

var $2hKx5 = parcelRequire("2hKx5");

var $7etnY = parcelRequire("7etnY");
parcelRequire("lJY7c");
parcelRequire("ayX0p");

var $gc8Ja = parcelRequire("gc8Ja");

var $aAFeM = parcelRequire("aAFeM");

var $alPCh = parcelRequire("alPCh");

var $6Ho1L = parcelRequire("6Ho1L");
/**
 * Background material defines definition.
 * @internal Mainly internal Use
 */ class $ba3c9faa90db0947$var$BackgroundMaterialDefines extends (0, $35xmP.MaterialDefines) {
    /**
     * Constructor of the defines.
     */ constructor(){
        super();
        /**
         * True if the diffuse texture is in use.
         */ this.DIFFUSE = false;
        /**
         * The direct UV channel to use.
         */ this.DIFFUSEDIRECTUV = 0;
        /**
         * True if the diffuse texture is in gamma space.
         */ this.GAMMADIFFUSE = false;
        /**
         * True if the diffuse texture has opacity in the alpha channel.
         */ this.DIFFUSEHASALPHA = false;
        /**
         * True if you want the material to fade to transparent at grazing angle.
         */ this.OPACITYFRESNEL = false;
        /**
         * True if an extra blur needs to be added in the reflection.
         */ this.REFLECTIONBLUR = false;
        /**
         * True if you want the material to fade to reflection at grazing angle.
         */ this.REFLECTIONFRESNEL = false;
        /**
         * True if you want the material to falloff as far as you move away from the scene center.
         */ this.REFLECTIONFALLOFF = false;
        /**
         * False if the current Webgl implementation does not support the texture lod extension.
         */ this.TEXTURELODSUPPORT = false;
        /**
         * True to ensure the data are premultiplied.
         */ this.PREMULTIPLYALPHA = false;
        /**
         * True if the texture contains cooked RGB values and not gray scaled multipliers.
         */ this.USERGBCOLOR = false;
        /**
         * True if highlight and shadow levels have been specified. It can help ensuring the main perceived color
         * stays aligned with the desired configuration.
         */ this.USEHIGHLIGHTANDSHADOWCOLORS = false;
        /**
         * True if only shadows must be rendered
         */ this.BACKMAT_SHADOWONLY = false;
        /**
         * True to add noise in order to reduce the banding effect.
         */ this.NOISE = false;
        /**
         * is the reflection texture in BGR color scheme?
         * Mainly used to solve a bug in ios10 video tag
         */ this.REFLECTIONBGR = false;
        /**
         * True if ground projection has been enabled.
         */ this.PROJECTED_GROUND = false;
        this.IMAGEPROCESSING = false;
        this.VIGNETTE = false;
        this.VIGNETTEBLENDMODEMULTIPLY = false;
        this.VIGNETTEBLENDMODEOPAQUE = false;
        this.TONEMAPPING = false;
        this.TONEMAPPING_ACES = false;
        this.CONTRAST = false;
        this.COLORCURVES = false;
        this.COLORGRADING = false;
        this.COLORGRADING3D = false;
        this.SAMPLER3DGREENDEPTH = false;
        this.SAMPLER3DBGRMAP = false;
        this.DITHER = false;
        this.IMAGEPROCESSINGPOSTPROCESS = false;
        this.SKIPFINALCOLORCLAMP = false;
        this.EXPOSURE = false;
        this.MULTIVIEW = false;
        // Reflection.
        this.REFLECTION = false;
        this.REFLECTIONMAP_3D = false;
        this.REFLECTIONMAP_SPHERICAL = false;
        this.REFLECTIONMAP_PLANAR = false;
        this.REFLECTIONMAP_CUBIC = false;
        this.REFLECTIONMAP_PROJECTION = false;
        this.REFLECTIONMAP_SKYBOX = false;
        this.REFLECTIONMAP_EXPLICIT = false;
        this.REFLECTIONMAP_EQUIRECTANGULAR = false;
        this.REFLECTIONMAP_EQUIRECTANGULAR_FIXED = false;
        this.REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED = false;
        this.INVERTCUBICMAP = false;
        this.REFLECTIONMAP_OPPOSITEZ = false;
        this.LODINREFLECTIONALPHA = false;
        this.GAMMAREFLECTION = false;
        this.RGBDREFLECTION = false;
        this.EQUIRECTANGULAR_RELFECTION_FOV = false;
        // Default BJS.
        this.MAINUV1 = false;
        this.MAINUV2 = false;
        this.UV1 = false;
        this.UV2 = false;
        this.CLIPPLANE = false;
        this.CLIPPLANE2 = false;
        this.CLIPPLANE3 = false;
        this.CLIPPLANE4 = false;
        this.CLIPPLANE5 = false;
        this.CLIPPLANE6 = false;
        this.POINTSIZE = false;
        this.FOG = false;
        this.NORMAL = false;
        this.NUM_BONE_INFLUENCERS = 0;
        this.BonesPerMesh = 0;
        this.INSTANCES = false;
        this.SHADOWFLOAT = false;
        this.LOGARITHMICDEPTH = false;
        this.NONUNIFORMSCALING = false;
        this.ALPHATEST = false;
        this.rebuild();
    }
}
class $ba3c9faa90db0947$export$5802ada321111986 extends (0, $atHN2.PushMaterial) {
    /**
     * Experimental Internal Use Only.
     *
     * Key light Color in "perceptual value" meaning the color you would like to see on screen.
     * This acts as a helper to set the primary color to a more "human friendly" value.
     * Conversion to linear space as well as exposure and tone mapping correction will be applied to keep the
     * output color as close as possible from the chosen value.
     * (This does not account for contrast color grading and color curves as they are considered post effect and not directly
     * part of lighting setup.)
     */ get _perceptualColor() {
        return this.__perceptualColor;
    }
    set _perceptualColor(value) {
        this.__perceptualColor = value;
        this._computePrimaryColorFromPerceptualColor();
        this._markAllSubMeshesAsLightsDirty();
    }
    /**
     * Defines the level of the shadows (dark area of the reflection map) in order to help scaling the colors.
     * The color opposite to the primary color is used at the level chosen to define what the black area would look.
     */ get primaryColorShadowLevel() {
        return this._primaryColorShadowLevel;
    }
    set primaryColorShadowLevel(value) {
        this._primaryColorShadowLevel = value;
        this._computePrimaryColors();
        this._markAllSubMeshesAsLightsDirty();
    }
    /**
     * Defines the level of the highlights (highlight area of the reflection map) in order to help scaling the colors.
     * The primary color is used at the level chosen to define what the white area would look.
     */ get primaryColorHighlightLevel() {
        return this._primaryColorHighlightLevel;
    }
    set primaryColorHighlightLevel(value) {
        this._primaryColorHighlightLevel = value;
        this._computePrimaryColors();
        this._markAllSubMeshesAsLightsDirty();
    }
    /**
     * Sets the reflection reflectance fresnel values according to the default standard
     * empirically know to work well :-)
     */ set reflectionStandardFresnelWeight(value) {
        let reflectionWeight = value;
        if (reflectionWeight < 0.5) {
            reflectionWeight = reflectionWeight * 2.0;
            this.reflectionReflectance0 = $ba3c9faa90db0947$export$5802ada321111986.StandardReflectance0 * reflectionWeight;
            this.reflectionReflectance90 = $ba3c9faa90db0947$export$5802ada321111986.StandardReflectance90 * reflectionWeight;
        } else {
            reflectionWeight = reflectionWeight * 2.0 - 1.0;
            this.reflectionReflectance0 = $ba3c9faa90db0947$export$5802ada321111986.StandardReflectance0 + (1.0 - $ba3c9faa90db0947$export$5802ada321111986.StandardReflectance0) * reflectionWeight;
            this.reflectionReflectance90 = $ba3c9faa90db0947$export$5802ada321111986.StandardReflectance90 + (1.0 - $ba3c9faa90db0947$export$5802ada321111986.StandardReflectance90) * reflectionWeight;
        }
    }
    /**
     * The current fov(field of view) multiplier, 0.0 - 2.0. Defaults to 1.0. Lower values "zoom in" and higher values "zoom out".
     * Best used when trying to implement visual zoom effects like fish-eye or binoculars while not adjusting camera fov.
     * Recommended to be keep at 1.0 except for special cases.
     */ get fovMultiplier() {
        return this._fovMultiplier;
    }
    set fovMultiplier(value) {
        if (isNaN(value)) value = 1.0;
        this._fovMultiplier = Math.max(0.0, Math.min(2.0, value));
    }
    /**
     * Attaches a new image processing configuration to the PBR Material.
     * @param configuration (if null the scene configuration will be use)
     */ _attachImageProcessingConfiguration(configuration) {
        if (configuration === this._imageProcessingConfiguration) return;
        // Detaches observer.
        if (this._imageProcessingConfiguration && this._imageProcessingObserver) this._imageProcessingConfiguration.onUpdateParameters.remove(this._imageProcessingObserver);
        // Pick the scene configuration if needed.
        if (!configuration) this._imageProcessingConfiguration = this.getScene().imageProcessingConfiguration;
        else this._imageProcessingConfiguration = configuration;
        // Attaches observer.
        if (this._imageProcessingConfiguration) this._imageProcessingObserver = this._imageProcessingConfiguration.onUpdateParameters.add(()=>{
            this._computePrimaryColorFromPerceptualColor();
            this._markAllSubMeshesAsImageProcessingDirty();
        });
    }
    /**
     * Gets the image processing configuration used either in this material.
     */ get imageProcessingConfiguration() {
        return this._imageProcessingConfiguration;
    }
    /**
     * Sets the Default image processing configuration used either in the this material.
     *
     * If sets to null, the scene one is in use.
     */ set imageProcessingConfiguration(value) {
        this._attachImageProcessingConfiguration(value);
        // Ensure the effect will be rebuilt.
        this._markAllSubMeshesAsTexturesDirty();
    }
    /**
     * Gets whether the color curves effect is enabled.
     */ get cameraColorCurvesEnabled() {
        return this.imageProcessingConfiguration.colorCurvesEnabled;
    }
    /**
     * Sets whether the color curves effect is enabled.
     */ set cameraColorCurvesEnabled(value) {
        this.imageProcessingConfiguration.colorCurvesEnabled = value;
    }
    /**
     * Gets whether the color grading effect is enabled.
     */ get cameraColorGradingEnabled() {
        return this.imageProcessingConfiguration.colorGradingEnabled;
    }
    /**
     * Gets whether the color grading effect is enabled.
     */ set cameraColorGradingEnabled(value) {
        this.imageProcessingConfiguration.colorGradingEnabled = value;
    }
    /**
     * Gets whether tonemapping is enabled or not.
     */ get cameraToneMappingEnabled() {
        return this._imageProcessingConfiguration.toneMappingEnabled;
    }
    /**
     * Sets whether tonemapping is enabled or not
     */ set cameraToneMappingEnabled(value) {
        this._imageProcessingConfiguration.toneMappingEnabled = value;
    }
    /**
     * The camera exposure used on this material.
     * This property is here and not in the camera to allow controlling exposure without full screen post process.
     * This corresponds to a photographic exposure.
     */ get cameraExposure() {
        return this._imageProcessingConfiguration.exposure;
    }
    /**
     * The camera exposure used on this material.
     * This property is here and not in the camera to allow controlling exposure without full screen post process.
     * This corresponds to a photographic exposure.
     */ set cameraExposure(value) {
        this._imageProcessingConfiguration.exposure = value;
    }
    /**
     * Gets The camera contrast used on this material.
     */ get cameraContrast() {
        return this._imageProcessingConfiguration.contrast;
    }
    /**
     * Sets The camera contrast used on this material.
     */ set cameraContrast(value) {
        this._imageProcessingConfiguration.contrast = value;
    }
    /**
     * Gets the Color Grading 2D Lookup Texture.
     */ get cameraColorGradingTexture() {
        return this._imageProcessingConfiguration.colorGradingTexture;
    }
    /**
     * Sets the Color Grading 2D Lookup Texture.
     */ set cameraColorGradingTexture(value) {
        this.imageProcessingConfiguration.colorGradingTexture = value;
    }
    /**
     * The color grading curves provide additional color adjustment that is applied after any color grading transform (3D LUT).
     * They allow basic adjustment of saturation and small exposure adjustments, along with color filter tinting to provide white balance adjustment or more stylistic effects.
     * These are similar to controls found in many professional imaging or colorist software. The global controls are applied to the entire image. For advanced tuning, extra controls are provided to adjust the shadow, midtone and highlight areas of the image;
     * corresponding to low luminance, medium luminance, and high luminance areas respectively.
     */ get cameraColorCurves() {
        return this.imageProcessingConfiguration.colorCurves;
    }
    /**
     * The color grading curves provide additional color adjustment that is applied after any color grading transform (3D LUT).
     * They allow basic adjustment of saturation and small exposure adjustments, along with color filter tinting to provide white balance adjustment or more stylistic effects.
     * These are similar to controls found in many professional imaging or colorist software. The global controls are applied to the entire image. For advanced tuning, extra controls are provided to adjust the shadow, midtone and highlight areas of the image;
     * corresponding to low luminance, medium luminance, and high luminance areas respectively.
     */ set cameraColorCurves(value) {
        this.imageProcessingConfiguration.colorCurves = value;
    }
    /**
     * Instantiates a Background Material in the given scene
     * @param name The friendly name of the material
     * @param scene The scene to add the material to
     */ constructor(name, scene){
        super(name, scene);
        /**
         * Key light Color (multiply against the environment texture)
         */ this.primaryColor = (0, $7etnY.Color3).White();
        this._primaryColorShadowLevel = 0;
        this._primaryColorHighlightLevel = 0;
        /**
         * Reflection Texture used in the material.
         * Should be author in a specific way for the best result (refer to the documentation).
         */ this.reflectionTexture = null;
        /**
         * Reflection Texture level of blur.
         *
         * Can be use to reuse an existing HDR Texture and target a specific LOD to prevent authoring the
         * texture twice.
         */ this.reflectionBlur = 0;
        /**
         * Diffuse Texture used in the material.
         * Should be author in a specific way for the best result (refer to the documentation).
         */ this.diffuseTexture = null;
        this._shadowLights = null;
        /**
         * Specify the list of lights casting shadow on the material.
         * All scene shadow lights will be included if null.
         */ this.shadowLights = null;
        /**
         * Helps adjusting the shadow to a softer level if required.
         * 0 means black shadows and 1 means no shadows.
         */ this.shadowLevel = 0;
        /**
         * In case of opacity Fresnel or reflection falloff, this is use as a scene center.
         * It is usually zero but might be interesting to modify according to your setup.
         */ this.sceneCenter = (0, $ha1VO.Vector3).Zero();
        /**
         * This helps specifying that the material is falling off to the sky box at grazing angle.
         * This helps ensuring a nice transition when the camera goes under the ground.
         */ this.opacityFresnel = true;
        /**
         * This helps specifying that the material is falling off from diffuse to the reflection texture at grazing angle.
         * This helps adding a mirror texture on the ground.
         */ this.reflectionFresnel = false;
        /**
         * This helps specifying the falloff radius off the reflection texture from the sceneCenter.
         * This helps adding a nice falloff effect to the reflection if used as a mirror for instance.
         */ this.reflectionFalloffDistance = 0.0;
        /**
         * This specifies the weight of the reflection against the background in case of reflection Fresnel.
         */ this.reflectionAmount = 1.0;
        /**
         * This specifies the weight of the reflection at grazing angle.
         */ this.reflectionReflectance0 = 0.05;
        /**
         * This specifies the weight of the reflection at a perpendicular point of view.
         */ this.reflectionReflectance90 = 0.5;
        /**
         * Helps to directly use the maps channels instead of their level.
         */ this.useRGBColor = true;
        /**
         * This helps reducing the banding effect that could occur on the background.
         */ this.enableNoise = false;
        this._fovMultiplier = 1.0;
        /**
         * Enable the FOV adjustment feature controlled by fovMultiplier.
         */ this.useEquirectangularFOV = false;
        this._maxSimultaneousLights = 4;
        /**
         * Number of Simultaneous lights allowed on the material.
         */ this.maxSimultaneousLights = 4;
        this._shadowOnly = false;
        /**
         * Make the material only render shadows
         */ this.shadowOnly = false;
        /**
         * Keep track of the image processing observer to allow dispose and replace.
         */ this._imageProcessingObserver = null;
        /**
         * Due to a bug in iOS10, video tags (which are using the background material) are in BGR and not RGB.
         * Setting this flag to true (not done automatically!) will convert it back to RGB.
         */ this.switchToBGR = false;
        this._enableGroundProjection = false;
        /**
         * Enables the ground projection mode on the material.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/environment/skybox#ground-projection
         */ this.enableGroundProjection = false;
        /**
         * Defines the radius of the projected ground if enableGroundProjection is true.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/environment/skybox#ground-projection
         */ this.projectedGroundRadius = 1000;
        /**
         * Defines the height of the projected ground if enableGroundProjection is true.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/environment/skybox#ground-projection
         */ this.projectedGroundHeight = 10;
        // Temp values kept as cache in the material.
        this._renderTargets = new (0, $57onU.SmartArray)(16);
        this._reflectionControls = (0, $ha1VO.Vector4).Zero();
        this._white = (0, $7etnY.Color3).White();
        this._primaryShadowColor = (0, $7etnY.Color3).Black();
        this._primaryHighlightColor = (0, $7etnY.Color3).Black();
        // Setup the default processing configuration to the scene.
        this._attachImageProcessingConfiguration(null);
        this.getRenderTargetTextures = ()=>{
            this._renderTargets.reset();
            if (this._diffuseTexture && this._diffuseTexture.isRenderTarget) this._renderTargets.push(this._diffuseTexture);
            if (this._reflectionTexture && this._reflectionTexture.isRenderTarget) this._renderTargets.push(this._reflectionTexture);
            return this._renderTargets;
        };
    }
    /**
     * Gets a boolean indicating that current material needs to register RTT
     */ get hasRenderTargetTextures() {
        if (this._diffuseTexture && this._diffuseTexture.isRenderTarget) return true;
        if (this._reflectionTexture && this._reflectionTexture.isRenderTarget) return true;
        return false;
    }
    /**
     * The entire material has been created in order to prevent overdraw.
     * @returns false
     */ needAlphaTesting() {
        return true;
    }
    /**
     * The entire material has been created in order to prevent overdraw.
     * @returns true if blending is enable
     */ needAlphaBlending() {
        return this.alpha < 1 || this._diffuseTexture != null && this._diffuseTexture.hasAlpha || this._shadowOnly;
    }
    /**
     * Checks whether the material is ready to be rendered for a given mesh.
     * @param mesh The mesh to render
     * @param subMesh The submesh to check against
     * @param useInstances Specify wether or not the material is used with instances
     * @returns true if all the dependencies are ready (Textures, Effects...)
     */ isReadyForSubMesh(mesh, subMesh, useInstances = false) {
        const drawWrapper = subMesh._drawWrapper;
        if (drawWrapper.effect && this.isFrozen) {
            if (drawWrapper._wasPreviouslyReady && drawWrapper._wasPreviouslyUsingInstances === useInstances) return true;
        }
        if (!subMesh.materialDefines) subMesh.materialDefines = new $ba3c9faa90db0947$var$BackgroundMaterialDefines();
        const scene = this.getScene();
        const defines = subMesh.materialDefines;
        if (this._isReadyForSubMesh(subMesh)) return true;
        const engine = scene.getEngine();
        // Lights
        (0, $alPCh.PrepareDefinesForLights)(scene, mesh, defines, false, this._maxSimultaneousLights);
        defines._needNormals = true;
        // Multiview
        (0, $alPCh.PrepareDefinesForMultiview)(scene, defines);
        // Textures
        if (defines._areTexturesDirty) {
            defines._needUVs = false;
            if (scene.texturesEnabled) {
                if (scene.getEngine().getCaps().textureLOD) defines.TEXTURELODSUPPORT = true;
                if (this._diffuseTexture && (0, $2hKx5.MaterialFlags).DiffuseTextureEnabled) {
                    if (!this._diffuseTexture.isReadyOrNotBlocking()) return false;
                    (0, $alPCh.PrepareDefinesForMergedUV)(this._diffuseTexture, defines, "DIFFUSE");
                    defines.DIFFUSEHASALPHA = this._diffuseTexture.hasAlpha;
                    defines.GAMMADIFFUSE = this._diffuseTexture.gammaSpace;
                    defines.OPACITYFRESNEL = this._opacityFresnel;
                } else {
                    defines.DIFFUSE = false;
                    defines.DIFFUSEDIRECTUV = 0;
                    defines.DIFFUSEHASALPHA = false;
                    defines.GAMMADIFFUSE = false;
                    defines.OPACITYFRESNEL = false;
                }
                const reflectionTexture = this._reflectionTexture;
                if (reflectionTexture && (0, $2hKx5.MaterialFlags).ReflectionTextureEnabled) {
                    if (!reflectionTexture.isReadyOrNotBlocking()) return false;
                    defines.REFLECTION = true;
                    defines.GAMMAREFLECTION = reflectionTexture.gammaSpace;
                    defines.RGBDREFLECTION = reflectionTexture.isRGBD;
                    defines.REFLECTIONBLUR = this._reflectionBlur > 0;
                    defines.LODINREFLECTIONALPHA = reflectionTexture.lodLevelInAlpha;
                    defines.EQUIRECTANGULAR_RELFECTION_FOV = this.useEquirectangularFOV;
                    defines.REFLECTIONBGR = this.switchToBGR;
                    if (reflectionTexture.coordinatesMode === (0, $j2mX5.Texture).INVCUBIC_MODE) defines.INVERTCUBICMAP = true;
                    defines.REFLECTIONMAP_3D = reflectionTexture.isCube;
                    defines.REFLECTIONMAP_OPPOSITEZ = defines.REFLECTIONMAP_3D && this.getScene().useRightHandedSystem ? !reflectionTexture.invertZ : reflectionTexture.invertZ;
                    switch(reflectionTexture.coordinatesMode){
                        case (0, $j2mX5.Texture).EXPLICIT_MODE:
                            defines.REFLECTIONMAP_EXPLICIT = true;
                            break;
                        case (0, $j2mX5.Texture).PLANAR_MODE:
                            defines.REFLECTIONMAP_PLANAR = true;
                            break;
                        case (0, $j2mX5.Texture).PROJECTION_MODE:
                            defines.REFLECTIONMAP_PROJECTION = true;
                            break;
                        case (0, $j2mX5.Texture).SKYBOX_MODE:
                            defines.REFLECTIONMAP_SKYBOX = true;
                            break;
                        case (0, $j2mX5.Texture).SPHERICAL_MODE:
                            defines.REFLECTIONMAP_SPHERICAL = true;
                            break;
                        case (0, $j2mX5.Texture).EQUIRECTANGULAR_MODE:
                            defines.REFLECTIONMAP_EQUIRECTANGULAR = true;
                            break;
                        case (0, $j2mX5.Texture).FIXED_EQUIRECTANGULAR_MODE:
                            defines.REFLECTIONMAP_EQUIRECTANGULAR_FIXED = true;
                            break;
                        case (0, $j2mX5.Texture).FIXED_EQUIRECTANGULAR_MIRRORED_MODE:
                            defines.REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED = true;
                            break;
                        case (0, $j2mX5.Texture).CUBIC_MODE:
                        case (0, $j2mX5.Texture).INVCUBIC_MODE:
                        default:
                            defines.REFLECTIONMAP_CUBIC = true;
                            break;
                    }
                    if (this.reflectionFresnel) {
                        defines.REFLECTIONFRESNEL = true;
                        defines.REFLECTIONFALLOFF = this.reflectionFalloffDistance > 0;
                        this._reflectionControls.x = this.reflectionAmount;
                        this._reflectionControls.y = this.reflectionReflectance0;
                        this._reflectionControls.z = this.reflectionReflectance90;
                        this._reflectionControls.w = 1 / this.reflectionFalloffDistance;
                    } else {
                        defines.REFLECTIONFRESNEL = false;
                        defines.REFLECTIONFALLOFF = false;
                    }
                } else {
                    defines.REFLECTION = false;
                    defines.REFLECTIONFRESNEL = false;
                    defines.REFLECTIONFALLOFF = false;
                    defines.REFLECTIONBLUR = false;
                    defines.REFLECTIONMAP_3D = false;
                    defines.REFLECTIONMAP_SPHERICAL = false;
                    defines.REFLECTIONMAP_PLANAR = false;
                    defines.REFLECTIONMAP_CUBIC = false;
                    defines.REFLECTIONMAP_PROJECTION = false;
                    defines.REFLECTIONMAP_SKYBOX = false;
                    defines.REFLECTIONMAP_EXPLICIT = false;
                    defines.REFLECTIONMAP_EQUIRECTANGULAR = false;
                    defines.REFLECTIONMAP_EQUIRECTANGULAR_FIXED = false;
                    defines.REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED = false;
                    defines.INVERTCUBICMAP = false;
                    defines.REFLECTIONMAP_OPPOSITEZ = false;
                    defines.LODINREFLECTIONALPHA = false;
                    defines.GAMMAREFLECTION = false;
                    defines.RGBDREFLECTION = false;
                }
            }
            defines.PREMULTIPLYALPHA = this.alphaMode === 7 || this.alphaMode === 8;
            defines.USERGBCOLOR = this._useRGBColor;
            defines.NOISE = this._enableNoise;
        }
        if (defines._areLightsDirty) {
            defines.USEHIGHLIGHTANDSHADOWCOLORS = !this._useRGBColor && (this._primaryColorShadowLevel !== 0 || this._primaryColorHighlightLevel !== 0);
            defines.BACKMAT_SHADOWONLY = this._shadowOnly;
        }
        if (defines._areImageProcessingDirty && this._imageProcessingConfiguration) {
            if (!this._imageProcessingConfiguration.isReady()) return false;
            this._imageProcessingConfiguration.prepareDefines(defines);
        }
        if (defines._areMiscDirty) {
            if (defines.REFLECTIONMAP_3D && this._enableGroundProjection) {
                defines.PROJECTED_GROUND = true;
                defines.REFLECTIONMAP_SKYBOX = true;
            } else defines.PROJECTED_GROUND = false;
        }
        // Misc.
        (0, $alPCh.PrepareDefinesForMisc)(mesh, scene, this._useLogarithmicDepth, this.pointsCloud, this.fogEnabled, this._shouldTurnAlphaTestOn(mesh), defines);
        // Values that need to be evaluated on every frame
        (0, $alPCh.PrepareDefinesForFrameBoundValues)(scene, engine, this, defines, useInstances, null, subMesh.getRenderingMesh().hasThinInstances);
        // Attribs
        if ((0, $alPCh.PrepareDefinesForAttributes)(mesh, defines, false, true, false)) {
            if (mesh) {
                if (!scene.getEngine().getCaps().standardDerivatives && !mesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).NormalKind)) {
                    mesh.createNormals(true);
                    (0, $kVtWi.Logger).Warn("BackgroundMaterial: Normals have been created for the mesh: " + mesh.name);
                }
            }
        }
        // Get correct effect
        if (defines.isDirty) {
            defines.markAsProcessed();
            scene.resetCachedMaterial();
            // Fallbacks
            const fallbacks = new (0, $gc8Ja.EffectFallbacks)();
            if (defines.FOG) fallbacks.addFallback(0, "FOG");
            if (defines.POINTSIZE) fallbacks.addFallback(1, "POINTSIZE");
            if (defines.MULTIVIEW) fallbacks.addFallback(0, "MULTIVIEW");
            (0, $alPCh.HandleFallbacksForShadows)(defines, fallbacks, this._maxSimultaneousLights);
            //Attributes
            const attribs = [
                (0, $b4i1f.VertexBuffer).PositionKind
            ];
            if (defines.NORMAL) attribs.push((0, $b4i1f.VertexBuffer).NormalKind);
            if (defines.UV1) attribs.push((0, $b4i1f.VertexBuffer).UVKind);
            if (defines.UV2) attribs.push((0, $b4i1f.VertexBuffer).UV2Kind);
            (0, $alPCh.PrepareAttributesForBones)(attribs, mesh, defines, fallbacks);
            (0, $alPCh.PrepareAttributesForInstances)(attribs, defines);
            const uniforms = [
                "world",
                "view",
                "viewProjection",
                "vEyePosition",
                "vLightsType",
                "vFogInfos",
                "vFogColor",
                "pointSize",
                "mBones",
                "vPrimaryColor",
                "vPrimaryColorShadow",
                "vReflectionInfos",
                "reflectionMatrix",
                "vReflectionMicrosurfaceInfos",
                "fFovMultiplier",
                "shadowLevel",
                "alpha",
                "vBackgroundCenter",
                "vReflectionControl",
                "vDiffuseInfos",
                "diffuseMatrix",
                "projectedGroundInfos",
                "logarithmicDepthConstant"
            ];
            (0, $aAFeM.addClipPlaneUniforms)(uniforms);
            const samplers = [
                "diffuseSampler",
                "reflectionSampler",
                "reflectionSamplerLow",
                "reflectionSamplerHigh"
            ];
            const uniformBuffers = [
                "Material",
                "Scene"
            ];
            if (0, $dG1pf.ImageProcessingConfiguration) {
                (0, $dG1pf.ImageProcessingConfiguration).PrepareUniforms(uniforms, defines);
                (0, $dG1pf.ImageProcessingConfiguration).PrepareSamplers(samplers, defines);
            }
            (0, $alPCh.PrepareUniformsAndSamplersList)({
                uniformsNames: uniforms,
                uniformBuffersNames: uniformBuffers,
                samplers: samplers,
                defines: defines,
                maxSimultaneousLights: this._maxSimultaneousLights
            });
            const join = defines.toString();
            const effect = scene.getEngine().createEffect("background", {
                attributes: attribs,
                uniformsNames: uniforms,
                uniformBuffersNames: uniformBuffers,
                samplers: samplers,
                defines: join,
                fallbacks: fallbacks,
                onCompiled: this.onCompiled,
                onError: this.onError,
                indexParameters: {
                    maxSimultaneousLights: this._maxSimultaneousLights
                }
            }, engine);
            subMesh.setEffect(effect, defines, this._materialContext);
            this.buildUniformLayout();
        }
        if (!subMesh.effect || !subMesh.effect.isReady()) return false;
        defines._renderId = scene.getRenderId();
        drawWrapper._wasPreviouslyReady = true;
        drawWrapper._wasPreviouslyUsingInstances = useInstances;
        this._checkScenePerformancePriority();
        return true;
    }
    /**
     * Compute the primary color according to the chosen perceptual color.
     */ _computePrimaryColorFromPerceptualColor() {
        if (!this.__perceptualColor) return;
        this._primaryColor.copyFrom(this.__perceptualColor);
        // Revert gamma space.
        this._primaryColor.toLinearSpaceToRef(this._primaryColor, this.getScene().getEngine().useExactSrgbConversions);
        // Revert image processing configuration.
        if (this._imageProcessingConfiguration) // Revert Exposure.
        this._primaryColor.scaleToRef(1 / this._imageProcessingConfiguration.exposure, this._primaryColor);
        this._computePrimaryColors();
    }
    /**
     * Compute the highlights and shadow colors according to their chosen levels.
     */ _computePrimaryColors() {
        if (this._primaryColorShadowLevel === 0 && this._primaryColorHighlightLevel === 0) return;
        // Find the highlight color based on the configuration.
        this._primaryColor.scaleToRef(this._primaryColorShadowLevel, this._primaryShadowColor);
        this._primaryColor.subtractToRef(this._primaryShadowColor, this._primaryShadowColor);
        // Find the shadow color based on the configuration.
        this._white.subtractToRef(this._primaryColor, this._primaryHighlightColor);
        this._primaryHighlightColor.scaleToRef(this._primaryColorHighlightLevel, this._primaryHighlightColor);
        this._primaryColor.addToRef(this._primaryHighlightColor, this._primaryHighlightColor);
    }
    /**
     * Build the uniform buffer used in the material.
     */ buildUniformLayout() {
        // Order is important !
        this._uniformBuffer.addUniform("vPrimaryColor", 4);
        this._uniformBuffer.addUniform("vPrimaryColorShadow", 4);
        this._uniformBuffer.addUniform("vDiffuseInfos", 2);
        this._uniformBuffer.addUniform("vReflectionInfos", 2);
        this._uniformBuffer.addUniform("diffuseMatrix", 16);
        this._uniformBuffer.addUniform("reflectionMatrix", 16);
        this._uniformBuffer.addUniform("vReflectionMicrosurfaceInfos", 3);
        this._uniformBuffer.addUniform("fFovMultiplier", 1);
        this._uniformBuffer.addUniform("pointSize", 1);
        this._uniformBuffer.addUniform("shadowLevel", 1);
        this._uniformBuffer.addUniform("alpha", 1);
        this._uniformBuffer.addUniform("vBackgroundCenter", 3);
        this._uniformBuffer.addUniform("vReflectionControl", 4);
        this._uniformBuffer.addUniform("projectedGroundInfos", 2);
        this._uniformBuffer.create();
    }
    /**
     * Unbind the material.
     */ unbind() {
        if (this._diffuseTexture && this._diffuseTexture.isRenderTarget) this._uniformBuffer.setTexture("diffuseSampler", null);
        if (this._reflectionTexture && this._reflectionTexture.isRenderTarget) this._uniformBuffer.setTexture("reflectionSampler", null);
        super.unbind();
    }
    /**
     * Bind only the world matrix to the material.
     * @param world The world matrix to bind.
     */ bindOnlyWorldMatrix(world) {
        this._activeEffect.setMatrix("world", world);
    }
    /**
     * Bind the material for a dedicated submesh (every used meshes will be considered opaque).
     * @param world The world matrix to bind.
     * @param mesh the mesh to bind for.
     * @param subMesh The submesh to bind for.
     */ bindForSubMesh(world, mesh, subMesh) {
        const scene = this.getScene();
        const defines = subMesh.materialDefines;
        if (!defines) return;
        const effect = subMesh.effect;
        if (!effect) return;
        this._activeEffect = effect;
        // Matrices
        this.bindOnlyWorldMatrix(world);
        // Bones
        (0, $alPCh.BindBonesParameters)(mesh, this._activeEffect);
        const mustRebind = this._mustRebind(scene, effect, subMesh, mesh.visibility);
        if (mustRebind) {
            this._uniformBuffer.bindToEffect(effect, "Material");
            this.bindViewProjection(effect);
            const reflectionTexture = this._reflectionTexture;
            if (!this._uniformBuffer.useUbo || !this.isFrozen || !this._uniformBuffer.isSync || subMesh._drawWrapper._forceRebindOnNextCall) {
                // Texture uniforms
                if (scene.texturesEnabled) {
                    if (this._diffuseTexture && (0, $2hKx5.MaterialFlags).DiffuseTextureEnabled) {
                        this._uniformBuffer.updateFloat2("vDiffuseInfos", this._diffuseTexture.coordinatesIndex, this._diffuseTexture.level);
                        (0, $alPCh.BindTextureMatrix)(this._diffuseTexture, this._uniformBuffer, "diffuse");
                    }
                    if (reflectionTexture && (0, $2hKx5.MaterialFlags).ReflectionTextureEnabled) {
                        this._uniformBuffer.updateMatrix("reflectionMatrix", reflectionTexture.getReflectionTextureMatrix());
                        this._uniformBuffer.updateFloat2("vReflectionInfos", reflectionTexture.level, this._reflectionBlur);
                        this._uniformBuffer.updateFloat3("vReflectionMicrosurfaceInfos", reflectionTexture.getSize().width, reflectionTexture.lodGenerationScale, reflectionTexture.lodGenerationOffset);
                    }
                }
                if (this.shadowLevel > 0) this._uniformBuffer.updateFloat("shadowLevel", this.shadowLevel);
                this._uniformBuffer.updateFloat("alpha", this.alpha);
                // Point size
                if (this.pointsCloud) this._uniformBuffer.updateFloat("pointSize", this.pointSize);
                if (defines.USEHIGHLIGHTANDSHADOWCOLORS) {
                    this._uniformBuffer.updateColor4("vPrimaryColor", this._primaryHighlightColor, 1.0);
                    this._uniformBuffer.updateColor4("vPrimaryColorShadow", this._primaryShadowColor, 1.0);
                } else this._uniformBuffer.updateColor4("vPrimaryColor", this._primaryColor, 1.0);
            }
            this._uniformBuffer.updateFloat("fFovMultiplier", this._fovMultiplier);
            // Textures
            if (scene.texturesEnabled) {
                if (this._diffuseTexture && (0, $2hKx5.MaterialFlags).DiffuseTextureEnabled) this._uniformBuffer.setTexture("diffuseSampler", this._diffuseTexture);
                if (reflectionTexture && (0, $2hKx5.MaterialFlags).ReflectionTextureEnabled) {
                    if (defines.REFLECTIONBLUR && defines.TEXTURELODSUPPORT) this._uniformBuffer.setTexture("reflectionSampler", reflectionTexture);
                    else if (!defines.REFLECTIONBLUR) this._uniformBuffer.setTexture("reflectionSampler", reflectionTexture);
                    else {
                        this._uniformBuffer.setTexture("reflectionSampler", reflectionTexture._lodTextureMid || reflectionTexture);
                        this._uniformBuffer.setTexture("reflectionSamplerLow", reflectionTexture._lodTextureLow || reflectionTexture);
                        this._uniformBuffer.setTexture("reflectionSamplerHigh", reflectionTexture._lodTextureHigh || reflectionTexture);
                    }
                    if (defines.REFLECTIONFRESNEL) {
                        this._uniformBuffer.updateFloat3("vBackgroundCenter", this.sceneCenter.x, this.sceneCenter.y, this.sceneCenter.z);
                        this._uniformBuffer.updateFloat4("vReflectionControl", this._reflectionControls.x, this._reflectionControls.y, this._reflectionControls.z, this._reflectionControls.w);
                    }
                }
                if (defines.PROJECTED_GROUND) this._uniformBuffer.updateFloat2("projectedGroundInfos", this.projectedGroundRadius, this.projectedGroundHeight);
            }
            // Clip plane
            (0, $aAFeM.bindClipPlane)(this._activeEffect, this, scene);
            scene.bindEyePosition(effect);
        } else if (scene.getEngine()._features.needToAlwaysBindUniformBuffers) {
            this._uniformBuffer.bindToEffect(effect, "Material");
            this._needToBindSceneUbo = true;
        }
        if (mustRebind || !this.isFrozen) {
            if (scene.lightsEnabled) (0, $alPCh.BindLights)(scene, mesh, this._activeEffect, defines, this._maxSimultaneousLights);
            // View
            this.bindView(effect);
            // Fog
            (0, $alPCh.BindFogParameters)(scene, mesh, this._activeEffect, true);
            // Log. depth
            if (this._useLogarithmicDepth) (0, $alPCh.BindLogDepth)(defines, effect, scene);
            // image processing
            if (this._imageProcessingConfiguration) this._imageProcessingConfiguration.bind(this._activeEffect);
        }
        this._afterBind(mesh, this._activeEffect, subMesh);
        this._uniformBuffer.update();
    }
    /**
     * Checks to see if a texture is used in the material.
     * @param texture - Base texture to use.
     * @returns - Boolean specifying if a texture is used in the material.
     */ hasTexture(texture) {
        if (super.hasTexture(texture)) return true;
        if (this._reflectionTexture === texture) return true;
        if (this._diffuseTexture === texture) return true;
        return false;
    }
    /**
     * Dispose the material.
     * @param forceDisposeEffect Force disposal of the associated effect.
     * @param forceDisposeTextures Force disposal of the associated textures.
     */ dispose(forceDisposeEffect = false, forceDisposeTextures = false) {
        if (forceDisposeTextures) {
            if (this.diffuseTexture) this.diffuseTexture.dispose();
            if (this.reflectionTexture) this.reflectionTexture.dispose();
        }
        this._renderTargets.dispose();
        if (this._imageProcessingConfiguration && this._imageProcessingObserver) this._imageProcessingConfiguration.onUpdateParameters.remove(this._imageProcessingObserver);
        super.dispose(forceDisposeEffect);
    }
    /**
     * Clones the material.
     * @param name The cloned name.
     * @returns The cloned material.
     */ clone(name) {
        return (0, $6Ho1L.SerializationHelper).Clone(()=>new $ba3c9faa90db0947$export$5802ada321111986(name, this.getScene()), this);
    }
    /**
     * Serializes the current material to its JSON representation.
     * @returns The JSON representation.
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.customType = "BABYLON.BackgroundMaterial";
        return serializationObject;
    }
    /**
     * Gets the class name of the material
     * @returns "BackgroundMaterial"
     */ getClassName() {
        return "BackgroundMaterial";
    }
    /**
     * Parse a JSON input to create back a background material.
     * @param source The JSON data to parse
     * @param scene The scene to create the parsed material in
     * @param rootUrl The root url of the assets the material depends upon
     * @returns the instantiated BackgroundMaterial.
     */ static Parse(source, scene, rootUrl) {
        return (0, $6Ho1L.SerializationHelper).Parse(()=>new $ba3c9faa90db0947$export$5802ada321111986(source.name, scene), source, scene, rootUrl);
    }
}
/**
 * Standard reflectance value at parallel view angle.
 */ $ba3c9faa90db0947$export$5802ada321111986.StandardReflectance0 = 0.05;
/**
 * Standard reflectance value at grazing angle.
 */ $ba3c9faa90db0947$export$5802ada321111986.StandardReflectance90 = 0.5;
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor3)()
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "_primaryColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsLightsDirty")
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "primaryColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor3)()
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "__perceptualColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "_primaryColorShadowLevel", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "_primaryColorHighlightLevel", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsLightsDirty")
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "primaryColorHighlightLevel", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)()
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "_reflectionTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "reflectionTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "_reflectionBlur", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "reflectionBlur", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)()
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "_diffuseTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "diffuseTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "shadowLights", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "_shadowLevel", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "shadowLevel", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsVector3)()
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "_sceneCenter", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "sceneCenter", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "_opacityFresnel", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "opacityFresnel", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "_reflectionFresnel", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "reflectionFresnel", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "_reflectionFalloffDistance", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "reflectionFalloffDistance", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "_reflectionAmount", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "reflectionAmount", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "_reflectionReflectance0", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "reflectionReflectance0", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "_reflectionReflectance90", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "reflectionReflectance90", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "_useRGBColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "useRGBColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "_enableNoise", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "enableNoise", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "_maxSimultaneousLights", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "maxSimultaneousLights", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "_shadowOnly", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsLightsDirty")
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "shadowOnly", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsImageProcessingConfiguration)()
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "_imageProcessingConfiguration", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsMiscDirty")
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "enableGroundProjection", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "projectedGroundRadius", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ba3c9faa90db0947$export$5802ada321111986.prototype, "projectedGroundHeight", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.BackgroundMaterial", $ba3c9faa90db0947$export$5802ada321111986);

});
parcelRegister("lJY7c", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("fYt6K");
parcelRequire("aeTvy");
parcelRequire("7Hs3g");
parcelRequire("6vG1y");
parcelRequire("jtwq6");
parcelRequire("7UkOz");
parcelRequire("gi9Sf");
parcelRequire("eFnxQ");
parcelRequire("lcI5C");
parcelRequire("cRFSM");
parcelRequire("4kipo");
parcelRequire("82O8L");
parcelRequire("hvLF9");
parcelRequire("kg1CD");
parcelRequire("4ycgE");
parcelRequire("izyqw");
parcelRequire("110hr");
const $fd3c6e910f2b7397$var$name = "backgroundPixelShader";
const $fd3c6e910f2b7397$var$shader = `#ifdef TEXTURELODSUPPORT
#extension GL_EXT_shader_texture_lod : enable
#endif
precision highp float;
#include<__decl__backgroundFragment>
#include<helperFunctions>
varying vec3 vPositionW;
#ifdef MAINUV1
varying vec2 vMainUV1;
#endif 
#ifdef MAINUV2 
varying vec2 vMainUV2; 
#endif 
#ifdef NORMAL
varying vec3 vNormalW;
#endif
#ifdef DIFFUSE
#if DIFFUSEDIRECTUV==1
#define vDiffuseUV vMainUV1
#elif DIFFUSEDIRECTUV==2
#define vDiffuseUV vMainUV2
#else
varying vec2 vDiffuseUV;
#endif
uniform sampler2D diffuseSampler;
#endif
#ifdef REFLECTION
#ifdef REFLECTIONMAP_3D
#define sampleReflection(s,c) textureCube(s,c)
uniform samplerCube reflectionSampler;
#ifdef TEXTURELODSUPPORT
#define sampleReflectionLod(s,c,l) textureCubeLodEXT(s,c,l)
#else
uniform samplerCube reflectionSamplerLow;uniform samplerCube reflectionSamplerHigh;
#endif
#else
#define sampleReflection(s,c) texture2D(s,c)
uniform sampler2D reflectionSampler;
#ifdef TEXTURELODSUPPORT
#define sampleReflectionLod(s,c,l) texture2DLodEXT(s,c,l)
#else
uniform samplerCube reflectionSamplerLow;uniform samplerCube reflectionSamplerHigh;
#endif
#endif
#ifdef REFLECTIONMAP_SKYBOX
varying vec3 vPositionUVW;
#else
#if defined(REFLECTIONMAP_EQUIRECTANGULAR_FIXED) || defined(REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED)
varying vec3 vDirectionW;
#endif
#endif
#include<reflectionFunction>
#endif
#ifndef FROMLINEARSPACE
#define FROMLINEARSPACE;
#endif
#ifndef SHADOWONLY
#define SHADOWONLY;
#endif
#include<imageProcessingDeclaration>
#include<__decl__lightFragment>[0..maxSimultaneousLights]
#include<lightsFragmentFunctions>
#include<shadowsFragmentFunctions>
#include<imageProcessingFunctions>
#ifdef LOGARITHMICDEPTH
#extension GL_EXT_frag_depth : enable
#endif
#include<logDepthDeclaration>
#include<clipPlaneFragmentDeclaration>
#include<fogFragmentDeclaration>
#ifdef REFLECTIONFRESNEL
#define FRESNEL_MAXIMUM_ON_ROUGH 0.25
vec3 fresnelSchlickEnvironmentGGX(float VdotN,vec3 reflectance0,vec3 reflectance90,float smoothness)
{float weight=mix(FRESNEL_MAXIMUM_ON_ROUGH,1.0,smoothness);return reflectance0+weight*(reflectance90-reflectance0)*pow5(saturate(1.0-VdotN));}
#endif
#ifdef PROJECTED_GROUND
float diskIntersectWithBackFaceCulling(vec3 ro,vec3 rd,vec3 c,float r) {float d=rd.y;if(d>0.0) { return 1e6; }
vec3 o=ro-c;float t=-o.y/d;vec3 q=o+rd*t;return (dot(q,q)<r*r) ? t : 1e6;}
float sphereIntersect(vec3 ro,vec3 rd,float ra) {float b=dot(ro,rd);float c=dot(ro,ro)-ra*ra;float h=b*b-c;if(h<0.0) { return -1.0; }
h=sqrt(h);return-b+h;}
vec3 project(vec3 viewDirectionW,vec3 eyePosition) {float radius=projectedGroundInfos.x;float height=projectedGroundInfos.y;vec3 camDir=-viewDirectionW;float skySphereDistance=sphereIntersect(eyePosition,camDir,radius);vec3 skySpherePositionW=eyePosition+camDir*skySphereDistance;vec3 p=normalize(skySpherePositionW);eyePosition.y-=height;float sIntersection=sphereIntersect(eyePosition,p,radius);vec3 h=vec3(0.0,-height,0.0);float dIntersection=diskIntersectWithBackFaceCulling(eyePosition,p,h,radius);p=(eyePosition+min(sIntersection,dIntersection)*p);return p;}
#endif
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) {
#define CUSTOM_FRAGMENT_MAIN_BEGIN
#include<clipPlaneFragment>
vec3 viewDirectionW=normalize(vEyePosition.xyz-vPositionW);
#ifdef NORMAL
vec3 normalW=normalize(vNormalW);
#else
vec3 normalW=vec3(0.0,1.0,0.0);
#endif
float shadow=1.;float globalShadow=0.;float shadowLightCount=0.;float aggShadow=0.;float numLights=0.;
#include<lightFragment>[0..maxSimultaneousLights]
#ifdef SHADOWINUSE
globalShadow/=shadowLightCount;
#else
globalShadow=1.0;
#endif
#ifndef BACKMAT_SHADOWONLY
vec4 reflectionColor=vec4(1.,1.,1.,1.);
#ifdef REFLECTION
#ifdef PROJECTED_GROUND
vec3 reflectionVector=project(viewDirectionW,vEyePosition.xyz);reflectionVector=vec3(reflectionMatrix*vec4(reflectionVector,1.));
#else
vec3 reflectionVector=computeReflectionCoords(vec4(vPositionW,1.0),normalW);
#endif
#ifdef REFLECTIONMAP_OPPOSITEZ
reflectionVector.z*=-1.0;
#endif
#ifdef REFLECTIONMAP_3D
vec3 reflectionCoords=reflectionVector;
#else
vec2 reflectionCoords=reflectionVector.xy;
#ifdef REFLECTIONMAP_PROJECTION
reflectionCoords/=reflectionVector.z;
#endif
reflectionCoords.y=1.0-reflectionCoords.y;
#endif
#ifdef REFLECTIONBLUR
float reflectionLOD=vReflectionInfos.y;
#ifdef TEXTURELODSUPPORT
reflectionLOD=reflectionLOD*log2(vReflectionMicrosurfaceInfos.x)*vReflectionMicrosurfaceInfos.y+vReflectionMicrosurfaceInfos.z;reflectionColor=sampleReflectionLod(reflectionSampler,reflectionCoords,reflectionLOD);
#else
float lodReflectionNormalized=saturate(reflectionLOD);float lodReflectionNormalizedDoubled=lodReflectionNormalized*2.0;vec4 reflectionSpecularMid=sampleReflection(reflectionSampler,reflectionCoords);if(lodReflectionNormalizedDoubled<1.0){reflectionColor=mix(
sampleReflection(reflectionSamplerHigh,reflectionCoords),
reflectionSpecularMid,
lodReflectionNormalizedDoubled
);} else {reflectionColor=mix(
reflectionSpecularMid,
sampleReflection(reflectionSamplerLow,reflectionCoords),
lodReflectionNormalizedDoubled-1.0
);}
#endif
#else
vec4 reflectionSample=sampleReflection(reflectionSampler,reflectionCoords);reflectionColor=reflectionSample;
#endif
#ifdef RGBDREFLECTION
reflectionColor.rgb=fromRGBD(reflectionColor);
#endif
#ifdef GAMMAREFLECTION
reflectionColor.rgb=toLinearSpace(reflectionColor.rgb);
#endif
#ifdef REFLECTIONBGR
reflectionColor.rgb=reflectionColor.bgr;
#endif
reflectionColor.rgb*=vReflectionInfos.x;
#endif
vec3 diffuseColor=vec3(1.,1.,1.);float finalAlpha=alpha;
#ifdef DIFFUSE
vec4 diffuseMap=texture2D(diffuseSampler,vDiffuseUV);
#ifdef GAMMADIFFUSE
diffuseMap.rgb=toLinearSpace(diffuseMap.rgb);
#endif
diffuseMap.rgb*=vDiffuseInfos.y;
#ifdef DIFFUSEHASALPHA
finalAlpha*=diffuseMap.a;
#endif
diffuseColor=diffuseMap.rgb;
#endif
#ifdef REFLECTIONFRESNEL
vec3 colorBase=diffuseColor;
#else
vec3 colorBase=reflectionColor.rgb*diffuseColor;
#endif
colorBase=max(colorBase,0.0);
#ifdef USERGBCOLOR
vec3 finalColor=colorBase;
#else
#ifdef USEHIGHLIGHTANDSHADOWCOLORS
vec3 mainColor=mix(vPrimaryColorShadow.rgb,vPrimaryColor.rgb,colorBase);
#else
vec3 mainColor=vPrimaryColor.rgb;
#endif
vec3 finalColor=colorBase*mainColor;
#endif
#ifdef REFLECTIONFRESNEL
vec3 reflectionAmount=vReflectionControl.xxx;vec3 reflectionReflectance0=vReflectionControl.yyy;vec3 reflectionReflectance90=vReflectionControl.zzz;float VdotN=dot(normalize(vEyePosition.xyz),normalW);vec3 planarReflectionFresnel=fresnelSchlickEnvironmentGGX(saturate(VdotN),reflectionReflectance0,reflectionReflectance90,1.0);reflectionAmount*=planarReflectionFresnel;
#ifdef REFLECTIONFALLOFF
float reflectionDistanceFalloff=1.0-saturate(length(vPositionW.xyz-vBackgroundCenter)*vReflectionControl.w);reflectionDistanceFalloff*=reflectionDistanceFalloff;reflectionAmount*=reflectionDistanceFalloff;
#endif
finalColor=mix(finalColor,reflectionColor.rgb,saturate(reflectionAmount));
#endif
#ifdef OPACITYFRESNEL
float viewAngleToFloor=dot(normalW,normalize(vEyePosition.xyz-vBackgroundCenter));const float startAngle=0.1;float fadeFactor=saturate(viewAngleToFloor/startAngle);finalAlpha*=fadeFactor*fadeFactor;
#endif
#ifdef SHADOWINUSE
finalColor=mix(finalColor*shadowLevel,finalColor,globalShadow);
#endif
vec4 color=vec4(finalColor,finalAlpha);
#else
vec4 color=vec4(vPrimaryColor.rgb,(1.0-clamp(globalShadow,0.,1.))*alpha);
#endif
#include<logDepthFragment>
#include<fogFragment>
#ifdef IMAGEPROCESSINGPOSTPROCESS
#if !defined(SKIPFINALCOLORCLAMP)
color.rgb=clamp(color.rgb,0.,30.0);
#endif
#else
color=applyImageProcessing(color);
#endif
#ifdef PREMULTIPLYALPHA
color.rgb*=color.a;
#endif
#ifdef NOISE
color.rgb+=dither(vPositionW.xy,0.5);color=max(color,0.0);
#endif
gl_FragColor=color;
#define CUSTOM_FRAGMENT_MAIN_END
}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$fd3c6e910f2b7397$var$name] = $fd3c6e910f2b7397$var$shader;
const $fd3c6e910f2b7397$export$9d89c5d8c2beeadc = {
    name: $fd3c6e910f2b7397$var$name,
    shader: $fd3c6e910f2b7397$var$shader
};

});
parcelRegister("fYt6K", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $ba1309d5c7ffba28$var$name = "backgroundFragmentDeclaration";
const $ba1309d5c7ffba28$var$shader = `uniform vec4 vEyePosition;uniform vec4 vPrimaryColor;
#ifdef USEHIGHLIGHTANDSHADOWCOLORS
uniform vec4 vPrimaryColorShadow;
#endif
uniform float shadowLevel;uniform float alpha;
#ifdef DIFFUSE
uniform vec2 vDiffuseInfos;
#endif
#ifdef REFLECTION
uniform vec2 vReflectionInfos;uniform mat4 reflectionMatrix;uniform vec3 vReflectionMicrosurfaceInfos;
#endif
#if defined(REFLECTIONFRESNEL) || defined(OPACITYFRESNEL)
uniform vec3 vBackgroundCenter;
#endif
#ifdef REFLECTIONFRESNEL
uniform vec4 vReflectionControl;
#endif
#if defined(REFLECTIONMAP_SPHERICAL) || defined(REFLECTIONMAP_PROJECTION) || defined(REFRACTION)
uniform mat4 view;
#endif
#ifdef PROJECTED_GROUND
uniform vec2 projectedGroundInfos;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$ba1309d5c7ffba28$var$name] = $ba1309d5c7ffba28$var$shader;
const $ba1309d5c7ffba28$export$fabc9a78d1dbe2a3 = {
    name: $ba1309d5c7ffba28$var$name,
    shader: $ba1309d5c7ffba28$var$shader
};

});

parcelRegister("aeTvy", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("eZlZI");
const $774644e3b8a7512f$var$name = "backgroundUboDeclaration";
const $774644e3b8a7512f$var$shader = `layout(std140,column_major) uniform;uniform Material
{uniform vec4 vPrimaryColor;uniform vec4 vPrimaryColorShadow;uniform vec2 vDiffuseInfos;uniform vec2 vReflectionInfos;uniform mat4 diffuseMatrix;uniform mat4 reflectionMatrix;uniform vec3 vReflectionMicrosurfaceInfos;uniform float fFovMultiplier;uniform float pointSize;uniform float shadowLevel;uniform float alpha;uniform vec3 vBackgroundCenter;uniform vec4 vReflectionControl;uniform vec2 projectedGroundInfos;};
#include<sceneUboDeclaration>
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$774644e3b8a7512f$var$name] = $774644e3b8a7512f$var$shader;
const $774644e3b8a7512f$export$8846bc6b34532362 = {
    name: $774644e3b8a7512f$var$name,
    shader: $774644e3b8a7512f$var$shader
};

});


parcelRegister("ayX0p", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("dONeh");
parcelRequire("aeTvy");
parcelRequire("7Hs3g");
parcelRequire("7PW7m");
parcelRequire("8kYMw");
parcelRequire("k3wwH");
parcelRequire("4A4MM");
parcelRequire("bdABV");
parcelRequire("1yLBX");
parcelRequire("c0VT2");
parcelRequire("4kipo");
parcelRequire("apKdp");
parcelRequire("4idCt");
parcelRequire("cIweX");
parcelRequire("kqCfW");
parcelRequire("1pV7g");
parcelRequire("5sP5F");
parcelRequire("a111f");
const $7b0ad99f7ae2d75e$var$name = "backgroundVertexShader";
const $7b0ad99f7ae2d75e$var$shader = `precision highp float;
#include<__decl__backgroundVertex>
#include<helperFunctions>
attribute vec3 position;
#ifdef NORMAL
attribute vec3 normal;
#endif
#include<bonesDeclaration>
#include<bakedVertexAnimationDeclaration>
#include<instancesDeclaration>
varying vec3 vPositionW;
#ifdef NORMAL
varying vec3 vNormalW;
#endif
#ifdef UV1
attribute vec2 uv;
#endif
#ifdef UV2
attribute vec2 uv2;
#endif
#ifdef MAINUV1
varying vec2 vMainUV1;
#endif
#ifdef MAINUV2
varying vec2 vMainUV2;
#endif
#if defined(DIFFUSE) && DIFFUSEDIRECTUV==0
varying vec2 vDiffuseUV;
#endif
#include<clipPlaneVertexDeclaration>
#include<fogVertexDeclaration>
#include<__decl__lightVxFragment>[0..maxSimultaneousLights]
#ifdef REFLECTIONMAP_SKYBOX
varying vec3 vPositionUVW;
#endif
#if defined(REFLECTIONMAP_EQUIRECTANGULAR_FIXED) || defined(REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED)
varying vec3 vDirectionW;
#endif
#include<logDepthDeclaration>
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
#ifdef REFLECTIONMAP_SKYBOX
vPositionUVW=position;
#endif
#include<instancesVertex>
#include<bonesVertex>
#include<bakedVertexAnimation>
#ifdef MULTIVIEW
if (gl_ViewID_OVR==0u) {gl_Position=viewProjection*finalWorld*vec4(position,1.0);} else {gl_Position=viewProjectionR*finalWorld*vec4(position,1.0);}
#else
gl_Position=viewProjection*finalWorld*vec4(position,1.0);
#endif
vec4 worldPos=finalWorld*vec4(position,1.0);vPositionW=vec3(worldPos);
#ifdef NORMAL
mat3 normalWorld=mat3(finalWorld);
#ifdef NONUNIFORMSCALING
normalWorld=transposeMat3(inverseMat3(normalWorld));
#endif
vNormalW=normalize(normalWorld*normal);
#endif
#if defined(REFLECTIONMAP_EQUIRECTANGULAR_FIXED) || defined(REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED)
vDirectionW=normalize(vec3(finalWorld*vec4(position,0.0)));
#ifdef EQUIRECTANGULAR_RELFECTION_FOV
mat3 screenToWorld=inverseMat3(mat3(finalWorld*viewProjection));vec3 segment=mix(vDirectionW,screenToWorld*vec3(0.0,0.0,1.0),abs(fFovMultiplier-1.0));if (fFovMultiplier<=1.0) {vDirectionW=normalize(segment);} else {vDirectionW=normalize(vDirectionW+(vDirectionW-segment));}
#endif
#endif
#ifndef UV1
vec2 uv=vec2(0.,0.);
#endif
#ifndef UV2
vec2 uv2=vec2(0.,0.);
#endif
#ifdef MAINUV1
vMainUV1=uv;
#endif
#ifdef MAINUV2
vMainUV2=uv2;
#endif
#if defined(DIFFUSE) && DIFFUSEDIRECTUV==0
if (vDiffuseInfos.x==0.)
{vDiffuseUV=vec2(diffuseMatrix*vec4(uv,1.0,0.0));}
else
{vDiffuseUV=vec2(diffuseMatrix*vec4(uv2,1.0,0.0));}
#endif
#include<clipPlaneVertex>
#include<fogVertex>
#include<shadowsVertex>[0..maxSimultaneousLights]
#ifdef VERTEXCOLOR
vColor=color;
#endif
#if defined(POINTSIZE) && !defined(WEBGPU)
gl_PointSize=pointSize;
#endif
#include<logDepthVertex>
#define CUSTOM_VERTEX_MAIN_END
}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$7b0ad99f7ae2d75e$var$name] = $7b0ad99f7ae2d75e$var$shader;
const $7b0ad99f7ae2d75e$export$ab234d5c84a02425 = {
    name: $7b0ad99f7ae2d75e$var$name,
    shader: $7b0ad99f7ae2d75e$var$shader
};

});
parcelRegister("dONeh", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $a0f621cbdb2ba7e2$var$name = "backgroundVertexDeclaration";
const $a0f621cbdb2ba7e2$var$shader = `uniform mat4 view;uniform mat4 viewProjection;uniform float shadowLevel;
#ifdef DIFFUSE
uniform mat4 diffuseMatrix;uniform vec2 vDiffuseInfos;
#endif
#ifdef REFLECTION
uniform vec2 vReflectionInfos;uniform mat4 reflectionMatrix;uniform vec3 vReflectionMicrosurfaceInfos;uniform float fFovMultiplier;
#endif
#ifdef POINTSIZE
uniform float pointSize;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$a0f621cbdb2ba7e2$var$name] = $a0f621cbdb2ba7e2$var$shader;
const $a0f621cbdb2ba7e2$export$73f2625646a0215b = {
    name: $a0f621cbdb2ba7e2$var$name,
    shader: $a0f621cbdb2ba7e2$var$shader
};

});




parcelRegister("7cG3W", function(module, exports) {

$parcel$export(module.exports, "PhotoDome", () => $015a7d08e9f0c172$export$20ab50663d9d74f5);

var $j2mX5 = parcelRequire("j2mX5");

var $klLLx = parcelRequire("klLLx");
class $015a7d08e9f0c172$export$20ab50663d9d74f5 extends (0, $klLLx.TextureDome) {
    /**
     * Gets or sets the texture being displayed on the sphere
     */ get photoTexture() {
        return this.texture;
    }
    /**
     * sets the texture being displayed on the sphere
     */ set photoTexture(value) {
        this.texture = value;
    }
    /**
     * Gets the current video mode for the video. It can be:
     * * TextureDome.MODE_MONOSCOPIC : Define the texture source as a Monoscopic panoramic 360.
     * * TextureDome.MODE_TOPBOTTOM  : Define the texture source as a Stereoscopic TopBottom/OverUnder panoramic 360.
     * * TextureDome.MODE_SIDEBYSIDE : Define the texture source as a Stereoscopic Side by Side panoramic 360.
     */ get imageMode() {
        return this.textureMode;
    }
    /**
     * Sets the current video mode for the video. It can be:
     * * TextureDome.MODE_MONOSCOPIC : Define the texture source as a Monoscopic panoramic 360.
     * * TextureDome.MODE_TOPBOTTOM  : Define the texture source as a Stereoscopic TopBottom/OverUnder panoramic 360.
     * * TextureDome.MODE_SIDEBYSIDE : Define the texture source as a Stereoscopic Side by Side panoramic 360.
     */ set imageMode(value) {
        this.textureMode = value;
    }
    _initTexture(urlsOrElement, scene, options) {
        return new (0, $j2mX5.Texture)(urlsOrElement, scene, !options.generateMipMaps, !this._useDirectMapping, undefined, ()=>{
            this.onLoadObservable.notifyObservers();
        }, (message, exception)=>{
            this.onLoadErrorObservable.notifyObservers(message || "Unknown error occured");
            if (this.onError) this.onError(message, exception);
        });
    }
}
/**
 * Define the image as a Monoscopic panoramic 360 image.
 */ $015a7d08e9f0c172$export$20ab50663d9d74f5.MODE_MONOSCOPIC = (0, $klLLx.TextureDome).MODE_MONOSCOPIC;
/**
 * Define the image as a Stereoscopic TopBottom/OverUnder panoramic 360 image.
 */ $015a7d08e9f0c172$export$20ab50663d9d74f5.MODE_TOPBOTTOM = (0, $klLLx.TextureDome).MODE_TOPBOTTOM;
/**
 * Define the image as a Stereoscopic Side by Side panoramic 360 image.
 */ $015a7d08e9f0c172$export$20ab50663d9d74f5.MODE_SIDEBYSIDE = (0, $klLLx.TextureDome).MODE_SIDEBYSIDE;

});
parcelRegister("klLLx", function(module, exports) {

$parcel$export(module.exports, "TextureDome", () => $ed0ad215e8a86524$export$4657b1cf414f42b7);

var $klshO = parcelRequire("klshO");

var $fbuqw = parcelRequire("fbuqw");

var $j2mX5 = parcelRequire("j2mX5");

var $fZkIz = parcelRequire("fZkIz");

var $8KqOo = parcelRequire("8KqOo");

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");
parcelRequire("6rxfP");
var $dbxbu = parcelRequire("dbxbu");
class $ed0ad215e8a86524$export$4657b1cf414f42b7 extends (0, $klshO.TransformNode) {
    /**
     * Gets the texture being displayed on the sphere
     */ get texture() {
        return this._texture;
    }
    /**
     * Sets the texture being displayed on the sphere
     */ set texture(newTexture) {
        if (this._texture === newTexture) return;
        this._texture = newTexture;
        if (this._useDirectMapping) {
            this._texture.wrapU = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
            this._texture.wrapV = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
            this._material.diffuseTexture = this._texture;
        } else {
            this._texture.coordinatesMode = (0, $j2mX5.Texture).FIXED_EQUIRECTANGULAR_MIRRORED_MODE; // matches orientation
            this._texture.wrapV = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
            this._material.reflectionTexture = this._texture;
        }
        this._changeTextureMode(this._textureMode);
    }
    /**
     * Gets the mesh used for the dome.
     */ get mesh() {
        return this._mesh;
    }
    /**
     * The current fov(field of view) multiplier, 0.0 - 2.0. Defaults to 1.0. Lower values "zoom in" and higher values "zoom out".
     * Also see the options.resolution property.
     */ get fovMultiplier() {
        return this._material.fovMultiplier;
    }
    set fovMultiplier(value) {
        this._material.fovMultiplier = value;
    }
    /**
     * Gets or set the current texture mode for the texture. It can be:
     * * TextureDome.MODE_MONOSCOPIC : Define the texture source as a Monoscopic panoramic 360.
     * * TextureDome.MODE_TOPBOTTOM  : Define the texture source as a Stereoscopic TopBottom/OverUnder panoramic 360.
     * * TextureDome.MODE_SIDEBYSIDE : Define the texture source as a Stereoscopic Side by Side panoramic 360.
     */ get textureMode() {
        return this._textureMode;
    }
    /**
     * Sets the current texture mode for the texture. It can be:
     * * TextureDome.MODE_MONOSCOPIC : Define the texture source as a Monoscopic panoramic 360.
     * * TextureDome.MODE_TOPBOTTOM  : Define the texture source as a Stereoscopic TopBottom/OverUnder panoramic 360.
     * * TextureDome.MODE_SIDEBYSIDE : Define the texture source as a Stereoscopic Side by Side panoramic 360.
     */ set textureMode(value) {
        if (this._textureMode === value) return;
        this._changeTextureMode(value);
    }
    /**
     * Is it a 180 degrees dome (half dome) or 360 texture (full dome)
     */ get halfDome() {
        return this._halfDome;
    }
    /**
     * Set the halfDome mode. If set, only the front (180 degrees) will be displayed and the back will be blacked out.
     */ set halfDome(enabled) {
        this._halfDome = enabled;
        this._halfDomeMask.setEnabled(enabled);
        this._changeTextureMode(this._textureMode);
    }
    /**
     * Set the cross-eye mode. If set, images that can be seen when crossing eyes will render correctly
     */ set crossEye(enabled) {
        this._crossEye = enabled;
        this._changeTextureMode(this._textureMode);
    }
    /**
     * Is it a cross-eye texture?
     */ get crossEye() {
        return this._crossEye;
    }
    /**
     * The background material of this dome.
     */ get material() {
        return this._material;
    }
    /**
     * Create an instance of this class and pass through the parameters to the relevant classes- Texture, StandardMaterial, and Mesh.
     * @param name Element's name, child elements will append suffixes for their own names.
     * @param textureUrlOrElement defines the url(s) or the (video) HTML element to use
     * @param options An object containing optional or exposed sub element properties
     * @param options.resolution
     * @param options.clickToPlay
     * @param options.autoPlay
     * @param options.loop
     * @param options.size
     * @param options.poster
     * @param options.faceForward
     * @param options.useDirectMapping
     * @param options.halfDomeMode
     * @param options.crossEyeMode
     * @param options.generateMipMaps
     * @param options.mesh
     * @param scene
     * @param onError
     */ constructor(name, textureUrlOrElement, options, scene, // eslint-disable-next-line @typescript-eslint/naming-convention
    onError = null){
        super(name, scene);
        this.onError = onError;
        this._halfDome = false;
        this._crossEye = false;
        this._useDirectMapping = false;
        this._textureMode = $ed0ad215e8a86524$export$4657b1cf414f42b7.MODE_MONOSCOPIC;
        /**
         * Oberserver used in Stereoscopic VR Mode.
         */ this._onBeforeCameraRenderObserver = null;
        /**
         * Observable raised when an error occurred while loading the texture
         */ this.onLoadErrorObservable = new (0, $diGQf.Observable)();
        /**
         * Observable raised when the texture finished loading
         */ this.onLoadObservable = new (0, $diGQf.Observable)();
        scene = this.getScene();
        // set defaults and manage values
        name = name || "textureDome";
        options.resolution = Math.abs(options.resolution) | 0 || 32;
        options.clickToPlay = Boolean(options.clickToPlay);
        options.autoPlay = options.autoPlay === undefined ? true : Boolean(options.autoPlay);
        options.loop = options.loop === undefined ? true : Boolean(options.loop);
        options.size = Math.abs(options.size) || (scene.activeCamera ? scene.activeCamera.maxZ * 0.48 : 1000);
        if (options.useDirectMapping === undefined) this._useDirectMapping = true;
        else this._useDirectMapping = options.useDirectMapping;
        if (options.faceForward === undefined) options.faceForward = true;
        this._setReady(false);
        if (!options.mesh) this._mesh = (0, $8KqOo.CreateSphere)(name + "_mesh", {
            segments: options.resolution,
            diameter: options.size,
            updatable: false,
            sideOrientation: (0, $fbuqw.Mesh).BACKSIDE
        }, scene);
        else this._mesh = options.mesh;
        // configure material
        const material = this._material = new (0, $fZkIz.BackgroundMaterial)(name + "_material", scene);
        material.useEquirectangularFOV = true;
        material.fovMultiplier = 1.0;
        material.opacityFresnel = false;
        const texture = this._initTexture(textureUrlOrElement, scene, options);
        this.texture = texture;
        // configure mesh
        this._mesh.material = material;
        this._mesh.parent = this;
        // create a (disabled until needed) mask to cover unneeded segments of 180 texture.
        this._halfDomeMask = (0, $8KqOo.CreateSphere)("", {
            slice: 0.5,
            diameter: options.size * 0.98,
            segments: options.resolution * 2,
            sideOrientation: (0, $fbuqw.Mesh).BACKSIDE
        }, scene);
        this._halfDomeMask.rotate((0, $dbxbu.Axis).X, -Math.PI / 2);
        // set the parent, so it will always be positioned correctly AND will be disposed when the main sphere is disposed
        this._halfDomeMask.parent = this._mesh;
        this._halfDome = !!options.halfDomeMode;
        // enable or disable according to the settings
        this._halfDomeMask.setEnabled(this._halfDome);
        this._crossEye = !!options.crossEyeMode;
        // create
        this._texture.anisotropicFilteringLevel = 1;
        this._texture.onLoadObservable.addOnce(()=>{
            this._setReady(true);
        });
        // Initial rotation
        if (options.faceForward && scene.activeCamera) {
            const camera = scene.activeCamera;
            const forward = (0, $ha1VO.Vector3).Forward();
            const direction = (0, $ha1VO.Vector3).TransformNormal(forward, camera.getViewMatrix());
            direction.normalize();
            this.rotation.y = Math.acos((0, $ha1VO.Vector3).Dot(forward, direction));
        }
        this._changeTextureMode(this._textureMode);
    }
    _changeTextureMode(value) {
        this._scene.onBeforeCameraRenderObservable.remove(this._onBeforeCameraRenderObserver);
        this._textureMode = value;
        // Default Setup and Reset.
        this._texture.uScale = 1;
        this._texture.vScale = 1;
        this._texture.uOffset = 0;
        this._texture.vOffset = 0;
        this._texture.vAng = 0;
        switch(value){
            case $ed0ad215e8a86524$export$4657b1cf414f42b7.MODE_MONOSCOPIC:
                if (this._halfDome) {
                    this._texture.uScale = 2;
                    this._texture.uOffset = -1;
                }
                break;
            case $ed0ad215e8a86524$export$4657b1cf414f42b7.MODE_SIDEBYSIDE:
                {
                    // in half-dome mode the uScale should be double of 360 texture
                    // Use 0.99999 to boost perf by not switching program
                    this._texture.uScale = this._halfDome ? 0.99999 : 0.5;
                    const rightOffset = this._halfDome ? 0.0 : 0.5;
                    const leftOffset = this._halfDome ? -0.5 : 0.0;
                    this._onBeforeCameraRenderObserver = this._scene.onBeforeCameraRenderObservable.add((camera)=>{
                        let isRightCamera = camera.isRightCamera;
                        if (this._crossEye) isRightCamera = !isRightCamera;
                        if (isRightCamera) this._texture.uOffset = rightOffset;
                        else this._texture.uOffset = leftOffset;
                    });
                    break;
                }
            case $ed0ad215e8a86524$export$4657b1cf414f42b7.MODE_TOPBOTTOM:
                // in half-dome mode the vScale should be double of 360 texture
                // Use 0.99999 to boost perf by not switching program
                this._texture.vScale = this._halfDome ? 0.99999 : 0.5;
                this._onBeforeCameraRenderObserver = this._scene.onBeforeCameraRenderObservable.add((camera)=>{
                    let isRightCamera = camera.isRightCamera;
                    // allow "cross-eye" if left and right were switched in this mode
                    if (this._crossEye) isRightCamera = !isRightCamera;
                    this._texture.vOffset = isRightCamera ? 0.5 : 0.0;
                });
                break;
        }
    }
    /**
     * Releases resources associated with this node.
     * @param doNotRecurse Set to true to not recurse into each children (recurse into each children by default)
     * @param disposeMaterialAndTextures Set to true to also dispose referenced materials and textures (false by default)
     */ dispose(doNotRecurse, disposeMaterialAndTextures = false) {
        this._texture.dispose();
        this._mesh.dispose();
        this._material.dispose();
        this._scene.onBeforeCameraRenderObservable.remove(this._onBeforeCameraRenderObserver);
        this.onLoadErrorObservable.clear();
        this.onLoadObservable.clear();
        super.dispose(doNotRecurse, disposeMaterialAndTextures);
    }
}
/**
 * Define the source as a Monoscopic panoramic 360/180.
 */ $ed0ad215e8a86524$export$4657b1cf414f42b7.MODE_MONOSCOPIC = 0;
/**
 * Define the source as a Stereoscopic TopBottom/OverUnder panoramic 360/180.
 */ $ed0ad215e8a86524$export$4657b1cf414f42b7.MODE_TOPBOTTOM = 1;
/**
 * Define the source as a Stereoscopic Side by Side panoramic 360/180.
 */ $ed0ad215e8a86524$export$4657b1cf414f42b7.MODE_SIDEBYSIDE = 2;

});


parcelRegister("7jk2q", function(module, exports) {

$parcel$export(module.exports, "_forceSceneHelpersToBundle", () => $5529d9e4f19aca00$export$a876586dbe1c3fc);

var $kVtWi = parcelRequire("kVtWi");

var $gmbCk = parcelRequire("gmbCk");

var $ha1VO = parcelRequire("ha1VO");

var $j2mX5 = parcelRequire("j2mX5");

var $gAH3H = parcelRequire("gAH3H");

var $5Ezgc = parcelRequire("5Ezgc");

var $lgdKn = parcelRequire("lgdKn");

var $eRBiN = parcelRequire("eRBiN");

var $gSOV5 = parcelRequire("gSOV5");

var $jIhlp = parcelRequire("jIhlp");

var $hLYkZ = parcelRequire("hLYkZ");
parcelRequire("hdvNa");
parcelRequire("lkQQp");
parcelRequire("72wSy");

var $4C7Qm = parcelRequire("4C7Qm");

var $bwZgn = parcelRequire("bwZgn");
var $5529d9e4f19aca00$export$a876586dbe1c3fc = true;
(0, $gmbCk.Scene).prototype.createDefaultLight = function(replace = false) {
    // Dispose existing light in replace mode.
    if (replace) {
        if (this.lights) for(let i = 0; i < this.lights.length; i++)this.lights[i].dispose();
    }
    // Light
    if (this.lights.length === 0) new (0, $lgdKn.HemisphericLight)("default light", (0, $ha1VO.Vector3).Up(), this);
};
(0, $gmbCk.Scene).prototype.createDefaultCamera = function(createArcRotateCamera = false, replace = false, attachCameraControls = false) {
    // Dispose existing camera in replace mode.
    if (replace) {
        if (this.activeCamera) {
            this.activeCamera.dispose();
            this.activeCamera = null;
        }
    }
    // Camera
    if (!this.activeCamera) {
        const worldExtends = this.getWorldExtends((mesh)=>mesh.isVisible && mesh.isEnabled());
        const worldSize = worldExtends.max.subtract(worldExtends.min);
        const worldCenter = worldExtends.min.add(worldSize.scale(0.5));
        let camera;
        let radius = worldSize.length() * 1.5;
        // empty scene scenario!
        if (!isFinite(radius)) {
            radius = 1;
            worldCenter.copyFromFloats(0, 0, 0);
        }
        if (createArcRotateCamera) {
            const arcRotateCamera = new (0, $jIhlp.ArcRotateCamera)("default camera", -(Math.PI / 2), Math.PI / 2, radius, worldCenter, this);
            arcRotateCamera.lowerRadiusLimit = radius * 0.01;
            arcRotateCamera.wheelPrecision = 100 / radius;
            camera = arcRotateCamera;
        } else {
            const freeCamera = new (0, $gSOV5.FreeCamera)("default camera", new (0, $ha1VO.Vector3)(worldCenter.x, worldCenter.y, -radius), this);
            freeCamera.setTarget(worldCenter);
            camera = freeCamera;
        }
        camera.minZ = radius * 0.01;
        camera.maxZ = radius * 1000;
        camera.speed = radius * 0.2;
        this.activeCamera = camera;
        if (attachCameraControls) camera.attachControl();
    }
};
(0, $gmbCk.Scene).prototype.createDefaultCameraOrLight = function(createArcRotateCamera = false, replace = false, attachCameraControls = false) {
    this.createDefaultLight(replace);
    this.createDefaultCamera(createArcRotateCamera, replace, attachCameraControls);
};
(0, $gmbCk.Scene).prototype.createDefaultSkybox = function(environmentTexture, pbr = false, scale = 1000, blur = 0, setGlobalEnvTexture = true) {
    if (!environmentTexture) {
        (0, $kVtWi.Logger).Warn("Can not create default skybox without environment texture.");
        return null;
    }
    if (setGlobalEnvTexture) {
        if (environmentTexture) this.environmentTexture = environmentTexture;
    }
    // Skybox
    const hdrSkybox = (0, $4C7Qm.CreateBox)("hdrSkyBox", {
        size: scale
    }, this);
    if (pbr) {
        const hdrSkyboxMaterial = new (0, $5Ezgc.PBRMaterial)("skyBox", this);
        hdrSkyboxMaterial.backFaceCulling = false;
        hdrSkyboxMaterial.reflectionTexture = environmentTexture.clone();
        if (hdrSkyboxMaterial.reflectionTexture) hdrSkyboxMaterial.reflectionTexture.coordinatesMode = (0, $j2mX5.Texture).SKYBOX_MODE;
        hdrSkyboxMaterial.microSurface = 1.0 - blur;
        hdrSkyboxMaterial.disableLighting = true;
        hdrSkyboxMaterial.twoSidedLighting = true;
        hdrSkybox.material = hdrSkyboxMaterial;
    } else {
        const skyboxMaterial = new (0, $gAH3H.StandardMaterial)("skyBox", this);
        skyboxMaterial.backFaceCulling = false;
        skyboxMaterial.reflectionTexture = environmentTexture.clone();
        if (skyboxMaterial.reflectionTexture) skyboxMaterial.reflectionTexture.coordinatesMode = (0, $j2mX5.Texture).SKYBOX_MODE;
        skyboxMaterial.disableLighting = true;
        hdrSkybox.material = skyboxMaterial;
    }
    hdrSkybox.isPickable = false;
    hdrSkybox.infiniteDistance = true;
    hdrSkybox.ignoreCameraMaxZ = true;
    return hdrSkybox;
};
(0, $gmbCk.Scene).prototype.createDefaultEnvironment = function(options) {
    if (0, $eRBiN.EnvironmentHelper) return new (0, $eRBiN.EnvironmentHelper)(options, this);
    return null;
};
(0, $gmbCk.Scene).prototype.createDefaultVRExperience = function(webVROptions = {}) {
    return new (0, $hLYkZ.VRExperienceHelper)(this, webVROptions);
};
(0, $gmbCk.Scene).prototype.createDefaultXRExperienceAsync = function(options = {}) {
    return (0, $bwZgn.WebXRDefaultExperience).CreateAsync(this, options).then((helper)=>{
        return helper;
    });
};

});
parcelRegister("5Ezgc", function(module, exports) {

$parcel$export(module.exports, "PBRMaterial", () => $41dc0a1e6e49e5da$export$ff1a5ab25b308f43);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $gVj3s = parcelRequire("gVj3s");

var $7etnY = parcelRequire("7etnY");

var $4G6Xh = parcelRequire("4G6Xh");

var $8DoUR = parcelRequire("8DoUR");

var $54229 = parcelRequire("54229");

var $6Ho1L = parcelRequire("6Ho1L");
class $41dc0a1e6e49e5da$export$ff1a5ab25b308f43 extends (0, $4G6Xh.PBRBaseMaterial) {
    /**
     * Stores the refracted light information in a texture.
     */ get refractionTexture() {
        return this.subSurface.refractionTexture;
    }
    set refractionTexture(value) {
        this.subSurface.refractionTexture = value;
        if (value) this.subSurface.isRefractionEnabled = true;
        else if (!this.subSurface.linkRefractionWithTransparency) this.subSurface.isRefractionEnabled = false;
    }
    /**
     * Index of refraction of the material base layer.
     * https://en.wikipedia.org/wiki/List_of_refractive_indices
     *
     * This does not only impact refraction but also the Base F0 of Dielectric Materials.
     *
     * From dielectric fresnel rules: F0 = square((iorT - iorI) / (iorT + iorI))
     */ get indexOfRefraction() {
        return this.subSurface.indexOfRefraction;
    }
    set indexOfRefraction(value) {
        this.subSurface.indexOfRefraction = value;
    }
    /**
     * Controls if refraction needs to be inverted on Y. This could be useful for procedural texture.
     */ get invertRefractionY() {
        return this.subSurface.invertRefractionY;
    }
    set invertRefractionY(value) {
        this.subSurface.invertRefractionY = value;
    }
    /**
     * This parameters will make the material used its opacity to control how much it is refracting against not.
     * Materials half opaque for instance using refraction could benefit from this control.
     */ get linkRefractionWithTransparency() {
        return this.subSurface.linkRefractionWithTransparency;
    }
    set linkRefractionWithTransparency(value) {
        this.subSurface.linkRefractionWithTransparency = value;
        if (value) this.subSurface.isRefractionEnabled = true;
    }
    /**
     * BJS is using an hardcoded light falloff based on a manually sets up range.
     * In PBR, one way to represents the falloff is to use the inverse squared root algorithm.
     * This parameter can help you switch back to the BJS mode in order to create scenes using both materials.
     */ get usePhysicalLightFalloff() {
        return this._lightFalloff === (0, $4G6Xh.PBRBaseMaterial).LIGHTFALLOFF_PHYSICAL;
    }
    /**
     * BJS is using an hardcoded light falloff based on a manually sets up range.
     * In PBR, one way to represents the falloff is to use the inverse squared root algorithm.
     * This parameter can help you switch back to the BJS mode in order to create scenes using both materials.
     */ set usePhysicalLightFalloff(value) {
        if (value !== this.usePhysicalLightFalloff) {
            // Ensure the effect will be rebuilt.
            this._markAllSubMeshesAsTexturesDirty();
            if (value) this._lightFalloff = (0, $4G6Xh.PBRBaseMaterial).LIGHTFALLOFF_PHYSICAL;
            else this._lightFalloff = (0, $4G6Xh.PBRBaseMaterial).LIGHTFALLOFF_STANDARD;
        }
    }
    /**
     * In order to support the falloff compatibility with gltf, a special mode has been added
     * to reproduce the gltf light falloff.
     */ get useGLTFLightFalloff() {
        return this._lightFalloff === (0, $4G6Xh.PBRBaseMaterial).LIGHTFALLOFF_GLTF;
    }
    /**
     * In order to support the falloff compatibility with gltf, a special mode has been added
     * to reproduce the gltf light falloff.
     */ set useGLTFLightFalloff(value) {
        if (value !== this.useGLTFLightFalloff) {
            // Ensure the effect will be rebuilt.
            this._markAllSubMeshesAsTexturesDirty();
            if (value) this._lightFalloff = (0, $4G6Xh.PBRBaseMaterial).LIGHTFALLOFF_GLTF;
            else this._lightFalloff = (0, $4G6Xh.PBRBaseMaterial).LIGHTFALLOFF_STANDARD;
        }
    }
    /**
     * Gets the image processing configuration used either in this material.
     */ get imageProcessingConfiguration() {
        return this._imageProcessingConfiguration;
    }
    /**
     * Sets the Default image processing configuration used either in the this material.
     *
     * If sets to null, the scene one is in use.
     */ set imageProcessingConfiguration(value) {
        this._attachImageProcessingConfiguration(value);
        // Ensure the effect will be rebuilt.
        this._markAllSubMeshesAsTexturesDirty();
    }
    /**
     * Gets whether the color curves effect is enabled.
     */ get cameraColorCurvesEnabled() {
        return this.imageProcessingConfiguration.colorCurvesEnabled;
    }
    /**
     * Sets whether the color curves effect is enabled.
     */ set cameraColorCurvesEnabled(value) {
        this.imageProcessingConfiguration.colorCurvesEnabled = value;
    }
    /**
     * Gets whether the color grading effect is enabled.
     */ get cameraColorGradingEnabled() {
        return this.imageProcessingConfiguration.colorGradingEnabled;
    }
    /**
     * Gets whether the color grading effect is enabled.
     */ set cameraColorGradingEnabled(value) {
        this.imageProcessingConfiguration.colorGradingEnabled = value;
    }
    /**
     * Gets whether tonemapping is enabled or not.
     */ get cameraToneMappingEnabled() {
        return this._imageProcessingConfiguration.toneMappingEnabled;
    }
    /**
     * Sets whether tonemapping is enabled or not
     */ set cameraToneMappingEnabled(value) {
        this._imageProcessingConfiguration.toneMappingEnabled = value;
    }
    /**
     * The camera exposure used on this material.
     * This property is here and not in the camera to allow controlling exposure without full screen post process.
     * This corresponds to a photographic exposure.
     */ get cameraExposure() {
        return this._imageProcessingConfiguration.exposure;
    }
    /**
     * The camera exposure used on this material.
     * This property is here and not in the camera to allow controlling exposure without full screen post process.
     * This corresponds to a photographic exposure.
     */ set cameraExposure(value) {
        this._imageProcessingConfiguration.exposure = value;
    }
    /**
     * Gets The camera contrast used on this material.
     */ get cameraContrast() {
        return this._imageProcessingConfiguration.contrast;
    }
    /**
     * Sets The camera contrast used on this material.
     */ set cameraContrast(value) {
        this._imageProcessingConfiguration.contrast = value;
    }
    /**
     * Gets the Color Grading 2D Lookup Texture.
     */ get cameraColorGradingTexture() {
        return this._imageProcessingConfiguration.colorGradingTexture;
    }
    /**
     * Sets the Color Grading 2D Lookup Texture.
     */ set cameraColorGradingTexture(value) {
        this._imageProcessingConfiguration.colorGradingTexture = value;
    }
    /**
     * The color grading curves provide additional color adjustment that is applied after any color grading transform (3D LUT).
     * They allow basic adjustment of saturation and small exposure adjustments, along with color filter tinting to provide white balance adjustment or more stylistic effects.
     * These are similar to controls found in many professional imaging or colorist software. The global controls are applied to the entire image. For advanced tuning, extra controls are provided to adjust the shadow, midtone and highlight areas of the image;
     * corresponding to low luminance, medium luminance, and high luminance areas respectively.
     */ get cameraColorCurves() {
        return this._imageProcessingConfiguration.colorCurves;
    }
    /**
     * The color grading curves provide additional color adjustment that is applied after any color grading transform (3D LUT).
     * They allow basic adjustment of saturation and small exposure adjustments, along with color filter tinting to provide white balance adjustment or more stylistic effects.
     * These are similar to controls found in many professional imaging or colorist software. The global controls are applied to the entire image. For advanced tuning, extra controls are provided to adjust the shadow, midtone and highlight areas of the image;
     * corresponding to low luminance, medium luminance, and high luminance areas respectively.
     */ set cameraColorCurves(value) {
        this._imageProcessingConfiguration.colorCurves = value;
    }
    /**
     * Instantiates a new PBRMaterial instance.
     *
     * @param name The material name
     * @param scene The scene the material will be use in.
     */ constructor(name, scene){
        super(name, scene);
        /**
         * Intensity of the direct lights e.g. the four lights available in your scene.
         * This impacts both the direct diffuse and specular highlights.
         */ this.directIntensity = 1.0;
        /**
         * Intensity of the emissive part of the material.
         * This helps controlling the emissive effect without modifying the emissive color.
         */ this.emissiveIntensity = 1.0;
        /**
         * Intensity of the environment e.g. how much the environment will light the object
         * either through harmonics for rough material or through the reflection for shiny ones.
         */ this.environmentIntensity = 1.0;
        /**
         * This is a special control allowing the reduction of the specular highlights coming from the
         * four lights of the scene. Those highlights may not be needed in full environment lighting.
         */ this.specularIntensity = 1.0;
        /**
         * Debug Control allowing disabling the bump map on this material.
         */ this.disableBumpMap = false;
        /**
         * AKA Occlusion Texture Intensity in other nomenclature.
         */ this.ambientTextureStrength = 1.0;
        /**
         * Defines how much the AO map is occluding the analytical lights (point spot...).
         * 1 means it completely occludes it
         * 0 mean it has no impact
         */ this.ambientTextureImpactOnAnalyticalLights = $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.DEFAULT_AO_ON_ANALYTICAL_LIGHTS;
        /**
         * In metallic workflow, specifies an F0 factor to help configuring the material F0.
         * By default the indexOfrefraction is used to compute F0;
         *
         * This is used as a factor against the default reflectance at normal incidence to tweak it.
         *
         * F0 = defaultF0 * metallicF0Factor * metallicReflectanceColor;
         * F90 = metallicReflectanceColor;
         */ this.metallicF0Factor = 1;
        /**
         * In metallic workflow, specifies an F0 color.
         * By default the F90 is always 1;
         *
         * Please note that this factor is also used as a factor against the default reflectance at normal incidence.
         *
         * F0 = defaultF0_from_IOR * metallicF0Factor * metallicReflectanceColor
         * F90 = metallicF0Factor;
         */ this.metallicReflectanceColor = (0, $7etnY.Color3).White();
        /**
         * Specifies that only the A channel from metallicReflectanceTexture should be used.
         * If false, both RGB and A channels will be used
         */ this.useOnlyMetallicFromMetallicReflectanceTexture = false;
        /**
         * The color of a material in ambient lighting.
         */ this.ambientColor = new (0, $7etnY.Color3)(0, 0, 0);
        /**
         * AKA Diffuse Color in other nomenclature.
         */ this.albedoColor = new (0, $7etnY.Color3)(1, 1, 1);
        /**
         * AKA Specular Color in other nomenclature.
         */ this.reflectivityColor = new (0, $7etnY.Color3)(1, 1, 1);
        /**
         * The color reflected from the material.
         */ this.reflectionColor = new (0, $7etnY.Color3)(1.0, 1.0, 1.0);
        /**
         * The color emitted from the material.
         */ this.emissiveColor = new (0, $7etnY.Color3)(0, 0, 0);
        /**
         * AKA Glossiness in other nomenclature.
         */ this.microSurface = 1.0;
        /**
         * If true, the light map contains occlusion information instead of lighting info.
         */ this.useLightmapAsShadowmap = false;
        /**
         * Specifies that the alpha is coming form the albedo channel alpha channel for alpha blending.
         */ this.useAlphaFromAlbedoTexture = false;
        /**
         * Enforces alpha test in opaque or blend mode in order to improve the performances of some situations.
         */ this.forceAlphaTest = false;
        /**
         * Defines the alpha limits in alpha test mode.
         */ this.alphaCutOff = 0.4;
        /**
         * Specifies that the material will keep the specular highlights over a transparent surface (only the most luminous ones).
         * A car glass is a good example of that. When sun reflects on it you can not see what is behind.
         */ this.useSpecularOverAlpha = true;
        /**
         * Specifies if the reflectivity texture contains the glossiness information in its alpha channel.
         */ this.useMicroSurfaceFromReflectivityMapAlpha = false;
        /**
         * Specifies if the metallic texture contains the roughness information in its alpha channel.
         */ this.useRoughnessFromMetallicTextureAlpha = true;
        /**
         * Specifies if the metallic texture contains the roughness information in its green channel.
         * Needs useRoughnessFromMetallicTextureAlpha to be false.
         */ this.useRoughnessFromMetallicTextureGreen = false;
        /**
         * Specifies if the metallic texture contains the metallness information in its blue channel.
         */ this.useMetallnessFromMetallicTextureBlue = false;
        /**
         * Specifies if the metallic texture contains the ambient occlusion information in its red channel.
         */ this.useAmbientOcclusionFromMetallicTextureRed = false;
        /**
         * Specifies if the ambient texture contains the ambient occlusion information in its red channel only.
         */ this.useAmbientInGrayScale = false;
        /**
         * In case the reflectivity map does not contain the microsurface information in its alpha channel,
         * The material will try to infer what glossiness each pixel should be.
         */ this.useAutoMicroSurfaceFromReflectivityMap = false;
        /**
         * Specifies that the material will keeps the reflection highlights over a transparent surface (only the most luminous ones).
         * A car glass is a good example of that. When the street lights reflects on it you can not see what is behind.
         */ this.useRadianceOverAlpha = true;
        /**
         * Allows using an object space normal map (instead of tangent space).
         */ this.useObjectSpaceNormalMap = false;
        /**
         * Allows using the bump map in parallax mode.
         */ this.useParallax = false;
        /**
         * Allows using the bump map in parallax occlusion mode.
         */ this.useParallaxOcclusion = false;
        /**
         * Controls the scale bias of the parallax mode.
         */ this.parallaxScaleBias = 0.05;
        /**
         * If sets to true, disables all the lights affecting the material.
         */ this.disableLighting = false;
        /**
         * Force the shader to compute irradiance in the fragment shader in order to take bump in account.
         */ this.forceIrradianceInFragment = false;
        /**
         * Number of Simultaneous lights allowed on the material.
         */ this.maxSimultaneousLights = 4;
        /**
         * If sets to true, x component of normal map value will invert (x = 1.0 - x).
         */ this.invertNormalMapX = false;
        /**
         * If sets to true, y component of normal map value will invert (y = 1.0 - y).
         */ this.invertNormalMapY = false;
        /**
         * If sets to true and backfaceCulling is false, normals will be flipped on the backside.
         */ this.twoSidedLighting = false;
        /**
         * A fresnel is applied to the alpha of the model to ensure grazing angles edges are not alpha tested.
         * And/Or occlude the blended part. (alpha is converted to gamma to compute the fresnel)
         */ this.useAlphaFresnel = false;
        /**
         * A fresnel is applied to the alpha of the model to ensure grazing angles edges are not alpha tested.
         * And/Or occlude the blended part. (alpha stays linear to compute the fresnel)
         */ this.useLinearAlphaFresnel = false;
        /**
         * Let user defines the brdf lookup texture used for IBL.
         * A default 8bit version is embedded but you could point at :
         * * Default texture: https://assets.babylonjs.com/environments/correlatedMSBRDF_RGBD.png
         * * Default 16bit pixel depth texture: https://assets.babylonjs.com/environments/correlatedMSBRDF.dds
         * * LEGACY Default None correlated https://assets.babylonjs.com/environments/uncorrelatedBRDF_RGBD.png
         * * LEGACY Default None correlated 16bit pixel depth https://assets.babylonjs.com/environments/uncorrelatedBRDF.dds
         */ this.environmentBRDFTexture = null;
        /**
         * Force normal to face away from face.
         */ this.forceNormalForward = false;
        /**
         * Enables specular anti aliasing in the PBR shader.
         * It will both interacts on the Geometry for analytical and IBL lighting.
         * It also prefilter the roughness map based on the bump values.
         */ this.enableSpecularAntiAliasing = false;
        /**
         * This parameters will enable/disable Horizon occlusion to prevent normal maps to look shiny when the normal
         * makes the reflect vector face the model (under horizon).
         */ this.useHorizonOcclusion = true;
        /**
         * This parameters will enable/disable radiance occlusion by preventing the radiance to lit
         * too much the area relying on ambient texture to define their ambient occlusion.
         */ this.useRadianceOcclusion = true;
        /**
         * If set to true, no lighting calculations will be applied.
         */ this.unlit = false;
        /**
         * If sets to true, the decal map will be applied after the detail map. Else, it is applied before (default: false)
         */ this.applyDecalMapAfterDetailMap = false;
        this._environmentBRDFTexture = (0, $gVj3s.GetEnvironmentBRDFTexture)(this.getScene());
    }
    /**
     * @returns the name of this material class.
     */ getClassName() {
        return "PBRMaterial";
    }
    /**
     * Makes a duplicate of the current material.
     * @param name - name to use for the new material.
     * @param cloneTexturesOnlyOnce - if a texture is used in more than one channel (e.g diffuse and opacity), only clone it once and reuse it on the other channels. Default false.
     * @param rootUrl defines the root URL to use to load textures
     * @returns cloned material instance
     */ clone(name, cloneTexturesOnlyOnce = true, rootUrl = "") {
        const clone = (0, $6Ho1L.SerializationHelper).Clone(()=>new $41dc0a1e6e49e5da$export$ff1a5ab25b308f43(name, this.getScene()), this, {
            cloneTexturesOnlyOnce: cloneTexturesOnlyOnce
        });
        clone.id = name;
        clone.name = name;
        this.stencil.copyTo(clone.stencil);
        this._clonePlugins(clone, rootUrl);
        return clone;
    }
    /**
     * Serializes this PBR Material.
     * @returns - An object with the serialized material.
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.customType = "BABYLON.PBRMaterial";
        return serializationObject;
    }
    // Statics
    /**
     * Parses a PBR Material from a serialized object.
     * @param source - Serialized object.
     * @param scene - BJS scene instance.
     * @param rootUrl - url for the scene object
     * @returns - PBRMaterial
     */ static Parse(source, scene, rootUrl) {
        const material = (0, $6Ho1L.SerializationHelper).Parse(()=>new $41dc0a1e6e49e5da$export$ff1a5ab25b308f43(source.name, scene), source, scene, rootUrl);
        if (source.stencil) material.stencil.parse(source.stencil, scene, rootUrl);
        (0, $54229.Material)._ParsePlugins(source, material, scene, rootUrl);
        // The code block below ensures backward compatibility with serialized materials before plugins are automatically serialized.
        if (source.clearCoat) material.clearCoat.parse(source.clearCoat, scene, rootUrl);
        if (source.anisotropy) material.anisotropy.parse(source.anisotropy, scene, rootUrl);
        if (source.brdf) material.brdf.parse(source.brdf, scene, rootUrl);
        if (source.sheen) material.sheen.parse(source.sheen, scene, rootUrl);
        if (source.subSurface) material.subSurface.parse(source.subSurface, scene, rootUrl);
        if (source.iridescence) material.iridescence.parse(source.iridescence, scene, rootUrl);
        return material;
    }
}
/**
 * PBRMaterialTransparencyMode: No transparency mode, Alpha channel is not use.
 */ $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.PBRMATERIAL_OPAQUE = (0, $4G6Xh.PBRBaseMaterial).PBRMATERIAL_OPAQUE;
/**
 * PBRMaterialTransparencyMode: Alpha Test mode, pixel are discarded below a certain threshold defined by the alpha cutoff value.
 */ $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.PBRMATERIAL_ALPHATEST = (0, $4G6Xh.PBRBaseMaterial).PBRMATERIAL_ALPHATEST;
/**
 * PBRMaterialTransparencyMode: Pixels are blended (according to the alpha mode) with the already drawn pixels in the current frame buffer.
 */ $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.PBRMATERIAL_ALPHABLEND = (0, $4G6Xh.PBRBaseMaterial).PBRMATERIAL_ALPHABLEND;
/**
 * PBRMaterialTransparencyMode: Pixels are blended (according to the alpha mode) with the already drawn pixels in the current frame buffer.
 * They are also discarded below the alpha cutoff threshold to improve performances.
 */ $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.PBRMATERIAL_ALPHATESTANDBLEND = (0, $4G6Xh.PBRBaseMaterial).PBRMATERIAL_ALPHATESTANDBLEND;
/**
 * Defines the default value of how much AO map is occluding the analytical lights
 * (point spot...).
 */ $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.DEFAULT_AO_ON_ANALYTICAL_LIGHTS = (0, $4G6Xh.PBRBaseMaterial).DEFAULT_AO_ON_ANALYTICAL_LIGHTS;
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "directIntensity", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "emissiveIntensity", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "environmentIntensity", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "specularIntensity", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "disableBumpMap", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "albedoTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "ambientTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "ambientTextureStrength", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "ambientTextureImpactOnAnalyticalLights", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesAndMiscDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "opacityTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "reflectionTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "emissiveTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "reflectivityTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "metallicTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "metallic", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "roughness", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "metallicF0Factor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor3)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "metallicReflectanceColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "useOnlyMetallicFromMetallicReflectanceTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "metallicReflectanceTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "reflectanceTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "microSurfaceTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "bumpTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty", null)
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "lightmapTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor3)("ambient"),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "ambientColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor3)("albedo"),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "albedoColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor3)("reflectivity"),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "reflectivityColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor3)("reflection"),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "reflectionColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor3)("emissive"),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "emissiveColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "microSurface", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "useLightmapAsShadowmap", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesAndMiscDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "useAlphaFromAlbedoTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesAndMiscDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "forceAlphaTest", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesAndMiscDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "alphaCutOff", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "useSpecularOverAlpha", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "useMicroSurfaceFromReflectivityMapAlpha", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "useRoughnessFromMetallicTextureAlpha", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "useRoughnessFromMetallicTextureGreen", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "useMetallnessFromMetallicTextureBlue", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "useAmbientOcclusionFromMetallicTextureRed", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "useAmbientInGrayScale", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "useAutoMicroSurfaceFromReflectivityMap", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "usePhysicalLightFalloff", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "useGLTFLightFalloff", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "useRadianceOverAlpha", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "useObjectSpaceNormalMap", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "useParallax", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "useParallaxOcclusion", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "parallaxScaleBias", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsLightsDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "disableLighting", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "forceIrradianceInFragment", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsLightsDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "maxSimultaneousLights", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "invertNormalMapX", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "invertNormalMapY", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "twoSidedLighting", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "useAlphaFresnel", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "useLinearAlphaFresnel", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "environmentBRDFTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "forceNormalForward", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "enableSpecularAntiAliasing", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "useHorizonOcclusion", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "useRadianceOcclusion", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsMiscDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "unlit", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsMiscDirty")
], $41dc0a1e6e49e5da$export$ff1a5ab25b308f43.prototype, "applyDecalMapAfterDetailMap", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.PBRMaterial", $41dc0a1e6e49e5da$export$ff1a5ab25b308f43);

});
parcelRegister("gVj3s", function(module, exports) {

$parcel$export(module.exports, "GetEnvironmentBRDFTexture", () => $c520c01920caea8f$export$9712a76d5eb55c88);
$parcel$export(module.exports, "BRDFTextureTools", () => $c520c01920caea8f$export$6160fb916073b7a7);

var $j2mX5 = parcelRequire("j2mX5");

var $ezAJn = parcelRequire("ezAJn");
// eslint-disable-next-line @typescript-eslint/naming-convention
const $c520c01920caea8f$var$_environmentBRDFBase64Texture = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAAEACAYAAABccqhmAAAgAElEQVR42u29yY5tWXIlZnbuiSaTbZFUkZRKrCKhElASQA0EoQABgn6hJvoXzfUP+gP9hWb6Bg00IgRoQJaKqUxmZmTEe8/v0uB2u7Fm2T7HIyIrnz88uPvt3f2a2WrMbOvf/u3PvvzP/sUf/N6//i8vf/lv/3v5H//d//Sb//Uq/5u8yf8hV/m/5Cp/L1f5hVzlG7nKJ7mKyJuIXN/hPwqXI/g++zq6rPI5u8z+WqfLre+zy7PrVv9L8brsMiGvk8XLmM/sdfHXal4e3ad6GXPdyu2ij8u/+uv/5cuf/OSLfdtEfvUr+dnf/d0X//t3H/7bf/hP//N/928h/0Yg/4VA/kogfyGQP5Wr/IFAvhbIlwK5CGQTPP+9z5uPeePJSW+yo2+s/GtN30Rnv1E+f5zxof9R/lSXv/nr//mrr3+i+5dfyX7ZZQP07Tffys//8R/l/9TtX7790T/7r/8G8pdy+/8XAvnnAvkzgfwzgfyxQP5AIL8vkJ8K5KsmMVzu1U7p5PA5AXxOAJ8TwPf7sX/51ZeXfcemqnp9w/W77/S7X/6T/vzf/7383RWCX3/z05/9i3/13/0PX//eX/2FyP8tIv+PiPy9iPy/IvIzEfm5iPxCRH4lIt/c/393//9BRD6KyKf7f488fP74/PH544dJAF9cLl98IZfLBZtuqterXr/7Dt9982v95S9+Lv+gF/3i7Spv/8lf/vnf/vGf/dF/JfKnIvLnIvLvReQ/NEngn0TklyLy6/v/34jIt00iGJOBlxAsdvv54/PH5493SQCXy9t2ueh2ueimKorrFbjq9eNH+fDtb+TXv/ol/vHyhX4Fxfbx7euPf/Lnf/PfiPyeiPyhiPxxkwB+fk8AvxzQgJcIrGTwFsiAEXH4/PH54/PHUgLY7whgu2C7bLqpQgHB2xvePn6SDx8+6G9+84384vKF/IPu8iVU9Y/+7C/+jWxffiHytYj8VER+X0T+oEEBvxqQwCMJeIngo5EI3goIwVMIPn98/vj8ESaAbbtu2ybbvl8u2ybbdtluSECA65u8ffqIDx8+6G++/VZ/efkV/sO261dQXP7wT/7kX8vl8qXIFyLylbySwe/dE0CLAr65B/9vGn0gQwRMMqgmhM/J4fPH548eAezbZd/lsm3YtssNAYiqiogAAkCvb5/k46cP8u2HD/rrb7+R/2/b9Wu9yJe//8d/9Ney6S5yEZFdRL68/38khG/uKOCnAwoYkcCoEXwkEgGDDq7CeQfyOTl8/vhd1QCum26ybZtu2yabbrKpQvXue1yvuF6v+vbpTT5+/CDffviAX1++1V9sO77WXb/66R/+4V/dgkbllQi+aBLBV/dE8LWRALwkYCWCNyMZXElkwLTMeMkga/P4/PH547ccAVwuctkvdxSw6bbdtYDbTfSZBN7e8PHTR/3u4wf55vKd/nL7DX6mu3791U9//5+/gkNFZGuSgZUQvnKowKgLWLTAQgRtEniTuEfwaELw0MJvf3LQzynud+53uG+X6y3gN9kul+2y6XVT1U27JCDAFVc8ksAn/e7jR/nN5YP+avtWfq6Xy9f7Vz/9w1dgRYngiyYhfNkkgzYBWHTg44AEMmqQUYQKOmDaiCIa8TmsfmzB+DnZDQjgcpGLbti2y3bZHjRAdRMVvb/dcYU8kcDbPQlsH/CrbddfbF98+RPZfvLFnAQeieCRDC5DMvju/vmD4JkEvjRQgKULeGggowdHkAHTYxihg89vu88I5UeGAPSOAFTlrgPopiqbKPSmCKreUoAAkCcSePukHz590m8vH+WbD9/JP335k6/+tA86KxFchv8jMvhiogE4JQm8XhfKqOAqx5qRPyeGzx8/cgSwbXcUoLJtim27C4Oi93+4v6VxQwKAvl2v+Hj9pB8+fZJvt4/yzfbF9lPdv/wJnsE2BogmyeCRED40tGFvksIXiSbgiYSRRpDNDZ6BDI6ghM+J4fPHeyKAO+zX7cb9t4tedMMNAQju5V+f1uAtBSiu1zsduMrHy5t8ePsk3376KN98sX/xE5FPAnm7/782o0DiUINXMkCXCB7/P94/e87AWUmARQWVvgMuKej9t1RLBp+Tw+ePgwngsutFFdu26WXbbl+rSvdfbnqAiuA23QcBgCugV1zl7e1NPm5v+LC96XfbJ/1W9y++fgXjA3bDYXV+MuhRwSPwL3JLMFYC+HS/LU8HYrGwIhwyNOF12SvgM4SgztdifP85MXz+KGsA2C6X7aJ6bXSAOwrY5OYIqGy3d5uq4P5GhABXuV6veLvRAf10fZMPb2/y3b7vX7+g+9v98/WOBq7GG7RNAlYy+Dgkhhb+Xxp0sE8IAC4SGAP/TbgVJK/PoJPBnAiwPKxsXfbbnRg+i3s/JAK4Q/4b9NfLtomBAqCickMBjy7BuywAUVyv8na94tMjCVzf9KNcLl/0SeA6oAEYb1i9g+FtSALb/bKL8/+t+wxXFMyswqiHoK4ToIgKqslgpg1qUC0QoYbvJZg/B/q5v4szHmPX7YEAsD0CX25OwEUVm9xag1+agKg+nxQArnKjAtDr9U0+Xd/k4/UqH7bL5YsewrcBBiMJZPRAp6TwQgWfjM9vgRbgUYGL8AvLWH2gqhesCokeUmCSwPsnhs8fP2YNYMO2XeSmAWxy2VQaXeDmDIhApf33rD4PTUCuV+DtCn27XuXT5ir8VmCJ2G5BpBM8/r/dEcJb8/0lEQMtJHA5TAlqNuLRhJChhEpSqFabH3di+G1AGj+W1/dyAR4IYJNNnuLf6+tWC9CHHiAtFhAIFLjK2/Uqn65X+SS67aK+3QeTDoy/IG2ogQ7fb/dAtz5vBgrYGqrwNtCHsVfgIvwK07OTQBURVNCBFpKCOjqCHn5L/67TgTN+fpySAC56nwSUi256kXsSuFGAVyLoUIDo8/Pz7fdoErr/v17lk162HbgHvFpIYDfoAJJfW4sGPjkU4VNAF8ZEcLmLhdc7kljdY1y1Dq9yLiI4IiRqcLujb138KIPn80ejATwRwIbtBvn1cqv+2J78/5EI5N4cJA8qIPcmwRsKAHDF9WYP6mV7VmrgLuTpxYTcMEW0LAmoQxFsuvAI8tv/a/C5fV2ZMMiKg++FCM7RDPRu8ebWY7VG6VJi+Bzk35MI2LsAckMAgwvQ0gC5DQjd3ABg2HQLAPpEAlZ1Bu7VV7MGHDFRAbo3VKsTbAY9sPWC/uvx86gBbDK3D1eEQS8pbAeSgSwmhepnJb6uBv/o/PzHLzxWA/X7TH77De5j6AGQi6o0CUGfCOD2X7cXAlCFQABtEsGLDtxuOyQB2UTQBKZe5GUPXgkUYCUAbZJRhBDeuq8xBf+bgwbehDm+BFQi2IJksOocvA8ysIMfxluVcRsY/eB3JzH8GFDAXQO48X/dcIf9jyDHptIigDsFkEe066tBSETQUYF7ElDdYEBytN4+rk9UcBPfrKaZqFHWcw3i4J8/X4ev2//bSXqAhwTay6OEIPLD2Ipt8OtAGzxkwLw9WVFRjTc/qC6H3+YK/b1oAA0KuOizHfieCLaHHiAb5NYTIC9EMEbZrVEQt1xwhVy1UfBh8PUOquMizwaap3tQXfY5B//tea/NZdfhsvbz+PURQTDSGWB87VX/7WSd4KxjUqrIgE0IUkoKGnhIvwvawpGf6eECXJ7tv4qbA7DJgwpsKthEmmYgfaAAffYF3HLxo0vwNjJ0SwRWMG4db4eh1gPNm18vQ+us/0eGmxDemu/fnM/X4evq/8342ksGHgLY5LyT/zg0wM8lcMjgGFXwqIOVFJBQw99eCvF9oZL9Mfl3QwAvIXDsBRC9R+fz8x0FPBLB0xJEpwUobrfAkARgIAF41h3wQgP6QAmX5E/7eI43IxGwwf/moIkRyWRJQIPgt9CA9b39nzt4bYUWjAlCjWDPgv8IEjgLJfzuaAsrv9VdVG4OwOXW/fdoA35qAdL0BDwvf6AAUVHd8LIEu94A3K+Q+2YxaB84MOH62P//qoo38fCRDERE2zf0JfmDa+MieElAjcDPKz+mRKCOtdgGtXaBjgNJ4H2owSpNeAW/rRH4CaHSpMwnBYYycjgSJwfie9CR6mPu20Uv8kABF206AvXlBMiIBPSlB9wjBW1fwEuSb94296VCqgMaGCt/G1BbExi3IG+r3a3J6P48Gv/J0YmEYoiGY7V/SxwFCwGoE/xa0AJ0CEiV9QPCJb1OJ5F1VTjEY2/MO9AEJvj1BJTQpqLfTlGwjABuzT962e4IoKnyrdh3+/6mzDVJ4PHOxj0JqGKoy20+wBMN6D1gLWi9NQHfVP5MEEPzjGYy8BMAOnTAJgEr8HUIejRo5xrA5xkR5AngmiSHs+zDDAmMgWzTg55GSJEmHE8IvWPAoYTfhWak/Wn/bQ0CGLSAjv83SUEfKp5q24LXuQICpzrjrgWoza8xVE00CQCORdhMJuTUT/rjuls0gO4Iby8BIEgK6gS7BsGuTtDrScH/fR68biUHNVGBnxjeNyHEvQe/ve3LZQqgG3rof6cEclsNflG9J4KtaQ8WHcVBHS1BtHE4QP9OBMS98mpbKTeDW7dJwRsnHpMBTFJpV4I+b0kY/NqInVFSyBLANbnMSgBM8F+Fqfxq/h657/Up+GaBnwV9hRqc9bZ/vA6vu+T9E8KPJWns94UfTeCj2QXwCHS9dNL8Xf3Ho/rfewSeFODGDV69AU0y6NFAE1DP3qK++rdB7/1HRxf86gT376zOr99T/h/ioBiXWQkgQgVeIrCC/WomhDmQK+hASI2ARQZKooHMLdCJwGEBBXC3+uERwg+VOHZ9ioAt9H80AI06wGgJ3nQA3BoCut6AhxYwgcPOFnxuFnrphk+NIKIGrWPQtgz3b0i7Y6D5rs1GKqTop0nQX52vmQC4BkjA+r4a7Kx9WLENGeegkhSETBCrNXIMdi/444Rw1n6E96ry7OPuj8UfLxtQ78NA2iSBbg7gIiIbdDLsb5agPhLC3RkYKv8NDbS2YGsatNRAG2oQwf9ZIOydgy1MAzBkAw8UwEEIDzSAqdPQ6za0PkeJAMH3Z0wXniUSZoHvBXU2mcjQgv56TedIKglCpIoQfgwCIjOytd8WgN0bfxoR8Fn9Gx0Aj5Zgq0lIZbsH/ibSJoFnS+C98g9ooHEELI3gliy25yONIiE6pb0NfBlyNEYyENoodkKwgl6I6s8kARgJ4ZoEfuYWHLEJa0LhSBXm7kImGeSfVdoJ1DO2G7WXsehAptupSOoyrCSF904k+6vt98X/ZcM98Hsd4JYIXhQAIg3/f9AAUYhsLQKAtkHVBnzjCKhOoYl2ym+iBtvzDzQ2DLXJ4PUmbJHAVnBQX4jkxfvHhNDqAdHXGQJgv0aSDGItgOseHIU+K9hXnIJzkoGlEKzNHagTdJ6VWEUH4iCKH4fd2AwDPaYBm4Wgng4gQ9V/CoGiuNmD04AQtNGMGzSAAQ2I2pzfogY9LRh7BrbOh4+D30sAencljFu2CUFrwY8UAWRfWwGvVOVfbx2uIILM0pwDv082dUTw8hYs8L+uIWiHGpWgClnAa1lMPJogovvvbePPs/q3Xr++kgCsfgB5oQF9WYKPJqEn6G+OE3i5AqouF59FQOmahQC8rlPLj38kg1c2f30vw+XaoIX24/pMGIgSBoZqoH3wo0sIIGlA9PWcCPrAtpPB8eBf6x1o6cHra+2+tpIFP4PgBfxZtZUJfo4qxELT948D9ucK8Mt9+ccjIQw6QJcEbrD/1g340ATuDgDkFfx6twSf1f9xvuBECYxq/7ythQQGm+5JDx6Brw4CkMGT3wgscCUoQ4sU2t6DR2ciBjTgtcpenQoZVX9NuL4Owc+dVaDursYVkVALX+shjSBKBuvCYDUZjE5BdNkxdHAUBexyHwB6NP7Iyw7sxUDViwge1t+mz8B/LAvVx/c3PeBBCToB8IUGOgqA3iV4yUg6UAOxaUFHDx6CYS8SorMOue0CCJGAf5YfRhoAI+A1CvwxqNkAY5yAIx2EQmkFfeWOXi+nEdSQQA0ZHMEItiagJArQxDXIrj8nCfQi4HZPAttrIahso9oPQ/2/JwV5JQU8zw+7I4D7/sBn4EO6rjw0FR+i3Z9fHtahzsFvJgM0X+tmVH5vaYiNDGAigewAz+gyNLThnjCURQFR1b9d3lZvnVqmj9mEPDKIUIC4KCCjBXywS4N+otp/Hk3QVthOkwEKlV9PQwXjT7s/zwF4Qf9toAAzFdjuaEB6S7D1//U5FIQu2MevO0rQQH8ZmoXE6B/IkgE60XCjVoq8gt2iCG0S8L5GdxkM1cGsfsCMArSCAnrr7dzAZxCEEpepvB8tqHJ/q+bmJGGts/AcAXFOMMeTwC7Pw0B6CtCtA2vWgonqBQJFSwH0JQK29OB2kvgj2HHXAoyeAIsCQO0kMNECAhFMqCBf8mElAkyBbX1tJQP2RJ/ha0gpAfS9l+/5n00CkrQpq0MZbOdAuxmMvHswog62jZj7BnYQe19b14kxNq2D/ehX/p68HEcF+x3yP7z/V/A/q/5DA3i5A/dzA5pdgbKp3v3/wQF4Bb70WkCTHGRAA6+KL0bFl6FJaFw0ImZwm6igSwbbwPn9RMBWf3sN2JgA/BVh/Rg0kQBgePf6HglAHLFQwqQQOwDjbdVxNZjR4iM6Qa3WxwvNxh0JFb3g/WzFQQS8b/ttKcDWoABtUMAd8j9hf0MB2uDXhzX4CHj03L9DBU3Qjz0C0l4mLSLQPicOOwZoVCB6P6dA7nDbGkVuxcNr8PU2JQO4wX5trEqmccZaHU4q8oCDFOpzAnOwqyMIMktNNNAHouDGxO37DgArQZzlmp/14W1QlqHTMaIIx7SCx0+5yza7AKJ3IXBrNAHVDcMZAU/BT/vgv/ULPOA+XiLggAREDF2g0ci6xNDRglegd7P7TWWH5oJfayliEg7bScQRBVgI4Ookg/F6rvpLWP29swREqA3CaG8/FpKqS8DTAV4TiBqIqtxfzaQRLys5I0XEFIFrPbZRQb+16Fgi2LvJv8EFUPW1gGfQv1T/F/d/HBnccP7rAwnIIyHI4ArgWeGbU4eHy6Tx/EeTZIb5bo/BsMBjmjBE08f/RB0PHYBd9eVRAGY7cHRwiBf8WeCPHY1bgBTa9xKTELzEkQX9CPtl0gJiqsAmCT7I8xbjivh3JGFI+D2nBcSJQJ8agDX+O9iBL7UfG4bzAkcaICrbtYHz1ycSmGmAjJfL3CMgT3tQpmrfB7gxSzC1DnvdhQMieG47u75+kTouKNkM8c/+vq/Q7ZYjO/hhVvRq8F/9gGfhP8aqE9EIdR6LTwJ1h0BItyDqB8iFwuNqASscRnYioxOg9ApvnYA35f8e9Ohbfe8J4rknoFkO0lmA2gmAG0YK0DkB4ieEjiLoMD8wBzom27ANZkzIoU8EMHk/uo1mzeVoEoRWKn8L/62EYAX/lsB7D/LXg74uAMr9oGivJ0CNJCGD6i9DhZdQF+gtOp4S+NODRzsDVbhdgv4BqTMNyIL9SCKwL9/FGPp5oQKxIf8A/UX6r231H7YIqLML0Ae2GtrADOvRQH5b/MPE9dt9BGLNG8jVTAQvIaK5TtvvvWQgDvyXIClUA78S9Nfg7VtIBlO7cbsEYkQDMot+ygQ7QwmOawTHnAM2XUSnJvPIYRYMmYPS+sv3J+cfP3d04JYIXsF/EwMbBKB9Q9AY+BiSwFj9mzrSXmcJhFPVHySTbgHJCPvRQ/z7G/SVUETsg0ZF+i3CRoCjhf7y1A9mOiDD7TwdwEoEXjLwAv+avLE2B7Jnb+OqDpBoAchoQJskxKnss0vu7Q2YhcDv4ySeLOg9GsCKiUIihP7yfW7zbTsBh0TQfN0iAWn9f72Z56/Ax9P7j5OAH/Qvv3/QxKfk0DgDuP+R3USg3bzBC7bO/QT9Eeh9QvDPG7glBQzJwK740lAFFgFk8P88CqDGAa223YckWYhr+c0BPdwetl2ocnsfzePAWcVnnAIp6gDVhDLyfV4nqFEDPxHsbWD3k4BDkN+pARqKMLYBPzYEvxp9xmCHQQdgWH/9EtH2TIFpu3AH/cdGydv1j0TQbRrq+D/mLcX3ZACZ15bF378CG0My6Kq/zoGOQwhASDFwFbxyNGBuSxbCEhQ/uEPe/6gAERWQObCVVfjPpQX+rexxYhYFxIkgpgX7Y/vPs+Pvxf9vwt8kAs7i32t3QCP+3SPaTwIytQXP38u0PESm+YER+o9B3vr8mETAUfDrEkPI80ck0FZ0dXh9U+HRbhey0cAc2H7A4y4egoD6y8JfkBiigLdFP8v2W00E8deT2IeAKujZ/QAVKpAtKI20gLWksHedfgPcb+0+NEHefd9vB9rayi8h7J91gBbaw20MsnWAF5xHkyDUCOoXp+yrOwwxcKj0aL6fFppaaKDv6OpHR5sgx5BAlK/+fYhuP1D196o8e7lFBaKqv5YIMnFQpd0FGVR35RJCnCDaABaXBtgbiSwtICMtalKC+1JQ6bx/PLcDPQL91QFodQNKpwOgF/9eqcBxBBqRcKAAVk+ArQOMx1RYGgB6naDhlK+uQQwJYx4meQbxtNnYQwMjt/d4f3M9ZE4UOld1LAh99fbfzOxiEkKFCkTJIUIMUeVnJ/9sDt8/e1NEJOi9oVHDGYhgnSLss9DX2IAqw1zALUncKcDr0FB5NP+0cBQNrEezDiyiADPkt9qGpwoPdL0AGPx/NOKeyf3b9WJNdfcFv6bKd2cLMJVfJ6Y3B6wB9WFUfWWEwKMfGiQL+3bz9XGQz2EHKhF41GCtZyDi/gUCsNhYoAr3UNJ58YidHKqnMb/6AB5J4N73/4L+t7mAkeeP3P+1LNSB/l0SkMEd8DcEuUlguEw6t2AU/PCE/q++Akw6QFf1u6SBrj1ZnnhG50AfkoGIdf7gJv1KcSfgzWWkQ9U33Z3tHXYASKJ9e/YhU90rvD+q9Ej69/wxYJVs506Eg/r3DkMDzEdDBRGgcZay49XihLA30P+l8N+hf1f57/0AoxbQbwYaan/rBMirE9Dk+sBzTkC8JNDEUlv5McB8PP19Y01Gayep+hC/2zvQ/2HGLAurowsNGlA1cnqGGzeH5weiYLZm7h3QQC4O2tXdhvMMk1ZS5ebpgI8eMrPvPGkwaxayk8Yc6PMOBPEdC1XZ+2UfbfOPtxLMQQAG9BcZFoF0gp/RKjxe7+oAw9T7ZPWhgedodgz0gf5KBtrtIZhQAZpAV1Bi36w6t98qVfH7hqGI318lLCjLCUFlxRHwqYEH9a2qb4XjWvDT7kBwfbZA5P0+PNuRuW1yf4yNQH3zzwv6b70QOJ0G9OT/dhoYRUGT15uQH/71MjQLtQlxfDuiCXrtM+SkA+icQdH6sU/xz7Ze7FlubV4TpoTQ2osdpaEjtqADmEU7OkBEFoLeC3IWFFeswJXKXzkboNL+wzcFHU8hTGKIboO7CLi1/P+5F+gydQhuvRbwEgxvtACmANikhLTbj0gCYk8KdlYgmj+4Ymaod7TwahwadICuX0Cm2fE5iNHPK0x/CDV66Kyg1MnqjNFBnhBoLQCgUULfaVe5nq/6EQWY67bXCszUb+7232fVPz51iGB12owK9peyP1T4raMFF/OEYJP792mgXYfZ04GHMAhBkCSmSj+dKqRPgVFGHbpLEGMiGFeQWfSgrY52VxaeDUPSNJI0P7NoisG729HHl78z6hxfs9rV3m4JjgM/lsui2qmThjCfDFSb+I9vwUqG5wwL55U7C+6ot8B+7N2o6r3q37T9trfpjgmTvv7PSQATLLeRAOZhIJHBQfDQQJPBdUwEbVW3+L08EcEE/9G4ANrCeWcnPKRHDupbNynMx5AA9IRYLmrc/YLSiD5EaEBS/s/TgnU9ILcH19n+CpHwegLejx7Mn/d25fdN+e9U/1vgb7bqf08MOtf8EXxaoh+GY8L6gDfhvs4i6HQ7seYI2sv1GchdMsBIG3xlvxcCRzdgCPTn+6q/TW00VE8Q9FaFv+R2VlOM1vm/hhjhDCdgNflVKME5B47I9xT8z0YgPAJ8myb/LqHy36j/Mwqw9AALxuO1JVjiuQAYLcFzIhiEPe05fk8tRjGw7yWQbsfuLAT2VqOId1osnr0F49VM8INACPHDoBz4B5mqqSnUgyh3ArjXxfQH5BbgUS8gP7aU+w0zHD9GGD0CGHf+P1p/DeivlhU4BbxR9a2kYFR58YaDZCUR2P0DMmgED2eg77puegy6PgDphEB0CwlG/i9d+/Hs34pBEQrBn0W51mqGnJAk3ACCHeiqkQ1XFQA5AlKH7Lk8yJKWY3/nym14h2C3JvxeMwD9ZVMz0BPMi1n1RbKl1cYhIVblF3G0ATsRiCMUvoK9//OgcwYMoe+ZKOLlC6/Xk50br9NFz9fanqA8UIYSpCwlBO4kHc4WLLBfBHVaKwKgLQjmP4Un61Vq+3s7Bsyi0WztmLjJwJwFeE0I2vD/1Q6MVwefxfUf32skCPbCnxQqf+QMPEUDHZ7vGeyj020JgkPXXwsldA7SYR1RE3h94NvNtugswcgxXEkIcBPCGZ1rmrgDC0A4K88nm2fn/eTnpQtWyZfybRoK8Dro4zYDIMGsf7saTBzvX0SMbkAD6o9CYbsfMK38cJKD9l2FJt9/VGs0h5Gib33pxMKWNsigFUh3G2un+/N1WUglI/EEx8fq27vUNnwsiOoKecL7kQS8VnWAGCFUgn6dBtQhv40CmIYggwK0uwDHRGAuBXVdfwzHUjZzATLMAoyJ4FmBhzaWBlrHld9CCWpPHRqofBqMReMGTJ78q9rDes1Tv7/0m0v0AFHXNR6P6g30SHivin7V1BOhh3iWPwvps/yE836L2XiwnUT8x2iHgfqhnwn667QHEE8oLQjEvtEW7GYBZDrDVkwNIO4G5GiBDf9fGoFM6n+vbEtzXwP6u9AduaWnGYSLAlVdl/AU+ikrSeEIKgwdaZ4AACAASURBVKj4/wtgHcHtdO2nWKcBkPfxcvnNQvsj2Me9f02r76T8q0IBn9OLKfz1HX8yVXQYGoAB/2UeBQ5/5kCL6+H/OGGoRnLSwdd3oH8r7KkGTbgIxEwVWvnF8KOpHnyzfF9Jod5Px+IF1h8owyitDw/XEgRb5bPqbt1uvn7qBIQ16vtS/u+DP3cR7CH0WWJgd5mTJKYgNzoGjQrfvu99NDBC+bnyW1x/qhTatv2OaMKgJWPvv5kwnMgxHYGFRtJW8VMl3uP+MgoqSZyWFKr7+KIDw1d6+IiOgZI4+d5iYL3imzbgyO+tph9t2oSBxOM3ugHtPoFZ1LM0hF4kXNEBssvVgPdjdXZWK7uKvyS3q1Xb1WQwtVDqSUggq+Vw3t56JA2cz7PXOwGNW1ecwxPhfe3QEUsDsFaAz8jg0nf+iZMAHNg/XSazDuC18Iq1HBRrOsAQ8NLB+16g614jmuSgs3bROxE55D+WDDQNA4ivdMJ9M1b309UqknaDU8ObV9/PwmMPATvTMAxpABLBzugUtV9bLdhNDQA+7B9tQJ06/7QNDHGSwtgZOCIA47InIoDdROQGtt0U1HI3GaoUnCnC/rzBMQJteN17+VaAzYNA7e+PFqHQUyXPUYB7iQYa5ZFjq1Zqpx8Uqu/XT7+6BWC1Xaj0GlBIwMoHu7UzcI/6/Acb8KIq+hzmGWmAYnADrIpvKP7TZeLaf0LAeQkGgebbq9FToI44p654F47tekKkI0L5PQNZPsDwPBpy/ni+wKMN76Vav4+2cFZFf8+JwAraMt0DFB7beA/u4Zz/a+RXx0M/ct4/jwaNAS8G17eSwmta0Fhx0VRxJkHMivso+onMXr+YwdWKbgioy1jp4x4AzIKg5lEA7wvHEYCRmdx11TAuT6lDLVl4KvXkAET9P4RT8H2u+lg9EPQIpw+/NpJ7RwE8HaDv/Mu4f3OdNkq/EfAiEiOANjEALvcWL9gfFV4NZbgbQc6qPky4Pm35QZxtH1f4j+P/jXuaYPcWwIEH/fmEPBoAO4m4LGxV3txOQqDU+dXgey+UwSzuqP++uImO/u/6ogCb7wTc1n61sL+vZi87rxnrNas+giTg6QLzaUCjIp6JfhwtGI7AjBBB9JjDY4ePYVR6ZPgN4owVv6Q2N5hhVHwNeYrM+w6dN6K1sMHZm/Ce7bHe3dzKr1xw1w4JrSQMZtgnoQHlr18fzunAszD4qurNUg/TDqzx/lfCaO6t4tACMUQ6P6htWjDPC1hCoZ8kpODzJ70MUR9AODcgwyqyPhmE+wfHYB/hvSqt6qeXUShhXH+d9SR8DzrDaZZdpSp/HxqLMQuATgDU/qDPRgOIeT8cvz/h/XC6BtE7ACLOWPE0KIS4UUjmZaJ2grBphiWgT41BUVWZfP3AnEIT6OrfoF122l2rMycBoU5i/OXoUZ4/aglsXwLzHNU++FVF3qikOj5HXm2PBitT1WuvJRAB+6O//W0/PY8vQH5IrAsMs/WuVmAdHBrQgrbOxJShXwRSsu08h8JMBpo0+aDTALwV4tbswgzHrftG/dJKIAQb5h9KCssWIMeto+GYqG12/HWGjx8kzqNJaa0noMWOr2KwW01AMwJoNvhMQda2/RKQP/3ecABM3g9uD6BY68Ntz9+nDOMb5iV+hIE+dP/Zs/wwJhJ9mgBnohBuStABUXjugF3hkXF9ZZJAjefKdHZCc389LoStKvIl7QIEb1d9RyciQgFDI9Cjyccc/23Aam7/PZJBhgDgin5CtQvbCzX8ip9YgIFtOAt+w0owp/hOiCWgEGbVHuYjRigPGR/YOnEoqPDoV5z5YqB3mRq2ox5ICmSSgAP1Ne+XV2NE+/vuFbCTRADxtS70VRBCjgBk2OyDUQiUgfl77b7DwaHm2rAZ7osRSOOUoHgKfNBSLI767+oDYrfwZvqChSpGfj3pFwZFsCJg2jeIQQBUiyI4WgD68ww4qO8khuWkkIuDrxWv2nv+UTBpJYiPd0KemTA8qqFiuUF1jWS3BoG6pADJq751JqBI0wvAVPyMQvjcX1zbELltKK+zBiXRFiRxG+b7q3M9xuLdzR8g0gCGNzSM5gNYfqGO9CBT8OHct6oB3KsSDBisUnwsFuISQaRHxDSv0vptt2oeLHMERfRn/FG/Cx01EpgIQG8LP+/i37PKw53xn6sYCM4/JwSRrCnIeB1ZkLsawDhaPKv/njU3wnZ/dBdGE8+YTHSG8+ofGgIjsC19YnwdM/KAnTSsqj6ig7uGgIPw3nYFzhhIIvriAxFP9CQd4HSlnzgxONIdrE7A8ZDPx9fjib8ifgegNIliRgdx95+E1T7+3nQVNNhEzDgGA3T2rEDLduwtPpuuouPcs8swwXFjdTaMKt+jA5gUAQPcf95KJQxYU0cYxEDvsBSmYuukp7AwnqniC9Afa5z8vboI68ImT0t26CvwBzSggkj447r9IojvCn7U92J/Hw0QSdwZKNNjxPCfSxRqnATkdwpOwh88oc4J8KTSm/wdbZjrc+4iFP8YO0/5JJDCfaijK5xVXevqfg6zGRrQf83chvX4aRfAE//6vv5+6490U4ADdO7QgM/5bcHP/n4OtCQhBEFeDWSvos8DPq8/IwzLzjpa8/U6MMSkBklDm8e0mn3QIY7XG1Om8wzN48y7HwhOK3P0/ZwUQHHv4psbdoVeb9VlAjChBCdtDDpOKTh9ZfcagOYq31RFjN4/gwBYzp8lAwYNwBELhZoxECeZxMlAzWGdCRV0fQWGHo8+8Kx+AAxnCIzowAxy9KvNepWfsfp4RR9kUrD88CPVTuXRybhqqTHcnxEGndsgub1Gdug8yz9fHt3Hpl57x/mfCOC29FOSQ7/noAZR5W3Ob24UMpuPYAYiQrQgk1gnFoUIKr4vKFpV15pHUJO3Y5rfH3UFHU4bGkU+NKJ9f2hJyOMxDBDpjAgwiYqvk5TqNl9EH2Arb6fA3yaA4cBtPWewhkEcIQJBlGzYp6zRmr1v+e3Fv27xpzvyI44NGDkCIi7CGNV9Dw0M8NtHC2vUwHINumCGNG8erxOwtQINsW88Tlwdoc+F85nI559ngEDpt2F/Uu3hiXYrkN/pBFS26hYDAkFgErMK67y9mGBA3L5ore5izf8b3n805MOq/t7XU4WHv1DUF/5gugCSOAIW/59uMwl6CHWAib8bvfxWl9/rBGEMTTwDfG+ezEYG4yk6FvRPuPwE+wvc39IRjENWM+/cm5b0W4Pf4WuKUnw/vD6eDbB1ETs5vl77Dhnm/51g6wPWwQAqxnivgQaeS3gy/u/1H4hpTPrIgHAN0mSgXUX13YP5PMIuQAfBr/f70cdeE+QoCX3i8nFMLcAjInBoAIYqt1LhC1WdtvmSab28AYffaeivCB+ohdYQgfUa/WS4ToMsNLHLc9nnvPZLwn1/EefPVf+U/xvnCVSEQEkEQEnEQJO7S7RvYDxNeNYKrG7DKMhtsQ8cMmhgPKKKj+F7CiHYFR5KIIPxOmg5IVAtu3ACQSPh7CzUQOgAej5CWEkIe3vgxz0ROGO//qYfz/dnLT+ZxDr4QW0eNCJBorCFOVC312Ec2TiY5Bk0cAaQmiA1VH1MOwDHQ0kHdEDDf+2UTWhS4Z8diQMicLx8MLBfverLcP/jQzF0P8EJj5+NGK9RCz755S6F/f1+X/gxeP+Wsedv+vF8/54aSPJYFjIQd624MDz/UDLQnr8HU3ztKHRf8Qeno1vyAQJBaLcMtTV3cvgP56COCqd/QP9xLgBkH4BxO13n4hNUDtACC6G1S3zqooZ6Ba4lp/zcAFb7iERKQwQcF39IFJjdXECGADw0IE4gg674pYAnk4HoHPx54tD5daO5vxrugSkMjgiiqc7TVKAT6AT8R4ckbHEQCYR/IZBxJgA+XZjsR7vaoRpIxWqeqfXuGC2CxwudicwePEB1kNkaZCuwyF0DuKv/4sz9mzP/Qxdg3BDkBTMC8Q+loD6UGBzx0Kz6eAX/KArOQTlPHFoI4vVtf4rNuLrca9edRn4xBP7k8w+9AgZCgBfEUZWfEs8iFNZ3UO7TqmkjCO/rWdgco/yIqHcQWaC2EGTzgz5y/iXQAvyx3riyxxV/JeBriaGB9OrTA5g9/eokM+37GszqfA/UZk9iW5UnCtBqBl3XoNN6Ag/+zy6A5evPAp+TIFDn15gQw9rjrOzFX0s2JBVAxa/nP1a6AsNWYGjPNGPLTQgBsNUFvOA3Ht9o/rGDN0tWOCcxJGp+f7++kkP7PxcGv1+GjkaLt/fawpwwerQxBJNW4b+PJsYEgiAYYdEAGIlDNaAbRkIgK3ut0jKByp+8yz23X6GttmBmjwDvChgiYLP5V/zhH6/110sGcKo5CkggCngxnIPoPja0j2B+1BRkiYJiviaLJqghDI63G2nAgAxMCuDdnoD0wIQm+urMB3VuAwbBrFGgGgnhAFqg9+ujKsLxB3qGCQNEEtPinIQlAj4WgIw7/iXc9V/x/yUWFs2KH504bAh4aYWf4TrTLGTy9YbftyLeVOWNfYNyt/ji29mQnqMAltU3ioTtbX343yv/1u0YPUBz6zB702tQucnX0gWaFh6DgPdmhXaapGotw0SFz1qDiTMdd8h45HfcqCPRUhA3+NmKz1l9teCPaMd4urGaewRitNBDdahR5c3AfQmDCFT9vmtQEwqAYXX4XI2n23Z9B/Yb1FL+LWox6wHGbZSo6FR1LzyG+3hriSZvWT6jfXhl2cmQZJDrAbuYAqAHo1GA/EOgD8eGcU7A8eDvH4fQBuAhBL/Zp/vamPTrRENDGLTV/7E1WEPLDlP/PwzU4YhusIMUgfIPAr6Dhv5R4y2r8ldFwiFoYHnmr8TAHbhRQSZOctH598ZYhqt6wP7q/ouqe77RJxvzFYaji/z4vna4v5cUMDXqDAJ5ytktqtBDckyjvJg04hl16LB0xFfyMfD77PZjErGQRRjYIfSvoAXntks0ok8MsUC4KARWnYPlJBeIgLeFrUgDOHYCag0/XNAbWgRwQuLAsaQwIhC1g7+jCNKuT38JfnYSyTi+QQEwwHeT4/dWHYxJPxfOj5oAnRQqgU3YgGZSOaDyK3n/qkDYBKptzR3oD6B4fyRKjp2AzSl80YR/3P+/1vBjX18Jbu+YsrMRgbqPP8zrDLTAaupphfeZtyPs9BPztpLSBZjowF3woYRwBwOWaqbev15b7X4RWsiqYiY6ZkFEIoUwUA2OrkeEQE8HYNyD/rl3m88jCGgO/nPW3xy8x4Q/HBcM1dYg5q8N+B/SBSYhtD0EY1PRGLDoKIBHF3yLz4H/gSYQJRETgqeB2d4vC8L2NVnQn4PoVJJAcP0inahAfdXVI8CFszjRagCTtRdV7Sr895NBpRKXIT64RMFw/iw5eChhEvmmyUIH+k+Qu3cLzOAN6ILlFvgWnx3YWFDz0f38ze9GlfP6UQ3ojEY0gtqRIEbA5/WgQFhsEuIeL75uTzvqHktAWfj/OD6sQXssROcGiRgFn0QVkld7OznMDT7CJKzhMIqxW9B+LCOQdH4uyxIcE49VTSeLj0wKjzcp2oDXQA8YoDEGBLMW0BJw+eAxXejPV/IXd59/tp5rVyYXDw5BlRetSpQAcvgfOwVM8ObzBq/AQ2wX4lwkQV3vNhYFfn2LFgaoDU1ogqsfqGkJYmrj9Tr22KQwBLzbLuzDeA9yzyJjVRfwegWq0H+FThDPA6ZhZwX2M2Kh4waovCzAWJTzD/qY00c+6PM8coz08VNqglzx54LfHuTJK7z2rwX35ABLg1DzsZ7Qv7l/f2yXDlbf4C/irg0MJ0aCuD0wP74MrxfdFlX7tq+vtRdCpvt599EG9Yz3V+P+Oj/n4zLruZHcJ7oMt/MNp9eD6HEeFb6/TMfbWo85Pb79HJo8t3371/PuIAZqMvjPC34nVV6ZB4hEuA7AzA5cfU0y2n6ux89D/35/n2/vWY5Bf0qwf3tPLISO1Tap9qzFB6eap/beqI94NCCbGwgqOItY3CGl446CaQ8i2Q9g0AvmgJOnBoAA0gu17tsKtKS7D4udgCYERy2QIceCX/P7mBW+g/7D9S6Mn50CS0eAoQPDcBjopIA5+EcxEjLweRjXq0UbLIjcBxsGx2IZvlf0ATjz/6qypAmY7bhrk4ahsIis6ccXKHdueAfUgk+RWPCLh42c6zEeKyJpRTdRAOqBbl/Wq/uT+q+Fx3FoTIuCzc6+hN8j4veGjuAnhSE5gKnco3A3XwYlq2sq+lmP4yEOpqEoG0M+mGDYuYT0pKCFHgLHKt3T7T9p8GcWH+n1UwGa8X6kQt2x4CeqPexegT6o/Z4Cr313PHdgrsS2ZReLfpKIf+IMFnmVmwxQ9AhithYT73+p2s+JIVfrjwiHnpAZrSsr9CMstQXP1+1+510N/q8E/YoekMN9OMFvi5LvkRDsy9rgFCOoPdpgaQIWBZjf5KCSQszZJ1ivTvLokpen6tsJAVND0NFqb6GUGg2Im4Dyx9Pn7/0dm4pADAslJzTv+dKNrAPQ0wyySm7bj1RQgbAXsRa4R+mBJzpaQmHLmy0BLoL+Nh2ZRca8uUc6P37k97n451fvTieAE8BdZ2ItqFEK6oOJIYPsiU4woo140Oh+H/UC++gatHYcOFT+2y3AYvD1rM/fpxdUcsAi70c0OxAEP45X/hymE9XeoC0zfYhbcqfbhs09HpwnKMDR6g0mmYyKth/UcLl9ITGQ8N1S6s+gA1HvQCc2pluPvN2Br8SyZyfyxPP/VhCi1L1HWX2CQCuAE8TIq/sBYdANZmTIwqq0sb0HIzhhugBeUpBZLFyA8y+EErsBUYDZHYN9QAAooQwOws+uQlhdESSSqk5Qsh8LSYI6LDS1AbmOvLlRBqQIeITvM36+TP63VfE5hFClCTr9zEyVFwS3STQBy66DMHB+PJWIrfgGnYBx2dTboPa2X49GaBVlePA7CFx4iaGi4ns0aLVjMGvtPTDtmO4XEE8E5Kb/8qYai+NHl60LgAICcUCoJPVeiYG6Pxw/X9VFNVbFn9FNPzXoIRDTyzcpREYB5Fm1EQQn3KRi9wKApR8Tz48SwxnV3qM0q7ZhpdKvr0zfY+gO4oQf+EGPFYW/Xf5hwWsUgxiBbShGoGIx+D2eH1h2EeR3UQMH4zMaUKr4033nzkSkfQADelFbLOQCalxdxvN8mInhPas9bxtGJw29Fx3Y8429MAS0fL33Oeo7qFZeiToCC3B/VSNYuU0fgDnkhxGgMFdxiYEY7MYel+OHPH30IMeVFK1C79l+QdXVpFqHlMAXEf3EYDyfkkGdNvJ8f3RAXU0jpgM7jMNA5yCrtfzOicKG/M9bgEkEjqqPPDEcDfqVwGZv6zcO9avDfOhf4OmLFd9OLBHHdxp51HvOBlnAoQksYjASA1xnIhPsapTCPjbsGB2YevpPpgM73EYeSYIftgPgte6CWesVBB9QEgfnWYMgoeC8ql69bWoRIqYHvSIv/u26bj/jdqZ9KSGk74JRo6QS9PuTiSHm6Z62kLUGH0UO4rwWrhtRETkR4iKRdI8giJ2D2nUCMjsA0TXiVDb98NAf/rCMlajA9wesWHZrAe1dlwRyVI2jx4KkyUHSx7YDe6YD4tOC6XW01puEdAJwaEJzf1uATHi6ZlSCpBQscsh6C1xRcWEG4bCFeKcAVhVlDu54JQIkTT21hptIT/Afk0kMcS9BKfjBJozcDXCrtgbWXxbMAw3INQIxtQJPAGwXmYaBbYh4SCsuKwLOAQ5awKskCMmRg8P3xwlBfbosQaDqyZqBkyQe1CLQACoTgN4qbyHsPwkTiF2pYaj6MAXBmUosQHnUEYCsBL3MW39SNKMJ5PfoBsT33DVJCEbFnBCMOkHfvj6Xq8uw+dgRIhGgAiUqf5QgKDFyhe8nnYrlqn9sG1GoAfirubygX4H+8IM1CmQrMFAJ5ExzKIp54nPoVU2Auh6eBShDlTV4u5c4HE/fVvjFrsII0Ik6QX+Iq68jB19ziLoKC27FYe0gC+j1RSS+BgB7AvAM3m8HLdy5fV60C8RMVuhD1ieQB32MCCq0QPJuvuw5IHF/geMKwOPdpmsxBwVEfGEOgeincJqNmuSFIPhPq/xM81CWIIi+gCFBqDX3QPYd2OcCRo6GZBoA3AM+00aesAOQ7/2Pe/vBCXoguD4OBD1WfPwClzcui12AuH+gC0gEwW72KfjBCQRBr05D0IQc7N8PzOCMehPWK384MPVDJQim7yDdoiRTItzzFV/ZOX9sYFetP0fsQzb6O7wOoFjxk89YoQXv+BmSN+yYHYO+BsDRAXHhuJXsEFbdIEGZQWUkNVNzGA9NZUVBIQL7jASR0AclE4Pb7JN3BO72mG92+o8UG3nybj+mASh0FsLKn9GPxDrEcS2Au35BzHO1BksriIJdpqWjKR1wlpR4fN977rZqI+XbYjYDgVDpcYQalOYKMiuQbB3G6Pu/HlMbi9a0EMkksXtjvvXTfgMKAEZRN/i/O7yD8Da2S2Bdh3ICWfp8yuMkYl5a4df4vVWt4UF0yyqEnaT6swYyWB8/j111Y1ERS9oB0SLMtBGDEBD1PEHwtdjUEAHnqmoHU4wCDAoAS+lHwtu9eQLUAgmxVvAuMB9cELMV3m8EUtcBYYI9nkNIEEJYrQeUHfnzzRyC39j8CgSkir/E0P2odnAmAqDnDIhqrtV9BDNS2POjv/0pwKr6z1h/PMz3uf9ykFYq9TtoAXSwpz0HljdvBCVAPY6t7osv6gFhMpkX13rcfXQMIpuTsfTibkfOPRAC2meLRipI4mDPwMD5x+v3+Ey+qEfACwoUEkKQSMZxYJDz9R68PyP43yvo2aYf881rNQbZgRU/jp80QnW/hdXqJxMvCFxXQSNHpE8QiF4XI+wFfQcw7VL2Md7RRajsKgh2D+6SLAKPF356+/7yXYBTUgFy/38StUjFHweD+iiHh8/LV/i/TSvGk4L5x7F6AsIKbgb4C0YjgdGRIToGUx7cgS3JKP8pRcgak95BJGQbjaJdBYQ1qHYnYHL8F45QgHx2gLMQ2cDxBD/4SeR0LSDi5XzPQNjM4ySE/HGG6g+ugltLNSARn281BPtNO72eJLjdX4ITSEgpQvJYFEUg24f1qAYQNQdxx6Q/RcB85j9f+03zf2QV33IDPHegNgPABTfqFR8cZK9TA7/ll0EQbUUHW8Gr1d+MSadia+LRHwhunv87yWoJ3h/pRDwJAbDNQQFd2P2mH4kP/wDT/ZeN3CK3+ZjvgVpw4r20AMafb58j4N1UMknuj6iCx883PU9g2VHVH5JX2eEcPghSgRBCKPzK0Q3fknwPN0Hk0CyC0zBkz//7duEetgFjVtypASDI4CsknYJgYDhqsBxxy29+eyxrAZX75EEf8f+CkOcijMDDHx4ASYGGu8WHgPwpHJc0qOG8FgFTuVk0cRZVePFwHEIUEu8xSHoL5qWg4I7/HgOKXe2dcnu2SSdCGIDTA+AcxY1zYL6Q6AAFu+/1GvjKPSeEoJV3NiM4Dz9C6oWkEav+NWjPWXNOIkKgNTi2I8LeBgaZHJxqrC4oNXoB9pzzMws/OW3ghSyQJgjbygOVEDhoj4nHLld8HPD6UUMFVLIgKrTL7cFoBRLQgEdXIseZ2/HhFPKbk4d5tYWwwR0nIFQSD2P5gQhs6meVfB+Bkyz2fOIvX/zxqsSODuAGIOLtPNnmIPCrv6Kqvgz3q4tCwNl9lWYfnsdHj2HTgQw5IBHwULmfSu1jEV3gDFSxTBmqSEVqiYK2IkWcRiAkwV/cyW9YhqHXDw9dkNQAcO6HFNJT7oChfrPUYc3KY17zAd+evAwF2w5SCKLV4EuCEKsKfjBVWHu9Q9Arh4CoBqEMWYBsNX7YgKP/69uC3M7/mOOz232QT+ox4iCyJGEFP4oBHd+GVvXBwX35nqp7qeIbV6L6tdZub3ueJ+gBIKgC6S5gOQFxDoGr+Bv2nzqbknd7ph/EmXzO0o+kZdc/wqvQkAOUffVMzKtYgx5Vob1/+HAfCdzHSiXHenX35/2JTr3KZ9Ruj2lYiMhLIFoNyMq9hFroeYMTE0bSLbhb4l3YlFPa6hMd2jk8dmrDgdQCnC4/+ANFlYTB6ATlx2GDGXP1rvL+SnWHw+cJes5/rRWt4H2pw9GklD4uSMpwasIQiaYR92gIyFX5S8dtRZt/nCAH48VXW3hRE/HKOsGquj8EM85Q9cfeAV4XwNGAlmIFIwPYrfLKuxV476RRetzcdeAsRSZhiHizCKEIOHn3EMOWy5X4uIJnXX6sFiBFLaBm/THOQAkVJK9j6TKwiSDTBWpwHkSPQJX7U959uAkoaTUuug6oQCBz1Zlxm0OJSIoIw04M+7zCGuYiznCfHww9AN6Ir+HXA7lfn2oBSJ2FOOh8SzINfmcAyITq8JX/sOMPx6A9LeYtVfwgCBZhdu25OB9/XmWWNPUEPD5dUuJ68wd1AqD2+w1PI9KxE9BW5t3z/igdYGWiL7L+wPv9jgVY8f0ZcbCKCuLAHN+c5wa69Zpr0J9t2KnpAGzyiAIPiFalJ8/xXrrA6Y+/8NoDnWCPNwFJzf5DpVkHte8hx76P+HU1+HEytEeSEIzAsu5r6wPJGu6oLz8VrKofXLce+ywIHhNa/Dmw8LrptWXZ4NKZm4pr/QQ7Qk8ehMrPtAF7PQCD309QgRgRZMKgAbFREAfBBXNalbHA9cEHMo4IgIUuPjjBWEUFEQpYTkhVO43eRiynJw9Jjj8TOUIlJExK+0wA4gWgQvcFBHAc7P4/u78/Ff4CC5ATB3P3oUwFClYgcALcxzp/B9Ez4DUV8RjBbsCBrMH4dLNwIDaCGhA6o3pXksdBvYBsktrXDgNJKAFy1Z+ZGIy5NXgXoBT8a3ZgVSPIUAMV6DjLxhsV8wX4n4ibbONObHNyCr8Z4FinNFjg8ziiF5zSV8A99u7Zdf5OisvVaAAAG3VJREFU/kIPAJLWX3hUIFD6o7MD4WkHIMXBk4IftSrPNBJVk0OoC7ice8HGS8XBKDoz/YFBLaQi392lGpCMJfhD9xVkx5Xbj73P9V4m1j0v73x9FjDDPlYvATkgFAVWcdNvJBamliOjAwRV0EpeRymAe717kMYRyy/j5FwFBX0fP7Dyx8gq8wn2ZXi8GfGYR+lFcGJSxa3Y84WgzBHetlU4cvKY44Ps4iP9fsgsPGEhQTAcHqwwGCj61SoPexKwasXFqtxq8qhD9SixoBBYcJEDNzmIoi3J7QkoJActVHocTVpPBCDhElAvMDK1PT/Sq3DwB/ygmyB9GNhYDH4so4Foy48kkPtZfZEv1PQTxYpyX0EI3Bu+/5krcN8fgwVdwWu2JNVNWAk+PcOOPMNdGFyAZ5Aj6gicgzNfwuHZg0HrLxBWfjSRl88fVCo/apX/IBrIvf65ZxtEoK9Bec4KZIPLe76osQns46NwW0pUPCPAyMc4A/KXOwZzFLGbAqD5xhhbgBcWfoJBAlarcCSQgdQJ+Movnih4gjZQTw51rz588y/ZgxVUEAQ8soCfX8OR26JwujCLGFAMsOjnwGrlPuQw9D/PPv8BYVR7pG/eeFtQpsLzR2KFI8SwKj9KlX++HeLOPuSBKrKeHBi7L4b+Kx184+ptAp4Trcscv69oARVYzWgaK01H1X0K3zNSmARKtxXYHvwJuT+8gLGGWgpHcWOmBeljFB2Ckg6wiAYOqfxEK3GMCAj6kIiTWdCBCXhkjUKMgJcLk271N9uLSbtvvK0S69OXAvoA5z94VsFubbmZvx4QAnXgBnJxENyQjy38wef81uPhxMpPJIQzr5ckuUTKe0wZyN57iFTWga8GvCwlh5UqvYgmaNV9XSxEVWs40kkosFwA70RgNOu8mLZfR6wDiwRa35y7j08NksqPQhcfkRBK/J8R75Iz+9C8gJpqzwiIeZII3QnYOkJWbVEI5jNuA+o2BwK82ifwnpSgHwaC+GNAdmW2VXfC+vPu6wR6lBj84C9WfvivZyUhZMJlJhjSukDlFJ3g4AvGJfC1iEpQJ/CaEd7G9wds7p71+odruKrHip/C7RdsxeVjzIxhoNkFGOW/+sk/YVAGtltfzZAIfzix8gcHhZCXpcGN2u69qWqD9OlRFAy7x2fQBhHUiETB+DocqvArYt98f+AEAXApsEmEcNLC0t2uPHCqPQIXwHYDfI4/9+8LMpchqr5HK39MJSrBXwnutNqjovjHFdq+fcHLp7YLR4mGgduW5hFpAXUoL4cTTuW5HJSkB5PC0S7A+8c+837DyoM1J9iv/po/o3BunlDqPjOSO/YbLFd+FGy9sxKFeT8b+nLNPrkAyD53FtT27yUS32yqUaEGTMBiASGcZ0FmK8nWxbvjC1q6WQC4VdWdAcBY8eFoAzIrC0b7Wt8wlPcIdE1FhUWeKU1Igv8Q/0dl4k/NnYSxdlDon8diUDeuQB4c8XVzcahRgyyZmNC+LAgeCfSVALde8/t1DCYawNoePGT83wlOpFUdOZKwxn89OsMEf0X8CxJCBN/dwKbFwkSMgx0ACJJDJD4iC1JEYh6XcEqVHpx4+J4I4UiAl26r5x64sttvSlAn3LBuQCz6edU8C+J5epBrC4YP52EFDgHrCw1B0eU9bOaTgh3wmYvQV3Oqqcf53XnVNXUBELX1xtSgFrirlII5d3HFulxBCNEfZx0h7K2f34XwdHpuYQcguN189Ow/nPXclaUcqMH5leCXjKOjbv3F0a7i2ZaRHmBe5zwnhA9S736ZC8AH8LHkg/T5znYgmES1dtuzGo92qwHIquiWX+4KgVLd8utv9Ml1BQNhEJW/FOgweiTguCUoQHkEwYhjfQIgm8eAzPKzHqAG5xGiiPyxeGRRaYetUpDVpHVC1T9bHGyaknb/TQTnuG7rDYwYCUT7/cMjtILzA+Go/FPw581F/mWeTkDuBsBCAK8ki+A29nMzPn4Rzjv6QV7xWW4fzQFUxb9jQQ1qc28kMi4mDl1NBr4usIsz5ltZqNm7AeJXfuTHd7nioLEyPBISU+8/tP1AC4Il/n+YGmjg2NiBRdl6yCw//zG5ph7bqaBuz8B4VMU/TqSsNPbwCeZA1cdxyG9SgKzRZPL+GXFOiH1/SFZ9wX8M3zUgvH8a4rMBjZj/h1W9MrwTiN6MlsCKiI4gycBzgV/xUaQGjGDHwHiYi0VIzeEAasCpNuL76AC7BIEl7i4AIxnAfoMxk35eJbZ68wWEUChs8IPz/EEE9BkUoNA4RCWSLJkY1h0Y/dG9bVCtUVPe7QRhtStXG4nOECDfUxc4Uw/Ik8JkA9o9+a83IrfHH11EdFUWc4phNgVFWkPsIHBnCvCCYBSgqEN9qtoXuwHhByYoJJA7BxIkkRwpDGgAHo+vQ3ZGOwCFJCJKUAx4MBpFZWvReeLgtBBkDDQu2OJxXa7SE/P4ZiUPHABjY1DsFIhPAaygWewiXK72hHjow/k8gCL6gKES8qcDZ7A+EhYlWCPGCX1wXIwzkQEKt8cP6iqkC0FEhFj/ZYtvXCtwuBLcDT5wXN+9H6ZEIkTwV/x/s78fXFX3siWHEKrC3tw7EFZ31Ll7ttknQyEMGgAqCaVe1bGk8r8nFWCQQR0h7CY0dsU/mIeIuA1AGCo02Q0YVXxub36sG1Qgfo0CBBUXxap+ECFEycQVyViBEBFPt14TK9rZHB9EwMG7DPXOv0OVHkdtx7OSCXfb3av4CFZGTwQBwT7/hKPHE4PzpJ4L4+FM9r1n8B+B+9R9I4Fu9brYUZgCunZWNxdQgIs8mASBQ4F8hJpEiaf4GPihk8FdAxin/kybjZjTj+mAQy6ihZ9whDvHAWB6BKrBXQr+5SBfqPaINwiz12UIwoTmbPACZY/fshBBBKNlW8ZCHwH/cVKSOZMm4Mxk4OwE9JeB+EFkn1IzcPQoiSB4vGgNeJSoik1A7m0TCmE/HrggB+/1M12C1Z18ACGoIeH1pH2IhAqFWgBq+kDFEWAvA3X8tpW0cnSD5WAOriOHhnYraF1eLTkS8P/QsHUBdtMPnOrMaANJE9AZiaKWII5Ue/8PTHn/UcCSTgIF2xN4zdmAQYIAKeBFl6FiO0aKfq5jcImHfPwTxcEdRmD3LcFoAva1Hdjm9UgGggI9YOoPkOBYLsT8HlG3nucMDGkOOJ8CkNOELdSO7D5qqAeJYBb2GpABgRi2gxLITgrOQ9C937HgB+0i7MeRx3gfPWCXLtgbLJAu/gCFBPzRX8eADJqCvA3FViC/BlOQC4LZyrBq8BdQAOUKoKjqR7v7EFfVFMojPgEoSlJesNIePyLHwW9NRgq7E6HvUN8A0yj0wyWDHRZ3J2A1jHdMyu3hCGwSDwdRir7h9VP7AKLgPoMCgKziOFLtrUm8aIFHlgxYfz8WBYUU55iAXauo+evJaIK/NTgRJM9sUcZRzcCnMdNKMJc7usnAyrpxHYkTRHK+n1HxS01LheAHqRWwKIDqLvQC0+PupHZgBawfVGsiniTVHwZHRqbUI/D4Cd+ftgyLAR1ehkIiqaKFw7MJEwUIuK5zsu4svoFYCFKgBJZACBuppOId2RDkPZas8H9kULcA9a0KTCQDGtpnzT+RMJiOGseHl4BQ1C29AWUXIIf/OIwwqoNEK3SCuA7FRiBrE9B4/PcrGJ1OQNj83F4Xbol/TgVHfMiIZLAdcaVkgh8sLrd+liNQH/FqsNTfj15m1J0X+ffZuq/gTY7QnvIfJz6UzBJLs83ItQpt3RfZz5iuGfNPajpngUm0R8DoA5jDlzsOTAwZjzsC3Jjxg7H914PjlcskGdghgx9HG4OOQH34uwQyzz61/0qiYNQjXxECuWYbGM/DrjtPH/Mw/K+gBLLSA+cEfPr4MroArzcDuybbr8Zc72i2UnzeHnTgzD4Ug78SzIvCoARVOQxaFFR3TzWnkkHUVFShEuqKxZnKz4p4YYcf8ZhYhuu8wFgSHcuuwCJagI4bgchJQK/qe9c/RT6nGcg6KGREJpb+MI0EY/b0jcsni3AJBeCQNsBOFVYoApcM2Aom4VFgIRdHpeIG8D3YaxBD+qCiQ+rBOSVnci8hzkAG1t/pgHA4uwDzmu8xFKkkkIqCfkIRs204r/hiDgutoAAcowBMZ9+KS0CcXVBOHCvJw2jMQSJyeoeExF2DuTuRcuWAo9sefyUQ6/oBaIjPtiRH1KvQKvygAHb171d+vc4GRMDPoxN/kL5pwlVh1mBQ1quQJAJ5j0TgOAis+h8d3mnC8xTKE34+8sDNjyVXE6nFMN+H39TQDmocHScENvN74LoGScGU4f7g6IG3n3C3qnG6JBS+Z5tHOOzRYQx+u7MZmAl0OSsRLAS/VIKfRAWU92+12aaVPksGDBWQuCMvgNy2M2Mt8EwqbjosZAec5xLEAmXmcFTHiOWARWglpNpjdEtBQRxJJU5VL5/7F1X86XntXgUK4q+KggsUoIIK8oA+kgy4+zLaACqQGTVOX6MBWdehL6BxHn+tlyBMDGAqufd7WOX5WTJwKYDfXJJP2GXDPk7Tj5Ed7BOG7DMFaBRAJgI/+H2Ngeb2SKb0zkoGlQBHkefDr7xMA5HZeJPtKIzyApI9gmnPgf1c3mulfhe0gFekDCdNFnrOwi4Gs6eTACNjB+Uegcgojog4V25P8bctRYY6RL8AJklE9ACFAGZdBEahd4d4CmghFhbzcwaXYH5qTlS6DY+KfNH5Avzjo2JJ0poDkSCMxLn73H/eB+ifvgvyIFCWAji7BWC8hd0qj0FziMdrS70BlVbgamIgcmotGZDNPwm0L9l5iHv7WRoAFx57ScFS2r2iwot8oKu8l+TOCOg2mZ2nFdjTgOFQENzKkJ8OjEnsE8f6AzyXwT6MNF3RDRnuj0Lwo6wTlBMDIyqaz6G+RiLJMg/KUrQV/rh9uH0tWduwoxmky0kSMQ+rnXxZsGadgnxfgk1pCnsIsGYltvfdzTOBIclIsN8MLAGcz5gBwj94AE8DuC9Molip/JGwB57nRyJiyD3pyk6q5ij+3TzRLohcqyqCEQBTepF15+WVmW8SEr5jMUUkx3oMIsrH3ndwAQganKzyMpOJNxMQooGBYwcByw7axIhgPRGEr6GSGJhkAELoQ1YRg+dPeD5IIRDIqq5PA2Jh0Rq0YcS8XBi0ghGRFpCtWTdum5+yLOsQf2EuYY8AfnbQZDgCjHxBSKwTGpt8QCIDVH3/4H5OwEvldhliINwAFLsEyyIfGKV+vm3eEehVqKTdNxtDiPoLHCRiuwTJxCECxMDqDjTvZ63KaPKvRgV2i/F3ohm88V8LN8hgJcXD5pVGIPPNn9EBqSQC0I4AMxBUcQNCkarkFgSn/oCs9GCVep4eUG5BRAOcQOCWlGSc3If0IFqRfURQGRrKewPKEJ9sLnIowKCcw+f48N6UHjqYtgInaCCkBbPSj8VEkCr2g8U43wY1xX/BNkwreQrzg+oaJghOCGTU8RBxuIp6VFOGoEXgEsBLIgV6gBgxoLSI5CgiYNT+GBHsU01GthrceiMUtv9KgAYktgVNeGrBbtiOQVi9x8WjiAW7UNUnm4Vet7WtsFgDCDYEwQ/EVL1PnQf/xCDLTowTh4c4HPRDoQaiwhKIAae4B7xgCBydI/CDPOrevK0FR4p6w3VfoXgQiB3T1N8Y1PCD0X19JqcHGfzB5WkQE4p/kdeXBcEVUXEIFqSij82lMyrWq/7c+LFHA7z5/dwOHHg8s/Y8C2CmhbmALtare+4UWLfb25BmXABKABTniC8gRAP2yvDAiUAsElnrxFzITQa/sAFecAOY7zPV/8jMQHSbWAiUPGkQNABhw85xrSCv+mMSzFR8+7mjw01A8f4F8S/td4jnDHYxpT8/OEyV3gz2+GTfdAeAszswfJNGlQhEIjB0Bls0BKn4Iw7WKu9f1gmSagmvqleEwJwnZwjO7npz1HdCJ1hS/mlBcRXyF3i/M7NxqJFoeH27z7nnJaBmpUZKHsTbGUc1ALEoIGsGYl9ixS50gjAT/VhB8IzvGTrBVfWEz1MzAkRFTtecW731VdjNQPukVdhdn0Y8d/a7WYH6i/TBPBzUFwAlHwtGHOQISrgb1AMUgDETTA3+THAdeRJhg59V/Ektofa9I8wxVICkC7QQSAd2O3cftzPzdMK6aA4iZI4ILfYRbb9RgqICt2AxVnYZ4kkBvHOBxT/zN9ybHx/f5Ql2fkGCX6ANm6F8WCfqAS+Eq5AGcHJd2IFHagTMHAAj+mWBnDXuc81CjhsAi5dL2K8QCYI1aJ/PJtSSxEFXASv7C2I3ZB9/a0j/7nDn/j1pHsz9Jr8fNpxPBUAUUYD4wz5GBlmyAiORjtAIGDFwzSUwqiNZ1d1tPiB7/Q9VeI9KeJU16/knkEeQJEALjY4rkp74fCZiMDSA/PgvT/aT2gYgp5E/P29AKBQAo6TRth5T4VesQFb0i4K7RA2MZpgyFXCEQHCOixuYMPgy2L7+45ezSSKt2oUkURlpXkEMOLSiXPuDQZjk63N5bmzOSxQdLHX7AhwUEA0BAeQPJIQzkAuFlOK/GtyLdiGDKEBdllQ7YouxV2Xdwza9So4Kp5Z0yAgUhTlJgFzSFrznIHYIwKcCu2/L3LsCg6UI1b1/CA+ApIV5/32HqOIjdQusE4azip5Wc1b0q/QGIAlaWEJbXP3r/L+AEipw/+BtkQVY9fIM2i/ZhgVEgJO6DZ1ksVtlYdoQAPhVO0oKmYBmnAYco4DRCRB3TwCziptaE0auER9/VzRqKNOEYINOQg2m1l9GpGNQAhh1v6UmxNQh2M4+LmlUzll0OTjYQOaGlZAEMCrdhmBphaMBwBADrSQQc3//He8KgFETT7p6BHnjj2X9EXsDjrgBS6ihoAmcSQVYmE4JgYWFpp1waAQRoqDzxDhU+HxSnZHz/9JEY6Y5MJA+cwoWrt99+U3Mc/9g/NQTFaigAEtwB1yBzwzucZSX7RZEILhR1d5GDCsBLVUdIQvsldZfEJt5i/MHx2hGJZFkVVyK242iFeh58oBUFqIQbkfp2DV2X0CkAYgv1sU+P+I/HmBu8nErugdRnUWhfp+A/ddlbEH3uQlBsNobUEMHasK1HOYn8BEEvCUaiuigXRIKj+sGOPA4KAWz9/s7WxcgB4+a6/fI2osEwv4yOENAiPf+wQhbc/5f0gGisWuQaRFmGoIqguARWsBQgTTocDLMT5OJUQnhqdCEig+/EShKSEgTVV0MBMnz04BcshPnLk/+OaV0/dwKzB4QUt1NB6uTDfGOP+cNm9mEsBAFiM7AQh9AKVEU75vy68jeOxrUC4mDEuYO0oLqoSdHaEF2eXYYSm0V+oEOwpLmYFOF3Z4CmAeBTIGueiIw2xoKPzDBJVBXQ5g5O8/twwA+QguIjJt3+g0NQEcDfUXgO5gsqlTBLkQLdl86K3CWneitQ8sg/5oWAUJP2C3V3RoEyji5n4b9lB4t9pz2CA+cAFn1Z9I/uzYsU/ELtEBOCHYQQqGcFejV+yeuRJX31zsKV5IGjway9z6PLDxKwNEPsBuOEiqw57jGgOtZ1Y++T50AuMFl7hPIbhskiOwsATtRoc7rS7dXrpcgrMCGJca6ELJo+Y0be0BW5ZKGcFz4y8W9BduwcDnK9iO5fagsKpp9ANnvDPxeP8THNyIVFo1AMas8Qk5v2Ytm0LCCYAXqn+wQsPTBh/5Bcnne14Os3uCQt28vsK1WUESJFviBgAW//3u9PLxusXchcCR2WsNzv/ImvgZzzkUByDUAIrjTvmSHAowpJBQE4SUlxMxnARlQbIqkArVAJ6pBBvELCCKlkyCDAP45BYfEPfcUpfMch3Vn4bheYK4E66BxAxHSVd5INgEPgU/NBCDfNQ8Ho1CoINAPQAW/QT8OCIZlNFCB84XhoDChFByHGjx35v9BLgyhmojqHYb5QYXnuAecvua0hZe6BV9f7v4ibvgvamrmAc1TmaEir0LQ9h97eYAYVoM/nWA60i8Q3Ifezha9BqaaL3zvqd6IAuwwLSCCuCLuJWch4h30giPtyiAphKEBcCu9BV5wwzkMxID8rhMwdwMhcSFgrBT3RUTQboAUg3+p+Qe1IGarOioVnazmefV3lHpwA0AcLWCahUiXwePHWJsP+GH1gnp/we5KfOhJAbsj0H/BIEb04TbrTPsAyb2LLu93KwfCvn5PLAwrOXAa72eEQRo1CNdw5IprsAZ3hApy9zlcITG2vpCihsRSYxNS+J4vdBZ6B52eqRcQ/QXmSjAWSfa/5GA5qEg4iJFtm624AqXLrSA2gx8p1Mdqcghv41S0lSp/xAYs9gakQc4Ie2RTUYwYgt748mV+FU1Xgp14eW3XYZ6cdqGTNHwHICTwEeTPl0jEZwIgP9gDEaogeg5IHWCF+1eoAhvEKPB/EAeTRsM/pSAP5wjWEUMM1/NJRhwJbpJSgK7S7zF3EOsI5jBQBK9DV80Z8Y0COzvmWzJXgDl40KEC6cqvqgi4OB5cpgLFYK/1CvDiItXqC6/S87wfAUfPtxqfGNzlYaOjlf1IsHPPvffHgDAoEeEST4ZLZUd/RSo91/BjXY5ggWgQ4In3fyj4mUqPrInHOCLKO3wUwRsfyXpt1nEIRLrqcWeTuk7bigsbid1zD4iDRQtnIdQsyIXnFCn1I9D7ADgxEhOvR5AJosoUbu1FkJyYCi9OhQERoIx+4AX/YqUXQhtYEwKN4Cy1HntLMmtaAQpqfrT/UCoLSxeswjA5UWPPi0mjajUWxMTdVusNvt/ChMdmILK5IRMFu90BMEzFYHdg2GAgeYVHMMJIBTA7EFTx/5fpgTFXz9w/en0ZjD8kCDoKPNGwlB01BmoWQbh+AxR689mBponGJOr9OwmMu3dtJ/ylW1Tik4ElUPmR9RqII+pVhD9ychABMQ51gOIZg+/G+5mGIzLB1JJC5WhzYjhJ7IWmLDpA8jzsAafUPkB2WnFBF4iSxkq1ty7f25rv/+EQLOxs2oUdTSA9HIR9swdBlCcFe9owPC3XWDDC0ISVzsEVbSCF/sWdA5Fu4HJqankp2SeQCYYrImNalfmhpVxYrGkUS4LeSUjg8dD7+D7w/ybIfy7vlB9/HJ978zr7/45Qgajzj+4EjIK/ULHPRAOlKr/aG0AFcqCyu0GcW45Igh6JMJmhA49/U+cEssHNJhtXDC1MOya3j/sAiAGcrEtqtgjBD6wEzSDc7D8o6C8rIqAZyPk+NQoNLAZ1hR64Yl1FBY648smUYKnSg1Xwk/0DyRyArByMUobyByhCcPnOaPyoegREFS4jNfYAw+IHCjdC1J2WDZBke/OyN85J24WiXwDYPoJyYuCD238ulvuzwt6KgHf0shWKsqCFFGjB/w8HU8eeTED9wAAAAABJRU5ErkJggg==";
let $c520c01920caea8f$var$_instanceNumber = 0;
const $c520c01920caea8f$export$9712a76d5eb55c88 = (scene)=>{
    if (!scene.environmentBRDFTexture) {
        // Forces Delayed Texture Loading to prevent undefined error whilst setting RGBD values.
        const useDelayedTextureLoading = scene.useDelayedTextureLoading;
        scene.useDelayedTextureLoading = false;
        const previousState = scene._blockEntityCollection;
        scene._blockEntityCollection = false;
        const texture = (0, $j2mX5.Texture).CreateFromBase64String($c520c01920caea8f$var$_environmentBRDFBase64Texture, "EnvironmentBRDFTexture" + $c520c01920caea8f$var$_instanceNumber++, scene, true, false, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE);
        scene._blockEntityCollection = previousState;
        // BRDF Texture should not be cached here due to pre processing and redundant scene caches.
        const texturesCache = scene.getEngine().getLoadedTexturesCache();
        const index = texturesCache.indexOf(texture.getInternalTexture());
        if (index !== -1) texturesCache.splice(index, 1);
        texture.isRGBD = true;
        texture.wrapU = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        texture.wrapV = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        scene.environmentBRDFTexture = texture;
        scene.useDelayedTextureLoading = useDelayedTextureLoading;
        (0, $ezAJn.RGBDTextureTools).ExpandRGBDTexture(texture);
        const observer = scene.getEngine().onContextRestoredObservable.add(()=>{
            texture.isRGBD = true;
            /**
             * Using scene.onBeforeRenderObservable instead of Tools.SetImmediate to check the texture's state of readiness allows us to check before any rendering occurs.
             * When a context restore occurs, it gives ExpandRGBDTexture the ability to reset the state to false, preventing the texture from being used in any rendering.
             * In WebGPU, not doing so would generate an error because ExpandRGBDTexture performs a _swapAndDie on the texture, which causes WebGPU caches to fail if the texture has already been used for rendering.
             * Only when ExpandRGBDTexture has finished its work, the texture is ready to be used again.
             */ const oo = scene.onBeforeRenderObservable.add(()=>{
                if (texture.isReady()) {
                    scene.onBeforeRenderObservable.remove(oo);
                    (0, $ezAJn.RGBDTextureTools).ExpandRGBDTexture(texture);
                }
            });
        });
        scene.onDisposeObservable.add(()=>{
            scene.getEngine().onContextRestoredObservable.remove(observer);
        });
    }
    return scene.environmentBRDFTexture;
};
const $c520c01920caea8f$export$6160fb916073b7a7 = {
    GetEnvironmentBRDFTexture: /**
     * Gets a default environment BRDF for MS-BRDF Height Correlated BRDF
     * @param scene defines the hosting scene
     * @returns the environment BRDF texture
     */ // eslint-disable-next-line @typescript-eslint/naming-convention
    $c520c01920caea8f$export$9712a76d5eb55c88
};

});

parcelRegister("4G6Xh", function(module, exports) {

$parcel$export(module.exports, "PBRMaterialDefines", () => $36807acca6a085d5$export$1cd3a08a9ead0258);
$parcel$export(module.exports, "PBRBaseMaterial", () => $36807acca6a085d5$export$a6012fe5a7d6699b);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $kVtWi = parcelRequire("kVtWi");

var $57onU = parcelRequire("57onU");

var $gVj3s = parcelRequire("gVj3s");

var $gmbCk = parcelRequire("gmbCk");

var $ha1VO = parcelRequire("ha1VO");

var $b4i1f = parcelRequire("b4i1f");

var $5LMez = parcelRequire("5LMez");

var $dqWqq = parcelRequire("dqWqq");

var $7etnY = parcelRequire("7etnY");

var $1VEEL = parcelRequire("1VEEL");

var $dG1pf = parcelRequire("dG1pf");

var $54229 = parcelRequire("54229");

var $7HBDq = parcelRequire("7HBDq");

var $35xmP = parcelRequire("35xmP");

var $atHN2 = parcelRequire("atHN2");

var $j2mX5 = parcelRequire("j2mX5");

var $2hKx5 = parcelRequire("2hKx5");
parcelRequire("90OM8");
parcelRequire("9K5SJ");
parcelRequire("fxKbe");

var $gc8Ja = parcelRequire("gc8Ja");

var $dXX3O = parcelRequire("dXX3O");

var $lngOr = parcelRequire("lngOr");

var $3rbQN = parcelRequire("3rbQN");

var $4T4Yv = parcelRequire("4T4Yv");

var $5Nlza = parcelRequire("5Nlza");

var $bRVvK = parcelRequire("bRVvK");

var $aAFeM = parcelRequire("aAFeM");

var $alPCh = parcelRequire("alPCh");
const $36807acca6a085d5$var$onCreatedEffectParameters = {
    effect: null,
    subMesh: null
};
class $36807acca6a085d5$export$1cd3a08a9ead0258 extends (0, $35xmP.MaterialDefines) {
    /**
     * Initializes the PBR Material defines.
     * @param externalProperties The external properties
     */ constructor(externalProperties){
        super(externalProperties);
        this.PBR = true;
        this.NUM_SAMPLES = "0";
        this.REALTIME_FILTERING = false;
        this.MAINUV1 = false;
        this.MAINUV2 = false;
        this.MAINUV3 = false;
        this.MAINUV4 = false;
        this.MAINUV5 = false;
        this.MAINUV6 = false;
        this.UV1 = false;
        this.UV2 = false;
        this.UV3 = false;
        this.UV4 = false;
        this.UV5 = false;
        this.UV6 = false;
        this.ALBEDO = false;
        this.GAMMAALBEDO = false;
        this.ALBEDODIRECTUV = 0;
        this.VERTEXCOLOR = false;
        this.BAKED_VERTEX_ANIMATION_TEXTURE = false;
        this.AMBIENT = false;
        this.AMBIENTDIRECTUV = 0;
        this.AMBIENTINGRAYSCALE = false;
        this.OPACITY = false;
        this.VERTEXALPHA = false;
        this.OPACITYDIRECTUV = 0;
        this.OPACITYRGB = false;
        this.ALPHATEST = false;
        this.DEPTHPREPASS = false;
        this.ALPHABLEND = false;
        this.ALPHAFROMALBEDO = false;
        this.ALPHATESTVALUE = "0.5";
        this.SPECULAROVERALPHA = false;
        this.RADIANCEOVERALPHA = false;
        this.ALPHAFRESNEL = false;
        this.LINEARALPHAFRESNEL = false;
        this.PREMULTIPLYALPHA = false;
        this.EMISSIVE = false;
        this.EMISSIVEDIRECTUV = 0;
        this.GAMMAEMISSIVE = false;
        this.REFLECTIVITY = false;
        this.REFLECTIVITY_GAMMA = false;
        this.REFLECTIVITYDIRECTUV = 0;
        this.SPECULARTERM = false;
        this.MICROSURFACEFROMREFLECTIVITYMAP = false;
        this.MICROSURFACEAUTOMATIC = false;
        this.LODBASEDMICROSFURACE = false;
        this.MICROSURFACEMAP = false;
        this.MICROSURFACEMAPDIRECTUV = 0;
        this.METALLICWORKFLOW = false;
        this.ROUGHNESSSTOREINMETALMAPALPHA = false;
        this.ROUGHNESSSTOREINMETALMAPGREEN = false;
        this.METALLNESSSTOREINMETALMAPBLUE = false;
        this.AOSTOREINMETALMAPRED = false;
        this.METALLIC_REFLECTANCE = false;
        this.METALLIC_REFLECTANCE_GAMMA = false;
        this.METALLIC_REFLECTANCEDIRECTUV = 0;
        this.METALLIC_REFLECTANCE_USE_ALPHA_ONLY = false;
        this.REFLECTANCE = false;
        this.REFLECTANCE_GAMMA = false;
        this.REFLECTANCEDIRECTUV = 0;
        this.ENVIRONMENTBRDF = false;
        this.ENVIRONMENTBRDF_RGBD = false;
        this.NORMAL = false;
        this.TANGENT = false;
        this.BUMP = false;
        this.BUMPDIRECTUV = 0;
        this.OBJECTSPACE_NORMALMAP = false;
        this.PARALLAX = false;
        this.PARALLAX_RHS = false;
        this.PARALLAXOCCLUSION = false;
        this.NORMALXYSCALE = true;
        this.LIGHTMAP = false;
        this.LIGHTMAPDIRECTUV = 0;
        this.USELIGHTMAPASSHADOWMAP = false;
        this.GAMMALIGHTMAP = false;
        this.RGBDLIGHTMAP = false;
        this.REFLECTION = false;
        this.REFLECTIONMAP_3D = false;
        this.REFLECTIONMAP_SPHERICAL = false;
        this.REFLECTIONMAP_PLANAR = false;
        this.REFLECTIONMAP_CUBIC = false;
        this.USE_LOCAL_REFLECTIONMAP_CUBIC = false;
        this.REFLECTIONMAP_PROJECTION = false;
        this.REFLECTIONMAP_SKYBOX = false;
        this.REFLECTIONMAP_EXPLICIT = false;
        this.REFLECTIONMAP_EQUIRECTANGULAR = false;
        this.REFLECTIONMAP_EQUIRECTANGULAR_FIXED = false;
        this.REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED = false;
        this.INVERTCUBICMAP = false;
        this.USESPHERICALFROMREFLECTIONMAP = false;
        this.USEIRRADIANCEMAP = false;
        this.USESPHERICALINVERTEX = false;
        this.REFLECTIONMAP_OPPOSITEZ = false;
        this.LODINREFLECTIONALPHA = false;
        this.GAMMAREFLECTION = false;
        this.RGBDREFLECTION = false;
        this.LINEARSPECULARREFLECTION = false;
        this.RADIANCEOCCLUSION = false;
        this.HORIZONOCCLUSION = false;
        this.INSTANCES = false;
        this.THIN_INSTANCES = false;
        this.INSTANCESCOLOR = false;
        this.PREPASS = false;
        this.PREPASS_IRRADIANCE = false;
        this.PREPASS_IRRADIANCE_INDEX = -1;
        this.PREPASS_ALBEDO_SQRT = false;
        this.PREPASS_ALBEDO_SQRT_INDEX = -1;
        this.PREPASS_DEPTH = false;
        this.PREPASS_DEPTH_INDEX = -1;
        this.PREPASS_NORMAL = false;
        this.PREPASS_NORMAL_INDEX = -1;
        this.PREPASS_NORMAL_WORLDSPACE = false;
        this.PREPASS_POSITION = false;
        this.PREPASS_POSITION_INDEX = -1;
        this.PREPASS_VELOCITY = false;
        this.PREPASS_VELOCITY_INDEX = -1;
        this.PREPASS_REFLECTIVITY = false;
        this.PREPASS_REFLECTIVITY_INDEX = -1;
        this.SCENE_MRT_COUNT = 0;
        this.NUM_BONE_INFLUENCERS = 0;
        this.BonesPerMesh = 0;
        this.BONETEXTURE = false;
        this.BONES_VELOCITY_ENABLED = false;
        this.NONUNIFORMSCALING = false;
        this.MORPHTARGETS = false;
        this.MORPHTARGETS_NORMAL = false;
        this.MORPHTARGETS_TANGENT = false;
        this.MORPHTARGETS_UV = false;
        this.NUM_MORPH_INFLUENCERS = 0;
        this.MORPHTARGETS_TEXTURE = false;
        this.IMAGEPROCESSING = false;
        this.VIGNETTE = false;
        this.VIGNETTEBLENDMODEMULTIPLY = false;
        this.VIGNETTEBLENDMODEOPAQUE = false;
        this.TONEMAPPING = false;
        this.TONEMAPPING_ACES = false;
        this.CONTRAST = false;
        this.COLORCURVES = false;
        this.COLORGRADING = false;
        this.COLORGRADING3D = false;
        this.SAMPLER3DGREENDEPTH = false;
        this.SAMPLER3DBGRMAP = false;
        this.DITHER = false;
        this.IMAGEPROCESSINGPOSTPROCESS = false;
        this.SKIPFINALCOLORCLAMP = false;
        this.EXPOSURE = false;
        this.MULTIVIEW = false;
        this.ORDER_INDEPENDENT_TRANSPARENCY = false;
        this.ORDER_INDEPENDENT_TRANSPARENCY_16BITS = false;
        this.USEPHYSICALLIGHTFALLOFF = false;
        this.USEGLTFLIGHTFALLOFF = false;
        this.TWOSIDEDLIGHTING = false;
        this.SHADOWFLOAT = false;
        this.CLIPPLANE = false;
        this.CLIPPLANE2 = false;
        this.CLIPPLANE3 = false;
        this.CLIPPLANE4 = false;
        this.CLIPPLANE5 = false;
        this.CLIPPLANE6 = false;
        this.POINTSIZE = false;
        this.FOG = false;
        this.LOGARITHMICDEPTH = false;
        this.CAMERA_ORTHOGRAPHIC = false;
        this.CAMERA_PERSPECTIVE = false;
        this.FORCENORMALFORWARD = false;
        this.SPECULARAA = false;
        this.UNLIT = false;
        this.DECAL_AFTER_DETAIL = false;
        this.DEBUGMODE = 0;
        this.rebuild();
    }
    /**
     * Resets the PBR Material defines.
     */ reset() {
        super.reset();
        this.ALPHATESTVALUE = "0.5";
        this.PBR = true;
        this.NORMALXYSCALE = true;
    }
}
class $36807acca6a085d5$export$a6012fe5a7d6699b extends (0, $atHN2.PushMaterial) {
    /**
     * Enables realtime filtering on the texture.
     */ get realTimeFiltering() {
        return this._realTimeFiltering;
    }
    set realTimeFiltering(b) {
        this._realTimeFiltering = b;
        this.markAsDirty(1);
    }
    /**
     * Quality switch for realtime filtering
     */ get realTimeFilteringQuality() {
        return this._realTimeFilteringQuality;
    }
    set realTimeFilteringQuality(n) {
        this._realTimeFilteringQuality = n;
        this.markAsDirty(1);
    }
    /**
     * Can this material render to several textures at once
     */ get canRenderToMRT() {
        return true;
    }
    /**
     * Attaches a new image processing configuration to the PBR Material.
     * @param configuration
     */ _attachImageProcessingConfiguration(configuration) {
        if (configuration === this._imageProcessingConfiguration) return;
        // Detaches observer.
        if (this._imageProcessingConfiguration && this._imageProcessingObserver) this._imageProcessingConfiguration.onUpdateParameters.remove(this._imageProcessingObserver);
        // Pick the scene configuration if needed.
        if (!configuration) this._imageProcessingConfiguration = this.getScene().imageProcessingConfiguration;
        else this._imageProcessingConfiguration = configuration;
        // Attaches observer.
        if (this._imageProcessingConfiguration) this._imageProcessingObserver = this._imageProcessingConfiguration.onUpdateParameters.add(()=>{
            this._markAllSubMeshesAsImageProcessingDirty();
        });
    }
    /**
     * Instantiates a new PBRMaterial instance.
     *
     * @param name The material name
     * @param scene The scene the material will be use in.
     */ constructor(name, scene){
        super(name, scene);
        /**
         * Intensity of the direct lights e.g. the four lights available in your scene.
         * This impacts both the direct diffuse and specular highlights.
         * @internal
         */ this._directIntensity = 1.0;
        /**
         * Intensity of the emissive part of the material.
         * This helps controlling the emissive effect without modifying the emissive color.
         * @internal
         */ this._emissiveIntensity = 1.0;
        /**
         * Intensity of the environment e.g. how much the environment will light the object
         * either through harmonics for rough material or through the reflection for shiny ones.
         * @internal
         */ this._environmentIntensity = 1.0;
        /**
         * This is a special control allowing the reduction of the specular highlights coming from the
         * four lights of the scene. Those highlights may not be needed in full environment lighting.
         * @internal
         */ this._specularIntensity = 1.0;
        /**
         * This stores the direct, emissive, environment, and specular light intensities into a Vector4.
         */ this._lightingInfos = new (0, $ha1VO.Vector4)(this._directIntensity, this._emissiveIntensity, this._environmentIntensity, this._specularIntensity);
        /**
         * Debug Control allowing disabling the bump map on this material.
         * @internal
         */ this._disableBumpMap = false;
        /**
         * AKA Diffuse Texture in standard nomenclature.
         * @internal
         */ this._albedoTexture = null;
        /**
         * AKA Occlusion Texture in other nomenclature.
         * @internal
         */ this._ambientTexture = null;
        /**
         * AKA Occlusion Texture Intensity in other nomenclature.
         * @internal
         */ this._ambientTextureStrength = 1.0;
        /**
         * Defines how much the AO map is occluding the analytical lights (point spot...).
         * 1 means it completely occludes it
         * 0 mean it has no impact
         * @internal
         */ this._ambientTextureImpactOnAnalyticalLights = $36807acca6a085d5$export$a6012fe5a7d6699b.DEFAULT_AO_ON_ANALYTICAL_LIGHTS;
        /**
         * Stores the alpha values in a texture.
         * @internal
         */ this._opacityTexture = null;
        /**
         * Stores the reflection values in a texture.
         * @internal
         */ this._reflectionTexture = null;
        /**
         * Stores the emissive values in a texture.
         * @internal
         */ this._emissiveTexture = null;
        /**
         * AKA Specular texture in other nomenclature.
         * @internal
         */ this._reflectivityTexture = null;
        /**
         * Used to switch from specular/glossiness to metallic/roughness workflow.
         * @internal
         */ this._metallicTexture = null;
        /**
         * Specifies the metallic scalar of the metallic/roughness workflow.
         * Can also be used to scale the metalness values of the metallic texture.
         * @internal
         */ this._metallic = null;
        /**
         * Specifies the roughness scalar of the metallic/roughness workflow.
         * Can also be used to scale the roughness values of the metallic texture.
         * @internal
         */ this._roughness = null;
        /**
         * In metallic workflow, specifies an F0 factor to help configuring the material F0.
         * By default the indexOfrefraction is used to compute F0;
         *
         * This is used as a factor against the default reflectance at normal incidence to tweak it.
         *
         * F0 = defaultF0 * metallicF0Factor * metallicReflectanceColor;
         * F90 = metallicReflectanceColor;
         * @internal
         */ this._metallicF0Factor = 1;
        /**
         * In metallic workflow, specifies an F0 color.
         * By default the F90 is always 1;
         *
         * Please note that this factor is also used as a factor against the default reflectance at normal incidence.
         *
         * F0 = defaultF0_from_IOR * metallicF0Factor * metallicReflectanceColor
         * F90 = metallicF0Factor;
         * @internal
         */ this._metallicReflectanceColor = (0, $7etnY.Color3).White();
        /**
         * Specifies that only the A channel from _metallicReflectanceTexture should be used.
         * If false, both RGB and A channels will be used
         * @internal
         */ this._useOnlyMetallicFromMetallicReflectanceTexture = false;
        /**
         * Defines to store metallicReflectanceColor in RGB and metallicF0Factor in A
         * This is multiply against the scalar values defined in the material.
         * @internal
         */ this._metallicReflectanceTexture = null;
        /**
         * Defines to store reflectanceColor in RGB
         * This is multiplied against the scalar values defined in the material.
         * If both _reflectanceTexture and _metallicReflectanceTexture textures are provided and _useOnlyMetallicFromMetallicReflectanceTexture
         * is false, _metallicReflectanceTexture takes precedence and _reflectanceTexture is not used
         * @internal
         */ this._reflectanceTexture = null;
        /**
         * Used to enable roughness/glossiness fetch from a separate channel depending on the current mode.
         * Gray Scale represents roughness in metallic mode and glossiness in specular mode.
         * @internal
         */ this._microSurfaceTexture = null;
        /**
         * Stores surface normal data used to displace a mesh in a texture.
         * @internal
         */ this._bumpTexture = null;
        /**
         * Stores the pre-calculated light information of a mesh in a texture.
         * @internal
         */ this._lightmapTexture = null;
        /**
         * The color of a material in ambient lighting.
         * @internal
         */ this._ambientColor = new (0, $7etnY.Color3)(0, 0, 0);
        /**
         * AKA Diffuse Color in other nomenclature.
         * @internal
         */ this._albedoColor = new (0, $7etnY.Color3)(1, 1, 1);
        /**
         * AKA Specular Color in other nomenclature.
         * @internal
         */ this._reflectivityColor = new (0, $7etnY.Color3)(1, 1, 1);
        /**
         * The color applied when light is reflected from a material.
         * @internal
         */ this._reflectionColor = new (0, $7etnY.Color3)(1, 1, 1);
        /**
         * The color applied when light is emitted from a material.
         * @internal
         */ this._emissiveColor = new (0, $7etnY.Color3)(0, 0, 0);
        /**
         * AKA Glossiness in other nomenclature.
         * @internal
         */ this._microSurface = 0.9;
        /**
         * Specifies that the material will use the light map as a show map.
         * @internal
         */ this._useLightmapAsShadowmap = false;
        /**
         * This parameters will enable/disable Horizon occlusion to prevent normal maps to look shiny when the normal
         * makes the reflect vector face the model (under horizon).
         * @internal
         */ this._useHorizonOcclusion = true;
        /**
         * This parameters will enable/disable radiance occlusion by preventing the radiance to lit
         * too much the area relying on ambient texture to define their ambient occlusion.
         * @internal
         */ this._useRadianceOcclusion = true;
        /**
         * Specifies that the alpha is coming form the albedo channel alpha channel for alpha blending.
         * @internal
         */ this._useAlphaFromAlbedoTexture = false;
        /**
         * Specifies that the material will keeps the specular highlights over a transparent surface (only the most luminous ones).
         * A car glass is a good example of that. When sun reflects on it you can not see what is behind.
         * @internal
         */ this._useSpecularOverAlpha = true;
        /**
         * Specifies if the reflectivity texture contains the glossiness information in its alpha channel.
         * @internal
         */ this._useMicroSurfaceFromReflectivityMapAlpha = false;
        /**
         * Specifies if the metallic texture contains the roughness information in its alpha channel.
         * @internal
         */ this._useRoughnessFromMetallicTextureAlpha = true;
        /**
         * Specifies if the metallic texture contains the roughness information in its green channel.
         * @internal
         */ this._useRoughnessFromMetallicTextureGreen = false;
        /**
         * Specifies if the metallic texture contains the metallness information in its blue channel.
         * @internal
         */ this._useMetallnessFromMetallicTextureBlue = false;
        /**
         * Specifies if the metallic texture contains the ambient occlusion information in its red channel.
         * @internal
         */ this._useAmbientOcclusionFromMetallicTextureRed = false;
        /**
         * Specifies if the ambient texture contains the ambient occlusion information in its red channel only.
         * @internal
         */ this._useAmbientInGrayScale = false;
        /**
         * In case the reflectivity map does not contain the microsurface information in its alpha channel,
         * The material will try to infer what glossiness each pixel should be.
         * @internal
         */ this._useAutoMicroSurfaceFromReflectivityMap = false;
        /**
         * Defines the  falloff type used in this material.
         * It by default is Physical.
         * @internal
         */ this._lightFalloff = $36807acca6a085d5$export$a6012fe5a7d6699b.LIGHTFALLOFF_PHYSICAL;
        /**
         * Specifies that the material will keeps the reflection highlights over a transparent surface (only the most luminous ones).
         * A car glass is a good example of that. When the street lights reflects on it you can not see what is behind.
         * @internal
         */ this._useRadianceOverAlpha = true;
        /**
         * Allows using an object space normal map (instead of tangent space).
         * @internal
         */ this._useObjectSpaceNormalMap = false;
        /**
         * Allows using the bump map in parallax mode.
         * @internal
         */ this._useParallax = false;
        /**
         * Allows using the bump map in parallax occlusion mode.
         * @internal
         */ this._useParallaxOcclusion = false;
        /**
         * Controls the scale bias of the parallax mode.
         * @internal
         */ this._parallaxScaleBias = 0.05;
        /**
         * If sets to true, disables all the lights affecting the material.
         * @internal
         */ this._disableLighting = false;
        /**
         * Number of Simultaneous lights allowed on the material.
         * @internal
         */ this._maxSimultaneousLights = 4;
        /**
         * If sets to true, x component of normal map value will be inverted (x = 1.0 - x).
         * @internal
         */ this._invertNormalMapX = false;
        /**
         * If sets to true, y component of normal map value will be inverted (y = 1.0 - y).
         * @internal
         */ this._invertNormalMapY = false;
        /**
         * If sets to true and backfaceCulling is false, normals will be flipped on the backside.
         * @internal
         */ this._twoSidedLighting = false;
        /**
         * Defines the alpha limits in alpha test mode.
         * @internal
         */ this._alphaCutOff = 0.4;
        /**
         * Enforces alpha test in opaque or blend mode in order to improve the performances of some situations.
         * @internal
         */ this._forceAlphaTest = false;
        /**
         * A fresnel is applied to the alpha of the model to ensure grazing angles edges are not alpha tested.
         * And/Or occlude the blended part. (alpha is converted to gamma to compute the fresnel)
         * @internal
         */ this._useAlphaFresnel = false;
        /**
         * A fresnel is applied to the alpha of the model to ensure grazing angles edges are not alpha tested.
         * And/Or occlude the blended part. (alpha stays linear to compute the fresnel)
         * @internal
         */ this._useLinearAlphaFresnel = false;
        /**
         * Specifies the environment BRDF texture used to compute the scale and offset roughness values
         * from cos theta and roughness:
         * http://blog.selfshadow.com/publications/s2013-shading-course/karis/s2013_pbs_epic_notes_v2.pdf
         * @internal
         */ this._environmentBRDFTexture = null;
        /**
         * Force the shader to compute irradiance in the fragment shader in order to take bump in account.
         * @internal
         */ this._forceIrradianceInFragment = false;
        this._realTimeFiltering = false;
        this._realTimeFilteringQuality = 8;
        /**
         * Force normal to face away from face.
         * @internal
         */ this._forceNormalForward = false;
        /**
         * Enables specular anti aliasing in the PBR shader.
         * It will both interacts on the Geometry for analytical and IBL lighting.
         * It also prefilter the roughness map based on the bump values.
         * @internal
         */ this._enableSpecularAntiAliasing = false;
        /**
         * Keep track of the image processing observer to allow dispose and replace.
         */ this._imageProcessingObserver = null;
        /**
         * Stores the available render targets.
         */ this._renderTargets = new (0, $57onU.SmartArray)(16);
        /**
         * Sets the global ambient color for the material used in lighting calculations.
         */ this._globalAmbientColor = new (0, $7etnY.Color3)(0, 0, 0);
        /**
         * If set to true, no lighting calculations will be applied.
         */ this._unlit = false;
        /**
         * If sets to true, the decal map will be applied after the detail map. Else, it is applied before (default: false)
         */ this._applyDecalMapAfterDetailMap = false;
        this._debugMode = 0;
        /**
         * @internal
         * This is reserved for the inspector.
         * Defines the material debug mode.
         * It helps seeing only some components of the material while troubleshooting.
         */ this.debugMode = 0;
        /**
         * @internal
         * This is reserved for the inspector.
         * Specify from where on screen the debug mode should start.
         * The value goes from -1 (full screen) to 1 (not visible)
         * It helps with side by side comparison against the final render
         * This defaults to -1
         */ this.debugLimit = -1;
        /**
         * @internal
         * This is reserved for the inspector.
         * As the default viewing range might not be enough (if the ambient is really small for instance)
         * You can use the factor to better multiply the final value.
         */ this.debugFactor = 1;
        this._cacheHasRenderTargetTextures = false;
        this.brdf = new (0, $5LMez.PBRBRDFConfiguration)(this);
        this.clearCoat = new (0, $dXX3O.PBRClearCoatConfiguration)(this);
        this.iridescence = new (0, $lngOr.PBRIridescenceConfiguration)(this);
        this.anisotropy = new (0, $3rbQN.PBRAnisotropicConfiguration)(this);
        this.sheen = new (0, $4T4Yv.PBRSheenConfiguration)(this);
        this.subSurface = new (0, $5Nlza.PBRSubSurfaceConfiguration)(this);
        this.detailMap = new (0, $bRVvK.DetailMapConfiguration)(this);
        // Setup the default processing configuration to the scene.
        this._attachImageProcessingConfiguration(null);
        this.getRenderTargetTextures = ()=>{
            this._renderTargets.reset();
            if ((0, $2hKx5.MaterialFlags).ReflectionTextureEnabled && this._reflectionTexture && this._reflectionTexture.isRenderTarget) this._renderTargets.push(this._reflectionTexture);
            this._eventInfo.renderTargets = this._renderTargets;
            this._callbackPluginEventFillRenderTargetTextures(this._eventInfo);
            return this._renderTargets;
        };
        this._environmentBRDFTexture = (0, $gVj3s.GetEnvironmentBRDFTexture)(this.getScene());
        this.prePassConfiguration = new (0, $dqWqq.PrePassConfiguration)();
    }
    /**
     * Gets a boolean indicating that current material needs to register RTT
     */ get hasRenderTargetTextures() {
        if ((0, $2hKx5.MaterialFlags).ReflectionTextureEnabled && this._reflectionTexture && this._reflectionTexture.isRenderTarget) return true;
        return this._cacheHasRenderTargetTextures;
    }
    /**
     * Can this material render to prepass
     */ get isPrePassCapable() {
        return !this.disableDepthWrite;
    }
    /**
     * @returns the name of the material class.
     */ getClassName() {
        return "PBRBaseMaterial";
    }
    /**
     * Returns true if alpha blending should be disabled.
     */ get _disableAlphaBlending() {
        return this._transparencyMode === $36807acca6a085d5$export$a6012fe5a7d6699b.PBRMATERIAL_OPAQUE || this._transparencyMode === $36807acca6a085d5$export$a6012fe5a7d6699b.PBRMATERIAL_ALPHATEST || this.subSurface?.disableAlphaBlending;
    }
    /**
     * @returns whether or not this material should be rendered in alpha blend mode.
     */ needAlphaBlending() {
        if (this._disableAlphaBlending) return false;
        return this.alpha < 1.0 || this._opacityTexture != null || this._shouldUseAlphaFromAlbedoTexture();
    }
    /**
     * @returns whether or not this material should be rendered in alpha test mode.
     */ needAlphaTesting() {
        if (this._forceAlphaTest) return true;
        if (this.subSurface?.disableAlphaBlending) return false;
        return this._hasAlphaChannel() && (this._transparencyMode == null || this._transparencyMode === $36807acca6a085d5$export$a6012fe5a7d6699b.PBRMATERIAL_ALPHATEST);
    }
    /**
     * @returns whether or not the alpha value of the albedo texture should be used for alpha blending.
     */ _shouldUseAlphaFromAlbedoTexture() {
        return this._albedoTexture != null && this._albedoTexture.hasAlpha && this._useAlphaFromAlbedoTexture && this._transparencyMode !== $36807acca6a085d5$export$a6012fe5a7d6699b.PBRMATERIAL_OPAQUE;
    }
    /**
     * @returns whether or not there is a usable alpha channel for transparency.
     */ _hasAlphaChannel() {
        return this._albedoTexture != null && this._albedoTexture.hasAlpha || this._opacityTexture != null;
    }
    /**
     * @returns the texture used for the alpha test.
     */ getAlphaTestTexture() {
        return this._albedoTexture;
    }
    /**
     * Specifies that the submesh is ready to be used.
     * @param mesh - BJS mesh.
     * @param subMesh - A submesh of the BJS mesh.  Used to check if it is ready.
     * @param useInstances - Specifies that instances should be used.
     * @returns - boolean indicating that the submesh is ready or not.
     */ isReadyForSubMesh(mesh, subMesh, useInstances) {
        if (!this._uniformBufferLayoutBuilt) this.buildUniformLayout();
        const drawWrapper = subMesh._drawWrapper;
        if (drawWrapper.effect && this.isFrozen) {
            if (drawWrapper._wasPreviouslyReady && drawWrapper._wasPreviouslyUsingInstances === useInstances) return true;
        }
        if (!subMesh.materialDefines) {
            this._callbackPluginEventGeneric((0, $7HBDq.MaterialPluginEvent).GetDefineNames, this._eventInfo);
            subMesh.materialDefines = new $36807acca6a085d5$export$1cd3a08a9ead0258(this._eventInfo.defineNames);
        }
        const defines = subMesh.materialDefines;
        if (this._isReadyForSubMesh(subMesh)) return true;
        const scene = this.getScene();
        const engine = scene.getEngine();
        if (defines._areTexturesDirty) {
            this._eventInfo.hasRenderTargetTextures = false;
            this._callbackPluginEventHasRenderTargetTextures(this._eventInfo);
            this._cacheHasRenderTargetTextures = this._eventInfo.hasRenderTargetTextures;
            if (scene.texturesEnabled) {
                if (this._albedoTexture && (0, $2hKx5.MaterialFlags).DiffuseTextureEnabled) {
                    if (!this._albedoTexture.isReadyOrNotBlocking()) return false;
                }
                if (this._ambientTexture && (0, $2hKx5.MaterialFlags).AmbientTextureEnabled) {
                    if (!this._ambientTexture.isReadyOrNotBlocking()) return false;
                }
                if (this._opacityTexture && (0, $2hKx5.MaterialFlags).OpacityTextureEnabled) {
                    if (!this._opacityTexture.isReadyOrNotBlocking()) return false;
                }
                const reflectionTexture = this._getReflectionTexture();
                if (reflectionTexture && (0, $2hKx5.MaterialFlags).ReflectionTextureEnabled) {
                    if (!reflectionTexture.isReadyOrNotBlocking()) return false;
                    if (reflectionTexture.irradianceTexture) {
                        if (!reflectionTexture.irradianceTexture.isReadyOrNotBlocking()) return false;
                    } else {
                        // Not ready until spherical are ready too.
                        if (!reflectionTexture.sphericalPolynomial && reflectionTexture.getInternalTexture()?._sphericalPolynomialPromise) return false;
                    }
                }
                if (this._lightmapTexture && (0, $2hKx5.MaterialFlags).LightmapTextureEnabled) {
                    if (!this._lightmapTexture.isReadyOrNotBlocking()) return false;
                }
                if (this._emissiveTexture && (0, $2hKx5.MaterialFlags).EmissiveTextureEnabled) {
                    if (!this._emissiveTexture.isReadyOrNotBlocking()) return false;
                }
                if ((0, $2hKx5.MaterialFlags).SpecularTextureEnabled) {
                    if (this._metallicTexture) {
                        if (!this._metallicTexture.isReadyOrNotBlocking()) return false;
                    } else if (this._reflectivityTexture) {
                        if (!this._reflectivityTexture.isReadyOrNotBlocking()) return false;
                    }
                    if (this._metallicReflectanceTexture) {
                        if (!this._metallicReflectanceTexture.isReadyOrNotBlocking()) return false;
                    }
                    if (this._reflectanceTexture) {
                        if (!this._reflectanceTexture.isReadyOrNotBlocking()) return false;
                    }
                    if (this._microSurfaceTexture) {
                        if (!this._microSurfaceTexture.isReadyOrNotBlocking()) return false;
                    }
                }
                if (engine.getCaps().standardDerivatives && this._bumpTexture && (0, $2hKx5.MaterialFlags).BumpTextureEnabled && !this._disableBumpMap) {
                    // Bump texture cannot be not blocking.
                    if (!this._bumpTexture.isReady()) return false;
                }
                if (this._environmentBRDFTexture && (0, $2hKx5.MaterialFlags).ReflectionTextureEnabled) {
                    // This is blocking.
                    if (!this._environmentBRDFTexture.isReady()) return false;
                }
            }
        }
        this._eventInfo.isReadyForSubMesh = true;
        this._eventInfo.defines = defines;
        this._eventInfo.subMesh = subMesh;
        this._callbackPluginEventIsReadyForSubMesh(this._eventInfo);
        if (!this._eventInfo.isReadyForSubMesh) return false;
        if (defines._areImageProcessingDirty && this._imageProcessingConfiguration) {
            if (!this._imageProcessingConfiguration.isReady()) return false;
        }
        if (!engine.getCaps().standardDerivatives && !mesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).NormalKind)) {
            mesh.createNormals(true);
            (0, $kVtWi.Logger).Warn("PBRMaterial: Normals have been created for the mesh: " + mesh.name);
        }
        const previousEffect = subMesh.effect;
        const lightDisposed = defines._areLightsDisposed;
        let effect = this._prepareEffect(mesh, defines, this.onCompiled, this.onError, useInstances, null, subMesh.getRenderingMesh().hasThinInstances);
        let forceWasNotReadyPreviously = false;
        if (effect) {
            if (this._onEffectCreatedObservable) {
                $36807acca6a085d5$var$onCreatedEffectParameters.effect = effect;
                $36807acca6a085d5$var$onCreatedEffectParameters.subMesh = subMesh;
                this._onEffectCreatedObservable.notifyObservers($36807acca6a085d5$var$onCreatedEffectParameters);
            }
            // Use previous effect while new one is compiling
            if (this.allowShaderHotSwapping && previousEffect && !effect.isReady()) {
                effect = previousEffect;
                defines.markAsUnprocessed();
                forceWasNotReadyPreviously = this.isFrozen;
                if (lightDisposed) {
                    // re register in case it takes more than one frame.
                    defines._areLightsDisposed = true;
                    return false;
                }
            } else {
                scene.resetCachedMaterial();
                subMesh.setEffect(effect, defines, this._materialContext);
            }
        }
        if (!subMesh.effect || !subMesh.effect.isReady()) return false;
        defines._renderId = scene.getRenderId();
        drawWrapper._wasPreviouslyReady = forceWasNotReadyPreviously ? false : true;
        drawWrapper._wasPreviouslyUsingInstances = !!useInstances;
        this._checkScenePerformancePriority();
        return true;
    }
    /**
     * Specifies if the material uses metallic roughness workflow.
     * @returns boolean specifying if the material uses metallic roughness workflow.
     */ isMetallicWorkflow() {
        if (this._metallic != null || this._roughness != null || this._metallicTexture) return true;
        return false;
    }
    _prepareEffect(mesh, defines, onCompiled = null, onError = null, useInstances = null, useClipPlane = null, useThinInstances) {
        this._prepareDefines(mesh, defines, useInstances, useClipPlane, useThinInstances);
        if (!defines.isDirty) return null;
        defines.markAsProcessed();
        const scene = this.getScene();
        const engine = scene.getEngine();
        // Fallbacks
        const fallbacks = new (0, $gc8Ja.EffectFallbacks)();
        let fallbackRank = 0;
        if (defines.USESPHERICALINVERTEX) fallbacks.addFallback(fallbackRank++, "USESPHERICALINVERTEX");
        if (defines.FOG) fallbacks.addFallback(fallbackRank, "FOG");
        if (defines.SPECULARAA) fallbacks.addFallback(fallbackRank, "SPECULARAA");
        if (defines.POINTSIZE) fallbacks.addFallback(fallbackRank, "POINTSIZE");
        if (defines.LOGARITHMICDEPTH) fallbacks.addFallback(fallbackRank, "LOGARITHMICDEPTH");
        if (defines.PARALLAX) fallbacks.addFallback(fallbackRank, "PARALLAX");
        if (defines.PARALLAX_RHS) fallbacks.addFallback(fallbackRank, "PARALLAX_RHS");
        if (defines.PARALLAXOCCLUSION) fallbacks.addFallback(fallbackRank++, "PARALLAXOCCLUSION");
        if (defines.ENVIRONMENTBRDF) fallbacks.addFallback(fallbackRank++, "ENVIRONMENTBRDF");
        if (defines.TANGENT) fallbacks.addFallback(fallbackRank++, "TANGENT");
        if (defines.BUMP) fallbacks.addFallback(fallbackRank++, "BUMP");
        fallbackRank = (0, $alPCh.HandleFallbacksForShadows)(defines, fallbacks, this._maxSimultaneousLights, fallbackRank++);
        if (defines.SPECULARTERM) fallbacks.addFallback(fallbackRank++, "SPECULARTERM");
        if (defines.USESPHERICALFROMREFLECTIONMAP) fallbacks.addFallback(fallbackRank++, "USESPHERICALFROMREFLECTIONMAP");
        if (defines.USEIRRADIANCEMAP) fallbacks.addFallback(fallbackRank++, "USEIRRADIANCEMAP");
        if (defines.LIGHTMAP) fallbacks.addFallback(fallbackRank++, "LIGHTMAP");
        if (defines.NORMAL) fallbacks.addFallback(fallbackRank++, "NORMAL");
        if (defines.AMBIENT) fallbacks.addFallback(fallbackRank++, "AMBIENT");
        if (defines.EMISSIVE) fallbacks.addFallback(fallbackRank++, "EMISSIVE");
        if (defines.VERTEXCOLOR) fallbacks.addFallback(fallbackRank++, "VERTEXCOLOR");
        if (defines.MORPHTARGETS) fallbacks.addFallback(fallbackRank++, "MORPHTARGETS");
        if (defines.MULTIVIEW) fallbacks.addFallback(0, "MULTIVIEW");
        //Attributes
        const attribs = [
            (0, $b4i1f.VertexBuffer).PositionKind
        ];
        if (defines.NORMAL) attribs.push((0, $b4i1f.VertexBuffer).NormalKind);
        if (defines.TANGENT) attribs.push((0, $b4i1f.VertexBuffer).TangentKind);
        for(let i = 1; i <= 6; ++i)if (defines["UV" + i]) attribs.push(`uv${i === 1 ? "" : i}`);
        if (defines.VERTEXCOLOR) attribs.push((0, $b4i1f.VertexBuffer).ColorKind);
        (0, $alPCh.PrepareAttributesForBones)(attribs, mesh, defines, fallbacks);
        (0, $alPCh.PrepareAttributesForInstances)(attribs, defines);
        (0, $alPCh.PrepareAttributesForMorphTargets)(attribs, mesh, defines);
        (0, $alPCh.PrepareAttributesForBakedVertexAnimation)(attribs, mesh, defines);
        let shaderName = "pbr";
        const uniforms = [
            "world",
            "view",
            "viewProjection",
            "vEyePosition",
            "vLightsType",
            "vAmbientColor",
            "vAlbedoColor",
            "vReflectivityColor",
            "vMetallicReflectanceFactors",
            "vEmissiveColor",
            "visibility",
            "vReflectionColor",
            "vFogInfos",
            "vFogColor",
            "pointSize",
            "vAlbedoInfos",
            "vAmbientInfos",
            "vOpacityInfos",
            "vReflectionInfos",
            "vReflectionPosition",
            "vReflectionSize",
            "vEmissiveInfos",
            "vReflectivityInfos",
            "vReflectionFilteringInfo",
            "vMetallicReflectanceInfos",
            "vReflectanceInfos",
            "vMicroSurfaceSamplerInfos",
            "vBumpInfos",
            "vLightmapInfos",
            "mBones",
            "albedoMatrix",
            "ambientMatrix",
            "opacityMatrix",
            "reflectionMatrix",
            "emissiveMatrix",
            "reflectivityMatrix",
            "normalMatrix",
            "microSurfaceSamplerMatrix",
            "bumpMatrix",
            "lightmapMatrix",
            "metallicReflectanceMatrix",
            "reflectanceMatrix",
            "vLightingIntensity",
            "logarithmicDepthConstant",
            "vSphericalX",
            "vSphericalY",
            "vSphericalZ",
            "vSphericalXX_ZZ",
            "vSphericalYY_ZZ",
            "vSphericalZZ",
            "vSphericalXY",
            "vSphericalYZ",
            "vSphericalZX",
            "vSphericalL00",
            "vSphericalL1_1",
            "vSphericalL10",
            "vSphericalL11",
            "vSphericalL2_2",
            "vSphericalL2_1",
            "vSphericalL20",
            "vSphericalL21",
            "vSphericalL22",
            "vReflectionMicrosurfaceInfos",
            "vTangentSpaceParams",
            "boneTextureWidth",
            "vDebugMode",
            "morphTargetTextureInfo",
            "morphTargetTextureIndices"
        ];
        const samplers = [
            "albedoSampler",
            "reflectivitySampler",
            "ambientSampler",
            "emissiveSampler",
            "bumpSampler",
            "lightmapSampler",
            "opacitySampler",
            "reflectionSampler",
            "reflectionSamplerLow",
            "reflectionSamplerHigh",
            "irradianceSampler",
            "microSurfaceSampler",
            "environmentBrdfSampler",
            "boneSampler",
            "metallicReflectanceSampler",
            "reflectanceSampler",
            "morphTargets",
            "oitDepthSampler",
            "oitFrontColorSampler"
        ];
        const uniformBuffers = [
            "Material",
            "Scene",
            "Mesh"
        ];
        const indexParameters = {
            maxSimultaneousLights: this._maxSimultaneousLights,
            maxSimultaneousMorphTargets: defines.NUM_MORPH_INFLUENCERS
        };
        this._eventInfo.fallbacks = fallbacks;
        this._eventInfo.fallbackRank = fallbackRank;
        this._eventInfo.defines = defines;
        this._eventInfo.uniforms = uniforms;
        this._eventInfo.attributes = attribs;
        this._eventInfo.samplers = samplers;
        this._eventInfo.uniformBuffersNames = uniformBuffers;
        this._eventInfo.customCode = undefined;
        this._eventInfo.mesh = mesh;
        this._eventInfo.indexParameters = indexParameters;
        this._callbackPluginEventGeneric((0, $7HBDq.MaterialPluginEvent).PrepareEffect, this._eventInfo);
        (0, $dqWqq.PrePassConfiguration).AddUniforms(uniforms);
        (0, $dqWqq.PrePassConfiguration).AddSamplers(samplers);
        (0, $aAFeM.addClipPlaneUniforms)(uniforms);
        if (0, $dG1pf.ImageProcessingConfiguration) {
            (0, $dG1pf.ImageProcessingConfiguration).PrepareUniforms(uniforms, defines);
            (0, $dG1pf.ImageProcessingConfiguration).PrepareSamplers(samplers, defines);
        }
        (0, $alPCh.PrepareUniformsAndSamplersList)({
            uniformsNames: uniforms,
            uniformBuffersNames: uniformBuffers,
            samplers: samplers,
            defines: defines,
            maxSimultaneousLights: this._maxSimultaneousLights
        });
        const csnrOptions = {};
        if (this.customShaderNameResolve) shaderName = this.customShaderNameResolve(shaderName, uniforms, uniformBuffers, samplers, defines, attribs, csnrOptions);
        const join = defines.toString();
        const effect = engine.createEffect(shaderName, {
            attributes: attribs,
            uniformsNames: uniforms,
            uniformBuffersNames: uniformBuffers,
            samplers: samplers,
            defines: join,
            fallbacks: fallbacks,
            onCompiled: onCompiled,
            onError: onError,
            indexParameters: indexParameters,
            processFinalCode: csnrOptions.processFinalCode,
            processCodeAfterIncludes: this._eventInfo.customCode,
            multiTarget: defines.PREPASS
        }, engine);
        this._eventInfo.customCode = undefined;
        return effect;
    }
    _prepareDefines(mesh, defines, useInstances = null, useClipPlane = null, useThinInstances = false) {
        const scene = this.getScene();
        const engine = scene.getEngine();
        // Lights
        (0, $alPCh.PrepareDefinesForLights)(scene, mesh, defines, true, this._maxSimultaneousLights, this._disableLighting);
        defines._needNormals = true;
        // Multiview
        (0, $alPCh.PrepareDefinesForMultiview)(scene, defines);
        // PrePass
        const oit = this.needAlphaBlendingForMesh(mesh) && this.getScene().useOrderIndependentTransparency;
        (0, $alPCh.PrepareDefinesForPrePass)(scene, defines, this.canRenderToMRT && !oit);
        // Order independant transparency
        (0, $alPCh.PrepareDefinesForOIT)(scene, defines, oit);
        // Textures
        defines.METALLICWORKFLOW = this.isMetallicWorkflow();
        if (defines._areTexturesDirty) {
            defines._needUVs = false;
            for(let i = 1; i <= 6; ++i)defines["MAINUV" + i] = false;
            if (scene.texturesEnabled) {
                defines.ALBEDODIRECTUV = 0;
                defines.AMBIENTDIRECTUV = 0;
                defines.OPACITYDIRECTUV = 0;
                defines.EMISSIVEDIRECTUV = 0;
                defines.REFLECTIVITYDIRECTUV = 0;
                defines.MICROSURFACEMAPDIRECTUV = 0;
                defines.METALLIC_REFLECTANCEDIRECTUV = 0;
                defines.REFLECTANCEDIRECTUV = 0;
                defines.BUMPDIRECTUV = 0;
                defines.LIGHTMAPDIRECTUV = 0;
                if (engine.getCaps().textureLOD) defines.LODBASEDMICROSFURACE = true;
                if (this._albedoTexture && (0, $2hKx5.MaterialFlags).DiffuseTextureEnabled) {
                    (0, $alPCh.PrepareDefinesForMergedUV)(this._albedoTexture, defines, "ALBEDO");
                    defines.GAMMAALBEDO = this._albedoTexture.gammaSpace;
                } else defines.ALBEDO = false;
                if (this._ambientTexture && (0, $2hKx5.MaterialFlags).AmbientTextureEnabled) {
                    (0, $alPCh.PrepareDefinesForMergedUV)(this._ambientTexture, defines, "AMBIENT");
                    defines.AMBIENTINGRAYSCALE = this._useAmbientInGrayScale;
                } else defines.AMBIENT = false;
                if (this._opacityTexture && (0, $2hKx5.MaterialFlags).OpacityTextureEnabled) {
                    (0, $alPCh.PrepareDefinesForMergedUV)(this._opacityTexture, defines, "OPACITY");
                    defines.OPACITYRGB = this._opacityTexture.getAlphaFromRGB;
                } else defines.OPACITY = false;
                const reflectionTexture = this._getReflectionTexture();
                if (reflectionTexture && (0, $2hKx5.MaterialFlags).ReflectionTextureEnabled) {
                    defines.REFLECTION = true;
                    defines.GAMMAREFLECTION = reflectionTexture.gammaSpace;
                    defines.RGBDREFLECTION = reflectionTexture.isRGBD;
                    defines.LODINREFLECTIONALPHA = reflectionTexture.lodLevelInAlpha;
                    defines.LINEARSPECULARREFLECTION = reflectionTexture.linearSpecularLOD;
                    if (this.realTimeFiltering && this.realTimeFilteringQuality > 0) {
                        defines.NUM_SAMPLES = "" + this.realTimeFilteringQuality;
                        if (engine._features.needTypeSuffixInShaderConstants) defines.NUM_SAMPLES = defines.NUM_SAMPLES + "u";
                        defines.REALTIME_FILTERING = true;
                    } else defines.REALTIME_FILTERING = false;
                    defines.INVERTCUBICMAP = reflectionTexture.coordinatesMode === (0, $j2mX5.Texture).INVCUBIC_MODE;
                    defines.REFLECTIONMAP_3D = reflectionTexture.isCube;
                    defines.REFLECTIONMAP_OPPOSITEZ = defines.REFLECTIONMAP_3D && this.getScene().useRightHandedSystem ? !reflectionTexture.invertZ : reflectionTexture.invertZ;
                    defines.REFLECTIONMAP_CUBIC = false;
                    defines.REFLECTIONMAP_EXPLICIT = false;
                    defines.REFLECTIONMAP_PLANAR = false;
                    defines.REFLECTIONMAP_PROJECTION = false;
                    defines.REFLECTIONMAP_SKYBOX = false;
                    defines.REFLECTIONMAP_SPHERICAL = false;
                    defines.REFLECTIONMAP_EQUIRECTANGULAR = false;
                    defines.REFLECTIONMAP_EQUIRECTANGULAR_FIXED = false;
                    defines.REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED = false;
                    switch(reflectionTexture.coordinatesMode){
                        case (0, $j2mX5.Texture).EXPLICIT_MODE:
                            defines.REFLECTIONMAP_EXPLICIT = true;
                            break;
                        case (0, $j2mX5.Texture).PLANAR_MODE:
                            defines.REFLECTIONMAP_PLANAR = true;
                            break;
                        case (0, $j2mX5.Texture).PROJECTION_MODE:
                            defines.REFLECTIONMAP_PROJECTION = true;
                            break;
                        case (0, $j2mX5.Texture).SKYBOX_MODE:
                            defines.REFLECTIONMAP_SKYBOX = true;
                            break;
                        case (0, $j2mX5.Texture).SPHERICAL_MODE:
                            defines.REFLECTIONMAP_SPHERICAL = true;
                            break;
                        case (0, $j2mX5.Texture).EQUIRECTANGULAR_MODE:
                            defines.REFLECTIONMAP_EQUIRECTANGULAR = true;
                            break;
                        case (0, $j2mX5.Texture).FIXED_EQUIRECTANGULAR_MODE:
                            defines.REFLECTIONMAP_EQUIRECTANGULAR_FIXED = true;
                            break;
                        case (0, $j2mX5.Texture).FIXED_EQUIRECTANGULAR_MIRRORED_MODE:
                            defines.REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED = true;
                            break;
                        case (0, $j2mX5.Texture).CUBIC_MODE:
                        case (0, $j2mX5.Texture).INVCUBIC_MODE:
                        default:
                            defines.REFLECTIONMAP_CUBIC = true;
                            defines.USE_LOCAL_REFLECTIONMAP_CUBIC = reflectionTexture.boundingBoxSize ? true : false;
                            break;
                    }
                    if (reflectionTexture.coordinatesMode !== (0, $j2mX5.Texture).SKYBOX_MODE) {
                        if (reflectionTexture.irradianceTexture) {
                            defines.USEIRRADIANCEMAP = true;
                            defines.USESPHERICALFROMREFLECTIONMAP = false;
                        } else if (reflectionTexture.isCube) {
                            defines.USESPHERICALFROMREFLECTIONMAP = true;
                            defines.USEIRRADIANCEMAP = false;
                            if (this._forceIrradianceInFragment || this.realTimeFiltering || this._twoSidedLighting || engine.getCaps().maxVaryingVectors <= 8) defines.USESPHERICALINVERTEX = false;
                            else defines.USESPHERICALINVERTEX = true;
                        }
                    }
                } else {
                    defines.REFLECTION = false;
                    defines.REFLECTIONMAP_3D = false;
                    defines.REFLECTIONMAP_SPHERICAL = false;
                    defines.REFLECTIONMAP_PLANAR = false;
                    defines.REFLECTIONMAP_CUBIC = false;
                    defines.USE_LOCAL_REFLECTIONMAP_CUBIC = false;
                    defines.REFLECTIONMAP_PROJECTION = false;
                    defines.REFLECTIONMAP_SKYBOX = false;
                    defines.REFLECTIONMAP_EXPLICIT = false;
                    defines.REFLECTIONMAP_EQUIRECTANGULAR = false;
                    defines.REFLECTIONMAP_EQUIRECTANGULAR_FIXED = false;
                    defines.REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED = false;
                    defines.INVERTCUBICMAP = false;
                    defines.USESPHERICALFROMREFLECTIONMAP = false;
                    defines.USEIRRADIANCEMAP = false;
                    defines.USESPHERICALINVERTEX = false;
                    defines.REFLECTIONMAP_OPPOSITEZ = false;
                    defines.LODINREFLECTIONALPHA = false;
                    defines.GAMMAREFLECTION = false;
                    defines.RGBDREFLECTION = false;
                    defines.LINEARSPECULARREFLECTION = false;
                }
                if (this._lightmapTexture && (0, $2hKx5.MaterialFlags).LightmapTextureEnabled) {
                    (0, $alPCh.PrepareDefinesForMergedUV)(this._lightmapTexture, defines, "LIGHTMAP");
                    defines.USELIGHTMAPASSHADOWMAP = this._useLightmapAsShadowmap;
                    defines.GAMMALIGHTMAP = this._lightmapTexture.gammaSpace;
                    defines.RGBDLIGHTMAP = this._lightmapTexture.isRGBD;
                } else defines.LIGHTMAP = false;
                if (this._emissiveTexture && (0, $2hKx5.MaterialFlags).EmissiveTextureEnabled) {
                    (0, $alPCh.PrepareDefinesForMergedUV)(this._emissiveTexture, defines, "EMISSIVE");
                    defines.GAMMAEMISSIVE = this._emissiveTexture.gammaSpace;
                } else defines.EMISSIVE = false;
                if ((0, $2hKx5.MaterialFlags).SpecularTextureEnabled) {
                    if (this._metallicTexture) {
                        (0, $alPCh.PrepareDefinesForMergedUV)(this._metallicTexture, defines, "REFLECTIVITY");
                        defines.ROUGHNESSSTOREINMETALMAPALPHA = this._useRoughnessFromMetallicTextureAlpha;
                        defines.ROUGHNESSSTOREINMETALMAPGREEN = !this._useRoughnessFromMetallicTextureAlpha && this._useRoughnessFromMetallicTextureGreen;
                        defines.METALLNESSSTOREINMETALMAPBLUE = this._useMetallnessFromMetallicTextureBlue;
                        defines.AOSTOREINMETALMAPRED = this._useAmbientOcclusionFromMetallicTextureRed;
                        defines.REFLECTIVITY_GAMMA = false;
                    } else if (this._reflectivityTexture) {
                        (0, $alPCh.PrepareDefinesForMergedUV)(this._reflectivityTexture, defines, "REFLECTIVITY");
                        defines.MICROSURFACEFROMREFLECTIVITYMAP = this._useMicroSurfaceFromReflectivityMapAlpha;
                        defines.MICROSURFACEAUTOMATIC = this._useAutoMicroSurfaceFromReflectivityMap;
                        defines.REFLECTIVITY_GAMMA = this._reflectivityTexture.gammaSpace;
                    } else defines.REFLECTIVITY = false;
                    if (this._metallicReflectanceTexture || this._reflectanceTexture) {
                        const identicalTextures = this._metallicReflectanceTexture !== null && this._metallicReflectanceTexture._texture === this._reflectanceTexture?._texture && this._metallicReflectanceTexture.checkTransformsAreIdentical(this._reflectanceTexture);
                        defines.METALLIC_REFLECTANCE_USE_ALPHA_ONLY = this._useOnlyMetallicFromMetallicReflectanceTexture && !identicalTextures;
                        if (this._metallicReflectanceTexture) {
                            (0, $alPCh.PrepareDefinesForMergedUV)(this._metallicReflectanceTexture, defines, "METALLIC_REFLECTANCE");
                            defines.METALLIC_REFLECTANCE_GAMMA = this._metallicReflectanceTexture.gammaSpace;
                        } else defines.METALLIC_REFLECTANCE = false;
                        if (this._reflectanceTexture && !identicalTextures && (!this._metallicReflectanceTexture || this._metallicReflectanceTexture && this._useOnlyMetallicFromMetallicReflectanceTexture)) {
                            (0, $alPCh.PrepareDefinesForMergedUV)(this._reflectanceTexture, defines, "REFLECTANCE");
                            defines.REFLECTANCE_GAMMA = this._reflectanceTexture.gammaSpace;
                        } else defines.REFLECTANCE = false;
                    } else {
                        defines.METALLIC_REFLECTANCE = false;
                        defines.REFLECTANCE = false;
                    }
                    if (this._microSurfaceTexture) (0, $alPCh.PrepareDefinesForMergedUV)(this._microSurfaceTexture, defines, "MICROSURFACEMAP");
                    else defines.MICROSURFACEMAP = false;
                } else {
                    defines.REFLECTIVITY = false;
                    defines.MICROSURFACEMAP = false;
                }
                if (engine.getCaps().standardDerivatives && this._bumpTexture && (0, $2hKx5.MaterialFlags).BumpTextureEnabled && !this._disableBumpMap) {
                    (0, $alPCh.PrepareDefinesForMergedUV)(this._bumpTexture, defines, "BUMP");
                    if (this._useParallax && this._albedoTexture && (0, $2hKx5.MaterialFlags).DiffuseTextureEnabled) {
                        defines.PARALLAX = true;
                        defines.PARALLAX_RHS = scene.useRightHandedSystem;
                        defines.PARALLAXOCCLUSION = !!this._useParallaxOcclusion;
                    } else defines.PARALLAX = false;
                    defines.OBJECTSPACE_NORMALMAP = this._useObjectSpaceNormalMap;
                } else {
                    defines.BUMP = false;
                    defines.PARALLAX = false;
                    defines.PARALLAX_RHS = false;
                    defines.PARALLAXOCCLUSION = false;
                    defines.OBJECTSPACE_NORMALMAP = false;
                }
                if (this._environmentBRDFTexture && (0, $2hKx5.MaterialFlags).ReflectionTextureEnabled) {
                    defines.ENVIRONMENTBRDF = true;
                    defines.ENVIRONMENTBRDF_RGBD = this._environmentBRDFTexture.isRGBD;
                } else {
                    defines.ENVIRONMENTBRDF = false;
                    defines.ENVIRONMENTBRDF_RGBD = false;
                }
                if (this._shouldUseAlphaFromAlbedoTexture()) defines.ALPHAFROMALBEDO = true;
                else defines.ALPHAFROMALBEDO = false;
            }
            defines.SPECULAROVERALPHA = this._useSpecularOverAlpha;
            if (this._lightFalloff === $36807acca6a085d5$export$a6012fe5a7d6699b.LIGHTFALLOFF_STANDARD) {
                defines.USEPHYSICALLIGHTFALLOFF = false;
                defines.USEGLTFLIGHTFALLOFF = false;
            } else if (this._lightFalloff === $36807acca6a085d5$export$a6012fe5a7d6699b.LIGHTFALLOFF_GLTF) {
                defines.USEPHYSICALLIGHTFALLOFF = false;
                defines.USEGLTFLIGHTFALLOFF = true;
            } else {
                defines.USEPHYSICALLIGHTFALLOFF = true;
                defines.USEGLTFLIGHTFALLOFF = false;
            }
            defines.RADIANCEOVERALPHA = this._useRadianceOverAlpha;
            if (!this.backFaceCulling && this._twoSidedLighting) defines.TWOSIDEDLIGHTING = true;
            else defines.TWOSIDEDLIGHTING = false;
            defines.SPECULARAA = engine.getCaps().standardDerivatives && this._enableSpecularAntiAliasing;
        }
        if (defines._areTexturesDirty || defines._areMiscDirty) {
            defines.ALPHATESTVALUE = `${this._alphaCutOff}${this._alphaCutOff % 1 === 0 ? "." : ""}`;
            defines.PREMULTIPLYALPHA = this.alphaMode === 7 || this.alphaMode === 8;
            defines.ALPHABLEND = this.needAlphaBlendingForMesh(mesh);
            defines.ALPHAFRESNEL = this._useAlphaFresnel || this._useLinearAlphaFresnel;
            defines.LINEARALPHAFRESNEL = this._useLinearAlphaFresnel;
        }
        if (defines._areImageProcessingDirty && this._imageProcessingConfiguration) this._imageProcessingConfiguration.prepareDefines(defines);
        defines.FORCENORMALFORWARD = this._forceNormalForward;
        defines.RADIANCEOCCLUSION = this._useRadianceOcclusion;
        defines.HORIZONOCCLUSION = this._useHorizonOcclusion;
        // Misc.
        if (defines._areMiscDirty) {
            (0, $alPCh.PrepareDefinesForMisc)(mesh, scene, this._useLogarithmicDepth, this.pointsCloud, this.fogEnabled, this._shouldTurnAlphaTestOn(mesh) || this._forceAlphaTest, defines, this._applyDecalMapAfterDetailMap);
            defines.UNLIT = this._unlit || (this.pointsCloud || this.wireframe) && !mesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).NormalKind);
            defines.DEBUGMODE = this._debugMode;
        }
        // Values that need to be evaluated on every frame
        (0, $alPCh.PrepareDefinesForFrameBoundValues)(scene, engine, this, defines, useInstances ? true : false, useClipPlane, useThinInstances);
        // External config
        this._eventInfo.defines = defines;
        this._eventInfo.mesh = mesh;
        this._callbackPluginEventPrepareDefinesBeforeAttributes(this._eventInfo);
        // Attribs
        (0, $alPCh.PrepareDefinesForAttributes)(mesh, defines, true, true, true, this._transparencyMode !== $36807acca6a085d5$export$a6012fe5a7d6699b.PBRMATERIAL_OPAQUE);
        // External config
        this._callbackPluginEventPrepareDefines(this._eventInfo);
    }
    /**
     * Force shader compilation
     * @param mesh - Define the mesh we want to force the compilation for
     * @param onCompiled - Define a callback triggered when the compilation completes
     * @param options - Define the options used to create the compilation
     */ forceCompilation(mesh, onCompiled, options) {
        const localOptions = {
            clipPlane: false,
            useInstances: false,
            ...options
        };
        if (!this._uniformBufferLayoutBuilt) this.buildUniformLayout();
        this._callbackPluginEventGeneric((0, $7HBDq.MaterialPluginEvent).GetDefineNames, this._eventInfo);
        const defines = new $36807acca6a085d5$export$1cd3a08a9ead0258(this._eventInfo.defineNames);
        const effect = this._prepareEffect(mesh, defines, undefined, undefined, localOptions.useInstances, localOptions.clipPlane, mesh.hasThinInstances);
        if (this._onEffectCreatedObservable) {
            $36807acca6a085d5$var$onCreatedEffectParameters.effect = effect;
            $36807acca6a085d5$var$onCreatedEffectParameters.subMesh = null;
            this._onEffectCreatedObservable.notifyObservers($36807acca6a085d5$var$onCreatedEffectParameters);
        }
        if (effect.isReady()) {
            if (onCompiled) onCompiled(this);
        } else effect.onCompileObservable.add(()=>{
            if (onCompiled) onCompiled(this);
        });
    }
    /**
     * Initializes the uniform buffer layout for the shader.
     */ buildUniformLayout() {
        // Order is important !
        const ubo = this._uniformBuffer;
        ubo.addUniform("vAlbedoInfos", 2);
        ubo.addUniform("vAmbientInfos", 4);
        ubo.addUniform("vOpacityInfos", 2);
        ubo.addUniform("vEmissiveInfos", 2);
        ubo.addUniform("vLightmapInfos", 2);
        ubo.addUniform("vReflectivityInfos", 3);
        ubo.addUniform("vMicroSurfaceSamplerInfos", 2);
        ubo.addUniform("vReflectionInfos", 2);
        ubo.addUniform("vReflectionFilteringInfo", 2);
        ubo.addUniform("vReflectionPosition", 3);
        ubo.addUniform("vReflectionSize", 3);
        ubo.addUniform("vBumpInfos", 3);
        ubo.addUniform("albedoMatrix", 16);
        ubo.addUniform("ambientMatrix", 16);
        ubo.addUniform("opacityMatrix", 16);
        ubo.addUniform("emissiveMatrix", 16);
        ubo.addUniform("lightmapMatrix", 16);
        ubo.addUniform("reflectivityMatrix", 16);
        ubo.addUniform("microSurfaceSamplerMatrix", 16);
        ubo.addUniform("bumpMatrix", 16);
        ubo.addUniform("vTangentSpaceParams", 2);
        ubo.addUniform("reflectionMatrix", 16);
        ubo.addUniform("vReflectionColor", 3);
        ubo.addUniform("vAlbedoColor", 4);
        ubo.addUniform("vLightingIntensity", 4);
        ubo.addUniform("vReflectionMicrosurfaceInfos", 3);
        ubo.addUniform("pointSize", 1);
        ubo.addUniform("vReflectivityColor", 4);
        ubo.addUniform("vEmissiveColor", 3);
        ubo.addUniform("vAmbientColor", 3);
        ubo.addUniform("vDebugMode", 2);
        ubo.addUniform("vMetallicReflectanceFactors", 4);
        ubo.addUniform("vMetallicReflectanceInfos", 2);
        ubo.addUniform("metallicReflectanceMatrix", 16);
        ubo.addUniform("vReflectanceInfos", 2);
        ubo.addUniform("reflectanceMatrix", 16);
        ubo.addUniform("vSphericalL00", 3);
        ubo.addUniform("vSphericalL1_1", 3);
        ubo.addUniform("vSphericalL10", 3);
        ubo.addUniform("vSphericalL11", 3);
        ubo.addUniform("vSphericalL2_2", 3);
        ubo.addUniform("vSphericalL2_1", 3);
        ubo.addUniform("vSphericalL20", 3);
        ubo.addUniform("vSphericalL21", 3);
        ubo.addUniform("vSphericalL22", 3);
        ubo.addUniform("vSphericalX", 3);
        ubo.addUniform("vSphericalY", 3);
        ubo.addUniform("vSphericalZ", 3);
        ubo.addUniform("vSphericalXX_ZZ", 3);
        ubo.addUniform("vSphericalYY_ZZ", 3);
        ubo.addUniform("vSphericalZZ", 3);
        ubo.addUniform("vSphericalXY", 3);
        ubo.addUniform("vSphericalYZ", 3);
        ubo.addUniform("vSphericalZX", 3);
        super.buildUniformLayout();
    }
    /**
     * Binds the submesh data.
     * @param world - The world matrix.
     * @param mesh - The BJS mesh.
     * @param subMesh - A submesh of the BJS mesh.
     */ bindForSubMesh(world, mesh, subMesh) {
        const scene = this.getScene();
        const defines = subMesh.materialDefines;
        if (!defines) return;
        const effect = subMesh.effect;
        if (!effect) return;
        this._activeEffect = effect;
        // Matrices Mesh.
        mesh.getMeshUniformBuffer().bindToEffect(effect, "Mesh");
        mesh.transferToEffect(world);
        const engine = scene.getEngine();
        // Binding unconditionally
        this._uniformBuffer.bindToEffect(effect, "Material");
        this.prePassConfiguration.bindForSubMesh(this._activeEffect, scene, mesh, world, this.isFrozen);
        this._eventInfo.subMesh = subMesh;
        this._callbackPluginEventHardBindForSubMesh(this._eventInfo);
        // Normal Matrix
        if (defines.OBJECTSPACE_NORMALMAP) {
            world.toNormalMatrix(this._normalMatrix);
            this.bindOnlyNormalMatrix(this._normalMatrix);
        }
        const mustRebind = this._mustRebind(scene, effect, subMesh, mesh.visibility);
        // Bones
        (0, $alPCh.BindBonesParameters)(mesh, this._activeEffect, this.prePassConfiguration);
        let reflectionTexture = null;
        const ubo = this._uniformBuffer;
        if (mustRebind) {
            this.bindViewProjection(effect);
            reflectionTexture = this._getReflectionTexture();
            if (!ubo.useUbo || !this.isFrozen || !ubo.isSync || subMesh._drawWrapper._forceRebindOnNextCall) {
                // Texture uniforms
                if (scene.texturesEnabled) {
                    if (this._albedoTexture && (0, $2hKx5.MaterialFlags).DiffuseTextureEnabled) {
                        ubo.updateFloat2("vAlbedoInfos", this._albedoTexture.coordinatesIndex, this._albedoTexture.level);
                        (0, $alPCh.BindTextureMatrix)(this._albedoTexture, ubo, "albedo");
                    }
                    if (this._ambientTexture && (0, $2hKx5.MaterialFlags).AmbientTextureEnabled) {
                        ubo.updateFloat4("vAmbientInfos", this._ambientTexture.coordinatesIndex, this._ambientTexture.level, this._ambientTextureStrength, this._ambientTextureImpactOnAnalyticalLights);
                        (0, $alPCh.BindTextureMatrix)(this._ambientTexture, ubo, "ambient");
                    }
                    if (this._opacityTexture && (0, $2hKx5.MaterialFlags).OpacityTextureEnabled) {
                        ubo.updateFloat2("vOpacityInfos", this._opacityTexture.coordinatesIndex, this._opacityTexture.level);
                        (0, $alPCh.BindTextureMatrix)(this._opacityTexture, ubo, "opacity");
                    }
                    if (reflectionTexture && (0, $2hKx5.MaterialFlags).ReflectionTextureEnabled) {
                        ubo.updateMatrix("reflectionMatrix", reflectionTexture.getReflectionTextureMatrix());
                        ubo.updateFloat2("vReflectionInfos", reflectionTexture.level, 0);
                        if (reflectionTexture.boundingBoxSize) {
                            const cubeTexture = reflectionTexture;
                            ubo.updateVector3("vReflectionPosition", cubeTexture.boundingBoxPosition);
                            ubo.updateVector3("vReflectionSize", cubeTexture.boundingBoxSize);
                        }
                        if (this.realTimeFiltering) {
                            const width = reflectionTexture.getSize().width;
                            ubo.updateFloat2("vReflectionFilteringInfo", width, (0, $1VEEL.Scalar).Log2(width));
                        }
                        if (!defines.USEIRRADIANCEMAP) {
                            const polynomials = reflectionTexture.sphericalPolynomial;
                            if (defines.USESPHERICALFROMREFLECTIONMAP && polynomials) {
                                if (defines.SPHERICAL_HARMONICS) {
                                    const preScaledHarmonics = polynomials.preScaledHarmonics;
                                    ubo.updateVector3("vSphericalL00", preScaledHarmonics.l00);
                                    ubo.updateVector3("vSphericalL1_1", preScaledHarmonics.l1_1);
                                    ubo.updateVector3("vSphericalL10", preScaledHarmonics.l10);
                                    ubo.updateVector3("vSphericalL11", preScaledHarmonics.l11);
                                    ubo.updateVector3("vSphericalL2_2", preScaledHarmonics.l2_2);
                                    ubo.updateVector3("vSphericalL2_1", preScaledHarmonics.l2_1);
                                    ubo.updateVector3("vSphericalL20", preScaledHarmonics.l20);
                                    ubo.updateVector3("vSphericalL21", preScaledHarmonics.l21);
                                    ubo.updateVector3("vSphericalL22", preScaledHarmonics.l22);
                                } else {
                                    ubo.updateFloat3("vSphericalX", polynomials.x.x, polynomials.x.y, polynomials.x.z);
                                    ubo.updateFloat3("vSphericalY", polynomials.y.x, polynomials.y.y, polynomials.y.z);
                                    ubo.updateFloat3("vSphericalZ", polynomials.z.x, polynomials.z.y, polynomials.z.z);
                                    ubo.updateFloat3("vSphericalXX_ZZ", polynomials.xx.x - polynomials.zz.x, polynomials.xx.y - polynomials.zz.y, polynomials.xx.z - polynomials.zz.z);
                                    ubo.updateFloat3("vSphericalYY_ZZ", polynomials.yy.x - polynomials.zz.x, polynomials.yy.y - polynomials.zz.y, polynomials.yy.z - polynomials.zz.z);
                                    ubo.updateFloat3("vSphericalZZ", polynomials.zz.x, polynomials.zz.y, polynomials.zz.z);
                                    ubo.updateFloat3("vSphericalXY", polynomials.xy.x, polynomials.xy.y, polynomials.xy.z);
                                    ubo.updateFloat3("vSphericalYZ", polynomials.yz.x, polynomials.yz.y, polynomials.yz.z);
                                    ubo.updateFloat3("vSphericalZX", polynomials.zx.x, polynomials.zx.y, polynomials.zx.z);
                                }
                            }
                        }
                        ubo.updateFloat3("vReflectionMicrosurfaceInfos", reflectionTexture.getSize().width, reflectionTexture.lodGenerationScale, reflectionTexture.lodGenerationOffset);
                    }
                    if (this._emissiveTexture && (0, $2hKx5.MaterialFlags).EmissiveTextureEnabled) {
                        ubo.updateFloat2("vEmissiveInfos", this._emissiveTexture.coordinatesIndex, this._emissiveTexture.level);
                        (0, $alPCh.BindTextureMatrix)(this._emissiveTexture, ubo, "emissive");
                    }
                    if (this._lightmapTexture && (0, $2hKx5.MaterialFlags).LightmapTextureEnabled) {
                        ubo.updateFloat2("vLightmapInfos", this._lightmapTexture.coordinatesIndex, this._lightmapTexture.level);
                        (0, $alPCh.BindTextureMatrix)(this._lightmapTexture, ubo, "lightmap");
                    }
                    if ((0, $2hKx5.MaterialFlags).SpecularTextureEnabled) {
                        if (this._metallicTexture) {
                            ubo.updateFloat3("vReflectivityInfos", this._metallicTexture.coordinatesIndex, this._metallicTexture.level, this._ambientTextureStrength);
                            (0, $alPCh.BindTextureMatrix)(this._metallicTexture, ubo, "reflectivity");
                        } else if (this._reflectivityTexture) {
                            ubo.updateFloat3("vReflectivityInfos", this._reflectivityTexture.coordinatesIndex, this._reflectivityTexture.level, 1.0);
                            (0, $alPCh.BindTextureMatrix)(this._reflectivityTexture, ubo, "reflectivity");
                        }
                        if (this._metallicReflectanceTexture) {
                            ubo.updateFloat2("vMetallicReflectanceInfos", this._metallicReflectanceTexture.coordinatesIndex, this._metallicReflectanceTexture.level);
                            (0, $alPCh.BindTextureMatrix)(this._metallicReflectanceTexture, ubo, "metallicReflectance");
                        }
                        if (this._reflectanceTexture && defines.REFLECTANCE) {
                            ubo.updateFloat2("vReflectanceInfos", this._reflectanceTexture.coordinatesIndex, this._reflectanceTexture.level);
                            (0, $alPCh.BindTextureMatrix)(this._reflectanceTexture, ubo, "reflectance");
                        }
                        if (this._microSurfaceTexture) {
                            ubo.updateFloat2("vMicroSurfaceSamplerInfos", this._microSurfaceTexture.coordinatesIndex, this._microSurfaceTexture.level);
                            (0, $alPCh.BindTextureMatrix)(this._microSurfaceTexture, ubo, "microSurfaceSampler");
                        }
                    }
                    if (this._bumpTexture && engine.getCaps().standardDerivatives && (0, $2hKx5.MaterialFlags).BumpTextureEnabled && !this._disableBumpMap) {
                        ubo.updateFloat3("vBumpInfos", this._bumpTexture.coordinatesIndex, this._bumpTexture.level, this._parallaxScaleBias);
                        (0, $alPCh.BindTextureMatrix)(this._bumpTexture, ubo, "bump");
                        if (scene._mirroredCameraPosition) ubo.updateFloat2("vTangentSpaceParams", this._invertNormalMapX ? 1.0 : -1, this._invertNormalMapY ? 1.0 : -1);
                        else ubo.updateFloat2("vTangentSpaceParams", this._invertNormalMapX ? -1 : 1.0, this._invertNormalMapY ? -1 : 1.0);
                    }
                }
                // Point size
                if (this.pointsCloud) ubo.updateFloat("pointSize", this.pointSize);
                // Colors
                if (defines.METALLICWORKFLOW) {
                    (0, $7etnY.TmpColors).Color3[0].r = this._metallic === undefined || this._metallic === null ? 1 : this._metallic;
                    (0, $7etnY.TmpColors).Color3[0].g = this._roughness === undefined || this._roughness === null ? 1 : this._roughness;
                    ubo.updateColor4("vReflectivityColor", (0, $7etnY.TmpColors).Color3[0], 1);
                    const ior = this.subSurface?._indexOfRefraction ?? 1.5;
                    const outsideIOR = 1; // consider air as clear coat and other layers would remap in the shader.
                    // We are here deriving our default reflectance from a common value for none metallic surface.
                    // Based of the schlick fresnel approximation model
                    // for dielectrics.
                    const f0 = Math.pow((ior - outsideIOR) / (ior + outsideIOR), 2);
                    // Tweak the default F0 and F90 based on our given setup
                    this._metallicReflectanceColor.scaleToRef(f0 * this._metallicF0Factor, (0, $7etnY.TmpColors).Color3[0]);
                    const metallicF90 = this._metallicF0Factor;
                    ubo.updateColor4("vMetallicReflectanceFactors", (0, $7etnY.TmpColors).Color3[0], metallicF90);
                } else ubo.updateColor4("vReflectivityColor", this._reflectivityColor, this._microSurface);
                ubo.updateColor3("vEmissiveColor", (0, $2hKx5.MaterialFlags).EmissiveTextureEnabled ? this._emissiveColor : (0, $7etnY.Color3).BlackReadOnly);
                ubo.updateColor3("vReflectionColor", this._reflectionColor);
                if (!defines.SS_REFRACTION && this.subSurface?._linkRefractionWithTransparency) ubo.updateColor4("vAlbedoColor", this._albedoColor, 1);
                else ubo.updateColor4("vAlbedoColor", this._albedoColor, this.alpha);
                // Misc
                this._lightingInfos.x = this._directIntensity;
                this._lightingInfos.y = this._emissiveIntensity;
                this._lightingInfos.z = this._environmentIntensity * scene.environmentIntensity;
                this._lightingInfos.w = this._specularIntensity;
                ubo.updateVector4("vLightingIntensity", this._lightingInfos);
                // Colors
                scene.ambientColor.multiplyToRef(this._ambientColor, this._globalAmbientColor);
                ubo.updateColor3("vAmbientColor", this._globalAmbientColor);
                ubo.updateFloat2("vDebugMode", this.debugLimit, this.debugFactor);
            }
            // Textures
            if (scene.texturesEnabled) {
                if (this._albedoTexture && (0, $2hKx5.MaterialFlags).DiffuseTextureEnabled) ubo.setTexture("albedoSampler", this._albedoTexture);
                if (this._ambientTexture && (0, $2hKx5.MaterialFlags).AmbientTextureEnabled) ubo.setTexture("ambientSampler", this._ambientTexture);
                if (this._opacityTexture && (0, $2hKx5.MaterialFlags).OpacityTextureEnabled) ubo.setTexture("opacitySampler", this._opacityTexture);
                if (reflectionTexture && (0, $2hKx5.MaterialFlags).ReflectionTextureEnabled) {
                    if (defines.LODBASEDMICROSFURACE) ubo.setTexture("reflectionSampler", reflectionTexture);
                    else {
                        ubo.setTexture("reflectionSampler", reflectionTexture._lodTextureMid || reflectionTexture);
                        ubo.setTexture("reflectionSamplerLow", reflectionTexture._lodTextureLow || reflectionTexture);
                        ubo.setTexture("reflectionSamplerHigh", reflectionTexture._lodTextureHigh || reflectionTexture);
                    }
                    if (defines.USEIRRADIANCEMAP) ubo.setTexture("irradianceSampler", reflectionTexture.irradianceTexture);
                }
                if (defines.ENVIRONMENTBRDF) ubo.setTexture("environmentBrdfSampler", this._environmentBRDFTexture);
                if (this._emissiveTexture && (0, $2hKx5.MaterialFlags).EmissiveTextureEnabled) ubo.setTexture("emissiveSampler", this._emissiveTexture);
                if (this._lightmapTexture && (0, $2hKx5.MaterialFlags).LightmapTextureEnabled) ubo.setTexture("lightmapSampler", this._lightmapTexture);
                if ((0, $2hKx5.MaterialFlags).SpecularTextureEnabled) {
                    if (this._metallicTexture) ubo.setTexture("reflectivitySampler", this._metallicTexture);
                    else if (this._reflectivityTexture) ubo.setTexture("reflectivitySampler", this._reflectivityTexture);
                    if (this._metallicReflectanceTexture) ubo.setTexture("metallicReflectanceSampler", this._metallicReflectanceTexture);
                    if (this._reflectanceTexture && defines.REFLECTANCE) ubo.setTexture("reflectanceSampler", this._reflectanceTexture);
                    if (this._microSurfaceTexture) ubo.setTexture("microSurfaceSampler", this._microSurfaceTexture);
                }
                if (this._bumpTexture && engine.getCaps().standardDerivatives && (0, $2hKx5.MaterialFlags).BumpTextureEnabled && !this._disableBumpMap) ubo.setTexture("bumpSampler", this._bumpTexture);
            }
            // OIT with depth peeling
            if (this.getScene().useOrderIndependentTransparency && this.needAlphaBlendingForMesh(mesh)) this.getScene().depthPeelingRenderer.bind(effect);
            this._eventInfo.subMesh = subMesh;
            this._callbackPluginEventBindForSubMesh(this._eventInfo);
            // Clip plane
            (0, $aAFeM.bindClipPlane)(this._activeEffect, this, scene);
            this.bindEyePosition(effect);
        } else if (scene.getEngine()._features.needToAlwaysBindUniformBuffers) this._needToBindSceneUbo = true;
        if (mustRebind || !this.isFrozen) {
            // Lights
            if (scene.lightsEnabled && !this._disableLighting) (0, $alPCh.BindLights)(scene, mesh, this._activeEffect, defines, this._maxSimultaneousLights);
            // View
            if (scene.fogEnabled && mesh.applyFog && scene.fogMode !== (0, $gmbCk.Scene).FOGMODE_NONE || reflectionTexture || this.subSurface.refractionTexture || mesh.receiveShadows || defines.PREPASS) this.bindView(effect);
            // Fog
            (0, $alPCh.BindFogParameters)(scene, mesh, this._activeEffect, true);
            // Morph targets
            if (defines.NUM_MORPH_INFLUENCERS) (0, $alPCh.BindMorphTargetParameters)(mesh, this._activeEffect);
            if (defines.BAKED_VERTEX_ANIMATION_TEXTURE) mesh.bakedVertexAnimationManager?.bind(effect, defines.INSTANCES);
            // image processing
            this._imageProcessingConfiguration.bind(this._activeEffect);
            // Log. depth
            (0, $alPCh.BindLogDepth)(defines, this._activeEffect, scene);
        }
        this._afterBind(mesh, this._activeEffect, subMesh);
        ubo.update();
    }
    /**
     * Returns the animatable textures.
     * If material have animatable metallic texture, then reflectivity texture will not be returned, even if it has animations.
     * @returns - Array of animatable textures.
     */ getAnimatables() {
        const results = super.getAnimatables();
        if (this._albedoTexture && this._albedoTexture.animations && this._albedoTexture.animations.length > 0) results.push(this._albedoTexture);
        if (this._ambientTexture && this._ambientTexture.animations && this._ambientTexture.animations.length > 0) results.push(this._ambientTexture);
        if (this._opacityTexture && this._opacityTexture.animations && this._opacityTexture.animations.length > 0) results.push(this._opacityTexture);
        if (this._reflectionTexture && this._reflectionTexture.animations && this._reflectionTexture.animations.length > 0) results.push(this._reflectionTexture);
        if (this._emissiveTexture && this._emissiveTexture.animations && this._emissiveTexture.animations.length > 0) results.push(this._emissiveTexture);
        if (this._metallicTexture && this._metallicTexture.animations && this._metallicTexture.animations.length > 0) results.push(this._metallicTexture);
        else if (this._reflectivityTexture && this._reflectivityTexture.animations && this._reflectivityTexture.animations.length > 0) results.push(this._reflectivityTexture);
        if (this._bumpTexture && this._bumpTexture.animations && this._bumpTexture.animations.length > 0) results.push(this._bumpTexture);
        if (this._lightmapTexture && this._lightmapTexture.animations && this._lightmapTexture.animations.length > 0) results.push(this._lightmapTexture);
        if (this._metallicReflectanceTexture && this._metallicReflectanceTexture.animations && this._metallicReflectanceTexture.animations.length > 0) results.push(this._metallicReflectanceTexture);
        if (this._reflectanceTexture && this._reflectanceTexture.animations && this._reflectanceTexture.animations.length > 0) results.push(this._reflectanceTexture);
        if (this._microSurfaceTexture && this._microSurfaceTexture.animations && this._microSurfaceTexture.animations.length > 0) results.push(this._microSurfaceTexture);
        return results;
    }
    /**
     * Returns the texture used for reflections.
     * @returns - Reflection texture if present.  Otherwise, returns the environment texture.
     */ _getReflectionTexture() {
        if (this._reflectionTexture) return this._reflectionTexture;
        return this.getScene().environmentTexture;
    }
    /**
     * Returns an array of the actively used textures.
     * @returns - Array of BaseTextures
     */ getActiveTextures() {
        const activeTextures = super.getActiveTextures();
        if (this._albedoTexture) activeTextures.push(this._albedoTexture);
        if (this._ambientTexture) activeTextures.push(this._ambientTexture);
        if (this._opacityTexture) activeTextures.push(this._opacityTexture);
        if (this._reflectionTexture) activeTextures.push(this._reflectionTexture);
        if (this._emissiveTexture) activeTextures.push(this._emissiveTexture);
        if (this._reflectivityTexture) activeTextures.push(this._reflectivityTexture);
        if (this._metallicTexture) activeTextures.push(this._metallicTexture);
        if (this._metallicReflectanceTexture) activeTextures.push(this._metallicReflectanceTexture);
        if (this._reflectanceTexture) activeTextures.push(this._reflectanceTexture);
        if (this._microSurfaceTexture) activeTextures.push(this._microSurfaceTexture);
        if (this._bumpTexture) activeTextures.push(this._bumpTexture);
        if (this._lightmapTexture) activeTextures.push(this._lightmapTexture);
        return activeTextures;
    }
    /**
     * Checks to see if a texture is used in the material.
     * @param texture - Base texture to use.
     * @returns - Boolean specifying if a texture is used in the material.
     */ hasTexture(texture) {
        if (super.hasTexture(texture)) return true;
        if (this._albedoTexture === texture) return true;
        if (this._ambientTexture === texture) return true;
        if (this._opacityTexture === texture) return true;
        if (this._reflectionTexture === texture) return true;
        if (this._emissiveTexture === texture) return true;
        if (this._reflectivityTexture === texture) return true;
        if (this._metallicTexture === texture) return true;
        if (this._metallicReflectanceTexture === texture) return true;
        if (this._reflectanceTexture === texture) return true;
        if (this._microSurfaceTexture === texture) return true;
        if (this._bumpTexture === texture) return true;
        if (this._lightmapTexture === texture) return true;
        return false;
    }
    /**
     * Sets the required values to the prepass renderer.
     * It can't be sets when subsurface scattering of this material is disabled.
     * When scene have ability to enable subsurface prepass effect, it will enable.
     * @returns - If prepass is enabled or not.
     */ setPrePassRenderer() {
        if (!this.subSurface?.isScatteringEnabled) return false;
        const subSurfaceConfiguration = this.getScene().enableSubSurfaceForPrePass();
        if (subSurfaceConfiguration) subSurfaceConfiguration.enabled = true;
        return true;
    }
    /**
     * Disposes the resources of the material.
     * @param forceDisposeEffect - Forces the disposal of effects.
     * @param forceDisposeTextures - Forces the disposal of all textures.
     */ dispose(forceDisposeEffect, forceDisposeTextures) {
        if (forceDisposeTextures) {
            if (this._environmentBRDFTexture && this.getScene().environmentBRDFTexture !== this._environmentBRDFTexture) this._environmentBRDFTexture.dispose();
            this._albedoTexture?.dispose();
            this._ambientTexture?.dispose();
            this._opacityTexture?.dispose();
            this._reflectionTexture?.dispose();
            this._emissiveTexture?.dispose();
            this._metallicTexture?.dispose();
            this._reflectivityTexture?.dispose();
            this._bumpTexture?.dispose();
            this._lightmapTexture?.dispose();
            this._metallicReflectanceTexture?.dispose();
            this._reflectanceTexture?.dispose();
            this._microSurfaceTexture?.dispose();
        }
        this._renderTargets.dispose();
        if (this._imageProcessingConfiguration && this._imageProcessingObserver) this._imageProcessingConfiguration.onUpdateParameters.remove(this._imageProcessingObserver);
        super.dispose(forceDisposeEffect, forceDisposeTextures);
    }
}
/**
 * PBRMaterialTransparencyMode: No transparency mode, Alpha channel is not use.
 */ $36807acca6a085d5$export$a6012fe5a7d6699b.PBRMATERIAL_OPAQUE = (0, $54229.Material).MATERIAL_OPAQUE;
/**
 * PBRMaterialTransparencyMode: Alpha Test mode, pixel are discarded below a certain threshold defined by the alpha cutoff value.
 */ $36807acca6a085d5$export$a6012fe5a7d6699b.PBRMATERIAL_ALPHATEST = (0, $54229.Material).MATERIAL_ALPHATEST;
/**
 * PBRMaterialTransparencyMode: Pixels are blended (according to the alpha mode) with the already drawn pixels in the current frame buffer.
 */ $36807acca6a085d5$export$a6012fe5a7d6699b.PBRMATERIAL_ALPHABLEND = (0, $54229.Material).MATERIAL_ALPHABLEND;
/**
 * PBRMaterialTransparencyMode: Pixels are blended (according to the alpha mode) with the already drawn pixels in the current frame buffer.
 * They are also discarded below the alpha cutoff threshold to improve performances.
 */ $36807acca6a085d5$export$a6012fe5a7d6699b.PBRMATERIAL_ALPHATESTANDBLEND = (0, $54229.Material).MATERIAL_ALPHATESTANDBLEND;
/**
 * Defines the default value of how much AO map is occluding the analytical lights
 * (point spot...).
 */ $36807acca6a085d5$export$a6012fe5a7d6699b.DEFAULT_AO_ON_ANALYTICAL_LIGHTS = 0;
/**
 * PBRMaterialLightFalloff Physical: light is falling off following the inverse squared distance law.
 */ $36807acca6a085d5$export$a6012fe5a7d6699b.LIGHTFALLOFF_PHYSICAL = 0;
/**
 * PBRMaterialLightFalloff gltf: light is falling off as described in the gltf moving to PBR document
 * to enhance interoperability with other engines.
 */ $36807acca6a085d5$export$a6012fe5a7d6699b.LIGHTFALLOFF_GLTF = 1;
/**
 * PBRMaterialLightFalloff Standard: light is falling off like in the standard material
 * to enhance interoperability with other materials.
 */ $36807acca6a085d5$export$a6012fe5a7d6699b.LIGHTFALLOFF_STANDARD = 2;
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsImageProcessingConfiguration)()
], $36807acca6a085d5$export$a6012fe5a7d6699b.prototype, "_imageProcessingConfiguration", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsMiscDirty")
], $36807acca6a085d5$export$a6012fe5a7d6699b.prototype, "debugMode", void 0);

});
parcelRegister("5LMez", function(module, exports) {

$parcel$export(module.exports, "PBRBRDFConfiguration", () => $4336c1d1a5b6166b$export$e77ec6ad6c31c61b);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $35xmP = parcelRequire("35xmP");

var $8XNAC = parcelRequire("8XNAC");
class $4336c1d1a5b6166b$export$2c3306eb633669bf extends (0, $35xmP.MaterialDefines) {
    constructor(){
        super(...arguments);
        this.BRDF_V_HEIGHT_CORRELATED = false;
        this.MS_BRDF_ENERGY_CONSERVATION = false;
        this.SPHERICAL_HARMONICS = false;
        this.SPECULAR_GLOSSINESS_ENERGY_CONSERVATION = false;
    }
}
class $4336c1d1a5b6166b$export$e77ec6ad6c31c61b extends (0, $8XNAC.MaterialPluginBase) {
    /** @internal */ _markAllSubMeshesAsMiscDirty() {
        this._internalMarkAllSubMeshesAsMiscDirty();
    }
    constructor(material, addToPluginList = true){
        super(material, "PBRBRDF", 90, new $4336c1d1a5b6166b$export$2c3306eb633669bf(), addToPluginList);
        this._useEnergyConservation = $4336c1d1a5b6166b$export$e77ec6ad6c31c61b.DEFAULT_USE_ENERGY_CONSERVATION;
        /**
         * Defines if the material uses energy conservation.
         */ this.useEnergyConservation = $4336c1d1a5b6166b$export$e77ec6ad6c31c61b.DEFAULT_USE_ENERGY_CONSERVATION;
        this._useSmithVisibilityHeightCorrelated = $4336c1d1a5b6166b$export$e77ec6ad6c31c61b.DEFAULT_USE_SMITH_VISIBILITY_HEIGHT_CORRELATED;
        /**
         * LEGACY Mode set to false
         * Defines if the material uses height smith correlated visibility term.
         * If you intent to not use our default BRDF, you need to load a separate BRDF Texture for the PBR
         * You can either load https://assets.babylonjs.com/environments/uncorrelatedBRDF.png
         * or https://assets.babylonjs.com/environments/uncorrelatedBRDF.dds to have more precision
         * Not relying on height correlated will also disable energy conservation.
         */ this.useSmithVisibilityHeightCorrelated = $4336c1d1a5b6166b$export$e77ec6ad6c31c61b.DEFAULT_USE_SMITH_VISIBILITY_HEIGHT_CORRELATED;
        this._useSphericalHarmonics = $4336c1d1a5b6166b$export$e77ec6ad6c31c61b.DEFAULT_USE_SPHERICAL_HARMONICS;
        /**
         * LEGACY Mode set to false
         * Defines if the material uses spherical harmonics vs spherical polynomials for the
         * diffuse part of the IBL.
         * The harmonics despite a tiny bigger cost has been proven to provide closer results
         * to the ground truth.
         */ this.useSphericalHarmonics = $4336c1d1a5b6166b$export$e77ec6ad6c31c61b.DEFAULT_USE_SPHERICAL_HARMONICS;
        this._useSpecularGlossinessInputEnergyConservation = $4336c1d1a5b6166b$export$e77ec6ad6c31c61b.DEFAULT_USE_SPECULAR_GLOSSINESS_INPUT_ENERGY_CONSERVATION;
        /**
         * Defines if the material uses energy conservation, when the specular workflow is active.
         * If activated, the albedo color is multiplied with (1. - maxChannel(specular color)).
         * If deactivated, a material is only physically plausible, when (albedo color + specular color) < 1.
         * In the deactivated case, the material author has to ensure energy conservation, for a physically plausible rendering.
         */ this.useSpecularGlossinessInputEnergyConservation = $4336c1d1a5b6166b$export$e77ec6ad6c31c61b.DEFAULT_USE_SPECULAR_GLOSSINESS_INPUT_ENERGY_CONSERVATION;
        this._internalMarkAllSubMeshesAsMiscDirty = material._dirtyCallbacks[16];
        this._enable(true);
    }
    prepareDefines(defines) {
        defines.BRDF_V_HEIGHT_CORRELATED = this._useSmithVisibilityHeightCorrelated;
        defines.MS_BRDF_ENERGY_CONSERVATION = this._useEnergyConservation && this._useSmithVisibilityHeightCorrelated;
        defines.SPHERICAL_HARMONICS = this._useSphericalHarmonics;
        defines.SPECULAR_GLOSSINESS_ENERGY_CONSERVATION = this._useSpecularGlossinessInputEnergyConservation;
    }
    getClassName() {
        return "PBRBRDFConfiguration";
    }
}
/**
 * Default value used for the energy conservation.
 * This should only be changed to adapt to the type of texture in scene.environmentBRDFTexture.
 */ $4336c1d1a5b6166b$export$e77ec6ad6c31c61b.DEFAULT_USE_ENERGY_CONSERVATION = true;
/**
 * Default value used for the Smith Visibility Height Correlated mode.
 * This should only be changed to adapt to the type of texture in scene.environmentBRDFTexture.
 */ $4336c1d1a5b6166b$export$e77ec6ad6c31c61b.DEFAULT_USE_SMITH_VISIBILITY_HEIGHT_CORRELATED = true;
/**
 * Default value used for the IBL diffuse part.
 * This can help switching back to the polynomials mode globally which is a tiny bit
 * less GPU intensive at the drawback of a lower quality.
 */ $4336c1d1a5b6166b$export$e77ec6ad6c31c61b.DEFAULT_USE_SPHERICAL_HARMONICS = true;
/**
 * Default value used for activating energy conservation for the specular workflow.
 * If activated, the albedo color is multiplied with (1. - maxChannel(specular color)).
 * If deactivated, a material is only physically plausible, when (albedo color + specular color) < 1.
 */ $4336c1d1a5b6166b$export$e77ec6ad6c31c61b.DEFAULT_USE_SPECULAR_GLOSSINESS_INPUT_ENERGY_CONSERVATION = true;
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsMiscDirty")
], $4336c1d1a5b6166b$export$e77ec6ad6c31c61b.prototype, "useEnergyConservation", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsMiscDirty")
], $4336c1d1a5b6166b$export$e77ec6ad6c31c61b.prototype, "useSmithVisibilityHeightCorrelated", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsMiscDirty")
], $4336c1d1a5b6166b$export$e77ec6ad6c31c61b.prototype, "useSphericalHarmonics", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsMiscDirty")
], $4336c1d1a5b6166b$export$e77ec6ad6c31c61b.prototype, "useSpecularGlossinessInputEnergyConservation", void 0);

});

parcelRegister("9K5SJ", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("aYEjM");
parcelRequire("7RpqZ");
parcelRequire("jLZ0e");
parcelRequire("8nfQe");
parcelRequire("l9yC5");
parcelRequire("7UkOz");
parcelRequire("gi9Sf");
parcelRequire("6RB1l");
parcelRequire("jtwq6");
parcelRequire("82O8L");
parcelRequire("4kipo");
parcelRequire("hvLF9");
parcelRequire("7Hs3g");
parcelRequire("OMx8e");
parcelRequire("fsNb6");
parcelRequire("f3ISH");
parcelRequire("cRFSM");
parcelRequire("lcI5C");
parcelRequire("hYOZS");
parcelRequire("c6yXF");
parcelRequire("2s0nq");
parcelRequire("bzdhG");
parcelRequire("aqaLg");
parcelRequire("8e2nm");
parcelRequire("3quE9");
parcelRequire("lnIOB");
parcelRequire("2KL02");
parcelRequire("6vG1y");
parcelRequire("fb4Jc");
parcelRequire("3xnAu");
parcelRequire("9L9o4");
parcelRequire("3bYfn");
parcelRequire("b4A2m");
parcelRequire("f3wp7");
parcelRequire("klCsf");
parcelRequire("kqYVA");
parcelRequire("9w3jT");
parcelRequire("k80c5");
parcelRequire("kg1CD");
parcelRequire("aaBxW");
parcelRequire("F4hvB");
parcelRequire("0TQE0");
parcelRequire("6bTUi");
parcelRequire("8cEpV");
parcelRequire("91ZzO");
parcelRequire("atIdy");
parcelRequire("gjTSR");
parcelRequire("1MYsb");
parcelRequire("4ycgE");
parcelRequire("cFZt2");
parcelRequire("5xWDR");
parcelRequire("1a7pD");
parcelRequire("izyqw");
parcelRequire("110hr");
parcelRequire("ccq4Y");
parcelRequire("b21vU");
parcelRequire("iKGGz");
const $717cf8ed3013d763$var$name = "pbrPixelShader";
const $717cf8ed3013d763$var$shader = `#if defined(BUMP) || !defined(NORMAL) || defined(FORCENORMALFORWARD) || defined(SPECULARAA) || defined(CLEARCOAT_BUMP) || defined(ANISOTROPIC)
#extension GL_OES_standard_derivatives : enable
#endif
#ifdef LODBASEDMICROSFURACE
#extension GL_EXT_shader_texture_lod : enable
#endif
#define CUSTOM_FRAGMENT_BEGIN
#ifdef LOGARITHMICDEPTH
#extension GL_EXT_frag_depth : enable
#endif
#include<prePassDeclaration>[SCENE_MRT_COUNT]
precision highp float;
#include<oitDeclaration>
#ifndef FROMLINEARSPACE
#define FROMLINEARSPACE
#endif
#include<__decl__pbrFragment>
#include<pbrFragmentExtraDeclaration>
#include<__decl__lightFragment>[0..maxSimultaneousLights]
#include<pbrFragmentSamplersDeclaration>
#include<imageProcessingDeclaration>
#include<clipPlaneFragmentDeclaration>
#include<logDepthDeclaration>
#include<fogFragmentDeclaration>
#include<helperFunctions>
#include<subSurfaceScatteringFunctions>
#include<importanceSampling>
#include<pbrHelperFunctions>
#include<imageProcessingFunctions>
#include<shadowsFragmentFunctions>
#include<harmonicsFunctions>
#include<pbrDirectLightingSetupFunctions>
#include<pbrDirectLightingFalloffFunctions>
#include<pbrBRDFFunctions>
#include<hdrFilteringFunctions>
#include<pbrDirectLightingFunctions>
#include<pbrIBLFunctions>
#include<bumpFragmentMainFunctions>
#include<bumpFragmentFunctions>
#ifdef REFLECTION
#include<reflectionFunction>
#endif
#define CUSTOM_FRAGMENT_DEFINITIONS
#include<pbrBlockAlbedoOpacity>
#include<pbrBlockReflectivity>
#include<pbrBlockAmbientOcclusion>
#include<pbrBlockAlphaFresnel>
#include<pbrBlockAnisotropic>
#include<pbrBlockReflection>
#include<pbrBlockSheen>
#include<pbrBlockClearcoat>
#include<pbrBlockIridescence>
#include<pbrBlockSubSurface>
void main(void) {
#define CUSTOM_FRAGMENT_MAIN_BEGIN
#include<clipPlaneFragment>
#include<pbrBlockNormalGeometric>
#include<bumpFragment>
#include<pbrBlockNormalFinal>
albedoOpacityOutParams albedoOpacityOut;
#ifdef ALBEDO
vec4 albedoTexture=texture2D(albedoSampler,vAlbedoUV+uvOffset);
#endif
#ifdef OPACITY
vec4 opacityMap=texture2D(opacitySampler,vOpacityUV+uvOffset);
#endif
#ifdef DECAL
vec4 decalColor=texture2D(decalSampler,vDecalUV+uvOffset);
#endif
albedoOpacityBlock(
vAlbedoColor,
#ifdef ALBEDO
albedoTexture,
vAlbedoInfos,
#endif
#ifdef OPACITY
opacityMap,
vOpacityInfos,
#endif
#ifdef DETAIL
detailColor,
vDetailInfos,
#endif
#ifdef DECAL
decalColor,
vDecalInfos,
#endif
albedoOpacityOut
);vec3 surfaceAlbedo=albedoOpacityOut.surfaceAlbedo;float alpha=albedoOpacityOut.alpha;
#define CUSTOM_FRAGMENT_UPDATE_ALPHA
#include<depthPrePass>
#define CUSTOM_FRAGMENT_BEFORE_LIGHTS
ambientOcclusionOutParams aoOut;
#ifdef AMBIENT
vec3 ambientOcclusionColorMap=texture2D(ambientSampler,vAmbientUV+uvOffset).rgb;
#endif
ambientOcclusionBlock(
#ifdef AMBIENT
ambientOcclusionColorMap,
vAmbientInfos,
#endif
aoOut
);
#include<pbrBlockLightmapInit>
#ifdef UNLIT
vec3 diffuseBase=vec3(1.,1.,1.);
#else
vec3 baseColor=surfaceAlbedo;reflectivityOutParams reflectivityOut;
#if defined(REFLECTIVITY)
vec4 surfaceMetallicOrReflectivityColorMap=texture2D(reflectivitySampler,vReflectivityUV+uvOffset);vec4 baseReflectivity=surfaceMetallicOrReflectivityColorMap;
#ifndef METALLICWORKFLOW
#ifdef REFLECTIVITY_GAMMA
surfaceMetallicOrReflectivityColorMap=toLinearSpace(surfaceMetallicOrReflectivityColorMap);
#endif
surfaceMetallicOrReflectivityColorMap.rgb*=vReflectivityInfos.y;
#endif
#endif
#if defined(MICROSURFACEMAP)
vec4 microSurfaceTexel=texture2D(microSurfaceSampler,vMicroSurfaceSamplerUV+uvOffset)*vMicroSurfaceSamplerInfos.y;
#endif
#ifdef METALLICWORKFLOW
vec4 metallicReflectanceFactors=vMetallicReflectanceFactors;
#ifdef REFLECTANCE
vec4 reflectanceFactorsMap=texture2D(reflectanceSampler,vReflectanceUV+uvOffset);
#ifdef REFLECTANCE_GAMMA
reflectanceFactorsMap=toLinearSpace(reflectanceFactorsMap);
#endif
metallicReflectanceFactors.rgb*=reflectanceFactorsMap.rgb;
#endif
#ifdef METALLIC_REFLECTANCE
vec4 metallicReflectanceFactorsMap=texture2D(metallicReflectanceSampler,vMetallicReflectanceUV+uvOffset);
#ifdef METALLIC_REFLECTANCE_GAMMA
metallicReflectanceFactorsMap=toLinearSpace(metallicReflectanceFactorsMap);
#endif
#ifndef METALLIC_REFLECTANCE_USE_ALPHA_ONLY
metallicReflectanceFactors.rgb*=metallicReflectanceFactorsMap.rgb;
#endif
metallicReflectanceFactors*=metallicReflectanceFactorsMap.a;
#endif
#endif
reflectivityBlock(
vReflectivityColor,
#ifdef METALLICWORKFLOW
surfaceAlbedo,
metallicReflectanceFactors,
#endif
#ifdef REFLECTIVITY
vReflectivityInfos,
surfaceMetallicOrReflectivityColorMap,
#endif
#if defined(METALLICWORKFLOW) && defined(REFLECTIVITY) && defined(AOSTOREINMETALMAPRED)
aoOut.ambientOcclusionColor,
#endif
#ifdef MICROSURFACEMAP
microSurfaceTexel,
#endif
#ifdef DETAIL
detailColor,
vDetailInfos,
#endif
reflectivityOut
);float microSurface=reflectivityOut.microSurface;float roughness=reflectivityOut.roughness;
#ifdef METALLICWORKFLOW
surfaceAlbedo=reflectivityOut.surfaceAlbedo;
#endif
#if defined(METALLICWORKFLOW) && defined(REFLECTIVITY) && defined(AOSTOREINMETALMAPRED)
aoOut.ambientOcclusionColor=reflectivityOut.ambientOcclusionColor;
#endif
#ifdef ALPHAFRESNEL
#if defined(ALPHATEST) || defined(ALPHABLEND)
alphaFresnelOutParams alphaFresnelOut;alphaFresnelBlock(
normalW,
viewDirectionW,
alpha,
microSurface,
alphaFresnelOut
);alpha=alphaFresnelOut.alpha;
#endif
#endif
#include<pbrBlockGeometryInfo>
#ifdef ANISOTROPIC
anisotropicOutParams anisotropicOut;
#ifdef ANISOTROPIC_TEXTURE
vec3 anisotropyMapData=texture2D(anisotropySampler,vAnisotropyUV+uvOffset).rgb*vAnisotropyInfos.y;
#endif
anisotropicBlock(
vAnisotropy,
roughness,
#ifdef ANISOTROPIC_TEXTURE
anisotropyMapData,
#endif
TBN,
normalW,
viewDirectionW,
anisotropicOut
);
#endif
#ifdef REFLECTION
reflectionOutParams reflectionOut;
#ifndef USE_CUSTOM_REFLECTION
reflectionBlock(
vPositionW,
normalW,
alphaG,
vReflectionMicrosurfaceInfos,
vReflectionInfos,
vReflectionColor,
#ifdef ANISOTROPIC
anisotropicOut,
#endif
#if defined(LODINREFLECTIONALPHA) && !defined(REFLECTIONMAP_SKYBOX)
NdotVUnclamped,
#endif
#ifdef LINEARSPECULARREFLECTION
roughness,
#endif
reflectionSampler,
#if defined(NORMAL) && defined(USESPHERICALINVERTEX)
vEnvironmentIrradiance,
#endif
#ifdef USESPHERICALFROMREFLECTIONMAP
#if !defined(NORMAL) || !defined(USESPHERICALINVERTEX)
reflectionMatrix,
#endif
#endif
#ifdef USEIRRADIANCEMAP
irradianceSampler,
#endif
#ifndef LODBASEDMICROSFURACE
reflectionSamplerLow,
reflectionSamplerHigh,
#endif
#ifdef REALTIME_FILTERING
vReflectionFilteringInfo,
#endif
reflectionOut
);
#else
#define CUSTOM_REFLECTION
#endif
#endif
#include<pbrBlockReflectance0>
#ifdef SHEEN
sheenOutParams sheenOut;
#ifdef SHEEN_TEXTURE
vec4 sheenMapData=texture2D(sheenSampler,vSheenUV+uvOffset);
#endif
#if defined(SHEEN_ROUGHNESS) && defined(SHEEN_TEXTURE_ROUGHNESS) && !defined(SHEEN_TEXTURE_ROUGHNESS_IDENTICAL) && !defined(SHEEN_USE_ROUGHNESS_FROM_MAINTEXTURE)
vec4 sheenMapRoughnessData=texture2D(sheenRoughnessSampler,vSheenRoughnessUV+uvOffset)*vSheenInfos.w;
#endif
sheenBlock(
vSheenColor,
#ifdef SHEEN_ROUGHNESS
vSheenRoughness,
#if defined(SHEEN_TEXTURE_ROUGHNESS) && !defined(SHEEN_TEXTURE_ROUGHNESS_IDENTICAL) && !defined(SHEEN_USE_ROUGHNESS_FROM_MAINTEXTURE)
sheenMapRoughnessData,
#endif
#endif
roughness,
#ifdef SHEEN_TEXTURE
sheenMapData,
vSheenInfos.y,
#endif
reflectance,
#ifdef SHEEN_LINKWITHALBEDO
baseColor,
surfaceAlbedo,
#endif
#ifdef ENVIRONMENTBRDF
NdotV,
environmentBrdf,
#endif
#if defined(REFLECTION) && defined(ENVIRONMENTBRDF)
AARoughnessFactors,
vReflectionMicrosurfaceInfos,
vReflectionInfos,
vReflectionColor,
vLightingIntensity,
reflectionSampler,
reflectionOut.reflectionCoords,
NdotVUnclamped,
#ifndef LODBASEDMICROSFURACE
reflectionSamplerLow,
reflectionSamplerHigh,
#endif
#ifdef REALTIME_FILTERING
vReflectionFilteringInfo,
#endif
#if !defined(REFLECTIONMAP_SKYBOX) && defined(RADIANCEOCCLUSION)
seo,
#endif
#if !defined(REFLECTIONMAP_SKYBOX) && defined(HORIZONOCCLUSION) && defined(BUMP) && defined(REFLECTIONMAP_3D)
eho,
#endif
#endif
sheenOut
);
#ifdef SHEEN_LINKWITHALBEDO
surfaceAlbedo=sheenOut.surfaceAlbedo;
#endif
#endif
#ifdef CLEARCOAT
#ifdef CLEARCOAT_TEXTURE
vec2 clearCoatMapData=texture2D(clearCoatSampler,vClearCoatUV+uvOffset).rg*vClearCoatInfos.y;
#endif
#endif
#ifdef IRIDESCENCE
iridescenceOutParams iridescenceOut;
#ifdef IRIDESCENCE_TEXTURE
vec2 iridescenceMapData=texture2D(iridescenceSampler,vIridescenceUV+uvOffset).rg*vIridescenceInfos.y;
#endif
#ifdef IRIDESCENCE_THICKNESS_TEXTURE
vec2 iridescenceThicknessMapData=texture2D(iridescenceThicknessSampler,vIridescenceThicknessUV+uvOffset).rg*vIridescenceInfos.w;
#endif
iridescenceBlock(
vIridescenceParams,
NdotV,
specularEnvironmentR0,
#ifdef IRIDESCENCE_TEXTURE
iridescenceMapData,
#endif
#ifdef IRIDESCENCE_THICKNESS_TEXTURE
iridescenceThicknessMapData,
#endif
#ifdef CLEARCOAT
NdotVUnclamped,
#ifdef CLEARCOAT_TEXTURE
clearCoatMapData,
#endif
#endif
iridescenceOut
);float iridescenceIntensity=iridescenceOut.iridescenceIntensity;specularEnvironmentR0=iridescenceOut.specularEnvironmentR0;
#endif
clearcoatOutParams clearcoatOut;
#ifdef CLEARCOAT
#if defined(CLEARCOAT_TEXTURE_ROUGHNESS) && !defined(CLEARCOAT_TEXTURE_ROUGHNESS_IDENTICAL) && !defined(CLEARCOAT_USE_ROUGHNESS_FROM_MAINTEXTURE)
vec4 clearCoatMapRoughnessData=texture2D(clearCoatRoughnessSampler,vClearCoatRoughnessUV+uvOffset)*vClearCoatInfos.w;
#endif
#if defined(CLEARCOAT_TINT) && defined(CLEARCOAT_TINT_TEXTURE)
vec4 clearCoatTintMapData=texture2D(clearCoatTintSampler,vClearCoatTintUV+uvOffset);
#endif
#ifdef CLEARCOAT_BUMP
vec4 clearCoatBumpMapData=texture2D(clearCoatBumpSampler,vClearCoatBumpUV+uvOffset);
#endif
clearcoatBlock(
vPositionW,
geometricNormalW,
viewDirectionW,
vClearCoatParams,
#if defined(CLEARCOAT_TEXTURE_ROUGHNESS) && !defined(CLEARCOAT_TEXTURE_ROUGHNESS_IDENTICAL) && !defined(CLEARCOAT_USE_ROUGHNESS_FROM_MAINTEXTURE)
clearCoatMapRoughnessData,
#endif
specularEnvironmentR0,
#ifdef CLEARCOAT_TEXTURE
clearCoatMapData,
#endif
#ifdef CLEARCOAT_TINT
vClearCoatTintParams,
clearCoatColorAtDistance,
vClearCoatRefractionParams,
#ifdef CLEARCOAT_TINT_TEXTURE
clearCoatTintMapData,
#endif
#endif
#ifdef CLEARCOAT_BUMP
vClearCoatBumpInfos,
clearCoatBumpMapData,
vClearCoatBumpUV,
#if defined(TANGENT) && defined(NORMAL)
vTBN,
#else
vClearCoatTangentSpaceParams,
#endif
#ifdef OBJECTSPACE_NORMALMAP
normalMatrix,
#endif
#endif
#if defined(FORCENORMALFORWARD) && defined(NORMAL)
faceNormal,
#endif
#ifdef REFLECTION
vReflectionMicrosurfaceInfos,
vReflectionInfos,
vReflectionColor,
vLightingIntensity,
reflectionSampler,
#ifndef LODBASEDMICROSFURACE
reflectionSamplerLow,
reflectionSamplerHigh,
#endif
#ifdef REALTIME_FILTERING
vReflectionFilteringInfo,
#endif
#endif
#if defined(ENVIRONMENTBRDF) && !defined(REFLECTIONMAP_SKYBOX)
#ifdef RADIANCEOCCLUSION
ambientMonochrome,
#endif
#endif
#if defined(CLEARCOAT_BUMP) || defined(TWOSIDEDLIGHTING)
(gl_FrontFacing ? 1. : -1.),
#endif
clearcoatOut
);
#else
clearcoatOut.specularEnvironmentR0=specularEnvironmentR0;
#endif
#include<pbrBlockReflectance>
subSurfaceOutParams subSurfaceOut;
#ifdef SUBSURFACE
#ifdef SS_THICKNESSANDMASK_TEXTURE
vec4 thicknessMap=texture2D(thicknessSampler,vThicknessUV+uvOffset);
#endif
#ifdef SS_REFRACTIONINTENSITY_TEXTURE
vec4 refractionIntensityMap=texture2D(refractionIntensitySampler,vRefractionIntensityUV+uvOffset);
#endif
#ifdef SS_TRANSLUCENCYINTENSITY_TEXTURE
vec4 translucencyIntensityMap=texture2D(translucencyIntensitySampler,vTranslucencyIntensityUV+uvOffset);
#endif
subSurfaceBlock(
vSubSurfaceIntensity,
vThicknessParam,
vTintColor,
normalW,
specularEnvironmentReflectance,
#ifdef SS_THICKNESSANDMASK_TEXTURE
thicknessMap,
#endif
#ifdef SS_REFRACTIONINTENSITY_TEXTURE
refractionIntensityMap,
#endif
#ifdef SS_TRANSLUCENCYINTENSITY_TEXTURE
translucencyIntensityMap,
#endif
#ifdef REFLECTION
#ifdef SS_TRANSLUCENCY
reflectionMatrix,
#ifdef USESPHERICALFROMREFLECTIONMAP
#if !defined(NORMAL) || !defined(USESPHERICALINVERTEX)
reflectionOut.irradianceVector,
#endif
#if defined(REALTIME_FILTERING)
reflectionSampler,
vReflectionFilteringInfo,
#endif
#endif
#ifdef USEIRRADIANCEMAP
irradianceSampler,
#endif
#endif
#endif
#if defined(SS_REFRACTION) || defined(SS_TRANSLUCENCY)
surfaceAlbedo,
#endif
#ifdef SS_REFRACTION
vPositionW,
viewDirectionW,
view,
vRefractionInfos,
refractionMatrix,
vRefractionMicrosurfaceInfos,
vLightingIntensity,
#ifdef SS_LINKREFRACTIONTOTRANSPARENCY
alpha,
#endif
#ifdef SS_LODINREFRACTIONALPHA
NdotVUnclamped,
#endif
#ifdef SS_LINEARSPECULARREFRACTION
roughness,
#endif
alphaG,
refractionSampler,
#ifndef LODBASEDMICROSFURACE
refractionSamplerLow,
refractionSamplerHigh,
#endif
#ifdef ANISOTROPIC
anisotropicOut,
#endif
#ifdef REALTIME_FILTERING
vRefractionFilteringInfo,
#endif
#ifdef SS_USE_LOCAL_REFRACTIONMAP_CUBIC
vRefractionPosition,
vRefractionSize,
#endif
#ifdef SS_DISPERSION
dispersion,
#endif
#endif
#ifdef SS_TRANSLUCENCY
vDiffusionDistance,
#endif
subSurfaceOut
);
#ifdef SS_REFRACTION
surfaceAlbedo=subSurfaceOut.surfaceAlbedo;
#ifdef SS_LINKREFRACTIONTOTRANSPARENCY
alpha=subSurfaceOut.alpha;
#endif
#endif
#else
subSurfaceOut.specularEnvironmentReflectance=specularEnvironmentReflectance;
#endif
#include<pbrBlockDirectLighting>
#include<lightFragment>[0..maxSimultaneousLights]
#include<pbrBlockFinalLitComponents>
#endif 
#include<pbrBlockFinalUnlitComponents>
#define CUSTOM_FRAGMENT_BEFORE_FINALCOLORCOMPOSITION
#include<pbrBlockFinalColorComposition>
#include<logDepthFragment>
#include<fogFragment>(color,finalColor)
#include<pbrBlockImageProcessing>
#define CUSTOM_FRAGMENT_BEFORE_FRAGCOLOR
#ifdef PREPASS
float writeGeometryInfo=finalColor.a>0.4 ? 1.0 : 0.0;
#ifdef PREPASS_POSITION
gl_FragData[PREPASS_POSITION_INDEX]=vec4(vPositionW,writeGeometryInfo);
#endif
#ifdef PREPASS_VELOCITY
vec2 a=(vCurrentPosition.xy/vCurrentPosition.w)*0.5+0.5;vec2 b=(vPreviousPosition.xy/vPreviousPosition.w)*0.5+0.5;vec2 velocity=abs(a-b);velocity=vec2(pow(velocity.x,1.0/3.0),pow(velocity.y,1.0/3.0))*sign(a-b)*0.5+0.5;gl_FragData[PREPASS_VELOCITY_INDEX]=vec4(velocity,0.0,writeGeometryInfo);
#endif
#ifdef PREPASS_ALBEDO_SQRT
vec3 sqAlbedo=sqrt(surfaceAlbedo); 
#endif
#ifdef PREPASS_IRRADIANCE
vec3 irradiance=finalDiffuse;
#ifndef UNLIT
#ifdef REFLECTION
irradiance+=finalIrradiance;
#endif
#endif
#ifdef SS_SCATTERING
gl_FragData[0]=vec4(finalColor.rgb-irradiance,finalColor.a); 
irradiance/=sqAlbedo;
#else
gl_FragData[0]=finalColor; 
float scatteringDiffusionProfile=255.;
#endif
gl_FragData[PREPASS_IRRADIANCE_INDEX]=vec4(clamp(irradiance,vec3(0.),vec3(1.)),writeGeometryInfo*scatteringDiffusionProfile/255.); 
#else
gl_FragData[0]=vec4(finalColor.rgb,finalColor.a);
#endif
#ifdef PREPASS_DEPTH
gl_FragData[PREPASS_DEPTH_INDEX]=vec4(vViewPos.z,0.0,0.0,writeGeometryInfo); 
#endif
#ifdef PREPASS_NORMAL
#ifdef PREPASS_NORMAL_WORLDSPACE
gl_FragData[PREPASS_NORMAL_INDEX]=vec4(normalW,writeGeometryInfo); 
#else
gl_FragData[PREPASS_NORMAL_INDEX]=vec4(normalize((view*vec4(normalW,0.0)).rgb),writeGeometryInfo); 
#endif
#endif
#ifdef PREPASS_ALBEDO_SQRT
gl_FragData[PREPASS_ALBEDO_SQRT_INDEX]=vec4(sqAlbedo,writeGeometryInfo); 
#endif
#ifdef PREPASS_REFLECTIVITY
#ifndef UNLIT
gl_FragData[PREPASS_REFLECTIVITY_INDEX]=vec4(specularEnvironmentR0,microSurface)*writeGeometryInfo;
#else
gl_FragData[PREPASS_REFLECTIVITY_INDEX]=vec4( 0.0,0.0,0.0,1.0 )*writeGeometryInfo;
#endif
#endif
#endif
#if !defined(PREPASS) || defined(WEBGL2)
gl_FragColor=finalColor;
#endif
#include<oitFragment>
#if ORDER_INDEPENDENT_TRANSPARENCY
if (fragDepth==nearestDepth) {frontColor.rgb+=finalColor.rgb*finalColor.a*alphaMultiplier;frontColor.a=1.0-alphaMultiplier*(1.0-finalColor.a);} else {backColor+=finalColor;}
#endif
#include<pbrDebug>
#define CUSTOM_FRAGMENT_MAIN_END
}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$717cf8ed3013d763$var$name] = $717cf8ed3013d763$var$shader;
const $717cf8ed3013d763$export$16feffb086adb998 = {
    name: $717cf8ed3013d763$var$name,
    shader: $717cf8ed3013d763$var$shader
};

});
parcelRegister("jLZ0e", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("hbX2w");
const $e651ba013d40a874$var$name = "pbrFragmentDeclaration";
const $e651ba013d40a874$var$shader = `uniform vec4 vEyePosition;uniform vec3 vReflectionColor;uniform vec4 vAlbedoColor;uniform vec4 vLightingIntensity;uniform vec4 vReflectivityColor;uniform vec4 vMetallicReflectanceFactors;uniform vec3 vEmissiveColor;uniform float visibility;uniform vec3 vAmbientColor;
#ifdef ALBEDO
uniform vec2 vAlbedoInfos;
#endif
#ifdef AMBIENT
uniform vec4 vAmbientInfos;
#endif
#ifdef BUMP
uniform vec3 vBumpInfos;uniform vec2 vTangentSpaceParams;
#endif
#ifdef OPACITY
uniform vec2 vOpacityInfos;
#endif
#ifdef EMISSIVE
uniform vec2 vEmissiveInfos;
#endif
#ifdef LIGHTMAP
uniform vec2 vLightmapInfos;
#endif
#ifdef REFLECTIVITY
uniform vec3 vReflectivityInfos;
#endif
#ifdef MICROSURFACEMAP
uniform vec2 vMicroSurfaceSamplerInfos;
#endif
#if defined(REFLECTIONMAP_SPHERICAL) || defined(REFLECTIONMAP_PROJECTION) || defined(SS_REFRACTION) || defined(PREPASS)
uniform mat4 view;
#endif
#ifdef REFLECTION
uniform vec2 vReflectionInfos;
#ifdef REALTIME_FILTERING
uniform vec2 vReflectionFilteringInfo;
#endif
uniform mat4 reflectionMatrix;uniform vec3 vReflectionMicrosurfaceInfos;
#if defined(USE_LOCAL_REFLECTIONMAP_CUBIC) && defined(REFLECTIONMAP_CUBIC)
uniform vec3 vReflectionPosition;uniform vec3 vReflectionSize; 
#endif
#endif
#if defined(SS_REFRACTION) && defined(SS_USE_LOCAL_REFRACTIONMAP_CUBIC)
uniform vec3 vRefractionPosition;uniform vec3 vRefractionSize; 
#endif
#ifdef CLEARCOAT
uniform vec2 vClearCoatParams;uniform vec4 vClearCoatRefractionParams;
#if defined(CLEARCOAT_TEXTURE) || defined(CLEARCOAT_TEXTURE_ROUGHNESS)
uniform vec4 vClearCoatInfos;
#endif
#ifdef CLEARCOAT_TEXTURE
uniform mat4 clearCoatMatrix;
#endif
#ifdef CLEARCOAT_TEXTURE_ROUGHNESS
uniform mat4 clearCoatRoughnessMatrix;
#endif
#ifdef CLEARCOAT_BUMP
uniform vec2 vClearCoatBumpInfos;uniform vec2 vClearCoatTangentSpaceParams;uniform mat4 clearCoatBumpMatrix;
#endif
#ifdef CLEARCOAT_TINT
uniform vec4 vClearCoatTintParams;uniform float clearCoatColorAtDistance;
#ifdef CLEARCOAT_TINT_TEXTURE
uniform vec2 vClearCoatTintInfos;uniform mat4 clearCoatTintMatrix;
#endif
#endif
#endif
#ifdef IRIDESCENCE
uniform vec4 vIridescenceParams;
#if defined(IRIDESCENCE_TEXTURE) || defined(IRIDESCENCE_THICKNESS_TEXTURE)
uniform vec4 vIridescenceInfos;
#endif
#ifdef IRIDESCENCE_TEXTURE
uniform mat4 iridescenceMatrix;
#endif
#ifdef IRIDESCENCE_THICKNESS_TEXTURE
uniform mat4 iridescenceThicknessMatrix;
#endif
#endif
#ifdef ANISOTROPIC
uniform vec3 vAnisotropy;
#ifdef ANISOTROPIC_TEXTURE
uniform vec2 vAnisotropyInfos;uniform mat4 anisotropyMatrix;
#endif
#endif
#ifdef SHEEN
uniform vec4 vSheenColor;
#ifdef SHEEN_ROUGHNESS
uniform float vSheenRoughness;
#endif
#if defined(SHEEN_TEXTURE) || defined(SHEEN_TEXTURE_ROUGHNESS)
uniform vec4 vSheenInfos;
#endif
#ifdef SHEEN_TEXTURE
uniform mat4 sheenMatrix;
#endif
#ifdef SHEEN_TEXTURE_ROUGHNESS
uniform mat4 sheenRoughnessMatrix;
#endif
#endif
#ifdef SUBSURFACE
#ifdef SS_REFRACTION
uniform vec4 vRefractionMicrosurfaceInfos;uniform vec4 vRefractionInfos;uniform mat4 refractionMatrix;
#ifdef REALTIME_FILTERING
uniform vec2 vRefractionFilteringInfo;
#endif
#ifdef SS_DISPERSION
uniform float dispersion;
#endif
#endif
#ifdef SS_THICKNESSANDMASK_TEXTURE
uniform vec2 vThicknessInfos;uniform mat4 thicknessMatrix;
#endif
#ifdef SS_REFRACTIONINTENSITY_TEXTURE
uniform vec2 vRefractionIntensityInfos;uniform mat4 refractionIntensityMatrix;
#endif
#ifdef SS_TRANSLUCENCYINTENSITY_TEXTURE
uniform vec2 vTranslucencyIntensityInfos;uniform mat4 translucencyIntensityMatrix;
#endif
uniform vec2 vThicknessParam;uniform vec3 vDiffusionDistance;uniform vec4 vTintColor;uniform vec3 vSubSurfaceIntensity;
#endif
#ifdef PREPASS
#ifdef SS_SCATTERING
uniform float scatteringDiffusionProfile;
#endif
#endif
#if DEBUGMODE>0
uniform vec2 vDebugMode;
#endif
#ifdef DETAIL
uniform vec4 vDetailInfos;
#endif
#include<decalFragmentDeclaration>
#ifdef USESPHERICALFROMREFLECTIONMAP
#ifdef SPHERICAL_HARMONICS
uniform vec3 vSphericalL00;uniform vec3 vSphericalL1_1;uniform vec3 vSphericalL10;uniform vec3 vSphericalL11;uniform vec3 vSphericalL2_2;uniform vec3 vSphericalL2_1;uniform vec3 vSphericalL20;uniform vec3 vSphericalL21;uniform vec3 vSphericalL22;
#else
uniform vec3 vSphericalX;uniform vec3 vSphericalY;uniform vec3 vSphericalZ;uniform vec3 vSphericalXX_ZZ;uniform vec3 vSphericalYY_ZZ;uniform vec3 vSphericalZZ;uniform vec3 vSphericalXY;uniform vec3 vSphericalYZ;uniform vec3 vSphericalZX;
#endif
#endif
#define ADDITIONAL_FRAGMENT_DECLARATION
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$e651ba013d40a874$var$name] = $e651ba013d40a874$var$shader;
const $e651ba013d40a874$export$59b94334ffe302d0 = {
    name: $e651ba013d40a874$var$name,
    shader: $e651ba013d40a874$var$shader
};

});

parcelRegister("8nfQe", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("eZlZI");
parcelRequire("4u6lu");
const $618cc2803efb2139$var$name = "pbrUboDeclaration";
const $618cc2803efb2139$var$shader = `layout(std140,column_major) uniform;uniform Material {vec2 vAlbedoInfos;vec4 vAmbientInfos;vec2 vOpacityInfos;vec2 vEmissiveInfos;vec2 vLightmapInfos;vec3 vReflectivityInfos;vec2 vMicroSurfaceSamplerInfos;vec2 vReflectionInfos;vec2 vReflectionFilteringInfo;vec3 vReflectionPosition;vec3 vReflectionSize;vec3 vBumpInfos;mat4 albedoMatrix;mat4 ambientMatrix;mat4 opacityMatrix;mat4 emissiveMatrix;mat4 lightmapMatrix;mat4 reflectivityMatrix;mat4 microSurfaceSamplerMatrix;mat4 bumpMatrix;vec2 vTangentSpaceParams;mat4 reflectionMatrix;vec3 vReflectionColor;vec4 vAlbedoColor;vec4 vLightingIntensity;vec3 vReflectionMicrosurfaceInfos;float pointSize;vec4 vReflectivityColor;vec3 vEmissiveColor;vec3 vAmbientColor;vec2 vDebugMode;vec4 vMetallicReflectanceFactors;vec2 vMetallicReflectanceInfos;mat4 metallicReflectanceMatrix;vec2 vReflectanceInfos;mat4 reflectanceMatrix;vec3 vSphericalL00;vec3 vSphericalL1_1;vec3 vSphericalL10;vec3 vSphericalL11;vec3 vSphericalL2_2;vec3 vSphericalL2_1;vec3 vSphericalL20;vec3 vSphericalL21;vec3 vSphericalL22;vec3 vSphericalX;vec3 vSphericalY;vec3 vSphericalZ;vec3 vSphericalXX_ZZ;vec3 vSphericalYY_ZZ;vec3 vSphericalZZ;vec3 vSphericalXY;vec3 vSphericalYZ;vec3 vSphericalZX;
#define ADDITIONAL_UBO_DECLARATION
};
#include<sceneUboDeclaration>
#include<meshUboDeclaration>
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$618cc2803efb2139$var$name] = $618cc2803efb2139$var$shader;
const $618cc2803efb2139$export$8f12d42fccf6efdf = {
    name: $618cc2803efb2139$var$name,
    shader: $618cc2803efb2139$var$shader
};

});

parcelRegister("l9yC5", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("5lMLg");
const $f66549b6d508d9b0$var$name = "pbrFragmentExtraDeclaration";
const $f66549b6d508d9b0$var$shader = `varying vec3 vPositionW;
#if DEBUGMODE>0
varying vec4 vClipSpacePosition;
#endif
#include<mainUVVaryingDeclaration>[1..7]
#ifdef NORMAL
varying vec3 vNormalW;
#if defined(USESPHERICALFROMREFLECTIONMAP) && defined(USESPHERICALINVERTEX)
varying vec3 vEnvironmentIrradiance;
#endif
#endif
#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
varying vec4 vColor;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$f66549b6d508d9b0$var$name] = $f66549b6d508d9b0$var$shader;
const $f66549b6d508d9b0$export$721ee3d6db81f74b = {
    name: $f66549b6d508d9b0$var$name,
    shader: $f66549b6d508d9b0$var$shader
};

});

parcelRegister("6RB1l", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("b4ZX6");
parcelRequire("jFKcc");
const $4ff468e0389620e9$var$name = "pbrFragmentSamplersDeclaration";
const $4ff468e0389620e9$var$shader = `#include<samplerFragmentDeclaration>(_DEFINENAME_,ALBEDO,_VARYINGNAME_,Albedo,_SAMPLERNAME_,albedo)
#include<samplerFragmentDeclaration>(_DEFINENAME_,AMBIENT,_VARYINGNAME_,Ambient,_SAMPLERNAME_,ambient)
#include<samplerFragmentDeclaration>(_DEFINENAME_,OPACITY,_VARYINGNAME_,Opacity,_SAMPLERNAME_,opacity)
#include<samplerFragmentDeclaration>(_DEFINENAME_,EMISSIVE,_VARYINGNAME_,Emissive,_SAMPLERNAME_,emissive)
#include<samplerFragmentDeclaration>(_DEFINENAME_,LIGHTMAP,_VARYINGNAME_,Lightmap,_SAMPLERNAME_,lightmap)
#include<samplerFragmentDeclaration>(_DEFINENAME_,REFLECTIVITY,_VARYINGNAME_,Reflectivity,_SAMPLERNAME_,reflectivity)
#include<samplerFragmentDeclaration>(_DEFINENAME_,MICROSURFACEMAP,_VARYINGNAME_,MicroSurfaceSampler,_SAMPLERNAME_,microSurface)
#include<samplerFragmentDeclaration>(_DEFINENAME_,METALLIC_REFLECTANCE,_VARYINGNAME_,MetallicReflectance,_SAMPLERNAME_,metallicReflectance)
#include<samplerFragmentDeclaration>(_DEFINENAME_,REFLECTANCE,_VARYINGNAME_,Reflectance,_SAMPLERNAME_,reflectance)
#include<samplerFragmentDeclaration>(_DEFINENAME_,DECAL,_VARYINGNAME_,Decal,_SAMPLERNAME_,decal)
#ifdef CLEARCOAT
#include<samplerFragmentDeclaration>(_DEFINENAME_,CLEARCOAT_TEXTURE,_VARYINGNAME_,ClearCoat,_SAMPLERNAME_,clearCoat)
#include<samplerFragmentAlternateDeclaration>(_DEFINENAME_,CLEARCOAT_TEXTURE_ROUGHNESS,_VARYINGNAME_,ClearCoatRoughness)
#if defined(CLEARCOAT_TEXTURE_ROUGHNESS) && !defined(CLEARCOAT_TEXTURE_ROUGHNESS_IDENTICAL)
uniform sampler2D clearCoatRoughnessSampler;
#endif
#include<samplerFragmentDeclaration>(_DEFINENAME_,CLEARCOAT_BUMP,_VARYINGNAME_,ClearCoatBump,_SAMPLERNAME_,clearCoatBump)
#include<samplerFragmentDeclaration>(_DEFINENAME_,CLEARCOAT_TINT_TEXTURE,_VARYINGNAME_,ClearCoatTint,_SAMPLERNAME_,clearCoatTint)
#endif
#ifdef IRIDESCENCE
#include<samplerFragmentDeclaration>(_DEFINENAME_,IRIDESCENCE_TEXTURE,_VARYINGNAME_,Iridescence,_SAMPLERNAME_,iridescence)
#include<samplerFragmentDeclaration>(_DEFINENAME_,IRIDESCENCE_THICKNESS_TEXTURE,_VARYINGNAME_,IridescenceThickness,_SAMPLERNAME_,iridescenceThickness)
#endif
#ifdef SHEEN
#include<samplerFragmentDeclaration>(_DEFINENAME_,SHEEN_TEXTURE,_VARYINGNAME_,Sheen,_SAMPLERNAME_,sheen)
#include<samplerFragmentAlternateDeclaration>(_DEFINENAME_,SHEEN_TEXTURE_ROUGHNESS,_VARYINGNAME_,SheenRoughness)
#if defined(SHEEN_ROUGHNESS) && defined(SHEEN_TEXTURE_ROUGHNESS) && !defined(SHEEN_TEXTURE_ROUGHNESS_IDENTICAL)
uniform sampler2D sheenRoughnessSampler;
#endif
#endif
#ifdef ANISOTROPIC
#include<samplerFragmentDeclaration>(_DEFINENAME_,ANISOTROPIC_TEXTURE,_VARYINGNAME_,Anisotropy,_SAMPLERNAME_,anisotropy)
#endif
#ifdef REFLECTION
#ifdef REFLECTIONMAP_3D
#define sampleReflection(s,c) textureCube(s,c)
uniform samplerCube reflectionSampler;
#ifdef LODBASEDMICROSFURACE
#define sampleReflectionLod(s,c,l) textureCubeLodEXT(s,c,l)
#else
uniform samplerCube reflectionSamplerLow;uniform samplerCube reflectionSamplerHigh;
#endif
#ifdef USEIRRADIANCEMAP
uniform samplerCube irradianceSampler;
#endif
#else
#define sampleReflection(s,c) texture2D(s,c)
uniform sampler2D reflectionSampler;
#ifdef LODBASEDMICROSFURACE
#define sampleReflectionLod(s,c,l) texture2DLodEXT(s,c,l)
#else
uniform sampler2D reflectionSamplerLow;uniform sampler2D reflectionSamplerHigh;
#endif
#ifdef USEIRRADIANCEMAP
uniform sampler2D irradianceSampler;
#endif
#endif
#ifdef REFLECTIONMAP_SKYBOX
varying vec3 vPositionUVW;
#else
#if defined(REFLECTIONMAP_EQUIRECTANGULAR_FIXED) || defined(REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED)
varying vec3 vDirectionW;
#endif
#endif
#endif
#ifdef ENVIRONMENTBRDF
uniform sampler2D environmentBrdfSampler;
#endif
#ifdef SUBSURFACE
#ifdef SS_REFRACTION
#ifdef SS_REFRACTIONMAP_3D
#define sampleRefraction(s,c) textureCube(s,c)
uniform samplerCube refractionSampler;
#ifdef LODBASEDMICROSFURACE
#define sampleRefractionLod(s,c,l) textureCubeLodEXT(s,c,l)
#else
uniform samplerCube refractionSamplerLow;uniform samplerCube refractionSamplerHigh;
#endif
#else
#define sampleRefraction(s,c) texture2D(s,c)
uniform sampler2D refractionSampler;
#ifdef LODBASEDMICROSFURACE
#define sampleRefractionLod(s,c,l) texture2DLodEXT(s,c,l)
#else
uniform sampler2D refractionSamplerLow;uniform sampler2D refractionSamplerHigh;
#endif
#endif
#endif
#include<samplerFragmentDeclaration>(_DEFINENAME_,SS_THICKNESSANDMASK_TEXTURE,_VARYINGNAME_,Thickness,_SAMPLERNAME_,thickness)
#include<samplerFragmentDeclaration>(_DEFINENAME_,SS_REFRACTIONINTENSITY_TEXTURE,_VARYINGNAME_,RefractionIntensity,_SAMPLERNAME_,refractionIntensity)
#include<samplerFragmentDeclaration>(_DEFINENAME_,SS_TRANSLUCENCYINTENSITY_TEXTURE,_VARYINGNAME_,TranslucencyIntensity,_SAMPLERNAME_,translucencyIntensity)
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$4ff468e0389620e9$var$name] = $4ff468e0389620e9$var$shader;
const $4ff468e0389620e9$export$f69708f4a5c53fa6 = {
    name: $4ff468e0389620e9$var$name,
    shader: $4ff468e0389620e9$var$shader
};

});
parcelRegister("jFKcc", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $e525ae2edf34d8eb$var$name = "samplerFragmentAlternateDeclaration";
const $e525ae2edf34d8eb$var$shader = `#ifdef _DEFINENAME_
#if _DEFINENAME_DIRECTUV==1
#define v_VARYINGNAME_UV vMainUV1
#elif _DEFINENAME_DIRECTUV==2
#define v_VARYINGNAME_UV vMainUV2
#elif _DEFINENAME_DIRECTUV==3
#define v_VARYINGNAME_UV vMainUV3
#elif _DEFINENAME_DIRECTUV==4
#define v_VARYINGNAME_UV vMainUV4
#elif _DEFINENAME_DIRECTUV==5
#define v_VARYINGNAME_UV vMainUV5
#elif _DEFINENAME_DIRECTUV==6
#define v_VARYINGNAME_UV vMainUV6
#else
varying vec2 v_VARYINGNAME_UV;
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$e525ae2edf34d8eb$var$name] = $e525ae2edf34d8eb$var$shader;
const $e525ae2edf34d8eb$export$2b5ecbb562a594a7 = {
    name: $e525ae2edf34d8eb$var$name,
    shader: $e525ae2edf34d8eb$var$shader
};

});


parcelRegister("OMx8e", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $098a5158516eca83$var$name = "subSurfaceScatteringFunctions";
const $098a5158516eca83$var$shader = `bool testLightingForSSS(float diffusionProfile)
{return diffusionProfile<1.;}`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$098a5158516eca83$var$name] = $098a5158516eca83$var$shader;
const $098a5158516eca83$export$4a989449544bdd1e = {
    name: $098a5158516eca83$var$name,
    shader: $098a5158516eca83$var$shader
};

});

parcelRegister("fsNb6", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $b41f9e48d39b99c7$var$name = "importanceSampling";
const $b41f9e48d39b99c7$var$shader = `vec3 hemisphereCosSample(vec2 u) {float phi=2.*PI*u.x;float cosTheta2=1.-u.y;float cosTheta=sqrt(cosTheta2);float sinTheta=sqrt(1.-cosTheta2);return vec3(sinTheta*cos(phi),sinTheta*sin(phi),cosTheta);}
vec3 hemisphereImportanceSampleDggx(vec2 u,float a) {float phi=2.*PI*u.x;float cosTheta2=(1.-u.y)/(1.+(a+1.)*((a-1.)*u.y));float cosTheta=sqrt(cosTheta2);float sinTheta=sqrt(1.-cosTheta2);return vec3(sinTheta*cos(phi),sinTheta*sin(phi),cosTheta);}
vec3 hemisphereImportanceSampleDCharlie(vec2 u,float a) { 
float phi=2.*PI*u.x;float sinTheta=pow(u.y,a/(2.*a+1.));float cosTheta=sqrt(1.-sinTheta*sinTheta);return vec3(sinTheta*cos(phi),sinTheta*sin(phi),cosTheta);}`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$b41f9e48d39b99c7$var$name] = $b41f9e48d39b99c7$var$shader;
const $b41f9e48d39b99c7$export$250901a99684436b = {
    name: $b41f9e48d39b99c7$var$name,
    shader: $b41f9e48d39b99c7$var$shader
};

});

parcelRegister("f3ISH", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $af69f34ed0f37646$var$name = "pbrHelperFunctions";
const $af69f34ed0f37646$var$shader = `#define MINIMUMVARIANCE 0.0005
float convertRoughnessToAverageSlope(float roughness)
{return square(roughness)+MINIMUMVARIANCE;}
float fresnelGrazingReflectance(float reflectance0) {float reflectance90=saturate(reflectance0*25.0);return reflectance90;}
vec2 getAARoughnessFactors(vec3 normalVector) {
#ifdef SPECULARAA
vec3 nDfdx=dFdx(normalVector.xyz);vec3 nDfdy=dFdy(normalVector.xyz);float slopeSquare=max(dot(nDfdx,nDfdx),dot(nDfdy,nDfdy));float geometricRoughnessFactor=pow(saturate(slopeSquare),0.333);float geometricAlphaGFactor=sqrt(slopeSquare);geometricAlphaGFactor*=0.75;return vec2(geometricRoughnessFactor,geometricAlphaGFactor);
#else
return vec2(0.);
#endif
}
#ifdef ANISOTROPIC
#ifdef ANISOTROPIC_LEGACY
vec2 getAnisotropicRoughness(float alphaG,float anisotropy) {float alphaT=max(alphaG*(1.0+anisotropy),MINIMUMVARIANCE);float alphaB=max(alphaG*(1.0-anisotropy),MINIMUMVARIANCE);return vec2(alphaT,alphaB);}
vec3 getAnisotropicBentNormals(const vec3 T,const vec3 B,const vec3 N,const vec3 V,float anisotropy,float roughness) {vec3 anisotropicFrameDirection=anisotropy>=0.0 ? B : T;vec3 anisotropicFrameTangent=cross(normalize(anisotropicFrameDirection),V);vec3 anisotropicFrameNormal=cross(anisotropicFrameTangent,anisotropicFrameDirection);vec3 anisotropicNormal=normalize(mix(N,anisotropicFrameNormal,abs(anisotropy)));return anisotropicNormal;}
#else
vec2 getAnisotropicRoughness(float alphaG,float anisotropy) {float alphaT=max(mix(alphaG,1.0,anisotropy*anisotropy),MINIMUMVARIANCE);float alphaB=max(alphaG,MINIMUMVARIANCE);return vec2(alphaT,alphaB);}
vec3 getAnisotropicBentNormals(const vec3 T,const vec3 B,const vec3 N,const vec3 V,float anisotropy,float roughness) {vec3 bentNormal=cross(B,V);bentNormal=normalize(cross(bentNormal,B));float a=square(square(1.0-anisotropy*(1.0-roughness)));bentNormal=normalize(mix(bentNormal,N,a));return bentNormal;}
#endif
#endif
#if defined(CLEARCOAT) || defined(SS_REFRACTION)
vec3 cocaLambert(vec3 alpha,float distance) {return exp(-alpha*distance);}
vec3 cocaLambert(float NdotVRefract,float NdotLRefract,vec3 alpha,float thickness) {return cocaLambert(alpha,(thickness*((NdotLRefract+NdotVRefract)/(NdotLRefract*NdotVRefract))));}
vec3 computeColorAtDistanceInMedia(vec3 color,float distance) {return -log(color)/distance;}
vec3 computeClearCoatAbsorption(float NdotVRefract,float NdotLRefract,vec3 clearCoatColor,float clearCoatThickness,float clearCoatIntensity) {vec3 clearCoatAbsorption=mix(vec3(1.0),
cocaLambert(NdotVRefract,NdotLRefract,clearCoatColor,clearCoatThickness),
clearCoatIntensity);return clearCoatAbsorption;}
#endif
#ifdef MICROSURFACEAUTOMATIC
float computeDefaultMicroSurface(float microSurface,vec3 reflectivityColor)
{const float kReflectivityNoAlphaWorkflow_SmoothnessMax=0.95;float reflectivityLuminance=getLuminance(reflectivityColor);float reflectivityLuma=sqrt(reflectivityLuminance);microSurface=reflectivityLuma*kReflectivityNoAlphaWorkflow_SmoothnessMax;return microSurface;}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$af69f34ed0f37646$var$name] = $af69f34ed0f37646$var$shader;
const $af69f34ed0f37646$export$2d4328a07109ea5b = {
    name: $af69f34ed0f37646$var$name,
    shader: $af69f34ed0f37646$var$shader
};

});

parcelRegister("hYOZS", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $d16f992fb6d57a1e$var$name = "harmonicsFunctions";
const $d16f992fb6d57a1e$var$shader = `#ifdef USESPHERICALFROMREFLECTIONMAP
#ifdef SPHERICAL_HARMONICS
vec3 computeEnvironmentIrradiance(vec3 normal) {return vSphericalL00
+ vSphericalL1_1*(normal.y)
+ vSphericalL10*(normal.z)
+ vSphericalL11*(normal.x)
+ vSphericalL2_2*(normal.y*normal.x)
+ vSphericalL2_1*(normal.y*normal.z)
+ vSphericalL20*((3.0*normal.z*normal.z)-1.0)
+ vSphericalL21*(normal.z*normal.x)
+ vSphericalL22*(normal.x*normal.x-(normal.y*normal.y));}
#else
vec3 computeEnvironmentIrradiance(vec3 normal) {float Nx=normal.x;float Ny=normal.y;float Nz=normal.z;vec3 C1=vSphericalZZ.rgb;vec3 Cx=vSphericalX.rgb;vec3 Cy=vSphericalY.rgb;vec3 Cz=vSphericalZ.rgb;vec3 Cxx_zz=vSphericalXX_ZZ.rgb;vec3 Cyy_zz=vSphericalYY_ZZ.rgb;vec3 Cxy=vSphericalXY.rgb;vec3 Cyz=vSphericalYZ.rgb;vec3 Czx=vSphericalZX.rgb;vec3 a1=Cyy_zz*Ny+Cy;vec3 a2=Cyz*Nz+a1;vec3 b1=Czx*Nz+Cx;vec3 b2=Cxy*Ny+b1;vec3 b3=Cxx_zz*Nx+b2;vec3 t1=Cz *Nz+C1;vec3 t2=a2 *Ny+t1;vec3 t3=b3 *Nx+t2;return t3;}
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$d16f992fb6d57a1e$var$name] = $d16f992fb6d57a1e$var$shader;
const $d16f992fb6d57a1e$export$2c90d28b3e4ea422 = {
    name: $d16f992fb6d57a1e$var$name,
    shader: $d16f992fb6d57a1e$var$shader
};

});

parcelRegister("c6yXF", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $8d012a329563916d$var$name = "pbrDirectLightingSetupFunctions";
const $8d012a329563916d$var$shader = `struct preLightingInfo
{vec3 lightOffset;float lightDistanceSquared;float lightDistance;float attenuation;vec3 L;vec3 H;float NdotV;float NdotLUnclamped;float NdotL;float VdotH;float roughness;
#ifdef IRIDESCENCE
float iridescenceIntensity;
#endif
};preLightingInfo computePointAndSpotPreLightingInfo(vec4 lightData,vec3 V,vec3 N) {preLightingInfo result;result.lightOffset=lightData.xyz-vPositionW;result.lightDistanceSquared=dot(result.lightOffset,result.lightOffset);result.lightDistance=sqrt(result.lightDistanceSquared);result.L=normalize(result.lightOffset);result.H=normalize(V+result.L);result.VdotH=saturate(dot(V,result.H));result.NdotLUnclamped=dot(N,result.L);result.NdotL=saturateEps(result.NdotLUnclamped);return result;}
preLightingInfo computeDirectionalPreLightingInfo(vec4 lightData,vec3 V,vec3 N) {preLightingInfo result;result.lightDistance=length(-lightData.xyz);result.L=normalize(-lightData.xyz);result.H=normalize(V+result.L);result.VdotH=saturate(dot(V,result.H));result.NdotLUnclamped=dot(N,result.L);result.NdotL=saturateEps(result.NdotLUnclamped);return result;}
preLightingInfo computeHemisphericPreLightingInfo(vec4 lightData,vec3 V,vec3 N) {preLightingInfo result;result.NdotL=dot(N,lightData.xyz)*0.5+0.5;result.NdotL=saturateEps(result.NdotL);result.NdotLUnclamped=result.NdotL;
#ifdef SPECULARTERM
result.L=normalize(lightData.xyz);result.H=normalize(V+result.L);result.VdotH=saturate(dot(V,result.H));
#endif
return result;}`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$8d012a329563916d$var$name] = $8d012a329563916d$var$shader;
const $8d012a329563916d$export$ab8837d0f511a92f = {
    name: $8d012a329563916d$var$name,
    shader: $8d012a329563916d$var$shader
};

});

parcelRegister("2s0nq", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $1c8e7d26157d7a1e$var$name = "pbrDirectLightingFalloffFunctions";
const $1c8e7d26157d7a1e$var$shader = `float computeDistanceLightFalloff_Standard(vec3 lightOffset,float range)
{return max(0.,1.0-length(lightOffset)/range);}
float computeDistanceLightFalloff_Physical(float lightDistanceSquared)
{return 1.0/maxEps(lightDistanceSquared);}
float computeDistanceLightFalloff_GLTF(float lightDistanceSquared,float inverseSquaredRange)
{float lightDistanceFalloff=1.0/maxEps(lightDistanceSquared);float factor=lightDistanceSquared*inverseSquaredRange;float attenuation=saturate(1.0-factor*factor);attenuation*=attenuation;lightDistanceFalloff*=attenuation;return lightDistanceFalloff;}
float computeDistanceLightFalloff(vec3 lightOffset,float lightDistanceSquared,float range,float inverseSquaredRange)
{
#ifdef USEPHYSICALLIGHTFALLOFF
return computeDistanceLightFalloff_Physical(lightDistanceSquared);
#elif defined(USEGLTFLIGHTFALLOFF)
return computeDistanceLightFalloff_GLTF(lightDistanceSquared,inverseSquaredRange);
#else
return computeDistanceLightFalloff_Standard(lightOffset,range);
#endif
}
float computeDirectionalLightFalloff_Standard(vec3 lightDirection,vec3 directionToLightCenterW,float cosHalfAngle,float exponent)
{float falloff=0.0;float cosAngle=maxEps(dot(-lightDirection,directionToLightCenterW));if (cosAngle>=cosHalfAngle)
{falloff=max(0.,pow(cosAngle,exponent));}
return falloff;}
float computeDirectionalLightFalloff_Physical(vec3 lightDirection,vec3 directionToLightCenterW,float cosHalfAngle)
{const float kMinusLog2ConeAngleIntensityRatio=6.64385618977; 
float concentrationKappa=kMinusLog2ConeAngleIntensityRatio/(1.0-cosHalfAngle);vec4 lightDirectionSpreadSG=vec4(-lightDirection*concentrationKappa,-concentrationKappa);float falloff=exp2(dot(vec4(directionToLightCenterW,1.0),lightDirectionSpreadSG));return falloff;}
float computeDirectionalLightFalloff_GLTF(vec3 lightDirection,vec3 directionToLightCenterW,float lightAngleScale,float lightAngleOffset)
{float cd=dot(-lightDirection,directionToLightCenterW);float falloff=saturate(cd*lightAngleScale+lightAngleOffset);falloff*=falloff;return falloff;}
float computeDirectionalLightFalloff(vec3 lightDirection,vec3 directionToLightCenterW,float cosHalfAngle,float exponent,float lightAngleScale,float lightAngleOffset)
{
#ifdef USEPHYSICALLIGHTFALLOFF
return computeDirectionalLightFalloff_Physical(lightDirection,directionToLightCenterW,cosHalfAngle);
#elif defined(USEGLTFLIGHTFALLOFF)
return computeDirectionalLightFalloff_GLTF(lightDirection,directionToLightCenterW,lightAngleScale,lightAngleOffset);
#else
return computeDirectionalLightFalloff_Standard(lightDirection,directionToLightCenterW,cosHalfAngle,exponent);
#endif
}`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$1c8e7d26157d7a1e$var$name] = $1c8e7d26157d7a1e$var$shader;
const $1c8e7d26157d7a1e$export$fadd4ad3b03e968f = {
    name: $1c8e7d26157d7a1e$var$name,
    shader: $1c8e7d26157d7a1e$var$shader
};

});

parcelRegister("bzdhG", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $86bd44914539f938$var$name = "pbrBRDFFunctions";
const $86bd44914539f938$var$shader = `#define FRESNEL_MAXIMUM_ON_ROUGH 0.25
#ifdef MS_BRDF_ENERGY_CONSERVATION
vec3 getEnergyConservationFactor(const vec3 specularEnvironmentR0,const vec3 environmentBrdf) {return 1.0+specularEnvironmentR0*(1.0/environmentBrdf.y-1.0);}
#endif
#ifdef ENVIRONMENTBRDF
vec3 getBRDFLookup(float NdotV,float perceptualRoughness) {vec2 UV=vec2(NdotV,perceptualRoughness);vec4 brdfLookup=texture2D(environmentBrdfSampler,UV);
#ifdef ENVIRONMENTBRDF_RGBD
brdfLookup.rgb=fromRGBD(brdfLookup.rgba);
#endif
return brdfLookup.rgb;}
vec3 getReflectanceFromBRDFLookup(const vec3 specularEnvironmentR0,const vec3 specularEnvironmentR90,const vec3 environmentBrdf) {
#ifdef BRDF_V_HEIGHT_CORRELATED
vec3 reflectance=(specularEnvironmentR90-specularEnvironmentR0)*environmentBrdf.x+specularEnvironmentR0*environmentBrdf.y;
#else
vec3 reflectance=specularEnvironmentR0*environmentBrdf.x+specularEnvironmentR90*environmentBrdf.y;
#endif
return reflectance;}
vec3 getReflectanceFromBRDFLookup(const vec3 specularEnvironmentR0,const vec3 environmentBrdf) {
#ifdef BRDF_V_HEIGHT_CORRELATED
vec3 reflectance=mix(environmentBrdf.xxx,environmentBrdf.yyy,specularEnvironmentR0);
#else
vec3 reflectance=specularEnvironmentR0*environmentBrdf.x+environmentBrdf.y;
#endif
return reflectance;}
#endif
/* NOT USED
#if defined(SHEEN) && defined(SHEEN_SOFTER)
float getBRDFLookupCharlieSheen(float NdotV,float perceptualRoughness)
{float c=1.0-NdotV;float c3=c*c*c;return 0.65584461*c3+1.0/(4.16526551+exp(-7.97291361*perceptualRoughness+6.33516894));}
#endif
*/
#if !defined(ENVIRONMENTBRDF) || defined(REFLECTIONMAP_SKYBOX) || defined(ALPHAFRESNEL)
vec3 getReflectanceFromAnalyticalBRDFLookup_Jones(float VdotN,vec3 reflectance0,vec3 reflectance90,float smoothness)
{float weight=mix(FRESNEL_MAXIMUM_ON_ROUGH,1.0,smoothness);return reflectance0+weight*(reflectance90-reflectance0)*pow5(saturate(1.0-VdotN));}
#endif
#if defined(SHEEN) && defined(ENVIRONMENTBRDF)
/**
* The sheen BRDF not containing F can be easily stored in the blue channel of the BRDF texture.
* The blue channel contains DCharlie*VAshikhmin*NdotL as a lokkup table
*/
vec3 getSheenReflectanceFromBRDFLookup(const vec3 reflectance0,const vec3 environmentBrdf) {vec3 sheenEnvironmentReflectance=reflectance0*environmentBrdf.b;return sheenEnvironmentReflectance;}
#endif
vec3 fresnelSchlickGGX(float VdotH,vec3 reflectance0,vec3 reflectance90)
{return reflectance0+(reflectance90-reflectance0)*pow5(1.0-VdotH);}
float fresnelSchlickGGX(float VdotH,float reflectance0,float reflectance90)
{return reflectance0+(reflectance90-reflectance0)*pow5(1.0-VdotH);}
#ifdef CLEARCOAT
vec3 getR0RemappedForClearCoat(vec3 f0) {
#ifdef CLEARCOAT_DEFAULTIOR
#ifdef MOBILE
return saturate(f0*(f0*0.526868+0.529324)-0.0482256);
#else
return saturate(f0*(f0*(0.941892-0.263008*f0)+0.346479)-0.0285998);
#endif
#else
vec3 s=sqrt(f0);vec3 t=(vClearCoatRefractionParams.z+vClearCoatRefractionParams.w*s)/(vClearCoatRefractionParams.w+vClearCoatRefractionParams.z*s);return square(t);
#endif
}
#endif
#ifdef IRIDESCENCE
const mat3 XYZ_TO_REC709=mat3(
3.2404542,-0.9692660, 0.0556434,
-1.5371385, 1.8760108,-0.2040259,
-0.4985314, 0.0415560, 1.0572252
);vec3 getIORTfromAirToSurfaceR0(vec3 f0) {vec3 sqrtF0=sqrt(f0);return (1.+sqrtF0)/(1.-sqrtF0);}
vec3 getR0fromIORs(vec3 iorT,float iorI) {return square((iorT-vec3(iorI))/(iorT+vec3(iorI)));}
float getR0fromIORs(float iorT,float iorI) {return square((iorT-iorI)/(iorT+iorI));}
vec3 evalSensitivity(float opd,vec3 shift) {float phase=2.0*PI*opd*1.0e-9;const vec3 val=vec3(5.4856e-13,4.4201e-13,5.2481e-13);const vec3 pos=vec3(1.6810e+06,1.7953e+06,2.2084e+06);const vec3 var=vec3(4.3278e+09,9.3046e+09,6.6121e+09);vec3 xyz=val*sqrt(2.0*PI*var)*cos(pos*phase+shift)*exp(-square(phase)*var);xyz.x+=9.7470e-14*sqrt(2.0*PI*4.5282e+09)*cos(2.2399e+06*phase+shift[0])*exp(-4.5282e+09*square(phase));xyz/=1.0685e-7;vec3 srgb=XYZ_TO_REC709*xyz;return srgb;}
vec3 evalIridescence(float outsideIOR,float eta2,float cosTheta1,float thinFilmThickness,vec3 baseF0) {vec3 I=vec3(1.0);float iridescenceIOR=mix(outsideIOR,eta2,smoothstep(0.0,0.03,thinFilmThickness));float sinTheta2Sq=square(outsideIOR/iridescenceIOR)*(1.0-square(cosTheta1));float cosTheta2Sq=1.0-sinTheta2Sq;if (cosTheta2Sq<0.0) {return I;}
float cosTheta2=sqrt(cosTheta2Sq);float R0=getR0fromIORs(iridescenceIOR,outsideIOR);float R12=fresnelSchlickGGX(cosTheta1,R0,1.);float R21=R12;float T121=1.0-R12;float phi12=0.0;if (iridescenceIOR<outsideIOR) phi12=PI;float phi21=PI-phi12;vec3 baseIOR=getIORTfromAirToSurfaceR0(clamp(baseF0,0.0,0.9999)); 
vec3 R1=getR0fromIORs(baseIOR,iridescenceIOR);vec3 R23=fresnelSchlickGGX(cosTheta2,R1,vec3(1.));vec3 phi23=vec3(0.0);if (baseIOR[0]<iridescenceIOR) phi23[0]=PI;if (baseIOR[1]<iridescenceIOR) phi23[1]=PI;if (baseIOR[2]<iridescenceIOR) phi23[2]=PI;float opd=2.0*iridescenceIOR*thinFilmThickness*cosTheta2;vec3 phi=vec3(phi21)+phi23;vec3 R123=clamp(R12*R23,1e-5,0.9999);vec3 r123=sqrt(R123);vec3 Rs=square(T121)*R23/(vec3(1.0)-R123);vec3 C0=R12+Rs;I=C0;vec3 Cm=Rs-T121;for (int m=1; m<=2; ++m)
{Cm*=r123;vec3 Sm=2.0*evalSensitivity(float(m)*opd,float(m)*phi);I+=Cm*Sm;}
return max(I,vec3(0.0));}
#endif
float normalDistributionFunction_TrowbridgeReitzGGX(float NdotH,float alphaG)
{float a2=square(alphaG);float d=NdotH*NdotH*(a2-1.0)+1.0;return a2/(PI*d*d);}
#ifdef SHEEN
float normalDistributionFunction_CharlieSheen(float NdotH,float alphaG)
{float invR=1./alphaG;float cos2h=NdotH*NdotH;float sin2h=1.-cos2h;return (2.+invR)*pow(sin2h,invR*.5)/(2.*PI);}
#endif
#ifdef ANISOTROPIC
float normalDistributionFunction_BurleyGGX_Anisotropic(float NdotH,float TdotH,float BdotH,const vec2 alphaTB) {float a2=alphaTB.x*alphaTB.y;vec3 v=vec3(alphaTB.y*TdotH,alphaTB.x *BdotH,a2*NdotH);float v2=dot(v,v);float w2=a2/v2;return a2*w2*w2*RECIPROCAL_PI;}
#endif
#ifdef BRDF_V_HEIGHT_CORRELATED
float smithVisibility_GGXCorrelated(float NdotL,float NdotV,float alphaG) {
#ifdef MOBILE
float GGXV=NdotL*(NdotV*(1.0-alphaG)+alphaG);float GGXL=NdotV*(NdotL*(1.0-alphaG)+alphaG);return 0.5/(GGXV+GGXL);
#else
float a2=alphaG*alphaG;float GGXV=NdotL*sqrt(NdotV*(NdotV-a2*NdotV)+a2);float GGXL=NdotV*sqrt(NdotL*(NdotL-a2*NdotL)+a2);return 0.5/(GGXV+GGXL);
#endif
}
#else
float smithVisibilityG1_TrowbridgeReitzGGXFast(float dot,float alphaG)
{
#ifdef MOBILE
return 1.0/(dot+alphaG+(1.0-alphaG)*dot ));
#else
float alphaSquared=alphaG*alphaG;return 1.0/(dot+sqrt(alphaSquared+(1.0-alphaSquared)*dot*dot));
#endif
}
float smithVisibility_TrowbridgeReitzGGXFast(float NdotL,float NdotV,float alphaG)
{float visibility=smithVisibilityG1_TrowbridgeReitzGGXFast(NdotL,alphaG)*smithVisibilityG1_TrowbridgeReitzGGXFast(NdotV,alphaG);return visibility;}
#endif
#ifdef ANISOTROPIC
float smithVisibility_GGXCorrelated_Anisotropic(float NdotL,float NdotV,float TdotV,float BdotV,float TdotL,float BdotL,const vec2 alphaTB) {float lambdaV=NdotL*length(vec3(alphaTB.x*TdotV,alphaTB.y*BdotV,NdotV));float lambdaL=NdotV*length(vec3(alphaTB.x*TdotL,alphaTB.y*BdotL,NdotL));float v=0.5/(lambdaV+lambdaL);return v;}
#endif
#ifdef CLEARCOAT
float visibility_Kelemen(float VdotH) {return 0.25/(VdotH*VdotH); }
#endif
#ifdef SHEEN
float visibility_Ashikhmin(float NdotL,float NdotV)
{return 1./(4.*(NdotL+NdotV-NdotL*NdotV));}
/* NOT USED
#ifdef SHEEN_SOFTER
float l(float x,float alphaG)
{float oneMinusAlphaSq=(1.0-alphaG)*(1.0-alphaG);float a=mix(21.5473,25.3245,oneMinusAlphaSq);float b=mix(3.82987,3.32435,oneMinusAlphaSq);float c=mix(0.19823,0.16801,oneMinusAlphaSq);float d=mix(-1.97760,-1.27393,oneMinusAlphaSq);float e=mix(-4.32054,-4.85967,oneMinusAlphaSq);return a/(1.0+b*pow(x,c))+d*x+e;}
float lambdaSheen(float cosTheta,float alphaG)
{return abs(cosTheta)<0.5 ? exp(l(cosTheta,alphaG)) : exp(2.0*l(0.5,alphaG)-l(1.0-cosTheta,alphaG));}
float visibility_CharlieSheen(float NdotL,float NdotV,float alphaG)
{float G=1.0/(1.0+lambdaSheen(NdotV,alphaG)+lambdaSheen(NdotL,alphaG));return G/(4.0*NdotV*NdotL);}
#endif
*/
#endif
float diffuseBRDF_Burley(float NdotL,float NdotV,float VdotH,float roughness) {float diffuseFresnelNV=pow5(saturateEps(1.0-NdotL));float diffuseFresnelNL=pow5(saturateEps(1.0-NdotV));float diffuseFresnel90=0.5+2.0*VdotH*VdotH*roughness;float fresnel =
(1.0+(diffuseFresnel90-1.0)*diffuseFresnelNL) *
(1.0+(diffuseFresnel90-1.0)*diffuseFresnelNV);return fresnel/PI;}
#ifdef SS_TRANSLUCENCY
vec3 transmittanceBRDF_Burley(const vec3 tintColor,const vec3 diffusionDistance,float thickness) {vec3 S=1./maxEps(diffusionDistance);vec3 temp=exp((-0.333333333*thickness)*S);return tintColor.rgb*0.25*(temp*temp*temp+3.0*temp);}
float computeWrappedDiffuseNdotL(float NdotL,float w) {float t=1.0+w;float invt2=1.0/square(t);return saturate((NdotL+w)*invt2);}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$86bd44914539f938$var$name] = $86bd44914539f938$var$shader;
const $86bd44914539f938$export$98032fbeb4b3ea24 = {
    name: $86bd44914539f938$var$name,
    shader: $86bd44914539f938$var$shader
};

});

parcelRegister("aqaLg", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $7964ae0eff32bb5d$var$name = "hdrFilteringFunctions";
const $7964ae0eff32bb5d$var$shader = `#ifdef NUM_SAMPLES
#if NUM_SAMPLES>0
#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
float radicalInverse_VdC(uint bits) 
{bits=(bits<<16u) | (bits>>16u);bits=((bits & 0x55555555u)<<1u) | ((bits & 0xAAAAAAAAu)>>1u);bits=((bits & 0x33333333u)<<2u) | ((bits & 0xCCCCCCCCu)>>2u);bits=((bits & 0x0F0F0F0Fu)<<4u) | ((bits & 0xF0F0F0F0u)>>4u);bits=((bits & 0x00FF00FFu)<<8u) | ((bits & 0xFF00FF00u)>>8u);return float(bits)*2.3283064365386963e-10; }
vec2 hammersley(uint i,uint N)
{return vec2(float(i)/float(N),radicalInverse_VdC(i));}
#else
float vanDerCorpus(int n,int base)
{float invBase=1.0/float(base);float denom =1.0;float result =0.0;for(int i=0; i<32; ++i)
{if(n>0)
{denom =mod(float(n),2.0);result+=denom*invBase;invBase=invBase/2.0;n =int(float(n)/2.0);}}
return result;}
vec2 hammersley(int i,int N)
{return vec2(float(i)/float(N),vanDerCorpus(i,2));}
#endif
float log4(float x) {return log2(x)/2.;}
const float NUM_SAMPLES_FLOAT=float(NUM_SAMPLES);const float NUM_SAMPLES_FLOAT_INVERSED=1./NUM_SAMPLES_FLOAT;const float K=4.;
#define inline
vec3 irradiance(samplerCube inputTexture,vec3 inputN,vec2 filteringInfo)
{vec3 n=normalize(inputN);vec3 result=vec3(0.0);vec3 tangent=abs(n.z)<0.999 ? vec3(0.,0.,1.) : vec3(1.,0.,0.);tangent=normalize(cross(tangent,n));vec3 bitangent=cross(n,tangent);mat3 tbn=mat3(tangent,bitangent,n);float maxLevel=filteringInfo.y;float dim0=filteringInfo.x;float omegaP=(4.*PI)/(6.*dim0*dim0);
#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
for(uint i=0u; i<NUM_SAMPLES; ++i)
#else
for(int i=0; i<NUM_SAMPLES; ++i)
#endif
{vec2 Xi=hammersley(i,NUM_SAMPLES);vec3 Ls=hemisphereCosSample(Xi);Ls=normalize(Ls);vec3 Ns=vec3(0.,0.,1.);float NoL=dot(Ns,Ls);if (NoL>0.) {float pdf_inversed=PI/NoL;float omegaS=NUM_SAMPLES_FLOAT_INVERSED*pdf_inversed;float l=log4(omegaS)-log4(omegaP)+log4(K);float mipLevel=clamp(l,0.0,maxLevel);vec3 c=textureCubeLodEXT(inputTexture,tbn*Ls,mipLevel).rgb;
#ifdef GAMMA_INPUT
c=toLinearSpace(c);
#endif
result+=c;}}
result=result*NUM_SAMPLES_FLOAT_INVERSED;return result;}
#define inline
vec3 radiance(float alphaG,samplerCube inputTexture,vec3 inputN,vec2 filteringInfo)
{vec3 n=normalize(inputN);vec3 c=textureCube(inputTexture,n).rgb; 
if (alphaG==0.) {
#ifdef GAMMA_INPUT
c=toLinearSpace(c);
#endif
return c;} else {vec3 result=vec3(0.);vec3 tangent=abs(n.z)<0.999 ? vec3(0.,0.,1.) : vec3(1.,0.,0.);tangent=normalize(cross(tangent,n));vec3 bitangent=cross(n,tangent);mat3 tbn=mat3(tangent,bitangent,n);float maxLevel=filteringInfo.y;float dim0=filteringInfo.x;float omegaP=(4.*PI)/(6.*dim0*dim0);float weight=0.;
#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
for(uint i=0u; i<NUM_SAMPLES; ++i)
#else
for(int i=0; i<NUM_SAMPLES; ++i)
#endif
{vec2 Xi=hammersley(i,NUM_SAMPLES);vec3 H=hemisphereImportanceSampleDggx(Xi,alphaG);float NoV=1.;float NoH=H.z;float NoH2=H.z*H.z;float NoL=2.*NoH2-1.;vec3 L=vec3(2.*NoH*H.x,2.*NoH*H.y,NoL);L=normalize(L);if (NoL>0.) {float pdf_inversed=4./normalDistributionFunction_TrowbridgeReitzGGX(NoH,alphaG);float omegaS=NUM_SAMPLES_FLOAT_INVERSED*pdf_inversed;float l=log4(omegaS)-log4(omegaP)+log4(K);float mipLevel=clamp(float(l),0.0,maxLevel);weight+=NoL;vec3 c=textureCubeLodEXT(inputTexture,tbn*L,mipLevel).rgb;
#ifdef GAMMA_INPUT
c=toLinearSpace(c);
#endif
result+=c*NoL;}}
result=result/weight;return result;}}
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$7964ae0eff32bb5d$var$name] = $7964ae0eff32bb5d$var$shader;
const $7964ae0eff32bb5d$export$1be8326ed93ff699 = {
    name: $7964ae0eff32bb5d$var$name,
    shader: $7964ae0eff32bb5d$var$shader
};

});

parcelRegister("8e2nm", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $5fd1794ea31783db$var$name = "pbrDirectLightingFunctions";
const $5fd1794ea31783db$var$shader = `#define CLEARCOATREFLECTANCE90 1.0
struct lightingInfo
{vec3 diffuse;
#ifdef SPECULARTERM
vec3 specular;
#endif
#ifdef CLEARCOAT
vec4 clearCoat;
#endif
#ifdef SHEEN
vec3 sheen;
#endif
};float adjustRoughnessFromLightProperties(float roughness,float lightRadius,float lightDistance) {
#if defined(USEPHYSICALLIGHTFALLOFF) || defined(USEGLTFLIGHTFALLOFF)
float lightRoughness=lightRadius/lightDistance;float totalRoughness=saturate(lightRoughness+roughness);return totalRoughness;
#else
return roughness;
#endif
}
vec3 computeHemisphericDiffuseLighting(preLightingInfo info,vec3 lightColor,vec3 groundColor) {return mix(groundColor,lightColor,info.NdotL);}
vec3 computeDiffuseLighting(preLightingInfo info,vec3 lightColor) {float diffuseTerm=diffuseBRDF_Burley(info.NdotL,info.NdotV,info.VdotH,info.roughness);return diffuseTerm*info.attenuation*info.NdotL*lightColor;}
#define inline
vec3 computeProjectionTextureDiffuseLighting(sampler2D projectionLightSampler,mat4 textureProjectionMatrix){vec4 strq=textureProjectionMatrix*vec4(vPositionW,1.0);strq/=strq.w;vec3 textureColor=texture2D(projectionLightSampler,strq.xy).rgb;return toLinearSpace(textureColor);}
#ifdef SS_TRANSLUCENCY
vec3 computeDiffuseAndTransmittedLighting(preLightingInfo info,vec3 lightColor,vec3 transmittance) {float NdotL=absEps(info.NdotLUnclamped);float wrapNdotL=computeWrappedDiffuseNdotL(NdotL,0.02);float trAdapt=step(0.,info.NdotLUnclamped);vec3 transmittanceNdotL=mix(transmittance*wrapNdotL,vec3(wrapNdotL),trAdapt);float diffuseTerm=diffuseBRDF_Burley(NdotL,info.NdotV,info.VdotH,info.roughness);return diffuseTerm*transmittanceNdotL*info.attenuation*lightColor;}
#endif
#ifdef SPECULARTERM
vec3 computeSpecularLighting(preLightingInfo info,vec3 N,vec3 reflectance0,vec3 reflectance90,float geometricRoughnessFactor,vec3 lightColor) {float NdotH=saturateEps(dot(N,info.H));float roughness=max(info.roughness,geometricRoughnessFactor);float alphaG=convertRoughnessToAverageSlope(roughness);vec3 fresnel=fresnelSchlickGGX(info.VdotH,reflectance0,reflectance90);
#ifdef IRIDESCENCE
fresnel=mix(fresnel,reflectance0,info.iridescenceIntensity);
#endif
float distribution=normalDistributionFunction_TrowbridgeReitzGGX(NdotH,alphaG);
#ifdef BRDF_V_HEIGHT_CORRELATED
float smithVisibility=smithVisibility_GGXCorrelated(info.NdotL,info.NdotV,alphaG);
#else
float smithVisibility=smithVisibility_TrowbridgeReitzGGXFast(info.NdotL,info.NdotV,alphaG);
#endif
vec3 specTerm=fresnel*distribution*smithVisibility;return specTerm*info.attenuation*info.NdotL*lightColor;}
#endif
#ifdef ANISOTROPIC
vec3 computeAnisotropicSpecularLighting(preLightingInfo info,vec3 V,vec3 N,vec3 T,vec3 B,float anisotropy,vec3 reflectance0,vec3 reflectance90,float geometricRoughnessFactor,vec3 lightColor) {float NdotH=saturateEps(dot(N,info.H));float TdotH=dot(T,info.H);float BdotH=dot(B,info.H);float TdotV=dot(T,V);float BdotV=dot(B,V);float TdotL=dot(T,info.L);float BdotL=dot(B,info.L);float alphaG=convertRoughnessToAverageSlope(info.roughness);vec2 alphaTB=getAnisotropicRoughness(alphaG,anisotropy);alphaTB=max(alphaTB,square(geometricRoughnessFactor));vec3 fresnel=fresnelSchlickGGX(info.VdotH,reflectance0,reflectance90);
#ifdef IRIDESCENCE
fresnel=mix(fresnel,reflectance0,info.iridescenceIntensity);
#endif
float distribution=normalDistributionFunction_BurleyGGX_Anisotropic(NdotH,TdotH,BdotH,alphaTB);float smithVisibility=smithVisibility_GGXCorrelated_Anisotropic(info.NdotL,info.NdotV,TdotV,BdotV,TdotL,BdotL,alphaTB);vec3 specTerm=fresnel*distribution*smithVisibility;return specTerm*info.attenuation*info.NdotL*lightColor;}
#endif
#ifdef CLEARCOAT
vec4 computeClearCoatLighting(preLightingInfo info,vec3 Ncc,float geometricRoughnessFactor,float clearCoatIntensity,vec3 lightColor) {float NccdotL=saturateEps(dot(Ncc,info.L));float NccdotH=saturateEps(dot(Ncc,info.H));float clearCoatRoughness=max(info.roughness,geometricRoughnessFactor);float alphaG=convertRoughnessToAverageSlope(clearCoatRoughness);float fresnel=fresnelSchlickGGX(info.VdotH,vClearCoatRefractionParams.x,CLEARCOATREFLECTANCE90);fresnel*=clearCoatIntensity;float distribution=normalDistributionFunction_TrowbridgeReitzGGX(NccdotH,alphaG);float kelemenVisibility=visibility_Kelemen(info.VdotH);float clearCoatTerm=fresnel*distribution*kelemenVisibility;return vec4(
clearCoatTerm*info.attenuation*NccdotL*lightColor,
1.0-fresnel
);}
vec3 computeClearCoatLightingAbsorption(float NdotVRefract,vec3 L,vec3 Ncc,vec3 clearCoatColor,float clearCoatThickness,float clearCoatIntensity) {vec3 LRefract=-refract(L,Ncc,vClearCoatRefractionParams.y);float NdotLRefract=saturateEps(dot(Ncc,LRefract));vec3 absorption=computeClearCoatAbsorption(NdotVRefract,NdotLRefract,clearCoatColor,clearCoatThickness,clearCoatIntensity);return absorption;}
#endif
#ifdef SHEEN
vec3 computeSheenLighting(preLightingInfo info,vec3 N,vec3 reflectance0,vec3 reflectance90,float geometricRoughnessFactor,vec3 lightColor) {float NdotH=saturateEps(dot(N,info.H));float roughness=max(info.roughness,geometricRoughnessFactor);float alphaG=convertRoughnessToAverageSlope(roughness);float fresnel=1.;float distribution=normalDistributionFunction_CharlieSheen(NdotH,alphaG);/*#ifdef SHEEN_SOFTER
float visibility=visibility_CharlieSheen(info.NdotL,info.NdotV,alphaG);
#else */
float visibility=visibility_Ashikhmin(info.NdotL,info.NdotV);/* #endif */
float sheenTerm=fresnel*distribution*visibility;return sheenTerm*info.attenuation*info.NdotL*lightColor;}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$5fd1794ea31783db$var$name] = $5fd1794ea31783db$var$shader;
const $5fd1794ea31783db$export$978feded9a5ae4bb = {
    name: $5fd1794ea31783db$var$name,
    shader: $5fd1794ea31783db$var$shader
};

});

parcelRegister("3quE9", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $27eb92904fae0aa7$var$name = "pbrIBLFunctions";
const $27eb92904fae0aa7$var$shader = `#if defined(REFLECTION) || defined(SS_REFRACTION)
float getLodFromAlphaG(float cubeMapDimensionPixels,float microsurfaceAverageSlope) {float microsurfaceAverageSlopeTexels=cubeMapDimensionPixels*microsurfaceAverageSlope;float lod=log2(microsurfaceAverageSlopeTexels);return lod;}
float getLinearLodFromRoughness(float cubeMapDimensionPixels,float roughness) {float lod=log2(cubeMapDimensionPixels)*roughness;return lod;}
#endif
#if defined(ENVIRONMENTBRDF) && defined(RADIANCEOCCLUSION)
float environmentRadianceOcclusion(float ambientOcclusion,float NdotVUnclamped) {float temp=NdotVUnclamped+ambientOcclusion;return saturate(square(temp)-1.0+ambientOcclusion);}
#endif
#if defined(ENVIRONMENTBRDF) && defined(HORIZONOCCLUSION)
float environmentHorizonOcclusion(vec3 view,vec3 normal,vec3 geometricNormal) {vec3 reflection=reflect(view,normal);float temp=saturate(1.0+1.1*dot(reflection,geometricNormal));return square(temp);}
#endif
#if defined(LODINREFLECTIONALPHA) || defined(SS_LODINREFRACTIONALPHA)
#define UNPACK_LOD(x) (1.0-x)*255.0
float getLodFromAlphaG(float cubeMapDimensionPixels,float alphaG,float NdotV) {float microsurfaceAverageSlope=alphaG;microsurfaceAverageSlope*=sqrt(abs(NdotV));return getLodFromAlphaG(cubeMapDimensionPixels,microsurfaceAverageSlope);}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$27eb92904fae0aa7$var$name] = $27eb92904fae0aa7$var$shader;
const $27eb92904fae0aa7$export$a30a7e49070edae4 = {
    name: $27eb92904fae0aa7$var$name,
    shader: $27eb92904fae0aa7$var$shader
};

});

parcelRegister("fb4Jc", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("lP7hO");
const $b0cb8cfb29e0470a$var$name = "pbrBlockAlbedoOpacity";
const $b0cb8cfb29e0470a$var$shader = `struct albedoOpacityOutParams
{vec3 surfaceAlbedo;float alpha;};
#define pbr_inline
void albedoOpacityBlock(
in vec4 vAlbedoColor,
#ifdef ALBEDO
in vec4 albedoTexture,
in vec2 albedoInfos,
#endif
#ifdef OPACITY
in vec4 opacityMap,
in vec2 vOpacityInfos,
#endif
#ifdef DETAIL
in vec4 detailColor,
in vec4 vDetailInfos,
#endif
#ifdef DECAL
in vec4 decalColor,
in vec4 vDecalInfos,
#endif
out albedoOpacityOutParams outParams
)
{vec3 surfaceAlbedo=vAlbedoColor.rgb;float alpha=vAlbedoColor.a;
#ifdef ALBEDO
#if defined(ALPHAFROMALBEDO) || defined(ALPHATEST)
alpha*=albedoTexture.a;
#endif
#ifdef GAMMAALBEDO
surfaceAlbedo*=toLinearSpace(albedoTexture.rgb);
#else
surfaceAlbedo*=albedoTexture.rgb;
#endif
surfaceAlbedo*=albedoInfos.y;
#endif
#ifndef DECAL_AFTER_DETAIL
#include<decalFragment>
#endif
#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
surfaceAlbedo*=vColor.rgb;
#endif
#ifdef DETAIL
float detailAlbedo=2.0*mix(0.5,detailColor.r,vDetailInfos.y);surfaceAlbedo.rgb=surfaceAlbedo.rgb*detailAlbedo*detailAlbedo; 
#endif
#ifdef DECAL_AFTER_DETAIL
#include<decalFragment>
#endif
#define CUSTOM_FRAGMENT_UPDATE_ALBEDO
#ifdef OPACITY
#ifdef OPACITYRGB
alpha=getLuminance(opacityMap.rgb);
#else
alpha*=opacityMap.a;
#endif
alpha*=vOpacityInfos.y;
#endif
#if defined(VERTEXALPHA) || defined(INSTANCESCOLOR) && defined(INSTANCES)
alpha*=vColor.a;
#endif
#if !defined(SS_LINKREFRACTIONTOTRANSPARENCY) && !defined(ALPHAFRESNEL)
#ifdef ALPHATEST 
#if DEBUGMODE != 88
if (alpha<ALPHATESTVALUE)
discard;
#endif
#ifndef ALPHABLEND
alpha=1.0;
#endif
#endif
#endif
outParams.surfaceAlbedo=surfaceAlbedo;outParams.alpha=alpha;}
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$b0cb8cfb29e0470a$var$name] = $b0cb8cfb29e0470a$var$shader;
const $b0cb8cfb29e0470a$export$2f18fc50cebf8d9c = {
    name: $b0cb8cfb29e0470a$var$name,
    shader: $b0cb8cfb29e0470a$var$shader
};

});

parcelRegister("3xnAu", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $2936c025278b444b$var$name = "pbrBlockReflectivity";
const $2936c025278b444b$var$shader = `struct reflectivityOutParams
{float microSurface;float roughness;vec3 surfaceReflectivityColor;
#ifdef METALLICWORKFLOW
vec3 surfaceAlbedo;
#endif
#if defined(METALLICWORKFLOW) && defined(REFLECTIVITY) && defined(AOSTOREINMETALMAPRED)
vec3 ambientOcclusionColor;
#endif
#if DEBUGMODE>0
#ifdef METALLICWORKFLOW
vec2 metallicRoughness;
#ifdef REFLECTIVITY
vec4 surfaceMetallicColorMap;
#endif
#ifndef FROSTBITE_REFLECTANCE
vec3 metallicF0;
#endif
#else
#ifdef REFLECTIVITY
vec4 surfaceReflectivityColorMap;
#endif
#endif
#endif
};
#define pbr_inline
void reflectivityBlock(
in vec4 vReflectivityColor,
#ifdef METALLICWORKFLOW
in vec3 surfaceAlbedo,
in vec4 metallicReflectanceFactors,
#endif
#ifdef REFLECTIVITY
in vec3 reflectivityInfos,
in vec4 surfaceMetallicOrReflectivityColorMap,
#endif
#if defined(METALLICWORKFLOW) && defined(REFLECTIVITY) && defined(AOSTOREINMETALMAPRED)
in vec3 ambientOcclusionColorIn,
#endif
#ifdef MICROSURFACEMAP
in vec4 microSurfaceTexel,
#endif
#ifdef DETAIL
in vec4 detailColor,
in vec4 vDetailInfos,
#endif
out reflectivityOutParams outParams
)
{float microSurface=vReflectivityColor.a;vec3 surfaceReflectivityColor=vReflectivityColor.rgb;
#ifdef METALLICWORKFLOW
vec2 metallicRoughness=surfaceReflectivityColor.rg;
#ifdef REFLECTIVITY
#if DEBUGMODE>0
outParams.surfaceMetallicColorMap=surfaceMetallicOrReflectivityColorMap;
#endif
#ifdef AOSTOREINMETALMAPRED
vec3 aoStoreInMetalMap=vec3(surfaceMetallicOrReflectivityColorMap.r,surfaceMetallicOrReflectivityColorMap.r,surfaceMetallicOrReflectivityColorMap.r);outParams.ambientOcclusionColor=mix(ambientOcclusionColorIn,aoStoreInMetalMap,reflectivityInfos.z);
#endif
#ifdef METALLNESSSTOREINMETALMAPBLUE
metallicRoughness.r*=surfaceMetallicOrReflectivityColorMap.b;
#else
metallicRoughness.r*=surfaceMetallicOrReflectivityColorMap.r;
#endif
#ifdef ROUGHNESSSTOREINMETALMAPALPHA
metallicRoughness.g*=surfaceMetallicOrReflectivityColorMap.a;
#else
#ifdef ROUGHNESSSTOREINMETALMAPGREEN
metallicRoughness.g*=surfaceMetallicOrReflectivityColorMap.g;
#endif
#endif
#endif
#ifdef DETAIL
float detailRoughness=mix(0.5,detailColor.b,vDetailInfos.w);float loLerp=mix(0.,metallicRoughness.g,detailRoughness*2.);float hiLerp=mix(metallicRoughness.g,1.,(detailRoughness-0.5)*2.);metallicRoughness.g=mix(loLerp,hiLerp,step(detailRoughness,0.5));
#endif
#ifdef MICROSURFACEMAP
metallicRoughness.g*=microSurfaceTexel.r;
#endif
#if DEBUGMODE>0
outParams.metallicRoughness=metallicRoughness;
#endif
#define CUSTOM_FRAGMENT_UPDATE_METALLICROUGHNESS
microSurface=1.0-metallicRoughness.g;vec3 baseColor=surfaceAlbedo;
#ifdef FROSTBITE_REFLECTANCE
outParams.surfaceAlbedo=baseColor.rgb*(1.0-metallicRoughness.r);surfaceReflectivityColor=mix(0.16*reflectance*reflectance,baseColor,metallicRoughness.r);
#else
vec3 metallicF0=metallicReflectanceFactors.rgb;
#if DEBUGMODE>0
outParams.metallicF0=metallicF0;
#endif
outParams.surfaceAlbedo=mix(baseColor.rgb*(1.0-metallicF0),vec3(0.,0.,0.),metallicRoughness.r);surfaceReflectivityColor=mix(metallicF0,baseColor,metallicRoughness.r);
#endif
#else
#ifdef REFLECTIVITY
surfaceReflectivityColor*=surfaceMetallicOrReflectivityColorMap.rgb;
#if DEBUGMODE>0
outParams.surfaceReflectivityColorMap=surfaceMetallicOrReflectivityColorMap;
#endif
#ifdef MICROSURFACEFROMREFLECTIVITYMAP
microSurface*=surfaceMetallicOrReflectivityColorMap.a;microSurface*=reflectivityInfos.z;
#else
#ifdef MICROSURFACEAUTOMATIC
microSurface*=computeDefaultMicroSurface(microSurface,surfaceReflectivityColor);
#endif
#ifdef MICROSURFACEMAP
microSurface*=microSurfaceTexel.r;
#endif
#define CUSTOM_FRAGMENT_UPDATE_MICROSURFACE
#endif
#endif
#endif
microSurface=saturate(microSurface);float roughness=1.-microSurface;outParams.microSurface=microSurface;outParams.roughness=roughness;outParams.surfaceReflectivityColor=surfaceReflectivityColor;}
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$2936c025278b444b$var$name] = $2936c025278b444b$var$shader;
const $2936c025278b444b$export$934d659496779d34 = {
    name: $2936c025278b444b$var$name,
    shader: $2936c025278b444b$var$shader
};

});

parcelRegister("9L9o4", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $71afc8f42f88cd57$var$name = "pbrBlockAmbientOcclusion";
const $71afc8f42f88cd57$var$shader = `struct ambientOcclusionOutParams
{vec3 ambientOcclusionColor;
#if DEBUGMODE>0 && defined(AMBIENT)
vec3 ambientOcclusionColorMap;
#endif
};
#define pbr_inline
void ambientOcclusionBlock(
#ifdef AMBIENT
in vec3 ambientOcclusionColorMap_,
in vec4 vAmbientInfos,
#endif
out ambientOcclusionOutParams outParams
)
{vec3 ambientOcclusionColor=vec3(1.,1.,1.);
#ifdef AMBIENT
vec3 ambientOcclusionColorMap=ambientOcclusionColorMap_*vAmbientInfos.y;
#ifdef AMBIENTINGRAYSCALE
ambientOcclusionColorMap=vec3(ambientOcclusionColorMap.r,ambientOcclusionColorMap.r,ambientOcclusionColorMap.r);
#endif
ambientOcclusionColor=mix(ambientOcclusionColor,ambientOcclusionColorMap,vAmbientInfos.z);
#if DEBUGMODE>0
outParams.ambientOcclusionColorMap=ambientOcclusionColorMap;
#endif
#endif
outParams.ambientOcclusionColor=ambientOcclusionColor;}
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$71afc8f42f88cd57$var$name] = $71afc8f42f88cd57$var$shader;
const $71afc8f42f88cd57$export$a6a40a9dc3c2a833 = {
    name: $71afc8f42f88cd57$var$name,
    shader: $71afc8f42f88cd57$var$shader
};

});

parcelRegister("3bYfn", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $253121f884997c64$var$name = "pbrBlockAlphaFresnel";
const $253121f884997c64$var$shader = `#ifdef ALPHAFRESNEL
#if defined(ALPHATEST) || defined(ALPHABLEND)
struct alphaFresnelOutParams
{float alpha;};
#define pbr_inline
void alphaFresnelBlock(
in vec3 normalW,
in vec3 viewDirectionW,
in float alpha,
in float microSurface,
out alphaFresnelOutParams outParams
)
{float opacityPerceptual=alpha;
#ifdef LINEARALPHAFRESNEL
float opacity0=opacityPerceptual;
#else
float opacity0=opacityPerceptual*opacityPerceptual;
#endif
float opacity90=fresnelGrazingReflectance(opacity0);vec3 normalForward=faceforward(normalW,-viewDirectionW,normalW);outParams.alpha=getReflectanceFromAnalyticalBRDFLookup_Jones(saturate(dot(viewDirectionW,normalForward)),vec3(opacity0),vec3(opacity90),sqrt(microSurface)).x;
#ifdef ALPHATEST
if (outParams.alpha<ALPHATESTVALUE)
discard;
#ifndef ALPHABLEND
outParams.alpha=1.0;
#endif
#endif
}
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$253121f884997c64$var$name] = $253121f884997c64$var$shader;
const $253121f884997c64$export$506f40f290559a0e = {
    name: $253121f884997c64$var$name,
    shader: $253121f884997c64$var$shader
};

});

parcelRegister("b4A2m", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $80fc05a5acef487c$var$name = "pbrBlockAnisotropic";
const $80fc05a5acef487c$var$shader = `#ifdef ANISOTROPIC
struct anisotropicOutParams
{float anisotropy;vec3 anisotropicTangent;vec3 anisotropicBitangent;vec3 anisotropicNormal;
#if DEBUGMODE>0 && defined(ANISOTROPIC_TEXTURE)
vec3 anisotropyMapData;
#endif
};
#define pbr_inline
void anisotropicBlock(
in vec3 vAnisotropy,
in float roughness,
#ifdef ANISOTROPIC_TEXTURE
in vec3 anisotropyMapData,
#endif
in mat3 TBN,
in vec3 normalW,
in vec3 viewDirectionW,
out anisotropicOutParams outParams
)
{float anisotropy=vAnisotropy.b;vec3 anisotropyDirection=vec3(vAnisotropy.xy,0.);
#ifdef ANISOTROPIC_TEXTURE
anisotropy*=anisotropyMapData.b;
#if DEBUGMODE>0
outParams.anisotropyMapData=anisotropyMapData;
#endif
anisotropyMapData.rg=anisotropyMapData.rg*2.0-1.0;
#ifdef ANISOTROPIC_LEGACY
anisotropyDirection.rg*=anisotropyMapData.rg;
#else
anisotropyDirection.xy=mat2(anisotropyDirection.x,anisotropyDirection.y,-anisotropyDirection.y,anisotropyDirection.x)*normalize(anisotropyMapData.rg);
#endif
#endif
mat3 anisoTBN=mat3(normalize(TBN[0]),normalize(TBN[1]),normalize(TBN[2]));vec3 anisotropicTangent=normalize(anisoTBN*anisotropyDirection);vec3 anisotropicBitangent=normalize(cross(anisoTBN[2],anisotropicTangent));outParams.anisotropy=anisotropy;outParams.anisotropicTangent=anisotropicTangent;outParams.anisotropicBitangent=anisotropicBitangent;outParams.anisotropicNormal=getAnisotropicBentNormals(anisotropicTangent,anisotropicBitangent,normalW,viewDirectionW,anisotropy,roughness);}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$80fc05a5acef487c$var$name] = $80fc05a5acef487c$var$shader;
const $80fc05a5acef487c$export$1349e024c79c70b2 = {
    name: $80fc05a5acef487c$var$name,
    shader: $80fc05a5acef487c$var$shader
};

});

parcelRegister("f3wp7", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $af60459fff3143c0$var$name = "pbrBlockReflection";
const $af60459fff3143c0$var$shader = `#ifdef REFLECTION
struct reflectionOutParams
{vec4 environmentRadiance;vec3 environmentIrradiance;
#ifdef REFLECTIONMAP_3D
vec3 reflectionCoords;
#else
vec2 reflectionCoords;
#endif
#ifdef SS_TRANSLUCENCY
#ifdef USESPHERICALFROMREFLECTIONMAP
#if !defined(NORMAL) || !defined(USESPHERICALINVERTEX)
vec3 irradianceVector;
#endif
#endif
#endif
};
#define pbr_inline
void createReflectionCoords(
in vec3 vPositionW,
in vec3 normalW,
#ifdef ANISOTROPIC
in anisotropicOutParams anisotropicOut,
#endif
#ifdef REFLECTIONMAP_3D
out vec3 reflectionCoords
#else
out vec2 reflectionCoords
#endif
)
{
#ifdef ANISOTROPIC
vec3 reflectionVector=computeReflectionCoords(vec4(vPositionW,1.0),anisotropicOut.anisotropicNormal);
#else
vec3 reflectionVector=computeReflectionCoords(vec4(vPositionW,1.0),normalW);
#endif
#ifdef REFLECTIONMAP_OPPOSITEZ
reflectionVector.z*=-1.0;
#endif
#ifdef REFLECTIONMAP_3D
reflectionCoords=reflectionVector;
#else
reflectionCoords=reflectionVector.xy;
#ifdef REFLECTIONMAP_PROJECTION
reflectionCoords/=reflectionVector.z;
#endif
reflectionCoords.y=1.0-reflectionCoords.y;
#endif
}
#define pbr_inline
#define inline
void sampleReflectionTexture(
in float alphaG,
in vec3 vReflectionMicrosurfaceInfos,
in vec2 vReflectionInfos,
in vec3 vReflectionColor,
#if defined(LODINREFLECTIONALPHA) && !defined(REFLECTIONMAP_SKYBOX)
in float NdotVUnclamped,
#endif
#ifdef LINEARSPECULARREFLECTION
in float roughness,
#endif
#ifdef REFLECTIONMAP_3D
in samplerCube reflectionSampler,
const vec3 reflectionCoords,
#else
in sampler2D reflectionSampler,
const vec2 reflectionCoords,
#endif
#ifndef LODBASEDMICROSFURACE
#ifdef REFLECTIONMAP_3D
in samplerCube reflectionSamplerLow,
in samplerCube reflectionSamplerHigh,
#else
in sampler2D reflectionSamplerLow,
in sampler2D reflectionSamplerHigh,
#endif
#endif
#ifdef REALTIME_FILTERING
in vec2 vReflectionFilteringInfo,
#endif
out vec4 environmentRadiance
)
{
#if defined(LODINREFLECTIONALPHA) && !defined(REFLECTIONMAP_SKYBOX)
float reflectionLOD=getLodFromAlphaG(vReflectionMicrosurfaceInfos.x,alphaG,NdotVUnclamped);
#elif defined(LINEARSPECULARREFLECTION)
float reflectionLOD=getLinearLodFromRoughness(vReflectionMicrosurfaceInfos.x,roughness);
#else
float reflectionLOD=getLodFromAlphaG(vReflectionMicrosurfaceInfos.x,alphaG);
#endif
#ifdef LODBASEDMICROSFURACE
reflectionLOD=reflectionLOD*vReflectionMicrosurfaceInfos.y+vReflectionMicrosurfaceInfos.z;
#ifdef LODINREFLECTIONALPHA
float automaticReflectionLOD=UNPACK_LOD(sampleReflection(reflectionSampler,reflectionCoords).a);float requestedReflectionLOD=max(automaticReflectionLOD,reflectionLOD);
#else
float requestedReflectionLOD=reflectionLOD;
#endif
#ifdef REALTIME_FILTERING
environmentRadiance=vec4(radiance(alphaG,reflectionSampler,reflectionCoords,vReflectionFilteringInfo),1.0);
#else
environmentRadiance=sampleReflectionLod(reflectionSampler,reflectionCoords,reflectionLOD);
#endif
#else
float lodReflectionNormalized=saturate(reflectionLOD/log2(vReflectionMicrosurfaceInfos.x));float lodReflectionNormalizedDoubled=lodReflectionNormalized*2.0;vec4 environmentMid=sampleReflection(reflectionSampler,reflectionCoords);if (lodReflectionNormalizedDoubled<1.0){environmentRadiance=mix(
sampleReflection(reflectionSamplerHigh,reflectionCoords),
environmentMid,
lodReflectionNormalizedDoubled
);} else {environmentRadiance=mix(
environmentMid,
sampleReflection(reflectionSamplerLow,reflectionCoords),
lodReflectionNormalizedDoubled-1.0
);}
#endif
#ifdef RGBDREFLECTION
environmentRadiance.rgb=fromRGBD(environmentRadiance);
#endif
#ifdef GAMMAREFLECTION
environmentRadiance.rgb=toLinearSpace(environmentRadiance.rgb);
#endif
environmentRadiance.rgb*=vReflectionInfos.x;environmentRadiance.rgb*=vReflectionColor.rgb;}
#define pbr_inline
#define inline
void reflectionBlock(
in vec3 vPositionW,
in vec3 normalW,
in float alphaG,
in vec3 vReflectionMicrosurfaceInfos,
in vec2 vReflectionInfos,
in vec3 vReflectionColor,
#ifdef ANISOTROPIC
in anisotropicOutParams anisotropicOut,
#endif
#if defined(LODINREFLECTIONALPHA) && !defined(REFLECTIONMAP_SKYBOX)
in float NdotVUnclamped,
#endif
#ifdef LINEARSPECULARREFLECTION
in float roughness,
#endif
#ifdef REFLECTIONMAP_3D
in samplerCube reflectionSampler,
#else
in sampler2D reflectionSampler,
#endif
#if defined(NORMAL) && defined(USESPHERICALINVERTEX)
in vec3 vEnvironmentIrradiance,
#endif
#ifdef USESPHERICALFROMREFLECTIONMAP
#if !defined(NORMAL) || !defined(USESPHERICALINVERTEX)
in mat4 reflectionMatrix,
#endif
#endif
#ifdef USEIRRADIANCEMAP
#ifdef REFLECTIONMAP_3D
in samplerCube irradianceSampler,
#else
in sampler2D irradianceSampler,
#endif
#endif
#ifndef LODBASEDMICROSFURACE
#ifdef REFLECTIONMAP_3D
in samplerCube reflectionSamplerLow,
in samplerCube reflectionSamplerHigh,
#else
in sampler2D reflectionSamplerLow,
in sampler2D reflectionSamplerHigh,
#endif
#endif
#ifdef REALTIME_FILTERING
in vec2 vReflectionFilteringInfo,
#endif
out reflectionOutParams outParams
)
{vec4 environmentRadiance=vec4(0.,0.,0.,0.);
#ifdef REFLECTIONMAP_3D
vec3 reflectionCoords=vec3(0.);
#else
vec2 reflectionCoords=vec2(0.);
#endif
createReflectionCoords(
vPositionW,
normalW,
#ifdef ANISOTROPIC
anisotropicOut,
#endif
reflectionCoords
);sampleReflectionTexture(
alphaG,
vReflectionMicrosurfaceInfos,
vReflectionInfos,
vReflectionColor,
#if defined(LODINREFLECTIONALPHA) && !defined(REFLECTIONMAP_SKYBOX)
NdotVUnclamped,
#endif
#ifdef LINEARSPECULARREFLECTION
roughness,
#endif
#ifdef REFLECTIONMAP_3D
reflectionSampler,
reflectionCoords,
#else
reflectionSampler,
reflectionCoords,
#endif
#ifndef LODBASEDMICROSFURACE
reflectionSamplerLow,
reflectionSamplerHigh,
#endif
#ifdef REALTIME_FILTERING
vReflectionFilteringInfo,
#endif
environmentRadiance
);vec3 environmentIrradiance=vec3(0.,0.,0.);
#ifdef USESPHERICALFROMREFLECTIONMAP
#if defined(NORMAL) && defined(USESPHERICALINVERTEX)
environmentIrradiance=vEnvironmentIrradiance;
#else
#ifdef ANISOTROPIC
vec3 irradianceVector=vec3(reflectionMatrix*vec4(anisotropicOut.anisotropicNormal,0)).xyz;
#else
vec3 irradianceVector=vec3(reflectionMatrix*vec4(normalW,0)).xyz;
#endif
#ifdef REFLECTIONMAP_OPPOSITEZ
irradianceVector.z*=-1.0;
#endif
#ifdef INVERTCUBICMAP
irradianceVector.y*=-1.0;
#endif
#if defined(REALTIME_FILTERING)
environmentIrradiance=irradiance(reflectionSampler,irradianceVector,vReflectionFilteringInfo);
#else
environmentIrradiance=computeEnvironmentIrradiance(irradianceVector);
#endif
#ifdef SS_TRANSLUCENCY
outParams.irradianceVector=irradianceVector;
#endif
#endif
#elif defined(USEIRRADIANCEMAP)
vec4 environmentIrradiance4=sampleReflection(irradianceSampler,reflectionCoords);environmentIrradiance=environmentIrradiance4.rgb;
#ifdef RGBDREFLECTION
environmentIrradiance.rgb=fromRGBD(environmentIrradiance4);
#endif
#ifdef GAMMAREFLECTION
environmentIrradiance.rgb=toLinearSpace(environmentIrradiance.rgb);
#endif
#endif
environmentIrradiance*=vReflectionColor.rgb;outParams.environmentRadiance=environmentRadiance;outParams.environmentIrradiance=environmentIrradiance;outParams.reflectionCoords=reflectionCoords;}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$af60459fff3143c0$var$name] = $af60459fff3143c0$var$shader;
const $af60459fff3143c0$export$429d3b25ba720a20 = {
    name: $af60459fff3143c0$var$name,
    shader: $af60459fff3143c0$var$shader
};

});

parcelRegister("klCsf", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $ed03991baebd7fc3$var$name = "pbrBlockSheen";
const $ed03991baebd7fc3$var$shader = `#ifdef SHEEN
struct sheenOutParams
{float sheenIntensity;vec3 sheenColor;float sheenRoughness;
#ifdef SHEEN_LINKWITHALBEDO
vec3 surfaceAlbedo;
#endif
#if defined(ENVIRONMENTBRDF) && defined(SHEEN_ALBEDOSCALING)
float sheenAlbedoScaling;
#endif
#if defined(REFLECTION) && defined(ENVIRONMENTBRDF)
vec3 finalSheenRadianceScaled;
#endif
#if DEBUGMODE>0
#ifdef SHEEN_TEXTURE
vec4 sheenMapData;
#endif
#if defined(REFLECTION) && defined(ENVIRONMENTBRDF)
vec3 sheenEnvironmentReflectance;
#endif
#endif
};
#define pbr_inline
#define inline
void sheenBlock(
in vec4 vSheenColor,
#ifdef SHEEN_ROUGHNESS
in float vSheenRoughness,
#if defined(SHEEN_TEXTURE_ROUGHNESS) && !defined(SHEEN_TEXTURE_ROUGHNESS_IDENTICAL) && !defined(SHEEN_USE_ROUGHNESS_FROM_MAINTEXTURE)
in vec4 sheenMapRoughnessData,
#endif
#endif
in float roughness,
#ifdef SHEEN_TEXTURE
in vec4 sheenMapData,
in float sheenMapLevel,
#endif
in float reflectance,
#ifdef SHEEN_LINKWITHALBEDO
in vec3 baseColor,
in vec3 surfaceAlbedo,
#endif
#ifdef ENVIRONMENTBRDF
in float NdotV,
in vec3 environmentBrdf,
#endif
#if defined(REFLECTION) && defined(ENVIRONMENTBRDF)
in vec2 AARoughnessFactors,
in vec3 vReflectionMicrosurfaceInfos,
in vec2 vReflectionInfos,
in vec3 vReflectionColor,
in vec4 vLightingIntensity,
#ifdef REFLECTIONMAP_3D
in samplerCube reflectionSampler,
in vec3 reflectionCoords,
#else
in sampler2D reflectionSampler,
in vec2 reflectionCoords,
#endif
in float NdotVUnclamped,
#ifndef LODBASEDMICROSFURACE
#ifdef REFLECTIONMAP_3D
in samplerCube reflectionSamplerLow,
in samplerCube reflectionSamplerHigh,
#else
in sampler2D reflectionSamplerLow,
in sampler2D reflectionSamplerHigh,
#endif
#endif
#ifdef REALTIME_FILTERING
in vec2 vReflectionFilteringInfo,
#endif
#if !defined(REFLECTIONMAP_SKYBOX) && defined(RADIANCEOCCLUSION)
in float seo,
#endif
#if !defined(REFLECTIONMAP_SKYBOX) && defined(HORIZONOCCLUSION) && defined(BUMP) && defined(REFLECTIONMAP_3D)
in float eho,
#endif
#endif
out sheenOutParams outParams
)
{float sheenIntensity=vSheenColor.a;
#ifdef SHEEN_TEXTURE
#if DEBUGMODE>0
outParams.sheenMapData=sheenMapData;
#endif
#endif
#ifdef SHEEN_LINKWITHALBEDO
float sheenFactor=pow5(1.0-sheenIntensity);vec3 sheenColor=baseColor.rgb*(1.0-sheenFactor);float sheenRoughness=sheenIntensity;outParams.surfaceAlbedo=surfaceAlbedo*sheenFactor;
#ifdef SHEEN_TEXTURE
sheenIntensity*=sheenMapData.a;
#endif
#else
vec3 sheenColor=vSheenColor.rgb;
#ifdef SHEEN_TEXTURE
#ifdef SHEEN_GAMMATEXTURE
sheenColor.rgb*=toLinearSpace(sheenMapData.rgb);
#else
sheenColor.rgb*=sheenMapData.rgb;
#endif
sheenColor.rgb*=sheenMapLevel;
#endif
#ifdef SHEEN_ROUGHNESS
float sheenRoughness=vSheenRoughness;
#ifdef SHEEN_USE_ROUGHNESS_FROM_MAINTEXTURE
#if defined(SHEEN_TEXTURE)
sheenRoughness*=sheenMapData.a;
#endif
#elif defined(SHEEN_TEXTURE_ROUGHNESS)
#ifdef SHEEN_TEXTURE_ROUGHNESS_IDENTICAL
sheenRoughness*=sheenMapData.a;
#else
sheenRoughness*=sheenMapRoughnessData.a;
#endif
#endif
#else
float sheenRoughness=roughness;
#ifdef SHEEN_TEXTURE
sheenIntensity*=sheenMapData.a;
#endif
#endif
#if !defined(SHEEN_ALBEDOSCALING)
sheenIntensity*=(1.-reflectance);
#endif
sheenColor*=sheenIntensity;
#endif
#ifdef ENVIRONMENTBRDF
/*#ifdef SHEEN_SOFTER
vec3 environmentSheenBrdf=vec3(0.,0.,getBRDFLookupCharlieSheen(NdotV,sheenRoughness));
#else*/
#ifdef SHEEN_ROUGHNESS
vec3 environmentSheenBrdf=getBRDFLookup(NdotV,sheenRoughness);
#else
vec3 environmentSheenBrdf=environmentBrdf;
#endif
/*#endif*/
#endif
#if defined(REFLECTION) && defined(ENVIRONMENTBRDF)
float sheenAlphaG=convertRoughnessToAverageSlope(sheenRoughness);
#ifdef SPECULARAA
sheenAlphaG+=AARoughnessFactors.y;
#endif
vec4 environmentSheenRadiance=vec4(0.,0.,0.,0.);sampleReflectionTexture(
sheenAlphaG,
vReflectionMicrosurfaceInfos,
vReflectionInfos,
vReflectionColor,
#if defined(LODINREFLECTIONALPHA) && !defined(REFLECTIONMAP_SKYBOX)
NdotVUnclamped,
#endif
#ifdef LINEARSPECULARREFLECTION
sheenRoughness,
#endif
reflectionSampler,
reflectionCoords,
#ifndef LODBASEDMICROSFURACE
reflectionSamplerLow,
reflectionSamplerHigh,
#endif
#ifdef REALTIME_FILTERING
vReflectionFilteringInfo,
#endif
environmentSheenRadiance
);vec3 sheenEnvironmentReflectance=getSheenReflectanceFromBRDFLookup(sheenColor,environmentSheenBrdf);
#if !defined(REFLECTIONMAP_SKYBOX) && defined(RADIANCEOCCLUSION)
sheenEnvironmentReflectance*=seo;
#endif
#if !defined(REFLECTIONMAP_SKYBOX) && defined(HORIZONOCCLUSION) && defined(BUMP) && defined(REFLECTIONMAP_3D)
sheenEnvironmentReflectance*=eho;
#endif
#if DEBUGMODE>0
outParams.sheenEnvironmentReflectance=sheenEnvironmentReflectance;
#endif
outParams.finalSheenRadianceScaled=
environmentSheenRadiance.rgb *
sheenEnvironmentReflectance *
vLightingIntensity.z;
#endif
#if defined(ENVIRONMENTBRDF) && defined(SHEEN_ALBEDOSCALING)
outParams.sheenAlbedoScaling=1.0-sheenIntensity*max(max(sheenColor.r,sheenColor.g),sheenColor.b)*environmentSheenBrdf.b;
#endif
outParams.sheenIntensity=sheenIntensity;outParams.sheenColor=sheenColor;outParams.sheenRoughness=sheenRoughness;}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$ed03991baebd7fc3$var$name] = $ed03991baebd7fc3$var$shader;
const $ed03991baebd7fc3$export$1d2995b26501fa4b = {
    name: $ed03991baebd7fc3$var$name,
    shader: $ed03991baebd7fc3$var$shader
};

});

parcelRegister("kqYVA", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $ee057f579a5e451c$var$name = "pbrBlockClearcoat";
const $ee057f579a5e451c$var$shader = `struct clearcoatOutParams
{vec3 specularEnvironmentR0;float conservationFactor;vec3 clearCoatNormalW;vec2 clearCoatAARoughnessFactors;float clearCoatIntensity;float clearCoatRoughness;
#ifdef REFLECTION
vec3 finalClearCoatRadianceScaled;
#endif
#ifdef CLEARCOAT_TINT
vec3 absorption;float clearCoatNdotVRefract;vec3 clearCoatColor;float clearCoatThickness;
#endif
#if defined(ENVIRONMENTBRDF) && defined(MS_BRDF_ENERGY_CONSERVATION)
vec3 energyConservationFactorClearCoat;
#endif
#if DEBUGMODE>0
#ifdef CLEARCOAT_BUMP
mat3 TBNClearCoat;
#endif
#ifdef CLEARCOAT_TEXTURE
vec2 clearCoatMapData;
#endif
#if defined(CLEARCOAT_TINT) && defined(CLEARCOAT_TINT_TEXTURE)
vec4 clearCoatTintMapData;
#endif
#ifdef REFLECTION
vec4 environmentClearCoatRadiance;vec3 clearCoatEnvironmentReflectance;
#endif
float clearCoatNdotV;
#endif
};
#ifdef CLEARCOAT
#define pbr_inline
#define inline
void clearcoatBlock(
in vec3 vPositionW,
in vec3 geometricNormalW,
in vec3 viewDirectionW,
in vec2 vClearCoatParams,
#if defined(CLEARCOAT_TEXTURE_ROUGHNESS) && !defined(CLEARCOAT_TEXTURE_ROUGHNESS_IDENTICAL) && !defined(CLEARCOAT_USE_ROUGHNESS_FROM_MAINTEXTURE)
in vec4 clearCoatMapRoughnessData,
#endif
in vec3 specularEnvironmentR0,
#ifdef CLEARCOAT_TEXTURE
in vec2 clearCoatMapData,
#endif
#ifdef CLEARCOAT_TINT
in vec4 vClearCoatTintParams,
in float clearCoatColorAtDistance,
in vec4 vClearCoatRefractionParams,
#ifdef CLEARCOAT_TINT_TEXTURE
in vec4 clearCoatTintMapData,
#endif
#endif
#ifdef CLEARCOAT_BUMP
in vec2 vClearCoatBumpInfos,
in vec4 clearCoatBumpMapData,
in vec2 vClearCoatBumpUV,
#if defined(TANGENT) && defined(NORMAL)
in mat3 vTBN,
#else
in vec2 vClearCoatTangentSpaceParams,
#endif
#ifdef OBJECTSPACE_NORMALMAP
in mat4 normalMatrix,
#endif
#endif
#if defined(FORCENORMALFORWARD) && defined(NORMAL)
in vec3 faceNormal,
#endif
#ifdef REFLECTION
in vec3 vReflectionMicrosurfaceInfos,
in vec2 vReflectionInfos,
in vec3 vReflectionColor,
in vec4 vLightingIntensity,
#ifdef REFLECTIONMAP_3D
in samplerCube reflectionSampler,
#else
in sampler2D reflectionSampler,
#endif
#ifndef LODBASEDMICROSFURACE
#ifdef REFLECTIONMAP_3D
in samplerCube reflectionSamplerLow,
in samplerCube reflectionSamplerHigh,
#else
in sampler2D reflectionSamplerLow,
in sampler2D reflectionSamplerHigh,
#endif
#endif
#ifdef REALTIME_FILTERING
in vec2 vReflectionFilteringInfo,
#endif
#endif
#if defined(ENVIRONMENTBRDF) && !defined(REFLECTIONMAP_SKYBOX)
#ifdef RADIANCEOCCLUSION
in float ambientMonochrome,
#endif
#endif
#if defined(CLEARCOAT_BUMP) || defined(TWOSIDEDLIGHTING)
in float frontFacingMultiplier,
#endif
out clearcoatOutParams outParams
)
{float clearCoatIntensity=vClearCoatParams.x;float clearCoatRoughness=vClearCoatParams.y;
#ifdef CLEARCOAT_TEXTURE
clearCoatIntensity*=clearCoatMapData.x;
#ifdef CLEARCOAT_USE_ROUGHNESS_FROM_MAINTEXTURE
clearCoatRoughness*=clearCoatMapData.y;
#endif
#if DEBUGMODE>0
outParams.clearCoatMapData=clearCoatMapData;
#endif
#endif
#if defined(CLEARCOAT_TEXTURE_ROUGHNESS) && !defined(CLEARCOAT_USE_ROUGHNESS_FROM_MAINTEXTURE)
#ifdef CLEARCOAT_TEXTURE_ROUGHNESS_IDENTICAL
clearCoatRoughness*=clearCoatMapData.y;
#else
clearCoatRoughness*=clearCoatMapRoughnessData.y;
#endif
#endif
outParams.clearCoatIntensity=clearCoatIntensity;outParams.clearCoatRoughness=clearCoatRoughness;
#ifdef CLEARCOAT_TINT
vec3 clearCoatColor=vClearCoatTintParams.rgb;float clearCoatThickness=vClearCoatTintParams.a;
#ifdef CLEARCOAT_TINT_TEXTURE
#ifdef CLEARCOAT_TINT_GAMMATEXTURE
clearCoatColor*=toLinearSpace(clearCoatTintMapData.rgb);
#else
clearCoatColor*=clearCoatTintMapData.rgb;
#endif
clearCoatThickness*=clearCoatTintMapData.a;
#if DEBUGMODE>0
outParams.clearCoatTintMapData=clearCoatTintMapData;
#endif
#endif
outParams.clearCoatColor=computeColorAtDistanceInMedia(clearCoatColor,clearCoatColorAtDistance);outParams.clearCoatThickness=clearCoatThickness;
#endif
#ifdef CLEARCOAT_REMAP_F0
vec3 specularEnvironmentR0Updated=getR0RemappedForClearCoat(specularEnvironmentR0);
#else
vec3 specularEnvironmentR0Updated=specularEnvironmentR0;
#endif
outParams.specularEnvironmentR0=mix(specularEnvironmentR0,specularEnvironmentR0Updated,clearCoatIntensity);vec3 clearCoatNormalW=geometricNormalW;
#ifdef CLEARCOAT_BUMP
#ifdef NORMALXYSCALE
float clearCoatNormalScale=1.0;
#else
float clearCoatNormalScale=vClearCoatBumpInfos.y;
#endif
#if defined(TANGENT) && defined(NORMAL)
mat3 TBNClearCoat=vTBN;
#else
vec2 TBNClearCoatUV=vClearCoatBumpUV*frontFacingMultiplier;mat3 TBNClearCoat=cotangent_frame(clearCoatNormalW*clearCoatNormalScale,vPositionW,TBNClearCoatUV,vClearCoatTangentSpaceParams);
#endif
#if DEBUGMODE>0
outParams.TBNClearCoat=TBNClearCoat;
#endif
#ifdef OBJECTSPACE_NORMALMAP
clearCoatNormalW=normalize(clearCoatBumpMapData.xyz *2.0-1.0);clearCoatNormalW=normalize(mat3(normalMatrix)*clearCoatNormalW);
#else
clearCoatNormalW=perturbNormal(TBNClearCoat,clearCoatBumpMapData.xyz,vClearCoatBumpInfos.y);
#endif
#endif
#if defined(FORCENORMALFORWARD) && defined(NORMAL)
clearCoatNormalW*=sign(dot(clearCoatNormalW,faceNormal));
#endif
#if defined(TWOSIDEDLIGHTING) && defined(NORMAL)
clearCoatNormalW=clearCoatNormalW*frontFacingMultiplier;
#endif
outParams.clearCoatNormalW=clearCoatNormalW;outParams.clearCoatAARoughnessFactors=getAARoughnessFactors(clearCoatNormalW.xyz);float clearCoatNdotVUnclamped=dot(clearCoatNormalW,viewDirectionW);float clearCoatNdotV=absEps(clearCoatNdotVUnclamped);
#if DEBUGMODE>0
outParams.clearCoatNdotV=clearCoatNdotV;
#endif
#ifdef CLEARCOAT_TINT
vec3 clearCoatVRefract=refract(-viewDirectionW,clearCoatNormalW,vClearCoatRefractionParams.y);outParams.clearCoatNdotVRefract=absEps(dot(clearCoatNormalW,clearCoatVRefract));
#endif
#if defined(ENVIRONMENTBRDF) && (!defined(REFLECTIONMAP_SKYBOX) || defined(MS_BRDF_ENERGY_CONSERVATION))
vec3 environmentClearCoatBrdf=getBRDFLookup(clearCoatNdotV,clearCoatRoughness);
#endif
#if defined(REFLECTION)
float clearCoatAlphaG=convertRoughnessToAverageSlope(clearCoatRoughness);
#ifdef SPECULARAA
clearCoatAlphaG+=outParams.clearCoatAARoughnessFactors.y;
#endif
vec4 environmentClearCoatRadiance=vec4(0.,0.,0.,0.);vec3 clearCoatReflectionVector=computeReflectionCoords(vec4(vPositionW,1.0),clearCoatNormalW);
#ifdef REFLECTIONMAP_OPPOSITEZ
clearCoatReflectionVector.z*=-1.0;
#endif
#ifdef REFLECTIONMAP_3D
vec3 clearCoatReflectionCoords=clearCoatReflectionVector;
#else
vec2 clearCoatReflectionCoords=clearCoatReflectionVector.xy;
#ifdef REFLECTIONMAP_PROJECTION
clearCoatReflectionCoords/=clearCoatReflectionVector.z;
#endif
clearCoatReflectionCoords.y=1.0-clearCoatReflectionCoords.y;
#endif
sampleReflectionTexture(
clearCoatAlphaG,
vReflectionMicrosurfaceInfos,
vReflectionInfos,
vReflectionColor,
#if defined(LODINREFLECTIONALPHA) && !defined(REFLECTIONMAP_SKYBOX)
clearCoatNdotVUnclamped,
#endif
#ifdef LINEARSPECULARREFLECTION
clearCoatRoughness,
#endif
reflectionSampler,
clearCoatReflectionCoords,
#ifndef LODBASEDMICROSFURACE
reflectionSamplerLow,
reflectionSamplerHigh,
#endif
#ifdef REALTIME_FILTERING
vReflectionFilteringInfo,
#endif
environmentClearCoatRadiance
);
#if DEBUGMODE>0
outParams.environmentClearCoatRadiance=environmentClearCoatRadiance;
#endif
#if defined(ENVIRONMENTBRDF) && !defined(REFLECTIONMAP_SKYBOX)
vec3 clearCoatEnvironmentReflectance=getReflectanceFromBRDFLookup(vec3(vClearCoatRefractionParams.x),environmentClearCoatBrdf);
#ifdef HORIZONOCCLUSION
#ifdef BUMP
#ifdef REFLECTIONMAP_3D
float clearCoatEho=environmentHorizonOcclusion(-viewDirectionW,clearCoatNormalW,geometricNormalW);clearCoatEnvironmentReflectance*=clearCoatEho;
#endif
#endif
#endif
#else
vec3 clearCoatEnvironmentReflectance=getReflectanceFromAnalyticalBRDFLookup_Jones(clearCoatNdotV,vec3(1.),vec3(1.),sqrt(1.-clearCoatRoughness));
#endif
clearCoatEnvironmentReflectance*=clearCoatIntensity;
#if DEBUGMODE>0
outParams.clearCoatEnvironmentReflectance=clearCoatEnvironmentReflectance;
#endif
outParams.finalClearCoatRadianceScaled=
environmentClearCoatRadiance.rgb *
clearCoatEnvironmentReflectance *
vLightingIntensity.z;
#endif
#if defined(CLEARCOAT_TINT)
outParams.absorption=computeClearCoatAbsorption(outParams.clearCoatNdotVRefract,outParams.clearCoatNdotVRefract,outParams.clearCoatColor,clearCoatThickness,clearCoatIntensity);
#endif
float fresnelIBLClearCoat=fresnelSchlickGGX(clearCoatNdotV,vClearCoatRefractionParams.x,CLEARCOATREFLECTANCE90);fresnelIBLClearCoat*=clearCoatIntensity;outParams.conservationFactor=(1.-fresnelIBLClearCoat);
#if defined(ENVIRONMENTBRDF) && defined(MS_BRDF_ENERGY_CONSERVATION)
outParams.energyConservationFactorClearCoat=getEnergyConservationFactor(outParams.specularEnvironmentR0,environmentClearCoatBrdf);
#endif
}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$ee057f579a5e451c$var$name] = $ee057f579a5e451c$var$shader;
const $ee057f579a5e451c$export$cdc7b556b68d0611 = {
    name: $ee057f579a5e451c$var$name,
    shader: $ee057f579a5e451c$var$shader
};

});

parcelRegister("9w3jT", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $6ed9ad7972ece50f$var$name = "pbrBlockIridescence";
const $6ed9ad7972ece50f$var$shader = `struct iridescenceOutParams
{float iridescenceIntensity;float iridescenceIOR;float iridescenceThickness;vec3 specularEnvironmentR0;};
#ifdef IRIDESCENCE
#define pbr_inline
#define inline
void iridescenceBlock(
in vec4 vIridescenceParams,
in float viewAngle,
in vec3 specularEnvironmentR0,
#ifdef IRIDESCENCE_TEXTURE
in vec2 iridescenceMapData,
#endif
#ifdef IRIDESCENCE_THICKNESS_TEXTURE
in vec2 iridescenceThicknessMapData,
#endif
#ifdef CLEARCOAT
in float NdotVUnclamped,
#ifdef CLEARCOAT_TEXTURE
in vec2 clearCoatMapData,
#endif
#endif
out iridescenceOutParams outParams
)
{float iridescenceIntensity=vIridescenceParams.x;float iridescenceIOR=vIridescenceParams.y;float iridescenceThicknessMin=vIridescenceParams.z;float iridescenceThicknessMax=vIridescenceParams.w;float iridescenceThicknessWeight=1.;
#ifdef IRIDESCENCE_TEXTURE
iridescenceIntensity*=iridescenceMapData.x;
#ifdef IRIDESCENCE_USE_THICKNESS_FROM_MAINTEXTURE
iridescenceThicknessWeight=iridescenceMapData.g;
#endif
#endif
#if defined(IRIDESCENCE_THICKNESS_TEXTURE)
iridescenceThicknessWeight=iridescenceThicknessMapData.g;
#endif
float iridescenceThickness=mix(iridescenceThicknessMin,iridescenceThicknessMax,iridescenceThicknessWeight);float topIor=1.; 
#ifdef CLEARCOAT
float clearCoatIntensity=vClearCoatParams.x;
#ifdef CLEARCOAT_TEXTURE
clearCoatIntensity*=clearCoatMapData.x;
#endif
topIor=mix(1.0,vClearCoatRefractionParams.w-1.,clearCoatIntensity);viewAngle=sqrt(1.0+square(1.0/topIor)*(square(NdotVUnclamped)-1.0));
#endif
vec3 iridescenceFresnel=evalIridescence(topIor,iridescenceIOR,viewAngle,iridescenceThickness,specularEnvironmentR0);outParams.specularEnvironmentR0=mix(specularEnvironmentR0,iridescenceFresnel,iridescenceIntensity);outParams.iridescenceIntensity=iridescenceIntensity;outParams.iridescenceThickness=iridescenceThickness;outParams.iridescenceIOR=iridescenceIOR;}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$6ed9ad7972ece50f$var$name] = $6ed9ad7972ece50f$var$shader;
const $6ed9ad7972ece50f$export$64534669c293c0d = {
    name: $6ed9ad7972ece50f$var$name,
    shader: $6ed9ad7972ece50f$var$shader
};

});

parcelRegister("k80c5", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $ea74b48a4a0f15f8$var$name = "pbrBlockSubSurface";
const $ea74b48a4a0f15f8$var$shader = `struct subSurfaceOutParams
{vec3 specularEnvironmentReflectance;
#ifdef SS_REFRACTION
vec3 finalRefraction;vec3 surfaceAlbedo;
#ifdef SS_LINKREFRACTIONTOTRANSPARENCY
float alpha;
#endif
#ifdef REFLECTION
float refractionFactorForIrradiance;
#endif
#endif
#ifdef SS_TRANSLUCENCY
vec3 transmittance;float translucencyIntensity;
#ifdef REFLECTION
vec3 refractionIrradiance;
#endif
#endif
#if DEBUGMODE>0
#ifdef SS_THICKNESSANDMASK_TEXTURE
vec4 thicknessMap;
#endif
#ifdef SS_REFRACTION
vec4 environmentRefraction;vec3 refractionTransmittance;
#endif
#endif
};
#ifdef SUBSURFACE
#ifdef SS_REFRACTION
#define pbr_inline
#define inline
vec4 sampleEnvironmentRefraction(
in float ior
,in float thickness
,in float refractionLOD
,in vec3 normalW
,in vec3 vPositionW
,in vec3 viewDirectionW
,in mat4 view
,in vec4 vRefractionInfos
,in mat4 refractionMatrix
,in vec4 vRefractionMicrosurfaceInfos
,in float alphaG
#ifdef SS_REFRACTIONMAP_3D
,in samplerCube refractionSampler
#ifndef LODBASEDMICROSFURACE
,in samplerCube refractionSamplerLow
,in samplerCube refractionSamplerHigh
#endif
#else
,in sampler2D refractionSampler
#ifndef LODBASEDMICROSFURACE
,in sampler2D refractionSamplerLow
,in sampler2D refractionSamplerHigh
#endif
#endif
#ifdef ANISOTROPIC
,in anisotropicOutParams anisotropicOut
#endif
#ifdef REALTIME_FILTERING
,in vec2 vRefractionFilteringInfo
#endif
#ifdef SS_USE_LOCAL_REFRACTIONMAP_CUBIC
,in vec3 refractionPosition
,in vec3 refractionSize
#endif
) {vec4 environmentRefraction=vec4(0.,0.,0.,0.);
#ifdef ANISOTROPIC
vec3 refractionVector=refract(-viewDirectionW,anisotropicOut.anisotropicNormal,ior);
#else
vec3 refractionVector=refract(-viewDirectionW,normalW,ior);
#endif
#ifdef SS_REFRACTIONMAP_OPPOSITEZ
refractionVector.z*=-1.0;
#endif
#ifdef SS_REFRACTIONMAP_3D
#ifdef SS_USE_LOCAL_REFRACTIONMAP_CUBIC
refractionVector=parallaxCorrectNormal(vPositionW,refractionVector,refractionSize,refractionPosition);
#endif
refractionVector.y=refractionVector.y*vRefractionInfos.w;vec3 refractionCoords=refractionVector;refractionCoords=vec3(refractionMatrix*vec4(refractionCoords,0));
#else
#ifdef SS_USE_THICKNESS_AS_DEPTH
vec3 vRefractionUVW=vec3(refractionMatrix*(view*vec4(vPositionW+refractionVector*thickness,1.0)));
#else
vec3 vRefractionUVW=vec3(refractionMatrix*(view*vec4(vPositionW+refractionVector*vRefractionInfos.z,1.0)));
#endif
vec2 refractionCoords=vRefractionUVW.xy/vRefractionUVW.z;refractionCoords.y=1.0-refractionCoords.y;
#endif
#ifdef LODBASEDMICROSFURACE
refractionLOD=refractionLOD*vRefractionMicrosurfaceInfos.y+vRefractionMicrosurfaceInfos.z;
#ifdef SS_LODINREFRACTIONALPHA
float automaticRefractionLOD=UNPACK_LOD(sampleRefraction(refractionSampler,refractionCoords).a);float requestedRefractionLOD=max(automaticRefractionLOD,refractionLOD);
#else
float requestedRefractionLOD=refractionLOD;
#endif
#if defined(REALTIME_FILTERING) && defined(SS_REFRACTIONMAP_3D)
environmentRefraction=vec4(radiance(alphaG,refractionSampler,refractionCoords,vRefractionFilteringInfo),1.0);
#else
environmentRefraction=sampleRefractionLod(refractionSampler,refractionCoords,requestedRefractionLOD);
#endif
#else
float lodRefractionNormalized=saturate(refractionLOD/log2(vRefractionMicrosurfaceInfos.x));float lodRefractionNormalizedDoubled=lodRefractionNormalized*2.0;vec4 environmentRefractionMid=sampleRefraction(refractionSampler,refractionCoords);if (lodRefractionNormalizedDoubled<1.0){environmentRefraction=mix(
sampleRefraction(refractionSamplerHigh,refractionCoords),
environmentRefractionMid,
lodRefractionNormalizedDoubled
);} else {environmentRefraction=mix(
environmentRefractionMid,
sampleRefraction(refractionSamplerLow,refractionCoords),
lodRefractionNormalizedDoubled-1.0
);}
#endif
#ifdef SS_RGBDREFRACTION
environmentRefraction.rgb=fromRGBD(environmentRefraction);
#endif
#ifdef SS_GAMMAREFRACTION
environmentRefraction.rgb=toLinearSpace(environmentRefraction.rgb);
#endif
return environmentRefraction;}
#endif
#define pbr_inline
#define inline
void subSurfaceBlock(
in vec3 vSubSurfaceIntensity,
in vec2 vThicknessParam,
in vec4 vTintColor,
in vec3 normalW,
in vec3 specularEnvironmentReflectance,
#ifdef SS_THICKNESSANDMASK_TEXTURE
in vec4 thicknessMap,
#endif
#ifdef SS_REFRACTIONINTENSITY_TEXTURE
in vec4 refractionIntensityMap,
#endif
#ifdef SS_TRANSLUCENCYINTENSITY_TEXTURE
in vec4 translucencyIntensityMap,
#endif
#ifdef REFLECTION
#ifdef SS_TRANSLUCENCY
in mat4 reflectionMatrix,
#ifdef USESPHERICALFROMREFLECTIONMAP
#if !defined(NORMAL) || !defined(USESPHERICALINVERTEX)
in vec3 irradianceVector_,
#endif
#if defined(REALTIME_FILTERING)
in samplerCube reflectionSampler,
in vec2 vReflectionFilteringInfo,
#endif
#endif
#ifdef USEIRRADIANCEMAP
#ifdef REFLECTIONMAP_3D
in samplerCube irradianceSampler,
#else
in sampler2D irradianceSampler,
#endif
#endif
#endif
#endif
#if defined(SS_REFRACTION) || defined(SS_TRANSLUCENCY)
in vec3 surfaceAlbedo,
#endif
#ifdef SS_REFRACTION
in vec3 vPositionW,
in vec3 viewDirectionW,
in mat4 view,
in vec4 vRefractionInfos,
in mat4 refractionMatrix,
in vec4 vRefractionMicrosurfaceInfos,
in vec4 vLightingIntensity,
#ifdef SS_LINKREFRACTIONTOTRANSPARENCY
in float alpha,
#endif
#ifdef SS_LODINREFRACTIONALPHA
in float NdotVUnclamped,
#endif
#ifdef SS_LINEARSPECULARREFRACTION
in float roughness,
#endif
in float alphaG,
#ifdef SS_REFRACTIONMAP_3D
in samplerCube refractionSampler,
#ifndef LODBASEDMICROSFURACE
in samplerCube refractionSamplerLow,
in samplerCube refractionSamplerHigh,
#endif
#else
in sampler2D refractionSampler,
#ifndef LODBASEDMICROSFURACE
in sampler2D refractionSamplerLow,
in sampler2D refractionSamplerHigh,
#endif
#endif
#ifdef ANISOTROPIC
in anisotropicOutParams anisotropicOut,
#endif
#ifdef REALTIME_FILTERING
in vec2 vRefractionFilteringInfo,
#endif
#ifdef SS_USE_LOCAL_REFRACTIONMAP_CUBIC
in vec3 refractionPosition,
in vec3 refractionSize,
#endif
#ifdef SS_DISPERSION
in float dispersion,
#endif
#endif
#ifdef SS_TRANSLUCENCY
in vec3 vDiffusionDistance,
#endif
out subSurfaceOutParams outParams
)
{outParams.specularEnvironmentReflectance=specularEnvironmentReflectance;
#ifdef SS_REFRACTION
float refractionIntensity=vSubSurfaceIntensity.x;
#ifdef SS_LINKREFRACTIONTOTRANSPARENCY
refractionIntensity*=(1.0-alpha);outParams.alpha=1.0;
#endif
#endif
#ifdef SS_TRANSLUCENCY
float translucencyIntensity=vSubSurfaceIntensity.y;
#endif
#ifdef SS_THICKNESSANDMASK_TEXTURE
#if defined(SS_USE_GLTF_TEXTURES)
float thickness=thicknessMap.g*vThicknessParam.y+vThicknessParam.x;
#else
float thickness=thicknessMap.r*vThicknessParam.y+vThicknessParam.x;
#endif
#if DEBUGMODE>0
outParams.thicknessMap=thicknessMap;
#endif
#ifdef SS_MASK_FROM_THICKNESS_TEXTURE
#if defined(SS_REFRACTION) && defined(SS_REFRACTION_USE_INTENSITY_FROM_TEXTURE)
#if defined(SS_USE_GLTF_TEXTURES)
refractionIntensity*=thicknessMap.r;
#else
refractionIntensity*=thicknessMap.g;
#endif
#endif
#if defined(SS_TRANSLUCENCY) && defined(SS_TRANSLUCENCY_USE_INTENSITY_FROM_TEXTURE)
translucencyIntensity*=thicknessMap.b;
#endif
#endif
#else
float thickness=vThicknessParam.y;
#endif
#ifdef SS_REFRACTIONINTENSITY_TEXTURE
#ifdef SS_USE_GLTF_TEXTURES
refractionIntensity*=refractionIntensityMap.r;
#else
refractionIntensity*=refractionIntensityMap.g;
#endif
#endif
#ifdef SS_TRANSLUCENCYINTENSITY_TEXTURE
translucencyIntensity*=translucencyIntensityMap.b;
#endif
#ifdef SS_TRANSLUCENCY
thickness=maxEps(thickness);vec3 transmittance=transmittanceBRDF_Burley(vTintColor.rgb,vDiffusionDistance,thickness);transmittance*=translucencyIntensity;outParams.transmittance=transmittance;outParams.translucencyIntensity=translucencyIntensity;
#endif
#ifdef SS_REFRACTION
vec4 environmentRefraction=vec4(0.,0.,0.,0.);
#ifdef SS_HAS_THICKNESS
float ior=vRefractionInfos.y;
#else
float ior=vRefractionMicrosurfaceInfos.w;
#endif
#ifdef SS_LODINREFRACTIONALPHA
float refractionAlphaG=alphaG;refractionAlphaG=mix(alphaG,0.0,clamp(ior*3.0-2.0,0.0,1.0));float refractionLOD=getLodFromAlphaG(vRefractionMicrosurfaceInfos.x,refractionAlphaG,NdotVUnclamped);
#elif defined(SS_LINEARSPECULARREFRACTION)
float refractionRoughness=alphaG;refractionRoughness=mix(alphaG,0.0,clamp(ior*3.0-2.0,0.0,1.0));float refractionLOD=getLinearLodFromRoughness(vRefractionMicrosurfaceInfos.x,refractionRoughness);
#else
float refractionAlphaG=alphaG;refractionAlphaG=mix(alphaG,0.0,clamp(ior*3.0-2.0,0.0,1.0));float refractionLOD=getLodFromAlphaG(vRefractionMicrosurfaceInfos.x,refractionAlphaG);
#endif
float refraction_ior=vRefractionInfos.y;
#ifdef SS_DISPERSION
float realIOR=1.0/refraction_ior;float iorDispersionSpread=0.04*dispersion*(realIOR-1.0);vec3 iors=vec3(1.0/(realIOR-iorDispersionSpread),refraction_ior,1.0/(realIOR+iorDispersionSpread));for (int i=0; i<3; i++) {refraction_ior=iors[i];
#endif
vec4 envSample=sampleEnvironmentRefraction(refraction_ior,thickness,refractionLOD,normalW,vPositionW,viewDirectionW,view,vRefractionInfos,refractionMatrix,vRefractionMicrosurfaceInfos,alphaG
#ifdef SS_REFRACTIONMAP_3D
,refractionSampler
#ifndef LODBASEDMICROSFURACE
,refractionSamplerLow
,refractionSamplerHigh
#endif
#else
,refractionSampler
#ifndef LODBASEDMICROSFURACE
,refractionSamplerLow
,refractionSamplerHigh
#endif
#endif
#ifdef ANISOTROPIC
,anisotropicOut
#endif
#ifdef REALTIME_FILTERING
,vRefractionFilteringInfo
#endif
#ifdef SS_USE_LOCAL_REFRACTIONMAP_CUBIC
,refractionPosition
,refractionSize
#endif
);
#ifdef SS_DISPERSION
environmentRefraction[i]=envSample[i];}
#else
environmentRefraction=envSample;
#endif
environmentRefraction.rgb*=vRefractionInfos.x;
#endif
#ifdef SS_REFRACTION
vec3 refractionTransmittance=vec3(refractionIntensity);
#ifdef SS_THICKNESSANDMASK_TEXTURE
vec3 volumeAlbedo=computeColorAtDistanceInMedia(vTintColor.rgb,vTintColor.w);refractionTransmittance*=cocaLambert(volumeAlbedo,thickness);
#elif defined(SS_LINKREFRACTIONTOTRANSPARENCY)
float maxChannel=max(max(surfaceAlbedo.r,surfaceAlbedo.g),surfaceAlbedo.b);vec3 volumeAlbedo=saturate(maxChannel*surfaceAlbedo);environmentRefraction.rgb*=volumeAlbedo;
#else
vec3 volumeAlbedo=computeColorAtDistanceInMedia(vTintColor.rgb,vTintColor.w);refractionTransmittance*=cocaLambert(volumeAlbedo,vThicknessParam.y);
#endif
#ifdef SS_ALBEDOFORREFRACTIONTINT
environmentRefraction.rgb*=surfaceAlbedo.rgb;
#endif
outParams.surfaceAlbedo=surfaceAlbedo*(1.-refractionIntensity);
#ifdef REFLECTION
outParams.refractionFactorForIrradiance=(1.-refractionIntensity);
#endif
#ifdef UNUSED_MULTIPLEBOUNCES
vec3 bounceSpecularEnvironmentReflectance=(2.0*specularEnvironmentReflectance)/(1.0+specularEnvironmentReflectance);outParams.specularEnvironmentReflectance=mix(bounceSpecularEnvironmentReflectance,specularEnvironmentReflectance,refractionIntensity);
#endif
refractionTransmittance*=1.0-outParams.specularEnvironmentReflectance;
#if DEBUGMODE>0
outParams.refractionTransmittance=refractionTransmittance;
#endif
outParams.finalRefraction=environmentRefraction.rgb*refractionTransmittance*vLightingIntensity.z;
#if DEBUGMODE>0
outParams.environmentRefraction=environmentRefraction;
#endif
#endif
#if defined(REFLECTION) && defined(SS_TRANSLUCENCY)
#if defined(NORMAL) && defined(USESPHERICALINVERTEX) || !defined(USESPHERICALFROMREFLECTIONMAP)
vec3 irradianceVector=vec3(reflectionMatrix*vec4(normalW,0)).xyz;
#ifdef REFLECTIONMAP_OPPOSITEZ
irradianceVector.z*=-1.0;
#endif
#ifdef INVERTCUBICMAP
irradianceVector.y*=-1.0;
#endif
#else
vec3 irradianceVector=irradianceVector_;
#endif
#if defined(USESPHERICALFROMREFLECTIONMAP)
#if defined(REALTIME_FILTERING)
vec3 refractionIrradiance=irradiance(reflectionSampler,-irradianceVector,vReflectionFilteringInfo);
#else
vec3 refractionIrradiance=computeEnvironmentIrradiance(-irradianceVector);
#endif
#elif defined(USEIRRADIANCEMAP)
#ifdef REFLECTIONMAP_3D
vec3 irradianceCoords=irradianceVector;
#else
vec2 irradianceCoords=irradianceVector.xy;
#ifdef REFLECTIONMAP_PROJECTION
irradianceCoords/=irradianceVector.z;
#endif
irradianceCoords.y=1.0-irradianceCoords.y;
#endif
vec4 refractionIrradiance=sampleReflection(irradianceSampler,-irradianceCoords);
#ifdef RGBDREFLECTION
refractionIrradiance.rgb=fromRGBD(refractionIrradiance);
#endif
#ifdef GAMMAREFLECTION
refractionIrradiance.rgb=toLinearSpace(refractionIrradiance.rgb);
#endif
#else
vec4 refractionIrradiance=vec4(0.);
#endif
refractionIrradiance.rgb*=transmittance;
#ifdef SS_ALBEDOFORTRANSLUCENCYTINT
refractionIrradiance.rgb*=surfaceAlbedo.rgb;
#endif
outParams.refractionIrradiance=refractionIrradiance.rgb;
#endif
}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$ea74b48a4a0f15f8$var$name] = $ea74b48a4a0f15f8$var$shader;
const $ea74b48a4a0f15f8$export$7b3f8abed4805e67 = {
    name: $ea74b48a4a0f15f8$var$name,
    shader: $ea74b48a4a0f15f8$var$shader
};

});

parcelRegister("aaBxW", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $7677f67e07abc726$var$name = "pbrBlockNormalGeometric";
const $7677f67e07abc726$var$shader = `vec3 viewDirectionW=normalize(vEyePosition.xyz-vPositionW);
#ifdef NORMAL
vec3 normalW=normalize(vNormalW);
#else
vec3 normalW=normalize(cross(dFdx(vPositionW),dFdy(vPositionW)))*vEyePosition.w;
#endif
vec3 geometricNormalW=normalW;
#if defined(TWOSIDEDLIGHTING) && defined(NORMAL)
geometricNormalW=gl_FrontFacing ? geometricNormalW : -geometricNormalW;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$7677f67e07abc726$var$name] = $7677f67e07abc726$var$shader;
const $7677f67e07abc726$export$fd88ccc97f436f4b = {
    name: $7677f67e07abc726$var$name,
    shader: $7677f67e07abc726$var$shader
};

});

parcelRegister("0TQE0", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $002b52789ac519ee$var$name = "pbrBlockNormalFinal";
const $002b52789ac519ee$var$shader = `#if defined(FORCENORMALFORWARD) && defined(NORMAL)
vec3 faceNormal=normalize(cross(dFdx(vPositionW),dFdy(vPositionW)))*vEyePosition.w;
#if defined(TWOSIDEDLIGHTING)
faceNormal=gl_FrontFacing ? faceNormal : -faceNormal;
#endif
normalW*=sign(dot(normalW,faceNormal));
#endif
#if defined(TWOSIDEDLIGHTING) && defined(NORMAL)
normalW=gl_FrontFacing ? normalW : -normalW;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$002b52789ac519ee$var$name] = $002b52789ac519ee$var$shader;
const $002b52789ac519ee$export$f60d269a840d5c95 = {
    name: $002b52789ac519ee$var$name,
    shader: $002b52789ac519ee$var$shader
};

});

parcelRegister("8cEpV", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $5f8ecbb535ed9bdb$var$name = "pbrBlockLightmapInit";
const $5f8ecbb535ed9bdb$var$shader = `#ifdef LIGHTMAP
vec4 lightmapColor=texture2D(lightmapSampler,vLightmapUV+uvOffset);
#ifdef RGBDLIGHTMAP
lightmapColor.rgb=fromRGBD(lightmapColor);
#endif
#ifdef GAMMALIGHTMAP
lightmapColor.rgb=toLinearSpace(lightmapColor.rgb);
#endif
lightmapColor.rgb*=vLightmapInfos.y;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$5f8ecbb535ed9bdb$var$name] = $5f8ecbb535ed9bdb$var$shader;
const $5f8ecbb535ed9bdb$export$3ba5ee21db4371ca = {
    name: $5f8ecbb535ed9bdb$var$name,
    shader: $5f8ecbb535ed9bdb$var$shader
};

});

parcelRegister("91ZzO", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $6933f8e0c4f17424$var$name = "pbrBlockGeometryInfo";
const $6933f8e0c4f17424$var$shader = `float NdotVUnclamped=dot(normalW,viewDirectionW);float NdotV=absEps(NdotVUnclamped);float alphaG=convertRoughnessToAverageSlope(roughness);vec2 AARoughnessFactors=getAARoughnessFactors(normalW.xyz);
#ifdef SPECULARAA
alphaG+=AARoughnessFactors.y;
#endif
#if defined(ENVIRONMENTBRDF)
vec3 environmentBrdf=getBRDFLookup(NdotV,roughness);
#endif
#if defined(ENVIRONMENTBRDF) && !defined(REFLECTIONMAP_SKYBOX)
#ifdef RADIANCEOCCLUSION
#ifdef AMBIENTINGRAYSCALE
float ambientMonochrome=aoOut.ambientOcclusionColor.r;
#else
float ambientMonochrome=getLuminance(aoOut.ambientOcclusionColor);
#endif
float seo=environmentRadianceOcclusion(ambientMonochrome,NdotVUnclamped);
#endif
#ifdef HORIZONOCCLUSION
#ifdef BUMP
#ifdef REFLECTIONMAP_3D
float eho=environmentHorizonOcclusion(-viewDirectionW,normalW,geometricNormalW);
#endif
#endif
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$6933f8e0c4f17424$var$name] = $6933f8e0c4f17424$var$shader;
const $6933f8e0c4f17424$export$814d27563ba6c271 = {
    name: $6933f8e0c4f17424$var$name,
    shader: $6933f8e0c4f17424$var$shader
};

});

parcelRegister("atIdy", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $7a0ee986b17d6315$var$name = "pbrBlockReflectance0";
const $7a0ee986b17d6315$var$shader = `float reflectance=max(max(reflectivityOut.surfaceReflectivityColor.r,reflectivityOut.surfaceReflectivityColor.g),reflectivityOut.surfaceReflectivityColor.b);vec3 specularEnvironmentR0=reflectivityOut.surfaceReflectivityColor.rgb;
#ifdef METALLICWORKFLOW
vec3 specularEnvironmentR90=vec3(metallicReflectanceFactors.a);
#else 
vec3 specularEnvironmentR90=vec3(1.0,1.0,1.0);
#endif
#ifdef ALPHAFRESNEL
float reflectance90=fresnelGrazingReflectance(reflectance);specularEnvironmentR90=specularEnvironmentR90*reflectance90;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$7a0ee986b17d6315$var$name] = $7a0ee986b17d6315$var$shader;
const $7a0ee986b17d6315$export$8f5c03352e7c06a5 = {
    name: $7a0ee986b17d6315$var$name,
    shader: $7a0ee986b17d6315$var$shader
};

});

parcelRegister("gjTSR", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $be19c50a5e424ad1$var$name = "pbrBlockReflectance";
const $be19c50a5e424ad1$var$shader = `#if defined(ENVIRONMENTBRDF) && !defined(REFLECTIONMAP_SKYBOX)
vec3 specularEnvironmentReflectance=getReflectanceFromBRDFLookup(clearcoatOut.specularEnvironmentR0,specularEnvironmentR90,environmentBrdf);
#ifdef RADIANCEOCCLUSION
specularEnvironmentReflectance*=seo;
#endif
#ifdef HORIZONOCCLUSION
#ifdef BUMP
#ifdef REFLECTIONMAP_3D
specularEnvironmentReflectance*=eho;
#endif
#endif
#endif
#else
vec3 specularEnvironmentReflectance=getReflectanceFromAnalyticalBRDFLookup_Jones(NdotV,clearcoatOut.specularEnvironmentR0,specularEnvironmentR90,sqrt(microSurface));
#endif
#ifdef CLEARCOAT
specularEnvironmentReflectance*=clearcoatOut.conservationFactor;
#if defined(CLEARCOAT_TINT)
specularEnvironmentReflectance*=clearcoatOut.absorption;
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$be19c50a5e424ad1$var$name] = $be19c50a5e424ad1$var$shader;
const $be19c50a5e424ad1$export$15d9b3ec47164be5 = {
    name: $be19c50a5e424ad1$var$name,
    shader: $be19c50a5e424ad1$var$shader
};

});

parcelRegister("1MYsb", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $14d92af356268b10$var$name = "pbrBlockDirectLighting";
const $14d92af356268b10$var$shader = `vec3 diffuseBase=vec3(0.,0.,0.);
#ifdef SPECULARTERM
vec3 specularBase=vec3(0.,0.,0.);
#endif
#ifdef CLEARCOAT
vec3 clearCoatBase=vec3(0.,0.,0.);
#endif
#ifdef SHEEN
vec3 sheenBase=vec3(0.,0.,0.);
#endif
preLightingInfo preInfo;lightingInfo info;float shadow=1.; 
float aggShadow=0.;float numLights=0.;
#if defined(CLEARCOAT) && defined(CLEARCOAT_TINT)
vec3 absorption=vec3(0.);
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$14d92af356268b10$var$name] = $14d92af356268b10$var$shader;
const $14d92af356268b10$export$5a182a6388bfca59 = {
    name: $14d92af356268b10$var$name,
    shader: $14d92af356268b10$var$shader
};

});

parcelRegister("cFZt2", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $93a8fe889146174a$var$name = "pbrBlockFinalLitComponents";
const $93a8fe889146174a$var$shader = `aggShadow=aggShadow/numLights;
#if defined(ENVIRONMENTBRDF)
#ifdef MS_BRDF_ENERGY_CONSERVATION
vec3 energyConservationFactor=getEnergyConservationFactor(clearcoatOut.specularEnvironmentR0,environmentBrdf);
#endif
#endif
#ifndef METALLICWORKFLOW
#ifdef SPECULAR_GLOSSINESS_ENERGY_CONSERVATION
surfaceAlbedo.rgb=(1.-reflectance)*surfaceAlbedo.rgb;
#endif
#endif
#if defined(SHEEN) && defined(SHEEN_ALBEDOSCALING) && defined(ENVIRONMENTBRDF)
surfaceAlbedo.rgb=sheenOut.sheenAlbedoScaling*surfaceAlbedo.rgb;
#endif
#ifdef REFLECTION
vec3 finalIrradiance=reflectionOut.environmentIrradiance;
#if defined(CLEARCOAT)
finalIrradiance*=clearcoatOut.conservationFactor;
#if defined(CLEARCOAT_TINT)
finalIrradiance*=clearcoatOut.absorption;
#endif
#endif
#if defined(SS_REFRACTION)
finalIrradiance*=subSurfaceOut.refractionFactorForIrradiance;
#endif
#if defined(SS_TRANSLUCENCY)
finalIrradiance*=(1.0-subSurfaceOut.translucencyIntensity);finalIrradiance+=subSurfaceOut.refractionIrradiance;
#endif
finalIrradiance*=surfaceAlbedo.rgb;finalIrradiance*=vLightingIntensity.z;finalIrradiance*=aoOut.ambientOcclusionColor;
#endif
#ifdef SPECULARTERM
vec3 finalSpecular=specularBase;finalSpecular=max(finalSpecular,0.0);vec3 finalSpecularScaled=finalSpecular*vLightingIntensity.x*vLightingIntensity.w;
#if defined(ENVIRONMENTBRDF) && defined(MS_BRDF_ENERGY_CONSERVATION)
finalSpecularScaled*=energyConservationFactor;
#endif
#if defined(SHEEN) && defined(ENVIRONMENTBRDF) && defined(SHEEN_ALBEDOSCALING)
finalSpecularScaled*=sheenOut.sheenAlbedoScaling;
#endif
#endif
#ifdef REFLECTION
vec3 finalRadiance=reflectionOut.environmentRadiance.rgb;finalRadiance*=subSurfaceOut.specularEnvironmentReflectance;vec3 finalRadianceScaled=finalRadiance*vLightingIntensity.z;
#if defined(ENVIRONMENTBRDF) && defined(MS_BRDF_ENERGY_CONSERVATION)
finalRadianceScaled*=energyConservationFactor;
#endif
#if defined(SHEEN) && defined(ENVIRONMENTBRDF) && defined(SHEEN_ALBEDOSCALING)
finalRadianceScaled*=sheenOut.sheenAlbedoScaling;
#endif
#endif
#ifdef SHEEN
vec3 finalSheen=sheenBase*sheenOut.sheenColor;finalSheen=max(finalSheen,0.0);vec3 finalSheenScaled=finalSheen*vLightingIntensity.x*vLightingIntensity.w;
#if defined(CLEARCOAT) && defined(REFLECTION) && defined(ENVIRONMENTBRDF)
sheenOut.finalSheenRadianceScaled*=clearcoatOut.conservationFactor;
#if defined(CLEARCOAT_TINT)
sheenOut.finalSheenRadianceScaled*=clearcoatOut.absorption;
#endif
#endif
#endif
#ifdef CLEARCOAT
vec3 finalClearCoat=clearCoatBase;finalClearCoat=max(finalClearCoat,0.0);vec3 finalClearCoatScaled=finalClearCoat*vLightingIntensity.x*vLightingIntensity.w;
#if defined(ENVIRONMENTBRDF) && defined(MS_BRDF_ENERGY_CONSERVATION)
finalClearCoatScaled*=clearcoatOut.energyConservationFactorClearCoat;
#endif
#ifdef SS_REFRACTION
subSurfaceOut.finalRefraction*=clearcoatOut.conservationFactor;
#ifdef CLEARCOAT_TINT
subSurfaceOut.finalRefraction*=clearcoatOut.absorption;
#endif
#endif
#endif
#ifdef ALPHABLEND
float luminanceOverAlpha=0.0;
#if defined(REFLECTION) && defined(RADIANCEOVERALPHA)
luminanceOverAlpha+=getLuminance(finalRadianceScaled);
#if defined(CLEARCOAT)
luminanceOverAlpha+=getLuminance(clearcoatOut.finalClearCoatRadianceScaled);
#endif
#endif
#if defined(SPECULARTERM) && defined(SPECULAROVERALPHA)
luminanceOverAlpha+=getLuminance(finalSpecularScaled);
#endif
#if defined(CLEARCOAT) && defined(CLEARCOATOVERALPHA)
luminanceOverAlpha+=getLuminance(finalClearCoatScaled);
#endif
#if defined(RADIANCEOVERALPHA) || defined(SPECULAROVERALPHA) || defined(CLEARCOATOVERALPHA)
alpha=saturate(alpha+luminanceOverAlpha*luminanceOverAlpha);
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$93a8fe889146174a$var$name] = $93a8fe889146174a$var$shader;
const $93a8fe889146174a$export$d88c56396a0d183f = {
    name: $93a8fe889146174a$var$name,
    shader: $93a8fe889146174a$var$shader
};

});

parcelRegister("5xWDR", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $409d85e0409175e6$var$name = "pbrBlockFinalUnlitComponents";
const $409d85e0409175e6$var$shader = `vec3 finalDiffuse=diffuseBase;finalDiffuse*=surfaceAlbedo.rgb;finalDiffuse=max(finalDiffuse,0.0);finalDiffuse*=vLightingIntensity.x;vec3 finalAmbient=vAmbientColor;finalAmbient*=surfaceAlbedo.rgb;vec3 finalEmissive=vEmissiveColor;
#ifdef EMISSIVE
vec3 emissiveColorTex=texture2D(emissiveSampler,vEmissiveUV+uvOffset).rgb;
#ifdef GAMMAEMISSIVE
finalEmissive*=toLinearSpace(emissiveColorTex.rgb);
#else
finalEmissive*=emissiveColorTex.rgb;
#endif
finalEmissive*= vEmissiveInfos.y;
#endif
finalEmissive*=vLightingIntensity.y;
#ifdef AMBIENT
vec3 ambientOcclusionForDirectDiffuse=mix(vec3(1.),aoOut.ambientOcclusionColor,vAmbientInfos.w);
#else
vec3 ambientOcclusionForDirectDiffuse=aoOut.ambientOcclusionColor;
#endif
finalAmbient*=aoOut.ambientOcclusionColor;finalDiffuse*=ambientOcclusionForDirectDiffuse;
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$409d85e0409175e6$var$name] = $409d85e0409175e6$var$shader;
const $409d85e0409175e6$export$a2b9b8d8acfd7d0d = {
    name: $409d85e0409175e6$var$name,
    shader: $409d85e0409175e6$var$shader
};

});

parcelRegister("1a7pD", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $0d8c7992752804c7$var$name = "pbrBlockFinalColorComposition";
const $0d8c7992752804c7$var$shader = `vec4 finalColor=vec4(
#ifndef UNLIT
#ifdef REFLECTION
finalIrradiance +
#endif
#ifdef SPECULARTERM
finalSpecularScaled +
#endif
#ifdef SHEEN
finalSheenScaled +
#endif
#ifdef CLEARCOAT
finalClearCoatScaled +
#endif
#ifdef REFLECTION
finalRadianceScaled +
#if defined(SHEEN) && defined(ENVIRONMENTBRDF)
sheenOut.finalSheenRadianceScaled +
#endif
#ifdef CLEARCOAT
clearcoatOut.finalClearCoatRadianceScaled +
#endif
#endif
#ifdef SS_REFRACTION
subSurfaceOut.finalRefraction +
#endif
#endif
finalAmbient +
finalDiffuse,
alpha);
#ifdef LIGHTMAP
#ifndef LIGHTMAPEXCLUDED
#ifdef USELIGHTMAPASSHADOWMAP
finalColor.rgb*=lightmapColor.rgb;
#else
finalColor.rgb+=lightmapColor.rgb;
#endif
#endif
#endif
finalColor.rgb+=finalEmissive;
#define CUSTOM_FRAGMENT_BEFORE_FOG
finalColor=max(finalColor,0.0);
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$0d8c7992752804c7$var$name] = $0d8c7992752804c7$var$shader;
const $0d8c7992752804c7$export$1271e9d93b0004e6 = {
    name: $0d8c7992752804c7$var$name,
    shader: $0d8c7992752804c7$var$shader
};

});

parcelRegister("ccq4Y", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $8e1ad5ceba194eb6$var$name = "pbrBlockImageProcessing";
const $8e1ad5ceba194eb6$var$shader = `#if defined(IMAGEPROCESSINGPOSTPROCESS) || defined(SS_SCATTERING)
#if !defined(SKIPFINALCOLORCLAMP)
finalColor.rgb=clamp(finalColor.rgb,0.,30.0);
#endif
#else
finalColor=applyImageProcessing(finalColor);
#endif
finalColor.a*=visibility;
#ifdef PREMULTIPLYALPHA
finalColor.rgb*=finalColor.a;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$8e1ad5ceba194eb6$var$name] = $8e1ad5ceba194eb6$var$shader;
const $8e1ad5ceba194eb6$export$7bba01292ac4a1fc = {
    name: $8e1ad5ceba194eb6$var$name,
    shader: $8e1ad5ceba194eb6$var$shader
};

});

parcelRegister("iKGGz", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $da6da25558a96347$var$name = "pbrDebug";
const $da6da25558a96347$var$shader = `#if DEBUGMODE>0
if (vClipSpacePosition.x/vClipSpacePosition.w>=vDebugMode.x) {
#if DEBUGMODE==1
gl_FragColor.rgb=vPositionW.rgb;
#define DEBUGMODE_NORMALIZE
#elif DEBUGMODE==2 && defined(NORMAL)
gl_FragColor.rgb=vNormalW.rgb;
#define DEBUGMODE_NORMALIZE
#elif DEBUGMODE==3 && defined(BUMP) || DEBUGMODE==3 && defined(PARALLAX) || DEBUGMODE==3 && defined(ANISOTROPIC)
gl_FragColor.rgb=TBN[0];
#define DEBUGMODE_NORMALIZE
#elif DEBUGMODE==4 && defined(BUMP) || DEBUGMODE==4 && defined(PARALLAX) || DEBUGMODE==4 && defined(ANISOTROPIC)
gl_FragColor.rgb=TBN[1];
#define DEBUGMODE_NORMALIZE
#elif DEBUGMODE==5
gl_FragColor.rgb=normalW;
#define DEBUGMODE_NORMALIZE
#elif DEBUGMODE==6 && defined(MAINUV1)
gl_FragColor.rgb=vec3(vMainUV1,0.0);
#elif DEBUGMODE==7 && defined(MAINUV2)
gl_FragColor.rgb=vec3(vMainUV2,0.0);
#elif DEBUGMODE==8 && defined(CLEARCOAT) && defined(CLEARCOAT_BUMP)
gl_FragColor.rgb=clearcoatOut.TBNClearCoat[0];
#define DEBUGMODE_NORMALIZE
#elif DEBUGMODE==9 && defined(CLEARCOAT) && defined(CLEARCOAT_BUMP)
gl_FragColor.rgb=clearcoatOut.TBNClearCoat[1];
#define DEBUGMODE_NORMALIZE
#elif DEBUGMODE==10 && defined(CLEARCOAT)
gl_FragColor.rgb=clearcoatOut.clearCoatNormalW;
#define DEBUGMODE_NORMALIZE
#elif DEBUGMODE==11 && defined(ANISOTROPIC)
gl_FragColor.rgb=anisotropicOut.anisotropicNormal;
#define DEBUGMODE_NORMALIZE
#elif DEBUGMODE==12 && defined(ANISOTROPIC)
gl_FragColor.rgb=anisotropicOut.anisotropicTangent;
#define DEBUGMODE_NORMALIZE
#elif DEBUGMODE==13 && defined(ANISOTROPIC)
gl_FragColor.rgb=anisotropicOut.anisotropicBitangent;
#define DEBUGMODE_NORMALIZE
#elif DEBUGMODE==20 && defined(ALBEDO)
gl_FragColor.rgb=albedoTexture.rgb;
#ifndef GAMMAALBEDO
#define DEBUGMODE_GAMMA
#endif
#elif DEBUGMODE==21 && defined(AMBIENT)
gl_FragColor.rgb=aoOut.ambientOcclusionColorMap.rgb;
#elif DEBUGMODE==22 && defined(OPACITY)
gl_FragColor.rgb=opacityMap.rgb;
#elif DEBUGMODE==23 && defined(EMISSIVE)
gl_FragColor.rgb=emissiveColorTex.rgb;
#ifndef GAMMAEMISSIVE
#define DEBUGMODE_GAMMA
#endif
#elif DEBUGMODE==24 && defined(LIGHTMAP)
gl_FragColor.rgb=lightmapColor.rgb;
#ifndef GAMMALIGHTMAP
#define DEBUGMODE_GAMMA
#endif
#elif DEBUGMODE==25 && defined(REFLECTIVITY) && defined(METALLICWORKFLOW)
gl_FragColor.rgb=reflectivityOut.surfaceMetallicColorMap.rgb;
#elif DEBUGMODE==26 && defined(REFLECTIVITY) && !defined(METALLICWORKFLOW)
gl_FragColor.rgb=reflectivityOut.surfaceReflectivityColorMap.rgb;
#define DEBUGMODE_GAMMA
#elif DEBUGMODE==27 && defined(CLEARCOAT) && defined(CLEARCOAT_TEXTURE)
gl_FragColor.rgb=vec3(clearcoatOut.clearCoatMapData.rg,0.0);
#elif DEBUGMODE==28 && defined(CLEARCOAT) && defined(CLEARCOAT_TINT) && defined(CLEARCOAT_TINT_TEXTURE)
gl_FragColor.rgb=clearcoatOut.clearCoatTintMapData.rgb;
#elif DEBUGMODE==29 && defined(SHEEN) && defined(SHEEN_TEXTURE)
gl_FragColor.rgb=sheenOut.sheenMapData.rgb;
#elif DEBUGMODE==30 && defined(ANISOTROPIC) && defined(ANISOTROPIC_TEXTURE)
gl_FragColor.rgb=anisotropicOut.anisotropyMapData.rgb;
#elif DEBUGMODE==31 && defined(SUBSURFACE) && defined(SS_THICKNESSANDMASK_TEXTURE)
gl_FragColor.rgb=subSurfaceOut.thicknessMap.rgb;
#elif DEBUGMODE==32 && defined(BUMP)
gl_FragColor.rgb=texture2D(bumpSampler,vBumpUV).rgb;
#elif DEBUGMODE==40 && defined(SS_REFRACTION)
gl_FragColor.rgb=subSurfaceOut.environmentRefraction.rgb;
#define DEBUGMODE_GAMMA
#elif DEBUGMODE==41 && defined(REFLECTION)
gl_FragColor.rgb=reflectionOut.environmentRadiance.rgb;
#ifndef GAMMAREFLECTION
#define DEBUGMODE_GAMMA
#endif
#elif DEBUGMODE==42 && defined(CLEARCOAT) && defined(REFLECTION)
gl_FragColor.rgb=clearcoatOut.environmentClearCoatRadiance.rgb;
#define DEBUGMODE_GAMMA
#elif DEBUGMODE==50
gl_FragColor.rgb=diffuseBase.rgb;
#define DEBUGMODE_GAMMA
#elif DEBUGMODE==51 && defined(SPECULARTERM)
gl_FragColor.rgb=specularBase.rgb;
#define DEBUGMODE_GAMMA
#elif DEBUGMODE==52 && defined(CLEARCOAT)
gl_FragColor.rgb=clearCoatBase.rgb;
#define DEBUGMODE_GAMMA
#elif DEBUGMODE==53 && defined(SHEEN)
gl_FragColor.rgb=sheenBase.rgb;
#define DEBUGMODE_GAMMA
#elif DEBUGMODE==54 && defined(REFLECTION)
gl_FragColor.rgb=reflectionOut.environmentIrradiance.rgb;
#ifndef GAMMAREFLECTION
#define DEBUGMODE_GAMMA
#endif
#elif DEBUGMODE==60
gl_FragColor.rgb=surfaceAlbedo.rgb;
#define DEBUGMODE_GAMMA
#elif DEBUGMODE==61
gl_FragColor.rgb=clearcoatOut.specularEnvironmentR0;
#define DEBUGMODE_GAMMA
#elif DEBUGMODE==62 && defined(METALLICWORKFLOW)
gl_FragColor.rgb=vec3(reflectivityOut.metallicRoughness.r);
#elif DEBUGMODE==71 && defined(METALLICWORKFLOW)
gl_FragColor.rgb=reflectivityOut.metallicF0;
#elif DEBUGMODE==63
gl_FragColor.rgb=vec3(roughness);
#elif DEBUGMODE==64
gl_FragColor.rgb=vec3(alphaG);
#elif DEBUGMODE==65
gl_FragColor.rgb=vec3(NdotV);
#elif DEBUGMODE==66 && defined(CLEARCOAT) && defined(CLEARCOAT_TINT)
gl_FragColor.rgb=clearcoatOut.clearCoatColor.rgb;
#define DEBUGMODE_GAMMA
#elif DEBUGMODE==67 && defined(CLEARCOAT)
gl_FragColor.rgb=vec3(clearcoatOut.clearCoatRoughness);
#elif DEBUGMODE==68 && defined(CLEARCOAT)
gl_FragColor.rgb=vec3(clearcoatOut.clearCoatNdotV);
#elif DEBUGMODE==69 && defined(SUBSURFACE) && defined(SS_TRANSLUCENCY)
gl_FragColor.rgb=subSurfaceOut.transmittance;
#elif DEBUGMODE==70 && defined(SUBSURFACE) && defined(SS_REFRACTION)
gl_FragColor.rgb=subSurfaceOut.refractionTransmittance;
#elif DEBUGMODE==72
gl_FragColor.rgb=vec3(microSurface);
#elif DEBUGMODE==73
gl_FragColor.rgb=vAlbedoColor.rgb;
#define DEBUGMODE_GAMMA
#elif DEBUGMODE==74 && !defined(METALLICWORKFLOW)
gl_FragColor.rgb=vReflectivityColor.rgb;
#define DEBUGMODE_GAMMA
#elif DEBUGMODE==75
gl_FragColor.rgb=vEmissiveColor.rgb;
#define DEBUGMODE_GAMMA
#elif DEBUGMODE==80 && defined(RADIANCEOCCLUSION)
gl_FragColor.rgb=vec3(seo);
#elif DEBUGMODE==81 && defined(HORIZONOCCLUSION) && defined(BUMP) && defined(REFLECTIONMAP_3D)
gl_FragColor.rgb=vec3(eho);
#elif DEBUGMODE==82 && defined(MS_BRDF_ENERGY_CONSERVATION)
gl_FragColor.rgb=vec3(energyConservationFactor);
#elif DEBUGMODE==83 && defined(ENVIRONMENTBRDF) && !defined(REFLECTIONMAP_SKYBOX)
gl_FragColor.rgb=specularEnvironmentReflectance;
#define DEBUGMODE_GAMMA
#elif DEBUGMODE==84 && defined(CLEARCOAT) && defined(ENVIRONMENTBRDF) && !defined(REFLECTIONMAP_SKYBOX)
gl_FragColor.rgb=clearcoatOut.clearCoatEnvironmentReflectance;
#define DEBUGMODE_GAMMA
#elif DEBUGMODE==85 && defined(SHEEN) && defined(REFLECTION)
gl_FragColor.rgb=sheenOut.sheenEnvironmentReflectance;
#define DEBUGMODE_GAMMA
#elif DEBUGMODE==86 && defined(ALPHABLEND)
gl_FragColor.rgb=vec3(luminanceOverAlpha);
#elif DEBUGMODE==87
gl_FragColor.rgb=vec3(alpha);
#elif DEBUGMODE==88 && defined(ALBEDO)
gl_FragColor.rgb=vec3(albedoTexture.a);
#else
float stripeWidth=30.;float stripePos=floor((gl_FragCoord.x+gl_FragCoord.y)/stripeWidth);float whichColor=mod(stripePos,2.);vec3 color1=vec3(.6,.2,.2);vec3 color2=vec3(.3,.1,.1);gl_FragColor.rgb=mix(color1,color2,whichColor);
#endif
gl_FragColor.rgb*=vDebugMode.y;
#ifdef DEBUGMODE_NORMALIZE
gl_FragColor.rgb=normalize(gl_FragColor.rgb)*0.5+0.5;
#endif
#ifdef DEBUGMODE_GAMMA
gl_FragColor.rgb=toGammaSpace(gl_FragColor.rgb);
#endif
gl_FragColor.a=1.0;
#ifdef PREPASS
gl_FragData[0]=toLinearSpace(gl_FragColor); 
gl_FragData[1]=vec4(0.,0.,0.,0.); 
#endif
#ifdef DEBUGMODE_FORCERETURN
return;
#endif
}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$da6da25558a96347$var$name] = $da6da25558a96347$var$shader;
const $da6da25558a96347$export$26ac20919a2a46cd = {
    name: $da6da25558a96347$var$name,
    shader: $da6da25558a96347$var$shader
};

});


parcelRegister("fxKbe", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("7t7jb");
parcelRequire("8nfQe");
parcelRequire("1ZoxO");
parcelRequire("5lMLg");
parcelRequire("7Hs3g");
parcelRequire("7PW7m");
parcelRequire("8kYMw");
parcelRequire("k3wwH");
parcelRequire("cdubm");
parcelRequire("eiwUK");
parcelRequire("hYOZS");
parcelRequire("hgGYG");
parcelRequire("4A4MM");
parcelRequire("bdABV");
parcelRequire("1yLBX");
parcelRequire("c0VT2");
parcelRequire("5Eb4I");
parcelRequire("9H5jp");
parcelRequire("4kipo");
parcelRequire("9ulLS");
parcelRequire("LFrAO");
parcelRequire("apKdp");
parcelRequire("4idCt");
parcelRequire("cIweX");
parcelRequire("f7nPp");
parcelRequire("i4Zbf");
parcelRequire("9N2ej");
parcelRequire("4GjUR");
parcelRequire("kqCfW");
parcelRequire("1pV7g");
parcelRequire("5sP5F");
parcelRequire("jl3r6");
parcelRequire("a111f");
const $b50dc27a0f6858c9$var$name = "pbrVertexShader";
const $b50dc27a0f6858c9$var$shader = `precision highp float;
#include<__decl__pbrVertex>
#define CUSTOM_VERTEX_BEGIN
attribute vec3 position;
#ifdef NORMAL
attribute vec3 normal;
#endif
#ifdef TANGENT
attribute vec4 tangent;
#endif
#ifdef UV1
attribute vec2 uv;
#endif
#include<uvAttributeDeclaration>[2..7]
#include<mainUVVaryingDeclaration>[1..7]
#ifdef VERTEXCOLOR
attribute vec4 color;
#endif
#include<helperFunctions>
#include<bonesDeclaration>
#include<bakedVertexAnimationDeclaration>
#include<instancesDeclaration>
#include<prePassVertexDeclaration>
#include<samplerVertexDeclaration>(_DEFINENAME_,ALBEDO,_VARYINGNAME_,Albedo)
#include<samplerVertexDeclaration>(_DEFINENAME_,DETAIL,_VARYINGNAME_,Detail)
#include<samplerVertexDeclaration>(_DEFINENAME_,AMBIENT,_VARYINGNAME_,Ambient)
#include<samplerVertexDeclaration>(_DEFINENAME_,OPACITY,_VARYINGNAME_,Opacity)
#include<samplerVertexDeclaration>(_DEFINENAME_,EMISSIVE,_VARYINGNAME_,Emissive)
#include<samplerVertexDeclaration>(_DEFINENAME_,LIGHTMAP,_VARYINGNAME_,Lightmap)
#include<samplerVertexDeclaration>(_DEFINENAME_,REFLECTIVITY,_VARYINGNAME_,Reflectivity)
#include<samplerVertexDeclaration>(_DEFINENAME_,MICROSURFACEMAP,_VARYINGNAME_,MicroSurfaceSampler)
#include<samplerVertexDeclaration>(_DEFINENAME_,METALLIC_REFLECTANCE,_VARYINGNAME_,MetallicReflectance)
#include<samplerVertexDeclaration>(_DEFINENAME_,REFLECTANCE,_VARYINGNAME_,Reflectance)
#include<samplerVertexDeclaration>(_DEFINENAME_,BUMP,_VARYINGNAME_,Bump)
#include<samplerVertexDeclaration>(_DEFINENAME_,DECAL,_VARYINGNAME_,Decal)
#ifdef CLEARCOAT
#include<samplerVertexDeclaration>(_DEFINENAME_,CLEARCOAT_TEXTURE,_VARYINGNAME_,ClearCoat)
#include<samplerVertexDeclaration>(_DEFINENAME_,CLEARCOAT_TEXTURE_ROUGHNESS,_VARYINGNAME_,ClearCoatRoughness)
#include<samplerVertexDeclaration>(_DEFINENAME_,CLEARCOAT_BUMP,_VARYINGNAME_,ClearCoatBump)
#include<samplerVertexDeclaration>(_DEFINENAME_,CLEARCOAT_TINT_TEXTURE,_VARYINGNAME_,ClearCoatTint)
#endif
#ifdef IRIDESCENCE
#include<samplerVertexDeclaration>(_DEFINENAME_,IRIDESCENCE_TEXTURE,_VARYINGNAME_,Iridescence)
#include<samplerVertexDeclaration>(_DEFINENAME_,IRIDESCENCE_THICKNESS_TEXTURE,_VARYINGNAME_,IridescenceThickness)
#endif
#ifdef SHEEN
#include<samplerVertexDeclaration>(_DEFINENAME_,SHEEN_TEXTURE,_VARYINGNAME_,Sheen)
#include<samplerVertexDeclaration>(_DEFINENAME_,SHEEN_TEXTURE_ROUGHNESS,_VARYINGNAME_,SheenRoughness)
#endif
#ifdef ANISOTROPIC
#include<samplerVertexDeclaration>(_DEFINENAME_,ANISOTROPIC_TEXTURE,_VARYINGNAME_,Anisotropy)
#endif
#ifdef SUBSURFACE
#include<samplerVertexDeclaration>(_DEFINENAME_,SS_THICKNESSANDMASK_TEXTURE,_VARYINGNAME_,Thickness)
#include<samplerVertexDeclaration>(_DEFINENAME_,SS_REFRACTIONINTENSITY_TEXTURE,_VARYINGNAME_,RefractionIntensity)
#include<samplerVertexDeclaration>(_DEFINENAME_,SS_TRANSLUCENCYINTENSITY_TEXTURE,_VARYINGNAME_,TranslucencyIntensity)
#endif
varying vec3 vPositionW;
#if DEBUGMODE>0
varying vec4 vClipSpacePosition;
#endif
#ifdef NORMAL
varying vec3 vNormalW;
#if defined(USESPHERICALFROMREFLECTIONMAP) && defined(USESPHERICALINVERTEX)
varying vec3 vEnvironmentIrradiance;
#include<harmonicsFunctions>
#endif
#endif
#if defined(VERTEXCOLOR) || defined(INSTANCESCOLOR) && defined(INSTANCES)
varying vec4 vColor;
#endif
#include<bumpVertexDeclaration>
#include<clipPlaneVertexDeclaration>
#include<fogVertexDeclaration>
#include<__decl__lightVxFragment>[0..maxSimultaneousLights]
#include<morphTargetsVertexGlobalDeclaration>
#include<morphTargetsVertexDeclaration>[0..maxSimultaneousMorphTargets]
#ifdef REFLECTIONMAP_SKYBOX
varying vec3 vPositionUVW;
#endif
#if defined(REFLECTIONMAP_EQUIRECTANGULAR_FIXED) || defined(REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED)
varying vec3 vDirectionW;
#endif
#include<logDepthDeclaration>
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
vec3 positionUpdated=position;
#ifdef NORMAL
vec3 normalUpdated=normal;
#endif
#ifdef TANGENT
vec4 tangentUpdated=tangent;
#endif
#ifdef UV1
vec2 uvUpdated=uv;
#endif
#include<morphTargetsVertexGlobal>
#include<morphTargetsVertex>[0..maxSimultaneousMorphTargets]
#ifdef REFLECTIONMAP_SKYBOX
vPositionUVW=positionUpdated;
#endif
#define CUSTOM_VERTEX_UPDATE_POSITION
#define CUSTOM_VERTEX_UPDATE_NORMAL
#include<instancesVertex>
#if defined(PREPASS) && defined(PREPASS_VELOCITY) && !defined(BONES_VELOCITY_ENABLED)
vCurrentPosition=viewProjection*finalWorld*vec4(positionUpdated,1.0);vPreviousPosition=previousViewProjection*finalPreviousWorld*vec4(positionUpdated,1.0);
#endif
#include<bonesVertex>
#include<bakedVertexAnimation>
vec4 worldPos=finalWorld*vec4(positionUpdated,1.0);vPositionW=vec3(worldPos);
#include<prePassVertex>
#ifdef NORMAL
mat3 normalWorld=mat3(finalWorld);
#if defined(INSTANCES) && defined(THIN_INSTANCES)
vNormalW=normalUpdated/vec3(dot(normalWorld[0],normalWorld[0]),dot(normalWorld[1],normalWorld[1]),dot(normalWorld[2],normalWorld[2]));vNormalW=normalize(normalWorld*vNormalW);
#else
#ifdef NONUNIFORMSCALING
normalWorld=transposeMat3(inverseMat3(normalWorld));
#endif
vNormalW=normalize(normalWorld*normalUpdated);
#endif
#if defined(USESPHERICALFROMREFLECTIONMAP) && defined(USESPHERICALINVERTEX)
vec3 reflectionVector=vec3(reflectionMatrix*vec4(vNormalW,0)).xyz;
#ifdef REFLECTIONMAP_OPPOSITEZ
reflectionVector.z*=-1.0;
#endif
vEnvironmentIrradiance=computeEnvironmentIrradiance(reflectionVector);
#endif
#endif
#define CUSTOM_VERTEX_UPDATE_WORLDPOS
#ifdef MULTIVIEW
if (gl_ViewID_OVR==0u) {gl_Position=viewProjection*worldPos;} else {gl_Position=viewProjectionR*worldPos;}
#else
gl_Position=viewProjection*worldPos;
#endif
#if DEBUGMODE>0
vClipSpacePosition=gl_Position;
#endif
#if defined(REFLECTIONMAP_EQUIRECTANGULAR_FIXED) || defined(REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED)
vDirectionW=normalize(vec3(finalWorld*vec4(positionUpdated,0.0)));
#endif
#ifndef UV1
vec2 uvUpdated=vec2(0.,0.);
#endif
#ifdef MAINUV1
vMainUV1=uvUpdated;
#endif
#include<uvVariableDeclaration>[2..7]
#include<samplerVertexImplementation>(_DEFINENAME_,ALBEDO,_VARYINGNAME_,Albedo,_MATRIXNAME_,albedo,_INFONAME_,AlbedoInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,DETAIL,_VARYINGNAME_,Detail,_MATRIXNAME_,detail,_INFONAME_,DetailInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,AMBIENT,_VARYINGNAME_,Ambient,_MATRIXNAME_,ambient,_INFONAME_,AmbientInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,OPACITY,_VARYINGNAME_,Opacity,_MATRIXNAME_,opacity,_INFONAME_,OpacityInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,EMISSIVE,_VARYINGNAME_,Emissive,_MATRIXNAME_,emissive,_INFONAME_,EmissiveInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,LIGHTMAP,_VARYINGNAME_,Lightmap,_MATRIXNAME_,lightmap,_INFONAME_,LightmapInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,REFLECTIVITY,_VARYINGNAME_,Reflectivity,_MATRIXNAME_,reflectivity,_INFONAME_,ReflectivityInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,MICROSURFACEMAP,_VARYINGNAME_,MicroSurfaceSampler,_MATRIXNAME_,microSurfaceSampler,_INFONAME_,MicroSurfaceSamplerInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,METALLIC_REFLECTANCE,_VARYINGNAME_,MetallicReflectance,_MATRIXNAME_,metallicReflectance,_INFONAME_,MetallicReflectanceInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,REFLECTANCE,_VARYINGNAME_,Reflectance,_MATRIXNAME_,reflectance,_INFONAME_,ReflectanceInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,BUMP,_VARYINGNAME_,Bump,_MATRIXNAME_,bump,_INFONAME_,BumpInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,DECAL,_VARYINGNAME_,Decal,_MATRIXNAME_,decal,_INFONAME_,DecalInfos.x)
#ifdef CLEARCOAT
#include<samplerVertexImplementation>(_DEFINENAME_,CLEARCOAT_TEXTURE,_VARYINGNAME_,ClearCoat,_MATRIXNAME_,clearCoat,_INFONAME_,ClearCoatInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,CLEARCOAT_TEXTURE_ROUGHNESS,_VARYINGNAME_,ClearCoatRoughness,_MATRIXNAME_,clearCoatRoughness,_INFONAME_,ClearCoatInfos.z)
#include<samplerVertexImplementation>(_DEFINENAME_,CLEARCOAT_BUMP,_VARYINGNAME_,ClearCoatBump,_MATRIXNAME_,clearCoatBump,_INFONAME_,ClearCoatBumpInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,CLEARCOAT_TINT_TEXTURE,_VARYINGNAME_,ClearCoatTint,_MATRIXNAME_,clearCoatTint,_INFONAME_,ClearCoatTintInfos.x)
#endif
#ifdef IRIDESCENCE
#include<samplerVertexImplementation>(_DEFINENAME_,IRIDESCENCE_TEXTURE,_VARYINGNAME_,Iridescence,_MATRIXNAME_,iridescence,_INFONAME_,IridescenceInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,IRIDESCENCE_THICKNESS_TEXTURE,_VARYINGNAME_,IridescenceThickness,_MATRIXNAME_,iridescenceThickness,_INFONAME_,IridescenceInfos.z)
#endif
#ifdef SHEEN
#include<samplerVertexImplementation>(_DEFINENAME_,SHEEN_TEXTURE,_VARYINGNAME_,Sheen,_MATRIXNAME_,sheen,_INFONAME_,SheenInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,SHEEN_TEXTURE_ROUGHNESS,_VARYINGNAME_,SheenRoughness,_MATRIXNAME_,sheenRoughness,_INFONAME_,SheenInfos.z)
#endif
#ifdef ANISOTROPIC
#include<samplerVertexImplementation>(_DEFINENAME_,ANISOTROPIC_TEXTURE,_VARYINGNAME_,Anisotropy,_MATRIXNAME_,anisotropy,_INFONAME_,AnisotropyInfos.x)
#endif
#ifdef SUBSURFACE
#include<samplerVertexImplementation>(_DEFINENAME_,SS_THICKNESSANDMASK_TEXTURE,_VARYINGNAME_,Thickness,_MATRIXNAME_,thickness,_INFONAME_,ThicknessInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,SS_REFRACTIONINTENSITY_TEXTURE,_VARYINGNAME_,RefractionIntensity,_MATRIXNAME_,refractionIntensity,_INFONAME_,RefractionIntensityInfos.x)
#include<samplerVertexImplementation>(_DEFINENAME_,SS_TRANSLUCENCYINTENSITY_TEXTURE,_VARYINGNAME_,TranslucencyIntensity,_MATRIXNAME_,translucencyIntensity,_INFONAME_,TranslucencyIntensityInfos.x)
#endif
#include<bumpVertex>
#include<clipPlaneVertex>
#include<fogVertex>
#include<shadowsVertex>[0..maxSimultaneousLights]
#include<vertexColorMixing>
#if defined(POINTSIZE) && !defined(WEBGPU)
gl_PointSize=pointSize;
#endif
#include<logDepthVertex>
#define CUSTOM_VERTEX_MAIN_END
}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$b50dc27a0f6858c9$var$name] = $b50dc27a0f6858c9$var$shader;
const $b50dc27a0f6858c9$export$28750e16560286ae = {
    name: $b50dc27a0f6858c9$var$name,
    shader: $b50dc27a0f6858c9$var$shader
};

});
parcelRegister("7t7jb", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("jsAPu");
const $5700e920392ae774$var$name = "pbrVertexDeclaration";
const $5700e920392ae774$var$shader = `uniform mat4 view;uniform mat4 viewProjection;
#ifdef ALBEDO
uniform mat4 albedoMatrix;uniform vec2 vAlbedoInfos;
#endif
#ifdef AMBIENT
uniform mat4 ambientMatrix;uniform vec4 vAmbientInfos;
#endif
#ifdef OPACITY
uniform mat4 opacityMatrix;uniform vec2 vOpacityInfos;
#endif
#ifdef EMISSIVE
uniform vec2 vEmissiveInfos;uniform mat4 emissiveMatrix;
#endif
#ifdef LIGHTMAP
uniform vec2 vLightmapInfos;uniform mat4 lightmapMatrix;
#endif
#ifdef REFLECTIVITY 
uniform vec3 vReflectivityInfos;uniform mat4 reflectivityMatrix;
#endif
#ifdef METALLIC_REFLECTANCE
uniform vec2 vMetallicReflectanceInfos;uniform mat4 metallicReflectanceMatrix;
#endif
#ifdef REFLECTANCE
uniform vec2 vReflectanceInfos;uniform mat4 reflectanceMatrix;
#endif
#ifdef MICROSURFACEMAP
uniform vec2 vMicroSurfaceSamplerInfos;uniform mat4 microSurfaceSamplerMatrix;
#endif
#ifdef BUMP
uniform vec3 vBumpInfos;uniform mat4 bumpMatrix;
#endif
#ifdef POINTSIZE
uniform float pointSize;
#endif
#ifdef REFLECTION
uniform vec2 vReflectionInfos;uniform mat4 reflectionMatrix;
#endif
#ifdef CLEARCOAT
#if defined(CLEARCOAT_TEXTURE) || defined(CLEARCOAT_TEXTURE_ROUGHNESS)
uniform vec4 vClearCoatInfos;
#endif
#ifdef CLEARCOAT_TEXTURE
uniform mat4 clearCoatMatrix;
#endif
#ifdef CLEARCOAT_TEXTURE_ROUGHNESS
uniform mat4 clearCoatRoughnessMatrix;
#endif
#ifdef CLEARCOAT_BUMP
uniform vec2 vClearCoatBumpInfos;uniform mat4 clearCoatBumpMatrix;
#endif
#ifdef CLEARCOAT_TINT_TEXTURE
uniform vec2 vClearCoatTintInfos;uniform mat4 clearCoatTintMatrix;
#endif
#endif
#ifdef IRIDESCENCE
#if defined(IRIDESCENCE_TEXTURE) || defined(IRIDESCENCE_THICKNESS_TEXTURE)
uniform vec4 vIridescenceInfos;
#endif
#ifdef IRIDESCENCE_TEXTURE
uniform mat4 iridescenceMatrix;
#endif
#ifdef IRIDESCENCE_THICKNESS_TEXTURE
uniform mat4 iridescenceThicknessMatrix;
#endif
#endif
#ifdef ANISOTROPIC
#ifdef ANISOTROPIC_TEXTURE
uniform vec2 vAnisotropyInfos;uniform mat4 anisotropyMatrix;
#endif
#endif
#ifdef SHEEN
#if defined(SHEEN_TEXTURE) || defined(SHEEN_TEXTURE_ROUGHNESS)
uniform vec4 vSheenInfos;
#endif
#ifdef SHEEN_TEXTURE
uniform mat4 sheenMatrix;
#endif
#ifdef SHEEN_TEXTURE_ROUGHNESS
uniform mat4 sheenRoughnessMatrix;
#endif
#endif
#ifdef SUBSURFACE
#ifdef SS_REFRACTION
uniform vec4 vRefractionInfos;uniform mat4 refractionMatrix;
#endif
#ifdef SS_THICKNESSANDMASK_TEXTURE
uniform vec2 vThicknessInfos;uniform mat4 thicknessMatrix;
#endif
#ifdef SS_REFRACTIONINTENSITY_TEXTURE
uniform vec2 vRefractionIntensityInfos;uniform mat4 refractionIntensityMatrix;
#endif
#ifdef SS_TRANSLUCENCYINTENSITY_TEXTURE
uniform vec2 vTranslucencyIntensityInfos;uniform mat4 translucencyIntensityMatrix;
#endif
#endif
#ifdef NORMAL
#if defined(USESPHERICALFROMREFLECTIONMAP) && defined(USESPHERICALINVERTEX)
#ifdef USESPHERICALFROMREFLECTIONMAP
#ifdef SPHERICAL_HARMONICS
uniform vec3 vSphericalL00;uniform vec3 vSphericalL1_1;uniform vec3 vSphericalL10;uniform vec3 vSphericalL11;uniform vec3 vSphericalL2_2;uniform vec3 vSphericalL2_1;uniform vec3 vSphericalL20;uniform vec3 vSphericalL21;uniform vec3 vSphericalL22;
#else
uniform vec3 vSphericalX;uniform vec3 vSphericalY;uniform vec3 vSphericalZ;uniform vec3 vSphericalXX_ZZ;uniform vec3 vSphericalYY_ZZ;uniform vec3 vSphericalZZ;uniform vec3 vSphericalXY;uniform vec3 vSphericalYZ;uniform vec3 vSphericalZX;
#endif
#endif
#endif
#endif
#ifdef DETAIL
uniform vec4 vDetailInfos;uniform mat4 detailMatrix;
#endif
#include<decalVertexDeclaration>
#define ADDITIONAL_VERTEX_DECLARATION
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$5700e920392ae774$var$name] = $5700e920392ae774$var$shader;
const $5700e920392ae774$export$5de41478f7f3ff47 = {
    name: $5700e920392ae774$var$name,
    shader: $5700e920392ae774$var$shader
};

});


parcelRegister("dXX3O", function(module, exports) {

$parcel$export(module.exports, "MaterialClearCoatDefines", () => $a2ae993db1296c0a$export$aa397430cde5dfed);
$parcel$export(module.exports, "PBRClearCoatConfiguration", () => $a2ae993db1296c0a$export$6d3220ca2057661c);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $7etnY = parcelRequire("7etnY");

var $2hKx5 = parcelRequire("2hKx5");

var $8XNAC = parcelRequire("8XNAC");

var $35xmP = parcelRequire("35xmP");

var $alPCh = parcelRequire("alPCh");
class $a2ae993db1296c0a$export$aa397430cde5dfed extends (0, $35xmP.MaterialDefines) {
    constructor(){
        super(...arguments);
        this.CLEARCOAT = false;
        this.CLEARCOAT_DEFAULTIOR = false;
        this.CLEARCOAT_TEXTURE = false;
        this.CLEARCOAT_TEXTURE_ROUGHNESS = false;
        this.CLEARCOAT_TEXTUREDIRECTUV = 0;
        this.CLEARCOAT_TEXTURE_ROUGHNESSDIRECTUV = 0;
        this.CLEARCOAT_BUMP = false;
        this.CLEARCOAT_BUMPDIRECTUV = 0;
        this.CLEARCOAT_USE_ROUGHNESS_FROM_MAINTEXTURE = false;
        this.CLEARCOAT_TEXTURE_ROUGHNESS_IDENTICAL = false;
        this.CLEARCOAT_REMAP_F0 = false;
        this.CLEARCOAT_TINT = false;
        this.CLEARCOAT_TINT_TEXTURE = false;
        this.CLEARCOAT_TINT_TEXTUREDIRECTUV = 0;
        this.CLEARCOAT_TINT_GAMMATEXTURE = false;
    }
}
class $a2ae993db1296c0a$export$6d3220ca2057661c extends (0, $8XNAC.MaterialPluginBase) {
    /** @internal */ _markAllSubMeshesAsTexturesDirty() {
        this._enable(this._isEnabled);
        this._internalMarkAllSubMeshesAsTexturesDirty();
    }
    constructor(material, addToPluginList = true){
        super(material, "PBRClearCoat", 100, new $a2ae993db1296c0a$export$aa397430cde5dfed(), addToPluginList);
        this._isEnabled = false;
        /**
         * Defines if the clear coat is enabled in the material.
         */ this.isEnabled = false;
        /**
         * Defines the clear coat layer strength (between 0 and 1) it defaults to 1.
         */ this.intensity = 1;
        /**
         * Defines the clear coat layer roughness.
         */ this.roughness = 0;
        this._indexOfRefraction = $a2ae993db1296c0a$export$6d3220ca2057661c._DefaultIndexOfRefraction;
        /**
         * Defines the index of refraction of the clear coat.
         * This defaults to 1.5 corresponding to a 0.04 f0 or a 4% reflectance at normal incidence
         * The default fits with a polyurethane material.
         * Changing the default value is more performance intensive.
         */ this.indexOfRefraction = $a2ae993db1296c0a$export$6d3220ca2057661c._DefaultIndexOfRefraction;
        this._texture = null;
        /**
         * Stores the clear coat values in a texture (red channel is intensity and green channel is roughness)
         * If useRoughnessFromMainTexture is false, the green channel of texture is not used and the green channel of textureRoughness is used instead
         * if textureRoughness is not empty, else no texture roughness is used
         */ this.texture = null;
        this._useRoughnessFromMainTexture = true;
        /**
         * Indicates that the green channel of the texture property will be used for roughness (default: true)
         * If false, the green channel from textureRoughness is used for roughness
         */ this.useRoughnessFromMainTexture = true;
        this._textureRoughness = null;
        /**
         * Stores the clear coat roughness in a texture (green channel)
         * Not used if useRoughnessFromMainTexture is true
         */ this.textureRoughness = null;
        this._remapF0OnInterfaceChange = true;
        /**
         * Defines if the F0 value should be remapped to account for the interface change in the material.
         */ this.remapF0OnInterfaceChange = true;
        this._bumpTexture = null;
        /**
         * Define the clear coat specific bump texture.
         */ this.bumpTexture = null;
        this._isTintEnabled = false;
        /**
         * Defines if the clear coat tint is enabled in the material.
         */ this.isTintEnabled = false;
        /**
         * Defines the clear coat tint of the material.
         * This is only use if tint is enabled
         */ this.tintColor = (0, $7etnY.Color3).White();
        /**
         * Defines the distance at which the tint color should be found in the
         * clear coat media.
         * This is only use if tint is enabled
         */ this.tintColorAtDistance = 1;
        /**
         * Defines the clear coat layer thickness.
         * This is only use if tint is enabled
         */ this.tintThickness = 1;
        this._tintTexture = null;
        /**
         * Stores the clear tint values in a texture.
         * rgb is tint
         * a is a thickness factor
         */ this.tintTexture = null;
        this._internalMarkAllSubMeshesAsTexturesDirty = material._dirtyCallbacks[1];
    }
    isReadyForSubMesh(defines, scene, engine) {
        if (!this._isEnabled) return true;
        const disableBumpMap = this._material._disableBumpMap;
        if (defines._areTexturesDirty) {
            if (scene.texturesEnabled) {
                if (this._texture && (0, $2hKx5.MaterialFlags).ClearCoatTextureEnabled) {
                    if (!this._texture.isReadyOrNotBlocking()) return false;
                }
                if (this._textureRoughness && (0, $2hKx5.MaterialFlags).ClearCoatTextureEnabled) {
                    if (!this._textureRoughness.isReadyOrNotBlocking()) return false;
                }
                if (engine.getCaps().standardDerivatives && this._bumpTexture && (0, $2hKx5.MaterialFlags).ClearCoatBumpTextureEnabled && !disableBumpMap) {
                    // Bump texture cannot be not blocking.
                    if (!this._bumpTexture.isReady()) return false;
                }
                if (this._isTintEnabled && this._tintTexture && (0, $2hKx5.MaterialFlags).ClearCoatTintTextureEnabled) {
                    if (!this._tintTexture.isReadyOrNotBlocking()) return false;
                }
            }
        }
        return true;
    }
    prepareDefinesBeforeAttributes(defines, scene) {
        if (this._isEnabled) {
            defines.CLEARCOAT = true;
            defines.CLEARCOAT_USE_ROUGHNESS_FROM_MAINTEXTURE = this._useRoughnessFromMainTexture;
            defines.CLEARCOAT_TEXTURE_ROUGHNESS_IDENTICAL = this._texture !== null && this._texture._texture === this._textureRoughness?._texture && this._texture.checkTransformsAreIdentical(this._textureRoughness);
            defines.CLEARCOAT_REMAP_F0 = this._remapF0OnInterfaceChange;
            if (defines._areTexturesDirty) {
                if (scene.texturesEnabled) {
                    if (this._texture && (0, $2hKx5.MaterialFlags).ClearCoatTextureEnabled) (0, $alPCh.PrepareDefinesForMergedUV)(this._texture, defines, "CLEARCOAT_TEXTURE");
                    else defines.CLEARCOAT_TEXTURE = false;
                    if (this._textureRoughness && (0, $2hKx5.MaterialFlags).ClearCoatTextureEnabled) (0, $alPCh.PrepareDefinesForMergedUV)(this._textureRoughness, defines, "CLEARCOAT_TEXTURE_ROUGHNESS");
                    else defines.CLEARCOAT_TEXTURE_ROUGHNESS = false;
                    if (this._bumpTexture && (0, $2hKx5.MaterialFlags).ClearCoatBumpTextureEnabled) (0, $alPCh.PrepareDefinesForMergedUV)(this._bumpTexture, defines, "CLEARCOAT_BUMP");
                    else defines.CLEARCOAT_BUMP = false;
                    defines.CLEARCOAT_DEFAULTIOR = this._indexOfRefraction === $a2ae993db1296c0a$export$6d3220ca2057661c._DefaultIndexOfRefraction;
                    if (this._isTintEnabled) {
                        defines.CLEARCOAT_TINT = true;
                        if (this._tintTexture && (0, $2hKx5.MaterialFlags).ClearCoatTintTextureEnabled) {
                            (0, $alPCh.PrepareDefinesForMergedUV)(this._tintTexture, defines, "CLEARCOAT_TINT_TEXTURE");
                            defines.CLEARCOAT_TINT_GAMMATEXTURE = this._tintTexture.gammaSpace;
                        } else defines.CLEARCOAT_TINT_TEXTURE = false;
                    } else {
                        defines.CLEARCOAT_TINT = false;
                        defines.CLEARCOAT_TINT_TEXTURE = false;
                    }
                }
            }
        } else {
            defines.CLEARCOAT = false;
            defines.CLEARCOAT_TEXTURE = false;
            defines.CLEARCOAT_TEXTURE_ROUGHNESS = false;
            defines.CLEARCOAT_BUMP = false;
            defines.CLEARCOAT_TINT = false;
            defines.CLEARCOAT_TINT_TEXTURE = false;
            defines.CLEARCOAT_USE_ROUGHNESS_FROM_MAINTEXTURE = false;
            defines.CLEARCOAT_TEXTURE_ROUGHNESS_IDENTICAL = false;
            defines.CLEARCOAT_DEFAULTIOR = false;
            defines.CLEARCOAT_TEXTUREDIRECTUV = 0;
            defines.CLEARCOAT_TEXTURE_ROUGHNESSDIRECTUV = 0;
            defines.CLEARCOAT_BUMPDIRECTUV = 0;
            defines.CLEARCOAT_REMAP_F0 = false;
            defines.CLEARCOAT_TINT_TEXTUREDIRECTUV = 0;
            defines.CLEARCOAT_TINT_GAMMATEXTURE = false;
        }
    }
    bindForSubMesh(uniformBuffer, scene, engine, subMesh) {
        if (!this._isEnabled) return;
        const defines = subMesh.materialDefines;
        const isFrozen = this._material.isFrozen;
        const disableBumpMap = this._material._disableBumpMap;
        const invertNormalMapX = this._material._invertNormalMapX;
        const invertNormalMapY = this._material._invertNormalMapY;
        const identicalTextures = defines.CLEARCOAT_TEXTURE_ROUGHNESS_IDENTICAL;
        if (!uniformBuffer.useUbo || !isFrozen || !uniformBuffer.isSync) {
            if (identicalTextures && (0, $2hKx5.MaterialFlags).ClearCoatTextureEnabled) {
                uniformBuffer.updateFloat4("vClearCoatInfos", this._texture.coordinatesIndex, this._texture.level, -1, -1);
                (0, $alPCh.BindTextureMatrix)(this._texture, uniformBuffer, "clearCoat");
            } else if ((this._texture || this._textureRoughness) && (0, $2hKx5.MaterialFlags).ClearCoatTextureEnabled) {
                uniformBuffer.updateFloat4("vClearCoatInfos", this._texture?.coordinatesIndex ?? 0, this._texture?.level ?? 0, this._textureRoughness?.coordinatesIndex ?? 0, this._textureRoughness?.level ?? 0);
                if (this._texture) (0, $alPCh.BindTextureMatrix)(this._texture, uniformBuffer, "clearCoat");
                if (this._textureRoughness && !identicalTextures && !defines.CLEARCOAT_USE_ROUGHNESS_FROM_MAINTEXTURE) (0, $alPCh.BindTextureMatrix)(this._textureRoughness, uniformBuffer, "clearCoatRoughness");
            }
            if (this._bumpTexture && engine.getCaps().standardDerivatives && (0, $2hKx5.MaterialFlags).ClearCoatTextureEnabled && !disableBumpMap) {
                uniformBuffer.updateFloat2("vClearCoatBumpInfos", this._bumpTexture.coordinatesIndex, this._bumpTexture.level);
                (0, $alPCh.BindTextureMatrix)(this._bumpTexture, uniformBuffer, "clearCoatBump");
                if (scene._mirroredCameraPosition) uniformBuffer.updateFloat2("vClearCoatTangentSpaceParams", invertNormalMapX ? 1.0 : -1, invertNormalMapY ? 1.0 : -1);
                else uniformBuffer.updateFloat2("vClearCoatTangentSpaceParams", invertNormalMapX ? -1 : 1.0, invertNormalMapY ? -1 : 1.0);
            }
            if (this._tintTexture && (0, $2hKx5.MaterialFlags).ClearCoatTintTextureEnabled) {
                uniformBuffer.updateFloat2("vClearCoatTintInfos", this._tintTexture.coordinatesIndex, this._tintTexture.level);
                (0, $alPCh.BindTextureMatrix)(this._tintTexture, uniformBuffer, "clearCoatTint");
            }
            // Clear Coat General params
            uniformBuffer.updateFloat2("vClearCoatParams", this.intensity, this.roughness);
            // Clear Coat Refraction params
            const a = 1 - this._indexOfRefraction;
            const b = 1 + this._indexOfRefraction;
            const f0 = Math.pow(-a / b, 2); // Schlicks approx: (ior1 - ior2) / (ior1 + ior2) where ior2 for air is close to vacuum = 1.
            const eta = 1 / this._indexOfRefraction;
            uniformBuffer.updateFloat4("vClearCoatRefractionParams", f0, eta, a, b);
            if (this._isTintEnabled) {
                uniformBuffer.updateFloat4("vClearCoatTintParams", this.tintColor.r, this.tintColor.g, this.tintColor.b, Math.max(0.00001, this.tintThickness));
                uniformBuffer.updateFloat("clearCoatColorAtDistance", Math.max(0.00001, this.tintColorAtDistance));
            }
        }
        // Textures
        if (scene.texturesEnabled) {
            if (this._texture && (0, $2hKx5.MaterialFlags).ClearCoatTextureEnabled) uniformBuffer.setTexture("clearCoatSampler", this._texture);
            if (this._textureRoughness && !identicalTextures && !defines.CLEARCOAT_USE_ROUGHNESS_FROM_MAINTEXTURE && (0, $2hKx5.MaterialFlags).ClearCoatTextureEnabled) uniformBuffer.setTexture("clearCoatRoughnessSampler", this._textureRoughness);
            if (this._bumpTexture && engine.getCaps().standardDerivatives && (0, $2hKx5.MaterialFlags).ClearCoatBumpTextureEnabled && !disableBumpMap) uniformBuffer.setTexture("clearCoatBumpSampler", this._bumpTexture);
            if (this._isTintEnabled && this._tintTexture && (0, $2hKx5.MaterialFlags).ClearCoatTintTextureEnabled) uniformBuffer.setTexture("clearCoatTintSampler", this._tintTexture);
        }
    }
    hasTexture(texture) {
        if (this._texture === texture) return true;
        if (this._textureRoughness === texture) return true;
        if (this._bumpTexture === texture) return true;
        if (this._tintTexture === texture) return true;
        return false;
    }
    getActiveTextures(activeTextures) {
        if (this._texture) activeTextures.push(this._texture);
        if (this._textureRoughness) activeTextures.push(this._textureRoughness);
        if (this._bumpTexture) activeTextures.push(this._bumpTexture);
        if (this._tintTexture) activeTextures.push(this._tintTexture);
    }
    getAnimatables(animatables) {
        if (this._texture && this._texture.animations && this._texture.animations.length > 0) animatables.push(this._texture);
        if (this._textureRoughness && this._textureRoughness.animations && this._textureRoughness.animations.length > 0) animatables.push(this._textureRoughness);
        if (this._bumpTexture && this._bumpTexture.animations && this._bumpTexture.animations.length > 0) animatables.push(this._bumpTexture);
        if (this._tintTexture && this._tintTexture.animations && this._tintTexture.animations.length > 0) animatables.push(this._tintTexture);
    }
    dispose(forceDisposeTextures) {
        if (forceDisposeTextures) {
            this._texture?.dispose();
            this._textureRoughness?.dispose();
            this._bumpTexture?.dispose();
            this._tintTexture?.dispose();
        }
    }
    getClassName() {
        return "PBRClearCoatConfiguration";
    }
    addFallbacks(defines, fallbacks, currentRank) {
        if (defines.CLEARCOAT_BUMP) fallbacks.addFallback(currentRank++, "CLEARCOAT_BUMP");
        if (defines.CLEARCOAT_TINT) fallbacks.addFallback(currentRank++, "CLEARCOAT_TINT");
        if (defines.CLEARCOAT) fallbacks.addFallback(currentRank++, "CLEARCOAT");
        return currentRank;
    }
    getSamplers(samplers) {
        samplers.push("clearCoatSampler", "clearCoatRoughnessSampler", "clearCoatBumpSampler", "clearCoatTintSampler");
    }
    getUniforms() {
        return {
            ubo: [
                {
                    name: "vClearCoatParams",
                    size: 2,
                    type: "vec2"
                },
                {
                    name: "vClearCoatRefractionParams",
                    size: 4,
                    type: "vec4"
                },
                {
                    name: "vClearCoatInfos",
                    size: 4,
                    type: "vec4"
                },
                {
                    name: "clearCoatMatrix",
                    size: 16,
                    type: "mat4"
                },
                {
                    name: "clearCoatRoughnessMatrix",
                    size: 16,
                    type: "mat4"
                },
                {
                    name: "vClearCoatBumpInfos",
                    size: 2,
                    type: "vec2"
                },
                {
                    name: "vClearCoatTangentSpaceParams",
                    size: 2,
                    type: "vec2"
                },
                {
                    name: "clearCoatBumpMatrix",
                    size: 16,
                    type: "mat4"
                },
                {
                    name: "vClearCoatTintParams",
                    size: 4,
                    type: "vec4"
                },
                {
                    name: "clearCoatColorAtDistance",
                    size: 1,
                    type: "float"
                },
                {
                    name: "vClearCoatTintInfos",
                    size: 2,
                    type: "vec2"
                },
                {
                    name: "clearCoatTintMatrix",
                    size: 16,
                    type: "mat4"
                }
            ]
        };
    }
}
/**
 * This defaults to 1.5 corresponding to a 0.04 f0 or a 4% reflectance at normal incidence
 * The default fits with a polyurethane material.
 * @internal
 */ $a2ae993db1296c0a$export$6d3220ca2057661c._DefaultIndexOfRefraction = 1.5;
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $a2ae993db1296c0a$export$6d3220ca2057661c.prototype, "isEnabled", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $a2ae993db1296c0a$export$6d3220ca2057661c.prototype, "intensity", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $a2ae993db1296c0a$export$6d3220ca2057661c.prototype, "roughness", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $a2ae993db1296c0a$export$6d3220ca2057661c.prototype, "indexOfRefraction", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $a2ae993db1296c0a$export$6d3220ca2057661c.prototype, "texture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $a2ae993db1296c0a$export$6d3220ca2057661c.prototype, "useRoughnessFromMainTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $a2ae993db1296c0a$export$6d3220ca2057661c.prototype, "textureRoughness", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $a2ae993db1296c0a$export$6d3220ca2057661c.prototype, "remapF0OnInterfaceChange", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $a2ae993db1296c0a$export$6d3220ca2057661c.prototype, "bumpTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $a2ae993db1296c0a$export$6d3220ca2057661c.prototype, "isTintEnabled", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor3)()
], $a2ae993db1296c0a$export$6d3220ca2057661c.prototype, "tintColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $a2ae993db1296c0a$export$6d3220ca2057661c.prototype, "tintColorAtDistance", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $a2ae993db1296c0a$export$6d3220ca2057661c.prototype, "tintThickness", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $a2ae993db1296c0a$export$6d3220ca2057661c.prototype, "tintTexture", void 0);

});

parcelRegister("lngOr", function(module, exports) {

$parcel$export(module.exports, "MaterialIridescenceDefines", () => $f8f8c999378ad390$export$52a0d3d88a7e58f2);
$parcel$export(module.exports, "PBRIridescenceConfiguration", () => $f8f8c999378ad390$export$d86d5f7c0bd7d272);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $2hKx5 = parcelRequire("2hKx5");

var $8XNAC = parcelRequire("8XNAC");

var $35xmP = parcelRequire("35xmP");

var $alPCh = parcelRequire("alPCh");
class $f8f8c999378ad390$export$52a0d3d88a7e58f2 extends (0, $35xmP.MaterialDefines) {
    constructor(){
        super(...arguments);
        this.IRIDESCENCE = false;
        this.IRIDESCENCE_TEXTURE = false;
        this.IRIDESCENCE_TEXTUREDIRECTUV = 0;
        this.IRIDESCENCE_THICKNESS_TEXTURE = false;
        this.IRIDESCENCE_THICKNESS_TEXTUREDIRECTUV = 0;
        this.IRIDESCENCE_USE_THICKNESS_FROM_MAINTEXTURE = false;
    }
}
class $f8f8c999378ad390$export$d86d5f7c0bd7d272 extends (0, $8XNAC.MaterialPluginBase) {
    /** @internal */ _markAllSubMeshesAsTexturesDirty() {
        this._enable(this._isEnabled);
        this._internalMarkAllSubMeshesAsTexturesDirty();
    }
    constructor(material, addToPluginList = true){
        super(material, "PBRIridescence", 110, new $f8f8c999378ad390$export$52a0d3d88a7e58f2(), addToPluginList);
        this._isEnabled = false;
        /**
         * Defines if the iridescence is enabled in the material.
         */ this.isEnabled = false;
        /**
         * Defines the iridescence layer strength (between 0 and 1) it defaults to 1.
         */ this.intensity = 1;
        /**
         * Defines the minimum thickness of the thin-film layer given in nanometers (nm).
         */ this.minimumThickness = $f8f8c999378ad390$export$d86d5f7c0bd7d272._DefaultMinimumThickness;
        /**
         * Defines the maximum thickness of the thin-film layer given in nanometers (nm). This will be the thickness used if not thickness texture has been set.
         */ this.maximumThickness = $f8f8c999378ad390$export$d86d5f7c0bd7d272._DefaultMaximumThickness;
        /**
         * Defines the maximum thickness of the thin-film layer given in nanometers (nm).
         */ this.indexOfRefraction = $f8f8c999378ad390$export$d86d5f7c0bd7d272._DefaultIndexOfRefraction;
        this._texture = null;
        /**
         * Stores the iridescence intensity in a texture (red channel)
         */ this.texture = null;
        this._thicknessTexture = null;
        /**
         * Stores the iridescence thickness in a texture (green channel)
         */ this.thicknessTexture = null;
        this._internalMarkAllSubMeshesAsTexturesDirty = material._dirtyCallbacks[1];
    }
    isReadyForSubMesh(defines, scene) {
        if (!this._isEnabled) return true;
        if (defines._areTexturesDirty) {
            if (scene.texturesEnabled) {
                if (this._texture && (0, $2hKx5.MaterialFlags).IridescenceTextureEnabled) {
                    if (!this._texture.isReadyOrNotBlocking()) return false;
                }
                if (this._thicknessTexture && (0, $2hKx5.MaterialFlags).IridescenceTextureEnabled) {
                    if (!this._thicknessTexture.isReadyOrNotBlocking()) return false;
                }
            }
        }
        return true;
    }
    prepareDefinesBeforeAttributes(defines, scene) {
        if (this._isEnabled) {
            defines.IRIDESCENCE = true;
            defines.IRIDESCENCE_USE_THICKNESS_FROM_MAINTEXTURE = this._texture !== null && this._texture._texture === this._thicknessTexture?._texture && this._texture.checkTransformsAreIdentical(this._thicknessTexture);
            if (defines._areTexturesDirty) {
                if (scene.texturesEnabled) {
                    if (this._texture && (0, $2hKx5.MaterialFlags).IridescenceTextureEnabled) (0, $alPCh.PrepareDefinesForMergedUV)(this._texture, defines, "IRIDESCENCE_TEXTURE");
                    else defines.IRIDESCENCE_TEXTURE = false;
                    if (!defines.IRIDESCENCE_USE_THICKNESS_FROM_MAINTEXTURE && this._thicknessTexture && (0, $2hKx5.MaterialFlags).IridescenceTextureEnabled) (0, $alPCh.PrepareDefinesForMergedUV)(this._thicknessTexture, defines, "IRIDESCENCE_THICKNESS_TEXTURE");
                    else defines.IRIDESCENCE_THICKNESS_TEXTURE = false;
                }
            }
        } else {
            defines.IRIDESCENCE = false;
            defines.IRIDESCENCE_TEXTURE = false;
            defines.IRIDESCENCE_THICKNESS_TEXTURE = false;
            defines.IRIDESCENCE_USE_THICKNESS_FROM_MAINTEXTURE = false;
            defines.IRIDESCENCE_TEXTUREDIRECTUV = 0;
            defines.IRIDESCENCE_THICKNESS_TEXTUREDIRECTUV = 0;
        }
    }
    bindForSubMesh(uniformBuffer, scene, engine, subMesh) {
        if (!this._isEnabled) return;
        const defines = subMesh.materialDefines;
        const isFrozen = this._material.isFrozen;
        const identicalTextures = defines.IRIDESCENCE_USE_THICKNESS_FROM_MAINTEXTURE;
        if (!uniformBuffer.useUbo || !isFrozen || !uniformBuffer.isSync) {
            if (identicalTextures && (0, $2hKx5.MaterialFlags).IridescenceTextureEnabled) {
                uniformBuffer.updateFloat4("vIridescenceInfos", this._texture.coordinatesIndex, this._texture.level, -1, -1);
                (0, $alPCh.BindTextureMatrix)(this._texture, uniformBuffer, "iridescence");
            } else if ((this._texture || this._thicknessTexture) && (0, $2hKx5.MaterialFlags).IridescenceTextureEnabled) {
                uniformBuffer.updateFloat4("vIridescenceInfos", this._texture?.coordinatesIndex ?? 0, this._texture?.level ?? 0, this._thicknessTexture?.coordinatesIndex ?? 0, this._thicknessTexture?.level ?? 0);
                if (this._texture) (0, $alPCh.BindTextureMatrix)(this._texture, uniformBuffer, "iridescence");
                if (this._thicknessTexture && !identicalTextures && !defines.IRIDESCENCE_USE_THICKNESS_FROM_MAINTEXTURE) (0, $alPCh.BindTextureMatrix)(this._thicknessTexture, uniformBuffer, "iridescenceThickness");
            }
            // Clear Coat General params
            uniformBuffer.updateFloat4("vIridescenceParams", this.intensity, this.indexOfRefraction, this.minimumThickness, this.maximumThickness);
        }
        // Textures
        if (scene.texturesEnabled) {
            if (this._texture && (0, $2hKx5.MaterialFlags).IridescenceTextureEnabled) uniformBuffer.setTexture("iridescenceSampler", this._texture);
            if (this._thicknessTexture && !identicalTextures && !defines.IRIDESCENCE_USE_THICKNESS_FROM_MAINTEXTURE && (0, $2hKx5.MaterialFlags).IridescenceTextureEnabled) uniformBuffer.setTexture("iridescenceThicknessSampler", this._thicknessTexture);
        }
    }
    hasTexture(texture) {
        if (this._texture === texture) return true;
        if (this._thicknessTexture === texture) return true;
        return false;
    }
    getActiveTextures(activeTextures) {
        if (this._texture) activeTextures.push(this._texture);
        if (this._thicknessTexture) activeTextures.push(this._thicknessTexture);
    }
    getAnimatables(animatables) {
        if (this._texture && this._texture.animations && this._texture.animations.length > 0) animatables.push(this._texture);
        if (this._thicknessTexture && this._thicknessTexture.animations && this._thicknessTexture.animations.length > 0) animatables.push(this._thicknessTexture);
    }
    dispose(forceDisposeTextures) {
        if (forceDisposeTextures) {
            this._texture?.dispose();
            this._thicknessTexture?.dispose();
        }
    }
    getClassName() {
        return "PBRIridescenceConfiguration";
    }
    addFallbacks(defines, fallbacks, currentRank) {
        if (defines.IRIDESCENCE) fallbacks.addFallback(currentRank++, "IRIDESCENCE");
        return currentRank;
    }
    getSamplers(samplers) {
        samplers.push("iridescenceSampler", "iridescenceThicknessSampler");
    }
    getUniforms() {
        return {
            ubo: [
                {
                    name: "vIridescenceParams",
                    size: 4,
                    type: "vec4"
                },
                {
                    name: "vIridescenceInfos",
                    size: 4,
                    type: "vec4"
                },
                {
                    name: "iridescenceMatrix",
                    size: 16,
                    type: "mat4"
                },
                {
                    name: "iridescenceThicknessMatrix",
                    size: 16,
                    type: "mat4"
                }
            ]
        };
    }
}
/**
 * The default minimum thickness of the thin-film layer given in nanometers (nm).
 * Defaults to 100 nm.
 * @internal
 */ $f8f8c999378ad390$export$d86d5f7c0bd7d272._DefaultMinimumThickness = 100;
/**
 * The default maximum thickness of the thin-film layer given in nanometers (nm).
 * Defaults to 400 nm.
 * @internal
 */ $f8f8c999378ad390$export$d86d5f7c0bd7d272._DefaultMaximumThickness = 400;
/**
 * The default index of refraction of the thin-film layer.
 * Defaults to 1.3
 * @internal
 */ $f8f8c999378ad390$export$d86d5f7c0bd7d272._DefaultIndexOfRefraction = 1.3;
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $f8f8c999378ad390$export$d86d5f7c0bd7d272.prototype, "isEnabled", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $f8f8c999378ad390$export$d86d5f7c0bd7d272.prototype, "intensity", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $f8f8c999378ad390$export$d86d5f7c0bd7d272.prototype, "minimumThickness", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $f8f8c999378ad390$export$d86d5f7c0bd7d272.prototype, "maximumThickness", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $f8f8c999378ad390$export$d86d5f7c0bd7d272.prototype, "indexOfRefraction", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $f8f8c999378ad390$export$d86d5f7c0bd7d272.prototype, "texture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $f8f8c999378ad390$export$d86d5f7c0bd7d272.prototype, "thicknessTexture", void 0);

});

parcelRegister("3rbQN", function(module, exports) {

$parcel$export(module.exports, "MaterialAnisotropicDefines", () => $280d15fb1bcfc670$export$a2c746ca2eeb62ab);
$parcel$export(module.exports, "PBRAnisotropicConfiguration", () => $280d15fb1bcfc670$export$ae45b9a5a9879894);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $b4i1f = parcelRequire("b4i1f");

var $ha1VO = parcelRequire("ha1VO");

var $2hKx5 = parcelRequire("2hKx5");

var $8XNAC = parcelRequire("8XNAC");

var $35xmP = parcelRequire("35xmP");

var $alPCh = parcelRequire("alPCh");
class $280d15fb1bcfc670$export$a2c746ca2eeb62ab extends (0, $35xmP.MaterialDefines) {
    constructor(){
        super(...arguments);
        this.ANISOTROPIC = false;
        this.ANISOTROPIC_TEXTURE = false;
        this.ANISOTROPIC_TEXTUREDIRECTUV = 0;
        this.ANISOTROPIC_LEGACY = false;
        this.MAINUV1 = false;
    }
}
class $280d15fb1bcfc670$export$ae45b9a5a9879894 extends (0, $8XNAC.MaterialPluginBase) {
    /**
     * Sets the anisotropy direction as an angle.
     */ set angle(value) {
        this.direction.x = Math.cos(value);
        this.direction.y = Math.sin(value);
    }
    /**
     * Gets the anisotropy angle value in radians.
     * @returns the anisotropy angle value in radians.
     */ get angle() {
        return Math.atan2(this.direction.y, this.direction.x);
    }
    /** @internal */ _markAllSubMeshesAsTexturesDirty() {
        this._enable(this._isEnabled);
        this._internalMarkAllSubMeshesAsTexturesDirty();
    }
    /** @internal */ _markAllSubMeshesAsMiscDirty() {
        this._enable(this._isEnabled);
        this._internalMarkAllSubMeshesAsMiscDirty();
    }
    constructor(material, addToPluginList = true){
        super(material, "PBRAnisotropic", 110, new $280d15fb1bcfc670$export$a2c746ca2eeb62ab(), addToPluginList);
        this._isEnabled = false;
        /**
         * Defines if the anisotropy is enabled in the material.
         */ this.isEnabled = false;
        /**
         * Defines the anisotropy strength (between 0 and 1) it defaults to 1.
         */ this.intensity = 1;
        /**
         * Defines if the effect is along the tangents, bitangents or in between.
         * By default, the effect is "stretching" the highlights along the tangents.
         */ this.direction = new (0, $ha1VO.Vector2)(1, 0);
        this._texture = null;
        /**
         * Stores the anisotropy values in a texture.
         * rg is direction (like normal from -1 to 1)
         * b is a intensity
         */ this.texture = null;
        this._legacy = false;
        /**
         * Defines if the anisotropy is in legacy mode for backwards compatibility before 6.4.0.
         */ this.legacy = false;
        this._internalMarkAllSubMeshesAsTexturesDirty = material._dirtyCallbacks[1];
        this._internalMarkAllSubMeshesAsMiscDirty = material._dirtyCallbacks[16];
    }
    isReadyForSubMesh(defines, scene) {
        if (!this._isEnabled) return true;
        if (defines._areTexturesDirty) {
            if (scene.texturesEnabled) {
                if (this._texture && (0, $2hKx5.MaterialFlags).AnisotropicTextureEnabled) {
                    if (!this._texture.isReadyOrNotBlocking()) return false;
                }
            }
        }
        return true;
    }
    prepareDefinesBeforeAttributes(defines, scene, mesh) {
        if (this._isEnabled) {
            defines.ANISOTROPIC = this._isEnabled;
            if (this._isEnabled && !mesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).TangentKind)) {
                defines._needUVs = true;
                defines.MAINUV1 = true;
            }
            if (defines._areTexturesDirty) {
                if (scene.texturesEnabled) {
                    if (this._texture && (0, $2hKx5.MaterialFlags).AnisotropicTextureEnabled) (0, $alPCh.PrepareDefinesForMergedUV)(this._texture, defines, "ANISOTROPIC_TEXTURE");
                    else defines.ANISOTROPIC_TEXTURE = false;
                }
            }
            if (defines._areMiscDirty) defines.ANISOTROPIC_LEGACY = this._legacy;
        } else {
            defines.ANISOTROPIC = false;
            defines.ANISOTROPIC_TEXTURE = false;
            defines.ANISOTROPIC_TEXTUREDIRECTUV = 0;
            defines.ANISOTROPIC_LEGACY = false;
        }
    }
    bindForSubMesh(uniformBuffer, scene) {
        if (!this._isEnabled) return;
        const isFrozen = this._material.isFrozen;
        if (!uniformBuffer.useUbo || !isFrozen || !uniformBuffer.isSync) {
            if (this._texture && (0, $2hKx5.MaterialFlags).AnisotropicTextureEnabled) {
                uniformBuffer.updateFloat2("vAnisotropyInfos", this._texture.coordinatesIndex, this._texture.level);
                (0, $alPCh.BindTextureMatrix)(this._texture, uniformBuffer, "anisotropy");
            }
            // Anisotropy
            uniformBuffer.updateFloat3("vAnisotropy", this.direction.x, this.direction.y, this.intensity);
        }
        // Textures
        if (scene.texturesEnabled) {
            if (this._texture && (0, $2hKx5.MaterialFlags).AnisotropicTextureEnabled) uniformBuffer.setTexture("anisotropySampler", this._texture);
        }
    }
    hasTexture(texture) {
        if (this._texture === texture) return true;
        return false;
    }
    getActiveTextures(activeTextures) {
        if (this._texture) activeTextures.push(this._texture);
    }
    getAnimatables(animatables) {
        if (this._texture && this._texture.animations && this._texture.animations.length > 0) animatables.push(this._texture);
    }
    dispose(forceDisposeTextures) {
        if (forceDisposeTextures) {
            if (this._texture) this._texture.dispose();
        }
    }
    getClassName() {
        return "PBRAnisotropicConfiguration";
    }
    addFallbacks(defines, fallbacks, currentRank) {
        if (defines.ANISOTROPIC) fallbacks.addFallback(currentRank++, "ANISOTROPIC");
        return currentRank;
    }
    getSamplers(samplers) {
        samplers.push("anisotropySampler");
    }
    getUniforms() {
        return {
            ubo: [
                {
                    name: "vAnisotropy",
                    size: 3,
                    type: "vec3"
                },
                {
                    name: "vAnisotropyInfos",
                    size: 2,
                    type: "vec2"
                },
                {
                    name: "anisotropyMatrix",
                    size: 16,
                    type: "mat4"
                }
            ]
        };
    }
    /**
     * Parses a anisotropy Configuration from a serialized object.
     * @param source - Serialized object.
     * @param scene Defines the scene we are parsing for
     * @param rootUrl Defines the rootUrl to load from
     */ parse(source, scene, rootUrl) {
        super.parse(source, scene, rootUrl);
        // Backward compatibility
        if (source.legacy === undefined) this.legacy = true;
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $280d15fb1bcfc670$export$ae45b9a5a9879894.prototype, "isEnabled", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $280d15fb1bcfc670$export$ae45b9a5a9879894.prototype, "intensity", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsVector2)()
], $280d15fb1bcfc670$export$ae45b9a5a9879894.prototype, "direction", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $280d15fb1bcfc670$export$ae45b9a5a9879894.prototype, "texture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsMiscDirty")
], $280d15fb1bcfc670$export$ae45b9a5a9879894.prototype, "legacy", void 0);

});

parcelRegister("4T4Yv", function(module, exports) {

$parcel$export(module.exports, "MaterialSheenDefines", () => $38f02867fcb22a57$export$58a95897ae6a67fe);
$parcel$export(module.exports, "PBRSheenConfiguration", () => $38f02867fcb22a57$export$3171adb304f6be6b);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $7etnY = parcelRequire("7etnY");

var $2hKx5 = parcelRequire("2hKx5");

var $8XNAC = parcelRequire("8XNAC");

var $35xmP = parcelRequire("35xmP");

var $alPCh = parcelRequire("alPCh");
class $38f02867fcb22a57$export$58a95897ae6a67fe extends (0, $35xmP.MaterialDefines) {
    constructor(){
        super(...arguments);
        this.SHEEN = false;
        this.SHEEN_TEXTURE = false;
        this.SHEEN_GAMMATEXTURE = false;
        this.SHEEN_TEXTURE_ROUGHNESS = false;
        this.SHEEN_TEXTUREDIRECTUV = 0;
        this.SHEEN_TEXTURE_ROUGHNESSDIRECTUV = 0;
        this.SHEEN_LINKWITHALBEDO = false;
        this.SHEEN_ROUGHNESS = false;
        this.SHEEN_ALBEDOSCALING = false;
        this.SHEEN_USE_ROUGHNESS_FROM_MAINTEXTURE = false;
        this.SHEEN_TEXTURE_ROUGHNESS_IDENTICAL = false;
    }
}
class $38f02867fcb22a57$export$3171adb304f6be6b extends (0, $8XNAC.MaterialPluginBase) {
    /** @internal */ _markAllSubMeshesAsTexturesDirty() {
        this._enable(this._isEnabled);
        this._internalMarkAllSubMeshesAsTexturesDirty();
    }
    constructor(material, addToPluginList = true){
        super(material, "Sheen", 120, new $38f02867fcb22a57$export$58a95897ae6a67fe(), addToPluginList);
        this._isEnabled = false;
        /**
         * Defines if the material uses sheen.
         */ this.isEnabled = false;
        this._linkSheenWithAlbedo = false;
        /**
         * Defines if the sheen is linked to the sheen color.
         */ this.linkSheenWithAlbedo = false;
        /**
         * Defines the sheen intensity.
         */ this.intensity = 1;
        /**
         * Defines the sheen color.
         */ this.color = (0, $7etnY.Color3).White();
        this._texture = null;
        /**
         * Stores the sheen tint values in a texture.
         * rgb is tint
         * a is a intensity or roughness if the roughness property has been defined and useRoughnessFromTexture is true (in that case, textureRoughness won't be used)
         * If the roughness property has been defined and useRoughnessFromTexture is false then the alpha channel is not used to modulate roughness
         */ this.texture = null;
        this._useRoughnessFromMainTexture = true;
        /**
         * Indicates that the alpha channel of the texture property will be used for roughness.
         * Has no effect if the roughness (and texture!) property is not defined
         */ this.useRoughnessFromMainTexture = true;
        this._roughness = null;
        /**
         * Defines the sheen roughness.
         * It is not taken into account if linkSheenWithAlbedo is true.
         * To stay backward compatible, material roughness is used instead if sheen roughness = null
         */ this.roughness = null;
        this._textureRoughness = null;
        /**
         * Stores the sheen roughness in a texture.
         * alpha channel is the roughness. This texture won't be used if the texture property is not empty and useRoughnessFromTexture is true
         */ this.textureRoughness = null;
        this._albedoScaling = false;
        /**
         * If true, the sheen effect is layered above the base BRDF with the albedo-scaling technique.
         * It allows the strength of the sheen effect to not depend on the base color of the material,
         * making it easier to setup and tweak the effect
         */ this.albedoScaling = false;
        this._internalMarkAllSubMeshesAsTexturesDirty = material._dirtyCallbacks[1];
    }
    isReadyForSubMesh(defines, scene) {
        if (!this._isEnabled) return true;
        if (defines._areTexturesDirty) {
            if (scene.texturesEnabled) {
                if (this._texture && (0, $2hKx5.MaterialFlags).SheenTextureEnabled) {
                    if (!this._texture.isReadyOrNotBlocking()) return false;
                }
                if (this._textureRoughness && (0, $2hKx5.MaterialFlags).SheenTextureEnabled) {
                    if (!this._textureRoughness.isReadyOrNotBlocking()) return false;
                }
            }
        }
        return true;
    }
    prepareDefinesBeforeAttributes(defines, scene) {
        if (this._isEnabled) {
            defines.SHEEN = true;
            defines.SHEEN_LINKWITHALBEDO = this._linkSheenWithAlbedo;
            defines.SHEEN_ROUGHNESS = this._roughness !== null;
            defines.SHEEN_ALBEDOSCALING = this._albedoScaling;
            defines.SHEEN_USE_ROUGHNESS_FROM_MAINTEXTURE = this._useRoughnessFromMainTexture;
            defines.SHEEN_TEXTURE_ROUGHNESS_IDENTICAL = this._texture !== null && this._texture._texture === this._textureRoughness?._texture && this._texture.checkTransformsAreIdentical(this._textureRoughness);
            if (defines._areTexturesDirty) {
                if (scene.texturesEnabled) {
                    if (this._texture && (0, $2hKx5.MaterialFlags).SheenTextureEnabled) {
                        (0, $alPCh.PrepareDefinesForMergedUV)(this._texture, defines, "SHEEN_TEXTURE");
                        defines.SHEEN_GAMMATEXTURE = this._texture.gammaSpace;
                    } else defines.SHEEN_TEXTURE = false;
                    if (this._textureRoughness && (0, $2hKx5.MaterialFlags).SheenTextureEnabled) (0, $alPCh.PrepareDefinesForMergedUV)(this._textureRoughness, defines, "SHEEN_TEXTURE_ROUGHNESS");
                    else defines.SHEEN_TEXTURE_ROUGHNESS = false;
                }
            }
        } else {
            defines.SHEEN = false;
            defines.SHEEN_TEXTURE = false;
            defines.SHEEN_TEXTURE_ROUGHNESS = false;
            defines.SHEEN_LINKWITHALBEDO = false;
            defines.SHEEN_ROUGHNESS = false;
            defines.SHEEN_ALBEDOSCALING = false;
            defines.SHEEN_USE_ROUGHNESS_FROM_MAINTEXTURE = false;
            defines.SHEEN_TEXTURE_ROUGHNESS_IDENTICAL = false;
            defines.SHEEN_GAMMATEXTURE = false;
            defines.SHEEN_TEXTUREDIRECTUV = 0;
            defines.SHEEN_TEXTURE_ROUGHNESSDIRECTUV = 0;
        }
    }
    bindForSubMesh(uniformBuffer, scene, engine, subMesh) {
        if (!this._isEnabled) return;
        const defines = subMesh.materialDefines;
        const isFrozen = this._material.isFrozen;
        const identicalTextures = defines.SHEEN_TEXTURE_ROUGHNESS_IDENTICAL;
        if (!uniformBuffer.useUbo || !isFrozen || !uniformBuffer.isSync) {
            if (identicalTextures && (0, $2hKx5.MaterialFlags).SheenTextureEnabled) {
                uniformBuffer.updateFloat4("vSheenInfos", this._texture.coordinatesIndex, this._texture.level, -1, -1);
                (0, $alPCh.BindTextureMatrix)(this._texture, uniformBuffer, "sheen");
            } else if ((this._texture || this._textureRoughness) && (0, $2hKx5.MaterialFlags).SheenTextureEnabled) {
                uniformBuffer.updateFloat4("vSheenInfos", this._texture?.coordinatesIndex ?? 0, this._texture?.level ?? 0, this._textureRoughness?.coordinatesIndex ?? 0, this._textureRoughness?.level ?? 0);
                if (this._texture) (0, $alPCh.BindTextureMatrix)(this._texture, uniformBuffer, "sheen");
                if (this._textureRoughness && !identicalTextures && !defines.SHEEN_USE_ROUGHNESS_FROM_MAINTEXTURE) (0, $alPCh.BindTextureMatrix)(this._textureRoughness, uniformBuffer, "sheenRoughness");
            }
            // Sheen
            uniformBuffer.updateFloat4("vSheenColor", this.color.r, this.color.g, this.color.b, this.intensity);
            if (this._roughness !== null) uniformBuffer.updateFloat("vSheenRoughness", this._roughness);
        }
        // Textures
        if (scene.texturesEnabled) {
            if (this._texture && (0, $2hKx5.MaterialFlags).SheenTextureEnabled) uniformBuffer.setTexture("sheenSampler", this._texture);
            if (this._textureRoughness && !identicalTextures && !defines.SHEEN_USE_ROUGHNESS_FROM_MAINTEXTURE && (0, $2hKx5.MaterialFlags).SheenTextureEnabled) uniformBuffer.setTexture("sheenRoughnessSampler", this._textureRoughness);
        }
    }
    hasTexture(texture) {
        if (this._texture === texture) return true;
        if (this._textureRoughness === texture) return true;
        return false;
    }
    getActiveTextures(activeTextures) {
        if (this._texture) activeTextures.push(this._texture);
        if (this._textureRoughness) activeTextures.push(this._textureRoughness);
    }
    getAnimatables(animatables) {
        if (this._texture && this._texture.animations && this._texture.animations.length > 0) animatables.push(this._texture);
        if (this._textureRoughness && this._textureRoughness.animations && this._textureRoughness.animations.length > 0) animatables.push(this._textureRoughness);
    }
    dispose(forceDisposeTextures) {
        if (forceDisposeTextures) {
            this._texture?.dispose();
            this._textureRoughness?.dispose();
        }
    }
    getClassName() {
        return "PBRSheenConfiguration";
    }
    addFallbacks(defines, fallbacks, currentRank) {
        if (defines.SHEEN) fallbacks.addFallback(currentRank++, "SHEEN");
        return currentRank;
    }
    getSamplers(samplers) {
        samplers.push("sheenSampler", "sheenRoughnessSampler");
    }
    getUniforms() {
        return {
            ubo: [
                {
                    name: "vSheenColor",
                    size: 4,
                    type: "vec4"
                },
                {
                    name: "vSheenRoughness",
                    size: 1,
                    type: "float"
                },
                {
                    name: "vSheenInfos",
                    size: 4,
                    type: "vec4"
                },
                {
                    name: "sheenMatrix",
                    size: 16,
                    type: "mat4"
                },
                {
                    name: "sheenRoughnessMatrix",
                    size: 16,
                    type: "mat4"
                }
            ]
        };
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $38f02867fcb22a57$export$3171adb304f6be6b.prototype, "isEnabled", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $38f02867fcb22a57$export$3171adb304f6be6b.prototype, "linkSheenWithAlbedo", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $38f02867fcb22a57$export$3171adb304f6be6b.prototype, "intensity", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor3)()
], $38f02867fcb22a57$export$3171adb304f6be6b.prototype, "color", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $38f02867fcb22a57$export$3171adb304f6be6b.prototype, "texture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $38f02867fcb22a57$export$3171adb304f6be6b.prototype, "useRoughnessFromMainTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $38f02867fcb22a57$export$3171adb304f6be6b.prototype, "roughness", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $38f02867fcb22a57$export$3171adb304f6be6b.prototype, "textureRoughness", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $38f02867fcb22a57$export$3171adb304f6be6b.prototype, "albedoScaling", void 0);

});

parcelRegister("5Nlza", function(module, exports) {

$parcel$export(module.exports, "MaterialSubSurfaceDefines", () => $438241f205d9c5c7$export$abaa8bff12eeb604);
$parcel$export(module.exports, "PBRSubSurfaceConfiguration", () => $438241f205d9c5c7$export$963b3563d9af0310);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $7etnY = parcelRequire("7etnY");

var $2hKx5 = parcelRequire("2hKx5");

var $1VEEL = parcelRequire("1VEEL");

var $ha1VO = parcelRequire("ha1VO");

var $8XNAC = parcelRequire("8XNAC");

var $35xmP = parcelRequire("35xmP");

var $alPCh = parcelRequire("alPCh");
class $438241f205d9c5c7$export$abaa8bff12eeb604 extends (0, $35xmP.MaterialDefines) {
    constructor(){
        super(...arguments);
        this.SUBSURFACE = false;
        this.SS_REFRACTION = false;
        this.SS_REFRACTION_USE_INTENSITY_FROM_TEXTURE = false;
        this.SS_TRANSLUCENCY = false;
        this.SS_TRANSLUCENCY_USE_INTENSITY_FROM_TEXTURE = false;
        this.SS_SCATTERING = false;
        this.SS_DISPERSION = false;
        this.SS_THICKNESSANDMASK_TEXTURE = false;
        this.SS_THICKNESSANDMASK_TEXTUREDIRECTUV = 0;
        this.SS_HAS_THICKNESS = false;
        this.SS_REFRACTIONINTENSITY_TEXTURE = false;
        this.SS_REFRACTIONINTENSITY_TEXTUREDIRECTUV = 0;
        this.SS_TRANSLUCENCYINTENSITY_TEXTURE = false;
        this.SS_TRANSLUCENCYINTENSITY_TEXTUREDIRECTUV = 0;
        this.SS_REFRACTIONMAP_3D = false;
        this.SS_REFRACTIONMAP_OPPOSITEZ = false;
        this.SS_LODINREFRACTIONALPHA = false;
        this.SS_GAMMAREFRACTION = false;
        this.SS_RGBDREFRACTION = false;
        this.SS_LINEARSPECULARREFRACTION = false;
        this.SS_LINKREFRACTIONTOTRANSPARENCY = false;
        this.SS_ALBEDOFORREFRACTIONTINT = false;
        this.SS_ALBEDOFORTRANSLUCENCYTINT = false;
        this.SS_USE_LOCAL_REFRACTIONMAP_CUBIC = false;
        this.SS_USE_THICKNESS_AS_DEPTH = false;
        this.SS_MASK_FROM_THICKNESS_TEXTURE = false;
        this.SS_USE_GLTF_TEXTURES = false;
    }
}
class $438241f205d9c5c7$export$963b3563d9af0310 extends (0, $8XNAC.MaterialPluginBase) {
    /**
     * Diffusion profile for subsurface scattering.
     * Useful for better scattering in the skins or foliages.
     */ get scatteringDiffusionProfile() {
        if (!this._scene.subSurfaceConfiguration) return null;
        return this._scene.subSurfaceConfiguration.ssDiffusionProfileColors[this._scatteringDiffusionProfileIndex];
    }
    set scatteringDiffusionProfile(c) {
        if (!this._scene.enableSubSurfaceForPrePass()) // Not supported
        return;
        // addDiffusionProfile automatically checks for doubles
        if (c) this._scatteringDiffusionProfileIndex = this._scene.subSurfaceConfiguration.addDiffusionProfile(c);
    }
    /**
     * Index of refraction of the material's volume.
     * https://en.wikipedia.org/wiki/List_of_refractive_indices
     *
     * This ONLY impacts refraction. If not provided or given a non-valid value,
     * the volume will use the same IOR as the surface.
     */ get volumeIndexOfRefraction() {
        if (this._volumeIndexOfRefraction >= 1.0) return this._volumeIndexOfRefraction;
        return this._indexOfRefraction;
    }
    set volumeIndexOfRefraction(value) {
        if (value >= 1.0) this._volumeIndexOfRefraction = value;
        else this._volumeIndexOfRefraction = -1;
    }
    /** @internal */ _markAllSubMeshesAsTexturesDirty() {
        this._enable(this._isRefractionEnabled || this._isTranslucencyEnabled || this._isScatteringEnabled);
        this._internalMarkAllSubMeshesAsTexturesDirty();
    }
    /** @internal */ _markScenePrePassDirty() {
        this._internalMarkAllSubMeshesAsTexturesDirty();
        this._internalMarkScenePrePassDirty();
    }
    constructor(material, addToPluginList = true){
        super(material, "PBRSubSurface", 130, new $438241f205d9c5c7$export$abaa8bff12eeb604(), addToPluginList);
        this._isRefractionEnabled = false;
        /**
         * Defines if the refraction is enabled in the material.
         */ this.isRefractionEnabled = false;
        this._isTranslucencyEnabled = false;
        /**
         * Defines if the translucency is enabled in the material.
         */ this.isTranslucencyEnabled = false;
        this._isDispersionEnabled = false;
        /**
         * Defines if dispersion is enabled in the material.
         */ this.isDispersionEnabled = false;
        this._isScatteringEnabled = false;
        /**
         * Defines if the sub surface scattering is enabled in the material.
         */ this.isScatteringEnabled = false;
        this._scatteringDiffusionProfileIndex = 0;
        /**
         * Defines the refraction intensity of the material.
         * The refraction when enabled replaces the Diffuse part of the material.
         * The intensity helps transitioning between diffuse and refraction.
         */ this.refractionIntensity = 1;
        /**
         * Defines the translucency intensity of the material.
         * When translucency has been enabled, this defines how much of the "translucency"
         * is added to the diffuse part of the material.
         */ this.translucencyIntensity = 1;
        /**
         * When enabled, transparent surfaces will be tinted with the albedo colour (independent of thickness)
         */ this.useAlbedoToTintRefraction = false;
        /**
         * When enabled, translucent surfaces will be tinted with the albedo colour (independent of thickness)
         */ this.useAlbedoToTintTranslucency = false;
        this._thicknessTexture = null;
        /**
         * Stores the average thickness of a mesh in a texture (The texture is holding the values linearly).
         * The red (or green if useGltfStyleTextures=true) channel of the texture should contain the thickness remapped between 0 and 1.
         * 0 would mean minimumThickness
         * 1 would mean maximumThickness
         * The other channels might be use as a mask to vary the different effects intensity.
         */ this.thicknessTexture = null;
        this._refractionTexture = null;
        /**
         * Defines the texture to use for refraction.
         */ this.refractionTexture = null;
        /** @internal */ this._indexOfRefraction = 1.5;
        /**
         * Index of refraction of the material base layer.
         * https://en.wikipedia.org/wiki/List_of_refractive_indices
         *
         * This does not only impact refraction but also the Base F0 of Dielectric Materials.
         *
         * From dielectric fresnel rules: F0 = square((iorT - iorI) / (iorT + iorI))
         */ this.indexOfRefraction = 1.5;
        this._volumeIndexOfRefraction = -1;
        this._invertRefractionY = false;
        /**
         * Controls if refraction needs to be inverted on Y. This could be useful for procedural texture.
         */ this.invertRefractionY = false;
        /** @internal */ this._linkRefractionWithTransparency = false;
        /**
         * This parameters will make the material used its opacity to control how much it is refracting against not.
         * Materials half opaque for instance using refraction could benefit from this control.
         */ this.linkRefractionWithTransparency = false;
        /**
         * Defines the minimum thickness stored in the thickness map.
         * If no thickness map is defined, this value will be used to simulate thickness.
         */ this.minimumThickness = 0;
        /**
         * Defines the maximum thickness stored in the thickness map.
         */ this.maximumThickness = 1;
        /**
         * Defines that the thickness should be used as a measure of the depth volume.
         */ this.useThicknessAsDepth = false;
        /**
         * Defines the volume tint of the material.
         * This is used for both translucency and scattering.
         */ this.tintColor = (0, $7etnY.Color3).White();
        /**
         * Defines the distance at which the tint color should be found in the media.
         * This is used for refraction only.
         */ this.tintColorAtDistance = 1;
        /**
         * Defines the Abbe number for the volume.
         */ this.dispersion = 0;
        /**
         * Defines how far each channel transmit through the media.
         * It is defined as a color to simplify it selection.
         */ this.diffusionDistance = (0, $7etnY.Color3).White();
        this._useMaskFromThicknessTexture = false;
        /**
         * Stores the intensity of the different subsurface effects in the thickness texture.
         * Note that if refractionIntensityTexture and/or translucencyIntensityTexture is provided it takes precedence over thicknessTexture + useMaskFromThicknessTexture
         * * the green (red if useGltfStyleTextures = true) channel is the refraction intensity.
         * * the blue channel is the translucency intensity.
         */ this.useMaskFromThicknessTexture = false;
        this._refractionIntensityTexture = null;
        /**
         * Stores the intensity of the refraction. If provided, it takes precedence over thicknessTexture + useMaskFromThicknessTexture
         * * the green (red if useGltfStyleTextures = true) channel is the refraction intensity.
         */ this.refractionIntensityTexture = null;
        this._translucencyIntensityTexture = null;
        /**
         * Stores the intensity of the translucency. If provided, it takes precedence over thicknessTexture + useMaskFromThicknessTexture
         * * the blue channel is the translucency intensity.
         */ this.translucencyIntensityTexture = null;
        this._useGltfStyleTextures = false;
        /**
         * Use channels layout used by glTF:
         * * thicknessTexture: the green (instead of red) channel is the thickness
         * * thicknessTexture/refractionIntensityTexture: the red (instead of green) channel is the refraction intensity
         * * thicknessTexture/translucencyIntensityTexture: no change, use the blue channel for the translucency intensity
         */ this.useGltfStyleTextures = false;
        this._scene = material.getScene();
        this.registerForExtraEvents = true;
        this._internalMarkAllSubMeshesAsTexturesDirty = material._dirtyCallbacks[1];
        this._internalMarkScenePrePassDirty = material._dirtyCallbacks[32];
    }
    isReadyForSubMesh(defines, scene) {
        if (!this._isRefractionEnabled && !this._isTranslucencyEnabled && !this._isScatteringEnabled) return true;
        if (defines._areTexturesDirty) {
            if (scene.texturesEnabled) {
                if (this._thicknessTexture && (0, $2hKx5.MaterialFlags).ThicknessTextureEnabled) {
                    if (!this._thicknessTexture.isReadyOrNotBlocking()) return false;
                }
                const refractionTexture = this._getRefractionTexture(scene);
                if (refractionTexture && (0, $2hKx5.MaterialFlags).RefractionTextureEnabled) {
                    if (!refractionTexture.isReadyOrNotBlocking()) return false;
                }
            }
        }
        return true;
    }
    prepareDefinesBeforeAttributes(defines, scene) {
        if (!this._isRefractionEnabled && !this._isTranslucencyEnabled && !this._isScatteringEnabled) {
            defines.SUBSURFACE = false;
            defines.SS_DISPERSION = false;
            defines.SS_TRANSLUCENCY = false;
            defines.SS_SCATTERING = false;
            defines.SS_REFRACTION = false;
            defines.SS_REFRACTION_USE_INTENSITY_FROM_TEXTURE = false;
            defines.SS_TRANSLUCENCY_USE_INTENSITY_FROM_TEXTURE = false;
            defines.SS_THICKNESSANDMASK_TEXTURE = false;
            defines.SS_THICKNESSANDMASK_TEXTUREDIRECTUV = 0;
            defines.SS_HAS_THICKNESS = false;
            defines.SS_REFRACTIONINTENSITY_TEXTURE = false;
            defines.SS_REFRACTIONINTENSITY_TEXTUREDIRECTUV = 0;
            defines.SS_TRANSLUCENCYINTENSITY_TEXTURE = false;
            defines.SS_TRANSLUCENCYINTENSITY_TEXTUREDIRECTUV = 0;
            defines.SS_REFRACTIONMAP_3D = false;
            defines.SS_REFRACTIONMAP_OPPOSITEZ = false;
            defines.SS_LODINREFRACTIONALPHA = false;
            defines.SS_GAMMAREFRACTION = false;
            defines.SS_RGBDREFRACTION = false;
            defines.SS_LINEARSPECULARREFRACTION = false;
            defines.SS_LINKREFRACTIONTOTRANSPARENCY = false;
            defines.SS_ALBEDOFORREFRACTIONTINT = false;
            defines.SS_ALBEDOFORTRANSLUCENCYTINT = false;
            defines.SS_USE_LOCAL_REFRACTIONMAP_CUBIC = false;
            defines.SS_USE_THICKNESS_AS_DEPTH = false;
            defines.SS_MASK_FROM_THICKNESS_TEXTURE = false;
            defines.SS_USE_GLTF_TEXTURES = false;
            return;
        }
        if (defines._areTexturesDirty) {
            defines.SUBSURFACE = true;
            defines.SS_DISPERSION = this._isDispersionEnabled;
            defines.SS_TRANSLUCENCY = this._isTranslucencyEnabled;
            defines.SS_TRANSLUCENCY_USE_INTENSITY_FROM_TEXTURE = false;
            defines.SS_SCATTERING = this._isScatteringEnabled;
            defines.SS_THICKNESSANDMASK_TEXTURE = false;
            defines.SS_REFRACTIONINTENSITY_TEXTURE = false;
            defines.SS_TRANSLUCENCYINTENSITY_TEXTURE = false;
            defines.SS_HAS_THICKNESS = false;
            defines.SS_MASK_FROM_THICKNESS_TEXTURE = false;
            defines.SS_USE_GLTF_TEXTURES = false;
            defines.SS_REFRACTION = false;
            defines.SS_REFRACTION_USE_INTENSITY_FROM_TEXTURE = false;
            defines.SS_REFRACTIONMAP_3D = false;
            defines.SS_GAMMAREFRACTION = false;
            defines.SS_RGBDREFRACTION = false;
            defines.SS_LINEARSPECULARREFRACTION = false;
            defines.SS_REFRACTIONMAP_OPPOSITEZ = false;
            defines.SS_LODINREFRACTIONALPHA = false;
            defines.SS_LINKREFRACTIONTOTRANSPARENCY = false;
            defines.SS_ALBEDOFORREFRACTIONTINT = false;
            defines.SS_ALBEDOFORTRANSLUCENCYTINT = false;
            defines.SS_USE_LOCAL_REFRACTIONMAP_CUBIC = false;
            defines.SS_USE_THICKNESS_AS_DEPTH = false;
            const refractionIntensityTextureIsThicknessTexture = !!this._thicknessTexture && !!this._refractionIntensityTexture && this._refractionIntensityTexture.checkTransformsAreIdentical(this._thicknessTexture) && this._refractionIntensityTexture._texture === this._thicknessTexture._texture;
            const translucencyIntensityTextureIsThicknessTexture = !!this._thicknessTexture && !!this._translucencyIntensityTexture && this._translucencyIntensityTexture.checkTransformsAreIdentical(this._thicknessTexture) && this._translucencyIntensityTexture._texture === this._thicknessTexture._texture;
            // if true, it means the refraction/translucency textures are the same than the thickness texture so there's no need to pass them to the shader, only thicknessTexture
            const useOnlyThicknessTexture = (refractionIntensityTextureIsThicknessTexture || !this._refractionIntensityTexture) && (translucencyIntensityTextureIsThicknessTexture || !this._translucencyIntensityTexture);
            if (defines._areTexturesDirty) {
                if (scene.texturesEnabled) {
                    if (this._thicknessTexture && (0, $2hKx5.MaterialFlags).ThicknessTextureEnabled) (0, $alPCh.PrepareDefinesForMergedUV)(this._thicknessTexture, defines, "SS_THICKNESSANDMASK_TEXTURE");
                    if (this._refractionIntensityTexture && (0, $2hKx5.MaterialFlags).RefractionIntensityTextureEnabled && !useOnlyThicknessTexture) (0, $alPCh.PrepareDefinesForMergedUV)(this._refractionIntensityTexture, defines, "SS_REFRACTIONINTENSITY_TEXTURE");
                    if (this._translucencyIntensityTexture && (0, $2hKx5.MaterialFlags).TranslucencyIntensityTextureEnabled && !useOnlyThicknessTexture) (0, $alPCh.PrepareDefinesForMergedUV)(this._translucencyIntensityTexture, defines, "SS_TRANSLUCENCYINTENSITY_TEXTURE");
                }
            }
            defines.SS_HAS_THICKNESS = this.maximumThickness - this.minimumThickness !== 0.0;
            defines.SS_MASK_FROM_THICKNESS_TEXTURE = (this._useMaskFromThicknessTexture || !!this._refractionIntensityTexture || !!this._translucencyIntensityTexture) && useOnlyThicknessTexture;
            defines.SS_USE_GLTF_TEXTURES = this._useGltfStyleTextures;
            defines.SS_REFRACTION_USE_INTENSITY_FROM_TEXTURE = (this._useMaskFromThicknessTexture || !!this._refractionIntensityTexture) && useOnlyThicknessTexture;
            defines.SS_TRANSLUCENCY_USE_INTENSITY_FROM_TEXTURE = (this._useMaskFromThicknessTexture || !!this._translucencyIntensityTexture) && useOnlyThicknessTexture;
            if (this._isRefractionEnabled) {
                if (scene.texturesEnabled) {
                    const refractionTexture = this._getRefractionTexture(scene);
                    if (refractionTexture && (0, $2hKx5.MaterialFlags).RefractionTextureEnabled) {
                        defines.SS_REFRACTION = true;
                        defines.SS_REFRACTIONMAP_3D = refractionTexture.isCube;
                        defines.SS_GAMMAREFRACTION = refractionTexture.gammaSpace;
                        defines.SS_RGBDREFRACTION = refractionTexture.isRGBD;
                        defines.SS_LINEARSPECULARREFRACTION = refractionTexture.linearSpecularLOD;
                        defines.SS_REFRACTIONMAP_OPPOSITEZ = this._scene.useRightHandedSystem && refractionTexture.isCube ? !refractionTexture.invertZ : refractionTexture.invertZ;
                        defines.SS_LODINREFRACTIONALPHA = refractionTexture.lodLevelInAlpha;
                        defines.SS_LINKREFRACTIONTOTRANSPARENCY = this._linkRefractionWithTransparency;
                        defines.SS_ALBEDOFORREFRACTIONTINT = this.useAlbedoToTintRefraction;
                        defines.SS_USE_LOCAL_REFRACTIONMAP_CUBIC = refractionTexture.isCube && refractionTexture.boundingBoxSize;
                        defines.SS_USE_THICKNESS_AS_DEPTH = this.useThicknessAsDepth;
                    }
                }
            }
            if (this._isTranslucencyEnabled) defines.SS_ALBEDOFORTRANSLUCENCYTINT = this.useAlbedoToTintTranslucency;
        }
    }
    /**
     * Binds the material data (this function is called even if mustRebind() returns false)
     * @param uniformBuffer defines the Uniform buffer to fill in.
     * @param scene defines the scene the material belongs to.
     * @param engine defines the engine the material belongs to.
     * @param subMesh the submesh to bind data for
     */ hardBindForSubMesh(uniformBuffer, scene, engine, subMesh) {
        if (!this._isRefractionEnabled && !this._isTranslucencyEnabled && !this._isScatteringEnabled) return;
        subMesh.getRenderingMesh().getWorldMatrix().decompose((0, $ha1VO.TmpVectors).Vector3[0]);
        const thicknessScale = Math.max(Math.abs((0, $ha1VO.TmpVectors).Vector3[0].x), Math.abs((0, $ha1VO.TmpVectors).Vector3[0].y), Math.abs((0, $ha1VO.TmpVectors).Vector3[0].z));
        uniformBuffer.updateFloat2("vThicknessParam", this.minimumThickness * thicknessScale, (this.maximumThickness - this.minimumThickness) * thicknessScale);
    }
    bindForSubMesh(uniformBuffer, scene, engine, subMesh) {
        if (!this._isRefractionEnabled && !this._isTranslucencyEnabled && !this._isScatteringEnabled) return;
        const defines = subMesh.materialDefines;
        const isFrozen = this._material.isFrozen;
        const realTimeFiltering = this._material.realTimeFiltering;
        const lodBasedMicrosurface = defines.LODBASEDMICROSFURACE;
        const refractionTexture = this._getRefractionTexture(scene);
        if (!uniformBuffer.useUbo || !isFrozen || !uniformBuffer.isSync) {
            if (this._thicknessTexture && (0, $2hKx5.MaterialFlags).ThicknessTextureEnabled) {
                uniformBuffer.updateFloat2("vThicknessInfos", this._thicknessTexture.coordinatesIndex, this._thicknessTexture.level);
                (0, $alPCh.BindTextureMatrix)(this._thicknessTexture, uniformBuffer, "thickness");
            }
            if (this._refractionIntensityTexture && (0, $2hKx5.MaterialFlags).RefractionIntensityTextureEnabled && defines.SS_REFRACTIONINTENSITY_TEXTURE) {
                uniformBuffer.updateFloat2("vRefractionIntensityInfos", this._refractionIntensityTexture.coordinatesIndex, this._refractionIntensityTexture.level);
                (0, $alPCh.BindTextureMatrix)(this._refractionIntensityTexture, uniformBuffer, "refractionIntensity");
            }
            if (this._translucencyIntensityTexture && (0, $2hKx5.MaterialFlags).TranslucencyIntensityTextureEnabled && defines.SS_TRANSLUCENCYINTENSITY_TEXTURE) {
                uniformBuffer.updateFloat2("vTranslucencyIntensityInfos", this._translucencyIntensityTexture.coordinatesIndex, this._translucencyIntensityTexture.level);
                (0, $alPCh.BindTextureMatrix)(this._translucencyIntensityTexture, uniformBuffer, "translucencyIntensity");
            }
            if (refractionTexture && (0, $2hKx5.MaterialFlags).RefractionTextureEnabled) {
                uniformBuffer.updateMatrix("refractionMatrix", refractionTexture.getRefractionTextureMatrix());
                let depth = 1.0;
                if (!refractionTexture.isCube) {
                    if (refractionTexture.depth) depth = refractionTexture.depth;
                }
                const width = refractionTexture.getSize().width;
                const refractionIor = this.volumeIndexOfRefraction;
                uniformBuffer.updateFloat4("vRefractionInfos", refractionTexture.level, 1 / refractionIor, depth, this._invertRefractionY ? -1 : 1);
                uniformBuffer.updateFloat4("vRefractionMicrosurfaceInfos", width, refractionTexture.lodGenerationScale, refractionTexture.lodGenerationOffset, 1.0 / this.indexOfRefraction);
                if (realTimeFiltering) uniformBuffer.updateFloat2("vRefractionFilteringInfo", width, (0, $1VEEL.Scalar).Log2(width));
                if (refractionTexture.boundingBoxSize) {
                    const cubeTexture = refractionTexture;
                    uniformBuffer.updateVector3("vRefractionPosition", cubeTexture.boundingBoxPosition);
                    uniformBuffer.updateVector3("vRefractionSize", cubeTexture.boundingBoxSize);
                }
            }
            if (this._isScatteringEnabled) uniformBuffer.updateFloat("scatteringDiffusionProfile", this._scatteringDiffusionProfileIndex);
            uniformBuffer.updateColor3("vDiffusionDistance", this.diffusionDistance);
            uniformBuffer.updateFloat4("vTintColor", this.tintColor.r, this.tintColor.g, this.tintColor.b, Math.max(0.00001, this.tintColorAtDistance));
            uniformBuffer.updateFloat3("vSubSurfaceIntensity", this.refractionIntensity, this.translucencyIntensity, 0);
            uniformBuffer.updateFloat("dispersion", this.dispersion);
        }
        // Textures
        if (scene.texturesEnabled) {
            if (this._thicknessTexture && (0, $2hKx5.MaterialFlags).ThicknessTextureEnabled) uniformBuffer.setTexture("thicknessSampler", this._thicknessTexture);
            if (this._refractionIntensityTexture && (0, $2hKx5.MaterialFlags).RefractionIntensityTextureEnabled && defines.SS_REFRACTIONINTENSITY_TEXTURE) uniformBuffer.setTexture("refractionIntensitySampler", this._refractionIntensityTexture);
            if (this._translucencyIntensityTexture && (0, $2hKx5.MaterialFlags).TranslucencyIntensityTextureEnabled && defines.SS_TRANSLUCENCYINTENSITY_TEXTURE) uniformBuffer.setTexture("translucencyIntensitySampler", this._translucencyIntensityTexture);
            if (refractionTexture && (0, $2hKx5.MaterialFlags).RefractionTextureEnabled) {
                if (lodBasedMicrosurface) uniformBuffer.setTexture("refractionSampler", refractionTexture);
                else {
                    uniformBuffer.setTexture("refractionSampler", refractionTexture._lodTextureMid || refractionTexture);
                    uniformBuffer.setTexture("refractionSamplerLow", refractionTexture._lodTextureLow || refractionTexture);
                    uniformBuffer.setTexture("refractionSamplerHigh", refractionTexture._lodTextureHigh || refractionTexture);
                }
            }
        }
    }
    /**
     * Returns the texture used for refraction or null if none is used.
     * @param scene defines the scene the material belongs to.
     * @returns - Refraction texture if present.  If no refraction texture and refraction
     * is linked with transparency, returns environment texture.  Otherwise, returns null.
     */ _getRefractionTexture(scene) {
        if (this._refractionTexture) return this._refractionTexture;
        if (this._isRefractionEnabled) return scene.environmentTexture;
        return null;
    }
    /**
     * Returns true if alpha blending should be disabled.
     */ get disableAlphaBlending() {
        return this._isRefractionEnabled && this._linkRefractionWithTransparency;
    }
    /**
     * Fills the list of render target textures.
     * @param renderTargets the list of render targets to update
     */ fillRenderTargetTextures(renderTargets) {
        if ((0, $2hKx5.MaterialFlags).RefractionTextureEnabled && this._refractionTexture && this._refractionTexture.isRenderTarget) renderTargets.push(this._refractionTexture);
    }
    hasTexture(texture) {
        if (this._thicknessTexture === texture) return true;
        if (this._refractionTexture === texture) return true;
        if (this._refractionIntensityTexture === texture) return true;
        if (this._translucencyIntensityTexture === texture) return true;
        return false;
    }
    hasRenderTargetTextures() {
        if ((0, $2hKx5.MaterialFlags).RefractionTextureEnabled && this._refractionTexture && this._refractionTexture.isRenderTarget) return true;
        return false;
    }
    getActiveTextures(activeTextures) {
        if (this._thicknessTexture) activeTextures.push(this._thicknessTexture);
        if (this._refractionTexture) activeTextures.push(this._refractionTexture);
    }
    getAnimatables(animatables) {
        if (this._thicknessTexture && this._thicknessTexture.animations && this._thicknessTexture.animations.length > 0) animatables.push(this._thicknessTexture);
        if (this._refractionTexture && this._refractionTexture.animations && this._refractionTexture.animations.length > 0) animatables.push(this._refractionTexture);
    }
    dispose(forceDisposeTextures) {
        if (forceDisposeTextures) {
            if (this._thicknessTexture) this._thicknessTexture.dispose();
            if (this._refractionTexture) this._refractionTexture.dispose();
        }
    }
    getClassName() {
        return "PBRSubSurfaceConfiguration";
    }
    addFallbacks(defines, fallbacks, currentRank) {
        if (defines.SS_SCATTERING) fallbacks.addFallback(currentRank++, "SS_SCATTERING");
        if (defines.SS_TRANSLUCENCY) fallbacks.addFallback(currentRank++, "SS_TRANSLUCENCY");
        return currentRank;
    }
    getSamplers(samplers) {
        samplers.push("thicknessSampler", "refractionIntensitySampler", "translucencyIntensitySampler", "refractionSampler", "refractionSamplerLow", "refractionSamplerHigh");
    }
    getUniforms() {
        return {
            ubo: [
                {
                    name: "vRefractionMicrosurfaceInfos",
                    size: 4,
                    type: "vec4"
                },
                {
                    name: "vRefractionFilteringInfo",
                    size: 2,
                    type: "vec2"
                },
                {
                    name: "vTranslucencyIntensityInfos",
                    size: 2,
                    type: "vec2"
                },
                {
                    name: "vRefractionInfos",
                    size: 4,
                    type: "vec4"
                },
                {
                    name: "refractionMatrix",
                    size: 16,
                    type: "mat4"
                },
                {
                    name: "vThicknessInfos",
                    size: 2,
                    type: "vec2"
                },
                {
                    name: "vRefractionIntensityInfos",
                    size: 2,
                    type: "vec2"
                },
                {
                    name: "thicknessMatrix",
                    size: 16,
                    type: "mat4"
                },
                {
                    name: "refractionIntensityMatrix",
                    size: 16,
                    type: "mat4"
                },
                {
                    name: "translucencyIntensityMatrix",
                    size: 16,
                    type: "mat4"
                },
                {
                    name: "vThicknessParam",
                    size: 2,
                    type: "vec2"
                },
                {
                    name: "vDiffusionDistance",
                    size: 3,
                    type: "vec3"
                },
                {
                    name: "vTintColor",
                    size: 4,
                    type: "vec4"
                },
                {
                    name: "vSubSurfaceIntensity",
                    size: 3,
                    type: "vec3"
                },
                {
                    name: "vRefractionPosition",
                    size: 3,
                    type: "vec3"
                },
                {
                    name: "vRefractionSize",
                    size: 3,
                    type: "vec3"
                },
                {
                    name: "scatteringDiffusionProfile",
                    size: 1,
                    type: "float"
                },
                {
                    name: "dispersion",
                    size: 1,
                    type: "float"
                }
            ]
        };
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $438241f205d9c5c7$export$963b3563d9af0310.prototype, "isRefractionEnabled", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $438241f205d9c5c7$export$963b3563d9af0310.prototype, "isTranslucencyEnabled", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $438241f205d9c5c7$export$963b3563d9af0310.prototype, "isDispersionEnabled", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markScenePrePassDirty")
], $438241f205d9c5c7$export$963b3563d9af0310.prototype, "isScatteringEnabled", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $438241f205d9c5c7$export$963b3563d9af0310.prototype, "_scatteringDiffusionProfileIndex", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $438241f205d9c5c7$export$963b3563d9af0310.prototype, "refractionIntensity", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $438241f205d9c5c7$export$963b3563d9af0310.prototype, "translucencyIntensity", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $438241f205d9c5c7$export$963b3563d9af0310.prototype, "useAlbedoToTintRefraction", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $438241f205d9c5c7$export$963b3563d9af0310.prototype, "useAlbedoToTintTranslucency", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $438241f205d9c5c7$export$963b3563d9af0310.prototype, "thicknessTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $438241f205d9c5c7$export$963b3563d9af0310.prototype, "refractionTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $438241f205d9c5c7$export$963b3563d9af0310.prototype, "indexOfRefraction", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $438241f205d9c5c7$export$963b3563d9af0310.prototype, "_volumeIndexOfRefraction", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $438241f205d9c5c7$export$963b3563d9af0310.prototype, "volumeIndexOfRefraction", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $438241f205d9c5c7$export$963b3563d9af0310.prototype, "invertRefractionY", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $438241f205d9c5c7$export$963b3563d9af0310.prototype, "linkRefractionWithTransparency", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $438241f205d9c5c7$export$963b3563d9af0310.prototype, "minimumThickness", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $438241f205d9c5c7$export$963b3563d9af0310.prototype, "maximumThickness", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $438241f205d9c5c7$export$963b3563d9af0310.prototype, "useThicknessAsDepth", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor3)()
], $438241f205d9c5c7$export$963b3563d9af0310.prototype, "tintColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $438241f205d9c5c7$export$963b3563d9af0310.prototype, "tintColorAtDistance", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $438241f205d9c5c7$export$963b3563d9af0310.prototype, "dispersion", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor3)()
], $438241f205d9c5c7$export$963b3563d9af0310.prototype, "diffusionDistance", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $438241f205d9c5c7$export$963b3563d9af0310.prototype, "useMaskFromThicknessTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $438241f205d9c5c7$export$963b3563d9af0310.prototype, "refractionIntensityTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $438241f205d9c5c7$export$963b3563d9af0310.prototype, "translucencyIntensityTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $438241f205d9c5c7$export$963b3563d9af0310.prototype, "useGltfStyleTextures", void 0);

});



parcelRegister("hdvNa", function(module, exports) {

$parcel$export(module.exports, "_DDSTextureLoader", () => $c88c4fd28429cb25$export$75e35d05397f507b);

var $f3g09 = parcelRequire("f3g09");

var $5YkyR = parcelRequire("5YkyR");

var $ckies = parcelRequire("ckies");
class $c88c4fd28429cb25$export$75e35d05397f507b {
    constructor(){
        /**
         * Defines whether the loader supports cascade loading the different faces.
         */ this.supportCascades = true;
    }
    /**
     * This returns if the loader support the current file information.
     * @param extension defines the file extension of the file being loaded
     * @returns true if the loader can load the specified file
     */ canLoad(extension) {
        return extension.endsWith(".dds");
    }
    /**
     * Uploads the cube texture data to the WebGL texture. It has already been bound.
     * @param imgs contains the cube maps
     * @param texture defines the BabylonJS internal texture
     * @param createPolynomials will be true if polynomials have been requested
     * @param onLoad defines the callback to trigger once the texture is ready
     */ loadCubeData(imgs, texture, createPolynomials, onLoad) {
        const engine = texture.getEngine();
        let info;
        let loadMipmap = false;
        let maxLevel = 1000;
        if (Array.isArray(imgs)) for(let index = 0; index < imgs.length; index++){
            const data = imgs[index];
            info = (0, $ckies.DDSTools).GetDDSInfo(data);
            texture.width = info.width;
            texture.height = info.height;
            loadMipmap = (info.isRGB || info.isLuminance || info.mipmapCount > 1) && texture.generateMipMaps;
            engine._unpackFlipY(info.isCompressed);
            (0, $ckies.DDSTools).UploadDDSLevels(engine, texture, data, info, loadMipmap, 6, -1, index);
            if (!info.isFourCC && info.mipmapCount === 1) engine.generateMipMapsForCubemap(texture);
            else maxLevel = info.mipmapCount - 1;
        }
        else {
            const data = imgs;
            info = (0, $ckies.DDSTools).GetDDSInfo(data);
            texture.width = info.width;
            texture.height = info.height;
            if (createPolynomials) info.sphericalPolynomial = new (0, $f3g09.SphericalPolynomial)();
            loadMipmap = (info.isRGB || info.isLuminance || info.mipmapCount > 1) && texture.generateMipMaps;
            engine._unpackFlipY(info.isCompressed);
            (0, $ckies.DDSTools).UploadDDSLevels(engine, texture, data, info, loadMipmap, 6);
            if (!info.isFourCC && info.mipmapCount === 1) // Do not unbind as we still need to set the parameters.
            engine.generateMipMapsForCubemap(texture, false);
            else maxLevel = info.mipmapCount - 1;
        }
        engine._setCubeMapTextureParams(texture, loadMipmap, maxLevel);
        texture.isReady = true;
        texture.onLoadedObservable.notifyObservers(texture);
        texture.onLoadedObservable.clear();
        if (onLoad) onLoad({
            isDDS: true,
            width: texture.width,
            info: info,
            data: imgs,
            texture: texture
        });
    }
    /**
     * Uploads the 2D texture data to the WebGL texture. It has already been bound once in the callback.
     * @param data contains the texture data
     * @param texture defines the BabylonJS internal texture
     * @param callback defines the method to call once ready to upload
     */ loadData(data, texture, callback) {
        const info = (0, $ckies.DDSTools).GetDDSInfo(data);
        const loadMipmap = (info.isRGB || info.isLuminance || info.mipmapCount > 1) && texture.generateMipMaps && info.width >> info.mipmapCount - 1 === 1;
        callback(info.width, info.height, loadMipmap, info.isFourCC, ()=>{
            (0, $ckies.DDSTools).UploadDDSLevels(texture.getEngine(), texture, data, info, loadMipmap, 1);
        });
    }
}
// Register the loader.
(0, $5YkyR.Engine)._TextureLoaders.push(new $c88c4fd28429cb25$export$75e35d05397f507b());

});
parcelRegister("ckies", function(module, exports) {

$parcel$export(module.exports, "DDSTools", () => $8f957ed7ca1c8179$export$573742ddcd7f96c8);
/* eslint-disable @typescript-eslint/naming-convention */ 
var $1VEEL = parcelRequire("1VEEL");

var $f3g09 = parcelRequire("f3g09");

var $b9e4a = parcelRequire("b9e4a");

var $kVtWi = parcelRequire("kVtWi");

var $4p0qs = parcelRequire("4p0qs");

var $akOl3 = parcelRequire("akOl3");

var $2h5JR = parcelRequire("2h5JR");

var $3a58A = parcelRequire("3a58A");
parcelRequire("5jUKR");
// Based on demo done by Brandon Jones - http://media.tojicode.com/webgl-samples/dds.html
// All values and structures referenced from:
// http://msdn.microsoft.com/en-us/library/bb943991.aspx/
const $8f957ed7ca1c8179$var$DDS_MAGIC = 0x20534444;
const //DDSD_HEIGHT = 0x2,
//DDSD_WIDTH = 0x4,
//DDSD_PITCH = 0x8,
//DDSD_PIXELFORMAT = 0x1000,
$8f957ed7ca1c8179$var$DDSD_MIPMAPCOUNT = 0x20000;
//DDSD_LINEARSIZE = 0x80000,
//DDSD_DEPTH = 0x800000;
// var DDSCAPS_COMPLEX = 0x8,
//     DDSCAPS_MIPMAP = 0x400000,
//     DDSCAPS_TEXTURE = 0x1000;
const $8f957ed7ca1c8179$var$DDSCAPS2_CUBEMAP = 0x200;
// DDSCAPS2_CUBEMAP_POSITIVEX = 0x400,
// DDSCAPS2_CUBEMAP_NEGATIVEX = 0x800,
// DDSCAPS2_CUBEMAP_POSITIVEY = 0x1000,
// DDSCAPS2_CUBEMAP_NEGATIVEY = 0x2000,
// DDSCAPS2_CUBEMAP_POSITIVEZ = 0x4000,
// DDSCAPS2_CUBEMAP_NEGATIVEZ = 0x8000,
// DDSCAPS2_VOLUME = 0x200000;
const //DDPF_ALPHA = 0x2,
$8f957ed7ca1c8179$var$DDPF_FOURCC = 0x4, $8f957ed7ca1c8179$var$DDPF_RGB = 0x40, //DDPF_YUV = 0x200,
$8f957ed7ca1c8179$var$DDPF_LUMINANCE = 0x20000;
function $8f957ed7ca1c8179$var$FourCCToInt32(value) {
    return value.charCodeAt(0) + (value.charCodeAt(1) << 8) + (value.charCodeAt(2) << 16) + (value.charCodeAt(3) << 24);
}
function $8f957ed7ca1c8179$var$Int32ToFourCC(value) {
    return String.fromCharCode(value & 0xff, value >> 8 & 0xff, value >> 16 & 0xff, value >> 24 & 0xff);
}
const $8f957ed7ca1c8179$var$FOURCC_DXT1 = $8f957ed7ca1c8179$var$FourCCToInt32("DXT1");
const $8f957ed7ca1c8179$var$FOURCC_DXT3 = $8f957ed7ca1c8179$var$FourCCToInt32("DXT3");
const $8f957ed7ca1c8179$var$FOURCC_DXT5 = $8f957ed7ca1c8179$var$FourCCToInt32("DXT5");
const $8f957ed7ca1c8179$var$FOURCC_DX10 = $8f957ed7ca1c8179$var$FourCCToInt32("DX10");
const $8f957ed7ca1c8179$var$FOURCC_D3DFMT_R16G16B16A16F = 113;
const $8f957ed7ca1c8179$var$FOURCC_D3DFMT_R32G32B32A32F = 116;
const $8f957ed7ca1c8179$var$DXGI_FORMAT_R32G32B32A32_FLOAT = 2;
const $8f957ed7ca1c8179$var$DXGI_FORMAT_R16G16B16A16_FLOAT = 10;
const $8f957ed7ca1c8179$var$DXGI_FORMAT_B8G8R8X8_UNORM = 88;
const $8f957ed7ca1c8179$var$headerLengthInt = 31; // The header length in 32 bit ints
// Offsets into the header array
const $8f957ed7ca1c8179$var$off_magic = 0;
const $8f957ed7ca1c8179$var$off_size = 1;
const $8f957ed7ca1c8179$var$off_flags = 2;
const $8f957ed7ca1c8179$var$off_height = 3;
const $8f957ed7ca1c8179$var$off_width = 4;
const $8f957ed7ca1c8179$var$off_mipmapCount = 7;
const $8f957ed7ca1c8179$var$off_pfFlags = 20;
const $8f957ed7ca1c8179$var$off_pfFourCC = 21;
const $8f957ed7ca1c8179$var$off_RGBbpp = 22;
const $8f957ed7ca1c8179$var$off_RMask = 23;
const $8f957ed7ca1c8179$var$off_GMask = 24;
const $8f957ed7ca1c8179$var$off_BMask = 25;
const $8f957ed7ca1c8179$var$off_AMask = 26;
// var off_caps1 = 27;
const $8f957ed7ca1c8179$var$off_caps2 = 28;
// var off_caps3 = 29;
// var off_caps4 = 30;
const $8f957ed7ca1c8179$var$off_dxgiFormat = 32;
class $8f957ed7ca1c8179$export$573742ddcd7f96c8 {
    /**
     * Gets DDS information from an array buffer
     * @param data defines the array buffer view to read data from
     * @returns the DDS information
     */ static GetDDSInfo(data) {
        const header = new Int32Array(data.buffer, data.byteOffset, $8f957ed7ca1c8179$var$headerLengthInt);
        const extendedHeader = new Int32Array(data.buffer, data.byteOffset, $8f957ed7ca1c8179$var$headerLengthInt + 4);
        let mipmapCount = 1;
        if (header[$8f957ed7ca1c8179$var$off_flags] & $8f957ed7ca1c8179$var$DDSD_MIPMAPCOUNT) mipmapCount = Math.max(1, header[$8f957ed7ca1c8179$var$off_mipmapCount]);
        const fourCC = header[$8f957ed7ca1c8179$var$off_pfFourCC];
        const dxgiFormat = fourCC === $8f957ed7ca1c8179$var$FOURCC_DX10 ? extendedHeader[$8f957ed7ca1c8179$var$off_dxgiFormat] : 0;
        let textureType = 0;
        switch(fourCC){
            case $8f957ed7ca1c8179$var$FOURCC_D3DFMT_R16G16B16A16F:
                textureType = 2;
                break;
            case $8f957ed7ca1c8179$var$FOURCC_D3DFMT_R32G32B32A32F:
                textureType = 1;
                break;
            case $8f957ed7ca1c8179$var$FOURCC_DX10:
                if (dxgiFormat === $8f957ed7ca1c8179$var$DXGI_FORMAT_R16G16B16A16_FLOAT) {
                    textureType = 2;
                    break;
                }
                if (dxgiFormat === $8f957ed7ca1c8179$var$DXGI_FORMAT_R32G32B32A32_FLOAT) {
                    textureType = 1;
                    break;
                }
        }
        return {
            width: header[$8f957ed7ca1c8179$var$off_width],
            height: header[$8f957ed7ca1c8179$var$off_height],
            mipmapCount: mipmapCount,
            isFourCC: (header[$8f957ed7ca1c8179$var$off_pfFlags] & $8f957ed7ca1c8179$var$DDPF_FOURCC) === $8f957ed7ca1c8179$var$DDPF_FOURCC,
            isRGB: (header[$8f957ed7ca1c8179$var$off_pfFlags] & $8f957ed7ca1c8179$var$DDPF_RGB) === $8f957ed7ca1c8179$var$DDPF_RGB,
            isLuminance: (header[$8f957ed7ca1c8179$var$off_pfFlags] & $8f957ed7ca1c8179$var$DDPF_LUMINANCE) === $8f957ed7ca1c8179$var$DDPF_LUMINANCE,
            isCube: (header[$8f957ed7ca1c8179$var$off_caps2] & $8f957ed7ca1c8179$var$DDSCAPS2_CUBEMAP) === $8f957ed7ca1c8179$var$DDSCAPS2_CUBEMAP,
            isCompressed: fourCC === $8f957ed7ca1c8179$var$FOURCC_DXT1 || fourCC === $8f957ed7ca1c8179$var$FOURCC_DXT3 || fourCC === $8f957ed7ca1c8179$var$FOURCC_DXT5,
            dxgiFormat: dxgiFormat,
            textureType: textureType
        };
    }
    static _GetHalfFloatAsFloatRGBAArrayBuffer(width, height, dataOffset, dataLength, arrayBuffer, lod) {
        const destArray = new Float32Array(dataLength);
        const srcData = new Uint16Array(arrayBuffer, dataOffset);
        let index = 0;
        for(let y = 0; y < height; y++)for(let x = 0; x < width; x++){
            const srcPos = (x + y * width) * 4;
            destArray[index] = (0, $3a58A.FromHalfFloat)(srcData[srcPos]);
            destArray[index + 1] = (0, $3a58A.FromHalfFloat)(srcData[srcPos + 1]);
            destArray[index + 2] = (0, $3a58A.FromHalfFloat)(srcData[srcPos + 2]);
            if ($8f957ed7ca1c8179$export$573742ddcd7f96c8.StoreLODInAlphaChannel) destArray[index + 3] = lod;
            else destArray[index + 3] = (0, $3a58A.FromHalfFloat)(srcData[srcPos + 3]);
            index += 4;
        }
        return destArray;
    }
    static _GetHalfFloatRGBAArrayBuffer(width, height, dataOffset, dataLength, arrayBuffer, lod) {
        if ($8f957ed7ca1c8179$export$573742ddcd7f96c8.StoreLODInAlphaChannel) {
            const destArray = new Uint16Array(dataLength);
            const srcData = new Uint16Array(arrayBuffer, dataOffset);
            let index = 0;
            for(let y = 0; y < height; y++)for(let x = 0; x < width; x++){
                const srcPos = (x + y * width) * 4;
                destArray[index] = srcData[srcPos];
                destArray[index + 1] = srcData[srcPos + 1];
                destArray[index + 2] = srcData[srcPos + 2];
                destArray[index + 3] = (0, $3a58A.ToHalfFloat)(lod);
                index += 4;
            }
            return destArray;
        }
        return new Uint16Array(arrayBuffer, dataOffset, dataLength);
    }
    static _GetFloatRGBAArrayBuffer(width, height, dataOffset, dataLength, arrayBuffer, lod) {
        if ($8f957ed7ca1c8179$export$573742ddcd7f96c8.StoreLODInAlphaChannel) {
            const destArray = new Float32Array(dataLength);
            const srcData = new Float32Array(arrayBuffer, dataOffset);
            let index = 0;
            for(let y = 0; y < height; y++)for(let x = 0; x < width; x++){
                const srcPos = (x + y * width) * 4;
                destArray[index] = srcData[srcPos];
                destArray[index + 1] = srcData[srcPos + 1];
                destArray[index + 2] = srcData[srcPos + 2];
                destArray[index + 3] = lod;
                index += 4;
            }
            return destArray;
        }
        return new Float32Array(arrayBuffer, dataOffset, dataLength);
    }
    static _GetFloatAsHalfFloatRGBAArrayBuffer(width, height, dataOffset, dataLength, arrayBuffer, lod) {
        const destArray = new Uint16Array(dataLength);
        const srcData = new Float32Array(arrayBuffer, dataOffset);
        let index = 0;
        for(let y = 0; y < height; y++)for(let x = 0; x < width; x++){
            destArray[index] = (0, $3a58A.ToHalfFloat)(srcData[index]);
            destArray[index + 1] = (0, $3a58A.ToHalfFloat)(srcData[index + 1]);
            destArray[index + 2] = (0, $3a58A.ToHalfFloat)(srcData[index + 2]);
            if ($8f957ed7ca1c8179$export$573742ddcd7f96c8.StoreLODInAlphaChannel) destArray[index + 3] = (0, $3a58A.ToHalfFloat)(lod);
            else destArray[index + 3] = (0, $3a58A.ToHalfFloat)(srcData[index + 3]);
            index += 4;
        }
        return destArray;
    }
    static _GetFloatAsUIntRGBAArrayBuffer(width, height, dataOffset, dataLength, arrayBuffer, lod) {
        const destArray = new Uint8Array(dataLength);
        const srcData = new Float32Array(arrayBuffer, dataOffset);
        let index = 0;
        for(let y = 0; y < height; y++)for(let x = 0; x < width; x++){
            const srcPos = (x + y * width) * 4;
            destArray[index] = (0, $1VEEL.Scalar).Clamp(srcData[srcPos]) * 255;
            destArray[index + 1] = (0, $1VEEL.Scalar).Clamp(srcData[srcPos + 1]) * 255;
            destArray[index + 2] = (0, $1VEEL.Scalar).Clamp(srcData[srcPos + 2]) * 255;
            if ($8f957ed7ca1c8179$export$573742ddcd7f96c8.StoreLODInAlphaChannel) destArray[index + 3] = lod;
            else destArray[index + 3] = (0, $1VEEL.Scalar).Clamp(srcData[srcPos + 3]) * 255;
            index += 4;
        }
        return destArray;
    }
    static _GetHalfFloatAsUIntRGBAArrayBuffer(width, height, dataOffset, dataLength, arrayBuffer, lod) {
        const destArray = new Uint8Array(dataLength);
        const srcData = new Uint16Array(arrayBuffer, dataOffset);
        let index = 0;
        for(let y = 0; y < height; y++)for(let x = 0; x < width; x++){
            const srcPos = (x + y * width) * 4;
            destArray[index] = (0, $1VEEL.Scalar).Clamp((0, $3a58A.FromHalfFloat)(srcData[srcPos])) * 255;
            destArray[index + 1] = (0, $1VEEL.Scalar).Clamp((0, $3a58A.FromHalfFloat)(srcData[srcPos + 1])) * 255;
            destArray[index + 2] = (0, $1VEEL.Scalar).Clamp((0, $3a58A.FromHalfFloat)(srcData[srcPos + 2])) * 255;
            if ($8f957ed7ca1c8179$export$573742ddcd7f96c8.StoreLODInAlphaChannel) destArray[index + 3] = lod;
            else destArray[index + 3] = (0, $1VEEL.Scalar).Clamp((0, $3a58A.FromHalfFloat)(srcData[srcPos + 3])) * 255;
            index += 4;
        }
        return destArray;
    }
    static _GetRGBAArrayBuffer(width, height, dataOffset, dataLength, arrayBuffer, rOffset, gOffset, bOffset, aOffset) {
        const byteArray = new Uint8Array(dataLength);
        const srcData = new Uint8Array(arrayBuffer, dataOffset);
        let index = 0;
        for(let y = 0; y < height; y++)for(let x = 0; x < width; x++){
            const srcPos = (x + y * width) * 4;
            byteArray[index] = srcData[srcPos + rOffset];
            byteArray[index + 1] = srcData[srcPos + gOffset];
            byteArray[index + 2] = srcData[srcPos + bOffset];
            byteArray[index + 3] = srcData[srcPos + aOffset];
            index += 4;
        }
        return byteArray;
    }
    static _ExtractLongWordOrder(value) {
        if (value === 0 || value === 255 || value === -16777216) return 0;
        return 1 + $8f957ed7ca1c8179$export$573742ddcd7f96c8._ExtractLongWordOrder(value >> 8);
    }
    static _GetRGBArrayBuffer(width, height, dataOffset, dataLength, arrayBuffer, rOffset, gOffset, bOffset) {
        const byteArray = new Uint8Array(dataLength);
        const srcData = new Uint8Array(arrayBuffer, dataOffset);
        let index = 0;
        for(let y = 0; y < height; y++)for(let x = 0; x < width; x++){
            const srcPos = (x + y * width) * 3;
            byteArray[index] = srcData[srcPos + rOffset];
            byteArray[index + 1] = srcData[srcPos + gOffset];
            byteArray[index + 2] = srcData[srcPos + bOffset];
            index += 3;
        }
        return byteArray;
    }
    static _GetLuminanceArrayBuffer(width, height, dataOffset, dataLength, arrayBuffer) {
        const byteArray = new Uint8Array(dataLength);
        const srcData = new Uint8Array(arrayBuffer, dataOffset);
        let index = 0;
        for(let y = 0; y < height; y++)for(let x = 0; x < width; x++){
            const srcPos = x + y * width;
            byteArray[index] = srcData[srcPos];
            index++;
        }
        return byteArray;
    }
    /**
     * Uploads DDS Levels to a Babylon Texture
     * @internal
     */ static UploadDDSLevels(engine, texture, data, info, loadMipmaps, faces, lodIndex = -1, currentFace, destTypeMustBeFilterable = true) {
        let sphericalPolynomialFaces = null;
        if (info.sphericalPolynomial) sphericalPolynomialFaces = [];
        const ext = !!engine.getCaps().s3tc;
        // TODO WEBGPU Once generateMipMaps is split into generateMipMaps + hasMipMaps in InternalTexture this line can be removed
        texture.generateMipMaps = loadMipmaps;
        const header = new Int32Array(data.buffer, data.byteOffset, $8f957ed7ca1c8179$var$headerLengthInt);
        let fourCC, width, height, dataLength = 0, dataOffset;
        let byteArray, mipmapCount, mip;
        let internalCompressedFormat = 0;
        let blockBytes = 1;
        if (header[$8f957ed7ca1c8179$var$off_magic] !== $8f957ed7ca1c8179$var$DDS_MAGIC) {
            (0, $kVtWi.Logger).Error("Invalid magic number in DDS header");
            return;
        }
        if (!info.isFourCC && !info.isRGB && !info.isLuminance) {
            (0, $kVtWi.Logger).Error("Unsupported format, must contain a FourCC, RGB or LUMINANCE code");
            return;
        }
        if (info.isCompressed && !ext) {
            (0, $kVtWi.Logger).Error("Compressed textures are not supported on this platform.");
            return;
        }
        let bpp = header[$8f957ed7ca1c8179$var$off_RGBbpp];
        dataOffset = header[$8f957ed7ca1c8179$var$off_size] + 4;
        let computeFormats = false;
        if (info.isFourCC) {
            fourCC = header[$8f957ed7ca1c8179$var$off_pfFourCC];
            switch(fourCC){
                case $8f957ed7ca1c8179$var$FOURCC_DXT1:
                    blockBytes = 8;
                    internalCompressedFormat = 33777;
                    break;
                case $8f957ed7ca1c8179$var$FOURCC_DXT3:
                    blockBytes = 16;
                    internalCompressedFormat = 33778;
                    break;
                case $8f957ed7ca1c8179$var$FOURCC_DXT5:
                    blockBytes = 16;
                    internalCompressedFormat = 33779;
                    break;
                case $8f957ed7ca1c8179$var$FOURCC_D3DFMT_R16G16B16A16F:
                    computeFormats = true;
                    bpp = 64;
                    break;
                case $8f957ed7ca1c8179$var$FOURCC_D3DFMT_R32G32B32A32F:
                    computeFormats = true;
                    bpp = 128;
                    break;
                case $8f957ed7ca1c8179$var$FOURCC_DX10:
                    {
                        // There is an additionnal header so dataOffset need to be changed
                        dataOffset += 20; // 5 uints
                        let supported = false;
                        switch(info.dxgiFormat){
                            case $8f957ed7ca1c8179$var$DXGI_FORMAT_R16G16B16A16_FLOAT:
                                computeFormats = true;
                                bpp = 64;
                                supported = true;
                                break;
                            case $8f957ed7ca1c8179$var$DXGI_FORMAT_R32G32B32A32_FLOAT:
                                computeFormats = true;
                                bpp = 128;
                                supported = true;
                                break;
                            case $8f957ed7ca1c8179$var$DXGI_FORMAT_B8G8R8X8_UNORM:
                                info.isRGB = true;
                                info.isFourCC = false;
                                bpp = 32;
                                supported = true;
                                break;
                        }
                        if (supported) break;
                    }
                // eslint-disable-next-line no-fallthrough
                default:
                    (0, $kVtWi.Logger).Error([
                        "Unsupported FourCC code:",
                        $8f957ed7ca1c8179$var$Int32ToFourCC(fourCC)
                    ]);
                    return;
            }
        }
        const rOffset = $8f957ed7ca1c8179$export$573742ddcd7f96c8._ExtractLongWordOrder(header[$8f957ed7ca1c8179$var$off_RMask]);
        const gOffset = $8f957ed7ca1c8179$export$573742ddcd7f96c8._ExtractLongWordOrder(header[$8f957ed7ca1c8179$var$off_GMask]);
        const bOffset = $8f957ed7ca1c8179$export$573742ddcd7f96c8._ExtractLongWordOrder(header[$8f957ed7ca1c8179$var$off_BMask]);
        const aOffset = $8f957ed7ca1c8179$export$573742ddcd7f96c8._ExtractLongWordOrder(header[$8f957ed7ca1c8179$var$off_AMask]);
        if (computeFormats) internalCompressedFormat = engine._getRGBABufferInternalSizedFormat(info.textureType);
        mipmapCount = 1;
        if (header[$8f957ed7ca1c8179$var$off_flags] & $8f957ed7ca1c8179$var$DDSD_MIPMAPCOUNT && loadMipmaps !== false) mipmapCount = Math.max(1, header[$8f957ed7ca1c8179$var$off_mipmapCount]);
        const startFace = currentFace || 0;
        const caps = engine.getCaps();
        for(let face = startFace; face < faces; face++){
            width = header[$8f957ed7ca1c8179$var$off_width];
            height = header[$8f957ed7ca1c8179$var$off_height];
            for(mip = 0; mip < mipmapCount; ++mip){
                if (lodIndex === -1 || lodIndex === mip) {
                    // In case of fixed LOD, if the lod has just been uploaded, early exit.
                    const i = lodIndex === -1 ? mip : 0;
                    if (!info.isCompressed && info.isFourCC) {
                        texture.format = 5;
                        dataLength = width * height * 4;
                        let floatArray = null;
                        if (engine._badOS || engine._badDesktopOS || !caps.textureHalfFloat && !caps.textureFloat) {
                            // Required because iOS has many issues with float and half float generation
                            if (bpp === 128) {
                                floatArray = $8f957ed7ca1c8179$export$573742ddcd7f96c8._GetFloatAsUIntRGBAArrayBuffer(width, height, data.byteOffset + dataOffset, dataLength, data.buffer, i);
                                if (sphericalPolynomialFaces && i == 0) sphericalPolynomialFaces.push($8f957ed7ca1c8179$export$573742ddcd7f96c8._GetFloatRGBAArrayBuffer(width, height, data.byteOffset + dataOffset, dataLength, data.buffer, i));
                            } else if (bpp === 64) {
                                floatArray = $8f957ed7ca1c8179$export$573742ddcd7f96c8._GetHalfFloatAsUIntRGBAArrayBuffer(width, height, data.byteOffset + dataOffset, dataLength, data.buffer, i);
                                if (sphericalPolynomialFaces && i == 0) sphericalPolynomialFaces.push($8f957ed7ca1c8179$export$573742ddcd7f96c8._GetHalfFloatAsFloatRGBAArrayBuffer(width, height, data.byteOffset + dataOffset, dataLength, data.buffer, i));
                            }
                            texture.type = 0;
                        } else {
                            const floatAvailable = caps.textureFloat && (destTypeMustBeFilterable && caps.textureFloatLinearFiltering || !destTypeMustBeFilterable);
                            const halfFloatAvailable = caps.textureHalfFloat && (destTypeMustBeFilterable && caps.textureHalfFloatLinearFiltering || !destTypeMustBeFilterable);
                            const destType = (bpp === 128 || bpp === 64 && !halfFloatAvailable) && floatAvailable ? 1 : (bpp === 64 || bpp === 128 && !floatAvailable) && halfFloatAvailable ? 2 : 0;
                            let dataGetter;
                            let dataGetterPolynomial = null;
                            switch(bpp){
                                case 128:
                                    switch(destType){
                                        case 1:
                                            dataGetter = $8f957ed7ca1c8179$export$573742ddcd7f96c8._GetFloatRGBAArrayBuffer;
                                            dataGetterPolynomial = null;
                                            break;
                                        case 2:
                                            dataGetter = $8f957ed7ca1c8179$export$573742ddcd7f96c8._GetFloatAsHalfFloatRGBAArrayBuffer;
                                            dataGetterPolynomial = $8f957ed7ca1c8179$export$573742ddcd7f96c8._GetFloatRGBAArrayBuffer;
                                            break;
                                        case 0:
                                            dataGetter = $8f957ed7ca1c8179$export$573742ddcd7f96c8._GetFloatAsUIntRGBAArrayBuffer;
                                            dataGetterPolynomial = $8f957ed7ca1c8179$export$573742ddcd7f96c8._GetFloatRGBAArrayBuffer;
                                            break;
                                    }
                                    break;
                                default:
                                    // 64 bpp
                                    switch(destType){
                                        case 1:
                                            dataGetter = $8f957ed7ca1c8179$export$573742ddcd7f96c8._GetHalfFloatAsFloatRGBAArrayBuffer;
                                            dataGetterPolynomial = null;
                                            break;
                                        case 2:
                                            dataGetter = $8f957ed7ca1c8179$export$573742ddcd7f96c8._GetHalfFloatRGBAArrayBuffer;
                                            dataGetterPolynomial = $8f957ed7ca1c8179$export$573742ddcd7f96c8._GetHalfFloatAsFloatRGBAArrayBuffer;
                                            break;
                                        case 0:
                                            dataGetter = $8f957ed7ca1c8179$export$573742ddcd7f96c8._GetHalfFloatAsUIntRGBAArrayBuffer;
                                            dataGetterPolynomial = $8f957ed7ca1c8179$export$573742ddcd7f96c8._GetHalfFloatAsFloatRGBAArrayBuffer;
                                            break;
                                    }
                                    break;
                            }
                            texture.type = destType;
                            floatArray = dataGetter(width, height, data.byteOffset + dataOffset, dataLength, data.buffer, i);
                            if (sphericalPolynomialFaces && i == 0) sphericalPolynomialFaces.push(dataGetterPolynomial ? dataGetterPolynomial(width, height, data.byteOffset + dataOffset, dataLength, data.buffer, i) : floatArray);
                        }
                        if (floatArray) engine._uploadDataToTextureDirectly(texture, floatArray, face, i);
                    } else if (info.isRGB) {
                        texture.type = 0;
                        if (bpp === 24) {
                            texture.format = 4;
                            dataLength = width * height * 3;
                            byteArray = $8f957ed7ca1c8179$export$573742ddcd7f96c8._GetRGBArrayBuffer(width, height, data.byteOffset + dataOffset, dataLength, data.buffer, rOffset, gOffset, bOffset);
                            engine._uploadDataToTextureDirectly(texture, byteArray, face, i);
                        } else {
                            // 32
                            texture.format = 5;
                            dataLength = width * height * 4;
                            byteArray = $8f957ed7ca1c8179$export$573742ddcd7f96c8._GetRGBAArrayBuffer(width, height, data.byteOffset + dataOffset, dataLength, data.buffer, rOffset, gOffset, bOffset, aOffset);
                            engine._uploadDataToTextureDirectly(texture, byteArray, face, i);
                        }
                    } else if (info.isLuminance) {
                        const unpackAlignment = engine._getUnpackAlignement();
                        const unpaddedRowSize = width;
                        const paddedRowSize = Math.floor((width + unpackAlignment - 1) / unpackAlignment) * unpackAlignment;
                        dataLength = paddedRowSize * (height - 1) + unpaddedRowSize;
                        byteArray = $8f957ed7ca1c8179$export$573742ddcd7f96c8._GetLuminanceArrayBuffer(width, height, data.byteOffset + dataOffset, dataLength, data.buffer);
                        texture.format = 1;
                        texture.type = 0;
                        engine._uploadDataToTextureDirectly(texture, byteArray, face, i);
                    } else {
                        dataLength = Math.max(4, width) / 4 * Math.max(4, height) / 4 * blockBytes;
                        byteArray = new Uint8Array(data.buffer, data.byteOffset + dataOffset, dataLength);
                        texture.type = 0;
                        engine._uploadCompressedDataToTextureDirectly(texture, internalCompressedFormat, width, height, byteArray, face, i);
                    }
                }
                dataOffset += bpp ? width * height * (bpp / 8) : dataLength;
                width *= 0.5;
                height *= 0.5;
                width = Math.max(1.0, width);
                height = Math.max(1.0, height);
            }
            if (currentFace !== undefined) break;
        }
        if (sphericalPolynomialFaces && sphericalPolynomialFaces.length > 0) info.sphericalPolynomial = (0, $4p0qs.CubeMapToSphericalPolynomialTools).ConvertCubeMapToSphericalPolynomial({
            size: header[$8f957ed7ca1c8179$var$off_width],
            right: sphericalPolynomialFaces[0],
            left: sphericalPolynomialFaces[1],
            up: sphericalPolynomialFaces[2],
            down: sphericalPolynomialFaces[3],
            front: sphericalPolynomialFaces[4],
            back: sphericalPolynomialFaces[5],
            format: 5,
            type: 1,
            gammaSpace: false
        });
        else info.sphericalPolynomial = undefined;
    }
}
/**
 * Gets or sets a boolean indicating that LOD info is stored in alpha channel (false by default)
 */ $8f957ed7ca1c8179$export$573742ddcd7f96c8.StoreLODInAlphaChannel = false;
/**
 * Create a cube texture from prefiltered data (ie. the mipmaps contain ready to use data for PBR reflection)
 * @param rootUrl defines the url where the file to load is located
 * @param scene defines the current scene
 * @param lodScale defines scale to apply to the mip map selection
 * @param lodOffset defines offset to apply to the mip map selection
 * @param onLoad defines an optional callback raised when the texture is loaded
 * @param onError defines an optional callback raised if there is an issue to load the texture
 * @param format defines the format of the data
 * @param forcedExtension defines the extension to use to pick the right loader
 * @param createPolynomials defines wheter or not to create polynomails harmonics for the texture
 * @returns the cube texture as an InternalTexture
 */ (0, $2h5JR.ThinEngine).prototype.createPrefilteredCubeTexture = function(rootUrl, scene, lodScale, lodOffset, onLoad = null, onError = null, format, forcedExtension = null, createPolynomials = true) {
    const callback = (loadData)=>{
        if (!loadData) {
            if (onLoad) onLoad(null);
            return;
        }
        const texture = loadData.texture;
        if (!createPolynomials) texture._sphericalPolynomial = new (0, $f3g09.SphericalPolynomial)();
        else if (loadData.info.sphericalPolynomial) texture._sphericalPolynomial = loadData.info.sphericalPolynomial;
        texture._source = (0, $b9e4a.InternalTextureSource).CubePrefiltered;
        if (this.getCaps().textureLOD) {
            // Do not add extra process if texture lod is supported.
            if (onLoad) onLoad(texture);
            return;
        }
        const mipSlices = 3;
        const gl = this._gl;
        const width = loadData.width;
        if (!width) return;
        const textures = [];
        for(let i = 0; i < mipSlices; i++){
            //compute LOD from even spacing in smoothness (matching shader calculation)
            const smoothness = i / (mipSlices - 1);
            const roughness = 1 - smoothness;
            const minLODIndex = lodOffset; // roughness = 0
            const maxLODIndex = (0, $1VEEL.Scalar).Log2(width) * lodScale + lodOffset; // roughness = 1
            const lodIndex = minLODIndex + (maxLODIndex - minLODIndex) * roughness;
            const mipmapIndex = Math.round(Math.min(Math.max(lodIndex, 0), maxLODIndex));
            const glTextureFromLod = new (0, $b9e4a.InternalTexture)(this, (0, $b9e4a.InternalTextureSource).Temp);
            glTextureFromLod.type = texture.type;
            glTextureFromLod.format = texture.format;
            glTextureFromLod.width = Math.pow(2, Math.max((0, $1VEEL.Scalar).Log2(width) - mipmapIndex, 0));
            glTextureFromLod.height = glTextureFromLod.width;
            glTextureFromLod.isCube = true;
            glTextureFromLod._cachedWrapU = 0;
            glTextureFromLod._cachedWrapV = 0;
            this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, glTextureFromLod, true);
            glTextureFromLod.samplingMode = 2;
            gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MAG_FILTER, gl.LINEAR);
            gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
            gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
            gl.texParameteri(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
            if (loadData.isDDS) {
                const info = loadData.info;
                const data = loadData.data;
                this._unpackFlipY(info.isCompressed);
                $8f957ed7ca1c8179$export$573742ddcd7f96c8.UploadDDSLevels(this, glTextureFromLod, data, info, true, 6, mipmapIndex);
            } else (0, $kVtWi.Logger).Warn("DDS is the only prefiltered cube map supported so far.");
            this._bindTextureDirectly(gl.TEXTURE_CUBE_MAP, null);
            // Wrap in a base texture for easy binding.
            const lodTexture = new (0, $akOl3.BaseTexture)(scene);
            lodTexture._isCube = true;
            lodTexture._texture = glTextureFromLod;
            glTextureFromLod.isReady = true;
            textures.push(lodTexture);
        }
        texture._lodTextureHigh = textures[2];
        texture._lodTextureMid = textures[1];
        texture._lodTextureLow = textures[0];
        if (onLoad) onLoad(texture);
    };
    return this.createCubeTexture(rootUrl, scene, null, false, callback, onError, format, forcedExtension, createPolynomials, lodScale, lodOffset);
};

});


parcelRegister("lkQQp", function(module, exports) {

$parcel$export(module.exports, "_ENVTextureLoader", () => $f884750220538d07$export$db3696f841ac8a69);

var $6XNeg = parcelRequire("6XNeg");

var $5YkyR = parcelRequire("5YkyR");
class $f884750220538d07$export$db3696f841ac8a69 {
    constructor(){
        /**
         * Defines whether the loader supports cascade loading the different faces.
         */ this.supportCascades = false;
    }
    /**
     * This returns if the loader support the current file information.
     * @param extension defines the file extension of the file being loaded
     * @returns true if the loader can load the specified file
     */ canLoad(extension) {
        return extension.endsWith(".env");
    }
    /**
     * Uploads the cube texture data to the WebGL texture. It has already been bound.
     * @param data contains the texture data
     * @param texture defines the BabylonJS internal texture
     * @param createPolynomials will be true if polynomials have been requested
     * @param onLoad defines the callback to trigger once the texture is ready
     * @param onError defines the callback to trigger in case of error
     */ loadCubeData(data, texture, createPolynomials, onLoad, onError) {
        if (Array.isArray(data)) return;
        const info = (0, $6XNeg.GetEnvInfo)(data);
        if (info) {
            texture.width = info.width;
            texture.height = info.width;
            try {
                (0, $6XNeg.UploadEnvSpherical)(texture, info);
                (0, $6XNeg.UploadEnvLevelsAsync)(texture, data, info).then(()=>{
                    texture.isReady = true;
                    texture.onLoadedObservable.notifyObservers(texture);
                    texture.onLoadedObservable.clear();
                    if (onLoad) onLoad();
                }, (reason)=>{
                    onError?.("Can not upload environment levels", reason);
                });
            } catch (e) {
                onError?.("Can not upload environment file", e);
            }
        } else if (onError) onError("Can not parse the environment file", null);
    }
    /**
     * Uploads the 2D texture data to the WebGL texture. It has already been bound once in the callback.
     */ loadData() {
        // eslint-disable-next-line no-throw-literal
        throw ".env not supported in 2d.";
    }
}
// Register the loader.
(0, $5YkyR.Engine)._TextureLoaders.push(new $f884750220538d07$export$db3696f841ac8a69());

});

parcelRegister("72wSy", function(module, exports) {

$parcel$export(module.exports, "_KTXTextureLoader", () => $520239600346da75$export$fb2ebe1d59cbbc46);

var $ibwgz = parcelRequire("ibwgz");

var $c2VJL = parcelRequire("c2VJL");

var $5YkyR = parcelRequire("5YkyR");

var $kVtWi = parcelRequire("kVtWi");
function $520239600346da75$var$mapSRGBToLinear(format) {
    switch(format){
        case 35916:
            return 33776;
        case 35918:
            return 33778;
        case 35919:
            return 33779;
        case 37493:
            return 37492;
        case 37497:
            return 37496;
        case 37495:
            return 37494;
        case 37840:
            return 37808;
        case 36493:
            return 36492;
    }
    return null;
}
class $520239600346da75$export$fb2ebe1d59cbbc46 {
    constructor(){
        /**
         * Defines whether the loader supports cascade loading the different faces.
         */ this.supportCascades = false;
    }
    /**
     * This returns if the loader support the current file information.
     * @param extension defines the file extension of the file being loaded
     * @param mimeType defines the optional mime type of the file being loaded
     * @returns true if the loader can load the specified file
     */ canLoad(extension, mimeType) {
        // The ".ktx2" file extension is still up for debate: https://github.com/KhronosGroup/KTX-Specification/issues/18
        return extension.endsWith(".ktx") || extension.endsWith(".ktx2") || mimeType === "image/ktx" || mimeType === "image/ktx2";
    }
    /**
     * Uploads the cube texture data to the WebGL texture. It has already been bound.
     * @param data contains the texture data
     * @param texture defines the BabylonJS internal texture
     * @param createPolynomials will be true if polynomials have been requested
     * @param onLoad defines the callback to trigger once the texture is ready
     */ loadCubeData(data, texture, createPolynomials, onLoad) {
        if (Array.isArray(data)) return;
        // Need to invert vScale as invertY via UNPACK_FLIP_Y_WEBGL is not supported by compressed texture
        texture._invertVScale = !texture.invertY;
        const engine = texture.getEngine();
        const ktx = new (0, $ibwgz.KhronosTextureContainer)(data, 6);
        const loadMipmap = ktx.numberOfMipmapLevels > 1 && texture.generateMipMaps;
        engine._unpackFlipY(true);
        ktx.uploadLevels(texture, texture.generateMipMaps);
        texture.width = ktx.pixelWidth;
        texture.height = ktx.pixelHeight;
        engine._setCubeMapTextureParams(texture, loadMipmap, ktx.numberOfMipmapLevels - 1);
        texture.isReady = true;
        texture.onLoadedObservable.notifyObservers(texture);
        texture.onLoadedObservable.clear();
        if (onLoad) onLoad();
    }
    /**
     * Uploads the 2D texture data to the WebGL texture. It has already been bound once in the callback.
     * @param data contains the texture data
     * @param texture defines the BabylonJS internal texture
     * @param callback defines the method to call once ready to upload
     * @param options
     */ loadData(data, texture, callback, options) {
        if ((0, $ibwgz.KhronosTextureContainer).IsValid(data)) {
            // Need to invert vScale as invertY via UNPACK_FLIP_Y_WEBGL is not supported by compressed texture
            texture._invertVScale = !texture.invertY;
            const ktx = new (0, $ibwgz.KhronosTextureContainer)(data, 1);
            const mappedFormat = $520239600346da75$var$mapSRGBToLinear(ktx.glInternalFormat);
            if (mappedFormat) {
                texture.format = mappedFormat;
                texture._useSRGBBuffer = texture.getEngine()._getUseSRGBBuffer(true, texture.generateMipMaps);
                texture._gammaSpace = true;
            } else texture.format = ktx.glInternalFormat;
            callback(ktx.pixelWidth, ktx.pixelHeight, texture.generateMipMaps, true, ()=>{
                ktx.uploadLevels(texture, texture.generateMipMaps);
            }, ktx.isInvalid);
        } else if ((0, $c2VJL.KhronosTextureContainer2).IsValid(data)) {
            const ktx2 = new (0, $c2VJL.KhronosTextureContainer2)(texture.getEngine());
            ktx2._uploadAsync(data, texture, options).then(()=>{
                callback(texture.width, texture.height, texture.generateMipMaps, true, ()=>{}, false);
            }, (error)=>{
                (0, $kVtWi.Logger).Warn(`Failed to load KTX2 texture data: ${error.message}`);
                callback(0, 0, false, false, ()=>{}, true);
            });
        } else {
            (0, $kVtWi.Logger).Error("texture missing KTX identifier");
            callback(0, 0, false, false, ()=>{}, true);
        }
    }
}
// Register the loader.
(0, $5YkyR.Engine)._TextureLoaders.unshift(new $520239600346da75$export$fb2ebe1d59cbbc46());

});
parcelRegister("ibwgz", function(module, exports) {

$parcel$export(module.exports, "KhronosTextureContainer", () => $d3d2487d366ab6ef$export$7dfab06d12cb9411);
/* eslint-disable @typescript-eslint/naming-convention */ 
var $kVtWi = parcelRequire("kVtWi");
class $d3d2487d366ab6ef$export$7dfab06d12cb9411 {
    /**
     * Creates a new KhronosTextureContainer
     * @param data contents of the KTX container file
     * @param facesExpected should be either 1 or 6, based whether a cube texture or or
     */ constructor(/** contents of the KTX container file */ data, facesExpected){
        this.data = data;
        /**
         * If the container has been made invalid (eg. constructor failed to correctly load array buffer)
         */ this.isInvalid = false;
        if (!$d3d2487d366ab6ef$export$7dfab06d12cb9411.IsValid(data)) {
            this.isInvalid = true;
            (0, $kVtWi.Logger).Error("texture missing KTX identifier");
            return;
        }
        // load the reset of the header in native 32 bit uint
        const dataSize = Uint32Array.BYTES_PER_ELEMENT;
        const headerDataView = new DataView(this.data.buffer, this.data.byteOffset + 12, 13 * dataSize);
        const endianness = headerDataView.getUint32(0, true);
        const littleEndian = endianness === 0x04030201;
        this.glType = headerDataView.getUint32(1 * dataSize, littleEndian); // must be 0 for compressed textures
        this.glTypeSize = headerDataView.getUint32(2 * dataSize, littleEndian); // must be 1 for compressed textures
        this.glFormat = headerDataView.getUint32(3 * dataSize, littleEndian); // must be 0 for compressed textures
        this.glInternalFormat = headerDataView.getUint32(4 * dataSize, littleEndian); // the value of arg passed to gl.compressedTexImage2D(,,x,,,,)
        this.glBaseInternalFormat = headerDataView.getUint32(5 * dataSize, littleEndian); // specify GL_RGB, GL_RGBA, GL_ALPHA, etc (un-compressed only)
        this.pixelWidth = headerDataView.getUint32(6 * dataSize, littleEndian); // level 0 value of arg passed to gl.compressedTexImage2D(,,,x,,,)
        this.pixelHeight = headerDataView.getUint32(7 * dataSize, littleEndian); // level 0 value of arg passed to gl.compressedTexImage2D(,,,,x,,)
        this.pixelDepth = headerDataView.getUint32(8 * dataSize, littleEndian); // level 0 value of arg passed to gl.compressedTexImage3D(,,,,,x,,)
        this.numberOfArrayElements = headerDataView.getUint32(9 * dataSize, littleEndian); // used for texture arrays
        this.numberOfFaces = headerDataView.getUint32(10 * dataSize, littleEndian); // used for cubemap textures, should either be 1 or 6
        this.numberOfMipmapLevels = headerDataView.getUint32(11 * dataSize, littleEndian); // number of levels; disregard possibility of 0 for compressed textures
        this.bytesOfKeyValueData = headerDataView.getUint32(12 * dataSize, littleEndian); // the amount of space after the header for meta-data
        // Make sure we have a compressed type.  Not only reduces work, but probably better to let dev know they are not compressing.
        if (this.glType !== 0) {
            (0, $kVtWi.Logger).Error("only compressed formats currently supported");
            this.isInvalid = true;
            return;
        } else // value of zero is an indication to generate mipmaps @ runtime.  Not usually allowed for compressed, so disregard.
        this.numberOfMipmapLevels = Math.max(1, this.numberOfMipmapLevels);
        if (this.pixelHeight === 0 || this.pixelDepth !== 0) {
            (0, $kVtWi.Logger).Error("only 2D textures currently supported");
            this.isInvalid = true;
            return;
        }
        if (this.numberOfArrayElements !== 0) {
            (0, $kVtWi.Logger).Error("texture arrays not currently supported");
            this.isInvalid = true;
            return;
        }
        if (this.numberOfFaces !== facesExpected) {
            (0, $kVtWi.Logger).Error("number of faces expected" + facesExpected + ", but found " + this.numberOfFaces);
            this.isInvalid = true;
            return;
        }
        // we now have a completely validated file, so could use existence of loadType as success
        // would need to make this more elaborate & adjust checks above to support more than one load type
        this.loadType = $d3d2487d366ab6ef$export$7dfab06d12cb9411.COMPRESSED_2D;
    }
    /**
     * Uploads KTX content to a Babylon Texture.
     * It is assumed that the texture has already been created & is currently bound
     * @internal
     */ uploadLevels(texture, loadMipmaps) {
        switch(this.loadType){
            case $d3d2487d366ab6ef$export$7dfab06d12cb9411.COMPRESSED_2D:
                this._upload2DCompressedLevels(texture, loadMipmaps);
                break;
            case $d3d2487d366ab6ef$export$7dfab06d12cb9411.TEX_2D:
            case $d3d2487d366ab6ef$export$7dfab06d12cb9411.COMPRESSED_3D:
            case $d3d2487d366ab6ef$export$7dfab06d12cb9411.TEX_3D:
        }
    }
    _upload2DCompressedLevels(texture, loadMipmaps) {
        // initialize width & height for level 1
        let dataOffset = $d3d2487d366ab6ef$export$7dfab06d12cb9411.HEADER_LEN + this.bytesOfKeyValueData;
        let width = this.pixelWidth;
        let height = this.pixelHeight;
        const mipmapCount = loadMipmaps ? this.numberOfMipmapLevels : 1;
        for(let level = 0; level < mipmapCount; level++){
            const imageSize = new Int32Array(this.data.buffer, this.data.byteOffset + dataOffset, 1)[0]; // size per face, since not supporting array cubemaps
            dataOffset += 4; //image data starts from next multiple of 4 offset. Each face refers to same imagesize field above.
            for(let face = 0; face < this.numberOfFaces; face++){
                const byteArray = new Uint8Array(this.data.buffer, this.data.byteOffset + dataOffset, imageSize);
                const engine = texture.getEngine();
                engine._uploadCompressedDataToTextureDirectly(texture, texture.format, width, height, byteArray, face, level);
                dataOffset += imageSize; // add size of the image for the next face/mipmap
                dataOffset += 3 - (imageSize + 3) % 4; // add padding for odd sized image
            }
            width = Math.max(1.0, width * 0.5);
            height = Math.max(1.0, height * 0.5);
        }
    }
    /**
     * Checks if the given data starts with a KTX file identifier.
     * @param data the data to check
     * @returns true if the data is a KTX file or false otherwise
     */ static IsValid(data) {
        if (data.byteLength >= 12) {
            // '«', 'K', 'T', 'X', ' ', '1', '1', '»', '\r', '\n', '\x1A', '\n'
            const identifier = new Uint8Array(data.buffer, data.byteOffset, 12);
            if (identifier[0] === 0xab && identifier[1] === 0x4b && identifier[2] === 0x54 && identifier[3] === 0x58 && identifier[4] === 0x20 && identifier[5] === 0x31 && identifier[6] === 0x31 && identifier[7] === 0xbb && identifier[8] === 0x0d && identifier[9] === 0x0a && identifier[10] === 0x1a && identifier[11] === 0x0a) return true;
        }
        return false;
    }
}
$d3d2487d366ab6ef$export$7dfab06d12cb9411.HEADER_LEN = 64; // identifier + header elements (not including key value meta-data pairs)
// load types
$d3d2487d366ab6ef$export$7dfab06d12cb9411.COMPRESSED_2D = 0; // uses a gl.compressedTexImage2D()
$d3d2487d366ab6ef$export$7dfab06d12cb9411.COMPRESSED_3D = 1; // uses a gl.compressedTexImage3D()
$d3d2487d366ab6ef$export$7dfab06d12cb9411.TEX_2D = 2; // uses a gl.texImage2D()
$d3d2487d366ab6ef$export$7dfab06d12cb9411.TEX_3D = 3; // uses a gl.texImage3D()

});

parcelRegister("c2VJL", function(module, exports) {

$parcel$export(module.exports, "DefaultKTX2DecoderOptions", () => $8c52755aa930a891$export$c6ce769265e97243);
$parcel$export(module.exports, "KhronosTextureContainer2", () => $8c52755aa930a891$export$89ffb2bd7027327e);

var $ib3jc = parcelRequire("ib3jc");

var $bOhSV = parcelRequire("bOhSV");

var $fx2sP = parcelRequire("fx2sP");

var $bjEls = parcelRequire("bjEls");
class $8c52755aa930a891$export$c6ce769265e97243 {
    constructor(){
        this._isDirty = true;
        this._useRGBAIfOnlyBC1BC3AvailableWhenUASTC = true;
        this._ktx2DecoderOptions = {};
    }
    /**
     * Gets the dirty flag
     */ get isDirty() {
        return this._isDirty;
    }
    /**
     * force a (uncompressed) RGBA transcoded format if transcoding a UASTC source format and ASTC + BC7 are not available as a compressed transcoded format
     */ get useRGBAIfASTCBC7NotAvailableWhenUASTC() {
        return this._useRGBAIfASTCBC7NotAvailableWhenUASTC;
    }
    set useRGBAIfASTCBC7NotAvailableWhenUASTC(value) {
        if (this._useRGBAIfASTCBC7NotAvailableWhenUASTC === value) return;
        this._useRGBAIfASTCBC7NotAvailableWhenUASTC = value;
        this._isDirty = true;
    }
    /**
     * force a (uncompressed) RGBA transcoded format if transcoding a UASTC source format and only BC1 or BC3 are available as a compressed transcoded format.
     * This property is true by default to favor speed over memory, because currently transcoding from UASTC to BC1/3 is slow because the transcoder transcodes
     * to uncompressed and then recompresses the texture
     */ get useRGBAIfOnlyBC1BC3AvailableWhenUASTC() {
        return this._useRGBAIfOnlyBC1BC3AvailableWhenUASTC;
    }
    set useRGBAIfOnlyBC1BC3AvailableWhenUASTC(value) {
        if (this._useRGBAIfOnlyBC1BC3AvailableWhenUASTC === value) return;
        this._useRGBAIfOnlyBC1BC3AvailableWhenUASTC = value;
        this._isDirty = true;
    }
    /**
     * force to always use (uncompressed) RGBA for transcoded format
     */ get forceRGBA() {
        return this._forceRGBA;
    }
    set forceRGBA(value) {
        if (this._forceRGBA === value) return;
        this._forceRGBA = value;
        this._isDirty = true;
    }
    /**
     * force to always use (uncompressed) R8 for transcoded format
     */ get forceR8() {
        return this._forceR8;
    }
    set forceR8(value) {
        if (this._forceR8 === value) return;
        this._forceR8 = value;
        this._isDirty = true;
    }
    /**
     * force to always use (uncompressed) RG8 for transcoded format
     */ get forceRG8() {
        return this._forceRG8;
    }
    set forceRG8(value) {
        if (this._forceRG8 === value) return;
        this._forceRG8 = value;
        this._isDirty = true;
    }
    /**
     * list of transcoders to bypass when looking for a suitable transcoder. The available transcoders are:
     *      UniversalTranscoder_UASTC_ASTC
     *      UniversalTranscoder_UASTC_BC7
     *      UniversalTranscoder_UASTC_RGBA_UNORM
     *      UniversalTranscoder_UASTC_RGBA_SRGB
     *      UniversalTranscoder_UASTC_R8_UNORM
     *      UniversalTranscoder_UASTC_RG8_UNORM
     *      MSCTranscoder
     */ get bypassTranscoders() {
        return this._bypassTranscoders;
    }
    set bypassTranscoders(value) {
        if (this._bypassTranscoders === value) return;
        this._bypassTranscoders = value;
        this._isDirty = true;
    }
    /** @internal */ _getKTX2DecoderOptions() {
        if (!this._isDirty) return this._ktx2DecoderOptions;
        this._isDirty = false;
        const options = {
            useRGBAIfASTCBC7NotAvailableWhenUASTC: this._useRGBAIfASTCBC7NotAvailableWhenUASTC,
            forceRGBA: this._forceRGBA,
            forceR8: this._forceR8,
            forceRG8: this._forceRG8,
            bypassTranscoders: this._bypassTranscoders
        };
        if (this.useRGBAIfOnlyBC1BC3AvailableWhenUASTC) options.transcodeFormatDecisionTree = {
            UASTC: {
                transcodeFormat: [
                    (0, $fx2sP.TranscodeTarget).BC1_RGB,
                    (0, $fx2sP.TranscodeTarget).BC3_RGBA
                ],
                yes: {
                    transcodeFormat: (0, $fx2sP.TranscodeTarget).RGBA32,
                    engineFormat: (0, $fx2sP.EngineFormat).RGBA8Format,
                    roundToMultiple4: false
                }
            }
        };
        this._ktx2DecoderOptions = options;
        return options;
    }
}
class $8c52755aa930a891$export$89ffb2bd7027327e {
    static GetDefaultNumWorkers() {
        if (typeof navigator !== "object" || !navigator.hardwareConcurrency) return 1;
        // Use 50% of the available logical processors but capped at 4.
        return Math.min(Math.floor(navigator.hardwareConcurrency * 0.5), 4);
    }
    static _Initialize(numWorkers) {
        if ($8c52755aa930a891$export$89ffb2bd7027327e._WorkerPoolPromise || $8c52755aa930a891$export$89ffb2bd7027327e._DecoderModulePromise) return;
        const urls = {
            jsDecoderModule: (0, $bOhSV.Tools).GetBabylonScriptURL(this.URLConfig.jsDecoderModule, true),
            wasmUASTCToASTC: (0, $bOhSV.Tools).GetBabylonScriptURL(this.URLConfig.wasmUASTCToASTC, true),
            wasmUASTCToBC7: (0, $bOhSV.Tools).GetBabylonScriptURL(this.URLConfig.wasmUASTCToBC7, true),
            wasmUASTCToRGBA_UNORM: (0, $bOhSV.Tools).GetBabylonScriptURL(this.URLConfig.wasmUASTCToRGBA_UNORM, true),
            wasmUASTCToRGBA_SRGB: (0, $bOhSV.Tools).GetBabylonScriptURL(this.URLConfig.wasmUASTCToRGBA_SRGB, true),
            wasmUASTCToR8_UNORM: (0, $bOhSV.Tools).GetBabylonScriptURL(this.URLConfig.wasmUASTCToR8_UNORM, true),
            wasmUASTCToRG8_UNORM: (0, $bOhSV.Tools).GetBabylonScriptURL(this.URLConfig.wasmUASTCToRG8_UNORM, true),
            jsMSCTranscoder: (0, $bOhSV.Tools).GetBabylonScriptURL(this.URLConfig.jsMSCTranscoder, true),
            wasmMSCTranscoder: (0, $bOhSV.Tools).GetBabylonScriptURL(this.URLConfig.wasmMSCTranscoder, true),
            wasmZSTDDecoder: (0, $bOhSV.Tools).GetBabylonScriptURL(this.URLConfig.wasmZSTDDecoder, true)
        };
        if (numWorkers && typeof Worker === "function" && typeof URL !== "undefined") $8c52755aa930a891$export$89ffb2bd7027327e._WorkerPoolPromise = new Promise((resolve)=>{
            const workerContent = `${(0, $bjEls.applyConfig)}(${(0, $bjEls.workerFunction)})()`;
            const workerBlobUrl = URL.createObjectURL(new Blob([
                workerContent
            ], {
                type: "application/javascript"
            }));
            resolve(new (0, $ib3jc.AutoReleaseWorkerPool)(numWorkers, ()=>(0, $bjEls.initializeWebWorker)(new Worker(workerBlobUrl), undefined, urls)));
        });
        else if (typeof $8c52755aa930a891$export$89ffb2bd7027327e._KTX2DecoderModule === "undefined") $8c52755aa930a891$export$89ffb2bd7027327e._DecoderModulePromise = (0, $bOhSV.Tools).LoadBabylonScriptAsync(urls.jsDecoderModule).then(()=>{
            $8c52755aa930a891$export$89ffb2bd7027327e._KTX2DecoderModule = KTX2DECODER;
            $8c52755aa930a891$export$89ffb2bd7027327e._KTX2DecoderModule.MSCTranscoder.UseFromWorkerThread = false;
            $8c52755aa930a891$export$89ffb2bd7027327e._KTX2DecoderModule.WASMMemoryManager.LoadBinariesFromCurrentThread = true;
            (0, $bjEls.applyConfig)(urls, $8c52755aa930a891$export$89ffb2bd7027327e._KTX2DecoderModule);
            return new $8c52755aa930a891$export$89ffb2bd7027327e._KTX2DecoderModule.KTX2Decoder();
        });
        else {
            $8c52755aa930a891$export$89ffb2bd7027327e._KTX2DecoderModule.MSCTranscoder.UseFromWorkerThread = false;
            $8c52755aa930a891$export$89ffb2bd7027327e._KTX2DecoderModule.WASMMemoryManager.LoadBinariesFromCurrentThread = true;
            $8c52755aa930a891$export$89ffb2bd7027327e._DecoderModulePromise = Promise.resolve(new $8c52755aa930a891$export$89ffb2bd7027327e._KTX2DecoderModule.KTX2Decoder());
        }
    }
    /**
     * Constructor
     * @param engine The engine to use
     * @param numWorkersOrOptions The number of workers for async operations. Specify `0` to disable web workers and run synchronously in the current context.
     */ constructor(engine, numWorkersOrOptions = $8c52755aa930a891$export$89ffb2bd7027327e.DefaultNumWorkers){
        this._engine = engine;
        if (typeof numWorkersOrOptions === "object" && numWorkersOrOptions.workerPool) $8c52755aa930a891$export$89ffb2bd7027327e._WorkerPoolPromise = Promise.resolve(numWorkersOrOptions.workerPool);
        else {
            // set the KTX2 decoder module
            if (typeof numWorkersOrOptions === "object") $8c52755aa930a891$export$89ffb2bd7027327e._KTX2DecoderModule = numWorkersOrOptions?.binariesAndModulesContainer?.jsDecoderModule;
            else if (typeof KTX2DECODER !== "undefined") $8c52755aa930a891$export$89ffb2bd7027327e._KTX2DecoderModule = KTX2DECODER;
            const numberOfWorkers = typeof numWorkersOrOptions === "number" ? numWorkersOrOptions : numWorkersOrOptions.numWorkers ?? $8c52755aa930a891$export$89ffb2bd7027327e.DefaultNumWorkers;
            $8c52755aa930a891$export$89ffb2bd7027327e._Initialize(numberOfWorkers);
        }
    }
    /**
     * @internal
     */ _uploadAsync(data, internalTexture, options) {
        const caps = this._engine.getCaps();
        const compressedTexturesCaps = {
            astc: !!caps.astc,
            bptc: !!caps.bptc,
            s3tc: !!caps.s3tc,
            pvrtc: !!caps.pvrtc,
            etc2: !!caps.etc2,
            etc1: !!caps.etc1
        };
        if ($8c52755aa930a891$export$89ffb2bd7027327e._WorkerPoolPromise) return $8c52755aa930a891$export$89ffb2bd7027327e._WorkerPoolPromise.then((workerPool)=>{
            return new Promise((resolve, reject)=>{
                workerPool.push((worker, onComplete)=>{
                    const onError = (error)=>{
                        worker.removeEventListener("error", onError);
                        worker.removeEventListener("message", onMessage);
                        reject(error);
                        onComplete();
                    };
                    const onMessage = (message)=>{
                        if (message.data.action === "decoded") {
                            worker.removeEventListener("error", onError);
                            worker.removeEventListener("message", onMessage);
                            if (!message.data.success) reject({
                                message: message.data.msg
                            });
                            else try {
                                this._createTexture(message.data.decodedData, internalTexture, options);
                                resolve();
                            } catch (err) {
                                reject({
                                    message: err
                                });
                            }
                            onComplete();
                        }
                    };
                    worker.addEventListener("error", onError);
                    worker.addEventListener("message", onMessage);
                    worker.postMessage({
                        action: "setDefaultDecoderOptions",
                        options: $8c52755aa930a891$export$89ffb2bd7027327e.DefaultDecoderOptions._getKTX2DecoderOptions()
                    });
                    const dataCopy = new Uint8Array(data.byteLength);
                    dataCopy.set(new Uint8Array(data.buffer, data.byteOffset, data.byteLength));
                    worker.postMessage({
                        action: "decode",
                        data: dataCopy,
                        caps: compressedTexturesCaps,
                        options: options
                    }, [
                        dataCopy.buffer
                    ]);
                });
            });
        });
        else if ($8c52755aa930a891$export$89ffb2bd7027327e._DecoderModulePromise) return $8c52755aa930a891$export$89ffb2bd7027327e._DecoderModulePromise.then((decoder)=>{
            if ($8c52755aa930a891$export$89ffb2bd7027327e.DefaultDecoderOptions.isDirty) $8c52755aa930a891$export$89ffb2bd7027327e._KTX2DecoderModule.KTX2Decoder.DefaultDecoderOptions = $8c52755aa930a891$export$89ffb2bd7027327e.DefaultDecoderOptions._getKTX2DecoderOptions();
            return new Promise((resolve, reject)=>{
                decoder.decode(data, caps).then((data)=>{
                    this._createTexture(data, internalTexture);
                    resolve();
                }).catch((reason)=>{
                    reject({
                        message: reason
                    });
                });
            });
        });
        throw new Error("KTX2 decoder module is not available");
    }
    _createTexture(data, internalTexture, options) {
        const oglTexture2D = 3553; // gl.TEXTURE_2D
        this._engine._bindTextureDirectly(oglTexture2D, internalTexture);
        if (options) {
            // return back some information about the decoded data
            options.transcodedFormat = data.transcodedFormat;
            options.isInGammaSpace = data.isInGammaSpace;
            options.hasAlpha = data.hasAlpha;
            options.transcoderName = data.transcoderName;
        }
        let isUncompressedFormat = true;
        switch(data.transcodedFormat){
            case 0x8058 /* RGBA8 */ :
                internalTexture.type = 0;
                internalTexture.format = 5;
                break;
            case 0x8229 /* R8 */ :
                internalTexture.type = 0;
                internalTexture.format = 6;
                break;
            case 0x822b /* RG8 */ :
                internalTexture.type = 0;
                internalTexture.format = 7;
                break;
            default:
                internalTexture.format = data.transcodedFormat;
                isUncompressedFormat = false;
                break;
        }
        internalTexture._gammaSpace = data.isInGammaSpace;
        internalTexture.generateMipMaps = data.mipmaps.length > 1;
        if (data.errors) throw new Error("KTX2 container - could not transcode the data. " + data.errors);
        for(let t = 0; t < data.mipmaps.length; ++t){
            const mipmap = data.mipmaps[t];
            if (!mipmap || !mipmap.data) throw new Error("KTX2 container - could not transcode one of the image");
            if (isUncompressedFormat) {
                // uncompressed RGBA / R8 / RG8
                internalTexture.width = mipmap.width; // need to set width/height so that the call to _uploadDataToTextureDirectly uses the right dimensions
                internalTexture.height = mipmap.height;
                this._engine._uploadDataToTextureDirectly(internalTexture, mipmap.data, 0, t, undefined, true);
            } else this._engine._uploadCompressedDataToTextureDirectly(internalTexture, data.transcodedFormat, mipmap.width, mipmap.height, mipmap.data, 0, t);
        }
        internalTexture._extension = ".ktx2";
        internalTexture.width = data.mipmaps[0].width;
        internalTexture.height = data.mipmaps[0].height;
        internalTexture.isReady = true;
        this._engine._bindTextureDirectly(oglTexture2D, null);
    }
    /**
     * Checks if the given data starts with a KTX2 file identifier.
     * @param data the data to check
     * @returns true if the data is a KTX2 file or false otherwise
     */ static IsValid(data) {
        if (data.byteLength >= 12) {
            // '«', 'K', 'T', 'X', ' ', '2', '0', '»', '\r', '\n', '\x1A', '\n'
            const identifier = new Uint8Array(data.buffer, data.byteOffset, 12);
            if (identifier[0] === 0xab && identifier[1] === 0x4b && identifier[2] === 0x54 && identifier[3] === 0x58 && identifier[4] === 0x20 && identifier[5] === 0x32 && identifier[6] === 0x30 && identifier[7] === 0xbb && identifier[8] === 0x0d && identifier[9] === 0x0a && identifier[10] === 0x1a && identifier[11] === 0x0a) return true;
        }
        return false;
    }
}
/**
 * URLs to use when loading the KTX2 decoder module as well as its dependencies
 * If a url is null, the default url is used (pointing to https://preview.babylonjs.com)
 * Note that jsDecoderModule can't be null and that the other dependencies will only be loaded if necessary
 * Urls you can change:
 *     URLConfig.jsDecoderModule
 *     URLConfig.wasmUASTCToASTC
 *     URLConfig.wasmUASTCToBC7
 *     URLConfig.wasmUASTCToRGBA_UNORM
 *     URLConfig.wasmUASTCToRGBA_SRGB
 *     URLConfig.wasmUASTCToR8_UNORM
 *     URLConfig.wasmUASTCToRG8_UNORM
 *     URLConfig.jsMSCTranscoder
 *     URLConfig.wasmMSCTranscoder
 *     URLConfig.wasmZSTDDecoder
 * You can see their default values in this PG: https://playground.babylonjs.com/#EIJH8L#29
 */ $8c52755aa930a891$export$89ffb2bd7027327e.URLConfig = {
    jsDecoderModule: "https://cdn.babylonjs.com/babylon.ktx2Decoder.js",
    wasmUASTCToASTC: null,
    wasmUASTCToBC7: null,
    wasmUASTCToRGBA_UNORM: null,
    wasmUASTCToRGBA_SRGB: null,
    wasmUASTCToR8_UNORM: null,
    wasmUASTCToRG8_UNORM: null,
    jsMSCTranscoder: null,
    wasmMSCTranscoder: null,
    wasmZSTDDecoder: null
};
/**
 * Default number of workers used to handle data decoding
 */ $8c52755aa930a891$export$89ffb2bd7027327e.DefaultNumWorkers = $8c52755aa930a891$export$89ffb2bd7027327e.GetDefaultNumWorkers();
/**
 * Default configuration for the KTX2 decoder.
 * The options defined in this way have priority over those passed when creating a KTX2 texture with new Texture(...).
 */ $8c52755aa930a891$export$89ffb2bd7027327e.DefaultDecoderOptions = new $8c52755aa930a891$export$c6ce769265e97243();

});
parcelRegister("ib3jc", function(module, exports) {

$parcel$export(module.exports, "WorkerPool", () => $d3bbd21718d12f41$export$ddf9e847a113aa9c);
$parcel$export(module.exports, "AutoReleaseWorkerPool", () => $d3bbd21718d12f41$export$79e656e78797d841);
/**
 * Helper class to push actions to a pool of workers.
 */ class $d3bbd21718d12f41$export$ddf9e847a113aa9c {
    /**
     * Constructor
     * @param workers Array of workers to use for actions
     */ constructor(workers){
        this._pendingActions = new Array();
        this._workerInfos = workers.map((worker)=>({
                workerPromise: Promise.resolve(worker),
                idle: true
            }));
    }
    /**
     * Terminates all workers and clears any pending actions.
     */ dispose() {
        for (const workerInfo of this._workerInfos)workerInfo.workerPromise.then((worker)=>{
            worker.terminate();
        });
        this._workerInfos.length = 0;
        this._pendingActions.length = 0;
    }
    /**
     * Pushes an action to the worker pool. If all the workers are active, the action will be
     * pended until a worker has completed its action.
     * @param action The action to perform. Call onComplete when the action is complete.
     */ push(action) {
        if (!this._executeOnIdleWorker(action)) this._pendingActions.push(action);
    }
    _executeOnIdleWorker(action) {
        for (const workerInfo of this._workerInfos)if (workerInfo.idle) {
            this._execute(workerInfo, action);
            return true;
        }
        return false;
    }
    _execute(workerInfo, action) {
        workerInfo.idle = false;
        workerInfo.workerPromise.then((worker)=>{
            action(worker, ()=>{
                const nextAction = this._pendingActions.shift();
                if (nextAction) this._execute(workerInfo, nextAction);
                else workerInfo.idle = true;
            });
        });
    }
}
class $d3bbd21718d12f41$export$79e656e78797d841 extends $d3bbd21718d12f41$export$ddf9e847a113aa9c {
    constructor(maxWorkers, createWorkerAsync, options = $d3bbd21718d12f41$export$79e656e78797d841.DefaultOptions){
        super([]);
        this._maxWorkers = maxWorkers;
        this._createWorkerAsync = createWorkerAsync;
        this._options = options;
    }
    push(action) {
        if (!this._executeOnIdleWorker(action)) {
            if (this._workerInfos.length < this._maxWorkers) {
                const workerInfo = {
                    workerPromise: this._createWorkerAsync(),
                    idle: false
                };
                this._workerInfos.push(workerInfo);
                this._execute(workerInfo, action);
            } else this._pendingActions.push(action);
        }
    }
    _execute(workerInfo, action) {
        // Reset the idle timeout.
        if (workerInfo.timeoutId) {
            clearTimeout(workerInfo.timeoutId);
            delete workerInfo.timeoutId;
        }
        super._execute(workerInfo, (worker, onComplete)=>{
            action(worker, ()=>{
                onComplete();
                if (workerInfo.idle) // Schedule the worker to be terminated after the elapsed time.
                workerInfo.timeoutId = setTimeout(()=>{
                    workerInfo.workerPromise.then((worker)=>{
                        worker.terminate();
                    });
                    const indexOf = this._workerInfos.indexOf(workerInfo);
                    if (indexOf !== -1) this._workerInfos.splice(indexOf, 1);
                }, this._options.idleTimeElapsedBeforeRelease);
            });
        });
    }
}
/**
 * Default options for the constructor.
 * Override to change the defaults.
 */ $d3bbd21718d12f41$export$79e656e78797d841.DefaultOptions = {
    idleTimeElapsedBeforeRelease: 1000
};

});

parcelRegister("fx2sP", function(module, exports) {

$parcel$export(module.exports, "SourceTextureFormat", () => $b4ebd95d9d3da3f0$export$7dd63d162124da2e);
$parcel$export(module.exports, "TranscodeTarget", () => $b4ebd95d9d3da3f0$export$8247134d5f16068b);
$parcel$export(module.exports, "EngineFormat", () => $b4ebd95d9d3da3f0$export$a111da1b0408eb6f);
var $b4ebd95d9d3da3f0$export$7dd63d162124da2e;
(function(SourceTextureFormat) {
    SourceTextureFormat[SourceTextureFormat["ETC1S"] = 0] = "ETC1S";
    SourceTextureFormat[SourceTextureFormat["UASTC4x4"] = 1] = "UASTC4x4";
})($b4ebd95d9d3da3f0$export$7dd63d162124da2e || ($b4ebd95d9d3da3f0$export$7dd63d162124da2e = {}));
var $b4ebd95d9d3da3f0$export$8247134d5f16068b;
(function(TranscodeTarget) {
    TranscodeTarget[TranscodeTarget["ASTC_4X4_RGBA"] = 0] = "ASTC_4X4_RGBA";
    TranscodeTarget[TranscodeTarget["BC7_RGBA"] = 1] = "BC7_RGBA";
    TranscodeTarget[TranscodeTarget["BC3_RGBA"] = 2] = "BC3_RGBA";
    TranscodeTarget[TranscodeTarget["BC1_RGB"] = 3] = "BC1_RGB";
    TranscodeTarget[TranscodeTarget["PVRTC1_4_RGBA"] = 4] = "PVRTC1_4_RGBA";
    TranscodeTarget[TranscodeTarget["PVRTC1_4_RGB"] = 5] = "PVRTC1_4_RGB";
    TranscodeTarget[TranscodeTarget["ETC2_RGBA"] = 6] = "ETC2_RGBA";
    TranscodeTarget[TranscodeTarget["ETC1_RGB"] = 7] = "ETC1_RGB";
    TranscodeTarget[TranscodeTarget["RGBA32"] = 8] = "RGBA32";
    TranscodeTarget[TranscodeTarget["R8"] = 9] = "R8";
    TranscodeTarget[TranscodeTarget["RG8"] = 10] = "RG8";
})($b4ebd95d9d3da3f0$export$8247134d5f16068b || ($b4ebd95d9d3da3f0$export$8247134d5f16068b = {}));
var $b4ebd95d9d3da3f0$export$a111da1b0408eb6f;
(function(EngineFormat) {
    EngineFormat[EngineFormat["COMPRESSED_RGBA_BPTC_UNORM_EXT"] = 36492] = "COMPRESSED_RGBA_BPTC_UNORM_EXT";
    EngineFormat[EngineFormat["COMPRESSED_RGBA_ASTC_4X4_KHR"] = 37808] = "COMPRESSED_RGBA_ASTC_4X4_KHR";
    EngineFormat[EngineFormat["COMPRESSED_RGB_S3TC_DXT1_EXT"] = 33776] = "COMPRESSED_RGB_S3TC_DXT1_EXT";
    EngineFormat[EngineFormat["COMPRESSED_RGBA_S3TC_DXT5_EXT"] = 33779] = "COMPRESSED_RGBA_S3TC_DXT5_EXT";
    EngineFormat[EngineFormat["COMPRESSED_RGBA_PVRTC_4BPPV1_IMG"] = 35842] = "COMPRESSED_RGBA_PVRTC_4BPPV1_IMG";
    EngineFormat[EngineFormat["COMPRESSED_RGB_PVRTC_4BPPV1_IMG"] = 35840] = "COMPRESSED_RGB_PVRTC_4BPPV1_IMG";
    EngineFormat[EngineFormat["COMPRESSED_RGBA8_ETC2_EAC"] = 37496] = "COMPRESSED_RGBA8_ETC2_EAC";
    EngineFormat[EngineFormat["COMPRESSED_RGB8_ETC2"] = 37492] = "COMPRESSED_RGB8_ETC2";
    EngineFormat[EngineFormat["COMPRESSED_RGB_ETC1_WEBGL"] = 36196] = "COMPRESSED_RGB_ETC1_WEBGL";
    EngineFormat[EngineFormat["RGBA8Format"] = 32856] = "RGBA8Format";
    EngineFormat[EngineFormat["R8Format"] = 33321] = "R8Format";
    EngineFormat[EngineFormat["RG8Format"] = 33323] = "RG8Format";
})($b4ebd95d9d3da3f0$export$a111da1b0408eb6f || ($b4ebd95d9d3da3f0$export$a111da1b0408eb6f = {}));

});

parcelRegister("bjEls", function(module, exports) {

$parcel$export(module.exports, "applyConfig", () => $83d0c3c28ee9e134$export$63b9475ad673449f);
$parcel$export(module.exports, "workerFunction", () => $83d0c3c28ee9e134$export$4fa462ff61661f49);
$parcel$export(module.exports, "initializeWebWorker", () => $83d0c3c28ee9e134$export$712a80800d0b66d1);
function $83d0c3c28ee9e134$export$63b9475ad673449f(urls, binariesAndModulesContainer) {
    const KTX2DecoderModule = binariesAndModulesContainer?.jsDecoderModule || KTX2DECODER;
    if (urls) {
        if (urls.wasmUASTCToASTC) KTX2DecoderModule.LiteTranscoder_UASTC_ASTC.WasmModuleURL = urls.wasmUASTCToASTC;
        if (urls.wasmUASTCToBC7) KTX2DecoderModule.LiteTranscoder_UASTC_BC7.WasmModuleURL = urls.wasmUASTCToBC7;
        if (urls.wasmUASTCToRGBA_UNORM) KTX2DecoderModule.LiteTranscoder_UASTC_RGBA_UNORM.WasmModuleURL = urls.wasmUASTCToRGBA_UNORM;
        if (urls.wasmUASTCToRGBA_SRGB) KTX2DecoderModule.LiteTranscoder_UASTC_RGBA_SRGB.WasmModuleURL = urls.wasmUASTCToRGBA_SRGB;
        if (urls.wasmUASTCToR8_UNORM) KTX2DecoderModule.LiteTranscoder_UASTC_R8_UNORM.WasmModuleURL = urls.wasmUASTCToR8_UNORM;
        if (urls.wasmUASTCToRG8_UNORM) KTX2DecoderModule.LiteTranscoder_UASTC_RG8_UNORM.WasmModuleURL = urls.wasmUASTCToRG8_UNORM;
        if (urls.jsMSCTranscoder) KTX2DecoderModule.MSCTranscoder.JSModuleURL = urls.jsMSCTranscoder;
        if (urls.wasmMSCTranscoder) KTX2DecoderModule.MSCTranscoder.WasmModuleURL = urls.wasmMSCTranscoder;
        if (urls.wasmZSTDDecoder) KTX2DecoderModule.ZSTDDecoder.WasmModuleURL = urls.wasmZSTDDecoder;
    }
    if (binariesAndModulesContainer) {
        if (binariesAndModulesContainer.wasmUASTCToASTC) KTX2DecoderModule.LiteTranscoder_UASTC_ASTC.WasmBinary = binariesAndModulesContainer.wasmUASTCToASTC;
        if (binariesAndModulesContainer.wasmUASTCToBC7) KTX2DecoderModule.LiteTranscoder_UASTC_BC7.WasmBinary = binariesAndModulesContainer.wasmUASTCToBC7;
        if (binariesAndModulesContainer.wasmUASTCToRGBA_UNORM) KTX2DecoderModule.LiteTranscoder_UASTC_RGBA_UNORM.WasmBinary = binariesAndModulesContainer.wasmUASTCToRGBA_UNORM;
        if (binariesAndModulesContainer.wasmUASTCToRGBA_SRGB) KTX2DecoderModule.LiteTranscoder_UASTC_RGBA_SRGB.WasmBinary = binariesAndModulesContainer.wasmUASTCToRGBA_SRGB;
        if (binariesAndModulesContainer.wasmUASTCToR8_UNORM) KTX2DecoderModule.LiteTranscoder_UASTC_R8_UNORM.WasmBinary = binariesAndModulesContainer.wasmUASTCToR8_UNORM;
        if (binariesAndModulesContainer.wasmUASTCToRG8_UNORM) KTX2DecoderModule.LiteTranscoder_UASTC_RG8_UNORM.WasmBinary = binariesAndModulesContainer.wasmUASTCToRG8_UNORM;
        if (binariesAndModulesContainer.jsMSCTranscoder) KTX2DecoderModule.MSCTranscoder.JSModule = binariesAndModulesContainer.jsMSCTranscoder;
        if (binariesAndModulesContainer.wasmMSCTranscoder) KTX2DecoderModule.MSCTranscoder.WasmBinary = binariesAndModulesContainer.wasmMSCTranscoder;
        if (binariesAndModulesContainer.wasmZSTDDecoder) KTX2DecoderModule.ZSTDDecoder.WasmBinary = binariesAndModulesContainer.wasmZSTDDecoder;
    }
}
function $83d0c3c28ee9e134$export$4fa462ff61661f49(KTX2DecoderModule) {
    if (typeof KTX2DecoderModule === "undefined" && typeof KTX2DECODER !== "undefined") KTX2DecoderModule = KTX2DECODER;
    let ktx2Decoder;
    onmessage = (event)=>{
        if (!event.data) return;
        switch(event.data.action){
            case "init":
                {
                    const urls = event.data.urls;
                    if (urls) {
                        if (urls.jsDecoderModule && typeof KTX2DecoderModule === "undefined") {
                            importScripts(urls.jsDecoderModule);
                            // assuming global namespace populated by the script (UMD pattern)
                            KTX2DecoderModule = KTX2DECODER;
                        }
                        $83d0c3c28ee9e134$export$63b9475ad673449f(urls);
                    }
                    if (event.data.wasmBinaries) $83d0c3c28ee9e134$export$63b9475ad673449f(undefined, {
                        ...event.data.wasmBinaries,
                        jsDecoderModule: KTX2DecoderModule
                    });
                    ktx2Decoder = new KTX2DecoderModule.KTX2Decoder();
                    postMessage({
                        action: "init"
                    });
                    break;
                }
            case "setDefaultDecoderOptions":
                KTX2DecoderModule.KTX2Decoder.DefaultDecoderOptions = event.data.options;
                break;
            case "decode":
                ktx2Decoder.decode(event.data.data, event.data.caps, event.data.options).then((data)=>{
                    const buffers = [];
                    for(let mip = 0; mip < data.mipmaps.length; ++mip){
                        const mipmap = data.mipmaps[mip];
                        if (mipmap && mipmap.data) buffers.push(mipmap.data.buffer);
                    }
                    postMessage({
                        action: "decoded",
                        success: true,
                        decodedData: data
                    }, buffers);
                }).catch((reason)=>{
                    postMessage({
                        action: "decoded",
                        success: false,
                        msg: reason
                    });
                });
                break;
        }
    };
}
function $83d0c3c28ee9e134$export$712a80800d0b66d1(worker, wasmBinaries, urls) {
    return new Promise((resolve, reject)=>{
        const onError = (error)=>{
            worker.removeEventListener("error", onError);
            worker.removeEventListener("message", onMessage);
            reject(error);
        };
        const onMessage = (message)=>{
            if (message.data.action === "init") {
                worker.removeEventListener("error", onError);
                worker.removeEventListener("message", onMessage);
                resolve(worker);
            }
        };
        worker.addEventListener("error", onError);
        worker.addEventListener("message", onMessage);
        worker.postMessage({
            action: "init",
            urls: urls,
            wasmBinaries: wasmBinaries
        });
    });
}

});



parcelRegister("bwZgn", function(module, exports) {

$parcel$export(module.exports, "WebXRDefaultExperienceOptions", () => $86523476facfde83$export$1a715aead4fd3e79);
$parcel$export(module.exports, "WebXRDefaultExperience", () => $86523476facfde83$export$333b3cb0c8895b7d);

var $jDt6c = parcelRequire("jDt6c");

var $9zzya = parcelRequire("9zzya");

var $9GdLu = parcelRequire("9GdLu");

var $gw4bf = parcelRequire("gw4bf");

var $h2dFw = parcelRequire("h2dFw");

var $k1hzP = parcelRequire("k1hzP");

var $laic7 = parcelRequire("laic7");

var $kVtWi = parcelRequire("kVtWi");
class $86523476facfde83$export$1a715aead4fd3e79 {
}
class $86523476facfde83$export$333b3cb0c8895b7d {
    constructor(){}
    /**
     * Creates the default xr experience
     * @param scene scene
     * @param options options for basic configuration
     * @returns resulting WebXRDefaultExperience
     */ static CreateAsync(scene, options = {}) {
        const result = new $86523476facfde83$export$333b3cb0c8895b7d();
        scene.onDisposeObservable.addOnce(()=>{
            result.dispose();
        });
        // init the UI right after construction
        if (!options.disableDefaultUI) {
            const uiOptions = {
                renderTarget: result.renderTarget,
                ...options.uiOptions || {}
            };
            if (options.optionalFeatures) {
                if (typeof options.optionalFeatures === "boolean") uiOptions.optionalFeatures = [
                    "hit-test",
                    "anchors",
                    "plane-detection",
                    "hand-tracking"
                ];
                else uiOptions.optionalFeatures = options.optionalFeatures;
            }
            result.enterExitUI = new (0, $h2dFw.WebXREnterExitUI)(scene, uiOptions);
        }
        // Create base experience
        return (0, $jDt6c.WebXRExperienceHelper).CreateAsync(scene).then((xrHelper)=>{
            result.baseExperience = xrHelper;
            if (options.ignoreNativeCameraTransformation) result.baseExperience.camera.compensateOnFirstFrame = false;
            // Add controller support
            result.input = new (0, $9zzya.WebXRInput)(xrHelper.sessionManager, xrHelper.camera, {
                controllerOptions: {
                    renderingGroupId: options.renderingGroupId
                },
                ...options.inputOptions || {}
            });
            if (!options.disablePointerSelection) {
                // Add default pointer selection
                const pointerSelectionOptions = {
                    ...options.pointerSelectionOptions,
                    xrInput: result.input,
                    renderingGroupId: options.renderingGroupId
                };
                result.pointerSelection = result.baseExperience.featuresManager.enableFeature((0, $9GdLu.WebXRControllerPointerSelection).Name, options.useStablePlugins ? "stable" : "latest", pointerSelectionOptions);
                if (!options.disableTeleportation) {
                    // Add default teleportation, including rotation
                    result.teleportation = result.baseExperience.featuresManager.enableFeature((0, $laic7.WebXRMotionControllerTeleportation).Name, options.useStablePlugins ? "stable" : "latest", {
                        floorMeshes: options.floorMeshes,
                        xrInput: result.input,
                        renderingGroupId: options.renderingGroupId,
                        ...options.teleportationOptions
                    });
                    result.teleportation.setSelectionFeature(result.pointerSelection);
                }
            }
            if (!options.disableNearInteraction) // Add default pointer selection
            result.nearInteraction = result.baseExperience.featuresManager.enableFeature((0, $gw4bf.WebXRNearInteraction).Name, options.useStablePlugins ? "stable" : "latest", {
                xrInput: result.input,
                farInteractionFeature: result.pointerSelection,
                renderingGroupId: options.renderingGroupId,
                useUtilityLayer: true,
                enableNearInteractionOnAllControllers: true,
                ...options.nearInteractionOptions
            });
            if (!options.disableHandTracking) // Add default hand tracking
            result.baseExperience.featuresManager.enableFeature((0, $k1hzP.WebXRHandTracking).Name, options.useStablePlugins ? "stable" : "latest", {
                xrInput: result.input,
                ...options.handSupportOptions
            }, undefined, false);
            // Create the WebXR output target
            result.renderTarget = result.baseExperience.sessionManager.getWebXRRenderTarget(options.outputCanvasOptions);
            if (!options.disableDefaultUI) // Create ui for entering/exiting xr
            return result.enterExitUI.setHelperAsync(result.baseExperience, result.renderTarget);
            else return;
        }).then(()=>{
            return result;
        }).catch((error)=>{
            (0, $kVtWi.Logger).Error("Error initializing XR");
            (0, $kVtWi.Logger).Error(error);
            return result;
        });
    }
    /**
     * Disposes of the experience helper
     */ dispose() {
        if (this.baseExperience) this.baseExperience.dispose();
        if (this.input) this.input.dispose();
        if (this.enterExitUI) this.enterExitUI.dispose();
        if (this.renderTarget) this.renderTarget.dispose();
    }
}

});
parcelRegister("jDt6c", function(module, exports) {

$parcel$export(module.exports, "WebXRExperienceHelper", () => $e4b83b4c37ae1d0f$export$76c372556a8eaf60);

var $diGQf = parcelRequire("diGQf");

var $2isQc = parcelRequire("2isQc");

var $UghGd = parcelRequire("UghGd");

var $jknux = parcelRequire("jknux");

var $cJN7d = parcelRequire("cJN7d");

var $kVtWi = parcelRequire("kVtWi");

var $765rp = parcelRequire("765rp");

var $ha1VO = parcelRequire("ha1VO");
class $e4b83b4c37ae1d0f$export$76c372556a8eaf60 {
    /**
     * Creates a WebXRExperienceHelper
     * @param _scene The scene the helper should be created in
     */ constructor(_scene){
        this._scene = _scene;
        this._nonVRCamera = null;
        this._attachedToElement = false;
        this._spectatorCamera = null;
        this._originalSceneAutoClear = true;
        this._supported = false;
        this._spectatorMode = false;
        this._lastTimestamp = 0;
        /**
         * Observers registered here will be triggered after the camera's initial transformation is set
         * This can be used to set a different ground level or an extra rotation.
         *
         * Note that ground level is considered to be at 0. The height defined by the XR camera will be added
         * to the position set after this observable is done executing.
         */ this.onInitialXRPoseSetObservable = new (0, $diGQf.Observable)();
        /**
         * Fires when the state of the experience helper has changed
         */ this.onStateChangedObservable = new (0, $diGQf.Observable)();
        /**
         * The current state of the XR experience (eg. transitioning, in XR or not in XR)
         */ this.state = (0, $jknux.WebXRState).NOT_IN_XR;
        this.sessionManager = new (0, $2isQc.WebXRSessionManager)(_scene);
        this.camera = new (0, $UghGd.WebXRCamera)("webxr", _scene, this.sessionManager);
        this.featuresManager = new (0, $cJN7d.WebXRFeaturesManager)(this.sessionManager);
        _scene.onDisposeObservable.addOnce(()=>{
            this.dispose();
        });
    }
    /**
     * Creates the experience helper
     * @param scene the scene to attach the experience helper to
     * @returns a promise for the experience helper
     */ static CreateAsync(scene) {
        const helper = new $e4b83b4c37ae1d0f$export$76c372556a8eaf60(scene);
        return helper.sessionManager.initializeAsync().then(()=>{
            helper._supported = true;
            return helper;
        }).catch((e)=>{
            helper._setState((0, $jknux.WebXRState).NOT_IN_XR);
            helper.dispose();
            throw e;
        });
    }
    /**
     * Disposes of the experience helper
     */ dispose() {
        this.exitXRAsync();
        this.camera.dispose();
        this.onStateChangedObservable.clear();
        this.onInitialXRPoseSetObservable.clear();
        this.sessionManager.dispose();
        this._spectatorCamera?.dispose();
        if (this._nonVRCamera) this._scene.activeCamera = this._nonVRCamera;
    }
    /**
     * Enters XR mode (This must be done within a user interaction in most browsers eg. button click)
     * @param sessionMode options for the XR session
     * @param referenceSpaceType frame of reference of the XR session
     * @param renderTarget the output canvas that will be used to enter XR mode
     * @param sessionCreationOptions optional XRSessionInit object to init the session with
     * @returns promise that resolves after xr mode has entered
     */ async enterXRAsync(sessionMode, referenceSpaceType, renderTarget = this.sessionManager.getWebXRRenderTarget(), sessionCreationOptions = {}) {
        if (!this._supported) // eslint-disable-next-line no-throw-literal
        throw "WebXR not supported in this browser or environment";
        this._setState((0, $jknux.WebXRState).ENTERING_XR);
        if (referenceSpaceType !== "viewer" && referenceSpaceType !== "local") {
            sessionCreationOptions.optionalFeatures = sessionCreationOptions.optionalFeatures || [];
            sessionCreationOptions.optionalFeatures.push(referenceSpaceType);
        }
        sessionCreationOptions = await this.featuresManager._extendXRSessionInitObject(sessionCreationOptions);
        // we currently recommend "unbounded" space in AR (#7959)
        if (sessionMode === "immersive-ar" && referenceSpaceType !== "unbounded") (0, $kVtWi.Logger).Warn("We recommend using 'unbounded' reference space type when using 'immersive-ar' session mode");
        // make sure that the session mode is supported
        try {
            await this.sessionManager.initializeSessionAsync(sessionMode, sessionCreationOptions);
            await this.sessionManager.setReferenceSpaceTypeAsync(referenceSpaceType);
            const xrRenderState = {
                // if maxZ is 0 it should be "Infinity", but it doesn't work with the WebXR API. Setting to a large number.
                depthFar: this.camera.maxZ || 10000,
                depthNear: this.camera.minZ
            };
            // The layers feature will have already initialized the xr session's layers on session init.
            if (!this.featuresManager.getEnabledFeature((0, $cJN7d.WebXRFeatureName).LAYERS)) {
                const baseLayer = await renderTarget.initializeXRLayerAsync(this.sessionManager.session);
                xrRenderState.baseLayer = baseLayer;
            }
            this.sessionManager.updateRenderState(xrRenderState);
            // run the render loop
            this.sessionManager.runXRRenderLoop();
            // Cache pre xr scene settings
            this._originalSceneAutoClear = this._scene.autoClear;
            this._nonVRCamera = this._scene.activeCamera;
            this._attachedToElement = !!this._nonVRCamera?.inputs?.attachedToElement;
            this._nonVRCamera?.detachControl();
            this._scene.activeCamera = this.camera;
            // do not compensate when AR session is used
            if (sessionMode !== "immersive-ar") this._nonXRToXRCamera();
            else {
                // Kept here, TODO - check if needed
                this._scene.autoClear = false;
                this.camera.compensateOnFirstFrame = false;
                // reset the camera's position to the origin
                this.camera.position.set(0, 0, 0);
                this.camera.rotationQuaternion.set(0, 0, 0, 1);
                this.onInitialXRPoseSetObservable.notifyObservers(this.camera);
            }
            this.sessionManager.onXRSessionEnded.addOnce(()=>{
                // when using the back button and not the exit button (default on mobile), the session is ending but the EXITING state was not set
                if (this.state !== (0, $jknux.WebXRState).EXITING_XR) this._setState((0, $jknux.WebXRState).EXITING_XR);
                // Reset camera rigs output render target to ensure sessions render target is not drawn after it ends
                this.camera.rigCameras.forEach((c)=>{
                    c.outputRenderTarget = null;
                });
                // Restore scene settings
                this._scene.autoClear = this._originalSceneAutoClear;
                this._scene.activeCamera = this._nonVRCamera;
                if (this._attachedToElement && this._nonVRCamera) this._nonVRCamera.attachControl(!!this._nonVRCamera.inputs.noPreventDefault);
                if (sessionMode !== "immersive-ar" && this.camera.compensateOnFirstFrame) {
                    if (this._nonVRCamera.setPosition) this._nonVRCamera.setPosition(this.camera.position);
                    else this._nonVRCamera.position.copyFrom(this.camera.position);
                }
                this._setState((0, $jknux.WebXRState).NOT_IN_XR);
            });
            // Wait until the first frame arrives before setting state to in xr
            this.sessionManager.onXRFrameObservable.addOnce(()=>{
                this._setState((0, $jknux.WebXRState).IN_XR);
            });
            return this.sessionManager;
        } catch (e) {
            (0, $kVtWi.Logger).Log(e);
            (0, $kVtWi.Logger).Log(e.message);
            this._setState((0, $jknux.WebXRState).NOT_IN_XR);
            throw e;
        }
    }
    /**
     * Exits XR mode and returns the scene to its original state
     * @returns promise that resolves after xr mode has exited
     */ exitXRAsync() {
        // only exit if state is IN_XR
        if (this.state !== (0, $jknux.WebXRState).IN_XR) return Promise.resolve();
        this._setState((0, $jknux.WebXRState).EXITING_XR);
        return this.sessionManager.exitXRAsync();
    }
    /**
     * Enable spectator mode for desktop VR experiences.
     * When spectator mode is enabled a camera will be attached to the desktop canvas and will
     * display the first rig camera's view on the desktop canvas.
     * Please note that this will degrade performance, as it requires another camera render.
     * It is also not recommended to enable this in devices like the quest, as it brings no benefit there.
     * @param options giving WebXRSpectatorModeOption for specutator camera to setup when the spectator mode is enabled.
     */ enableSpectatorMode(options) {
        if (!this._spectatorMode) {
            this._spectatorMode = true;
            this._switchSpectatorMode(options);
        }
    }
    /**
     * Disable spectator mode for desktop VR experiences.
     */ disableSpecatatorMode() {
        if (this._spectatorMode) {
            this._spectatorMode = false;
            this._switchSpectatorMode();
        }
    }
    _switchSpectatorMode(options) {
        const fps = options?.fps ? options.fps : 1000.0;
        const refreshRate = 1.0 / fps * 1000.0;
        const cameraIndex = options?.preferredCameraIndex ? options?.preferredCameraIndex : 0;
        const updateSpectatorCamera = ()=>{
            if (this._spectatorCamera) {
                const delta = this.sessionManager.currentTimestamp - this._lastTimestamp;
                if (delta >= refreshRate) {
                    this._lastTimestamp = this.sessionManager.currentTimestamp;
                    this._spectatorCamera.position.copyFrom(this.camera.rigCameras[cameraIndex].globalPosition);
                    this._spectatorCamera.rotationQuaternion.copyFrom(this.camera.rigCameras[cameraIndex].absoluteRotation);
                }
            }
        };
        if (this._spectatorMode) {
            if (cameraIndex >= this.camera.rigCameras.length) throw new Error("the preferred camera index is beyond the length of rig camera array.");
            const onStateChanged = ()=>{
                if (this.state === (0, $jknux.WebXRState).IN_XR) {
                    this._spectatorCamera = new (0, $765rp.UniversalCamera)("webxr-spectator", (0, $ha1VO.Vector3).Zero(), this._scene);
                    this._spectatorCamera.rotationQuaternion = new (0, $ha1VO.Quaternion)();
                    this._scene.activeCameras = [
                        this.camera,
                        this._spectatorCamera
                    ];
                    this.sessionManager.onXRFrameObservable.add(updateSpectatorCamera);
                    this._scene.onAfterRenderCameraObservable.add((camera)=>{
                        if (camera === this.camera) // reset the dimensions object for correct resizing
                        this._scene.getEngine().framebufferDimensionsObject = null;
                    });
                } else if (this.state === (0, $jknux.WebXRState).EXITING_XR) {
                    this.sessionManager.onXRFrameObservable.removeCallback(updateSpectatorCamera);
                    this._scene.activeCameras = null;
                }
            };
            this.onStateChangedObservable.add(onStateChanged);
            onStateChanged();
        } else {
            this.sessionManager.onXRFrameObservable.removeCallback(updateSpectatorCamera);
            this._scene.activeCameras = [
                this.camera
            ];
        }
    }
    _nonXRToXRCamera() {
        this.camera.setTransformationFromNonVRCamera(this._nonVRCamera);
        this.onInitialXRPoseSetObservable.notifyObservers(this.camera);
    }
    _setState(val) {
        if (this.state === val) return;
        this.state = val;
        this.onStateChangedObservable.notifyObservers(this.state);
    }
}

});
parcelRegister("UghGd", function(module, exports) {

$parcel$export(module.exports, "WebXRCamera", () => $0a91dcc59d4509b2$export$86fb17d55dd8466a);

var $ha1VO = parcelRequire("ha1VO");

var $74SKQ = parcelRequire("74SKQ");

var $gSOV5 = parcelRequire("gSOV5");

var $fJj0G = parcelRequire("fJj0G");

var $191mA = parcelRequire("191mA");

var $diGQf = parcelRequire("diGQf");

var $jknux = parcelRequire("jknux");
class $0a91dcc59d4509b2$export$86fb17d55dd8466a extends (0, $gSOV5.FreeCamera) {
    /**
     * Creates a new webXRCamera, this should only be set at the camera after it has been updated by the xrSessionManager
     * @param name the name of the camera
     * @param scene the scene to add the camera to
     * @param _xrSessionManager a constructed xr session manager
     */ constructor(name, scene, _xrSessionManager){
        super(name, (0, $ha1VO.Vector3).Zero(), scene);
        this._xrSessionManager = _xrSessionManager;
        this._firstFrame = false;
        this._referenceQuaternion = (0, $ha1VO.Quaternion).Identity();
        this._referencedPosition = new (0, $ha1VO.Vector3)();
        this._trackingState = (0, $jknux.WebXRTrackingState).NOT_TRACKING;
        /**
         * This will be triggered after the first XR Frame initialized the camera,
         * including the right number of views and their rendering parameters
         */ this.onXRCameraInitializedObservable = new (0, $diGQf.Observable)();
        /**
         * Observable raised before camera teleportation
         * @deprecated use onBeforeCameraTeleport of the teleportation feature instead
         */ this.onBeforeCameraTeleport = new (0, $diGQf.Observable)();
        /**
         *  Observable raised after camera teleportation
         * @deprecated use onAfterCameraTeleport of the teleportation feature instead
         */ this.onAfterCameraTeleport = new (0, $diGQf.Observable)();
        /**
         * Notifies when the camera's tracking state has changed.
         * Notice - will also be triggered when tracking has started (at the beginning of the session)
         */ this.onTrackingStateChanged = new (0, $diGQf.Observable)();
        /**
         * Should position compensation execute on first frame.
         * This is used when copying the position from a native (non XR) camera
         */ this.compensateOnFirstFrame = true;
        this._rotate180 = new (0, $ha1VO.Quaternion)(0, 1, 0, 0);
        // Initial camera configuration
        this.minZ = 0.1;
        this.rotationQuaternion = new (0, $ha1VO.Quaternion)();
        this.cameraRigMode = (0, $74SKQ.Camera).RIG_MODE_CUSTOM;
        this.updateUpVectorFromRotation = true;
        this._updateNumberOfRigCameras(1);
        // freeze projection matrix, which will be copied later
        this.freezeProjectionMatrix();
        this._deferOnly = true;
        this._xrSessionManager.onXRSessionInit.add(()=>{
            this._referencedPosition.copyFromFloats(0, 0, 0);
            this._referenceQuaternion.copyFromFloats(0, 0, 0, 1);
            // first frame - camera's y position should be 0 for the correct offset
            this._firstFrame = this.compensateOnFirstFrame;
            this._xrSessionManager.onWorldScaleFactorChangedObservable.add(()=>{
                // only run if in session
                if (!this._xrSessionManager.currentFrame) return;
                this._updateDepthNearFar();
            });
        });
        // Check transformation changes on each frame. Callback is added to be first so that the transformation will be
        // applied to the rest of the elements using the referenceSpace object
        this._xrSessionManager.onXRFrameObservable.add(()=>{
            if (this._firstFrame) this._updateFromXRSession();
            if (this.onXRCameraInitializedObservable.hasObservers()) {
                this.onXRCameraInitializedObservable.notifyObservers(this);
                this.onXRCameraInitializedObservable.clear();
            }
            if (this._deferredUpdated) {
                this.position.copyFrom(this._deferredPositionUpdate);
                this.rotationQuaternion.copyFrom(this._deferredRotationQuaternionUpdate);
            }
            this._updateReferenceSpace();
            this._updateFromXRSession();
        }, undefined, true);
    }
    /**
     * Get the current XR tracking state of the camera
     */ get trackingState() {
        return this._trackingState;
    }
    _setTrackingState(newState) {
        if (this._trackingState !== newState) {
            this._trackingState = newState;
            this.onTrackingStateChanged.notifyObservers(newState);
        }
    }
    /**
     * Return the user's height, unrelated to the current ground.
     * This will be the y position of this camera, when ground level is 0.
     *
     * Note - this value is multiplied by the worldScalingFactor (if set), so it will be in the same units as the scene.
     */ get realWorldHeight() {
        const basePose = this._xrSessionManager.currentFrame && this._xrSessionManager.currentFrame.getViewerPose(this._xrSessionManager.baseReferenceSpace);
        if (basePose && basePose.transform) return basePose.transform.position.y * this._xrSessionManager.worldScalingFactor;
        else return 0;
    }
    /** @internal */ _updateForDualEyeDebugging() {
        // Create initial camera rigs
        this._updateNumberOfRigCameras(2);
        this.rigCameras[0].viewport = new (0, $191mA.Viewport)(0, 0, 0.5, 1.0);
        // this.rigCameras[0].position.x = -pupilDistance / 2;
        this.rigCameras[0].outputRenderTarget = null;
        this.rigCameras[1].viewport = new (0, $191mA.Viewport)(0.5, 0, 0.5, 1.0);
        // this.rigCameras[1].position.x = pupilDistance / 2;
        this.rigCameras[1].outputRenderTarget = null;
    }
    /**
     * Sets this camera's transformation based on a non-vr camera
     * @param otherCamera the non-vr camera to copy the transformation from
     * @param resetToBaseReferenceSpace should XR reset to the base reference space
     */ setTransformationFromNonVRCamera(otherCamera = this.getScene().activeCamera, resetToBaseReferenceSpace = true) {
        if (!otherCamera || otherCamera === this) return;
        const mat = otherCamera.computeWorldMatrix();
        mat.decompose(undefined, this.rotationQuaternion, this.position);
        // set the ground level
        this.position.y = 0;
        (0, $ha1VO.Quaternion).FromEulerAnglesToRef(0, this.rotationQuaternion.toEulerAngles().y, 0, this.rotationQuaternion);
        this._firstFrame = true;
        if (resetToBaseReferenceSpace) this._xrSessionManager.resetReferenceSpace();
    }
    /**
     * Gets the current instance class name ("WebXRCamera").
     * @returns the class name
     */ getClassName() {
        return "WebXRCamera";
    }
    /**
     * Set the target for the camera to look at.
     * Note that this only rotates around the Y axis, as opposed to the default behavior of other cameras
     * @param target the target to set the camera to look at
     */ setTarget(target) {
        // only rotate around the y axis!
        const tmpVector = (0, $ha1VO.TmpVectors).Vector3[1];
        target.subtractToRef(this.position, tmpVector);
        tmpVector.y = 0;
        tmpVector.normalize();
        const yRotation = Math.atan2(tmpVector.x, tmpVector.z);
        this.rotationQuaternion.toEulerAnglesToRef(tmpVector);
        (0, $ha1VO.Quaternion).FromEulerAnglesToRef(tmpVector.x, yRotation, tmpVector.z, this.rotationQuaternion);
    }
    dispose() {
        super.dispose();
        this._lastXRViewerPose = undefined;
    }
    _updateDepthNearFar() {
        const far = (this.maxZ || 10000) * this._xrSessionManager.worldScalingFactor;
        const xrRenderState = {
            // if maxZ is 0 it should be "Infinity", but it doesn't work with the WebXR API. Setting to a large number.
            depthFar: far,
            depthNear: this.minZ
        };
        this._xrSessionManager.updateRenderState(xrRenderState);
        this._cache.minZ = this.minZ;
        this._cache.maxZ = far;
    }
    _updateFromXRSession() {
        const pose = this._xrSessionManager.currentFrame && this._xrSessionManager.currentFrame.getViewerPose(this._xrSessionManager.referenceSpace);
        this._lastXRViewerPose = pose || undefined;
        if (!pose) {
            this._setTrackingState((0, $jknux.WebXRTrackingState).NOT_TRACKING);
            return;
        }
        // Set the tracking state. if it didn't change it is a no-op
        const trackingState = pose.emulatedPosition ? (0, $jknux.WebXRTrackingState).TRACKING_LOST : (0, $jknux.WebXRTrackingState).TRACKING;
        this._setTrackingState(trackingState);
        // check min/max Z and update if not the same as in cache
        if (this.minZ !== this._cache.minZ || this.maxZ !== this._cache.maxZ) this._updateDepthNearFar();
        if (pose.transform) {
            const orientation = pose.transform.orientation;
            if (pose.transform.orientation.x === undefined) // Babylon native polyfill can return an undefined orientation value
            // When not initialized
            return;
            const pos = pose.transform.position;
            this._referencedPosition.set(pos.x, pos.y, pos.z).scaleInPlace(this._xrSessionManager.worldScalingFactor);
            this._referenceQuaternion.set(orientation.x, orientation.y, orientation.z, orientation.w);
            if (!this._scene.useRightHandedSystem) {
                this._referencedPosition.z *= -1;
                this._referenceQuaternion.z *= -1;
                this._referenceQuaternion.w *= -1;
            }
            if (this._firstFrame) {
                this._firstFrame = false;
                // we have the XR reference, now use this to find the offset to get the camera to be
                // in the right position
                // set the height to correlate to the current height
                this.position.y += this._referencedPosition.y;
                // avoid using the head rotation on the first frame.
                this._referenceQuaternion.copyFromFloats(0, 0, 0, 1);
            } else {
                // update position and rotation as reference
                this.rotationQuaternion.copyFrom(this._referenceQuaternion);
                this.position.copyFrom(this._referencedPosition);
            }
        }
        // Update camera rigs
        if (this.rigCameras.length !== pose.views.length) this._updateNumberOfRigCameras(pose.views.length);
        pose.views.forEach((view, i)=>{
            const currentRig = this.rigCameras[i];
            // update right and left, where applicable
            if (!currentRig.isLeftCamera && !currentRig.isRightCamera) {
                if (view.eye === "right") currentRig._isRightCamera = true;
                else if (view.eye === "left") currentRig._isLeftCamera = true;
            }
            // add any custom render targets to this camera, if available in the scene
            const customRenderTargets = this.getScene().customRenderTargets;
            // use a for loop
            for(let i = 0; i < customRenderTargets.length; i++){
                const rt = customRenderTargets[i];
                // make sure we don't add the same render target twice
                if (currentRig.customRenderTargets.indexOf(rt) === -1) currentRig.customRenderTargets.push(rt);
            }
            // Update view/projection matrix
            const pos = view.transform.position;
            const orientation = view.transform.orientation;
            currentRig.parent = this.parent;
            currentRig.position.set(pos.x, pos.y, pos.z).scaleInPlace(this._xrSessionManager.worldScalingFactor);
            currentRig.rotationQuaternion.set(orientation.x, orientation.y, orientation.z, orientation.w);
            if (!this._scene.useRightHandedSystem) {
                currentRig.position.z *= -1;
                currentRig.rotationQuaternion.z *= -1;
                currentRig.rotationQuaternion.w *= -1;
            } else currentRig.rotationQuaternion.multiplyInPlace(this._rotate180);
            (0, $ha1VO.Matrix).FromFloat32ArrayToRefScaled(view.projectionMatrix, 0, 1, currentRig._projectionMatrix);
            if (!this._scene.useRightHandedSystem) currentRig._projectionMatrix.toggleProjectionMatrixHandInPlace();
            // first camera?
            if (i === 0) this._projectionMatrix.copyFrom(currentRig._projectionMatrix);
            const renderTargetTexture = this._xrSessionManager.getRenderTargetTextureForView(view);
            this._renderingMultiview = renderTargetTexture?._texture?.isMultiview || false;
            if (this._renderingMultiview) // For multiview, the render target texture is the same per-view (just the slice index is different),
            // so we only need to set the output render target once for the rig parent.
            {
                if (i == 0) {
                    this._xrSessionManager.trySetViewportForView(this.viewport, view);
                    this.outputRenderTarget = renderTargetTexture;
                }
            } else {
                // Update viewport
                this._xrSessionManager.trySetViewportForView(currentRig.viewport, view);
                // Set cameras to render to the session's render target
                currentRig.outputRenderTarget = renderTargetTexture || this._xrSessionManager.getRenderTargetTextureForView(view);
            }
            // Replicate parent rig camera behavior
            currentRig.layerMask = this.layerMask;
        });
    }
    _updateNumberOfRigCameras(viewCount = 1) {
        while(this.rigCameras.length < viewCount){
            const newCamera = new (0, $fJj0G.TargetCamera)("XR-RigCamera: " + this.rigCameras.length, (0, $ha1VO.Vector3).Zero(), this.getScene());
            newCamera.minZ = 0.1;
            newCamera.rotationQuaternion = new (0, $ha1VO.Quaternion)();
            newCamera.updateUpVectorFromRotation = true;
            newCamera.isRigCamera = true;
            newCamera.rigParent = this;
            // do not compute projection matrix, provided by XR
            newCamera.freezeProjectionMatrix();
            this.rigCameras.push(newCamera);
        }
        while(this.rigCameras.length > viewCount){
            const removedCamera = this.rigCameras.pop();
            if (removedCamera) removedCamera.dispose();
        }
    }
    _updateReferenceSpace() {
        // were position & rotation updated OUTSIDE of the xr update loop
        if (!this.position.equals(this._referencedPosition) || !this.rotationQuaternion.equals(this._referenceQuaternion)) {
            const referencedMat = (0, $ha1VO.TmpVectors).Matrix[0];
            const poseMat = (0, $ha1VO.TmpVectors).Matrix[1];
            const transformMat = (0, $ha1VO.TmpVectors).Matrix[2];
            (0, $ha1VO.Matrix).ComposeToRef($0a91dcc59d4509b2$export$86fb17d55dd8466a._ScaleReadOnly, this._referenceQuaternion, this._referencedPosition, referencedMat);
            (0, $ha1VO.Matrix).ComposeToRef($0a91dcc59d4509b2$export$86fb17d55dd8466a._ScaleReadOnly, this.rotationQuaternion, this.position, poseMat);
            referencedMat.invert().multiplyToRef(poseMat, transformMat);
            transformMat.invert();
            if (!this._scene.useRightHandedSystem) transformMat.toggleModelMatrixHandInPlace();
            transformMat.decompose(undefined, this._referenceQuaternion, this._referencedPosition);
            const transform = new XRRigidTransform({
                x: this._referencedPosition.x / this._xrSessionManager.worldScalingFactor,
                y: this._referencedPosition.y / this._xrSessionManager.worldScalingFactor,
                z: this._referencedPosition.z / this._xrSessionManager.worldScalingFactor
            }, {
                x: this._referenceQuaternion.x,
                y: this._referenceQuaternion.y,
                z: this._referenceQuaternion.z,
                w: this._referenceQuaternion.w
            });
            this._xrSessionManager.referenceSpace = this._xrSessionManager.referenceSpace.getOffsetReferenceSpace(transform);
        }
    }
}
$0a91dcc59d4509b2$export$86fb17d55dd8466a._ScaleReadOnly = (0, $ha1VO.Vector3).One();

});


parcelRegister("9zzya", function(module, exports) {

$parcel$export(module.exports, "WebXRInput", () => $6f82f5739db7dc99$export$d205b4b212f75321);

var $diGQf = parcelRequire("diGQf");

var $6KWAu = parcelRequire("6KWAu");

var $ebuqW = parcelRequire("ebuqW");
class $6f82f5739db7dc99$export$d205b4b212f75321 {
    /**
     * Initializes the WebXRInput
     * @param xrSessionManager the xr session manager for this session
     * @param xrCamera the WebXR camera for this session. Mainly used for teleportation
     * @param _options = initialization options for this xr input
     */ constructor(/**
     * the xr session manager for this session
     */ xrSessionManager, /**
     * the WebXR camera for this session. Mainly used for teleportation
     */ xrCamera, _options = {}){
        this.xrSessionManager = xrSessionManager;
        this.xrCamera = xrCamera;
        this._options = _options;
        /**
         * XR controllers being tracked
         */ this.controllers = [];
        /**
         * Event when a controller has been connected/added
         */ this.onControllerAddedObservable = new (0, $diGQf.Observable)();
        /**
         * Event when a controller has been removed/disconnected
         */ this.onControllerRemovedObservable = new (0, $diGQf.Observable)();
        this._onInputSourcesChange = (event)=>{
            this._addAndRemoveControllers(event.added, event.removed);
        };
        // Remove controllers when exiting XR
        this._sessionEndedObserver = this.xrSessionManager.onXRSessionEnded.add(()=>{
            this._addAndRemoveControllers([], this.controllers.map((c)=>{
                return c.inputSource;
            }));
        });
        this._sessionInitObserver = this.xrSessionManager.onXRSessionInit.add((session)=>{
            session.addEventListener("inputsourceschange", this._onInputSourcesChange);
        });
        this._frameObserver = this.xrSessionManager.onXRFrameObservable.add((frame)=>{
            // Update controller pose info
            this.controllers.forEach((controller)=>{
                controller.updateFromXRFrame(frame, this.xrSessionManager.referenceSpace, this.xrCamera, this.xrSessionManager);
            });
        });
        if (this._options.customControllersRepositoryURL) (0, $ebuqW.WebXRMotionControllerManager).BaseRepositoryUrl = this._options.customControllersRepositoryURL;
        (0, $ebuqW.WebXRMotionControllerManager).UseOnlineRepository = !this._options.disableOnlineControllerRepository;
        if ((0, $ebuqW.WebXRMotionControllerManager).UseOnlineRepository) // pre-load the profiles list to load the controllers quicker afterwards
        try {
            (0, $ebuqW.WebXRMotionControllerManager).UpdateProfilesList().catch(()=>{
                (0, $ebuqW.WebXRMotionControllerManager).UseOnlineRepository = false;
            });
        } catch (e) {
            (0, $ebuqW.WebXRMotionControllerManager).UseOnlineRepository = false;
        }
    }
    _addAndRemoveControllers(addInputs, removeInputs) {
        // Add controllers if they don't already exist
        const sources = this.controllers.map((c)=>{
            return c.inputSource;
        });
        for (const input of addInputs)if (sources.indexOf(input) === -1) {
            const controller = new (0, $6KWAu.WebXRInputSource)(this.xrSessionManager.scene, input, {
                ...this._options.controllerOptions || {},
                forceControllerProfile: this._options.forceInputProfile,
                doNotLoadControllerMesh: this._options.doNotLoadControllerMeshes,
                disableMotionControllerAnimation: this._options.disableControllerAnimation
            });
            this.controllers.push(controller);
            this.onControllerAddedObservable.notifyObservers(controller);
        }
        // Remove and dispose of controllers to be disposed
        const keepControllers = [];
        const removedControllers = [];
        this.controllers.forEach((c)=>{
            if (removeInputs.indexOf(c.inputSource) === -1) keepControllers.push(c);
            else removedControllers.push(c);
        });
        this.controllers = keepControllers;
        removedControllers.forEach((c)=>{
            this.onControllerRemovedObservable.notifyObservers(c);
            c.dispose();
        });
    }
    /**
     * Disposes of the object
     */ dispose() {
        this.controllers.forEach((c)=>{
            c.dispose();
        });
        this.xrSessionManager.onXRFrameObservable.remove(this._frameObserver);
        this.xrSessionManager.onXRSessionInit.remove(this._sessionInitObserver);
        this.xrSessionManager.onXRSessionEnded.remove(this._sessionEndedObserver);
        this.onControllerAddedObservable.clear();
        this.onControllerRemovedObservable.clear();
        // clear the controller cache
        (0, $ebuqW.WebXRMotionControllerManager).ClearControllerCache();
    }
}

});
parcelRegister("6KWAu", function(module, exports) {

$parcel$export(module.exports, "WebXRInputSource", () => $4eb47c3f122a0059$export$7f9d92918929760b);

var $diGQf = parcelRequire("diGQf");

var $0cHNL = parcelRequire("0cHNL");

var $ha1VO = parcelRequire("ha1VO");

var $ebuqW = parcelRequire("ebuqW");

var $bOhSV = parcelRequire("bOhSV");
let $4eb47c3f122a0059$var$idCount = 0;
class $4eb47c3f122a0059$export$7f9d92918929760b {
    /**
     * Creates the input source object
     * @see https://doc.babylonjs.com/features/featuresDeepDive/webXR/webXRInputControllerSupport
     * @param _scene the scene which the controller should be associated to
     * @param inputSource the underlying input source for the controller
     * @param _options options for this controller creation
     */ constructor(_scene, /** The underlying input source for the controller  */ inputSource, _options = {}){
        this._scene = _scene;
        this.inputSource = inputSource;
        this._options = _options;
        this._tmpVector = new (0, $ha1VO.Vector3)();
        this._disposed = false;
        /**
         * Event that fires when the controller is removed/disposed.
         * The object provided as event data is this controller, after associated assets were disposed.
         * uniqueId is still available.
         */ this.onDisposeObservable = new (0, $diGQf.Observable)();
        /**
         * Will be triggered when the mesh associated with the motion controller is done loading.
         * It is also possible that this will never trigger (!) if no mesh was loaded, or if the developer decides to load a different mesh
         * A shortened version of controller -> motion controller -> on mesh loaded.
         */ this.onMeshLoadedObservable = new (0, $diGQf.Observable)();
        /**
         * Observers registered here will trigger when a motion controller profile was assigned to this xr controller
         */ this.onMotionControllerInitObservable = new (0, $diGQf.Observable)();
        this._uniqueId = `controller-${$4eb47c3f122a0059$var$idCount++}-${inputSource.targetRayMode}-${inputSource.handedness}`;
        this.pointer = new (0, $0cHNL.AbstractMesh)(`${this._uniqueId}-pointer`, _scene);
        this.pointer.rotationQuaternion = new (0, $ha1VO.Quaternion)();
        if (this.inputSource.gripSpace) {
            this.grip = new (0, $0cHNL.AbstractMesh)(`${this._uniqueId}-grip`, this._scene);
            this.grip.rotationQuaternion = new (0, $ha1VO.Quaternion)();
        }
        this._tmpVector.set(0, 0, this._scene.useRightHandedSystem ? -1 : 1.0);
        // for now only load motion controllers if gamepad object available
        if (this.inputSource.gamepad && this.inputSource.targetRayMode === "tracked-pointer") (0, $ebuqW.WebXRMotionControllerManager).GetMotionControllerWithXRInput(inputSource, _scene, this._options.forceControllerProfile).then((motionController)=>{
            this.motionController = motionController;
            this.onMotionControllerInitObservable.notifyObservers(motionController);
            // should the model be loaded?
            if (!this._options.doNotLoadControllerMesh && !this.motionController._doNotLoadControllerMesh) this.motionController.loadModel().then((success)=>{
                if (success && this.motionController && this.motionController.rootMesh) {
                    if (this._options.renderingGroupId) {
                        // anything other than 0?
                        this.motionController.rootMesh.renderingGroupId = this._options.renderingGroupId;
                        this.motionController.rootMesh.getChildMeshes(false).forEach((mesh)=>mesh.renderingGroupId = this._options.renderingGroupId);
                    }
                    this.onMeshLoadedObservable.notifyObservers(this.motionController.rootMesh);
                    this.motionController.rootMesh.parent = this.grip || this.pointer;
                    this.motionController.disableAnimation = !!this._options.disableMotionControllerAnimation;
                }
                // make sure to dispose is the controller is already disposed
                if (this._disposed) this.motionController?.dispose();
            });
        }, ()=>{
            (0, $bOhSV.Tools).Warn(`Could not find a matching motion controller for the registered input source`);
        });
    }
    /**
     * Get this controllers unique id
     */ get uniqueId() {
        return this._uniqueId;
    }
    /**
     * Disposes of the object
     */ dispose() {
        if (this.grip) this.grip.dispose(true);
        if (this.motionController) this.motionController.dispose();
        this.pointer.dispose(true);
        this.onMotionControllerInitObservable.clear();
        this.onMeshLoadedObservable.clear();
        this.onDisposeObservable.notifyObservers(this);
        this.onDisposeObservable.clear();
        this._disposed = true;
    }
    /**
     * Gets a world space ray coming from the pointer or grip
     * @param result the resulting ray
     * @param gripIfAvailable use the grip mesh instead of the pointer, if available
     */ getWorldPointerRayToRef(result, gripIfAvailable = false) {
        const object = gripIfAvailable && this.grip ? this.grip : this.pointer;
        (0, $ha1VO.Vector3).TransformNormalToRef(this._tmpVector, object.getWorldMatrix(), result.direction);
        result.direction.normalize();
        result.origin.copyFrom(object.absolutePosition);
        result.length = 1000;
    }
    /**
     * Updates the controller pose based on the given XRFrame
     * @param xrFrame xr frame to update the pose with
     * @param referenceSpace reference space to use
     * @param xrCamera the xr camera, used for parenting
     * @param xrSessionManager the session manager used to get the world reference system
     */ updateFromXRFrame(xrFrame, referenceSpace, xrCamera, xrSessionManager) {
        const pose = xrFrame.getPose(this.inputSource.targetRaySpace, referenceSpace);
        this._lastXRPose = pose;
        // Update the pointer mesh
        if (pose) {
            const pos = pose.transform.position;
            this.pointer.position.set(pos.x, pos.y, pos.z).scaleInPlace(xrSessionManager.worldScalingFactor);
            const orientation = pose.transform.orientation;
            this.pointer.rotationQuaternion.set(orientation.x, orientation.y, orientation.z, orientation.w);
            if (!this._scene.useRightHandedSystem) {
                this.pointer.position.z *= -1;
                this.pointer.rotationQuaternion.z *= -1;
                this.pointer.rotationQuaternion.w *= -1;
            }
            this.pointer.parent = xrCamera.parent;
            this.pointer.scaling.setAll(xrSessionManager.worldScalingFactor);
        }
        // Update the grip mesh if it exists
        if (this.inputSource.gripSpace && this.grip) {
            const pose = xrFrame.getPose(this.inputSource.gripSpace, referenceSpace);
            if (pose) {
                const pos = pose.transform.position;
                const orientation = pose.transform.orientation;
                this.grip.position.set(pos.x, pos.y, pos.z).scaleInPlace(xrSessionManager.worldScalingFactor);
                this.grip.rotationQuaternion.set(orientation.x, orientation.y, orientation.z, orientation.w);
                if (!this._scene.useRightHandedSystem) {
                    this.grip.position.z *= -1;
                    this.grip.rotationQuaternion.z *= -1;
                    this.grip.rotationQuaternion.w *= -1;
                }
            }
            this.grip.parent = xrCamera.parent;
            this.grip.scaling.setAll(xrSessionManager.worldScalingFactor);
        }
        if (this.motionController) // either update buttons only or also position, if in gamepad mode
        this.motionController.updateFromXRFrame(xrFrame);
    }
}

});
parcelRegister("ebuqW", function(module, exports) {

$parcel$export(module.exports, "WebXRMotionControllerManager", () => $a539b340523f843a$export$6bd26113fa422c0f);

var $ho0hq = parcelRequire("ho0hq");

var $bOhSV = parcelRequire("bOhSV");

var $xXlMh = parcelRequire("xXlMh");
/**
 * The MotionController Manager manages all registered motion controllers and loads the right one when needed.
 *
 * When this repository is complete: https://github.com/immersive-web/webxr-input-profiles/tree/master/packages/assets
 * it should be replaced with auto-loaded controllers.
 *
 * When using a model try to stay as generic as possible. Eventually there will be no need in any of the controller classes
 */ const $a539b340523f843a$var$controllerCache = [];
class $a539b340523f843a$export$6bd26113fa422c0f {
    /**
     * Clear the cache used for profile loading and reload when requested again
     */ static ClearProfilesCache() {
        this._ProfilesList = null;
        this._ProfileLoadingPromises = {};
    }
    /**
     * Register the default fallbacks.
     * This function is called automatically when this file is imported.
     */ static DefaultFallbacks() {
        this.RegisterFallbacksForProfileId("google-daydream", [
            "generic-touchpad"
        ]);
        this.RegisterFallbacksForProfileId("htc-vive-focus", [
            "generic-trigger-touchpad"
        ]);
        this.RegisterFallbacksForProfileId("htc-vive", [
            "generic-trigger-squeeze-touchpad"
        ]);
        this.RegisterFallbacksForProfileId("magicleap-one", [
            "generic-trigger-squeeze-touchpad"
        ]);
        this.RegisterFallbacksForProfileId("windows-mixed-reality", [
            "generic-trigger-squeeze-touchpad-thumbstick"
        ]);
        this.RegisterFallbacksForProfileId("microsoft-mixed-reality", [
            "windows-mixed-reality",
            "generic-trigger-squeeze-touchpad-thumbstick"
        ]);
        this.RegisterFallbacksForProfileId("oculus-go", [
            "generic-trigger-touchpad"
        ]);
        this.RegisterFallbacksForProfileId("oculus-touch-v2", [
            "oculus-touch",
            "generic-trigger-squeeze-thumbstick"
        ]);
        this.RegisterFallbacksForProfileId("oculus-touch", [
            "generic-trigger-squeeze-thumbstick"
        ]);
        this.RegisterFallbacksForProfileId("samsung-gearvr", [
            "windows-mixed-reality",
            "generic-trigger-squeeze-touchpad-thumbstick"
        ]);
        this.RegisterFallbacksForProfileId("samsung-odyssey", [
            "generic-touchpad"
        ]);
        this.RegisterFallbacksForProfileId("valve-index", [
            "generic-trigger-squeeze-touchpad-thumbstick"
        ]);
        this.RegisterFallbacksForProfileId("generic-hand-select", [
            "generic-trigger"
        ]);
    }
    /**
     * Find a fallback profile if the profile was not found. There are a few predefined generic profiles.
     * @param profileId the profile to which a fallback needs to be found
     * @returns an array with corresponding fallback profiles
     */ static FindFallbackWithProfileId(profileId) {
        const returnArray = this._Fallbacks[profileId] || [];
        returnArray.unshift(profileId);
        return returnArray;
    }
    /**
     * When acquiring a new xrInput object (usually by the WebXRInput class), match it with the correct profile.
     * The order of search:
     *
     * 1) Iterate the profiles array of the xr input and try finding a corresponding motion controller
     * 2) (If not found) search in the gamepad id and try using it (legacy versions only)
     * 3) search for registered fallbacks (should be redundant, nonetheless it makes sense to check)
     * 4) return the generic trigger controller if none were found
     *
     * @param xrInput the xrInput to which a new controller is initialized
     * @param scene the scene to which the model will be added
     * @param forceProfile force a certain profile for this controller
     * @returns A promise that fulfils with the motion controller class for this profile id or the generic standard class if none was found
     */ static GetMotionControllerWithXRInput(xrInput, scene, forceProfile) {
        const profileArray = [];
        if (forceProfile) profileArray.push(forceProfile);
        profileArray.push(...xrInput.profiles || []);
        // emulator support
        if (profileArray.length && !profileArray[0]) // remove the first "undefined" that the emulator is adding
        profileArray.pop();
        // legacy support - try using the gamepad id
        if (xrInput.gamepad && xrInput.gamepad.id) switch(xrInput.gamepad.id){
            case xrInput.gamepad.id.match(/oculus touch/gi) ? xrInput.gamepad.id : undefined:
                // oculus in gamepad id
                profileArray.push("oculus-touch-v2");
                break;
        }
        // make sure microsoft/windows mixed reality works correctly
        const windowsMRIdx = profileArray.indexOf("windows-mixed-reality");
        if (windowsMRIdx !== -1) profileArray.splice(windowsMRIdx, 0, "microsoft-mixed-reality");
        if (!profileArray.length) profileArray.push("generic-trigger");
        if (this.UseOnlineRepository) {
            const firstFunction = this.PrioritizeOnlineRepository ? this._LoadProfileFromRepository : this._LoadProfilesFromAvailableControllers;
            const secondFunction = this.PrioritizeOnlineRepository ? this._LoadProfilesFromAvailableControllers : this._LoadProfileFromRepository;
            return firstFunction.call(this, profileArray, xrInput, scene).catch(()=>{
                return secondFunction.call(this, profileArray, xrInput, scene);
            });
        } else // use only available functions
        return this._LoadProfilesFromAvailableControllers(profileArray, xrInput, scene);
    }
    /**
     * Register a new controller based on its profile. This function will be called by the controller classes themselves.
     *
     * If you are missing a profile, make sure it is imported in your source, otherwise it will not register.
     *
     * @param type the profile type to register
     * @param constructFunction the function to be called when loading this profile
     */ static RegisterController(type, constructFunction) {
        this._AvailableControllers[type] = constructFunction;
    }
    /**
     * Register a fallback to a specific profile.
     * @param profileId the profileId that will receive the fallbacks
     * @param fallbacks A list of fallback profiles
     */ static RegisterFallbacksForProfileId(profileId, fallbacks) {
        if (this._Fallbacks[profileId]) this._Fallbacks[profileId].push(...fallbacks);
        else this._Fallbacks[profileId] = fallbacks;
    }
    /**
     * Will update the list of profiles available in the repository
     * @returns a promise that resolves to a map of profiles available online
     */ static UpdateProfilesList() {
        this._ProfilesList = (0, $bOhSV.Tools).LoadFileAsync(this.BaseRepositoryUrl + "/profiles/profilesList.json", false).then((data)=>{
            return JSON.parse(data);
        });
        return this._ProfilesList;
    }
    /**
     * Clear the controller's cache (usually happens at the end of a session)
     */ static ClearControllerCache() {
        $a539b340523f843a$var$controllerCache.forEach((cacheItem)=>{
            cacheItem.meshes.forEach((mesh)=>{
                mesh.dispose(false, true);
            });
        });
        $a539b340523f843a$var$controllerCache.length = 0;
    }
    static _LoadProfileFromRepository(profileArray, xrInput, scene) {
        return Promise.resolve().then(()=>{
            if (!this._ProfilesList) return this.UpdateProfilesList();
            else return this._ProfilesList;
        }).then((profilesList)=>{
            // load the right profile
            for(let i = 0; i < profileArray.length; ++i){
                // defensive
                if (!profileArray[i]) continue;
                if (profilesList[profileArray[i]]) return profileArray[i];
            }
            throw new Error(`neither controller ${profileArray[0]} nor all fallbacks were found in the repository,`);
        }).then((profileToLoad)=>{
            // load the profile
            if (!this._ProfileLoadingPromises[profileToLoad]) this._ProfileLoadingPromises[profileToLoad] = (0, $bOhSV.Tools).LoadFileAsync(`${this.BaseRepositoryUrl}/profiles/${profileToLoad}/profile.json`, false).then((data)=>JSON.parse(data));
            return this._ProfileLoadingPromises[profileToLoad];
        }).then((profile)=>{
            return new (0, $xXlMh.WebXRProfiledMotionController)(scene, xrInput, profile, this.BaseRepositoryUrl, this.DisableControllerCache ? undefined : $a539b340523f843a$var$controllerCache);
        });
    }
    static _LoadProfilesFromAvailableControllers(profileArray, xrInput, scene) {
        // check fallbacks
        for(let i = 0; i < profileArray.length; ++i){
            // defensive
            if (!profileArray[i]) continue;
            const fallbacks = this.FindFallbackWithProfileId(profileArray[i]);
            for(let j = 0; j < fallbacks.length; ++j){
                const constructionFunction = this._AvailableControllers[fallbacks[j]];
                if (constructionFunction) return Promise.resolve(constructionFunction(xrInput, scene));
            }
        }
        throw new Error(`no controller requested was found in the available controllers list`);
    }
}
$a539b340523f843a$export$6bd26113fa422c0f._AvailableControllers = {};
$a539b340523f843a$export$6bd26113fa422c0f._Fallbacks = {};
// cache for loading
$a539b340523f843a$export$6bd26113fa422c0f._ProfileLoadingPromises = {};
/**
 * The base URL of the online controller repository. Can be changed at any time.
 */ $a539b340523f843a$export$6bd26113fa422c0f.BaseRepositoryUrl = "https://immersive-web.github.io/webxr-input-profiles/packages/viewer/dist";
/**
 * Which repository gets priority - local or online
 */ $a539b340523f843a$export$6bd26113fa422c0f.PrioritizeOnlineRepository = true;
/**
 * Use the online repository, or use only locally-defined controllers
 */ $a539b340523f843a$export$6bd26113fa422c0f.UseOnlineRepository = true;
/**
 * Disable the controller cache and load the models each time a new WebXRProfileMotionController is loaded.
 * Defaults to true.
 */ $a539b340523f843a$export$6bd26113fa422c0f.DisableControllerCache = true;
// register the generic profile(s) here so we will at least have them
$a539b340523f843a$export$6bd26113fa422c0f.RegisterController((0, $ho0hq.WebXRGenericTriggerMotionController).ProfileId, (xrInput, scene)=>{
    return new (0, $ho0hq.WebXRGenericTriggerMotionController)(scene, xrInput.gamepad, xrInput.handedness);
});
// register fallbacks
$a539b340523f843a$export$6bd26113fa422c0f.DefaultFallbacks();

});
parcelRegister("ho0hq", function(module, exports) {

$parcel$export(module.exports, "WebXRGenericTriggerMotionController", () => $ca84e529ddef1ae9$export$41c5b3d29c6728c1);

var $d2047 = parcelRequire("d2047");

var $fbuqw = parcelRequire("fbuqw");

var $ha1VO = parcelRequire("ha1VO");
class $ca84e529ddef1ae9$export$41c5b3d29c6728c1 extends (0, $d2047.WebXRAbstractMotionController) {
    constructor(scene, gamepadObject, handedness){
        super(scene, $ca84e529ddef1ae9$var$GenericTriggerLayout[handedness], gamepadObject, handedness);
        this.profileId = $ca84e529ddef1ae9$export$41c5b3d29c6728c1.ProfileId;
    }
    _getFilenameAndPath() {
        return {
            filename: "generic.babylon",
            path: "https://controllers.babylonjs.com/generic/"
        };
    }
    _getModelLoadingConstraints() {
        return true;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _processLoadedModel(meshes) {
    // nothing to do
    }
    _setRootMesh(meshes) {
        this.rootMesh = new (0, $fbuqw.Mesh)(this.profileId + " " + this.handedness, this.scene);
        meshes.forEach((mesh)=>{
            mesh.isPickable = false;
            if (!mesh.parent) mesh.setParent(this.rootMesh);
        });
        this.rootMesh.rotationQuaternion = (0, $ha1VO.Quaternion).FromEulerAngles(0, Math.PI, 0);
    }
    _updateModel() {
    // no-op
    }
}
/**
 * Static version of the profile id of this controller
 */ $ca84e529ddef1ae9$export$41c5b3d29c6728c1.ProfileId = "generic-trigger";
// https://github.com/immersive-web/webxr-input-profiles/blob/master/packages/registry/profiles/generic/generic-trigger-touchpad-thumbstick.json
const $ca84e529ddef1ae9$var$GenericTriggerLayout = {
    left: {
        selectComponentId: "xr-standard-trigger",
        components: {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            "xr-standard-trigger": {
                type: "trigger",
                gamepadIndices: {
                    button: 0
                },
                rootNodeName: "xr_standard_trigger",
                visualResponses: {}
            }
        },
        gamepadMapping: "xr-standard",
        rootNodeName: "generic-trigger-left",
        assetPath: "left.glb"
    },
    right: {
        selectComponentId: "xr-standard-trigger",
        components: {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            "xr-standard-trigger": {
                type: "trigger",
                gamepadIndices: {
                    button: 0
                },
                rootNodeName: "xr_standard_trigger",
                visualResponses: {}
            }
        },
        gamepadMapping: "xr-standard",
        rootNodeName: "generic-trigger-right",
        assetPath: "right.glb"
    },
    none: {
        selectComponentId: "xr-standard-trigger",
        components: {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            "xr-standard-trigger": {
                type: "trigger",
                gamepadIndices: {
                    button: 0
                },
                rootNodeName: "xr_standard_trigger",
                visualResponses: {}
            }
        },
        gamepadMapping: "xr-standard",
        rootNodeName: "generic-trigger-none",
        assetPath: "none.glb"
    }
};

});
parcelRegister("d2047", function(module, exports) {

$parcel$export(module.exports, "WebXRAbstractMotionController", () => $97cb8340560603fa$export$1bc95da1ffee1589);

var $f9SMB = parcelRequire("f9SMB");

var $diGQf = parcelRequire("diGQf");

var $kVtWi = parcelRequire("kVtWi");

var $agoTA = parcelRequire("agoTA");

var $ha1VO = parcelRequire("ha1VO");

var $fbuqw = parcelRequire("fbuqw");
class $97cb8340560603fa$export$1bc95da1ffee1589 {
    /**
     * constructs a new abstract motion controller
     * @param scene the scene to which the model of the controller will be added
     * @param layout The profile layout to load
     * @param gamepadObject The gamepad object correlating to this controller
     * @param handedness handedness (left/right/none) of this controller
     * @param _doNotLoadControllerMesh set this flag to ignore the mesh loading
     * @param _controllerCache a cache holding controller models already loaded in this session
     */ constructor(// eslint-disable-next-line @typescript-eslint/naming-convention
    scene, // eslint-disable-next-line @typescript-eslint/naming-convention
    layout, /**
     * The gamepad object correlating to this controller
     */ gamepadObject, /**
     * handedness (left/right/none) of this controller
     */ handedness, /**
     * @internal
     */ _doNotLoadControllerMesh = false, _controllerCache){
        this.scene = scene;
        this.layout = layout;
        this.gamepadObject = gamepadObject;
        this.handedness = handedness;
        this._doNotLoadControllerMesh = _doNotLoadControllerMesh;
        this._controllerCache = _controllerCache;
        this._initComponent = (id)=>{
            if (!id) return;
            const componentDef = this.layout.components[id];
            const type = componentDef.type;
            const buttonIndex = componentDef.gamepadIndices.button;
            // search for axes
            const axes = [];
            if (componentDef.gamepadIndices.xAxis !== undefined && componentDef.gamepadIndices.yAxis !== undefined) axes.push(componentDef.gamepadIndices.xAxis, componentDef.gamepadIndices.yAxis);
            this.components[id] = new (0, $f9SMB.WebXRControllerComponent)(id, type, buttonIndex, axes);
        };
        this._modelReady = false;
        /**
         * A map of components (WebXRControllerComponent) in this motion controller
         * Components have a ComponentType and can also have both button and axis definitions
         */ this.components = {};
        /**
         * Disable the model's animation. Can be set at any time.
         */ this.disableAnimation = false;
        /**
         * Observers registered here will be triggered when the model of this controller is done loading
         */ this.onModelLoadedObservable = new (0, $diGQf.Observable)();
        // initialize the components
        if (layout.components) Object.keys(layout.components).forEach(this._initComponent);
    // Model is loaded in WebXRInput
    }
    /**
     * Dispose this controller, the model mesh and all its components
     */ dispose() {
        this.getComponentIds().forEach((id)=>this.getComponent(id).dispose());
        if (this.rootMesh) {
            this.rootMesh.getChildren(undefined, true).forEach((node)=>{
                node.setEnabled(false);
            });
            this.rootMesh.dispose(!!this._controllerCache, !this._controllerCache);
        }
    }
    /**
     * Returns all components of specific type
     * @param type the type to search for
     * @returns an array of components with this type
     */ getAllComponentsOfType(type) {
        return this.getComponentIds().map((id)=>this.components[id]).filter((component)=>component.type === type);
    }
    /**
     * get a component based an its component id as defined in layout.components
     * @param id the id of the component
     * @returns the component correlates to the id or undefined if not found
     */ getComponent(id) {
        return this.components[id];
    }
    /**
     * Get the list of components available in this motion controller
     * @returns an array of strings correlating to available components
     */ getComponentIds() {
        return Object.keys(this.components);
    }
    /**
     * Get the first component of specific type
     * @param type type of component to find
     * @returns a controller component or null if not found
     */ getComponentOfType(type) {
        return this.getAllComponentsOfType(type)[0] || null;
    }
    /**
     * Get the main (Select) component of this controller as defined in the layout
     * @returns the main component of this controller
     */ getMainComponent() {
        return this.getComponent(this.layout.selectComponentId);
    }
    /**
     * Loads the model correlating to this controller
     * When the mesh is loaded, the onModelLoadedObservable will be triggered
     * @returns A promise fulfilled with the result of the model loading
     */ async loadModel() {
        const useGeneric = !this._getModelLoadingConstraints();
        let loadingParams = this._getGenericFilenameAndPath();
        // Checking if GLB loader is present
        if (useGeneric) (0, $kVtWi.Logger).Warn("Falling back to generic models");
        else loadingParams = this._getFilenameAndPath();
        return new Promise((resolve, reject)=>{
            const meshesLoaded = (meshes)=>{
                if (useGeneric) this._getGenericParentMesh(meshes);
                else this._setRootMesh(meshes);
                this._processLoadedModel(meshes);
                this._modelReady = true;
                this.onModelLoadedObservable.notifyObservers(this);
                resolve(true);
            };
            if (this._controllerCache) {
                // look for it in the cache
                const found = this._controllerCache.filter((c)=>{
                    return c.filename === loadingParams.filename && c.path === loadingParams.path;
                });
                if (found[0]) {
                    found[0].meshes.forEach((mesh)=>mesh.setEnabled(true));
                    meshesLoaded(found[0].meshes);
                    return;
                // found, don't continue to load
                }
            }
            (0, $agoTA.SceneLoader).ImportMesh("", loadingParams.path, loadingParams.filename, this.scene, (meshes)=>{
                if (this._controllerCache) this._controllerCache.push({
                    ...loadingParams,
                    meshes: meshes
                });
                meshesLoaded(meshes);
            }, null, (_scene, message)=>{
                (0, $kVtWi.Logger).Log(message);
                (0, $kVtWi.Logger).Warn(`Failed to retrieve controller model of type ${this.profileId} from the remote server: ${loadingParams.path}${loadingParams.filename}`);
                reject(message);
            });
        });
    }
    /**
     * Update this model using the current XRFrame
     * @param xrFrame the current xr frame to use and update the model
     */ updateFromXRFrame(xrFrame) {
        this.getComponentIds().forEach((id)=>this.getComponent(id).update(this.gamepadObject));
        this.updateModel(xrFrame);
    }
    /**
     * Backwards compatibility due to a deeply-integrated typo
     */ get handness() {
        return this.handedness;
    }
    /**
     * Pulse (vibrate) this controller
     * If the controller does not support pulses, this function will fail silently and return Promise<false> directly after called
     * Consecutive calls to this function will cancel the last pulse call
     *
     * @param value the strength of the pulse in 0.0...1.0 range
     * @param duration Duration of the pulse in milliseconds
     * @param hapticActuatorIndex optional index of actuator (will usually be 0)
     * @returns a promise that will send true when the pulse has ended and false if the device doesn't support pulse or an error accrued
     */ pulse(value, duration, hapticActuatorIndex = 0) {
        if (this.gamepadObject.hapticActuators && this.gamepadObject.hapticActuators[hapticActuatorIndex]) return this.gamepadObject.hapticActuators[hapticActuatorIndex].pulse(value, duration);
        else return Promise.resolve(false);
    }
    // Look through all children recursively. This will return null if no mesh exists with the given name.
    _getChildByName(node, name) {
        return node.getChildren((n)=>n.name === name, false)[0];
    }
    // Look through only immediate children. This will return null if no mesh exists with the given name.
    _getImmediateChildByName(node, name) {
        return node.getChildren((n)=>n.name == name, true)[0];
    }
    /**
     * Moves the axis on the controller mesh based on its current state
     * @param axisMap
     * @param axisValue the value of the axis which determines the meshes new position
     * @internal
     */ _lerpTransform(axisMap, axisValue, fixValueCoordinates) {
        if (!axisMap.minMesh || !axisMap.maxMesh || !axisMap.valueMesh) return;
        if (!axisMap.minMesh.rotationQuaternion || !axisMap.maxMesh.rotationQuaternion || !axisMap.valueMesh.rotationQuaternion) return;
        // Convert from gamepad value range (-1 to +1) to lerp range (0 to 1)
        const lerpValue = fixValueCoordinates ? axisValue * 0.5 + 0.5 : axisValue;
        (0, $ha1VO.Quaternion).SlerpToRef(axisMap.minMesh.rotationQuaternion, axisMap.maxMesh.rotationQuaternion, lerpValue, axisMap.valueMesh.rotationQuaternion);
        (0, $ha1VO.Vector3).LerpToRef(axisMap.minMesh.position, axisMap.maxMesh.position, lerpValue, axisMap.valueMesh.position);
    }
    /**
     * Update the model itself with the current frame data
     * @param xrFrame the frame to use for updating the model mesh
     */ // eslint-disable-next-line @typescript-eslint/naming-convention
    updateModel(xrFrame) {
        if (!this._modelReady) return;
        this._updateModel(xrFrame);
    }
    _getGenericFilenameAndPath() {
        return {
            filename: "generic.babylon",
            path: "https://controllers.babylonjs.com/generic/"
        };
    }
    _getGenericParentMesh(meshes) {
        this.rootMesh = new (0, $fbuqw.Mesh)(this.profileId + " " + this.handedness, this.scene);
        meshes.forEach((mesh)=>{
            if (!mesh.parent) {
                mesh.isPickable = false;
                mesh.setParent(this.rootMesh);
            }
        });
        this.rootMesh.rotationQuaternion = (0, $ha1VO.Quaternion).FromEulerAngles(0, Math.PI, 0);
    }
}

});
parcelRegister("f9SMB", function(module, exports) {

$parcel$export(module.exports, "WebXRControllerComponent", () => $b09231079c66b259$export$dd75c966c26a9c28);

var $diGQf = parcelRequire("diGQf");
class $b09231079c66b259$export$dd75c966c26a9c28 {
    /**
     * Creates a new component for a motion controller.
     * It is created by the motion controller itself
     *
     * @param id the id of this component
     * @param type the type of the component
     * @param _buttonIndex index in the buttons array of the gamepad
     * @param _axesIndices indices of the values in the axes array of the gamepad
     */ constructor(/**
     * the id of this component
     */ id, /**
     * the type of the component
     */ type, _buttonIndex = -1, _axesIndices = []){
        this.id = id;
        this.type = type;
        this._buttonIndex = _buttonIndex;
        this._axesIndices = _axesIndices;
        this._axes = {
            x: 0,
            y: 0
        };
        this._changes = {};
        this._currentValue = 0;
        this._hasChanges = false;
        this._pressed = false;
        this._touched = false;
        /**
         * If axes are available for this component (like a touchpad or thumbstick) the observers will be notified when
         * the axes data changes
         */ this.onAxisValueChangedObservable = new (0, $diGQf.Observable)();
        /**
         * Observers registered here will be triggered when the state of a button changes
         * State change is either pressed / touched / value
         */ this.onButtonStateChangedObservable = new (0, $diGQf.Observable)();
    }
    /**
     * The current axes data. If this component has no axes it will still return an object { x: 0, y: 0 }
     */ get axes() {
        return this._axes;
    }
    /**
     * Get the changes. Elements will be populated only if they changed with their previous and current value
     */ get changes() {
        return this._changes;
    }
    /**
     * Return whether or not the component changed the last frame
     */ get hasChanges() {
        return this._hasChanges;
    }
    /**
     * is the button currently pressed
     */ get pressed() {
        return this._pressed;
    }
    /**
     * is the button currently touched
     */ get touched() {
        return this._touched;
    }
    /**
     * Get the current value of this component
     */ get value() {
        return this._currentValue;
    }
    /**
     * Dispose this component
     */ dispose() {
        this.onAxisValueChangedObservable.clear();
        this.onButtonStateChangedObservable.clear();
    }
    /**
     * Are there axes correlating to this component
     * @returns true is axes data is available
     */ isAxes() {
        return this._axesIndices.length !== 0;
    }
    /**
     * Is this component a button (hence - pressable)
     * @returns true if can be pressed
     */ isButton() {
        return this._buttonIndex !== -1;
    }
    /**
     * update this component using the gamepad object it is in. Called on every frame
     * @param nativeController the native gamepad controller object
     */ update(nativeController) {
        let buttonUpdated = false;
        let axesUpdate = false;
        this._hasChanges = false;
        this._changes = {};
        if (this.isButton()) {
            const button = nativeController.buttons[this._buttonIndex];
            // defensive, in case a profile was forced
            if (!button) return;
            if (this._currentValue !== button.value) {
                this.changes.value = {
                    current: button.value,
                    previous: this._currentValue
                };
                buttonUpdated = true;
                this._currentValue = button.value;
            }
            if (this._touched !== button.touched) {
                this.changes.touched = {
                    current: button.touched,
                    previous: this._touched
                };
                buttonUpdated = true;
                this._touched = button.touched;
            }
            if (this._pressed !== button.pressed) {
                this.changes.pressed = {
                    current: button.pressed,
                    previous: this._pressed
                };
                buttonUpdated = true;
                this._pressed = button.pressed;
            }
        }
        if (this.isAxes()) {
            if (this._axes.x !== nativeController.axes[this._axesIndices[0]]) {
                this.changes.axes = {
                    current: {
                        x: nativeController.axes[this._axesIndices[0]],
                        y: this._axes.y
                    },
                    previous: {
                        x: this._axes.x,
                        y: this._axes.y
                    }
                };
                this._axes.x = nativeController.axes[this._axesIndices[0]];
                axesUpdate = true;
            }
            if (this._axes.y !== nativeController.axes[this._axesIndices[1]]) {
                if (this.changes.axes) this.changes.axes.current.y = nativeController.axes[this._axesIndices[1]];
                else this.changes.axes = {
                    current: {
                        x: this._axes.x,
                        y: nativeController.axes[this._axesIndices[1]]
                    },
                    previous: {
                        x: this._axes.x,
                        y: this._axes.y
                    }
                };
                this._axes.y = nativeController.axes[this._axesIndices[1]];
                axesUpdate = true;
            }
        }
        if (buttonUpdated) {
            this._hasChanges = true;
            this.onButtonStateChangedObservable.notifyObservers(this);
        }
        if (axesUpdate) {
            this._hasChanges = true;
            this.onAxisValueChangedObservable.notifyObservers(this._axes);
        }
    }
}
/**
 * button component type
 */ $b09231079c66b259$export$dd75c966c26a9c28.BUTTON_TYPE = "button";
/**
 * squeeze component type
 */ $b09231079c66b259$export$dd75c966c26a9c28.SQUEEZE_TYPE = "squeeze";
/**
 * Thumbstick component type
 */ $b09231079c66b259$export$dd75c966c26a9c28.THUMBSTICK_TYPE = "thumbstick";
/**
 * Touchpad component type
 */ $b09231079c66b259$export$dd75c966c26a9c28.TOUCHPAD_TYPE = "touchpad";
/**
 * trigger component type
 */ $b09231079c66b259$export$dd75c966c26a9c28.TRIGGER_TYPE = "trigger";

});



parcelRegister("xXlMh", function(module, exports) {

$parcel$export(module.exports, "WebXRProfiledMotionController", () => $06611ee7e405502c$export$29568dc6ea8eeef0);

var $d2047 = parcelRequire("d2047");

var $agoTA = parcelRequire("agoTA");

var $fbuqw = parcelRequire("fbuqw");

var $dbxbu = parcelRequire("dbxbu");

var $7etnY = parcelRequire("7etnY");

var $f9SMB = parcelRequire("f9SMB");

var $8KqOo = parcelRequire("8KqOo");

var $gAH3H = parcelRequire("gAH3H");

var $kVtWi = parcelRequire("kVtWi");
class $06611ee7e405502c$export$29568dc6ea8eeef0 extends (0, $d2047.WebXRAbstractMotionController) {
    constructor(scene, xrInput, _profile, _repositoryUrl, // eslint-disable-next-line @typescript-eslint/naming-convention
    controllerCache){
        super(scene, _profile.layouts[xrInput.handedness || "none"], xrInput.gamepad, xrInput.handedness, undefined, controllerCache);
        this._repositoryUrl = _repositoryUrl;
        this.controllerCache = controllerCache;
        this._buttonMeshMapping = {};
        this._touchDots = {};
        this.profileId = _profile.profileId;
    }
    dispose() {
        super.dispose();
        if (!this.controllerCache) Object.keys(this._touchDots).forEach((visResKey)=>{
            this._touchDots[visResKey].dispose();
        });
    }
    _getFilenameAndPath() {
        return {
            filename: this.layout.assetPath,
            path: `${this._repositoryUrl}/profiles/${this.profileId}/`
        };
    }
    _getModelLoadingConstraints() {
        const glbLoaded = (0, $agoTA.SceneLoader).IsPluginForExtensionAvailable(".glb");
        if (!glbLoaded) (0, $kVtWi.Logger).Warn("glTF / glb loader was not registered, using generic controller instead");
        return glbLoaded;
    }
    _processLoadedModel(_meshes) {
        this.getComponentIds().forEach((type)=>{
            const componentInLayout = this.layout.components[type];
            this._buttonMeshMapping[type] = {
                mainMesh: this._getChildByName(this.rootMesh, componentInLayout.rootNodeName),
                states: {}
            };
            Object.keys(componentInLayout.visualResponses).forEach((visualResponseKey)=>{
                const visResponse = componentInLayout.visualResponses[visualResponseKey];
                if (visResponse.valueNodeProperty === "transform") this._buttonMeshMapping[type].states[visualResponseKey] = {
                    valueMesh: this._getChildByName(this.rootMesh, visResponse.valueNodeName),
                    minMesh: this._getChildByName(this.rootMesh, visResponse.minNodeName),
                    maxMesh: this._getChildByName(this.rootMesh, visResponse.maxNodeName)
                };
                else {
                    // visibility, usually for touchpads
                    const nameOfMesh = componentInLayout.type === (0, $f9SMB.WebXRControllerComponent).TOUCHPAD_TYPE && componentInLayout.touchPointNodeName ? componentInLayout.touchPointNodeName : visResponse.valueNodeName;
                    this._buttonMeshMapping[type].states[visualResponseKey] = {
                        valueMesh: this._getChildByName(this.rootMesh, nameOfMesh)
                    };
                    if (componentInLayout.type === (0, $f9SMB.WebXRControllerComponent).TOUCHPAD_TYPE && !this._touchDots[visualResponseKey]) {
                        const dot = (0, $8KqOo.CreateSphere)(visualResponseKey + "dot", {
                            diameter: 0.0015,
                            segments: 8
                        }, this.scene);
                        dot.material = new (0, $gAH3H.StandardMaterial)(visualResponseKey + "mat", this.scene);
                        dot.material.diffuseColor = (0, $7etnY.Color3).Red();
                        dot.parent = this._buttonMeshMapping[type].states[visualResponseKey].valueMesh || null;
                        dot.isVisible = false;
                        this._touchDots[visualResponseKey] = dot;
                    }
                }
            });
        });
    }
    _setRootMesh(meshes) {
        this.rootMesh = new (0, $fbuqw.Mesh)(this.profileId + "-" + this.handedness, this.scene);
        this.rootMesh.isPickable = false;
        let rootMesh;
        // Find the root node in the loaded glTF scene, and attach it as a child of 'parentMesh'
        for(let i = 0; i < meshes.length; i++){
            const mesh = meshes[i];
            mesh.isPickable = false;
            if (!mesh.parent) // Handle root node, attach to the new parentMesh
            rootMesh = mesh;
        }
        if (rootMesh) rootMesh.setParent(this.rootMesh);
        if (!this.scene.useRightHandedSystem) this.rootMesh.rotate((0, $dbxbu.Axis).Y, Math.PI, (0, $dbxbu.Space).WORLD);
    }
    _updateModel(_xrFrame) {
        if (this.disableAnimation) return;
        this.getComponentIds().forEach((id)=>{
            const component = this.getComponent(id);
            if (!component.hasChanges) return;
            const meshes = this._buttonMeshMapping[id];
            const componentInLayout = this.layout.components[id];
            Object.keys(componentInLayout.visualResponses).forEach((visualResponseKey)=>{
                const visResponse = componentInLayout.visualResponses[visualResponseKey];
                let value = component.value;
                if (visResponse.componentProperty === "xAxis") value = component.axes.x;
                else if (visResponse.componentProperty === "yAxis") value = component.axes.y;
                if (visResponse.valueNodeProperty === "transform") this._lerpTransform(meshes.states[visualResponseKey], value, visResponse.componentProperty !== "button");
                else {
                    // visibility
                    const valueMesh = meshes.states[visualResponseKey].valueMesh;
                    if (valueMesh) valueMesh.isVisible = component.touched || component.pressed;
                    if (this._touchDots[visualResponseKey]) this._touchDots[visualResponseKey].isVisible = component.touched || component.pressed;
                }
            });
        });
    }
}

});




parcelRegister("9GdLu", function(module, exports) {

$parcel$export(module.exports, "WebXRControllerPointerSelection", () => $01d19797b977817b$export$f4b08e719fa2f192);

var $cJN7d = parcelRequire("cJN7d");

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $dbxbu = parcelRequire("dbxbu");

var $gAH3H = parcelRequire("gAH3H");

var $9zY5k = parcelRequire("9zY5k");

var $bCJrn = parcelRequire("bCJrn");

var $3kez7 = parcelRequire("3kez7");

var $gzCma = parcelRequire("gzCma");

var $2YzP2 = parcelRequire("2YzP2");

var $6mCYU = parcelRequire("6mCYU");

var $191mA = parcelRequire("191mA");

var $bOhSV = parcelRequire("bOhSV");
class $01d19797b977817b$export$f4b08e719fa2f192 extends (0, $2YzP2.WebXRAbstractFeature) {
    /**
     * constructs a new background remover module
     * @param _xrSessionManager the session manager for this module
     * @param _options read-only options to be used in this module
     */ constructor(_xrSessionManager, _options){
        super(_xrSessionManager);
        this._options = _options;
        this._attachController = (xrController)=>{
            if (this._controllers[xrController.uniqueId]) // already attached
            return;
            const { laserPointer: laserPointer, selectionMesh: selectionMesh } = this._generateNewMeshPair(this._options.forceGripIfAvailable && xrController.grip ? xrController.grip : xrController.pointer);
            // get two new meshes
            this._controllers[xrController.uniqueId] = {
                xrController: xrController,
                laserPointer: laserPointer,
                selectionMesh: selectionMesh,
                meshUnderPointer: null,
                pick: null,
                tmpRay: new (0, $3kez7.Ray)(new (0, $ha1VO.Vector3)(), new (0, $ha1VO.Vector3)()),
                disabledByNearInteraction: false,
                id: $01d19797b977817b$export$f4b08e719fa2f192._IdCounter++
            };
            if (this._attachedController) {
                if (!this._options.enablePointerSelectionOnAllControllers && this._options.preferredHandedness && xrController.inputSource.handedness === this._options.preferredHandedness) this._attachedController = xrController.uniqueId;
            } else if (!this._options.enablePointerSelectionOnAllControllers) this._attachedController = xrController.uniqueId;
            switch(xrController.inputSource.targetRayMode){
                case "tracked-pointer":
                    return this._attachTrackedPointerRayMode(xrController);
                case "gaze":
                    return this._attachGazeMode(xrController);
                case "screen":
                case "transient-pointer":
                    return this._attachScreenRayMode(xrController);
            }
        };
        this._controllers = {};
        this._tmpVectorForPickCompare = new (0, $ha1VO.Vector3)();
        /**
         * Disable lighting on the laser pointer (so it will always be visible)
         */ this.disablePointerLighting = true;
        /**
         * Disable lighting on the selection mesh (so it will always be visible)
         */ this.disableSelectionMeshLighting = true;
        /**
         * Should the laser pointer be displayed
         */ this.displayLaserPointer = true;
        /**
         * Should the selection mesh be displayed (The ring at the end of the laser pointer)
         */ this.displaySelectionMesh = true;
        /**
         * This color will be set to the laser pointer when selection is triggered
         */ this.laserPointerPickedColor = new (0, $7etnY.Color3)(0.9, 0.9, 0.9);
        /**
         * Default color of the laser pointer
         */ this.laserPointerDefaultColor = new (0, $7etnY.Color3)(0.7, 0.7, 0.7);
        /**
         * default color of the selection ring
         */ this.selectionMeshDefaultColor = new (0, $7etnY.Color3)(0.8, 0.8, 0.8);
        /**
         * This color will be applied to the selection ring when selection is triggered
         */ this.selectionMeshPickedColor = new (0, $7etnY.Color3)(0.3, 0.3, 1.0);
        this._identityMatrix = (0, $ha1VO.Matrix).Identity();
        this._screenCoordinatesRef = (0, $ha1VO.Vector3).Zero();
        this._viewportRef = new (0, $191mA.Viewport)(0, 0, 0, 0);
        this._scene = this._xrSessionManager.scene;
        // force look and pick mode if using WebXR on safari, assuming it is vision OS
        // Only if not explicitly set. If set to false, it will not be forced
        if (this._options.lookAndPickMode === undefined && (this._scene.getEngine()._badDesktopOS || this._scene.getEngine()._badOS)) this._options.lookAndPickMode = true;
        // look and pick mode extra state changes
        if (this._options.lookAndPickMode) {
            this._options.enablePointerSelectionOnAllControllers = true;
            this.displayLaserPointer = false;
        }
    }
    /**
     * attach this feature
     * Will usually be called by the features manager
     *
     * @returns true if successful.
     */ attach() {
        if (!super.attach()) return false;
        this._options.xrInput.controllers.forEach(this._attachController);
        this._addNewAttachObserver(this._options.xrInput.onControllerAddedObservable, this._attachController, true);
        this._addNewAttachObserver(this._options.xrInput.onControllerRemovedObservable, (controller)=>{
            // REMOVE the controller
            this._detachController(controller.uniqueId);
        }, true);
        this._scene.constantlyUpdateMeshUnderPointer = true;
        if (this._options.gazeCamera) {
            const webXRCamera = this._options.gazeCamera;
            const { laserPointer: laserPointer, selectionMesh: selectionMesh } = this._generateNewMeshPair(webXRCamera);
            this._controllers["camera"] = {
                webXRCamera: webXRCamera,
                laserPointer: laserPointer,
                selectionMesh: selectionMesh,
                meshUnderPointer: null,
                pick: null,
                tmpRay: new (0, $3kez7.Ray)(new (0, $ha1VO.Vector3)(), new (0, $ha1VO.Vector3)()),
                disabledByNearInteraction: false,
                id: $01d19797b977817b$export$f4b08e719fa2f192._IdCounter++
            };
            this._attachGazeMode();
        }
        return true;
    }
    /**
     * detach this feature.
     * Will usually be called by the features manager
     *
     * @returns true if successful.
     */ detach() {
        if (!super.detach()) return false;
        Object.keys(this._controllers).forEach((controllerId)=>{
            this._detachController(controllerId);
        });
        return true;
    }
    /**
     * Will get the mesh under a specific pointer.
     * `scene.meshUnderPointer` will only return one mesh - either left or right.
     * @param controllerId the controllerId to check
     * @returns The mesh under pointer or null if no mesh is under the pointer
     */ getMeshUnderPointer(controllerId) {
        if (this._controllers[controllerId]) return this._controllers[controllerId].meshUnderPointer;
        else return null;
    }
    /**
     * Get the xr controller that correlates to the pointer id in the pointer event
     *
     * @param id the pointer id to search for
     * @returns the controller that correlates to this id or null if not found
     */ getXRControllerByPointerId(id) {
        const keys = Object.keys(this._controllers);
        for(let i = 0; i < keys.length; ++i){
            if (this._controllers[keys[i]].id === id) return this._controllers[keys[i]].xrController || null;
        }
        return null;
    }
    /**
     * @internal
     */ _getPointerSelectionDisabledByPointerId(id) {
        const keys = Object.keys(this._controllers);
        for(let i = 0; i < keys.length; ++i){
            if (this._controllers[keys[i]].id === id) return this._controllers[keys[i]].disabledByNearInteraction;
        }
        return true;
    }
    /**
     * @internal
     */ _setPointerSelectionDisabledByPointerId(id, state) {
        const keys = Object.keys(this._controllers);
        for(let i = 0; i < keys.length; ++i)if (this._controllers[keys[i]].id === id) {
            this._controllers[keys[i]].disabledByNearInteraction = state;
            return;
        }
    }
    _onXRFrame(_xrFrame) {
        Object.keys(this._controllers).forEach((id)=>{
            // look and pick mode
            // only do this for the selected pointer
            const controllerData = this._controllers[id];
            if (this._options.lookAndPickMode && controllerData.xrController?.inputSource.targetRayMode !== "transient-pointer") return;
            if (!this._options.enablePointerSelectionOnAllControllers && id !== this._attachedController || controllerData.disabledByNearInteraction) {
                controllerData.selectionMesh.isVisible = false;
                controllerData.laserPointer.isVisible = false;
                controllerData.pick = null;
                return;
            }
            controllerData.laserPointer.isVisible = this.displayLaserPointer;
            let controllerGlobalPosition;
            // Every frame check collisions/input
            if (controllerData.xrController) {
                controllerGlobalPosition = this._options.forceGripIfAvailable && controllerData.xrController.grip ? controllerData.xrController.grip.position : controllerData.xrController.pointer.position;
                controllerData.xrController.getWorldPointerRayToRef(controllerData.tmpRay, this._options.forceGripIfAvailable);
            } else if (controllerData.webXRCamera) {
                controllerGlobalPosition = controllerData.webXRCamera.position;
                controllerData.webXRCamera.getForwardRayToRef(controllerData.tmpRay);
            } else return;
            if (this._options.maxPointerDistance) controllerData.tmpRay.length = this._options.maxPointerDistance;
            // update pointerX and pointerY of the scene. Only if the flag is set to true!
            if (!this._options.disableScenePointerVectorUpdate && controllerGlobalPosition) {
                const scene = this._xrSessionManager.scene;
                const camera = this._options.xrInput.xrCamera;
                if (camera) {
                    camera.viewport.toGlobalToRef(scene.getEngine().getRenderWidth() / camera.rigCameras.length, scene.getEngine().getRenderHeight(), this._viewportRef);
                    (0, $ha1VO.Vector3).ProjectToRef(controllerGlobalPosition, this._identityMatrix, camera.getTransformationMatrix(), this._viewportRef, this._screenCoordinatesRef);
                    // stay safe
                    if (typeof this._screenCoordinatesRef.x === "number" && typeof this._screenCoordinatesRef.y === "number" && !isNaN(this._screenCoordinatesRef.x) && !isNaN(this._screenCoordinatesRef.y) && this._screenCoordinatesRef.x !== Infinity && this._screenCoordinatesRef.y !== Infinity) {
                        scene.pointerX = this._screenCoordinatesRef.x;
                        scene.pointerY = this._screenCoordinatesRef.y;
                        controllerData.screenCoordinates = {
                            x: this._screenCoordinatesRef.x,
                            y: this._screenCoordinatesRef.y
                        };
                    }
                }
            }
            let utilityScenePick = null;
            if (this._utilityLayerScene) utilityScenePick = this._utilityLayerScene.pickWithRay(controllerData.tmpRay, this._utilityLayerScene.pointerMovePredicate || this.raySelectionPredicate);
            const originalScenePick = this._scene.pickWithRay(controllerData.tmpRay, this._scene.pointerMovePredicate || this.raySelectionPredicate);
            if (!utilityScenePick || !utilityScenePick.hit) // No hit in utility scene
            controllerData.pick = originalScenePick;
            else if (!originalScenePick || !originalScenePick.hit) // No hit in original scene
            controllerData.pick = utilityScenePick;
            else if (utilityScenePick.distance < originalScenePick.distance) // Hit is closer in utility scene
            controllerData.pick = utilityScenePick;
            else // Hit is closer in original scene
            controllerData.pick = originalScenePick;
            if (controllerData.pick && controllerData.xrController) {
                controllerData.pick.aimTransform = controllerData.xrController.pointer;
                controllerData.pick.gripTransform = controllerData.xrController.grip || null;
                controllerData.pick.originMesh = controllerData.xrController.pointer;
            }
            const pick = controllerData.pick;
            if (pick && pick.pickedPoint && pick.hit) {
                // Update laser state
                this._updatePointerDistance(controllerData.laserPointer, pick.distance);
                // Update cursor state
                controllerData.selectionMesh.position.copyFrom(pick.pickedPoint);
                controllerData.selectionMesh.scaling.x = Math.sqrt(pick.distance);
                controllerData.selectionMesh.scaling.y = Math.sqrt(pick.distance);
                controllerData.selectionMesh.scaling.z = Math.sqrt(pick.distance);
                // To avoid z-fighting
                const pickNormal = this._convertNormalToDirectionOfRay(pick.getNormal(true), controllerData.tmpRay);
                const deltaFighting = 0.001;
                controllerData.selectionMesh.position.copyFrom(pick.pickedPoint);
                if (pickNormal) {
                    const axis1 = (0, $ha1VO.Vector3).Cross((0, $dbxbu.Axis).Y, pickNormal);
                    const axis2 = (0, $ha1VO.Vector3).Cross(pickNormal, axis1);
                    (0, $ha1VO.Vector3).RotationFromAxisToRef(axis2, pickNormal, axis1, controllerData.selectionMesh.rotation);
                    controllerData.selectionMesh.position.addInPlace(pickNormal.scale(deltaFighting));
                }
                controllerData.selectionMesh.isVisible = this.displaySelectionMesh;
                controllerData.meshUnderPointer = pick.pickedMesh;
            } else {
                controllerData.selectionMesh.isVisible = false;
                this._updatePointerDistance(controllerData.laserPointer, 1);
                controllerData.meshUnderPointer = null;
            }
        });
    }
    get _utilityLayerScene() {
        return this._options.customUtilityLayerScene || (0, $6mCYU.UtilityLayerRenderer).DefaultUtilityLayer.utilityLayerScene;
    }
    _attachGazeMode(xrController) {
        const controllerData = this._controllers[xrController && xrController.uniqueId || "camera"];
        // attached when touched, detaches when raised
        const timeToSelect = this._options.timeToSelect || 3000;
        const sceneToRenderTo = this._options.useUtilityLayer ? this._utilityLayerScene : this._scene;
        let oldPick = new (0, $gzCma.PickingInfo)();
        const discMesh = (0, $bCJrn.CreateTorus)("selection", {
            diameter: 0.0525,
            thickness: 0.015,
            tessellation: 20
        }, sceneToRenderTo);
        discMesh.isVisible = false;
        discMesh.isPickable = false;
        discMesh.parent = controllerData.selectionMesh;
        let timer = 0;
        let downTriggered = false;
        const pointerEventInit = {
            pointerId: controllerData.id,
            pointerType: "xr"
        };
        controllerData.onFrameObserver = this._xrSessionManager.onXRFrameObservable.add(()=>{
            if (!controllerData.pick) return;
            this._augmentPointerInit(pointerEventInit, controllerData.id, controllerData.screenCoordinates);
            controllerData.laserPointer.material.alpha = 0;
            discMesh.isVisible = false;
            if (controllerData.pick.hit) {
                if (!this._pickingMoved(oldPick, controllerData.pick)) {
                    if (timer > timeToSelect / 10) discMesh.isVisible = true;
                    timer += this._scene.getEngine().getDeltaTime();
                    if (timer >= timeToSelect) {
                        this._scene.simulatePointerDown(controllerData.pick, pointerEventInit);
                        // this pointerdown event is not setting the controllerData.pointerDownTriggered to avoid a pointerUp event when this feature is detached
                        downTriggered = true;
                        // pointer up right after down, if disable on touch out
                        if (this._options.disablePointerUpOnTouchOut) this._scene.simulatePointerUp(controllerData.pick, pointerEventInit);
                        discMesh.isVisible = false;
                    } else {
                        const scaleFactor = 1 - timer / timeToSelect;
                        discMesh.scaling.set(scaleFactor, scaleFactor, scaleFactor);
                    }
                } else {
                    if (downTriggered) {
                        if (!this._options.disablePointerUpOnTouchOut) this._scene.simulatePointerUp(controllerData.pick, pointerEventInit);
                    }
                    downTriggered = false;
                    timer = 0;
                }
            } else {
                downTriggered = false;
                timer = 0;
            }
            this._scene.simulatePointerMove(controllerData.pick, pointerEventInit);
            oldPick = controllerData.pick;
        });
        if (this._options.renderingGroupId !== undefined) discMesh.renderingGroupId = this._options.renderingGroupId;
        if (xrController) xrController.onDisposeObservable.addOnce(()=>{
            if (controllerData.pick && !this._options.disablePointerUpOnTouchOut && downTriggered) {
                this._scene.simulatePointerUp(controllerData.pick, pointerEventInit);
                controllerData.finalPointerUpTriggered = true;
            }
            discMesh.dispose();
        });
    }
    _attachScreenRayMode(xrController) {
        const controllerData = this._controllers[xrController.uniqueId];
        let downTriggered = false;
        const pointerEventInit = {
            pointerId: controllerData.id,
            pointerType: "xr"
        };
        controllerData.onFrameObserver = this._xrSessionManager.onXRFrameObservable.add(()=>{
            this._augmentPointerInit(pointerEventInit, controllerData.id, controllerData.screenCoordinates);
            if (!controllerData.pick || this._options.disablePointerUpOnTouchOut && downTriggered) return;
            if (!downTriggered) {
                this._scene.simulatePointerDown(controllerData.pick, pointerEventInit);
                controllerData.pointerDownTriggered = true;
                downTriggered = true;
                if (this._options.disablePointerUpOnTouchOut) this._scene.simulatePointerUp(controllerData.pick, pointerEventInit);
            } else this._scene.simulatePointerMove(controllerData.pick, pointerEventInit);
        });
        xrController.onDisposeObservable.addOnce(()=>{
            this._augmentPointerInit(pointerEventInit, controllerData.id, controllerData.screenCoordinates);
            this._xrSessionManager.runInXRFrame(()=>{
                if (controllerData.pick && !controllerData.finalPointerUpTriggered && downTriggered && !this._options.disablePointerUpOnTouchOut) {
                    this._scene.simulatePointerUp(controllerData.pick, pointerEventInit);
                    controllerData.finalPointerUpTriggered = true;
                }
            });
        });
    }
    _attachTrackedPointerRayMode(xrController) {
        const controllerData = this._controllers[xrController.uniqueId];
        if (this._options.forceGazeMode) return this._attachGazeMode(xrController);
        const pointerEventInit = {
            pointerId: controllerData.id,
            pointerType: "xr"
        };
        controllerData.onFrameObserver = this._xrSessionManager.onXRFrameObservable.add(()=>{
            controllerData.laserPointer.material.disableLighting = this.disablePointerLighting;
            controllerData.selectionMesh.material.disableLighting = this.disableSelectionMeshLighting;
            if (controllerData.pick) {
                this._augmentPointerInit(pointerEventInit, controllerData.id, controllerData.screenCoordinates);
                this._scene.simulatePointerMove(controllerData.pick, pointerEventInit);
            }
        });
        if (xrController.inputSource.gamepad) {
            const init = (motionController)=>{
                if (this._options.overrideButtonId) controllerData.selectionComponent = motionController.getComponent(this._options.overrideButtonId);
                if (!controllerData.selectionComponent) controllerData.selectionComponent = motionController.getMainComponent();
                controllerData.onButtonChangedObserver = controllerData.selectionComponent.onButtonStateChangedObservable.add((component)=>{
                    if (component.changes.pressed) {
                        const pressed = component.changes.pressed.current;
                        if (controllerData.pick) {
                            if (this._options.enablePointerSelectionOnAllControllers || xrController.uniqueId === this._attachedController) {
                                this._augmentPointerInit(pointerEventInit, controllerData.id, controllerData.screenCoordinates);
                                if (pressed) {
                                    this._scene.simulatePointerDown(controllerData.pick, pointerEventInit);
                                    controllerData.pointerDownTriggered = true;
                                    controllerData.selectionMesh.material.emissiveColor = this.selectionMeshPickedColor;
                                    controllerData.laserPointer.material.emissiveColor = this.laserPointerPickedColor;
                                } else {
                                    this._scene.simulatePointerUp(controllerData.pick, pointerEventInit);
                                    controllerData.selectionMesh.material.emissiveColor = this.selectionMeshDefaultColor;
                                    controllerData.laserPointer.material.emissiveColor = this.laserPointerDefaultColor;
                                }
                            }
                        } else if (pressed && !this._options.enablePointerSelectionOnAllControllers && !this._options.disableSwitchOnClick) {
                            // force a pointer up if switching controllers
                            // get the controller that was attached before
                            const prevController = this._controllers[this._attachedController];
                            if (prevController && prevController.pointerDownTriggered && !prevController.finalPointerUpTriggered) {
                                this._augmentPointerInit(pointerEventInit, prevController.id, prevController.screenCoordinates);
                                this._scene.simulatePointerUp(new (0, $gzCma.PickingInfo)(), {
                                    pointerId: prevController.id,
                                    pointerType: "xr"
                                });
                                prevController.finalPointerUpTriggered = true;
                            }
                            this._attachedController = xrController.uniqueId;
                        }
                    }
                });
            };
            if (xrController.motionController) init(xrController.motionController);
            else xrController.onMotionControllerInitObservable.add(init);
        } else {
            // use the select and squeeze events
            const selectStartListener = (event)=>{
                this._xrSessionManager.onXRFrameObservable.addOnce(()=>{
                    this._augmentPointerInit(pointerEventInit, controllerData.id, controllerData.screenCoordinates);
                    if (controllerData.xrController && event.inputSource === controllerData.xrController.inputSource && controllerData.pick) {
                        this._scene.simulatePointerDown(controllerData.pick, pointerEventInit);
                        controllerData.pointerDownTriggered = true;
                        controllerData.selectionMesh.material.emissiveColor = this.selectionMeshPickedColor;
                        controllerData.laserPointer.material.emissiveColor = this.laserPointerPickedColor;
                    }
                });
            };
            const selectEndListener = (event)=>{
                this._xrSessionManager.onXRFrameObservable.addOnce(()=>{
                    this._augmentPointerInit(pointerEventInit, controllerData.id, controllerData.screenCoordinates);
                    if (controllerData.xrController && event.inputSource === controllerData.xrController.inputSource && controllerData.pick) {
                        this._scene.simulatePointerUp(controllerData.pick, pointerEventInit);
                        controllerData.selectionMesh.material.emissiveColor = this.selectionMeshDefaultColor;
                        controllerData.laserPointer.material.emissiveColor = this.laserPointerDefaultColor;
                    }
                });
            };
            controllerData.eventListeners = {
                selectend: selectEndListener,
                selectstart: selectStartListener
            };
            this._xrSessionManager.session.addEventListener("selectstart", selectStartListener);
            this._xrSessionManager.session.addEventListener("selectend", selectEndListener);
        }
    }
    _convertNormalToDirectionOfRay(normal, ray) {
        if (normal) {
            const angle = Math.acos((0, $ha1VO.Vector3).Dot(normal, ray.direction));
            if (angle < Math.PI / 2) normal.scaleInPlace(-1);
        }
        return normal;
    }
    _detachController(xrControllerUniqueId) {
        const controllerData = this._controllers[xrControllerUniqueId];
        if (!controllerData) return;
        if (controllerData.selectionComponent) {
            if (controllerData.onButtonChangedObserver) controllerData.selectionComponent.onButtonStateChangedObservable.remove(controllerData.onButtonChangedObserver);
        }
        if (controllerData.onFrameObserver) this._xrSessionManager.onXRFrameObservable.remove(controllerData.onFrameObserver);
        if (controllerData.eventListeners) Object.keys(controllerData.eventListeners).forEach((eventName)=>{
            const func = controllerData.eventListeners && controllerData.eventListeners[eventName];
            if (func) // For future reference - this is an issue in the WebXR typings.
            this._xrSessionManager.session.removeEventListener(eventName, func);
        });
        if (!controllerData.finalPointerUpTriggered && controllerData.pointerDownTriggered) {
            // Stay safe and fire a pointerup, in case it wasn't already triggered
            const pointerEventInit = {
                pointerId: controllerData.id,
                pointerType: "xr"
            };
            this._xrSessionManager.runInXRFrame(()=>{
                this._augmentPointerInit(pointerEventInit, controllerData.id, controllerData.screenCoordinates);
                this._scene.simulatePointerUp(controllerData.pick || new (0, $gzCma.PickingInfo)(), pointerEventInit);
                controllerData.finalPointerUpTriggered = true;
            });
        }
        this._xrSessionManager.scene.onBeforeRenderObservable.addOnce(()=>{
            try {
                controllerData.selectionMesh.dispose();
                controllerData.laserPointer.dispose();
                // remove from the map
                delete this._controllers[xrControllerUniqueId];
                if (this._attachedController === xrControllerUniqueId) {
                    // check for other controllers
                    const keys = Object.keys(this._controllers);
                    if (keys.length) this._attachedController = keys[0];
                    else this._attachedController = "";
                }
            } catch (e) {
                (0, $bOhSV.Tools).Warn("controller already detached.");
            }
        });
    }
    _generateNewMeshPair(meshParent) {
        const sceneToRenderTo = this._options.useUtilityLayer ? this._options.customUtilityLayerScene || (0, $6mCYU.UtilityLayerRenderer).DefaultUtilityLayer.utilityLayerScene : this._scene;
        const laserPointer = this._options.customLasterPointerMeshGenerator ? this._options.customLasterPointerMeshGenerator() : (0, $9zY5k.CreateCylinder)("laserPointer", {
            height: 1,
            diameterTop: 0.0002,
            diameterBottom: 0.004,
            tessellation: 20,
            subdivisions: 1
        }, sceneToRenderTo);
        laserPointer.parent = meshParent;
        const laserPointerMaterial = new (0, $gAH3H.StandardMaterial)("laserPointerMat", sceneToRenderTo);
        laserPointerMaterial.emissiveColor = this.laserPointerDefaultColor;
        laserPointerMaterial.alpha = 0.7;
        laserPointer.material = laserPointerMaterial;
        laserPointer.rotation.x = Math.PI / 2;
        this._updatePointerDistance(laserPointer, 1);
        laserPointer.isPickable = false;
        laserPointer.isVisible = false;
        // Create a gaze tracker for the  XR controller
        const selectionMesh = this._options.customSelectionMeshGenerator ? this._options.customSelectionMeshGenerator() : (0, $bCJrn.CreateTorus)("gazeTracker", {
            diameter: 0.0105,
            thickness: 0.0075,
            tessellation: 20
        }, sceneToRenderTo);
        selectionMesh.bakeCurrentTransformIntoVertices();
        selectionMesh.isPickable = false;
        selectionMesh.isVisible = false;
        const targetMat = new (0, $gAH3H.StandardMaterial)("targetMat", sceneToRenderTo);
        targetMat.specularColor = (0, $7etnY.Color3).Black();
        targetMat.emissiveColor = this.selectionMeshDefaultColor;
        targetMat.backFaceCulling = false;
        selectionMesh.material = targetMat;
        if (this._options.renderingGroupId !== undefined) {
            laserPointer.renderingGroupId = this._options.renderingGroupId;
            selectionMesh.renderingGroupId = this._options.renderingGroupId;
        }
        return {
            laserPointer: laserPointer,
            selectionMesh: selectionMesh
        };
    }
    _pickingMoved(oldPick, newPick) {
        if (!oldPick.hit || !newPick.hit) return true;
        if (!oldPick.pickedMesh || !oldPick.pickedPoint || !newPick.pickedMesh || !newPick.pickedPoint) return true;
        if (oldPick.pickedMesh !== newPick.pickedMesh) return true;
        oldPick.pickedPoint?.subtractToRef(newPick.pickedPoint, this._tmpVectorForPickCompare);
        this._tmpVectorForPickCompare.set(Math.abs(this._tmpVectorForPickCompare.x), Math.abs(this._tmpVectorForPickCompare.y), Math.abs(this._tmpVectorForPickCompare.z));
        const delta = (this._options.gazeModePointerMovedFactor || 1) * 0.01 * newPick.distance;
        const length = this._tmpVectorForPickCompare.length();
        if (length > delta) return true;
        return false;
    }
    _updatePointerDistance(_laserPointer, distance = 100) {
        _laserPointer.scaling.y = distance;
        // a bit of distance from the controller
        if (this._scene.useRightHandedSystem) distance *= -1;
        _laserPointer.position.z = distance / 2 + 0.05;
    }
    _augmentPointerInit(pointerEventInit, id, screenCoordinates) {
        pointerEventInit.pointerId = id;
        pointerEventInit.pointerType = "xr";
        if (screenCoordinates) {
            pointerEventInit.screenX = screenCoordinates.x;
            pointerEventInit.screenY = screenCoordinates.y;
        }
    }
    /** @internal */ get lasterPointerDefaultColor() {
        // here due to a typo
        return this.laserPointerDefaultColor;
    }
}
$01d19797b977817b$export$f4b08e719fa2f192._IdCounter = 200;
/**
 * The module's name
 */ $01d19797b977817b$export$f4b08e719fa2f192.Name = (0, $cJN7d.WebXRFeatureName).POINTER_SELECTION;
/**
 * The (Babylon) version of this module.
 * This is an integer representing the implementation version.
 * This number does not correspond to the WebXR specs version
 */ $01d19797b977817b$export$f4b08e719fa2f192.Version = 1;
//register the plugin
(0, $cJN7d.WebXRFeaturesManager).AddWebXRFeature($01d19797b977817b$export$f4b08e719fa2f192.Name, (xrSessionManager, options)=>{
    return ()=>new $01d19797b977817b$export$f4b08e719fa2f192(xrSessionManager, options);
}, $01d19797b977817b$export$f4b08e719fa2f192.Version, true);

});

parcelRegister("gw4bf", function(module, exports) {

$parcel$export(module.exports, "WebXRNearControllerMode", () => $c062e0a9d02930f6$export$f807ba0099691b47);
$parcel$export(module.exports, "WebXRNearInteraction", () => $c062e0a9d02930f6$export$4aa57b4ddae15469);

var $cJN7d = parcelRequire("cJN7d");

var $8KqOo = parcelRequire("8KqOo");

var $ha1VO = parcelRequire("ha1VO");

var $3kez7 = parcelRequire("3kez7");

var $gzCma = parcelRequire("gzCma");

var $2YzP2 = parcelRequire("2YzP2");

var $6mCYU = parcelRequire("6mCYU");

var $aC4Bv = parcelRequire("aC4Bv");

var $gAH3H = parcelRequire("gAH3H");

var $7etnY = parcelRequire("7etnY");

var $5fNQr = parcelRequire("5fNQr");

var $lWogh = parcelRequire("lWogh");

var $01TD7 = parcelRequire("01TD7");
parcelRequire("4A7HA");
// Tracks the interaction animation state when using a motion controller with a near interaction orb
var $c062e0a9d02930f6$var$ControllerOrbAnimationState;
(function(ControllerOrbAnimationState) {
    /**
     * Orb is invisible
     */ ControllerOrbAnimationState[ControllerOrbAnimationState["DEHYDRATED"] = 0] = "DEHYDRATED";
    /**
     * Orb is visible and inside the hover range
     */ ControllerOrbAnimationState[ControllerOrbAnimationState["HOVER"] = 1] = "HOVER";
    /**
     * Orb is visible and touching a near interaction target
     */ ControllerOrbAnimationState[ControllerOrbAnimationState["TOUCH"] = 2] = "TOUCH";
})($c062e0a9d02930f6$var$ControllerOrbAnimationState || ($c062e0a9d02930f6$var$ControllerOrbAnimationState = {}));
var $c062e0a9d02930f6$export$f807ba0099691b47;
(function(WebXRNearControllerMode) {
    /**
     * Motion controllers will not support near interaction
     */ WebXRNearControllerMode[WebXRNearControllerMode["DISABLED"] = 0] = "DISABLED";
    /**
     * The interaction point for motion controllers will be inside of them
     */ WebXRNearControllerMode[WebXRNearControllerMode["CENTERED_ON_CONTROLLER"] = 1] = "CENTERED_ON_CONTROLLER";
    /**
     * The interaction point for motion controllers will be in front of the controller
     */ WebXRNearControllerMode[WebXRNearControllerMode["CENTERED_IN_FRONT"] = 2] = "CENTERED_IN_FRONT";
})($c062e0a9d02930f6$export$f807ba0099691b47 || ($c062e0a9d02930f6$export$f807ba0099691b47 = {}));
class $c062e0a9d02930f6$export$4aa57b4ddae15469 extends (0, $2YzP2.WebXRAbstractFeature) {
    /**
     * constructs a new background remover module
     * @param _xrSessionManager the session manager for this module
     * @param _options read-only options to be used in this module
     */ constructor(_xrSessionManager, _options){
        super(_xrSessionManager);
        this._options = _options;
        this._tmpRay = new (0, $3kez7.Ray)(new (0, $ha1VO.Vector3)(), new (0, $ha1VO.Vector3)());
        this._attachController = (xrController)=>{
            if (this._controllers[xrController.uniqueId]) // already attached
            return;
            // get two new meshes
            const { touchCollisionMesh: touchCollisionMesh, touchCollisionMeshFunction: touchCollisionMeshFunction, hydrateCollisionMeshFunction: hydrateCollisionMeshFunction } = this._generateNewTouchPointMesh();
            const selectionMesh = this._generateVisualCue();
            this._controllers[xrController.uniqueId] = {
                xrController: xrController,
                meshUnderPointer: null,
                nearInteractionTargetMesh: null,
                pick: null,
                stalePick: null,
                touchCollisionMesh: touchCollisionMesh,
                touchCollisionMeshFunction: touchCollisionMeshFunction,
                hydrateCollisionMeshFunction: hydrateCollisionMeshFunction,
                currentAnimationState: $c062e0a9d02930f6$var$ControllerOrbAnimationState.DEHYDRATED,
                grabRay: new (0, $3kez7.Ray)(new (0, $ha1VO.Vector3)(), new (0, $ha1VO.Vector3)()),
                hoverInteraction: false,
                nearInteraction: false,
                grabInteraction: false,
                downTriggered: false,
                id: $c062e0a9d02930f6$export$4aa57b4ddae15469._IdCounter++,
                pickedPointVisualCue: selectionMesh
            };
            this._controllers[xrController.uniqueId]._worldScaleObserver = this._controllers[xrController.uniqueId]._worldScaleObserver || this._xrSessionManager.onWorldScaleFactorChangedObservable.add((values)=>{
                if (values.newScaleFactor !== values.previousScaleFactor) {
                    this._controllers[xrController.uniqueId].touchCollisionMesh.dispose();
                    this._controllers[xrController.uniqueId].pickedPointVisualCue.dispose();
                    const { touchCollisionMesh: touchCollisionMesh, touchCollisionMeshFunction: touchCollisionMeshFunction, hydrateCollisionMeshFunction: hydrateCollisionMeshFunction } = this._generateNewTouchPointMesh();
                    this._controllers[xrController.uniqueId].touchCollisionMesh = touchCollisionMesh;
                    this._controllers[xrController.uniqueId].touchCollisionMeshFunction = touchCollisionMeshFunction;
                    this._controllers[xrController.uniqueId].hydrateCollisionMeshFunction = hydrateCollisionMeshFunction;
                    this._controllers[xrController.uniqueId].pickedPointVisualCue = this._generateVisualCue();
                }
            });
            if (this._attachedController) {
                if (!this._options.enableNearInteractionOnAllControllers && this._options.preferredHandedness && xrController.inputSource.handedness === this._options.preferredHandedness) this._attachedController = xrController.uniqueId;
            } else if (!this._options.enableNearInteractionOnAllControllers) this._attachedController = xrController.uniqueId;
            switch(xrController.inputSource.targetRayMode){
                case "tracked-pointer":
                    return this._attachNearInteractionMode(xrController);
                case "gaze":
                    return null;
                case "screen":
                    return null;
            }
        };
        this._controllers = {};
        this._farInteractionFeature = null;
        /**
         * default color of the selection ring
         */ this.selectionMeshDefaultColor = new (0, $7etnY.Color3)(0.8, 0.8, 0.8);
        /**
         * This color will be applied to the selection ring when selection is triggered
         */ this.selectionMeshPickedColor = new (0, $7etnY.Color3)(0.3, 0.3, 1.0);
        this._hoverRadius = 0.1;
        this._pickRadius = 0.02;
        this._controllerPickRadius = 0.03; // The radius is slightly larger here to make it easier to manipulate since it's not tied to the hand position
        this._nearGrabLengthScale = 5;
        this._scene = this._xrSessionManager.scene;
        if (this._options.nearInteractionControllerMode === undefined) this._options.nearInteractionControllerMode = $c062e0a9d02930f6$export$f807ba0099691b47.CENTERED_IN_FRONT;
        if (this._options.farInteractionFeature) this._farInteractionFeature = this._options.farInteractionFeature;
    }
    /**
     * Attach this feature
     * Will usually be called by the features manager
     *
     * @returns true if successful.
     */ attach() {
        if (!super.attach()) return false;
        this._options.xrInput.controllers.forEach(this._attachController);
        this._addNewAttachObserver(this._options.xrInput.onControllerAddedObservable, this._attachController);
        this._addNewAttachObserver(this._options.xrInput.onControllerRemovedObservable, (controller)=>{
            // REMOVE the controller
            this._detachController(controller.uniqueId);
        });
        this._scene.constantlyUpdateMeshUnderPointer = true;
        return true;
    }
    /**
     * Detach this feature.
     * Will usually be called by the features manager
     *
     * @returns true if successful.
     */ detach() {
        if (!super.detach()) return false;
        Object.keys(this._controllers).forEach((controllerId)=>{
            this._detachController(controllerId);
        });
        return true;
    }
    /**
     * Will get the mesh under a specific pointer.
     * `scene.meshUnderPointer` will only return one mesh - either left or right.
     * @param controllerId the controllerId to check
     * @returns The mesh under pointer or null if no mesh is under the pointer
     */ getMeshUnderPointer(controllerId) {
        if (this._controllers[controllerId]) return this._controllers[controllerId].meshUnderPointer;
        else return null;
    }
    /**
     * Get the xr controller that correlates to the pointer id in the pointer event
     *
     * @param id the pointer id to search for
     * @returns the controller that correlates to this id or null if not found
     */ getXRControllerByPointerId(id) {
        const keys = Object.keys(this._controllers);
        for(let i = 0; i < keys.length; ++i){
            if (this._controllers[keys[i]].id === id) return this._controllers[keys[i]].xrController || null;
        }
        return null;
    }
    /**
     * This function sets webXRControllerPointerSelection feature that will be disabled when
     * the hover range is reached for a mesh and will be reattached when not in hover range.
     * This is used to remove the selection rays when moving.
     * @param farInteractionFeature the feature to disable when finger is in hover range for a mesh
     */ setFarInteractionFeature(farInteractionFeature) {
        this._farInteractionFeature = farInteractionFeature;
    }
    /**
     * Filter used for near interaction pick and hover
     * @param mesh the mesh candidate to be pick-filtered
     * @returns if the mesh should be included in the list of candidate meshes for near interaction
     */ _nearPickPredicate(mesh) {
        return mesh.isEnabled() && mesh.isVisible && mesh.isPickable && mesh.isNearPickable;
    }
    /**
     * Filter used for near interaction grab
     * @param mesh the mesh candidate to be pick-filtered
     * @returns if the mesh should be included in the list of candidate meshes for near interaction
     */ _nearGrabPredicate(mesh) {
        return mesh.isEnabled() && mesh.isVisible && mesh.isPickable && mesh.isNearGrabbable;
    }
    /**
     * Filter used for any near interaction
     * @param mesh the mesh candidate to be pick-filtered
     * @returns if the mesh should be included in the list of candidate meshes for near interaction
     */ _nearInteractionPredicate(mesh) {
        return mesh.isEnabled() && mesh.isVisible && mesh.isPickable && (mesh.isNearPickable || mesh.isNearGrabbable);
    }
    _controllerAvailablePredicate(mesh, controllerId) {
        let parent = mesh;
        while(parent){
            if (parent.reservedDataStore && parent.reservedDataStore.nearInteraction && parent.reservedDataStore.nearInteraction.excludedControllerId === controllerId) return false;
            parent = parent.parent;
        }
        return true;
    }
    _handleTransitionAnimation(controllerData, newState) {
        if (controllerData.currentAnimationState === newState || this._options.nearInteractionControllerMode !== $c062e0a9d02930f6$export$f807ba0099691b47.CENTERED_IN_FRONT || !!controllerData.xrController?.inputSource.hand) return;
        // Don't always break to allow for animation fallthrough on rare cases of multi-transitions
        if (newState > controllerData.currentAnimationState) switch(controllerData.currentAnimationState){
            case $c062e0a9d02930f6$var$ControllerOrbAnimationState.DEHYDRATED:
                controllerData.hydrateCollisionMeshFunction(true);
                if (newState === $c062e0a9d02930f6$var$ControllerOrbAnimationState.HOVER) break;
            // eslint-disable-next-line no-fallthrough
            case $c062e0a9d02930f6$var$ControllerOrbAnimationState.HOVER:
                controllerData.touchCollisionMeshFunction(true);
                if (newState === $c062e0a9d02930f6$var$ControllerOrbAnimationState.TOUCH) break;
        }
        else switch(controllerData.currentAnimationState){
            case $c062e0a9d02930f6$var$ControllerOrbAnimationState.TOUCH:
                controllerData.touchCollisionMeshFunction(false);
                if (newState === $c062e0a9d02930f6$var$ControllerOrbAnimationState.HOVER) break;
            // eslint-disable-next-line no-fallthrough
            case $c062e0a9d02930f6$var$ControllerOrbAnimationState.HOVER:
                controllerData.hydrateCollisionMeshFunction(false);
                if (newState === $c062e0a9d02930f6$var$ControllerOrbAnimationState.DEHYDRATED) break;
        }
        controllerData.currentAnimationState = newState;
    }
    _processTouchPoint(id, position, orientation) {
        const controllerData = this._controllers[id];
        // Position and orientation could be temporary values, se we take care of them before calling any functions that use temporary vectors/quaternions
        controllerData.grabRay.origin.copyFrom(position);
        orientation.toEulerAnglesToRef((0, $ha1VO.TmpVectors).Vector3[0]);
        controllerData.grabRay.direction.copyFrom((0, $ha1VO.TmpVectors).Vector3[0]);
        if (this._options.nearInteractionControllerMode === $c062e0a9d02930f6$export$f807ba0099691b47.CENTERED_IN_FRONT && !controllerData.xrController?.inputSource.hand) {
            // offset the touch point in the direction the transform is facing
            controllerData.xrController.getWorldPointerRayToRef(this._tmpRay);
            controllerData.grabRay.origin.addInPlace(this._tmpRay.direction.scale(0.05));
        }
        controllerData.grabRay.length = this._nearGrabLengthScale * this._hoverRadius * this._xrSessionManager.worldScalingFactor;
        controllerData.touchCollisionMesh.position.copyFrom(controllerData.grabRay.origin).scaleInPlace(this._xrSessionManager.worldScalingFactor);
    }
    _onXRFrame(_xrFrame) {
        Object.keys(this._controllers).forEach((id)=>{
            // only do this for the selected pointer
            const controllerData = this._controllers[id];
            const handData = controllerData.xrController?.inputSource.hand;
            // If near interaction is not enabled/available for this controller, return early
            if (!this._options.enableNearInteractionOnAllControllers && id !== this._attachedController || !controllerData.xrController || !handData && (!this._options.nearInteractionControllerMode || !controllerData.xrController.inputSource.gamepad)) {
                controllerData.pick = null;
                return;
            }
            controllerData.hoverInteraction = false;
            controllerData.nearInteraction = false;
            // Every frame check collisions/input
            if (controllerData.xrController) {
                if (handData) {
                    const xrIndexTip = handData.get("index-finger-tip");
                    if (xrIndexTip) {
                        const indexTipPose = _xrFrame.getJointPose(xrIndexTip, this._xrSessionManager.referenceSpace);
                        if (indexTipPose && indexTipPose.transform) {
                            const axisRHSMultiplier = this._scene.useRightHandedSystem ? 1 : -1;
                            (0, $ha1VO.TmpVectors).Vector3[0].set(indexTipPose.transform.position.x, indexTipPose.transform.position.y, indexTipPose.transform.position.z * axisRHSMultiplier);
                            (0, $ha1VO.TmpVectors).Quaternion[0].set(indexTipPose.transform.orientation.x, indexTipPose.transform.orientation.y, indexTipPose.transform.orientation.z * axisRHSMultiplier, indexTipPose.transform.orientation.w * axisRHSMultiplier);
                            this._processTouchPoint(id, (0, $ha1VO.TmpVectors).Vector3[0], (0, $ha1VO.TmpVectors).Quaternion[0]);
                        }
                    }
                } else if (controllerData.xrController.inputSource.gamepad && this._options.nearInteractionControllerMode !== $c062e0a9d02930f6$export$f807ba0099691b47.DISABLED) {
                    let controllerPose = controllerData.xrController.pointer;
                    if (controllerData.xrController.grip && this._options.nearInteractionControllerMode === $c062e0a9d02930f6$export$f807ba0099691b47.CENTERED_ON_CONTROLLER) controllerPose = controllerData.xrController.grip;
                    this._processTouchPoint(id, controllerPose.position, controllerPose.rotationQuaternion);
                }
            } else return;
            const accuratePickInfo = (originalScenePick, utilityScenePick)=>{
                let pick = null;
                if (!utilityScenePick || !utilityScenePick.hit) // No hit in utility scene
                pick = originalScenePick;
                else if (!originalScenePick || !originalScenePick.hit) // No hit in original scene
                pick = utilityScenePick;
                else if (utilityScenePick.distance < originalScenePick.distance) // Hit is closer in utility scene
                pick = utilityScenePick;
                else // Hit is closer in original scene
                pick = originalScenePick;
                return pick;
            };
            const populateNearInteractionInfo = (nearInteractionInfo)=>{
                let result = new (0, $gzCma.PickingInfo)();
                let nearInteractionAtOrigin = false;
                const nearInteraction = nearInteractionInfo && nearInteractionInfo.pickedPoint && nearInteractionInfo.hit;
                if (nearInteractionInfo?.pickedPoint) nearInteractionAtOrigin = nearInteractionInfo.pickedPoint.x === 0 && nearInteractionInfo.pickedPoint.y === 0 && nearInteractionInfo.pickedPoint.z === 0;
                if (nearInteraction && !nearInteractionAtOrigin) result = nearInteractionInfo;
                return result;
            };
            // Don't perform touch logic while grabbing, to prevent triggering touch interactions while in the middle of a grab interaction
            // Dont update cursor logic either - the cursor should already be visible for the grab to be in range,
            // and in order to maintain its position on the target mesh it is parented for the duration of the grab.
            if (!controllerData.grabInteraction) {
                let pick = null;
                // near interaction hover
                let utilitySceneHoverPick = null;
                if (this._options.useUtilityLayer && this._utilityLayerScene) utilitySceneHoverPick = this._pickWithSphere(controllerData, this._hoverRadius * this._xrSessionManager.worldScalingFactor, this._utilityLayerScene, (mesh)=>this._nearInteractionPredicate(mesh));
                const originalSceneHoverPick = this._pickWithSphere(controllerData, this._hoverRadius * this._xrSessionManager.worldScalingFactor, this._scene, (mesh)=>this._nearInteractionPredicate(mesh));
                const hoverPickInfo = accuratePickInfo(originalSceneHoverPick, utilitySceneHoverPick);
                if (hoverPickInfo && hoverPickInfo.hit) {
                    pick = populateNearInteractionInfo(hoverPickInfo);
                    if (pick.hit) controllerData.hoverInteraction = true;
                }
                // near interaction pick
                if (controllerData.hoverInteraction) {
                    let utilitySceneNearPick = null;
                    const radius = (handData ? this._pickRadius : this._controllerPickRadius) * this._xrSessionManager.worldScalingFactor;
                    if (this._options.useUtilityLayer && this._utilityLayerScene) utilitySceneNearPick = this._pickWithSphere(controllerData, radius, this._utilityLayerScene, (mesh)=>this._nearPickPredicate(mesh));
                    const originalSceneNearPick = this._pickWithSphere(controllerData, radius, this._scene, (mesh)=>this._nearPickPredicate(mesh));
                    const pickInfo = accuratePickInfo(originalSceneNearPick, utilitySceneNearPick);
                    const nearPick = populateNearInteractionInfo(pickInfo);
                    if (nearPick.hit) {
                        // Near pick takes precedence over hover interaction
                        pick = nearPick;
                        controllerData.nearInteraction = true;
                    }
                }
                controllerData.stalePick = controllerData.pick;
                controllerData.pick = pick;
                // Update mesh under pointer
                if (controllerData.pick && controllerData.pick.pickedPoint && controllerData.pick.hit) {
                    controllerData.meshUnderPointer = controllerData.pick.pickedMesh;
                    controllerData.pickedPointVisualCue.position.copyFrom(controllerData.pick.pickedPoint);
                    controllerData.pickedPointVisualCue.isVisible = true;
                    if (this._farInteractionFeature && this._farInteractionFeature.attached) this._farInteractionFeature._setPointerSelectionDisabledByPointerId(controllerData.id, true);
                } else {
                    controllerData.meshUnderPointer = null;
                    controllerData.pickedPointVisualCue.isVisible = false;
                    if (this._farInteractionFeature && this._farInteractionFeature.attached) this._farInteractionFeature._setPointerSelectionDisabledByPointerId(controllerData.id, false);
                }
            }
            // Update the interaction animation. Only updates if the visible touch mesh is active
            let state = $c062e0a9d02930f6$var$ControllerOrbAnimationState.DEHYDRATED;
            if (controllerData.grabInteraction || controllerData.nearInteraction) state = $c062e0a9d02930f6$var$ControllerOrbAnimationState.TOUCH;
            else if (controllerData.hoverInteraction) state = $c062e0a9d02930f6$var$ControllerOrbAnimationState.HOVER;
            this._handleTransitionAnimation(controllerData, state);
        });
    }
    get _utilityLayerScene() {
        return this._options.customUtilityLayerScene || (0, $6mCYU.UtilityLayerRenderer).DefaultUtilityLayer.utilityLayerScene;
    }
    _generateVisualCue() {
        const sceneToRenderTo = this._options.useUtilityLayer ? this._options.customUtilityLayerScene || (0, $6mCYU.UtilityLayerRenderer).DefaultUtilityLayer.utilityLayerScene : this._scene;
        const selectionMesh = (0, $8KqOo.CreateSphere)("nearInteraction", {
            diameter: 0.0105 * this._xrSessionManager.worldScalingFactor
        }, sceneToRenderTo);
        selectionMesh.bakeCurrentTransformIntoVertices();
        selectionMesh.isPickable = false;
        selectionMesh.isVisible = false;
        selectionMesh.rotationQuaternion = (0, $ha1VO.Quaternion).Identity();
        const targetMat = new (0, $gAH3H.StandardMaterial)("targetMat", sceneToRenderTo);
        targetMat.specularColor = (0, $7etnY.Color3).Black();
        targetMat.emissiveColor = this.selectionMeshDefaultColor;
        targetMat.backFaceCulling = false;
        selectionMesh.material = targetMat;
        return selectionMesh;
    }
    _isControllerReadyForNearInteraction(id) {
        if (this._farInteractionFeature) return this._farInteractionFeature._getPointerSelectionDisabledByPointerId(id);
        return true;
    }
    _attachNearInteractionMode(xrController) {
        const controllerData = this._controllers[xrController.uniqueId];
        const pointerEventInit = {
            pointerId: controllerData.id,
            pointerType: "xr-near"
        };
        controllerData.onFrameObserver = this._xrSessionManager.onXRFrameObservable.add(()=>{
            if (!this._options.enableNearInteractionOnAllControllers && xrController.uniqueId !== this._attachedController || !controllerData.xrController || !controllerData.xrController.inputSource.hand && (!this._options.nearInteractionControllerMode || !controllerData.xrController.inputSource.gamepad)) return;
            if (controllerData.pick) controllerData.pick.ray = controllerData.grabRay;
            if (controllerData.pick && this._isControllerReadyForNearInteraction(controllerData.id)) this._scene.simulatePointerMove(controllerData.pick, pointerEventInit);
            // Near pick pointer event
            if (controllerData.nearInteraction && controllerData.pick && controllerData.pick.hit) {
                if (!controllerData.nearInteractionTargetMesh) {
                    this._scene.simulatePointerDown(controllerData.pick, pointerEventInit);
                    controllerData.nearInteractionTargetMesh = controllerData.meshUnderPointer;
                    controllerData.downTriggered = true;
                }
            } else if (controllerData.nearInteractionTargetMesh && controllerData.stalePick) {
                this._scene.simulatePointerUp(controllerData.stalePick, pointerEventInit);
                controllerData.downTriggered = false;
                controllerData.nearInteractionTargetMesh = null;
            }
        });
        const grabCheck = (pressed)=>{
            if (this._options.enableNearInteractionOnAllControllers || xrController.uniqueId === this._attachedController && this._isControllerReadyForNearInteraction(controllerData.id)) {
                if (controllerData.pick) controllerData.pick.ray = controllerData.grabRay;
                if (pressed && controllerData.pick && controllerData.meshUnderPointer && this._nearGrabPredicate(controllerData.meshUnderPointer)) {
                    controllerData.grabInteraction = true;
                    controllerData.pickedPointVisualCue.isVisible = false;
                    this._scene.simulatePointerDown(controllerData.pick, pointerEventInit);
                    controllerData.downTriggered = true;
                } else if (!pressed && controllerData.pick && controllerData.grabInteraction) {
                    this._scene.simulatePointerUp(controllerData.pick, pointerEventInit);
                    controllerData.downTriggered = false;
                    controllerData.grabInteraction = false;
                    controllerData.pickedPointVisualCue.isVisible = true;
                }
            } else if (pressed && !this._options.enableNearInteractionOnAllControllers && !this._options.disableSwitchOnClick) this._attachedController = xrController.uniqueId;
        };
        if (xrController.inputSource.gamepad) {
            const init = (motionController)=>{
                controllerData.squeezeComponent = motionController.getComponent("grasp");
                if (controllerData.squeezeComponent) controllerData.onSqueezeButtonChangedObserver = controllerData.squeezeComponent.onButtonStateChangedObservable.add((component)=>{
                    if (component.changes.pressed) {
                        const pressed = component.changes.pressed.current;
                        grabCheck(pressed);
                    }
                });
                else {
                    controllerData.selectionComponent = motionController.getMainComponent();
                    controllerData.onButtonChangedObserver = controllerData.selectionComponent.onButtonStateChangedObservable.add((component)=>{
                        if (component.changes.pressed) {
                            const pressed = component.changes.pressed.current;
                            grabCheck(pressed);
                        }
                    });
                }
            };
            if (xrController.motionController) init(xrController.motionController);
            else xrController.onMotionControllerInitObservable.add(init);
        } else {
            // use the select and squeeze events
            const selectStartListener = (event)=>{
                if (controllerData.xrController && event.inputSource === controllerData.xrController.inputSource && controllerData.pick && this._isControllerReadyForNearInteraction(controllerData.id) && controllerData.meshUnderPointer && this._nearGrabPredicate(controllerData.meshUnderPointer)) {
                    controllerData.grabInteraction = true;
                    controllerData.pickedPointVisualCue.isVisible = false;
                    this._scene.simulatePointerDown(controllerData.pick, pointerEventInit);
                    controllerData.downTriggered = true;
                }
            };
            const selectEndListener = (event)=>{
                if (controllerData.xrController && event.inputSource === controllerData.xrController.inputSource && controllerData.pick && this._isControllerReadyForNearInteraction(controllerData.id)) {
                    this._scene.simulatePointerUp(controllerData.pick, pointerEventInit);
                    controllerData.grabInteraction = false;
                    controllerData.pickedPointVisualCue.isVisible = true;
                    controllerData.downTriggered = false;
                }
            };
            controllerData.eventListeners = {
                selectend: selectEndListener,
                selectstart: selectStartListener
            };
            this._xrSessionManager.session.addEventListener("selectstart", selectStartListener);
            this._xrSessionManager.session.addEventListener("selectend", selectEndListener);
        }
    }
    _detachController(xrControllerUniqueId) {
        const controllerData = this._controllers[xrControllerUniqueId];
        if (!controllerData) return;
        if (controllerData.squeezeComponent) {
            if (controllerData.onSqueezeButtonChangedObserver) controllerData.squeezeComponent.onButtonStateChangedObservable.remove(controllerData.onSqueezeButtonChangedObserver);
        }
        if (controllerData.selectionComponent) {
            if (controllerData.onButtonChangedObserver) controllerData.selectionComponent.onButtonStateChangedObservable.remove(controllerData.onButtonChangedObserver);
        }
        if (controllerData.onFrameObserver) this._xrSessionManager.onXRFrameObservable.remove(controllerData.onFrameObserver);
        if (controllerData.eventListeners) Object.keys(controllerData.eventListeners).forEach((eventName)=>{
            const func = controllerData.eventListeners && controllerData.eventListeners[eventName];
            if (func) this._xrSessionManager.session.removeEventListener(eventName, func);
        });
        controllerData.touchCollisionMesh.dispose();
        controllerData.pickedPointVisualCue.dispose();
        this._xrSessionManager.runInXRFrame(()=>{
            if (!controllerData.downTriggered) return;
            // Fire a pointerup in case controller was detached before a pointerup event was fired
            const pointerEventInit = {
                pointerId: controllerData.id,
                pointerType: "xr-near"
            };
            this._scene.simulatePointerUp(new (0, $gzCma.PickingInfo)(), pointerEventInit);
        });
        // remove world scale observer
        if (controllerData._worldScaleObserver) this._xrSessionManager.onWorldScaleFactorChangedObservable.remove(controllerData._worldScaleObserver);
        // remove from the map
        delete this._controllers[xrControllerUniqueId];
        if (this._attachedController === xrControllerUniqueId) {
            // check for other controllers
            const keys = Object.keys(this._controllers);
            if (keys.length) this._attachedController = keys[0];
            else this._attachedController = "";
        }
    }
    _generateNewTouchPointMesh() {
        const worldScale = this._xrSessionManager.worldScalingFactor;
        // populate information for near hover, pick and pinch
        const meshCreationScene = this._options.useUtilityLayer ? this._options.customUtilityLayerScene || (0, $6mCYU.UtilityLayerRenderer).DefaultUtilityLayer.utilityLayerScene : this._scene;
        const touchCollisionMesh = (0, $8KqOo.CreateSphere)("PickSphere", {
            diameter: 1 * worldScale
        }, meshCreationScene);
        touchCollisionMesh.isVisible = false;
        // Generate the material for the touch mesh visuals
        if (this._options.motionControllerOrbMaterial) touchCollisionMesh.material = this._options.motionControllerOrbMaterial;
        else (0, $5fNQr.NodeMaterial).ParseFromSnippetAsync("8RUNKL#3", meshCreationScene).then((nodeMaterial)=>{
            touchCollisionMesh.material = nodeMaterial;
        });
        const easingFunction = new (0, $01TD7.QuadraticEase)();
        easingFunction.setEasingMode((0, $01TD7.EasingFunction).EASINGMODE_EASEINOUT);
        // Adjust the visual size based off of the size of the touch collision orb.
        // Having the size perfectly match for hover gives a more accurate tell for when the user will start interacting with the target
        // Sizes for other states are somewhat arbitrary, as they are based on what feels nice during an interaction
        const hoverSizeVec = new (0, $ha1VO.Vector3)(this._controllerPickRadius, this._controllerPickRadius, this._controllerPickRadius).scaleInPlace(worldScale);
        const touchSize = this._controllerPickRadius * (4 / 3);
        const touchSizeVec = new (0, $ha1VO.Vector3)(touchSize, touchSize, touchSize).scaleInPlace(worldScale);
        const hydrateTransitionSize = this._controllerPickRadius * (7 / 6);
        const hydrateTransitionSizeVec = new (0, $ha1VO.Vector3)(hydrateTransitionSize, hydrateTransitionSize, hydrateTransitionSize).scaleInPlace(worldScale);
        const touchHoverTransitionSize = this._controllerPickRadius * 0.8;
        const touchHoverTransitionSizeVec = new (0, $ha1VO.Vector3)(touchHoverTransitionSize, touchHoverTransitionSize, touchHoverTransitionSize).scaleInPlace(worldScale);
        const hoverTouchTransitionSize = this._controllerPickRadius * 1.5;
        const hoverTouchTransitionSizeVec = new (0, $ha1VO.Vector3)(hoverTouchTransitionSize, hoverTouchTransitionSize, hoverTouchTransitionSize).scaleInPlace(worldScale);
        const touchKeys = [
            {
                frame: 0,
                value: hoverSizeVec
            },
            {
                frame: 10,
                value: hoverTouchTransitionSizeVec
            },
            {
                frame: 18,
                value: touchSizeVec
            }
        ];
        const releaseKeys = [
            {
                frame: 0,
                value: touchSizeVec
            },
            {
                frame: 10,
                value: touchHoverTransitionSizeVec
            },
            {
                frame: 18,
                value: hoverSizeVec
            }
        ];
        const hydrateKeys = [
            {
                frame: 0,
                value: (0, $ha1VO.Vector3).ZeroReadOnly
            },
            {
                frame: 12,
                value: hydrateTransitionSizeVec
            },
            {
                frame: 15,
                value: hoverSizeVec
            }
        ];
        const dehydrateKeys = [
            {
                frame: 0,
                value: hoverSizeVec
            },
            {
                frame: 10,
                value: (0, $ha1VO.Vector3).ZeroReadOnly
            },
            {
                frame: 15,
                value: (0, $ha1VO.Vector3).ZeroReadOnly
            }
        ];
        const touchAction = new (0, $lWogh.Animation)("touch", "scaling", 60, (0, $lWogh.Animation).ANIMATIONTYPE_VECTOR3, (0, $lWogh.Animation).ANIMATIONLOOPMODE_CONSTANT);
        const releaseAction = new (0, $lWogh.Animation)("release", "scaling", 60, (0, $lWogh.Animation).ANIMATIONTYPE_VECTOR3, (0, $lWogh.Animation).ANIMATIONLOOPMODE_CONSTANT);
        const hydrateAction = new (0, $lWogh.Animation)("hydrate", "scaling", 60, (0, $lWogh.Animation).ANIMATIONTYPE_VECTOR3, (0, $lWogh.Animation).ANIMATIONLOOPMODE_CONSTANT);
        const dehydrateAction = new (0, $lWogh.Animation)("dehydrate", "scaling", 60, (0, $lWogh.Animation).ANIMATIONTYPE_VECTOR3, (0, $lWogh.Animation).ANIMATIONLOOPMODE_CONSTANT);
        touchAction.setEasingFunction(easingFunction);
        releaseAction.setEasingFunction(easingFunction);
        hydrateAction.setEasingFunction(easingFunction);
        dehydrateAction.setEasingFunction(easingFunction);
        touchAction.setKeys(touchKeys);
        releaseAction.setKeys(releaseKeys);
        hydrateAction.setKeys(hydrateKeys);
        dehydrateAction.setKeys(dehydrateKeys);
        const touchCollisionMeshFunction = (isTouch)=>{
            const action = isTouch ? touchAction : releaseAction;
            meshCreationScene.beginDirectAnimation(touchCollisionMesh, [
                action
            ], 0, 18, false, 1);
        };
        const hydrateCollisionMeshFunction = (isHydration)=>{
            const action = isHydration ? hydrateAction : dehydrateAction;
            if (isHydration) touchCollisionMesh.isVisible = true;
            meshCreationScene.beginDirectAnimation(touchCollisionMesh, [
                action
            ], 0, 15, false, 1, ()=>{
                if (!isHydration) touchCollisionMesh.isVisible = false;
            });
        };
        return {
            touchCollisionMesh: touchCollisionMesh,
            touchCollisionMeshFunction: touchCollisionMeshFunction,
            hydrateCollisionMeshFunction: hydrateCollisionMeshFunction
        };
    }
    _pickWithSphere(controllerData, radius, sceneToUse, predicate) {
        const pickingInfo = new (0, $gzCma.PickingInfo)();
        pickingInfo.distance = Infinity;
        if (controllerData.touchCollisionMesh && controllerData.xrController) {
            const position = controllerData.touchCollisionMesh.position;
            const sphere = (0, $aC4Bv.BoundingSphere).CreateFromCenterAndRadius(position, radius);
            for(let meshIndex = 0; meshIndex < sceneToUse.meshes.length; meshIndex++){
                const mesh = sceneToUse.meshes[meshIndex];
                if (!predicate(mesh) || !this._controllerAvailablePredicate(mesh, controllerData.xrController.uniqueId)) continue;
                const result = $c062e0a9d02930f6$export$4aa57b4ddae15469.PickMeshWithSphere(mesh, sphere);
                if (result && result.hit && result.distance < pickingInfo.distance) {
                    pickingInfo.hit = result.hit;
                    pickingInfo.pickedMesh = mesh;
                    pickingInfo.pickedPoint = result.pickedPoint;
                    pickingInfo.aimTransform = controllerData.xrController.pointer;
                    pickingInfo.gripTransform = controllerData.xrController.grip || null;
                    pickingInfo.originMesh = controllerData.touchCollisionMesh;
                    pickingInfo.distance = result.distance;
                    pickingInfo.bu = result.bu;
                    pickingInfo.bv = result.bv;
                    pickingInfo.faceId = result.faceId;
                    pickingInfo.subMeshId = result.subMeshId;
                }
            }
        }
        return pickingInfo;
    }
    /**
     * Picks a mesh with a sphere
     * @param mesh the mesh to pick
     * @param sphere picking sphere in world coordinates
     * @param skipBoundingInfo a boolean indicating if we should skip the bounding info check
     * @returns the picking info
     */ static PickMeshWithSphere(mesh, sphere, skipBoundingInfo = false) {
        const subMeshes = mesh.subMeshes;
        const pi = new (0, $gzCma.PickingInfo)();
        const boundingInfo = mesh.getBoundingInfo();
        if (!mesh._generatePointsArray()) return pi;
        if (!mesh.subMeshes || !boundingInfo) return pi;
        if (!skipBoundingInfo && !(0, $aC4Bv.BoundingSphere).Intersects(boundingInfo.boundingSphere, sphere)) return pi;
        const result = (0, $ha1VO.TmpVectors).Vector3[0];
        const tmpVec = (0, $ha1VO.TmpVectors).Vector3[1];
        const tmpRay = new (0, $3kez7.Ray)((0, $ha1VO.Vector3).Zero(), (0, $ha1VO.Vector3).Zero(), 1);
        let distance = Infinity;
        let tmp, tmpDistanceSphereToCenter, tmpDistanceSurfaceToCenter, intersectionInfo;
        const center = (0, $ha1VO.TmpVectors).Vector3[2];
        const worldToMesh = (0, $ha1VO.TmpVectors).Matrix[0];
        worldToMesh.copyFrom(mesh.getWorldMatrix());
        worldToMesh.invert();
        (0, $ha1VO.Vector3).TransformCoordinatesToRef(sphere.center, worldToMesh, center);
        for(let index = 0; index < subMeshes.length; index++){
            const subMesh = subMeshes[index];
            subMesh.projectToRef(center, mesh._positions, mesh.getIndices(), tmpVec);
            (0, $ha1VO.Vector3).TransformCoordinatesToRef(tmpVec, mesh.getWorldMatrix(), tmpVec);
            tmp = (0, $ha1VO.Vector3).Distance(tmpVec, sphere.center);
            // Check for finger inside of mesh
            tmpDistanceSurfaceToCenter = (0, $ha1VO.Vector3).Distance(tmpVec, mesh.getAbsolutePosition());
            tmpDistanceSphereToCenter = (0, $ha1VO.Vector3).Distance(sphere.center, mesh.getAbsolutePosition());
            if (tmpDistanceSphereToCenter !== -1 && tmpDistanceSurfaceToCenter !== -1 && tmpDistanceSurfaceToCenter > tmpDistanceSphereToCenter) {
                tmp = 0;
                tmpVec.copyFrom(sphere.center);
            }
            if (tmp !== -1 && tmp < distance) {
                distance = tmp;
                // ray between the sphere center and the point on the mesh
                (0, $3kez7.Ray).CreateFromToToRef(sphere.center, tmpVec, tmpRay);
                tmpRay.length = distance * 2;
                intersectionInfo = tmpRay.intersectsMesh(mesh);
                result.copyFrom(tmpVec);
            }
        }
        if (distance < sphere.radius) {
            pi.hit = true;
            pi.distance = distance;
            pi.pickedMesh = mesh;
            pi.pickedPoint = result.clone();
            if (intersectionInfo && intersectionInfo.bu !== null && intersectionInfo.bv !== null) {
                pi.faceId = intersectionInfo.faceId;
                pi.subMeshId = intersectionInfo.subMeshId;
                pi.bu = intersectionInfo.bu;
                pi.bv = intersectionInfo.bv;
            }
        }
        return pi;
    }
}
$c062e0a9d02930f6$export$4aa57b4ddae15469._IdCounter = 200;
/**
 * The module's name
 */ $c062e0a9d02930f6$export$4aa57b4ddae15469.Name = (0, $cJN7d.WebXRFeatureName).NEAR_INTERACTION;
/**
 * The (Babylon) version of this module.
 * This is an integer representing the implementation version.
 * This number does not correspond to the WebXR specs version
 */ $c062e0a9d02930f6$export$4aa57b4ddae15469.Version = 1;
//Register the plugin
(0, $cJN7d.WebXRFeaturesManager).AddWebXRFeature($c062e0a9d02930f6$export$4aa57b4ddae15469.Name, (xrSessionManager, options)=>{
    return ()=>new $c062e0a9d02930f6$export$4aa57b4ddae15469(xrSessionManager, options);
}, $c062e0a9d02930f6$export$4aa57b4ddae15469.Version, true);

});
parcelRegister("4A7HA", function(module, exports) {

var $ha1VO = parcelRequire("ha1VO");

var $lEBSs = parcelRequire("lEBSs");
/**
 * @internal
 */ (0, $lEBSs.SubMesh).prototype._projectOnTrianglesToRef = function(vector, positions, indices, step, checkStopper, ref) {
    // Triangles test
    const proj = (0, $ha1VO.TmpVectors).Vector3[0];
    const tmp = (0, $ha1VO.TmpVectors).Vector3[1];
    let distance = Infinity;
    for(let index = this.indexStart; index < this.indexStart + this.indexCount - (3 - step); index += step){
        const indexA = indices[index];
        const indexB = indices[index + 1];
        const indexC = indices[index + 2];
        if (checkStopper && indexC === 0xffffffff) {
            index += 2;
            continue;
        }
        const p0 = positions[indexA];
        const p1 = positions[indexB];
        const p2 = positions[indexC];
        // stay defensive and don't check against undefined positions.
        if (!p0 || !p1 || !p2) continue;
        const tmpDist = (0, $ha1VO.Vector3).ProjectOnTriangleToRef(vector, p0, p1, p2, tmp);
        if (tmpDist < distance) {
            proj.copyFrom(tmp);
            distance = tmpDist;
        }
    }
    ref.copyFrom(proj);
    return distance;
};
/**
 * @internal
 */ (0, $lEBSs.SubMesh).prototype._projectOnUnIndexedTrianglesToRef = function(vector, positions, indices, ref) {
    // Triangles test
    const proj = (0, $ha1VO.TmpVectors).Vector3[0];
    const tmp = (0, $ha1VO.TmpVectors).Vector3[1];
    let distance = Infinity;
    for(let index = this.verticesStart; index < this.verticesStart + this.verticesCount; index += 3){
        const p0 = positions[index];
        const p1 = positions[index + 1];
        const p2 = positions[index + 2];
        const tmpDist = (0, $ha1VO.Vector3).ProjectOnTriangleToRef(vector, p0, p1, p2, tmp);
        if (tmpDist < distance) {
            proj.copyFrom(tmp);
            distance = tmpDist;
        }
    }
    ref.copyFrom(proj);
    return distance;
};
(0, $lEBSs.SubMesh).prototype.projectToRef = function(vector, positions, indices, ref) {
    const material = this.getMaterial();
    if (!material) return -1;
    let step = 3;
    let checkStopper = false;
    switch(material.fillMode){
        case 3:
        case 5:
        case 6:
        case 8:
            return -1;
        case 7:
            step = 1;
            checkStopper = true;
            break;
        default:
            break;
    }
    // LineMesh first as it's also a Mesh...
    if (material.fillMode === 4) return -1;
    else {
        // Check if mesh is unindexed
        if (!indices.length && this._mesh._unIndexed) return this._projectOnUnIndexedTrianglesToRef(vector, positions, indices, ref);
        return this._projectOnTrianglesToRef(vector, positions, indices, step, checkStopper, ref);
    }
};

});


parcelRegister("h2dFw", function(module, exports) {

$parcel$export(module.exports, "WebXREnterExitUIButton", () => $c66d39e9d07e17a0$export$20d6c66047606d8);
$parcel$export(module.exports, "WebXREnterExitUIOptions", () => $c66d39e9d07e17a0$export$7605963696f404ea);
$parcel$export(module.exports, "WebXREnterExitUI", () => $c66d39e9d07e17a0$export$d375c25f9afef55c);

var $diGQf = parcelRequire("diGQf");

var $jknux = parcelRequire("jknux");

var $bOhSV = parcelRequire("bOhSV");
class $c66d39e9d07e17a0$export$20d6c66047606d8 {
    /**
     * Creates a WebXREnterExitUIButton
     * @param element button element
     * @param sessionMode XR initialization session mode
     * @param referenceSpaceType the type of reference space to be used
     */ constructor(/** button element */ element, /** XR initialization options for the button */ sessionMode, /** Reference space type */ referenceSpaceType){
        this.element = element;
        this.sessionMode = sessionMode;
        this.referenceSpaceType = referenceSpaceType;
    }
    /**
     * Extendable function which can be used to update the button's visuals when the state changes
     * @param activeButton the current active button in the UI
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    update(activeButton) {}
}
class $c66d39e9d07e17a0$export$7605963696f404ea {
}
class $c66d39e9d07e17a0$export$d375c25f9afef55c {
    /**
     * Construct a new EnterExit UI class
     *
     * @param _scene babylon scene object to use
     * @param options (read-only) version of the options passed to this UI
     */ constructor(_scene, /** version of the options passed to this UI */ options){
        this._scene = _scene;
        this.options = options;
        this._activeButton = null;
        this._buttons = [];
        /**
         * Fired every time the active button is changed.
         *
         * When xr is entered via a button that launches xr that button will be the callback parameter
         *
         * When exiting xr the callback parameter will be null)
         */ this.activeButtonChangedObservable = new (0, $diGQf.Observable)();
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this._onSessionGranted = (evt)=>{
            // This section is for future reference.
            // As per specs, evt.session.mode should have the supported session mode, but no browser supports it for now.
            // // check if the session granted is the same as the one requested
            // const grantedMode = (evt.session as any).mode;
            // if (grantedMode) {
            //     this._buttons.some((btn, idx) => {
            //         if (btn.sessionMode === grantedMode) {
            //             this._enterXRWithButtonIndex(idx);
            //             return true;
            //         }
            //         return false;
            //     });
            // } else
            if (this._helper) this._enterXRWithButtonIndex(0);
        };
        this.overlay = document.createElement("div");
        this.overlay.classList.add("xr-button-overlay");
        // prepare for session granted event
        if (!options.ignoreSessionGrantedEvent && navigator.xr) navigator.xr.addEventListener("sessiongranted", this._onSessionGranted);
        // if served over HTTP, warn people.
        // Hopefully the browsers will catch up
        if (typeof window !== "undefined") {
            if (window.location && window.location.protocol === "http:" && window.location.hostname !== "localhost") {
                (0, $bOhSV.Tools).Warn("WebXR can only be served over HTTPS");
                throw new Error("WebXR can only be served over HTTPS");
            }
        }
        if (options.customButtons) this._buttons = options.customButtons;
        else {
            this.overlay.style.cssText = "z-index:11;position: absolute; right: 20px;bottom: 50px;";
            const sessionMode = options.sessionMode || "immersive-vr";
            const referenceSpaceType = options.referenceSpaceType || "local-floor";
            const url = typeof SVGSVGElement === "undefined" ? "https://cdn.babylonjs.com/Assets/vrButton.png" : "data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A//www.w3.org/2000/svg%22%20width%3D%222048%22%20height%3D%221152%22%20viewBox%3D%220%200%202048%201152%22%20version%3D%221.1%22%3E%3Cpath%20transform%3D%22rotate%28180%201024%2C576.0000000000001%29%22%20d%3D%22m1109%2C896q17%2C0%2030%2C-12t13%2C-30t-12.5%2C-30.5t-30.5%2C-12.5l-170%2C0q-18%2C0%20-30.5%2C12.5t-12.5%2C30.5t13%2C30t30%2C12l170%2C0zm-85%2C256q59%2C0%20132.5%2C-1.5t154.5%2C-5.5t164.5%2C-11.5t163%2C-20t150%2C-30t124.5%2C-41.5q23%2C-11%2042%2C-24t38%2C-30q27%2C-25%2041%2C-61.5t14%2C-72.5l0%2C-257q0%2C-123%20-47%2C-232t-128%2C-190t-190%2C-128t-232%2C-47l-81%2C0q-37%2C0%20-68.5%2C14t-60.5%2C34.5t-55.5%2C45t-53%2C45t-53%2C34.5t-55.5%2C14t-55.5%2C-14t-53%2C-34.5t-53%2C-45t-55.5%2C-45t-60.5%2C-34.5t-68.5%2C-14l-81%2C0q-123%2C0%20-232%2C47t-190%2C128t-128%2C190t-47%2C232l0%2C257q0%2C68%2038%2C115t97%2C73q54%2C24%20124.5%2C41.5t150%2C30t163%2C20t164.5%2C11.5t154.5%2C5.5t132.5%2C1.5zm939%2C-298q0%2C39%20-24.5%2C67t-58.5%2C42q-54%2C23%20-122%2C39.5t-143.5%2C28t-155.5%2C19t-157%2C11t-148.5%2C5t-129.5%2C1.5q-59%2C0%20-130%2C-1.5t-148%2C-5t-157%2C-11t-155.5%2C-19t-143.5%2C-28t-122%2C-39.5q-34%2C-14%20-58.5%2C-42t-24.5%2C-67l0%2C-257q0%2C-106%2040.5%2C-199t110%2C-162.5t162.5%2C-109.5t199%2C-40l81%2C0q27%2C0%2052%2C14t50%2C34.5t51%2C44.5t55.5%2C44.5t63.5%2C34.5t74%2C14t74%2C-14t63.5%2C-34.5t55.5%2C-44.5t51%2C-44.5t50%2C-34.5t52%2C-14l14%2C0q37%2C0%2070%2C0.5t64.5%2C4.5t63.5%2C12t68%2C23q71%2C30%20128.5%2C78.5t98.5%2C110t63.5%2C133.5t22.5%2C149l0%2C257z%22%20fill%3D%22white%22%20/%3E%3C/svg%3E%0A";
            let css = ".babylonVRicon { color: #868686; border-color: #868686; border-style: solid; margin-left: 10px; height: 50px; width: 80px; background-color: rgba(51,51,51,0.7); background-image: url(" + url + "); background-size: 80%; background-repeat:no-repeat; background-position: center; border: none; outline: none; transition: transform 0.125s ease-out } .babylonVRicon:hover { transform: scale(1.05) } .babylonVRicon:active {background-color: rgba(51,51,51,1) } .babylonVRicon:focus {background-color: rgba(51,51,51,1) }";
            css += '.babylonVRicon.vrdisplaypresenting { background-image: none;} .vrdisplaypresenting::after { content: "EXIT"} .xr-error::after { content: "ERROR"}';
            const style = document.createElement("style");
            style.appendChild(document.createTextNode(css));
            document.getElementsByTagName("head")[0].appendChild(style);
            const hmdBtn = document.createElement("button");
            hmdBtn.className = "babylonVRicon";
            hmdBtn.title = `${sessionMode} - ${referenceSpaceType}`;
            this._buttons.push(new $c66d39e9d07e17a0$export$20d6c66047606d8(hmdBtn, sessionMode, referenceSpaceType));
            this._buttons[this._buttons.length - 1].update = function(activeButton) {
                this.element.style.display = activeButton === null || activeButton === this ? "" : "none";
                hmdBtn.className = "babylonVRicon" + (activeButton === this ? " vrdisplaypresenting" : "");
            };
            this._updateButtons(null);
        }
        const renderCanvas = _scene.getEngine().getInputElement();
        if (renderCanvas && renderCanvas.parentNode) {
            renderCanvas.parentNode.appendChild(this.overlay);
            _scene.onDisposeObservable.addOnce(()=>{
                this.dispose();
            });
        }
    }
    /**
     * Set the helper to be used with this UI component.
     * The UI is bound to an experience helper. If not provided the UI can still be used but the events should be registered by the developer.
     *
     * @param helper the experience helper to attach
     * @param renderTarget an optional render target (in case it is created outside of the helper scope)
     * @returns a promise that resolves when the ui is ready
     */ async setHelperAsync(helper, renderTarget) {
        this._helper = helper;
        this._renderTarget = renderTarget;
        const supportedPromises = this._buttons.map((btn)=>{
            return helper.sessionManager.isSessionSupportedAsync(btn.sessionMode);
        });
        helper.onStateChangedObservable.add((state)=>{
            if (state == (0, $jknux.WebXRState).NOT_IN_XR) this._updateButtons(null);
        });
        const results = await Promise.all(supportedPromises);
        results.forEach((supported, i)=>{
            if (supported) {
                this.overlay.appendChild(this._buttons[i].element);
                this._buttons[i].element.onclick = this._enterXRWithButtonIndex.bind(this, i);
            } else (0, $bOhSV.Tools).Warn(`Session mode "${this._buttons[i].sessionMode}" not supported in browser`);
        });
    }
    /**
     * Creates UI to allow the user to enter/exit XR mode
     * @param scene the scene to add the ui to
     * @param helper the xr experience helper to enter/exit xr with
     * @param options options to configure the UI
     * @returns the created ui
     */ static async CreateAsync(scene, helper, options) {
        const ui = new $c66d39e9d07e17a0$export$d375c25f9afef55c(scene, options);
        await ui.setHelperAsync(helper, options.renderTarget || undefined);
        return ui;
    }
    async _enterXRWithButtonIndex(idx = 0) {
        if (this._helper.state == (0, $jknux.WebXRState).IN_XR) {
            await this._helper.exitXRAsync();
            this._updateButtons(null);
        } else if (this._helper.state == (0, $jknux.WebXRState).NOT_IN_XR) try {
            await this._helper.enterXRAsync(this._buttons[idx].sessionMode, this._buttons[idx].referenceSpaceType, this._renderTarget, {
                optionalFeatures: this.options.optionalFeatures,
                requiredFeatures: this.options.requiredFeatures
            });
            this._updateButtons(this._buttons[idx]);
        } catch (e) {
            // make sure button is visible
            this._updateButtons(null);
            const element = this._buttons[idx].element;
            const prevTitle = element.title;
            element.title = "Error entering XR session : " + prevTitle;
            element.classList.add("xr-error");
            if (this.options.onError) this.options.onError(e);
        }
    }
    /**
     * Disposes of the XR UI component
     */ dispose() {
        const renderCanvas = this._scene.getEngine().getInputElement();
        if (renderCanvas && renderCanvas.parentNode && renderCanvas.parentNode.contains(this.overlay)) renderCanvas.parentNode.removeChild(this.overlay);
        this.activeButtonChangedObservable.clear();
        navigator.xr.removeEventListener("sessiongranted", this._onSessionGranted);
    }
    _updateButtons(activeButton) {
        this._activeButton = activeButton;
        this._buttons.forEach((b)=>{
            b.update(this._activeButton);
        });
        this.activeButtonChangedObservable.notifyObservers(this._activeButton);
    }
}

});

parcelRegister("laic7", function(module, exports) {

$parcel$export(module.exports, "WebXRMotionControllerTeleportation", () => $f688a52fdccf36e5$export$fbb54262c41eef9a);

var $cJN7d = parcelRequire("cJN7d");

var $diGQf = parcelRequire("diGQf");

var $f9SMB = parcelRequire("f9SMB");

var $ha1VO = parcelRequire("ha1VO");

var $3kez7 = parcelRequire("3kez7");

var $fJfwX = parcelRequire("fJfwX");

var $9zY5k = parcelRequire("9zY5k");

var $01TD7 = parcelRequire("01TD7");

var $lWogh = parcelRequire("lWogh");

var $dbxbu = parcelRequire("dbxbu");

var $gAH3H = parcelRequire("gAH3H");

var $8CiHO = parcelRequire("8CiHO");

var $bCJrn = parcelRequire("bCJrn");

var $fm2C6 = parcelRequire("fm2C6");

var $8Eyol = parcelRequire("8Eyol");

var $2YzP2 = parcelRequire("2YzP2");

var $7etnY = parcelRequire("7etnY");

var $6mCYU = parcelRequire("6mCYU");

var $cfkw4 = parcelRequire("cfkw4");

var $2PCL1 = parcelRequire("2PCL1");
class $f688a52fdccf36e5$export$fbb54262c41eef9a extends (0, $2YzP2.WebXRAbstractFeature) {
    /**
     * Is rotation enabled when moving forward?
     * Disabling this feature will prevent the user from deciding the direction when teleporting
     */ get rotationEnabled() {
        return this._rotationEnabled;
    }
    /**
     * Sets whether rotation is enabled or not
     * @param enabled is rotation enabled when teleportation is shown
     */ set rotationEnabled(enabled) {
        this._rotationEnabled = enabled;
        if (this._options.teleportationTargetMesh) {
            const children = this._options.teleportationTargetMesh.getChildMeshes(false, (node)=>node.name === "rotationCone");
            if (children[0]) children[0].setEnabled(enabled);
        }
    }
    /**
     * Exposes the currently set teleportation target mesh.
     */ get teleportationTargetMesh() {
        return this._options.teleportationTargetMesh || null;
    }
    /**
     * constructs a new teleportation system
     * @param _xrSessionManager an instance of WebXRSessionManager
     * @param _options configuration object for this feature
     */ constructor(_xrSessionManager, _options){
        super(_xrSessionManager);
        this._options = _options;
        this._controllers = {};
        this._snappedToPoint = false;
        this._cachedColor4White = new (0, $7etnY.Color4)(1, 1, 1, 1);
        this._tmpRay = new (0, $3kez7.Ray)(new (0, $ha1VO.Vector3)(), new (0, $ha1VO.Vector3)());
        this._tmpVector = new (0, $ha1VO.Vector3)();
        this._tmpQuaternion = new (0, $ha1VO.Quaternion)();
        this._worldScaleObserver = null;
        /**
         * Skip the next teleportation. This can be controlled by the user to prevent the user from teleportation
         * to sections that are not yet "unlocked", but should still show the teleportation mesh.
         */ this.skipNextTeleportation = false;
        /**
         * Is movement backwards enabled
         */ this.backwardsMovementEnabled = true;
        /**
         * Distance to travel when moving backwards
         */ this.backwardsTeleportationDistance = 0.7;
        /**
         * The distance from the user to the inspection point in the direction of the controller
         * A higher number will allow the user to move further
         * defaults to 5 (meters, in xr units)
         */ this.parabolicCheckRadius = 5;
        /**
         * Should the module support parabolic ray on top of direct ray
         * If enabled, the user will be able to point "at the sky" and move according to predefined radius distance
         * Very helpful when moving between floors / different heights
         */ this.parabolicRayEnabled = true;
        /**
         * The second type of ray - straight line.
         * Should it be enabled or should the parabolic line be the only one.
         */ this.straightRayEnabled = true;
        /**
         * How much rotation should be applied when rotating right and left
         */ this.rotationAngle = Math.PI / 8;
        /**
         * This observable will notify when the target mesh position was updated.
         * The picking info it provides contains the point to which the target mesh will move ()
         */ this.onTargetMeshPositionUpdatedObservable = new (0, $diGQf.Observable)();
        /**
         * Is teleportation enabled. Can be used to allow rotation only.
         */ this.teleportationEnabled = true;
        this._rotationEnabled = true;
        /**
         * Observable raised before camera rotation
         */ this.onBeforeCameraTeleportRotation = new (0, $diGQf.Observable)();
        /**
         *  Observable raised after camera rotation
         */ this.onAfterCameraTeleportRotation = new (0, $diGQf.Observable)();
        this._attachController = (xrController)=>{
            if (this._controllers[xrController.uniqueId] || this._options.forceHandedness && xrController.inputSource.handedness !== this._options.forceHandedness) // already attached
            return;
            this._controllers[xrController.uniqueId] = {
                xrController: xrController,
                teleportationState: {
                    forward: false,
                    backwards: false,
                    rotating: false,
                    currentRotation: 0,
                    baseRotation: 0,
                    blocked: false,
                    initialHit: false,
                    mainComponentUsed: false
                }
            };
            const controllerData = this._controllers[xrController.uniqueId];
            // motion controller only available to gamepad-enabled input sources.
            if (controllerData.xrController.inputSource.targetRayMode === "tracked-pointer" && controllerData.xrController.inputSource.gamepad) {
                // motion controller support
                const initMotionController = ()=>{
                    if (xrController.motionController) {
                        const movementController = xrController.motionController.getComponentOfType((0, $f9SMB.WebXRControllerComponent).THUMBSTICK_TYPE) || xrController.motionController.getComponentOfType((0, $f9SMB.WebXRControllerComponent).TOUCHPAD_TYPE);
                        if (!movementController || this._options.useMainComponentOnly) {
                            // use trigger to move on long press
                            const mainComponent = xrController.motionController.getMainComponent();
                            if (!mainComponent) return;
                            controllerData.teleportationState.mainComponentUsed = true;
                            controllerData.teleportationComponent = mainComponent;
                            controllerData.onButtonChangedObserver = mainComponent.onButtonStateChangedObservable.add(()=>{
                                if (!this.teleportationEnabled) return;
                                const teleportLocal = ()=>{
                                    // simulate "forward" thumbstick push
                                    controllerData.teleportationState.forward = true;
                                    controllerData.teleportationState.initialHit = false;
                                    this._currentTeleportationControllerId = controllerData.xrController.uniqueId;
                                    controllerData.teleportationState.baseRotation = this._options.xrInput.xrCamera.rotationQuaternion.toEulerAngles().y;
                                    controllerData.teleportationState.currentRotation = 0;
                                    const timeToSelect = this._options.timeToTeleport || 3000;
                                    (0, $2PCL1.setAndStartTimer)({
                                        timeout: timeToSelect,
                                        contextObservable: this._xrSessionManager.onXRFrameObservable,
                                        breakCondition: ()=>!mainComponent.pressed,
                                        onEnded: ()=>{
                                            if (this._currentTeleportationControllerId === controllerData.xrController.uniqueId && controllerData.teleportationState.forward) this._teleportForward(xrController.uniqueId);
                                        }
                                    });
                                };
                                // did "pressed" changed?
                                if (mainComponent.changes.pressed) {
                                    if (mainComponent.changes.pressed.current) {
                                        // delay if the start time is defined
                                        if (this._options.timeToTeleportStart) (0, $2PCL1.setAndStartTimer)({
                                            timeout: this._options.timeToTeleportStart,
                                            contextObservable: this._xrSessionManager.onXRFrameObservable,
                                            onEnded: ()=>{
                                                // check if still pressed
                                                if (mainComponent.pressed) teleportLocal();
                                            }
                                        });
                                        else teleportLocal();
                                    } else {
                                        controllerData.teleportationState.forward = false;
                                        this._currentTeleportationControllerId = "";
                                    }
                                }
                            });
                        } else {
                            controllerData.teleportationComponent = movementController;
                            // use thumbstick (or touchpad if thumbstick not available)
                            controllerData.onAxisChangedObserver = movementController.onAxisValueChangedObservable.add((axesData)=>{
                                if (axesData.y <= 0.7 && controllerData.teleportationState.backwards) controllerData.teleportationState.backwards = false;
                                if (axesData.y > 0.7 && !controllerData.teleportationState.forward && this.backwardsMovementEnabled && !this.snapPointsOnly) // teleport backwards
                                // General gist: Go Back N units, cast a ray towards the floor. If collided, move.
                                {
                                    if (!controllerData.teleportationState.backwards) {
                                        controllerData.teleportationState.backwards = true;
                                        // teleport backwards ONCE
                                        this._tmpQuaternion.copyFrom(this._options.xrInput.xrCamera.rotationQuaternion);
                                        this._tmpQuaternion.toEulerAnglesToRef(this._tmpVector);
                                        // get only the y rotation
                                        this._tmpVector.x = 0;
                                        this._tmpVector.z = 0;
                                        // get the quaternion
                                        (0, $ha1VO.Quaternion).FromEulerVectorToRef(this._tmpVector, this._tmpQuaternion);
                                        this._tmpVector.set(0, 0, this.backwardsTeleportationDistance * (this._xrSessionManager.scene.useRightHandedSystem ? 1.0 : -1));
                                        this._tmpVector.rotateByQuaternionToRef(this._tmpQuaternion, this._tmpVector);
                                        this._tmpVector.addInPlace(this._options.xrInput.xrCamera.position);
                                        this._tmpRay.origin.copyFrom(this._tmpVector);
                                        // This will prevent the user from "falling" to a lower platform!
                                        // TODO - should this be a flag? 'allow falling to lower platforms'?
                                        this._tmpRay.length = this._options.xrInput.xrCamera.realWorldHeight + 0.1;
                                        // Right handed system had here "1" instead of -1. This is unneeded.
                                        this._tmpRay.direction.set(0, -1, 0);
                                        const pick = this._xrSessionManager.scene.pickWithRay(this._tmpRay, (o)=>{
                                            return this._floorMeshes.indexOf(o) !== -1;
                                        });
                                        // pick must exist, but stay safe
                                        if (pick && pick.pickedPoint) {
                                            // Teleport the users feet to where they targeted. Ignore the Y axis.
                                            // If the "falling to lower platforms" feature is implemented the Y axis should be set here as well
                                            this._options.xrInput.xrCamera.position.x = pick.pickedPoint.x;
                                            this._options.xrInput.xrCamera.position.z = pick.pickedPoint.z;
                                        }
                                    }
                                }
                                if (axesData.y < -0.7 && !this._currentTeleportationControllerId && !controllerData.teleportationState.rotating && this.teleportationEnabled) {
                                    controllerData.teleportationState.forward = true;
                                    this._currentTeleportationControllerId = controllerData.xrController.uniqueId;
                                    controllerData.teleportationState.baseRotation = this._options.xrInput.xrCamera.rotationQuaternion.toEulerAngles().y;
                                }
                                if (axesData.x) {
                                    if (!controllerData.teleportationState.forward) {
                                        if (!controllerData.teleportationState.rotating && Math.abs(axesData.x) > 0.7) {
                                            // rotate in the right direction positive is right
                                            controllerData.teleportationState.rotating = true;
                                            const rotation = this.rotationAngle * (axesData.x > 0 ? 1 : -1) * (this._xrSessionManager.scene.useRightHandedSystem ? -1 : 1);
                                            this.onBeforeCameraTeleportRotation.notifyObservers(rotation);
                                            (0, $ha1VO.Quaternion).FromEulerAngles(0, rotation, 0).multiplyToRef(this._options.xrInput.xrCamera.rotationQuaternion, this._options.xrInput.xrCamera.rotationQuaternion);
                                            this.onAfterCameraTeleportRotation.notifyObservers(this._options.xrInput.xrCamera.rotationQuaternion);
                                        }
                                    } else if (this._currentTeleportationControllerId === controllerData.xrController.uniqueId) {
                                        // set the rotation of the forward movement
                                        if (this.rotationEnabled) setTimeout(()=>{
                                            controllerData.teleportationState.currentRotation = Math.atan2(axesData.x, axesData.y * (this._xrSessionManager.scene.useRightHandedSystem ? 1 : -1));
                                        });
                                        else controllerData.teleportationState.currentRotation = 0;
                                    }
                                } else controllerData.teleportationState.rotating = false;
                                if (axesData.x === 0 && axesData.y === 0) {
                                    if (controllerData.teleportationState.blocked) {
                                        controllerData.teleportationState.blocked = false;
                                        this._setTargetMeshVisibility(false);
                                    }
                                    if (controllerData.teleportationState.forward) this._teleportForward(xrController.uniqueId);
                                }
                            });
                        }
                    }
                };
                if (xrController.motionController) initMotionController();
                else xrController.onMotionControllerInitObservable.addOnce(()=>{
                    initMotionController();
                });
            } else {
                controllerData.teleportationState.mainComponentUsed = true;
                let breakObserver = false;
                const teleportLocal = ()=>{
                    this._currentTeleportationControllerId = controllerData.xrController.uniqueId;
                    controllerData.teleportationState.forward = true;
                    controllerData.teleportationState.initialHit = false;
                    controllerData.teleportationState.baseRotation = this._options.xrInput.xrCamera.rotationQuaternion.toEulerAngles().y;
                    controllerData.teleportationState.currentRotation = 0;
                    const timeToSelect = this._options.timeToTeleport || 3000;
                    (0, $2PCL1.setAndStartTimer)({
                        timeout: timeToSelect,
                        contextObservable: this._xrSessionManager.onXRFrameObservable,
                        onEnded: ()=>{
                            if (this._currentTeleportationControllerId === controllerData.xrController.uniqueId && controllerData.teleportationState.forward) this._teleportForward(xrController.uniqueId);
                        }
                    });
                };
                this._xrSessionManager.scene.onPointerObservable.add((pointerInfo)=>{
                    if (pointerInfo.type === (0, $cfkw4.PointerEventTypes).POINTERDOWN) {
                        breakObserver = false;
                        // check if start time is defined
                        if (this._options.timeToTeleportStart) (0, $2PCL1.setAndStartTimer)({
                            timeout: this._options.timeToTeleportStart,
                            contextObservable: this._xrSessionManager.onXRFrameObservable,
                            onEnded: ()=>{
                                // make sure pointer up was not triggered during this time
                                if (this._currentTeleportationControllerId === controllerData.xrController.uniqueId) teleportLocal();
                            },
                            breakCondition: ()=>{
                                if (breakObserver) {
                                    breakObserver = false;
                                    return true;
                                }
                                return false;
                            }
                        });
                        else teleportLocal();
                    } else if (pointerInfo.type === (0, $cfkw4.PointerEventTypes).POINTERUP) {
                        breakObserver = true;
                        controllerData.teleportationState.forward = false;
                        this._currentTeleportationControllerId = "";
                    }
                });
            }
        };
        this._colorArray = Array(24).fill(this._cachedColor4White);
        // create default mesh if not provided
        if (!this._options.teleportationTargetMesh) this._createDefaultTargetMesh();
        this._floorMeshes = this._options.floorMeshes || [];
        this._snapToPositions = this._options.snapPositions || [];
        this._blockedRayColor = this._options.blockedRayColor || new (0, $7etnY.Color4)(1, 0, 0, 0.75);
        this._setTargetMeshVisibility(false);
        // set the observables
        this.onBeforeCameraTeleport = _options.xrInput.xrCamera.onBeforeCameraTeleport;
        this.onAfterCameraTeleport = _options.xrInput.xrCamera.onAfterCameraTeleport;
        this.parabolicCheckRadius *= this._xrSessionManager.worldScalingFactor;
        this._worldScaleObserver = _xrSessionManager.onWorldScaleFactorChangedObservable.add((values)=>{
            this.parabolicCheckRadius = this.parabolicCheckRadius / values.previousScaleFactor * values.newScaleFactor;
            this._options.teleportationTargetMesh?.scaling.scaleInPlace(values.newScaleFactor / values.previousScaleFactor);
        });
    }
    /**
     * Get the snapPointsOnly flag
     */ get snapPointsOnly() {
        return !!this._options.snapPointsOnly;
    }
    /**
     * Sets the snapPointsOnly flag
     * @param snapToPoints should teleportation be exclusively to snap points
     */ set snapPointsOnly(snapToPoints) {
        this._options.snapPointsOnly = snapToPoints;
    }
    /**
     * Add a new mesh to the floor meshes array
     * @param mesh the mesh to use as floor mesh
     */ addFloorMesh(mesh) {
        this._floorMeshes.push(mesh);
    }
    /**
     * Add a mesh to the list of meshes blocking the teleportation ray
     * @param mesh The mesh to add to the teleportation-blocking meshes
     */ addBlockerMesh(mesh) {
        this._options.pickBlockerMeshes = this._options.pickBlockerMeshes || [];
        this._options.pickBlockerMeshes.push(mesh);
    }
    /**
     * Add a new snap-to point to fix teleportation to this position
     * @param newSnapPoint The new Snap-To point
     */ addSnapPoint(newSnapPoint) {
        this._snapToPositions.push(newSnapPoint);
    }
    attach() {
        if (!super.attach()) return false;
        // Safety reset
        this._currentTeleportationControllerId = "";
        this._options.xrInput.controllers.forEach(this._attachController);
        this._addNewAttachObserver(this._options.xrInput.onControllerAddedObservable, this._attachController);
        this._addNewAttachObserver(this._options.xrInput.onControllerRemovedObservable, (controller)=>{
            // REMOVE the controller
            this._detachController(controller.uniqueId);
        });
        return true;
    }
    detach() {
        if (!super.detach()) return false;
        Object.keys(this._controllers).forEach((controllerId)=>{
            this._detachController(controllerId);
        });
        this._setTargetMeshVisibility(false);
        this._currentTeleportationControllerId = "";
        this._controllers = {};
        return true;
    }
    dispose() {
        super.dispose();
        this._options.teleportationTargetMesh && this._options.teleportationTargetMesh.dispose(false, true);
        if (this._worldScaleObserver) this._xrSessionManager.onWorldScaleFactorChangedObservable.remove(this._worldScaleObserver);
    }
    /**
     * Remove a mesh from the floor meshes array
     * @param mesh the mesh to remove
     */ removeFloorMesh(mesh) {
        const index = this._floorMeshes.indexOf(mesh);
        if (index !== -1) this._floorMeshes.splice(index, 1);
    }
    /**
     * Remove a mesh from the blocker meshes array
     * @param mesh the mesh to remove
     */ removeBlockerMesh(mesh) {
        this._options.pickBlockerMeshes = this._options.pickBlockerMeshes || [];
        const index = this._options.pickBlockerMeshes.indexOf(mesh);
        if (index !== -1) this._options.pickBlockerMeshes.splice(index, 1);
    }
    /**
     * Remove a mesh from the floor meshes array using its name
     * @param name the mesh name to remove
     */ removeFloorMeshByName(name) {
        const mesh = this._xrSessionManager.scene.getMeshByName(name);
        if (mesh) this.removeFloorMesh(mesh);
    }
    /**
     * This function will iterate through the array, searching for this point or equal to it. It will then remove it from the snap-to array
     * @param snapPointToRemove the point (or a clone of it) to be removed from the array
     * @returns was the point found and removed or not
     */ removeSnapPoint(snapPointToRemove) {
        // check if the object is in the array
        let index = this._snapToPositions.indexOf(snapPointToRemove);
        // if not found as an object, compare to the points
        if (index === -1) {
            for(let i = 0; i < this._snapToPositions.length; ++i)// equals? index is i, break the loop
            if (this._snapToPositions[i].equals(snapPointToRemove)) {
                index = i;
                break;
            }
        }
        // index is not -1? remove the object
        if (index !== -1) {
            this._snapToPositions.splice(index, 1);
            return true;
        }
        return false;
    }
    /**
     * This function sets a selection feature that will be disabled when
     * the forward ray is shown and will be reattached when hidden.
     * This is used to remove the selection rays when moving.
     * @param selectionFeature the feature to disable when forward movement is enabled
     */ setSelectionFeature(selectionFeature) {
        this._selectionFeature = selectionFeature;
    }
    _onXRFrame(_xrFrame) {
        const frame = this._xrSessionManager.currentFrame;
        const scene = this._xrSessionManager.scene;
        if (!this.attach || !frame) return;
        // render target if needed
        const targetMesh = this._options.teleportationTargetMesh;
        if (this._currentTeleportationControllerId) {
            if (!targetMesh) return;
            targetMesh.rotationQuaternion = targetMesh.rotationQuaternion || new (0, $ha1VO.Quaternion)();
            const controllerData = this._controllers[this._currentTeleportationControllerId];
            if (controllerData && controllerData.teleportationState.forward) {
                // set the rotation
                (0, $ha1VO.Quaternion).RotationYawPitchRollToRef(controllerData.teleportationState.currentRotation + controllerData.teleportationState.baseRotation, 0, 0, targetMesh.rotationQuaternion);
                // set the ray and position
                let hitPossible = false;
                const controlSelectionFeature = controllerData.xrController.inputSource.targetRayMode !== "transient-pointer";
                controllerData.xrController.getWorldPointerRayToRef(this._tmpRay);
                if (this.straightRayEnabled) {
                    // first check if direct ray possible
                    // pick grounds that are LOWER only. upper will use parabolic path
                    const pick = scene.pickWithRay(this._tmpRay, (o)=>{
                        if (this._options.blockerMeshesPredicate && this._options.blockerMeshesPredicate(o)) return true;
                        if (this._options.blockAllPickableMeshes && o.isPickable) return true;
                        // check for mesh-blockers
                        if (this._options.pickBlockerMeshes && this._options.pickBlockerMeshes.indexOf(o) !== -1) return true;
                        const index = this._floorMeshes.indexOf(o);
                        if (index === -1) return false;
                        return this._floorMeshes[index].absolutePosition.y < this._options.xrInput.xrCamera.globalPosition.y;
                    });
                    const floorMeshPicked = pick && pick.pickedMesh && this._floorMeshes.indexOf(pick.pickedMesh) !== -1;
                    if (pick && pick.pickedMesh && !floorMeshPicked) {
                        if (controllerData.teleportationState.mainComponentUsed && !controllerData.teleportationState.initialHit) {
                            controllerData.teleportationState.forward = false;
                            return;
                        }
                        controllerData.teleportationState.blocked = true;
                        this._setTargetMeshVisibility(false, false, controlSelectionFeature);
                        this._showParabolicPath(pick);
                        return;
                    } else if (pick && pick.pickedPoint) {
                        controllerData.teleportationState.initialHit = true;
                        controllerData.teleportationState.blocked = false;
                        hitPossible = true;
                        this._setTargetMeshPosition(pick);
                        this._setTargetMeshVisibility(true, false, controlSelectionFeature);
                        this._showParabolicPath(pick);
                    }
                }
                // straight ray is still the main ray, but disabling the straight line will force parabolic line.
                if (this.parabolicRayEnabled && !hitPossible) {
                    // radius compensation according to pointer rotation around X
                    const xRotation = controllerData.xrController.pointer.rotationQuaternion.toEulerAngles().x;
                    const compensation = 1 + (Math.PI / 2 - Math.abs(xRotation));
                    // check parabolic ray
                    const radius = this.parabolicCheckRadius * compensation;
                    this._tmpRay.origin.addToRef(this._tmpRay.direction.scale(radius * 2), this._tmpVector);
                    this._tmpVector.y = this._tmpRay.origin.y;
                    this._tmpRay.origin.addInPlace(this._tmpRay.direction.scale(radius));
                    this._tmpVector.subtractToRef(this._tmpRay.origin, this._tmpRay.direction);
                    this._tmpRay.direction.normalize();
                    const pick = scene.pickWithRay(this._tmpRay, (o)=>{
                        if (this._options.blockerMeshesPredicate && this._options.blockerMeshesPredicate(o)) return true;
                        if (this._options.blockAllPickableMeshes && o.isPickable) return true;
                        // check for mesh-blockers
                        if (this._options.pickBlockerMeshes && this._options.pickBlockerMeshes.indexOf(o) !== -1) return true;
                        return this._floorMeshes.indexOf(o) !== -1;
                    });
                    const floorMeshPicked = pick && pick.pickedMesh && this._floorMeshes.indexOf(pick.pickedMesh) !== -1;
                    if (pick && pick.pickedMesh && !floorMeshPicked) {
                        if (controllerData.teleportationState.mainComponentUsed && !controllerData.teleportationState.initialHit) {
                            controllerData.teleportationState.forward = false;
                            return;
                        }
                        controllerData.teleportationState.blocked = true;
                        this._setTargetMeshVisibility(false, false, controlSelectionFeature);
                        this._showParabolicPath(pick);
                        return;
                    } else if (pick && pick.pickedPoint) {
                        controllerData.teleportationState.initialHit = true;
                        controllerData.teleportationState.blocked = false;
                        hitPossible = true;
                        this._setTargetMeshPosition(pick);
                        this._setTargetMeshVisibility(true, false, controlSelectionFeature);
                        this._showParabolicPath(pick);
                    }
                }
                // if needed, set visible:
                this._setTargetMeshVisibility(hitPossible, false, controlSelectionFeature);
            } else this._setTargetMeshVisibility(false, false, true);
        } else {
            this._disposeBezierCurve();
            this._setTargetMeshVisibility(false, false, true);
        }
    }
    _createDefaultTargetMesh() {
        // set defaults
        this._options.defaultTargetMeshOptions = this._options.defaultTargetMeshOptions || {};
        const sceneToRenderTo = this._options.useUtilityLayer ? this._options.customUtilityLayerScene || (0, $6mCYU.UtilityLayerRenderer).DefaultUtilityLayer.utilityLayerScene : this._xrSessionManager.scene;
        const teleportationTarget = (0, $8CiHO.CreateGround)("teleportationTarget", {
            width: 2,
            height: 2,
            subdivisions: 2
        }, sceneToRenderTo);
        teleportationTarget.isPickable = false;
        if (this._options.defaultTargetMeshOptions.teleportationCircleMaterial) teleportationTarget.material = this._options.defaultTargetMeshOptions.teleportationCircleMaterial;
        else {
            const length = 512;
            const dynamicTexture = new (0, $fJfwX.DynamicTexture)("teleportationPlaneDynamicTexture", length, sceneToRenderTo, true);
            dynamicTexture.hasAlpha = true;
            const context = dynamicTexture.getContext();
            const centerX = length / 2;
            const centerY = length / 2;
            const radius = 200;
            context.beginPath();
            context.arc(centerX, centerY, radius, 0, 2 * Math.PI, false);
            context.fillStyle = this._options.defaultTargetMeshOptions.teleportationFillColor || "#444444";
            context.fill();
            context.lineWidth = 10;
            context.strokeStyle = this._options.defaultTargetMeshOptions.teleportationBorderColor || "#FFFFFF";
            context.stroke();
            context.closePath();
            dynamicTexture.update();
            const teleportationCircleMaterial = new (0, $gAH3H.StandardMaterial)("teleportationPlaneMaterial", sceneToRenderTo);
            teleportationCircleMaterial.diffuseTexture = dynamicTexture;
            teleportationTarget.material = teleportationCircleMaterial;
        }
        const torus = (0, $bCJrn.CreateTorus)("torusTeleportation", {
            diameter: 0.75,
            thickness: 0.1,
            tessellation: 20
        }, sceneToRenderTo);
        torus.isPickable = false;
        torus.parent = teleportationTarget;
        if (!this._options.defaultTargetMeshOptions.disableAnimation) {
            const animationInnerCircle = new (0, $lWogh.Animation)("animationInnerCircle", "position.y", 30, (0, $lWogh.Animation).ANIMATIONTYPE_FLOAT, (0, $lWogh.Animation).ANIMATIONLOOPMODE_CYCLE);
            const keys = [];
            keys.push({
                frame: 0,
                value: 0
            });
            keys.push({
                frame: 30,
                value: 0.4
            });
            keys.push({
                frame: 60,
                value: 0
            });
            animationInnerCircle.setKeys(keys);
            const easingFunction = new (0, $01TD7.SineEase)();
            easingFunction.setEasingMode((0, $01TD7.EasingFunction).EASINGMODE_EASEINOUT);
            animationInnerCircle.setEasingFunction(easingFunction);
            torus.animations = [];
            torus.animations.push(animationInnerCircle);
            sceneToRenderTo.beginAnimation(torus, 0, 60, true);
        }
        const cone = (0, $9zY5k.CreateCylinder)("rotationCone", {
            diameterTop: 0,
            tessellation: 4
        }, sceneToRenderTo);
        cone.isPickable = false;
        cone.scaling.set(0.5, 0.12, 0.2);
        cone.rotate((0, $dbxbu.Axis).X, Math.PI / 2);
        cone.position.z = 0.6;
        cone.parent = torus;
        if (this._options.defaultTargetMeshOptions.torusArrowMaterial) {
            torus.material = this._options.defaultTargetMeshOptions.torusArrowMaterial;
            cone.material = this._options.defaultTargetMeshOptions.torusArrowMaterial;
        } else {
            const torusConeMaterial = new (0, $gAH3H.StandardMaterial)("torusConsMat", sceneToRenderTo);
            torusConeMaterial.disableLighting = !!this._options.defaultTargetMeshOptions.disableLighting;
            if (torusConeMaterial.disableLighting) torusConeMaterial.emissiveColor = new (0, $7etnY.Color3)(0.3, 0.3, 1.0);
            else torusConeMaterial.diffuseColor = new (0, $7etnY.Color3)(0.3, 0.3, 1.0);
            torusConeMaterial.alpha = 0.9;
            torus.material = torusConeMaterial;
            cone.material = torusConeMaterial;
            this._teleportationRingMaterial = torusConeMaterial;
        }
        if (this._options.renderingGroupId !== undefined) {
            teleportationTarget.renderingGroupId = this._options.renderingGroupId;
            torus.renderingGroupId = this._options.renderingGroupId;
            cone.renderingGroupId = this._options.renderingGroupId;
        }
        this._options.teleportationTargetMesh = teleportationTarget;
        this._options.teleportationTargetMesh.scaling.setAll(this._xrSessionManager.worldScalingFactor);
        // hide the teleportation target mesh right after creating it.
        this._setTargetMeshVisibility(false);
    }
    _detachController(xrControllerUniqueId) {
        const controllerData = this._controllers[xrControllerUniqueId];
        if (!controllerData) return;
        if (controllerData.teleportationComponent) {
            if (controllerData.onAxisChangedObserver) controllerData.teleportationComponent.onAxisValueChangedObservable.remove(controllerData.onAxisChangedObserver);
            if (controllerData.onButtonChangedObserver) controllerData.teleportationComponent.onButtonStateChangedObservable.remove(controllerData.onButtonChangedObserver);
        }
        // remove from the map
        delete this._controllers[xrControllerUniqueId];
    }
    _findClosestSnapPointWithRadius(realPosition, radius = this._options.snapToPositionRadius || 0.8) {
        let closestPoint = null;
        let closestDistance = Number.MAX_VALUE;
        if (this._snapToPositions.length) {
            const radiusSquared = radius * radius;
            this._snapToPositions.forEach((position)=>{
                const dist = (0, $ha1VO.Vector3).DistanceSquared(position, realPosition);
                if (dist <= radiusSquared && dist < closestDistance) {
                    closestDistance = dist;
                    closestPoint = position;
                }
            });
        }
        return closestPoint;
    }
    _setTargetMeshPosition(pickInfo) {
        const newPosition = pickInfo.pickedPoint;
        if (!this._options.teleportationTargetMesh || !newPosition) return;
        const snapPosition = this._findClosestSnapPointWithRadius(newPosition);
        this._snappedToPoint = !!snapPosition;
        if (this.snapPointsOnly && !this._snappedToPoint && this._teleportationRingMaterial) this._teleportationRingMaterial.diffuseColor.set(1.0, 0.3, 0.3);
        else if (this.snapPointsOnly && this._snappedToPoint && this._teleportationRingMaterial) this._teleportationRingMaterial.diffuseColor.set(0.3, 0.3, 1.0);
        this._options.teleportationTargetMesh.position.copyFrom(snapPosition || newPosition);
        this._options.teleportationTargetMesh.position.y += 0.01;
        this.onTargetMeshPositionUpdatedObservable.notifyObservers(pickInfo);
    }
    _setTargetMeshVisibility(visible, force, controlSelectionFeature) {
        if (!this._options.teleportationTargetMesh) return;
        if (this._options.teleportationTargetMesh.isVisible === visible && !force) return;
        this._options.teleportationTargetMesh.isVisible = visible;
        this._options.teleportationTargetMesh.getChildren(undefined, false).forEach((m)=>{
            m.isVisible = visible;
        });
        if (!visible) {
            if (this._quadraticBezierCurve) {
                this._quadraticBezierCurve.dispose();
                this._quadraticBezierCurve = null;
            }
            if (this._selectionFeature && controlSelectionFeature) this._selectionFeature.attach();
        } else if (this._selectionFeature && controlSelectionFeature) this._selectionFeature.detach();
    }
    _disposeBezierCurve() {
        if (this._quadraticBezierCurve) {
            this._quadraticBezierCurve.dispose();
            this._quadraticBezierCurve = null;
        }
    }
    _showParabolicPath(pickInfo) {
        if (!pickInfo.pickedPoint || !this._currentTeleportationControllerId) return;
        const sceneToRenderTo = this._options.useUtilityLayer ? this._options.customUtilityLayerScene || (0, $6mCYU.UtilityLayerRenderer).DefaultUtilityLayer.utilityLayerScene : this._xrSessionManager.scene;
        const controllerData = this._controllers[this._currentTeleportationControllerId];
        const quadraticBezierVectors = (0, $fm2C6.Curve3).CreateQuadraticBezier(controllerData.xrController.pointer.absolutePosition, pickInfo.ray.origin, pickInfo.pickedPoint, 25);
        const color = controllerData.teleportationState.blocked ? this._blockedRayColor : undefined;
        const colorsArray = this._colorArray.fill(color || this._cachedColor4White);
        // take out the first 2 points, to not start directly from the controller
        const points = quadraticBezierVectors.getPoints();
        points.shift();
        points.shift();
        if (!this._options.generateRayPathMesh) this._quadraticBezierCurve = (0, $8Eyol.CreateLines)("teleportation path line", {
            points: points,
            instance: this._quadraticBezierCurve,
            updatable: true,
            colors: colorsArray
        }, sceneToRenderTo);
        else this._quadraticBezierCurve = this._options.generateRayPathMesh(quadraticBezierVectors.getPoints(), pickInfo);
        this._quadraticBezierCurve.isPickable = false;
        if (this._options.renderingGroupId !== undefined) this._quadraticBezierCurve.renderingGroupId = this._options.renderingGroupId;
    }
    _teleportForward(controllerId) {
        const controllerData = this._controllers[controllerId];
        if (!controllerData || !controllerData.teleportationState.forward || !this.teleportationEnabled) return;
        controllerData.teleportationState.forward = false;
        this._currentTeleportationControllerId = "";
        if (this.snapPointsOnly && !this._snappedToPoint) return;
        if (this.skipNextTeleportation) {
            this.skipNextTeleportation = false;
            return;
        }
        // do the movement forward here
        if (this._options.teleportationTargetMesh && this._options.teleportationTargetMesh.isVisible) {
            const height = this._options.xrInput.xrCamera.realWorldHeight;
            this.onBeforeCameraTeleport.notifyObservers(this._options.xrInput.xrCamera.position);
            this._options.xrInput.xrCamera.position.copyFrom(this._options.teleportationTargetMesh.position);
            this._options.xrInput.xrCamera.position.y += height;
            (0, $ha1VO.Quaternion).FromEulerAngles(0, controllerData.teleportationState.currentRotation - (this._xrSessionManager.scene.useRightHandedSystem ? Math.PI : 0), 0).multiplyToRef(this._options.xrInput.xrCamera.rotationQuaternion, this._options.xrInput.xrCamera.rotationQuaternion);
            this.onAfterCameraTeleport.notifyObservers(this._options.xrInput.xrCamera.position);
        }
    }
}
/**
 * The module's name
 */ $f688a52fdccf36e5$export$fbb54262c41eef9a.Name = (0, $cJN7d.WebXRFeatureName).TELEPORTATION;
/**
 * The (Babylon) version of this module.
 * This is an integer representing the implementation version.
 * This number does not correspond to the webxr specs version
 */ $f688a52fdccf36e5$export$fbb54262c41eef9a.Version = 1;
(0, $cJN7d.WebXRFeaturesManager).AddWebXRFeature($f688a52fdccf36e5$export$fbb54262c41eef9a.Name, (xrSessionManager, options)=>{
    return ()=>new $f688a52fdccf36e5$export$fbb54262c41eef9a(xrSessionManager, options);
}, $f688a52fdccf36e5$export$fbb54262c41eef9a.Version, true);

});
parcelRegister("2PCL1", function(module, exports) {

$parcel$export(module.exports, "TimerState", () => $20fe68a071c874a4$export$d79da05e6e8c1545);
$parcel$export(module.exports, "setAndStartTimer", () => $20fe68a071c874a4$export$86d38924c503edff);
$parcel$export(module.exports, "AdvancedTimer", () => $20fe68a071c874a4$export$2ed5489bb4fd20e4);

var $diGQf = parcelRequire("diGQf");
var $20fe68a071c874a4$export$d79da05e6e8c1545;
(function(TimerState) {
    /**
     * Timer initialized, not yet started
     */ TimerState[TimerState["INIT"] = 0] = "INIT";
    /**
     * Timer started and counting
     */ TimerState[TimerState["STARTED"] = 1] = "STARTED";
    /**
     * Timer ended (whether aborted or time reached)
     */ TimerState[TimerState["ENDED"] = 2] = "ENDED";
})($20fe68a071c874a4$export$d79da05e6e8c1545 || ($20fe68a071c874a4$export$d79da05e6e8c1545 = {}));
function $20fe68a071c874a4$export$86d38924c503edff(options) {
    let timer = 0;
    const startTime = Date.now();
    options.observableParameters = options.observableParameters ?? {};
    const observer = options.contextObservable.add((payload)=>{
        const now = Date.now();
        timer = now - startTime;
        const data = {
            startTime: startTime,
            currentTime: now,
            deltaTime: timer,
            completeRate: timer / options.timeout,
            payload: payload
        };
        options.onTick && options.onTick(data);
        if (options.breakCondition && options.breakCondition()) {
            options.contextObservable.remove(observer);
            options.onAborted && options.onAborted(data);
        }
        if (timer >= options.timeout) {
            options.contextObservable.remove(observer);
            options.onEnded && options.onEnded(data);
        }
    }, options.observableParameters.mask, options.observableParameters.insertFirst, options.observableParameters.scope);
    return observer;
}
class $20fe68a071c874a4$export$2ed5489bb4fd20e4 {
    /**
     * Will construct a new advanced timer based on the options provided. Timer will not start until start() is called.
     * @param options construction options for this advanced timer
     */ constructor(options){
        /**
         * Will notify each time the timer calculates the remaining time
         */ this.onEachCountObservable = new (0, $diGQf.Observable)();
        /**
         * Will trigger when the timer was aborted due to the break condition
         */ this.onTimerAbortedObservable = new (0, $diGQf.Observable)();
        /**
         * Will trigger when the timer ended successfully
         */ this.onTimerEndedObservable = new (0, $diGQf.Observable)();
        /**
         * Will trigger when the timer state has changed
         */ this.onStateChangedObservable = new (0, $diGQf.Observable)();
        this._observer = null;
        this._breakOnNextTick = false;
        this._tick = (payload)=>{
            const now = Date.now();
            this._timer = now - this._startTime;
            const data = {
                startTime: this._startTime,
                currentTime: now,
                deltaTime: this._timer,
                completeRate: this._timer / this._timeToEnd,
                payload: payload
            };
            const shouldBreak = this._breakOnNextTick || this._breakCondition(data);
            if (shouldBreak || this._timer >= this._timeToEnd) this._stop(data, shouldBreak);
            else this.onEachCountObservable.notifyObservers(data);
        };
        this._setState($20fe68a071c874a4$export$d79da05e6e8c1545.INIT);
        this._contextObservable = options.contextObservable;
        this._observableParameters = options.observableParameters ?? {};
        this._breakCondition = options.breakCondition ?? (()=>false);
        this._timeToEnd = options.timeout;
        if (options.onEnded) this.onTimerEndedObservable.add(options.onEnded);
        if (options.onTick) this.onEachCountObservable.add(options.onTick);
        if (options.onAborted) this.onTimerAbortedObservable.add(options.onAborted);
    }
    /**
     * set a breaking condition for this timer. Default is to never break during count
     * @param predicate the new break condition. Returns true to break, false otherwise
     */ set breakCondition(predicate) {
        this._breakCondition = predicate;
    }
    /**
     * Reset ALL associated observables in this advanced timer
     */ clearObservables() {
        this.onEachCountObservable.clear();
        this.onTimerAbortedObservable.clear();
        this.onTimerEndedObservable.clear();
        this.onStateChangedObservable.clear();
    }
    /**
     * Will start a new iteration of this timer. Only one instance of this timer can run at a time.
     *
     * @param timeToEnd how much time to measure until timer ended
     */ start(timeToEnd = this._timeToEnd) {
        if (this._state === $20fe68a071c874a4$export$d79da05e6e8c1545.STARTED) throw new Error("Timer already started. Please stop it before starting again");
        this._timeToEnd = timeToEnd;
        this._startTime = Date.now();
        this._timer = 0;
        this._observer = this._contextObservable.add(this._tick, this._observableParameters.mask, this._observableParameters.insertFirst, this._observableParameters.scope);
        this._setState($20fe68a071c874a4$export$d79da05e6e8c1545.STARTED);
    }
    /**
     * Will force a stop on the next tick.
     */ stop() {
        if (this._state !== $20fe68a071c874a4$export$d79da05e6e8c1545.STARTED) return;
        this._breakOnNextTick = true;
    }
    /**
     * Dispose this timer, clearing all resources
     */ dispose() {
        if (this._observer) this._contextObservable.remove(this._observer);
        this.clearObservables();
    }
    _setState(newState) {
        this._state = newState;
        this.onStateChangedObservable.notifyObservers(this._state);
    }
    _stop(data, aborted = false) {
        this._contextObservable.remove(this._observer);
        this._setState($20fe68a071c874a4$export$d79da05e6e8c1545.ENDED);
        if (aborted) this.onTimerAbortedObservable.notifyObservers(data);
        else this.onTimerEndedObservable.notifyObservers(data);
    }
}

});




parcelRegister("1nCYs", function(module, exports) {

$parcel$export(module.exports, "VideoDome", () => $10162be19dbc0949$export$3a7af0ecf2243c39);

var $j2mX5 = parcelRequire("j2mX5");

var $6Hwnm = parcelRequire("6Hwnm");

var $klLLx = parcelRequire("klLLx");

var $cfkw4 = parcelRequire("cfkw4");
class $10162be19dbc0949$export$3a7af0ecf2243c39 extends (0, $klLLx.TextureDome) {
    /**
     * Get the video texture associated with this video dome
     */ get videoTexture() {
        return this._texture;
    }
    /**
     * Get the video mode of this dome
     */ get videoMode() {
        return this.textureMode;
    }
    /**
     * Set the video mode of this dome.
     * @see textureMode
     */ set videoMode(value) {
        this.textureMode = value;
    }
    _initTexture(urlsOrElement, scene, options) {
        const tempOptions = {
            loop: options.loop,
            autoPlay: options.autoPlay,
            autoUpdateTexture: true,
            poster: options.poster
        };
        const texture = new (0, $6Hwnm.VideoTexture)((this.name || "videoDome") + "_texture", urlsOrElement, scene, options.generateMipMaps, this._useDirectMapping, (0, $j2mX5.Texture).TRILINEAR_SAMPLINGMODE, tempOptions);
        // optional configuration
        if (options.clickToPlay) this._pointerObserver = scene.onPointerObservable.add((data)=>{
            data.pickInfo?.pickedMesh === this.mesh && this._texture.video.play();
        }, (0, $cfkw4.PointerEventTypes).POINTERDOWN);
        this._textureObserver = texture.onLoadObservable.add(()=>{
            this.onLoadObservable.notifyObservers();
        });
        return texture;
    }
    /**
     * Releases resources associated with this node.
     * @param doNotRecurse Set to true to not recurse into each children (recurse into each children by default)
     * @param disposeMaterialAndTextures Set to true to also dispose referenced materials and textures (false by default)
     */ dispose(doNotRecurse, disposeMaterialAndTextures = false) {
        this._texture.onLoadObservable.remove(this._textureObserver);
        this._scene.onPointerObservable.remove(this._pointerObserver);
        super.dispose(doNotRecurse, disposeMaterialAndTextures);
    }
}
/**
 * Define the video source as a Monoscopic panoramic 360 video.
 */ $10162be19dbc0949$export$3a7af0ecf2243c39.MODE_MONOSCOPIC = (0, $klLLx.TextureDome).MODE_MONOSCOPIC;
/**
 * Define the video source as a Stereoscopic TopBottom/OverUnder panoramic 360 video.
 */ $10162be19dbc0949$export$3a7af0ecf2243c39.MODE_TOPBOTTOM = (0, $klLLx.TextureDome).MODE_TOPBOTTOM;
/**
 * Define the video source as a Stereoscopic Side by Side panoramic 360 video.
 */ $10162be19dbc0949$export$3a7af0ecf2243c39.MODE_SIDEBYSIDE = (0, $klLLx.TextureDome).MODE_SIDEBYSIDE;

});
parcelRegister("6Hwnm", function(module, exports) {

$parcel$export(module.exports, "VideoTexture", () => $4e0fdf63ccfec261$export$6e09d1edf8d5a25c);

var $e0Suo = parcelRequire("e0Suo");

var $diGQf = parcelRequire("diGQf");

var $bOhSV = parcelRequire("bOhSV");

var $kVtWi = parcelRequire("kVtWi");

var $j2mX5 = parcelRequire("j2mX5");
parcelRequire("ahLMi");
parcelRequire("2yVdu");

var $ir0rz = parcelRequire("ir0rz");

var $8DoUR = parcelRequire("8DoUR");
function $4e0fdf63ccfec261$var$removeSource(video) {
    // Remove any <source> elements, etc.
    while(video.firstChild)video.removeChild(video.firstChild);
    // detach srcObject
    video.srcObject = null;
    // Set a blank src (https://html.spec.whatwg.org/multipage/media.html#best-practices-for-authors-using-media-elements)
    video.src = "";
    // Prevent non-important errors maybe (https://twitter.com/beraliv/status/1205214277956775936)
    video.removeAttribute("src");
}
class $4e0fdf63ccfec261$export$6e09d1edf8d5a25c extends (0, $j2mX5.Texture) {
    /**
     * Event triggered when a dom action is required by the user to play the video.
     * This happens due to recent changes in browser policies preventing video to auto start.
     */ get onUserActionRequestedObservable() {
        if (!this._onUserActionRequestedObservable) this._onUserActionRequestedObservable = new (0, $diGQf.Observable)();
        return this._onUserActionRequestedObservable;
    }
    _processError(reason) {
        this._errorFound = true;
        if (this._onError) this._onError(reason?.message);
        else (0, $kVtWi.Logger).Error(reason?.message);
    }
    _handlePlay() {
        this._errorFound = false;
        this.video.play().catch((reason)=>{
            if (reason?.name === "NotAllowedError") {
                if (this._onUserActionRequestedObservable && this._onUserActionRequestedObservable.hasObservers()) {
                    this._onUserActionRequestedObservable.notifyObservers(this);
                    return;
                } else if (!this.video.muted) {
                    (0, $kVtWi.Logger).Warn("Unable to autoplay a video with sound. Trying again with muted turned true");
                    this.video.muted = true;
                    this._errorFound = false;
                    this.video.play().catch((otherReason)=>{
                        this._processError(otherReason);
                    });
                    return;
                }
            }
            this._processError(reason);
        });
    }
    /**
     * Creates a video texture.
     * If you want to display a video in your scene, this is the special texture for that.
     * This special texture works similar to other textures, with the exception of a few parameters.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/videoTexture
     * @param name optional name, will detect from video source, if not defined
     * @param src can be used to provide an url, array of urls or an already setup HTML video element.
     * @param scene is obviously the current scene.
     * @param generateMipMaps can be used to turn on mipmaps (Can be expensive for videoTextures because they are often updated).
     * @param invertY is false by default but can be used to invert video on Y axis
     * @param samplingMode controls the sampling method and is set to TRILINEAR_SAMPLINGMODE by default
     * @param settings allows finer control over video usage
     * @param onError defines a callback triggered when an error occurred during the loading session
     * @param format defines the texture format to use (Engine.TEXTUREFORMAT_RGBA by default)
     */ constructor(name, src, scene, generateMipMaps = false, invertY = false, samplingMode = (0, $j2mX5.Texture).TRILINEAR_SAMPLINGMODE, settings = {}, onError, format = 5){
        super(null, scene, !generateMipMaps, invertY);
        this._externalTexture = null;
        this._onUserActionRequestedObservable = null;
        this._stillImageCaptured = false;
        this._displayingPosterTexture = false;
        this._frameId = -1;
        this._currentSrc = null;
        this._errorFound = false;
        /**
         * Serialize the flag to define this texture as a video texture
         */ this.isVideo = true;
        this._resizeInternalTexture = ()=>{
            // Cleanup the old texture before replacing it
            if (this._texture != null) this._texture.dispose();
            if (!this._getEngine().needPOTTextures || (0, $bOhSV.Tools).IsExponentOfTwo(this.video.videoWidth) && (0, $bOhSV.Tools).IsExponentOfTwo(this.video.videoHeight)) {
                this.wrapU = (0, $j2mX5.Texture).WRAP_ADDRESSMODE;
                this.wrapV = (0, $j2mX5.Texture).WRAP_ADDRESSMODE;
            } else {
                this.wrapU = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
                this.wrapV = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
                this._generateMipMaps = false;
            }
            this._texture = this._getEngine().createDynamicTexture(this.video.videoWidth, this.video.videoHeight, this._generateMipMaps, this.samplingMode);
            this._texture.format = this._format ?? 5;
            // Reset the frame ID and update the new texture to ensure it pulls in the current video frame
            this._frameId = -1;
            this._updateInternalTexture();
        };
        this._createInternalTexture = ()=>{
            if (this._texture != null) {
                if (this._displayingPosterTexture) this._displayingPosterTexture = false;
                else return;
            }
            this.video.addEventListener("resize", this._resizeInternalTexture);
            this._resizeInternalTexture();
            if (!this.video.autoplay && !this._settings.poster && !this._settings.independentVideoSource) {
                const oldHandler = this.video.onplaying;
                const oldMuted = this.video.muted;
                this.video.muted = true;
                this.video.onplaying = ()=>{
                    this.video.muted = oldMuted;
                    this.video.onplaying = oldHandler;
                    this._updateInternalTexture();
                    if (!this._errorFound) this.video.pause();
                    if (this.onLoadObservable.hasObservers()) this.onLoadObservable.notifyObservers(this);
                };
                this._handlePlay();
            } else {
                this._updateInternalTexture();
                if (this.onLoadObservable.hasObservers()) this.onLoadObservable.notifyObservers(this);
            }
        };
        this._reset = ()=>{
            if (this._texture == null) return;
            if (!this._displayingPosterTexture) {
                this._texture.dispose();
                this._texture = null;
            }
        };
        this._updateInternalTexture = ()=>{
            if (this._texture == null) return;
            if (this.video.readyState < this.video.HAVE_CURRENT_DATA) return;
            if (this._displayingPosterTexture) return;
            const frameId = this.getScene().getFrameId();
            if (this._frameId === frameId) return;
            this._frameId = frameId;
            this._getEngine().updateVideoTexture(this._texture, this._externalTexture ? this._externalTexture : this.video, this._invertY);
        };
        this._settings = {
            autoPlay: true,
            loop: true,
            autoUpdateTexture: true,
            ...settings
        };
        this._onError = onError;
        this._generateMipMaps = generateMipMaps;
        this._initialSamplingMode = samplingMode;
        this.autoUpdateTexture = this._settings.autoUpdateTexture;
        this._currentSrc = src;
        this.name = name || this._getName(src);
        this.video = this._getVideo(src);
        if (this._engine?.createExternalTexture) this._externalTexture = this._engine.createExternalTexture(this.video);
        if (!this._settings.independentVideoSource) {
            if (this._settings.poster) this.video.poster = this._settings.poster;
            if (this._settings.autoPlay !== undefined) this.video.autoplay = this._settings.autoPlay;
            if (this._settings.loop !== undefined) this.video.loop = this._settings.loop;
            if (this._settings.muted !== undefined) this.video.muted = this._settings.muted;
            this.video.setAttribute("playsinline", "");
            this.video.addEventListener("paused", this._updateInternalTexture);
            this.video.addEventListener("seeked", this._updateInternalTexture);
            this.video.addEventListener("loadeddata", this._updateInternalTexture);
            this.video.addEventListener("emptied", this._reset);
            if (this._settings.autoPlay) this._handlePlay();
        }
        this._createInternalTextureOnEvent = this._settings.poster && !this._settings.autoPlay ? "play" : "canplay";
        this.video.addEventListener(this._createInternalTextureOnEvent, this._createInternalTexture);
        this._format = format;
        const videoHasEnoughData = this.video.readyState >= this.video.HAVE_CURRENT_DATA;
        if (this._settings.poster && (!this._settings.autoPlay || !videoHasEnoughData)) {
            this._texture = this._getEngine().createTexture(this._settings.poster, false, !this.invertY, scene);
            this._displayingPosterTexture = true;
        } else if (videoHasEnoughData) this._createInternalTexture();
    }
    /**
     * Get the current class name of the video texture useful for serialization or dynamic coding.
     * @returns "VideoTexture"
     */ getClassName() {
        return "VideoTexture";
    }
    _getName(src) {
        if (src instanceof HTMLVideoElement) return src.currentSrc;
        if (typeof src === "object") return src.toString();
        return src;
    }
    _getVideo(src) {
        if (src.isNative) return src;
        if (src instanceof HTMLVideoElement) {
            (0, $bOhSV.Tools).SetCorsBehavior(src.currentSrc, src);
            return src;
        }
        const video = document.createElement("video");
        if (typeof src === "string") {
            (0, $bOhSV.Tools).SetCorsBehavior(src, video);
            video.src = src;
        } else {
            (0, $bOhSV.Tools).SetCorsBehavior(src[0], video);
            src.forEach((url)=>{
                const source = document.createElement("source");
                source.src = url;
                video.appendChild(source);
            });
        }
        this.onDisposeObservable.addOnce(()=>{
            $4e0fdf63ccfec261$var$removeSource(video);
        });
        return video;
    }
    /**
     * @internal Internal method to initiate `update`.
     */ _rebuild() {
        this.update();
    }
    /**
     * Update Texture in the `auto` mode. Does not do anything if `settings.autoUpdateTexture` is false.
     */ update() {
        if (!this.autoUpdateTexture) // Expecting user to call `updateTexture` manually
        return;
        this.updateTexture(true);
    }
    /**
     * Update Texture in `manual` mode. Does not do anything if not visible or paused.
     * @param isVisible Visibility state, detected by user using `scene.getActiveMeshes()` or otherwise.
     */ updateTexture(isVisible) {
        if (!isVisible) return;
        if (this.video.paused && this._stillImageCaptured) return;
        this._stillImageCaptured = true;
        this._updateInternalTexture();
    }
    /**
     * Get the underlying external texture (if supported by the current engine, else null)
     */ get externalTexture() {
        return this._externalTexture;
    }
    /**
     * Change video content. Changing video instance or setting multiple urls (as in constructor) is not supported.
     * @param url New url.
     */ updateURL(url) {
        this.video.src = url;
        this._currentSrc = url;
    }
    /**
     * Clones the texture.
     * @returns the cloned texture
     */ clone() {
        return new $4e0fdf63ccfec261$export$6e09d1edf8d5a25c(this.name, this._currentSrc, this.getScene(), this._generateMipMaps, this.invertY, this.samplingMode, this._settings);
    }
    /**
     * Dispose the texture and release its associated resources.
     */ dispose() {
        super.dispose();
        this._currentSrc = null;
        if (this._onUserActionRequestedObservable) {
            this._onUserActionRequestedObservable.clear();
            this._onUserActionRequestedObservable = null;
        }
        this.video.removeEventListener(this._createInternalTextureOnEvent, this._createInternalTexture);
        if (!this._settings.independentVideoSource) {
            this.video.removeEventListener("paused", this._updateInternalTexture);
            this.video.removeEventListener("seeked", this._updateInternalTexture);
            this.video.removeEventListener("loadeddata", this._updateInternalTexture);
            this.video.removeEventListener("emptied", this._reset);
            this.video.removeEventListener("resize", this._resizeInternalTexture);
            this.video.pause();
        }
        this._externalTexture?.dispose();
    }
    /**
     * Creates a video texture straight from a stream.
     * @param scene Define the scene the texture should be created in
     * @param stream Define the stream the texture should be created from
     * @param constraints video constraints
     * @param invertY Defines if the video should be stored with invert Y set to true (true by default)
     * @returns The created video texture as a promise
     */ static CreateFromStreamAsync(scene, stream, constraints, invertY = true) {
        const video = scene.getEngine().createVideoElement(constraints);
        if (scene.getEngine()._badOS) {
            // Yes... I know and I hope to remove it soon...
            document.body.appendChild(video);
            video.style.transform = "scale(0.0001, 0.0001)";
            video.style.opacity = "0";
            video.style.position = "fixed";
            video.style.bottom = "0px";
            video.style.right = "0px";
        }
        video.setAttribute("autoplay", "");
        video.setAttribute("muted", "true");
        video.setAttribute("playsinline", "");
        video.muted = true;
        if (video.isNative) ;
        else if (video.mozSrcObject !== undefined) // hack for Firefox < 19
        video.mozSrcObject = stream;
        else if (typeof video.srcObject == "object") video.srcObject = stream;
        else // older API. See https://developer.mozilla.org/en-US/docs/Web/API/URL/createObjectURL#using_object_urls_for_media_streams
        video.src = window.URL && window.URL.createObjectURL(stream);
        return new Promise((resolve)=>{
            const onPlaying = ()=>{
                const videoTexture = new $4e0fdf63ccfec261$export$6e09d1edf8d5a25c("video", video, scene, true, invertY, undefined, undefined, undefined, 4);
                if (scene.getEngine()._badOS) videoTexture.onDisposeObservable.addOnce(()=>{
                    video.remove();
                });
                videoTexture.onDisposeObservable.addOnce(()=>{
                    $4e0fdf63ccfec261$var$removeSource(video);
                });
                resolve(videoTexture);
                video.removeEventListener("playing", onPlaying);
            };
            video.addEventListener("playing", onPlaying);
            video.play();
        });
    }
    /**
     * Creates a video texture straight from your WebCam video feed.
     * @param scene Define the scene the texture should be created in
     * @param constraints Define the constraints to use to create the web cam feed from WebRTC
     * @param audioConstaints Define the audio constraints to use to create the web cam feed from WebRTC
     * @param invertY Defines if the video should be stored with invert Y set to true (true by default)
     * @returns The created video texture as a promise
     */ static async CreateFromWebCamAsync(scene, constraints, audioConstaints = false, invertY = true) {
        if (navigator.mediaDevices) {
            const stream = await navigator.mediaDevices.getUserMedia({
                video: constraints,
                audio: audioConstaints
            });
            const videoTexture = await this.CreateFromStreamAsync(scene, stream, constraints, invertY);
            videoTexture.onDisposeObservable.addOnce(()=>{
                stream.getTracks().forEach((track)=>{
                    track.stop();
                });
            });
            return videoTexture;
        }
        return Promise.reject("No support for userMedia on this device");
    }
    /**
     * Creates a video texture straight from your WebCam video feed.
     * @param scene Defines the scene the texture should be created in
     * @param onReady Defines a callback to triggered once the texture will be ready
     * @param constraints Defines the constraints to use to create the web cam feed from WebRTC
     * @param audioConstaints Defines the audio constraints to use to create the web cam feed from WebRTC
     * @param invertY Defines if the video should be stored with invert Y set to true (true by default)
     */ static CreateFromWebCam(scene, onReady, constraints, audioConstaints = false, invertY = true) {
        this.CreateFromWebCamAsync(scene, constraints, audioConstaints, invertY).then(function(videoTexture) {
            if (onReady) onReady(videoTexture);
        }).catch(function(err) {
            (0, $kVtWi.Logger).Error(err.name);
        });
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("settings")
], $4e0fdf63ccfec261$export$6e09d1edf8d5a25c.prototype, "_settings", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("src")
], $4e0fdf63ccfec261$export$6e09d1edf8d5a25c.prototype, "_currentSrc", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $4e0fdf63ccfec261$export$6e09d1edf8d5a25c.prototype, "isVideo", void 0);
(0, $j2mX5.Texture)._CreateVideoTexture = (name, src, scene, generateMipMaps = false, invertY = false, samplingMode = (0, $j2mX5.Texture).TRILINEAR_SAMPLINGMODE, settings = {}, onError, format = 5)=>{
    return new $4e0fdf63ccfec261$export$6e09d1edf8d5a25c(name, src, scene, generateMipMaps, invertY, samplingMode, settings, onError, format);
};
// Some exporters relies on Tools.Instantiate
(0, $8DoUR.RegisterClass)("BABYLON.VideoTexture", $4e0fdf63ccfec261$export$6e09d1edf8d5a25c);

});



parcelRegister("dXHo1", function(module, exports) {

var $k4hBS = parcelRequire("k4hBS");

var $gGWXq = parcelRequire("gGWXq");

var $8NQGp = parcelRequire("8NQGp");
$parcel$exportWildcard(module.exports, $k4hBS);
$parcel$exportWildcard(module.exports, $gGWXq);
$parcel$exportWildcard(module.exports, $8NQGp);

});
parcelRegister("k4hBS", function(module, exports) {

$parcel$export(module.exports, "EngineInstrumentation", () => $e9c1d758936c5c9c$export$bd9ee65215838a5c);

var $2Fclq = parcelRequire("2Fclq");
class $e9c1d758936c5c9c$export$bd9ee65215838a5c {
    // Properties
    /**
     * Gets the perf counter used for GPU frame time
     */ get gpuFrameTimeCounter() {
        return this.engine.getGPUFrameTimeCounter();
    }
    /**
     * Gets the GPU frame time capture status
     */ get captureGPUFrameTime() {
        return this._captureGPUFrameTime;
    }
    /**
     * Enable or disable the GPU frame time capture
     */ set captureGPUFrameTime(value) {
        if (value === this._captureGPUFrameTime) return;
        this._captureGPUFrameTime = value;
        this.engine.captureGPUFrameTime(value);
    }
    /**
     * Gets the perf counter used for shader compilation time
     */ get shaderCompilationTimeCounter() {
        return this._shaderCompilationTime;
    }
    /**
     * Gets the shader compilation time capture status
     */ get captureShaderCompilationTime() {
        return this._captureShaderCompilationTime;
    }
    /**
     * Enable or disable the shader compilation time capture
     */ set captureShaderCompilationTime(value) {
        if (value === this._captureShaderCompilationTime) return;
        this._captureShaderCompilationTime = value;
        if (value) {
            this._onBeforeShaderCompilationObserver = this.engine.onBeforeShaderCompilationObservable.add(()=>{
                this._shaderCompilationTime.fetchNewFrame();
                this._shaderCompilationTime.beginMonitoring();
            });
            this._onAfterShaderCompilationObserver = this.engine.onAfterShaderCompilationObservable.add(()=>{
                this._shaderCompilationTime.endMonitoring();
            });
        } else {
            this.engine.onBeforeShaderCompilationObservable.remove(this._onBeforeShaderCompilationObserver);
            this._onBeforeShaderCompilationObserver = null;
            this.engine.onAfterShaderCompilationObservable.remove(this._onAfterShaderCompilationObserver);
            this._onAfterShaderCompilationObserver = null;
        }
    }
    /**
     * Instantiates a new engine instrumentation.
     * This class can be used to get instrumentation data from a Babylon engine
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/optimize_your_scene#engineinstrumentation
     * @param engine Defines the engine to instrument
     */ constructor(/**
     * Define the instrumented engine.
     */ engine){
        this.engine = engine;
        this._captureGPUFrameTime = false;
        this._captureShaderCompilationTime = false;
        this._shaderCompilationTime = new (0, $2Fclq.PerfCounter)();
        // Observers
        this._onBeginFrameObserver = null;
        this._onEndFrameObserver = null;
        this._onBeforeShaderCompilationObserver = null;
        this._onAfterShaderCompilationObserver = null;
    }
    /**
     * Dispose and release associated resources.
     */ dispose() {
        this.engine.onBeginFrameObservable.remove(this._onBeginFrameObserver);
        this._onBeginFrameObserver = null;
        this.engine.onEndFrameObservable.remove(this._onEndFrameObserver);
        this._onEndFrameObserver = null;
        this.engine.onBeforeShaderCompilationObservable.remove(this._onBeforeShaderCompilationObserver);
        this._onBeforeShaderCompilationObserver = null;
        this.engine.onAfterShaderCompilationObservable.remove(this._onAfterShaderCompilationObserver);
        this._onAfterShaderCompilationObserver = null;
        this.engine = null;
    }
}

});

parcelRegister("gGWXq", function(module, exports) {

$parcel$export(module.exports, "SceneInstrumentation", () => $c26e4d4fe5f55224$export$2bb95a321423f741);

var $bOhSV = parcelRequire("bOhSV");

var $2Fclq = parcelRequire("2Fclq");
class $c26e4d4fe5f55224$export$2bb95a321423f741 {
    // Properties
    /**
     * Gets the perf counter used for active meshes evaluation time
     */ get activeMeshesEvaluationTimeCounter() {
        return this._activeMeshesEvaluationTime;
    }
    /**
     * Gets the active meshes evaluation time capture status
     */ get captureActiveMeshesEvaluationTime() {
        return this._captureActiveMeshesEvaluationTime;
    }
    /**
     * Enable or disable the active meshes evaluation time capture
     */ set captureActiveMeshesEvaluationTime(value) {
        if (value === this._captureActiveMeshesEvaluationTime) return;
        this._captureActiveMeshesEvaluationTime = value;
        if (value) {
            this._onBeforeActiveMeshesEvaluationObserver = this.scene.onBeforeActiveMeshesEvaluationObservable.add(()=>{
                (0, $bOhSV.Tools).StartPerformanceCounter("Active meshes evaluation");
                this._activeMeshesEvaluationTime.beginMonitoring();
            });
            this._onAfterActiveMeshesEvaluationObserver = this.scene.onAfterActiveMeshesEvaluationObservable.add(()=>{
                (0, $bOhSV.Tools).EndPerformanceCounter("Active meshes evaluation");
                this._activeMeshesEvaluationTime.endMonitoring(false);
            });
        } else {
            this.scene.onBeforeActiveMeshesEvaluationObservable.remove(this._onBeforeActiveMeshesEvaluationObserver);
            this._onBeforeActiveMeshesEvaluationObserver = null;
            this.scene.onAfterActiveMeshesEvaluationObservable.remove(this._onAfterActiveMeshesEvaluationObserver);
            this._onAfterActiveMeshesEvaluationObserver = null;
        }
    }
    /**
     * Gets the perf counter used for render targets render time
     */ get renderTargetsRenderTimeCounter() {
        return this._renderTargetsRenderTime;
    }
    /**
     * Gets the render targets render time capture status
     */ get captureRenderTargetsRenderTime() {
        return this._captureRenderTargetsRenderTime;
    }
    /**
     * Enable or disable the render targets render time capture
     */ set captureRenderTargetsRenderTime(value) {
        if (value === this._captureRenderTargetsRenderTime) return;
        this._captureRenderTargetsRenderTime = value;
        if (value) {
            this._onBeforeRenderTargetsRenderObserver = this.scene.onBeforeRenderTargetsRenderObservable.add(()=>{
                (0, $bOhSV.Tools).StartPerformanceCounter("Render targets rendering");
                this._renderTargetsRenderTime.beginMonitoring();
            });
            this._onAfterRenderTargetsRenderObserver = this.scene.onAfterRenderTargetsRenderObservable.add(()=>{
                (0, $bOhSV.Tools).EndPerformanceCounter("Render targets rendering");
                this._renderTargetsRenderTime.endMonitoring(false);
            });
        } else {
            this.scene.onBeforeRenderTargetsRenderObservable.remove(this._onBeforeRenderTargetsRenderObserver);
            this._onBeforeRenderTargetsRenderObserver = null;
            this.scene.onAfterRenderTargetsRenderObservable.remove(this._onAfterRenderTargetsRenderObserver);
            this._onAfterRenderTargetsRenderObserver = null;
        }
    }
    /**
     * Gets the perf counter used for particles render time
     */ get particlesRenderTimeCounter() {
        return this._particlesRenderTime;
    }
    /**
     * Gets the particles render time capture status
     */ get captureParticlesRenderTime() {
        return this._captureParticlesRenderTime;
    }
    /**
     * Enable or disable the particles render time capture
     */ set captureParticlesRenderTime(value) {
        if (value === this._captureParticlesRenderTime) return;
        this._captureParticlesRenderTime = value;
        if (value) {
            this._onBeforeParticlesRenderingObserver = this.scene.onBeforeParticlesRenderingObservable.add(()=>{
                (0, $bOhSV.Tools).StartPerformanceCounter("Particles");
                this._particlesRenderTime.beginMonitoring();
            });
            this._onAfterParticlesRenderingObserver = this.scene.onAfterParticlesRenderingObservable.add(()=>{
                (0, $bOhSV.Tools).EndPerformanceCounter("Particles");
                this._particlesRenderTime.endMonitoring(false);
            });
        } else {
            this.scene.onBeforeParticlesRenderingObservable.remove(this._onBeforeParticlesRenderingObserver);
            this._onBeforeParticlesRenderingObserver = null;
            this.scene.onAfterParticlesRenderingObservable.remove(this._onAfterParticlesRenderingObserver);
            this._onAfterParticlesRenderingObserver = null;
        }
    }
    /**
     * Gets the perf counter used for sprites render time
     */ get spritesRenderTimeCounter() {
        return this._spritesRenderTime;
    }
    /**
     * Gets the sprites render time capture status
     */ get captureSpritesRenderTime() {
        return this._captureSpritesRenderTime;
    }
    /**
     * Enable or disable the sprites render time capture
     */ set captureSpritesRenderTime(value) {
        if (value === this._captureSpritesRenderTime) return;
        this._captureSpritesRenderTime = value;
        if (!this.scene.spriteManagers) return;
        if (value) {
            this._onBeforeSpritesRenderingObserver = this.scene.onBeforeSpritesRenderingObservable.add(()=>{
                (0, $bOhSV.Tools).StartPerformanceCounter("Sprites");
                this._spritesRenderTime.beginMonitoring();
            });
            this._onAfterSpritesRenderingObserver = this.scene.onAfterSpritesRenderingObservable.add(()=>{
                (0, $bOhSV.Tools).EndPerformanceCounter("Sprites");
                this._spritesRenderTime.endMonitoring(false);
            });
        } else {
            this.scene.onBeforeSpritesRenderingObservable.remove(this._onBeforeSpritesRenderingObserver);
            this._onBeforeSpritesRenderingObserver = null;
            this.scene.onAfterSpritesRenderingObservable.remove(this._onAfterSpritesRenderingObserver);
            this._onAfterSpritesRenderingObserver = null;
        }
    }
    /**
     * Gets the perf counter used for physics time
     */ get physicsTimeCounter() {
        return this._physicsTime;
    }
    /**
     * Gets the physics time capture status
     */ get capturePhysicsTime() {
        return this._capturePhysicsTime;
    }
    /**
     * Enable or disable the physics time capture
     */ set capturePhysicsTime(value) {
        if (value === this._capturePhysicsTime) return;
        if (!this.scene.onBeforePhysicsObservable) return;
        this._capturePhysicsTime = value;
        if (value) {
            this._onBeforePhysicsObserver = this.scene.onBeforePhysicsObservable.add(()=>{
                (0, $bOhSV.Tools).StartPerformanceCounter("Physics");
                this._physicsTime.beginMonitoring();
            });
            this._onAfterPhysicsObserver = this.scene.onAfterPhysicsObservable.add(()=>{
                (0, $bOhSV.Tools).EndPerformanceCounter("Physics");
                this._physicsTime.endMonitoring();
            });
        } else {
            this.scene.onBeforePhysicsObservable.remove(this._onBeforePhysicsObserver);
            this._onBeforePhysicsObserver = null;
            this.scene.onAfterPhysicsObservable.remove(this._onAfterPhysicsObserver);
            this._onAfterPhysicsObserver = null;
        }
    }
    /**
     * Gets the perf counter used for animations time
     */ get animationsTimeCounter() {
        return this._animationsTime;
    }
    /**
     * Gets the animations time capture status
     */ get captureAnimationsTime() {
        return this._captureAnimationsTime;
    }
    /**
     * Enable or disable the animations time capture
     */ set captureAnimationsTime(value) {
        if (value === this._captureAnimationsTime) return;
        this._captureAnimationsTime = value;
        if (value) this._onAfterAnimationsObserver = this.scene.onAfterAnimationsObservable.add(()=>{
            this._animationsTime.endMonitoring();
        });
        else {
            this.scene.onAfterAnimationsObservable.remove(this._onAfterAnimationsObserver);
            this._onAfterAnimationsObserver = null;
        }
    }
    /**
     * Gets the perf counter used for frame time capture
     */ get frameTimeCounter() {
        return this._frameTime;
    }
    /**
     * Gets the frame time capture status
     */ get captureFrameTime() {
        return this._captureFrameTime;
    }
    /**
     * Enable or disable the frame time capture
     */ set captureFrameTime(value) {
        this._captureFrameTime = value;
    }
    /**
     * Gets the perf counter used for inter-frames time capture
     */ get interFrameTimeCounter() {
        return this._interFrameTime;
    }
    /**
     * Gets the inter-frames time capture status
     */ get captureInterFrameTime() {
        return this._captureInterFrameTime;
    }
    /**
     * Enable or disable the inter-frames time capture
     */ set captureInterFrameTime(value) {
        this._captureInterFrameTime = value;
    }
    /**
     * Gets the perf counter used for render time capture
     */ get renderTimeCounter() {
        return this._renderTime;
    }
    /**
     * Gets the render time capture status
     */ get captureRenderTime() {
        return this._captureRenderTime;
    }
    /**
     * Enable or disable the render time capture
     */ set captureRenderTime(value) {
        if (value === this._captureRenderTime) return;
        this._captureRenderTime = value;
        if (value) {
            this._onBeforeDrawPhaseObserver = this.scene.onBeforeDrawPhaseObservable.add(()=>{
                this._renderTime.beginMonitoring();
                (0, $bOhSV.Tools).StartPerformanceCounter("Main render");
            });
            this._onAfterDrawPhaseObserver = this.scene.onAfterDrawPhaseObservable.add(()=>{
                this._renderTime.endMonitoring(false);
                (0, $bOhSV.Tools).EndPerformanceCounter("Main render");
            });
        } else {
            this.scene.onBeforeDrawPhaseObservable.remove(this._onBeforeDrawPhaseObserver);
            this._onBeforeDrawPhaseObserver = null;
            this.scene.onAfterDrawPhaseObservable.remove(this._onAfterDrawPhaseObserver);
            this._onAfterDrawPhaseObserver = null;
        }
    }
    /**
     * Gets the perf counter used for camera render time capture
     */ get cameraRenderTimeCounter() {
        return this._cameraRenderTime;
    }
    /**
     * Gets the camera render time capture status
     */ get captureCameraRenderTime() {
        return this._captureCameraRenderTime;
    }
    /**
     * Enable or disable the camera render time capture
     */ set captureCameraRenderTime(value) {
        if (value === this._captureCameraRenderTime) return;
        this._captureCameraRenderTime = value;
        if (value) {
            this._onBeforeCameraRenderObserver = this.scene.onBeforeCameraRenderObservable.add((camera)=>{
                this._cameraRenderTime.beginMonitoring();
                (0, $bOhSV.Tools).StartPerformanceCounter(`Rendering camera ${camera.name}`);
            });
            this._onAfterCameraRenderObserver = this.scene.onAfterCameraRenderObservable.add((camera)=>{
                this._cameraRenderTime.endMonitoring(false);
                (0, $bOhSV.Tools).EndPerformanceCounter(`Rendering camera ${camera.name}`);
            });
        } else {
            this.scene.onBeforeCameraRenderObservable.remove(this._onBeforeCameraRenderObserver);
            this._onBeforeCameraRenderObserver = null;
            this.scene.onAfterCameraRenderObservable.remove(this._onAfterCameraRenderObserver);
            this._onAfterCameraRenderObserver = null;
        }
    }
    /**
     * Gets the perf counter used for draw calls
     */ get drawCallsCounter() {
        return this.scene.getEngine()._drawCalls;
    }
    /**
     * Instantiates a new scene instrumentation.
     * This class can be used to get instrumentation data from a Babylon engine
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/optimize_your_scene#sceneinstrumentation
     * @param scene Defines the scene to instrument
     */ constructor(/**
     * Defines the scene to instrument
     */ scene){
        this.scene = scene;
        this._captureActiveMeshesEvaluationTime = false;
        this._activeMeshesEvaluationTime = new (0, $2Fclq.PerfCounter)();
        this._captureRenderTargetsRenderTime = false;
        this._renderTargetsRenderTime = new (0, $2Fclq.PerfCounter)();
        this._captureFrameTime = false;
        this._frameTime = new (0, $2Fclq.PerfCounter)();
        this._captureRenderTime = false;
        this._renderTime = new (0, $2Fclq.PerfCounter)();
        this._captureInterFrameTime = false;
        this._interFrameTime = new (0, $2Fclq.PerfCounter)();
        this._captureParticlesRenderTime = false;
        this._particlesRenderTime = new (0, $2Fclq.PerfCounter)();
        this._captureSpritesRenderTime = false;
        this._spritesRenderTime = new (0, $2Fclq.PerfCounter)();
        this._capturePhysicsTime = false;
        this._physicsTime = new (0, $2Fclq.PerfCounter)();
        this._captureAnimationsTime = false;
        this._animationsTime = new (0, $2Fclq.PerfCounter)();
        this._captureCameraRenderTime = false;
        this._cameraRenderTime = new (0, $2Fclq.PerfCounter)();
        // Observers
        this._onBeforeActiveMeshesEvaluationObserver = null;
        this._onAfterActiveMeshesEvaluationObserver = null;
        this._onBeforeRenderTargetsRenderObserver = null;
        this._onAfterRenderTargetsRenderObserver = null;
        this._onAfterRenderObserver = null;
        this._onBeforeDrawPhaseObserver = null;
        this._onAfterDrawPhaseObserver = null;
        this._onBeforeAnimationsObserver = null;
        this._onBeforeParticlesRenderingObserver = null;
        this._onAfterParticlesRenderingObserver = null;
        this._onBeforeSpritesRenderingObserver = null;
        this._onAfterSpritesRenderingObserver = null;
        this._onBeforePhysicsObserver = null;
        this._onAfterPhysicsObserver = null;
        this._onAfterAnimationsObserver = null;
        this._onBeforeCameraRenderObserver = null;
        this._onAfterCameraRenderObserver = null;
        // Before render
        this._onBeforeAnimationsObserver = scene.onBeforeAnimationsObservable.add(()=>{
            if (this._captureActiveMeshesEvaluationTime) this._activeMeshesEvaluationTime.fetchNewFrame();
            if (this._captureRenderTargetsRenderTime) this._renderTargetsRenderTime.fetchNewFrame();
            if (this._captureFrameTime) {
                (0, $bOhSV.Tools).StartPerformanceCounter("Scene rendering");
                this._frameTime.beginMonitoring();
            }
            if (this._captureInterFrameTime) this._interFrameTime.endMonitoring();
            if (this._captureParticlesRenderTime) this._particlesRenderTime.fetchNewFrame();
            if (this._captureSpritesRenderTime) this._spritesRenderTime.fetchNewFrame();
            if (this._captureAnimationsTime) this._animationsTime.beginMonitoring();
            if (this._captureRenderTime) this._renderTime.fetchNewFrame();
            if (this._captureCameraRenderTime) this._cameraRenderTime.fetchNewFrame();
            this.scene.getEngine()._drawCalls.fetchNewFrame();
        });
        // After render
        this._onAfterRenderObserver = scene.onAfterRenderObservable.add(()=>{
            if (this._captureFrameTime) {
                (0, $bOhSV.Tools).EndPerformanceCounter("Scene rendering");
                this._frameTime.endMonitoring();
            }
            if (this._captureRenderTime) this._renderTime.endMonitoring(false);
            if (this._captureInterFrameTime) this._interFrameTime.beginMonitoring();
            if (this._captureActiveMeshesEvaluationTime) this._activeMeshesEvaluationTime.endFrame();
            if (this._captureRenderTargetsRenderTime) this._renderTargetsRenderTime.endFrame();
            if (this._captureParticlesRenderTime) this._particlesRenderTime.endFrame();
            if (this._captureSpritesRenderTime) this._spritesRenderTime.endFrame();
            if (this._captureRenderTime) this._renderTime.endFrame();
            if (this._captureCameraRenderTime) this._cameraRenderTime.endFrame();
        });
    }
    /**
     * Dispose and release associated resources.
     */ dispose() {
        this.scene.onAfterRenderObservable.remove(this._onAfterRenderObserver);
        this._onAfterRenderObserver = null;
        this.scene.onBeforeActiveMeshesEvaluationObservable.remove(this._onBeforeActiveMeshesEvaluationObserver);
        this._onBeforeActiveMeshesEvaluationObserver = null;
        this.scene.onAfterActiveMeshesEvaluationObservable.remove(this._onAfterActiveMeshesEvaluationObserver);
        this._onAfterActiveMeshesEvaluationObserver = null;
        this.scene.onBeforeRenderTargetsRenderObservable.remove(this._onBeforeRenderTargetsRenderObserver);
        this._onBeforeRenderTargetsRenderObserver = null;
        this.scene.onAfterRenderTargetsRenderObservable.remove(this._onAfterRenderTargetsRenderObserver);
        this._onAfterRenderTargetsRenderObserver = null;
        this.scene.onBeforeAnimationsObservable.remove(this._onBeforeAnimationsObserver);
        this._onBeforeAnimationsObserver = null;
        this.scene.onBeforeParticlesRenderingObservable.remove(this._onBeforeParticlesRenderingObserver);
        this._onBeforeParticlesRenderingObserver = null;
        this.scene.onAfterParticlesRenderingObservable.remove(this._onAfterParticlesRenderingObserver);
        this._onAfterParticlesRenderingObserver = null;
        if (this._onBeforeSpritesRenderingObserver) {
            this.scene.onBeforeSpritesRenderingObservable.remove(this._onBeforeSpritesRenderingObserver);
            this._onBeforeSpritesRenderingObserver = null;
        }
        if (this._onAfterSpritesRenderingObserver) {
            this.scene.onAfterSpritesRenderingObservable.remove(this._onAfterSpritesRenderingObserver);
            this._onAfterSpritesRenderingObserver = null;
        }
        this.scene.onBeforeDrawPhaseObservable.remove(this._onBeforeDrawPhaseObserver);
        this._onBeforeDrawPhaseObserver = null;
        this.scene.onAfterDrawPhaseObservable.remove(this._onAfterDrawPhaseObserver);
        this._onAfterDrawPhaseObserver = null;
        if (this._onBeforePhysicsObserver) {
            this.scene.onBeforePhysicsObservable.remove(this._onBeforePhysicsObserver);
            this._onBeforePhysicsObserver = null;
        }
        if (this._onAfterPhysicsObserver) {
            this.scene.onAfterPhysicsObservable.remove(this._onAfterPhysicsObserver);
            this._onAfterPhysicsObserver = null;
        }
        this.scene.onAfterAnimationsObservable.remove(this._onAfterAnimationsObserver);
        this._onAfterAnimationsObserver = null;
        this.scene.onBeforeCameraRenderObservable.remove(this._onBeforeCameraRenderObserver);
        this._onBeforeCameraRenderObserver = null;
        this.scene.onAfterCameraRenderObservable.remove(this._onAfterCameraRenderObserver);
        this._onAfterCameraRenderObserver = null;
        this.scene = null;
    }
}

});


parcelRegister("76Hyh", function(module, exports) {

var $gkrS2 = parcelRequire("gkrS2");

var $dr9wK = parcelRequire("dr9wK");

var $fY6Qv = parcelRequire("fY6Qv");

var $49kOf = parcelRequire("49kOf");

var $8fwD5 = parcelRequire("8fwD5");

var $56TxP = parcelRequire("56TxP");
$parcel$exportWildcard(module.exports, $gkrS2);
$parcel$exportWildcard(module.exports, $dr9wK);
$parcel$exportWildcard(module.exports, $fY6Qv);
$parcel$exportWildcard(module.exports, $49kOf);
$parcel$exportWildcard(module.exports, $8fwD5);
$parcel$exportWildcard(module.exports, $56TxP);

});
parcelRegister("gkrS2", function(module, exports) {

$parcel$export(module.exports, "EffectLayer", () => $be3422187f7249e7$export$12d066ea2d38fac7);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $bOhSV = parcelRequire("bOhSV");

var $diGQf = parcelRequire("diGQf");

var $7etnY = parcelRequire("7etnY");

var $5YkyR = parcelRequire("5YkyR");

var $ejQPp = parcelRequire("ejQPp");

var $b4i1f = parcelRequire("b4i1f");

var $j2mX5 = parcelRequire("j2mX5");

var $gQtNK = parcelRequire("gQtNK");

var $54229 = parcelRequire("54229");
parcelRequire("8CzsX");
parcelRequire("eXRI5");

var $dUFYy = parcelRequire("dUFYy");

var $gc8Ja = parcelRequire("gc8Ja");

var $hOyoX = parcelRequire("hOyoX");

var $aAFeM = parcelRequire("aAFeM");

var $alPCh = parcelRequire("alPCh");
class $be3422187f7249e7$export$12d066ea2d38fac7 {
    /**
     * Gets the camera attached to the layer.
     */ get camera() {
        return this._effectLayerOptions.camera;
    }
    /**
     * Gets the rendering group id the layer should render in.
     */ get renderingGroupId() {
        return this._effectLayerOptions.renderingGroupId;
    }
    set renderingGroupId(renderingGroupId) {
        this._effectLayerOptions.renderingGroupId = renderingGroupId;
    }
    /**
     * Gets the main texture where the effect is rendered
     */ get mainTexture() {
        return this._mainTexture;
    }
    /**
     * Sets a specific material to be used to render a mesh/a list of meshes in the layer
     * @param mesh mesh or array of meshes
     * @param material material to use by the layer when rendering the mesh(es). If undefined is passed, the specific material created by the layer will be used.
     */ setMaterialForRendering(mesh, material) {
        this._mainTexture.setMaterialForRendering(mesh, material);
        if (Array.isArray(mesh)) for(let i = 0; i < mesh.length; ++i){
            const currentMesh = mesh[i];
            if (!material) delete this._materialForRendering[currentMesh.uniqueId];
            else this._materialForRendering[currentMesh.uniqueId] = [
                currentMesh,
                material
            ];
        }
        else if (!material) delete this._materialForRendering[mesh.uniqueId];
        else this._materialForRendering[mesh.uniqueId] = [
            mesh,
            material
        ];
    }
    /**
     * Gets the intensity of the effect for a specific mesh.
     * @param mesh The mesh to get the effect intensity for
     * @returns The intensity of the effect for the mesh
     */ getEffectIntensity(mesh) {
        return this._effectIntensity[mesh.uniqueId] ?? 1;
    }
    /**
     * Sets the intensity of the effect for a specific mesh.
     * @param mesh The mesh to set the effect intensity for
     * @param intensity The intensity of the effect for the mesh
     */ setEffectIntensity(mesh, intensity) {
        this._effectIntensity[mesh.uniqueId] = intensity;
    }
    /**
     * Instantiates a new effect Layer and references it in the scene.
     * @param name The name of the layer
     * @param scene The scene to use the layer in
     */ constructor(/** The Friendly of the effect in the scene */ name, scene){
        this._vertexBuffers = {};
        this._maxSize = 0;
        this._mainTextureDesiredSize = {
            width: 0,
            height: 0
        };
        this._shouldRender = true;
        this._postProcesses = [];
        this._textures = [];
        this._emissiveTextureAndColor = {
            texture: null,
            color: new (0, $7etnY.Color4)()
        };
        this._effectIntensity = {};
        /**
         * The clear color of the texture used to generate the glow map.
         */ this.neutralColor = new (0, $7etnY.Color4)();
        /**
         * Specifies whether the highlight layer is enabled or not.
         */ this.isEnabled = true;
        /**
         * Specifies if the bounding boxes should be rendered normally or if they should undergo the effect of the layer
         */ this.disableBoundingBoxesFromEffectLayer = false;
        /**
         * An event triggered when the effect layer has been disposed.
         */ this.onDisposeObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the effect layer is about rendering the main texture with the glowy parts.
         */ this.onBeforeRenderMainTextureObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the generated texture is being merged in the scene.
         */ this.onBeforeComposeObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the mesh is rendered into the effect render target.
         */ this.onBeforeRenderMeshToEffect = new (0, $diGQf.Observable)();
        /**
         * An event triggered after the mesh has been rendered into the effect render target.
         */ this.onAfterRenderMeshToEffect = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the generated texture has been merged in the scene.
         */ this.onAfterComposeObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the effect layer changes its size.
         */ this.onSizeChangedObservable = new (0, $diGQf.Observable)();
        this._materialForRendering = {};
        this.name = name;
        this._scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        $be3422187f7249e7$export$12d066ea2d38fac7._SceneComponentInitialization(this._scene);
        this._engine = this._scene.getEngine();
        this._maxSize = this._engine.getCaps().maxTextureSize;
        this._scene.effectLayers.push(this);
        this._mergeDrawWrapper = [];
        // Generate Buffers
        this._generateIndexBuffer();
        this._generateVertexBuffer();
    }
    /**
     * Number of times _internalRender will be called. Some effect layers need to render the mesh several times, so they should override this method with the number of times the mesh should be rendered
     * @returns Number of times a mesh must be rendered in the layer
     */ _numInternalDraws() {
        return 1;
    }
    /**
     * Initializes the effect layer with the required options.
     * @param options Sets of none mandatory options to use with the layer (see IEffectLayerOptions for more information)
     */ _init(options) {
        // Adapt options
        this._effectLayerOptions = {
            mainTextureRatio: 0.5,
            alphaBlendingMode: 2,
            camera: null,
            renderingGroupId: -1,
            mainTextureType: 0,
            generateStencilBuffer: false,
            ...options
        };
        this._setMainTextureSize();
        this._createMainTexture();
        this._createTextureAndPostProcesses();
    }
    /**
     * Generates the index buffer of the full screen quad blending to the main canvas.
     */ _generateIndexBuffer() {
        // Indices
        const indices = [];
        indices.push(0);
        indices.push(1);
        indices.push(2);
        indices.push(0);
        indices.push(2);
        indices.push(3);
        this._indexBuffer = this._engine.createIndexBuffer(indices);
    }
    /**
     * Generates the vertex buffer of the full screen quad blending to the main canvas.
     */ _generateVertexBuffer() {
        // VBO
        const vertices = [];
        vertices.push(1, 1);
        vertices.push(-1, 1);
        vertices.push(-1, -1);
        vertices.push(1, -1);
        const vertexBuffer = new (0, $b4i1f.VertexBuffer)(this._engine, vertices, (0, $b4i1f.VertexBuffer).PositionKind, false, false, 2);
        this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind] = vertexBuffer;
    }
    /**
     * Sets the main texture desired size which is the closest power of two
     * of the engine canvas size.
     */ _setMainTextureSize() {
        if (this._effectLayerOptions.mainTextureFixedSize) {
            this._mainTextureDesiredSize.width = this._effectLayerOptions.mainTextureFixedSize;
            this._mainTextureDesiredSize.height = this._effectLayerOptions.mainTextureFixedSize;
        } else {
            this._mainTextureDesiredSize.width = this._engine.getRenderWidth() * this._effectLayerOptions.mainTextureRatio;
            this._mainTextureDesiredSize.height = this._engine.getRenderHeight() * this._effectLayerOptions.mainTextureRatio;
            this._mainTextureDesiredSize.width = this._engine.needPOTTextures ? (0, $5YkyR.Engine).GetExponentOfTwo(this._mainTextureDesiredSize.width, this._maxSize) : this._mainTextureDesiredSize.width;
            this._mainTextureDesiredSize.height = this._engine.needPOTTextures ? (0, $5YkyR.Engine).GetExponentOfTwo(this._mainTextureDesiredSize.height, this._maxSize) : this._mainTextureDesiredSize.height;
        }
        this._mainTextureDesiredSize.width = Math.floor(this._mainTextureDesiredSize.width);
        this._mainTextureDesiredSize.height = Math.floor(this._mainTextureDesiredSize.height);
    }
    /**
     * Creates the main texture for the effect layer.
     */ _createMainTexture() {
        this._mainTexture = new (0, $gQtNK.RenderTargetTexture)("EffectLayerMainRTT", {
            width: this._mainTextureDesiredSize.width,
            height: this._mainTextureDesiredSize.height
        }, this._scene, false, true, this._effectLayerOptions.mainTextureType, false, (0, $j2mX5.Texture).TRILINEAR_SAMPLINGMODE, true, this._effectLayerOptions.generateStencilBuffer);
        this._mainTexture.activeCamera = this._effectLayerOptions.camera;
        this._mainTexture.wrapU = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        this._mainTexture.wrapV = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        this._mainTexture.anisotropicFilteringLevel = 1;
        this._mainTexture.updateSamplingMode((0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE);
        this._mainTexture.renderParticles = false;
        this._mainTexture.renderList = null;
        this._mainTexture.ignoreCameraViewport = true;
        for(const id in this._materialForRendering){
            const [mesh, material] = this._materialForRendering[id];
            this._mainTexture.setMaterialForRendering(mesh, material);
        }
        this._mainTexture.customIsReadyFunction = (mesh, refreshRate, preWarm)=>{
            if ((preWarm || refreshRate === 0) && mesh.subMeshes) for(let i = 0; i < mesh.subMeshes.length; ++i){
                const subMesh = mesh.subMeshes[i];
                const material = subMesh.getMaterial();
                const renderingMesh = subMesh.getRenderingMesh();
                if (!material) continue;
                const batch = renderingMesh._getInstancesRenderList(subMesh._id, !!subMesh.getReplacementMesh());
                const hardwareInstancedRendering = batch.hardwareInstancedRendering[subMesh._id] || renderingMesh.hasThinInstances;
                this._setEmissiveTextureAndColor(renderingMesh, subMesh, material);
                if (!this._isReady(subMesh, hardwareInstancedRendering, this._emissiveTextureAndColor.texture)) return false;
            }
            return true;
        };
        // Custom render function
        this._mainTexture.customRenderFunction = (opaqueSubMeshes, alphaTestSubMeshes, transparentSubMeshes, depthOnlySubMeshes)=>{
            this.onBeforeRenderMainTextureObservable.notifyObservers(this);
            let index;
            const engine = this._scene.getEngine();
            if (depthOnlySubMeshes.length) {
                engine.setColorWrite(false);
                for(index = 0; index < depthOnlySubMeshes.length; index++)this._renderSubMesh(depthOnlySubMeshes.data[index]);
                engine.setColorWrite(true);
            }
            for(index = 0; index < opaqueSubMeshes.length; index++)this._renderSubMesh(opaqueSubMeshes.data[index]);
            for(index = 0; index < alphaTestSubMeshes.length; index++)this._renderSubMesh(alphaTestSubMeshes.data[index]);
            const previousAlphaMode = engine.getAlphaMode();
            for(index = 0; index < transparentSubMeshes.length; index++)this._renderSubMesh(transparentSubMeshes.data[index], true);
            engine.setAlphaMode(previousAlphaMode);
        };
        this._mainTexture.onClearObservable.add((engine)=>{
            engine.clear(this.neutralColor, true, true, true);
        });
        // Prevent package size in es6 (getBoundingBoxRenderer might not be present)
        if (this._scene.getBoundingBoxRenderer) {
            const boundingBoxRendererEnabled = this._scene.getBoundingBoxRenderer().enabled;
            this._mainTexture.onBeforeBindObservable.add(()=>{
                this._scene.getBoundingBoxRenderer().enabled = !this.disableBoundingBoxesFromEffectLayer && boundingBoxRendererEnabled;
            });
            this._mainTexture.onAfterUnbindObservable.add(()=>{
                this._scene.getBoundingBoxRenderer().enabled = boundingBoxRendererEnabled;
            });
        }
    }
    /**
     * Adds specific effects defines.
     * @param defines The defines to add specifics to.
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _addCustomEffectDefines(defines) {
    // Nothing to add by default.
    }
    /**
     * Checks for the readiness of the element composing the layer.
     * @param subMesh the mesh to check for
     * @param useInstances specify whether or not to use instances to render the mesh
     * @param emissiveTexture the associated emissive texture used to generate the glow
     * @returns true if ready otherwise, false
     */ _isReady(subMesh, useInstances, emissiveTexture) {
        const engine = this._scene.getEngine();
        const mesh = subMesh.getMesh();
        const renderingMaterial = mesh._internalAbstractMeshDataInfo._materialForRenderPass?.[engine.currentRenderPassId];
        if (renderingMaterial) return renderingMaterial.isReadyForSubMesh(mesh, subMesh, useInstances);
        const material = subMesh.getMaterial();
        if (!material) return false;
        if (this._useMeshMaterial(subMesh.getRenderingMesh())) return material.isReadyForSubMesh(subMesh.getMesh(), subMesh, useInstances);
        const defines = [];
        const attribs = [
            (0, $b4i1f.VertexBuffer).PositionKind
        ];
        let uv1 = false;
        let uv2 = false;
        // Diffuse
        if (material) {
            const needAlphaTest = material.needAlphaTesting();
            const diffuseTexture = material.getAlphaTestTexture();
            const needAlphaBlendFromDiffuse = diffuseTexture && diffuseTexture.hasAlpha && (material.useAlphaFromDiffuseTexture || material._useAlphaFromAlbedoTexture);
            if (diffuseTexture && (needAlphaTest || needAlphaBlendFromDiffuse)) {
                defines.push("#define DIFFUSE");
                if (mesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UV2Kind) && diffuseTexture.coordinatesIndex === 1) {
                    defines.push("#define DIFFUSEUV2");
                    uv2 = true;
                } else if (mesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UVKind)) {
                    defines.push("#define DIFFUSEUV1");
                    uv1 = true;
                }
                if (needAlphaTest) {
                    defines.push("#define ALPHATEST");
                    defines.push("#define ALPHATESTVALUE 0.4");
                }
                if (!diffuseTexture.gammaSpace) defines.push("#define DIFFUSE_ISLINEAR");
            }
            const opacityTexture = material.opacityTexture;
            if (opacityTexture) {
                defines.push("#define OPACITY");
                if (mesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UV2Kind) && opacityTexture.coordinatesIndex === 1) {
                    defines.push("#define OPACITYUV2");
                    uv2 = true;
                } else if (mesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UVKind)) {
                    defines.push("#define OPACITYUV1");
                    uv1 = true;
                }
            }
        }
        // Emissive
        if (emissiveTexture) {
            defines.push("#define EMISSIVE");
            if (mesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UV2Kind) && emissiveTexture.coordinatesIndex === 1) {
                defines.push("#define EMISSIVEUV2");
                uv2 = true;
            } else if (mesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UVKind)) {
                defines.push("#define EMISSIVEUV1");
                uv1 = true;
            }
            if (!emissiveTexture.gammaSpace) defines.push("#define EMISSIVE_ISLINEAR");
        }
        // Vertex
        if (mesh.useVertexColors && mesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).ColorKind) && mesh.hasVertexAlpha && material.transparencyMode !== (0, $54229.Material).MATERIAL_OPAQUE) {
            attribs.push((0, $b4i1f.VertexBuffer).ColorKind);
            defines.push("#define VERTEXALPHA");
        }
        if (uv1) {
            attribs.push((0, $b4i1f.VertexBuffer).UVKind);
            defines.push("#define UV1");
        }
        if (uv2) {
            attribs.push((0, $b4i1f.VertexBuffer).UV2Kind);
            defines.push("#define UV2");
        }
        // Bones
        const fallbacks = new (0, $gc8Ja.EffectFallbacks)();
        if (mesh.useBones && mesh.computeBonesUsingShaders) {
            attribs.push((0, $b4i1f.VertexBuffer).MatricesIndicesKind);
            attribs.push((0, $b4i1f.VertexBuffer).MatricesWeightsKind);
            if (mesh.numBoneInfluencers > 4) {
                attribs.push((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind);
                attribs.push((0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind);
            }
            defines.push("#define NUM_BONE_INFLUENCERS " + mesh.numBoneInfluencers);
            const skeleton = mesh.skeleton;
            if (skeleton && skeleton.isUsingTextureForMatrices) defines.push("#define BONETEXTURE");
            else defines.push("#define BonesPerMesh " + (skeleton ? skeleton.bones.length + 1 : 0));
            if (mesh.numBoneInfluencers > 0) fallbacks.addCPUSkinningFallback(0, mesh);
        } else defines.push("#define NUM_BONE_INFLUENCERS 0");
        // Morph targets
        const manager = mesh.morphTargetManager;
        let morphInfluencers = 0;
        if (manager) {
            morphInfluencers = manager.numMaxInfluencers || manager.numInfluencers;
            if (morphInfluencers > 0) {
                defines.push("#define MORPHTARGETS");
                defines.push("#define NUM_MORPH_INFLUENCERS " + morphInfluencers);
                if (manager.isUsingTextureForTargets) defines.push("#define MORPHTARGETS_TEXTURE");
                (0, $alPCh.PrepareAttributesForMorphTargetsInfluencers)(attribs, mesh, morphInfluencers);
            }
        }
        // Instances
        if (useInstances) {
            defines.push("#define INSTANCES");
            (0, $alPCh.PushAttributesForInstances)(attribs);
            if (subMesh.getRenderingMesh().hasThinInstances) defines.push("#define THIN_INSTANCES");
        }
        // ClipPlanes
        (0, $aAFeM.prepareStringDefinesForClipPlanes)(material, this._scene, defines);
        this._addCustomEffectDefines(defines);
        // Get correct effect
        const drawWrapper = subMesh._getDrawWrapper(undefined, true);
        const cachedDefines = drawWrapper.defines;
        const join = defines.join("\n");
        if (cachedDefines !== join) {
            const uniforms = [
                "world",
                "mBones",
                "viewProjection",
                "glowColor",
                "morphTargetInfluences",
                "morphTargetCount",
                "boneTextureWidth",
                "diffuseMatrix",
                "emissiveMatrix",
                "opacityMatrix",
                "opacityIntensity",
                "morphTargetTextureInfo",
                "morphTargetTextureIndices",
                "glowIntensity"
            ];
            (0, $aAFeM.addClipPlaneUniforms)(uniforms);
            drawWrapper.setEffect(this._engine.createEffect("glowMapGeneration", attribs, uniforms, [
                "diffuseSampler",
                "emissiveSampler",
                "opacitySampler",
                "boneSampler",
                "morphTargets"
            ], join, fallbacks, undefined, undefined, {
                maxSimultaneousMorphTargets: morphInfluencers
            }), join);
        }
        return drawWrapper.effect.isReady();
    }
    /**
     * Renders the glowing part of the scene by blending the blurred glowing meshes on top of the rendered scene.
     */ render() {
        for(let i = 0; i < this._postProcesses.length; i++){
            if (!this._postProcesses[i].isReady()) return;
        }
        const engine = this._scene.getEngine();
        const numDraws = this._numInternalDraws();
        // Check
        let isReady = true;
        for(let i = 0; i < numDraws; ++i){
            let currentEffect = this._mergeDrawWrapper[i];
            if (!currentEffect) {
                currentEffect = this._mergeDrawWrapper[i] = new (0, $hOyoX.DrawWrapper)(this._engine);
                currentEffect.setEffect(this._createMergeEffect());
            }
            isReady = isReady && currentEffect.effect.isReady();
        }
        if (!isReady) return;
        this.onBeforeComposeObservable.notifyObservers(this);
        const previousAlphaMode = engine.getAlphaMode();
        for(let i = 0; i < numDraws; ++i){
            const currentEffect = this._mergeDrawWrapper[i];
            // Render
            engine.enableEffect(currentEffect);
            engine.setState(false);
            // VBOs
            engine.bindBuffers(this._vertexBuffers, this._indexBuffer, currentEffect.effect);
            // Go Blend.
            engine.setAlphaMode(this._effectLayerOptions.alphaBlendingMode);
            // Blends the map on the main canvas.
            this._internalRender(currentEffect.effect, i);
        }
        // Restore Alpha
        engine.setAlphaMode(previousAlphaMode);
        this.onAfterComposeObservable.notifyObservers(this);
        // Handle size changes.
        const size = this._mainTexture.getSize();
        this._setMainTextureSize();
        if ((size.width !== this._mainTextureDesiredSize.width || size.height !== this._mainTextureDesiredSize.height) && this._mainTextureDesiredSize.width !== 0 && this._mainTextureDesiredSize.height !== 0) {
            // Recreate RTT and post processes on size change.
            this.onSizeChangedObservable.notifyObservers(this);
            this._disposeTextureAndPostProcesses();
            this._createMainTexture();
            this._createTextureAndPostProcesses();
        }
    }
    /**
     * Determine if a given mesh will be used in the current effect.
     * @param mesh mesh to test
     * @returns true if the mesh will be used
     */ hasMesh(mesh) {
        if (this.renderingGroupId === -1 || mesh.renderingGroupId === this.renderingGroupId) return true;
        return false;
    }
    /**
     * Returns true if the layer contains information to display, otherwise false.
     * @returns true if the glow layer should be rendered
     */ shouldRender() {
        return this.isEnabled && this._shouldRender;
    }
    /**
     * Returns true if the mesh should render, otherwise false.
     * @param mesh The mesh to render
     * @returns true if it should render otherwise false
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _shouldRenderMesh(mesh) {
        return true;
    }
    /**
     * Returns true if the mesh can be rendered, otherwise false.
     * @param mesh The mesh to render
     * @param material The material used on the mesh
     * @returns true if it can be rendered otherwise false
     */ _canRenderMesh(mesh, material) {
        return !material.needAlphaBlendingForMesh(mesh);
    }
    /**
     * Returns true if the mesh should render, otherwise false.
     * @returns true if it should render otherwise false
     */ _shouldRenderEmissiveTextureForMesh() {
        return true;
    }
    /**
     * Renders the submesh passed in parameter to the generation map.
     * @param subMesh
     * @param enableAlphaMode
     */ _renderSubMesh(subMesh, enableAlphaMode = false) {
        if (!this.shouldRender()) return;
        const material = subMesh.getMaterial();
        const ownerMesh = subMesh.getMesh();
        const replacementMesh = subMesh.getReplacementMesh();
        const renderingMesh = subMesh.getRenderingMesh();
        const effectiveMesh = subMesh.getEffectiveMesh();
        const scene = this._scene;
        const engine = scene.getEngine();
        effectiveMesh._internalAbstractMeshDataInfo._isActiveIntermediate = false;
        if (!material) return;
        // Do not block in blend mode.
        if (!this._canRenderMesh(renderingMesh, material)) return;
        // Culling
        let sideOrientation = renderingMesh.overrideMaterialSideOrientation ?? material.sideOrientation;
        const mainDeterminant = effectiveMesh._getWorldMatrixDeterminant();
        if (mainDeterminant < 0) sideOrientation = sideOrientation === (0, $54229.Material).ClockWiseSideOrientation ? (0, $54229.Material).CounterClockWiseSideOrientation : (0, $54229.Material).ClockWiseSideOrientation;
        const reverse = sideOrientation === (0, $54229.Material).ClockWiseSideOrientation;
        engine.setState(material.backFaceCulling, material.zOffset, undefined, reverse, material.cullBackFaces, undefined, material.zOffsetUnits);
        // Managing instances
        const batch = renderingMesh._getInstancesRenderList(subMesh._id, !!replacementMesh);
        if (batch.mustReturn) return;
        // Early Exit per mesh
        if (!this._shouldRenderMesh(renderingMesh)) return;
        const hardwareInstancedRendering = batch.hardwareInstancedRendering[subMesh._id] || renderingMesh.hasThinInstances;
        this._setEmissiveTextureAndColor(renderingMesh, subMesh, material);
        this.onBeforeRenderMeshToEffect.notifyObservers(ownerMesh);
        if (this._useMeshMaterial(renderingMesh)) renderingMesh.render(subMesh, enableAlphaMode, replacementMesh || undefined);
        else if (this._isReady(subMesh, hardwareInstancedRendering, this._emissiveTextureAndColor.texture)) {
            const renderingMaterial = effectiveMesh._internalAbstractMeshDataInfo._materialForRenderPass?.[engine.currentRenderPassId];
            let drawWrapper = subMesh._getDrawWrapper();
            if (!drawWrapper && renderingMaterial) drawWrapper = renderingMaterial._getDrawWrapper();
            if (!drawWrapper) return;
            const effect = drawWrapper.effect;
            engine.enableEffect(drawWrapper);
            if (!hardwareInstancedRendering) renderingMesh._bind(subMesh, effect, material.fillMode);
            if (!renderingMaterial) {
                effect.setMatrix("viewProjection", scene.getTransformMatrix());
                effect.setMatrix("world", effectiveMesh.getWorldMatrix());
                effect.setFloat4("glowColor", this._emissiveTextureAndColor.color.r, this._emissiveTextureAndColor.color.g, this._emissiveTextureAndColor.color.b, this._emissiveTextureAndColor.color.a);
            } else renderingMaterial.bindForSubMesh(effectiveMesh.getWorldMatrix(), effectiveMesh, subMesh);
            if (!renderingMaterial) {
                const needAlphaTest = material.needAlphaTesting();
                const diffuseTexture = material.getAlphaTestTexture();
                const needAlphaBlendFromDiffuse = diffuseTexture && diffuseTexture.hasAlpha && (material.useAlphaFromDiffuseTexture || material._useAlphaFromAlbedoTexture);
                if (diffuseTexture && (needAlphaTest || needAlphaBlendFromDiffuse)) {
                    effect.setTexture("diffuseSampler", diffuseTexture);
                    const textureMatrix = diffuseTexture.getTextureMatrix();
                    if (textureMatrix) effect.setMatrix("diffuseMatrix", textureMatrix);
                }
                const opacityTexture = material.opacityTexture;
                if (opacityTexture) {
                    effect.setTexture("opacitySampler", opacityTexture);
                    effect.setFloat("opacityIntensity", opacityTexture.level);
                    const textureMatrix = opacityTexture.getTextureMatrix();
                    if (textureMatrix) effect.setMatrix("opacityMatrix", textureMatrix);
                }
                // Glow emissive only
                if (this._emissiveTextureAndColor.texture) {
                    effect.setTexture("emissiveSampler", this._emissiveTextureAndColor.texture);
                    effect.setMatrix("emissiveMatrix", this._emissiveTextureAndColor.texture.getTextureMatrix());
                }
                // Bones
                if (renderingMesh.useBones && renderingMesh.computeBonesUsingShaders && renderingMesh.skeleton) {
                    const skeleton = renderingMesh.skeleton;
                    if (skeleton.isUsingTextureForMatrices) {
                        const boneTexture = skeleton.getTransformMatrixTexture(renderingMesh);
                        if (!boneTexture) return;
                        effect.setTexture("boneSampler", boneTexture);
                        effect.setFloat("boneTextureWidth", 4.0 * (skeleton.bones.length + 1));
                    } else effect.setMatrices("mBones", skeleton.getTransformMatrices(renderingMesh));
                }
                // Morph targets
                (0, $alPCh.BindMorphTargetParameters)(renderingMesh, effect);
                if (renderingMesh.morphTargetManager && renderingMesh.morphTargetManager.isUsingTextureForTargets) renderingMesh.morphTargetManager._bind(effect);
                // Alpha mode
                if (enableAlphaMode) engine.setAlphaMode(material.alphaMode);
                // Intensity of effect
                effect.setFloat("glowIntensity", this.getEffectIntensity(renderingMesh));
                // Clip planes
                (0, $aAFeM.bindClipPlane)(effect, material, scene);
            }
            // Draw
            renderingMesh._processRendering(effectiveMesh, subMesh, effect, material.fillMode, batch, hardwareInstancedRendering, (isInstance, world)=>effect.setMatrix("world", world));
        } else // Need to reset refresh rate of the main map
        this._mainTexture.resetRefreshCounter();
        this.onAfterRenderMeshToEffect.notifyObservers(ownerMesh);
    }
    /**
     * Defines whether the current material of the mesh should be use to render the effect.
     * @param mesh defines the current mesh to render
     * @returns true if the mesh material should be use
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _useMeshMaterial(mesh) {
        return false;
    }
    /**
     * Rebuild the required buffers.
     * @internal Internal use only.
     */ _rebuild() {
        const vb = this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind];
        if (vb) vb._rebuild();
        this._generateIndexBuffer();
    }
    /**
     * Dispose only the render target textures and post process.
     */ _disposeTextureAndPostProcesses() {
        this._mainTexture.dispose();
        for(let i = 0; i < this._postProcesses.length; i++)if (this._postProcesses[i]) this._postProcesses[i].dispose();
        this._postProcesses = [];
        for(let i = 0; i < this._textures.length; i++)if (this._textures[i]) this._textures[i].dispose();
        this._textures = [];
    }
    /**
     * Dispose the highlight layer and free resources.
     */ dispose() {
        const vertexBuffer = this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind];
        if (vertexBuffer) {
            vertexBuffer.dispose();
            this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind] = null;
        }
        if (this._indexBuffer) {
            this._scene.getEngine()._releaseBuffer(this._indexBuffer);
            this._indexBuffer = null;
        }
        for (const drawWrapper of this._mergeDrawWrapper)drawWrapper.dispose();
        this._mergeDrawWrapper = [];
        // Clean textures and post processes
        this._disposeTextureAndPostProcesses();
        // Remove from scene
        const index = this._scene.effectLayers.indexOf(this, 0);
        if (index > -1) this._scene.effectLayers.splice(index, 1);
        // Callback
        this.onDisposeObservable.notifyObservers(this);
        this.onDisposeObservable.clear();
        this.onBeforeRenderMainTextureObservable.clear();
        this.onBeforeComposeObservable.clear();
        this.onBeforeRenderMeshToEffect.clear();
        this.onAfterRenderMeshToEffect.clear();
        this.onAfterComposeObservable.clear();
        this.onSizeChangedObservable.clear();
    }
    /**
     * Gets the class name of the effect layer
     * @returns the string with the class name of the effect layer
     */ getClassName() {
        return "EffectLayer";
    }
    /**
     * Creates an effect layer from parsed effect layer data
     * @param parsedEffectLayer defines effect layer data
     * @param scene defines the current scene
     * @param rootUrl defines the root URL containing the effect layer information
     * @returns a parsed effect Layer
     */ static Parse(parsedEffectLayer, scene, rootUrl) {
        const effectLayerType = (0, $bOhSV.Tools).Instantiate(parsedEffectLayer.customType);
        return effectLayerType.Parse(parsedEffectLayer, scene, rootUrl);
    }
}
/**
 * @internal
 */ $be3422187f7249e7$export$12d066ea2d38fac7._SceneComponentInitialization = (_)=>{
    throw (0, $dUFYy._WarnImport)("EffectLayerSceneComponent");
};
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $be3422187f7249e7$export$12d066ea2d38fac7.prototype, "name", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor4)()
], $be3422187f7249e7$export$12d066ea2d38fac7.prototype, "neutralColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $be3422187f7249e7$export$12d066ea2d38fac7.prototype, "isEnabled", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsCameraReference)()
], $be3422187f7249e7$export$12d066ea2d38fac7.prototype, "camera", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $be3422187f7249e7$export$12d066ea2d38fac7.prototype, "renderingGroupId", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $be3422187f7249e7$export$12d066ea2d38fac7.prototype, "disableBoundingBoxesFromEffectLayer", void 0);

});
parcelRegister("8CzsX", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("7Hs3g");
parcelRequire("82O8L");
parcelRequire("kg1CD");
const $646d62275ca28024$var$name = "glowMapGenerationPixelShader";
const $646d62275ca28024$var$shader = `#if defined(DIFFUSE_ISLINEAR) || defined(EMISSIVE_ISLINEAR)
#include<helperFunctions>
#endif
#ifdef DIFFUSE
varying vec2 vUVDiffuse;uniform sampler2D diffuseSampler;
#endif
#ifdef OPACITY
varying vec2 vUVOpacity;uniform sampler2D opacitySampler;uniform float opacityIntensity;
#endif
#ifdef EMISSIVE
varying vec2 vUVEmissive;uniform sampler2D emissiveSampler;
#endif
#ifdef VERTEXALPHA
varying vec4 vColor;
#endif
uniform vec4 glowColor;uniform float glowIntensity;
#include<clipPlaneFragmentDeclaration>
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{
#include<clipPlaneFragment>
vec4 finalColor=glowColor;
#ifdef DIFFUSE
vec4 albedoTexture=texture2D(diffuseSampler,vUVDiffuse);
#ifdef DIFFUSE_ISLINEAR
albedoTexture=toGammaSpace(albedoTexture);
#endif
#ifdef GLOW
finalColor.a*=albedoTexture.a;
#endif
#ifdef HIGHLIGHT
finalColor.a=albedoTexture.a;
#endif
#endif
#ifdef OPACITY
vec4 opacityMap=texture2D(opacitySampler,vUVOpacity);
#ifdef OPACITYRGB
finalColor.a*=getLuminance(opacityMap.rgb);
#else
finalColor.a*=opacityMap.a;
#endif
finalColor.a*=opacityIntensity;
#endif
#ifdef VERTEXALPHA
finalColor.a*=vColor.a;
#endif
#ifdef ALPHATEST
if (finalColor.a<ALPHATESTVALUE)
discard;
#endif
#ifdef EMISSIVE
vec4 emissive=texture2D(emissiveSampler,vUVEmissive);
#ifdef EMISSIVE_ISLINEAR
emissive=toGammaSpace(emissive);
#endif
gl_FragColor=emissive*finalColor*glowIntensity;
#else
gl_FragColor=finalColor*glowIntensity;
#endif
#ifdef HIGHLIGHT
gl_FragColor.a=glowColor.a;
#endif
}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$646d62275ca28024$var$name] = $646d62275ca28024$var$shader;
const $646d62275ca28024$export$7369dde145ca8da1 = {
    name: $646d62275ca28024$var$name,
    shader: $646d62275ca28024$var$shader
};

});

parcelRegister("eXRI5", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("7PW7m");
parcelRequire("8kYMw");
parcelRequire("5Eb4I");
parcelRequire("9H5jp");
parcelRequire("4A4MM");
parcelRequire("k3wwH");
parcelRequire("9ulLS");
parcelRequire("LFrAO");
parcelRequire("apKdp");
parcelRequire("4idCt");
parcelRequire("cIweX");
parcelRequire("kqCfW");
const $ae503d12ca97e052$var$name = "glowMapGenerationVertexShader";
const $ae503d12ca97e052$var$shader = `attribute vec3 position;
#include<bonesDeclaration>
#include<bakedVertexAnimationDeclaration>
#include<morphTargetsVertexGlobalDeclaration>
#include<morphTargetsVertexDeclaration>[0..maxSimultaneousMorphTargets]
#include<clipPlaneVertexDeclaration>
#include<instancesDeclaration>
uniform mat4 viewProjection;varying vec4 vPosition;
#ifdef UV1
attribute vec2 uv;
#endif
#ifdef UV2
attribute vec2 uv2;
#endif
#ifdef DIFFUSE
varying vec2 vUVDiffuse;uniform mat4 diffuseMatrix;
#endif
#ifdef OPACITY
varying vec2 vUVOpacity;uniform mat4 opacityMatrix;
#endif
#ifdef EMISSIVE
varying vec2 vUVEmissive;uniform mat4 emissiveMatrix;
#endif
#ifdef VERTEXALPHA
attribute vec4 color;varying vec4 vColor;
#endif
#define CUSTOM_VERTEX_DEFINITIONS
void main(void)
{vec3 positionUpdated=position;
#ifdef UV1
vec2 uvUpdated=uv;
#endif
#include<morphTargetsVertexGlobal>
#include<morphTargetsVertex>[0..maxSimultaneousMorphTargets]
#include<instancesVertex>
#include<bonesVertex>
#include<bakedVertexAnimation>
vec4 worldPos=finalWorld*vec4(positionUpdated,1.0);
#ifdef CUBEMAP
vPosition=worldPos;gl_Position=viewProjection*finalWorld*vec4(position,1.0);
#else
vPosition=viewProjection*worldPos;gl_Position=vPosition;
#endif
#ifdef DIFFUSE
#ifdef DIFFUSEUV1
vUVDiffuse=vec2(diffuseMatrix*vec4(uvUpdated,1.0,0.0));
#endif
#ifdef DIFFUSEUV2
vUVDiffuse=vec2(diffuseMatrix*vec4(uv2,1.0,0.0));
#endif
#endif
#ifdef OPACITY
#ifdef OPACITYUV1
vUVOpacity=vec2(opacityMatrix*vec4(uvUpdated,1.0,0.0));
#endif
#ifdef OPACITYUV2
vUVOpacity=vec2(opacityMatrix*vec4(uv2,1.0,0.0));
#endif
#endif
#ifdef EMISSIVE
#ifdef EMISSIVEUV1
vUVEmissive=vec2(emissiveMatrix*vec4(uvUpdated,1.0,0.0));
#endif
#ifdef EMISSIVEUV2
vUVEmissive=vec2(emissiveMatrix*vec4(uv2,1.0,0.0));
#endif
#endif
#ifdef VERTEXALPHA
vColor=color;
#endif
#include<clipPlaneVertex>
}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$ae503d12ca97e052$var$name] = $ae503d12ca97e052$var$shader;
const $ae503d12ca97e052$export$efd2386a41e9d90a = {
    name: $ae503d12ca97e052$var$name,
    shader: $ae503d12ca97e052$var$shader
};

});


parcelRegister("dr9wK", function(module, exports) {

$parcel$export(module.exports, "EffectLayerSceneComponent", () => $9c852fdeaa3823b3$export$cfb796e36d33a5f);

var $74SKQ = parcelRequire("74SKQ");

var $bv05l = parcelRequire("bv05l");

var $gkrS2 = parcelRequire("gkrS2");

var $5Tqba = parcelRequire("5Tqba");

var $ejQPp = parcelRequire("ejQPp");
// Adds the parser to the scene parsers.
(0, $5Tqba.AbstractScene).AddParser((0, $bv05l.SceneComponentConstants).NAME_EFFECTLAYER, (parsedData, scene, container, rootUrl)=>{
    if (parsedData.effectLayers) {
        if (!container.effectLayers) container.effectLayers = [];
        for(let index = 0; index < parsedData.effectLayers.length; index++){
            const effectLayer = (0, $gkrS2.EffectLayer).Parse(parsedData.effectLayers[index], scene, rootUrl);
            container.effectLayers.push(effectLayer);
        }
    }
});
(0, $5Tqba.AbstractScene).prototype.removeEffectLayer = function(toRemove) {
    const index = this.effectLayers.indexOf(toRemove);
    if (index !== -1) this.effectLayers.splice(index, 1);
    return index;
};
(0, $5Tqba.AbstractScene).prototype.addEffectLayer = function(newEffectLayer) {
    this.effectLayers.push(newEffectLayer);
};
class $9c852fdeaa3823b3$export$cfb796e36d33a5f {
    /**
     * Creates a new instance of the component for the given scene
     * @param scene Defines the scene to register the component in
     */ constructor(scene){
        /**
         * The component name helpful to identify the component in the list of scene components.
         */ this.name = (0, $bv05l.SceneComponentConstants).NAME_EFFECTLAYER;
        this._renderEffects = false;
        this._needStencil = false;
        this._previousStencilState = false;
        this.scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        if (!this.scene) return;
        this._engine = this.scene.getEngine();
        this.scene.effectLayers = [];
    }
    /**
     * Registers the component in a given scene
     */ register() {
        this.scene._isReadyForMeshStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_ISREADYFORMESH_EFFECTLAYER, this, this._isReadyForMesh);
        this.scene._cameraDrawRenderTargetStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_CAMERADRAWRENDERTARGET_EFFECTLAYER, this, this._renderMainTexture);
        this.scene._beforeCameraDrawStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_BEFORECAMERADRAW_EFFECTLAYER, this, this._setStencil);
        this.scene._afterRenderingGroupDrawStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_AFTERRENDERINGGROUPDRAW_EFFECTLAYER_DRAW, this, this._drawRenderingGroup);
        this.scene._afterCameraDrawStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_AFTERCAMERADRAW_EFFECTLAYER, this, this._setStencilBack);
        this.scene._afterCameraDrawStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_AFTERCAMERADRAW_EFFECTLAYER_DRAW, this, this._drawCamera);
    }
    /**
     * Rebuilds the elements related to this component in case of
     * context lost for instance.
     */ rebuild() {
        const layers = this.scene.effectLayers;
        for (const effectLayer of layers)effectLayer._rebuild();
    }
    /**
     * Serializes the component data to the specified json object
     * @param serializationObject The object to serialize to
     */ serialize(serializationObject) {
        // Effect layers
        serializationObject.effectLayers = [];
        const layers = this.scene.effectLayers;
        for (const effectLayer of layers)if (effectLayer.serialize) serializationObject.effectLayers.push(effectLayer.serialize());
    }
    /**
     * Adds all the elements from the container to the scene
     * @param container the container holding the elements
     */ addFromContainer(container) {
        if (!container.effectLayers) return;
        container.effectLayers.forEach((o)=>{
            this.scene.addEffectLayer(o);
        });
    }
    /**
     * Removes all the elements in the container from the scene
     * @param container contains the elements to remove
     * @param dispose if the removed element should be disposed (default: false)
     */ removeFromContainer(container, dispose) {
        if (!container.effectLayers) return;
        container.effectLayers.forEach((o)=>{
            this.scene.removeEffectLayer(o);
            if (dispose) o.dispose();
        });
    }
    /**
     * Disposes the component and the associated resources.
     */ dispose() {
        const layers = this.scene.effectLayers;
        while(layers.length)layers[0].dispose();
    }
    _isReadyForMesh(mesh, hardwareInstancedRendering) {
        const currentRenderPassId = this._engine.currentRenderPassId;
        const layers = this.scene.effectLayers;
        for (const layer of layers){
            if (!layer.hasMesh(mesh)) continue;
            const renderTarget = layer._mainTexture;
            this._engine.currentRenderPassId = renderTarget.renderPassId;
            for (const subMesh of mesh.subMeshes)if (!layer.isReady(subMesh, hardwareInstancedRendering)) {
                this._engine.currentRenderPassId = currentRenderPassId;
                return false;
            }
        }
        this._engine.currentRenderPassId = currentRenderPassId;
        return true;
    }
    _renderMainTexture(camera) {
        this._renderEffects = false;
        this._needStencil = false;
        let needRebind = false;
        const layers = this.scene.effectLayers;
        if (layers && layers.length > 0) {
            this._previousStencilState = this._engine.getStencilBuffer();
            for (const effectLayer of layers)if (effectLayer.shouldRender() && (!effectLayer.camera || effectLayer.camera.cameraRigMode === (0, $74SKQ.Camera).RIG_MODE_NONE && camera === effectLayer.camera || effectLayer.camera.cameraRigMode !== (0, $74SKQ.Camera).RIG_MODE_NONE && effectLayer.camera._rigCameras.indexOf(camera) > -1)) {
                this._renderEffects = true;
                this._needStencil = this._needStencil || effectLayer.needStencil();
                const renderTarget = effectLayer._mainTexture;
                if (renderTarget._shouldRender()) {
                    this.scene.incrementRenderId();
                    renderTarget.render(false, false);
                    needRebind = true;
                }
            }
            this.scene.incrementRenderId();
        }
        return needRebind;
    }
    _setStencil() {
        // Activate effect Layer stencil
        if (this._needStencil) this._engine.setStencilBuffer(true);
    }
    _setStencilBack() {
        // Restore effect Layer stencil
        if (this._needStencil) this._engine.setStencilBuffer(this._previousStencilState);
    }
    _draw(renderingGroupId) {
        if (this._renderEffects) {
            this._engine.setDepthBuffer(false);
            const layers = this.scene.effectLayers;
            for(let i = 0; i < layers.length; i++){
                const effectLayer = layers[i];
                if (effectLayer.renderingGroupId === renderingGroupId) {
                    if (effectLayer.shouldRender()) effectLayer.render();
                }
            }
            this._engine.setDepthBuffer(true);
        }
    }
    _drawCamera() {
        if (this._renderEffects) this._draw(-1);
    }
    _drawRenderingGroup(index) {
        if (!this.scene._isInIntermediateRendering() && this._renderEffects) this._draw(index);
    }
}
(0, $gkrS2.EffectLayer)._SceneComponentInitialization = (scene)=>{
    let component = scene._getComponent((0, $bv05l.SceneComponentConstants).NAME_EFFECTLAYER);
    if (!component) {
        component = new $9c852fdeaa3823b3$export$cfb796e36d33a5f(scene);
        scene._addComponent(component);
    }
};

});

parcelRegister("fY6Qv", function(module, exports) {

$parcel$export(module.exports, "GlowLayer", () => $ba01c510ffb7f19d$export$560831ae0419d7af);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $ha1VO = parcelRequire("ha1VO");

var $b4i1f = parcelRequire("b4i1f");

var $j2mX5 = parcelRequire("j2mX5");

var $gQtNK = parcelRequire("gQtNK");

var $54229 = parcelRequire("54229");

var $8zEq7 = parcelRequire("8zEq7");

var $gkrS2 = parcelRequire("gkrS2");

var $5Tqba = parcelRequire("5Tqba");

var $8DoUR = parcelRequire("8DoUR");

var $5YkyR = parcelRequire("5YkyR");

var $7etnY = parcelRequire("7etnY");
parcelRequire("4BFof");
parcelRequire("jElvn");
parcelRequire("dr9wK");

var $6Ho1L = parcelRequire("6Ho1L");
(0, $5Tqba.AbstractScene).prototype.getGlowLayerByName = function(name) {
    for(let index = 0; index < this.effectLayers?.length; index++){
        if (this.effectLayers[index].name === name && this.effectLayers[index].getEffectName() === $ba01c510ffb7f19d$export$560831ae0419d7af.EffectName) return this.effectLayers[index];
    }
    return null;
};
class $ba01c510ffb7f19d$export$560831ae0419d7af extends (0, $gkrS2.EffectLayer) {
    /**
     * Sets the kernel size of the blur.
     */ set blurKernelSize(value) {
        if (value === this._options.blurKernelSize) return;
        this._options.blurKernelSize = value;
        const effectiveKernel = this._getEffectiveBlurKernelSize();
        this._horizontalBlurPostprocess1.kernel = effectiveKernel;
        this._verticalBlurPostprocess1.kernel = effectiveKernel;
        this._horizontalBlurPostprocess2.kernel = effectiveKernel;
        this._verticalBlurPostprocess2.kernel = effectiveKernel;
    }
    /**
     * Gets the kernel size of the blur.
     */ get blurKernelSize() {
        return this._options.blurKernelSize;
    }
    /**
     * Sets the glow intensity.
     */ set intensity(value) {
        this._intensity = value;
    }
    /**
     * Gets the glow intensity.
     */ get intensity() {
        return this._intensity;
    }
    /**
     * Instantiates a new glow Layer and references it to the scene.
     * @param name The name of the layer
     * @param scene The scene to use the layer in
     * @param options Sets of none mandatory options to use with the layer (see IGlowLayerOptions for more information)
     */ constructor(name, scene, options){
        super(name, scene);
        this._intensity = 1.0;
        this._includedOnlyMeshes = [];
        this._excludedMeshes = [];
        this._meshesUsingTheirOwnMaterials = [];
        this.neutralColor = new (0, $7etnY.Color4)(0, 0, 0, 1);
        // Adapt options
        this._options = {
            mainTextureRatio: $ba01c510ffb7f19d$export$560831ae0419d7af.DefaultTextureRatio,
            blurKernelSize: 32,
            mainTextureFixedSize: undefined,
            camera: null,
            mainTextureSamples: 1,
            renderingGroupId: -1,
            ldrMerge: false,
            alphaBlendingMode: 1,
            mainTextureType: 0,
            generateStencilBuffer: false,
            ...options
        };
        // Initialize the layer
        this._init({
            alphaBlendingMode: this._options.alphaBlendingMode,
            camera: this._options.camera,
            mainTextureFixedSize: this._options.mainTextureFixedSize,
            mainTextureRatio: this._options.mainTextureRatio,
            renderingGroupId: this._options.renderingGroupId,
            mainTextureType: this._options.mainTextureType,
            generateStencilBuffer: this._options.generateStencilBuffer
        });
    }
    /**
     * Get the effect name of the layer.
     * @returns The effect name
     */ getEffectName() {
        return $ba01c510ffb7f19d$export$560831ae0419d7af.EffectName;
    }
    /**
     * @internal
     * Create the merge effect. This is the shader use to blit the information back
     * to the main canvas at the end of the scene rendering.
     */ _createMergeEffect() {
        let defines = "#define EMISSIVE \n";
        if (this._options.ldrMerge) defines += "#define LDR \n";
        // Effect
        return this._engine.createEffect("glowMapMerge", [
            (0, $b4i1f.VertexBuffer).PositionKind
        ], [
            "offset"
        ], [
            "textureSampler",
            "textureSampler2"
        ], defines);
    }
    /**
     * Creates the render target textures and post processes used in the glow layer.
     */ _createTextureAndPostProcesses() {
        let blurTextureWidth = this._mainTextureDesiredSize.width;
        let blurTextureHeight = this._mainTextureDesiredSize.height;
        blurTextureWidth = this._engine.needPOTTextures ? (0, $5YkyR.Engine).GetExponentOfTwo(blurTextureWidth, this._maxSize) : blurTextureWidth;
        blurTextureHeight = this._engine.needPOTTextures ? (0, $5YkyR.Engine).GetExponentOfTwo(blurTextureHeight, this._maxSize) : blurTextureHeight;
        let textureType = 0;
        if (this._engine.getCaps().textureHalfFloatRender) textureType = 2;
        else textureType = 0;
        this._blurTexture1 = new (0, $gQtNK.RenderTargetTexture)("GlowLayerBlurRTT", {
            width: blurTextureWidth,
            height: blurTextureHeight
        }, this._scene, false, true, textureType);
        this._blurTexture1.wrapU = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        this._blurTexture1.wrapV = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        this._blurTexture1.updateSamplingMode((0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE);
        this._blurTexture1.renderParticles = false;
        this._blurTexture1.ignoreCameraViewport = true;
        const blurTextureWidth2 = Math.floor(blurTextureWidth / 2);
        const blurTextureHeight2 = Math.floor(blurTextureHeight / 2);
        this._blurTexture2 = new (0, $gQtNK.RenderTargetTexture)("GlowLayerBlurRTT2", {
            width: blurTextureWidth2,
            height: blurTextureHeight2
        }, this._scene, false, true, textureType);
        this._blurTexture2.wrapU = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        this._blurTexture2.wrapV = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        this._blurTexture2.updateSamplingMode((0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE);
        this._blurTexture2.renderParticles = false;
        this._blurTexture2.ignoreCameraViewport = true;
        this._textures = [
            this._blurTexture1,
            this._blurTexture2
        ];
        const effectiveKernel = this._getEffectiveBlurKernelSize();
        this._horizontalBlurPostprocess1 = new (0, $8zEq7.BlurPostProcess)("GlowLayerHBP1", new (0, $ha1VO.Vector2)(1.0, 0), effectiveKernel, {
            width: blurTextureWidth,
            height: blurTextureHeight
        }, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, this._scene.getEngine(), false, textureType);
        this._horizontalBlurPostprocess1.width = blurTextureWidth;
        this._horizontalBlurPostprocess1.height = blurTextureHeight;
        this._horizontalBlurPostprocess1.externalTextureSamplerBinding = true;
        this._horizontalBlurPostprocess1.onApplyObservable.add((effect)=>{
            effect.setTexture("textureSampler", this._mainTexture);
        });
        this._verticalBlurPostprocess1 = new (0, $8zEq7.BlurPostProcess)("GlowLayerVBP1", new (0, $ha1VO.Vector2)(0, 1.0), effectiveKernel, {
            width: blurTextureWidth,
            height: blurTextureHeight
        }, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, this._scene.getEngine(), false, textureType);
        this._horizontalBlurPostprocess2 = new (0, $8zEq7.BlurPostProcess)("GlowLayerHBP2", new (0, $ha1VO.Vector2)(1.0, 0), effectiveKernel, {
            width: blurTextureWidth2,
            height: blurTextureHeight2
        }, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, this._scene.getEngine(), false, textureType);
        this._horizontalBlurPostprocess2.width = blurTextureWidth2;
        this._horizontalBlurPostprocess2.height = blurTextureHeight2;
        this._horizontalBlurPostprocess2.externalTextureSamplerBinding = true;
        this._horizontalBlurPostprocess2.onApplyObservable.add((effect)=>{
            effect.setTexture("textureSampler", this._blurTexture1);
        });
        this._verticalBlurPostprocess2 = new (0, $8zEq7.BlurPostProcess)("GlowLayerVBP2", new (0, $ha1VO.Vector2)(0, 1.0), effectiveKernel, {
            width: blurTextureWidth2,
            height: blurTextureHeight2
        }, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, this._scene.getEngine(), false, textureType);
        this._postProcesses = [
            this._horizontalBlurPostprocess1,
            this._verticalBlurPostprocess1,
            this._horizontalBlurPostprocess2,
            this._verticalBlurPostprocess2
        ];
        this._postProcesses1 = [
            this._horizontalBlurPostprocess1,
            this._verticalBlurPostprocess1
        ];
        this._postProcesses2 = [
            this._horizontalBlurPostprocess2,
            this._verticalBlurPostprocess2
        ];
        this._mainTexture.samples = this._options.mainTextureSamples;
        this._mainTexture.onAfterUnbindObservable.add(()=>{
            const internalTexture = this._blurTexture1.renderTarget;
            if (internalTexture) {
                this._scene.postProcessManager.directRender(this._postProcesses1, internalTexture, true);
                const internalTexture2 = this._blurTexture2.renderTarget;
                if (internalTexture2) this._scene.postProcessManager.directRender(this._postProcesses2, internalTexture2, true);
                this._engine.unBindFramebuffer(internalTexture2 ?? internalTexture, true);
            }
        });
        // Prevent autoClear.
        this._postProcesses.map((pp)=>{
            pp.autoClear = false;
        });
    }
    /**
     * @returns The blur kernel size used by the glow.
     * Note: The value passed in the options is divided by 2 for back compatibility.
     */ _getEffectiveBlurKernelSize() {
        return this._options.blurKernelSize / 2;
    }
    /**
     * Checks for the readiness of the element composing the layer.
     * @param subMesh the mesh to check for
     * @param useInstances specify whether or not to use instances to render the mesh
     * @returns true if ready otherwise, false
     */ isReady(subMesh, useInstances) {
        const material = subMesh.getMaterial();
        const mesh = subMesh.getRenderingMesh();
        if (!material || !mesh) return false;
        const emissiveTexture = material.emissiveTexture;
        return super._isReady(subMesh, useInstances, emissiveTexture);
    }
    /**
     * @returns whether or not the layer needs stencil enabled during the mesh rendering.
     */ needStencil() {
        return false;
    }
    /**
     * Returns true if the mesh can be rendered, otherwise false.
     * @param mesh The mesh to render
     * @param material The material used on the mesh
     * @returns true if it can be rendered otherwise false
     */ _canRenderMesh(mesh, material) {
        return true;
    }
    /**
     * Implementation specific of rendering the generating effect on the main canvas.
     * @param effect The effect used to render through
     */ _internalRender(effect) {
        // Texture
        effect.setTexture("textureSampler", this._blurTexture1);
        effect.setTexture("textureSampler2", this._blurTexture2);
        effect.setFloat("offset", this._intensity);
        // Cache
        const engine = this._engine;
        const previousStencilBuffer = engine.getStencilBuffer();
        // Draw order
        engine.setStencilBuffer(false);
        engine.drawElementsType((0, $54229.Material).TriangleFillMode, 0, 6);
        // Draw order
        engine.setStencilBuffer(previousStencilBuffer);
    }
    /**
     * Sets the required values for both the emissive texture and and the main color.
     * @param mesh
     * @param subMesh
     * @param material
     */ _setEmissiveTextureAndColor(mesh, subMesh, material) {
        let textureLevel = 1.0;
        if (this.customEmissiveTextureSelector) this._emissiveTextureAndColor.texture = this.customEmissiveTextureSelector(mesh, subMesh, material);
        else if (material) {
            this._emissiveTextureAndColor.texture = material.emissiveTexture;
            if (this._emissiveTextureAndColor.texture) textureLevel = this._emissiveTextureAndColor.texture.level;
        } else this._emissiveTextureAndColor.texture = null;
        if (this.customEmissiveColorSelector) this.customEmissiveColorSelector(mesh, subMesh, material, this._emissiveTextureAndColor.color);
        else if (material.emissiveColor) {
            const emissiveIntensity = material.emissiveIntensity ?? 1;
            textureLevel *= emissiveIntensity;
            this._emissiveTextureAndColor.color.set(material.emissiveColor.r * textureLevel, material.emissiveColor.g * textureLevel, material.emissiveColor.b * textureLevel, material.alpha);
        } else this._emissiveTextureAndColor.color.set(this.neutralColor.r, this.neutralColor.g, this.neutralColor.b, this.neutralColor.a);
    }
    /**
     * Returns true if the mesh should render, otherwise false.
     * @param mesh The mesh to render
     * @returns true if it should render otherwise false
     */ _shouldRenderMesh(mesh) {
        return this.hasMesh(mesh);
    }
    /**
     * Adds specific effects defines.
     * @param defines The defines to add specifics to.
     */ _addCustomEffectDefines(defines) {
        defines.push("#define GLOW");
    }
    /**
     * Add a mesh in the exclusion list to prevent it to impact or being impacted by the glow layer.
     * @param mesh The mesh to exclude from the glow layer
     */ addExcludedMesh(mesh) {
        if (this._excludedMeshes.indexOf(mesh.uniqueId) === -1) this._excludedMeshes.push(mesh.uniqueId);
    }
    /**
     * Remove a mesh from the exclusion list to let it impact or being impacted by the glow layer.
     * @param mesh The mesh to remove
     */ removeExcludedMesh(mesh) {
        const index = this._excludedMeshes.indexOf(mesh.uniqueId);
        if (index !== -1) this._excludedMeshes.splice(index, 1);
    }
    /**
     * Add a mesh in the inclusion list to impact or being impacted by the glow layer.
     * @param mesh The mesh to include in the glow layer
     */ addIncludedOnlyMesh(mesh) {
        if (this._includedOnlyMeshes.indexOf(mesh.uniqueId) === -1) this._includedOnlyMeshes.push(mesh.uniqueId);
    }
    /**
     * Remove a mesh from the Inclusion list to prevent it to impact or being impacted by the glow layer.
     * @param mesh The mesh to remove
     */ removeIncludedOnlyMesh(mesh) {
        const index = this._includedOnlyMeshes.indexOf(mesh.uniqueId);
        if (index !== -1) this._includedOnlyMeshes.splice(index, 1);
    }
    /**
     * Determine if a given mesh will be used in the glow layer
     * @param mesh The mesh to test
     * @returns true if the mesh will be highlighted by the current glow layer
     */ hasMesh(mesh) {
        if (!super.hasMesh(mesh)) return false;
        // Included Mesh
        if (this._includedOnlyMeshes.length) return this._includedOnlyMeshes.indexOf(mesh.uniqueId) !== -1;
        // Excluded Mesh
        if (this._excludedMeshes.length) return this._excludedMeshes.indexOf(mesh.uniqueId) === -1;
        return true;
    }
    /**
     * Defines whether the current material of the mesh should be use to render the effect.
     * @param mesh defines the current mesh to render
     * @returns true if the material of the mesh should be use to render the effect
     */ _useMeshMaterial(mesh) {
        if (this._meshesUsingTheirOwnMaterials.length == 0) return false;
        return this._meshesUsingTheirOwnMaterials.indexOf(mesh.uniqueId) > -1;
    }
    /**
     * Add a mesh to be rendered through its own material and not with emissive only.
     * @param mesh The mesh for which we need to use its material
     */ referenceMeshToUseItsOwnMaterial(mesh) {
        mesh.resetDrawCache(this._mainTexture.renderPassId);
        this._meshesUsingTheirOwnMaterials.push(mesh.uniqueId);
        mesh.onDisposeObservable.add(()=>{
            this._disposeMesh(mesh);
        });
    }
    /**
     * Remove a mesh from being rendered through its own material and not with emissive only.
     * @param mesh The mesh for which we need to not use its material
     */ unReferenceMeshFromUsingItsOwnMaterial(mesh) {
        let index = this._meshesUsingTheirOwnMaterials.indexOf(mesh.uniqueId);
        while(index >= 0){
            this._meshesUsingTheirOwnMaterials.splice(index, 1);
            index = this._meshesUsingTheirOwnMaterials.indexOf(mesh.uniqueId);
        }
        mesh.resetDrawCache(this._mainTexture.renderPassId);
    }
    /**
     * Free any resources and references associated to a mesh.
     * Internal use
     * @param mesh The mesh to free.
     * @internal
     */ _disposeMesh(mesh) {
        this.removeIncludedOnlyMesh(mesh);
        this.removeExcludedMesh(mesh);
    }
    /**
     * Gets the class name of the effect layer
     * @returns the string with the class name of the effect layer
     */ getClassName() {
        return "GlowLayer";
    }
    /**
     * Serializes this glow layer
     * @returns a serialized glow layer object
     */ serialize() {
        const serializationObject = (0, $6Ho1L.SerializationHelper).Serialize(this);
        serializationObject.customType = "BABYLON.GlowLayer";
        let index;
        // Included meshes
        serializationObject.includedMeshes = [];
        if (this._includedOnlyMeshes.length) for(index = 0; index < this._includedOnlyMeshes.length; index++){
            const mesh = this._scene.getMeshByUniqueId(this._includedOnlyMeshes[index]);
            if (mesh) serializationObject.includedMeshes.push(mesh.id);
        }
        // Excluded meshes
        serializationObject.excludedMeshes = [];
        if (this._excludedMeshes.length) for(index = 0; index < this._excludedMeshes.length; index++){
            const mesh = this._scene.getMeshByUniqueId(this._excludedMeshes[index]);
            if (mesh) serializationObject.excludedMeshes.push(mesh.id);
        }
        return serializationObject;
    }
    /**
     * Creates a Glow Layer from parsed glow layer data
     * @param parsedGlowLayer defines glow layer data
     * @param scene defines the current scene
     * @param rootUrl defines the root URL containing the glow layer information
     * @returns a parsed Glow Layer
     */ static Parse(parsedGlowLayer, scene, rootUrl) {
        const gl = (0, $6Ho1L.SerializationHelper).Parse(()=>new $ba01c510ffb7f19d$export$560831ae0419d7af(parsedGlowLayer.name, scene, parsedGlowLayer.options), parsedGlowLayer, scene, rootUrl);
        let index;
        // Excluded meshes
        for(index = 0; index < parsedGlowLayer.excludedMeshes.length; index++){
            const mesh = scene.getMeshById(parsedGlowLayer.excludedMeshes[index]);
            if (mesh) gl.addExcludedMesh(mesh);
        }
        // Included meshes
        for(index = 0; index < parsedGlowLayer.includedMeshes.length; index++){
            const mesh = scene.getMeshById(parsedGlowLayer.includedMeshes[index]);
            if (mesh) gl.addIncludedOnlyMesh(mesh);
        }
        return gl;
    }
}
/**
 * Effect Name of the layer.
 */ $ba01c510ffb7f19d$export$560831ae0419d7af.EffectName = "GlowLayer";
/**
 * The default blur kernel size used for the glow.
 */ $ba01c510ffb7f19d$export$560831ae0419d7af.DefaultBlurKernelSize = 32;
/**
 * The default texture size ratio used for the glow.
 */ $ba01c510ffb7f19d$export$560831ae0419d7af.DefaultTextureRatio = 0.5;
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ba01c510ffb7f19d$export$560831ae0419d7af.prototype, "blurKernelSize", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ba01c510ffb7f19d$export$560831ae0419d7af.prototype, "intensity", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("options")
], $ba01c510ffb7f19d$export$560831ae0419d7af.prototype, "_options", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.GlowLayer", $ba01c510ffb7f19d$export$560831ae0419d7af);

});
parcelRegister("4BFof", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $35aab9511d40a404$var$name = "glowMapMergePixelShader";
const $35aab9511d40a404$var$shader = `varying vec2 vUV;uniform sampler2D textureSampler;
#ifdef EMISSIVE
uniform sampler2D textureSampler2;
#endif
uniform float offset;
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) {
#define CUSTOM_FRAGMENT_MAIN_BEGIN
vec4 baseColor=texture2D(textureSampler,vUV);
#ifdef EMISSIVE
baseColor+=texture2D(textureSampler2,vUV);baseColor*=offset;
#else
baseColor.a=abs(offset-baseColor.a);
#ifdef STROKE
float alpha=smoothstep(.0,.1,baseColor.a);baseColor.a=alpha;baseColor.rgb=baseColor.rgb*alpha;
#endif
#endif
#if LDR
baseColor=clamp(baseColor,0.,1.0);
#endif
gl_FragColor=baseColor;
#define CUSTOM_FRAGMENT_MAIN_END
}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$35aab9511d40a404$var$name] = $35aab9511d40a404$var$shader;
const $35aab9511d40a404$export$ae260c65fa67dc9a = {
    name: $35aab9511d40a404$var$name,
    shader: $35aab9511d40a404$var$shader
};

});

parcelRegister("jElvn", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $e4e26f368346e7fd$var$name = "glowMapMergeVertexShader";
const $e4e26f368346e7fd$var$shader = `attribute vec2 position;varying vec2 vUV;const vec2 madd=vec2(0.5,0.5);
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
vUV=position*madd+madd;gl_Position=vec4(position,0.0,1.0);
#define CUSTOM_VERTEX_MAIN_END
}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$e4e26f368346e7fd$var$name] = $e4e26f368346e7fd$var$shader;
const $e4e26f368346e7fd$export$3fdf997e77aa9957 = {
    name: $e4e26f368346e7fd$var$name,
    shader: $e4e26f368346e7fd$var$shader
};

});


parcelRegister("49kOf", function(module, exports) {

$parcel$export(module.exports, "HighlightLayer", () => $3058250859f6f027$export$941427cc94643dc4);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $5YkyR = parcelRequire("5YkyR");

var $b4i1f = parcelRequire("b4i1f");

var $54229 = parcelRequire("54229");

var $j2mX5 = parcelRequire("j2mX5");

var $gQtNK = parcelRequire("gQtNK");

var $cFdBb = parcelRequire("cFdBb");

var $c7c1r = parcelRequire("c7c1r");

var $8zEq7 = parcelRequire("8zEq7");

var $gkrS2 = parcelRequire("gkrS2");

var $5Tqba = parcelRequire("5Tqba");

var $kVtWi = parcelRequire("kVtWi");

var $8DoUR = parcelRequire("8DoUR");

var $7etnY = parcelRequire("7etnY");
parcelRequire("4BFof");
parcelRequire("jElvn");
parcelRequire("ePxB3");
parcelRequire("dr9wK");

var $6Ho1L = parcelRequire("6Ho1L");
(0, $5Tqba.AbstractScene).prototype.getHighlightLayerByName = function(name) {
    for(let index = 0; index < this.effectLayers?.length; index++){
        if (this.effectLayers[index].name === name && this.effectLayers[index].getEffectName() === $3058250859f6f027$export$941427cc94643dc4.EffectName) return this.effectLayers[index];
    }
    return null;
};
/**
 * Special Glow Blur post process only blurring the alpha channel
 * It enforces keeping the most luminous color in the color channel.
 */ class $3058250859f6f027$var$GlowBlurPostProcess extends (0, $cFdBb.PostProcess) {
    constructor(name, direction, kernel, options, camera, samplingMode = (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, engine, reusable){
        super(name, "glowBlurPostProcess", [
            "screenSize",
            "direction",
            "blurWidth"
        ], null, options, camera, samplingMode, engine, reusable);
        this.direction = direction;
        this.kernel = kernel;
        this.onApplyObservable.add((effect)=>{
            effect.setFloat2("screenSize", this.width, this.height);
            effect.setVector2("direction", this.direction);
            effect.setFloat("blurWidth", this.kernel);
        });
    }
}
class $3058250859f6f027$export$941427cc94643dc4 extends (0, $gkrS2.EffectLayer) {
    /**
     * Specifies the horizontal size of the blur.
     */ set blurHorizontalSize(value) {
        this._horizontalBlurPostprocess.kernel = value;
        this._options.blurHorizontalSize = value;
    }
    /**
     * Specifies the vertical size of the blur.
     */ set blurVerticalSize(value) {
        this._verticalBlurPostprocess.kernel = value;
        this._options.blurVerticalSize = value;
    }
    /**
     * Gets the horizontal size of the blur.
     */ get blurHorizontalSize() {
        return this._horizontalBlurPostprocess.kernel;
    }
    /**
     * Gets the vertical size of the blur.
     */ get blurVerticalSize() {
        return this._verticalBlurPostprocess.kernel;
    }
    /**
     * Instantiates a new highlight Layer and references it to the scene..
     * @param name The name of the layer
     * @param scene The scene to use the layer in
     * @param options Sets of none mandatory options to use with the layer (see IHighlightLayerOptions for more information)
     */ constructor(name, scene, options){
        super(name, scene);
        this.name = name;
        /**
         * Specifies whether or not the inner glow is ACTIVE in the layer.
         */ this.innerGlow = true;
        /**
         * Specifies whether or not the outer glow is ACTIVE in the layer.
         */ this.outerGlow = true;
        /**
         * An event triggered when the highlight layer is being blurred.
         */ this.onBeforeBlurObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the highlight layer has been blurred.
         */ this.onAfterBlurObservable = new (0, $diGQf.Observable)();
        this._instanceGlowingMeshStencilReference = $3058250859f6f027$export$941427cc94643dc4.GlowingMeshStencilReference++;
        this._meshes = {};
        this._excludedMeshes = {};
        this.neutralColor = $3058250859f6f027$export$941427cc94643dc4.NeutralColor;
        // Warn on stencil
        if (!this._engine.isStencilEnable) (0, $kVtWi.Logger).Warn("Rendering the Highlight Layer requires the stencil to be active on the canvas. var engine = new Engine(canvas, antialias, { stencil: true }");
        // Adapt options
        this._options = {
            mainTextureRatio: 0.5,
            blurTextureSizeRatio: 0.5,
            blurHorizontalSize: 1.0,
            blurVerticalSize: 1.0,
            alphaBlendingMode: 2,
            camera: null,
            renderingGroupId: -1,
            mainTextureType: 0,
            ...options
        };
        // Initialize the layer
        this._init({
            alphaBlendingMode: this._options.alphaBlendingMode,
            camera: this._options.camera,
            mainTextureFixedSize: this._options.mainTextureFixedSize,
            mainTextureRatio: this._options.mainTextureRatio,
            renderingGroupId: this._options.renderingGroupId,
            mainTextureType: this._options.mainTextureType
        });
        // Do not render as long as no meshes have been added
        this._shouldRender = false;
    }
    /**
     * Get the effect name of the layer.
     * @returns The effect name
     */ getEffectName() {
        return $3058250859f6f027$export$941427cc94643dc4.EffectName;
    }
    _numInternalDraws() {
        return 2; // we need two rendering, one for the inner glow and the other for the outer glow
    }
    /**
     * Create the merge effect. This is the shader use to blit the information back
     * to the main canvas at the end of the scene rendering.
     * @returns The effect created
     */ _createMergeEffect() {
        // Effect
        return this._engine.createEffect("glowMapMerge", [
            (0, $b4i1f.VertexBuffer).PositionKind
        ], [
            "offset"
        ], [
            "textureSampler"
        ], this._options.isStroke ? "#define STROKE \n" : undefined);
    }
    /**
     * Creates the render target textures and post processes used in the highlight layer.
     */ _createTextureAndPostProcesses() {
        let blurTextureWidth = this._mainTextureDesiredSize.width * this._options.blurTextureSizeRatio;
        let blurTextureHeight = this._mainTextureDesiredSize.height * this._options.blurTextureSizeRatio;
        blurTextureWidth = this._engine.needPOTTextures ? (0, $5YkyR.Engine).GetExponentOfTwo(blurTextureWidth, this._maxSize) : blurTextureWidth;
        blurTextureHeight = this._engine.needPOTTextures ? (0, $5YkyR.Engine).GetExponentOfTwo(blurTextureHeight, this._maxSize) : blurTextureHeight;
        let textureType = 0;
        if (this._engine.getCaps().textureHalfFloatRender) textureType = 2;
        else textureType = 0;
        this._blurTexture = new (0, $gQtNK.RenderTargetTexture)("HighlightLayerBlurRTT", {
            width: blurTextureWidth,
            height: blurTextureHeight
        }, this._scene, false, true, textureType);
        this._blurTexture.wrapU = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        this._blurTexture.wrapV = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        this._blurTexture.anisotropicFilteringLevel = 16;
        this._blurTexture.updateSamplingMode((0, $j2mX5.Texture).TRILINEAR_SAMPLINGMODE);
        this._blurTexture.renderParticles = false;
        this._blurTexture.ignoreCameraViewport = true;
        this._textures = [
            this._blurTexture
        ];
        if (this._options.alphaBlendingMode === 2) {
            this._downSamplePostprocess = new (0, $c7c1r.PassPostProcess)("HighlightLayerPPP", this._options.blurTextureSizeRatio, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, this._scene.getEngine());
            this._downSamplePostprocess.externalTextureSamplerBinding = true;
            this._downSamplePostprocess.onApplyObservable.add((effect)=>{
                effect.setTexture("textureSampler", this._mainTexture);
            });
            this._horizontalBlurPostprocess = new $3058250859f6f027$var$GlowBlurPostProcess("HighlightLayerHBP", new (0, $ha1VO.Vector2)(1.0, 0), this._options.blurHorizontalSize, 1, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, this._scene.getEngine());
            this._horizontalBlurPostprocess.onApplyObservable.add((effect)=>{
                effect.setFloat2("screenSize", blurTextureWidth, blurTextureHeight);
            });
            this._verticalBlurPostprocess = new $3058250859f6f027$var$GlowBlurPostProcess("HighlightLayerVBP", new (0, $ha1VO.Vector2)(0, 1.0), this._options.blurVerticalSize, 1, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, this._scene.getEngine());
            this._verticalBlurPostprocess.onApplyObservable.add((effect)=>{
                effect.setFloat2("screenSize", blurTextureWidth, blurTextureHeight);
            });
            this._postProcesses = [
                this._downSamplePostprocess,
                this._horizontalBlurPostprocess,
                this._verticalBlurPostprocess
            ];
        } else {
            this._horizontalBlurPostprocess = new (0, $8zEq7.BlurPostProcess)("HighlightLayerHBP", new (0, $ha1VO.Vector2)(1.0, 0), this._options.blurHorizontalSize / 2, {
                width: blurTextureWidth,
                height: blurTextureHeight
            }, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, this._scene.getEngine(), false, textureType);
            this._horizontalBlurPostprocess.width = blurTextureWidth;
            this._horizontalBlurPostprocess.height = blurTextureHeight;
            this._horizontalBlurPostprocess.externalTextureSamplerBinding = true;
            this._horizontalBlurPostprocess.onApplyObservable.add((effect)=>{
                effect.setTexture("textureSampler", this._mainTexture);
            });
            this._verticalBlurPostprocess = new (0, $8zEq7.BlurPostProcess)("HighlightLayerVBP", new (0, $ha1VO.Vector2)(0, 1.0), this._options.blurVerticalSize / 2, {
                width: blurTextureWidth,
                height: blurTextureHeight
            }, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, this._scene.getEngine(), false, textureType);
            this._postProcesses = [
                this._horizontalBlurPostprocess,
                this._verticalBlurPostprocess
            ];
        }
        this._mainTexture.onAfterUnbindObservable.add(()=>{
            this.onBeforeBlurObservable.notifyObservers(this);
            const internalTexture = this._blurTexture.renderTarget;
            if (internalTexture) {
                this._scene.postProcessManager.directRender(this._postProcesses, internalTexture, true);
                this._engine.unBindFramebuffer(internalTexture, true);
            }
            this.onAfterBlurObservable.notifyObservers(this);
        });
        // Prevent autoClear.
        this._postProcesses.map((pp)=>{
            pp.autoClear = false;
        });
    }
    /**
     * @returns whether or not the layer needs stencil enabled during the mesh rendering.
     */ needStencil() {
        return true;
    }
    /**
     * Checks for the readiness of the element composing the layer.
     * @param subMesh the mesh to check for
     * @param useInstances specify whether or not to use instances to render the mesh
     * @returns true if ready otherwise, false
     */ isReady(subMesh, useInstances) {
        const material = subMesh.getMaterial();
        const mesh = subMesh.getRenderingMesh();
        if (!material || !mesh || !this._meshes) return false;
        let emissiveTexture = null;
        const highlightLayerMesh = this._meshes[mesh.uniqueId];
        if (highlightLayerMesh && highlightLayerMesh.glowEmissiveOnly && material) emissiveTexture = material.emissiveTexture;
        return super._isReady(subMesh, useInstances, emissiveTexture);
    }
    /**
     * Implementation specific of rendering the generating effect on the main canvas.
     * @param effect The effect used to render through
     * @param renderIndex
     */ _internalRender(effect, renderIndex) {
        // Texture
        effect.setTexture("textureSampler", this._blurTexture);
        // Cache
        const engine = this._engine;
        engine.cacheStencilState();
        // Stencil operations
        engine.setStencilOperationPass(7681);
        engine.setStencilOperationFail(7680);
        engine.setStencilOperationDepthFail(7680);
        // Draw order
        engine.setStencilMask(0x00);
        engine.setStencilBuffer(true);
        engine.setStencilFunctionReference(this._instanceGlowingMeshStencilReference);
        // 2 passes inner outer
        if (this.outerGlow && renderIndex === 0) {
            // the outer glow is rendered the first time _internalRender is called, so when renderIndex == 0 (and only if outerGlow is enabled)
            effect.setFloat("offset", 0);
            engine.setStencilFunction(517);
            engine.drawElementsType((0, $54229.Material).TriangleFillMode, 0, 6);
        }
        if (this.innerGlow && renderIndex === 1) {
            // the inner glow is rendered the second time _internalRender is called, so when renderIndex == 1 (and only if innerGlow is enabled)
            effect.setFloat("offset", 1);
            engine.setStencilFunction(514);
            engine.drawElementsType((0, $54229.Material).TriangleFillMode, 0, 6);
        }
        // Restore Cache
        engine.restoreStencilState();
    }
    /**
     * @returns true if the layer contains information to display, otherwise false.
     */ shouldRender() {
        if (super.shouldRender()) return this._meshes ? true : false;
        return false;
    }
    /**
     * Returns true if the mesh should render, otherwise false.
     * @param mesh The mesh to render
     * @returns true if it should render otherwise false
     */ _shouldRenderMesh(mesh) {
        // Excluded Mesh
        if (this._excludedMeshes && this._excludedMeshes[mesh.uniqueId]) return false;
        if (!super.hasMesh(mesh)) return false;
        return true;
    }
    /**
     * Returns true if the mesh can be rendered, otherwise false.
     * @param mesh The mesh to render
     * @param material The material used on the mesh
     * @returns true if it can be rendered otherwise false
     */ _canRenderMesh(mesh, material) {
        // all meshes can be rendered in the highlight layer, even transparent ones
        return true;
    }
    /**
     * Adds specific effects defines.
     * @param defines The defines to add specifics to.
     */ _addCustomEffectDefines(defines) {
        defines.push("#define HIGHLIGHT");
    }
    /**
     * Sets the required values for both the emissive texture and and the main color.
     * @param mesh
     * @param subMesh
     * @param material
     */ _setEmissiveTextureAndColor(mesh, subMesh, material) {
        const highlightLayerMesh = this._meshes[mesh.uniqueId];
        if (highlightLayerMesh) this._emissiveTextureAndColor.color.set(highlightLayerMesh.color.r, highlightLayerMesh.color.g, highlightLayerMesh.color.b, 1.0);
        else this._emissiveTextureAndColor.color.set(this.neutralColor.r, this.neutralColor.g, this.neutralColor.b, this.neutralColor.a);
        if (highlightLayerMesh && highlightLayerMesh.glowEmissiveOnly && material) {
            this._emissiveTextureAndColor.texture = material.emissiveTexture;
            this._emissiveTextureAndColor.color.set(1.0, 1.0, 1.0, 1.0);
        } else this._emissiveTextureAndColor.texture = null;
    }
    /**
     * Add a mesh in the exclusion list to prevent it to impact or being impacted by the highlight layer.
     * @param mesh The mesh to exclude from the highlight layer
     */ addExcludedMesh(mesh) {
        if (!this._excludedMeshes) return;
        const meshExcluded = this._excludedMeshes[mesh.uniqueId];
        if (!meshExcluded) {
            const obj = {
                mesh: mesh,
                beforeBind: null,
                afterRender: null,
                stencilState: false
            };
            obj.beforeBind = mesh.onBeforeBindObservable.add((mesh)=>{
                obj.stencilState = mesh.getEngine().getStencilBuffer();
                mesh.getEngine().setStencilBuffer(false);
            });
            obj.afterRender = mesh.onAfterRenderObservable.add((mesh)=>{
                mesh.getEngine().setStencilBuffer(obj.stencilState);
            });
            this._excludedMeshes[mesh.uniqueId] = obj;
        }
    }
    /**
     * Remove a mesh from the exclusion list to let it impact or being impacted by the highlight layer.
     * @param mesh The mesh to highlight
     */ removeExcludedMesh(mesh) {
        if (!this._excludedMeshes) return;
        const meshExcluded = this._excludedMeshes[mesh.uniqueId];
        if (meshExcluded) {
            if (meshExcluded.beforeBind) mesh.onBeforeBindObservable.remove(meshExcluded.beforeBind);
            if (meshExcluded.afterRender) mesh.onAfterRenderObservable.remove(meshExcluded.afterRender);
        }
        this._excludedMeshes[mesh.uniqueId] = null;
    }
    /**
     * Determine if a given mesh will be highlighted by the current HighlightLayer
     * @param mesh mesh to test
     * @returns true if the mesh will be highlighted by the current HighlightLayer
     */ hasMesh(mesh) {
        if (!this._meshes) return false;
        if (!super.hasMesh(mesh)) return false;
        return this._meshes[mesh.uniqueId] !== undefined && this._meshes[mesh.uniqueId] !== null;
    }
    /**
     * Add a mesh in the highlight layer in order to make it glow with the chosen color.
     * @param mesh The mesh to highlight
     * @param color The color of the highlight
     * @param glowEmissiveOnly Extract the glow from the emissive texture
     */ addMesh(mesh, color, glowEmissiveOnly = false) {
        if (!this._meshes) return;
        const meshHighlight = this._meshes[mesh.uniqueId];
        if (meshHighlight) meshHighlight.color = color;
        else {
            this._meshes[mesh.uniqueId] = {
                mesh: mesh,
                color: color,
                // Lambda required for capture due to Observable this context
                observerHighlight: mesh.onBeforeBindObservable.add((mesh)=>{
                    if (this.isEnabled) {
                        if (this._excludedMeshes && this._excludedMeshes[mesh.uniqueId]) this._defaultStencilReference(mesh);
                        else mesh.getScene().getEngine().setStencilFunctionReference(this._instanceGlowingMeshStencilReference);
                    }
                }),
                observerDefault: mesh.onAfterRenderObservable.add((mesh)=>{
                    if (this.isEnabled) this._defaultStencilReference(mesh);
                }),
                glowEmissiveOnly: glowEmissiveOnly
            };
            mesh.onDisposeObservable.add(()=>{
                this._disposeMesh(mesh);
            });
        }
        this._shouldRender = true;
    }
    /**
     * Remove a mesh from the highlight layer in order to make it stop glowing.
     * @param mesh The mesh to highlight
     */ removeMesh(mesh) {
        if (!this._meshes) return;
        const meshHighlight = this._meshes[mesh.uniqueId];
        if (meshHighlight) {
            if (meshHighlight.observerHighlight) mesh.onBeforeBindObservable.remove(meshHighlight.observerHighlight);
            if (meshHighlight.observerDefault) mesh.onAfterRenderObservable.remove(meshHighlight.observerDefault);
            delete this._meshes[mesh.uniqueId];
        }
        this._shouldRender = false;
        for(const meshHighlightToCheck in this._meshes)if (this._meshes[meshHighlightToCheck]) {
            this._shouldRender = true;
            break;
        }
    }
    /**
     * Remove all the meshes currently referenced in the highlight layer
     */ removeAllMeshes() {
        if (!this._meshes) return;
        for(const uniqueId in this._meshes)if (Object.prototype.hasOwnProperty.call(this._meshes, uniqueId)) {
            const mesh = this._meshes[uniqueId];
            if (mesh) this.removeMesh(mesh.mesh);
        }
    }
    /**
     * Force the stencil to the normal expected value for none glowing parts
     * @param mesh
     */ _defaultStencilReference(mesh) {
        mesh.getScene().getEngine().setStencilFunctionReference($3058250859f6f027$export$941427cc94643dc4.NormalMeshStencilReference);
    }
    /**
     * Free any resources and references associated to a mesh.
     * Internal use
     * @param mesh The mesh to free.
     * @internal
     */ _disposeMesh(mesh) {
        this.removeMesh(mesh);
        this.removeExcludedMesh(mesh);
    }
    /**
     * Dispose the highlight layer and free resources.
     */ dispose() {
        if (this._meshes) {
            // Clean mesh references
            for(const id in this._meshes){
                const meshHighlight = this._meshes[id];
                if (meshHighlight && meshHighlight.mesh) {
                    if (meshHighlight.observerHighlight) meshHighlight.mesh.onBeforeBindObservable.remove(meshHighlight.observerHighlight);
                    if (meshHighlight.observerDefault) meshHighlight.mesh.onAfterRenderObservable.remove(meshHighlight.observerDefault);
                }
            }
            this._meshes = null;
        }
        if (this._excludedMeshes) {
            for(const id in this._excludedMeshes){
                const meshHighlight = this._excludedMeshes[id];
                if (meshHighlight) {
                    if (meshHighlight.beforeBind) meshHighlight.mesh.onBeforeBindObservable.remove(meshHighlight.beforeBind);
                    if (meshHighlight.afterRender) meshHighlight.mesh.onAfterRenderObservable.remove(meshHighlight.afterRender);
                }
            }
            this._excludedMeshes = null;
        }
        super.dispose();
    }
    /**
     * Gets the class name of the effect layer
     * @returns the string with the class name of the effect layer
     */ getClassName() {
        return "HighlightLayer";
    }
    /**
     * Serializes this Highlight layer
     * @returns a serialized Highlight layer object
     */ serialize() {
        const serializationObject = (0, $6Ho1L.SerializationHelper).Serialize(this);
        serializationObject.customType = "BABYLON.HighlightLayer";
        // Highlighted meshes
        serializationObject.meshes = [];
        if (this._meshes) for(const m in this._meshes){
            const mesh = this._meshes[m];
            if (mesh) serializationObject.meshes.push({
                glowEmissiveOnly: mesh.glowEmissiveOnly,
                color: mesh.color.asArray(),
                meshId: mesh.mesh.id
            });
        }
        // Excluded meshes
        serializationObject.excludedMeshes = [];
        if (this._excludedMeshes) for(const e in this._excludedMeshes){
            const excludedMesh = this._excludedMeshes[e];
            if (excludedMesh) serializationObject.excludedMeshes.push(excludedMesh.mesh.id);
        }
        return serializationObject;
    }
    /**
     * Creates a Highlight layer from parsed Highlight layer data
     * @param parsedHightlightLayer defines the Highlight layer data
     * @param scene defines the current scene
     * @param rootUrl defines the root URL containing the Highlight layer information
     * @returns a parsed Highlight layer
     */ static Parse(parsedHightlightLayer, scene, rootUrl) {
        const hl = (0, $6Ho1L.SerializationHelper).Parse(()=>new $3058250859f6f027$export$941427cc94643dc4(parsedHightlightLayer.name, scene, parsedHightlightLayer.options), parsedHightlightLayer, scene, rootUrl);
        let index;
        // Excluded meshes
        for(index = 0; index < parsedHightlightLayer.excludedMeshes.length; index++){
            const mesh = scene.getMeshById(parsedHightlightLayer.excludedMeshes[index]);
            if (mesh) hl.addExcludedMesh(mesh);
        }
        // Included meshes
        for(index = 0; index < parsedHightlightLayer.meshes.length; index++){
            const highlightedMesh = parsedHightlightLayer.meshes[index];
            const mesh = scene.getMeshById(highlightedMesh.meshId);
            if (mesh) hl.addMesh(mesh, (0, $7etnY.Color3).FromArray(highlightedMesh.color), highlightedMesh.glowEmissiveOnly);
        }
        return hl;
    }
}
/**
 * Effect Name of the highlight layer.
 */ $3058250859f6f027$export$941427cc94643dc4.EffectName = "HighlightLayer";
/**
 * The neutral color used during the preparation of the glow effect.
 * This is black by default as the blend operation is a blend operation.
 */ $3058250859f6f027$export$941427cc94643dc4.NeutralColor = new (0, $7etnY.Color4)(0, 0, 0, 0);
/**
 * Stencil value used for glowing meshes.
 */ $3058250859f6f027$export$941427cc94643dc4.GlowingMeshStencilReference = 0x02;
/**
 * Stencil value used for the other meshes in the scene.
 */ $3058250859f6f027$export$941427cc94643dc4.NormalMeshStencilReference = 0x01;
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3058250859f6f027$export$941427cc94643dc4.prototype, "innerGlow", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3058250859f6f027$export$941427cc94643dc4.prototype, "outerGlow", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3058250859f6f027$export$941427cc94643dc4.prototype, "blurHorizontalSize", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $3058250859f6f027$export$941427cc94643dc4.prototype, "blurVerticalSize", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("options")
], $3058250859f6f027$export$941427cc94643dc4.prototype, "_options", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.HighlightLayer", $3058250859f6f027$export$941427cc94643dc4);

});
parcelRegister("ePxB3", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $acbfe3ae434a25a8$var$name = "glowBlurPostProcessPixelShader";
const $acbfe3ae434a25a8$var$shader = `varying vec2 vUV;uniform sampler2D textureSampler;uniform vec2 screenSize;uniform vec2 direction;uniform float blurWidth;float getLuminance(vec3 color)
{return dot(color,vec3(0.2126,0.7152,0.0722));}
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{float weights[7];weights[0]=0.05;weights[1]=0.1;weights[2]=0.2;weights[3]=0.3;weights[4]=0.2;weights[5]=0.1;weights[6]=0.05;vec2 texelSize=vec2(1.0/screenSize.x,1.0/screenSize.y);vec2 texelStep=texelSize*direction*blurWidth;vec2 start=vUV-3.0*texelStep;vec4 baseColor=vec4(0.,0.,0.,0.);vec2 texelOffset=vec2(0.,0.);for (int i=0; i<7; i++)
{vec4 texel=texture2D(textureSampler,start+texelOffset);baseColor.a+=texel.a*weights[i];float luminance=getLuminance(baseColor.rgb);float luminanceTexel=getLuminance(texel.rgb);float choice=step(luminanceTexel,luminance);baseColor.rgb=choice*baseColor.rgb+(1.0-choice)*texel.rgb;texelOffset+=texelStep;}
gl_FragColor=baseColor;}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$acbfe3ae434a25a8$var$name] = $acbfe3ae434a25a8$var$shader;
const $acbfe3ae434a25a8$export$f78006d07838cf35 = {
    name: $acbfe3ae434a25a8$var$name,
    shader: $acbfe3ae434a25a8$var$shader
};

});


parcelRegister("8fwD5", function(module, exports) {

$parcel$export(module.exports, "Layer", () => $601908f1c5e3fa9a$export$936d0764594b6eb3);

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $ejQPp = parcelRequire("ejQPp");

var $b4i1f = parcelRequire("b4i1f");

var $54229 = parcelRequire("54229");

var $j2mX5 = parcelRequire("j2mX5");

var $bv05l = parcelRequire("bv05l");

var $56TxP = parcelRequire("56TxP");

var $hOyoX = parcelRequire("hOyoX");
parcelRequire("cGwq9");
parcelRequire("jiOMu");
class $601908f1c5e3fa9a$export$936d0764594b6eb3 {
    /**
     * Determines if the layer is drawn before (true) or after (false) post-processing.
     * If the layer is background, it is always before.
     */ set applyPostProcess(value) {
        this._applyPostProcess = value;
    }
    get applyPostProcess() {
        return this.isBackground || this._applyPostProcess;
    }
    /**
     * Back compatibility with callback before the onDisposeObservable existed.
     * The set callback will be triggered when the layer has been disposed.
     */ set onDispose(callback) {
        if (this._onDisposeObserver) this.onDisposeObservable.remove(this._onDisposeObserver);
        this._onDisposeObserver = this.onDisposeObservable.add(callback);
    }
    /**
     * Back compatibility with callback before the onBeforeRenderObservable existed.
     * The set callback will be triggered just before rendering the layer.
     */ set onBeforeRender(callback) {
        if (this._onBeforeRenderObserver) this.onBeforeRenderObservable.remove(this._onBeforeRenderObserver);
        this._onBeforeRenderObserver = this.onBeforeRenderObservable.add(callback);
    }
    /**
     * Back compatibility with callback before the onAfterRenderObservable existed.
     * The set callback will be triggered just after rendering the layer.
     */ set onAfterRender(callback) {
        if (this._onAfterRenderObserver) this.onAfterRenderObservable.remove(this._onAfterRenderObserver);
        this._onAfterRenderObserver = this.onAfterRenderObservable.add(callback);
    }
    /**
     * Instantiates a new layer.
     * This represents a full screen 2d layer.
     * This can be useful to display a picture in the  background of your scene for instance.
     * @see https://www.babylonjs-playground.com/#08A2BS#1
     * @param name Define the name of the layer in the scene
     * @param imgUrl Define the url of the texture to display in the layer
     * @param scene Define the scene the layer belongs to
     * @param isBackground Defines whether the layer is displayed in front or behind the scene
     * @param color Defines a color for the layer
     */ constructor(/**
     * Define the name of the layer.
     */ name, imgUrl, scene, isBackground, color){
        this.name = name;
        this._applyPostProcess = true;
        /**
         * Define the scale of the layer in order to zoom in out of the texture.
         */ this.scale = new (0, $ha1VO.Vector2)(1, 1);
        /**
         * Define an offset for the layer in order to shift the texture.
         */ this.offset = new (0, $ha1VO.Vector2)(0, 0);
        /**
         * Define the alpha blending mode used in the layer in case the texture or color has an alpha.
         */ this.alphaBlendingMode = 2;
        /**
         * Define a mask to restrict the layer to only some of the scene cameras.
         */ this.layerMask = 0x0fffffff;
        /**
         * Define the list of render target the layer is visible into.
         */ this.renderTargetTextures = [];
        /**
         * Define if the layer is only used in renderTarget or if it also
         * renders in the main frame buffer of the canvas.
         */ this.renderOnlyInRenderTargetTextures = false;
        /**
         * Define if the layer is enabled (ie. should be displayed). Default: true
         */ this.isEnabled = true;
        this._vertexBuffers = {};
        /**
         * An event triggered when the layer is disposed.
         */ this.onDisposeObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered before rendering the scene
         */ this.onBeforeRenderObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered after rendering the scene
         */ this.onAfterRenderObservable = new (0, $diGQf.Observable)();
        this.texture = imgUrl ? new (0, $j2mX5.Texture)(imgUrl, scene, true) : null;
        this.isBackground = isBackground === undefined ? true : isBackground;
        this.color = color === undefined ? new (0, $7etnY.Color4)(1, 1, 1, 1) : color;
        this._scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        let layerComponent = this._scene._getComponent((0, $bv05l.SceneComponentConstants).NAME_LAYER);
        if (!layerComponent) {
            layerComponent = new (0, $56TxP.LayerSceneComponent)(this._scene);
            this._scene._addComponent(layerComponent);
        }
        this._scene.layers.push(this);
        const engine = this._scene.getEngine();
        this._drawWrapper = new (0, $hOyoX.DrawWrapper)(engine);
        // VBO
        const vertices = [];
        vertices.push(1, 1);
        vertices.push(-1, 1);
        vertices.push(-1, -1);
        vertices.push(1, -1);
        const vertexBuffer = new (0, $b4i1f.VertexBuffer)(engine, vertices, (0, $b4i1f.VertexBuffer).PositionKind, false, false, 2);
        this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind] = vertexBuffer;
        this._createIndexBuffer();
    }
    _createIndexBuffer() {
        const engine = this._scene.getEngine();
        // Indices
        const indices = [];
        indices.push(0);
        indices.push(1);
        indices.push(2);
        indices.push(0);
        indices.push(2);
        indices.push(3);
        this._indexBuffer = engine.createIndexBuffer(indices);
    }
    /** @internal */ _rebuild() {
        const vb = this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind];
        if (vb) vb._rebuild();
        this._createIndexBuffer();
    }
    /**
     * Checks if the layer is ready to be rendered
     * @returns true if the layer is ready. False otherwise.
     */ isReady() {
        const engine = this._scene.getEngine();
        let defines = "";
        if (this.alphaTest) defines = "#define ALPHATEST";
        if (this.texture && !this.texture.gammaSpace) defines += "\n#define LINEAR";
        if (this._previousDefines !== defines) {
            this._previousDefines = defines;
            this._drawWrapper.effect = engine.createEffect("layer", [
                (0, $b4i1f.VertexBuffer).PositionKind
            ], [
                "textureMatrix",
                "color",
                "scale",
                "offset"
            ], [
                "textureSampler"
            ], defines);
        }
        const currentEffect = this._drawWrapper.effect;
        return currentEffect?.isReady() && this.texture?.isReady();
    }
    /**
     * Renders the layer in the scene.
     */ render() {
        if (!this.isEnabled) return;
        const engine = this._scene.getEngine();
        // Check
        if (!this.isReady()) return;
        const currentEffect = this._drawWrapper.effect;
        this.onBeforeRenderObservable.notifyObservers(this);
        // Render
        engine.enableEffect(this._drawWrapper);
        engine.setState(false);
        // Texture
        currentEffect.setTexture("textureSampler", this.texture);
        currentEffect.setMatrix("textureMatrix", this.texture.getTextureMatrix());
        // Color
        currentEffect.setFloat4("color", this.color.r, this.color.g, this.color.b, this.color.a);
        // Scale / offset
        currentEffect.setVector2("offset", this.offset);
        currentEffect.setVector2("scale", this.scale);
        // VBOs
        engine.bindBuffers(this._vertexBuffers, this._indexBuffer, currentEffect);
        // Draw order
        if (!this.alphaTest) {
            engine.setAlphaMode(this.alphaBlendingMode);
            engine.drawElementsType((0, $54229.Material).TriangleFillMode, 0, 6);
            engine.setAlphaMode(0);
        } else engine.drawElementsType((0, $54229.Material).TriangleFillMode, 0, 6);
        this.onAfterRenderObservable.notifyObservers(this);
    }
    /**
     * Disposes and releases the associated resources.
     */ dispose() {
        const vertexBuffer = this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind];
        if (vertexBuffer) {
            vertexBuffer.dispose();
            this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind] = null;
        }
        if (this._indexBuffer) {
            this._scene.getEngine()._releaseBuffer(this._indexBuffer);
            this._indexBuffer = null;
        }
        if (this.texture) {
            this.texture.dispose();
            this.texture = null;
        }
        // Clean RTT list
        this.renderTargetTextures = [];
        // Remove from scene
        const index = this._scene.layers.indexOf(this);
        this._scene.layers.splice(index, 1);
        // Callback
        this.onDisposeObservable.notifyObservers(this);
        this.onDisposeObservable.clear();
        this.onAfterRenderObservable.clear();
        this.onBeforeRenderObservable.clear();
    }
}

});
parcelRegister("56TxP", function(module, exports) {

$parcel$export(module.exports, "LayerSceneComponent", () => $3b88994aee31475a$export$98912974b6a8e94a);

var $bv05l = parcelRequire("bv05l");

var $ejQPp = parcelRequire("ejQPp");
class $3b88994aee31475a$export$98912974b6a8e94a {
    /**
     * Creates a new instance of the component for the given scene
     * @param scene Defines the scene to register the component in
     */ constructor(scene){
        /**
         * The component name helpful to identify the component in the list of scene components.
         */ this.name = (0, $bv05l.SceneComponentConstants).NAME_LAYER;
        this.scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        if (!this.scene) return;
        this._engine = this.scene.getEngine();
        this.scene.layers = [];
    }
    /**
     * Registers the component in a given scene
     */ register() {
        this.scene._beforeCameraDrawStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_BEFORECAMERADRAW_LAYER, this, this._drawCameraBackground);
        this.scene._afterCameraDrawStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_AFTERCAMERADRAW_LAYER, this, this._drawCameraForegroundWithPostProcessing);
        this.scene._afterCameraPostProcessStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_AFTERCAMERAPOSTPROCESS_LAYER, this, this._drawCameraForegroundWithoutPostProcessing);
        this.scene._beforeRenderTargetDrawStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_BEFORERENDERTARGETDRAW_LAYER, this, this._drawRenderTargetBackground);
        this.scene._afterRenderTargetDrawStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_AFTERRENDERTARGETDRAW_LAYER, this, this._drawRenderTargetForegroundWithPostProcessing);
        this.scene._afterRenderTargetPostProcessStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_AFTERRENDERTARGETPOSTPROCESS_LAYER, this, this._drawRenderTargetForegroundWithoutPostProcessing);
    }
    /**
     * Rebuilds the elements related to this component in case of
     * context lost for instance.
     */ rebuild() {
        const layers = this.scene.layers;
        for (const layer of layers)layer._rebuild();
    }
    /**
     * Disposes the component and the associated resources.
     */ dispose() {
        const layers = this.scene.layers;
        while(layers.length)layers[0].dispose();
    }
    _draw(predicate) {
        const layers = this.scene.layers;
        if (layers.length) {
            this._engine.setDepthBuffer(false);
            for (const layer of layers)if (predicate(layer)) layer.render();
            this._engine.setDepthBuffer(true);
        }
    }
    _drawCameraPredicate(layer, isBackground, applyPostProcess, cameraLayerMask) {
        return !layer.renderOnlyInRenderTargetTextures && layer.isBackground === isBackground && layer.applyPostProcess === applyPostProcess && (layer.layerMask & cameraLayerMask) !== 0;
    }
    _drawCameraBackground(camera) {
        this._draw((layer)=>{
            return this._drawCameraPredicate(layer, true, true, camera.layerMask);
        });
    }
    _drawCameraForegroundWithPostProcessing(camera) {
        this._draw((layer)=>{
            return this._drawCameraPredicate(layer, false, true, camera.layerMask);
        });
    }
    _drawCameraForegroundWithoutPostProcessing(camera) {
        this._draw((layer)=>{
            return this._drawCameraPredicate(layer, false, false, camera.layerMask);
        });
    }
    _drawRenderTargetPredicate(layer, isBackground, applyPostProcess, cameraLayerMask, renderTargetTexture) {
        return layer.renderTargetTextures.length > 0 && layer.isBackground === isBackground && layer.applyPostProcess === applyPostProcess && layer.renderTargetTextures.indexOf(renderTargetTexture) > -1 && (layer.layerMask & cameraLayerMask) !== 0;
    }
    _drawRenderTargetBackground(renderTarget) {
        this._draw((layer)=>{
            return this._drawRenderTargetPredicate(layer, true, true, this.scene.activeCamera.layerMask, renderTarget);
        });
    }
    _drawRenderTargetForegroundWithPostProcessing(renderTarget) {
        this._draw((layer)=>{
            return this._drawRenderTargetPredicate(layer, false, true, this.scene.activeCamera.layerMask, renderTarget);
        });
    }
    _drawRenderTargetForegroundWithoutPostProcessing(renderTarget) {
        this._draw((layer)=>{
            return this._drawRenderTargetPredicate(layer, false, false, this.scene.activeCamera.layerMask, renderTarget);
        });
    }
    /**
     * Adds all the elements from the container to the scene
     * @param container the container holding the elements
     */ addFromContainer(container) {
        if (!container.layers) return;
        container.layers.forEach((layer)=>{
            this.scene.layers.push(layer);
        });
    }
    /**
     * Removes all the elements in the container from the scene
     * @param container contains the elements to remove
     * @param dispose if the removed element should be disposed (default: false)
     */ removeFromContainer(container, dispose = false) {
        if (!container.layers) return;
        container.layers.forEach((layer)=>{
            const index = this.scene.layers.indexOf(layer);
            if (index !== -1) this.scene.layers.splice(index, 1);
            if (dispose) layer.dispose();
        });
    }
}

});

parcelRegister("cGwq9", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("7Hs3g");
const $93c28e5ae876e69f$var$name = "layerPixelShader";
const $93c28e5ae876e69f$var$shader = `varying vec2 vUV;uniform sampler2D textureSampler;uniform vec4 color;
#include<helperFunctions>
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) {
#define CUSTOM_FRAGMENT_MAIN_BEGIN
vec4 baseColor=texture2D(textureSampler,vUV);
#ifdef LINEAR
baseColor.rgb=toGammaSpace(baseColor.rgb);
#endif
#ifdef ALPHATEST
if (baseColor.a<0.4)
discard;
#endif
gl_FragColor=baseColor*color;
#define CUSTOM_FRAGMENT_MAIN_END
}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$93c28e5ae876e69f$var$name] = $93c28e5ae876e69f$var$shader;
const $93c28e5ae876e69f$export$1ffb156739b0bdd = {
    name: $93c28e5ae876e69f$var$name,
    shader: $93c28e5ae876e69f$var$shader
};

});

parcelRegister("jiOMu", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $e0d716d7d9829604$var$name = "layerVertexShader";
const $e0d716d7d9829604$var$shader = `attribute vec2 position;uniform vec2 scale;uniform vec2 offset;uniform mat4 textureMatrix;varying vec2 vUV;const vec2 madd=vec2(0.5,0.5);
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
vec2 shiftedPosition=position*scale+offset;vUV=vec2(textureMatrix*vec4(shiftedPosition*madd+madd,1.0,0.0));gl_Position=vec4(shiftedPosition,0.0,1.0);
#define CUSTOM_VERTEX_MAIN_END
}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$e0d716d7d9829604$var$name] = $e0d716d7d9829604$var$shader;
const $e0d716d7d9829604$export$d19396c9adfcd2d7 = {
    name: $e0d716d7d9829604$var$name,
    shader: $e0d716d7d9829604$var$shader
};

});



parcelRegister("8xKGe", function(module, exports) {

var $jNSPe = parcelRequire("jNSPe");

var $jik3B = parcelRequire("jik3B");

var $3NwTE = parcelRequire("3NwTE");
$parcel$exportWildcard(module.exports, $jNSPe);
$parcel$exportWildcard(module.exports, $jik3B);
$parcel$exportWildcard(module.exports, $3NwTE);

});
parcelRegister("jNSPe", function(module, exports) {

$parcel$export(module.exports, "LensFlare", () => $e6ad1f15c75507d5$export$3f909fba4d49fe3d);

var $7etnY = parcelRequire("7etnY");

var $j2mX5 = parcelRequire("j2mX5");

var $hOyoX = parcelRequire("hOyoX");

var $b4i1f = parcelRequire("b4i1f");
class $e6ad1f15c75507d5$export$3f909fba4d49fe3d {
    /**
     * Creates a new Lens Flare.
     * This represents one of the lens effect in a `lensFlareSystem`.
     * It controls one of the individual texture used in the effect.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/environment/lenseFlare
     * @param size Define the size of the lens flare (a floating value between 0 and 1)
     * @param position Define the position of the lens flare in the system. (a floating value between -1 and 1). A value of 0 is located on the emitter. A value greater than 0 is beyond the emitter and a value lesser than 0 is behind.
     * @param color Define the lens color
     * @param imgUrl Define the lens texture url
     * @param system Define the `lensFlareSystem` this flare is part of
     * @returns The newly created Lens Flare
     */ static AddFlare(size, position, color, imgUrl, system) {
        return new $e6ad1f15c75507d5$export$3f909fba4d49fe3d(size, position, color, imgUrl, system);
    }
    /**
     * Instantiates a new Lens Flare.
     * This represents one of the lens effect in a `lensFlareSystem`.
     * It controls one of the individual texture used in the effect.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/environment/lenseFlare
     * @param size Define the size of the lens flare in the system (a floating value between 0 and 1)
     * @param position Define the position of the lens flare in the system. (a floating value between -1 and 1). A value of 0 is located on the emitter. A value greater than 0 is beyond the emitter and a value lesser than 0 is behind.
     * @param color Define the lens color
     * @param imgUrl Define the lens texture url
     * @param system Define the `lensFlareSystem` this flare is part of
     */ constructor(/**
     * Define the size of the lens flare in the system (a floating value between 0 and 1)
     */ size, /**
     * Define the position of the lens flare in the system. (a floating value between -1 and 1). A value of 0 is located on the emitter. A value greater than 0 is beyond the emitter and a value lesser than 0 is behind.
     */ position, color, imgUrl, system){
        this.size = size;
        this.position = position;
        /**
         * Define the alpha mode to render this particular lens.
         */ this.alphaMode = 6;
        this.color = color || new (0, $7etnY.Color3)(1, 1, 1);
        this.texture = imgUrl ? new (0, $j2mX5.Texture)(imgUrl, system.getScene(), true) : null;
        this._system = system;
        const engine = system.scene.getEngine();
        this._drawWrapper = new (0, $hOyoX.DrawWrapper)(engine);
        this._drawWrapper.effect = engine.createEffect("lensFlare", [
            (0, $b4i1f.VertexBuffer).PositionKind
        ], [
            "color",
            "viewportMatrix"
        ], [
            "textureSampler"
        ], "");
        system.lensFlares.push(this);
    }
    /**
     * Dispose and release the lens flare with its associated resources.
     */ dispose() {
        if (this.texture) this.texture.dispose();
        // Remove from scene
        const index = this._system.lensFlares.indexOf(this);
        this._system.lensFlares.splice(index, 1);
    }
}

});

parcelRegister("jik3B", function(module, exports) {

$parcel$export(module.exports, "LensFlareSystem", () => $e0bf41b135359f0c$export$ef99376b838b0dac);

var $bOhSV = parcelRequire("bOhSV");

var $ha1VO = parcelRequire("ha1VO");

var $1VEEL = parcelRequire("1VEEL");

var $ejQPp = parcelRequire("ejQPp");

var $b4i1f = parcelRequire("b4i1f");

var $3kez7 = parcelRequire("3kez7");

var $54229 = parcelRequire("54229");

var $jNSPe = parcelRequire("jNSPe");
parcelRequire("da6aR");
parcelRequire("6MMmX");

var $dUFYy = parcelRequire("dUFYy");

var $7etnY = parcelRequire("7etnY");
class $e0bf41b135359f0c$export$ef99376b838b0dac {
    /** Gets the scene */ get scene() {
        return this._scene;
    }
    /**
     * Instantiates a lens flare system.
     * This represents a Lens Flare System or the shiny effect created by the light reflection on the  camera lenses.
     * It is usually composed of several `lensFlare`.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/environment/lenseFlare
     * @param name Define the name of the lens flare system in the scene
     * @param emitter Define the source (the emitter) of the lens flares (it can be a camera, a light or a mesh).
     * @param scene Define the scene the lens flare system belongs to
     */ constructor(/**
     * Define the name of the lens flare system
     */ name, emitter, scene){
        this.name = name;
        /**
         * List of lens flares used in this system.
         */ this.lensFlares = [];
        /**
         * Define a limit from the border the lens flare can be visible.
         */ this.borderLimit = 300;
        /**
         * Define a viewport border we do not want to see the lens flare in.
         */ this.viewportBorder = 0;
        /**
         * Restricts the rendering of the effect to only the camera rendering this layer mask.
         */ this.layerMask = 0x0fffffff;
        this._vertexBuffers = {};
        this._isEnabled = true;
        this._scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        $e0bf41b135359f0c$export$ef99376b838b0dac._SceneComponentInitialization(this._scene);
        this._emitter = emitter;
        this.id = name;
        scene.lensFlareSystems.push(this);
        this.meshesSelectionPredicate = (m)=>scene.activeCamera && m.material && m.isVisible && m.isEnabled() && m.isBlocker && (m.layerMask & scene.activeCamera.layerMask) != 0;
        const engine = scene.getEngine();
        // VBO
        const vertices = [];
        vertices.push(1, 1);
        vertices.push(-1, 1);
        vertices.push(-1, -1);
        vertices.push(1, -1);
        this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind] = new (0, $b4i1f.VertexBuffer)(engine, vertices, (0, $b4i1f.VertexBuffer).PositionKind, false, false, 2);
        // Indices
        this._createIndexBuffer();
    }
    _createIndexBuffer() {
        const indices = [];
        indices.push(0);
        indices.push(1);
        indices.push(2);
        indices.push(0);
        indices.push(2);
        indices.push(3);
        this._indexBuffer = this._scene.getEngine().createIndexBuffer(indices);
    }
    /**
     * Define if the lens flare system is enabled.
     */ get isEnabled() {
        return this._isEnabled;
    }
    set isEnabled(value) {
        this._isEnabled = value;
    }
    /**
     * Get the scene the effects belongs to.
     * @returns the scene holding the lens flare system
     */ getScene() {
        return this._scene;
    }
    /**
     * Get the emitter of the lens flare system.
     * It defines the source of the lens flares (it can be a camera, a light or a mesh).
     * @returns the emitter of the lens flare system
     */ getEmitter() {
        return this._emitter;
    }
    /**
     * Set the emitter of the lens flare system.
     * It defines the source of the lens flares (it can be a camera, a light or a mesh).
     * @param newEmitter Define the new emitter of the system
     */ setEmitter(newEmitter) {
        this._emitter = newEmitter;
    }
    /**
     * Get the lens flare system emitter position.
     * The emitter defines the source of the lens flares (it can be a camera, a light or a mesh).
     * @returns the position
     */ getEmitterPosition() {
        return this._emitter.getAbsolutePosition ? this._emitter.getAbsolutePosition() : this._emitter.position;
    }
    /**
     * @internal
     */ computeEffectivePosition(globalViewport) {
        let position = this.getEmitterPosition();
        position = (0, $ha1VO.Vector3).Project(position, (0, $ha1VO.Matrix).Identity(), this._scene.getTransformMatrix(), globalViewport);
        this._positionX = position.x;
        this._positionY = position.y;
        position = (0, $ha1VO.Vector3).TransformCoordinates(this.getEmitterPosition(), this._scene.getViewMatrix());
        if (this.viewportBorder > 0) {
            globalViewport.x -= this.viewportBorder;
            globalViewport.y -= this.viewportBorder;
            globalViewport.width += this.viewportBorder * 2;
            globalViewport.height += this.viewportBorder * 2;
            position.x += this.viewportBorder;
            position.y += this.viewportBorder;
            this._positionX += this.viewportBorder;
            this._positionY += this.viewportBorder;
        }
        const rhs = this._scene.useRightHandedSystem;
        const okZ = position.z > 0 && !rhs || position.z < 0 && rhs;
        if (okZ) {
            if (this._positionX > globalViewport.x && this._positionX < globalViewport.x + globalViewport.width) {
                if (this._positionY > globalViewport.y && this._positionY < globalViewport.y + globalViewport.height) return true;
            }
            return true;
        }
        return false;
    }
    /** @internal */ _isVisible() {
        if (!this._isEnabled || !this._scene.activeCamera) return false;
        const emitterPosition = this.getEmitterPosition();
        const direction = emitterPosition.subtract(this._scene.activeCamera.globalPosition);
        const distance = direction.length();
        direction.normalize();
        const ray = new (0, $3kez7.Ray)(this._scene.activeCamera.globalPosition, direction);
        const pickInfo = this._scene.pickWithRay(ray, this.meshesSelectionPredicate, true);
        return !pickInfo || !pickInfo.hit || pickInfo.distance > distance;
    }
    /**
     * @internal
     */ render() {
        if (!this._scene.activeCamera) return false;
        const engine = this._scene.getEngine();
        const viewport = this._scene.activeCamera.viewport;
        const globalViewport = viewport.toGlobal(engine.getRenderWidth(true), engine.getRenderHeight(true));
        // Position
        if (!this.computeEffectivePosition(globalViewport)) return false;
        // Visibility
        if (!this._isVisible()) return false;
        // Intensity
        let awayX;
        let awayY;
        if (this._positionX < this.borderLimit + globalViewport.x) awayX = this.borderLimit + globalViewport.x - this._positionX;
        else if (this._positionX > globalViewport.x + globalViewport.width - this.borderLimit) awayX = this._positionX - globalViewport.x - globalViewport.width + this.borderLimit;
        else awayX = 0;
        if (this._positionY < this.borderLimit + globalViewport.y) awayY = this.borderLimit + globalViewport.y - this._positionY;
        else if (this._positionY > globalViewport.y + globalViewport.height - this.borderLimit) awayY = this._positionY - globalViewport.y - globalViewport.height + this.borderLimit;
        else awayY = 0;
        let away = awayX > awayY ? awayX : awayY;
        away -= this.viewportBorder;
        if (away > this.borderLimit) away = this.borderLimit;
        let intensity = 1.0 - (0, $1VEEL.Scalar).Clamp(away / this.borderLimit, 0, 1);
        if (intensity < 0) return false;
        if (intensity > 1.0) intensity = 1.0;
        if (this.viewportBorder > 0) {
            globalViewport.x += this.viewportBorder;
            globalViewport.y += this.viewportBorder;
            globalViewport.width -= this.viewportBorder * 2;
            globalViewport.height -= this.viewportBorder * 2;
            this._positionX -= this.viewportBorder;
            this._positionY -= this.viewportBorder;
        }
        // Position
        const centerX = globalViewport.x + globalViewport.width / 2;
        const centerY = globalViewport.y + globalViewport.height / 2;
        const distX = centerX - this._positionX;
        const distY = centerY - this._positionY;
        // Effects
        engine.setState(false);
        engine.setDepthBuffer(false);
        // Flares
        for(let index = 0; index < this.lensFlares.length; index++){
            const flare = this.lensFlares[index];
            if (!flare._drawWrapper.effect.isReady() || flare.texture && !flare.texture.isReady()) continue;
            engine.enableEffect(flare._drawWrapper);
            engine.bindBuffers(this._vertexBuffers, this._indexBuffer, flare._drawWrapper.effect);
            engine.setAlphaMode(flare.alphaMode);
            const x = centerX - distX * flare.position;
            const y = centerY - distY * flare.position;
            const cw = flare.size;
            const ch = flare.size * engine.getAspectRatio(this._scene.activeCamera, true);
            const cx = 2 * (x / (globalViewport.width + globalViewport.x * 2)) - 1.0;
            const cy = 1.0 - 2 * (y / (globalViewport.height + globalViewport.y * 2));
            const viewportMatrix = (0, $ha1VO.Matrix).FromValues(cw / 2, 0, 0, 0, 0, ch / 2, 0, 0, 0, 0, 1, 0, cx, cy, 0, 1);
            flare._drawWrapper.effect.setMatrix("viewportMatrix", viewportMatrix);
            // Texture
            flare._drawWrapper.effect.setTexture("textureSampler", flare.texture);
            // Color
            flare._drawWrapper.effect.setFloat4("color", flare.color.r * intensity, flare.color.g * intensity, flare.color.b * intensity, 1.0);
            // Draw order
            engine.drawElementsType((0, $54229.Material).TriangleFillMode, 0, 6);
        }
        engine.setDepthBuffer(true);
        engine.setAlphaMode(0);
        return true;
    }
    /**
     * Rebuilds the lens flare system
     */ rebuild() {
        this._createIndexBuffer();
        for(const key in this._vertexBuffers)this._vertexBuffers[key]?._rebuild();
    }
    /**
     * Dispose and release the lens flare with its associated resources.
     */ dispose() {
        const vertexBuffer = this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind];
        if (vertexBuffer) {
            vertexBuffer.dispose();
            this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind] = null;
        }
        if (this._indexBuffer) {
            this._scene.getEngine()._releaseBuffer(this._indexBuffer);
            this._indexBuffer = null;
        }
        while(this.lensFlares.length)this.lensFlares[0].dispose();
        // Remove from scene
        const index = this._scene.lensFlareSystems.indexOf(this);
        this._scene.lensFlareSystems.splice(index, 1);
    }
    /**
     * Parse a lens flare system from a JSON representation
     * @param parsedLensFlareSystem Define the JSON to parse
     * @param scene Define the scene the parsed system should be instantiated in
     * @param rootUrl Define the rootUrl of the load sequence to easily find a load relative dependencies such as textures
     * @returns the parsed system
     */ static Parse(parsedLensFlareSystem, scene, rootUrl) {
        const emitter = scene.getLastEntryById(parsedLensFlareSystem.emitterId);
        const name = parsedLensFlareSystem.name || "lensFlareSystem#" + parsedLensFlareSystem.emitterId;
        const lensFlareSystem = new $e0bf41b135359f0c$export$ef99376b838b0dac(name, emitter, scene);
        lensFlareSystem.id = parsedLensFlareSystem.id || name;
        lensFlareSystem.borderLimit = parsedLensFlareSystem.borderLimit;
        for(let index = 0; index < parsedLensFlareSystem.flares.length; index++){
            const parsedFlare = parsedLensFlareSystem.flares[index];
            (0, $jNSPe.LensFlare).AddFlare(parsedFlare.size, parsedFlare.position, (0, $7etnY.Color3).FromArray(parsedFlare.color), parsedFlare.textureName ? rootUrl + parsedFlare.textureName : "", lensFlareSystem);
        }
        return lensFlareSystem;
    }
    /**
     * Serialize the current Lens Flare System into a JSON representation.
     * @returns the serialized JSON
     */ serialize() {
        const serializationObject = {};
        serializationObject.id = this.id;
        serializationObject.name = this.name;
        serializationObject.emitterId = this.getEmitter().id;
        serializationObject.borderLimit = this.borderLimit;
        serializationObject.flares = [];
        for(let index = 0; index < this.lensFlares.length; index++){
            const flare = this.lensFlares[index];
            serializationObject.flares.push({
                size: flare.size,
                position: flare.position,
                color: flare.color.asArray(),
                textureName: (0, $bOhSV.Tools).GetFilename(flare.texture ? flare.texture.name : "")
            });
        }
        return serializationObject;
    }
}
/**
 * @internal
 */ $e0bf41b135359f0c$export$ef99376b838b0dac._SceneComponentInitialization = (_)=>{
    throw (0, $dUFYy._WarnImport)("LensFlareSystemSceneComponent");
};

});
parcelRegister("da6aR", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $9950ff987d99f4ae$var$name = "lensFlarePixelShader";
const $9950ff987d99f4ae$var$shader = `varying vec2 vUV;uniform sampler2D textureSampler;uniform vec4 color;
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) {
#define CUSTOM_FRAGMENT_MAIN_BEGIN
vec4 baseColor=texture2D(textureSampler,vUV);gl_FragColor=baseColor*color;
#define CUSTOM_FRAGMENT_MAIN_END
}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$9950ff987d99f4ae$var$name] = $9950ff987d99f4ae$var$shader;
const $9950ff987d99f4ae$export$f92f9b40048ad72b = {
    name: $9950ff987d99f4ae$var$name,
    shader: $9950ff987d99f4ae$var$shader
};

});

parcelRegister("6MMmX", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $4f0cbee8550d60d3$var$name = "lensFlareVertexShader";
const $4f0cbee8550d60d3$var$shader = `attribute vec2 position;uniform mat4 viewportMatrix;varying vec2 vUV;const vec2 madd=vec2(0.5,0.5);
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
vUV=position*madd+madd;gl_Position=viewportMatrix*vec4(position,0.0,1.0);
#define CUSTOM_VERTEX_MAIN_END
}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$4f0cbee8550d60d3$var$name] = $4f0cbee8550d60d3$var$shader;
const $4f0cbee8550d60d3$export$9eba7a00c6a5cda3 = {
    name: $4f0cbee8550d60d3$var$name,
    shader: $4f0cbee8550d60d3$var$shader
};

});


parcelRegister("3NwTE", function(module, exports) {

$parcel$export(module.exports, "LensFlareSystemSceneComponent", () => $2c3f774627348160$export$6edff8e1215a551e);

var $bOhSV = parcelRequire("bOhSV");

var $bv05l = parcelRequire("bv05l");

var $5Tqba = parcelRequire("5Tqba");

var $jik3B = parcelRequire("jik3B");
// Adds the parser to the scene parsers.
(0, $5Tqba.AbstractScene).AddParser((0, $bv05l.SceneComponentConstants).NAME_LENSFLARESYSTEM, (parsedData, scene, container, rootUrl)=>{
    // Lens flares
    if (parsedData.lensFlareSystems !== undefined && parsedData.lensFlareSystems !== null) {
        if (!container.lensFlareSystems) container.lensFlareSystems = [];
        for(let index = 0, cache = parsedData.lensFlareSystems.length; index < cache; index++){
            const parsedLensFlareSystem = parsedData.lensFlareSystems[index];
            const lf = (0, $jik3B.LensFlareSystem).Parse(parsedLensFlareSystem, scene, rootUrl);
            container.lensFlareSystems.push(lf);
        }
    }
});
(0, $5Tqba.AbstractScene).prototype.getLensFlareSystemByName = function(name) {
    for(let index = 0; index < this.lensFlareSystems.length; index++){
        if (this.lensFlareSystems[index].name === name) return this.lensFlareSystems[index];
    }
    return null;
};
(0, $5Tqba.AbstractScene).prototype.getLensFlareSystemById = function(id) {
    for(let index = 0; index < this.lensFlareSystems.length; index++){
        if (this.lensFlareSystems[index].id === id) return this.lensFlareSystems[index];
    }
    return null;
};
(0, $5Tqba.AbstractScene).prototype.getLensFlareSystemByID = function(id) {
    return this.getLensFlareSystemById(id);
};
(0, $5Tqba.AbstractScene).prototype.removeLensFlareSystem = function(toRemove) {
    const index = this.lensFlareSystems.indexOf(toRemove);
    if (index !== -1) this.lensFlareSystems.splice(index, 1);
    return index;
};
(0, $5Tqba.AbstractScene).prototype.addLensFlareSystem = function(newLensFlareSystem) {
    this.lensFlareSystems.push(newLensFlareSystem);
};
class $2c3f774627348160$export$6edff8e1215a551e {
    /**
     * Creates a new instance of the component for the given scene
     * @param scene Defines the scene to register the component in
     */ constructor(scene){
        /**
         * The component name helpful to identify the component in the list of scene components.
         */ this.name = (0, $bv05l.SceneComponentConstants).NAME_LENSFLARESYSTEM;
        this.scene = scene;
        scene.lensFlareSystems = [];
    }
    /**
     * Registers the component in a given scene
     */ register() {
        this.scene._afterCameraDrawStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_AFTERCAMERADRAW_LENSFLARESYSTEM, this, this._draw);
    }
    /**
     * Rebuilds the elements related to this component in case of
     * context lost for instance.
     */ rebuild() {
        for(let index = 0; index < this.scene.lensFlareSystems.length; index++)this.scene.lensFlareSystems[index].rebuild();
    }
    /**
     * Adds all the elements from the container to the scene
     * @param container the container holding the elements
     */ addFromContainer(container) {
        if (!container.lensFlareSystems) return;
        container.lensFlareSystems.forEach((o)=>{
            this.scene.addLensFlareSystem(o);
        });
    }
    /**
     * Removes all the elements in the container from the scene
     * @param container contains the elements to remove
     * @param dispose if the removed element should be disposed (default: false)
     */ removeFromContainer(container, dispose) {
        if (!container.lensFlareSystems) return;
        container.lensFlareSystems.forEach((o)=>{
            this.scene.removeLensFlareSystem(o);
            if (dispose) o.dispose();
        });
    }
    /**
     * Serializes the component data to the specified json object
     * @param serializationObject The object to serialize to
     */ serialize(serializationObject) {
        // Lens flares
        serializationObject.lensFlareSystems = [];
        const lensFlareSystems = this.scene.lensFlareSystems;
        for (const lensFlareSystem of lensFlareSystems)serializationObject.lensFlareSystems.push(lensFlareSystem.serialize());
    }
    /**
     * Disposes the component and the associated resources.
     */ dispose() {
        const lensFlareSystems = this.scene.lensFlareSystems;
        while(lensFlareSystems.length)lensFlareSystems[0].dispose();
    }
    _draw(camera) {
        // Lens flares
        if (this.scene.lensFlaresEnabled) {
            const lensFlareSystems = this.scene.lensFlareSystems;
            (0, $bOhSV.Tools).StartPerformanceCounter("Lens flares", lensFlareSystems.length > 0);
            for (const lensFlareSystem of lensFlareSystems)if ((camera.layerMask & lensFlareSystem.layerMask) !== 0) lensFlareSystem.render();
            (0, $bOhSV.Tools).EndPerformanceCounter("Lens flares", lensFlareSystems.length > 0);
        }
    }
}
(0, $jik3B.LensFlareSystem)._SceneComponentInitialization = (scene)=>{
    let component = scene._getComponent((0, $bv05l.SceneComponentConstants).NAME_LENSFLARESYSTEM);
    if (!component) {
        component = new $2c3f774627348160$export$6edff8e1215a551e(scene);
        scene._addComponent(component);
    }
};

});


parcelRegister("eh12X", function(module, exports) {
/* eslint-disable import/no-internal-modules */ 
var $c6YWJ = parcelRequire("c6YWJ");

var $lso8g = parcelRequire("lso8g");

var $dAeGw = parcelRequire("dAeGw");

var $btpzP = parcelRequire("btpzP");

var $lgdKn = parcelRequire("lgdKn");

var $3r3bc = parcelRequire("3r3bc");

var $aYDyu = parcelRequire("aYDyu");
$parcel$exportWildcard(module.exports, $c6YWJ);
$parcel$exportWildcard(module.exports, $lso8g);
$parcel$exportWildcard(module.exports, $dAeGw);
$parcel$exportWildcard(module.exports, $btpzP);
$parcel$exportWildcard(module.exports, $lgdKn);
$parcel$exportWildcard(module.exports, $3r3bc);
$parcel$exportWildcard(module.exports, $aYDyu);

});
parcelRegister("dAeGw", function(module, exports) {

var $itc0L = parcelRequire("itc0L");

var $jFaMv = parcelRequire("jFaMv");

var $jJcGg = parcelRequire("jJcGg");
$parcel$exportWildcard(module.exports, $itc0L);
$parcel$exportWildcard(module.exports, $jFaMv);
$parcel$exportWildcard(module.exports, $jJcGg);

});
parcelRegister("itc0L", function(module, exports) {

$parcel$export(module.exports, "ShadowGenerator", () => $d72440a6bcb638ba$export$17b5c8c0ade7fd9e);

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $b4i1f = parcelRequire("b4i1f");

var $c6YWJ = parcelRequire("c6YWJ");

var $j2mX5 = parcelRequire("j2mX5");

var $gQtNK = parcelRequire("gQtNK");

var $cFdBb = parcelRequire("cFdBb");

var $8zEq7 = parcelRequire("8zEq7");

var $diGQf = parcelRequire("diGQf");

var $dUFYy = parcelRequire("dUFYy");

var $gc8Ja = parcelRequire("gc8Ja");

var $jJNg8 = parcelRequire("jJNg8");

var $hOyoX = parcelRequire("hOyoX");
parcelRequire("1DQzz");
parcelRequire("340di");
parcelRequire("hy7L3");
parcelRequire("5FASc");

var $aAFeM = parcelRequire("aAFeM");

var $alPCh = parcelRequire("alPCh");
class $d72440a6bcb638ba$export$17b5c8c0ade7fd9e {
    /**
     * Gets the bias: offset applied on the depth preventing acnea (in light direction).
     */ get bias() {
        return this._bias;
    }
    /**
     * Sets the bias: offset applied on the depth preventing acnea (in light direction).
     */ set bias(bias) {
        this._bias = bias;
    }
    /**
     * Gets the normalBias: offset applied on the depth preventing acnea (along side the normal direction and proportional to the light/normal angle).
     */ get normalBias() {
        return this._normalBias;
    }
    /**
     * Sets the normalBias: offset applied on the depth preventing acnea (along side the normal direction and proportional to the light/normal angle).
     */ set normalBias(normalBias) {
        this._normalBias = normalBias;
    }
    /**
     * Gets the blur box offset: offset applied during the blur pass.
     * Only useful if useKernelBlur = false
     */ get blurBoxOffset() {
        return this._blurBoxOffset;
    }
    /**
     * Sets the blur box offset: offset applied during the blur pass.
     * Only useful if useKernelBlur = false
     */ set blurBoxOffset(value) {
        if (this._blurBoxOffset === value) return;
        this._blurBoxOffset = value;
        this._disposeBlurPostProcesses();
    }
    /**
     * Gets the blur scale: scale of the blurred texture compared to the main shadow map.
     * 2 means half of the size.
     */ get blurScale() {
        return this._blurScale;
    }
    /**
     * Sets the blur scale: scale of the blurred texture compared to the main shadow map.
     * 2 means half of the size.
     */ set blurScale(value) {
        if (this._blurScale === value) return;
        this._blurScale = value;
        this._disposeBlurPostProcesses();
    }
    /**
     * Gets the blur kernel: kernel size of the blur pass.
     * Only useful if useKernelBlur = true
     */ get blurKernel() {
        return this._blurKernel;
    }
    /**
     * Sets the blur kernel: kernel size of the blur pass.
     * Only useful if useKernelBlur = true
     */ set blurKernel(value) {
        if (this._blurKernel === value) return;
        this._blurKernel = value;
        this._disposeBlurPostProcesses();
    }
    /**
     * Gets whether the blur pass is a kernel blur (if true) or box blur.
     * Only useful in filtered mode (useBlurExponentialShadowMap...)
     */ get useKernelBlur() {
        return this._useKernelBlur;
    }
    /**
     * Sets whether the blur pass is a kernel blur (if true) or box blur.
     * Only useful in filtered mode (useBlurExponentialShadowMap...)
     */ set useKernelBlur(value) {
        if (this._useKernelBlur === value) return;
        this._useKernelBlur = value;
        this._disposeBlurPostProcesses();
    }
    /**
     * Gets the depth scale used in ESM mode.
     */ get depthScale() {
        return this._depthScale !== undefined ? this._depthScale : this._light.getDepthScale();
    }
    /**
     * Sets the depth scale used in ESM mode.
     * This can override the scale stored on the light.
     */ set depthScale(value) {
        this._depthScale = value;
    }
    _validateFilter(filter) {
        return filter;
    }
    /**
     * Gets the current mode of the shadow generator (normal, PCF, ESM...).
     * The returned value is a number equal to one of the available mode defined in ShadowMap.FILTER_x like _FILTER_NONE
     */ get filter() {
        return this._filter;
    }
    /**
     * Sets the current mode of the shadow generator (normal, PCF, ESM...).
     * The returned value is a number equal to one of the available mode defined in ShadowMap.FILTER_x like _FILTER_NONE
     */ set filter(value) {
        value = this._validateFilter(value);
        // Blurring the cubemap is going to be too expensive. Reverting to unblurred version
        if (this._light.needCube()) {
            if (value === $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_BLUREXPONENTIALSHADOWMAP) {
                this.useExponentialShadowMap = true;
                return;
            } else if (value === $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_BLURCLOSEEXPONENTIALSHADOWMAP) {
                this.useCloseExponentialShadowMap = true;
                return;
            } else if (value === $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_PCF || value === $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_PCSS) {
                this.usePoissonSampling = true;
                return;
            }
        }
        // Weblg1 fallback for PCF.
        if (value === $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_PCF || value === $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_PCSS) {
            if (!this._scene.getEngine()._features.supportShadowSamplers) {
                this.usePoissonSampling = true;
                return;
            }
        }
        if (this._filter === value) return;
        this._filter = value;
        this._disposeBlurPostProcesses();
        this._applyFilterValues();
        this._light._markMeshesAsLightDirty();
    }
    /**
     * Gets if the current filter is set to Poisson Sampling.
     */ get usePoissonSampling() {
        return this.filter === $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_POISSONSAMPLING;
    }
    /**
     * Sets the current filter to Poisson Sampling.
     */ set usePoissonSampling(value) {
        const filter = this._validateFilter($d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_POISSONSAMPLING);
        if (!value && this.filter !== $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_POISSONSAMPLING) return;
        this.filter = value ? filter : $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_NONE;
    }
    /**
     * Gets if the current filter is set to ESM.
     */ get useExponentialShadowMap() {
        return this.filter === $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_EXPONENTIALSHADOWMAP;
    }
    /**
     * Sets the current filter is to ESM.
     */ set useExponentialShadowMap(value) {
        const filter = this._validateFilter($d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_EXPONENTIALSHADOWMAP);
        if (!value && this.filter !== $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_EXPONENTIALSHADOWMAP) return;
        this.filter = value ? filter : $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_NONE;
    }
    /**
     * Gets if the current filter is set to filtered ESM.
     */ get useBlurExponentialShadowMap() {
        return this.filter === $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_BLUREXPONENTIALSHADOWMAP;
    }
    /**
     * Gets if the current filter is set to filtered  ESM.
     */ set useBlurExponentialShadowMap(value) {
        const filter = this._validateFilter($d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_BLUREXPONENTIALSHADOWMAP);
        if (!value && this.filter !== $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_BLUREXPONENTIALSHADOWMAP) return;
        this.filter = value ? filter : $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_NONE;
    }
    /**
     * Gets if the current filter is set to "close ESM" (using the inverse of the
     * exponential to prevent steep falloff artifacts).
     */ get useCloseExponentialShadowMap() {
        return this.filter === $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_CLOSEEXPONENTIALSHADOWMAP;
    }
    /**
     * Sets the current filter to "close ESM" (using the inverse of the
     * exponential to prevent steep falloff artifacts).
     */ set useCloseExponentialShadowMap(value) {
        const filter = this._validateFilter($d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_CLOSEEXPONENTIALSHADOWMAP);
        if (!value && this.filter !== $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_CLOSEEXPONENTIALSHADOWMAP) return;
        this.filter = value ? filter : $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_NONE;
    }
    /**
     * Gets if the current filter is set to filtered "close ESM" (using the inverse of the
     * exponential to prevent steep falloff artifacts).
     */ get useBlurCloseExponentialShadowMap() {
        return this.filter === $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_BLURCLOSEEXPONENTIALSHADOWMAP;
    }
    /**
     * Sets the current filter to filtered "close ESM" (using the inverse of the
     * exponential to prevent steep falloff artifacts).
     */ set useBlurCloseExponentialShadowMap(value) {
        const filter = this._validateFilter($d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_BLURCLOSEEXPONENTIALSHADOWMAP);
        if (!value && this.filter !== $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_BLURCLOSEEXPONENTIALSHADOWMAP) return;
        this.filter = value ? filter : $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_NONE;
    }
    /**
     * Gets if the current filter is set to "PCF" (percentage closer filtering).
     */ get usePercentageCloserFiltering() {
        return this.filter === $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_PCF;
    }
    /**
     * Sets the current filter to "PCF" (percentage closer filtering).
     */ set usePercentageCloserFiltering(value) {
        const filter = this._validateFilter($d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_PCF);
        if (!value && this.filter !== $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_PCF) return;
        this.filter = value ? filter : $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_NONE;
    }
    /**
     * Gets the PCF or PCSS Quality.
     * Only valid if usePercentageCloserFiltering or usePercentageCloserFiltering is true.
     */ get filteringQuality() {
        return this._filteringQuality;
    }
    /**
     * Sets the PCF or PCSS Quality.
     * Only valid if usePercentageCloserFiltering or usePercentageCloserFiltering is true.
     */ set filteringQuality(filteringQuality) {
        if (this._filteringQuality === filteringQuality) return;
        this._filteringQuality = filteringQuality;
        this._disposeBlurPostProcesses();
        this._applyFilterValues();
        this._light._markMeshesAsLightDirty();
    }
    /**
     * Gets if the current filter is set to "PCSS" (contact hardening).
     */ get useContactHardeningShadow() {
        return this.filter === $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_PCSS;
    }
    /**
     * Sets the current filter to "PCSS" (contact hardening).
     */ set useContactHardeningShadow(value) {
        const filter = this._validateFilter($d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_PCSS);
        if (!value && this.filter !== $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_PCSS) return;
        this.filter = value ? filter : $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_NONE;
    }
    /**
     * Gets the Light Size (in shadow map uv unit) used in PCSS to determine the blocker search area and the penumbra size.
     * Using a ratio helps keeping shape stability independently of the map size.
     *
     * It does not account for the light projection as it was having too much
     * instability during the light setup or during light position changes.
     *
     * Only valid if useContactHardeningShadow is true.
     */ get contactHardeningLightSizeUVRatio() {
        return this._contactHardeningLightSizeUVRatio;
    }
    /**
     * Sets the Light Size (in shadow map uv unit) used in PCSS to determine the blocker search area and the penumbra size.
     * Using a ratio helps keeping shape stability independently of the map size.
     *
     * It does not account for the light projection as it was having too much
     * instability during the light setup or during light position changes.
     *
     * Only valid if useContactHardeningShadow is true.
     */ set contactHardeningLightSizeUVRatio(contactHardeningLightSizeUVRatio) {
        this._contactHardeningLightSizeUVRatio = contactHardeningLightSizeUVRatio;
    }
    /** Gets or sets the actual darkness of a shadow */ get darkness() {
        return this._darkness;
    }
    set darkness(value) {
        this.setDarkness(value);
    }
    /**
     * Returns the darkness value (float). This can only decrease the actual darkness of a shadow.
     * 0 means strongest and 1 would means no shadow.
     * @returns the darkness.
     */ getDarkness() {
        return this._darkness;
    }
    /**
     * Sets the darkness value (float). This can only decrease the actual darkness of a shadow.
     * @param darkness The darkness value 0 means strongest and 1 would means no shadow.
     * @returns the shadow generator allowing fluent coding.
     */ setDarkness(darkness) {
        if (darkness >= 1.0) this._darkness = 1.0;
        else if (darkness <= 0.0) this._darkness = 0.0;
        else this._darkness = darkness;
        return this;
    }
    /** Gets or sets the ability to have transparent shadow  */ get transparencyShadow() {
        return this._transparencyShadow;
    }
    set transparencyShadow(value) {
        this.setTransparencyShadow(value);
    }
    /**
     * Sets the ability to have transparent shadow (boolean).
     * @param transparent True if transparent else False
     * @returns the shadow generator allowing fluent coding
     */ setTransparencyShadow(transparent) {
        this._transparencyShadow = transparent;
        return this;
    }
    /**
     * Gets the main RTT containing the shadow map (usually storing depth from the light point of view).
     * @returns The render target texture if present otherwise, null
     */ getShadowMap() {
        return this._shadowMap;
    }
    /**
     * Gets the RTT used during rendering (can be a blurred version of the shadow map or the shadow map itself).
     * @returns The render target texture if the shadow map is present otherwise, null
     */ getShadowMapForRendering() {
        if (this._shadowMap2) return this._shadowMap2;
        return this._shadowMap;
    }
    /**
     * Gets the class name of that object
     * @returns "ShadowGenerator"
     */ getClassName() {
        return $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.CLASSNAME;
    }
    /**
     * Helper function to add a mesh and its descendants to the list of shadow casters.
     * @param mesh Mesh to add
     * @param includeDescendants boolean indicating if the descendants should be added. Default to true
     * @returns the Shadow Generator itself
     */ addShadowCaster(mesh, includeDescendants = true) {
        if (!this._shadowMap) return this;
        if (!this._shadowMap.renderList) this._shadowMap.renderList = [];
        if (this._shadowMap.renderList.indexOf(mesh) === -1) this._shadowMap.renderList.push(mesh);
        if (includeDescendants) {
            for (const childMesh of mesh.getChildMeshes())if (this._shadowMap.renderList.indexOf(childMesh) === -1) this._shadowMap.renderList.push(childMesh);
        }
        return this;
    }
    /**
     * Helper function to remove a mesh and its descendants from the list of shadow casters
     * @param mesh Mesh to remove
     * @param includeDescendants boolean indicating if the descendants should be removed. Default to true
     * @returns the Shadow Generator itself
     */ removeShadowCaster(mesh, includeDescendants = true) {
        if (!this._shadowMap || !this._shadowMap.renderList) return this;
        const index = this._shadowMap.renderList.indexOf(mesh);
        if (index !== -1) this._shadowMap.renderList.splice(index, 1);
        if (includeDescendants) for (const child of mesh.getChildren())this.removeShadowCaster(child);
        return this;
    }
    /**
     * Returns the associated light object.
     * @returns the light generating the shadow
     */ getLight() {
        return this._light;
    }
    _getCamera() {
        return this._camera ?? this._scene.activeCamera;
    }
    /**
     * Gets or sets the size of the texture what stores the shadows
     */ get mapSize() {
        return this._mapSize;
    }
    set mapSize(size) {
        this._mapSize = size;
        this._light._markMeshesAsLightDirty();
        this.recreateShadowMap();
    }
    /**
     * Creates a ShadowGenerator object.
     * A ShadowGenerator is the required tool to use the shadows.
     * Each light casting shadows needs to use its own ShadowGenerator.
     * Documentation : https://doc.babylonjs.com/features/featuresDeepDive/lights/shadows
     * @param mapSize The size of the texture what stores the shadows. Example : 1024.
     * @param light The light object generating the shadows.
     * @param usefullFloatFirst By default the generator will try to use half float textures but if you need precision (for self shadowing for instance), you can use this option to enforce full float texture.
     * @param camera Camera associated with this shadow generator (default: null). If null, takes the scene active camera at the time we need to access it
     * @param useRedTextureType Forces the generator to use a Red instead of a RGBA type for the shadow map texture format (default: false)
     */ constructor(mapSize, light, usefullFloatFirst, camera, useRedTextureType){
        /**
         * Observable triggered before the shadow is rendered. Can be used to update internal effect state
         */ this.onBeforeShadowMapRenderObservable = new (0, $diGQf.Observable)();
        /**
         * Observable triggered after the shadow is rendered. Can be used to restore internal effect state
         */ this.onAfterShadowMapRenderObservable = new (0, $diGQf.Observable)();
        /**
         * Observable triggered before a mesh is rendered in the shadow map.
         * Can be used to update internal effect state (that you can get from the onBeforeShadowMapRenderObservable)
         */ this.onBeforeShadowMapRenderMeshObservable = new (0, $diGQf.Observable)();
        /**
         * Observable triggered after a mesh is rendered in the shadow map.
         * Can be used to update internal effect state (that you can get from the onAfterShadowMapRenderObservable)
         */ this.onAfterShadowMapRenderMeshObservable = new (0, $diGQf.Observable)();
        this._bias = 0.00005;
        this._normalBias = 0;
        this._blurBoxOffset = 1;
        this._blurScale = 2;
        this._blurKernel = 1;
        this._useKernelBlur = false;
        this._filter = $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_NONE;
        this._filteringQuality = $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.QUALITY_HIGH;
        this._contactHardeningLightSizeUVRatio = 0.1;
        this._darkness = 0;
        this._transparencyShadow = false;
        /**
         * Enables or disables shadows with varying strength based on the transparency
         * When it is enabled, the strength of the shadow is taken equal to mesh.visibility
         * If you enabled an alpha texture on your material, the alpha value red from the texture is also combined to compute the strength:
         *          mesh.visibility * alphaTexture.a
         * The texture used is the diffuse by default, but it can be set to the opacity by setting useOpacityTextureForTransparentShadow
         * Note that by definition transparencyShadow must be set to true for enableSoftTransparentShadow to work!
         */ this.enableSoftTransparentShadow = false;
        /**
         * If this is true, use the opacity texture's alpha channel for transparent shadows instead of the diffuse one
         */ this.useOpacityTextureForTransparentShadow = false;
        /**
         * Controls the extent to which the shadows fade out at the edge of the frustum
         */ this.frustumEdgeFalloff = 0;
        /**
         * If true the shadow map is generated by rendering the back face of the mesh instead of the front face.
         * This can help with self-shadowing as the geometry making up the back of objects is slightly offset.
         * It might on the other hand introduce peter panning.
         */ this.forceBackFacesOnly = false;
        this._lightDirection = (0, $ha1VO.Vector3).Zero();
        this._viewMatrix = (0, $ha1VO.Matrix).Zero();
        this._projectionMatrix = (0, $ha1VO.Matrix).Zero();
        this._transformMatrix = (0, $ha1VO.Matrix).Zero();
        this._cachedPosition = new (0, $ha1VO.Vector3)(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
        this._cachedDirection = new (0, $ha1VO.Vector3)(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
        this._currentFaceIndex = 0;
        this._currentFaceIndexCache = 0;
        this._defaultTextureMatrix = (0, $ha1VO.Matrix).Identity();
        this._mapSize = mapSize;
        this._light = light;
        this._scene = light.getScene();
        this._camera = camera ?? null;
        this._useRedTextureType = !!useRedTextureType;
        let shadowGenerators = light._shadowGenerators;
        if (!shadowGenerators) shadowGenerators = light._shadowGenerators = new Map();
        shadowGenerators.set(this._camera, this);
        this.id = light.id;
        this._useUBO = this._scene.getEngine().supportsUniformBuffers;
        if (this._useUBO) {
            this._sceneUBOs = [];
            this._sceneUBOs.push(this._scene.createSceneUniformBuffer(`Scene for Shadow Generator (light "${this._light.name}")`));
        }
        $d72440a6bcb638ba$export$17b5c8c0ade7fd9e._SceneComponentInitialization(this._scene);
        // Texture type fallback from float to int if not supported.
        const caps = this._scene.getEngine().getCaps();
        if (!usefullFloatFirst) {
            if (caps.textureHalfFloatRender && caps.textureHalfFloatLinearFiltering) this._textureType = 2;
            else if (caps.textureFloatRender && caps.textureFloatLinearFiltering) this._textureType = 1;
            else this._textureType = 0;
        } else {
            if (caps.textureFloatRender && caps.textureFloatLinearFiltering) this._textureType = 1;
            else if (caps.textureHalfFloatRender && caps.textureHalfFloatLinearFiltering) this._textureType = 2;
            else this._textureType = 0;
        }
        this._initializeGenerator();
        this._applyFilterValues();
    }
    _initializeGenerator() {
        this._light._markMeshesAsLightDirty();
        this._initializeShadowMap();
    }
    _createTargetRenderTexture() {
        const engine = this._scene.getEngine();
        if (engine._features.supportDepthStencilTexture) {
            this._shadowMap = new (0, $gQtNK.RenderTargetTexture)(this._light.name + "_shadowMap", this._mapSize, this._scene, false, true, this._textureType, this._light.needCube(), undefined, false, false, undefined, this._useRedTextureType ? 6 : 5);
            this._shadowMap.createDepthStencilTexture(engine.useReverseDepthBuffer ? 516 : 513, true);
        } else this._shadowMap = new (0, $gQtNK.RenderTargetTexture)(this._light.name + "_shadowMap", this._mapSize, this._scene, false, true, this._textureType, this._light.needCube());
        this._shadowMap.noPrePassRenderer = true;
    }
    _initializeShadowMap() {
        this._createTargetRenderTexture();
        if (this._shadowMap === null) return;
        this._shadowMap.wrapU = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        this._shadowMap.wrapV = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        this._shadowMap.anisotropicFilteringLevel = 1;
        this._shadowMap.updateSamplingMode((0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE);
        this._shadowMap.renderParticles = false;
        this._shadowMap.ignoreCameraViewport = true;
        if (this._storedUniqueId) this._shadowMap.uniqueId = this._storedUniqueId;
        // Custom render function.
        this._shadowMap.customRenderFunction = (opaqueSubMeshes, alphaTestSubMeshes, transparentSubMeshes, depthOnlySubMeshes)=>this._renderForShadowMap(opaqueSubMeshes, alphaTestSubMeshes, transparentSubMeshes, depthOnlySubMeshes);
        // Force the mesh is ready function to true as we are double checking it
        // in the custom render function. Also it prevents side effects and useless
        // shader variations in DEPTHPREPASS mode.
        this._shadowMap.customIsReadyFunction = ()=>{
            return true;
        };
        const engine = this._scene.getEngine();
        this._shadowMap.onBeforeBindObservable.add(()=>{
            this._currentSceneUBO = this._scene.getSceneUniformBuffer();
            engine._debugPushGroup?.(`shadow map generation for pass id ${engine.currentRenderPassId}`, 1);
        });
        // Record Face Index before render.
        this._shadowMap.onBeforeRenderObservable.add((faceIndex)=>{
            if (this._sceneUBOs) this._scene.setSceneUniformBuffer(this._sceneUBOs[0]);
            this._currentFaceIndex = faceIndex;
            if (this._filter === $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_PCF) engine.setColorWrite(false);
            this.getTransformMatrix(); // generate the view/projection matrix
            this._scene.setTransformMatrix(this._viewMatrix, this._projectionMatrix);
            if (this._useUBO) {
                this._scene.getSceneUniformBuffer().unbindEffect();
                this._scene.finalizeSceneUbo();
            }
        });
        // Blur if required after render.
        this._shadowMap.onAfterUnbindObservable.add(()=>{
            if (this._sceneUBOs) this._scene.setSceneUniformBuffer(this._currentSceneUBO);
            this._scene.updateTransformMatrix(); // restore the view/projection matrices of the active camera
            if (this._filter === $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_PCF) engine.setColorWrite(true);
            if (!this.useBlurExponentialShadowMap && !this.useBlurCloseExponentialShadowMap) {
                engine._debugPopGroup?.(1);
                return;
            }
            const shadowMap = this.getShadowMapForRendering();
            if (shadowMap) {
                this._scene.postProcessManager.directRender(this._blurPostProcesses, shadowMap.renderTarget, true);
                engine.unBindFramebuffer(shadowMap.renderTarget, true);
                engine._debugPopGroup?.(1);
            }
        });
        // Clear according to the chosen filter.
        const clearZero = new (0, $7etnY.Color4)(0, 0, 0, 0);
        const clearOne = new (0, $7etnY.Color4)(1.0, 1.0, 1.0, 1.0);
        this._shadowMap.onClearObservable.add((engine)=>{
            if (this._filter === $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_PCF) engine.clear(clearOne, false, true, false);
            else if (this.useExponentialShadowMap || this.useBlurExponentialShadowMap) engine.clear(clearZero, true, true, false);
            else engine.clear(clearOne, true, true, false);
        });
        // Recreate on resize.
        this._shadowMap.onResizeObservable.add((rtt)=>{
            this._storedUniqueId = this._shadowMap.uniqueId;
            this._mapSize = rtt.getRenderSize();
            this._light._markMeshesAsLightDirty();
            this.recreateShadowMap();
        });
        // Ensures rendering groupids do not erase the depth buffer
        // or we would lose the shadows information.
        for(let i = (0, $jJNg8.RenderingManager).MIN_RENDERINGGROUPS; i < (0, $jJNg8.RenderingManager).MAX_RENDERINGGROUPS; i++)this._shadowMap.setRenderingAutoClearDepthStencil(i, false);
    }
    _initializeBlurRTTAndPostProcesses() {
        const engine = this._scene.getEngine();
        const targetSize = this._mapSize / this.blurScale;
        if (!this.useKernelBlur || this.blurScale !== 1.0) {
            this._shadowMap2 = new (0, $gQtNK.RenderTargetTexture)(this._light.name + "_shadowMap2", targetSize, this._scene, false, true, this._textureType, undefined, undefined, false);
            this._shadowMap2.wrapU = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
            this._shadowMap2.wrapV = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
            this._shadowMap2.updateSamplingMode((0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE);
        }
        if (this.useKernelBlur) {
            this._kernelBlurXPostprocess = new (0, $8zEq7.BlurPostProcess)(this._light.name + "KernelBlurX", new (0, $ha1VO.Vector2)(1, 0), this.blurKernel, 1.0, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, engine, false, this._textureType);
            this._kernelBlurXPostprocess.width = targetSize;
            this._kernelBlurXPostprocess.height = targetSize;
            this._kernelBlurXPostprocess.externalTextureSamplerBinding = true;
            this._kernelBlurXPostprocess.onApplyObservable.add((effect)=>{
                effect.setTexture("textureSampler", this._shadowMap);
            });
            this._kernelBlurYPostprocess = new (0, $8zEq7.BlurPostProcess)(this._light.name + "KernelBlurY", new (0, $ha1VO.Vector2)(0, 1), this.blurKernel, 1.0, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, engine, false, this._textureType);
            this._kernelBlurXPostprocess.autoClear = false;
            this._kernelBlurYPostprocess.autoClear = false;
            if (this._textureType === 0) {
                this._kernelBlurXPostprocess.packedFloat = true;
                this._kernelBlurYPostprocess.packedFloat = true;
            }
            this._blurPostProcesses = [
                this._kernelBlurXPostprocess,
                this._kernelBlurYPostprocess
            ];
        } else {
            this._boxBlurPostprocess = new (0, $cFdBb.PostProcess)(this._light.name + "DepthBoxBlur", "depthBoxBlur", [
                "screenSize",
                "boxOffset"
            ], [], 1.0, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, engine, false, "#define OFFSET " + this._blurBoxOffset, this._textureType);
            this._boxBlurPostprocess.externalTextureSamplerBinding = true;
            this._boxBlurPostprocess.onApplyObservable.add((effect)=>{
                effect.setFloat2("screenSize", targetSize, targetSize);
                effect.setTexture("textureSampler", this._shadowMap);
            });
            this._boxBlurPostprocess.autoClear = false;
            this._blurPostProcesses = [
                this._boxBlurPostprocess
            ];
        }
    }
    _renderForShadowMap(opaqueSubMeshes, alphaTestSubMeshes, transparentSubMeshes, depthOnlySubMeshes) {
        let index;
        if (depthOnlySubMeshes.length) for(index = 0; index < depthOnlySubMeshes.length; index++)this._renderSubMeshForShadowMap(depthOnlySubMeshes.data[index]);
        for(index = 0; index < opaqueSubMeshes.length; index++)this._renderSubMeshForShadowMap(opaqueSubMeshes.data[index]);
        for(index = 0; index < alphaTestSubMeshes.length; index++)this._renderSubMeshForShadowMap(alphaTestSubMeshes.data[index]);
        if (this._transparencyShadow) for(index = 0; index < transparentSubMeshes.length; index++)this._renderSubMeshForShadowMap(transparentSubMeshes.data[index], true);
        else for(index = 0; index < transparentSubMeshes.length; index++)transparentSubMeshes.data[index].getEffectiveMesh()._internalAbstractMeshDataInfo._isActiveIntermediate = false;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _bindCustomEffectForRenderSubMeshForShadowMap(subMesh, effect, mesh) {
        effect.setMatrix("viewProjection", this.getTransformMatrix());
    }
    _renderSubMeshForShadowMap(subMesh, isTransparent = false) {
        const renderingMesh = subMesh.getRenderingMesh();
        const effectiveMesh = subMesh.getEffectiveMesh();
        const scene = this._scene;
        const engine = scene.getEngine();
        const material = subMesh.getMaterial();
        effectiveMesh._internalAbstractMeshDataInfo._isActiveIntermediate = false;
        if (!material || subMesh.verticesCount === 0 || subMesh._renderId === scene.getRenderId()) return;
        // Culling
        const detNeg = effectiveMesh._getWorldMatrixDeterminant() < 0;
        let sideOrientation = renderingMesh.overrideMaterialSideOrientation ?? material.sideOrientation;
        if (detNeg) sideOrientation = sideOrientation === 0 ? 1 : 0;
        const reverseSideOrientation = sideOrientation === 0;
        engine.setState(material.backFaceCulling, undefined, undefined, reverseSideOrientation, material.cullBackFaces);
        // Managing instances
        const batch = renderingMesh._getInstancesRenderList(subMesh._id, !!subMesh.getReplacementMesh());
        if (batch.mustReturn) return;
        const hardwareInstancedRendering = engine.getCaps().instancedArrays && (batch.visibleInstances[subMesh._id] !== null && batch.visibleInstances[subMesh._id] !== undefined || renderingMesh.hasThinInstances);
        if (this.customAllowRendering && !this.customAllowRendering(subMesh)) return;
        if (this.isReady(subMesh, hardwareInstancedRendering, isTransparent)) {
            subMesh._renderId = scene.getRenderId();
            const shadowDepthWrapper = material.shadowDepthWrapper;
            const drawWrapper = shadowDepthWrapper?.getEffect(subMesh, this, engine.currentRenderPassId) ?? subMesh._getDrawWrapper();
            const effect = (0, $hOyoX.DrawWrapper).GetEffect(drawWrapper);
            engine.enableEffect(drawWrapper);
            if (!hardwareInstancedRendering) renderingMesh._bind(subMesh, effect, material.fillMode);
            this.getTransformMatrix(); // make sure _cachedDirection et _cachedPosition are up to date
            effect.setFloat3("biasAndScaleSM", this.bias, this.normalBias, this.depthScale);
            if (this.getLight().getTypeID() === (0, $c6YWJ.Light).LIGHTTYPEID_DIRECTIONALLIGHT) effect.setVector3("lightDataSM", this._cachedDirection);
            else effect.setVector3("lightDataSM", this._cachedPosition);
            const camera = this._getCamera();
            if (camera) effect.setFloat2("depthValuesSM", this.getLight().getDepthMinZ(camera), this.getLight().getDepthMinZ(camera) + this.getLight().getDepthMaxZ(camera));
            if (isTransparent && this.enableSoftTransparentShadow) effect.setFloat("softTransparentShadowSM", effectiveMesh.visibility * material.alpha);
            if (shadowDepthWrapper) {
                subMesh._setMainDrawWrapperOverride(drawWrapper);
                if (shadowDepthWrapper.standalone) shadowDepthWrapper.baseMaterial.bindForSubMesh(effectiveMesh.getWorldMatrix(), renderingMesh, subMesh);
                else material.bindForSubMesh(effectiveMesh.getWorldMatrix(), renderingMesh, subMesh);
                subMesh._setMainDrawWrapperOverride(null);
            } else {
                // Alpha test
                if (this._opacityTexture) {
                    effect.setTexture("diffuseSampler", this._opacityTexture);
                    effect.setMatrix("diffuseMatrix", this._opacityTexture.getTextureMatrix() || this._defaultTextureMatrix);
                }
                // Bones
                if (renderingMesh.useBones && renderingMesh.computeBonesUsingShaders && renderingMesh.skeleton) {
                    const skeleton = renderingMesh.skeleton;
                    if (skeleton.isUsingTextureForMatrices) {
                        const boneTexture = skeleton.getTransformMatrixTexture(renderingMesh);
                        if (!boneTexture) return;
                        effect.setTexture("boneSampler", boneTexture);
                        effect.setFloat("boneTextureWidth", 4.0 * (skeleton.bones.length + 1));
                    } else effect.setMatrices("mBones", skeleton.getTransformMatrices(renderingMesh));
                }
                // Morph targets
                (0, $alPCh.BindMorphTargetParameters)(renderingMesh, effect);
                if (renderingMesh.morphTargetManager && renderingMesh.morphTargetManager.isUsingTextureForTargets) renderingMesh.morphTargetManager._bind(effect);
                // Clip planes
                (0, $aAFeM.bindClipPlane)(effect, material, scene);
            }
            if (!this._useUBO && !shadowDepthWrapper) this._bindCustomEffectForRenderSubMeshForShadowMap(subMesh, effect, effectiveMesh);
            (0, $alPCh.BindSceneUniformBuffer)(effect, this._scene.getSceneUniformBuffer());
            this._scene.getSceneUniformBuffer().bindUniformBuffer();
            const world = effectiveMesh.getWorldMatrix();
            // In the non hardware instanced mode, the Mesh ubo update is done by the callback passed to renderingMesh._processRendering (see below)
            if (hardwareInstancedRendering) {
                effectiveMesh.getMeshUniformBuffer().bindToEffect(effect, "Mesh");
                effectiveMesh.transferToEffect(world);
            }
            if (this.forceBackFacesOnly) engine.setState(true, 0, false, true, material.cullBackFaces);
            // Observables
            this.onBeforeShadowMapRenderMeshObservable.notifyObservers(renderingMesh);
            this.onBeforeShadowMapRenderObservable.notifyObservers(effect);
            // Draw
            renderingMesh._processRendering(effectiveMesh, subMesh, effect, material.fillMode, batch, hardwareInstancedRendering, (isInstance, worldOverride)=>{
                if (effectiveMesh !== renderingMesh && !isInstance) {
                    renderingMesh.getMeshUniformBuffer().bindToEffect(effect, "Mesh");
                    renderingMesh.transferToEffect(worldOverride);
                } else {
                    effectiveMesh.getMeshUniformBuffer().bindToEffect(effect, "Mesh");
                    effectiveMesh.transferToEffect(isInstance ? worldOverride : world);
                }
            });
            if (this.forceBackFacesOnly) engine.setState(true, 0, false, false, material.cullBackFaces);
            // Observables
            this.onAfterShadowMapRenderObservable.notifyObservers(effect);
            this.onAfterShadowMapRenderMeshObservable.notifyObservers(renderingMesh);
        } else // Need to reset refresh rate of the shadowMap
        if (this._shadowMap) this._shadowMap.resetRefreshCounter();
    }
    _applyFilterValues() {
        if (!this._shadowMap) return;
        if (this.filter === $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_NONE || this.filter === $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_PCSS) this._shadowMap.updateSamplingMode((0, $j2mX5.Texture).NEAREST_SAMPLINGMODE);
        else this._shadowMap.updateSamplingMode((0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE);
    }
    /**
     * Forces all the attached effect to compile to enable rendering only once ready vs. lazily compiling effects.
     * @param onCompiled Callback triggered at the and of the effects compilation
     * @param options Sets of optional options forcing the compilation with different modes
     */ forceCompilation(onCompiled, options) {
        const localOptions = {
            useInstances: false,
            ...options
        };
        const shadowMap = this.getShadowMap();
        if (!shadowMap) {
            if (onCompiled) onCompiled(this);
            return;
        }
        const renderList = shadowMap.renderList;
        if (!renderList) {
            if (onCompiled) onCompiled(this);
            return;
        }
        const subMeshes = [];
        for (const mesh of renderList)subMeshes.push(...mesh.subMeshes);
        if (subMeshes.length === 0) {
            if (onCompiled) onCompiled(this);
            return;
        }
        let currentIndex = 0;
        const checkReady = ()=>{
            if (!this._scene || !this._scene.getEngine()) return;
            while(this.isReady(subMeshes[currentIndex], localOptions.useInstances, subMeshes[currentIndex].getMaterial()?.needAlphaBlendingForMesh(subMeshes[currentIndex].getMesh()) ?? false)){
                currentIndex++;
                if (currentIndex >= subMeshes.length) {
                    if (onCompiled) onCompiled(this);
                    return;
                }
            }
            setTimeout(checkReady, 16);
        };
        checkReady();
    }
    /**
     * Forces all the attached effect to compile to enable rendering only once ready vs. lazily compiling effects.
     * @param options Sets of optional options forcing the compilation with different modes
     * @returns A promise that resolves when the compilation completes
     */ forceCompilationAsync(options) {
        return new Promise((resolve)=>{
            this.forceCompilation(()=>{
                resolve();
            }, options);
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _isReadyCustomDefines(defines, subMesh, useInstances) {}
    _prepareShadowDefines(subMesh, useInstances, defines, isTransparent) {
        defines.push("#define SM_LIGHTTYPE_" + this._light.getClassName().toUpperCase());
        defines.push("#define SM_FLOAT " + (this._textureType !== 0 ? "1" : "0"));
        defines.push("#define SM_ESM " + (this.useExponentialShadowMap || this.useBlurExponentialShadowMap ? "1" : "0"));
        defines.push("#define SM_DEPTHTEXTURE " + (this.usePercentageCloserFiltering || this.useContactHardeningShadow ? "1" : "0"));
        const mesh = subMesh.getMesh();
        // Normal bias.
        defines.push("#define SM_NORMALBIAS " + (this.normalBias && mesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).NormalKind) ? "1" : "0"));
        defines.push("#define SM_DIRECTIONINLIGHTDATA " + (this.getLight().getTypeID() === (0, $c6YWJ.Light).LIGHTTYPEID_DIRECTIONALLIGHT ? "1" : "0"));
        // Point light
        defines.push("#define SM_USEDISTANCE " + (this._light.needCube() ? "1" : "0"));
        // Soft transparent shadows
        defines.push("#define SM_SOFTTRANSPARENTSHADOW " + (this.enableSoftTransparentShadow && isTransparent ? "1" : "0"));
        this._isReadyCustomDefines(defines, subMesh, useInstances);
        return defines;
    }
    /**
     * Determine whether the shadow generator is ready or not (mainly all effects and related post processes needs to be ready).
     * @param subMesh The submesh we want to render in the shadow map
     * @param useInstances Defines whether will draw in the map using instances
     * @param isTransparent Indicates that isReady is called for a transparent subMesh
     * @returns true if ready otherwise, false
     */ isReady(subMesh, useInstances, isTransparent) {
        const material = subMesh.getMaterial(), shadowDepthWrapper = material?.shadowDepthWrapper;
        this._opacityTexture = null;
        if (!material) return false;
        const defines = [];
        this._prepareShadowDefines(subMesh, useInstances, defines, isTransparent);
        if (shadowDepthWrapper) {
            if (!shadowDepthWrapper.isReadyForSubMesh(subMesh, defines, this, useInstances, this._scene.getEngine().currentRenderPassId)) return false;
        } else {
            const subMeshEffect = subMesh._getDrawWrapper(undefined, true);
            let effect = subMeshEffect.effect;
            let cachedDefines = subMeshEffect.defines;
            const attribs = [
                (0, $b4i1f.VertexBuffer).PositionKind
            ];
            const mesh = subMesh.getMesh();
            // Normal bias.
            if (this.normalBias && mesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).NormalKind)) {
                attribs.push((0, $b4i1f.VertexBuffer).NormalKind);
                defines.push("#define NORMAL");
                if (mesh.nonUniformScaling) defines.push("#define NONUNIFORMSCALING");
            }
            // Alpha test
            const needAlphaTesting = material.needAlphaTesting();
            if (needAlphaTesting || material.needAlphaBlending()) {
                if (this.useOpacityTextureForTransparentShadow) this._opacityTexture = material.opacityTexture;
                else this._opacityTexture = material.getAlphaTestTexture();
                if (this._opacityTexture) {
                    if (!this._opacityTexture.isReady()) return false;
                    const alphaCutOff = material.alphaCutOff ?? $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.DEFAULT_ALPHA_CUTOFF;
                    defines.push("#define ALPHATEXTURE");
                    if (needAlphaTesting) defines.push(`#define ALPHATESTVALUE ${alphaCutOff}${alphaCutOff % 1 === 0 ? "." : ""}`);
                    if (mesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UVKind)) {
                        attribs.push((0, $b4i1f.VertexBuffer).UVKind);
                        defines.push("#define UV1");
                    }
                    if (mesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UV2Kind)) {
                        if (this._opacityTexture.coordinatesIndex === 1) {
                            attribs.push((0, $b4i1f.VertexBuffer).UV2Kind);
                            defines.push("#define UV2");
                        }
                    }
                }
            }
            // Bones
            const fallbacks = new (0, $gc8Ja.EffectFallbacks)();
            if (mesh.useBones && mesh.computeBonesUsingShaders && mesh.skeleton) {
                attribs.push((0, $b4i1f.VertexBuffer).MatricesIndicesKind);
                attribs.push((0, $b4i1f.VertexBuffer).MatricesWeightsKind);
                if (mesh.numBoneInfluencers > 4) {
                    attribs.push((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind);
                    attribs.push((0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind);
                }
                const skeleton = mesh.skeleton;
                defines.push("#define NUM_BONE_INFLUENCERS " + mesh.numBoneInfluencers);
                if (mesh.numBoneInfluencers > 0) fallbacks.addCPUSkinningFallback(0, mesh);
                if (skeleton.isUsingTextureForMatrices) defines.push("#define BONETEXTURE");
                else defines.push("#define BonesPerMesh " + (skeleton.bones.length + 1));
            } else defines.push("#define NUM_BONE_INFLUENCERS 0");
            // Morph targets
            const manager = mesh.morphTargetManager;
            let morphInfluencers = 0;
            if (manager) {
                morphInfluencers = manager.numMaxInfluencers || manager.numInfluencers;
                if (morphInfluencers > 0) {
                    defines.push("#define MORPHTARGETS");
                    defines.push("#define NUM_MORPH_INFLUENCERS " + morphInfluencers);
                    if (manager.isUsingTextureForTargets) defines.push("#define MORPHTARGETS_TEXTURE");
                    (0, $alPCh.PrepareAttributesForMorphTargetsInfluencers)(attribs, mesh, morphInfluencers);
                }
            }
            // ClipPlanes
            (0, $aAFeM.prepareStringDefinesForClipPlanes)(material, this._scene, defines);
            // Instances
            if (useInstances) {
                defines.push("#define INSTANCES");
                (0, $alPCh.PushAttributesForInstances)(attribs);
                if (subMesh.getRenderingMesh().hasThinInstances) defines.push("#define THIN_INSTANCES");
            }
            if (this.customShaderOptions) {
                if (this.customShaderOptions.defines) {
                    for (const define of this.customShaderOptions.defines)if (defines.indexOf(define) === -1) defines.push(define);
                }
            }
            // Get correct effect
            const join = defines.join("\n");
            if (cachedDefines !== join) {
                cachedDefines = join;
                let shaderName = "shadowMap";
                const uniforms = [
                    "world",
                    "mBones",
                    "viewProjection",
                    "diffuseMatrix",
                    "lightDataSM",
                    "depthValuesSM",
                    "biasAndScaleSM",
                    "morphTargetInfluences",
                    "morphTargetCount",
                    "boneTextureWidth",
                    "softTransparentShadowSM",
                    "morphTargetTextureInfo",
                    "morphTargetTextureIndices"
                ];
                const samplers = [
                    "diffuseSampler",
                    "boneSampler",
                    "morphTargets"
                ];
                const uniformBuffers = [
                    "Scene",
                    "Mesh"
                ];
                (0, $aAFeM.addClipPlaneUniforms)(uniforms);
                // Custom shader?
                if (this.customShaderOptions) {
                    shaderName = this.customShaderOptions.shaderName;
                    if (this.customShaderOptions.attributes) {
                        for (const attrib of this.customShaderOptions.attributes)if (attribs.indexOf(attrib) === -1) attribs.push(attrib);
                    }
                    if (this.customShaderOptions.uniforms) {
                        for (const uniform of this.customShaderOptions.uniforms)if (uniforms.indexOf(uniform) === -1) uniforms.push(uniform);
                    }
                    if (this.customShaderOptions.samplers) {
                        for (const sampler of this.customShaderOptions.samplers)if (samplers.indexOf(sampler) === -1) samplers.push(sampler);
                    }
                }
                const engine = this._scene.getEngine();
                effect = engine.createEffect(shaderName, {
                    attributes: attribs,
                    uniformsNames: uniforms,
                    uniformBuffersNames: uniformBuffers,
                    samplers: samplers,
                    defines: join,
                    fallbacks: fallbacks,
                    onCompiled: null,
                    onError: null,
                    indexParameters: {
                        maxSimultaneousMorphTargets: morphInfluencers
                    }
                }, engine);
                subMeshEffect.setEffect(effect, cachedDefines);
            }
            if (!effect.isReady()) return false;
        }
        if (this.useBlurExponentialShadowMap || this.useBlurCloseExponentialShadowMap) {
            if (!this._blurPostProcesses || !this._blurPostProcesses.length) this._initializeBlurRTTAndPostProcesses();
        }
        if (this._kernelBlurXPostprocess && !this._kernelBlurXPostprocess.isReady()) return false;
        if (this._kernelBlurYPostprocess && !this._kernelBlurYPostprocess.isReady()) return false;
        if (this._boxBlurPostprocess && !this._boxBlurPostprocess.isReady()) return false;
        return true;
    }
    /**
     * Prepare all the defines in a material relying on a shadow map at the specified light index.
     * @param defines Defines of the material we want to update
     * @param lightIndex Index of the light in the enabled light list of the material
     */ prepareDefines(defines, lightIndex) {
        const scene = this._scene;
        const light = this._light;
        if (!scene.shadowsEnabled || !light.shadowEnabled) return;
        defines["SHADOW" + lightIndex] = true;
        if (this.useContactHardeningShadow) {
            defines["SHADOWPCSS" + lightIndex] = true;
            if (this._filteringQuality === $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.QUALITY_LOW) defines["SHADOWLOWQUALITY" + lightIndex] = true;
            else if (this._filteringQuality === $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.QUALITY_MEDIUM) defines["SHADOWMEDIUMQUALITY" + lightIndex] = true;
        // else default to high.
        } else if (this.usePercentageCloserFiltering) {
            defines["SHADOWPCF" + lightIndex] = true;
            if (this._filteringQuality === $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.QUALITY_LOW) defines["SHADOWLOWQUALITY" + lightIndex] = true;
            else if (this._filteringQuality === $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.QUALITY_MEDIUM) defines["SHADOWMEDIUMQUALITY" + lightIndex] = true;
        // else default to high.
        } else if (this.usePoissonSampling) defines["SHADOWPOISSON" + lightIndex] = true;
        else if (this.useExponentialShadowMap || this.useBlurExponentialShadowMap) defines["SHADOWESM" + lightIndex] = true;
        else if (this.useCloseExponentialShadowMap || this.useBlurCloseExponentialShadowMap) defines["SHADOWCLOSEESM" + lightIndex] = true;
        if (light.needCube()) defines["SHADOWCUBE" + lightIndex] = true;
    }
    /**
     * Binds the shadow related information inside of an effect (information like near, far, darkness...
     * defined in the generator but impacting the effect).
     * @param lightIndex Index of the light in the enabled light list of the material owning the effect
     * @param effect The effect we are binding the information for
     */ bindShadowLight(lightIndex, effect) {
        const light = this._light;
        const scene = this._scene;
        if (!scene.shadowsEnabled || !light.shadowEnabled) return;
        const camera = this._getCamera();
        if (!camera) return;
        const shadowMap = this.getShadowMap();
        if (!shadowMap) return;
        if (!light.needCube()) effect.setMatrix("lightMatrix" + lightIndex, this.getTransformMatrix());
        // Only PCF uses depth stencil texture.
        if (this._filter === $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_PCF) {
            effect.setDepthStencilTexture("shadowSampler" + lightIndex, this.getShadowMapForRendering());
            light._uniformBuffer.updateFloat4("shadowsInfo", this.getDarkness(), shadowMap.getSize().width, 1 / shadowMap.getSize().width, this.frustumEdgeFalloff, lightIndex);
        } else if (this._filter === $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_PCSS) {
            effect.setDepthStencilTexture("shadowSampler" + lightIndex, this.getShadowMapForRendering());
            effect.setTexture("depthSampler" + lightIndex, this.getShadowMapForRendering());
            light._uniformBuffer.updateFloat4("shadowsInfo", this.getDarkness(), 1 / shadowMap.getSize().width, this._contactHardeningLightSizeUVRatio * shadowMap.getSize().width, this.frustumEdgeFalloff, lightIndex);
        } else {
            effect.setTexture("shadowSampler" + lightIndex, this.getShadowMapForRendering());
            light._uniformBuffer.updateFloat4("shadowsInfo", this.getDarkness(), this.blurScale / shadowMap.getSize().width, this.depthScale, this.frustumEdgeFalloff, lightIndex);
        }
        light._uniformBuffer.updateFloat2("depthValues", this.getLight().getDepthMinZ(camera), this.getLight().getDepthMinZ(camera) + this.getLight().getDepthMaxZ(camera), lightIndex);
    }
    /**
     * Gets the view matrix used to render the shadow map.
     */ get viewMatrix() {
        return this._viewMatrix;
    }
    /**
     * Gets the projection matrix used to render the shadow map.
     */ get projectionMatrix() {
        return this._projectionMatrix;
    }
    /**
     * Gets the transformation matrix used to project the meshes into the map from the light point of view.
     * (eq to shadow projection matrix * light transform matrix)
     * @returns The transform matrix used to create the shadow map
     */ getTransformMatrix() {
        const scene = this._scene;
        if (this._currentRenderId === scene.getRenderId() && this._currentFaceIndexCache === this._currentFaceIndex) return this._transformMatrix;
        this._currentRenderId = scene.getRenderId();
        this._currentFaceIndexCache = this._currentFaceIndex;
        let lightPosition = this._light.position;
        if (this._light.computeTransformedInformation()) lightPosition = this._light.transformedPosition;
        (0, $ha1VO.Vector3).NormalizeToRef(this._light.getShadowDirection(this._currentFaceIndex), this._lightDirection);
        if (Math.abs((0, $ha1VO.Vector3).Dot(this._lightDirection, (0, $ha1VO.Vector3).Up())) === 1.0) this._lightDirection.z = 0.0000000000001; // Required to avoid perfectly perpendicular light
        if (this._light.needProjectionMatrixCompute() || !this._cachedPosition || !this._cachedDirection || !lightPosition.equals(this._cachedPosition) || !this._lightDirection.equals(this._cachedDirection)) {
            this._cachedPosition.copyFrom(lightPosition);
            this._cachedDirection.copyFrom(this._lightDirection);
            (0, $ha1VO.Matrix).LookAtLHToRef(lightPosition, lightPosition.add(this._lightDirection), (0, $ha1VO.Vector3).Up(), this._viewMatrix);
            const shadowMap = this.getShadowMap();
            if (shadowMap) {
                const renderList = shadowMap.renderList;
                if (renderList) this._light.setShadowProjectionMatrix(this._projectionMatrix, this._viewMatrix, renderList);
            }
            this._viewMatrix.multiplyToRef(this._projectionMatrix, this._transformMatrix);
        }
        return this._transformMatrix;
    }
    /**
     * Recreates the shadow map dependencies like RTT and post processes. This can be used during the switch between
     * Cube and 2D textures for instance.
     */ recreateShadowMap() {
        const shadowMap = this._shadowMap;
        if (!shadowMap) return;
        // Track render list.
        const renderList = shadowMap.renderList;
        // Clean up existing data.
        this._disposeRTTandPostProcesses();
        // Reinitializes.
        this._initializeGenerator();
        // Reaffect the filter to ensure a correct fallback if necessary.
        this.filter = this._filter;
        // Reaffect the filter.
        this._applyFilterValues();
        // Reaffect Render List.
        if (renderList) {
            // Note: don't do this._shadowMap!.renderList = renderList;
            // The renderList hooked array is accessing the old RenderTargetTexture (see RenderTargetTexture._hookArray), which is disposed at this point (by the call to _disposeRTTandPostProcesses)
            if (!this._shadowMap.renderList) this._shadowMap.renderList = [];
            for (const mesh of renderList)this._shadowMap.renderList.push(mesh);
        } else this._shadowMap.renderList = null;
    }
    _disposeBlurPostProcesses() {
        if (this._shadowMap2) {
            this._shadowMap2.dispose();
            this._shadowMap2 = null;
        }
        if (this._boxBlurPostprocess) {
            this._boxBlurPostprocess.dispose();
            this._boxBlurPostprocess = null;
        }
        if (this._kernelBlurXPostprocess) {
            this._kernelBlurXPostprocess.dispose();
            this._kernelBlurXPostprocess = null;
        }
        if (this._kernelBlurYPostprocess) {
            this._kernelBlurYPostprocess.dispose();
            this._kernelBlurYPostprocess = null;
        }
        this._blurPostProcesses = [];
    }
    _disposeRTTandPostProcesses() {
        if (this._shadowMap) {
            this._shadowMap.dispose();
            this._shadowMap = null;
        }
        this._disposeBlurPostProcesses();
    }
    _disposeSceneUBOs() {
        if (this._sceneUBOs) {
            for (const ubo of this._sceneUBOs)ubo.dispose();
            this._sceneUBOs = [];
        }
    }
    /**
     * Disposes the ShadowGenerator.
     * Returns nothing.
     */ dispose() {
        this._disposeRTTandPostProcesses();
        this._disposeSceneUBOs();
        if (this._light) {
            if (this._light._shadowGenerators) {
                const iterator = this._light._shadowGenerators.entries();
                for(let entry = iterator.next(); entry.done !== true; entry = iterator.next()){
                    const [camera, shadowGenerator] = entry.value;
                    if (shadowGenerator === this) this._light._shadowGenerators.delete(camera);
                }
                if (this._light._shadowGenerators.size === 0) this._light._shadowGenerators = null;
            }
            this._light._markMeshesAsLightDirty();
        }
        this.onBeforeShadowMapRenderMeshObservable.clear();
        this.onBeforeShadowMapRenderObservable.clear();
        this.onAfterShadowMapRenderMeshObservable.clear();
        this.onAfterShadowMapRenderObservable.clear();
    }
    /**
     * Serializes the shadow generator setup to a json object.
     * @returns The serialized JSON object
     */ serialize() {
        const serializationObject = {};
        const shadowMap = this.getShadowMap();
        if (!shadowMap) return serializationObject;
        serializationObject.className = this.getClassName();
        serializationObject.lightId = this._light.id;
        serializationObject.cameraId = this._camera?.id;
        serializationObject.id = this.id;
        serializationObject.mapSize = shadowMap.getRenderSize();
        serializationObject.forceBackFacesOnly = this.forceBackFacesOnly;
        serializationObject.darkness = this.getDarkness();
        serializationObject.transparencyShadow = this._transparencyShadow;
        serializationObject.frustumEdgeFalloff = this.frustumEdgeFalloff;
        serializationObject.bias = this.bias;
        serializationObject.normalBias = this.normalBias;
        serializationObject.usePercentageCloserFiltering = this.usePercentageCloserFiltering;
        serializationObject.useContactHardeningShadow = this.useContactHardeningShadow;
        serializationObject.contactHardeningLightSizeUVRatio = this.contactHardeningLightSizeUVRatio;
        serializationObject.filteringQuality = this.filteringQuality;
        serializationObject.useExponentialShadowMap = this.useExponentialShadowMap;
        serializationObject.useBlurExponentialShadowMap = this.useBlurExponentialShadowMap;
        serializationObject.useCloseExponentialShadowMap = this.useBlurExponentialShadowMap;
        serializationObject.useBlurCloseExponentialShadowMap = this.useBlurExponentialShadowMap;
        serializationObject.usePoissonSampling = this.usePoissonSampling;
        serializationObject.depthScale = this.depthScale;
        serializationObject.blurBoxOffset = this.blurBoxOffset;
        serializationObject.blurKernel = this.blurKernel;
        serializationObject.blurScale = this.blurScale;
        serializationObject.useKernelBlur = this.useKernelBlur;
        serializationObject.renderList = [];
        if (shadowMap.renderList) for(let meshIndex = 0; meshIndex < shadowMap.renderList.length; meshIndex++){
            const mesh = shadowMap.renderList[meshIndex];
            serializationObject.renderList.push(mesh.id);
        }
        return serializationObject;
    }
    /**
     * Parses a serialized ShadowGenerator and returns a new ShadowGenerator.
     * @param parsedShadowGenerator The JSON object to parse
     * @param scene The scene to create the shadow map for
     * @param constr A function that builds a shadow generator or undefined to create an instance of the default shadow generator
     * @returns The parsed shadow generator
     */ static Parse(parsedShadowGenerator, scene, constr) {
        const light = scene.getLightById(parsedShadowGenerator.lightId);
        const camera = parsedShadowGenerator.cameraId !== undefined ? scene.getCameraById(parsedShadowGenerator.cameraId) : null;
        const shadowGenerator = constr ? constr(parsedShadowGenerator.mapSize, light, camera) : new $d72440a6bcb638ba$export$17b5c8c0ade7fd9e(parsedShadowGenerator.mapSize, light, undefined, camera);
        const shadowMap = shadowGenerator.getShadowMap();
        for(let meshIndex = 0; meshIndex < parsedShadowGenerator.renderList.length; meshIndex++){
            const meshes = scene.getMeshesById(parsedShadowGenerator.renderList[meshIndex]);
            meshes.forEach(function(mesh) {
                if (!shadowMap) return;
                if (!shadowMap.renderList) shadowMap.renderList = [];
                shadowMap.renderList.push(mesh);
            });
        }
        if (parsedShadowGenerator.id !== undefined) shadowGenerator.id = parsedShadowGenerator.id;
        shadowGenerator.forceBackFacesOnly = !!parsedShadowGenerator.forceBackFacesOnly;
        if (parsedShadowGenerator.darkness !== undefined) shadowGenerator.setDarkness(parsedShadowGenerator.darkness);
        if (parsedShadowGenerator.transparencyShadow) shadowGenerator.setTransparencyShadow(true);
        if (parsedShadowGenerator.frustumEdgeFalloff !== undefined) shadowGenerator.frustumEdgeFalloff = parsedShadowGenerator.frustumEdgeFalloff;
        if (parsedShadowGenerator.bias !== undefined) shadowGenerator.bias = parsedShadowGenerator.bias;
        if (parsedShadowGenerator.normalBias !== undefined) shadowGenerator.normalBias = parsedShadowGenerator.normalBias;
        if (parsedShadowGenerator.usePercentageCloserFiltering) shadowGenerator.usePercentageCloserFiltering = true;
        else if (parsedShadowGenerator.useContactHardeningShadow) shadowGenerator.useContactHardeningShadow = true;
        else if (parsedShadowGenerator.usePoissonSampling) shadowGenerator.usePoissonSampling = true;
        else if (parsedShadowGenerator.useExponentialShadowMap) shadowGenerator.useExponentialShadowMap = true;
        else if (parsedShadowGenerator.useBlurExponentialShadowMap) shadowGenerator.useBlurExponentialShadowMap = true;
        else if (parsedShadowGenerator.useCloseExponentialShadowMap) shadowGenerator.useCloseExponentialShadowMap = true;
        else if (parsedShadowGenerator.useBlurCloseExponentialShadowMap) shadowGenerator.useBlurCloseExponentialShadowMap = true;
        else if (parsedShadowGenerator.useVarianceShadowMap) shadowGenerator.useExponentialShadowMap = true;
        else if (parsedShadowGenerator.useBlurVarianceShadowMap) shadowGenerator.useBlurExponentialShadowMap = true;
        if (parsedShadowGenerator.contactHardeningLightSizeUVRatio !== undefined) shadowGenerator.contactHardeningLightSizeUVRatio = parsedShadowGenerator.contactHardeningLightSizeUVRatio;
        if (parsedShadowGenerator.filteringQuality !== undefined) shadowGenerator.filteringQuality = parsedShadowGenerator.filteringQuality;
        if (parsedShadowGenerator.depthScale) shadowGenerator.depthScale = parsedShadowGenerator.depthScale;
        if (parsedShadowGenerator.blurScale) shadowGenerator.blurScale = parsedShadowGenerator.blurScale;
        if (parsedShadowGenerator.blurBoxOffset) shadowGenerator.blurBoxOffset = parsedShadowGenerator.blurBoxOffset;
        if (parsedShadowGenerator.useKernelBlur) shadowGenerator.useKernelBlur = parsedShadowGenerator.useKernelBlur;
        if (parsedShadowGenerator.blurKernel) shadowGenerator.blurKernel = parsedShadowGenerator.blurKernel;
        return shadowGenerator;
    }
}
/**
 * Name of the shadow generator class
 */ $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.CLASSNAME = "ShadowGenerator";
/**
 * Shadow generator mode None: no filtering applied.
 */ $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_NONE = 0;
/**
 * Shadow generator mode ESM: Exponential Shadow Mapping.
 * (http://developer.download.nvidia.com/presentations/2008/GDC/GDC08_SoftShadowMapping.pdf)
 */ $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_EXPONENTIALSHADOWMAP = 1;
/**
 * Shadow generator mode Poisson Sampling: Percentage Closer Filtering.
 * (Multiple Tap around evenly distributed around the pixel are used to evaluate the shadow strength)
 */ $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_POISSONSAMPLING = 2;
/**
 * Shadow generator mode ESM: Blurred Exponential Shadow Mapping.
 * (http://developer.download.nvidia.com/presentations/2008/GDC/GDC08_SoftShadowMapping.pdf)
 */ $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_BLUREXPONENTIALSHADOWMAP = 3;
/**
 * Shadow generator mode ESM: Exponential Shadow Mapping using the inverse of the exponential preventing
 * edge artifacts on steep falloff.
 * (http://developer.download.nvidia.com/presentations/2008/GDC/GDC08_SoftShadowMapping.pdf)
 */ $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_CLOSEEXPONENTIALSHADOWMAP = 4;
/**
 * Shadow generator mode ESM: Blurred Exponential Shadow Mapping using the inverse of the exponential preventing
 * edge artifacts on steep falloff.
 * (http://developer.download.nvidia.com/presentations/2008/GDC/GDC08_SoftShadowMapping.pdf)
 */ $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_BLURCLOSEEXPONENTIALSHADOWMAP = 5;
/**
 * Shadow generator mode PCF: Percentage Closer Filtering
 * benefits from Webgl 2 shadow samplers. Fallback to Poisson Sampling in Webgl 1
 * (https://developer.nvidia.com/gpugems/GPUGems/gpugems_ch11.html)
 */ $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_PCF = 6;
/**
 * Shadow generator mode PCSS: Percentage Closering Soft Shadow.
 * benefits from Webgl 2 shadow samplers. Fallback to Poisson Sampling in Webgl 1
 * Contact Hardening
 */ $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.FILTER_PCSS = 7;
/**
 * Reserved for PCF and PCSS
 * Highest Quality.
 *
 * Execute PCF on a 5*5 kernel improving a lot the shadow aliasing artifacts.
 *
 * Execute PCSS with 32 taps blocker search and 64 taps PCF.
 */ $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.QUALITY_HIGH = 0;
/**
 * Reserved for PCF and PCSS
 * Good tradeoff for quality/perf cross devices
 *
 * Execute PCF on a 3*3 kernel.
 *
 * Execute PCSS with 16 taps blocker search and 32 taps PCF.
 */ $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.QUALITY_MEDIUM = 1;
/**
 * Reserved for PCF and PCSS
 * The lowest quality but the fastest.
 *
 * Execute PCF on a 1*1 kernel.
 *
 * Execute PCSS with 16 taps blocker search and 16 taps PCF.
 */ $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.QUALITY_LOW = 2;
/**
 * Defines the default alpha cutoff value used for transparent alpha tested materials.
 */ $d72440a6bcb638ba$export$17b5c8c0ade7fd9e.DEFAULT_ALPHA_CUTOFF = 0.5;
/**
 * @internal
 */ $d72440a6bcb638ba$export$17b5c8c0ade7fd9e._SceneComponentInitialization = (_)=>{
    throw (0, $dUFYy._WarnImport)("ShadowGeneratorSceneComponent");
};

});
parcelRegister("1DQzz", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("chwT2");
parcelRequire("82O8L");
parcelRequire("kg1CD");
parcelRequire("1w0pR");
const $132236cb723e7c11$var$name = "shadowMapPixelShader";
const $132236cb723e7c11$var$shader = `#include<shadowMapFragmentExtraDeclaration>
#ifdef ALPHATEXTURE
varying vec2 vUV;uniform sampler2D diffuseSampler;
#endif
#include<clipPlaneFragmentDeclaration>
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{
#include<clipPlaneFragment>
#ifdef ALPHATEXTURE
float alphaFromAlphaTexture=texture2D(diffuseSampler,vUV).a;
#ifdef ALPHATESTVALUE
if (alphaFromAlphaTexture<ALPHATESTVALUE)
discard;
#endif
#endif
#if SM_SOFTTRANSPARENTSHADOW==1
#ifdef ALPHATEXTURE
if ((bayerDither8(floor(mod(gl_FragCoord.xy,8.0))))/64.0>=softTransparentShadowSM*alphaFromAlphaTexture) discard;
#else
if ((bayerDither8(floor(mod(gl_FragCoord.xy,8.0))))/64.0>=softTransparentShadowSM) discard;
#endif
#endif
#include<shadowMapFragment>
}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$132236cb723e7c11$var$name] = $132236cb723e7c11$var$shader;
const $132236cb723e7c11$export$299089c3a396ac72 = {
    name: $132236cb723e7c11$var$name,
    shader: $132236cb723e7c11$var$shader
};

});
parcelRegister("chwT2", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("SJ1ad");
parcelRequire("6YyJQ");
const $8f10952a2842771c$var$name = "shadowMapFragmentExtraDeclaration";
const $8f10952a2842771c$var$shader = `#if SM_FLOAT==0
#include<packingFunctions>
#endif
#if SM_SOFTTRANSPARENTSHADOW==1
#include<bayerDitherFunctions>
uniform float softTransparentShadowSM;
#endif
varying float vDepthMetricSM;
#if SM_USEDISTANCE==1
uniform vec3 lightDataSM;varying vec3 vPositionWSM;
#endif
uniform vec3 biasAndScaleSM;uniform vec2 depthValuesSM;
#if defined(SM_DEPTHCLAMP) && SM_DEPTHCLAMP==1
varying float zSM;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$8f10952a2842771c$var$name] = $8f10952a2842771c$var$shader;
const $8f10952a2842771c$export$feed7cbe747b8e0c = {
    name: $8f10952a2842771c$var$name,
    shader: $8f10952a2842771c$var$shader
};

});
parcelRegister("6YyJQ", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $51434b04c0b6f4f0$var$name = "bayerDitherFunctions";
const $51434b04c0b6f4f0$var$shader = `float bayerDither2(vec2 _P) {return mod(2.0*_P.y+_P.x+1.0,4.0);}
float bayerDither4(vec2 _P) {vec2 P1=mod(_P,2.0); 
vec2 P2=floor(0.5*mod(_P,4.0)); 
return 4.0*bayerDither2(P1)+bayerDither2(P2);}
float bayerDither8(vec2 _P) {vec2 P1=mod(_P,2.0); 
vec2 P2=floor(0.5 *mod(_P,4.0)); 
vec2 P4=floor(0.25*mod(_P,8.0)); 
return 4.0*(4.0*bayerDither2(P1)+bayerDither2(P2))+bayerDither2(P4);}
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$51434b04c0b6f4f0$var$name] = $51434b04c0b6f4f0$var$shader;
const $51434b04c0b6f4f0$export$e0b3656857a3e5f2 = {
    name: $51434b04c0b6f4f0$var$name,
    shader: $51434b04c0b6f4f0$var$shader
};

});


parcelRegister("1w0pR", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $11a91a363468ad2d$var$name = "shadowMapFragment";
const $11a91a363468ad2d$var$shader = `float depthSM=vDepthMetricSM;
#if defined(SM_DEPTHCLAMP) && SM_DEPTHCLAMP==1
#if SM_USEDISTANCE==1
depthSM=(length(vPositionWSM-lightDataSM)+depthValuesSM.x)/depthValuesSM.y+biasAndScaleSM.x;
#else
#ifdef USE_REVERSE_DEPTHBUFFER
depthSM=(-zSM+depthValuesSM.x)/depthValuesSM.y+biasAndScaleSM.x;
#else
depthSM=(zSM+depthValuesSM.x)/depthValuesSM.y+biasAndScaleSM.x;
#endif
#endif
#ifdef USE_REVERSE_DEPTHBUFFER
gl_FragDepth=clamp(1.0-depthSM,0.0,1.0);
#else
gl_FragDepth=clamp(depthSM,0.0,1.0); 
#endif
#elif SM_USEDISTANCE==1
depthSM=(length(vPositionWSM-lightDataSM)+depthValuesSM.x)/depthValuesSM.y+biasAndScaleSM.x;
#endif
#if SM_ESM==1
depthSM=clamp(exp(-min(87.,biasAndScaleSM.z*depthSM)),0.,1.);
#endif
#if SM_FLOAT==1
gl_FragColor=vec4(depthSM,1.0,1.0,1.0);
#else
gl_FragColor=pack(depthSM);
#endif
return;`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$11a91a363468ad2d$var$name] = $11a91a363468ad2d$var$shader;
const $11a91a363468ad2d$export$fd70fe06bc582fe5 = {
    name: $11a91a363468ad2d$var$name,
    shader: $11a91a363468ad2d$var$shader
};

});


parcelRegister("340di", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("7PW7m");
parcelRequire("8kYMw");
parcelRequire("5Eb4I");
parcelRequire("9H5jp");
parcelRequire("7Hs3g");
parcelRequire("bdk1s");
parcelRequire("icZBk");
parcelRequire("5uRcV");
parcelRequire("4A4MM");
parcelRequire("9ulLS");
parcelRequire("LFrAO");
parcelRequire("apKdp");
parcelRequire("4idCt");
parcelRequire("cIweX");
parcelRequire("lq5Ji");
parcelRequire("cEQx6");
parcelRequire("kqCfW");
const $23b1e9398bfa5dad$var$name = "shadowMapVertexShader";
const $23b1e9398bfa5dad$var$shader = `attribute vec3 position;
#ifdef NORMAL
attribute vec3 normal;
#endif
#include<bonesDeclaration>
#include<bakedVertexAnimationDeclaration>
#include<morphTargetsVertexGlobalDeclaration>
#include<morphTargetsVertexDeclaration>[0..maxSimultaneousMorphTargets]
#ifdef INSTANCES
attribute vec4 world0;attribute vec4 world1;attribute vec4 world2;attribute vec4 world3;
#endif
#include<helperFunctions>
#include<__decl__shadowMapVertex>
#ifdef ALPHATEXTURE
varying vec2 vUV;uniform mat4 diffuseMatrix;
#ifdef UV1
attribute vec2 uv;
#endif
#ifdef UV2
attribute vec2 uv2;
#endif
#endif
#include<shadowMapVertexExtraDeclaration>
#include<clipPlaneVertexDeclaration>
#define CUSTOM_VERTEX_DEFINITIONS
void main(void)
{vec3 positionUpdated=position;
#ifdef UV1
vec2 uvUpdated=uv;
#endif
#ifdef NORMAL
vec3 normalUpdated=normal;
#endif
#include<morphTargetsVertexGlobal>
#include<morphTargetsVertex>[0..maxSimultaneousMorphTargets]
#include<instancesVertex>
#include<bonesVertex>
#include<bakedVertexAnimation>
vec4 worldPos=finalWorld*vec4(positionUpdated,1.0);
#ifdef NORMAL
mat3 normWorldSM=mat3(finalWorld);
#if defined(INSTANCES) && defined(THIN_INSTANCES)
vec3 vNormalW=normalUpdated/vec3(dot(normWorldSM[0],normWorldSM[0]),dot(normWorldSM[1],normWorldSM[1]),dot(normWorldSM[2],normWorldSM[2]));vNormalW=normalize(normWorldSM*vNormalW);
#else
#ifdef NONUNIFORMSCALING
normWorldSM=transposeMat3(inverseMat3(normWorldSM));
#endif
vec3 vNormalW=normalize(normWorldSM*normalUpdated);
#endif
#endif
#include<shadowMapVertexNormalBias>
gl_Position=viewProjection*worldPos;
#include<shadowMapVertexMetric>
#ifdef ALPHATEXTURE
#ifdef UV1
vUV=vec2(diffuseMatrix*vec4(uvUpdated,1.0,0.0));
#endif
#ifdef UV2
vUV=vec2(diffuseMatrix*vec4(uv2,1.0,0.0));
#endif
#endif
#include<clipPlaneVertex>
}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$23b1e9398bfa5dad$var$name] = $23b1e9398bfa5dad$var$shader;
const $23b1e9398bfa5dad$export$1ac43e6cba837be9 = {
    name: $23b1e9398bfa5dad$var$name,
    shader: $23b1e9398bfa5dad$var$shader
};

});
parcelRegister("bdk1s", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("vH26W");
parcelRequire("ayOSe");
const $82a070a43974d30e$var$name = "shadowMapVertexDeclaration";
const $82a070a43974d30e$var$shader = `#include<sceneVertexDeclaration>
#include<meshVertexDeclaration>
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$82a070a43974d30e$var$name] = $82a070a43974d30e$var$shader;
const $82a070a43974d30e$export$772d4f4b928be3c3 = {
    name: $82a070a43974d30e$var$name,
    shader: $82a070a43974d30e$var$shader
};

});
parcelRegister("vH26W", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $05f446d4ea992151$var$name = "sceneVertexDeclaration";
const $05f446d4ea992151$var$shader = `uniform mat4 viewProjection;
#ifdef MULTIVIEW
uniform mat4 viewProjectionR;
#endif
uniform mat4 view;uniform mat4 projection;uniform vec4 vEyePosition;
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$05f446d4ea992151$var$name] = $05f446d4ea992151$var$shader;
const $05f446d4ea992151$export$2fc915d16c05187c = {
    name: $05f446d4ea992151$var$name,
    shader: $05f446d4ea992151$var$shader
};

});

parcelRegister("ayOSe", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $7b048acdc6629d89$var$name = "meshVertexDeclaration";
const $7b048acdc6629d89$var$shader = `uniform mat4 world;uniform float visibility;
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$7b048acdc6629d89$var$name] = $7b048acdc6629d89$var$shader;
const $7b048acdc6629d89$export$e4a6ceeeb00b0893 = {
    name: $7b048acdc6629d89$var$name,
    shader: $7b048acdc6629d89$var$shader
};

});


parcelRegister("icZBk", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("eZlZI");
parcelRequire("4u6lu");
const $d41921ae00942dfb$var$name = "shadowMapUboDeclaration";
const $d41921ae00942dfb$var$shader = `layout(std140,column_major) uniform;
#include<sceneUboDeclaration>
#include<meshUboDeclaration>
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$d41921ae00942dfb$var$name] = $d41921ae00942dfb$var$shader;
const $d41921ae00942dfb$export$adca7d263e581866 = {
    name: $d41921ae00942dfb$var$name,
    shader: $d41921ae00942dfb$var$shader
};

});

parcelRegister("5uRcV", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $400906fa190cdc7f$var$name = "shadowMapVertexExtraDeclaration";
const $400906fa190cdc7f$var$shader = `#if SM_NORMALBIAS==1
uniform vec3 lightDataSM;
#endif
uniform vec3 biasAndScaleSM;uniform vec2 depthValuesSM;varying float vDepthMetricSM;
#if SM_USEDISTANCE==1
varying vec3 vPositionWSM;
#endif
#if defined(SM_DEPTHCLAMP) && SM_DEPTHCLAMP==1
varying float zSM;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$400906fa190cdc7f$var$name] = $400906fa190cdc7f$var$shader;
const $400906fa190cdc7f$export$9ce0b4853e88ac01 = {
    name: $400906fa190cdc7f$var$name,
    shader: $400906fa190cdc7f$var$shader
};

});

parcelRegister("lq5Ji", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $f980787503a5b9cc$var$name = "shadowMapVertexNormalBias";
const $f980787503a5b9cc$var$shader = `#if SM_NORMALBIAS==1
#if SM_DIRECTIONINLIGHTDATA==1
vec3 worldLightDirSM=normalize(-lightDataSM.xyz);
#else
vec3 directionToLightSM=lightDataSM.xyz-worldPos.xyz;vec3 worldLightDirSM=normalize(directionToLightSM);
#endif
float ndlSM=dot(vNormalW,worldLightDirSM);float sinNLSM=sqrt(1.0-ndlSM*ndlSM);float normalBiasSM=biasAndScaleSM.y*sinNLSM;worldPos.xyz-=vNormalW*normalBiasSM;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$f980787503a5b9cc$var$name] = $f980787503a5b9cc$var$shader;
const $f980787503a5b9cc$export$1e591149340627ad = {
    name: $f980787503a5b9cc$var$name,
    shader: $f980787503a5b9cc$var$shader
};

});

parcelRegister("cEQx6", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $9371f863c0060674$var$name = "shadowMapVertexMetric";
const $9371f863c0060674$var$shader = `#if SM_USEDISTANCE==1
vPositionWSM=worldPos.xyz;
#endif
#if SM_DEPTHTEXTURE==1
#ifdef IS_NDC_HALF_ZRANGE
#define BIASFACTOR 0.5
#else
#define BIASFACTOR 1.0
#endif
#ifdef USE_REVERSE_DEPTHBUFFER
gl_Position.z-=biasAndScaleSM.x*gl_Position.w*BIASFACTOR;
#else
gl_Position.z+=biasAndScaleSM.x*gl_Position.w*BIASFACTOR;
#endif
#endif
#if defined(SM_DEPTHCLAMP) && SM_DEPTHCLAMP==1
zSM=gl_Position.z;gl_Position.z=0.0;
#elif SM_USEDISTANCE==0
#ifdef USE_REVERSE_DEPTHBUFFER
vDepthMetricSM=(-gl_Position.z+depthValuesSM.x)/depthValuesSM.y+biasAndScaleSM.x;
#else
vDepthMetricSM=(gl_Position.z+depthValuesSM.x)/depthValuesSM.y+biasAndScaleSM.x;
#endif
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$9371f863c0060674$var$name] = $9371f863c0060674$var$shader;
const $9371f863c0060674$export$5c1f1df81f71c481 = {
    name: $9371f863c0060674$var$name,
    shader: $9371f863c0060674$var$shader
};

});


parcelRegister("hy7L3", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $cc6ba13191b96c36$var$name = "depthBoxBlurPixelShader";
const $cc6ba13191b96c36$var$shader = `varying vec2 vUV;uniform sampler2D textureSampler;uniform vec2 screenSize;
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{vec4 colorDepth=vec4(0.0);for (int x=-OFFSET; x<=OFFSET; x++)
for (int y=-OFFSET; y<=OFFSET; y++)
colorDepth+=texture2D(textureSampler,vUV+vec2(x,y)/screenSize);gl_FragColor=(colorDepth/float((OFFSET*2+1)*(OFFSET*2+1)));}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$cc6ba13191b96c36$var$name] = $cc6ba13191b96c36$var$shader;
const $cc6ba13191b96c36$export$6e07629015afb29 = {
    name: $cc6ba13191b96c36$var$name,
    shader: $cc6ba13191b96c36$var$shader
};

});

parcelRegister("5FASc", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $420d625199983d39$var$name = "shadowMapFragmentSoftTransparentShadow";
const $420d625199983d39$var$shader = `#if SM_SOFTTRANSPARENTSHADOW==1
if ((bayerDither8(floor(mod(gl_FragCoord.xy,8.0))))/64.0>=softTransparentShadowSM*alpha) discard;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$420d625199983d39$var$name] = $420d625199983d39$var$shader;
const $420d625199983d39$export$787c84e0e3b50552 = {
    name: $420d625199983d39$var$name,
    shader: $420d625199983d39$var$shader
};

});


parcelRegister("jFaMv", function(module, exports) {

$parcel$export(module.exports, "CascadedShadowGenerator", () => $e50a359d9475e545$export$caacf519593d8044);

var $ha1VO = parcelRequire("ha1VO");

var $gQtNK = parcelRequire("gQtNK");
parcelRequire("1DQzz");
parcelRequire("340di");
parcelRequire("hy7L3");

var $dUFYy = parcelRequire("dUFYy");

var $itc0L = parcelRequire("itc0L");

var $ef012 = parcelRequire("ef012");

var $ciyho = parcelRequire("ciyho");

var $kVtWi = parcelRequire("kVtWi");

var $ejQPp = parcelRequire("ejQPp");
// eslint-disable-next-line @typescript-eslint/naming-convention
const $e50a359d9475e545$var$UpDir = (0, $ha1VO.Vector3).Up();
// eslint-disable-next-line @typescript-eslint/naming-convention
const $e50a359d9475e545$var$ZeroVec = (0, $ha1VO.Vector3).Zero();
const $e50a359d9475e545$var$tmpv1 = new (0, $ha1VO.Vector3)(), $e50a359d9475e545$var$tmpv2 = new (0, $ha1VO.Vector3)(), $e50a359d9475e545$var$tmpMatrix = new (0, $ha1VO.Matrix)();
class $e50a359d9475e545$export$caacf519593d8044 extends (0, $itc0L.ShadowGenerator) {
    _validateFilter(filter) {
        if (filter === (0, $itc0L.ShadowGenerator).FILTER_NONE || filter === (0, $itc0L.ShadowGenerator).FILTER_PCF || filter === (0, $itc0L.ShadowGenerator).FILTER_PCSS) return filter;
        (0, $kVtWi.Logger).Error('Unsupported filter "' + filter + '"!');
        return (0, $itc0L.ShadowGenerator).FILTER_NONE;
    }
    /**
     * Gets or set the number of cascades used by the CSM.
     */ get numCascades() {
        return this._numCascades;
    }
    set numCascades(value) {
        value = Math.min(Math.max(value, $e50a359d9475e545$export$caacf519593d8044.MIN_CASCADES_COUNT), $e50a359d9475e545$export$caacf519593d8044.MAX_CASCADES_COUNT);
        if (value === this._numCascades) return;
        this._numCascades = value;
        this.recreateShadowMap();
        this._recreateSceneUBOs();
    }
    /**
     * Enables or disables the shadow casters bounding info computation.
     * If your shadow casters don't move, you can disable this feature.
     * If it is enabled, the bounding box computation is done every frame.
     */ get freezeShadowCastersBoundingInfo() {
        return this._freezeShadowCastersBoundingInfo;
    }
    set freezeShadowCastersBoundingInfo(freeze) {
        if (this._freezeShadowCastersBoundingInfoObservable && freeze) {
            this._scene.onBeforeRenderObservable.remove(this._freezeShadowCastersBoundingInfoObservable);
            this._freezeShadowCastersBoundingInfoObservable = null;
        }
        if (!this._freezeShadowCastersBoundingInfoObservable && !freeze) this._freezeShadowCastersBoundingInfoObservable = this._scene.onBeforeRenderObservable.add(()=>this._computeShadowCastersBoundingInfo());
        this._freezeShadowCastersBoundingInfo = freeze;
        if (freeze) this._computeShadowCastersBoundingInfo();
    }
    _computeShadowCastersBoundingInfo() {
        this._scbiMin.copyFromFloats(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
        this._scbiMax.copyFromFloats(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
        if (this._shadowMap && this._shadowMap.renderList) {
            const renderList = this._shadowMap.renderList;
            for(let meshIndex = 0; meshIndex < renderList.length; meshIndex++){
                const mesh = renderList[meshIndex];
                if (!mesh) continue;
                const boundingInfo = mesh.getBoundingInfo(), boundingBox = boundingInfo.boundingBox;
                this._scbiMin.minimizeInPlace(boundingBox.minimumWorld);
                this._scbiMax.maximizeInPlace(boundingBox.maximumWorld);
            }
            const meshes = this._scene.meshes;
            for(let meshIndex = 0; meshIndex < meshes.length; meshIndex++){
                const mesh = meshes[meshIndex];
                if (!mesh || !mesh.isVisible || !mesh.isEnabled || !mesh.receiveShadows) continue;
                const boundingInfo = mesh.getBoundingInfo(), boundingBox = boundingInfo.boundingBox;
                this._scbiMin.minimizeInPlace(boundingBox.minimumWorld);
                this._scbiMax.maximizeInPlace(boundingBox.maximumWorld);
            }
        }
        this._shadowCastersBoundingInfo.reConstruct(this._scbiMin, this._scbiMax);
    }
    /**
     * Gets or sets the shadow casters bounding info.
     * If you provide your own shadow casters bounding info, first enable freezeShadowCastersBoundingInfo
     * so that the system won't overwrite the bounds you provide
     */ get shadowCastersBoundingInfo() {
        return this._shadowCastersBoundingInfo;
    }
    set shadowCastersBoundingInfo(boundingInfo) {
        this._shadowCastersBoundingInfo = boundingInfo;
    }
    /**
     * Sets the minimal and maximal distances to use when computing the cascade breaks.
     *
     * The values of min / max are typically the depth zmin and zmax values of your scene, for a given frame.
     * If you don't know these values, simply leave them to their defaults and don't call this function.
     * @param min minimal distance for the breaks (default to 0.)
     * @param max maximal distance for the breaks (default to 1.)
     */ setMinMaxDistance(min, max) {
        if (this._minDistance === min && this._maxDistance === max) return;
        if (min > max) {
            min = 0;
            max = 1;
        }
        if (min < 0) min = 0;
        if (max > 1) max = 1;
        this._minDistance = min;
        this._maxDistance = max;
        this._breaksAreDirty = true;
    }
    /** Gets the minimal distance used in the cascade break computation */ get minDistance() {
        return this._minDistance;
    }
    /** Gets the maximal distance used in the cascade break computation */ get maxDistance() {
        return this._maxDistance;
    }
    /**
     * Gets the class name of that object
     * @returns "CascadedShadowGenerator"
     */ getClassName() {
        return $e50a359d9475e545$export$caacf519593d8044.CLASSNAME;
    }
    /**
     * Gets a cascade minimum extents
     * @param cascadeIndex index of the cascade
     * @returns the minimum cascade extents
     */ getCascadeMinExtents(cascadeIndex) {
        return cascadeIndex >= 0 && cascadeIndex < this._numCascades ? this._cascadeMinExtents[cascadeIndex] : null;
    }
    /**
     * Gets a cascade maximum extents
     * @param cascadeIndex index of the cascade
     * @returns the maximum cascade extents
     */ getCascadeMaxExtents(cascadeIndex) {
        return cascadeIndex >= 0 && cascadeIndex < this._numCascades ? this._cascadeMaxExtents[cascadeIndex] : null;
    }
    /**
     * Gets the shadow max z distance. It's the limit beyond which shadows are not displayed.
     * It defaults to camera.maxZ
     */ get shadowMaxZ() {
        if (!this._getCamera()) return 0;
        return this._shadowMaxZ;
    }
    /**
     * Sets the shadow max z distance.
     */ set shadowMaxZ(value) {
        const camera = this._getCamera();
        if (!camera) {
            this._shadowMaxZ = value;
            return;
        }
        if (this._shadowMaxZ === value || value < camera.minZ || value > camera.maxZ && camera.maxZ !== 0) return;
        this._shadowMaxZ = value;
        this._light._markMeshesAsLightDirty();
        this._breaksAreDirty = true;
    }
    /**
     * Gets or sets the debug flag.
     * When enabled, the cascades are materialized by different colors on the screen.
     */ get debug() {
        return this._debug;
    }
    set debug(dbg) {
        this._debug = dbg;
        this._light._markMeshesAsLightDirty();
    }
    /**
     * Gets or sets the depth clamping value.
     *
     * When enabled, it improves the shadow quality because the near z plane of the light frustum don't need to be adjusted
     * to account for the shadow casters far away.
     *
     * Note that this property is incompatible with PCSS filtering, so it won't be used in that case.
     */ get depthClamp() {
        return this._depthClamp;
    }
    set depthClamp(value) {
        this._depthClamp = value;
    }
    /**
     * Gets or sets the percentage of blending between two cascades (value between 0. and 1.).
     * It defaults to 0.1 (10% blending).
     */ get cascadeBlendPercentage() {
        return this._cascadeBlendPercentage;
    }
    set cascadeBlendPercentage(value) {
        this._cascadeBlendPercentage = value;
        this._light._markMeshesAsLightDirty();
    }
    /**
     * Gets or set the lambda parameter.
     * This parameter is used to split the camera frustum and create the cascades.
     * It's a value between 0. and 1.: If 0, the split is a uniform split of the frustum, if 1 it is a logarithmic split.
     * For all values in-between, it's a linear combination of the uniform and logarithm split algorithm.
     */ get lambda() {
        return this._lambda;
    }
    set lambda(value) {
        const lambda = Math.min(Math.max(value, 0), 1);
        if (this._lambda == lambda) return;
        this._lambda = lambda;
        this._breaksAreDirty = true;
    }
    /**
     * Gets the view matrix corresponding to a given cascade
     * @param cascadeNum cascade to retrieve the view matrix from
     * @returns the cascade view matrix
     */ getCascadeViewMatrix(cascadeNum) {
        return cascadeNum >= 0 && cascadeNum < this._numCascades ? this._viewMatrices[cascadeNum] : null;
    }
    /**
     * Gets the projection matrix corresponding to a given cascade
     * @param cascadeNum cascade to retrieve the projection matrix from
     * @returns the cascade projection matrix
     */ getCascadeProjectionMatrix(cascadeNum) {
        return cascadeNum >= 0 && cascadeNum < this._numCascades ? this._projectionMatrices[cascadeNum] : null;
    }
    /**
     * Gets the transformation matrix corresponding to a given cascade
     * @param cascadeNum cascade to retrieve the transformation matrix from
     * @returns the cascade transformation matrix
     */ getCascadeTransformMatrix(cascadeNum) {
        return cascadeNum >= 0 && cascadeNum < this._numCascades ? this._transformMatrices[cascadeNum] : null;
    }
    /**
     * Sets the depth renderer to use when autoCalcDepthBounds is enabled.
     *
     * Note that if no depth renderer is set, a new one will be automatically created internally when necessary.
     *
     * You should call this function if you already have a depth renderer enabled in your scene, to avoid
     * doing multiple depth rendering each frame. If you provide your own depth renderer, make sure it stores linear depth!
     * @param depthRenderer The depth renderer to use when autoCalcDepthBounds is enabled. If you pass null or don't call this function at all, a depth renderer will be automatically created
     */ setDepthRenderer(depthRenderer) {
        this._depthRenderer = depthRenderer;
        if (this._depthReducer) this._depthReducer.setDepthRenderer(this._depthRenderer);
    }
    /**
     * Gets or sets the autoCalcDepthBounds property.
     *
     * When enabled, a depth rendering pass is first performed (with an internally created depth renderer or with the one
     * you provide by calling setDepthRenderer). Then, a min/max reducing is applied on the depth map to compute the
     * minimal and maximal depth of the map and those values are used as inputs for the setMinMaxDistance() function.
     * It can greatly enhance the shadow quality, at the expense of more GPU works.
     * When using this option, you should increase the value of the lambda parameter, and even set it to 1 for best results.
     */ get autoCalcDepthBounds() {
        return this._autoCalcDepthBounds;
    }
    set autoCalcDepthBounds(value) {
        const camera = this._getCamera();
        if (!camera) return;
        this._autoCalcDepthBounds = value;
        if (!value) {
            if (this._depthReducer) this._depthReducer.deactivate();
            this.setMinMaxDistance(0, 1);
            return;
        }
        if (!this._depthReducer) {
            this._depthReducer = new (0, $ciyho.DepthReducer)(camera);
            this._depthReducer.onAfterReductionPerformed.add((minmax)=>{
                let min = minmax.min, max = minmax.max;
                if (min >= max) {
                    min = 0;
                    max = 1;
                }
                if (min != this._minDistance || max != this._maxDistance) this.setMinMaxDistance(min, max);
            });
            this._depthReducer.setDepthRenderer(this._depthRenderer);
        }
        this._depthReducer.activate();
    }
    /**
     * Defines the refresh rate of the min/max computation used when autoCalcDepthBounds is set to true
     * Use 0 to compute just once, 1 to compute on every frame, 2 to compute every two frames and so on...
     * Note that if you provided your own depth renderer through a call to setDepthRenderer, you are responsible
     * for setting the refresh rate on the renderer yourself!
     */ get autoCalcDepthBoundsRefreshRate() {
        return this._depthReducer?.depthRenderer?.getDepthMap().refreshRate ?? -1;
    }
    set autoCalcDepthBoundsRefreshRate(value) {
        if (this._depthReducer?.depthRenderer) this._depthReducer.depthRenderer.getDepthMap().refreshRate = value;
    }
    /**
     * Create the cascade breaks according to the lambda, shadowMaxZ and min/max distance properties, as well as the camera near and far planes.
     * This function is automatically called when updating lambda, shadowMaxZ and min/max distances, however you should call it yourself if
     * you change the camera near/far planes!
     */ splitFrustum() {
        this._breaksAreDirty = true;
    }
    _splitFrustum() {
        const camera = this._getCamera();
        if (!camera) return;
        const near = camera.minZ, far = camera.maxZ || this._shadowMaxZ, cameraRange = far - near, minDistance = this._minDistance, maxDistance = this._shadowMaxZ < far && this._shadowMaxZ >= near ? Math.min((this._shadowMaxZ - near) / (far - near), this._maxDistance) : this._maxDistance;
        const minZ = near + minDistance * cameraRange, maxZ = near + maxDistance * cameraRange;
        const range = maxZ - minZ, ratio = maxZ / minZ;
        for(let cascadeIndex = 0; cascadeIndex < this._cascades.length; ++cascadeIndex){
            const p = (cascadeIndex + 1) / this._numCascades, log = minZ * ratio ** p, uniform = minZ + range * p;
            const d = this._lambda * (log - uniform) + uniform;
            this._cascades[cascadeIndex].prevBreakDistance = cascadeIndex === 0 ? minDistance : this._cascades[cascadeIndex - 1].breakDistance;
            this._cascades[cascadeIndex].breakDistance = (d - near) / cameraRange;
            this._viewSpaceFrustumsZ[cascadeIndex] = d;
            this._frustumLengths[cascadeIndex] = (this._cascades[cascadeIndex].breakDistance - this._cascades[cascadeIndex].prevBreakDistance) * cameraRange;
        }
        this._breaksAreDirty = false;
    }
    _computeMatrices() {
        const scene = this._scene;
        const camera = this._getCamera();
        if (!camera) return;
        (0, $ha1VO.Vector3).NormalizeToRef(this._light.getShadowDirection(0), this._lightDirection);
        if (Math.abs((0, $ha1VO.Vector3).Dot(this._lightDirection, (0, $ha1VO.Vector3).Up())) === 1.0) this._lightDirection.z = 0.0000000000001; // Required to avoid perfectly perpendicular light
        this._cachedDirection.copyFrom(this._lightDirection);
        const useReverseDepthBuffer = scene.getEngine().useReverseDepthBuffer;
        for(let cascadeIndex = 0; cascadeIndex < this._numCascades; ++cascadeIndex){
            this._computeFrustumInWorldSpace(cascadeIndex);
            this._computeCascadeFrustum(cascadeIndex);
            this._cascadeMaxExtents[cascadeIndex].subtractToRef(this._cascadeMinExtents[cascadeIndex], $e50a359d9475e545$var$tmpv1); // tmpv1 = cascadeExtents
            // Get position of the shadow camera
            this._frustumCenter[cascadeIndex].addToRef(this._lightDirection.scale(this._cascadeMinExtents[cascadeIndex].z), this._shadowCameraPos[cascadeIndex]);
            // Come up with a new orthographic camera for the shadow caster
            (0, $ha1VO.Matrix).LookAtLHToRef(this._shadowCameraPos[cascadeIndex], this._frustumCenter[cascadeIndex], $e50a359d9475e545$var$UpDir, this._viewMatrices[cascadeIndex]);
            let minZ = 0, maxZ = $e50a359d9475e545$var$tmpv1.z;
            // Try to tighten minZ and maxZ based on the bounding box of the shadow casters
            const boundingInfo = this._shadowCastersBoundingInfo;
            boundingInfo.update(this._viewMatrices[cascadeIndex]);
            maxZ = Math.min(maxZ, boundingInfo.boundingBox.maximumWorld.z);
            if (!this._depthClamp || this.filter === (0, $itc0L.ShadowGenerator).FILTER_PCSS) // If we don't use depth clamping, we must set minZ so that all shadow casters are in the light frustum
            minZ = Math.min(minZ, boundingInfo.boundingBox.minimumWorld.z);
            else // If using depth clamping, we can adjust minZ to reduce the [minZ, maxZ] range (and get some additional precision in the shadow map)
            minZ = Math.max(minZ, boundingInfo.boundingBox.minimumWorld.z);
            (0, $ha1VO.Matrix).OrthoOffCenterLHToRef(this._cascadeMinExtents[cascadeIndex].x, this._cascadeMaxExtents[cascadeIndex].x, this._cascadeMinExtents[cascadeIndex].y, this._cascadeMaxExtents[cascadeIndex].y, useReverseDepthBuffer ? maxZ : minZ, useReverseDepthBuffer ? minZ : maxZ, this._projectionMatrices[cascadeIndex], scene.getEngine().isNDCHalfZRange);
            this._cascadeMinExtents[cascadeIndex].z = minZ;
            this._cascadeMaxExtents[cascadeIndex].z = maxZ;
            this._viewMatrices[cascadeIndex].multiplyToRef(this._projectionMatrices[cascadeIndex], this._transformMatrices[cascadeIndex]);
            // Create the rounding matrix, by projecting the world-space origin and determining
            // the fractional offset in texel space
            (0, $ha1VO.Vector3).TransformCoordinatesToRef($e50a359d9475e545$var$ZeroVec, this._transformMatrices[cascadeIndex], $e50a359d9475e545$var$tmpv1); // tmpv1 = shadowOrigin
            $e50a359d9475e545$var$tmpv1.scaleInPlace(this._mapSize / 2);
            $e50a359d9475e545$var$tmpv2.copyFromFloats(Math.round($e50a359d9475e545$var$tmpv1.x), Math.round($e50a359d9475e545$var$tmpv1.y), Math.round($e50a359d9475e545$var$tmpv1.z)); // tmpv2 = roundedOrigin
            $e50a359d9475e545$var$tmpv2.subtractInPlace($e50a359d9475e545$var$tmpv1).scaleInPlace(2 / this._mapSize); // tmpv2 = roundOffset
            (0, $ha1VO.Matrix).TranslationToRef($e50a359d9475e545$var$tmpv2.x, $e50a359d9475e545$var$tmpv2.y, 0.0, $e50a359d9475e545$var$tmpMatrix);
            this._projectionMatrices[cascadeIndex].multiplyToRef($e50a359d9475e545$var$tmpMatrix, this._projectionMatrices[cascadeIndex]);
            this._viewMatrices[cascadeIndex].multiplyToRef(this._projectionMatrices[cascadeIndex], this._transformMatrices[cascadeIndex]);
            this._transformMatrices[cascadeIndex].copyToArray(this._transformMatricesAsArray, cascadeIndex * 16);
        }
    }
    // Get the 8 points of the view frustum in world space
    _computeFrustumInWorldSpace(cascadeIndex) {
        const camera = this._getCamera();
        if (!camera) return;
        const prevSplitDist = this._cascades[cascadeIndex].prevBreakDistance, splitDist = this._cascades[cascadeIndex].breakDistance;
        const isNDCHalfZRange = this._scene.getEngine().isNDCHalfZRange;
        camera.getViewMatrix(); // make sure the transformation matrix we get when calling 'getTransformationMatrix()' is calculated with an up to date view matrix
        const cameraInfiniteFarPlane = camera.maxZ === 0;
        const saveCameraMaxZ = camera.maxZ;
        if (cameraInfiniteFarPlane) {
            camera.maxZ = this._shadowMaxZ;
            camera.getProjectionMatrix(true);
        }
        const invViewProj = (0, $ha1VO.Matrix).Invert(camera.getTransformationMatrix());
        if (cameraInfiniteFarPlane) {
            camera.maxZ = saveCameraMaxZ;
            camera.getProjectionMatrix(true);
        }
        const cornerIndexOffset = this._scene.getEngine().useReverseDepthBuffer ? 4 : 0;
        for(let cornerIndex = 0; cornerIndex < $e50a359d9475e545$export$caacf519593d8044._FrustumCornersNDCSpace.length; ++cornerIndex){
            $e50a359d9475e545$var$tmpv1.copyFrom($e50a359d9475e545$export$caacf519593d8044._FrustumCornersNDCSpace[(cornerIndex + cornerIndexOffset) % $e50a359d9475e545$export$caacf519593d8044._FrustumCornersNDCSpace.length]);
            if (isNDCHalfZRange && $e50a359d9475e545$var$tmpv1.z === -1) $e50a359d9475e545$var$tmpv1.z = 0;
            (0, $ha1VO.Vector3).TransformCoordinatesToRef($e50a359d9475e545$var$tmpv1, invViewProj, this._frustumCornersWorldSpace[cascadeIndex][cornerIndex]);
        }
        // Get the corners of the current cascade slice of the view frustum
        for(let cornerIndex = 0; cornerIndex < $e50a359d9475e545$export$caacf519593d8044._FrustumCornersNDCSpace.length / 2; ++cornerIndex){
            $e50a359d9475e545$var$tmpv1.copyFrom(this._frustumCornersWorldSpace[cascadeIndex][cornerIndex + 4]).subtractInPlace(this._frustumCornersWorldSpace[cascadeIndex][cornerIndex]);
            $e50a359d9475e545$var$tmpv2.copyFrom($e50a359d9475e545$var$tmpv1).scaleInPlace(prevSplitDist); // near corner ray
            $e50a359d9475e545$var$tmpv1.scaleInPlace(splitDist); // far corner ray
            $e50a359d9475e545$var$tmpv1.addInPlace(this._frustumCornersWorldSpace[cascadeIndex][cornerIndex]);
            this._frustumCornersWorldSpace[cascadeIndex][cornerIndex + 4].copyFrom($e50a359d9475e545$var$tmpv1);
            this._frustumCornersWorldSpace[cascadeIndex][cornerIndex].addInPlace($e50a359d9475e545$var$tmpv2);
        }
    }
    _computeCascadeFrustum(cascadeIndex) {
        this._cascadeMinExtents[cascadeIndex].copyFromFloats(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
        this._cascadeMaxExtents[cascadeIndex].copyFromFloats(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
        this._frustumCenter[cascadeIndex].copyFromFloats(0, 0, 0);
        const camera = this._getCamera();
        if (!camera) return;
        // Calculate the centroid of the view frustum slice
        for(let cornerIndex = 0; cornerIndex < this._frustumCornersWorldSpace[cascadeIndex].length; ++cornerIndex)this._frustumCenter[cascadeIndex].addInPlace(this._frustumCornersWorldSpace[cascadeIndex][cornerIndex]);
        this._frustumCenter[cascadeIndex].scaleInPlace(1 / this._frustumCornersWorldSpace[cascadeIndex].length);
        if (this.stabilizeCascades) {
            // Calculate the radius of a bounding sphere surrounding the frustum corners
            let sphereRadius = 0;
            for(let cornerIndex = 0; cornerIndex < this._frustumCornersWorldSpace[cascadeIndex].length; ++cornerIndex){
                const dist = this._frustumCornersWorldSpace[cascadeIndex][cornerIndex].subtractToRef(this._frustumCenter[cascadeIndex], $e50a359d9475e545$var$tmpv1).length();
                sphereRadius = Math.max(sphereRadius, dist);
            }
            sphereRadius = Math.ceil(sphereRadius * 16) / 16;
            this._cascadeMaxExtents[cascadeIndex].copyFromFloats(sphereRadius, sphereRadius, sphereRadius);
            this._cascadeMinExtents[cascadeIndex].copyFromFloats(-sphereRadius, -sphereRadius, -sphereRadius);
        } else {
            // Create a temporary view matrix for the light
            const lightCameraPos = this._frustumCenter[cascadeIndex];
            this._frustumCenter[cascadeIndex].addToRef(this._lightDirection, $e50a359d9475e545$var$tmpv1); // tmpv1 = look at
            (0, $ha1VO.Matrix).LookAtLHToRef(lightCameraPos, $e50a359d9475e545$var$tmpv1, $e50a359d9475e545$var$UpDir, $e50a359d9475e545$var$tmpMatrix); // matrix = lightView
            // Calculate an AABB around the frustum corners
            for(let cornerIndex = 0; cornerIndex < this._frustumCornersWorldSpace[cascadeIndex].length; ++cornerIndex){
                (0, $ha1VO.Vector3).TransformCoordinatesToRef(this._frustumCornersWorldSpace[cascadeIndex][cornerIndex], $e50a359d9475e545$var$tmpMatrix, $e50a359d9475e545$var$tmpv1);
                this._cascadeMinExtents[cascadeIndex].minimizeInPlace($e50a359d9475e545$var$tmpv1);
                this._cascadeMaxExtents[cascadeIndex].maximizeInPlace($e50a359d9475e545$var$tmpv1);
            }
        }
    }
    _recreateSceneUBOs() {
        this._disposeSceneUBOs();
        if (this._sceneUBOs) for(let i = 0; i < this._numCascades; ++i)this._sceneUBOs.push(this._scene.createSceneUniformBuffer(`Scene for CSM Shadow Generator (light "${this._light.name}" cascade #${i})`));
    }
    /**
     *  Support test.
     */ static get IsSupported() {
        const engine = (0, $ejQPp.EngineStore).LastCreatedEngine;
        if (!engine) return false;
        return engine._features.supportCSM;
    }
    /**
     * Creates a Cascaded Shadow Generator object.
     * A ShadowGenerator is the required tool to use the shadows.
     * Each directional light casting shadows needs to use its own ShadowGenerator.
     * Documentation : https://doc.babylonjs.com/babylon101/cascadedShadows
     * @param mapSize The size of the texture what stores the shadows. Example : 1024.
     * @param light The directional light object generating the shadows.
     * @param usefulFloatFirst By default the generator will try to use half float textures but if you need precision (for self shadowing for instance), you can use this option to enforce full float texture.
     * @param camera Camera associated with this shadow generator (default: null). If null, takes the scene active camera at the time we need to access it
     * @param useRedTextureType Forces the generator to use a Red instead of a RGBA type for the shadow map texture format (default: true)
     */ constructor(mapSize, light, usefulFloatFirst, camera, useRedTextureType = true){
        if (!$e50a359d9475e545$export$caacf519593d8044.IsSupported) {
            (0, $kVtWi.Logger).Error("CascadedShadowMap is not supported by the current engine.");
            return;
        }
        super(mapSize, light, usefulFloatFirst, camera, useRedTextureType);
        this.usePercentageCloserFiltering = true;
    }
    _initializeGenerator() {
        this.penumbraDarkness = this.penumbraDarkness ?? 1.0;
        this._numCascades = this._numCascades ?? $e50a359d9475e545$export$caacf519593d8044.DEFAULT_CASCADES_COUNT;
        this.stabilizeCascades = this.stabilizeCascades ?? false;
        this._freezeShadowCastersBoundingInfoObservable = this._freezeShadowCastersBoundingInfoObservable ?? null;
        this.freezeShadowCastersBoundingInfo = this.freezeShadowCastersBoundingInfo ?? false;
        this._scbiMin = this._scbiMin ?? new (0, $ha1VO.Vector3)(0, 0, 0);
        this._scbiMax = this._scbiMax ?? new (0, $ha1VO.Vector3)(0, 0, 0);
        this._shadowCastersBoundingInfo = this._shadowCastersBoundingInfo ?? new (0, $ef012.BoundingInfo)(new (0, $ha1VO.Vector3)(0, 0, 0), new (0, $ha1VO.Vector3)(0, 0, 0));
        this._breaksAreDirty = this._breaksAreDirty ?? true;
        this._minDistance = this._minDistance ?? 0;
        this._maxDistance = this._maxDistance ?? 1;
        this._currentLayer = this._currentLayer ?? 0;
        this._shadowMaxZ = this._shadowMaxZ ?? this._getCamera()?.maxZ ?? 10000;
        this._debug = this._debug ?? false;
        this._depthClamp = this._depthClamp ?? true;
        this._cascadeBlendPercentage = this._cascadeBlendPercentage ?? 0.1;
        this._lambda = this._lambda ?? 0.5;
        this._autoCalcDepthBounds = this._autoCalcDepthBounds ?? false;
        this._recreateSceneUBOs();
        super._initializeGenerator();
    }
    _createTargetRenderTexture() {
        const engine = this._scene.getEngine();
        const size = {
            width: this._mapSize,
            height: this._mapSize,
            layers: this.numCascades
        };
        this._shadowMap = new (0, $gQtNK.RenderTargetTexture)(this._light.name + "_CSMShadowMap", size, this._scene, false, true, this._textureType, false, undefined, false, false, undefined, this._useRedTextureType ? 6 : 5);
        this._shadowMap.createDepthStencilTexture(engine.useReverseDepthBuffer ? 516 : 513, true);
        this._shadowMap.noPrePassRenderer = true;
    }
    _initializeShadowMap() {
        super._initializeShadowMap();
        if (this._shadowMap === null) return;
        this._transformMatricesAsArray = new Float32Array(this._numCascades * 16);
        this._viewSpaceFrustumsZ = new Array(this._numCascades);
        this._frustumLengths = new Array(this._numCascades);
        this._lightSizeUVCorrection = new Array(this._numCascades * 2);
        this._depthCorrection = new Array(this._numCascades);
        this._cascades = [];
        this._viewMatrices = [];
        this._projectionMatrices = [];
        this._transformMatrices = [];
        this._cascadeMinExtents = [];
        this._cascadeMaxExtents = [];
        this._frustumCenter = [];
        this._shadowCameraPos = [];
        this._frustumCornersWorldSpace = [];
        for(let cascadeIndex = 0; cascadeIndex < this._numCascades; ++cascadeIndex){
            this._cascades[cascadeIndex] = {
                prevBreakDistance: 0,
                breakDistance: 0
            };
            this._viewMatrices[cascadeIndex] = (0, $ha1VO.Matrix).Zero();
            this._projectionMatrices[cascadeIndex] = (0, $ha1VO.Matrix).Zero();
            this._transformMatrices[cascadeIndex] = (0, $ha1VO.Matrix).Zero();
            this._cascadeMinExtents[cascadeIndex] = new (0, $ha1VO.Vector3)();
            this._cascadeMaxExtents[cascadeIndex] = new (0, $ha1VO.Vector3)();
            this._frustumCenter[cascadeIndex] = new (0, $ha1VO.Vector3)();
            this._shadowCameraPos[cascadeIndex] = new (0, $ha1VO.Vector3)();
            this._frustumCornersWorldSpace[cascadeIndex] = new Array($e50a359d9475e545$export$caacf519593d8044._FrustumCornersNDCSpace.length);
            for(let i = 0; i < $e50a359d9475e545$export$caacf519593d8044._FrustumCornersNDCSpace.length; ++i)this._frustumCornersWorldSpace[cascadeIndex][i] = new (0, $ha1VO.Vector3)();
        }
        const engine = this._scene.getEngine();
        this._shadowMap.onBeforeBindObservable.clear();
        this._shadowMap.onBeforeRenderObservable.clear();
        this._shadowMap.onBeforeRenderObservable.add((layer)=>{
            if (this._sceneUBOs) this._scene.setSceneUniformBuffer(this._sceneUBOs[layer]);
            this._currentLayer = layer;
            if (this._filter === (0, $itc0L.ShadowGenerator).FILTER_PCF) engine.setColorWrite(false);
            this._scene.setTransformMatrix(this.getCascadeViewMatrix(layer), this.getCascadeProjectionMatrix(layer));
            if (this._useUBO) {
                this._scene.getSceneUniformBuffer().unbindEffect();
                this._scene.finalizeSceneUbo();
            }
        });
        this._shadowMap.onBeforeBindObservable.add(()=>{
            this._currentSceneUBO = this._scene.getSceneUniformBuffer();
            engine._debugPushGroup?.(`cascaded shadow map generation for pass id ${engine.currentRenderPassId}`, 1);
            if (this._breaksAreDirty) this._splitFrustum();
            this._computeMatrices();
        });
        this._splitFrustum();
    }
    _bindCustomEffectForRenderSubMeshForShadowMap(subMesh, effect) {
        effect.setMatrix("viewProjection", this.getCascadeTransformMatrix(this._currentLayer));
    }
    _isReadyCustomDefines(defines) {
        defines.push("#define SM_DEPTHCLAMP " + (this._depthClamp && this._filter !== (0, $itc0L.ShadowGenerator).FILTER_PCSS ? "1" : "0"));
    }
    /**
     * Prepare all the defines in a material relying on a shadow map at the specified light index.
     * @param defines Defines of the material we want to update
     * @param lightIndex Index of the light in the enabled light list of the material
     */ prepareDefines(defines, lightIndex) {
        super.prepareDefines(defines, lightIndex);
        const scene = this._scene;
        const light = this._light;
        if (!scene.shadowsEnabled || !light.shadowEnabled) return;
        defines["SHADOWCSM" + lightIndex] = true;
        defines["SHADOWCSMDEBUG" + lightIndex] = this.debug;
        defines["SHADOWCSMNUM_CASCADES" + lightIndex] = this.numCascades;
        defines["SHADOWCSM_RIGHTHANDED" + lightIndex] = scene.useRightHandedSystem;
        const camera = this._getCamera();
        if (camera && this._shadowMaxZ <= (camera.maxZ || this._shadowMaxZ)) defines["SHADOWCSMUSESHADOWMAXZ" + lightIndex] = true;
        if (this.cascadeBlendPercentage === 0) defines["SHADOWCSMNOBLEND" + lightIndex] = true;
    }
    /**
     * Binds the shadow related information inside of an effect (information like near, far, darkness...
     * defined in the generator but impacting the effect).
     * @param lightIndex Index of the light in the enabled light list of the material owning the effect
     * @param effect The effect we are binfing the information for
     */ bindShadowLight(lightIndex, effect) {
        const light = this._light;
        const scene = this._scene;
        if (!scene.shadowsEnabled || !light.shadowEnabled) return;
        const camera = this._getCamera();
        if (!camera) return;
        const shadowMap = this.getShadowMap();
        if (!shadowMap) return;
        const width = shadowMap.getSize().width;
        effect.setMatrices("lightMatrix" + lightIndex, this._transformMatricesAsArray);
        effect.setArray("viewFrustumZ" + lightIndex, this._viewSpaceFrustumsZ);
        effect.setFloat("cascadeBlendFactor" + lightIndex, this.cascadeBlendPercentage === 0 ? 10000 : 1 / this.cascadeBlendPercentage);
        effect.setArray("frustumLengths" + lightIndex, this._frustumLengths);
        // Only PCF uses depth stencil texture.
        if (this._filter === (0, $itc0L.ShadowGenerator).FILTER_PCF) {
            effect.setDepthStencilTexture("shadowSampler" + lightIndex, shadowMap);
            light._uniformBuffer.updateFloat4("shadowsInfo", this.getDarkness(), width, 1 / width, this.frustumEdgeFalloff, lightIndex);
        } else if (this._filter === (0, $itc0L.ShadowGenerator).FILTER_PCSS) {
            for(let cascadeIndex = 0; cascadeIndex < this._numCascades; ++cascadeIndex){
                this._lightSizeUVCorrection[cascadeIndex * 2 + 0] = cascadeIndex === 0 ? 1 : (this._cascadeMaxExtents[0].x - this._cascadeMinExtents[0].x) / (this._cascadeMaxExtents[cascadeIndex].x - this._cascadeMinExtents[cascadeIndex].x); // x correction
                this._lightSizeUVCorrection[cascadeIndex * 2 + 1] = cascadeIndex === 0 ? 1 : (this._cascadeMaxExtents[0].y - this._cascadeMinExtents[0].y) / (this._cascadeMaxExtents[cascadeIndex].y - this._cascadeMinExtents[cascadeIndex].y); // y correction
                this._depthCorrection[cascadeIndex] = cascadeIndex === 0 ? 1 : (this._cascadeMaxExtents[cascadeIndex].z - this._cascadeMinExtents[cascadeIndex].z) / (this._cascadeMaxExtents[0].z - this._cascadeMinExtents[0].z);
            }
            effect.setDepthStencilTexture("shadowSampler" + lightIndex, shadowMap);
            effect.setTexture("depthSampler" + lightIndex, shadowMap);
            effect.setArray2("lightSizeUVCorrection" + lightIndex, this._lightSizeUVCorrection);
            effect.setArray("depthCorrection" + lightIndex, this._depthCorrection);
            effect.setFloat("penumbraDarkness" + lightIndex, this.penumbraDarkness);
            light._uniformBuffer.updateFloat4("shadowsInfo", this.getDarkness(), 1 / width, this._contactHardeningLightSizeUVRatio * width, this.frustumEdgeFalloff, lightIndex);
        } else {
            effect.setTexture("shadowSampler" + lightIndex, shadowMap);
            light._uniformBuffer.updateFloat4("shadowsInfo", this.getDarkness(), width, 1 / width, this.frustumEdgeFalloff, lightIndex);
        }
        light._uniformBuffer.updateFloat2("depthValues", this.getLight().getDepthMinZ(camera), this.getLight().getDepthMinZ(camera) + this.getLight().getDepthMaxZ(camera), lightIndex);
    }
    /**
     * Gets the transformation matrix of the first cascade used to project the meshes into the map from the light point of view.
     * (eq to view projection * shadow projection matrices)
     * @returns The transform matrix used to create the shadow map
     */ getTransformMatrix() {
        return this.getCascadeTransformMatrix(0);
    }
    /**
     * Disposes the ShadowGenerator.
     * Returns nothing.
     */ dispose() {
        super.dispose();
        if (this._freezeShadowCastersBoundingInfoObservable) {
            this._scene.onBeforeRenderObservable.remove(this._freezeShadowCastersBoundingInfoObservable);
            this._freezeShadowCastersBoundingInfoObservable = null;
        }
        if (this._depthReducer) {
            this._depthReducer.dispose();
            this._depthReducer = null;
        }
    }
    /**
     * Serializes the shadow generator setup to a json object.
     * @returns The serialized JSON object
     */ serialize() {
        const serializationObject = super.serialize();
        const shadowMap = this.getShadowMap();
        if (!shadowMap) return serializationObject;
        serializationObject.numCascades = this._numCascades;
        serializationObject.debug = this._debug;
        serializationObject.stabilizeCascades = this.stabilizeCascades;
        serializationObject.lambda = this._lambda;
        serializationObject.cascadeBlendPercentage = this.cascadeBlendPercentage;
        serializationObject.depthClamp = this._depthClamp;
        serializationObject.autoCalcDepthBounds = this.autoCalcDepthBounds;
        serializationObject.shadowMaxZ = this._shadowMaxZ;
        serializationObject.penumbraDarkness = this.penumbraDarkness;
        serializationObject.freezeShadowCastersBoundingInfo = this._freezeShadowCastersBoundingInfo;
        serializationObject.minDistance = this.minDistance;
        serializationObject.maxDistance = this.maxDistance;
        serializationObject.renderList = [];
        if (shadowMap.renderList) for(let meshIndex = 0; meshIndex < shadowMap.renderList.length; meshIndex++){
            const mesh = shadowMap.renderList[meshIndex];
            serializationObject.renderList.push(mesh.id);
        }
        return serializationObject;
    }
    /**
     * Parses a serialized ShadowGenerator and returns a new ShadowGenerator.
     * @param parsedShadowGenerator The JSON object to parse
     * @param scene The scene to create the shadow map for
     * @returns The parsed shadow generator
     */ static Parse(parsedShadowGenerator, scene) {
        const shadowGenerator = (0, $itc0L.ShadowGenerator).Parse(parsedShadowGenerator, scene, (mapSize, light, camera)=>new $e50a359d9475e545$export$caacf519593d8044(mapSize, light, undefined, camera));
        if (parsedShadowGenerator.numCascades !== undefined) shadowGenerator.numCascades = parsedShadowGenerator.numCascades;
        if (parsedShadowGenerator.debug !== undefined) shadowGenerator.debug = parsedShadowGenerator.debug;
        if (parsedShadowGenerator.stabilizeCascades !== undefined) shadowGenerator.stabilizeCascades = parsedShadowGenerator.stabilizeCascades;
        if (parsedShadowGenerator.lambda !== undefined) shadowGenerator.lambda = parsedShadowGenerator.lambda;
        if (parsedShadowGenerator.cascadeBlendPercentage !== undefined) shadowGenerator.cascadeBlendPercentage = parsedShadowGenerator.cascadeBlendPercentage;
        if (parsedShadowGenerator.depthClamp !== undefined) shadowGenerator.depthClamp = parsedShadowGenerator.depthClamp;
        if (parsedShadowGenerator.autoCalcDepthBounds !== undefined) shadowGenerator.autoCalcDepthBounds = parsedShadowGenerator.autoCalcDepthBounds;
        if (parsedShadowGenerator.shadowMaxZ !== undefined) shadowGenerator.shadowMaxZ = parsedShadowGenerator.shadowMaxZ;
        if (parsedShadowGenerator.penumbraDarkness !== undefined) shadowGenerator.penumbraDarkness = parsedShadowGenerator.penumbraDarkness;
        if (parsedShadowGenerator.freezeShadowCastersBoundingInfo !== undefined) shadowGenerator.freezeShadowCastersBoundingInfo = parsedShadowGenerator.freezeShadowCastersBoundingInfo;
        if (parsedShadowGenerator.minDistance !== undefined && parsedShadowGenerator.maxDistance !== undefined) shadowGenerator.setMinMaxDistance(parsedShadowGenerator.minDistance, parsedShadowGenerator.maxDistance);
        return shadowGenerator;
    }
}
$e50a359d9475e545$export$caacf519593d8044._FrustumCornersNDCSpace = [
    new (0, $ha1VO.Vector3)(-1, 1, -1),
    new (0, $ha1VO.Vector3)(1, 1, -1),
    new (0, $ha1VO.Vector3)(1, -1, -1),
    new (0, $ha1VO.Vector3)(-1, -1, -1),
    new (0, $ha1VO.Vector3)(-1, 1, 1),
    new (0, $ha1VO.Vector3)(1, 1, 1),
    new (0, $ha1VO.Vector3)(1, -1, 1),
    new (0, $ha1VO.Vector3)(-1, -1, 1)
];
/**
 * Name of the CSM class
 */ $e50a359d9475e545$export$caacf519593d8044.CLASSNAME = "CascadedShadowGenerator";
/**
 * Defines the default number of cascades used by the CSM.
 */ $e50a359d9475e545$export$caacf519593d8044.DEFAULT_CASCADES_COUNT = 4;
/**
 * Defines the minimum number of cascades used by the CSM.
 */ $e50a359d9475e545$export$caacf519593d8044.MIN_CASCADES_COUNT = 2;
/**
 * Defines the maximum number of cascades used by the CSM.
 */ $e50a359d9475e545$export$caacf519593d8044.MAX_CASCADES_COUNT = 4;
/**
 * @internal
 */ $e50a359d9475e545$export$caacf519593d8044._SceneComponentInitialization = (_)=>{
    throw (0, $dUFYy._WarnImport)("ShadowGeneratorSceneComponent");
};

});
parcelRegister("ciyho", function(module, exports) {

$parcel$export(module.exports, "DepthReducer", () => $8f41c1b224a17d38$export$1158bf9b06b7cf73);

var $UZ4tK = parcelRequire("UZ4tK");

var $lfM5G = parcelRequire("lfM5G");
class $8f41c1b224a17d38$export$1158bf9b06b7cf73 extends (0, $lfM5G.MinMaxReducer) {
    /**
     * Gets the depth renderer used for the computation.
     * Note that the result is null if you provide your own renderer when calling setDepthRenderer.
     */ get depthRenderer() {
        return this._depthRenderer;
    }
    /**
     * Creates a depth reducer
     * @param camera The camera used to render the depth texture
     */ constructor(camera){
        super(camera);
    }
    /**
     * Sets the depth renderer to use to generate the depth map
     * @param depthRenderer The depth renderer to use. If not provided, a new one will be created automatically
     * @param type The texture type of the depth map (default: TEXTURETYPE_HALF_FLOAT)
     * @param forceFullscreenViewport Forces the post processes used for the reduction to be applied without taking into account viewport (defaults to true)
     */ setDepthRenderer(depthRenderer = null, type = 2, forceFullscreenViewport = true) {
        const scene = this._camera.getScene();
        if (this._depthRenderer) {
            delete scene._depthRenderer[this._depthRendererId];
            this._depthRenderer.dispose();
            this._depthRenderer = null;
        }
        if (depthRenderer === null) {
            if (!scene._depthRenderer) scene._depthRenderer = {};
            depthRenderer = this._depthRenderer = new (0, $UZ4tK.DepthRenderer)(scene, type, this._camera, false, 1);
            depthRenderer.enabled = false;
            this._depthRendererId = "minmax" + this._camera.id;
            scene._depthRenderer[this._depthRendererId] = depthRenderer;
        }
        super.setSourceTexture(depthRenderer.getDepthMap(), true, type, forceFullscreenViewport);
    }
    /**
     * @internal
     */ setSourceTexture(sourceTexture, depthRedux, type = 2, forceFullscreenViewport = true) {
        super.setSourceTexture(sourceTexture, depthRedux, type, forceFullscreenViewport);
    }
    /**
     * Activates the reduction computation.
     * When activated, the observers registered in onAfterReductionPerformed are
     * called after the computation is performed
     */ activate() {
        if (this._depthRenderer) this._depthRenderer.enabled = true;
        super.activate();
    }
    /**
     * Deactivates the reduction computation.
     */ deactivate() {
        super.deactivate();
        if (this._depthRenderer) this._depthRenderer.enabled = false;
    }
    /**
     * Disposes the depth reducer
     * @param disposeAll true to dispose all the resources. You should always call this function with true as the parameter (or without any parameter as it is the default one). This flag is meant to be used internally.
     */ dispose(disposeAll = true) {
        super.dispose(disposeAll);
        if (this._depthRenderer && disposeAll) {
            const scene = this._depthRenderer.getDepthMap().getScene();
            if (scene) delete scene._depthRenderer[this._depthRendererId];
            this._depthRenderer.dispose();
            this._depthRenderer = null;
        }
    }
}

});
parcelRegister("UZ4tK", function(module, exports) {

$parcel$export(module.exports, "DepthRenderer", () => $0ab49a8db98eb6ea$export$7ca926ca0996efa0);

var $7etnY = parcelRequire("7etnY");

var $b4i1f = parcelRequire("b4i1f");

var $j2mX5 = parcelRequire("j2mX5");

var $gQtNK = parcelRequire("gQtNK");

var $74SKQ = parcelRequire("74SKQ");
parcelRequire("gO9ru");
parcelRequire("dKvV4");

var $dUFYy = parcelRequire("dUFYy");

var $aAFeM = parcelRequire("aAFeM");

var $alPCh = parcelRequire("alPCh");
class $0ab49a8db98eb6ea$export$7ca926ca0996efa0 {
    /**
     * Sets a specific material to be used to render a mesh/a list of meshes by the depth renderer
     * @param mesh mesh or array of meshes
     * @param material material to use by the depth render when rendering the mesh(es). If undefined is passed, the specific material created by the depth renderer will be used.
     */ setMaterialForRendering(mesh, material) {
        this._depthMap.setMaterialForRendering(mesh, material);
    }
    /**
     * Instantiates a depth renderer
     * @param scene The scene the renderer belongs to
     * @param type The texture type of the depth map (default: Engine.TEXTURETYPE_FLOAT)
     * @param camera The camera to be used to render the depth map (default: scene's active camera)
     * @param storeNonLinearDepth Defines whether the depth is stored linearly like in Babylon Shadows or directly like glFragCoord.z
     * @param samplingMode The sampling mode to be used with the render target (Linear, Nearest...) (default: TRILINEAR_SAMPLINGMODE)
     * @param storeCameraSpaceZ Defines whether the depth stored is the Z coordinate in camera space. If true, storeNonLinearDepth has no effect. (Default: false)
     * @param name Name of the render target (default: DepthRenderer)
     */ constructor(scene, type = 1, camera = null, storeNonLinearDepth = false, samplingMode = (0, $j2mX5.Texture).TRILINEAR_SAMPLINGMODE, storeCameraSpaceZ = false, name){
        /** Enable or disable the depth renderer. When disabled, the depth texture is not updated */ this.enabled = true;
        /** Force writing the transparent objects into the depth map */ this.forceDepthWriteTransparentMeshes = false;
        /**
         * Specifies that the depth renderer will only be used within
         * the camera it is created for.
         * This can help forcing its rendering during the camera processing.
         */ this.useOnlyInActiveCamera = false;
        /** If true, reverse the culling of materials before writing to the depth texture.
         * So, basically, when "true", back facing instead of front facing faces are rasterized into the texture
         */ this.reverseCulling = false;
        this._scene = scene;
        this._storeNonLinearDepth = storeNonLinearDepth;
        this._storeCameraSpaceZ = storeCameraSpaceZ;
        this.isPacked = type === 0;
        if (this.isPacked) this.clearColor = new (0, $7etnY.Color4)(1.0, 1.0, 1.0, 1.0);
        else this.clearColor = new (0, $7etnY.Color4)(storeCameraSpaceZ ? 1e8 : 1.0, 0.0, 0.0, 1.0);
        $0ab49a8db98eb6ea$export$7ca926ca0996efa0._SceneComponentInitialization(this._scene);
        const engine = scene.getEngine();
        this._camera = camera;
        if (samplingMode !== (0, $j2mX5.Texture).NEAREST_SAMPLINGMODE) {
            if (type === 1 && !engine._caps.textureFloatLinearFiltering) samplingMode = (0, $j2mX5.Texture).NEAREST_SAMPLINGMODE;
            if (type === 2 && !engine._caps.textureHalfFloatLinearFiltering) samplingMode = (0, $j2mX5.Texture).NEAREST_SAMPLINGMODE;
        }
        // Render target
        const format = this.isPacked || !engine._features.supportExtendedTextureFormats ? 5 : 6;
        this._depthMap = new (0, $gQtNK.RenderTargetTexture)(name ?? "DepthRenderer", {
            width: engine.getRenderWidth(),
            height: engine.getRenderHeight()
        }, this._scene, false, true, type, false, samplingMode, undefined, undefined, undefined, format);
        this._depthMap.wrapU = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        this._depthMap.wrapV = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        this._depthMap.refreshRate = 1;
        this._depthMap.renderParticles = false;
        this._depthMap.renderList = null;
        this._depthMap.noPrePassRenderer = true;
        // Camera to get depth map from to support multiple concurrent cameras
        this._depthMap.activeCamera = this._camera;
        this._depthMap.ignoreCameraViewport = true;
        this._depthMap.useCameraPostProcesses = false;
        // set default depth value to 1.0 (far away)
        this._depthMap.onClearObservable.add((engine)=>{
            engine.clear(this.clearColor, true, true, true);
        });
        this._depthMap.onBeforeBindObservable.add(()=>{
            engine._debugPushGroup?.("depth renderer", 1);
        });
        this._depthMap.onAfterUnbindObservable.add(()=>{
            engine._debugPopGroup?.(1);
        });
        this._depthMap.customIsReadyFunction = (mesh, refreshRate, preWarm)=>{
            if ((preWarm || refreshRate === 0) && mesh.subMeshes) for(let i = 0; i < mesh.subMeshes.length; ++i){
                const subMesh = mesh.subMeshes[i];
                const renderingMesh = subMesh.getRenderingMesh();
                const batch = renderingMesh._getInstancesRenderList(subMesh._id, !!subMesh.getReplacementMesh());
                const hardwareInstancedRendering = engine.getCaps().instancedArrays && (batch.visibleInstances[subMesh._id] !== null && batch.visibleInstances[subMesh._id] !== undefined || renderingMesh.hasThinInstances);
                if (!this.isReady(subMesh, hardwareInstancedRendering)) return false;
            }
            return true;
        };
        // Custom render function
        const renderSubMesh = (subMesh)=>{
            const renderingMesh = subMesh.getRenderingMesh();
            const effectiveMesh = subMesh.getEffectiveMesh();
            const scene = this._scene;
            const engine = scene.getEngine();
            const material = subMesh.getMaterial();
            effectiveMesh._internalAbstractMeshDataInfo._isActiveIntermediate = false;
            if (!material || effectiveMesh.infiniteDistance || material.disableDepthWrite || subMesh.verticesCount === 0 || subMesh._renderId === scene.getRenderId()) return;
            // Culling
            const detNeg = effectiveMesh._getWorldMatrixDeterminant() < 0;
            let sideOrientation = renderingMesh.overrideMaterialSideOrientation ?? material.sideOrientation;
            if (detNeg) sideOrientation = sideOrientation === 0 ? 1 : 0;
            const reverseSideOrientation = sideOrientation === 0;
            engine.setState(material.backFaceCulling, 0, false, reverseSideOrientation, this.reverseCulling ? !material.cullBackFaces : material.cullBackFaces);
            // Managing instances
            const batch = renderingMesh._getInstancesRenderList(subMesh._id, !!subMesh.getReplacementMesh());
            if (batch.mustReturn) return;
            const hardwareInstancedRendering = engine.getCaps().instancedArrays && (batch.visibleInstances[subMesh._id] !== null && batch.visibleInstances[subMesh._id] !== undefined || renderingMesh.hasThinInstances);
            const camera = this._camera || scene.activeCamera;
            if (this.isReady(subMesh, hardwareInstancedRendering) && camera) {
                subMesh._renderId = scene.getRenderId();
                const renderingMaterial = effectiveMesh._internalAbstractMeshDataInfo._materialForRenderPass?.[engine.currentRenderPassId];
                let drawWrapper = subMesh._getDrawWrapper();
                if (!drawWrapper && renderingMaterial) drawWrapper = renderingMaterial._getDrawWrapper();
                const cameraIsOrtho = camera.mode === (0, $74SKQ.Camera).ORTHOGRAPHIC_CAMERA;
                if (!drawWrapper) return;
                const effect = drawWrapper.effect;
                engine.enableEffect(drawWrapper);
                if (!hardwareInstancedRendering) renderingMesh._bind(subMesh, effect, material.fillMode);
                if (!renderingMaterial) {
                    effect.setMatrix("viewProjection", scene.getTransformMatrix());
                    effect.setMatrix("world", effectiveMesh.getWorldMatrix());
                    if (this._storeCameraSpaceZ) effect.setMatrix("view", scene.getViewMatrix());
                } else renderingMaterial.bindForSubMesh(effectiveMesh.getWorldMatrix(), effectiveMesh, subMesh);
                let minZ, maxZ;
                if (cameraIsOrtho) {
                    minZ = !engine.useReverseDepthBuffer && engine.isNDCHalfZRange ? 0 : 1;
                    maxZ = engine.useReverseDepthBuffer && engine.isNDCHalfZRange ? 0 : 1;
                } else {
                    minZ = engine.useReverseDepthBuffer && engine.isNDCHalfZRange ? camera.minZ : engine.isNDCHalfZRange ? 0 : camera.minZ;
                    maxZ = engine.useReverseDepthBuffer && engine.isNDCHalfZRange ? 0 : camera.maxZ;
                }
                effect.setFloat2("depthValues", minZ, minZ + maxZ);
                if (!renderingMaterial) {
                    // Alpha test
                    if (material.needAlphaTesting()) {
                        const alphaTexture = material.getAlphaTestTexture();
                        if (alphaTexture) {
                            effect.setTexture("diffuseSampler", alphaTexture);
                            effect.setMatrix("diffuseMatrix", alphaTexture.getTextureMatrix());
                        }
                    }
                    // Bones
                    if (renderingMesh.useBones && renderingMesh.computeBonesUsingShaders && renderingMesh.skeleton) {
                        const skeleton = renderingMesh.skeleton;
                        if (skeleton.isUsingTextureForMatrices) {
                            const boneTexture = skeleton.getTransformMatrixTexture(renderingMesh);
                            if (!boneTexture) return;
                            effect.setTexture("boneSampler", boneTexture);
                            effect.setFloat("boneTextureWidth", 4.0 * (skeleton.bones.length + 1));
                        } else effect.setMatrices("mBones", skeleton.getTransformMatrices(renderingMesh));
                    }
                    // Clip planes
                    (0, $aAFeM.bindClipPlane)(effect, material, scene);
                    // Morph targets
                    (0, $alPCh.BindMorphTargetParameters)(renderingMesh, effect);
                    if (renderingMesh.morphTargetManager && renderingMesh.morphTargetManager.isUsingTextureForTargets) renderingMesh.morphTargetManager._bind(effect);
                    // Points cloud rendering
                    if (material.pointsCloud) effect.setFloat("pointSize", material.pointSize);
                }
                // Draw
                renderingMesh._processRendering(effectiveMesh, subMesh, effect, material.fillMode, batch, hardwareInstancedRendering, (isInstance, world)=>effect.setMatrix("world", world));
            }
        };
        this._depthMap.customRenderFunction = (opaqueSubMeshes, alphaTestSubMeshes, transparentSubMeshes, depthOnlySubMeshes)=>{
            let index;
            if (depthOnlySubMeshes.length) for(index = 0; index < depthOnlySubMeshes.length; index++)renderSubMesh(depthOnlySubMeshes.data[index]);
            for(index = 0; index < opaqueSubMeshes.length; index++)renderSubMesh(opaqueSubMeshes.data[index]);
            for(index = 0; index < alphaTestSubMeshes.length; index++)renderSubMesh(alphaTestSubMeshes.data[index]);
            if (this.forceDepthWriteTransparentMeshes) for(index = 0; index < transparentSubMeshes.length; index++)renderSubMesh(transparentSubMeshes.data[index]);
            else for(index = 0; index < transparentSubMeshes.length; index++)transparentSubMeshes.data[index].getEffectiveMesh()._internalAbstractMeshDataInfo._isActiveIntermediate = false;
        };
    }
    /**
     * Creates the depth rendering effect and checks if the effect is ready.
     * @param subMesh The submesh to be used to render the depth map of
     * @param useInstances If multiple world instances should be used
     * @returns if the depth renderer is ready to render the depth map
     */ isReady(subMesh, useInstances) {
        const engine = this._scene.getEngine();
        const mesh = subMesh.getMesh();
        const scene = mesh.getScene();
        const renderingMaterial = mesh._internalAbstractMeshDataInfo._materialForRenderPass?.[engine.currentRenderPassId];
        if (renderingMaterial) return renderingMaterial.isReadyForSubMesh(mesh, subMesh, useInstances);
        const material = subMesh.getMaterial();
        if (!material || material.disableDepthWrite) return false;
        const defines = [];
        const attribs = [
            (0, $b4i1f.VertexBuffer).PositionKind
        ];
        // Alpha test
        if (material && material.needAlphaTesting() && material.getAlphaTestTexture()) {
            defines.push("#define ALPHATEST");
            if (mesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UVKind)) {
                attribs.push((0, $b4i1f.VertexBuffer).UVKind);
                defines.push("#define UV1");
            }
            if (mesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UV2Kind)) {
                attribs.push((0, $b4i1f.VertexBuffer).UV2Kind);
                defines.push("#define UV2");
            }
        }
        // Bones
        if (mesh.useBones && mesh.computeBonesUsingShaders) {
            attribs.push((0, $b4i1f.VertexBuffer).MatricesIndicesKind);
            attribs.push((0, $b4i1f.VertexBuffer).MatricesWeightsKind);
            if (mesh.numBoneInfluencers > 4) {
                attribs.push((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind);
                attribs.push((0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind);
            }
            defines.push("#define NUM_BONE_INFLUENCERS " + mesh.numBoneInfluencers);
            defines.push("#define BonesPerMesh " + (mesh.skeleton ? mesh.skeleton.bones.length + 1 : 0));
            const skeleton = subMesh.getRenderingMesh().skeleton;
            if (skeleton?.isUsingTextureForMatrices) defines.push("#define BONETEXTURE");
        } else defines.push("#define NUM_BONE_INFLUENCERS 0");
        // Morph targets
        const morphTargetManager = mesh.morphTargetManager;
        let numMorphInfluencers = 0;
        if (morphTargetManager) {
            numMorphInfluencers = morphTargetManager.numMaxInfluencers || morphTargetManager.numInfluencers;
            if (numMorphInfluencers > 0) {
                defines.push("#define MORPHTARGETS");
                defines.push("#define NUM_MORPH_INFLUENCERS " + numMorphInfluencers);
                if (morphTargetManager.isUsingTextureForTargets) defines.push("#define MORPHTARGETS_TEXTURE");
                (0, $alPCh.PrepareAttributesForMorphTargetsInfluencers)(attribs, mesh, numMorphInfluencers);
            }
        }
        // Points cloud rendering
        if (material.pointsCloud) defines.push("#define POINTSIZE");
        // Instances
        if (useInstances) {
            defines.push("#define INSTANCES");
            (0, $alPCh.PushAttributesForInstances)(attribs);
            if (subMesh.getRenderingMesh().hasThinInstances) defines.push("#define THIN_INSTANCES");
        }
        // None linear depth
        if (this._storeNonLinearDepth) defines.push("#define NONLINEARDEPTH");
        // Store camera space Z coordinate instead of NDC Z
        if (this._storeCameraSpaceZ) defines.push("#define STORE_CAMERASPACE_Z");
        // Float Mode
        if (this.isPacked) defines.push("#define PACKED");
        // Clip planes
        (0, $aAFeM.prepareStringDefinesForClipPlanes)(material, scene, defines);
        // Get correct effect
        const drawWrapper = subMesh._getDrawWrapper(undefined, true);
        const cachedDefines = drawWrapper.defines;
        const join = defines.join("\n");
        if (cachedDefines !== join) {
            const uniforms = [
                "world",
                "mBones",
                "boneTextureWidth",
                "pointSize",
                "viewProjection",
                "view",
                "diffuseMatrix",
                "depthValues",
                "morphTargetInfluences",
                "morphTargetCount",
                "morphTargetTextureInfo",
                "morphTargetTextureIndices"
            ];
            (0, $aAFeM.addClipPlaneUniforms)(uniforms);
            drawWrapper.setEffect(engine.createEffect("depth", attribs, uniforms, [
                "diffuseSampler",
                "morphTargets",
                "boneSampler"
            ], join, undefined, undefined, undefined, {
                maxSimultaneousMorphTargets: numMorphInfluencers
            }), join);
        }
        return drawWrapper.effect.isReady();
    }
    /**
     * Gets the texture which the depth map will be written to.
     * @returns The depth map texture
     */ getDepthMap() {
        return this._depthMap;
    }
    /**
     * Disposes of the depth renderer.
     */ dispose() {
        const keysToDelete = [];
        for(const key in this._scene._depthRenderer){
            const depthRenderer = this._scene._depthRenderer[key];
            if (depthRenderer === this) keysToDelete.push(key);
        }
        if (keysToDelete.length > 0) {
            this._depthMap.dispose();
            for (const key of keysToDelete)delete this._scene._depthRenderer[key];
        }
    }
}
/**
 * @internal
 */ $0ab49a8db98eb6ea$export$7ca926ca0996efa0._SceneComponentInitialization = (_)=>{
    throw (0, $dUFYy._WarnImport)("DepthRendererSceneComponent");
};

});
parcelRegister("gO9ru", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("82O8L");
parcelRequire("SJ1ad");
parcelRequire("kg1CD");
const $c3c8a3e7689fda24$var$name = "depthPixelShader";
const $c3c8a3e7689fda24$var$shader = `#ifdef ALPHATEST
varying vec2 vUV;uniform sampler2D diffuseSampler;
#endif
#include<clipPlaneFragmentDeclaration>
varying float vDepthMetric;
#ifdef PACKED
#include<packingFunctions>
#endif
#ifdef STORE_CAMERASPACE_Z
varying vec4 vViewPos;
#endif
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{
#include<clipPlaneFragment>
#ifdef ALPHATEST
if (texture2D(diffuseSampler,vUV).a<0.4)
discard;
#endif
#ifdef STORE_CAMERASPACE_Z
#ifdef PACKED
gl_FragColor=pack(vViewPos.z);
#else
gl_FragColor=vec4(vViewPos.z,0.0,0.0,1.0);
#endif
#else
#ifdef NONLINEARDEPTH
#ifdef PACKED
gl_FragColor=pack(gl_FragCoord.z);
#else
gl_FragColor=vec4(gl_FragCoord.z,0.0,0.0,0.0);
#endif
#else
#ifdef PACKED
gl_FragColor=pack(vDepthMetric);
#else
gl_FragColor=vec4(vDepthMetric,0.0,0.0,1.0);
#endif
#endif
#endif
}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$c3c8a3e7689fda24$var$name] = $c3c8a3e7689fda24$var$shader;
const $c3c8a3e7689fda24$export$8948d2cc83a110ed = {
    name: $c3c8a3e7689fda24$var$name,
    shader: $c3c8a3e7689fda24$var$shader
};

});

parcelRegister("dKvV4", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("7PW7m");
parcelRequire("8kYMw");
parcelRequire("5Eb4I");
parcelRequire("9H5jp");
parcelRequire("4A4MM");
parcelRequire("k3wwH");
parcelRequire("3lbCX");
parcelRequire("9ulLS");
parcelRequire("LFrAO");
parcelRequire("apKdp");
parcelRequire("4idCt");
parcelRequire("cIweX");
parcelRequire("kqCfW");
parcelRequire("2NtPW");
const $a02854c48b9cb7a1$var$name = "depthVertexShader";
const $a02854c48b9cb7a1$var$shader = `attribute vec3 position;
#include<bonesDeclaration>
#include<bakedVertexAnimationDeclaration>
#include<morphTargetsVertexGlobalDeclaration>
#include<morphTargetsVertexDeclaration>[0..maxSimultaneousMorphTargets]
#include<clipPlaneVertexDeclaration>
#include<instancesDeclaration>
uniform mat4 viewProjection;uniform vec2 depthValues;
#if defined(ALPHATEST) || defined(NEED_UV)
varying vec2 vUV;uniform mat4 diffuseMatrix;
#ifdef UV1
attribute vec2 uv;
#endif
#ifdef UV2
attribute vec2 uv2;
#endif
#endif
#ifdef STORE_CAMERASPACE_Z
uniform mat4 view;varying vec4 vViewPos;
#endif
#include<pointCloudVertexDeclaration>
varying float vDepthMetric;
#define CUSTOM_VERTEX_DEFINITIONS
void main(void)
{vec3 positionUpdated=position;
#ifdef UV1
vec2 uvUpdated=uv;
#endif
#include<morphTargetsVertexGlobal>
#include<morphTargetsVertex>[0..maxSimultaneousMorphTargets]
#include<instancesVertex>
#include<bonesVertex>
#include<bakedVertexAnimation>
vec4 worldPos=finalWorld*vec4(positionUpdated,1.0);
#include<clipPlaneVertex>
gl_Position=viewProjection*worldPos;
#ifdef STORE_CAMERASPACE_Z
vViewPos=view*worldPos;
#else
#ifdef USE_REVERSE_DEPTHBUFFER
vDepthMetric=((-gl_Position.z+depthValues.x)/(depthValues.y));
#else
vDepthMetric=((gl_Position.z+depthValues.x)/(depthValues.y));
#endif
#endif
#if defined(ALPHATEST) || defined(BASIC_RENDER)
#ifdef UV1
vUV=vec2(diffuseMatrix*vec4(uvUpdated,1.0,0.0));
#endif
#ifdef UV2
vUV=vec2(diffuseMatrix*vec4(uv2,1.0,0.0));
#endif
#endif
#include<pointCloudVertex>
}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$a02854c48b9cb7a1$var$name] = $a02854c48b9cb7a1$var$shader;
const $a02854c48b9cb7a1$export$be6f2c0bc72b081 = {
    name: $a02854c48b9cb7a1$var$name,
    shader: $a02854c48b9cb7a1$var$shader
};

});
parcelRegister("3lbCX", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $26ec5a303c5e36be$var$name = "pointCloudVertexDeclaration";
const $26ec5a303c5e36be$var$shader = `#ifdef POINTSIZE
uniform float pointSize;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$26ec5a303c5e36be$var$name] = $26ec5a303c5e36be$var$shader;
const $26ec5a303c5e36be$export$1fe51c6b169a0d95 = {
    name: $26ec5a303c5e36be$var$name,
    shader: $26ec5a303c5e36be$var$shader
};

});



parcelRegister("lfM5G", function(module, exports) {

$parcel$export(module.exports, "MinMaxReducer", () => $f7904d7f236ffe25$export$8e43701e638cb399);

var $diGQf = parcelRequire("diGQf");

var $cFdBb = parcelRequire("cFdBb");

var $8MhbJ = parcelRequire("8MhbJ");
parcelRequire("h78iS");
class $f7904d7f236ffe25$export$8e43701e638cb399 {
    /**
     * Creates a min/max reducer
     * @param camera The camera to use for the post processes
     */ constructor(camera){
        /**
         * Observable triggered when the computation has been performed
         */ this.onAfterReductionPerformed = new (0, $diGQf.Observable)();
        this._forceFullscreenViewport = true;
        this._activated = false;
        this._camera = camera;
        this._postProcessManager = new (0, $8MhbJ.PostProcessManager)(camera.getScene());
        this._onContextRestoredObserver = camera.getEngine().onContextRestoredObservable.add(()=>{
            this._postProcessManager._rebuild();
        });
    }
    /**
     * Gets the texture used to read the values from.
     */ get sourceTexture() {
        return this._sourceTexture;
    }
    /**
     * Sets the source texture to read the values from.
     * One must indicate if the texture is a depth texture or not through the depthRedux parameter
     * because in such textures '1' value must not be taken into account to compute the maximum
     * as this value is used to clear the texture.
     * Note that the computation is not activated by calling this function, you must call activate() for that!
     * @param sourceTexture The texture to read the values from. The values should be in the red channel.
     * @param depthRedux Indicates if the texture is a depth texture or not
     * @param type The type of the textures created for the reduction (defaults to TEXTURETYPE_HALF_FLOAT)
     * @param forceFullscreenViewport Forces the post processes used for the reduction to be applied without taking into account viewport (defaults to true)
     */ setSourceTexture(sourceTexture, depthRedux, type = 2, forceFullscreenViewport = true) {
        if (sourceTexture === this._sourceTexture) return;
        this.dispose(false);
        this._sourceTexture = sourceTexture;
        this._reductionSteps = [];
        this._forceFullscreenViewport = forceFullscreenViewport;
        const scene = this._camera.getScene();
        // create the first step
        const reductionInitial = new (0, $cFdBb.PostProcess)("Initial reduction phase", "minmaxRedux", [
            "texSize"
        ], [
            "sourceTexture"
        ], 1.0, null, 1, scene.getEngine(), false, "#define INITIAL" + (depthRedux ? "\n#define DEPTH_REDUX" : ""), type, undefined, undefined, undefined, 7);
        reductionInitial.autoClear = false;
        reductionInitial.forceFullscreenViewport = forceFullscreenViewport;
        let w = this._sourceTexture.getRenderWidth(), h = this._sourceTexture.getRenderHeight();
        reductionInitial.onApply = ((w, h)=>{
            return (effect)=>{
                effect.setTexture("sourceTexture", this._sourceTexture);
                effect.setFloat2("texSize", w, h);
            };
        })(w, h);
        this._reductionSteps.push(reductionInitial);
        let index = 1;
        // create the additional steps
        while(w > 1 || h > 1){
            w = Math.max(Math.round(w / 2), 1);
            h = Math.max(Math.round(h / 2), 1);
            const reduction = new (0, $cFdBb.PostProcess)("Reduction phase " + index, "minmaxRedux", [
                "texSize"
            ], null, {
                width: w,
                height: h
            }, null, 1, scene.getEngine(), false, "#define " + (w == 1 && h == 1 ? "LAST" : w == 1 || h == 1 ? "ONEBEFORELAST" : "MAIN"), type, undefined, undefined, undefined, 7);
            reduction.autoClear = false;
            reduction.forceFullscreenViewport = forceFullscreenViewport;
            reduction.onApply = ((w, h)=>{
                return (effect)=>{
                    if (w == 1 || h == 1) effect.setInt2("texSize", w, h);
                    else effect.setFloat2("texSize", w, h);
                };
            })(w, h);
            this._reductionSteps.push(reduction);
            index++;
            if (w == 1 && h == 1) {
                const func = (w, h, reduction)=>{
                    const buffer = new Float32Array(4 * w * h), minmax = {
                        min: 0,
                        max: 0
                    };
                    return ()=>{
                        scene.getEngine()._readTexturePixels(reduction.inputTexture.texture, w, h, -1, 0, buffer, false);
                        minmax.min = buffer[0];
                        minmax.max = buffer[1];
                        this.onAfterReductionPerformed.notifyObservers(minmax);
                    };
                };
                reduction.onAfterRenderObservable.add(func(w, h, reduction));
            }
        }
    }
    /**
     * Defines the refresh rate of the computation.
     * Use 0 to compute just once, 1 to compute on every frame, 2 to compute every two frames and so on...
     */ get refreshRate() {
        return this._sourceTexture ? this._sourceTexture.refreshRate : -1;
    }
    set refreshRate(value) {
        if (this._sourceTexture) this._sourceTexture.refreshRate = value;
    }
    /**
     * Gets the activation status of the reducer
     */ get activated() {
        return this._activated;
    }
    /**
     * Activates the reduction computation.
     * When activated, the observers registered in onAfterReductionPerformed are
     * called after the computation is performed
     */ activate() {
        if (this._onAfterUnbindObserver || !this._sourceTexture) return;
        this._onAfterUnbindObserver = this._sourceTexture.onAfterUnbindObservable.add(()=>{
            const engine = this._camera.getScene().getEngine();
            engine._debugPushGroup?.(`min max reduction`, 1);
            this._reductionSteps[0].activate(this._camera);
            this._postProcessManager.directRender(this._reductionSteps, this._reductionSteps[0].inputTexture, this._forceFullscreenViewport);
            engine.unBindFramebuffer(this._reductionSteps[0].inputTexture, false);
            engine._debugPopGroup?.(1);
        });
        this._activated = true;
    }
    /**
     * Deactivates the reduction computation.
     */ deactivate() {
        if (!this._onAfterUnbindObserver || !this._sourceTexture) return;
        this._sourceTexture.onAfterUnbindObservable.remove(this._onAfterUnbindObserver);
        this._onAfterUnbindObserver = null;
        this._activated = false;
    }
    /**
     * Disposes the min/max reducer
     * @param disposeAll true to dispose all the resources. You should always call this function with true as the parameter (or without any parameter as it is the default one). This flag is meant to be used internally.
     */ dispose(disposeAll = true) {
        if (disposeAll) {
            this.onAfterReductionPerformed.clear();
            if (this._onContextRestoredObserver) {
                this._camera.getEngine().onContextRestoredObservable.remove(this._onContextRestoredObserver);
                this._onContextRestoredObserver = null;
            }
        }
        this.deactivate();
        if (this._reductionSteps) {
            for(let i = 0; i < this._reductionSteps.length; ++i)this._reductionSteps[i].dispose();
            this._reductionSteps = null;
        }
        if (this._postProcessManager && disposeAll) this._postProcessManager.dispose();
        this._sourceTexture = null;
    }
}

});
parcelRegister("h78iS", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $c75987feedaa57ca$var$name = "minmaxReduxPixelShader";
const $c75987feedaa57ca$var$shader = `varying vec2 vUV;uniform sampler2D textureSampler;
#if defined(INITIAL)
uniform sampler2D sourceTexture;uniform vec2 texSize;void main(void)
{ivec2 coord=ivec2(vUV*(texSize-1.0));float f1=texelFetch(sourceTexture,coord,0).r;float f2=texelFetch(sourceTexture,coord+ivec2(1,0),0).r;float f3=texelFetch(sourceTexture,coord+ivec2(1,1),0).r;float f4=texelFetch(sourceTexture,coord+ivec2(0,1),0).r;float minz=min(min(min(f1,f2),f3),f4);
#ifdef DEPTH_REDUX
float maxz=max(max(max(sign(1.0-f1)*f1,sign(1.0-f2)*f2),sign(1.0-f3)*f3),sign(1.0-f4)*f4);
#else
float maxz=max(max(max(f1,f2),f3),f4);
#endif
glFragColor=vec4(minz,maxz,0.,0.);}
#elif defined(MAIN)
uniform vec2 texSize;void main(void)
{ivec2 coord=ivec2(vUV*(texSize-1.0));vec2 f1=texelFetch(textureSampler,coord,0).rg;vec2 f2=texelFetch(textureSampler,coord+ivec2(1,0),0).rg;vec2 f3=texelFetch(textureSampler,coord+ivec2(1,1),0).rg;vec2 f4=texelFetch(textureSampler,coord+ivec2(0,1),0).rg;float minz=min(min(min(f1.x,f2.x),f3.x),f4.x);float maxz=max(max(max(f1.y,f2.y),f3.y),f4.y);glFragColor=vec4(minz,maxz,0.,0.);}
#elif defined(ONEBEFORELAST)
uniform ivec2 texSize;void main(void)
{ivec2 coord=ivec2(vUV*vec2(texSize-1));vec2 f1=texelFetch(textureSampler,coord % texSize,0).rg;vec2 f2=texelFetch(textureSampler,(coord+ivec2(1,0)) % texSize,0).rg;vec2 f3=texelFetch(textureSampler,(coord+ivec2(1,1)) % texSize,0).rg;vec2 f4=texelFetch(textureSampler,(coord+ivec2(0,1)) % texSize,0).rg;float minz=min(f1.x,f2.x);float maxz=max(f1.y,f2.y);glFragColor=vec4(minz,maxz,0.,0.);}
#elif defined(LAST)
void main(void)
{glFragColor=vec4(0.);if (true) { 
discard;}}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$c75987feedaa57ca$var$name] = $c75987feedaa57ca$var$shader;
const $c75987feedaa57ca$export$4cb5f07f4fae8686 = {
    name: $c75987feedaa57ca$var$name,
    shader: $c75987feedaa57ca$var$shader
};

});




parcelRegister("jJcGg", function(module, exports) {

$parcel$export(module.exports, "ShadowGeneratorSceneComponent", () => $e5cc0e6a9d5c3373$export$256065c354ff519f);

var $itc0L = parcelRequire("itc0L");

var $jFaMv = parcelRequire("jFaMv");

var $bv05l = parcelRequire("bv05l");

var $5Tqba = parcelRequire("5Tqba");
// Adds the parser to the scene parsers.
(0, $5Tqba.AbstractScene).AddParser((0, $bv05l.SceneComponentConstants).NAME_SHADOWGENERATOR, (parsedData, scene)=>{
    // Shadows
    if (parsedData.shadowGenerators !== undefined && parsedData.shadowGenerators !== null) for(let index = 0, cache = parsedData.shadowGenerators.length; index < cache; index++){
        const parsedShadowGenerator = parsedData.shadowGenerators[index];
        if (parsedShadowGenerator.className === (0, $jFaMv.CascadedShadowGenerator).CLASSNAME) (0, $jFaMv.CascadedShadowGenerator).Parse(parsedShadowGenerator, scene);
        else (0, $itc0L.ShadowGenerator).Parse(parsedShadowGenerator, scene);
    // SG would be available on their associated lights
    }
});
class $e5cc0e6a9d5c3373$export$256065c354ff519f {
    /**
     * Creates a new instance of the component for the given scene
     * @param scene Defines the scene to register the component in
     */ constructor(scene){
        /**
         * The component name helpful to identify the component in the list of scene components.
         */ this.name = (0, $bv05l.SceneComponentConstants).NAME_SHADOWGENERATOR;
        this.scene = scene;
    }
    /**
     * Registers the component in a given scene
     */ register() {
        this.scene._gatherRenderTargetsStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_GATHERRENDERTARGETS_SHADOWGENERATOR, this, this._gatherRenderTargets);
    }
    /**
     * Rebuilds the elements related to this component in case of
     * context lost for instance.
     */ rebuild() {
    // Nothing To Do Here.
    }
    /**
     * Serializes the component data to the specified json object
     * @param serializationObject The object to serialize to
     */ serialize(serializationObject) {
        // Shadows
        serializationObject.shadowGenerators = [];
        const lights = this.scene.lights;
        for (const light of lights){
            const shadowGenerators = light.getShadowGenerators();
            if (shadowGenerators) {
                const iterator = shadowGenerators.values();
                for(let key = iterator.next(); key.done !== true; key = iterator.next()){
                    const shadowGenerator = key.value;
                    serializationObject.shadowGenerators.push(shadowGenerator.serialize());
                }
            }
        }
    }
    /**
     * Adds all the elements from the container to the scene
     * @param container the container holding the elements
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    addFromContainer(container) {
    // Nothing To Do Here. (directly attached to a light)
    }
    /**
     * Removes all the elements in the container from the scene
     * @param container contains the elements to remove
     * @param dispose if the removed element should be disposed (default: false)
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    removeFromContainer(container, dispose) {
    // Nothing To Do Here. (directly attached to a light)
    }
    /**
     * Rebuilds the elements related to this component in case of
     * context lost for instance.
     */ dispose() {
    // Nothing To Do Here.
    }
    _gatherRenderTargets(renderTargets) {
        // Shadows
        const scene = this.scene;
        if (this.scene.shadowsEnabled) for(let lightIndex = 0; lightIndex < scene.lights.length; lightIndex++){
            const light = scene.lights[lightIndex];
            const shadowGenerators = light.getShadowGenerators();
            if (light.isEnabled() && light.shadowEnabled && shadowGenerators) {
                const iterator = shadowGenerators.values();
                for(let key = iterator.next(); key.done !== true; key = iterator.next()){
                    const shadowGenerator = key.value;
                    const shadowMap = shadowGenerator.getShadowMap();
                    if (scene.textures.indexOf(shadowMap) !== -1) renderTargets.push(shadowMap);
                }
            }
        }
    }
}
(0, $itc0L.ShadowGenerator)._SceneComponentInitialization = (scene)=>{
    let component = scene._getComponent((0, $bv05l.SceneComponentConstants).NAME_SHADOWGENERATOR);
    if (!component) {
        component = new $e5cc0e6a9d5c3373$export$256065c354ff519f(scene);
        scene._addComponent(component);
    }
};

});


parcelRegister("3r3bc", function(module, exports) {

$parcel$export(module.exports, "PointLight", () => $28065c1a125a7a39$export$4c9c1cb3f0b6f455);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $ha1VO = parcelRequire("ha1VO");

var $bgssx = parcelRequire("bgssx");

var $c6YWJ = parcelRequire("c6YWJ");

var $lso8g = parcelRequire("lso8g");
(0, $bgssx.Node).AddNodeConstructor("Light_Type_0", (name, scene)=>{
    return ()=>new $28065c1a125a7a39$export$4c9c1cb3f0b6f455(name, (0, $ha1VO.Vector3).Zero(), scene);
});
class $28065c1a125a7a39$export$4c9c1cb3f0b6f455 extends (0, $lso8g.ShadowLight) {
    /**
     * Getter: In case of direction provided, the shadow will not use a cube texture but simulate a spot shadow as a fallback
     * This specifies what angle the shadow will use to be created.
     *
     * It default to 90 degrees to work nicely with the cube texture generation for point lights shadow maps.
     */ get shadowAngle() {
        return this._shadowAngle;
    }
    /**
     * Setter: In case of direction provided, the shadow will not use a cube texture but simulate a spot shadow as a fallback
     * This specifies what angle the shadow will use to be created.
     *
     * It default to 90 degrees to work nicely with the cube texture generation for point lights shadow maps.
     */ set shadowAngle(value) {
        this._shadowAngle = value;
        this.forceProjectionMatrixCompute();
    }
    /**
     * Gets the direction if it has been set.
     * In case of direction provided, the shadow will not use a cube texture but simulate a spot shadow as a fallback
     */ get direction() {
        return this._direction;
    }
    /**
     * In case of direction provided, the shadow will not use a cube texture but simulate a spot shadow as a fallback
     */ set direction(value) {
        const previousNeedCube = this.needCube();
        this._direction = value;
        if (this.needCube() !== previousNeedCube && this._shadowGenerators) {
            const iterator = this._shadowGenerators.values();
            for(let key = iterator.next(); key.done !== true; key = iterator.next()){
                const shadowGenerator = key.value;
                shadowGenerator.recreateShadowMap();
            }
        }
    }
    /**
     * Creates a PointLight object from the passed name and position (Vector3) and adds it in the scene.
     * A PointLight emits the light in every direction.
     * It can cast shadows.
     * If the scene camera is already defined and you want to set your PointLight at the camera position, just set it :
     * ```javascript
     * var pointLight = new PointLight("pl", camera.position, scene);
     * ```
     * Documentation : https://doc.babylonjs.com/features/featuresDeepDive/lights/lights_introduction
     * @param name The light friendly name
     * @param position The position of the point light in the scene
     * @param scene The scene the lights belongs to
     */ constructor(name, position, scene){
        super(name, scene);
        this._shadowAngle = Math.PI / 2;
        this.position = position;
    }
    /**
     * Returns the string "PointLight"
     * @returns the class name
     */ getClassName() {
        return "PointLight";
    }
    /**
     * Returns the integer 0.
     * @returns The light Type id as a constant defines in Light.LIGHTTYPEID_x
     */ getTypeID() {
        return (0, $c6YWJ.Light).LIGHTTYPEID_POINTLIGHT;
    }
    /**
     * Specifies whether or not the shadowmap should be a cube texture.
     * @returns true if the shadowmap needs to be a cube texture.
     */ needCube() {
        return !this.direction;
    }
    /**
     * Returns a new Vector3 aligned with the PointLight cube system according to the passed cube face index (integer).
     * @param faceIndex The index of the face we are computed the direction to generate shadow
     * @returns The set direction in 2d mode otherwise the direction to the cubemap face if needCube() is true
     */ getShadowDirection(faceIndex) {
        if (this.direction) return super.getShadowDirection(faceIndex);
        else switch(faceIndex){
            case 0:
                return new (0, $ha1VO.Vector3)(1.0, 0.0, 0.0);
            case 1:
                return new (0, $ha1VO.Vector3)(-1, 0.0, 0.0);
            case 2:
                return new (0, $ha1VO.Vector3)(0.0, -1, 0.0);
            case 3:
                return new (0, $ha1VO.Vector3)(0.0, 1.0, 0.0);
            case 4:
                return new (0, $ha1VO.Vector3)(0.0, 0.0, 1.0);
            case 5:
                return new (0, $ha1VO.Vector3)(0.0, 0.0, -1);
        }
        return (0, $ha1VO.Vector3).Zero();
    }
    /**
     * Sets the passed matrix "matrix" as a left-handed perspective projection matrix with the following settings :
     * - fov = PI / 2
     * - aspect ratio : 1.0
     * - z-near and far equal to the active camera minZ and maxZ.
     * Returns the PointLight.
     * @param matrix
     * @param viewMatrix
     * @param renderList
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _setDefaultShadowProjectionMatrix(matrix, viewMatrix, renderList) {
        const activeCamera = this.getScene().activeCamera;
        if (!activeCamera) return;
        const minZ = this.shadowMinZ !== undefined ? this.shadowMinZ : activeCamera.minZ;
        const maxZ = this.shadowMaxZ !== undefined ? this.shadowMaxZ : activeCamera.maxZ;
        const useReverseDepthBuffer = this.getScene().getEngine().useReverseDepthBuffer;
        (0, $ha1VO.Matrix).PerspectiveFovLHToRef(this.shadowAngle, 1.0, useReverseDepthBuffer ? maxZ : minZ, useReverseDepthBuffer ? minZ : maxZ, matrix, true, this._scene.getEngine().isNDCHalfZRange, undefined, useReverseDepthBuffer);
    }
    _buildUniformLayout() {
        this._uniformBuffer.addUniform("vLightData", 4);
        this._uniformBuffer.addUniform("vLightDiffuse", 4);
        this._uniformBuffer.addUniform("vLightSpecular", 4);
        this._uniformBuffer.addUniform("vLightFalloff", 4);
        this._uniformBuffer.addUniform("shadowsInfo", 3);
        this._uniformBuffer.addUniform("depthValues", 2);
        this._uniformBuffer.create();
    }
    /**
     * Sets the passed Effect "effect" with the PointLight transformed position (or position, if none) and passed name (string).
     * @param effect The effect to update
     * @param lightIndex The index of the light in the effect to update
     * @returns The point light
     */ transferToEffect(effect, lightIndex) {
        if (this.computeTransformedInformation()) this._uniformBuffer.updateFloat4("vLightData", this.transformedPosition.x, this.transformedPosition.y, this.transformedPosition.z, 0.0, lightIndex);
        else this._uniformBuffer.updateFloat4("vLightData", this.position.x, this.position.y, this.position.z, 0, lightIndex);
        this._uniformBuffer.updateFloat4("vLightFalloff", this.range, this._inverseSquaredRange, 0, 0, lightIndex);
        return this;
    }
    transferToNodeMaterialEffect(effect, lightDataUniformName) {
        if (this.computeTransformedInformation()) effect.setFloat3(lightDataUniformName, this.transformedPosition.x, this.transformedPosition.y, this.transformedPosition.z);
        else effect.setFloat3(lightDataUniformName, this.position.x, this.position.y, this.position.z);
        return this;
    }
    /**
     * Prepares the list of defines specific to the light type.
     * @param defines the list of defines
     * @param lightIndex defines the index of the light for the effect
     */ prepareLightSpecificDefines(defines, lightIndex) {
        defines["POINTLIGHT" + lightIndex] = true;
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $28065c1a125a7a39$export$4c9c1cb3f0b6f455.prototype, "shadowAngle", null);

});


parcelRegister("8PAFk", function(module, exports) {
/* eslint-disable import/no-internal-modules */ 
var $8w1k3 = parcelRequire("8w1k3");

var $jb4Uv = parcelRequire("jb4Uv");

var $agoTA = parcelRequire("agoTA");

var $kixW2 = parcelRequire("kixW2");
$parcel$exportWildcard(module.exports, $8w1k3);
$parcel$exportWildcard(module.exports, $jb4Uv);
$parcel$exportWildcard(module.exports, $agoTA);
$parcel$exportWildcard(module.exports, $kixW2);

});
parcelRegister("8w1k3", function(module, exports) {

$parcel$export(module.exports, "DefaultLoadingScreen", () => $63325681016c7dcd$export$c5d4ab585ecdc16);

var $5YkyR = parcelRequire("5YkyR");
class $63325681016c7dcd$export$c5d4ab585ecdc16 {
    /**
     * Creates a new default loading screen
     * @param _renderingCanvas defines the canvas used to render the scene
     * @param _loadingText defines the default text to display
     * @param _loadingDivBackgroundColor defines the default background color
     */ constructor(_renderingCanvas, _loadingText = "", _loadingDivBackgroundColor = "black"){
        this._renderingCanvas = _renderingCanvas;
        this._loadingText = _loadingText;
        this._loadingDivBackgroundColor = _loadingDivBackgroundColor;
        // Resize
        this._resizeLoadingUI = ()=>{
            const canvasRect = this._renderingCanvas.getBoundingClientRect();
            const canvasPositioning = window.getComputedStyle(this._renderingCanvas).position;
            if (!this._loadingDiv) return;
            this._loadingDiv.style.position = canvasPositioning === "fixed" ? "fixed" : "absolute";
            this._loadingDiv.style.left = canvasRect.left + "px";
            this._loadingDiv.style.top = canvasRect.top + "px";
            this._loadingDiv.style.width = canvasRect.width + "px";
            this._loadingDiv.style.height = canvasRect.height + "px";
        };
    }
    /**
     * Function called to display the loading screen
     */ displayLoadingUI() {
        if (this._loadingDiv) // Do not add a loading screen if there is already one
        return;
        this._loadingDiv = document.createElement("div");
        this._loadingDiv.id = "babylonjsLoadingDiv";
        this._loadingDiv.style.opacity = "0";
        this._loadingDiv.style.transition = "opacity 1.5s ease";
        this._loadingDiv.style.pointerEvents = "none";
        this._loadingDiv.style.display = "grid";
        this._loadingDiv.style.gridTemplateRows = "100%";
        this._loadingDiv.style.gridTemplateColumns = "100%";
        this._loadingDiv.style.justifyItems = "center";
        this._loadingDiv.style.alignItems = "center";
        // Loading text
        this._loadingTextDiv = document.createElement("div");
        this._loadingTextDiv.style.position = "absolute";
        this._loadingTextDiv.style.left = "0";
        this._loadingTextDiv.style.top = "50%";
        this._loadingTextDiv.style.marginTop = "80px";
        this._loadingTextDiv.style.width = "100%";
        this._loadingTextDiv.style.height = "20px";
        this._loadingTextDiv.style.fontFamily = "Arial";
        this._loadingTextDiv.style.fontSize = "14px";
        this._loadingTextDiv.style.color = "white";
        this._loadingTextDiv.style.textAlign = "center";
        this._loadingTextDiv.style.zIndex = "1";
        this._loadingTextDiv.innerHTML = "Loading";
        this._loadingDiv.appendChild(this._loadingTextDiv);
        //set the predefined text
        this._loadingTextDiv.innerHTML = this._loadingText;
        // Generating keyframes
        this._style = document.createElement("style");
        this._style.type = "text/css";
        const keyFrames = `@-webkit-keyframes spin1 {\
                    0% { -webkit-transform: rotate(0deg);}
                    100% { -webkit-transform: rotate(360deg);}
                }\
                @keyframes spin1 {\
                    0% { transform: rotate(0deg);}
                    100% { transform: rotate(360deg);}
                }`;
        this._style.innerHTML = keyFrames;
        document.getElementsByTagName("head")[0].appendChild(this._style);
        const svgSupport = !!window.SVGSVGElement;
        // Loading img
        const imgBack = new Image();
        if (!$63325681016c7dcd$export$c5d4ab585ecdc16.DefaultLogoUrl) imgBack.src = !svgSupport ? "https://cdn.babylonjs.com/Assets/babylonLogo.png" : `data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxODAuMTcgMjA4LjA0Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZmZjt9LmNscy0ye2ZpbGw6I2UwNjg0Yjt9LmNscy0ze2ZpbGw6I2JiNDY0Yjt9LmNscy00e2ZpbGw6I2UwZGVkODt9LmNscy01e2ZpbGw6I2Q1ZDJjYTt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkJhYnlsb25Mb2dvPC90aXRsZT48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iUGFnZV9FbGVtZW50cyIgZGF0YS1uYW1lPSJQYWdlIEVsZW1lbnRzIj48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik05MC4wOSwwLDAsNTJWMTU2bDkwLjA5LDUyLDkwLjA4LTUyVjUyWiIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtMiIgcG9pbnRzPSIxODAuMTcgNTIuMDEgMTUxLjk3IDM1LjczIDEyNC44NSA1MS4zOSAxNTMuMDUgNjcuNjcgMTgwLjE3IDUyLjAxIi8+PHBvbHlnb24gY2xhc3M9ImNscy0yIiBwb2ludHM9IjI3LjEyIDY3LjY3IDExNy4yMSAxNS42NiA5MC4wOCAwIDAgNTIuMDEgMjcuMTIgNjcuNjciLz48cG9seWdvbiBjbGFzcz0iY2xzLTIiIHBvaW50cz0iNjEuODkgMTIwLjMgOTAuMDggMTM2LjU4IDExOC4yOCAxMjAuMyA5MC4wOCAxMDQuMDIgNjEuODkgMTIwLjMiLz48cG9seWdvbiBjbGFzcz0iY2xzLTMiIHBvaW50cz0iMTUzLjA1IDY3LjY3IDE1My4wNSAxNDAuMzcgOTAuMDggMTc2LjcyIDI3LjEyIDE0MC4zNyAyNy4xMiA2Ny42NyAwIDUyLjAxIDAgMTU2LjAzIDkwLjA4IDIwOC4wNCAxODAuMTcgMTU2LjAzIDE4MC4xNyA1Mi4wMSAxNTMuMDUgNjcuNjciLz48cG9seWdvbiBjbGFzcz0iY2xzLTMiIHBvaW50cz0iOTAuMDggNzEuNDYgNjEuODkgODcuNzQgNjEuODkgMTIwLjMgOTAuMDggMTA0LjAyIDExOC4yOCAxMjAuMyAxMTguMjggODcuNzQgOTAuMDggNzEuNDYiLz48cG9seWdvbiBjbGFzcz0iY2xzLTQiIHBvaW50cz0iMTUzLjA1IDY3LjY3IDExOC4yOCA4Ny43NCAxMTguMjggMTIwLjMgOTAuMDggMTM2LjU4IDkwLjA4IDE3Ni43MiAxNTMuMDUgMTQwLjM3IDE1My4wNSA2Ny42NyIvPjxwb2x5Z29uIGNsYXNzPSJjbHMtNSIgcG9pbnRzPSIyNy4xMiA2Ny42NyA2MS44OSA4Ny43NCA2MS44OSAxMjAuMyA5MC4wOCAxMzYuNTggOTAuMDggMTc2LjcyIDI3LjEyIDE0MC4zNyAyNy4xMiA2Ny42NyIvPjwvZz48L2c+PC9zdmc+`;
        else imgBack.src = $63325681016c7dcd$export$c5d4ab585ecdc16.DefaultLogoUrl;
        imgBack.style.width = "150px";
        imgBack.style.gridColumn = "1";
        imgBack.style.gridRow = "1";
        imgBack.style.top = "50%";
        imgBack.style.left = "50%";
        imgBack.style.transform = "translate(-50%, -50%)";
        imgBack.style.position = "absolute";
        const imageSpinnerContainer = document.createElement("div");
        imageSpinnerContainer.style.width = "300px";
        imageSpinnerContainer.style.gridColumn = "1";
        imageSpinnerContainer.style.gridRow = "1";
        imageSpinnerContainer.style.top = "50%";
        imageSpinnerContainer.style.left = "50%";
        imageSpinnerContainer.style.transform = "translate(-50%, -50%)";
        imageSpinnerContainer.style.position = "absolute";
        // Loading spinner
        const imgSpinner = new Image();
        if (!$63325681016c7dcd$export$c5d4ab585ecdc16.DefaultSpinnerUrl) imgSpinner.src = !svgSupport ? "https://cdn.babylonjs.com/Assets/loadingIcon.png" : `data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzOTIgMzkyIj48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2UwNjg0Yjt9LmNscy0ye2ZpbGw6bm9uZTt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPlNwaW5uZXJJY29uPC90aXRsZT48ZyBpZD0iTGF5ZXJfMiIgZGF0YS1uYW1lPSJMYXllciAyIj48ZyBpZD0iU3Bpbm5lciI+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNNDAuMjEsMTI2LjQzYzMuNy03LjMxLDcuNjctMTQuNDQsMTItMjEuMzJsMy4zNi01LjEsMy41Mi01YzEuMjMtMS42MywyLjQxLTMuMjksMy42NS00LjkxczIuNTMtMy4yMSwzLjgyLTQuNzlBMTg1LjIsMTg1LjIsMCwwLDEsODMuNCw2Ny40M2EyMDgsMjA4LDAsMCwxLDE5LTE1LjY2YzMuMzUtMi40MSw2Ljc0LTQuNzgsMTAuMjUtN3M3LjExLTQuMjgsMTAuNzUtNi4zMmM3LjI5LTQsMTQuNzMtOCwyMi41My0xMS40OSwzLjktMS43Miw3Ljg4LTMuMywxMi00LjY0YTEwNC4yMiwxMDQuMjIsMCwwLDEsMTIuNDQtMy4yMyw2Mi40NCw2Mi40NCwwLDAsMSwxMi43OC0xLjM5QTI1LjkyLDI1LjkyLDAsMCwxLDE5NiwyMS40NGE2LjU1LDYuNTUsMCwwLDEsMi4wNSw5LDYuNjYsNi42NiwwLDAsMS0xLjY0LDEuNzhsLS40MS4yOWEyMi4wNywyMi4wNywwLDAsMS01Ljc4LDMsMzAuNDIsMzAuNDIsMCwwLDEtNS42NywxLjYyLDM3LjgyLDM3LjgyLDAsMCwxLTUuNjkuNzFjLTEsMC0xLjkuMTgtMi44NS4yNmwtMi44NS4yNHEtNS43Mi41MS0xMS40OCwxLjFjLTMuODQuNC03LjcxLjgyLTExLjU4LDEuNGExMTIuMzQsMTEyLjM0LDAsMCwwLTIyLjk0LDUuNjFjLTMuNzIsMS4zNS03LjM0LDMtMTAuOTQsNC42NHMtNy4xNCwzLjUxLTEwLjYsNS41MUExNTEuNiwxNTEuNiwwLDAsMCw2OC41Niw4N0M2Ny4yMyw4OC40OCw2Niw5MCw2NC42NCw5MS41NnMtMi41MSwzLjE1LTMuNzUsNC43M2wtMy41NCw0LjljLTEuMTMsMS42Ni0yLjIzLDMuMzUtMy4zMyw1YTEyNywxMjcsMCwwLDAtMTAuOTMsMjEuNDksMS41OCwxLjU4LDAsMSwxLTMtMS4xNVM0MC4xOSwxMjYuNDcsNDAuMjEsMTI2LjQzWiIvPjxyZWN0IGNsYXNzPSJjbHMtMiIgd2lkdGg9IjM5MiIgaGVpZ2h0PSIzOTIiLz48L2c+PC9nPjwvc3ZnPg==`;
        else imgSpinner.src = $63325681016c7dcd$export$c5d4ab585ecdc16.DefaultSpinnerUrl;
        imgSpinner.style.animation = "spin1 0.75s infinite linear";
        imgSpinner.style.webkitAnimation = "spin1 0.75s infinite linear";
        imgSpinner.style.transformOrigin = "50% 50%";
        imgSpinner.style.webkitTransformOrigin = "50% 50%";
        if (!svgSupport) {
            const logoSize = {
                w: 16,
                h: 18.5
            };
            const loadingSize = {
                w: 30,
                h: 30
            };
            // set styling correctly
            imgBack.style.width = `${logoSize.w}vh`;
            imgBack.style.height = `${logoSize.h}vh`;
            imgBack.style.left = `calc(50% - ${logoSize.w / 2}vh)`;
            imgBack.style.top = `calc(50% - ${logoSize.h / 2}vh)`;
            imgSpinner.style.width = `${loadingSize.w}vh`;
            imgSpinner.style.height = `${loadingSize.h}vh`;
            imgSpinner.style.left = `calc(50% - ${loadingSize.w / 2}vh)`;
            imgSpinner.style.top = `calc(50% - ${loadingSize.h / 2}vh)`;
        }
        imageSpinnerContainer.appendChild(imgSpinner);
        this._loadingDiv.appendChild(imgBack);
        this._loadingDiv.appendChild(imageSpinnerContainer);
        this._resizeLoadingUI();
        window.addEventListener("resize", this._resizeLoadingUI);
        this._loadingDiv.style.backgroundColor = this._loadingDivBackgroundColor;
        document.body.appendChild(this._loadingDiv);
        this._loadingDiv.style.opacity = "1";
    }
    /**
     * Function called to hide the loading screen
     */ hideLoadingUI() {
        if (!this._loadingDiv) return;
        const onTransitionEnd = ()=>{
            if (this._loadingTextDiv) {
                this._loadingTextDiv.remove();
                this._loadingTextDiv = null;
            }
            if (this._loadingDiv) {
                this._loadingDiv.remove();
                this._loadingDiv = null;
            }
            if (this._style) {
                this._style.remove();
                this._style = null;
            }
            window.removeEventListener("resize", this._resizeLoadingUI);
        };
        this._loadingDiv.style.opacity = "0";
        this._loadingDiv.addEventListener("transitionend", onTransitionEnd);
    }
    /**
     * Gets or sets the text to display while loading
     */ set loadingUIText(text) {
        this._loadingText = text;
        if (this._loadingTextDiv) this._loadingTextDiv.innerHTML = this._loadingText;
    }
    get loadingUIText() {
        return this._loadingText;
    }
    /**
     * Gets or sets the color to use for the background
     */ get loadingUIBackgroundColor() {
        return this._loadingDivBackgroundColor;
    }
    set loadingUIBackgroundColor(color) {
        this._loadingDivBackgroundColor = color;
        if (!this._loadingDiv) return;
        this._loadingDiv.style.backgroundColor = this._loadingDivBackgroundColor;
    }
}
/** Gets or sets the logo url to use for the default loading screen */ $63325681016c7dcd$export$c5d4ab585ecdc16.DefaultLogoUrl = "";
/** Gets or sets the spinner url to use for the default loading screen */ $63325681016c7dcd$export$c5d4ab585ecdc16.DefaultSpinnerUrl = "";
(0, $5YkyR.Engine).DefaultLoadingScreenFactory = (canvas)=>{
    return new $63325681016c7dcd$export$c5d4ab585ecdc16(canvas);
};

});

parcelRegister("jb4Uv", function(module, exports) {

var $bgKzS = parcelRequire("bgKzS");
$parcel$exportWildcard(module.exports, $bgKzS);

});
parcelRegister("bgKzS", function(module, exports) {

$parcel$export(module.exports, "_BabylonLoaderRegistered", () => $834551b1d1b9902f$export$e8b450b78fbae6e6);
$parcel$export(module.exports, "BabylonFileLoaderConfiguration", () => $834551b1d1b9902f$export$b26905abc1f61e3e);

var $kVtWi = parcelRequire("kVtWi");

var $74SKQ = parcelRequire("74SKQ");

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $fbuqw = parcelRequire("fbuqw");

var $FUHfe = parcelRequire("FUHfe");

var $klshO = parcelRequire("klshO");

var $54229 = parcelRequire("54229");

var $3zFLd = parcelRequire("3zFLd");

var $iPQLf = parcelRequire("iPQLf");

var $6Y7JP = parcelRequire("6Y7JP");

var $1LmZt = parcelRequire("1LmZt");

var $c6YWJ = parcelRequire("c6YWJ");

var $bv05l = parcelRequire("bv05l");

var $agoTA = parcelRequire("agoTA");

var $5Tqba = parcelRequire("5Tqba");

var $kMzus = parcelRequire("kMzus");

var $ebhJB = parcelRequire("ebhJB");

var $3RnX0 = parcelRequire("3RnX0");

var $c9v5E = parcelRequire("c9v5E");

var $9l7E8 = parcelRequire("9l7E8");

var $9o1yl = parcelRequire("9o1yl");

var $hEg94 = parcelRequire("hEg94");

var $lxthF = parcelRequire("lxthF");

var $8DoUR = parcelRequire("8DoUR");

var $bOhSV = parcelRequire("bOhSV");

var $cFdBb = parcelRequire("cFdBb");

var $CnKcI = parcelRequire("CnKcI");
var $834551b1d1b9902f$export$e8b450b78fbae6e6 = true;
class $834551b1d1b9902f$export$b26905abc1f61e3e {
}
/**
 * The loader does not allow injecting custom physics engine into the plugins.
 * Unfortunately in ES6, we need to manually inject them into the plugin.
 * So you could set this variable to your engine import to make it work.
 */ $834551b1d1b9902f$export$b26905abc1f61e3e.LoaderInjectedPhysicsEngine = undefined;
let $834551b1d1b9902f$var$tempIndexContainer = {};
let $834551b1d1b9902f$var$tempMaterialIndexContainer = {};
const $834551b1d1b9902f$var$parseMaterialByPredicate = (predicate, parsedData, scene, rootUrl)=>{
    if (!parsedData.materials) return null;
    for(let index = 0, cache = parsedData.materials.length; index < cache; index++){
        const parsedMaterial = parsedData.materials[index];
        if (predicate(parsedMaterial)) return {
            parsedMaterial: parsedMaterial,
            material: (0, $54229.Material).Parse(parsedMaterial, scene, rootUrl)
        };
    }
    return null;
};
const $834551b1d1b9902f$var$isDescendantOf = (mesh, names, hierarchyIds)=>{
    for(const i in names)if (mesh.name === names[i]) {
        hierarchyIds.push(mesh.id);
        return true;
    }
    if (mesh.parentId !== undefined && hierarchyIds.indexOf(mesh.parentId) !== -1) {
        hierarchyIds.push(mesh.id);
        return true;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/naming-convention
const $834551b1d1b9902f$var$logOperation = (operation, producer)=>{
    return operation + " of " + (producer ? producer.file + " from " + producer.name + " version: " + producer.version + ", exporter version: " + producer.exporter_version : "unknown");
};
const $834551b1d1b9902f$var$loadDetailLevels = (scene, mesh)=>{
    const mastermesh = mesh;
    // Every value specified in the ids array of the lod data points to another mesh which should be used as the lower LOD level.
    // The distances (or coverages) array values specified are used along with the lod mesh ids as a hint to determine the switching threshold for the various LODs.
    if (mesh._waitingData.lods) {
        if (mesh._waitingData.lods.ids && mesh._waitingData.lods.ids.length > 0) {
            const lodmeshes = mesh._waitingData.lods.ids;
            const wasenabled = mastermesh.isEnabled(false);
            if (mesh._waitingData.lods.distances) {
                const distances = mesh._waitingData.lods.distances;
                if (distances.length >= lodmeshes.length) {
                    const culling = distances.length > lodmeshes.length ? distances[distances.length - 1] : 0;
                    mastermesh.setEnabled(false);
                    for(let index = 0; index < lodmeshes.length; index++){
                        const lodid = lodmeshes[index];
                        const lodmesh = scene.getMeshById(lodid);
                        if (lodmesh != null) mastermesh.addLODLevel(distances[index], lodmesh);
                    }
                    if (culling > 0) mastermesh.addLODLevel(culling, null);
                    if (wasenabled === true) mastermesh.setEnabled(true);
                } else (0, $bOhSV.Tools).Warn("Invalid level of detail distances for " + mesh.name);
            }
        }
        mesh._waitingData.lods = null;
    }
};
const $834551b1d1b9902f$var$findParent = (parentId, parentInstanceIndex, scene)=>{
    if (typeof parentId !== "number") {
        const parentEntry = scene.getLastEntryById(parentId);
        if (parentEntry && parentInstanceIndex !== undefined && parentInstanceIndex !== null) {
            const instance = parentEntry.instances[parseInt(parentInstanceIndex)];
            return instance;
        }
        return parentEntry;
    }
    const parent = $834551b1d1b9902f$var$tempIndexContainer[parentId];
    if (parent && parentInstanceIndex !== undefined && parentInstanceIndex !== null) {
        const instance = parent.instances[parseInt(parentInstanceIndex)];
        return instance;
    }
    return parent;
};
const $834551b1d1b9902f$var$findMaterial = (materialId, scene)=>{
    if (typeof materialId !== "number") return scene.getLastMaterialById(materialId, true);
    return $834551b1d1b9902f$var$tempMaterialIndexContainer[materialId];
};
const $834551b1d1b9902f$var$loadAssetContainer = (scene, data, rootUrl, onError, addToScene = false)=>{
    const container = new (0, $kMzus.AssetContainer)(scene);
    // Entire method running in try block, so ALWAYS logs as far as it got, only actually writes details
    // when SceneLoader.debugLogging = true (default), or exception encountered.
    // Everything stored in var log instead of writing separate lines to support only writing in exception,
    // and avoid problems with multiple concurrent .babylon loads.
    let log = "importScene has failed JSON parse";
    try {
        // eslint-disable-next-line no-var
        var parsedData = JSON.parse(data);
        log = "";
        const fullDetails = (0, $agoTA.SceneLoader).loggingLevel === (0, $agoTA.SceneLoader).DETAILED_LOGGING;
        let index;
        let cache;
        // Environment texture
        if (parsedData.environmentTexture !== undefined && parsedData.environmentTexture !== null) {
            // PBR needed for both HDR texture (gamma space) & a sky box
            const isPBR = parsedData.isPBR !== undefined ? parsedData.isPBR : true;
            if (parsedData.environmentTextureType && parsedData.environmentTextureType === "BABYLON.HDRCubeTexture") {
                const hdrSize = parsedData.environmentTextureSize ? parsedData.environmentTextureSize : 128;
                const hdrTexture = new (0, $6Y7JP.HDRCubeTexture)((parsedData.environmentTexture.match(/https?:\/\//g) ? "" : rootUrl) + parsedData.environmentTexture, scene, hdrSize, true, !isPBR, undefined, parsedData.environmentTexturePrefilterOnLoad);
                if (parsedData.environmentTextureRotationY) hdrTexture.rotationY = parsedData.environmentTextureRotationY;
                scene.environmentTexture = hdrTexture;
            } else {
                if (typeof parsedData.environmentTexture === "object") {
                    const environmentTexture = (0, $iPQLf.CubeTexture).Parse(parsedData.environmentTexture, scene, rootUrl);
                    scene.environmentTexture = environmentTexture;
                } else if (parsedData.environmentTexture.endsWith(".env")) {
                    const compressedTexture = new (0, $iPQLf.CubeTexture)((parsedData.environmentTexture.match(/https?:\/\//g) ? "" : rootUrl) + parsedData.environmentTexture, scene, parsedData.environmentTextureForcedExtension);
                    if (parsedData.environmentTextureRotationY) compressedTexture.rotationY = parsedData.environmentTextureRotationY;
                    scene.environmentTexture = compressedTexture;
                } else {
                    const cubeTexture = (0, $iPQLf.CubeTexture).CreateFromPrefilteredData((parsedData.environmentTexture.match(/https?:\/\//g) ? "" : rootUrl) + parsedData.environmentTexture, scene, parsedData.environmentTextureForcedExtension);
                    if (parsedData.environmentTextureRotationY) cubeTexture.rotationY = parsedData.environmentTextureRotationY;
                    scene.environmentTexture = cubeTexture;
                }
            }
            if (parsedData.createDefaultSkybox === true) {
                const skyboxScale = scene.activeCamera !== undefined && scene.activeCamera !== null ? (scene.activeCamera.maxZ - scene.activeCamera.minZ) / 2 : 1000;
                const skyboxBlurLevel = parsedData.skyboxBlurLevel || 0;
                scene.createDefaultSkybox(scene.environmentTexture, isPBR, skyboxScale, skyboxBlurLevel);
            }
            container.environmentTexture = scene.environmentTexture;
        }
        // Environment Intensity
        if (parsedData.environmentIntensity !== undefined && parsedData.environmentIntensity !== null) scene.environmentIntensity = parsedData.environmentIntensity;
        // Lights
        if (parsedData.lights !== undefined && parsedData.lights !== null) for(index = 0, cache = parsedData.lights.length; index < cache; index++){
            const parsedLight = parsedData.lights[index];
            const light = (0, $c6YWJ.Light).Parse(parsedLight, scene);
            if (light) {
                $834551b1d1b9902f$var$tempIndexContainer[parsedLight.uniqueId] = light;
                container.lights.push(light);
                light._parentContainer = container;
                log += index === 0 ? "\n\tLights:" : "";
                log += "\n\t\t" + light.toString(fullDetails);
            }
        }
        // Reflection probes
        if (parsedData.reflectionProbes !== undefined && parsedData.reflectionProbes !== null) for(index = 0, cache = parsedData.reflectionProbes.length; index < cache; index++){
            const parsedReflectionProbe = parsedData.reflectionProbes[index];
            const reflectionProbe = (0, $lxthF.ReflectionProbe).Parse(parsedReflectionProbe, scene, rootUrl);
            if (reflectionProbe) {
                container.reflectionProbes.push(reflectionProbe);
                reflectionProbe._parentContainer = container;
                log += index === 0 ? "\n\tReflection Probes:" : "";
                log += "\n\t\t" + reflectionProbe.toString(fullDetails);
            }
        }
        // Animations
        if (parsedData.animations !== undefined && parsedData.animations !== null) for(index = 0, cache = parsedData.animations.length; index < cache; index++){
            const parsedAnimation = parsedData.animations[index];
            const internalClass = (0, $8DoUR.GetClass)("BABYLON.Animation");
            if (internalClass) {
                const animation = internalClass.Parse(parsedAnimation);
                scene.animations.push(animation);
                container.animations.push(animation);
                log += index === 0 ? "\n\tAnimations:" : "";
                log += "\n\t\t" + animation.toString(fullDetails);
            }
        }
        // Materials
        if (parsedData.materials !== undefined && parsedData.materials !== null) for(index = 0, cache = parsedData.materials.length; index < cache; index++){
            const parsedMaterial = parsedData.materials[index];
            const mat = (0, $54229.Material).Parse(parsedMaterial, scene, rootUrl);
            if (mat) {
                $834551b1d1b9902f$var$tempMaterialIndexContainer[parsedMaterial.uniqueId || parsedMaterial.id] = mat;
                container.materials.push(mat);
                mat._parentContainer = container;
                log += index === 0 ? "\n\tMaterials:" : "";
                log += "\n\t\t" + mat.toString(fullDetails);
                // Textures
                const textures = mat.getActiveTextures();
                textures.forEach((t)=>{
                    if (container.textures.indexOf(t) == -1) {
                        container.textures.push(t);
                        t._parentContainer = container;
                    }
                });
            }
        }
        if (parsedData.multiMaterials !== undefined && parsedData.multiMaterials !== null) for(index = 0, cache = parsedData.multiMaterials.length; index < cache; index++){
            const parsedMultiMaterial = parsedData.multiMaterials[index];
            const mmat = (0, $3zFLd.MultiMaterial).ParseMultiMaterial(parsedMultiMaterial, scene);
            $834551b1d1b9902f$var$tempMaterialIndexContainer[parsedMultiMaterial.uniqueId || parsedMultiMaterial.id] = mmat;
            container.multiMaterials.push(mmat);
            mmat._parentContainer = container;
            log += index === 0 ? "\n\tMultiMaterials:" : "";
            log += "\n\t\t" + mmat.toString(fullDetails);
            // Textures
            const textures = mmat.getActiveTextures();
            textures.forEach((t)=>{
                if (container.textures.indexOf(t) == -1) {
                    container.textures.push(t);
                    t._parentContainer = container;
                }
            });
        }
        // Morph targets
        if (parsedData.morphTargetManagers !== undefined && parsedData.morphTargetManagers !== null) for (const managerData of parsedData.morphTargetManagers){
            const manager = (0, $c9v5E.MorphTargetManager).Parse(managerData, scene);
            container.morphTargetManagers.push(manager);
            manager._parentContainer = container;
        }
        // Skeletons
        if (parsedData.skeletons !== undefined && parsedData.skeletons !== null) for(index = 0, cache = parsedData.skeletons.length; index < cache; index++){
            const parsedSkeleton = parsedData.skeletons[index];
            const skeleton = (0, $3RnX0.Skeleton).Parse(parsedSkeleton, scene);
            container.skeletons.push(skeleton);
            skeleton._parentContainer = container;
            log += index === 0 ? "\n\tSkeletons:" : "";
            log += "\n\t\t" + skeleton.toString(fullDetails);
        }
        // Geometries
        const geometries = parsedData.geometries;
        if (geometries !== undefined && geometries !== null) {
            const addedGeometry = new Array();
            // VertexData
            const vertexData = geometries.vertexData;
            if (vertexData !== undefined && vertexData !== null) for(index = 0, cache = vertexData.length; index < cache; index++){
                const parsedVertexData = vertexData[index];
                addedGeometry.push((0, $FUHfe.Geometry).Parse(parsedVertexData, scene, rootUrl));
            }
            addedGeometry.forEach((g)=>{
                if (g) {
                    container.geometries.push(g);
                    g._parentContainer = container;
                }
            });
        }
        // Transform nodes
        if (parsedData.transformNodes !== undefined && parsedData.transformNodes !== null) for(index = 0, cache = parsedData.transformNodes.length; index < cache; index++){
            const parsedTransformNode = parsedData.transformNodes[index];
            const node = (0, $klshO.TransformNode).Parse(parsedTransformNode, scene, rootUrl);
            $834551b1d1b9902f$var$tempIndexContainer[parsedTransformNode.uniqueId] = node;
            container.transformNodes.push(node);
            node._parentContainer = container;
        }
        // Meshes
        if (parsedData.meshes !== undefined && parsedData.meshes !== null) for(index = 0, cache = parsedData.meshes.length; index < cache; index++){
            const parsedMesh = parsedData.meshes[index];
            const mesh = (0, $fbuqw.Mesh).Parse(parsedMesh, scene, rootUrl);
            $834551b1d1b9902f$var$tempIndexContainer[parsedMesh.uniqueId] = mesh;
            container.meshes.push(mesh);
            mesh._parentContainer = container;
            if (mesh.hasInstances) for (const instance of mesh.instances){
                container.meshes.push(instance);
                instance._parentContainer = container;
            }
            log += index === 0 ? "\n\tMeshes:" : "";
            log += "\n\t\t" + mesh.toString(fullDetails);
        }
        // Cameras
        if (parsedData.cameras !== undefined && parsedData.cameras !== null) for(index = 0, cache = parsedData.cameras.length; index < cache; index++){
            const parsedCamera = parsedData.cameras[index];
            const camera = (0, $74SKQ.Camera).Parse(parsedCamera, scene);
            $834551b1d1b9902f$var$tempIndexContainer[parsedCamera.uniqueId] = camera;
            container.cameras.push(camera);
            camera._parentContainer = container;
            log += index === 0 ? "\n\tCameras:" : "";
            log += "\n\t\t" + camera.toString(fullDetails);
        }
        // Postprocesses
        if (parsedData.postProcesses !== undefined && parsedData.postProcesses !== null) for(index = 0, cache = parsedData.postProcesses.length; index < cache; index++){
            const parsedPostProcess = parsedData.postProcesses[index];
            const postProcess = (0, $cFdBb.PostProcess).Parse(parsedPostProcess, scene, rootUrl);
            if (postProcess) {
                container.postProcesses.push(postProcess);
                postProcess._parentContainer = container;
                log += index === 0 ? "\nPostprocesses:" : "";
                log += "\n\t\t" + postProcess.toString();
            }
        }
        // Animation Groups
        if (parsedData.animationGroups !== undefined && parsedData.animationGroups !== null) for(index = 0, cache = parsedData.animationGroups.length; index < cache; index++){
            const parsedAnimationGroup = parsedData.animationGroups[index];
            const animationGroup = (0, $1LmZt.AnimationGroup).Parse(parsedAnimationGroup, scene);
            container.animationGroups.push(animationGroup);
            animationGroup._parentContainer = container;
            log += index === 0 ? "\n\tAnimationGroups:" : "";
            log += "\n\t\t" + animationGroup.toString(fullDetails);
        }
        // Sprites
        if (parsedData.spriteManagers) for(let index = 0, cache = parsedData.spriteManagers.length; index < cache; index++){
            const parsedSpriteManager = parsedData.spriteManagers[index];
            const spriteManager = (0, $CnKcI.SpriteManager).Parse(parsedSpriteManager, scene, rootUrl);
            log += "\n\t\tSpriteManager " + spriteManager.name;
        }
        // Browsing all the graph to connect the dots
        for(index = 0, cache = scene.cameras.length; index < cache; index++){
            const camera = scene.cameras[index];
            if (camera._waitingParentId !== null) {
                camera.parent = $834551b1d1b9902f$var$findParent(camera._waitingParentId, camera._waitingParentInstanceIndex, scene);
                camera._waitingParentId = null;
                camera._waitingParentInstanceIndex = null;
            }
        }
        for(index = 0, cache = scene.lights.length; index < cache; index++){
            const light = scene.lights[index];
            if (light && light._waitingParentId !== null) {
                light.parent = $834551b1d1b9902f$var$findParent(light._waitingParentId, light._waitingParentInstanceIndex, scene);
                light._waitingParentId = null;
                light._waitingParentInstanceIndex = null;
            }
        }
        // Connect parents & children and parse actions and lods
        for(index = 0, cache = scene.transformNodes.length; index < cache; index++){
            const transformNode = scene.transformNodes[index];
            if (transformNode._waitingParentId !== null) {
                transformNode.parent = $834551b1d1b9902f$var$findParent(transformNode._waitingParentId, transformNode._waitingParentInstanceIndex, scene);
                transformNode._waitingParentId = null;
                transformNode._waitingParentInstanceIndex = null;
            }
        }
        for(index = 0, cache = scene.meshes.length; index < cache; index++){
            const mesh = scene.meshes[index];
            if (mesh._waitingParentId !== null) {
                mesh.parent = $834551b1d1b9902f$var$findParent(mesh._waitingParentId, mesh._waitingParentInstanceIndex, scene);
                mesh._waitingParentId = null;
                mesh._waitingParentInstanceIndex = null;
            }
            if (mesh._waitingData.lods) $834551b1d1b9902f$var$loadDetailLevels(scene, mesh);
        }
        // link multimats with materials
        scene.multiMaterials.forEach((multimat)=>{
            multimat._waitingSubMaterialsUniqueIds.forEach((subMaterial)=>{
                multimat.subMaterials.push($834551b1d1b9902f$var$findMaterial(subMaterial, scene));
            });
            multimat._waitingSubMaterialsUniqueIds = [];
        });
        // link meshes with materials
        scene.meshes.forEach((mesh)=>{
            if (mesh._waitingMaterialId !== null) {
                mesh.material = $834551b1d1b9902f$var$findMaterial(mesh._waitingMaterialId, scene);
                mesh._waitingMaterialId = null;
            }
        });
        // link skeleton transform nodes
        for(index = 0, cache = scene.skeletons.length; index < cache; index++){
            const skeleton = scene.skeletons[index];
            if (skeleton._hasWaitingData) {
                if (skeleton.bones != null) skeleton.bones.forEach((bone)=>{
                    if (bone._waitingTransformNodeId) {
                        const linkTransformNode = scene.getLastEntryById(bone._waitingTransformNodeId);
                        if (linkTransformNode) bone.linkTransformNode(linkTransformNode);
                        bone._waitingTransformNodeId = null;
                    }
                });
                skeleton._hasWaitingData = null;
            }
        }
        // freeze world matrix application
        for(index = 0, cache = scene.meshes.length; index < cache; index++){
            const currentMesh = scene.meshes[index];
            if (currentMesh._waitingData.freezeWorldMatrix) {
                currentMesh.freezeWorldMatrix();
                currentMesh._waitingData.freezeWorldMatrix = null;
            } else currentMesh.computeWorldMatrix(true);
        }
        // Lights exclusions / inclusions
        for(index = 0, cache = scene.lights.length; index < cache; index++){
            const light = scene.lights[index];
            // Excluded check
            if (light._excludedMeshesIds.length > 0) {
                for(let excludedIndex = 0; excludedIndex < light._excludedMeshesIds.length; excludedIndex++){
                    const excludedMesh = scene.getMeshById(light._excludedMeshesIds[excludedIndex]);
                    if (excludedMesh) light.excludedMeshes.push(excludedMesh);
                }
                light._excludedMeshesIds = [];
            }
            // Included check
            if (light._includedOnlyMeshesIds.length > 0) {
                for(let includedOnlyIndex = 0; includedOnlyIndex < light._includedOnlyMeshesIds.length; includedOnlyIndex++){
                    const includedOnlyMesh = scene.getMeshById(light._includedOnlyMeshesIds[includedOnlyIndex]);
                    if (includedOnlyMesh) light.includedOnlyMeshes.push(includedOnlyMesh);
                }
                light._includedOnlyMeshesIds = [];
            }
        }
        scene.geometries.forEach((g)=>{
            g._loadedUniqueId = "";
        });
        (0, $5Tqba.AbstractScene).Parse(parsedData, scene, container, rootUrl);
        // Actions (scene) Done last as it can access other objects.
        for(index = 0, cache = scene.meshes.length; index < cache; index++){
            const mesh = scene.meshes[index];
            if (mesh._waitingData.actions) {
                (0, $ebhJB.ActionManager).Parse(mesh._waitingData.actions, mesh, scene);
                mesh._waitingData.actions = null;
            }
        }
        if (parsedData.actions !== undefined && parsedData.actions !== null) (0, $ebhJB.ActionManager).Parse(parsedData.actions, null, scene);
    } catch (err) {
        const msg = $834551b1d1b9902f$var$logOperation("loadAssets", parsedData ? parsedData.producer : "Unknown") + log;
        if (onError) onError(msg, err);
        else {
            (0, $kVtWi.Logger).Log(msg);
            throw err;
        }
    } finally{
        $834551b1d1b9902f$var$tempIndexContainer = {};
        $834551b1d1b9902f$var$tempMaterialIndexContainer = {};
        if (!addToScene) container.removeAllFromScene();
        if (log !== null && (0, $agoTA.SceneLoader).loggingLevel !== (0, $agoTA.SceneLoader).NO_LOGGING) (0, $kVtWi.Logger).Log($834551b1d1b9902f$var$logOperation("loadAssets", parsedData ? parsedData.producer : "Unknown") + ((0, $agoTA.SceneLoader).loggingLevel !== (0, $agoTA.SceneLoader).MINIMAL_LOGGING ? log : ""));
    }
    return container;
};
(0, $agoTA.SceneLoader).RegisterPlugin({
    name: "babylon.js",
    extensions: ".babylon",
    canDirectLoad: (data)=>{
        if (data.indexOf("babylon") !== -1) // We consider that the producer string is filled
        return true;
        return false;
    },
    importMesh: (meshesNames, scene, data, rootUrl, meshes, particleSystems, skeletons, onError)=>{
        // Entire method running in try block, so ALWAYS logs as far as it got, only actually writes details
        // when SceneLoader.debugLogging = true (default), or exception encountered.
        // Everything stored in var log instead of writing separate lines to support only writing in exception,
        // and avoid problems with multiple concurrent .babylon loads.
        let log = "importMesh has failed JSON parse";
        try {
            // eslint-disable-next-line no-var
            var parsedData = JSON.parse(data);
            log = "";
            const fullDetails = (0, $agoTA.SceneLoader).loggingLevel === (0, $agoTA.SceneLoader).DETAILED_LOGGING;
            if (!meshesNames) meshesNames = null;
            else if (!Array.isArray(meshesNames)) meshesNames = [
                meshesNames
            ];
            const hierarchyIds = [];
            const parsedIdToNodeMap = new Map();
            // Transform nodes (the overall idea is to load all of them as this is super fast and then get rid of the ones we don't need)
            const loadedTransformNodes = [];
            if (parsedData.transformNodes !== undefined && parsedData.transformNodes !== null) for(let index = 0, cache = parsedData.transformNodes.length; index < cache; index++){
                const parsedJSONTransformNode = parsedData.transformNodes[index];
                const parsedTransformNode = (0, $klshO.TransformNode).Parse(parsedJSONTransformNode, scene, rootUrl);
                loadedTransformNodes.push(parsedTransformNode);
                parsedIdToNodeMap.set(parsedTransformNode._waitingParsedUniqueId, parsedTransformNode);
                parsedTransformNode._waitingParsedUniqueId = null;
            }
            if (parsedData.meshes !== undefined && parsedData.meshes !== null) {
                const loadedSkeletonsIds = [];
                const loadedMaterialsIds = [];
                const loadedMaterialsUniqueIds = [];
                const loadedMorphTargetsIds = [];
                for(let index = 0, cache = parsedData.meshes.length; index < cache; index++){
                    const parsedMesh = parsedData.meshes[index];
                    if (meshesNames === null || $834551b1d1b9902f$var$isDescendantOf(parsedMesh, meshesNames, hierarchyIds)) {
                        if (meshesNames !== null) // Remove found mesh name from list.
                        delete meshesNames[meshesNames.indexOf(parsedMesh.name)];
                        //Geometry?
                        if (parsedMesh.geometryId !== undefined && parsedMesh.geometryId !== null) //does the file contain geometries?
                        {
                            if (parsedData.geometries !== undefined && parsedData.geometries !== null) {
                                //find the correct geometry and add it to the scene
                                let found = false;
                                [
                                    "boxes",
                                    "spheres",
                                    "cylinders",
                                    "toruses",
                                    "grounds",
                                    "planes",
                                    "torusKnots",
                                    "vertexData"
                                ].forEach((geometryType)=>{
                                    if (found === true || !parsedData.geometries[geometryType] || !Array.isArray(parsedData.geometries[geometryType])) return;
                                    else parsedData.geometries[geometryType].forEach((parsedGeometryData)=>{
                                        if (parsedGeometryData.id === parsedMesh.geometryId) {
                                            switch(geometryType){
                                                case "vertexData":
                                                    (0, $FUHfe.Geometry).Parse(parsedGeometryData, scene, rootUrl);
                                                    break;
                                            }
                                            found = true;
                                        }
                                    });
                                });
                                if (found === false) (0, $kVtWi.Logger).Warn("Geometry not found for mesh " + parsedMesh.id);
                            }
                        }
                        // Material ?
                        if (parsedMesh.materialUniqueId || parsedMesh.materialId) {
                            // if we have a unique ID, look up and store in loadedMaterialsUniqueIds, else use loadedMaterialsIds
                            const materialArray = parsedMesh.materialUniqueId ? loadedMaterialsUniqueIds : loadedMaterialsIds;
                            let materialFound = materialArray.indexOf(parsedMesh.materialUniqueId || parsedMesh.materialId) !== -1;
                            if (materialFound === false && parsedData.multiMaterials !== undefined && parsedData.multiMaterials !== null) {
                                // Loads a submaterial of a multimaterial
                                const loadSubMaterial = (subMatId, predicate)=>{
                                    materialArray.push(subMatId);
                                    const mat = $834551b1d1b9902f$var$parseMaterialByPredicate(predicate, parsedData, scene, rootUrl);
                                    if (mat && mat.material) {
                                        $834551b1d1b9902f$var$tempMaterialIndexContainer[mat.parsedMaterial.uniqueId || mat.parsedMaterial.id] = mat.material;
                                        log += "\n\tMaterial " + mat.material.toString(fullDetails);
                                    }
                                };
                                for(let multimatIndex = 0, multimatCache = parsedData.multiMaterials.length; multimatIndex < multimatCache; multimatIndex++){
                                    const parsedMultiMaterial = parsedData.multiMaterials[multimatIndex];
                                    if (parsedMesh.materialUniqueId && parsedMultiMaterial.uniqueId === parsedMesh.materialUniqueId || parsedMultiMaterial.id === parsedMesh.materialId) {
                                        if (parsedMultiMaterial.materialsUniqueIds) // if the materials inside the multimat are stored by unique id
                                        parsedMultiMaterial.materialsUniqueIds.forEach((subMatId)=>loadSubMaterial(subMatId, (parsedMaterial)=>parsedMaterial.uniqueId === subMatId));
                                        else // if the mats are stored by id instead
                                        parsedMultiMaterial.materials.forEach((subMatId)=>loadSubMaterial(subMatId, (parsedMaterial)=>parsedMaterial.id === subMatId));
                                        materialArray.push(parsedMultiMaterial.uniqueId || parsedMultiMaterial.id);
                                        const mmat = (0, $3zFLd.MultiMaterial).ParseMultiMaterial(parsedMultiMaterial, scene);
                                        $834551b1d1b9902f$var$tempMaterialIndexContainer[parsedMultiMaterial.uniqueId || parsedMultiMaterial.id] = mmat;
                                        if (mmat) {
                                            materialFound = true;
                                            log += "\n\tMulti-Material " + mmat.toString(fullDetails);
                                        }
                                        break;
                                    }
                                }
                            }
                            if (materialFound === false) {
                                materialArray.push(parsedMesh.materialUniqueId || parsedMesh.materialId);
                                const mat = $834551b1d1b9902f$var$parseMaterialByPredicate((parsedMaterial)=>parsedMesh.materialUniqueId && parsedMaterial.uniqueId === parsedMesh.materialUniqueId || parsedMaterial.id === parsedMesh.materialId, parsedData, scene, rootUrl);
                                if (!mat || !mat.material) (0, $kVtWi.Logger).Warn("Material not found for mesh " + parsedMesh.id);
                                else {
                                    $834551b1d1b9902f$var$tempMaterialIndexContainer[mat.parsedMaterial.uniqueId || mat.parsedMaterial.id] = mat.material;
                                    log += "\n\tMaterial " + mat.material.toString(fullDetails);
                                }
                            }
                        }
                        // Skeleton ?
                        if (parsedMesh.skeletonId !== null && parsedMesh.skeletonId !== undefined && parsedData.skeletonId !== -1 && parsedData.skeletons !== undefined && parsedData.skeletons !== null) {
                            const skeletonAlreadyLoaded = loadedSkeletonsIds.indexOf(parsedMesh.skeletonId) > -1;
                            if (!skeletonAlreadyLoaded) for(let skeletonIndex = 0, skeletonCache = parsedData.skeletons.length; skeletonIndex < skeletonCache; skeletonIndex++){
                                const parsedSkeleton = parsedData.skeletons[skeletonIndex];
                                if (parsedSkeleton.id === parsedMesh.skeletonId) {
                                    const skeleton = (0, $3RnX0.Skeleton).Parse(parsedSkeleton, scene);
                                    skeletons.push(skeleton);
                                    loadedSkeletonsIds.push(parsedSkeleton.id);
                                    log += "\n\tSkeleton " + skeleton.toString(fullDetails);
                                }
                            }
                        }
                        // Morph targets ?
                        if (parsedMesh.morphTargetManagerId > -1 && parsedData.morphTargetManagers !== undefined && parsedData.morphTargetManagers !== null) {
                            const morphTargetAlreadyLoaded = loadedMorphTargetsIds.indexOf(parsedMesh.morphTargetManagerId) > -1;
                            if (!morphTargetAlreadyLoaded) for(let morphTargetIndex = 0, morphTargetCache = parsedData.morphTargetManagers.length; morphTargetIndex < morphTargetCache; morphTargetIndex++){
                                const parsedMorphTarget = parsedData.morphTargetManagers[morphTargetIndex];
                                if (parsedMorphTarget.id === parsedMesh.morphTargetManagerId) {
                                    const morphTarget = (0, $c9v5E.MorphTargetManager).Parse(parsedMorphTarget, scene);
                                    loadedMorphTargetsIds.push(morphTarget.uniqueId);
                                    log += "\nMorph target " + morphTarget.toString();
                                }
                            }
                        }
                        const mesh = (0, $fbuqw.Mesh).Parse(parsedMesh, scene, rootUrl);
                        meshes.push(mesh);
                        parsedIdToNodeMap.set(mesh._waitingParsedUniqueId, mesh);
                        mesh._waitingParsedUniqueId = null;
                        log += "\n\tMesh " + mesh.toString(fullDetails);
                    }
                }
                // link multimats with materials
                scene.multiMaterials.forEach((multimat)=>{
                    multimat._waitingSubMaterialsUniqueIds.forEach((subMaterial)=>{
                        multimat.subMaterials.push($834551b1d1b9902f$var$findMaterial(subMaterial, scene));
                    });
                    multimat._waitingSubMaterialsUniqueIds = [];
                });
                // link meshes with materials
                scene.meshes.forEach((mesh)=>{
                    if (mesh._waitingMaterialId !== null) {
                        mesh.material = $834551b1d1b9902f$var$findMaterial(mesh._waitingMaterialId, scene);
                        mesh._waitingMaterialId = null;
                    }
                });
                // Connecting parents and lods
                for(let index = 0, cache = scene.transformNodes.length; index < cache; index++){
                    const transformNode = scene.transformNodes[index];
                    if (transformNode._waitingParentId !== null) {
                        let parent = parsedIdToNodeMap.get(parseInt(transformNode._waitingParentId)) || null;
                        if (parent === null) parent = scene.getLastEntryById(transformNode._waitingParentId);
                        let parentNode = parent;
                        if (transformNode._waitingParentInstanceIndex) {
                            parentNode = parent.instances[parseInt(transformNode._waitingParentInstanceIndex)];
                            transformNode._waitingParentInstanceIndex = null;
                        }
                        transformNode.parent = parentNode;
                        transformNode._waitingParentId = null;
                    }
                }
                let currentMesh;
                for(let index = 0, cache = scene.meshes.length; index < cache; index++){
                    currentMesh = scene.meshes[index];
                    if (currentMesh._waitingParentId) {
                        let parent = parsedIdToNodeMap.get(parseInt(currentMesh._waitingParentId)) || null;
                        if (parent === null) parent = scene.getLastEntryById(currentMesh._waitingParentId);
                        let parentNode = parent;
                        if (currentMesh._waitingParentInstanceIndex) {
                            parentNode = parent.instances[parseInt(currentMesh._waitingParentInstanceIndex)];
                            currentMesh._waitingParentInstanceIndex = null;
                        }
                        currentMesh.parent = parentNode;
                        if (currentMesh.parent?.getClassName() === "TransformNode") {
                            const loadedTransformNodeIndex = loadedTransformNodes.indexOf(currentMesh.parent);
                            if (loadedTransformNodeIndex > -1) loadedTransformNodes.splice(loadedTransformNodeIndex, 1);
                        }
                        currentMesh._waitingParentId = null;
                    }
                    if (currentMesh._waitingData.lods) $834551b1d1b9902f$var$loadDetailLevels(scene, currentMesh);
                }
                // Remove unused transform nodes
                for (const transformNode of loadedTransformNodes)transformNode.dispose();
                // link skeleton transform nodes
                for(let index = 0, cache = scene.skeletons.length; index < cache; index++){
                    const skeleton = scene.skeletons[index];
                    if (skeleton._hasWaitingData) {
                        if (skeleton.bones != null) skeleton.bones.forEach((bone)=>{
                            if (bone._waitingTransformNodeId) {
                                const linkTransformNode = scene.getLastEntryById(bone._waitingTransformNodeId);
                                if (linkTransformNode) bone.linkTransformNode(linkTransformNode);
                                bone._waitingTransformNodeId = null;
                            }
                        });
                        skeleton._hasWaitingData = null;
                    }
                }
                // freeze and compute world matrix application
                for(let index = 0, cache = scene.meshes.length; index < cache; index++){
                    currentMesh = scene.meshes[index];
                    if (currentMesh._waitingData.freezeWorldMatrix) {
                        currentMesh.freezeWorldMatrix();
                        currentMesh._waitingData.freezeWorldMatrix = null;
                    } else currentMesh.computeWorldMatrix(true);
                }
            }
            // Particles
            if (parsedData.particleSystems !== undefined && parsedData.particleSystems !== null) {
                const parser = (0, $5Tqba.AbstractScene).GetIndividualParser((0, $bv05l.SceneComponentConstants).NAME_PARTICLESYSTEM);
                if (parser) for(let index = 0, cache = parsedData.particleSystems.length; index < cache; index++){
                    const parsedParticleSystem = parsedData.particleSystems[index];
                    if (hierarchyIds.indexOf(parsedParticleSystem.emitterId) !== -1) particleSystems.push(parser(parsedParticleSystem, scene, rootUrl));
                }
            }
            scene.geometries.forEach((g)=>{
                g._loadedUniqueId = "";
            });
            return true;
        } catch (err) {
            const msg = $834551b1d1b9902f$var$logOperation("importMesh", parsedData ? parsedData.producer : "Unknown") + log;
            if (onError) onError(msg, err);
            else {
                (0, $kVtWi.Logger).Log(msg);
                throw err;
            }
        } finally{
            if (log !== null && (0, $agoTA.SceneLoader).loggingLevel !== (0, $agoTA.SceneLoader).NO_LOGGING) (0, $kVtWi.Logger).Log($834551b1d1b9902f$var$logOperation("importMesh", parsedData ? parsedData.producer : "Unknown") + ((0, $agoTA.SceneLoader).loggingLevel !== (0, $agoTA.SceneLoader).MINIMAL_LOGGING ? log : ""));
            $834551b1d1b9902f$var$tempMaterialIndexContainer = {};
        }
        return false;
    },
    load: (scene, data, rootUrl, onError)=>{
        // Entire method running in try block, so ALWAYS logs as far as it got, only actually writes details
        // when SceneLoader.debugLogging = true (default), or exception encountered.
        // Everything stored in var log instead of writing separate lines to support only writing in exception,
        // and avoid problems with multiple concurrent .babylon loads.
        let log = "importScene has failed JSON parse";
        try {
            // eslint-disable-next-line no-var
            var parsedData = JSON.parse(data);
            log = "";
            // Scene
            if (parsedData.useDelayedTextureLoading !== undefined && parsedData.useDelayedTextureLoading !== null) scene.useDelayedTextureLoading = parsedData.useDelayedTextureLoading && !(0, $agoTA.SceneLoader).ForceFullSceneLoadingForIncremental;
            if (parsedData.autoClear !== undefined && parsedData.autoClear !== null) scene.autoClear = parsedData.autoClear;
            if (parsedData.clearColor !== undefined && parsedData.clearColor !== null) scene.clearColor = (0, $7etnY.Color4).FromArray(parsedData.clearColor);
            if (parsedData.ambientColor !== undefined && parsedData.ambientColor !== null) scene.ambientColor = (0, $7etnY.Color3).FromArray(parsedData.ambientColor);
            if (parsedData.gravity !== undefined && parsedData.gravity !== null) scene.gravity = (0, $ha1VO.Vector3).FromArray(parsedData.gravity);
            if (parsedData.useRightHandedSystem !== undefined) scene.useRightHandedSystem = !!parsedData.useRightHandedSystem;
            // Fog
            if (parsedData.fogMode && parsedData.fogMode !== 0) {
                scene.fogMode = parsedData.fogMode;
                scene.fogColor = (0, $7etnY.Color3).FromArray(parsedData.fogColor);
                scene.fogStart = parsedData.fogStart;
                scene.fogEnd = parsedData.fogEnd;
                scene.fogDensity = parsedData.fogDensity;
                log += "\tFog mode for scene:  ";
                switch(scene.fogMode){
                    // getters not compiling, so using hardcoded
                    case 1:
                        log += "exp\n";
                        break;
                    case 2:
                        log += "exp2\n";
                        break;
                    case 3:
                        log += "linear\n";
                        break;
                }
            }
            //Physics
            if (parsedData.physicsEnabled) {
                let physicsPlugin;
                if (parsedData.physicsEngine === "cannon" || parsedData.physicsEngine === (0, $9l7E8.CannonJSPlugin).name) physicsPlugin = new (0, $9l7E8.CannonJSPlugin)(undefined, undefined, $834551b1d1b9902f$export$b26905abc1f61e3e.LoaderInjectedPhysicsEngine);
                else if (parsedData.physicsEngine === "oimo" || parsedData.physicsEngine === (0, $9o1yl.OimoJSPlugin).name) physicsPlugin = new (0, $9o1yl.OimoJSPlugin)(undefined, $834551b1d1b9902f$export$b26905abc1f61e3e.LoaderInjectedPhysicsEngine);
                else if (parsedData.physicsEngine === "ammo" || parsedData.physicsEngine === (0, $hEg94.AmmoJSPlugin).name) physicsPlugin = new (0, $hEg94.AmmoJSPlugin)(undefined, $834551b1d1b9902f$export$b26905abc1f61e3e.LoaderInjectedPhysicsEngine, undefined);
                log = "\tPhysics engine " + (parsedData.physicsEngine ? parsedData.physicsEngine : "oimo") + " enabled\n";
                //else - default engine, which is currently oimo
                const physicsGravity = parsedData.physicsGravity ? (0, $ha1VO.Vector3).FromArray(parsedData.physicsGravity) : null;
                scene.enablePhysics(physicsGravity, physicsPlugin);
            }
            // Metadata
            if (parsedData.metadata !== undefined && parsedData.metadata !== null) scene.metadata = parsedData.metadata;
            //collisions, if defined. otherwise, default is true
            if (parsedData.collisionsEnabled !== undefined && parsedData.collisionsEnabled !== null) scene.collisionsEnabled = parsedData.collisionsEnabled;
            const container = $834551b1d1b9902f$var$loadAssetContainer(scene, data, rootUrl, onError, true);
            if (!container) return false;
            if (parsedData.autoAnimate) scene.beginAnimation(scene, parsedData.autoAnimateFrom, parsedData.autoAnimateTo, parsedData.autoAnimateLoop, parsedData.autoAnimateSpeed || 1.0);
            if (parsedData.activeCameraID !== undefined && parsedData.activeCameraID !== null) scene.setActiveCameraById(parsedData.activeCameraID);
            // Finish
            return true;
        } catch (err) {
            const msg = $834551b1d1b9902f$var$logOperation("importScene", parsedData ? parsedData.producer : "Unknown") + log;
            if (onError) onError(msg, err);
            else {
                (0, $kVtWi.Logger).Log(msg);
                throw err;
            }
        } finally{
            if (log !== null && (0, $agoTA.SceneLoader).loggingLevel !== (0, $agoTA.SceneLoader).NO_LOGGING) (0, $kVtWi.Logger).Log($834551b1d1b9902f$var$logOperation("importScene", parsedData ? parsedData.producer : "Unknown") + ((0, $agoTA.SceneLoader).loggingLevel !== (0, $agoTA.SceneLoader).MINIMAL_LOGGING ? log : ""));
        }
        return false;
    },
    loadAssetContainer: (scene, data, rootUrl, onError)=>{
        const container = $834551b1d1b9902f$var$loadAssetContainer(scene, data, rootUrl, onError);
        return container;
    }
});

});
parcelRegister("6Y7JP", function(module, exports) {

$parcel$export(module.exports, "HDRCubeTexture", () => $512e594ce94fef91$export$d0d038230df5d233);

var $ha1VO = parcelRequire("ha1VO");

var $akOl3 = parcelRequire("akOl3");

var $j2mX5 = parcelRequire("j2mX5");

var $jSNZm = parcelRequire("jSNZm");

var $4p0qs = parcelRequire("4p0qs");

var $8DoUR = parcelRequire("8DoUR");

var $diGQf = parcelRequire("diGQf");

var $bOhSV = parcelRequire("bOhSV");

var $53VPf = parcelRequire("53VPf");

var $9LfOV = parcelRequire("9LfOV");

var $3a58A = parcelRequire("3a58A");
parcelRequire("e7NUJ");
parcelRequire("90OM8");
class $512e594ce94fef91$export$d0d038230df5d233 extends (0, $akOl3.BaseTexture) {
    /**
     * Sets whether or not the texture is blocking during loading.
     */ set isBlocking(value) {
        this._isBlocking = value;
    }
    /**
     * Gets whether or not the texture is blocking during loading.
     */ get isBlocking() {
        return this._isBlocking;
    }
    /**
     * Sets texture matrix rotation angle around Y axis in radians.
     */ set rotationY(value) {
        this._rotationY = value;
        this.setReflectionTextureMatrix((0, $ha1VO.Matrix).RotationY(this._rotationY));
    }
    /**
     * Gets texture matrix rotation angle around Y axis radians.
     */ get rotationY() {
        return this._rotationY;
    }
    /**
     * Gets or sets the size of the bounding box associated with the cube texture
     * When defined, the cubemap will switch to local mode
     * @see https://community.arm.com/graphics/b/blog/posts/reflections-based-on-local-cubemaps-in-unity
     * @example https://www.babylonjs-playground.com/#RNASML
     */ set boundingBoxSize(value) {
        if (this._boundingBoxSize && this._boundingBoxSize.equals(value)) return;
        this._boundingBoxSize = value;
        const scene = this.getScene();
        if (scene) scene.markAllMaterialsAsDirty(1);
    }
    get boundingBoxSize() {
        return this._boundingBoxSize;
    }
    /**
     * Instantiates an HDRTexture from the following parameters.
     *
     * @param url The location of the HDR raw data (Panorama stored in RGBE format)
     * @param sceneOrEngine The scene or engine the texture will be used in
     * @param size The cubemap desired size (the more it increases the longer the generation will be)
     * @param noMipmap Forces to not generate the mipmap if true
     * @param generateHarmonics Specifies whether you want to extract the polynomial harmonics during the generation process
     * @param gammaSpace Specifies if the texture will be use in gamma or linear space (the PBR material requires those texture in linear space, but the standard material would require them in Gamma space)
     * @param prefilterOnLoad Prefilters HDR texture to allow use of this texture as a PBR reflection texture.
     * @param onLoad on success callback function
     * @param onError on error callback function
     * @param supersample Defines if texture must be supersampled (default: false)
     */ constructor(url, sceneOrEngine, size, noMipmap = false, generateHarmonics = true, gammaSpace = false, prefilterOnLoad = false, onLoad = null, onError = null, supersample = false){
        super(sceneOrEngine);
        this._generateHarmonics = true;
        this._onError = null;
        this._isBlocking = true;
        this._rotationY = 0;
        /**
         * Gets or sets the center of the bounding box associated with the cube texture
         * It must define where the camera used to render the texture was set
         */ this.boundingBoxPosition = (0, $ha1VO.Vector3).Zero();
        /**
         * Observable triggered once the texture has been loaded.
         */ this.onLoadObservable = new (0, $diGQf.Observable)();
        if (!url) return;
        this._coordinatesMode = (0, $j2mX5.Texture).CUBIC_MODE;
        this.name = url;
        this.url = url;
        this.hasAlpha = false;
        this.isCube = true;
        this._textureMatrix = (0, $ha1VO.Matrix).Identity();
        this._prefilterOnLoad = prefilterOnLoad;
        this._onLoad = ()=>{
            this.onLoadObservable.notifyObservers(this);
            if (onLoad) onLoad();
        };
        this._onError = onError;
        this.gammaSpace = gammaSpace;
        this._noMipmap = noMipmap;
        this._size = size;
        this._supersample = supersample;
        this._generateHarmonics = generateHarmonics;
        this._texture = this._getFromCache(url, this._noMipmap, undefined, undefined, undefined, this.isCube);
        if (!this._texture) {
            if (!this.getScene()?.useDelayedTextureLoading) this._loadTexture();
            else this.delayLoadState = 4;
        } else if (this._texture.isReady) (0, $bOhSV.Tools).SetImmediate(()=>this._onLoad());
        else this._texture.onLoadedObservable.add(this._onLoad);
    }
    /**
     * Get the current class name of the texture useful for serialization or dynamic coding.
     * @returns "HDRCubeTexture"
     */ getClassName() {
        return "HDRCubeTexture";
    }
    /**
     * Occurs when the file is raw .hdr file.
     */ _loadTexture() {
        const engine = this._getEngine();
        const caps = engine.getCaps();
        let textureType = 0;
        if (caps.textureFloat && caps.textureFloatLinearFiltering) textureType = 1;
        else if (caps.textureHalfFloat && caps.textureHalfFloatLinearFiltering) textureType = 2;
        const callback = (buffer)=>{
            this.lodGenerationOffset = 0.0;
            this.lodGenerationScale = 0.8;
            // Extract the raw linear data.
            const data = (0, $jSNZm.HDRTools).GetCubeMapTextureData(buffer, this._size, this._supersample);
            // Generate harmonics if needed.
            if (this._generateHarmonics) {
                const sphericalPolynomial = (0, $4p0qs.CubeMapToSphericalPolynomialTools).ConvertCubeMapToSphericalPolynomial(data);
                this.sphericalPolynomial = sphericalPolynomial;
            }
            const results = [];
            let byteArray = null;
            let shortArray = null;
            // Push each faces.
            for(let j = 0; j < 6; j++){
                // Create fallback array
                if (textureType === 2) shortArray = new Uint16Array(this._size * this._size * 3);
                else if (textureType === 0) // 3 channels of 1 bytes per pixel in bytes.
                byteArray = new Uint8Array(this._size * this._size * 3);
                const dataFace = data[$512e594ce94fef91$export$d0d038230df5d233._FacesMapping[j]];
                // If special cases.
                if (this.gammaSpace || shortArray || byteArray) for(let i = 0; i < this._size * this._size; i++){
                    // Put in gamma space if requested.
                    if (this.gammaSpace) {
                        dataFace[i * 3 + 0] = Math.pow(dataFace[i * 3 + 0], (0, $53VPf.ToGammaSpace));
                        dataFace[i * 3 + 1] = Math.pow(dataFace[i * 3 + 1], (0, $53VPf.ToGammaSpace));
                        dataFace[i * 3 + 2] = Math.pow(dataFace[i * 3 + 2], (0, $53VPf.ToGammaSpace));
                    }
                    // Convert to half float texture for fallback.
                    if (shortArray) {
                        shortArray[i * 3 + 0] = (0, $3a58A.ToHalfFloat)(dataFace[i * 3 + 0]);
                        shortArray[i * 3 + 1] = (0, $3a58A.ToHalfFloat)(dataFace[i * 3 + 1]);
                        shortArray[i * 3 + 2] = (0, $3a58A.ToHalfFloat)(dataFace[i * 3 + 2]);
                    }
                    // Convert to int texture for fallback.
                    if (byteArray) {
                        let r = Math.max(dataFace[i * 3 + 0] * 255, 0);
                        let g = Math.max(dataFace[i * 3 + 1] * 255, 0);
                        let b = Math.max(dataFace[i * 3 + 2] * 255, 0);
                        // May use luminance instead if the result is not accurate.
                        const max = Math.max(Math.max(r, g), b);
                        if (max > 255) {
                            const scale = 255 / max;
                            r *= scale;
                            g *= scale;
                            b *= scale;
                        }
                        byteArray[i * 3 + 0] = r;
                        byteArray[i * 3 + 1] = g;
                        byteArray[i * 3 + 2] = b;
                    }
                }
                if (shortArray) results.push(shortArray);
                else if (byteArray) results.push(byteArray);
                else results.push(dataFace);
            }
            return results;
        };
        if (engine._features.allowTexturePrefiltering && this._prefilterOnLoad) {
            const previousOnLoad = this._onLoad;
            const hdrFiltering = new (0, $9LfOV.HDRFiltering)(engine);
            this._onLoad = ()=>{
                hdrFiltering.prefilter(this, previousOnLoad);
            };
        }
        this._texture = engine.createRawCubeTextureFromUrl(this.url, this.getScene(), this._size, 4, textureType, this._noMipmap, callback, null, this._onLoad, this._onError);
    }
    clone() {
        const newTexture = new $512e594ce94fef91$export$d0d038230df5d233(this.url, this.getScene() || this._getEngine(), this._size, this._noMipmap, this._generateHarmonics, this.gammaSpace);
        // Base texture
        newTexture.level = this.level;
        newTexture.wrapU = this.wrapU;
        newTexture.wrapV = this.wrapV;
        newTexture.coordinatesIndex = this.coordinatesIndex;
        newTexture.coordinatesMode = this.coordinatesMode;
        return newTexture;
    }
    // Methods
    delayLoad() {
        if (this.delayLoadState !== 4) return;
        this.delayLoadState = 1;
        this._texture = this._getFromCache(this.url, this._noMipmap);
        if (!this._texture) this._loadTexture();
    }
    /**
     * Get the texture reflection matrix used to rotate/transform the reflection.
     * @returns the reflection matrix
     */ getReflectionTextureMatrix() {
        return this._textureMatrix;
    }
    /**
     * Set the texture reflection matrix used to rotate/transform the reflection.
     * @param value Define the reflection matrix to set
     */ setReflectionTextureMatrix(value) {
        this._textureMatrix = value;
        if (value.updateFlag === this._textureMatrix.updateFlag) return;
        if (value.isIdentity() !== this._textureMatrix.isIdentity()) this.getScene()?.markAllMaterialsAsDirty(1, (mat)=>mat.getActiveTextures().indexOf(this) !== -1);
    }
    /**
     * Dispose the texture and release its associated resources.
     */ dispose() {
        this.onLoadObservable.clear();
        super.dispose();
    }
    /**
     * Parses a JSON representation of an HDR Texture in order to create the texture
     * @param parsedTexture Define the JSON representation
     * @param scene Define the scene the texture should be created in
     * @param rootUrl Define the root url in case we need to load relative dependencies
     * @returns the newly created texture after parsing
     */ static Parse(parsedTexture, scene, rootUrl) {
        let texture = null;
        if (parsedTexture.name && !parsedTexture.isRenderTarget) {
            texture = new $512e594ce94fef91$export$d0d038230df5d233(rootUrl + parsedTexture.name, scene, parsedTexture.size, parsedTexture.noMipmap, parsedTexture.generateHarmonics, parsedTexture.useInGammaSpace);
            texture.name = parsedTexture.name;
            texture.hasAlpha = parsedTexture.hasAlpha;
            texture.level = parsedTexture.level;
            texture.coordinatesMode = parsedTexture.coordinatesMode;
            texture.isBlocking = parsedTexture.isBlocking;
        }
        if (texture) {
            if (parsedTexture.boundingBoxPosition) texture.boundingBoxPosition = (0, $ha1VO.Vector3).FromArray(parsedTexture.boundingBoxPosition);
            if (parsedTexture.boundingBoxSize) texture.boundingBoxSize = (0, $ha1VO.Vector3).FromArray(parsedTexture.boundingBoxSize);
            if (parsedTexture.rotationY) texture.rotationY = parsedTexture.rotationY;
        }
        return texture;
    }
    serialize() {
        if (!this.name) return null;
        const serializationObject = {};
        serializationObject.name = this.name;
        serializationObject.hasAlpha = this.hasAlpha;
        serializationObject.isCube = true;
        serializationObject.level = this.level;
        serializationObject.size = this._size;
        serializationObject.coordinatesMode = this.coordinatesMode;
        serializationObject.useInGammaSpace = this.gammaSpace;
        serializationObject.generateHarmonics = this._generateHarmonics;
        serializationObject.customType = "BABYLON.HDRCubeTexture";
        serializationObject.noMipmap = this._noMipmap;
        serializationObject.isBlocking = this._isBlocking;
        serializationObject.rotationY = this._rotationY;
        return serializationObject;
    }
}
$512e594ce94fef91$export$d0d038230df5d233._FacesMapping = [
    "right",
    "left",
    "up",
    "down",
    "front",
    "back"
];
(0, $8DoUR.RegisterClass)("BABYLON.HDRCubeTexture", $512e594ce94fef91$export$d0d038230df5d233);

});
parcelRegister("jSNZm", function(module, exports) {

$parcel$export(module.exports, "HDRTools", () => $e799d632a8c902c3$export$f5d0a896123037eb);

var $h8zBf = parcelRequire("h8zBf");
class $e799d632a8c902c3$export$f5d0a896123037eb {
    static _Ldexp(mantissa, exponent) {
        if (exponent > 1023) return mantissa * Math.pow(2, 1023) * Math.pow(2, exponent - 1023);
        if (exponent < -1074) return mantissa * Math.pow(2, -1074) * Math.pow(2, exponent + 1074);
        return mantissa * Math.pow(2, exponent);
    }
    static _Rgbe2float(float32array, red, green, blue, exponent, index) {
        if (exponent > 0) {
            /*nonzero pixel*/ exponent = this._Ldexp(1.0, exponent - 136);
            float32array[index + 0] = red * exponent;
            float32array[index + 1] = green * exponent;
            float32array[index + 2] = blue * exponent;
        } else {
            float32array[index + 0] = 0;
            float32array[index + 1] = 0;
            float32array[index + 2] = 0;
        }
    }
    static _ReadStringLine(uint8array, startIndex) {
        let line = "";
        let character = "";
        for(let i = startIndex; i < uint8array.length - startIndex; i++){
            character = String.fromCharCode(uint8array[i]);
            if (character == "\n") break;
            line += character;
        }
        return line;
    }
    /**
     * Reads header information from an RGBE texture stored in a native array.
     * More information on this format are available here:
     * https://en.wikipedia.org/wiki/RGBE_image_format
     *
     * @param uint8array The binary file stored in  native array.
     * @returns The header information.
     */ // eslint-disable-next-line @typescript-eslint/naming-convention
    static RGBE_ReadHeader(uint8array) {
        let height = 0;
        let width = 0;
        let line = this._ReadStringLine(uint8array, 0);
        if (line[0] != "#" || line[1] != "?") // eslint-disable-next-line no-throw-literal
        throw "Bad HDR Format.";
        let endOfHeader = false;
        let findFormat = false;
        let lineIndex = 0;
        do {
            lineIndex += line.length + 1;
            line = this._ReadStringLine(uint8array, lineIndex);
            if (line == "FORMAT=32-bit_rle_rgbe") findFormat = true;
            else if (line.length == 0) endOfHeader = true;
        }while (!endOfHeader);
        if (!findFormat) // eslint-disable-next-line no-throw-literal
        throw "HDR Bad header format, unsupported FORMAT";
        lineIndex += line.length + 1;
        line = this._ReadStringLine(uint8array, lineIndex);
        const sizeRegexp = /^-Y (.*) \+X (.*)$/g;
        const match = sizeRegexp.exec(line);
        // TODO. Support +Y and -X if needed.
        if (!match || match.length < 3) // eslint-disable-next-line no-throw-literal
        throw "HDR Bad header format, no size";
        width = parseInt(match[2]);
        height = parseInt(match[1]);
        if (width < 8 || width > 0x7fff) // eslint-disable-next-line no-throw-literal
        throw "HDR Bad header format, unsupported size";
        lineIndex += line.length + 1;
        return {
            height: height,
            width: width,
            dataPosition: lineIndex
        };
    }
    /**
     * Returns the cubemap information (each faces texture data) extracted from an RGBE texture.
     * This RGBE texture needs to store the information as a panorama.
     *
     * More information on this format are available here:
     * https://en.wikipedia.org/wiki/RGBE_image_format
     *
     * @param buffer The binary file stored in an array buffer.
     * @param size The expected size of the extracted cubemap.
     * @param supersample enable supersampling the cubemap (default: false)
     * @returns The Cube Map information.
     */ static GetCubeMapTextureData(buffer, size, supersample = false) {
        const uint8array = new Uint8Array(buffer);
        const hdrInfo = this.RGBE_ReadHeader(uint8array);
        const data = this.RGBE_ReadPixels(uint8array, hdrInfo);
        const cubeMapData = (0, $h8zBf.PanoramaToCubeMapTools).ConvertPanoramaToCubemap(data, hdrInfo.width, hdrInfo.height, size, supersample);
        return cubeMapData;
    }
    /**
     * Returns the pixels data extracted from an RGBE texture.
     * This pixels will be stored left to right up to down in the R G B order in one array.
     *
     * More information on this format are available here:
     * https://en.wikipedia.org/wiki/RGBE_image_format
     *
     * @param uint8array The binary file stored in an array buffer.
     * @param hdrInfo The header information of the file.
     * @returns The pixels data in RGB right to left up to down order.
     */ // eslint-disable-next-line @typescript-eslint/naming-convention
    static RGBE_ReadPixels(uint8array, hdrInfo) {
        return this._RGBEReadPixelsRLE(uint8array, hdrInfo);
    }
    static _RGBEReadPixelsRLE(uint8array, hdrInfo) {
        let num_scanlines = hdrInfo.height;
        const scanline_width = hdrInfo.width;
        let a, b, c, d, count;
        let dataIndex = hdrInfo.dataPosition;
        let index = 0, endIndex = 0, i = 0;
        const scanLineArrayBuffer = new ArrayBuffer(scanline_width * 4); // four channel R G B E
        const scanLineArray = new Uint8Array(scanLineArrayBuffer);
        // 3 channels of 4 bytes per pixel in float.
        const resultBuffer = new ArrayBuffer(hdrInfo.width * hdrInfo.height * 12);
        const resultArray = new Float32Array(resultBuffer);
        // read in each successive scanline
        while(num_scanlines > 0){
            a = uint8array[dataIndex++];
            b = uint8array[dataIndex++];
            c = uint8array[dataIndex++];
            d = uint8array[dataIndex++];
            if (a != 2 || b != 2 || c & 0x80 || hdrInfo.width < 8 || hdrInfo.width > 32767) return this._RGBEReadPixelsNOTRLE(uint8array, hdrInfo);
            if ((c << 8 | d) != scanline_width) // eslint-disable-next-line no-throw-literal
            throw "HDR Bad header format, wrong scan line width";
            index = 0;
            // read each of the four channels for the scanline into the buffer
            for(i = 0; i < 4; i++){
                endIndex = (i + 1) * scanline_width;
                while(index < endIndex){
                    a = uint8array[dataIndex++];
                    b = uint8array[dataIndex++];
                    if (a > 128) {
                        // a run of the same value
                        count = a - 128;
                        if (count == 0 || count > endIndex - index) // eslint-disable-next-line no-throw-literal
                        throw "HDR Bad Format, bad scanline data (run)";
                        while(count-- > 0)scanLineArray[index++] = b;
                    } else {
                        // a non-run
                        count = a;
                        if (count == 0 || count > endIndex - index) // eslint-disable-next-line no-throw-literal
                        throw "HDR Bad Format, bad scanline data (non-run)";
                        scanLineArray[index++] = b;
                        if (--count > 0) for(let j = 0; j < count; j++)scanLineArray[index++] = uint8array[dataIndex++];
                    }
                }
            }
            // now convert data from buffer into floats
            for(i = 0; i < scanline_width; i++){
                a = scanLineArray[i];
                b = scanLineArray[i + scanline_width];
                c = scanLineArray[i + 2 * scanline_width];
                d = scanLineArray[i + 3 * scanline_width];
                this._Rgbe2float(resultArray, a, b, c, d, (hdrInfo.height - num_scanlines) * scanline_width * 3 + i * 3);
            }
            num_scanlines--;
        }
        return resultArray;
    }
    static _RGBEReadPixelsNOTRLE(uint8array, hdrInfo) {
        // this file is not run length encoded
        // read values sequentially
        let num_scanlines = hdrInfo.height;
        const scanline_width = hdrInfo.width;
        let a, b, c, d, i;
        let dataIndex = hdrInfo.dataPosition;
        // 3 channels of 4 bytes per pixel in float.
        const resultBuffer = new ArrayBuffer(hdrInfo.width * hdrInfo.height * 12);
        const resultArray = new Float32Array(resultBuffer);
        // read in each successive scanline
        while(num_scanlines > 0){
            for(i = 0; i < hdrInfo.width; i++){
                a = uint8array[dataIndex++];
                b = uint8array[dataIndex++];
                c = uint8array[dataIndex++];
                d = uint8array[dataIndex++];
                this._Rgbe2float(resultArray, a, b, c, d, (hdrInfo.height - num_scanlines) * scanline_width * 3 + i * 3);
            }
            num_scanlines--;
        }
        return resultArray;
    }
}

});
parcelRegister("h8zBf", function(module, exports) {

$parcel$export(module.exports, "PanoramaToCubeMapTools", () => $c79ecc6787b65f4d$export$76063747088dfc2d);

var $ha1VO = parcelRequire("ha1VO");
class $c79ecc6787b65f4d$export$76063747088dfc2d {
    /**
     * Converts a panorama stored in RGB right to left up to down format into a cubemap (6 faces).
     *
     * @param float32Array The source data.
     * @param inputWidth The width of the input panorama.
     * @param inputHeight The height of the input panorama.
     * @param size The willing size of the generated cubemap (each faces will be size * size pixels)
     * @param supersample enable supersampling the cubemap
     * @returns The cubemap data
     */ static ConvertPanoramaToCubemap(float32Array, inputWidth, inputHeight, size, supersample = false) {
        if (!float32Array) // eslint-disable-next-line no-throw-literal
        throw "ConvertPanoramaToCubemap: input cannot be null";
        if (float32Array.length != inputWidth * inputHeight * 3) // eslint-disable-next-line no-throw-literal
        throw "ConvertPanoramaToCubemap: input size is wrong";
        const textureFront = this.CreateCubemapTexture(size, this.FACE_FRONT, float32Array, inputWidth, inputHeight, supersample);
        const textureBack = this.CreateCubemapTexture(size, this.FACE_BACK, float32Array, inputWidth, inputHeight, supersample);
        const textureLeft = this.CreateCubemapTexture(size, this.FACE_LEFT, float32Array, inputWidth, inputHeight, supersample);
        const textureRight = this.CreateCubemapTexture(size, this.FACE_RIGHT, float32Array, inputWidth, inputHeight, supersample);
        const textureUp = this.CreateCubemapTexture(size, this.FACE_UP, float32Array, inputWidth, inputHeight, supersample);
        const textureDown = this.CreateCubemapTexture(size, this.FACE_DOWN, float32Array, inputWidth, inputHeight, supersample);
        return {
            front: textureFront,
            back: textureBack,
            left: textureLeft,
            right: textureRight,
            up: textureUp,
            down: textureDown,
            size: size,
            type: 1,
            format: 4,
            gammaSpace: false
        };
    }
    static CreateCubemapTexture(texSize, faceData, float32Array, inputWidth, inputHeight, supersample = false) {
        const buffer = new ArrayBuffer(texSize * texSize * 12);
        const textureArray = new Float32Array(buffer);
        // If supersampling, determine number of samples needed when source texture width is divided for 4 cube faces
        const samples = supersample ? Math.max(1, Math.round(inputWidth / 4 / texSize)) : 1;
        const sampleFactor = 1 / samples;
        const sampleFactorSqr = sampleFactor * sampleFactor;
        const rotDX1 = faceData[1].subtract(faceData[0]).scale(sampleFactor / texSize);
        const rotDX2 = faceData[3].subtract(faceData[2]).scale(sampleFactor / texSize);
        const dy = 1 / texSize;
        let fy = 0;
        for(let y = 0; y < texSize; y++)for(let sy = 0; sy < samples; sy++){
            let xv1 = faceData[0];
            let xv2 = faceData[2];
            for(let x = 0; x < texSize; x++)for(let sx = 0; sx < samples; sx++){
                const v = xv2.subtract(xv1).scale(fy).add(xv1);
                v.normalize();
                const color = this.CalcProjectionSpherical(v, float32Array, inputWidth, inputHeight);
                // 3 channels per pixels
                textureArray[y * texSize * 3 + x * 3 + 0] += color.r * sampleFactorSqr;
                textureArray[y * texSize * 3 + x * 3 + 1] += color.g * sampleFactorSqr;
                textureArray[y * texSize * 3 + x * 3 + 2] += color.b * sampleFactorSqr;
                xv1 = xv1.add(rotDX1);
                xv2 = xv2.add(rotDX2);
            }
            fy += dy * sampleFactor;
        }
        return textureArray;
    }
    static CalcProjectionSpherical(vDir, float32Array, inputWidth, inputHeight) {
        let theta = Math.atan2(vDir.z, vDir.x);
        const phi = Math.acos(vDir.y);
        while(theta < -Math.PI)theta += 2 * Math.PI;
        while(theta > Math.PI)theta -= 2 * Math.PI;
        let dx = theta / Math.PI;
        const dy = phi / Math.PI;
        // recenter.
        dx = dx * 0.5 + 0.5;
        let px = Math.round(dx * inputWidth);
        if (px < 0) px = 0;
        else if (px >= inputWidth) px = inputWidth - 1;
        let py = Math.round(dy * inputHeight);
        if (py < 0) py = 0;
        else if (py >= inputHeight) py = inputHeight - 1;
        const inputY = inputHeight - py - 1;
        const r = float32Array[inputY * inputWidth * 3 + px * 3 + 0];
        const g = float32Array[inputY * inputWidth * 3 + px * 3 + 1];
        const b = float32Array[inputY * inputWidth * 3 + px * 3 + 2];
        return {
            r: r,
            g: g,
            b: b
        };
    }
}
$c79ecc6787b65f4d$export$76063747088dfc2d.FACE_LEFT = [
    new (0, $ha1VO.Vector3)(-1, -1, -1),
    new (0, $ha1VO.Vector3)(1.0, -1, -1),
    new (0, $ha1VO.Vector3)(-1, 1.0, -1),
    new (0, $ha1VO.Vector3)(1.0, 1.0, -1)
];
$c79ecc6787b65f4d$export$76063747088dfc2d.FACE_RIGHT = [
    new (0, $ha1VO.Vector3)(1.0, -1, 1.0),
    new (0, $ha1VO.Vector3)(-1, -1, 1.0),
    new (0, $ha1VO.Vector3)(1.0, 1.0, 1.0),
    new (0, $ha1VO.Vector3)(-1, 1.0, 1.0)
];
$c79ecc6787b65f4d$export$76063747088dfc2d.FACE_FRONT = [
    new (0, $ha1VO.Vector3)(1.0, -1, -1),
    new (0, $ha1VO.Vector3)(1.0, -1, 1.0),
    new (0, $ha1VO.Vector3)(1.0, 1.0, -1),
    new (0, $ha1VO.Vector3)(1.0, 1.0, 1.0)
];
$c79ecc6787b65f4d$export$76063747088dfc2d.FACE_BACK = [
    new (0, $ha1VO.Vector3)(-1, -1, 1.0),
    new (0, $ha1VO.Vector3)(-1, -1, -1),
    new (0, $ha1VO.Vector3)(-1, 1.0, 1.0),
    new (0, $ha1VO.Vector3)(-1, 1.0, -1)
];
$c79ecc6787b65f4d$export$76063747088dfc2d.FACE_DOWN = [
    new (0, $ha1VO.Vector3)(1.0, 1.0, -1),
    new (0, $ha1VO.Vector3)(1.0, 1.0, 1.0),
    new (0, $ha1VO.Vector3)(-1, 1.0, -1),
    new (0, $ha1VO.Vector3)(-1, 1.0, 1.0)
];
$c79ecc6787b65f4d$export$76063747088dfc2d.FACE_UP = [
    new (0, $ha1VO.Vector3)(-1, -1, -1),
    new (0, $ha1VO.Vector3)(-1, -1, 1.0),
    new (0, $ha1VO.Vector3)(1.0, -1, -1),
    new (0, $ha1VO.Vector3)(1.0, -1, 1.0)
];

});


parcelRegister("9LfOV", function(module, exports) {

$parcel$export(module.exports, "HDRFiltering", () => $71b4c66d269e144a$export$40bdd62731636918);
parcelRequire("6rxfP");
var $ha1VO = parcelRequire("ha1VO");

var $1VEEL = parcelRequire("1VEEL");

var $iYGpr = parcelRequire("iYGpr");
parcelRequire("jXJzw");
parcelRequire("9UFFS");

var $kVtWi = parcelRequire("kVtWi");
class $71b4c66d269e144a$export$40bdd62731636918 {
    /**
     * Instantiates HDR filter for reflection maps
     *
     * @param engine Thin engine
     * @param options Options
     */ constructor(engine, options = {}){
        this._lodGenerationOffset = 0;
        this._lodGenerationScale = 0.8;
        /**
         * Quality switch for prefiltering. Should be set to `4096` unless
         * you care about baking speed.
         */ this.quality = 4096;
        /**
         * Scales pixel intensity for the input HDR map.
         */ this.hdrScale = 1;
        // pass
        this._engine = engine;
        this.hdrScale = options.hdrScale || this.hdrScale;
        this.quality = options.quality || this.quality;
    }
    _createRenderTarget(size) {
        let textureType = 0;
        if (this._engine.getCaps().textureHalfFloatRender) textureType = 2;
        else if (this._engine.getCaps().textureFloatRender) textureType = 1;
        const rtWrapper = this._engine.createRenderTargetCubeTexture(size, {
            format: 5,
            type: textureType,
            createMipMaps: true,
            generateMipMaps: false,
            generateDepthBuffer: false,
            generateStencilBuffer: false,
            samplingMode: 1
        });
        this._engine.updateTextureWrappingMode(rtWrapper.texture, 0, 0, 0);
        this._engine.updateTextureSamplingMode(3, rtWrapper.texture, true);
        return rtWrapper;
    }
    _prefilterInternal(texture) {
        const width = texture.getSize().width;
        const mipmapsCount = (0, $1VEEL.Scalar).ILog2(width) + 1;
        const effect = this._effectWrapper.effect;
        const outputTexture = this._createRenderTarget(width);
        this._effectRenderer.saveStates();
        this._effectRenderer.setViewport();
        const intTexture = texture.getInternalTexture();
        if (intTexture) // Just in case generate fresh clean mips.
        this._engine.updateTextureSamplingMode(3, intTexture, true);
        this._effectRenderer.applyEffectWrapper(this._effectWrapper);
        const directions = [
            [
                new (0, $ha1VO.Vector3)(0, 0, -1),
                new (0, $ha1VO.Vector3)(0, -1, 0),
                new (0, $ha1VO.Vector3)(1, 0, 0)
            ],
            [
                new (0, $ha1VO.Vector3)(0, 0, 1),
                new (0, $ha1VO.Vector3)(0, -1, 0),
                new (0, $ha1VO.Vector3)(-1, 0, 0)
            ],
            [
                new (0, $ha1VO.Vector3)(1, 0, 0),
                new (0, $ha1VO.Vector3)(0, 0, 1),
                new (0, $ha1VO.Vector3)(0, 1, 0)
            ],
            [
                new (0, $ha1VO.Vector3)(1, 0, 0),
                new (0, $ha1VO.Vector3)(0, 0, -1),
                new (0, $ha1VO.Vector3)(0, -1, 0)
            ],
            [
                new (0, $ha1VO.Vector3)(1, 0, 0),
                new (0, $ha1VO.Vector3)(0, -1, 0),
                new (0, $ha1VO.Vector3)(0, 0, 1)
            ],
            [
                new (0, $ha1VO.Vector3)(-1, 0, 0),
                new (0, $ha1VO.Vector3)(0, -1, 0),
                new (0, $ha1VO.Vector3)(0, 0, -1)
            ]
        ];
        effect.setFloat("hdrScale", this.hdrScale);
        effect.setFloat2("vFilteringInfo", texture.getSize().width, mipmapsCount);
        effect.setTexture("inputTexture", texture);
        for(let face = 0; face < 6; face++){
            effect.setVector3("up", directions[face][0]);
            effect.setVector3("right", directions[face][1]);
            effect.setVector3("front", directions[face][2]);
            for(let lod = 0; lod < mipmapsCount; lod++){
                this._engine.bindFramebuffer(outputTexture, face, undefined, undefined, true, lod);
                this._effectRenderer.applyEffectWrapper(this._effectWrapper);
                let alpha = Math.pow(2, (lod - this._lodGenerationOffset) / this._lodGenerationScale) / width;
                if (lod === 0) alpha = 0;
                effect.setFloat("alphaG", alpha);
                this._effectRenderer.draw();
            }
        }
        // Cleanup
        this._effectRenderer.restoreStates();
        this._engine.restoreDefaultFramebuffer();
        this._engine._releaseTexture(texture._texture);
        // Internal Swap
        const type = outputTexture.texture.type;
        const format = outputTexture.texture.format;
        outputTexture._swapAndDie(texture._texture);
        texture._texture.type = type;
        texture._texture.format = format;
        // New settings
        texture.gammaSpace = false;
        texture.lodGenerationOffset = this._lodGenerationOffset;
        texture.lodGenerationScale = this._lodGenerationScale;
        texture._prefiltered = true;
        return texture;
    }
    _createEffect(texture, onCompiled) {
        const defines = [];
        if (texture.gammaSpace) defines.push("#define GAMMA_INPUT");
        defines.push("#define NUM_SAMPLES " + this.quality + "u"); // unsigned int
        const effectWrapper = new (0, $iYGpr.EffectWrapper)({
            engine: this._engine,
            name: "hdrFiltering",
            vertexShader: "hdrFiltering",
            fragmentShader: "hdrFiltering",
            samplerNames: [
                "inputTexture"
            ],
            uniformNames: [
                "vSampleDirections",
                "vWeights",
                "up",
                "right",
                "front",
                "vFilteringInfo",
                "hdrScale",
                "alphaG"
            ],
            useShaderStore: true,
            defines: defines,
            onCompiled: onCompiled
        });
        return effectWrapper;
    }
    /**
     * Get a value indicating if the filter is ready to be used
     * @param texture Texture to filter
     * @returns true if the filter is ready
     */ isReady(texture) {
        return texture.isReady() && this._effectWrapper.effect.isReady();
    }
    /**
     * Prefilters a cube texture to have mipmap levels representing roughness values.
     * Prefiltering will be invoked at the end of next rendering pass.
     * This has to be done once the map is loaded, and has not been prefiltered by a third party software.
     * See http://blog.selfshadow.com/publications/s2013-shading-course/karis/s2013_pbs_epic_notes_v2.pdf for more information
     * @param texture Texture to filter
     * @param onFinished Callback when filtering is done
     * @returns Promise called when prefiltering is done
     */ prefilter(texture, onFinished = null) {
        if (!this._engine._features.allowTexturePrefiltering) {
            (0, $kVtWi.Logger).Warn("HDR prefiltering is not available in WebGL 1., you can use real time filtering instead.");
            return Promise.reject("HDR prefiltering is not available in WebGL 1., you can use real time filtering instead.");
        }
        return new Promise((resolve)=>{
            this._effectRenderer = new (0, $iYGpr.EffectRenderer)(this._engine);
            this._effectWrapper = this._createEffect(texture);
            this._effectWrapper.effect.executeWhenCompiled(()=>{
                this._prefilterInternal(texture);
                this._effectRenderer.dispose();
                this._effectWrapper.dispose();
                resolve();
                if (onFinished) onFinished();
            });
        });
    }
}

});
parcelRegister("jXJzw", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $e886e0a75fd16465$var$name = "hdrFilteringVertexShader";
const $e886e0a75fd16465$var$shader = `attribute vec2 position;varying vec3 direction;uniform vec3 up;uniform vec3 right;uniform vec3 front;
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
mat3 view=mat3(up,right,front);direction=view*vec3(position,1.0);gl_Position=vec4(position,0.0,1.0);
#define CUSTOM_VERTEX_MAIN_END
}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$e886e0a75fd16465$var$name] = $e886e0a75fd16465$var$shader;
const $e886e0a75fd16465$export$7df3f96b4dea8424 = {
    name: $e886e0a75fd16465$var$name,
    shader: $e886e0a75fd16465$var$shader
};

});

parcelRegister("9UFFS", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("7Hs3g");
parcelRequire("fsNb6");
parcelRequire("bzdhG");
parcelRequire("aqaLg");
const $7379abb5ea9a6204$var$name = "hdrFilteringPixelShader";
const $7379abb5ea9a6204$var$shader = `#include<helperFunctions>
#include<importanceSampling>
#include<pbrBRDFFunctions>
#include<hdrFilteringFunctions>
uniform float alphaG;uniform samplerCube inputTexture;uniform vec2 vFilteringInfo;uniform float hdrScale;varying vec3 direction;void main() {vec3 color=radiance(alphaG,inputTexture,direction,vFilteringInfo);gl_FragColor=vec4(color*hdrScale,1.0);}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$7379abb5ea9a6204$var$name] = $7379abb5ea9a6204$var$shader;
const $7379abb5ea9a6204$export$a2ef96d4c7fc0e35 = {
    name: $7379abb5ea9a6204$var$name,
    shader: $7379abb5ea9a6204$var$shader
};

});



parcelRegister("c9v5E", function(module, exports) {

$parcel$export(module.exports, "MorphTargetManager", () => $8d8e712bd1875cdd$export$57426e3eafceaf36);

var $57onU = parcelRequire("57onU");

var $kVtWi = parcelRequire("kVtWi");

var $ejQPp = parcelRequire("ejQPp");

var $1oI71 = parcelRequire("1oI71");

var $ePSfe = parcelRequire("ePSfe");
class $8d8e712bd1875cdd$export$57426e3eafceaf36 {
    /**
     * Sets a boolean indicating that adding new target or updating an existing target will not update the underlying data buffers
     */ set areUpdatesFrozen(block) {
        if (block) this._blockCounter++;
        else {
            this._blockCounter--;
            if (this._blockCounter <= 0) {
                this._blockCounter = 0;
                this._syncActiveTargets(true);
            }
        }
    }
    get areUpdatesFrozen() {
        return this._blockCounter > 0;
    }
    /**
     * Creates a new MorphTargetManager
     * @param scene defines the current scene
     */ constructor(scene = null){
        this._targets = new Array();
        this._targetInfluenceChangedObservers = new Array();
        this._targetDataLayoutChangedObservers = new Array();
        this._activeTargets = new (0, $57onU.SmartArray)(16);
        this._supportsNormals = false;
        this._supportsTangents = false;
        this._supportsUVs = false;
        this._vertexCount = 0;
        this._textureVertexStride = 0;
        this._textureWidth = 0;
        this._textureHeight = 1;
        this._uniqueId = 0;
        this._tempInfluences = new Array();
        this._canUseTextureForTargets = false;
        this._blockCounter = 0;
        /** @internal */ this._parentContainer = null;
        /**
         * Gets or sets a boolean indicating if influencers must be optimized (eg. recompiling the shader if less influencers are used)
         */ this.optimizeInfluencers = true;
        /**
         * Gets or sets a boolean indicating if normals must be morphed
         */ this.enableNormalMorphing = true;
        /**
         * Gets or sets a boolean indicating if tangents must be morphed
         */ this.enableTangentMorphing = true;
        /**
         * Gets or sets a boolean indicating if UV must be morphed
         */ this.enableUVMorphing = true;
        this._numMaxInfluencers = 0;
        this._useTextureToStoreTargets = true;
        if (!scene) scene = (0, $ejQPp.EngineStore).LastCreatedScene;
        this._scene = scene;
        if (this._scene) {
            this._scene.addMorphTargetManager(this);
            this._uniqueId = this._scene.getUniqueId();
            const engineCaps = this._scene.getEngine().getCaps();
            this._canUseTextureForTargets = engineCaps.canUseGLVertexID && engineCaps.textureFloat && engineCaps.maxVertexTextureImageUnits > 0 && engineCaps.texture2DArrayMaxLayerCount > 1;
        }
    }
    /**
     * Gets or sets the maximum number of influencers (targets) (default value: 0).
     * Setting a value for this property can lead to a smoother experience, as only one shader will be compiled, which will use this value as the maximum number of influencers.
     * If you leave the value at 0 (default), a new shader will be compiled every time the number of active influencers changes. This can cause problems, as compiling a shader takes time.
     * If you assign a non-zero value to this property, you need to ensure that this value is greater than the maximum number of (active) influencers you'll need for this morph manager.
     * Otherwise, the number of active influencers will be truncated at the value you set for this property, which can lead to unexpected results.
     * Note that this property has no effect if "useTextureToStoreTargets" is false.
     */ get numMaxInfluencers() {
        return this._numMaxInfluencers;
    }
    set numMaxInfluencers(value) {
        if (this._numMaxInfluencers === value) return;
        this._numMaxInfluencers = value;
        this._syncActiveTargets(true);
    }
    /**
     * Gets the unique ID of this manager
     */ get uniqueId() {
        return this._uniqueId;
    }
    /**
     * Gets the number of vertices handled by this manager
     */ get vertexCount() {
        return this._vertexCount;
    }
    /**
     * Gets a boolean indicating if this manager supports morphing of normals
     */ get supportsNormals() {
        return this._supportsNormals && this.enableNormalMorphing;
    }
    /**
     * Gets a boolean indicating if this manager supports morphing of tangents
     */ get supportsTangents() {
        return this._supportsTangents && this.enableTangentMorphing;
    }
    /**
     * Gets a boolean indicating if this manager supports morphing of texture coordinates
     */ get supportsUVs() {
        return this._supportsUVs && this.enableUVMorphing;
    }
    /**
     * Gets the number of targets stored in this manager
     */ get numTargets() {
        return this._targets.length;
    }
    /**
     * Gets the number of influencers (ie. the number of targets with influences > 0)
     */ get numInfluencers() {
        return this._activeTargets.length;
    }
    /**
     * Gets the list of influences (one per target)
     */ get influences() {
        return this._influences;
    }
    /**
     * Gets or sets a boolean indicating that targets should be stored as a texture instead of using vertex attributes (default is true).
     * Please note that this option is not available if the hardware does not support it
     */ get useTextureToStoreTargets() {
        return this._useTextureToStoreTargets;
    }
    set useTextureToStoreTargets(value) {
        this._useTextureToStoreTargets = value;
    }
    /**
     * Gets a boolean indicating that the targets are stored into a texture (instead of as attributes)
     */ get isUsingTextureForTargets() {
        return $8d8e712bd1875cdd$export$57426e3eafceaf36.EnableTextureStorage && this.useTextureToStoreTargets && this._canUseTextureForTargets && !this._scene?.getEngine().getCaps().disableMorphTargetTexture;
    }
    /**
     * Gets the active target at specified index. An active target is a target with an influence > 0
     * @param index defines the index to check
     * @returns the requested target
     */ getActiveTarget(index) {
        return this._activeTargets.data[index];
    }
    /**
     * Gets the target at specified index
     * @param index defines the index to check
     * @returns the requested target
     */ getTarget(index) {
        return this._targets[index];
    }
    /**
     * Add a new target to this manager
     * @param target defines the target to add
     */ addTarget(target) {
        this._targets.push(target);
        this._targetInfluenceChangedObservers.push(target.onInfluenceChanged.add((needUpdate)=>{
            this._syncActiveTargets(needUpdate);
        }));
        this._targetDataLayoutChangedObservers.push(target._onDataLayoutChanged.add(()=>{
            this._syncActiveTargets(true);
        }));
        this._syncActiveTargets(true);
    }
    /**
     * Removes a target from the manager
     * @param target defines the target to remove
     */ removeTarget(target) {
        const index = this._targets.indexOf(target);
        if (index >= 0) {
            this._targets.splice(index, 1);
            target.onInfluenceChanged.remove(this._targetInfluenceChangedObservers.splice(index, 1)[0]);
            target._onDataLayoutChanged.remove(this._targetDataLayoutChangedObservers.splice(index, 1)[0]);
            this._syncActiveTargets(true);
        }
        if (this._scene) this._scene.stopAnimation(target);
    }
    /**
     * @internal
     */ _bind(effect) {
        effect.setFloat3("morphTargetTextureInfo", this._textureVertexStride, this._textureWidth, this._textureHeight);
        effect.setFloatArray("morphTargetTextureIndices", this._morphTargetTextureIndices);
        effect.setTexture("morphTargets", this._targetStoreTexture);
        effect.setInt("morphTargetCount", this.numInfluencers);
    }
    /**
     * Clone the current manager
     * @returns a new MorphTargetManager
     */ clone() {
        const copy = new $8d8e712bd1875cdd$export$57426e3eafceaf36(this._scene);
        for (const target of this._targets)copy.addTarget(target.clone());
        copy.enableNormalMorphing = this.enableNormalMorphing;
        copy.enableTangentMorphing = this.enableTangentMorphing;
        copy.enableUVMorphing = this.enableUVMorphing;
        return copy;
    }
    /**
     * Serializes the current manager into a Serialization object
     * @returns the serialized object
     */ serialize() {
        const serializationObject = {};
        serializationObject.id = this.uniqueId;
        serializationObject.targets = [];
        for (const target of this._targets)serializationObject.targets.push(target.serialize());
        return serializationObject;
    }
    _syncActiveTargets(needUpdate) {
        if (this.areUpdatesFrozen) return;
        let influenceCount = 0;
        this._activeTargets.reset();
        this._supportsNormals = true;
        this._supportsTangents = true;
        this._supportsUVs = true;
        this._vertexCount = 0;
        if (this._scene && this._targets.length > this._scene.getEngine().getCaps().texture2DArrayMaxLayerCount) this.useTextureToStoreTargets = false;
        if (!this._morphTargetTextureIndices || this._morphTargetTextureIndices.length !== this._targets.length) this._morphTargetTextureIndices = new Float32Array(this._targets.length);
        let targetIndex = -1;
        for (const target of this._targets){
            targetIndex++;
            if (target.influence === 0 && this.optimizeInfluencers) continue;
            if (this._activeTargets.length >= $8d8e712bd1875cdd$export$57426e3eafceaf36.MaxActiveMorphTargetsInVertexAttributeMode && !this.isUsingTextureForTargets) break;
            this._activeTargets.push(target);
            this._morphTargetTextureIndices[influenceCount] = targetIndex;
            this._tempInfluences[influenceCount++] = target.influence;
            this._supportsNormals = this._supportsNormals && target.hasNormals;
            this._supportsTangents = this._supportsTangents && target.hasTangents;
            this._supportsUVs = this._supportsUVs && target.hasUVs;
            const positions = target.getPositions();
            if (positions) {
                const vertexCount = positions.length / 3;
                if (this._vertexCount === 0) this._vertexCount = vertexCount;
                else if (this._vertexCount !== vertexCount) {
                    (0, $kVtWi.Logger).Error("Incompatible target. Targets must all have the same vertices count.");
                    return;
                }
            }
        }
        if (this._morphTargetTextureIndices.length !== influenceCount) this._morphTargetTextureIndices = this._morphTargetTextureIndices.slice(0, influenceCount);
        if (!this._influences || this._influences.length !== influenceCount) this._influences = new Float32Array(influenceCount);
        for(let index = 0; index < influenceCount; index++)this._influences[index] = this._tempInfluences[index];
        if (needUpdate) this.synchronize();
    }
    /**
     * Synchronize the targets with all the meshes using this morph target manager
     */ synchronize() {
        if (!this._scene || this.areUpdatesFrozen) return;
        if (this.isUsingTextureForTargets && (this._vertexCount || this.numMaxInfluencers > 0)) {
            this._textureVertexStride = 1;
            if (this._supportsNormals) this._textureVertexStride++;
            if (this._supportsTangents) this._textureVertexStride++;
            if (this._supportsUVs) this._textureVertexStride++;
            this._textureWidth = this._vertexCount * this._textureVertexStride || 1;
            this._textureHeight = 1;
            const maxTextureSize = this._scene.getEngine().getCaps().maxTextureSize;
            if (this._textureWidth > maxTextureSize) {
                this._textureHeight = Math.ceil(this._textureWidth / maxTextureSize);
                this._textureWidth = maxTextureSize;
            }
            let mustUpdateTexture = true;
            if (this._targetStoreTexture) {
                const textureSize = this._targetStoreTexture.getSize();
                if (textureSize.width === this._textureWidth && textureSize.height === this._textureHeight && this._targetStoreTexture.depth === this._targets.length) mustUpdateTexture = false;
            }
            if (mustUpdateTexture) {
                if (this._targetStoreTexture) this._targetStoreTexture.dispose();
                const targetCount = this._targets.length;
                const data = new Float32Array(targetCount * this._textureWidth * this._textureHeight * 4);
                let offset = 0;
                for(let index = 0; index < targetCount; index++){
                    const target = this._targets[index];
                    const positions = target.getPositions();
                    const normals = target.getNormals();
                    const uvs = target.getUVs();
                    const tangents = target.getTangents();
                    if (!positions) {
                        if (index === 0) (0, $kVtWi.Logger).Error("Invalid morph target. Target must have positions.");
                        return;
                    }
                    offset = index * this._textureWidth * this._textureHeight * 4;
                    for(let vertex = 0; vertex < this._vertexCount; vertex++){
                        data[offset] = positions[vertex * 3];
                        data[offset + 1] = positions[vertex * 3 + 1];
                        data[offset + 2] = positions[vertex * 3 + 2];
                        offset += 4;
                        if (this._supportsNormals && normals) {
                            data[offset] = normals[vertex * 3];
                            data[offset + 1] = normals[vertex * 3 + 1];
                            data[offset + 2] = normals[vertex * 3 + 2];
                            offset += 4;
                        }
                        if (this._supportsUVs && uvs) {
                            data[offset] = uvs[vertex * 2];
                            data[offset + 1] = uvs[vertex * 2 + 1];
                            offset += 4;
                        }
                        if (this._supportsTangents && tangents) {
                            data[offset] = tangents[vertex * 3];
                            data[offset + 1] = tangents[vertex * 3 + 1];
                            data[offset + 2] = tangents[vertex * 3 + 2];
                            offset += 4;
                        }
                    }
                }
                this._targetStoreTexture = (0, $ePSfe.RawTexture2DArray).CreateRGBATexture(data, this._textureWidth, this._textureHeight, targetCount, this._scene, false, false, 1, 1);
            }
        }
        // Flag meshes as dirty to resync with the active targets
        for (const mesh of this._scene.meshes)if (mesh.morphTargetManager === this) mesh._syncGeometryWithMorphTargetManager();
    }
    /**
     * Release all resources
     */ dispose() {
        if (this._targetStoreTexture) this._targetStoreTexture.dispose();
        this._targetStoreTexture = null;
        // Remove from scene
        if (this._scene) {
            this._scene.removeMorphTargetManager(this);
            if (this._parentContainer) {
                const index = this._parentContainer.morphTargetManagers.indexOf(this);
                if (index > -1) this._parentContainer.morphTargetManagers.splice(index, 1);
                this._parentContainer = null;
            }
            for (const morph of this._targets)this._scene.stopAnimation(morph);
        }
    }
    // Statics
    /**
     * Creates a new MorphTargetManager from serialized data
     * @param serializationObject defines the serialized data
     * @param scene defines the hosting scene
     * @returns the new MorphTargetManager
     */ static Parse(serializationObject, scene) {
        const result = new $8d8e712bd1875cdd$export$57426e3eafceaf36(scene);
        result._uniqueId = serializationObject.id;
        for (const targetData of serializationObject.targets)result.addTarget((0, $1oI71.MorphTarget).Parse(targetData, scene));
        return result;
    }
}
/** Enable storing morph target data into textures when set to true (true by default) */ $8d8e712bd1875cdd$export$57426e3eafceaf36.EnableTextureStorage = true;
/** Maximum number of active morph targets supported in the "vertex attribute" mode (i.e., not the "texture" mode) */ $8d8e712bd1875cdd$export$57426e3eafceaf36.MaxActiveMorphTargetsInVertexAttributeMode = 8;

});
parcelRegister("1oI71", function(module, exports) {

$parcel$export(module.exports, "MorphTarget", () => $104a4020572fd365$export$3c16fd3768d7a9bf);

var $e0Suo = parcelRequire("e0Suo");

var $diGQf = parcelRequire("diGQf");

var $ejQPp = parcelRequire("ejQPp");

var $b4i1f = parcelRequire("b4i1f");

var $ir0rz = parcelRequire("ir0rz");

var $6Ho1L = parcelRequire("6Ho1L");

var $8DoUR = parcelRequire("8DoUR");
class $104a4020572fd365$export$3c16fd3768d7a9bf {
    /**
     * Gets or sets the influence of this target (ie. its weight in the overall morphing)
     */ get influence() {
        return this._influence;
    }
    set influence(influence) {
        if (this._influence === influence) return;
        const previous = this._influence;
        this._influence = influence;
        if (this.onInfluenceChanged.hasObservers()) this.onInfluenceChanged.notifyObservers(previous === 0 || influence === 0);
    }
    /**
     * Gets or sets the animation properties override
     */ get animationPropertiesOverride() {
        if (!this._animationPropertiesOverride && this._scene) return this._scene.animationPropertiesOverride;
        return this._animationPropertiesOverride;
    }
    set animationPropertiesOverride(value) {
        this._animationPropertiesOverride = value;
    }
    /**
     * Creates a new MorphTarget
     * @param name defines the name of the target
     * @param influence defines the influence to use
     * @param scene defines the scene the morphtarget belongs to
     */ constructor(/** defines the name of the target */ name, influence = 0, scene = null){
        this.name = name;
        /**
         * Gets or sets the list of animations
         */ this.animations = [];
        this._positions = null;
        this._normals = null;
        this._tangents = null;
        this._uvs = null;
        this._uniqueId = 0;
        /**
         * Observable raised when the influence changes
         */ this.onInfluenceChanged = new (0, $diGQf.Observable)();
        /** @internal */ this._onDataLayoutChanged = new (0, $diGQf.Observable)();
        this._animationPropertiesOverride = null;
        this._scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        this.influence = influence;
        if (this._scene) this._uniqueId = this._scene.getUniqueId();
    }
    /**
     * Gets the unique ID of this manager
     */ get uniqueId() {
        return this._uniqueId;
    }
    /**
     * Gets a boolean defining if the target contains position data
     */ get hasPositions() {
        return !!this._positions;
    }
    /**
     * Gets a boolean defining if the target contains normal data
     */ get hasNormals() {
        return !!this._normals;
    }
    /**
     * Gets a boolean defining if the target contains tangent data
     */ get hasTangents() {
        return !!this._tangents;
    }
    /**
     * Gets a boolean defining if the target contains texture coordinates data
     */ get hasUVs() {
        return !!this._uvs;
    }
    /**
     * Affects position data to this target
     * @param data defines the position data to use
     */ setPositions(data) {
        const hadPositions = this.hasPositions;
        this._positions = data;
        if (hadPositions !== this.hasPositions) this._onDataLayoutChanged.notifyObservers(undefined);
    }
    /**
     * Gets the position data stored in this target
     * @returns a FloatArray containing the position data (or null if not present)
     */ getPositions() {
        return this._positions;
    }
    /**
     * Affects normal data to this target
     * @param data defines the normal data to use
     */ setNormals(data) {
        const hadNormals = this.hasNormals;
        this._normals = data;
        if (hadNormals !== this.hasNormals) this._onDataLayoutChanged.notifyObservers(undefined);
    }
    /**
     * Gets the normal data stored in this target
     * @returns a FloatArray containing the normal data (or null if not present)
     */ getNormals() {
        return this._normals;
    }
    /**
     * Affects tangent data to this target
     * @param data defines the tangent data to use
     */ setTangents(data) {
        const hadTangents = this.hasTangents;
        this._tangents = data;
        if (hadTangents !== this.hasTangents) this._onDataLayoutChanged.notifyObservers(undefined);
    }
    /**
     * Gets the tangent data stored in this target
     * @returns a FloatArray containing the tangent data (or null if not present)
     */ getTangents() {
        return this._tangents;
    }
    /**
     * Affects texture coordinates data to this target
     * @param data defines the texture coordinates data to use
     */ setUVs(data) {
        const hadUVs = this.hasUVs;
        this._uvs = data;
        if (hadUVs !== this.hasUVs) this._onDataLayoutChanged.notifyObservers(undefined);
    }
    /**
     * Gets the texture coordinates data stored in this target
     * @returns a FloatArray containing the texture coordinates data (or null if not present)
     */ getUVs() {
        return this._uvs;
    }
    /**
     * Clone the current target
     * @returns a new MorphTarget
     */ clone() {
        const newOne = (0, $6Ho1L.SerializationHelper).Clone(()=>new $104a4020572fd365$export$3c16fd3768d7a9bf(this.name, this.influence, this._scene), this);
        newOne._positions = this._positions;
        newOne._normals = this._normals;
        newOne._tangents = this._tangents;
        newOne._uvs = this._uvs;
        return newOne;
    }
    /**
     * Serializes the current target into a Serialization object
     * @returns the serialized object
     */ serialize() {
        const serializationObject = {};
        serializationObject.name = this.name;
        serializationObject.influence = this.influence;
        serializationObject.positions = Array.prototype.slice.call(this.getPositions());
        if (this.id != null) serializationObject.id = this.id;
        if (this.hasNormals) serializationObject.normals = Array.prototype.slice.call(this.getNormals());
        if (this.hasTangents) serializationObject.tangents = Array.prototype.slice.call(this.getTangents());
        if (this.hasUVs) serializationObject.uvs = Array.prototype.slice.call(this.getUVs());
        // Animations
        (0, $6Ho1L.SerializationHelper).AppendSerializedAnimations(this, serializationObject);
        return serializationObject;
    }
    /**
     * Returns the string "MorphTarget"
     * @returns "MorphTarget"
     */ getClassName() {
        return "MorphTarget";
    }
    // Statics
    /**
     * Creates a new target from serialized data
     * @param serializationObject defines the serialized data to use
     * @param scene defines the hosting scene
     * @returns a new MorphTarget
     */ static Parse(serializationObject, scene) {
        const result = new $104a4020572fd365$export$3c16fd3768d7a9bf(serializationObject.name, serializationObject.influence);
        result.setPositions(serializationObject.positions);
        if (serializationObject.id != null) result.id = serializationObject.id;
        if (serializationObject.normals) result.setNormals(serializationObject.normals);
        if (serializationObject.tangents) result.setTangents(serializationObject.tangents);
        if (serializationObject.uvs) result.setUVs(serializationObject.uvs);
        // Animations
        if (serializationObject.animations) {
            for(let animationIndex = 0; animationIndex < serializationObject.animations.length; animationIndex++){
                const parsedAnimation = serializationObject.animations[animationIndex];
                const internalClass = (0, $8DoUR.GetClass)("BABYLON.Animation");
                if (internalClass) result.animations.push(internalClass.Parse(parsedAnimation));
            }
            if (serializationObject.autoAnimate && scene) scene.beginAnimation(result, serializationObject.autoAnimateFrom, serializationObject.autoAnimateTo, serializationObject.autoAnimateLoop, serializationObject.autoAnimateSpeed || 1.0);
        }
        return result;
    }
    /**
     * Creates a MorphTarget from mesh data
     * @param mesh defines the source mesh
     * @param name defines the name to use for the new target
     * @param influence defines the influence to attach to the target
     * @returns a new MorphTarget
     */ static FromMesh(mesh, name, influence) {
        if (!name) name = mesh.name;
        const result = new $104a4020572fd365$export$3c16fd3768d7a9bf(name, influence, mesh.getScene());
        result.setPositions(mesh.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind));
        if (mesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).NormalKind)) result.setNormals(mesh.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind));
        if (mesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).TangentKind)) result.setTangents(mesh.getVerticesData((0, $b4i1f.VertexBuffer).TangentKind));
        if (mesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UVKind)) result.setUVs(mesh.getVerticesData((0, $b4i1f.VertexBuffer).UVKind));
        return result;
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $104a4020572fd365$export$3c16fd3768d7a9bf.prototype, "id", void 0);

});

parcelRegister("ePSfe", function(module, exports) {

$parcel$export(module.exports, "RawTexture2DArray", () => $accfe7fe0da9e6c9$export$226299a91f6adbb4);

var $j2mX5 = parcelRequire("j2mX5");
parcelRequire("e7NUJ");
class $accfe7fe0da9e6c9$export$226299a91f6adbb4 extends (0, $j2mX5.Texture) {
    /**
     * Gets the number of layers of the texture
     */ get depth() {
        return this._depth;
    }
    /**
     * Create a new RawTexture2DArray
     * @param data defines the data of the texture
     * @param width defines the width of the texture
     * @param height defines the height of the texture
     * @param depth defines the number of layers of the texture
     * @param format defines the texture format to use
     * @param scene defines the hosting scene
     * @param generateMipMaps defines a boolean indicating if mip levels should be generated (true by default)
     * @param invertY defines if texture must be stored with Y axis inverted
     * @param samplingMode defines the sampling mode to use (Texture.TRILINEAR_SAMPLINGMODE by default)
     * @param textureType defines the texture Type (Engine.TEXTURETYPE_UNSIGNED_INT, Engine.TEXTURETYPE_FLOAT...)
     * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
     */ constructor(data, width, height, depth, /** Gets or sets the texture format to use */ format, scene, generateMipMaps = true, invertY = false, samplingMode = (0, $j2mX5.Texture).TRILINEAR_SAMPLINGMODE, textureType = 0, creationFlags){
        super(null, scene, !generateMipMaps, invertY);
        this.format = format;
        this._texture = scene.getEngine().createRawTexture2DArray(data, width, height, depth, format, generateMipMaps, invertY, samplingMode, null, textureType, creationFlags);
        this._depth = depth;
        this.is2DArray = true;
    }
    /**
     * Update the texture with new data
     * @param data defines the data to store in the texture
     */ update(data) {
        if (!this._texture) return;
        this._getEngine().updateRawTexture2DArray(this._texture, data, this._texture.format, this._texture.invertY, null, this._texture.type);
    }
    /**
     * Creates a RGBA texture from some data.
     * @param data Define the texture data
     * @param width Define the width of the texture
     * @param height Define the height of the texture
     * @param depth defines the number of layers of the texture
     * @param scene defines the scene the texture will belong to
     * @param generateMipMaps Define whether or not to create mip maps for the texture
     * @param invertY define if the data should be flipped on Y when uploaded to the GPU
     * @param samplingMode define the texture sampling mode (Texture.xxx_SAMPLINGMODE)
     * @param type define the format of the data (int, float... Engine.TEXTURETYPE_xxx)
     * @returns the RGBA texture
     */ static CreateRGBATexture(data, width, height, depth, scene, generateMipMaps = true, invertY = false, samplingMode = 3, type = 0) {
        return new $accfe7fe0da9e6c9$export$226299a91f6adbb4(data, width, height, depth, 5, scene, generateMipMaps, invertY, samplingMode, type);
    }
}

});


parcelRegister("9l7E8", function(module, exports) {

$parcel$export(module.exports, "CannonJSPlugin", () => $6ccc019e222cb599$export$2873373418a42505);

var $kVtWi = parcelRequire("kVtWi");

var $ha1VO = parcelRequire("ha1VO");

var $b4i1f = parcelRequire("b4i1f");

var $iz3U8 = parcelRequire("iz3U8");

var $kGTHw = parcelRequire("kGTHw");

var $iz1eP = parcelRequire("iz1eP");

var $4qQ0v = parcelRequire("4qQ0v");

var $53VPf = parcelRequire("53VPf");
class $6ccc019e222cb599$export$2873373418a42505 {
    constructor(_useDeltaForWorldStep = true, iterations = 10, cannonInjection = CANNON){
        this._useDeltaForWorldStep = _useDeltaForWorldStep;
        this.name = "CannonJSPlugin";
        this._physicsMaterials = new Array();
        this._fixedTimeStep = 1 / 60;
        this._physicsBodiesToRemoveAfterStep = new Array();
        this._firstFrame = true;
        this._tmpQuaternion = new (0, $ha1VO.Quaternion)();
        this._minus90X = new (0, $ha1VO.Quaternion)(-0.7071067811865475, 0, 0, 0.7071067811865475);
        this._plus90X = new (0, $ha1VO.Quaternion)(0.7071067811865475, 0, 0, 0.7071067811865475);
        this._tmpPosition = (0, $ha1VO.Vector3).Zero();
        this._tmpDeltaPosition = (0, $ha1VO.Vector3).Zero();
        this._tmpUnityRotation = new (0, $ha1VO.Quaternion)();
        this.BJSCANNON = cannonInjection;
        if (!this.isSupported()) {
            (0, $kVtWi.Logger).Error("CannonJS is not available. Please make sure you included the js file.");
            return;
        }
        this._extendNamespace();
        this.world = new this.BJSCANNON.World();
        this.world.broadphase = new this.BJSCANNON.NaiveBroadphase();
        this.world.solver.iterations = iterations;
        this._cannonRaycastResult = new this.BJSCANNON.RaycastResult();
        this._raycastResult = new (0, $iz1eP.PhysicsRaycastResult)();
    }
    /**
     *
     * @returns plugin version
     */ getPluginVersion() {
        return 1;
    }
    setGravity(gravity) {
        const vec = gravity;
        this.world.gravity.set(vec.x, vec.y, vec.z);
    }
    setTimeStep(timeStep) {
        this._fixedTimeStep = timeStep;
    }
    getTimeStep() {
        return this._fixedTimeStep;
    }
    executeStep(delta, impostors) {
        // due to cannon's architecture, the first frame's before-step is skipped.
        if (this._firstFrame) {
            this._firstFrame = false;
            for (const impostor of impostors)if (!(impostor.type == (0, $iz3U8.PhysicsImpostor).HeightmapImpostor || impostor.type === (0, $iz3U8.PhysicsImpostor).PlaneImpostor)) impostor.beforeStep();
        }
        this.world.step(this._useDeltaForWorldStep ? delta : this._fixedTimeStep);
        this._removeMarkedPhysicsBodiesFromWorld();
    }
    _removeMarkedPhysicsBodiesFromWorld() {
        if (this._physicsBodiesToRemoveAfterStep.length > 0) {
            this._physicsBodiesToRemoveAfterStep.forEach((physicsBody)=>{
                if (typeof this.world.removeBody === "function") this.world.removeBody(physicsBody);
                else this.world.remove(physicsBody);
            });
            this._physicsBodiesToRemoveAfterStep.length = 0;
        }
    }
    applyImpulse(impostor, force, contactPoint) {
        const worldPoint = new this.BJSCANNON.Vec3(contactPoint.x, contactPoint.y, contactPoint.z);
        const impulse = new this.BJSCANNON.Vec3(force.x, force.y, force.z);
        impostor.physicsBody.applyImpulse(impulse, worldPoint);
    }
    applyForce(impostor, force, contactPoint) {
        const worldPoint = new this.BJSCANNON.Vec3(contactPoint.x, contactPoint.y, contactPoint.z);
        const impulse = new this.BJSCANNON.Vec3(force.x, force.y, force.z);
        impostor.physicsBody.applyForce(impulse, worldPoint);
    }
    generatePhysicsBody(impostor) {
        // When calling forceUpdate generatePhysicsBody is called again, ensure that the updated body does not instantly collide with removed body
        this._removeMarkedPhysicsBodiesFromWorld();
        //parent-child relationship. Does this impostor have a parent impostor?
        if (impostor.parent) {
            if (impostor.physicsBody) {
                this.removePhysicsBody(impostor);
                //TODO is that needed?
                impostor.forceUpdate();
            }
            return;
        }
        //should a new body be created for this impostor?
        if (impostor.isBodyInitRequired()) {
            const shape = this._createShape(impostor);
            if (!shape) {
                (0, $kVtWi.Logger).Warn("It was not possible to create a physics body for this object.");
                return;
            }
            //unregister events if body is being changed
            const oldBody = impostor.physicsBody;
            if (oldBody) this.removePhysicsBody(impostor);
            //create the body and material
            const material = this._addMaterial("mat-" + impostor.uniqueId, impostor.getParam("friction"), impostor.getParam("restitution"));
            const bodyCreationObject = {
                mass: impostor.getParam("mass"),
                material: material
            };
            // A simple extend, in case native options were used.
            const nativeOptions = impostor.getParam("nativeOptions");
            for(const key in nativeOptions)if (Object.prototype.hasOwnProperty.call(nativeOptions, key)) bodyCreationObject[key] = nativeOptions[key];
            impostor.physicsBody = new this.BJSCANNON.Body(bodyCreationObject);
            impostor.physicsBody.addEventListener("collide", impostor.onCollide);
            this.world.addEventListener("preStep", impostor.beforeStep);
            this.world.addEventListener("postStep", impostor.afterStep);
            impostor.physicsBody.addShape(shape);
            if (typeof this.world.addBody === "function") this.world.addBody(impostor.physicsBody);
            else this.world.add(impostor.physicsBody);
            //try to keep the body moving in the right direction by taking old properties.
            //Should be tested!
            if (oldBody) [
                "force",
                "torque",
                "velocity",
                "angularVelocity"
            ].forEach(function(param) {
                const vec = oldBody[param];
                impostor.physicsBody[param].set(vec.x, vec.y, vec.z);
            });
            this._processChildMeshes(impostor);
        }
        //now update the body's transformation
        this._updatePhysicsBodyTransformation(impostor);
    }
    _processChildMeshes(mainImpostor) {
        const meshChildren = mainImpostor.object.getChildMeshes ? mainImpostor.object.getChildMeshes(true) : [];
        const mainRotation = mainImpostor.object.rotationQuaternion;
        if (mainRotation) mainRotation.conjugateToRef(this._tmpQuaternion);
        else this._tmpQuaternion.set(0, 0, 0, 1);
        if (meshChildren.length) {
            const processMesh = (mesh)=>{
                if (!mesh.rotationQuaternion) return;
                const childImpostor = mesh.getPhysicsImpostor();
                if (childImpostor) {
                    const parent = childImpostor.parent;
                    if (parent !== mainImpostor && mesh.parent) {
                        const pPosition = mesh.getAbsolutePosition().subtract(mesh.parent.getAbsolutePosition());
                        const q = mesh.rotationQuaternion.multiply(this._tmpQuaternion);
                        if (childImpostor.physicsBody) {
                            this.removePhysicsBody(childImpostor);
                            childImpostor.physicsBody = null;
                        }
                        childImpostor.parent = mainImpostor;
                        childImpostor.resetUpdateFlags();
                        mainImpostor.physicsBody.addShape(this._createShape(childImpostor), new this.BJSCANNON.Vec3(pPosition.x, pPosition.y, pPosition.z), new this.BJSCANNON.Quaternion(q.x, q.y, q.z, q.w));
                        //Add the mass of the children.
                        mainImpostor.physicsBody.mass += childImpostor.getParam("mass");
                    }
                }
                mesh.getChildMeshes(true).filter((m)=>!!m.physicsImpostor).forEach(processMesh);
            };
            meshChildren.filter((m)=>!!m.physicsImpostor).forEach(processMesh);
        }
    }
    removePhysicsBody(impostor) {
        impostor.physicsBody.removeEventListener("collide", impostor.onCollide);
        this.world.removeEventListener("preStep", impostor.beforeStep);
        this.world.removeEventListener("postStep", impostor.afterStep);
        // Only remove the physics body after the physics step to avoid disrupting cannon's internal state
        if (this._physicsBodiesToRemoveAfterStep.indexOf(impostor.physicsBody) === -1) this._physicsBodiesToRemoveAfterStep.push(impostor.physicsBody);
    }
    generateJoint(impostorJoint) {
        const mainBody = impostorJoint.mainImpostor.physicsBody;
        const connectedBody = impostorJoint.connectedImpostor.physicsBody;
        if (!mainBody || !connectedBody) return;
        let constraint;
        const jointData = impostorJoint.joint.jointData;
        //TODO - https://github.com/schteppe/this.BJSCANNON.js/blob/gh-pages/demos/collisionFilter.html
        const constraintData = {
            pivotA: jointData.mainPivot ? new this.BJSCANNON.Vec3().set(jointData.mainPivot.x, jointData.mainPivot.y, jointData.mainPivot.z) : null,
            pivotB: jointData.connectedPivot ? new this.BJSCANNON.Vec3().set(jointData.connectedPivot.x, jointData.connectedPivot.y, jointData.connectedPivot.z) : null,
            axisA: jointData.mainAxis ? new this.BJSCANNON.Vec3().set(jointData.mainAxis.x, jointData.mainAxis.y, jointData.mainAxis.z) : null,
            axisB: jointData.connectedAxis ? new this.BJSCANNON.Vec3().set(jointData.connectedAxis.x, jointData.connectedAxis.y, jointData.connectedAxis.z) : null,
            maxForce: jointData.nativeParams.maxForce,
            collideConnected: !!jointData.collision
        };
        switch(impostorJoint.joint.type){
            case (0, $kGTHw.PhysicsJoint).HingeJoint:
            case (0, $kGTHw.PhysicsJoint).Hinge2Joint:
                constraint = new this.BJSCANNON.HingeConstraint(mainBody, connectedBody, constraintData);
                break;
            case (0, $kGTHw.PhysicsJoint).DistanceJoint:
                constraint = new this.BJSCANNON.DistanceConstraint(mainBody, connectedBody, jointData.maxDistance || 2);
                break;
            case (0, $kGTHw.PhysicsJoint).SpringJoint:
                {
                    const springData = jointData;
                    constraint = new this.BJSCANNON.Spring(mainBody, connectedBody, {
                        restLength: springData.length,
                        stiffness: springData.stiffness,
                        damping: springData.damping,
                        localAnchorA: constraintData.pivotA,
                        localAnchorB: constraintData.pivotB
                    });
                    break;
                }
            case (0, $kGTHw.PhysicsJoint).LockJoint:
                constraint = new this.BJSCANNON.LockConstraint(mainBody, connectedBody, constraintData);
                break;
            case (0, $kGTHw.PhysicsJoint).PointToPointJoint:
            case (0, $kGTHw.PhysicsJoint).BallAndSocketJoint:
            default:
                constraint = new this.BJSCANNON.PointToPointConstraint(mainBody, constraintData.pivotA, connectedBody, constraintData.pivotB, constraintData.maxForce);
                break;
        }
        //set the collideConnected flag after the creation, since DistanceJoint ignores it.
        constraint.collideConnected = !!jointData.collision;
        impostorJoint.joint.physicsJoint = constraint;
        //don't add spring as constraint, as it is not one.
        if (impostorJoint.joint.type !== (0, $kGTHw.PhysicsJoint).SpringJoint) this.world.addConstraint(constraint);
        else {
            impostorJoint.joint.jointData.forceApplicationCallback = impostorJoint.joint.jointData.forceApplicationCallback || function() {
                constraint.applyForce();
            };
            impostorJoint.mainImpostor.registerAfterPhysicsStep(impostorJoint.joint.jointData.forceApplicationCallback);
        }
    }
    removeJoint(impostorJoint) {
        if (impostorJoint.joint.type !== (0, $kGTHw.PhysicsJoint).SpringJoint) this.world.removeConstraint(impostorJoint.joint.physicsJoint);
        else impostorJoint.mainImpostor.unregisterAfterPhysicsStep(impostorJoint.joint.jointData.forceApplicationCallback);
    }
    _addMaterial(name, friction, restitution) {
        let index;
        let mat;
        for(index = 0; index < this._physicsMaterials.length; index++){
            mat = this._physicsMaterials[index];
            if (mat.friction === friction && mat.restitution === restitution) return mat;
        }
        const currentMat = new this.BJSCANNON.Material(name);
        currentMat.friction = friction;
        currentMat.restitution = restitution;
        this._physicsMaterials.push(currentMat);
        return currentMat;
    }
    _checkWithEpsilon(value) {
        return value < (0, $53VPf.Epsilon) ? (0, $53VPf.Epsilon) : value;
    }
    _createShape(impostor) {
        const object = impostor.object;
        let returnValue;
        const impostorExtents = impostor.getObjectExtents();
        switch(impostor.type){
            case (0, $iz3U8.PhysicsImpostor).SphereImpostor:
                {
                    const radiusX = impostorExtents.x;
                    const radiusY = impostorExtents.y;
                    const radiusZ = impostorExtents.z;
                    returnValue = new this.BJSCANNON.Sphere(Math.max(this._checkWithEpsilon(radiusX), this._checkWithEpsilon(radiusY), this._checkWithEpsilon(radiusZ)) / 2);
                    break;
                }
            //TMP also for cylinder - TODO Cannon supports cylinder natively.
            case (0, $iz3U8.PhysicsImpostor).CylinderImpostor:
                {
                    let nativeParams = impostor.getParam("nativeOptions");
                    if (!nativeParams) nativeParams = {};
                    const radiusTop = nativeParams.radiusTop !== undefined ? nativeParams.radiusTop : this._checkWithEpsilon(impostorExtents.x) / 2;
                    const radiusBottom = nativeParams.radiusBottom !== undefined ? nativeParams.radiusBottom : this._checkWithEpsilon(impostorExtents.x) / 2;
                    const height = nativeParams.height !== undefined ? nativeParams.height : this._checkWithEpsilon(impostorExtents.y);
                    const numSegments = nativeParams.numSegments !== undefined ? nativeParams.numSegments : 16;
                    returnValue = new this.BJSCANNON.Cylinder(radiusTop, radiusBottom, height, numSegments);
                    // Rotate 90 degrees as this shape is horizontal in cannon
                    const quat = new this.BJSCANNON.Quaternion();
                    quat.setFromAxisAngle(new this.BJSCANNON.Vec3(1, 0, 0), -Math.PI / 2);
                    const translation = new this.BJSCANNON.Vec3(0, 0, 0);
                    returnValue.transformAllPoints(translation, quat);
                    break;
                }
            case (0, $iz3U8.PhysicsImpostor).BoxImpostor:
                {
                    const box = impostorExtents.scale(0.5);
                    returnValue = new this.BJSCANNON.Box(new this.BJSCANNON.Vec3(this._checkWithEpsilon(box.x), this._checkWithEpsilon(box.y), this._checkWithEpsilon(box.z)));
                    break;
                }
            case (0, $iz3U8.PhysicsImpostor).PlaneImpostor:
                (0, $kVtWi.Logger).Warn("Attention, PlaneImposter might not behave as you expect. Consider using BoxImposter instead");
                returnValue = new this.BJSCANNON.Plane();
                break;
            case (0, $iz3U8.PhysicsImpostor).MeshImpostor:
                {
                    // should transform the vertex data to world coordinates!!
                    const rawVerts = object.getVerticesData ? object.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind) : [];
                    const rawFaces = object.getIndices ? object.getIndices() : [];
                    if (!rawVerts) {
                        (0, $kVtWi.Logger).Warn("Tried to create a MeshImpostor for an object without vertices. This will fail.");
                        return;
                    }
                    // get only scale! so the object could transform correctly.
                    const oldPosition = object.position.clone();
                    const oldRotation = object.rotation && object.rotation.clone();
                    const oldQuaternion = object.rotationQuaternion && object.rotationQuaternion.clone();
                    object.position.copyFromFloats(0, 0, 0);
                    object.rotation && object.rotation.copyFromFloats(0, 0, 0);
                    object.rotationQuaternion && object.rotationQuaternion.copyFrom(impostor.getParentsRotation());
                    object.rotationQuaternion && object.parent && object.rotationQuaternion.conjugateInPlace();
                    const transform = object.computeWorldMatrix(true);
                    // convert rawVerts to object space
                    const transformedVertices = [];
                    let index;
                    for(index = 0; index < rawVerts.length; index += 3)(0, $ha1VO.Vector3).TransformCoordinates((0, $ha1VO.Vector3).FromArray(rawVerts, index), transform).toArray(transformedVertices, index);
                    (0, $kVtWi.Logger).Warn("MeshImpostor only collides against spheres.");
                    returnValue = new this.BJSCANNON.Trimesh(transformedVertices, rawFaces);
                    //now set back the transformation!
                    object.position.copyFrom(oldPosition);
                    oldRotation && object.rotation && object.rotation.copyFrom(oldRotation);
                    oldQuaternion && object.rotationQuaternion && object.rotationQuaternion.copyFrom(oldQuaternion);
                    break;
                }
            case (0, $iz3U8.PhysicsImpostor).HeightmapImpostor:
                {
                    const oldPosition2 = object.position.clone();
                    const oldRotation2 = object.rotation && object.rotation.clone();
                    const oldQuaternion2 = object.rotationQuaternion && object.rotationQuaternion.clone();
                    object.position.copyFromFloats(0, 0, 0);
                    object.rotation && object.rotation.copyFromFloats(0, 0, 0);
                    object.rotationQuaternion && object.rotationQuaternion.copyFrom(impostor.getParentsRotation());
                    object.rotationQuaternion && object.parent && object.rotationQuaternion.conjugateInPlace();
                    object.rotationQuaternion && object.rotationQuaternion.multiplyInPlace(this._minus90X);
                    returnValue = this._createHeightmap(object);
                    object.position.copyFrom(oldPosition2);
                    oldRotation2 && object.rotation && object.rotation.copyFrom(oldRotation2);
                    oldQuaternion2 && object.rotationQuaternion && object.rotationQuaternion.copyFrom(oldQuaternion2);
                    object.computeWorldMatrix(true);
                    break;
                }
            case (0, $iz3U8.PhysicsImpostor).ParticleImpostor:
                returnValue = new this.BJSCANNON.Particle();
                break;
            case (0, $iz3U8.PhysicsImpostor).NoImpostor:
                returnValue = new this.BJSCANNON.Box(new this.BJSCANNON.Vec3(0, 0, 0));
                break;
        }
        return returnValue;
    }
    _createHeightmap(object, pointDepth) {
        let pos = object.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        const transform = object.computeWorldMatrix(true);
        // convert rawVerts to object space
        const transformedVertices = [];
        let index;
        for(index = 0; index < pos.length; index += 3)(0, $ha1VO.Vector3).TransformCoordinates((0, $ha1VO.Vector3).FromArray(pos, index), transform).toArray(transformedVertices, index);
        pos = transformedVertices;
        const matrix = new Array();
        //For now pointDepth will not be used and will be automatically calculated.
        //Future reference - try and find the best place to add a reference to the pointDepth variable.
        const arraySize = pointDepth || ~~(Math.sqrt(pos.length / 3) - 1);
        const boundingInfo = object.getBoundingInfo();
        const dim = Math.min(boundingInfo.boundingBox.extendSizeWorld.x, boundingInfo.boundingBox.extendSizeWorld.y);
        const minY = boundingInfo.boundingBox.extendSizeWorld.z;
        const elementSize = dim * 2 / arraySize;
        for(let i = 0; i < pos.length; i = i + 3){
            const x = Math.round(pos[i + 0] / elementSize + arraySize / 2);
            const z = Math.round((pos[i + 1] / elementSize - arraySize / 2) * -1);
            const y = -pos[i + 2] + minY;
            if (!matrix[x]) matrix[x] = [];
            if (!matrix[x][z]) matrix[x][z] = y;
            matrix[x][z] = Math.max(y, matrix[x][z]);
        }
        for(let x = 0; x <= arraySize; ++x){
            if (!matrix[x]) {
                let loc = 1;
                while(!matrix[(x + loc) % arraySize])loc++;
                matrix[x] = matrix[(x + loc) % arraySize].slice();
            //console.log("missing x", x);
            }
            for(let z = 0; z <= arraySize; ++z)if (!matrix[x][z]) {
                let loc = 1;
                let newValue;
                while(newValue === undefined)newValue = matrix[x][(z + loc++) % arraySize];
                matrix[x][z] = newValue;
            }
        }
        const shape = new this.BJSCANNON.Heightfield(matrix, {
            elementSize: elementSize
        });
        //For future reference, needed for body transformation
        shape.minY = minY;
        return shape;
    }
    _updatePhysicsBodyTransformation(impostor) {
        const object = impostor.object;
        //make sure it is updated...
        object.computeWorldMatrix && object.computeWorldMatrix(true);
        if (!object.getBoundingInfo()) return;
        const center = impostor.getObjectCenter();
        //m.getAbsolutePosition().subtract(m.getBoundingInfo().boundingBox.centerWorld)
        // The delta between the mesh position and the mesh bounding box center
        this._tmpDeltaPosition.copyFrom(object.getAbsolutePivotPoint().subtract(center));
        this._tmpDeltaPosition.divideInPlace(impostor.object.scaling);
        this._tmpPosition.copyFrom(center);
        let quaternion = object.rotationQuaternion;
        if (!quaternion) return;
        //is shape is a plane or a heightmap, it must be rotated 90 degs in the X axis.
        //ideally these would be rotated at time of creation like cylinder but they dont extend ConvexPolyhedron
        if (impostor.type === (0, $iz3U8.PhysicsImpostor).PlaneImpostor || impostor.type === (0, $iz3U8.PhysicsImpostor).HeightmapImpostor) {
            //-90 DEG in X, precalculated
            quaternion = quaternion.multiply(this._minus90X);
            //Invert! (Precalculated, 90 deg in X)
            //No need to clone. this will never change.
            impostor.setDeltaRotation(this._plus90X);
        }
        //If it is a heightfield, if should be centered.
        if (impostor.type === (0, $iz3U8.PhysicsImpostor).HeightmapImpostor) {
            const mesh = object;
            let boundingInfo = mesh.getBoundingInfo();
            //calculate the correct body position:
            const rotationQuaternion = mesh.rotationQuaternion;
            mesh.rotationQuaternion = this._tmpUnityRotation;
            mesh.computeWorldMatrix(true);
            //get original center with no rotation
            const c = center.clone();
            let oldPivot = mesh.getPivotMatrix();
            if (oldPivot) // create a copy the pivot Matrix as it is modified in place
            oldPivot = oldPivot.clone();
            else oldPivot = (0, $ha1VO.Matrix).Identity();
            //calculate the new center using a pivot (since this.BJSCANNON.js doesn't center height maps)
            const p = (0, $ha1VO.Matrix).Translation(boundingInfo.boundingBox.extendSizeWorld.x, 0, -boundingInfo.boundingBox.extendSizeWorld.z);
            mesh.setPreTransformMatrix(p);
            mesh.computeWorldMatrix(true);
            // force bounding box recomputation
            boundingInfo = mesh.getBoundingInfo();
            //calculate the translation
            const translation = boundingInfo.boundingBox.centerWorld.subtract(center).subtract(mesh.position).negate();
            this._tmpPosition.copyFromFloats(translation.x, translation.y - boundingInfo.boundingBox.extendSizeWorld.y, translation.z);
            //add it inverted to the delta
            this._tmpDeltaPosition.copyFrom(boundingInfo.boundingBox.centerWorld.subtract(c));
            this._tmpDeltaPosition.y += boundingInfo.boundingBox.extendSizeWorld.y;
            //rotation is back
            mesh.rotationQuaternion = rotationQuaternion;
            mesh.setPreTransformMatrix(oldPivot);
            mesh.computeWorldMatrix(true);
        } else if (impostor.type === (0, $iz3U8.PhysicsImpostor).MeshImpostor) this._tmpDeltaPosition.copyFromFloats(0, 0, 0);
        impostor.setDeltaPosition(this._tmpDeltaPosition);
        //Now update the impostor object
        impostor.physicsBody.position.set(this._tmpPosition.x, this._tmpPosition.y, this._tmpPosition.z);
        impostor.physicsBody.quaternion.set(quaternion.x, quaternion.y, quaternion.z, quaternion.w);
    }
    setTransformationFromPhysicsBody(impostor) {
        impostor.object.position.set(impostor.physicsBody.position.x, impostor.physicsBody.position.y, impostor.physicsBody.position.z);
        if (impostor.object.rotationQuaternion) {
            const q = impostor.physicsBody.quaternion;
            impostor.object.rotationQuaternion.set(q.x, q.y, q.z, q.w);
        }
    }
    setPhysicsBodyTransformation(impostor, newPosition, newRotation) {
        impostor.physicsBody.position.set(newPosition.x, newPosition.y, newPosition.z);
        impostor.physicsBody.quaternion.set(newRotation.x, newRotation.y, newRotation.z, newRotation.w);
    }
    isSupported() {
        return this.BJSCANNON !== undefined;
    }
    setLinearVelocity(impostor, velocity) {
        impostor.physicsBody.velocity.set(velocity.x, velocity.y, velocity.z);
    }
    setAngularVelocity(impostor, velocity) {
        impostor.physicsBody.angularVelocity.set(velocity.x, velocity.y, velocity.z);
    }
    getLinearVelocity(impostor) {
        const v = impostor.physicsBody.velocity;
        if (!v) return null;
        return new (0, $ha1VO.Vector3)(v.x, v.y, v.z);
    }
    getAngularVelocity(impostor) {
        const v = impostor.physicsBody.angularVelocity;
        if (!v) return null;
        return new (0, $ha1VO.Vector3)(v.x, v.y, v.z);
    }
    setBodyMass(impostor, mass) {
        impostor.physicsBody.mass = mass;
        impostor.physicsBody.updateMassProperties();
    }
    getBodyMass(impostor) {
        return impostor.physicsBody.mass;
    }
    getBodyFriction(impostor) {
        return impostor.physicsBody.material.friction;
    }
    setBodyFriction(impostor, friction) {
        impostor.physicsBody.material.friction = friction;
    }
    getBodyRestitution(impostor) {
        return impostor.physicsBody.material.restitution;
    }
    setBodyRestitution(impostor, restitution) {
        impostor.physicsBody.material.restitution = restitution;
    }
    sleepBody(impostor) {
        impostor.physicsBody.sleep();
    }
    wakeUpBody(impostor) {
        impostor.physicsBody.wakeUp();
    }
    updateDistanceJoint(joint, maxDistance) {
        joint.physicsJoint.distance = maxDistance;
    }
    setMotor(joint, speed, maxForce, motorIndex) {
        if (!motorIndex) {
            joint.physicsJoint.enableMotor();
            joint.physicsJoint.setMotorSpeed(speed);
            if (maxForce) this.setLimit(joint, maxForce);
        }
    }
    setLimit(joint, minForce, maxForce) {
        joint.physicsJoint.motorEquation.maxForce = maxForce;
        joint.physicsJoint.motorEquation.minForce = minForce === void 0 ? -minForce : minForce;
    }
    syncMeshWithImpostor(mesh, impostor) {
        const body = impostor.physicsBody;
        mesh.position.x = body.position.x;
        mesh.position.y = body.position.y;
        mesh.position.z = body.position.z;
        if (mesh.rotationQuaternion) {
            mesh.rotationQuaternion.x = body.quaternion.x;
            mesh.rotationQuaternion.y = body.quaternion.y;
            mesh.rotationQuaternion.z = body.quaternion.z;
            mesh.rotationQuaternion.w = body.quaternion.w;
        }
    }
    getRadius(impostor) {
        const shape = impostor.physicsBody.shapes[0];
        return shape.boundingSphereRadius;
    }
    getBoxSizeToRef(impostor, result) {
        const shape = impostor.physicsBody.shapes[0];
        result.x = shape.halfExtents.x * 2;
        result.y = shape.halfExtents.y * 2;
        result.z = shape.halfExtents.z * 2;
    }
    dispose() {}
    _extendNamespace() {
        //this will force cannon to execute at least one step when using interpolation
        const step_tmp1 = new this.BJSCANNON.Vec3();
        const engine = this.BJSCANNON;
        this.BJSCANNON.World.prototype.step = function(dt, timeSinceLastCalled, maxSubSteps) {
            maxSubSteps = maxSubSteps || 10;
            timeSinceLastCalled = timeSinceLastCalled || 0;
            if (timeSinceLastCalled === 0) {
                this.internalStep(dt);
                this.time += dt;
            } else {
                let internalSteps = Math.floor((this.time + timeSinceLastCalled) / dt) - Math.floor(this.time / dt);
                internalSteps = Math.min(internalSteps, maxSubSteps) || 1;
                const t0 = performance.now();
                for(let i = 0; i !== internalSteps; i++){
                    this.internalStep(dt);
                    if (performance.now() - t0 > dt * 1000) break;
                }
                this.time += timeSinceLastCalled;
                const h = this.time % dt;
                const h_div_dt = h / dt;
                const interpvelo = step_tmp1;
                const bodies = this.bodies;
                for(let j = 0; j !== bodies.length; j++){
                    const b = bodies[j];
                    if (b.type !== engine.Body.STATIC && b.sleepState !== engine.Body.SLEEPING) {
                        b.position.vsub(b.previousPosition, interpvelo);
                        interpvelo.scale(h_div_dt, interpvelo);
                        b.position.vadd(interpvelo, b.interpolatedPosition);
                    } else {
                        b.interpolatedPosition.set(b.position.x, b.position.y, b.position.z);
                        b.interpolatedQuaternion.set(b.quaternion.x, b.quaternion.y, b.quaternion.z, b.quaternion.w);
                    }
                }
            }
        };
    }
    /**
     * Does a raycast in the physics world
     * @param from when should the ray start?
     * @param to when should the ray end?
     * @returns PhysicsRaycastResult
     */ raycast(from, to) {
        this._raycastResult.reset(from, to);
        this.raycastToRef(from, to, this._raycastResult);
        return this._raycastResult;
    }
    /**
     * Does a raycast in the physics world
     * @param from when should the ray start?
     * @param to when should the ray end?
     * @param result resulting PhysicsRaycastResult
     */ raycastToRef(from, to, result) {
        this._cannonRaycastResult.reset();
        this.world.raycastClosest(from, to, {}, this._cannonRaycastResult);
        result.reset(from, to);
        if (this._cannonRaycastResult.hasHit) {
            // TODO: do we also want to get the body it hit?
            result.setHitData({
                x: this._cannonRaycastResult.hitNormalWorld.x,
                y: this._cannonRaycastResult.hitNormalWorld.y,
                z: this._cannonRaycastResult.hitNormalWorld.z
            }, {
                x: this._cannonRaycastResult.hitPointWorld.x,
                y: this._cannonRaycastResult.hitPointWorld.y,
                z: this._cannonRaycastResult.hitPointWorld.z
            });
            result.setHitDistance(this._cannonRaycastResult.distance);
        }
    }
}
(0, $4qQ0v.PhysicsEngine).DefaultPluginFactory = ()=>{
    return new $6ccc019e222cb599$export$2873373418a42505();
};

});
parcelRegister("iz1eP", function(module, exports) {

$parcel$export(module.exports, "PhysicsRaycastResult", () => $d83c74bf94e0bfb5$export$fe863fcbc118f621);

var $ha1VO = parcelRequire("ha1VO");

var $jbAke = parcelRequire("jbAke");
class $d83c74bf94e0bfb5$export$fe863fcbc118f621 extends (0, $jbAke.CastingResult) {
    constructor(){
        super(...arguments);
        this._hitDistance = 0;
        this._rayFromWorld = (0, $ha1VO.Vector3).Zero();
        this._rayToWorld = (0, $ha1VO.Vector3).Zero();
    }
    /**
     * Gets the distance from the hit
     */ get hitDistance() {
        return this._hitDistance;
    }
    /**
     * Gets the hit normal/direction in the world
     */ get hitNormalWorld() {
        return this._hitNormal;
    }
    /**
     * Gets the hit point in the world
     */ get hitPointWorld() {
        return this._hitPoint;
    }
    /**
     * Gets the ray "start point" of the ray in the world
     */ get rayFromWorld() {
        return this._rayFromWorld;
    }
    /**
     * Gets the ray "end point" of the ray in the world
     */ get rayToWorld() {
        return this._rayToWorld;
    }
    /**
     * Sets the distance from the start point to the hit point
     * @param distance defines the distance to set
     */ setHitDistance(distance) {
        this._hitDistance = distance;
    }
    /**
     * Calculates the distance manually
     */ calculateHitDistance() {
        this._hitDistance = (0, $ha1VO.Vector3).Distance(this._rayFromWorld, this._hitPoint);
    }
    /**
     * Resets all the values to default
     * @param from The from point on world space
     * @param to The to point on world space
     */ reset(from = (0, $ha1VO.Vector3).Zero(), to = (0, $ha1VO.Vector3).Zero()) {
        super.reset();
        this._rayFromWorld.copyFrom(from);
        this._rayToWorld.copyFrom(to);
        this._hitDistance = 0;
    }
}

});
parcelRegister("jbAke", function(module, exports) {

$parcel$export(module.exports, "CastingResult", () => $df7b38db3f09576f$export$49565cc92c2ea26f);

var $ha1VO = parcelRequire("ha1VO");
class $df7b38db3f09576f$export$49565cc92c2ea26f {
    constructor(){
        this._hasHit = false;
        this._hitNormal = (0, $ha1VO.Vector3).Zero();
        this._hitPoint = (0, $ha1VO.Vector3).Zero();
        this._triangleIndex = -1;
    }
    /**
     * Gets the hit point.
     */ get hitPoint() {
        return this._hitPoint;
    }
    /**
     * Gets the hit normal.
     */ get hitNormal() {
        return this._hitNormal;
    }
    /**
     * Gets if there was a hit
     */ get hasHit() {
        return this._hasHit;
    }
    /*
     * The index of the original triangle which was hit. Will be -1 if contact point is not on a mesh shape
     */ get triangleIndex() {
        return this._triangleIndex;
    }
    /**
     * Sets the hit data
     * @param hitNormal defines the normal in world space
     * @param hitPoint defines the point in world space
     * @param triangleIndex defines the index of the triangle in case of mesh shape
     */ setHitData(hitNormal, hitPoint, triangleIndex) {
        this._hasHit = true;
        this._hitNormal.set(hitNormal.x, hitNormal.y, hitNormal.z);
        this._hitPoint.set(hitPoint.x, hitPoint.y, hitPoint.z);
        this._triangleIndex = triangleIndex ?? -1;
    }
    /**
     * Resets all the values to default
     */ reset() {
        this._hasHit = false;
        this._hitNormal.setAll(0);
        this._hitPoint.setAll(0);
        this._triangleIndex = -1;
        this.body = undefined;
        this.bodyIndex = undefined;
        this.shape = undefined;
    }
}

});


parcelRegister("4qQ0v", function(module, exports) {

$parcel$export(module.exports, "PhysicsEngine", () => $33a1eea5c638d1fc$export$69b1b1c72d4bbb9d);

var $ha1VO = parcelRequire("ha1VO");

var $dUFYy = parcelRequire("dUFYy");
class $33a1eea5c638d1fc$export$69b1b1c72d4bbb9d {
    /**
     *
     * @returns version
     */ getPluginVersion() {
        return this._physicsPlugin.getPluginVersion();
    }
    /**
     * @virtual
     * Factory used to create the default physics plugin.
     * @returns The default physics plugin
     */ static DefaultPluginFactory() {
        throw (0, $dUFYy._WarnImport)("CannonJSPlugin");
    }
    /**
     * Creates a new Physics Engine
     * @param gravity defines the gravity vector used by the simulation
     * @param _physicsPlugin defines the plugin to use (CannonJS by default)
     */ constructor(gravity, _physicsPlugin = $33a1eea5c638d1fc$export$69b1b1c72d4bbb9d.DefaultPluginFactory()){
        this._physicsPlugin = _physicsPlugin;
        /**
         * Global value used to control the smallest number supported by the simulation
         */ this._impostors = [];
        this._joints = [];
        this._subTimeStep = 0;
        this._uniqueIdCounter = 0;
        if (!this._physicsPlugin.isSupported()) throw new Error("Physics Engine " + this._physicsPlugin.name + " cannot be found. " + "Please make sure it is included.");
        gravity = gravity || new (0, $ha1VO.Vector3)(0, -9.807, 0);
        this.setGravity(gravity);
        this.setTimeStep();
    }
    /**
     * Sets the gravity vector used by the simulation
     * @param gravity defines the gravity vector to use
     */ setGravity(gravity) {
        this.gravity = gravity;
        this._physicsPlugin.setGravity(this.gravity);
    }
    /**
     * Set the time step of the physics engine.
     * Default is 1/60.
     * To slow it down, enter 1/600 for example.
     * To speed it up, 1/30
     * @param newTimeStep defines the new timestep to apply to this world.
     */ setTimeStep(newTimeStep = 1 / 60) {
        this._physicsPlugin.setTimeStep(newTimeStep);
    }
    /**
     * Get the time step of the physics engine.
     * @returns the current time step
     */ getTimeStep() {
        return this._physicsPlugin.getTimeStep();
    }
    /**
     * Set the sub time step of the physics engine.
     * Default is 0 meaning there is no sub steps
     * To increase physics resolution precision, set a small value (like 1 ms)
     * @param subTimeStep defines the new sub timestep used for physics resolution.
     */ setSubTimeStep(subTimeStep = 0) {
        this._subTimeStep = subTimeStep;
    }
    /**
     * Get the sub time step of the physics engine.
     * @returns the current sub time step
     */ getSubTimeStep() {
        return this._subTimeStep;
    }
    /**
     * Release all resources
     */ dispose() {
        this._impostors.forEach(function(impostor) {
            impostor.dispose();
        });
        this._physicsPlugin.dispose();
    }
    /**
     * Gets the name of the current physics plugin
     * @returns the name of the plugin
     */ getPhysicsPluginName() {
        return this._physicsPlugin.name;
    }
    /**
     * Adding a new impostor for the impostor tracking.
     * This will be done by the impostor itself.
     * @param impostor the impostor to add
     */ addImpostor(impostor) {
        this._impostors.push(impostor);
        impostor.uniqueId = this._uniqueIdCounter++;
        //if no parent, generate the body
        if (!impostor.parent) this._physicsPlugin.generatePhysicsBody(impostor);
    }
    /**
     * Remove an impostor from the engine.
     * This impostor and its mesh will not longer be updated by the physics engine.
     * @param impostor the impostor to remove
     */ removeImpostor(impostor) {
        const index = this._impostors.indexOf(impostor);
        if (index > -1) {
            const removed = this._impostors.splice(index, 1);
            //Is it needed?
            if (removed.length) this.getPhysicsPlugin().removePhysicsBody(impostor);
        }
    }
    /**
     * Add a joint to the physics engine
     * @param mainImpostor defines the main impostor to which the joint is added.
     * @param connectedImpostor defines the impostor that is connected to the main impostor using this joint
     * @param joint defines the joint that will connect both impostors.
     */ addJoint(mainImpostor, connectedImpostor, joint) {
        const impostorJoint = {
            mainImpostor: mainImpostor,
            connectedImpostor: connectedImpostor,
            joint: joint
        };
        joint.physicsPlugin = this._physicsPlugin;
        this._joints.push(impostorJoint);
        this._physicsPlugin.generateJoint(impostorJoint);
    }
    /**
     * Removes a joint from the simulation
     * @param mainImpostor defines the impostor used with the joint
     * @param connectedImpostor defines the other impostor connected to the main one by the joint
     * @param joint defines the joint to remove
     */ removeJoint(mainImpostor, connectedImpostor, joint) {
        const matchingJoints = this._joints.filter(function(impostorJoint) {
            return impostorJoint.connectedImpostor === connectedImpostor && impostorJoint.joint === joint && impostorJoint.mainImpostor === mainImpostor;
        });
        if (matchingJoints.length) this._physicsPlugin.removeJoint(matchingJoints[0]);
    }
    /**
     * Called by the scene. No need to call it.
     * @param delta defines the timespan between frames
     */ _step(delta) {
        //check if any mesh has no body / requires an update
        this._impostors.forEach((impostor)=>{
            if (impostor.isBodyInitRequired()) this._physicsPlugin.generatePhysicsBody(impostor);
        });
        if (delta > 0.1) delta = 0.1;
        else if (delta <= 0) delta = 1.0 / 60.0;
        this._physicsPlugin.executeStep(delta, this._impostors);
    }
    /**
     * Gets the current plugin used to run the simulation
     * @returns current plugin
     */ getPhysicsPlugin() {
        return this._physicsPlugin;
    }
    /**
     * Gets the list of physic impostors
     * @returns an array of PhysicsImpostor
     */ getImpostors() {
        return this._impostors;
    }
    /**
     * Gets the impostor for a physics enabled object
     * @param object defines the object impersonated by the impostor
     * @returns the PhysicsImpostor or null if not found
     */ getImpostorForPhysicsObject(object) {
        for(let i = 0; i < this._impostors.length; ++i){
            if (this._impostors[i].object === object) return this._impostors[i];
        }
        return null;
    }
    /**
     * Gets the impostor for a physics body object
     * @param body defines physics body used by the impostor
     * @returns the PhysicsImpostor or null if not found
     */ getImpostorWithPhysicsBody(body) {
        for(let i = 0; i < this._impostors.length; ++i){
            if (this._impostors[i].physicsBody === body) return this._impostors[i];
        }
        return null;
    }
    /**
     * Does a raycast in the physics world
     * @param from when should the ray start?
     * @param to when should the ray end?
     * @returns PhysicsRaycastResult
     */ raycast(from, to) {
        return this._physicsPlugin.raycast(from, to);
    }
    /**
     * Does a raycast in the physics world
     * @param from when should the ray start?
     * @param to when should the ray end?
     * @param result resulting PhysicsRaycastResult
     * @returns true if the ray hits an impostor, else false
     */ raycastToRef(from, to, result) {
        return this._physicsPlugin.raycastToRef(from, to, result);
    }
}

});


parcelRegister("9o1yl", function(module, exports) {

$parcel$export(module.exports, "OimoJSPlugin", () => $6d578f51be286070$export$43486276e9bff77a);

var $iz3U8 = parcelRequire("iz3U8");

var $kGTHw = parcelRequire("kGTHw");

var $ha1VO = parcelRequire("ha1VO");

var $kVtWi = parcelRequire("kVtWi");

var $iz1eP = parcelRequire("iz1eP");

var $53VPf = parcelRequire("53VPf");
class $6d578f51be286070$export$43486276e9bff77a {
    constructor(_useDeltaForWorldStep = true, iterations, oimoInjection = OIMO){
        this._useDeltaForWorldStep = _useDeltaForWorldStep;
        this.name = "OimoJSPlugin";
        this._fixedTimeStep = 1 / 60;
        this._tmpImpostorsArray = [];
        this._tmpPositionVector = (0, $ha1VO.Vector3).Zero();
        this.BJSOIMO = oimoInjection;
        this.world = new this.BJSOIMO.World({
            iterations: iterations
        });
        this.world.clear();
        this._raycastResult = new (0, $iz1eP.PhysicsRaycastResult)();
    }
    /**
     *
     * @returns plugin version
     */ getPluginVersion() {
        return 1;
    }
    setGravity(gravity) {
        this.world.gravity.set(gravity.x, gravity.y, gravity.z);
    }
    setTimeStep(timeStep) {
        this.world.timeStep = timeStep;
    }
    getTimeStep() {
        return this.world.timeStep;
    }
    executeStep(delta, impostors) {
        impostors.forEach(function(impostor) {
            impostor.beforeStep();
        });
        this.world.timeStep = this._useDeltaForWorldStep ? delta : this._fixedTimeStep;
        this.world.step();
        impostors.forEach((impostor)=>{
            impostor.afterStep();
            //update the ordered impostors array
            this._tmpImpostorsArray[impostor.uniqueId] = impostor;
        });
        //check for collisions
        let contact = this.world.contacts;
        while(contact !== null){
            if (contact.touching && !contact.body1.sleeping && !contact.body2.sleeping) {
                contact = contact.next;
                continue;
            }
            //is this body colliding with any other? get the impostor
            const mainImpostor = this._tmpImpostorsArray[+contact.body1.name];
            const collidingImpostor = this._tmpImpostorsArray[+contact.body2.name];
            if (!mainImpostor || !collidingImpostor) {
                contact = contact.next;
                continue;
            }
            mainImpostor.onCollide({
                body: collidingImpostor.physicsBody,
                point: null,
                distance: 0,
                impulse: 0,
                normal: null
            });
            collidingImpostor.onCollide({
                body: mainImpostor.physicsBody,
                point: null,
                distance: 0,
                impulse: 0,
                normal: null
            });
            contact = contact.next;
        }
    }
    applyImpulse(impostor, force, contactPoint) {
        const mass = impostor.physicsBody.mass;
        impostor.physicsBody.applyImpulse(contactPoint.scale(this.world.invScale), force.scale(this.world.invScale * mass));
    }
    applyForce(impostor, force, contactPoint) {
        (0, $kVtWi.Logger).Warn("Oimo doesn't support applying force. Using impulse instead.");
        this.applyImpulse(impostor, force, contactPoint);
    }
    generatePhysicsBody(impostor) {
        //parent-child relationship. Does this impostor has a parent impostor?
        if (impostor.parent) {
            if (impostor.physicsBody) {
                this.removePhysicsBody(impostor);
                //TODO is that needed?
                impostor.forceUpdate();
            }
            return;
        }
        if (impostor.isBodyInitRequired()) {
            const bodyConfig = {
                name: impostor.uniqueId,
                //Oimo must have mass, also for static objects.
                config: [
                    impostor.getParam("mass") || 0.001,
                    impostor.getParam("friction"),
                    impostor.getParam("restitution")
                ],
                size: [],
                type: [],
                pos: [],
                posShape: [],
                rot: [],
                rotShape: [],
                move: impostor.getParam("mass") !== 0,
                density: impostor.getParam("mass"),
                friction: impostor.getParam("friction"),
                restitution: impostor.getParam("restitution"),
                //Supporting older versions of Oimo
                world: this.world
            };
            const impostors = [
                impostor
            ];
            const addToArray = (parent)=>{
                if (!parent.getChildMeshes) return;
                parent.getChildMeshes().forEach(function(m) {
                    if (m.physicsImpostor) impostors.push(m.physicsImpostor);
                });
            };
            addToArray(impostor.object);
            const checkWithEpsilon = (value)=>{
                return Math.max(value, (0, $53VPf.Epsilon));
            };
            const globalQuaternion = new (0, $ha1VO.Quaternion)();
            impostors.forEach((i)=>{
                if (!i.object.rotationQuaternion) return;
                //get the correct bounding box
                const oldQuaternion = i.object.rotationQuaternion;
                globalQuaternion.copyFrom(oldQuaternion);
                i.object.rotationQuaternion.set(0, 0, 0, 1);
                i.object.computeWorldMatrix(true);
                const rot = globalQuaternion.toEulerAngles();
                const impostorExtents = i.getObjectExtents();
                // eslint-disable-next-line no-loss-of-precision
                const radToDeg = 57.295779513082320876;
                if (i === impostor) {
                    const center = impostor.getObjectCenter();
                    impostor.object.getAbsolutePivotPoint().subtractToRef(center, this._tmpPositionVector);
                    this._tmpPositionVector.divideInPlace(impostor.object.scaling);
                    //Can also use Array.prototype.push.apply
                    bodyConfig.pos.push(center.x);
                    bodyConfig.pos.push(center.y);
                    bodyConfig.pos.push(center.z);
                    bodyConfig.posShape.push(0, 0, 0);
                    bodyConfig.rotShape.push(0, 0, 0);
                } else {
                    const localPosition = i.object.position.clone();
                    bodyConfig.posShape.push(localPosition.x);
                    bodyConfig.posShape.push(localPosition.y);
                    bodyConfig.posShape.push(localPosition.z);
                    // bodyConfig.pos.push(0, 0, 0);
                    bodyConfig.rotShape.push(rot.x * radToDeg, rot.y * radToDeg, rot.z * radToDeg);
                }
                i.object.rotationQuaternion.copyFrom(globalQuaternion);
                // register mesh
                switch(i.type){
                    case (0, $iz3U8.PhysicsImpostor).ParticleImpostor:
                        (0, $kVtWi.Logger).Warn("No Particle support in OIMO.js. using SphereImpostor instead");
                    // eslint-disable-next-line no-fallthrough
                    case (0, $iz3U8.PhysicsImpostor).SphereImpostor:
                        {
                            const radiusX = impostorExtents.x;
                            const radiusY = impostorExtents.y;
                            const radiusZ = impostorExtents.z;
                            const size = Math.max(checkWithEpsilon(radiusX), checkWithEpsilon(radiusY), checkWithEpsilon(radiusZ)) / 2;
                            bodyConfig.type.push("sphere");
                            //due to the way oimo works with compounds, add 3 times
                            bodyConfig.size.push(size);
                            bodyConfig.size.push(size);
                            bodyConfig.size.push(size);
                            break;
                        }
                    case (0, $iz3U8.PhysicsImpostor).CylinderImpostor:
                        {
                            const sizeX = checkWithEpsilon(impostorExtents.x) / 2;
                            const sizeY = checkWithEpsilon(impostorExtents.y);
                            bodyConfig.type.push("cylinder");
                            bodyConfig.size.push(sizeX);
                            bodyConfig.size.push(sizeY);
                            //due to the way oimo works with compounds, add one more value.
                            bodyConfig.size.push(sizeY);
                            break;
                        }
                    case (0, $iz3U8.PhysicsImpostor).PlaneImpostor:
                    case (0, $iz3U8.PhysicsImpostor).BoxImpostor:
                    default:
                        {
                            const sizeX = checkWithEpsilon(impostorExtents.x);
                            const sizeY = checkWithEpsilon(impostorExtents.y);
                            const sizeZ = checkWithEpsilon(impostorExtents.z);
                            bodyConfig.type.push("box");
                            //if (i === impostor) {
                            bodyConfig.size.push(sizeX);
                            bodyConfig.size.push(sizeY);
                            bodyConfig.size.push(sizeZ);
                            break;
                        }
                }
                //actually not needed, but hey...
                i.object.rotationQuaternion = oldQuaternion;
            });
            impostor.physicsBody = this.world.add(bodyConfig);
            // set the quaternion, ignoring the previously defined (euler) rotation
            impostor.physicsBody.resetQuaternion(globalQuaternion);
            // update with delta 0, so the body will receive the new rotation.
            impostor.physicsBody.updatePosition(0);
        } else this._tmpPositionVector.copyFromFloats(0, 0, 0);
        impostor.setDeltaPosition(this._tmpPositionVector);
    //this._tmpPositionVector.addInPlace(impostor.mesh.getBoundingInfo().boundingBox.center);
    //this.setPhysicsBodyTransformation(impostor, this._tmpPositionVector, impostor.mesh.rotationQuaternion);
    }
    removePhysicsBody(impostor) {
        //impostor.physicsBody.dispose();
        this.world.removeRigidBody(impostor.physicsBody);
    }
    generateJoint(impostorJoint) {
        const mainBody = impostorJoint.mainImpostor.physicsBody;
        const connectedBody = impostorJoint.connectedImpostor.physicsBody;
        if (!mainBody || !connectedBody) return;
        const jointData = impostorJoint.joint.jointData;
        const options = jointData.nativeParams || {};
        let type;
        const nativeJointData = {
            body1: mainBody,
            body2: connectedBody,
            axe1: options.axe1 || (jointData.mainAxis ? jointData.mainAxis.asArray() : null),
            axe2: options.axe2 || (jointData.connectedAxis ? jointData.connectedAxis.asArray() : null),
            pos1: options.pos1 || (jointData.mainPivot ? jointData.mainPivot.asArray() : null),
            pos2: options.pos2 || (jointData.connectedPivot ? jointData.connectedPivot.asArray() : null),
            min: options.min,
            max: options.max,
            collision: options.collision || jointData.collision,
            spring: options.spring,
            //supporting older version of Oimo
            world: this.world
        };
        switch(impostorJoint.joint.type){
            case (0, $kGTHw.PhysicsJoint).BallAndSocketJoint:
                type = "jointBall";
                break;
            case (0, $kGTHw.PhysicsJoint).SpringJoint:
                {
                    (0, $kVtWi.Logger).Warn("OIMO.js doesn't support Spring Constraint. Simulating using DistanceJoint instead");
                    const springData = jointData;
                    nativeJointData.min = springData.length || nativeJointData.min;
                    //Max should also be set, just make sure it is at least min
                    nativeJointData.max = Math.max(nativeJointData.min, nativeJointData.max);
                }
            // eslint-disable-next-line no-fallthrough
            case (0, $kGTHw.PhysicsJoint).DistanceJoint:
                type = "jointDistance";
                nativeJointData.max = jointData.maxDistance;
                break;
            case (0, $kGTHw.PhysicsJoint).PrismaticJoint:
                type = "jointPrisme";
                break;
            case (0, $kGTHw.PhysicsJoint).SliderJoint:
                type = "jointSlide";
                break;
            case (0, $kGTHw.PhysicsJoint).WheelJoint:
                type = "jointWheel";
                break;
            case (0, $kGTHw.PhysicsJoint).HingeJoint:
            default:
                type = "jointHinge";
                break;
        }
        nativeJointData.type = type;
        impostorJoint.joint.physicsJoint = this.world.add(nativeJointData);
    }
    removeJoint(impostorJoint) {
        //Bug in Oimo prevents us from disposing a joint in the playground
        //joint.joint.physicsJoint.dispose();
        //So we will bruteforce it!
        try {
            this.world.removeJoint(impostorJoint.joint.physicsJoint);
        } catch (e) {
            (0, $kVtWi.Logger).Warn(e);
        }
    }
    isSupported() {
        return this.BJSOIMO !== undefined;
    }
    setTransformationFromPhysicsBody(impostor) {
        if (!impostor.physicsBody.sleeping) {
            if (impostor.physicsBody.shapes.next) {
                let parent = impostor.physicsBody.shapes;
                while(parent.next)parent = parent.next;
                impostor.object.position.set(parent.position.x, parent.position.y, parent.position.z);
            } else {
                const pos = impostor.physicsBody.getPosition();
                impostor.object.position.set(pos.x, pos.y, pos.z);
            }
            if (impostor.object.rotationQuaternion) {
                const quat = impostor.physicsBody.getQuaternion();
                impostor.object.rotationQuaternion.set(quat.x, quat.y, quat.z, quat.w);
            }
        }
    }
    setPhysicsBodyTransformation(impostor, newPosition, newRotation) {
        const body = impostor.physicsBody;
        // disable bidirectional for compound meshes
        if (impostor.physicsBody.shapes.next) return;
        body.position.set(newPosition.x, newPosition.y, newPosition.z);
        body.orientation.set(newRotation.x, newRotation.y, newRotation.z, newRotation.w);
        body.syncShapes();
        body.awake();
    }
    /*private _getLastShape(body: any): any {
        var lastShape = body.shapes;
        while (lastShape.next) {
            lastShape = lastShape.next;
        }
        return lastShape;
    }*/ setLinearVelocity(impostor, velocity) {
        impostor.physicsBody.linearVelocity.set(velocity.x, velocity.y, velocity.z);
    }
    setAngularVelocity(impostor, velocity) {
        impostor.physicsBody.angularVelocity.set(velocity.x, velocity.y, velocity.z);
    }
    getLinearVelocity(impostor) {
        const v = impostor.physicsBody.linearVelocity;
        if (!v) return null;
        return new (0, $ha1VO.Vector3)(v.x, v.y, v.z);
    }
    getAngularVelocity(impostor) {
        const v = impostor.physicsBody.angularVelocity;
        if (!v) return null;
        return new (0, $ha1VO.Vector3)(v.x, v.y, v.z);
    }
    setBodyMass(impostor, mass) {
        const staticBody = mass === 0;
        //this will actually set the body's density and not its mass.
        //But this is how oimo treats the mass variable.
        impostor.physicsBody.shapes.density = staticBody ? 1 : mass;
        impostor.physicsBody.setupMass(staticBody ? 0x2 : 0x1);
    }
    getBodyMass(impostor) {
        return impostor.physicsBody.shapes.density;
    }
    getBodyFriction(impostor) {
        return impostor.physicsBody.shapes.friction;
    }
    setBodyFriction(impostor, friction) {
        impostor.physicsBody.shapes.friction = friction;
    }
    getBodyRestitution(impostor) {
        return impostor.physicsBody.shapes.restitution;
    }
    setBodyRestitution(impostor, restitution) {
        impostor.physicsBody.shapes.restitution = restitution;
    }
    sleepBody(impostor) {
        impostor.physicsBody.sleep();
    }
    wakeUpBody(impostor) {
        impostor.physicsBody.awake();
    }
    updateDistanceJoint(joint, maxDistance, minDistance) {
        joint.physicsJoint.limitMotor.upperLimit = maxDistance;
        if (minDistance !== void 0) joint.physicsJoint.limitMotor.lowerLimit = minDistance;
    }
    setMotor(joint, speed, force, motorIndex) {
        if (force !== undefined) (0, $kVtWi.Logger).Warn("OimoJS plugin currently has unexpected behavior when using setMotor with force parameter");
        else force = 1e6;
        speed *= -1;
        //TODO separate rotational and transational motors.
        const motor = motorIndex ? joint.physicsJoint.rotationalLimitMotor2 : joint.physicsJoint.rotationalLimitMotor1 || joint.physicsJoint.rotationalLimitMotor || joint.physicsJoint.limitMotor;
        if (motor) motor.setMotor(speed, force);
    }
    setLimit(joint, upperLimit, lowerLimit, motorIndex) {
        //TODO separate rotational and transational motors.
        const motor = motorIndex ? joint.physicsJoint.rotationalLimitMotor2 : joint.physicsJoint.rotationalLimitMotor1 || joint.physicsJoint.rotationalLimitMotor || joint.physicsJoint.limitMotor;
        if (motor) motor.setLimit(upperLimit, lowerLimit === void 0 ? -upperLimit : lowerLimit);
    }
    syncMeshWithImpostor(mesh, impostor) {
        const body = impostor.physicsBody;
        mesh.position.x = body.position.x;
        mesh.position.y = body.position.y;
        mesh.position.z = body.position.z;
        if (mesh.rotationQuaternion) {
            mesh.rotationQuaternion.x = body.orientation.x;
            mesh.rotationQuaternion.y = body.orientation.y;
            mesh.rotationQuaternion.z = body.orientation.z;
            mesh.rotationQuaternion.w = body.orientation.w;
        }
    }
    getRadius(impostor) {
        return impostor.physicsBody.shapes.radius;
    }
    getBoxSizeToRef(impostor, result) {
        const shape = impostor.physicsBody.shapes;
        result.x = shape.halfWidth * 2;
        result.y = shape.halfHeight * 2;
        result.z = shape.halfDepth * 2;
    }
    dispose() {
        this.world.clear();
    }
    /**
     * Does a raycast in the physics world
     * @param from when should the ray start?
     * @param to when should the ray end?
     * @returns PhysicsRaycastResult
     */ raycast(from, to) {
        (0, $kVtWi.Logger).Warn("raycast is not currently supported by the Oimo physics plugin");
        this._raycastResult.reset(from, to);
        return this._raycastResult;
    }
    /**
     * Does a raycast in the physics world
     * @param from when should the ray start?
     * @param to when should the ray end?
     * @param result resulting PhysicsRaycastResult
     */ raycastToRef(from, to, result) {
        (0, $kVtWi.Logger).Warn("raycast is not currently supported by the Oimo physics plugin");
        result.reset(from, to);
    }
}

});

parcelRegister("hEg94", function(module, exports) {

$parcel$export(module.exports, "AmmoJSPlugin", () => $cd92b23d2107974f$export$2e7e53469038d8f7);

var $ha1VO = parcelRequire("ha1VO");

var $kVtWi = parcelRequire("kVtWi");

var $iz3U8 = parcelRequire("iz3U8");

var $kGTHw = parcelRequire("kGTHw");

var $b4i1f = parcelRequire("b4i1f");

var $5v6ry = parcelRequire("5v6ry");

var $l411O = parcelRequire("l411O");

var $8Eyol = parcelRequire("8Eyol");

var $iz1eP = parcelRequire("iz1eP");

var $1VEEL = parcelRequire("1VEEL");

var $53VPf = parcelRequire("53VPf");
class $cd92b23d2107974f$export$2e7e53469038d8f7 {
    /**
     * Initializes the ammoJS plugin
     * @param _useDeltaForWorldStep if the time between frames should be used when calculating physics steps (Default: true)
     * @param ammoInjection can be used to inject your own ammo reference
     * @param overlappingPairCache can be used to specify your own overlapping pair cache
     */ constructor(_useDeltaForWorldStep = true, ammoInjection = Ammo, overlappingPairCache = null){
        this._useDeltaForWorldStep = _useDeltaForWorldStep;
        /**
         * Reference to the Ammo library
         */ this.bjsAMMO = {};
        /**
         * Name of the plugin
         */ this.name = "AmmoJSPlugin";
        this._timeStep = 1 / 60;
        this._fixedTimeStep = 1 / 60;
        this._maxSteps = 5;
        this._tmpQuaternion = new (0, $ha1VO.Quaternion)();
        this._tmpContactCallbackResult = false;
        this._tmpContactPoint = new (0, $ha1VO.Vector3)();
        this._tmpContactNormal = new (0, $ha1VO.Vector3)();
        this._tmpVec3 = new (0, $ha1VO.Vector3)();
        this._tmpMatrix = new (0, $ha1VO.Matrix)();
        if (typeof ammoInjection === "function") {
            (0, $kVtWi.Logger).Error("AmmoJS is not ready. Please make sure you await Ammo() before using the plugin.");
            return;
        } else this.bjsAMMO = ammoInjection;
        if (!this.isSupported()) {
            (0, $kVtWi.Logger).Error("AmmoJS is not available. Please make sure you included the js file.");
            return;
        }
        // Initialize the physics world
        this._collisionConfiguration = new this.bjsAMMO.btSoftBodyRigidBodyCollisionConfiguration();
        this._dispatcher = new this.bjsAMMO.btCollisionDispatcher(this._collisionConfiguration);
        this._overlappingPairCache = overlappingPairCache || new this.bjsAMMO.btDbvtBroadphase();
        this._solver = new this.bjsAMMO.btSequentialImpulseConstraintSolver();
        this._softBodySolver = new this.bjsAMMO.btDefaultSoftBodySolver();
        this.world = new this.bjsAMMO.btSoftRigidDynamicsWorld(this._dispatcher, this._overlappingPairCache, this._solver, this._collisionConfiguration, this._softBodySolver);
        this._tmpAmmoConcreteContactResultCallback = new this.bjsAMMO.ConcreteContactResultCallback();
        this._tmpAmmoConcreteContactResultCallback.addSingleResult = (contactPoint)=>{
            contactPoint = this.bjsAMMO.wrapPointer(contactPoint, this.bjsAMMO.btManifoldPoint);
            const worldPoint = contactPoint.getPositionWorldOnA();
            const worldNormal = contactPoint.m_normalWorldOnB;
            this._tmpContactPoint.x = worldPoint.x();
            this._tmpContactPoint.y = worldPoint.y();
            this._tmpContactPoint.z = worldPoint.z();
            this._tmpContactNormal.x = worldNormal.x();
            this._tmpContactNormal.y = worldNormal.y();
            this._tmpContactNormal.z = worldNormal.z();
            this._tmpContactImpulse = contactPoint.getAppliedImpulse();
            this._tmpContactDistance = contactPoint.getDistance();
            this._tmpContactCallbackResult = true;
        };
        this._raycastResult = new (0, $iz1eP.PhysicsRaycastResult)();
        // Create temp ammo variables
        this._tmpAmmoTransform = new this.bjsAMMO.btTransform();
        this._tmpAmmoTransform.setIdentity();
        this._tmpAmmoQuaternion = new this.bjsAMMO.btQuaternion(0, 0, 0, 1);
        this._tmpAmmoVectorA = new this.bjsAMMO.btVector3(0, 0, 0);
        this._tmpAmmoVectorB = new this.bjsAMMO.btVector3(0, 0, 0);
        this._tmpAmmoVectorC = new this.bjsAMMO.btVector3(0, 0, 0);
        this._tmpAmmoVectorD = new this.bjsAMMO.btVector3(0, 0, 0);
    }
    /**
     *
     * @returns plugin version
     */ getPluginVersion() {
        return 1;
    }
    /**
     * Sets the gravity of the physics world (m/(s^2))
     * @param gravity Gravity to set
     */ setGravity(gravity) {
        this._tmpAmmoVectorA.setValue(gravity.x, gravity.y, gravity.z);
        this.world.setGravity(this._tmpAmmoVectorA);
        this.world.getWorldInfo().set_m_gravity(this._tmpAmmoVectorA);
    }
    /**
     * Amount of time to step forward on each frame (only used if useDeltaForWorldStep is false in the constructor)
     * @param timeStep timestep to use in seconds
     */ setTimeStep(timeStep) {
        this._timeStep = timeStep;
    }
    /**
     * Increment to step forward in the physics engine (If timeStep is set to 1/60 and fixedTimeStep is set to 1/120 the physics engine should run 2 steps per frame) (Default: 1/60)
     * @param fixedTimeStep fixedTimeStep to use in seconds
     */ setFixedTimeStep(fixedTimeStep) {
        this._fixedTimeStep = fixedTimeStep;
    }
    /**
     * Sets the maximum number of steps by the physics engine per frame (Default: 5)
     * @param maxSteps the maximum number of steps by the physics engine per frame
     */ setMaxSteps(maxSteps) {
        this._maxSteps = maxSteps;
    }
    /**
     * Gets the current timestep (only used if useDeltaForWorldStep is false in the constructor)
     * @returns the current timestep in seconds
     */ getTimeStep() {
        return this._timeStep;
    }
    // Ammo's contactTest and contactPairTest take a callback that runs synchronously, wrap them so that they are easier to consume
    _isImpostorInContact(impostor) {
        this._tmpContactCallbackResult = false;
        this.world.contactTest(impostor.physicsBody, this._tmpAmmoConcreteContactResultCallback);
        return this._tmpContactCallbackResult;
    }
    // Ammo's collision events have some weird quirks
    // contactPairTest fires too many events as it fires events even when objects are close together but contactTest does not
    // so only fire event if both contactTest and contactPairTest have a hit
    _isImpostorPairInContact(impostorA, impostorB) {
        this._tmpContactCallbackResult = false;
        this.world.contactPairTest(impostorA.physicsBody, impostorB.physicsBody, this._tmpAmmoConcreteContactResultCallback);
        return this._tmpContactCallbackResult;
    }
    // Ammo's behavior when maxSteps > 0 does not behave as described in docs
    // @see http://www.bulletphysics.org/mediawiki-1.5.8/index.php/Stepping_The_World
    //
    // When maxSteps is 0 do the entire simulation in one step
    // When maxSteps is > 0, run up to maxStep times, if on the last step the (remaining step - fixedTimeStep) is < fixedTimeStep, the remainder will be used for the step. (eg. if remainder is 1.001 and fixedTimeStep is 1 the last step will be 1.001, if instead it did 2 steps (1, 0.001) issues occuered when having a tiny step in ammo)
    // Note: To get deterministic physics, timeStep would always need to be divisible by fixedTimeStep
    _stepSimulation(timeStep = 1 / 60, maxSteps = 10, fixedTimeStep = 1 / 60) {
        if (maxSteps == 0) this.world.stepSimulation(timeStep, 0);
        else while(maxSteps > 0 && timeStep > 0){
            if (timeStep - fixedTimeStep < fixedTimeStep) {
                this.world.stepSimulation(timeStep, 0);
                timeStep = 0;
            } else {
                timeStep -= fixedTimeStep;
                this.world.stepSimulation(fixedTimeStep, 0);
            }
            maxSteps--;
        }
    }
    /**
     * Moves the physics simulation forward delta seconds and updates the given physics imposters
     * Prior to the step the imposters physics location is set to the position of the babylon meshes
     * After the step the babylon meshes are set to the position of the physics imposters
     * @param delta amount of time to step forward
     * @param impostors array of imposters to update before/after the step
     */ executeStep(delta, impostors) {
        for (const impostor of impostors)// Update physics world objects to match babylon world
        if (!impostor.soft) impostor.beforeStep();
        this._stepSimulation(this._useDeltaForWorldStep ? delta : this._timeStep, this._maxSteps, this._fixedTimeStep);
        for (const mainImpostor of impostors){
            // After physics update make babylon world objects match physics world objects
            if (mainImpostor.soft) this._afterSoftStep(mainImpostor);
            else mainImpostor.afterStep();
            // Handle collision event
            if (mainImpostor._onPhysicsCollideCallbacks.length > 0) {
                if (this._isImpostorInContact(mainImpostor)) {
                    for (const collideCallback of mainImpostor._onPhysicsCollideCallbacks)for (const otherImpostor of collideCallback.otherImpostors){
                        if (mainImpostor.physicsBody.isActive() || otherImpostor.physicsBody.isActive()) {
                            if (this._isImpostorPairInContact(mainImpostor, otherImpostor)) {
                                mainImpostor.onCollide({
                                    body: otherImpostor.physicsBody,
                                    point: this._tmpContactPoint,
                                    distance: this._tmpContactDistance,
                                    impulse: this._tmpContactImpulse,
                                    normal: this._tmpContactNormal
                                });
                                otherImpostor.onCollide({
                                    body: mainImpostor.physicsBody,
                                    point: this._tmpContactPoint,
                                    distance: this._tmpContactDistance,
                                    impulse: this._tmpContactImpulse,
                                    normal: this._tmpContactNormal
                                });
                            }
                        }
                    }
                }
            }
        }
    }
    /**
     * Update babylon mesh to match physics world object
     * @param impostor imposter to match
     */ _afterSoftStep(impostor) {
        if (impostor.type === (0, $iz3U8.PhysicsImpostor).RopeImpostor) this._ropeStep(impostor);
        else this._softbodyOrClothStep(impostor);
    }
    /**
     * Update babylon mesh vertices vertices to match physics world softbody or cloth
     * @param impostor imposter to match
     */ _ropeStep(impostor) {
        const bodyVertices = impostor.physicsBody.get_m_nodes();
        const nbVertices = bodyVertices.size();
        let node;
        let nodePositions;
        let x, y, z;
        const path = new Array();
        for(let n = 0; n < nbVertices; n++){
            node = bodyVertices.at(n);
            nodePositions = node.get_m_x();
            x = nodePositions.x();
            y = nodePositions.y();
            z = nodePositions.z();
            path.push(new (0, $ha1VO.Vector3)(x, y, z));
        }
        const object = impostor.object;
        const shape = impostor.getParam("shape");
        if (impostor._isFromLine) impostor.object = (0, $8Eyol.CreateLines)("lines", {
            points: path,
            instance: object
        });
        else impostor.object = (0, $l411O.ExtrudeShape)("ext", {
            shape: shape,
            path: path,
            instance: object
        });
    }
    /**
     * Update babylon mesh vertices vertices to match physics world softbody or cloth
     * @param impostor imposter to match
     */ _softbodyOrClothStep(impostor) {
        const normalDirection = impostor.type === (0, $iz3U8.PhysicsImpostor).ClothImpostor ? 1 : -1;
        const object = impostor.object;
        let vertexPositions = object.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        if (!vertexPositions) vertexPositions = [];
        let vertexNormals = object.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind);
        if (!vertexNormals) vertexNormals = [];
        const nbVertices = vertexPositions.length / 3;
        const bodyVertices = impostor.physicsBody.get_m_nodes();
        let node;
        let nodePositions;
        let x, y, z;
        let nx, ny, nz;
        for(let n = 0; n < nbVertices; n++){
            node = bodyVertices.at(n);
            nodePositions = node.get_m_x();
            x = nodePositions.x();
            y = nodePositions.y();
            z = nodePositions.z() * normalDirection;
            const nodeNormals = node.get_m_n();
            nx = nodeNormals.x();
            ny = nodeNormals.y();
            nz = nodeNormals.z() * normalDirection;
            vertexPositions[3 * n] = x;
            vertexPositions[3 * n + 1] = y;
            vertexPositions[3 * n + 2] = z;
            vertexNormals[3 * n] = nx;
            vertexNormals[3 * n + 1] = ny;
            vertexNormals[3 * n + 2] = nz;
        }
        const vertex_data = new (0, $5v6ry.VertexData)();
        vertex_data.positions = vertexPositions;
        vertex_data.normals = vertexNormals;
        vertex_data.uvs = object.getVerticesData((0, $b4i1f.VertexBuffer).UVKind);
        vertex_data.colors = object.getVerticesData((0, $b4i1f.VertexBuffer).ColorKind);
        if (object && object.getIndices) vertex_data.indices = object.getIndices();
        vertex_data.applyToMesh(object);
    }
    /**
     * Applies an impulse on the imposter
     * @param impostor imposter to apply impulse to
     * @param force amount of force to be applied to the imposter
     * @param contactPoint the location to apply the impulse on the imposter
     */ applyImpulse(impostor, force, contactPoint) {
        if (!impostor.soft) {
            impostor.physicsBody.activate();
            const worldPoint = this._tmpAmmoVectorA;
            const impulse = this._tmpAmmoVectorB;
            // Convert contactPoint relative to center of mass
            if (impostor.object && impostor.object.getWorldMatrix) contactPoint.subtractInPlace(impostor.object.getWorldMatrix().getTranslation());
            worldPoint.setValue(contactPoint.x, contactPoint.y, contactPoint.z);
            impulse.setValue(force.x, force.y, force.z);
            impostor.physicsBody.applyImpulse(impulse, worldPoint);
        } else (0, $kVtWi.Logger).Warn("Cannot be applied to a soft body");
    }
    /**
     * Applies a force on the imposter
     * @param impostor imposter to apply force
     * @param force amount of force to be applied to the imposter
     * @param contactPoint the location to apply the force on the imposter
     */ applyForce(impostor, force, contactPoint) {
        if (!impostor.soft) {
            impostor.physicsBody.activate();
            const worldPoint = this._tmpAmmoVectorA;
            const impulse = this._tmpAmmoVectorB;
            // Convert contactPoint relative to center of mass
            if (impostor.object && impostor.object.getWorldMatrix) {
                const localTranslation = impostor.object.getWorldMatrix().getTranslation();
                worldPoint.setValue(contactPoint.x - localTranslation.x, contactPoint.y - localTranslation.y, contactPoint.z - localTranslation.z);
            } else worldPoint.setValue(contactPoint.x, contactPoint.y, contactPoint.z);
            impulse.setValue(force.x, force.y, force.z);
            impostor.physicsBody.applyForce(impulse, worldPoint);
        } else (0, $kVtWi.Logger).Warn("Cannot be applied to a soft body");
    }
    /**
     * Creates a physics body using the plugin
     * @param impostor the imposter to create the physics body on
     */ generatePhysicsBody(impostor) {
        // Note: this method will not be called on child imposotrs for compound impostors
        impostor._pluginData.toDispose = [];
        //parent-child relationship
        if (impostor.parent) {
            if (impostor.physicsBody) {
                this.removePhysicsBody(impostor);
                impostor.forceUpdate();
            }
            return;
        }
        if (impostor.isBodyInitRequired()) {
            const colShape = this._createShape(impostor);
            const mass = impostor.getParam("mass");
            impostor._pluginData.mass = mass;
            if (impostor.soft) {
                colShape.get_m_cfg().set_collisions(0x11);
                colShape.get_m_cfg().set_kDP(impostor.getParam("damping"));
                this.bjsAMMO.castObject(colShape, this.bjsAMMO.btCollisionObject).getCollisionShape().setMargin(impostor.getParam("margin"));
                colShape.setActivationState($cd92b23d2107974f$export$2e7e53469038d8f7._DISABLE_DEACTIVATION_FLAG);
                this.world.addSoftBody(colShape, 1, -1);
                impostor.physicsBody = colShape;
                impostor._pluginData.toDispose.push(colShape);
                this.setBodyPressure(impostor, 0);
                if (impostor.type === (0, $iz3U8.PhysicsImpostor).SoftbodyImpostor) this.setBodyPressure(impostor, impostor.getParam("pressure"));
                this.setBodyStiffness(impostor, impostor.getParam("stiffness"));
                this.setBodyVelocityIterations(impostor, impostor.getParam("velocityIterations"));
                this.setBodyPositionIterations(impostor, impostor.getParam("positionIterations"));
            } else {
                const localInertia = new this.bjsAMMO.btVector3(0, 0, 0);
                const startTransform = new this.bjsAMMO.btTransform();
                impostor.object.computeWorldMatrix(true);
                startTransform.setIdentity();
                if (mass !== 0) colShape.calculateLocalInertia(mass, localInertia);
                this._tmpAmmoVectorA.setValue(impostor.object.position.x, impostor.object.position.y, impostor.object.position.z);
                this._tmpAmmoQuaternion.setValue(impostor.object.rotationQuaternion.x, impostor.object.rotationQuaternion.y, impostor.object.rotationQuaternion.z, impostor.object.rotationQuaternion.w);
                startTransform.setOrigin(this._tmpAmmoVectorA);
                startTransform.setRotation(this._tmpAmmoQuaternion);
                const myMotionState = new this.bjsAMMO.btDefaultMotionState(startTransform);
                const rbInfo = new this.bjsAMMO.btRigidBodyConstructionInfo(mass, myMotionState, colShape, localInertia);
                const body = new this.bjsAMMO.btRigidBody(rbInfo);
                // Make objects kinematic if it's mass is 0
                if (mass === 0) {
                    body.setCollisionFlags(body.getCollisionFlags() | $cd92b23d2107974f$export$2e7e53469038d8f7._KINEMATIC_FLAG);
                    body.setActivationState($cd92b23d2107974f$export$2e7e53469038d8f7._DISABLE_DEACTIVATION_FLAG);
                }
                // Disable collision if NoImpostor, but keep collision if shape is btCompoundShape
                if (impostor.type == (0, $iz3U8.PhysicsImpostor).NoImpostor && !colShape.getChildShape) body.setCollisionFlags(body.getCollisionFlags() | $cd92b23d2107974f$export$2e7e53469038d8f7._DISABLE_COLLISION_FLAG);
                // compute delta position: compensate the difference between shape center and mesh origin
                if (impostor.type !== (0, $iz3U8.PhysicsImpostor).MeshImpostor && impostor.type !== (0, $iz3U8.PhysicsImpostor).NoImpostor) {
                    const boundingInfo = impostor.object.getBoundingInfo();
                    this._tmpVec3.copyFrom(impostor.object.getAbsolutePosition());
                    this._tmpVec3.subtractInPlace(boundingInfo.boundingBox.centerWorld);
                    this._tmpVec3.x /= impostor.object.scaling.x;
                    this._tmpVec3.y /= impostor.object.scaling.y;
                    this._tmpVec3.z /= impostor.object.scaling.z;
                    impostor.setDeltaPosition(this._tmpVec3);
                }
                const group = impostor.getParam("group");
                const mask = impostor.getParam("mask");
                if (group && mask) this.world.addRigidBody(body, group, mask);
                else this.world.addRigidBody(body);
                impostor.physicsBody = body;
                impostor._pluginData.toDispose = impostor._pluginData.toDispose.concat([
                    body,
                    rbInfo,
                    myMotionState,
                    startTransform,
                    localInertia,
                    colShape
                ]);
            }
            this.setBodyRestitution(impostor, impostor.getParam("restitution"));
            this.setBodyFriction(impostor, impostor.getParam("friction"));
        }
    }
    /**
     * Removes the physics body from the imposter and disposes of the body's memory
     * @param impostor imposter to remove the physics body from
     */ removePhysicsBody(impostor) {
        if (this.world) {
            if (impostor.soft) this.world.removeSoftBody(impostor.physicsBody);
            else this.world.removeRigidBody(impostor.physicsBody);
            if (impostor._pluginData) {
                impostor._pluginData.toDispose.forEach((d)=>{
                    this.bjsAMMO.destroy(d);
                });
                impostor._pluginData.toDispose = [];
            }
        }
    }
    /**
     * Generates a joint
     * @param impostorJoint the imposter joint to create the joint with
     */ generateJoint(impostorJoint) {
        const mainBody = impostorJoint.mainImpostor.physicsBody;
        const connectedBody = impostorJoint.connectedImpostor.physicsBody;
        if (!mainBody || !connectedBody) return;
        const jointData = impostorJoint.joint.jointData;
        if (!jointData.mainPivot) jointData.mainPivot = new (0, $ha1VO.Vector3)(0, 0, 0);
        if (!jointData.connectedPivot) jointData.connectedPivot = new (0, $ha1VO.Vector3)(0, 0, 0);
        let joint;
        switch(impostorJoint.joint.type){
            case (0, $kGTHw.PhysicsJoint).DistanceJoint:
                {
                    const distance = jointData.maxDistance;
                    if (distance) {
                        jointData.mainPivot = new (0, $ha1VO.Vector3)(0, -distance / 2, 0);
                        jointData.connectedPivot = new (0, $ha1VO.Vector3)(0, distance / 2, 0);
                    }
                    joint = new this.bjsAMMO.btPoint2PointConstraint(mainBody, connectedBody, new this.bjsAMMO.btVector3(jointData.mainPivot.x, jointData.mainPivot.y, jointData.mainPivot.z), new this.bjsAMMO.btVector3(jointData.connectedPivot.x, jointData.connectedPivot.y, jointData.connectedPivot.z));
                    break;
                }
            case (0, $kGTHw.PhysicsJoint).HingeJoint:
                {
                    if (!jointData.mainAxis) jointData.mainAxis = new (0, $ha1VO.Vector3)(0, 0, 0);
                    if (!jointData.connectedAxis) jointData.connectedAxis = new (0, $ha1VO.Vector3)(0, 0, 0);
                    const mainAxis = new this.bjsAMMO.btVector3(jointData.mainAxis.x, jointData.mainAxis.y, jointData.mainAxis.z);
                    const connectedAxis = new this.bjsAMMO.btVector3(jointData.connectedAxis.x, jointData.connectedAxis.y, jointData.connectedAxis.z);
                    joint = new this.bjsAMMO.btHingeConstraint(mainBody, connectedBody, new this.bjsAMMO.btVector3(jointData.mainPivot.x, jointData.mainPivot.y, jointData.mainPivot.z), new this.bjsAMMO.btVector3(jointData.connectedPivot.x, jointData.connectedPivot.y, jointData.connectedPivot.z), mainAxis, connectedAxis);
                    break;
                }
            case (0, $kGTHw.PhysicsJoint).BallAndSocketJoint:
                joint = new this.bjsAMMO.btPoint2PointConstraint(mainBody, connectedBody, new this.bjsAMMO.btVector3(jointData.mainPivot.x, jointData.mainPivot.y, jointData.mainPivot.z), new this.bjsAMMO.btVector3(jointData.connectedPivot.x, jointData.connectedPivot.y, jointData.connectedPivot.z));
                break;
            default:
                (0, $kVtWi.Logger).Warn("JointType not currently supported by the Ammo plugin, falling back to PhysicsJoint.BallAndSocketJoint");
                joint = new this.bjsAMMO.btPoint2PointConstraint(mainBody, connectedBody, new this.bjsAMMO.btVector3(jointData.mainPivot.x, jointData.mainPivot.y, jointData.mainPivot.z), new this.bjsAMMO.btVector3(jointData.connectedPivot.x, jointData.connectedPivot.y, jointData.connectedPivot.z));
                break;
        }
        this.world.addConstraint(joint, !impostorJoint.joint.jointData.collision);
        impostorJoint.joint.physicsJoint = joint;
    }
    /**
     * Removes a joint
     * @param impostorJoint the imposter joint to remove the joint from
     */ removeJoint(impostorJoint) {
        if (this.world) this.world.removeConstraint(impostorJoint.joint.physicsJoint);
    }
    // adds all verticies (including child verticies) to the triangle mesh
    _addMeshVerts(btTriangleMesh, topLevelObject, object) {
        let triangleCount = 0;
        if (object && object.getIndices && object.getWorldMatrix && object.getChildMeshes) {
            let indices = object.getIndices();
            if (!indices) indices = [];
            let vertexPositions = object.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
            if (!vertexPositions) vertexPositions = [];
            let localMatrix;
            if (topLevelObject && topLevelObject !== object) {
                // top level matrix used for shape transform doesn't take scale into account.
                // Moreover, every children vertex position must be in that space.
                // So, each vertex position here is transform by (mesh world matrix * toplevelMatrix -1)
                let topLevelQuaternion;
                if (topLevelObject.rotationQuaternion) topLevelQuaternion = topLevelObject.rotationQuaternion;
                else if (topLevelObject.rotation) topLevelQuaternion = (0, $ha1VO.Quaternion).FromEulerAngles(topLevelObject.rotation.x, topLevelObject.rotation.y, topLevelObject.rotation.z);
                else topLevelQuaternion = (0, $ha1VO.Quaternion).Identity();
                const topLevelMatrix = (0, $ha1VO.Matrix).Compose((0, $ha1VO.Vector3).One(), topLevelQuaternion, topLevelObject.position);
                topLevelMatrix.invertToRef(this._tmpMatrix);
                const wm = object.computeWorldMatrix(false);
                localMatrix = wm.multiply(this._tmpMatrix);
            } else {
                // current top level is same as object level -> only use local scaling
                (0, $ha1VO.Matrix).ScalingToRef(object.scaling.x, object.scaling.y, object.scaling.z, this._tmpMatrix);
                localMatrix = this._tmpMatrix;
            }
            const faceCount = indices.length / 3;
            for(let i = 0; i < faceCount; i++){
                const triPoints = [];
                for(let point = 0; point < 3; point++){
                    let v = new (0, $ha1VO.Vector3)(vertexPositions[indices[i * 3 + point] * 3 + 0], vertexPositions[indices[i * 3 + point] * 3 + 1], vertexPositions[indices[i * 3 + point] * 3 + 2]);
                    v = (0, $ha1VO.Vector3).TransformCoordinates(v, localMatrix);
                    let vec;
                    if (point == 0) vec = this._tmpAmmoVectorA;
                    else if (point == 1) vec = this._tmpAmmoVectorB;
                    else vec = this._tmpAmmoVectorC;
                    vec.setValue(v.x, v.y, v.z);
                    triPoints.push(vec);
                }
                btTriangleMesh.addTriangle(triPoints[0], triPoints[1], triPoints[2]);
                triangleCount++;
            }
            object.getChildMeshes().forEach((m)=>{
                triangleCount += this._addMeshVerts(btTriangleMesh, topLevelObject, m);
            });
        }
        return triangleCount;
    }
    /**
     * Initialise the soft body vertices to match its object's (mesh) vertices
     * Softbody vertices (nodes) are in world space and to match this
     * The object's position and rotation is set to zero and so its vertices are also then set in world space
     * @param impostor to create the softbody for
     * @returns the number of vertices added to the softbody
     */ _softVertexData(impostor) {
        const object = impostor.object;
        if (object && object.getIndices && object.getWorldMatrix && object.getChildMeshes) {
            let indices = object.getIndices();
            if (!indices) indices = [];
            let vertexPositions = object.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
            if (!vertexPositions) vertexPositions = [];
            let vertexNormals = object.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind);
            if (!vertexNormals) vertexNormals = [];
            object.computeWorldMatrix(false);
            const newPoints = [];
            const newNorms = [];
            for(let i = 0; i < vertexPositions.length; i += 3){
                let v = new (0, $ha1VO.Vector3)(vertexPositions[i], vertexPositions[i + 1], vertexPositions[i + 2]);
                let n = new (0, $ha1VO.Vector3)(vertexNormals[i], vertexNormals[i + 1], vertexNormals[i + 2]);
                v = (0, $ha1VO.Vector3).TransformCoordinates(v, object.getWorldMatrix());
                n = (0, $ha1VO.Vector3).TransformNormal(n, object.getWorldMatrix());
                newPoints.push(v.x, v.y, v.z);
                newNorms.push(n.x, n.y, n.z);
            }
            const vertex_data = new (0, $5v6ry.VertexData)();
            vertex_data.positions = newPoints;
            vertex_data.normals = newNorms;
            vertex_data.uvs = object.getVerticesData((0, $b4i1f.VertexBuffer).UVKind);
            vertex_data.colors = object.getVerticesData((0, $b4i1f.VertexBuffer).ColorKind);
            if (object && object.getIndices) vertex_data.indices = object.getIndices();
            vertex_data.applyToMesh(object);
            object.position = (0, $ha1VO.Vector3).Zero();
            object.rotationQuaternion = null;
            object.rotation = (0, $ha1VO.Vector3).Zero();
            object.computeWorldMatrix(true);
            return vertex_data;
        }
        return (0, $5v6ry.VertexData).ExtractFromMesh(object);
    }
    /**
     * Create an impostor's soft body
     * @param impostor to create the softbody for
     * @returns the softbody
     */ _createSoftbody(impostor) {
        const object = impostor.object;
        if (object && object.getIndices) {
            let indices = object.getIndices();
            if (!indices) indices = [];
            const vertex_data = this._softVertexData(impostor);
            const vertexPositions = vertex_data.positions;
            const vertexNormals = vertex_data.normals;
            if (vertexPositions === null || vertexNormals === null) return new this.bjsAMMO.btCompoundShape();
            else {
                const triPoints = [];
                const triNorms = [];
                for(let i = 0; i < vertexPositions.length; i += 3){
                    const v = new (0, $ha1VO.Vector3)(vertexPositions[i], vertexPositions[i + 1], vertexPositions[i + 2]);
                    const n = new (0, $ha1VO.Vector3)(vertexNormals[i], vertexNormals[i + 1], vertexNormals[i + 2]);
                    triPoints.push(v.x, v.y, -v.z);
                    triNorms.push(n.x, n.y, -n.z);
                }
                const softBody = new this.bjsAMMO.btSoftBodyHelpers().CreateFromTriMesh(this.world.getWorldInfo(), triPoints, object.getIndices(), indices.length / 3, true);
                const nbVertices = vertexPositions.length / 3;
                const bodyVertices = softBody.get_m_nodes();
                let node;
                let nodeNormals;
                for(let i = 0; i < nbVertices; i++){
                    node = bodyVertices.at(i);
                    nodeNormals = node.get_m_n();
                    nodeNormals.setX(triNorms[3 * i]);
                    nodeNormals.setY(triNorms[3 * i + 1]);
                    nodeNormals.setZ(triNorms[3 * i + 2]);
                }
                return softBody;
            }
        }
    }
    /**
     * Create cloth for an impostor
     * @param impostor to create the softbody for
     * @returns the cloth
     */ _createCloth(impostor) {
        const object = impostor.object;
        if (object && object.getIndices) {
            let indices = object.getIndices();
            if (!indices) indices = [];
            const vertex_data = this._softVertexData(impostor);
            const vertexPositions = vertex_data.positions;
            const vertexNormals = vertex_data.normals;
            if (vertexPositions === null || vertexNormals === null) return new this.bjsAMMO.btCompoundShape();
            else {
                const len = vertexPositions.length;
                const segments = Math.sqrt(len / 3);
                impostor.segments = segments;
                const segs = segments - 1;
                this._tmpAmmoVectorA.setValue(vertexPositions[0], vertexPositions[1], vertexPositions[2]);
                this._tmpAmmoVectorB.setValue(vertexPositions[3 * segs], vertexPositions[3 * segs + 1], vertexPositions[3 * segs + 2]);
                this._tmpAmmoVectorD.setValue(vertexPositions[len - 3], vertexPositions[len - 2], vertexPositions[len - 1]);
                this._tmpAmmoVectorC.setValue(vertexPositions[len - 3 - 3 * segs], vertexPositions[len - 2 - 3 * segs], vertexPositions[len - 1 - 3 * segs]);
                const clothBody = new this.bjsAMMO.btSoftBodyHelpers().CreatePatch(this.world.getWorldInfo(), this._tmpAmmoVectorA, this._tmpAmmoVectorB, this._tmpAmmoVectorC, this._tmpAmmoVectorD, segments, segments, impostor.getParam("fixedPoints"), true);
                return clothBody;
            }
        }
    }
    /**
     * Create rope for an impostor
     * @param impostor to create the softbody for
     * @returns the rope
     */ _createRope(impostor) {
        let len;
        let segments;
        const vertex_data = this._softVertexData(impostor);
        const vertexPositions = vertex_data.positions;
        const vertexNormals = vertex_data.normals;
        if (vertexPositions === null || vertexNormals === null) return new this.bjsAMMO.btCompoundShape();
        //force the mesh to be updatable
        vertex_data.applyToMesh(impostor.object, true);
        impostor._isFromLine = true;
        // If in lines mesh all normals will be zero
        const vertexSquared = vertexNormals.map((x)=>x * x);
        const reducer = (accumulator, currentValue)=>accumulator + currentValue;
        const reduced = vertexSquared.reduce(reducer);
        if (reduced === 0) {
            // line mesh
            len = vertexPositions.length;
            segments = len / 3 - 1;
            this._tmpAmmoVectorA.setValue(vertexPositions[0], vertexPositions[1], vertexPositions[2]);
            this._tmpAmmoVectorB.setValue(vertexPositions[len - 3], vertexPositions[len - 2], vertexPositions[len - 1]);
        } else {
            //extruded mesh
            impostor._isFromLine = false;
            const pathVectors = impostor.getParam("path");
            const shape = impostor.getParam("shape");
            if (shape === null) {
                (0, $kVtWi.Logger).Warn("No shape available for extruded mesh");
                return new this.bjsAMMO.btCompoundShape();
            }
            len = pathVectors.length;
            segments = len - 1;
            this._tmpAmmoVectorA.setValue(pathVectors[0].x, pathVectors[0].y, pathVectors[0].z);
            this._tmpAmmoVectorB.setValue(pathVectors[len - 1].x, pathVectors[len - 1].y, pathVectors[len - 1].z);
        }
        impostor.segments = segments;
        let fixedPoints = impostor.getParam("fixedPoints");
        fixedPoints = fixedPoints > 3 ? 3 : fixedPoints;
        const ropeBody = new this.bjsAMMO.btSoftBodyHelpers().CreateRope(this.world.getWorldInfo(), this._tmpAmmoVectorA, this._tmpAmmoVectorB, segments - 1, fixedPoints);
        ropeBody.get_m_cfg().set_collisions(0x11);
        return ropeBody;
    }
    /**
     * Create a custom physics impostor shape using the plugin's onCreateCustomShape handler
     * @param impostor to create the custom physics shape for
     * @returns the custom physics shape
     */ _createCustom(impostor) {
        let returnValue = null;
        if (this.onCreateCustomShape) returnValue = this.onCreateCustomShape(impostor);
        if (returnValue == null) returnValue = new this.bjsAMMO.btCompoundShape();
        return returnValue;
    }
    // adds all verticies (including child verticies) to the convex hull shape
    _addHullVerts(btConvexHullShape, topLevelObject, object) {
        let triangleCount = 0;
        if (object && object.getIndices && object.getWorldMatrix && object.getChildMeshes) {
            let indices = object.getIndices();
            if (!indices) indices = [];
            let vertexPositions = object.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
            if (!vertexPositions) vertexPositions = [];
            object.computeWorldMatrix(false);
            const faceCount = indices.length / 3;
            for(let i = 0; i < faceCount; i++){
                const triPoints = [];
                for(let point = 0; point < 3; point++){
                    let v = new (0, $ha1VO.Vector3)(vertexPositions[indices[i * 3 + point] * 3 + 0], vertexPositions[indices[i * 3 + point] * 3 + 1], vertexPositions[indices[i * 3 + point] * 3 + 2]);
                    // Adjust for initial scaling
                    (0, $ha1VO.Matrix).ScalingToRef(object.scaling.x, object.scaling.y, object.scaling.z, this._tmpMatrix);
                    v = (0, $ha1VO.Vector3).TransformCoordinates(v, this._tmpMatrix);
                    let vec;
                    if (point == 0) vec = this._tmpAmmoVectorA;
                    else if (point == 1) vec = this._tmpAmmoVectorB;
                    else vec = this._tmpAmmoVectorC;
                    vec.setValue(v.x, v.y, v.z);
                    triPoints.push(vec);
                }
                btConvexHullShape.addPoint(triPoints[0], true);
                btConvexHullShape.addPoint(triPoints[1], true);
                btConvexHullShape.addPoint(triPoints[2], true);
                triangleCount++;
            }
            object.getChildMeshes().forEach((m)=>{
                triangleCount += this._addHullVerts(btConvexHullShape, topLevelObject, m);
            });
        }
        return triangleCount;
    }
    _createShape(impostor, ignoreChildren = false) {
        const object = impostor.object;
        let returnValue;
        const impostorExtents = impostor.getObjectExtents();
        if (!ignoreChildren) {
            const meshChildren = impostor.object.getChildMeshes ? impostor.object.getChildMeshes(true) : [];
            returnValue = new this.bjsAMMO.btCompoundShape();
            // Add shape of all children to the compound shape
            let childrenAdded = 0;
            meshChildren.forEach((childMesh)=>{
                const childImpostor = childMesh.getPhysicsImpostor();
                if (childImpostor) {
                    if (childImpostor.type == (0, $iz3U8.PhysicsImpostor).MeshImpostor) // eslint-disable-next-line no-throw-literal
                    throw "A child MeshImpostor is not supported. Only primitive impostors are supported as children (eg. box or sphere)";
                    const shape = this._createShape(childImpostor);
                    // Position needs to be scaled based on parent's scaling
                    const parentMat = childMesh.parent.getWorldMatrix().clone();
                    const s = new (0, $ha1VO.Vector3)();
                    parentMat.decompose(s);
                    this._tmpAmmoTransform.getOrigin().setValue(childMesh.position.x * s.x, childMesh.position.y * s.y, childMesh.position.z * s.z);
                    this._tmpAmmoQuaternion.setValue(childMesh.rotationQuaternion.x, childMesh.rotationQuaternion.y, childMesh.rotationQuaternion.z, childMesh.rotationQuaternion.w);
                    this._tmpAmmoTransform.setRotation(this._tmpAmmoQuaternion);
                    returnValue.addChildShape(this._tmpAmmoTransform, shape);
                    childImpostor.dispose();
                    childrenAdded++;
                }
            });
            if (childrenAdded > 0) {
                // Add parents shape as a child if present
                if (impostor.type != (0, $iz3U8.PhysicsImpostor).NoImpostor) {
                    const shape = this._createShape(impostor, true);
                    if (shape) {
                        this._tmpAmmoTransform.getOrigin().setValue(0, 0, 0);
                        this._tmpAmmoQuaternion.setValue(0, 0, 0, 1);
                        this._tmpAmmoTransform.setRotation(this._tmpAmmoQuaternion);
                        returnValue.addChildShape(this._tmpAmmoTransform, shape);
                    }
                }
                return returnValue;
            } else {
                // If no children with impostors create the actual shape below instead
                this.bjsAMMO.destroy(returnValue);
                returnValue = null;
            }
        }
        switch(impostor.type){
            case (0, $iz3U8.PhysicsImpostor).SphereImpostor:
                // Is there a better way to compare floats number? With an epsilon or with a Math function
                if ((0, $1VEEL.Scalar).WithinEpsilon(impostorExtents.x, impostorExtents.y, 0.0001) && (0, $1VEEL.Scalar).WithinEpsilon(impostorExtents.x, impostorExtents.z, 0.0001)) returnValue = new this.bjsAMMO.btSphereShape(impostorExtents.x / 2);
                else {
                    // create a btMultiSphereShape because it's not possible to set a local scaling on a btSphereShape
                    const positions = [
                        new this.bjsAMMO.btVector3(0, 0, 0)
                    ];
                    const radii = [
                        1
                    ];
                    returnValue = new this.bjsAMMO.btMultiSphereShape(positions, radii, 1);
                    returnValue.setLocalScaling(new this.bjsAMMO.btVector3(impostorExtents.x / 2, impostorExtents.y / 2, impostorExtents.z / 2));
                }
                break;
            case (0, $iz3U8.PhysicsImpostor).CapsuleImpostor:
                {
                    // https://pybullet.org/Bullet/BulletFull/classbtCapsuleShape.html#details
                    // Height is just the height between the center of each 'sphere' of the capsule caps
                    const capRadius = impostorExtents.x / 2;
                    returnValue = new this.bjsAMMO.btCapsuleShape(capRadius, impostorExtents.y - capRadius * 2);
                }
                break;
            case (0, $iz3U8.PhysicsImpostor).CylinderImpostor:
                this._tmpAmmoVectorA.setValue(impostorExtents.x / 2, impostorExtents.y / 2, impostorExtents.z / 2);
                returnValue = new this.bjsAMMO.btCylinderShape(this._tmpAmmoVectorA);
                break;
            case (0, $iz3U8.PhysicsImpostor).PlaneImpostor:
            case (0, $iz3U8.PhysicsImpostor).BoxImpostor:
                this._tmpAmmoVectorA.setValue(impostorExtents.x / 2, impostorExtents.y / 2, impostorExtents.z / 2);
                returnValue = new this.bjsAMMO.btBoxShape(this._tmpAmmoVectorA);
                break;
            case (0, $iz3U8.PhysicsImpostor).MeshImpostor:
                if (impostor.getParam("mass") == 0) {
                    // Only create btBvhTriangleMeshShape if the impostor is static
                    // See https://pybullet.org/Bullet/phpBB3/viewtopic.php?t=7283
                    if (this.onCreateCustomMeshImpostor) returnValue = this.onCreateCustomMeshImpostor(impostor);
                    else {
                        const triMesh = new this.bjsAMMO.btTriangleMesh();
                        impostor._pluginData.toDispose.push(triMesh);
                        const triangleCount = this._addMeshVerts(triMesh, object, object);
                        if (triangleCount == 0) returnValue = new this.bjsAMMO.btCompoundShape();
                        else returnValue = new this.bjsAMMO.btBvhTriangleMeshShape(triMesh);
                    }
                    break;
                }
            // Otherwise create convexHullImpostor
            // eslint-disable-next-line no-fallthrough
            case (0, $iz3U8.PhysicsImpostor).ConvexHullImpostor:
                if (this.onCreateCustomConvexHullImpostor) returnValue = this.onCreateCustomConvexHullImpostor(impostor);
                else {
                    const convexHull = new this.bjsAMMO.btConvexHullShape();
                    const triangleCount = this._addHullVerts(convexHull, object, object);
                    if (triangleCount == 0) {
                        // Cleanup Unused Convex Hull Shape
                        impostor._pluginData.toDispose.push(convexHull);
                        returnValue = new this.bjsAMMO.btCompoundShape();
                    } else returnValue = convexHull;
                }
                break;
            case (0, $iz3U8.PhysicsImpostor).NoImpostor:
                // Fill with sphere but collision is disabled on the rigid body in generatePhysicsBody, using an empty shape caused unexpected movement with joints
                returnValue = new this.bjsAMMO.btSphereShape(impostorExtents.x / 2);
                break;
            case (0, $iz3U8.PhysicsImpostor).CustomImpostor:
                // Only usable when the plugin's onCreateCustomShape is set
                returnValue = this._createCustom(impostor);
                break;
            case (0, $iz3U8.PhysicsImpostor).SoftbodyImpostor:
                // Only usable with a mesh that has sufficient and shared vertices
                returnValue = this._createSoftbody(impostor);
                break;
            case (0, $iz3U8.PhysicsImpostor).ClothImpostor:
                // Only usable with a ground mesh that has sufficient and shared vertices
                returnValue = this._createCloth(impostor);
                break;
            case (0, $iz3U8.PhysicsImpostor).RopeImpostor:
                // Only usable with a line mesh or an extruded mesh that is updatable
                returnValue = this._createRope(impostor);
                break;
            default:
                (0, $kVtWi.Logger).Warn("The impostor type is not currently supported by the ammo plugin.");
                break;
        }
        return returnValue;
    }
    /**
     * Sets the mesh body position/rotation from the babylon impostor
     * @param impostor imposter containing the physics body and babylon object
     */ setTransformationFromPhysicsBody(impostor) {
        impostor.physicsBody.getMotionState().getWorldTransform(this._tmpAmmoTransform);
        impostor.object.position.set(this._tmpAmmoTransform.getOrigin().x(), this._tmpAmmoTransform.getOrigin().y(), this._tmpAmmoTransform.getOrigin().z());
        if (!impostor.object.rotationQuaternion) {
            if (impostor.object.rotation) {
                this._tmpQuaternion.set(this._tmpAmmoTransform.getRotation().x(), this._tmpAmmoTransform.getRotation().y(), this._tmpAmmoTransform.getRotation().z(), this._tmpAmmoTransform.getRotation().w());
                this._tmpQuaternion.toEulerAnglesToRef(impostor.object.rotation);
            }
        } else impostor.object.rotationQuaternion.set(this._tmpAmmoTransform.getRotation().x(), this._tmpAmmoTransform.getRotation().y(), this._tmpAmmoTransform.getRotation().z(), this._tmpAmmoTransform.getRotation().w());
    }
    /**
     * Sets the babylon object's position/rotation from the physics body's position/rotation
     * @param impostor imposter containing the physics body and babylon object
     * @param newPosition new position
     * @param newRotation new rotation
     */ setPhysicsBodyTransformation(impostor, newPosition, newRotation) {
        const trans = impostor.physicsBody.getWorldTransform();
        // If rotation/position has changed update and activate rigged body
        if (Math.abs(trans.getOrigin().x() - newPosition.x) > (0, $53VPf.Epsilon) || Math.abs(trans.getOrigin().y() - newPosition.y) > (0, $53VPf.Epsilon) || Math.abs(trans.getOrigin().z() - newPosition.z) > (0, $53VPf.Epsilon) || Math.abs(trans.getRotation().x() - newRotation.x) > (0, $53VPf.Epsilon) || Math.abs(trans.getRotation().y() - newRotation.y) > (0, $53VPf.Epsilon) || Math.abs(trans.getRotation().z() - newRotation.z) > (0, $53VPf.Epsilon) || Math.abs(trans.getRotation().w() - newRotation.w) > (0, $53VPf.Epsilon)) {
            this._tmpAmmoVectorA.setValue(newPosition.x, newPosition.y, newPosition.z);
            trans.setOrigin(this._tmpAmmoVectorA);
            this._tmpAmmoQuaternion.setValue(newRotation.x, newRotation.y, newRotation.z, newRotation.w);
            trans.setRotation(this._tmpAmmoQuaternion);
            impostor.physicsBody.setWorldTransform(trans);
            if (impostor.mass == 0) {
                // Kinematic objects must be updated using motion state
                const motionState = impostor.physicsBody.getMotionState();
                if (motionState) motionState.setWorldTransform(trans);
            } else impostor.physicsBody.activate();
        }
    }
    /**
     * If this plugin is supported
     * @returns true if its supported
     */ isSupported() {
        return this.bjsAMMO !== undefined;
    }
    /**
     * Sets the linear velocity of the physics body
     * @param impostor imposter to set the velocity on
     * @param velocity velocity to set
     */ setLinearVelocity(impostor, velocity) {
        this._tmpAmmoVectorA.setValue(velocity.x, velocity.y, velocity.z);
        if (impostor.soft) impostor.physicsBody.linearVelocity(this._tmpAmmoVectorA);
        else impostor.physicsBody.setLinearVelocity(this._tmpAmmoVectorA);
    }
    /**
     * Sets the angular velocity of the physics body
     * @param impostor imposter to set the velocity on
     * @param velocity velocity to set
     */ setAngularVelocity(impostor, velocity) {
        this._tmpAmmoVectorA.setValue(velocity.x, velocity.y, velocity.z);
        if (impostor.soft) impostor.physicsBody.angularVelocity(this._tmpAmmoVectorA);
        else impostor.physicsBody.setAngularVelocity(this._tmpAmmoVectorA);
    }
    /**
     * gets the linear velocity
     * @param impostor imposter to get linear velocity from
     * @returns linear velocity
     */ getLinearVelocity(impostor) {
        let v;
        if (impostor.soft) v = impostor.physicsBody.linearVelocity();
        else v = impostor.physicsBody.getLinearVelocity();
        if (!v) return null;
        const result = new (0, $ha1VO.Vector3)(v.x(), v.y(), v.z());
        this.bjsAMMO.destroy(v);
        return result;
    }
    /**
     * gets the angular velocity
     * @param impostor imposter to get angular velocity from
     * @returns angular velocity
     */ getAngularVelocity(impostor) {
        let v;
        if (impostor.soft) v = impostor.physicsBody.angularVelocity();
        else v = impostor.physicsBody.getAngularVelocity();
        if (!v) return null;
        const result = new (0, $ha1VO.Vector3)(v.x(), v.y(), v.z());
        this.bjsAMMO.destroy(v);
        return result;
    }
    /**
     * Sets the mass of physics body
     * @param impostor imposter to set the mass on
     * @param mass mass to set
     */ setBodyMass(impostor, mass) {
        if (impostor.soft) impostor.physicsBody.setTotalMass(mass, false);
        else impostor.physicsBody.setMassProps(mass);
        impostor._pluginData.mass = mass;
    }
    /**
     * Gets the mass of the physics body
     * @param impostor imposter to get the mass from
     * @returns mass
     */ getBodyMass(impostor) {
        return impostor._pluginData.mass || 0;
    }
    /**
     * Gets friction of the impostor
     * @param impostor impostor to get friction from
     * @returns friction value
     */ getBodyFriction(impostor) {
        return impostor._pluginData.friction || 0;
    }
    /**
     * Sets friction of the impostor
     * @param impostor impostor to set friction on
     * @param friction friction value
     */ setBodyFriction(impostor, friction) {
        if (impostor.soft) impostor.physicsBody.get_m_cfg().set_kDF(friction);
        else impostor.physicsBody.setFriction(friction);
        impostor._pluginData.friction = friction;
    }
    /**
     * Gets restitution of the impostor
     * @param impostor impostor to get restitution from
     * @returns restitution value
     */ getBodyRestitution(impostor) {
        return impostor._pluginData.restitution || 0;
    }
    /**
     * Sets restitution of the impostor
     * @param impostor impostor to set resitution on
     * @param restitution resitution value
     */ setBodyRestitution(impostor, restitution) {
        impostor.physicsBody.setRestitution(restitution);
        impostor._pluginData.restitution = restitution;
    }
    /**
     * Gets pressure inside the impostor
     * @param impostor impostor to get pressure from
     * @returns pressure value
     */ getBodyPressure(impostor) {
        if (!impostor.soft) {
            (0, $kVtWi.Logger).Warn("Pressure is not a property of a rigid body");
            return 0;
        }
        return impostor._pluginData.pressure || 0;
    }
    /**
     * Sets pressure inside a soft body impostor
     * Cloth and rope must remain 0 pressure
     * @param impostor impostor to set pressure on
     * @param pressure pressure value
     */ setBodyPressure(impostor, pressure) {
        if (impostor.soft) {
            if (impostor.type === (0, $iz3U8.PhysicsImpostor).SoftbodyImpostor) {
                impostor.physicsBody.get_m_cfg().set_kPR(pressure);
                impostor._pluginData.pressure = pressure;
            } else {
                impostor.physicsBody.get_m_cfg().set_kPR(0);
                impostor._pluginData.pressure = 0;
            }
        } else (0, $kVtWi.Logger).Warn("Pressure can only be applied to a softbody");
    }
    /**
     * Gets stiffness of the impostor
     * @param impostor impostor to get stiffness from
     * @returns pressure value
     */ getBodyStiffness(impostor) {
        if (!impostor.soft) {
            (0, $kVtWi.Logger).Warn("Stiffness is not a property of a rigid body");
            return 0;
        }
        return impostor._pluginData.stiffness || 0;
    }
    /**
     * Sets stiffness of the impostor
     * @param impostor impostor to set stiffness on
     * @param stiffness stiffness value from 0 to 1
     */ setBodyStiffness(impostor, stiffness) {
        if (impostor.soft) {
            stiffness = stiffness < 0 ? 0 : stiffness;
            stiffness = stiffness > 1 ? 1 : stiffness;
            impostor.physicsBody.get_m_materials().at(0).set_m_kLST(stiffness);
            impostor._pluginData.stiffness = stiffness;
        } else (0, $kVtWi.Logger).Warn("Stiffness cannot be applied to a rigid body");
    }
    /**
     * Gets velocityIterations of the impostor
     * @param impostor impostor to get velocity iterations from
     * @returns velocityIterations value
     */ getBodyVelocityIterations(impostor) {
        if (!impostor.soft) {
            (0, $kVtWi.Logger).Warn("Velocity iterations is not a property of a rigid body");
            return 0;
        }
        return impostor._pluginData.velocityIterations || 0;
    }
    /**
     * Sets velocityIterations of the impostor
     * @param impostor impostor to set velocity iterations on
     * @param velocityIterations velocityIterations value
     */ setBodyVelocityIterations(impostor, velocityIterations) {
        if (impostor.soft) {
            velocityIterations = velocityIterations < 0 ? 0 : velocityIterations;
            impostor.physicsBody.get_m_cfg().set_viterations(velocityIterations);
            impostor._pluginData.velocityIterations = velocityIterations;
        } else (0, $kVtWi.Logger).Warn("Velocity iterations cannot be applied to a rigid body");
    }
    /**
     * Gets positionIterations of the impostor
     * @param impostor impostor to get position iterations from
     * @returns positionIterations value
     */ getBodyPositionIterations(impostor) {
        if (!impostor.soft) {
            (0, $kVtWi.Logger).Warn("Position iterations is not a property of a rigid body");
            return 0;
        }
        return impostor._pluginData.positionIterations || 0;
    }
    /**
     * Sets positionIterations of the impostor
     * @param impostor impostor to set position on
     * @param positionIterations positionIterations value
     */ setBodyPositionIterations(impostor, positionIterations) {
        if (impostor.soft) {
            positionIterations = positionIterations < 0 ? 0 : positionIterations;
            impostor.physicsBody.get_m_cfg().set_piterations(positionIterations);
            impostor._pluginData.positionIterations = positionIterations;
        } else (0, $kVtWi.Logger).Warn("Position iterations cannot be applied to a rigid body");
    }
    /**
     * Append an anchor to a cloth object
     * @param impostor is the cloth impostor to add anchor to
     * @param otherImpostor is the rigid impostor to anchor to
     * @param width ratio across width from 0 to 1
     * @param height ratio up height from 0 to 1
     * @param influence the elasticity between cloth impostor and anchor from 0, very stretchy to 1, little stretch
     * @param noCollisionBetweenLinkedBodies when true collisions between soft impostor and anchor are ignored; default false
     */ appendAnchor(impostor, otherImpostor, width, height, influence = 1, noCollisionBetweenLinkedBodies = false) {
        const segs = impostor.segments;
        const nbAcross = Math.round((segs - 1) * width);
        const nbUp = Math.round((segs - 1) * height);
        const nbDown = segs - 1 - nbUp;
        const node = nbAcross + segs * nbDown;
        impostor.physicsBody.appendAnchor(node, otherImpostor.physicsBody, noCollisionBetweenLinkedBodies, influence);
    }
    /**
     * Append an hook to a rope object
     * @param impostor is the rope impostor to add hook to
     * @param otherImpostor is the rigid impostor to hook to
     * @param length ratio along the rope from 0 to 1
     * @param influence the elasticity between soft impostor and anchor from 0, very stretchy to 1, little stretch
     * @param noCollisionBetweenLinkedBodies when true collisions between soft impostor and anchor are ignored; default false
     */ appendHook(impostor, otherImpostor, length, influence = 1, noCollisionBetweenLinkedBodies = false) {
        const node = Math.round(impostor.segments * length);
        impostor.physicsBody.appendAnchor(node, otherImpostor.physicsBody, noCollisionBetweenLinkedBodies, influence);
    }
    /**
     * Sleeps the physics body and stops it from being active
     * @param impostor impostor to sleep
     */ sleepBody(impostor) {
        impostor.physicsBody.forceActivationState(0);
    }
    /**
     * Activates the physics body
     * @param impostor impostor to activate
     */ wakeUpBody(impostor) {
        impostor.physicsBody.activate();
    }
    /**
     * Updates the distance parameters of the joint
     */ updateDistanceJoint() {
        (0, $kVtWi.Logger).Warn("updateDistanceJoint is not currently supported by the Ammo physics plugin");
    }
    /**
     * Sets a motor on the joint
     * @param joint joint to set motor on
     * @param speed speed of the motor
     * @param maxForce maximum force of the motor
     */ setMotor(joint, speed, maxForce) {
        joint.physicsJoint.enableAngularMotor(true, speed, maxForce);
    }
    /**
     * Sets the motors limit
     */ setLimit() {
        (0, $kVtWi.Logger).Warn("setLimit is not currently supported by the Ammo physics plugin");
    }
    /**
     * Syncs the position and rotation of a mesh with the impostor
     * @param mesh mesh to sync
     * @param impostor impostor to update the mesh with
     */ syncMeshWithImpostor(mesh, impostor) {
        const body = impostor.physicsBody;
        body.getMotionState().getWorldTransform(this._tmpAmmoTransform);
        mesh.position.x = this._tmpAmmoTransform.getOrigin().x();
        mesh.position.y = this._tmpAmmoTransform.getOrigin().y();
        mesh.position.z = this._tmpAmmoTransform.getOrigin().z();
        if (mesh.rotationQuaternion) {
            mesh.rotationQuaternion.x = this._tmpAmmoTransform.getRotation().x();
            mesh.rotationQuaternion.y = this._tmpAmmoTransform.getRotation().y();
            mesh.rotationQuaternion.z = this._tmpAmmoTransform.getRotation().z();
            mesh.rotationQuaternion.w = this._tmpAmmoTransform.getRotation().w();
        }
    }
    /**
     * Gets the radius of the impostor
     * @param impostor impostor to get radius from
     * @returns the radius
     */ getRadius(impostor) {
        const extents = impostor.getObjectExtents();
        return extents.x / 2;
    }
    /**
     * Gets the box size of the impostor
     * @param impostor impostor to get box size from
     * @param result the resulting box size
     */ getBoxSizeToRef(impostor, result) {
        const extents = impostor.getObjectExtents();
        result.x = extents.x;
        result.y = extents.y;
        result.z = extents.z;
    }
    /**
     * Disposes of the impostor
     */ dispose() {
        // Dispose of world
        this.bjsAMMO.destroy(this.world);
        this.bjsAMMO.destroy(this._solver);
        this.bjsAMMO.destroy(this._overlappingPairCache);
        this.bjsAMMO.destroy(this._dispatcher);
        this.bjsAMMO.destroy(this._collisionConfiguration);
        // Dispose of temp variables
        this.bjsAMMO.destroy(this._tmpAmmoVectorA);
        this.bjsAMMO.destroy(this._tmpAmmoVectorB);
        this.bjsAMMO.destroy(this._tmpAmmoVectorC);
        this.bjsAMMO.destroy(this._tmpAmmoTransform);
        this.bjsAMMO.destroy(this._tmpAmmoQuaternion);
        this.bjsAMMO.destroy(this._tmpAmmoConcreteContactResultCallback);
        this.world = null;
    }
    /**
     * Does a raycast in the physics world
     * @param from where should the ray start?
     * @param to where should the ray end?
     * @returns PhysicsRaycastResult
     */ raycast(from, to) {
        this.raycastToRef(from, to, this._raycastResult);
        return this._raycastResult;
    }
    /**
     * Does a raycast in the physics world
     * @param from when should the ray start?
     * @param to when should the ray end?
     * @param result resulting PhysicsRaycastResult
     */ raycastToRef(from, to, result) {
        this._tmpAmmoVectorRCA = new this.bjsAMMO.btVector3(from.x, from.y, from.z);
        this._tmpAmmoVectorRCB = new this.bjsAMMO.btVector3(to.x, to.y, to.z);
        const rayCallback = new this.bjsAMMO.ClosestRayResultCallback(this._tmpAmmoVectorRCA, this._tmpAmmoVectorRCB);
        this.world.rayTest(this._tmpAmmoVectorRCA, this._tmpAmmoVectorRCB, rayCallback);
        result.reset(from, to);
        if (rayCallback.hasHit()) {
            // TODO: do we want/need the body? If so, set all the data
            /*
            var rigidBody = this.bjsAMMO.btRigidBody.prototype.upcast(
                rayCallback.get_m_collisionObject()
            );
            var body = {};
            */ result.setHitData({
                x: rayCallback.get_m_hitNormalWorld().x(),
                y: rayCallback.get_m_hitNormalWorld().y(),
                z: rayCallback.get_m_hitNormalWorld().z()
            }, {
                x: rayCallback.get_m_hitPointWorld().x(),
                y: rayCallback.get_m_hitPointWorld().y(),
                z: rayCallback.get_m_hitPointWorld().z()
            });
            result.calculateHitDistance();
        }
        this.bjsAMMO.destroy(rayCallback);
        this.bjsAMMO.destroy(this._tmpAmmoVectorRCA);
        this.bjsAMMO.destroy(this._tmpAmmoVectorRCB);
    }
}
$cd92b23d2107974f$export$2e7e53469038d8f7._DISABLE_COLLISION_FLAG = 4;
$cd92b23d2107974f$export$2e7e53469038d8f7._KINEMATIC_FLAG = 2;
$cd92b23d2107974f$export$2e7e53469038d8f7._DISABLE_DEACTIVATION_FLAG = 4;

});

parcelRegister("lxthF", function(module, exports) {

$parcel$export(module.exports, "ReflectionProbe", () => $fae3653871172ced$export$c5f8573df3aa848e);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $6Ho1L = parcelRequire("6Ho1L");

var $gQtNK = parcelRequire("gQtNK");

var $ha1VO = parcelRequire("ha1VO");

var $5Tqba = parcelRequire("5Tqba");
(0, $5Tqba.AbstractScene).prototype.removeReflectionProbe = function(toRemove) {
    if (!this.reflectionProbes) return -1;
    const index = this.reflectionProbes.indexOf(toRemove);
    if (index !== -1) this.reflectionProbes.splice(index, 1);
    return index;
};
(0, $5Tqba.AbstractScene).prototype.addReflectionProbe = function(newReflectionProbe) {
    if (!this.reflectionProbes) this.reflectionProbes = [];
    this.reflectionProbes.push(newReflectionProbe);
};
class $fae3653871172ced$export$c5f8573df3aa848e {
    /**
     * Creates a new reflection probe
     * @param name defines the name of the probe
     * @param size defines the texture resolution (for each face)
     * @param scene defines the hosting scene
     * @param generateMipMaps defines if mip maps should be generated automatically (true by default)
     * @param useFloat defines if HDR data (float data) should be used to store colors (false by default)
     * @param linearSpace defines if the probe should be generated in linear space or not (false by default)
     */ constructor(/** defines the name of the probe */ name, size, scene, generateMipMaps = true, useFloat = false, linearSpace = false){
        this.name = name;
        this._viewMatrix = (0, $ha1VO.Matrix).Identity();
        this._target = (0, $ha1VO.Vector3).Zero();
        this._add = (0, $ha1VO.Vector3).Zero();
        this._invertYAxis = false;
        /** Gets or sets probe position (center of the cube map) */ this.position = (0, $ha1VO.Vector3).Zero();
        /**
         * Gets or sets an object used to store user defined information for the reflection probe.
         */ this.metadata = null;
        /** @internal */ this._parentContainer = null;
        this._scene = scene;
        if (scene.getEngine().supportsUniformBuffers) {
            this._sceneUBOs = [];
            for(let i = 0; i < 6; ++i)this._sceneUBOs.push(scene.createSceneUniformBuffer(`Scene for Reflection Probe (name "${name}") face #${i}`));
        }
        // Create the scene field if not exist.
        if (!this._scene.reflectionProbes) this._scene.reflectionProbes = [];
        this._scene.reflectionProbes.push(this);
        let textureType = 0;
        if (useFloat) {
            const caps = this._scene.getEngine().getCaps();
            if (caps.textureHalfFloatRender) textureType = 2;
            else if (caps.textureFloatRender) textureType = 1;
        }
        this._renderTargetTexture = new (0, $gQtNK.RenderTargetTexture)(name, size, scene, generateMipMaps, true, textureType, true);
        this._renderTargetTexture.gammaSpace = !linearSpace;
        this._renderTargetTexture.invertZ = scene.useRightHandedSystem;
        const useReverseDepthBuffer = scene.getEngine().useReverseDepthBuffer;
        this._renderTargetTexture.onBeforeRenderObservable.add((faceIndex)=>{
            if (this._sceneUBOs) {
                scene.setSceneUniformBuffer(this._sceneUBOs[faceIndex]);
                scene.getSceneUniformBuffer().unbindEffect();
            }
            switch(faceIndex){
                case 0:
                    this._add.copyFromFloats(1, 0, 0);
                    break;
                case 1:
                    this._add.copyFromFloats(-1, 0, 0);
                    break;
                case 2:
                    this._add.copyFromFloats(0, this._invertYAxis ? 1 : -1, 0);
                    break;
                case 3:
                    this._add.copyFromFloats(0, this._invertYAxis ? -1 : 1, 0);
                    break;
                case 4:
                    this._add.copyFromFloats(0, 0, scene.useRightHandedSystem ? -1 : 1);
                    break;
                case 5:
                    this._add.copyFromFloats(0, 0, scene.useRightHandedSystem ? 1 : -1);
                    break;
            }
            if (this._attachedMesh) this.position.copyFrom(this._attachedMesh.getAbsolutePosition());
            this.position.addToRef(this._add, this._target);
            const lookAtFunction = scene.useRightHandedSystem ? (0, $ha1VO.Matrix).LookAtRHToRef : (0, $ha1VO.Matrix).LookAtLHToRef;
            const perspectiveFunction = scene.useRightHandedSystem ? (0, $ha1VO.Matrix).PerspectiveFovRH : (0, $ha1VO.Matrix).PerspectiveFovLH;
            lookAtFunction(this.position, this._target, (0, $ha1VO.Vector3).Up(), this._viewMatrix);
            if (scene.activeCamera) {
                this._projectionMatrix = perspectiveFunction(Math.PI / 2, 1, useReverseDepthBuffer ? scene.activeCamera.maxZ : scene.activeCamera.minZ, useReverseDepthBuffer ? scene.activeCamera.minZ : scene.activeCamera.maxZ, this._scene.getEngine().isNDCHalfZRange);
                scene.setTransformMatrix(this._viewMatrix, this._projectionMatrix);
                if (scene.activeCamera.isRigCamera && !this._renderTargetTexture.activeCamera) this._renderTargetTexture.activeCamera = scene.activeCamera.rigParent || null;
            }
            scene._forcedViewPosition = this.position;
        });
        let currentApplyByPostProcess;
        this._renderTargetTexture.onBeforeBindObservable.add(()=>{
            this._currentSceneUBO = scene.getSceneUniformBuffer();
            scene.getEngine()._debugPushGroup?.(`reflection probe generation for ${name}`, 1);
            currentApplyByPostProcess = this._scene.imageProcessingConfiguration.applyByPostProcess;
            if (linearSpace) scene.imageProcessingConfiguration.applyByPostProcess = true;
        });
        this._renderTargetTexture.onAfterUnbindObservable.add(()=>{
            scene.imageProcessingConfiguration.applyByPostProcess = currentApplyByPostProcess;
            scene._forcedViewPosition = null;
            if (this._sceneUBOs) scene.setSceneUniformBuffer(this._currentSceneUBO);
            scene.updateTransformMatrix(true);
            scene.getEngine()._debugPopGroup?.(1);
        });
    }
    /** Gets or sets the number of samples to use for multi-sampling (0 by default). Required WebGL2 */ get samples() {
        return this._renderTargetTexture.samples;
    }
    set samples(value) {
        this._renderTargetTexture.samples = value;
    }
    /** Gets or sets the refresh rate to use (on every frame by default) */ get refreshRate() {
        return this._renderTargetTexture.refreshRate;
    }
    set refreshRate(value) {
        this._renderTargetTexture.refreshRate = value;
    }
    /**
     * Gets the hosting scene
     * @returns a Scene
     */ getScene() {
        return this._scene;
    }
    /** Gets the internal CubeTexture used to render to */ get cubeTexture() {
        return this._renderTargetTexture;
    }
    /** Gets or sets the list of meshes to render */ get renderList() {
        return this._renderTargetTexture.renderList;
    }
    set renderList(value) {
        this._renderTargetTexture.renderList = value;
    }
    /**
     * Attach the probe to a specific mesh (Rendering will be done from attached mesh's position)
     * @param mesh defines the mesh to attach to
     */ attachToMesh(mesh) {
        this._attachedMesh = mesh;
    }
    /**
     * Specifies whether or not the stencil and depth buffer are cleared between two rendering groups
     * @param renderingGroupId The rendering group id corresponding to its index
     * @param autoClearDepthStencil Automatically clears depth and stencil between groups if true.
     */ setRenderingAutoClearDepthStencil(renderingGroupId, autoClearDepthStencil) {
        this._renderTargetTexture.setRenderingAutoClearDepthStencil(renderingGroupId, autoClearDepthStencil);
    }
    /**
     * Clean all associated resources
     */ dispose() {
        const index = this._scene.reflectionProbes.indexOf(this);
        if (index !== -1) // Remove from the scene if found
        this._scene.reflectionProbes.splice(index, 1);
        if (this._parentContainer) {
            const index = this._parentContainer.reflectionProbes.indexOf(this);
            if (index > -1) this._parentContainer.reflectionProbes.splice(index, 1);
            this._parentContainer = null;
        }
        if (this._renderTargetTexture) {
            this._renderTargetTexture.dispose();
            this._renderTargetTexture = null;
        }
        if (this._sceneUBOs) {
            for (const ubo of this._sceneUBOs)ubo.dispose();
            this._sceneUBOs = [];
        }
    }
    /**
     * Converts the reflection probe information to a readable string for debug purpose.
     * @param fullDetails Supports for multiple levels of logging within scene loading
     * @returns the human readable reflection probe info
     */ toString(fullDetails) {
        let ret = "Name: " + this.name;
        if (fullDetails) {
            ret += ", position: " + this.position.toString();
            if (this._attachedMesh) ret += ", attached mesh: " + this._attachedMesh.name;
        }
        return ret;
    }
    /**
     * Get the class name of the refection probe.
     * @returns "ReflectionProbe"
     */ getClassName() {
        return "ReflectionProbe";
    }
    /**
     * Serialize the reflection probe to a JSON representation we can easily use in the respective Parse function.
     * @returns The JSON representation of the texture
     */ serialize() {
        const serializationObject = (0, $6Ho1L.SerializationHelper).Serialize(this, this._renderTargetTexture.serialize());
        serializationObject.isReflectionProbe = true;
        serializationObject.metadata = this.metadata;
        return serializationObject;
    }
    /**
     * Parse the JSON representation of a reflection probe in order to recreate the reflection probe in the given scene.
     * @param parsedReflectionProbe Define the JSON representation of the reflection probe
     * @param scene Define the scene the parsed reflection probe should be instantiated in
     * @param rootUrl Define the root url of the parsing sequence in the case of relative dependencies
     * @returns The parsed reflection probe if successful
     */ static Parse(parsedReflectionProbe, scene, rootUrl) {
        let reflectionProbe = null;
        if (scene.reflectionProbes) for(let index = 0; index < scene.reflectionProbes.length; index++){
            const rp = scene.reflectionProbes[index];
            if (rp.name === parsedReflectionProbe.name) {
                reflectionProbe = rp;
                break;
            }
        }
        reflectionProbe = (0, $6Ho1L.SerializationHelper).Parse(()=>reflectionProbe || new $fae3653871172ced$export$c5f8573df3aa848e(parsedReflectionProbe.name, parsedReflectionProbe.renderTargetSize, scene, parsedReflectionProbe._generateMipMaps), parsedReflectionProbe, scene, rootUrl);
        reflectionProbe.cubeTexture._waitingRenderList = parsedReflectionProbe.renderList;
        if (parsedReflectionProbe._attachedMesh) reflectionProbe.attachToMesh(scene.getMeshById(parsedReflectionProbe._attachedMesh));
        if (parsedReflectionProbe.metadata) reflectionProbe.metadata = parsedReflectionProbe.metadata;
        return reflectionProbe;
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsMeshReference)()
], $fae3653871172ced$export$c5f8573df3aa848e.prototype, "_attachedMesh", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsVector3)()
], $fae3653871172ced$export$c5f8573df3aa848e.prototype, "position", void 0);

});

parcelRegister("CnKcI", function(module, exports) {

$parcel$export(module.exports, "SpriteManager", () => $0735f7d56100d2ae$export$1526a6c71c79d341);

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $hQxeF = parcelRequire("hQxeF");

var $3mCyn = parcelRequire("3mCyn");

var $gzCma = parcelRequire("gzCma");

var $j2mX5 = parcelRequire("j2mX5");

var $bv05l = parcelRequire("bv05l");

var $kVtWi = parcelRequire("kVtWi");

var $bOhSV = parcelRequire("bOhSV");

var $hUzEl = parcelRequire("hUzEl");

var $6o5NX = parcelRequire("6o5NX");

var $ejQPp = parcelRequire("ejQPp");
class $0735f7d56100d2ae$export$1526a6c71c79d341 {
    /**
     * Callback called when the manager is disposed
     */ set onDispose(callback) {
        if (this._onDisposeObserver) this.onDisposeObservable.remove(this._onDisposeObserver);
        this._onDisposeObserver = this.onDisposeObservable.add(callback);
    }
    /**
     * Gets the array of sprites
     */ get children() {
        return this.sprites;
    }
    /**
     * Gets the hosting scene
     */ get scene() {
        return this._scene;
    }
    /**
     * Gets the capacity of the manager
     */ get capacity() {
        return this._spriteRenderer.capacity;
    }
    /**
     * Gets or sets the spritesheet texture
     */ get texture() {
        return this._spriteRenderer.texture;
    }
    set texture(value) {
        value.wrapU = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        value.wrapV = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        this._spriteRenderer.texture = value;
        this._textureContent = null;
    }
    /** Defines the default width of a cell in the spritesheet */ get cellWidth() {
        return this._spriteRenderer.cellWidth;
    }
    set cellWidth(value) {
        this._spriteRenderer.cellWidth = value;
    }
    /** Defines the default height of a cell in the spritesheet */ get cellHeight() {
        return this._spriteRenderer.cellHeight;
    }
    set cellHeight(value) {
        this._spriteRenderer.cellHeight = value;
    }
    /** Gets or sets a boolean indicating if the manager must consider scene fog when rendering */ get fogEnabled() {
        return this._spriteRenderer.fogEnabled;
    }
    set fogEnabled(value) {
        this._spriteRenderer.fogEnabled = value;
    }
    /**
     * Blend mode use to render the particle, it can be any of
     * the static undefined properties provided in this class.
     * Default value is 2
     */ get blendMode() {
        return this._spriteRenderer.blendMode;
    }
    set blendMode(blendMode) {
        this._spriteRenderer.blendMode = blendMode;
    }
    /** Disables writing to the depth buffer when rendering the sprites.
     *  It can be handy to disable depth writing when using textures without alpha channel
     *  and setting some specific blend modes.
     */ get disableDepthWrite() {
        return this._disableDepthWrite;
    }
    set disableDepthWrite(value) {
        this._disableDepthWrite = value;
        this._spriteRenderer.disableDepthWrite = value;
    }
    /**
     * Gets or sets a boolean indicating if the renderer must render sprites with pixel perfect rendering
     * In this mode, sprites are rendered as "pixel art", which means that they appear as pixelated but remain stable when moving or when rotated or scaled.
     * Note that for this mode to work as expected, the sprite texture must use the BILINEAR sampling mode, not NEAREST!
     */ get pixelPerfect() {
        return this._spriteRenderer.pixelPerfect;
    }
    set pixelPerfect(value) {
        this._spriteRenderer.pixelPerfect = value;
        if (value && this.texture.samplingMode !== 3) this.texture.updateSamplingMode(3);
    }
    /**
     * Creates a new sprite manager
     * @param name defines the manager's name
     * @param imgUrl defines the sprite sheet url
     * @param capacity defines the maximum allowed number of sprites
     * @param cellSize defines the size of a sprite cell
     * @param scene defines the hosting scene
     * @param epsilon defines the epsilon value to align texture (0.01 by default)
     * @param samplingMode defines the sampling mode to use with spritesheet
     * @param fromPacked set to false; do not alter
     * @param spriteJSON null otherwise a JSON object defining sprite sheet data; do not alter
     */ constructor(/** defines the manager's name */ name, imgUrl, capacity, cellSize, scene, epsilon = 0.01, samplingMode = (0, $j2mX5.Texture).TRILINEAR_SAMPLINGMODE, fromPacked = false, spriteJSON = null){
        this.name = name;
        /** Gets the list of sprites */ this.sprites = [];
        /** Gets or sets the rendering group id (0 by default) */ this.renderingGroupId = 0;
        /** Gets or sets camera layer mask */ this.layerMask = 0x0fffffff;
        /** Gets or sets a boolean indicating if the sprites are pickable */ this.isPickable = false;
        /**
         * Gets or sets an object used to store user defined information for the sprite manager
         */ this.metadata = null;
        /** @internal */ this._wasDispatched = false;
        /**
         * An event triggered when the manager is disposed.
         */ this.onDisposeObservable = new (0, $diGQf.Observable)();
        this._disableDepthWrite = false;
        /** True when packed cell data from JSON file is ready*/ this._packedAndReady = false;
        this._customUpdate = (sprite, baseSize)=>{
            if (!sprite.cellRef) sprite.cellIndex = 0;
            const num = sprite.cellIndex;
            if (typeof num === "number" && isFinite(num) && Math.floor(num) === num) sprite.cellRef = this._spriteMap[sprite.cellIndex];
            sprite._xOffset = this._cellData[sprite.cellRef].frame.x / baseSize.width;
            sprite._yOffset = this._cellData[sprite.cellRef].frame.y / baseSize.height;
            sprite._xSize = this._cellData[sprite.cellRef].frame.w;
            sprite._ySize = this._cellData[sprite.cellRef].frame.h;
        };
        if (!scene) scene = (0, $ejQPp.EngineStore).LastCreatedScene;
        if (!scene._getComponent((0, $bv05l.SceneComponentConstants).NAME_SPRITE)) scene._addComponent(new (0, $3mCyn.SpriteSceneComponent)(scene));
        this._fromPacked = fromPacked;
        this._scene = scene;
        const engine = this._scene.getEngine();
        this._spriteRenderer = new (0, $6o5NX.SpriteRenderer)(engine, capacity, epsilon, scene);
        if (cellSize.width && cellSize.height) {
            this.cellWidth = cellSize.width;
            this.cellHeight = cellSize.height;
        } else if (cellSize !== undefined) {
            this.cellWidth = cellSize;
            this.cellHeight = cellSize;
        } else {
            this._spriteRenderer = null;
            return;
        }
        this._scene.spriteManagers && this._scene.spriteManagers.push(this);
        this.uniqueId = this.scene.getUniqueId();
        if (imgUrl) this.texture = new (0, $j2mX5.Texture)(imgUrl, scene, true, false, samplingMode);
        if (this._fromPacked) this._makePacked(imgUrl, spriteJSON);
    }
    /**
     * Returns the string "SpriteManager"
     * @returns "SpriteManager"
     */ getClassName() {
        return "SpriteManager";
    }
    _makePacked(imgUrl, spriteJSON) {
        if (spriteJSON !== null) try {
            //Get the JSON and Check its structure.  If its an array parse it if its a JSON string etc...
            let celldata;
            if (typeof spriteJSON === "string") celldata = JSON.parse(spriteJSON);
            else celldata = spriteJSON;
            if (celldata.frames.length) {
                const frametemp = {};
                for(let i = 0; i < celldata.frames.length; i++){
                    const _f = celldata.frames[i];
                    if (typeof Object.keys(_f)[0] !== "string") throw new Error("Invalid JSON Format.  Check the frame values and make sure the name is the first parameter.");
                    const name = _f[Object.keys(_f)[0]];
                    frametemp[name] = _f;
                }
                celldata.frames = frametemp;
            }
            const spritemap = Reflect.ownKeys(celldata.frames);
            this._spriteMap = spritemap;
            this._packedAndReady = true;
            this._cellData = celldata.frames;
        } catch (e) {
            this._fromPacked = false;
            this._packedAndReady = false;
            throw new Error("Invalid JSON from string. Spritesheet managed with constant cell size.");
        }
        else {
            const re = /\./g;
            let li;
            do {
                li = re.lastIndex;
                re.test(imgUrl);
            }while (re.lastIndex > 0);
            const jsonUrl = imgUrl.substring(0, li - 1) + ".json";
            const onerror = ()=>{
                (0, $kVtWi.Logger).Error("JSON ERROR: Unable to load JSON file.");
                this._fromPacked = false;
                this._packedAndReady = false;
            };
            const onload = (data)=>{
                try {
                    const celldata = JSON.parse(data);
                    const spritemap = Reflect.ownKeys(celldata.frames);
                    this._spriteMap = spritemap;
                    this._packedAndReady = true;
                    this._cellData = celldata.frames;
                } catch (e) {
                    this._fromPacked = false;
                    this._packedAndReady = false;
                    throw new Error("Invalid JSON format. Please check documentation for format specifications.");
                }
            };
            (0, $bOhSV.Tools).LoadFile(jsonUrl, onload, undefined, undefined, false, onerror);
        }
    }
    _checkTextureAlpha(sprite, ray, distance, min, max) {
        if (!sprite.useAlphaForPicking || !this.texture) return true;
        const textureSize = this.texture.getSize();
        if (!this._textureContent) {
            this._textureContent = new Uint8Array(textureSize.width * textureSize.height * 4);
            this.texture.readPixels(0, 0, this._textureContent);
        }
        const contactPoint = (0, $ha1VO.TmpVectors).Vector3[0];
        contactPoint.copyFrom(ray.direction);
        contactPoint.normalize();
        contactPoint.scaleInPlace(distance);
        contactPoint.addInPlace(ray.origin);
        const contactPointU = (contactPoint.x - min.x) / (max.x - min.x);
        const contactPointV = 1.0 - (contactPoint.y - min.y) / (max.y - min.y);
        const u = sprite._xOffset * textureSize.width + contactPointU * sprite._xSize | 0;
        const v = sprite._yOffset * textureSize.height + contactPointV * sprite._ySize | 0;
        const alpha = this._textureContent[(u + v * textureSize.width) * 4 + 3];
        return alpha > 0.5;
    }
    /**
     * Intersects the sprites with a ray
     * @param ray defines the ray to intersect with
     * @param camera defines the current active camera
     * @param predicate defines a predicate used to select candidate sprites
     * @param fastCheck defines if a fast check only must be done (the first potential sprite is will be used and not the closer)
     * @returns null if no hit or a PickingInfo
     */ intersects(ray, camera, predicate, fastCheck) {
        const count = Math.min(this.capacity, this.sprites.length);
        const min = (0, $ha1VO.Vector3).Zero();
        const max = (0, $ha1VO.Vector3).Zero();
        let distance = Number.MAX_VALUE;
        let currentSprite = null;
        const pickedPoint = (0, $ha1VO.TmpVectors).Vector3[0];
        const cameraSpacePosition = (0, $ha1VO.TmpVectors).Vector3[1];
        const cameraView = camera.getViewMatrix();
        let activeRay = ray;
        let pickedRay = ray;
        for(let index = 0; index < count; index++){
            const sprite = this.sprites[index];
            if (!sprite) continue;
            if (predicate) {
                if (!predicate(sprite)) continue;
            } else if (!sprite.isPickable) continue;
            (0, $ha1VO.Vector3).TransformCoordinatesToRef(sprite.position, cameraView, cameraSpacePosition);
            if (sprite.angle) {
                // Create a rotation matrix to rotate the ray to the sprite's rotation
                (0, $ha1VO.Matrix).TranslationToRef(-cameraSpacePosition.x, -cameraSpacePosition.y, 0, (0, $ha1VO.TmpVectors).Matrix[1]);
                (0, $ha1VO.Matrix).TranslationToRef(cameraSpacePosition.x, cameraSpacePosition.y, 0, (0, $ha1VO.TmpVectors).Matrix[2]);
                (0, $ha1VO.Matrix).RotationZToRef(-sprite.angle, (0, $ha1VO.TmpVectors).Matrix[3]);
                // inv translation x rotation x translation
                (0, $ha1VO.TmpVectors).Matrix[1].multiplyToRef((0, $ha1VO.TmpVectors).Matrix[3], (0, $ha1VO.TmpVectors).Matrix[4]);
                (0, $ha1VO.TmpVectors).Matrix[4].multiplyToRef((0, $ha1VO.TmpVectors).Matrix[2], (0, $ha1VO.TmpVectors).Matrix[0]);
                activeRay = ray.clone();
                (0, $ha1VO.Vector3).TransformCoordinatesToRef(ray.origin, (0, $ha1VO.TmpVectors).Matrix[0], activeRay.origin);
                (0, $ha1VO.Vector3).TransformNormalToRef(ray.direction, (0, $ha1VO.TmpVectors).Matrix[0], activeRay.direction);
            } else activeRay = ray;
            min.copyFromFloats(cameraSpacePosition.x - sprite.width / 2, cameraSpacePosition.y - sprite.height / 2, cameraSpacePosition.z);
            max.copyFromFloats(cameraSpacePosition.x + sprite.width / 2, cameraSpacePosition.y + sprite.height / 2, cameraSpacePosition.z);
            if (activeRay.intersectsBoxMinMax(min, max)) {
                const currentDistance = (0, $ha1VO.Vector3).Distance(cameraSpacePosition, activeRay.origin);
                if (distance > currentDistance) {
                    if (!this._checkTextureAlpha(sprite, activeRay, currentDistance, min, max)) continue;
                    pickedRay = activeRay;
                    distance = currentDistance;
                    currentSprite = sprite;
                    if (fastCheck) break;
                }
            }
        }
        if (currentSprite) {
            const result = new (0, $gzCma.PickingInfo)();
            cameraView.invertToRef((0, $ha1VO.TmpVectors).Matrix[0]);
            result.hit = true;
            result.pickedSprite = currentSprite;
            result.distance = distance;
            // Get picked point
            const direction = (0, $ha1VO.TmpVectors).Vector3[2];
            direction.copyFrom(pickedRay.direction);
            direction.normalize();
            direction.scaleInPlace(distance);
            pickedRay.origin.addToRef(direction, pickedPoint);
            result.pickedPoint = (0, $ha1VO.Vector3).TransformCoordinates(pickedPoint, (0, $ha1VO.TmpVectors).Matrix[0]);
            return result;
        }
        return null;
    }
    /**
     * Intersects the sprites with a ray
     * @param ray defines the ray to intersect with
     * @param camera defines the current active camera
     * @param predicate defines a predicate used to select candidate sprites
     * @returns null if no hit or a PickingInfo array
     */ multiIntersects(ray, camera, predicate) {
        const count = Math.min(this.capacity, this.sprites.length);
        const min = (0, $ha1VO.Vector3).Zero();
        const max = (0, $ha1VO.Vector3).Zero();
        let distance;
        const results = [];
        const pickedPoint = (0, $ha1VO.TmpVectors).Vector3[0].copyFromFloats(0, 0, 0);
        const cameraSpacePosition = (0, $ha1VO.TmpVectors).Vector3[1].copyFromFloats(0, 0, 0);
        const cameraView = camera.getViewMatrix();
        for(let index = 0; index < count; index++){
            const sprite = this.sprites[index];
            if (!sprite) continue;
            if (predicate) {
                if (!predicate(sprite)) continue;
            } else if (!sprite.isPickable) continue;
            (0, $ha1VO.Vector3).TransformCoordinatesToRef(sprite.position, cameraView, cameraSpacePosition);
            min.copyFromFloats(cameraSpacePosition.x - sprite.width / 2, cameraSpacePosition.y - sprite.height / 2, cameraSpacePosition.z);
            max.copyFromFloats(cameraSpacePosition.x + sprite.width / 2, cameraSpacePosition.y + sprite.height / 2, cameraSpacePosition.z);
            if (ray.intersectsBoxMinMax(min, max)) {
                distance = (0, $ha1VO.Vector3).Distance(cameraSpacePosition, ray.origin);
                if (!this._checkTextureAlpha(sprite, ray, distance, min, max)) continue;
                const result = new (0, $gzCma.PickingInfo)();
                results.push(result);
                cameraView.invertToRef((0, $ha1VO.TmpVectors).Matrix[0]);
                result.hit = true;
                result.pickedSprite = sprite;
                result.distance = distance;
                // Get picked point
                const direction = (0, $ha1VO.TmpVectors).Vector3[2];
                direction.copyFrom(ray.direction);
                direction.normalize();
                direction.scaleInPlace(distance);
                ray.origin.addToRef(direction, pickedPoint);
                result.pickedPoint = (0, $ha1VO.Vector3).TransformCoordinates(pickedPoint, (0, $ha1VO.TmpVectors).Matrix[0]);
            }
        }
        return results;
    }
    /**
     * Render all child sprites
     */ render() {
        // Check
        if (this._fromPacked && (!this._packedAndReady || !this._spriteMap || !this._cellData)) return;
        const engine = this._scene.getEngine();
        const deltaTime = engine.getDeltaTime();
        if (this._packedAndReady) this._spriteRenderer.render(this.sprites, deltaTime, this._scene.getViewMatrix(), this._scene.getProjectionMatrix(), this._customUpdate);
        else this._spriteRenderer.render(this.sprites, deltaTime, this._scene.getViewMatrix(), this._scene.getProjectionMatrix());
    }
    /**
     * Rebuilds the manager (after a context lost, for eg)
     */ rebuild() {
        this._spriteRenderer?.rebuild();
    }
    /**
     * Release associated resources
     */ dispose() {
        if (this._spriteRenderer) {
            this._spriteRenderer.dispose();
            this._spriteRenderer = null;
        }
        this._textureContent = null;
        // Remove from scene
        if (this._scene.spriteManagers) {
            const index = this._scene.spriteManagers.indexOf(this);
            this._scene.spriteManagers.splice(index, 1);
        }
        // Callback
        this.onDisposeObservable.notifyObservers(this);
        this.onDisposeObservable.clear();
        this.metadata = null;
    }
    /**
     * Serializes the sprite manager to a JSON object
     * @param serializeTexture defines if the texture must be serialized as well
     * @returns the JSON object
     */ serialize(serializeTexture = false) {
        const serializationObject = {};
        serializationObject.name = this.name;
        serializationObject.capacity = this.capacity;
        serializationObject.cellWidth = this.cellWidth;
        serializationObject.cellHeight = this.cellHeight;
        serializationObject.fogEnabled = this.fogEnabled;
        serializationObject.blendMode = this.blendMode;
        serializationObject.disableDepthWrite = this.disableDepthWrite;
        serializationObject.pixelPerfect = this.pixelPerfect;
        if (this.texture) {
            if (serializeTexture) serializationObject.texture = this.texture.serialize();
            else {
                serializationObject.textureUrl = this.texture.name;
                serializationObject.invertY = this.texture._invertY;
            }
        }
        serializationObject.sprites = [];
        for (const sprite of this.sprites)serializationObject.sprites.push(sprite.serialize());
        serializationObject.metadata = this.metadata;
        return serializationObject;
    }
    /**
     * Parses a JSON object to create a new sprite manager.
     * @param parsedManager The JSON object to parse
     * @param scene The scene to create the sprite manager
     * @param rootUrl The root url to use to load external dependencies like texture
     * @returns the new sprite manager
     */ static Parse(parsedManager, scene, rootUrl) {
        const manager = new $0735f7d56100d2ae$export$1526a6c71c79d341(parsedManager.name, "", parsedManager.capacity, {
            width: parsedManager.cellWidth,
            height: parsedManager.cellHeight
        }, scene);
        if (parsedManager.fogEnabled !== undefined) manager.fogEnabled = parsedManager.fogEnabled;
        if (parsedManager.blendMode !== undefined) manager.blendMode = parsedManager.blendMode;
        if (parsedManager.disableDepthWrite !== undefined) manager.disableDepthWrite = parsedManager.disableDepthWrite;
        if (parsedManager.pixelPerfect !== undefined) manager.pixelPerfect = parsedManager.pixelPerfect;
        if (parsedManager.metadata !== undefined) manager.metadata = parsedManager.metadata;
        if (parsedManager.texture) manager.texture = (0, $j2mX5.Texture).Parse(parsedManager.texture, scene, rootUrl);
        else if (parsedManager.textureName) manager.texture = new (0, $j2mX5.Texture)(rootUrl + parsedManager.textureUrl, scene, false, parsedManager.invertY !== undefined ? parsedManager.invertY : true);
        for (const parsedSprite of parsedManager.sprites)(0, $hQxeF.Sprite).Parse(parsedSprite, manager);
        return manager;
    }
    /**
     * Creates a sprite manager from a snippet saved in a remote file
     * @param name defines the name of the sprite manager to create (can be null or empty to use the one from the json data)
     * @param url defines the url to load from
     * @param scene defines the hosting scene
     * @param rootUrl defines the root URL to use to load textures and relative dependencies
     * @returns a promise that will resolve to the new sprite manager
     */ static ParseFromFileAsync(name, url, scene, rootUrl = "") {
        return new Promise((resolve, reject)=>{
            const request = new (0, $hUzEl.WebRequest)();
            request.addEventListener("readystatechange", ()=>{
                if (request.readyState == 4) {
                    if (request.status == 200) {
                        const serializationObject = JSON.parse(request.responseText);
                        const output = $0735f7d56100d2ae$export$1526a6c71c79d341.Parse(serializationObject, scene || (0, $ejQPp.EngineStore).LastCreatedScene, rootUrl);
                        if (name) output.name = name;
                        resolve(output);
                    } else reject("Unable to load the sprite manager");
                }
            });
            request.open("GET", url);
            request.send();
        });
    }
    /**
     * Creates a sprite manager from a snippet saved by the sprite editor
     * @param snippetId defines the snippet to load (can be set to _BLANK to create a default one)
     * @param scene defines the hosting scene
     * @param rootUrl defines the root URL to use to load textures and relative dependencies
     * @returns a promise that will resolve to the new sprite manager
     */ static ParseFromSnippetAsync(snippetId, scene, rootUrl = "") {
        if (snippetId === "_BLANK") return Promise.resolve(new $0735f7d56100d2ae$export$1526a6c71c79d341("Default sprite manager", "//playground.babylonjs.com/textures/player.png", 500, 64, scene));
        return new Promise((resolve, reject)=>{
            const request = new (0, $hUzEl.WebRequest)();
            request.addEventListener("readystatechange", ()=>{
                if (request.readyState == 4) {
                    if (request.status == 200) {
                        const snippet = JSON.parse(JSON.parse(request.responseText).jsonPayload);
                        const serializationObject = JSON.parse(snippet.spriteManager);
                        const output = $0735f7d56100d2ae$export$1526a6c71c79d341.Parse(serializationObject, scene || (0, $ejQPp.EngineStore).LastCreatedScene, rootUrl);
                        output.snippetId = snippetId;
                        resolve(output);
                    } else reject("Unable to load the snippet " + snippetId);
                }
            });
            request.open("GET", this.SnippetUrl + "/" + snippetId.replace(/#/g, "/"));
            request.send();
        });
    }
}
/** Define the Url to load snippets */ $0735f7d56100d2ae$export$1526a6c71c79d341.SnippetUrl = `https://snippet.babylonjs.com`;
/**
 * Creates a sprite manager from a snippet saved by the sprite editor
 * @deprecated Please use ParseFromSnippetAsync instead
 * @param snippetId defines the snippet to load (can be set to _BLANK to create a default one)
 * @param scene defines the hosting scene
 * @param rootUrl defines the root URL to use to load textures and relative dependencies
 * @returns a promise that will resolve to the new sprite manager
 */ $0735f7d56100d2ae$export$1526a6c71c79d341.CreateFromSnippetAsync = $0735f7d56100d2ae$export$1526a6c71c79d341.ParseFromSnippetAsync;

});
parcelRegister("hQxeF", function(module, exports) {

$parcel$export(module.exports, "Sprite", () => $cfe112e8c93a8593$export$3075603db8e6204c);

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $diGQf = parcelRequire("diGQf");

var $buGRR = parcelRequire("buGRR");
class $cfe112e8c93a8593$export$3075603db8e6204c extends (0, $buGRR.ThinSprite) {
    /**
     * Gets or sets the sprite size
     */ get size() {
        return this.width;
    }
    set size(value) {
        this.width = value;
        this.height = value;
    }
    /**
     * Gets the manager of this sprite
     */ get manager() {
        return this._manager;
    }
    /**
     * Creates a new Sprite
     * @param name defines the name
     * @param manager defines the manager
     */ constructor(/** defines the name */ name, manager){
        super();
        this.name = name;
        /** Gets the list of attached animations */ this.animations = new Array();
        /** Gets or sets a boolean indicating if the sprite can be picked */ this.isPickable = false;
        /** Gets or sets a boolean indicating that sprite texture alpha will be used for precise picking (false by default) */ this.useAlphaForPicking = false;
        /**
         * An event triggered when the control has been disposed
         */ this.onDisposeObservable = new (0, $diGQf.Observable)();
        this._onAnimationEnd = null;
        this._endAnimation = ()=>{
            if (this._onAnimationEnd) this._onAnimationEnd();
            if (this.disposeWhenFinishedAnimating) this.dispose();
        };
        this.color = new (0, $7etnY.Color4)(1.0, 1.0, 1.0, 1.0);
        this.position = (0, $ha1VO.Vector3).Zero();
        this._manager = manager;
        this._manager.sprites.push(this);
        this.uniqueId = this._manager.scene.getUniqueId();
    }
    /**
     * Returns the string "Sprite"
     * @returns "Sprite"
     */ getClassName() {
        return "Sprite";
    }
    /** Gets or sets the initial key for the animation (setting it will restart the animation)  */ get fromIndex() {
        return this._fromIndex;
    }
    set fromIndex(value) {
        this.playAnimation(value, this._toIndex, this._loopAnimation, this._delay, this._onAnimationEnd);
    }
    /** Gets or sets the end key for the animation (setting it will restart the animation)  */ get toIndex() {
        return this._toIndex;
    }
    set toIndex(value) {
        this.playAnimation(this._fromIndex, value, this._loopAnimation, this._delay, this._onAnimationEnd);
    }
    /** Gets or sets a boolean indicating if the animation is looping (setting it will restart the animation)  */ get loopAnimation() {
        return this._loopAnimation;
    }
    set loopAnimation(value) {
        this.playAnimation(this._fromIndex, this._toIndex, value, this._delay, this._onAnimationEnd);
    }
    /** Gets or sets the delay between cell changes (setting it will restart the animation)  */ get delay() {
        return Math.max(this._delay, 1);
    }
    set delay(value) {
        this.playAnimation(this._fromIndex, this._toIndex, this._loopAnimation, value, this._onAnimationEnd);
    }
    /**
     * Starts an animation
     * @param from defines the initial key
     * @param to defines the end key
     * @param loop defines if the animation must loop
     * @param delay defines the start delay (in ms)
     * @param onAnimationEnd defines a callback to call when animation ends
     */ playAnimation(from, to, loop, delay, onAnimationEnd = null) {
        this._onAnimationEnd = onAnimationEnd;
        super.playAnimation(from, to, loop, delay, this._endAnimation);
    }
    /** Release associated resources */ dispose() {
        for(let i = 0; i < this._manager.sprites.length; i++)if (this._manager.sprites[i] == this) this._manager.sprites.splice(i, 1);
        // Callback
        this.onDisposeObservable.notifyObservers(this);
        this.onDisposeObservable.clear();
    }
    /**
     * Serializes the sprite to a JSON object
     * @returns the JSON object
     */ serialize() {
        const serializationObject = {};
        serializationObject.name = this.name;
        serializationObject.position = this.position.asArray();
        serializationObject.color = this.color.asArray();
        serializationObject.width = this.width;
        serializationObject.height = this.height;
        serializationObject.angle = this.angle;
        serializationObject.cellIndex = this.cellIndex;
        serializationObject.cellRef = this.cellRef;
        serializationObject.invertU = this.invertU;
        serializationObject.invertV = this.invertV;
        serializationObject.disposeWhenFinishedAnimating = this.disposeWhenFinishedAnimating;
        serializationObject.isPickable = this.isPickable;
        serializationObject.isVisible = this.isVisible;
        serializationObject.useAlphaForPicking = this.useAlphaForPicking;
        serializationObject.animationStarted = this.animationStarted;
        serializationObject.fromIndex = this.fromIndex;
        serializationObject.toIndex = this.toIndex;
        serializationObject.loopAnimation = this.loopAnimation;
        serializationObject.delay = this.delay;
        return serializationObject;
    }
    /**
     * Parses a JSON object to create a new sprite
     * @param parsedSprite The JSON object to parse
     * @param manager defines the hosting manager
     * @returns the new sprite
     */ static Parse(parsedSprite, manager) {
        const sprite = new $cfe112e8c93a8593$export$3075603db8e6204c(parsedSprite.name, manager);
        sprite.position = (0, $ha1VO.Vector3).FromArray(parsedSprite.position);
        sprite.color = (0, $7etnY.Color4).FromArray(parsedSprite.color);
        sprite.width = parsedSprite.width;
        sprite.height = parsedSprite.height;
        sprite.angle = parsedSprite.angle;
        sprite.cellIndex = parsedSprite.cellIndex;
        sprite.cellRef = parsedSprite.cellRef;
        sprite.invertU = parsedSprite.invertU;
        sprite.invertV = parsedSprite.invertV;
        sprite.disposeWhenFinishedAnimating = parsedSprite.disposeWhenFinishedAnimating;
        sprite.isPickable = parsedSprite.isPickable;
        sprite.isVisible = parsedSprite.isVisible;
        sprite.useAlphaForPicking = parsedSprite.useAlphaForPicking;
        sprite._fromIndex = parsedSprite.fromIndex;
        sprite._toIndex = parsedSprite.toIndex;
        sprite._loopAnimation = parsedSprite.loopAnimation;
        sprite._delay = parsedSprite.delay;
        if (parsedSprite.animationStarted) sprite.playAnimation(sprite.fromIndex, sprite.toIndex, sprite.loopAnimation, sprite.delay);
        return sprite;
    }
}

});
parcelRegister("buGRR", function(module, exports) {

$parcel$export(module.exports, "ThinSprite", () => $85e3bfb174328683$export$655ca99c1b73f848);
/**
 * ThinSprite Class used to represent a thin sprite
 * This is the base class for sprites but can also directly be used with ThinEngine
 * @see https://doc.babylonjs.com/features/featuresDeepDive/sprites
 */ class $85e3bfb174328683$export$655ca99c1b73f848 {
    /**
     * Returns a boolean indicating if the animation is started
     */ get animationStarted() {
        return this._animationStarted;
    }
    /** Gets the initial key for the animation (setting it will restart the animation)  */ get fromIndex() {
        return this._fromIndex;
    }
    /** Gets or sets the end key for the animation (setting it will restart the animation)  */ get toIndex() {
        return this._toIndex;
    }
    /** Gets or sets a boolean indicating if the animation is looping (setting it will restart the animation)  */ get loopAnimation() {
        return this._loopAnimation;
    }
    /** Gets or sets the delay between cell changes (setting it will restart the animation)  */ get delay() {
        return Math.max(this._delay, 1);
    }
    /**
     * Creates a new Thin Sprite
     */ constructor(){
        /** Gets or sets the width */ this.width = 1.0;
        /** Gets or sets the height */ this.height = 1.0;
        /** Gets or sets rotation angle */ this.angle = 0;
        /** Gets or sets a boolean indicating if UV coordinates should be inverted in U axis */ this.invertU = false;
        /** Gets or sets a boolean indicating if UV coordinates should be inverted in B axis */ this.invertV = false;
        /** Gets or sets a boolean indicating if the sprite is visible (renderable). Default is true */ this.isVisible = true;
        this._animationStarted = false;
        this._loopAnimation = false;
        this._fromIndex = 0;
        this._toIndex = 0;
        this._delay = 0;
        this._direction = 1;
        this._time = 0;
        this._onBaseAnimationEnd = null;
        this.position = {
            x: 1.0,
            y: 1.0,
            z: 1.0
        };
        this.color = {
            r: 1.0,
            g: 1.0,
            b: 1.0,
            a: 1.0
        };
    }
    /**
     * Starts an animation
     * @param from defines the initial key
     * @param to defines the end key
     * @param loop defines if the animation must loop
     * @param delay defines the start delay (in ms)
     * @param onAnimationEnd defines a callback for when the animation ends
     */ playAnimation(from, to, loop, delay, onAnimationEnd) {
        this._fromIndex = from;
        this._toIndex = to;
        this._loopAnimation = loop;
        this._delay = delay || 1;
        this._animationStarted = true;
        this._onBaseAnimationEnd = onAnimationEnd;
        if (from < to) this._direction = 1;
        else {
            this._direction = -1;
            this._toIndex = from;
            this._fromIndex = to;
        }
        this.cellIndex = from;
        this._time = 0;
    }
    /** Stops current animation (if any) */ stopAnimation() {
        this._animationStarted = false;
    }
    /**
     * @internal
     */ _animate(deltaTime) {
        if (!this._animationStarted) return;
        this._time += deltaTime;
        if (this._time > this._delay) {
            this._time = this._time % this._delay;
            this.cellIndex += this._direction;
            if (this._direction > 0 && this.cellIndex > this._toIndex || this._direction < 0 && this.cellIndex < this._fromIndex) {
                if (this._loopAnimation) this.cellIndex = this._direction > 0 ? this._fromIndex : this._toIndex;
                else {
                    this.cellIndex = this._toIndex;
                    this._animationStarted = false;
                    if (this._onBaseAnimationEnd) this._onBaseAnimationEnd();
                }
            }
        }
    }
}

});


parcelRegister("3mCyn", function(module, exports) {

$parcel$export(module.exports, "SpriteSceneComponent", () => $273155118ff22b06$export$430bc3912f5d9da9);

var $diGQf = parcelRequire("diGQf");

var $gmbCk = parcelRequire("gmbCk");

var $3kez7 = parcelRequire("3kez7");

var $gzCma = parcelRequire("gzCma");

var $bv05l = parcelRequire("bv05l");

var $cmj0B = parcelRequire("cmj0B");
(0, $gmbCk.Scene).prototype._internalPickSprites = function(ray, predicate, fastCheck, camera) {
    if (!(0, $gzCma.PickingInfo)) return null;
    let pickingInfo = null;
    if (!camera) {
        if (!this.activeCamera) return null;
        camera = this.activeCamera;
    }
    if (this.spriteManagers && this.spriteManagers.length > 0) for(let spriteIndex = 0; spriteIndex < this.spriteManagers.length; spriteIndex++){
        const spriteManager = this.spriteManagers[spriteIndex];
        if (!spriteManager.isPickable) continue;
        const result = spriteManager.intersects(ray, camera, predicate, fastCheck);
        if (!result || !result.hit) continue;
        if (!fastCheck && pickingInfo != null && result.distance >= pickingInfo.distance) continue;
        pickingInfo = result;
        if (fastCheck) break;
    }
    return pickingInfo || new (0, $gzCma.PickingInfo)();
};
(0, $gmbCk.Scene).prototype._internalMultiPickSprites = function(ray, predicate, camera) {
    if (!(0, $gzCma.PickingInfo)) return null;
    let pickingInfos = [];
    if (!camera) {
        if (!this.activeCamera) return null;
        camera = this.activeCamera;
    }
    if (this.spriteManagers && this.spriteManagers.length > 0) for(let spriteIndex = 0; spriteIndex < this.spriteManagers.length; spriteIndex++){
        const spriteManager = this.spriteManagers[spriteIndex];
        if (!spriteManager.isPickable) continue;
        const results = spriteManager.multiIntersects(ray, camera, predicate);
        if (results !== null) pickingInfos = pickingInfos.concat(results);
    }
    return pickingInfos;
};
(0, $gmbCk.Scene).prototype.pickSprite = function(x, y, predicate, fastCheck, camera) {
    if (!this._tempSpritePickingRay) return null;
    this.createPickingRayInCameraSpaceToRef(x, y, this._tempSpritePickingRay, camera);
    const result = this._internalPickSprites(this._tempSpritePickingRay, predicate, fastCheck, camera);
    if (result) result.ray = this.createPickingRayInCameraSpace(x, y, camera);
    return result;
};
(0, $gmbCk.Scene).prototype.pickSpriteWithRay = function(ray, predicate, fastCheck, camera) {
    if (!this._tempSpritePickingRay) return null;
    if (!camera) {
        if (!this.activeCamera) return null;
        camera = this.activeCamera;
    }
    (0, $3kez7.Ray).TransformToRef(ray, camera.getViewMatrix(), this._tempSpritePickingRay);
    const result = this._internalPickSprites(this._tempSpritePickingRay, predicate, fastCheck, camera);
    if (result) result.ray = ray;
    return result;
};
(0, $gmbCk.Scene).prototype.multiPickSprite = function(x, y, predicate, camera) {
    this.createPickingRayInCameraSpaceToRef(x, y, this._tempSpritePickingRay, camera);
    return this._internalMultiPickSprites(this._tempSpritePickingRay, predicate, camera);
};
(0, $gmbCk.Scene).prototype.multiPickSpriteWithRay = function(ray, predicate, camera) {
    if (!this._tempSpritePickingRay) return null;
    if (!camera) {
        if (!this.activeCamera) return null;
        camera = this.activeCamera;
    }
    (0, $3kez7.Ray).TransformToRef(ray, camera.getViewMatrix(), this._tempSpritePickingRay);
    return this._internalMultiPickSprites(this._tempSpritePickingRay, predicate, camera);
};
(0, $gmbCk.Scene).prototype.setPointerOverSprite = function(sprite) {
    if (this._pointerOverSprite === sprite) return;
    if (this._pointerOverSprite && this._pointerOverSprite.actionManager) this._pointerOverSprite.actionManager.processTrigger(10, (0, $cmj0B.ActionEvent).CreateNewFromSprite(this._pointerOverSprite, this));
    this._pointerOverSprite = sprite;
    if (this._pointerOverSprite && this._pointerOverSprite.actionManager) this._pointerOverSprite.actionManager.processTrigger(9, (0, $cmj0B.ActionEvent).CreateNewFromSprite(this._pointerOverSprite, this));
};
(0, $gmbCk.Scene).prototype.getPointerOverSprite = function() {
    return this._pointerOverSprite;
};
class $273155118ff22b06$export$430bc3912f5d9da9 {
    /**
     * Creates a new instance of the component for the given scene
     * @param scene Defines the scene to register the component in
     */ constructor(scene){
        /**
         * The component name helpfull to identify the component in the list of scene components.
         */ this.name = (0, $bv05l.SceneComponentConstants).NAME_SPRITE;
        this.scene = scene;
        this.scene.spriteManagers = [];
        this.scene._tempSpritePickingRay = (0, $3kez7.Ray) ? (0, $3kez7.Ray).Zero() : null;
        this.scene.onBeforeSpritesRenderingObservable = new (0, $diGQf.Observable)();
        this.scene.onAfterSpritesRenderingObservable = new (0, $diGQf.Observable)();
        this._spritePredicate = (sprite)=>{
            if (!sprite.actionManager) return false;
            return sprite.isPickable && sprite.actionManager.hasPointerTriggers;
        };
    }
    /**
     * Registers the component in a given scene
     */ register() {
        this.scene._pointerMoveStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_POINTERMOVE_SPRITE, this, this._pointerMove);
        this.scene._pointerDownStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_POINTERDOWN_SPRITE, this, this._pointerDown);
        this.scene._pointerUpStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_POINTERUP_SPRITE, this, this._pointerUp);
    }
    /**
     * Rebuilds the elements related to this component in case of
     * context lost for instance.
     */ rebuild() {
    /** Nothing to do for sprites */ }
    /**
     * Disposes the component and the associated resources.
     */ dispose() {
        this.scene.onBeforeSpritesRenderingObservable.clear();
        this.scene.onAfterSpritesRenderingObservable.clear();
        const spriteManagers = this.scene.spriteManagers;
        if (!spriteManagers) return;
        while(spriteManagers.length)spriteManagers[0].dispose();
    }
    _pickSpriteButKeepRay(originalPointerInfo, x, y, fastCheck, camera) {
        const result = this.scene.pickSprite(x, y, this._spritePredicate, fastCheck, camera);
        if (result) result.ray = originalPointerInfo ? originalPointerInfo.ray : null;
        return result;
    }
    _pointerMove(unTranslatedPointerX, unTranslatedPointerY, pickResult, isMeshPicked, element) {
        const scene = this.scene;
        if (isMeshPicked) scene.setPointerOverSprite(null);
        else {
            pickResult = this._pickSpriteButKeepRay(pickResult, unTranslatedPointerX, unTranslatedPointerY, false, scene.cameraToUseForPointers || undefined);
            if (pickResult && pickResult.hit && pickResult.pickedSprite) {
                scene.setPointerOverSprite(pickResult.pickedSprite);
                if (!scene.doNotHandleCursors && element) {
                    if (scene._pointerOverSprite && scene._pointerOverSprite.actionManager && scene._pointerOverSprite.actionManager.hoverCursor) element.style.cursor = scene._pointerOverSprite.actionManager.hoverCursor;
                    else element.style.cursor = scene.hoverCursor;
                }
            } else scene.setPointerOverSprite(null);
        }
        return pickResult;
    }
    _pointerDown(unTranslatedPointerX, unTranslatedPointerY, pickResult, evt) {
        const scene = this.scene;
        scene._pickedDownSprite = null;
        if (scene.spriteManagers && scene.spriteManagers.length > 0) {
            pickResult = scene.pickSprite(unTranslatedPointerX, unTranslatedPointerY, this._spritePredicate, false, scene.cameraToUseForPointers || undefined);
            if (pickResult && pickResult.hit && pickResult.pickedSprite) {
                if (pickResult.pickedSprite.actionManager) {
                    scene._pickedDownSprite = pickResult.pickedSprite;
                    switch(evt.button){
                        case 0:
                            pickResult.pickedSprite.actionManager.processTrigger(2, (0, $cmj0B.ActionEvent).CreateNewFromSprite(pickResult.pickedSprite, scene, evt));
                            break;
                        case 1:
                            pickResult.pickedSprite.actionManager.processTrigger(4, (0, $cmj0B.ActionEvent).CreateNewFromSprite(pickResult.pickedSprite, scene, evt));
                            break;
                        case 2:
                            pickResult.pickedSprite.actionManager.processTrigger(3, (0, $cmj0B.ActionEvent).CreateNewFromSprite(pickResult.pickedSprite, scene, evt));
                            break;
                    }
                    if (pickResult.pickedSprite.actionManager) pickResult.pickedSprite.actionManager.processTrigger(5, (0, $cmj0B.ActionEvent).CreateNewFromSprite(pickResult.pickedSprite, scene, evt));
                }
            }
        }
        return pickResult;
    }
    _pointerUp(unTranslatedPointerX, unTranslatedPointerY, pickResult, evt, doubleClick) {
        const scene = this.scene;
        if (scene.spriteManagers && scene.spriteManagers.length > 0) {
            const spritePickResult = scene.pickSprite(unTranslatedPointerX, unTranslatedPointerY, this._spritePredicate, false, scene.cameraToUseForPointers || undefined);
            if (spritePickResult) {
                if (spritePickResult.hit && spritePickResult.pickedSprite) {
                    if (spritePickResult.pickedSprite.actionManager) {
                        spritePickResult.pickedSprite.actionManager.processTrigger(7, (0, $cmj0B.ActionEvent).CreateNewFromSprite(spritePickResult.pickedSprite, scene, evt));
                        if (spritePickResult.pickedSprite.actionManager) {
                            if (!this.scene._inputManager._isPointerSwiping()) spritePickResult.pickedSprite.actionManager.processTrigger(1, (0, $cmj0B.ActionEvent).CreateNewFromSprite(spritePickResult.pickedSprite, scene, evt));
                            if (doubleClick) spritePickResult.pickedSprite.actionManager.processTrigger(6, (0, $cmj0B.ActionEvent).CreateNewFromSprite(spritePickResult.pickedSprite, scene, evt));
                        }
                    }
                }
                if (scene._pickedDownSprite && scene._pickedDownSprite.actionManager && scene._pickedDownSprite !== spritePickResult.pickedSprite) scene._pickedDownSprite.actionManager.processTrigger(16, (0, $cmj0B.ActionEvent).CreateNewFromSprite(scene._pickedDownSprite, scene, evt));
            }
        }
        return pickResult;
    }
}

});

parcelRegister("6o5NX", function(module, exports) {

$parcel$export(module.exports, "SpriteRenderer", () => $4a697ca78f83a18a$export$9c73b00b522dbb1a);

var $b4i1f = parcelRequire("b4i1f");

var $hOyoX = parcelRequire("hOyoX");
parcelRequire("emm58");
parcelRequire("7G59J");
parcelRequire("6ThfD");
parcelRequire("2R21O");
class $4a697ca78f83a18a$export$9c73b00b522dbb1a {
    /**
     * Gets the capacity of the manager
     */ get capacity() {
        return this._capacity;
    }
    /**
     * Gets or sets a boolean indicating if the renderer must render sprites with pixel perfect rendering
     * Note that pixel perfect mode is not supported in WebGL 1
     */ get pixelPerfect() {
        return this._pixelPerfect;
    }
    set pixelPerfect(value) {
        if (this._pixelPerfect === value) return;
        this._pixelPerfect = value;
        this._createEffects();
    }
    /**
     * Creates a new sprite Renderer
     * @param engine defines the engine the renderer works with
     * @param capacity defines the maximum allowed number of sprites
     * @param epsilon defines the epsilon value to align texture (0.01 by default)
     * @param scene defines the hosting scene
     */ constructor(engine, capacity, epsilon = 0.01, scene = null){
        /**
         * Blend mode use to render the particle, it can be any of
         * the static undefined properties provided in this class.
         * Default value is 2
         */ this.blendMode = 2;
        /**
         * Gets or sets a boolean indicating if alpha mode is automatically
         * reset.
         */ this.autoResetAlpha = true;
        /**
         * Disables writing to the depth buffer when rendering the sprites.
         * It can be handy to disable depth writing when using textures without alpha channel
         * and setting some specific blend modes.
         */ this.disableDepthWrite = false;
        /**
         * Gets or sets a boolean indicating if the manager must consider scene fog when rendering
         */ this.fogEnabled = true;
        this._pixelPerfect = false;
        this._useVAO = false;
        this._useInstancing = false;
        this._vertexBuffers = {};
        this._capacity = capacity;
        this._epsilon = epsilon;
        this._engine = engine;
        this._useInstancing = engine.getCaps().instancedArrays && engine._features.supportSpriteInstancing;
        this._useVAO = engine.getCaps().vertexArrayObject && !engine.disableVertexArrayObjects;
        this._scene = scene;
        if (!this._useInstancing) this._buildIndexBuffer();
        // VBO
        // 18 floats per sprite (x, y, z, angle, sizeX, sizeY, offsetX, offsetY, invertU, invertV, cellLeft, cellTop, cellWidth, cellHeight, color r, color g, color b, color a)
        // 16 when using instances
        this._vertexBufferSize = this._useInstancing ? 16 : 18;
        this._vertexData = new Float32Array(capacity * this._vertexBufferSize * (this._useInstancing ? 1 : 4));
        this._buffer = new (0, $b4i1f.Buffer)(engine, this._vertexData, true, this._vertexBufferSize);
        const positions = this._buffer.createVertexBuffer((0, $b4i1f.VertexBuffer).PositionKind, 0, 4, this._vertexBufferSize, this._useInstancing);
        const options = this._buffer.createVertexBuffer("options", 4, 2, this._vertexBufferSize, this._useInstancing);
        let offset = 6;
        let offsets;
        if (this._useInstancing) {
            const spriteData = new Float32Array([
                0,
                0,
                1,
                0,
                0,
                1,
                1,
                1
            ]);
            this._spriteBuffer = new (0, $b4i1f.Buffer)(engine, spriteData, false, 2);
            offsets = this._spriteBuffer.createVertexBuffer("offsets", 0, 2);
        } else {
            offsets = this._buffer.createVertexBuffer("offsets", offset, 2, this._vertexBufferSize, this._useInstancing);
            offset += 2;
        }
        const inverts = this._buffer.createVertexBuffer("inverts", offset, 2, this._vertexBufferSize, this._useInstancing);
        const cellInfo = this._buffer.createVertexBuffer("cellInfo", offset + 2, 4, this._vertexBufferSize, this._useInstancing);
        const colors = this._buffer.createVertexBuffer((0, $b4i1f.VertexBuffer).ColorKind, offset + 6, 4, this._vertexBufferSize, this._useInstancing);
        this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind] = positions;
        this._vertexBuffers["options"] = options;
        this._vertexBuffers["offsets"] = offsets;
        this._vertexBuffers["inverts"] = inverts;
        this._vertexBuffers["cellInfo"] = cellInfo;
        this._vertexBuffers[(0, $b4i1f.VertexBuffer).ColorKind] = colors;
        this._createEffects();
    }
    _createEffects() {
        this._drawWrapperBase?.dispose();
        this._drawWrapperFog?.dispose();
        this._drawWrapperDepth?.dispose();
        this._drawWrapperFogDepth?.dispose();
        this._drawWrapperBase = new (0, $hOyoX.DrawWrapper)(this._engine);
        this._drawWrapperFog = new (0, $hOyoX.DrawWrapper)(this._engine);
        this._drawWrapperDepth = new (0, $hOyoX.DrawWrapper)(this._engine, false);
        this._drawWrapperFogDepth = new (0, $hOyoX.DrawWrapper)(this._engine, false);
        if (this._drawWrapperBase.drawContext) this._drawWrapperBase.drawContext.useInstancing = this._useInstancing;
        if (this._drawWrapperFog.drawContext) this._drawWrapperFog.drawContext.useInstancing = this._useInstancing;
        if (this._drawWrapperDepth.drawContext) this._drawWrapperDepth.drawContext.useInstancing = this._useInstancing;
        if (this._drawWrapperFogDepth.drawContext) this._drawWrapperFogDepth.drawContext.useInstancing = this._useInstancing;
        const defines = this._pixelPerfect ? "#define PIXEL_PERFECT\n" : "";
        this._drawWrapperBase.effect = this._engine.createEffect("sprites", [
            (0, $b4i1f.VertexBuffer).PositionKind,
            "options",
            "offsets",
            "inverts",
            "cellInfo",
            (0, $b4i1f.VertexBuffer).ColorKind
        ], [
            "view",
            "projection",
            "textureInfos",
            "alphaTest"
        ], [
            "diffuseSampler"
        ], defines);
        this._drawWrapperDepth.effect = this._drawWrapperBase.effect;
        this._drawWrapperDepth.materialContext = this._drawWrapperBase.materialContext;
        if (this._scene) {
            this._drawWrapperFog.effect = this._scene.getEngine().createEffect("sprites", [
                (0, $b4i1f.VertexBuffer).PositionKind,
                "options",
                "offsets",
                "inverts",
                "cellInfo",
                (0, $b4i1f.VertexBuffer).ColorKind
            ], [
                "view",
                "projection",
                "textureInfos",
                "alphaTest",
                "vFogInfos",
                "vFogColor"
            ], [
                "diffuseSampler"
            ], defines + "#define FOG");
            this._drawWrapperFogDepth.effect = this._drawWrapperFog.effect;
            this._drawWrapperFogDepth.materialContext = this._drawWrapperFog.materialContext;
        }
    }
    /**
     * Render all child sprites
     * @param sprites defines the list of sprites to render
     * @param deltaTime defines the time since last frame
     * @param viewMatrix defines the viewMatrix to use to render the sprites
     * @param projectionMatrix defines the projectionMatrix to use to render the sprites
     * @param customSpriteUpdate defines a custom function to update the sprites data before they render
     */ render(sprites, deltaTime, viewMatrix, projectionMatrix, customSpriteUpdate = null) {
        if (!this.texture || !this.texture.isReady() || !sprites.length) return;
        let drawWrapper = this._drawWrapperBase;
        let drawWrapperDepth = this._drawWrapperDepth;
        let shouldRenderFog = false;
        if (this.fogEnabled && this._scene && this._scene.fogEnabled && this._scene.fogMode !== 0) {
            drawWrapper = this._drawWrapperFog;
            drawWrapperDepth = this._drawWrapperFogDepth;
            shouldRenderFog = true;
        }
        const effect = drawWrapper.effect;
        // Check
        if (!effect.isReady()) return;
        const engine = this._engine;
        const useRightHandedSystem = !!(this._scene && this._scene.useRightHandedSystem);
        const baseSize = this.texture.getBaseSize();
        // Sprites
        const max = Math.min(this._capacity, sprites.length);
        let offset = 0;
        let noSprite = true;
        for(let index = 0; index < max; index++){
            const sprite = sprites[index];
            if (!sprite || !sprite.isVisible) continue;
            noSprite = false;
            sprite._animate(deltaTime);
            this._appendSpriteVertex(offset++, sprite, 0, 0, baseSize, useRightHandedSystem, customSpriteUpdate);
            if (!this._useInstancing) {
                this._appendSpriteVertex(offset++, sprite, 1, 0, baseSize, useRightHandedSystem, customSpriteUpdate);
                this._appendSpriteVertex(offset++, sprite, 1, 1, baseSize, useRightHandedSystem, customSpriteUpdate);
                this._appendSpriteVertex(offset++, sprite, 0, 1, baseSize, useRightHandedSystem, customSpriteUpdate);
            }
        }
        if (noSprite) return;
        this._buffer.update(this._vertexData);
        const culling = !!engine.depthCullingState.cull;
        const zOffset = engine.depthCullingState.zOffset;
        const zOffsetUnits = engine.depthCullingState.zOffsetUnits;
        engine.setState(culling, zOffset, false, false, undefined, undefined, zOffsetUnits);
        // Render
        engine.enableEffect(drawWrapper);
        effect.setTexture("diffuseSampler", this.texture);
        effect.setMatrix("view", viewMatrix);
        effect.setMatrix("projection", projectionMatrix);
        // Scene Info
        if (shouldRenderFog) {
            const scene = this._scene;
            // Fog
            effect.setFloat4("vFogInfos", scene.fogMode, scene.fogStart, scene.fogEnd, scene.fogDensity);
            effect.setColor3("vFogColor", scene.fogColor);
        }
        if (this._useVAO) {
            if (!this._vertexArrayObject) this._vertexArrayObject = engine.recordVertexArrayObject(this._vertexBuffers, this._indexBuffer, effect);
            engine.bindVertexArrayObject(this._vertexArrayObject, this._indexBuffer);
        } else // VBOs
        engine.bindBuffers(this._vertexBuffers, this._indexBuffer, effect);
        // Draw order
        engine.depthCullingState.depthFunc = engine.useReverseDepthBuffer ? 518 : 515;
        if (!this.disableDepthWrite) {
            effect.setBool("alphaTest", true);
            engine.setColorWrite(false);
            engine.enableEffect(drawWrapperDepth);
            if (this._useInstancing) engine.drawArraysType(7, 0, 4, offset);
            else engine.drawElementsType(0, 0, offset / 4 * 6);
            engine.enableEffect(drawWrapper);
            engine.setColorWrite(true);
            effect.setBool("alphaTest", false);
        }
        engine.setAlphaMode(this.blendMode);
        if (this._useInstancing) engine.drawArraysType(7, 0, 4, offset);
        else engine.drawElementsType(0, 0, offset / 4 * 6);
        if (this.autoResetAlpha) engine.setAlphaMode(0);
        // Restore Right Handed
        if (useRightHandedSystem) this._scene.getEngine().setState(culling, zOffset, false, true, undefined, undefined, zOffsetUnits);
        engine.unbindInstanceAttributes();
    }
    _appendSpriteVertex(index, sprite, offsetX, offsetY, baseSize, useRightHandedSystem, customSpriteUpdate) {
        let arrayOffset = index * this._vertexBufferSize;
        if (offsetX === 0) offsetX = this._epsilon;
        else if (offsetX === 1) offsetX = 1 - this._epsilon;
        if (offsetY === 0) offsetY = this._epsilon;
        else if (offsetY === 1) offsetY = 1 - this._epsilon;
        if (customSpriteUpdate) customSpriteUpdate(sprite, baseSize);
        else {
            if (!sprite.cellIndex) sprite.cellIndex = 0;
            const rowSize = baseSize.width / this.cellWidth;
            const offset = sprite.cellIndex / rowSize >> 0;
            sprite._xOffset = (sprite.cellIndex - offset * rowSize) * this.cellWidth / baseSize.width;
            sprite._yOffset = offset * this.cellHeight / baseSize.height;
            sprite._xSize = this.cellWidth;
            sprite._ySize = this.cellHeight;
        }
        // Positions
        this._vertexData[arrayOffset] = sprite.position.x;
        this._vertexData[arrayOffset + 1] = sprite.position.y;
        this._vertexData[arrayOffset + 2] = sprite.position.z;
        this._vertexData[arrayOffset + 3] = sprite.angle;
        // Options
        this._vertexData[arrayOffset + 4] = sprite.width;
        this._vertexData[arrayOffset + 5] = sprite.height;
        if (!this._useInstancing) {
            this._vertexData[arrayOffset + 6] = offsetX;
            this._vertexData[arrayOffset + 7] = offsetY;
        } else arrayOffset -= 2;
        // Inverts according to Right Handed
        if (useRightHandedSystem) this._vertexData[arrayOffset + 8] = sprite.invertU ? 0 : 1;
        else this._vertexData[arrayOffset + 8] = sprite.invertU ? 1 : 0;
        this._vertexData[arrayOffset + 9] = sprite.invertV ? 1 : 0;
        this._vertexData[arrayOffset + 10] = sprite._xOffset;
        this._vertexData[arrayOffset + 11] = sprite._yOffset;
        this._vertexData[arrayOffset + 12] = sprite._xSize / baseSize.width;
        this._vertexData[arrayOffset + 13] = sprite._ySize / baseSize.height;
        // Color
        this._vertexData[arrayOffset + 14] = sprite.color.r;
        this._vertexData[arrayOffset + 15] = sprite.color.g;
        this._vertexData[arrayOffset + 16] = sprite.color.b;
        this._vertexData[arrayOffset + 17] = sprite.color.a;
    }
    _buildIndexBuffer() {
        const indices = [];
        let index = 0;
        for(let count = 0; count < this._capacity; count++){
            indices.push(index);
            indices.push(index + 1);
            indices.push(index + 2);
            indices.push(index);
            indices.push(index + 2);
            indices.push(index + 3);
            index += 4;
        }
        this._indexBuffer = this._engine.createIndexBuffer(indices);
    }
    /**
     * Rebuilds the renderer (after a context lost, for eg)
     */ rebuild() {
        if (this._indexBuffer) this._buildIndexBuffer();
        if (this._useVAO) this._vertexArrayObject = undefined;
        this._buffer._rebuild();
        for(const key in this._vertexBuffers){
            const vertexBuffer = this._vertexBuffers[key];
            vertexBuffer._rebuild();
        }
        this._spriteBuffer?._rebuild();
    }
    /**
     * Release associated resources
     */ dispose() {
        if (this._buffer) {
            this._buffer.dispose();
            this._buffer = null;
        }
        if (this._spriteBuffer) {
            this._spriteBuffer.dispose();
            this._spriteBuffer = null;
        }
        if (this._indexBuffer) {
            this._engine._releaseBuffer(this._indexBuffer);
            this._indexBuffer = null;
        }
        if (this._vertexArrayObject) {
            this._engine.releaseVertexArrayObject(this._vertexArrayObject);
            this._vertexArrayObject = null;
        }
        if (this.texture) {
            this.texture.dispose();
            this.texture = null;
        }
        this._drawWrapperBase.dispose();
        this._drawWrapperFog.dispose();
        this._drawWrapperDepth.dispose();
        this._drawWrapperFogDepth.dispose();
    }
}

});
parcelRegister("6ThfD", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("hvLF9");
parcelRequire("110hr");
parcelRequire("dCyNy");
const $504542dd99d8c53e$var$name = "spritesPixelShader";
const $504542dd99d8c53e$var$shader = `uniform bool alphaTest;varying vec4 vColor;varying vec2 vUV;uniform sampler2D diffuseSampler;
#include<fogFragmentDeclaration>
#define CUSTOM_FRAGMENT_DEFINITIONS
#ifdef PIXEL_PERFECT
vec2 uvPixelPerfect(vec2 uv) {vec2 res=vec2(textureSize(diffuseSampler,0));uv=uv*res;vec2 seam=floor(uv+0.5);uv=seam+clamp((uv-seam)/fwidth(uv),-0.5,0.5);return uv/res;}
#endif
void main(void) {
#define CUSTOM_FRAGMENT_MAIN_BEGIN
#ifdef PIXEL_PERFECT
vec2 uv=uvPixelPerfect(vUV);
#else
vec2 uv=vUV;
#endif
vec4 color=texture2D(diffuseSampler,uv);float fAlphaTest=float(alphaTest);if (fAlphaTest != 0.)
{if (color.a<0.95)
discard;}
color*=vColor;
#include<fogFragment>
gl_FragColor=color;
#include<imageProcessingCompatibility>
#define CUSTOM_FRAGMENT_MAIN_END
}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$504542dd99d8c53e$var$name] = $504542dd99d8c53e$var$shader;
const $504542dd99d8c53e$export$b23875f353696a2b = {
    name: $504542dd99d8c53e$var$name,
    shader: $504542dd99d8c53e$var$shader
};

});
parcelRegister("dCyNy", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $9ea9d12ce9f347fb$var$name = "imageProcessingCompatibility";
const $9ea9d12ce9f347fb$var$shader = `#ifdef IMAGEPROCESSINGPOSTPROCESS
gl_FragColor.rgb=pow(gl_FragColor.rgb,vec3(2.2));
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$9ea9d12ce9f347fb$var$name] = $9ea9d12ce9f347fb$var$shader;
const $9ea9d12ce9f347fb$export$80ea1778dabadb3 = {
    name: $9ea9d12ce9f347fb$var$name,
    shader: $9ea9d12ce9f347fb$var$shader
};

});


parcelRegister("2R21O", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("bdABV");
const $21421ac9619a9d18$var$name = "spritesVertexShader";
const $21421ac9619a9d18$var$shader = `attribute vec4 position;attribute vec2 options;attribute vec2 offsets;attribute vec2 inverts;attribute vec4 cellInfo;attribute vec4 color;uniform mat4 view;uniform mat4 projection;varying vec2 vUV;varying vec4 vColor;
#include<fogVertexDeclaration>
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
vec3 viewPos=(view*vec4(position.xyz,1.0)).xyz; 
vec2 cornerPos;float angle=position.w;vec2 size=vec2(options.x,options.y);vec2 offset=offsets.xy;cornerPos=vec2(offset.x-0.5,offset.y -0.5)*size;vec3 rotatedCorner;rotatedCorner.x=cornerPos.x*cos(angle)-cornerPos.y*sin(angle);rotatedCorner.y=cornerPos.x*sin(angle)+cornerPos.y*cos(angle);rotatedCorner.z=0.;viewPos+=rotatedCorner;gl_Position=projection*vec4(viewPos,1.0); 
vColor=color;vec2 uvOffset=vec2(abs(offset.x-inverts.x),abs(1.0-offset.y-inverts.y));vec2 uvPlace=cellInfo.xy;vec2 uvSize=cellInfo.zw;vUV.x=uvPlace.x+uvSize.x*uvOffset.x;vUV.y=uvPlace.y+uvSize.y*uvOffset.y;
#ifdef FOG
vFogDistance=viewPos;
#endif
#define CUSTOM_VERTEX_MAIN_END
}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$21421ac9619a9d18$var$name] = $21421ac9619a9d18$var$shader;
const $21421ac9619a9d18$export$6c9bf7053da206b5 = {
    name: $21421ac9619a9d18$var$name,
    shader: $21421ac9619a9d18$var$shader
};

});






parcelRegister("hHnf3", function(module, exports) {
/* eslint-disable import/no-internal-modules */ 
var $3tzuN = parcelRequire("3tzuN");

var $eVS9r = parcelRequire("eVS9r");

var $EbTSE = parcelRequire("EbTSE");

var $gc8Ja = parcelRequire("gc8Ja");

var $lUDWq = parcelRequire("lUDWq");

var $LKxRV = parcelRequire("LKxRV");

var $dG1pf = parcelRequire("dG1pf");

var $54229 = parcelRequire("54229");

var $35xmP = parcelRequire("35xmP");

var $aAFeM = parcelRequire("aAFeM");

var $2RkJE = parcelRequire("2RkJE");

var $3zFLd = parcelRequire("3zFLd");

var $2tXqH = parcelRequire("2tXqH");

var $bZsq9 = parcelRequire("bZsq9");

var $atHN2 = parcelRequire("atHN2");

var $8WI3I = parcelRequire("8WI3I");

var $4I7rl = parcelRequire("4I7rl");

var $gAH3H = parcelRequire("gAH3H");

var $gGwWu = parcelRequire("gGwWu");

var $ghoTi = parcelRequire("ghoTi");

var $2hKx5 = parcelRequire("2hKx5");

var $1ZqT6 = parcelRequire("1ZqT6");

var $iYGpr = parcelRequire("iYGpr");

var $au7qz = parcelRequire("au7qz");

var $hOyoX = parcelRequire("hOyoX");

var $8XNAC = parcelRequire("8XNAC");

var $hvV64 = parcelRequire("hvV64");

var $7HBDq = parcelRequire("7HBDq");

var $bRVvK = parcelRequire("bRVvK");

var $96fF1 = parcelRequire("96fF1");

var $3U64T = parcelRequire("3U64T");

var $heA9x = parcelRequire("heA9x");

var $hExvk = parcelRequire("hExvk");

var $bZbGh = parcelRequire("bZbGh");

var $7LG5O = parcelRequire("7LG5O");

var $7Fvtq = parcelRequire("7Fvtq");

var $6wUCE = parcelRequire("6wUCE");

var $alPCh = parcelRequire("alPCh");
parcelRequire("1OwjH");
$parcel$exportWildcard(module.exports, $3tzuN);
$parcel$exportWildcard(module.exports, $eVS9r);
$parcel$exportWildcard(module.exports, $EbTSE);
$parcel$exportWildcard(module.exports, $gc8Ja);
$parcel$exportWildcard(module.exports, $lUDWq);
$parcel$exportWildcard(module.exports, $LKxRV);
$parcel$exportWildcard(module.exports, $dG1pf);
$parcel$exportWildcard(module.exports, $54229);
$parcel$exportWildcard(module.exports, $35xmP);
$parcel$exportWildcard(module.exports, $aAFeM);
$parcel$exportWildcard(module.exports, $2RkJE);
$parcel$exportWildcard(module.exports, $3zFLd);
$parcel$exportWildcard(module.exports, $2tXqH);
$parcel$exportWildcard(module.exports, $bZsq9);
$parcel$exportWildcard(module.exports, $atHN2);
$parcel$exportWildcard(module.exports, $8WI3I);
$parcel$exportWildcard(module.exports, $4I7rl);
$parcel$exportWildcard(module.exports, $gAH3H);
$parcel$exportWildcard(module.exports, $gGwWu);
$parcel$exportWildcard(module.exports, $ghoTi);
$parcel$exportWildcard(module.exports, $2hKx5);
$parcel$exportWildcard(module.exports, $1ZqT6);
$parcel$exportWildcard(module.exports, $iYGpr);
$parcel$exportWildcard(module.exports, $au7qz);
$parcel$exportWildcard(module.exports, $hOyoX);
$parcel$exportWildcard(module.exports, $8XNAC);
$parcel$exportWildcard(module.exports, $hvV64);
$parcel$exportWildcard(module.exports, $7HBDq);
$parcel$exportWildcard(module.exports, $bRVvK);
$parcel$exportWildcard(module.exports, $96fF1);
$parcel$exportWildcard(module.exports, $3U64T);
$parcel$exportWildcard(module.exports, $heA9x);
$parcel$exportWildcard(module.exports, $hExvk);
$parcel$exportWildcard(module.exports, $bZbGh);
$parcel$exportWildcard(module.exports, $7LG5O);
$parcel$exportWildcard(module.exports, $7Fvtq);
$parcel$exportWildcard(module.exports, $6wUCE);
$parcel$exportWildcard(module.exports, $alPCh);

});
parcelRegister("3tzuN", function(module, exports) {

var $fZkIz = parcelRequire("fZkIz");
$parcel$exportWildcard(module.exports, $fZkIz);

});

parcelRegister("EbTSE", function(module, exports) {

});

parcelRegister("LKxRV", function(module, exports) {

$parcel$export(module.exports, "FresnelParameters", () => $08f87ed26b8946a4$export$ead2cdea5a43d2d2);

var $fhgis = parcelRequire("fhgis");

var $7etnY = parcelRequire("7etnY");

var $5YkyR = parcelRequire("5YkyR");

var $6Ho1L = parcelRequire("6Ho1L");
class $08f87ed26b8946a4$export$ead2cdea5a43d2d2 {
    /**
     * Define if the fresnel effect is enable or not.
     */ get isEnabled() {
        return this._isEnabled;
    }
    set isEnabled(value) {
        if (this._isEnabled === value) return;
        this._isEnabled = value;
        (0, $5YkyR.Engine).MarkAllMaterialsAsDirty(20);
    }
    /**
     * Creates a new FresnelParameters object.
     *
     * @param options provide your own settings to optionally to override defaults
     */ constructor(options = {}){
        this._isEnabled = true;
        this.bias = options.bias === undefined ? 0 : options.bias;
        this.power = options.power === undefined ? 1 : options.power;
        this.leftColor = options.leftColor || (0, $7etnY.Color3).White();
        this.rightColor = options.rightColor || (0, $7etnY.Color3).Black();
        if (options.isEnabled === false) this.isEnabled = false;
    }
    /**
     * Clones the current fresnel and its values
     * @returns a clone fresnel configuration
     */ clone() {
        const newFresnelParameters = new $08f87ed26b8946a4$export$ead2cdea5a43d2d2();
        (0, $fhgis.DeepCopier).DeepCopy(this, newFresnelParameters);
        return newFresnelParameters;
    }
    /**
     * Determines equality between FresnelParameters objects
     * @param otherFresnelParameters defines the second operand
     * @returns true if the power, bias, leftColor, rightColor and isEnabled values are equal to the given ones
     */ equals(otherFresnelParameters) {
        return otherFresnelParameters && this.bias === otherFresnelParameters.bias && this.power === otherFresnelParameters.power && this.leftColor.equals(otherFresnelParameters.leftColor) && this.rightColor.equals(otherFresnelParameters.rightColor) && this.isEnabled === otherFresnelParameters.isEnabled;
    }
    /**
     * Serializes the current fresnel parameters to a JSON representation.
     * @returns the JSON serialization
     */ serialize() {
        return {
            isEnabled: this.isEnabled,
            leftColor: this.leftColor.asArray(),
            rightColor: this.rightColor.asArray(),
            bias: this.bias,
            power: this.power
        };
    }
    /**
     * Parse a JSON object and deserialize it to a new Fresnel parameter object.
     * @param parsedFresnelParameters Define the JSON representation
     * @returns the parsed parameters
     */ static Parse(parsedFresnelParameters) {
        return new $08f87ed26b8946a4$export$ead2cdea5a43d2d2({
            isEnabled: parsedFresnelParameters.isEnabled,
            leftColor: (0, $7etnY.Color3).FromArray(parsedFresnelParameters.leftColor),
            rightColor: (0, $7etnY.Color3).FromArray(parsedFresnelParameters.rightColor),
            bias: parsedFresnelParameters.bias,
            power: parsedFresnelParameters.power || 1.0
        });
    }
}
// References the dependencies.
(0, $6Ho1L.SerializationHelper)._FresnelParametersParser = $08f87ed26b8946a4$export$ead2cdea5a43d2d2.Parse;

});

parcelRegister("2RkJE", function(module, exports) {

$parcel$export(module.exports, "MaterialHelper", () => $21509d954ca67f92$export$a4c755fdd251e756);

var $alPCh = parcelRequire("alPCh");
class $21509d954ca67f92$export$a4c755fdd251e756 {
}
/**
 * Binds the scene's uniform buffer to the effect.
 * @param effect defines the effect to bind to the scene uniform buffer
 * @param sceneUbo defines the uniform buffer storing scene data
 */ $21509d954ca67f92$export$a4c755fdd251e756.BindSceneUniformBuffer = (0, $alPCh.BindSceneUniformBuffer);
/**
 * Helps preparing the defines values about the UVs in used in the effect.
 * UVs are shared as much as we can across channels in the shaders.
 * @param texture The texture we are preparing the UVs for
 * @param defines The defines to update
 * @param key The channel key "diffuse", "specular"... used in the shader
 */ $21509d954ca67f92$export$a4c755fdd251e756.PrepareDefinesForMergedUV = (0, $alPCh.PrepareDefinesForMergedUV);
/**
 * Binds a texture matrix value to its corresponding uniform
 * @param texture The texture to bind the matrix for
 * @param uniformBuffer The uniform buffer receiving the data
 * @param key The channel key "diffuse", "specular"... used in the shader
 */ $21509d954ca67f92$export$a4c755fdd251e756.BindTextureMatrix = (0, $alPCh.BindTextureMatrix);
/**
 * Gets the current status of the fog (should it be enabled?)
 * @param mesh defines the mesh to evaluate for fog support
 * @param scene defines the hosting scene
 * @returns true if fog must be enabled
 */ $21509d954ca67f92$export$a4c755fdd251e756.GetFogState = (0, $alPCh.GetFogState);
/**
 * Helper used to prepare the list of defines associated with misc. values for shader compilation
 * @param mesh defines the current mesh
 * @param scene defines the current scene
 * @param useLogarithmicDepth defines if logarithmic depth has to be turned on
 * @param pointsCloud defines if point cloud rendering has to be turned on
 * @param fogEnabled defines if fog has to be turned on
 * @param alphaTest defines if alpha testing has to be turned on
 * @param defines defines the current list of defines
 * @param applyDecalAfterDetail Defines if the decal is applied after or before the detail
 */ $21509d954ca67f92$export$a4c755fdd251e756.PrepareDefinesForMisc = (0, $alPCh.PrepareDefinesForMisc);
/**
 * Helper used to prepare the defines relative to the active camera
 * @param scene defines the current scene
 * @param defines specifies the list of active defines
 * @returns true if the defines have been updated, else false
 */ $21509d954ca67f92$export$a4c755fdd251e756.PrepareDefinesForCamera = (0, $alPCh.PrepareDefinesForCamera);
/**
 * Helper used to prepare the list of defines associated with frame values for shader compilation
 * @param scene defines the current scene
 * @param engine defines the current engine
 * @param material defines the material we are compiling the shader for
 * @param defines specifies the list of active defines
 * @param useInstances defines if instances have to be turned on
 * @param useClipPlane defines if clip plane have to be turned on
 * @param useThinInstances defines if thin instances have to be turned on
 */ $21509d954ca67f92$export$a4c755fdd251e756.PrepareDefinesForFrameBoundValues = (0, $alPCh.PrepareDefinesForFrameBoundValues);
/**
 * Prepares the defines for bones
 * @param mesh The mesh containing the geometry data we will draw
 * @param defines The defines to update
 */ $21509d954ca67f92$export$a4c755fdd251e756.PrepareDefinesForBones = (0, $alPCh.PrepareDefinesForBones);
/**
 * Prepares the defines for morph targets
 * @param mesh The mesh containing the geometry data we will draw
 * @param defines The defines to update
 */ $21509d954ca67f92$export$a4c755fdd251e756.PrepareDefinesForMorphTargets = (0, $alPCh.PrepareDefinesForMorphTargets);
/**
 * Prepares the defines for baked vertex animation
 * @param mesh The mesh containing the geometry data we will draw
 * @param defines The defines to update
 */ $21509d954ca67f92$export$a4c755fdd251e756.PrepareDefinesForBakedVertexAnimation = (0, $alPCh.PrepareDefinesForBakedVertexAnimation);
/**
 * Prepares the defines used in the shader depending on the attributes data available in the mesh
 * @param mesh The mesh containing the geometry data we will draw
 * @param defines The defines to update
 * @param useVertexColor Precise whether vertex colors should be used or not (override mesh info)
 * @param useBones Precise whether bones should be used or not (override mesh info)
 * @param useMorphTargets Precise whether morph targets should be used or not (override mesh info)
 * @param useVertexAlpha Precise whether vertex alpha should be used or not (override mesh info)
 * @param useBakedVertexAnimation Precise whether baked vertex animation should be used or not (override mesh info)
 * @returns false if defines are considered not dirty and have not been checked
 */ $21509d954ca67f92$export$a4c755fdd251e756.PrepareDefinesForAttributes = (0, $alPCh.PrepareDefinesForAttributes);
/**
 * Prepares the defines related to multiview
 * @param scene The scene we are intending to draw
 * @param defines The defines to update
 */ $21509d954ca67f92$export$a4c755fdd251e756.PrepareDefinesForMultiview = (0, $alPCh.PrepareDefinesForMultiview);
/**
 * Prepares the defines related to order independant transparency
 * @param scene The scene we are intending to draw
 * @param defines The defines to update
 * @param needAlphaBlending Determines if the material needs alpha blending
 */ $21509d954ca67f92$export$a4c755fdd251e756.PrepareDefinesForOIT = (0, $alPCh.PrepareDefinesForOIT);
/**
 * Prepares the defines related to the prepass
 * @param scene The scene we are intending to draw
 * @param defines The defines to update
 * @param canRenderToMRT Indicates if this material renders to several textures in the prepass
 */ $21509d954ca67f92$export$a4c755fdd251e756.PrepareDefinesForPrePass = (0, $alPCh.PrepareDefinesForPrePass);
/**
 * Prepares the defines related to the light information passed in parameter
 * @param scene The scene we are intending to draw
 * @param mesh The mesh the effect is compiling for
 * @param light The light the effect is compiling for
 * @param lightIndex The index of the light
 * @param defines The defines to update
 * @param specularSupported Specifies whether specular is supported or not (override lights data)
 * @param state Defines the current state regarding what is needed (normals, etc...)
 * @param state.needNormals
 * @param state.needRebuild
 * @param state.shadowEnabled
 * @param state.specularEnabled
 * @param state.lightmapMode
 */ $21509d954ca67f92$export$a4c755fdd251e756.PrepareDefinesForLight = (0, $alPCh.PrepareDefinesForLight);
/**
 * Prepares the defines related to the light information passed in parameter
 * @param scene The scene we are intending to draw
 * @param mesh The mesh the effect is compiling for
 * @param defines The defines to update
 * @param specularSupported Specifies whether specular is supported or not (override lights data)
 * @param maxSimultaneousLights Specifies how manuy lights can be added to the effect at max
 * @param disableLighting Specifies whether the lighting is disabled (override scene and light)
 * @returns true if normals will be required for the rest of the effect
 */ $21509d954ca67f92$export$a4c755fdd251e756.PrepareDefinesForLights = (0, $alPCh.PrepareDefinesForLights);
/**
 * Prepares the uniforms and samplers list to be used in the effect (for a specific light)
 * @param lightIndex defines the light index
 * @param uniformsList The uniform list
 * @param samplersList The sampler list
 * @param projectedLightTexture defines if projected texture must be used
 * @param uniformBuffersList defines an optional list of uniform buffers
 * @param updateOnlyBuffersList True to only update the uniformBuffersList array
 */ $21509d954ca67f92$export$a4c755fdd251e756.PrepareUniformsAndSamplersForLight = (0, $alPCh.PrepareUniformsAndSamplersForLight);
/**
 * Prepares the uniforms and samplers list to be used in the effect
 * @param uniformsListOrOptions The uniform names to prepare or an EffectCreationOptions containing the list and extra information
 * @param samplersList The sampler list
 * @param defines The defines helping in the list generation
 * @param maxSimultaneousLights The maximum number of simultaneous light allowed in the effect
 */ $21509d954ca67f92$export$a4c755fdd251e756.PrepareUniformsAndSamplersList = (0, $alPCh.PrepareUniformsAndSamplersList);
/**
 * This helps decreasing rank by rank the shadow quality (0 being the highest rank and quality)
 * @param defines The defines to update while falling back
 * @param fallbacks The authorized effect fallbacks
 * @param maxSimultaneousLights The maximum number of lights allowed
 * @param rank the current rank of the Effect
 * @returns The newly affected rank
 */ $21509d954ca67f92$export$a4c755fdd251e756.HandleFallbacksForShadows = (0, $alPCh.HandleFallbacksForShadows);
/**
 * Prepares the list of attributes required for morph targets according to the effect defines.
 * @param attribs The current list of supported attribs
 * @param mesh The mesh to prepare the morph targets attributes for
 * @param influencers The number of influencers
 */ $21509d954ca67f92$export$a4c755fdd251e756.PrepareAttributesForMorphTargetsInfluencers = (0, $alPCh.PrepareAttributesForMorphTargetsInfluencers);
/**
 * Prepares the list of attributes required for morph targets according to the effect defines.
 * @param attribs The current list of supported attribs
 * @param mesh The mesh to prepare the morph targets attributes for
 * @param defines The current Defines of the effect
 */ $21509d954ca67f92$export$a4c755fdd251e756.PrepareAttributesForMorphTargets = (0, $alPCh.PrepareAttributesForMorphTargets);
/**
 * Prepares the list of attributes required for baked vertex animations according to the effect defines.
 * @param attribs The current list of supported attribs
 * @param mesh The mesh to prepare for baked vertex animations
 * @param defines The current Defines of the effect
 */ $21509d954ca67f92$export$a4c755fdd251e756.PrepareAttributesForBakedVertexAnimation = (0, $alPCh.PrepareAttributesForBakedVertexAnimation);
/**
 * Prepares the list of attributes required for bones according to the effect defines.
 * @param attribs The current list of supported attribs
 * @param mesh The mesh to prepare the bones attributes for
 * @param defines The current Defines of the effect
 * @param fallbacks The current effect fallback strategy
 */ $21509d954ca67f92$export$a4c755fdd251e756.PrepareAttributesForBones = (0, $alPCh.PrepareAttributesForBones);
/**
 * Check and prepare the list of attributes required for instances according to the effect defines.
 * @param attribs The current list of supported attribs
 * @param defines The current MaterialDefines of the effect
 */ $21509d954ca67f92$export$a4c755fdd251e756.PrepareAttributesForInstances = (0, $alPCh.PrepareAttributesForInstances);
/**
 * Add the list of attributes required for instances to the attribs array.
 * @param attribs The current list of supported attribs
 * @param needsPreviousMatrices If the shader needs previous matrices
 */ $21509d954ca67f92$export$a4c755fdd251e756.PushAttributesForInstances = (0, $alPCh.PushAttributesForInstances);
/**
 * Binds the light information to the effect.
 * @param light The light containing the generator
 * @param effect The effect we are binding the data to
 * @param lightIndex The light index in the effect used to render
 */ $21509d954ca67f92$export$a4c755fdd251e756.BindLightProperties = (0, $alPCh.BindLightProperties);
/**
 * Binds the lights information from the scene to the effect for the given mesh.
 * @param light Light to bind
 * @param lightIndex Light index
 * @param scene The scene where the light belongs to
 * @param effect The effect we are binding the data to
 * @param useSpecular Defines if specular is supported
 * @param receiveShadows Defines if the effect (mesh) we bind the light for receives shadows
 */ $21509d954ca67f92$export$a4c755fdd251e756.BindLight = (0, $alPCh.BindLight);
/**
 * Binds the lights information from the scene to the effect for the given mesh.
 * @param scene The scene the lights belongs to
 * @param mesh The mesh we are binding the information to render
 * @param effect The effect we are binding the data to
 * @param defines The generated defines for the effect
 * @param maxSimultaneousLights The maximum number of light that can be bound to the effect
 */ $21509d954ca67f92$export$a4c755fdd251e756.BindLights = (0, $alPCh.BindLights);
/**
 * Binds the fog information from the scene to the effect for the given mesh.
 * @param scene The scene the lights belongs to
 * @param mesh The mesh we are binding the information to render
 * @param effect The effect we are binding the data to
 * @param linearSpace Defines if the fog effect is applied in linear space
 */ $21509d954ca67f92$export$a4c755fdd251e756.BindFogParameters = (0, $alPCh.BindFogParameters);
/**
 * Binds the bones information from the mesh to the effect.
 * @param mesh The mesh we are binding the information to render
 * @param effect The effect we are binding the data to
 * @param prePassConfiguration Configuration for the prepass, in case prepass is activated
 */ $21509d954ca67f92$export$a4c755fdd251e756.BindBonesParameters = (0, $alPCh.BindBonesParameters);
/**
 * Binds the morph targets information from the mesh to the effect.
 * @param abstractMesh The mesh we are binding the information to render
 * @param effect The effect we are binding the data to
 */ $21509d954ca67f92$export$a4c755fdd251e756.BindMorphTargetParameters = (0, $alPCh.BindMorphTargetParameters);
/**
 * Binds the logarithmic depth information from the scene to the effect for the given defines.
 * @param defines The generated defines used in the effect
 * @param effect The effect we are binding the data to
 * @param scene The scene we are willing to render with logarithmic scale for
 */ $21509d954ca67f92$export$a4c755fdd251e756.BindLogDepth = (0, $alPCh.BindLogDepth);

});

parcelRegister("2tXqH", function(module, exports) {

var $diSMf = parcelRequire("diSMf");
$parcel$exportWildcard(module.exports, $diSMf);

});
parcelRegister("diSMf", function(module, exports) {

$parcel$export(module.exports, "OcclusionMaterial", () => $9af772660b7f1089$export$6a53b85ed4b47e35);

var $7etnY = parcelRequire("7etnY");

var $4I7rl = parcelRequire("4I7rl");
parcelRequire("kqZxW");
parcelRequire("7Z1KU");
class $9af772660b7f1089$export$6a53b85ed4b47e35 extends (0, $4I7rl.ShaderMaterial) {
    constructor(name, scene){
        super(name, scene, "color", {
            attributes: [
                "position"
            ],
            uniforms: [
                "world",
                "viewProjection",
                "color"
            ]
        });
        this.disableColorWrite = true;
        this.forceDepthWrite = true;
        this.setColor4("color", new (0, $7etnY.Color4)(0, 0, 0, 1));
    }
}

});


parcelRegister("bZsq9", function(module, exports) {

var $3rbQN = parcelRequire("3rbQN");

var $4G6Xh = parcelRequire("4G6Xh");

var $bl19F = parcelRequire("bl19F");

var $dXX3O = parcelRequire("dXX3O");

var $lngOr = parcelRequire("lngOr");

var $5Ezgc = parcelRequire("5Ezgc");

var $allm6 = parcelRequire("allm6");

var $Qsw72 = parcelRequire("Qsw72");

var $4T4Yv = parcelRequire("4T4Yv");

var $5Nlza = parcelRequire("5Nlza");
$parcel$exportWildcard(module.exports, $3rbQN);
$parcel$exportWildcard(module.exports, $4G6Xh);
$parcel$exportWildcard(module.exports, $bl19F);
$parcel$exportWildcard(module.exports, $dXX3O);
$parcel$exportWildcard(module.exports, $lngOr);
$parcel$exportWildcard(module.exports, $5Ezgc);
$parcel$exportWildcard(module.exports, $allm6);
$parcel$exportWildcard(module.exports, $Qsw72);
$parcel$exportWildcard(module.exports, $4T4Yv);
$parcel$exportWildcard(module.exports, $5Nlza);

});
parcelRegister("bl19F", function(module, exports) {

$parcel$export(module.exports, "PBRBaseSimpleMaterial", () => $84128d34f2b55b64$export$6f2e53744bf4844b);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $7etnY = parcelRequire("7etnY");

var $4G6Xh = parcelRequire("4G6Xh");
class $84128d34f2b55b64$export$6f2e53744bf4844b extends (0, $4G6Xh.PBRBaseMaterial) {
    /**
     * Gets the current double sided mode.
     */ get doubleSided() {
        return this._twoSidedLighting;
    }
    /**
     * If sets to true and backfaceCulling is false, normals will be flipped on the backside.
     */ set doubleSided(value) {
        if (this._twoSidedLighting === value) return;
        this._twoSidedLighting = value;
        this.backFaceCulling = !value;
        this._markAllSubMeshesAsTexturesDirty();
    }
    /**
     * Instantiates a new PBRMaterial instance.
     *
     * @param name The material name
     * @param scene The scene the material will be use in.
     */ constructor(name, scene){
        super(name, scene);
        /**
         * Number of Simultaneous lights allowed on the material.
         */ this.maxSimultaneousLights = 4;
        /**
         * If sets to true, disables all the lights affecting the material.
         */ this.disableLighting = false;
        /**
         * If sets to true, x component of normal map value will invert (x = 1.0 - x).
         */ this.invertNormalMapX = false;
        /**
         * If sets to true, y component of normal map value will invert (y = 1.0 - y).
         */ this.invertNormalMapY = false;
        /**
         * Emissivie color used to self-illuminate the model.
         */ this.emissiveColor = new (0, $7etnY.Color3)(0, 0, 0);
        /**
         * Occlusion Channel Strength.
         */ this.occlusionStrength = 1.0;
        /**
         * If true, the light map contains occlusion information instead of lighting info.
         */ this.useLightmapAsShadowmap = false;
        this._useAlphaFromAlbedoTexture = true;
        this._useAmbientInGrayScale = true;
    }
    getClassName() {
        return "PBRBaseSimpleMaterial";
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsLightsDirty")
], $84128d34f2b55b64$export$6f2e53744bf4844b.prototype, "maxSimultaneousLights", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsLightsDirty")
], $84128d34f2b55b64$export$6f2e53744bf4844b.prototype, "disableLighting", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty", "_reflectionTexture")
], $84128d34f2b55b64$export$6f2e53744bf4844b.prototype, "environmentTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $84128d34f2b55b64$export$6f2e53744bf4844b.prototype, "invertNormalMapX", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $84128d34f2b55b64$export$6f2e53744bf4844b.prototype, "invertNormalMapY", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty", "_bumpTexture")
], $84128d34f2b55b64$export$6f2e53744bf4844b.prototype, "normalTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor3)("emissive"),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $84128d34f2b55b64$export$6f2e53744bf4844b.prototype, "emissiveColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $84128d34f2b55b64$export$6f2e53744bf4844b.prototype, "emissiveTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty", "_ambientTextureStrength")
], $84128d34f2b55b64$export$6f2e53744bf4844b.prototype, "occlusionStrength", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty", "_ambientTexture")
], $84128d34f2b55b64$export$6f2e53744bf4844b.prototype, "occlusionTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty", "_alphaCutOff")
], $84128d34f2b55b64$export$6f2e53744bf4844b.prototype, "alphaCutOff", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $84128d34f2b55b64$export$6f2e53744bf4844b.prototype, "doubleSided", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty", null)
], $84128d34f2b55b64$export$6f2e53744bf4844b.prototype, "lightmapTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $84128d34f2b55b64$export$6f2e53744bf4844b.prototype, "useLightmapAsShadowmap", void 0);

});

parcelRegister("allm6", function(module, exports) {

$parcel$export(module.exports, "PBRMetallicRoughnessMaterial", () => $787c6e53e8a43c98$export$f21a62a4e04c053a);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $6Ho1L = parcelRequire("6Ho1L");

var $bl19F = parcelRequire("bl19F");

var $8DoUR = parcelRequire("8DoUR");
class $787c6e53e8a43c98$export$f21a62a4e04c053a extends (0, $bl19F.PBRBaseSimpleMaterial) {
    /**
     * Instantiates a new PBRMetalRoughnessMaterial instance.
     *
     * @param name The material name
     * @param scene The scene the material will be use in.
     */ constructor(name, scene){
        super(name, scene);
        this._useRoughnessFromMetallicTextureAlpha = false;
        this._useRoughnessFromMetallicTextureGreen = true;
        this._useMetallnessFromMetallicTextureBlue = true;
        this.metallic = 1.0;
        this.roughness = 1.0;
    }
    /**
     * @returns the current class name of the material.
     */ getClassName() {
        return "PBRMetallicRoughnessMaterial";
    }
    /**
     * Makes a duplicate of the current material.
     * @param name - name to use for the new material.
     * @returns cloned material instance
     */ clone(name) {
        const clone = (0, $6Ho1L.SerializationHelper).Clone(()=>new $787c6e53e8a43c98$export$f21a62a4e04c053a(name, this.getScene()), this);
        clone.id = name;
        clone.name = name;
        this.clearCoat.copyTo(clone.clearCoat);
        this.anisotropy.copyTo(clone.anisotropy);
        this.brdf.copyTo(clone.brdf);
        this.sheen.copyTo(clone.sheen);
        this.subSurface.copyTo(clone.subSurface);
        return clone;
    }
    /**
     * Serialize the material to a parsable JSON object.
     * @returns the JSON object
     */ serialize() {
        const serializationObject = (0, $6Ho1L.SerializationHelper).Serialize(this);
        serializationObject.customType = "BABYLON.PBRMetallicRoughnessMaterial";
        serializationObject.clearCoat = this.clearCoat.serialize();
        serializationObject.anisotropy = this.anisotropy.serialize();
        serializationObject.brdf = this.brdf.serialize();
        serializationObject.sheen = this.sheen.serialize();
        serializationObject.subSurface = this.subSurface.serialize();
        serializationObject.iridescence = this.iridescence.serialize();
        return serializationObject;
    }
    /**
     * Parses a JSON object corresponding to the serialize function.
     * @param source - JSON source object.
     * @param scene - Defines the scene we are parsing for
     * @param rootUrl - Defines the rootUrl of this parsed object
     * @returns a new PBRMetalRoughnessMaterial
     */ static Parse(source, scene, rootUrl) {
        const material = (0, $6Ho1L.SerializationHelper).Parse(()=>new $787c6e53e8a43c98$export$f21a62a4e04c053a(source.name, scene), source, scene, rootUrl);
        if (source.clearCoat) material.clearCoat.parse(source.clearCoat, scene, rootUrl);
        if (source.anisotropy) material.anisotropy.parse(source.anisotropy, scene, rootUrl);
        if (source.brdf) material.brdf.parse(source.brdf, scene, rootUrl);
        if (source.sheen) material.sheen.parse(source.sheen, scene, rootUrl);
        if (source.subSurface) material.subSurface.parse(source.subSurface, scene, rootUrl);
        if (source.iridescence) material.iridescence.parse(source.iridescence, scene, rootUrl);
        return material;
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor3)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty", "_albedoColor")
], $787c6e53e8a43c98$export$f21a62a4e04c053a.prototype, "baseColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty", "_albedoTexture")
], $787c6e53e8a43c98$export$f21a62a4e04c053a.prototype, "baseTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $787c6e53e8a43c98$export$f21a62a4e04c053a.prototype, "metallic", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $787c6e53e8a43c98$export$f21a62a4e04c053a.prototype, "roughness", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty", "_metallicTexture")
], $787c6e53e8a43c98$export$f21a62a4e04c053a.prototype, "metallicRoughnessTexture", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.PBRMetallicRoughnessMaterial", $787c6e53e8a43c98$export$f21a62a4e04c053a);

});

parcelRegister("Qsw72", function(module, exports) {

$parcel$export(module.exports, "PBRSpecularGlossinessMaterial", () => $09dafa507580b441$export$fbf9a91379be5f2e);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $bl19F = parcelRequire("bl19F");

var $8DoUR = parcelRequire("8DoUR");

var $6Ho1L = parcelRequire("6Ho1L");
class $09dafa507580b441$export$fbf9a91379be5f2e extends (0, $bl19F.PBRBaseSimpleMaterial) {
    /**
     * Specifies if the reflectivity texture contains the glossiness information in its alpha channel.
     */ get useMicroSurfaceFromReflectivityMapAlpha() {
        return this._useMicroSurfaceFromReflectivityMapAlpha;
    }
    /**
     * Instantiates a new PBRSpecularGlossinessMaterial instance.
     *
     * @param name The material name
     * @param scene The scene the material will be use in.
     */ constructor(name, scene){
        super(name, scene);
        this._useMicroSurfaceFromReflectivityMapAlpha = true;
    }
    /**
     * @returns the current class name of the material.
     */ getClassName() {
        return "PBRSpecularGlossinessMaterial";
    }
    /**
     * Makes a duplicate of the current material.
     * @param name - name to use for the new material.
     * @returns cloned material instance
     */ clone(name) {
        const clone = (0, $6Ho1L.SerializationHelper).Clone(()=>new $09dafa507580b441$export$fbf9a91379be5f2e(name, this.getScene()), this);
        clone.id = name;
        clone.name = name;
        this.clearCoat.copyTo(clone.clearCoat);
        this.anisotropy.copyTo(clone.anisotropy);
        this.brdf.copyTo(clone.brdf);
        this.sheen.copyTo(clone.sheen);
        this.subSurface.copyTo(clone.subSurface);
        return clone;
    }
    /**
     * Serialize the material to a parsable JSON object.
     * @returns the JSON object
     */ serialize() {
        const serializationObject = (0, $6Ho1L.SerializationHelper).Serialize(this);
        serializationObject.customType = "BABYLON.PBRSpecularGlossinessMaterial";
        serializationObject.clearCoat = this.clearCoat.serialize();
        serializationObject.anisotropy = this.anisotropy.serialize();
        serializationObject.brdf = this.brdf.serialize();
        serializationObject.sheen = this.sheen.serialize();
        serializationObject.subSurface = this.subSurface.serialize();
        serializationObject.iridescence = this.iridescence.serialize();
        return serializationObject;
    }
    /**
     * Parses a JSON object corresponding to the serialize function.
     * @param source - JSON source object.
     * @param scene - the scene to parse to.
     * @param rootUrl - root url of the assets.
     * @returns a new PBRSpecularGlossinessMaterial.
     */ static Parse(source, scene, rootUrl) {
        const material = (0, $6Ho1L.SerializationHelper).Parse(()=>new $09dafa507580b441$export$fbf9a91379be5f2e(source.name, scene), source, scene, rootUrl);
        if (source.clearCoat) material.clearCoat.parse(source.clearCoat, scene, rootUrl);
        if (source.anisotropy) material.anisotropy.parse(source.anisotropy, scene, rootUrl);
        if (source.brdf) material.brdf.parse(source.brdf, scene, rootUrl);
        if (source.sheen) material.sheen.parse(source.sheen, scene, rootUrl);
        if (source.subSurface) material.subSurface.parse(source.subSurface, scene, rootUrl);
        if (source.iridescence) material.iridescence.parse(source.iridescence, scene, rootUrl);
        return material;
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor3)("diffuse"),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty", "_albedoColor")
], $09dafa507580b441$export$fbf9a91379be5f2e.prototype, "diffuseColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty", "_albedoTexture")
], $09dafa507580b441$export$fbf9a91379be5f2e.prototype, "diffuseTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor3)("specular"),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty", "_reflectivityColor")
], $09dafa507580b441$export$fbf9a91379be5f2e.prototype, "specularColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty", "_microSurface")
], $09dafa507580b441$export$fbf9a91379be5f2e.prototype, "glossiness", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty", "_reflectivityTexture")
], $09dafa507580b441$export$fbf9a91379be5f2e.prototype, "specularGlossinessTexture", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.PBRSpecularGlossinessMaterial", $09dafa507580b441$export$fbf9a91379be5f2e);

});


parcelRegister("gGwWu", function(module, exports) {
/* eslint-disable import/no-internal-modules */ 
var $akOl3 = parcelRequire("akOl3");

var $90OM8 = parcelRequire("90OM8");

var $cr7k5 = parcelRequire("cr7k5");

var $iPQLf = parcelRequire("iPQLf");

var $fJfwX = parcelRequire("fJfwX");

var $1EKNO = parcelRequire("1EKNO");

var $42iIf = parcelRequire("42iIf");

var $9LfOV = parcelRequire("9LfOV");

var $6Y7JP = parcelRequire("6Y7JP");

var $kfaDA = parcelRequire("kfaDA");

var $b9e4a = parcelRequire("b9e4a");

var $i93ua = parcelRequire("i93ua");

var $8N79I = parcelRequire("8N79I");

var $73LGq = parcelRequire("73LGq");

var $3TXsv = parcelRequire("3TXsv");

var $iAir6 = parcelRequire("iAir6");

var $ksUhX = parcelRequire("ksUhX");

var $lgDo7 = parcelRequire("lgDo7");

var $5Egpj = parcelRequire("5Egpj");

var $ePSfe = parcelRequire("ePSfe");

var $hhyUd = parcelRequire("hhyUd");

var $feu8u = parcelRequire("feu8u");

var $gQtNK = parcelRequire("gQtNK");

var $bEkJJ = parcelRequire("bEkJJ");

var $j2mX5 = parcelRequire("j2mX5");

var $jyMMC = parcelRequire("jyMMC");

var $1A6Mn = parcelRequire("1A6Mn");

var $6Hwnm = parcelRequire("6Hwnm");

var $fx2sP = parcelRequire("fx2sP");
$parcel$exportWildcard(module.exports, $akOl3);
$parcel$exportWildcard(module.exports, $90OM8);
$parcel$exportWildcard(module.exports, $cr7k5);
$parcel$exportWildcard(module.exports, $iPQLf);
$parcel$exportWildcard(module.exports, $fJfwX);
$parcel$exportWildcard(module.exports, $1EKNO);
$parcel$exportWildcard(module.exports, $42iIf);
$parcel$exportWildcard(module.exports, $9LfOV);
$parcel$exportWildcard(module.exports, $6Y7JP);
$parcel$exportWildcard(module.exports, $kfaDA);
$parcel$exportWildcard(module.exports, $b9e4a);
$parcel$exportWildcard(module.exports, $i93ua);
$parcel$exportWildcard(module.exports, $8N79I);
$parcel$exportWildcard(module.exports, $73LGq);
$parcel$exportWildcard(module.exports, $3TXsv);
$parcel$exportWildcard(module.exports, $iAir6);
$parcel$exportWildcard(module.exports, $ksUhX);
$parcel$exportWildcard(module.exports, $lgDo7);
$parcel$exportWildcard(module.exports, $5Egpj);
$parcel$exportWildcard(module.exports, $ePSfe);
$parcel$exportWildcard(module.exports, $hhyUd);
$parcel$exportWildcard(module.exports, $feu8u);
$parcel$exportWildcard(module.exports, $gQtNK);
$parcel$exportWildcard(module.exports, $bEkJJ);
$parcel$exportWildcard(module.exports, $j2mX5);
$parcel$exportWildcard(module.exports, $jyMMC);
$parcel$exportWildcard(module.exports, $1A6Mn);
$parcel$exportWildcard(module.exports, $6Hwnm);
$parcel$exportWildcard(module.exports, $fx2sP);

});
parcelRegister("cr7k5", function(module, exports) {

$parcel$export(module.exports, "ColorGradingTexture", () => $90ddafd68c6e1c93$export$6283b77daa10f646);

var $ha1VO = parcelRequire("ha1VO");

var $akOl3 = parcelRequire("akOl3");

var $8DoUR = parcelRequire("8DoUR");
parcelRequire("e7NUJ");
class $90ddafd68c6e1c93$export$6283b77daa10f646 extends (0, $akOl3.BaseTexture) {
    /**
     * Instantiates a ColorGradingTexture from the following parameters.
     *
     * @param url The location of the color grading data (currently only supporting 3dl)
     * @param sceneOrEngine The scene or engine the texture will be used in
     * @param onLoad defines a callback triggered when the texture has been loaded
     */ constructor(url, sceneOrEngine, onLoad = null){
        super(sceneOrEngine);
        if (!url) return;
        this._textureMatrix = (0, $ha1VO.Matrix).Identity();
        this.name = url;
        this.url = url;
        this._onLoad = onLoad;
        this._texture = this._getFromCache(url, true);
        if (!this._texture) {
            const scene = this.getScene();
            if (scene) {
                if (!scene.useDelayedTextureLoading) this._loadTexture();
                else this.delayLoadState = 4;
            } else this._loadTexture();
        } else this._triggerOnLoad();
    }
    /**
     * Fires the onload event from the constructor if requested.
     */ _triggerOnLoad() {
        if (this._onLoad) this._onLoad();
    }
    /**
     * @returns the texture matrix used in most of the material.
     * This is not used in color grading but keep for troubleshooting purpose (easily swap diffuse by colorgrading to look in).
     */ getTextureMatrix() {
        return this._textureMatrix;
    }
    /**
     * Occurs when the file being loaded is a .3dl LUT file.
     * @returns the 3D LUT texture
     */ _load3dlTexture() {
        const engine = this._getEngine();
        let texture;
        if (!engine._features.support3DTextures) texture = engine.createRawTexture(null, 1, 1, 5, false, false, 2, null, 0);
        else texture = engine.createRawTexture3D(null, 1, 1, 1, 5, false, false, 2, null, 0);
        this._texture = texture;
        this._texture.isReady = false;
        this.isCube = false;
        this.is3D = engine._features.support3DTextures;
        this.wrapU = 0;
        this.wrapV = 0;
        this.wrapR = 0;
        this.anisotropicFilteringLevel = 1;
        const callback = (text)=>{
            if (typeof text !== "string") return;
            let data = null;
            let tempData = null;
            let line;
            const lines = text.split("\n");
            let size = 0, pixelIndexW = 0, pixelIndexH = 0, pixelIndexSlice = 0;
            let maxColor = 0;
            for(let i = 0; i < lines.length; i++){
                line = lines[i];
                if (!$90ddafd68c6e1c93$export$6283b77daa10f646._NoneEmptyLineRegex.test(line)) continue;
                if (line.indexOf("#") === 0) continue;
                const words = line.split(" ");
                if (size === 0) {
                    // Number of space + one
                    size = words.length;
                    data = new Uint8Array(size * size * size * 4); // volume texture of side size and rgb 8
                    tempData = new Float32Array(size * size * size * 4);
                    continue;
                }
                if (size != 0) {
                    const r = Math.max(parseInt(words[0]), 0);
                    const g = Math.max(parseInt(words[1]), 0);
                    const b = Math.max(parseInt(words[2]), 0);
                    maxColor = Math.max(r, maxColor);
                    maxColor = Math.max(g, maxColor);
                    maxColor = Math.max(b, maxColor);
                    const pixelStorageIndex = (pixelIndexW + pixelIndexSlice * size + pixelIndexH * size * size) * 4;
                    if (tempData) {
                        tempData[pixelStorageIndex + 0] = r;
                        tempData[pixelStorageIndex + 1] = g;
                        tempData[pixelStorageIndex + 2] = b;
                    }
                    // Keep for reference in case of back compat problems.
                    // pixelIndexSlice++;
                    // if (pixelIndexSlice % size == 0) {
                    //     pixelIndexH++;
                    //     pixelIndexSlice = 0;
                    //     if (pixelIndexH % size == 0) {
                    //         pixelIndexW++;
                    //         pixelIndexH = 0;
                    //     }
                    // }
                    pixelIndexH++;
                    if (pixelIndexH % size == 0) {
                        pixelIndexSlice++;
                        pixelIndexH = 0;
                        if (pixelIndexSlice % size == 0) {
                            pixelIndexW++;
                            pixelIndexSlice = 0;
                        }
                    }
                }
            }
            if (tempData && data) {
                for(let i = 0; i < tempData.length; i++)if (i > 0 && (i + 1) % 4 === 0) data[i] = 255;
                else {
                    const value = tempData[i];
                    data[i] = value / maxColor * 255;
                }
            }
            if (texture.is3D) {
                texture.updateSize(size, size, size);
                engine.updateRawTexture3D(texture, data, 5, false);
            } else {
                texture.updateSize(size * size, size);
                engine.updateRawTexture(texture, data, 5, false);
            }
            texture.isReady = true;
            this._triggerOnLoad();
        };
        const scene = this.getScene();
        if (scene) scene._loadFile(this.url, callback);
        else engine._loadFile(this.url, callback);
        return this._texture;
    }
    /**
     * Starts the loading process of the texture.
     */ _loadTexture() {
        if (this.url && this.url.toLocaleLowerCase().indexOf(".3dl") == this.url.length - 4) this._load3dlTexture();
    }
    /**
     * Clones the color grading texture.
     * @returns the cloned texture
     */ clone() {
        const newTexture = new $90ddafd68c6e1c93$export$6283b77daa10f646(this.url, this.getScene() || this._getEngine());
        // Base texture
        newTexture.level = this.level;
        return newTexture;
    }
    /**
     * Called during delayed load for textures.
     */ delayLoad() {
        if (this.delayLoadState !== 4) return;
        this.delayLoadState = 1;
        this._texture = this._getFromCache(this.url, true);
        if (!this._texture) this._loadTexture();
    }
    /**
     * Parses a color grading texture serialized by Babylon.
     * @param parsedTexture The texture information being parsedTexture
     * @param scene The scene to load the texture in
     * @returns A color grading texture
     */ static Parse(parsedTexture, scene) {
        let texture = null;
        if (parsedTexture.name && !parsedTexture.isRenderTarget) {
            texture = new $90ddafd68c6e1c93$export$6283b77daa10f646(parsedTexture.name, scene);
            texture.name = parsedTexture.name;
            texture.level = parsedTexture.level;
        }
        return texture;
    }
    /**
     * Serializes the LUT texture to json format.
     * @returns The JSON representation of the texture
     */ serialize() {
        if (!this.name) return null;
        const serializationObject = {};
        serializationObject.name = this.name;
        serializationObject.level = this.level;
        serializationObject.customType = "BABYLON.ColorGradingTexture";
        return serializationObject;
    }
}
/**
 * Empty line regex stored for GC.
 */ $90ddafd68c6e1c93$export$6283b77daa10f646._NoneEmptyLineRegex = /\S+/;
(0, $8DoUR.RegisterClass)("BABYLON.ColorGradingTexture", $90ddafd68c6e1c93$export$6283b77daa10f646);

});

parcelRegister("1EKNO", function(module, exports) {

$parcel$export(module.exports, "EquiRectangularCubeTexture", () => $134dd4dcb036c00d$export$fda2c7b64961e6e5);

var $h8zBf = parcelRequire("h8zBf");

var $akOl3 = parcelRequire("akOl3");

var $j2mX5 = parcelRequire("j2mX5");

var $bOhSV = parcelRequire("bOhSV");
parcelRequire("e7NUJ");

var $EOxw7 = parcelRequire("EOxw7");
class $134dd4dcb036c00d$export$fda2c7b64961e6e5 extends (0, $akOl3.BaseTexture) {
    /**
     * Instantiates an EquiRectangularCubeTexture from the following parameters.
     * @param url The location of the image
     * @param scene The scene the texture will be used in
     * @param size The cubemap desired size (the more it increases the longer the generation will be)
     * @param noMipmap Forces to not generate the mipmap if true
     * @param gammaSpace Specifies if the texture will be used in gamma or linear space
     * (the PBR material requires those textures in linear space, but the standard material would require them in Gamma space)
     * @param onLoad — defines a callback called when texture is loaded
     * @param onError — defines a callback called if there is an error
     * @param supersample — defines if texture must be supersampled (default: false)
     */ constructor(url, scene, size, noMipmap = false, gammaSpace = true, onLoad = null, onError = null, supersample = false){
        super(scene);
        this._onLoad = null;
        this._onError = null;
        if (!url) throw new Error("Image url is not set");
        this._coordinatesMode = (0, $j2mX5.Texture).CUBIC_MODE;
        this.name = url;
        this.url = url;
        this._size = size;
        this._supersample = supersample;
        this._noMipmap = noMipmap;
        this.gammaSpace = gammaSpace;
        this._onLoad = onLoad;
        this._onError = onError;
        this.hasAlpha = false;
        this.isCube = true;
        this._texture = this._getFromCache(url, this._noMipmap, undefined, undefined, undefined, this.isCube);
        if (!this._texture) {
            if (!scene.useDelayedTextureLoading) this._loadImage(()=>this._loadTexture(), this._onError);
            else this.delayLoadState = 4;
        } else if (onLoad) {
            if (this._texture.isReady) (0, $bOhSV.Tools).SetImmediate(()=>onLoad());
            else this._texture.onLoadedObservable.add(onLoad);
        }
    }
    /**
     * Load the image data, by putting the image on a canvas and extracting its buffer.
     * @param loadTextureCallback
     * @param onError
     */ _loadImage(loadTextureCallback, onError) {
        const scene = this.getScene();
        if (!scene) return;
        // Create texture before loading
        const texture = scene.getEngine().createRawCubeTexture(null, this._size, 4, scene.getEngine().getCaps().textureFloat ? 1 : 7, this._noMipmap, false, 3);
        texture.generateMipMaps = !this._noMipmap;
        scene.addPendingData(texture);
        texture.url = this.url;
        texture.isReady = false;
        scene.getEngine()._internalTexturesCache.push(texture);
        this._texture = texture;
        const canvas = document.createElement("canvas");
        (0, $EOxw7.LoadImage)(this.url, (image)=>{
            this._width = image.width;
            this._height = image.height;
            canvas.width = this._width;
            canvas.height = this._height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(image, 0, 0);
            const imageData = ctx.getImageData(0, 0, image.width, image.height);
            this._buffer = imageData.data.buffer;
            canvas.remove();
            loadTextureCallback();
        }, (_, e)=>{
            scene.removePendingData(texture);
            if (onError) onError(`${this.getClassName()} could not be loaded`, e);
        }, scene ? scene.offlineProvider : null);
    }
    /**
     * Convert the image buffer into a cubemap and create a CubeTexture.
     */ _loadTexture() {
        const scene = this.getScene();
        const callback = ()=>{
            const imageData = this._getFloat32ArrayFromArrayBuffer(this._buffer);
            // Extract the raw linear data.
            const data = (0, $h8zBf.PanoramaToCubeMapTools).ConvertPanoramaToCubemap(imageData, this._width, this._height, this._size, this._supersample);
            const results = [];
            // Push each faces.
            for(let i = 0; i < 6; i++){
                const dataFace = data[$134dd4dcb036c00d$export$fda2c7b64961e6e5._FacesMapping[i]];
                results.push(dataFace);
            }
            return results;
        };
        if (!scene) return;
        const faceDataArrays = callback();
        const texture = this._texture;
        scene.getEngine().updateRawCubeTexture(texture, faceDataArrays, texture.format, texture.type, texture.invertY);
        texture.isReady = true;
        scene.removePendingData(texture);
        texture.onLoadedObservable.notifyObservers(texture);
        texture.onLoadedObservable.clear();
        if (this._onLoad) this._onLoad();
    }
    /**
     * Convert the ArrayBuffer into a Float32Array and drop the transparency channel.
     * @param buffer The ArrayBuffer that should be converted.
     * @returns The buffer as Float32Array.
     */ _getFloat32ArrayFromArrayBuffer(buffer) {
        const dataView = new DataView(buffer);
        const floatImageData = new Float32Array(buffer.byteLength * 3 / 4);
        let k = 0;
        for(let i = 0; i < buffer.byteLength; i++)// We drop the transparency channel, because we do not need/want it
        if ((i + 1) % 4 !== 0) floatImageData[k++] = dataView.getUint8(i) / 255;
        return floatImageData;
    }
    /**
     * Get the current class name of the texture useful for serialization or dynamic coding.
     * @returns "EquiRectangularCubeTexture"
     */ getClassName() {
        return "EquiRectangularCubeTexture";
    }
    /**
     * Create a clone of the current EquiRectangularCubeTexture and return it.
     * @returns A clone of the current EquiRectangularCubeTexture.
     */ clone() {
        const scene = this.getScene();
        if (!scene) return this;
        const newTexture = new $134dd4dcb036c00d$export$fda2c7b64961e6e5(this.url, scene, this._size, this._noMipmap, this.gammaSpace);
        // Base texture
        newTexture.level = this.level;
        newTexture.wrapU = this.wrapU;
        newTexture.wrapV = this.wrapV;
        newTexture.coordinatesIndex = this.coordinatesIndex;
        newTexture.coordinatesMode = this.coordinatesMode;
        return newTexture;
    }
}
/** The six faces of the cube. */ $134dd4dcb036c00d$export$fda2c7b64961e6e5._FacesMapping = [
    "right",
    "left",
    "up",
    "down",
    "front",
    "back"
];

});

parcelRegister("kfaDA", function(module, exports) {

$parcel$export(module.exports, "HtmlElementTexture", () => $ebcd75bd2ed81ff7$export$d21b82b0b0e6fdba);

var $akOl3 = parcelRequire("akOl3");

var $ha1VO = parcelRequire("ha1VO");

var $diGQf = parcelRequire("diGQf");
parcelRequire("2yVdu");
parcelRequire("ahLMi");
parcelRequire("bZTNp");
class $ebcd75bd2ed81ff7$export$d21b82b0b0e6fdba extends (0, $akOl3.BaseTexture) {
    /**
     * Instantiates a HtmlElementTexture from the following parameters.
     *
     * @param name Defines the name of the texture
     * @param element Defines the video or canvas the texture is filled with
     * @param options Defines the other none mandatory texture creation options
     */ constructor(name, element, options){
        super(options.scene || options.engine);
        /**
         * Observable triggered once the texture has been loaded.
         */ this.onLoadObservable = new (0, $diGQf.Observable)();
        if (!element || !options.engine && !options.scene) return;
        options = {
            ...$ebcd75bd2ed81ff7$export$d21b82b0b0e6fdba._DefaultOptions,
            ...options
        };
        this._generateMipMaps = options.generateMipMaps;
        this._samplingMode = options.samplingMode;
        this._textureMatrix = (0, $ha1VO.Matrix).Identity();
        this._format = options.format;
        this.name = name;
        this.element = element;
        this._isVideo = !!element.getVideoPlaybackQuality;
        this._externalTexture = this._isVideo ? this._engine?.createExternalTexture(element) ?? null : null;
        this.anisotropicFilteringLevel = 1;
        this._createInternalTexture();
    }
    _createInternalTexture() {
        let width = 0;
        let height = 0;
        if (this._isVideo) {
            width = this.element.videoWidth;
            height = this.element.videoHeight;
        } else {
            width = this.element.width;
            height = this.element.height;
        }
        const engine = this._getEngine();
        if (engine) {
            this._texture = engine.createDynamicTexture(width, height, this._generateMipMaps, this._samplingMode);
            this._texture.format = this._format;
        }
        this.update();
    }
    /**
     * @returns the texture matrix used in most of the material.
     */ getTextureMatrix() {
        return this._textureMatrix;
    }
    /**
     * Updates the content of the texture.
     * @param invertY Defines whether the texture should be inverted on Y (false by default on video and true on canvas)
     */ update(invertY = null) {
        const engine = this._getEngine();
        if (this._texture == null || engine == null) return;
        const wasReady = this.isReady();
        if (this._isVideo) {
            const videoElement = this.element;
            if (videoElement.readyState < videoElement.HAVE_CURRENT_DATA) return;
            engine.updateVideoTexture(this._texture, this._externalTexture ? this._externalTexture : videoElement, invertY === null ? true : invertY);
        } else {
            const canvasElement = this.element;
            engine.updateDynamicTexture(this._texture, canvasElement, invertY === null ? true : invertY, false, this._format);
        }
        if (!wasReady && this.isReady()) this.onLoadObservable.notifyObservers(this);
    }
    /**
     * Dispose the texture and release its associated resources.
     */ dispose() {
        this.onLoadObservable.clear();
        super.dispose();
    }
}
$ebcd75bd2ed81ff7$export$d21b82b0b0e6fdba._DefaultOptions = {
    generateMipMaps: false,
    samplingMode: 2,
    format: 5,
    engine: null,
    scene: null
};

});

parcelRegister("i93ua", function(module, exports) {

});

parcelRegister("8N79I", function(module, exports) {

var $hdvNa = parcelRequire("hdvNa");

var $lkQQp = parcelRequire("lkQQp");

var $72wSy = parcelRequire("72wSy");

var $4eipL = parcelRequire("4eipL");

var $ezxpO = parcelRequire("ezxpO");

var $d0PoS = parcelRequire("d0PoS");
$parcel$exportWildcard(module.exports, $hdvNa);
$parcel$exportWildcard(module.exports, $lkQQp);
$parcel$exportWildcard(module.exports, $72wSy);
$parcel$exportWildcard(module.exports, $4eipL);
$parcel$exportWildcard(module.exports, $ezxpO);
$parcel$exportWildcard(module.exports, $d0PoS);

});
parcelRegister("4eipL", function(module, exports) {

$parcel$export(module.exports, "_TGATextureLoader", () => $3146c0f620a13113$export$bc25f312373311d0);

var $2TSIk = parcelRequire("2TSIk");

var $5YkyR = parcelRequire("5YkyR");
class $3146c0f620a13113$export$bc25f312373311d0 {
    constructor(){
        /**
         * Defines whether the loader supports cascade loading the different faces.
         */ this.supportCascades = false;
    }
    /**
     * This returns if the loader support the current file information.
     * @param extension defines the file extension of the file being loaded
     * @returns true if the loader can load the specified file
     */ canLoad(extension) {
        return extension.endsWith(".tga");
    }
    /**
     * Uploads the cube texture data to the WebGL texture. It has already been bound.
     */ loadCubeData() {
        // eslint-disable-next-line no-throw-literal
        throw ".env not supported in Cube.";
    }
    /**
     * Uploads the 2D texture data to the WebGL texture. It has already been bound once in the callback.
     * @param data contains the texture data
     * @param texture defines the BabylonJS internal texture
     * @param callback defines the method to call once ready to upload
     */ loadData(data, texture, callback) {
        const bytes = new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
        const header = (0, $2TSIk.GetTGAHeader)(bytes);
        callback(header.width, header.height, texture.generateMipMaps, false, ()=>{
            (0, $2TSIk.UploadContent)(texture, bytes);
        });
    }
}
// Register the loader.
(0, $5YkyR.Engine)._TextureLoaders.push(new $3146c0f620a13113$export$bc25f312373311d0());

});
parcelRegister("2TSIk", function(module, exports) {

$parcel$export(module.exports, "GetTGAHeader", () => $21cb28dcb463e29e$export$90b0901f3b785038);
$parcel$export(module.exports, "UploadContent", () => $21cb28dcb463e29e$export$f484b4377dfb0b39);
$parcel$export(module.exports, "TGATools", () => $21cb28dcb463e29e$export$8f8e6737de937f95);

var $kVtWi = parcelRequire("kVtWi");
//private static _TYPE_NO_DATA = 0;
const $21cb28dcb463e29e$var$_TYPE_INDEXED = 1;
const $21cb28dcb463e29e$var$_TYPE_RGB = 2;
const $21cb28dcb463e29e$var$_TYPE_GREY = 3;
const $21cb28dcb463e29e$var$_TYPE_RLE_INDEXED = 9;
const $21cb28dcb463e29e$var$_TYPE_RLE_RGB = 10;
const $21cb28dcb463e29e$var$_TYPE_RLE_GREY = 11;
const $21cb28dcb463e29e$var$_ORIGIN_MASK = 0x30;
const $21cb28dcb463e29e$var$_ORIGIN_SHIFT = 0x04;
const $21cb28dcb463e29e$var$_ORIGIN_BL = 0x00;
const $21cb28dcb463e29e$var$_ORIGIN_BR = 0x01;
const $21cb28dcb463e29e$var$_ORIGIN_UL = 0x02;
const $21cb28dcb463e29e$var$_ORIGIN_UR = 0x03;
function $21cb28dcb463e29e$export$90b0901f3b785038(data) {
    let offset = 0;
    const header = {
        id_length: data[offset++],
        colormap_type: data[offset++],
        image_type: data[offset++],
        colormap_index: data[offset++] | data[offset++] << 8,
        colormap_length: data[offset++] | data[offset++] << 8,
        colormap_size: data[offset++],
        origin: [
            data[offset++] | data[offset++] << 8,
            data[offset++] | data[offset++] << 8
        ],
        width: data[offset++] | data[offset++] << 8,
        height: data[offset++] | data[offset++] << 8,
        pixel_size: data[offset++],
        flags: data[offset++]
    };
    return header;
}
function $21cb28dcb463e29e$export$f484b4377dfb0b39(texture, data) {
    // Not enough data to contain header ?
    if (data.length < 19) {
        (0, $kVtWi.Logger).Error("Unable to load TGA file - Not enough data to contain header");
        return;
    }
    // Read Header
    let offset = 18;
    const header = $21cb28dcb463e29e$export$90b0901f3b785038(data);
    // Assume it's a valid Targa file.
    if (header.id_length + offset > data.length) {
        (0, $kVtWi.Logger).Error("Unable to load TGA file - Not enough data");
        return;
    }
    // Skip not needed data
    offset += header.id_length;
    let use_rle = false;
    let use_pal = false;
    let use_grey = false;
    // Get some informations.
    switch(header.image_type){
        case $21cb28dcb463e29e$var$_TYPE_RLE_INDEXED:
            use_rle = true;
        // eslint-disable-next-line no-fallthrough
        case $21cb28dcb463e29e$var$_TYPE_INDEXED:
            use_pal = true;
            break;
        case $21cb28dcb463e29e$var$_TYPE_RLE_RGB:
            use_rle = true;
        // eslint-disable-next-line no-fallthrough
        case $21cb28dcb463e29e$var$_TYPE_RGB:
            break;
        case $21cb28dcb463e29e$var$_TYPE_RLE_GREY:
            use_rle = true;
        // eslint-disable-next-line no-fallthrough
        case $21cb28dcb463e29e$var$_TYPE_GREY:
            use_grey = true;
            break;
    }
    let pixel_data;
    // var numAlphaBits = header.flags & 0xf;
    const pixel_size = header.pixel_size >> 3;
    const pixel_total = header.width * header.height * pixel_size;
    // Read palettes
    let palettes;
    if (use_pal) palettes = data.subarray(offset, offset += header.colormap_length * (header.colormap_size >> 3));
    // Read LRE
    if (use_rle) {
        pixel_data = new Uint8Array(pixel_total);
        let c, count, i;
        let localOffset = 0;
        const pixels = new Uint8Array(pixel_size);
        while(offset < pixel_total && localOffset < pixel_total){
            c = data[offset++];
            count = (c & 0x7f) + 1;
            // RLE pixels
            if (c & 0x80) {
                // Bind pixel tmp array
                for(i = 0; i < pixel_size; ++i)pixels[i] = data[offset++];
                // Copy pixel array
                for(i = 0; i < count; ++i)pixel_data.set(pixels, localOffset + i * pixel_size);
                localOffset += pixel_size * count;
            } else {
                count *= pixel_size;
                for(i = 0; i < count; ++i)pixel_data[localOffset + i] = data[offset++];
                localOffset += count;
            }
        }
    } else pixel_data = data.subarray(offset, offset += use_pal ? header.width * header.height : pixel_total);
    // Load to texture
    let x_start, y_start, x_step, y_step, y_end, x_end;
    switch((header.flags & $21cb28dcb463e29e$var$_ORIGIN_MASK) >> $21cb28dcb463e29e$var$_ORIGIN_SHIFT){
        default:
        case $21cb28dcb463e29e$var$_ORIGIN_UL:
            x_start = 0;
            x_step = 1;
            x_end = header.width;
            y_start = 0;
            y_step = 1;
            y_end = header.height;
            break;
        case $21cb28dcb463e29e$var$_ORIGIN_BL:
            x_start = 0;
            x_step = 1;
            x_end = header.width;
            y_start = header.height - 1;
            y_step = -1;
            y_end = -1;
            break;
        case $21cb28dcb463e29e$var$_ORIGIN_UR:
            x_start = header.width - 1;
            x_step = -1;
            x_end = -1;
            y_start = 0;
            y_step = 1;
            y_end = header.height;
            break;
        case $21cb28dcb463e29e$var$_ORIGIN_BR:
            x_start = header.width - 1;
            x_step = -1;
            x_end = -1;
            y_start = header.height - 1;
            y_step = -1;
            y_end = -1;
            break;
    }
    // Load the specify method
    const func = "_getImageData" + (use_grey ? "Grey" : "") + header.pixel_size + "bits";
    const imageData = $21cb28dcb463e29e$export$8f8e6737de937f95[func](header, palettes, pixel_data, y_start, y_step, y_end, x_start, x_step, x_end);
    const engine = texture.getEngine();
    engine._uploadDataToTextureDirectly(texture, imageData);
}
/**
 * @internal
 */ function $21cb28dcb463e29e$var$_getImageData8bits(header, palettes, pixel_data, y_start, y_step, y_end, x_start, x_step, x_end) {
    const image = pixel_data, colormap = palettes;
    const width = header.width, height = header.height;
    let color, i = 0, x, y;
    const imageData = new Uint8Array(width * height * 4);
    for(y = y_start; y !== y_end; y += y_step)for(x = x_start; x !== x_end; x += x_step, i++){
        color = image[i];
        imageData[(x + width * y) * 4 + 3] = 255;
        imageData[(x + width * y) * 4 + 2] = colormap[color * 3 + 0];
        imageData[(x + width * y) * 4 + 1] = colormap[color * 3 + 1];
        imageData[(x + width * y) * 4 + 0] = colormap[color * 3 + 2];
    }
    return imageData;
}
/**
 * @internal
 */ function $21cb28dcb463e29e$var$_getImageData16bits(header, palettes, pixel_data, y_start, y_step, y_end, x_start, x_step, x_end) {
    const image = pixel_data;
    const width = header.width, height = header.height;
    let color, i = 0, x, y;
    const imageData = new Uint8Array(width * height * 4);
    for(y = y_start; y !== y_end; y += y_step)for(x = x_start; x !== x_end; x += x_step, i += 2){
        color = image[i + 0] + (image[i + 1] << 8); // Inversed ?
        const r = ((color & 0x7c00) >> 10) * 255 / 0x1f | 0;
        const g = ((color & 0x03e0) >> 5) * 255 / 0x1f | 0;
        const b = (color & 0x001f) * 255 / 0x1f | 0;
        imageData[(x + width * y) * 4 + 0] = r;
        imageData[(x + width * y) * 4 + 1] = g;
        imageData[(x + width * y) * 4 + 2] = b;
        imageData[(x + width * y) * 4 + 3] = color & 0x8000 ? 0 : 255;
    }
    return imageData;
}
/**
 * @internal
 */ function $21cb28dcb463e29e$var$_getImageData24bits(header, palettes, pixel_data, y_start, y_step, y_end, x_start, x_step, x_end) {
    const image = pixel_data;
    const width = header.width, height = header.height;
    let i = 0, x, y;
    const imageData = new Uint8Array(width * height * 4);
    for(y = y_start; y !== y_end; y += y_step)for(x = x_start; x !== x_end; x += x_step, i += 3){
        imageData[(x + width * y) * 4 + 3] = 255;
        imageData[(x + width * y) * 4 + 2] = image[i + 0];
        imageData[(x + width * y) * 4 + 1] = image[i + 1];
        imageData[(x + width * y) * 4 + 0] = image[i + 2];
    }
    return imageData;
}
/**
 * @internal
 */ function $21cb28dcb463e29e$var$_getImageData32bits(header, palettes, pixel_data, y_start, y_step, y_end, x_start, x_step, x_end) {
    const image = pixel_data;
    const width = header.width, height = header.height;
    let i = 0, x, y;
    const imageData = new Uint8Array(width * height * 4);
    for(y = y_start; y !== y_end; y += y_step)for(x = x_start; x !== x_end; x += x_step, i += 4){
        imageData[(x + width * y) * 4 + 2] = image[i + 0];
        imageData[(x + width * y) * 4 + 1] = image[i + 1];
        imageData[(x + width * y) * 4 + 0] = image[i + 2];
        imageData[(x + width * y) * 4 + 3] = image[i + 3];
    }
    return imageData;
}
/**
 * @internal
 */ function $21cb28dcb463e29e$var$_getImageDataGrey8bits(header, palettes, pixel_data, y_start, y_step, y_end, x_start, x_step, x_end) {
    const image = pixel_data;
    const width = header.width, height = header.height;
    let color, i = 0, x, y;
    const imageData = new Uint8Array(width * height * 4);
    for(y = y_start; y !== y_end; y += y_step)for(x = x_start; x !== x_end; x += x_step, i++){
        color = image[i];
        imageData[(x + width * y) * 4 + 0] = color;
        imageData[(x + width * y) * 4 + 1] = color;
        imageData[(x + width * y) * 4 + 2] = color;
        imageData[(x + width * y) * 4 + 3] = 255;
    }
    return imageData;
}
/**
 * @internal
 */ function $21cb28dcb463e29e$var$_getImageDataGrey16bits(header, palettes, pixel_data, y_start, y_step, y_end, x_start, x_step, x_end) {
    const image = pixel_data;
    const width = header.width, height = header.height;
    let i = 0, x, y;
    const imageData = new Uint8Array(width * height * 4);
    for(y = y_start; y !== y_end; y += y_step)for(x = x_start; x !== x_end; x += x_step, i += 2){
        imageData[(x + width * y) * 4 + 0] = image[i + 0];
        imageData[(x + width * y) * 4 + 1] = image[i + 0];
        imageData[(x + width * y) * 4 + 2] = image[i + 0];
        imageData[(x + width * y) * 4 + 3] = image[i + 1];
    }
    return imageData;
}
const $21cb28dcb463e29e$export$8f8e6737de937f95 = {
    GetTGAHeader: /**
     * Gets the header of a TGA file
     * @param data defines the TGA data
     * @returns the header
     */ $21cb28dcb463e29e$export$90b0901f3b785038,
    UploadContent: /**
     * Uploads TGA content to a Babylon Texture
     * @internal
     */ $21cb28dcb463e29e$export$f484b4377dfb0b39,
    _getImageData8bits: /** @internal */ $21cb28dcb463e29e$var$_getImageData8bits,
    _getImageData16bits: /** @internal */ $21cb28dcb463e29e$var$_getImageData16bits,
    _getImageData24bits: /** @internal */ $21cb28dcb463e29e$var$_getImageData24bits,
    _getImageData32bits: /** @internal */ $21cb28dcb463e29e$var$_getImageData32bits,
    _getImageDataGrey8bits: /** @internal */ $21cb28dcb463e29e$var$_getImageDataGrey8bits,
    _getImageDataGrey16bits: /** @internal */ $21cb28dcb463e29e$var$_getImageDataGrey16bits
};

});


parcelRegister("ezxpO", function(module, exports) {

$parcel$export(module.exports, "_HDRTextureLoader", () => $a9be412b37b1a205$export$3ad3b07307e687ea);

var $jSNZm = parcelRequire("jSNZm");

var $5YkyR = parcelRequire("5YkyR");
class $a9be412b37b1a205$export$3ad3b07307e687ea {
    constructor(){
        /**
         * Defines whether the loader supports cascade loading the different faces.
         */ this.supportCascades = false;
    }
    /**
     * This returns if the loader support the current file information.
     * @param extension defines the file extension of the file being loaded
     * @returns true if the loader can load the specified file
     */ canLoad(extension) {
        return extension.endsWith(".hdr");
    }
    /**
     * Uploads the cube texture data to the WebGL texture. It has already been bound.
     */ loadCubeData() {
        // eslint-disable-next-line no-throw-literal
        throw ".env not supported in Cube.";
    }
    /**
     * Uploads the 2D texture data to the WebGL texture. It has already been bound once in the callback.
     * @param data contains the texture data
     * @param texture defines the BabylonJS internal texture
     * @param callback defines the method to call once ready to upload
     */ loadData(data, texture, callback) {
        const uint8array = new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
        const hdrInfo = (0, $jSNZm.HDRTools).RGBE_ReadHeader(uint8array);
        const pixelsDataRGB32 = (0, $jSNZm.HDRTools).RGBE_ReadPixels(uint8array, hdrInfo);
        const pixels = hdrInfo.width * hdrInfo.height;
        const pixelsDataRGBA32 = new Float32Array(pixels * 4);
        for(let i = 0; i < pixels; i += 1){
            pixelsDataRGBA32[i * 4] = pixelsDataRGB32[i * 3];
            pixelsDataRGBA32[i * 4 + 1] = pixelsDataRGB32[i * 3 + 1];
            pixelsDataRGBA32[i * 4 + 2] = pixelsDataRGB32[i * 3 + 2];
            pixelsDataRGBA32[i * 4 + 3] = 1;
        }
        callback(hdrInfo.width, hdrInfo.height, texture.generateMipMaps, false, ()=>{
            const engine = texture.getEngine();
            texture.type = 1;
            texture.format = 5;
            texture._gammaSpace = false;
            engine._uploadDataToTextureDirectly(texture, pixelsDataRGBA32);
        });
    }
}
// Register the loader.
(0, $5YkyR.Engine)._TextureLoaders.push(new $a9be412b37b1a205$export$3ad3b07307e687ea());

});

parcelRegister("d0PoS", function(module, exports) {

$parcel$export(module.exports, "_BasisTextureLoader", () => $0271db71507c12f5$export$4b8f8f3b0356c558);

var $5YkyR = parcelRequire("5YkyR");

var $02O3B = parcelRequire("02O3B");

var $bOhSV = parcelRequire("bOhSV");
class $0271db71507c12f5$export$4b8f8f3b0356c558 {
    constructor(){
        /**
         * Defines whether the loader supports cascade loading the different faces.
         */ this.supportCascades = false;
    }
    /**
     * This returns if the loader support the current file information.
     * @param extension defines the file extension of the file being loaded
     * @returns true if the loader can load the specified file
     */ canLoad(extension) {
        return extension.endsWith(".basis");
    }
    /**
     * Uploads the cube texture data to the WebGL texture. It has already been bound.
     * @param data contains the texture data
     * @param texture defines the BabylonJS internal texture
     * @param createPolynomials will be true if polynomials have been requested
     * @param onLoad defines the callback to trigger once the texture is ready
     * @param onError defines the callback to trigger in case of error
     */ loadCubeData(data, texture, createPolynomials, onLoad, onError) {
        if (Array.isArray(data)) return;
        const caps = texture.getEngine().getCaps();
        const transcodeConfig = {
            supportedCompressionFormats: {
                etc1: caps.etc1 ? true : false,
                s3tc: caps.s3tc ? true : false,
                pvrtc: caps.pvrtc ? true : false,
                etc2: caps.etc2 ? true : false,
                astc: caps.astc ? true : false,
                bc7: caps.bptc ? true : false
            }
        };
        (0, $02O3B.TranscodeAsync)(data, transcodeConfig).then((result)=>{
            const hasMipmap = result.fileInfo.images[0].levels.length > 1 && texture.generateMipMaps;
            (0, $02O3B.LoadTextureFromTranscodeResult)(texture, result);
            texture.getEngine()._setCubeMapTextureParams(texture, hasMipmap);
            texture.isReady = true;
            texture.onLoadedObservable.notifyObservers(texture);
            texture.onLoadedObservable.clear();
            if (onLoad) onLoad();
        }).catch((err)=>{
            const errorMessage = "Failed to transcode Basis file, transcoding may not be supported on this device";
            (0, $bOhSV.Tools).Warn(errorMessage);
            texture.isReady = true;
            if (onError) onError(err);
        });
    }
    /**
     * Uploads the 2D texture data to the WebGL texture. It has already been bound once in the callback.
     * @param data contains the texture data
     * @param texture defines the BabylonJS internal texture
     * @param callback defines the method to call once ready to upload
     */ loadData(data, texture, callback) {
        const caps = texture.getEngine().getCaps();
        const transcodeConfig = {
            supportedCompressionFormats: {
                etc1: caps.etc1 ? true : false,
                s3tc: caps.s3tc ? true : false,
                pvrtc: caps.pvrtc ? true : false,
                etc2: caps.etc2 ? true : false,
                astc: caps.astc ? true : false,
                bc7: caps.bptc ? true : false
            }
        };
        (0, $02O3B.TranscodeAsync)(data, transcodeConfig).then((result)=>{
            const rootImage = result.fileInfo.images[0].levels[0];
            const hasMipmap = result.fileInfo.images[0].levels.length > 1 && texture.generateMipMaps;
            callback(rootImage.width, rootImage.height, hasMipmap, result.format !== -1, ()=>{
                (0, $02O3B.LoadTextureFromTranscodeResult)(texture, result);
            });
        }).catch((err)=>{
            (0, $bOhSV.Tools).Warn("Failed to transcode Basis file, transcoding may not be supported on this device");
            (0, $bOhSV.Tools).Warn(`Failed to transcode Basis file: ${err}`);
            callback(0, 0, false, false, ()=>{}, true);
        });
    }
}
// Register the loader.
(0, $5YkyR.Engine)._TextureLoaders.push(new $0271db71507c12f5$export$4b8f8f3b0356c558());

});
parcelRegister("02O3B", function(module, exports) {

$parcel$export(module.exports, "BasisFileInfo", () => $0087044e67e7ceca$export$7205a00e057868af);
$parcel$export(module.exports, "BasisTranscodeConfiguration", () => $0087044e67e7ceca$export$2ad8241a01251b94);
$parcel$export(module.exports, "BasisToolsOptions", () => $0087044e67e7ceca$export$434c6eca3bbc1363);
$parcel$export(module.exports, "GetInternalFormatFromBasisFormat", () => $0087044e67e7ceca$export$ea4db16e865acae5);
$parcel$export(module.exports, "SetBasisTranscoderWorker", () => $0087044e67e7ceca$export$bee989bae2a0024e);
$parcel$export(module.exports, "TranscodeAsync", () => $0087044e67e7ceca$export$847235ea79250c51);
$parcel$export(module.exports, "LoadTextureFromTranscodeResult", () => $0087044e67e7ceca$export$2fb8e56a9f2d557);
$parcel$export(module.exports, "BasisTools", () => $0087044e67e7ceca$export$613fa9e792f43837);

var $bOhSV = parcelRequire("bOhSV");

var $j2mX5 = parcelRequire("j2mX5");

var $b9e4a = parcelRequire("b9e4a");

var $1VEEL = parcelRequire("1VEEL");

var $afgEM = parcelRequire("afgEM");
class $0087044e67e7ceca$export$7205a00e057868af {
}
/**
 * Result of transcoding a basis file
 */ class $0087044e67e7ceca$var$TranscodeResult {
}
class $0087044e67e7ceca$export$2ad8241a01251b94 {
}
/**
 * @internal
 * Enum of basis transcoder formats
 */ var $0087044e67e7ceca$var$BASIS_FORMATS;
(function(BASIS_FORMATS) {
    BASIS_FORMATS[BASIS_FORMATS["cTFETC1"] = 0] = "cTFETC1";
    BASIS_FORMATS[BASIS_FORMATS["cTFETC2"] = 1] = "cTFETC2";
    BASIS_FORMATS[BASIS_FORMATS["cTFBC1"] = 2] = "cTFBC1";
    BASIS_FORMATS[BASIS_FORMATS["cTFBC3"] = 3] = "cTFBC3";
    BASIS_FORMATS[BASIS_FORMATS["cTFBC4"] = 4] = "cTFBC4";
    BASIS_FORMATS[BASIS_FORMATS["cTFBC5"] = 5] = "cTFBC5";
    BASIS_FORMATS[BASIS_FORMATS["cTFBC7"] = 6] = "cTFBC7";
    BASIS_FORMATS[BASIS_FORMATS["cTFPVRTC1_4_RGB"] = 8] = "cTFPVRTC1_4_RGB";
    BASIS_FORMATS[BASIS_FORMATS["cTFPVRTC1_4_RGBA"] = 9] = "cTFPVRTC1_4_RGBA";
    BASIS_FORMATS[BASIS_FORMATS["cTFASTC_4x4"] = 10] = "cTFASTC_4x4";
    BASIS_FORMATS[BASIS_FORMATS["cTFATC_RGB"] = 11] = "cTFATC_RGB";
    BASIS_FORMATS[BASIS_FORMATS["cTFATC_RGBA_INTERPOLATED_ALPHA"] = 12] = "cTFATC_RGBA_INTERPOLATED_ALPHA";
    BASIS_FORMATS[BASIS_FORMATS["cTFRGBA32"] = 13] = "cTFRGBA32";
    BASIS_FORMATS[BASIS_FORMATS["cTFRGB565"] = 14] = "cTFRGB565";
    BASIS_FORMATS[BASIS_FORMATS["cTFBGR565"] = 15] = "cTFBGR565";
    BASIS_FORMATS[BASIS_FORMATS["cTFRGBA4444"] = 16] = "cTFRGBA4444";
    BASIS_FORMATS[BASIS_FORMATS["cTFFXT1_RGB"] = 17] = "cTFFXT1_RGB";
    BASIS_FORMATS[BASIS_FORMATS["cTFPVRTC2_4_RGB"] = 18] = "cTFPVRTC2_4_RGB";
    BASIS_FORMATS[BASIS_FORMATS["cTFPVRTC2_4_RGBA"] = 19] = "cTFPVRTC2_4_RGBA";
    BASIS_FORMATS[BASIS_FORMATS["cTFETC2_EAC_R11"] = 20] = "cTFETC2_EAC_R11";
    BASIS_FORMATS[BASIS_FORMATS["cTFETC2_EAC_RG11"] = 21] = "cTFETC2_EAC_RG11";
})($0087044e67e7ceca$var$BASIS_FORMATS || ($0087044e67e7ceca$var$BASIS_FORMATS = {}));
const $0087044e67e7ceca$export$434c6eca3bbc1363 = {
    /**
     * URL to use when loading the basis transcoder
     */ JSModuleURL: `${(0, $bOhSV.Tools)._DefaultCdnUrl}/basisTranscoder/1/basis_transcoder.js`,
    /**
     * URL to use when loading the wasm module for the transcoder
     */ WasmModuleURL: `${(0, $bOhSV.Tools)._DefaultCdnUrl}/basisTranscoder/1/basis_transcoder.wasm`
};
const $0087044e67e7ceca$export$ea4db16e865acae5 = (basisFormat, engine)=>{
    let format;
    switch(basisFormat){
        case $0087044e67e7ceca$var$BASIS_FORMATS.cTFETC1:
            format = 36196;
            break;
        case $0087044e67e7ceca$var$BASIS_FORMATS.cTFBC1:
            format = 33776;
            break;
        case $0087044e67e7ceca$var$BASIS_FORMATS.cTFBC4:
            format = 33779;
            break;
        case $0087044e67e7ceca$var$BASIS_FORMATS.cTFASTC_4x4:
            format = 37808;
            break;
        case $0087044e67e7ceca$var$BASIS_FORMATS.cTFETC2:
            format = 37496;
            break;
        case $0087044e67e7ceca$var$BASIS_FORMATS.cTFBC7:
            format = 36492;
            break;
    }
    if (format === undefined) // eslint-disable-next-line no-throw-literal
    throw "The chosen Basis transcoder format is not currently supported";
    return format;
};
let $0087044e67e7ceca$var$_WorkerPromise = null;
let $0087044e67e7ceca$var$_Worker = null;
let $0087044e67e7ceca$var$_actionId = 0;
const $0087044e67e7ceca$var$_IgnoreSupportedFormats = false;
const $0087044e67e7ceca$var$_CreateWorkerAsync = ()=>{
    if (!$0087044e67e7ceca$var$_WorkerPromise) $0087044e67e7ceca$var$_WorkerPromise = new Promise((res, reject)=>{
        if ($0087044e67e7ceca$var$_Worker) res($0087044e67e7ceca$var$_Worker);
        else (0, $bOhSV.Tools).LoadFileAsync((0, $bOhSV.Tools).GetBabylonScriptURL($0087044e67e7ceca$export$434c6eca3bbc1363.WasmModuleURL)).then((wasmBinary)=>{
            if (typeof URL !== "function") return reject("Basis transcoder requires an environment with a URL constructor");
            const workerBlobUrl = URL.createObjectURL(new Blob([
                `(${(0, $afgEM.workerFunction)})()`
            ], {
                type: "application/javascript"
            }));
            $0087044e67e7ceca$var$_Worker = new Worker(workerBlobUrl);
            (0, $afgEM.initializeWebWorker)($0087044e67e7ceca$var$_Worker, wasmBinary, $0087044e67e7ceca$export$434c6eca3bbc1363.JSModuleURL).then(res, reject);
        }).catch(reject);
    });
    return $0087044e67e7ceca$var$_WorkerPromise;
};
const $0087044e67e7ceca$export$bee989bae2a0024e = (worker)=>{
    $0087044e67e7ceca$var$_Worker = worker;
};
const $0087044e67e7ceca$export$847235ea79250c51 = (data, config)=>{
    const dataView = data instanceof ArrayBuffer ? new Uint8Array(data) : data;
    return new Promise((res, rej)=>{
        $0087044e67e7ceca$var$_CreateWorkerAsync().then(()=>{
            const actionId = $0087044e67e7ceca$var$_actionId++;
            const messageHandler = (msg)=>{
                if (msg.data.action === "transcode" && msg.data.id === actionId) {
                    $0087044e67e7ceca$var$_Worker.removeEventListener("message", messageHandler);
                    if (!msg.data.success) rej("Transcode is not supported on this device");
                    else res(msg.data);
                }
            };
            $0087044e67e7ceca$var$_Worker.addEventListener("message", messageHandler);
            const dataViewCopy = new Uint8Array(dataView.byteLength);
            dataViewCopy.set(new Uint8Array(dataView.buffer, dataView.byteOffset, dataView.byteLength));
            $0087044e67e7ceca$var$_Worker.postMessage({
                action: "transcode",
                id: actionId,
                imageData: dataViewCopy,
                config: config,
                ignoreSupportedFormats: $0087044e67e7ceca$var$_IgnoreSupportedFormats
            }, [
                dataViewCopy.buffer
            ]);
        }, (error)=>{
            rej(error);
        });
    });
};
/**
 * Binds a texture according to its underlying target.
 * @param texture texture to bind
 * @param engine the engine to bind the texture in
 */ const $0087044e67e7ceca$var$BindTexture = (texture, engine)=>{
    let target = engine._gl?.TEXTURE_2D;
    if (texture.isCube) target = engine._gl?.TEXTURE_CUBE_MAP;
    engine._bindTextureDirectly(target, texture, true);
};
const $0087044e67e7ceca$export$2fb8e56a9f2d557 = (texture, transcodeResult)=>{
    const engine = texture.getEngine();
    for(let i = 0; i < transcodeResult.fileInfo.images.length; i++){
        const rootImage = transcodeResult.fileInfo.images[i].levels[0];
        texture._invertVScale = texture.invertY;
        if (transcodeResult.format === -1 || transcodeResult.format === $0087044e67e7ceca$var$BASIS_FORMATS.cTFRGB565) {
            // No compatable compressed format found, fallback to RGB
            texture.type = 10;
            texture.format = 4;
            if (engine._features.basisNeedsPOT && ((0, $1VEEL.Scalar).Log2(rootImage.width) % 1 !== 0 || (0, $1VEEL.Scalar).Log2(rootImage.height) % 1 !== 0)) {
                // Create non power of two texture
                const source = new (0, $b9e4a.InternalTexture)(engine, (0, $b9e4a.InternalTextureSource).Temp);
                texture._invertVScale = texture.invertY;
                source.type = 10;
                source.format = 4;
                // Fallback requires aligned width/height
                source.width = rootImage.width + 3 & -4;
                source.height = rootImage.height + 3 & -4;
                $0087044e67e7ceca$var$BindTexture(source, engine);
                engine._uploadDataToTextureDirectly(source, new Uint16Array(rootImage.transcodedPixels.buffer), i, 0, 4, true);
                // Resize to power of two
                engine._rescaleTexture(source, texture, engine.scenes[0], engine._getInternalFormat(4), ()=>{
                    engine._releaseTexture(source);
                    $0087044e67e7ceca$var$BindTexture(texture, engine);
                });
            } else {
                // Fallback is already inverted
                texture._invertVScale = !texture.invertY;
                // Upload directly
                texture.width = rootImage.width + 3 & -4;
                texture.height = rootImage.height + 3 & -4;
                texture.samplingMode = 2;
                $0087044e67e7ceca$var$BindTexture(texture, engine);
                engine._uploadDataToTextureDirectly(texture, new Uint16Array(rootImage.transcodedPixels.buffer), i, 0, 4, true);
            }
        } else {
            texture.width = rootImage.width;
            texture.height = rootImage.height;
            texture.generateMipMaps = transcodeResult.fileInfo.images[i].levels.length > 1;
            const format = $0087044e67e7ceca$export$613fa9e792f43837.GetInternalFormatFromBasisFormat(transcodeResult.format, engine);
            texture.format = format;
            $0087044e67e7ceca$var$BindTexture(texture, engine);
            // Upload all mip levels in the file
            transcodeResult.fileInfo.images[i].levels.forEach((level, index)=>{
                engine._uploadCompressedDataToTextureDirectly(texture, format, level.width, level.height, level.transcodedPixels, i, index);
            });
            if (engine._features.basisNeedsPOT && ((0, $1VEEL.Scalar).Log2(texture.width) % 1 !== 0 || (0, $1VEEL.Scalar).Log2(texture.height) % 1 !== 0)) {
                (0, $bOhSV.Tools).Warn("Loaded .basis texture width and height are not a power of two. Texture wrapping will be set to Texture.CLAMP_ADDRESSMODE as other modes are not supported with non power of two dimensions in webGL 1.");
                texture._cachedWrapU = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
                texture._cachedWrapV = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
            }
        }
    }
};
const $0087044e67e7ceca$export$613fa9e792f43837 = {
    /**
     * URL to use when loading the basis transcoder
     */ JSModuleURL: $0087044e67e7ceca$export$434c6eca3bbc1363.JSModuleURL,
    /**
     * URL to use when loading the wasm module for the transcoder
     */ WasmModuleURL: $0087044e67e7ceca$export$434c6eca3bbc1363.WasmModuleURL,
    GetInternalFormatFromBasisFormat: /**
     * Get the internal format to be passed to texImage2D corresponding to the .basis format value
     * @param basisFormat format chosen from GetSupportedTranscodeFormat
     * @returns internal format corresponding to the Basis format
     */ $0087044e67e7ceca$export$ea4db16e865acae5,
    TranscodeAsync: /**
     * Transcodes a loaded image file to compressed pixel data
     * @param data image data to transcode
     * @param config configuration options for the transcoding
     * @returns a promise resulting in the transcoded image
     */ $0087044e67e7ceca$export$847235ea79250c51,
    LoadTextureFromTranscodeResult: /**
     * Loads a texture from the transcode result
     * @param texture texture load to
     * @param transcodeResult the result of transcoding the basis file to load from
     */ $0087044e67e7ceca$export$2fb8e56a9f2d557
};
Object.defineProperty($0087044e67e7ceca$export$613fa9e792f43837, "JSModuleURL", {
    get: function() {
        return $0087044e67e7ceca$export$434c6eca3bbc1363.JSModuleURL;
    },
    set: function(value) {
        $0087044e67e7ceca$export$434c6eca3bbc1363.JSModuleURL = value;
    }
});
Object.defineProperty($0087044e67e7ceca$export$613fa9e792f43837, "WasmModuleURL", {
    get: function() {
        return $0087044e67e7ceca$export$434c6eca3bbc1363.WasmModuleURL;
    },
    set: function(value) {
        $0087044e67e7ceca$export$434c6eca3bbc1363.WasmModuleURL = value;
    }
});

});
parcelRegister("afgEM", function(module, exports) {

$parcel$export(module.exports, "workerFunction", () => $775839ca65a71d17$export$4fa462ff61661f49);
$parcel$export(module.exports, "initializeWebWorker", () => $775839ca65a71d17$export$712a80800d0b66d1);

var $bOhSV = parcelRequire("bOhSV");
function $775839ca65a71d17$export$4fa462ff61661f49() {
    const _BASIS_FORMAT = {
        cTFETC1: 0,
        cTFETC2: 1,
        cTFBC1: 2,
        cTFBC3: 3,
        cTFBC4: 4,
        cTFBC5: 5,
        cTFBC7: 6,
        cTFPVRTC1_4_RGB: 8,
        cTFPVRTC1_4_RGBA: 9,
        cTFASTC_4x4: 10,
        cTFATC_RGB: 11,
        cTFATC_RGBA_INTERPOLATED_ALPHA: 12,
        cTFRGBA32: 13,
        cTFRGB565: 14,
        cTFBGR565: 15,
        cTFRGBA4444: 16,
        cTFFXT1_RGB: 17,
        cTFPVRTC2_4_RGB: 18,
        cTFPVRTC2_4_RGBA: 19,
        cTFETC2_EAC_R11: 20,
        cTFETC2_EAC_RG11: 21
    };
    let transcoderModulePromise = null;
    onmessage = (event)=>{
        if (event.data.action === "init") {
            // Load the transcoder if it hasn't been yet
            if (event.data.url) // make sure we loaded the script correctly
            try {
                importScripts(event.data.url);
            } catch (e) {
                postMessage({
                    action: "error",
                    error: e
                });
            }
            if (!transcoderModulePromise) transcoderModulePromise = BASIS({
                // Override wasm binary
                wasmBinary: event.data.wasmBinary
            });
            if (transcoderModulePromise !== null) transcoderModulePromise.then((m)=>{
                BASIS = m;
                m.initializeBasis();
                postMessage({
                    action: "init"
                });
            });
        } else if (event.data.action === "transcode") {
            // Transcode the basis image and return the resulting pixels
            const config = event.data.config;
            const imgData = event.data.imageData;
            const loadedFile = new BASIS.BasisFile(imgData);
            const fileInfo = GetFileInfo(loadedFile);
            let format = event.data.ignoreSupportedFormats ? null : GetSupportedTranscodeFormat(event.data.config, fileInfo);
            let needsConversion = false;
            if (format === null) {
                needsConversion = true;
                format = fileInfo.hasAlpha ? _BASIS_FORMAT.cTFBC3 : _BASIS_FORMAT.cTFBC1;
            }
            // Begin transcode
            let success = true;
            if (!loadedFile.startTranscoding()) success = false;
            const buffers = [];
            for(let imageIndex = 0; imageIndex < fileInfo.images.length; imageIndex++){
                if (!success) break;
                const image = fileInfo.images[imageIndex];
                if (config.loadSingleImage === undefined || config.loadSingleImage === imageIndex) {
                    let mipCount = image.levels.length;
                    if (config.loadMipmapLevels === false) mipCount = 1;
                    for(let levelIndex = 0; levelIndex < mipCount; levelIndex++){
                        const levelInfo = image.levels[levelIndex];
                        const pixels = TranscodeLevel(loadedFile, imageIndex, levelIndex, format, needsConversion);
                        if (!pixels) {
                            success = false;
                            break;
                        }
                        levelInfo.transcodedPixels = pixels;
                        buffers.push(levelInfo.transcodedPixels.buffer);
                    }
                }
            }
            // Close file
            loadedFile.close();
            loadedFile.delete();
            if (needsConversion) format = -1;
            if (!success) postMessage({
                action: "transcode",
                success: success,
                id: event.data.id
            });
            else postMessage({
                action: "transcode",
                success: success,
                id: event.data.id,
                fileInfo: fileInfo,
                format: format
            }, buffers);
        }
    };
    /**
     * Detects the supported transcode format for the file
     * @param config transcode config
     * @param fileInfo info about the file
     * @returns the chosed format or null if none are supported
     */ function GetSupportedTranscodeFormat(config, fileInfo) {
        let format = null;
        if (config.supportedCompressionFormats) {
            if (config.supportedCompressionFormats.astc) format = _BASIS_FORMAT.cTFASTC_4x4;
            else if (config.supportedCompressionFormats.bc7) format = _BASIS_FORMAT.cTFBC7;
            else if (config.supportedCompressionFormats.s3tc) format = fileInfo.hasAlpha ? _BASIS_FORMAT.cTFBC3 : _BASIS_FORMAT.cTFBC1;
            else if (config.supportedCompressionFormats.pvrtc) format = fileInfo.hasAlpha ? _BASIS_FORMAT.cTFPVRTC1_4_RGBA : _BASIS_FORMAT.cTFPVRTC1_4_RGB;
            else if (config.supportedCompressionFormats.etc2) format = _BASIS_FORMAT.cTFETC2;
            else if (config.supportedCompressionFormats.etc1) format = _BASIS_FORMAT.cTFETC1;
            else format = _BASIS_FORMAT.cTFRGB565;
        }
        return format;
    }
    /**
     * Retrieves information about the basis file eg. dimensions
     * @param basisFile the basis file to get the info from
     * @returns information about the basis file
     */ function GetFileInfo(basisFile) {
        const hasAlpha = basisFile.getHasAlpha();
        const imageCount = basisFile.getNumImages();
        const images = [];
        for(let i = 0; i < imageCount; i++){
            const imageInfo = {
                levels: []
            };
            const levelCount = basisFile.getNumLevels(i);
            for(let level = 0; level < levelCount; level++){
                const levelInfo = {
                    width: basisFile.getImageWidth(i, level),
                    height: basisFile.getImageHeight(i, level)
                };
                imageInfo.levels.push(levelInfo);
            }
            images.push(imageInfo);
        }
        const info = {
            hasAlpha: hasAlpha,
            images: images
        };
        return info;
    }
    function TranscodeLevel(loadedFile, imageIndex, levelIndex, format, convertToRgb565) {
        const dstSize = loadedFile.getImageTranscodedSizeInBytes(imageIndex, levelIndex, format);
        let dst = new Uint8Array(dstSize);
        if (!loadedFile.transcodeImage(dst, imageIndex, levelIndex, format, 1, 0)) return null;
        // If no supported format is found, load as dxt and convert to rgb565
        if (convertToRgb565) {
            const alignedWidth = loadedFile.getImageWidth(imageIndex, levelIndex) + 3 & -4;
            const alignedHeight = loadedFile.getImageHeight(imageIndex, levelIndex) + 3 & -4;
            dst = ConvertDxtToRgb565(dst, 0, alignedWidth, alignedHeight);
        }
        return dst;
    }
    /**
     * From https://github.com/BinomialLLC/basis_universal/blob/master/webgl/texture/dxt-to-rgb565.js
     * An unoptimized version of dxtToRgb565.  Also, the floating
     * point math used to compute the colors actually results in
     * slightly different colors compared to hardware DXT decoders.
     * @param src dxt src pixels
     * @param srcByteOffset offset for the start of src
     * @param  width aligned width of the image
     * @param  height aligned height of the image
     * @returns the converted pixels
     */ function ConvertDxtToRgb565(src, srcByteOffset, width, height) {
        const c = new Uint16Array(4);
        const dst = new Uint16Array(width * height);
        const blockWidth = width / 4;
        const blockHeight = height / 4;
        for(let blockY = 0; blockY < blockHeight; blockY++)for(let blockX = 0; blockX < blockWidth; blockX++){
            const i = srcByteOffset + 8 * (blockY * blockWidth + blockX);
            c[0] = src[i] | src[i + 1] << 8;
            c[1] = src[i + 2] | src[i + 3] << 8;
            c[2] = (2 * (c[0] & 0x1f) + 1 * (c[1] & 0x1f)) / 3 | (2 * (c[0] & 0x7e0) + 1 * (c[1] & 0x7e0)) / 3 & 0x7e0 | (2 * (c[0] & 0xf800) + 1 * (c[1] & 0xf800)) / 3 & 0xf800;
            c[3] = (2 * (c[1] & 0x1f) + 1 * (c[0] & 0x1f)) / 3 | (2 * (c[1] & 0x7e0) + 1 * (c[0] & 0x7e0)) / 3 & 0x7e0 | (2 * (c[1] & 0xf800) + 1 * (c[0] & 0xf800)) / 3 & 0xf800;
            for(let row = 0; row < 4; row++){
                const m = src[i + 4 + row];
                let dstI = (blockY * 4 + row) * width + blockX * 4;
                dst[dstI++] = c[m & 0x3];
                dst[dstI++] = c[m >> 2 & 0x3];
                dst[dstI++] = c[m >> 4 & 0x3];
                dst[dstI++] = c[m >> 6 & 0x3];
            }
        }
        return dst;
    }
}
function $775839ca65a71d17$export$712a80800d0b66d1(worker, wasmBinary, moduleUrl) {
    return new Promise((res, reject)=>{
        const initHandler = (msg)=>{
            if (msg.data.action === "init") {
                worker.removeEventListener("message", initHandler);
                res(worker);
            } else if (msg.data.action === "error") reject(msg.data.error || "error initializing worker");
        };
        worker.addEventListener("message", initHandler);
        // we can use transferable objects here because the worker will own the ArrayBuffer
        worker.postMessage({
            action: "init",
            url: moduleUrl ? (0, $bOhSV.Tools).GetBabylonScriptURL(moduleUrl) : undefined,
            wasmBinary: wasmBinary
        }, [
            wasmBinary
        ]);
    });
}

});




parcelRegister("3TXsv", function(module, exports) {

$parcel$export(module.exports, "MultiRenderTarget", () => $2d74a16bff4ef9de$export$81ca19ef131ad840);

var $j2mX5 = parcelRequire("j2mX5");

var $gQtNK = parcelRequire("gQtNK");
parcelRequire("1uz5x");
class $2d74a16bff4ef9de$export$81ca19ef131ad840 extends (0, $gQtNK.RenderTargetTexture) {
    /**
     * Get if draw buffers (render textures) are currently supported by the used hardware and browser.
     */ get isSupported() {
        return this._engine?.getCaps().drawBuffersExtension ?? false;
    }
    /**
     * Get the list of textures generated by the multi render target.
     */ get textures() {
        return this._textures;
    }
    /**
     * Gets the number of textures in this MRT. This number can be different from `_textures.length` in case a depth texture is generated.
     */ get count() {
        return this._count;
    }
    /**
     * Get the depth texture generated by the multi render target if options.generateDepthTexture has been set
     */ get depthTexture() {
        return this._textures[this._textures.length - 1];
    }
    /**
     * Set the wrapping mode on U of all the textures we are rendering to.
     * Can be any of the Texture. (CLAMP_ADDRESSMODE, MIRROR_ADDRESSMODE or WRAP_ADDRESSMODE)
     */ set wrapU(wrap) {
        if (this._textures) for(let i = 0; i < this._textures.length; i++)this._textures[i].wrapU = wrap;
    }
    /**
     * Set the wrapping mode on V of all the textures we are rendering to.
     * Can be any of the Texture. (CLAMP_ADDRESSMODE, MIRROR_ADDRESSMODE or WRAP_ADDRESSMODE)
     */ set wrapV(wrap) {
        if (this._textures) for(let i = 0; i < this._textures.length; i++)this._textures[i].wrapV = wrap;
    }
    /**
     * Instantiate a new multi render target texture.
     * A multi render target, like a render target provides the ability to render to a texture.
     * Unlike the render target, it can render to several draw buffers (render textures) in one draw.
     * This is specially interesting in deferred rendering or for any effects requiring more than
     * just one color from a single pass.
     * @param name Define the name of the texture
     * @param size Define the size of the buffers to render to
     * @param count Define the number of target we are rendering into
     * @param scene Define the scene the texture belongs to
     * @param options Define the options used to create the multi render target
     * @param textureNames Define the names to set to the textures (if count \> 0 - optional)
     */ constructor(name, size, count, scene, options, textureNames){
        const generateMipMaps = options && options.generateMipMaps ? options.generateMipMaps : false;
        const generateDepthTexture = options && options.generateDepthTexture ? options.generateDepthTexture : false;
        const depthTextureFormat = options && options.depthTextureFormat ? options.depthTextureFormat : 15;
        const doNotChangeAspectRatio = !options || options.doNotChangeAspectRatio === undefined ? true : options.doNotChangeAspectRatio;
        const drawOnlyOnFirstAttachmentByDefault = options && options.drawOnlyOnFirstAttachmentByDefault ? options.drawOnlyOnFirstAttachmentByDefault : false;
        super(name, size, scene, generateMipMaps, doNotChangeAspectRatio, undefined, undefined, undefined, undefined, undefined, undefined, undefined, true);
        if (!this.isSupported) {
            this.dispose();
            return;
        }
        this._textureNames = textureNames;
        const types = [];
        const samplingModes = [];
        const useSRGBBuffers = [];
        const formats = [];
        const targetTypes = [];
        const faceIndex = [];
        const layerIndex = [];
        const layerCounts = [];
        this._initTypes(count, types, samplingModes, useSRGBBuffers, formats, targetTypes, faceIndex, layerIndex, layerCounts, options);
        const generateDepthBuffer = !options || options.generateDepthBuffer === undefined ? true : options.generateDepthBuffer;
        const generateStencilBuffer = !options || options.generateStencilBuffer === undefined ? false : options.generateStencilBuffer;
        this._multiRenderTargetOptions = {
            samplingModes: samplingModes,
            generateMipMaps: generateMipMaps,
            generateDepthBuffer: generateDepthBuffer,
            generateStencilBuffer: generateStencilBuffer,
            generateDepthTexture: generateDepthTexture,
            depthTextureFormat: depthTextureFormat,
            types: types,
            textureCount: count,
            useSRGBBuffers: useSRGBBuffers,
            formats: formats,
            targetTypes: targetTypes,
            faceIndex: faceIndex,
            layerIndex: layerIndex,
            layerCounts: layerCounts,
            labels: textureNames,
            label: name
        };
        this._count = count;
        this._drawOnlyOnFirstAttachmentByDefault = drawOnlyOnFirstAttachmentByDefault;
        if (count > 0) {
            this._createInternalTextures();
            this._createTextures(textureNames);
        }
    }
    _initTypes(count, types, samplingModes, useSRGBBuffers, formats, targets, faceIndex, layerIndex, layerCounts, options) {
        for(let i = 0; i < count; i++){
            if (options && options.types && options.types[i] !== undefined) types.push(options.types[i]);
            else types.push(options && options.defaultType ? options.defaultType : 0);
            if (options && options.samplingModes && options.samplingModes[i] !== undefined) samplingModes.push(options.samplingModes[i]);
            else samplingModes.push((0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE);
            if (options && options.useSRGBBuffers && options.useSRGBBuffers[i] !== undefined) useSRGBBuffers.push(options.useSRGBBuffers[i]);
            else useSRGBBuffers.push(false);
            if (options && options.formats && options.formats[i] !== undefined) formats.push(options.formats[i]);
            else formats.push(5);
            if (options && options.targetTypes && options.targetTypes[i] !== undefined) targets.push(options.targetTypes[i]);
            else targets.push(3553);
            if (options && options.faceIndex && options.faceIndex[i] !== undefined) faceIndex.push(options.faceIndex[i]);
            else faceIndex.push(0);
            if (options && options.layerIndex && options.layerIndex[i] !== undefined) layerIndex.push(options.layerIndex[i]);
            else layerIndex.push(0);
            if (options && options.layerCounts && options.layerCounts[i] !== undefined) layerCounts.push(options.layerCounts[i]);
            else layerCounts.push(1);
        }
    }
    _createInternaTextureIndexMapping() {
        const mapMainInternalTexture2Index = {};
        const mapInternalTexture2MainIndex = [];
        if (!this._renderTarget) return mapInternalTexture2MainIndex;
        const internalTextures = this._renderTarget.textures;
        for(let i = 0; i < internalTextures.length; i++){
            const texture = internalTextures[i];
            if (!texture) continue;
            const mainIndex = mapMainInternalTexture2Index[texture.uniqueId];
            if (mainIndex !== undefined) mapInternalTexture2MainIndex[i] = mainIndex;
            else mapMainInternalTexture2Index[texture.uniqueId] = i;
        }
        return mapInternalTexture2MainIndex;
    }
    /**
     * @internal
     */ _rebuild(fromContextLost = false, forceFullRebuild = false, textureNames) {
        if (this._count < 1 || fromContextLost) return;
        const mapInternalTexture2MainIndex = this._createInternaTextureIndexMapping();
        this.releaseInternalTextures();
        this._createInternalTextures();
        if (forceFullRebuild) {
            this._releaseTextures();
            this._createTextures(textureNames);
        }
        const internalTextures = this._renderTarget.textures;
        for(let i = 0; i < internalTextures.length; i++){
            const texture = this._textures[i];
            if (mapInternalTexture2MainIndex[i] !== undefined) this._renderTarget.setTexture(internalTextures[mapInternalTexture2MainIndex[i]], i);
            texture._texture = internalTextures[i];
            if (texture._texture) {
                texture._noMipmap = !texture._texture.useMipMaps;
                texture._useSRGBBuffer = texture._texture._useSRGBBuffer;
            }
        }
        if (this.samples !== 1) this._renderTarget.setSamples(this.samples, !this._drawOnlyOnFirstAttachmentByDefault, true);
    }
    _createInternalTextures() {
        this._renderTarget = this._getEngine().createMultipleRenderTarget(this._size, this._multiRenderTargetOptions, !this._drawOnlyOnFirstAttachmentByDefault);
        this._texture = this._renderTarget.texture;
    }
    _releaseTextures() {
        if (this._textures) for(let i = 0; i < this._textures.length; i++){
            this._textures[i]._texture = null; // internal textures are released by a call to releaseInternalTextures()
            this._textures[i].dispose();
        }
    }
    _createTextures(textureNames) {
        const internalTextures = this._renderTarget.textures;
        this._textures = [];
        for(let i = 0; i < internalTextures.length; i++){
            const texture = new (0, $j2mX5.Texture)(null, this.getScene());
            if (textureNames?.[i]) texture.name = textureNames[i];
            texture._texture = internalTextures[i];
            if (texture._texture) {
                texture._noMipmap = !texture._texture.useMipMaps;
                texture._useSRGBBuffer = texture._texture._useSRGBBuffer;
            }
            this._textures.push(texture);
        }
    }
    /**
     * Replaces an internal texture within the MRT. Useful to share textures between MultiRenderTarget.
     * @param texture The new texture to set in the MRT
     * @param index The index of the texture to replace
     * @param disposePrevious Set to true if the previous internal texture should be disposed
     */ setInternalTexture(texture, index, disposePrevious = true) {
        if (!this.renderTarget) return;
        if (index === 0) this._texture = texture;
        this.renderTarget.setTexture(texture, index, disposePrevious);
        if (!this.textures[index]) {
            this.textures[index] = new (0, $j2mX5.Texture)(null, this.getScene());
            this.textures[index].name = this._textureNames?.[index] ?? this.textures[index].name;
        }
        this.textures[index]._texture = texture;
        this.textures[index]._noMipmap = !texture.useMipMaps;
        this.textures[index]._useSRGBBuffer = texture._useSRGBBuffer;
        this._count = this.renderTarget.textures ? this.renderTarget.textures.length : 0;
        if (this._multiRenderTargetOptions.types) this._multiRenderTargetOptions.types[index] = texture.type;
        if (this._multiRenderTargetOptions.samplingModes) this._multiRenderTargetOptions.samplingModes[index] = texture.samplingMode;
        if (this._multiRenderTargetOptions.useSRGBBuffers) this._multiRenderTargetOptions.useSRGBBuffers[index] = texture._useSRGBBuffer;
        if (this._multiRenderTargetOptions.targetTypes && this._multiRenderTargetOptions.targetTypes[index] !== -1) {
            let target = 0;
            if (texture.is2DArray) target = 35866;
            else if (texture.isCube) target = 34067;
            else if (texture.is3D) target = 32879;
            else target = 3553;
            this._multiRenderTargetOptions.targetTypes[index] = target;
        }
    }
    /**
     * Changes an attached texture's face index or layer.
     * @param index The index of the texture to modify the attachment of
     * @param layerIndex The layer index of the texture to be attached to the framebuffer
     * @param faceIndex The face index of the texture to be attached to the framebuffer
     */ setLayerAndFaceIndex(index, layerIndex = -1, faceIndex = -1) {
        if (!this.textures[index] || !this.renderTarget) return;
        if (this._multiRenderTargetOptions.layerIndex) this._multiRenderTargetOptions.layerIndex[index] = layerIndex;
        if (this._multiRenderTargetOptions.faceIndex) this._multiRenderTargetOptions.faceIndex[index] = faceIndex;
        this.renderTarget.setLayerAndFaceIndex(index, layerIndex, faceIndex);
    }
    /**
     * Changes every attached texture's face index or layer.
     * @param layerIndices The layer indices of the texture to be attached to the framebuffer
     * @param faceIndices The face indices of the texture to be attached to the framebuffer
     */ setLayerAndFaceIndices(layerIndices, faceIndices) {
        if (!this.renderTarget) return;
        this._multiRenderTargetOptions.layerIndex = layerIndices;
        this._multiRenderTargetOptions.faceIndex = faceIndices;
        this.renderTarget.setLayerAndFaceIndices(layerIndices, faceIndices);
    }
    /**
     * Define the number of samples used if MSAA is enabled.
     */ get samples() {
        return this._samples;
    }
    set samples(value) {
        if (this._renderTarget) this._samples = this._renderTarget.setSamples(value);
        else // In case samples are set with 0 textures created, we must save the desired samples value
        this._samples = value;
    }
    /**
     * Resize all the textures in the multi render target.
     * Be careful as it will recreate all the data in the new texture.
     * @param size Define the new size
     */ resize(size) {
        this._processSizeParameter(size, false);
        this._rebuild(false, undefined, this._textureNames);
    }
    /**
     * Changes the number of render targets in this MRT
     * Be careful as it will recreate all the data in the new texture.
     * @param count new texture count
     * @param options Specifies texture types and sampling modes for new textures
     * @param textureNames Specifies the names of the textures (optional)
     */ updateCount(count, options, textureNames) {
        this._multiRenderTargetOptions.textureCount = count;
        this._count = count;
        const types = [];
        const samplingModes = [];
        const useSRGBBuffers = [];
        const formats = [];
        const targetTypes = [];
        const faceIndex = [];
        const layerIndex = [];
        const layerCounts = [];
        this._textureNames = textureNames;
        this._initTypes(count, types, samplingModes, useSRGBBuffers, formats, targetTypes, faceIndex, layerIndex, layerCounts, options);
        this._multiRenderTargetOptions.types = types;
        this._multiRenderTargetOptions.samplingModes = samplingModes;
        this._multiRenderTargetOptions.useSRGBBuffers = useSRGBBuffers;
        this._multiRenderTargetOptions.formats = formats;
        this._multiRenderTargetOptions.targetTypes = targetTypes;
        this._multiRenderTargetOptions.faceIndex = faceIndex;
        this._multiRenderTargetOptions.layerIndex = layerIndex;
        this._multiRenderTargetOptions.layerCounts = layerCounts;
        this._multiRenderTargetOptions.labels = textureNames;
        this._rebuild(false, true, textureNames);
    }
    _unbindFrameBuffer(engine, faceIndex) {
        if (this._renderTarget) engine.unBindMultiColorAttachmentFramebuffer(this._renderTarget, this.isCube, ()=>{
            this.onAfterRenderObservable.notifyObservers(faceIndex);
        });
    }
    /**
     * Dispose the render targets and their associated resources
     * @param doNotDisposeInternalTextures if set to true, internal textures won't be disposed (default: false).
     */ dispose(doNotDisposeInternalTextures = false) {
        this._releaseTextures();
        if (!doNotDisposeInternalTextures) this.releaseInternalTextures();
        else // Prevent internal texture dispose in super.dispose
        this._texture = null;
        super.dispose();
    }
    /**
     * Release all the underlying texture used as draw buffers (render textures).
     */ releaseInternalTextures() {
        const internalTextures = this._renderTarget?.textures;
        if (!internalTextures) return;
        for(let i = internalTextures.length - 1; i >= 0; i--)this._textures[i]._texture = null;
        this._renderTarget?.dispose();
        this._renderTarget = null;
    }
}

});

parcelRegister("iAir6", function(module, exports) {

var $j6QeV = parcelRequire("j6QeV");

var $aZmLG = parcelRequire("aZmLG");
$parcel$exportWildcard(module.exports, $j6QeV);
$parcel$exportWildcard(module.exports, $aZmLG);

});
parcelRegister("j6QeV", function(module, exports) {

$parcel$export(module.exports, "TexturePacker", () => $de97199b54b17a66$export$50cdc69105291fc1);

var $5YkyR = parcelRequire("5YkyR");

var $b4i1f = parcelRequire("b4i1f");

var $j2mX5 = parcelRequire("j2mX5");

var $fJfwX = parcelRequire("fJfwX");

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $aZmLG = parcelRequire("aZmLG");

var $kVtWi = parcelRequire("kVtWi");

var $bOhSV = parcelRequire("bOhSV");
class $de97199b54b17a66$export$50cdc69105291fc1 {
    /**
     * Initializes a texture package series from an array of meshes or a single mesh.
     * @param name The name of the package
     * @param meshes The target meshes to compose the package from
     * @param options The arguments that texture packer should follow while building.
     * @param scene The scene which the textures are scoped to.
     * @returns TexturePacker
     */ constructor(name, meshes, options, scene){
        this.name = name;
        this.meshes = meshes;
        this.scene = scene;
        /**
         * Run through the options and set what ever defaults are needed that where not declared.
         */ this.options = options;
        this.options.map = this.options.map ?? [
            "ambientTexture",
            "bumpTexture",
            "diffuseTexture",
            "emissiveTexture",
            "lightmapTexture",
            "opacityTexture",
            "reflectionTexture",
            "refractionTexture",
            "specularTexture"
        ];
        this.options.uvsIn = this.options.uvsIn ?? (0, $b4i1f.VertexBuffer).UVKind;
        this.options.uvsOut = this.options.uvsOut ?? (0, $b4i1f.VertexBuffer).UVKind;
        this.options.layout = this.options.layout ?? $de97199b54b17a66$export$50cdc69105291fc1.LAYOUT_STRIP;
        if (this.options.layout === $de97199b54b17a66$export$50cdc69105291fc1.LAYOUT_COLNUM) this.options.colnum = this.options.colnum ?? 8;
        this.options.updateInputMeshes = this.options.updateInputMeshes ?? true;
        this.options.disposeSources = this.options.disposeSources ?? true;
        this._expecting = 0;
        this.options.fillBlanks = this.options.fillBlanks ?? true;
        if (this.options.fillBlanks === true) this.options.customFillColor = this.options.customFillColor ?? "black";
        this.options.frameSize = this.options.frameSize ?? 256;
        this.options.paddingRatio = this.options.paddingRatio ?? 0.0115;
        this._paddingValue = Math.ceil(this.options.frameSize * this.options.paddingRatio);
        //Make it an even padding Number.
        if (this._paddingValue % 2 !== 0) this._paddingValue++;
        this.options.paddingMode = this.options.paddingMode ?? $de97199b54b17a66$export$50cdc69105291fc1.SUBUV_WRAP;
        if (this.options.paddingMode === $de97199b54b17a66$export$50cdc69105291fc1.SUBUV_COLOR) this.options.paddingColor = this.options.paddingColor ?? new (0, $7etnY.Color4)(0, 0, 0, 1.0);
        this.sets = {};
        this.frames = [];
        return this;
    }
    /**
     * Starts the package process
     * @param resolve The promises resolution function
     */ _createFrames(resolve) {
        const dtSize = this._calculateSize();
        const dtUnits = new (0, $ha1VO.Vector2)(1, 1).divide(dtSize);
        let doneCount = 0;
        const expecting = this._expecting;
        const meshLength = this.meshes.length;
        const sKeys = Object.keys(this.sets);
        for(let i = 0; i < sKeys.length; i++){
            const setName = sKeys[i];
            const dt = new (0, $fJfwX.DynamicTexture)(this.name + ".TexturePack." + setName + "Set", {
                width: dtSize.x,
                height: dtSize.y
            }, this.scene, true, (0, $j2mX5.Texture).TRILINEAR_SAMPLINGMODE, (0, $5YkyR.Engine).TEXTUREFORMAT_RGBA);
            const dtx = dt.getContext();
            dtx.fillStyle = "rgba(0,0,0,0)";
            dtx.fillRect(0, 0, dtSize.x, dtSize.y);
            dt.update(false);
            this.sets[setName] = dt;
        }
        const baseSize = this.options.frameSize || 256;
        const padding = this._paddingValue;
        const tcs = baseSize + 2 * padding;
        const done = ()=>{
            this._calculateMeshUVFrames(baseSize, padding, dtSize, dtUnits, this.options.updateInputMeshes || false);
        };
        //Update the Textures
        for(let i = 0; i < meshLength; i++){
            const m = this.meshes[i];
            const mat = m.material;
            //Check if the material has the texture
            //Create a temporary canvas the same size as 1 frame
            //Then apply the texture to the center and the 8 offsets
            //Copy the Context and place in the correct frame on the DT
            for(let j = 0; j < sKeys.length; j++){
                const tempTexture = new (0, $fJfwX.DynamicTexture)("temp", tcs, this.scene, true);
                const tcx = tempTexture.getContext();
                const offset = this._getFrameOffset(i);
                const updateDt = ()=>{
                    doneCount++;
                    tempTexture.update(false);
                    const iDat = tcx.getImageData(0, 0, tcs, tcs);
                    //Update Set
                    const dt = this.sets[setName];
                    const dtx = dt.getContext();
                    dtx.putImageData(iDat, dtSize.x * offset.x, dtSize.y * offset.y);
                    tempTexture.dispose();
                    dt.update(false);
                    if (doneCount == expecting) {
                        done();
                        resolve();
                        return;
                    }
                };
                const setName = sKeys[j] || "_blank";
                if (!mat || mat[setName] === null) {
                    tcx.fillStyle = "rgba(0,0,0,0)";
                    if (this.options.fillBlanks) tcx.fillStyle = this.options.customFillColor;
                    tcx.fillRect(0, 0, tcs, tcs);
                    updateDt();
                } else {
                    const setTexture = mat[setName];
                    const img = new Image();
                    if (setTexture instanceof (0, $fJfwX.DynamicTexture)) img.src = setTexture.getContext().canvas.toDataURL("image/png");
                    else img.src = setTexture.url;
                    (0, $bOhSV.Tools).SetCorsBehavior(img.src, img);
                    img.onload = ()=>{
                        tcx.fillStyle = "rgba(0,0,0,0)";
                        tcx.fillRect(0, 0, tcs, tcs);
                        tempTexture.update(false);
                        tcx.setTransform(1, 0, 0, -1, 0, 0);
                        const cellOffsets = [
                            0,
                            0,
                            1,
                            0,
                            1,
                            1,
                            0,
                            1,
                            -1,
                            1,
                            -1,
                            0,
                            -2,
                            0,
                            -1,
                            1,
                            -1
                        ];
                        switch(this.options.paddingMode){
                            //Wrap Mode
                            case 0:
                                for(let i = 0; i < 9; i++)tcx.drawImage(img, 0, 0, img.width, img.height, padding + baseSize * cellOffsets[i], padding + baseSize * cellOffsets[i + 1] - tcs, baseSize, baseSize);
                                break;
                            //Extend Mode
                            case 1:
                                for(let i = 0; i < padding; i++){
                                    tcx.drawImage(img, 0, 0, img.width, img.height, i + baseSize * cellOffsets[0], padding - tcs, baseSize, baseSize);
                                    tcx.drawImage(img, 0, 0, img.width, img.height, padding * 2 - i, padding - tcs, baseSize, baseSize);
                                    tcx.drawImage(img, 0, 0, img.width, img.height, padding, i - tcs, baseSize, baseSize);
                                    tcx.drawImage(img, 0, 0, img.width, img.height, padding, padding * 2 - i - tcs, baseSize, baseSize);
                                }
                                tcx.drawImage(img, 0, 0, img.width, img.height, padding + baseSize * cellOffsets[0], padding + baseSize * cellOffsets[1] - tcs, baseSize, baseSize);
                                break;
                            //Color Mode
                            case 2:
                                tcx.fillStyle = (this.options.paddingColor || (0, $7etnY.Color3).Black()).toHexString();
                                tcx.fillRect(0, 0, tcs, -tcs);
                                tcx.clearRect(padding, padding, baseSize, baseSize);
                                tcx.drawImage(img, 0, 0, img.width, img.height, padding + baseSize * cellOffsets[0], padding + baseSize * cellOffsets[1] - tcs, baseSize, baseSize);
                                break;
                        }
                        tcx.setTransform(1, 0, 0, 1, 0, 0);
                        updateDt();
                    };
                }
            }
        }
    }
    /**
     * Calculates the Size of the Channel Sets
     * @returns Vector2
     */ _calculateSize() {
        const meshLength = this.meshes.length || 0;
        const baseSize = this.options.frameSize || 0;
        const padding = this._paddingValue || 0;
        switch(this.options.layout){
            case 0:
                //STRIP_LAYOUT
                return new (0, $ha1VO.Vector2)(baseSize * meshLength + 2 * padding * meshLength, baseSize + 2 * padding);
            case 1:
                {
                    //POWER2
                    const sqrtCount = Math.max(2, Math.ceil(Math.sqrt(meshLength)));
                    const size = baseSize * sqrtCount + 2 * padding * sqrtCount;
                    return new (0, $ha1VO.Vector2)(size, size);
                }
            case 2:
                {
                    //COLNUM
                    const cols = this.options.colnum || 1;
                    const rowCnt = Math.max(1, Math.ceil(meshLength / cols));
                    return new (0, $ha1VO.Vector2)(baseSize * cols + 2 * padding * cols, baseSize * rowCnt + 2 * padding * rowCnt);
                }
        }
        return (0, $ha1VO.Vector2).Zero();
    }
    /**
     * Calculates the UV data for the frames.
     * @param baseSize the base frameSize
     * @param padding the base frame padding
     * @param dtSize size of the Dynamic Texture for that channel
     * @param dtUnits is 1/dtSize
     * @param update flag to update the input meshes
     */ _calculateMeshUVFrames(baseSize, padding, dtSize, dtUnits, update) {
        const meshLength = this.meshes.length;
        for(let i = 0; i < meshLength; i++){
            const m = this.meshes[i];
            const scale = new (0, $ha1VO.Vector2)(baseSize / dtSize.x, baseSize / dtSize.y);
            const pOffset = dtUnits.clone().scale(padding);
            const frameOffset = this._getFrameOffset(i);
            const offset = frameOffset.add(pOffset);
            const frame = new (0, $aZmLG.TexturePackerFrame)(i, scale, offset);
            this.frames.push(frame);
            //Update Output UVs
            if (update) {
                this._updateMeshUV(m, i);
                this._updateTextureReferences(m);
            }
        }
    }
    /**
     * Calculates the frames Offset.
     * @param index of the frame
     * @returns Vector2
     */ _getFrameOffset(index) {
        const meshLength = this.meshes.length;
        let uvStep, yStep, xStep;
        switch(this.options.layout){
            case 0:
                //STRIP_LAYOUT
                uvStep = 1 / meshLength;
                return new (0, $ha1VO.Vector2)(index * uvStep, 0);
            case 1:
                {
                    //POWER2
                    const sqrtCount = Math.max(2, Math.ceil(Math.sqrt(meshLength)));
                    yStep = Math.floor(index / sqrtCount);
                    xStep = index - yStep * sqrtCount;
                    uvStep = 1 / sqrtCount;
                    return new (0, $ha1VO.Vector2)(xStep * uvStep, yStep * uvStep);
                }
            case 2:
                {
                    //COLNUM
                    const cols = this.options.colnum || 1;
                    const rowCnt = Math.max(1, Math.ceil(meshLength / cols));
                    xStep = Math.floor(index / rowCnt);
                    yStep = index - xStep * rowCnt;
                    uvStep = new (0, $ha1VO.Vector2)(1 / cols, 1 / rowCnt);
                    return new (0, $ha1VO.Vector2)(xStep * uvStep.x, yStep * uvStep.y);
                }
        }
        return (0, $ha1VO.Vector2).Zero();
    }
    /**
     * Updates a Mesh to the frame data
     * @param mesh that is the target
     * @param frameID or the frame index
     */ _updateMeshUV(mesh, frameID) {
        const frame = this.frames[frameID];
        const uvIn = mesh.getVerticesData(this.options.uvsIn || (0, $b4i1f.VertexBuffer).UVKind);
        const uvOut = [];
        let toCount = 0;
        if (uvIn.length) toCount = uvIn.length || 0;
        for(let i = 0; i < toCount; i += 2)uvOut.push(uvIn[i] * frame.scale.x + frame.offset.x, uvIn[i + 1] * frame.scale.y + frame.offset.y);
        mesh.setVerticesData(this.options.uvsOut || (0, $b4i1f.VertexBuffer).UVKind, uvOut);
    }
    /**
     * Updates a Meshes materials to use the texture packer channels
     * @param m is the mesh to target
     * @param force all channels on the packer to be set.
     */ _updateTextureReferences(m, force = false) {
        const mat = m.material;
        const sKeys = Object.keys(this.sets);
        const _dispose = (_t)=>{
            if (_t.dispose) _t.dispose();
        };
        for(let i = 0; i < sKeys.length; i++){
            const setName = sKeys[i];
            if (!force) {
                if (!mat) return;
                if (mat[setName] !== null) {
                    _dispose(mat[setName]);
                    mat[setName] = this.sets[setName];
                }
            } else {
                if (mat[setName] !== null) _dispose(mat[setName]);
                mat[setName] = this.sets[setName];
            }
        }
    }
    /**
     * Public method to set a Mesh to a frame
     * @param m that is the target
     * @param frameID or the frame index
     * @param updateMaterial trigger for if the Meshes attached Material be updated?
     */ setMeshToFrame(m, frameID, updateMaterial = false) {
        this._updateMeshUV(m, frameID);
        if (updateMaterial) this._updateTextureReferences(m, true);
    }
    /**
     * Starts the async promise to compile the texture packer.
     * @returns Promise<void>
     */ processAsync() {
        return new Promise((resolve, reject)=>{
            try {
                if (this.meshes.length === 0) {
                    //Must be a JSON load!
                    resolve();
                    return;
                }
                let done = 0;
                const doneCheck = (mat)=>{
                    done++;
                    //Check Status of all Textures on all meshes, till they are ready.
                    if (this.options.map) {
                        for(let j = 0; j < this.options.map.length; j++){
                            const index = this.options.map[j];
                            const t = mat[index];
                            if (t !== null) {
                                if (!this.sets[this.options.map[j]]) this.sets[this.options.map[j]] = true;
                                this._expecting++;
                            }
                        }
                        if (done === this.meshes.length) this._createFrames(resolve);
                    }
                };
                for(let i = 0; i < this.meshes.length; i++){
                    const mesh = this.meshes[i];
                    const material = mesh.material;
                    if (!material) {
                        done++;
                        if (done === this.meshes.length) return this._createFrames(resolve);
                        continue;
                    }
                    material.forceCompilationAsync(mesh).then(()=>{
                        doneCheck(material);
                    });
                }
            } catch (e) {
                return reject(e);
            }
        });
    }
    /**
     * Disposes all textures associated with this packer
     */ dispose() {
        const sKeys = Object.keys(this.sets);
        for(let i = 0; i < sKeys.length; i++){
            const channel = sKeys[i];
            this.sets[channel].dispose();
        }
    }
    /**
     * Starts the download process for all the channels converting them to base64 data and embedding it all in a JSON file.
     * @param imageType is the image type to use.
     * @param quality of the image if downloading as jpeg, Ranges from >0 to 1.
     */ download(imageType = "png", quality = 1) {
        setTimeout(()=>{
            const pack = {
                name: this.name,
                sets: {},
                options: {},
                frames: []
            };
            const sKeys = Object.keys(this.sets);
            const oKeys = Object.keys(this.options);
            try {
                for(let i = 0; i < sKeys.length; i++){
                    const channel = sKeys[i];
                    const dt = this.sets[channel];
                    pack.sets[channel] = dt.getContext().canvas.toDataURL("image/" + imageType, quality);
                }
                for(let i = 0; i < oKeys.length; i++){
                    const opt = oKeys[i];
                    pack.options[opt] = this.options[opt];
                }
                for(let i = 0; i < this.frames.length; i++){
                    const _f = this.frames[i];
                    pack.frames.push(_f.scale.x, _f.scale.y, _f.offset.x, _f.offset.y);
                }
            } catch (err) {
                (0, $kVtWi.Logger).Warn("Unable to download: " + err);
                return;
            }
            const data = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(pack, null, 4));
            const _a = document.createElement("a");
            _a.setAttribute("href", data);
            _a.setAttribute("download", this.name + "_texurePackage.json");
            document.body.appendChild(_a);
            _a.click();
            _a.remove();
        }, 0);
    }
    /**
     * Public method to load a texturePacker JSON file.
     * @param data of the JSON file in string format.
     */ updateFromJSON(data) {
        try {
            const parsedData = JSON.parse(data);
            this.name = parsedData.name;
            const _options = Object.keys(parsedData.options);
            for(let i = 0; i < _options.length; i++)this.options[_options[i]] = parsedData.options[_options[i]];
            for(let i = 0; i < parsedData.frames.length; i += 4){
                const frame = new (0, $aZmLG.TexturePackerFrame)(i / 4, new (0, $ha1VO.Vector2)(parsedData.frames[i], parsedData.frames[i + 1]), new (0, $ha1VO.Vector2)(parsedData.frames[i + 2], parsedData.frames[i + 3]));
                this.frames.push(frame);
            }
            const channels = Object.keys(parsedData.sets);
            for(let i = 0; i < channels.length; i++){
                const _t = new (0, $j2mX5.Texture)(parsedData.sets[channels[i]], this.scene, false, false);
                this.sets[channels[i]] = _t;
            }
        } catch (err) {
            (0, $kVtWi.Logger).Warn("Unable to update from JSON: " + err);
        }
    }
}
/** Packer Layout Constant 0 */ $de97199b54b17a66$export$50cdc69105291fc1.LAYOUT_STRIP = 0;
/** Packer Layout Constant 1 */ $de97199b54b17a66$export$50cdc69105291fc1.LAYOUT_POWER2 = 1;
/** Packer Layout Constant 2 */ $de97199b54b17a66$export$50cdc69105291fc1.LAYOUT_COLNUM = 2;
/** Packer Layout Constant 0 */ $de97199b54b17a66$export$50cdc69105291fc1.SUBUV_WRAP = 0;
/** Packer Layout Constant 1 */ $de97199b54b17a66$export$50cdc69105291fc1.SUBUV_EXTEND = 1;
/** Packer Layout Constant 2 */ $de97199b54b17a66$export$50cdc69105291fc1.SUBUV_COLOR = 2;

});
parcelRegister("aZmLG", function(module, exports) {

$parcel$export(module.exports, "TexturePackerFrame", () => $800143277a634491$export$9ebae739cef488c7);
/**
 * This is a support class for frame Data on texture packer sets.
 */ class $800143277a634491$export$9ebae739cef488c7 {
    /**
     * Initializes a texture package frame.
     * @param id The numerical frame identifier
     * @param scale Scalar Vector2 for UV frame
     * @param offset Vector2 for the frame position in UV units.
     * @returns TexturePackerFrame
     */ constructor(id, scale, offset){
        this.id = id;
        this.scale = scale;
        this.offset = offset;
    }
}

});



parcelRegister("ksUhX", function(module, exports) {

var $ggTip = parcelRequire("ggTip");

var $8udCI = parcelRequire("8udCI");

var $bds6B = parcelRequire("bds6B");

var $3BZkj = parcelRequire("3BZkj");
$parcel$exportWildcard(module.exports, $ggTip);
$parcel$exportWildcard(module.exports, $8udCI);
$parcel$exportWildcard(module.exports, $bds6B);
$parcel$exportWildcard(module.exports, $3BZkj);

});
parcelRegister("ggTip", function(module, exports) {

$parcel$export(module.exports, "CustomProceduralTexture", () => $bd890896e7ac39fc$export$118566093fb23129);

var $kVtWi = parcelRequire("kVtWi");

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $j2mX5 = parcelRequire("j2mX5");

var $bds6B = parcelRequire("bds6B");

var $hUzEl = parcelRequire("hUzEl");
class $bd890896e7ac39fc$export$118566093fb23129 extends (0, $bds6B.ProceduralTexture) {
    /**
     * Instantiates a new Custom Procedural Texture.
     * Procedural texturing is a way to programmatically create a texture. There are 2 types of procedural textures: code-only, and code that references some classic 2D images, sometimes called 'refMaps' or 'sampler' images.
     * Custom Procedural textures are the easiest way to create your own procedural in your application.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/proceduralTextures#creating-custom-procedural-textures
     * @param name Define the name of the texture
     * @param texturePath Define the folder path containing all the custom texture related files (config, shaders...)
     * @param size Define the size of the texture to create
     * @param scene Define the scene the texture belongs to
     * @param fallbackTexture Define a fallback texture in case there were issues to create the custom texture
     * @param generateMipMaps Define if the texture should creates mip maps or not
     * @param skipJson Define a boolena indicating that there is no json config file to load
     */ constructor(name, texturePath, size, scene, fallbackTexture, generateMipMaps, skipJson){
        super(name, size, null, scene, fallbackTexture, generateMipMaps);
        this._animate = true;
        this._time = 0;
        this._texturePath = texturePath;
        if (fallbackTexture && !(fallbackTexture instanceof (0, $j2mX5.Texture))) skipJson = !!fallbackTexture.skipJson;
        if (!skipJson) //Try to load json
        this._loadJson(texturePath);
        else this.setFragment(this._texturePath);
        this.refreshRate = 1;
    }
    _loadJson(jsonUrl) {
        const noConfigFile = ()=>{
            try {
                this.setFragment(this._texturePath);
            } catch (ex) {
                (0, $kVtWi.Logger).Log("No json or ShaderStore or DOM element found for CustomProceduralTexture");
            }
        };
        const configFileUrl = jsonUrl + "/config.json";
        const xhr = new (0, $hUzEl.WebRequest)();
        xhr.open("GET", configFileUrl);
        xhr.addEventListener("load", ()=>{
            if (xhr.status === 200 || xhr.responseText && xhr.responseText.length > 0) try {
                this._config = JSON.parse(xhr.response);
                this.updateShaderUniforms();
                this.updateTextures();
                this.setFragment(this._texturePath + "/custom");
                this._animate = this._config.animate;
                this.refreshRate = this._config.refreshrate;
            } catch (ex) {
                noConfigFile();
            }
            else noConfigFile();
        }, false);
        xhr.addEventListener("error", ()=>{
            noConfigFile();
        }, false);
        try {
            xhr.send();
        } catch (ex) {
            (0, $kVtWi.Logger).Error("CustomProceduralTexture: Error on XHR send request.");
        }
    }
    /**
     * Is the texture ready to be used ? (rendered at least once)
     * @returns true if ready, otherwise, false.
     */ isReady() {
        if (!super.isReady()) return false;
        for(const name in this._textures){
            const texture = this._textures[name];
            if (!texture.isReady()) return false;
        }
        return true;
    }
    /**
     * Render the texture to its associated render target.
     * @param useCameraPostProcess Define if camera post process should be applied to the texture
     */ render(useCameraPostProcess) {
        const scene = this.getScene();
        if (this._animate && scene) {
            this._time += scene.getAnimationRatio() * 0.03;
            this.updateShaderUniforms();
        }
        super.render(useCameraPostProcess);
    }
    /**
     * Update the list of dependant textures samplers in the shader.
     */ updateTextures() {
        for(let i = 0; i < this._config.sampler2Ds.length; i++)this.setTexture(this._config.sampler2Ds[i].sample2Dname, new (0, $j2mX5.Texture)(this._texturePath + "/" + this._config.sampler2Ds[i].textureRelativeUrl, this.getScene()));
    }
    /**
     * Update the uniform values of the procedural texture in the shader.
     */ updateShaderUniforms() {
        if (this._config) for(let j = 0; j < this._config.uniforms.length; j++){
            const uniform = this._config.uniforms[j];
            switch(uniform.type){
                case "float":
                    this.setFloat(uniform.name, uniform.value);
                    break;
                case "color3":
                    this.setColor3(uniform.name, new (0, $7etnY.Color3)(uniform.r, uniform.g, uniform.b));
                    break;
                case "color4":
                    this.setColor4(uniform.name, new (0, $7etnY.Color4)(uniform.r, uniform.g, uniform.b, uniform.a));
                    break;
                case "vector2":
                    this.setVector2(uniform.name, new (0, $ha1VO.Vector2)(uniform.x, uniform.y));
                    break;
                case "vector3":
                    this.setVector3(uniform.name, new (0, $ha1VO.Vector3)(uniform.x, uniform.y, uniform.z));
                    break;
            }
        }
        this.setFloat("time", this._time);
    }
    /**
     * Define if the texture animates or not.
     */ get animate() {
        return this._animate;
    }
    set animate(value) {
        this._animate = value;
    }
}

});

parcelRegister("8udCI", function(module, exports) {

$parcel$export(module.exports, "NoiseProceduralTexture", () => $62dbb1698e9d10f5$export$6c73f2614ba326fb);

var $ejQPp = parcelRequire("ejQPp");

var $bds6B = parcelRequire("bds6B");

var $8DoUR = parcelRequire("8DoUR");
parcelRequire("7nf7S");
class $62dbb1698e9d10f5$export$6c73f2614ba326fb extends (0, $bds6B.ProceduralTexture) {
    /**
     * Creates a new NoiseProceduralTexture
     * @param name defines the name fo the texture
     * @param size defines the size of the texture (default is 256)
     * @param scene defines the hosting scene
     * @param fallbackTexture defines the texture to use if the NoiseProceduralTexture can't be created
     * @param generateMipMaps defines if mipmaps must be generated (true by default)
     */ constructor(name, size = 256, scene = (0, $ejQPp.EngineStore).LastCreatedScene, fallbackTexture, generateMipMaps){
        super(name, size, "noise", scene, fallbackTexture, generateMipMaps);
        /** Gets or sets the start time (default is 0) */ this.time = 0.0;
        /** Gets or sets a value between 0 and 1 indicating the overall brightness of the texture (default is 0.2) */ this.brightness = 0.2;
        /** Defines the number of octaves to process */ this.octaves = 3;
        /** Defines the level of persistence (0.8 by default) */ this.persistence = 0.8;
        /** Gets or sets animation speed factor (default is 1) */ this.animationSpeedFactor = 1;
        this.autoClear = false;
        this._updateShaderUniforms();
    }
    _updateShaderUniforms() {
        const scene = this.getScene();
        if (!scene) return;
        this.time += scene.getAnimationRatio() * this.animationSpeedFactor * 0.01;
        this.setFloat("brightness", this.brightness);
        this.setFloat("persistence", this.persistence);
        this.setFloat("timeScale", this.time);
    }
    _getDefines() {
        return "#define OCTAVES " + (this.octaves | 0);
    }
    /**
     * Generate the current state of the procedural texture
     * @param useCameraPostProcess Define if camera post process should be applied to the texture
     */ render(useCameraPostProcess) {
        this._updateShaderUniforms();
        super.render(useCameraPostProcess);
    }
    /**
     * Serializes this noise procedural texture
     * @returns a serialized noise procedural texture object
     */ serialize() {
        const serializationObject = {};
        serializationObject.customType = "BABYLON.NoiseProceduralTexture";
        serializationObject.brightness = this.brightness;
        serializationObject.octaves = this.octaves;
        serializationObject.persistence = this.persistence;
        serializationObject.animationSpeedFactor = this.animationSpeedFactor;
        serializationObject.size = this.getSize().width;
        serializationObject.generateMipMaps = this._generateMipMaps;
        serializationObject.time = this.time;
        return serializationObject;
    }
    /**
     * Clone the texture.
     * @returns the cloned texture
     */ clone() {
        const textureSize = this.getSize();
        const newTexture = new $62dbb1698e9d10f5$export$6c73f2614ba326fb(this.name, textureSize.width, this.getScene(), this._fallbackTexture ? this._fallbackTexture : undefined, this._generateMipMaps);
        // Base texture
        newTexture.hasAlpha = this.hasAlpha;
        newTexture.level = this.level;
        // RenderTarget Texture
        newTexture.coordinatesMode = this.coordinatesMode;
        // Noise Specifics
        newTexture.brightness = this.brightness;
        newTexture.octaves = this.octaves;
        newTexture.persistence = this.persistence;
        newTexture.animationSpeedFactor = this.animationSpeedFactor;
        newTexture.time = this.time;
        return newTexture;
    }
    /**
     * Creates a NoiseProceduralTexture from parsed noise procedural texture data
     * @param parsedTexture defines parsed texture data
     * @param scene defines the current scene
     * @returns a parsed NoiseProceduralTexture
     */ static Parse(parsedTexture, scene) {
        const texture = new $62dbb1698e9d10f5$export$6c73f2614ba326fb(parsedTexture.name, parsedTexture.size, scene, undefined, parsedTexture.generateMipMaps);
        texture.brightness = parsedTexture.brightness;
        texture.octaves = parsedTexture.octaves;
        texture.persistence = parsedTexture.persistence;
        texture.animationSpeedFactor = parsedTexture.animationSpeedFactor;
        texture.time = parsedTexture.time ?? 0;
        return texture;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.NoiseProceduralTexture", $62dbb1698e9d10f5$export$6c73f2614ba326fb);

});
parcelRegister("7nf7S", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $55e66a1a844ab988$var$name = "noisePixelShader";
const $55e66a1a844ab988$var$shader = `uniform float brightness;uniform float persistence;uniform float timeScale;varying vec2 vUV;vec2 hash22(vec2 p)
{p=p*mat2(127.1,311.7,269.5,183.3);p=-1.0+2.0*fract(sin(p)*43758.5453123);return sin(p*6.283+timeScale);}
float interpolationNoise(vec2 p)
{vec2 pi=floor(p);vec2 pf=p-pi;vec2 w=pf*pf*(3.-2.*pf);float f00=dot(hash22(pi+vec2(.0,.0)),pf-vec2(.0,.0));float f01=dot(hash22(pi+vec2(.0,1.)),pf-vec2(.0,1.));float f10=dot(hash22(pi+vec2(1.0,0.)),pf-vec2(1.0,0.));float f11=dot(hash22(pi+vec2(1.0,1.)),pf-vec2(1.0,1.));float xm1=mix(f00,f10,w.x);float xm2=mix(f01,f11,w.x);float ym=mix(xm1,xm2,w.y); 
return ym;}
float perlinNoise2D(float x,float y)
{float sum=0.0;float frequency=0.0;float amplitude=0.0;for(int i=0; i<OCTAVES; i++)
{frequency=pow(2.0,float(i));amplitude=pow(persistence,float(i));sum=sum+interpolationNoise(vec2(x*frequency,y*frequency))*amplitude;}
return sum;}
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{float x=abs(vUV.x);float y=abs(vUV.y);float noise=brightness+(1.0-brightness)*perlinNoise2D(x,y);gl_FragColor=vec4(noise,noise,noise,1.0);}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$55e66a1a844ab988$var$name] = $55e66a1a844ab988$var$shader;
const $55e66a1a844ab988$export$1fd0a07c34005890 = {
    name: $55e66a1a844ab988$var$name,
    shader: $55e66a1a844ab988$var$shader
};

});



parcelRegister("lgDo7", function(module, exports) {

$parcel$export(module.exports, "RawCubeTexture", () => $f7b9a538f447bff4$export$6bf11de0b0d8d6a8);

var $6Ho1L = parcelRequire("6Ho1L");

var $6XNeg = parcelRequire("6XNeg");

var $b9e4a = parcelRequire("b9e4a");

var $iPQLf = parcelRequire("iPQLf");
parcelRequire("e7NUJ");
class $f7b9a538f447bff4$export$6bf11de0b0d8d6a8 extends (0, $iPQLf.CubeTexture) {
    /**
     * Creates a cube texture where the raw buffers are passed in.
     * @param scene defines the scene the texture is attached to
     * @param data defines the array of data to use to create each face
     * @param size defines the size of the textures
     * @param format defines the format of the data
     * @param type defines the type of the data (like Engine.TEXTURETYPE_UNSIGNED_INT)
     * @param generateMipMaps  defines if the engine should generate the mip levels
     * @param invertY defines if data must be stored with Y axis inverted
     * @param samplingMode defines the required sampling mode (like Texture.NEAREST_SAMPLINGMODE)
     * @param compression defines the compression used (null by default)
     */ constructor(scene, data, size, format = 5, type = 0, generateMipMaps = false, invertY = false, samplingMode = 3, compression = null){
        super("", scene);
        this._texture = scene.getEngine().createRawCubeTexture(data, size, format, type, generateMipMaps, invertY, samplingMode, compression);
    }
    /**
     * Updates the raw cube texture.
     * @param data defines the data to store
     * @param format defines the data format
     * @param type defines the type fo the data (Engine.TEXTURETYPE_UNSIGNED_INT by default)
     * @param invertY defines if data must be stored with Y axis inverted
     * @param compression defines the compression used (null by default)
     */ update(data, format, type, invertY, compression = null) {
        this._texture.getEngine().updateRawCubeTexture(this._texture, data, format, type, invertY, compression);
    }
    /**
     * Updates a raw cube texture with RGBD encoded data.
     * @param data defines the array of data [mipmap][face] to use to create each face
     * @param sphericalPolynomial defines the spherical polynomial for irradiance
     * @param lodScale defines the scale applied to environment texture. This manages the range of LOD level used for IBL according to the roughness
     * @param lodOffset defines the offset applied to environment texture. This manages first LOD level used for IBL according to the roughness
     * @returns a promise that resolves when the operation is complete
     */ updateRGBDAsync(data, sphericalPolynomial = null, lodScale = 0.8, lodOffset = 0) {
        return (0, $6XNeg._UpdateRGBDAsync)(this._texture, data, sphericalPolynomial, lodScale, lodOffset).then(()=>{});
    }
    /**
     * Clones the raw cube texture.
     * @returns a new cube texture
     */ clone() {
        return (0, $6Ho1L.SerializationHelper).Clone(()=>{
            const scene = this.getScene();
            const internalTexture = this._texture;
            const texture = new $f7b9a538f447bff4$export$6bf11de0b0d8d6a8(scene, internalTexture._bufferViewArray, internalTexture.width, internalTexture.format, internalTexture.type, internalTexture.generateMipMaps, internalTexture.invertY, internalTexture.samplingMode, internalTexture._compression);
            if (internalTexture.source === (0, $b9e4a.InternalTextureSource).CubeRawRGBD) texture.updateRGBDAsync(internalTexture._bufferViewArrayArray, internalTexture._sphericalPolynomial, internalTexture._lodGenerationScale, internalTexture._lodGenerationOffset);
            return texture;
        }, this);
    }
}

});

parcelRegister("hhyUd", function(module, exports) {

$parcel$export(module.exports, "RawTexture3D", () => $c94f19b8eea45f2d$export$6d55fcb61b42fbd1);

var $j2mX5 = parcelRequire("j2mX5");
parcelRequire("e7NUJ");
class $c94f19b8eea45f2d$export$6d55fcb61b42fbd1 extends (0, $j2mX5.Texture) {
    /**
     * Create a new RawTexture3D
     * @param data defines the data of the texture
     * @param width defines the width of the texture
     * @param height defines the height of the texture
     * @param depth defines the depth of the texture
     * @param format defines the texture format to use
     * @param scene defines the hosting scene
     * @param generateMipMaps defines a boolean indicating if mip levels should be generated (true by default)
     * @param invertY defines if texture must be stored with Y axis inverted
     * @param samplingMode defines the sampling mode to use (Texture.TRILINEAR_SAMPLINGMODE by default)
     * @param textureType defines the texture Type (Engine.TEXTURETYPE_UNSIGNED_INT, Engine.TEXTURETYPE_FLOAT...)
     * @param creationFlags specific flags to use when creating the texture (1 for storage textures, for eg)
     */ constructor(data, width, height, depth, /** Gets or sets the texture format to use */ format, scene, generateMipMaps = true, invertY = false, samplingMode = (0, $j2mX5.Texture).TRILINEAR_SAMPLINGMODE, textureType = 0, creationFlags){
        super(null, scene, !generateMipMaps, invertY);
        this.format = format;
        this._texture = scene.getEngine().createRawTexture3D(data, width, height, depth, format, generateMipMaps, invertY, samplingMode, null, textureType, creationFlags);
        this.is3D = true;
    }
    /**
     * Update the texture with new data
     * @param data defines the data to store in the texture
     */ update(data) {
        if (!this._texture) return;
        this._getEngine().updateRawTexture3D(this._texture, data, this._texture.format, this._texture.invertY, null, this._texture.type);
    }
}

});

parcelRegister("feu8u", function(module, exports) {

$parcel$export(module.exports, "RefractionTexture", () => $b16f8a2f414b2f05$export$aed3025af7c59d2c);

var $23POp = parcelRequire("23POp");

var $gQtNK = parcelRequire("gQtNK");
class $b16f8a2f414b2f05$export$aed3025af7c59d2c extends (0, $gQtNK.RenderTargetTexture) {
    /**
     * Creates a refraction texture used by refraction channel of the standard material.
     * It is like a mirror but to see through a material.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/reflectionTexture#refraction
     * @param name Define the texture name
     * @param size Define the size of the underlying texture
     * @param scene Define the scene the refraction belongs to
     * @param generateMipMaps Define if we need to generate mips level for the refraction
     */ constructor(name, size, scene, generateMipMaps){
        super(name, size, scene, generateMipMaps, true);
        /**
         * Define the reflection plane we want to use. The refractionPlane is usually set to the constructed refractor.
         * It is possible to directly set the refractionPlane by directly using a Plane(a, b, c, d) where a, b and c give the plane normal vector (a, b, c) and d is a scalar displacement from the refractionPlane to the origin. However in all but the very simplest of situations it is more straight forward to set it to the refractor as stated in the doc.
         * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/reflectionTexture#refraction
         */ this.refractionPlane = new (0, $23POp.Plane)(0, 1, 0, 1);
        /**
         * Define how deep under the surface we should see.
         */ this.depth = 2.0;
        this.onBeforeRenderObservable.add(()=>{
            this.getScene().clipPlane = this.refractionPlane;
        });
        this.onAfterRenderObservable.add(()=>{
            this.getScene().clipPlane = null;
        });
    }
    /**
     * Clone the refraction texture.
     * @returns the cloned texture
     */ clone() {
        const scene = this.getScene();
        if (!scene) return this;
        const textureSize = this.getSize();
        const newTexture = new $b16f8a2f414b2f05$export$aed3025af7c59d2c(this.name, textureSize.width, scene, this._generateMipMaps);
        // Base texture
        newTexture.hasAlpha = this.hasAlpha;
        newTexture.level = this.level;
        // Refraction Texture
        newTexture.refractionPlane = this.refractionPlane.clone();
        if (this.renderList) newTexture.renderList = this.renderList.slice(0);
        newTexture.depth = this.depth;
        return newTexture;
    }
    /**
     * Serialize the texture to a JSON representation you could use in Parse later on
     * @returns the serialized JSON representation
     */ serialize() {
        if (!this.name) return null;
        const serializationObject = super.serialize();
        serializationObject.mirrorPlane = this.refractionPlane.asArray();
        serializationObject.depth = this.depth;
        return serializationObject;
    }
}

});

parcelRegister("1A6Mn", function(module, exports) {

$parcel$export(module.exports, "ThinRenderTargetTexture", () => $126e697c0ca9297d$export$8fdfc987472e3e1f);

var $jyMMC = parcelRequire("jyMMC");
class $126e697c0ca9297d$export$8fdfc987472e3e1f extends (0, $jyMMC.ThinTexture) {
    /**
     * Gets the render target wrapper associated with this render target
     */ get renderTarget() {
        return this._renderTarget;
    }
    /**
     * Instantiates a new ThinRenderTargetTexture.
     * Tiny helper class to wrap a RenderTargetWrapper in a texture.
     * This can be used as an internal texture wrapper in ThinEngine to benefit from the cache and to hold on the associated RTT
     * @param engine Define the internalTexture to wrap
     * @param size Define the size of the RTT to create
     * @param options Define rendertarget options
     */ constructor(engine, size, options){
        super(null);
        this._renderTarget = null;
        this._engine = engine;
        this._renderTargetOptions = options;
        this.resize(size);
    }
    /**
     * Resize the texture to a new desired size.
     * Be careful as it will recreate all the data in the new texture.
     * @param size Define the new size. It can be:
     *   - a number for squared texture,
     *   - an object containing { width: number, height: number }
     */ resize(size) {
        this._renderTarget?.dispose();
        this._renderTarget = null;
        this._texture = null;
        this._size = size;
        if (this._engine) this._renderTarget = this._engine.createRenderTargetTexture(this._size, this._renderTargetOptions);
        this._texture = this.renderTarget.texture;
    }
    /**
     * Get the underlying lower level texture from Babylon.
     * @returns the internal texture
     */ getInternalTexture() {
        return this._texture;
    }
    /**
     * Get the class name of the texture.
     * @returns "ThinRenderTargetTexture"
     */ getClassName() {
        return "ThinRenderTargetTexture";
    }
    /**
     * Dispose the texture and release its associated resources.
     * @param disposeOnlyFramebuffers if set to true it will dispose only the frame buffers (default: false)
     */ dispose(disposeOnlyFramebuffers = false) {
        this._renderTarget?.dispose(true);
        this._renderTarget = null;
        if (!disposeOnlyFramebuffers) super.dispose();
    }
}

});


parcelRegister("1ZqT6", function(module, exports) {
/* eslint-disable import/no-internal-modules */ 
var $46iB1 = parcelRequire("46iB1");

var $dTtBA = parcelRequire("dTtBA");

var $g92b7 = parcelRequire("g92b7");

var $kpKE2 = parcelRequire("kpKE2");

var $5fNQr = parcelRequire("5fNQr");

var $7dR1d = parcelRequire("7dR1d");

var $hm4mN = parcelRequire("hm4mN");

var $1aXVF = parcelRequire("1aXVF");
$parcel$exportWildcard(module.exports, $46iB1);
$parcel$exportWildcard(module.exports, $dTtBA);
$parcel$exportWildcard(module.exports, $g92b7);
$parcel$exportWildcard(module.exports, $kpKE2);
$parcel$exportWildcard(module.exports, $5fNQr);
$parcel$exportWildcard(module.exports, $7dR1d);
$parcel$exportWildcard(module.exports, $hm4mN);
$parcel$exportWildcard(module.exports, $1aXVF);

});
parcelRegister("46iB1", function(module, exports) {

var $iAIIe = parcelRequire("iAIIe");

var $3mKw5 = parcelRequire("3mKw5");

var $g9kSQ = parcelRequire("g9kSQ");

var $7qH6c = parcelRequire("7qH6c");

var $5oHv1 = parcelRequire("5oHv1");
$parcel$exportWildcard(module.exports, $iAIIe);
$parcel$exportWildcard(module.exports, $3mKw5);
$parcel$exportWildcard(module.exports, $g9kSQ);
$parcel$exportWildcard(module.exports, $7qH6c);
$parcel$exportWildcard(module.exports, $5oHv1);

});

parcelRegister("dTtBA", function(module, exports) {

$parcel$export(module.exports, "NodeMaterialConnectionPointCustomObject", () => $a1d76067c1ca2bfb$export$8d8531924fa32a4a);

var $g92b7 = parcelRequire("g92b7");
class $a1d76067c1ca2bfb$export$8d8531924fa32a4a extends (0, $g92b7.NodeMaterialConnectionPoint) {
    /**
     * Creates a new connection point
     * @param name defines the connection point name
     * @param ownerBlock defines the block hosting this connection point
     * @param direction defines the direction of the connection point
     * @param _blockType
     * @param _blockName
     */ constructor(name, ownerBlock, direction, // @internal
    _blockType, _blockName){
        super(name, ownerBlock, direction);
        this._blockType = _blockType;
        this._blockName = _blockName;
        this.needDualDirectionValidation = true;
    }
    /**
     * Gets a number indicating if the current point can be connected to another point
     * @param connectionPoint defines the other connection point
     * @returns a number defining the compatibility state
     */ checkCompatibilityState(connectionPoint) {
        return connectionPoint instanceof $a1d76067c1ca2bfb$export$8d8531924fa32a4a && connectionPoint._blockName === this._blockName ? (0, $g92b7.NodeMaterialConnectionPointCompatibilityStates).Compatible : (0, $g92b7.NodeMaterialConnectionPointCompatibilityStates).TypeIncompatible;
    }
    /**
     * Creates a block suitable to be used as an input for this input point.
     * If null is returned, a block based on the point type will be created.
     * @returns The returned string parameter is the name of the output point of NodeMaterialBlock (first parameter of the returned array) that can be connected to the input
     */ createCustomInputBlock() {
        return [
            new this._blockType(this._blockName),
            this.name
        ];
    }
}

});

parcelRegister("7dR1d", function(module, exports) {
/* eslint-disable import/no-internal-modules */ 
var $7YBBf = parcelRequire("7YBBf");

var $eYgRs = parcelRequire("eYgRs");

var $7ulf0 = parcelRequire("7ulf0");

var $gJaMt = parcelRequire("gJaMt");

var $4a7EU = parcelRequire("4a7EU");

var $fTSHo = parcelRequire("fTSHo");

var $gpOxb = parcelRequire("gpOxb");

var $eoRzM = parcelRequire("eoRzM");

var $2KFUi = parcelRequire("2KFUi");

var $3cPC6 = parcelRequire("3cPC6");

var $gRxmB = parcelRequire("gRxmB");

var $cgDd4 = parcelRequire("cgDd4");

var $cFAzb = parcelRequire("cFAzb");

var $dIpWY = parcelRequire("dIpWY");

var $dvbrd = parcelRequire("dvbrd");

var $3hVDe = parcelRequire("3hVDe");

var $5t5lc = parcelRequire("5t5lc");

var $jnIu6 = parcelRequire("jnIu6");

var $6XqNB = parcelRequire("6XqNB");

var $3fRZu = parcelRequire("3fRZu");

var $go8IL = parcelRequire("go8IL");

var $bDLPt = parcelRequire("bDLPt");

var $lbEYX = parcelRequire("lbEYX");

var $1RMzf = parcelRequire("1RMzf");

var $kJdlu = parcelRequire("kJdlu");

var $j6itU = parcelRequire("j6itU");

var $lfnp6 = parcelRequire("lfnp6");

var $lPuXp = parcelRequire("lPuXp");

var $6ibKD = parcelRequire("6ibKD");

var $5ENQg = parcelRequire("5ENQg");

var $lRCx0 = parcelRequire("lRCx0");

var $l54kk = parcelRequire("l54kk");

var $3HImk = parcelRequire("3HImk");

var $a2z4w = parcelRequire("a2z4w");

var $rDM9g = parcelRequire("rDM9g");

var $aZdrO = parcelRequire("aZdrO");

var $11SLn = parcelRequire("11SLn");

var $iqn1M = parcelRequire("iqn1M");

var $8CfhV = parcelRequire("8CfhV");

var $GWBLc = parcelRequire("GWBLc");

var $jR0O5 = parcelRequire("jR0O5");

var $apJef = parcelRequire("apJef");

var $44zvG = parcelRequire("44zvG");

var $cuFkd = parcelRequire("cuFkd");

var $aRD4Z = parcelRequire("aRD4Z");

var $cV45E = parcelRequire("cV45E");

var $3lCtu = parcelRequire("3lCtu");

var $WuxMr = parcelRequire("WuxMr");

var $eXLCJ = parcelRequire("eXLCJ");

var $1Tc4k = parcelRequire("1Tc4k");

var $jMhOs = parcelRequire("jMhOs");

var $lq3DF = parcelRequire("lq3DF");

var $2PO9P = parcelRequire("2PO9P");

var $kDfGd = parcelRequire("kDfGd");

var $5OQGp = parcelRequire("5OQGp");

var $98lkH = parcelRequire("98lkH");

var $1UCax = parcelRequire("1UCax");

var $8fgUJ = parcelRequire("8fgUJ");

var $52cvd = parcelRequire("52cvd");

var $jdXLf = parcelRequire("jdXLf");

var $cYxyI = parcelRequire("cYxyI");

var $fqovS = parcelRequire("fqovS");

var $9OUks = parcelRequire("9OUks");
$parcel$exportWildcard(module.exports, $7YBBf);
$parcel$exportWildcard(module.exports, $eYgRs);
$parcel$exportWildcard(module.exports, $7ulf0);
$parcel$exportWildcard(module.exports, $gJaMt);
$parcel$exportWildcard(module.exports, $4a7EU);
$parcel$exportWildcard(module.exports, $fTSHo);
$parcel$exportWildcard(module.exports, $gpOxb);
$parcel$exportWildcard(module.exports, $eoRzM);
$parcel$exportWildcard(module.exports, $2KFUi);
$parcel$exportWildcard(module.exports, $3cPC6);
$parcel$exportWildcard(module.exports, $gRxmB);
$parcel$exportWildcard(module.exports, $cgDd4);
$parcel$exportWildcard(module.exports, $cFAzb);
$parcel$exportWildcard(module.exports, $dIpWY);
$parcel$exportWildcard(module.exports, $dvbrd);
$parcel$exportWildcard(module.exports, $3hVDe);
$parcel$exportWildcard(module.exports, $5t5lc);
$parcel$exportWildcard(module.exports, $jnIu6);
$parcel$exportWildcard(module.exports, $6XqNB);
$parcel$exportWildcard(module.exports, $3fRZu);
$parcel$exportWildcard(module.exports, $go8IL);
$parcel$exportWildcard(module.exports, $bDLPt);
$parcel$exportWildcard(module.exports, $lbEYX);
$parcel$exportWildcard(module.exports, $1RMzf);
$parcel$exportWildcard(module.exports, $kJdlu);
$parcel$exportWildcard(module.exports, $j6itU);
$parcel$exportWildcard(module.exports, $lfnp6);
$parcel$exportWildcard(module.exports, $lPuXp);
$parcel$exportWildcard(module.exports, $6ibKD);
$parcel$exportWildcard(module.exports, $5ENQg);
$parcel$exportWildcard(module.exports, $lRCx0);
$parcel$exportWildcard(module.exports, $l54kk);
$parcel$exportWildcard(module.exports, $3HImk);
$parcel$exportWildcard(module.exports, $a2z4w);
$parcel$exportWildcard(module.exports, $rDM9g);
$parcel$exportWildcard(module.exports, $aZdrO);
$parcel$exportWildcard(module.exports, $11SLn);
$parcel$exportWildcard(module.exports, $iqn1M);
$parcel$exportWildcard(module.exports, $8CfhV);
$parcel$exportWildcard(module.exports, $GWBLc);
$parcel$exportWildcard(module.exports, $jR0O5);
$parcel$exportWildcard(module.exports, $apJef);
$parcel$exportWildcard(module.exports, $44zvG);
$parcel$exportWildcard(module.exports, $cuFkd);
$parcel$exportWildcard(module.exports, $aRD4Z);
$parcel$exportWildcard(module.exports, $cV45E);
$parcel$exportWildcard(module.exports, $3lCtu);
$parcel$exportWildcard(module.exports, $WuxMr);
$parcel$exportWildcard(module.exports, $eXLCJ);
$parcel$exportWildcard(module.exports, $1Tc4k);
$parcel$exportWildcard(module.exports, $jMhOs);
$parcel$exportWildcard(module.exports, $lq3DF);
$parcel$exportWildcard(module.exports, $2PO9P);
$parcel$exportWildcard(module.exports, $kDfGd);
$parcel$exportWildcard(module.exports, $5OQGp);
$parcel$exportWildcard(module.exports, $98lkH);
$parcel$exportWildcard(module.exports, $1UCax);
$parcel$exportWildcard(module.exports, $8fgUJ);
$parcel$exportWildcard(module.exports, $52cvd);
$parcel$exportWildcard(module.exports, $jdXLf);
$parcel$exportWildcard(module.exports, $cYxyI);
$parcel$exportWildcard(module.exports, $fqovS);
$parcel$exportWildcard(module.exports, $9OUks);

});
parcelRegister("7YBBf", function(module, exports) {

var $eH9s9 = parcelRequire("eH9s9");

var $w4E40 = parcelRequire("w4E40");

var $9z1cT = parcelRequire("9z1cT");

var $5JyDL = parcelRequire("5JyDL");

var $1H78A = parcelRequire("1H78A");
$parcel$exportWildcard(module.exports, $eH9s9);
$parcel$exportWildcard(module.exports, $w4E40);
$parcel$exportWildcard(module.exports, $9z1cT);
$parcel$exportWildcard(module.exports, $5JyDL);
$parcel$exportWildcard(module.exports, $1H78A);

});
parcelRegister("w4E40", function(module, exports) {

$parcel$export(module.exports, "BonesBlock", () => $060697b5f2ea142e$export$32caab2951764457);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $7qH6c = parcelRequire("7qH6c");

var $iAIIe = parcelRequire("iAIIe");

var $aKEh2 = parcelRequire("aKEh2");

var $8DoUR = parcelRequire("8DoUR");
parcelRequire("7PW7m");
parcelRequire("4idCt");

var $alPCh = parcelRequire("alPCh");
class $060697b5f2ea142e$export$32caab2951764457 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new BonesBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Vertex);
        this.registerInput("matricesIndices", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4);
        this.registerInput("matricesWeights", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4);
        this.registerInput("matricesIndicesExtra", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4, true);
        this.registerInput("matricesWeightsExtra", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4, true);
        this.registerInput("world", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix);
    }
    /**
     * Initialize the block and prepare the context for build
     * @param state defines the state that will be used for the build
     */ initialize(state) {
        state._excludeVariableName("boneSampler");
        state._excludeVariableName("boneTextureWidth");
        state._excludeVariableName("mBones");
        state._excludeVariableName("BonesPerMesh");
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "BonesBlock";
    }
    /**
     * Gets the matrix indices input component
     */ get matricesIndices() {
        return this._inputs[0];
    }
    /**
     * Gets the matrix weights input component
     */ get matricesWeights() {
        return this._inputs[1];
    }
    /**
     * Gets the extra matrix indices input component
     */ get matricesIndicesExtra() {
        return this._inputs[2];
    }
    /**
     * Gets the extra matrix weights input component
     */ get matricesWeightsExtra() {
        return this._inputs[3];
    }
    /**
     * Gets the world input component
     */ get world() {
        return this._inputs[4];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    autoConfigure(material, additionalFilteringInfo = ()=>true) {
        if (!this.matricesIndices.isConnected) {
            let matricesIndicesInput = material.getInputBlockByPredicate((b)=>b.isAttribute && b.name === "matricesIndices" && additionalFilteringInfo(b));
            if (!matricesIndicesInput) {
                matricesIndicesInput = new (0, $aKEh2.InputBlock)("matricesIndices");
                matricesIndicesInput.setAsAttribute("matricesIndices");
            }
            matricesIndicesInput.output.connectTo(this.matricesIndices);
        }
        if (!this.matricesWeights.isConnected) {
            let matricesWeightsInput = material.getInputBlockByPredicate((b)=>b.isAttribute && b.name === "matricesWeights" && additionalFilteringInfo(b));
            if (!matricesWeightsInput) {
                matricesWeightsInput = new (0, $aKEh2.InputBlock)("matricesWeights");
                matricesWeightsInput.setAsAttribute("matricesWeights");
            }
            matricesWeightsInput.output.connectTo(this.matricesWeights);
        }
        if (!this.world.isConnected) {
            let worldInput = material.getInputBlockByPredicate((b)=>b.systemValue === (0, $7qH6c.NodeMaterialSystemValues).World && additionalFilteringInfo(b));
            if (!worldInput) {
                worldInput = new (0, $aKEh2.InputBlock)("world");
                worldInput.setAsSystemValue((0, $7qH6c.NodeMaterialSystemValues).World);
            }
            worldInput.output.connectTo(this.world);
        }
    }
    provideFallbacks(mesh, fallbacks) {
        if (mesh && mesh.useBones && mesh.computeBonesUsingShaders && mesh.skeleton) fallbacks.addCPUSkinningFallback(0, mesh);
    }
    bind(effect, nodeMaterial, mesh) {
        (0, $alPCh.BindBonesParameters)(mesh, effect);
    }
    prepareDefines(mesh, nodeMaterial, defines) {
        if (!defines._areAttributesDirty) return;
        (0, $alPCh.PrepareDefinesForBones)(mesh, defines);
    }
    _buildBlock(state) {
        super._buildBlock(state);
        // Register for compilation fallbacks
        state.sharedData.blocksWithFallbacks.push(this);
        // Register for binding
        state.sharedData.forcedBindableBlocks.push(this);
        // Register for defines
        state.sharedData.blocksWithDefines.push(this);
        // Register internal uniforms and samplers
        state.uniforms.push("boneTextureWidth");
        state.uniforms.push("mBones");
        state.samplers.push("boneSampler");
        // Emit code
        const comments = `//${this.name}`;
        state._emitFunctionFromInclude("bonesDeclaration", comments, {
            removeAttributes: true,
            removeUniforms: false,
            removeVaryings: true,
            removeIfDef: false
        });
        const influenceVariablename = state._getFreeVariableName("influence");
        state.compilationString += state._emitCodeFromInclude("bonesVertex", comments, {
            replaceStrings: [
                {
                    search: /finalWorld=finalWorld\*influence;/,
                    replace: ""
                },
                {
                    search: /influence/gm,
                    replace: influenceVariablename
                }
            ]
        });
        const output = this._outputs[0];
        const worldInput = this.world;
        state.compilationString += `#if NUM_BONE_INFLUENCERS>0\n`;
        state.compilationString += this._declareOutput(output, state) + ` = ${worldInput.associatedVariableName} * ${influenceVariablename};\n`;
        state.compilationString += `#else\n`;
        state.compilationString += this._declareOutput(output, state) + ` = ${worldInput.associatedVariableName};\n`;
        state.compilationString += `#endif\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.BonesBlock", $060697b5f2ea142e$export$32caab2951764457);

});

parcelRegister("9z1cT", function(module, exports) {

$parcel$export(module.exports, "InstancesBlock", () => $6f68519e616de098$export$4a138c28f4f8bc4e);

var $kpKE2 = parcelRequire("kpKE2");

var $iAIIe = parcelRequire("iAIIe");

var $3mKw5 = parcelRequire("3mKw5");

var $7qH6c = parcelRequire("7qH6c");

var $aKEh2 = parcelRequire("aKEh2");

var $8DoUR = parcelRequire("8DoUR");
class $6f68519e616de098$export$4a138c28f4f8bc4e extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new InstancesBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Vertex);
        this.registerInput("world0", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4);
        this.registerInput("world1", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4);
        this.registerInput("world2", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4);
        this.registerInput("world3", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4);
        this.registerInput("world", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix, true);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix);
        this.registerOutput("instanceID", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "InstancesBlock";
    }
    /**
     * Gets the first world row input component
     */ get world0() {
        return this._inputs[0];
    }
    /**
     * Gets the second world row input component
     */ get world1() {
        return this._inputs[1];
    }
    /**
     * Gets the third world row input component
     */ get world2() {
        return this._inputs[2];
    }
    /**
     * Gets the forth world row input component
     */ get world3() {
        return this._inputs[3];
    }
    /**
     * Gets the world input component
     */ get world() {
        return this._inputs[4];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    /**
     * Gets the instanceID component
     */ get instanceID() {
        return this._outputs[1];
    }
    autoConfigure(material, additionalFilteringInfo = ()=>true) {
        if (!this.world0.connectedPoint) {
            let world0Input = material.getInputBlockByPredicate((b)=>b.isAttribute && b.name === "world0" && additionalFilteringInfo(b));
            if (!world0Input) {
                world0Input = new (0, $aKEh2.InputBlock)("world0");
                world0Input.setAsAttribute("world0");
            }
            world0Input.output.connectTo(this.world0);
        }
        if (!this.world1.connectedPoint) {
            let world1Input = material.getInputBlockByPredicate((b)=>b.isAttribute && b.name === "world1" && additionalFilteringInfo(b));
            if (!world1Input) {
                world1Input = new (0, $aKEh2.InputBlock)("world1");
                world1Input.setAsAttribute("world1");
            }
            world1Input.output.connectTo(this.world1);
        }
        if (!this.world2.connectedPoint) {
            let world2Input = material.getInputBlockByPredicate((b)=>b.isAttribute && b.name === "world2" && additionalFilteringInfo(b));
            if (!world2Input) {
                world2Input = new (0, $aKEh2.InputBlock)("world2");
                world2Input.setAsAttribute("world2");
            }
            world2Input.output.connectTo(this.world2);
        }
        if (!this.world3.connectedPoint) {
            let world3Input = material.getInputBlockByPredicate((b)=>b.isAttribute && b.name === "world3" && additionalFilteringInfo(b));
            if (!world3Input) {
                world3Input = new (0, $aKEh2.InputBlock)("world3");
                world3Input.setAsAttribute("world3");
            }
            world3Input.output.connectTo(this.world3);
        }
        if (!this.world.connectedPoint) {
            let worldInput = material.getInputBlockByPredicate((b)=>b.isAttribute && b.name === "world" && additionalFilteringInfo(b));
            if (!worldInput) {
                worldInput = new (0, $aKEh2.InputBlock)("world");
                worldInput.setAsSystemValue((0, $7qH6c.NodeMaterialSystemValues).World);
            }
            worldInput.output.connectTo(this.world);
        }
        this.world.define = "!INSTANCES || THIN_INSTANCES";
    }
    prepareDefines(mesh, nodeMaterial, defines, useInstances = false, subMesh) {
        let changed = false;
        if (defines["INSTANCES"] !== useInstances) {
            defines.setValue("INSTANCES", useInstances);
            changed = true;
        }
        if (subMesh && defines["THIN_INSTANCES"] !== !!subMesh?.getRenderingMesh().hasThinInstances) {
            defines.setValue("THIN_INSTANCES", !!subMesh?.getRenderingMesh().hasThinInstances);
            changed = true;
        }
        if (changed) defines.markAsUnprocessed();
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const engine = state.sharedData.scene.getEngine();
        // Register for defines
        state.sharedData.blocksWithDefines.push(this);
        // Emit code
        const output = this._outputs[0];
        const instanceID = this._outputs[1];
        const world0 = this.world0;
        const world1 = this.world1;
        const world2 = this.world2;
        const world3 = this.world3;
        state.compilationString += `#ifdef INSTANCES\n`;
        state.compilationString += this._declareOutput(output, state) + ` = mat4(${world0.associatedVariableName}, ${world1.associatedVariableName}, ${world2.associatedVariableName}, ${world3.associatedVariableName});\n`;
        state.compilationString += `#ifdef THIN_INSTANCES\n`;
        state.compilationString += `${output.associatedVariableName} = ${this.world.associatedVariableName} * ${output.associatedVariableName};\n`;
        state.compilationString += `#endif\n`;
        if (engine._caps.canUseGLInstanceID) state.compilationString += this._declareOutput(instanceID, state) + ` = float(gl_InstanceID);\n`;
        else state.compilationString += this._declareOutput(instanceID, state) + ` = 0.0;\n`;
        state.compilationString += `#else\n`;
        state.compilationString += this._declareOutput(output, state) + ` = ${this.world.associatedVariableName};\n`;
        state.compilationString += this._declareOutput(instanceID, state) + ` = 0.0;\n`;
        state.compilationString += `#endif\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.InstancesBlock", $6f68519e616de098$export$4a138c28f4f8bc4e);

});

parcelRegister("5JyDL", function(module, exports) {

$parcel$export(module.exports, "MorphTargetsBlock", () => $42cc0692a2cd3919$export$a4918fa70d83f267);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $b4i1f = parcelRequire("b4i1f");

var $aKEh2 = parcelRequire("aKEh2");

var $8DoUR = parcelRequire("8DoUR");
parcelRequire("9H5jp");
parcelRequire("5Eb4I");

var $alPCh = parcelRequire("alPCh");
class $42cc0692a2cd3919$export$a4918fa70d83f267 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Create a new MorphTargetsBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Vertex);
        this.registerInput("position", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3);
        this.registerInput("normal", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3);
        this.registerInput("tangent", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.tangent.addExcludedConnectionPointFromAllowedTypes((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3);
        this.registerInput("uv", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2);
        this.registerOutput("positionOutput", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3);
        this.registerOutput("normalOutput", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3);
        this.registerOutput("tangentOutput", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4);
        this.registerOutput("uvOutput", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "MorphTargetsBlock";
    }
    /**
     * Gets the position input component
     */ get position() {
        return this._inputs[0];
    }
    /**
     * Gets the normal input component
     */ get normal() {
        return this._inputs[1];
    }
    /**
     * Gets the tangent input component
     */ get tangent() {
        return this._inputs[2];
    }
    /**
     * Gets the tangent input component
     */ get uv() {
        return this._inputs[3];
    }
    /**
     * Gets the position output component
     */ get positionOutput() {
        return this._outputs[0];
    }
    /**
     * Gets the normal output component
     */ get normalOutput() {
        return this._outputs[1];
    }
    /**
     * Gets the tangent output component
     */ get tangentOutput() {
        return this._outputs[2];
    }
    /**
     * Gets the tangent output component
     */ get uvOutput() {
        return this._outputs[3];
    }
    initialize(state) {
        state._excludeVariableName("morphTargetInfluences");
    }
    autoConfigure(material, additionalFilteringInfo = ()=>true) {
        if (!this.position.isConnected) {
            let positionInput = material.getInputBlockByPredicate((b)=>b.isAttribute && b.name === "position" && additionalFilteringInfo(b));
            if (!positionInput) {
                positionInput = new (0, $aKEh2.InputBlock)("position");
                positionInput.setAsAttribute();
            }
            positionInput.output.connectTo(this.position);
        }
        if (!this.normal.isConnected) {
            let normalInput = material.getInputBlockByPredicate((b)=>b.isAttribute && b.name === "normal" && additionalFilteringInfo(b));
            if (!normalInput) {
                normalInput = new (0, $aKEh2.InputBlock)("normal");
                normalInput.setAsAttribute("normal");
            }
            normalInput.output.connectTo(this.normal);
        }
        if (!this.tangent.isConnected) {
            let tangentInput = material.getInputBlockByPredicate((b)=>b.isAttribute && b.name === "tangent" && additionalFilteringInfo(b));
            if (!tangentInput) {
                tangentInput = new (0, $aKEh2.InputBlock)("tangent");
                tangentInput.setAsAttribute("tangent");
            }
            tangentInput.output.connectTo(this.tangent);
        }
        if (!this.uv.isConnected) {
            let uvInput = material.getInputBlockByPredicate((b)=>b.isAttribute && b.name === "uv" && additionalFilteringInfo(b));
            if (!uvInput) {
                uvInput = new (0, $aKEh2.InputBlock)("uv");
                uvInput.setAsAttribute("uv");
            }
            uvInput.output.connectTo(this.uv);
        }
    }
    prepareDefines(mesh, nodeMaterial, defines) {
        if (mesh.morphTargetManager) {
            const morphTargetManager = mesh.morphTargetManager;
            if (morphTargetManager?.isUsingTextureForTargets && (morphTargetManager.numMaxInfluencers || morphTargetManager.numInfluencers) !== defines["NUM_MORPH_INFLUENCERS"]) defines.markAsAttributesDirty();
        }
        if (!defines._areAttributesDirty) return;
        (0, $alPCh.PrepareDefinesForMorphTargets)(mesh, defines);
    }
    bind(effect, nodeMaterial, mesh) {
        if (mesh && mesh.morphTargetManager && mesh.morphTargetManager.numInfluencers > 0) {
            (0, $alPCh.BindMorphTargetParameters)(mesh, effect);
            if (mesh.morphTargetManager.isUsingTextureForTargets) mesh.morphTargetManager._bind(effect);
        }
    }
    replaceRepeatableContent(vertexShaderState, fragmentShaderState, mesh, defines) {
        const position = this.position;
        const normal = this.normal;
        const tangent = this.tangent;
        const uv = this.uv;
        const positionOutput = this.positionOutput;
        const normalOutput = this.normalOutput;
        const tangentOutput = this.tangentOutput;
        const uvOutput = this.uvOutput;
        const state = vertexShaderState;
        const repeatCount = defines.NUM_MORPH_INFLUENCERS;
        const manager = mesh.morphTargetManager;
        const hasNormals = manager && manager.supportsNormals && defines["NORMAL"];
        const hasTangents = manager && manager.supportsTangents && defines["TANGENT"];
        const hasUVs = manager && manager.supportsUVs && defines["UV1"];
        let injectionCode = "";
        if (manager?.isUsingTextureForTargets && repeatCount > 0) injectionCode += `float vertexID;\n`;
        injectionCode += `#ifdef MORPHTARGETS\n`;
        if (manager?.isUsingTextureForTargets) {
            injectionCode += "for (int i = 0; i < NUM_MORPH_INFLUENCERS; i++) {\n";
            injectionCode += "if (i >= morphTargetCount) break;\n";
            injectionCode += `vertexID = float(gl_VertexID) * morphTargetTextureInfo.x;\n`;
            injectionCode += `${positionOutput.associatedVariableName} += (readVector3FromRawSampler(i, vertexID) - ${position.associatedVariableName}) * morphTargetInfluences[i];\n`;
            injectionCode += `vertexID += 1.0;\n`;
            if (hasNormals) {
                injectionCode += `#ifdef MORPHTARGETS_NORMAL\n`;
                injectionCode += `${normalOutput.associatedVariableName} += (readVector3FromRawSampler(i, vertexID) - ${normal.associatedVariableName}) * morphTargetInfluences[i];\n`;
                injectionCode += `vertexID += 1.0;\n`;
                injectionCode += `#endif\n`;
            }
            if (hasUVs) {
                injectionCode += `#ifdef MORPHTARGETS_UV\n`;
                injectionCode += `${uvOutput.associatedVariableName} += (readVector3FromRawSampler(i, vertexID).xy - ${uv.associatedVariableName}) * morphTargetInfluences[i];\n`;
                injectionCode += `vertexID += 1.0;\n`;
                injectionCode += `#endif\n`;
            }
            if (hasTangents) {
                injectionCode += `#ifdef MORPHTARGETS_TANGENT\n`;
                injectionCode += `${tangentOutput.associatedVariableName}.xyz += (readVector3FromRawSampler(i, vertexID) - ${tangent.associatedVariableName}.xyz) * morphTargetInfluences[i];\n`;
                if (tangent.type === (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4) injectionCode += `${tangentOutput.associatedVariableName}.w = ${tangent.associatedVariableName}.w;\n`;
                else injectionCode += `${tangentOutput.associatedVariableName}.w = 1.;\n`;
                injectionCode += `#endif\n`;
            }
            injectionCode += "}\n";
        } else for(let index = 0; index < repeatCount; index++){
            injectionCode += `${positionOutput.associatedVariableName} += (position${index} - ${position.associatedVariableName}) * morphTargetInfluences[${index}];\n`;
            if (hasNormals) {
                injectionCode += `#ifdef MORPHTARGETS_NORMAL\n`;
                injectionCode += `${normalOutput.associatedVariableName} += (normal${index} - ${normal.associatedVariableName}) * morphTargetInfluences[${index}];\n`;
                injectionCode += `#endif\n`;
            }
            if (hasUVs) {
                injectionCode += `#ifdef MORPHTARGETS_UV\n`;
                injectionCode += `${uvOutput.associatedVariableName}.xy += (uv_${index} - ${uv.associatedVariableName}.xy) * morphTargetInfluences[${index}];\n`;
                injectionCode += `#endif\n`;
            }
            if (hasTangents) {
                injectionCode += `#ifdef MORPHTARGETS_TANGENT\n`;
                injectionCode += `${tangentOutput.associatedVariableName}.xyz += (tangent${index} - ${tangent.associatedVariableName}.xyz) * morphTargetInfluences[${index}];\n`;
                if (tangent.type === (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4) injectionCode += `${tangentOutput.associatedVariableName}.w = ${tangent.associatedVariableName}.w;\n`;
                else injectionCode += `${tangentOutput.associatedVariableName}.w = 1.;\n`;
                injectionCode += `#endif\n`;
            }
        }
        injectionCode += `#endif\n`;
        state.compilationString = state.compilationString.replace(this._repeatableContentAnchor, injectionCode);
        if (repeatCount > 0) for(let index = 0; index < repeatCount; index++){
            state.attributes.push((0, $b4i1f.VertexBuffer).PositionKind + index);
            if (hasNormals) state.attributes.push((0, $b4i1f.VertexBuffer).NormalKind + index);
            if (hasTangents) state.attributes.push((0, $b4i1f.VertexBuffer).TangentKind + index);
            if (hasUVs) state.attributes.push((0, $b4i1f.VertexBuffer).UVKind + "_" + index);
        }
    }
    _buildBlock(state) {
        super._buildBlock(state);
        // Register for defines
        state.sharedData.blocksWithDefines.push(this);
        // Register for binding
        state.sharedData.bindableBlocks.push(this);
        // Register for repeatable content generation
        state.sharedData.repeatableContentBlocks.push(this);
        // Emit code
        const position = this.position;
        const normal = this.normal;
        const tangent = this.tangent;
        const uv = this.uv;
        const positionOutput = this.positionOutput;
        const normalOutput = this.normalOutput;
        const tangentOutput = this.tangentOutput;
        const uvOutput = this.uvOutput;
        const comments = `//${this.name}`;
        state.uniforms.push("morphTargetInfluences");
        state.uniforms.push("morphTargetCount");
        state.uniforms.push("morphTargetTextureInfo");
        state.uniforms.push("morphTargetTextureIndices");
        state.samplers.push("morphTargets");
        state._emitFunctionFromInclude("morphTargetsVertexGlobalDeclaration", comments);
        state._emitFunctionFromInclude("morphTargetsVertexDeclaration", comments, {
            repeatKey: "maxSimultaneousMorphTargets"
        });
        state.compilationString += `${this._declareOutput(positionOutput, state)} = ${position.associatedVariableName};\n`;
        state.compilationString += `#ifdef NORMAL\n`;
        state.compilationString += `${this._declareOutput(normalOutput, state)} = ${normal.associatedVariableName};\n`;
        state.compilationString += `#else\n`;
        state.compilationString += `${this._declareOutput(normalOutput, state)} = vec3(0., 0., 0.);\n`;
        state.compilationString += `#endif\n`;
        state.compilationString += `#ifdef TANGENT\n`;
        state.compilationString += `${this._declareOutput(tangentOutput, state)} = ${tangent.associatedVariableName};\n`;
        state.compilationString += `#else\n`;
        state.compilationString += `${this._declareOutput(tangentOutput, state)} = vec4(0., 0., 0., 0.);\n`;
        state.compilationString += `#endif\n`;
        state.compilationString += `#ifdef UV1\n`;
        state.compilationString += `${this._declareOutput(uvOutput, state)} = ${uv.associatedVariableName};\n`;
        state.compilationString += `#else\n`;
        state.compilationString += `${this._declareOutput(uvOutput, state)} = vec2(0., 0.);\n`;
        state.compilationString += `#endif\n`;
        // Repeatable content
        this._repeatableContentAnchor = state._repeatableContentAnchor;
        state.compilationString += this._repeatableContentAnchor;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.MorphTargetsBlock", $42cc0692a2cd3919$export$a4918fa70d83f267);

});

parcelRegister("1H78A", function(module, exports) {

$parcel$export(module.exports, "LightInformationBlock", () => $13bf57f865e416ff$export$d4adc70d9c19499c);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");

var $3r3bc = parcelRequire("3r3bc");
class $13bf57f865e416ff$export$d4adc70d9c19499c extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new LightInformationBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Vertex);
        this.registerInput("worldPosition", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4, false, (0, $iAIIe.NodeMaterialBlockTargets).Vertex);
        this.registerOutput("direction", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3);
        this.registerOutput("color", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3);
        this.registerOutput("intensity", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.registerOutput("shadowBias", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.registerOutput("shadowNormalBias", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.registerOutput("shadowDepthScale", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.registerOutput("shadowDepthRange", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "LightInformationBlock";
    }
    /**
     * Gets the world position input component
     */ get worldPosition() {
        return this._inputs[0];
    }
    /**
     * Gets the direction output component
     */ get direction() {
        return this._outputs[0];
    }
    /**
     * Gets the direction output component
     */ get color() {
        return this._outputs[1];
    }
    /**
     * Gets the direction output component
     */ get intensity() {
        return this._outputs[2];
    }
    /**
     * Gets the shadow bias output component
     */ get shadowBias() {
        return this._outputs[3];
    }
    /**
     * Gets the shadow normal bias output component
     */ get shadowNormalBias() {
        return this._outputs[4];
    }
    /**
     * Gets the shadow depth scale component
     */ get shadowDepthScale() {
        return this._outputs[5];
    }
    /**
     * Gets the shadow depth range component
     */ get shadowDepthRange() {
        return this._outputs[6];
    }
    bind(effect, nodeMaterial, mesh) {
        if (!mesh) return;
        if (this.light && this.light.isDisposed()) this.light = null;
        let light = this.light;
        const scene = nodeMaterial.getScene();
        if (!light && scene.lights.length) {
            light = this.light = scene.lights[0];
            this._forcePrepareDefines = true;
        }
        if (!light || !light.isEnabled) {
            effect.setFloat3(this._lightDataUniformName, 0, 0, 0);
            effect.setFloat4(this._lightColorUniformName, 0, 0, 0, 0);
            return;
        }
        light.transferToNodeMaterialEffect(effect, this._lightDataUniformName);
        effect.setColor4(this._lightColorUniformName, light.diffuse, light.intensity);
        const generator = light.getShadowGenerator();
        if (this.shadowBias.hasEndpoints || this.shadowNormalBias.hasEndpoints || this.shadowDepthScale.hasEndpoints) {
            if (generator) effect.setFloat3(this._lightShadowUniformName, generator.bias, generator.normalBias, generator.depthScale);
            else effect.setFloat3(this._lightShadowUniformName, 0, 0, 0);
        }
        if (this.shadowDepthRange) {
            if (generator && scene.activeCamera) {
                const shadowLight = light;
                effect.setFloat2(this._lightShadowExtraUniformName, shadowLight.getDepthMinZ(scene.activeCamera), shadowLight.getDepthMinZ(scene.activeCamera) + shadowLight.getDepthMaxZ(scene.activeCamera));
            } else effect.setFloat2(this._lightShadowExtraUniformName, 0, 0);
        }
    }
    prepareDefines(mesh, nodeMaterial, defines) {
        if (!defines._areLightsDirty && !this._forcePrepareDefines) return;
        this._forcePrepareDefines = false;
        const light = this.light;
        defines.setValue(this._lightTypeDefineName, light && light instanceof (0, $3r3bc.PointLight) ? true : false, true);
    }
    _buildBlock(state) {
        super._buildBlock(state);
        state.sharedData.bindableBlocks.push(this);
        state.sharedData.blocksWithDefines.push(this);
        const direction = this.direction;
        const color = this.color;
        const intensity = this.intensity;
        const shadowBias = this.shadowBias;
        const shadowNormalBias = this.shadowNormalBias;
        const shadowDepthScale = this.shadowDepthScale;
        const shadowDepthRange = this.shadowDepthRange;
        this._lightDataUniformName = state._getFreeVariableName("lightData");
        this._lightColorUniformName = state._getFreeVariableName("lightColor");
        this._lightShadowUniformName = state._getFreeVariableName("shadowData");
        this._lightShadowExtraUniformName = state._getFreeVariableName("shadowExtraData");
        this._lightTypeDefineName = state._getFreeDefineName("LIGHTPOINTTYPE");
        state._emitUniformFromString(this._lightDataUniformName, "vec3");
        state._emitUniformFromString(this._lightColorUniformName, "vec4");
        state.compilationString += `#ifdef ${this._lightTypeDefineName}\n`;
        state.compilationString += this._declareOutput(direction, state) + ` = normalize(${this.worldPosition.associatedVariableName}.xyz - ${this._lightDataUniformName});\n`;
        state.compilationString += `#else\n`;
        state.compilationString += this._declareOutput(direction, state) + ` = ${this._lightDataUniformName};\n`;
        state.compilationString += `#endif\n`;
        state.compilationString += this._declareOutput(color, state) + ` = ${this._lightColorUniformName}.rgb;\n`;
        state.compilationString += this._declareOutput(intensity, state) + ` = ${this._lightColorUniformName}.a;\n`;
        if (shadowBias.hasEndpoints || shadowNormalBias.hasEndpoints || shadowDepthScale.hasEndpoints) {
            state._emitUniformFromString(this._lightShadowUniformName, "vec3");
            if (shadowBias.hasEndpoints) state.compilationString += this._declareOutput(shadowBias, state) + ` = ${this._lightShadowUniformName}.x;\n`;
            if (shadowNormalBias.hasEndpoints) state.compilationString += this._declareOutput(shadowNormalBias, state) + ` = ${this._lightShadowUniformName}.y;\n`;
            if (shadowDepthScale.hasEndpoints) state.compilationString += this._declareOutput(shadowDepthScale, state) + ` = ${this._lightShadowUniformName}.z;\n`;
        }
        if (shadowDepthRange.hasEndpoints) {
            state._emitUniformFromString(this._lightShadowExtraUniformName, "vec2");
            state.compilationString += this._declareOutput(shadowDepthRange, state) + ` = ${this._lightShadowUniformName};\n`;
        }
        return this;
    }
    serialize() {
        const serializationObject = super.serialize();
        if (this.light) serializationObject.lightId = this.light.id;
        return serializationObject;
    }
    _deserialize(serializationObject, scene, rootUrl) {
        super._deserialize(serializationObject, scene, rootUrl);
        if (serializationObject.lightId) this.light = scene.getLightById(serializationObject.lightId);
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.LightInformationBlock", $13bf57f865e416ff$export$d4adc70d9c19499c);

});


parcelRegister("eYgRs", function(module, exports) {

var $9d6MD = parcelRequire("9d6MD");

var $hjlfg = parcelRequire("hjlfg");

var $fBGE3 = parcelRequire("fBGE3");

var $2ndTl = parcelRequire("2ndTl");

var $jy2rC = parcelRequire("jy2rC");

var $2aGF4 = parcelRequire("2aGF4");

var $kpLli = parcelRequire("kpLli");

var $JO4Gc = parcelRequire("JO4Gc");

var $3zIWE = parcelRequire("3zIWE");

var $aTD95 = parcelRequire("aTD95");

var $aK6BL = parcelRequire("aK6BL");

var $3ilyD = parcelRequire("3ilyD");

var $5lBTH = parcelRequire("5lBTH");

var $dPfUd = parcelRequire("dPfUd");

var $2jO7O = parcelRequire("2jO7O");
$parcel$exportWildcard(module.exports, $9d6MD);
$parcel$exportWildcard(module.exports, $hjlfg);
$parcel$exportWildcard(module.exports, $fBGE3);
$parcel$exportWildcard(module.exports, $2ndTl);
$parcel$exportWildcard(module.exports, $jy2rC);
$parcel$exportWildcard(module.exports, $2aGF4);
$parcel$exportWildcard(module.exports, $kpLli);
$parcel$exportWildcard(module.exports, $JO4Gc);
$parcel$exportWildcard(module.exports, $3zIWE);
$parcel$exportWildcard(module.exports, $aTD95);
$parcel$exportWildcard(module.exports, $aK6BL);
$parcel$exportWildcard(module.exports, $3ilyD);
$parcel$exportWildcard(module.exports, $5lBTH);
$parcel$exportWildcard(module.exports, $dPfUd);
$parcel$exportWildcard(module.exports, $2jO7O);

});
parcelRegister("hjlfg", function(module, exports) {

$parcel$export(module.exports, "ImageProcessingBlock", () => $c9a4b0dc2d9d8cc8$export$a8f3c44a4d2b01df);

var $e0Suo = parcelRequire("e0Suo");

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");

var $1aXVF = parcelRequire("1aXVF");
parcelRequire("7Hs3g");
parcelRequire("jtwq6");
parcelRequire("cRFSM");
class $c9a4b0dc2d9d8cc8$export$a8f3c44a4d2b01df extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Create a new ImageProcessingBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        /**
         * Defines if the input should be converted to linear space (default: true)
         */ this.convertInputToLinearSpace = true;
        this.registerInput("color", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4);
        this.registerOutput("rgb", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3);
        this._inputs[0].addExcludedConnectionPointFromAllowedTypes((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "ImageProcessingBlock";
    }
    /**
     * Gets the color input component
     */ get color() {
        return this._inputs[0];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    /**
     * Gets the rgb component
     */ get rgb() {
        return this._outputs[1];
    }
    /**
     * Initialize the block and prepare the context for build
     * @param state defines the state that will be used for the build
     */ initialize(state) {
        state._excludeVariableName("exposureLinear");
        state._excludeVariableName("contrast");
        state._excludeVariableName("vInverseScreenSize");
        state._excludeVariableName("vignetteSettings1");
        state._excludeVariableName("vignetteSettings2");
        state._excludeVariableName("vCameraColorCurveNegative");
        state._excludeVariableName("vCameraColorCurveNeutral");
        state._excludeVariableName("vCameraColorCurvePositive");
        state._excludeVariableName("txColorTransform");
        state._excludeVariableName("colorTransformSettings");
        state._excludeVariableName("ditherIntensity");
    }
    isReady(mesh, nodeMaterial, defines) {
        if (defines._areImageProcessingDirty && nodeMaterial.imageProcessingConfiguration) {
            if (!nodeMaterial.imageProcessingConfiguration.isReady()) return false;
        }
        return true;
    }
    prepareDefines(mesh, nodeMaterial, defines) {
        if (defines._areImageProcessingDirty && nodeMaterial.imageProcessingConfiguration) nodeMaterial.imageProcessingConfiguration.prepareDefines(defines);
    }
    bind(effect, nodeMaterial, mesh) {
        if (!mesh) return;
        if (!nodeMaterial.imageProcessingConfiguration) return;
        nodeMaterial.imageProcessingConfiguration.bind(effect);
    }
    _buildBlock(state) {
        super._buildBlock(state);
        // Register for defines
        state.sharedData.blocksWithDefines.push(this);
        // Register for blocking
        state.sharedData.blockingBlocks.push(this);
        // Register for binding
        state.sharedData.bindableBlocks.push(this);
        // Uniforms
        state.uniforms.push("exposureLinear");
        state.uniforms.push("contrast");
        state.uniforms.push("vInverseScreenSize");
        state.uniforms.push("vignetteSettings1");
        state.uniforms.push("vignetteSettings2");
        state.uniforms.push("vCameraColorCurveNegative");
        state.uniforms.push("vCameraColorCurveNeutral");
        state.uniforms.push("vCameraColorCurvePositive");
        state.uniforms.push("txColorTransform");
        state.uniforms.push("colorTransformSettings");
        state.uniforms.push("ditherIntensity");
        // Emit code
        const color = this.color;
        const output = this._outputs[0];
        const comments = `//${this.name}`;
        state._emitFunctionFromInclude("helperFunctions", comments);
        state._emitFunctionFromInclude("imageProcessingDeclaration", comments);
        state._emitFunctionFromInclude("imageProcessingFunctions", comments);
        if (color.connectedPoint?.isConnected) {
            if (color.connectedPoint.type === (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4 || color.connectedPoint.type === (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4) state.compilationString += `${this._declareOutput(output, state)} = ${color.associatedVariableName};\n`;
            else state.compilationString += `${this._declareOutput(output, state)} = vec4(${color.associatedVariableName}, 1.0);\n`;
            state.compilationString += `#ifdef IMAGEPROCESSINGPOSTPROCESS\n`;
            if (this.convertInputToLinearSpace) state.compilationString += `${output.associatedVariableName}.rgb = toLinearSpace(${color.associatedVariableName}.rgb);\n`;
            state.compilationString += `#else\n`;
            state.compilationString += `#ifdef IMAGEPROCESSING\n`;
            if (this.convertInputToLinearSpace) state.compilationString += `${output.associatedVariableName}.rgb = toLinearSpace(${color.associatedVariableName}.rgb);\n`;
            state.compilationString += `${output.associatedVariableName} = applyImageProcessing(${output.associatedVariableName});\n`;
            state.compilationString += `#endif\n`;
            state.compilationString += `#endif\n`;
            if (this.rgb.hasEndpoints) state.compilationString += this._declareOutput(this.rgb, state) + ` = ${this.output.associatedVariableName}.xyz;\n`;
        }
        return this;
    }
    _dumpPropertiesCode() {
        let codeString = super._dumpPropertiesCode();
        codeString += `${this._codeVariableName}.convertInputToLinearSpace = ${this.convertInputToLinearSpace};\n`;
        return codeString;
    }
    serialize() {
        const serializationObject = super.serialize();
        serializationObject.convertInputToLinearSpace = this.convertInputToLinearSpace;
        return serializationObject;
    }
    _deserialize(serializationObject, scene, rootUrl) {
        super._deserialize(serializationObject, scene, rootUrl);
        this.convertInputToLinearSpace = serializationObject.convertInputToLinearSpace ?? true;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Convert input to linear space", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED")
], $c9a4b0dc2d9d8cc8$export$a8f3c44a4d2b01df.prototype, "convertInputToLinearSpace", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.ImageProcessingBlock", $c9a4b0dc2d9d8cc8$export$a8f3c44a4d2b01df);

});

parcelRegister("fBGE3", function(module, exports) {

$parcel$export(module.exports, "PerturbNormalBlock", () => $b5cb6421dec0f56a$export$5841b31fb05de246);

var $e0Suo = parcelRequire("e0Suo");

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $g92b7 = parcelRequire("g92b7");

var $8DoUR = parcelRequire("8DoUR");

var $aKEh2 = parcelRequire("aKEh2");

var $1aXVF = parcelRequire("1aXVF");

var $dTtBA = parcelRequire("dTtBA");

var $aK6BL = parcelRequire("aK6BL");
parcelRequire("lnIOB");
parcelRequire("2KL02");
parcelRequire("F4hvB");
class $b5cb6421dec0f56a$export$5841b31fb05de246 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Create a new PerturbNormalBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this._tangentSpaceParameterName = "";
        this._tangentCorrectionFactorName = "";
        this._worldMatrixName = "";
        /** Gets or sets a boolean indicating that normal should be inverted on X axis */ this.invertX = false;
        /** Gets or sets a boolean indicating that normal should be inverted on Y axis */ this.invertY = false;
        /** Gets or sets a boolean indicating that parallax occlusion should be enabled */ this.useParallaxOcclusion = false;
        /** Gets or sets a boolean indicating that sampling mode is in Object space */ this.useObjectSpaceNormalMap = false;
        this._isUnique = true;
        // Vertex
        this.registerInput("worldPosition", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4, false);
        this.registerInput("worldNormal", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4, false);
        this.registerInput("worldTangent", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4, true);
        this.registerInput("uv", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2, false);
        this.registerInput("normalMapColor", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3, false);
        this.registerInput("strength", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, false);
        this.registerInput("viewDirection", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3, true);
        this.registerInput("parallaxScale", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true);
        this.registerInput("parallaxHeight", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true);
        this.registerInput("TBN", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Object, true, (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment, new (0, $dTtBA.NodeMaterialConnectionPointCustomObject)("TBN", this, (0, $g92b7.NodeMaterialConnectionPointDirection).Input, (0, $aK6BL.TBNBlock), "TBNBlock"));
        this.registerInput("world", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix, true);
        // Fragment
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4);
        this.registerOutput("uvOffset", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "PerturbNormalBlock";
    }
    /**
     * Gets the world position input component
     */ get worldPosition() {
        return this._inputs[0];
    }
    /**
     * Gets the world normal input component
     */ get worldNormal() {
        return this._inputs[1];
    }
    /**
     * Gets the world tangent input component
     */ get worldTangent() {
        return this._inputs[2];
    }
    /**
     * Gets the uv input component
     */ get uv() {
        return this._inputs[3];
    }
    /**
     * Gets the normal map color input component
     */ get normalMapColor() {
        return this._inputs[4];
    }
    /**
     * Gets the strength input component
     */ get strength() {
        return this._inputs[5];
    }
    /**
     * Gets the view direction input component
     */ get viewDirection() {
        return this._inputs[6];
    }
    /**
     * Gets the parallax scale input component
     */ get parallaxScale() {
        return this._inputs[7];
    }
    /**
     * Gets the parallax height input component
     */ get parallaxHeight() {
        return this._inputs[8];
    }
    /**
     * Gets the TBN input component
     */ // eslint-disable-next-line @typescript-eslint/naming-convention
    get TBN() {
        return this._inputs[9];
    }
    /**
     * Gets the World input component
     */ get world() {
        return this._inputs[10];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    /**
     * Gets the uv offset output component
     */ get uvOffset() {
        return this._outputs[1];
    }
    prepareDefines(mesh, nodeMaterial, defines) {
        const normalSamplerName = this.normalMapColor.connectedPoint._ownerBlock.samplerName;
        const useParallax = this.viewDirection.isConnected && (this.useParallaxOcclusion && normalSamplerName || !this.useParallaxOcclusion && this.parallaxHeight.isConnected);
        defines.setValue("BUMP", true);
        defines.setValue("PARALLAX", useParallax, true);
        defines.setValue("PARALLAX_RHS", nodeMaterial.getScene().useRightHandedSystem, true);
        defines.setValue("PARALLAXOCCLUSION", this.useParallaxOcclusion, true);
        defines.setValue("OBJECTSPACE_NORMALMAP", this.useObjectSpaceNormalMap, true);
    }
    bind(effect, nodeMaterial, mesh) {
        if (nodeMaterial.getScene()._mirroredCameraPosition) effect.setFloat2(this._tangentSpaceParameterName, this.invertX ? 1.0 : -1, this.invertY ? 1.0 : -1);
        else effect.setFloat2(this._tangentSpaceParameterName, this.invertX ? -1 : 1.0, this.invertY ? -1 : 1.0);
        if (mesh) {
            effect.setFloat(this._tangentCorrectionFactorName, mesh.getWorldMatrix().determinant() < 0 ? -1 : 1);
            if (this.useObjectSpaceNormalMap && !this.world.isConnected) // World default to the mesh world matrix
            effect.setMatrix(this._worldMatrixName, mesh.getWorldMatrix());
        }
    }
    autoConfigure(material, additionalFilteringInfo = ()=>true) {
        if (!this.uv.isConnected) {
            let uvInput = material.getInputBlockByPredicate((b)=>b.isAttribute && b.name === "uv" && additionalFilteringInfo(b));
            if (!uvInput) {
                uvInput = new (0, $aKEh2.InputBlock)("uv");
                uvInput.setAsAttribute();
            }
            uvInput.output.connectTo(this.uv);
        }
        if (!this.strength.isConnected) {
            const strengthInput = new (0, $aKEh2.InputBlock)("strength");
            strengthInput.value = 1.0;
            strengthInput.output.connectTo(this.strength);
        }
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const comments = `//${this.name}`;
        const uv = this.uv;
        const worldPosition = this.worldPosition;
        const worldNormal = this.worldNormal;
        const worldTangent = this.worldTangent;
        state.sharedData.blocksWithDefines.push(this);
        state.sharedData.bindableBlocks.push(this);
        this._tangentSpaceParameterName = state._getFreeDefineName("tangentSpaceParameter");
        state._emitUniformFromString(this._tangentSpaceParameterName, "vec2");
        this._tangentCorrectionFactorName = state._getFreeDefineName("tangentCorrectionFactor");
        state._emitUniformFromString(this._tangentCorrectionFactorName, "float");
        this._worldMatrixName = state._getFreeDefineName("perturbNormalWorldMatrix");
        state._emitUniformFromString(this._worldMatrixName, "mat4");
        let normalSamplerName = null;
        if (this.normalMapColor.connectedPoint) normalSamplerName = this.normalMapColor.connectedPoint._ownerBlock.samplerName;
        const useParallax = this.viewDirection.isConnected && (this.useParallaxOcclusion && normalSamplerName || !this.useParallaxOcclusion && this.parallaxHeight.isConnected);
        const replaceForParallaxInfos = !this.parallaxScale.isConnectedToInputBlock ? "0.05" : this.parallaxScale.connectInputBlock.isConstant ? state._emitFloat(this.parallaxScale.connectInputBlock.value) : this.parallaxScale.associatedVariableName;
        const replaceForBumpInfos = this.strength.isConnectedToInputBlock && this.strength.connectInputBlock.isConstant ? `\n#if !defined(NORMALXYSCALE)\n1.0/\n#endif\n${state._emitFloat(this.strength.connectInputBlock.value)}` : `\n#if !defined(NORMALXYSCALE)\n1.0/\n#endif\n${this.strength.associatedVariableName}`;
        state._emitExtension("derivatives", "#extension GL_OES_standard_derivatives : enable");
        const tangentReplaceString = {
            search: /defined\(TANGENT\)/g,
            replace: worldTangent.isConnected ? "defined(TANGENT)" : "defined(IGNORE)"
        };
        const tbnVarying = {
            search: /varying mat3 vTBN;/g,
            replace: ""
        };
        const normalMatrixReplaceString = {
            search: /uniform mat4 normalMatrix;/g,
            replace: ""
        };
        const TBN = this.TBN;
        if (TBN.isConnected) state.compilationString += `
            #ifdef TBNBLOCK
            mat3 vTBN = ${TBN.associatedVariableName};
            #endif
            `;
        else if (worldTangent.isConnected) {
            state.compilationString += `vec3 tbnNormal = normalize(${worldNormal.associatedVariableName}.xyz);\n`;
            state.compilationString += `vec3 tbnTangent = normalize(${worldTangent.associatedVariableName}.xyz);\n`;
            state.compilationString += `vec3 tbnBitangent = cross(tbnNormal, tbnTangent) * ${this._tangentCorrectionFactorName};\n`;
            state.compilationString += `mat3 vTBN = mat3(tbnTangent, tbnBitangent, tbnNormal);\n`;
        }
        state._emitFunctionFromInclude("bumpFragmentMainFunctions", comments, {
            replaceStrings: [
                tangentReplaceString,
                tbnVarying,
                normalMatrixReplaceString
            ]
        });
        state._emitFunctionFromInclude("bumpFragmentFunctions", comments, {
            replaceStrings: [
                {
                    search: /#include<samplerFragmentDeclaration>\(_DEFINENAME_,BUMP,_VARYINGNAME_,Bump,_SAMPLERNAME_,bump\)/g,
                    replace: ""
                },
                {
                    search: /uniform sampler2D bumpSampler;/g,
                    replace: ""
                },
                {
                    search: /vec2 parallaxOcclusion\(vec3 vViewDirCoT,vec3 vNormalCoT,vec2 texCoord,float parallaxScale\)/g,
                    replace: "#define inline\nvec2 parallaxOcclusion(vec3 vViewDirCoT, vec3 vNormalCoT, vec2 texCoord, float parallaxScale, sampler2D bumpSampler)"
                },
                {
                    search: /vec2 parallaxOffset\(vec3 viewDir,float heightScale\)/g,
                    replace: "vec2 parallaxOffset(vec3 viewDir, float heightScale, float height_)"
                },
                {
                    search: /texture2D\(bumpSampler,vBumpUV\)\.w/g,
                    replace: "height_"
                }
            ]
        });
        const uvForPerturbNormal = !useParallax || !normalSamplerName ? this.normalMapColor.associatedVariableName : `texture2D(${normalSamplerName}, ${uv.associatedVariableName} + uvOffset).xyz`;
        state.compilationString += this._declareOutput(this.output, state) + " = vec4(0.);\n";
        state.compilationString += state._emitCodeFromInclude("bumpFragment", comments, {
            replaceStrings: [
                {
                    search: /texture2D\(bumpSampler,vBumpUV\)/g,
                    replace: `${uvForPerturbNormal}`
                },
                {
                    search: /#define CUSTOM_FRAGMENT_BUMP_FRAGMENT/g,
                    replace: `mat4 normalMatrix = toNormalMatrix(${this.world.isConnected ? this.world.associatedVariableName : this._worldMatrixName});`
                },
                {
                    search: /perturbNormal\(TBN,texture2D\(bumpSampler,vBumpUV\+uvOffset\).xyz,vBumpInfos.y\)/g,
                    replace: `perturbNormal(TBN, ${uvForPerturbNormal}, vBumpInfos.y)`
                },
                {
                    search: /parallaxOcclusion\(invTBN\*-viewDirectionW,invTBN\*normalW,vBumpUV,vBumpInfos.z\)/g,
                    replace: `parallaxOcclusion((invTBN * -viewDirectionW), (invTBN * normalW), vBumpUV, vBumpInfos.z, ${useParallax && this.useParallaxOcclusion ? normalSamplerName : "bumpSampler"})`
                },
                {
                    search: /parallaxOffset\(invTBN\*viewDirectionW,vBumpInfos\.z\)/g,
                    replace: `parallaxOffset(invTBN * viewDirectionW, vBumpInfos.z, ${useParallax ? this.parallaxHeight.associatedVariableName : "0."})`
                },
                {
                    search: /vTangentSpaceParams/g,
                    replace: this._tangentSpaceParameterName
                },
                {
                    search: /vBumpInfos.y/g,
                    replace: replaceForBumpInfos
                },
                {
                    search: /vBumpInfos.z/g,
                    replace: replaceForParallaxInfos
                },
                {
                    search: /vBumpUV/g,
                    replace: uv.associatedVariableName
                },
                {
                    search: /vPositionW/g,
                    replace: worldPosition.associatedVariableName + ".xyz"
                },
                {
                    search: /normalW=/g,
                    replace: this.output.associatedVariableName + ".xyz = "
                },
                {
                    search: /mat3\(normalMatrix\)\*normalW/g,
                    replace: "mat3(normalMatrix) * " + this.output.associatedVariableName + ".xyz"
                },
                {
                    search: /normalW/g,
                    replace: worldNormal.associatedVariableName + ".xyz"
                },
                {
                    search: /viewDirectionW/g,
                    replace: useParallax ? this.viewDirection.associatedVariableName : "vec3(0.)"
                },
                tangentReplaceString
            ]
        });
        return this;
    }
    _dumpPropertiesCode() {
        let codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.invertX = ${this.invertX};\n`;
        codeString += `${this._codeVariableName}.invertY = ${this.invertY};\n`;
        codeString += `${this._codeVariableName}.useParallaxOcclusion = ${this.useParallaxOcclusion};\n`;
        codeString += `${this._codeVariableName}.useObjectSpaceNormalMap = ${this.useObjectSpaceNormalMap};\n`;
        return codeString;
    }
    serialize() {
        const serializationObject = super.serialize();
        serializationObject.invertX = this.invertX;
        serializationObject.invertY = this.invertY;
        serializationObject.useParallaxOcclusion = this.useParallaxOcclusion;
        serializationObject.useObjectSpaceNormalMap = this.useObjectSpaceNormalMap;
        return serializationObject;
    }
    _deserialize(serializationObject, scene, rootUrl) {
        super._deserialize(serializationObject, scene, rootUrl);
        this.invertX = serializationObject.invertX;
        this.invertY = serializationObject.invertY;
        this.useParallaxOcclusion = !!serializationObject.useParallaxOcclusion;
        this.useObjectSpaceNormalMap = !!serializationObject.useObjectSpaceNormalMap;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Invert X axis", (0, $1aXVF.PropertyTypeForEdition).Boolean, "PROPERTIES", {
        notifiers: {
            update: false
        }
    })
], $b5cb6421dec0f56a$export$5841b31fb05de246.prototype, "invertX", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Invert Y axis", (0, $1aXVF.PropertyTypeForEdition).Boolean, "PROPERTIES", {
        notifiers: {
            update: false
        }
    })
], $b5cb6421dec0f56a$export$5841b31fb05de246.prototype, "invertY", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Use parallax occlusion", (0, $1aXVF.PropertyTypeForEdition).Boolean)
], $b5cb6421dec0f56a$export$5841b31fb05de246.prototype, "useParallaxOcclusion", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Object Space Mode", (0, $1aXVF.PropertyTypeForEdition).Boolean, "PROPERTIES", {
        notifiers: {
            update: false
        }
    })
], $b5cb6421dec0f56a$export$5841b31fb05de246.prototype, "useObjectSpaceNormalMap", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.PerturbNormalBlock", $b5cb6421dec0f56a$export$5841b31fb05de246);

});
parcelRegister("aK6BL", function(module, exports) {

$parcel$export(module.exports, "TBNBlock", () => $7d23537ecc489c39$export$fa26c360c5e1d9c3);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $g92b7 = parcelRequire("g92b7");

var $8DoUR = parcelRequire("8DoUR");

var $dTtBA = parcelRequire("dTtBA");

var $7qH6c = parcelRequire("7qH6c");

var $aKEh2 = parcelRequire("aKEh2");
class $7d23537ecc489c39$export$fa26c360c5e1d9c3 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Create a new TBNBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Fragment, true);
        this.registerInput("normal", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect, false);
        this.normal.addExcludedConnectionPointFromAllowedTypes((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3);
        this.registerInput("tangent", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4, false);
        this.registerInput("world", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix, false);
        this.registerOutput("TBN", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Object, (0, $iAIIe.NodeMaterialBlockTargets).Fragment, new (0, $dTtBA.NodeMaterialConnectionPointCustomObject)("TBN", this, (0, $g92b7.NodeMaterialConnectionPointDirection).Output, $7d23537ecc489c39$export$fa26c360c5e1d9c3, "TBNBlock"));
        this.registerOutput("row0", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("row1", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("row2", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "TBNBlock";
    }
    /**
     * Initialize the block and prepare the context for build
     * @param state defines the state that will be used for the build
     */ initialize(state) {
        state._excludeVariableName("tbnNormal");
        state._excludeVariableName("tbnTangent");
        state._excludeVariableName("tbnBitangent");
        state._excludeVariableName("TBN");
    }
    /**
     * Gets the normal input component
     */ get normal() {
        return this._inputs[0];
    }
    /**
     * Gets the tangent input component
     */ get tangent() {
        return this._inputs[1];
    }
    /**
     * Gets the world matrix input component
     */ get world() {
        return this._inputs[2];
    }
    /**
     * Gets the TBN output component
     */ // eslint-disable-next-line @typescript-eslint/naming-convention
    get TBN() {
        return this._outputs[0];
    }
    /**
     * Gets the row0 of the output matrix
     */ get row0() {
        return this._outputs[1];
    }
    /**
     * Gets the row1 of the output matrix
     */ get row1() {
        return this._outputs[2];
    }
    /**
     * Gets the row2 of the output matrix
     */ get row2() {
        return this._outputs[3];
    }
    get target() {
        return (0, $iAIIe.NodeMaterialBlockTargets).Fragment;
    }
    set target(value) {}
    autoConfigure(material, additionalFilteringInfo = ()=>true) {
        if (!this.world.isConnected) {
            let worldInput = material.getInputBlockByPredicate((b)=>b.isSystemValue && b.systemValue === (0, $7qH6c.NodeMaterialSystemValues).World && additionalFilteringInfo(b));
            if (!worldInput) {
                worldInput = new (0, $aKEh2.InputBlock)("world");
                worldInput.setAsSystemValue((0, $7qH6c.NodeMaterialSystemValues).World);
            }
            worldInput.output.connectTo(this.world);
        }
        if (!this.normal.isConnected) {
            let normalInput = material.getInputBlockByPredicate((b)=>b.isAttribute && b.name === "normal" && additionalFilteringInfo(b));
            if (!normalInput) {
                normalInput = new (0, $aKEh2.InputBlock)("normal");
                normalInput.setAsAttribute("normal");
            }
            normalInput.output.connectTo(this.normal);
        }
        if (!this.tangent.isConnected) {
            let tangentInput = material.getInputBlockByPredicate((b)=>b.isAttribute && b.name === "tangent" && b.type === (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4 && additionalFilteringInfo(b));
            if (!tangentInput) {
                tangentInput = new (0, $aKEh2.InputBlock)("tangent");
                tangentInput.setAsAttribute("tangent");
            }
            tangentInput.output.connectTo(this.tangent);
        }
    }
    prepareDefines(mesh, nodeMaterial, defines) {
        const normal = this.normal;
        const tangent = this.tangent;
        let normalAvailable = normal.isConnected;
        if (normal.connectInputBlock?.isAttribute && !mesh.isVerticesDataPresent(normal.connectInputBlock?.name)) normalAvailable = false;
        let tangentAvailable = tangent.isConnected;
        if (tangent.connectInputBlock?.isAttribute && !mesh.isVerticesDataPresent(tangent.connectInputBlock?.name)) tangentAvailable = false;
        const useTBNBlock = normalAvailable && tangentAvailable;
        defines.setValue("TBNBLOCK", useTBNBlock, true);
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const normal = this.normal;
        const tangent = this.tangent;
        const world = this.world;
        const TBN = this.TBN;
        const row0 = this.row0;
        const row1 = this.row1;
        const row2 = this.row2;
        // Fragment
        if (state.target === (0, $iAIIe.NodeMaterialBlockTargets).Fragment) {
            state.compilationString += `
                // ${this.name}
                vec3 tbnNormal = normalize(${normal.associatedVariableName}).xyz;
                vec3 tbnTangent = normalize(${tangent.associatedVariableName}.xyz);
                vec3 tbnBitangent = cross(tbnNormal, tbnTangent) * ${tangent.associatedVariableName}.w;
                mat3 ${TBN.associatedVariableName} = mat3(${world.associatedVariableName}) * mat3(tbnTangent, tbnBitangent, tbnNormal);
            `;
            if (row0.hasEndpoints) state.compilationString += this._declareOutput(row0, state) + ` = vec3(${TBN.associatedVariableName}[0][0], ${TBN.associatedVariableName}[0][1], ${TBN.associatedVariableName}[0][2]);\n`;
            if (row1.hasEndpoints) state.compilationString += this._declareOutput(row1, state) + ` = vec3(${TBN.associatedVariableName}[1[0], ${TBN.associatedVariableName}[1][1], ${TBN.associatedVariableName}[1][2]);\n`;
            if (row2.hasEndpoints) state.compilationString += this._declareOutput(row2, state) + ` = vec3(${TBN.associatedVariableName}[2][0], ${TBN.associatedVariableName}[2][1], ${TBN.associatedVariableName}[2][2]);\n`;
            state.sharedData.blocksWithDefines.push(this);
        }
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.TBNBlock", $7d23537ecc489c39$export$fa26c360c5e1d9c3);

});


parcelRegister("2ndTl", function(module, exports) {

$parcel$export(module.exports, "DiscardBlock", () => $1ba8815dda5ee43b$export$d0217237e05b90a7);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $1ba8815dda5ee43b$export$d0217237e05b90a7 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Create a new DiscardBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Fragment, true);
        this.registerInput("value", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true);
        this.registerInput("cutoff", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "DiscardBlock";
    }
    /**
     * Gets the color input component
     */ get value() {
        return this._inputs[0];
    }
    /**
     * Gets the cutoff input component
     */ get cutoff() {
        return this._inputs[1];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        state.sharedData.hints.needAlphaTesting = true;
        if (!this.cutoff.isConnected || !this.value.isConnected) return;
        state.compilationString += `if (${this.value.associatedVariableName} < ${this.cutoff.associatedVariableName}) discard;\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.DiscardBlock", $1ba8815dda5ee43b$export$d0217237e05b90a7);

});

parcelRegister("jy2rC", function(module, exports) {

$parcel$export(module.exports, "FrontFacingBlock", () => $e3b316b8fe469d6d$export$301cd62c3888053a);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $e3b316b8fe469d6d$export$301cd62c3888053a extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new FrontFacingBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "FrontFacingBlock";
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        if (state.target === (0, $iAIIe.NodeMaterialBlockTargets).Vertex) // eslint-disable-next-line no-throw-literal
        throw "FrontFacingBlock must only be used in a fragment shader";
        const output = this._outputs[0];
        state.compilationString += this._declareOutput(output, state) + ` = gl_FrontFacing ? 1.0 : 0.0;\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.FrontFacingBlock", $e3b316b8fe469d6d$export$301cd62c3888053a);

});

parcelRegister("2aGF4", function(module, exports) {

$parcel$export(module.exports, "DerivativeBlock", () => $194d9ba10cb539a0$export$fe652f8db6f919b1);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $194d9ba10cb539a0$export$fe652f8db6f919b1 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Create a new DerivativeBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("input", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect, false);
        this.registerOutput("dx", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).BasedOnInput);
        this.registerOutput("dy", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
        this._outputs[1]._typeConnectionSource = this._inputs[0];
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "DerivativeBlock";
    }
    /**
     * Gets the input component
     */ get input() {
        return this._inputs[0];
    }
    /**
     * Gets the derivative output on x
     */ get dx() {
        return this._outputs[0];
    }
    /**
     * Gets the derivative output on y
     */ get dy() {
        return this._outputs[1];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const dx = this._outputs[0];
        const dy = this._outputs[1];
        state._emitExtension("derivatives", "#extension GL_OES_standard_derivatives : enable");
        if (dx.hasEndpoints) state.compilationString += this._declareOutput(dx, state) + ` = dFdx(${this.input.associatedVariableName});\n`;
        if (dy.hasEndpoints) state.compilationString += this._declareOutput(dy, state) + ` = dFdy(${this.input.associatedVariableName});\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.DerivativeBlock", $194d9ba10cb539a0$export$fe652f8db6f919b1);

});

parcelRegister("kpLli", function(module, exports) {

$parcel$export(module.exports, "FragCoordBlock", () => $edcaddb16433b87e$export$881128630ed0cc8e);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $edcaddb16433b87e$export$881128630ed0cc8e extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new FragCoordBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("xy", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("xyz", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("xyzw", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("x", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("y", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("z", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("w", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "FragCoordBlock";
    }
    /**
     * Gets the xy component
     */ get xy() {
        return this._outputs[0];
    }
    /**
     * Gets the xyz component
     */ get xyz() {
        return this._outputs[1];
    }
    /**
     * Gets the xyzw component
     */ get xyzw() {
        return this._outputs[2];
    }
    /**
     * Gets the x component
     */ get x() {
        return this._outputs[3];
    }
    /**
     * Gets the y component
     */ get y() {
        return this._outputs[4];
    }
    /**
     * Gets the z component
     */ get z() {
        return this._outputs[5];
    }
    /**
     * Gets the w component
     */ get output() {
        return this._outputs[6];
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    writeOutputs(state) {
        let code = "";
        for (const output of this._outputs)if (output.hasEndpoints) code += `${this._declareOutput(output, state)} = gl_FragCoord.${output.name};\n`;
        return code;
    }
    _buildBlock(state) {
        super._buildBlock(state);
        if (state.target === (0, $iAIIe.NodeMaterialBlockTargets).Vertex) // eslint-disable-next-line no-throw-literal
        throw "FragCoordBlock must only be used in a fragment shader";
        state.compilationString += this.writeOutputs(state);
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.FragCoordBlock", $edcaddb16433b87e$export$881128630ed0cc8e);

});

parcelRegister("JO4Gc", function(module, exports) {

$parcel$export(module.exports, "ScreenSizeBlock", () => $089b0bd4f4caf630$export$e2445c101dbc0575);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $089b0bd4f4caf630$export$e2445c101dbc0575 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new ScreenSizeBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("xy", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("x", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("y", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "ScreenSizeBlock";
    }
    /**
     * Gets the xy component
     */ get xy() {
        return this._outputs[0];
    }
    /**
     * Gets the x component
     */ get x() {
        return this._outputs[1];
    }
    /**
     * Gets the y component
     */ get y() {
        return this._outputs[2];
    }
    bind(effect) {
        const engine = this._scene.getEngine();
        effect.setFloat2(this._varName, engine.getRenderWidth(), engine.getRenderHeight());
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    writeOutputs(state, varName) {
        let code = "";
        for (const output of this._outputs)if (output.hasEndpoints) code += `${this._declareOutput(output, state)} = ${varName}.${output.name};\n`;
        return code;
    }
    _buildBlock(state) {
        super._buildBlock(state);
        this._scene = state.sharedData.scene;
        if (state.target === (0, $iAIIe.NodeMaterialBlockTargets).Vertex) // eslint-disable-next-line no-throw-literal
        throw "ScreenSizeBlock must only be used in a fragment shader";
        state.sharedData.bindableBlocks.push(this);
        this._varName = state._getFreeVariableName("screenSize");
        state._emitUniformFromString(this._varName, "vec2");
        state.compilationString += this.writeOutputs(state, this._varName);
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.ScreenSizeBlock", $089b0bd4f4caf630$export$e2445c101dbc0575);

});

parcelRegister("3zIWE", function(module, exports) {

$parcel$export(module.exports, "ScreenSpaceBlock", () => $29a78118b6eaf98b$export$42b3b87c1fbb5a33);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");

var $7qH6c = parcelRequire("7qH6c");

var $aKEh2 = parcelRequire("aKEh2");
class $29a78118b6eaf98b$export$42b3b87c1fbb5a33 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new ScreenSpaceBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("vector", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerInput("worldViewProjection", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2);
        this.registerOutput("x", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.registerOutput("y", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.inputs[0].addExcludedConnectionPointFromAllowedTypes((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "ScreenSpaceBlock";
    }
    /**
     * Gets the vector input
     */ get vector() {
        return this._inputs[0];
    }
    /**
     * Gets the worldViewProjection transform input
     */ get worldViewProjection() {
        return this._inputs[1];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    /**
     * Gets the x output component
     */ get x() {
        return this._outputs[1];
    }
    /**
     * Gets the y output component
     */ get y() {
        return this._outputs[2];
    }
    autoConfigure(material, additionalFilteringInfo = ()=>true) {
        if (!this.worldViewProjection.isConnected) {
            let worldViewProjectionInput = material.getInputBlockByPredicate((b)=>b.systemValue === (0, $7qH6c.NodeMaterialSystemValues).WorldViewProjection && additionalFilteringInfo(b));
            if (!worldViewProjectionInput) {
                worldViewProjectionInput = new (0, $aKEh2.InputBlock)("worldViewProjection");
                worldViewProjectionInput.setAsSystemValue((0, $7qH6c.NodeMaterialSystemValues).WorldViewProjection);
            }
            worldViewProjectionInput.output.connectTo(this.worldViewProjection);
        }
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const vector = this.vector;
        const worldViewProjection = this.worldViewProjection;
        if (!vector.connectedPoint) return;
        const worldViewProjectionName = worldViewProjection.associatedVariableName;
        const tempVariableName = state._getFreeVariableName("screenSpaceTemp");
        switch(vector.connectedPoint.type){
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3:
                state.compilationString += `vec4 ${tempVariableName} = ${worldViewProjectionName} * vec4(${vector.associatedVariableName}, 1.0);\n`;
                break;
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4:
                state.compilationString += `vec4 ${tempVariableName} = ${worldViewProjectionName} * ${vector.associatedVariableName};\n`;
                break;
        }
        state.compilationString += `${tempVariableName}.xy /= ${tempVariableName}.w;`;
        state.compilationString += `${tempVariableName}.xy = ${tempVariableName}.xy * 0.5 + vec2(0.5, 0.5);`;
        if (this.output.hasEndpoints) state.compilationString += this._declareOutput(this.output, state) + ` = ${tempVariableName}.xy;\n`;
        if (this.x.hasEndpoints) state.compilationString += this._declareOutput(this.x, state) + ` = ${tempVariableName}.x;\n`;
        if (this.y.hasEndpoints) state.compilationString += this._declareOutput(this.y, state) + ` = ${tempVariableName}.y;\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.ScreenSpaceBlock", $29a78118b6eaf98b$export$42b3b87c1fbb5a33);

});

parcelRegister("aTD95", function(module, exports) {

$parcel$export(module.exports, "TwirlBlock", () => $7eed67ef4718789c$export$dac94cc90f25a9f);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");

var $aKEh2 = parcelRequire("aKEh2");

var $ha1VO = parcelRequire("ha1VO");
class $7eed67ef4718789c$export$dac94cc90f25a9f extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new TwirlBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("input", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2);
        this.registerInput("strength", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.registerInput("center", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2);
        this.registerInput("offset", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2);
        this.registerOutput("x", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.registerOutput("y", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "TwirlBlock";
    }
    /**
     * Gets the input component
     */ get input() {
        return this._inputs[0];
    }
    /**
     * Gets the strength component
     */ get strength() {
        return this._inputs[1];
    }
    /**
     * Gets the center component
     */ get center() {
        return this._inputs[2];
    }
    /**
     * Gets the offset component
     */ get offset() {
        return this._inputs[3];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    /**
     * Gets the x output component
     */ get x() {
        return this._outputs[1];
    }
    /**
     * Gets the y output component
     */ get y() {
        return this._outputs[2];
    }
    autoConfigure() {
        if (!this.center.isConnected) {
            const centerInput = new (0, $aKEh2.InputBlock)("center");
            centerInput.value = new (0, $ha1VO.Vector2)(0.5, 0.5);
            centerInput.output.connectTo(this.center);
        }
        if (!this.strength.isConnected) {
            const strengthInput = new (0, $aKEh2.InputBlock)("strength");
            strengthInput.value = 1.0;
            strengthInput.output.connectTo(this.strength);
        }
        if (!this.offset.isConnected) {
            const offsetInput = new (0, $aKEh2.InputBlock)("offset");
            offsetInput.value = new (0, $ha1VO.Vector2)(0, 0);
            offsetInput.output.connectTo(this.offset);
        }
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const tempDelta = state._getFreeVariableName("delta");
        const tempAngle = state._getFreeVariableName("angle");
        const tempX = state._getFreeVariableName("x");
        const tempY = state._getFreeVariableName("y");
        const tempResult = state._getFreeVariableName("result");
        state.compilationString += `
            vec2 ${tempDelta} = ${this.input.associatedVariableName} - ${this.center.associatedVariableName};
            float ${tempAngle} = ${this.strength.associatedVariableName} * length(${tempDelta});
            float ${tempX} = cos(${tempAngle}) * ${tempDelta}.x - sin(${tempAngle}) * ${tempDelta}.y;
            float ${tempY} = sin(${tempAngle}) * ${tempDelta}.x + cos(${tempAngle}) * ${tempDelta}.y;
            vec2 ${tempResult} = vec2(${tempX} + ${this.center.associatedVariableName}.x + ${this.offset.associatedVariableName}.x, ${tempY} + ${this.center.associatedVariableName}.y + ${this.offset.associatedVariableName}.y);
        `;
        if (this.output.hasEndpoints) state.compilationString += this._declareOutput(this.output, state) + ` = ${tempResult};\n`;
        if (this.x.hasEndpoints) state.compilationString += this._declareOutput(this.x, state) + ` = ${tempResult}.x;\n`;
        if (this.y.hasEndpoints) state.compilationString += this._declareOutput(this.y, state) + ` = ${tempResult}.y;\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.TwirlBlock", $7eed67ef4718789c$export$dac94cc90f25a9f);

});

parcelRegister("3ilyD", function(module, exports) {

$parcel$export(module.exports, "HeightToNormalBlock", () => $2663c6734eb84dfd$export$575128d0bb37a74c);

var $e0Suo = parcelRequire("e0Suo");

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");

var $1aXVF = parcelRequire("1aXVF");

var $kVtWi = parcelRequire("kVtWi");
class $2663c6734eb84dfd$export$575128d0bb37a74c extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new HeightToNormalBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        /**
         * Defines if the output should be generated in world or tangent space.
         * Note that in tangent space the result is also scaled by 0.5 and offsetted by 0.5 so that it can directly be used as a PerturbNormal.normalMapColor input
         */ this.generateInWorldSpace = false;
        /**
         * Defines that the worldNormal input will be normalized by the HeightToNormal block before being used
         */ this.automaticNormalizationNormal = true;
        /**
         * Defines that the worldTangent input will be normalized by the HeightToNormal block before being used
         */ this.automaticNormalizationTangent = true;
        this.registerInput("input", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.registerInput("worldPosition", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3);
        this.registerInput("worldNormal", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3);
        this.registerInput("worldTangent", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect, true);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4);
        this.registerOutput("xyz", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3);
        this._inputs[3].addExcludedConnectionPointFromAllowedTypes((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "HeightToNormalBlock";
    }
    /**
     * Gets the input component
     */ get input() {
        return this._inputs[0];
    }
    /**
     * Gets the position component
     */ get worldPosition() {
        return this._inputs[1];
    }
    /**
     * Gets the normal component
     */ get worldNormal() {
        return this._inputs[2];
    }
    /**
     * Gets the tangent component
     */ get worldTangent() {
        return this._inputs[3];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    /**
     * Gets the xyz component
     */ get xyz() {
        return this._outputs[1];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        if (!this.generateInWorldSpace && !this.worldTangent.isConnected) (0, $kVtWi.Logger).Error(`You must connect the 'worldTangent' input of the ${this.name} block!`);
        const startCode = this.generateInWorldSpace ? "" : `
            vec3 biTangent = cross(normal, tangent);
            mat3 TBN = mat3(tangent, biTangent, normal);
            `;
        const endCode = this.generateInWorldSpace ? "" : `
            result = TBN * result;
            result = result * vec3(0.5) + vec3(0.5);
            `;
        const heightToNormal = `
            vec4 heightToNormal(in float height, in vec3 position, in vec3 tangent, in vec3 normal) {
                ${this.automaticNormalizationTangent ? "tangent = normalize(tangent);" : ""}
                ${this.automaticNormalizationNormal ? "normal = normalize(normal);" : ""}
                ${startCode}
                vec3 worlddX = dFdx(position);
                vec3 worlddY = dFdy(position);
                vec3 crossX = cross(normal, worlddX);
                vec3 crossY = cross(normal, worlddY);
                float d = abs(dot(crossY, worlddX));
                vec3 inToNormal = vec3(((((height + dFdx(height)) - height) * crossY) + (((height + dFdy(height)) - height) * crossX)) * sign(d));
                inToNormal.y *= -1.0;
                vec3 result = normalize((d * normal) - inToNormal);
                ${endCode}
                return vec4(result, 0.);
            }`;
        state._emitExtension("derivatives", "#extension GL_OES_standard_derivatives : enable");
        state._emitFunction("heightToNormal", heightToNormal, "// heightToNormal");
        state.compilationString += this._declareOutput(output, state) + ` = heightToNormal(${this.input.associatedVariableName}, ${this.worldPosition.associatedVariableName}, ${this.worldTangent.isConnected ? this.worldTangent.associatedVariableName : "vec3(0.)"}.xyz, ${this.worldNormal.associatedVariableName});\n`;
        if (this.xyz.hasEndpoints) state.compilationString += this._declareOutput(this.xyz, state) + ` = ${this.output.associatedVariableName}.xyz;\n`;
        return this;
    }
    _dumpPropertiesCode() {
        let codeString = super._dumpPropertiesCode();
        codeString += `${this._codeVariableName}.generateInWorldSpace = ${this.generateInWorldSpace};\n`;
        codeString += `${this._codeVariableName}.automaticNormalizationNormal = ${this.automaticNormalizationNormal};\n`;
        codeString += `${this._codeVariableName}.automaticNormalizationTangent = ${this.automaticNormalizationTangent};\n`;
        return codeString;
    }
    serialize() {
        const serializationObject = super.serialize();
        serializationObject.generateInWorldSpace = this.generateInWorldSpace;
        serializationObject.automaticNormalizationNormal = this.automaticNormalizationNormal;
        serializationObject.automaticNormalizationTangent = this.automaticNormalizationTangent;
        return serializationObject;
    }
    _deserialize(serializationObject, scene, rootUrl) {
        super._deserialize(serializationObject, scene, rootUrl);
        this.generateInWorldSpace = serializationObject.generateInWorldSpace;
        this.automaticNormalizationNormal = serializationObject.automaticNormalizationNormal;
        this.automaticNormalizationTangent = serializationObject.automaticNormalizationTangent;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Generate in world space instead of tangent space", (0, $1aXVF.PropertyTypeForEdition).Boolean, "PROPERTIES", {
        notifiers: {
            update: true
        }
    })
], $2663c6734eb84dfd$export$575128d0bb37a74c.prototype, "generateInWorldSpace", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Force normalization for the worldNormal input", (0, $1aXVF.PropertyTypeForEdition).Boolean, "PROPERTIES", {
        notifiers: {
            update: true
        }
    })
], $2663c6734eb84dfd$export$575128d0bb37a74c.prototype, "automaticNormalizationNormal", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Force normalization for the worldTangent input", (0, $1aXVF.PropertyTypeForEdition).Boolean, "PROPERTIES", {
        notifiers: {
            update: true
        }
    })
], $2663c6734eb84dfd$export$575128d0bb37a74c.prototype, "automaticNormalizationTangent", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.HeightToNormalBlock", $2663c6734eb84dfd$export$575128d0bb37a74c);

});

parcelRegister("5lBTH", function(module, exports) {

$parcel$export(module.exports, "FragDepthBlock", () => $3e4c4f894d856cc8$export$6d5f8ed6a573543c);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");

var $kVtWi = parcelRequire("kVtWi");
class $3e4c4f894d856cc8$export$6d5f8ed6a573543c extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Create a new FragDepthBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Fragment, true);
        this.registerInput("depth", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true);
        this.registerInput("worldPos", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4, true);
        this.registerInput("viewProjection", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix, true);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "FragDepthBlock";
    }
    /**
     * Gets the depth input component
     */ get depth() {
        return this._inputs[0];
    }
    /**
     * Gets the worldPos input component
     */ get worldPos() {
        return this._inputs[1];
    }
    /**
     * Gets the viewProjection input component
     */ get viewProjection() {
        return this._inputs[2];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        if (this.depth.isConnected) state.compilationString += `gl_FragDepth = ${this.depth.associatedVariableName};\n`;
        else if (this.worldPos.isConnected && this.viewProjection.isConnected) state.compilationString += `
                vec4 p = ${this.viewProjection.associatedVariableName} * ${this.worldPos.associatedVariableName};
                float v = p.z / p.w;
                #ifndef IS_NDC_HALF_ZRANGE
                    v = v * 0.5 + 0.5;
                #endif
                gl_FragDepth = v;
    
            `;
        else (0, $kVtWi.Logger).Warn("FragDepthBlock: either the depth input or both the worldPos and viewProjection inputs must be connected!");
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.FragDepthBlock", $3e4c4f894d856cc8$export$6d5f8ed6a573543c);

});

parcelRegister("dPfUd", function(module, exports) {

$parcel$export(module.exports, "ShadowMapBlock", () => $a10c604e6e63c527$export$3f57c3e5e2cc5555);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $a10c604e6e63c527$export$3f57c3e5e2cc5555 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Create a new ShadowMapBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("worldPosition", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4, false);
        this.registerInput("viewProjection", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix, false);
        this.registerInput("worldNormal", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect, true);
        this.registerOutput("depth", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3);
        this.worldNormal.addExcludedConnectionPointFromAllowedTypes((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "ShadowMapBlock";
    }
    /**
     * Initialize the block and prepare the context for build
     * @param state defines the state that will be used for the build
     */ initialize(state) {
        state._excludeVariableName("vPositionWSM");
        state._excludeVariableName("lightDataSM");
        state._excludeVariableName("biasAndScaleSM");
        state._excludeVariableName("depthValuesSM");
        state._excludeVariableName("clipPos");
        state._excludeVariableName("worldPos");
        state._excludeVariableName("zSM");
    }
    /**
     * Gets the world position input component
     */ get worldPosition() {
        return this._inputs[0];
    }
    /**
     * Gets the view x projection input component
     */ get viewProjection() {
        return this._inputs[1];
    }
    /**
     * Gets the world normal input component
     */ get worldNormal() {
        return this._inputs[2];
    }
    /**
     * Gets the depth output component
     */ get depth() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const comments = `//${this.name}`;
        state._emitUniformFromString("biasAndScaleSM", "vec3");
        state._emitUniformFromString("lightDataSM", "vec3");
        state._emitUniformFromString("depthValuesSM", "vec2");
        state._emitFunctionFromInclude("packingFunctions", comments);
        state.compilationString += `vec4 worldPos = ${this.worldPosition.associatedVariableName};\n`;
        state.compilationString += `vec3 vPositionWSM;\n`;
        state.compilationString += `float vDepthMetricSM = 0.0;\n`;
        state.compilationString += `float zSM;\n`;
        if (this.worldNormal.isConnected) {
            state.compilationString += `vec3 vNormalW = ${this.worldNormal.associatedVariableName}.xyz;\n`;
            state.compilationString += state._emitCodeFromInclude("shadowMapVertexNormalBias", comments);
        }
        state.compilationString += `vec4 clipPos = ${this.viewProjection.associatedVariableName} * worldPos;\n`;
        state.compilationString += state._emitCodeFromInclude("shadowMapVertexMetric", comments, {
            replaceStrings: [
                {
                    search: /gl_Position/g,
                    replace: "clipPos"
                }
            ]
        });
        state.compilationString += state._emitCodeFromInclude("shadowMapFragment", comments, {
            replaceStrings: [
                {
                    search: /return;/g,
                    replace: ""
                }
            ]
        });
        state.compilationString += `
            #if SM_DEPTHTEXTURE == 1
                #ifdef IS_NDC_HALF_ZRANGE
                    gl_FragDepth = (clipPos.z / clipPos.w);
                #else
                    gl_FragDepth = (clipPos.z / clipPos.w) * 0.5 + 0.5;
                #endif
            #endif
        `;
        state.compilationString += `${this._declareOutput(this.depth, state)} = vec3(depthSM, 1., 1.);\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.ShadowMapBlock", $a10c604e6e63c527$export$3f57c3e5e2cc5555);

});

parcelRegister("2jO7O", function(module, exports) {

$parcel$export(module.exports, "PrePassOutputBlock", () => $1b043ce8c9e87fd6$export$fe72da4f45057b53);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $1b043ce8c9e87fd6$export$fe72da4f45057b53 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Create a new PrePassOutputBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Fragment, true);
        this.registerInput("viewDepth", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true);
        this.registerInput("worldPosition", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect, true);
        this.registerInput("viewNormal", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect, true);
        this.registerInput("reflectivity", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect, true);
        this.inputs[1].addExcludedConnectionPointFromAllowedTypes((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4);
        this.inputs[2].addExcludedConnectionPointFromAllowedTypes((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4);
        this.inputs[3].addExcludedConnectionPointFromAllowedTypes((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "PrePassOutputBlock";
    }
    /**
     * Gets the view depth component
     */ get viewDepth() {
        return this._inputs[0];
    }
    /**
     * Gets the world position component
     */ get worldPosition() {
        return this._inputs[1];
    }
    /**
     * Gets the view normal component
     */ get viewNormal() {
        return this._inputs[2];
    }
    /**
     * Gets the reflectivity component
     */ get reflectivity() {
        return this._inputs[3];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const worldPosition = this.worldPosition;
        const viewNormal = this.viewNormal;
        const viewDepth = this.viewDepth;
        const reflectivity = this.reflectivity;
        state.sharedData.blocksWithDefines.push(this);
        const comments = `//${this.name}`;
        state._emitFunctionFromInclude("helperFunctions", comments);
        state.compilationString += `#if defined(PREPASS)\r\n`;
        state.compilationString += `#ifdef PREPASS_DEPTH\r\n`;
        if (viewDepth.connectedPoint) state.compilationString += ` gl_FragData[PREPASS_DEPTH_INDEX] = vec4(${viewDepth.associatedVariableName}, 0.0, 0.0, 1.0);\r\n`;
        else // We have to write something on the viewDepth output or it will raise a gl error
        state.compilationString += ` gl_FragData[PREPASS_DEPTH_INDEX] = vec4(0.0, 0.0, 0.0, 0.0);\r\n`;
        state.compilationString += `#endif\r\n`;
        state.compilationString += `#ifdef PREPASS_POSITION\r\n`;
        if (worldPosition.connectedPoint) state.compilationString += ` gl_FragData[PREPASS_POSITION_INDEX] = vec4(${worldPosition.associatedVariableName}.rgb, ${worldPosition.connectedPoint.type === (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4 ? worldPosition.associatedVariableName + ".a" : "1.0"});\r\n`;
        else // We have to write something on the position output or it will raise a gl error
        state.compilationString += ` gl_FragData[PREPASS_POSITION_INDEX] = vec4(0.0, 0.0, 0.0, 0.0);\r\n`;
        state.compilationString += `#endif\r\n`;
        state.compilationString += `#ifdef PREPASS_NORMAL\r\n`;
        if (viewNormal.connectedPoint) state.compilationString += ` gl_FragData[PREPASS_NORMAL_INDEX] = vec4(${viewNormal.associatedVariableName}.rgb, ${viewNormal.connectedPoint.type === (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4 ? viewNormal.associatedVariableName + ".a" : "1.0"});\r\n`;
        else // We have to write something on the normal output or it will raise a gl error
        state.compilationString += ` gl_FragData[PREPASS_NORMAL_INDEX] = vec4(0.0, 0.0, 0.0, 0.0);\r\n`;
        state.compilationString += `#endif\r\n`;
        state.compilationString += `#ifdef PREPASS_REFLECTIVITY\r\n`;
        if (reflectivity.connectedPoint) state.compilationString += ` gl_FragData[PREPASS_REFLECTIVITY_INDEX] = vec4(${reflectivity.associatedVariableName}.rgb, ${reflectivity.connectedPoint.type === (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4 ? reflectivity.associatedVariableName + ".a" : "1.0"});\r\n`;
        else // We have to write something on the reflectivity output or it will raise a gl error
        state.compilationString += ` gl_FragData[PREPASS_REFLECTIVITY_INDEX] = vec4(0.0, 0.0, 0.0, 1.0);\r\n`;
        state.compilationString += `#endif\r\n`;
        state.compilationString += `#endif\r\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.PrePassOutputBlock", $1b043ce8c9e87fd6$export$fe72da4f45057b53);

});


parcelRegister("7ulf0", function(module, exports) {

var $ldDeN = parcelRequire("ldDeN");

var $inyXT = parcelRequire("inyXT");

var $aW0mr = parcelRequire("aW0mr");

var $7htMm = parcelRequire("7htMm");

var $5QeYV = parcelRequire("5QeYV");

var $h62fU = parcelRequire("h62fU");

var $3jhpF = parcelRequire("3jhpF");

var $0nhKt = parcelRequire("0nhKt");

var $clKbk = parcelRequire("clKbk");
$parcel$exportWildcard(module.exports, $ldDeN);
$parcel$exportWildcard(module.exports, $inyXT);
$parcel$exportWildcard(module.exports, $aW0mr);
$parcel$exportWildcard(module.exports, $7htMm);
$parcel$exportWildcard(module.exports, $5QeYV);
$parcel$exportWildcard(module.exports, $h62fU);
$parcel$exportWildcard(module.exports, $3jhpF);
$parcel$exportWildcard(module.exports, $0nhKt);
$parcel$exportWildcard(module.exports, $clKbk);

});
parcelRegister("ldDeN", function(module, exports) {

$parcel$export(module.exports, "FogBlock", () => $f7293fa834ee3396$export$fd5e6909bd2501a5);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $7qH6c = parcelRequire("7qH6c");

var $iAIIe = parcelRequire("iAIIe");

var $aKEh2 = parcelRequire("aKEh2");

var $8DoUR = parcelRequire("8DoUR");
parcelRequire("hvLF9");

var $alPCh = parcelRequire("alPCh");
class $f7293fa834ee3396$export$fd5e6909bd2501a5 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Create a new FogBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment, false);
        // Vertex
        this.registerInput("worldPosition", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4, false, (0, $iAIIe.NodeMaterialBlockTargets).Vertex);
        this.registerInput("view", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix, false, (0, $iAIIe.NodeMaterialBlockTargets).Vertex);
        // Fragment
        this.registerInput("input", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect, false, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("fogColor", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect, false, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.input.addExcludedConnectionPointFromAllowedTypes((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4);
        this.fogColor.addExcludedConnectionPointFromAllowedTypes((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "FogBlock";
    }
    /**
     * Gets the world position input component
     */ get worldPosition() {
        return this._inputs[0];
    }
    /**
     * Gets the view input component
     */ get view() {
        return this._inputs[1];
    }
    /**
     * Gets the color input component
     */ get input() {
        return this._inputs[2];
    }
    /**
     * Gets the fog color input component
     */ get fogColor() {
        return this._inputs[3];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    autoConfigure(material, additionalFilteringInfo = ()=>true) {
        if (!this.view.isConnected) {
            let viewInput = material.getInputBlockByPredicate((b)=>b.systemValue === (0, $7qH6c.NodeMaterialSystemValues).View && additionalFilteringInfo(b));
            if (!viewInput) {
                viewInput = new (0, $aKEh2.InputBlock)("view");
                viewInput.setAsSystemValue((0, $7qH6c.NodeMaterialSystemValues).View);
            }
            viewInput.output.connectTo(this.view);
        }
        if (!this.fogColor.isConnected) {
            let fogColorInput = material.getInputBlockByPredicate((b)=>b.systemValue === (0, $7qH6c.NodeMaterialSystemValues).FogColor && additionalFilteringInfo(b));
            if (!fogColorInput) {
                fogColorInput = new (0, $aKEh2.InputBlock)("fogColor", undefined, (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3);
                fogColorInput.setAsSystemValue((0, $7qH6c.NodeMaterialSystemValues).FogColor);
            }
            fogColorInput.output.connectTo(this.fogColor);
        }
    }
    prepareDefines(mesh, nodeMaterial, defines) {
        const scene = mesh.getScene();
        defines.setValue("FOG", nodeMaterial.fogEnabled && (0, $alPCh.GetFogState)(mesh, scene));
    }
    bind(effect, nodeMaterial, mesh) {
        if (!mesh) return;
        const scene = mesh.getScene();
        effect.setFloat4(this._fogParameters, scene.fogMode, scene.fogStart, scene.fogEnd, scene.fogDensity);
    }
    _buildBlock(state) {
        super._buildBlock(state);
        if (state.target === (0, $iAIIe.NodeMaterialBlockTargets).Fragment) {
            state.sharedData.blocksWithDefines.push(this);
            state.sharedData.bindableBlocks.push(this);
            state._emitFunctionFromInclude("fogFragmentDeclaration", `//${this.name}`, {
                removeUniforms: true,
                removeVaryings: true,
                removeIfDef: false,
                replaceStrings: [
                    {
                        search: /float CalcFogFactor\(\)/,
                        replace: "float CalcFogFactor(vec3 vFogDistance, vec4 vFogInfos)"
                    }
                ]
            });
            const tempFogVariablename = state._getFreeVariableName("fog");
            const color = this.input;
            const fogColor = this.fogColor;
            this._fogParameters = state._getFreeVariableName("fogParameters");
            const output = this._outputs[0];
            state._emitUniformFromString(this._fogParameters, "vec4");
            state.compilationString += `#ifdef FOG\n`;
            state.compilationString += `float ${tempFogVariablename} = CalcFogFactor(${this._fogDistanceName}, ${this._fogParameters});\n`;
            state.compilationString += this._declareOutput(output, state) + ` = ${tempFogVariablename} * ${color.associatedVariableName}.rgb + (1.0 - ${tempFogVariablename}) * ${fogColor.associatedVariableName}.rgb;\n`;
            state.compilationString += `#else\n${this._declareOutput(output, state)} =  ${color.associatedVariableName}.rgb;\n`;
            state.compilationString += `#endif\n`;
        } else {
            const worldPos = this.worldPosition;
            const view = this.view;
            this._fogDistanceName = state._getFreeVariableName("vFogDistance");
            state._emitVaryingFromString(this._fogDistanceName, "vec3");
            state.compilationString += `${this._fogDistanceName} = (${view.associatedVariableName} * ${worldPos.associatedVariableName}).xyz;\n`;
        }
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.FogBlock", $f7293fa834ee3396$export$fd5e6909bd2501a5);

});

parcelRegister("inyXT", function(module, exports) {

$parcel$export(module.exports, "LightBlock", () => $d6157f5286701b61$export$d5b94f568b81036c);

var $e0Suo = parcelRequire("e0Suo");

var $kpKE2 = parcelRequire("kpKE2");

var $iAIIe = parcelRequire("iAIIe");

var $3mKw5 = parcelRequire("3mKw5");

var $7qH6c = parcelRequire("7qH6c");

var $aKEh2 = parcelRequire("aKEh2");

var $8DoUR = parcelRequire("8DoUR");

var $1aXVF = parcelRequire("1aXVF");
parcelRequire("7UkOz");
parcelRequire("1yLBX");
parcelRequire("gi9Sf");
parcelRequire("c0VT2");
parcelRequire("4ycgE");
parcelRequire("7Hs3g");
parcelRequire("eFnxQ");
parcelRequire("lcI5C");
parcelRequire("5sP5F");

var $kVtWi = parcelRequire("kVtWi");

var $alPCh = parcelRequire("alPCh");
class $d6157f5286701b61$export$d5b94f568b81036c extends (0, $kpKE2.NodeMaterialBlock) {
    static _OnGenerateOnlyFragmentCodeChanged(block, _propertyName) {
        const that = block;
        if (that.worldPosition.isConnected) {
            that.generateOnlyFragmentCode = !that.generateOnlyFragmentCode;
            (0, $kVtWi.Logger).Error("The worldPosition input must not be connected to be able to switch!");
            return false;
        }
        that._setTarget();
        return true;
    }
    _setTarget() {
        this._setInitialTarget(this.generateOnlyFragmentCode ? (0, $iAIIe.NodeMaterialBlockTargets).Fragment : (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment);
        this.getInputByName("worldPosition").target = this.generateOnlyFragmentCode ? (0, $iAIIe.NodeMaterialBlockTargets).Fragment : (0, $iAIIe.NodeMaterialBlockTargets).Vertex;
    }
    /**
     * Create a new LightBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment);
        this._lightId = 0;
        /** Indicates that no code should be generated in the vertex shader. Can be useful in some specific circumstances (like when doing ray marching for eg) */ this.generateOnlyFragmentCode = false;
        this._isUnique = true;
        this.registerInput("worldPosition", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4, false, (0, $iAIIe.NodeMaterialBlockTargets).Vertex);
        this.registerInput("worldNormal", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4, false, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("cameraPosition", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3, false, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("glossiness", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("glossPower", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("diffuseColor", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("specularColor", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("view", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix, true);
        this.registerOutput("diffuseOutput", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("specularOutput", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("shadow", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "LightBlock";
    }
    /**
     * Gets the world position input component
     */ get worldPosition() {
        return this._inputs[0];
    }
    /**
     * Gets the world normal input component
     */ get worldNormal() {
        return this._inputs[1];
    }
    /**
     * Gets the camera (or eye) position component
     */ get cameraPosition() {
        return this._inputs[2];
    }
    /**
     * Gets the glossiness component
     */ get glossiness() {
        return this._inputs[3];
    }
    /**
     * Gets the glossiness power component
     */ get glossPower() {
        return this._inputs[4];
    }
    /**
     * Gets the diffuse color component
     */ get diffuseColor() {
        return this._inputs[5];
    }
    /**
     * Gets the specular color component
     */ get specularColor() {
        return this._inputs[6];
    }
    /**
     * Gets the view matrix component
     */ get view() {
        return this._inputs[7];
    }
    /**
     * Gets the diffuse output component
     */ get diffuseOutput() {
        return this._outputs[0];
    }
    /**
     * Gets the specular output component
     */ get specularOutput() {
        return this._outputs[1];
    }
    /**
     * Gets the shadow output component
     */ get shadow() {
        return this._outputs[2];
    }
    autoConfigure(material, additionalFilteringInfo = ()=>true) {
        if (!this.cameraPosition.isConnected) {
            let cameraPositionInput = material.getInputBlockByPredicate((b)=>b.systemValue === (0, $7qH6c.NodeMaterialSystemValues).CameraPosition && additionalFilteringInfo(b));
            if (!cameraPositionInput) {
                cameraPositionInput = new (0, $aKEh2.InputBlock)("cameraPosition");
                cameraPositionInput.setAsSystemValue((0, $7qH6c.NodeMaterialSystemValues).CameraPosition);
            }
            cameraPositionInput.output.connectTo(this.cameraPosition);
        }
    }
    prepareDefines(mesh, nodeMaterial, defines) {
        if (!defines._areLightsDirty) return;
        const scene = mesh.getScene();
        if (!this.light) (0, $alPCh.PrepareDefinesForLights)(scene, mesh, defines, true, nodeMaterial.maxSimultaneousLights);
        else {
            const state = {
                needNormals: false,
                needRebuild: false,
                lightmapMode: false,
                shadowEnabled: false,
                specularEnabled: false
            };
            (0, $alPCh.PrepareDefinesForLight)(scene, mesh, this.light, this._lightId, defines, true, state);
            if (state.needRebuild) defines.rebuild();
        }
    }
    updateUniformsAndSamples(state, nodeMaterial, defines, uniformBuffers) {
        for(let lightIndex = 0; lightIndex < nodeMaterial.maxSimultaneousLights; lightIndex++){
            if (!defines["LIGHT" + lightIndex]) break;
            const onlyUpdateBuffersList = state.uniforms.indexOf("vLightData" + lightIndex) >= 0;
            (0, $alPCh.PrepareUniformsAndSamplersForLight)(lightIndex, state.uniforms, state.samplers, defines["PROJECTEDLIGHTTEXTURE" + lightIndex], uniformBuffers, onlyUpdateBuffersList);
        }
    }
    bind(effect, nodeMaterial, mesh) {
        if (!mesh) return;
        const scene = mesh.getScene();
        if (!this.light) (0, $alPCh.BindLights)(scene, mesh, effect, true, nodeMaterial.maxSimultaneousLights);
        else (0, $alPCh.BindLight)(this.light, this._lightId, scene, effect, true);
    }
    _injectVertexCode(state) {
        const worldPos = this.worldPosition;
        const comments = `//${this.name}`;
        // Declaration
        if (!this.light) {
            // Emit for all lights
            state._emitFunctionFromInclude(state.supportUniformBuffers ? "lightVxUboDeclaration" : "lightVxFragmentDeclaration", comments, {
                repeatKey: "maxSimultaneousLights"
            });
            this._lightId = 0;
            state.sharedData.dynamicUniformBlocks.push(this);
        } else {
            this._lightId = (state.counters["lightCounter"] !== undefined ? state.counters["lightCounter"] : -1) + 1;
            state.counters["lightCounter"] = this._lightId;
            state._emitFunctionFromInclude(state.supportUniformBuffers ? "lightVxUboDeclaration" : "lightVxFragmentDeclaration", comments, {
                replaceStrings: [
                    {
                        search: /{X}/g,
                        replace: this._lightId.toString()
                    }
                ]
            }, this._lightId.toString());
        }
        // Inject code in vertex
        const worldPosVaryingName = "v_" + worldPos.associatedVariableName;
        if (state._emitVaryingFromString(worldPosVaryingName, "vec4")) state.compilationString += `${worldPosVaryingName} = ${worldPos.associatedVariableName};\n`;
        if (this.light) state.compilationString += state._emitCodeFromInclude("shadowsVertex", comments, {
            replaceStrings: [
                {
                    search: /{X}/g,
                    replace: this._lightId.toString()
                },
                {
                    search: /worldPos/g,
                    replace: worldPos.associatedVariableName
                }
            ]
        });
        else {
            state.compilationString += `vec4 worldPos = ${worldPos.associatedVariableName};\n`;
            if (this.view.isConnected) state.compilationString += `mat4 view = ${this.view.associatedVariableName};\n`;
            state.compilationString += state._emitCodeFromInclude("shadowsVertex", comments, {
                repeatKey: "maxSimultaneousLights"
            });
        }
    }
    _buildBlock(state) {
        super._buildBlock(state);
        if (state.target !== (0, $iAIIe.NodeMaterialBlockTargets).Fragment) {
            // Vertex
            this._injectVertexCode(state);
            return;
        }
        if (this.generateOnlyFragmentCode) state.sharedData.dynamicUniformBlocks.push(this);
        // Fragment
        state.sharedData.forcedBindableBlocks.push(this);
        state.sharedData.blocksWithDefines.push(this);
        const comments = `//${this.name}`;
        const worldPos = this.worldPosition;
        let worldPosVariableName = worldPos.associatedVariableName;
        if (this.generateOnlyFragmentCode) {
            worldPosVariableName = state._getFreeVariableName("globalWorldPos");
            state._emitFunction("light_globalworldpos", `vec3 ${worldPosVariableName};\n`, comments);
            state.compilationString += `${worldPosVariableName} = ${worldPos.associatedVariableName}.xyz;\n`;
            state.compilationString += state._emitCodeFromInclude("shadowsVertex", comments, {
                repeatKey: "maxSimultaneousLights",
                substitutionVars: this.generateOnlyFragmentCode ? `worldPos,${worldPos.associatedVariableName}` : undefined
            });
        } else worldPosVariableName = "v_" + worldPosVariableName + ".xyz";
        state._emitFunctionFromInclude("helperFunctions", comments);
        state._emitFunctionFromInclude("lightsFragmentFunctions", comments, {
            replaceStrings: [
                {
                    search: /vPositionW/g,
                    replace: worldPosVariableName
                }
            ]
        });
        state._emitFunctionFromInclude("shadowsFragmentFunctions", comments, {
            replaceStrings: [
                {
                    search: /vPositionW/g,
                    replace: worldPosVariableName
                }
            ]
        });
        if (!this.light) // Emit for all lights
        state._emitFunctionFromInclude(state.supportUniformBuffers ? "lightUboDeclaration" : "lightFragmentDeclaration", comments, {
            repeatKey: "maxSimultaneousLights",
            substitutionVars: this.generateOnlyFragmentCode ? "varying," : undefined
        });
        else state._emitFunctionFromInclude(state.supportUniformBuffers ? "lightUboDeclaration" : "lightFragmentDeclaration", comments, {
            replaceStrings: [
                {
                    search: /{X}/g,
                    replace: this._lightId.toString()
                }
            ]
        }, this._lightId.toString());
        // Code
        if (this._lightId === 0) {
            if (state._registerTempVariable("viewDirectionW")) state.compilationString += `vec3 viewDirectionW = normalize(${this.cameraPosition.associatedVariableName} - ${worldPosVariableName});\n`;
            state.compilationString += `lightingInfo info;\n`;
            state.compilationString += `float shadow = 1.;\n`;
            state.compilationString += `float aggShadow = 0.;\n`;
            state.compilationString += `float numLights = 0.;\n`;
            state.compilationString += `float glossiness = ${this.glossiness.isConnected ? this.glossiness.associatedVariableName : "1.0"} * ${this.glossPower.isConnected ? this.glossPower.associatedVariableName : "1024.0"};\n`;
            state.compilationString += `vec3 diffuseBase = vec3(0., 0., 0.);\n`;
            state.compilationString += `vec3 specularBase = vec3(0., 0., 0.);\n`;
            state.compilationString += `vec3 normalW = ${this.worldNormal.associatedVariableName}.xyz;\n`;
        }
        if (this.light) state.compilationString += state._emitCodeFromInclude("lightFragment", comments, {
            replaceStrings: [
                {
                    search: /{X}/g,
                    replace: this._lightId.toString()
                },
                {
                    search: /vPositionW/g,
                    replace: worldPosVariableName + ".xyz"
                }
            ]
        });
        else state.compilationString += state._emitCodeFromInclude("lightFragment", comments, {
            repeatKey: "maxSimultaneousLights",
            substitutionVars: `vPositionW,${worldPosVariableName}.xyz`
        });
        if (this._lightId === 0) state.compilationString += `aggShadow = aggShadow / numLights;\n`;
        const diffuseOutput = this.diffuseOutput;
        const specularOutput = this.specularOutput;
        state.compilationString += this._declareOutput(diffuseOutput, state) + ` = diffuseBase${this.diffuseColor.isConnected ? " * " + this.diffuseColor.associatedVariableName : ""};\n`;
        if (specularOutput.hasEndpoints) state.compilationString += this._declareOutput(specularOutput, state) + ` = specularBase${this.specularColor.isConnected ? " * " + this.specularColor.associatedVariableName : ""};\n`;
        if (this.shadow.hasEndpoints) state.compilationString += this._declareOutput(this.shadow, state) + ` = aggShadow;\n`;
        return this;
    }
    serialize() {
        const serializationObject = super.serialize();
        serializationObject.generateOnlyFragmentCode = this.generateOnlyFragmentCode;
        if (this.light) serializationObject.lightId = this.light.id;
        return serializationObject;
    }
    _deserialize(serializationObject, scene, rootUrl) {
        super._deserialize(serializationObject, scene, rootUrl);
        if (serializationObject.lightId) this.light = scene.getLightById(serializationObject.lightId);
        this.generateOnlyFragmentCode = serializationObject.generateOnlyFragmentCode;
        this._setTarget();
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Generate only fragment code", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            rebuild: true,
            update: true,
            onValidation: $d6157f5286701b61$export$d5b94f568b81036c._OnGenerateOnlyFragmentCodeChanged
        }
    })
], $d6157f5286701b61$export$d5b94f568b81036c.prototype, "generateOnlyFragmentCode", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.LightBlock", $d6157f5286701b61$export$d5b94f568b81036c);

});

parcelRegister("aW0mr", function(module, exports) {

$parcel$export(module.exports, "TextureBlock", () => $7f5f99d27259000e$export$b7de30131de2e697);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $g92b7 = parcelRequire("g92b7");

var $5fNQr = parcelRequire("5fNQr");

var $aKEh2 = parcelRequire("aKEh2");

var $8DoUR = parcelRequire("8DoUR");

var $j2mX5 = parcelRequire("j2mX5");

var $5oHv1 = parcelRequire("5oHv1");
parcelRequire("7Hs3g");

var $0nhKt = parcelRequire("0nhKt");

var $dTtBA = parcelRequire("dTtBA");

var $ejQPp = parcelRequire("ejQPp");
class $7f5f99d27259000e$export$b7de30131de2e697 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Gets or sets the texture associated with the node
     */ get texture() {
        if (this.source.isConnected) return (this.source.connectedPoint?.ownerBlock).texture;
        return this._texture;
    }
    set texture(texture) {
        if (this._texture === texture) return;
        const scene = texture?.getScene() ?? (0, $ejQPp.EngineStore).LastCreatedScene;
        if (!texture && scene) scene.markAllMaterialsAsDirty(1, (mat)=>{
            return mat.hasTexture(this._texture);
        });
        this._texture = texture;
        if (texture && scene) scene.markAllMaterialsAsDirty(1, (mat)=>{
            return mat.hasTexture(texture);
        });
    }
    static _IsPrePassTextureBlock(block) {
        return block?.getClassName() === "PrePassTextureBlock";
    }
    get _isSourcePrePass() {
        return $7f5f99d27259000e$export$b7de30131de2e697._IsPrePassTextureBlock(this._imageSource);
    }
    /**
     * Gets the sampler name associated with this texture
     */ get samplerName() {
        if (this._imageSource) {
            if (!$7f5f99d27259000e$export$b7de30131de2e697._IsPrePassTextureBlock(this._imageSource)) return this._imageSource.samplerName;
            if (this.source.connectedPoint) return this._imageSource.getSamplerName(this.source.connectedPoint);
        }
        return this._samplerName;
    }
    /**
     * Gets a boolean indicating that this block is linked to an ImageSourceBlock
     */ get hasImageSource() {
        return this.source.isConnected;
    }
    /**
     * Gets or sets a boolean indicating if content needs to be converted to gamma space
     */ set convertToGammaSpace(value) {
        if (value === this._convertToGammaSpace) return;
        this._convertToGammaSpace = value;
        if (this.texture) {
            const scene = this.texture.getScene() ?? (0, $ejQPp.EngineStore).LastCreatedScene;
            scene?.markAllMaterialsAsDirty(1, (mat)=>{
                return mat.hasTexture(this.texture);
            });
        }
    }
    get convertToGammaSpace() {
        return this._convertToGammaSpace;
    }
    /**
     * Gets or sets a boolean indicating if content needs to be converted to linear space
     */ set convertToLinearSpace(value) {
        if (value === this._convertToLinearSpace) return;
        this._convertToLinearSpace = value;
        if (this.texture) {
            const scene = this.texture.getScene() ?? (0, $ejQPp.EngineStore).LastCreatedScene;
            scene?.markAllMaterialsAsDirty(1, (mat)=>{
                return mat.hasTexture(this.texture);
            });
        }
    }
    get convertToLinearSpace() {
        return this._convertToLinearSpace;
    }
    /**
     * Create a new TextureBlock
     * @param name defines the block name
     * @param fragmentOnly
     */ constructor(name, fragmentOnly = false){
        super(name, fragmentOnly ? (0, $iAIIe.NodeMaterialBlockTargets).Fragment : (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment);
        this._convertToGammaSpace = false;
        this._convertToLinearSpace = false;
        /**
         * Gets or sets a boolean indicating if multiplication of texture with level should be disabled
         */ this.disableLevelMultiplication = false;
        this._fragmentOnly = fragmentOnly;
        this.registerInput("uv", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect, false, (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment);
        this.registerInput("source", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Object, true, (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment, new (0, $dTtBA.NodeMaterialConnectionPointCustomObject)("source", this, (0, $g92b7.NodeMaterialConnectionPointDirection).Input, (0, $0nhKt.ImageSourceBlock), "ImageSourceBlock"));
        this.registerInput("layer", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true);
        this.registerInput("lod", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true);
        this.registerOutput("rgba", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerOutput("rgb", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerOutput("r", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerOutput("g", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerOutput("b", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerOutput("a", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerOutput("level", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this._inputs[0].addExcludedConnectionPointFromAllowedTypes((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4);
        this._inputs[0]._prioritizeVertex = !fragmentOnly;
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "TextureBlock";
    }
    /**
     * Gets the uv input component
     */ get uv() {
        return this._inputs[0];
    }
    /**
     * Gets the source input component
     */ get source() {
        return this._inputs[1];
    }
    /**
     * Gets the layer input component
     */ get layer() {
        return this._inputs[2];
    }
    /**
     * Gets the LOD input component
     */ get lod() {
        return this._inputs[3];
    }
    /**
     * Gets the rgba output component
     */ get rgba() {
        return this._outputs[0];
    }
    /**
     * Gets the rgb output component
     */ get rgb() {
        return this._outputs[1];
    }
    /**
     * Gets the r output component
     */ get r() {
        return this._outputs[2];
    }
    /**
     * Gets the g output component
     */ get g() {
        return this._outputs[3];
    }
    /**
     * Gets the b output component
     */ get b() {
        return this._outputs[4];
    }
    /**
     * Gets the a output component
     */ get a() {
        return this._outputs[5];
    }
    /**
     * Gets the level output component
     */ get level() {
        return this._outputs[6];
    }
    get target() {
        if (this._fragmentOnly) return (0, $iAIIe.NodeMaterialBlockTargets).Fragment;
        // TextureBlock has a special optimizations for uvs that come from the vertex shaders as they can be packed into a single varyings.
        // But we need to detect uvs coming from fragment then
        if (!this.uv.isConnected) return (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment;
        if (this.uv.sourceBlock.isInput) return (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment;
        let parent = this.uv.connectedPoint;
        while(parent){
            if (parent.target === (0, $iAIIe.NodeMaterialBlockTargets).Fragment) return (0, $iAIIe.NodeMaterialBlockTargets).Fragment;
            if (parent.target === (0, $iAIIe.NodeMaterialBlockTargets).Vertex) return (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment;
            if (parent.target === (0, $iAIIe.NodeMaterialBlockTargets).Neutral || parent.target === (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment) {
                const parentBlock = parent.ownerBlock;
                if (parentBlock.target === (0, $iAIIe.NodeMaterialBlockTargets).Fragment) return (0, $iAIIe.NodeMaterialBlockTargets).Fragment;
                parent = null;
                for (const input of parentBlock.inputs)if (input.connectedPoint) {
                    parent = input.connectedPoint;
                    break;
                }
            }
        }
        return (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment;
    }
    set target(value) {}
    autoConfigure(material, additionalFilteringInfo = ()=>true) {
        if (!this.uv.isConnected) {
            if (material.mode === (0, $5oHv1.NodeMaterialModes).PostProcess) {
                const uvInput = material.getBlockByPredicate((b)=>b.name === "uv" && additionalFilteringInfo(b));
                if (uvInput) uvInput.connectTo(this);
            } else {
                const attributeName = material.mode === (0, $5oHv1.NodeMaterialModes).Particle ? "particle_uv" : "uv";
                let uvInput = material.getInputBlockByPredicate((b)=>b.isAttribute && b.name === attributeName && additionalFilteringInfo(b));
                if (!uvInput) {
                    uvInput = new (0, $aKEh2.InputBlock)("uv");
                    uvInput.setAsAttribute(attributeName);
                }
                uvInput.output.connectTo(this.uv);
            }
        }
    }
    initializeDefines(mesh, nodeMaterial, defines) {
        if (!defines._areTexturesDirty) return;
        if (this._mainUVDefineName !== undefined) defines.setValue(this._mainUVDefineName, false, true);
    }
    prepareDefines(mesh, nodeMaterial, defines) {
        if (!defines._areTexturesDirty) return;
        if (!this.texture || !this.texture.getTextureMatrix) {
            if (this._isMixed) {
                defines.setValue(this._defineName, false, true);
                defines.setValue(this._mainUVDefineName, true, true);
            }
            return;
        }
        const toGamma = this.convertToGammaSpace && this.texture && !this.texture.gammaSpace;
        const toLinear = this.convertToLinearSpace && this.texture && this.texture.gammaSpace;
        // Not a bug... Name defines the texture space not the required conversion
        defines.setValue(this._linearDefineName, toGamma, true);
        defines.setValue(this._gammaDefineName, toLinear, true);
        if (this._isMixed) {
            if (!this.texture.getTextureMatrix().isIdentityAs3x2()) {
                defines.setValue(this._defineName, true);
                if (defines[this._mainUVDefineName] == undefined) defines.setValue(this._mainUVDefineName, false, true);
            } else {
                defines.setValue(this._defineName, false, true);
                defines.setValue(this._mainUVDefineName, true, true);
            }
        }
    }
    isReady() {
        if (this._isSourcePrePass) return true;
        if (this.texture && !this.texture.isReadyOrNotBlocking()) return false;
        return true;
    }
    bind(effect) {
        if (this._isSourcePrePass) effect.setFloat(this._textureInfoName, 1);
        if (!this.texture) return;
        if (this._isMixed) {
            effect.setFloat(this._textureInfoName, this.texture.level);
            effect.setMatrix(this._textureTransformName, this.texture.getTextureMatrix());
        }
        if (!this._imageSource) effect.setTexture(this._samplerName, this.texture);
    }
    get _isMixed() {
        return this.target !== (0, $iAIIe.NodeMaterialBlockTargets).Fragment;
    }
    _injectVertexCode(state) {
        const uvInput = this.uv;
        // Inject code in vertex
        this._defineName = state._getFreeDefineName("UVTRANSFORM");
        this._mainUVDefineName = "VMAIN" + uvInput.associatedVariableName.toUpperCase();
        this._mainUVName = "vMain" + uvInput.associatedVariableName;
        this._transformedUVName = state._getFreeVariableName("transformedUV");
        this._textureTransformName = state._getFreeVariableName("textureTransform");
        this._textureInfoName = state._getFreeVariableName("textureInfoName");
        this.level.associatedVariableName = this._textureInfoName;
        state._emitVaryingFromString(this._transformedUVName, "vec2", this._defineName);
        state._emitVaryingFromString(this._mainUVName, "vec2", this._mainUVDefineName);
        state._emitUniformFromString(this._textureTransformName, "mat4", this._defineName);
        state.compilationString += `#ifdef ${this._defineName}\n`;
        state.compilationString += `${this._transformedUVName} = vec2(${this._textureTransformName} * vec4(${uvInput.associatedVariableName}.xy, 1.0, 0.0));\n`;
        state.compilationString += `#elif defined(${this._mainUVDefineName})\n`;
        state.compilationString += `${this._mainUVName} = ${uvInput.associatedVariableName}.xy;\n`;
        state.compilationString += `#endif\n`;
        if (!this._outputs.some((o)=>o.isConnectedInVertexShader)) return;
        this._writeTextureRead(state, true);
        for (const output of this._outputs)if (output.hasEndpoints && output.name !== "level") this._writeOutput(state, output, output.name, true);
    }
    _getUVW(uvName) {
        let coords = uvName;
        const is2DArrayTexture = this._texture?._texture?.is2DArray ?? false;
        if (is2DArrayTexture) {
            const layerValue = this.layer.isConnected ? this.layer.associatedVariableName : "0";
            coords = `vec3(${uvName}, ${layerValue})`;
        }
        return coords;
    }
    get _samplerFunc() {
        return this.lod.isConnected ? "texture2DLodEXT" : "texture2D";
    }
    get _samplerLodSuffix() {
        return this.lod.isConnected ? `, ${this.lod.associatedVariableName}` : "";
    }
    _generateTextureLookup(state) {
        const samplerName = this.samplerName;
        state.compilationString += `#ifdef ${this._defineName}\n`;
        state.compilationString += `vec4 ${this._tempTextureRead} = ${this._samplerFunc}(${samplerName}, ${this._getUVW(this._transformedUVName)}${this._samplerLodSuffix});\n`;
        state.compilationString += `#elif defined(${this._mainUVDefineName})\n`;
        state.compilationString += `vec4 ${this._tempTextureRead} = ${this._samplerFunc}(${samplerName}, ${this._getUVW(this._mainUVName ? this._mainUVName : this.uv.associatedVariableName)}${this._samplerLodSuffix});\n`;
        state.compilationString += `#endif\n`;
    }
    _writeTextureRead(state, vertexMode = false) {
        const uvInput = this.uv;
        if (vertexMode) {
            if (state.target === (0, $iAIIe.NodeMaterialBlockTargets).Fragment) return;
            this._generateTextureLookup(state);
            return;
        }
        if (this.uv.ownerBlock.target === (0, $iAIIe.NodeMaterialBlockTargets).Fragment) {
            state.compilationString += `vec4 ${this._tempTextureRead} = ${this._samplerFunc}(${this.samplerName}, ${this._getUVW(uvInput.associatedVariableName)}${this._samplerLodSuffix});\n`;
            return;
        }
        this._generateTextureLookup(state);
    }
    _generateConversionCode(state, output, swizzle) {
        if (swizzle !== "a") {
            // no conversion if the output is "a" (alpha)
            if (!this.texture || !this.texture.gammaSpace) state.compilationString += `#ifdef ${this._linearDefineName}
                    ${output.associatedVariableName} = toGammaSpace(${output.associatedVariableName});
                    #endif
                `;
            state.compilationString += `#ifdef ${this._gammaDefineName}
                ${output.associatedVariableName} = toLinearSpace(${output.associatedVariableName});
                #endif
            `;
        }
    }
    _writeOutput(state, output, swizzle, vertexMode = false) {
        if (vertexMode) {
            if (state.target === (0, $iAIIe.NodeMaterialBlockTargets).Fragment) return;
            state.compilationString += `${this._declareOutput(output, state)} = ${this._tempTextureRead}.${swizzle};\n`;
            this._generateConversionCode(state, output, swizzle);
            return;
        }
        if (this.uv.ownerBlock.target === (0, $iAIIe.NodeMaterialBlockTargets).Fragment) {
            state.compilationString += `${this._declareOutput(output, state)} = ${this._tempTextureRead}.${swizzle};\n`;
            this._generateConversionCode(state, output, swizzle);
            return;
        }
        let complement = "";
        if (!this.disableLevelMultiplication) complement = ` * ${this._textureInfoName}`;
        state.compilationString += `${this._declareOutput(output, state)} = ${this._tempTextureRead}.${swizzle}${complement};\n`;
        this._generateConversionCode(state, output, swizzle);
    }
    _buildBlock(state) {
        super._buildBlock(state);
        if (this.source.isConnected) this._imageSource = this.source.connectedPoint.ownerBlock;
        else this._imageSource = null;
        if (state.target === (0, $iAIIe.NodeMaterialBlockTargets).Vertex || this._fragmentOnly || state.target === (0, $iAIIe.NodeMaterialBlockTargets).Fragment) {
            this._tempTextureRead = state._getFreeVariableName("tempTextureRead");
            this._linearDefineName = state._getFreeDefineName("ISLINEAR");
            this._gammaDefineName = state._getFreeDefineName("ISGAMMA");
        }
        if (!this._isMixed && state.target === (0, $iAIIe.NodeMaterialBlockTargets).Fragment || this._isMixed && state.target === (0, $iAIIe.NodeMaterialBlockTargets).Vertex) {
            if (!this._imageSource) {
                this._samplerName = state._getFreeVariableName(this.name + "Sampler");
                if (this._texture?._texture?.is2DArray) state._emit2DArraySampler(this._samplerName);
                else state._emit2DSampler(this._samplerName);
            }
            // Declarations
            state.sharedData.blockingBlocks.push(this);
            state.sharedData.textureBlocks.push(this);
            state.sharedData.blocksWithDefines.push(this);
            state.sharedData.bindableBlocks.push(this);
        }
        if (state.target !== (0, $iAIIe.NodeMaterialBlockTargets).Fragment) {
            // Vertex
            this._injectVertexCode(state);
            return;
        }
        // Fragment
        if (!this._outputs.some((o)=>o.isConnectedInFragmentShader)) return;
        if (this._isMixed && !this._imageSource) {
            // Reexport the sampler
            if (this._texture?._texture?.is2DArray) state._emit2DArraySampler(this._samplerName);
            else state._emit2DSampler(this._samplerName);
        }
        const comments = `//${this.name}`;
        state._emitFunctionFromInclude("helperFunctions", comments);
        if (this._isMixed) state._emitUniformFromString(this._textureInfoName, "float");
        this._writeTextureRead(state);
        for (const output of this._outputs)if (output.hasEndpoints && output.name !== "level") this._writeOutput(state, output, output.name);
        return this;
    }
    _dumpPropertiesCode() {
        let codeString = super._dumpPropertiesCode();
        codeString += `${this._codeVariableName}.convertToGammaSpace = ${this.convertToGammaSpace};\n`;
        codeString += `${this._codeVariableName}.convertToLinearSpace = ${this.convertToLinearSpace};\n`;
        codeString += `${this._codeVariableName}.disableLevelMultiplication = ${this.disableLevelMultiplication};\n`;
        if (!this.texture) return codeString;
        codeString += `${this._codeVariableName}.texture = new BABYLON.Texture("${this.texture.name}", null, ${this.texture.noMipmap}, ${this.texture.invertY}, ${this.texture.samplingMode});\n`;
        codeString += `${this._codeVariableName}.texture.wrapU = ${this.texture.wrapU};\n`;
        codeString += `${this._codeVariableName}.texture.wrapV = ${this.texture.wrapV};\n`;
        codeString += `${this._codeVariableName}.texture.uAng = ${this.texture.uAng};\n`;
        codeString += `${this._codeVariableName}.texture.vAng = ${this.texture.vAng};\n`;
        codeString += `${this._codeVariableName}.texture.wAng = ${this.texture.wAng};\n`;
        codeString += `${this._codeVariableName}.texture.uOffset = ${this.texture.uOffset};\n`;
        codeString += `${this._codeVariableName}.texture.vOffset = ${this.texture.vOffset};\n`;
        codeString += `${this._codeVariableName}.texture.uScale = ${this.texture.uScale};\n`;
        codeString += `${this._codeVariableName}.texture.vScale = ${this.texture.vScale};\n`;
        codeString += `${this._codeVariableName}.texture.coordinatesMode = ${this.texture.coordinatesMode};\n`;
        return codeString;
    }
    serialize() {
        const serializationObject = super.serialize();
        serializationObject.convertToGammaSpace = this.convertToGammaSpace;
        serializationObject.convertToLinearSpace = this.convertToLinearSpace;
        serializationObject.fragmentOnly = this._fragmentOnly;
        serializationObject.disableLevelMultiplication = this.disableLevelMultiplication;
        if (!this.hasImageSource && this.texture && !this.texture.isRenderTarget && this.texture.getClassName() !== "VideoTexture") serializationObject.texture = this.texture.serialize();
        return serializationObject;
    }
    _deserialize(serializationObject, scene, rootUrl) {
        super._deserialize(serializationObject, scene, rootUrl);
        this.convertToGammaSpace = serializationObject.convertToGammaSpace;
        this.convertToLinearSpace = !!serializationObject.convertToLinearSpace;
        this._fragmentOnly = !!serializationObject.fragmentOnly;
        this.disableLevelMultiplication = !!serializationObject.disableLevelMultiplication;
        if (serializationObject.texture && !(0, $5fNQr.NodeMaterial).IgnoreTexturesAtLoadTime && serializationObject.texture.url !== undefined) {
            rootUrl = serializationObject.texture.url.indexOf("data:") === 0 ? "" : rootUrl;
            this.texture = (0, $j2mX5.Texture).Parse(serializationObject.texture, scene, rootUrl);
        }
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.TextureBlock", $7f5f99d27259000e$export$b7de30131de2e697);

});
parcelRegister("0nhKt", function(module, exports) {

$parcel$export(module.exports, "ImageSourceBlock", () => $0012102bb50a8f15$export$1a999e16cae70d06);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $g92b7 = parcelRequire("g92b7");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");

var $j2mX5 = parcelRequire("j2mX5");

var $5fNQr = parcelRequire("5fNQr");

var $dTtBA = parcelRequire("dTtBA");

var $ejQPp = parcelRequire("ejQPp");
class $0012102bb50a8f15$export$1a999e16cae70d06 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Gets or sets the texture associated with the node
     */ get texture() {
        return this._texture;
    }
    set texture(texture) {
        if (this._texture === texture) return;
        const scene = texture?.getScene() ?? (0, $ejQPp.EngineStore).LastCreatedScene;
        if (!texture && scene) scene.markAllMaterialsAsDirty(1, (mat)=>{
            return mat.hasTexture(this._texture);
        });
        this._texture = texture;
        if (texture && scene) scene.markAllMaterialsAsDirty(1, (mat)=>{
            return mat.hasTexture(texture);
        });
    }
    /**
     * Gets the sampler name associated with this image source
     */ get samplerName() {
        return this._samplerName;
    }
    /**
     * Creates a new ImageSourceBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment);
        this.registerOutput("source", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Object, (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment, new (0, $dTtBA.NodeMaterialConnectionPointCustomObject)("source", this, (0, $g92b7.NodeMaterialConnectionPointDirection).Output, $0012102bb50a8f15$export$1a999e16cae70d06, "ImageSourceBlock"));
    }
    bind(effect) {
        if (!this.texture) return;
        effect.setTexture(this._samplerName, this.texture);
    }
    isReady() {
        if (this.texture && !this.texture.isReadyOrNotBlocking()) return false;
        return true;
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "ImageSourceBlock";
    }
    /**
     * Gets the output component
     */ get source() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        if (state.target === (0, $iAIIe.NodeMaterialBlockTargets).Vertex) {
            this._samplerName = state._getFreeVariableName(this.name + "Sampler");
            // Declarations
            state.sharedData.blockingBlocks.push(this);
            state.sharedData.textureBlocks.push(this);
            state.sharedData.bindableBlocks.push(this);
        }
        state._emit2DSampler(this._samplerName);
        return this;
    }
    _dumpPropertiesCode() {
        let codeString = super._dumpPropertiesCode();
        if (!this.texture) return codeString;
        codeString += `${this._codeVariableName}.texture = new BABYLON.Texture("${this.texture.name}", null, ${this.texture.noMipmap}, ${this.texture.invertY}, ${this.texture.samplingMode});\n`;
        codeString += `${this._codeVariableName}.texture.wrapU = ${this.texture.wrapU};\n`;
        codeString += `${this._codeVariableName}.texture.wrapV = ${this.texture.wrapV};\n`;
        codeString += `${this._codeVariableName}.texture.uAng = ${this.texture.uAng};\n`;
        codeString += `${this._codeVariableName}.texture.vAng = ${this.texture.vAng};\n`;
        codeString += `${this._codeVariableName}.texture.wAng = ${this.texture.wAng};\n`;
        codeString += `${this._codeVariableName}.texture.uOffset = ${this.texture.uOffset};\n`;
        codeString += `${this._codeVariableName}.texture.vOffset = ${this.texture.vOffset};\n`;
        codeString += `${this._codeVariableName}.texture.uScale = ${this.texture.uScale};\n`;
        codeString += `${this._codeVariableName}.texture.vScale = ${this.texture.vScale};\n`;
        codeString += `${this._codeVariableName}.texture.coordinatesMode = ${this.texture.coordinatesMode};\n`;
        return codeString;
    }
    serialize() {
        const serializationObject = super.serialize();
        if (this.texture && !this.texture.isRenderTarget && this.texture.getClassName() !== "VideoTexture") serializationObject.texture = this.texture.serialize();
        return serializationObject;
    }
    _deserialize(serializationObject, scene, rootUrl) {
        super._deserialize(serializationObject, scene, rootUrl);
        if (serializationObject.texture && !(0, $5fNQr.NodeMaterial).IgnoreTexturesAtLoadTime && serializationObject.texture.url !== undefined) {
            rootUrl = serializationObject.texture.url.indexOf("data:") === 0 ? "" : rootUrl;
            this.texture = (0, $j2mX5.Texture).Parse(serializationObject.texture, scene, rootUrl);
        }
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.ImageSourceBlock", $0012102bb50a8f15$export$1a999e16cae70d06);

});


parcelRegister("7htMm", function(module, exports) {

$parcel$export(module.exports, "ReflectionTextureBaseBlock", () => $54d1387066b7959f$export$37ef4c0550d458c0);

var $e0Suo = parcelRequire("e0Suo");

var $kpKE2 = parcelRequire("kpKE2");

var $iAIIe = parcelRequire("iAIIe");

var $5fNQr = parcelRequire("5fNQr");

var $8DoUR = parcelRequire("8DoUR");

var $aKEh2 = parcelRequire("aKEh2");

var $7qH6c = parcelRequire("7qH6c");
parcelRequire("6vG1y");

var $iPQLf = parcelRequire("iPQLf");

var $j2mX5 = parcelRequire("j2mX5");

var $ejQPp = parcelRequire("ejQPp");

var $1aXVF = parcelRequire("1aXVF");
class $54d1387066b7959f$export$37ef4c0550d458c0 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Gets or sets the texture associated with the node
     */ get texture() {
        return this._texture;
    }
    set texture(texture) {
        if (this._texture === texture) return;
        const scene = texture?.getScene() ?? (0, $ejQPp.EngineStore).LastCreatedScene;
        if (!texture && scene) scene.markAllMaterialsAsDirty(1, (mat)=>{
            return mat.hasTexture(this._texture);
        });
        this._texture = texture;
        if (texture && scene) scene.markAllMaterialsAsDirty(1, (mat)=>{
            return mat.hasTexture(texture);
        });
    }
    static _OnGenerateOnlyFragmentCodeChanged(block, _propertyName) {
        const that = block;
        return that._onGenerateOnlyFragmentCodeChanged();
    }
    _onGenerateOnlyFragmentCodeChanged() {
        this._setTarget();
        return true;
    }
    _setTarget() {
        this._setInitialTarget(this.generateOnlyFragmentCode ? (0, $iAIIe.NodeMaterialBlockTargets).Fragment : (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment);
    }
    /**
     * Create a new ReflectionTextureBaseBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment);
        /** Indicates that no code should be generated in the vertex shader. Can be useful in some specific circumstances (like when doing ray marching for eg) */ this.generateOnlyFragmentCode = false;
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "ReflectionTextureBaseBlock";
    }
    _getTexture() {
        return this.texture;
    }
    /**
     * Auto configure the node based on the existing material
     * @param material defines the material to configure
     * @param additionalFilteringInfo defines additional info to be used when filtering inputs (we might want to skip some non relevant blocks)
     */ autoConfigure(material, additionalFilteringInfo = ()=>true) {
        if (!this.position.isConnected) {
            let positionInput = material.getInputBlockByPredicate((b)=>b.isAttribute && b.name === "position" && additionalFilteringInfo(b));
            if (!positionInput) {
                positionInput = new (0, $aKEh2.InputBlock)("position");
                positionInput.setAsAttribute();
            }
            positionInput.output.connectTo(this.position);
        }
        if (!this.world.isConnected) {
            let worldInput = material.getInputBlockByPredicate((b)=>b.systemValue === (0, $7qH6c.NodeMaterialSystemValues).World && additionalFilteringInfo(b));
            if (!worldInput) {
                worldInput = new (0, $aKEh2.InputBlock)("world");
                worldInput.setAsSystemValue((0, $7qH6c.NodeMaterialSystemValues).World);
            }
            worldInput.output.connectTo(this.world);
        }
        if (this.view && !this.view.isConnected) {
            let viewInput = material.getInputBlockByPredicate((b)=>b.systemValue === (0, $7qH6c.NodeMaterialSystemValues).View && additionalFilteringInfo(b));
            if (!viewInput) {
                viewInput = new (0, $aKEh2.InputBlock)("view");
                viewInput.setAsSystemValue((0, $7qH6c.NodeMaterialSystemValues).View);
            }
            viewInput.output.connectTo(this.view);
        }
    }
    prepareDefines(mesh, nodeMaterial, defines) {
        if (!defines._areTexturesDirty) return;
        const texture = this._getTexture();
        if (!texture || !texture.getTextureMatrix) return;
        defines.setValue(this._define3DName, texture.isCube, true);
        defines.setValue(this._defineLocalCubicName, texture.boundingBoxSize ? true : false, true);
        defines.setValue(this._defineExplicitName, texture.coordinatesMode === 0, true);
        defines.setValue(this._defineSkyboxName, texture.coordinatesMode === 5, true);
        defines.setValue(this._defineCubicName, texture.coordinatesMode === 3 || texture.coordinatesMode === 6, true);
        defines.setValue("INVERTCUBICMAP", texture.coordinatesMode === 6, true);
        defines.setValue(this._defineSphericalName, texture.coordinatesMode === 1, true);
        defines.setValue(this._definePlanarName, texture.coordinatesMode === 2, true);
        defines.setValue(this._defineProjectionName, texture.coordinatesMode === 4, true);
        defines.setValue(this._defineEquirectangularName, texture.coordinatesMode === 7, true);
        defines.setValue(this._defineEquirectangularFixedName, texture.coordinatesMode === 8, true);
        defines.setValue(this._defineMirroredEquirectangularFixedName, texture.coordinatesMode === 9, true);
    }
    isReady() {
        const texture = this._getTexture();
        if (texture && !texture.isReadyOrNotBlocking()) return false;
        return true;
    }
    bind(effect, nodeMaterial, mesh, _subMesh) {
        const texture = this._getTexture();
        if (!mesh || !texture) return;
        effect.setMatrix(this._reflectionMatrixName, texture.getReflectionTextureMatrix());
        if (texture.isCube) effect.setTexture(this._cubeSamplerName, texture);
        else effect.setTexture(this._2DSamplerName, texture);
        if (texture.boundingBoxSize) {
            const cubeTexture = texture;
            effect.setVector3(this._reflectionPositionName, cubeTexture.boundingBoxPosition);
            effect.setVector3(this._reflectionSizeName, cubeTexture.boundingBoxSize);
        }
    }
    /**
     * Gets the code to inject in the vertex shader
     * @param state current state of the node material building
     * @returns the shader code
     */ handleVertexSide(state) {
        if (this.generateOnlyFragmentCode && state.target === (0, $iAIIe.NodeMaterialBlockTargets).Vertex) return "";
        this._define3DName = state._getFreeDefineName("REFLECTIONMAP_3D");
        this._defineCubicName = state._getFreeDefineName("REFLECTIONMAP_CUBIC");
        this._defineSphericalName = state._getFreeDefineName("REFLECTIONMAP_SPHERICAL");
        this._definePlanarName = state._getFreeDefineName("REFLECTIONMAP_PLANAR");
        this._defineProjectionName = state._getFreeDefineName("REFLECTIONMAP_PROJECTION");
        this._defineExplicitName = state._getFreeDefineName("REFLECTIONMAP_EXPLICIT");
        this._defineEquirectangularName = state._getFreeDefineName("REFLECTIONMAP_EQUIRECTANGULAR");
        this._defineLocalCubicName = state._getFreeDefineName("USE_LOCAL_REFLECTIONMAP_CUBIC");
        this._defineMirroredEquirectangularFixedName = state._getFreeDefineName("REFLECTIONMAP_MIRROREDEQUIRECTANGULAR_FIXED");
        this._defineEquirectangularFixedName = state._getFreeDefineName("REFLECTIONMAP_EQUIRECTANGULAR_FIXED");
        this._defineSkyboxName = state._getFreeDefineName("REFLECTIONMAP_SKYBOX");
        this._defineOppositeZ = state._getFreeDefineName("REFLECTIONMAP_OPPOSITEZ");
        this._reflectionMatrixName = state._getFreeVariableName("reflectionMatrix");
        state._emitUniformFromString(this._reflectionMatrixName, "mat4");
        let code = "";
        this._worldPositionNameInFragmentOnlyMode = state._getFreeVariableName("worldPosition");
        const worldPosVaryingName = this.generateOnlyFragmentCode ? this._worldPositionNameInFragmentOnlyMode : "v_" + this.worldPosition.associatedVariableName;
        if (this.generateOnlyFragmentCode || state._emitVaryingFromString(worldPosVaryingName, "vec4")) code += `${this.generateOnlyFragmentCode ? "vec4 " : ""}${worldPosVaryingName} = ${this.worldPosition.associatedVariableName};\n`;
        this._positionUVWName = state._getFreeVariableName("positionUVW");
        this._directionWName = state._getFreeVariableName("directionW");
        if (this.generateOnlyFragmentCode || state._emitVaryingFromString(this._positionUVWName, "vec3", this._defineSkyboxName)) {
            code += `#ifdef ${this._defineSkyboxName}\n`;
            code += `${this.generateOnlyFragmentCode ? "vec3 " : ""}${this._positionUVWName} = ${this.position.associatedVariableName}.xyz;\n`;
            code += `#endif\n`;
        }
        if (this.generateOnlyFragmentCode || state._emitVaryingFromString(this._directionWName, "vec3", `defined(${this._defineEquirectangularFixedName}) || defined(${this._defineMirroredEquirectangularFixedName})`)) {
            code += `#if defined(${this._defineEquirectangularFixedName}) || defined(${this._defineMirroredEquirectangularFixedName})\n`;
            code += `${this.generateOnlyFragmentCode ? "vec3 " : ""}${this._directionWName} = normalize(vec3(${this.world.associatedVariableName} * vec4(${this.position.associatedVariableName}.xyz, 0.0)));\n`;
            code += `#endif\n`;
        }
        return code;
    }
    /**
     * Handles the inits for the fragment code path
     * @param state node material build state
     */ handleFragmentSideInits(state) {
        state.sharedData.blockingBlocks.push(this);
        state.sharedData.textureBlocks.push(this);
        // Samplers
        this._cubeSamplerName = state._getFreeVariableName(this.name + "CubeSampler");
        state.samplers.push(this._cubeSamplerName);
        this._2DSamplerName = state._getFreeVariableName(this.name + "2DSampler");
        state.samplers.push(this._2DSamplerName);
        state._samplerDeclaration += `#ifdef ${this._define3DName}\n`;
        state._samplerDeclaration += `uniform samplerCube ${this._cubeSamplerName};\n`;
        state._samplerDeclaration += `#else\n`;
        state._samplerDeclaration += `uniform sampler2D ${this._2DSamplerName};\n`;
        state._samplerDeclaration += `#endif\n`;
        // Fragment
        state.sharedData.blocksWithDefines.push(this);
        state.sharedData.bindableBlocks.push(this);
        const comments = `//${this.name}`;
        state._emitFunctionFromInclude("helperFunctions", comments);
        state._emitFunctionFromInclude("reflectionFunction", comments, {
            replaceStrings: [
                {
                    search: /vec3 computeReflectionCoords/g,
                    replace: "void DUMMYFUNC"
                }
            ]
        });
        this._reflectionColorName = state._getFreeVariableName("reflectionColor");
        this._reflectionVectorName = state._getFreeVariableName("reflectionUVW");
        this._reflectionCoordsName = state._getFreeVariableName("reflectionCoords");
        this._reflectionPositionName = state._getFreeVariableName("vReflectionPosition");
        state._emitUniformFromString(this._reflectionPositionName, "vec3");
        this._reflectionSizeName = state._getFreeVariableName("vReflectionPosition");
        state._emitUniformFromString(this._reflectionSizeName, "vec3");
    }
    /**
     * Generates the reflection coords code for the fragment code path
     * @param worldNormalVarName name of the world normal variable
     * @param worldPos name of the world position variable. If not provided, will use the world position connected to this block
     * @param onlyReflectionVector if true, generates code only for the reflection vector computation, not for the reflection coordinates
     * @param doNotEmitInvertZ if true, does not emit the invertZ code
     * @returns the shader code
     */ handleFragmentSideCodeReflectionCoords(worldNormalVarName, worldPos, onlyReflectionVector = false, doNotEmitInvertZ = false) {
        if (!worldPos) worldPos = this.generateOnlyFragmentCode ? this._worldPositionNameInFragmentOnlyMode : `v_${this.worldPosition.associatedVariableName}`;
        const reflectionMatrix = this._reflectionMatrixName;
        const direction = `normalize(${this._directionWName})`;
        const positionUVW = `${this._positionUVWName}`;
        const vEyePosition = `${this.cameraPosition.associatedVariableName}`;
        const view = `${this.view.associatedVariableName}`;
        worldNormalVarName += ".xyz";
        let code = `
            #ifdef ${this._defineMirroredEquirectangularFixedName}
                vec3 ${this._reflectionVectorName} = computeMirroredFixedEquirectangularCoords(${worldPos}, ${worldNormalVarName}, ${direction});
            #endif

            #ifdef ${this._defineEquirectangularFixedName}
                vec3 ${this._reflectionVectorName} = computeFixedEquirectangularCoords(${worldPos}, ${worldNormalVarName}, ${direction});
            #endif

            #ifdef ${this._defineEquirectangularName}
                vec3 ${this._reflectionVectorName} = computeEquirectangularCoords(${worldPos}, ${worldNormalVarName}, ${vEyePosition}.xyz, ${reflectionMatrix});
            #endif

            #ifdef ${this._defineSphericalName}
                vec3 ${this._reflectionVectorName} = computeSphericalCoords(${worldPos}, ${worldNormalVarName}, ${view}, ${reflectionMatrix});
            #endif

            #ifdef ${this._definePlanarName}
                vec3 ${this._reflectionVectorName} = computePlanarCoords(${worldPos}, ${worldNormalVarName}, ${vEyePosition}.xyz, ${reflectionMatrix});
            #endif

            #ifdef ${this._defineCubicName}
                #ifdef ${this._defineLocalCubicName}
                    vec3 ${this._reflectionVectorName} = computeCubicLocalCoords(${worldPos}, ${worldNormalVarName}, ${vEyePosition}.xyz, ${reflectionMatrix}, ${this._reflectionSizeName}, ${this._reflectionPositionName});
                #else
                vec3 ${this._reflectionVectorName} = computeCubicCoords(${worldPos}, ${worldNormalVarName}, ${vEyePosition}.xyz, ${reflectionMatrix});
                #endif
            #endif

            #ifdef ${this._defineProjectionName}
                vec3 ${this._reflectionVectorName} = computeProjectionCoords(${worldPos}, ${view}, ${reflectionMatrix});
            #endif

            #ifdef ${this._defineSkyboxName}
                vec3 ${this._reflectionVectorName} = computeSkyBoxCoords(${positionUVW}, ${reflectionMatrix});
            #endif

            #ifdef ${this._defineExplicitName}
                vec3 ${this._reflectionVectorName} = vec3(0, 0, 0);
            #endif\n`;
        if (!doNotEmitInvertZ) code += `#ifdef ${this._defineOppositeZ}
                ${this._reflectionVectorName}.z *= -1.0;
            #endif\n`;
        if (!onlyReflectionVector) code += `
                #ifdef ${this._define3DName}
                    vec3 ${this._reflectionCoordsName} = ${this._reflectionVectorName};
                #else
                    vec2 ${this._reflectionCoordsName} = ${this._reflectionVectorName}.xy;
                    #ifdef ${this._defineProjectionName}
                        ${this._reflectionCoordsName} /= ${this._reflectionVectorName}.z;
                    #endif
                    ${this._reflectionCoordsName}.y = 1.0 - ${this._reflectionCoordsName}.y;
                #endif\n`;
        return code;
    }
    /**
     * Generates the reflection color code for the fragment code path
     * @param lodVarName name of the lod variable
     * @param swizzleLookupTexture swizzle to use for the final color variable
     * @returns the shader code
     */ handleFragmentSideCodeReflectionColor(lodVarName, swizzleLookupTexture = ".rgb") {
        const colorType = "vec" + (swizzleLookupTexture.length === 0 ? "4" : swizzleLookupTexture.length - 1);
        let code = `${colorType} ${this._reflectionColorName};
            #ifdef ${this._define3DName}\n`;
        if (lodVarName) code += `${this._reflectionColorName} = textureCubeLodEXT(${this._cubeSamplerName}, ${this._reflectionVectorName}, ${lodVarName})${swizzleLookupTexture};\n`;
        else code += `${this._reflectionColorName} = textureCube(${this._cubeSamplerName}, ${this._reflectionVectorName})${swizzleLookupTexture};\n`;
        code += `
            #else\n`;
        if (lodVarName) code += `${this._reflectionColorName} = texture2DLodEXT(${this._2DSamplerName}, ${this._reflectionCoordsName}, ${lodVarName})${swizzleLookupTexture};\n`;
        else code += `${this._reflectionColorName} = texture2D(${this._2DSamplerName}, ${this._reflectionCoordsName})${swizzleLookupTexture};\n`;
        code += `#endif\n`;
        return code;
    }
    /**
     * Generates the code corresponding to the connected output points
     * @param state node material build state
     * @param varName name of the variable to output
     * @returns the shader code
     */ writeOutputs(state, varName) {
        let code = "";
        if (state.target === (0, $iAIIe.NodeMaterialBlockTargets).Fragment) {
            for (const output of this._outputs)if (output.hasEndpoints) code += `${this._declareOutput(output, state)} = ${varName}.${output.name};\n`;
        }
        return code;
    }
    _buildBlock(state) {
        super._buildBlock(state);
        return this;
    }
    _dumpPropertiesCode() {
        let codeString = super._dumpPropertiesCode();
        if (!this.texture) return codeString;
        if (this.texture.isCube) {
            const forcedExtension = this.texture.forcedExtension;
            codeString += `${this._codeVariableName}.texture = new BABYLON.CubeTexture("${this.texture.name}", undefined, undefined, ${this.texture.noMipmap}, null, undefined, undefined, undefined, ${this.texture._prefiltered}, ${forcedExtension ? '"' + forcedExtension + '"' : "null"});\n`;
        } else codeString += `${this._codeVariableName}.texture = new BABYLON.Texture("${this.texture.name}", null);\n`;
        codeString += `${this._codeVariableName}.texture.coordinatesMode = ${this.texture.coordinatesMode};\n`;
        return codeString;
    }
    serialize() {
        const serializationObject = super.serialize();
        if (this.texture && !this.texture.isRenderTarget) serializationObject.texture = this.texture.serialize();
        serializationObject.generateOnlyFragmentCode = this.generateOnlyFragmentCode;
        return serializationObject;
    }
    _deserialize(serializationObject, scene, rootUrl) {
        super._deserialize(serializationObject, scene, rootUrl);
        if (serializationObject.texture && !(0, $5fNQr.NodeMaterial).IgnoreTexturesAtLoadTime) {
            rootUrl = serializationObject.texture.url.indexOf("data:") === 0 ? "" : rootUrl;
            if (serializationObject.texture.isCube) this.texture = (0, $iPQLf.CubeTexture).Parse(serializationObject.texture, scene, rootUrl);
            else this.texture = (0, $j2mX5.Texture).Parse(serializationObject.texture, scene, rootUrl);
        }
        this.generateOnlyFragmentCode = serializationObject.generateOnlyFragmentCode;
        this._setTarget();
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Generate only fragment code", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            rebuild: true,
            update: true,
            onValidation: $54d1387066b7959f$export$37ef4c0550d458c0._OnGenerateOnlyFragmentCodeChanged
        }
    })
], $54d1387066b7959f$export$37ef4c0550d458c0.prototype, "generateOnlyFragmentCode", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.ReflectionTextureBaseBlock", $54d1387066b7959f$export$37ef4c0550d458c0);

});

parcelRegister("5QeYV", function(module, exports) {

$parcel$export(module.exports, "ReflectionTextureBlock", () => $440d6e207e093462$export$1e7fffc845daa7b8);

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");

var $aKEh2 = parcelRequire("aKEh2");

var $7qH6c = parcelRequire("7qH6c");

var $7htMm = parcelRequire("7htMm");

var $kVtWi = parcelRequire("kVtWi");
class $440d6e207e093462$export$1e7fffc845daa7b8 extends (0, $7htMm.ReflectionTextureBaseBlock) {
    _onGenerateOnlyFragmentCodeChanged() {
        if (this.position.isConnected) {
            this.generateOnlyFragmentCode = !this.generateOnlyFragmentCode;
            (0, $kVtWi.Logger).Error("The position input must not be connected to be able to switch!");
            return false;
        }
        if (this.worldPosition.isConnected) {
            this.generateOnlyFragmentCode = !this.generateOnlyFragmentCode;
            (0, $kVtWi.Logger).Error("The worldPosition input must not be connected to be able to switch!");
            return false;
        }
        this._setTarget();
        return true;
    }
    _setTarget() {
        super._setTarget();
        this.getInputByName("position").target = this.generateOnlyFragmentCode ? (0, $iAIIe.NodeMaterialBlockTargets).Fragment : (0, $iAIIe.NodeMaterialBlockTargets).Vertex;
        this.getInputByName("worldPosition").target = this.generateOnlyFragmentCode ? (0, $iAIIe.NodeMaterialBlockTargets).Fragment : (0, $iAIIe.NodeMaterialBlockTargets).Vertex;
    }
    /**
     * Create a new ReflectionTextureBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this.registerInput("position", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect, false, (0, $iAIIe.NodeMaterialBlockTargets).Vertex);
        this.registerInput("worldPosition", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4, false, (0, $iAIIe.NodeMaterialBlockTargets).Vertex);
        this.registerInput("worldNormal", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4, false, (0, $iAIIe.NodeMaterialBlockTargets).Fragment); // Flagging as fragment as the normal can be changed by fragment code
        this.registerInput("world", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix, false, (0, $iAIIe.NodeMaterialBlockTargets).Vertex);
        this.registerInput("cameraPosition", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3, false, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("view", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix, false, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("rgb", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("rgba", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("r", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("g", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("b", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("a", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this._inputs[0].addExcludedConnectionPointFromAllowedTypes((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "ReflectionTextureBlock";
    }
    /**
     * Gets the world position input component
     */ get position() {
        return this._inputs[0];
    }
    /**
     * Gets the world position input component
     */ get worldPosition() {
        return this._inputs[1];
    }
    /**
     * Gets the world normal input component
     */ get worldNormal() {
        return this._inputs[2];
    }
    /**
     * Gets the world input component
     */ get world() {
        return this._inputs[3];
    }
    /**
     * Gets the camera (or eye) position component
     */ get cameraPosition() {
        return this._inputs[4];
    }
    /**
     * Gets the view input component
     */ get view() {
        return this._inputs[5];
    }
    /**
     * Gets the rgb output component
     */ get rgb() {
        return this._outputs[0];
    }
    /**
     * Gets the rgba output component
     */ get rgba() {
        return this._outputs[1];
    }
    /**
     * Gets the r output component
     */ get r() {
        return this._outputs[2];
    }
    /**
     * Gets the g output component
     */ get g() {
        return this._outputs[3];
    }
    /**
     * Gets the b output component
     */ get b() {
        return this._outputs[4];
    }
    /**
     * Gets the a output component
     */ get a() {
        return this._outputs[5];
    }
    autoConfigure(material, additionalFilteringInfo = ()=>true) {
        super.autoConfigure(material);
        if (!this.cameraPosition.isConnected) {
            let cameraPositionInput = material.getInputBlockByPredicate((b)=>b.systemValue === (0, $7qH6c.NodeMaterialSystemValues).CameraPosition && additionalFilteringInfo(b));
            if (!cameraPositionInput) {
                cameraPositionInput = new (0, $aKEh2.InputBlock)("cameraPosition");
                cameraPositionInput.setAsSystemValue((0, $7qH6c.NodeMaterialSystemValues).CameraPosition);
            }
            cameraPositionInput.output.connectTo(this.cameraPosition);
        }
    }
    _buildBlock(state) {
        super._buildBlock(state);
        if (!this.texture) {
            state.compilationString += this.writeOutputs(state, "vec4(0.)");
            return this;
        }
        if (state.target !== (0, $iAIIe.NodeMaterialBlockTargets).Fragment) {
            state.compilationString += this.handleVertexSide(state);
            return this;
        }
        if (this.generateOnlyFragmentCode) state.compilationString += this.handleVertexSide(state);
        this.handleFragmentSideInits(state);
        const normalWUnit = state._getFreeVariableName("normalWUnit");
        state.compilationString += `vec4 ${normalWUnit} = normalize(${this.worldNormal.associatedVariableName});\n`;
        state.compilationString += this.handleFragmentSideCodeReflectionCoords(normalWUnit);
        state.compilationString += this.handleFragmentSideCodeReflectionColor(undefined, "");
        state.compilationString += this.writeOutputs(state, this._reflectionColorName);
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.ReflectionTextureBlock", $440d6e207e093462$export$1e7fffc845daa7b8);

});

parcelRegister("3jhpF", function(module, exports) {

$parcel$export(module.exports, "SceneDepthBlock", () => $2690a74c0b673e22$export$bd2f869e516ca7b6);

var $e0Suo = parcelRequire("e0Suo");

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");

var $1aXVF = parcelRequire("1aXVF");
class $2690a74c0b673e22$export$bd2f869e516ca7b6 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Create a new SceneDepthBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment);
        /**
         * Defines if the depth renderer should be setup in non linear mode
         */ this.useNonLinearDepth = false;
        /**
         * Defines if the depth renderer should be setup in camera space Z mode (if set, useNonLinearDepth has no effect)
         */ this.storeCameraSpaceZ = false;
        /**
         * Defines if the depth renderer should be setup in full 32 bits float mode
         */ this.force32itsFloat = false;
        this._isUnique = true;
        this.registerInput("uv", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect, false, (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment);
        this.registerOutput("depth", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this._inputs[0].addExcludedConnectionPointFromAllowedTypes((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4);
        this._inputs[0]._prioritizeVertex = false;
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "SceneDepthBlock";
    }
    /**
     * Gets the uv input component
     */ get uv() {
        return this._inputs[0];
    }
    /**
     * Gets the depth output component
     */ get depth() {
        return this._outputs[0];
    }
    /**
     * Initialize the block and prepare the context for build
     * @param state defines the state that will be used for the build
     */ initialize(state) {
        state._excludeVariableName("textureSampler");
    }
    get target() {
        if (!this.uv.isConnected) return (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment;
        if (this.uv.sourceBlock.isInput) return (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment;
        return (0, $iAIIe.NodeMaterialBlockTargets).Fragment;
    }
    _getTexture(scene) {
        const depthRenderer = scene.enableDepthRenderer(undefined, this.useNonLinearDepth, this.force32itsFloat, undefined, this.storeCameraSpaceZ);
        return depthRenderer.getDepthMap();
    }
    bind(effect, nodeMaterial) {
        const texture = this._getTexture(nodeMaterial.getScene());
        effect.setTexture(this._samplerName, texture);
    }
    _injectVertexCode(state) {
        const uvInput = this.uv;
        if (uvInput.connectedPoint.ownerBlock.isInput) {
            const uvInputOwnerBlock = uvInput.connectedPoint.ownerBlock;
            if (!uvInputOwnerBlock.isAttribute) state._emitUniformFromString(uvInput.associatedVariableName, "vec" + (uvInput.type === (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3 ? "3" : uvInput.type === (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4 ? "4" : "2"));
        }
        this._mainUVName = "vMain" + uvInput.associatedVariableName;
        state._emitVaryingFromString(this._mainUVName, "vec2");
        state.compilationString += `${this._mainUVName} = ${uvInput.associatedVariableName}.xy;\n`;
        if (!this._outputs.some((o)=>o.isConnectedInVertexShader)) return;
        this._writeTextureRead(state, true);
        for (const output of this._outputs)if (output.hasEndpoints) this._writeOutput(state, output, "r", true);
    }
    _writeTextureRead(state, vertexMode = false) {
        const uvInput = this.uv;
        if (vertexMode) {
            if (state.target === (0, $iAIIe.NodeMaterialBlockTargets).Fragment) return;
            state.compilationString += `vec4 ${this._tempTextureRead} = texture2D(${this._samplerName}, ${uvInput.associatedVariableName}.xy);\n`;
            return;
        }
        if (this.uv.ownerBlock.target === (0, $iAIIe.NodeMaterialBlockTargets).Fragment) {
            state.compilationString += `vec4 ${this._tempTextureRead} = texture2D(${this._samplerName}, ${uvInput.associatedVariableName}.xy);\n`;
            return;
        }
        state.compilationString += `vec4 ${this._tempTextureRead} = texture2D(${this._samplerName}, ${this._mainUVName});\n`;
    }
    _writeOutput(state, output, swizzle, vertexMode = false) {
        if (vertexMode) {
            if (state.target === (0, $iAIIe.NodeMaterialBlockTargets).Fragment) return;
            state.compilationString += `${this._declareOutput(output, state)} = ${this._tempTextureRead}.${swizzle};\n`;
            return;
        }
        if (this.uv.ownerBlock.target === (0, $iAIIe.NodeMaterialBlockTargets).Fragment) {
            state.compilationString += `${this._declareOutput(output, state)} = ${this._tempTextureRead}.${swizzle};\n`;
            return;
        }
        state.compilationString += `${this._declareOutput(output, state)} = ${this._tempTextureRead}.${swizzle};\n`;
    }
    _buildBlock(state) {
        super._buildBlock(state);
        this._samplerName = state._getFreeVariableName(this.name + "Sampler");
        this._tempTextureRead = state._getFreeVariableName("tempTextureRead");
        if (state.sharedData.bindableBlocks.indexOf(this) < 0) state.sharedData.bindableBlocks.push(this);
        if (state.target !== (0, $iAIIe.NodeMaterialBlockTargets).Fragment) {
            // Vertex
            state._emit2DSampler(this._samplerName);
            this._injectVertexCode(state);
            return;
        }
        // Fragment
        if (!this._outputs.some((o)=>o.isConnectedInFragmentShader)) return;
        state._emit2DSampler(this._samplerName);
        this._writeTextureRead(state);
        for (const output of this._outputs)if (output.hasEndpoints) this._writeOutput(state, output, "r");
        return this;
    }
    serialize() {
        const serializationObject = super.serialize();
        serializationObject.useNonLinearDepth = this.useNonLinearDepth;
        serializationObject.storeCameraSpaceZ = this.storeCameraSpaceZ;
        serializationObject.force32itsFloat = this.force32itsFloat;
        return serializationObject;
    }
    _deserialize(serializationObject, scene, rootUrl) {
        super._deserialize(serializationObject, scene, rootUrl);
        this.useNonLinearDepth = serializationObject.useNonLinearDepth;
        this.storeCameraSpaceZ = !!serializationObject.storeCameraSpaceZ;
        this.force32itsFloat = serializationObject.force32itsFloat;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Use non linear depth", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            activatePreviewCommand: true,
            callback: (scene, block)=>{
                const sceneDepthBlock = block;
                let retVal = false;
                if (sceneDepthBlock.useNonLinearDepth) {
                    sceneDepthBlock.storeCameraSpaceZ = false;
                    retVal = true;
                }
                if (scene) scene.disableDepthRenderer();
                return retVal;
            }
        }
    })
], $2690a74c0b673e22$export$bd2f869e516ca7b6.prototype, "useNonLinearDepth", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Store Camera space Z", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            activatePreviewCommand: true,
            callback: (scene, block)=>{
                const sceneDepthBlock = block;
                let retVal = false;
                if (sceneDepthBlock.storeCameraSpaceZ) {
                    sceneDepthBlock.useNonLinearDepth = false;
                    retVal = true;
                }
                if (scene) scene.disableDepthRenderer();
                return retVal;
            }
        }
    })
], $2690a74c0b673e22$export$bd2f869e516ca7b6.prototype, "storeCameraSpaceZ", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Force 32 bits float", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            activatePreviewCommand: true,
            callback: (scene)=>scene?.disableDepthRenderer()
        }
    })
], $2690a74c0b673e22$export$bd2f869e516ca7b6.prototype, "force32itsFloat", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.SceneDepthBlock", $2690a74c0b673e22$export$bd2f869e516ca7b6);

});

parcelRegister("clKbk", function(module, exports) {

$parcel$export(module.exports, "ClipPlanesBlock", () => $8fdb44f03790d6c8$export$362b3006f48cf941);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");

var $aAFeM = parcelRequire("aAFeM");
class $8fdb44f03790d6c8$export$362b3006f48cf941 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Create a new ClipPlanesBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment, true);
        this.registerInput("worldPosition", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4, false);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "ClipPlanesBlock";
    }
    /**
     * Initialize the block and prepare the context for build
     * @param state defines the state that will be used for the build
     */ initialize(state) {
        state._excludeVariableName("vClipPlane");
        state._excludeVariableName("fClipDistance");
        state._excludeVariableName("vClipPlane2");
        state._excludeVariableName("fClipDistance2");
        state._excludeVariableName("vClipPlane3");
        state._excludeVariableName("fClipDistance3");
        state._excludeVariableName("vClipPlane4");
        state._excludeVariableName("fClipDistance4");
        state._excludeVariableName("vClipPlane5");
        state._excludeVariableName("fClipDistance5");
        state._excludeVariableName("vClipPlane6");
        state._excludeVariableName("fClipDistance6");
    }
    /**
     * Gets the worldPosition input component
     */ get worldPosition() {
        return this._inputs[0];
    }
    get target() {
        return (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment;
    }
    set target(value) {}
    prepareDefines(mesh, nodeMaterial, defines) {
        const scene = mesh.getScene();
        const useClipPlane1 = nodeMaterial.clipPlane ?? scene.clipPlane ? true : false;
        const useClipPlane2 = nodeMaterial.clipPlane2 ?? scene.clipPlane2 ? true : false;
        const useClipPlane3 = nodeMaterial.clipPlane3 ?? scene.clipPlane3 ? true : false;
        const useClipPlane4 = nodeMaterial.clipPlane4 ?? scene.clipPlane4 ? true : false;
        const useClipPlane5 = nodeMaterial.clipPlane5 ?? scene.clipPlane5 ? true : false;
        const useClipPlane6 = nodeMaterial.clipPlane6 ?? scene.clipPlane6 ? true : false;
        defines.setValue("CLIPPLANE", useClipPlane1, true);
        defines.setValue("CLIPPLANE2", useClipPlane2, true);
        defines.setValue("CLIPPLANE3", useClipPlane3, true);
        defines.setValue("CLIPPLANE4", useClipPlane4, true);
        defines.setValue("CLIPPLANE5", useClipPlane5, true);
        defines.setValue("CLIPPLANE6", useClipPlane6, true);
    }
    bind(effect, nodeMaterial, mesh) {
        if (!mesh) return;
        const scene = mesh.getScene();
        (0, $aAFeM.bindClipPlane)(effect, nodeMaterial, scene);
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const comments = `//${this.name}`;
        if (state.target !== (0, $iAIIe.NodeMaterialBlockTargets).Fragment) {
            // Vertex
            const worldPos = this.worldPosition;
            state._emitFunctionFromInclude("clipPlaneVertexDeclaration", comments, {
                replaceStrings: [
                    {
                        search: /uniform vec4 vClipPlane\d*;/g,
                        replace: ""
                    }
                ]
            });
            state.compilationString += state._emitCodeFromInclude("clipPlaneVertex", comments, {
                replaceStrings: [
                    {
                        search: /worldPos/g,
                        replace: worldPos.associatedVariableName
                    }
                ]
            });
            state._emitUniformFromString("vClipPlane", "vec4");
            state._emitUniformFromString("vClipPlane2", "vec4");
            state._emitUniformFromString("vClipPlane3", "vec4");
            state._emitUniformFromString("vClipPlane4", "vec4");
            state._emitUniformFromString("vClipPlane5", "vec4");
            state._emitUniformFromString("vClipPlane6", "vec4");
            return;
        }
        // Fragment
        state.sharedData.bindableBlocks.push(this);
        state.sharedData.blocksWithDefines.push(this);
        state._emitFunctionFromInclude("clipPlaneFragmentDeclaration", comments);
        state.compilationString += state._emitCodeFromInclude("clipPlaneFragment", comments);
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.ClipPlanesBlock", $8fdb44f03790d6c8$export$362b3006f48cf941);

});


parcelRegister("gJaMt", function(module, exports) {

var $aKEh2 = parcelRequire("aKEh2");

var $apsYB = parcelRequire("apsYB");

var $jvArq = parcelRequire("jvArq");
$parcel$exportWildcard(module.exports, $aKEh2);
$parcel$exportWildcard(module.exports, $apsYB);
$parcel$exportWildcard(module.exports, $jvArq);

});
parcelRegister("jvArq", function(module, exports) {

$parcel$export(module.exports, "PrePassTextureBlock", () => $e33d2e1298eae7c8$export$63d3aa365c636e3a);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $g92b7 = parcelRequire("g92b7");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");

var $dTtBA = parcelRequire("dTtBA");

var $0nhKt = parcelRequire("0nhKt");
class $e33d2e1298eae7c8$export$63d3aa365c636e3a extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * The texture associated with the node is the prepass texture
     */ get texture() {
        return null;
    }
    set texture(value) {
        return;
    }
    /**
     * Creates a new PrePassTextureBlock
     * @param name defines the block name
     * @param target defines the target of that block (VertexAndFragment by default)
     */ constructor(name, target = (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment){
        super(name, target, false);
        this.registerOutput("position", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Object, (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment, new (0, $dTtBA.NodeMaterialConnectionPointCustomObject)("position", this, (0, $g92b7.NodeMaterialConnectionPointDirection).Output, (0, $0nhKt.ImageSourceBlock), "ImageSourceBlock"));
        this.registerOutput("depth", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Object, (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment, new (0, $dTtBA.NodeMaterialConnectionPointCustomObject)("depth", this, (0, $g92b7.NodeMaterialConnectionPointDirection).Output, (0, $0nhKt.ImageSourceBlock), "ImageSourceBlock"));
        this.registerOutput("normal", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Object, (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment, new (0, $dTtBA.NodeMaterialConnectionPointCustomObject)("normal", this, (0, $g92b7.NodeMaterialConnectionPointDirection).Output, (0, $0nhKt.ImageSourceBlock), "ImageSourceBlock"));
    }
    /**
     * Returns the sampler name associated with the node connection point
     * @param output defines the connection point to get the associated sampler name
     * @returns
     */ getSamplerName(output) {
        if (output === this._outputs[0]) return this._positionSamplerName;
        if (output === this._outputs[1]) return this._depthSamplerName;
        if (output === this._outputs[2]) return this._normalSamplerName;
        return "";
    }
    /**
     * Gets the position texture
     */ get position() {
        return this._outputs[0];
    }
    /**
     * Gets the depth texture
     */ get depth() {
        return this._outputs[1];
    }
    /**
     * Gets the normal texture
     */ get normal() {
        return this._outputs[2];
    }
    /**
     * Gets the sampler name associated with this image source
     */ get positionSamplerName() {
        return this._positionSamplerName;
    }
    /**
     * Gets the sampler name associated with this image source
     */ get normalSamplerName() {
        return this._normalSamplerName;
    }
    /**
     * Gets the sampler name associated with this image source
     */ get depthSamplerName() {
        return this._depthSamplerName;
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "PrePassTextureBlock";
    }
    _buildBlock(state) {
        super._buildBlock(state);
        if (state.target === (0, $iAIIe.NodeMaterialBlockTargets).Vertex) return;
        this._positionSamplerName = "prepassPositionSampler";
        this._depthSamplerName = "prepassDepthSampler";
        this._normalSamplerName = "prepassNormalSampler";
        // Unique sampler names for every prepasstexture block
        state.sharedData.variableNames.prepassPositionSampler = 0;
        state.sharedData.variableNames.prepassDepthSampler = 0;
        state.sharedData.variableNames.prepassNormalSampler = 0;
        // Declarations
        state.sharedData.textureBlocks.push(this);
        state.sharedData.bindableBlocks.push(this);
        state._emit2DSampler(this._positionSamplerName);
        state._emit2DSampler(this._depthSamplerName);
        state._emit2DSampler(this._normalSamplerName);
        return this;
    }
    bind(effect, nodeMaterial) {
        const scene = nodeMaterial.getScene();
        const prePassRenderer = scene.enablePrePassRenderer();
        if (!prePassRenderer) return;
        const sceneRT = prePassRenderer.defaultRT;
        if (!sceneRT.textures) return;
        if (this.position.isConnected) effect.setTexture(this._positionSamplerName, sceneRT.textures[prePassRenderer.getIndex(1)]);
        if (this.depth.isConnected) effect.setTexture(this._depthSamplerName, sceneRT.textures[prePassRenderer.getIndex(5)]);
        if (this.normal.isConnected) effect.setTexture(this._normalSamplerName, sceneRT.textures[prePassRenderer.getIndex(6)]);
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.PrePassTextureBlock", $e33d2e1298eae7c8$export$63d3aa365c636e3a);

});


parcelRegister("4a7EU", function(module, exports) {

var $cSFlw = parcelRequire("cSFlw");

var $aRBSc = parcelRequire("aRBSc");
$parcel$exportWildcard(module.exports, $cSFlw);
$parcel$exportWildcard(module.exports, $aRBSc);

});
parcelRegister("cSFlw", function(module, exports) {

$parcel$export(module.exports, "NodeMaterialTeleportInBlock", () => $960a99a9929c3d52$export$b62a394424723a70);

var $8DoUR = parcelRequire("8DoUR");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $kpKE2 = parcelRequire("kpKE2");
class $960a99a9929c3d52$export$b62a394424723a70 extends (0, $kpKE2.NodeMaterialBlock) {
    /** Gets the list of attached endpoints */ get endpoints() {
        return this._endpoints;
    }
    /**
     * Gets or sets the target of the block
     */ get target() {
        const input = this._inputs[0];
        if (input.isConnected) {
            const block = input.connectedPoint.ownerBlock;
            if (block.target !== (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment) return block.target;
            if (input.connectedPoint.target !== (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment) return input.connectedPoint.target;
        }
        return this._target;
    }
    set target(value) {
        if ((this._target & value) !== 0) return;
        this._target = value;
    }
    /**
     * Create a new NodeMaterialTeleportInBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this._endpoints = [];
        this.registerInput("input", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "NodeMaterialTeleportInBlock";
    }
    /**
     * Gets the input component
     */ get input() {
        return this._inputs[0];
    }
    /**
     * @returns a boolean indicating that this connection will be used in the fragment shader
     */ isConnectedInFragmentShader() {
        return this.endpoints.some((e)=>e.output.isConnectedInFragmentShader);
    }
    _dumpCode(uniqueNames, alreadyDumped) {
        let codeString = super._dumpCode(uniqueNames, alreadyDumped);
        for (const endpoint of this.endpoints)if (alreadyDumped.indexOf(endpoint) === -1) codeString += endpoint._dumpCode(uniqueNames, alreadyDumped);
        return codeString;
    }
    /**
     * Checks if the current block is an ancestor of a given block
     * @param block defines the potential descendant block to check
     * @returns true if block is a descendant
     */ isAnAncestorOf(block) {
        for (const endpoint of this.endpoints){
            if (endpoint === block) return true;
            if (endpoint.isAnAncestorOf(block)) return true;
        }
        return false;
    }
    /**
     * Add an enpoint to this block
     * @param endpoint define the endpoint to attach to
     */ attachToEndpoint(endpoint) {
        endpoint.detach();
        this._endpoints.push(endpoint);
        endpoint._entryPoint = this;
        endpoint._outputs[0]._typeConnectionSource = this._inputs[0];
        endpoint._tempEntryPointUniqueId = null;
        endpoint.name = "> " + this.name;
    }
    /**
     * Remove enpoint from this block
     * @param endpoint define the endpoint to remove
     */ detachFromEndpoint(endpoint) {
        const index = this._endpoints.indexOf(endpoint);
        if (index !== -1) {
            this._endpoints.splice(index, 1);
            endpoint._outputs[0]._typeConnectionSource = null;
            endpoint._entryPoint = null;
        }
    }
    /**
     * Release resources
     */ dispose() {
        super.dispose();
        for (const endpoint of this._endpoints)this.detachFromEndpoint(endpoint);
        this._endpoints = [];
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.NodeMaterialTeleportInBlock", $960a99a9929c3d52$export$b62a394424723a70);

});

parcelRegister("aRBSc", function(module, exports) {

$parcel$export(module.exports, "NodeMaterialTeleportOutBlock", () => $7e8c3b6f08749f58$export$a81def906018ab74);

var $8DoUR = parcelRequire("8DoUR");

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");
class $7e8c3b6f08749f58$export$a81def906018ab74 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Create a new TeleportOutBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        /** @internal */ this._entryPoint = null;
        /** @internal */ this._tempEntryPointUniqueId = null;
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).BasedOnInput);
    }
    /**
     * Gets the entry point
     */ get entryPoint() {
        return this._entryPoint;
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "NodeMaterialTeleportOutBlock";
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    /**
     * Gets or sets the target of the block
     */ get target() {
        return this._entryPoint ? this._entryPoint.target : this._target;
    }
    set target(value) {
        if ((this._target & value) !== 0) return;
        this._target = value;
    }
    /** Detach from entry point */ detach() {
        if (!this._entryPoint) return;
        this._entryPoint.detachFromEndpoint(this);
    }
    _buildBlock(state) {
        super._buildBlock(state);
        if (this.entryPoint) state.compilationString += this._declareOutput(this.output, state) + ` = ${this.entryPoint.input.associatedVariableName};\n`;
    }
    /**
     * Clone the current block to a new identical block
     * @param scene defines the hosting scene
     * @param rootUrl defines the root URL to use to load textures and relative dependencies
     * @returns a copy of the current block
     */ clone(scene, rootUrl = "") {
        const clone = super.clone(scene, rootUrl);
        if (this.entryPoint) this.entryPoint.attachToEndpoint(clone);
        return clone;
    }
    _customBuildStep(state, activeBlocks) {
        if (this.entryPoint) this.entryPoint.build(state, activeBlocks);
    }
    _dumpCode(uniqueNames, alreadyDumped) {
        let codeString = "";
        if (this.entryPoint) {
            if (alreadyDumped.indexOf(this.entryPoint) === -1) codeString += this.entryPoint._dumpCode(uniqueNames, alreadyDumped);
        }
        return codeString + super._dumpCode(uniqueNames, alreadyDumped);
    }
    _dumpCodeForOutputConnections(alreadyDumped) {
        let codeString = super._dumpCodeForOutputConnections(alreadyDumped);
        if (this.entryPoint) codeString += this.entryPoint._dumpCodeForOutputConnections(alreadyDumped);
        return codeString;
    }
    _dumpPropertiesCode() {
        let codeString = super._dumpPropertiesCode();
        if (this.entryPoint) codeString += `${this.entryPoint._codeVariableName}.attachToEndpoint(${this._codeVariableName});\n`;
        return codeString;
    }
    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.entryPoint = this.entryPoint?.uniqueId ?? "";
        return serializationObject;
    }
    _deserialize(serializationObject, scene, rootUrl) {
        super._deserialize(serializationObject, scene, rootUrl);
        this._tempEntryPointUniqueId = serializationObject.entryPoint;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.NodeMaterialTeleportOutBlock", $7e8c3b6f08749f58$export$a81def906018ab74);

});


parcelRegister("gpOxb", function(module, exports) {

$parcel$export(module.exports, "AddBlock", () => $bf362e33e36d37c9$export$b0bdb923ca9c9c5f);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $bf362e33e36d37c9$export$b0bdb923ca9c9c5f extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new AddBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("left", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerInput("right", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
        this._linkConnectionTypes(0, 1, true);
        this._inputs[0].acceptedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this._inputs[1].acceptedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "AddBlock";
    }
    /**
     * Gets the left operand input component
     */ get left() {
        return this._inputs[0];
    }
    /**
     * Gets the right operand input component
     */ get right() {
        return this._inputs[1];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        state.compilationString += this._declareOutput(output, state) + ` = ${this.left.associatedVariableName} + ${this.right.associatedVariableName};\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.AddBlock", $bf362e33e36d37c9$export$b0bdb923ca9c9c5f);

});

parcelRegister("eoRzM", function(module, exports) {

$parcel$export(module.exports, "ScaleBlock", () => $a7bcddb2c327e9a6$export$9bc6fa54cf024c17);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $a7bcddb2c327e9a6$export$9bc6fa54cf024c17 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new ScaleBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("input", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerInput("factor", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "ScaleBlock";
    }
    /**
     * Gets the input component
     */ get input() {
        return this._inputs[0];
    }
    /**
     * Gets the factor input component
     */ get factor() {
        return this._inputs[1];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        state.compilationString += this._declareOutput(output, state) + ` = ${this.input.associatedVariableName} * ${this.factor.associatedVariableName};\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.ScaleBlock", $a7bcddb2c327e9a6$export$9bc6fa54cf024c17);

});

parcelRegister("2KFUi", function(module, exports) {

$parcel$export(module.exports, "ClampBlock", () => $201062806a0ace93$export$90b2da7873fdee51);

var $e0Suo = parcelRequire("e0Suo");

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");

var $1aXVF = parcelRequire("1aXVF");
class $201062806a0ace93$export$90b2da7873fdee51 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new ClampBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        /** Gets or sets the minimum range */ this.minimum = 0.0;
        /** Gets or sets the maximum range */ this.maximum = 1.0;
        this.registerInput("value", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "ClampBlock";
    }
    /**
     * Gets the value input component
     */ get value() {
        return this._inputs[0];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        state.compilationString += this._declareOutput(output, state) + ` = clamp(${this.value.associatedVariableName}, ${this._writeFloat(this.minimum)}, ${this._writeFloat(this.maximum)});\n`;
        return this;
    }
    _dumpPropertiesCode() {
        let codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.minimum = ${this.minimum};\n`;
        codeString += `${this._codeVariableName}.maximum = ${this.maximum};\n`;
        return codeString;
    }
    serialize() {
        const serializationObject = super.serialize();
        serializationObject.minimum = this.minimum;
        serializationObject.maximum = this.maximum;
        return serializationObject;
    }
    _deserialize(serializationObject, scene, rootUrl) {
        super._deserialize(serializationObject, scene, rootUrl);
        this.minimum = serializationObject.minimum;
        this.maximum = serializationObject.maximum;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Minimum", (0, $1aXVF.PropertyTypeForEdition).Float)
], $201062806a0ace93$export$90b2da7873fdee51.prototype, "minimum", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Maximum", (0, $1aXVF.PropertyTypeForEdition).Float)
], $201062806a0ace93$export$90b2da7873fdee51.prototype, "maximum", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.ClampBlock", $201062806a0ace93$export$90b2da7873fdee51);

});

parcelRegister("3cPC6", function(module, exports) {

$parcel$export(module.exports, "CrossBlock", () => $255a8777573c133f$export$1dbd2496d6b7b2ab);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $255a8777573c133f$export$1dbd2496d6b7b2ab extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new CrossBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("left", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerInput("right", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3);
        this._linkConnectionTypes(0, 1);
        this._inputs[0].excludedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this._inputs[0].excludedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix);
        this._inputs[0].excludedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2);
        this._inputs[1].excludedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this._inputs[1].excludedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix);
        this._inputs[1].excludedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "CrossBlock";
    }
    /**
     * Gets the left operand input component
     */ get left() {
        return this._inputs[0];
    }
    /**
     * Gets the right operand input component
     */ get right() {
        return this._inputs[1];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        state.compilationString += this._declareOutput(output, state) + ` = cross(${this.left.associatedVariableName}.xyz, ${this.right.associatedVariableName}.xyz);\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.CrossBlock", $255a8777573c133f$export$1dbd2496d6b7b2ab);

});

parcelRegister("gRxmB", function(module, exports) {

$parcel$export(module.exports, "CustomBlock", () => $c46b79e8a6eaee00$export$50a6a2d597e669c);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");

var $g92b7 = parcelRequire("g92b7");

var $0nhKt = parcelRequire("0nhKt");

var $dTtBA = parcelRequire("dTtBA");
class $c46b79e8a6eaee00$export$50a6a2d597e669c extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Gets or sets the options for this custom block
     */ get options() {
        return this._options;
    }
    set options(options) {
        this._deserializeOptions(options);
    }
    /**
     * Creates a new CustomBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "CustomBlock";
    }
    _buildBlock(state) {
        super._buildBlock(state);
        let code = this._code;
        let functionName = this._options.functionName;
        // Replace the TYPE_XXX placeholders (if any)
        this._inputs.forEach((input)=>{
            const rexp = new RegExp("\\{TYPE_" + input.name + "\\}", "gm");
            const type = state._getGLType(input.type);
            code = code.replace(rexp, type);
            functionName = functionName.replace(rexp, type);
        });
        this._outputs.forEach((output)=>{
            const rexp = new RegExp("\\{TYPE_" + output.name + "\\}", "gm");
            const type = state._getGLType(output.type);
            code = code.replace(rexp, type);
            functionName = functionName.replace(rexp, type);
        });
        state._emitFunction(functionName, code, "");
        // Declare the output variables
        this._outputs.forEach((output)=>{
            state.compilationString += this._declareOutput(output, state) + ";\n";
        });
        // Generate the function call
        state.compilationString += functionName + "(";
        let hasInput = false;
        this._inputs.forEach((input, index)=>{
            if (index > 0) state.compilationString += ", ";
            if (this._inputSamplers && this._inputSamplers.indexOf(input.name) !== -1) state.compilationString += input.connectedPoint?.ownerBlock?.samplerName ?? input.associatedVariableName;
            else state.compilationString += input.associatedVariableName;
            hasInput = true;
        });
        this._outputs.forEach((output, index)=>{
            if (index > 0 || hasInput) state.compilationString += ", ";
            state.compilationString += output.associatedVariableName;
        });
        state.compilationString += ");\n";
        return this;
    }
    _dumpPropertiesCode() {
        let codeString = super._dumpPropertiesCode();
        codeString += `${this._codeVariableName}.options = ${JSON.stringify(this._options)};\n`;
        return codeString;
    }
    serialize() {
        const serializationObject = super.serialize();
        serializationObject.options = this._options;
        return serializationObject;
    }
    _deserialize(serializationObject, scene, rootUrl) {
        this._deserializeOptions(serializationObject.options);
        super._deserialize(serializationObject, scene, rootUrl);
    }
    _deserializeOptions(options) {
        this._options = options;
        this._code = options.code.join("\n") + "\n";
        this.name = this.name || options.name;
        this.target = (0, $iAIIe.NodeMaterialBlockTargets)[options.target];
        options.inParameters?.forEach((input, index)=>{
            const type = (0, $3mKw5.NodeMaterialBlockConnectionPointTypes)[input.type];
            if (input.type === "sampler2D" || input.type === "samplerCube") {
                this._inputSamplers = this._inputSamplers || [];
                this._inputSamplers.push(input.name);
                this.registerInput(input.name, (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Object, true, (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment, new (0, $dTtBA.NodeMaterialConnectionPointCustomObject)(input.name, this, (0, $g92b7.NodeMaterialConnectionPointDirection).Input, (0, $0nhKt.ImageSourceBlock), "ImageSourceBlock"));
            } else this.registerInput(input.name, type);
            Object.defineProperty(this, input.name, {
                get: function() {
                    return this._inputs[index];
                },
                enumerable: true,
                configurable: true
            });
        });
        options.outParameters?.forEach((output, index)=>{
            this.registerOutput(output.name, (0, $3mKw5.NodeMaterialBlockConnectionPointTypes)[output.type]);
            Object.defineProperty(this, output.name, {
                get: function() {
                    return this._outputs[index];
                },
                enumerable: true,
                configurable: true
            });
            if (output.type === "BasedOnInput") this._outputs[index]._typeConnectionSource = this._findInputByName(output.typeFromInput)[0];
        });
        options.inLinkedConnectionTypes?.forEach((connection)=>{
            this._linkConnectionTypes(this._findInputByName(connection.input1)[1], this._findInputByName(connection.input2)[1]);
        });
    }
    _findInputByName(name) {
        if (!name) return null;
        for(let i = 0; i < this._inputs.length; i++){
            if (this._inputs[i].name === name) return [
                this._inputs[i],
                i
            ];
        }
        return null;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.CustomBlock", $c46b79e8a6eaee00$export$50a6a2d597e669c);

});

parcelRegister("cgDd4", function(module, exports) {

$parcel$export(module.exports, "DotBlock", () => $8ee564ea7cb963b7$export$18781f8d59bfc501);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $8ee564ea7cb963b7$export$18781f8d59bfc501 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new DotBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("left", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerInput("right", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this._linkConnectionTypes(0, 1);
        this._inputs[0].excludedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this._inputs[0].excludedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix);
        this._inputs[1].excludedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this._inputs[1].excludedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "DotBlock";
    }
    /**
     * Gets the left operand input component
     */ get left() {
        return this._inputs[0];
    }
    /**
     * Gets the right operand input component
     */ get right() {
        return this._inputs[1];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        state.compilationString += this._declareOutput(output, state) + ` = dot(${this.left.associatedVariableName}, ${this.right.associatedVariableName});\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.DotBlock", $8ee564ea7cb963b7$export$18781f8d59bfc501);

});

parcelRegister("dvbrd", function(module, exports) {

$parcel$export(module.exports, "NormalizeBlock", () => $9d470af4a2336cec$export$fcb276d9af2f3372);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $9d470af4a2336cec$export$fcb276d9af2f3372 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new NormalizeBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("input", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
        this._inputs[0].excludedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this._inputs[0].excludedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "NormalizeBlock";
    }
    /**
     * Gets the input component
     */ get input() {
        return this._inputs[0];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        const input = this._inputs[0];
        state.compilationString += this._declareOutput(output, state) + ` = normalize(${input.associatedVariableName});\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.NormalizeBlock", $9d470af4a2336cec$export$fcb276d9af2f3372);

});

parcelRegister("5t5lc", function(module, exports) {

$parcel$export(module.exports, "ColorMergerBlock", () => $3fb3cdc2dad0c408$export$7f119027736b3a35);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $3fb3cdc2dad0c408$export$7f119027736b3a35 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Create a new ColorMergerBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        /**
         * Gets or sets the swizzle for r (meaning which component to affect to the output.r)
         */ this.rSwizzle = "r";
        /**
         * Gets or sets the swizzle for g (meaning which component to affect to the output.g)
         */ this.gSwizzle = "g";
        /**
         * Gets or sets the swizzle for b (meaning which component to affect to the output.b)
         */ this.bSwizzle = "b";
        /**
         * Gets or sets the swizzle for a (meaning which component to affect to the output.a)
         */ this.aSwizzle = "a";
        this.registerInput("rgb ", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3, true);
        this.registerInput("r", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true);
        this.registerInput("g", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true);
        this.registerInput("b", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true);
        this.registerInput("a", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true);
        this.registerOutput("rgba", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4);
        this.registerOutput("rgb", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "ColorMergerBlock";
    }
    /**
     * Gets the rgb component (input)
     */ get rgbIn() {
        return this._inputs[0];
    }
    /**
     * Gets the r component (input)
     */ get r() {
        return this._inputs[1];
    }
    /**
     * Gets the g component (input)
     */ get g() {
        return this._inputs[2];
    }
    /**
     * Gets the b component (input)
     */ get b() {
        return this._inputs[3];
    }
    /**
     * Gets the a component (input)
     */ get a() {
        return this._inputs[4];
    }
    /**
     * Gets the rgba component (output)
     */ get rgba() {
        return this._outputs[0];
    }
    /**
     * Gets the rgb component (output)
     */ get rgbOut() {
        return this._outputs[1];
    }
    /**
     * Gets the rgb component (output)
     * @deprecated Please use rgbOut instead.
     */ get rgb() {
        return this.rgbOut;
    }
    _inputRename(name) {
        if (name === "rgb ") return "rgbIn";
        return name;
    }
    _buildSwizzle(len) {
        const swizzle = this.rSwizzle + this.gSwizzle + this.bSwizzle + this.aSwizzle;
        return "." + swizzle.substr(0, len);
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const rInput = this.r;
        const gInput = this.g;
        const bInput = this.b;
        const aInput = this.a;
        const rgbInput = this.rgbIn;
        const color4Output = this._outputs[0];
        const color3Output = this._outputs[1];
        if (rgbInput.isConnected) {
            if (color4Output.hasEndpoints) state.compilationString += this._declareOutput(color4Output, state) + ` = vec4(${rgbInput.associatedVariableName}, ${aInput.isConnected ? this._writeVariable(aInput) : "0.0"})${this._buildSwizzle(4)};\n`;
            if (color3Output.hasEndpoints) state.compilationString += this._declareOutput(color3Output, state) + ` = ${rgbInput.associatedVariableName}${this._buildSwizzle(3)};\n`;
        } else {
            if (color4Output.hasEndpoints) state.compilationString += this._declareOutput(color4Output, state) + ` = vec4(${rInput.isConnected ? this._writeVariable(rInput) : "0.0"}, ${gInput.isConnected ? this._writeVariable(gInput) : "0.0"}, ${bInput.isConnected ? this._writeVariable(bInput) : "0.0"}, ${aInput.isConnected ? this._writeVariable(aInput) : "0.0"})${this._buildSwizzle(4)};\n`;
            if (color3Output.hasEndpoints) state.compilationString += this._declareOutput(color3Output, state) + ` = vec3(${rInput.isConnected ? this._writeVariable(rInput) : "0.0"}, ${gInput.isConnected ? this._writeVariable(gInput) : "0.0"}, ${bInput.isConnected ? this._writeVariable(bInput) : "0.0"})${this._buildSwizzle(3)};\n`;
        }
        return this;
    }
    serialize() {
        const serializationObject = super.serialize();
        serializationObject.rSwizzle = this.rSwizzle;
        serializationObject.gSwizzle = this.gSwizzle;
        serializationObject.bSwizzle = this.bSwizzle;
        serializationObject.aSwizzle = this.aSwizzle;
        return serializationObject;
    }
    _deserialize(serializationObject, scene, rootUrl) {
        super._deserialize(serializationObject, scene, rootUrl);
        this.rSwizzle = serializationObject.rSwizzle ?? "r";
        this.gSwizzle = serializationObject.gSwizzle ?? "g";
        this.bSwizzle = serializationObject.bSwizzle ?? "b";
        this.aSwizzle = serializationObject.aSwizzle ?? "a";
    }
    _dumpPropertiesCode() {
        let codeString = super._dumpPropertiesCode();
        codeString += `${this._codeVariableName}.rSwizzle = "${this.rSwizzle}";\n`;
        codeString += `${this._codeVariableName}.gSwizzle = "${this.gSwizzle}";\n`;
        codeString += `${this._codeVariableName}.bSwizzle = "${this.bSwizzle}";\n`;
        codeString += `${this._codeVariableName}.aSwizzle = "${this.aSwizzle}";\n`;
        return codeString;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.ColorMergerBlock", $3fb3cdc2dad0c408$export$7f119027736b3a35);

});

parcelRegister("3fRZu", function(module, exports) {

$parcel$export(module.exports, "VectorSplitterBlock", () => $25eca73b33b8b194$export$3ab434ead032fa11);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $25eca73b33b8b194$export$3ab434ead032fa11 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Create a new VectorSplitterBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("xyzw", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4, true);
        this.registerInput("xyz ", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3, true);
        this.registerInput("xy ", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2, true);
        this.registerOutput("xyz", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3);
        this.registerOutput("xy", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2);
        this.registerOutput("zw", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2);
        this.registerOutput("x", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.registerOutput("y", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.registerOutput("z", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.registerOutput("w", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.inputsAreExclusive = true;
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "VectorSplitterBlock";
    }
    /**
     * Gets the xyzw component (input)
     */ get xyzw() {
        return this._inputs[0];
    }
    /**
     * Gets the xyz component (input)
     */ get xyzIn() {
        return this._inputs[1];
    }
    /**
     * Gets the xy component (input)
     */ get xyIn() {
        return this._inputs[2];
    }
    /**
     * Gets the xyz component (output)
     */ get xyzOut() {
        return this._outputs[0];
    }
    /**
     * Gets the xy component (output)
     */ get xyOut() {
        return this._outputs[1];
    }
    /**
     * Gets the zw component (output)
     */ get zw() {
        return this._outputs[2];
    }
    /**
     * Gets the x component (output)
     */ get x() {
        return this._outputs[3];
    }
    /**
     * Gets the y component (output)
     */ get y() {
        return this._outputs[4];
    }
    /**
     * Gets the z component (output)
     */ get z() {
        return this._outputs[5];
    }
    /**
     * Gets the w component (output)
     */ get w() {
        return this._outputs[6];
    }
    _inputRename(name) {
        switch(name){
            case "xy ":
                return "xyIn";
            case "xyz ":
                return "xyzIn";
            default:
                return name;
        }
    }
    _outputRename(name) {
        switch(name){
            case "xy":
                return "xyOut";
            case "xyz":
                return "xyzOut";
            default:
                return name;
        }
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const input = this.xyzw.isConnected ? this.xyzw : this.xyzIn.isConnected ? this.xyzIn : this.xyIn;
        const xyzOutput = this._outputs[0];
        const xyOutput = this._outputs[1];
        const zwOutput = this._outputs[2];
        const xOutput = this._outputs[3];
        const yOutput = this._outputs[4];
        const zOutput = this._outputs[5];
        const wOutput = this._outputs[6];
        if (xyzOutput.hasEndpoints) {
            if (input === this.xyIn) state.compilationString += this._declareOutput(xyzOutput, state) + ` = vec3(${input.associatedVariableName}, 0.0);\n`;
            else state.compilationString += this._declareOutput(xyzOutput, state) + ` = ${input.associatedVariableName}.xyz;\n`;
        }
        if (zwOutput.hasEndpoints && this.xyzw.isConnected) state.compilationString += this._declareOutput(zwOutput, state) + ` = ${this.xyzw.associatedVariableName}.zw;\n`;
        if (xyOutput.hasEndpoints) state.compilationString += this._declareOutput(xyOutput, state) + ` = ${input.associatedVariableName}.xy;\n`;
        if (xOutput.hasEndpoints) state.compilationString += this._declareOutput(xOutput, state) + ` = ${input.associatedVariableName}.x;\n`;
        if (yOutput.hasEndpoints) state.compilationString += this._declareOutput(yOutput, state) + ` = ${input.associatedVariableName}.y;\n`;
        if (zOutput.hasEndpoints) state.compilationString += this._declareOutput(zOutput, state) + ` = ${input.associatedVariableName}.z;\n`;
        if (wOutput.hasEndpoints) state.compilationString += this._declareOutput(wOutput, state) + ` = ${input.associatedVariableName}.w;\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.VectorSplitterBlock", $25eca73b33b8b194$export$3ab434ead032fa11);

});

parcelRegister("go8IL", function(module, exports) {

$parcel$export(module.exports, "LerpBlock", () => $bee5a7053bb008d1$export$32e6ec9abd68b4aa);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $bee5a7053bb008d1$export$32e6ec9abd68b4aa extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new LerpBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("left", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerInput("right", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerInput("gradient", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
        this._linkConnectionTypes(0, 1);
        this._linkConnectionTypes(1, 2, true);
        this._inputs[2].acceptedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "LerpBlock";
    }
    /**
     * Gets the left operand input component
     */ get left() {
        return this._inputs[0];
    }
    /**
     * Gets the right operand input component
     */ get right() {
        return this._inputs[1];
    }
    /**
     * Gets the gradient operand input component
     */ get gradient() {
        return this._inputs[2];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        state.compilationString += this._declareOutput(output, state) + ` = mix(${this.left.associatedVariableName} , ${this.right.associatedVariableName}, ${this.gradient.associatedVariableName});\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.LerpBlock", $bee5a7053bb008d1$export$32e6ec9abd68b4aa);

});

parcelRegister("bDLPt", function(module, exports) {

$parcel$export(module.exports, "DivideBlock", () => $8798701a92e2c4ab$export$5bb0709cb2f5f63c);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $8798701a92e2c4ab$export$5bb0709cb2f5f63c extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new DivideBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("left", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerInput("right", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
        this._linkConnectionTypes(0, 1, true);
        this._inputs[0].acceptedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this._inputs[1].acceptedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "DivideBlock";
    }
    /**
     * Gets the left operand input component
     */ get left() {
        return this._inputs[0];
    }
    /**
     * Gets the right operand input component
     */ get right() {
        return this._inputs[1];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        state.compilationString += this._declareOutput(output, state) + ` = ${this.left.associatedVariableName} / ${this.right.associatedVariableName};\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.DivideBlock", $8798701a92e2c4ab$export$5bb0709cb2f5f63c);

});

parcelRegister("lbEYX", function(module, exports) {

$parcel$export(module.exports, "SubtractBlock", () => $f6ca6a49726b6a81$export$21a56450ad9dc301);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $f6ca6a49726b6a81$export$21a56450ad9dc301 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new SubtractBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("left", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerInput("right", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
        this._linkConnectionTypes(0, 1, true);
        this._inputs[0].acceptedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this._inputs[1].acceptedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "SubtractBlock";
    }
    /**
     * Gets the left operand input component
     */ get left() {
        return this._inputs[0];
    }
    /**
     * Gets the right operand input component
     */ get right() {
        return this._inputs[1];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        state.compilationString += this._declareOutput(output, state) + ` = ${this.left.associatedVariableName} - ${this.right.associatedVariableName};\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.SubtractBlock", $f6ca6a49726b6a81$export$21a56450ad9dc301);

});

parcelRegister("1RMzf", function(module, exports) {

$parcel$export(module.exports, "StepBlock", () => $15c06a2ac121e88c$export$9ce4e278f91c1140);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $15c06a2ac121e88c$export$9ce4e278f91c1140 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new StepBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("value", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.registerInput("edge", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "StepBlock";
    }
    /**
     * Gets the value operand input component
     */ get value() {
        return this._inputs[0];
    }
    /**
     * Gets the edge operand input component
     */ get edge() {
        return this._inputs[1];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        state.compilationString += this._declareOutput(output, state) + ` = step(${this.edge.associatedVariableName}, ${this.value.associatedVariableName});\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.StepBlock", $15c06a2ac121e88c$export$9ce4e278f91c1140);

});

parcelRegister("kJdlu", function(module, exports) {

$parcel$export(module.exports, "OneMinusBlock", () => $f1725cc537f80ae9$export$189797420721277);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $f1725cc537f80ae9$export$189797420721277 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new OneMinusBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("input", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
        this._outputs[0].excludedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "OneMinusBlock";
    }
    /**
     * Gets the input component
     */ get input() {
        return this._inputs[0];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        state.compilationString += this._declareOutput(output, state) + ` = 1. - ${this.input.associatedVariableName};\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.OneMinusBlock", $f1725cc537f80ae9$export$189797420721277);
(0, $8DoUR.RegisterClass)("BABYLON.OppositeBlock", $f1725cc537f80ae9$export$189797420721277); // Backward compatibility

});

parcelRegister("j6itU", function(module, exports) {

$parcel$export(module.exports, "ViewDirectionBlock", () => $de7ce9e22f1be6aa$export$ada4cf91e831775b);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");

var $7qH6c = parcelRequire("7qH6c");

var $aKEh2 = parcelRequire("aKEh2");
class $de7ce9e22f1be6aa$export$ada4cf91e831775b extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new ViewDirectionBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("worldPosition", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4);
        this.registerInput("cameraPosition", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "ViewDirectionBlock";
    }
    /**
     * Gets the world position component
     */ get worldPosition() {
        return this._inputs[0];
    }
    /**
     * Gets the camera position component
     */ get cameraPosition() {
        return this._inputs[1];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    autoConfigure(material, additionalFilteringInfo = ()=>true) {
        if (!this.cameraPosition.isConnected) {
            let cameraPositionInput = material.getInputBlockByPredicate((b)=>b.systemValue === (0, $7qH6c.NodeMaterialSystemValues).CameraPosition && additionalFilteringInfo(b));
            if (!cameraPositionInput) {
                cameraPositionInput = new (0, $aKEh2.InputBlock)("cameraPosition");
                cameraPositionInput.setAsSystemValue((0, $7qH6c.NodeMaterialSystemValues).CameraPosition);
            }
            cameraPositionInput.output.connectTo(this.cameraPosition);
        }
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        state.compilationString += this._declareOutput(output, state) + ` = normalize(${this.cameraPosition.associatedVariableName} - ${this.worldPosition.associatedVariableName}.xyz);\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.ViewDirectionBlock", $de7ce9e22f1be6aa$export$ada4cf91e831775b);

});

parcelRegister("lfnp6", function(module, exports) {

$parcel$export(module.exports, "FresnelBlock", () => $f77d2734963c4ea2$export$d2feeeeefcd95478);

var $kpKE2 = parcelRequire("kpKE2");

var $iAIIe = parcelRequire("iAIIe");

var $3mKw5 = parcelRequire("3mKw5");

var $8DoUR = parcelRequire("8DoUR");

var $aKEh2 = parcelRequire("aKEh2");
parcelRequire("6zQZ5");

var $j6itU = parcelRequire("j6itU");
class $f77d2734963c4ea2$export$d2feeeeefcd95478 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Create a new FresnelBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("worldNormal", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4);
        this.registerInput("viewDirection", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3);
        this.registerInput("bias", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.registerInput("power", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.registerOutput("fresnel", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "FresnelBlock";
    }
    /**
     * Gets the world normal input component
     */ get worldNormal() {
        return this._inputs[0];
    }
    /**
     * Gets the view direction input component
     */ get viewDirection() {
        return this._inputs[1];
    }
    /**
     * Gets the bias input component
     */ get bias() {
        return this._inputs[2];
    }
    /**
     * Gets the camera (or eye) position component
     */ get power() {
        return this._inputs[3];
    }
    /**
     * Gets the fresnel output component
     */ get fresnel() {
        return this._outputs[0];
    }
    autoConfigure(material) {
        if (!this.viewDirection.isConnected) {
            const viewDirectionInput = new (0, $j6itU.ViewDirectionBlock)("View direction");
            viewDirectionInput.output.connectTo(this.viewDirection);
            viewDirectionInput.autoConfigure(material);
        }
        if (!this.bias.isConnected) {
            const biasInput = new (0, $aKEh2.InputBlock)("bias");
            biasInput.value = 0;
            biasInput.output.connectTo(this.bias);
        }
        if (!this.power.isConnected) {
            const powerInput = new (0, $aKEh2.InputBlock)("power");
            powerInput.value = 1;
            powerInput.output.connectTo(this.power);
        }
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const comments = `//${this.name}`;
        state._emitFunctionFromInclude("fresnelFunction", comments, {
            removeIfDef: true
        });
        state.compilationString += this._declareOutput(this.fresnel, state) + ` = computeFresnelTerm(${this.viewDirection.associatedVariableName}.xyz, ${this.worldNormal.associatedVariableName}.xyz, ${this.bias.associatedVariableName}, ${this.power.associatedVariableName});\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.FresnelBlock", $f77d2734963c4ea2$export$d2feeeeefcd95478);

});

parcelRegister("lPuXp", function(module, exports) {

$parcel$export(module.exports, "MaxBlock", () => $fe465fd40d6f9889$export$a3085738539b0ea2);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $fe465fd40d6f9889$export$a3085738539b0ea2 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new MaxBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("left", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerInput("right", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
        this._linkConnectionTypes(0, 1);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "MaxBlock";
    }
    /**
     * Gets the left operand input component
     */ get left() {
        return this._inputs[0];
    }
    /**
     * Gets the right operand input component
     */ get right() {
        return this._inputs[1];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        state.compilationString += this._declareOutput(output, state) + ` = max(${this.left.associatedVariableName}, ${this.right.associatedVariableName});\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.MaxBlock", $fe465fd40d6f9889$export$a3085738539b0ea2);

});

parcelRegister("6ibKD", function(module, exports) {

$parcel$export(module.exports, "MinBlock", () => $494d8a10a4da86ac$export$446f4e2aa62bb3c2);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $494d8a10a4da86ac$export$446f4e2aa62bb3c2 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new MinBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("left", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerInput("right", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
        this._linkConnectionTypes(0, 1);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "MinBlock";
    }
    /**
     * Gets the left operand input component
     */ get left() {
        return this._inputs[0];
    }
    /**
     * Gets the right operand input component
     */ get right() {
        return this._inputs[1];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        state.compilationString += this._declareOutput(output, state) + ` = min(${this.left.associatedVariableName}, ${this.right.associatedVariableName});\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.MinBlock", $494d8a10a4da86ac$export$446f4e2aa62bb3c2);

});

parcelRegister("5ENQg", function(module, exports) {

$parcel$export(module.exports, "DistanceBlock", () => $41e759beb559f816$export$f7946e441c36acbc);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $41e759beb559f816$export$f7946e441c36acbc extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new DistanceBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("left", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerInput("right", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this._linkConnectionTypes(0, 1);
        this._inputs[0].excludedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this._inputs[0].excludedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix);
        this._inputs[1].excludedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this._inputs[1].excludedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "DistanceBlock";
    }
    /**
     * Gets the left operand input component
     */ get left() {
        return this._inputs[0];
    }
    /**
     * Gets the right operand input component
     */ get right() {
        return this._inputs[1];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        state.compilationString += this._declareOutput(output, state) + ` = length(${this.left.associatedVariableName} - ${this.right.associatedVariableName});\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.DistanceBlock", $41e759beb559f816$export$f7946e441c36acbc);

});

parcelRegister("lRCx0", function(module, exports) {

$parcel$export(module.exports, "LengthBlock", () => $041b8e3074ddde7e$export$6e57290b48c11588);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $041b8e3074ddde7e$export$6e57290b48c11588 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new LengthBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("value", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this._inputs[0].excludedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this._inputs[0].excludedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "LengthBlock";
    }
    /**
     * Gets the value input component
     */ get value() {
        return this._inputs[0];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        state.compilationString += this._declareOutput(output, state) + ` = length(${this.value.associatedVariableName});\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.LengthBlock", $041b8e3074ddde7e$export$6e57290b48c11588);

});

parcelRegister("l54kk", function(module, exports) {

$parcel$export(module.exports, "NegateBlock", () => $f58d6bcfad92c3db$export$288e455442721bc2);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $f58d6bcfad92c3db$export$288e455442721bc2 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new NegateBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("value", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "NegateBlock";
    }
    /**
     * Gets the value input component
     */ get value() {
        return this._inputs[0];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        state.compilationString += this._declareOutput(output, state) + ` = -1.0 * ${this.value.associatedVariableName};\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.NegateBlock", $f58d6bcfad92c3db$export$288e455442721bc2);

});

parcelRegister("3HImk", function(module, exports) {

$parcel$export(module.exports, "PowBlock", () => $2b27cc07e8a5fdc4$export$537b5397ab861880);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $2b27cc07e8a5fdc4$export$537b5397ab861880 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new PowBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("value", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerInput("power", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
        this._linkConnectionTypes(0, 1);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "PowBlock";
    }
    /**
     * Gets the value operand input component
     */ get value() {
        return this._inputs[0];
    }
    /**
     * Gets the power operand input component
     */ get power() {
        return this._inputs[1];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        state.compilationString += this._declareOutput(output, state) + ` = pow(${this.value.associatedVariableName}, ${this.power.associatedVariableName});\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.PowBlock", $2b27cc07e8a5fdc4$export$537b5397ab861880);

});

parcelRegister("a2z4w", function(module, exports) {

$parcel$export(module.exports, "RandomNumberBlock", () => $74f54bd4d64702fe$export$a3e1cb6072b39421);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
parcelRequire("7Hs3g");
class $74f54bd4d64702fe$export$a3e1cb6072b39421 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new RandomNumberBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("seed", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this._inputs[0].addExcludedConnectionPointFromAllowedTypes((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "RandomNumberBlock";
    }
    /**
     * Gets the seed input component
     */ get seed() {
        return this._inputs[0];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        const comments = `//${this.name}`;
        state._emitFunctionFromInclude("helperFunctions", comments);
        state.compilationString += this._declareOutput(output, state) + ` = getRand(${this.seed.associatedVariableName}.xy);\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.RandomNumberBlock", $74f54bd4d64702fe$export$a3e1cb6072b39421);

});

parcelRegister("rDM9g", function(module, exports) {

$parcel$export(module.exports, "ArcTan2Block", () => $05316055a6a79c9c$export$a493dea3953fd293);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $05316055a6a79c9c$export$a493dea3953fd293 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new ArcTan2Block
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("x", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.registerInput("y", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "ArcTan2Block";
    }
    /**
     * Gets the x operand input component
     */ get x() {
        return this._inputs[0];
    }
    /**
     * Gets the y operand input component
     */ get y() {
        return this._inputs[1];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        state.compilationString += this._declareOutput(output, state) + ` = atan(${this.x.associatedVariableName}, ${this.y.associatedVariableName});\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.ArcTan2Block", $05316055a6a79c9c$export$a493dea3953fd293);

});

parcelRegister("aZdrO", function(module, exports) {

$parcel$export(module.exports, "SmoothStepBlock", () => $7ffa084fe79b1ee8$export$e4ffb306c5d6f949);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $7ffa084fe79b1ee8$export$e4ffb306c5d6f949 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new SmoothStepBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("value", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerInput("edge0", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.registerInput("edge1", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "SmoothStepBlock";
    }
    /**
     * Gets the value operand input component
     */ get value() {
        return this._inputs[0];
    }
    /**
     * Gets the first edge operand input component
     */ get edge0() {
        return this._inputs[1];
    }
    /**
     * Gets the second edge operand input component
     */ get edge1() {
        return this._inputs[2];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        state.compilationString += this._declareOutput(output, state) + ` = smoothstep(${this.edge0.associatedVariableName}, ${this.edge1.associatedVariableName}, ${this.value.associatedVariableName});\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.SmoothStepBlock", $7ffa084fe79b1ee8$export$e4ffb306c5d6f949);

});

parcelRegister("11SLn", function(module, exports) {

$parcel$export(module.exports, "ReciprocalBlock", () => $0c005d3c8a3deef6$export$1073cc262e8868e5);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $0c005d3c8a3deef6$export$1073cc262e8868e5 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new ReciprocalBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("input", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "ReciprocalBlock";
    }
    /**
     * Gets the input component
     */ get input() {
        return this._inputs[0];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        if (this.input.type === (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix) state.compilationString += this._declareOutput(output, state) + ` = inverse(${this.input.associatedVariableName});\n`;
        else state.compilationString += this._declareOutput(output, state) + ` = 1. / ${this.input.associatedVariableName};\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.ReciprocalBlock", $0c005d3c8a3deef6$export$1073cc262e8868e5);

});

parcelRegister("iqn1M", function(module, exports) {

$parcel$export(module.exports, "ReplaceColorBlock", () => $d69c848b6dfeb95b$export$744ff6e2ae65a2e4);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $d69c848b6dfeb95b$export$744ff6e2ae65a2e4 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new ReplaceColorBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("value", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerInput("reference", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerInput("distance", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.registerInput("replacement", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
        this._linkConnectionTypes(0, 1);
        this._linkConnectionTypes(0, 3);
        this._inputs[0].excludedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this._inputs[0].excludedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix);
        this._inputs[1].excludedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this._inputs[1].excludedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix);
        this._inputs[3].excludedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this._inputs[3].excludedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "ReplaceColorBlock";
    }
    /**
     * Gets the value input component
     */ get value() {
        return this._inputs[0];
    }
    /**
     * Gets the reference input component
     */ get reference() {
        return this._inputs[1];
    }
    /**
     * Gets the distance input component
     */ get distance() {
        return this._inputs[2];
    }
    /**
     * Gets the replacement input component
     */ get replacement() {
        return this._inputs[3];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        state.compilationString += this._declareOutput(output, state) + `;\n`;
        state.compilationString += `if (length(${this.value.associatedVariableName} - ${this.reference.associatedVariableName}) < ${this.distance.associatedVariableName}) {\n`;
        state.compilationString += `${output.associatedVariableName} = ${this.replacement.associatedVariableName};\n`;
        state.compilationString += `} else {\n`;
        state.compilationString += `${output.associatedVariableName} = ${this.value.associatedVariableName};\n`;
        state.compilationString += `}\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.ReplaceColorBlock", $d69c848b6dfeb95b$export$744ff6e2ae65a2e4);

});

parcelRegister("8CfhV", function(module, exports) {

$parcel$export(module.exports, "PosterizeBlock", () => $645dbb3958596a16$export$d49b72203b7072cc);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $645dbb3958596a16$export$d49b72203b7072cc extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new PosterizeBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("value", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerInput("steps", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
        this._linkConnectionTypes(0, 1);
        this._inputs[0].excludedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix);
        this._inputs[1].excludedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix);
        this._inputs[1].acceptedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "PosterizeBlock";
    }
    /**
     * Gets the value input component
     */ get value() {
        return this._inputs[0];
    }
    /**
     * Gets the steps input component
     */ get steps() {
        return this._inputs[1];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        state.compilationString += this._declareOutput(output, state) + ` = floor(${this.value.associatedVariableName} / (1.0 / ${this.steps.associatedVariableName})) * (1.0 / ${this.steps.associatedVariableName});\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.PosterizeBlock", $645dbb3958596a16$export$d49b72203b7072cc);

});

parcelRegister("GWBLc", function(module, exports) {

$parcel$export(module.exports, "WaveBlockKind", () => $081162b191e45e1a$export$6ab68f2686a694c4);
$parcel$export(module.exports, "WaveBlock", () => $081162b191e45e1a$export$64dffa0a505252a3);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
var $081162b191e45e1a$export$6ab68f2686a694c4;
(function(WaveBlockKind) {
    /** SawTooth */ WaveBlockKind[WaveBlockKind["SawTooth"] = 0] = "SawTooth";
    /** Square */ WaveBlockKind[WaveBlockKind["Square"] = 1] = "Square";
    /** Triangle */ WaveBlockKind[WaveBlockKind["Triangle"] = 2] = "Triangle";
})($081162b191e45e1a$export$6ab68f2686a694c4 || ($081162b191e45e1a$export$6ab68f2686a694c4 = {}));
class $081162b191e45e1a$export$64dffa0a505252a3 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new WaveBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        /**
         * Gets or sets the kibnd of wave to be applied by the block
         */ this.kind = $081162b191e45e1a$export$6ab68f2686a694c4.SawTooth;
        this.registerInput("input", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
        this._inputs[0].excludedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "WaveBlock";
    }
    /**
     * Gets the input component
     */ get input() {
        return this._inputs[0];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        switch(this.kind){
            case $081162b191e45e1a$export$6ab68f2686a694c4.SawTooth:
                state.compilationString += this._declareOutput(output, state) + ` = ${this.input.associatedVariableName} - floor(0.5 + ${this.input.associatedVariableName});\n`;
                break;
            case $081162b191e45e1a$export$6ab68f2686a694c4.Square:
                state.compilationString += this._declareOutput(output, state) + ` = 1.0 - 2.0 * round(fract(${this.input.associatedVariableName}));\n`;
                break;
            case $081162b191e45e1a$export$6ab68f2686a694c4.Triangle:
                state.compilationString += this._declareOutput(output, state) + ` = 2.0 * abs(2.0 * (${this.input.associatedVariableName} - floor(0.5 + ${this.input.associatedVariableName}))) - 1.0;\n`;
                break;
        }
        return this;
    }
    serialize() {
        const serializationObject = super.serialize();
        serializationObject.kind = this.kind;
        return serializationObject;
    }
    _deserialize(serializationObject, scene, rootUrl) {
        super._deserialize(serializationObject, scene, rootUrl);
        this.kind = serializationObject.kind;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.WaveBlock", $081162b191e45e1a$export$64dffa0a505252a3);

});

parcelRegister("jR0O5", function(module, exports) {

$parcel$export(module.exports, "GradientBlockColorStep", () => $e74397c95bdeadd1$export$c471a40f1a5d59cb);
$parcel$export(module.exports, "GradientBlock", () => $e74397c95bdeadd1$export$26399f8503e67c0e);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");

var $7etnY = parcelRequire("7etnY");

var $diGQf = parcelRequire("diGQf");
class $e74397c95bdeadd1$export$c471a40f1a5d59cb {
    /**
     * Gets value indicating which step this color is associated with (between 0 and 1)
     */ get step() {
        return this._step;
    }
    /**
     * Sets a value indicating which step this color is associated with (between 0 and 1)
     */ set step(val) {
        this._step = val;
    }
    /**
     * Gets the color associated with this step
     */ get color() {
        return this._color;
    }
    /**
     * Sets the color associated with this step
     */ set color(val) {
        this._color = val;
    }
    /**
     * Creates a new GradientBlockColorStep
     * @param step defines a value indicating which step this color is associated with (between 0 and 1)
     * @param color defines the color associated with this step
     */ constructor(step, color){
        this.step = step;
        this.color = color;
    }
}
class $e74397c95bdeadd1$export$26399f8503e67c0e extends (0, $kpKE2.NodeMaterialBlock) {
    /** calls observable when the value is changed*/ colorStepsUpdated() {
        this.onValueChangedObservable.notifyObservers(this);
    }
    /**
     * Creates a new GradientBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        /**
         * Gets or sets the list of color steps
         */ this.colorSteps = [
            new $e74397c95bdeadd1$export$c471a40f1a5d59cb(0, (0, $7etnY.Color3).Black()),
            new $e74397c95bdeadd1$export$c471a40f1a5d59cb(1.0, (0, $7etnY.Color3).White())
        ];
        /** Gets an observable raised when the value is changed */ this.onValueChangedObservable = new (0, $diGQf.Observable)();
        this.registerInput("gradient", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3);
        this._inputs[0].addExcludedConnectionPointFromAllowedTypes((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "GradientBlock";
    }
    /**
     * Gets the gradient input component
     */ get gradient() {
        return this._inputs[0];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _writeColorConstant(index) {
        const step = this.colorSteps[index];
        return `vec3(${step.color.r}, ${step.color.g}, ${step.color.b})`;
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        if (!this.colorSteps.length || !this.gradient.connectedPoint) {
            state.compilationString += this._declareOutput(output, state) + ` = vec3(0., 0., 0.);\n`;
            return;
        }
        const tempColor = state._getFreeVariableName("gradientTempColor");
        const tempPosition = state._getFreeVariableName("gradientTempPosition");
        state.compilationString += `vec3 ${tempColor} = ${this._writeColorConstant(0)};\n`;
        state.compilationString += `float ${tempPosition};\n`;
        let gradientSource = this.gradient.associatedVariableName;
        if (this.gradient.connectedPoint.type !== (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float) gradientSource += ".x";
        for(let index = 1; index < this.colorSteps.length; index++){
            const step = this.colorSteps[index];
            const previousStep = this.colorSteps[index - 1];
            state.compilationString += `${tempPosition} = clamp((${gradientSource} - ${state._emitFloat(previousStep.step)}) / (${state._emitFloat(step.step)} -  ${state._emitFloat(previousStep.step)}), 0.0, 1.0) * step(${state._emitFloat(index)}, ${state._emitFloat(this.colorSteps.length - 1)});\n`;
            state.compilationString += `${tempColor} = mix(${tempColor}, ${this._writeColorConstant(index)}, ${tempPosition});\n`;
        }
        state.compilationString += this._declareOutput(output, state) + ` = ${tempColor};\n`;
        return this;
    }
    serialize() {
        const serializationObject = super.serialize();
        serializationObject.colorSteps = [];
        for (const step of this.colorSteps)serializationObject.colorSteps.push({
            step: step.step,
            color: {
                r: step.color.r,
                g: step.color.g,
                b: step.color.b
            }
        });
        return serializationObject;
    }
    _deserialize(serializationObject, scene, rootUrl) {
        super._deserialize(serializationObject, scene, rootUrl);
        this.colorSteps.length = 0;
        for (const step of serializationObject.colorSteps)this.colorSteps.push(new $e74397c95bdeadd1$export$c471a40f1a5d59cb(step.step, new (0, $7etnY.Color3)(step.color.r, step.color.g, step.color.b)));
    }
    _dumpPropertiesCode() {
        let codeString = super._dumpPropertiesCode();
        codeString += `${this._codeVariableName}.colorSteps = [];\n`;
        for (const colorStep of this.colorSteps)codeString += `${this._codeVariableName}.colorSteps.push(new BABYLON.GradientBlockColorStep(${colorStep.step}, new BABYLON.Color3(${colorStep.color.r}, ${colorStep.color.g}, ${colorStep.color.b})));\n`;
        return codeString;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.GradientBlock", $e74397c95bdeadd1$export$26399f8503e67c0e);

});

parcelRegister("apJef", function(module, exports) {

$parcel$export(module.exports, "NLerpBlock", () => $794f52a7b30e0584$export$8a3a29e49eaef2c2);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $794f52a7b30e0584$export$8a3a29e49eaef2c2 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new NLerpBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("left", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerInput("right", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerInput("gradient", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
        this._linkConnectionTypes(0, 1);
        this._linkConnectionTypes(1, 2, true);
        this._inputs[2].acceptedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "NLerpBlock";
    }
    /**
     * Gets the left operand input component
     */ get left() {
        return this._inputs[0];
    }
    /**
     * Gets the right operand input component
     */ get right() {
        return this._inputs[1];
    }
    /**
     * Gets the gradient operand input component
     */ get gradient() {
        return this._inputs[2];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        state.compilationString += this._declareOutput(output, state) + ` = normalize(mix(${this.left.associatedVariableName} , ${this.right.associatedVariableName}, ${this.gradient.associatedVariableName}));\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.NLerpBlock", $794f52a7b30e0584$export$8a3a29e49eaef2c2);

});

parcelRegister("44zvG", function(module, exports) {

$parcel$export(module.exports, "WorleyNoise3DBlock", () => $2f7314b021ae64f7$export$1199b01f96baf167);

var $e0Suo = parcelRequire("e0Suo");

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");

var $1aXVF = parcelRequire("1aXVF");
class $2f7314b021ae64f7$export$1199b01f96baf167 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new WorleyNoise3DBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        /** Gets or sets a boolean indicating that normal should be inverted on X axis */ this.manhattanDistance = false;
        this.registerInput("seed", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3);
        this.registerInput("jitter", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2);
        this.registerOutput("x", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.registerOutput("y", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "WorleyNoise3DBlock";
    }
    /**
     * Gets the seed input component
     */ get seed() {
        return this._inputs[0];
    }
    /**
     * Gets the jitter input component
     */ get jitter() {
        return this._inputs[1];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    /**
     * Gets the x component
     */ get x() {
        return this._outputs[1];
    }
    /**
     * Gets the y component
     */ get y() {
        return this._outputs[2];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        if (!this.seed.isConnected) return;
        if (!this.output.hasEndpoints && !this.x.hasEndpoints && !this.y.hasEndpoints) return;
        let functionString = `vec3 permute(vec3 x){\n`;
        functionString += `    return mod((34.0 * x + 1.0) * x, 289.0);\n`;
        functionString += `}\n\n`;
        functionString += `vec3 dist(vec3 x, vec3 y, vec3 z,  bool manhattanDistance){\n`;
        functionString += `    return manhattanDistance ?  abs(x) + abs(y) + abs(z) :  (x * x + y * y + z * z);\n`;
        functionString += `}\n\n`;
        functionString += `vec2 worley(vec3 P, float jitter, bool manhattanDistance){\n`;
        functionString += `    float K = 0.142857142857; // 1/7\n`;
        functionString += `    float Ko = 0.428571428571; // 1/2-K/2\n`;
        functionString += `    float  K2 = 0.020408163265306; // 1/(7*7)\n`;
        functionString += `    float Kz = 0.166666666667; // 1/6\n`;
        functionString += `    float Kzo = 0.416666666667; // 1/2-1/6*2\n`;
        functionString += `\n`;
        functionString += `    vec3 Pi = mod(floor(P), 289.0);\n`;
        functionString += `    vec3 Pf = fract(P) - 0.5;\n`;
        functionString += `\n`;
        functionString += `    vec3 Pfx = Pf.x + vec3(1.0, 0.0, -1.0);\n`;
        functionString += `    vec3 Pfy = Pf.y + vec3(1.0, 0.0, -1.0);\n`;
        functionString += `    vec3 Pfz = Pf.z + vec3(1.0, 0.0, -1.0);\n`;
        functionString += `\n`;
        functionString += `    vec3 p = permute(Pi.x + vec3(-1.0, 0.0, 1.0));\n`;
        functionString += `    vec3 p1 = permute(p + Pi.y - 1.0);\n`;
        functionString += `    vec3 p2 = permute(p + Pi.y);\n`;
        functionString += `    vec3 p3 = permute(p + Pi.y + 1.0);\n`;
        functionString += `\n`;
        functionString += `    vec3 p11 = permute(p1 + Pi.z - 1.0);\n`;
        functionString += `    vec3 p12 = permute(p1 + Pi.z);\n`;
        functionString += `    vec3 p13 = permute(p1 + Pi.z + 1.0);\n`;
        functionString += `\n`;
        functionString += `    vec3 p21 = permute(p2 + Pi.z - 1.0);\n`;
        functionString += `    vec3 p22 = permute(p2 + Pi.z);\n`;
        functionString += `    vec3 p23 = permute(p2 + Pi.z + 1.0);\n`;
        functionString += `\n`;
        functionString += `    vec3 p31 = permute(p3 + Pi.z - 1.0);\n`;
        functionString += `    vec3 p32 = permute(p3 + Pi.z);\n`;
        functionString += `    vec3 p33 = permute(p3 + Pi.z + 1.0);\n`;
        functionString += `\n`;
        functionString += `    vec3 ox11 = fract(p11*K) - Ko;\n`;
        functionString += `    vec3 oy11 = mod(floor(p11*K), 7.0)*K - Ko;\n`;
        functionString += `    vec3 oz11 = floor(p11*K2)*Kz - Kzo; // p11 < 289 guaranteed\n`;
        functionString += `\n`;
        functionString += `    vec3 ox12 = fract(p12*K) - Ko;\n`;
        functionString += `    vec3 oy12 = mod(floor(p12*K), 7.0)*K - Ko;\n`;
        functionString += `    vec3 oz12 = floor(p12*K2)*Kz - Kzo;\n`;
        functionString += `\n`;
        functionString += `    vec3 ox13 = fract(p13*K) - Ko;\n`;
        functionString += `    vec3 oy13 = mod(floor(p13*K), 7.0)*K - Ko;\n`;
        functionString += `    vec3 oz13 = floor(p13*K2)*Kz - Kzo;\n`;
        functionString += `\n`;
        functionString += `    vec3 ox21 = fract(p21*K) - Ko;\n`;
        functionString += `    vec3 oy21 = mod(floor(p21*K), 7.0)*K - Ko;\n`;
        functionString += `    vec3 oz21 = floor(p21*K2)*Kz - Kzo;\n`;
        functionString += `\n`;
        functionString += `    vec3 ox22 = fract(p22*K) - Ko;\n`;
        functionString += `    vec3 oy22 = mod(floor(p22*K), 7.0)*K - Ko;\n`;
        functionString += `    vec3 oz22 = floor(p22*K2)*Kz - Kzo;\n`;
        functionString += `\n`;
        functionString += `    vec3 ox23 = fract(p23*K) - Ko;\n`;
        functionString += `    vec3 oy23 = mod(floor(p23*K), 7.0)*K - Ko;\n`;
        functionString += `    vec3 oz23 = floor(p23*K2)*Kz - Kzo;\n`;
        functionString += `\n`;
        functionString += `    vec3 ox31 = fract(p31*K) - Ko;\n`;
        functionString += `    vec3 oy31 = mod(floor(p31*K), 7.0)*K - Ko;\n`;
        functionString += `    vec3 oz31 = floor(p31*K2)*Kz - Kzo;\n`;
        functionString += `\n`;
        functionString += `    vec3 ox32 = fract(p32*K) - Ko;\n`;
        functionString += `    vec3 oy32 = mod(floor(p32*K), 7.0)*K - Ko;\n`;
        functionString += `    vec3 oz32 = floor(p32*K2)*Kz - Kzo;\n`;
        functionString += `\n`;
        functionString += `    vec3 ox33 = fract(p33*K) - Ko;\n`;
        functionString += `    vec3 oy33 = mod(floor(p33*K), 7.0)*K - Ko;\n`;
        functionString += `    vec3 oz33 = floor(p33*K2)*Kz - Kzo;\n`;
        functionString += `\n`;
        functionString += `    vec3 dx11 = Pfx + jitter*ox11;\n`;
        functionString += `    vec3 dy11 = Pfy.x + jitter*oy11;\n`;
        functionString += `    vec3 dz11 = Pfz.x + jitter*oz11;\n`;
        functionString += `\n`;
        functionString += `    vec3 dx12 = Pfx + jitter*ox12;\n`;
        functionString += `    vec3 dy12 = Pfy.x + jitter*oy12;\n`;
        functionString += `    vec3 dz12 = Pfz.y + jitter*oz12;\n`;
        functionString += `\n`;
        functionString += `    vec3 dx13 = Pfx + jitter*ox13;\n`;
        functionString += `    vec3 dy13 = Pfy.x + jitter*oy13;\n`;
        functionString += `    vec3 dz13 = Pfz.z + jitter*oz13;\n`;
        functionString += `\n`;
        functionString += `    vec3 dx21 = Pfx + jitter*ox21;\n`;
        functionString += `    vec3 dy21 = Pfy.y + jitter*oy21;\n`;
        functionString += `    vec3 dz21 = Pfz.x + jitter*oz21;\n`;
        functionString += `\n`;
        functionString += `    vec3 dx22 = Pfx + jitter*ox22;\n`;
        functionString += `    vec3 dy22 = Pfy.y + jitter*oy22;\n`;
        functionString += `    vec3 dz22 = Pfz.y + jitter*oz22;\n`;
        functionString += `\n`;
        functionString += `    vec3 dx23 = Pfx + jitter*ox23;\n`;
        functionString += `    vec3 dy23 = Pfy.y + jitter*oy23;\n`;
        functionString += `    vec3 dz23 = Pfz.z + jitter*oz23;\n`;
        functionString += `\n`;
        functionString += `    vec3 dx31 = Pfx + jitter*ox31;\n`;
        functionString += `    vec3 dy31 = Pfy.z + jitter*oy31;\n`;
        functionString += `    vec3 dz31 = Pfz.x + jitter*oz31;\n`;
        functionString += `\n`;
        functionString += `    vec3 dx32 = Pfx + jitter*ox32;\n`;
        functionString += `    vec3 dy32 = Pfy.z + jitter*oy32;\n`;
        functionString += `    vec3 dz32 = Pfz.y + jitter*oz32;\n`;
        functionString += `\n`;
        functionString += `    vec3 dx33 = Pfx + jitter*ox33;\n`;
        functionString += `    vec3 dy33 = Pfy.z + jitter*oy33;\n`;
        functionString += `    vec3 dz33 = Pfz.z + jitter*oz33;\n`;
        functionString += `\n`;
        functionString += `    vec3 d11 = dist(dx11, dy11, dz11, manhattanDistance);\n`;
        functionString += `    vec3 d12 =dist(dx12, dy12, dz12, manhattanDistance);\n`;
        functionString += `    vec3 d13 = dist(dx13, dy13, dz13, manhattanDistance);\n`;
        functionString += `    vec3 d21 = dist(dx21, dy21, dz21, manhattanDistance);\n`;
        functionString += `    vec3 d22 = dist(dx22, dy22, dz22, manhattanDistance);\n`;
        functionString += `    vec3 d23 = dist(dx23, dy23, dz23, manhattanDistance);\n`;
        functionString += `    vec3 d31 = dist(dx31, dy31, dz31, manhattanDistance);\n`;
        functionString += `    vec3 d32 = dist(dx32, dy32, dz32, manhattanDistance);\n`;
        functionString += `    vec3 d33 = dist(dx33, dy33, dz33, manhattanDistance);\n`;
        functionString += `\n`;
        functionString += `    vec3 d1a = min(d11, d12);\n`;
        functionString += `    d12 = max(d11, d12);\n`;
        functionString += `    d11 = min(d1a, d13); // Smallest now not in d12 or d13\n`;
        functionString += `    d13 = max(d1a, d13);\n`;
        functionString += `    d12 = min(d12, d13); // 2nd smallest now not in d13\n`;
        functionString += `    vec3 d2a = min(d21, d22);\n`;
        functionString += `    d22 = max(d21, d22);\n`;
        functionString += `    d21 = min(d2a, d23); // Smallest now not in d22 or d23\n`;
        functionString += `    d23 = max(d2a, d23);\n`;
        functionString += `    d22 = min(d22, d23); // 2nd smallest now not in d23\n`;
        functionString += `    vec3 d3a = min(d31, d32);\n`;
        functionString += `    d32 = max(d31, d32);\n`;
        functionString += `    d31 = min(d3a, d33); // Smallest now not in d32 or d33\n`;
        functionString += `    d33 = max(d3a, d33);\n`;
        functionString += `    d32 = min(d32, d33); // 2nd smallest now not in d33\n`;
        functionString += `    vec3 da = min(d11, d21);\n`;
        functionString += `    d21 = max(d11, d21);\n`;
        functionString += `    d11 = min(da, d31); // Smallest now in d11\n`;
        functionString += `    d31 = max(da, d31); // 2nd smallest now not in d31\n`;
        functionString += `    d11.xy = (d11.x < d11.y) ? d11.xy : d11.yx;\n`;
        functionString += `    d11.xz = (d11.x < d11.z) ? d11.xz : d11.zx; // d11.x now smallest\n`;
        functionString += `    d12 = min(d12, d21); // 2nd smallest now not in d21\n`;
        functionString += `    d12 = min(d12, d22); // nor in d22\n`;
        functionString += `    d12 = min(d12, d31); // nor in d31\n`;
        functionString += `    d12 = min(d12, d32); // nor in d32\n`;
        functionString += `    d11.yz = min(d11.yz,d12.xy); // nor in d12.yz\n`;
        functionString += `    d11.y = min(d11.y,d12.z); // Only two more to go\n`;
        functionString += `    d11.y = min(d11.y,d11.z); // Done! (Phew!)\n`;
        functionString += `    return sqrt(d11.xy); // F1, F2\n`;
        functionString += `}\n\n`;
        state._emitFunction("worley3D", functionString, "// Worley3D");
        const tempVariable = state._getFreeVariableName("worleyTemp");
        state.compilationString += `vec2 ${tempVariable} = worley(${this.seed.associatedVariableName}, ${this.jitter.associatedVariableName}, ${this.manhattanDistance});\n`;
        if (this.output.hasEndpoints) state.compilationString += this._declareOutput(this.output, state) + ` = ${tempVariable};\n`;
        if (this.x.hasEndpoints) state.compilationString += this._declareOutput(this.x, state) + ` = ${tempVariable}.x;\n`;
        if (this.y.hasEndpoints) state.compilationString += this._declareOutput(this.y, state) + ` = ${tempVariable}.y;\n`;
        return this;
    }
    /**
     * Exposes the properties to the UI?
     * @returns - boolean indicating if the block has properties or not
     */ _dumpPropertiesCode() {
        const codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.manhattanDistance = ${this.manhattanDistance};\n`;
        return codeString;
    }
    /**
     * Exposes the properties to the Serialize?
     * @returns - a serialized object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.manhattanDistance = this.manhattanDistance;
        return serializationObject;
    }
    /**
     * Exposes the properties to the deserialize?
     * @param serializationObject
     * @param scene
     * @param rootUrl
     */ _deserialize(serializationObject, scene, rootUrl) {
        super._deserialize(serializationObject, scene, rootUrl);
        this.manhattanDistance = serializationObject.manhattanDistance;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Use Manhattan Distance", (0, $1aXVF.PropertyTypeForEdition).Boolean, "PROPERTIES", {
        notifiers: {
            update: false
        }
    })
], $2f7314b021ae64f7$export$1199b01f96baf167.prototype, "manhattanDistance", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.WorleyNoise3DBlock", $2f7314b021ae64f7$export$1199b01f96baf167);

});

parcelRegister("cuFkd", function(module, exports) {

$parcel$export(module.exports, "SimplexPerlin3DBlock", () => $918857b2abe473e6$export$d5d0d9c6844b9b85);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $918857b2abe473e6$export$d5d0d9c6844b9b85 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new SimplexPerlin3DBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("seed", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "SimplexPerlin3DBlock";
    }
    /**
     * Gets the seed operand input component
     */ get seed() {
        return this._inputs[0];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        if (!this.seed.isConnected) return;
        if (!this._outputs[0].hasEndpoints) return;
        let functionString = `const float SKEWFACTOR = 1.0/3.0;\n`;
        functionString += `const float UNSKEWFACTOR = 1.0/6.0;\n`;
        functionString += `const float SIMPLEX_CORNER_POS = 0.5;\n`;
        functionString += `const float SIMPLEX_TETRAHADRON_HEIGHT = 0.70710678118654752440084436210485;\n`;
        functionString += `float SimplexPerlin3D( vec3 P ){\n`;
        functionString += `    P.x = P == vec3(0., 0., 0.) ? 0.00001 : P.x;\n`;
        functionString += `    P *= SIMPLEX_TETRAHADRON_HEIGHT;\n`;
        functionString += `    vec3 Pi = floor( P + dot( P, vec3( SKEWFACTOR) ) );`;
        functionString += `    vec3 x0 = P - Pi + dot(Pi, vec3( UNSKEWFACTOR ) );\n`;
        functionString += `    vec3 g = step(x0.yzx, x0.xyz);\n`;
        functionString += `    vec3 l = 1.0 - g;\n`;
        functionString += `    vec3 Pi_1 = min( g.xyz, l.zxy );\n`;
        functionString += `    vec3 Pi_2 = max( g.xyz, l.zxy );\n`;
        functionString += `    vec3 x1 = x0 - Pi_1 + UNSKEWFACTOR;\n`;
        functionString += `    vec3 x2 = x0 - Pi_2 + SKEWFACTOR;\n`;
        functionString += `    vec3 x3 = x0 - SIMPLEX_CORNER_POS;\n`;
        functionString += `    vec4 v1234_x = vec4( x0.x, x1.x, x2.x, x3.x );\n`;
        functionString += `    vec4 v1234_y = vec4( x0.y, x1.y, x2.y, x3.y );\n`;
        functionString += `    vec4 v1234_z = vec4( x0.z, x1.z, x2.z, x3.z );\n`;
        functionString += `    Pi.xyz = Pi.xyz - floor(Pi.xyz * ( 1.0 / 69.0 )) * 69.0;\n`;
        functionString += `    vec3 Pi_inc1 = step( Pi, vec3( 69.0 - 1.5 ) ) * ( Pi + 1.0 );\n`;
        functionString += `    vec4 Pt = vec4( Pi.xy, Pi_inc1.xy ) + vec2( 50.0, 161.0 ).xyxy;\n`;
        functionString += `    Pt *= Pt;\n`;
        functionString += `    vec4 V1xy_V2xy = mix( Pt.xyxy, Pt.zwzw, vec4( Pi_1.xy, Pi_2.xy ) );\n`;
        functionString += `    Pt = vec4( Pt.x, V1xy_V2xy.xz, Pt.z ) * vec4( Pt.y, V1xy_V2xy.yw, Pt.w );\n`;
        functionString += `    const vec3 SOMELARGEFLOATS = vec3( 635.298681, 682.357502, 668.926525 );\n`;
        functionString += `    const vec3 ZINC = vec3( 48.500388, 65.294118, 63.934599 );\n`;
        functionString += `    vec3 lowz_mods = vec3( 1.0 / ( SOMELARGEFLOATS.xyz + Pi.zzz * ZINC.xyz ) );\n`;
        functionString += `    vec3 highz_mods = vec3( 1.0 / ( SOMELARGEFLOATS.xyz + Pi_inc1.zzz * ZINC.xyz ) );\n`;
        functionString += `    Pi_1 = ( Pi_1.z < 0.5 ) ? lowz_mods : highz_mods;\n`;
        functionString += `    Pi_2 = ( Pi_2.z < 0.5 ) ? lowz_mods : highz_mods;\n`;
        functionString += `    vec4 hash_0 = fract( Pt * vec4( lowz_mods.x, Pi_1.x, Pi_2.x, highz_mods.x ) ) - 0.49999;\n`;
        functionString += `    vec4 hash_1 = fract( Pt * vec4( lowz_mods.y, Pi_1.y, Pi_2.y, highz_mods.y ) ) - 0.49999;\n`;
        functionString += `    vec4 hash_2 = fract( Pt * vec4( lowz_mods.z, Pi_1.z, Pi_2.z, highz_mods.z ) ) - 0.49999;\n`;
        functionString += `    vec4 grad_results = inversesqrt( hash_0 * hash_0 + hash_1 * hash_1 + hash_2 * hash_2 ) * ( hash_0 * v1234_x + hash_1 * v1234_y + hash_2 * v1234_z );\n`;
        functionString += `    const float FINAL_NORMALIZATION = 37.837227241611314102871574478976;\n`;
        functionString += `    vec4 kernel_weights = v1234_x * v1234_x + v1234_y * v1234_y + v1234_z * v1234_z;\n`;
        functionString += `    kernel_weights = max(0.5 - kernel_weights, 0.0);\n`;
        functionString += `    kernel_weights = kernel_weights*kernel_weights*kernel_weights;\n`;
        functionString += `    return dot( kernel_weights, grad_results ) * FINAL_NORMALIZATION;\n`;
        functionString += `}\n`;
        state._emitFunction("SimplexPerlin3D", functionString, "// SimplexPerlin3D");
        state.compilationString += this._declareOutput(this._outputs[0], state) + ` = SimplexPerlin3D(${this.seed.associatedVariableName});\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.SimplexPerlin3DBlock", $918857b2abe473e6$export$d5d0d9c6844b9b85);

});

parcelRegister("aRD4Z", function(module, exports) {

$parcel$export(module.exports, "NormalBlendBlock", () => $7e8d2af7759bd6f5$export$8c2e9194e0d65cfc);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $7e8d2af7759bd6f5$export$8c2e9194e0d65cfc extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new NormalBlendBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("normalMap0", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerInput("normalMap1", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3);
        this._inputs[0].addExcludedConnectionPointFromAllowedTypes((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4);
        this._inputs[1].addExcludedConnectionPointFromAllowedTypes((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "NormalBlendBlock";
    }
    /**
     * Gets the first input component
     */ get normalMap0() {
        return this._inputs[0];
    }
    /**
     * Gets the second input component
     */ get normalMap1() {
        return this._inputs[1];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        const input0 = this._inputs[0];
        const input1 = this._inputs[1];
        const stepR = state._getFreeVariableName("stepR");
        const stepG = state._getFreeVariableName("stepG");
        state.compilationString += `float ${stepR} = step(0.5, ${input0.associatedVariableName}.r);\n`;
        state.compilationString += `float ${stepG} = step(0.5, ${input0.associatedVariableName}.g);\n`;
        state.compilationString += this._declareOutput(output, state) + `;\n`;
        state.compilationString += `${output.associatedVariableName}.r = (1.0 - ${stepR}) * ${input0.associatedVariableName}.r * ${input1.associatedVariableName}.r * 2.0 + ${stepR} * (1.0 - (1.0 - ${input0.associatedVariableName}.r) * (1.0 - ${input1.associatedVariableName}.r) * 2.0);\n`;
        state.compilationString += `${output.associatedVariableName}.g = (1.0 - ${stepG}) * ${input0.associatedVariableName}.g * ${input1.associatedVariableName}.g * 2.0 + ${stepG} * (1.0 - (1.0 - ${input0.associatedVariableName}.g) * (1.0 - ${input1.associatedVariableName}.g) * 2.0);\n`;
        state.compilationString += `${output.associatedVariableName}.b = ${input0.associatedVariableName}.b * ${input1.associatedVariableName}.b;\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.NormalBlendBlock", $7e8d2af7759bd6f5$export$8c2e9194e0d65cfc);

});

parcelRegister("cV45E", function(module, exports) {

$parcel$export(module.exports, "Rotate2dBlock", () => $967dfb1aa136ff1b$export$3c6a31e2a20de002);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");

var $aKEh2 = parcelRequire("aKEh2");
class $967dfb1aa136ff1b$export$3c6a31e2a20de002 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new Rotate2dBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("input", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2);
        this.registerInput("angle", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "Rotate2dBlock";
    }
    /**
     * Gets the input vector
     */ get input() {
        return this._inputs[0];
    }
    /**
     * Gets the input angle
     */ get angle() {
        return this._inputs[1];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    autoConfigure() {
        if (!this.angle.isConnected) {
            const angleInput = new (0, $aKEh2.InputBlock)("angle");
            angleInput.value = 0;
            angleInput.output.connectTo(this.angle);
        }
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        const angle = this.angle;
        const input = this.input;
        state.compilationString += this._declareOutput(output, state) + ` = vec2(cos(${angle.associatedVariableName}) * ${input.associatedVariableName}.x - sin(${angle.associatedVariableName}) * ${input.associatedVariableName}.y, sin(${angle.associatedVariableName}) * ${input.associatedVariableName}.x + cos(${angle.associatedVariableName}) * ${input.associatedVariableName}.y);\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.Rotate2dBlock", $967dfb1aa136ff1b$export$3c6a31e2a20de002);

});

parcelRegister("3lCtu", function(module, exports) {

$parcel$export(module.exports, "ReflectBlock", () => $27012d8bcb8eb418$export$e185fbf8e92bc9e2);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $27012d8bcb8eb418$export$e185fbf8e92bc9e2 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new ReflectBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("incident", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerInput("normal", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3);
        this._inputs[0].addExcludedConnectionPointFromAllowedTypes((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4);
        this._inputs[1].addExcludedConnectionPointFromAllowedTypes((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "ReflectBlock";
    }
    /**
     * Gets the incident component
     */ get incident() {
        return this._inputs[0];
    }
    /**
     * Gets the normal component
     */ get normal() {
        return this._inputs[1];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        state.compilationString += this._declareOutput(output, state) + ` = reflect(${this.incident.associatedVariableName}.xyz, ${this.normal.associatedVariableName}.xyz);\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.ReflectBlock", $27012d8bcb8eb418$export$e185fbf8e92bc9e2);

});

parcelRegister("WuxMr", function(module, exports) {

$parcel$export(module.exports, "RefractBlock", () => $0afd1c43f7716934$export$cb9388f7c831239d);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $0afd1c43f7716934$export$cb9388f7c831239d extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new RefractBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("incident", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerInput("normal", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerInput("ior", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3);
        this._inputs[0].addExcludedConnectionPointFromAllowedTypes((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4);
        this._inputs[1].addExcludedConnectionPointFromAllowedTypes((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "RefractBlock";
    }
    /**
     * Gets the incident component
     */ get incident() {
        return this._inputs[0];
    }
    /**
     * Gets the normal component
     */ get normal() {
        return this._inputs[1];
    }
    /**
     * Gets the index of refraction component
     */ get ior() {
        return this._inputs[2];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        state.compilationString += this._declareOutput(output, state) + ` = refract(${this.incident.associatedVariableName}.xyz, ${this.normal.associatedVariableName}.xyz, ${this.ior.associatedVariableName});\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.RefractBlock", $0afd1c43f7716934$export$cb9388f7c831239d);

});

parcelRegister("eXLCJ", function(module, exports) {

$parcel$export(module.exports, "DesaturateBlock", () => $ae4b846f3d7f182f$export$7a1cf6f3c683a89e);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $ae4b846f3d7f182f$export$7a1cf6f3c683a89e extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new DesaturateBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("color", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3);
        this.registerInput("level", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "DesaturateBlock";
    }
    /**
     * Gets the color operand input component
     */ get color() {
        return this._inputs[0];
    }
    /**
     * Gets the level operand input component
     */ get level() {
        return this._inputs[1];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        const color = this.color;
        const colorName = color.associatedVariableName;
        const tempMin = state._getFreeVariableName("colorMin");
        const tempMax = state._getFreeVariableName("colorMax");
        const tempMerge = state._getFreeVariableName("colorMerge");
        state.compilationString += `float ${tempMin} = min(min(${colorName}.x, ${colorName}.y), ${colorName}.z);\n`;
        state.compilationString += `float ${tempMax} = max(max(${colorName}.x, ${colorName}.y), ${colorName}.z);\n`;
        state.compilationString += `float ${tempMerge} = 0.5 * (${tempMin} + ${tempMax});\n`;
        state.compilationString += this._declareOutput(output, state) + ` = mix(${colorName}, vec3(${tempMerge}, ${tempMerge}, ${tempMerge}), ${this.level.associatedVariableName});\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.DesaturateBlock", $ae4b846f3d7f182f$export$7a1cf6f3c683a89e);

});

parcelRegister("1Tc4k", function(module, exports) {

var $3jhzj = parcelRequire("3jhzj");

var $ZlADR = parcelRequire("ZlADR");

var $6m6Gl = parcelRequire("6m6Gl");

var $fXrWs = parcelRequire("fXrWs");

var $lYyNa = parcelRequire("lYyNa");

var $53VIr = parcelRequire("53VIr");

var $dXP4V = parcelRequire("dXP4V");
$parcel$exportWildcard(module.exports, $3jhzj);
$parcel$exportWildcard(module.exports, $ZlADR);
$parcel$exportWildcard(module.exports, $6m6Gl);
$parcel$exportWildcard(module.exports, $fXrWs);
$parcel$exportWildcard(module.exports, $lYyNa);
$parcel$exportWildcard(module.exports, $53VIr);
$parcel$exportWildcard(module.exports, $dXP4V);

});
parcelRegister("3jhzj", function(module, exports) {

$parcel$export(module.exports, "PBRMetallicRoughnessBlock", () => $2690c632bd7ae248$export$179888ee87865781);

var $e0Suo = parcelRequire("e0Suo");

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $g92b7 = parcelRequire("g92b7");

var $iAIIe = parcelRequire("iAIIe");

var $7qH6c = parcelRequire("7qH6c");

var $aKEh2 = parcelRequire("aKEh2");

var $8DoUR = parcelRequire("8DoUR");

var $4G6Xh = parcelRequire("4G6Xh");

var $1aXVF = parcelRequire("1aXVF");

var $dTtBA = parcelRequire("dTtBA");

var $ZlADR = parcelRequire("ZlADR");

var $gVj3s = parcelRequire("gVj3s");

var $2hKx5 = parcelRequire("2hKx5");

var $6m6Gl = parcelRequire("6m6Gl");

var $fXrWs = parcelRequire("fXrWs");

var $lYyNa = parcelRequire("lYyNa");

var $fgQXs = parcelRequire("fgQXs");

var $dXP4V = parcelRequire("dXP4V");

var $7etnY = parcelRequire("7etnY");

var $kVtWi = parcelRequire("kVtWi");

var $alPCh = parcelRequire("alPCh");
const $2690c632bd7ae248$var$mapOutputToVariable = {
    ambientClr: [
        "finalAmbient",
        ""
    ],
    diffuseDir: [
        "finalDiffuse",
        ""
    ],
    specularDir: [
        "finalSpecularScaled",
        "!defined(UNLIT) && defined(SPECULARTERM)"
    ],
    clearcoatDir: [
        "finalClearCoatScaled",
        "!defined(UNLIT) && defined(CLEARCOAT)"
    ],
    sheenDir: [
        "finalSheenScaled",
        "!defined(UNLIT) && defined(SHEEN)"
    ],
    diffuseInd: [
        "finalIrradiance",
        "!defined(UNLIT) && defined(REFLECTION)"
    ],
    specularInd: [
        "finalRadianceScaled",
        "!defined(UNLIT) && defined(REFLECTION)"
    ],
    clearcoatInd: [
        "clearcoatOut.finalClearCoatRadianceScaled",
        "!defined(UNLIT) && defined(REFLECTION) && defined(CLEARCOAT)"
    ],
    sheenInd: [
        "sheenOut.finalSheenRadianceScaled",
        "!defined(UNLIT) && defined(REFLECTION) && defined(SHEEN) && defined(ENVIRONMENTBRDF)"
    ],
    refraction: [
        "subSurfaceOut.finalRefraction",
        "!defined(UNLIT) && defined(SS_REFRACTION)"
    ],
    lighting: [
        "finalColor.rgb",
        ""
    ],
    shadow: [
        "aggShadow",
        ""
    ],
    alpha: [
        "alpha",
        ""
    ]
};
class $2690c632bd7ae248$export$179888ee87865781 extends (0, $kpKE2.NodeMaterialBlock) {
    static _OnGenerateOnlyFragmentCodeChanged(block, _propertyName) {
        const that = block;
        if (that.worldPosition.isConnected) {
            that.generateOnlyFragmentCode = !that.generateOnlyFragmentCode;
            (0, $kVtWi.Logger).Error("The worldPosition input must not be connected to be able to switch!");
            return false;
        }
        that._setTarget();
        return true;
    }
    _setTarget() {
        this._setInitialTarget(this.generateOnlyFragmentCode ? (0, $iAIIe.NodeMaterialBlockTargets).Fragment : (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment);
        this.getInputByName("worldPosition").target = this.generateOnlyFragmentCode ? (0, $iAIIe.NodeMaterialBlockTargets).Fragment : (0, $iAIIe.NodeMaterialBlockTargets).Vertex;
    }
    /**
     * Create a new ReflectionBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment);
        this._environmentBRDFTexture = null;
        this._metallicReflectanceColor = (0, $7etnY.Color3).White();
        this._metallicF0Factor = 1;
        /**
         * Intensity of the direct lights e.g. the four lights available in your scene.
         * This impacts both the direct diffuse and specular highlights.
         */ this.directIntensity = 1.0;
        /**
         * Intensity of the environment e.g. how much the environment will light the object
         * either through harmonics for rough material or through the reflection for shiny ones.
         */ this.environmentIntensity = 1.0;
        /**
         * This is a special control allowing the reduction of the specular highlights coming from the
         * four lights of the scene. Those highlights may not be needed in full environment lighting.
         */ this.specularIntensity = 1.0;
        /**
         * Defines the  falloff type used in this material.
         * It by default is Physical.
         */ this.lightFalloff = 0;
        /**
         * Specifies that alpha test should be used
         */ this.useAlphaTest = false;
        /**
         * Defines the alpha limits in alpha test mode.
         */ this.alphaTestCutoff = 0.5;
        /**
         * Specifies that alpha blending should be used
         */ this.useAlphaBlending = false;
        /**
         * Specifies that the material will keeps the reflection highlights over a transparent surface (only the most luminous ones).
         * A car glass is a good example of that. When the street lights reflects on it you can not see what is behind.
         */ this.useRadianceOverAlpha = true;
        /**
         * Specifies that the material will keeps the specular highlights over a transparent surface (only the most luminous ones).
         * A car glass is a good example of that. When sun reflects on it you can not see what is behind.
         */ this.useSpecularOverAlpha = true;
        /**
         * Enables specular anti aliasing in the PBR shader.
         * It will both interacts on the Geometry for analytical and IBL lighting.
         * It also prefilter the roughness map based on the bump values.
         */ this.enableSpecularAntiAliasing = false;
        /**
         * Enables realtime filtering on the texture.
         */ this.realTimeFiltering = false;
        /**
         * Quality switch for realtime filtering
         */ this.realTimeFilteringQuality = 8;
        /**
         * Defines if the material uses energy conservation.
         */ this.useEnergyConservation = true;
        /**
         * This parameters will enable/disable radiance occlusion by preventing the radiance to lit
         * too much the area relying on ambient texture to define their ambient occlusion.
         */ this.useRadianceOcclusion = true;
        /**
         * This parameters will enable/disable Horizon occlusion to prevent normal maps to look shiny when the normal
         * makes the reflect vector face the model (under horizon).
         */ this.useHorizonOcclusion = true;
        /**
         * If set to true, no lighting calculations will be applied.
         */ this.unlit = false;
        /**
         * Force normal to face away from face.
         */ this.forceNormalForward = false;
        /** Indicates that no code should be generated in the vertex shader. Can be useful in some specific circumstances (like when doing ray marching for eg) */ this.generateOnlyFragmentCode = false;
        /**
         * Defines the material debug mode.
         * It helps seeing only some components of the material while troubleshooting.
         */ this.debugMode = 0;
        /**
         * Specify from where on screen the debug mode should start.
         * The value goes from -1 (full screen) to 1 (not visible)
         * It helps with side by side comparison against the final render
         * This defaults to 0
         */ this.debugLimit = 0;
        /**
         * As the default viewing range might not be enough (if the ambient is really small for instance)
         * You can use the factor to better multiply the final value.
         */ this.debugFactor = 1;
        this._isUnique = true;
        this.registerInput("worldPosition", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4, false, (0, $iAIIe.NodeMaterialBlockTargets).Vertex);
        this.registerInput("worldNormal", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4, false, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("view", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix, false);
        this.registerInput("cameraPosition", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3, false, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("perturbedNormal", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("baseColor", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("metallic", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, false, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("roughness", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, false, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("ambientOcc", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("opacity", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("indexOfRefraction", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("ambientColor", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("reflection", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Object, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment, new (0, $dTtBA.NodeMaterialConnectionPointCustomObject)("reflection", this, (0, $g92b7.NodeMaterialConnectionPointDirection).Input, (0, $fXrWs.ReflectionBlock), "ReflectionBlock"));
        this.registerInput("clearcoat", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Object, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment, new (0, $dTtBA.NodeMaterialConnectionPointCustomObject)("clearcoat", this, (0, $g92b7.NodeMaterialConnectionPointDirection).Input, (0, $lYyNa.ClearCoatBlock), "ClearCoatBlock"));
        this.registerInput("sheen", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Object, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment, new (0, $dTtBA.NodeMaterialConnectionPointCustomObject)("sheen", this, (0, $g92b7.NodeMaterialConnectionPointDirection).Input, (0, $ZlADR.SheenBlock), "SheenBlock"));
        this.registerInput("subsurface", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Object, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment, new (0, $dTtBA.NodeMaterialConnectionPointCustomObject)("subsurface", this, (0, $g92b7.NodeMaterialConnectionPointDirection).Input, (0, $dXP4V.SubSurfaceBlock), "SubSurfaceBlock"));
        this.registerInput("anisotropy", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Object, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment, new (0, $dTtBA.NodeMaterialConnectionPointCustomObject)("anisotropy", this, (0, $g92b7.NodeMaterialConnectionPointDirection).Input, (0, $6m6Gl.AnisotropyBlock), "AnisotropyBlock"));
        this.registerInput("iridescence", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Object, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment, new (0, $dTtBA.NodeMaterialConnectionPointCustomObject)("iridescence", this, (0, $g92b7.NodeMaterialConnectionPointDirection).Input, (0, $fgQXs.IridescenceBlock), "IridescenceBlock"));
        this.registerOutput("ambientClr", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("diffuseDir", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("specularDir", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("clearcoatDir", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("sheenDir", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("diffuseInd", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("specularInd", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("clearcoatInd", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("sheenInd", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("refraction", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("lighting", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("shadow", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("alpha", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
    }
    /**
     * Initialize the block and prepare the context for build
     * @param state defines the state that will be used for the build
     */ initialize(state) {
        state._excludeVariableName("vLightingIntensity");
        state._excludeVariableName("geometricNormalW");
        state._excludeVariableName("normalW");
        state._excludeVariableName("faceNormal");
        state._excludeVariableName("albedoOpacityOut");
        state._excludeVariableName("surfaceAlbedo");
        state._excludeVariableName("alpha");
        state._excludeVariableName("aoOut");
        state._excludeVariableName("baseColor");
        state._excludeVariableName("reflectivityOut");
        state._excludeVariableName("microSurface");
        state._excludeVariableName("roughness");
        state._excludeVariableName("NdotVUnclamped");
        state._excludeVariableName("NdotV");
        state._excludeVariableName("alphaG");
        state._excludeVariableName("AARoughnessFactors");
        state._excludeVariableName("environmentBrdf");
        state._excludeVariableName("ambientMonochrome");
        state._excludeVariableName("seo");
        state._excludeVariableName("eho");
        state._excludeVariableName("environmentRadiance");
        state._excludeVariableName("irradianceVector");
        state._excludeVariableName("environmentIrradiance");
        state._excludeVariableName("diffuseBase");
        state._excludeVariableName("specularBase");
        state._excludeVariableName("preInfo");
        state._excludeVariableName("info");
        state._excludeVariableName("shadow");
        state._excludeVariableName("finalDiffuse");
        state._excludeVariableName("finalAmbient");
        state._excludeVariableName("ambientOcclusionForDirectDiffuse");
        state._excludeVariableName("finalColor");
        state._excludeVariableName("vClipSpacePosition");
        state._excludeVariableName("vDebugMode");
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "PBRMetallicRoughnessBlock";
    }
    /**
     * Gets the world position input component
     */ get worldPosition() {
        return this._inputs[0];
    }
    /**
     * Gets the world normal input component
     */ get worldNormal() {
        return this._inputs[1];
    }
    /**
     * Gets the view matrix parameter
     */ get view() {
        return this._inputs[2];
    }
    /**
     * Gets the camera position input component
     */ get cameraPosition() {
        return this._inputs[3];
    }
    /**
     * Gets the perturbed normal input component
     */ get perturbedNormal() {
        return this._inputs[4];
    }
    /**
     * Gets the base color input component
     */ get baseColor() {
        return this._inputs[5];
    }
    /**
     * Gets the metallic input component
     */ get metallic() {
        return this._inputs[6];
    }
    /**
     * Gets the roughness input component
     */ get roughness() {
        return this._inputs[7];
    }
    /**
     * Gets the ambient occlusion input component
     */ get ambientOcc() {
        return this._inputs[8];
    }
    /**
     * Gets the opacity input component
     */ get opacity() {
        return this._inputs[9];
    }
    /**
     * Gets the index of refraction input component
     */ get indexOfRefraction() {
        return this._inputs[10];
    }
    /**
     * Gets the ambient color input component
     */ get ambientColor() {
        return this._inputs[11];
    }
    /**
     * Gets the reflection object parameters
     */ get reflection() {
        return this._inputs[12];
    }
    /**
     * Gets the clear coat object parameters
     */ get clearcoat() {
        return this._inputs[13];
    }
    /**
     * Gets the sheen object parameters
     */ get sheen() {
        return this._inputs[14];
    }
    /**
     * Gets the sub surface object parameters
     */ get subsurface() {
        return this._inputs[15];
    }
    /**
     * Gets the anisotropy object parameters
     */ get anisotropy() {
        return this._inputs[16];
    }
    /**
     * Gets the iridescence object parameters
     */ get iridescence() {
        return this._inputs[17];
    }
    /**
     * Gets the ambient output component
     */ get ambientClr() {
        return this._outputs[0];
    }
    /**
     * Gets the diffuse output component
     */ get diffuseDir() {
        return this._outputs[1];
    }
    /**
     * Gets the specular output component
     */ get specularDir() {
        return this._outputs[2];
    }
    /**
     * Gets the clear coat output component
     */ get clearcoatDir() {
        return this._outputs[3];
    }
    /**
     * Gets the sheen output component
     */ get sheenDir() {
        return this._outputs[4];
    }
    /**
     * Gets the indirect diffuse output component
     */ get diffuseInd() {
        return this._outputs[5];
    }
    /**
     * Gets the indirect specular output component
     */ get specularInd() {
        return this._outputs[6];
    }
    /**
     * Gets the indirect clear coat output component
     */ get clearcoatInd() {
        return this._outputs[7];
    }
    /**
     * Gets the indirect sheen output component
     */ get sheenInd() {
        return this._outputs[8];
    }
    /**
     * Gets the refraction output component
     */ get refraction() {
        return this._outputs[9];
    }
    /**
     * Gets the global lighting output component
     */ get lighting() {
        return this._outputs[10];
    }
    /**
     * Gets the shadow output component
     */ get shadow() {
        return this._outputs[11];
    }
    /**
     * Gets the alpha output component
     */ get alpha() {
        return this._outputs[12];
    }
    autoConfigure(material, additionalFilteringInfo = ()=>true) {
        if (!this.cameraPosition.isConnected) {
            let cameraPositionInput = material.getInputBlockByPredicate((b)=>b.systemValue === (0, $7qH6c.NodeMaterialSystemValues).CameraPosition && additionalFilteringInfo(b));
            if (!cameraPositionInput) {
                cameraPositionInput = new (0, $aKEh2.InputBlock)("cameraPosition");
                cameraPositionInput.setAsSystemValue((0, $7qH6c.NodeMaterialSystemValues).CameraPosition);
            }
            cameraPositionInput.output.connectTo(this.cameraPosition);
        }
        if (!this.view.isConnected) {
            let viewInput = material.getInputBlockByPredicate((b)=>b.systemValue === (0, $7qH6c.NodeMaterialSystemValues).View && additionalFilteringInfo(b));
            if (!viewInput) {
                viewInput = new (0, $aKEh2.InputBlock)("view");
                viewInput.setAsSystemValue((0, $7qH6c.NodeMaterialSystemValues).View);
            }
            viewInput.output.connectTo(this.view);
        }
    }
    prepareDefines(mesh, nodeMaterial, defines) {
        // General
        defines.setValue("PBR", true);
        defines.setValue("METALLICWORKFLOW", true);
        defines.setValue("DEBUGMODE", this.debugMode, true);
        defines.setValue("DEBUGMODE_FORCERETURN", true);
        defines.setValue("NORMALXYSCALE", true);
        defines.setValue("BUMP", this.perturbedNormal.isConnected, true);
        defines.setValue("LODBASEDMICROSFURACE", this._scene.getEngine().getCaps().textureLOD);
        // Albedo & Opacity
        defines.setValue("ALBEDO", false, true);
        defines.setValue("OPACITY", this.opacity.isConnected, true);
        // Ambient occlusion
        defines.setValue("AMBIENT", true, true);
        defines.setValue("AMBIENTINGRAYSCALE", false, true);
        // Reflectivity
        defines.setValue("REFLECTIVITY", false, true);
        defines.setValue("AOSTOREINMETALMAPRED", false, true);
        defines.setValue("METALLNESSSTOREINMETALMAPBLUE", false, true);
        defines.setValue("ROUGHNESSSTOREINMETALMAPALPHA", false, true);
        defines.setValue("ROUGHNESSSTOREINMETALMAPGREEN", false, true);
        // Lighting & colors
        if (this.lightFalloff === (0, $4G6Xh.PBRBaseMaterial).LIGHTFALLOFF_STANDARD) {
            defines.setValue("USEPHYSICALLIGHTFALLOFF", false);
            defines.setValue("USEGLTFLIGHTFALLOFF", false);
        } else if (this.lightFalloff === (0, $4G6Xh.PBRBaseMaterial).LIGHTFALLOFF_GLTF) {
            defines.setValue("USEPHYSICALLIGHTFALLOFF", false);
            defines.setValue("USEGLTFLIGHTFALLOFF", true);
        } else {
            defines.setValue("USEPHYSICALLIGHTFALLOFF", true);
            defines.setValue("USEGLTFLIGHTFALLOFF", false);
        }
        // Transparency
        const alphaTestCutOffString = this.alphaTestCutoff.toString();
        defines.setValue("ALPHABLEND", this.useAlphaBlending, true);
        defines.setValue("ALPHAFROMALBEDO", false, true);
        defines.setValue("ALPHATEST", this.useAlphaTest, true);
        defines.setValue("ALPHATESTVALUE", alphaTestCutOffString.indexOf(".") < 0 ? alphaTestCutOffString + "." : alphaTestCutOffString, true);
        defines.setValue("OPACITYRGB", false, true);
        // Rendering
        defines.setValue("RADIANCEOVERALPHA", this.useRadianceOverAlpha, true);
        defines.setValue("SPECULAROVERALPHA", this.useSpecularOverAlpha, true);
        defines.setValue("SPECULARAA", this._scene.getEngine().getCaps().standardDerivatives && this.enableSpecularAntiAliasing, true);
        defines.setValue("REALTIME_FILTERING", this.realTimeFiltering, true);
        const scene = mesh.getScene();
        const engine = scene.getEngine();
        if (engine._features.needTypeSuffixInShaderConstants) defines.setValue("NUM_SAMPLES", this.realTimeFilteringQuality + "u", true);
        else defines.setValue("NUM_SAMPLES", "" + this.realTimeFilteringQuality, true);
        // Advanced
        defines.setValue("BRDF_V_HEIGHT_CORRELATED", true);
        defines.setValue("MS_BRDF_ENERGY_CONSERVATION", this.useEnergyConservation, true);
        defines.setValue("RADIANCEOCCLUSION", this.useRadianceOcclusion, true);
        defines.setValue("HORIZONOCCLUSION", this.useHorizonOcclusion, true);
        defines.setValue("UNLIT", this.unlit, true);
        defines.setValue("FORCENORMALFORWARD", this.forceNormalForward, true);
        if (this._environmentBRDFTexture && (0, $2hKx5.MaterialFlags).ReflectionTextureEnabled) {
            defines.setValue("ENVIRONMENTBRDF", true);
            defines.setValue("ENVIRONMENTBRDF_RGBD", this._environmentBRDFTexture.isRGBD, true);
        } else {
            defines.setValue("ENVIRONMENTBRDF", false);
            defines.setValue("ENVIRONMENTBRDF_RGBD", false);
        }
        if (defines._areImageProcessingDirty && nodeMaterial.imageProcessingConfiguration) nodeMaterial.imageProcessingConfiguration.prepareDefines(defines);
        if (!defines._areLightsDirty) return;
        if (!this.light) {
            // Lights
            (0, $alPCh.PrepareDefinesForLights)(scene, mesh, defines, true, nodeMaterial.maxSimultaneousLights);
            defines._needNormals = true;
            // Multiview
            (0, $alPCh.PrepareDefinesForMultiview)(scene, defines);
        } else {
            const state = {
                needNormals: false,
                needRebuild: false,
                lightmapMode: false,
                shadowEnabled: false,
                specularEnabled: false
            };
            (0, $alPCh.PrepareDefinesForLight)(scene, mesh, this.light, this._lightId, defines, true, state);
            if (state.needRebuild) defines.rebuild();
        }
    }
    updateUniformsAndSamples(state, nodeMaterial, defines, uniformBuffers) {
        for(let lightIndex = 0; lightIndex < nodeMaterial.maxSimultaneousLights; lightIndex++){
            if (!defines["LIGHT" + lightIndex]) break;
            const onlyUpdateBuffersList = state.uniforms.indexOf("vLightData" + lightIndex) >= 0;
            (0, $alPCh.PrepareUniformsAndSamplersForLight)(lightIndex, state.uniforms, state.samplers, defines["PROJECTEDLIGHTTEXTURE" + lightIndex], uniformBuffers, onlyUpdateBuffersList);
        }
    }
    isReady(mesh, nodeMaterial, defines) {
        if (this._environmentBRDFTexture && !this._environmentBRDFTexture.isReady()) return false;
        if (defines._areImageProcessingDirty && nodeMaterial.imageProcessingConfiguration) {
            if (!nodeMaterial.imageProcessingConfiguration.isReady()) return false;
        }
        return true;
    }
    bind(effect, nodeMaterial, mesh) {
        if (!mesh) return;
        const scene = mesh.getScene();
        if (!this.light) (0, $alPCh.BindLights)(scene, mesh, effect, true, nodeMaterial.maxSimultaneousLights);
        else (0, $alPCh.BindLight)(this.light, this._lightId, scene, effect, true);
        effect.setTexture(this._environmentBrdfSamplerName, this._environmentBRDFTexture);
        effect.setFloat2("vDebugMode", this.debugLimit, this.debugFactor);
        const ambientScene = this._scene.ambientColor;
        if (ambientScene) effect.setColor3("ambientFromScene", ambientScene);
        const invertNormal = scene.useRightHandedSystem === (scene._mirroredCameraPosition != null);
        effect.setFloat(this._invertNormalName, invertNormal ? -1 : 1);
        effect.setFloat4("vLightingIntensity", this.directIntensity, 1, this.environmentIntensity * this._scene.environmentIntensity, this.specularIntensity);
        // reflectivity bindings
        const outsideIOR = 1; // consider air as clear coat and other layers would remap in the shader.
        const ior = this.indexOfRefraction.connectInputBlock?.value ?? 1.5;
        // We are here deriving our default reflectance from a common value for none metallic surface.
        // Based of the schlick fresnel approximation model
        // for dielectrics.
        const f0 = Math.pow((ior - outsideIOR) / (ior + outsideIOR), 2);
        // Tweak the default F0 and F90 based on our given setup
        this._metallicReflectanceColor.scaleToRef(f0 * this._metallicF0Factor, (0, $7etnY.TmpColors).Color3[0]);
        const metallicF90 = this._metallicF0Factor;
        effect.setColor4(this._vMetallicReflectanceFactorsName, (0, $7etnY.TmpColors).Color3[0], metallicF90);
        if (nodeMaterial.imageProcessingConfiguration) nodeMaterial.imageProcessingConfiguration.bind(effect);
    }
    _injectVertexCode(state) {
        const worldPos = this.worldPosition;
        const comments = `//${this.name}`;
        // Declaration
        if (!this.light) {
            // Emit for all lights
            state._emitFunctionFromInclude(state.supportUniformBuffers ? "lightVxUboDeclaration" : "lightVxFragmentDeclaration", comments, {
                repeatKey: "maxSimultaneousLights"
            });
            this._lightId = 0;
            state.sharedData.dynamicUniformBlocks.push(this);
        } else {
            this._lightId = (state.counters["lightCounter"] !== undefined ? state.counters["lightCounter"] : -1) + 1;
            state.counters["lightCounter"] = this._lightId;
            state._emitFunctionFromInclude(state.supportUniformBuffers ? "lightVxUboDeclaration" : "lightVxFragmentDeclaration", comments, {
                replaceStrings: [
                    {
                        search: /{X}/g,
                        replace: this._lightId.toString()
                    }
                ]
            }, this._lightId.toString());
        }
        // Inject code in vertex
        const worldPosVaryingName = "v_" + worldPos.associatedVariableName;
        if (state._emitVaryingFromString(worldPosVaryingName, "vec4")) state.compilationString += `${worldPosVaryingName} = ${worldPos.associatedVariableName};\n`;
        const reflectionBlock = this.reflection.isConnected ? this.reflection.connectedPoint?.ownerBlock : null;
        if (reflectionBlock) reflectionBlock.viewConnectionPoint = this.view;
        state.compilationString += reflectionBlock?.handleVertexSide(state) ?? "";
        if (state._emitVaryingFromString("vClipSpacePosition", "vec4", "defined(IGNORE) || DEBUGMODE > 0")) {
            state._injectAtEnd += `#if DEBUGMODE > 0\n`;
            state._injectAtEnd += `vClipSpacePosition = gl_Position;\n`;
            state._injectAtEnd += `#endif\n`;
        }
        if (this.light) state.compilationString += state._emitCodeFromInclude("shadowsVertex", comments, {
            replaceStrings: [
                {
                    search: /{X}/g,
                    replace: this._lightId.toString()
                },
                {
                    search: /worldPos/g,
                    replace: worldPos.associatedVariableName
                }
            ]
        });
        else {
            state.compilationString += `vec4 worldPos = ${worldPos.associatedVariableName};\n`;
            if (this.view.isConnected) state.compilationString += `mat4 view = ${this.view.associatedVariableName};\n`;
            state.compilationString += state._emitCodeFromInclude("shadowsVertex", comments, {
                repeatKey: "maxSimultaneousLights"
            });
        }
    }
    _getAlbedoOpacityCode() {
        let code = `albedoOpacityOutParams albedoOpacityOut;\n`;
        const albedoColor = this.baseColor.isConnected ? this.baseColor.associatedVariableName : "vec3(1.)";
        const opacity = this.opacity.isConnected ? this.opacity.associatedVariableName : "1.";
        code += `albedoOpacityBlock(
                vec4(${albedoColor}, 1.),
            #ifdef ALBEDO
                vec4(1.),
                vec2(1., 1.),
            #endif
            #ifdef OPACITY
                vec4(${opacity}),
                vec2(1., 1.),
            #endif
                albedoOpacityOut
            );

            vec3 surfaceAlbedo = albedoOpacityOut.surfaceAlbedo;
            float alpha = albedoOpacityOut.alpha;\n`;
        return code;
    }
    _getAmbientOcclusionCode() {
        let code = `ambientOcclusionOutParams aoOut;\n`;
        const ao = this.ambientOcc.isConnected ? this.ambientOcc.associatedVariableName : "1.";
        code += `ambientOcclusionBlock(
            #ifdef AMBIENT
                vec3(${ao}),
                vec4(0., 1.0, 1.0, 0.),
            #endif
                aoOut
            );\n`;
        return code;
    }
    _getReflectivityCode(state) {
        let code = `reflectivityOutParams reflectivityOut;\n`;
        const aoIntensity = "1.";
        this._vMetallicReflectanceFactorsName = state._getFreeVariableName("vMetallicReflectanceFactors");
        state._emitUniformFromString(this._vMetallicReflectanceFactorsName, "vec4");
        code += `vec3 baseColor = surfaceAlbedo;

            reflectivityBlock(
                vec4(${this.metallic.associatedVariableName}, ${this.roughness.associatedVariableName}, 0., 0.),
            #ifdef METALLICWORKFLOW
                surfaceAlbedo,
                ${this._vMetallicReflectanceFactorsName},
            #endif
            #ifdef REFLECTIVITY
                vec3(0., 0., ${aoIntensity}),
                vec4(1.),
            #endif
            #if defined(METALLICWORKFLOW) && defined(REFLECTIVITY)  && defined(AOSTOREINMETALMAPRED)
                aoOut.ambientOcclusionColor,
            #endif
            #ifdef MICROSURFACEMAP
                microSurfaceTexel, <== not handled!
            #endif
                reflectivityOut
            );

            float microSurface = reflectivityOut.microSurface;
            float roughness = reflectivityOut.roughness;

            #ifdef METALLICWORKFLOW
                surfaceAlbedo = reflectivityOut.surfaceAlbedo;
            #endif
            #if defined(METALLICWORKFLOW) && defined(REFLECTIVITY) && defined(AOSTOREINMETALMAPRED)
                aoOut.ambientOcclusionColor = reflectivityOut.ambientOcclusionColor;
            #endif\n`;
        return code;
    }
    _buildBlock(state) {
        super._buildBlock(state);
        this._scene = state.sharedData.scene;
        if (!this._environmentBRDFTexture) this._environmentBRDFTexture = (0, $gVj3s.GetEnvironmentBRDFTexture)(this._scene);
        const reflectionBlock = this.reflection.isConnected ? this.reflection.connectedPoint?.ownerBlock : null;
        if (reflectionBlock) {
            // Need those variables to be setup when calling _injectVertexCode
            reflectionBlock.worldPositionConnectionPoint = this.worldPosition;
            reflectionBlock.cameraPositionConnectionPoint = this.cameraPosition;
            reflectionBlock.worldNormalConnectionPoint = this.worldNormal;
            reflectionBlock.viewConnectionPoint = this.view;
        }
        if (state.target !== (0, $iAIIe.NodeMaterialBlockTargets).Fragment) {
            // Vertex
            this._injectVertexCode(state);
            return this;
        }
        // Fragment
        state.sharedData.forcedBindableBlocks.push(this);
        state.sharedData.blocksWithDefines.push(this);
        state.sharedData.blockingBlocks.push(this);
        if (this.generateOnlyFragmentCode) state.sharedData.dynamicUniformBlocks.push(this);
        const comments = `//${this.name}`;
        const normalShading = this.perturbedNormal;
        let worldPosVarName = this.worldPosition.associatedVariableName;
        if (this.generateOnlyFragmentCode) {
            worldPosVarName = state._getFreeVariableName("globalWorldPos");
            state._emitFunction("pbr_globalworldpos", `vec3 ${worldPosVarName};\n`, comments);
            state.compilationString += `${worldPosVarName} = ${this.worldPosition.associatedVariableName}.xyz;\n`;
            state.compilationString += state._emitCodeFromInclude("shadowsVertex", comments, {
                repeatKey: "maxSimultaneousLights",
                substitutionVars: this.generateOnlyFragmentCode ? `worldPos,${this.worldPosition.associatedVariableName}` : undefined
            });
            state.compilationString += `#if DEBUGMODE > 0\n`;
            state.compilationString += `vec4 vClipSpacePosition = vec4((vec2(gl_FragCoord.xy) / vec2(1.0)) * 2.0 - 1.0, 0.0, 1.0);\n`;
            state.compilationString += `#endif\n`;
        } else worldPosVarName = "v_" + worldPosVarName;
        this._environmentBrdfSamplerName = state._getFreeVariableName("environmentBrdfSampler");
        state._emit2DSampler(this._environmentBrdfSamplerName);
        state.sharedData.hints.needAlphaBlending = state.sharedData.hints.needAlphaBlending || this.useAlphaBlending;
        state.sharedData.hints.needAlphaTesting = state.sharedData.hints.needAlphaTesting || this.useAlphaTest;
        state._emitExtension("lod", "#extension GL_EXT_shader_texture_lod : enable", "defined(LODBASEDMICROSFURACE)");
        state._emitExtension("derivatives", "#extension GL_OES_standard_derivatives : enable");
        state._emitUniformFromString("vDebugMode", "vec2", "defined(IGNORE) || DEBUGMODE > 0");
        state._emitUniformFromString("ambientFromScene", "vec3");
        // Image processing uniforms
        state.uniforms.push("exposureLinear");
        state.uniforms.push("contrast");
        state.uniforms.push("vInverseScreenSize");
        state.uniforms.push("vignetteSettings1");
        state.uniforms.push("vignetteSettings2");
        state.uniforms.push("vCameraColorCurveNegative");
        state.uniforms.push("vCameraColorCurveNeutral");
        state.uniforms.push("vCameraColorCurvePositive");
        state.uniforms.push("txColorTransform");
        state.uniforms.push("colorTransformSettings");
        state.uniforms.push("ditherIntensity");
        //
        // Includes
        //
        if (!this.light) // Emit for all lights
        state._emitFunctionFromInclude(state.supportUniformBuffers ? "lightUboDeclaration" : "lightFragmentDeclaration", comments, {
            repeatKey: "maxSimultaneousLights",
            substitutionVars: this.generateOnlyFragmentCode ? "varying," : undefined
        });
        else state._emitFunctionFromInclude(state.supportUniformBuffers ? "lightUboDeclaration" : "lightFragmentDeclaration", comments, {
            replaceStrings: [
                {
                    search: /{X}/g,
                    replace: this._lightId.toString()
                }
            ]
        }, this._lightId.toString());
        state._emitFunctionFromInclude("helperFunctions", comments);
        state._emitFunctionFromInclude("importanceSampling", comments);
        state._emitFunctionFromInclude("pbrHelperFunctions", comments);
        state._emitFunctionFromInclude("imageProcessingDeclaration", comments);
        state._emitFunctionFromInclude("imageProcessingFunctions", comments);
        state._emitFunctionFromInclude("shadowsFragmentFunctions", comments);
        state._emitFunctionFromInclude("pbrDirectLightingSetupFunctions", comments, {
            replaceStrings: [
                {
                    search: /vPositionW/g,
                    replace: worldPosVarName + ".xyz"
                }
            ]
        });
        state._emitFunctionFromInclude("pbrDirectLightingFalloffFunctions", comments);
        state._emitFunctionFromInclude("pbrBRDFFunctions", comments, {
            replaceStrings: [
                {
                    search: /REFLECTIONMAP_SKYBOX/g,
                    replace: reflectionBlock?._defineSkyboxName ?? "REFLECTIONMAP_SKYBOX"
                }
            ]
        });
        state._emitFunctionFromInclude("hdrFilteringFunctions", comments);
        state._emitFunctionFromInclude("pbrDirectLightingFunctions", comments, {
            replaceStrings: [
                {
                    search: /vPositionW/g,
                    replace: worldPosVarName + ".xyz"
                }
            ]
        });
        state._emitFunctionFromInclude("pbrIBLFunctions", comments);
        state._emitFunctionFromInclude("pbrBlockAlbedoOpacity", comments);
        state._emitFunctionFromInclude("pbrBlockReflectivity", comments);
        state._emitFunctionFromInclude("pbrBlockAmbientOcclusion", comments);
        state._emitFunctionFromInclude("pbrBlockAlphaFresnel", comments);
        state._emitFunctionFromInclude("pbrBlockAnisotropic", comments);
        //
        // code
        //
        state._emitUniformFromString("vLightingIntensity", "vec4");
        if (reflectionBlock?.generateOnlyFragmentCode) state.compilationString += reflectionBlock.handleVertexSide(state);
        // _____________________________ Geometry Information ____________________________
        this._vNormalWName = state._getFreeVariableName("vNormalW");
        state.compilationString += `vec4 ${this._vNormalWName} = normalize(${this.worldNormal.associatedVariableName});\n`;
        if (state._registerTempVariable("viewDirectionW")) state.compilationString += `vec3 viewDirectionW = normalize(${this.cameraPosition.associatedVariableName} - ${worldPosVarName}.xyz);\n`;
        state.compilationString += `vec3 geometricNormalW = ${this._vNormalWName}.xyz;\n`;
        state.compilationString += `vec3 normalW = ${normalShading.isConnected ? "normalize(" + normalShading.associatedVariableName + ".xyz)" : "geometricNormalW"};\n`;
        this._invertNormalName = state._getFreeVariableName("invertNormal");
        state._emitUniformFromString(this._invertNormalName, "float");
        state.compilationString += state._emitCodeFromInclude("pbrBlockNormalFinal", comments, {
            replaceStrings: [
                {
                    search: /vPositionW/g,
                    replace: worldPosVarName + ".xyz"
                },
                {
                    search: /vEyePosition.w/g,
                    replace: this._invertNormalName
                }
            ]
        });
        // _____________________________ Albedo & Opacity ______________________________
        state.compilationString += this._getAlbedoOpacityCode();
        state.compilationString += state._emitCodeFromInclude("depthPrePass", comments);
        // _____________________________ AO  _______________________________
        state.compilationString += this._getAmbientOcclusionCode();
        state.compilationString += state._emitCodeFromInclude("pbrBlockLightmapInit", comments);
        // _____________________________ UNLIT  _______________________________
        state.compilationString += `#ifdef UNLIT
                vec3 diffuseBase = vec3(1., 1., 1.);
            #else\n`;
        // _____________________________ Reflectivity _______________________________
        state.compilationString += this._getReflectivityCode(state);
        // _____________________________ Geometry info _________________________________
        state.compilationString += state._emitCodeFromInclude("pbrBlockGeometryInfo", comments, {
            replaceStrings: [
                {
                    search: /REFLECTIONMAP_SKYBOX/g,
                    replace: reflectionBlock?._defineSkyboxName ?? "REFLECTIONMAP_SKYBOX"
                },
                {
                    search: /REFLECTIONMAP_3D/g,
                    replace: reflectionBlock?._define3DName ?? "REFLECTIONMAP_3D"
                }
            ]
        });
        // _____________________________ Anisotropy _______________________________________
        const anisotropyBlock = this.anisotropy.isConnected ? this.anisotropy.connectedPoint?.ownerBlock : null;
        if (anisotropyBlock) {
            anisotropyBlock.worldPositionConnectionPoint = this.worldPosition;
            anisotropyBlock.worldNormalConnectionPoint = this.worldNormal;
            state.compilationString += anisotropyBlock.getCode(state, !this.perturbedNormal.isConnected);
        }
        // _____________________________ Reflection _______________________________________
        if (reflectionBlock && reflectionBlock.hasTexture) state.compilationString += reflectionBlock.getCode(state, anisotropyBlock ? "anisotropicOut.anisotropicNormal" : "normalW");
        state._emitFunctionFromInclude("pbrBlockReflection", comments, {
            replaceStrings: [
                {
                    search: /computeReflectionCoords/g,
                    replace: "computeReflectionCoordsPBR"
                },
                {
                    search: /REFLECTIONMAP_3D/g,
                    replace: reflectionBlock?._define3DName ?? "REFLECTIONMAP_3D"
                },
                {
                    search: /REFLECTIONMAP_OPPOSITEZ/g,
                    replace: reflectionBlock?._defineOppositeZ ?? "REFLECTIONMAP_OPPOSITEZ"
                },
                {
                    search: /REFLECTIONMAP_PROJECTION/g,
                    replace: reflectionBlock?._defineProjectionName ?? "REFLECTIONMAP_PROJECTION"
                },
                {
                    search: /REFLECTIONMAP_SKYBOX/g,
                    replace: reflectionBlock?._defineSkyboxName ?? "REFLECTIONMAP_SKYBOX"
                },
                {
                    search: /LODINREFLECTIONALPHA/g,
                    replace: reflectionBlock?._defineLODReflectionAlpha ?? "LODINREFLECTIONALPHA"
                },
                {
                    search: /LINEARSPECULARREFLECTION/g,
                    replace: reflectionBlock?._defineLinearSpecularReflection ?? "LINEARSPECULARREFLECTION"
                },
                {
                    search: /vReflectionFilteringInfo/g,
                    replace: reflectionBlock?._vReflectionFilteringInfoName ?? "vReflectionFilteringInfo"
                }
            ]
        });
        // ___________________ Compute Reflectance aka R0 F0 info _________________________
        state.compilationString += state._emitCodeFromInclude("pbrBlockReflectance0", comments, {
            replaceStrings: [
                {
                    search: /metallicReflectanceFactors/g,
                    replace: this._vMetallicReflectanceFactorsName
                }
            ]
        });
        // ________________________________ Sheen ______________________________
        const sheenBlock = this.sheen.isConnected ? this.sheen.connectedPoint?.ownerBlock : null;
        if (sheenBlock) state.compilationString += sheenBlock.getCode(reflectionBlock);
        state._emitFunctionFromInclude("pbrBlockSheen", comments, {
            replaceStrings: [
                {
                    search: /REFLECTIONMAP_3D/g,
                    replace: reflectionBlock?._define3DName ?? "REFLECTIONMAP_3D"
                },
                {
                    search: /REFLECTIONMAP_SKYBOX/g,
                    replace: reflectionBlock?._defineSkyboxName ?? "REFLECTIONMAP_SKYBOX"
                },
                {
                    search: /LODINREFLECTIONALPHA/g,
                    replace: reflectionBlock?._defineLODReflectionAlpha ?? "LODINREFLECTIONALPHA"
                },
                {
                    search: /LINEARSPECULARREFLECTION/g,
                    replace: reflectionBlock?._defineLinearSpecularReflection ?? "LINEARSPECULARREFLECTION"
                }
            ]
        });
        // _____________________________ Iridescence _______________________________
        const iridescenceBlock = this.iridescence.isConnected ? this.iridescence.connectedPoint?.ownerBlock : null;
        state.compilationString += (0, $fgQXs.IridescenceBlock).GetCode(iridescenceBlock);
        state._emitFunctionFromInclude("pbrBlockIridescence", comments, {
            replaceStrings: []
        });
        // _____________________________ Clear Coat ____________________________
        const clearcoatBlock = this.clearcoat.isConnected ? this.clearcoat.connectedPoint?.ownerBlock : null;
        const generateTBNSpace = !this.perturbedNormal.isConnected && !this.anisotropy.isConnected;
        const isTangentConnectedToPerturbNormal = this.perturbedNormal.isConnected && this.perturbedNormal.connectedPoint?.ownerBlock.worldTangent?.isConnected;
        const isTangentConnectedToAnisotropy = this.anisotropy.isConnected && (this.anisotropy.connectedPoint?.ownerBlock).worldTangent.isConnected;
        let vTBNAvailable = isTangentConnectedToPerturbNormal || !this.perturbedNormal.isConnected && isTangentConnectedToAnisotropy;
        state.compilationString += (0, $lYyNa.ClearCoatBlock).GetCode(state, clearcoatBlock, reflectionBlock, worldPosVarName, generateTBNSpace, vTBNAvailable, this.worldNormal.associatedVariableName);
        if (generateTBNSpace) vTBNAvailable = clearcoatBlock?.worldTangent.isConnected ?? false;
        state._emitFunctionFromInclude("pbrBlockClearcoat", comments, {
            replaceStrings: [
                {
                    search: /computeReflectionCoords/g,
                    replace: "computeReflectionCoordsPBR"
                },
                {
                    search: /REFLECTIONMAP_3D/g,
                    replace: reflectionBlock?._define3DName ?? "REFLECTIONMAP_3D"
                },
                {
                    search: /REFLECTIONMAP_OPPOSITEZ/g,
                    replace: reflectionBlock?._defineOppositeZ ?? "REFLECTIONMAP_OPPOSITEZ"
                },
                {
                    search: /REFLECTIONMAP_PROJECTION/g,
                    replace: reflectionBlock?._defineProjectionName ?? "REFLECTIONMAP_PROJECTION"
                },
                {
                    search: /REFLECTIONMAP_SKYBOX/g,
                    replace: reflectionBlock?._defineSkyboxName ?? "REFLECTIONMAP_SKYBOX"
                },
                {
                    search: /LODINREFLECTIONALPHA/g,
                    replace: reflectionBlock?._defineLODReflectionAlpha ?? "LODINREFLECTIONALPHA"
                },
                {
                    search: /LINEARSPECULARREFLECTION/g,
                    replace: reflectionBlock?._defineLinearSpecularReflection ?? "LINEARSPECULARREFLECTION"
                },
                {
                    search: /defined\(TANGENT\)/g,
                    replace: vTBNAvailable ? "defined(TANGENT)" : "defined(IGNORE)"
                }
            ]
        });
        // _________________________ Specular Environment Reflectance __________________________
        state.compilationString += state._emitCodeFromInclude("pbrBlockReflectance", comments, {
            replaceStrings: [
                {
                    search: /REFLECTIONMAP_SKYBOX/g,
                    replace: reflectionBlock?._defineSkyboxName ?? "REFLECTIONMAP_SKYBOX"
                },
                {
                    search: /REFLECTIONMAP_3D/g,
                    replace: reflectionBlock?._define3DName ?? "REFLECTIONMAP_3D"
                }
            ]
        });
        // ___________________________________ SubSurface ______________________________________
        const subsurfaceBlock = this.subsurface.isConnected ? this.subsurface.connectedPoint?.ownerBlock : null;
        const refractionBlock = this.subsurface.isConnected ? this.subsurface.connectedPoint?.ownerBlock.refraction.connectedPoint?.ownerBlock : null;
        if (refractionBlock) {
            refractionBlock.viewConnectionPoint = this.view;
            refractionBlock.indexOfRefractionConnectionPoint = this.indexOfRefraction;
        }
        state.compilationString += (0, $dXP4V.SubSurfaceBlock).GetCode(state, subsurfaceBlock, reflectionBlock, worldPosVarName);
        state._emitFunctionFromInclude("pbrBlockSubSurface", comments, {
            replaceStrings: [
                {
                    search: /REFLECTIONMAP_3D/g,
                    replace: reflectionBlock?._define3DName ?? "REFLECTIONMAP_3D"
                },
                {
                    search: /REFLECTIONMAP_OPPOSITEZ/g,
                    replace: reflectionBlock?._defineOppositeZ ?? "REFLECTIONMAP_OPPOSITEZ"
                },
                {
                    search: /REFLECTIONMAP_PROJECTION/g,
                    replace: reflectionBlock?._defineProjectionName ?? "REFLECTIONMAP_PROJECTION"
                },
                {
                    search: /SS_REFRACTIONMAP_3D/g,
                    replace: refractionBlock?._define3DName ?? "SS_REFRACTIONMAP_3D"
                },
                {
                    search: /SS_LODINREFRACTIONALPHA/g,
                    replace: refractionBlock?._defineLODRefractionAlpha ?? "SS_LODINREFRACTIONALPHA"
                },
                {
                    search: /SS_LINEARSPECULARREFRACTION/g,
                    replace: refractionBlock?._defineLinearSpecularRefraction ?? "SS_LINEARSPECULARREFRACTION"
                },
                {
                    search: /SS_REFRACTIONMAP_OPPOSITEZ/g,
                    replace: refractionBlock?._defineOppositeZ ?? "SS_REFRACTIONMAP_OPPOSITEZ"
                }
            ]
        });
        // _____________________________ Direct Lighting Info __________________________________
        state.compilationString += state._emitCodeFromInclude("pbrBlockDirectLighting", comments);
        if (this.light) state.compilationString += state._emitCodeFromInclude("lightFragment", comments, {
            replaceStrings: [
                {
                    search: /{X}/g,
                    replace: this._lightId.toString()
                },
                {
                    search: /vPositionW/g,
                    replace: worldPosVarName + ".xyz"
                }
            ]
        });
        else state.compilationString += state._emitCodeFromInclude("lightFragment", comments, {
            repeatKey: "maxSimultaneousLights",
            substitutionVars: `vPositionW,${worldPosVarName}.xyz`
        });
        // _____________________________ Compute Final Lit Components ________________________
        state.compilationString += state._emitCodeFromInclude("pbrBlockFinalLitComponents", comments);
        // _____________________________ UNLIT (2) ________________________
        state.compilationString += `#endif\n`; // UNLIT
        // _____________________________ Compute Final Unlit Components ________________________
        const aoColor = this.ambientColor.isConnected ? this.ambientColor.associatedVariableName : "vec3(0., 0., 0.)";
        let aoDirectLightIntensity = (0, $4G6Xh.PBRBaseMaterial).DEFAULT_AO_ON_ANALYTICAL_LIGHTS.toString();
        if (aoDirectLightIntensity.indexOf(".") === -1) aoDirectLightIntensity += ".";
        state.compilationString += state._emitCodeFromInclude("pbrBlockFinalUnlitComponents", comments, {
            replaceStrings: [
                {
                    search: /vec3 finalEmissive[\s\S]*?finalEmissive\*=vLightingIntensity\.y;/g,
                    replace: ""
                },
                {
                    search: /vAmbientColor/g,
                    replace: aoColor + " * ambientFromScene"
                },
                {
                    search: /vAmbientInfos\.w/g,
                    replace: aoDirectLightIntensity
                }
            ]
        });
        // _____________________________ Output Final Color Composition ________________________
        state.compilationString += state._emitCodeFromInclude("pbrBlockFinalColorComposition", comments, {
            replaceStrings: [
                {
                    search: /finalEmissive/g,
                    replace: "vec3(0.)"
                }
            ]
        });
        // _____________________________ Apply image processing ________________________
        state.compilationString += state._emitCodeFromInclude("pbrBlockImageProcessing", comments, {
            replaceStrings: [
                {
                    search: /visibility/g,
                    replace: "1."
                }
            ]
        });
        // _____________________________ Generate debug code ________________________
        state.compilationString += state._emitCodeFromInclude("pbrDebug", comments, {
            replaceStrings: [
                {
                    search: /vNormalW/g,
                    replace: this._vNormalWName
                },
                {
                    search: /vPositionW/g,
                    replace: worldPosVarName
                },
                {
                    search: /albedoTexture\.rgb;/g,
                    replace: "vec3(1.);\ngl_FragColor.rgb = toGammaSpace(gl_FragColor.rgb);\n"
                }
            ]
        });
        // _____________________________ Generate end points ________________________
        for (const output of this._outputs)if (output.hasEndpoints) {
            const remap = $2690c632bd7ae248$var$mapOutputToVariable[output.name];
            if (remap) {
                const [varName, conditions] = remap;
                if (conditions) state.compilationString += `#if ${conditions}\n`;
                state.compilationString += `${this._declareOutput(output, state)} = ${varName};\n`;
                if (conditions) {
                    state.compilationString += `#else\n`;
                    state.compilationString += `${this._declareOutput(output, state)} = vec3(0.);\n`;
                    state.compilationString += `#endif\n`;
                }
            } else (0, $kVtWi.Logger).Error(`There's no remapping for the ${output.name} end point! No code generated`);
        }
        return this;
    }
    _dumpPropertiesCode() {
        let codeString = super._dumpPropertiesCode();
        codeString += `${this._codeVariableName}.lightFalloff = ${this.lightFalloff};\n`;
        codeString += `${this._codeVariableName}.useAlphaTest = ${this.useAlphaTest};\n`;
        codeString += `${this._codeVariableName}.alphaTestCutoff = ${this.alphaTestCutoff};\n`;
        codeString += `${this._codeVariableName}.useAlphaBlending = ${this.useAlphaBlending};\n`;
        codeString += `${this._codeVariableName}.useRadianceOverAlpha = ${this.useRadianceOverAlpha};\n`;
        codeString += `${this._codeVariableName}.useSpecularOverAlpha = ${this.useSpecularOverAlpha};\n`;
        codeString += `${this._codeVariableName}.enableSpecularAntiAliasing = ${this.enableSpecularAntiAliasing};\n`;
        codeString += `${this._codeVariableName}.realTimeFiltering = ${this.realTimeFiltering};\n`;
        codeString += `${this._codeVariableName}.realTimeFilteringQuality = ${this.realTimeFilteringQuality};\n`;
        codeString += `${this._codeVariableName}.useEnergyConservation = ${this.useEnergyConservation};\n`;
        codeString += `${this._codeVariableName}.useRadianceOcclusion = ${this.useRadianceOcclusion};\n`;
        codeString += `${this._codeVariableName}.useHorizonOcclusion = ${this.useHorizonOcclusion};\n`;
        codeString += `${this._codeVariableName}.unlit = ${this.unlit};\n`;
        codeString += `${this._codeVariableName}.forceNormalForward = ${this.forceNormalForward};\n`;
        codeString += `${this._codeVariableName}.debugMode = ${this.debugMode};\n`;
        codeString += `${this._codeVariableName}.debugLimit = ${this.debugLimit};\n`;
        codeString += `${this._codeVariableName}.debugFactor = ${this.debugFactor};\n`;
        return codeString;
    }
    serialize() {
        const serializationObject = super.serialize();
        if (this.light) serializationObject.lightId = this.light.id;
        serializationObject.lightFalloff = this.lightFalloff;
        serializationObject.useAlphaTest = this.useAlphaTest;
        serializationObject.alphaTestCutoff = this.alphaTestCutoff;
        serializationObject.useAlphaBlending = this.useAlphaBlending;
        serializationObject.useRadianceOverAlpha = this.useRadianceOverAlpha;
        serializationObject.useSpecularOverAlpha = this.useSpecularOverAlpha;
        serializationObject.enableSpecularAntiAliasing = this.enableSpecularAntiAliasing;
        serializationObject.realTimeFiltering = this.realTimeFiltering;
        serializationObject.realTimeFilteringQuality = this.realTimeFilteringQuality;
        serializationObject.useEnergyConservation = this.useEnergyConservation;
        serializationObject.useRadianceOcclusion = this.useRadianceOcclusion;
        serializationObject.useHorizonOcclusion = this.useHorizonOcclusion;
        serializationObject.unlit = this.unlit;
        serializationObject.forceNormalForward = this.forceNormalForward;
        serializationObject.debugMode = this.debugMode;
        serializationObject.debugLimit = this.debugLimit;
        serializationObject.debugFactor = this.debugFactor;
        serializationObject.generateOnlyFragmentCode = this.generateOnlyFragmentCode;
        return serializationObject;
    }
    _deserialize(serializationObject, scene, rootUrl) {
        super._deserialize(serializationObject, scene, rootUrl);
        if (serializationObject.lightId) this.light = scene.getLightById(serializationObject.lightId);
        this.lightFalloff = serializationObject.lightFalloff ?? 0;
        this.useAlphaTest = serializationObject.useAlphaTest;
        this.alphaTestCutoff = serializationObject.alphaTestCutoff;
        this.useAlphaBlending = serializationObject.useAlphaBlending;
        this.useRadianceOverAlpha = serializationObject.useRadianceOverAlpha;
        this.useSpecularOverAlpha = serializationObject.useSpecularOverAlpha;
        this.enableSpecularAntiAliasing = serializationObject.enableSpecularAntiAliasing;
        this.realTimeFiltering = !!serializationObject.realTimeFiltering;
        this.realTimeFilteringQuality = serializationObject.realTimeFilteringQuality ?? 8;
        this.useEnergyConservation = serializationObject.useEnergyConservation;
        this.useRadianceOcclusion = serializationObject.useRadianceOcclusion;
        this.useHorizonOcclusion = serializationObject.useHorizonOcclusion;
        this.unlit = serializationObject.unlit;
        this.forceNormalForward = !!serializationObject.forceNormalForward;
        this.debugMode = serializationObject.debugMode;
        this.debugLimit = serializationObject.debugLimit;
        this.debugFactor = serializationObject.debugFactor;
        this.generateOnlyFragmentCode = !!serializationObject.generateOnlyFragmentCode;
        this._setTarget();
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Direct lights", (0, $1aXVF.PropertyTypeForEdition).Float, "INTENSITY", {
        min: 0,
        max: 1,
        notifiers: {
            update: true
        }
    })
], $2690c632bd7ae248$export$179888ee87865781.prototype, "directIntensity", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Environment lights", (0, $1aXVF.PropertyTypeForEdition).Float, "INTENSITY", {
        min: 0,
        max: 1,
        notifiers: {
            update: true
        }
    })
], $2690c632bd7ae248$export$179888ee87865781.prototype, "environmentIntensity", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Specular highlights", (0, $1aXVF.PropertyTypeForEdition).Float, "INTENSITY", {
        min: 0,
        max: 1,
        notifiers: {
            update: true
        }
    })
], $2690c632bd7ae248$export$179888ee87865781.prototype, "specularIntensity", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Light falloff", (0, $1aXVF.PropertyTypeForEdition).List, "LIGHTING & COLORS", {
        notifiers: {
            update: true
        },
        options: [
            {
                label: "Physical",
                value: (0, $4G6Xh.PBRBaseMaterial).LIGHTFALLOFF_PHYSICAL
            },
            {
                label: "GLTF",
                value: (0, $4G6Xh.PBRBaseMaterial).LIGHTFALLOFF_GLTF
            },
            {
                label: "Standard",
                value: (0, $4G6Xh.PBRBaseMaterial).LIGHTFALLOFF_STANDARD
            }
        ]
    })
], $2690c632bd7ae248$export$179888ee87865781.prototype, "lightFalloff", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Alpha Testing", (0, $1aXVF.PropertyTypeForEdition).Boolean, "OPACITY")
], $2690c632bd7ae248$export$179888ee87865781.prototype, "useAlphaTest", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Alpha CutOff", (0, $1aXVF.PropertyTypeForEdition).Float, "OPACITY", {
        min: 0,
        max: 1,
        notifiers: {
            update: true
        }
    })
], $2690c632bd7ae248$export$179888ee87865781.prototype, "alphaTestCutoff", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Alpha blending", (0, $1aXVF.PropertyTypeForEdition).Boolean, "OPACITY")
], $2690c632bd7ae248$export$179888ee87865781.prototype, "useAlphaBlending", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Radiance over alpha", (0, $1aXVF.PropertyTypeForEdition).Boolean, "RENDERING", {
        notifiers: {
            update: true
        }
    })
], $2690c632bd7ae248$export$179888ee87865781.prototype, "useRadianceOverAlpha", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Specular over alpha", (0, $1aXVF.PropertyTypeForEdition).Boolean, "RENDERING", {
        notifiers: {
            update: true
        }
    })
], $2690c632bd7ae248$export$179888ee87865781.prototype, "useSpecularOverAlpha", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Specular anti-aliasing", (0, $1aXVF.PropertyTypeForEdition).Boolean, "RENDERING", {
        notifiers: {
            update: true
        }
    })
], $2690c632bd7ae248$export$179888ee87865781.prototype, "enableSpecularAntiAliasing", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Realtime filtering", (0, $1aXVF.PropertyTypeForEdition).Boolean, "RENDERING", {
        notifiers: {
            update: true
        }
    })
], $2690c632bd7ae248$export$179888ee87865781.prototype, "realTimeFiltering", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Realtime filtering quality", (0, $1aXVF.PropertyTypeForEdition).List, "RENDERING", {
        notifiers: {
            update: true
        },
        options: [
            {
                label: "Low",
                value: 8
            },
            {
                label: "Medium",
                value: 16
            },
            {
                label: "High",
                value: 64
            }
        ]
    })
], $2690c632bd7ae248$export$179888ee87865781.prototype, "realTimeFilteringQuality", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Energy Conservation", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            update: true
        }
    })
], $2690c632bd7ae248$export$179888ee87865781.prototype, "useEnergyConservation", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Radiance occlusion", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            update: true
        }
    })
], $2690c632bd7ae248$export$179888ee87865781.prototype, "useRadianceOcclusion", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Horizon occlusion", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            update: true
        }
    })
], $2690c632bd7ae248$export$179888ee87865781.prototype, "useHorizonOcclusion", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Unlit", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            update: true
        }
    })
], $2690c632bd7ae248$export$179888ee87865781.prototype, "unlit", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Force normal forward", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            update: true
        }
    })
], $2690c632bd7ae248$export$179888ee87865781.prototype, "forceNormalForward", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Generate only fragment code", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            rebuild: true,
            update: true,
            onValidation: $2690c632bd7ae248$export$179888ee87865781._OnGenerateOnlyFragmentCodeChanged
        }
    })
], $2690c632bd7ae248$export$179888ee87865781.prototype, "generateOnlyFragmentCode", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Debug mode", (0, $1aXVF.PropertyTypeForEdition).List, "DEBUG", {
        notifiers: {
            update: true
        },
        options: [
            {
                label: "None",
                value: 0
            },
            // Geometry
            {
                label: "Normalized position",
                value: 1
            },
            {
                label: "Normals",
                value: 2
            },
            {
                label: "Tangents",
                value: 3
            },
            {
                label: "Bitangents",
                value: 4
            },
            {
                label: "Bump Normals",
                value: 5
            },
            //{ label: "UV1", value: 6 },
            //{ label: "UV2", value: 7 },
            {
                label: "ClearCoat Normals",
                value: 8
            },
            {
                label: "ClearCoat Tangents",
                value: 9
            },
            {
                label: "ClearCoat Bitangents",
                value: 10
            },
            {
                label: "Anisotropic Normals",
                value: 11
            },
            {
                label: "Anisotropic Tangents",
                value: 12
            },
            {
                label: "Anisotropic Bitangents",
                value: 13
            },
            // Maps
            //{ label: "Emissive Map", value: 23 },
            //{ label: "Light Map", value: 24 },
            // Env
            {
                label: "Env Refraction",
                value: 40
            },
            {
                label: "Env Reflection",
                value: 41
            },
            {
                label: "Env Clear Coat",
                value: 42
            },
            // Lighting
            {
                label: "Direct Diffuse",
                value: 50
            },
            {
                label: "Direct Specular",
                value: 51
            },
            {
                label: "Direct Clear Coat",
                value: 52
            },
            {
                label: "Direct Sheen",
                value: 53
            },
            {
                label: "Env Irradiance",
                value: 54
            },
            // Lighting Params
            {
                label: "Surface Albedo",
                value: 60
            },
            {
                label: "Reflectance 0",
                value: 61
            },
            {
                label: "Metallic",
                value: 62
            },
            {
                label: "Metallic F0",
                value: 71
            },
            {
                label: "Roughness",
                value: 63
            },
            {
                label: "AlphaG",
                value: 64
            },
            {
                label: "NdotV",
                value: 65
            },
            {
                label: "ClearCoat Color",
                value: 66
            },
            {
                label: "ClearCoat Roughness",
                value: 67
            },
            {
                label: "ClearCoat NdotV",
                value: 68
            },
            {
                label: "Transmittance",
                value: 69
            },
            {
                label: "Refraction Transmittance",
                value: 70
            },
            // Misc
            {
                label: "SEO",
                value: 80
            },
            {
                label: "EHO",
                value: 81
            },
            {
                label: "Energy Factor",
                value: 82
            },
            {
                label: "Specular Reflectance",
                value: 83
            },
            {
                label: "Clear Coat Reflectance",
                value: 84
            },
            {
                label: "Sheen Reflectance",
                value: 85
            },
            {
                label: "Luminance Over Alpha",
                value: 86
            },
            {
                label: "Alpha",
                value: 87
            }
        ]
    })
], $2690c632bd7ae248$export$179888ee87865781.prototype, "debugMode", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Split position", (0, $1aXVF.PropertyTypeForEdition).Float, "DEBUG", {
        min: -1,
        max: 1,
        notifiers: {
            update: true
        }
    })
], $2690c632bd7ae248$export$179888ee87865781.prototype, "debugLimit", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Output factor", (0, $1aXVF.PropertyTypeForEdition).Float, "DEBUG", {
        min: 0,
        max: 5,
        notifiers: {
            update: true
        }
    })
], $2690c632bd7ae248$export$179888ee87865781.prototype, "debugFactor", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.PBRMetallicRoughnessBlock", $2690c632bd7ae248$export$179888ee87865781);

});
parcelRegister("ZlADR", function(module, exports) {

$parcel$export(module.exports, "SheenBlock", () => $0b8671f1a4c8576e$export$b4f8c0debc0b1259);

var $e0Suo = parcelRequire("e0Suo");

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $g92b7 = parcelRequire("g92b7");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");

var $1aXVF = parcelRequire("1aXVF");

var $dTtBA = parcelRequire("dTtBA");
class $0b8671f1a4c8576e$export$b4f8c0debc0b1259 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Create a new SheenBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        /**
         * If true, the sheen effect is layered above the base BRDF with the albedo-scaling technique.
         * It allows the strength of the sheen effect to not depend on the base color of the material,
         * making it easier to setup and tweak the effect
         */ this.albedoScaling = false;
        /**
         * Defines if the sheen is linked to the sheen color.
         */ this.linkSheenWithAlbedo = false;
        this._isUnique = true;
        this.registerInput("intensity", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("color", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("roughness", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("sheen", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Object, (0, $iAIIe.NodeMaterialBlockTargets).Fragment, new (0, $dTtBA.NodeMaterialConnectionPointCustomObject)("sheen", this, (0, $g92b7.NodeMaterialConnectionPointDirection).Output, $0b8671f1a4c8576e$export$b4f8c0debc0b1259, "SheenBlock"));
    }
    /**
     * Initialize the block and prepare the context for build
     * @param state defines the state that will be used for the build
     */ initialize(state) {
        state._excludeVariableName("sheenOut");
        state._excludeVariableName("sheenMapData");
        state._excludeVariableName("vSheenColor");
        state._excludeVariableName("vSheenRoughness");
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "SheenBlock";
    }
    /**
     * Gets the intensity input component
     */ get intensity() {
        return this._inputs[0];
    }
    /**
     * Gets the color input component
     */ get color() {
        return this._inputs[1];
    }
    /**
     * Gets the roughness input component
     */ get roughness() {
        return this._inputs[2];
    }
    /**
     * Gets the sheen object output component
     */ get sheen() {
        return this._outputs[0];
    }
    prepareDefines(mesh, nodeMaterial, defines) {
        super.prepareDefines(mesh, nodeMaterial, defines);
        defines.setValue("SHEEN", true);
        defines.setValue("SHEEN_USE_ROUGHNESS_FROM_MAINTEXTURE", true, true);
        defines.setValue("SHEEN_LINKWITHALBEDO", this.linkSheenWithAlbedo, true);
        defines.setValue("SHEEN_ROUGHNESS", this.roughness.isConnected, true);
        defines.setValue("SHEEN_ALBEDOSCALING", this.albedoScaling, true);
    }
    /**
     * Gets the main code of the block (fragment side)
     * @param reflectionBlock instance of a ReflectionBlock null if the code must be generated without an active reflection module
     * @returns the shader code
     */ getCode(reflectionBlock) {
        let code = "";
        const color = this.color.isConnected ? this.color.associatedVariableName : "vec3(1.)";
        const intensity = this.intensity.isConnected ? this.intensity.associatedVariableName : "1.";
        const roughness = this.roughness.isConnected ? this.roughness.associatedVariableName : "0.";
        const texture = "vec4(0.)";
        code = `#ifdef SHEEN
            sheenOutParams sheenOut;

            vec4 vSheenColor = vec4(${color}, ${intensity});

            sheenBlock(
                vSheenColor,
            #ifdef SHEEN_ROUGHNESS
                ${roughness},
            #endif
                roughness,
            #ifdef SHEEN_TEXTURE
                ${texture},
                1.0,
            #endif
                reflectance,
            #ifdef SHEEN_LINKWITHALBEDO
                baseColor,
                surfaceAlbedo,
            #endif
            #ifdef ENVIRONMENTBRDF
                NdotV,
                environmentBrdf,
            #endif
            #if defined(REFLECTION) && defined(ENVIRONMENTBRDF)
                AARoughnessFactors,
                ${reflectionBlock?._vReflectionMicrosurfaceInfosName},
                ${reflectionBlock?._vReflectionInfosName},
                ${reflectionBlock?.reflectionColor},
                vLightingIntensity,
                #ifdef ${reflectionBlock?._define3DName}
                    ${reflectionBlock?._cubeSamplerName},
                #else
                    ${reflectionBlock?._2DSamplerName},
                #endif
                reflectionOut.reflectionCoords,
                NdotVUnclamped,
                #ifndef LODBASEDMICROSFURACE
                    #ifdef ${reflectionBlock?._define3DName}
                        ${reflectionBlock?._cubeSamplerName},
                        ${reflectionBlock?._cubeSamplerName},
                    #else
                        ${reflectionBlock?._2DSamplerName},
                        ${reflectionBlock?._2DSamplerName},
                    #endif
                #endif
                #if !defined(${reflectionBlock?._defineSkyboxName}) && defined(RADIANCEOCCLUSION)
                    seo,
                #endif
                #if !defined(${reflectionBlock?._defineSkyboxName}) && defined(HORIZONOCCLUSION) && defined(BUMP) && defined(${reflectionBlock?._define3DName})
                    eho,
                #endif
            #endif
                sheenOut
            );

            #ifdef SHEEN_LINKWITHALBEDO
                surfaceAlbedo = sheenOut.surfaceAlbedo;
            #endif
        #endif\n`;
        return code;
    }
    _buildBlock(state) {
        if (state.target === (0, $iAIIe.NodeMaterialBlockTargets).Fragment) state.sharedData.blocksWithDefines.push(this);
        return this;
    }
    _dumpPropertiesCode() {
        let codeString = super._dumpPropertiesCode();
        codeString += `${this._codeVariableName}.albedoScaling = ${this.albedoScaling};\n`;
        codeString += `${this._codeVariableName}.linkSheenWithAlbedo = ${this.linkSheenWithAlbedo};\n`;
        return codeString;
    }
    serialize() {
        const serializationObject = super.serialize();
        serializationObject.albedoScaling = this.albedoScaling;
        serializationObject.linkSheenWithAlbedo = this.linkSheenWithAlbedo;
        return serializationObject;
    }
    _deserialize(serializationObject, scene, rootUrl) {
        super._deserialize(serializationObject, scene, rootUrl);
        this.albedoScaling = serializationObject.albedoScaling;
        this.linkSheenWithAlbedo = serializationObject.linkSheenWithAlbedo;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Albedo scaling", (0, $1aXVF.PropertyTypeForEdition).Boolean, "PROPERTIES", {
        notifiers: {
            update: true
        }
    })
], $0b8671f1a4c8576e$export$b4f8c0debc0b1259.prototype, "albedoScaling", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Link sheen with albedo", (0, $1aXVF.PropertyTypeForEdition).Boolean, "PROPERTIES", {
        notifiers: {
            update: true
        }
    })
], $0b8671f1a4c8576e$export$b4f8c0debc0b1259.prototype, "linkSheenWithAlbedo", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.SheenBlock", $0b8671f1a4c8576e$export$b4f8c0debc0b1259);

});

parcelRegister("6m6Gl", function(module, exports) {

$parcel$export(module.exports, "AnisotropyBlock", () => $4a09fb0fabfabfe9$export$8feeb87f67c1b328);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $g92b7 = parcelRequire("g92b7");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");

var $dTtBA = parcelRequire("dTtBA");

var $aK6BL = parcelRequire("aK6BL");

var $kVtWi = parcelRequire("kVtWi");
class $4a09fb0fabfabfe9$export$8feeb87f67c1b328 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Create a new AnisotropyBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this._tangentCorrectionFactorName = "";
        this._isUnique = true;
        this.registerInput("intensity", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("direction", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("uv", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2, true); // need this property and the next one in case there's no PerturbNormal block connected to the main PBR block
        this.registerInput("worldTangent", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4, true);
        this.registerInput("TBN", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Object, true, (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment, new (0, $dTtBA.NodeMaterialConnectionPointCustomObject)("TBN", this, (0, $g92b7.NodeMaterialConnectionPointDirection).Input, (0, $aK6BL.TBNBlock), "TBNBlock"));
        this.registerInput("roughness", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("anisotropy", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Object, (0, $iAIIe.NodeMaterialBlockTargets).Fragment, new (0, $dTtBA.NodeMaterialConnectionPointCustomObject)("anisotropy", this, (0, $g92b7.NodeMaterialConnectionPointDirection).Output, $4a09fb0fabfabfe9$export$8feeb87f67c1b328, "AnisotropyBlock"));
    }
    /**
     * Initialize the block and prepare the context for build
     * @param state defines the state that will be used for the build
     */ initialize(state) {
        state._excludeVariableName("anisotropicOut");
        state._excludeVariableName("TBN");
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "AnisotropyBlock";
    }
    /**
     * Gets the intensity input component
     */ get intensity() {
        return this._inputs[0];
    }
    /**
     * Gets the direction input component
     */ get direction() {
        return this._inputs[1];
    }
    /**
     * Gets the uv input component
     */ get uv() {
        return this._inputs[2];
    }
    /**
     * Gets the worldTangent input component
     */ get worldTangent() {
        return this._inputs[3];
    }
    /**
     * Gets the TBN input component
     */ // eslint-disable-next-line @typescript-eslint/naming-convention
    get TBN() {
        return this._inputs[4];
    }
    /**
     * Gets the roughness input component
     */ get roughness() {
        return this._inputs[5];
    }
    /**
     * Gets the anisotropy object output component
     */ get anisotropy() {
        return this._outputs[0];
    }
    _generateTBNSpace(state) {
        let code = "";
        const comments = `//${this.name}`;
        const uv = this.uv;
        const worldPosition = this.worldPositionConnectionPoint;
        const worldNormal = this.worldNormalConnectionPoint;
        const worldTangent = this.worldTangent;
        if (!uv.isConnected) // we must set the uv input as optional because we may not end up in this method (in case a PerturbNormal block is linked to the PBR material)
        // in which case uv is not required. But if we do come here, we do need the uv, so we have to raise an error but not with throw, else
        // it will stop the building of the node material and will lead to errors in the editor!
        (0, $kVtWi.Logger).Error("You must connect the 'uv' input of the Anisotropy block!");
        state._emitExtension("derivatives", "#extension GL_OES_standard_derivatives : enable");
        const tangentReplaceString = {
            search: /defined\(TANGENT\)/g,
            replace: worldTangent.isConnected ? "defined(TANGENT)" : "defined(IGNORE)"
        };
        const TBN = this.TBN;
        if (TBN.isConnected) state.compilationString += `
            #ifdef TBNBLOCK
            mat3 vTBN = ${TBN.associatedVariableName};
            #endif
            `;
        else if (worldTangent.isConnected) {
            code += `vec3 tbnNormal = normalize(${worldNormal.associatedVariableName}.xyz);\n`;
            code += `vec3 tbnTangent = normalize(${worldTangent.associatedVariableName}.xyz);\n`;
            code += `vec3 tbnBitangent = cross(tbnNormal, tbnTangent) * ${this._tangentCorrectionFactorName};\n`;
            code += `mat3 vTBN = mat3(tbnTangent, tbnBitangent, tbnNormal);\n`;
        }
        code += `
            #if defined(${worldTangent.isConnected ? "TANGENT" : "IGNORE"}) && defined(NORMAL)
                mat3 TBN = vTBN;
            #else
                mat3 TBN = cotangent_frame(${worldNormal.associatedVariableName + ".xyz"}, ${"v_" + worldPosition.associatedVariableName + ".xyz"}, ${uv.isConnected ? uv.associatedVariableName : "vec2(0.)"}, vec2(1., 1.));
            #endif\n`;
        state._emitFunctionFromInclude("bumpFragmentMainFunctions", comments, {
            replaceStrings: [
                tangentReplaceString
            ]
        });
        return code;
    }
    /**
     * Gets the main code of the block (fragment side)
     * @param state current state of the node material building
     * @param generateTBNSpace if true, the code needed to create the TBN coordinate space is generated
     * @returns the shader code
     */ getCode(state, generateTBNSpace = false) {
        let code = "";
        if (generateTBNSpace) code += this._generateTBNSpace(state);
        const intensity = this.intensity.isConnected ? this.intensity.associatedVariableName : "1.0";
        const direction = this.direction.isConnected ? this.direction.associatedVariableName : "vec2(1., 0.)";
        const roughness = this.roughness.isConnected ? this.roughness.associatedVariableName : "0.";
        code += `anisotropicOutParams anisotropicOut;
            anisotropicBlock(
                vec3(${direction}, ${intensity}),
                ${roughness},
            #ifdef ANISOTROPIC_TEXTURE
                vec3(0.),
            #endif
                TBN,
                normalW,
                viewDirectionW,
                anisotropicOut
            );\n`;
        return code;
    }
    prepareDefines(mesh, nodeMaterial, defines) {
        super.prepareDefines(mesh, nodeMaterial, defines);
        defines.setValue("ANISOTROPIC", true);
        defines.setValue("ANISOTROPIC_TEXTURE", false, true);
        defines.setValue("ANISOTROPIC_LEGACY", !this.roughness.isConnected);
    }
    bind(effect, nodeMaterial, mesh) {
        super.bind(effect, nodeMaterial, mesh);
        if (mesh) effect.setFloat(this._tangentCorrectionFactorName, mesh.getWorldMatrix().determinant() < 0 ? -1 : 1);
    }
    _buildBlock(state) {
        if (state.target === (0, $iAIIe.NodeMaterialBlockTargets).Fragment) {
            state.sharedData.blocksWithDefines.push(this);
            state.sharedData.bindableBlocks.push(this);
            this._tangentCorrectionFactorName = state._getFreeDefineName("tangentCorrectionFactor");
            state._emitUniformFromString(this._tangentCorrectionFactorName, "float");
        }
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.AnisotropyBlock", $4a09fb0fabfabfe9$export$8feeb87f67c1b328);

});

parcelRegister("fXrWs", function(module, exports) {

$parcel$export(module.exports, "ReflectionBlock", () => $b9e20a5b6775664b$export$ac52bf338779e632);

var $e0Suo = parcelRequire("e0Suo");

var $3mKw5 = parcelRequire("3mKw5");

var $g92b7 = parcelRequire("g92b7");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");

var $dTtBA = parcelRequire("dTtBA");

var $7htMm = parcelRequire("7htMm");

var $j2mX5 = parcelRequire("j2mX5");

var $1aXVF = parcelRequire("1aXVF");

var $1VEEL = parcelRequire("1VEEL");

var $kVtWi = parcelRequire("kVtWi");
class $b9e20a5b6775664b$export$ac52bf338779e632 extends (0, $7htMm.ReflectionTextureBaseBlock) {
    _onGenerateOnlyFragmentCodeChanged() {
        if (this.position.isConnected) {
            this.generateOnlyFragmentCode = !this.generateOnlyFragmentCode;
            (0, $kVtWi.Logger).Error("The position input must not be connected to be able to switch!");
            return false;
        }
        this._setTarget();
        return true;
    }
    _setTarget() {
        super._setTarget();
        this.getInputByName("position").target = this.generateOnlyFragmentCode ? (0, $iAIIe.NodeMaterialBlockTargets).Fragment : (0, $iAIIe.NodeMaterialBlockTargets).Vertex;
        if (this.generateOnlyFragmentCode) this.forceIrradianceInFragment = true;
    }
    /**
     * Create a new ReflectionBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        /**
         * Defines if the material uses spherical harmonics vs spherical polynomials for the
         * diffuse part of the IBL.
         */ this.useSphericalHarmonics = true;
        /**
         * Force the shader to compute irradiance in the fragment shader in order to take bump in account.
         */ this.forceIrradianceInFragment = false;
        this._isUnique = true;
        this.registerInput("position", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect, false, (0, $iAIIe.NodeMaterialBlockTargets).Vertex);
        this.registerInput("world", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix, false, (0, $iAIIe.NodeMaterialBlockTargets).Vertex);
        this.registerInput("color", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("reflection", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Object, (0, $iAIIe.NodeMaterialBlockTargets).Fragment, new (0, $dTtBA.NodeMaterialConnectionPointCustomObject)("reflection", this, (0, $g92b7.NodeMaterialConnectionPointDirection).Output, $b9e20a5b6775664b$export$ac52bf338779e632, "ReflectionBlock"));
        this.position.addExcludedConnectionPointFromAllowedTypes((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "ReflectionBlock";
    }
    /**
     * Gets the position input component
     */ get position() {
        return this._inputs[0];
    }
    /**
     * Gets the world position input component
     */ get worldPosition() {
        return this.worldPositionConnectionPoint;
    }
    /**
     * Gets the world normal input component
     */ get worldNormal() {
        return this.worldNormalConnectionPoint;
    }
    /**
     * Gets the world input component
     */ get world() {
        return this._inputs[1];
    }
    /**
     * Gets the camera (or eye) position component
     */ get cameraPosition() {
        return this.cameraPositionConnectionPoint;
    }
    /**
     * Gets the view input component
     */ get view() {
        return this.viewConnectionPoint;
    }
    /**
     * Gets the color input component
     */ get color() {
        return this._inputs[2];
    }
    /**
     * Gets the reflection object output component
     */ get reflection() {
        return this._outputs[0];
    }
    /**
     * Returns true if the block has a texture (either its own texture or the environment texture from the scene, if set)
     */ get hasTexture() {
        return !!this._getTexture();
    }
    /**
     * Gets the reflection color (either the name of the variable if the color input is connected, else a default value)
     */ get reflectionColor() {
        return this.color.isConnected ? this.color.associatedVariableName : "vec3(1., 1., 1.)";
    }
    _getTexture() {
        if (this.texture) return this.texture;
        return this._scene.environmentTexture;
    }
    prepareDefines(mesh, nodeMaterial, defines) {
        super.prepareDefines(mesh, nodeMaterial, defines);
        const reflectionTexture = this._getTexture();
        const reflection = reflectionTexture && reflectionTexture.getTextureMatrix;
        defines.setValue("REFLECTION", reflection, true);
        if (!reflection) return;
        defines.setValue(this._defineLODReflectionAlpha, reflectionTexture.lodLevelInAlpha, true);
        defines.setValue(this._defineLinearSpecularReflection, reflectionTexture.linearSpecularLOD, true);
        defines.setValue(this._defineOppositeZ, this._scene.useRightHandedSystem ? !reflectionTexture.invertZ : reflectionTexture.invertZ, true);
        defines.setValue("SPHERICAL_HARMONICS", this.useSphericalHarmonics, true);
        defines.setValue("GAMMAREFLECTION", reflectionTexture.gammaSpace, true);
        defines.setValue("RGBDREFLECTION", reflectionTexture.isRGBD, true);
        if (reflectionTexture && reflectionTexture.coordinatesMode !== (0, $j2mX5.Texture).SKYBOX_MODE) {
            if (reflectionTexture.isCube) {
                defines.setValue("USESPHERICALFROMREFLECTIONMAP", true);
                defines.setValue("USEIRRADIANCEMAP", false);
                if (this.forceIrradianceInFragment || this._scene.getEngine().getCaps().maxVaryingVectors <= 8) defines.setValue("USESPHERICALINVERTEX", false);
                else defines.setValue("USESPHERICALINVERTEX", true);
            }
        }
    }
    bind(effect, nodeMaterial, mesh, subMesh) {
        super.bind(effect, nodeMaterial, mesh);
        const reflectionTexture = this._getTexture();
        if (!reflectionTexture || !subMesh) return;
        if (reflectionTexture.isCube) effect.setTexture(this._cubeSamplerName, reflectionTexture);
        else effect.setTexture(this._2DSamplerName, reflectionTexture);
        const width = reflectionTexture.getSize().width;
        effect.setFloat3(this._vReflectionMicrosurfaceInfosName, width, reflectionTexture.lodGenerationScale, reflectionTexture.lodGenerationOffset);
        effect.setFloat2(this._vReflectionFilteringInfoName, width, (0, $1VEEL.Scalar).Log2(width));
        const defines = subMesh.materialDefines;
        const polynomials = reflectionTexture.sphericalPolynomial;
        if (defines.USESPHERICALFROMREFLECTIONMAP && polynomials) {
            if (defines.SPHERICAL_HARMONICS) {
                const preScaledHarmonics = polynomials.preScaledHarmonics;
                effect.setVector3("vSphericalL00", preScaledHarmonics.l00);
                effect.setVector3("vSphericalL1_1", preScaledHarmonics.l1_1);
                effect.setVector3("vSphericalL10", preScaledHarmonics.l10);
                effect.setVector3("vSphericalL11", preScaledHarmonics.l11);
                effect.setVector3("vSphericalL2_2", preScaledHarmonics.l2_2);
                effect.setVector3("vSphericalL2_1", preScaledHarmonics.l2_1);
                effect.setVector3("vSphericalL20", preScaledHarmonics.l20);
                effect.setVector3("vSphericalL21", preScaledHarmonics.l21);
                effect.setVector3("vSphericalL22", preScaledHarmonics.l22);
            } else {
                effect.setFloat3("vSphericalX", polynomials.x.x, polynomials.x.y, polynomials.x.z);
                effect.setFloat3("vSphericalY", polynomials.y.x, polynomials.y.y, polynomials.y.z);
                effect.setFloat3("vSphericalZ", polynomials.z.x, polynomials.z.y, polynomials.z.z);
                effect.setFloat3("vSphericalXX_ZZ", polynomials.xx.x - polynomials.zz.x, polynomials.xx.y - polynomials.zz.y, polynomials.xx.z - polynomials.zz.z);
                effect.setFloat3("vSphericalYY_ZZ", polynomials.yy.x - polynomials.zz.x, polynomials.yy.y - polynomials.zz.y, polynomials.yy.z - polynomials.zz.z);
                effect.setFloat3("vSphericalZZ", polynomials.zz.x, polynomials.zz.y, polynomials.zz.z);
                effect.setFloat3("vSphericalXY", polynomials.xy.x, polynomials.xy.y, polynomials.xy.z);
                effect.setFloat3("vSphericalYZ", polynomials.yz.x, polynomials.yz.y, polynomials.yz.z);
                effect.setFloat3("vSphericalZX", polynomials.zx.x, polynomials.zx.y, polynomials.zx.z);
            }
        }
    }
    /**
     * Gets the code to inject in the vertex shader
     * @param state current state of the node material building
     * @returns the shader code
     */ handleVertexSide(state) {
        let code = super.handleVertexSide(state);
        state._emitFunctionFromInclude("harmonicsFunctions", `//${this.name}`, {
            replaceStrings: [
                {
                    search: /uniform vec3 vSphericalL00;[\s\S]*?uniform vec3 vSphericalL22;/g,
                    replace: ""
                },
                {
                    search: /uniform vec3 vSphericalX;[\s\S]*?uniform vec3 vSphericalZX;/g,
                    replace: ""
                }
            ]
        });
        const reflectionVectorName = state._getFreeVariableName("reflectionVector");
        this._vEnvironmentIrradianceName = state._getFreeVariableName("vEnvironmentIrradiance");
        state._emitVaryingFromString(this._vEnvironmentIrradianceName, "vec3", "defined(USESPHERICALFROMREFLECTIONMAP) && defined(USESPHERICALINVERTEX)");
        state._emitUniformFromString("vSphericalL00", "vec3", "SPHERICAL_HARMONICS");
        state._emitUniformFromString("vSphericalL1_1", "vec3", "SPHERICAL_HARMONICS");
        state._emitUniformFromString("vSphericalL10", "vec3", "SPHERICAL_HARMONICS");
        state._emitUniformFromString("vSphericalL11", "vec3", "SPHERICAL_HARMONICS");
        state._emitUniformFromString("vSphericalL2_2", "vec3", "SPHERICAL_HARMONICS");
        state._emitUniformFromString("vSphericalL2_1", "vec3", "SPHERICAL_HARMONICS");
        state._emitUniformFromString("vSphericalL20", "vec3", "SPHERICAL_HARMONICS");
        state._emitUniformFromString("vSphericalL21", "vec3", "SPHERICAL_HARMONICS");
        state._emitUniformFromString("vSphericalL22", "vec3", "SPHERICAL_HARMONICS");
        state._emitUniformFromString("vSphericalX", "vec3", "SPHERICAL_HARMONICS", true);
        state._emitUniformFromString("vSphericalY", "vec3", "SPHERICAL_HARMONICS", true);
        state._emitUniformFromString("vSphericalZ", "vec3", "SPHERICAL_HARMONICS", true);
        state._emitUniformFromString("vSphericalXX_ZZ", "vec3", "SPHERICAL_HARMONICS", true);
        state._emitUniformFromString("vSphericalYY_ZZ", "vec3", "SPHERICAL_HARMONICS", true);
        state._emitUniformFromString("vSphericalZZ", "vec3", "SPHERICAL_HARMONICS", true);
        state._emitUniformFromString("vSphericalXY", "vec3", "SPHERICAL_HARMONICS", true);
        state._emitUniformFromString("vSphericalYZ", "vec3", "SPHERICAL_HARMONICS", true);
        state._emitUniformFromString("vSphericalZX", "vec3", "SPHERICAL_HARMONICS", true);
        code += `#if defined(USESPHERICALFROMREFLECTIONMAP) && defined(USESPHERICALINVERTEX)
                vec3 ${reflectionVectorName} = vec3(${this._reflectionMatrixName} * vec4(normalize(${this.worldNormal.associatedVariableName}).xyz, 0)).xyz;
                #ifdef ${this._defineOppositeZ}
                    ${reflectionVectorName}.z *= -1.0;
                #endif
                ${this._vEnvironmentIrradianceName} = computeEnvironmentIrradiance(${reflectionVectorName});
            #endif\n`;
        return code;
    }
    /**
     * Gets the main code of the block (fragment side)
     * @param state current state of the node material building
     * @param normalVarName name of the existing variable corresponding to the normal
     * @returns the shader code
     */ getCode(state, normalVarName) {
        let code = "";
        this.handleFragmentSideInits(state);
        state._emitFunctionFromInclude("harmonicsFunctions", `//${this.name}`, {
            replaceStrings: [
                {
                    search: /uniform vec3 vSphericalL00;[\s\S]*?uniform vec3 vSphericalL22;/g,
                    replace: ""
                },
                {
                    search: /uniform vec3 vSphericalX;[\s\S]*?uniform vec3 vSphericalZX;/g,
                    replace: ""
                }
            ]
        });
        state._emitFunction("sampleReflection", `
            #ifdef ${this._define3DName}
                #define sampleReflection(s, c) textureCube(s, c)
            #else
                #define sampleReflection(s, c) texture2D(s, c)
            #endif\n`, `//${this.name}`);
        state._emitFunction("sampleReflectionLod", `
            #ifdef ${this._define3DName}
                #define sampleReflectionLod(s, c, l) textureCubeLodEXT(s, c, l)
            #else
                #define sampleReflectionLod(s, c, l) texture2DLodEXT(s, c, l)
            #endif\n`, `//${this.name}`);
        const computeReflectionCoordsFunc = `
            vec3 computeReflectionCoordsPBR(vec4 worldPos, vec3 worldNormal) {
                ${this.handleFragmentSideCodeReflectionCoords("worldNormal", "worldPos", true, true)}
                return ${this._reflectionVectorName};
            }\n`;
        state._emitFunction("computeReflectionCoordsPBR", computeReflectionCoordsFunc, `//${this.name}`);
        this._vReflectionMicrosurfaceInfosName = state._getFreeVariableName("vReflectionMicrosurfaceInfos");
        state._emitUniformFromString(this._vReflectionMicrosurfaceInfosName, "vec3");
        this._vReflectionInfosName = state._getFreeVariableName("vReflectionInfos");
        this._vReflectionFilteringInfoName = state._getFreeVariableName("vReflectionFilteringInfo");
        state._emitUniformFromString(this._vReflectionFilteringInfoName, "vec2");
        code += `#ifdef REFLECTION
            vec2 ${this._vReflectionInfosName} = vec2(1., 0.);

            reflectionOutParams reflectionOut;

            reflectionBlock(
                ${this.generateOnlyFragmentCode ? this._worldPositionNameInFragmentOnlyMode : "v_" + this.worldPosition.associatedVariableName}.xyz,
                ${normalVarName},
                alphaG,
                ${this._vReflectionMicrosurfaceInfosName},
                ${this._vReflectionInfosName},
                ${this.reflectionColor},
            #ifdef ANISOTROPIC
                anisotropicOut,
            #endif
            #if defined(${this._defineLODReflectionAlpha}) && !defined(${this._defineSkyboxName})
                NdotVUnclamped,
            #endif
            #ifdef ${this._defineLinearSpecularReflection}
                roughness,
            #endif
            #ifdef ${this._define3DName}
                ${this._cubeSamplerName},
            #else
                ${this._2DSamplerName},
            #endif
            #if defined(NORMAL) && defined(USESPHERICALINVERTEX)
                ${this._vEnvironmentIrradianceName},
            #endif
            #ifdef USESPHERICALFROMREFLECTIONMAP
                #if !defined(NORMAL) || !defined(USESPHERICALINVERTEX)
                    ${this._reflectionMatrixName},
                #endif
            #endif
            #ifdef USEIRRADIANCEMAP
                irradianceSampler, // ** not handled **
            #endif
            #ifndef LODBASEDMICROSFURACE
                #ifdef ${this._define3DName}
                    ${this._cubeSamplerName},
                    ${this._cubeSamplerName},
                #else
                    ${this._2DSamplerName},
                    ${this._2DSamplerName},
                #endif
            #endif
            #ifdef REALTIME_FILTERING
                ${this._vReflectionFilteringInfoName},
            #endif
                reflectionOut
            );
        #endif\n`;
        return code;
    }
    _buildBlock(state) {
        this._scene = state.sharedData.scene;
        if (state.target !== (0, $iAIIe.NodeMaterialBlockTargets).Fragment) {
            this._defineLODReflectionAlpha = state._getFreeDefineName("LODINREFLECTIONALPHA");
            this._defineLinearSpecularReflection = state._getFreeDefineName("LINEARSPECULARREFLECTION");
        }
        return this;
    }
    _dumpPropertiesCode() {
        let codeString = super._dumpPropertiesCode();
        if (this.texture) codeString += `${this._codeVariableName}.texture.gammaSpace = ${this.texture.gammaSpace};\n`;
        codeString += `${this._codeVariableName}.useSphericalHarmonics = ${this.useSphericalHarmonics};\n`;
        codeString += `${this._codeVariableName}.forceIrradianceInFragment = ${this.forceIrradianceInFragment};\n`;
        return codeString;
    }
    serialize() {
        const serializationObject = super.serialize();
        serializationObject.useSphericalHarmonics = this.useSphericalHarmonics;
        serializationObject.forceIrradianceInFragment = this.forceIrradianceInFragment;
        serializationObject.gammaSpace = this.texture?.gammaSpace ?? true;
        return serializationObject;
    }
    _deserialize(serializationObject, scene, rootUrl) {
        super._deserialize(serializationObject, scene, rootUrl);
        this.useSphericalHarmonics = serializationObject.useSphericalHarmonics;
        this.forceIrradianceInFragment = serializationObject.forceIrradianceInFragment;
        if (this.texture) this.texture.gammaSpace = serializationObject.gammaSpace;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Spherical Harmonics", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            update: true
        }
    })
], $b9e20a5b6775664b$export$ac52bf338779e632.prototype, "useSphericalHarmonics", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Force irradiance in fragment", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            update: true
        }
    })
], $b9e20a5b6775664b$export$ac52bf338779e632.prototype, "forceIrradianceInFragment", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.ReflectionBlock", $b9e20a5b6775664b$export$ac52bf338779e632);

});

parcelRegister("lYyNa", function(module, exports) {

$parcel$export(module.exports, "ClearCoatBlock", () => $fffa308a45f078c2$export$4159f5fb5daf3ae3);

var $e0Suo = parcelRequire("e0Suo");

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $g92b7 = parcelRequire("g92b7");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");

var $aKEh2 = parcelRequire("aKEh2");

var $dTtBA = parcelRequire("dTtBA");

var $dXX3O = parcelRequire("dXX3O");

var $1aXVF = parcelRequire("1aXVF");

var $aK6BL = parcelRequire("aK6BL");
class $fffa308a45f078c2$export$4159f5fb5daf3ae3 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Create a new ClearCoatBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this._tangentCorrectionFactorName = "";
        /**
         * Defines if the F0 value should be remapped to account for the interface change in the material.
         */ this.remapF0OnInterfaceChange = true;
        this._isUnique = true;
        this.registerInput("intensity", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, false, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("roughness", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("indexOfRefraction", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("normalMapColor", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("uv", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("tintColor", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("tintAtDistance", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("tintThickness", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("worldTangent", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4, true);
        this.registerInput("worldNormal", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect, true);
        this.worldNormal.addExcludedConnectionPointFromAllowedTypes((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3);
        this.registerInput("TBN", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Object, true, (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment, new (0, $dTtBA.NodeMaterialConnectionPointCustomObject)("TBN", this, (0, $g92b7.NodeMaterialConnectionPointDirection).Input, (0, $aK6BL.TBNBlock), "TBNBlock"));
        this.registerOutput("clearcoat", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Object, (0, $iAIIe.NodeMaterialBlockTargets).Fragment, new (0, $dTtBA.NodeMaterialConnectionPointCustomObject)("clearcoat", this, (0, $g92b7.NodeMaterialConnectionPointDirection).Output, $fffa308a45f078c2$export$4159f5fb5daf3ae3, "ClearCoatBlock"));
    }
    /**
     * Initialize the block and prepare the context for build
     * @param state defines the state that will be used for the build
     */ initialize(state) {
        state._excludeVariableName("clearcoatOut");
        state._excludeVariableName("vClearCoatParams");
        state._excludeVariableName("vClearCoatTintParams");
        state._excludeVariableName("vClearCoatRefractionParams");
        state._excludeVariableName("vClearCoatTangentSpaceParams");
        state._excludeVariableName("vGeometricNormaClearCoatW");
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "ClearCoatBlock";
    }
    /**
     * Gets the intensity input component
     */ get intensity() {
        return this._inputs[0];
    }
    /**
     * Gets the roughness input component
     */ get roughness() {
        return this._inputs[1];
    }
    /**
     * Gets the ior input component
     */ get indexOfRefraction() {
        return this._inputs[2];
    }
    /**
     * Gets the bump texture input component
     */ get normalMapColor() {
        return this._inputs[3];
    }
    /**
     * Gets the uv input component
     */ get uv() {
        return this._inputs[4];
    }
    /**
     * Gets the tint color input component
     */ get tintColor() {
        return this._inputs[5];
    }
    /**
     * Gets the tint "at distance" input component
     */ get tintAtDistance() {
        return this._inputs[6];
    }
    /**
     * Gets the tint thickness input component
     */ get tintThickness() {
        return this._inputs[7];
    }
    /**
     * Gets the world tangent input component
     */ get worldTangent() {
        return this._inputs[8];
    }
    /**
     * Gets the world normal input component
     */ get worldNormal() {
        return this._inputs[9];
    }
    /**
     * Gets the TBN input component
     */ // eslint-disable-next-line @typescript-eslint/naming-convention
    get TBN() {
        return this._inputs[10];
    }
    /**
     * Gets the clear coat object output component
     */ get clearcoat() {
        return this._outputs[0];
    }
    autoConfigure() {
        if (!this.intensity.isConnected) {
            const intensityInput = new (0, $aKEh2.InputBlock)("ClearCoat intensity", (0, $iAIIe.NodeMaterialBlockTargets).Fragment, (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
            intensityInput.value = 1;
            intensityInput.output.connectTo(this.intensity);
        }
    }
    prepareDefines(mesh, nodeMaterial, defines) {
        super.prepareDefines(mesh, nodeMaterial, defines);
        defines.setValue("CLEARCOAT", true);
        defines.setValue("CLEARCOAT_TEXTURE", false, true);
        defines.setValue("CLEARCOAT_USE_ROUGHNESS_FROM_MAINTEXTURE", true, true);
        defines.setValue("CLEARCOAT_TINT", this.tintColor.isConnected || this.tintThickness.isConnected || this.tintAtDistance.isConnected, true);
        defines.setValue("CLEARCOAT_BUMP", this.normalMapColor.isConnected, true);
        defines.setValue("CLEARCOAT_DEFAULTIOR", this.indexOfRefraction.isConnected ? this.indexOfRefraction.connectInputBlock.value === (0, $dXX3O.PBRClearCoatConfiguration)._DefaultIndexOfRefraction : true, true);
        defines.setValue("CLEARCOAT_REMAP_F0", this.remapF0OnInterfaceChange, true);
    }
    bind(effect, nodeMaterial, mesh) {
        super.bind(effect, nodeMaterial, mesh);
        // Clear Coat Refraction params
        const indexOfRefraction = this.indexOfRefraction.connectInputBlock?.value ?? (0, $dXX3O.PBRClearCoatConfiguration)._DefaultIndexOfRefraction;
        const a = 1 - indexOfRefraction;
        const b = 1 + indexOfRefraction;
        const f0 = Math.pow(-a / b, 2); // Schlicks approx: (ior1 - ior2) / (ior1 + ior2) where ior2 for air is close to vacuum = 1.
        const eta = 1 / indexOfRefraction;
        effect.setFloat4("vClearCoatRefractionParams", f0, eta, a, b);
        // Clear Coat tangent space params
        const mainPBRBlock = this.clearcoat.hasEndpoints ? this.clearcoat.endpoints[0].ownerBlock : null;
        const perturbedNormalBlock = mainPBRBlock?.perturbedNormal.isConnected ? mainPBRBlock.perturbedNormal.connectedPoint.ownerBlock : null;
        if (this._scene._mirroredCameraPosition) effect.setFloat2("vClearCoatTangentSpaceParams", perturbedNormalBlock?.invertX ? 1.0 : -1, perturbedNormalBlock?.invertY ? 1.0 : -1);
        else effect.setFloat2("vClearCoatTangentSpaceParams", perturbedNormalBlock?.invertX ? -1 : 1.0, perturbedNormalBlock?.invertY ? -1 : 1.0);
        if (mesh) effect.setFloat(this._tangentCorrectionFactorName, mesh.getWorldMatrix().determinant() < 0 ? -1 : 1);
    }
    _generateTBNSpace(state, worldPositionVarName, worldNormalVarName) {
        let code = "";
        const comments = `//${this.name}`;
        const worldTangent = this.worldTangent;
        state._emitExtension("derivatives", "#extension GL_OES_standard_derivatives : enable");
        const tangentReplaceString = {
            search: /defined\(TANGENT\)/g,
            replace: worldTangent.isConnected ? "defined(TANGENT)" : "defined(IGNORE)"
        };
        const TBN = this.TBN;
        if (TBN.isConnected) state.compilationString += `
            #ifdef TBNBLOCK
            mat3 vTBN = ${TBN.associatedVariableName};
            #endif
            `;
        else if (worldTangent.isConnected) {
            code += `vec3 tbnNormal = normalize(${worldNormalVarName}.xyz);\n`;
            code += `vec3 tbnTangent = normalize(${worldTangent.associatedVariableName}.xyz);\n`;
            code += `vec3 tbnBitangent = cross(tbnNormal, tbnTangent) * ${this._tangentCorrectionFactorName};\n`;
            code += `mat3 vTBN = mat3(tbnTangent, tbnBitangent, tbnNormal);\n`;
        }
        state._emitFunctionFromInclude("bumpFragmentMainFunctions", comments, {
            replaceStrings: [
                tangentReplaceString
            ]
        });
        return code;
    }
    /**
     * Gets the main code of the block (fragment side)
     * @param state current state of the node material building
     * @param ccBlock instance of a ClearCoatBlock or null if the code must be generated without an active clear coat module
     * @param reflectionBlock instance of a ReflectionBlock null if the code must be generated without an active reflection module
     * @param worldPosVarName name of the variable holding the world position
     * @param generateTBNSpace if true, the code needed to create the TBN coordinate space is generated
     * @param vTBNAvailable indicate that the vTBN variable is already existing because it has already been generated by another block (PerturbNormal or Anisotropy)
     * @param worldNormalVarName name of the variable holding the world normal
     * @returns the shader code
     */ static GetCode(state, ccBlock, reflectionBlock, worldPosVarName, generateTBNSpace, vTBNAvailable, worldNormalVarName) {
        let code = "";
        const intensity = ccBlock?.intensity.isConnected ? ccBlock.intensity.associatedVariableName : "1.";
        const roughness = ccBlock?.roughness.isConnected ? ccBlock.roughness.associatedVariableName : "0.";
        const normalMapColor = ccBlock?.normalMapColor.isConnected ? ccBlock.normalMapColor.associatedVariableName : "vec3(0.)";
        const uv = ccBlock?.uv.isConnected ? ccBlock.uv.associatedVariableName : "vec2(0.)";
        const tintColor = ccBlock?.tintColor.isConnected ? ccBlock.tintColor.associatedVariableName : "vec3(1.)";
        const tintThickness = ccBlock?.tintThickness.isConnected ? ccBlock.tintThickness.associatedVariableName : "1.";
        const tintAtDistance = ccBlock?.tintAtDistance.isConnected ? ccBlock.tintAtDistance.associatedVariableName : "1.";
        const tintTexture = "vec4(0.)";
        if (ccBlock) {
            state._emitUniformFromString("vClearCoatRefractionParams", "vec4");
            state._emitUniformFromString("vClearCoatTangentSpaceParams", "vec2");
            const normalShading = ccBlock.worldNormal;
            code += `vec3 vGeometricNormaClearCoatW = ${normalShading.isConnected ? "normalize(" + normalShading.associatedVariableName + ".xyz)" : "geometricNormalW"};\n`;
        } else code += `vec3 vGeometricNormaClearCoatW = geometricNormalW;\n`;
        if (generateTBNSpace && ccBlock) {
            code += ccBlock._generateTBNSpace(state, worldPosVarName, worldNormalVarName);
            vTBNAvailable = ccBlock.worldTangent.isConnected;
        }
        code += `clearcoatOutParams clearcoatOut;

        #ifdef CLEARCOAT
            vec2 vClearCoatParams = vec2(${intensity}, ${roughness});
            vec4 vClearCoatTintParams = vec4(${tintColor}, ${tintThickness});

            clearcoatBlock(
                ${worldPosVarName}.xyz,
                vGeometricNormaClearCoatW,
                viewDirectionW,
                vClearCoatParams,
                specularEnvironmentR0,
            #ifdef CLEARCOAT_TEXTURE
                vec2(0.),
            #endif
            #ifdef CLEARCOAT_TINT
                vClearCoatTintParams,
                ${tintAtDistance},
                vClearCoatRefractionParams,
                #ifdef CLEARCOAT_TINT_TEXTURE
                    ${tintTexture},
                #endif
            #endif
            #ifdef CLEARCOAT_BUMP
                vec2(0., 1.),
                vec4(${normalMapColor}, 0.),
                ${uv},
                #if defined(${vTBNAvailable ? "TANGENT" : "IGNORE"}) && defined(NORMAL)
                    vTBN,
                #else
                    vClearCoatTangentSpaceParams,
                #endif
                #ifdef OBJECTSPACE_NORMALMAP
                    normalMatrix,
                #endif
            #endif
            #if defined(FORCENORMALFORWARD) && defined(NORMAL)
                faceNormal,
            #endif
            #ifdef REFLECTION
                ${reflectionBlock?._vReflectionMicrosurfaceInfosName},
                ${reflectionBlock?._vReflectionInfosName},
                ${reflectionBlock?.reflectionColor},
                vLightingIntensity,
                #ifdef ${reflectionBlock?._define3DName}
                    ${reflectionBlock?._cubeSamplerName},
                #else
                    ${reflectionBlock?._2DSamplerName},
                #endif
                #ifndef LODBASEDMICROSFURACE
                    #ifdef ${reflectionBlock?._define3DName}
                        ${reflectionBlock?._cubeSamplerName},
                        ${reflectionBlock?._cubeSamplerName},
                    #else
                        ${reflectionBlock?._2DSamplerName},
                        ${reflectionBlock?._2DSamplerName},
                    #endif
                #endif
            #endif
            #if defined(ENVIRONMENTBRDF) && !defined(${reflectionBlock?._defineSkyboxName})
                #ifdef RADIANCEOCCLUSION
                    ambientMonochrome,
                #endif
            #endif
            #if defined(CLEARCOAT_BUMP) || defined(TWOSIDEDLIGHTING)
                (gl_FrontFacing ? 1. : -1.),
            #endif
                clearcoatOut
            );
        #else
            clearcoatOut.specularEnvironmentR0 = specularEnvironmentR0;
        #endif\n`;
        return code;
    }
    _buildBlock(state) {
        this._scene = state.sharedData.scene;
        if (state.target === (0, $iAIIe.NodeMaterialBlockTargets).Fragment) {
            state.sharedData.bindableBlocks.push(this);
            state.sharedData.blocksWithDefines.push(this);
            this._tangentCorrectionFactorName = state._getFreeDefineName("tangentCorrectionFactor");
            state._emitUniformFromString(this._tangentCorrectionFactorName, "float");
        }
        return this;
    }
    _dumpPropertiesCode() {
        let codeString = super._dumpPropertiesCode();
        codeString += `${this._codeVariableName}.remapF0OnInterfaceChange = ${this.remapF0OnInterfaceChange};\n`;
        return codeString;
    }
    serialize() {
        const serializationObject = super.serialize();
        serializationObject.remapF0OnInterfaceChange = this.remapF0OnInterfaceChange;
        return serializationObject;
    }
    _deserialize(serializationObject, scene, rootUrl) {
        super._deserialize(serializationObject, scene, rootUrl);
        this.remapF0OnInterfaceChange = serializationObject.remapF0OnInterfaceChange ?? true;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Remap F0 on interface change", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED")
], $fffa308a45f078c2$export$4159f5fb5daf3ae3.prototype, "remapF0OnInterfaceChange", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.ClearCoatBlock", $fffa308a45f078c2$export$4159f5fb5daf3ae3);

});

parcelRegister("fgQXs", function(module, exports) {

$parcel$export(module.exports, "IridescenceBlock", () => $b1e16df9f584aaf0$export$604b9819450f4892);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $g92b7 = parcelRequire("g92b7");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");

var $aKEh2 = parcelRequire("aKEh2");

var $dTtBA = parcelRequire("dTtBA");

var $lngOr = parcelRequire("lngOr");
class $b1e16df9f584aaf0$export$604b9819450f4892 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Create a new IridescenceBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this._isUnique = true;
        this.registerInput("intensity", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("indexOfRefraction", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("thickness", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("iridescence", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Object, (0, $iAIIe.NodeMaterialBlockTargets).Fragment, new (0, $dTtBA.NodeMaterialConnectionPointCustomObject)("iridescence", this, (0, $g92b7.NodeMaterialConnectionPointDirection).Output, $b1e16df9f584aaf0$export$604b9819450f4892, "IridescenceBlock"));
    }
    /**
     * Initialize the block and prepare the context for build
     * @param state defines the state that will be used for the build
     */ initialize(state) {
        state._excludeVariableName("iridescenceOut");
        state._excludeVariableName("vIridescenceParams");
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "IridescenceBlock";
    }
    /**
     * Gets the intensity input component
     */ get intensity() {
        return this._inputs[0];
    }
    /**
     * Gets the indexOfRefraction input component
     */ get indexOfRefraction() {
        return this._inputs[1];
    }
    /**
     * Gets the thickness input component
     */ get thickness() {
        return this._inputs[2];
    }
    /**
     * Gets the iridescence object output component
     */ get iridescence() {
        return this._outputs[0];
    }
    autoConfigure() {
        if (!this.intensity.isConnected) {
            const intensityInput = new (0, $aKEh2.InputBlock)("Iridescence intensity", (0, $iAIIe.NodeMaterialBlockTargets).Fragment, (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
            intensityInput.value = 1;
            intensityInput.output.connectTo(this.intensity);
            const indexOfRefractionInput = new (0, $aKEh2.InputBlock)("Iridescence ior", (0, $iAIIe.NodeMaterialBlockTargets).Fragment, (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
            indexOfRefractionInput.value = 1.3;
            indexOfRefractionInput.output.connectTo(this.indexOfRefraction);
            const thicknessInput = new (0, $aKEh2.InputBlock)("Iridescence thickness", (0, $iAIIe.NodeMaterialBlockTargets).Fragment, (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
            thicknessInput.value = 400;
            thicknessInput.output.connectTo(this.thickness);
        }
    }
    prepareDefines(mesh, nodeMaterial, defines) {
        super.prepareDefines(mesh, nodeMaterial, defines);
        defines.setValue("IRIDESCENCE", true, true);
        defines.setValue("IRIDESCENCE_TEXTURE", false, true);
        defines.setValue("IRIDESCENCE_THICKNESS_TEXTURE", false, true);
    }
    /**
     * Gets the main code of the block (fragment side)
     * @param iridescenceBlock instance of a IridescenceBlock or null if the code must be generated without an active iridescence module
     * @returns the shader code
     */ static GetCode(iridescenceBlock) {
        let code = "";
        const intensityName = iridescenceBlock?.intensity.isConnected ? iridescenceBlock.intensity.associatedVariableName : "1.";
        const indexOfRefraction = iridescenceBlock?.indexOfRefraction.isConnected ? iridescenceBlock.indexOfRefraction.associatedVariableName : (0, $lngOr.PBRIridescenceConfiguration)._DefaultIndexOfRefraction;
        const thickness = iridescenceBlock?.thickness.isConnected ? iridescenceBlock.thickness.associatedVariableName : (0, $lngOr.PBRIridescenceConfiguration)._DefaultMaximumThickness;
        code += `iridescenceOutParams iridescenceOut;

        #ifdef IRIDESCENCE
            iridescenceBlock(
                vec4(${intensityName}, ${indexOfRefraction}, 1., ${thickness}),
                NdotV,
                specularEnvironmentR0,
                #ifdef CLEARCOAT
                    NdotVUnclamped,
                #endif
                iridescenceOut
            );

            float iridescenceIntensity = iridescenceOut.iridescenceIntensity;
            specularEnvironmentR0 = iridescenceOut.specularEnvironmentR0;
        #endif\n`;
        return code;
    }
    _buildBlock(state) {
        if (state.target === (0, $iAIIe.NodeMaterialBlockTargets).Fragment) {
            state.sharedData.bindableBlocks.push(this);
            state.sharedData.blocksWithDefines.push(this);
        }
        return this;
    }
    serialize() {
        const serializationObject = super.serialize();
        return serializationObject;
    }
    _deserialize(serializationObject, scene, rootUrl) {
        super._deserialize(serializationObject, scene, rootUrl);
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.IridescenceBlock", $b1e16df9f584aaf0$export$604b9819450f4892);

});

parcelRegister("dXP4V", function(module, exports) {

$parcel$export(module.exports, "SubSurfaceBlock", () => $a2a86828d1320571$export$b6e05b7f7bd2d9ab);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $g92b7 = parcelRequire("g92b7");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");

var $aKEh2 = parcelRequire("aKEh2");

var $dTtBA = parcelRequire("dTtBA");

var $53VIr = parcelRequire("53VIr");
class $a2a86828d1320571$export$b6e05b7f7bd2d9ab extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Create a new SubSurfaceBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this._isUnique = true;
        this.registerInput("thickness", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, false, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("tintColor", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("translucencyIntensity", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("translucencyDiffusionDist", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("refraction", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Object, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment, new (0, $dTtBA.NodeMaterialConnectionPointCustomObject)("refraction", this, (0, $g92b7.NodeMaterialConnectionPointDirection).Input, (0, $53VIr.RefractionBlock), "RefractionBlock"));
        this.registerInput("dispersion", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("subsurface", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Object, (0, $iAIIe.NodeMaterialBlockTargets).Fragment, new (0, $dTtBA.NodeMaterialConnectionPointCustomObject)("subsurface", this, (0, $g92b7.NodeMaterialConnectionPointDirection).Output, $a2a86828d1320571$export$b6e05b7f7bd2d9ab, "SubSurfaceBlock"));
    }
    /**
     * Initialize the block and prepare the context for build
     * @param state defines the state that will be used for the build
     */ initialize(state) {
        state._excludeVariableName("subSurfaceOut");
        state._excludeVariableName("vThicknessParam");
        state._excludeVariableName("vTintColor");
        state._excludeVariableName("vSubSurfaceIntensity");
        state._excludeVariableName("dispersion");
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "SubSurfaceBlock";
    }
    /**
     * Gets the thickness component
     */ get thickness() {
        return this._inputs[0];
    }
    /**
     * Gets the tint color input component
     */ get tintColor() {
        return this._inputs[1];
    }
    /**
     * Gets the translucency intensity input component
     */ get translucencyIntensity() {
        return this._inputs[2];
    }
    /**
     * Gets the translucency diffusion distance input component
     */ get translucencyDiffusionDist() {
        return this._inputs[3];
    }
    /**
     * Gets the refraction object parameters
     */ get refraction() {
        return this._inputs[4];
    }
    /**
     * Gets the dispersion input component
     */ get dispersion() {
        return this._inputs[5];
    }
    /**
     * Gets the sub surface object output component
     */ get subsurface() {
        return this._outputs[0];
    }
    autoConfigure() {
        if (!this.thickness.isConnected) {
            const thicknessInput = new (0, $aKEh2.InputBlock)("SubSurface thickness", (0, $iAIIe.NodeMaterialBlockTargets).Fragment, (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
            thicknessInput.value = 0;
            thicknessInput.output.connectTo(this.thickness);
        }
    }
    prepareDefines(mesh, nodeMaterial, defines) {
        super.prepareDefines(mesh, nodeMaterial, defines);
        const translucencyEnabled = this.translucencyDiffusionDist.isConnected || this.translucencyIntensity.isConnected;
        defines.setValue("SUBSURFACE", translucencyEnabled || this.refraction.isConnected, true);
        defines.setValue("SS_TRANSLUCENCY", translucencyEnabled, true);
        defines.setValue("SS_THICKNESSANDMASK_TEXTURE", false, true);
        defines.setValue("SS_REFRACTIONINTENSITY_TEXTURE", false, true);
        defines.setValue("SS_TRANSLUCENCYINTENSITY_TEXTURE", false, true);
        defines.setValue("SS_MASK_FROM_THICKNESS_TEXTURE", false, true);
        defines.setValue("SS_USE_GLTF_TEXTURES", false, true);
        defines.setValue("SS_DISPERSION", this.dispersion.isConnected, true);
    }
    /**
     * Gets the main code of the block (fragment side)
     * @param state current state of the node material building
     * @param ssBlock instance of a SubSurfaceBlock or null if the code must be generated without an active sub surface module
     * @param reflectionBlock instance of a ReflectionBlock null if the code must be generated without an active reflection module
     * @param worldPosVarName name of the variable holding the world position
     * @returns the shader code
     */ static GetCode(state, ssBlock, reflectionBlock, worldPosVarName) {
        let code = "";
        const thickness = ssBlock?.thickness.isConnected ? ssBlock.thickness.associatedVariableName : "0.";
        const tintColor = ssBlock?.tintColor.isConnected ? ssBlock.tintColor.associatedVariableName : "vec3(1.)";
        const translucencyIntensity = ssBlock?.translucencyIntensity.isConnected ? ssBlock?.translucencyIntensity.associatedVariableName : "1.";
        const translucencyDiffusionDistance = ssBlock?.translucencyDiffusionDist.isConnected ? ssBlock?.translucencyDiffusionDist.associatedVariableName : "vec3(1.)";
        const refractionBlock = ssBlock?.refraction.isConnected ? ssBlock?.refraction.connectedPoint?.ownerBlock : null;
        const refractionTintAtDistance = refractionBlock?.tintAtDistance.isConnected ? refractionBlock.tintAtDistance.associatedVariableName : "1.";
        const refractionIntensity = refractionBlock?.intensity.isConnected ? refractionBlock.intensity.associatedVariableName : "1.";
        const refractionView = refractionBlock?.view.isConnected ? refractionBlock.view.associatedVariableName : "";
        const dispersion = ssBlock?.dispersion.isConnected ? ssBlock?.dispersion.associatedVariableName : "0.0";
        code += refractionBlock?.getCode(state) ?? "";
        code += `subSurfaceOutParams subSurfaceOut;

        #ifdef SUBSURFACE
            vec2 vThicknessParam = vec2(0., ${thickness});
            vec4 vTintColor = vec4(${tintColor}, ${refractionTintAtDistance});
            vec3 vSubSurfaceIntensity = vec3(${refractionIntensity}, ${translucencyIntensity}, 0.);
            float dispersion = ${dispersion};
            subSurfaceBlock(
                vSubSurfaceIntensity,
                vThicknessParam,
                vTintColor,
                normalW,
                specularEnvironmentReflectance,
            #ifdef SS_THICKNESSANDMASK_TEXTURE
                vec4(0.),
            #endif
            #ifdef REFLECTION
                #ifdef SS_TRANSLUCENCY
                    ${reflectionBlock?._reflectionMatrixName},
                    #ifdef USESPHERICALFROMREFLECTIONMAP
                        #if !defined(NORMAL) || !defined(USESPHERICALINVERTEX)
                            reflectionOut.irradianceVector,
                        #endif
                        #if defined(REALTIME_FILTERING)
                            ${reflectionBlock?._cubeSamplerName},
                            ${reflectionBlock?._vReflectionFilteringInfoName},
                        #endif
                        #endif
                    #ifdef USEIRRADIANCEMAP
                        irradianceSampler,
                    #endif
                #endif
            #endif
            #if defined(SS_REFRACTION) || defined(SS_TRANSLUCENCY)
                surfaceAlbedo,
            #endif
            #ifdef SS_REFRACTION
                ${worldPosVarName}.xyz,
                viewDirectionW,
                ${refractionView},
                ${refractionBlock?._vRefractionInfosName ?? ""},
                ${refractionBlock?._refractionMatrixName ?? ""},
                ${refractionBlock?._vRefractionMicrosurfaceInfosName ?? ""},
                vLightingIntensity,
                #ifdef SS_LINKREFRACTIONTOTRANSPARENCY
                    alpha,
                #endif
                #ifdef ${refractionBlock?._defineLODRefractionAlpha ?? "IGNORE"}
                    NdotVUnclamped,
                #endif
                #ifdef ${refractionBlock?._defineLinearSpecularRefraction ?? "IGNORE"}
                    roughness,
                #endif
                alphaG,
                #ifdef ${refractionBlock?._define3DName ?? "IGNORE"}
                    ${refractionBlock?._cubeSamplerName ?? ""},
                #else
                    ${refractionBlock?._2DSamplerName ?? ""},
                #endif
                #ifndef LODBASEDMICROSFURACE
                    #ifdef ${refractionBlock?._define3DName ?? "IGNORE"}
                        ${refractionBlock?._cubeSamplerName ?? ""},
                        ${refractionBlock?._cubeSamplerName ?? ""},
                    #else
                        ${refractionBlock?._2DSamplerName ?? ""},
                        ${refractionBlock?._2DSamplerName ?? ""},
                    #endif
                #endif
                #ifdef ANISOTROPIC
                    anisotropicOut,
                #endif
                #ifdef REALTIME_FILTERING
                    ${refractionBlock?._vRefractionFilteringInfoName ?? ""},
                #endif
                #ifdef SS_USE_LOCAL_REFRACTIONMAP_CUBIC
                    vRefractionPosition,
                    vRefractionSize,
                #endif
                #ifdef SS_DISPERSION
                    dispersion,
                #endif
            #endif
            #ifdef SS_TRANSLUCENCY
                ${translucencyDiffusionDistance},
            #endif
                subSurfaceOut
            );

            #ifdef SS_REFRACTION
                surfaceAlbedo = subSurfaceOut.surfaceAlbedo;
                #ifdef SS_LINKREFRACTIONTOTRANSPARENCY
                    alpha = subSurfaceOut.alpha;
                #endif
            #endif
        #else
            subSurfaceOut.specularEnvironmentReflectance = specularEnvironmentReflectance;
        #endif\n`;
        return code;
    }
    _buildBlock(state) {
        if (state.target === (0, $iAIIe.NodeMaterialBlockTargets).Fragment) state.sharedData.blocksWithDefines.push(this);
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.SubSurfaceBlock", $a2a86828d1320571$export$b6e05b7f7bd2d9ab);

});
parcelRegister("53VIr", function(module, exports) {

$parcel$export(module.exports, "RefractionBlock", () => $3afa00b422a7c258$export$b9e677b2b0de4a7d);

var $e0Suo = parcelRequire("e0Suo");

var $3mKw5 = parcelRequire("3mKw5");

var $g92b7 = parcelRequire("g92b7");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");

var $aKEh2 = parcelRequire("aKEh2");

var $dTtBA = parcelRequire("dTtBA");

var $1aXVF = parcelRequire("1aXVF");

var $kpKE2 = parcelRequire("kpKE2");

var $iPQLf = parcelRequire("iPQLf");

var $j2mX5 = parcelRequire("j2mX5");

var $7qH6c = parcelRequire("7qH6c");

var $1VEEL = parcelRequire("1VEEL");
class $3afa00b422a7c258$export$b9e677b2b0de4a7d extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Create a new RefractionBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        /**
         * This parameters will make the material used its opacity to control how much it is refracting against not.
         * Materials half opaque for instance using refraction could benefit from this control.
         */ this.linkRefractionWithTransparency = false;
        /**
         * Controls if refraction needs to be inverted on Y. This could be useful for procedural texture.
         */ this.invertRefractionY = false;
        /**
         * Controls if refraction needs to be inverted on Y. This could be useful for procedural texture.
         */ this.useThicknessAsDepth = false;
        this._isUnique = true;
        this.registerInput("intensity", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, false, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("tintAtDistance", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerInput("volumeIndexOfRefraction", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true, (0, $iAIIe.NodeMaterialBlockTargets).Fragment);
        this.registerOutput("refraction", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Object, (0, $iAIIe.NodeMaterialBlockTargets).Fragment, new (0, $dTtBA.NodeMaterialConnectionPointCustomObject)("refraction", this, (0, $g92b7.NodeMaterialConnectionPointDirection).Output, $3afa00b422a7c258$export$b9e677b2b0de4a7d, "RefractionBlock"));
    }
    /**
     * Initialize the block and prepare the context for build
     * @param state defines the state that will be used for the build
     */ initialize(state) {
        state._excludeVariableName("vRefractionPosition");
        state._excludeVariableName("vRefractionSize");
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "RefractionBlock";
    }
    /**
     * Gets the intensity input component
     */ get intensity() {
        return this._inputs[0];
    }
    /**
     * Gets the tint at distance input component
     */ get tintAtDistance() {
        return this._inputs[1];
    }
    /**
     * Gets the volume index of refraction input component
     */ get volumeIndexOfRefraction() {
        return this._inputs[2];
    }
    /**
     * Gets the view input component
     */ get view() {
        return this.viewConnectionPoint;
    }
    /**
     * Gets the refraction object output component
     */ get refraction() {
        return this._outputs[0];
    }
    /**
     * Returns true if the block has a texture
     */ get hasTexture() {
        return !!this._getTexture();
    }
    _getTexture() {
        if (this.texture) return this.texture;
        return this._scene.environmentTexture;
    }
    autoConfigure(material, additionalFilteringInfo = ()=>true) {
        if (!this.intensity.isConnected) {
            const intensityInput = new (0, $aKEh2.InputBlock)("Refraction intensity", (0, $iAIIe.NodeMaterialBlockTargets).Fragment, (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
            intensityInput.value = 1;
            intensityInput.output.connectTo(this.intensity);
        }
        if (this.view && !this.view.isConnected) {
            let viewInput = material.getInputBlockByPredicate((b)=>b.systemValue === (0, $7qH6c.NodeMaterialSystemValues).View && additionalFilteringInfo(b));
            if (!viewInput) {
                viewInput = new (0, $aKEh2.InputBlock)("view");
                viewInput.setAsSystemValue((0, $7qH6c.NodeMaterialSystemValues).View);
            }
            viewInput.output.connectTo(this.view);
        }
    }
    prepareDefines(mesh, nodeMaterial, defines) {
        super.prepareDefines(mesh, nodeMaterial, defines);
        const refractionTexture = this._getTexture();
        const refraction = refractionTexture && refractionTexture.getTextureMatrix;
        defines.setValue("SS_REFRACTION", refraction, true);
        if (!refraction) return;
        defines.setValue(this._define3DName, refractionTexture.isCube, true);
        defines.setValue(this._defineLODRefractionAlpha, refractionTexture.lodLevelInAlpha, true);
        defines.setValue(this._defineLinearSpecularRefraction, refractionTexture.linearSpecularLOD, true);
        defines.setValue(this._defineOppositeZ, this._scene.useRightHandedSystem && refractionTexture.isCube ? !refractionTexture.invertZ : refractionTexture.invertZ, true);
        defines.setValue("SS_LINKREFRACTIONTOTRANSPARENCY", this.linkRefractionWithTransparency, true);
        defines.setValue("SS_GAMMAREFRACTION", refractionTexture.gammaSpace, true);
        defines.setValue("SS_RGBDREFRACTION", refractionTexture.isRGBD, true);
        defines.setValue("SS_USE_LOCAL_REFRACTIONMAP_CUBIC", refractionTexture.boundingBoxSize ? true : false, true);
        defines.setValue("SS_USE_THICKNESS_AS_DEPTH", this.useThicknessAsDepth, true);
    }
    isReady() {
        const texture = this._getTexture();
        if (texture && !texture.isReadyOrNotBlocking()) return false;
        return true;
    }
    bind(effect, nodeMaterial, mesh) {
        super.bind(effect, nodeMaterial, mesh);
        const refractionTexture = this._getTexture();
        if (!refractionTexture) return;
        if (refractionTexture.isCube) effect.setTexture(this._cubeSamplerName, refractionTexture);
        else effect.setTexture(this._2DSamplerName, refractionTexture);
        effect.setMatrix(this._refractionMatrixName, refractionTexture.getRefractionTextureMatrix());
        let depth = 1.0;
        if (!refractionTexture.isCube) {
            if (refractionTexture.depth) depth = refractionTexture.depth;
        }
        const indexOfRefraction = this.volumeIndexOfRefraction.connectInputBlock?.value ?? this.indexOfRefractionConnectionPoint.connectInputBlock?.value ?? 1.5;
        effect.setFloat4(this._vRefractionInfosName, refractionTexture.level, 1 / indexOfRefraction, depth, this.invertRefractionY ? -1 : 1);
        effect.setFloat4(this._vRefractionMicrosurfaceInfosName, refractionTexture.getSize().width, refractionTexture.lodGenerationScale, refractionTexture.lodGenerationOffset, 1 / indexOfRefraction);
        const width = refractionTexture.getSize().width;
        effect.setFloat2(this._vRefractionFilteringInfoName, width, (0, $1VEEL.Scalar).Log2(width));
        if (refractionTexture.boundingBoxSize) {
            const cubeTexture = refractionTexture;
            effect.setVector3("vRefractionPosition", cubeTexture.boundingBoxPosition);
            effect.setVector3("vRefractionSize", cubeTexture.boundingBoxSize);
        }
    }
    /**
     * Gets the main code of the block (fragment side)
     * @param state current state of the node material building
     * @returns the shader code
     */ getCode(state) {
        const code = "";
        state.sharedData.blockingBlocks.push(this);
        state.sharedData.textureBlocks.push(this);
        // Samplers
        this._cubeSamplerName = state._getFreeVariableName(this.name + "CubeSampler");
        state.samplers.push(this._cubeSamplerName);
        this._2DSamplerName = state._getFreeVariableName(this.name + "2DSampler");
        state.samplers.push(this._2DSamplerName);
        this._define3DName = state._getFreeDefineName("SS_REFRACTIONMAP_3D");
        state._samplerDeclaration += `#ifdef ${this._define3DName}\n`;
        state._samplerDeclaration += `uniform samplerCube ${this._cubeSamplerName};\n`;
        state._samplerDeclaration += `#else\n`;
        state._samplerDeclaration += `uniform sampler2D ${this._2DSamplerName};\n`;
        state._samplerDeclaration += `#endif\n`;
        // Fragment
        state.sharedData.blocksWithDefines.push(this);
        state.sharedData.bindableBlocks.push(this);
        this._defineLODRefractionAlpha = state._getFreeDefineName("SS_LODINREFRACTIONALPHA");
        this._defineLinearSpecularRefraction = state._getFreeDefineName("SS_LINEARSPECULARREFRACTION");
        this._defineOppositeZ = state._getFreeDefineName("SS_REFRACTIONMAP_OPPOSITEZ");
        this._refractionMatrixName = state._getFreeVariableName("refractionMatrix");
        state._emitUniformFromString(this._refractionMatrixName, "mat4");
        state._emitFunction("sampleRefraction", `
            #ifdef ${this._define3DName}
                #define sampleRefraction(s, c) textureCube(s, c)
            #else
                #define sampleRefraction(s, c) texture2D(s, c)
            #endif\n`, `//${this.name}`);
        state._emitFunction("sampleRefractionLod", `
            #ifdef ${this._define3DName}
                #define sampleRefractionLod(s, c, l) textureCubeLodEXT(s, c, l)
            #else
                #define sampleRefractionLod(s, c, l) texture2DLodEXT(s, c, l)
            #endif\n`, `//${this.name}`);
        this._vRefractionMicrosurfaceInfosName = state._getFreeVariableName("vRefractionMicrosurfaceInfos");
        state._emitUniformFromString(this._vRefractionMicrosurfaceInfosName, "vec4");
        this._vRefractionInfosName = state._getFreeVariableName("vRefractionInfos");
        state._emitUniformFromString(this._vRefractionInfosName, "vec4");
        this._vRefractionFilteringInfoName = state._getFreeVariableName("vRefractionFilteringInfo");
        state._emitUniformFromString(this._vRefractionFilteringInfoName, "vec2");
        state._emitUniformFromString("vRefractionPosition", "vec3");
        state._emitUniformFromString("vRefractionSize", "vec3");
        return code;
    }
    _buildBlock(state) {
        this._scene = state.sharedData.scene;
        return this;
    }
    _dumpPropertiesCode() {
        let codeString = super._dumpPropertiesCode();
        if (this.texture) {
            if (this.texture.isCube) codeString = `${this._codeVariableName}.texture = new BABYLON.CubeTexture("${this.texture.name}");\n`;
            else codeString = `${this._codeVariableName}.texture = new BABYLON.Texture("${this.texture.name}");\n`;
            codeString += `${this._codeVariableName}.texture.coordinatesMode = ${this.texture.coordinatesMode};\n`;
        }
        codeString += `${this._codeVariableName}.linkRefractionWithTransparency = ${this.linkRefractionWithTransparency};\n`;
        codeString += `${this._codeVariableName}.invertRefractionY = ${this.invertRefractionY};\n`;
        codeString += `${this._codeVariableName}.useThicknessAsDepth = ${this.useThicknessAsDepth};\n`;
        return codeString;
    }
    serialize() {
        const serializationObject = super.serialize();
        if (this.texture && !this.texture.isRenderTarget) serializationObject.texture = this.texture.serialize();
        serializationObject.linkRefractionWithTransparency = this.linkRefractionWithTransparency;
        serializationObject.invertRefractionY = this.invertRefractionY;
        serializationObject.useThicknessAsDepth = this.useThicknessAsDepth;
        return serializationObject;
    }
    _deserialize(serializationObject, scene, rootUrl) {
        super._deserialize(serializationObject, scene, rootUrl);
        if (serializationObject.texture) {
            rootUrl = serializationObject.texture.url.indexOf("data:") === 0 ? "" : rootUrl;
            if (serializationObject.texture.isCube) this.texture = (0, $iPQLf.CubeTexture).Parse(serializationObject.texture, scene, rootUrl);
            else this.texture = (0, $j2mX5.Texture).Parse(serializationObject.texture, scene, rootUrl);
        }
        this.linkRefractionWithTransparency = serializationObject.linkRefractionWithTransparency;
        this.invertRefractionY = serializationObject.invertRefractionY;
        this.useThicknessAsDepth = !!serializationObject.useThicknessAsDepth;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Link refraction to transparency", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            update: true
        }
    })
], $3afa00b422a7c258$export$b9e677b2b0de4a7d.prototype, "linkRefractionWithTransparency", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Invert refraction Y", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            update: true
        }
    })
], $3afa00b422a7c258$export$b9e677b2b0de4a7d.prototype, "invertRefractionY", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Use thickness as depth", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            update: true
        }
    })
], $3afa00b422a7c258$export$b9e677b2b0de4a7d.prototype, "useThicknessAsDepth", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.RefractionBlock", $3afa00b422a7c258$export$b9e677b2b0de4a7d);

});




parcelRegister("jMhOs", function(module, exports) {

var $hExiF = parcelRequire("hExiF");

var $ejSsy = parcelRequire("ejSsy");

var $h7sVv = parcelRequire("h7sVv");
$parcel$exportWildcard(module.exports, $hExiF);
$parcel$exportWildcard(module.exports, $ejSsy);
$parcel$exportWildcard(module.exports, $h7sVv);

});

parcelRegister("lq3DF", function(module, exports) {

$parcel$export(module.exports, "ModBlock", () => $f97ed94335774039$export$3fc1f0cc1fffb9df);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $f97ed94335774039$export$3fc1f0cc1fffb9df extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new ModBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("left", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerInput("right", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
        this._linkConnectionTypes(0, 1);
        this._inputs[1].acceptedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "ModBlock";
    }
    /**
     * Gets the left operand input component
     */ get left() {
        return this._inputs[0];
    }
    /**
     * Gets the right operand input component
     */ get right() {
        return this._inputs[1];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        state.compilationString += this._declareOutput(output, state) + ` = mod(${this.left.associatedVariableName}, ${this.right.associatedVariableName});\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.ModBlock", $f97ed94335774039$export$3fc1f0cc1fffb9df);

});

parcelRegister("2PO9P", function(module, exports) {

$parcel$export(module.exports, "MatrixBuilderBlock", () => $21074069a197c563$export$a01ee00279226722);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");

var $aKEh2 = parcelRequire("aKEh2");

var $ha1VO = parcelRequire("ha1VO");
class $21074069a197c563$export$a01ee00279226722 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new MatrixBuilder
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("row0", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4);
        this.registerInput("row1", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4);
        this.registerInput("row2", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4);
        this.registerInput("row3", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "MatrixBuilder";
    }
    /**
     * Gets the row0 vector
     */ get row0() {
        return this._inputs[0];
    }
    /**
     * Gets the row1 vector
     */ get row1() {
        return this._inputs[1];
    }
    /**
     * Gets the row2 vector
     */ get row2() {
        return this._inputs[2];
    }
    /**
     * Gets the row3 vector
     */ get row3() {
        return this._inputs[3];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    autoConfigure() {
        if (!this.row0.isConnected) {
            const row0Input = new (0, $aKEh2.InputBlock)("row0");
            row0Input.value = new (0, $ha1VO.Vector4)(1, 0, 0, 0);
            row0Input.output.connectTo(this.row0);
        }
        if (!this.row1.isConnected) {
            const row1Input = new (0, $aKEh2.InputBlock)("row1");
            row1Input.value = new (0, $ha1VO.Vector4)(0, 1, 0, 0);
            row1Input.output.connectTo(this.row1);
        }
        if (!this.row2.isConnected) {
            const row2Input = new (0, $aKEh2.InputBlock)("row2");
            row2Input.value = new (0, $ha1VO.Vector4)(0, 0, 1, 0);
            row2Input.output.connectTo(this.row2);
        }
        if (!this.row3.isConnected) {
            const row3Input = new (0, $aKEh2.InputBlock)("row3");
            row3Input.value = new (0, $ha1VO.Vector4)(0, 0, 0, 1);
            row3Input.output.connectTo(this.row3);
        }
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        const row0 = this.row0;
        const row1 = this.row1;
        const row2 = this.row2;
        const row3 = this.row3;
        state.compilationString += this._declareOutput(output, state) + ` = mat4(${row0.associatedVariableName}, ${row1.associatedVariableName}, ${row2.associatedVariableName}, ${row3.associatedVariableName});\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.MatrixBuilder", $21074069a197c563$export$a01ee00279226722);

});

parcelRegister("kDfGd", function(module, exports) {

$parcel$export(module.exports, "ConditionalBlockConditions", () => $f0539ce4077945ff$export$ab670da661bb6d34);
$parcel$export(module.exports, "ConditionalBlock", () => $f0539ce4077945ff$export$a867775f0a39adc9);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
var $f0539ce4077945ff$export$ab670da661bb6d34;
(function(ConditionalBlockConditions) {
    /** Equal */ ConditionalBlockConditions[ConditionalBlockConditions["Equal"] = 0] = "Equal";
    /** NotEqual */ ConditionalBlockConditions[ConditionalBlockConditions["NotEqual"] = 1] = "NotEqual";
    /** LessThan */ ConditionalBlockConditions[ConditionalBlockConditions["LessThan"] = 2] = "LessThan";
    /** GreaterThan */ ConditionalBlockConditions[ConditionalBlockConditions["GreaterThan"] = 3] = "GreaterThan";
    /** LessOrEqual */ ConditionalBlockConditions[ConditionalBlockConditions["LessOrEqual"] = 4] = "LessOrEqual";
    /** GreaterOrEqual */ ConditionalBlockConditions[ConditionalBlockConditions["GreaterOrEqual"] = 5] = "GreaterOrEqual";
    /** Logical Exclusive OR */ ConditionalBlockConditions[ConditionalBlockConditions["Xor"] = 6] = "Xor";
    /** Logical Or */ ConditionalBlockConditions[ConditionalBlockConditions["Or"] = 7] = "Or";
    /** Logical And */ ConditionalBlockConditions[ConditionalBlockConditions["And"] = 8] = "And";
})($f0539ce4077945ff$export$ab670da661bb6d34 || ($f0539ce4077945ff$export$ab670da661bb6d34 = {}));
class $f0539ce4077945ff$export$a867775f0a39adc9 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new ConditionalBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        /**
         * Gets or sets the condition applied by the block
         */ this.condition = $f0539ce4077945ff$export$ab670da661bb6d34.LessThan;
        this.registerInput("a", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.registerInput("b", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.registerInput("true", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect, true);
        this.registerInput("false", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect, true);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).BasedOnInput);
        this._linkConnectionTypes(2, 3);
        this._outputs[0]._typeConnectionSource = this._inputs[2];
        this._outputs[0]._defaultConnectionPointType = (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float;
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "ConditionalBlock";
    }
    /**
     * Gets the first operand component
     */ get a() {
        return this._inputs[0];
    }
    /**
     * Gets the second operand component
     */ get b() {
        return this._inputs[1];
    }
    /**
     * Gets the value to return if condition is true
     */ get true() {
        return this._inputs[2];
    }
    /**
     * Gets the value to return if condition is false
     */ get false() {
        return this._inputs[3];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        const trueStatement = this.true.isConnected ? this.true.associatedVariableName : "1.0";
        const falseStatement = this.false.isConnected ? this.false.associatedVariableName : "0.0";
        switch(this.condition){
            case $f0539ce4077945ff$export$ab670da661bb6d34.Equal:
                state.compilationString += this._declareOutput(output, state) + ` = ${this.a.associatedVariableName} == ${this.b.associatedVariableName} ? ${trueStatement} : ${falseStatement};\n`;
                break;
            case $f0539ce4077945ff$export$ab670da661bb6d34.NotEqual:
                state.compilationString += this._declareOutput(output, state) + ` = ${this.a.associatedVariableName} != ${this.b.associatedVariableName} ? ${trueStatement} : ${falseStatement};\n`;
                break;
            case $f0539ce4077945ff$export$ab670da661bb6d34.LessThan:
                state.compilationString += this._declareOutput(output, state) + ` = ${this.a.associatedVariableName} < ${this.b.associatedVariableName} ? ${trueStatement} : ${falseStatement};\n`;
                break;
            case $f0539ce4077945ff$export$ab670da661bb6d34.LessOrEqual:
                state.compilationString += this._declareOutput(output, state) + ` = ${this.a.associatedVariableName} <= ${this.b.associatedVariableName} ? ${trueStatement} : ${falseStatement};\n`;
                break;
            case $f0539ce4077945ff$export$ab670da661bb6d34.GreaterThan:
                state.compilationString += this._declareOutput(output, state) + ` = ${this.a.associatedVariableName} > ${this.b.associatedVariableName} ? ${trueStatement} : ${falseStatement};\n`;
                break;
            case $f0539ce4077945ff$export$ab670da661bb6d34.GreaterOrEqual:
                state.compilationString += this._declareOutput(output, state) + ` = ${this.a.associatedVariableName} >= ${this.b.associatedVariableName} ? ${trueStatement} : ${falseStatement};\n`;
                break;
            case $f0539ce4077945ff$export$ab670da661bb6d34.Xor:
                state.compilationString += this._declareOutput(output, state) + ` = (mod(${this.a.associatedVariableName} + ${this.b.associatedVariableName}, 2.0) > 0.0) ? ${trueStatement} : ${falseStatement};\n`;
                break;
            case $f0539ce4077945ff$export$ab670da661bb6d34.Or:
                state.compilationString += this._declareOutput(output, state) + ` = (min(${this.a.associatedVariableName} + ${this.b.associatedVariableName}, 1.0) > 0.0) ? ${trueStatement} : ${falseStatement};\n`;
                break;
            case $f0539ce4077945ff$export$ab670da661bb6d34.And:
                state.compilationString += this._declareOutput(output, state) + ` = (${this.a.associatedVariableName} * ${this.b.associatedVariableName} > 0.0)  ? ${trueStatement} : ${falseStatement};\n`;
                break;
        }
        return this;
    }
    serialize() {
        const serializationObject = super.serialize();
        serializationObject.condition = this.condition;
        return serializationObject;
    }
    _deserialize(serializationObject, scene, rootUrl) {
        super._deserialize(serializationObject, scene, rootUrl);
        this.condition = serializationObject.condition;
    }
    _dumpPropertiesCode() {
        const codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.condition = BABYLON.ConditionalBlockConditions.${$f0539ce4077945ff$export$ab670da661bb6d34[this.condition]};\n`;
        return codeString;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.ConditionalBlock", $f0539ce4077945ff$export$a867775f0a39adc9);

});

parcelRegister("5OQGp", function(module, exports) {

$parcel$export(module.exports, "CloudBlock", () => $43ca7cfdf92d9cc7$export$d90028c41e9ec2b3);

var $e0Suo = parcelRequire("e0Suo");

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");

var $1aXVF = parcelRequire("1aXVF");
class $43ca7cfdf92d9cc7$export$d90028c41e9ec2b3 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new CloudBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        /** Gets or sets the number of octaves */ this.octaves = 6.0;
        this.registerInput("seed", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerInput("chaos", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect, true);
        this.registerInput("offsetX", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true);
        this.registerInput("offsetY", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true);
        this.registerInput("offsetZ", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this._inputs[0].acceptedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2);
        this._inputs[0].acceptedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3);
        this._linkConnectionTypes(0, 1);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "CloudBlock";
    }
    /**
     * Gets the seed input component
     */ get seed() {
        return this._inputs[0];
    }
    /**
     * Gets the chaos input component
     */ get chaos() {
        return this._inputs[1];
    }
    /**
     * Gets the offset X input component
     */ get offsetX() {
        return this._inputs[2];
    }
    /**
     * Gets the offset Y input component
     */ get offsetY() {
        return this._inputs[3];
    }
    /**
     * Gets the offset Z input component
     */ get offsetZ() {
        return this._inputs[4];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        if (!this.seed.isConnected) return;
        if (!this._outputs[0].hasEndpoints) return;
        const functionString = `

        float cloudRandom(in float p) { p = fract(p * 0.011); p *= p + 7.5; p *= p + p; return fract(p); }

        // Based on Morgan McGuire @morgan3d
        // https://www.shadertoy.com/view/4dS3Wd
        float cloudNoise(in vec2 x, in vec2 chaos) {
            vec2 step = chaos * vec2(75., 120.) + vec2(75., 120.);

            vec2 i = floor(x);
            vec2 f = fract(x);

            float n = dot(i, step);

            vec2 u = f * f * (3.0 - 2.0 * f);
            return mix(
                    mix(cloudRandom(n + dot(step, vec2(0, 0))), cloudRandom(n + dot(step, vec2(1, 0))), u.x),
                    mix(cloudRandom(n + dot(step, vec2(0, 1))), cloudRandom(n + dot(step, vec2(1, 1))), u.x),
                    u.y
                );
        }

        float cloudNoise(in vec3 x, in vec3 chaos) {
            vec3 step = chaos * vec3(60., 120., 75.) + vec3(60., 120., 75.);

            vec3 i = floor(x);
            vec3 f = fract(x);

            float n = dot(i, step);

            vec3 u = f * f * (3.0 - 2.0 * f);
            return mix(mix(mix( cloudRandom(n + dot(step, vec3(0, 0, 0))), cloudRandom(n + dot(step, vec3(1, 0, 0))), u.x),
                           mix( cloudRandom(n + dot(step, vec3(0, 1, 0))), cloudRandom(n + dot(step, vec3(1, 1, 0))), u.x), u.y),
                       mix(mix( cloudRandom(n + dot(step, vec3(0, 0, 1))), cloudRandom(n + dot(step, vec3(1, 0, 1))), u.x),
                           mix( cloudRandom(n + dot(step, vec3(0, 1, 1))), cloudRandom(n + dot(step, vec3(1, 1, 1))), u.x), u.y), u.z);
        }`;
        const fractalBrownianString = `
        float fbm(in vec2 st, in vec2 chaos) {
            // Initial values
            float value = 0.0;
            float amplitude = .5;
            float frequency = 0.;

            // Loop of octaves
            for (int i = 0; i < OCTAVES; i++) {
                value += amplitude * cloudNoise(st, chaos);
                st *= 2.0;
                amplitude *= 0.5;
            }
            return value;
        }

        float fbm(in vec3 x, in vec3 chaos) {
            // Initial values
            float value = 0.0;
            float amplitude = 0.5;
            for (int i = 0; i < OCTAVES; ++i) {
                value += amplitude * cloudNoise(x, chaos);
                x = x * 2.0;
                amplitude *= 0.5;
            }
            return value;
        }`;
        const fbmNewName = `fbm${this.octaves}`;
        state._emitFunction("CloudBlockCode", functionString, "// CloudBlockCode");
        state._emitFunction("CloudBlockCodeFBM" + this.octaves, fractalBrownianString.replace(/fbm/gi, fbmNewName).replace(/OCTAVES/gi, (this.octaves | 0).toString()), "// CloudBlockCode FBM");
        const localVariable = state._getFreeVariableName("st");
        const seedType = this.seed.connectedPoint?.type === (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2 ? "vec2" : "vec3";
        state.compilationString += `${seedType} ${localVariable} = ${this.seed.associatedVariableName};\n`;
        if (this.offsetX.isConnected) state.compilationString += `${localVariable}.x += 0.1 * ${this.offsetX.associatedVariableName};\n`;
        if (this.offsetY.isConnected) state.compilationString += `${localVariable}.y += 0.1 * ${this.offsetY.associatedVariableName};\n`;
        if (this.offsetZ.isConnected && seedType === "vec3") state.compilationString += `${localVariable}.z += 0.1 * ${this.offsetZ.associatedVariableName};\n`;
        let chaosValue = "";
        if (this.chaos.isConnected) chaosValue = this.chaos.associatedVariableName;
        else chaosValue = this.seed.connectedPoint?.type === (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2 ? "vec2(0., 0.)" : "vec3(0., 0., 0.)";
        state.compilationString += this._declareOutput(this._outputs[0], state) + ` = ${fbmNewName}(${localVariable}, ${chaosValue});\n`;
        return this;
    }
    _dumpPropertiesCode() {
        const codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.octaves = ${this.octaves};\n`;
        return codeString;
    }
    serialize() {
        const serializationObject = super.serialize();
        serializationObject.octaves = this.octaves;
        return serializationObject;
    }
    _deserialize(serializationObject, scene, rootUrl) {
        super._deserialize(serializationObject, scene, rootUrl);
        this.octaves = serializationObject.octaves;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Octaves", (0, $1aXVF.PropertyTypeForEdition).Int)
], $43ca7cfdf92d9cc7$export$d90028c41e9ec2b3.prototype, "octaves", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.CloudBlock", $43ca7cfdf92d9cc7$export$d90028c41e9ec2b3);

});

parcelRegister("98lkH", function(module, exports) {

$parcel$export(module.exports, "VoronoiNoiseBlock", () => $6a6568a68f2fa89b$export$c69a20a92b394735);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $6a6568a68f2fa89b$export$c69a20a92b394735 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new VoronoiNoiseBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("seed", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2);
        this.registerInput("offset", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.registerInput("density", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
        this.registerOutput("cells", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "VoronoiNoiseBlock";
    }
    /**
     * Gets the seed input component
     */ get seed() {
        return this._inputs[0];
    }
    /**
     * Gets the offset input component
     */ get offset() {
        return this._inputs[1];
    }
    /**
     * Gets the density input component
     */ get density() {
        return this._inputs[2];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    /**
     * Gets the output component
     */ get cells() {
        return this._outputs[1];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        if (!this.seed.isConnected) return;
        let functionString = `vec2 voronoiRandom(vec2 seed, float offset){
            mat2 m = mat2(15.27, 47.63, 99.41, 89.98);
            vec2 uv = fract(sin(m * seed) * 46839.32);
            return vec2(sin(uv.y * offset) * 0.5 + 0.5, cos(uv.x * offset) * 0.5 + 0.5);
        }
        `;
        state._emitFunction("voronoiRandom", functionString, "// Voronoi random generator");
        functionString = `void voronoi(vec2 seed, float offset, float density, out float outValue, out float cells){
            vec2 g = floor(seed * density);
            vec2 f = fract(seed * density);
            float t = 8.0;
            vec3 res = vec3(8.0, 0.0, 0.0);

            for(int y=-1; y<=1; y++)
            {
                for(int x=-1; x<=1; x++)
                {
                    vec2 lattice = vec2(x,y);
                    vec2 randomOffset = voronoiRandom(lattice + g, offset);
                    float d = distance(lattice + randomOffset, f);
                    if(d < res.x)
                    {
                        res = vec3(d, randomOffset.x, randomOffset.y);
                        outValue = res.x;
                        cells = res.y;
                    }
                }
            }
        }
        `;
        state._emitFunction("voronoi", functionString, "// Voronoi");
        const tempOutput = state._getFreeVariableName("tempOutput");
        const tempCells = state._getFreeVariableName("tempCells");
        state.compilationString += `float ${tempOutput} = 0.0;\n`;
        state.compilationString += `float ${tempCells} = 0.0;\n`;
        state.compilationString += `voronoi(${this.seed.associatedVariableName}, ${this.offset.associatedVariableName}, ${this.density.associatedVariableName}, ${tempOutput}, ${tempCells});\n`;
        if (this.output.hasEndpoints) state.compilationString += this._declareOutput(this.output, state) + ` = ${tempOutput};\n`;
        if (this.cells.hasEndpoints) state.compilationString += this._declareOutput(this.cells, state) + ` = ${tempCells};\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.VoronoiNoiseBlock", $6a6568a68f2fa89b$export$c69a20a92b394735);

});

parcelRegister("1UCax", function(module, exports) {

$parcel$export(module.exports, "ElbowBlock", () => $1648a0f37f67fe32$export$6125852c79ab03e9);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $1648a0f37f67fe32$export$6125852c79ab03e9 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new ElbowBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("input", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "ElbowBlock";
    }
    /**
     * Gets the input component
     */ get input() {
        return this._inputs[0];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    /**
     * Gets or sets the target of the block
     */ get target() {
        const input = this._inputs[0];
        if (input.isConnected) {
            const block = input.connectedPoint.ownerBlock;
            if (block.target !== (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment) return block.target;
            if (input.connectedPoint.target !== (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment) return input.connectedPoint.target;
        }
        return this._target;
    }
    set target(value) {
        if ((this._target & value) !== 0) return;
        this._target = value;
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        const input = this._inputs[0];
        state.compilationString += this._declareOutput(output, state) + ` = ${input.associatedVariableName};\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.ElbowBlock", $1648a0f37f67fe32$export$6125852c79ab03e9);

});

parcelRegister("8fgUJ", function(module, exports) {

$parcel$export(module.exports, "TriPlanarBlock", () => $600cd83882844af4$export$3d129b82b29a186a);

var $e0Suo = parcelRequire("e0Suo");

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $g92b7 = parcelRequire("g92b7");

var $5fNQr = parcelRequire("5fNQr");

var $8DoUR = parcelRequire("8DoUR");

var $j2mX5 = parcelRequire("j2mX5");
parcelRequire("7Hs3g");

var $0nhKt = parcelRequire("0nhKt");

var $dTtBA = parcelRequire("dTtBA");

var $ejQPp = parcelRequire("ejQPp");

var $1aXVF = parcelRequire("1aXVF");
class $600cd83882844af4$export$3d129b82b29a186a extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Gets or sets the texture associated with the node
     */ get texture() {
        if (this.source.isConnected) return (this.source.connectedPoint?.ownerBlock).texture;
        return this._texture;
    }
    set texture(texture) {
        if (this._texture === texture) return;
        const scene = texture?.getScene() ?? (0, $ejQPp.EngineStore).LastCreatedScene;
        if (!texture && scene) scene.markAllMaterialsAsDirty(1, (mat)=>{
            return mat.hasTexture(this._texture);
        });
        this._texture = texture;
        if (texture && scene) scene.markAllMaterialsAsDirty(1, (mat)=>{
            return mat.hasTexture(texture);
        });
    }
    /**
     * Gets the textureY associated with the node
     */ get textureY() {
        if (this.sourceY.isConnected) return (this.sourceY.connectedPoint?.ownerBlock).texture;
        return null;
    }
    /**
     * Gets the textureZ associated with the node
     */ get textureZ() {
        if (this.sourceZ?.isConnected) return (this.sourceY.connectedPoint?.ownerBlock).texture;
        return null;
    }
    _getImageSourceBlock(connectionPoint) {
        return connectionPoint?.isConnected ? connectionPoint.connectedPoint.ownerBlock : null;
    }
    /**
     * Gets the sampler name associated with this texture
     */ get samplerName() {
        const imageSourceBlock = this._getImageSourceBlock(this.source);
        if (imageSourceBlock) return imageSourceBlock.samplerName;
        return this._samplerName;
    }
    /**
     * Gets the samplerY name associated with this texture
     */ get samplerYName() {
        return this._getImageSourceBlock(this.sourceY)?.samplerName ?? null;
    }
    /**
     * Gets the samplerZ name associated with this texture
     */ get samplerZName() {
        return this._getImageSourceBlock(this.sourceZ)?.samplerName ?? null;
    }
    /**
     * Gets a boolean indicating that this block is linked to an ImageSourceBlock
     */ get hasImageSource() {
        return this.source.isConnected;
    }
    /**
     * Gets or sets a boolean indicating if content needs to be converted to gamma space
     */ set convertToGammaSpace(value) {
        if (value === this._convertToGammaSpace) return;
        this._convertToGammaSpace = value;
        if (this.texture) {
            const scene = this.texture.getScene() ?? (0, $ejQPp.EngineStore).LastCreatedScene;
            scene?.markAllMaterialsAsDirty(1, (mat)=>{
                return mat.hasTexture(this.texture);
            });
        }
    }
    get convertToGammaSpace() {
        return this._convertToGammaSpace;
    }
    /**
     * Gets or sets a boolean indicating if content needs to be converted to linear space
     */ set convertToLinearSpace(value) {
        if (value === this._convertToLinearSpace) return;
        this._convertToLinearSpace = value;
        if (this.texture) {
            const scene = this.texture.getScene() ?? (0, $ejQPp.EngineStore).LastCreatedScene;
            scene?.markAllMaterialsAsDirty(1, (mat)=>{
                return mat.hasTexture(this.texture);
            });
        }
    }
    get convertToLinearSpace() {
        return this._convertToLinearSpace;
    }
    /**
     * Create a new TriPlanarBlock
     * @param name defines the block name
     * @param hideSourceZ defines a boolean indicating that normal Z should not be used (false by default)
     */ constructor(name, hideSourceZ = false){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        /**
         * Project the texture(s) for a better fit to a cube
         */ this.projectAsCube = false;
        this._convertToGammaSpace = false;
        this._convertToLinearSpace = false;
        /**
         * Gets or sets a boolean indicating if multiplication of texture with level should be disabled
         */ this.disableLevelMultiplication = false;
        this.registerInput("position", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect, false);
        this.registerInput("normal", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect, false);
        this.registerInput("sharpness", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, true);
        this.registerInput("source", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Object, true, (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment, new (0, $dTtBA.NodeMaterialConnectionPointCustomObject)("source", this, (0, $g92b7.NodeMaterialConnectionPointDirection).Input, (0, $0nhKt.ImageSourceBlock), "ImageSourceBlock"));
        this.registerInput("sourceY", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Object, true, (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment, new (0, $dTtBA.NodeMaterialConnectionPointCustomObject)("sourceY", this, (0, $g92b7.NodeMaterialConnectionPointDirection).Input, (0, $0nhKt.ImageSourceBlock), "ImageSourceBlock"));
        if (!hideSourceZ) this.registerInput("sourceZ", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Object, true, (0, $iAIIe.NodeMaterialBlockTargets).VertexAndFragment, new (0, $dTtBA.NodeMaterialConnectionPointCustomObject)("sourceZ", this, (0, $g92b7.NodeMaterialConnectionPointDirection).Input, (0, $0nhKt.ImageSourceBlock), "ImageSourceBlock"));
        this.registerOutput("rgba", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerOutput("rgb", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerOutput("r", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerOutput("g", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerOutput("b", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerOutput("a", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerOutput("level", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this._inputs[0].addExcludedConnectionPointFromAllowedTypes((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4);
        this._inputs[1].addExcludedConnectionPointFromAllowedTypes((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3 | (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "TriPlanarBlock";
    }
    /**
     * Gets the position input component
     */ get position() {
        return this._inputs[0];
    }
    /**
     * Gets the normal input component
     */ get normal() {
        return this._inputs[1];
    }
    /**
     * Gets the sharpness input component
     */ get sharpness() {
        return this._inputs[2];
    }
    /**
     * Gets the source input component
     */ get source() {
        return this._inputs[3];
    }
    /**
     * Gets the sourceY input component
     */ get sourceY() {
        return this._inputs[4];
    }
    /**
     * Gets the sourceZ input component
     */ get sourceZ() {
        return this._inputs[5];
    }
    /**
     * Gets the rgba output component
     */ get rgba() {
        return this._outputs[0];
    }
    /**
     * Gets the rgb output component
     */ get rgb() {
        return this._outputs[1];
    }
    /**
     * Gets the r output component
     */ get r() {
        return this._outputs[2];
    }
    /**
     * Gets the g output component
     */ get g() {
        return this._outputs[3];
    }
    /**
     * Gets the b output component
     */ get b() {
        return this._outputs[4];
    }
    /**
     * Gets the a output component
     */ get a() {
        return this._outputs[5];
    }
    /**
     * Gets the level output component
     */ get level() {
        return this._outputs[6];
    }
    prepareDefines(mesh, nodeMaterial, defines) {
        if (!defines._areTexturesDirty) return;
        const toGamma = this.convertToGammaSpace && this.texture && !this.texture.gammaSpace;
        const toLinear = this.convertToLinearSpace && this.texture && this.texture.gammaSpace;
        // Not a bug... Name defines the texture space not the required conversion
        defines.setValue(this._linearDefineName, toGamma, true);
        defines.setValue(this._gammaDefineName, toLinear, true);
    }
    isReady() {
        if (this.texture && !this.texture.isReadyOrNotBlocking()) return false;
        return true;
    }
    bind(effect) {
        if (!this.texture) return;
        effect.setFloat(this._textureInfoName, this.texture.level);
        if (!this._imageSource) effect.setTexture(this._samplerName, this.texture);
    }
    _generateTextureLookup(state) {
        const samplerName = this.samplerName;
        const samplerYName = this.samplerYName ?? samplerName;
        const samplerZName = this.samplerZName ?? samplerName;
        const sharpness = this.sharpness.isConnected ? this.sharpness.associatedVariableName : "1.0";
        const x = state._getFreeVariableName("x");
        const y = state._getFreeVariableName("y");
        const z = state._getFreeVariableName("z");
        const w = state._getFreeVariableName("w");
        const n = state._getFreeVariableName("n");
        const uvx = state._getFreeVariableName("uvx");
        const uvy = state._getFreeVariableName("uvy");
        const uvz = state._getFreeVariableName("uvz");
        state.compilationString += `
            vec3 ${n} = ${this.normal.associatedVariableName}.xyz;

            vec2 ${uvx} = ${this.position.associatedVariableName}.yz;
            vec2 ${uvy} = ${this.position.associatedVariableName}.zx;
            vec2 ${uvz} = ${this.position.associatedVariableName}.xy;
        `;
        if (this.projectAsCube) state.compilationString += `
                ${uvx}.xy = ${uvx}.yx;

                if (${n}.x >= 0.0) {
                    ${uvx}.x = -${uvx}.x;
                }
                if (${n}.y < 0.0) {
                    ${uvy}.y = -${uvy}.y;
                }
                if (${n}.z < 0.0) {
                    ${uvz}.x = -${uvz}.x;
                }
            `;
        state.compilationString += `
            vec4 ${x} = texture2D(${samplerName}, ${uvx});
            vec4 ${y} = texture2D(${samplerYName}, ${uvy});
            vec4 ${z} = texture2D(${samplerZName}, ${uvz});
           
            // blend weights
            vec3 ${w} = pow(abs(${n}), vec3(${sharpness}));

            // blend and return
            vec4 ${this._tempTextureRead} = (${x}*${w}.x + ${y}*${w}.y + ${z}*${w}.z) / (${w}.x + ${w}.y + ${w}.z);        
        `;
    }
    _generateConversionCode(state, output, swizzle) {
        if (swizzle !== "a") {
            // no conversion if the output is "a" (alpha)
            if (!this.texture || !this.texture.gammaSpace) state.compilationString += `#ifdef ${this._linearDefineName}
                    ${output.associatedVariableName} = toGammaSpace(${output.associatedVariableName});
                    #endif
                `;
            state.compilationString += `#ifdef ${this._gammaDefineName}
                ${output.associatedVariableName} = toLinearSpace(${output.associatedVariableName});
                #endif
            `;
        }
    }
    _writeOutput(state, output, swizzle) {
        let complement = "";
        if (!this.disableLevelMultiplication) complement = ` * ${this._textureInfoName}`;
        state.compilationString += `${this._declareOutput(output, state)} = ${this._tempTextureRead}.${swizzle}${complement};\n`;
        this._generateConversionCode(state, output, swizzle);
    }
    _buildBlock(state) {
        super._buildBlock(state);
        if (this.source.isConnected) this._imageSource = this.source.connectedPoint.ownerBlock;
        else this._imageSource = null;
        this._textureInfoName = state._getFreeVariableName("textureInfoName");
        this.level.associatedVariableName = this._textureInfoName;
        this._tempTextureRead = state._getFreeVariableName("tempTextureRead");
        this._linearDefineName = state._getFreeDefineName("ISLINEAR");
        this._gammaDefineName = state._getFreeDefineName("ISGAMMA");
        if (!this._imageSource) {
            this._samplerName = state._getFreeVariableName(this.name + "Sampler");
            state._emit2DSampler(this._samplerName);
        }
        // Declarations
        state.sharedData.blockingBlocks.push(this);
        state.sharedData.textureBlocks.push(this);
        state.sharedData.blocksWithDefines.push(this);
        state.sharedData.bindableBlocks.push(this);
        const comments = `//${this.name}`;
        state._emitFunctionFromInclude("helperFunctions", comments);
        state._emitUniformFromString(this._textureInfoName, "float");
        this._generateTextureLookup(state);
        for (const output of this._outputs)if (output.hasEndpoints && output.name !== "level") this._writeOutput(state, output, output.name);
        return this;
    }
    _dumpPropertiesCode() {
        let codeString = super._dumpPropertiesCode();
        codeString += `${this._codeVariableName}.convertToGammaSpace = ${this.convertToGammaSpace};\n`;
        codeString += `${this._codeVariableName}.convertToLinearSpace = ${this.convertToLinearSpace};\n`;
        codeString += `${this._codeVariableName}.disableLevelMultiplication = ${this.disableLevelMultiplication};\n`;
        codeString += `${this._codeVariableName}.projectAsCube = ${this.projectAsCube};\n`;
        if (!this.texture) return codeString;
        codeString += `${this._codeVariableName}.texture = new BABYLON.Texture("${this.texture.name}", null, ${this.texture.noMipmap}, ${this.texture.invertY}, ${this.texture.samplingMode});\n`;
        codeString += `${this._codeVariableName}.texture.wrapU = ${this.texture.wrapU};\n`;
        codeString += `${this._codeVariableName}.texture.wrapV = ${this.texture.wrapV};\n`;
        codeString += `${this._codeVariableName}.texture.uAng = ${this.texture.uAng};\n`;
        codeString += `${this._codeVariableName}.texture.vAng = ${this.texture.vAng};\n`;
        codeString += `${this._codeVariableName}.texture.wAng = ${this.texture.wAng};\n`;
        codeString += `${this._codeVariableName}.texture.uOffset = ${this.texture.uOffset};\n`;
        codeString += `${this._codeVariableName}.texture.vOffset = ${this.texture.vOffset};\n`;
        codeString += `${this._codeVariableName}.texture.uScale = ${this.texture.uScale};\n`;
        codeString += `${this._codeVariableName}.texture.vScale = ${this.texture.vScale};\n`;
        codeString += `${this._codeVariableName}.texture.coordinatesMode = ${this.texture.coordinatesMode};\n`;
        return codeString;
    }
    serialize() {
        const serializationObject = super.serialize();
        serializationObject.convertToGammaSpace = this.convertToGammaSpace;
        serializationObject.convertToLinearSpace = this.convertToLinearSpace;
        serializationObject.disableLevelMultiplication = this.disableLevelMultiplication;
        serializationObject.projectAsCube = this.projectAsCube;
        if (!this.hasImageSource && this.texture && !this.texture.isRenderTarget && this.texture.getClassName() !== "VideoTexture") serializationObject.texture = this.texture.serialize();
        return serializationObject;
    }
    _deserialize(serializationObject, scene, rootUrl) {
        super._deserialize(serializationObject, scene, rootUrl);
        this.convertToGammaSpace = serializationObject.convertToGammaSpace;
        this.convertToLinearSpace = !!serializationObject.convertToLinearSpace;
        this.disableLevelMultiplication = !!serializationObject.disableLevelMultiplication;
        this.projectAsCube = !!serializationObject.projectAsCube;
        if (serializationObject.texture && !(0, $5fNQr.NodeMaterial).IgnoreTexturesAtLoadTime && serializationObject.texture.url !== undefined) {
            rootUrl = serializationObject.texture.url.indexOf("data:") === 0 ? "" : rootUrl;
            this.texture = (0, $j2mX5.Texture).Parse(serializationObject.texture, scene, rootUrl);
        }
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Project as cube", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            update: true
        }
    })
], $600cd83882844af4$export$3d129b82b29a186a.prototype, "projectAsCube", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.TriPlanarBlock", $600cd83882844af4$export$3d129b82b29a186a);

});

parcelRegister("52cvd", function(module, exports) {

$parcel$export(module.exports, "BiPlanarBlock", () => $3aa6d660b0fb521a$export$ffce82d08dcf2b2c);

var $8DoUR = parcelRequire("8DoUR");

var $8fgUJ = parcelRequire("8fgUJ");
class $3aa6d660b0fb521a$export$ffce82d08dcf2b2c extends (0, $8fgUJ.TriPlanarBlock) {
    /**
     * Create a new BiPlanarBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, true);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "BiPlanarBlock";
    }
    _generateTextureLookup(state) {
        const samplerName = this.samplerName;
        const samplerYName = this.samplerYName ?? this.samplerName;
        const sharpness = this.sharpness.isConnected ? this.sharpness.associatedVariableName : "1.0";
        const dpdx = state._getFreeVariableName("dpdx");
        const dpdy = state._getFreeVariableName("dpdy");
        const n = state._getFreeVariableName("n");
        const ma = state._getFreeVariableName("ma");
        const mi = state._getFreeVariableName("mi");
        const me = state._getFreeVariableName("me");
        const x = state._getFreeVariableName("x");
        const y = state._getFreeVariableName("y");
        const w = state._getFreeVariableName("y");
        state.compilationString += `
            // grab coord derivatives for texturing
            vec3 ${dpdx} = dFdx(${this.position.associatedVariableName}.xyz);
            vec3 ${dpdy} = dFdy(${this.position.associatedVariableName}.xyz);
            vec3 ${n} = abs(${this.normal.associatedVariableName}.xyz);
        
            // determine major axis (in x; yz are following axis)
            ivec3 ${ma} = (${n}.x>${n}.y && ${n}.x>${n}.z) ? ivec3(0,1,2) :
                    (${n}.y>${n}.z)            ? ivec3(1,2,0) :
                                            ivec3(2,0,1) ;
            // determine minor axis (in x; yz are following axis)
            ivec3 ${mi} = (${n}.x<${n}.y && ${n}.x<${n}.z) ? ivec3(0,1,2) :
                    (${n}.y<${n}.z)            ? ivec3(1,2,0) :
                                            ivec3(2,0,1) ;
            // determine median axis (in x;  yz are following axis)
            ivec3 ${me} = ivec3(3) - ${mi} - ${ma};
            
            // project+fetch
            vec4 ${x} = textureGrad( ${samplerName}, vec2(   ${this.position.associatedVariableName}[${ma}.y],   ${this.position.associatedVariableName}[${ma}.z]), 
                                    vec2(${dpdx}[${ma}.y],${dpdx}[${ma}.z]), 
                                    vec2(${dpdy}[${ma}.y],${dpdy}[${ma}.z]) );
            vec4 ${y} = textureGrad( ${samplerYName}, vec2(   ${this.position.associatedVariableName}[${me}.y],   ${this.position.associatedVariableName}[${me}.z]), 
                                    vec2(${dpdx}[${me}.y],${dpdx}[${me}.z]),
                                    vec2(${dpdy}[${me}.y],${dpdy}[${me}.z]) );
            
            // blend factors
            vec2 ${w} = vec2(${n}[${ma}.x],${n}[${me}.x]);
            // make local support
            ${w} = clamp( (${w}-0.5773)/(1.0-0.5773), 0.0, 1.0 );
            // shape transition
            ${w} = pow( ${w}, vec2(${sharpness}/8.0) );
            // blend and return
            vec4 ${this._tempTextureRead} = (${x}*${w}.x + ${y}*${w}.y) / (${w}.x + ${w}.y);
        `;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.BiPlanarBlock", $3aa6d660b0fb521a$export$ffce82d08dcf2b2c);

});

parcelRegister("jdXLf", function(module, exports) {

$parcel$export(module.exports, "MatrixDeterminantBlock", () => $dfed968028fd0cea$export$87b759b68899f540);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $dfed968028fd0cea$export$87b759b68899f540 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new MatrixDeterminantBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("input", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "MatrixDeterminantBlock";
    }
    /**
     * Gets the input matrix
     */ get input() {
        return this._inputs[0];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this.output;
        const input = this.input;
        state.compilationString += this._declareOutput(output, state) + `${output.associatedVariableName} = determinant(${input.associatedVariableName});\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.MatrixDeterminantBlock", $dfed968028fd0cea$export$87b759b68899f540);

});

parcelRegister("cYxyI", function(module, exports) {

$parcel$export(module.exports, "MatrixTransposeBlock", () => $97251eb8fdd705da$export$4c5f1826f6be1d64);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
class $97251eb8fdd705da$export$4c5f1826f6be1d64 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new MatrixTransposeBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        this.registerInput("input", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "MatrixTransposeBlock";
    }
    /**
     * Gets the input matrix
     */ get input() {
        return this._inputs[0];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this.output;
        const input = this.input;
        state.compilationString += this._declareOutput(output, state) + `${output.associatedVariableName} = transpose(${input.associatedVariableName});\n`;
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.MatrixTransposeBlock", $97251eb8fdd705da$export$4c5f1826f6be1d64);

});

parcelRegister("fqovS", function(module, exports) {

$parcel$export(module.exports, "MeshAttributeExistsBlockTypes", () => $b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a);
$parcel$export(module.exports, "MeshAttributeExistsBlock", () => $b3ac4c8b7d66a8b0$export$2e138bbba0ebc788);

var $e0Suo = parcelRequire("e0Suo");

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");

var $aKEh2 = parcelRequire("aKEh2");

var $5JyDL = parcelRequire("5JyDL");

var $1aXVF = parcelRequire("1aXVF");
var $b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a;
(function(MeshAttributeExistsBlockTypes) {
    MeshAttributeExistsBlockTypes[MeshAttributeExistsBlockTypes["None"] = 0] = "None";
    MeshAttributeExistsBlockTypes[MeshAttributeExistsBlockTypes["Normal"] = 1] = "Normal";
    MeshAttributeExistsBlockTypes[MeshAttributeExistsBlockTypes["Tangent"] = 2] = "Tangent";
    MeshAttributeExistsBlockTypes[MeshAttributeExistsBlockTypes["VertexColor"] = 3] = "VertexColor";
    MeshAttributeExistsBlockTypes[MeshAttributeExistsBlockTypes["UV1"] = 4] = "UV1";
    MeshAttributeExistsBlockTypes[MeshAttributeExistsBlockTypes["UV2"] = 5] = "UV2";
    MeshAttributeExistsBlockTypes[MeshAttributeExistsBlockTypes["UV3"] = 6] = "UV3";
    MeshAttributeExistsBlockTypes[MeshAttributeExistsBlockTypes["UV4"] = 7] = "UV4";
    MeshAttributeExistsBlockTypes[MeshAttributeExistsBlockTypes["UV5"] = 8] = "UV5";
    MeshAttributeExistsBlockTypes[MeshAttributeExistsBlockTypes["UV6"] = 9] = "UV6";
})($b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a || ($b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a = {}));
class $b3ac4c8b7d66a8b0$export$2e138bbba0ebc788 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new MeshAttributeExistsBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        /**
         * Defines which mesh attribute to use
         */ this.attributeType = $b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a.None;
        this.registerInput("input", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerInput("fallback", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
        this._linkConnectionTypes(0, 1);
        // Try to auto determine attributeType
        this._inputs[0].onConnectionObservable.add((other)=>{
            if (this.attributeType) // But only if not already specified
            return;
            const sourceBlock = other.ownerBlock;
            if (sourceBlock instanceof (0, $aKEh2.InputBlock) && sourceBlock.isAttribute) switch(sourceBlock.name){
                case "color":
                    this.attributeType = $b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a.VertexColor;
                    break;
                case "normal":
                    this.attributeType = $b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a.Normal;
                    break;
                case "tangent":
                    this.attributeType = $b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a.Tangent;
                    break;
                case "uv":
                    this.attributeType = $b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a.UV1;
                    break;
                case "uv2":
                    this.attributeType = $b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a.UV2;
                    break;
                case "uv3":
                    this.attributeType = $b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a.UV3;
                    break;
                case "uv4":
                    this.attributeType = $b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a.UV4;
                    break;
                case "uv5":
                    this.attributeType = $b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a.UV5;
                    break;
                case "uv6":
                    this.attributeType = $b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a.UV6;
                    break;
            }
            else if (sourceBlock instanceof (0, $5JyDL.MorphTargetsBlock)) switch(this.input.connectedPoint?.name){
                case "normalOutput":
                    this.attributeType = $b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a.Normal;
                    break;
                case "tangentOutput":
                    this.attributeType = $b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a.Tangent;
                    break;
                case "uvOutput":
                    this.attributeType = $b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a.UV1;
                    break;
            }
        });
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "MeshAttributeExistsBlock";
    }
    /**
     * Gets the input component
     */ get input() {
        return this._inputs[0];
    }
    /**
     * Gets the fallback component when speciefied attribute doesn't exist
     */ get fallback() {
        return this._inputs[1];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        let attributeDefine = null;
        switch(this.attributeType){
            case $b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a.VertexColor:
                attributeDefine = "VERTEXCOLOR_NME";
                break;
            case $b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a.Normal:
                attributeDefine = "NORMAL";
                break;
            case $b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a.Tangent:
                attributeDefine = "TANGENT";
                break;
            case $b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a.UV1:
                attributeDefine = "UV1";
                break;
            case $b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a.UV2:
                attributeDefine = "UV2";
                break;
            case $b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a.UV3:
                attributeDefine = "UV3";
                break;
            case $b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a.UV4:
                attributeDefine = "UV4";
                break;
            case $b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a.UV5:
                attributeDefine = "UV5";
                break;
            case $b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a.UV6:
                attributeDefine = "UV6";
                break;
        }
        const output = this._declareOutput(this.output, state);
        if (attributeDefine) state.compilationString += `#ifdef ${attributeDefine}\n`;
        state.compilationString += `${output} = ${this.input.associatedVariableName};\n`;
        if (attributeDefine) {
            state.compilationString += `#else\n`;
            state.compilationString += `${output} = ${this.fallback.associatedVariableName};\n`;
            state.compilationString += `#endif\n`;
        }
        return this;
    }
    serialize() {
        const serializationObject = super.serialize();
        serializationObject.attributeType = this.attributeType;
        return serializationObject;
    }
    _deserialize(serializationObject, scene, rootUrl) {
        super._deserialize(serializationObject, scene, rootUrl);
        this.attributeType = serializationObject.attributeType ?? $b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a.None;
    }
    _dumpPropertiesCode() {
        let codeString = super._dumpPropertiesCode();
        codeString += `${this._codeVariableName}.attributeType = ${this.attributeType};\n`;
        return codeString;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Attribute lookup", (0, $1aXVF.PropertyTypeForEdition).List, undefined, {
        notifiers: {
            update: true
        },
        options: [
            {
                label: "(None)",
                value: $b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a.None
            },
            {
                label: "Normal",
                value: $b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a.Normal
            },
            {
                label: "Tangent",
                value: $b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a.Tangent
            },
            {
                label: "Vertex Color",
                value: $b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a.VertexColor
            },
            {
                label: "UV1",
                value: $b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a.UV1
            },
            {
                label: "UV2",
                value: $b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a.UV2
            },
            {
                label: "UV3",
                value: $b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a.UV3
            },
            {
                label: "UV4",
                value: $b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a.UV4
            },
            {
                label: "UV5",
                value: $b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a.UV5
            },
            {
                label: "UV6",
                value: $b3ac4c8b7d66a8b0$export$f6e107d13c7f4c2a.UV6
            }
        ]
    })
], $b3ac4c8b7d66a8b0$export$2e138bbba0ebc788.prototype, "attributeType", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.MeshAttributeExistsBlock", $b3ac4c8b7d66a8b0$export$2e138bbba0ebc788);

});

parcelRegister("9OUks", function(module, exports) {

$parcel$export(module.exports, "CurveBlockTypes", () => $72647a53c81c1fc1$export$137d4afcdbc674c0);
$parcel$export(module.exports, "CurveBlock", () => $72647a53c81c1fc1$export$bbefad92f0492a24);

var $kpKE2 = parcelRequire("kpKE2");

var $3mKw5 = parcelRequire("3mKw5");

var $iAIIe = parcelRequire("iAIIe");

var $8DoUR = parcelRequire("8DoUR");
var $72647a53c81c1fc1$export$137d4afcdbc674c0;
(function(CurveBlockTypes) {
    /** EaseInSine */ CurveBlockTypes[CurveBlockTypes["EaseInSine"] = 0] = "EaseInSine";
    /** EaseOutSine */ CurveBlockTypes[CurveBlockTypes["EaseOutSine"] = 1] = "EaseOutSine";
    /** EaseInOutSine */ CurveBlockTypes[CurveBlockTypes["EaseInOutSine"] = 2] = "EaseInOutSine";
    /** EaseInQuad */ CurveBlockTypes[CurveBlockTypes["EaseInQuad"] = 3] = "EaseInQuad";
    /** EaseOutQuad */ CurveBlockTypes[CurveBlockTypes["EaseOutQuad"] = 4] = "EaseOutQuad";
    /** EaseInOutQuad */ CurveBlockTypes[CurveBlockTypes["EaseInOutQuad"] = 5] = "EaseInOutQuad";
    /** EaseInCubic */ CurveBlockTypes[CurveBlockTypes["EaseInCubic"] = 6] = "EaseInCubic";
    /** EaseOutCubic */ CurveBlockTypes[CurveBlockTypes["EaseOutCubic"] = 7] = "EaseOutCubic";
    /** EaseInOutCubic */ CurveBlockTypes[CurveBlockTypes["EaseInOutCubic"] = 8] = "EaseInOutCubic";
    /** EaseInQuart */ CurveBlockTypes[CurveBlockTypes["EaseInQuart"] = 9] = "EaseInQuart";
    /** EaseOutQuart */ CurveBlockTypes[CurveBlockTypes["EaseOutQuart"] = 10] = "EaseOutQuart";
    /** EaseInOutQuart */ CurveBlockTypes[CurveBlockTypes["EaseInOutQuart"] = 11] = "EaseInOutQuart";
    /** EaseInQuint */ CurveBlockTypes[CurveBlockTypes["EaseInQuint"] = 12] = "EaseInQuint";
    /** EaseOutQuint */ CurveBlockTypes[CurveBlockTypes["EaseOutQuint"] = 13] = "EaseOutQuint";
    /** EaseInOutQuint */ CurveBlockTypes[CurveBlockTypes["EaseInOutQuint"] = 14] = "EaseInOutQuint";
    /** EaseInExpo */ CurveBlockTypes[CurveBlockTypes["EaseInExpo"] = 15] = "EaseInExpo";
    /** EaseOutExpo */ CurveBlockTypes[CurveBlockTypes["EaseOutExpo"] = 16] = "EaseOutExpo";
    /** EaseInOutExpo */ CurveBlockTypes[CurveBlockTypes["EaseInOutExpo"] = 17] = "EaseInOutExpo";
    /** EaseInCirc */ CurveBlockTypes[CurveBlockTypes["EaseInCirc"] = 18] = "EaseInCirc";
    /** EaseOutCirc */ CurveBlockTypes[CurveBlockTypes["EaseOutCirc"] = 19] = "EaseOutCirc";
    /** EaseInOutCirc */ CurveBlockTypes[CurveBlockTypes["EaseInOutCirc"] = 20] = "EaseInOutCirc";
    /** EaseInBack */ CurveBlockTypes[CurveBlockTypes["EaseInBack"] = 21] = "EaseInBack";
    /** EaseOutBack */ CurveBlockTypes[CurveBlockTypes["EaseOutBack"] = 22] = "EaseOutBack";
    /** EaseInOutBack */ CurveBlockTypes[CurveBlockTypes["EaseInOutBack"] = 23] = "EaseInOutBack";
    /** EaseInElastic */ CurveBlockTypes[CurveBlockTypes["EaseInElastic"] = 24] = "EaseInElastic";
    /** EaseOutElastic */ CurveBlockTypes[CurveBlockTypes["EaseOutElastic"] = 25] = "EaseOutElastic";
    /** EaseInOutElastic */ CurveBlockTypes[CurveBlockTypes["EaseInOutElastic"] = 26] = "EaseInOutElastic";
})($72647a53c81c1fc1$export$137d4afcdbc674c0 || ($72647a53c81c1fc1$export$137d4afcdbc674c0 = {}));
class $72647a53c81c1fc1$export$bbefad92f0492a24 extends (0, $kpKE2.NodeMaterialBlock) {
    /**
     * Creates a new CurveBlock
     * @param name defines the block name
     */ constructor(name){
        super(name, (0, $iAIIe.NodeMaterialBlockTargets).Neutral);
        /**
         * Gets or sets the type of the curve applied by the block
         */ this.type = $72647a53c81c1fc1$export$137d4afcdbc674c0.EaseInOutSine;
        this.registerInput("input", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
        this._inputs[0].excludedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Matrix);
        this._inputs[0].excludedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Object);
        this._inputs[0].excludedConnectionPointTypes.push((0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Int);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "CurveBlock";
    }
    /**
     * Gets the input component
     */ get input() {
        return this._inputs[0];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _duplicateEntry(entry, component) {
        return `ret.${component} = ${entry.replace(/VAL/g, "v." + component)}`;
    }
    _duplicateEntryDirect(entry) {
        return `return ${entry.replace(/VAL/g, "v")}`;
    }
    _duplicateVector(entry, inputType) {
        if (inputType === "float") return this._duplicateEntryDirect(entry);
        const size = parseInt(inputType.replace("vec", ""));
        let code = `
            vec${size} ret = vec${size}(0.0);
        `;
        for(let i = 1; i <= size; i++)code += this._duplicateEntry(entry, i === 1 ? "x" : i === 2 ? "y" : i === 3 ? "z" : "w") + ";\n";
        code += "return ret;\n";
        return code;
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        let registeredFunction = "";
        let registeredFunctionName = "";
        let inputType = "";
        switch(this.input.type){
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Float:
                inputType = "float";
                break;
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector2:
                inputType = "vec2";
                break;
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector3:
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color3:
                inputType = "vec3";
                break;
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Vector4:
            case (0, $3mKw5.NodeMaterialBlockConnectionPointTypes).Color4:
                inputType = "vec4";
                break;
        }
        registeredFunctionName = $72647a53c81c1fc1$export$137d4afcdbc674c0[this.type] + "_" + inputType;
        switch(this.type){
            case $72647a53c81c1fc1$export$137d4afcdbc674c0.EaseInSine:
                registeredFunction = `return 1.0 - cos((v * 3.1415) / 2.0)`;
                break;
            case $72647a53c81c1fc1$export$137d4afcdbc674c0.EaseOutSine:
                registeredFunction = `return sin((v * 3.1415) / 2.0)`;
                break;
            case $72647a53c81c1fc1$export$137d4afcdbc674c0.EaseInOutSine:
                registeredFunction = `return -(cos(v * 3.1415) - 1.0) / 2.0`;
                break;
            case $72647a53c81c1fc1$export$137d4afcdbc674c0.EaseInQuad:
                registeredFunction = `return v * v`;
                break;
            case $72647a53c81c1fc1$export$137d4afcdbc674c0.EaseOutQuad:
                registeredFunction = `return (1.0 - v) * (1.0 - v)`;
                break;
            case $72647a53c81c1fc1$export$137d4afcdbc674c0.EaseInOutQuad:
                {
                    const entry = "VAL < 0.5 ? 2.0 * VAL * VAL : 1.0 - pow(-2.0 * VAL + 2.0, 2.0) / 2.0";
                    registeredFunction = this._duplicateVector(entry, inputType);
                    break;
                }
            case $72647a53c81c1fc1$export$137d4afcdbc674c0.EaseInCubic:
                registeredFunction = `return v * v * v`;
                break;
            case $72647a53c81c1fc1$export$137d4afcdbc674c0.EaseOutCubic:
                {
                    const entry = "1.0 - pow(1.0 - VAL, 3.0)";
                    registeredFunction = this._duplicateVector(entry, inputType);
                    break;
                }
            case $72647a53c81c1fc1$export$137d4afcdbc674c0.EaseInOutCubic:
                {
                    const entry = "VAL < 0.5 ? 4.0 * VAL * VAL * VAL : 1.0 - pow(-2.0 * VAL + 2.0, 3.0) / 2.0";
                    registeredFunction = this._duplicateVector(entry, inputType);
                    break;
                }
            case $72647a53c81c1fc1$export$137d4afcdbc674c0.EaseInQuart:
                registeredFunction = `return v * v * v * v`;
                break;
            case $72647a53c81c1fc1$export$137d4afcdbc674c0.EaseOutQuart:
                {
                    const entry = "1.0 - pow(1.0 - VAL, 4.0)";
                    registeredFunction = this._duplicateVector(entry, inputType);
                    break;
                }
            case $72647a53c81c1fc1$export$137d4afcdbc674c0.EaseInOutQuart:
                {
                    const entry = "VAL < 0.5 ? 8.0 * VAL * VAL * VAL * VAL : 1.0 - pow(-2.0 * VAL + 2.0, 4.0) / 2.0";
                    registeredFunction = this._duplicateVector(entry, inputType);
                    break;
                }
            case $72647a53c81c1fc1$export$137d4afcdbc674c0.EaseInQuint:
                registeredFunction = `return v * v * v * v * v`;
                break;
            case $72647a53c81c1fc1$export$137d4afcdbc674c0.EaseOutQuint:
                {
                    const entry = "1.0 - pow(1.0 - VAL, 5.0)";
                    registeredFunction = this._duplicateVector(entry, inputType);
                    break;
                }
            case $72647a53c81c1fc1$export$137d4afcdbc674c0.EaseInOutQuint:
                {
                    const entry = "VAL < 0.5 ? 16.0 * VAL * VAL * VAL * VAL * VAL : 1.0 - pow(-2.0 * VAL + 2.0, 5.0) / 2.0";
                    registeredFunction = this._duplicateVector(entry, inputType);
                    break;
                }
            case $72647a53c81c1fc1$export$137d4afcdbc674c0.EaseInExpo:
                {
                    const entry = "VAL == 0.0 ? 0.0 : pow(2.0, 10.0 * VAL - 10.0)";
                    registeredFunction = this._duplicateVector(entry, inputType);
                    break;
                }
            case $72647a53c81c1fc1$export$137d4afcdbc674c0.EaseOutExpo:
                {
                    const entry = "VAL == 1.0 ? 1.0 : 1.0 - pow(2.0, -10.0 * VAL)";
                    registeredFunction = this._duplicateVector(entry, inputType);
                    break;
                }
            case $72647a53c81c1fc1$export$137d4afcdbc674c0.EaseInOutExpo:
                {
                    const entry = "VAL == 0.0 ? 0.0 : VAL == 1.0 ? 1.0 : VAL < 0.5 ? pow(2.0, 20.0 * VAL - 10.0) / 2.0 : (2.0 - pow(2.0, -20.0 * VAL + 10.0)) / 2.0";
                    registeredFunction = this._duplicateVector(entry, inputType);
                    break;
                }
            case $72647a53c81c1fc1$export$137d4afcdbc674c0.EaseInCirc:
                {
                    const entry = "1.0 - sqrt(1.0 - pow(VAL, 2.0))";
                    registeredFunction = this._duplicateVector(entry, inputType);
                    break;
                }
            case $72647a53c81c1fc1$export$137d4afcdbc674c0.EaseOutCirc:
                {
                    const entry = "sqrt(1.0 - pow(VAL - 1.0, 2.0))";
                    registeredFunction = this._duplicateVector(entry, inputType);
                    break;
                }
            case $72647a53c81c1fc1$export$137d4afcdbc674c0.EaseInOutCirc:
                {
                    const entry = "VAL < 0.5 ? (1.0 - sqrt(1.0 - pow(2.0 * VAL, 2.0))) / 2.0 : (sqrt(1.0 - pow(-2.0 * VAL + 2.0, 2.0)) + 1.0) / 2.0";
                    registeredFunction = this._duplicateVector(entry, inputType);
                    break;
                }
            case $72647a53c81c1fc1$export$137d4afcdbc674c0.EaseInBack:
                registeredFunction = "return 2.70158 * v * v * v - 1.70158 * v * v";
                break;
            case $72647a53c81c1fc1$export$137d4afcdbc674c0.EaseOutBack:
                {
                    const entry = "2.70158 * pow(VAL - 1.0, 3.0) + 1.70158 * pow(VAL - 1.0, 2.0)";
                    registeredFunction = this._duplicateVector(entry, inputType);
                    break;
                }
            case $72647a53c81c1fc1$export$137d4afcdbc674c0.EaseInOutBack:
                {
                    const entry = "VAL < 0.5 ? (pow(2.0 * VAL, 2.0) * ((3.5949095) * 2.0 * VAL - 2.5949095)) / 2.0 : (pow(2.0 * VAL - 2.0, 2.0) * (3.5949095 * (VAL * 2.0 - 2.0) + 3.5949095) + 2.0) / 2.0";
                    registeredFunction = this._duplicateVector(entry, inputType);
                    break;
                }
            case $72647a53c81c1fc1$export$137d4afcdbc674c0.EaseInElastic:
                {
                    const entry = "VAL == 0.0 ? 0.0 : VAL == 1.0 ? 1.0 : -pow(2.0, 10.0 * VAL - 10.0) * sin((VAL * 10.0 - 10.75) * ((2.0 * 3.1415) / 3.0))";
                    registeredFunction = this._duplicateVector(entry, inputType);
                    break;
                }
            case $72647a53c81c1fc1$export$137d4afcdbc674c0.EaseOutElastic:
                {
                    const entry = "VAL == 0.0 ? 0.0 : VAL == 1.0 ? 1.0 : pow(2.0, -10.0 * VAL) * sin((VAL * 10.0 - 0.75) * ((2.0 * 3.1415) / 3.0)) + 1.0";
                    registeredFunction = this._duplicateVector(entry, inputType);
                    break;
                }
            case $72647a53c81c1fc1$export$137d4afcdbc674c0.EaseInOutElastic:
                {
                    const entry = "VAL == 0.0 ? 0.0 : VAL == 1.0 ? 1.0 : VAL < 0.5 ? -(pow(2.0, 20.0 * VAL - 10.0) * sin((20.0 * VAL - 11.125) * ((2.0 * 3.1415) / 4.5))) / 2.0 : (pow(2.0, -20.0 * VAL + 10.0) * sin((20.0 * VAL - 11.125) * ((2.0 * 3.1415) / 4.5))) / 2.0 + 1.0";
                    registeredFunction = this._duplicateVector(entry, inputType);
                    break;
                }
        }
        state._emitFunction(registeredFunctionName, `${inputType} ${registeredFunctionName}(${inputType} v) {${registeredFunction};}\n`, "");
        state.compilationString += this._declareOutput(output, state) + ` = ${registeredFunctionName}(${this.input.associatedVariableName});\n`;
        return this;
    }
    serialize() {
        const serializationObject = super.serialize();
        serializationObject.curveType = this.type;
        return serializationObject;
    }
    _deserialize(serializationObject, scene, rootUrl) {
        super._deserialize(serializationObject, scene, rootUrl);
        this.type = serializationObject.curveType;
    }
    _dumpPropertiesCode() {
        const codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.type = BABYLON.CurveBlockTypes.${$72647a53c81c1fc1$export$137d4afcdbc674c0[this.type]};\n`;
        return codeString;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.CurveBlock", $72647a53c81c1fc1$export$bbefad92f0492a24);

});


parcelRegister("hm4mN", function(module, exports) {

var $e7bx1 = parcelRequire("e7bx1");
$parcel$exportWildcard(module.exports, $e7bx1);

});
parcelRegister("e7bx1", function(module, exports) {

$parcel$export(module.exports, "NodeMaterialOptimizer", () => $a46aaa160dce59bb$export$a44b2fd4fd4712b9);
/**
 * Root class for all node material optimizers
 */ class $a46aaa160dce59bb$export$a44b2fd4fd4712b9 {
    /**
     * Function used to optimize a NodeMaterial graph
     * @param _vertexOutputNodes defines the list of output nodes for the vertex shader
     * @param _fragmentOutputNodes defines the list of output nodes for the fragment shader
     */ optimize(_vertexOutputNodes, _fragmentOutputNodes) {
    // Do nothing by default
    }
}

});



parcelRegister("au7qz", function(module, exports) {

$parcel$export(module.exports, "ShadowDepthWrapper", () => $7a2277b2d5b8aafe$export$d05efdd8150b0322);

var $lUDWq = parcelRequire("lUDWq");

var $321Uk = parcelRequire("321Uk");

var $hOyoX = parcelRequire("hOyoX");

var $ejQPp = parcelRequire("ejQPp");

var $8WI3I = parcelRequire("8WI3I");
class $7a2277b2d5b8aafe$var$MapMap {
    constructor(){
        this.mm = new Map();
    }
    get(a, b) {
        const m = this.mm.get(a);
        if (m !== undefined) return m.get(b);
        return undefined;
    }
    set(a, b, v) {
        let m = this.mm.get(a);
        if (m === undefined) this.mm.set(a, m = new Map());
        m.set(b, v);
    }
}
class $7a2277b2d5b8aafe$export$d05efdd8150b0322 {
    /** Gets the standalone status of the wrapper */ get standalone() {
        return this._options?.standalone ?? false;
    }
    /** Gets the base material the wrapper is built upon */ get baseMaterial() {
        return this._baseMaterial;
    }
    /** Gets the doNotInjectCode status of the wrapper */ get doNotInjectCode() {
        return this._options?.doNotInjectCode ?? false;
    }
    /**
     * Instantiate a new shadow depth wrapper.
     * It works by injecting some specific code in the vertex/fragment shaders of the base material and is used by a shadow generator to
     * generate the shadow depth map. For more information, please refer to the documentation:
     * https://doc.babylonjs.com/features/featuresDeepDive/lights/shadows
     * @param baseMaterial Material to wrap
     * @param scene Define the scene the material belongs to
     * @param options Options used to create the wrapper
     */ constructor(baseMaterial, scene, options){
        this._baseMaterial = baseMaterial;
        this._scene = scene ?? (0, $ejQPp.EngineStore).LastCreatedScene;
        this._options = options;
        this._subMeshToEffect = new Map();
        this._subMeshToDepthWrapper = new $7a2277b2d5b8aafe$var$MapMap();
        this._meshes = new Map();
        // Register for onEffectCreated to store the effect of the base material when it is (re)generated. This effect will be used
        // to create the depth effect later on
        this._onEffectCreatedObserver = this._baseMaterial.onEffectCreatedObservable.add((params)=>{
            const mesh = params.subMesh?.getMesh();
            if (mesh && !this._meshes.has(mesh)) // Register for mesh onDispose to clean up our internal maps when a mesh is disposed
            this._meshes.set(mesh, mesh.onDisposeObservable.add((mesh)=>{
                const iterator = this._subMeshToEffect.keys();
                for(let key = iterator.next(); key.done !== true; key = iterator.next()){
                    const subMesh = key.value;
                    if (subMesh?.getMesh() === mesh) {
                        this._subMeshToEffect.delete(subMesh);
                        this._deleteDepthWrapperEffect(subMesh);
                    }
                }
            }));
            if (this._subMeshToEffect.get(params.subMesh)?.[0] !== params.effect) {
                this._subMeshToEffect.set(params.subMesh, [
                    params.effect,
                    this._scene.getEngine().currentRenderPassId
                ]);
                this._deleteDepthWrapperEffect(params.subMesh);
            }
        });
    }
    _deleteDepthWrapperEffect(subMesh) {
        const depthWrapperEntries = this._subMeshToDepthWrapper.mm.get(subMesh);
        if (depthWrapperEntries) {
            // find and release the previous depth effect
            depthWrapperEntries.forEach((depthWrapper)=>{
                depthWrapper.mainDrawWrapper.effect?.dispose();
            });
            this._subMeshToDepthWrapper.mm.delete(subMesh); // trigger a depth effect recreation
        }
    }
    /**
     * Gets the effect to use to generate the depth map
     * @param subMesh subMesh to get the effect for
     * @param shadowGenerator shadow generator to get the effect for
     * @param passIdForDrawWrapper Id of the pass for which the effect from the draw wrapper must be retrieved from
     * @returns the effect to use to generate the depth map for the subMesh + shadow generator specified
     */ getEffect(subMesh, shadowGenerator, passIdForDrawWrapper) {
        const entry = this._subMeshToDepthWrapper.mm.get(subMesh)?.get(shadowGenerator);
        if (!entry) return null;
        let drawWrapper = entry.drawWrapper[passIdForDrawWrapper];
        if (!drawWrapper) {
            drawWrapper = entry.drawWrapper[passIdForDrawWrapper] = new (0, $hOyoX.DrawWrapper)(this._scene.getEngine());
            drawWrapper.setEffect(entry.mainDrawWrapper.effect, entry.mainDrawWrapper.defines);
        }
        return drawWrapper;
    }
    /**
     * Specifies that the submesh is ready to be used for depth rendering
     * @param subMesh submesh to check
     * @param defines the list of defines to take into account when checking the effect
     * @param shadowGenerator combined with subMesh, it defines the effect to check
     * @param useInstances specifies that instances should be used
     * @param passIdForDrawWrapper Id of the pass for which the draw wrapper should be created
     * @returns a boolean indicating that the submesh is ready or not
     */ isReadyForSubMesh(subMesh, defines, shadowGenerator, useInstances, passIdForDrawWrapper) {
        if (this.standalone) {
            // will ensure the effect is (re)created for the base material
            if (!this._baseMaterial.isReadyForSubMesh(subMesh.getMesh(), subMesh, useInstances)) return false;
        }
        return this._makeEffect(subMesh, defines, shadowGenerator, passIdForDrawWrapper)?.isReady() ?? false;
    }
    /**
     * Disposes the resources
     */ dispose() {
        this._baseMaterial.onEffectCreatedObservable.remove(this._onEffectCreatedObserver);
        this._onEffectCreatedObserver = null;
        const iterator = this._meshes.entries();
        for(let entry = iterator.next(); entry.done !== true; entry = iterator.next()){
            const [mesh, observer] = entry.value;
            mesh.onDisposeObservable.remove(observer);
        }
    }
    _makeEffect(subMesh, defines, shadowGenerator, passIdForDrawWrapper) {
        const engine = this._scene.getEngine();
        const origEffectAndRenderPassId = this._subMeshToEffect.get(subMesh);
        if (!origEffectAndRenderPassId) return null;
        const [origEffect, origRenderPassId] = origEffectAndRenderPassId;
        let params = this._subMeshToDepthWrapper.get(subMesh, shadowGenerator);
        if (!params) {
            const mainDrawWrapper = new (0, $hOyoX.DrawWrapper)(engine);
            mainDrawWrapper.defines = subMesh._getDrawWrapper(origRenderPassId)?.defines ?? null;
            params = {
                drawWrapper: [],
                mainDrawWrapper: mainDrawWrapper,
                depthDefines: "",
                token: (0, $321Uk.RandomGUID)()
            };
            params.drawWrapper[passIdForDrawWrapper] = mainDrawWrapper;
            this._subMeshToDepthWrapper.set(subMesh, shadowGenerator, params);
        }
        const join = defines.join("\n");
        if (params.mainDrawWrapper.effect) {
            if (join === params.depthDefines) // we already created the depth effect and it is still up to date for this submesh + shadow generator
            return params.mainDrawWrapper.effect;
        }
        params.depthDefines = join;
        const uniforms = origEffect.getUniformNames().slice();
        // the depth effect is either out of date or has not been created yet
        let vertexCode = origEffect.vertexSourceCodeBeforeMigration, fragmentCode = origEffect.fragmentSourceCodeBeforeMigration;
        if (!this.doNotInjectCode) {
            // Declare the shadow map includes
            const vertexNormalBiasCode = this._options && this._options.remappedVariables ? `#include<shadowMapVertexNormalBias>(${this._options.remappedVariables.join(",")})` : `#include<shadowMapVertexNormalBias>`, vertexMetricCode = this._options && this._options.remappedVariables ? `#include<shadowMapVertexMetric>(${this._options.remappedVariables.join(",")})` : `#include<shadowMapVertexMetric>`, fragmentSoftTransparentShadow = this._options && this._options.remappedVariables ? `#include<shadowMapFragmentSoftTransparentShadow>(${this._options.remappedVariables.join(",")})` : `#include<shadowMapFragmentSoftTransparentShadow>`, fragmentBlockCode = `#include<shadowMapFragment>`, vertexExtraDeclartion = `#include<shadowMapVertexExtraDeclaration>`;
            // vertex code
            if (origEffect.shaderLanguage === (0, $8WI3I.ShaderLanguage).GLSL) vertexCode = vertexCode.replace(/void\s+?main/g, `\n${vertexExtraDeclartion}\nvoid main`);
            else vertexCode = vertexCode.replace(/@vertex/g, `\n${vertexExtraDeclartion}\n@vertex`);
            vertexCode = vertexCode.replace(/#define SHADOWDEPTH_NORMALBIAS|#define CUSTOM_VERTEX_UPDATE_WORLDPOS/g, vertexNormalBiasCode);
            if (vertexCode.indexOf("#define SHADOWDEPTH_METRIC") !== -1) vertexCode = vertexCode.replace(/#define SHADOWDEPTH_METRIC/g, vertexMetricCode);
            else vertexCode = vertexCode.replace(/}\s*$/g, vertexMetricCode + "\n}");
            vertexCode = vertexCode.replace(/#define SHADER_NAME.*?\n|out vec4 glFragColor;\n/g, "");
            // fragment code
            const hasLocationForSoftTransparentShadow = fragmentCode.indexOf("#define SHADOWDEPTH_SOFTTRANSPARENTSHADOW") >= 0 || fragmentCode.indexOf("#define CUSTOM_FRAGMENT_BEFORE_FOG") >= 0;
            const hasLocationForFragment = fragmentCode.indexOf("#define SHADOWDEPTH_FRAGMENT") !== -1;
            let fragmentCodeToInjectAtEnd = "";
            if (!hasLocationForSoftTransparentShadow) fragmentCodeToInjectAtEnd = fragmentSoftTransparentShadow + "\n";
            else fragmentCode = fragmentCode.replace(/#define SHADOWDEPTH_SOFTTRANSPARENTSHADOW|#define CUSTOM_FRAGMENT_BEFORE_FOG/g, fragmentSoftTransparentShadow);
            fragmentCode = fragmentCode.replace(/void\s+?main/g, (0, $lUDWq.Effect).IncludesShadersStore["shadowMapFragmentExtraDeclaration"] + "\nvoid main");
            if (hasLocationForFragment) fragmentCode = fragmentCode.replace(/#define SHADOWDEPTH_FRAGMENT/g, fragmentBlockCode);
            else fragmentCodeToInjectAtEnd += fragmentBlockCode + "\n";
            if (fragmentCodeToInjectAtEnd) fragmentCode = fragmentCode.replace(/}\s*$/g, fragmentCodeToInjectAtEnd + "}");
            uniforms.push("biasAndScaleSM", "depthValuesSM", "lightDataSM", "softTransparentShadowSM");
        }
        params.mainDrawWrapper.effect = engine.createEffect({
            vertexSource: vertexCode,
            fragmentSource: fragmentCode,
            vertexToken: params.token,
            fragmentToken: params.token
        }, {
            attributes: origEffect.getAttributesNames(),
            uniformsNames: uniforms,
            uniformBuffersNames: origEffect.getUniformBuffersNames(),
            samplers: origEffect.getSamplers(),
            defines: join + "\n" + origEffect.defines.replace("#define SHADOWS", "").replace(/#define SHADOW\d/g, ""),
            indexParameters: origEffect.getIndexParameters(),
            shaderLanguage: origEffect.shaderLanguage
        }, engine);
        for(let id = 0; id < params.drawWrapper.length; ++id)if (id !== passIdForDrawWrapper) params.drawWrapper[id]?.setEffect(params.mainDrawWrapper.effect, params.mainDrawWrapper.defines);
        return params.mainDrawWrapper.effect;
    }
}

});

parcelRegister("96fF1", function(module, exports) {

$parcel$export(module.exports, "DecalMapDefines", () => $6a00d2772dcc9b8a$export$6c61c067d1018d9b);
$parcel$export(module.exports, "DecalMapConfiguration", () => $6a00d2772dcc9b8a$export$789eefdf40eb0c9f);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $35xmP = parcelRequire("35xmP");

var $8XNAC = parcelRequire("8XNAC");

var $2hKx5 = parcelRequire("2hKx5");

var $8DoUR = parcelRequire("8DoUR");

var $alPCh = parcelRequire("alPCh");
class $6a00d2772dcc9b8a$export$6c61c067d1018d9b extends (0, $35xmP.MaterialDefines) {
    constructor(){
        super(...arguments);
        this.DECAL = false;
        this.DECALDIRECTUV = 0;
        this.DECAL_SMOOTHALPHA = false;
        this.GAMMADECAL = false;
    }
}
class $6a00d2772dcc9b8a$export$789eefdf40eb0c9f extends (0, $8XNAC.MaterialPluginBase) {
    /** @internal */ _markAllSubMeshesAsTexturesDirty() {
        this._enable(this._isEnabled);
        this._internalMarkAllSubMeshesAsTexturesDirty();
    }
    /**
     * Creates a new DecalMapConfiguration
     * @param material The material to attach the decal map plugin to
     * @param addToPluginList If the plugin should be added to the material plugin list
     */ constructor(material, addToPluginList = true){
        super(material, "DecalMap", 150, new $6a00d2772dcc9b8a$export$6c61c067d1018d9b(), addToPluginList);
        this._isEnabled = false;
        /**
         * Enables or disables the decal map on this material
         */ this.isEnabled = false;
        this._smoothAlpha = false;
        /**
         * Enables or disables the smooth alpha mode on this material. Default: false.
         * When enabled, the alpha value used to blend the decal map will be the squared value and will produce a smoother result.
         */ this.smoothAlpha = false;
        this.registerForExtraEvents = true; // because we override the hardBindForSubMesh method
        this._internalMarkAllSubMeshesAsTexturesDirty = material._dirtyCallbacks[1];
    }
    isReadyForSubMesh(defines, scene, engine, subMesh) {
        const decalMap = subMesh.getMesh().decalMap;
        if (!this._isEnabled || !decalMap?.texture || !(0, $2hKx5.MaterialFlags).DecalMapEnabled || !scene.texturesEnabled) return true;
        return decalMap.isReady();
    }
    prepareDefines(defines, scene, mesh) {
        const decalMap = mesh.decalMap;
        if (!this._isEnabled || !decalMap?.texture || !(0, $2hKx5.MaterialFlags).DecalMapEnabled || !scene.texturesEnabled) {
            const isDirty = defines.DECAL;
            if (isDirty) defines.markAsTexturesDirty();
            defines.DECAL = false;
        } else {
            const isDirty = !defines.DECAL || defines.GAMMADECAL !== decalMap.texture.gammaSpace;
            if (isDirty) defines.markAsTexturesDirty();
            defines.DECAL = true;
            defines.GAMMADECAL = decalMap.texture.gammaSpace;
            defines.DECAL_SMOOTHALPHA = this._smoothAlpha;
            (0, $alPCh.PrepareDefinesForMergedUV)(decalMap.texture, defines, "DECAL");
        }
    }
    hardBindForSubMesh(uniformBuffer, scene, _engine, subMesh) {
        /**
         * Note that we override hardBindForSubMesh and not bindForSubMesh because the material can be shared by multiple meshes,
         * in which case mustRebind could return false even though the decal map is different for each mesh: that's because the decal map
         * is not part of the material but hosted by the decalMap of the mesh instead.
         */ const decalMap = subMesh.getMesh().decalMap;
        if (!this._isEnabled || !decalMap?.texture || !(0, $2hKx5.MaterialFlags).DecalMapEnabled || !scene.texturesEnabled) return;
        const isFrozen = this._material.isFrozen;
        const texture = decalMap.texture;
        if (!uniformBuffer.useUbo || !isFrozen || !uniformBuffer.isSync) {
            uniformBuffer.updateFloat4("vDecalInfos", texture.coordinatesIndex, 0, 0, 0);
            (0, $alPCh.BindTextureMatrix)(texture, uniformBuffer, "decal");
        }
        uniformBuffer.setTexture("decalSampler", texture);
    }
    getClassName() {
        return "DecalMapConfiguration";
    }
    getSamplers(samplers) {
        samplers.push("decalSampler");
    }
    getUniforms() {
        return {
            ubo: [
                {
                    name: "vDecalInfos",
                    size: 4,
                    type: "vec4"
                },
                {
                    name: "decalMatrix",
                    size: 16,
                    type: "mat4"
                }
            ]
        };
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $6a00d2772dcc9b8a$export$789eefdf40eb0c9f.prototype, "isEnabled", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $6a00d2772dcc9b8a$export$789eefdf40eb0c9f.prototype, "smoothAlpha", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.DecalMapConfiguration", $6a00d2772dcc9b8a$export$789eefdf40eb0c9f);

});

parcelRegister("3U64T", function(module, exports) {

$parcel$export(module.exports, "createPBRAnisotropicPlugin", () => $2d7b51016a81b56f$export$b1c721400568fefd);
$parcel$export(module.exports, "createPBRBRDFPlugin", () => $2d7b51016a81b56f$export$1ee5cad46c0aff5a);
$parcel$export(module.exports, "createPBRClearCoatPlugin", () => $2d7b51016a81b56f$export$48a3e7607fb44e20);
$parcel$export(module.exports, "createPBRIridescencePlugin", () => $2d7b51016a81b56f$export$4e38098c4b3ed2cb);
$parcel$export(module.exports, "createPBRSheenPlugin", () => $2d7b51016a81b56f$export$a0f79c9fabaab5cd);
$parcel$export(module.exports, "createPBRSubSurfacePlugin", () => $2d7b51016a81b56f$export$b43f56b048fa075d);
$parcel$export(module.exports, "createDetailMapPlugin", () => $2d7b51016a81b56f$export$3f327986c63f7e4);

var $bRVvK = parcelRequire("bRVvK");

var $3rbQN = parcelRequire("3rbQN");

var $4G6Xh = parcelRequire("4G6Xh");

var $5LMez = parcelRequire("5LMez");

var $dXX3O = parcelRequire("dXX3O");

var $lngOr = parcelRequire("lngOr");

var $4T4Yv = parcelRequire("4T4Yv");

var $5Nlza = parcelRequire("5Nlza");

var $gAH3H = parcelRequire("gAH3H");
function $2d7b51016a81b56f$export$b1c721400568fefd(material) {
    if (material instanceof (0, $4G6Xh.PBRBaseMaterial)) return new (0, $3rbQN.PBRAnisotropicConfiguration)(material);
    return null;
}
function $2d7b51016a81b56f$export$1ee5cad46c0aff5a(material) {
    if (material instanceof (0, $4G6Xh.PBRBaseMaterial)) return new (0, $5LMez.PBRBRDFConfiguration)(material);
    return null;
}
function $2d7b51016a81b56f$export$48a3e7607fb44e20(material) {
    if (material instanceof (0, $4G6Xh.PBRBaseMaterial)) return new (0, $dXX3O.PBRClearCoatConfiguration)(material);
    return null;
}
function $2d7b51016a81b56f$export$4e38098c4b3ed2cb(material) {
    if (material instanceof (0, $4G6Xh.PBRBaseMaterial)) return new (0, $lngOr.PBRIridescenceConfiguration)(material);
    return null;
}
function $2d7b51016a81b56f$export$a0f79c9fabaab5cd(material) {
    if (material instanceof (0, $4G6Xh.PBRBaseMaterial)) return new (0, $4T4Yv.PBRSheenConfiguration)(material);
    return null;
}
function $2d7b51016a81b56f$export$b43f56b048fa075d(material) {
    if (material instanceof (0, $4G6Xh.PBRBaseMaterial)) return new (0, $5Nlza.PBRSubSurfaceConfiguration)(material);
    return null;
}
function $2d7b51016a81b56f$export$3f327986c63f7e4(material) {
    if (material instanceof (0, $4G6Xh.PBRBaseMaterial) || material instanceof (0, $gAH3H.StandardMaterial)) return new (0, $bRVvK.DetailMapConfiguration)(material);
    return null;
}

});

parcelRegister("heA9x", function(module, exports) {

$parcel$export(module.exports, "MaterialGreasedLineDefines", () => $c8bfc9a838b767d6$export$67dd8ce4506af8c4);
$parcel$export(module.exports, "GreasedLinePluginMaterial", () => $c8bfc9a838b767d6$export$ae2f8e31bbaf2218);

var $5Egpj = parcelRequire("5Egpj");

var $8XNAC = parcelRequire("8XNAC");

var $ha1VO = parcelRequire("ha1VO");

var $35xmP = parcelRequire("35xmP");

var $8DoUR = parcelRequire("8DoUR");

var $bZbGh = parcelRequire("bZbGh");

var $7LG5O = parcelRequire("7LG5O");

var $btEbG = parcelRequire("btEbG");
class $c8bfc9a838b767d6$export$67dd8ce4506af8c4 extends (0, $35xmP.MaterialDefines) {
    constructor(){
        super(...arguments);
        /**
         * The material has a color option specified
         */ // eslint-disable-next-line @typescript-eslint/naming-convention
        this.GREASED_LINE_HAS_COLOR = false;
        /**
         * The material's size attenuation optiom
         */ // eslint-disable-next-line @typescript-eslint/naming-convention
        this.GREASED_LINE_SIZE_ATTENUATION = false;
        /**
         * The type of color distribution is set to line this value equals to true.
         */ // eslint-disable-next-line @typescript-eslint/naming-convention
        this.GREASED_LINE_COLOR_DISTRIBUTION_TYPE_LINE = false;
        /**
         * True if scene is in right handed coordinate system.
         */ // eslint-disable-next-line @typescript-eslint/naming-convention
        this.GREASED_LINE_RIGHT_HANDED_COORDINATE_SYSTEM = false;
        /**
         * True if the line is in camera facing mode
         */ // eslint-disable-next-line @typescript-eslint/naming-convention
        this.GREASED_LINE_CAMERA_FACING = true;
    }
}
class $c8bfc9a838b767d6$export$ae2f8e31bbaf2218 extends (0, $8XNAC.MaterialPluginBase) {
    /**
     * Creates a new instance of the GreasedLinePluginMaterial
     * @param material base material for the plugin
     * @param scene the scene
     * @param options plugin options
     */ constructor(material, scene, options){
        options = options || {
            color: (0, $7LG5O.GreasedLineMaterialDefaults).DEFAULT_COLOR
        };
        const defines = new $c8bfc9a838b767d6$export$67dd8ce4506af8c4();
        defines.GREASED_LINE_HAS_COLOR = !!options.color && !options.useColors;
        defines.GREASED_LINE_SIZE_ATTENUATION = options.sizeAttenuation ?? false;
        defines.GREASED_LINE_COLOR_DISTRIBUTION_TYPE_LINE = options.colorDistributionType === (0, $bZbGh.GreasedLineMeshColorDistributionType).COLOR_DISTRIBUTION_TYPE_LINE;
        defines.GREASED_LINE_RIGHT_HANDED_COORDINATE_SYSTEM = (scene ?? material.getScene()).useRightHandedSystem;
        defines.GREASED_LINE_CAMERA_FACING = options.cameraFacing ?? true;
        super(material, $c8bfc9a838b767d6$export$ae2f8e31bbaf2218.GREASED_LINE_MATERIAL_NAME, 200, defines);
        /**
         * You can provide a colorsTexture to use instead of one generated from the 'colors' option
         */ this.colorsTexture = null;
        this._scene = scene ?? material.getScene();
        this._engine = this._scene.getEngine();
        this._cameraFacing = options.cameraFacing ?? true;
        this.visibility = options.visibility ?? 1;
        this.useDash = options.useDash ?? false;
        this.dashRatio = options.dashRatio ?? 0.5;
        this.dashOffset = options.dashOffset ?? 0;
        this.width = options.width ? options.width : options.sizeAttenuation ? (0, $7LG5O.GreasedLineMaterialDefaults).DEFAULT_WIDTH_ATTENUATED : (0, $7LG5O.GreasedLineMaterialDefaults).DEFAULT_WIDTH;
        this._sizeAttenuation = options.sizeAttenuation ?? false;
        this.colorMode = options.colorMode ?? (0, $bZbGh.GreasedLineMeshColorMode).COLOR_MODE_SET;
        this._color = options.color ?? null;
        this.useColors = options.useColors ?? false;
        this._colorsDistributionType = options.colorDistributionType ?? (0, $bZbGh.GreasedLineMeshColorDistributionType).COLOR_DISTRIBUTION_TYPE_SEGMENT;
        this.colorsSampling = options.colorsSampling ?? (0, $5Egpj.RawTexture).NEAREST_NEAREST;
        this._colors = options.colors ?? null;
        this.dashCount = options.dashCount ?? 1; // calculate the _dashArray value, call the setter
        this.resolution = options.resolution ?? new (0, $ha1VO.Vector2)(this._engine.getRenderWidth(), this._engine.getRenderHeight()); // calculate aspect call the setter
        if (options.colorsTexture) this.colorsTexture = options.colorsTexture; // colorsTexture from options takes precedence
        else if (this._colors) this.colorsTexture = (0, $btEbG.GreasedLineTools).CreateColorsTexture(`${material.name}-colors-texture`, this._colors, this.colorsSampling, this._scene);
        else {
            this._color = this._color ?? (0, $7LG5O.GreasedLineMaterialDefaults).DEFAULT_COLOR;
            (0, $btEbG.GreasedLineTools).PrepareEmptyColorsTexture(this._scene);
        }
        this._engine.onDisposeObservable.add(()=>{
            (0, $btEbG.GreasedLineTools).DisposeEmptyColorsTexture();
        });
        this._enable(true); // always enabled
    }
    /**
     * Get the shader attributes
     * @param attributes array which will be filled with the attributes
     */ getAttributes(attributes) {
        attributes.push("grl_offsets");
        attributes.push("grl_widths");
        attributes.push("grl_colorPointers");
        attributes.push("grl_counters");
        if (this._cameraFacing) {
            attributes.push("grl_previousAndSide");
            attributes.push("grl_nextAndCounters");
        } else attributes.push("grl_slopes");
    }
    /**
     * Get the shader samplers
     * @param samplers
     */ getSamplers(samplers) {
        samplers.push("grl_colors");
    }
    /**
     * Get the shader textures
     * @param activeTextures array which will be filled with the textures
     */ getActiveTextures(activeTextures) {
        if (this.colorsTexture) activeTextures.push(this.colorsTexture);
    }
    /**
     * Get the shader uniforms
     * @returns uniforms
     */ getUniforms() {
        const ubo = [
            {
                name: "grl_singleColor",
                size: 3,
                type: "vec3"
            },
            {
                name: "grl_dashOptions",
                size: 4,
                type: "vec4"
            },
            {
                name: "grl_colorMode_visibility_colorsWidth_useColors",
                size: 4,
                type: "vec4"
            }
        ];
        if (this._cameraFacing) ubo.push({
            name: "grl_projection",
            size: 16,
            type: "mat4"
        }, {
            name: "grl_aspect_resolution_lineWidth",
            size: 4,
            type: "vec4"
        });
        return {
            ubo: ubo,
            vertex: this._cameraFacing ? `
                uniform vec4 grl_aspect_resolution_lineWidth;
                uniform mat4 grl_projection;
                ` : "",
            fragment: `
                uniform vec4 grl_dashOptions;
                uniform vec4 grl_colorMode_visibility_colorsWidth_useColors;
                uniform vec3 grl_singleColor;
                `
        };
    }
    // only getter, it doesn't make sense to use this plugin on a mesh other than GreasedLineMesh
    // and it doesn't make sense to disable it on the mesh
    get isEnabled() {
        return true;
    }
    /**
     * Bind the uniform buffer
     * @param uniformBuffer
     */ bindForSubMesh(uniformBuffer) {
        if (this._cameraFacing) {
            const activeCamera = this._scene.activeCamera;
            if (activeCamera) {
                const projection = activeCamera.getProjectionMatrix();
                uniformBuffer.updateMatrix("grl_projection", projection);
            } else throw Error("GreasedLinePluginMaterial requires an active camera.");
            const resolutionLineWidth = (0, $ha1VO.TmpVectors).Vector4[0];
            resolutionLineWidth.x = this._aspect;
            resolutionLineWidth.y = this._resolution.x;
            resolutionLineWidth.z = this._resolution.y;
            resolutionLineWidth.w = this.width;
            uniformBuffer.updateVector4("grl_aspect_resolution_lineWidth", resolutionLineWidth);
        }
        const dashOptions = (0, $ha1VO.TmpVectors).Vector4[0];
        dashOptions.x = (0, $btEbG.GreasedLineTools).BooleanToNumber(this.useDash);
        dashOptions.y = this._dashArray;
        dashOptions.z = this.dashOffset;
        dashOptions.w = this.dashRatio;
        uniformBuffer.updateVector4("grl_dashOptions", dashOptions);
        const colorModeVisibilityColorsWidthUseColors = (0, $ha1VO.TmpVectors).Vector4[1];
        colorModeVisibilityColorsWidthUseColors.x = this.colorMode;
        colorModeVisibilityColorsWidthUseColors.y = this.visibility;
        colorModeVisibilityColorsWidthUseColors.z = this.colorsTexture ? this.colorsTexture.getSize().width : 0;
        colorModeVisibilityColorsWidthUseColors.w = (0, $btEbG.GreasedLineTools).BooleanToNumber(this.useColors);
        uniformBuffer.updateVector4("grl_colorMode_visibility_colorsWidth_useColors", colorModeVisibilityColorsWidthUseColors);
        if (this._color) uniformBuffer.updateColor3("grl_singleColor", this._color);
        uniformBuffer.setTexture("grl_colors", this.colorsTexture ?? (0, $7LG5O.GreasedLineMaterialDefaults).EmptyColorsTexture);
    }
    /**
     * Prepare the defines
     * @param defines
     * @param _scene
     * @param _mesh
     */ prepareDefines(defines, _scene, _mesh) {
        defines.GREASED_LINE_HAS_COLOR = !!this.color && !this.useColors;
        defines.GREASED_LINE_SIZE_ATTENUATION = this._sizeAttenuation;
        defines.GREASED_LINE_COLOR_DISTRIBUTION_TYPE_LINE = this._colorsDistributionType === (0, $bZbGh.GreasedLineMeshColorDistributionType).COLOR_DISTRIBUTION_TYPE_LINE;
        defines.GREASED_LINE_RIGHT_HANDED_COORDINATE_SYSTEM = _scene.useRightHandedSystem;
        defines.GREASED_LINE_CAMERA_FACING = this._cameraFacing;
    }
    /**
     * Get the class name
     * @returns class name
     */ getClassName() {
        return $c8bfc9a838b767d6$export$ae2f8e31bbaf2218.GREASED_LINE_MATERIAL_NAME;
    }
    /**
     * Get shader code
     * @param shaderType vertex/fragment
     * @returns shader code
     */ getCustomCode(shaderType) {
        if (shaderType === "vertex") {
            const obj = {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                CUSTOM_VERTEX_DEFINITIONS: `
                attribute float grl_widths;
                attribute vec3 grl_offsets;
                attribute float grl_colorPointers;

                varying float grlCounters;
                varying float grlColorPointer;

                #ifdef GREASED_LINE_CAMERA_FACING
                    attribute vec4 grl_previousAndSide;
                    attribute vec4 grl_nextAndCounters;

                    vec2 grlFix( vec4 i, float aspect ) {
                        vec2 res = i.xy / i.w;
                        res.x *= aspect;
                        return res;
                    }
                #else
                    attribute vec3 grl_slopes;
                    attribute float grl_counters;
                #endif
                `,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                CUSTOM_VERTEX_UPDATE_POSITION: `
                #ifdef GREASED_LINE_CAMERA_FACING
                    vec3 grlPositionOffset = grl_offsets;
                    positionUpdated += grlPositionOffset;
                #else
                    positionUpdated = (positionUpdated + grl_offsets) + (grl_slopes * grl_widths);
                #endif
                `,
                // eslint-disable-next-line @typescript-eslint/naming-convention
                CUSTOM_VERTEX_MAIN_END: `
                grlColorPointer = grl_colorPointers;

                #ifdef GREASED_LINE_CAMERA_FACING

                    float grlAspect = grl_aspect_resolution_lineWidth.x;
                    float grlBaseWidth = grl_aspect_resolution_lineWidth.w;


                    vec3 grlPrevious = grl_previousAndSide.xyz;
                    float grlSide = grl_previousAndSide.w;

                    vec3 grlNext = grl_nextAndCounters.xyz;
                    grlCounters = grl_nextAndCounters.w;

                    mat4 grlMatrix = viewProjection * finalWorld;
                    vec4 grlFinalPosition = grlMatrix * vec4( positionUpdated , 1.0 );
                    vec4 grlPrevPos = grlMatrix * vec4( grlPrevious + grlPositionOffset, 1.0 );
                    vec4 grlNextPos = grlMatrix * vec4( grlNext + grlPositionOffset, 1.0 );

                    vec2 grlCurrentP = grlFix( grlFinalPosition, grlAspect );
                    vec2 grlPrevP = grlFix( grlPrevPos, grlAspect );
                    vec2 grlNextP = grlFix( grlNextPos, grlAspect );

                    float grlWidth = grlBaseWidth * grl_widths;

                    vec2 grlDir;
                    if( grlNextP == grlCurrentP ) grlDir = normalize( grlCurrentP - grlPrevP );
                    else if( grlPrevP == grlCurrentP ) grlDir = normalize( grlNextP - grlCurrentP );
                    else {
                        vec2 grlDir1 = normalize( grlCurrentP - grlPrevP );
                        vec2 grlDir2 = normalize( grlNextP - grlCurrentP );
                        grlDir = normalize( grlDir1 + grlDir2 );
                    }
                    vec4 grlNormal = vec4( -grlDir.y, grlDir.x, 0., 1. );
                    #ifdef GREASED_LINE_RIGHT_HANDED_COORDINATE_SYSTEM
                        grlNormal.xy *= -.5 * grlWidth;
                    #else
                        grlNormal.xy *= .5 * grlWidth;
                    #endif

                    grlNormal *= grl_projection;

                    #ifdef GREASED_LINE_SIZE_ATTENUATION
                        grlNormal.xy *= grlFinalPosition.w;
                        grlNormal.xy /= ( vec4( grl_aspect_resolution_lineWidth.yz, 0., 1. ) * grl_projection ).xy;
                    #endif

                    grlFinalPosition.xy += grlNormal.xy * grlSide;
                    gl_Position = grlFinalPosition;

                    vPositionW = vec3(grlFinalPosition);
                #else
                    grlCounters = grl_counters;
                #endif
                `
            };
            this._cameraFacing && (obj["!gl_Position\\=viewProjection\\*worldPos;"] = "//"); // not needed for camera facing GRL
            return obj;
        }
        if (shaderType === "fragment") return {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            CUSTOM_FRAGMENT_DEFINITIONS: `
                    varying float grlCounters;
                    varying float grlColorPointer;
                    uniform sampler2D grl_colors;
                `,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            CUSTOM_FRAGMENT_MAIN_END: `
                    float grlColorMode = grl_colorMode_visibility_colorsWidth_useColors.x;
                    float grlVisibility = grl_colorMode_visibility_colorsWidth_useColors.y;
                    float grlColorsWidth = grl_colorMode_visibility_colorsWidth_useColors.z;
                    float grlUseColors = grl_colorMode_visibility_colorsWidth_useColors.w;

                    float grlUseDash = grl_dashOptions.x;
                    float grlDashArray = grl_dashOptions.y;
                    float grlDashOffset = grl_dashOptions.z;
                    float grlDashRatio = grl_dashOptions.w;

                    gl_FragColor.a *= step(grlCounters, grlVisibility);
                    if( gl_FragColor.a == 0. ) discard;

                    if(grlUseDash == 1.){
                        gl_FragColor.a *= ceil(mod(grlCounters + grlDashOffset, grlDashArray) - (grlDashArray * grlDashRatio));
                        if (gl_FragColor.a == 0.) discard;
                    }

                    #ifdef GREASED_LINE_HAS_COLOR
                        if (grlColorMode == ${(0, $bZbGh.GreasedLineMeshColorMode).COLOR_MODE_SET}.) {
                            gl_FragColor.rgb = grl_singleColor;
                        } else if (grlColorMode == ${(0, $bZbGh.GreasedLineMeshColorMode).COLOR_MODE_ADD}.) {
                            gl_FragColor.rgb += grl_singleColor;
                        } else if (grlColorMode == ${(0, $bZbGh.GreasedLineMeshColorMode).COLOR_MODE_MULTIPLY}.) {
                            gl_FragColor.rgb *= grl_singleColor;
                        }
                    #else
                        if (grlUseColors == 1.) {
                            #ifdef GREASED_LINE_COLOR_DISTRIBUTION_TYPE_LINE
                                vec4 grlColor = texture2D(grl_colors, vec2(grlCounters, 0.), 0.);
                            #else
                                vec4 grlColor = texture2D(grl_colors, vec2(grlColorPointer/grlColorsWidth, 0.), 0.);
                            #endif
                            if (grlColorMode == ${(0, $bZbGh.GreasedLineMeshColorMode).COLOR_MODE_SET}.) {
                                gl_FragColor = grlColor;
                            } else if (grlColorMode == ${(0, $bZbGh.GreasedLineMeshColorMode).COLOR_MODE_ADD}.) {
                                gl_FragColor += grlColor;
                            } else if (grlColorMode == ${(0, $bZbGh.GreasedLineMeshColorMode).COLOR_MODE_MULTIPLY}.) {
                                gl_FragColor *= grlColor;
                            }
                        }
                    #endif

                `
        };
        return null;
    }
    /**
     * Disposes the plugin material.
     */ dispose() {
        this.colorsTexture?.dispose();
        super.dispose();
    }
    /**
     * Returns the colors used to colorize the line
     */ get colors() {
        return this._colors;
    }
    /**
     * Sets the colors used to colorize the line
     */ set colors(value) {
        this.setColors(value);
    }
    /**
     * Creates or updates the colors texture
     * @param colors color table RGBA
     * @param lazy if lazy, the colors are not updated
     * @param forceNewTexture force creation of a new texture
     */ setColors(colors, lazy = false, forceNewTexture = false) {
        const origColorsCount = this._colors?.length ?? 0;
        this._colors = colors;
        if (colors === null || colors.length === 0) {
            this.colorsTexture?.dispose();
            return;
        }
        if (lazy && !forceNewTexture) return;
        if (this.colorsTexture && origColorsCount === colors.length && !forceNewTexture) {
            const colorArray = (0, $btEbG.GreasedLineTools).Color3toRGBAUint8(colors);
            this.colorsTexture.update(colorArray);
        } else {
            this.colorsTexture?.dispose();
            this.colorsTexture = (0, $btEbG.GreasedLineTools).CreateColorsTexture(`${this._material.name}-colors-texture`, colors, this.colorsSampling, this._scene);
        }
    }
    /**
     * Updates the material. Use when material created in lazy mode.
     */ updateLazy() {
        if (this._colors) this.setColors(this._colors, false, true);
    }
    /**
     * Gets the number of dashes in the line
     */ get dashCount() {
        return this._dashCount;
    }
    /**
     * Sets the number of dashes in the line
     * @param value dash
     */ set dashCount(value) {
        this._dashCount = value;
        this._dashArray = 1 / value;
    }
    /**
     * If set to true the line will be rendered always with the same width regardless how far it is located from the camera.
     * Not supported for non camera facing lines.
     */ get sizeAttenuation() {
        return this._sizeAttenuation;
    }
    /**
     * Turn on/off size attenuation of the width option and widths array.
     * Not supported for non camera facing lines.
     * @param value If set to true the line will be rendered always with the same width regardless how far it is located from the camera.
     */ set sizeAttenuation(value) {
        this._sizeAttenuation = value;
        this.markAllDefinesAsDirty();
    }
    /**
     * Gets the color of the line
     */ get color() {
        return this._color;
    }
    /**
     * Sets the color of the line
     * @param value Color3 or null to clear the color. You need to clear the color if you use colors and useColors = true
     */ set color(value) {
        this.setColor(value);
    }
    /**
     * Sets the color of the line. If set the whole line will be mixed with this color according to the colorMode option.
     * @param value color
     * @param doNotMarkDirty if true, the material will not be marked as dirty
     */ setColor(value, doNotMarkDirty = false) {
        if (this._color === null && value !== null || this._color !== null && value === null) {
            this._color = value;
            !doNotMarkDirty && this.markAllDefinesAsDirty();
        } else this._color = value;
    }
    /**
     * Gets the color distributiopn type
     */ get colorsDistributionType() {
        return this._colorsDistributionType;
    }
    /**
     * Sets the color distribution type
     * @see GreasedLineMeshColorDistributionType
     * @param value color distribution type
     */ set colorsDistributionType(value) {
        this._colorsDistributionType = value;
        this.markAllDefinesAsDirty();
    }
    /**
     * Gets the resolution
     */ get resolution() {
        return this._resolution;
    }
    /**
     * Sets the resolution
     * @param value resolution of the screen for GreasedLine
     */ set resolution(value) {
        this._aspect = value.x / value.y;
        this._resolution = value;
    }
    /**
     * Serializes this plugin material
     * @returns serializationObjec
     */ serialize() {
        const serializationObject = super.serialize();
        const greasedLineMaterialOptions = {
            colorDistributionType: this._colorsDistributionType,
            colorsSampling: this.colorsSampling,
            colorMode: this.colorMode,
            dashCount: this._dashCount,
            dashOffset: this.dashOffset,
            dashRatio: this.dashRatio,
            resolution: this._resolution,
            sizeAttenuation: this._sizeAttenuation,
            useColors: this.useColors,
            useDash: this.useDash,
            visibility: this.visibility,
            width: this.width
        };
        this._colors && (greasedLineMaterialOptions.colors = this._colors);
        this._color && (greasedLineMaterialOptions.color = this._color);
        serializationObject.greasedLineMaterialOptions = greasedLineMaterialOptions;
        return serializationObject;
    }
    /**
     * Parses a serialized objects
     * @param source serialized object
     * @param scene scene
     * @param rootUrl root url for textures
     */ parse(source, scene, rootUrl) {
        super.parse(source, scene, rootUrl);
        const greasedLineMaterialOptions = source.greasedLineMaterialOptions;
        this.colorsTexture?.dispose();
        greasedLineMaterialOptions.color && this.setColor(greasedLineMaterialOptions.color, true);
        greasedLineMaterialOptions.colorDistributionType && (this.colorsDistributionType = greasedLineMaterialOptions.colorDistributionType);
        greasedLineMaterialOptions.colors && (this.colors = greasedLineMaterialOptions.colors);
        greasedLineMaterialOptions.colorsSampling && (this.colorsSampling = greasedLineMaterialOptions.colorsSampling);
        greasedLineMaterialOptions.colorMode && (this.colorMode = greasedLineMaterialOptions.colorMode);
        greasedLineMaterialOptions.useColors && (this.useColors = greasedLineMaterialOptions.useColors);
        greasedLineMaterialOptions.visibility && (this.visibility = greasedLineMaterialOptions.visibility);
        greasedLineMaterialOptions.useDash && (this.useDash = greasedLineMaterialOptions.useDash);
        greasedLineMaterialOptions.dashCount && (this.dashCount = greasedLineMaterialOptions.dashCount);
        greasedLineMaterialOptions.dashRatio && (this.dashRatio = greasedLineMaterialOptions.dashRatio);
        greasedLineMaterialOptions.dashOffset && (this.dashOffset = greasedLineMaterialOptions.dashOffset);
        greasedLineMaterialOptions.width && (this.width = greasedLineMaterialOptions.width);
        greasedLineMaterialOptions.sizeAttenuation && (this.sizeAttenuation = greasedLineMaterialOptions.sizeAttenuation);
        greasedLineMaterialOptions.resolution && (this.resolution = greasedLineMaterialOptions.resolution);
        if (this.colors) this.colorsTexture = (0, $btEbG.GreasedLineTools).CreateColorsTexture(`${this._material.name}-colors-texture`, this.colors, this.colorsSampling, scene);
        else (0, $btEbG.GreasedLineTools).PrepareEmptyColorsTexture(scene);
        this.markAllDefinesAsDirty();
    }
    /**
     * Makes a duplicate of the current configuration into another one.
     * @param plugin define the config where to copy the info
     */ copyTo(plugin) {
        const dest = plugin;
        dest.colorsTexture?.dispose();
        if (this._colors) dest.colorsTexture = (0, $btEbG.GreasedLineTools).CreateColorsTexture(`${dest._material.name}-colors-texture`, this._colors, dest.colorsSampling, this._scene);
        dest.setColor(this.color, true);
        dest.colorsDistributionType = this.colorsDistributionType;
        dest.colorsSampling = this.colorsSampling;
        dest.colorMode = this.colorMode;
        dest.useColors = this.useColors;
        dest.visibility = this.visibility;
        dest.useDash = this.useDash;
        dest.dashCount = this.dashCount;
        dest.dashRatio = this.dashRatio;
        dest.dashOffset = this.dashOffset;
        dest.width = this.width;
        dest.sizeAttenuation = this.sizeAttenuation;
        dest.resolution = this.resolution;
        dest.markAllDefinesAsDirty();
    }
}
/**
 * Plugin name
 */ $c8bfc9a838b767d6$export$ae2f8e31bbaf2218.GREASED_LINE_MATERIAL_NAME = "GreasedLinePluginMaterial";
(0, $8DoUR.RegisterClass)(`BABYLON.${$c8bfc9a838b767d6$export$ae2f8e31bbaf2218.GREASED_LINE_MATERIAL_NAME}`, $c8bfc9a838b767d6$export$ae2f8e31bbaf2218);

});
parcelRegister("bZbGh", function(module, exports) {

$parcel$export(module.exports, "GreasedLineMeshMaterialType", () => $8b9e73cb4a3d1243$export$911ac0ce69a776c2);
$parcel$export(module.exports, "GreasedLineMeshColorMode", () => $8b9e73cb4a3d1243$export$a6c76f858a5916f5);
$parcel$export(module.exports, "GreasedLineMeshColorDistributionType", () => $8b9e73cb4a3d1243$export$df8c52931b2663de);
/**
 * Material types for GreasedLine
 * {@link https://doc.babylonjs.com/features/featuresDeepDive/mesh/creation/param/greased_line#materialtype}
 */ var $8b9e73cb4a3d1243$export$911ac0ce69a776c2;
(function(GreasedLineMeshMaterialType) {
    /**
     * StandardMaterial
     */ GreasedLineMeshMaterialType[GreasedLineMeshMaterialType["MATERIAL_TYPE_STANDARD"] = 0] = "MATERIAL_TYPE_STANDARD";
    /**
     * PBR Material
     */ GreasedLineMeshMaterialType[GreasedLineMeshMaterialType["MATERIAL_TYPE_PBR"] = 1] = "MATERIAL_TYPE_PBR";
    /**
     * Simple and fast shader material not supporting lightning nor textures
     */ GreasedLineMeshMaterialType[GreasedLineMeshMaterialType["MATERIAL_TYPE_SIMPLE"] = 2] = "MATERIAL_TYPE_SIMPLE";
})($8b9e73cb4a3d1243$export$911ac0ce69a776c2 || ($8b9e73cb4a3d1243$export$911ac0ce69a776c2 = {}));
var $8b9e73cb4a3d1243$export$a6c76f858a5916f5;
(function(GreasedLineMeshColorMode) {
    /**
     * Color blending mode SET
     */ GreasedLineMeshColorMode[GreasedLineMeshColorMode["COLOR_MODE_SET"] = 0] = "COLOR_MODE_SET";
    /**
     * Color blending mode ADD
     */ GreasedLineMeshColorMode[GreasedLineMeshColorMode["COLOR_MODE_ADD"] = 1] = "COLOR_MODE_ADD";
    /**
     * Color blending mode ADD
     */ GreasedLineMeshColorMode[GreasedLineMeshColorMode["COLOR_MODE_MULTIPLY"] = 2] = "COLOR_MODE_MULTIPLY";
})($8b9e73cb4a3d1243$export$a6c76f858a5916f5 || ($8b9e73cb4a3d1243$export$a6c76f858a5916f5 = {}));
var $8b9e73cb4a3d1243$export$df8c52931b2663de;
(function(GreasedLineMeshColorDistributionType) {
    /**
     * Colors distributed between segments of the line
     */ GreasedLineMeshColorDistributionType[GreasedLineMeshColorDistributionType["COLOR_DISTRIBUTION_TYPE_SEGMENT"] = 0] = "COLOR_DISTRIBUTION_TYPE_SEGMENT";
    /**
     * Colors distributed along the line ingoring the segments
     */ GreasedLineMeshColorDistributionType[GreasedLineMeshColorDistributionType["COLOR_DISTRIBUTION_TYPE_LINE"] = 1] = "COLOR_DISTRIBUTION_TYPE_LINE";
})($8b9e73cb4a3d1243$export$df8c52931b2663de || ($8b9e73cb4a3d1243$export$df8c52931b2663de = {}));

});

parcelRegister("7LG5O", function(module, exports) {

$parcel$export(module.exports, "GreasedLineMaterialDefaults", () => $5a7d92ec311505ea$export$d1c9f54740aa1aca);

var $7etnY = parcelRequire("7etnY");
class $5a7d92ec311505ea$export$d1c9f54740aa1aca {
}
/**
 * Default line color for newly created lines
 */ $5a7d92ec311505ea$export$d1c9f54740aa1aca.DEFAULT_COLOR = (0, $7etnY.Color3).White();
/**
 * Default line width when sizeAttenuation is true
 */ $5a7d92ec311505ea$export$d1c9f54740aa1aca.DEFAULT_WIDTH_ATTENUATED = 1;
/**
 * Defaule line width
 */ $5a7d92ec311505ea$export$d1c9f54740aa1aca.DEFAULT_WIDTH = 0.1;

});

parcelRegister("btEbG", function(module, exports) {

$parcel$export(module.exports, "GreasedLineTools", () => $85b193861407b7a8$export$691a2718102fcdcf);

var $fm2C6 = parcelRequire("fm2C6");

var $b4i1f = parcelRequire("b4i1f");

var $ha1VO = parcelRequire("ha1VO");

var $dBltS = parcelRequire("dBltS");

var $5Egpj = parcelRequire("5Egpj");

var $5YkyR = parcelRequire("5YkyR");

var $7LG5O = parcelRequire("7LG5O");
class $85b193861407b7a8$export$691a2718102fcdcf {
    /**
     * Converts GreasedLinePoints to number[][]
     * @param points GreasedLinePoints
     * @returns number[][] with x, y, z coordinates of the points, like [[x, y, z, x, y, z, ...], [x, y, z, ...]]
     */ static ConvertPoints(points) {
        if (points.length && Array.isArray(points) && typeof points[0] === "number") return [
            points
        ];
        else if (points.length && Array.isArray(points[0]) && typeof points[0][0] === "number") return points;
        else if (points.length && !Array.isArray(points[0]) && points[0] instanceof (0, $ha1VO.Vector3)) {
            const positions = [];
            for(let j = 0; j < points.length; j++){
                const p = points[j];
                positions.push(p.x, p.y, p.z);
            }
            return [
                positions
            ];
        } else if (points.length > 0 && Array.isArray(points[0]) && points[0].length > 0 && points[0][0] instanceof (0, $ha1VO.Vector3)) {
            const positions = [];
            const vectorPoints = points;
            vectorPoints.forEach((p)=>{
                positions.push(p.flatMap((p2)=>[
                        p2.x,
                        p2.y,
                        p2.z
                    ]));
            });
            return positions;
        } else if (points instanceof Float32Array) return [
            Array.from(points)
        ];
        else if (points.length && points[0] instanceof Float32Array) {
            const positions = [];
            points.forEach((p)=>{
                positions.push(Array.from(p));
            });
            return positions;
        }
        return [];
    }
    /**
     * Omit zero length lines predicate for the MeshesToLines function
     * @param p1 point1 position of the face
     * @param p2 point2 position of the face
     * @param p3 point3 position of the face
     * @returns original points or null if any edge length is zero
     */ static OmitZeroLengthPredicate(p1, p2, p3) {
        const fileredPoints = [];
        // edge1
        if (p2.subtract(p1).lengthSquared() > 0) fileredPoints.push([
            p1,
            p2
        ]);
        // edge2
        if (p3.subtract(p2).lengthSquared() > 0) fileredPoints.push([
            p2,
            p3
        ]);
        // edge3
        if (p1.subtract(p3).lengthSquared() > 0) fileredPoints.push([
            p3,
            p1
        ]);
        return fileredPoints.length === 0 ? null : fileredPoints;
    }
    /**
     * Omit duplicate lines predicate for the MeshesToLines function
     * @param p1 point1 position of the face
     * @param p2 point2 position of the face
     * @param p3 point3 position of the face
     * @param points array of points to search in
     * @returns original points or null if any edge length is zero
     */ static OmitDuplicatesPredicate(p1, p2, p3, points) {
        const fileredPoints = [];
        // edge1
        if (!$85b193861407b7a8$export$691a2718102fcdcf._SearchInPoints(p1, p2, points)) fileredPoints.push([
            p1,
            p2
        ]);
        // edge2
        if (!$85b193861407b7a8$export$691a2718102fcdcf._SearchInPoints(p2, p3, points)) fileredPoints.push([
            p2,
            p3
        ]);
        // edge3
        if (!$85b193861407b7a8$export$691a2718102fcdcf._SearchInPoints(p3, p1, points)) fileredPoints.push([
            p3,
            p1
        ]);
        return fileredPoints.length === 0 ? null : fileredPoints;
    }
    static _SearchInPoints(p1, p2, points) {
        for (const ps of points){
            for(let i = 0; i < ps.length; i++)if (ps[i]?.equals(p1)) {
                // find the first point
                // if it has a sibling of p2 the line already exists
                if (ps[i + 1]?.equals(p2) || ps[i - 1]?.equals(p2)) return true;
            }
        }
        return false;
    }
    /**
     * Gets mesh triangles as line positions
     * @param meshes array of meshes
     * @param predicate predicate function which decides whether to include the mesh triangle/face in the ouput
     * @returns array of arrays of points
     */ static MeshesToLines(meshes, predicate) {
        const points = [];
        meshes.forEach((m, meshIndex)=>{
            const vertices = m.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
            const indices = m.getIndices();
            if (vertices && indices) for(let i = 0, ii = 0; i < indices.length; i++){
                const vi1 = indices[ii++] * 3;
                const vi2 = indices[ii++] * 3;
                const vi3 = indices[ii++] * 3;
                const p1 = new (0, $ha1VO.Vector3)(vertices[vi1], vertices[vi1 + 1], vertices[vi1 + 2]);
                const p2 = new (0, $ha1VO.Vector3)(vertices[vi2], vertices[vi2 + 1], vertices[vi2 + 2]);
                const p3 = new (0, $ha1VO.Vector3)(vertices[vi3], vertices[vi3 + 1], vertices[vi3 + 2]);
                if (predicate) {
                    const pointsFromPredicate = predicate(p1, p2, p3, points, i, vi1, m, meshIndex, vertices, indices);
                    if (pointsFromPredicate) for (const p of pointsFromPredicate)points.push(p);
                } else points.push([
                    p1,
                    p2
                ], [
                    p2,
                    p3
                ], [
                    p3,
                    p1
                ]);
            }
        });
        return points;
    }
    /**
     * Converts number coordinates to Vector3s
     * @param points number array of x, y, z, x, y z, ... coordinates
     * @returns Vector3 array
     */ static ToVector3Array(points) {
        if (Array.isArray(points[0])) {
            const array = [];
            const inputArray = points;
            for (const subInputArray of inputArray){
                const subArray = [];
                for(let i = 0; i < subInputArray.length; i += 3)subArray.push(new (0, $ha1VO.Vector3)(subInputArray[i], subInputArray[i + 1], subInputArray[i + 2]));
                array.push(subArray);
            }
            return array;
        }
        const inputArray = points;
        const array = [];
        for(let i = 0; i < inputArray.length; i += 3)array.push(new (0, $ha1VO.Vector3)(inputArray[i], inputArray[i + 1], inputArray[i + 2]));
        return array;
    }
    /**
     * Gets a number array from a Vector3 array.
     * You can you for example to convert your Vector3[] offsets to the required number[] for the offsets option.
     * @param points Vector3 array
     * @returns an array of x, y, z coordinates as numbers [x, y, z, x, y, z, x, y, z, ....]
     */ static ToNumberArray(points) {
        return points.flatMap((v)=>[
                v.x,
                v.y,
                v.z
            ]);
    }
    /**
     * Calculates the sum of points of every line and the number of points in each line.
     * This function is useful when you are drawing multiple lines in one mesh and you want
     * to know the counts. For example for creating an offsets table.
     * @param points point array
     * @returns points count info
     */ static GetPointsCountInfo(points) {
        const counts = new Array(points.length);
        let total = 0;
        for(let n = points.length; n--;){
            counts[n] = points[n].length / 3;
            total += counts[n];
        }
        return {
            total: total,
            counts: counts
        };
    }
    /**
     * Gets the length of the line counting all it's segments length
     * @param data array of line points
     * @returns length of the line
     */ static GetLineLength(data) {
        if (data.length === 0) return 0;
        let points;
        if (typeof data[0] === "number") points = $85b193861407b7a8$export$691a2718102fcdcf.ToVector3Array(data);
        else points = data;
        const tmp = (0, $ha1VO.TmpVectors).Vector3[0];
        let length = 0;
        for(let index = 0; index < points.length - 1; index++){
            const point1 = points[index];
            const point2 = points[index + 1];
            length += point2.subtractToRef(point1, tmp).length();
        }
        return length;
    }
    /**
     * Divides a segment into smaller segments.
     * A segment is a part of the line between it's two points.
     * @param point1 first point of the line
     * @param point2 second point of the line
     * @param segmentCount number of segments we want to have in the divided line
     * @returns
     */ static SegmentizeSegmentByCount(point1, point2, segmentCount) {
        const dividedLinePoints = [];
        const diff = point2.subtract(point1);
        const divisor = (0, $ha1VO.TmpVectors).Vector3[0];
        divisor.setAll(segmentCount);
        const segmentVector = (0, $ha1VO.TmpVectors).Vector3[1];
        diff.divideToRef(divisor, segmentVector);
        let nextPoint = point1.clone();
        dividedLinePoints.push(nextPoint);
        for(let index = 0; index < segmentCount; index++){
            nextPoint = nextPoint.clone();
            dividedLinePoints.push(nextPoint.addInPlace(segmentVector));
        }
        return dividedLinePoints;
    }
    /**
     * Divides a line into segments.
     * A segment is a part of the line between it's two points.
     * @param what line points
     * @param segmentLength length of each segment of the resulting line (distance between two line points)
     * @returns line point
     */ static SegmentizeLineBySegmentLength(what, segmentLength) {
        const subLines = what[0] instanceof (0, $ha1VO.Vector3) ? $85b193861407b7a8$export$691a2718102fcdcf.GetLineSegments(what) : typeof what[0] === "number" ? $85b193861407b7a8$export$691a2718102fcdcf.GetLineSegments($85b193861407b7a8$export$691a2718102fcdcf.ToVector3Array(what)) : what;
        const points = [];
        subLines.forEach((s)=>{
            if (s.length > segmentLength) {
                const segments = $85b193861407b7a8$export$691a2718102fcdcf.SegmentizeSegmentByCount(s.point1, s.point2, Math.ceil(s.length / segmentLength));
                segments.forEach((seg)=>{
                    points.push(seg);
                });
            } else {
                points.push(s.point1);
                points.push(s.point2);
            }
        });
        return points;
    }
    /**
     * Divides a line into segments.
     * A segment is a part of the line between it's two points.
     * @param what line points
     * @param segmentCount number of segments
     * @returns line point
     */ static SegmentizeLineBySegmentCount(what, segmentCount) {
        const points = typeof what[0] === "number" ? $85b193861407b7a8$export$691a2718102fcdcf.ToVector3Array(what) : what;
        const segmentLength = $85b193861407b7a8$export$691a2718102fcdcf.GetLineLength(points) / segmentCount;
        return $85b193861407b7a8$export$691a2718102fcdcf.SegmentizeLineBySegmentLength(points, segmentLength);
    }
    /**
     * Gets line segments.
     * A segment is a part of the line between it's two points.
     * @param points line points
     * @returns segments information of the line segment including starting point, ending point and the distance between them
     */ static GetLineSegments(points) {
        const segments = [];
        for(let index = 0; index < points.length - 1; index++){
            const point1 = points[index];
            const point2 = points[index + 1];
            const length = point2.subtract(point1).length();
            segments.push({
                point1: point1,
                point2: point2,
                length: length
            });
        }
        return segments;
    }
    /**
     * Gets the minimum and the maximum length of a line segment in the line.
     * A segment is a part of the line between it's two points.
     * @param points line points
     * @returns
     */ static GetMinMaxSegmentLength(points) {
        const subLines = $85b193861407b7a8$export$691a2718102fcdcf.GetLineSegments(points);
        const sorted = subLines.sort((s)=>s.length);
        return {
            min: sorted[0].length,
            max: sorted[sorted.length - 1].length
        };
    }
    /**
     * Finds the last visible position in world space of the line according to the visibility parameter
     * @param lineSegments segments of the line
     * @param lineLength total length of the line
     * @param visbility normalized value of visibility
     * @param localSpace if true the result will be in local space (default is false)
     * @returns world space coordinate of the last visible piece of the line
     */ static GetPositionOnLineByVisibility(lineSegments, lineLength, visbility, localSpace = false) {
        const lengthVisibilityRatio = lineLength * visbility;
        let sumSegmentLengths = 0;
        let segmentIndex = 0;
        const lineSegmentsLength = lineSegments.length;
        for(let i = 0; i < lineSegmentsLength; i++){
            if (lengthVisibilityRatio <= sumSegmentLengths + lineSegments[i].length) {
                segmentIndex = i;
                break;
            }
            sumSegmentLengths += lineSegments[i].length;
        }
        const s = (lengthVisibilityRatio - sumSegmentLengths) / lineSegments[segmentIndex].length;
        lineSegments[segmentIndex].point2.subtractToRef(lineSegments[segmentIndex].point1, (0, $ha1VO.TmpVectors).Vector3[0]);
        (0, $ha1VO.TmpVectors).Vector3[1] = (0, $ha1VO.TmpVectors).Vector3[0].multiplyByFloats(s, s, s);
        if (!localSpace) (0, $ha1VO.TmpVectors).Vector3[1].addInPlace(lineSegments[segmentIndex].point1);
        return (0, $ha1VO.TmpVectors).Vector3[1].clone();
    }
    /**
     * Creates lines in a shape of circle/arc.
     * A segment is a part of the line between it's two points.
     * @param radiusX radiusX of the circle
     * @param segments number of segments in the circle
     * @param z z coordinate of the points. Defaults to 0.
     * @param radiusY radiusY of the circle - you can draw an oval if using different values
     * @param segmentAngle angle offset of the segments. Defaults to Math.PI * 2 / segments. Change this value to draw a part of the circle.
     * @returns line points
     */ static GetCircleLinePoints(radiusX, segments, z = 0, radiusY = radiusX, segmentAngle = Math.PI * 2 / segments) {
        const points = [];
        for(let i = 0; i <= segments; i++)points.push(new (0, $ha1VO.Vector3)(Math.cos(i * segmentAngle) * radiusX, Math.sin(i * segmentAngle) * radiusY, z));
        return points;
    }
    /**
     * Gets line points in a shape of a bezier curve
     * @param p0 bezier point0
     * @param p1 bezier point1
     * @param p2 bezier point2
     * @param segments number of segments in the curve
     * @returns
     */ static GetBezierLinePoints(p0, p1, p2, segments) {
        return (0, $fm2C6.Curve3).CreateQuadraticBezier(p0, p1, p2, segments).getPoints().flatMap((v)=>[
                v.x,
                v.y,
                v.z
            ]);
    }
    /**
     *
     * @param position position of the arrow cap (mainly you want to create a triangle, set widthUp and widthDown to the same value and omit widthStartUp and widthStartDown)
     * @param direction direction which the arrow points to
     * @param length length (size) of the arrow cap itself
     * @param widthUp the arrow width above the line
     * @param widthDown the arrow width belove the line
     * @param widthStartUp the arrow width at the start of the arrow above the line. In most scenarios this is 0.
     * @param widthStartDown the arrow width at the start of the arrow below the line. In most scenarios this is 0.
     * @returns
     */ static GetArrowCap(position, direction, length, widthUp, widthDown, widthStartUp = 0, widthStartDown = 0) {
        const points = [
            position.clone(),
            position.add(direction.multiplyByFloats(length, length, length))
        ];
        const widths = [
            widthUp,
            widthDown,
            widthStartUp,
            widthStartDown
        ];
        return {
            points: points,
            widths: widths
        };
    }
    /**
     * Gets 3D positions of points from a text and font
     * @param text Text
     * @param size Size of the font
     * @param resolution Resolution of the font
     * @param fontData defines the font data (can be generated with http://gero3.github.io/facetype.js/)
     * @param z z coordinate
     * @param includeInner include the inner parts of the font in the result. Default true. If false, only the outlines will be returned.
     * @returns number[][] of 3D positions
     */ static GetPointsFromText(text, size, resolution, fontData, z = 0, includeInner = true) {
        const allPoints = [];
        const shapePaths = (0, $dBltS.CreateTextShapePaths)(text, size, resolution, fontData);
        for (const sp of shapePaths){
            for (const p of sp.paths){
                const points = [];
                const points2d = p.getPoints();
                for (const p2d of points2d)points.push(p2d.x, p2d.y, z);
                allPoints.push(points);
            }
            if (includeInner) for (const h of sp.holes){
                const holes = [];
                const points2d = h.getPoints();
                for (const p2d of points2d)holes.push(p2d.x, p2d.y, z);
                allPoints.push(holes);
            }
        }
        return allPoints;
    }
    /**
     * Converts an array of Color3 to Uint8Array
     * @param colors Arrray of Color3
     * @returns Uin8Array of colors [r, g, b, a, r, g, b, a, ...]
     */ static Color3toRGBAUint8(colors) {
        const colorTable = new Uint8Array(colors.length * 4);
        for(let i = 0, j = 0; i < colors.length; i++){
            colorTable[j++] = colors[i].r * 255;
            colorTable[j++] = colors[i].g * 255;
            colorTable[j++] = colors[i].b * 255;
            colorTable[j++] = 255;
        }
        return colorTable;
    }
    /**
     * Creates a RawTexture from an RGBA color array and sets it on the plugin material instance.
     * @param name name of the texture
     * @param colors Uint8Array of colors
     * @param colorsSampling sampling mode of the created texture
     * @param scene Scene
     * @returns the colors texture
     */ static CreateColorsTexture(name, colors, colorsSampling, scene) {
        const colorsArray = $85b193861407b7a8$export$691a2718102fcdcf.Color3toRGBAUint8(colors);
        const colorsTexture = new (0, $5Egpj.RawTexture)(colorsArray, colors.length, 1, (0, $5YkyR.Engine).TEXTUREFORMAT_RGBA, scene, false, true, colorsSampling);
        colorsTexture.name = name;
        return colorsTexture;
    }
    /**
     * A minimum size texture for the colors sampler2D when there is no colors texture defined yet.
     * For fast switching using the useColors property without the need to use defines.
     * @param scene Scene
     * @returns empty colors texture
     */ static PrepareEmptyColorsTexture(scene) {
        if (!(0, $7LG5O.GreasedLineMaterialDefaults).EmptyColorsTexture) {
            const colorsArray = new Uint8Array(4);
            (0, $7LG5O.GreasedLineMaterialDefaults).EmptyColorsTexture = new (0, $5Egpj.RawTexture)(colorsArray, 1, 1, (0, $5YkyR.Engine).TEXTUREFORMAT_RGBA, scene, false, false, (0, $5Egpj.RawTexture).NEAREST_NEAREST);
            (0, $7LG5O.GreasedLineMaterialDefaults).EmptyColorsTexture.name = "grlEmptyColorsTexture";
        }
        return (0, $7LG5O.GreasedLineMaterialDefaults).EmptyColorsTexture;
    }
    /**
     * Diposes the shared empty colors texture
     */ static DisposeEmptyColorsTexture() {
        (0, $7LG5O.GreasedLineMaterialDefaults).EmptyColorsTexture?.dispose();
        (0, $7LG5O.GreasedLineMaterialDefaults).EmptyColorsTexture = null;
    }
    /**
     * Converts boolean to number.
     * @param bool the bool value
     * @returns 1 if true, 0 if false.
     */ static BooleanToNumber(bool) {
        return bool ? 1 : 0;
    }
}

});


parcelRegister("hExvk", function(module, exports) {

$parcel$export(module.exports, "GreasedLineSimpleMaterial", () => $cda0295c234ab1e7$export$a77643760525895b);

var $5Egpj = parcelRequire("5Egpj");

var $4I7rl = parcelRequire("4I7rl");

var $7etnY = parcelRequire("7etnY");

var $ha1VO = parcelRequire("ha1VO");
parcelRequire("i73gc");
parcelRequire("51URk");

var $bZbGh = parcelRequire("bZbGh");

var $btEbG = parcelRequire("btEbG");

var $7LG5O = parcelRequire("7LG5O");
class $cda0295c234ab1e7$export$a77643760525895b extends (0, $4I7rl.ShaderMaterial) {
    /**
     * GreasedLineSimple material constructor
     * @param name material name
     * @param scene the scene
     * @param options material options
     */ constructor(name, scene, options){
        const defines = [
            `COLOR_DISTRIBUTION_TYPE_LINE ${(0, $bZbGh.GreasedLineMeshColorDistributionType).COLOR_DISTRIBUTION_TYPE_LINE}.`,
            `COLOR_DISTRIBUTION_TYPE_SEGMENT ${(0, $bZbGh.GreasedLineMeshColorDistributionType).COLOR_DISTRIBUTION_TYPE_SEGMENT}.`,
            `COLOR_MODE_SET ${(0, $bZbGh.GreasedLineMeshColorMode).COLOR_MODE_SET}.`,
            `COLOR_MODE_ADD ${(0, $bZbGh.GreasedLineMeshColorMode).COLOR_MODE_ADD}.`,
            `COLOR_MODE_MULTIPLY ${(0, $bZbGh.GreasedLineMeshColorMode).COLOR_MODE_MULTIPLY}.`
        ];
        const attributes = [
            "position",
            "grl_widths",
            "grl_offsets",
            "grl_colorPointers"
        ];
        scene.useRightHandedSystem && defines.push("GREASED_LINE_RIGHT_HANDED_COORDINATE_SYSTEM");
        if (options.cameraFacing) {
            defines.push("GREASED_LINE_CAMERA_FACING");
            attributes.push("grl_previousAndSide", "grl_nextAndCounters");
        } else {
            attributes.push("grl_slopes");
            attributes.push("grl_counters");
        }
        super(name, scene, {
            vertex: "greasedLine",
            fragment: "greasedLine"
        }, {
            attributes: attributes,
            uniforms: [
                "world",
                "viewProjection",
                "view",
                "projection",
                "grlColorsWidth",
                "grlUseColors",
                "grlWidth",
                "grlColor",
                "grl_colorModeAndColorDistributionType",
                "grlResolution",
                "grlAspect",
                "grlAizeAttenuation",
                "grlDashArray",
                "grlDashOffset",
                "grlDashRatio",
                "grlUseDash",
                "grlVisibility"
            ],
            samplers: [
                "grlColors"
            ],
            defines: defines
        });
        this._color = (0, $7etnY.Color3).White();
        this._colorsDistributionType = (0, $bZbGh.GreasedLineMeshColorDistributionType).COLOR_DISTRIBUTION_TYPE_SEGMENT;
        this._colorsTexture = null;
        options = options || {
            color: (0, $7LG5O.GreasedLineMaterialDefaults).DEFAULT_COLOR
        };
        const engine = scene.getEngine();
        this.visibility = options.visibility ?? 1;
        this.useDash = options.useDash ?? false;
        this.dashRatio = options.dashRatio ?? 0.5;
        this.dashOffset = options.dashOffset ?? 0;
        this.dashCount = options.dashCount ?? 1; // calculate the _dashArray value, call the setter
        this.width = options.width ? options.width : options.sizeAttenuation && options.cameraFacing ? (0, $7LG5O.GreasedLineMaterialDefaults).DEFAULT_WIDTH_ATTENUATED : (0, $7LG5O.GreasedLineMaterialDefaults).DEFAULT_WIDTH;
        this.sizeAttenuation = options.sizeAttenuation ?? false;
        this.color = options.color ?? (0, $7etnY.Color3).White();
        this.useColors = options.useColors ?? false;
        this.colorsDistributionType = options.colorDistributionType ?? (0, $bZbGh.GreasedLineMeshColorDistributionType).COLOR_DISTRIBUTION_TYPE_SEGMENT;
        this.colorsSampling = options.colorsSampling ?? (0, $5Egpj.RawTexture).NEAREST_NEAREST;
        this.colorMode = options.colorMode ?? (0, $bZbGh.GreasedLineMeshColorMode).COLOR_MODE_SET;
        this._colors = options.colors ?? null;
        this._cameraFacing = options.cameraFacing ?? true;
        this.resolution = options.resolution ?? new (0, $ha1VO.Vector2)(engine.getRenderWidth(), engine.getRenderHeight()); // calculate aspect call the setter
        if (options.colorsTexture) this.colorsTexture = options.colorsTexture;
        else this.colorsTexture = (0, $btEbG.GreasedLineTools).PrepareEmptyColorsTexture(scene);
        if (this._colors) this.setColors(this._colors);
        engine.onDisposeObservable.add(()=>{
            (0, $btEbG.GreasedLineTools).DisposeEmptyColorsTexture();
        });
    }
    /**
     * Disposes the plugin material.
     */ dispose() {
        this._colorsTexture?.dispose();
        super.dispose();
    }
    _setColorModeAndColorDistributionType() {
        this.setVector2("grl_colorModeAndColorDistributionType", new (0, $ha1VO.Vector2)(this._colorMode, this._colorsDistributionType));
    }
    /**
     * Updates the material. Use when material created in lazy mode.
     */ updateLazy() {
        if (this._colors) this.setColors(this._colors, false, true);
    }
    /**
     * Returns the colors used to colorize the line
     */ get colors() {
        return this._colors;
    }
    /**
     * Sets the colors used to colorize the line
     */ set colors(value) {
        this.setColors(value);
    }
    /**
     * Creates or updates the colors texture
     * @param colors color table RGBA
     * @param lazy if lazy, the colors are not updated
     * @param forceNewTexture force creation of a new texture
     */ setColors(colors, lazy = false, forceNewTexture = false) {
        const origColorsCount = this._colors?.length ?? 0;
        this._colors = colors;
        if (colors === null || colors.length === 0) {
            this._colorsTexture?.dispose();
            return;
        }
        if (lazy && !forceNewTexture) return;
        if (this._colorsTexture && origColorsCount === colors.length && !forceNewTexture) {
            const colorArray = (0, $btEbG.GreasedLineTools).Color3toRGBAUint8(colors);
            this._colorsTexture.update(colorArray);
        } else {
            this._colorsTexture?.dispose();
            this.colorsTexture = (0, $btEbG.GreasedLineTools).CreateColorsTexture(`${this.name}-colors-texture`, colors, this.colorsSampling, this.getScene());
        }
    }
    /**
     * Gets the colors texture
     */ get colorsTexture() {
        return this._colorsTexture ?? null;
    }
    /**
     * Sets the colorsTexture
     */ set colorsTexture(value) {
        this._colorsTexture = value;
        this.setFloat("grlColorsWidth", this._colorsTexture.getSize().width);
        this.setTexture("grlColors", this._colorsTexture);
    }
    /**
     * Line base width. At each point the line width is calculated by widths[pointIndex] * width
     */ get width() {
        return this._width;
    }
    /**
     * Line base width. At each point the line width is calculated by widths[pointIndex] * width
     */ set width(value) {
        this._width = value;
        this.setFloat("grlWidth", value);
    }
    /**
     * Whether to use the colors option to colorize the line
     */ get useColors() {
        return this._useColors;
    }
    set useColors(value) {
        this._useColors = value;
        this.setFloat("grlUseColors", (0, $btEbG.GreasedLineTools).BooleanToNumber(value));
    }
    /**
     * The type of sampling of the colors texture. The values are the same when using with textures.
     */ get colorsSampling() {
        return this._colorsSampling;
    }
    /**
     * The type of sampling of the colors texture. The values are the same when using with textures.
     */ set colorsSampling(value) {
        this._colorsSampling = value;
    }
    /**
     * Normalized value of how much of the line will be visible
     * 0 - 0% of the line will be visible
     * 1 - 100% of the line will be visible
     */ get visibility() {
        return this._visibility;
    }
    set visibility(value) {
        this._visibility = value;
        this.setFloat("grlVisibility", value);
    }
    /**
     * Turns on/off dash mode
     */ get useDash() {
        return this._useDash;
    }
    /**
     * Turns on/off dash mode
     */ set useDash(value) {
        this._useDash = value;
        this.setFloat("grlUseDash", (0, $btEbG.GreasedLineTools).BooleanToNumber(value));
    }
    /**
     * Gets the dash offset
     */ get dashOffset() {
        return this._dashOffset;
    }
    /**
     * Sets the dash offset
     */ set dashOffset(value) {
        this._dashOffset = value;
        this.setFloat("grlDashOffset", value);
    }
    /**
     * Length of the dash. 0 to 1. 0.5 means half empty, half drawn.
     */ get dashRatio() {
        return this._dashRatio;
    }
    /**
     * Length of the dash. 0 to 1. 0.5 means half empty, half drawn.
     */ set dashRatio(value) {
        this._dashRatio = value;
        this.setFloat("grlDashRatio", value);
    }
    /**
     * Gets the number of dashes in the line
     */ get dashCount() {
        return this._dashCount;
    }
    /**
     * Sets the number of dashes in the line
     * @param value dash
     */ set dashCount(value) {
        this._dashCount = value;
        this._dashArray = 1 / value;
        this.setFloat("grlDashArray", this._dashArray);
    }
    /**
     * False means 1 unit in width = 1 unit on scene, true means 1 unit in width is reduced on the screen to make better looking lines
     */ get sizeAttenuation() {
        return this._sizeAttenuation;
    }
    /**
     * Turn on/off attenuation of the width option and widths array.
     * @param value false means 1 unit in width = 1 unit on scene, true means 1 unit in width is reduced on the screen to make better looking lines
     */ set sizeAttenuation(value) {
        this._sizeAttenuation = value;
        this.setFloat("grlSizeAttenuation", (0, $btEbG.GreasedLineTools).BooleanToNumber(value));
    }
    /**
     * Gets the color of the line
     */ get color() {
        return this.color;
    }
    /**
     * Sets the color of the line
     * @param value Color3
     */ set color(value) {
        this.setColor(value);
    }
    /**
     * Sets the color of the line. If set the whole line will be mixed with this color according to the colorMode option.
     * The simple material always needs a color to be set. If you set it to null it will set the color to the default color (GreasedLineSimpleMaterial.DEFAULT_COLOR).
     * @param value color
     */ setColor(value) {
        value = value ?? (0, $7LG5O.GreasedLineMaterialDefaults).DEFAULT_COLOR;
        this._color = value;
        this.setColor3("grlColor", value);
    }
    /**
     * Gets the color distributiopn type
     */ get colorsDistributionType() {
        return this._colorsDistributionType;
    }
    /**
     * Sets the color distribution type
     * @see GreasedLineMeshColorDistributionType
     * @param value color distribution type
     */ set colorsDistributionType(value) {
        this._colorsDistributionType = value;
        this._setColorModeAndColorDistributionType();
    }
    /**
     * Gets the mixing mode of the color and colors paramaters. Default value is GreasedLineMeshColorMode.SET.
     * MATERIAL_TYPE_SIMPLE mixes the color and colors of the greased line material.
     * @see GreasedLineMeshColorMode
     */ get colorMode() {
        return this._colorMode;
    }
    /**
     * Sets the mixing mode of the color and colors paramaters. Default value is GreasedLineMeshColorMode.SET.
     * MATERIAL_TYPE_SIMPLE mixes the color and colors of the greased line material.
     * @see GreasedLineMeshColorMode
     */ set colorMode(value) {
        this._colorMode = value;
        this._setColorModeAndColorDistributionType();
    }
    /**
     * Gets the resolution
     */ get resolution() {
        return this._resolution;
    }
    /**
     * Sets the resolution
     * @param value resolution of the screen for GreasedLine
     */ set resolution(value) {
        this._resolution = value;
        this.setVector2("grlResolution", value);
        this.setFloat("grlAspect", value.x / value.y);
    }
    /**
     * Serializes this plugin material
     * @returns serializationObjec
     */ serialize() {
        const serializationObject = super.serialize();
        const greasedLineMaterialOptions = {
            colorDistributionType: this._colorsDistributionType,
            colorsSampling: this._colorsSampling,
            colorMode: this._colorMode,
            color: this._color,
            dashCount: this._dashCount,
            dashOffset: this._dashOffset,
            dashRatio: this._dashRatio,
            resolution: this._resolution,
            sizeAttenuation: this._sizeAttenuation,
            useColors: this._useColors,
            useDash: this._useDash,
            visibility: this._visibility,
            width: this._width,
            cameraFacing: this._cameraFacing
        };
        this._colors && (greasedLineMaterialOptions.colors = this._colors);
        serializationObject.greasedLineMaterialOptions = greasedLineMaterialOptions;
        return serializationObject;
    }
    /**
     * Parses a serialized objects
     * @param source serialized object
     * @param scene scene
     * @param _rootUrl root url for textures
     */ parse(source, scene, _rootUrl) {
        // TODO: super.parse?
        const greasedLineMaterialOptions = source.greasedLineMaterialOptions;
        this._colorsTexture?.dispose();
        greasedLineMaterialOptions.color && (this.color = greasedLineMaterialOptions.color);
        greasedLineMaterialOptions.colorDistributionType && (this.colorsDistributionType = greasedLineMaterialOptions.colorDistributionType);
        greasedLineMaterialOptions.colorsSampling && (this.colorsSampling = greasedLineMaterialOptions.colorsSampling);
        greasedLineMaterialOptions.colorMode && (this.colorMode = greasedLineMaterialOptions.colorMode);
        greasedLineMaterialOptions.useColors && (this.useColors = greasedLineMaterialOptions.useColors);
        greasedLineMaterialOptions.visibility && (this.visibility = greasedLineMaterialOptions.visibility);
        greasedLineMaterialOptions.useDash && (this.useDash = greasedLineMaterialOptions.useDash);
        greasedLineMaterialOptions.dashCount && (this.dashCount = greasedLineMaterialOptions.dashCount);
        greasedLineMaterialOptions.dashRatio && (this.dashRatio = greasedLineMaterialOptions.dashRatio);
        greasedLineMaterialOptions.dashOffset && (this.dashOffset = greasedLineMaterialOptions.dashOffset);
        greasedLineMaterialOptions.width && (this.width = greasedLineMaterialOptions.width);
        greasedLineMaterialOptions.sizeAttenuation && (this.sizeAttenuation = greasedLineMaterialOptions.sizeAttenuation);
        greasedLineMaterialOptions.resolution && (this.resolution = greasedLineMaterialOptions.resolution);
        if (greasedLineMaterialOptions.colors) this.colorsTexture = (0, $btEbG.GreasedLineTools).CreateColorsTexture(`${this.name}-colors-texture`, greasedLineMaterialOptions.colors, this.colorsSampling, this.getScene());
        else this.colorsTexture = (0, $btEbG.GreasedLineTools).PrepareEmptyColorsTexture(scene);
        this._cameraFacing = greasedLineMaterialOptions.cameraFacing ?? true;
        this.setDefine("GREASED_LINE_CAMERA_FACING", this._cameraFacing);
    }
}

});
parcelRegister("i73gc", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $d2fb68defc9432af$var$name = "greasedLinePixelShader";
const $d2fb68defc9432af$var$shader = `precision highp float;uniform sampler2D grlColors;uniform float grlUseColors;uniform float grlUseDash;uniform float grlDashArray;uniform float grlDashOffset;uniform float grlDashRatio;uniform float grlVisibility;uniform float grlColorsWidth;uniform vec2 grl_colorModeAndColorDistributionType;uniform vec3 grlColor;varying float grlCounters;varying float grlColorPointer;void main() {float grlColorMode=grl_colorModeAndColorDistributionType.x;float grlColorDistributionType=grl_colorModeAndColorDistributionType.y;gl_FragColor=vec4(grlColor,1.);gl_FragColor.a=step(grlCounters,grlVisibility);if (gl_FragColor.a==0.) discard;if( grlUseDash==1. ){gl_FragColor.a=ceil(mod(grlCounters+grlDashOffset,grlDashArray)-(grlDashArray*grlDashRatio));if (gl_FragColor.a==0.) discard;}
if (grlUseColors==1.) {vec4 textureColor;if (grlColorDistributionType==COLOR_DISTRIBUTION_TYPE_LINE) { 
textureColor=texture2D(grlColors,vec2(grlCounters,0.),0.);} else {textureColor=texture2D(grlColors,vec2(grlColorPointer/grlColorsWidth,0.),0.);}
if (grlColorMode==COLOR_MODE_SET) {gl_FragColor=textureColor;} else if (grlColorMode==COLOR_MODE_ADD) {gl_FragColor+=textureColor;} else if (grlColorMode==COLOR_MODE_MULTIPLY) {gl_FragColor*=textureColor;}}}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$d2fb68defc9432af$var$name] = $d2fb68defc9432af$var$shader;
const $d2fb68defc9432af$export$e0b0110c95f0e352 = {
    name: $d2fb68defc9432af$var$name,
    shader: $d2fb68defc9432af$var$shader
};

});

parcelRegister("51URk", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("k3wwH");
parcelRequire("apKdp");
const $3a9926cbfa5975cd$var$name = "greasedLineVertexShader";
const $3a9926cbfa5975cd$var$shader = `precision highp float;
#include<instancesDeclaration>
attribute float grl_widths;attribute vec3 grl_offsets;attribute float grl_colorPointers;attribute vec3 position;uniform mat4 viewProjection;uniform mat4 projection;varying float grlCounters;varying float grlColorPointer;
#ifdef GREASED_LINE_CAMERA_FACING
attribute vec4 grl_nextAndCounters;attribute vec4 grl_previousAndSide;uniform vec2 grlResolution;uniform float grlAspect;uniform float grlWidth;uniform float grlSizeAttenuation;vec2 grlFix( vec4 i,float aspect ) {vec2 res=i.xy/i.w;res.x*=aspect;return res;}
#else
attribute vec3 grl_slopes;attribute float grl_counters;
#endif
void main() {
#include<instancesVertex>
grlColorPointer=grl_colorPointers;
#ifdef GREASED_LINE_CAMERA_FACING
float grlBaseWidth=grlWidth;vec3 grlPrevious=grl_previousAndSide.xyz;float grlSide=grl_previousAndSide.w;vec3 grlNext=grl_nextAndCounters.xyz;grlCounters=grl_nextAndCounters.w;mat4 grlMatrix=viewProjection*finalWorld ;vec3 grlPositionOffset=grl_offsets;vec4 grlFinalPosition=grlMatrix*vec4( position+grlPositionOffset ,1.0 );vec4 grlPrevPos=grlMatrix*vec4( grlPrevious+grlPositionOffset,1.0 );vec4 grlNextPos=grlMatrix*vec4( grlNext+grlPositionOffset,1.0 );vec2 grlCurrentP=grlFix( grlFinalPosition,grlAspect );vec2 grlPrevP=grlFix( grlPrevPos,grlAspect );vec2 grlNextP=grlFix( grlNextPos,grlAspect );float grlWidth=grlBaseWidth*grl_widths;vec2 grlDir;if( grlNextP==grlCurrentP ) grlDir=normalize( grlCurrentP-grlPrevP );else if( grlPrevP==grlCurrentP ) grlDir=normalize( grlNextP-grlCurrentP );else {vec2 grlDir1=normalize( grlCurrentP-grlPrevP );vec2 grlDir2=normalize( grlNextP-grlCurrentP );grlDir=normalize( grlDir1+grlDir2 );}
vec4 grlNormal=vec4( -grlDir.y,grlDir.x,0.,1. );
#ifdef GREASED_LINE_RIGHT_HANDED_COORDINATE_SYSTEM
grlNormal.xy*=-.5*grlWidth;
#else
grlNormal.xy*=.5*grlWidth;
#endif
grlNormal*=projection;if (grlSizeAttenuation==1.) {grlNormal.xy*=grlFinalPosition.w;grlNormal.xy/=( vec4( grlResolution,0.,1. )*projection ).xy;}
grlFinalPosition.xy+=grlNormal.xy*grlSide;gl_Position=grlFinalPosition;
#else
grlCounters=grl_counters;vec4 grlFinalPosition=worldViewProjection*vec4( (position+grl_offsets)+grl_slopes*grl_widths ,1.0 ) ;gl_Position=grlFinalPosition;
#endif
}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$3a9926cbfa5975cd$var$name] = $3a9926cbfa5975cd$var$shader;
const $3a9926cbfa5975cd$export$363c8c1ab9439fb4 = {
    name: $3a9926cbfa5975cd$var$name,
    shader: $3a9926cbfa5975cd$var$shader
};

});


parcelRegister("7Fvtq", function(module, exports) {

$parcel$export(module.exports, "MeshDebugMode", () => $5954c6b758e67c53$export$b21a051b241c7232);
$parcel$export(module.exports, "MeshDebugPluginMaterial", () => $5954c6b758e67c53$export$b81db3435f12d221);

var $e0Suo = parcelRequire("e0Suo");

var $8XNAC = parcelRequire("8XNAC");

var $35xmP = parcelRequire("35xmP");

var $8DoUR = parcelRequire("8DoUR");
parcelRequire("6rxfP");
var $7etnY = parcelRequire("7etnY");

var $kVtWi = parcelRequire("kVtWi");

var $ir0rz = parcelRequire("ir0rz");
const $5954c6b758e67c53$var$vertexDefinitions = `#if defined(DBG_ENABLED)
attribute float dbg_initialPass;
varying vec3 dbg_vBarycentric;
flat varying vec3 dbg_vVertexWorldPos;
flat varying float dbg_vPass;
#endif`;
const $5954c6b758e67c53$var$vertexMainEnd = `#if defined(DBG_ENABLED)
float dbg_vertexIndex = mod(float(gl_VertexID), 3.);
if (dbg_vertexIndex == 0.0) { 
    dbg_vBarycentric = vec3(1.,0.,0.); 
}
else if (dbg_vertexIndex == 1.0) { 
    dbg_vBarycentric = vec3(0.,1.,0.); 
}
else { 
    dbg_vBarycentric = vec3(0.,0.,1.); 
}

dbg_vVertexWorldPos = vPositionW;
dbg_vPass = dbg_initialPass;
#endif`;
const $5954c6b758e67c53$var$fragmentUniforms = `#if defined(DBG_ENABLED)
uniform vec3 dbg_shadedDiffuseColor;
uniform vec4 dbg_shadedSpecularColorPower;
uniform vec3 dbg_thicknessRadiusScale;

#if DBG_MODE == 2 || DBG_MODE == 3
    uniform vec3 dbg_vertexColor;
#endif

#if DBG_MODE == 1
    uniform vec3 dbg_wireframeTrianglesColor;
#elif DBG_MODE == 3
    uniform vec3 dbg_wireframeVerticesColor;
#elif DBG_MODE == 4 || DBG_MODE == 5
    uniform vec3 dbg_uvPrimaryColor;
    uniform vec3 dbg_uvSecondaryColor;
#elif DBG_MODE == 7
    uniform vec3 dbg_materialColor;
#endif
#endif`;
const $5954c6b758e67c53$var$fragmentDefinitions = `#if defined(DBG_ENABLED)
varying vec3 dbg_vBarycentric;
flat varying vec3 dbg_vVertexWorldPos;
flat varying float dbg_vPass;

#if !defined(DBG_MULTIPLY)
    vec3 dbg_applyShading(vec3 color) {
        vec3 N = vNormalW.xyz;
        vec3 L = normalize(vEyePosition.xyz - vPositionW.xyz);
        vec3 H = normalize(L + L);
        float LdotN = clamp(dot(L,N), 0., 1.);
        float HdotN = clamp(dot(H,N), 0., 1.);
        float specTerm = pow(HdotN, dbg_shadedSpecularColorPower.w);
        color *= (LdotN / PI);
        color += dbg_shadedSpecularColorPower.rgb * (specTerm / PI);
        return color;
    }
#endif

#if DBG_MODE == 1 || DBG_MODE == 3
    float dbg_edgeFactor() {
        vec3 d = fwidth(dbg_vBarycentric);
        vec3 a3 = smoothstep(vec3(0.), d * dbg_thicknessRadiusScale.x, dbg_vBarycentric);
        return min(min(a3.x, a3.y), a3.z);
    }
#endif

#if DBG_MODE == 2 || DBG_MODE == 3
    float dbg_cornerFactor() {
        vec3 worldPos = vPositionW;
        float dist = length(worldPos - dbg_vVertexWorldPos);
        float camDist = length(worldPos - vEyePosition.xyz);
        float d = sqrt(camDist) * .001;
        return smoothstep((dbg_thicknessRadiusScale.y * d), ((dbg_thicknessRadiusScale.y * 1.01) * d), dist);
    }
#endif

#if (DBG_MODE == 4 && defined(UV1)) || (DBG_MODE == 5 && defined(UV2))
    float dbg_checkerboardFactor(vec2 uv) {
        vec2 f = fract(uv * dbg_thicknessRadiusScale.z);
        f -= .5;
        return (f.x * f.y) > 0. ? 1. : 0.;
    }
#endif
#endif`;
const $5954c6b758e67c53$var$fragmentMainEnd = `#if defined(DBG_ENABLED)
vec3 dbg_color = vec3(1.);
#if DBG_MODE == 1
    dbg_color = mix(dbg_wireframeTrianglesColor, vec3(1.), dbg_edgeFactor());
#elif DBG_MODE == 2 || DBG_MODE == 3
    float dbg_cornerFactor = dbg_cornerFactor();
    if (dbg_vPass == 0. && dbg_cornerFactor == 1.) discard;
    dbg_color = mix(dbg_vertexColor, vec3(1.), dbg_cornerFactor);
    #if DBG_MODE == 3
        dbg_color *= mix(dbg_wireframeVerticesColor, vec3(1.), dbg_edgeFactor());
    #endif
#elif DBG_MODE == 4 && defined(UV1)
    dbg_color = mix(dbg_uvPrimaryColor, dbg_uvSecondaryColor, dbg_checkerboardFactor(vMainUV1));
#elif DBG_MODE == 5 && defined(UV2)
    dbg_color = mix(dbg_uvPrimaryColor, dbg_uvSecondaryColor, dbg_checkerboardFactor(vMainUV2));
#elif DBG_MODE == 6 && defined(VERTEXCOLOR)
    dbg_color = vColor.rgb;
#elif DBG_MODE == 7
    dbg_color = dbg_materialColor;
#endif

#if defined(DBG_MULTIPLY)
    gl_FragColor *= vec4(dbg_color, 1.);
#else
    #if DBG_MODE != 6
        gl_FragColor = vec4(dbg_applyShading(dbg_shadedDiffuseColor) * dbg_color, 1.);
    #else
        gl_FragColor = vec4(dbg_color, 1.);
    #endif
#endif
#endif`;
const $5954c6b758e67c53$var$defaultMaterialColors = [
    new (0, $7etnY.Color3)(0.98, 0.26, 0.38),
    new (0, $7etnY.Color3)(0.47, 0.75, 0.3),
    new (0, $7etnY.Color3)(0, 0.26, 0.77),
    new (0, $7etnY.Color3)(0.97, 0.6, 0.76),
    new (0, $7etnY.Color3)(0.19, 0.63, 0.78),
    new (0, $7etnY.Color3)(0.98, 0.8, 0.6),
    new (0, $7etnY.Color3)(0.65, 0.43, 0.15),
    new (0, $7etnY.Color3)(0.15, 0.47, 0.22),
    new (0, $7etnY.Color3)(0.67, 0.71, 0.86),
    new (0, $7etnY.Color3)(0.09, 0.46, 0.56),
    new (0, $7etnY.Color3)(0.8, 0.98, 0.02),
    new (0, $7etnY.Color3)(0.39, 0.29, 0.13),
    new (0, $7etnY.Color3)(0.53, 0.63, 0.06),
    new (0, $7etnY.Color3)(0.95, 0.96, 0.41),
    new (0, $7etnY.Color3)(1, 0.72, 0.94),
    new (0, $7etnY.Color3)(0.63, 0.08, 0.31),
    new (0, $7etnY.Color3)(0.66, 0.96, 0.95),
    new (0, $7etnY.Color3)(0.22, 0.14, 0.19),
    new (0, $7etnY.Color3)(0.14, 0.65, 0.59),
    new (0, $7etnY.Color3)(0.93, 1, 0.68),
    new (0, $7etnY.Color3)(0.93, 0.14, 0.44),
    new (0, $7etnY.Color3)(0.47, 0.86, 0.67),
    new (0, $7etnY.Color3)(0.85, 0.07, 0.78),
    new (0, $7etnY.Color3)(0.53, 0.64, 0.98),
    new (0, $7etnY.Color3)(0.43, 0.37, 0.56),
    new (0, $7etnY.Color3)(0.71, 0.65, 0.25),
    new (0, $7etnY.Color3)(0.66, 0.19, 0.01),
    new (0, $7etnY.Color3)(0.94, 0.53, 0.12),
    new (0, $7etnY.Color3)(0.41, 0.44, 0.44),
    new (0, $7etnY.Color3)(0.24, 0.71, 0.96),
    new (0, $7etnY.Color3)(0.57, 0.28, 0.56),
    new (0, $7etnY.Color3)(0.44, 0.98, 0.42)
];
var $5954c6b758e67c53$export$b21a051b241c7232;
(function(MeshDebugMode) {
    /**
     * Material without any mesh debug visualization
     */ MeshDebugMode[MeshDebugMode["NONE"] = 0] = "NONE";
    /**
     * A wireframe of the mesh
     * NOTE: For this mode to work correctly, convertToUnIndexedMesh() or MeshDebugPluginMaterial.PrepareMeshForTrianglesAndVerticesMode() must first be called on mesh.
     */ MeshDebugMode[MeshDebugMode["TRIANGLES"] = 1] = "TRIANGLES";
    /**
     * Points drawn over vertices of mesh
     * NOTE: For this mode to work correctly, MeshDebugPluginMaterial.PrepareMeshForTrianglesAndVerticesMode() must first be called on mesh.
     */ MeshDebugMode[MeshDebugMode["VERTICES"] = 2] = "VERTICES";
    /**
     * A wireframe of the mesh, with points drawn over vertices
     * NOTE: For this mode to work correctly, MeshDebugPluginMaterial.PrepareMeshForTrianglesAndVerticesMode() must first be called on mesh.
     */ MeshDebugMode[MeshDebugMode["TRIANGLES_VERTICES"] = 3] = "TRIANGLES_VERTICES";
    /**
     * A checkerboard grid of the mesh's UV set 0
     */ MeshDebugMode[MeshDebugMode["UV0"] = 4] = "UV0";
    /**
     * A checkerboard grid of the mesh's UV set 1
     */ MeshDebugMode[MeshDebugMode["UV1"] = 5] = "UV1";
    /**
     * The mesh's vertex colors displayed as the primary texture
     */ MeshDebugMode[MeshDebugMode["VERTEXCOLORS"] = 6] = "VERTEXCOLORS";
    /**
     * An arbitrary, distinguishable color to identify the material
     */ MeshDebugMode[MeshDebugMode["MATERIALIDS"] = 7] = "MATERIALIDS";
})($5954c6b758e67c53$export$b21a051b241c7232 || ($5954c6b758e67c53$export$b21a051b241c7232 = {}));
/** @internal */ class $5954c6b758e67c53$var$MeshDebugDefines extends (0, $35xmP.MaterialDefines) {
    constructor(){
        super(...arguments);
        /**
         * Current mesh debug visualization.
         * Defaults to NONE.
         */ this.DBG_MODE = $5954c6b758e67c53$export$b21a051b241c7232.NONE;
        /**
         * Whether the mesh debug visualization multiplies with colors underneath.
         * Defaults to true.
         */ this.DBG_MULTIPLY = true;
        /**
         * Whether the mesh debug plugin is enabled in the material.
         * Defaults to true.
         */ this.DBG_ENABLED = true;
    }
}
class $5954c6b758e67c53$export$b81db3435f12d221 extends (0, $8XNAC.MaterialPluginBase) {
    /** @internal */ _markAllDefinesAsDirty() {
        this._enable(this._isEnabled);
        this.markAllDefinesAsDirty();
    }
    /**
     * Creates a new MeshDebugPluginMaterial
     * @param material Material to attach the mesh debug plugin to
     * @param options Options for the mesh debug plugin
     */ constructor(material, options = {}){
        const defines = new $5954c6b758e67c53$var$MeshDebugDefines();
        defines.DBG_MODE = options.mode ?? defines.DBG_MODE;
        defines.DBG_MULTIPLY = options.multiply ?? defines.DBG_MULTIPLY;
        super(material, "MeshDebug", 200, defines, true, true);
        this._mode = defines.DBG_MODE;
        this._multiply = defines.DBG_MULTIPLY;
        this.shadedDiffuseColor = options.shadedDiffuseColor ?? new (0, $7etnY.Color3)(1, 1, 1);
        this.shadedSpecularColor = options.shadedSpecularColor ?? new (0, $7etnY.Color3)(0.8, 0.8, 0.8);
        this.shadedSpecularPower = options.shadedSpecularPower ?? 10;
        this.wireframeThickness = options.wireframeThickness ?? 0.7;
        this.wireframeTrianglesColor = options.wireframeTrianglesColor ?? new (0, $7etnY.Color3)(0, 0, 0);
        this.wireframeVerticesColor = options.wireframeVerticesColor ?? new (0, $7etnY.Color3)(0.8, 0.8, 0.8);
        this.vertexColor = options.vertexColor ?? new (0, $7etnY.Color3)(0, 0, 0);
        this.vertexRadius = options.vertexRadius ?? 1.2;
        this.uvScale = options.uvScale ?? 20;
        this.uvPrimaryColor = options.uvPrimaryColor ?? new (0, $7etnY.Color3)(1, 1, 1);
        this.uvSecondaryColor = options.uvSecondaryColor ?? new (0, $7etnY.Color3)(0.5, 0.5, 0.5);
        this._materialColor = $5954c6b758e67c53$export$b81db3435f12d221.MaterialColors[$5954c6b758e67c53$export$b81db3435f12d221._PluginCount++ % $5954c6b758e67c53$export$b81db3435f12d221.MaterialColors.length];
        this.isEnabled = true;
    }
    /**
     * Get the class name
     * @returns Class name
     */ getClassName() {
        return "MeshDebugPluginMaterial";
    }
    /**
     * Gets whether the mesh debug plugin is enabled in the material.
     */ get isEnabled() {
        return this._isEnabled;
    }
    /**
     * Sets whether the mesh debug plugin is enabled in the material.
     * @param value enabled
     */ set isEnabled(value) {
        if (this._isEnabled === value) return;
        if (!this._material.getScene().getEngine().isWebGPU && this._material.getScene().getEngine().webGLVersion == 1) {
            (0, $kVtWi.Logger).Error("MeshDebugPluginMaterial is not supported on WebGL 1.0.");
            this._isEnabled = false;
            return;
        }
        this._isEnabled = value;
        this._markAllDefinesAsDirty();
    }
    /**
     * Prepare the defines
     * @param defines Mesh debug defines
     * @param scene Scene
     * @param mesh Mesh associated with material
     */ prepareDefines(defines, scene, mesh) {
        if ((this._mode == $5954c6b758e67c53$export$b21a051b241c7232.VERTICES || this._mode == $5954c6b758e67c53$export$b21a051b241c7232.TRIANGLES || this._mode == $5954c6b758e67c53$export$b21a051b241c7232.TRIANGLES_VERTICES) && !mesh.isVerticesDataPresent("dbg_initialPass")) (0, $kVtWi.Logger).Warn("For best results with TRIANGLES, TRIANGLES_VERTICES, or VERTICES modes, please use MeshDebugPluginMaterial.PrepareMeshForTrianglesAndVerticesMode() on mesh.", 1);
        defines.DBG_MODE = this._mode;
        defines.DBG_MULTIPLY = this._multiply;
        defines.DBG_ENABLED = this._isEnabled;
    }
    /**
     * Get the shader attributes
     * @param attributes Array of attributes
     */ getAttributes(attributes) {
        attributes.push("dbg_initialPass");
    }
    /**
     * Get the shader uniforms
     * @returns Uniforms
     */ getUniforms() {
        return {
            ubo: [
                {
                    name: "dbg_shadedDiffuseColor",
                    size: 3,
                    type: "vec3"
                },
                {
                    name: "dbg_shadedSpecularColorPower",
                    size: 4,
                    type: "vec4"
                },
                {
                    name: "dbg_thicknessRadiusScale",
                    size: 3,
                    type: "vec3"
                },
                {
                    name: "dbg_wireframeTrianglesColor",
                    size: 3,
                    type: "vec3"
                },
                {
                    name: "dbg_wireframeVerticesColor",
                    size: 3,
                    type: "vec3"
                },
                {
                    name: "dbg_vertexColor",
                    size: 3,
                    type: "vec3"
                },
                {
                    name: "dbg_uvPrimaryColor",
                    size: 3,
                    type: "vec3"
                },
                {
                    name: "dbg_uvSecondaryColor",
                    size: 3,
                    type: "vec3"
                },
                {
                    name: "dbg_materialColor",
                    size: 3,
                    type: "vec3"
                }
            ],
            fragment: $5954c6b758e67c53$var$fragmentUniforms
        };
    }
    /**
     * Bind the uniform buffer
     * @param uniformBuffer Uniform buffer
     */ bindForSubMesh(uniformBuffer) {
        if (!this._isEnabled) return;
        uniformBuffer.updateFloat3("dbg_shadedDiffuseColor", this.shadedDiffuseColor.r, this.shadedDiffuseColor.g, this.shadedDiffuseColor.b);
        uniformBuffer.updateFloat4("dbg_shadedSpecularColorPower", this.shadedSpecularColor.r, this.shadedSpecularColor.g, this.shadedSpecularColor.b, this.shadedSpecularPower);
        uniformBuffer.updateFloat3("dbg_thicknessRadiusScale", this.wireframeThickness, this.vertexRadius, this.uvScale);
        uniformBuffer.updateColor3("dbg_wireframeTrianglesColor", this.wireframeTrianglesColor);
        uniformBuffer.updateColor3("dbg_wireframeVerticesColor", this.wireframeVerticesColor);
        uniformBuffer.updateColor3("dbg_vertexColor", this.vertexColor);
        uniformBuffer.updateColor3("dbg_uvPrimaryColor", this.uvPrimaryColor);
        uniformBuffer.updateColor3("dbg_uvSecondaryColor", this.uvSecondaryColor);
        uniformBuffer.updateColor3("dbg_materialColor", this._materialColor);
    }
    /**
     * Get shader code
     * @param shaderType "vertex" or "fragment"
     * @returns Shader code
     */ getCustomCode(shaderType) {
        return shaderType === "vertex" ? {
            CUSTOM_VERTEX_DEFINITIONS: $5954c6b758e67c53$var$vertexDefinitions,
            CUSTOM_VERTEX_MAIN_END: $5954c6b758e67c53$var$vertexMainEnd
        } : {
            CUSTOM_FRAGMENT_DEFINITIONS: $5954c6b758e67c53$var$fragmentDefinitions,
            CUSTOM_FRAGMENT_MAIN_END: $5954c6b758e67c53$var$fragmentMainEnd
        };
    }
    /**
     * Resets static variables of the plugin to their original state
     */ static Reset() {
        this._PluginCount = 0;
        this.MaterialColors = $5954c6b758e67c53$var$defaultMaterialColors;
    }
    /**
     * Renders triangles in a mesh 3 times by tripling the indices in the index buffer.
     * Used to prepare a mesh to be rendered in `TRIANGLES`, `VERTICES`, or `TRIANGLES_VERTICES` modes.
     * NOTE: This is a destructive operation. The mesh's index buffer and vertex buffers are modified, and a new vertex buffer is allocated.
     * If you'd like the ability to revert these changes, toggle the optional `returnRollback` flag.
     * @param mesh the mesh to target
     * @param returnRollback whether or not to return a function that reverts mesh to its initial state. Default: false.
     * @returns a rollback function if `returnRollback` is true, otherwise an empty function.
     */ static PrepareMeshForTrianglesAndVerticesMode(mesh, returnRollback = false) {
        let rollback = ()=>{};
        if (mesh.getTotalIndices() == 0) return rollback;
        if (returnRollback) {
            const kinds = mesh.getVerticesDataKinds();
            const indices = mesh.getIndices();
            const data = {};
            for (const kind of kinds)data[kind] = mesh.getVerticesData(kind);
            rollback = function() {
                mesh.setIndices(indices);
                for (const kind of kinds){
                    const stride = mesh.getVertexBuffer(kind).getStrideSize();
                    mesh.setVerticesData(kind, data[kind], undefined, stride);
                }
                mesh.removeVerticesData("dbg_initialPass");
            };
        }
        let indices = Array.from(mesh.getIndices());
        const newIndices1 = [];
        for(let i = 0; i < indices.length; i += 3)newIndices1.push(indices[i + 1], indices[i + 2], indices[i + 0]);
        mesh.setIndices(indices.concat(newIndices1));
        mesh.convertToUnIndexedMesh();
        mesh.isUnIndexed = false;
        indices = Array.from(mesh.getIndices());
        const newIndices2 = [];
        for(let i = indices.length / 2; i < indices.length; i += 3)newIndices2.push(indices[i + 1], indices[i + 2], indices[i + 0]);
        mesh.setIndices(indices.concat(newIndices2));
        const num = mesh.getTotalVertices();
        const mid = num / 2;
        const pass = new Array(num).fill(1, 0, mid).fill(0, mid, num);
        mesh.setVerticesData("dbg_initialPass", pass, false, 1);
        return rollback;
    }
}
/**
 * Total number of instances of the plugin.
 * Starts at 0.
 */ $5954c6b758e67c53$export$b81db3435f12d221._PluginCount = 0;
/**
 * Color palette used for MATERIALIDS mode.
 * Defaults to `defaultMaterialColors`
 */ $5954c6b758e67c53$export$b81db3435f12d221.MaterialColors = $5954c6b758e67c53$var$defaultMaterialColors;
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor3)()
], $5954c6b758e67c53$export$b81db3435f12d221.prototype, "_materialColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $5954c6b758e67c53$export$b81db3435f12d221.prototype, "_isEnabled", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllDefinesAsDirty")
], $5954c6b758e67c53$export$b81db3435f12d221.prototype, "mode", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllDefinesAsDirty")
], $5954c6b758e67c53$export$b81db3435f12d221.prototype, "multiply", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor3)()
], $5954c6b758e67c53$export$b81db3435f12d221.prototype, "shadedDiffuseColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor3)()
], $5954c6b758e67c53$export$b81db3435f12d221.prototype, "shadedSpecularColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $5954c6b758e67c53$export$b81db3435f12d221.prototype, "shadedSpecularPower", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $5954c6b758e67c53$export$b81db3435f12d221.prototype, "wireframeThickness", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor3)()
], $5954c6b758e67c53$export$b81db3435f12d221.prototype, "wireframeTrianglesColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor3)()
], $5954c6b758e67c53$export$b81db3435f12d221.prototype, "wireframeVerticesColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor3)()
], $5954c6b758e67c53$export$b81db3435f12d221.prototype, "vertexColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $5954c6b758e67c53$export$b81db3435f12d221.prototype, "vertexRadius", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $5954c6b758e67c53$export$b81db3435f12d221.prototype, "uvScale", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor3)()
], $5954c6b758e67c53$export$b81db3435f12d221.prototype, "uvPrimaryColor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsColor3)()
], $5954c6b758e67c53$export$b81db3435f12d221.prototype, "uvSecondaryColor", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.MeshDebugPluginMaterial", $5954c6b758e67c53$export$b81db3435f12d221);

});

parcelRegister("6wUCE", function(module, exports) {

$parcel$export(module.exports, "GaussianSplattingMaterial", () => $4c11a7433208af5b$export$e3b1c9f1e4e8ae89);

var $6Ho1L = parcelRequire("6Ho1L");

var $b4i1f = parcelRequire("b4i1f");

var $35xmP = parcelRequire("35xmP");

var $atHN2 = parcelRequire("atHN2");

var $8DoUR = parcelRequire("8DoUR");

var $aAFeM = parcelRequire("aAFeM");

var $74SKQ = parcelRequire("74SKQ");
parcelRequire("iZqOp");
parcelRequire("djfyP");

var $alPCh = parcelRequire("alPCh");
/**
 * @internal
 */ class $4c11a7433208af5b$var$GaussianSplattingMaterialDefines extends (0, $35xmP.MaterialDefines) {
    /**
     * Constructor of the defines.
     */ constructor(){
        super();
        this.FOG = false;
        this.THIN_INSTANCES = true;
        this.LOGARITHMICDEPTH = false;
        this.CLIPPLANE = false;
        this.CLIPPLANE2 = false;
        this.CLIPPLANE3 = false;
        this.CLIPPLANE4 = false;
        this.CLIPPLANE5 = false;
        this.CLIPPLANE6 = false;
        this.rebuild();
    }
}
class $4c11a7433208af5b$export$e3b1c9f1e4e8ae89 extends (0, $atHN2.PushMaterial) {
    /**
     * Instantiates a Gaussian Splatting Material in the given scene
     * @param name The friendly name of the material
     * @param scene The scene to add the material to
     */ constructor(name, scene){
        super(name, scene);
        this.backFaceCulling = false;
    }
    /**
     * Gets a boolean indicating that current material needs to register RTT
     */ get hasRenderTargetTextures() {
        return false;
    }
    /**
     * Specifies whether or not this material should be rendered in alpha test mode.
     * @returns false
     */ needAlphaTesting() {
        return false;
    }
    /**
     * Specifies whether or not this material should be rendered in alpha blend mode.
     * @returns true
     */ needAlphaBlending() {
        return true;
    }
    /**
     * Checks whether the material is ready to be rendered for a given mesh.
     * @param mesh The mesh to render
     * @param subMesh The submesh to check against
     * @returns true if all the dependencies are ready (Textures, Effects...)
     */ isReadyForSubMesh(mesh, subMesh) {
        const useInstances = true;
        const drawWrapper = subMesh._drawWrapper;
        if (drawWrapper.effect && this.isFrozen) {
            if (drawWrapper._wasPreviouslyReady && drawWrapper._wasPreviouslyUsingInstances === useInstances) return true;
        }
        if (!subMesh.materialDefines) subMesh.materialDefines = new $4c11a7433208af5b$var$GaussianSplattingMaterialDefines();
        const scene = this.getScene();
        const defines = subMesh.materialDefines;
        if (this._isReadyForSubMesh(subMesh)) return true;
        const engine = scene.getEngine();
        // Misc.
        (0, $alPCh.PrepareDefinesForMisc)(mesh, scene, this._useLogarithmicDepth, this.pointsCloud, this.fogEnabled, false, defines);
        // Values that need to be evaluated on every frame
        (0, $alPCh.PrepareDefinesForFrameBoundValues)(scene, engine, this, defines, useInstances, null, true);
        // Attribs
        (0, $alPCh.PrepareDefinesForAttributes)(mesh, defines, false, false);
        // Get correct effect
        if (defines.isDirty) {
            defines.markAsProcessed();
            scene.resetCachedMaterial();
            //Attributes
            const attribs = [
                (0, $b4i1f.VertexBuffer).PositionKind,
                "splatIndex"
            ];
            (0, $alPCh.PrepareAttributesForInstances)(attribs, defines);
            const uniforms = [
                "world",
                "view",
                "projection",
                "vFogInfos",
                "vFogColor",
                "logarithmicDepthConstant",
                "viewport",
                "dataTextureSize",
                "focal"
            ];
            const samplers = [
                "covariancesATexture",
                "covariancesBTexture",
                "centersTexture",
                "colorsTexture"
            ];
            const uniformBuffers = [
                "Scene",
                "Mesh"
            ];
            (0, $alPCh.PrepareUniformsAndSamplersList)({
                uniformsNames: uniforms,
                uniformBuffersNames: uniformBuffers,
                samplers: samplers,
                defines: defines
            });
            (0, $aAFeM.addClipPlaneUniforms)(uniforms);
            const join = defines.toString();
            const effect = scene.getEngine().createEffect("gaussianSplatting", {
                attributes: attribs,
                uniformsNames: uniforms,
                uniformBuffersNames: uniformBuffers,
                samplers: samplers,
                defines: join,
                onCompiled: this.onCompiled,
                onError: this.onError
            }, engine);
            subMesh.setEffect(effect, defines, this._materialContext);
        }
        if (!subMesh.effect || !subMesh.effect.isReady()) return false;
        defines._renderId = scene.getRenderId();
        drawWrapper._wasPreviouslyReady = true;
        drawWrapper._wasPreviouslyUsingInstances = useInstances;
        return true;
    }
    /**
     * Binds the submesh to this material by preparing the effect and shader to draw
     * @param world defines the world transformation matrix
     * @param mesh defines the mesh containing the submesh
     * @param subMesh defines the submesh to bind the material to
     */ bindForSubMesh(world, mesh, subMesh) {
        const scene = this.getScene();
        const defines = subMesh.materialDefines;
        if (!defines) return;
        const effect = subMesh.effect;
        if (!effect) return;
        this._activeEffect = effect;
        // Matrices Mesh.
        mesh.getMeshUniformBuffer().bindToEffect(effect, "Mesh");
        mesh.transferToEffect(world);
        // Bind data
        const mustRebind = this._mustRebind(scene, effect, subMesh, mesh.visibility);
        if (mustRebind) {
            this.bindView(effect);
            this.bindViewProjection(effect);
            const engine = scene.getEngine();
            const camera = this.getScene().activeCamera;
            const renderWidth = engine.getRenderWidth();
            const renderHeight = engine.getRenderHeight();
            this._activeEffect.setFloat2("viewport", renderWidth, renderHeight);
            let focal = 1000;
            if (camera) {
                if (camera.fovMode == (0, $74SKQ.Camera).FOVMODE_VERTICAL_FIXED) focal = renderHeight / 2.0 / Math.tan(camera.fov / 2.0);
                else focal = renderWidth / 2.0 / Math.tan(camera.fov / 2.0);
            }
            this._activeEffect.setFloat2("focal", focal, focal);
            const gsMesh = mesh;
            if (gsMesh.covariancesATexture) {
                const textureSize = gsMesh.covariancesATexture.getSize();
                effect.setFloat2("dataTextureSize", textureSize.width, textureSize.height);
                effect.setTexture("covariancesATexture", gsMesh.covariancesATexture);
                effect.setTexture("covariancesBTexture", gsMesh.covariancesBTexture);
                effect.setTexture("centersTexture", gsMesh.centersTexture);
                effect.setTexture("colorsTexture", gsMesh.colorsTexture);
            }
            // Clip plane
            (0, $aAFeM.bindClipPlane)(effect, this, scene);
        } else if (scene.getEngine()._features.needToAlwaysBindUniformBuffers) this._needToBindSceneUbo = true;
        // Fog
        (0, $alPCh.BindFogParameters)(scene, mesh, effect);
        // Log. depth
        if (this.useLogarithmicDepth) (0, $alPCh.BindLogDepth)(defines, effect, scene);
        this._afterBind(mesh, this._activeEffect, subMesh);
    }
    /**
     * Clones the material.
     * @param name The cloned name.
     * @returns The cloned material.
     */ clone(name) {
        return (0, $6Ho1L.SerializationHelper).Clone(()=>new $4c11a7433208af5b$export$e3b1c9f1e4e8ae89(name, this.getScene()), this);
    }
    /**
     * Serializes the current material to its JSON representation.
     * @returns The JSON representation.
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.customType = "BABYLON.GaussianSplattingMaterial";
        return serializationObject;
    }
    /**
     * Gets the class name of the material
     * @returns "GaussianSplattingMaterial"
     */ getClassName() {
        return "GaussianSplattingMaterial";
    }
    /**
     * Parse a JSON input to create back a Gaussian Splatting material.
     * @param source The JSON data to parse
     * @param scene The scene to create the parsed material in
     * @param rootUrl The root url of the assets the material depends upon
     * @returns the instantiated GaussianSplattingMaterial.
     */ static Parse(source, scene, rootUrl) {
        return (0, $6Ho1L.SerializationHelper).Parse(()=>new $4c11a7433208af5b$export$e3b1c9f1e4e8ae89(source.name, scene), source, scene, rootUrl);
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.GaussianSplattingMaterial", $4c11a7433208af5b$export$e3b1c9f1e4e8ae89);

});
parcelRegister("iZqOp", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("82O8L");
parcelRequire("4kipo");
parcelRequire("hvLF9");
parcelRequire("kg1CD");
parcelRequire("izyqw");
parcelRequire("110hr");
const $dd32b8d17599ae93$var$name = "gaussianSplattingPixelShader";
const $dd32b8d17599ae93$var$shader = `#include<clipPlaneFragmentDeclaration>
#include<logDepthDeclaration>
#include<fogFragmentDeclaration>
varying vec4 vColor;varying vec2 vPosition;void main () { 
#include<clipPlaneFragment>
float A=-dot(vPosition,vPosition);if (A<-4.0) discard;float B=exp(A)*vColor.a;
#include<logDepthFragment>
vec3 color=vColor.rgb;
#ifdef FOG
#include<fogFragment>
#endif
gl_FragColor=vec4(color,B);}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$dd32b8d17599ae93$var$name] = $dd32b8d17599ae93$var$shader;
const $dd32b8d17599ae93$export$5e40c894da955ae1 = {
    name: $dd32b8d17599ae93$var$name,
    shader: $dd32b8d17599ae93$var$shader
};

});

parcelRegister("djfyP", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("eWuAV");
parcelRequire("iU0Ua");
parcelRequire("4A4MM");
parcelRequire("bdABV");
parcelRequire("4kipo");
parcelRequire("kqCfW");
parcelRequire("1pV7g");
parcelRequire("a111f");
const $9b091ec103896cd4$var$name = "gaussianSplattingVertexShader";
const $9b091ec103896cd4$var$shader = `#include<__decl__gaussianSplattingVertex>
#ifdef LOGARITHMICDEPTH
#extension GL_EXT_frag_depth : enable
#endif
#include<clipPlaneVertexDeclaration>
#include<fogVertexDeclaration>
#include<logDepthDeclaration>
attribute vec2 position;attribute float splatIndex;uniform vec2 viewport;uniform vec2 dataTextureSize;uniform vec2 focal;uniform sampler2D covariancesATexture;uniform sampler2D covariancesBTexture;uniform sampler2D centersTexture;uniform sampler2D colorsTexture;varying vec4 vColor;varying vec2 vPosition;
#if !defined(WEBGL2) && !defined(WEBGPU) && !defined(NATIVE)
mat3 transpose(mat3 matrix) {return mat3(matrix[0][0],matrix[1][0],matrix[2][0],
matrix[0][1],matrix[1][1],matrix[2][1],
matrix[0][2],matrix[1][2],matrix[2][2]);}
#endif
vec2 getDataUV(float index,vec2 textureSize) {float y=floor(index/textureSize.x);float x=index-y*textureSize.x;return vec2((x+0.5)/textureSize.x,(y+0.5)/textureSize.y);}
void main () {vec2 splatUV=getDataUV(splatIndex,dataTextureSize);vec3 center=texture2D(centersTexture,splatUV).xyz;vec4 color=texture2D(colorsTexture,splatUV);vec3 covA=texture2D(covariancesATexture,splatUV).xyz;vec3 covB=texture2D(covariancesBTexture,splatUV).xyz;vec4 worldPos=world*vec4(center,1.0);mat4 modelView=view*world;vec4 camspace=view*worldPos;vec4 pos2d=projection*camspace;float bounds=1.2*pos2d.w;if (pos2d.z<-pos2d.w || pos2d.x<-bounds || pos2d.x>bounds
|| pos2d.y<-bounds || pos2d.y>bounds) {gl_Position=vec4(0.0,0.0,2.0,1.0);return;}
mat3 Vrk=mat3(
covA.x,covA.y,covA.z,
covA.y,covB.x,covB.y,
covA.z,covB.y,covB.z
);mat3 J=mat3(
focal.x/camspace.z,0.,-(focal.x*camspace.x)/(camspace.z*camspace.z),
0.,focal.y/camspace.z,-(focal.y*camspace.y)/(camspace.z*camspace.z),
0.,0.,0.
);mat3 invy=mat3(1,0,0,0,-1,0,0,0,1);mat3 T=invy*transpose(mat3(modelView))*J;mat3 cov2d=transpose(T)*Vrk*T;float mid=(cov2d[0][0]+cov2d[1][1])/2.0;float radius=length(vec2((cov2d[0][0]-cov2d[1][1])/2.0,cov2d[0][1]));float lambda1=mid+radius,lambda2=mid-radius;if (lambda2<0.0) return;vec2 diagonalVector=normalize(vec2(cov2d[0][1],lambda1-cov2d[0][0]));vec2 majorAxis=min(sqrt(2.0*lambda1),1024.0)*diagonalVector;vec2 minorAxis=min(sqrt(2.0*lambda2),1024.0)*vec2(diagonalVector.y,-diagonalVector.x);vColor=color;vPosition=position;vec2 vCenter=vec2(pos2d);gl_Position=vec4(
vCenter 
+ (position.x*majorAxis*1./viewport 
+ position.y*minorAxis*1./viewport)*pos2d.w,pos2d.zw);
#include<clipPlaneVertex>
#include<fogVertex>
#include<logDepthVertex>
}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$9b091ec103896cd4$var$name] = $9b091ec103896cd4$var$shader;
const $9b091ec103896cd4$export$13ef75347ac9870c = {
    name: $9b091ec103896cd4$var$name,
    shader: $9b091ec103896cd4$var$shader
};

});
parcelRegister("eWuAV", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $ae0e36edfab52174$var$name = "gaussianSplattingVertexDeclaration";
const $ae0e36edfab52174$var$shader = `uniform mat4 world;uniform mat4 view;uniform mat4 projection;
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$ae0e36edfab52174$var$name] = $ae0e36edfab52174$var$shader;
const $ae0e36edfab52174$export$b9aba75f93a1d918 = {
    name: $ae0e36edfab52174$var$name,
    shader: $ae0e36edfab52174$var$shader
};

});

parcelRegister("iU0Ua", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("eZlZI");
parcelRequire("4u6lu");
const $dc2e28a9ecdf58f2$var$name = "gaussianSplattingUboDeclaration";
const $dc2e28a9ecdf58f2$var$shader = `#include<sceneUboDeclaration>
#include<meshUboDeclaration>
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$dc2e28a9ecdf58f2$var$name] = $dc2e28a9ecdf58f2$var$shader;
const $dc2e28a9ecdf58f2$export$638e9aeff8f0c80f = {
    name: $dc2e28a9ecdf58f2$var$name,
    shader: $dc2e28a9ecdf58f2$var$shader
};

});



parcelRegister("1OwjH", function(module, exports) {
parcelRequire("ddKol");
parcelRequire("EOyGg");
parcelRequire("1fNre");

});
parcelRegister("ddKol", function(module, exports) {

var $96fF1 = parcelRequire("96fF1");

var $gAH3H = parcelRequire("gAH3H");
Object.defineProperty((0, $gAH3H.StandardMaterial).prototype, "decalMap", {
    get: function() {
        if (!this._decalMap) {
            if (this._uniformBufferLayoutBuilt) // Material already used to display a mesh, so it's invalid to add the decal map plugin at that point
            // Returns null instead of having new DecalMapConfiguration throws an exception
            return null;
            this._decalMap = new (0, $96fF1.DecalMapConfiguration)(this);
        }
        return this._decalMap;
    },
    enumerable: true,
    configurable: true
});

});

parcelRegister("EOyGg", function(module, exports) {

var $96fF1 = parcelRequire("96fF1");

var $4G6Xh = parcelRequire("4G6Xh");
Object.defineProperty((0, $4G6Xh.PBRBaseMaterial).prototype, "decalMap", {
    get: function() {
        if (!this._decalMap) {
            if (this._uniformBufferLayoutBuilt) // Material already used to display a mesh, so it's invalid to add the decal map plugin at that point
            // Returns null instead of having new DecalMapConfiguration throws an exception
            return null;
            this._decalMap = new (0, $96fF1.DecalMapConfiguration)(this);
        }
        return this._decalMap;
    },
    enumerable: true,
    configurable: true
});

});

parcelRegister("1fNre", function(module, exports) {

var $0cHNL = parcelRequire("0cHNL");
Object.defineProperty((0, $0cHNL.AbstractMesh).prototype, "decalMap", {
    get: function() {
        return this._decalMap;
    },
    set: function(decalMap) {
        this._decalMap = decalMap;
    },
    enumerable: true,
    configurable: true
});

});



parcelRegister("4aDh4", function(module, exports) {

var $1VEEL = parcelRequire("1VEEL");

var $1NJAz = parcelRequire("1NJAz");

var $hcvsL = parcelRequire("hcvsL");

var $6rxfP = parcelRequire("6rxfP");

var $f3g09 = parcelRequire("f3g09");

var $5V90k = parcelRequire("5V90k");

var $g59iN = parcelRequire("g59iN");
$parcel$exportWildcard(module.exports, $1VEEL);
$parcel$exportWildcard(module.exports, $1NJAz);
$parcel$exportWildcard(module.exports, $hcvsL);
$parcel$exportWildcard(module.exports, $6rxfP);
$parcel$exportWildcard(module.exports, $f3g09);
$parcel$exportWildcard(module.exports, $5V90k);
$parcel$exportWildcard(module.exports, $g59iN);

});
parcelRegister("hcvsL", function(module, exports) {

$parcel$export(module.exports, "Polar", () => $c85bf68a1a09f281$export$60611d9d78163dfd);
$parcel$export(module.exports, "Spherical", () => $c85bf68a1a09f281$export$d712cd887b4a00f7);

var $ha1VO = parcelRequire("ha1VO");
class $c85bf68a1a09f281$export$60611d9d78163dfd {
    /**
     * Creates a new Polar object
     * @param radius the radius of the vector
     * @param theta the angle of the vector
     */ constructor(radius, theta){
        this.radius = radius;
        this.theta = theta;
        this.radius = radius;
        this.theta = theta;
    }
    /**
     * Gets the class name
     * @returns the string "Polar"
     */ getClassName() {
        return "Polar";
    }
    /**
     * Converts the current polar to a string
     * @returns the current polar as a string
     */ toString() {
        return JSON.stringify(this);
    }
    /**
     * Converts the current polar to an array
     * @returns the current polar as an array
     */ asArray() {
        return [
            this.radius,
            this.theta
        ];
    }
    /**
     * Adds the current Polar and the given Polar and stores the result
     * @param polar the polar to add
     * @param ref the polar to store the result in
     * @returns the updated ref
     */ addToRef(polar, ref) {
        ref.radius = this.radius + polar.radius;
        ref.theta = this.theta + polar.theta;
        return ref;
    }
    /**
     * Adds the current Polar and the given Polar
     * @param polar the polar to add
     * @returns the sum polar
     */ add(polar) {
        const ref = new $c85bf68a1a09f281$export$60611d9d78163dfd(0, 0);
        this.addToRef(polar, ref);
        return ref;
    }
    /**
     * Adds the given polar to the current polar
     * @param polar the polar to add
     * @returns the current polar
     */ addInPlace(polar) {
        this.addToRef(polar, this);
        return this;
    }
    /**
     * Adds the provided values to the current polar
     * @param radius the amount to add to the radius
     * @param theta the amount to add to the theta
     * @returns the current polar
     */ addInPlaceFromFloats(radius, theta) {
        this.radius += radius;
        this.theta += theta;
        return this;
    }
    /**
     * Subtracts the given Polar from the current Polar and stores the result
     * @param polar the polar to subtract
     * @param ref the polar to store the result in
     * @returns the updated ref
     */ subtractToRef(polar, ref) {
        ref.radius = this.radius - polar.radius;
        ref.theta = this.theta - polar.theta;
        return ref;
    }
    /**
     * Subtracts the given Polar from the current Polar
     * @param polar the polar to subtract
     * @returns the difference polar
     */ subtract(polar) {
        const ref = new $c85bf68a1a09f281$export$60611d9d78163dfd(0, 0);
        this.subtractToRef(polar, ref);
        return ref;
    }
    /**
     * Subtracts the given Polar from the current Polar
     * @param polar the polar to subtract
     * @returns the current polar
     */ subtractInPlace(polar) {
        this.subtractToRef(polar, this);
        return this;
    }
    /**
     * Subtracts the given floats from the current polar
     * @param radius the amount to subtract from the radius
     * @param theta the amount to subtract from the theta
     * @param ref the polar to store the result in
     * @returns the updated ref
     */ subtractFromFloatsToRef(radius, theta, ref) {
        ref.radius = this.radius - radius;
        ref.theta = this.theta - theta;
        return ref;
    }
    /**
     * Subtracts the given floats from the current polar
     * @param radius the amount to subtract from the radius
     * @param theta the amount to subtract from the theta
     * @returns the difference polar
     */ subtractFromFloats(radius, theta) {
        const ref = new $c85bf68a1a09f281$export$60611d9d78163dfd(0, 0);
        this.subtractFromFloatsToRef(radius, theta, ref);
        return ref;
    }
    /**
     * Multiplies the given Polar with the current Polar and stores the result
     * @param polar the polar to multiply
     * @param ref the polar to store the result in
     * @returns the updated ref
     */ multiplyToRef(polar, ref) {
        ref.radius = this.radius * polar.radius;
        ref.theta = this.theta * polar.theta;
        return ref;
    }
    /**
     * Multiplies the given Polar with the current Polar
     * @param polar the polar to multiply
     * @returns the product polar
     */ multiply(polar) {
        const ref = new $c85bf68a1a09f281$export$60611d9d78163dfd(0, 0);
        this.multiplyToRef(polar, ref);
        return ref;
    }
    /**
     * Multiplies the given Polar with the current Polar
     * @param polar the polar to multiply
     * @returns the current polar
     */ multiplyInPlace(polar) {
        this.multiplyToRef(polar, this);
        return this;
    }
    /**
     * Divides the current Polar by the given Polar and stores the result
     * @param polar the polar to divide
     * @param ref the polar to store the result in
     * @returns the updated ref
     */ divideToRef(polar, ref) {
        ref.radius = this.radius / polar.radius;
        ref.theta = this.theta / polar.theta;
        return ref;
    }
    /**
     * Divides the current Polar by the given Polar
     * @param polar the polar to divide
     * @returns the quotient polar
     */ divide(polar) {
        const ref = new $c85bf68a1a09f281$export$60611d9d78163dfd(0, 0);
        this.divideToRef(polar, ref);
        return ref;
    }
    /**
     * Divides the current Polar by the given Polar
     * @param polar the polar to divide
     * @returns the current polar
     */ divideInPlace(polar) {
        this.divideToRef(polar, this);
        return this;
    }
    /**
     * Clones the current polar
     * @returns a clone of the current polar
     */ clone() {
        return new $c85bf68a1a09f281$export$60611d9d78163dfd(this.radius, this.theta);
    }
    /**
     * Copies the source polar into the current polar
     * @param source the polar to copy from
     * @returns the current polar
     */ copyFrom(source) {
        this.radius = source.radius;
        this.theta = source.theta;
        return this;
    }
    /**
     * Copies the given values into the current polar
     * @param radius the radius to use
     * @param theta the theta to use
     * @returns the current polar
     */ copyFromFloats(radius, theta) {
        this.radius = radius;
        this.theta = theta;
        return this;
    }
    /**
     * Scales the current polar and stores the result
     * @param scale defines the multiplication factor
     * @param ref where to store the result
     * @returns the updated ref
     */ scaleToRef(scale, ref) {
        ref.radius = this.radius * scale;
        ref.theta = this.theta * scale;
        return ref;
    }
    /**
     * Scales the current polar and returns a new polar with the scaled coordinates
     * @param scale defines the multiplication factor
     * @returns the scaled polar
     */ scale(scale) {
        const ref = new $c85bf68a1a09f281$export$60611d9d78163dfd(0, 0);
        this.scaleToRef(scale, ref);
        return ref;
    }
    /**
     * Scales the current polar
     * @param scale defines the multiplication factor
     * @returns the current polar
     */ scaleInPlace(scale) {
        this.scaleToRef(scale, this);
        return this;
    }
    /**
     * Sets the values of the current polar
     * @param radius the new radius
     * @param theta the new theta
     * @returns the current polar
     */ set(radius, theta) {
        this.radius = radius;
        this.theta = theta;
        return this;
    }
    /**
     * Sets the values of the current polar
     * @param value the new values
     * @returns the current polar
     */ setAll(value) {
        this.set(value, value);
        return this;
    }
    /**
     * Gets the rectangular coordinates of the current Polar
     * @param ref the reference to assign the result
     * @returns the updated reference
     */ toVector2ToRef(ref) {
        const x = this.radius * Math.cos(this.theta);
        const y = this.radius * Math.sin(this.theta);
        ref.set(x, y);
        return ref;
    }
    /**
     * Gets the rectangular coordinates of the current Polar
     * @returns the rectangular coordinates
     */ toVector2() {
        const ref = new (0, $ha1VO.Vector2)(0, 0);
        return this.toVector2ToRef(ref);
    }
    /**
     * Converts a given Vector2 to its polar coordinates
     * @param v the Vector2 to convert
     * @param ref the reference to assign the result
     * @returns the updated reference
     */ static FromVector2ToRef(v, ref) {
        const theta = Math.sign(v.y) * Math.acos(v.x / v.length());
        ref.radius = v.length();
        ref.theta = theta;
        return ref;
    }
    /**
     * Converts a given Vector2 to its polar coordinates
     * @param v the Vector2 to convert
     * @returns a Polar
     */ static FromVector2(v) {
        const polar = new $c85bf68a1a09f281$export$60611d9d78163dfd(0, 0);
        $c85bf68a1a09f281$export$60611d9d78163dfd.FromVector2ToRef(v, polar);
        return polar;
    }
    /**
     * Converts an array of floats to a polar
     * @param array the array to convert
     * @returns the converted polar
     */ static FromArray(array) {
        return new $c85bf68a1a09f281$export$60611d9d78163dfd(array[0], array[1]);
    }
}
class $c85bf68a1a09f281$export$d712cd887b4a00f7 {
    /**
     * Creates a new Spherical object from the given spherical coordinates
     * @param radius spherical radius
     * @param theta angle from positive y axis to radial line from 0 to PI (vertical)
     * @param phi angle from positive x axis measured anticlockwise from -PI to PI (horizontal)
     */ constructor(radius, theta, phi){
        this.radius = radius;
        this.theta = theta;
        this.phi = phi;
        this.radius = radius;
        this.theta = theta;
        this.phi = phi;
    }
    /**
     * Gets the class name
     * @returns the string "Spherical"
     */ getClassName() {
        return "Spherical";
    }
    /**
     * Converts the current spherical to a string
     * @returns the current spherical as a string
     */ toString() {
        return JSON.stringify(this);
    }
    /**
     * Converts the current spherical to an array
     * @returns the current spherical as an array
     */ asArray() {
        return [
            this.radius,
            this.theta,
            this.phi
        ];
    }
    /**
     * Adds the current Spherical and the given Spherical and stores the result
     * @param spherical the spherical to add
     * @param ref the spherical to store the result in
     * @returns the updated ref
     */ addToRef(spherical, ref) {
        ref.radius = this.radius + spherical.radius;
        ref.theta = this.theta + spherical.theta;
        ref.phi = this.phi + spherical.phi;
        return ref;
    }
    /**
     * Adds the current Spherical and the given Spherical
     * @param spherical the spherical to add
     * @returns the sum spherical
     */ add(spherical) {
        const ref = new $c85bf68a1a09f281$export$d712cd887b4a00f7(0, 0, 0);
        this.addToRef(spherical, ref);
        return ref;
    }
    /**
     * Adds the given spherical to the current spherical
     * @param spherical the spherical to add
     * @returns the current spherical
     */ addInPlace(spherical) {
        this.addToRef(spherical, this);
        return this;
    }
    /**
     * Adds the provided values to the current spherical
     * @param radius the amount to add to the radius
     * @param theta the amount to add to the theta
     * @param phi the amount to add to the phi
     * @returns the current spherical
     */ addInPlaceFromFloats(radius, theta, phi) {
        this.radius += radius;
        this.theta += theta;
        this.phi += phi;
        return this;
    }
    /**
     * Subtracts the given Spherical from the current Spherical and stores the result
     * @param spherical the spherical to subtract
     * @param ref the spherical to store the result in
     * @returns the updated ref
     */ subtractToRef(spherical, ref) {
        ref.radius = this.radius - spherical.radius;
        ref.theta = this.theta - spherical.theta;
        ref.phi = this.phi - spherical.phi;
        return ref;
    }
    /**
     * Subtracts the given Spherical from the current Spherical
     * @param spherical the spherical to subtract
     * @returns the difference spherical
     */ subtract(spherical) {
        const ref = new $c85bf68a1a09f281$export$d712cd887b4a00f7(0, 0, 0);
        this.subtractToRef(spherical, ref);
        return ref;
    }
    /**
     * Subtracts the given Spherical from the current Spherical
     * @param spherical the spherical to subtract
     * @returns the current spherical
     */ subtractInPlace(spherical) {
        this.subtractToRef(spherical, this);
        return this;
    }
    /**
     * Subtracts the given floats from the current spherical
     * @param radius the amount to subtract from the radius
     * @param theta the amount to subtract from the theta
     * @param phi the amount to subtract from the phi
     * @param ref the spherical to store the result in
     * @returns the updated ref
     */ subtractFromFloatsToRef(radius, theta, phi, ref) {
        ref.radius = this.radius - radius;
        ref.theta = this.theta - theta;
        ref.phi = this.phi - phi;
        return ref;
    }
    /**
     * Subtracts the given floats from the current spherical
     * @param radius the amount to subtract from the radius
     * @param theta the amount to subtract from the theta
     * @param phi the amount to subtract from the phi
     * @returns the difference spherical
     */ subtractFromFloats(radius, theta, phi) {
        const ref = new $c85bf68a1a09f281$export$d712cd887b4a00f7(0, 0, 0);
        this.subtractFromFloatsToRef(radius, theta, phi, ref);
        return ref;
    }
    /**
     * Multiplies the given Spherical with the current Spherical and stores the result
     * @param spherical the spherical to multiply
     * @param ref the spherical to store the result in
     * @returns the updated ref
     */ multiplyToRef(spherical, ref) {
        ref.radius = this.radius * spherical.radius;
        ref.theta = this.theta * spherical.theta;
        ref.phi = this.phi * spherical.phi;
        return ref;
    }
    /**
     * Multiplies the given Spherical with the current Spherical
     * @param spherical the spherical to multiply
     * @returns the product spherical
     */ multiply(spherical) {
        const ref = new $c85bf68a1a09f281$export$d712cd887b4a00f7(0, 0, 0);
        this.multiplyToRef(spherical, ref);
        return ref;
    }
    /**
     * Multiplies the given Spherical with the current Spherical
     * @param spherical the spherical to multiply
     * @returns the current spherical
     */ multiplyInPlace(spherical) {
        this.multiplyToRef(spherical, this);
        return this;
    }
    /**
     * Divides the current Spherical by the given Spherical and stores the result
     * @param spherical the spherical to divide
     * @param ref the spherical to store the result in
     * @returns the updated ref
     */ divideToRef(spherical, ref) {
        ref.radius = this.radius / spherical.radius;
        ref.theta = this.theta / spherical.theta;
        ref.phi = this.phi / spherical.phi;
        return ref;
    }
    /**
     * Divides the current Spherical by the given Spherical
     * @param spherical the spherical to divide
     * @returns the quotient spherical
     */ divide(spherical) {
        const ref = new $c85bf68a1a09f281$export$d712cd887b4a00f7(0, 0, 0);
        this.divideToRef(spherical, ref);
        return ref;
    }
    /**
     * Divides the current Spherical by the given Spherical
     * @param spherical the spherical to divide
     * @returns the current spherical
     */ divideInPlace(spherical) {
        this.divideToRef(spherical, this);
        return this;
    }
    /**
     * Clones the current spherical
     * @returns a clone of the current spherical
     */ clone() {
        return new $c85bf68a1a09f281$export$d712cd887b4a00f7(this.radius, this.theta, this.phi);
    }
    /**
     * Copies the source spherical into the current spherical
     * @param source the spherical to copy from
     * @returns the current spherical
     */ copyFrom(source) {
        this.radius = source.radius;
        this.theta = source.theta;
        this.phi = source.phi;
        return this;
    }
    /**
     * Copies the given values into the current spherical
     * @param radius the radius to use
     * @param theta the theta to use
     * @param phi the phi to use
     * @returns the current spherical
     */ copyFromFloats(radius, theta, phi) {
        this.radius = radius;
        this.theta = theta;
        this.phi = phi;
        return this;
    }
    /**
     * Scales the current spherical and stores the result
     * @param scale defines the multiplication factor
     * @param ref where to store the result
     * @returns the updated ref
     */ scaleToRef(scale, ref) {
        ref.radius = this.radius * scale;
        ref.theta = this.theta * scale;
        ref.phi = this.phi * scale;
        return ref;
    }
    /**
     * Scales the current spherical and returns a new spherical with the scaled coordinates
     * @param scale defines the multiplication factor
     * @returns the scaled spherical
     */ scale(scale) {
        const ref = new $c85bf68a1a09f281$export$d712cd887b4a00f7(0, 0, 0);
        this.scaleToRef(scale, ref);
        return ref;
    }
    /**
     * Scales the current spherical
     * @param scale defines the multiplication factor
     * @returns the current spherical
     */ scaleInPlace(scale) {
        this.scaleToRef(scale, this);
        return this;
    }
    /**
     * Sets the values of the current spherical
     * @param radius the new radius
     * @param theta the new theta
     * @param phi the new phi
     * @returns the current spherical
     */ set(radius, theta, phi) {
        this.radius = radius;
        this.theta = theta;
        this.phi = phi;
        return this;
    }
    /**
     * Sets the values of the current spherical
     * @param value the new values
     * @returns the current spherical
     */ setAll(value) {
        this.set(value, value, value);
        return this;
    }
    /**
     * Assigns the rectangular coordinates of the current Spherical to a Vector3
     * @param ref the Vector3 to update
     * @returns the updated Vector3
     */ toVector3ToRef(ref) {
        const x = this.radius * Math.sin(this.theta) * Math.cos(this.phi);
        const y = this.radius * Math.cos(this.theta);
        const z = this.radius * Math.sin(this.theta) * Math.sin(this.phi);
        ref.set(x, y, z);
        return ref;
    }
    /**
     * Gets a Vector3 from the current spherical coordinates
     * @returns the (x, y,z) form of the current Spherical
     */ toVector3() {
        const ref = new (0, $ha1VO.Vector3)(0, 0, 0);
        return this.toVector3ToRef(ref);
    }
    /**
     * Assigns the spherical coordinates from a Vector3
     * @param vector the vector to convert
     * @param ref the Spherical to update
     * @returns the updated ref
     */ static FromVector3ToRef(vector, ref) {
        ref.radius = vector.length();
        ref.theta = Math.acos(vector.y / ref.radius);
        ref.phi = Math.atan2(vector.z, vector.x);
        return ref;
    }
    /**
     * Gets a Spherical from a Vector3
     * @param vector defines the vector in (x, y, z) coordinate space
     * @returns a new Spherical
     */ static FromVector3(vector) {
        const spherical = new $c85bf68a1a09f281$export$d712cd887b4a00f7(0, 0, 0);
        $c85bf68a1a09f281$export$d712cd887b4a00f7.FromVector3ToRef(vector, spherical);
        return spherical;
    }
    /**
     * Converts an array of floats to a spherical
     * @param array the array to convert
     * @returns the converted spherical
     */ static FromArray(array) {
        return new $c85bf68a1a09f281$export$d712cd887b4a00f7(array[0], array[1], array[2]);
    }
}

});

parcelRegister("5V90k", function(module, exports) {

$parcel$export(module.exports, "Halton2DSequence", () => $44f942af65d3c29c$export$a233dbe4c98469a);
/**
 * Class for generating 2D Halton sequences.
 * From https://observablehq.com/@jrus/halton
 */ class $44f942af65d3c29c$export$a233dbe4c98469a {
    /**
     * Creates a new Halton2DSequence.
     * @param numSamples Number of samples in the sequence.
     * @param baseX The base for the x coordinate (default: 2).
     * @param baseY The base for the y coordinate (default: 3).
     * @param width Factor to scale the x coordinate by (default: 1). The scaling factor is 1/width.
     * @param height Factor to scale the y coordinate by (default: 1). The scaling factor is 1/height.
     */ constructor(numSamples, baseX = 2, baseY = 3, width = 1, height = 1){
        this._curIndex = 0;
        this._sequence = [];
        this._numSamples = 0;
        /**
         * The x coordinate of the current sample.
         */ this.x = 0;
        /**
         * The y coordinate of the current sample.
         */ this.y = 0;
        this._width = width;
        this._height = height;
        this._baseX = baseX;
        this._baseY = baseY;
        this._generateSequence(numSamples);
        this.next();
    }
    /**
     * Regenerates the sequence with a new number of samples.
     * @param numSamples Number of samples in the sequence.
     */ regenerate(numSamples) {
        this._generateSequence(numSamples);
        this.next();
    }
    /**
     * Sets the dimensions of the sequence.
     * @param width Factor to scale the x coordinate by. The scaling factor is 1/width.
     * @param height Factor to scale the y coordinate by. The scaling factor is 1/height.
     */ setDimensions(width, height) {
        this._width = width;
        this._height = height;
    }
    /**
     * Advances to the next sample in the sequence.
     */ next() {
        this.x = this._sequence[this._curIndex] / this._width;
        this.y = this._sequence[this._curIndex + 1] / this._height;
        this._curIndex += 2;
        if (this._curIndex >= this._numSamples * 2) this._curIndex = 0;
    }
    _generateSequence(numSamples) {
        this._sequence = [];
        this._curIndex = 0;
        this._numSamples = numSamples;
        for(let i = 1; i <= numSamples; ++i)this._sequence.push(this._halton(i, this._baseX) - 0.5, this._halton(i, this._baseY) - 0.5);
    }
    _halton(index, base) {
        let fraction = 1;
        let result = 0;
        while(index > 0){
            fraction /= base;
            result += fraction * (index % base);
            index = ~~(index / base); // floor division
        }
        return result;
    }
}

});

parcelRegister("g59iN", function(module, exports) {

$parcel$export(module.exports, "Vector2ToFixed", () => $bb54542c9a876d3c$export$f8e2e8187f9f3299);
$parcel$export(module.exports, "Vector3ToFixed", () => $bb54542c9a876d3c$export$4dbd25c9c902c3dd);
$parcel$export(module.exports, "Vector4ToFixed", () => $bb54542c9a876d3c$export$429eeb6a2f9284f);
/**
 * Creates a string representation of the Vector2
 * @param vector defines the Vector2 to stringify
 * @param decimalCount defines the number of decimals to use
 * @returns a string with the Vector2 coordinates.
 */ function $bb54542c9a876d3c$export$f8e2e8187f9f3299(vector, decimalCount) {
    return `{X: ${vector.x.toFixed(decimalCount)} Y: ${vector.y.toFixed(decimalCount)}}`;
}
function $bb54542c9a876d3c$export$4dbd25c9c902c3dd(vector, decimalCount) {
    return `{X: ${vector._x.toFixed(decimalCount)} Y: ${vector._y.toFixed(decimalCount)} Z: ${vector._z.toFixed(decimalCount)}}`;
}
function $bb54542c9a876d3c$export$429eeb6a2f9284f(vector, decimalCount) {
    return `{X: ${vector.x.toFixed(decimalCount)} Y: ${vector.y.toFixed(decimalCount)} Z: ${vector.z.toFixed(decimalCount)} W: ${vector.w.toFixed(decimalCount)}}`;
}

});


parcelRegister("9ZIGQ", function(module, exports) {
/* eslint-disable import/export */ /* eslint-disable import/no-internal-modules */ 
var $0cHNL = parcelRequire("0cHNL");
parcelRequire("1fNre");

var $ihfnn = parcelRequire("ihfnn");

var $eg7RM = parcelRequire("eg7RM");

var $c2cCF = parcelRequire("c2cCF");

var $FUHfe = parcelRequire("FUHfe");

var $1cCRP = parcelRequire("1cCRP");

var $c0aRk = parcelRequire("c0aRk");

var $8nuZn = parcelRequire("8nuZn");

var $9Xybp = parcelRequire("9Xybp");

var $abjAz = parcelRequire("abjAz");

var $fbuqw = parcelRequire("fbuqw");

var $5v6ry = parcelRequire("5v6ry");

var $dls1y = parcelRequire("dls1y");

var $fl174 = parcelRequire("fl174");

var $c6UQl = parcelRequire("c6UQl");

var $a4MLb = parcelRequire("a4MLb");

var $ip6UH = parcelRequire("ip6UH");

var $lEBSs = parcelRequire("lEBSs");

var $4A7HA = parcelRequire("4A7HA");

var $8WG4F = parcelRequire("8WG4F");

var $klshO = parcelRequire("klshO");

var $6PQ5r = parcelRequire("6PQ5r");

var $koExS = parcelRequire("koExS");

var $iRIOb = parcelRequire("iRIOb");

var $DduJm = parcelRequire("DduJm");

var $iGY4d = parcelRequire("iGY4d");

var $il6pG = parcelRequire("il6pG");

var $5DCzZ = parcelRequire("5DCzZ");

var $eofEg = parcelRequire("eofEg");

var $hvUJP = parcelRequire("hvUJP");
$parcel$exportWildcard(module.exports, $0cHNL);
$parcel$exportWildcard(module.exports, $ihfnn);
$parcel$exportWildcard(module.exports, $eg7RM);
$parcel$exportWildcard(module.exports, $c2cCF);
$parcel$exportWildcard(module.exports, $FUHfe);
$parcel$exportWildcard(module.exports, $1cCRP);
$parcel$exportWildcard(module.exports, $c0aRk);
$parcel$exportWildcard(module.exports, $8nuZn);
$parcel$exportWildcard(module.exports, $9Xybp);
$parcel$exportWildcard(module.exports, $abjAz);
$parcel$exportWildcard(module.exports, $fbuqw);
$parcel$exportWildcard(module.exports, $5v6ry);
$parcel$exportWildcard(module.exports, $dls1y);
$parcel$exportWildcard(module.exports, $fl174);
$parcel$exportWildcard(module.exports, $c6UQl);
$parcel$exportWildcard(module.exports, $a4MLb);
$parcel$exportWildcard(module.exports, $ip6UH);
$parcel$exportWildcard(module.exports, $lEBSs);
$parcel$exportWildcard(module.exports, $4A7HA);
$parcel$exportWildcard(module.exports, $8WG4F);
$parcel$exportWildcard(module.exports, $klshO);
$parcel$exportWildcard(module.exports, $6PQ5r);
$parcel$exportWildcard(module.exports, $koExS);
$parcel$exportWildcard(module.exports, $iRIOb);
$parcel$exportWildcard(module.exports, $DduJm);
$parcel$exportWildcard(module.exports, $iGY4d);
$parcel$exportWildcard(module.exports, $il6pG);
$parcel$exportWildcard(module.exports, $5DCzZ);
$parcel$exportWildcard(module.exports, $eofEg);
$parcel$exportWildcard(module.exports, $hvUJP);

});
parcelRegister("ihfnn", function(module, exports) {

var $i22TP = parcelRequire("i22TP");

var $kJQop = parcelRequire("kJQop");
$parcel$exportWildcard(module.exports, $i22TP);
$parcel$exportWildcard(module.exports, $kJQop);

});
parcelRegister("i22TP", function(module, exports) {

$parcel$export(module.exports, "DracoCompression", () => $d20aa9a5ac95fe4d$export$c0bcf2d8331f78df);
/* eslint-disable @typescript-eslint/naming-convention */ 
var $bOhSV = parcelRequire("bOhSV");

var $ib3jc = parcelRequire("ib3jc");

var $FUHfe = parcelRequire("FUHfe");
parcelRequire("8HkN0");
var $b4i1f = parcelRequire("b4i1f");

var $5v6ry = parcelRequire("5v6ry");

var $kVtWi = parcelRequire("kVtWi");

var $fJtmt = parcelRequire("fJtmt");
function $d20aa9a5ac95fe4d$var$createDecoderAsync(wasmBinary, jsModule) {
    return new Promise((resolve)=>{
        (jsModule || DracoDecoderModule)({
            wasmBinary: wasmBinary
        }).then((module)=>{
            resolve({
                module: module
            });
        });
    });
}
class $d20aa9a5ac95fe4d$export$c0bcf2d8331f78df {
    /**
     * Returns true if the decoder configuration is available.
     */ static get DecoderAvailable() {
        const decoder = $d20aa9a5ac95fe4d$export$c0bcf2d8331f78df.Configuration.decoder;
        return !!(decoder.wasmUrl && decoder.wasmBinaryUrl && typeof WebAssembly === "object" || decoder.fallbackUrl);
    }
    static GetDefaultNumWorkers() {
        if (typeof navigator !== "object" || !navigator.hardwareConcurrency) return 1;
        // Use 50% of the available logical processors but capped at 4.
        return Math.min(Math.floor(navigator.hardwareConcurrency * 0.5), 4);
    }
    /**
     * Default instance for the draco compression object.
     */ static get Default() {
        if (!$d20aa9a5ac95fe4d$export$c0bcf2d8331f78df._Default) $d20aa9a5ac95fe4d$export$c0bcf2d8331f78df._Default = new $d20aa9a5ac95fe4d$export$c0bcf2d8331f78df();
        return $d20aa9a5ac95fe4d$export$c0bcf2d8331f78df._Default;
    }
    /**
     * Constructor
     * @param numWorkers The number of workers for async operations Or an options object. Specify `0` to disable web workers and run synchronously in the current context.
     */ constructor(numWorkers = $d20aa9a5ac95fe4d$export$c0bcf2d8331f78df.DefaultNumWorkers){
        const decoder = $d20aa9a5ac95fe4d$export$c0bcf2d8331f78df.Configuration.decoder;
        // check if the decoder binary and worker pool was injected
        // Note - it is expected that the developer checked if WebWorker, WebAssembly and the URL object are available
        if (decoder.workerPool || typeof numWorkers === "object" && numWorkers.workerPool) // set the promise accordingly
        this._workerPoolPromise = Promise.resolve(decoder.workerPool || numWorkers.workerPool);
        else {
            // to avoid making big changes to the decider, if wasmBinary is provided use it in the wasmBinaryPromise
            const wasmBinaryProvided = decoder.wasmBinary || typeof numWorkers === "object" && numWorkers.wasmBinary;
            const numberOfWorkers = typeof numWorkers === "number" ? numWorkers : numWorkers.numWorkers;
            const useWorkers = numberOfWorkers && typeof Worker === "function" && typeof URL === "function";
            const urlNeeded = useWorkers || !useWorkers && !decoder.jsModule;
            // code maintained here for back-compat with no changes
            const decoderInfo = decoder.wasmUrl && decoder.wasmBinaryUrl && typeof WebAssembly === "object" ? {
                url: urlNeeded ? (0, $bOhSV.Tools).GetBabylonScriptURL(decoder.wasmUrl, true) : "",
                wasmBinaryPromise: wasmBinaryProvided ? Promise.resolve(wasmBinaryProvided) : (0, $bOhSV.Tools).LoadFileAsync((0, $bOhSV.Tools).GetBabylonScriptURL(decoder.wasmBinaryUrl, true))
            } : {
                url: urlNeeded ? (0, $bOhSV.Tools).GetBabylonScriptURL(decoder.fallbackUrl) : "",
                wasmBinaryPromise: Promise.resolve(undefined)
            };
            if (useWorkers) this._workerPoolPromise = decoderInfo.wasmBinaryPromise.then((decoderWasmBinary)=>{
                const workerContent = `${(0, $fJtmt.decodeMesh)}(${(0, $fJtmt.workerFunction)})()`;
                const workerBlobUrl = URL.createObjectURL(new Blob([
                    workerContent
                ], {
                    type: "application/javascript"
                }));
                return new (0, $ib3jc.AutoReleaseWorkerPool)(numberOfWorkers, ()=>{
                    const worker = new Worker(workerBlobUrl);
                    return (0, $fJtmt.initializeWebWorker)(worker, decoderWasmBinary, decoderInfo.url);
                });
            });
            else this._decoderModulePromise = decoderInfo.wasmBinaryPromise.then(async (decoderWasmBinary)=>{
                if (typeof DracoDecoderModule === "undefined") {
                    if (!decoder.jsModule) {
                        if (!decoderInfo.url) throw new Error("Draco decoder module is not available");
                        await (0, $bOhSV.Tools).LoadBabylonScriptAsync(decoderInfo.url);
                    }
                }
                return await $d20aa9a5ac95fe4d$var$createDecoderAsync(decoderWasmBinary, decoder.jsModule);
            });
        }
    }
    /**
     * Stop all async operations and release resources.
     */ dispose() {
        if (this._workerPoolPromise) this._workerPoolPromise.then((workerPool)=>{
            workerPool.dispose();
        });
        delete this._workerPoolPromise;
        delete this._decoderModulePromise;
    }
    /**
     * Returns a promise that resolves when ready. Call this manually to ensure draco compression is ready before use.
     * @returns a promise that resolves when ready
     */ async whenReadyAsync() {
        if (this._workerPoolPromise) {
            await this._workerPoolPromise;
            return;
        }
        if (this._decoderModulePromise) {
            await this._decoderModulePromise;
            return;
        }
    }
    _decodeMeshAsync(data, attributes, gltfNormalizedOverride) {
        const dataView = data instanceof ArrayBuffer ? new Int8Array(data) : new Int8Array(data.buffer, data.byteOffset, data.byteLength);
        const applyGltfNormalizedOverride = (kind, normalized)=>{
            if (gltfNormalizedOverride && gltfNormalizedOverride[kind] !== undefined) {
                if (normalized !== gltfNormalizedOverride[kind]) (0, $kVtWi.Logger).Warn(`Normalized flag from Draco data (${normalized}) does not match normalized flag from glTF accessor (${gltfNormalizedOverride[kind]}). Using flag from glTF accessor.`);
                return gltfNormalizedOverride[kind];
            } else return normalized;
        };
        if (this._workerPoolPromise) return this._workerPoolPromise.then((workerPool)=>{
            return new Promise((resolve, reject)=>{
                workerPool.push((worker, onComplete)=>{
                    let resultIndices = null;
                    const resultAttributes = [];
                    const onError = (error)=>{
                        worker.removeEventListener("error", onError);
                        worker.removeEventListener("message", onMessage);
                        reject(error);
                        onComplete();
                    };
                    const onMessage = (event)=>{
                        const message = event.data;
                        switch(message.id){
                            case "decodeMeshDone":
                                worker.removeEventListener("error", onError);
                                worker.removeEventListener("message", onMessage);
                                resolve({
                                    indices: resultIndices,
                                    attributes: resultAttributes,
                                    totalVertices: message.totalVertices
                                });
                                onComplete();
                                break;
                            case "indices":
                                resultIndices = message.data;
                                break;
                            case "attribute":
                                resultAttributes.push({
                                    kind: message.kind,
                                    data: message.data,
                                    size: message.size,
                                    byteOffset: message.byteOffset,
                                    byteStride: message.byteStride,
                                    normalized: applyGltfNormalizedOverride(message.kind, message.normalized)
                                });
                                break;
                        }
                    };
                    worker.addEventListener("error", onError);
                    worker.addEventListener("message", onMessage);
                    const dataViewCopy = dataView.slice();
                    worker.postMessage({
                        id: "decodeMesh",
                        dataView: dataViewCopy,
                        attributes: attributes
                    }, [
                        dataViewCopy.buffer
                    ]);
                });
            });
        });
        if (this._decoderModulePromise) return this._decoderModulePromise.then((decoder)=>{
            let resultIndices = null;
            const resultAttributes = [];
            const numPoints = (0, $fJtmt.decodeMesh)(decoder.module, dataView, attributes, (indices)=>{
                resultIndices = indices;
            }, (kind, data, size, byteOffset, byteStride, normalized)=>{
                resultAttributes.push({
                    kind: kind,
                    data: data,
                    size: size,
                    byteOffset: byteOffset,
                    byteStride: byteStride,
                    normalized: normalized
                });
            });
            return {
                indices: resultIndices,
                attributes: resultAttributes,
                totalVertices: numPoints
            };
        });
        throw new Error("Draco decoder module is not available");
    }
    /**
     * Decode Draco compressed mesh data to Babylon geometry.
     * @param name The name to use when creating the geometry
     * @param scene The scene to use when creating the geometry
     * @param data The ArrayBuffer or ArrayBufferView for the Draco compression data
     * @param attributes A map of attributes from vertex buffer kinds to Draco unique ids
     * @returns A promise that resolves with the decoded geometry
     */ async decodeMeshToGeometryAsync(name, scene, data, attributes) {
        const meshData = await this._decodeMeshAsync(data, attributes);
        const geometry = new (0, $FUHfe.Geometry)(name, scene);
        if (meshData.indices) geometry.setIndices(meshData.indices);
        for (const attribute of meshData.attributes)geometry.setVerticesBuffer(new (0, $b4i1f.VertexBuffer)(scene.getEngine(), attribute.data, attribute.kind, false, undefined, attribute.byteStride, undefined, attribute.byteOffset, attribute.size, undefined, attribute.normalized, true), meshData.totalVertices);
        return geometry;
    }
    /** @internal */ async _decodeMeshToGeometryForGltfAsync(name, scene, data, attributes, gltfNormalizedOverride) {
        const meshData = await this._decodeMeshAsync(data, attributes, gltfNormalizedOverride);
        const geometry = new (0, $FUHfe.Geometry)(name, scene);
        if (meshData.indices) geometry.setIndices(meshData.indices);
        for (const attribute of meshData.attributes)geometry.setVerticesBuffer(new (0, $b4i1f.VertexBuffer)(scene.getEngine(), attribute.data, attribute.kind, false, undefined, attribute.byteStride, undefined, attribute.byteOffset, attribute.size, undefined, attribute.normalized, true), meshData.totalVertices);
        return geometry;
    }
    /**
     * Decode Draco compressed mesh data to Babylon vertex data.
     * @param data The ArrayBuffer or ArrayBufferView for the Draco compression data
     * @param attributes A map of attributes from vertex buffer kinds to Draco unique ids
     * @returns A promise that resolves with the decoded vertex data
     * @deprecated Use {@link decodeMeshToGeometryAsync} for better performance in some cases
     */ async decodeMeshAsync(data, attributes) {
        const meshData = await this._decodeMeshAsync(data, attributes);
        const vertexData = new (0, $5v6ry.VertexData)();
        if (meshData.indices) vertexData.indices = meshData.indices;
        for (const attribute of meshData.attributes){
            const floatData = (0, $b4i1f.VertexBuffer).GetFloatData(attribute.data, attribute.size, (0, $b4i1f.VertexBuffer).GetDataType(attribute.data), attribute.byteOffset, attribute.byteStride, attribute.normalized, meshData.totalVertices);
            vertexData.set(floatData, attribute.kind);
        }
        return vertexData;
    }
}
/**
 * The configuration. Defaults to the following urls:
 * - wasmUrl: "https://cdn.babylonjs.com/draco_wasm_wrapper_gltf.js"
 * - wasmBinaryUrl: "https://cdn.babylonjs.com/draco_decoder_gltf.wasm"
 * - fallbackUrl: "https://cdn.babylonjs.com/draco_decoder_gltf.js"
 */ $d20aa9a5ac95fe4d$export$c0bcf2d8331f78df.Configuration = {
    decoder: {
        wasmUrl: `${(0, $bOhSV.Tools)._DefaultCdnUrl}/draco_wasm_wrapper_gltf.js`,
        wasmBinaryUrl: `${(0, $bOhSV.Tools)._DefaultCdnUrl}/draco_decoder_gltf.wasm`,
        fallbackUrl: `${(0, $bOhSV.Tools)._DefaultCdnUrl}/draco_decoder_gltf.js`
    }
};
/**
 * Default number of workers to create when creating the draco compression object.
 */ $d20aa9a5ac95fe4d$export$c0bcf2d8331f78df.DefaultNumWorkers = $d20aa9a5ac95fe4d$export$c0bcf2d8331f78df.GetDefaultNumWorkers();
$d20aa9a5ac95fe4d$export$c0bcf2d8331f78df._Default = null;

});
parcelRegister("8HkN0", function(module, exports) {

$parcel$export(module.exports, "VertexBuffer", () => (parcelRequire("b4i1f")).VertexBuffer);
/**
 * This is here for backwards compatibility with 4.2
 * @internal
 */ 
var $b4i1f = parcelRequire("b4i1f");

});

parcelRegister("fJtmt", function(module, exports) {

$parcel$export(module.exports, "decodeMesh", () => $b741d58c72fcdbca$export$ed9e904a68e01391);
$parcel$export(module.exports, "workerFunction", () => $b741d58c72fcdbca$export$4fa462ff61661f49);
$parcel$export(module.exports, "initializeWebWorker", () => $b741d58c72fcdbca$export$712a80800d0b66d1);
/**
 * @internal
 */ function $b741d58c72fcdbca$export$ed9e904a68e01391(decoderModule /*DecoderModule*/ , data, attributes, onIndicesData, onAttributeData) {
    let decoder = null;
    let buffer = null;
    let geometry = null;
    try {
        decoder = new decoderModule.Decoder();
        buffer = new decoderModule.DecoderBuffer();
        buffer.Init(data, data.byteLength);
        let status;
        const type = decoder.GetEncodedGeometryType(buffer);
        switch(type){
            case decoderModule.TRIANGULAR_MESH:
                {
                    const mesh = new decoderModule.Mesh();
                    status = decoder.DecodeBufferToMesh(buffer, mesh);
                    if (!status.ok() || mesh.ptr === 0) throw new Error(status.error_msg());
                    const numFaces = mesh.num_faces();
                    const numIndices = numFaces * 3;
                    const byteLength = numIndices * 4;
                    const ptr = decoderModule._malloc(byteLength);
                    try {
                        decoder.GetTrianglesUInt32Array(mesh, byteLength, ptr);
                        const indices = new Uint32Array(numIndices);
                        indices.set(new Uint32Array(decoderModule.HEAPF32.buffer, ptr, numIndices));
                        onIndicesData(indices);
                    } finally{
                        decoderModule._free(ptr);
                    }
                    geometry = mesh;
                    break;
                }
            case decoderModule.POINT_CLOUD:
                {
                    const pointCloud = new decoderModule.PointCloud();
                    status = decoder.DecodeBufferToPointCloud(buffer, pointCloud);
                    if (!status.ok() || !pointCloud.ptr) throw new Error(status.error_msg());
                    geometry = pointCloud;
                    break;
                }
            default:
                throw new Error(`Invalid geometry type ${type}`);
        }
        const numPoints = geometry.num_points();
        const processAttribute = (decoder, geometry, kind, attribute)=>{
            const dataType = attribute.data_type();
            const numComponents = attribute.num_components();
            const normalized = attribute.normalized();
            const byteStride = attribute.byte_stride();
            const byteOffset = attribute.byte_offset();
            const dataTypeInfo = {
                [decoderModule.DT_FLOAT32]: {
                    typedArrayConstructor: Float32Array,
                    heap: decoderModule.HEAPF32
                },
                [decoderModule.DT_INT8]: {
                    typedArrayConstructor: Int8Array,
                    heap: decoderModule.HEAP8
                },
                [decoderModule.DT_INT16]: {
                    typedArrayConstructor: Int16Array,
                    heap: decoderModule.HEAP16
                },
                [decoderModule.DT_INT32]: {
                    typedArrayConstructor: Int32Array,
                    heap: decoderModule.HEAP32
                },
                [decoderModule.DT_UINT8]: {
                    typedArrayConstructor: Uint8Array,
                    heap: decoderModule.HEAPU8
                },
                [decoderModule.DT_UINT16]: {
                    typedArrayConstructor: Uint16Array,
                    heap: decoderModule.HEAPU16
                },
                [decoderModule.DT_UINT32]: {
                    typedArrayConstructor: Uint32Array,
                    heap: decoderModule.HEAPU32
                }
            };
            const info = dataTypeInfo[dataType];
            if (!info) throw new Error(`Invalid data type ${dataType}`);
            const numValues = numPoints * numComponents;
            const byteLength = numValues * info.typedArrayConstructor.BYTES_PER_ELEMENT;
            const ptr = decoderModule._malloc(byteLength);
            try {
                decoder.GetAttributeDataArrayForAllPoints(geometry, attribute, dataType, byteLength, ptr);
                const data = new info.typedArrayConstructor(info.heap.buffer, ptr, numValues);
                onAttributeData(kind, data.slice(), numComponents, byteOffset, byteStride, normalized);
            } finally{
                decoderModule._free(ptr);
            }
        };
        if (attributes) for(const kind in attributes){
            const id = attributes[kind];
            const attribute = decoder.GetAttributeByUniqueId(geometry, id);
            processAttribute(decoder, geometry, kind, attribute);
        }
        else {
            const dracoAttributeTypes = {
                position: decoderModule.POSITION,
                normal: decoderModule.NORMAL,
                color: decoderModule.COLOR,
                uv: decoderModule.TEX_COORD
            };
            for(const kind in dracoAttributeTypes){
                const id = decoder.GetAttributeId(geometry, dracoAttributeTypes[kind]);
                if (id !== -1) {
                    const attribute = decoder.GetAttribute(geometry, id);
                    processAttribute(decoder, geometry, kind, attribute);
                }
            }
        }
        return numPoints;
    } finally{
        if (geometry) decoderModule.destroy(geometry);
        if (buffer) decoderModule.destroy(buffer);
        if (decoder) decoderModule.destroy(decoder);
    }
}
function $b741d58c72fcdbca$export$4fa462ff61661f49() {
    let decoderPromise;
    onmessage = (event)=>{
        const message = event.data;
        switch(message.id){
            case "init":
                {
                    const decoder = message.decoder;
                    // if URL is provided then load the script. Otherwise expect the script to be loaded already
                    if (decoder.url) importScripts(decoder.url);
                    decoderPromise = DracoDecoderModule({
                        wasmBinary: decoder.wasmBinary
                    });
                    postMessage({
                        id: "initDone"
                    });
                    break;
                }
            case "decodeMesh":
                if (!decoderPromise) throw new Error("Draco decoder module is not available");
                decoderPromise.then((decoder)=>{
                    const numPoints = $b741d58c72fcdbca$export$ed9e904a68e01391(decoder, message.dataView, message.attributes, (indices)=>{
                        postMessage({
                            id: "indices",
                            data: indices
                        }, [
                            indices.buffer
                        ]);
                    }, (kind, data, size, offset, stride, normalized)=>{
                        postMessage({
                            id: "attribute",
                            kind: kind,
                            data: data,
                            size: size,
                            byteOffset: offset,
                            byteStride: stride,
                            normalized: normalized
                        }, [
                            data.buffer
                        ]);
                    });
                    postMessage({
                        id: "decodeMeshDone",
                        totalVertices: numPoints
                    });
                });
                break;
        }
    };
}
function $b741d58c72fcdbca$export$712a80800d0b66d1(worker, decoderWasmBinary, moduleUrl) {
    return new Promise((resolve, reject)=>{
        const onError = (error)=>{
            worker.removeEventListener("error", onError);
            worker.removeEventListener("message", onMessage);
            reject(error);
        };
        const onMessage = (event)=>{
            if (event.data.id === "initDone") {
                worker.removeEventListener("error", onError);
                worker.removeEventListener("message", onMessage);
                resolve(worker);
            }
        };
        worker.addEventListener("error", onError);
        worker.addEventListener("message", onMessage);
        // clone the array buffer to make it transferable
        const clone = decoderWasmBinary.slice(0);
        worker.postMessage({
            id: "init",
            decoder: {
                url: moduleUrl,
                wasmBinary: clone
            }
        }, [
            clone
        ]);
    // note: no transfer list as the ArrayBuffer is shared across main thread and pool workers
    });
}

});


parcelRegister("kJQop", function(module, exports) {

$parcel$export(module.exports, "MeshoptCompression", () => $f190a6bcb1b2db16$export$d64bd7d4cdb6bfac);

var $bOhSV = parcelRequire("bOhSV");
class $f190a6bcb1b2db16$export$d64bd7d4cdb6bfac {
    /**
     * Default instance for the meshoptimizer object.
     */ static get Default() {
        if (!$f190a6bcb1b2db16$export$d64bd7d4cdb6bfac._Default) $f190a6bcb1b2db16$export$d64bd7d4cdb6bfac._Default = new $f190a6bcb1b2db16$export$d64bd7d4cdb6bfac();
        return $f190a6bcb1b2db16$export$d64bd7d4cdb6bfac._Default;
    }
    /**
     * Constructor
     */ constructor(){
        const decoder = $f190a6bcb1b2db16$export$d64bd7d4cdb6bfac.Configuration.decoder;
        this._decoderModulePromise = (0, $bOhSV.Tools).LoadBabylonScriptAsync(decoder.url).then(()=>{
            // Wait for WebAssembly compilation before resolving promise
            return MeshoptDecoder.ready;
        });
    }
    /**
     * Stop all async operations and release resources.
     */ dispose() {
        delete this._decoderModulePromise;
    }
    /**
     * Decode meshopt data.
     * @see https://github.com/zeux/meshoptimizer/tree/master/js#decoder
     * @param source The input data.
     * @param count The number of elements.
     * @param stride The stride in bytes.
     * @param mode The compression mode.
     * @param filter The compression filter.
     * @returns a Promise<Uint8Array> that resolves to the decoded data
     */ decodeGltfBufferAsync(source, count, stride, mode, filter) {
        return this._decoderModulePromise.then(()=>{
            const result = new Uint8Array(count * stride);
            MeshoptDecoder.decodeGltfBuffer(result, count, stride, source, mode, filter);
            return result;
        });
    }
}
/**
 * The configuration. Defaults to the following:
 * ```javascript
 * decoder: {
 *   url: "https://cdn.babylonjs.com/meshopt_decoder.js"
 * }
 * ```
 */ $f190a6bcb1b2db16$export$d64bd7d4cdb6bfac.Configuration = {
    decoder: {
        url: `${(0, $bOhSV.Tools)._DefaultCdnUrl}/meshopt_decoder.js`
    }
};
$f190a6bcb1b2db16$export$d64bd7d4cdb6bfac._Default = null;

});


parcelRegister("eg7RM", function(module, exports) {

$parcel$export(module.exports, "CSG", () => $a618a96d4ce57592$export$6245acb12b2caa6b);

var $ha1VO = parcelRequire("ha1VO");

var $b4i1f = parcelRequire("b4i1f");

var $lEBSs = parcelRequire("lEBSs");

var $fbuqw = parcelRequire("fbuqw");

var $7etnY = parcelRequire("7etnY");

var $5v6ry = parcelRequire("5v6ry");
/**
 * Unique ID when we import meshes from Babylon to CSG
 */ let $a618a96d4ce57592$var$currentCSGMeshId = 0;
/**
 * Represents a vertex of a polygon. Use your own vertex class instead of this
 * one to provide additional features like texture coordinates and vertex
 * colors. Custom vertex classes need to provide a `pos` property and `clone()`,
 * `flip()`, and `interpolate()` methods that behave analogous to the ones
 * defined by `BABYLON.CSG.Vertex`. This class provides `normal` so convenience
 * functions like `BABYLON.CSG.sphere()` can return a smooth vertex normal, but `normal`
 * is not used anywhere else.
 * Same goes for uv, it allows to keep the original vertex uv coordinates of the 2 meshes
 */ class $a618a96d4ce57592$var$Vertex {
    /**
     * Initializes the vertex
     * @param pos The position of the vertex
     * @param normal The normal of the vertex
     * @param uv The texture coordinate of the vertex
     * @param vertColor The RGBA color of the vertex
     */ constructor(/**
     * The position of the vertex
     */ pos, /**
     * The normal of the vertex
     */ normal, /**
     * The texture coordinate of the vertex
     */ uv, /**
     * The texture coordinate of the vertex
     */ vertColor){
        this.pos = pos;
        this.normal = normal;
        this.uv = uv;
        this.vertColor = vertColor;
    }
    /**
     * Make a clone, or deep copy, of the vertex
     * @returns A new Vertex
     */ clone() {
        return new $a618a96d4ce57592$var$Vertex(this.pos.clone(), this.normal.clone(), this.uv?.clone(), this.vertColor?.clone());
    }
    /**
     * Invert all orientation-specific data (e.g. vertex normal). Called when the
     * orientation of a polygon is flipped.
     */ flip() {
        this.normal = this.normal.scale(-1);
    }
    /**
     * Create a new vertex between this vertex and `other` by linearly
     * interpolating all properties using a parameter of `t`. Subclasses should
     * override this to interpolate additional properties.
     * @param other the vertex to interpolate against
     * @param t The factor used to linearly interpolate between the vertices
     * @returns The new interpolated vertex
     */ interpolate(other, t) {
        return new $a618a96d4ce57592$var$Vertex((0, $ha1VO.Vector3).Lerp(this.pos, other.pos, t), (0, $ha1VO.Vector3).Lerp(this.normal, other.normal, t), this.uv && other.uv ? (0, $ha1VO.Vector2).Lerp(this.uv, other.uv, t) : undefined, this.vertColor && other.vertColor ? (0, $7etnY.Color4).Lerp(this.vertColor, other.vertColor, t) : undefined);
    }
}
/**
 * Represents a plane in 3D space.
 */ class $a618a96d4ce57592$var$CSGPlane {
    /**
     * Initializes the plane
     * @param normal The normal for the plane
     * @param w
     */ constructor(normal, w){
        this.normal = normal;
        this.w = w;
    }
    /**
     * Construct a plane from three points
     * @param a Point a
     * @param b Point b
     * @param c Point c
     * @returns A new plane
     */ static FromPoints(a, b, c) {
        const v0 = c.subtract(a);
        const v1 = b.subtract(a);
        if (v0.lengthSquared() === 0 || v1.lengthSquared() === 0) return null;
        const n = (0, $ha1VO.Vector3).Normalize((0, $ha1VO.Vector3).Cross(v0, v1));
        return new $a618a96d4ce57592$var$CSGPlane(n, (0, $ha1VO.Vector3).Dot(n, a));
    }
    /**
     * Clone, or make a deep copy of the plane
     * @returns a new Plane
     */ clone() {
        return new $a618a96d4ce57592$var$CSGPlane(this.normal.clone(), this.w);
    }
    /**
     * Flip the face of the plane
     */ flip() {
        this.normal.scaleInPlace(-1);
        this.w = -this.w;
    }
    /**
     * Split `polygon` by this plane if needed, then put the polygon or polygon
     * fragments in the appropriate lists. Coplanar polygons go into either
    `* coplanarFront` or `coplanarBack` depending on their orientation with
     * respect to this plane. Polygons in front or in back of this plane go into
     * either `front` or `back`
     * @param polygon The polygon to be split
     * @param coplanarFront Will contain polygons coplanar with the plane that are oriented to the front of the plane
     * @param coplanarBack Will contain polygons coplanar with the plane that are oriented to the back of the plane
     * @param front Will contain the polygons in front of the plane
     * @param back Will contain the polygons begind the plane
     */ splitPolygon(polygon, coplanarFront, coplanarBack, front, back) {
        const COPLANAR = 0;
        const FRONT = 1;
        const BACK = 2;
        const SPANNING = 3;
        // Classify each point as well as the entire polygon into one of the above
        // four classes.
        let polygonType = 0;
        const types = [];
        let i;
        let t;
        for(i = 0; i < polygon.vertices.length; i++){
            t = (0, $ha1VO.Vector3).Dot(this.normal, polygon.vertices[i].pos) - this.w;
            const type = t < -$a618a96d4ce57592$var$CSGPlane.EPSILON ? BACK : t > $a618a96d4ce57592$var$CSGPlane.EPSILON ? FRONT : COPLANAR;
            polygonType |= type;
            types.push(type);
        }
        // Put the polygon in the correct list, splitting it when necessary
        switch(polygonType){
            case COPLANAR:
                ((0, $ha1VO.Vector3).Dot(this.normal, polygon.plane.normal) > 0 ? coplanarFront : coplanarBack).push(polygon);
                break;
            case FRONT:
                front.push(polygon);
                break;
            case BACK:
                back.push(polygon);
                break;
            case SPANNING:
                {
                    const f = [], b = [];
                    for(i = 0; i < polygon.vertices.length; i++){
                        const j = (i + 1) % polygon.vertices.length;
                        const ti = types[i], tj = types[j];
                        const vi = polygon.vertices[i], vj = polygon.vertices[j];
                        if (ti !== BACK) f.push(vi);
                        if (ti !== FRONT) b.push(ti !== BACK ? vi.clone() : vi);
                        if ((ti | tj) === SPANNING) {
                            t = (this.w - (0, $ha1VO.Vector3).Dot(this.normal, vi.pos)) / (0, $ha1VO.Vector3).Dot(this.normal, vj.pos.subtract(vi.pos));
                            const v = vi.interpolate(vj, t);
                            f.push(v);
                            b.push(v.clone());
                        }
                    }
                    let poly;
                    if (f.length >= 3) {
                        poly = new $a618a96d4ce57592$var$CSGPolygon(f, polygon.shared);
                        if (poly.plane) front.push(poly);
                    }
                    if (b.length >= 3) {
                        poly = new $a618a96d4ce57592$var$CSGPolygon(b, polygon.shared);
                        if (poly.plane) back.push(poly);
                    }
                    break;
                }
        }
    }
}
/**
 * `CSG.Plane.EPSILON` is the tolerance used by `splitPolygon()` to decide if a
 * point is on the plane
 */ $a618a96d4ce57592$var$CSGPlane.EPSILON = 1e-5;
/**
 * Represents a convex polygon. The vertices used to initialize a polygon must
 * be coplanar and form a convex loop.
 *
 * Each convex polygon has a `shared` property, which is shared between all
 * polygons that are clones of each other or were split from the same polygon.
 * This can be used to define per-polygon properties (such as surface color)
 */ class $a618a96d4ce57592$var$CSGPolygon {
    /**
     * Initializes the polygon
     * @param vertices The vertices of the polygon
     * @param shared The properties shared across all polygons
     */ constructor(vertices, shared){
        this.vertices = vertices;
        this.shared = shared;
        this.plane = $a618a96d4ce57592$var$CSGPlane.FromPoints(vertices[0].pos, vertices[1].pos, vertices[2].pos);
    }
    /**
     * Clones, or makes a deep copy, or the polygon
     * @returns A new CSGPolygon
     */ clone() {
        const vertices = this.vertices.map((v)=>v.clone());
        return new $a618a96d4ce57592$var$CSGPolygon(vertices, this.shared);
    }
    /**
     * Flips the faces of the polygon
     */ flip() {
        this.vertices.reverse().map((v)=>{
            v.flip();
        });
        this.plane.flip();
    }
}
/**
 * Holds a node in a BSP tree. A BSP tree is built from a collection of polygons
 * by picking a polygon to split along. That polygon (and all other coplanar
 * polygons) are added directly to that node and the other polygons are added to
 * the front and/or back subtrees. This is not a leafy BSP tree since there is
 * no distinction between internal and leaf nodes
 */ class $a618a96d4ce57592$var$Node {
    /**
     * Initializes the node
     * @param polygons A collection of polygons held in the node
     */ constructor(polygons){
        this._plane = null;
        this._front = null;
        this._back = null;
        this._polygons = new Array();
        if (polygons) this.build(polygons);
    }
    /**
     * Clones, or makes a deep copy, of the node
     * @returns The cloned node
     */ clone() {
        const node = new $a618a96d4ce57592$var$Node();
        node._plane = this._plane && this._plane.clone();
        node._front = this._front && this._front.clone();
        node._back = this._back && this._back.clone();
        node._polygons = this._polygons.map((p)=>p.clone());
        return node;
    }
    /**
     * Convert solid space to empty space and empty space to solid space
     */ invert() {
        for(let i = 0; i < this._polygons.length; i++)this._polygons[i].flip();
        if (this._plane) this._plane.flip();
        if (this._front) this._front.invert();
        if (this._back) this._back.invert();
        const temp = this._front;
        this._front = this._back;
        this._back = temp;
    }
    /**
     * Recursively remove all polygons in `polygons` that are inside this BSP
     * tree.
     * @param polygons Polygons to remove from the BSP
     * @returns Polygons clipped from the BSP
     */ clipPolygons(polygons) {
        if (!this._plane) return polygons.slice();
        let front = [], back = [];
        for(let i = 0; i < polygons.length; i++)this._plane.splitPolygon(polygons[i], front, back, front, back);
        if (this._front) front = this._front.clipPolygons(front);
        if (this._back) back = this._back.clipPolygons(back);
        else back = [];
        return front.concat(back);
    }
    /**
     * Remove all polygons in this BSP tree that are inside the other BSP tree
     * `bsp`.
     * @param bsp BSP containing polygons to remove from this BSP
     */ clipTo(bsp) {
        this._polygons = bsp.clipPolygons(this._polygons);
        if (this._front) this._front.clipTo(bsp);
        if (this._back) this._back.clipTo(bsp);
    }
    /**
     * Return a list of all polygons in this BSP tree
     * @returns List of all polygons in this BSP tree
     */ allPolygons() {
        let polygons = this._polygons.slice();
        if (this._front) polygons = polygons.concat(this._front.allPolygons());
        if (this._back) polygons = polygons.concat(this._back.allPolygons());
        return polygons;
    }
    /**
     * Build a BSP tree out of `polygons`. When called on an existing tree, the
     * new polygons are filtered down to the bottom of the tree and become new
     * nodes there. Each set of polygons is partitioned using the first polygon
     * (no heuristic is used to pick a good split)
     * @param polygons Polygons used to construct the BSP tree
     */ build(polygons) {
        if (!polygons.length) return;
        if (!this._plane) this._plane = polygons[0].plane.clone();
        const front = [], back = [];
        for(let i = 0; i < polygons.length; i++)this._plane.splitPolygon(polygons[i], this._polygons, this._polygons, front, back);
        if (front.length) {
            if (!this._front) this._front = new $a618a96d4ce57592$var$Node();
            this._front.build(front);
        }
        if (back.length) {
            if (!this._back) this._back = new $a618a96d4ce57592$var$Node();
            this._back.build(back);
        }
    }
}
class $a618a96d4ce57592$export$6245acb12b2caa6b {
    constructor(){
        this._polygons = new Array();
    }
    /**
     * Convert a VertexData to CSG
     * @param data defines the VertexData to convert to CSG
     * @returns the new CSG
     */ static FromVertexData(data) {
        let vertex, polygon, vertices;
        const polygons = [];
        const indices = data.indices;
        const positions = data.positions;
        const normals = data.normals;
        const uvs = data.uvs;
        const vertColors = data.colors;
        if (!indices || !positions) // eslint-disable-next-line no-throw-literal
        throw "BABYLON.CSG: VertexData must at least contain positions and indices";
        for(let i = 0; i < indices.length; i += 3){
            vertices = [];
            for(let j = 0; j < 3; j++){
                const indexIndices = i + j;
                const offset = indices[indexIndices];
                const normal = normals ? (0, $ha1VO.Vector3).FromArray(normals, offset * 3) : (0, $ha1VO.Vector3).Zero();
                const uv = uvs ? (0, $ha1VO.Vector2).FromArray(uvs, offset * 2) : undefined;
                const vertColor = vertColors ? (0, $7etnY.Color4).FromArray(vertColors, offset * 4) : undefined;
                const position = (0, $ha1VO.Vector3).FromArray(positions, offset * 3);
                vertex = new $a618a96d4ce57592$var$Vertex(position, normal, uv, vertColor);
                vertices.push(vertex);
            }
            polygon = new $a618a96d4ce57592$var$CSGPolygon(vertices, {
                subMeshId: 0,
                meshId: $a618a96d4ce57592$var$currentCSGMeshId,
                materialIndex: 0
            });
            // To handle the case of degenerated triangle
            // polygon.plane == null <=> the polygon does not represent 1 single plane <=> the triangle is degenerated
            if (polygon.plane) polygons.push(polygon);
        }
        const csg = $a618a96d4ce57592$export$6245acb12b2caa6b._FromPolygons(polygons);
        csg.matrix = (0, $ha1VO.Matrix).Identity();
        csg.position = (0, $ha1VO.Vector3).Zero();
        csg.rotation = (0, $ha1VO.Vector3).Zero();
        csg.scaling = (0, $ha1VO.Vector3).One();
        csg.rotationQuaternion = (0, $ha1VO.Quaternion).Identity();
        $a618a96d4ce57592$var$currentCSGMeshId++;
        return csg;
    }
    /**
     * Convert the Mesh to CSG
     * @param mesh The Mesh to convert to CSG
     * @param absolute If true, the final (local) matrix transformation is set to the identity and not to that of `mesh`. It can help when dealing with right-handed meshes (default: false)
     * @returns A new CSG from the Mesh
     */ static FromMesh(mesh, absolute = false) {
        let vertex, normal, uv = undefined, position, vertColor = undefined, polygon, vertices;
        const polygons = [];
        let matrix, meshPosition, meshRotation, meshRotationQuaternion = null, meshScaling;
        let invertWinding = false;
        if (mesh instanceof (0, $fbuqw.Mesh)) {
            mesh.computeWorldMatrix(true);
            matrix = mesh.getWorldMatrix();
            meshPosition = mesh.position.clone();
            meshRotation = mesh.rotation.clone();
            if (mesh.rotationQuaternion) meshRotationQuaternion = mesh.rotationQuaternion.clone();
            meshScaling = mesh.scaling.clone();
            if (mesh.material && absolute) invertWinding = mesh.material.sideOrientation === 0;
        } else // eslint-disable-next-line no-throw-literal
        throw "BABYLON.CSG: Wrong Mesh type, must be BABYLON.Mesh";
        const indices = mesh.getIndices(), positions = mesh.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind), normals = mesh.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind), uvs = mesh.getVerticesData((0, $b4i1f.VertexBuffer).UVKind), vertColors = mesh.getVerticesData((0, $b4i1f.VertexBuffer).ColorKind);
        const subMeshes = mesh.subMeshes;
        for(let sm = 0, sml = subMeshes.length; sm < sml; sm++)for(let i = subMeshes[sm].indexStart, il = subMeshes[sm].indexCount + subMeshes[sm].indexStart; i < il; i += 3){
            vertices = [];
            for(let j = 0; j < 3; j++){
                const indexIndices = j === 0 ? i + j : invertWinding ? i + 3 - j : i + j;
                const sourceNormal = new (0, $ha1VO.Vector3)(normals[indices[indexIndices] * 3], normals[indices[indexIndices] * 3 + 1], normals[indices[indexIndices] * 3 + 2]);
                if (uvs) uv = new (0, $ha1VO.Vector2)(uvs[indices[indexIndices] * 2], uvs[indices[indexIndices] * 2 + 1]);
                if (vertColors) vertColor = new (0, $7etnY.Color4)(vertColors[indices[indexIndices] * 4], vertColors[indices[indexIndices] * 4 + 1], vertColors[indices[indexIndices] * 4 + 2], vertColors[indices[indexIndices] * 4 + 3]);
                const sourcePosition = new (0, $ha1VO.Vector3)(positions[indices[indexIndices] * 3], positions[indices[indexIndices] * 3 + 1], positions[indices[indexIndices] * 3 + 2]);
                position = (0, $ha1VO.Vector3).TransformCoordinates(sourcePosition, matrix);
                normal = (0, $ha1VO.Vector3).TransformNormal(sourceNormal, matrix);
                vertex = new $a618a96d4ce57592$var$Vertex(position, normal, uv, vertColor);
                vertices.push(vertex);
            }
            polygon = new $a618a96d4ce57592$var$CSGPolygon(vertices, {
                subMeshId: sm,
                meshId: $a618a96d4ce57592$var$currentCSGMeshId,
                materialIndex: subMeshes[sm].materialIndex
            });
            // To handle the case of degenerated triangle
            // polygon.plane == null <=> the polygon does not represent 1 single plane <=> the triangle is degenerated
            if (polygon.plane) polygons.push(polygon);
        }
        const csg = $a618a96d4ce57592$export$6245acb12b2caa6b._FromPolygons(polygons);
        csg.matrix = absolute ? (0, $ha1VO.Matrix).Identity() : matrix;
        csg.position = absolute ? (0, $ha1VO.Vector3).Zero() : meshPosition;
        csg.rotation = absolute ? (0, $ha1VO.Vector3).Zero() : meshRotation;
        csg.scaling = absolute ? (0, $ha1VO.Vector3).One() : meshScaling;
        csg.rotationQuaternion = absolute && meshRotationQuaternion ? (0, $ha1VO.Quaternion).Identity() : meshRotationQuaternion;
        $a618a96d4ce57592$var$currentCSGMeshId++;
        return csg;
    }
    /**
     * Construct a CSG solid from a list of `CSG.Polygon` instances.
     * @param polygons Polygons used to construct a CSG solid
     * @returns A new CSG solid
     */ static _FromPolygons(polygons) {
        const csg = new $a618a96d4ce57592$export$6245acb12b2caa6b();
        csg._polygons = polygons;
        return csg;
    }
    /**
     * Clones, or makes a deep copy, of the CSG
     * @returns A new CSG
     */ clone() {
        const csg = new $a618a96d4ce57592$export$6245acb12b2caa6b();
        csg._polygons = this._polygons.map((p)=>p.clone());
        csg.copyTransformAttributes(this);
        return csg;
    }
    /**
     * Unions this CSG with another CSG
     * @param csg The CSG to union against this CSG
     * @returns The unioned CSG
     */ union(csg) {
        const a = new $a618a96d4ce57592$var$Node(this.clone()._polygons);
        const b = new $a618a96d4ce57592$var$Node(csg.clone()._polygons);
        a.clipTo(b);
        b.clipTo(a);
        b.invert();
        b.clipTo(a);
        b.invert();
        a.build(b.allPolygons());
        return $a618a96d4ce57592$export$6245acb12b2caa6b._FromPolygons(a.allPolygons()).copyTransformAttributes(this);
    }
    /**
     * Unions this CSG with another CSG in place
     * @param csg The CSG to union against this CSG
     */ unionInPlace(csg) {
        const a = new $a618a96d4ce57592$var$Node(this._polygons);
        const b = new $a618a96d4ce57592$var$Node(csg._polygons);
        a.clipTo(b);
        b.clipTo(a);
        b.invert();
        b.clipTo(a);
        b.invert();
        a.build(b.allPolygons());
        this._polygons = a.allPolygons();
    }
    /**
     * Subtracts this CSG with another CSG
     * @param csg The CSG to subtract against this CSG
     * @returns A new CSG
     */ subtract(csg) {
        const a = new $a618a96d4ce57592$var$Node(this.clone()._polygons);
        const b = new $a618a96d4ce57592$var$Node(csg.clone()._polygons);
        a.invert();
        a.clipTo(b);
        b.clipTo(a);
        b.invert();
        b.clipTo(a);
        b.invert();
        a.build(b.allPolygons());
        a.invert();
        return $a618a96d4ce57592$export$6245acb12b2caa6b._FromPolygons(a.allPolygons()).copyTransformAttributes(this);
    }
    /**
     * Subtracts this CSG with another CSG in place
     * @param csg The CSG to subtract against this CSG
     */ subtractInPlace(csg) {
        const a = new $a618a96d4ce57592$var$Node(this._polygons);
        const b = new $a618a96d4ce57592$var$Node(csg._polygons);
        a.invert();
        a.clipTo(b);
        b.clipTo(a);
        b.invert();
        b.clipTo(a);
        b.invert();
        a.build(b.allPolygons());
        a.invert();
        this._polygons = a.allPolygons();
    }
    /**
     * Intersect this CSG with another CSG
     * @param csg The CSG to intersect against this CSG
     * @returns A new CSG
     */ intersect(csg) {
        const a = new $a618a96d4ce57592$var$Node(this.clone()._polygons);
        const b = new $a618a96d4ce57592$var$Node(csg.clone()._polygons);
        a.invert();
        b.clipTo(a);
        b.invert();
        a.clipTo(b);
        b.clipTo(a);
        a.build(b.allPolygons());
        a.invert();
        return $a618a96d4ce57592$export$6245acb12b2caa6b._FromPolygons(a.allPolygons()).copyTransformAttributes(this);
    }
    /**
     * Intersects this CSG with another CSG in place
     * @param csg The CSG to intersect against this CSG
     */ intersectInPlace(csg) {
        const a = new $a618a96d4ce57592$var$Node(this._polygons);
        const b = new $a618a96d4ce57592$var$Node(csg._polygons);
        a.invert();
        b.clipTo(a);
        b.invert();
        a.clipTo(b);
        b.clipTo(a);
        a.build(b.allPolygons());
        a.invert();
        this._polygons = a.allPolygons();
    }
    /**
     * Return a new CSG solid with solid and empty space switched. This solid is
     * not modified.
     * @returns A new CSG solid with solid and empty space switched
     */ inverse() {
        const csg = this.clone();
        csg.inverseInPlace();
        return csg;
    }
    /**
     * Inverses the CSG in place
     */ inverseInPlace() {
        this._polygons.map((p)=>{
            p.flip();
        });
    }
    /**
     * This is used to keep meshes transformations so they can be restored
     * when we build back a Babylon Mesh
     * NB : All CSG operations are performed in world coordinates
     * @param csg The CSG to copy the transform attributes from
     * @returns This CSG
     */ copyTransformAttributes(csg) {
        this.matrix = csg.matrix;
        this.position = csg.position;
        this.rotation = csg.rotation;
        this.scaling = csg.scaling;
        this.rotationQuaternion = csg.rotationQuaternion;
        return this;
    }
    /**
     * Build vertex data from CSG
     * Coordinates here are in world space
     * @param onBeforePolygonProcessing called before each polygon is being processed
     * @param onAfterPolygonProcessing called after each polygon has been processed
     * @returns the final vertex data
     */ toVertexData(onBeforePolygonProcessing = null, onAfterPolygonProcessing = null) {
        const matrix = this.matrix.clone();
        matrix.invert();
        const polygons = this._polygons;
        const vertices = [];
        const indices = [];
        const normals = [];
        let uvs = null;
        let vertColors = null;
        const vertex = (0, $ha1VO.Vector3).Zero();
        const normal = (0, $ha1VO.Vector3).Zero();
        const uv = (0, $ha1VO.Vector2).Zero();
        const vertColor = new (0, $7etnY.Color4)(0, 0, 0, 0);
        const polygonIndices = [
            0,
            0,
            0
        ];
        const vertice_dict = {};
        let vertex_idx;
        for(let i = 0, il = polygons.length; i < il; i++){
            const polygon = polygons[i];
            if (onBeforePolygonProcessing) onBeforePolygonProcessing(polygon);
            for(let j = 2, jl = polygon.vertices.length; j < jl; j++){
                polygonIndices[0] = 0;
                polygonIndices[1] = j - 1;
                polygonIndices[2] = j;
                for(let k = 0; k < 3; k++){
                    vertex.copyFrom(polygon.vertices[polygonIndices[k]].pos);
                    normal.copyFrom(polygon.vertices[polygonIndices[k]].normal);
                    if (polygon.vertices[polygonIndices[k]].uv) {
                        if (!uvs) uvs = [];
                        uv.copyFrom(polygon.vertices[polygonIndices[k]].uv);
                    }
                    if (polygon.vertices[polygonIndices[k]].vertColor) {
                        if (!vertColors) vertColors = [];
                        vertColor.copyFrom(polygon.vertices[polygonIndices[k]].vertColor);
                    }
                    const localVertex = (0, $ha1VO.Vector3).TransformCoordinates(vertex, matrix);
                    const localNormal = (0, $ha1VO.Vector3).TransformNormal(normal, matrix);
                    vertex_idx = vertice_dict[localVertex.x + "," + localVertex.y + "," + localVertex.z];
                    let areUvsDifferent = false;
                    if (uvs && !(uvs[vertex_idx * 2] === uv.x || uvs[vertex_idx * 2 + 1] === uv.y)) areUvsDifferent = true;
                    let areColorsDifferent = false;
                    if (vertColors && !(vertColors[vertex_idx * 4] === vertColor.r || vertColors[vertex_idx * 4 + 1] === vertColor.g || vertColors[vertex_idx * 4 + 2] === vertColor.b || vertColors[vertex_idx * 4 + 3] === vertColor.a)) areColorsDifferent = true;
                    // Check if 2 points can be merged
                    if (!(typeof vertex_idx !== "undefined" && normals[vertex_idx * 3] === localNormal.x && normals[vertex_idx * 3 + 1] === localNormal.y && normals[vertex_idx * 3 + 2] === localNormal.z) || areUvsDifferent || areColorsDifferent) {
                        vertices.push(localVertex.x, localVertex.y, localVertex.z);
                        if (uvs) uvs.push(uv.x, uv.y);
                        normals.push(normal.x, normal.y, normal.z);
                        if (vertColors) vertColors.push(vertColor.r, vertColor.g, vertColor.b, vertColor.a);
                        vertex_idx = vertice_dict[localVertex.x + "," + localVertex.y + "," + localVertex.z] = vertices.length / 3 - 1;
                    }
                    indices.push(vertex_idx);
                    if (onAfterPolygonProcessing) onAfterPolygonProcessing();
                }
            }
        }
        const result = new (0, $5v6ry.VertexData)();
        result.positions = vertices;
        result.normals = normals;
        if (uvs) result.uvs = uvs;
        if (vertColors) result.colors = vertColors;
        result.indices = indices;
        return result;
    }
    /**
     * Build Raw mesh from CSG
     * Coordinates here are in world space
     * @param name The name of the mesh geometry
     * @param scene The Scene
     * @param keepSubMeshes Specifies if the submeshes should be kept
     * @returns A new Mesh
     */ buildMeshGeometry(name, scene, keepSubMeshes) {
        const mesh = new (0, $fbuqw.Mesh)(name, scene);
        const polygons = this._polygons;
        let currentIndex = 0;
        const subMeshDict = {};
        let subMeshObj;
        if (keepSubMeshes) // Sort Polygons, since subMeshes are indices range
        polygons.sort((a, b)=>{
            if (a.shared.meshId === b.shared.meshId) return a.shared.subMeshId - b.shared.subMeshId;
            else return a.shared.meshId - b.shared.meshId;
        });
        const vertexData = this.toVertexData((polygon)=>{
            // Building SubMeshes
            if (!subMeshDict[polygon.shared.meshId]) subMeshDict[polygon.shared.meshId] = {};
            if (!subMeshDict[polygon.shared.meshId][polygon.shared.subMeshId]) subMeshDict[polygon.shared.meshId][polygon.shared.subMeshId] = {
                indexStart: Infinity,
                indexEnd: -Infinity,
                materialIndex: polygon.shared.materialIndex
            };
            subMeshObj = subMeshDict[polygon.shared.meshId][polygon.shared.subMeshId];
        }, ()=>{
            subMeshObj.indexStart = Math.min(currentIndex, subMeshObj.indexStart);
            subMeshObj.indexEnd = Math.max(currentIndex, subMeshObj.indexEnd);
            currentIndex++;
        });
        vertexData.applyToMesh(mesh);
        if (keepSubMeshes) {
            // We offset the materialIndex by the previous number of materials in the CSG mixed meshes
            let materialIndexOffset = 0, materialMaxIndex;
            mesh.subMeshes = [];
            for(const m in subMeshDict){
                materialMaxIndex = -1;
                for(const sm in subMeshDict[m]){
                    subMeshObj = subMeshDict[m][sm];
                    (0, $lEBSs.SubMesh).CreateFromIndices(subMeshObj.materialIndex + materialIndexOffset, subMeshObj.indexStart, subMeshObj.indexEnd - subMeshObj.indexStart + 1, mesh);
                    materialMaxIndex = Math.max(subMeshObj.materialIndex, materialMaxIndex);
                }
                materialIndexOffset += ++materialMaxIndex;
            }
        }
        return mesh;
    }
    /**
     * Build Mesh from CSG taking material and transforms into account
     * @param name The name of the Mesh
     * @param material The material of the Mesh
     * @param scene The Scene
     * @param keepSubMeshes Specifies if submeshes should be kept
     * @returns The new Mesh
     */ toMesh(name, material = null, scene, keepSubMeshes) {
        const mesh = this.buildMeshGeometry(name, scene, keepSubMeshes);
        mesh.material = material;
        mesh.position.copyFrom(this.position);
        mesh.rotation.copyFrom(this.rotation);
        if (this.rotationQuaternion) mesh.rotationQuaternion = this.rotationQuaternion.clone();
        mesh.scaling.copyFrom(this.scaling);
        mesh.computeWorldMatrix(true);
        return mesh;
    }
}

});

parcelRegister("c2cCF", function(module, exports) {

$parcel$export(module.exports, "MeshUVSpaceRenderer", () => $8c2f76854e570ca6$export$d679e17c76a311f0);

var $ha1VO = parcelRequire("ha1VO");

var $4I7rl = parcelRequire("4I7rl");

var $gQtNK = parcelRequire("gQtNK");

var $7etnY = parcelRequire("7etnY");

var $cFdBb = parcelRequire("cFdBb");
parcelRequire("dJGp2");
parcelRequire("cUAkp");
parcelRequire("bgouw");
parcelRequire("gh3bN");
parcelRequire("lC61Y");
parcelRequire("aHKW2");
class $8c2f76854e570ca6$export$d679e17c76a311f0 {
    static _GetShader(scene) {
        if (!scene._meshUVSpaceRendererShader) {
            const shader = new (0, $4I7rl.ShaderMaterial)("meshUVSpaceRendererShader", scene, {
                vertex: "meshUVSpaceRenderer",
                fragment: "meshUVSpaceRenderer"
            }, {
                attributes: [
                    "position",
                    "normal",
                    "uv"
                ],
                uniforms: [
                    "world",
                    "projMatrix"
                ],
                samplers: [
                    "textureSampler"
                ],
                needAlphaBlending: true
            });
            shader.backFaceCulling = false;
            shader.alphaMode = 2;
            scene.onDisposeObservable.add(()=>{
                scene._meshUVSpaceRendererShader?.dispose();
                scene._meshUVSpaceRendererShader = null;
            });
            scene._meshUVSpaceRendererShader = shader;
        }
        return scene._meshUVSpaceRendererShader;
    }
    static _GetMaskShader(scene) {
        if (!scene._meshUVSpaceRendererMaskShader) {
            const shader = new (0, $4I7rl.ShaderMaterial)("meshUVSpaceRendererMaskShader", scene, {
                vertex: "meshUVSpaceRendererMasker",
                fragment: "meshUVSpaceRendererMasker"
            }, {
                attributes: [
                    "position",
                    "uv"
                ],
                uniforms: [
                    "worldViewProjection"
                ]
            });
            shader.backFaceCulling = false;
            shader.alphaMode = 2;
            scene.onDisposeObservable.add(()=>{
                scene._meshUVSpaceRendererMaskShader?.dispose();
                scene._meshUVSpaceRendererMaskShader = null;
            });
            scene._meshUVSpaceRendererMaskShader = shader;
        }
        return scene._meshUVSpaceRendererMaskShader;
    }
    static _IsRenderTargetTexture(texture) {
        return texture.renderList !== undefined;
    }
    /**
     * Creates a new MeshUVSpaceRenderer
     * @param mesh The mesh used for the source UV space
     * @param scene The scene the mesh belongs to
     * @param options The options to use when creating the texture
     */ constructor(mesh, scene, options){
        this._textureCreatedInternally = false;
        this._configureUserCreatedTexture = true;
        this._maskTexture = null;
        this._finalPostProcess = null;
        /**
         * Clear color of the texture
         */ this.clearColor = new (0, $7etnY.Color4)(0, 0, 0, 0);
        this._mesh = mesh;
        this._scene = scene;
        this._options = {
            width: 1024,
            height: 1024,
            textureType: 0,
            generateMipMaps: true,
            optimizeUVAllocation: true,
            uvEdgeBlending: false,
            ...options
        };
    }
    /**
     * Checks if the texture is ready to be used
     * @returns true if the texture is ready to be used
     */ isReady() {
        if (!this.texture) this._createDiffuseRTT();
        const textureIsReady = $8c2f76854e570ca6$export$d679e17c76a311f0._IsRenderTargetTexture(this.texture) ? this.texture.isReadyForRendering() : this.texture.isReady();
        const maskIsReady = this._maskTexture?.isReadyForRendering() ?? true;
        const postProcessIsReady = this._finalPostProcess?.isReady() ?? true;
        return textureIsReady && maskIsReady && postProcessIsReady;
    }
    /**
     * Projects and renders a texture in the mesh UV space
     * @param texture The texture
     * @param position The position of the center of projection (world space coordinates)
     * @param normal The direction of the projection (world space coordinates)
     * @param size The size of the projection
     * @param angle The rotation angle around the direction of the projection
     */ renderTexture(texture, position, normal, size, angle = 0) {
        if (!this.texture) this._createDiffuseRTT();
        else if (this._configureUserCreatedTexture) this._configureUserCreatedRTT();
        if ($8c2f76854e570ca6$export$d679e17c76a311f0._IsRenderTargetTexture(this.texture)) {
            const matrix = this._createProjectionMatrix(position, normal, size, angle);
            const shader = $8c2f76854e570ca6$export$d679e17c76a311f0._GetShader(this._scene);
            shader.setTexture("textureSampler", texture);
            shader.setMatrix("projMatrix", matrix);
            this.texture.render();
        }
    }
    /**
     * Clears the texture map
     */ clear() {
        if ($8c2f76854e570ca6$export$d679e17c76a311f0._IsRenderTargetTexture(this.texture) && this.texture.renderTarget) {
            const engine = this._scene.getEngine();
            engine.bindFramebuffer(this.texture.renderTarget);
            engine.clear(this.clearColor, true, true, true);
            engine.unBindFramebuffer(this.texture.renderTarget);
        }
        if (this._finalPostProcess?.inputTexture) {
            const engine = this._scene.getEngine();
            engine.bindFramebuffer(this._finalPostProcess?.inputTexture);
            engine.clear(this.clearColor, true, true, true);
            engine.unBindFramebuffer(this._finalPostProcess?.inputTexture);
        }
    }
    /**
     * Disposes of the resources
     */ dispose() {
        if (this._textureCreatedInternally) {
            this.texture.dispose();
            this._textureCreatedInternally = false;
        }
        this._configureUserCreatedTexture = true;
        this._maskTexture?.dispose();
        this._maskTexture = null;
        this._finalPostProcess?.dispose();
        this._finalPostProcess = null;
    }
    _configureUserCreatedRTT() {
        this._configureUserCreatedTexture = false;
        if ($8c2f76854e570ca6$export$d679e17c76a311f0._IsRenderTargetTexture(this.texture)) {
            this.texture.setMaterialForRendering(this._mesh, $8c2f76854e570ca6$export$d679e17c76a311f0._GetShader(this._scene));
            this.texture.onClearObservable.add(()=>{});
            this.texture.renderList = [
                this._mesh
            ];
            if (this._options.uvEdgeBlending) {
                this._createMaskTexture();
                this._createPostProcess();
                this.texture.addPostProcess(this._finalPostProcess);
            }
        }
    }
    _createDiffuseRTT() {
        this._textureCreatedInternally = true;
        const texture = this._createRenderTargetTexture(this._options.width, this._options.height);
        texture.setMaterialForRendering(this._mesh, $8c2f76854e570ca6$export$d679e17c76a311f0._GetShader(this._scene));
        this.texture = texture;
        this._configureUserCreatedTexture = false;
        if (this._options.uvEdgeBlending) {
            this._createMaskTexture();
            this._createPostProcess();
            texture.addPostProcess(this._finalPostProcess);
        }
    }
    _createMaskTexture() {
        if (this._maskTexture) return;
        this._maskTexture = new (0, $gQtNK.RenderTargetTexture)(this._mesh.name + "_maskTexture", {
            width: this._options.width,
            height: this._options.height
        }, this._scene, false, true, 0, false, 2, undefined, undefined, undefined, 6);
        this._maskTexture.clearColor = new (0, $7etnY.Color4)(0, 0, 0, 0);
        // Render the mesh with the mask material to the mask texture
        this._maskTexture.renderList.push(this._mesh);
        this._maskTexture.setMaterialForRendering(this._mesh, $8c2f76854e570ca6$export$d679e17c76a311f0._GetMaskShader(this._scene));
        // Ensure the mask texture is updated
        this._maskTexture.refreshRate = (0, $gQtNK.RenderTargetTexture).REFRESHRATE_RENDER_ONCE;
        this._scene.customRenderTargets.push(this._maskTexture);
    }
    _createPostProcess() {
        if (this._finalPostProcess) return;
        this._finalPostProcess = new (0, $cFdBb.PostProcess)(this._mesh.name + "_fixSeamsPostProcess", "meshUVSpaceRendererFinaliser", [
            "textureSize"
        ], [
            "textureSampler",
            "maskTextureSampler"
        ], 1.0, null, 1, this._scene.getEngine(), false, null, this._options.textureType);
        this._finalPostProcess.onApplyObservable.add((effect)=>{
            effect.setTexture("maskTextureSampler", this._maskTexture);
            effect.setFloat2("textureSize", this._options.width, this._options.height);
        });
    }
    _createRenderTargetTexture(width, height) {
        const rtt = new (0, $gQtNK.RenderTargetTexture)(this._mesh.name + "_uvspaceTexture", {
            width: width,
            height: height
        }, this._scene, this._options.generateMipMaps, true, this._options.textureType, false, this._options.generateMipMaps ? 3 : 2, false, false, false, 5);
        rtt.renderParticles = false;
        rtt.optimizeUVAllocation = !!this._options.optimizeUVAllocation;
        rtt.onClearObservable.addOnce(()=>{
            this._scene.getEngine().clear(this.clearColor, true, true, true);
            rtt.onClearObservable.add(()=>{}); // this disables clearing the texture for the next frames
        });
        rtt.renderList = [
            this._mesh
        ];
        return rtt;
    }
    _createProjectionMatrix(position, normal, size, angle = 0) {
        const yaw = -Math.atan2(normal.z, normal.x) - Math.PI / 2;
        const len = Math.sqrt(normal.x * normal.x + normal.z * normal.z);
        const pitch = Math.atan2(normal.y, len);
        const p = position.add(normal.scale(size.z * 0.5));
        const projWorldMatrix = (0, $ha1VO.Matrix).RotationYawPitchRoll(yaw, pitch, angle).multiply((0, $ha1VO.Matrix).Translation(p.x, p.y, p.z));
        const inverseProjWorldMatrix = (0, $ha1VO.Matrix).Invert(projWorldMatrix);
        const projMatrix = (0, $ha1VO.Matrix).FromArray([
            2 / size.x,
            0,
            0,
            0,
            0,
            2 / size.y,
            0,
            0,
            0,
            0,
            1 / size.z,
            0,
            0,
            0,
            0,
            1
        ]);
        const screenMatrix = (0, $ha1VO.Matrix).FromArray([
            0.5,
            0,
            0,
            0,
            0,
            0.5,
            0,
            0,
            0,
            0,
            1,
            0,
            0.5,
            0.5,
            0.0,
            1
        ]);
        return inverseProjWorldMatrix.multiply(projMatrix).multiply(screenMatrix);
    }
}

});
parcelRegister("dJGp2", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("7PW7m");
parcelRequire("8kYMw");
parcelRequire("5Eb4I");
parcelRequire("9H5jp");
parcelRequire("k3wwH");
parcelRequire("9ulLS");
parcelRequire("LFrAO");
parcelRequire("apKdp");
parcelRequire("4idCt");
parcelRequire("cIweX");
const $a0005ea966a1feed$var$name = "meshUVSpaceRendererVertexShader";
const $a0005ea966a1feed$var$shader = `precision highp float;attribute vec3 position;attribute vec3 normal;attribute vec2 uv;uniform mat4 projMatrix;varying vec2 vDecalTC;
#include<bonesDeclaration>
#include<bakedVertexAnimationDeclaration>
#include<morphTargetsVertexGlobalDeclaration>
#include<morphTargetsVertexDeclaration>[0..maxSimultaneousMorphTargets]
#include<instancesDeclaration>
void main(void) {vec3 positionUpdated=position;vec3 normalUpdated=normal;
#include<morphTargetsVertexGlobal>
#include<morphTargetsVertex>[0..maxSimultaneousMorphTargets]
#include<instancesVertex>
#include<bonesVertex>
#include<bakedVertexAnimation>
vec4 worldPos=finalWorld*vec4(positionUpdated,1.0);mat3 normWorldSM=mat3(finalWorld);vec3 vNormalW;
#if defined(INSTANCES) && defined(THIN_INSTANCES)
vNormalW=normalUpdated/vec3(dot(normWorldSM[0],normWorldSM[0]),dot(normWorldSM[1],normWorldSM[1]),dot(normWorldSM[2],normWorldSM[2]));vNormalW=normalize(normWorldSM*vNormalW);
#else
#ifdef NONUNIFORMSCALING
normWorldSM=transposeMat3(inverseMat3(normWorldSM));
#endif
vNormalW=normalize(normWorldSM*normalUpdated);
#endif
vec3 normalView=normalize((projMatrix*vec4(vNormalW,0.0)).xyz);vec3 decalTC=(projMatrix*worldPos).xyz;vDecalTC=decalTC.xy;gl_Position=vec4(uv*2.0-1.0,normalView.z>0.0 ? 2. : decalTC.z,1.0);}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$a0005ea966a1feed$var$name] = $a0005ea966a1feed$var$shader;
const $a0005ea966a1feed$export$e25a5c3bbc1f42fb = {
    name: $a0005ea966a1feed$var$name,
    shader: $a0005ea966a1feed$var$shader
};

});

parcelRegister("cUAkp", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $9666e504bba3e3d7$var$name = "meshUVSpaceRendererPixelShader";
const $9666e504bba3e3d7$var$shader = `precision highp float;varying vec2 vDecalTC;uniform sampler2D textureSampler;void main(void) {if (vDecalTC.x<0. || vDecalTC.x>1. || vDecalTC.y<0. || vDecalTC.y>1.) {discard;}
gl_FragColor=texture2D(textureSampler,vDecalTC);}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$9666e504bba3e3d7$var$name] = $9666e504bba3e3d7$var$shader;
const $9666e504bba3e3d7$export$591be1ac00cbb6ac = {
    name: $9666e504bba3e3d7$var$name,
    shader: $9666e504bba3e3d7$var$shader
};

});

parcelRegister("bgouw", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $83342fc4d425af9e$var$name = "meshUVSpaceRendererMaskerVertexShader";
const $83342fc4d425af9e$var$shader = `attribute vec2 uv;varying vec2 vUV;void main(void) {gl_Position=vec4(vec2(uv.x,uv.y)*2.0-1.0,0.,1.0);vUV=uv;}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$83342fc4d425af9e$var$name] = $83342fc4d425af9e$var$shader;
const $83342fc4d425af9e$export$6418cd687e8a8dba = {
    name: $83342fc4d425af9e$var$name,
    shader: $83342fc4d425af9e$var$shader
};

});

parcelRegister("gh3bN", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $bd90b530839c1ede$var$name = "meshUVSpaceRendererMaskerPixelShader";
const $bd90b530839c1ede$var$shader = `varying vec2 vUV;void main(void) {gl_FragColor=vec4(1.0,1.0,1.0,1.0);}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$bd90b530839c1ede$var$name] = $bd90b530839c1ede$var$shader;
const $bd90b530839c1ede$export$ea474382095c9f65 = {
    name: $bd90b530839c1ede$var$name,
    shader: $bd90b530839c1ede$var$shader
};

});

parcelRegister("lC61Y", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $fbc1d3330f1ff432$var$name = "meshUVSpaceRendererFinaliserPixelShader";
const $fbc1d3330f1ff432$var$shader = `precision highp float;varying vec2 vUV;uniform sampler2D textureSampler;uniform sampler2D maskTextureSampler;uniform vec2 textureSize;void main() {vec4 mask=texture2D(maskTextureSampler,vUV).rgba;if (mask.r>0.5) {gl_FragColor=texture2D(textureSampler,vUV);} else {vec2 texelSize=4.0/textureSize;vec2 uv_p01=vUV+vec2(-1.0,0.0)*texelSize;vec2 uv_p21=vUV+vec2(1.0,0.0)*texelSize;vec2 uv_p10=vUV+vec2(0.0,-1.0)*texelSize;vec2 uv_p12=vUV+vec2(0.0,1.0)*texelSize;float mask_p01=texture2D(maskTextureSampler,uv_p01).r;float mask_p21=texture2D(maskTextureSampler,uv_p21).r;float mask_p10=texture2D(maskTextureSampler,uv_p10).r;float mask_p12=texture2D(maskTextureSampler,uv_p12).r;vec4 col=vec4(0.0,0.0,0.0,0.0);float total_weight=0.0;if (mask_p01>0.5) {col+=texture2D(textureSampler,uv_p01);total_weight+=1.0;}
if (mask_p21>0.5) {col+=texture2D(textureSampler,uv_p21);total_weight+=1.0;}
if (mask_p10>0.5) {col+=texture2D(textureSampler,uv_p10);total_weight+=1.0;}
if (mask_p12>0.5) {col+=texture2D(textureSampler,uv_p12);total_weight+=1.0;}
if (total_weight>0.0) {gl_FragColor=col/total_weight;} else {gl_FragColor=col;}}}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$fbc1d3330f1ff432$var$name] = $fbc1d3330f1ff432$var$shader;
const $fbc1d3330f1ff432$export$862389715b29e0b = {
    name: $fbc1d3330f1ff432$var$name,
    shader: $fbc1d3330f1ff432$var$shader
};

});

parcelRegister("aHKW2", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $7cb253dccab1db12$var$name = "meshUVSpaceRendererFinaliserVertexShader";
const $7cb253dccab1db12$var$shader = `precision highp float;attribute vec3 position;attribute vec2 uv;uniform mat4 worldViewProjection;varying vec2 vUV;void main() {gl_Position=worldViewProjection*vec4(position,1.0);vUV=uv;}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$7cb253dccab1db12$var$name] = $7cb253dccab1db12$var$shader;
const $7cb253dccab1db12$export$3be07b147dc16ade = {
    name: $7cb253dccab1db12$var$name,
    shader: $7cb253dccab1db12$var$shader
};

});


parcelRegister("8nuZn", function(module, exports) {

$parcel$export(module.exports, "TrailMesh", () => $619882746df419d1$export$2dc4fa9720108c23);

var $0cHNL = parcelRequire("0cHNL");

var $fbuqw = parcelRequire("fbuqw");

var $ha1VO = parcelRequire("ha1VO");

var $b4i1f = parcelRequire("b4i1f");

var $5v6ry = parcelRequire("5v6ry");
(0, $fbuqw.Mesh)._TrailMeshParser = (parsedMesh, scene)=>{
    return $619882746df419d1$export$2dc4fa9720108c23.Parse(parsedMesh, scene);
};
class $619882746df419d1$export$2dc4fa9720108c23 extends (0, $fbuqw.Mesh) {
    /**
     * Creates a new TrailMesh.
     * @param name The value used by scene.getMeshByName() to do a lookup.
     * @param generator The mesh or transform node to generate a trail.
     * @param scene The scene to add this mesh to.
     * @param diameter Diameter of trailing mesh. Default is 1.
     * @param length Length of trailing mesh. Default is 60.
     * @param autoStart Automatically start trailing mesh. Default true.
     */ constructor(name, generator, scene, diameter = 1, length = 60, autoStart = true){
        super(name, scene);
        this._sectionPolygonPointsCount = 4;
        this._running = false;
        this._autoStart = autoStart;
        this._generator = generator;
        this.diameter = diameter;
        this._length = length;
        this._sectionVectors = [];
        this._sectionNormalVectors = [];
        for(let i = 0; i <= this._sectionPolygonPointsCount; i++){
            this._sectionVectors[i] = (0, $ha1VO.Vector3).Zero();
            this._sectionNormalVectors[i] = (0, $ha1VO.Vector3).Zero();
        }
        this._createMesh();
    }
    /**
     * "TrailMesh"
     * @returns "TrailMesh"
     */ getClassName() {
        return "TrailMesh";
    }
    _createMesh() {
        const data = new (0, $5v6ry.VertexData)();
        const positions = [];
        const normals = [];
        const indices = [];
        const uvs = [];
        let meshCenter = (0, $ha1VO.Vector3).Zero();
        if (this._generator instanceof (0, $0cHNL.AbstractMesh) && this._generator.hasBoundingInfo) meshCenter = this._generator.getBoundingInfo().boundingBox.centerWorld;
        else meshCenter = this._generator.absolutePosition;
        const alpha = 2 * Math.PI / this._sectionPolygonPointsCount;
        for(let i = 0; i <= this._sectionPolygonPointsCount; i++){
            const angle = i !== this._sectionPolygonPointsCount ? i * alpha : 0;
            positions.push(meshCenter.x + Math.cos(angle) * this.diameter, meshCenter.y + Math.sin(angle) * this.diameter, meshCenter.z);
            uvs.push(i / this._sectionPolygonPointsCount, 0);
        }
        for(let i = 1; i <= this._length; i++){
            for(let j = 0; j <= this._sectionPolygonPointsCount; j++){
                const angle = j !== this._sectionPolygonPointsCount ? j * alpha : 0;
                positions.push(meshCenter.x + Math.cos(angle) * this.diameter, meshCenter.y + Math.sin(angle) * this.diameter, meshCenter.z);
                uvs.push(j / this._sectionPolygonPointsCount, i / this._length);
            }
            const l = positions.length / 3 - 2 * (this._sectionPolygonPointsCount + 1);
            for(let j = 0; j <= this._sectionPolygonPointsCount; j++){
                indices.push(l + j, l + j + this._sectionPolygonPointsCount, l + j + this._sectionPolygonPointsCount + 1);
                indices.push(l + j, l + j + this._sectionPolygonPointsCount + 1, l + j + 1);
            }
        }
        (0, $5v6ry.VertexData).ComputeNormals(positions, indices, normals);
        data.positions = positions;
        data.normals = normals;
        data.indices = indices;
        data.uvs = uvs;
        data.applyToMesh(this, true);
        if (this._autoStart) this.start();
    }
    /**
     * Start trailing mesh.
     */ start() {
        if (!this._running) {
            this._running = true;
            this._beforeRenderObserver = this.getScene().onBeforeRenderObservable.add(()=>{
                this.update();
            });
        }
    }
    /**
     * Stop trailing mesh.
     */ stop() {
        if (this._beforeRenderObserver && this._running) {
            this._running = false;
            this.getScene().onBeforeRenderObservable.remove(this._beforeRenderObserver);
        }
    }
    /**
     * Update trailing mesh geometry.
     */ update() {
        const positions = this.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        const normals = this.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind);
        const wm = this._generator.getWorldMatrix();
        if (positions && normals) {
            for(let i = 3 * (this._sectionPolygonPointsCount + 1); i < positions.length; i++)positions[i - 3 * (this._sectionPolygonPointsCount + 1)] = positions[i] - normals[i] / this._length * this.diameter;
            for(let i = 3 * (this._sectionPolygonPointsCount + 1); i < normals.length; i++)normals[i - 3 * (this._sectionPolygonPointsCount + 1)] = normals[i];
            const l = positions.length - 3 * (this._sectionPolygonPointsCount + 1);
            const alpha = 2 * Math.PI / this._sectionPolygonPointsCount;
            for(let i = 0; i <= this._sectionPolygonPointsCount; i++){
                const angle = i !== this._sectionPolygonPointsCount ? i * alpha : 0;
                this._sectionVectors[i].copyFromFloats(Math.cos(angle) * this.diameter, Math.sin(angle) * this.diameter, 0);
                this._sectionNormalVectors[i].copyFromFloats(Math.cos(angle), Math.sin(angle), 0);
                (0, $ha1VO.Vector3).TransformCoordinatesToRef(this._sectionVectors[i], wm, this._sectionVectors[i]);
                (0, $ha1VO.Vector3).TransformNormalToRef(this._sectionNormalVectors[i], wm, this._sectionNormalVectors[i]);
            }
            for(let i = 0; i <= this._sectionPolygonPointsCount; i++){
                positions[l + 3 * i] = this._sectionVectors[i].x;
                positions[l + 3 * i + 1] = this._sectionVectors[i].y;
                positions[l + 3 * i + 2] = this._sectionVectors[i].z;
                normals[l + 3 * i] = this._sectionNormalVectors[i].x;
                normals[l + 3 * i + 1] = this._sectionNormalVectors[i].y;
                normals[l + 3 * i + 2] = this._sectionNormalVectors[i].z;
            }
            this.updateVerticesData((0, $b4i1f.VertexBuffer).PositionKind, positions, true, false);
            this.updateVerticesData((0, $b4i1f.VertexBuffer).NormalKind, normals, true, false);
        }
    }
    /**
     * Returns a new TrailMesh object.
     * @param name is a string, the name given to the new mesh
     * @param newGenerator use new generator object for cloned trail mesh
     * @returns a new mesh
     */ clone(name = "", newGenerator) {
        return new $619882746df419d1$export$2dc4fa9720108c23(name, newGenerator ?? this._generator, this.getScene(), this.diameter, this._length, this._autoStart);
    }
    /**
     * Serializes this trail mesh
     * @param serializationObject object to write serialization to
     */ serialize(serializationObject) {
        super.serialize(serializationObject);
        serializationObject.generatorId = this._generator.id;
    }
    /**
     * Parses a serialized trail mesh
     * @param parsedMesh the serialized mesh
     * @param scene the scene to create the trail mesh in
     * @returns the created trail mesh
     */ static Parse(parsedMesh, scene) {
        const generator = scene.getLastMeshById(parsedMesh.generatorId) ?? scene.getLastTransformNodeById(parsedMesh.generatorId);
        if (!generator) throw new Error("TrailMesh: generator not found with ID " + parsedMesh.generatorId);
        return new $619882746df419d1$export$2dc4fa9720108c23(parsedMesh.name, generator, scene, parsedMesh.diameter ?? parsedMesh._diameter, parsedMesh._length, parsedMesh._autoStart);
    }
}

});

parcelRegister("fl174", function(module, exports) {

$parcel$export(module.exports, "SimplificationSettings", () => $b2a9ae33dd41f237$export$9d119d25a5f83d47);
$parcel$export(module.exports, "SimplificationQueue", () => $b2a9ae33dd41f237$export$3aabe67e0970e9a5);
$parcel$export(module.exports, "SimplificationType", () => $b2a9ae33dd41f237$export$aaccfb30a4b44b8e);
$parcel$export(module.exports, "QuadraticErrorSimplification", () => $b2a9ae33dd41f237$export$7b857e93090b72a6);

var $ha1VO = parcelRequire("ha1VO");

var $b4i1f = parcelRequire("b4i1f");

var $lEBSs = parcelRequire("lEBSs");

var $fbuqw = parcelRequire("fbuqw");

var $bOhSV = parcelRequire("bOhSV");

var $53VPf = parcelRequire("53VPf");
class $b2a9ae33dd41f237$export$9d119d25a5f83d47 {
    /**
     * Creates a SimplificationSettings
     * @param quality expected quality
     * @param distance distance when this optimized version should be used
     * @param optimizeMesh already optimized mesh
     */ constructor(/** expected quality */ quality, /** distance when this optimized version should be used */ distance, /** already optimized mesh  */ optimizeMesh){
        this.quality = quality;
        this.distance = distance;
        this.optimizeMesh = optimizeMesh;
    }
}
class $b2a9ae33dd41f237$export$3aabe67e0970e9a5 {
    /**
     * Creates a new queue
     */ constructor(){
        this.running = false;
        this._simplificationArray = [];
    }
    /**
     * Adds a new simplification task
     * @param task defines a task to add
     */ addTask(task) {
        this._simplificationArray.push(task);
    }
    /**
     * Execute next task
     */ executeNext() {
        const task = this._simplificationArray.pop();
        if (task) {
            this.running = true;
            this.runSimplification(task);
        } else this.running = false;
    }
    /**
     * Execute a simplification task
     * @param task defines the task to run
     */ runSimplification(task) {
        if (task.parallelProcessing) //parallel simplifier
        task.settings.forEach((setting)=>{
            const simplifier = this._getSimplifier(task);
            simplifier.simplify(setting, (newMesh)=>{
                if (setting.distance !== undefined) task.mesh.addLODLevel(setting.distance, newMesh);
                newMesh.isVisible = true;
                //check if it is the last
                if (setting.quality === task.settings[task.settings.length - 1].quality && task.successCallback) //all done, run the success callback.
                task.successCallback();
                this.executeNext();
            });
        });
        else {
            //single simplifier.
            const simplifier = this._getSimplifier(task);
            const runDecimation = (setting, callback)=>{
                simplifier.simplify(setting, (newMesh)=>{
                    if (setting.distance !== undefined) task.mesh.addLODLevel(setting.distance, newMesh);
                    newMesh.isVisible = true;
                    //run the next quality level
                    callback();
                });
            };
            (0, $bOhSV.AsyncLoop).Run(task.settings.length, (loop)=>{
                runDecimation(task.settings[loop.index], ()=>{
                    loop.executeNext();
                });
            }, ()=>{
                //execution ended, run the success callback.
                if (task.successCallback) task.successCallback();
                this.executeNext();
            });
        }
    }
    _getSimplifier(task) {
        switch(task.simplificationType){
            case $b2a9ae33dd41f237$export$aaccfb30a4b44b8e.QUADRATIC:
            default:
                return new $b2a9ae33dd41f237$export$7b857e93090b72a6(task.mesh);
        }
    }
}
var $b2a9ae33dd41f237$export$aaccfb30a4b44b8e;
(function(SimplificationType) {
    /** Quadratic error decimation */ SimplificationType[SimplificationType["QUADRATIC"] = 0] = "QUADRATIC";
})($b2a9ae33dd41f237$export$aaccfb30a4b44b8e || ($b2a9ae33dd41f237$export$aaccfb30a4b44b8e = {}));
class $b2a9ae33dd41f237$var$DecimationTriangle {
    constructor(_vertices){
        this._vertices = _vertices;
        this.error = new Array(4);
        this.deleted = false;
        this.isDirty = false;
        this.deletePending = false;
        this.borderFactor = 0;
    }
}
class $b2a9ae33dd41f237$var$DecimationVertex {
    constructor(position, id){
        this.position = position;
        this.id = id;
        this.isBorder = true;
        this.q = new $b2a9ae33dd41f237$var$QuadraticMatrix();
        this.triangleCount = 0;
        this.triangleStart = 0;
        this.originalOffsets = [];
    }
    updatePosition(newPosition) {
        this.position.copyFrom(newPosition);
    }
}
class $b2a9ae33dd41f237$var$QuadraticMatrix {
    constructor(data){
        this.data = new Array(10);
        for(let i = 0; i < 10; ++i)if (data && data[i]) this.data[i] = data[i];
        else this.data[i] = 0;
    }
    det(a11, a12, a13, a21, a22, a23, a31, a32, a33) {
        const det = this.data[a11] * this.data[a22] * this.data[a33] + this.data[a13] * this.data[a21] * this.data[a32] + this.data[a12] * this.data[a23] * this.data[a31] - this.data[a13] * this.data[a22] * this.data[a31] - this.data[a11] * this.data[a23] * this.data[a32] - this.data[a12] * this.data[a21] * this.data[a33];
        return det;
    }
    addInPlace(matrix) {
        for(let i = 0; i < 10; ++i)this.data[i] += matrix.data[i];
    }
    addArrayInPlace(data) {
        for(let i = 0; i < 10; ++i)this.data[i] += data[i];
    }
    add(matrix) {
        const m = new $b2a9ae33dd41f237$var$QuadraticMatrix();
        for(let i = 0; i < 10; ++i)m.data[i] = this.data[i] + matrix.data[i];
        return m;
    }
    static FromData(a, b, c, d) {
        return new $b2a9ae33dd41f237$var$QuadraticMatrix($b2a9ae33dd41f237$var$QuadraticMatrix.DataFromNumbers(a, b, c, d));
    }
    //returning an array to avoid garbage collection
    static DataFromNumbers(a, b, c, d) {
        return [
            a * a,
            a * b,
            a * c,
            a * d,
            b * b,
            b * c,
            b * d,
            c * c,
            c * d,
            d * d
        ];
    }
}
class $b2a9ae33dd41f237$var$Reference {
    constructor(vertexId, triangleId){
        this.vertexId = vertexId;
        this.triangleId = triangleId;
    }
}
class $b2a9ae33dd41f237$export$7b857e93090b72a6 {
    /**
     * Creates a new QuadraticErrorSimplification
     * @param _mesh defines the target mesh
     */ constructor(_mesh){
        this._mesh = _mesh;
        /** Gets or sets the number pf sync iterations */ this.syncIterations = 5000;
        this.aggressiveness = 7;
        this.decimationIterations = 100;
        this.boundingBoxEpsilon = (0, $53VPf.Epsilon);
    }
    /**
     * Simplification of a given mesh according to the given settings.
     * Since this requires computation, it is assumed that the function runs async.
     * @param settings The settings of the simplification, including quality and distance
     * @param successCallback A callback that will be called after the mesh was simplified.
     */ simplify(settings, successCallback) {
        this._initDecimatedMesh();
        //iterating through the submeshes array, one after the other.
        (0, $bOhSV.AsyncLoop).Run(this._mesh.subMeshes.length, (loop)=>{
            this._initWithMesh(loop.index, ()=>{
                this._runDecimation(settings, loop.index, ()=>{
                    loop.executeNext();
                });
            }, settings.optimizeMesh);
        }, ()=>{
            setTimeout(()=>{
                successCallback(this._reconstructedMesh);
            }, 0);
        });
    }
    _runDecimation(settings, submeshIndex, successCallback) {
        const targetCount = ~~(this._triangles.length * settings.quality);
        let deletedTriangles = 0;
        const triangleCount = this._triangles.length;
        const iterationFunction = (iteration, callback)=>{
            setTimeout(()=>{
                if (iteration % 5 === 0) this._updateMesh(iteration === 0);
                for(let i = 0; i < this._triangles.length; ++i)this._triangles[i].isDirty = false;
                const threshold = 0.000000001 * Math.pow(iteration + 3, this.aggressiveness);
                const trianglesIterator = (i)=>{
                    const tIdx = ~~((this._triangles.length / 2 + i) % this._triangles.length);
                    const t = this._triangles[tIdx];
                    if (!t) return;
                    if (t.error[3] > threshold || t.deleted || t.isDirty) return;
                    for(let j = 0; j < 3; ++j)if (t.error[j] < threshold) {
                        const deleted0 = [];
                        const deleted1 = [];
                        const v0 = t._vertices[j];
                        const v1 = t._vertices[(j + 1) % 3];
                        if (v0.isBorder || v1.isBorder) continue;
                        const p = (0, $ha1VO.Vector3).Zero();
                        // var n = Vector3.Zero();
                        // var uv = Vector2.Zero();
                        // var color = new Color4(0, 0, 0, 1);
                        this._calculateError(v0, v1, p);
                        const delTr = [];
                        if (this._isFlipped(v0, v1, p, deleted0, delTr)) continue;
                        if (this._isFlipped(v1, v0, p, deleted1, delTr)) continue;
                        if (deleted0.indexOf(true) < 0 || deleted1.indexOf(true) < 0) continue;
                        const uniqueArray = [];
                        delTr.forEach((deletedT)=>{
                            if (uniqueArray.indexOf(deletedT) === -1) {
                                deletedT.deletePending = true;
                                uniqueArray.push(deletedT);
                            }
                        });
                        if (uniqueArray.length % 2 !== 0) continue;
                        v0.q = v1.q.add(v0.q);
                        v0.updatePosition(p);
                        const tStart = this._references.length;
                        deletedTriangles = this._updateTriangles(v0, v0, deleted0, deletedTriangles);
                        deletedTriangles = this._updateTriangles(v0, v1, deleted1, deletedTriangles);
                        const tCount = this._references.length - tStart;
                        if (tCount <= v0.triangleCount) {
                            if (tCount) for(let c = 0; c < tCount; c++)this._references[v0.triangleStart + c] = this._references[tStart + c];
                        } else v0.triangleStart = tStart;
                        v0.triangleCount = tCount;
                        break;
                    }
                };
                (0, $bOhSV.AsyncLoop).SyncAsyncForLoop(this._triangles.length, this.syncIterations, trianglesIterator, callback, ()=>{
                    return triangleCount - deletedTriangles <= targetCount;
                });
            }, 0);
        };
        (0, $bOhSV.AsyncLoop).Run(this.decimationIterations, (loop)=>{
            if (triangleCount - deletedTriangles <= targetCount) loop.breakLoop();
            else iterationFunction(loop.index, ()=>{
                loop.executeNext();
            });
        }, ()=>{
            setTimeout(()=>{
                //reconstruct this part of the mesh
                this._reconstructMesh(submeshIndex);
                successCallback();
            }, 0);
        });
    }
    _initWithMesh(submeshIndex, callback, optimizeMesh) {
        this._vertices = [];
        this._triangles = [];
        const positionData = this._mesh.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        const indices = this._mesh.getIndices();
        const submesh = this._mesh.subMeshes[submeshIndex];
        const findInVertices = (positionToSearch)=>{
            if (optimizeMesh) for(let ii = 0; ii < this._vertices.length; ++ii){
                if (this._vertices[ii].position.equalsWithEpsilon(positionToSearch, 0.0001)) return this._vertices[ii];
            }
            return null;
        };
        const vertexReferences = [];
        const vertexInit = (i)=>{
            if (!positionData) return;
            const offset = i + submesh.verticesStart;
            const position = (0, $ha1VO.Vector3).FromArray(positionData, offset * 3);
            const vertex = findInVertices(position) || new $b2a9ae33dd41f237$var$DecimationVertex(position, this._vertices.length);
            vertex.originalOffsets.push(offset);
            if (vertex.id === this._vertices.length) this._vertices.push(vertex);
            vertexReferences.push(vertex.id);
        };
        //var totalVertices = mesh.getTotalVertices();
        const totalVertices = submesh.verticesCount;
        (0, $bOhSV.AsyncLoop).SyncAsyncForLoop(totalVertices, this.syncIterations / 4 >> 0, vertexInit, ()=>{
            const indicesInit = (i)=>{
                if (!indices) return;
                const offset = submesh.indexStart / 3 + i;
                const pos = offset * 3;
                const i0 = indices[pos + 0];
                const i1 = indices[pos + 1];
                const i2 = indices[pos + 2];
                const v0 = this._vertices[vertexReferences[i0 - submesh.verticesStart]];
                const v1 = this._vertices[vertexReferences[i1 - submesh.verticesStart]];
                const v2 = this._vertices[vertexReferences[i2 - submesh.verticesStart]];
                const triangle = new $b2a9ae33dd41f237$var$DecimationTriangle([
                    v0,
                    v1,
                    v2
                ]);
                triangle.originalOffset = pos;
                this._triangles.push(triangle);
            };
            (0, $bOhSV.AsyncLoop).SyncAsyncForLoop(submesh.indexCount / 3, this.syncIterations, indicesInit, ()=>{
                this._init(callback);
            });
        });
    }
    _init(callback) {
        const triangleInit1 = (i)=>{
            const t = this._triangles[i];
            t.normal = (0, $ha1VO.Vector3).Cross(t._vertices[1].position.subtract(t._vertices[0].position), t._vertices[2].position.subtract(t._vertices[0].position)).normalize();
            for(let j = 0; j < 3; j++)t._vertices[j].q.addArrayInPlace($b2a9ae33dd41f237$var$QuadraticMatrix.DataFromNumbers(t.normal.x, t.normal.y, t.normal.z, -(0, $ha1VO.Vector3).Dot(t.normal, t._vertices[0].position)));
        };
        (0, $bOhSV.AsyncLoop).SyncAsyncForLoop(this._triangles.length, this.syncIterations, triangleInit1, ()=>{
            const triangleInit2 = (i)=>{
                const t = this._triangles[i];
                for(let j = 0; j < 3; ++j)t.error[j] = this._calculateError(t._vertices[j], t._vertices[(j + 1) % 3]);
                t.error[3] = Math.min(t.error[0], t.error[1], t.error[2]);
            };
            (0, $bOhSV.AsyncLoop).SyncAsyncForLoop(this._triangles.length, this.syncIterations, triangleInit2, ()=>{
                callback();
            });
        });
    }
    _reconstructMesh(submeshIndex) {
        const newTriangles = [];
        let i;
        for(i = 0; i < this._vertices.length; ++i)this._vertices[i].triangleCount = 0;
        let t;
        let j;
        for(i = 0; i < this._triangles.length; ++i)if (!this._triangles[i].deleted) {
            t = this._triangles[i];
            for(j = 0; j < 3; ++j)t._vertices[j].triangleCount = 1;
            newTriangles.push(t);
        }
        const newPositionData = this._reconstructedMesh.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind) || [];
        const newNormalData = this._reconstructedMesh.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind) || [];
        const newUVsData = this._reconstructedMesh.getVerticesData((0, $b4i1f.VertexBuffer).UVKind) || [];
        const newColorsData = this._reconstructedMesh.getVerticesData((0, $b4i1f.VertexBuffer).ColorKind) || [];
        const normalData = this._mesh.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind);
        const uvs = this._mesh.getVerticesData((0, $b4i1f.VertexBuffer).UVKind);
        const colorsData = this._mesh.getVerticesData((0, $b4i1f.VertexBuffer).ColorKind);
        let vertexCount = 0;
        for(i = 0; i < this._vertices.length; ++i){
            const vertex = this._vertices[i];
            vertex.id = vertexCount;
            if (vertex.triangleCount) vertex.originalOffsets.forEach((originalOffset)=>{
                newPositionData.push(vertex.position.x);
                newPositionData.push(vertex.position.y);
                newPositionData.push(vertex.position.z);
                if (normalData && normalData.length) {
                    newNormalData.push(normalData[originalOffset * 3]);
                    newNormalData.push(normalData[originalOffset * 3 + 1]);
                    newNormalData.push(normalData[originalOffset * 3 + 2]);
                }
                if (uvs && uvs.length) {
                    newUVsData.push(uvs[originalOffset * 2]);
                    newUVsData.push(uvs[originalOffset * 2 + 1]);
                }
                if (colorsData && colorsData.length) {
                    newColorsData.push(colorsData[originalOffset * 4]);
                    newColorsData.push(colorsData[originalOffset * 4 + 1]);
                    newColorsData.push(colorsData[originalOffset * 4 + 2]);
                    newColorsData.push(colorsData[originalOffset * 4 + 3]);
                }
                ++vertexCount;
            });
        }
        const startingIndex = this._reconstructedMesh.getTotalIndices();
        const startingVertex = this._reconstructedMesh.getTotalVertices();
        const submeshesArray = this._reconstructedMesh.subMeshes;
        this._reconstructedMesh.subMeshes = [];
        const newIndicesArray = this._reconstructedMesh.getIndices(); //[];
        const originalIndices = this._mesh.getIndices();
        for(i = 0; i < newTriangles.length; ++i){
            t = newTriangles[i]; //now get the new referencing point for each vertex
            [
                0,
                1,
                2
            ].forEach((idx)=>{
                const id = originalIndices[t.originalOffset + idx];
                let offset = t._vertices[idx].originalOffsets.indexOf(id);
                if (offset < 0) offset = 0;
                newIndicesArray.push(t._vertices[idx].id + offset + startingVertex);
            });
        }
        //overwriting the old vertex buffers and indices.
        this._reconstructedMesh.setIndices(newIndicesArray);
        this._reconstructedMesh.setVerticesData((0, $b4i1f.VertexBuffer).PositionKind, newPositionData);
        if (newNormalData.length > 0) this._reconstructedMesh.setVerticesData((0, $b4i1f.VertexBuffer).NormalKind, newNormalData);
        if (newUVsData.length > 0) this._reconstructedMesh.setVerticesData((0, $b4i1f.VertexBuffer).UVKind, newUVsData);
        if (newColorsData.length > 0) this._reconstructedMesh.setVerticesData((0, $b4i1f.VertexBuffer).ColorKind, newColorsData);
        //create submesh
        const originalSubmesh = this._mesh.subMeshes[submeshIndex];
        if (submeshIndex > 0) {
            this._reconstructedMesh.subMeshes = [];
            submeshesArray.forEach((submesh)=>{
                (0, $lEBSs.SubMesh).AddToMesh(submesh.materialIndex, submesh.verticesStart, submesh.verticesCount, /* 0, newPositionData.length/3, */ submesh.indexStart, submesh.indexCount, submesh.getMesh());
            });
            (0, $lEBSs.SubMesh).AddToMesh(originalSubmesh.materialIndex, startingVertex, vertexCount, /* 0, newPositionData.length / 3, */ startingIndex, newTriangles.length * 3, this._reconstructedMesh);
        }
    }
    _initDecimatedMesh() {
        this._reconstructedMesh = new (0, $fbuqw.Mesh)(this._mesh.name + "Decimated", this._mesh.getScene());
        this._reconstructedMesh.material = this._mesh.material;
        this._reconstructedMesh.parent = this._mesh.parent;
        this._reconstructedMesh.isVisible = false;
        this._reconstructedMesh.renderingGroupId = this._mesh.renderingGroupId;
    }
    _isFlipped(vertex1, vertex2, point, deletedArray, delTr) {
        for(let i = 0; i < vertex1.triangleCount; ++i){
            const t = this._triangles[this._references[vertex1.triangleStart + i].triangleId];
            if (t.deleted) continue;
            const s = this._references[vertex1.triangleStart + i].vertexId;
            const v1 = t._vertices[(s + 1) % 3];
            const v2 = t._vertices[(s + 2) % 3];
            if (v1 === vertex2 || v2 === vertex2) {
                deletedArray[i] = true;
                delTr.push(t);
                continue;
            }
            let d1 = v1.position.subtract(point);
            d1 = d1.normalize();
            let d2 = v2.position.subtract(point);
            d2 = d2.normalize();
            if (Math.abs((0, $ha1VO.Vector3).Dot(d1, d2)) > 0.999) return true;
            const normal = (0, $ha1VO.Vector3).Cross(d1, d2).normalize();
            deletedArray[i] = false;
            if ((0, $ha1VO.Vector3).Dot(normal, t.normal) < 0.2) return true;
        }
        return false;
    }
    _updateTriangles(origVertex, vertex, deletedArray, deletedTriangles) {
        let newDeleted = deletedTriangles;
        for(let i = 0; i < vertex.triangleCount; ++i){
            const ref = this._references[vertex.triangleStart + i];
            const t = this._triangles[ref.triangleId];
            if (t.deleted) continue;
            if (deletedArray[i] && t.deletePending) {
                t.deleted = true;
                newDeleted++;
                continue;
            }
            t._vertices[ref.vertexId] = origVertex;
            t.isDirty = true;
            t.error[0] = this._calculateError(t._vertices[0], t._vertices[1]) + t.borderFactor / 2;
            t.error[1] = this._calculateError(t._vertices[1], t._vertices[2]) + t.borderFactor / 2;
            t.error[2] = this._calculateError(t._vertices[2], t._vertices[0]) + t.borderFactor / 2;
            t.error[3] = Math.min(t.error[0], t.error[1], t.error[2]);
            this._references.push(ref);
        }
        return newDeleted;
    }
    _identifyBorder() {
        for(let i = 0; i < this._vertices.length; ++i){
            const vCount = [];
            const vId = [];
            const v = this._vertices[i];
            let j;
            for(j = 0; j < v.triangleCount; ++j){
                const triangle = this._triangles[this._references[v.triangleStart + j].triangleId];
                for(let ii = 0; ii < 3; ii++){
                    let ofs = 0;
                    const vv = triangle._vertices[ii];
                    while(ofs < vCount.length){
                        if (vId[ofs] === vv.id) break;
                        ++ofs;
                    }
                    if (ofs === vCount.length) {
                        vCount.push(1);
                        vId.push(vv.id);
                    } else vCount[ofs]++;
                }
            }
            for(j = 0; j < vCount.length; ++j)if (vCount[j] === 1) this._vertices[vId[j]].isBorder = true;
            else this._vertices[vId[j]].isBorder = false;
        }
    }
    _updateMesh(identifyBorders = false) {
        let i;
        if (!identifyBorders) {
            const newTrianglesVector = [];
            for(i = 0; i < this._triangles.length; ++i)if (!this._triangles[i].deleted) newTrianglesVector.push(this._triangles[i]);
            this._triangles = newTrianglesVector;
        }
        for(i = 0; i < this._vertices.length; ++i){
            this._vertices[i].triangleCount = 0;
            this._vertices[i].triangleStart = 0;
        }
        let t;
        let j;
        let v;
        for(i = 0; i < this._triangles.length; ++i){
            t = this._triangles[i];
            for(j = 0; j < 3; ++j){
                v = t._vertices[j];
                v.triangleCount++;
            }
        }
        let tStart = 0;
        for(i = 0; i < this._vertices.length; ++i){
            this._vertices[i].triangleStart = tStart;
            tStart += this._vertices[i].triangleCount;
            this._vertices[i].triangleCount = 0;
        }
        const newReferences = new Array(this._triangles.length * 3);
        for(i = 0; i < this._triangles.length; ++i){
            t = this._triangles[i];
            for(j = 0; j < 3; ++j){
                v = t._vertices[j];
                newReferences[v.triangleStart + v.triangleCount] = new $b2a9ae33dd41f237$var$Reference(j, i);
                v.triangleCount++;
            }
        }
        this._references = newReferences;
        if (identifyBorders) this._identifyBorder();
    }
    _vertexError(q, point) {
        const x = point.x;
        const y = point.y;
        const z = point.z;
        return q.data[0] * x * x + 2 * q.data[1] * x * y + 2 * q.data[2] * x * z + 2 * q.data[3] * x + q.data[4] * y * y + 2 * q.data[5] * y * z + 2 * q.data[6] * y + q.data[7] * z * z + 2 * q.data[8] * z + q.data[9];
    }
    _calculateError(vertex1, vertex2, pointResult) {
        const q = vertex1.q.add(vertex2.q);
        const border = vertex1.isBorder && vertex2.isBorder;
        let error = 0;
        const qDet = q.det(0, 1, 2, 1, 4, 5, 2, 5, 7);
        if (qDet !== 0 && !border) {
            if (!pointResult) pointResult = (0, $ha1VO.Vector3).Zero();
            pointResult.x = -1 / qDet * q.det(1, 2, 3, 4, 5, 6, 5, 7, 8);
            pointResult.y = 1 / qDet * q.det(0, 2, 3, 1, 5, 6, 2, 7, 8);
            pointResult.z = -1 / qDet * q.det(0, 1, 3, 1, 4, 6, 2, 5, 8);
            error = this._vertexError(q, pointResult);
        } else {
            const p3 = vertex1.position.add(vertex2.position).divide(new (0, $ha1VO.Vector3)(2, 2, 2));
            //var norm3 = (vertex1.normal.add(vertex2.normal)).divide(new Vector3(2, 2, 2)).normalize();
            const error1 = this._vertexError(q, vertex1.position);
            const error2 = this._vertexError(q, vertex2.position);
            const error3 = this._vertexError(q, p3);
            error = Math.min(error1, error2, error3);
            if (error === error1) {
                if (pointResult) pointResult.copyFrom(vertex1.position);
            } else if (error === error2) {
                if (pointResult) pointResult.copyFrom(vertex2.position);
            } else if (pointResult) pointResult.copyFrom(p3);
        }
        return error;
    }
}

});

parcelRegister("c6UQl", function(module, exports) {

$parcel$export(module.exports, "SimplicationQueueSceneComponent", () => $8d12237459e69023$export$933c58692a5f6aca);

var $gmbCk = parcelRequire("gmbCk");

var $fbuqw = parcelRequire("fbuqw");

var $fl174 = parcelRequire("fl174");

var $bv05l = parcelRequire("bv05l");
Object.defineProperty((0, $gmbCk.Scene).prototype, "simplificationQueue", {
    get: function() {
        if (!this._simplificationQueue) {
            this._simplificationQueue = new (0, $fl174.SimplificationQueue)();
            let component = this._getComponent((0, $bv05l.SceneComponentConstants).NAME_SIMPLIFICATIONQUEUE);
            if (!component) {
                component = new $8d12237459e69023$export$933c58692a5f6aca(this);
                this._addComponent(component);
            }
        }
        return this._simplificationQueue;
    },
    set: function(value) {
        this._simplificationQueue = value;
    },
    enumerable: true,
    configurable: true
});
(0, $fbuqw.Mesh).prototype.simplify = function(settings, parallelProcessing = true, simplificationType = (0, $fl174.SimplificationType).QUADRATIC, successCallback) {
    this.getScene().simplificationQueue.addTask({
        settings: settings,
        parallelProcessing: parallelProcessing,
        mesh: this,
        simplificationType: simplificationType,
        successCallback: successCallback
    });
    return this;
};
class $8d12237459e69023$export$933c58692a5f6aca {
    /**
     * Creates a new instance of the component for the given scene
     * @param scene Defines the scene to register the component in
     */ constructor(scene){
        /**
         * The component name helpfull to identify the component in the list of scene components.
         */ this.name = (0, $bv05l.SceneComponentConstants).NAME_SIMPLIFICATIONQUEUE;
        this.scene = scene;
    }
    /**
     * Registers the component in a given scene
     */ register() {
        this.scene._beforeCameraUpdateStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_BEFORECAMERAUPDATE_SIMPLIFICATIONQUEUE, this, this._beforeCameraUpdate);
    }
    /**
     * Rebuilds the elements related to this component in case of
     * context lost for instance.
     */ rebuild() {
    // Nothing to do for this component
    }
    /**
     * Disposes the component and the associated resources
     */ dispose() {
    // Nothing to do for this component
    }
    _beforeCameraUpdate() {
        if (this.scene._simplificationQueue && !this.scene._simplificationQueue.running) this.scene._simplificationQueue.executeNext();
    }
}

});

parcelRegister("6PQ5r", function(module, exports) {

var $4C7Qm = parcelRequire("4C7Qm");

var $fPX0M = parcelRequire("fPX0M");

var $fWMvm = parcelRequire("fWMvm");

var $aFflY = parcelRequire("aFflY");

var $8KqOo = parcelRequire("8KqOo");

var $dRlRf = parcelRequire("dRlRf");

var $9zY5k = parcelRequire("9zY5k");

var $bCJrn = parcelRequire("bCJrn");

var $geytg = parcelRequire("geytg");

var $8Eyol = parcelRequire("8Eyol");

var $a2Hja = parcelRequire("a2Hja");

var $l411O = parcelRequire("l411O");

var $g8AI7 = parcelRequire("g8AI7");

var $kt6s5 = parcelRequire("kt6s5");

var $li5Nf = parcelRequire("li5Nf");

var $8CiHO = parcelRequire("8CiHO");

var $4gG1w = parcelRequire("4gG1w");

var $2vSVS = parcelRequire("2vSVS");

var $kZzg0 = parcelRequire("kZzg0");

var $5EAju = parcelRequire("5EAju");

var $1ewDO = parcelRequire("1ewDO");

var $g3tvW = parcelRequire("g3tvW");

var $22sXo = parcelRequire("22sXo");

var $dBltS = parcelRequire("dBltS");

var $hzq5f = parcelRequire("hzq5f");
$parcel$exportWildcard(module.exports, $4C7Qm);
$parcel$exportWildcard(module.exports, $fPX0M);
$parcel$exportWildcard(module.exports, $fWMvm);
$parcel$exportWildcard(module.exports, $aFflY);
$parcel$exportWildcard(module.exports, $8KqOo);
$parcel$exportWildcard(module.exports, $dRlRf);
$parcel$exportWildcard(module.exports, $9zY5k);
$parcel$exportWildcard(module.exports, $bCJrn);
$parcel$exportWildcard(module.exports, $geytg);
$parcel$exportWildcard(module.exports, $8Eyol);
$parcel$exportWildcard(module.exports, $a2Hja);
$parcel$exportWildcard(module.exports, $l411O);
$parcel$exportWildcard(module.exports, $g8AI7);
$parcel$exportWildcard(module.exports, $kt6s5);
$parcel$exportWildcard(module.exports, $li5Nf);
$parcel$exportWildcard(module.exports, $8CiHO);
$parcel$exportWildcard(module.exports, $4gG1w);
$parcel$exportWildcard(module.exports, $2vSVS);
$parcel$exportWildcard(module.exports, $kZzg0);
$parcel$exportWildcard(module.exports, $5EAju);
$parcel$exportWildcard(module.exports, $1ewDO);
$parcel$exportWildcard(module.exports, $g3tvW);
$parcel$exportWildcard(module.exports, $22sXo);
$parcel$exportWildcard(module.exports, $dBltS);
$parcel$exportWildcard(module.exports, $hzq5f);

});
parcelRegister("hzq5f", function(module, exports) {

$parcel$export(module.exports, "GreasedLineMeshColorDistribution", () => $cca9f03eaf0ec6ec$export$bc364857a9c33a23);
$parcel$export(module.exports, "GreasedLineMeshWidthDistribution", () => $cca9f03eaf0ec6ec$export$94fa861b714c693e);
$parcel$export(module.exports, "CreateGreasedLineMaterial", () => $cca9f03eaf0ec6ec$export$c614f0960658bef2);
$parcel$export(module.exports, "CreateGreasedLine", () => $cca9f03eaf0ec6ec$export$628ef4a115051407);
$parcel$export(module.exports, "CompleteGreasedLineWidthTable", () => $cca9f03eaf0ec6ec$export$86e2fee0ac88b38b);
$parcel$export(module.exports, "CompleteGreasedLineColorTable", () => $cca9f03eaf0ec6ec$export$160e3fa204becb15);

var $gAH3H = parcelRequire("gAH3H");

var $5Ezgc = parcelRequire("5Ezgc");

var $DduJm = parcelRequire("DduJm");

var $ejQPp = parcelRequire("ejQPp");

var $hExvk = parcelRequire("hExvk");

var $btEbG = parcelRequire("btEbG");

var $il6pG = parcelRequire("il6pG");

var $iGY4d = parcelRequire("iGY4d");

var $bZbGh = parcelRequire("bZbGh");

var $heA9x = parcelRequire("heA9x");

var $7LG5O = parcelRequire("7LG5O");
var $cca9f03eaf0ec6ec$export$bc364857a9c33a23;
(function(GreasedLineMeshColorDistribution) {
    /**
     * Do no modify the color table
     */ GreasedLineMeshColorDistribution[GreasedLineMeshColorDistribution["COLOR_DISTRIBUTION_NONE"] = 0] = "COLOR_DISTRIBUTION_NONE";
    /**
     * Repeat the colors until the color table is full
     */ GreasedLineMeshColorDistribution[GreasedLineMeshColorDistribution["COLOR_DISTRIBUTION_REPEAT"] = 1] = "COLOR_DISTRIBUTION_REPEAT";
    /**
     * Distribute the colors evenly through the color table
     */ GreasedLineMeshColorDistribution[GreasedLineMeshColorDistribution["COLOR_DISTRIBUTION_EVEN"] = 2] = "COLOR_DISTRIBUTION_EVEN";
    /**
     * Put the colors to start of the color table a fill the rest with the default color
     */ GreasedLineMeshColorDistribution[GreasedLineMeshColorDistribution["COLOR_DISTRIBUTION_START"] = 3] = "COLOR_DISTRIBUTION_START";
    /**
     * Put the colors to the end of the color table and fill the rest with the default color
     */ GreasedLineMeshColorDistribution[GreasedLineMeshColorDistribution["COLOR_DISTRIBUTION_END"] = 4] = "COLOR_DISTRIBUTION_END";
    /**
     * Put the colors to start and to the end of the color table and fill the gap between with the default color
     */ GreasedLineMeshColorDistribution[GreasedLineMeshColorDistribution["COLOR_DISTRIBUTION_START_END"] = 5] = "COLOR_DISTRIBUTION_START_END";
})($cca9f03eaf0ec6ec$export$bc364857a9c33a23 || ($cca9f03eaf0ec6ec$export$bc364857a9c33a23 = {}));
var $cca9f03eaf0ec6ec$export$94fa861b714c693e;
(function(GreasedLineMeshWidthDistribution) {
    /**
     * Do no modify the width table
     */ GreasedLineMeshWidthDistribution[GreasedLineMeshWidthDistribution["WIDTH_DISTRIBUTION_NONE"] = 0] = "WIDTH_DISTRIBUTION_NONE";
    /**
     * Repeat the widths until the width table is full
     */ GreasedLineMeshWidthDistribution[GreasedLineMeshWidthDistribution["WIDTH_DISTRIBUTION_REPEAT"] = 1] = "WIDTH_DISTRIBUTION_REPEAT";
    /**
     * Distribute the widths evenly through the width table
     */ GreasedLineMeshWidthDistribution[GreasedLineMeshWidthDistribution["WIDTH_DISTRIBUTION_EVEN"] = 2] = "WIDTH_DISTRIBUTION_EVEN";
    /**
     * Put the widths to start of the width table a fill the rest with the default width
     */ GreasedLineMeshWidthDistribution[GreasedLineMeshWidthDistribution["WIDTH_DISTRIBUTION_START"] = 3] = "WIDTH_DISTRIBUTION_START";
    /**
     * Put the widths to the end of the width table and fill the rest with the default width
     */ GreasedLineMeshWidthDistribution[GreasedLineMeshWidthDistribution["WIDTH_DISTRIBUTION_END"] = 4] = "WIDTH_DISTRIBUTION_END";
    /**
     * Put the widths to start and to the end of the width table and fill the gap between with the default width
     */ GreasedLineMeshWidthDistribution[GreasedLineMeshWidthDistribution["WIDTH_DISTRIBUTION_START_END"] = 5] = "WIDTH_DISTRIBUTION_START_END";
})($cca9f03eaf0ec6ec$export$94fa861b714c693e || ($cca9f03eaf0ec6ec$export$94fa861b714c693e = {}));
function $cca9f03eaf0ec6ec$export$c614f0960658bef2(name, options, scene) {
    scene = scene ?? (0, $ejQPp.EngineStore).LastCreatedScene;
    let material;
    switch(options.materialType){
        case (0, $bZbGh.GreasedLineMeshMaterialType).MATERIAL_TYPE_PBR:
            material = new (0, $5Ezgc.PBRMaterial)(name, scene);
            new (0, $heA9x.GreasedLinePluginMaterial)(material, scene, options);
            break;
        case (0, $bZbGh.GreasedLineMeshMaterialType).MATERIAL_TYPE_SIMPLE:
            material = new (0, $hExvk.GreasedLineSimpleMaterial)(name, scene, options);
            break;
        default:
            material = new (0, $gAH3H.StandardMaterial)(name, scene);
            new (0, $heA9x.GreasedLinePluginMaterial)(material, scene, options);
            break;
    }
    return material;
}
function $cca9f03eaf0ec6ec$export$628ef4a115051407(name, options, materialOptions, scene) {
    scene = scene ?? (0, $ejQPp.EngineStore).LastCreatedScene;
    let instance;
    const allPoints = (0, $btEbG.GreasedLineTools).ConvertPoints(options.points);
    options.widthDistribution = options.widthDistribution ?? $cca9f03eaf0ec6ec$export$94fa861b714c693e.WIDTH_DISTRIBUTION_START;
    if (options.ribbonOptions) {
        options.ribbonOptions.facesMode = options.ribbonOptions.facesMode ?? (0, $il6pG.GreasedLineRibbonFacesMode).FACES_MODE_SINGLE_SIDED_NO_BACKFACE_CULLING;
        options.ribbonOptions.pointsMode = options.ribbonOptions.pointsMode ?? (0, $il6pG.GreasedLineRibbonPointsMode).POINTS_MODE_POINTS;
        options.ribbonOptions.directionsAutoMode = options.ribbonOptions.directionsAutoMode ?? (options.ribbonOptions.directions ? (0, $il6pG.GreasedLineRibbonAutoDirectionMode).AUTO_DIRECTIONS_NONE : (0, $il6pG.GreasedLineRibbonAutoDirectionMode).AUTO_DIRECTIONS_FROM_FIRST_SEGMENT);
    }
    materialOptions = materialOptions ?? {
        color: (0, $7LG5O.GreasedLineMaterialDefaults).DEFAULT_COLOR
    };
    materialOptions.createAndAssignMaterial = materialOptions.createAndAssignMaterial ?? true;
    materialOptions.colorDistribution = materialOptions?.colorDistribution ?? $cca9f03eaf0ec6ec$export$bc364857a9c33a23.COLOR_DISTRIBUTION_START;
    materialOptions.materialType = materialOptions.materialType ?? (0, $bZbGh.GreasedLineMeshMaterialType).MATERIAL_TYPE_STANDARD;
    let length = 0;
    if (Array.isArray(allPoints[0])) allPoints.forEach((points)=>{
        length += points.length / 3;
    });
    const widths = $cca9f03eaf0ec6ec$export$86e2fee0ac88b38b(length, options.widths ?? [], options.widthDistribution);
    const colors = materialOptions?.colors ? $cca9f03eaf0ec6ec$export$160e3fa204becb15(length, materialOptions.colors, materialOptions.colorDistribution, materialOptions.color ?? (0, $7LG5O.GreasedLineMaterialDefaults).DEFAULT_COLOR) : undefined;
    // create new mesh if instance is not defined
    const initialGreasedLineOptions = {
        points: allPoints,
        updatable: options.updatable,
        widths: widths,
        lazy: options.lazy,
        ribbonOptions: options.ribbonOptions,
        uvs: options.uvs,
        colorPointers: options.colorPointers
    };
    if (initialGreasedLineOptions.ribbonOptions) {
        if (initialGreasedLineOptions.ribbonOptions.pointsMode === (0, $il6pG.GreasedLineRibbonPointsMode).POINTS_MODE_POINTS) initialGreasedLineOptions.ribbonOptions.width = materialOptions.width ?? initialGreasedLineOptions.ribbonOptions.width ?? (0, $7LG5O.GreasedLineMaterialDefaults).DEFAULT_WIDTH;
    }
    if (!options.instance) {
        instance = initialGreasedLineOptions.ribbonOptions ? new (0, $iGY4d.GreasedLineRibbonMesh)(name, scene, initialGreasedLineOptions) : new (0, $DduJm.GreasedLineMesh)(name, scene, initialGreasedLineOptions);
        if (materialOptions) {
            const initialMaterialOptions = {
                materialType: materialOptions.materialType,
                dashCount: materialOptions.dashCount,
                dashOffset: materialOptions.dashOffset,
                dashRatio: materialOptions.dashRatio,
                resolution: materialOptions.resolution,
                sizeAttenuation: materialOptions.sizeAttenuation,
                useColors: materialOptions.useColors,
                useDash: materialOptions.useDash,
                visibility: materialOptions.visibility,
                width: materialOptions.width,
                color: materialOptions.color,
                colorMode: materialOptions.colorMode,
                colorsSampling: materialOptions.colorsSampling,
                colorDistributionType: materialOptions.colorDistributionType,
                colors: colors,
                cameraFacing: !options.ribbonOptions,
                colorsTexture: materialOptions.colorsTexture
            };
            if (materialOptions.createAndAssignMaterial) {
                const material = $cca9f03eaf0ec6ec$export$c614f0960658bef2(name, initialMaterialOptions, scene);
                instance.material = material;
                if (options.ribbonOptions?.facesMode === (0, $il6pG.GreasedLineRibbonFacesMode).FACES_MODE_SINGLE_SIDED_NO_BACKFACE_CULLING) material.backFaceCulling = false;
            }
        }
    } else {
        // update the data on the mesh instance
        instance = options.instance;
        if (instance instanceof (0, $iGY4d.GreasedLineRibbonMesh)) instance.addPoints(allPoints, initialGreasedLineOptions);
        else {
            const currentWidths = instance.widths;
            if (currentWidths) {
                const newWidths = currentWidths.slice();
                for (const w of widths)newWidths.push(w);
                instance.widths = newWidths;
            } else instance.widths = widths;
            instance.addPoints(allPoints);
        }
    }
    // add colors
    // it will merge if any colors already on the instance
    if (colors && options.instance) {
        if (options.instance.greasedLineMaterial) {
            const currentColors = options.instance.greasedLineMaterial.colors;
            if (currentColors) {
                const newColors = currentColors.concat(colors);
                options.instance.greasedLineMaterial.setColors(newColors, instance.isLazy());
            }
        }
    }
    return instance;
}
function $cca9f03eaf0ec6ec$export$86e2fee0ac88b38b(pointCount, widths, widthsDistribution, defaultWidthUpper = 1, defaultWidthLower = 1) {
    const missingCount = pointCount - widths.length / 2;
    const widthsData = [];
    if (missingCount < 0) return widths.slice(0, pointCount * 2);
    // is the width table shorter than the point table?
    if (missingCount > 0) {
        if (widths.length % 2 != 0) widths.push(defaultWidthUpper);
        // it is, fill in the missing elements
        if (widthsDistribution === $cca9f03eaf0ec6ec$export$94fa861b714c693e.WIDTH_DISTRIBUTION_START_END) {
            const halfCount = Math.floor(widths.length / 2);
            // start sector
            for(let i = 0, j = 0; i < halfCount - 1; i++){
                widthsData.push(widths[j++]);
                widthsData.push(widths[j++]);
            }
            // middle sector
            const widthL = widths[halfCount / 2];
            const widthU = widths[halfCount / 2 + 1];
            for(let i = 0; i < missingCount; i++){
                widthsData.push(widthU);
                widthsData.push(widthL);
            }
            // end sector
            for(let i = halfCount; i < widths.length; i += 2){
                widthsData.push(widths[i]);
                widthsData.push(widths[i + 1]);
            }
        } else if (widthsDistribution === $cca9f03eaf0ec6ec$export$94fa861b714c693e.WIDTH_DISTRIBUTION_START) {
            // start sector
            for(let i = 0; i < widths.length; i += 2){
                widthsData.push(widths[i]);
                widthsData.push(widths[i + 1]);
            }
            // end sector
            for(let i = 0; i < missingCount; i++){
                widthsData.push(defaultWidthUpper);
                widthsData.push(defaultWidthLower);
            }
        } else if (widthsDistribution === $cca9f03eaf0ec6ec$export$94fa861b714c693e.WIDTH_DISTRIBUTION_END) {
            // start sector
            for(let i = 0; i < missingCount; i++){
                widthsData.push(defaultWidthUpper);
                widthsData.push(defaultWidthLower);
            }
            // end sector
            for(let i = 0; i < widths.length; i += 2){
                widthsData.push(widths[i]);
                widthsData.push(widths[i + 1]);
            }
        } else if (widthsDistribution === $cca9f03eaf0ec6ec$export$94fa861b714c693e.WIDTH_DISTRIBUTION_REPEAT) {
            let i = 0;
            for(let x = 0; x < pointCount; x++){
                widthsData.push(widths[i++]);
                widthsData.push(widths[i++]);
                if (i === widths.length) i = 0;
            }
        } else if (widthsDistribution === $cca9f03eaf0ec6ec$export$94fa861b714c693e.WIDTH_DISTRIBUTION_EVEN) {
            let j = 0;
            const widthsectorLength = widths.length / ((pointCount - 1) * 2);
            for(let x = 0; x < pointCount; x++){
                const i = Math.floor(j);
                widthsData.push(widths[i]);
                widthsData.push(widths[i + 1]);
                j += widthsectorLength;
            }
        }
    } else for(let i = 0; i < widths.length; i++)widthsData.push(widths[i]);
    return widthsData;
}
function $cca9f03eaf0ec6ec$export$160e3fa204becb15(pointCount, colors, colorDistribution, defaultColor) {
    pointCount = Math.max(colors.length, pointCount);
    const missingCount = pointCount - colors.length;
    if (missingCount < 0) return colors.slice(0, pointCount);
    const colorsData = [];
    // is the color table shorter than the point table?
    if (missingCount > 0) {
        // it is, fill in the missing elements
        if (colorDistribution === $cca9f03eaf0ec6ec$export$bc364857a9c33a23.COLOR_DISTRIBUTION_START_END) {
            const halfCount = Math.floor(colors.length / 2);
            // start sector
            for(let i = 0; i < halfCount; i++)colorsData.push(colors[i]);
            // middle sector
            for(let i = 0; i < missingCount - 1; i++)colorsData.push(defaultColor);
            // end sector
            for(let i = halfCount; i < colors.length; i++)colorsData.push(colors[i]);
        } else if (colorDistribution === $cca9f03eaf0ec6ec$export$bc364857a9c33a23.COLOR_DISTRIBUTION_START) {
            // start sector
            for(let i = 0; i < colors.length; i++)colorsData.push(colors[i]);
            // end sector
            for(let i = 0; i < missingCount; i++)colorsData.push(defaultColor);
        } else if (colorDistribution === $cca9f03eaf0ec6ec$export$bc364857a9c33a23.COLOR_DISTRIBUTION_END) {
            // start sector
            for(let i = 0; i < missingCount - 1; i++)colorsData.push(defaultColor);
            // end sector
            for(let i = 0; i < colors.length; i++)colorsData.push(colors[i]);
        } else if (colorDistribution === $cca9f03eaf0ec6ec$export$bc364857a9c33a23.COLOR_DISTRIBUTION_REPEAT) {
            let i = 0;
            for(let x = 0; x < pointCount; x++){
                colorsData.push(colors[i]);
                i++;
                if (i === colors.length) i = 0;
            }
        } else if (colorDistribution === $cca9f03eaf0ec6ec$export$bc364857a9c33a23.COLOR_DISTRIBUTION_EVEN) {
            let j = 0;
            const colorSectorLength = colors.length / (pointCount - 1);
            for(let x = 0; x < pointCount - 1; x++){
                const i = Math.floor(j);
                colorsData.push(colors[i]);
                j += colorSectorLength;
            }
        } else if (colorDistribution === $cca9f03eaf0ec6ec$export$bc364857a9c33a23.COLOR_DISTRIBUTION_NONE) for(let i = 0; i < colors.length; i++)colorsData.push(colors[i]);
    } else for(let i = 0; i < pointCount; i++)colorsData.push(colors[i]);
    return colorsData;
}

});
parcelRegister("DduJm", function(module, exports) {

$parcel$export(module.exports, "GreasedLineMesh", () => $075e1c64054caaf1$export$70a1b8a4058ab643);

var $ha1VO = parcelRequire("ha1VO");

var $fbuqw = parcelRequire("fbuqw");

var $b4i1f = parcelRequire("b4i1f");

var $gzCma = parcelRequire("gzCma");

var $fhgis = parcelRequire("fhgis");

var $btEbG = parcelRequire("btEbG");

var $il6pG = parcelRequire("il6pG");
(0, $fbuqw.Mesh)._GreasedLineMeshParser = (parsedMesh, scene)=>{
    return $075e1c64054caaf1$export$70a1b8a4058ab643.Parse(parsedMesh, scene);
};
class $075e1c64054caaf1$export$70a1b8a4058ab643 extends (0, $il6pG.GreasedLineBaseMesh) {
    /**
     * GreasedLineMesh
     * @param name name of the mesh
     * @param scene the scene
     * @param _options mesh options
     */ constructor(name, scene, _options){
        super(name, scene, _options);
        this.name = name;
        /**
         * Treshold used to pick the mesh
         */ this.intersectionThreshold = 0.1;
        this._previousAndSide = [];
        this._nextAndCounters = [];
        if (_options.points) this.addPoints((0, $btEbG.GreasedLineTools).ConvertPoints(_options.points));
    }
    /**
     * "GreasedLineMesh"
     * @returns "GreasedLineMesh"
     */ getClassName() {
        return "GreasedLineMesh";
    }
    _updateColorPointers() {
        if (this._options.colorPointers) return;
        let colorPointer = 0;
        this._colorPointers = [];
        this._points.forEach((p)=>{
            for(let jj = 0; jj < p.length; jj += 3){
                this._colorPointers.push(colorPointer);
                this._colorPointers.push(colorPointer++);
            }
        });
    }
    _updateWidths() {
        super._updateWidthsWithValue(0);
    }
    _setPoints(points) {
        this._points = points;
        this._options.points = points;
        this._initGreasedLine();
        let indiceOffset = 0;
        points.forEach((p)=>{
            const counters = [];
            const positions = [];
            const indices = [];
            const totalLength = (0, $btEbG.GreasedLineTools).GetLineLength(p);
            for(let j = 0, jj = 0; jj < p.length; j++, jj += 3){
                const partialLine = p.slice(0, jj + 3);
                const partialLineLength = (0, $btEbG.GreasedLineTools).GetLineLength(partialLine);
                const c = partialLineLength / totalLength;
                positions.push(p[jj], p[jj + 1], p[jj + 2]);
                positions.push(p[jj], p[jj + 1], p[jj + 2]);
                counters.push(c);
                counters.push(c);
                if (jj < p.length - 3) {
                    const n = j * 2 + indiceOffset;
                    indices.push(n, n + 1, n + 2);
                    indices.push(n + 2, n + 1, n + 3);
                }
            }
            indiceOffset += p.length / 3 * 2;
            const previous = [];
            const next = [];
            const side = [];
            let uvs = [];
            this._preprocess(positions, previous, next, side, uvs);
            for (const vp of positions)this._vertexPositions.push(vp);
            for (const i of indices)this._indices.push(i);
            for(let i = 0; i < side.length; i++){
                this._previousAndSide.push(previous[i * 3], previous[i * 3 + 1], previous[i * 3 + 2], side[i]);
                this._nextAndCounters.push(next[i * 3], next[i * 3 + 1], next[i * 3 + 2], counters[i]);
            }
            uvs = this._options.uvs ?? uvs;
            for (const uv of uvs)this._uvs.push(uv);
        });
        if (!this._lazy) {
            if (!this._options.colorPointers) this._updateColorPointers();
            this._createVertexBuffers();
            this.refreshBoundingInfo();
        }
    }
    /**
     * Clones the GreasedLineMesh.
     * @param name new line name
     * @param newParent new parent node
     * @returns cloned line
     */ clone(name = `${this.name}-cloned`, newParent) {
        const lineOptions = this._createLineOptions();
        const deepCopiedLineOptions = {};
        (0, $fhgis.DeepCopier).DeepCopy(lineOptions, deepCopiedLineOptions, [
            "instance"
        ], undefined, true);
        const cloned = new $075e1c64054caaf1$export$70a1b8a4058ab643(name, this._scene, deepCopiedLineOptions);
        if (newParent) cloned.parent = newParent;
        cloned.material = this.material;
        return cloned;
    }
    /**
     * Serializes this GreasedLineMesh
     * @param serializationObject object to write serialization to
     */ serialize(serializationObject) {
        super.serialize(serializationObject);
        serializationObject.type = this.getClassName();
        serializationObject.lineOptions = this._createLineOptions();
    }
    /**
     * Parses a serialized GreasedLineMesh
     * @param parsedMesh the serialized GreasedLineMesh
     * @param scene the scene to create the GreasedLineMesh in
     * @returns the created GreasedLineMesh
     */ static Parse(parsedMesh, scene) {
        const lineOptions = parsedMesh.lineOptions;
        const name = parsedMesh.name;
        const result = new $075e1c64054caaf1$export$70a1b8a4058ab643(name, scene, lineOptions);
        return result;
    }
    _initGreasedLine() {
        super._initGreasedLine();
        this._previousAndSide = [];
        this._nextAndCounters = [];
    }
    /**
     * Checks whether a ray is intersecting this GreasedLineMesh
     * @param ray ray to check the intersection of this mesh with
     * @param fastCheck not supported
     * @param trianglePredicate not supported
     * @param onlyBoundingInfo defines a boolean indicating if picking should only happen using bounding info (false by default)
     * @param worldToUse not supported
     * @param skipBoundingInfo a boolean indicating if we should skip the bounding info check
     * @returns the picking info
     */ intersects(ray, fastCheck, trianglePredicate, onlyBoundingInfo = false, worldToUse, skipBoundingInfo = false) {
        const pickingInfo = new (0, $gzCma.PickingInfo)();
        const intersections = this.findAllIntersections(ray, fastCheck, trianglePredicate, onlyBoundingInfo, worldToUse, skipBoundingInfo, true);
        if (intersections?.length === 1) {
            const intersection = intersections[0];
            pickingInfo.hit = true;
            pickingInfo.distance = intersection.distance;
            pickingInfo.ray = ray;
            pickingInfo.pickedMesh = this;
            pickingInfo.pickedPoint = intersection.point;
        }
        return pickingInfo;
    }
    /**
     * Gets all intersections of a ray and the line
     * @param ray Ray to check the intersection of this mesh with
     * @param _fastCheck not supported
     * @param _trianglePredicate not supported
     * @param onlyBoundingInfo defines a boolean indicating if picking should only happen using bounding info (false by default)
     * @param _worldToUse not supported
     * @param skipBoundingInfo a boolean indicating if we should skip the bounding info check
     * @param firstOnly If true, the first and only intersection is immediatelly returned if found
     * @returns intersection(s)
     */ findAllIntersections(ray, _fastCheck, _trianglePredicate, onlyBoundingInfo = false, _worldToUse, skipBoundingInfo = false, firstOnly = false) {
        if (onlyBoundingInfo && !skipBoundingInfo && ray.intersectsSphere(this._boundingSphere, this.intersectionThreshold) === false) return;
        const indices = this.getIndices();
        const positions = this.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        const widths = this._widths;
        const lineWidth = this.greasedLineMaterial?.width ?? 1;
        const intersects = [];
        if (indices && positions && widths) {
            let i = 0, l = 0;
            for(i = 0, l = indices.length - 1; i < l; i += 3){
                const a = indices[i];
                const b = indices[i + 1];
                $075e1c64054caaf1$export$70a1b8a4058ab643._V_START.fromArray(positions, a * 3);
                $075e1c64054caaf1$export$70a1b8a4058ab643._V_END.fromArray(positions, b * 3);
                if (this._offsets) {
                    $075e1c64054caaf1$export$70a1b8a4058ab643._V_OFFSET_START.fromArray(this._offsets, a * 3);
                    $075e1c64054caaf1$export$70a1b8a4058ab643._V_OFFSET_END.fromArray(this._offsets, b * 3);
                    $075e1c64054caaf1$export$70a1b8a4058ab643._V_START.addInPlace($075e1c64054caaf1$export$70a1b8a4058ab643._V_OFFSET_START);
                    $075e1c64054caaf1$export$70a1b8a4058ab643._V_END.addInPlace($075e1c64054caaf1$export$70a1b8a4058ab643._V_OFFSET_END);
                }
                const iFloored = Math.floor(i / 3);
                const width = widths[iFloored] !== undefined ? widths[iFloored] : 1;
                const precision = this.intersectionThreshold * (lineWidth * width) / 2;
                const distance = ray.intersectionSegment($075e1c64054caaf1$export$70a1b8a4058ab643._V_START, $075e1c64054caaf1$export$70a1b8a4058ab643._V_END, precision);
                if (distance !== -1) {
                    intersects.push({
                        distance: distance,
                        point: ray.direction.normalize().multiplyByFloats(distance, distance, distance).add(ray.origin)
                    });
                    if (firstOnly) return intersects;
                }
            }
            i = l;
        }
        return intersects;
    }
    get _boundingSphere() {
        return this.getBoundingInfo().boundingSphere;
    }
    static _CompareV3(positionIdx1, positionIdx2, positions) {
        const arrayIdx1 = positionIdx1 * 6;
        const arrayIdx2 = positionIdx2 * 6;
        return positions[arrayIdx1] === positions[arrayIdx2] && positions[arrayIdx1 + 1] === positions[arrayIdx2 + 1] && positions[arrayIdx1 + 2] === positions[arrayIdx2 + 2];
    }
    static _CopyV3(positionIdx, positions) {
        const arrayIdx = positionIdx * 6;
        return [
            positions[arrayIdx],
            positions[arrayIdx + 1],
            positions[arrayIdx + 2]
        ];
    }
    _preprocess(positions, previous, next, side, uvs) {
        const l = positions.length / 6;
        let v = [];
        if ($075e1c64054caaf1$export$70a1b8a4058ab643._CompareV3(0, l - 1, positions)) v = $075e1c64054caaf1$export$70a1b8a4058ab643._CopyV3(l - 2, positions);
        else v = $075e1c64054caaf1$export$70a1b8a4058ab643._CopyV3(0, positions);
        previous.push(v[0], v[1], v[2]);
        previous.push(v[0], v[1], v[2]);
        for(let j = 0; j < l; j++){
            side.push(1);
            side.push(-1);
            // uvs
            if (!this._options.uvs) {
                uvs.push(j / (l - 1), 0);
                uvs.push(j / (l - 1), 1);
            }
            if (j < l - 1) {
                v = $075e1c64054caaf1$export$70a1b8a4058ab643._CopyV3(j, positions);
                previous.push(v[0], v[1], v[2]);
                previous.push(v[0], v[1], v[2]);
            }
            if (j > 0) {
                v = $075e1c64054caaf1$export$70a1b8a4058ab643._CopyV3(j, positions);
                next.push(v[0], v[1], v[2]);
                next.push(v[0], v[1], v[2]);
            }
        }
        if ($075e1c64054caaf1$export$70a1b8a4058ab643._CompareV3(l - 1, 0, positions)) v = $075e1c64054caaf1$export$70a1b8a4058ab643._CopyV3(1, positions);
        else v = $075e1c64054caaf1$export$70a1b8a4058ab643._CopyV3(l - 1, positions);
        next.push(v[0], v[1], v[2]);
        next.push(v[0], v[1], v[2]);
        return {
            previous: previous,
            next: next,
            uvs: uvs,
            side: side
        };
    }
    _createVertexBuffers() {
        const vertexData = super._createVertexBuffers();
        const engine = this._scene.getEngine();
        const previousAndSideBuffer = new (0, $b4i1f.Buffer)(engine, this._previousAndSide, false, 4);
        this.setVerticesBuffer(previousAndSideBuffer.createVertexBuffer("grl_previousAndSide", 0, 4));
        const nextAndCountersBuffer = new (0, $b4i1f.Buffer)(engine, this._nextAndCounters, false, 4);
        this.setVerticesBuffer(nextAndCountersBuffer.createVertexBuffer("grl_nextAndCounters", 0, 4));
        const widthBuffer = new (0, $b4i1f.Buffer)(engine, this._widths, this._updatable, 1);
        this.setVerticesBuffer(widthBuffer.createVertexBuffer("grl_widths", 0, 1));
        this._widthsBuffer = widthBuffer;
        const colorPointersBuffer = new (0, $b4i1f.Buffer)(engine, this._colorPointers, this._updatable, 1);
        this.setVerticesBuffer(colorPointersBuffer.createVertexBuffer("grl_colorPointers", 0, 1));
        this._colorPointersBuffer = colorPointersBuffer;
        return vertexData;
    }
}
$075e1c64054caaf1$export$70a1b8a4058ab643._V_START = new (0, $ha1VO.Vector3)();
$075e1c64054caaf1$export$70a1b8a4058ab643._V_END = new (0, $ha1VO.Vector3)();
$075e1c64054caaf1$export$70a1b8a4058ab643._V_OFFSET_START = new (0, $ha1VO.Vector3)();
$075e1c64054caaf1$export$70a1b8a4058ab643._V_OFFSET_END = new (0, $ha1VO.Vector3)();

});
parcelRegister("il6pG", function(module, exports) {

$parcel$export(module.exports, "GreasedLineRibbonPointsMode", () => $d59f29acc02c80db$export$31f15237600a666e);
$parcel$export(module.exports, "GreasedLineRibbonFacesMode", () => $d59f29acc02c80db$export$77817bdd938877c2);
$parcel$export(module.exports, "GreasedLineRibbonAutoDirectionMode", () => $d59f29acc02c80db$export$162634a61468caa4);
$parcel$export(module.exports, "GreasedLineBaseMesh", () => $d59f29acc02c80db$export$9c9b855f562a709b);

var $heA9x = parcelRequire("heA9x");

var $fbuqw = parcelRequire("fbuqw");

var $b4i1f = parcelRequire("b4i1f");

var $5v6ry = parcelRequire("5v6ry");

var $fhgis = parcelRequire("fhgis");

var $hExvk = parcelRequire("hExvk");
var $d59f29acc02c80db$export$31f15237600a666e;
(function(GreasedLineRibbonPointsMode) {
    GreasedLineRibbonPointsMode[GreasedLineRibbonPointsMode["POINTS_MODE_POINTS"] = 0] = "POINTS_MODE_POINTS";
    GreasedLineRibbonPointsMode[GreasedLineRibbonPointsMode["POINTS_MODE_PATHS"] = 1] = "POINTS_MODE_PATHS";
})($d59f29acc02c80db$export$31f15237600a666e || ($d59f29acc02c80db$export$31f15237600a666e = {}));
var $d59f29acc02c80db$export$77817bdd938877c2;
(function(GreasedLineRibbonFacesMode) {
    GreasedLineRibbonFacesMode[GreasedLineRibbonFacesMode["FACES_MODE_SINGLE_SIDED"] = 0] = "FACES_MODE_SINGLE_SIDED";
    GreasedLineRibbonFacesMode[GreasedLineRibbonFacesMode["FACES_MODE_SINGLE_SIDED_NO_BACKFACE_CULLING"] = 1] = "FACES_MODE_SINGLE_SIDED_NO_BACKFACE_CULLING";
    GreasedLineRibbonFacesMode[GreasedLineRibbonFacesMode["FACES_MODE_DOUBLE_SIDED"] = 2] = "FACES_MODE_DOUBLE_SIDED";
})($d59f29acc02c80db$export$77817bdd938877c2 || ($d59f29acc02c80db$export$77817bdd938877c2 = {}));
var $d59f29acc02c80db$export$162634a61468caa4;
(function(GreasedLineRibbonAutoDirectionMode) {
    GreasedLineRibbonAutoDirectionMode[GreasedLineRibbonAutoDirectionMode["AUTO_DIRECTIONS_FROM_FIRST_SEGMENT"] = 0] = "AUTO_DIRECTIONS_FROM_FIRST_SEGMENT";
    GreasedLineRibbonAutoDirectionMode[GreasedLineRibbonAutoDirectionMode["AUTO_DIRECTIONS_FROM_ALL_SEGMENTS"] = 1] = "AUTO_DIRECTIONS_FROM_ALL_SEGMENTS";
    GreasedLineRibbonAutoDirectionMode[GreasedLineRibbonAutoDirectionMode["AUTO_DIRECTIONS_ENHANCED"] = 2] = "AUTO_DIRECTIONS_ENHANCED";
    GreasedLineRibbonAutoDirectionMode[GreasedLineRibbonAutoDirectionMode["AUTO_DIRECTIONS_NONE"] = 99] = "AUTO_DIRECTIONS_NONE";
})($d59f29acc02c80db$export$162634a61468caa4 || ($d59f29acc02c80db$export$162634a61468caa4 = {}));
class $d59f29acc02c80db$export$9c9b855f562a709b extends (0, $fbuqw.Mesh) {
    constructor(name, scene, _options){
        super(name, scene, null, null, false, false);
        this.name = name;
        this._options = _options;
        this._lazy = false;
        this._updatable = false;
        this._engine = scene.getEngine();
        this._lazy = _options.lazy ?? false;
        this._updatable = _options.updatable ?? false;
        this._vertexPositions = [];
        this._indices = [];
        this._uvs = [];
        this._points = [];
        this._colorPointers = _options.colorPointers ?? [];
        this._widths = _options.widths ?? new Array(_options.points.length).fill(1);
    }
    /**
     * "GreasedLineMesh"
     * @returns "GreasedLineMesh"
     */ getClassName() {
        return "GreasedLineMesh";
    }
    _updateWidthsWithValue(defaulValue) {
        let pointCount = 0;
        for (const points of this._points)pointCount += points.length;
        const countDiff = pointCount / 3 * 2 - this._widths.length;
        for(let i = 0; i < countDiff; i++)this._widths.push(defaulValue);
    }
    /**
     * Updated a lazy line. Rerenders the line and updates boundinfo as well.
     */ updateLazy() {
        this._setPoints(this._points);
        if (!this._options.colorPointers) this._updateColorPointers();
        this._createVertexBuffers(this._options.ribbonOptions?.smoothShading);
        this.refreshBoundingInfo();
        this.greasedLineMaterial?.updateLazy();
    }
    /**
     * Adds new points to the line. It doesn't rerenders the line if in lazy mode.
     * @param points points table
     * @param options optional options
     */ addPoints(points, options) {
        for (const p of points)this._points.push(p);
        if (!this._lazy) this.setPoints(this._points, options);
    }
    /**
     * Dispose the line and it's resources
     * @param doNotRecurse Set to true to not recurse into each children (recurse into each children by default)
     * @param disposeMaterialAndTextures Set to true to also dispose referenced materials and textures (false by default)
     */ dispose(doNotRecurse, disposeMaterialAndTextures = false) {
        super.dispose(doNotRecurse, disposeMaterialAndTextures);
    }
    /**
     *
     * @returns true if the mesh was created in lazy mode
     */ isLazy() {
        return this._lazy;
    }
    /**
     * Return the points offsets
     */ get offsets() {
        return this._offsets;
    }
    /**
     * Sets point offests
     * @param offsets offset table [x,y,z, x,y,z, ....]
     */ set offsets(offsets) {
        this._offsets = offsets;
        if (!this._offsetsBuffer) this._createOffsetsBuffer(offsets);
        else this._offsetsBuffer.update(offsets);
    }
    /**
     * Gets widths at each line point like [widthLower, widthUpper, widthLower, widthUpper, ...]
     */ get widths() {
        return this._widths;
    }
    /**
     * Sets widths at each line point
     * @param widths width table [widthLower, widthUpper, widthLower, widthUpper ...]
     */ set widths(widths) {
        this._widths = widths;
        if (!this._lazy) this._widthsBuffer && this._widthsBuffer.update(widths);
    }
    /**
     * Gets the color pointer. Each vertex need a color pointer. These color pointers points to the colors in the color table @see colors
     */ get colorPointers() {
        return this._colorPointers;
    }
    /**
     * Sets the color pointer
     * @param colorPointers array of color pointer in the colors array. One pointer for every vertex is needed.
     */ set colorPointers(colorPointers) {
        this._colorPointers = colorPointers;
        if (!this._lazy) this._colorPointersBuffer && this._colorPointersBuffer.update(colorPointers);
    }
    /**
     * Gets the pluginMaterial associated with line
     */ get greasedLineMaterial() {
        if (this.material && this.material instanceof (0, $hExvk.GreasedLineSimpleMaterial)) return this.material;
        const materialPlugin = this.material?.pluginManager?.getPlugin((0, $heA9x.GreasedLinePluginMaterial).GREASED_LINE_MATERIAL_NAME);
        if (materialPlugin) return materialPlugin;
        return;
    }
    /**
     * Return copy the points.
     */ get points() {
        const pointsCopy = [];
        (0, $fhgis.DeepCopier).DeepCopy(this._points, pointsCopy);
        return pointsCopy;
    }
    /**
     * Sets line points and rerenders the line.
     * @param points points table
     * @param options optional options
     */ setPoints(points, options) {
        this._points = points;
        this._updateWidths();
        if (!options?.colorPointers) this._updateColorPointers();
        this._setPoints(points, options);
    }
    _initGreasedLine() {
        this._vertexPositions = [];
        this._indices = [];
        this._uvs = [];
    }
    _createLineOptions() {
        const lineOptions = {
            points: this._points,
            colorPointers: this._colorPointers,
            lazy: this._lazy,
            updatable: this._updatable,
            uvs: this._uvs,
            widths: this._widths,
            ribbonOptions: this._options.ribbonOptions
        };
        return lineOptions;
    }
    /**
     * Serializes this GreasedLineMesh
     * @param serializationObject object to write serialization to
     */ serialize(serializationObject) {
        super.serialize(serializationObject);
        serializationObject.type = this.getClassName();
        serializationObject.lineOptions = this._createLineOptions();
    }
    _createVertexBuffers(computeNormals = false) {
        const vertexData = new (0, $5v6ry.VertexData)();
        vertexData.positions = this._vertexPositions;
        vertexData.indices = this._indices;
        vertexData.uvs = this._uvs;
        if (computeNormals) {
            vertexData.normals = [];
            (0, $5v6ry.VertexData).ComputeNormals(this._vertexPositions, this._indices, vertexData.normals);
        }
        vertexData.applyToMesh(this, this._options.updatable);
        return vertexData;
    }
    _createOffsetsBuffer(offsets) {
        const engine = this._scene.getEngine();
        const offsetBuffer = new (0, $b4i1f.Buffer)(engine, offsets, this._updatable, 3);
        this.setVerticesBuffer(offsetBuffer.createVertexBuffer("grl_offsets", 0, 3));
        this._offsetsBuffer = offsetBuffer;
    }
}

});


parcelRegister("iGY4d", function(module, exports) {

$parcel$export(module.exports, "GreasedLineRibbonMesh", () => $d9babe4fb3cdc0d3$export$3e262369320d5a5f);

var $ha1VO = parcelRequire("ha1VO");

var $fbuqw = parcelRequire("fbuqw");

var $b4i1f = parcelRequire("b4i1f");

var $fhgis = parcelRequire("fhgis");

var $btEbG = parcelRequire("btEbG");

var $il6pG = parcelRequire("il6pG");
(0, $fbuqw.Mesh)._GreasedLineRibbonMeshParser = (parsedMesh, scene)=>{
    return $d9babe4fb3cdc0d3$export$3e262369320d5a5f.Parse(parsedMesh, scene);
};
class $d9babe4fb3cdc0d3$export$3e262369320d5a5f extends (0, $il6pG.GreasedLineBaseMesh) {
    /**
     * GreasedLineRibbonMesh
     * @param name name of the mesh
     * @param scene the scene
     * @param _options mesh options
     * @param _pathOptions used internaly when parsing a serialized GreasedLineRibbonMesh
     */ constructor(name, scene, _options, _pathOptions){
        super(name, scene, _options);
        this.name = name;
        if (!_options.ribbonOptions) // eslint-disable-next-line no-throw-literal
        throw "'GreasedLineMeshOptions.ribbonOptions' is not set.";
        this._paths = [];
        this._counters = [];
        this._slopes = [];
        this._widths = _options.widths ?? [];
        this._ribbonWidths = [];
        this._pathsOptions = _pathOptions ?? [];
        if (_options.points) this.addPoints((0, $btEbG.GreasedLineTools).ConvertPoints(_options.points), _options, !!_pathOptions);
    }
    /**
     * Adds new points to the line. It doesn't rerenders the line if in lazy mode.
     * @param points points table
     * @param options mesh options
     * @param hasPathOptions defaults to false
     */ addPoints(points, options, hasPathOptions = false) {
        if (!options.ribbonOptions) // eslint-disable-next-line no-throw-literal
        throw "addPoints() on GreasedLineRibbonMesh instance requires 'GreasedLineMeshOptions.ribbonOptions'.";
        if (!hasPathOptions) this._pathsOptions.push({
            options: options,
            pathCount: points.length
        });
        super.addPoints(points, options);
    }
    /**
     * "GreasedLineRibbonMesh"
     * @returns "GreasedLineRibbonMesh"
     */ getClassName() {
        return "GreasedLineRibbonMesh";
    }
    /**
     * Return true if the line was created from two edge paths or one points path.
     * In this case the line is always flat.
     */ get isFlatLine() {
        return this._paths.length < 3;
    }
    /**
     * Returns the slopes of the line at each point relative to the center of the line
     */ get slopes() {
        return this._slopes;
    }
    /**
     * Set the slopes of the line at each point relative to the center of the line
     */ set slopes(slopes) {
        this._slopes = slopes;
    }
    _updateColorPointers() {
        if (this._options.colorPointers) return;
        let colorPointer = 0;
        this._colorPointers = [];
        for(let i = 0; i < this._pathsOptions.length; i++){
            const { options: pathOptions, pathCount: pathCount } = this._pathsOptions[i];
            const points = this._points[i];
            if (pathOptions.ribbonOptions.pointsMode === (0, $il6pG.GreasedLineRibbonPointsMode).POINTS_MODE_POINTS) {
                for(let k = 0; k < pathCount; k++)for(let j = 0; j < points.length; j += 3){
                    this._colorPointers.push(colorPointer);
                    this._colorPointers.push(colorPointer++);
                }
            } else for(let j = 0; j < points.length; j += 3){
                for(let k = 0; k < pathCount; k++)this._colorPointers.push(colorPointer);
                colorPointer++;
            }
        }
    }
    _updateWidths() {
        super._updateWidthsWithValue(1);
    }
    _setPoints(points, _options) {
        if (!this._options.ribbonOptions) // eslint-disable-next-line no-throw-literal
        throw "No 'GreasedLineMeshOptions.ribbonOptions' provided.";
        this._points = points;
        this._options.points = points;
        this._initGreasedLine();
        let indiceOffset = 0;
        let directionPlanes;
        for(let i = 0, c = 0; i < this._pathsOptions.length; i++){
            const { options: pathOptions, pathCount: pathCount } = this._pathsOptions[i];
            const subPoints = points.slice(c, c + pathCount);
            c += pathCount;
            if (pathOptions.ribbonOptions?.pointsMode === (0, $il6pG.GreasedLineRibbonPointsMode).POINTS_MODE_PATHS) indiceOffset = this._preprocess((0, $btEbG.GreasedLineTools).ToVector3Array(subPoints), indiceOffset, pathOptions);
            else {
                if (pathOptions.ribbonOptions?.directionsAutoMode === (0, $il6pG.GreasedLineRibbonAutoDirectionMode).AUTO_DIRECTIONS_NONE) {
                    if (!pathOptions.ribbonOptions.directions) // eslint-disable-next-line no-throw-literal
                    throw "In GreasedLineRibbonAutoDirectionMode.AUTO_DIRECTIONS_NONE 'GreasedLineMeshOptions.ribbonOptions.directions' must be defined.";
                    directionPlanes = $d9babe4fb3cdc0d3$export$3e262369320d5a5f._GetDirectionPlanesFromDirectionsOption(subPoints.length, pathOptions.ribbonOptions.directions);
                }
                subPoints.forEach((p, idx)=>{
                    const pathArray = $d9babe4fb3cdc0d3$export$3e262369320d5a5f._ConvertToRibbonPath(p, pathOptions.ribbonOptions, this._scene.useRightHandedSystem, directionPlanes ? directionPlanes[idx] : directionPlanes);
                    indiceOffset = this._preprocess(pathArray, indiceOffset, pathOptions);
                });
            }
        }
        if (!this._lazy) {
            this._createVertexBuffers();
            this.refreshBoundingInfo();
        }
    }
    static _GetDirectionPlanesFromDirectionsOption(count, directions) {
        if (Array.isArray(directions)) return directions;
        return new Array(count).fill(directions);
    }
    static _CreateRibbonVertexData(pathArray, options) {
        const numOfPaths = pathArray.length;
        if (numOfPaths < 2) // eslint-disable-next-line no-throw-literal
        throw "Minimum of two paths are required to create a GreasedLineRibbonMesh.";
        const positions = [];
        const indices = [];
        const path = pathArray[0];
        for(let i = 0; i < path.length; i++)for(let pi = 0; pi < pathArray.length; pi++){
            const v = pathArray[pi][i];
            positions.push(v.x, v.y, v.z);
        }
        const v = [
            1,
            0,
            numOfPaths
        ];
        const doubleSided = (options.ribbonOptions?.facesMode === (0, $il6pG.GreasedLineRibbonFacesMode).FACES_MODE_DOUBLE_SIDED) ?? false;
        const closePath = options.ribbonOptions?.pointsMode === (0, $il6pG.GreasedLineRibbonPointsMode).POINTS_MODE_PATHS && options.ribbonOptions.closePath;
        if (numOfPaths > 2) for(let i = 0; i < path.length - 1; i++){
            v[0] = 1 + numOfPaths * i;
            v[1] = numOfPaths * i;
            v[2] = (i + 1) * numOfPaths;
            for(let pi = 0; pi < (numOfPaths - 1) * 2; pi++){
                if (pi % 2 !== 0) v[2] += 1;
                if (pi % 2 === 0 && pi > 0) {
                    v[0] += 1;
                    v[1] += 1;
                }
                indices.push(v[1] + (pi % 2 !== 0 ? numOfPaths : 0), v[0], v[2]);
                if (doubleSided) indices.push(v[0], v[1] + (pi % 2 !== 0 ? numOfPaths : 0), v[2]);
            }
        }
        else for(let i = 0; i < positions.length / 3 - 3; i += 2){
            indices.push(i, i + 1, i + 2);
            indices.push(i + 2, i + 1, i + 3);
            if (doubleSided) {
                indices.push(i + 1, i, i + 2);
                indices.push(i + 1, i + 2, i + 3);
            }
        }
        if (closePath) {
            let lastIndice = numOfPaths * (path.length - 1);
            for(let pi = 0; pi < numOfPaths - 1; pi++){
                indices.push(lastIndice, pi + 1, pi);
                indices.push(lastIndice + 1, pi + 1, lastIndice);
                if (doubleSided) {
                    indices.push(pi, pi + 1, lastIndice);
                    indices.push(lastIndice, pi + 1, lastIndice + 1);
                }
                lastIndice++;
            }
        }
        return {
            positions: positions,
            indices: indices
        };
    }
    _preprocess(pathArray, indiceOffset, options) {
        this._paths = pathArray;
        const ribbonVertexData = $d9babe4fb3cdc0d3$export$3e262369320d5a5f._CreateRibbonVertexData(pathArray, options);
        const positions = ribbonVertexData.positions;
        if (!this._options.widths) // eslint-disable-next-line no-throw-literal
        throw "No 'GreasedLineMeshOptions.widths' table is specified.";
        for (const p of positions)this._vertexPositions.push(p);
        let pathArrayCopy = pathArray;
        if (options.ribbonOptions?.pointsMode === (0, $il6pG.GreasedLineRibbonPointsMode).POINTS_MODE_PATHS && options.ribbonOptions.closePath) {
            pathArrayCopy = [];
            for(let i = 0; i < pathArray.length; i++){
                const pathCopy = pathArray[i].slice();
                pathCopy.push(pathArray[i][0].clone());
                pathArrayCopy.push(pathCopy);
            }
        }
        this._calculateSegmentLengths(pathArrayCopy);
        const pathArrayLength = pathArrayCopy.length;
        const previousCounters = new Array(pathArrayLength).fill(0);
        for(let i = 0; i < pathArrayCopy[0].length; i++){
            let v = 0;
            for(let pi = 0; pi < pathArrayLength; pi++){
                const counter = previousCounters[pi] + this._vSegmentLengths[pi][i] / this._vTotalLengths[pi];
                this._counters.push(counter);
                this._uvs.push(counter, v);
                previousCounters[pi] = counter;
                v += this._uSegmentLengths[i][pi] / this._uTotalLengths[i];
            }
        }
        for(let i = 0, c = 0; i < pathArrayCopy[0].length; i++){
            const widthLower = this._uSegmentLengths[i][0] / 2;
            const widthUpper = this._uSegmentLengths[i][pathArrayLength - 1] / 2;
            this._ribbonWidths.push(((this._widths[c++] ?? 1) - 1) * widthLower);
            for(let pi = 0; pi < pathArrayLength - 2; pi++)this._ribbonWidths.push(0);
            this._ribbonWidths.push(((this._widths[c++] ?? 1) - 1) * widthUpper);
        }
        const slopes = options.ribbonOptions?.pointsMode === (0, $il6pG.GreasedLineRibbonPointsMode).POINTS_MODE_PATHS ? new Array(pathArrayCopy[0].length * pathArrayCopy.length * 6).fill(0) : $d9babe4fb3cdc0d3$export$3e262369320d5a5f._CalculateSlopes(pathArrayCopy);
        for (const s of slopes)this._slopes.push(s);
        if (ribbonVertexData.indices) for(let i = 0; i < ribbonVertexData.indices.length; i++)this._indices.push(ribbonVertexData.indices[i] + indiceOffset);
        indiceOffset += positions.length / 3;
        return indiceOffset;
    }
    static _ConvertToRibbonPath(points, ribbonInfo, rightHandedSystem, directionPlane) {
        if (ribbonInfo.pointsMode === (0, $il6pG.GreasedLineRibbonPointsMode).POINTS_MODE_POINTS && !ribbonInfo.width) // eslint-disable-next-line no-throw-literal
        throw "'GreasedLineMeshOptions.ribbonOptiosn.width' must be specified in GreasedLineRibbonPointsMode.POINTS_MODE_POINTS.";
        const path1 = [];
        const path2 = [];
        if (ribbonInfo.pointsMode === (0, $il6pG.GreasedLineRibbonPointsMode).POINTS_MODE_POINTS) {
            const width = ribbonInfo.width / 2;
            const pointVectors = (0, $btEbG.GreasedLineTools).ToVector3Array(points);
            let direction = null;
            let fatDirection = null;
            if (ribbonInfo.directionsAutoMode === (0, $il6pG.GreasedLineRibbonAutoDirectionMode).AUTO_DIRECTIONS_FROM_FIRST_SEGMENT) // set the direction plane from the first line segment for the whole line
            directionPlane = $d9babe4fb3cdc0d3$export$3e262369320d5a5f._GetDirectionFromPoints(pointVectors[0], pointVectors[1], null);
            for(let i = 0; i < pointVectors.length - (directionPlane ? 0 : 1); i++){
                const p1 = pointVectors[i];
                const p2 = pointVectors[i + 1];
                if (directionPlane) direction = directionPlane;
                else if (ribbonInfo.directionsAutoMode === (0, $il6pG.GreasedLineRibbonAutoDirectionMode).AUTO_DIRECTIONS_FROM_ALL_SEGMENTS) direction = $d9babe4fb3cdc0d3$export$3e262369320d5a5f._GetDirectionFromPoints(p1, p2, direction);
                else {
                    // GreasedLineRibbonAutoDirectionMode.DIRECTION_ENHANCED
                    const directionTemp = p2.subtract(p1);
                    directionTemp.applyRotationQuaternionInPlace(directionTemp.x > directionTemp.y && directionTemp.x > directionTemp.z ? rightHandedSystem ? $d9babe4fb3cdc0d3$export$3e262369320d5a5f._RightHandedForwardReadOnlyQuaternion : $d9babe4fb3cdc0d3$export$3e262369320d5a5f._LeftHandedForwardReadOnlyQuaternion : $d9babe4fb3cdc0d3$export$3e262369320d5a5f._LeftReadOnlyQuaternion);
                    direction = directionTemp.normalize();
                }
                fatDirection = direction.multiplyByFloats(width, width, width);
                path1.push(p1.add(fatDirection));
                path2.push(p1.subtract(fatDirection));
            }
            if (!directionPlane) {
                path1.push(pointVectors[pointVectors.length - 1].add(fatDirection));
                path2.push(pointVectors[pointVectors.length - 1].subtract(fatDirection));
            }
        }
        return [
            path1,
            path2
        ];
    }
    static _GetDirectionFromPoints(p1, p2, previousDirection) {
        // handle straight lines
        if (p1.x === p2.x && (!previousDirection || previousDirection?.x === 1)) return $d9babe4fb3cdc0d3$export$3e262369320d5a5f.DIRECTION_YZ;
        if (p1.y === p2.y) return $d9babe4fb3cdc0d3$export$3e262369320d5a5f.DIRECTION_XZ;
        if (p1.z === p2.z) return $d9babe4fb3cdc0d3$export$3e262369320d5a5f.DIRECTION_XY;
        return $d9babe4fb3cdc0d3$export$3e262369320d5a5f.DIRECTION_XZ;
    }
    /**
     * Clones the GreasedLineRibbonMesh.
     * @param name new line name
     * @param newParent new parent node
     * @returns cloned line
     */ clone(name = `${this.name}-cloned`, newParent) {
        const lineOptions = this._createLineOptions();
        const deepCopiedLineOptions = {};
        const pathOptionsCloned = [];
        (0, $fhgis.DeepCopier).DeepCopy(this._pathsOptions, pathOptionsCloned, undefined, undefined, true);
        (0, $fhgis.DeepCopier).DeepCopy(lineOptions, deepCopiedLineOptions, [
            "instance"
        ], undefined, true);
        const cloned = new $d9babe4fb3cdc0d3$export$3e262369320d5a5f(name, this._scene, deepCopiedLineOptions, pathOptionsCloned);
        if (newParent) cloned.parent = newParent;
        cloned.material = this.material;
        return cloned;
    }
    /**
     * Serializes this GreasedLineRibbonMesh
     * @param serializationObject object to write serialization to
     */ serialize(serializationObject) {
        super.serialize(serializationObject);
        serializationObject.type = this.getClassName();
        serializationObject.lineOptions = this._createLineOptions();
        serializationObject.pathsOptions = this._pathsOptions;
    }
    /**
     * Parses a serialized GreasedLineRibbonMesh
     * @param parsedMesh the serialized GreasedLineRibbonMesh
     * @param scene the scene to create the GreasedLineRibbonMesh in
     * @returns the created GreasedLineRibbonMesh
     */ static Parse(parsedMesh, scene) {
        const lineOptions = parsedMesh.lineOptions;
        const name = parsedMesh.name;
        const pathOptions = parsedMesh.pathOptions;
        const result = new $d9babe4fb3cdc0d3$export$3e262369320d5a5f(name, scene, lineOptions, pathOptions);
        return result;
    }
    _initGreasedLine() {
        super._initGreasedLine();
        this._paths = [];
        this._counters = [];
        this._slopes = [];
        this._ribbonWidths = [];
    }
    _calculateSegmentLengths(pathArray) {
        const pathArrayLength = pathArray.length;
        this._vSegmentLengths = new Array(pathArrayLength);
        this._vTotalLengths = new Array(pathArrayLength);
        let length = 0;
        for(let pi = 0; pi < pathArrayLength; pi++){
            const points = pathArray[pi];
            this._vSegmentLengths[pi] = [
                0
            ]; // first point has 0 distance
            length = 0;
            for(let i = 0; i < points.length - 1; i++){
                const l = Math.abs(points[i].subtract(points[i + 1]).lengthSquared()); // it's ok to have lengthSquared() here
                length += l;
                this._vSegmentLengths[pi].push(l);
            }
            this._vTotalLengths[pi] = length;
        }
        const positionsLength = pathArray[0].length;
        this._uSegmentLengths = new Array(positionsLength).fill([]);
        this._uTotalLengths = new Array(positionsLength).fill([]);
        const uLength = new (0, $ha1VO.Vector3)();
        for(let i = 0; i < positionsLength; i++){
            length = 0;
            for(let pi = 1; pi < pathArrayLength; pi++){
                pathArray[pi][i].subtractToRef(pathArray[pi - 1][i], uLength);
                const l = uLength.length(); // must be length()
                length += l;
                this._uSegmentLengths[i].push(l);
            }
            this._uTotalLengths[i] = length;
        }
    }
    static _CalculateSlopes(paths) {
        const points1 = paths[0];
        const points2 = paths.length === 2 ? paths[1] : paths[paths.length - 1];
        const slopes = [];
        const slope = new (0, $ha1VO.Vector3)();
        for(let i = 0; i < points1.length; i++){
            for(let pi = 0; pi < paths.length; pi++)if (pi === 0 || pi === paths.length - 1) {
                points1[i].subtract(points2[i]).normalizeToRef(slope);
                slopes.push(slope.x, slope.y, slope.z);
                slopes.push(-slope.x, -slope.y, -slope.z);
            } else slopes.push(0, 0, 0, 0, 0, 0);
        }
        return slopes;
    }
    _createVertexBuffers() {
        this._uvs = this._options.uvs ?? this._uvs;
        const vertexData = super._createVertexBuffers(this._options.ribbonOptions?.smoothShading);
        const countersBuffer = new (0, $b4i1f.Buffer)(this._engine, this._counters, this._updatable, 1);
        this.setVerticesBuffer(countersBuffer.createVertexBuffer("grl_counters", 0, 1));
        const colorPointersBuffer = new (0, $b4i1f.Buffer)(this._engine, this._colorPointers, this._updatable, 1);
        this.setVerticesBuffer(colorPointersBuffer.createVertexBuffer("grl_colorPointers", 0, 1));
        const slopesBuffer = new (0, $b4i1f.Buffer)(this._engine, this._slopes, this._updatable, 3);
        this.setVerticesBuffer(slopesBuffer.createVertexBuffer("grl_slopes", 0, 3));
        const widthsBuffer = new (0, $b4i1f.Buffer)(this._engine, this._ribbonWidths, this._updatable, 1);
        this.setVerticesBuffer(widthsBuffer.createVertexBuffer("grl_widths", 0, 1));
        this._widthsBuffer = widthsBuffer;
        return vertexData;
    }
}
/**
 * Default line width
 */ $d9babe4fb3cdc0d3$export$3e262369320d5a5f.DEFAULT_WIDTH = 0.1;
$d9babe4fb3cdc0d3$export$3e262369320d5a5f._RightHandedForwardReadOnlyQuaternion = (0, $ha1VO.Quaternion).RotationAxis((0, $ha1VO.Vector3).RightHandedForwardReadOnly, Math.PI / 2);
$d9babe4fb3cdc0d3$export$3e262369320d5a5f._LeftHandedForwardReadOnlyQuaternion = (0, $ha1VO.Quaternion).RotationAxis((0, $ha1VO.Vector3).LeftHandedForwardReadOnly, Math.PI / 2);
$d9babe4fb3cdc0d3$export$3e262369320d5a5f._LeftReadOnlyQuaternion = (0, $ha1VO.Quaternion).RotationAxis((0, $ha1VO.Vector3).LeftReadOnly, Math.PI / 2);
/**
 * Direction which the line segment will be thickened if drawn on the XY plane
 */ $d9babe4fb3cdc0d3$export$3e262369320d5a5f.DIRECTION_XY = (0, $ha1VO.Vector3).LeftHandedForwardReadOnly; // doesn't matter in which handed system the scene operates
/**
 * Direction which the line segment will be thickened if drawn on the XZ plane
 */ $d9babe4fb3cdc0d3$export$3e262369320d5a5f.DIRECTION_XZ = (0, $ha1VO.Vector3).UpReadOnly;
/**
 * Direction which the line segment will be thickened if drawn on the YZ plane
 */ $d9babe4fb3cdc0d3$export$3e262369320d5a5f.DIRECTION_YZ = (0, $ha1VO.Vector3).LeftReadOnly;

});



parcelRegister("5DCzZ", function(module, exports) {

var $fbuqw = parcelRequire("fbuqw");

var $b4i1f = parcelRequire("b4i1f");

var $ha1VO = parcelRequire("ha1VO");

var $kVtWi = parcelRequire("kVtWi");

var $ef012 = parcelRequire("ef012");
(0, $fbuqw.Mesh).prototype.thinInstanceAdd = function(matrix, refresh = true) {
    if (!this.getScene().getEngine().getCaps().instancedArrays) {
        (0, $kVtWi.Logger).Error("Thin Instances are not supported on this device as Instanced Array extension not supported");
        return -1;
    }
    this._thinInstanceUpdateBufferSize("matrix", Array.isArray(matrix) ? matrix.length : 1);
    const index = this._thinInstanceDataStorage.instancesCount;
    if (Array.isArray(matrix)) for(let i = 0; i < matrix.length; ++i)this.thinInstanceSetMatrixAt(this._thinInstanceDataStorage.instancesCount++, matrix[i], i === matrix.length - 1 && refresh);
    else this.thinInstanceSetMatrixAt(this._thinInstanceDataStorage.instancesCount++, matrix, refresh);
    return index;
};
(0, $fbuqw.Mesh).prototype.thinInstanceAddSelf = function(refresh = true) {
    return this.thinInstanceAdd((0, $ha1VO.Matrix).IdentityReadOnly, refresh);
};
(0, $fbuqw.Mesh).prototype.thinInstanceRegisterAttribute = function(kind, stride) {
    // preserve backward compatibility
    if (kind === (0, $b4i1f.VertexBuffer).ColorKind) kind = (0, $b4i1f.VertexBuffer).ColorInstanceKind;
    this.removeVerticesData(kind);
    this._thinInstanceInitializeUserStorage();
    this._userThinInstanceBuffersStorage.strides[kind] = stride;
    this._userThinInstanceBuffersStorage.sizes[kind] = stride * Math.max(32, this._thinInstanceDataStorage.instancesCount); // Initial size
    this._userThinInstanceBuffersStorage.data[kind] = new Float32Array(this._userThinInstanceBuffersStorage.sizes[kind]);
    this._userThinInstanceBuffersStorage.vertexBuffers[kind] = new (0, $b4i1f.VertexBuffer)(this.getEngine(), this._userThinInstanceBuffersStorage.data[kind], kind, true, false, stride, true);
    this.setVerticesBuffer(this._userThinInstanceBuffersStorage.vertexBuffers[kind]);
};
(0, $fbuqw.Mesh).prototype.thinInstanceSetMatrixAt = function(index, matrix, refresh = true) {
    if (!this._thinInstanceDataStorage.matrixData || index >= this._thinInstanceDataStorage.instancesCount) return false;
    const matrixData = this._thinInstanceDataStorage.matrixData;
    matrix.copyToArray(matrixData, index * 16);
    if (this._thinInstanceDataStorage.worldMatrices) this._thinInstanceDataStorage.worldMatrices[index] = matrix;
    if (refresh) {
        this.thinInstanceBufferUpdated("matrix");
        if (!this.doNotSyncBoundingInfo) this.thinInstanceRefreshBoundingInfo(false);
    }
    return true;
};
(0, $fbuqw.Mesh).prototype.thinInstanceSetAttributeAt = function(kind, index, value, refresh = true) {
    // preserve backward compatibility
    if (kind === (0, $b4i1f.VertexBuffer).ColorKind) kind = (0, $b4i1f.VertexBuffer).ColorInstanceKind;
    if (!this._userThinInstanceBuffersStorage || !this._userThinInstanceBuffersStorage.data[kind] || index >= this._thinInstanceDataStorage.instancesCount) return false;
    this._thinInstanceUpdateBufferSize(kind, 0); // make sur the buffer for the kind attribute is big enough
    this._userThinInstanceBuffersStorage.data[kind].set(value, index * this._userThinInstanceBuffersStorage.strides[kind]);
    if (refresh) this.thinInstanceBufferUpdated(kind);
    return true;
};
Object.defineProperty((0, $fbuqw.Mesh).prototype, "thinInstanceCount", {
    get: function() {
        return this._thinInstanceDataStorage.instancesCount;
    },
    set: function(value) {
        const matrixData = this._thinInstanceDataStorage.matrixData ?? this.source?._thinInstanceDataStorage.matrixData;
        const numMaxInstances = matrixData ? matrixData.length / 16 : 0;
        if (value <= numMaxInstances) this._thinInstanceDataStorage.instancesCount = value;
    },
    enumerable: true,
    configurable: true
});
(0, $fbuqw.Mesh).prototype._thinInstanceCreateMatrixBuffer = function(kind, buffer, staticBuffer = true) {
    const matrixBuffer = new (0, $b4i1f.Buffer)(this.getEngine(), buffer, !staticBuffer, 16, false, true);
    for(let i = 0; i < 4; i++)this.setVerticesBuffer(matrixBuffer.createVertexBuffer(kind + i, i * 4, 4));
    return matrixBuffer;
};
(0, $fbuqw.Mesh).prototype.thinInstanceSetBuffer = function(kind, buffer, stride = 0, staticBuffer = true) {
    stride = stride || 16;
    if (kind === "matrix") {
        this._thinInstanceDataStorage.matrixBuffer?.dispose();
        this._thinInstanceDataStorage.matrixBuffer = null;
        this._thinInstanceDataStorage.matrixBufferSize = buffer ? buffer.length : 32 * stride;
        this._thinInstanceDataStorage.matrixData = buffer;
        this._thinInstanceDataStorage.worldMatrices = null;
        if (buffer !== null) {
            this._thinInstanceDataStorage.instancesCount = buffer.length / stride;
            this._thinInstanceDataStorage.matrixBuffer = this._thinInstanceCreateMatrixBuffer("world", buffer, staticBuffer);
            if (!this.doNotSyncBoundingInfo) this.thinInstanceRefreshBoundingInfo(false);
        } else {
            this._thinInstanceDataStorage.instancesCount = 0;
            if (!this.doNotSyncBoundingInfo) // mesh has no more thin instances, so need to recompute the bounding box because it's the regular mesh that will now be displayed
            this.refreshBoundingInfo();
        }
    } else if (kind === "previousMatrix") {
        this._thinInstanceDataStorage.previousMatrixBuffer?.dispose();
        this._thinInstanceDataStorage.previousMatrixBuffer = null;
        this._thinInstanceDataStorage.previousMatrixData = buffer;
        if (buffer !== null) this._thinInstanceDataStorage.previousMatrixBuffer = this._thinInstanceCreateMatrixBuffer("previousWorld", buffer, staticBuffer);
    } else {
        // color for instanced mesh is ColorInstanceKind and not ColorKind because of native that needs to do the differenciation
        // hot switching kind here to preserve backward compatibility
        if (kind === (0, $b4i1f.VertexBuffer).ColorKind) kind = (0, $b4i1f.VertexBuffer).ColorInstanceKind;
        if (buffer === null) {
            if (this._userThinInstanceBuffersStorage?.data[kind]) {
                this.removeVerticesData(kind);
                delete this._userThinInstanceBuffersStorage.data[kind];
                delete this._userThinInstanceBuffersStorage.strides[kind];
                delete this._userThinInstanceBuffersStorage.sizes[kind];
                delete this._userThinInstanceBuffersStorage.vertexBuffers[kind];
            }
        } else {
            this._thinInstanceInitializeUserStorage();
            this._userThinInstanceBuffersStorage.data[kind] = buffer;
            this._userThinInstanceBuffersStorage.strides[kind] = stride;
            this._userThinInstanceBuffersStorage.sizes[kind] = buffer.length;
            this._userThinInstanceBuffersStorage.vertexBuffers[kind] = new (0, $b4i1f.VertexBuffer)(this.getEngine(), buffer, kind, !staticBuffer, false, stride, true);
            this.setVerticesBuffer(this._userThinInstanceBuffersStorage.vertexBuffers[kind]);
        }
    }
};
(0, $fbuqw.Mesh).prototype.thinInstanceBufferUpdated = function(kind) {
    if (kind === "matrix") {
        if (this.thinInstanceAllowAutomaticStaticBufferRecreation && this._thinInstanceDataStorage.matrixBuffer && !this._thinInstanceDataStorage.matrixBuffer.isUpdatable()) this._thinInstanceRecreateBuffer(kind);
        this._thinInstanceDataStorage.matrixBuffer?.updateDirectly(this._thinInstanceDataStorage.matrixData, 0, this._thinInstanceDataStorage.instancesCount);
    } else if (kind === "previousMatrix") {
        if (this.thinInstanceAllowAutomaticStaticBufferRecreation && this._thinInstanceDataStorage.previousMatrixBuffer && !this._thinInstanceDataStorage.previousMatrixBuffer.isUpdatable()) this._thinInstanceRecreateBuffer(kind);
        this._thinInstanceDataStorage.previousMatrixBuffer?.updateDirectly(this._thinInstanceDataStorage.previousMatrixData, 0, this._thinInstanceDataStorage.instancesCount);
    } else {
        // preserve backward compatibility
        if (kind === (0, $b4i1f.VertexBuffer).ColorKind) kind = (0, $b4i1f.VertexBuffer).ColorInstanceKind;
        if (this._userThinInstanceBuffersStorage?.vertexBuffers[kind]) {
            if (this.thinInstanceAllowAutomaticStaticBufferRecreation && !this._userThinInstanceBuffersStorage.vertexBuffers[kind].isUpdatable()) this._thinInstanceRecreateBuffer(kind);
            this._userThinInstanceBuffersStorage.vertexBuffers[kind].updateDirectly(this._userThinInstanceBuffersStorage.data[kind], 0);
        }
    }
};
(0, $fbuqw.Mesh).prototype.thinInstancePartialBufferUpdate = function(kind, data, offset) {
    if (kind === "matrix") {
        if (this._thinInstanceDataStorage.matrixBuffer) this._thinInstanceDataStorage.matrixBuffer.updateDirectly(data, offset);
    } else {
        // preserve backward compatibility
        if (kind === (0, $b4i1f.VertexBuffer).ColorKind) kind = (0, $b4i1f.VertexBuffer).ColorInstanceKind;
        if (this._userThinInstanceBuffersStorage?.vertexBuffers[kind]) this._userThinInstanceBuffersStorage.vertexBuffers[kind].updateDirectly(data, offset);
    }
};
(0, $fbuqw.Mesh).prototype.thinInstanceGetWorldMatrices = function() {
    if (!this._thinInstanceDataStorage.matrixData || !this._thinInstanceDataStorage.matrixBuffer) return [];
    const matrixData = this._thinInstanceDataStorage.matrixData;
    if (!this._thinInstanceDataStorage.worldMatrices) {
        this._thinInstanceDataStorage.worldMatrices = [];
        for(let i = 0; i < this._thinInstanceDataStorage.instancesCount; ++i)this._thinInstanceDataStorage.worldMatrices[i] = (0, $ha1VO.Matrix).FromArray(matrixData, i * 16);
    }
    return this._thinInstanceDataStorage.worldMatrices;
};
(0, $fbuqw.Mesh).prototype.thinInstanceRefreshBoundingInfo = function(forceRefreshParentInfo = false, applySkeleton = false, applyMorph = false) {
    if (!this._thinInstanceDataStorage.matrixData || !this._thinInstanceDataStorage.matrixBuffer) return;
    const vectors = this._thinInstanceDataStorage.boundingVectors;
    if (forceRefreshParentInfo || !this.rawBoundingInfo) {
        vectors.length = 0;
        this.refreshBoundingInfo(applySkeleton, applyMorph);
        const boundingInfo = this.getBoundingInfo();
        this.rawBoundingInfo = new (0, $ef012.BoundingInfo)(boundingInfo.minimum, boundingInfo.maximum);
    }
    const boundingInfo = this.getBoundingInfo();
    const matrixData = this._thinInstanceDataStorage.matrixData;
    if (vectors.length === 0) for(let v = 0; v < boundingInfo.boundingBox.vectors.length; ++v)vectors.push(boundingInfo.boundingBox.vectors[v].clone());
    (0, $ha1VO.TmpVectors).Vector3[0].setAll(Number.POSITIVE_INFINITY); // min
    (0, $ha1VO.TmpVectors).Vector3[1].setAll(Number.NEGATIVE_INFINITY); // max
    for(let i = 0; i < this._thinInstanceDataStorage.instancesCount; ++i){
        (0, $ha1VO.Matrix).FromArrayToRef(matrixData, i * 16, (0, $ha1VO.TmpVectors).Matrix[0]);
        for(let v = 0; v < vectors.length; ++v){
            (0, $ha1VO.Vector3).TransformCoordinatesToRef(vectors[v], (0, $ha1VO.TmpVectors).Matrix[0], (0, $ha1VO.TmpVectors).Vector3[2]);
            (0, $ha1VO.TmpVectors).Vector3[0].minimizeInPlace((0, $ha1VO.TmpVectors).Vector3[2]);
            (0, $ha1VO.TmpVectors).Vector3[1].maximizeInPlace((0, $ha1VO.TmpVectors).Vector3[2]);
        }
    }
    boundingInfo.reConstruct((0, $ha1VO.TmpVectors).Vector3[0], (0, $ha1VO.TmpVectors).Vector3[1]);
    this._updateBoundingInfo();
};
(0, $fbuqw.Mesh).prototype._thinInstanceRecreateBuffer = function(kind, staticBuffer = true) {
    if (kind === "matrix") {
        this._thinInstanceDataStorage.matrixBuffer?.dispose();
        this._thinInstanceDataStorage.matrixBuffer = this._thinInstanceCreateMatrixBuffer("world", this._thinInstanceDataStorage.matrixData, staticBuffer);
    } else if (kind === "previousMatrix") {
        if (this._scene.needsPreviousWorldMatrices) {
            this._thinInstanceDataStorage.previousMatrixBuffer?.dispose();
            this._thinInstanceDataStorage.previousMatrixBuffer = this._thinInstanceCreateMatrixBuffer("previousWorld", this._thinInstanceDataStorage.previousMatrixData ?? this._thinInstanceDataStorage.matrixData, staticBuffer);
        }
    } else {
        if (kind === (0, $b4i1f.VertexBuffer).ColorKind) kind = (0, $b4i1f.VertexBuffer).ColorInstanceKind;
        this._userThinInstanceBuffersStorage.vertexBuffers[kind]?.dispose();
        this._userThinInstanceBuffersStorage.vertexBuffers[kind] = new (0, $b4i1f.VertexBuffer)(this.getEngine(), this._userThinInstanceBuffersStorage.data[kind], kind, !staticBuffer, false, this._userThinInstanceBuffersStorage.strides[kind], true);
        this.setVerticesBuffer(this._userThinInstanceBuffersStorage.vertexBuffers[kind]);
    }
};
(0, $fbuqw.Mesh).prototype._thinInstanceUpdateBufferSize = function(kind, numInstances = 1) {
    // preserve backward compatibility
    if (kind === (0, $b4i1f.VertexBuffer).ColorKind) kind = (0, $b4i1f.VertexBuffer).ColorInstanceKind;
    const kindIsMatrix = kind === "matrix";
    if (!kindIsMatrix && (!this._userThinInstanceBuffersStorage || !this._userThinInstanceBuffersStorage.strides[kind])) return;
    const stride = kindIsMatrix ? 16 : this._userThinInstanceBuffersStorage.strides[kind];
    const currentSize = kindIsMatrix ? this._thinInstanceDataStorage.matrixBufferSize : this._userThinInstanceBuffersStorage.sizes[kind];
    let data = kindIsMatrix ? this._thinInstanceDataStorage.matrixData : this._userThinInstanceBuffersStorage.data[kind];
    const bufferSize = (this._thinInstanceDataStorage.instancesCount + numInstances) * stride;
    let newSize = currentSize;
    while(newSize < bufferSize)newSize *= 2;
    if (!data || currentSize != newSize) {
        if (!data) data = new Float32Array(newSize);
        else {
            const newData = new Float32Array(newSize);
            newData.set(data, 0);
            data = newData;
        }
        if (kindIsMatrix) {
            this._thinInstanceDataStorage.matrixBuffer?.dispose();
            this._thinInstanceDataStorage.matrixBuffer = this._thinInstanceCreateMatrixBuffer("world", data, false);
            this._thinInstanceDataStorage.matrixData = data;
            this._thinInstanceDataStorage.matrixBufferSize = newSize;
            if (this._scene.needsPreviousWorldMatrices && !this._thinInstanceDataStorage.previousMatrixData) {
                this._thinInstanceDataStorage.previousMatrixBuffer?.dispose();
                this._thinInstanceDataStorage.previousMatrixBuffer = this._thinInstanceCreateMatrixBuffer("previousWorld", data, false);
            }
        } else {
            this._userThinInstanceBuffersStorage.vertexBuffers[kind]?.dispose();
            this._userThinInstanceBuffersStorage.data[kind] = data;
            this._userThinInstanceBuffersStorage.sizes[kind] = newSize;
            this._userThinInstanceBuffersStorage.vertexBuffers[kind] = new (0, $b4i1f.VertexBuffer)(this.getEngine(), data, kind, true, false, stride, true);
            this.setVerticesBuffer(this._userThinInstanceBuffersStorage.vertexBuffers[kind]);
        }
    }
};
(0, $fbuqw.Mesh).prototype._thinInstanceInitializeUserStorage = function() {
    if (!this._userThinInstanceBuffersStorage) this._userThinInstanceBuffersStorage = {
        data: {},
        sizes: {},
        vertexBuffers: {},
        strides: {}
    };
};
(0, $fbuqw.Mesh).prototype._disposeThinInstanceSpecificData = function() {
    if (this._thinInstanceDataStorage?.matrixBuffer) {
        this._thinInstanceDataStorage.matrixBuffer.dispose();
        this._thinInstanceDataStorage.matrixBuffer = null;
    }
};

});

parcelRegister("eofEg", function(module, exports) {

var $6ZwMW = parcelRequire("6ZwMW");

var $gJfVN = parcelRequire("gJfVN");

var $8Ik7p = parcelRequire("8Ik7p");

var $492xU = parcelRequire("492xU");

var $eN8Hc = parcelRequire("eN8Hc");

var $4k2Tt = parcelRequire("4k2Tt");

var $8Jk1D = parcelRequire("8Jk1D");

var $6alCW = parcelRequire("6alCW");

var $1F29z = parcelRequire("1F29z");

var $a76QT = parcelRequire("a76QT");

var $jChac = parcelRequire("jChac");

var $gB7vT = parcelRequire("gB7vT");

var $Spfz5 = parcelRequire("Spfz5");

var $eG1cP = parcelRequire("eG1cP");

var $hZjUT = parcelRequire("hZjUT");

var $9nf7R = parcelRequire("9nf7R");

var $7KArL = parcelRequire("7KArL");

var $DaRa4 = parcelRequire("DaRa4");

var $l4YtH = parcelRequire("l4YtH");

var $f877G = parcelRequire("f877G");

var $eCyMX = parcelRequire("eCyMX");

var $kJLgn = parcelRequire("kJLgn");

var $bzxv9 = parcelRequire("bzxv9");

var $agqpv = parcelRequire("agqpv");

var $3sVfn = parcelRequire("3sVfn");

var $6zPal = parcelRequire("6zPal");

var $fJvYG = parcelRequire("fJvYG");

var $7JAyZ = parcelRequire("7JAyZ");

var $cmwmj = parcelRequire("cmwmj");

var $8PlwB = parcelRequire("8PlwB");

var $5f2ez = parcelRequire("5f2ez");

var $9pTV3 = parcelRequire("9pTV3");

var $bK7gN = parcelRequire("bK7gN");

var $i6Ieo = parcelRequire("i6Ieo");

var $euB66 = parcelRequire("euB66");

var $7xBtK = parcelRequire("7xBtK");

var $jagi3 = parcelRequire("jagi3");

var $5z48Y = parcelRequire("5z48Y");

var $3YavI = parcelRequire("3YavI");

var $UvE6e = parcelRequire("UvE6e");

var $jPA08 = parcelRequire("jPA08");

var $55PTw = parcelRequire("55PTw");

var $3RqJm = parcelRequire("3RqJm");

var $hJSiV = parcelRequire("hJSiV");

var $6PcfJ = parcelRequire("6PcfJ");

var $iYgB9 = parcelRequire("iYgB9");

var $k7nXZ = parcelRequire("k7nXZ");

var $31JLU = parcelRequire("31JLU");

var $4ekeI = parcelRequire("4ekeI");

var $fBR0z = parcelRequire("fBR0z");

var $gsIz5 = parcelRequire("gsIz5");

var $7KJHu = parcelRequire("7KJHu");

var $ha5SG = parcelRequire("ha5SG");

var $3i6nP = parcelRequire("3i6nP");

var $lyPDb = parcelRequire("lyPDb");

var $gFhyf = parcelRequire("gFhyf");

var $7IIbf = parcelRequire("7IIbf");

var $hkQGS = parcelRequire("hkQGS");

var $eU5hS = parcelRequire("eU5hS");

var $8OaXC = parcelRequire("8OaXC");

var $cWcKG = parcelRequire("cWcKG");

var $33PHi = parcelRequire("33PHi");

var $l2eEI = parcelRequire("l2eEI");

var $27rlu = parcelRequire("27rlu");

var $dhPzd = parcelRequire("dhPzd");

var $6zhJ5 = parcelRequire("6zhJ5");

var $tfRhS = parcelRequire("tfRhS");

var $fBVNd = parcelRequire("fBVNd");

var $lqLlC = parcelRequire("lqLlC");

var $kPUD7 = parcelRequire("kPUD7");

var $2uBFG = parcelRequire("2uBFG");

var $lJwlI = parcelRequire("lJwlI");

var $gPpPv = parcelRequire("gPpPv");

var $1NNxM = parcelRequire("1NNxM");

var $7r4nc = parcelRequire("7r4nc");

var $3F1M9 = parcelRequire("3F1M9");

var $59Ae6 = parcelRequire("59Ae6");

var $iIMB4 = parcelRequire("iIMB4");

var $6HgjP = parcelRequire("6HgjP");

var $72nAM = parcelRequire("72nAM");
$parcel$exportWildcard(module.exports, $6ZwMW);
$parcel$exportWildcard(module.exports, $gJfVN);
$parcel$exportWildcard(module.exports, $8Ik7p);
$parcel$exportWildcard(module.exports, $492xU);
$parcel$exportWildcard(module.exports, $eN8Hc);
$parcel$exportWildcard(module.exports, $4k2Tt);
$parcel$exportWildcard(module.exports, $8Jk1D);
$parcel$exportWildcard(module.exports, $6alCW);
$parcel$exportWildcard(module.exports, $1F29z);
$parcel$exportWildcard(module.exports, $a76QT);
$parcel$exportWildcard(module.exports, $jChac);
$parcel$exportWildcard(module.exports, $gB7vT);
$parcel$exportWildcard(module.exports, $Spfz5);
$parcel$exportWildcard(module.exports, $eG1cP);
$parcel$exportWildcard(module.exports, $hZjUT);
$parcel$exportWildcard(module.exports, $9nf7R);
$parcel$exportWildcard(module.exports, $7KArL);
$parcel$exportWildcard(module.exports, $DaRa4);
$parcel$exportWildcard(module.exports, $l4YtH);
$parcel$exportWildcard(module.exports, $f877G);
$parcel$exportWildcard(module.exports, $eCyMX);
$parcel$exportWildcard(module.exports, $kJLgn);
$parcel$exportWildcard(module.exports, $bzxv9);
$parcel$exportWildcard(module.exports, $agqpv);
$parcel$exportWildcard(module.exports, $3sVfn);
$parcel$exportWildcard(module.exports, $6zPal);
$parcel$exportWildcard(module.exports, $fJvYG);
$parcel$exportWildcard(module.exports, $7JAyZ);
$parcel$exportWildcard(module.exports, $cmwmj);
$parcel$exportWildcard(module.exports, $8PlwB);
$parcel$exportWildcard(module.exports, $5f2ez);
$parcel$exportWildcard(module.exports, $9pTV3);
$parcel$exportWildcard(module.exports, $bK7gN);
$parcel$exportWildcard(module.exports, $i6Ieo);
$parcel$exportWildcard(module.exports, $euB66);
$parcel$exportWildcard(module.exports, $7xBtK);
$parcel$exportWildcard(module.exports, $jagi3);
$parcel$exportWildcard(module.exports, $5z48Y);
$parcel$exportWildcard(module.exports, $3YavI);
$parcel$exportWildcard(module.exports, $UvE6e);
$parcel$exportWildcard(module.exports, $jPA08);
$parcel$exportWildcard(module.exports, $55PTw);
$parcel$exportWildcard(module.exports, $3RqJm);
$parcel$exportWildcard(module.exports, $hJSiV);
$parcel$exportWildcard(module.exports, $6PcfJ);
$parcel$exportWildcard(module.exports, $iYgB9);
$parcel$exportWildcard(module.exports, $k7nXZ);
$parcel$exportWildcard(module.exports, $31JLU);
$parcel$exportWildcard(module.exports, $4ekeI);
$parcel$exportWildcard(module.exports, $fBR0z);
$parcel$exportWildcard(module.exports, $gsIz5);
$parcel$exportWildcard(module.exports, $7KJHu);
$parcel$exportWildcard(module.exports, $ha5SG);
$parcel$exportWildcard(module.exports, $3i6nP);
$parcel$exportWildcard(module.exports, $lyPDb);
$parcel$exportWildcard(module.exports, $gFhyf);
$parcel$exportWildcard(module.exports, $7IIbf);
$parcel$exportWildcard(module.exports, $hkQGS);
$parcel$exportWildcard(module.exports, $eU5hS);
$parcel$exportWildcard(module.exports, $8OaXC);
$parcel$exportWildcard(module.exports, $cWcKG);
$parcel$exportWildcard(module.exports, $33PHi);
$parcel$exportWildcard(module.exports, $l2eEI);
$parcel$exportWildcard(module.exports, $27rlu);
$parcel$exportWildcard(module.exports, $dhPzd);
$parcel$exportWildcard(module.exports, $6zhJ5);
$parcel$exportWildcard(module.exports, $tfRhS);
$parcel$exportWildcard(module.exports, $fBVNd);
$parcel$exportWildcard(module.exports, $lqLlC);
$parcel$exportWildcard(module.exports, $kPUD7);
$parcel$exportWildcard(module.exports, $2uBFG);
$parcel$exportWildcard(module.exports, $lJwlI);
$parcel$exportWildcard(module.exports, $gPpPv);
$parcel$exportWildcard(module.exports, $1NNxM);
$parcel$exportWildcard(module.exports, $7r4nc);
$parcel$exportWildcard(module.exports, $3F1M9);
$parcel$exportWildcard(module.exports, $59Ae6);
$parcel$exportWildcard(module.exports, $iIMB4);
$parcel$exportWildcard(module.exports, $6HgjP);
$parcel$exportWildcard(module.exports, $72nAM);

});
parcelRegister("6ZwMW", function(module, exports) {

$parcel$export(module.exports, "NodeGeometry", () => $5171dfa5a50acb38$export$c71b0921f91cbff5);

var $e0Suo = parcelRequire("e0Suo");

var $diGQf = parcelRequire("diGQf");

var $fbuqw = parcelRequire("fbuqw");

var $1F29z = parcelRequire("1F29z");

var $492xU = parcelRequire("492xU");

var $8DoUR = parcelRequire("8DoUR");

var $ir0rz = parcelRequire("ir0rz");

var $6Ho1L = parcelRequire("6Ho1L");

var $hUzEl = parcelRequire("hUzEl");

var $gB7vT = parcelRequire("gB7vT");

var $blHSI = parcelRequire("blHSI");

var $bOhSV = parcelRequire("bOhSV");

var $5YkyR = parcelRequire("5YkyR");
class $5171dfa5a50acb38$export$c71b0921f91cbff5 {
    /** @returns the inspector from bundle or global */ _getGlobalNodeGeometryEditor() {
        // UMD Global name detection from Webpack Bundle UMD Name.
        if (typeof NODEGEOMETRYEDITOR !== "undefined") return NODEGEOMETRYEDITOR;
        // In case of module let's check the global emitted from the editor entry point.
        if (typeof BABYLON !== "undefined" && typeof BABYLON.NodeGeometryEditor !== "undefined") return BABYLON;
        return undefined;
    }
    /**
     * Gets the time spent to build this block (in ms)
     */ get buildExecutionTime() {
        return this._buildExecutionTime;
    }
    /**
     * Creates a new geometry
     * @param name defines the name of the geometry
     */ constructor(name){
        this._buildId = $5171dfa5a50acb38$export$c71b0921f91cbff5._BuildIdGenerator++;
        this._buildWasSuccessful = false;
        this._vertexData = null;
        this._buildExecutionTime = 0;
        // eslint-disable-next-line @typescript-eslint/naming-convention
        this.BJSNODEGEOMETRYEDITOR = this._getGlobalNodeGeometryEditor();
        /**
         * Gets or sets data used by visual editor
         * @see https://nge.babylonjs.com
         */ this.editorData = null;
        /**
         * Gets an array of blocks that needs to be serialized even if they are not yet connected
         */ this.attachedBlocks = [];
        /**
         * Observable raised when the geometry is built
         */ this.onBuildObservable = new (0, $diGQf.Observable)();
        /** Gets or sets the GeometryOutputBlock used to gather the final geometry data */ this.outputBlock = null;
        this.name = name;
    }
    /**
     * Gets the current class name of the geometry e.g. "NodeGeometry"
     * @returns the class name
     */ getClassName() {
        return "NodeGeometry";
    }
    /**
     * Get a block by its name
     * @param name defines the name of the block to retrieve
     * @returns the required block or null if not found
     */ getBlockByName(name) {
        let result = null;
        for (const block of this.attachedBlocks)if (block.name === name) {
            if (!result) result = block;
            else {
                (0, $bOhSV.Tools).Warn("More than one block was found with the name `" + name + "`");
                return result;
            }
        }
        return result;
    }
    /**
     * Get a block using a predicate
     * @param predicate defines the predicate used to find the good candidate
     * @returns the required block or null if not found
     */ getBlockByPredicate(predicate) {
        for (const block of this.attachedBlocks){
            if (predicate(block)) return block;
        }
        return null;
    }
    /**
     * Gets the list of input blocks attached to this material
     * @returns an array of InputBlocks
     */ getInputBlocks() {
        const blocks = [];
        for (const block of this.attachedBlocks)if (block.isInput) blocks.push(block);
        return blocks;
    }
    /**
     * Launch the node geometry editor
     * @param config Define the configuration of the editor
     * @returns a promise fulfilled when the node editor is visible
     */ edit(config) {
        return new Promise((resolve)=>{
            this.BJSNODEGEOMETRYEDITOR = this.BJSNODEGEOMETRYEDITOR || this._getGlobalNodeGeometryEditor();
            if (typeof this.BJSNODEGEOMETRYEDITOR == "undefined") {
                const editorUrl = config && config.editorURL ? config.editorURL : $5171dfa5a50acb38$export$c71b0921f91cbff5.EditorURL;
                // Load editor and add it to the DOM
                (0, $bOhSV.Tools).LoadBabylonScript(editorUrl, ()=>{
                    this.BJSNODEGEOMETRYEDITOR = this.BJSNODEGEOMETRYEDITOR || this._getGlobalNodeGeometryEditor();
                    this._createNodeEditor(config?.nodeGeometryEditorConfig);
                    resolve();
                });
            } else {
                // Otherwise creates the editor
                this._createNodeEditor(config?.nodeGeometryEditorConfig);
                resolve();
            }
        });
    }
    /**
     * Creates the node editor window.
     * @param additionalConfig Additional configuration for the NGE
     */ _createNodeEditor(additionalConfig) {
        const nodeEditorConfig = {
            nodeGeometry: this,
            ...additionalConfig
        };
        this.BJSNODEGEOMETRYEDITOR.NodeGeometryEditor.Show(nodeEditorConfig);
    }
    /**
     * Build the final geometry
     * @param verbose defines if the build should log activity
     * @param updateBuildId defines if the internal build Id should be updated (default is true)
     * @param autoConfigure defines if the autoConfigure method should be called when initializing blocks (default is false)
     */ build(verbose = false, updateBuildId = true, autoConfigure = false) {
        this._buildWasSuccessful = false;
        if (!this.outputBlock) // eslint-disable-next-line no-throw-literal
        throw "You must define the outputBlock property before building the geometry";
        const now = (0, $blHSI.PrecisionDate).Now;
        // Initialize blocks
        this._initializeBlock(this.outputBlock, autoConfigure);
        // Build
        const state = new (0, $492xU.NodeGeometryBuildState)();
        state.buildId = this._buildId;
        state.verbose = verbose;
        this.outputBlock.build(state);
        if (updateBuildId) this._buildId = $5171dfa5a50acb38$export$c71b0921f91cbff5._BuildIdGenerator++;
        this._buildExecutionTime = (0, $blHSI.PrecisionDate).Now - now;
        // Errors
        state.emitErrors();
        this._buildWasSuccessful = true;
        this._vertexData = state.vertexData;
        this.onBuildObservable.notifyObservers(this);
    }
    /**
     * Creates a mesh from the geometry blocks
     * @param name defines the name of the mesh
     * @param scene The scene the mesh is scoped to
     * @returns The new mesh
     */ createMesh(name, scene = null) {
        if (!this._buildWasSuccessful) this.build();
        if (!this._vertexData) return null;
        const mesh = new (0, $fbuqw.Mesh)(name, scene);
        this._vertexData.applyToMesh(mesh);
        mesh._internalMetadata = mesh._internalMetadata || {};
        mesh._internalMetadata.nodeGeometry = this;
        return mesh;
    }
    /**
     * Creates a mesh from the geometry blocks
     * @param mesh the mesh to update
     * @returns True if successfully updated
     */ updateMesh(mesh) {
        if (!this._buildWasSuccessful) this.build();
        if (!this._vertexData) return false;
        this._vertexData.applyToMesh(mesh);
        mesh._internalMetadata = mesh._internalMetadata || {};
        mesh._internalMetadata.nodeGeometry = this;
        return mesh;
    }
    _initializeBlock(node, autoConfigure = true) {
        node.initialize();
        if (autoConfigure) node.autoConfigure();
        node._preparationId = this._buildId;
        if (this.attachedBlocks.indexOf(node) === -1) this.attachedBlocks.push(node);
        for (const input of node.inputs){
            const connectedPoint = input.connectedPoint;
            if (connectedPoint) {
                const block = connectedPoint.ownerBlock;
                if (block !== node) this._initializeBlock(block, autoConfigure);
            }
        }
    }
    /**
     * Clear the current geometry
     */ clear() {
        this.outputBlock = null;
        this.attachedBlocks.length = 0;
    }
    /**
     * Remove a block from the current geometry
     * @param block defines the block to remove
     */ removeBlock(block) {
        const attachedBlockIndex = this.attachedBlocks.indexOf(block);
        if (attachedBlockIndex > -1) this.attachedBlocks.splice(attachedBlockIndex, 1);
        if (block === this.outputBlock) this.outputBlock = null;
    }
    /**
     * Clear the current graph and load a new one from a serialization object
     * @param source defines the JSON representation of the geometry
     * @param merge defines whether or not the source must be merged or replace the current content
     */ parseSerializedObject(source, merge = false) {
        if (!merge) this.clear();
        const map = {};
        // Create blocks
        for (const parsedBlock of source.blocks){
            const blockType = (0, $8DoUR.GetClass)(parsedBlock.customType);
            if (blockType) {
                const block = new blockType();
                block._deserialize(parsedBlock);
                map[parsedBlock.id] = block;
                this.attachedBlocks.push(block);
            }
        }
        // Reconnect teleportation
        for (const block of this.attachedBlocks)if (block.isTeleportOut) {
            const teleportOut = block;
            const id = teleportOut._tempEntryPointUniqueId;
            if (id) {
                const source = map[id];
                if (source) source.attachToEndpoint(teleportOut);
            }
        }
        // Connections - Starts with input blocks only (except if in "merge" mode where we scan all blocks)
        for(let blockIndex = 0; blockIndex < source.blocks.length; blockIndex++){
            const parsedBlock = source.blocks[blockIndex];
            const block = map[parsedBlock.id];
            if (!block) continue;
            if (block.inputs.length && parsedBlock.inputs.some((i)=>i.targetConnectionName) && !merge) continue;
            this._restoreConnections(block, source, map);
        }
        // Outputs
        if (source.outputNodeId) this.outputBlock = map[source.outputNodeId];
        // UI related info
        if (source.locations || source.editorData && source.editorData.locations) {
            const locations = source.locations || source.editorData.locations;
            for (const location of locations)if (map[location.blockId]) location.blockId = map[location.blockId].uniqueId;
            if (merge && this.editorData && this.editorData.locations) locations.concat(this.editorData.locations);
            if (source.locations) this.editorData = {
                locations: locations
            };
            else {
                this.editorData = source.editorData;
                this.editorData.locations = locations;
            }
            const blockMap = [];
            for(const key in map)blockMap[key] = map[key].uniqueId;
            this.editorData.map = blockMap;
        }
        this.comment = source.comment;
    }
    _restoreConnections(block, source, map) {
        for (const outputPoint of block.outputs)for (const candidate of source.blocks){
            const target = map[candidate.id];
            if (!target) continue;
            for (const input of candidate.inputs)if (map[input.targetBlockId] === block && input.targetConnectionName === outputPoint.name) {
                const inputPoint = target.getInputByName(input.inputName);
                if (!inputPoint || inputPoint.isConnected) continue;
                outputPoint.connectTo(inputPoint, true);
                this._restoreConnections(target, source, map);
                continue;
            }
        }
    }
    /**
     * Generate a string containing the code declaration required to create an equivalent of this geometry
     * @returns a string
     */ generateCode() {
        let alreadyDumped = [];
        const blocks = [];
        const uniqueNames = [
            "const",
            "var",
            "let"
        ];
        // Gets active blocks
        if (this.outputBlock) this._gatherBlocks(this.outputBlock, blocks);
        // Generate
        let codeString = `let nodeGeometry = new BABYLON.NodeGeometry("${this.name || "node geometry"}");\n`;
        for (const node of blocks)if (node.isInput && alreadyDumped.indexOf(node) === -1) codeString += node._dumpCode(uniqueNames, alreadyDumped);
        if (this.outputBlock) {
            // Connections
            alreadyDumped = [];
            codeString += "// Connections\n";
            codeString += this.outputBlock._dumpCodeForOutputConnections(alreadyDumped);
            // Output nodes
            codeString += "// Output nodes\n";
            codeString += `nodeGeometry.outputBlock = ${this.outputBlock._codeVariableName};\n`;
            codeString += `nodeGeometry.build();\n`;
        }
        return codeString;
    }
    _gatherBlocks(rootNode, list) {
        if (list.indexOf(rootNode) !== -1) return;
        list.push(rootNode);
        for (const input of rootNode.inputs){
            const connectedPoint = input.connectedPoint;
            if (connectedPoint) {
                const block = connectedPoint.ownerBlock;
                if (block !== rootNode) this._gatherBlocks(block, list);
            }
        }
        // Teleportation
        if (rootNode.isTeleportOut) {
            const block = rootNode;
            if (block.entryPoint) this._gatherBlocks(block.entryPoint, list);
        }
    }
    /**
     * Clear the current geometry and set it to a default state
     */ setToDefault() {
        this.clear();
        this.editorData = null;
        // Source
        const dataBlock = new (0, $gB7vT.BoxBlock)("Box");
        dataBlock.autoConfigure();
        // Final output
        const output = new (0, $1F29z.GeometryOutputBlock)("Geometry Output");
        dataBlock.geometry.connectTo(output.geometry);
        this.outputBlock = output;
    }
    /**
     * Makes a duplicate of the current geometry.
     * @param name defines the name to use for the new geometry
     * @returns the new geometry
     */ clone(name) {
        const serializationObject = this.serialize();
        const clone = (0, $6Ho1L.SerializationHelper).Clone(()=>new $5171dfa5a50acb38$export$c71b0921f91cbff5(name), this);
        clone.name = name;
        clone.parseSerializedObject(serializationObject);
        clone._buildId = this._buildId;
        clone.build(false);
        return clone;
    }
    /**
     * Serializes this geometry in a JSON representation
     * @param selectedBlocks defines the list of blocks to save (if null the whole geometry will be saved)
     * @returns the serialized geometry object
     */ serialize(selectedBlocks) {
        const serializationObject = selectedBlocks ? {} : (0, $6Ho1L.SerializationHelper).Serialize(this);
        serializationObject.editorData = JSON.parse(JSON.stringify(this.editorData)); // Copy
        let blocks = [];
        if (selectedBlocks) blocks = selectedBlocks;
        else {
            serializationObject.customType = "BABYLON.NodeGeometry";
            if (this.outputBlock) serializationObject.outputNodeId = this.outputBlock.uniqueId;
        }
        // Blocks
        serializationObject.blocks = [];
        for (const block of blocks)serializationObject.blocks.push(block.serialize());
        if (!selectedBlocks) for (const block of this.attachedBlocks){
            if (blocks.indexOf(block) !== -1) continue;
            serializationObject.blocks.push(block.serialize());
        }
        return serializationObject;
    }
    /**
     * Disposes the ressources
     */ dispose() {
        for (const block of this.attachedBlocks)block.dispose();
        this.attachedBlocks.length = 0;
        this.onBuildObservable.clear();
    }
    /**
     * Creates a new node geometry set to default basic configuration
     * @param name defines the name of the geometry
     * @returns a new NodeGeometry
     */ static CreateDefault(name) {
        const nodeGeometry = new $5171dfa5a50acb38$export$c71b0921f91cbff5(name);
        nodeGeometry.setToDefault();
        nodeGeometry.build();
        return nodeGeometry;
    }
    /**
     * Creates a node geometry from parsed geometry data
     * @param source defines the JSON representation of the geometry
     * @returns a new node geometry
     */ static Parse(source) {
        const nodeGeometry = (0, $6Ho1L.SerializationHelper).Parse(()=>new $5171dfa5a50acb38$export$c71b0921f91cbff5(source.name), source, null);
        nodeGeometry.parseSerializedObject(source);
        nodeGeometry.build();
        return nodeGeometry;
    }
    /**
     * Creates a node geometry from a snippet saved by the node geometry editor
     * @param snippetId defines the snippet to load
     * @param nodeGeometry defines a node geometry to update (instead of creating a new one)
     * @param skipBuild defines whether to build the node geometry
     * @returns a promise that will resolve to the new node geometry
     */ static ParseFromSnippetAsync(snippetId, nodeGeometry, skipBuild = false) {
        if (snippetId === "_BLANK") return Promise.resolve($5171dfa5a50acb38$export$c71b0921f91cbff5.CreateDefault("blank"));
        return new Promise((resolve, reject)=>{
            const request = new (0, $hUzEl.WebRequest)();
            request.addEventListener("readystatechange", ()=>{
                if (request.readyState == 4) {
                    if (request.status == 200) {
                        const snippet = JSON.parse(JSON.parse(request.responseText).jsonPayload);
                        const serializationObject = JSON.parse(snippet.nodeGeometry);
                        if (!nodeGeometry) nodeGeometry = (0, $6Ho1L.SerializationHelper).Parse(()=>new $5171dfa5a50acb38$export$c71b0921f91cbff5(snippetId), serializationObject, null);
                        nodeGeometry.parseSerializedObject(serializationObject);
                        nodeGeometry.snippetId = snippetId;
                        try {
                            if (!skipBuild) nodeGeometry.build();
                            resolve(nodeGeometry);
                        } catch (err) {
                            reject(err);
                        }
                    } else reject("Unable to load the snippet " + snippetId);
                }
            });
            request.open("GET", this.SnippetUrl + "/" + snippetId.replace(/#/g, "/"));
            request.send();
        });
    }
}
$5171dfa5a50acb38$export$c71b0921f91cbff5._BuildIdGenerator = 0;
/** Define the Url to load node editor script */ $5171dfa5a50acb38$export$c71b0921f91cbff5.EditorURL = `${(0, $bOhSV.Tools)._DefaultCdnUrl}/v${(0, $5YkyR.Engine).Version}/nodeGeometryEditor/babylon.nodeGeometryEditor.js`;
/** Define the Url to load snippets */ $5171dfa5a50acb38$export$c71b0921f91cbff5.SnippetUrl = `https://snippet.babylonjs.com`;
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $5171dfa5a50acb38$export$c71b0921f91cbff5.prototype, "name", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("comment")
], $5171dfa5a50acb38$export$c71b0921f91cbff5.prototype, "comment", void 0);

});
parcelRegister("1F29z", function(module, exports) {

$parcel$export(module.exports, "GeometryOutputBlock", () => $135b4a64bfe5c45e$export$4110f095e80504db);

var $gJfVN = parcelRequire("gJfVN");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");
class $135b4a64bfe5c45e$export$4110f095e80504db extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Gets the current vertex data if the graph was successfully built
     */ get currentVertexData() {
        return this._vertexData;
    }
    /**
     * Create a new GeometryOutputBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this._vertexData = null;
        this._isUnique = true;
        this.registerInput("geometry", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "GeometryOutputBlock";
    }
    /**
     * Gets the geometry input component
     */ get geometry() {
        return this._inputs[0];
    }
    _buildBlock(state) {
        state.vertexData = this.geometry.getConnectedValue(state);
        this._vertexData = state.vertexData;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.GeometryOutputBlock", $135b4a64bfe5c45e$export$4110f095e80504db);

});
parcelRegister("gJfVN", function(module, exports) {

$parcel$export(module.exports, "NodeGeometryBlock", () => $c2dd34e81b975998$export$2df77a3ff67e6ad2);

var $e0Suo = parcelRequire("e0Suo");

var $8DoUR = parcelRequire("8DoUR");

var $ir0rz = parcelRequire("ir0rz");

var $3u0QC = parcelRequire("3u0QC");

var $8Ik7p = parcelRequire("8Ik7p");

var $diGQf = parcelRequire("diGQf");

var $blHSI = parcelRequire("blHSI");

var $kVtWi = parcelRequire("kVtWi");
class $c2dd34e81b975998$export$2df77a3ff67e6ad2 {
    /**
     * Gets the time spent to build this block (in ms)
     */ get buildExecutionTime() {
        return this._buildExecutionTime;
    }
    /**
     * Gets the list of input points
     */ get inputs() {
        return this._inputs;
    }
    /** Gets the list of output points */ get outputs() {
        return this._outputs;
    }
    /**
     * Gets or set the name of the block
     */ get name() {
        return this._name;
    }
    set name(value) {
        this._name = value;
    }
    /**
     * Gets a boolean indicating if this block is an input
     */ get isInput() {
        return this._isInput;
    }
    /**
     * Gets a boolean indicating if this block is a teleport out
     */ get isTeleportOut() {
        return this._isTeleportOut;
    }
    /**
     * Gets a boolean indicating if this block is a teleport in
     */ get isTeleportIn() {
        return this._isTeleportIn;
    }
    /**
     * Gets a boolean indicating if this block is a debug block
     */ get isDebug() {
        return this._isDebug;
    }
    /**
     * Gets a boolean indicating that this block can only be used once per NodeGeometry
     */ get isUnique() {
        return this._isUnique;
    }
    /**
     * Gets the current class name e.g. "NodeGeometryBlock"
     * @returns the class name
     */ getClassName() {
        return "NodeGeometryBlock";
    }
    _inputRename(name) {
        return name;
    }
    _outputRename(name) {
        return name;
    }
    /**
     * Checks if the current block is an ancestor of a given block
     * @param block defines the potential descendant block to check
     * @returns true if block is a descendant
     */ isAnAncestorOf(block) {
        for (const output of this._outputs){
            if (!output.hasEndpoints) continue;
            for (const endpoint of output.endpoints){
                if (endpoint.ownerBlock === block) return true;
                if (endpoint.ownerBlock.isAnAncestorOf(block)) return true;
            }
        }
        return false;
    }
    /**
     * Checks if the current block is an ancestor of a given type
     * @param type defines the potential type to check
     * @returns true if block is a descendant
     */ isAnAncestorOfType(type) {
        if (this.getClassName() === type) return true;
        for (const output of this._outputs){
            if (!output.hasEndpoints) continue;
            for (const endpoint of output.endpoints){
                if (endpoint.ownerBlock.isAnAncestorOfType(type)) return true;
            }
        }
        return false;
    }
    /**
     * Get the first descendant using a predicate
     * @param predicate defines the predicate to check
     * @returns descendant or null if none found
     */ getDescendantOfPredicate(predicate) {
        if (predicate(this)) return this;
        for (const output of this._outputs){
            if (!output.hasEndpoints) continue;
            for (const endpoint of output.endpoints){
                const descendant = endpoint.ownerBlock.getDescendantOfPredicate(predicate);
                if (descendant) return descendant;
            }
        }
        return null;
    }
    /**
     * Creates a new NodeGeometryBlock
     * @param name defines the block name
     */ constructor(name){
        this._name = "";
        this._isInput = false;
        this._isTeleportOut = false;
        this._isTeleportIn = false;
        this._isDebug = false;
        this._isUnique = false;
        this._buildExecutionTime = 0;
        /**
         * Gets an observable raised when the block is built
         */ this.onBuildObservable = new (0, $diGQf.Observable)();
        /** @internal */ this._inputs = new Array();
        /** @internal */ this._outputs = new Array();
        /** @internal */ this._codeVariableName = "";
        /** Gets or sets a boolean indicating that this input can be edited from a collapsed frame */ this.visibleOnFrame = false;
        this._name = name;
        this.uniqueId = (0, $3u0QC.UniqueIdGenerator).UniqueId;
    }
    /**
     * Register a new input. Must be called inside a block constructor
     * @param name defines the connection point name
     * @param type defines the connection point type
     * @param isOptional defines a boolean indicating that this input can be omitted
     * @param value value to return if there is no connection
     * @param valueMin min value accepted for value
     * @param valueMax max value accepted for value
     * @returns the current block
     */ registerInput(name, type, isOptional = false, value, valueMin, valueMax) {
        const point = new (0, $8Ik7p.NodeGeometryConnectionPoint)(name, this, (0, $8Ik7p.NodeGeometryConnectionPointDirection).Input);
        point.type = type;
        point.isOptional = isOptional;
        point.defaultValue = value;
        point.value = value;
        point.valueMin = valueMin;
        point.valueMax = valueMax;
        this._inputs.push(point);
        return this;
    }
    /**
     * Register a new output. Must be called inside a block constructor
     * @param name defines the connection point name
     * @param type defines the connection point type
     * @param point an already created connection point. If not provided, create a new one
     * @returns the current block
     */ registerOutput(name, type, point) {
        point = point ?? new (0, $8Ik7p.NodeGeometryConnectionPoint)(name, this, (0, $8Ik7p.NodeGeometryConnectionPointDirection).Output);
        point.type = type;
        this._outputs.push(point);
        return this;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _buildBlock(state) {
    // Empty. Must be defined by child nodes
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _customBuildStep(state) {
    // Must be implemented by children
    }
    /**
     * Build the current node and generate the vertex data
     * @param state defines the current generation state
     * @returns true if already built
     */ build(state) {
        if (this._buildId === state.buildId) return true;
        if (this._outputs.length > 0) {
            if (!this._outputs.some((o)=>o.hasEndpoints) && !this.isDebug) return false;
            this.outputs.forEach((o)=>o._resetCounters());
        }
        this._buildId = state.buildId;
        // Check if "parent" blocks are compiled
        for (const input of this._inputs){
            if (!input.connectedPoint) {
                if (!input.isOptional) // Emit a warning
                state.notConnectedNonOptionalInputs.push(input);
                continue;
            }
            const block = input.connectedPoint.ownerBlock;
            if (block && block !== this) block.build(state);
        }
        this._customBuildStep(state);
        // Logs
        if (state.verbose) (0, $kVtWi.Logger).Log(`Building ${this.name} [${this.getClassName()}]`);
        const now = (0, $blHSI.PrecisionDate).Now;
        this._buildBlock(state);
        this._buildExecutionTime = (0, $blHSI.PrecisionDate).Now - now;
        // Compile connected blocks
        for (const output of this._outputs)for (const endpoint of output.endpoints){
            const block = endpoint.ownerBlock;
            if (block) block.build(state);
        }
        this.onBuildObservable.notifyObservers(this);
        return false;
    }
    _linkConnectionTypes(inputIndex0, inputIndex1, looseCoupling = false) {
        if (looseCoupling) this._inputs[inputIndex1]._acceptedConnectionPointType = this._inputs[inputIndex0];
        else this._inputs[inputIndex0]._linkedConnectionSource = this._inputs[inputIndex1];
        this._inputs[inputIndex1]._linkedConnectionSource = this._inputs[inputIndex0];
    }
    /**
     * Initialize the block and prepare the context for build
     */ initialize() {
    // Do nothing
    }
    /**
     * Lets the block try to connect some inputs automatically
     */ autoConfigure() {
    // Do nothing
    }
    /**
     * Find an input by its name
     * @param name defines the name of the input to look for
     * @returns the input or null if not found
     */ getInputByName(name) {
        const filter = this._inputs.filter((e)=>e.name === name);
        if (filter.length) return filter[0];
        return null;
    }
    /**
     * Find an output by its name
     * @param name defines the name of the output to look for
     * @returns the output or null if not found
     */ getOutputByName(name) {
        const filter = this._outputs.filter((e)=>e.name === name);
        if (filter.length) return filter[0];
        return null;
    }
    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */ serialize() {
        const serializationObject = {};
        serializationObject.customType = "BABYLON." + this.getClassName();
        serializationObject.id = this.uniqueId;
        serializationObject.name = this.name;
        serializationObject.inputs = [];
        serializationObject.outputs = [];
        for (const input of this.inputs)serializationObject.inputs.push(input.serialize());
        for (const output of this.outputs)serializationObject.outputs.push(output.serialize(false));
        return serializationObject;
    }
    /**
     * @internal
     */ _deserialize(serializationObject) {
        this._name = serializationObject.name;
        this.comments = serializationObject.comments;
        this.visibleOnFrame = !!serializationObject.visibleOnFrame;
        this._deserializePortDisplayNamesAndExposedOnFrame(serializationObject);
    }
    _deserializePortDisplayNamesAndExposedOnFrame(serializationObject) {
        const serializedInputs = serializationObject.inputs;
        const serializedOutputs = serializationObject.outputs;
        if (serializedInputs) serializedInputs.forEach((port)=>{
            const input = this.inputs.find((i)=>i.name === port.name);
            if (!input) return;
            if (port.displayName) input.displayName = port.displayName;
            if (port.isExposedOnFrame) {
                input.isExposedOnFrame = port.isExposedOnFrame;
                input.exposedPortPosition = port.exposedPortPosition;
            }
            if (port.value !== undefined && port.value !== null) {
                if (port.valueType === "number") input.value = port.value;
                else {
                    const valueType = (0, $8DoUR.GetClass)(port.valueType);
                    if (valueType) input.value = valueType.FromArray(port.value);
                }
            }
        });
        if (serializedOutputs) serializedOutputs.forEach((port, i)=>{
            if (port.displayName) this.outputs[i].displayName = port.displayName;
            if (port.isExposedOnFrame) {
                this.outputs[i].isExposedOnFrame = port.isExposedOnFrame;
                this.outputs[i].exposedPortPosition = port.exposedPortPosition;
            }
        });
    }
    _dumpPropertiesCode() {
        const variableName = this._codeVariableName;
        return `${variableName}.visibleOnFrame = ${this.visibleOnFrame};\n`;
    }
    /**
     * @internal
     */ _dumpCodeForOutputConnections(alreadyDumped) {
        let codeString = "";
        if (alreadyDumped.indexOf(this) !== -1) return codeString;
        alreadyDumped.push(this);
        for (const input of this.inputs){
            if (!input.isConnected) continue;
            const connectedOutput = input.connectedPoint;
            const connectedBlock = connectedOutput.ownerBlock;
            codeString += connectedBlock._dumpCodeForOutputConnections(alreadyDumped);
            codeString += `${connectedBlock._codeVariableName}.${connectedBlock._outputRename(connectedOutput.name)}.connectTo(${this._codeVariableName}.${this._inputRename(input.name)});\n`;
        }
        return codeString;
    }
    /**
     * @internal
     */ _dumpCode(uniqueNames, alreadyDumped) {
        alreadyDumped.push(this);
        // Get unique name
        const nameAsVariableName = this.name.replace(/[^A-Za-z_]+/g, "");
        this._codeVariableName = nameAsVariableName || `${this.getClassName()}_${this.uniqueId}`;
        if (uniqueNames.indexOf(this._codeVariableName) !== -1) {
            let index = 0;
            do {
                index++;
                this._codeVariableName = nameAsVariableName + index;
            }while (uniqueNames.indexOf(this._codeVariableName) !== -1);
        }
        uniqueNames.push(this._codeVariableName);
        // Declaration
        let codeString = `\n// ${this.getClassName()}\n`;
        if (this.comments) codeString += `// ${this.comments}\n`;
        const className = this.getClassName();
        if (className === "GeometryInputBlock") {
            const block = this;
            const blockType = block.type;
            codeString += `var ${this._codeVariableName} = new BABYLON.GeometryInputBlock("${this.name}", ${blockType});\n`;
        } else codeString += `var ${this._codeVariableName} = new BABYLON.${className}("${this.name}");\n`;
        // Properties
        codeString += this._dumpPropertiesCode();
        // Inputs
        for (const input of this.inputs){
            if (!input.isConnected) continue;
            const connectedOutput = input.connectedPoint;
            const connectedBlock = connectedOutput.ownerBlock;
            if (alreadyDumped.indexOf(connectedBlock) === -1) codeString += connectedBlock._dumpCode(uniqueNames, alreadyDumped);
        }
        // Outputs
        for (const output of this.outputs){
            if (!output.hasEndpoints) continue;
            for (const endpoint of output.endpoints){
                const connectedBlock = endpoint.ownerBlock;
                if (connectedBlock && alreadyDumped.indexOf(connectedBlock) === -1) codeString += connectedBlock._dumpCode(uniqueNames, alreadyDumped);
            }
        }
        return codeString;
    }
    /**
     * Clone the current block to a new identical block
     * @returns a copy of the current block
     */ clone() {
        const serializationObject = this.serialize();
        const blockType = (0, $8DoUR.GetClass)(serializationObject.customType);
        if (blockType) {
            const block = new blockType();
            block._deserialize(serializationObject);
            return block;
        }
        return null;
    }
    /**
     * Release resources
     */ dispose() {
        for (const input of this.inputs)input.dispose();
        for (const output of this.outputs)output.dispose();
        this.onBuildObservable.clear();
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("comment")
], $c2dd34e81b975998$export$2df77a3ff67e6ad2.prototype, "comments", void 0);

});
parcelRegister("8Ik7p", function(module, exports) {

$parcel$export(module.exports, "NodeGeometryConnectionPointCompatibilityStates", () => $658209e9b093a421$export$528722b4cbb242a4);
$parcel$export(module.exports, "NodeGeometryConnectionPointDirection", () => $658209e9b093a421$export$4d0c358ea789522a);
$parcel$export(module.exports, "NodeGeometryConnectionPoint", () => $658209e9b093a421$export$152fedd70be43ea9);

var $diGQf = parcelRequire("diGQf");

var $4k2Tt = parcelRequire("4k2Tt");
var $658209e9b093a421$export$528722b4cbb242a4;
(function(NodeGeometryConnectionPointCompatibilityStates) {
    /** Points are compatibles */ NodeGeometryConnectionPointCompatibilityStates[NodeGeometryConnectionPointCompatibilityStates["Compatible"] = 0] = "Compatible";
    /** Points are incompatible because of their types */ NodeGeometryConnectionPointCompatibilityStates[NodeGeometryConnectionPointCompatibilityStates["TypeIncompatible"] = 1] = "TypeIncompatible";
    /** Points are incompatible because they are in the same hierarchy **/ NodeGeometryConnectionPointCompatibilityStates[NodeGeometryConnectionPointCompatibilityStates["HierarchyIssue"] = 2] = "HierarchyIssue";
})($658209e9b093a421$export$528722b4cbb242a4 || ($658209e9b093a421$export$528722b4cbb242a4 = {}));
var $658209e9b093a421$export$4d0c358ea789522a;
(function(NodeGeometryConnectionPointDirection) {
    /** Input */ NodeGeometryConnectionPointDirection[NodeGeometryConnectionPointDirection["Input"] = 0] = "Input";
    /** Output */ NodeGeometryConnectionPointDirection[NodeGeometryConnectionPointDirection["Output"] = 1] = "Output";
})($658209e9b093a421$export$4d0c358ea789522a || ($658209e9b093a421$export$4d0c358ea789522a = {}));
class $658209e9b093a421$export$152fedd70be43ea9 {
    /** Gets the direction of the point */ get direction() {
        return this._direction;
    }
    /**
     * Gets or sets the connection point type (default is float)
     */ get type() {
        if (this._type === (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect) {
            if (this._ownerBlock.isInput) return this._ownerBlock.type;
            if (this._connectedPoint) return this._connectedPoint.type;
            if (this._linkedConnectionSource && this._linkedConnectionSource.isConnected) return this._linkedConnectionSource.type;
        }
        if (this._type === (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).BasedOnInput) {
            if (this._typeConnectionSource) {
                if (!this._typeConnectionSource.isConnected && this._defaultConnectionPointType) return this._defaultConnectionPointType;
                return this._typeConnectionSource.type;
            } else if (this._defaultConnectionPointType) return this._defaultConnectionPointType;
        }
        return this._type;
    }
    set type(value) {
        this._type = value;
    }
    /**
     * Gets a boolean indicating that the current point is connected to another NodeMaterialBlock
     */ get isConnected() {
        return this.connectedPoint !== null || this.hasEndpoints;
    }
    /** Get the other side of the connection (if any) */ get connectedPoint() {
        return this._connectedPoint;
    }
    /** Get the block that owns this connection point */ get ownerBlock() {
        return this._ownerBlock;
    }
    /** Get the block connected on the other side of this connection (if any) */ get sourceBlock() {
        if (!this._connectedPoint) return null;
        return this._connectedPoint.ownerBlock;
    }
    /** Get the block connected on the endpoints of this connection (if any) */ get connectedBlocks() {
        if (this._endpoints.length === 0) return [];
        return this._endpoints.map((e)=>e.ownerBlock);
    }
    /** Gets the list of connected endpoints */ get endpoints() {
        return this._endpoints;
    }
    /** Gets a boolean indicating if that output point is connected to at least one input */ get hasEndpoints() {
        return this._endpoints && this._endpoints.length > 0;
    }
    /** Get the inner type (ie AutoDetect for instance instead of the inferred one) */ get innerType() {
        if (this._linkedConnectionSource && this._linkedConnectionSource.isConnected) return this.type;
        return this._type;
    }
    /** @internal */ _resetCounters() {
        this._callCount = 0;
        this._executionCount = 0;
    }
    /**
     * Gets the number of times this point was called
     */ get callCount() {
        return this._callCount;
    }
    /**
     * Gets the number of times this point was executed
     */ get executionCount() {
        return this._executionCount;
    }
    /**
     * Gets the value represented by this connection point
     * @param state current evaluation state
     * @returns the connected value or the value if nothing is connected
     */ getConnectedValue(state) {
        if (this.isConnected) {
            if (this._connectedPoint?._storedFunction) {
                this._connectedPoint._callCount++;
                this._connectedPoint._executionCount++;
                return this._connectedPoint._storedFunction(state);
            }
            this._connectedPoint._callCount++;
            this._connectedPoint._executionCount = 1;
            return this._connectedPoint._storedValue;
        }
        this._callCount++;
        this._executionCount = 1;
        return this.value;
    }
    /**
     * Creates a new connection point
     * @param name defines the connection point name
     * @param ownerBlock defines the block hosting this connection point
     * @param direction defines the direction of the connection point
     */ constructor(name, ownerBlock, direction){
        /** @internal */ this._connectedPoint = null;
        /** @internal */ this._storedValue = null;
        /** @internal */ this._storedFunction = null;
        /** @internal */ this._acceptedConnectionPointType = null;
        this._endpoints = new Array();
        this._type = (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry;
        /** @internal */ this._linkedConnectionSource = null;
        /** @internal */ this._typeConnectionSource = null;
        /** @internal */ this._defaultConnectionPointType = null;
        /**
         * Gets or sets the additional types supported by this connection point
         */ this.acceptedConnectionPointTypes = [];
        /**
         * Gets or sets the additional types excluded by this connection point
         */ this.excludedConnectionPointTypes = [];
        /**
         * Observable triggered when this point is connected
         */ this.onConnectionObservable = new (0, $diGQf.Observable)();
        /**
         * Gets or sets a boolean indicating that this connection point is exposed on a frame
         */ this.isExposedOnFrame = false;
        /**
         * Gets or sets number indicating the position that the port is exposed to on a frame
         */ this.exposedPortPosition = -1;
        /**
         * Gets the default value used for this point at creation time
         */ this.defaultValue = null;
        /**
         * Gets or sets the default value used for this point if nothing is connected
         */ this.value = null;
        /**
         * Gets or sets the min value accepted for this point if nothing is connected
         */ this.valueMin = null;
        /**
         * Gets or sets the max value accepted for this point if nothing is connected
         */ this.valueMax = null;
        /** @internal */ this._callCount = 0;
        /** @internal */ this._executionCount = 0;
        this._ownerBlock = ownerBlock;
        this.name = name;
        this._direction = direction;
    }
    /**
     * Gets the current class name e.g. "NodeMaterialConnectionPoint"
     * @returns the class name
     */ getClassName() {
        return "NodeGeometryConnectionPoint";
    }
    /**
     * Gets a boolean indicating if the current point can be connected to another point
     * @param connectionPoint defines the other connection point
     * @returns a boolean
     */ canConnectTo(connectionPoint) {
        return this.checkCompatibilityState(connectionPoint) === $658209e9b093a421$export$528722b4cbb242a4.Compatible;
    }
    /**
     * Gets a number indicating if the current point can be connected to another point
     * @param connectionPoint defines the other connection point
     * @returns a number defining the compatibility state
     */ checkCompatibilityState(connectionPoint) {
        const ownerBlock = this._ownerBlock;
        const otherBlock = connectionPoint.ownerBlock;
        if (this.type !== connectionPoint.type && connectionPoint.innerType !== (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect) {
            // Accepted types
            if (connectionPoint.acceptedConnectionPointTypes && connectionPoint.acceptedConnectionPointTypes.indexOf(this.type) !== -1) return $658209e9b093a421$export$528722b4cbb242a4.Compatible;
            else return $658209e9b093a421$export$528722b4cbb242a4.TypeIncompatible;
        }
        // Excluded
        if (connectionPoint.excludedConnectionPointTypes && connectionPoint.excludedConnectionPointTypes.indexOf(this.type) !== -1) return $658209e9b093a421$export$528722b4cbb242a4.TypeIncompatible;
        // Check hierarchy
        let targetBlock = otherBlock;
        let sourceBlock = ownerBlock;
        if (this.direction === $658209e9b093a421$export$4d0c358ea789522a.Input) {
            targetBlock = ownerBlock;
            sourceBlock = otherBlock;
        }
        if (targetBlock.isAnAncestorOf(sourceBlock)) return $658209e9b093a421$export$528722b4cbb242a4.HierarchyIssue;
        return $658209e9b093a421$export$528722b4cbb242a4.Compatible;
    }
    /**
     * Connect this point to another connection point
     * @param connectionPoint defines the other connection point
     * @param ignoreConstraints defines if the system will ignore connection type constraints (default is false)
     * @returns the current connection point
     */ connectTo(connectionPoint, ignoreConstraints = false) {
        if (!ignoreConstraints && !this.canConnectTo(connectionPoint)) // eslint-disable-next-line no-throw-literal
        throw "Cannot connect these two connectors.";
        this._endpoints.push(connectionPoint);
        connectionPoint._connectedPoint = this;
        this.onConnectionObservable.notifyObservers(connectionPoint);
        connectionPoint.onConnectionObservable.notifyObservers(this);
        return this;
    }
    /**
     * Disconnect this point from one of his endpoint
     * @param endpoint defines the other connection point
     * @returns the current connection point
     */ disconnectFrom(endpoint) {
        const index = this._endpoints.indexOf(endpoint);
        if (index === -1) return this;
        this._endpoints.splice(index, 1);
        endpoint._connectedPoint = null;
        return this;
    }
    /**
     * Fill the list of excluded connection point types with all types other than those passed in the parameter
     * @param mask Types (ORed values of NodeMaterialBlockConnectionPointTypes) that are allowed, and thus will not be pushed to the excluded list
     */ addExcludedConnectionPointFromAllowedTypes(mask) {
        let bitmask = 1;
        while(bitmask < (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).All){
            if (!(mask & bitmask)) this.excludedConnectionPointTypes.push(bitmask);
            bitmask = bitmask << 1;
        }
    }
    /**
     * Serializes this point in a JSON representation
     * @param isInput defines if the connection point is an input (default is true)
     * @returns the serialized point object
     */ serialize(isInput = true) {
        const serializationObject = {};
        serializationObject.name = this.name;
        serializationObject.displayName = this.displayName;
        if (this.value !== undefined && this.value !== null) {
            if (this.value.asArray) {
                serializationObject.valueType = "BABYLON." + this.value.getClassName();
                serializationObject.value = this.value.asArray();
            } else {
                serializationObject.valueType = "number";
                serializationObject.value = this.value;
            }
        }
        if (isInput && this.connectedPoint) {
            serializationObject.inputName = this.name;
            serializationObject.targetBlockId = this.connectedPoint.ownerBlock.uniqueId;
            serializationObject.targetConnectionName = this.connectedPoint.name;
        }
        return serializationObject;
    }
    /**
     * Release resources
     */ dispose() {
        this.onConnectionObservable.clear();
    }
}

});
parcelRegister("4k2Tt", function(module, exports) {

$parcel$export(module.exports, "NodeGeometryBlockConnectionPointTypes", () => $325b46535975f7b9$export$c4f8a830266cd3a);
/**
 * Defines the kind of connection point for node geometry
 */ var $325b46535975f7b9$export$c4f8a830266cd3a;
(function(NodeGeometryBlockConnectionPointTypes) {
    /** Int */ NodeGeometryBlockConnectionPointTypes[NodeGeometryBlockConnectionPointTypes["Int"] = 1] = "Int";
    /** Float */ NodeGeometryBlockConnectionPointTypes[NodeGeometryBlockConnectionPointTypes["Float"] = 2] = "Float";
    /** Vector2 */ NodeGeometryBlockConnectionPointTypes[NodeGeometryBlockConnectionPointTypes["Vector2"] = 4] = "Vector2";
    /** Vector3 */ NodeGeometryBlockConnectionPointTypes[NodeGeometryBlockConnectionPointTypes["Vector3"] = 8] = "Vector3";
    /** Vector4 */ NodeGeometryBlockConnectionPointTypes[NodeGeometryBlockConnectionPointTypes["Vector4"] = 16] = "Vector4";
    /** Matrix */ NodeGeometryBlockConnectionPointTypes[NodeGeometryBlockConnectionPointTypes["Matrix"] = 32] = "Matrix";
    /** Geometry */ NodeGeometryBlockConnectionPointTypes[NodeGeometryBlockConnectionPointTypes["Geometry"] = 64] = "Geometry";
    /** Texture */ NodeGeometryBlockConnectionPointTypes[NodeGeometryBlockConnectionPointTypes["Texture"] = 128] = "Texture";
    /** Detect type based on connection */ NodeGeometryBlockConnectionPointTypes[NodeGeometryBlockConnectionPointTypes["AutoDetect"] = 1024] = "AutoDetect";
    /** Output type that will be defined by input type */ NodeGeometryBlockConnectionPointTypes[NodeGeometryBlockConnectionPointTypes["BasedOnInput"] = 2048] = "BasedOnInput";
    /** Undefined */ NodeGeometryBlockConnectionPointTypes[NodeGeometryBlockConnectionPointTypes["Undefined"] = 4096] = "Undefined";
    /** Bitmask of all types */ NodeGeometryBlockConnectionPointTypes[NodeGeometryBlockConnectionPointTypes["All"] = 4095] = "All";
})($325b46535975f7b9$export$c4f8a830266cd3a || ($325b46535975f7b9$export$c4f8a830266cd3a = {}));

});




parcelRegister("492xU", function(module, exports) {

$parcel$export(module.exports, "NodeGeometryBuildState", () => $3049fa3dd19c22af$export$bb398b2d9becb4f3);

var $8Jk1D = parcelRequire("8Jk1D");

var $ha1VO = parcelRequire("ha1VO");

var $4k2Tt = parcelRequire("4k2Tt");
class $3049fa3dd19c22af$export$bb398b2d9becb4f3 {
    constructor(){
        this._rotationMatrix = new (0, $ha1VO.Matrix)();
        this._scalingMatrix = new (0, $ha1VO.Matrix)();
        this._positionMatrix = new (0, $ha1VO.Matrix)();
        this._scalingRotationMatrix = new (0, $ha1VO.Matrix)();
        this._transformMatrix = new (0, $ha1VO.Matrix)();
        this._tempVector3 = new (0, $ha1VO.Vector3)();
        /** Gets or sets the list of non connected mandatory inputs */ this.notConnectedNonOptionalInputs = [];
        /** Gets or sets the list of non contextual inputs having no contextudal data */ this.noContextualData = [];
        /** Gets or sets the vertex data */ this.vertexData = null;
        this._geometryContext = null;
        this._executionContext = null;
        this._instancingContext = null;
        this._geometryContextStack = [];
        this._executionContextStack = [];
        this._instancingContextStack = [];
    }
    /** Gets or sets the geometry context */ get geometryContext() {
        return this._geometryContext;
    }
    /** Gets or sets the execution context */ get executionContext() {
        return this._executionContext;
    }
    /** Gets or sets the instancing context */ get instancingContext() {
        return this._instancingContext;
    }
    /**
     * Push the new active geometry context
     * @param geometryContext defines the geometry context
     */ pushGeometryContext(geometryContext) {
        this._geometryContext = geometryContext;
        this._geometryContextStack.push(this._geometryContext);
    }
    /**
     * Push the new active execution context
     * @param executionContext defines the execution context
     */ pushExecutionContext(executionContext) {
        this._executionContext = executionContext;
        this._executionContextStack.push(this._executionContext);
    }
    /**
     * Push the new active instancing context
     * @param instancingContext defines the instancing context
     */ pushInstancingContext(instancingContext) {
        this._instancingContext = instancingContext;
        this._instancingContextStack.push(this._instancingContext);
    }
    /**
     * Remove current geometry context and restore the previous one
     */ restoreGeometryContext() {
        this._geometryContextStack.pop();
        this._geometryContext = this._geometryContextStack.length > 0 ? this._geometryContextStack[this._geometryContextStack.length - 1] : null;
    }
    /**
     * Remove current execution context and restore the previous one
     */ restoreExecutionContext() {
        this._executionContextStack.pop();
        this._executionContext = this._executionContextStack.length > 0 ? this._executionContextStack[this._executionContextStack.length - 1] : null;
    }
    /**
     * Remove current isntancing context and restore the previous one
     */ restoreInstancingContext() {
        this._instancingContextStack.pop();
        this._instancingContext = this._instancingContextStack.length > 0 ? this._instancingContextStack[this._instancingContextStack.length - 1] : null;
    }
    /**
     * Gets the value associated with a contextual source
     * @param source Source of the contextual value
     * @param skipWarning Do not store the warning for reporting if true
     * @returns the value associated with the source
     */ getContextualValue(source, skipWarning = false) {
        if (!this.executionContext) {
            if (!skipWarning) this.noContextualData.push(source);
            return null;
        }
        const index = this.executionContext.getExecutionIndex();
        switch(source){
            case (0, $8Jk1D.NodeGeometryContextualSources).Positions:
                if (this.executionContext.getOverridePositionsContextualValue) return this.executionContext.getOverridePositionsContextualValue();
                if (!this.geometryContext || !this.geometryContext.positions) return (0, $ha1VO.Vector3).Zero();
                return (0, $ha1VO.Vector3).FromArray(this.geometryContext.positions, index * 3);
            case (0, $8Jk1D.NodeGeometryContextualSources).Normals:
                if (this.executionContext.getOverrideNormalsContextualValue) return this.executionContext.getOverrideNormalsContextualValue();
                if (!this.geometryContext || !this.geometryContext.normals) return (0, $ha1VO.Vector3).Zero();
                return (0, $ha1VO.Vector3).FromArray(this.geometryContext.normals, index * 3);
            case (0, $8Jk1D.NodeGeometryContextualSources).Colors:
                if (!this.geometryContext || !this.geometryContext.colors) return (0, $ha1VO.Vector4).Zero();
                return (0, $ha1VO.Vector4).FromArray(this.geometryContext.colors, index * 4);
            case (0, $8Jk1D.NodeGeometryContextualSources).Tangents:
                if (!this.geometryContext || !this.geometryContext.tangents) return (0, $ha1VO.Vector4).Zero();
                return (0, $ha1VO.Vector4).FromArray(this.geometryContext.tangents, index * 4);
            case (0, $8Jk1D.NodeGeometryContextualSources).UV:
                if (this.executionContext.getOverrideUVs1ContextualValue) return this.executionContext.getOverrideUVs1ContextualValue();
                if (!this.geometryContext || !this.geometryContext.uvs) return (0, $ha1VO.Vector2).Zero();
                return (0, $ha1VO.Vector2).FromArray(this.geometryContext.uvs, index * 2);
            case (0, $8Jk1D.NodeGeometryContextualSources).UV2:
                if (!this.geometryContext || !this.geometryContext.uvs2) return (0, $ha1VO.Vector2).Zero();
                return (0, $ha1VO.Vector2).FromArray(this.geometryContext.uvs2, index * 2);
            case (0, $8Jk1D.NodeGeometryContextualSources).UV3:
                if (!this.geometryContext || !this.geometryContext.uvs3) return (0, $ha1VO.Vector2).Zero();
                return (0, $ha1VO.Vector2).FromArray(this.geometryContext.uvs3, index * 2);
            case (0, $8Jk1D.NodeGeometryContextualSources).UV4:
                if (!this.geometryContext || !this.geometryContext.uvs4) return (0, $ha1VO.Vector2).Zero();
                return (0, $ha1VO.Vector2).FromArray(this.geometryContext.uvs4, index * 2);
            case (0, $8Jk1D.NodeGeometryContextualSources).UV5:
                if (!this.geometryContext || !this.geometryContext.uvs5) return (0, $ha1VO.Vector2).Zero();
                return (0, $ha1VO.Vector2).FromArray(this.geometryContext.uvs5, index * 2);
            case (0, $8Jk1D.NodeGeometryContextualSources).UV6:
                if (!this.geometryContext || !this.geometryContext.uvs6) return (0, $ha1VO.Vector2).Zero();
                return (0, $ha1VO.Vector2).FromArray(this.geometryContext.uvs6, index * 2);
            case (0, $8Jk1D.NodeGeometryContextualSources).VertexID:
                return index;
            case (0, $8Jk1D.NodeGeometryContextualSources).FaceID:
                return this.executionContext.getExecutionFaceIndex();
            case (0, $8Jk1D.NodeGeometryContextualSources).LoopID:
                return this.executionContext.getExecutionLoopIndex();
            case (0, $8Jk1D.NodeGeometryContextualSources).InstanceID:
                return this.instancingContext ? this.instancingContext.getInstanceIndex() : 0;
            case (0, $8Jk1D.NodeGeometryContextualSources).GeometryID:
                return !this.geometryContext ? 0 : this.geometryContext.uniqueId;
            case (0, $8Jk1D.NodeGeometryContextualSources).CollectionID:
                if (!this.geometryContext || !this.geometryContext.metadata) return 0;
                return this.geometryContext.metadata.collectionId || 0;
        }
        return null;
    }
    /**
     * Adapt a value to a target type
     * @param source defines the value to adapt
     * @param targetType defines the target type
     * @returns the adapted value
     */ adapt(source, targetType) {
        const value = source.getConnectedValue(this) || 0;
        if (source.type === targetType) return value;
        switch(targetType){
            case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector2:
                return new (0, $ha1VO.Vector2)(value, value);
            case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3:
                return new (0, $ha1VO.Vector3)(value, value, value);
            case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector4:
                return new (0, $ha1VO.Vector4)(value, value, value, value);
        }
        return null;
    }
    /**
     * Adapt an input value to a target type
     * @param source defines the value to adapt
     * @param targetType defines the target type
     * @param defaultValue defines the default value to use if not connected
     * @returns the adapted value
     */ adaptInput(source, targetType, defaultValue) {
        if (!source.isConnected) return source.value || defaultValue;
        const value = source.getConnectedValue(this);
        if (source._connectedPoint?.type === targetType) return value;
        switch(targetType){
            case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector2:
                return new (0, $ha1VO.Vector2)(value, value);
            case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3:
                return new (0, $ha1VO.Vector3)(value, value, value);
            case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector4:
                return new (0, $ha1VO.Vector4)(value, value, value, value);
        }
        return null;
    }
    /**
     * Emits console errors and exceptions if there is a failing check
     */ emitErrors() {
        let errorMessage = "";
        for (const notConnectedInput of this.notConnectedNonOptionalInputs)errorMessage += `input ${notConnectedInput.name} from block ${notConnectedInput.ownerBlock.name}[${notConnectedInput.ownerBlock.getClassName()}] is not connected and is not optional.\n`;
        for (const source of this.noContextualData)errorMessage += `Contextual input ${(0, $8Jk1D.NodeGeometryContextualSources)[source]} has no context to pull data from (must be connected to a setXXX block or a instantiateXXX block).\n`;
        if (errorMessage) // eslint-disable-next-line no-throw-literal
        throw "Build of NodeGeometry failed:\n" + errorMessage;
    }
    /** @internal  */ _instantiate(clone, currentPosition, rotation, scaling, additionalVertexData) {
        // Transform
        (0, $ha1VO.Matrix).ScalingToRef(scaling.x, scaling.y, scaling.z, this._scalingMatrix);
        (0, $ha1VO.Matrix).RotationYawPitchRollToRef(rotation.y, rotation.x, rotation.z, this._rotationMatrix);
        (0, $ha1VO.Matrix).TranslationToRef(currentPosition.x, currentPosition.y, currentPosition.z, this._positionMatrix);
        this._scalingMatrix.multiplyToRef(this._rotationMatrix, this._scalingRotationMatrix);
        this._scalingRotationMatrix.multiplyToRef(this._positionMatrix, this._transformMatrix);
        for(let clonePositionIndex = 0; clonePositionIndex < clone.positions.length; clonePositionIndex += 3){
            this._tempVector3.fromArray(clone.positions, clonePositionIndex);
            (0, $ha1VO.Vector3).TransformCoordinatesToRef(this._tempVector3, this._transformMatrix, this._tempVector3);
            this._tempVector3.toArray(clone.positions, clonePositionIndex);
            if (clone.normals) {
                this._tempVector3.fromArray(clone.normals, clonePositionIndex);
                (0, $ha1VO.Vector3).TransformNormalToRef(this._tempVector3, this._scalingRotationMatrix, this._tempVector3);
                this._tempVector3.toArray(clone.normals, clonePositionIndex);
            }
        }
        additionalVertexData.push(clone);
    }
    /** @internal  */ _instantiateWithMatrix(clone, transform, additionalVertexData) {
        for(let clonePositionIndex = 0; clonePositionIndex < clone.positions.length; clonePositionIndex += 3){
            this._tempVector3.fromArray(clone.positions, clonePositionIndex);
            (0, $ha1VO.Vector3).TransformCoordinatesToRef(this._tempVector3, transform, this._tempVector3);
            this._tempVector3.toArray(clone.positions, clonePositionIndex);
            if (clone.normals) {
                this._tempVector3.fromArray(clone.normals, clonePositionIndex);
                (0, $ha1VO.Vector3).TransformNormalToRef(this._tempVector3, transform, this._tempVector3);
                this._tempVector3.toArray(clone.normals, clonePositionIndex);
            }
        }
        additionalVertexData.push(clone);
    }
    /** @internal  */ _instantiateWithPositionAndMatrix(clone, currentPosition, transform, additionalVertexData) {
        (0, $ha1VO.Matrix).TranslationToRef(currentPosition.x, currentPosition.y, currentPosition.z, this._positionMatrix);
        transform.multiplyToRef(this._positionMatrix, this._transformMatrix);
        for(let clonePositionIndex = 0; clonePositionIndex < clone.positions.length; clonePositionIndex += 3){
            this._tempVector3.fromArray(clone.positions, clonePositionIndex);
            (0, $ha1VO.Vector3).TransformCoordinatesToRef(this._tempVector3, this._transformMatrix, this._tempVector3);
            this._tempVector3.toArray(clone.positions, clonePositionIndex);
            if (clone.normals) {
                this._tempVector3.fromArray(clone.normals, clonePositionIndex);
                (0, $ha1VO.Vector3).TransformNormalToRef(this._tempVector3, this._transformMatrix, this._tempVector3);
                this._tempVector3.toArray(clone.normals, clonePositionIndex);
            }
        }
        additionalVertexData.push(clone);
    }
}

});
parcelRegister("8Jk1D", function(module, exports) {

$parcel$export(module.exports, "NodeGeometryContextualSources", () => $65b20f4eab3ddd79$export$c74e2fae575d0d88);
/**
 * Defines the kind of contextual sources for node geometry
 */ var $65b20f4eab3ddd79$export$c74e2fae575d0d88;
(function(NodeGeometryContextualSources) {
    /** None */ NodeGeometryContextualSources[NodeGeometryContextualSources["None"] = 0] = "None";
    /** Positions */ NodeGeometryContextualSources[NodeGeometryContextualSources["Positions"] = 1] = "Positions";
    /** Normals */ NodeGeometryContextualSources[NodeGeometryContextualSources["Normals"] = 2] = "Normals";
    /** Tangents */ NodeGeometryContextualSources[NodeGeometryContextualSources["Tangents"] = 3] = "Tangents";
    /** UV */ NodeGeometryContextualSources[NodeGeometryContextualSources["UV"] = 4] = "UV";
    /** UV2 */ NodeGeometryContextualSources[NodeGeometryContextualSources["UV2"] = 5] = "UV2";
    /** UV3 */ NodeGeometryContextualSources[NodeGeometryContextualSources["UV3"] = 6] = "UV3";
    /** UV4 */ NodeGeometryContextualSources[NodeGeometryContextualSources["UV4"] = 7] = "UV4";
    /** UV5 */ NodeGeometryContextualSources[NodeGeometryContextualSources["UV5"] = 8] = "UV5";
    /** UV6 */ NodeGeometryContextualSources[NodeGeometryContextualSources["UV6"] = 9] = "UV6";
    /** Colors */ NodeGeometryContextualSources[NodeGeometryContextualSources["Colors"] = 10] = "Colors";
    /** VertexID */ NodeGeometryContextualSources[NodeGeometryContextualSources["VertexID"] = 11] = "VertexID";
    /** FaceID */ NodeGeometryContextualSources[NodeGeometryContextualSources["FaceID"] = 12] = "FaceID";
    /** GeometryID */ NodeGeometryContextualSources[NodeGeometryContextualSources["GeometryID"] = 13] = "GeometryID";
    /** CollectionID */ NodeGeometryContextualSources[NodeGeometryContextualSources["CollectionID"] = 14] = "CollectionID";
    /** LoopID */ NodeGeometryContextualSources[NodeGeometryContextualSources["LoopID"] = 15] = "LoopID";
    /** InstanceID */ NodeGeometryContextualSources[NodeGeometryContextualSources["InstanceID"] = 16] = "InstanceID";
})($65b20f4eab3ddd79$export$c74e2fae575d0d88 || ($65b20f4eab3ddd79$export$c74e2fae575d0d88 = {}));

});


parcelRegister("gB7vT", function(module, exports) {

$parcel$export(module.exports, "BoxBlock", () => $c155ee129f4120e4$export$ba0f53bc4eae986b);

var $e0Suo = parcelRequire("e0Suo");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");

var $a76QT = parcelRequire("a76QT");

var $8DoUR = parcelRequire("8DoUR");

var $4C7Qm = parcelRequire("4C7Qm");

var $1aXVF = parcelRequire("1aXVF");
class $c155ee129f4120e4$export$ba0f53bc4eae986b extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new BoxBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        /**
         * Gets or sets a boolean indicating that this block can evaluate context
         * Build performance is improved when this value is set to false as the system will cache values instead of reevaluating everything per context change
         */ this.evaluateContext = false;
        this.registerInput("size", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 1);
        this.registerInput("width", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 0);
        this.registerInput("height", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 0);
        this.registerInput("depth", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 0);
        this.registerInput("subdivisions", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int, true, 1);
        this.registerInput("subdivisionsX", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int, true, 0);
        this.registerInput("subdivisionsY", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int, true, 0);
        this.registerInput("subdivisionsZ", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int, true, 0);
        this.registerOutput("geometry", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "BoxBlock";
    }
    /**
     * Gets the size input component
     */ get size() {
        return this._inputs[0];
    }
    /**
     * Gets the width input component
     */ get width() {
        return this._inputs[1];
    }
    /**
     * Gets the height input component
     */ get height() {
        return this._inputs[2];
    }
    /**
     * Gets the depth input component
     */ get depth() {
        return this._inputs[3];
    }
    /**
     * Gets the subdivisions input component
     */ get subdivisions() {
        return this._inputs[4];
    }
    /**
     * Gets the subdivisionsX input component
     */ get subdivisionsX() {
        return this._inputs[5];
    }
    /**
     * Gets the subdivisionsY input component
     */ get subdivisionsY() {
        return this._inputs[6];
    }
    /**
     * Gets the subdivisionsZ input component
     */ get subdivisionsZ() {
        return this._inputs[7];
    }
    /**
     * Gets the geometry output component
     */ get geometry() {
        return this._outputs[0];
    }
    autoConfigure() {
        if (this.size.isConnected) return;
        if (!this.width.isConnected && !this.height.isConnected && !this.depth.isConnected) {
            const sizeInput = new (0, $a76QT.GeometryInputBlock)("Size");
            sizeInput.value = 1;
            sizeInput.output.connectTo(this.size);
            return;
        }
        if (!this.width.isConnected) {
            const widthInput = new (0, $a76QT.GeometryInputBlock)("Width");
            widthInput.value = 1;
            widthInput.output.connectTo(this.width);
        }
        if (!this.height.isConnected) {
            const heightInput = new (0, $a76QT.GeometryInputBlock)("Height");
            heightInput.value = 1;
            heightInput.output.connectTo(this.height);
        }
        if (!this.depth.isConnected) {
            const depthInput = new (0, $a76QT.GeometryInputBlock)("Depth");
            depthInput.value = 1;
            depthInput.output.connectTo(this.depth);
        }
    }
    _buildBlock(state) {
        const options = {};
        const func = (state)=>{
            options.size = this.size.getConnectedValue(state);
            options.width = this.width.getConnectedValue(state);
            options.height = this.height.getConnectedValue(state);
            options.depth = this.depth.getConnectedValue(state);
            const subdivisions = this.subdivisions.getConnectedValue(state);
            const subdivisionsX = this.subdivisionsX.getConnectedValue(state);
            const subdivisionsY = this.subdivisionsY.getConnectedValue(state);
            const subdivisionsZ = this.subdivisionsZ.getConnectedValue(state);
            if (subdivisions) options.segments = subdivisions;
            if (subdivisionsX) options.widthSegments = subdivisionsX;
            if (subdivisionsY) options.heightSegments = subdivisionsY;
            if (subdivisionsZ) options.depthSegments = subdivisionsZ;
            // Append vertex data from the plane builder
            return (0, $4C7Qm.CreateSegmentedBoxVertexData)(options);
        };
        if (this.evaluateContext) this.geometry._storedFunction = func;
        else {
            const value = func(state);
            this.geometry._storedFunction = ()=>{
                this.geometry._executionCount = 1;
                return value.clone();
            };
        }
    }
    _dumpPropertiesCode() {
        const codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.evaluateContext = ${this.evaluateContext ? "true" : "false"};\n`;
        return codeString;
    }
    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.evaluateContext = this.evaluateContext;
        return serializationObject;
    }
    _deserialize(serializationObject) {
        super._deserialize(serializationObject);
        this.evaluateContext = serializationObject.evaluateContext;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Evaluate context", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            rebuild: true
        }
    })
], $c155ee129f4120e4$export$ba0f53bc4eae986b.prototype, "evaluateContext", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.BoxBlock", $c155ee129f4120e4$export$ba0f53bc4eae986b);

});
parcelRegister("a76QT", function(module, exports) {

$parcel$export(module.exports, "GeometryInputBlock", () => $01e67316daeb853d$export$ce806f9a96a423ca);

var $diGQf = parcelRequire("diGQf");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");

var $8DoUR = parcelRequire("8DoUR");

var $ha1VO = parcelRequire("ha1VO");

var $8Jk1D = parcelRequire("8Jk1D");
class $01e67316daeb853d$export$ce806f9a96a423ca extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Gets or sets the connection point type (default is float)
     */ get type() {
        if (this._type === (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect) {
            if (this.value != null) {
                if (!isNaN(this.value)) {
                    this._type = (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float;
                    return this._type;
                }
                switch(this.value.getClassName()){
                    case "Vector2":
                        this._type = (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector2;
                        return this._type;
                    case "Vector3":
                        this._type = (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3;
                        return this._type;
                    case "Vector4":
                        this._type = (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector4;
                        return this._type;
                    case "Matrix":
                        this._type = (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix;
                        return this._type;
                }
            }
        }
        return this._type;
    }
    /**
     * Gets a boolean indicating that the current connection point is a contextual value
     */ get isContextual() {
        return this._contextualSource !== (0, $8Jk1D.NodeGeometryContextualSources).None;
    }
    /**
     * Gets or sets the current contextual value
     */ get contextualValue() {
        return this._contextualSource;
    }
    set contextualValue(value) {
        this._contextualSource = value;
        switch(value){
            case (0, $8Jk1D.NodeGeometryContextualSources).Positions:
            case (0, $8Jk1D.NodeGeometryContextualSources).Normals:
                this._type = (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3;
                break;
            case (0, $8Jk1D.NodeGeometryContextualSources).Colors:
            case (0, $8Jk1D.NodeGeometryContextualSources).Tangents:
                this._type = (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector4;
                break;
            case (0, $8Jk1D.NodeGeometryContextualSources).UV:
            case (0, $8Jk1D.NodeGeometryContextualSources).UV2:
            case (0, $8Jk1D.NodeGeometryContextualSources).UV3:
            case (0, $8Jk1D.NodeGeometryContextualSources).UV4:
            case (0, $8Jk1D.NodeGeometryContextualSources).UV5:
            case (0, $8Jk1D.NodeGeometryContextualSources).UV6:
                this._type = (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector2;
                break;
            case (0, $8Jk1D.NodeGeometryContextualSources).VertexID:
            case (0, $8Jk1D.NodeGeometryContextualSources).GeometryID:
            case (0, $8Jk1D.NodeGeometryContextualSources).CollectionID:
            case (0, $8Jk1D.NodeGeometryContextualSources).FaceID:
            case (0, $8Jk1D.NodeGeometryContextualSources).LoopID:
            case (0, $8Jk1D.NodeGeometryContextualSources).InstanceID:
                this._type = (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int;
                break;
        }
        if (this.output) this.output.type = this._type;
    }
    /**
     * Creates a new InputBlock
     * @param name defines the block name
     * @param type defines the type of the input (can be set to NodeGeometryBlockConnectionPointTypes.AutoDetect)
     */ constructor(name, type = (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect){
        super(name);
        this._type = (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Undefined;
        this._contextualSource = (0, $8Jk1D.NodeGeometryContextualSources).None;
        /** Gets or set a value used to limit the range of float values */ this.min = 0;
        /** Gets or set a value used to limit the range of float values */ this.max = 0;
        /** Gets or sets the group to use to display this block in the Inspector */ this.groupInInspector = "";
        /** Gets an observable raised when the value is changed */ this.onValueChangedObservable = new (0, $diGQf.Observable)();
        this._type = type;
        this._isInput = true;
        this.setDefaultValue();
        this.registerOutput("output", type);
    }
    /**
     * Gets or sets the value of that point.
     * Please note that this value will be ignored if valueCallback is defined
     */ get value() {
        return this._storedValue;
    }
    set value(value) {
        if (this.type === (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float) {
            if (this.min !== this.max) {
                value = Math.max(this.min, value);
                value = Math.min(this.max, value);
            }
        }
        this._storedValue = value;
        this.onValueChangedObservable.notifyObservers(this);
    }
    /**
     * Gets or sets a callback used to get the value of that point.
     * Please note that setting this value will force the connection point to ignore the value property
     */ get valueCallback() {
        return this._valueCallback;
    }
    set valueCallback(value) {
        this._valueCallback = value;
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "GeometryInputBlock";
    }
    /**
     * Gets the geometry output component
     */ get output() {
        return this._outputs[0];
    }
    /**
     * Set the input block to its default value (based on its type)
     */ setDefaultValue() {
        this.contextualValue = (0, $8Jk1D.NodeGeometryContextualSources).None;
        switch(this.type){
            case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int:
            case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float:
                this.value = 0;
                break;
            case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector2:
                this.value = (0, $ha1VO.Vector2).Zero();
                break;
            case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3:
                this.value = (0, $ha1VO.Vector3).Zero();
                break;
            case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector4:
                this.value = (0, $ha1VO.Vector4).Zero();
                break;
            case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix:
                this.value = (0, $ha1VO.Matrix).Identity();
                break;
        }
    }
    _buildBlock(state) {
        super._buildBlock(state);
        if (this.isContextual) {
            this.output._storedValue = null;
            this.output._storedFunction = (state)=>{
                return state.getContextualValue(this._contextualSource);
            };
        } else {
            this.output._storedFunction = null;
            this.output._storedValue = this.value;
        }
    }
    dispose() {
        this.onValueChangedObservable.clear();
        super.dispose();
    }
    _dumpPropertiesCode() {
        const variableName = this._codeVariableName;
        if (this.isContextual) return super._dumpPropertiesCode() + `${variableName}.contextualValue = BABYLON.NodeGeometryContextualSources.${(0, $8Jk1D.NodeGeometryContextualSources)[this._contextualSource]};\n`;
        const codes = [];
        let valueString = "";
        switch(this.type){
            case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float:
            case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int:
                valueString = `${this.value}`;
                break;
            case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector2:
                valueString = `new BABYLON.Vector2(${this.value.x}, ${this.value.y})`;
                break;
            case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3:
                valueString = `new BABYLON.Vector3(${this.value.x}, ${this.value.y}, ${this.value.z})`;
                break;
            case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector4:
                valueString = `new BABYLON.Vector4(${this.value.x}, ${this.value.y}, ${this.value.z}, ${this.value.w})`;
                break;
        }
        // Common Property "Value"
        codes.push(`${variableName}.value = ${valueString}`);
        // Float-Value-Specific Properties
        if (this.type === (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float || this.type === (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int) codes.push(`${variableName}.min = ${this.min}`, `${variableName}.max = ${this.max}`);
        codes.push("");
        return super._dumpPropertiesCode() + codes.join(";\n");
    }
    serialize() {
        const serializationObject = super.serialize();
        serializationObject.type = this.type;
        serializationObject.contextualValue = this.contextualValue;
        serializationObject.min = this.min;
        serializationObject.max = this.max;
        serializationObject.groupInInspector = this.groupInInspector;
        if (this._storedValue !== null && !this.isContextual) {
            if (this._storedValue.asArray) {
                serializationObject.valueType = "BABYLON." + this._storedValue.getClassName();
                serializationObject.value = this._storedValue.asArray();
            } else {
                serializationObject.valueType = "number";
                serializationObject.value = this._storedValue;
            }
        }
        return serializationObject;
    }
    _deserialize(serializationObject) {
        super._deserialize(serializationObject);
        this._type = serializationObject.type;
        this.contextualValue = serializationObject.contextualValue;
        this.min = serializationObject.min || 0;
        this.max = serializationObject.max || 0;
        this.groupInInspector = serializationObject.groupInInspector || "";
        if (!serializationObject.valueType) return;
        if (serializationObject.valueType === "number") this._storedValue = serializationObject.value;
        else {
            const valueType = (0, $8DoUR.GetClass)(serializationObject.valueType);
            if (valueType) this._storedValue = valueType.FromArray(serializationObject.value);
        }
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.GeometryInputBlock", $01e67316daeb853d$export$ce806f9a96a423ca);

});



parcelRegister("eN8Hc", function(module, exports) {

});

parcelRegister("6alCW", function(module, exports) {

$parcel$export(module.exports, "GeometryOptimizeBlock", () => $47d473f5faca4cdb$export$fa16de098396b271);

var $e0Suo = parcelRequire("e0Suo");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");

var $1aXVF = parcelRequire("1aXVF");

var $5v6ry = parcelRequire("5v6ry");

var $1VEEL = parcelRequire("1VEEL");

var $53VPf = parcelRequire("53VPf");
class $47d473f5faca4cdb$export$fa16de098396b271 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Creates a new GeometryOptimizeBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        /**
         * Gets or sets a boolean indicating that this block can evaluate context
         * Build performance is improved when this value is set to false as the system will cache values instead of reevaluating everything per context change
         */ this.evaluateContext = true;
        /**
         * Define the epsilon used to compare similar positions
         */ this.epsilon = (0, $53VPf.Epsilon);
        this.registerInput("geometry", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "GeometryOptimizeBlock";
    }
    /**
     * Gets the geometry component
     */ get geometry() {
        return this._inputs[0];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        const func = (state)=>{
            if (!this.geometry.isConnected) return null;
            const vertexData = this.geometry.getConnectedValue(state);
            const newPositions = [];
            const newIndicesMap = {};
            for(let index = 0; index < vertexData.positions.length; index += 3){
                const x = vertexData.positions[index];
                const y = vertexData.positions[index + 1];
                const z = vertexData.positions[index + 2];
                // check if we already have it
                let found = false;
                for(let checkIndex = 0; checkIndex < newPositions.length; checkIndex += 3)if ((0, $1VEEL.Scalar).WithinEpsilon(x, newPositions[checkIndex], this.epsilon) && (0, $1VEEL.Scalar).WithinEpsilon(y, newPositions[checkIndex + 1], this.epsilon) && (0, $1VEEL.Scalar).WithinEpsilon(z, newPositions[checkIndex + 2], this.epsilon)) {
                    newIndicesMap[index / 3] = checkIndex / 3;
                    found = true;
                    continue;
                }
                if (!found) {
                    newIndicesMap[index / 3] = newPositions.length / 3;
                    newPositions.push(x, y, z);
                }
            }
            const newVertexData = new (0, $5v6ry.VertexData)();
            newVertexData.positions = newPositions;
            newVertexData.indices = vertexData.indices.map((index)=>newIndicesMap[index]);
            return newVertexData;
        };
        if (this.evaluateContext) this.output._storedFunction = func;
        else {
            this.output._storedFunction = null;
            this.output._storedValue = func(state);
        }
    }
    _dumpPropertiesCode() {
        let codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.evaluateContext = ${this.evaluateContext ? "true" : "false"};\n`;
        codeString += `${this._codeVariableName}.epsilon = ${this.epsilon};\n`;
        return codeString;
    }
    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.evaluateContext = this.evaluateContext;
        serializationObject.epsilon = this.epsilon;
        return serializationObject;
    }
    _deserialize(serializationObject) {
        super._deserialize(serializationObject);
        this.evaluateContext = serializationObject.evaluateContext;
        this.epsilon = serializationObject.epsilon;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Evaluate context", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            rebuild: true
        }
    })
], $47d473f5faca4cdb$export$fa16de098396b271.prototype, "evaluateContext", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Epsilon", (0, $1aXVF.PropertyTypeForEdition).Float, "ADVANCED", {
        notifiers: {
            rebuild: true
        }
    })
], $47d473f5faca4cdb$export$fa16de098396b271.prototype, "epsilon", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.GeometryOptimizeBlock", $47d473f5faca4cdb$export$fa16de098396b271);

});

parcelRegister("jChac", function(module, exports) {

$parcel$export(module.exports, "PlaneBlock", () => $e47ee13e15a11920$export$3ff25cbb61804cb8);

var $e0Suo = parcelRequire("e0Suo");

var $kt6s5 = parcelRequire("kt6s5");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");

var $a76QT = parcelRequire("a76QT");

var $8DoUR = parcelRequire("8DoUR");

var $1aXVF = parcelRequire("1aXVF");
class $e47ee13e15a11920$export$3ff25cbb61804cb8 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new PlaneBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        /**
         * Gets or sets a boolean indicating that this block can evaluate context
         * Build performance is improved when this value is set to false as the system will cache values instead of reevaluating everything per context change
         */ this.evaluateContext = false;
        this.registerInput("size", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 1);
        this.registerInput("width", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 0);
        this.registerInput("height", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 0);
        this.registerOutput("geometry", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "PlaneBlock";
    }
    /**
     * Gets the size input component
     */ get size() {
        return this._inputs[0];
    }
    /**
     * Gets the width input component
     */ get width() {
        return this._inputs[1];
    }
    /**
     * Gets the height input component
     */ get height() {
        return this._inputs[2];
    }
    /**
     * Gets the geometry output component
     */ get geometry() {
        return this._outputs[0];
    }
    autoConfigure() {
        if (this.size.isConnected) return;
        if (!this.width.isConnected && !this.height.isConnected) {
            const sizeInput = new (0, $a76QT.GeometryInputBlock)("Size");
            sizeInput.value = 1;
            sizeInput.output.connectTo(this.size);
            return;
        }
        if (!this.width.isConnected) {
            const widthInput = new (0, $a76QT.GeometryInputBlock)("Width");
            widthInput.value = 1;
            widthInput.output.connectTo(this.width);
        }
        if (!this.height.isConnected) {
            const heightInput = new (0, $a76QT.GeometryInputBlock)("Height");
            heightInput.value = 1;
            heightInput.output.connectTo(this.height);
        }
    }
    _buildBlock(state) {
        const options = {};
        const func = (state)=>{
            options.size = this.size.getConnectedValue(state);
            options.width = this.width.getConnectedValue(state);
            options.height = this.height.getConnectedValue(state);
            // Append vertex data from the plane builder
            return (0, $kt6s5.CreatePlaneVertexData)(options);
        };
        if (this.evaluateContext) this.geometry._storedFunction = func;
        else {
            const value = func(state);
            this.geometry._storedFunction = ()=>{
                this.geometry._executionCount = 1;
                return value.clone();
            };
        }
    }
    _dumpPropertiesCode() {
        const codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.evaluateContext = ${this.evaluateContext ? "true" : "false"};\n`;
        return codeString;
    }
    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.evaluateContext = this.evaluateContext;
        return serializationObject;
    }
    _deserialize(serializationObject) {
        super._deserialize(serializationObject);
        this.evaluateContext = serializationObject.evaluateContext;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Evaluate context", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            rebuild: true
        }
    })
], $e47ee13e15a11920$export$3ff25cbb61804cb8.prototype, "evaluateContext", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.PlaneBlock", $e47ee13e15a11920$export$3ff25cbb61804cb8);

});

parcelRegister("Spfz5", function(module, exports) {

$parcel$export(module.exports, "MeshBlock", () => $0a38a164ce78c8e2$export$c9e482cecc435b42);

var $e0Suo = parcelRequire("e0Suo");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");

var $8DoUR = parcelRequire("8DoUR");

var $5v6ry = parcelRequire("5v6ry");

var $1aXVF = parcelRequire("1aXVF");
class $0a38a164ce78c8e2$export$c9e482cecc435b42 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Gets or sets the mesh to use to get vertex data
     */ get mesh() {
        return this._mesh;
    }
    set mesh(value) {
        this._mesh = value;
    }
    /**
     * Create a new MeshBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this._cachedVertexData = null;
        /**
         * Gets or sets a boolean indicating that winding order needs to be reserved
         */ this.reverseWindingOrder = false;
        /**
         * Gets or sets a boolean indicating that this block should serialize its cached data
         */ this.serializedCachedData = false;
        this.registerOutput("geometry", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "MeshBlock";
    }
    /**
     * Gets a boolean indicating if the block is using cached data
     */ get isUsingCachedData() {
        return !this.mesh && !!this._cachedVertexData;
    }
    /**
     * Gets the geometry output component
     */ get geometry() {
        return this._outputs[0];
    }
    /**
     * Remove stored data
     */ cleanData() {
        this._mesh = null;
        this._cachedVertexData = null;
    }
    _buildBlock() {
        if (!this._mesh) {
            if (this._cachedVertexData) this.geometry._storedValue = this._cachedVertexData.clone();
            else this.geometry._storedValue = null;
            return;
        }
        const vertexData = (0, $5v6ry.VertexData).ExtractFromMesh(this._mesh, false, true);
        this._cachedVertexData = null;
        if (this.reverseWindingOrder && vertexData.indices) for(let index = 0; index < vertexData.indices.length; index += 3){
            const tmp = vertexData.indices[index];
            vertexData.indices[index] = vertexData.indices[index + 2];
            vertexData.indices[index + 2] = tmp;
        }
        this.geometry._storedFunction = ()=>{
            return vertexData.clone();
        };
    }
    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.serializedCachedData = this.serializedCachedData;
        if (this.serializedCachedData) {
            if (this._mesh) serializationObject.cachedVertexData = (0, $5v6ry.VertexData).ExtractFromMesh(this._mesh, false, true).serialize();
            else if (this._cachedVertexData) serializationObject.cachedVertexData = this._cachedVertexData.serialize();
        }
        serializationObject.reverseWindingOrder = this.reverseWindingOrder;
        return serializationObject;
    }
    _deserialize(serializationObject) {
        super._deserialize(serializationObject);
        if (serializationObject.cachedVertexData) this._cachedVertexData = (0, $5v6ry.VertexData).Parse(serializationObject.cachedVertexData);
        this.serializedCachedData = !!serializationObject.serializedCachedData;
        this.reverseWindingOrder = serializationObject.reverseWindingOrder;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Serialize cached data", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            rebuild: true
        }
    })
], $0a38a164ce78c8e2$export$c9e482cecc435b42.prototype, "serializedCachedData", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.MeshBlock", $0a38a164ce78c8e2$export$c9e482cecc435b42);

});

parcelRegister("eG1cP", function(module, exports) {

$parcel$export(module.exports, "IcoSphereBlock", () => $02c1e6e8eae991c2$export$aa964b89b89ad75a);

var $e0Suo = parcelRequire("e0Suo");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");

var $a76QT = parcelRequire("a76QT");

var $8DoUR = parcelRequire("8DoUR");

var $g3tvW = parcelRequire("g3tvW");

var $1aXVF = parcelRequire("1aXVF");
class $02c1e6e8eae991c2$export$aa964b89b89ad75a extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new IcoSphereBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        /**
         * Gets or sets a boolean indicating that this block can evaluate context
         * Build performance is improved when this value is set to false as the system will cache values instead of reevaluating everything per context change
         */ this.evaluateContext = false;
        this.registerInput("radius", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 1);
        this.registerInput("radiusX", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 0);
        this.registerInput("radiusY", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 0);
        this.registerInput("radiusZ", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 0);
        this.registerInput("subdivisions", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int, true, 4);
        this.registerOutput("geometry", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "IcoSphereBlock";
    }
    /**
     * Gets the radius input component
     */ get radius() {
        return this._inputs[0];
    }
    /**
     * Gets the radiusX input component
     */ get radiusX() {
        return this._inputs[1];
    }
    /**
     * Gets the radiusY input component
     */ get radiusY() {
        return this._inputs[2];
    }
    /**
     * Gets the radiusZ input component
     */ get radiusZ() {
        return this._inputs[3];
    }
    /**
     * Gets the subdivisions input component
     */ get subdivisions() {
        return this._inputs[4];
    }
    /**
     * Gets the geometry output component
     */ get geometry() {
        return this._outputs[0];
    }
    autoConfigure() {
        if (!this.radius.isConnected) {
            const radiusInput = new (0, $a76QT.GeometryInputBlock)("Radius");
            radiusInput.value = 0.2;
            radiusInput.output.connectTo(this.radius);
        }
    }
    _buildBlock(state) {
        const options = {};
        const func = (state)=>{
            options.radius = this.radius.getConnectedValue(state);
            options.subdivisions = this.subdivisions.getConnectedValue(state);
            options.radiusX = this.radiusX.getConnectedValue(state);
            options.radiusY = this.radiusY.getConnectedValue(state);
            options.radiusZ = this.radiusZ.getConnectedValue(state);
            // Append vertex data from the plane builder
            return (0, $g3tvW.CreateIcoSphereVertexData)(options);
        };
        if (this.evaluateContext) this.geometry._storedFunction = func;
        else {
            const value = func(state);
            this.geometry._storedFunction = ()=>{
                this.geometry._executionCount = 1;
                return value.clone();
            };
        }
    }
    _dumpPropertiesCode() {
        const codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.evaluateContext = ${this.evaluateContext ? "true" : "false"};\n`;
        return codeString;
    }
    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.evaluateContext = this.evaluateContext;
        return serializationObject;
    }
    _deserialize(serializationObject) {
        super._deserialize(serializationObject);
        this.evaluateContext = serializationObject.evaluateContext;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Evaluate context", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            rebuild: true
        }
    })
], $02c1e6e8eae991c2$export$aa964b89b89ad75a.prototype, "evaluateContext", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.IcoSphereBlock", $02c1e6e8eae991c2$export$aa964b89b89ad75a);

});

parcelRegister("hZjUT", function(module, exports) {

$parcel$export(module.exports, "SphereBlock", () => $d1879530de80b62e$export$151376cd387832b4);

var $e0Suo = parcelRequire("e0Suo");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");

var $a76QT = parcelRequire("a76QT");

var $8DoUR = parcelRequire("8DoUR");

var $8KqOo = parcelRequire("8KqOo");

var $1aXVF = parcelRequire("1aXVF");
class $d1879530de80b62e$export$151376cd387832b4 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new SphereBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        /**
         * Gets or sets a boolean indicating that this block can evaluate context
         * Build performance is improved when this value is set to false as the system will cache values instead of reevaluating everything per context change
         */ this.evaluateContext = false;
        this.registerInput("segments", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int, true, 32);
        this.registerInput("diameter", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 1);
        this.registerInput("diameterX", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 0);
        this.registerInput("diameterY", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 0);
        this.registerInput("diameterZ", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 0);
        this.registerInput("arc", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 1);
        this.registerInput("slice", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 1);
        this.registerOutput("geometry", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "SphereBlock";
    }
    /**
     * Gets the segments input component
     */ get segments() {
        return this._inputs[0];
    }
    /**
     * Gets the diameter input component
     */ get diameter() {
        return this._inputs[1];
    }
    /**
     * Gets the diameterX input component
     */ get diameterX() {
        return this._inputs[2];
    }
    /**
     * Gets the diameterY input component
     */ get diameterY() {
        return this._inputs[3];
    }
    /**
     * Gets the diameterZ input component
     */ get diameterZ() {
        return this._inputs[4];
    }
    /**
     * Gets the arc input component
     */ get arc() {
        return this._inputs[5];
    }
    /**
     * Gets the slice input component
     */ get slice() {
        return this._inputs[6];
    }
    /**
     * Gets the geometry output component
     */ get geometry() {
        return this._outputs[0];
    }
    autoConfigure() {
        if (!this.diameter.isConnected) {
            const diameterInput = new (0, $a76QT.GeometryInputBlock)("Diameter");
            diameterInput.value = 1;
            diameterInput.output.connectTo(this.diameter);
        }
    }
    _buildBlock(state) {
        const options = {};
        const func = (state)=>{
            options.segments = this.segments.getConnectedValue(state);
            options.diameter = this.diameter.getConnectedValue(state);
            options.diameterX = this.diameterX.getConnectedValue(state);
            options.diameterY = this.diameterY.getConnectedValue(state);
            options.diameterZ = this.diameterZ.getConnectedValue(state);
            options.arc = this.arc.getConnectedValue(state);
            options.slice = this.slice.getConnectedValue(state);
            // Append vertex data from the plane builder
            return (0, $8KqOo.CreateSphereVertexData)(options);
        };
        if (this.evaluateContext) this.geometry._storedFunction = func;
        else {
            const value = func(state);
            this.geometry._storedFunction = ()=>{
                this.geometry._executionCount = 1;
                return value.clone();
            };
        }
    }
    _dumpPropertiesCode() {
        const codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.evaluateContext = ${this.evaluateContext ? "true" : "false"};\n`;
        return codeString;
    }
    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.evaluateContext = this.evaluateContext;
        return serializationObject;
    }
    _deserialize(serializationObject) {
        super._deserialize(serializationObject);
        this.evaluateContext = serializationObject.evaluateContext;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Evaluate context", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            rebuild: true
        }
    })
], $d1879530de80b62e$export$151376cd387832b4.prototype, "evaluateContext", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.SphereBlock", $d1879530de80b62e$export$151376cd387832b4);

});

parcelRegister("9nf7R", function(module, exports) {

$parcel$export(module.exports, "GridBlock", () => $6d31feb96f0ad684$export$523a194ee0648976);

var $e0Suo = parcelRequire("e0Suo");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");

var $a76QT = parcelRequire("a76QT");

var $8DoUR = parcelRequire("8DoUR");

var $8CiHO = parcelRequire("8CiHO");

var $1aXVF = parcelRequire("1aXVF");
class $6d31feb96f0ad684$export$523a194ee0648976 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new GridBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        /**
         * Gets or sets a boolean indicating that this block can evaluate context
         * Build performance is improved when this value is set to false as the system will cache values instead of reevaluating everything per context change
         */ this.evaluateContext = false;
        this.registerInput("width", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 1);
        this.registerInput("height", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 1);
        this.registerInput("subdivisions", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int, true, 1);
        this.registerInput("subdivisionsX", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int, true, 0);
        this.registerInput("subdivisionsY", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int, true, 0);
        this.registerOutput("geometry", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "GridBlock";
    }
    /**
     * Gets the width input component
     */ get width() {
        return this._inputs[0];
    }
    /**
     * Gets the height input component
     */ get height() {
        return this._inputs[1];
    }
    /**
     * Gets the subdivisions input component
     */ get subdivisions() {
        return this._inputs[2];
    }
    /**
     * Gets the subdivisionsX input component
     */ get subdivisionsX() {
        return this._inputs[3];
    }
    /**
     * Gets the subdivisionsY input component
     */ get subdivisionsY() {
        return this._inputs[4];
    }
    /**
     * Gets the geometry output component
     */ get geometry() {
        return this._outputs[0];
    }
    autoConfigure() {
        if (!this.width.isConnected) {
            const widthInput = new (0, $a76QT.GeometryInputBlock)("Width");
            widthInput.value = 1;
            widthInput.output.connectTo(this.width);
        }
        if (!this.height.isConnected) {
            const heightInput = new (0, $a76QT.GeometryInputBlock)("Height");
            heightInput.value = 1;
            heightInput.output.connectTo(this.height);
        }
    }
    _buildBlock(state) {
        const options = {};
        const func = (state)=>{
            options.width = this.width.getConnectedValue(state);
            options.height = this.height.getConnectedValue(state);
            options.subdivisions = this.subdivisions.getConnectedValue(state);
            options.subdivisionsX = this.subdivisionsX.getConnectedValue(state);
            options.subdivisionsY = this.subdivisionsY.getConnectedValue(state);
            // Append vertex data from the plane builder
            return (0, $8CiHO.CreateGroundVertexData)(options);
        };
        if (this.evaluateContext) this.geometry._storedFunction = func;
        else {
            const value = func(state);
            this.geometry._storedFunction = ()=>{
                this.geometry._executionCount = 1;
                return value.clone();
            };
        }
    }
    _dumpPropertiesCode() {
        const codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.evaluateContext = ${this.evaluateContext ? "true" : "false"};\n`;
        return codeString;
    }
    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.evaluateContext = this.evaluateContext;
        return serializationObject;
    }
    _deserialize(serializationObject) {
        super._deserialize(serializationObject);
        this.evaluateContext = serializationObject.evaluateContext;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Evaluate context", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            rebuild: true
        }
    })
], $6d31feb96f0ad684$export$523a194ee0648976.prototype, "evaluateContext", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.GridBlock", $6d31feb96f0ad684$export$523a194ee0648976);

});

parcelRegister("7KArL", function(module, exports) {

$parcel$export(module.exports, "TorusBlock", () => $5a4919dc0c2fe10b$export$476c7130e1ff3399);

var $e0Suo = parcelRequire("e0Suo");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");

var $a76QT = parcelRequire("a76QT");

var $8DoUR = parcelRequire("8DoUR");

var $bCJrn = parcelRequire("bCJrn");

var $1aXVF = parcelRequire("1aXVF");
class $5a4919dc0c2fe10b$export$476c7130e1ff3399 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new TorusBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        /**
         * Gets or sets a boolean indicating that this block can evaluate context
         * Build performance is improved when this value is set to false as the system will cache values instead of reevaluating everything per context change
         */ this.evaluateContext = false;
        this.registerInput("diameter", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 1);
        this.registerInput("thickness", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 0.5);
        this.registerInput("tessellation", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int, true, 16);
        this.registerOutput("geometry", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "TorusBlock";
    }
    /**
     * Gets the diameter input component
     */ get diameter() {
        return this._inputs[0];
    }
    /**
     * Gets the thickness input component
     */ get thickness() {
        return this._inputs[1];
    }
    /**
     * Gets the tessellation input component
     */ get tessellation() {
        return this._inputs[2];
    }
    /**
     * Gets the geometry output component
     */ get geometry() {
        return this._outputs[0];
    }
    autoConfigure() {
        if (!this.diameter.isConnected) {
            const diameterInput = new (0, $a76QT.GeometryInputBlock)("Diameter");
            diameterInput.value = 1;
            diameterInput.output.connectTo(this.diameter);
        }
    }
    _buildBlock(state) {
        const options = {};
        const func = (state)=>{
            options.thickness = this.thickness.getConnectedValue(state);
            options.diameter = this.diameter.getConnectedValue(state);
            options.tessellation = this.tessellation.getConnectedValue(state);
            // Append vertex data from the plane builder
            return (0, $bCJrn.CreateTorusVertexData)(options);
        };
        if (this.evaluateContext) this.geometry._storedFunction = func;
        else {
            const value = func(state);
            this.geometry._storedFunction = ()=>{
                this.geometry._executionCount = 1;
                return value.clone();
            };
        }
    }
    _dumpPropertiesCode() {
        const codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.evaluateContext = ${this.evaluateContext ? "true" : "false"};\n`;
        return codeString;
    }
    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.evaluateContext = this.evaluateContext;
        return serializationObject;
    }
    _deserialize(serializationObject) {
        super._deserialize(serializationObject);
        this.evaluateContext = serializationObject.evaluateContext;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Evaluate context", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            rebuild: true
        }
    })
], $5a4919dc0c2fe10b$export$476c7130e1ff3399.prototype, "evaluateContext", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.TorusBlock", $5a4919dc0c2fe10b$export$476c7130e1ff3399);

});

parcelRegister("DaRa4", function(module, exports) {

$parcel$export(module.exports, "CylinderBlock", () => $075c107f0a8fa44b$export$9726976566054a9b);

var $e0Suo = parcelRequire("e0Suo");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");

var $a76QT = parcelRequire("a76QT");

var $8DoUR = parcelRequire("8DoUR");

var $9zY5k = parcelRequire("9zY5k");

var $1aXVF = parcelRequire("1aXVF");
class $075c107f0a8fa44b$export$9726976566054a9b extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new SphereBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        /**
         * Gets or sets a boolean indicating that this block can evaluate context
         * Build performance is improved when this value is set to false as the system will cache values instead of reevaluating everything per context change
         */ this.evaluateContext = false;
        this.registerInput("height", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 25);
        this.registerInput("diameter", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 1);
        this.registerInput("diameterTop", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, -1);
        this.registerInput("diameterBottom", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, -1);
        this.registerInput("subdivisions", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int, true, 1);
        this.registerInput("tessellation", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int, true, 24);
        this.registerInput("arc", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 1.0);
        this.registerOutput("geometry", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "CylinderBlock";
    }
    /**
     * Gets the height input component
     */ get height() {
        return this._inputs[0];
    }
    /**
     * Gets the diameter input component
     */ get diameter() {
        return this._inputs[1];
    }
    /**
     * Gets the diameterTop input component
     */ get diameterTop() {
        return this._inputs[2];
    }
    /**
     * Gets the diameterBottom input component
     */ get diameterBottom() {
        return this._inputs[3];
    }
    /**
     * Gets the subdivisions input component
     */ get subdivisions() {
        return this._inputs[4];
    }
    /**
     * Gets the tessellation input component
     */ get tessellation() {
        return this._inputs[5];
    }
    /**
     * Gets the arc input component
     */ get arc() {
        return this._inputs[6];
    }
    /**
     * Gets the geometry output component
     */ get geometry() {
        return this._outputs[0];
    }
    autoConfigure() {
        if (!this.diameter.isConnected) {
            const diameterInput = new (0, $a76QT.GeometryInputBlock)("Diameter");
            diameterInput.value = 1;
            diameterInput.output.connectTo(this.diameter);
        }
        if (!this.height.isConnected) {
            const heightInput = new (0, $a76QT.GeometryInputBlock)("Height");
            heightInput.value = 1;
            heightInput.output.connectTo(this.height);
        }
    }
    _buildBlock(state) {
        const options = {};
        const func = (state)=>{
            options.height = this.height.getConnectedValue(state);
            options.diameter = this.diameter.getConnectedValue(state);
            options.diameterTop = this.diameterTop.getConnectedValue(state);
            options.diameterBottom = this.diameterBottom.getConnectedValue(state);
            if (options.diameterTop === -1) options.diameterTop = options.diameter;
            if (options.diameterBottom === -1) options.diameterBottom = options.diameter;
            options.tessellation = this.tessellation.getConnectedValue(state);
            options.subdivisions = this.subdivisions.getConnectedValue(state);
            options.arc = this.arc.getConnectedValue(state);
            // Append vertex data from the plane builder
            return (0, $9zY5k.CreateCylinderVertexData)(options);
        };
        if (this.evaluateContext) this.geometry._storedFunction = func;
        else {
            const value = func(state);
            this.geometry._storedFunction = ()=>{
                this.geometry._executionCount = 1;
                return value.clone();
            };
        }
    }
    _dumpPropertiesCode() {
        const codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.evaluateContext = ${this.evaluateContext ? "true" : "false"};\n`;
        return codeString;
    }
    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.evaluateContext = this.evaluateContext;
        return serializationObject;
    }
    _deserialize(serializationObject) {
        super._deserialize(serializationObject);
        this.evaluateContext = serializationObject.evaluateContext;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Evaluate context", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            rebuild: true
        }
    })
], $075c107f0a8fa44b$export$9726976566054a9b.prototype, "evaluateContext", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.CylinderBlock", $075c107f0a8fa44b$export$9726976566054a9b);

});

parcelRegister("l4YtH", function(module, exports) {

$parcel$export(module.exports, "CapsuleBlock", () => $f588e264b0db8949$export$a9e3d0dfdca18377);

var $e0Suo = parcelRequire("e0Suo");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");

var $a76QT = parcelRequire("a76QT");

var $8DoUR = parcelRequire("8DoUR");

var $22sXo = parcelRequire("22sXo");

var $1aXVF = parcelRequire("1aXVF");
class $f588e264b0db8949$export$a9e3d0dfdca18377 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new CapsuleBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        /**
         * Gets or sets a boolean indicating that this block can evaluate context
         * Build performance is improved when this value is set to false as the system will cache values instead of reevaluating everything per context change
         */ this.evaluateContext = false;
        this.registerInput("height", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 1);
        this.registerInput("radius", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 0.25);
        this.registerInput("tessellation", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int, true, 16);
        this.registerInput("subdivisions", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int, true, 2);
        this.registerOutput("geometry", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "CapsuleBlock";
    }
    /**
     * Gets the height input component
     */ get height() {
        return this._inputs[0];
    }
    /**
     * Gets the radius input component
     */ get radius() {
        return this._inputs[1];
    }
    /**
     * Gets the tessellation input component
     */ get tessellation() {
        return this._inputs[2];
    }
    /**
     * Gets the subdivisions input component
     */ get subdivisions() {
        return this._inputs[3];
    }
    /**
     * Gets the geometry output component
     */ get geometry() {
        return this._outputs[0];
    }
    autoConfigure() {
        if (!this.height.isConnected) {
            const heightInput = new (0, $a76QT.GeometryInputBlock)("Height");
            heightInput.value = 1;
            heightInput.output.connectTo(this.height);
        }
        if (!this.radius.isConnected) {
            const radiusInput = new (0, $a76QT.GeometryInputBlock)("Radius");
            radiusInput.value = 0.2;
            radiusInput.output.connectTo(this.radius);
        }
    }
    _buildBlock(state) {
        const options = {};
        const func = (state)=>{
            options.height = this.height.getConnectedValue(state);
            options.radius = this.radius.getConnectedValue(state);
            options.tessellation = this.tessellation.getConnectedValue(state);
            options.subdivisions = this.subdivisions.getConnectedValue(state);
            // Append vertex data from the plane builder
            return (0, $22sXo.CreateCapsuleVertexData)(options);
        };
        if (this.evaluateContext) this.geometry._storedFunction = func;
        else {
            const value = func(state);
            this.geometry._storedFunction = ()=>{
                this.geometry._executionCount = 1;
                return value.clone();
            };
        }
    }
    _dumpPropertiesCode() {
        const codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.evaluateContext = ${this.evaluateContext ? "true" : "false"};\n`;
        return codeString;
    }
    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.evaluateContext = this.evaluateContext;
        return serializationObject;
    }
    _deserialize(serializationObject) {
        super._deserialize(serializationObject);
        this.evaluateContext = serializationObject.evaluateContext;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Evaluate context", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            rebuild: true
        }
    })
], $f588e264b0db8949$export$a9e3d0dfdca18377.prototype, "evaluateContext", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.CapsuleBlock", $f588e264b0db8949$export$a9e3d0dfdca18377);

});

parcelRegister("f877G", function(module, exports) {

$parcel$export(module.exports, "DiscBlock", () => $b03d20d328cd042a$export$cbeac13d5ad8f946);

var $e0Suo = parcelRequire("e0Suo");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");

var $a76QT = parcelRequire("a76QT");

var $8DoUR = parcelRequire("8DoUR");

var $fWMvm = parcelRequire("fWMvm");

var $1aXVF = parcelRequire("1aXVF");
class $b03d20d328cd042a$export$cbeac13d5ad8f946 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new DiscBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        /**
         * Gets or sets a boolean indicating that this block can evaluate context
         * Build performance is improved when this value is set to false as the system will cache values instead of reevaluating everything per context change
         */ this.evaluateContext = false;
        this.registerInput("radius", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 0.5);
        this.registerInput("tessellation", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int, true, 64);
        this.registerInput("arc", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 1.0);
        this.registerOutput("geometry", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "DiscBlock";
    }
    /**
     * Gets the radius input component
     */ get radius() {
        return this._inputs[0];
    }
    /**
     * Gets the tessellation input component
     */ get tessellation() {
        return this._inputs[1];
    }
    /**
     * Gets the arc input component
     */ get arc() {
        return this._inputs[2];
    }
    /**
     * Gets the geometry output component
     */ get geometry() {
        return this._outputs[0];
    }
    autoConfigure() {
        if (!this.radius.isConnected) {
            const radiusInput = new (0, $a76QT.GeometryInputBlock)("Radius");
            radiusInput.value = 0.2;
            radiusInput.output.connectTo(this.radius);
        }
    }
    _buildBlock(state) {
        const options = {};
        const func = (state)=>{
            options.radius = this.radius.getConnectedValue(state);
            options.tessellation = this.tessellation.getConnectedValue(state);
            options.arc = this.arc.getConnectedValue(state);
            // Append vertex data from the plane builder
            return (0, $fWMvm.CreateDiscVertexData)(options);
        };
        if (this.evaluateContext) this.geometry._storedFunction = func;
        else {
            const value = func(state);
            this.geometry._storedFunction = ()=>{
                this.geometry._executionCount = 1;
                return value.clone();
            };
        }
    }
    _dumpPropertiesCode() {
        const codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.evaluateContext = ${this.evaluateContext ? "true" : "false"};\n`;
        return codeString;
    }
    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.evaluateContext = this.evaluateContext;
        return serializationObject;
    }
    _deserialize(serializationObject) {
        super._deserialize(serializationObject);
        this.evaluateContext = serializationObject.evaluateContext;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Evaluate context", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            rebuild: true
        }
    })
], $b03d20d328cd042a$export$cbeac13d5ad8f946.prototype, "evaluateContext", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.DiscBlock", $b03d20d328cd042a$export$cbeac13d5ad8f946);

});

parcelRegister("eCyMX", function(module, exports) {

$parcel$export(module.exports, "NullBlock", () => $aa4f9997e22d5234$export$dbe67fc4723c4db3);

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");

var $8DoUR = parcelRequire("8DoUR");
class $aa4f9997e22d5234$export$dbe67fc4723c4db3 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new NullBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this.registerOutput("geometry", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "NullBlock";
    }
    /**
     * Gets the geometry output component
     */ get geometry() {
        return this._outputs[0];
    }
    _buildBlock() {
        this.geometry._storedValue = null;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.NullBlock", $aa4f9997e22d5234$export$dbe67fc4723c4db3);

});

parcelRegister("kJLgn", function(module, exports) {

$parcel$export(module.exports, "SetPositionsBlock", () => $f18cac148f0d9cd6$export$c87c6b39d1c45e86);

var $e0Suo = parcelRequire("e0Suo");

var $gJfVN = parcelRequire("gJfVN");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $1aXVF = parcelRequire("1aXVF");
class $f18cac148f0d9cd6$export$c87c6b39d1c45e86 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new SetPositionsBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        /**
         * Gets or sets a boolean indicating that this block can evaluate context
         * Build performance is improved when this value is set to false as the system will cache values instead of reevaluating everything per context change
         */ this.evaluateContext = true;
        this.registerInput("geometry", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
        this.registerInput("positions", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
    }
    /**
     * Gets the current index in the current flow
     * @returns the current index
     */ getExecutionIndex() {
        return this._currentIndex;
    }
    /**
     * Gets the current loop index in the current flow
     * @returns the current loop index
     */ getExecutionLoopIndex() {
        return this._currentIndex;
    }
    /**
     * Gets the current face index in the current flow
     * @returns the current face index
     */ getExecutionFaceIndex() {
        return 0;
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "SetPositionsBlock";
    }
    /**
     * Gets the geometry input component
     */ get geometry() {
        return this._inputs[0];
    }
    /**
     * Gets the positions input component
     */ get positions() {
        return this._inputs[1];
    }
    /**
     * Gets the geometry output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        const func = (state)=>{
            state.pushExecutionContext(this);
            this._vertexData = this.geometry.getConnectedValue(state);
            if (this._vertexData) this._vertexData = this._vertexData.clone(); // Preserve source data
            state.pushGeometryContext(this._vertexData);
            if (!this._vertexData || !this._vertexData.positions || !this.positions.isConnected) {
                state.restoreGeometryContext();
                state.restoreExecutionContext();
                this.output._storedValue = null;
                return;
            }
            // Processing
            const vertexCount = this._vertexData.positions.length / 3;
            for(this._currentIndex = 0; this._currentIndex < vertexCount; this._currentIndex++){
                const tempVector3 = this.positions.getConnectedValue(state);
                if (tempVector3) tempVector3.toArray(this._vertexData.positions, this._currentIndex * 3);
            }
            // Storage
            state.restoreGeometryContext();
            state.restoreExecutionContext();
            return this._vertexData;
        };
        if (this.evaluateContext) this.output._storedFunction = func;
        else {
            this.output._storedFunction = null;
            this.output._storedValue = func(state);
        }
    }
    _dumpPropertiesCode() {
        const codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.evaluateContext = ${this.evaluateContext ? "true" : "false"};\n`;
        return codeString;
    }
    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.evaluateContext = this.evaluateContext;
        return serializationObject;
    }
    _deserialize(serializationObject) {
        super._deserialize(serializationObject);
        if (serializationObject.evaluateContext !== undefined) this.evaluateContext = serializationObject.evaluateContext;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Evaluate context", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            rebuild: true
        }
    })
], $f18cac148f0d9cd6$export$c87c6b39d1c45e86.prototype, "evaluateContext", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.SetPositionsBlock", $f18cac148f0d9cd6$export$c87c6b39d1c45e86);

});

parcelRegister("bzxv9", function(module, exports) {

$parcel$export(module.exports, "SetNormalsBlock", () => $86ccf345902b5ef2$export$fac07ca11f907c3e);

var $e0Suo = parcelRequire("e0Suo");

var $gJfVN = parcelRequire("gJfVN");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $1aXVF = parcelRequire("1aXVF");
class $86ccf345902b5ef2$export$fac07ca11f907c3e extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new SetNormalsBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        /**
         * Gets or sets a boolean indicating that this block can evaluate context
         * Build performance is improved when this value is set to false as the system will cache values instead of reevaluating everything per context change
         */ this.evaluateContext = true;
        this.registerInput("geometry", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
        this.registerInput("normals", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
    }
    /**
     * Gets the current index in the current flow
     * @returns the current index
     */ getExecutionIndex() {
        return this._currentIndex;
    }
    /**
     * Gets the current loop index in the current flow
     * @returns the current loop index
     */ getExecutionLoopIndex() {
        return this._currentIndex;
    }
    /**
     * Gets the current face index in the current flow
     * @returns the current face index
     */ getExecutionFaceIndex() {
        return 0;
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "SetNormalsBlock";
    }
    /**
     * Gets the geometry input component
     */ get geometry() {
        return this._inputs[0];
    }
    /**
     * Gets the normals input component
     */ get normals() {
        return this._inputs[1];
    }
    /**
     * Gets the geometry output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        const func = (state)=>{
            state.pushExecutionContext(this);
            this._vertexData = this.geometry.getConnectedValue(state);
            if (this._vertexData) this._vertexData = this._vertexData.clone(); // Preserve source data
            state.pushGeometryContext(this._vertexData);
            if (!this._vertexData || !this._vertexData.positions) {
                state.restoreGeometryContext();
                state.restoreExecutionContext();
                this.output._storedValue = null;
                return;
            }
            if (!this.normals.isConnected) {
                state.restoreGeometryContext();
                state.restoreExecutionContext();
                this.output._storedValue = this._vertexData;
                return;
            }
            if (!this._vertexData.normals) this._vertexData.normals = [];
            // Processing
            const vertexCount = this._vertexData.positions.length / 3;
            for(this._currentIndex = 0; this._currentIndex < vertexCount; this._currentIndex++){
                const tempVector3 = this.normals.getConnectedValue(state);
                if (tempVector3) tempVector3.toArray(this._vertexData.normals, this._currentIndex * 3);
            }
            // Storage
            state.restoreGeometryContext();
            state.restoreExecutionContext();
            return this._vertexData;
        };
        if (this.evaluateContext) this.output._storedFunction = func;
        else {
            this.output._storedFunction = null;
            this.output._storedValue = func(state);
        }
    }
    _dumpPropertiesCode() {
        const codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.evaluateContext = ${this.evaluateContext ? "true" : "false"};\n`;
        return codeString;
    }
    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.evaluateContext = this.evaluateContext;
        return serializationObject;
    }
    _deserialize(serializationObject) {
        super._deserialize(serializationObject);
        if (serializationObject.evaluateContext !== undefined) this.evaluateContext = serializationObject.evaluateContext;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Evaluate context", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            rebuild: true
        }
    })
], $86ccf345902b5ef2$export$fac07ca11f907c3e.prototype, "evaluateContext", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.SetNormalsBlock", $86ccf345902b5ef2$export$fac07ca11f907c3e);

});

parcelRegister("agqpv", function(module, exports) {

$parcel$export(module.exports, "SetUVsBlock", () => $778fe289625d73d5$export$3be1e4df75a28d30);

var $e0Suo = parcelRequire("e0Suo");

var $gJfVN = parcelRequire("gJfVN");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $1aXVF = parcelRequire("1aXVF");
class $778fe289625d73d5$export$3be1e4df75a28d30 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new SetUVsBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        /**
         * Gets or sets a boolean indicating that this block can evaluate context
         * Build performance is improved when this value is set to false as the system will cache values instead of reevaluating everything per context change
         */ this.evaluateContext = true;
        /**
         * Gets or sets a value indicating which UV to set
         */ this.textureCoordinateIndex = 0;
        this.registerInput("geometry", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
        this.registerInput("uvs", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector2);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
    }
    /**
     * Gets the current index in the current flow
     * @returns the current index
     */ getExecutionIndex() {
        return this._currentIndex;
    }
    /**
     * Gets the current loop index in the current flow
     * @returns the current loop index
     */ getExecutionLoopIndex() {
        return this._currentIndex;
    }
    /**
     * Gets the current face index in the current flow
     * @returns the current face index
     */ getExecutionFaceIndex() {
        return 0;
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "SetUVsBlock";
    }
    /**
     * Gets the geometry input component
     */ get geometry() {
        return this._inputs[0];
    }
    /**
     * Gets the uvs input component
     */ get uvs() {
        return this._inputs[1];
    }
    /**
     * Gets the geometry output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        const func = (state)=>{
            state.pushExecutionContext(this);
            this._vertexData = this.geometry.getConnectedValue(state);
            if (this._vertexData) this._vertexData = this._vertexData.clone(); // Preserve source data
            state.pushGeometryContext(this._vertexData);
            if (!this._vertexData || !this._vertexData.positions) {
                state.restoreGeometryContext();
                state.restoreExecutionContext();
                this.output._storedValue = null;
                return;
            }
            if (!this.uvs.isConnected) {
                state.restoreGeometryContext();
                state.restoreExecutionContext();
                this.output._storedValue = this._vertexData;
                return;
            }
            const uvs = [];
            // Processing
            const vertexCount = this._vertexData.positions.length / 3;
            for(this._currentIndex = 0; this._currentIndex < vertexCount; this._currentIndex++){
                const tempVector2 = this.uvs.getConnectedValue(state);
                if (tempVector2) tempVector2.toArray(uvs, this._currentIndex * 2);
            }
            switch(this.textureCoordinateIndex){
                case 0:
                    this._vertexData.uvs = uvs;
                    break;
                case 1:
                    this._vertexData.uvs2 = uvs;
                    break;
                case 2:
                    this._vertexData.uvs3 = uvs;
                    break;
                case 3:
                    this._vertexData.uvs4 = uvs;
                    break;
                case 4:
                    this._vertexData.uvs5 = uvs;
                    break;
                case 5:
                    this._vertexData.uvs6 = uvs;
                    break;
            }
            // Storage
            state.restoreGeometryContext();
            state.restoreExecutionContext();
            return this._vertexData;
        };
        if (this.evaluateContext) this.output._storedFunction = func;
        else {
            this.output._storedFunction = null;
            this.output._storedValue = func(state);
        }
    }
    _dumpPropertiesCode() {
        let codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.textureCoordinateIndex};\n`;
        codeString += `${this._codeVariableName}.evaluateContext = ${this.evaluateContext ? "true" : "false"};\n`;
        return codeString;
    }
    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.evaluateContext = this.evaluateContext;
        serializationObject.textureCoordinateIndex = this.textureCoordinateIndex;
        return serializationObject;
    }
    _deserialize(serializationObject) {
        super._deserialize(serializationObject);
        this.textureCoordinateIndex = serializationObject.textureCoordinateIndex;
        if (serializationObject.evaluateContext !== undefined) this.evaluateContext = serializationObject.evaluateContext;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Evaluate context", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            rebuild: true
        }
    })
], $778fe289625d73d5$export$3be1e4df75a28d30.prototype, "evaluateContext", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Texture coordinates index", (0, $1aXVF.PropertyTypeForEdition).List, "ADVANCED", {
        notifiers: {
            update: true
        },
        options: [
            {
                label: "UV1",
                value: 0
            },
            {
                label: "UV2",
                value: 1
            },
            {
                label: "UV3",
                value: 2
            },
            {
                label: "UV4",
                value: 3
            },
            {
                label: "UV5",
                value: 4
            },
            {
                label: "UV6",
                value: 5
            }
        ]
    })
], $778fe289625d73d5$export$3be1e4df75a28d30.prototype, "textureCoordinateIndex", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.SetUVsBlock", $778fe289625d73d5$export$3be1e4df75a28d30);

});

parcelRegister("3sVfn", function(module, exports) {

$parcel$export(module.exports, "SetColorsBlock", () => $286064a9fbeee4b3$export$297a934de22caba2);

var $e0Suo = parcelRequire("e0Suo");

var $gJfVN = parcelRequire("gJfVN");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $1aXVF = parcelRequire("1aXVF");
class $286064a9fbeee4b3$export$297a934de22caba2 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new SetColorsBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        /**
         * Gets or sets a boolean indicating that this block can evaluate context
         * Build performance is improved when this value is set to false as the system will cache values instead of reevaluating everything per context change
         */ this.evaluateContext = true;
        this.registerInput("geometry", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
        this.registerInput("colors", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
        this._inputs[1].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int);
        this._inputs[1].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
        this._inputs[1].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector2);
        this._inputs[1].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Texture);
        this._inputs[1].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Texture);
    }
    /**
     * Gets the current index in the current flow
     * @returns the current index
     */ getExecutionIndex() {
        return this._currentIndex;
    }
    /**
     * Gets the current loop index in the current flow
     * @returns the current loop index
     */ getExecutionLoopIndex() {
        return this._currentIndex;
    }
    /**
     * Gets the current face index in the current flow
     * @returns the current face index
     */ getExecutionFaceIndex() {
        return 0;
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "SetColorsBlock";
    }
    /**
     * Gets the geometry input component
     */ get geometry() {
        return this._inputs[0];
    }
    /**
     * Gets the colors input component
     */ get colors() {
        return this._inputs[1];
    }
    /**
     * Gets the geometry output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        const func = (state)=>{
            state.pushExecutionContext(this);
            this._vertexData = this.geometry.getConnectedValue(state);
            if (this._vertexData) this._vertexData = this._vertexData.clone(); // Preserve source data
            state.pushGeometryContext(this._vertexData);
            if (!this._vertexData || !this._vertexData.positions) {
                state.restoreGeometryContext();
                state.restoreExecutionContext();
                this.output._storedValue = null;
                return;
            }
            if (!this.colors.isConnected) {
                state.restoreGeometryContext();
                state.restoreExecutionContext();
                this.output._storedValue = this._vertexData;
                return;
            }
            if (!this._vertexData.colors) this._vertexData.colors = [];
            // Processing
            const vertexCount = this._vertexData.positions.length / 3;
            for(this._currentIndex = 0; this._currentIndex < vertexCount; this._currentIndex++)if (this.colors.connectedPoint?.type === (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3) {
                const tempVector3 = this.colors.getConnectedValue(state);
                if (tempVector3) {
                    tempVector3.toArray(this._vertexData.colors, this._currentIndex * 4);
                    this._vertexData.colors[this._currentIndex * 4 + 3] = 1; // Alpha
                    this._vertexData.hasVertexAlpha = false;
                }
            } else {
                const tempVector4 = this.colors.getConnectedValue(state);
                if (tempVector4) {
                    tempVector4.toArray(this._vertexData.colors, this._currentIndex * 4);
                    this._vertexData.hasVertexAlpha = true;
                }
            }
            // Storage
            state.restoreGeometryContext();
            state.restoreExecutionContext();
            return this._vertexData;
        };
        if (this.evaluateContext) this.output._storedFunction = func;
        else {
            this.output._storedFunction = null;
            this.output._storedValue = func(state);
        }
    }
    _dumpPropertiesCode() {
        const codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.evaluateContext = ${this.evaluateContext ? "true" : "false"};\n`;
        return codeString;
    }
    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.evaluateContext = this.evaluateContext;
        return serializationObject;
    }
    _deserialize(serializationObject) {
        super._deserialize(serializationObject);
        if (serializationObject.evaluateContext !== undefined) this.evaluateContext = serializationObject.evaluateContext;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Evaluate context", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            rebuild: true
        }
    })
], $286064a9fbeee4b3$export$297a934de22caba2.prototype, "evaluateContext", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.SetColorsBlock", $286064a9fbeee4b3$export$297a934de22caba2);

});

parcelRegister("6zPal", function(module, exports) {

$parcel$export(module.exports, "SetTangentsBlock", () => $4c9db37579c95732$export$27c1fe020eda182);

var $e0Suo = parcelRequire("e0Suo");

var $gJfVN = parcelRequire("gJfVN");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $1aXVF = parcelRequire("1aXVF");
class $4c9db37579c95732$export$27c1fe020eda182 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new SetTangentsBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        /**
         * Gets or sets a boolean indicating that this block can evaluate context
         * Build performance is improved when this value is set to false as the system will cache values instead of reevaluating everything per context change
         */ this.evaluateContext = true;
        this.registerInput("geometry", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
        this.registerInput("tangents", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector4);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
    }
    /**
     * Gets the current index in the current flow
     * @returns the current index
     */ getExecutionIndex() {
        return this._currentIndex;
    }
    /**
     * Gets the current loop index in the current flow
     * @returns the current loop index
     */ getExecutionLoopIndex() {
        return this._currentIndex;
    }
    /**
     * Gets the current face index in the current flow
     * @returns the current face index
     */ getExecutionFaceIndex() {
        return 0;
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "SetTangentsBlock";
    }
    /**
     * Gets the geometry input component
     */ get geometry() {
        return this._inputs[0];
    }
    /**
     * Gets the tangents input component
     */ get tangents() {
        return this._inputs[1];
    }
    /**
     * Gets the geometry output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        const func = (state)=>{
            state.pushExecutionContext(this);
            this._vertexData = this.geometry.getConnectedValue(state);
            if (this._vertexData) this._vertexData = this._vertexData.clone(); // Preserve source data
            state.pushGeometryContext(this._vertexData);
            if (!this._vertexData || !this._vertexData.positions) {
                state.restoreGeometryContext();
                state.restoreExecutionContext();
                this.output._storedValue = null;
                return;
            }
            if (!this.tangents.isConnected) {
                state.restoreGeometryContext();
                state.restoreExecutionContext();
                this.output._storedValue = this._vertexData;
                return;
            }
            if (!this._vertexData.tangents) this._vertexData.tangents = [];
            // Processing
            const vertexCount = this._vertexData.positions.length / 3;
            for(this._currentIndex = 0; this._currentIndex < vertexCount; this._currentIndex++){
                const tempVector4 = this.tangents.getConnectedValue(state);
                if (tempVector4) tempVector4.toArray(this._vertexData.tangents, this._currentIndex * 4);
            }
            // Storage
            state.restoreGeometryContext();
            state.restoreExecutionContext();
            return this._vertexData;
        };
        if (this.evaluateContext) this.output._storedFunction = func;
        else {
            this.output._storedFunction = null;
            this.output._storedValue = func(state);
        }
    }
    _dumpPropertiesCode() {
        const codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.evaluateContext = ${this.evaluateContext ? "true" : "false"};\n`;
        return codeString;
    }
    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.evaluateContext = this.evaluateContext;
        return serializationObject;
    }
    _deserialize(serializationObject) {
        super._deserialize(serializationObject);
        if (serializationObject.evaluateContext !== undefined) this.evaluateContext = serializationObject.evaluateContext;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Evaluate context", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            rebuild: true
        }
    })
], $4c9db37579c95732$export$27c1fe020eda182.prototype, "evaluateContext", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.SetTangentsBlock", $4c9db37579c95732$export$27c1fe020eda182);

});

parcelRegister("fJvYG", function(module, exports) {

$parcel$export(module.exports, "MathBlockOperations", () => $b743dd1596361699$export$f514a6137bed4063);
$parcel$export(module.exports, "MathBlock", () => $b743dd1596361699$export$3891432f830a2d59);

var $e0Suo = parcelRequire("e0Suo");

var $gJfVN = parcelRequire("gJfVN");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $ha1VO = parcelRequire("ha1VO");

var $1aXVF = parcelRequire("1aXVF");
var $b743dd1596361699$export$f514a6137bed4063;
(function(MathBlockOperations) {
    /** Add */ MathBlockOperations[MathBlockOperations["Add"] = 0] = "Add";
    /** Subtract */ MathBlockOperations[MathBlockOperations["Subtract"] = 1] = "Subtract";
    /** Multiply */ MathBlockOperations[MathBlockOperations["Multiply"] = 2] = "Multiply";
    /** Divide */ MathBlockOperations[MathBlockOperations["Divide"] = 3] = "Divide";
    /** Max */ MathBlockOperations[MathBlockOperations["Max"] = 4] = "Max";
    /** Min */ MathBlockOperations[MathBlockOperations["Min"] = 5] = "Min";
})($b743dd1596361699$export$f514a6137bed4063 || ($b743dd1596361699$export$f514a6137bed4063 = {}));
class $b743dd1596361699$export$3891432f830a2d59 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new MathBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        /**
         * Gets or sets the operation applied by the block
         */ this.operation = $b743dd1596361699$export$f514a6137bed4063.Add;
        this.registerInput("left", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerInput("right", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Texture);
        this._inputs[1].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
        this._inputs[1].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
        this._inputs[1].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Texture);
        this._inputs[1].acceptedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
        this._linkConnectionTypes(0, 1);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "MathBlock";
    }
    /**
     * Gets the left input component
     */ get left() {
        return this._inputs[0];
    }
    /**
     * Gets the right input component
     */ get right() {
        return this._inputs[1];
    }
    /**
     * Gets the geometry output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock() {
        let func;
        const left = this.left;
        const right = this.right;
        if (!left.isConnected || !right.isConnected) {
            this.output._storedFunction = null;
            this.output._storedValue = null;
            return;
        }
        const isFloat = left.type === (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float || left.type === (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int;
        switch(this.operation){
            case $b743dd1596361699$export$f514a6137bed4063.Add:
                if (isFloat) func = (state)=>{
                    return left.getConnectedValue(state) + right.getConnectedValue(state);
                };
                else func = (state)=>{
                    return left.getConnectedValue(state).add(state.adapt(right, left.type));
                };
                break;
            case $b743dd1596361699$export$f514a6137bed4063.Subtract:
                if (isFloat) func = (state)=>{
                    return left.getConnectedValue(state) - right.getConnectedValue(state);
                };
                else func = (state)=>{
                    return left.getConnectedValue(state).subtract(state.adapt(right, left.type));
                };
                break;
            case $b743dd1596361699$export$f514a6137bed4063.Multiply:
                if (isFloat) func = (state)=>{
                    return left.getConnectedValue(state) * right.getConnectedValue(state);
                };
                else func = (state)=>{
                    return left.getConnectedValue(state).multiply(state.adapt(right, left.type));
                };
                break;
            case $b743dd1596361699$export$f514a6137bed4063.Divide:
                if (isFloat) func = (state)=>{
                    return left.getConnectedValue(state) / right.getConnectedValue(state);
                };
                else func = (state)=>{
                    return left.getConnectedValue(state).divide(state.adapt(right, left.type));
                };
                break;
            case $b743dd1596361699$export$f514a6137bed4063.Min:
                if (isFloat) func = (state)=>{
                    return Math.min(left.getConnectedValue(state), right.getConnectedValue(state));
                };
                else switch(left.type){
                    case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector2:
                        func = (state)=>{
                            return (0, $ha1VO.Vector2).Minimize(left.getConnectedValue(state), state.adapt(right, left.type));
                        };
                        break;
                    case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3:
                        func = (state)=>{
                            return (0, $ha1VO.Vector3).Minimize(left.getConnectedValue(state), state.adapt(right, left.type));
                        };
                        break;
                    case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector4:
                        func = (state)=>{
                            return (0, $ha1VO.Vector4).Minimize(left.getConnectedValue(state), state.adapt(right, left.type));
                        };
                        break;
                }
                break;
            case $b743dd1596361699$export$f514a6137bed4063.Max:
                if (isFloat) func = (state)=>{
                    return Math.max(left.getConnectedValue(state), right.getConnectedValue(state));
                };
                else {
                    switch(left.type){
                        case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector2:
                            func = (state)=>{
                                return (0, $ha1VO.Vector2).Maximize(left.getConnectedValue(state), state.adapt(right, left.type));
                            };
                            break;
                        case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3:
                            func = (state)=>{
                                return (0, $ha1VO.Vector3).Maximize(left.getConnectedValue(state), state.adapt(right, left.type));
                            };
                            break;
                        case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector4:
                            func = (state)=>{
                                return (0, $ha1VO.Vector4).Maximize(left.getConnectedValue(state), state.adapt(right, left.type));
                            };
                            break;
                    }
                    break;
                }
        }
        this.output._storedFunction = (state)=>{
            if (left.type === (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int) return func(state) | 0;
            return func(state);
        };
    }
    _dumpPropertiesCode() {
        const codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.operation = BABYLON.MathBlockOperations.${$b743dd1596361699$export$f514a6137bed4063[this.operation]};\n`;
        return codeString;
    }
    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.operation = this.operation;
        return serializationObject;
    }
    _deserialize(serializationObject) {
        super._deserialize(serializationObject);
        this.operation = serializationObject.operation;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Operation", (0, $1aXVF.PropertyTypeForEdition).List, "ADVANCED", {
        notifiers: {
            rebuild: true
        },
        options: [
            {
                label: "Add",
                value: $b743dd1596361699$export$f514a6137bed4063.Add
            },
            {
                label: "Subtract",
                value: $b743dd1596361699$export$f514a6137bed4063.Subtract
            },
            {
                label: "Multiply",
                value: $b743dd1596361699$export$f514a6137bed4063.Multiply
            },
            {
                label: "Divide",
                value: $b743dd1596361699$export$f514a6137bed4063.Divide
            },
            {
                label: "Max",
                value: $b743dd1596361699$export$f514a6137bed4063.Max
            },
            {
                label: "Min",
                value: $b743dd1596361699$export$f514a6137bed4063.Min
            }
        ]
    })
], $b743dd1596361699$export$3891432f830a2d59.prototype, "operation", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.MathBlock", $b743dd1596361699$export$3891432f830a2d59);

});

parcelRegister("7JAyZ", function(module, exports) {

$parcel$export(module.exports, "MapRangeBlock", () => $5a191913500aea41$export$e519a6d5f5607806);

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");
class $5a191913500aea41$export$e519a6d5f5607806 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new MapRangeBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this.registerInput("value", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerInput("fromMin", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 0);
        this.registerInput("fromMax", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 1);
        this.registerInput("toMin", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 0);
        this.registerInput("toMax", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 1);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).BasedOnInput);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector2);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector4);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Texture);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "MapRangeBlock";
    }
    /**
     * Gets the value input component
     */ get value() {
        return this._inputs[0];
    }
    /**
     * Gets the fromMin input component
     */ get fromMin() {
        return this._inputs[1];
    }
    /**
     * Gets the fromMax input component
     */ get fromMax() {
        return this._inputs[2];
    }
    /**
     * Gets the toMin input component
     */ get toMin() {
        return this._inputs[3];
    }
    /**
     * Gets the toMax input component
     */ get toMax() {
        return this._inputs[4];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock() {
        if (!this.value.isConnected) {
            this.output._storedFunction = null;
            this.output._storedValue = null;
            return;
        }
        this.output._storedFunction = (state)=>{
            const value = this.value.getConnectedValue(state);
            const fromMin = this.fromMin.getConnectedValue(state);
            const fromMax = this.fromMax.getConnectedValue(state);
            const toMin = this.toMin.getConnectedValue(state);
            const toMax = this.toMax.getConnectedValue(state);
            const result = (value - fromMin) / (fromMax - fromMin) * (toMax - toMin) + toMin;
            if (this.output.type === (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int) return Math.floor(result);
            return result;
        };
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.MapRangeBlock", $5a191913500aea41$export$e519a6d5f5607806);

});

parcelRegister("cmwmj", function(module, exports) {

$parcel$export(module.exports, "ConditionBlockTests", () => $9000a3e4dd1f276f$export$8ae5a146555c6dc8);
$parcel$export(module.exports, "ConditionBlock", () => $9000a3e4dd1f276f$export$fd3188377b6729a6);

var $e0Suo = parcelRequire("e0Suo");

var $gJfVN = parcelRequire("gJfVN");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $1aXVF = parcelRequire("1aXVF");

var $1VEEL = parcelRequire("1VEEL");

var $53VPf = parcelRequire("53VPf");
var $9000a3e4dd1f276f$export$8ae5a146555c6dc8;
(function(ConditionBlockTests) {
    /** Equal */ ConditionBlockTests[ConditionBlockTests["Equal"] = 0] = "Equal";
    /** NotEqual */ ConditionBlockTests[ConditionBlockTests["NotEqual"] = 1] = "NotEqual";
    /** LessThan */ ConditionBlockTests[ConditionBlockTests["LessThan"] = 2] = "LessThan";
    /** GreaterThan */ ConditionBlockTests[ConditionBlockTests["GreaterThan"] = 3] = "GreaterThan";
    /** LessOrEqual */ ConditionBlockTests[ConditionBlockTests["LessOrEqual"] = 4] = "LessOrEqual";
    /** GreaterOrEqual */ ConditionBlockTests[ConditionBlockTests["GreaterOrEqual"] = 5] = "GreaterOrEqual";
    /** Logical Exclusive OR */ ConditionBlockTests[ConditionBlockTests["Xor"] = 6] = "Xor";
    /** Logical Or */ ConditionBlockTests[ConditionBlockTests["Or"] = 7] = "Or";
    /** Logical And */ ConditionBlockTests[ConditionBlockTests["And"] = 8] = "And";
})($9000a3e4dd1f276f$export$8ae5a146555c6dc8 || ($9000a3e4dd1f276f$export$8ae5a146555c6dc8 = {}));
class $9000a3e4dd1f276f$export$fd3188377b6729a6 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new ConditionBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        /**
         * Gets or sets the test used by the block
         */ this.test = $9000a3e4dd1f276f$export$8ae5a146555c6dc8.Equal;
        this.registerInput("left", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
        this.registerInput("right", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 0);
        this.registerInput("ifTrue", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect, true, 1);
        this.registerInput("ifFalse", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect, true, 0);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[2];
        this._outputs[0]._defaultConnectionPointType = (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float;
        this._inputs[0].acceptedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int);
        this._inputs[1].acceptedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int);
        this._linkConnectionTypes(2, 3);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "ConditionBlock";
    }
    /**
     * Gets the left input component
     */ get left() {
        return this._inputs[0];
    }
    /**
     * Gets the right input component
     */ get right() {
        return this._inputs[1];
    }
    /**
     * Gets the ifTrue input component
     */ get ifTrue() {
        return this._inputs[2];
    }
    /**
     * Gets the ifFalse input component
     */ get ifFalse() {
        return this._inputs[3];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock() {
        if (!this.left.isConnected) {
            this.output._storedFunction = null;
            this.output._storedValue = null;
            return;
        }
        const func = (state)=>{
            const left = this.left.getConnectedValue(state);
            const right = this.right.getConnectedValue(state);
            let condition = false;
            switch(this.test){
                case $9000a3e4dd1f276f$export$8ae5a146555c6dc8.Equal:
                    condition = (0, $1VEEL.Scalar).WithinEpsilon(left, right, (0, $53VPf.Epsilon));
                    break;
                case $9000a3e4dd1f276f$export$8ae5a146555c6dc8.NotEqual:
                    condition = left !== right;
                    break;
                case $9000a3e4dd1f276f$export$8ae5a146555c6dc8.LessThan:
                    condition = left < right;
                    break;
                case $9000a3e4dd1f276f$export$8ae5a146555c6dc8.GreaterThan:
                    condition = left > right;
                    break;
                case $9000a3e4dd1f276f$export$8ae5a146555c6dc8.LessOrEqual:
                    condition = left <= right;
                    break;
                case $9000a3e4dd1f276f$export$8ae5a146555c6dc8.GreaterOrEqual:
                    condition = left >= right;
                    break;
                case $9000a3e4dd1f276f$export$8ae5a146555c6dc8.Xor:
                    condition = !!left && !right || !left && !!right;
                    break;
                case $9000a3e4dd1f276f$export$8ae5a146555c6dc8.Or:
                    condition = !!left || !!right;
                    break;
                case $9000a3e4dd1f276f$export$8ae5a146555c6dc8.And:
                    condition = !!left && !!right;
                    break;
            }
            return condition;
        };
        this.output._storedFunction = (state)=>{
            if (func(state)) return this.ifTrue.getConnectedValue(state);
            return this.ifFalse.getConnectedValue(state);
        };
    }
    _dumpPropertiesCode() {
        const codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.test = BABYLON.ConditionBlockTests.${$9000a3e4dd1f276f$export$8ae5a146555c6dc8[this.test]};\n`;
        return codeString;
    }
    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.test = this.test;
        return serializationObject;
    }
    _deserialize(serializationObject) {
        super._deserialize(serializationObject);
        this.test = serializationObject.test;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Test", (0, $1aXVF.PropertyTypeForEdition).List, "ADVANCED", {
        notifiers: {
            rebuild: true
        },
        options: [
            {
                label: "Equal",
                value: $9000a3e4dd1f276f$export$8ae5a146555c6dc8.Equal
            },
            {
                label: "NotEqual",
                value: $9000a3e4dd1f276f$export$8ae5a146555c6dc8.NotEqual
            },
            {
                label: "LessThan",
                value: $9000a3e4dd1f276f$export$8ae5a146555c6dc8.LessThan
            },
            {
                label: "GreaterThan",
                value: $9000a3e4dd1f276f$export$8ae5a146555c6dc8.GreaterThan
            },
            {
                label: "LessOrEqual",
                value: $9000a3e4dd1f276f$export$8ae5a146555c6dc8.LessOrEqual
            },
            {
                label: "GreaterOrEqual",
                value: $9000a3e4dd1f276f$export$8ae5a146555c6dc8.GreaterOrEqual
            },
            {
                label: "Xor",
                value: $9000a3e4dd1f276f$export$8ae5a146555c6dc8.Xor
            },
            {
                label: "Or",
                value: $9000a3e4dd1f276f$export$8ae5a146555c6dc8.Or
            },
            {
                label: "And",
                value: $9000a3e4dd1f276f$export$8ae5a146555c6dc8.And
            }
        ]
    })
], $9000a3e4dd1f276f$export$fd3188377b6729a6.prototype, "test", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.ConditionBlock", $9000a3e4dd1f276f$export$fd3188377b6729a6);

});

parcelRegister("8PlwB", function(module, exports) {

$parcel$export(module.exports, "RandomBlockLocks", () => $66d3c88f5328d90f$export$a271c6c991ead8cf);
$parcel$export(module.exports, "RandomBlock", () => $66d3c88f5328d90f$export$533d444b0f59b0ce);

var $e0Suo = parcelRequire("e0Suo");

var $gJfVN = parcelRequire("gJfVN");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $a76QT = parcelRequire("a76QT");

var $ha1VO = parcelRequire("ha1VO");

var $1aXVF = parcelRequire("1aXVF");

var $8Jk1D = parcelRequire("8Jk1D");
var $66d3c88f5328d90f$export$a271c6c991ead8cf;
(function(RandomBlockLocks) {
    /** None */ RandomBlockLocks[RandomBlockLocks["None"] = 0] = "None";
    /** LoopID */ RandomBlockLocks[RandomBlockLocks["LoopID"] = 1] = "LoopID";
    /** InstanceID */ RandomBlockLocks[RandomBlockLocks["InstanceID"] = 2] = "InstanceID";
})($66d3c88f5328d90f$export$a271c6c991ead8cf || ($66d3c88f5328d90f$export$a271c6c991ead8cf = {}));
class $66d3c88f5328d90f$export$533d444b0f59b0ce extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new RandomBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this._currentLockId = -1;
        /**
         * Gets or sets a value indicating if that block will lock its value for a specific duration
         */ this.lockMode = $66d3c88f5328d90f$export$a271c6c991ead8cf.None;
        this.registerInput("min", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerInput("max", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).BasedOnInput);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Texture);
        this._inputs[1].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
        this._inputs[1].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
        this._inputs[1].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Texture);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
        this._linkConnectionTypes(0, 1);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "RandomBlock";
    }
    /**
     * Gets the min input component
     */ get min() {
        return this._inputs[0];
    }
    /**
     * Gets the max input component
     */ get max() {
        return this._inputs[1];
    }
    /**
     * Gets the geometry output component
     */ get output() {
        return this._outputs[0];
    }
    autoConfigure() {
        if (!this.min.isConnected) {
            const minInput = new (0, $a76QT.GeometryInputBlock)("Min");
            minInput.value = 0;
            minInput.output.connectTo(this.min);
        }
        if (!this.max.isConnected) {
            const maxInput = new (0, $a76QT.GeometryInputBlock)("Max");
            maxInput.value = 1;
            maxInput.output.connectTo(this.max);
        }
    }
    _buildBlock() {
        let func = null;
        this._currentLockId = -1;
        switch(this.min.type){
            case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int:
            case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float:
                func = (state)=>{
                    const min = this.min.getConnectedValue(state) || 0;
                    const max = this.max.getConnectedValue(state) || 0;
                    return min + Math.random() * (max - min);
                };
                break;
            case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector2:
                func = (state)=>{
                    const min = this.min.getConnectedValue(state) || (0, $ha1VO.Vector2).Zero();
                    const max = this.max.getConnectedValue(state) || (0, $ha1VO.Vector2).Zero();
                    return new (0, $ha1VO.Vector2)(min.x + Math.random() * (max.x - min.x), min.y + Math.random() * (max.y - min.y));
                };
                break;
            case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3:
                func = (state)=>{
                    const min = this.min.getConnectedValue(state) || (0, $ha1VO.Vector3).Zero();
                    const max = this.max.getConnectedValue(state) || (0, $ha1VO.Vector3).Zero();
                    return new (0, $ha1VO.Vector3)(min.x + Math.random() * (max.x - min.x), min.y + Math.random() * (max.y - min.y), min.z + Math.random() * (max.z - min.z));
                };
                break;
            case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector4:
                func = (state)=>{
                    const min = this.min.getConnectedValue(state) || (0, $ha1VO.Vector4).Zero();
                    const max = this.max.getConnectedValue(state) || (0, $ha1VO.Vector4).Zero();
                    return new (0, $ha1VO.Vector4)(min.x + Math.random() * (max.x - min.x), min.y + Math.random() * (max.y - min.y), min.z + Math.random() * (max.z - min.z), min.w + Math.random() * (max.w - min.w));
                };
                break;
        }
        if (this.lockMode === $66d3c88f5328d90f$export$a271c6c991ead8cf.None || !func) this.output._storedFunction = func;
        else this.output._storedFunction = (state)=>{
            let lockId = 0;
            switch(this.lockMode){
                case $66d3c88f5328d90f$export$a271c6c991ead8cf.InstanceID:
                    lockId = state.getContextualValue((0, $8Jk1D.NodeGeometryContextualSources).InstanceID, true) || 0;
                    break;
                case $66d3c88f5328d90f$export$a271c6c991ead8cf.LoopID:
                    lockId = state.getContextualValue((0, $8Jk1D.NodeGeometryContextualSources).LoopID, true) || 0;
                    break;
            }
            if (this._currentLockId !== lockId || this.lockMode === $66d3c88f5328d90f$export$a271c6c991ead8cf.None) {
                this._currentLockId = lockId;
                this.output._storedValue = func(state);
            }
            return this.output._storedValue;
        };
    }
    _dumpPropertiesCode() {
        const codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.lockMode = BABYLON.RandomBlockLocks.${$66d3c88f5328d90f$export$a271c6c991ead8cf[this.lockMode]};\n`;
        return codeString;
    }
    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.lockMode = this.lockMode;
        return serializationObject;
    }
    _deserialize(serializationObject) {
        super._deserialize(serializationObject);
        this.lockMode = serializationObject.lockMode;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("LockMode", (0, $1aXVF.PropertyTypeForEdition).List, "ADVANCED", {
        notifiers: {
            rebuild: true
        },
        options: [
            {
                label: "None",
                value: $66d3c88f5328d90f$export$a271c6c991ead8cf.None
            },
            {
                label: "LoopID",
                value: $66d3c88f5328d90f$export$a271c6c991ead8cf.LoopID
            },
            {
                label: "InstanceID",
                value: $66d3c88f5328d90f$export$a271c6c991ead8cf.InstanceID
            }
        ]
    })
], $66d3c88f5328d90f$export$533d444b0f59b0ce.prototype, "lockMode", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.RandomBlock", $66d3c88f5328d90f$export$533d444b0f59b0ce);

});

parcelRegister("5f2ez", function(module, exports) {

$parcel$export(module.exports, "NoiseBlock", () => $3d101617933b6d9b$export$77ab9c7f4c25e8a9);

var $gJfVN = parcelRequire("gJfVN");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $ha1VO = parcelRequire("ha1VO");

var $1VEEL = parcelRequire("1VEEL");

var $8Jk1D = parcelRequire("8Jk1D");
class $3d101617933b6d9b$export$77ab9c7f4c25e8a9 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new NoiseBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this.registerInput("offset", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3, true, (0, $ha1VO.Vector3).Zero());
        this.registerInput("scale", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 1);
        this.registerInput("octaves", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 2, 0, 16);
        this.registerInput("roughness", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 0.5, 0, 1);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "NoiseBlock";
    }
    /**
     * Gets the offset input component
     */ get offset() {
        return this._inputs[0];
    }
    /**
     * Gets the scale input component
     */ get scale() {
        return this._inputs[1];
    }
    /**
     * Gets the octaves input component
     */ get octaves() {
        return this._inputs[2];
    }
    /**
     * Gets the roughtness input component
     */ get roughness() {
        return this._inputs[3];
    }
    /**
     * Gets the geometry output component
     */ get output() {
        return this._outputs[0];
    }
    _negateIf(value, condition) {
        return condition !== 0 ? -value : value;
    }
    _noiseGrad(hash, x, y, z) {
        const h = hash & 15;
        const u = h < 8 ? x : y;
        const vt = h === 12 || h == 14 ? x : z;
        const v = h < 4 ? y : vt;
        return this._negateIf(u, h & u) + this._negateIf(v, h & 2);
    }
    _fade(t) {
        return t * t * t * (t * (t * 6.0 - 15.0) + 10.0);
    }
    _hashBitRotate(x, k) {
        return x << k | x >> 32 - k;
    }
    _hash(kx, ky, kz) {
        let a, b, c;
        a = b = c = 3735928584;
        c += kz;
        b += ky;
        a += kx;
        c ^= b;
        c -= this._hashBitRotate(b, 14);
        a ^= c;
        a -= this._hashBitRotate(c, 11);
        b ^= a;
        b -= this._hashBitRotate(a, 25);
        c ^= b;
        c -= this._hashBitRotate(b, 16);
        a ^= c;
        a -= this._hashBitRotate(c, 4);
        b ^= a;
        b -= this._hashBitRotate(a, 14);
        c ^= b;
        c -= this._hashBitRotate(b, 24);
        return c;
    }
    _mix(v0, v1, v2, v3, v4, v5, v6, v7, x, y, z) {
        const x1 = 1.0 - x;
        const y1 = 1.0 - y;
        const z1 = 1.0 - z;
        return z1 * (y1 * (v0 * x1 + v1 * x) + y * (v2 * x1 + v3 * x)) + z * (y1 * (v4 * x1 + v5 * x) + y * (v6 * x1 + v7 * x));
    }
    _perlinNoise(position) {
        const X = (position.x | 0) - (position.x < 0 ? 1 : 0);
        const Y = (position.y | 0) - (position.y < 0 ? 1 : 0);
        const Z = (position.z | 0) - (position.z < 0 ? 1 : 0);
        const fx = position.x - X;
        const fy = position.y - Y;
        const fz = position.z - Z;
        const u = this._fade(fx);
        const v = this._fade(fy);
        const w = this._fade(fz);
        return this._mix(this._noiseGrad(this._hash(X, Y, Z), fx, fy, fz), this._noiseGrad(this._hash(X + 1, Y, Z), fx - 1, fy, fz), this._noiseGrad(this._hash(X, Y + 1, Z), fx, fy - 1, fz), this._noiseGrad(this._hash(X + 1, Y + 1, Z), fx - 1, fy - 1, fz), this._noiseGrad(this._hash(X, Y, Z + 1), fx, fy, fz - 1), this._noiseGrad(this._hash(X + 1, Y, Z + 1), fx - 1, fy, fz - 1), this._noiseGrad(this._hash(X, Y + 1, Z + 1), fx, fy - 1, fz - 1), this._noiseGrad(this._hash(X + 1, Y + 1, Z + 1), fx - 1, fy - 1, fz - 1), u, v, w);
    }
    _perlinSigned(position) {
        return this._perlinNoise(position) * 0.982;
    }
    _perlin(position) {
        return this._perlinSigned(position) / 2.0 + 0.5;
    }
    /**
     * Gets a perlin noise value
     * @param octaves number of octaves
     * @param roughness roughness
     * @param _position position vector
     * @param offset offset vector
     * @param scale scale value
     * @returns a value between 0 and 1
     * @see Based on https://github.com/blender/blender/blob/main/source/blender/blenlib/intern/noise.cc#L533
     */ noise(octaves, roughness, _position, offset, scale) {
        const position = new (0, $ha1VO.Vector3)(_position.x * scale + offset.x, _position.y * scale + offset.y, _position.z * scale + offset.z);
        let fscale = 1.0;
        let amp = 1.0;
        let maxamp = 0.0;
        let sum = 0.0;
        octaves = (0, $1VEEL.Scalar).Clamp(octaves, 0, 15.0);
        const step = octaves | 0;
        for(let i = 0; i <= step; i++){
            const t = this._perlin(position.scale(fscale));
            sum += t * amp;
            maxamp += amp;
            amp *= (0, $1VEEL.Scalar).Clamp(roughness, 0.0, 1.0);
            fscale *= 2.0;
        }
        const rmd = octaves - Math.floor(octaves);
        if (rmd == 0.0) return sum / maxamp;
        const t = this._perlin(position.scale(fscale));
        let sum2 = sum + t * amp;
        sum /= maxamp;
        sum2 /= maxamp + amp;
        return (1.0 - rmd) * sum + rmd * sum2;
    }
    _buildBlock() {
        this.output._storedFunction = (state)=>{
            const position = state.getContextualValue((0, $8Jk1D.NodeGeometryContextualSources).Positions);
            const octaves = this.octaves.getConnectedValue(state);
            const roughness = this.roughness.getConnectedValue(state);
            const offset = this.offset.getConnectedValue(state);
            const scale = this.scale.getConnectedValue(state);
            return this.noise(octaves, roughness, position, offset, scale);
        };
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.NoiseBlock", $3d101617933b6d9b$export$77ab9c7f4c25e8a9);

});

parcelRegister("9pTV3", function(module, exports) {

$parcel$export(module.exports, "MergeGeometryBlock", () => $6db1d344921222c6$export$dfd9dfad9150e3a9);

var $e0Suo = parcelRequire("e0Suo");

var $gJfVN = parcelRequire("gJfVN");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $1aXVF = parcelRequire("1aXVF");
class $6db1d344921222c6$export$dfd9dfad9150e3a9 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new MergeGeometryBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        /**
         * Gets or sets a boolean indicating that this block can evaluate context
         * Build performance is improved when this value is set to false as the system will cache values instead of reevaluating everything per context change
         */ this.evaluateContext = false;
        this.registerInput("geometry0", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
        this.registerInput("geometry1", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry, true);
        this.registerInput("geometry2", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry, true);
        this.registerInput("geometry3", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry, true);
        this.registerInput("geometry4", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry, true);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "MergeGeometryBlock";
    }
    /**
     * Gets the geometry0 input component
     */ get geometry0() {
        return this._inputs[0];
    }
    /**
     * Gets the geometry1 input component
     */ get geometry1() {
        return this._inputs[1];
    }
    /**
     * Gets the geometry2 input component
     */ get geometry2() {
        return this._inputs[2];
    }
    /**
     * Gets the geometry3 input component
     */ get geometry3() {
        return this._inputs[3];
    }
    /**
     * Gets the geometry4 input component
     */ get geometry4() {
        return this._inputs[4];
    }
    /**
     * Gets the geometry output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        const func = (state)=>{
            let vertexData = this.geometry0.getConnectedValue(state);
            const additionalVertexData = [];
            if (vertexData) vertexData = vertexData.clone(); // Preserve source data
            else return null;
            if (this.geometry1.isConnected) {
                const data = this.geometry1.getConnectedValue(state);
                if (data) additionalVertexData.push(data);
            }
            if (this.geometry2.isConnected) {
                const data = this.geometry2.getConnectedValue(state);
                if (data) additionalVertexData.push(data);
            }
            if (this.geometry3.isConnected) {
                const data = this.geometry3.getConnectedValue(state);
                if (data) additionalVertexData.push(data);
            }
            if (this.geometry4.isConnected) {
                const data = this.geometry4.getConnectedValue(state);
                if (data) additionalVertexData.push(data);
            }
            if (additionalVertexData.length && vertexData) vertexData = vertexData.merge(additionalVertexData, true, false, true, true);
            return vertexData;
        };
        if (this.evaluateContext) this.output._storedFunction = func;
        else {
            this.output._storedFunction = null;
            this.output._storedValue = func(state);
        }
    }
    _dumpPropertiesCode() {
        const codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.evaluateContext = ${this.evaluateContext ? "true" : "false"};\n`;
        return codeString;
    }
    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.evaluateContext = this.evaluateContext;
        return serializationObject;
    }
    _deserialize(serializationObject) {
        super._deserialize(serializationObject);
        this.evaluateContext = serializationObject.evaluateContext;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Evaluate context", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            rebuild: true
        }
    })
], $6db1d344921222c6$export$dfd9dfad9150e3a9.prototype, "evaluateContext", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.MergeGeometryBlock", $6db1d344921222c6$export$dfd9dfad9150e3a9);

});

parcelRegister("bK7gN", function(module, exports) {

$parcel$export(module.exports, "GeometryCollectionBlock", () => $88c9a137129b8dab$export$1df9e80494147eeb);

var $e0Suo = parcelRequire("e0Suo");

var $gJfVN = parcelRequire("gJfVN");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $1aXVF = parcelRequire("1aXVF");
class $88c9a137129b8dab$export$1df9e80494147eeb extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new GeometryCollectionBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        /**
         * Gets or sets a boolean indicating that this block can evaluate context
         * Build performance is improved when this value is set to false as the system will cache values instead of reevaluating everything per context change
         */ this.evaluateContext = true;
        this.registerInput("geometry0", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry, true);
        this.registerInput("geometry1", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry, true);
        this.registerInput("geometry2", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry, true);
        this.registerInput("geometry3", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry, true);
        this.registerInput("geometry4", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry, true);
        this.registerInput("geometry5", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry, true);
        this.registerInput("geometry6", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry, true);
        this.registerInput("geometry7", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry, true);
        this.registerInput("geometry8", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry, true);
        this.registerInput("geometry9", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry, true);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
        this._linkConnectionTypes(0, 1);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "GeometryCollectionBlock";
    }
    /**
     * Gets the geometry0 input component
     */ get geometry0() {
        return this._inputs[0];
    }
    /**
     * Gets the geometry1 input component
     */ get geometry1() {
        return this._inputs[1];
    }
    /**
     * Gets the geometry2 input component
     */ get geometry2() {
        return this._inputs[2];
    }
    /**
     * Gets the geometry3 input component
     */ get geometry3() {
        return this._inputs[3];
    }
    /**
     * Gets the geometry4 input component
     */ get geometry4() {
        return this._inputs[4];
    }
    /**
     * Gets the geometry5 input component
     */ get geometry5() {
        return this._inputs[5];
    }
    /**
     * Gets the geometry6 input component
     */ get geometry6() {
        return this._inputs[6];
    }
    /**
     * Gets the geometry7 input component
     */ get geometry7() {
        return this._inputs[7];
    }
    /**
     * Gets the geometry8 input component
     */ get geometry8() {
        return this._inputs[8];
    }
    /**
     * Gets the geometry9 input component
     */ get geometry9() {
        return this._inputs[9];
    }
    /**
     * Gets the geometry output component
     */ get output() {
        return this._outputs[0];
    }
    _storeGeometry(input, state, index, availables) {
        if (input.isConnected) {
            const vertexData = input.getConnectedValue(state);
            if (!vertexData) return;
            vertexData.metadata = vertexData.metadata || {};
            vertexData.metadata.collectionId = index;
            availables.push(vertexData);
        }
    }
    _buildBlock(state) {
        const func = (state)=>{
            const availables = [];
            this._storeGeometry(this.geometry0, state, 0, availables);
            this._storeGeometry(this.geometry1, state, 1, availables);
            this._storeGeometry(this.geometry2, state, 2, availables);
            this._storeGeometry(this.geometry3, state, 3, availables);
            this._storeGeometry(this.geometry4, state, 4, availables);
            this._storeGeometry(this.geometry5, state, 5, availables);
            this._storeGeometry(this.geometry6, state, 6, availables);
            this._storeGeometry(this.geometry7, state, 7, availables);
            this._storeGeometry(this.geometry8, state, 8, availables);
            this._storeGeometry(this.geometry9, state, 9, availables);
            if (!availables.length) return null;
            return availables[Math.round(Math.random() * (availables.length - 1))];
        };
        if (this.evaluateContext) this.output._storedFunction = func;
        else {
            this.output._storedFunction = null;
            this.output._storedValue = func(state);
        }
    }
    _dumpPropertiesCode() {
        const codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.evaluateContext = ${this.evaluateContext ? "true" : "false"};\n`;
        return codeString;
    }
    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.evaluateContext = this.evaluateContext;
        return serializationObject;
    }
    _deserialize(serializationObject) {
        super._deserialize(serializationObject);
        this.evaluateContext = serializationObject.evaluateContext;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Evaluate context", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            rebuild: true
        }
    })
], $88c9a137129b8dab$export$1df9e80494147eeb.prototype, "evaluateContext", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.GeometryCollectionBlock", $88c9a137129b8dab$export$1df9e80494147eeb);

});

parcelRegister("i6Ieo", function(module, exports) {

$parcel$export(module.exports, "GeometryElbowBlock", () => $d2eb18f12313f3c0$export$c76d4c208c41b30b);

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");
class $d2eb18f12313f3c0$export$c76d4c208c41b30b extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Creates a new GeometryElbowBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this.registerInput("input", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
    }
    /**
     * Gets the time spent to build this block (in ms)
     */ get buildExecutionTime() {
        return 0;
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "GeometryElbowBlock";
    }
    /**
     * Gets the input component
     */ get input() {
        return this._inputs[0];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const output = this._outputs[0];
        const input = this._inputs[0];
        output._storedFunction = (state)=>{
            return input.getConnectedValue(state);
        };
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.GeometryElbowBlock", $d2eb18f12313f3c0$export$c76d4c208c41b30b);

});

parcelRegister("euB66", function(module, exports) {

$parcel$export(module.exports, "ComputeNormalsBlock", () => $a8d0a4cf866d9a3f$export$f5ffbc181929867d);

var $5v6ry = parcelRequire("5v6ry");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");
class $a8d0a4cf866d9a3f$export$f5ffbc181929867d extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Creates a new ComputeNormalsBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this.registerInput("geometry", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "ComputeNormalsBlock";
    }
    /**
     * Gets the geometry component
     */ get geometry() {
        return this._inputs[0];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock() {
        this.output._storedFunction = (state)=>{
            if (!this.geometry.isConnected) return null;
            const vertexData = this.geometry.getConnectedValue(state);
            if (!vertexData.normals) vertexData.normals = [];
            (0, $5v6ry.VertexData).ComputeNormals(vertexData.positions, vertexData.indices, vertexData.normals);
            return vertexData;
        };
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.ComputeNormalsBlock", $a8d0a4cf866d9a3f$export$f5ffbc181929867d);

});

parcelRegister("7xBtK", function(module, exports) {

$parcel$export(module.exports, "VectorConverterBlock", () => $57d8aff788b2d190$export$19243242121ac95a);

var $ha1VO = parcelRequire("ha1VO");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");
class $57d8aff788b2d190$export$19243242121ac95a extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new VectorConverterBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this.registerInput("xyzw ", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector4, true);
        this.registerInput("xyz ", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3, true);
        this.registerInput("xy ", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector2, true);
        this.registerInput("zw ", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector2, true);
        this.registerInput("x ", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true);
        this.registerInput("y ", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true);
        this.registerInput("z ", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true);
        this.registerInput("w ", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true);
        this.registerOutput("xyzw", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector4);
        this.registerOutput("xyz", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3);
        this.registerOutput("xy", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector2);
        this.registerOutput("zw", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector2);
        this.registerOutput("x", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
        this.registerOutput("y", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
        this.registerOutput("z", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
        this.registerOutput("w", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "VectorConverterBlock";
    }
    /**
     * Gets the xyzw component (input)
     */ get xyzwIn() {
        return this._inputs[0];
    }
    /**
     * Gets the xyz component (input)
     */ get xyzIn() {
        return this._inputs[1];
    }
    /**
     * Gets the xy component (input)
     */ get xyIn() {
        return this._inputs[2];
    }
    /**
     * Gets the zw component (input)
     */ get zwIn() {
        return this._inputs[3];
    }
    /**
     * Gets the x component (input)
     */ get xIn() {
        return this._inputs[4];
    }
    /**
     * Gets the y component (input)
     */ get yIn() {
        return this._inputs[5];
    }
    /**
     * Gets the z component (input)
     */ get zIn() {
        return this._inputs[6];
    }
    /**
     * Gets the w component (input)
     */ get wIn() {
        return this._inputs[7];
    }
    /**
     * Gets the xyzw component (output)
     */ get xyzwOut() {
        return this._outputs[0];
    }
    /**
     * Gets the xyz component (output)
     */ get xyzOut() {
        return this._outputs[1];
    }
    /**
     * Gets the xy component (output)
     */ get xyOut() {
        return this._outputs[2];
    }
    /**
     * Gets the zw component (output)
     */ get zwOut() {
        return this._outputs[3];
    }
    /**
     * Gets the x component (output)
     */ get xOut() {
        return this._outputs[4];
    }
    /**
     * Gets the y component (output)
     */ get yOut() {
        return this._outputs[5];
    }
    /**
     * Gets the z component (output)
     */ get zOut() {
        return this._outputs[6];
    }
    /**
     * Gets the w component (output)
     */ get wOut() {
        return this._outputs[7];
    }
    _inputRename(name) {
        if (name === "xyzw ") return "xyzwIn";
        if (name === "xyz ") return "xyzIn";
        if (name === "xy ") return "xyIn";
        if (name === "zw ") return "zwIn";
        if (name === "x ") return "xIn";
        if (name === "y ") return "yIn";
        if (name === "z ") return "zIn";
        if (name === "w ") return "wIn";
        return name;
    }
    _outputRename(name) {
        switch(name){
            case "x":
                return "xOut";
            case "y":
                return "yOut";
            case "z":
                return "zOut";
            case "w":
                return "wOut";
            case "xy":
                return "xyOut";
            case "zw":
                return "zwOut";
            case "xyz":
                return "xyzOut";
            case "xyzw":
                return "xyzwOut";
            default:
                return name;
        }
    }
    _buildBlock(state) {
        super._buildBlock(state);
        const xInput = this.xIn;
        const yInput = this.yIn;
        const zInput = this.zIn;
        const wInput = this.wIn;
        const xyInput = this.xyIn;
        const zwInput = this.zwIn;
        const xyzInput = this.xyzIn;
        const xyzwInput = this.xyzwIn;
        const xyzwOutput = this.xyzwOut;
        const xyzOutput = this.xyzOut;
        const xyOutput = this.xyOut;
        const zwOutput = this.zwOut;
        const xOutput = this.xOut;
        const yOutput = this.yOut;
        const zOutput = this.zOut;
        const wOutput = this.wOut;
        const getData = (state)=>{
            if (xyzwInput.isConnected) return xyzwInput.getConnectedValue(state);
            let x = 0;
            let y = 0;
            let z = 0;
            let w = 0;
            if (xInput.isConnected) x = xInput.getConnectedValue(state);
            if (yInput.isConnected) y = yInput.getConnectedValue(state);
            if (zInput.isConnected) z = zInput.getConnectedValue(state);
            if (wInput.isConnected) w = wInput.getConnectedValue(state);
            if (xyInput.isConnected) {
                const temp = xyInput.getConnectedValue(state);
                if (temp) {
                    x = temp.x;
                    y = temp.y;
                }
            }
            if (zwInput.isConnected) {
                const temp = zwInput.getConnectedValue(state);
                if (temp) {
                    z = temp.x;
                    w = temp.y;
                }
            }
            if (xyzInput.isConnected) {
                const temp = xyzInput.getConnectedValue(state);
                if (temp) {
                    x = temp.x;
                    y = temp.y;
                    z = temp.z;
                }
            }
            return new (0, $ha1VO.Vector4)(x, y, z, w);
        };
        xyzwOutput._storedFunction = (state)=>getData(state);
        xyzOutput._storedFunction = (state)=>{
            const data = getData(state);
            return new (0, $ha1VO.Vector3)(data.x, data.y, data.z);
        };
        xyOutput._storedFunction = (state)=>{
            const data = getData(state);
            return new (0, $ha1VO.Vector2)(data.x, data.y);
        };
        zwOutput._storedFunction = (state)=>{
            const data = getData(state);
            return new (0, $ha1VO.Vector2)(data.z, data.w);
        };
        xOutput._storedFunction = (state)=>getData(state).x;
        yOutput._storedFunction = (state)=>getData(state).y;
        zOutput._storedFunction = (state)=>getData(state).z;
        wOutput._storedFunction = (state)=>getData(state).w;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.VectorConverterBlock", $57d8aff788b2d190$export$19243242121ac95a);

});

parcelRegister("jagi3", function(module, exports) {

$parcel$export(module.exports, "NormalizeVectorBlock", () => $df3b965ea773e168$export$1a34aaa72467ccd6);

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");
class $df3b965ea773e168$export$1a34aaa72467ccd6 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Creates a new NormalizeVectorBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this.registerInput("input", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).BasedOnInput);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Texture);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "NormalizeVectorBlock";
    }
    /**
     * Gets the input component
     */ get input() {
        return this._inputs[0];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        this.output._storedFunction = null;
        if (!this.input.isConnected) {
            this.output._storedValue = null;
            return;
        }
        this.output._storedFunction = (state)=>this.input.getConnectedValue(state).normalize();
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.NormalizeVectorBlock", $df3b965ea773e168$export$1a34aaa72467ccd6);

});

parcelRegister("5z48Y", function(module, exports) {

$parcel$export(module.exports, "SetMaterialIDBlock", () => $40d36f80bfde9d93$export$d75d0f707d6b4388);

var $e0Suo = parcelRequire("e0Suo");

var $gJfVN = parcelRequire("gJfVN");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $5v6ry = parcelRequire("5v6ry");

var $1aXVF = parcelRequire("1aXVF");
class $40d36f80bfde9d93$export$d75d0f707d6b4388 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new SetMaterialIDBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        /**
         * Gets or sets a boolean indicating that this block can evaluate context
         * Build performance is improved when this value is set to false as the system will cache values instead of reevaluating everything per context change
         */ this.evaluateContext = true;
        this.registerInput("geometry", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
        this.registerInput("id", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int, true, 0);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
        this.id.acceptedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "SetMaterialIDBlock";
    }
    /**
     * Gets the geometry input component
     */ get geometry() {
        return this._inputs[0];
    }
    /**
     * Gets the id input component
     */ get id() {
        return this._inputs[1];
    }
    /**
     * Gets the geometry output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        if (!this.geometry.isConnected) {
            this.output._storedFunction = null;
            this.output._storedValue = null;
            return;
        }
        const func = (state)=>{
            const vertexData = this.geometry.getConnectedValue(state);
            if (!vertexData || !vertexData.indices || !vertexData.positions) return vertexData;
            const materialInfo = new (0, $5v6ry.VertexDataMaterialInfo)();
            materialInfo.materialIndex = this.id.getConnectedValue(state) | 0;
            materialInfo.indexStart = 0;
            materialInfo.indexCount = vertexData.indices.length;
            materialInfo.verticesStart = 0;
            materialInfo.verticesCount = vertexData.positions.length / 3;
            vertexData.materialInfos = [
                materialInfo
            ];
            return vertexData;
        };
        if (this.evaluateContext) this.output._storedFunction = func;
        else {
            this.output._storedFunction = null;
            this.output._storedValue = func(state);
        }
    }
    _dumpPropertiesCode() {
        const codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.evaluateContext = ${this.evaluateContext ? "true" : "false"};\n`;
        return codeString;
    }
    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.evaluateContext = this.evaluateContext;
        return serializationObject;
    }
    _deserialize(serializationObject) {
        super._deserialize(serializationObject);
        if (serializationObject.evaluateContext !== undefined) this.evaluateContext = serializationObject.evaluateContext;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Evaluate context", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            rebuild: true
        }
    })
], $40d36f80bfde9d93$export$d75d0f707d6b4388.prototype, "evaluateContext", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.SetMaterialIDBlock", $40d36f80bfde9d93$export$d75d0f707d6b4388);

});

parcelRegister("3YavI", function(module, exports) {

$parcel$export(module.exports, "GeometryTrigonometryBlockOperations", () => $2e3f20e0d6157ba9$export$7d57033a276022da);
$parcel$export(module.exports, "GeometryTrigonometryBlock", () => $2e3f20e0d6157ba9$export$b836bf902c52c848);

var $e0Suo = parcelRequire("e0Suo");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");

var $ha1VO = parcelRequire("ha1VO");

var $1aXVF = parcelRequire("1aXVF");
var $2e3f20e0d6157ba9$export$7d57033a276022da;
(function(GeometryTrigonometryBlockOperations) {
    /** Cos */ GeometryTrigonometryBlockOperations[GeometryTrigonometryBlockOperations["Cos"] = 0] = "Cos";
    /** Sin */ GeometryTrigonometryBlockOperations[GeometryTrigonometryBlockOperations["Sin"] = 1] = "Sin";
    /** Abs */ GeometryTrigonometryBlockOperations[GeometryTrigonometryBlockOperations["Abs"] = 2] = "Abs";
    /** Exp */ GeometryTrigonometryBlockOperations[GeometryTrigonometryBlockOperations["Exp"] = 3] = "Exp";
    /** Round */ GeometryTrigonometryBlockOperations[GeometryTrigonometryBlockOperations["Round"] = 4] = "Round";
    /** Floor */ GeometryTrigonometryBlockOperations[GeometryTrigonometryBlockOperations["Floor"] = 5] = "Floor";
    /** Ceiling */ GeometryTrigonometryBlockOperations[GeometryTrigonometryBlockOperations["Ceiling"] = 6] = "Ceiling";
    /** Square root */ GeometryTrigonometryBlockOperations[GeometryTrigonometryBlockOperations["Sqrt"] = 7] = "Sqrt";
    /** Log */ GeometryTrigonometryBlockOperations[GeometryTrigonometryBlockOperations["Log"] = 8] = "Log";
    /** Tangent */ GeometryTrigonometryBlockOperations[GeometryTrigonometryBlockOperations["Tan"] = 9] = "Tan";
    /** Arc tangent */ GeometryTrigonometryBlockOperations[GeometryTrigonometryBlockOperations["ArcTan"] = 10] = "ArcTan";
    /** Arc cosinus */ GeometryTrigonometryBlockOperations[GeometryTrigonometryBlockOperations["ArcCos"] = 11] = "ArcCos";
    /** Arc sinus */ GeometryTrigonometryBlockOperations[GeometryTrigonometryBlockOperations["ArcSin"] = 12] = "ArcSin";
    /** Sign */ GeometryTrigonometryBlockOperations[GeometryTrigonometryBlockOperations["Sign"] = 13] = "Sign";
    /** Negate */ GeometryTrigonometryBlockOperations[GeometryTrigonometryBlockOperations["Negate"] = 14] = "Negate";
    /** OneMinus */ GeometryTrigonometryBlockOperations[GeometryTrigonometryBlockOperations["OneMinus"] = 15] = "OneMinus";
    /** Reciprocal */ GeometryTrigonometryBlockOperations[GeometryTrigonometryBlockOperations["Reciprocal"] = 16] = "Reciprocal";
    /** ToDegrees */ GeometryTrigonometryBlockOperations[GeometryTrigonometryBlockOperations["ToDegrees"] = 17] = "ToDegrees";
    /** ToRadians */ GeometryTrigonometryBlockOperations[GeometryTrigonometryBlockOperations["ToRadians"] = 18] = "ToRadians";
    /** Fract */ GeometryTrigonometryBlockOperations[GeometryTrigonometryBlockOperations["Fract"] = 19] = "Fract";
    /** Exp2 */ GeometryTrigonometryBlockOperations[GeometryTrigonometryBlockOperations["Exp2"] = 20] = "Exp2";
})($2e3f20e0d6157ba9$export$7d57033a276022da || ($2e3f20e0d6157ba9$export$7d57033a276022da = {}));
class $2e3f20e0d6157ba9$export$b836bf902c52c848 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Creates a new GeometryTrigonometryBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        /**
         * Gets or sets the operation applied by the block
         */ this.operation = $2e3f20e0d6157ba9$export$7d57033a276022da.Cos;
        this.registerInput("input", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Texture);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "GeometryTrigonometryBlock";
    }
    /**
     * Gets the input component
     */ get input() {
        return this._inputs[0];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        let func = null;
        switch(this.operation){
            case $2e3f20e0d6157ba9$export$7d57033a276022da.Cos:
                func = (value)=>Math.cos(value);
                break;
            case $2e3f20e0d6157ba9$export$7d57033a276022da.Sin:
                func = (value)=>Math.sin(value);
                break;
            case $2e3f20e0d6157ba9$export$7d57033a276022da.Abs:
                func = (value)=>Math.abs(value);
                break;
            case $2e3f20e0d6157ba9$export$7d57033a276022da.Exp:
                func = (value)=>Math.exp(value);
                break;
            case $2e3f20e0d6157ba9$export$7d57033a276022da.Exp2:
                func = (value)=>Math.pow(2, value);
                break;
            case $2e3f20e0d6157ba9$export$7d57033a276022da.Round:
                func = (value)=>Math.round(value);
                break;
            case $2e3f20e0d6157ba9$export$7d57033a276022da.Floor:
                func = (value)=>Math.floor(value);
                break;
            case $2e3f20e0d6157ba9$export$7d57033a276022da.Ceiling:
                func = (value)=>Math.ceil(value);
                break;
            case $2e3f20e0d6157ba9$export$7d57033a276022da.Sqrt:
                func = (value)=>Math.sqrt(value);
                break;
            case $2e3f20e0d6157ba9$export$7d57033a276022da.Log:
                func = (value)=>Math.log(value);
                break;
            case $2e3f20e0d6157ba9$export$7d57033a276022da.Tan:
                func = (value)=>Math.tan(value);
                break;
            case $2e3f20e0d6157ba9$export$7d57033a276022da.ArcTan:
                func = (value)=>Math.atan(value);
                break;
            case $2e3f20e0d6157ba9$export$7d57033a276022da.ArcCos:
                func = (value)=>Math.acos(value);
                break;
            case $2e3f20e0d6157ba9$export$7d57033a276022da.ArcSin:
                func = (value)=>Math.asin(value);
                break;
            case $2e3f20e0d6157ba9$export$7d57033a276022da.Sign:
                func = (value)=>Math.sign(value);
                break;
            case $2e3f20e0d6157ba9$export$7d57033a276022da.Negate:
                func = (value)=>-value;
                break;
            case $2e3f20e0d6157ba9$export$7d57033a276022da.OneMinus:
                func = (value)=>1 - value;
                break;
            case $2e3f20e0d6157ba9$export$7d57033a276022da.Reciprocal:
                func = (value)=>1 / value;
                break;
            case $2e3f20e0d6157ba9$export$7d57033a276022da.ToRadians:
                func = (value)=>value * Math.PI / 180;
                break;
            case $2e3f20e0d6157ba9$export$7d57033a276022da.ToDegrees:
                func = (value)=>value * 180 / Math.PI;
                break;
            case $2e3f20e0d6157ba9$export$7d57033a276022da.Fract:
                func = (value)=>{
                    if (value >= 0) return value - Math.floor(value);
                    else return value - Math.ceil(value);
                };
                break;
        }
        if (!func) {
            this.output._storedFunction = null;
            this.output._storedValue = null;
            return;
        }
        switch(this.input.type){
            case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int:
            case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float:
                this.output._storedFunction = (state)=>{
                    const source = this.input.getConnectedValue(state);
                    return func(source);
                };
                break;
            case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector2:
                this.output._storedFunction = (state)=>{
                    const source = this.input.getConnectedValue(state);
                    return new (0, $ha1VO.Vector2)(func(source.x), func(source.y));
                };
                break;
            case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3:
                this.output._storedFunction = (state)=>{
                    const source = this.input.getConnectedValue(state);
                    return new (0, $ha1VO.Vector3)(func(source.x), func(source.y), func(source.z));
                };
                break;
            case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector4:
                this.output._storedFunction = (state)=>{
                    const source = this.input.getConnectedValue(state);
                    return new (0, $ha1VO.Vector4)(func(source.x), func(source.y), func(source.z), func(source.w));
                };
                break;
        }
        return this;
    }
    serialize() {
        const serializationObject = super.serialize();
        serializationObject.operation = this.operation;
        return serializationObject;
    }
    _deserialize(serializationObject) {
        super._deserialize(serializationObject);
        this.operation = serializationObject.operation;
    }
    _dumpPropertiesCode() {
        const codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.operation = BABYLON.GeometryTrigonometryBlockOperations.${$2e3f20e0d6157ba9$export$7d57033a276022da[this.operation]};\n`;
        return codeString;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Operation", (0, $1aXVF.PropertyTypeForEdition).List, "ADVANCED", {
        notifiers: {
            rebuild: true
        },
        options: [
            {
                label: "Cos",
                value: $2e3f20e0d6157ba9$export$7d57033a276022da.Cos
            },
            {
                label: "Sin",
                value: $2e3f20e0d6157ba9$export$7d57033a276022da.Sin
            },
            {
                label: "Abs",
                value: $2e3f20e0d6157ba9$export$7d57033a276022da.Abs
            },
            {
                label: "Exp",
                value: $2e3f20e0d6157ba9$export$7d57033a276022da.Exp
            },
            {
                label: "Exp2",
                value: $2e3f20e0d6157ba9$export$7d57033a276022da.Exp2
            },
            {
                label: "Round",
                value: $2e3f20e0d6157ba9$export$7d57033a276022da.Round
            },
            {
                label: "Floor",
                value: $2e3f20e0d6157ba9$export$7d57033a276022da.Floor
            },
            {
                label: "Ceiling",
                value: $2e3f20e0d6157ba9$export$7d57033a276022da.Ceiling
            },
            {
                label: "Sqrt",
                value: $2e3f20e0d6157ba9$export$7d57033a276022da.Sqrt
            },
            {
                label: "Log",
                value: $2e3f20e0d6157ba9$export$7d57033a276022da.Log
            },
            {
                label: "Tan",
                value: $2e3f20e0d6157ba9$export$7d57033a276022da.Tan
            },
            {
                label: "ArcTan",
                value: $2e3f20e0d6157ba9$export$7d57033a276022da.ArcTan
            },
            {
                label: "ArcCos",
                value: $2e3f20e0d6157ba9$export$7d57033a276022da.ArcCos
            },
            {
                label: "ArcSin",
                value: $2e3f20e0d6157ba9$export$7d57033a276022da.ArcSin
            },
            {
                label: "Sign",
                value: $2e3f20e0d6157ba9$export$7d57033a276022da.Sign
            },
            {
                label: "Negate",
                value: $2e3f20e0d6157ba9$export$7d57033a276022da.Negate
            },
            {
                label: "OneMinus",
                value: $2e3f20e0d6157ba9$export$7d57033a276022da.OneMinus
            },
            {
                label: "Reciprocal",
                value: $2e3f20e0d6157ba9$export$7d57033a276022da.Reciprocal
            },
            {
                label: "ToDegrees",
                value: $2e3f20e0d6157ba9$export$7d57033a276022da.ToDegrees
            },
            {
                label: "ToRadians",
                value: $2e3f20e0d6157ba9$export$7d57033a276022da.ToRadians
            },
            {
                label: "Fract",
                value: $2e3f20e0d6157ba9$export$7d57033a276022da.Fract
            }
        ]
    })
], $2e3f20e0d6157ba9$export$b836bf902c52c848.prototype, "operation", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.GeometryTrigonometryBlock", $2e3f20e0d6157ba9$export$b836bf902c52c848);

});

parcelRegister("UvE6e", function(module, exports) {

$parcel$export(module.exports, "GeometryTransformBlock", () => $0a9dc744797a2f8b$export$6760312b91661dc5);

var $e0Suo = parcelRequire("e0Suo");

var $gJfVN = parcelRequire("gJfVN");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $ha1VO = parcelRequire("ha1VO");

var $1aXVF = parcelRequire("1aXVF");
class $0a9dc744797a2f8b$export$6760312b91661dc5 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new GeometryTransformBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this._rotationMatrix = new (0, $ha1VO.Matrix)();
        this._scalingMatrix = new (0, $ha1VO.Matrix)();
        this._translationMatrix = new (0, $ha1VO.Matrix)();
        this._scalingRotationMatrix = new (0, $ha1VO.Matrix)();
        this._transformMatrix = new (0, $ha1VO.Matrix)();
        /**
         * Gets or sets a boolean indicating that this block can evaluate context
         * Build performance is improved when this value is set to false as the system will cache values instead of reevaluating everything per context change
         */ this.evaluateContext = true;
        this.registerInput("value", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerInput("matrix", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix, true);
        this.registerInput("translation", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3, true, (0, $ha1VO.Vector3).Zero());
        this.registerInput("rotation", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3, true, (0, $ha1VO.Vector3).Zero());
        this.registerInput("scaling", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3, true, (0, $ha1VO.Vector3).One());
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Texture);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "GeometryTransformBlock";
    }
    /**
     * Gets the value input component
     */ get value() {
        return this._inputs[0];
    }
    /**
     * Gets the matrix input component
     */ get matrix() {
        return this._inputs[1];
    }
    /**
     * Gets the translation input component
     */ get translation() {
        return this._inputs[2];
    }
    /**
     * Gets the rotation input component
     */ get rotation() {
        return this._inputs[3];
    }
    /**
     * Gets the scaling input component
     */ get scaling() {
        return this._inputs[4];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        if (!this.value.isConnected) {
            this.output._storedFunction = null;
            this.output._storedValue = null;
            return;
        }
        const func = (state)=>{
            const value = this.value.getConnectedValue(state);
            if (!value) return null;
            let matrix;
            if (this.matrix.isConnected) matrix = this.matrix.getConnectedValue(state);
            else {
                const scaling = this.scaling.getConnectedValue(state);
                const rotation = this.rotation.getConnectedValue(state);
                const translation = this.translation.getConnectedValue(state);
                // Transform
                (0, $ha1VO.Matrix).ScalingToRef(scaling.x, scaling.y, scaling.z, this._scalingMatrix);
                (0, $ha1VO.Matrix).RotationYawPitchRollToRef(rotation.y, rotation.x, rotation.z, this._rotationMatrix);
                (0, $ha1VO.Matrix).TranslationToRef(translation.x, translation.y, translation.z, this._translationMatrix);
                this._scalingMatrix.multiplyToRef(this._rotationMatrix, this._scalingRotationMatrix);
                this._scalingRotationMatrix.multiplyToRef(this._translationMatrix, this._transformMatrix);
                matrix = this._transformMatrix;
            }
            switch(this.value.type){
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry:
                    {
                        const geometry = value.clone();
                        geometry.transform(matrix);
                        return geometry;
                    }
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector2:
                    return (0, $ha1VO.Vector2).Transform(value, matrix);
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3:
                    return (0, $ha1VO.Vector3).TransformCoordinates(value, matrix);
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector4:
                    return (0, $ha1VO.Vector4).TransformCoordinates(value, matrix);
            }
            return null;
        };
        if (this.evaluateContext) this.output._storedFunction = func;
        else {
            this.output._storedFunction = null;
            this.output._storedValue = func(state);
        }
    }
    _dumpPropertiesCode() {
        const codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.evaluateContext = ${this.evaluateContext ? "true" : "false"};\n`;
        return codeString;
    }
    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.evaluateContext = this.evaluateContext;
        return serializationObject;
    }
    _deserialize(serializationObject) {
        super._deserialize(serializationObject);
        if (serializationObject.evaluateContext !== undefined) this.evaluateContext = serializationObject.evaluateContext;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Evaluate context", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            rebuild: true
        }
    })
], $0a9dc744797a2f8b$export$6760312b91661dc5.prototype, "evaluateContext", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.GeometryTransformBlock", $0a9dc744797a2f8b$export$6760312b91661dc5);

});

parcelRegister("jPA08", function(module, exports) {

$parcel$export(module.exports, "RotationXBlock", () => $e6feb4d92864d705$export$441b82eaad774576);

var $gJfVN = parcelRequire("gJfVN");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $a76QT = parcelRequire("a76QT");

var $ha1VO = parcelRequire("ha1VO");
class $e6feb4d92864d705$export$441b82eaad774576 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new RotationXBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this.registerInput("angle", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, false, 0);
        this.registerOutput("matrix", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "RotationXBlock";
    }
    /**
     * Gets the angle input component
     */ get angle() {
        return this._inputs[0];
    }
    /**
     * Gets the matrix output component
     */ get matrix() {
        return this._outputs[0];
    }
    autoConfigure() {
        if (!this.angle.isConnected) {
            const angleInput = new (0, $a76QT.GeometryInputBlock)("Angle");
            angleInput.value = 0;
            angleInput.output.connectTo(this.angle);
        }
    }
    _buildBlock(state) {
        super._buildBlock(state);
        this.matrix._storedFunction = (state)=>{
            return (0, $ha1VO.Matrix).RotationX(this.angle.getConnectedValue(state));
        };
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.RotationXBlock", $e6feb4d92864d705$export$441b82eaad774576);

});

parcelRegister("55PTw", function(module, exports) {

$parcel$export(module.exports, "RotationYBlock", () => $3b55ac901ba0c5d2$export$209de8ecc49630c3);

var $gJfVN = parcelRequire("gJfVN");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $a76QT = parcelRequire("a76QT");

var $ha1VO = parcelRequire("ha1VO");
class $3b55ac901ba0c5d2$export$209de8ecc49630c3 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new RotationYBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this.registerInput("angle", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, false, 0);
        this.registerOutput("matrix", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "RotationYBlock";
    }
    /**
     * Gets the angle input component
     */ get angle() {
        return this._inputs[0];
    }
    /**
     * Gets the matrix output component
     */ get matrix() {
        return this._outputs[0];
    }
    autoConfigure() {
        if (!this.angle.isConnected) {
            const angleInput = new (0, $a76QT.GeometryInputBlock)("Angle");
            angleInput.value = 0;
            angleInput.output.connectTo(this.angle);
        }
    }
    _buildBlock(state) {
        super._buildBlock(state);
        this.matrix._storedFunction = (state)=>{
            return (0, $ha1VO.Matrix).RotationY(this.angle.getConnectedValue(state));
        };
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.RotationYBlock", $3b55ac901ba0c5d2$export$209de8ecc49630c3);

});

parcelRegister("3RqJm", function(module, exports) {

$parcel$export(module.exports, "RotationZBlock", () => $2cfb0e75719f591c$export$ce06799421f5efb0);

var $gJfVN = parcelRequire("gJfVN");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $a76QT = parcelRequire("a76QT");

var $ha1VO = parcelRequire("ha1VO");
class $2cfb0e75719f591c$export$ce06799421f5efb0 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new RotationZBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this.registerInput("angle", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, false, 0);
        this.registerOutput("matrix", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "RotationZBlock";
    }
    /**
     * Gets the angle input component
     */ get angle() {
        return this._inputs[0];
    }
    /**
     * Gets the matrix output component
     */ get matrix() {
        return this._outputs[0];
    }
    autoConfigure() {
        if (!this.angle.isConnected) {
            const angleInput = new (0, $a76QT.GeometryInputBlock)("Angle");
            angleInput.value = 0;
            angleInput.output.connectTo(this.angle);
        }
    }
    _buildBlock(state) {
        super._buildBlock(state);
        this.matrix._storedFunction = (state)=>{
            return (0, $ha1VO.Matrix).RotationZ(this.angle.getConnectedValue(state));
        };
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.RotationZBlock", $2cfb0e75719f591c$export$ce06799421f5efb0);

});

parcelRegister("hJSiV", function(module, exports) {

$parcel$export(module.exports, "ScalingBlock", () => $cea0c3556ee31fdd$export$467afae9fa78b2ca);

var $gJfVN = parcelRequire("gJfVN");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $a76QT = parcelRequire("a76QT");

var $ha1VO = parcelRequire("ha1VO");
class $cea0c3556ee31fdd$export$467afae9fa78b2ca extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new ScalingBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this.registerInput("scale", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3, false, (0, $ha1VO.Vector3).One());
        this.registerOutput("matrix", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "ScalingBlock";
    }
    /**
     * Gets the scale input component
     */ get scale() {
        return this._inputs[0];
    }
    /**
     * Gets the matrix output component
     */ get matrix() {
        return this._outputs[0];
    }
    autoConfigure() {
        if (!this.scale.isConnected) {
            const scaleInput = new (0, $a76QT.GeometryInputBlock)("Scale");
            scaleInput.value = new (0, $ha1VO.Vector3)(1, 1, 1);
            scaleInput.output.connectTo(this.scale);
        }
    }
    _buildBlock(state) {
        super._buildBlock(state);
        this.matrix._storedFunction = (state)=>{
            const value = this.scale.getConnectedValue(state);
            return (0, $ha1VO.Matrix).Scaling(value.x, value.y, value.z);
        };
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.ScalingBlock", $cea0c3556ee31fdd$export$467afae9fa78b2ca);

});

parcelRegister("6PcfJ", function(module, exports) {

$parcel$export(module.exports, "AlignBlock", () => $4f8102a42b1cf8a7$export$8c0feab2458e0f55);

var $gJfVN = parcelRequire("gJfVN");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $ha1VO = parcelRequire("ha1VO");
class $4f8102a42b1cf8a7$export$8c0feab2458e0f55 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new AlignBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this.registerInput("source", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3, true, (0, $ha1VO.Vector3).Up());
        this.registerInput("target", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3, true, (0, $ha1VO.Vector3).Left());
        this.registerOutput("matrix", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "AlignBlock";
    }
    /**
     * Gets the source input component
     */ get source() {
        return this._inputs[0];
    }
    /**
     * Gets the target input component
     */ get target() {
        return this._inputs[1];
    }
    /**
     * Gets the matrix output component
     */ get matrix() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        super._buildBlock(state);
        this.matrix._storedFunction = (state)=>{
            const source = this.source.getConnectedValue(state).clone();
            const target = this.target.getConnectedValue(state).clone();
            const result = new (0, $ha1VO.Matrix)();
            source.normalize();
            target.normalize();
            (0, $ha1VO.Matrix).RotationAlignToRef(source, target, result, true);
            return result;
        };
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.AlignBlock", $4f8102a42b1cf8a7$export$8c0feab2458e0f55);

});

parcelRegister("iYgB9", function(module, exports) {

$parcel$export(module.exports, "TranslationBlock", () => $dcfab4a3cb9ee79a$export$15e5088d6f327ddf);

var $gJfVN = parcelRequire("gJfVN");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $a76QT = parcelRequire("a76QT");

var $ha1VO = parcelRequire("ha1VO");
class $dcfab4a3cb9ee79a$export$15e5088d6f327ddf extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new TranslationBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this.registerInput("translation", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3, false, (0, $ha1VO.Vector3).Zero());
        this.registerOutput("matrix", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "TranslationBlock";
    }
    /**
     * Gets the translation input component
     */ get translation() {
        return this._inputs[0];
    }
    /**
     * Gets the matrix output component
     */ get matrix() {
        return this._outputs[0];
    }
    autoConfigure() {
        if (!this.translation.isConnected) {
            const translationInput = new (0, $a76QT.GeometryInputBlock)("Translation");
            translationInput.value = new (0, $ha1VO.Vector3)(0, 0, 0);
            translationInput.output.connectTo(this.translation);
        }
    }
    _buildBlock(state) {
        super._buildBlock(state);
        this.matrix._storedFunction = (state)=>{
            const value = this.translation.getConnectedValue(state);
            return (0, $ha1VO.Matrix).Translation(value.x, value.y, value.z);
        };
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.TranslationBlock", $dcfab4a3cb9ee79a$export$15e5088d6f327ddf);

});

parcelRegister("k7nXZ", function(module, exports) {

$parcel$export(module.exports, "InstantiateOnVerticesBlock", () => $ea570d5f4a018957$export$ec2d6a2391da921f);

var $e0Suo = parcelRequire("e0Suo");

var $gJfVN = parcelRequire("gJfVN");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $ha1VO = parcelRequire("ha1VO");

var $1aXVF = parcelRequire("1aXVF");

var $53VPf = parcelRequire("53VPf");
class $ea570d5f4a018957$export$ec2d6a2391da921f extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new InstantiateOnVerticesBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this._indexTranslation = null;
        /**
         * Gets or sets a boolean indicating that this block can evaluate context
         * Build performance is improved when this value is set to false as the system will cache values instead of reevaluating everything per context change
         */ this.evaluateContext = true;
        /**
         * Gets or sets a boolean indicating if the block should remove duplicated positions
         */ this.removeDuplicatedPositions = true;
        this.registerInput("geometry", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
        this.registerInput("instance", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry, true);
        this.registerInput("density", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 1, 0, 1);
        this.registerInput("matrix", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix, true);
        this.registerInput("rotation", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3, true, (0, $ha1VO.Vector3).Zero());
        this.registerInput("scaling", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3, true, (0, $ha1VO.Vector3).One());
        this.scaling.acceptedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
    }
    /**
     * Gets the current instance index in the current flow
     * @returns the current index
     */ getInstanceIndex() {
        return this._currentLoopIndex;
    }
    /**
     * Gets the current index in the current flow
     * @returns the current index
     */ getExecutionIndex() {
        return this._indexTranslation ? this._indexTranslation[this._currentIndex] : this._currentIndex;
    }
    /**
     * Gets the current loop index in the current flow
     * @returns the current loop index
     */ getExecutionLoopIndex() {
        return this._currentLoopIndex;
    }
    /**
     * Gets the current face index in the current flow
     * @returns the current face index
     */ getExecutionFaceIndex() {
        return 0;
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "InstantiateOnVerticesBlock";
    }
    /**
     * Gets the geometry input component
     */ get geometry() {
        return this._inputs[0];
    }
    /**
     * Gets the instance input component
     */ get instance() {
        return this._inputs[1];
    }
    /**
     * Gets the density input component
     */ get density() {
        return this._inputs[2];
    }
    /**
     * Gets the matrix input component
     */ get matrix() {
        return this._inputs[3];
    }
    /**
     * Gets the rotation input component
     */ get rotation() {
        return this._inputs[4];
    }
    /**
     * Gets the scaling input component
     */ get scaling() {
        return this._inputs[5];
    }
    /**
     * Gets the geometry output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        const func = (state)=>{
            state.pushExecutionContext(this);
            state.pushInstancingContext(this);
            this._vertexData = this.geometry.getConnectedValue(state);
            state.pushGeometryContext(this._vertexData);
            if (!this._vertexData || !this._vertexData.positions || !this.instance.isConnected) {
                state.restoreExecutionContext();
                state.restoreInstancingContext();
                state.restoreGeometryContext();
                this.output._storedValue = null;
                return;
            }
            // Processing
            let vertexCount = this._vertexData.positions.length / 3;
            const additionalVertexData = [];
            const currentPosition = new (0, $ha1VO.Vector3)();
            const alreadyDone = [];
            let vertices = this._vertexData.positions;
            this._currentLoopIndex = 0;
            if (this.removeDuplicatedPositions) {
                this._indexTranslation = {};
                for(this._currentIndex = 0; this._currentIndex < vertexCount; this._currentIndex++){
                    const x = vertices[this._currentIndex * 3];
                    const y = vertices[this._currentIndex * 3 + 1];
                    const z = vertices[this._currentIndex * 3 + 2];
                    let found = false;
                    for(let index = 0; index < alreadyDone.length; index += 3)if (Math.abs(alreadyDone[index] - x) < (0, $53VPf.Epsilon) && Math.abs(alreadyDone[index + 1] - y) < (0, $53VPf.Epsilon) && Math.abs(alreadyDone[index + 2] - z) < (0, $53VPf.Epsilon)) {
                        found = true;
                        break;
                    }
                    if (found) continue;
                    this._indexTranslation[alreadyDone.length / 3] = this._currentIndex;
                    alreadyDone.push(x, y, z);
                }
                vertices = alreadyDone;
                vertexCount = vertices.length / 3;
            } else this._indexTranslation = null;
            for(this._currentIndex = 0; this._currentIndex < vertexCount; this._currentIndex++){
                const instanceGeometry = this.instance.getConnectedValue(state);
                if (!instanceGeometry || !instanceGeometry.positions || instanceGeometry.positions.length === 0) continue;
                const density = this.density.getConnectedValue(state);
                if (density < 1) {
                    if (Math.random() > density) continue;
                }
                currentPosition.fromArray(vertices, this._currentIndex * 3);
                // Clone the instance
                const clone = instanceGeometry.clone();
                // Transform
                if (this.matrix.isConnected) {
                    const transform = this.matrix.getConnectedValue(state);
                    state._instantiateWithPositionAndMatrix(clone, currentPosition, transform, additionalVertexData);
                } else {
                    const scaling = state.adaptInput(this.scaling, (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3, (0, $ha1VO.Vector3).OneReadOnly);
                    const rotation = this.rotation.getConnectedValue(state) || (0, $ha1VO.Vector3).ZeroReadOnly;
                    state._instantiate(clone, currentPosition, rotation, scaling, additionalVertexData);
                }
                this._currentLoopIndex++;
            }
            // Restore
            state.restoreGeometryContext();
            state.restoreExecutionContext();
            state.restoreInstancingContext();
            // Merge
            if (additionalVertexData.length) {
                if (additionalVertexData.length === 1) this._vertexData = additionalVertexData[0];
                else {
                    // We do not merge the main one as user can use a merge node if wanted
                    const main = additionalVertexData.splice(0, 1)[0];
                    this._vertexData = main.merge(additionalVertexData, true, false, true, true);
                }
            } else return null;
            return this._vertexData;
        };
        // Storage
        if (this.evaluateContext) this.output._storedFunction = func;
        else {
            this.output._storedFunction = null;
            this.output._storedValue = func(state);
        }
    }
    _dumpPropertiesCode() {
        let codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.removeDuplicatedPositions = ${this.removeDuplicatedPositions ? "true" : "false"};\n`;
        codeString += `${this._codeVariableName}.evaluateContext = ${this.evaluateContext ? "true" : "false"};\n`;
        return codeString;
    }
    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.removeDuplicatedPositions = this.removeDuplicatedPositions;
        serializationObject.evaluateContext = this.evaluateContext;
        return serializationObject;
    }
    _deserialize(serializationObject) {
        super._deserialize(serializationObject);
        this.removeDuplicatedPositions = serializationObject.removeDuplicatedPositions;
        if (serializationObject.evaluateContext !== undefined) this.evaluateContext = serializationObject.evaluateContext;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Evaluate context", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            rebuild: true
        }
    })
], $ea570d5f4a018957$export$ec2d6a2391da921f.prototype, "evaluateContext", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Remove duplicated positions", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            update: true
        }
    })
], $ea570d5f4a018957$export$ec2d6a2391da921f.prototype, "removeDuplicatedPositions", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.InstantiateOnVerticesBlock", $ea570d5f4a018957$export$ec2d6a2391da921f);

});

parcelRegister("31JLU", function(module, exports) {

$parcel$export(module.exports, "InstantiateOnFacesBlock", () => $2344f86bd3e49e61$export$c941ffe0c0667335);

var $e0Suo = parcelRequire("e0Suo");

var $gJfVN = parcelRequire("gJfVN");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $ha1VO = parcelRequire("ha1VO");

var $1aXVF = parcelRequire("1aXVF");
class $2344f86bd3e49e61$export$c941ffe0c0667335 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new InstantiateOnFacesBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this._currentPosition = new (0, $ha1VO.Vector3)();
        this._currentUV = new (0, $ha1VO.Vector2)();
        this._vertex0 = new (0, $ha1VO.Vector3)();
        this._vertex1 = new (0, $ha1VO.Vector3)();
        this._vertex2 = new (0, $ha1VO.Vector3)();
        this._tempVector0 = new (0, $ha1VO.Vector3)();
        this._tempVector1 = new (0, $ha1VO.Vector3)();
        this._uv0 = new (0, $ha1VO.Vector2)();
        this._uv1 = new (0, $ha1VO.Vector2)();
        this._uv2 = new (0, $ha1VO.Vector2)();
        /**
         * Gets or sets a boolean indicating that this block can evaluate context
         * Build performance is improved when this value is set to false as the system will cache values instead of reevaluating everything per context change
         */ this.evaluateContext = true;
        this.registerInput("geometry", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
        this.registerInput("instance", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry, true);
        this.registerInput("count", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int, true, 256);
        this.registerInput("matrix", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix, true);
        this.registerInput("rotation", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3, true, (0, $ha1VO.Vector3).Zero());
        this.registerInput("scaling", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3, true, (0, $ha1VO.Vector3).One());
        this.scaling.acceptedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
    }
    /**
     * Gets the current instance index in the current flow
     * @returns the current index
     */ getInstanceIndex() {
        return this._currentLoopIndex;
    }
    /**
     * Gets the current index in the current flow
     * @returns the current index
     */ getExecutionIndex() {
        return 0;
    }
    /**
     * Gets the current face index in the current flow
     * @returns the current face index
     */ getExecutionFaceIndex() {
        return this._currentFaceIndex;
    }
    /**
     * Gets the current loop index in the current flow
     * @returns the current loop index
     */ getExecutionLoopIndex() {
        return this._currentLoopIndex;
    }
    /**
     * Gets the value associated with a contextual positions
     * @returns the value associated with the source
     */ getOverridePositionsContextualValue() {
        return this._currentPosition;
    }
    /**
     * Gets the value associated with a contextual normals
     * @returns the value associated with the source
     */ getOverrideNormalsContextualValue() {
        this._vertex1.subtractToRef(this._vertex0, this._tempVector0);
        this._vertex2.subtractToRef(this._vertex1, this._tempVector1);
        this._tempVector0.normalize();
        this._tempVector1.normalize();
        return (0, $ha1VO.Vector3).Cross(this._tempVector1, this._tempVector0);
    }
    /**
     * Gets the value associated with a contextual UV1 se
     * @returns the value associated with the source
     */ getOverrideUVs1ContextualValue() {
        return this._currentUV;
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "InstantiateOnFacesBlock";
    }
    /**
     * Gets the geometry input component
     */ get geometry() {
        return this._inputs[0];
    }
    /**
     * Gets the instance input component
     */ get instance() {
        return this._inputs[1];
    }
    /**
     * Gets the count input component
     */ get count() {
        return this._inputs[2];
    }
    /**
     * Gets the matrix input component
     */ get matrix() {
        return this._inputs[3];
    }
    /**
     * Gets the rotation input component
     */ get rotation() {
        return this._inputs[4];
    }
    /**
     * Gets the scaling input component
     */ get scaling() {
        return this._inputs[5];
    }
    /**
     * Gets the geometry output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        const func = (state)=>{
            state.pushExecutionContext(this);
            state.pushInstancingContext(this);
            this._vertexData = this.geometry.getConnectedValue(state);
            state.pushGeometryContext(this._vertexData);
            if (!this._vertexData || !this._vertexData.positions || !this._vertexData.indices || !this.instance.isConnected) {
                state.restoreExecutionContext();
                state.restoreInstancingContext();
                state.restoreGeometryContext();
                this.output._storedValue = null;
                return;
            }
            // Processing
            let instanceGeometry = null;
            const instanceCount = this.count.getConnectedValue(state);
            const faceCount = this._vertexData.indices.length / 3;
            const instancePerFace = instanceCount / faceCount;
            let accumulatedCount = 0;
            const additionalVertexData = [];
            let totalDone = 0;
            this._currentLoopIndex = 0;
            for(this._currentFaceIndex = 0; this._currentFaceIndex < faceCount; this._currentFaceIndex++){
                accumulatedCount += instancePerFace;
                const countPerFace = (accumulatedCount | 0) - totalDone;
                if (countPerFace < 1) continue;
                const faceID0 = this._vertexData.indices[this._currentFaceIndex * 3];
                const faceID1 = this._vertexData.indices[this._currentFaceIndex * 3 + 1];
                const faceID2 = this._vertexData.indices[this._currentFaceIndex * 3 + 2];
                // Extract face vertices
                this._vertex0.fromArray(this._vertexData.positions, faceID0 * 3);
                this._vertex1.fromArray(this._vertexData.positions, faceID1 * 3);
                this._vertex2.fromArray(this._vertexData.positions, faceID2 * 3);
                if (this._vertexData.uvs) {
                    this._uv0.fromArray(this._vertexData.uvs, faceID0 * 2);
                    this._uv1.fromArray(this._vertexData.uvs, faceID1 * 2);
                    this._uv2.fromArray(this._vertexData.uvs, faceID2 * 2);
                }
                for(let faceDispatchCount = 0; faceDispatchCount < countPerFace; faceDispatchCount++){
                    if (totalDone >= instanceCount) break;
                    // Get random point on face
                    let x = Math.random();
                    let y = Math.random();
                    if (x > y) {
                        const temp = x;
                        x = y;
                        y = temp;
                    }
                    const s = x;
                    const t = y - x;
                    const u = 1 - s - t;
                    this._currentPosition.set(s * this._vertex0.x + t * this._vertex1.x + u * this._vertex2.x, s * this._vertex0.y + t * this._vertex1.y + u * this._vertex2.y, s * this._vertex0.z + t * this._vertex1.z + u * this._vertex2.z);
                    if (this._vertexData.uvs) this._currentUV.set(s * this._uv0.x + t * this._uv1.x + u * this._uv2.x, s * this._uv0.y + t * this._uv1.y + u * this._uv2.y);
                    // Clone the instance
                    instanceGeometry = this.instance.getConnectedValue(state);
                    if (!instanceGeometry || !instanceGeometry.positions || instanceGeometry.positions.length === 0) {
                        accumulatedCount -= instancePerFace;
                        continue;
                    }
                    const clone = instanceGeometry.clone();
                    if (this.matrix.isConnected) {
                        const transform = this.matrix.getConnectedValue(state);
                        state._instantiateWithPositionAndMatrix(clone, this._currentPosition, transform, additionalVertexData);
                    } else {
                        const scaling = state.adaptInput(this.scaling, (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3, (0, $ha1VO.Vector3).OneReadOnly);
                        const rotation = this.rotation.getConnectedValue(state) || (0, $ha1VO.Vector3).ZeroReadOnly;
                        state._instantiate(clone, this._currentPosition, rotation, scaling, additionalVertexData);
                    }
                    totalDone++;
                    this._currentLoopIndex++;
                }
            }
            // Merge
            if (additionalVertexData.length) {
                if (additionalVertexData.length === 1) this._vertexData = additionalVertexData[0];
                else {
                    // We do not merge the main one as user can use a merge node if wanted
                    const main = additionalVertexData.splice(0, 1)[0];
                    this._vertexData = main.merge(additionalVertexData, true, false, true, true);
                }
            }
            state.restoreExecutionContext();
            state.restoreInstancingContext();
            state.restoreGeometryContext();
            return this._vertexData;
        };
        // Storage
        if (this.evaluateContext) this.output._storedFunction = func;
        else {
            this.output._storedFunction = null;
            this.output._storedValue = func(state);
        }
    }
    _dumpPropertiesCode() {
        const codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.evaluateContext = ${this.evaluateContext ? "true" : "false"};\n`;
        return codeString;
    }
    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.evaluateContext = this.evaluateContext;
        return serializationObject;
    }
    _deserialize(serializationObject) {
        super._deserialize(serializationObject);
        if (serializationObject.evaluateContext !== undefined) this.evaluateContext = serializationObject.evaluateContext;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Evaluate context", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            rebuild: true
        }
    })
], $2344f86bd3e49e61$export$c941ffe0c0667335.prototype, "evaluateContext", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.InstantiateOnFacesBlock", $2344f86bd3e49e61$export$c941ffe0c0667335);

});

parcelRegister("4ekeI", function(module, exports) {

$parcel$export(module.exports, "InstantiateOnVolumeBlock", () => $31482ab8f662bb16$export$72ce8e179a2ecbeb);

var $e0Suo = parcelRequire("e0Suo");

var $gJfVN = parcelRequire("gJfVN");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $ha1VO = parcelRequire("ha1VO");

var $1aXVF = parcelRequire("1aXVF");

var $3kez7 = parcelRequire("3kez7");

var $1NJAz = parcelRequire("1NJAz");
class $31482ab8f662bb16$export$72ce8e179a2ecbeb extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new InstantiateOnVolumeBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this._currentPosition = new (0, $ha1VO.Vector3)();
        this._vertex0 = new (0, $ha1VO.Vector3)();
        this._vertex1 = new (0, $ha1VO.Vector3)();
        this._vertex2 = new (0, $ha1VO.Vector3)();
        /**
         * Gets or sets a boolean indicating that this block can evaluate context
         * Build performance is improved when this value is set to false as the system will cache values instead of reevaluating everything per context change
         */ this.evaluateContext = true;
        this.registerInput("geometry", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
        this.registerInput("instance", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry, true);
        this.registerInput("count", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int, true, 256);
        this.registerInput("matrix", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix, true);
        this.registerInput("rotation", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3, true, (0, $ha1VO.Vector3).Zero());
        this.registerInput("scaling", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3, true, (0, $ha1VO.Vector3).One());
        this.scaling.acceptedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
    }
    /**
     * Gets the current instance index in the current flow
     * @returns the current index
     */ getInstanceIndex() {
        return this._currentLoopIndex;
    }
    /**
     * Gets the current index in the current flow
     * @returns the current index
     */ getExecutionIndex() {
        return 0;
    }
    /**
     * Gets the current face index in the current flow
     * @returns the current face index
     */ getExecutionFaceIndex() {
        return 0;
    }
    /**
     * Gets the current loop index in the current flow
     * @returns the current loop index
     */ getExecutionLoopIndex() {
        return this._currentLoopIndex;
    }
    /**
     * Gets the value associated with a contextual positions
     * @returns the value associated with the source
     */ getOverridePositionsContextualValue() {
        return this._currentPosition;
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "InstantiateOnVolumeBlock";
    }
    /**
     * Gets the geometry input component
     */ get geometry() {
        return this._inputs[0];
    }
    /**
     * Gets the instance input component
     */ get instance() {
        return this._inputs[1];
    }
    /**
     * Gets the count input component
     */ get count() {
        return this._inputs[2];
    }
    /**
     * Gets the matrix input component
     */ get matrix() {
        return this._inputs[3];
    }
    /**
     * Gets the rotation input component
     */ get rotation() {
        return this._inputs[4];
    }
    /**
     * Gets the scaling input component
     */ get scaling() {
        return this._inputs[5];
    }
    /**
     * Gets the geometry output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        const func = (state)=>{
            state.pushExecutionContext(this);
            state.pushInstancingContext(this);
            this._vertexData = this.geometry.getConnectedValue(state);
            state.pushGeometryContext(this._vertexData);
            if (!this._vertexData || !this._vertexData.positions || !this._vertexData.indices || !this.instance.isConnected) {
                state.restoreExecutionContext();
                state.restoreInstancingContext();
                state.restoreGeometryContext();
                this.output._storedValue = null;
                return;
            }
            // Processing
            let instanceGeometry = null;
            const instanceCount = this.count.getConnectedValue(state);
            const additionalVertexData = [];
            const boundingInfo = (0, $1NJAz.extractMinAndMax)(this._vertexData.positions, 0, this._vertexData.positions.length / 3);
            const min = boundingInfo.minimum;
            const max = boundingInfo.maximum;
            const direction = new (0, $ha1VO.Vector3)(1, 0, 0);
            const faceCount = this._vertexData.indices.length / 3;
            this._currentLoopIndex = 0;
            for(let index = 0; index < instanceCount; index++){
                this._currentPosition.set(Math.random() * (max.x - min.x) + min.x, Math.random() * (max.y - min.y) + min.y, Math.random() * (max.z - min.z) + min.z);
                // Cast a ray from the random point in an arbitrary direction
                const ray = new (0, $3kez7.Ray)(this._currentPosition, direction);
                let intersectionCount = 0;
                for(let currentFaceIndex = 0; currentFaceIndex < faceCount; currentFaceIndex++){
                    // Extract face vertices
                    this._vertex0.fromArray(this._vertexData.positions, this._vertexData.indices[currentFaceIndex * 3] * 3);
                    this._vertex1.fromArray(this._vertexData.positions, this._vertexData.indices[currentFaceIndex * 3 + 1] * 3);
                    this._vertex2.fromArray(this._vertexData.positions, this._vertexData.indices[currentFaceIndex * 3 + 2] * 3);
                    const currentIntersectInfo = ray.intersectsTriangle(this._vertex0, this._vertex1, this._vertex2);
                    if (currentIntersectInfo && currentIntersectInfo.distance > 0) intersectionCount++;
                }
                if (intersectionCount % 2 === 0) {
                    // We are outside, try again
                    index--;
                    continue;
                }
                // Clone the instance
                instanceGeometry = this.instance.getConnectedValue(state);
                if (!instanceGeometry || !instanceGeometry.positions || instanceGeometry.positions.length === 0) continue;
                const clone = instanceGeometry.clone();
                if (this.matrix.isConnected) {
                    const transform = this.matrix.getConnectedValue(state);
                    state._instantiateWithPositionAndMatrix(clone, this._currentPosition, transform, additionalVertexData);
                } else {
                    const scaling = state.adaptInput(this.scaling, (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3, (0, $ha1VO.Vector3).OneReadOnly);
                    const rotation = this.rotation.getConnectedValue(state) || (0, $ha1VO.Vector3).ZeroReadOnly;
                    state._instantiate(clone, this._currentPosition, rotation, scaling, additionalVertexData);
                }
                this._currentLoopIndex++;
            }
            // Merge
            if (additionalVertexData.length) {
                if (additionalVertexData.length === 1) this._vertexData = additionalVertexData[0];
                else {
                    // We do not merge the main one as user can use a merge node if wanted
                    const main = additionalVertexData.splice(0, 1)[0];
                    this._vertexData = main.merge(additionalVertexData, true, false, true, true);
                }
            }
            state.restoreGeometryContext();
            state.restoreExecutionContext();
            state.restoreInstancingContext();
            return this._vertexData;
        };
        // Storage
        if (this.evaluateContext) this.output._storedFunction = func;
        else {
            this.output._storedFunction = null;
            this.output._storedValue = func(state);
        }
    }
    _dumpPropertiesCode() {
        const codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.evaluateContext = ${this.evaluateContext ? "true" : "false"};\n`;
        return codeString;
    }
    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.evaluateContext = this.evaluateContext;
        return serializationObject;
    }
    _deserialize(serializationObject) {
        super._deserialize(serializationObject);
        if (serializationObject.evaluateContext !== undefined) this.evaluateContext = serializationObject.evaluateContext;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Evaluate context", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            rebuild: true
        }
    })
], $31482ab8f662bb16$export$72ce8e179a2ecbeb.prototype, "evaluateContext", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.InstantiateOnVolumeBlock", $31482ab8f662bb16$export$72ce8e179a2ecbeb);

});

parcelRegister("fBR0z", function(module, exports) {

$parcel$export(module.exports, "InstantiateBlock", () => $b5d36e0a1bc75d33$export$1fe4a813842d3820);

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $ha1VO = parcelRequire("ha1VO");

var $eTl7F = parcelRequire("eTl7F");
class $b5d36e0a1bc75d33$export$1fe4a813842d3820 extends (0, $eTl7F.InstantiateBaseBlock) {
    /**
     * Create a new InstantiateBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this.registerInput("matrix", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix, true);
        this.registerInput("position", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3, true, (0, $ha1VO.Vector3).Zero());
        this.registerInput("rotation", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3, true, (0, $ha1VO.Vector3).Zero());
        this.registerInput("scaling", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3, true, (0, $ha1VO.Vector3).One());
        this.scaling.acceptedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
    }
    /**
     * Gets the current instance index in the current flow
     * @returns the current index
     */ getInstanceIndex() {
        return this._currentIndex;
    }
    /**
     * Gets the current index in the current flow
     * @returns the current index
     */ getExecutionIndex() {
        return this._currentIndex;
    }
    /**
     * Gets the current loop index in the current flow
     * @returns the current loop index
     */ getExecutionLoopIndex() {
        return this._currentIndex;
    }
    /**
     * Gets the current face index in the current flow
     * @returns the current face index
     */ getExecutionFaceIndex() {
        return 0;
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "InstantiateBlock";
    }
    /**
     * Gets the matrix input component
     */ get matrix() {
        return this._inputs[2];
    }
    /**
     * Gets the position input component
     */ get position() {
        return this._inputs[3];
    }
    /**
     * Gets the rotation input component
     */ get rotation() {
        return this._inputs[4];
    }
    /**
     * Gets the scaling input component
     */ get scaling() {
        return this._inputs[5];
    }
    _buildBlock(state) {
        const func = (state)=>{
            state.pushExecutionContext(this);
            state.pushInstancingContext(this);
            // Processing
            const iterationCount = this.count.getConnectedValue(state);
            const additionalVertexData = [];
            for(this._currentIndex = 0; this._currentIndex < iterationCount; this._currentIndex++){
                const instanceGeometry = this.instance.getConnectedValue(state);
                if (!instanceGeometry || !instanceGeometry.positions || instanceGeometry.positions.length === 0) continue;
                // Clone the instance
                const clone = instanceGeometry.clone();
                // Transform
                if (this.matrix.isConnected) {
                    const transform = this.matrix.getConnectedValue(state);
                    state._instantiateWithMatrix(clone, transform, additionalVertexData);
                } else {
                    const position = this.position.getConnectedValue(state) || (0, $ha1VO.Vector3).ZeroReadOnly;
                    const scaling = state.adaptInput(this.scaling, (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3, (0, $ha1VO.Vector3).OneReadOnly);
                    const rotation = this.rotation.getConnectedValue(state) || (0, $ha1VO.Vector3).ZeroReadOnly;
                    state._instantiate(clone, position, rotation, scaling, additionalVertexData);
                }
            }
            // Merge
            if (additionalVertexData.length) {
                if (additionalVertexData.length === 1) this._vertexData = additionalVertexData[0];
                else {
                    // We do not merge the main one as user can use a merge node if wanted
                    const main = additionalVertexData.splice(0, 1)[0];
                    this._vertexData = main.merge(additionalVertexData, true, false, true, true);
                }
            }
            state.restoreExecutionContext();
            state.restoreInstancingContext();
            return this._vertexData;
        };
        // Storage
        if (this.evaluateContext) this.output._storedFunction = func;
        else {
            this.output._storedFunction = null;
            this.output._storedValue = func(state);
        }
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.InstantiateBlock", $b5d36e0a1bc75d33$export$1fe4a813842d3820);

});
parcelRegister("eTl7F", function(module, exports) {

$parcel$export(module.exports, "InstantiateBaseBlock", () => $ad7696400bacca0c$export$1294a82ca7ac5ebc);

var $e0Suo = parcelRequire("e0Suo");

var $gJfVN = parcelRequire("gJfVN");

var $4k2Tt = parcelRequire("4k2Tt");

var $1aXVF = parcelRequire("1aXVF");
class $ad7696400bacca0c$export$1294a82ca7ac5ebc extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new InstantiateBaseBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        /**
         * Gets or sets a boolean indicating that this block can evaluate context
         * Build performance is improved when this value is set to false as the system will cache values instead of reevaluating everything per context change
         */ this.evaluateContext = true;
        this.registerInput("instance", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry, true);
        this.registerInput("count", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int, true, 1);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
    }
    /**
     * Gets the current instance index in the current flow
     * @returns the current index
     */ getInstanceIndex() {
        return this._currentIndex;
    }
    /**
     * Gets the current index in the current flow
     * @returns the current index
     */ getExecutionIndex() {
        return this._currentIndex;
    }
    /**
     * Gets the current loop index in the current flow
     * @returns the current loop index
     */ getExecutionLoopIndex() {
        return this._currentIndex;
    }
    /**
     * Gets the current face index in the current flow
     * @returns the current face index
     */ getExecutionFaceIndex() {
        return 0;
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "InstantiateBaseBlock";
    }
    /**
     * Gets the instance input component
     */ get instance() {
        return this._inputs[0];
    }
    /**
     * Gets the count input component
     */ get count() {
        return this._inputs[1];
    }
    /**
     * Gets the geometry output component
     */ get output() {
        return this._outputs[0];
    }
    _dumpPropertiesCode() {
        const codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.evaluateContext = ${this.evaluateContext ? "true" : "false"};\n`;
        return codeString;
    }
    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.evaluateContext = this.evaluateContext;
        return serializationObject;
    }
    _deserialize(serializationObject) {
        super._deserialize(serializationObject);
        if (serializationObject.evaluateContext !== undefined) this.evaluateContext = serializationObject.evaluateContext;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Evaluate context", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            rebuild: true
        }
    })
], $ad7696400bacca0c$export$1294a82ca7ac5ebc.prototype, "evaluateContext", void 0);

});


parcelRegister("gsIz5", function(module, exports) {

$parcel$export(module.exports, "InstantiateLinearBlock", () => $bfc1d48cc87ac647$export$1ec8fc0dd810ad2b);

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $ha1VO = parcelRequire("ha1VO");

var $eTl7F = parcelRequire("eTl7F");
class $bfc1d48cc87ac647$export$1ec8fc0dd810ad2b extends (0, $eTl7F.InstantiateBaseBlock) {
    /**
     * Create a new Instantiate Linear Block
     * @param name defines the block name
     */ constructor(name){
        super(name);
        // Direction is magnitude per step
        this.registerInput("direction", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3, true, new (0, $ha1VO.Vector3)(1, 0, 0));
        // Rotation is magnitude per step
        this.registerInput("rotation", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3, true, new (0, $ha1VO.Vector3)(0, 0, 0));
        // Scaling is magnitude per step
        this.registerInput("scaling", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3, true, new (0, $ha1VO.Vector3)(0, 0, 0));
        this.scaling.acceptedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "InstantiateLinearBlock";
    }
    /**
     * Gets the direction input component
     */ get direction() {
        return this._inputs[2];
    }
    /**
     * Gets the rotation input component
     */ get rotation() {
        return this._inputs[3];
    }
    /**
     * Gets the scaling input component
     */ get scaling() {
        return this._inputs[4];
    }
    _buildBlock(state) {
        const func = (state)=>{
            state.pushExecutionContext(this);
            state.pushInstancingContext(this);
            const iterationCount = this.count.getConnectedValue(state);
            const additionalVertexData = [];
            const transformMatrix = (0, $ha1VO.Matrix).Identity();
            const transformOffset = (0, $ha1VO.Vector3).Zero();
            const rotationOffset = (0, $ha1VO.Vector3).Zero();
            const scaleOffset = (0, $ha1VO.Vector3).Zero();
            for(this._currentIndex = 0; this._currentIndex < iterationCount; this._currentIndex++){
                const instanceGeometry = this.instance.getConnectedValue(state);
                if (!instanceGeometry || !instanceGeometry.positions || instanceGeometry.positions.length === 0) continue;
                // Clone the instance
                const clone = instanceGeometry.clone();
                const direction = this.direction.getConnectedValue(state);
                const rotation = this.rotation.getConnectedValue(state);
                const scale = state.adaptInput(this.scaling, (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3, (0, $ha1VO.Vector3).OneReadOnly);
                transformOffset.copyFrom(direction.clone().scale(this._currentIndex));
                rotationOffset.copyFrom(rotation.clone().scale(this._currentIndex));
                scaleOffset.copyFrom(scale.clone().scale(this._currentIndex));
                scaleOffset.addInPlaceFromFloats(1, 1, 1);
                (0, $ha1VO.Matrix).ComposeToRef(scaleOffset, (0, $ha1VO.Quaternion).FromEulerAngles(rotationOffset.x, rotationOffset.y, rotationOffset.z), transformOffset, transformMatrix);
                state._instantiateWithMatrix(clone, transformMatrix, additionalVertexData);
            }
            // Merge
            if (additionalVertexData.length) {
                if (additionalVertexData.length === 1) this._vertexData = additionalVertexData[0];
                else {
                    // We do not merge the main one as user can use a merge node if wanted
                    const main = additionalVertexData.splice(0, 1)[0];
                    this._vertexData = main.merge(additionalVertexData, true, false, true, true);
                }
            }
            state.restoreExecutionContext();
            state.restoreInstancingContext();
            // Storage
            return this._vertexData;
        };
        if (this.evaluateContext) this.output._storedFunction = func;
        else {
            this.output._storedFunction = null;
            this.output._storedValue = func(state);
        }
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.InstantiateLinearBlock", $bfc1d48cc87ac647$export$1ec8fc0dd810ad2b);

});

parcelRegister("7KJHu", function(module, exports) {

$parcel$export(module.exports, "InstantiateRadialBlock", () => $5a5047701d488a5d$export$97ead943e0119afb);

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $ha1VO = parcelRequire("ha1VO");

var $eTl7F = parcelRequire("eTl7F");
class $5a5047701d488a5d$export$97ead943e0119afb extends (0, $eTl7F.InstantiateBaseBlock) {
    /**
     * Create a new InstantiateRadialBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this.registerInput("radius", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int, true, 0, 0);
        // Angle start and end
        this.registerInput("angleStart", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 0);
        this.registerInput("angleEnd", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, Math.PI * 2);
        // Transform offset
        this.registerInput("transform", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3, true, new (0, $ha1VO.Vector3)(0, 0, 0));
        // Rotation is magnitude per step
        this.registerInput("rotation", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3, true, new (0, $ha1VO.Vector3)(0, 0, 0));
        // Scale is magnitude per step
        this.registerInput("scaling", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3, true, new (0, $ha1VO.Vector3)(0, 0, 0));
        this.scaling.acceptedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "InstantiateRadialBlock";
    }
    /**
     * Gets the direction input component
     */ get radius() {
        return this._inputs[2];
    }
    /**
     * Gets the direction input component
     */ get angleStart() {
        return this._inputs[3];
    }
    /**
     * Gets the direction input component
     */ get angleEnd() {
        return this._inputs[4];
    }
    /**
     * Gets the transform input component
     */ get transform() {
        return this._inputs[5];
    }
    /**
     * Gets the rotation input component
     */ get rotation() {
        return this._inputs[6];
    }
    /**
     * Gets the scaling input component
     */ get scaling() {
        return this._inputs[7];
    }
    _buildBlock(state) {
        const func = (state)=>{
            state.pushExecutionContext(this);
            state.pushInstancingContext(this);
            const iterationCount = this.count.getConnectedValue(state);
            const additionalVertexData = [];
            const rotMatrix = (0, $ha1VO.Matrix).Identity();
            const radiusMatrix = (0, $ha1VO.Matrix).Identity();
            const transformMatrix = (0, $ha1VO.Matrix).Identity();
            const transformOffset = (0, $ha1VO.Vector3).Zero();
            const rotationOffset = (0, $ha1VO.Vector3).Zero();
            const scaleOffset = (0, $ha1VO.Vector3).Zero();
            for(this._currentIndex = 0; this._currentIndex < iterationCount; this._currentIndex++){
                const instanceGeometry = this.instance.getConnectedValue(state);
                if (!instanceGeometry || !instanceGeometry.positions || instanceGeometry.positions.length === 0) continue;
                // Clone the instance
                const clone = instanceGeometry.clone();
                const radius = this.radius.getConnectedValue(state);
                const angleStart = this.angleStart.getConnectedValue(state);
                const angleEnd = this.angleEnd.getConnectedValue(state);
                const transform = this.transform.getConnectedValue(state);
                const rotation = this.rotation.getConnectedValue(state);
                const scale = state.adaptInput(this.scaling, (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3, (0, $ha1VO.Vector3).OneReadOnly);
                // Define arc size
                const pieSlice = angleEnd - angleStart;
                const rStep = pieSlice / iterationCount;
                const angle = angleStart + rStep * this._currentIndex;
                const angleQuat = (0, $ha1VO.Quaternion).FromEulerAngles(0, angle, 0);
                // Get local transforms
                transformOffset.copyFrom(transform.clone().scale(this._currentIndex));
                rotationOffset.copyFrom(rotation.clone().scale(this._currentIndex));
                scaleOffset.copyFrom(scale.clone().scale(this._currentIndex));
                scaleOffset.addInPlaceFromFloats(1, 1, 1);
                // Compose (rotMatrix x radius x scale x angle x user transform)
                (0, $ha1VO.Matrix).RotationYawPitchRollToRef(rotationOffset.y, rotationOffset.x, rotationOffset.z, rotMatrix);
                radiusMatrix.setTranslationFromFloats(0, 0, radius);
                (0, $ha1VO.Matrix).ComposeToRef(scaleOffset, angleQuat, transformOffset, transformMatrix);
                rotMatrix.multiplyToRef(radiusMatrix, radiusMatrix);
                radiusMatrix.multiplyToRef(transformMatrix, transformMatrix);
                state._instantiateWithMatrix(clone, transformMatrix, additionalVertexData);
            }
            // Merge
            if (additionalVertexData.length) {
                if (additionalVertexData.length === 1) this._vertexData = additionalVertexData[0];
                else {
                    // We do not merge the main one as user can use a merge node if wanted
                    const main = additionalVertexData.splice(0, 1)[0];
                    this._vertexData = main.merge(additionalVertexData, true, false, true, true);
                }
            }
            // Storage
            state.restoreExecutionContext();
            state.restoreInstancingContext();
            return this._vertexData;
        };
        if (this.evaluateContext) this.output._storedFunction = func;
        else {
            this.output._storedFunction = null;
            this.output._storedValue = func(state);
        }
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.InstantiateRadialBlock", $5a5047701d488a5d$export$97ead943e0119afb);

});

parcelRegister("ha5SG", function(module, exports) {

$parcel$export(module.exports, "IntFloatConverterBlock", () => $c7e7eeadfa53652a$export$5841e035d6dc175b);

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");
class $c7e7eeadfa53652a$export$5841e035d6dc175b extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new IntFloatConverterBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this.registerInput("float ", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true);
        this.registerInput("int ", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int, true);
        this.registerOutput("float", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
        this.registerOutput("int", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "IntFloatConverterBlock";
    }
    /**
     * Gets the float input component
     */ get floatIn() {
        return this._inputs[0];
    }
    /**
     * Gets the int input component
     */ get intIn() {
        return this._inputs[1];
    }
    /**
     * Gets the float output component
     */ get floatOut() {
        return this._outputs[0];
    }
    /**
     * Gets the int output component
     */ get intOut() {
        return this._outputs[1];
    }
    _inputRename(name) {
        if (name === "float ") return "floatIn";
        if (name === "int ") return "intIn";
        return name;
    }
    _buildBlock() {
        this.floatOut._storedFunction = (state)=>{
            if (this.floatIn.isConnected) return this.floatIn.getConnectedValue(state);
            if (this.intIn.isConnected) return this.intIn.getConnectedValue(state);
            return 0;
        };
        this.intOut._storedFunction = (state)=>{
            if (this.floatIn.isConnected) return Math.floor(this.floatIn.getConnectedValue(state));
            if (this.intIn.isConnected) return Math.floor(this.intIn.getConnectedValue(state));
            return 0;
        };
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.IntFloatConverterBlock", $c7e7eeadfa53652a$export$5841e035d6dc175b);

});

parcelRegister("3i6nP", function(module, exports) {

$parcel$export(module.exports, "DebugBlock", () => $26580123a2bc413f$export$cb56ded3abf1e406);

var $g59iN = parcelRequire("g59iN");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");
class $26580123a2bc413f$export$cb56ded3abf1e406 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new DebugBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        /**
         * Gets the log entries
         */ this.log = [];
        this._isDebug = true;
        this.registerInput("input", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Texture);
    }
    /**
     * Gets the time spent to build this block (in ms)
     */ get buildExecutionTime() {
        return 0;
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "DebugBlock";
    }
    /**
     * Gets the input component
     */ get input() {
        return this._inputs[0];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        if (!this.input.isConnected) {
            this.output._storedFunction = null;
            this.output._storedValue = null;
            return;
        }
        this.log = [];
        const func = (state)=>{
            const input = this.input.getConnectedValue(state);
            if (input === null || input === undefined) {
                this.log.push([
                    "null",
                    ""
                ]);
                return input;
            }
            switch(this.input.type){
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector2:
                    this.log.push([
                        (0, $g59iN.Vector2ToFixed)(input, 4),
                        input.toString()
                    ]);
                    break;
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3:
                    this.log.push([
                        (0, $g59iN.Vector3ToFixed)(input, 4),
                        input.toString()
                    ]);
                    break;
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector4:
                    this.log.push([
                        (0, $g59iN.Vector4ToFixed)(input, 4),
                        input.toString()
                    ]);
                    break;
                default:
                    this.log.push([
                        input.toString(),
                        input.toString()
                    ]);
                    break;
            }
            return input;
        };
        if (this.output.isConnected) this.output._storedFunction = func;
        else this.output._storedValue = func(state);
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.DebugBlock", $26580123a2bc413f$export$cb56ded3abf1e406);

});

parcelRegister("lyPDb", function(module, exports) {

$parcel$export(module.exports, "GeometryInfoBlock", () => $fb24d2cd0bbd1b9d$export$ab680b096af55ece);

var $gJfVN = parcelRequire("gJfVN");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");
class $fb24d2cd0bbd1b9d$export$ab680b096af55ece extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new GeometryInfoBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this.registerInput("geometry", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
        this.registerOutput("id", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int);
        this.registerOutput("collectionId", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int);
        this.registerOutput("verticesCount", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int);
        this.registerOutput("facesCount", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "GeometryInfoBlock";
    }
    /**
     * Gets the geometry input component
     */ get geometry() {
        return this._inputs[0];
    }
    /**
     * Gets the geometry output component
     */ get output() {
        return this._outputs[0];
    }
    /**
     * Gets the id output component
     */ get id() {
        return this._outputs[1];
    }
    /**
     * Gets the collectionId output component
     */ get collectionId() {
        return this._outputs[2];
    }
    /**
     * Gets the verticesCount output component
     */ get verticesCount() {
        return this._outputs[3];
    }
    /**
     * Gets the facesCount output component
     */ get facesCount() {
        return this._outputs[4];
    }
    _buildBlock() {
        if (!this.geometry.isConnected) {
            this.id._storedValue = 0;
            this.collectionId._storedValue = 0;
            this.verticesCount._storedValue = 0;
            this.facesCount._storedValue = 0;
            this.output._storedValue = 0;
            this.id._storedFunction = null;
            this.collectionId._storedFunction = null;
            this.verticesCount._storedFunction = null;
            this.facesCount._storedFunction = null;
            this.output._storedFunction = null;
            return;
        }
        this.output._storedFunction = (state)=>{
            this._currentVertexData = this.geometry.getConnectedValue(state);
            return this._currentVertexData;
        };
        this.id._storedFunction = (state)=>{
            this._currentVertexData = this._currentVertexData || this.geometry.getConnectedValue(state);
            return this._currentVertexData.uniqueId;
        };
        this.collectionId._storedFunction = (state)=>{
            this._currentVertexData = this._currentVertexData || this.geometry.getConnectedValue(state);
            return this._currentVertexData.metadata ? this._currentVertexData.metadata.collectionId : 0;
        };
        this.verticesCount._storedFunction = (state)=>{
            this._currentVertexData = this._currentVertexData || this.geometry.getConnectedValue(state);
            return this._currentVertexData.positions ? this._currentVertexData.positions.length / 3 : 0;
        };
        this.facesCount._storedFunction = (state)=>{
            this._currentVertexData = this._currentVertexData || this.geometry.getConnectedValue(state);
            return this._currentVertexData.indices ? this._currentVertexData.indices.length / 3 : 0;
        };
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.GeometryInfoBlock", $fb24d2cd0bbd1b9d$export$ab680b096af55ece);

});

parcelRegister("gFhyf", function(module, exports) {

$parcel$export(module.exports, "MappingTypes", () => $c21e170aa8c9c2f3$export$c2d7dd977bfa5bd7);
$parcel$export(module.exports, "MappingBlock", () => $c21e170aa8c9c2f3$export$6c437abffc923fb1);

var $e0Suo = parcelRequire("e0Suo");

var $gJfVN = parcelRequire("gJfVN");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $1aXVF = parcelRequire("1aXVF");

var $ha1VO = parcelRequire("ha1VO");
var $c21e170aa8c9c2f3$export$c2d7dd977bfa5bd7;
(function(MappingTypes) {
    /** Spherical */ MappingTypes[MappingTypes["Spherical"] = 0] = "Spherical";
    /** Cylindrical */ MappingTypes[MappingTypes["Cylindrical"] = 1] = "Cylindrical";
    /** Cubic */ MappingTypes[MappingTypes["Cubic"] = 2] = "Cubic";
})($c21e170aa8c9c2f3$export$c2d7dd977bfa5bd7 || ($c21e170aa8c9c2f3$export$c2d7dd977bfa5bd7 = {}));
class $c21e170aa8c9c2f3$export$6c437abffc923fb1 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new MappingBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        /**
         * Gets or sets the mapping type used by the block
         */ this.mapping = $c21e170aa8c9c2f3$export$c2d7dd977bfa5bd7.Spherical;
        this.registerInput("position", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3);
        this.registerInput("normal", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3);
        this.registerInput("center", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3, true, (0, $ha1VO.Vector3).Zero());
        this.registerOutput("uv", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector2);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "MappingBlock";
    }
    /**
     * Gets the position input component
     */ get position() {
        return this._inputs[0];
    }
    /**
     * Gets the normal input component
     */ get normal() {
        return this._inputs[1];
    }
    /**
     * Gets the center input component
     */ get center() {
        return this._inputs[2];
    }
    /**
     * Gets the output component
     */ get uv() {
        return this._outputs[0];
    }
    _buildBlock() {
        if (!this.position.isConnected) {
            this.uv._storedFunction = null;
            this.uv._storedValue = null;
            return;
        }
        const tempDirection = (0, $ha1VO.Vector3).Zero();
        const func = (state)=>{
            const position = this.position.getConnectedValue(state) || (0, $ha1VO.Vector3).Zero();
            const normal = this.normal.getConnectedValue(state) || (0, $ha1VO.Vector3).Zero();
            const center = this.center.getConnectedValue(state);
            const uv = (0, $ha1VO.Vector2).Zero();
            switch(this.mapping){
                case $c21e170aa8c9c2f3$export$c2d7dd977bfa5bd7.Spherical:
                    {
                        position.subtractToRef(center, tempDirection);
                        const len = tempDirection.length();
                        if (len > 0) {
                            uv.x = Math.acos(tempDirection.y / len) / Math.PI;
                            if (tempDirection.x !== 0 || tempDirection.z !== 0) uv.y = Math.atan2(tempDirection.x, tempDirection.z) / (Math.PI * 2);
                        }
                        break;
                    }
                case $c21e170aa8c9c2f3$export$c2d7dd977bfa5bd7.Cylindrical:
                    {
                        position.subtractToRef(center, tempDirection);
                        const len = tempDirection.length();
                        if (len > 0) {
                            uv.x = Math.atan2(tempDirection.x / len, tempDirection.z / len) / (Math.PI * 2);
                            uv.y = (tempDirection.y + 1.0) / 2.0;
                        }
                        break;
                    }
                case $c21e170aa8c9c2f3$export$c2d7dd977bfa5bd7.Cubic:
                    {
                        // Find the largest component of the normal vector
                        const absX = Math.abs(normal.x);
                        const absY = Math.abs(normal.y);
                        const absZ = Math.abs(normal.z);
                        const maxDim = Math.max(Math.abs(position.x), Math.abs(position.y), Math.abs(position.z));
                        let u = 0, v = 0;
                        if (absX >= absY && absX >= absZ) {
                            u = position.y / maxDim - center.y;
                            v = position.z / maxDim - center.z;
                        } else if (absY >= absX && absY >= absZ) {
                            u = position.x / maxDim - center.x;
                            v = position.z / maxDim - center.z;
                        } else {
                            u = position.x / maxDim - center.x;
                            v = position.y / maxDim - center.y;
                        }
                        uv.x = (u + 1) / 2;
                        uv.y = (v + 1) / 2;
                    }
            }
            return uv;
        };
        this.uv._storedFunction = (state)=>{
            return func(state);
        };
    }
    _dumpPropertiesCode() {
        const codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.mapping = BABYLON.MappingTypes.${$c21e170aa8c9c2f3$export$c2d7dd977bfa5bd7[this.mapping]};\n`;
        return codeString;
    }
    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.mapping = this.mapping;
        return serializationObject;
    }
    _deserialize(serializationObject) {
        super._deserialize(serializationObject);
        this.mapping = serializationObject.mapping;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Mapping", (0, $1aXVF.PropertyTypeForEdition).List, "ADVANCED", {
        notifiers: {
            rebuild: true
        },
        options: [
            {
                label: "Spherical",
                value: $c21e170aa8c9c2f3$export$c2d7dd977bfa5bd7.Spherical
            },
            {
                label: "Cylindrical",
                value: $c21e170aa8c9c2f3$export$c2d7dd977bfa5bd7.Cylindrical
            },
            {
                label: "Cubic",
                value: $c21e170aa8c9c2f3$export$c2d7dd977bfa5bd7.Cubic
            }
        ]
    })
], $c21e170aa8c9c2f3$export$6c437abffc923fb1.prototype, "mapping", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.MappingBlock", $c21e170aa8c9c2f3$export$6c437abffc923fb1);

});

parcelRegister("7IIbf", function(module, exports) {

$parcel$export(module.exports, "MatrixComposeBlock", () => $59eee9c1363ca7dc$export$fb3a11b1d529a833);

var $gJfVN = parcelRequire("gJfVN");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");
class $59eee9c1363ca7dc$export$fb3a11b1d529a833 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new MatrixComposeBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this.registerInput("matrix0", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
        this.registerInput("matrix1", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "MatrixComposeBlock";
    }
    /**
     * Gets the matrix0 input component
     */ get matrix0() {
        return this._inputs[0];
    }
    /**
     * Gets the matrix1 input component
     */ get matrix1() {
        return this._inputs[1];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock() {
        this.output._storedFunction = (state)=>{
            if (!this.matrix0.isConnected || !this.matrix1.isConnected) return null;
            const matrix0 = this.matrix0.getConnectedValue(state);
            const matrix1 = this.matrix1.getConnectedValue(state);
            if (!matrix0 || !matrix1) return null;
            return matrix0.multiply(matrix1);
        };
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.MatrixComposeBlock", $59eee9c1363ca7dc$export$fb3a11b1d529a833);

});

parcelRegister("hkQGS", function(module, exports) {

$parcel$export(module.exports, "TeleportInBlock", () => $c9ed2d2afa8bcc91$export$2da1231962b8eae0);

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");
class $c9ed2d2afa8bcc91$export$2da1231962b8eae0 extends (0, $gJfVN.NodeGeometryBlock) {
    /** Gets the list of attached endpoints */ get endpoints() {
        return this._endpoints;
    }
    /**
     * Create a new TeleportInBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this._endpoints = [];
        this._isTeleportIn = true;
        this.registerInput("input", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "TeleportInBlock";
    }
    /**
     * Gets the input component
     */ get input() {
        return this._inputs[0];
    }
    _dumpCode(uniqueNames, alreadyDumped) {
        let codeString = super._dumpCode(uniqueNames, alreadyDumped);
        for (const endpoint of this.endpoints)if (alreadyDumped.indexOf(endpoint) === -1) codeString += endpoint._dumpCode(uniqueNames, alreadyDumped);
        return codeString;
    }
    /**
     * Checks if the current block is an ancestor of a given type
     * @param type defines the potential type to check
     * @returns true if block is a descendant
     */ isAnAncestorOfType(type) {
        if (this.getClassName() === type) return true;
        for (const endpoint of this.endpoints){
            if (endpoint.isAnAncestorOfType(type)) return true;
        }
        return false;
    }
    /**
     * Checks if the current block is an ancestor of a given block
     * @param block defines the potential descendant block to check
     * @returns true if block is a descendant
     */ isAnAncestorOf(block) {
        for (const endpoint of this.endpoints){
            if (endpoint === block) return true;
            if (endpoint.isAnAncestorOf(block)) return true;
        }
        return false;
    }
    /**
     * Get the first descendant using a predicate
     * @param predicate defines the predicate to check
     * @returns descendant or null if none found
     */ getDescendantOfPredicate(predicate) {
        if (predicate(this)) return this;
        for (const endpoint of this.endpoints){
            const descendant = endpoint.getDescendantOfPredicate(predicate);
            if (descendant) return descendant;
        }
        return null;
    }
    /**
     * Add an enpoint to this block
     * @param endpoint define the endpoint to attach to
     */ attachToEndpoint(endpoint) {
        endpoint.detach();
        this._endpoints.push(endpoint);
        endpoint._entryPoint = this;
        endpoint._outputs[0]._typeConnectionSource = this._inputs[0];
        endpoint._tempEntryPointUniqueId = null;
        endpoint.name = "> " + this.name;
    }
    /**
     * Remove enpoint from this block
     * @param endpoint define the endpoint to remove
     */ detachFromEndpoint(endpoint) {
        const index = this._endpoints.indexOf(endpoint);
        if (index !== -1) {
            this._endpoints.splice(index, 1);
            endpoint._outputs[0]._typeConnectionSource = null;
            endpoint._entryPoint = null;
        }
    }
    _buildBlock() {
        for (const endpoint of this._endpoints)endpoint.output._storedFunction = (state)=>{
            return this.input.getConnectedValue(state);
        };
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.TeleportInBlock", $c9ed2d2afa8bcc91$export$2da1231962b8eae0);

});

parcelRegister("eU5hS", function(module, exports) {

$parcel$export(module.exports, "TeleportOutBlock", () => $ad9a65a04ab5e943$export$1bacdd4e79a4a6c5);

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");
class $ad9a65a04ab5e943$export$1bacdd4e79a4a6c5 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new TeleportOutBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        /** @internal */ this._entryPoint = null;
        /** @internal */ this._tempEntryPointUniqueId = null;
        this._isTeleportOut = true;
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).BasedOnInput);
    }
    /**
     * Gets the entry point
     */ get entryPoint() {
        return this._entryPoint;
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "TeleportOutBlock";
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    /** Detach from entry point */ detach() {
        if (!this._entryPoint) return;
        this._entryPoint.detachFromEndpoint(this);
    }
    _buildBlock() {
    // Do nothing
    // All work done by the emitter
    }
    _customBuildStep(state) {
        if (this.entryPoint) this.entryPoint.build(state);
    }
    _dumpCode(uniqueNames, alreadyDumped) {
        let codeString = "";
        if (this.entryPoint) {
            if (alreadyDumped.indexOf(this.entryPoint) === -1) codeString += this.entryPoint._dumpCode(uniqueNames, alreadyDumped);
        }
        return codeString + super._dumpCode(uniqueNames, alreadyDumped);
    }
    _dumpCodeForOutputConnections(alreadyDumped) {
        let codeString = super._dumpCodeForOutputConnections(alreadyDumped);
        if (this.entryPoint) codeString += this.entryPoint._dumpCodeForOutputConnections(alreadyDumped);
        return codeString;
    }
    /**
     * Clone the current block to a new identical block
     * @returns a copy of the current block
     */ clone() {
        const clone = super.clone();
        if (this.entryPoint) this.entryPoint.attachToEndpoint(clone);
        return clone;
    }
    _dumpPropertiesCode() {
        let codeString = super._dumpPropertiesCode();
        if (this.entryPoint) codeString += `${this.entryPoint._codeVariableName}.attachToEndpoint(${this._codeVariableName});\n`;
        return codeString;
    }
    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.entryPoint = this.entryPoint?.uniqueId ?? "";
        return serializationObject;
    }
    _deserialize(serializationObject) {
        super._deserialize(serializationObject);
        this._tempEntryPointUniqueId = serializationObject.entryPoint;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.TeleportOutBlock", $ad9a65a04ab5e943$export$1bacdd4e79a4a6c5);

});

parcelRegister("8OaXC", function(module, exports) {

$parcel$export(module.exports, "GeometryTextureBlock", () => $669b7ec7ae9f19a6$export$2b12e1a4aec29314);

var $e0Suo = parcelRequire("e0Suo");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");

var $3a58A = parcelRequire("3a58A");

var $1aXVF = parcelRequire("1aXVF");
class $669b7ec7ae9f19a6$export$2b12e1a4aec29314 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Gets the texture data
     */ get textureData() {
        return this._data;
    }
    /**
     * Gets the texture width
     */ get textureWidth() {
        return this._width;
    }
    /**
     * Gets the texture height
     */ get textureHeight() {
        return this._height;
    }
    /**
     * Creates a new GeometryTextureBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this._data = null;
        /**
         * Gets or sets a boolean indicating that this block should serialize its cached data
         */ this.serializedCachedData = false;
        this.registerOutput("texture", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Texture);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "GeometryTextureBlock";
    }
    /**
     * Gets the texture component
     */ get texture() {
        return this._outputs[0];
    }
    _prepareImgToLoadAsync(url) {
        return new Promise((resolve, reject)=>{
            const img = new Image();
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            img.onload = ()=>{
                canvas.width = img.width;
                canvas.height = img.height;
                ctx.drawImage(img, 0, 0);
                const imageData = ctx.getImageData(0, 0, img.width, img.height);
                const pixels = imageData.data;
                const floatArray = new Float32Array(pixels.length);
                for(let i = 0; i < pixels.length; i++)floatArray[i] = pixels[i] / 255.0;
                this._data = floatArray;
                this._width = img.width;
                this._height = img.height;
                resolve();
            };
            img.onerror = ()=>{
                this._data = null;
                reject();
            };
            img.src = url;
        });
    }
    /**
     * Remove stored data
     */ cleanData() {
        this._data = null;
    }
    /**
     * Load the texture data
     * @param imageFile defines the file to load data from
     * @returns a promise fulfilled when image data is loaded
     */ loadTextureFromFileAsync(imageFile) {
        return this._prepareImgToLoadAsync(URL.createObjectURL(imageFile));
    }
    /**
     * Load the texture data
     * @param url defines the url to load data from
     * @returns a promise fulfilled when image data is loaded
     */ loadTextureFromUrlAsync(url) {
        return this._prepareImgToLoadAsync(url);
    }
    /**
     * Load the texture data
     * @param texture defines the source texture
     * @returns a promise fulfilled when image data is loaded
     */ extractFromTextureAsync(texture) {
        return new Promise((resolve, reject)=>{
            if (!texture.isReady()) {
                texture.onLoadObservable.addOnce(()=>{
                    return this.extractFromTextureAsync(texture).then(resolve).catch(reject);
                });
                return;
            }
            const size = texture.getSize();
            (0, $3a58A.TextureTools).GetTextureDataAsync(texture, size.width, size.height).then(async (data)=>{
                const floatArray = new Float32Array(data.length);
                for(let i = 0; i < data.length; i++)floatArray[i] = data[i] / 255.0;
                this._data = floatArray;
                this._width = size.width;
                this._height = size.height;
                resolve();
            }).catch(reject);
        });
    }
    _buildBlock() {
        if (!this._data) {
            this.texture._storedValue = null;
            return;
        }
        const textureData = {
            data: this._data,
            width: this._width,
            height: this._height
        };
        this.texture._storedValue = textureData;
    }
    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.width = this._width;
        serializationObject.height = this._height;
        serializationObject.serializedCachedData = this.serializedCachedData;
        if (this._data && this.serializedCachedData) serializationObject.data = Array.from(this._data);
        return serializationObject;
    }
    _deserialize(serializationObject) {
        super._deserialize(serializationObject);
        this._width = serializationObject.width;
        this._height = serializationObject.height;
        if (serializationObject.data) {
            this._data = new Float32Array(serializationObject.data);
            this.serializedCachedData = true;
        } else this.serializedCachedData = !!serializationObject.serializedCachedData;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Serialize cached data", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            rebuild: true
        }
    })
], $669b7ec7ae9f19a6$export$2b12e1a4aec29314.prototype, "serializedCachedData", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.GeometryTextureBlock", $669b7ec7ae9f19a6$export$2b12e1a4aec29314);

});

parcelRegister("cWcKG", function(module, exports) {

$parcel$export(module.exports, "GeometryTextureFetchBlock", () => $96b4cb10f3827afc$export$fbcbc7cfaa7c1b45);

var $e0Suo = parcelRequire("e0Suo");

var $ha1VO = parcelRequire("ha1VO");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");

var $1aXVF = parcelRequire("1aXVF");
class $96b4cb10f3827afc$export$fbcbc7cfaa7c1b45 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Creates a new GeometryTextureFetchBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        /**
         * Gets or sets a boolean indicating if coordinates should be clamped between 0 and 1
         */ this.clampCoordinates = true;
        this.registerInput("texture", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Texture);
        this.registerInput("coordinates", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector2);
        this.registerOutput("rgba", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector4);
        this.registerOutput("rgb", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3);
        this.registerOutput("r", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
        this.registerOutput("g", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
        this.registerOutput("b", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
        this.registerOutput("a", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "GeometryTextureFetchBlock";
    }
    /**
     * Gets the texture component
     */ get texture() {
        return this.inputs[0];
    }
    /**
     * Gets the coordinates component
     */ get coordinates() {
        return this.inputs[1];
    }
    /**
     * Gets the rgba component
     */ get rgba() {
        return this._outputs[0];
    }
    /**
     * Gets the rgb component
     */ get rgb() {
        return this._outputs[1];
    }
    /**
     * Gets the r component
     */ get r() {
        return this._outputs[2];
    }
    /**
     * Gets the g component
     */ get g() {
        return this._outputs[3];
    }
    /**
     * Gets the b component
     */ get b() {
        return this._outputs[4];
    }
    /**
     * Gets the a component
     */ get a() {
        return this._outputs[5];
    }
    _repeatClamp(num) {
        if (num >= 0) return num % 1;
        else return 1 - Math.abs(num) % 1;
    }
    _buildBlock() {
        const func = (state)=>{
            const textureData = this.texture.getConnectedValue(state);
            if (!textureData || !textureData.data) return null;
            const uv = this.coordinates.getConnectedValue(state);
            if (!uv) return null;
            const u = this.clampCoordinates ? Math.max(0, Math.min(uv.x, 1.0)) : this._repeatClamp(uv.x);
            const v = this.clampCoordinates ? Math.max(0, Math.min(uv.y, 1.0)) : this._repeatClamp(uv.y);
            const x = Math.floor(u * (textureData.width - 1));
            const y = Math.floor(v * (textureData.height - 1));
            const index = x + textureData.width * y;
            return (0, $ha1VO.Vector4).FromArray(textureData.data, index * 4);
        };
        this.rgba._storedFunction = (state)=>{
            return func(state);
        };
        this.rgb._storedFunction = (state)=>{
            const color = func(state);
            return color ? color.toVector3() : null;
        };
        this.r._storedFunction = (state)=>{
            const color = func(state);
            return color ? color.x : null;
        };
        this.g._storedFunction = (state)=>{
            const color = func(state);
            return color ? color.y : null;
        };
        this.b._storedFunction = (state)=>{
            const color = func(state);
            return color ? color.z : null;
        };
        this.a._storedFunction = (state)=>{
            const color = func(state);
            return color ? color.w : null;
        };
    }
    _dumpPropertiesCode() {
        const codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.clampCoordinates = ${this.clampCoordinates};\n`;
        return codeString;
    }
    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.clampCoordinates = this.clampCoordinates;
        return serializationObject;
    }
    _deserialize(serializationObject) {
        super._deserialize(serializationObject);
        this.clampCoordinates = serializationObject.clampCoordinates;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Clamp Coordinates", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            rebuild: true
        }
    })
], $96b4cb10f3827afc$export$fbcbc7cfaa7c1b45.prototype, "clampCoordinates", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.GeometryTextureFetchBlock", $96b4cb10f3827afc$export$fbcbc7cfaa7c1b45);

});

parcelRegister("33PHi", function(module, exports) {

$parcel$export(module.exports, "BoundingBlock", () => $23a9c0e640cacb90$export$4e73ffc17e11c9e1);

var $gJfVN = parcelRequire("gJfVN");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $1NJAz = parcelRequire("1NJAz");
class $23a9c0e640cacb90$export$4e73ffc17e11c9e1 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new BoundingBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this.registerInput("geometry", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
        this.registerOutput("min", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3);
        this.registerOutput("max", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "BoundingBlock";
    }
    /**
     * Gets the geometry input component
     */ get geometry() {
        return this._inputs[0];
    }
    /**
     * Gets the min output component
     */ get min() {
        return this._outputs[0];
    }
    /**
     * Gets the max output component
     */ get max() {
        return this._outputs[1];
    }
    _buildBlock() {
        this.min._storedFunction = (state)=>{
            const geometry = this.geometry.getConnectedValue(state);
            if (!geometry) return null;
            const boundingInfo = (0, $1NJAz.extractMinAndMax)(geometry.positions, 0, geometry.positions.length / 3);
            return boundingInfo.minimum;
        };
        this.max._storedFunction = (state)=>{
            const geometry = this.geometry.getConnectedValue(state);
            if (!geometry) return null;
            const boundingInfo = (0, $1NJAz.extractMinAndMax)(geometry.positions, 0, geometry.positions.length / 3);
            return boundingInfo.maximum;
        };
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.BoundingBlock", $23a9c0e640cacb90$export$4e73ffc17e11c9e1);

});

parcelRegister("l2eEI", function(module, exports) {

$parcel$export(module.exports, "BooleanGeometryOperations", () => $f505273663dc3c10$export$463271756f09020c);
$parcel$export(module.exports, "BooleanGeometryBlock", () => $f505273663dc3c10$export$2b259b6ab4b1b924);

var $e0Suo = parcelRequire("e0Suo");

var $gJfVN = parcelRequire("gJfVN");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $1aXVF = parcelRequire("1aXVF");

var $eg7RM = parcelRequire("eg7RM");
var $f505273663dc3c10$export$463271756f09020c;
(function(BooleanGeometryOperations) {
    /** Intersect */ BooleanGeometryOperations[BooleanGeometryOperations["Intersect"] = 0] = "Intersect";
    /** Subtract */ BooleanGeometryOperations[BooleanGeometryOperations["Subtract"] = 1] = "Subtract";
    /** Union */ BooleanGeometryOperations[BooleanGeometryOperations["Union"] = 2] = "Union";
})($f505273663dc3c10$export$463271756f09020c || ($f505273663dc3c10$export$463271756f09020c = {}));
class $f505273663dc3c10$export$2b259b6ab4b1b924 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Create a new BooleanGeometryBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        /**
         * Gets or sets a boolean indicating that this block can evaluate context
         * Build performance is improved when this value is set to false as the system will cache values instead of reevaluating everything per context change
         */ this.evaluateContext = false;
        /**
         * Gets or sets the operation applied by the block
         */ this.operation = $f505273663dc3c10$export$463271756f09020c.Intersect;
        this.registerInput("geometry0", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
        this.registerInput("geometry1", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "BooleanGeometryBlock";
    }
    /**
     * Gets the geometry0 input component
     */ get geometry0() {
        return this._inputs[0];
    }
    /**
     * Gets the geometry1 input component
     */ get geometry1() {
        return this._inputs[1];
    }
    /**
     * Gets the geometry output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock(state) {
        const func = (state)=>{
            const vertexData0 = this.geometry0.getConnectedValue(state);
            const vertexData1 = this.geometry1.getConnectedValue(state);
            if (!vertexData0 || !vertexData1) return null;
            const vertexCount = vertexData0.positions.length / 3;
            // Ensure that all the fields are filled to avoid problems later on in the graph
            if (!vertexData0.normals && vertexData1.normals) vertexData0.normals = new Array(vertexData0.positions.length);
            if (!vertexData1.normals && vertexData0.normals) vertexData1.normals = new Array(vertexData1.positions.length);
            if (!vertexData0.uvs && vertexData1.uvs) vertexData0.uvs = new Array(vertexCount * 2);
            if (!vertexData1.uvs && vertexData0.uvs) vertexData1.uvs = new Array(vertexCount * 2);
            if (!vertexData0.colors && vertexData1.colors) vertexData0.colors = new Array(vertexCount * 4);
            if (!vertexData1.colors && vertexData0.colors) vertexData1.colors = new Array(vertexCount * 4);
            const CSG0 = (0, $eg7RM.CSG).FromVertexData(vertexData0);
            const CSG1 = (0, $eg7RM.CSG).FromVertexData(vertexData1);
            let boolCSG;
            switch(this.operation){
                case $f505273663dc3c10$export$463271756f09020c.Intersect:
                    boolCSG = CSG0.intersect(CSG1);
                    break;
                case $f505273663dc3c10$export$463271756f09020c.Subtract:
                    boolCSG = CSG0.subtract(CSG1);
                    break;
                case $f505273663dc3c10$export$463271756f09020c.Union:
                    boolCSG = CSG0.union(CSG1);
                    break;
            }
            return boolCSG.toVertexData();
        };
        if (this.evaluateContext) this.output._storedFunction = func;
        else {
            this.output._storedFunction = null;
            this.output._storedValue = func(state);
        }
    }
    _dumpPropertiesCode() {
        let codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.evaluateContext = ${this.evaluateContext ? "true" : "false"};\n`;
        codeString += `${this._codeVariableName}.operation = BABYLON.BooleanGeometryOperations.${$f505273663dc3c10$export$463271756f09020c[this.operation]};\n`;
        return codeString;
    }
    /**
     * Serializes this block in a JSON representation
     * @returns the serialized block object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.evaluateContext = this.evaluateContext;
        serializationObject.operation = this.operation;
        return serializationObject;
    }
    _deserialize(serializationObject) {
        super._deserialize(serializationObject);
        this.evaluateContext = serializationObject.evaluateContext;
        if (serializationObject.operation) this.operation = serializationObject.operation;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Evaluate context", (0, $1aXVF.PropertyTypeForEdition).Boolean, "ADVANCED", {
        notifiers: {
            rebuild: true
        }
    })
], $f505273663dc3c10$export$2b259b6ab4b1b924.prototype, "evaluateContext", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Operation", (0, $1aXVF.PropertyTypeForEdition).List, "ADVANCED", {
        notifiers: {
            rebuild: true
        },
        options: [
            {
                label: "Intersect",
                value: $f505273663dc3c10$export$463271756f09020c.Intersect
            },
            {
                label: "Subtract",
                value: $f505273663dc3c10$export$463271756f09020c.Subtract
            },
            {
                label: "Union",
                value: $f505273663dc3c10$export$463271756f09020c.Union
            }
        ]
    })
], $f505273663dc3c10$export$2b259b6ab4b1b924.prototype, "operation", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.BooleanGeometryBlock", $f505273663dc3c10$export$2b259b6ab4b1b924);

});

parcelRegister("27rlu", function(module, exports) {

$parcel$export(module.exports, "GeometryArcTan2Block", () => $18b1727616eb633b$export$ddf30a2529f5a451);

var $ha1VO = parcelRequire("ha1VO");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");
class $18b1727616eb633b$export$ddf30a2529f5a451 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Creates a new GeometryArcTan2Block
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this.registerInput("x", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerInput("y", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
        this._linkConnectionTypes(0, 1);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Texture);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "GeometryArcTan2Block";
    }
    /**
     * Gets the x operand input component
     */ get x() {
        return this._inputs[0];
    }
    /**
     * Gets the y operand input component
     */ get y() {
        return this._inputs[1];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock() {
        if (!this.x.isConnected || !this.y.isConnected) {
            this.output._storedFunction = null;
            this.output._storedValue = null;
            return;
        }
        const func = (x, y)=>{
            return Math.atan2(x, y);
        };
        this.output._storedFunction = (state)=>{
            const x = this.x.getConnectedValue(state);
            const y = this.y.getConnectedValue(state);
            switch(this.x.type){
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int:
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float:
                    return func(x, y);
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector2:
                    return new (0, $ha1VO.Vector2)(func(x.x, y.x), func(x.y, y.y));
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3:
                    return new (0, $ha1VO.Vector3)(func(x.x, y.x), func(x.y, y.y), func(x.z, y.z));
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector4:
                    return new (0, $ha1VO.Vector4)(func(x.x, y.x), func(x.y, y.y), func(x.z, y.z), func(x.w, y.w));
            }
            return 0;
        };
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.GeometryArcTan2Block", $18b1727616eb633b$export$ddf30a2529f5a451);

});

parcelRegister("dhPzd", function(module, exports) {

$parcel$export(module.exports, "GeometryLerpBlock", () => $9ac4dd075bf221a9$export$90e94cbe3952c589);

var $8DoUR = parcelRequire("8DoUR");

var $gJfVN = parcelRequire("gJfVN");

var $4k2Tt = parcelRequire("4k2Tt");

var $ha1VO = parcelRequire("ha1VO");
class $9ac4dd075bf221a9$export$90e94cbe3952c589 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Creates a new GeometryLerpBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this.registerInput("left", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerInput("right", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerInput("gradient", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
        this._linkConnectionTypes(0, 1);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Texture);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "GeometryLerpBlock";
    }
    /**
     * Gets the left operand input component
     */ get left() {
        return this._inputs[0];
    }
    /**
     * Gets the right operand input component
     */ get right() {
        return this._inputs[1];
    }
    /**
     * Gets the gradient operand input component
     */ get gradient() {
        return this._inputs[2];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock() {
        if (!this.left.isConnected || !this.right.isConnected || !this.gradient.isConnected) {
            this.output._storedFunction = null;
            this.output._storedValue = null;
            return;
        }
        const func = (gradient, left, right)=>{
            return (1 - gradient) * left + gradient * right;
        };
        this.output._storedFunction = (state)=>{
            const left = this.left.getConnectedValue(state);
            const right = this.right.getConnectedValue(state);
            const gradient = this.gradient.getConnectedValue(state);
            switch(this.left.type){
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int:
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float:
                    return func(gradient, left, right);
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector2:
                    return new (0, $ha1VO.Vector2)(func(gradient, left.x, right.x), func(gradient, left.y, right.y));
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3:
                    return new (0, $ha1VO.Vector3)(func(gradient, left.x, right.x), func(gradient, left.y, right.y), func(gradient, left.z, right.z));
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector4:
                    return new (0, $ha1VO.Vector4)(func(gradient, left.x, right.x), func(gradient, left.y, right.y), func(gradient, left.z, right.z), func(gradient, left.w, right.w));
            }
            return 0;
        };
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.GeometryLerpBlock", $9ac4dd075bf221a9$export$90e94cbe3952c589);

});

parcelRegister("6zhJ5", function(module, exports) {

$parcel$export(module.exports, "GeometryNLerpBlock", () => $4c83c309f5f7cae6$export$4be3cc20d45d069c);

var $ha1VO = parcelRequire("ha1VO");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");
class $4c83c309f5f7cae6$export$4be3cc20d45d069c extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Creates a new GeometryNLerpBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this.registerInput("left", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerInput("right", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerInput("gradient", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
        this._linkConnectionTypes(0, 1);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Texture);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "GeometryNLerpBlock";
    }
    /**
     * Gets the left operand input component
     */ get left() {
        return this._inputs[0];
    }
    /**
     * Gets the right operand input component
     */ get right() {
        return this._inputs[1];
    }
    /**
     * Gets the gradient operand input component
     */ get gradient() {
        return this._inputs[2];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock() {
        if (!this.left.isConnected || !this.right.isConnected || !this.gradient.isConnected) {
            this.output._storedFunction = null;
            this.output._storedValue = null;
            return;
        }
        const func = (gradient, left, right)=>{
            return (1 - gradient) * left + gradient * right;
        };
        this.output._storedFunction = (state)=>{
            const left = this.left.getConnectedValue(state);
            const right = this.right.getConnectedValue(state);
            const gradient = this.gradient.getConnectedValue(state);
            switch(this.left.type){
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int:
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float:
                    return func(gradient, left, right); // NLerp is really lerp in that case
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector2:
                    {
                        const result = new (0, $ha1VO.Vector2)(func(gradient, left.x, right.x), func(gradient, left.y, right.y));
                        result.normalize();
                        return result;
                    }
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3:
                    {
                        const result = new (0, $ha1VO.Vector3)(func(gradient, left.x, right.x), func(gradient, left.y, right.y), func(gradient, left.z, right.z));
                        result.normalize();
                        return result;
                    }
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector4:
                    {
                        const result = new (0, $ha1VO.Vector4)(func(gradient, left.x, right.x), func(gradient, left.y, right.y), func(gradient, left.z, right.z), func(gradient, left.w, right.w));
                        result.normalize();
                        return result;
                    }
            }
            return 0;
        };
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.GeometryNLerpBlock", $4c83c309f5f7cae6$export$4be3cc20d45d069c);

});

parcelRegister("tfRhS", function(module, exports) {

$parcel$export(module.exports, "GeometryStepBlock", () => $057f02b5fbbbeec0$export$32cec5abe841590e);

var $ha1VO = parcelRequire("ha1VO");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");
class $057f02b5fbbbeec0$export$32cec5abe841590e extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Creates a new GeometryStepBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this.registerInput("value", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerInput("edge", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Texture);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "GeometryStepBlock";
    }
    /**
     * Gets the value operand input component
     */ get value() {
        return this._inputs[0];
    }
    /**
     * Gets the edge operand input component
     */ get edge() {
        return this._inputs[1];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock() {
        if (!this.value.isConnected || !this.edge.isConnected) {
            this.output._storedFunction = null;
            this.output._storedValue = null;
            return;
        }
        const func = (value, edge)=>{
            if (value < edge) return 0;
            return 1;
        };
        this.output._storedFunction = (state)=>{
            const source = this.value.getConnectedValue(state);
            const edge = this.edge.getConnectedValue(state);
            switch(this.value.type){
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int:
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float:
                    return func(source, edge);
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector2:
                    return new (0, $ha1VO.Vector2)(func(source.x, edge), func(source.y, edge));
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3:
                    return new (0, $ha1VO.Vector3)(func(source.x, edge), func(source.y, edge), func(source.z, edge));
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector4:
                    return new (0, $ha1VO.Vector4)(func(source.x, edge), func(source.y, edge), func(source.z, edge), func(source.w, edge));
            }
            return 0;
        };
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.GeometryStepBlock", $057f02b5fbbbeec0$export$32cec5abe841590e);

});

parcelRegister("fBVNd", function(module, exports) {

$parcel$export(module.exports, "GeometrySmoothStepBlock", () => $b5d7242cac9cdd09$export$4f319d0f26905b27);

var $ha1VO = parcelRequire("ha1VO");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");
class $b5d7242cac9cdd09$export$4f319d0f26905b27 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Creates a new GeometrySmoothStepBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this.registerInput("value", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerInput("edge0", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
        this.registerInput("edge1", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Texture);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "GeometrySmoothStepBlock";
    }
    /**
     * Gets the value operand input component
     */ get value() {
        return this._inputs[0];
    }
    /**
     * Gets the first edge operand input component
     */ get edge0() {
        return this._inputs[1];
    }
    /**
     * Gets the second edge operand input component
     */ get edge1() {
        return this._inputs[2];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock() {
        if (!this.value.isConnected || !this.edge0.isConnected || !this.edge1.isConnected) {
            this.output._storedFunction = null;
            this.output._storedValue = null;
            return;
        }
        const func = (value, edge0, edge1)=>{
            const x = Math.max(0, Math.min((value - edge0) / (edge1 - edge0), 1));
            // Smoothstep formula: 3x^2 - 2x^3
            return x * x * (3 - 2 * x);
        };
        this.output._storedFunction = (state)=>{
            const source = this.value.getConnectedValue(state);
            const edge0 = this.edge0.getConnectedValue(state);
            const edge1 = this.edge1.getConnectedValue(state);
            switch(this.value.type){
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int:
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float:
                    return func(source, edge0, edge1);
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector2:
                    return new (0, $ha1VO.Vector2)(func(source.x, edge0, edge1), func(source.y, edge0, edge1));
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3:
                    return new (0, $ha1VO.Vector3)(func(source.x, edge0, edge1), func(source.y, edge0, edge1), func(source.z, edge0, edge1));
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector4:
                    return new (0, $ha1VO.Vector4)(func(source.x, edge0, edge1), func(source.y, edge0, edge1), func(source.z, edge0, edge1), func(source.w, edge0, edge1));
            }
            return 0;
        };
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.GeometrySmoothStepBlock", $b5d7242cac9cdd09$export$4f319d0f26905b27);

});

parcelRegister("lqLlC", function(module, exports) {

$parcel$export(module.exports, "GeometryModBlock", () => $f9a0c0f0bb3e4854$export$a06b11eeafa2d293);

var $ha1VO = parcelRequire("ha1VO");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");
class $f9a0c0f0bb3e4854$export$a06b11eeafa2d293 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Creates a new GeometryModBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this.registerInput("left", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerInput("right", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
        this._linkConnectionTypes(0, 1);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Texture);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "GeometryModBlock";
    }
    /**
     * Gets the left operand input component
     */ get left() {
        return this._inputs[0];
    }
    /**
     * Gets the right operand input component
     */ get right() {
        return this._inputs[1];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock() {
        if (!this.left.isConnected || !this.right.isConnected) {
            this.output._storedFunction = null;
            this.output._storedValue = null;
            return;
        }
        const func = (left, right)=>{
            return left - Math.floor(left / right) * right;
        };
        this.output._storedFunction = (state)=>{
            const left = this.left.getConnectedValue(state);
            const right = this.right.getConnectedValue(state);
            switch(this.left.type){
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int:
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float:
                    return func(left, right);
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector2:
                    return new (0, $ha1VO.Vector2)(func(left.x, right.x), func(left.y, right.y));
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3:
                    return new (0, $ha1VO.Vector3)(func(left.x, right.x), func(left.y, right.y), func(left.z, right.z));
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector4:
                    return new (0, $ha1VO.Vector4)(func(left.x, right.x), func(left.y, right.y), func(left.z, right.z), func(left.w, right.w));
            }
            return 0;
        };
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.GeometryModBlock", $f9a0c0f0bb3e4854$export$a06b11eeafa2d293);

});

parcelRegister("kPUD7", function(module, exports) {

$parcel$export(module.exports, "GeometryPowBlock", () => $f2b47f9b1db7db76$export$822845bd21d90f6a);

var $ha1VO = parcelRequire("ha1VO");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");
class $f2b47f9b1db7db76$export$822845bd21d90f6a extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Creates a new GeometryPowBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this.registerInput("value", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerInput("power", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
        this._linkConnectionTypes(0, 1);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Texture);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "GeometryPowBlock";
    }
    /**
     * Gets the value operand input component
     */ get value() {
        return this._inputs[0];
    }
    /**
     * Gets the power operand input component
     */ get power() {
        return this._inputs[1];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock() {
        if (!this.value.isConnected || !this.power.isConnected) {
            this.output._storedFunction = null;
            this.output._storedValue = null;
            return;
        }
        const func = (value, power)=>{
            return Math.pow(value, power);
        };
        this.output._storedFunction = (state)=>{
            const source = this.value.getConnectedValue(state);
            const power = this.power.getConnectedValue(state);
            switch(this.value.type){
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int:
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float:
                    return func(source, power);
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector2:
                    return new (0, $ha1VO.Vector2)(func(source.x, power), func(source.y, power));
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3:
                    return new (0, $ha1VO.Vector3)(func(source.x, power), func(source.y, power), func(source.z, power));
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector4:
                    return new (0, $ha1VO.Vector4)(func(source.x, power), func(source.y, power), func(source.z, power), func(source.w, power));
            }
            return 0;
        };
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.GeometryPowBlock", $f2b47f9b1db7db76$export$822845bd21d90f6a);

});

parcelRegister("2uBFG", function(module, exports) {

$parcel$export(module.exports, "GeometryClampBlock", () => $1d0b9ad7e627f08e$export$43cf4fb23f20ca26);

var $e0Suo = parcelRequire("e0Suo");

var $8DoUR = parcelRequire("8DoUR");

var $1aXVF = parcelRequire("1aXVF");

var $gJfVN = parcelRequire("gJfVN");

var $4k2Tt = parcelRequire("4k2Tt");

var $ha1VO = parcelRequire("ha1VO");
class $1d0b9ad7e627f08e$export$43cf4fb23f20ca26 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Creates a new GeometryClampBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        /** Gets or sets the minimum range */ this.minimum = 0.0;
        /** Gets or sets the maximum range */ this.maximum = 1.0;
        this.registerInput("value", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Geometry);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Texture);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "GeometryClampBlock";
    }
    /**
     * Gets the value input component
     */ get value() {
        return this._inputs[0];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock() {
        if (!this.value.isConnected) {
            this.output._storedFunction = null;
            this.output._storedValue = null;
            return;
        }
        const func = (value)=>{
            return Math.max(this.minimum, Math.min(value, this.maximum));
        };
        this.output._storedFunction = (state)=>{
            const value = this.value.getConnectedValue(state);
            switch(this.value.type){
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int:
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float:
                    return func(value);
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector2:
                    return new (0, $ha1VO.Vector2)(func(value.x), func(value.y));
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3:
                    return new (0, $ha1VO.Vector3)(func(value.x), func(value.y), func(value.z));
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector4:
                    return new (0, $ha1VO.Vector4)(func(value.x), func(value.y), func(value.z), func(value.w));
            }
            return 0;
        };
        return this;
    }
    _dumpPropertiesCode() {
        let codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.minimum = ${this.minimum};\n`;
        codeString += `${this._codeVariableName}.maximum = ${this.maximum};\n`;
        return codeString;
    }
    serialize() {
        const serializationObject = super.serialize();
        serializationObject.minimum = this.minimum;
        serializationObject.maximum = this.maximum;
        return serializationObject;
    }
    _deserialize(serializationObject) {
        super._deserialize(serializationObject);
        this.minimum = serializationObject.minimum;
        this.maximum = serializationObject.maximum;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Minimum", (0, $1aXVF.PropertyTypeForEdition).Float)
], $1d0b9ad7e627f08e$export$43cf4fb23f20ca26.prototype, "minimum", void 0);
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Maximum", (0, $1aXVF.PropertyTypeForEdition).Float)
], $1d0b9ad7e627f08e$export$43cf4fb23f20ca26.prototype, "maximum", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.GeometryClampBlock", $1d0b9ad7e627f08e$export$43cf4fb23f20ca26);

});

parcelRegister("lJwlI", function(module, exports) {

$parcel$export(module.exports, "GeometryCrossBlock", () => $fd26e4d98db327eb$export$2a2f02e2797bc10);

var $ha1VO = parcelRequire("ha1VO");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");
class $fd26e4d98db327eb$export$2a2f02e2797bc10 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Creates a new GeometryCrossBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this.registerInput("left", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerInput("right", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3);
        this._linkConnectionTypes(0, 1);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector2);
        this._inputs[1].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int);
        this._inputs[1].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
        this._inputs[1].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
        this._inputs[1].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector2);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "GeometryCrossBlock";
    }
    /**
     * Gets the left operand input component
     */ get left() {
        return this._inputs[0];
    }
    /**
     * Gets the right operand input component
     */ get right() {
        return this._inputs[1];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock() {
        if (!this.left.isConnected || !this.right.isConnected) {
            this.output._storedFunction = null;
            this.output._storedValue = null;
            return;
        }
        this.output._storedFunction = (state)=>{
            const left = this.left.getConnectedValue(state);
            const right = this.right.getConnectedValue(state);
            switch(this.left.type){
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3:
                    return (0, $ha1VO.Vector3).Cross(left, right);
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector4:
                    return (0, $ha1VO.Vector3).Cross(left.toVector3(), right.toVector3());
            }
            return 0;
        };
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.GeometryCrossBlock", $fd26e4d98db327eb$export$2a2f02e2797bc10);

});

parcelRegister("gPpPv", function(module, exports) {

$parcel$export(module.exports, "GeometryCurveBlockTypes", () => $c4057209291fe11d$export$6818b98fc6382905);
$parcel$export(module.exports, "GeometryCurveBlock", () => $c4057209291fe11d$export$dd4959fe0fee97c4);

var $e0Suo = parcelRequire("e0Suo");

var $8DoUR = parcelRequire("8DoUR");

var $gJfVN = parcelRequire("gJfVN");

var $4k2Tt = parcelRequire("4k2Tt");

var $ha1VO = parcelRequire("ha1VO");

var $1aXVF = parcelRequire("1aXVF");
var $c4057209291fe11d$export$6818b98fc6382905;
(function(GeometryCurveBlockTypes) {
    /** EaseInSine */ GeometryCurveBlockTypes[GeometryCurveBlockTypes["EaseInSine"] = 0] = "EaseInSine";
    /** EaseOutSine */ GeometryCurveBlockTypes[GeometryCurveBlockTypes["EaseOutSine"] = 1] = "EaseOutSine";
    /** EaseInOutSine */ GeometryCurveBlockTypes[GeometryCurveBlockTypes["EaseInOutSine"] = 2] = "EaseInOutSine";
    /** EaseInQuad */ GeometryCurveBlockTypes[GeometryCurveBlockTypes["EaseInQuad"] = 3] = "EaseInQuad";
    /** EaseOutQuad */ GeometryCurveBlockTypes[GeometryCurveBlockTypes["EaseOutQuad"] = 4] = "EaseOutQuad";
    /** EaseInOutQuad */ GeometryCurveBlockTypes[GeometryCurveBlockTypes["EaseInOutQuad"] = 5] = "EaseInOutQuad";
    /** EaseInCubic */ GeometryCurveBlockTypes[GeometryCurveBlockTypes["EaseInCubic"] = 6] = "EaseInCubic";
    /** EaseOutCubic */ GeometryCurveBlockTypes[GeometryCurveBlockTypes["EaseOutCubic"] = 7] = "EaseOutCubic";
    /** EaseInOutCubic */ GeometryCurveBlockTypes[GeometryCurveBlockTypes["EaseInOutCubic"] = 8] = "EaseInOutCubic";
    /** EaseInQuart */ GeometryCurveBlockTypes[GeometryCurveBlockTypes["EaseInQuart"] = 9] = "EaseInQuart";
    /** EaseOutQuart */ GeometryCurveBlockTypes[GeometryCurveBlockTypes["EaseOutQuart"] = 10] = "EaseOutQuart";
    /** EaseInOutQuart */ GeometryCurveBlockTypes[GeometryCurveBlockTypes["EaseInOutQuart"] = 11] = "EaseInOutQuart";
    /** EaseInQuint */ GeometryCurveBlockTypes[GeometryCurveBlockTypes["EaseInQuint"] = 12] = "EaseInQuint";
    /** EaseOutQuint */ GeometryCurveBlockTypes[GeometryCurveBlockTypes["EaseOutQuint"] = 13] = "EaseOutQuint";
    /** EaseInOutQuint */ GeometryCurveBlockTypes[GeometryCurveBlockTypes["EaseInOutQuint"] = 14] = "EaseInOutQuint";
    /** EaseInExpo */ GeometryCurveBlockTypes[GeometryCurveBlockTypes["EaseInExpo"] = 15] = "EaseInExpo";
    /** EaseOutExpo */ GeometryCurveBlockTypes[GeometryCurveBlockTypes["EaseOutExpo"] = 16] = "EaseOutExpo";
    /** EaseInOutExpo */ GeometryCurveBlockTypes[GeometryCurveBlockTypes["EaseInOutExpo"] = 17] = "EaseInOutExpo";
    /** EaseInCirc */ GeometryCurveBlockTypes[GeometryCurveBlockTypes["EaseInCirc"] = 18] = "EaseInCirc";
    /** EaseOutCirc */ GeometryCurveBlockTypes[GeometryCurveBlockTypes["EaseOutCirc"] = 19] = "EaseOutCirc";
    /** EaseInOutCirc */ GeometryCurveBlockTypes[GeometryCurveBlockTypes["EaseInOutCirc"] = 20] = "EaseInOutCirc";
    /** EaseInBack */ GeometryCurveBlockTypes[GeometryCurveBlockTypes["EaseInBack"] = 21] = "EaseInBack";
    /** EaseOutBack */ GeometryCurveBlockTypes[GeometryCurveBlockTypes["EaseOutBack"] = 22] = "EaseOutBack";
    /** EaseInOutBack */ GeometryCurveBlockTypes[GeometryCurveBlockTypes["EaseInOutBack"] = 23] = "EaseInOutBack";
    /** EaseInElastic */ GeometryCurveBlockTypes[GeometryCurveBlockTypes["EaseInElastic"] = 24] = "EaseInElastic";
    /** EaseOutElastic */ GeometryCurveBlockTypes[GeometryCurveBlockTypes["EaseOutElastic"] = 25] = "EaseOutElastic";
    /** EaseInOutElastic */ GeometryCurveBlockTypes[GeometryCurveBlockTypes["EaseInOutElastic"] = 26] = "EaseInOutElastic";
})($c4057209291fe11d$export$6818b98fc6382905 || ($c4057209291fe11d$export$6818b98fc6382905 = {}));
class $c4057209291fe11d$export$dd4959fe0fee97c4 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Creates a new CurveBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        /**
         * Gets or sets the type of the curve applied by the block
         */ this.type = $c4057209291fe11d$export$6818b98fc6382905.EaseInOutSine;
        this.registerInput("input", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "GeometryCurveBlock";
    }
    /**
     * Gets the input component
     */ get input() {
        return this._inputs[0];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock() {
        if (!this.input.isConnected) {
            this.output._storedFunction = null;
            this.output._storedValue = null;
            return;
        }
        let func;
        switch(this.type){
            case $c4057209291fe11d$export$6818b98fc6382905.EaseInSine:
                func = (v)=>1.0 - Math.cos(v * 3.1415 / 2.0);
                break;
            case $c4057209291fe11d$export$6818b98fc6382905.EaseOutSine:
                func = (v)=>Math.sin(v * 3.1415 / 2.0);
                break;
            case $c4057209291fe11d$export$6818b98fc6382905.EaseInOutSine:
                func = (v)=>-(Math.cos(v * 3.1415) - 1.0) / 2.0;
                break;
            case $c4057209291fe11d$export$6818b98fc6382905.EaseInQuad:
                func = (v)=>v * v;
                break;
            case $c4057209291fe11d$export$6818b98fc6382905.EaseOutQuad:
                func = (v)=>(1.0 - v) * (1.0 - v);
                break;
            case $c4057209291fe11d$export$6818b98fc6382905.EaseInOutQuad:
                func = (v)=>v < 0.5 ? 2.0 * v * v : 1.0 - Math.pow(-2 * v + 2.0, 2.0) / 2.0;
                break;
            case $c4057209291fe11d$export$6818b98fc6382905.EaseInCubic:
                func = (v)=>v * v * v;
                break;
            case $c4057209291fe11d$export$6818b98fc6382905.EaseOutCubic:
                func = (v)=>1.0 - Math.pow(1.0 - v, 3.0);
                break;
            case $c4057209291fe11d$export$6818b98fc6382905.EaseInOutCubic:
                func = (v)=>v < 0.5 ? 4.0 * v * v * v : 1.0 - Math.pow(-2 * v + 2.0, 3.0) / 2.0;
                break;
            case $c4057209291fe11d$export$6818b98fc6382905.EaseInQuart:
                func = (v)=>v * v * v * v;
                break;
            case $c4057209291fe11d$export$6818b98fc6382905.EaseOutQuart:
                func = (v)=>1.0 - Math.pow(1.0 - v, 4.0);
                break;
            case $c4057209291fe11d$export$6818b98fc6382905.EaseInOutQuart:
                func = (v)=>v < 0.5 ? 8.0 * v * v * v * v : 1.0 - Math.pow(-2 * v + 2.0, 4.0) / 2.0;
                break;
            case $c4057209291fe11d$export$6818b98fc6382905.EaseInQuint:
                func = (v)=>v * v * v * v * v;
                break;
            case $c4057209291fe11d$export$6818b98fc6382905.EaseOutQuint:
                func = (v)=>1.0 - Math.pow(1.0 - v, 5.0);
                break;
            case $c4057209291fe11d$export$6818b98fc6382905.EaseInOutQuint:
                func = (v)=>v < 0.5 ? 16.0 * v * v * v * v * v : 1.0 - Math.pow(-2 * v + 2.0, 5.0) / 2.0;
                break;
            case $c4057209291fe11d$export$6818b98fc6382905.EaseInExpo:
                func = (v)=>v === 0.0 ? 0.0 : Math.pow(2.0, 10.0 * v - 10.0);
                break;
            case $c4057209291fe11d$export$6818b98fc6382905.EaseOutExpo:
                func = (v)=>v === 1.0 ? 1.0 : 1.0 - Math.pow(2.0, -10 * v);
                break;
            case $c4057209291fe11d$export$6818b98fc6382905.EaseInOutExpo:
                func = (v)=>v === 0.0 ? 0.0 : v === 1.0 ? 1.0 : v < 0.5 ? Math.pow(2.0, 20.0 * v - 10.0) / 2.0 : (2.0 - Math.pow(2.0, -20 * v + 10.0)) / 2.0;
                break;
            case $c4057209291fe11d$export$6818b98fc6382905.EaseInCirc:
                func = (v)=>1.0 - Math.sqrt(1.0 - Math.pow(v, 2.0));
                break;
            case $c4057209291fe11d$export$6818b98fc6382905.EaseOutCirc:
                func = (v)=>Math.sqrt(1.0 - Math.pow(v - 1.0, 2.0));
                break;
            case $c4057209291fe11d$export$6818b98fc6382905.EaseInOutCirc:
                func = (v)=>v < 0.5 ? (1.0 - Math.sqrt(1.0 - Math.pow(2.0 * v, 2.0))) / 2.0 : (Math.sqrt(1.0 - Math.pow(-2 * v + 2.0, 2.0)) + 1.0) / 2.0;
                break;
            case $c4057209291fe11d$export$6818b98fc6382905.EaseInBack:
                func = (v)=>2.70158 * v * v * v - 1.70158 * v * v;
                break;
            case $c4057209291fe11d$export$6818b98fc6382905.EaseOutBack:
                func = (v)=>2.70158 * Math.pow(v - 1.0, 3.0) + 1.70158 * Math.pow(v - 1.0, 2.0);
                break;
            case $c4057209291fe11d$export$6818b98fc6382905.EaseInOutBack:
                func = (v)=>v < 0.5 ? Math.pow(2.0 * v, 2.0) * (7.189819 * v - 2.5949095) / 2.0 : (Math.pow(2.0 * v - 2.0, 2.0) * (3.5949095 * (v * 2.0 - 2.0) + 3.5949095) + 2.0) / 2.0;
                break;
            case $c4057209291fe11d$export$6818b98fc6382905.EaseInElastic:
                func = (v)=>v === 0.0 ? 0.0 : v === 1.0 ? 1.0 : -Math.pow(2.0, 10.0 * v - 10.0) * Math.sin((v * 10.0 - 10.75) * (6.283 / 3.0));
                break;
            case $c4057209291fe11d$export$6818b98fc6382905.EaseOutElastic:
                func = (v)=>v === 0.0 ? 0.0 : v === 1.0 ? 1.0 : Math.pow(2.0, -10 * v) * Math.sin((v * 10.0 - 0.75) * (6.283 / 3.0)) + 1.0;
                break;
            case $c4057209291fe11d$export$6818b98fc6382905.EaseInOutElastic:
                func = (v)=>v === 0.0 ? 0.0 : v == 1.0 ? 1.0 : v < 0.5 ? -(Math.pow(2.0, 20.0 * v - 10.0) * Math.sin((20.0 * v - 11.125) * (6.283 / 4.5))) / 2.0 : Math.pow(2.0, -20 * v + 10.0) * Math.sin((20.0 * v - 11.125) * (6.283 / 4.5)) / 2.0 + 1.0;
                break;
        }
        this.output._storedFunction = (state)=>{
            const input = this.input.getConnectedValue(state);
            switch(this.input.type){
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float:
                    return func(input);
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector2:
                    return new (0, $ha1VO.Vector2)(func(input.x), func(input.y));
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3:
                    return new (0, $ha1VO.Vector3)(func(input.x), func(input.y), func(input.z));
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector4:
                    return new (0, $ha1VO.Vector4)(func(input.x), func(input.y), func(input.z), func(input.w));
            }
            return 0;
        };
        return this;
    }
    serialize() {
        const serializationObject = super.serialize();
        serializationObject.curveType = this.type;
        return serializationObject;
    }
    _deserialize(serializationObject) {
        super._deserialize(serializationObject);
        this.type = serializationObject.curveType;
    }
    _dumpPropertiesCode() {
        const codeString = super._dumpPropertiesCode() + `${this._codeVariableName}.type = BABYLON.GeometryCurveBlockTypes.${$c4057209291fe11d$export$6818b98fc6382905[this.type]};\n`;
        return codeString;
    }
}
(0, $e0Suo.__decorate)([
    (0, $1aXVF.editableInPropertyPage)("Type", (0, $1aXVF.PropertyTypeForEdition).List, "ADVANCED", {
        notifiers: {
            rebuild: true
        },
        options: [
            {
                label: "EaseInSine",
                value: $c4057209291fe11d$export$6818b98fc6382905.EaseInSine
            },
            {
                label: "EaseOutSine",
                value: $c4057209291fe11d$export$6818b98fc6382905.EaseOutSine
            },
            {
                label: "EaseInOutSine",
                value: $c4057209291fe11d$export$6818b98fc6382905.EaseInOutSine
            },
            {
                label: "EaseInQuad",
                value: $c4057209291fe11d$export$6818b98fc6382905.EaseInQuad
            },
            {
                label: "EaseOutQuad",
                value: $c4057209291fe11d$export$6818b98fc6382905.EaseOutQuad
            },
            {
                label: "EaseInOutQuad",
                value: $c4057209291fe11d$export$6818b98fc6382905.EaseInOutQuad
            },
            {
                label: "EaseInCubic",
                value: $c4057209291fe11d$export$6818b98fc6382905.EaseInCubic
            },
            {
                label: "EaseOutCubic",
                value: $c4057209291fe11d$export$6818b98fc6382905.EaseOutCubic
            },
            {
                label: "EaseInOutCubic",
                value: $c4057209291fe11d$export$6818b98fc6382905.EaseInOutCubic
            },
            {
                label: "EaseInQuart",
                value: $c4057209291fe11d$export$6818b98fc6382905.EaseInQuart
            },
            {
                label: "EaseOutQuart",
                value: $c4057209291fe11d$export$6818b98fc6382905.EaseOutQuart
            },
            {
                label: "EaseInOutQuart",
                value: $c4057209291fe11d$export$6818b98fc6382905.EaseInOutQuart
            },
            {
                label: "EaseInQuint",
                value: $c4057209291fe11d$export$6818b98fc6382905.EaseInQuint
            },
            {
                label: "EaseOutQuint",
                value: $c4057209291fe11d$export$6818b98fc6382905.EaseOutQuint
            },
            {
                label: "EaseInOutQuint",
                value: $c4057209291fe11d$export$6818b98fc6382905.EaseInOutQuint
            },
            {
                label: "EaseInExpo",
                value: $c4057209291fe11d$export$6818b98fc6382905.EaseInExpo
            },
            {
                label: "EaseOutExpo",
                value: $c4057209291fe11d$export$6818b98fc6382905.EaseOutExpo
            },
            {
                label: "EaseInOutExpo",
                value: $c4057209291fe11d$export$6818b98fc6382905.EaseInOutExpo
            },
            {
                label: "EaseInCirc",
                value: $c4057209291fe11d$export$6818b98fc6382905.EaseInCirc
            },
            {
                label: "EaseOutCirc",
                value: $c4057209291fe11d$export$6818b98fc6382905.EaseOutCirc
            },
            {
                label: "EaseInOutCirc",
                value: $c4057209291fe11d$export$6818b98fc6382905.EaseInOutCirc
            },
            {
                label: "EaseInBack",
                value: $c4057209291fe11d$export$6818b98fc6382905.EaseInBack
            },
            {
                label: "EaseOutBack",
                value: $c4057209291fe11d$export$6818b98fc6382905.EaseOutBack
            },
            {
                label: "EaseInOutBack",
                value: $c4057209291fe11d$export$6818b98fc6382905.EaseInOutBack
            },
            {
                label: "EaseInElastic",
                value: $c4057209291fe11d$export$6818b98fc6382905.EaseInElastic
            },
            {
                label: "EaseOutElastic",
                value: $c4057209291fe11d$export$6818b98fc6382905.EaseOutElastic
            },
            {
                label: "EaseInOutElastic",
                value: $c4057209291fe11d$export$6818b98fc6382905.EaseInOutElastic
            }
        ]
    })
], $c4057209291fe11d$export$dd4959fe0fee97c4.prototype, "type", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.GeometryCurveBlock", $c4057209291fe11d$export$dd4959fe0fee97c4);

});

parcelRegister("1NNxM", function(module, exports) {

$parcel$export(module.exports, "GeometryDesaturateBlock", () => $1500cc68125923e6$export$e92d33dd0237d457);

var $ha1VO = parcelRequire("ha1VO");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");
class $1500cc68125923e6$export$e92d33dd0237d457 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Creates a new GeometryDesaturateBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this.registerInput("color", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3);
        this.registerInput("level", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float, true, 0);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "GeometryDesaturateBlock";
    }
    /**
     * Gets the color operand input component
     */ get color() {
        return this._inputs[0];
    }
    /**
     * Gets the level operand input component
     */ get level() {
        return this._inputs[1];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock() {
        if (!this.color.isConnected) {
            this.output._storedFunction = null;
            this.output._storedValue = null;
            return;
        }
        this.output._storedFunction = (state)=>{
            const color = this.color.getConnectedValue(state);
            const level = this.level.getConnectedValue(state);
            const tempMin = Math.min(color.x, color.y, color.z);
            const tempMax = Math.max(color.x, color.y, color.z);
            const tempMerge = 0.5 * (tempMin + tempMax);
            return new (0, $ha1VO.Vector3)(color.x * (1 - level) + tempMerge * level, color.y * (1 - level) + tempMerge * level, color.z * (1 - level) + tempMerge * level);
        };
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.GeometryDesaturateBlock", $1500cc68125923e6$export$e92d33dd0237d457);

});

parcelRegister("7r4nc", function(module, exports) {

$parcel$export(module.exports, "GeometryPosterizeBlock", () => $569e7275efaf29f6$export$cfde6ee388eac5fd);

var $ha1VO = parcelRequire("ha1VO");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");
class $569e7275efaf29f6$export$cfde6ee388eac5fd extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Creates a new GeometryPosterizeBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this.registerInput("value", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerInput("steps", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
        this._linkConnectionTypes(0, 1);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
        this._inputs[1].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
        this._inputs[1].acceptedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "GeometryPosterizeBlock";
    }
    /**
     * Gets the value input component
     */ get value() {
        return this._inputs[0];
    }
    /**
     * Gets the steps input component
     */ get steps() {
        return this._inputs[1];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock() {
        if (!this.value.isConnected || !this.steps.isConnected) {
            this.output._storedFunction = null;
            this.output._storedValue = null;
            return;
        }
        this.output._storedFunction = (state)=>{
            const source = this.value.getConnectedValue(state);
            const steps = this.steps.getConnectedValue(state);
            let stepVector = steps;
            if (this.steps.type === (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float) switch(this.value.type){
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector2:
                    stepVector = new (0, $ha1VO.Vector2)(steps, steps);
                    break;
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3:
                    stepVector = new (0, $ha1VO.Vector3)(steps, steps, steps);
                    break;
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector4:
                    stepVector = new (0, $ha1VO.Vector4)(steps, steps, steps, steps);
                    break;
            }
            switch(this.value.type){
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector2:
                    return new (0, $ha1VO.Vector2)(source.x / (1.0 / stepVector.x) * (1.0 / stepVector.x), source.y / (1.0 / stepVector.y) * (1.0 / stepVector.y));
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector3:
                    return new (0, $ha1VO.Vector3)(source.x / (1.0 / stepVector.x) * (1.0 / stepVector.x), source.y / (1.0 / stepVector.y) * (1.0 / stepVector.y), source.z / (1.0 / stepVector.z) * (1.0 / stepVector.z));
                case (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector4:
                    return new (0, $ha1VO.Vector4)(source.x / (1.0 / stepVector.x) * (1.0 / stepVector.x), source.y / (1.0 / stepVector.y) * (1.0 / stepVector.y), source.z / (1.0 / stepVector.z) * (1.0 / stepVector.z), source.w / (1.0 / stepVector.w) * (1.0 / stepVector.w));
                default:
                    return Math.floor(source / (1.0 / steps) * (1.0 / steps));
            }
        };
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.GeometryPosterizeBlock", $569e7275efaf29f6$export$cfde6ee388eac5fd);

});

parcelRegister("3F1M9", function(module, exports) {

$parcel$export(module.exports, "GeometryReplaceColorBlock", () => $2aa6940d0617f525$export$be581026c61ddd3);

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");
class $2aa6940d0617f525$export$be581026c61ddd3 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Creates a new GeometryReplaceColorBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this.registerInput("value", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerInput("reference", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerInput("distance", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
        this.registerInput("replacement", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).BasedOnInput);
        this._outputs[0]._typeConnectionSource = this._inputs[0];
        this._linkConnectionTypes(0, 1);
        this._linkConnectionTypes(0, 3);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
        this._inputs[1].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
        this._inputs[1].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
        this._inputs[3].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
        this._inputs[3].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "GeometryReplaceColorBlock";
    }
    /**
     * Gets the value input component
     */ get value() {
        return this._inputs[0];
    }
    /**
     * Gets the reference input component
     */ get reference() {
        return this._inputs[1];
    }
    /**
     * Gets the distance input component
     */ get distance() {
        return this._inputs[2];
    }
    /**
     * Gets the replacement input component
     */ get replacement() {
        return this._inputs[3];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock() {
        if (!this.value.isConnected || !this.reference.isConnected || !this.distance.isConnected || !this.replacement.isConnected) {
            this.output._storedFunction = null;
            this.output._storedValue = null;
            return;
        }
        this.output._storedFunction = (state)=>{
            const value = this.value.getConnectedValue(state);
            const reference = this.reference.getConnectedValue(state);
            const distance = this.distance.getConnectedValue(state);
            const replacement = this.replacement.getConnectedValue(state);
            if (value.subtract(reference).length() < distance) return replacement;
            else return value;
        };
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.GeometryReplaceColorBlock", $2aa6940d0617f525$export$be581026c61ddd3);

});

parcelRegister("59Ae6", function(module, exports) {

$parcel$export(module.exports, "GeometryDistanceBlock", () => $3c09e4db165714f7$export$506652408dae2a4b);

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");
class $3c09e4db165714f7$export$506652408dae2a4b extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Creates a new GeometryDistanceBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this.registerInput("left", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerInput("right", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
        this._linkConnectionTypes(0, 1);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
        this._inputs[1].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
        this._inputs[1].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "GeometryDistanceBlock";
    }
    /**
     * Gets the left operand input component
     */ get left() {
        return this._inputs[0];
    }
    /**
     * Gets the right operand input component
     */ get right() {
        return this._inputs[1];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock() {
        if (!this.left.isConnected || !this.right.isConnected) {
            this.output._storedFunction = null;
            this.output._storedValue = null;
            return;
        }
        this.output._storedFunction = (state)=>{
            const left = this.left.getConnectedValue(state);
            const right = this.right.getConnectedValue(state);
            return left.subtract(right).length();
        };
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.GeometryDistanceBlock", $3c09e4db165714f7$export$506652408dae2a4b);

});

parcelRegister("iIMB4", function(module, exports) {

$parcel$export(module.exports, "GeometryDotBlock", () => $da120861997be332$export$7339a31cc5d827e3);

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");
class $da120861997be332$export$7339a31cc5d827e3 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Creates a new GeometryDotBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this.registerInput("left", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerInput("right", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
        this._linkConnectionTypes(0, 1);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
        this._inputs[1].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
        this._inputs[1].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "GeometryDotBlock";
    }
    /**
     * Gets the left operand input component
     */ get left() {
        return this._inputs[0];
    }
    /**
     * Gets the right operand input component
     */ get right() {
        return this._inputs[1];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock() {
        if (!this.left.isConnected || !this.right.isConnected) {
            this.output._storedFunction = null;
            this.output._storedValue = null;
            return;
        }
        this.output._storedFunction = (state)=>{
            const left = this.left.getConnectedValue(state);
            const right = this.right.getConnectedValue(state);
            return left.dot(right);
        };
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.GeometryDotBlock", $da120861997be332$export$7339a31cc5d827e3);

});

parcelRegister("6HgjP", function(module, exports) {

$parcel$export(module.exports, "GeometryLengthBlock", () => $4e036acbd2c5a084$export$42f1e1cbeb305d33);

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");
class $4e036acbd2c5a084$export$42f1e1cbeb305d33 extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Creates a new GeometryLengthBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this.registerInput("value", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).AutoDetect);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Int);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
        this._inputs[0].excludedConnectionPointTypes.push((0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Matrix);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "GeometryLengthBlock";
    }
    /**
     * Gets the value input component
     */ get value() {
        return this._inputs[0];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock() {
        if (!this.value.isConnected) {
            this.output._storedFunction = null;
            this.output._storedValue = null;
            return;
        }
        this.output._storedFunction = (state)=>{
            const value = this.value.getConnectedValue(state);
            return value.length();
        };
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.GeometryLengthBlock", $4e036acbd2c5a084$export$42f1e1cbeb305d33);

});

parcelRegister("72nAM", function(module, exports) {

$parcel$export(module.exports, "GeometryRotate2dBlock", () => $51fb05410049b4d7$export$6a00d8399a5358ef);

var $ha1VO = parcelRequire("ha1VO");

var $8DoUR = parcelRequire("8DoUR");

var $4k2Tt = parcelRequire("4k2Tt");

var $gJfVN = parcelRequire("gJfVN");
class $51fb05410049b4d7$export$6a00d8399a5358ef extends (0, $gJfVN.NodeGeometryBlock) {
    /**
     * Creates a new GeometryRotate2dBlock
     * @param name defines the block name
     */ constructor(name){
        super(name);
        this.registerInput("input", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector2);
        this.registerInput("angle", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Float);
        this.registerOutput("output", (0, $4k2Tt.NodeGeometryBlockConnectionPointTypes).Vector2);
    }
    /**
     * Gets the current class name
     * @returns the class name
     */ getClassName() {
        return "GeometryRotate2dBlock";
    }
    /**
     * Gets the input vector
     */ get input() {
        return this._inputs[0];
    }
    /**
     * Gets the input angle
     */ get angle() {
        return this._inputs[1];
    }
    /**
     * Gets the output component
     */ get output() {
        return this._outputs[0];
    }
    _buildBlock() {
        if (!this.angle.isConnected || !this.input.isConnected) {
            this.output._storedFunction = null;
            this.output._storedValue = null;
            return;
        }
        this.output._storedFunction = (state)=>{
            const input = this.input.getConnectedValue(state);
            const angle = this.angle.getConnectedValue(state);
            return new (0, $ha1VO.Vector2)(Math.cos(angle) * input.x - Math.sin(angle) * input.y, Math.sin(angle) * input.x + Math.cos(angle) * input.y);
        };
        return this;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.GeometryRotate2dBlock", $51fb05410049b4d7$export$6a00d8399a5358ef);

});


parcelRegister("hvUJP", function(module, exports) {

$parcel$export(module.exports, "GaussianSplattingMesh", () => $cc0157ea8c68f4dc$export$f2829e7c030c5b43);

var $lEBSs = parcelRequire("lEBSs");

var $fbuqw = parcelRequire("fbuqw");

var $5v6ry = parcelRequire("5v6ry");

var $bOhSV = parcelRequire("bOhSV");

var $ha1VO = parcelRequire("ha1VO");

var $kVtWi = parcelRequire("kVtWi");

var $6wUCE = parcelRequire("6wUCE");

var $5Egpj = parcelRequire("5Egpj");
class $cc0157ea8c68f4dc$export$f2829e7c030c5b43 extends (0, $fbuqw.Mesh) {
    /**
     * Gets the covariancesA texture
     */ get covariancesATexture() {
        return this._covariancesATexture;
    }
    /**
     * Gets the covariancesB texture
     */ get covariancesBTexture() {
        return this._covariancesBTexture;
    }
    /**
     * Gets the centers texture
     */ get centersTexture() {
        return this._centersTexture;
    }
    /**
     * Gets the colors texture
     */ get colorsTexture() {
        return this._colorsTexture;
    }
    /**
     * Creates a new gaussian splatting mesh
     * @param name defines the name of the mesh
     * @param url defines the url to load from (optional)
     * @param scene defines the hosting scene (optional)
     */ constructor(name, url = null, scene = null){
        super(name, scene);
        this._vertexCount = 0;
        this._worker = null;
        this._frameIdLastUpdate = -1;
        this._modelViewMatrix = (0, $ha1VO.Matrix).Identity();
        this._material = null;
        this._canPostToWorker = true;
        this._covariancesATexture = null;
        this._covariancesBTexture = null;
        this._centersTexture = null;
        this._colorsTexture = null;
        const vertexData = new (0, $5v6ry.VertexData)();
        vertexData.positions = [
            -2,
            -2,
            0,
            2,
            -2,
            0,
            2,
            2,
            0,
            -2,
            2,
            0
        ];
        vertexData.indices = [
            0,
            1,
            2,
            0,
            2,
            3
        ];
        vertexData.applyToMesh(this);
        this.subMeshes = [];
        new (0, $lEBSs.SubMesh)(0, 0, 4, 0, 6, this);
        this.doNotSyncBoundingInfo = true;
        this.setEnabled(false);
        this._lastProj = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        if (url) this.loadFileAsync(url);
    }
    /**
     * Returns the class name
     * @returns "GaussianSplattingMesh"
     */ getClassName() {
        return "GaussianSplattingMesh";
    }
    /**
     * Returns the total number of vertices (splats) within the mesh
     * @returns the total number of vertices
     */ getTotalVertices() {
        return this._vertexCount;
    }
    /**
     * Triggers the draw call for the mesh. Usually, you don't need to call this method by your own because the mesh rendering is handled by the scene rendering manager
     * @param subMesh defines the subMesh to render
     * @param enableAlphaMode defines if alpha mode can be changed
     * @param effectiveMeshReplacement defines an optional mesh used to provide info for the rendering
     * @returns the current mesh
     */ render(subMesh, enableAlphaMode, effectiveMeshReplacement) {
        if (!this.material) {
            this._material = new (0, $6wUCE.GaussianSplattingMaterial)(this.name + "_material", this._scene);
            this.material = this._material;
        }
        const frameId = this.getScene().getFrameId();
        if (frameId !== this._frameIdLastUpdate && this._worker && this._scene.activeCamera && this._canPostToWorker) {
            this.getWorldMatrix().multiplyToRef(this._scene.activeCamera.getViewMatrix(), this._modelViewMatrix);
            const dot = this._lastProj[2] * this._modelViewMatrix.m[2] + this._lastProj[6] * this._modelViewMatrix.m[6] + this._lastProj[10] * this._modelViewMatrix.m[10];
            if (Math.abs(dot - 1) >= 0.01) {
                this._frameIdLastUpdate = frameId;
                this._canPostToWorker = false;
                this._lastProj = this._modelViewMatrix.m.slice(0);
                this._worker.postMessage({
                    view: this._modelViewMatrix.m,
                    depthMix: this._depthMix
                }, [
                    this._depthMix.buffer
                ]);
            }
        }
        return super.render(subMesh, enableAlphaMode, effectiveMeshReplacement);
    }
    /**
     * Code from https://github.com/dylanebert/gsplat.js/blob/main/src/loaders/PLYLoader.ts Under MIT license
     * Converts a .ply data array buffer to splat
     * if data array buffer is not ply, returns the original buffer
     * @param data the .ply data to load
     * @returns the loaded splat buffer
     */ static ConvertPLYToSplat(data) {
        const ubuf = new Uint8Array(data);
        const header = new TextDecoder().decode(ubuf.slice(0, 10240));
        const headerEnd = "end_header\n";
        const headerEndIndex = header.indexOf(headerEnd);
        if (headerEndIndex < 0 || !header) return data;
        const vertexCount = parseInt(/element vertex (\d+)\n/.exec(header)[1]);
        let rowOffset = 0;
        const offsets = {
            double: 8,
            int: 4,
            uint: 4,
            float: 4,
            short: 2,
            ushort: 2,
            uchar: 1
        };
        const properties = [];
        const filtered = header.slice(0, headerEndIndex).split("\n").filter((k)=>k.startsWith("property "));
        for (const prop of filtered){
            const [, type, name] = prop.split(" ");
            properties.push({
                name: name,
                type: type,
                offset: rowOffset
            });
            if (offsets[type]) rowOffset += offsets[type];
            else {
                (0, $kVtWi.Logger).Error(`Unsupported property type: ${type}. Are you sure it's a valid Gaussian Splatting file?`);
                return new ArrayBuffer(0);
            }
        }
        const rowLength = 32;
        const SH_C0 = 0.28209479177387814;
        const dataView = new DataView(data, headerEndIndex + headerEnd.length);
        const buffer = new ArrayBuffer(rowLength * vertexCount);
        const q = new (0, $ha1VO.Quaternion)();
        for(let i = 0; i < vertexCount; i++){
            const position = new Float32Array(buffer, i * rowLength, 3);
            const scale = new Float32Array(buffer, i * rowLength + 12, 3);
            const rgba = new Uint8ClampedArray(buffer, i * rowLength + 24, 4);
            const rot = new Uint8ClampedArray(buffer, i * rowLength + 28, 4);
            let r0 = 255;
            let r1 = 0;
            let r2 = 0;
            let r3 = 0;
            for(let propertyIndex = 0; propertyIndex < properties.length; propertyIndex++){
                const property = properties[propertyIndex];
                let value;
                switch(property.type){
                    case "float":
                        value = dataView.getFloat32(property.offset + i * rowOffset, true);
                        break;
                    case "int":
                        value = dataView.getInt32(property.offset + i * rowOffset, true);
                        break;
                    default:
                        throw new Error(`Unsupported property type: ${property.type}`);
                }
                switch(property.name){
                    case "x":
                        position[0] = value;
                        break;
                    case "y":
                        position[1] = value;
                        break;
                    case "z":
                        position[2] = value;
                        break;
                    case "scale_0":
                        scale[0] = Math.exp(value);
                        break;
                    case "scale_1":
                        scale[1] = Math.exp(value);
                        break;
                    case "scale_2":
                        scale[2] = Math.exp(value);
                        break;
                    case "red":
                        rgba[0] = value;
                        break;
                    case "green":
                        rgba[1] = value;
                        break;
                    case "blue":
                        rgba[2] = value;
                        break;
                    case "f_dc_0":
                        rgba[0] = (0.5 + SH_C0 * value) * 255;
                        break;
                    case "f_dc_1":
                        rgba[1] = (0.5 + SH_C0 * value) * 255;
                        break;
                    case "f_dc_2":
                        rgba[2] = (0.5 + SH_C0 * value) * 255;
                        break;
                    case "f_dc_3":
                        rgba[3] = (0.5 + SH_C0 * value) * 255;
                        break;
                    case "opacity":
                        rgba[3] = 1 / (1 + Math.exp(-value)) * 255;
                        break;
                    case "rot_0":
                        r0 = value;
                        break;
                    case "rot_1":
                        r1 = value;
                        break;
                    case "rot_2":
                        r2 = value;
                        break;
                    case "rot_3":
                        r3 = value;
                        break;
                }
            }
            q.set(r1, r2, r3, r0);
            q.normalize();
            rot[0] = q.w * 128 + 128;
            rot[1] = q.x * 128 + 128;
            rot[2] = q.y * 128 + 128;
            rot[3] = q.z * 128 + 128;
        }
        return buffer;
    }
    /**
     * Loads a .splat Gaussian Splatting array buffer asynchronously
     * @param data arraybuffer containing splat file
     * @returns a promise that resolves when the operation is complete
     */ loadDataAsync(data) {
        return Promise.resolve(this._loadData(data));
    }
    /**
     * Loads a .splat Gaussian or .ply Splatting file asynchronously
     * @param url path to the splat file to load
     * @returns a promise that resolves when the operation is complete
     */ loadFileAsync(url) {
        return (0, $bOhSV.Tools).LoadFileAsync(url, true).then((data)=>{
            this._loadData($cc0157ea8c68f4dc$export$f2829e7c030c5b43.ConvertPLYToSplat(data));
        });
    }
    /**
     * Releases resources associated with this mesh.
     * @param doNotRecurse Set to true to not recurse into each children (recurse into each children by default)
     */ dispose(doNotRecurse) {
        this._covariancesATexture?.dispose();
        this._covariancesBTexture?.dispose();
        this._centersTexture?.dispose();
        this._colorsTexture?.dispose();
        this._covariancesATexture = null;
        this._covariancesBTexture = null;
        this._centersTexture = null;
        this._colorsTexture = null;
        this._material?.dispose(false, true);
        this._material = null;
        this._worker?.terminate();
        this._worker = null;
        super.dispose(doNotRecurse);
    }
    _loadData(data) {
        if (!data.byteLength) return;
        // Parse the data
        const uBuffer = new Uint8Array(data);
        const fBuffer = new Float32Array(uBuffer.buffer);
        const rowLength = 32;
        const vertexCount = uBuffer.length / rowLength;
        this._vertexCount = vertexCount;
        const textureSize = this._getTextureSize(vertexCount);
        const textureLength = textureSize.x * textureSize.y;
        const positions = new Float32Array(3 * textureLength);
        const covA = new Float32Array(3 * textureLength);
        const covB = new Float32Array(3 * textureLength);
        const matrixRotation = (0, $ha1VO.TmpVectors).Matrix[0];
        const matrixScale = (0, $ha1VO.TmpVectors).Matrix[1];
        const quaternion = (0, $ha1VO.TmpVectors).Quaternion[0];
        const minimum = new (0, $ha1VO.Vector3)(Number.MAX_VALUE, Number.MAX_VALUE, Number.MAX_VALUE);
        const maximum = new (0, $ha1VO.Vector3)(-Number.MAX_VALUE, -Number.MAX_VALUE, -Number.MAX_VALUE);
        for(let i = 0; i < vertexCount; i++){
            const x = fBuffer[8 * i + 0];
            const y = -fBuffer[8 * i + 1];
            const z = fBuffer[8 * i + 2];
            positions[3 * i + 0] = x;
            positions[3 * i + 1] = y;
            positions[3 * i + 2] = z;
            minimum.minimizeInPlaceFromFloats(x, y, z);
            maximum.maximizeInPlaceFromFloats(x, y, z);
            quaternion.set((uBuffer[32 * i + 28 + 1] - 128) / 128, (uBuffer[32 * i + 28 + 2] - 128) / 128, (uBuffer[32 * i + 28 + 3] - 128) / 128, -(uBuffer[32 * i + 28 + 0] - 128) / 128);
            quaternion.toRotationMatrix(matrixRotation);
            (0, $ha1VO.Matrix).ScalingToRef(fBuffer[8 * i + 3 + 0] * 2, fBuffer[8 * i + 3 + 1] * 2, fBuffer[8 * i + 3 + 2] * 2, matrixScale);
            const M = matrixRotation.multiplyToRef(matrixScale, (0, $ha1VO.TmpVectors).Matrix[0]).m;
            covA[i * 3 + 0] = M[0] * M[0] + M[1] * M[1] + M[2] * M[2];
            covA[i * 3 + 1] = M[0] * M[4] + M[1] * M[5] + M[2] * M[6];
            covA[i * 3 + 2] = M[0] * M[8] + M[1] * M[9] + M[2] * M[10];
            covB[i * 3 + 0] = M[4] * M[4] + M[5] * M[5] + M[6] * M[6];
            covB[i * 3 + 1] = M[4] * M[8] + M[5] * M[9] + M[6] * M[10];
            covB[i * 3 + 2] = M[8] * M[8] + M[9] * M[9] + M[10] * M[10];
        }
        // Update the mesh
        const binfo = this.getBoundingInfo();
        binfo.reConstruct(minimum, maximum, this.getWorldMatrix());
        binfo.isLocked = true;
        this.forcedInstanceCount = this._vertexCount;
        this.setEnabled(true);
        const splatIndex = new Float32Array(this._vertexCount * 1);
        this.thinInstanceSetBuffer("splatIndex", splatIndex, 1, false);
        // Update the material
        const createTextureFromData = (data, width, height, format)=>{
            return new (0, $5Egpj.RawTexture)(data, width, height, format, this._scene, false, false, 2, 1);
        };
        const convertRgbToRgba = (rgb)=>{
            const count = rgb.length / 3;
            const rgba = new Float32Array(count * 4);
            for(let i = 0; i < count; ++i){
                rgba[i * 4 + 0] = rgb[i * 3 + 0];
                rgba[i * 4 + 1] = rgb[i * 3 + 1];
                rgba[i * 4 + 2] = rgb[i * 3 + 2];
                rgba[i * 4 + 3] = 1.0;
            }
            return rgba;
        };
        const colorArray = new Float32Array(textureSize.x * textureSize.y * 4);
        for(let i = 0; i < this._vertexCount; ++i){
            colorArray[i * 4 + 0] = uBuffer[32 * i + 24 + 0] / 255;
            colorArray[i * 4 + 1] = uBuffer[32 * i + 24 + 1] / 255;
            colorArray[i * 4 + 2] = uBuffer[32 * i + 24 + 2] / 255;
            colorArray[i * 4 + 3] = uBuffer[32 * i + 24 + 3] / 255;
        }
        this._covariancesATexture = createTextureFromData(convertRgbToRgba(covA), textureSize.x, textureSize.y, 5);
        this._covariancesBTexture = createTextureFromData(convertRgbToRgba(covB), textureSize.x, textureSize.y, 5);
        this._centersTexture = createTextureFromData(convertRgbToRgba(positions), textureSize.x, textureSize.y, 5);
        this._colorsTexture = createTextureFromData(colorArray, textureSize.x, textureSize.y, 5);
        // Start the worker thread
        this._worker?.terminate();
        this._worker = new Worker(URL.createObjectURL(new Blob([
            "(",
            $cc0157ea8c68f4dc$export$f2829e7c030c5b43._CreateWorker.toString(),
            ")(self)"
        ], {
            type: "application/javascript"
        })));
        this._depthMix = new BigInt64Array(vertexCount);
        this._worker.postMessage({
            positions: positions,
            vertexCount: vertexCount
        }, [
            positions.buffer
        ]);
        this._worker.onmessage = (e)=>{
            this._depthMix = e.data.depthMix;
            const indexMix = new Uint32Array(e.data.depthMix.buffer);
            for(let j = 0; j < this._vertexCount; j++)splatIndex[j] = indexMix[2 * j];
            this.thinInstanceBufferUpdated("splatIndex");
            this._canPostToWorker = true;
        };
    }
    _getTextureSize(length) {
        const engine = this._scene.getEngine();
        const width = engine.getCaps().maxTextureSize;
        let height = 1;
        if (engine.webGLVersion === 1 && !engine.isWebGPU) while(width * height < length)height *= 2;
        else height = Math.ceil(length / width);
        if (height > width) {
            (0, $kVtWi.Logger).Error("GaussianSplatting texture size: (" + width + ", " + height + "), maxTextureSize: " + width);
            height = width;
        }
        return new (0, $ha1VO.Vector2)(width, height);
    }
}
$cc0157ea8c68f4dc$export$f2829e7c030c5b43._CreateWorker = function(self) {
    let vertexCount = 0;
    let positions;
    let depthMix;
    let indices;
    let floatMix;
    self.onmessage = (e)=>{
        // updated on init
        if (e.data.positions) {
            positions = e.data.positions;
            vertexCount = e.data.vertexCount;
        } else {
            const viewProj = e.data.view;
            if (!positions || !viewProj) // Sanity check, it shouldn't happen!
            throw new Error("positions or view is not defined!");
            depthMix = e.data.depthMix;
            indices = new Uint32Array(depthMix.buffer);
            floatMix = new Float32Array(depthMix.buffer);
            // Sort
            for(let j = 0; j < vertexCount; j++)indices[2 * j] = j;
            for(let j = 0; j < vertexCount; j++)floatMix[2 * j + 1] = 10000 - (viewProj[2] * positions[3 * j + 0] + viewProj[6] * positions[3 * j + 1] + viewProj[10] * positions[3 * j + 2]);
            depthMix.sort();
            self.postMessage({
                depthMix: depthMix
            }, [
                depthMix.buffer
            ]);
        }
    };
};

});


parcelRegister("2kwDx", function(module, exports) {

var $1oI71 = parcelRequire("1oI71");

var $c9v5E = parcelRequire("c9v5E");
$parcel$exportWildcard(module.exports, $1oI71);
$parcel$exportWildcard(module.exports, $c9v5E);

});

parcelRegister("lacby", function(module, exports) {
/* eslint-disable import/no-internal-modules */ 
var $eWQiR = parcelRequire("eWQiR");

var $5MBff = parcelRequire("5MBff");
$parcel$exportWildcard(module.exports, $eWQiR);
$parcel$exportWildcard(module.exports, $5MBff);

});
parcelRegister("eWQiR", function(module, exports) {

});

parcelRegister("5MBff", function(module, exports) {

var $5YeRN = parcelRequire("5YeRN");
$parcel$exportWildcard(module.exports, $5YeRN);

});
parcelRegister("5YeRN", function(module, exports) {

$parcel$export(module.exports, "RecastJSPlugin", () => $458e1691e7407e45$export$670b657e2a1ca3f1);
$parcel$export(module.exports, "RecastJSCrowd", () => $458e1691e7407e45$export$37dd14fcbe6b4741);

var $kVtWi = parcelRequire("kVtWi");

var $5v6ry = parcelRequire("5v6ry");

var $fbuqw = parcelRequire("fbuqw");
parcelRequire("6rxfP");
var $53VPf = parcelRequire("53VPf");
var $ha1VO = parcelRequire("ha1VO");

var $diGQf = parcelRequire("diGQf");

var $b4i1f = parcelRequire("b4i1f");
class $458e1691e7407e45$export$670b657e2a1ca3f1 {
    /**
     * Initializes the recastJS plugin
     * @param recastInjection can be used to inject your own recast reference
     */ constructor(recastInjection = Recast){
        /**
         * Reference to the Recast library
         */ this.bjsRECAST = {};
        /**
         * plugin name
         */ this.name = "RecastJSPlugin";
        this._maximumSubStepCount = 10;
        this._timeStep = 1 / 60;
        this._timeFactor = 1;
        this._worker = null;
        if (typeof recastInjection === "function") (0, $kVtWi.Logger).Error("RecastJS is not ready. Please make sure you await Recast() before using the plugin.");
        else this.bjsRECAST = recastInjection;
        if (!this.isSupported()) {
            (0, $kVtWi.Logger).Error("RecastJS is not available. Please make sure you included the js file.");
            return;
        }
        this.setTimeStep();
        this._tempVec1 = new this.bjsRECAST.Vec3();
        this._tempVec2 = new this.bjsRECAST.Vec3();
    }
    /**
     * Set worker URL to be used when generating a new navmesh
     * @param workerURL url string
     * @returns boolean indicating if worker is created
     */ setWorkerURL(workerURL) {
        if (window && window.Worker) {
            this._worker = new Worker(workerURL);
            return true;
        }
        return false;
    }
    /**
     * Set the time step of the navigation tick update.
     * Default is 1/60.
     * A value of 0 will disable fixed time update
     * @param newTimeStep the new timestep to apply to this world.
     */ setTimeStep(newTimeStep = 1 / 60) {
        this._timeStep = newTimeStep;
    }
    /**
     * Get the time step of the navigation tick update.
     * @returns the current time step
     */ getTimeStep() {
        return this._timeStep;
    }
    /**
     * If delta time in navigation tick update is greater than the time step
     * a number of sub iterations are done. If more iterations are need to reach deltatime
     * they will be discarded.
     * A value of 0 will set to no maximum and update will use as many substeps as needed
     * @param newStepCount the maximum number of iterations
     */ setMaximumSubStepCount(newStepCount = 10) {
        this._maximumSubStepCount = newStepCount;
    }
    /**
     * Get the maximum number of iterations per navigation tick update
     * @returns the maximum number of iterations
     */ getMaximumSubStepCount() {
        return this._maximumSubStepCount;
    }
    /**
     * Time factor applied when updating crowd agents (default 1). A value of 0 will pause crowd updates.
     * @param value the time factor applied at update
     */ set timeFactor(value) {
        this._timeFactor = Math.max(value, 0);
    }
    /**
     * Get the time factor used for crowd agent update
     * @returns the time factor
     */ get timeFactor() {
        return this._timeFactor;
    }
    /**
     * Creates a navigation mesh
     * @param meshes array of all the geometry used to compute the navigation mesh
     * @param parameters bunch of parameters used to filter geometry
     * @param completion callback when data is available from the worker. Not used without a worker
     */ createNavMesh(meshes, parameters, completion) {
        if (this._worker && !completion) (0, $kVtWi.Logger).Warn("A worker is avaible but no completion callback. Defaulting to blocking navmesh creation");
        else if (!this._worker && completion) (0, $kVtWi.Logger).Warn("A completion callback is avaible but no worker. Defaulting to blocking navmesh creation");
        this.navMesh = new this.bjsRECAST.NavMesh();
        let index;
        let tri;
        let pt;
        const indices = [];
        const positions = [];
        let offset = 0;
        for(index = 0; index < meshes.length; index++)if (meshes[index]) {
            const mesh = meshes[index];
            const meshIndices = mesh.getIndices();
            if (!meshIndices) continue;
            const meshPositions = mesh.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind, false, false);
            if (!meshPositions) continue;
            const worldMatrices = [];
            const worldMatrix = mesh.computeWorldMatrix(true);
            if (mesh.hasThinInstances) {
                const thinMatrices = mesh.thinInstanceGetWorldMatrices();
                for(let instanceIndex = 0; instanceIndex < thinMatrices.length; instanceIndex++){
                    const tmpMatrix = new (0, $ha1VO.Matrix)();
                    const thinMatrix = thinMatrices[instanceIndex];
                    thinMatrix.multiplyToRef(worldMatrix, tmpMatrix);
                    worldMatrices.push(tmpMatrix);
                }
            } else worldMatrices.push(worldMatrix);
            for(let matrixIndex = 0; matrixIndex < worldMatrices.length; matrixIndex++){
                const wm = worldMatrices[matrixIndex];
                for(tri = 0; tri < meshIndices.length; tri++)indices.push(meshIndices[tri] + offset);
                const transformed = (0, $ha1VO.Vector3).Zero();
                const position = (0, $ha1VO.Vector3).Zero();
                for(pt = 0; pt < meshPositions.length; pt += 3){
                    (0, $ha1VO.Vector3).FromArrayToRef(meshPositions, pt, position);
                    (0, $ha1VO.Vector3).TransformCoordinatesToRef(position, wm, transformed);
                    positions.push(transformed.x, transformed.y, transformed.z);
                }
                offset += meshPositions.length / 3;
            }
        }
        if (this._worker && completion) {
            // spawn worker and send message
            this._worker.postMessage([
                positions,
                offset,
                indices,
                indices.length,
                parameters
            ]);
            this._worker.onmessage = function(e) {
                completion(e.data);
            };
        } else {
            // blocking calls
            const rc = new this.bjsRECAST.rcConfig();
            rc.cs = parameters.cs;
            rc.ch = parameters.ch;
            rc.borderSize = parameters.borderSize ? parameters.borderSize : 0;
            rc.tileSize = parameters.tileSize ? parameters.tileSize : 0;
            rc.walkableSlopeAngle = parameters.walkableSlopeAngle;
            rc.walkableHeight = parameters.walkableHeight;
            rc.walkableClimb = parameters.walkableClimb;
            rc.walkableRadius = parameters.walkableRadius;
            rc.maxEdgeLen = parameters.maxEdgeLen;
            rc.maxSimplificationError = parameters.maxSimplificationError;
            rc.minRegionArea = parameters.minRegionArea;
            rc.mergeRegionArea = parameters.mergeRegionArea;
            rc.maxVertsPerPoly = parameters.maxVertsPerPoly;
            rc.detailSampleDist = parameters.detailSampleDist;
            rc.detailSampleMaxError = parameters.detailSampleMaxError;
            this.navMesh.build(positions, offset, indices, indices.length, rc);
        }
    }
    /**
     * Create a navigation mesh debug mesh
     * @param scene is where the mesh will be added
     * @returns debug display mesh
     */ createDebugNavMesh(scene) {
        let tri;
        let pt;
        const debugNavMesh = this.navMesh.getDebugNavMesh();
        const triangleCount = debugNavMesh.getTriangleCount();
        const indices = [];
        const positions = [];
        for(tri = 0; tri < triangleCount * 3; tri++)indices.push(tri);
        for(tri = 0; tri < triangleCount; tri++)for(pt = 0; pt < 3; pt++){
            const point = debugNavMesh.getTriangle(tri).getPoint(pt);
            positions.push(point.x, point.y, point.z);
        }
        const mesh = new (0, $fbuqw.Mesh)("NavMeshDebug", scene);
        const vertexData = new (0, $5v6ry.VertexData)();
        vertexData.indices = indices;
        vertexData.positions = positions;
        vertexData.applyToMesh(mesh, false);
        return mesh;
    }
    /**
     * Get a navigation mesh constrained position, closest to the parameter position
     * @param position world position
     * @returns the closest point to position constrained by the navigation mesh
     */ getClosestPoint(position) {
        this._tempVec1.x = position.x;
        this._tempVec1.y = position.y;
        this._tempVec1.z = position.z;
        const ret = this.navMesh.getClosestPoint(this._tempVec1);
        const pr = new (0, $ha1VO.Vector3)(ret.x, ret.y, ret.z);
        return pr;
    }
    /**
     * Get a navigation mesh constrained position, closest to the parameter position
     * @param position world position
     * @param result output the closest point to position constrained by the navigation mesh
     */ getClosestPointToRef(position, result) {
        this._tempVec1.x = position.x;
        this._tempVec1.y = position.y;
        this._tempVec1.z = position.z;
        const ret = this.navMesh.getClosestPoint(this._tempVec1);
        result.set(ret.x, ret.y, ret.z);
    }
    /**
     * Get a navigation mesh constrained position, within a particular radius
     * @param position world position
     * @param maxRadius the maximum distance to the constrained world position
     * @returns the closest point to position constrained by the navigation mesh
     */ getRandomPointAround(position, maxRadius) {
        this._tempVec1.x = position.x;
        this._tempVec1.y = position.y;
        this._tempVec1.z = position.z;
        const ret = this.navMesh.getRandomPointAround(this._tempVec1, maxRadius);
        const pr = new (0, $ha1VO.Vector3)(ret.x, ret.y, ret.z);
        return pr;
    }
    /**
     * Get a navigation mesh constrained position, within a particular radius
     * @param position world position
     * @param maxRadius the maximum distance to the constrained world position
     * @param result output the closest point to position constrained by the navigation mesh
     */ getRandomPointAroundToRef(position, maxRadius, result) {
        this._tempVec1.x = position.x;
        this._tempVec1.y = position.y;
        this._tempVec1.z = position.z;
        const ret = this.navMesh.getRandomPointAround(this._tempVec1, maxRadius);
        result.set(ret.x, ret.y, ret.z);
    }
    /**
     * Compute the final position from a segment made of destination-position
     * @param position world position
     * @param destination world position
     * @returns the resulting point along the navmesh
     */ moveAlong(position, destination) {
        this._tempVec1.x = position.x;
        this._tempVec1.y = position.y;
        this._tempVec1.z = position.z;
        this._tempVec2.x = destination.x;
        this._tempVec2.y = destination.y;
        this._tempVec2.z = destination.z;
        const ret = this.navMesh.moveAlong(this._tempVec1, this._tempVec2);
        const pr = new (0, $ha1VO.Vector3)(ret.x, ret.y, ret.z);
        return pr;
    }
    /**
     * Compute the final position from a segment made of destination-position
     * @param position world position
     * @param destination world position
     * @param result output the resulting point along the navmesh
     */ moveAlongToRef(position, destination, result) {
        this._tempVec1.x = position.x;
        this._tempVec1.y = position.y;
        this._tempVec1.z = position.z;
        this._tempVec2.x = destination.x;
        this._tempVec2.y = destination.y;
        this._tempVec2.z = destination.z;
        const ret = this.navMesh.moveAlong(this._tempVec1, this._tempVec2);
        result.set(ret.x, ret.y, ret.z);
    }
    _convertNavPathPoints(navPath) {
        let pt;
        const pointCount = navPath.getPointCount();
        const positions = [];
        for(pt = 0; pt < pointCount; pt++){
            const p = navPath.getPoint(pt);
            positions.push(new (0, $ha1VO.Vector3)(p.x, p.y, p.z));
        }
        return positions;
    }
    /**
     * Compute a navigation path from start to end. Returns an empty array if no path can be computed
     * Path is straight.
     * @param start world position
     * @param end world position
     * @returns array containing world position composing the path
     */ computePath(start, end) {
        this._tempVec1.x = start.x;
        this._tempVec1.y = start.y;
        this._tempVec1.z = start.z;
        this._tempVec2.x = end.x;
        this._tempVec2.y = end.y;
        this._tempVec2.z = end.z;
        const navPath = this.navMesh.computePath(this._tempVec1, this._tempVec2);
        return this._convertNavPathPoints(navPath);
    }
    /**
     * Compute a navigation path from start to end. Returns an empty array if no path can be computed.
     * Path follows navigation mesh geometry.
     * @param start world position
     * @param end world position
     * @returns array containing world position composing the path
     */ computePathSmooth(start, end) {
        this._tempVec1.x = start.x;
        this._tempVec1.y = start.y;
        this._tempVec1.z = start.z;
        this._tempVec2.x = end.x;
        this._tempVec2.y = end.y;
        this._tempVec2.z = end.z;
        const navPath = this.navMesh.computePathSmooth(this._tempVec1, this._tempVec2);
        return this._convertNavPathPoints(navPath);
    }
    /**
     * Create a new Crowd so you can add agents
     * @param maxAgents the maximum agent count in the crowd
     * @param maxAgentRadius the maximum radius an agent can have
     * @param scene to attach the crowd to
     * @returns the crowd you can add agents to
     */ createCrowd(maxAgents, maxAgentRadius, scene) {
        const crowd = new $458e1691e7407e45$export$37dd14fcbe6b4741(this, maxAgents, maxAgentRadius, scene);
        return crowd;
    }
    /**
     * Set the Bounding box extent for doing spatial queries (getClosestPoint, getRandomPointAround, ...)
     * The queries will try to find a solution within those bounds
     * default is (1,1,1)
     * @param extent x,y,z value that define the extent around the queries point of reference
     */ setDefaultQueryExtent(extent) {
        this._tempVec1.x = extent.x;
        this._tempVec1.y = extent.y;
        this._tempVec1.z = extent.z;
        this.navMesh.setDefaultQueryExtent(this._tempVec1);
    }
    /**
     * Get the Bounding box extent specified by setDefaultQueryExtent
     * @returns the box extent values
     */ getDefaultQueryExtent() {
        const p = this.navMesh.getDefaultQueryExtent();
        return new (0, $ha1VO.Vector3)(p.x, p.y, p.z);
    }
    /**
     * build the navmesh from a previously saved state using getNavmeshData
     * @param data the Uint8Array returned by getNavmeshData
     */ buildFromNavmeshData(data) {
        const nDataBytes = data.length * data.BYTES_PER_ELEMENT;
        const dataPtr = this.bjsRECAST._malloc(nDataBytes);
        const dataHeap = new Uint8Array(this.bjsRECAST.HEAPU8.buffer, dataPtr, nDataBytes);
        dataHeap.set(data);
        const buf = new this.bjsRECAST.NavmeshData();
        buf.dataPointer = dataHeap.byteOffset;
        buf.size = data.length;
        this.navMesh = new this.bjsRECAST.NavMesh();
        this.navMesh.buildFromNavmeshData(buf);
        // Free memory
        this.bjsRECAST._free(dataHeap.byteOffset);
    }
    /**
     * returns the navmesh data that can be used later. The navmesh must be built before retrieving the data
     * @returns data the Uint8Array that can be saved and reused
     */ getNavmeshData() {
        const navmeshData = this.navMesh.getNavmeshData();
        const arrView = new Uint8Array(this.bjsRECAST.HEAPU8.buffer, navmeshData.dataPointer, navmeshData.size);
        const ret = new Uint8Array(navmeshData.size);
        ret.set(arrView);
        this.navMesh.freeNavmeshData(navmeshData);
        return ret;
    }
    /**
     * Get the Bounding box extent result specified by setDefaultQueryExtent
     * @param result output the box extent values
     */ getDefaultQueryExtentToRef(result) {
        const p = this.navMesh.getDefaultQueryExtent();
        result.set(p.x, p.y, p.z);
    }
    /**
     * Disposes
     */ dispose() {}
    /**
     * Creates a cylinder obstacle and add it to the navigation
     * @param position world position
     * @param radius cylinder radius
     * @param height cylinder height
     * @returns the obstacle freshly created
     */ addCylinderObstacle(position, radius, height) {
        this._tempVec1.x = position.x;
        this._tempVec1.y = position.y;
        this._tempVec1.z = position.z;
        return this.navMesh.addCylinderObstacle(this._tempVec1, radius, height);
    }
    /**
     * Creates an oriented box obstacle and add it to the navigation
     * @param position world position
     * @param extent box size
     * @param angle angle in radians of the box orientation on Y axis
     * @returns the obstacle freshly created
     */ addBoxObstacle(position, extent, angle) {
        this._tempVec1.x = position.x;
        this._tempVec1.y = position.y;
        this._tempVec1.z = position.z;
        this._tempVec2.x = extent.x;
        this._tempVec2.y = extent.y;
        this._tempVec2.z = extent.z;
        return this.navMesh.addBoxObstacle(this._tempVec1, this._tempVec2, angle);
    }
    /**
     * Removes an obstacle created by addCylinderObstacle or addBoxObstacle
     * @param obstacle obstacle to remove from the navigation
     */ removeObstacle(obstacle) {
        this.navMesh.removeObstacle(obstacle);
    }
    /**
     * If this plugin is supported
     * @returns true if plugin is supported
     */ isSupported() {
        return this.bjsRECAST !== undefined;
    }
    /**
     * Returns the seed used for randomized functions like `getRandomPointAround`
     * @returns seed number
     */ getRandomSeed() {
        return this.bjsRECAST._getRandomSeed();
    }
    /**
     * Set the seed used for randomized functions like `getRandomPointAround`
     * @param seed number used as seed for random functions
     */ setRandomSeed(seed) {
        this.bjsRECAST._setRandomSeed(seed);
    }
}
class $458e1691e7407e45$export$37dd14fcbe6b4741 {
    /**
     * Constructor
     * @param plugin recastJS plugin
     * @param maxAgents the maximum agent count in the crowd
     * @param maxAgentRadius the maximum radius an agent can have
     * @param scene to attach the crowd to
     * @returns the crowd you can add agents to
     */ constructor(plugin, maxAgents, maxAgentRadius, scene){
        /**
         * Link to the detour crowd
         */ this.recastCrowd = {};
        /**
         * One transform per agent
         */ this.transforms = new Array();
        /**
         * All agents created
         */ this.agents = new Array();
        /**
         * agents reach radius
         */ this.reachRadii = new Array();
        /**
         * true when a destination is active for an agent and notifier hasn't been notified of reach
         */ this._agentDestinationArmed = new Array();
        /**
         * agent current target
         */ this._agentDestination = new Array();
        /**
         * Observer for crowd updates
         */ this._onBeforeAnimationsObserver = null;
        /**
         * Fires each time an agent is in reach radius of its destination
         */ this.onReachTargetObservable = new (0, $diGQf.Observable)();
        this.bjsRECASTPlugin = plugin;
        this.recastCrowd = new this.bjsRECASTPlugin.bjsRECAST.Crowd(maxAgents, maxAgentRadius, this.bjsRECASTPlugin.navMesh.getNavMesh());
        this._scene = scene;
        this._onBeforeAnimationsObserver = scene.onBeforeAnimationsObservable.add(()=>{
            this.update(scene.getEngine().getDeltaTime() * 0.001 * plugin.timeFactor);
        });
    }
    /**
     * Add a new agent to the crowd with the specified parameter a corresponding transformNode.
     * You can attach anything to that node. The node position is updated in the scene update tick.
     * @param pos world position that will be constrained by the navigation mesh
     * @param parameters agent parameters
     * @param transform hooked to the agent that will be update by the scene
     * @returns agent index
     */ addAgent(pos, parameters, transform) {
        const agentParams = new this.bjsRECASTPlugin.bjsRECAST.dtCrowdAgentParams();
        agentParams.radius = parameters.radius;
        agentParams.height = parameters.height;
        agentParams.maxAcceleration = parameters.maxAcceleration;
        agentParams.maxSpeed = parameters.maxSpeed;
        agentParams.collisionQueryRange = parameters.collisionQueryRange;
        agentParams.pathOptimizationRange = parameters.pathOptimizationRange;
        agentParams.separationWeight = parameters.separationWeight;
        agentParams.updateFlags = 7;
        agentParams.obstacleAvoidanceType = 0;
        agentParams.queryFilterType = 0;
        agentParams.userData = 0;
        const agentIndex = this.recastCrowd.addAgent(new this.bjsRECASTPlugin.bjsRECAST.Vec3(pos.x, pos.y, pos.z), agentParams);
        this.transforms.push(transform);
        this.agents.push(agentIndex);
        this.reachRadii.push(parameters.reachRadius ? parameters.reachRadius : parameters.radius);
        this._agentDestinationArmed.push(false);
        this._agentDestination.push(new (0, $ha1VO.Vector3)(0, 0, 0));
        return agentIndex;
    }
    /**
     * Returns the agent position in world space
     * @param index agent index returned by addAgent
     * @returns world space position
     */ getAgentPosition(index) {
        const agentPos = this.recastCrowd.getAgentPosition(index);
        return new (0, $ha1VO.Vector3)(agentPos.x, agentPos.y, agentPos.z);
    }
    /**
     * Returns the agent position result in world space
     * @param index agent index returned by addAgent
     * @param result output world space position
     */ getAgentPositionToRef(index, result) {
        const agentPos = this.recastCrowd.getAgentPosition(index);
        result.set(agentPos.x, agentPos.y, agentPos.z);
    }
    /**
     * Returns the agent velocity in world space
     * @param index agent index returned by addAgent
     * @returns world space velocity
     */ getAgentVelocity(index) {
        const agentVel = this.recastCrowd.getAgentVelocity(index);
        return new (0, $ha1VO.Vector3)(agentVel.x, agentVel.y, agentVel.z);
    }
    /**
     * Returns the agent velocity result in world space
     * @param index agent index returned by addAgent
     * @param result output world space velocity
     */ getAgentVelocityToRef(index, result) {
        const agentVel = this.recastCrowd.getAgentVelocity(index);
        result.set(agentVel.x, agentVel.y, agentVel.z);
    }
    /**
     * Returns the agent next target point on the path
     * @param index agent index returned by addAgent
     * @returns world space position
     */ getAgentNextTargetPath(index) {
        const pathTargetPos = this.recastCrowd.getAgentNextTargetPath(index);
        return new (0, $ha1VO.Vector3)(pathTargetPos.x, pathTargetPos.y, pathTargetPos.z);
    }
    /**
     * Returns the agent next target point on the path
     * @param index agent index returned by addAgent
     * @param result output world space position
     */ getAgentNextTargetPathToRef(index, result) {
        const pathTargetPos = this.recastCrowd.getAgentNextTargetPath(index);
        result.set(pathTargetPos.x, pathTargetPos.y, pathTargetPos.z);
    }
    /**
     * Gets the agent state
     * @param index agent index returned by addAgent
     * @returns agent state
     */ getAgentState(index) {
        return this.recastCrowd.getAgentState(index);
    }
    /**
     * returns true if the agent in over an off mesh link connection
     * @param index agent index returned by addAgent
     * @returns true if over an off mesh link connection
     */ overOffmeshConnection(index) {
        return this.recastCrowd.overOffmeshConnection(index);
    }
    /**
     * Asks a particular agent to go to a destination. That destination is constrained by the navigation mesh
     * @param index agent index returned by addAgent
     * @param destination targeted world position
     */ agentGoto(index, destination) {
        this.recastCrowd.agentGoto(index, new this.bjsRECASTPlugin.bjsRECAST.Vec3(destination.x, destination.y, destination.z));
        // arm observer
        const item = this.agents.indexOf(index);
        if (item > -1) {
            this._agentDestinationArmed[item] = true;
            this._agentDestination[item].set(destination.x, destination.y, destination.z);
        }
    }
    /**
     * Teleport the agent to a new position
     * @param index agent index returned by addAgent
     * @param destination targeted world position
     */ agentTeleport(index, destination) {
        this.recastCrowd.agentTeleport(index, new this.bjsRECASTPlugin.bjsRECAST.Vec3(destination.x, destination.y, destination.z));
    }
    /**
     * Update agent parameters
     * @param index agent index returned by addAgent
     * @param parameters agent parameters
     */ updateAgentParameters(index, parameters) {
        const agentParams = this.recastCrowd.getAgentParameters(index);
        if (parameters.radius !== undefined) agentParams.radius = parameters.radius;
        if (parameters.height !== undefined) agentParams.height = parameters.height;
        if (parameters.maxAcceleration !== undefined) agentParams.maxAcceleration = parameters.maxAcceleration;
        if (parameters.maxSpeed !== undefined) agentParams.maxSpeed = parameters.maxSpeed;
        if (parameters.collisionQueryRange !== undefined) agentParams.collisionQueryRange = parameters.collisionQueryRange;
        if (parameters.pathOptimizationRange !== undefined) agentParams.pathOptimizationRange = parameters.pathOptimizationRange;
        if (parameters.separationWeight !== undefined) agentParams.separationWeight = parameters.separationWeight;
        this.recastCrowd.setAgentParameters(index, agentParams);
    }
    /**
     * remove a particular agent previously created
     * @param index agent index returned by addAgent
     */ removeAgent(index) {
        this.recastCrowd.removeAgent(index);
        const item = this.agents.indexOf(index);
        if (item > -1) {
            this.agents.splice(item, 1);
            this.transforms.splice(item, 1);
            this.reachRadii.splice(item, 1);
            this._agentDestinationArmed.splice(item, 1);
            this._agentDestination.splice(item, 1);
        }
    }
    /**
     * get the list of all agents attached to this crowd
     * @returns list of agent indices
     */ getAgents() {
        return this.agents;
    }
    /**
     * Tick update done by the Scene. Agent position/velocity/acceleration is updated by this function
     * @param deltaTime in seconds
     */ update(deltaTime) {
        // update obstacles
        this.bjsRECASTPlugin.navMesh.update();
        if (deltaTime <= (0, $53VPf.Epsilon)) return;
        // update crowd
        const timeStep = this.bjsRECASTPlugin.getTimeStep();
        const maxStepCount = this.bjsRECASTPlugin.getMaximumSubStepCount();
        if (timeStep <= (0, $53VPf.Epsilon)) this.recastCrowd.update(deltaTime);
        else {
            let iterationCount = Math.floor(deltaTime / timeStep);
            if (maxStepCount && iterationCount > maxStepCount) iterationCount = maxStepCount;
            if (iterationCount < 1) iterationCount = 1;
            const step = deltaTime / iterationCount;
            for(let i = 0; i < iterationCount; i++)this.recastCrowd.update(step);
        }
        // update transforms
        for(let index = 0; index < this.agents.length; index++){
            // update transform position
            const agentIndex = this.agents[index];
            const agentPosition = this.getAgentPosition(agentIndex);
            this.transforms[index].position = agentPosition;
            // check agent reach destination
            if (this._agentDestinationArmed[index]) {
                const dx = agentPosition.x - this._agentDestination[index].x;
                const dz = agentPosition.z - this._agentDestination[index].z;
                const radius = this.reachRadii[index];
                const groundY = this._agentDestination[index].y - this.reachRadii[index];
                const ceilingY = this._agentDestination[index].y + this.reachRadii[index];
                const distanceXZSquared = dx * dx + dz * dz;
                if (agentPosition.y > groundY && agentPosition.y < ceilingY && distanceXZSquared < radius * radius) {
                    this._agentDestinationArmed[index] = false;
                    this.onReachTargetObservable.notifyObservers({
                        agentIndex: agentIndex,
                        destination: this._agentDestination[index]
                    });
                }
            }
        }
    }
    /**
     * Set the Bounding box extent for doing spatial queries (getClosestPoint, getRandomPointAround, ...)
     * The queries will try to find a solution within those bounds
     * default is (1,1,1)
     * @param extent x,y,z value that define the extent around the queries point of reference
     */ setDefaultQueryExtent(extent) {
        const ext = new this.bjsRECASTPlugin.bjsRECAST.Vec3(extent.x, extent.y, extent.z);
        this.recastCrowd.setDefaultQueryExtent(ext);
    }
    /**
     * Get the Bounding box extent specified by setDefaultQueryExtent
     * @returns the box extent values
     */ getDefaultQueryExtent() {
        const p = this.recastCrowd.getDefaultQueryExtent();
        return new (0, $ha1VO.Vector3)(p.x, p.y, p.z);
    }
    /**
     * Get the Bounding box extent result specified by setDefaultQueryExtent
     * @param result output the box extent values
     */ getDefaultQueryExtentToRef(result) {
        const p = this.recastCrowd.getDefaultQueryExtent();
        result.set(p.x, p.y, p.z);
    }
    /**
     * Get the next corner points composing the path (max 4 points)
     * @param index agent index returned by addAgent
     * @returns array containing world position composing the path
     */ getCorners(index) {
        let pt;
        const navPath = this.recastCrowd.getCorners(index);
        const pointCount = navPath.getPointCount();
        const positions = [];
        for(pt = 0; pt < pointCount; pt++){
            const p = navPath.getPoint(pt);
            positions.push(new (0, $ha1VO.Vector3)(p.x, p.y, p.z));
        }
        return positions;
    }
    /**
     * Release all resources
     */ dispose() {
        this.recastCrowd.destroy();
        this._scene.onBeforeAnimationsObservable.remove(this._onBeforeAnimationsObserver);
        this._onBeforeAnimationsObserver = null;
        this.onReachTargetObservable.clear();
    }
}

});



parcelRegister("9Uw9w", function(module, exports) {

var $dHUPr = parcelRequire("dHUPr");

var $dXFfY = parcelRequire("dXFfY");
$parcel$exportWildcard(module.exports, $dHUPr);
$parcel$exportWildcard(module.exports, $dXFfY);

});
parcelRegister("dHUPr", function(module, exports) {

$parcel$export(module.exports, "Database", () => $9fab5f7cb3d21aa1$export$6feb5ea51a7b0b47);

var $bOhSV = parcelRequire("bOhSV");

var $kVtWi = parcelRequire("kVtWi");

var $2TSIk = parcelRequire("2TSIk");

var $5YkyR = parcelRequire("5YkyR");

var $hUzEl = parcelRequire("hUzEl");
// Sets the default offline provider to Babylon.js
(0, $5YkyR.Engine).OfflineProviderFactory = (urlToScene, callbackManifestChecked, disableManifestCheck = false)=>{
    return new $9fab5f7cb3d21aa1$export$6feb5ea51a7b0b47(urlToScene, callbackManifestChecked, disableManifestCheck);
};
class $9fab5f7cb3d21aa1$export$6feb5ea51a7b0b47 {
    /**
     * Gets a boolean indicating if scene must be saved in the database
     */ get enableSceneOffline() {
        return this._enableSceneOffline;
    }
    /**
     * Gets a boolean indicating if textures must be saved in the database
     */ get enableTexturesOffline() {
        return this._enableTexturesOffline;
    }
    /**
     * Creates a new Database
     * @param urlToScene defines the url to load the scene
     * @param callbackManifestChecked defines the callback to use when manifest is checked
     * @param disableManifestCheck defines a boolean indicating that we want to skip the manifest validation (it will be considered validated and up to date)
     */ constructor(urlToScene, callbackManifestChecked, disableManifestCheck = false){
        // Handling various flavors of prefixed version of IndexedDB
        this._idbFactory = typeof indexedDB !== "undefined" ? indexedDB : undefined;
        this._currentSceneUrl = $9fab5f7cb3d21aa1$export$6feb5ea51a7b0b47._ReturnFullUrlLocation(urlToScene);
        this._db = null;
        this._enableSceneOffline = false;
        this._enableTexturesOffline = false;
        this._manifestVersionFound = 0;
        this._mustUpdateRessources = false;
        this._hasReachedQuota = false;
        if (!$9fab5f7cb3d21aa1$export$6feb5ea51a7b0b47.IDBStorageEnabled) callbackManifestChecked(true);
        else if (disableManifestCheck) {
            this._enableSceneOffline = true;
            this._enableTexturesOffline = true;
            this._manifestVersionFound = 1;
            (0, $bOhSV.Tools).SetImmediate(()=>{
                callbackManifestChecked(true);
            });
        } else this._checkManifestFile(callbackManifestChecked);
    }
    _checkManifestFile(callbackManifestChecked) {
        const noManifestFile = ()=>{
            this._enableSceneOffline = false;
            this._enableTexturesOffline = false;
            callbackManifestChecked(false);
        };
        const createManifestURL = ()=>{
            try {
                // make sure we have a valid URL.
                if (typeof URL === "function" && this._currentSceneUrl.indexOf("http") === 0) {
                    // we don't have the base url, so the URL string must have a protocol
                    const url = new URL(this._currentSceneUrl);
                    url.pathname += ".manifest";
                    return url.toString();
                }
            } catch (e) {
            // defensive - if this fails for any reason, fall back to the older method
            }
            return `${this._currentSceneUrl}.manifest`;
        };
        let timeStampUsed = false;
        let manifestURL = createManifestURL();
        const xhr = new (0, $hUzEl.WebRequest)();
        if (navigator.onLine) {
            // Adding a timestamp to by-pass browsers' cache
            timeStampUsed = true;
            manifestURL = manifestURL + (manifestURL.match(/\?/) == null ? "?" : "&") + Date.now();
        }
        xhr.open("GET", manifestURL);
        xhr.addEventListener("load", ()=>{
            if (xhr.status === 200 || $9fab5f7cb3d21aa1$export$6feb5ea51a7b0b47._ValidateXHRData(xhr, 1)) try {
                const manifestFile = JSON.parse(xhr.response);
                this._enableSceneOffline = manifestFile.enableSceneOffline;
                this._enableTexturesOffline = manifestFile.enableTexturesOffline && $9fab5f7cb3d21aa1$export$6feb5ea51a7b0b47._IsUASupportingBlobStorage;
                if (manifestFile.version && !isNaN(parseInt(manifestFile.version))) this._manifestVersionFound = manifestFile.version;
                callbackManifestChecked(true);
            } catch (ex) {
                noManifestFile();
            }
            else noManifestFile();
        }, false);
        xhr.addEventListener("error", ()=>{
            if (timeStampUsed) {
                timeStampUsed = false;
                // Let's retry without the timeStamp
                // It could fail when coupled with HTML5 Offline API
                const retryManifestURL = createManifestURL();
                xhr.open("GET", retryManifestURL);
                xhr.send();
            } else noManifestFile();
        }, false);
        try {
            xhr.send();
        } catch (ex) {
            (0, $kVtWi.Logger).Error("Error on XHR send request.");
            callbackManifestChecked(false);
        }
    }
    /**
     * Open the database and make it available
     * @param successCallback defines the callback to call on success
     * @param errorCallback defines the callback to call on error
     */ open(successCallback, errorCallback) {
        const handleError = ()=>{
            this._isSupported = false;
            if (errorCallback) errorCallback();
        };
        if (!this._idbFactory || !(this._enableSceneOffline || this._enableTexturesOffline)) {
            // Your browser doesn't support IndexedDB
            this._isSupported = false;
            if (errorCallback) errorCallback();
        } else {
            // If the DB hasn't been opened or created yet
            if (!this._db) {
                this._hasReachedQuota = false;
                this._isSupported = true;
                const request = this._idbFactory.open("babylonjs", 1);
                // Could occur if user is blocking the quota for the DB and/or doesn't grant access to IndexedDB
                request.onerror = ()=>{
                    handleError();
                };
                // executes when a version change transaction cannot complete due to other active transactions
                request.onblocked = ()=>{
                    (0, $kVtWi.Logger).Error("IDB request blocked. Please reload the page.");
                    handleError();
                };
                // DB has been opened successfully
                request.onsuccess = ()=>{
                    this._db = request.result;
                    successCallback();
                };
                // Initialization of the DB. Creating Scenes & Textures stores
                request.onupgradeneeded = (event)=>{
                    this._db = event.target.result;
                    if (this._db) try {
                        this._db.createObjectStore("scenes", {
                            keyPath: "sceneUrl"
                        });
                        this._db.createObjectStore("versions", {
                            keyPath: "sceneUrl"
                        });
                        this._db.createObjectStore("textures", {
                            keyPath: "textureUrl"
                        });
                    } catch (ex) {
                        (0, $kVtWi.Logger).Error("Error while creating object stores. Exception: " + ex.message);
                        handleError();
                    }
                };
            } else if (successCallback) successCallback();
        }
    }
    /**
     * Loads an image from the database
     * @param url defines the url to load from
     * @param image defines the target DOM image
     */ loadImage(url, image) {
        const completeURL = $9fab5f7cb3d21aa1$export$6feb5ea51a7b0b47._ReturnFullUrlLocation(url);
        const saveAndLoadImage = ()=>{
            if (!this._hasReachedQuota && this._db !== null) // the texture is not yet in the DB, let's try to save it
            this._saveImageIntoDBAsync(completeURL, image);
            else image.src = url;
        };
        if (!this._mustUpdateRessources) this._loadImageFromDBAsync(completeURL, image, saveAndLoadImage);
        else saveAndLoadImage();
    }
    _loadImageFromDBAsync(url, image, notInDBCallback) {
        if (this._isSupported && this._db !== null) {
            let texture;
            const transaction = this._db.transaction([
                "textures"
            ]);
            transaction.onabort = ()=>{
                image.src = url;
            };
            transaction.oncomplete = ()=>{
                let blobTextureURL;
                if (texture && typeof URL === "function") {
                    blobTextureURL = URL.createObjectURL(texture.data);
                    image.onerror = ()=>{
                        (0, $kVtWi.Logger).Error("Error loading image from blob URL: " + blobTextureURL + " switching back to web url: " + url);
                        image.src = url;
                    };
                    image.src = blobTextureURL;
                } else notInDBCallback();
            };
            const getRequest = transaction.objectStore("textures").get(url);
            getRequest.onsuccess = (event)=>{
                texture = event.target.result;
            };
            getRequest.onerror = ()=>{
                (0, $kVtWi.Logger).Error("Error loading texture " + url + " from DB.");
                image.src = url;
            };
        } else {
            (0, $kVtWi.Logger).Error("Error: IndexedDB not supported by your browser or BabylonJS Database is not open.");
            image.src = url;
        }
    }
    _saveImageIntoDBAsync(url, image) {
        let blob;
        if (this._isSupported) {
            // In case of error (type not supported or quota exceeded), we're at least sending back XHR data to allow texture loading later on
            const generateBlobUrl = ()=>{
                let blobTextureURL;
                if (blob && typeof URL === "function") try {
                    blobTextureURL = URL.createObjectURL(blob);
                } catch (ex) {
                    // Chrome is raising a type error if we're setting the oneTimeOnly parameter
                    blobTextureURL = URL.createObjectURL(blob);
                }
                if (blobTextureURL) image.src = blobTextureURL;
            };
            if ($9fab5f7cb3d21aa1$export$6feb5ea51a7b0b47._IsUASupportingBlobStorage) {
                // Create XHR
                const xhr = new (0, $hUzEl.WebRequest)();
                xhr.open("GET", url);
                xhr.responseType = "blob";
                xhr.addEventListener("load", ()=>{
                    if (xhr.status === 200 && this._db) {
                        // Blob as response
                        blob = xhr.response;
                        const transaction = this._db.transaction([
                            "textures"
                        ], "readwrite");
                        // the transaction could abort because of a QuotaExceededError error
                        transaction.onabort = (event)=>{
                            try {
                                //backwards compatibility with ts 1.0, srcElement doesn't have an "error" according to ts 1.3
                                const srcElement = event.target;
                                const error = srcElement.error;
                                if (error && error.name === "QuotaExceededError") this._hasReachedQuota = true;
                            } catch (ex) {}
                            generateBlobUrl();
                        };
                        transaction.oncomplete = ()=>{
                            generateBlobUrl();
                        };
                        const newTexture = {
                            textureUrl: url,
                            data: blob
                        };
                        try {
                            // Put the blob into the dabase
                            const addRequest = transaction.objectStore("textures").put(newTexture);
                            addRequest.onsuccess = ()=>{};
                            addRequest.onerror = ()=>{
                                generateBlobUrl();
                            };
                        } catch (ex) {
                            // "DataCloneError" generated by Chrome when you try to inject blob into IndexedDB
                            if (ex.code === 25) {
                                $9fab5f7cb3d21aa1$export$6feb5ea51a7b0b47._IsUASupportingBlobStorage = false;
                                this._enableTexturesOffline = false;
                            }
                            image.src = url;
                        }
                    } else image.src = url;
                }, false);
                xhr.addEventListener("error", ()=>{
                    (0, $kVtWi.Logger).Error("Error in XHR request in BABYLON.Database.");
                    image.src = url;
                }, false);
                xhr.send();
            } else image.src = url;
        } else {
            (0, $kVtWi.Logger).Error("Error: IndexedDB not supported by your browser or Babylon.js database is not open.");
            image.src = url;
        }
    }
    _checkVersionFromDB(url, versionLoaded) {
        const updateVersion = ()=>{
            // the version is not yet in the DB or we need to update it
            this._saveVersionIntoDBAsync(url, versionLoaded);
        };
        this._loadVersionFromDBAsync(url, versionLoaded, updateVersion);
    }
    _loadVersionFromDBAsync(url, callback, updateInDBCallback) {
        if (this._isSupported && this._db) {
            let version;
            try {
                const transaction = this._db.transaction([
                    "versions"
                ]);
                transaction.oncomplete = ()=>{
                    if (version) {
                        // If the version in the JSON file is different from the version in DB
                        if (this._manifestVersionFound !== version.data) {
                            this._mustUpdateRessources = true;
                            updateInDBCallback();
                        } else callback(version.data);
                    } else {
                        this._mustUpdateRessources = true;
                        updateInDBCallback();
                    }
                };
                transaction.onabort = ()=>{
                    callback(-1);
                };
                const getRequest = transaction.objectStore("versions").get(url);
                getRequest.onsuccess = (event)=>{
                    version = event.target.result;
                };
                getRequest.onerror = ()=>{
                    (0, $kVtWi.Logger).Error("Error loading version for scene " + url + " from DB.");
                    callback(-1);
                };
            } catch (ex) {
                (0, $kVtWi.Logger).Error("Error while accessing 'versions' object store (READ OP). Exception: " + ex.message);
                callback(-1);
            }
        } else {
            (0, $kVtWi.Logger).Error("Error: IndexedDB not supported by your browser or Babylon.js database is not open.");
            callback(-1);
        }
    }
    _saveVersionIntoDBAsync(url, callback) {
        if (this._isSupported && !this._hasReachedQuota && this._db) try {
            // Open a transaction to the database
            const transaction = this._db.transaction([
                "versions"
            ], "readwrite");
            // the transaction could abort because of a QuotaExceededError error
            transaction.onabort = (event)=>{
                try {
                    //backwards compatibility with ts 1.0, srcElement doesn't have an "error" according to ts 1.3
                    const error = event.target["error"];
                    if (error && error.name === "QuotaExceededError") this._hasReachedQuota = true;
                } catch (ex) {}
                callback(-1);
            };
            transaction.oncomplete = ()=>{
                callback(this._manifestVersionFound);
            };
            const newVersion = {
                sceneUrl: url,
                data: this._manifestVersionFound
            };
            // Put the scene into the database
            const addRequest = transaction.objectStore("versions").put(newVersion);
            addRequest.onsuccess = ()=>{};
            addRequest.onerror = ()=>{
                (0, $kVtWi.Logger).Error("Error in DB add version request in BABYLON.Database.");
            };
        } catch (ex) {
            (0, $kVtWi.Logger).Error("Error while accessing 'versions' object store (WRITE OP). Exception: " + ex.message);
            callback(-1);
        }
        else callback(-1);
    }
    /**
     * Loads a file from database
     * @param url defines the URL to load from
     * @param sceneLoaded defines a callback to call on success
     * @param progressCallBack defines a callback to call when progress changed
     * @param errorCallback defines a callback to call on error
     * @param useArrayBuffer defines a boolean to use array buffer instead of text string
     */ loadFile(url, sceneLoaded, progressCallBack, errorCallback, useArrayBuffer) {
        const completeUrl = $9fab5f7cb3d21aa1$export$6feb5ea51a7b0b47._ReturnFullUrlLocation(url);
        const saveAndLoadFile = ()=>{
            // the scene is not yet in the DB, let's try to save it
            this._saveFileAsync(completeUrl, sceneLoaded, progressCallBack, useArrayBuffer, errorCallback);
        };
        this._checkVersionFromDB(completeUrl, (version)=>{
            if (version !== -1) {
                if (!this._mustUpdateRessources) this._loadFileAsync(completeUrl, sceneLoaded, saveAndLoadFile);
                else this._saveFileAsync(completeUrl, sceneLoaded, progressCallBack, useArrayBuffer, errorCallback);
            } else if (errorCallback) errorCallback();
        });
    }
    _loadFileAsync(url, callback, notInDBCallback) {
        if (this._isSupported && this._db) {
            let targetStore;
            if (url.indexOf(".babylon") !== -1) targetStore = "scenes";
            else targetStore = "textures";
            let file;
            const transaction = this._db.transaction([
                targetStore
            ]);
            transaction.oncomplete = ()=>{
                if (file) callback(file.data);
                else notInDBCallback();
            };
            transaction.onabort = ()=>{
                notInDBCallback();
            };
            const getRequest = transaction.objectStore(targetStore).get(url);
            getRequest.onsuccess = (event)=>{
                file = event.target.result;
            };
            getRequest.onerror = ()=>{
                (0, $kVtWi.Logger).Error("Error loading file " + url + " from DB.");
                notInDBCallback();
            };
        } else {
            (0, $kVtWi.Logger).Error("Error: IndexedDB not supported by your browser or BabylonJS Database is not open.");
            callback();
        }
    }
    _saveFileAsync(url, callback, progressCallback, useArrayBuffer, errorCallback) {
        if (this._isSupported) {
            let targetStore;
            if (url.indexOf(".babylon") !== -1) targetStore = "scenes";
            else targetStore = "textures";
            // Create XHR
            const xhr = new (0, $hUzEl.WebRequest)();
            let fileData;
            xhr.open("GET", url + (url.match(/\?/) == null ? "?" : "&") + Date.now());
            if (useArrayBuffer) xhr.responseType = "arraybuffer";
            if (progressCallback) xhr.onprogress = progressCallback;
            xhr.addEventListener("load", ()=>{
                if (xhr.status === 200 || xhr.status < 400 && $9fab5f7cb3d21aa1$export$6feb5ea51a7b0b47._ValidateXHRData(xhr, !useArrayBuffer ? 1 : 6)) {
                    // Blob as response
                    fileData = !useArrayBuffer ? xhr.responseText : xhr.response;
                    if (!this._hasReachedQuota && this._db) {
                        // Open a transaction to the database
                        const transaction = this._db.transaction([
                            targetStore
                        ], "readwrite");
                        // the transaction could abort because of a QuotaExceededError error
                        transaction.onabort = (event)=>{
                            try {
                                //backwards compatibility with ts 1.0, srcElement doesn't have an "error" according to ts 1.3
                                const error = event.target["error"];
                                if (error && error.name === "QuotaExceededError") this._hasReachedQuota = true;
                            } catch (ex) {}
                            callback(fileData);
                        };
                        transaction.oncomplete = ()=>{
                            callback(fileData);
                        };
                        let newFile;
                        if (targetStore === "scenes") newFile = {
                            sceneUrl: url,
                            data: fileData,
                            version: this._manifestVersionFound
                        };
                        else newFile = {
                            textureUrl: url,
                            data: fileData
                        };
                        try {
                            // Put the scene into the database
                            const addRequest = transaction.objectStore(targetStore).put(newFile);
                            addRequest.onsuccess = ()=>{};
                            addRequest.onerror = ()=>{
                                (0, $kVtWi.Logger).Error("Error in DB add file request in BABYLON.Database.");
                            };
                        } catch (ex) {
                            callback(fileData);
                        }
                    } else callback(fileData);
                } else if (xhr.status >= 400 && errorCallback) errorCallback(xhr);
                else callback();
            }, false);
            xhr.addEventListener("error", ()=>{
                (0, $kVtWi.Logger).Error("error on XHR request.");
                errorCallback && errorCallback();
            }, false);
            xhr.send();
        } else {
            (0, $kVtWi.Logger).Error("Error: IndexedDB not supported by your browser or Babylon.js database is not open.");
            errorCallback && errorCallback();
        }
    }
    /**
     * Validates if xhr data is correct
     * @param xhr defines the request to validate
     * @param dataType defines the expected data type
     * @returns true if data is correct
     */ static _ValidateXHRData(xhr, dataType = 7) {
        // 1 for text (.babylon, manifest and shaders), 2 for TGA, 4 for DDS, 7 for all
        try {
            if (dataType & 1) {
                if (xhr.responseText && xhr.responseText.length > 0) return true;
                else if (dataType === 1) return false;
            }
            if (dataType & 2) {
                // Check header width and height since there is no "TGA" magic number
                const tgaHeader = (0, $2TSIk.GetTGAHeader)(xhr.response);
                if (tgaHeader.width && tgaHeader.height && tgaHeader.width > 0 && tgaHeader.height > 0) return true;
                else if (dataType === 2) return false;
            }
            if (dataType & 4) {
                // Check for the "DDS" magic number
                const ddsHeader = new Uint8Array(xhr.response, 0, 3);
                if (ddsHeader[0] === 68 && ddsHeader[1] === 68 && ddsHeader[2] === 83) return true;
                else return false;
            }
        } catch (e) {
        // Global protection
        }
        return false;
    }
}
/** Gets a boolean indicating if the user agent supports blob storage (this value will be updated after creating the first Database object) */ $9fab5f7cb3d21aa1$export$6feb5ea51a7b0b47._IsUASupportingBlobStorage = true;
/**
 * Gets a boolean indicating if Database storage is enabled (off by default)
 */ $9fab5f7cb3d21aa1$export$6feb5ea51a7b0b47.IDBStorageEnabled = false;
$9fab5f7cb3d21aa1$export$6feb5ea51a7b0b47._ParseURL = (url)=>{
    const a = document.createElement("a");
    a.href = url;
    const urlWithoutHash = url.substring(0, url.lastIndexOf("#"));
    const fileName = url.substring(urlWithoutHash.lastIndexOf("/") + 1, url.length);
    const absLocation = url.substring(0, url.indexOf(fileName, 0));
    return absLocation;
};
$9fab5f7cb3d21aa1$export$6feb5ea51a7b0b47._ReturnFullUrlLocation = (url)=>{
    if (url.indexOf("http:/") === -1 && url.indexOf("https:/") === -1 && typeof window !== "undefined") return $9fab5f7cb3d21aa1$export$6feb5ea51a7b0b47._ParseURL(window.location.href) + url;
    else return url;
};

});

parcelRegister("dXFfY", function(module, exports) {

});


parcelRegister("hzbqE", function(module, exports) {
/* eslint-disable import/export */ /* eslint-disable import/no-internal-modules */ 
var $1iaDW = parcelRequire("1iaDW");

var $3aLOK = parcelRequire("3aLOK");

var $lqZqT = parcelRequire("lqZqT");

var $AAqid = parcelRequire("AAqid");

var $d0CRN = parcelRequire("d0CRN");

var $94dSH = parcelRequire("94dSH");

var $e6EVj = parcelRequire("e6EVj");

var $8ksU7 = parcelRequire("8ksU7");

var $hi6ss = parcelRequire("hi6ss");

var $9VY7N = parcelRequire("9VY7N");

var $3zhnu = parcelRequire("3zhnu");

var $8Qyhp = parcelRequire("8Qyhp");

var $2PQbT = parcelRequire("2PQbT");

var $dkFul = parcelRequire("dkFul");

var $6Q8c4 = parcelRequire("6Q8c4");

var $b2hv8 = parcelRequire("b2hv8");
$parcel$exportWildcard(module.exports, $1iaDW);
$parcel$exportWildcard(module.exports, $3aLOK);
$parcel$exportWildcard(module.exports, $lqZqT);
$parcel$exportWildcard(module.exports, $AAqid);
$parcel$exportWildcard(module.exports, $d0CRN);
$parcel$exportWildcard(module.exports, $94dSH);
$parcel$exportWildcard(module.exports, $e6EVj);
$parcel$exportWildcard(module.exports, $8ksU7);
$parcel$exportWildcard(module.exports, $hi6ss);
$parcel$exportWildcard(module.exports, $9VY7N);
$parcel$exportWildcard(module.exports, $3zhnu);
$parcel$exportWildcard(module.exports, $8Qyhp);
$parcel$exportWildcard(module.exports, $2PQbT);
$parcel$exportWildcard(module.exports, $dkFul);
$parcel$exportWildcard(module.exports, $6Q8c4);
$parcel$exportWildcard(module.exports, $b2hv8);

});
parcelRegister("3aLOK", function(module, exports) {

var $6V6Qz = parcelRequire("6V6Qz");

var $fRkVr = parcelRequire("fRkVr");

var $eHSuH = parcelRequire("eHSuH");

var $2QOeY = parcelRequire("2QOeY");

var $1eUSb = parcelRequire("1eUSb");

var $7W4Lm = parcelRequire("7W4Lm");

var $lqOHh = parcelRequire("lqOHh");

var $bnmc3 = parcelRequire("bnmc3");

var $i7kWk = parcelRequire("i7kWk");
$parcel$exportWildcard(module.exports, $6V6Qz);
$parcel$exportWildcard(module.exports, $fRkVr);
$parcel$exportWildcard(module.exports, $eHSuH);
$parcel$exportWildcard(module.exports, $2QOeY);
$parcel$exportWildcard(module.exports, $1eUSb);
$parcel$exportWildcard(module.exports, $7W4Lm);
$parcel$exportWildcard(module.exports, $lqOHh);
$parcel$exportWildcard(module.exports, $bnmc3);
$parcel$exportWildcard(module.exports, $i7kWk);

});
parcelRegister("6V6Qz", function(module, exports) {

$parcel$export(module.exports, "BoxParticleEmitter", () => $509d609d93dac4de$export$e7201bab8caf4869);

var $ha1VO = parcelRequire("ha1VO");

var $iosaP = parcelRequire("iosaP");

var $fhgis = parcelRequire("fhgis");
class $509d609d93dac4de$export$e7201bab8caf4869 {
    /**
     * Creates a new instance BoxParticleEmitter
     */ constructor(){
        /**
         * Random direction of each particle after it has been emitted, between direction1 and direction2 vectors.
         */ this.direction1 = new (0, $ha1VO.Vector3)(0, 1.0, 0);
        /**
         * Random direction of each particle after it has been emitted, between direction1 and direction2 vectors.
         */ this.direction2 = new (0, $ha1VO.Vector3)(0, 1.0, 0);
        /**
         * Minimum box point around our emitter. Our emitter is the center of particles source, but if you want your particles to emit from more than one point, then you can tell it to do so.
         */ this.minEmitBox = new (0, $ha1VO.Vector3)(-0.5, -0.5, -0.5);
        /**
         * Maximum box point around our emitter. Our emitter is the center of particles source, but if you want your particles to emit from more than one point, then you can tell it to do so.
         */ this.maxEmitBox = new (0, $ha1VO.Vector3)(0.5, 0.5, 0.5);
    }
    /**
     * Called by the particle System when the direction is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param directionToUpdate is the direction vector to update with the result
     * @param particle is the particle we are computed the direction for
     * @param isLocal defines if the direction should be set in local space
     */ startDirectionFunction(worldMatrix, directionToUpdate, particle, isLocal) {
        const randX = (0, $iosaP.RandomRange)(this.direction1.x, this.direction2.x);
        const randY = (0, $iosaP.RandomRange)(this.direction1.y, this.direction2.y);
        const randZ = (0, $iosaP.RandomRange)(this.direction1.z, this.direction2.z);
        if (isLocal) {
            directionToUpdate.x = randX;
            directionToUpdate.y = randY;
            directionToUpdate.z = randZ;
            return;
        }
        (0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(randX, randY, randZ, worldMatrix, directionToUpdate);
    }
    /**
     * Called by the particle System when the position is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param positionToUpdate is the position vector to update with the result
     * @param particle is the particle we are computed the position for
     * @param isLocal defines if the position should be set in local space
     */ startPositionFunction(worldMatrix, positionToUpdate, particle, isLocal) {
        const randX = (0, $iosaP.RandomRange)(this.minEmitBox.x, this.maxEmitBox.x);
        const randY = (0, $iosaP.RandomRange)(this.minEmitBox.y, this.maxEmitBox.y);
        const randZ = (0, $iosaP.RandomRange)(this.minEmitBox.z, this.maxEmitBox.z);
        if (isLocal) {
            positionToUpdate.x = randX;
            positionToUpdate.y = randY;
            positionToUpdate.z = randZ;
            return;
        }
        (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(randX, randY, randZ, worldMatrix, positionToUpdate);
    }
    /**
     * Clones the current emitter and returns a copy of it
     * @returns the new emitter
     */ clone() {
        const newOne = new $509d609d93dac4de$export$e7201bab8caf4869();
        (0, $fhgis.DeepCopier).DeepCopy(this, newOne);
        return newOne;
    }
    /**
     * Called by the GPUParticleSystem to setup the update shader
     * @param uboOrEffect defines the update shader
     */ applyToShader(uboOrEffect) {
        uboOrEffect.setVector3("direction1", this.direction1);
        uboOrEffect.setVector3("direction2", this.direction2);
        uboOrEffect.setVector3("minEmitBox", this.minEmitBox);
        uboOrEffect.setVector3("maxEmitBox", this.maxEmitBox);
    }
    /**
     * Creates the structure of the ubo for this particle emitter
     * @param ubo ubo to create the structure for
     */ buildUniformLayout(ubo) {
        ubo.addUniform("direction1", 3);
        ubo.addUniform("direction2", 3);
        ubo.addUniform("minEmitBox", 3);
        ubo.addUniform("maxEmitBox", 3);
    }
    /**
     * Returns a string to use to update the GPU particles update shader
     * @returns a string containing the defines string
     */ getEffectDefines() {
        return "#define BOXEMITTER";
    }
    /**
     * Returns the string "BoxParticleEmitter"
     * @returns a string containing the class name
     */ getClassName() {
        return "BoxParticleEmitter";
    }
    /**
     * Serializes the particle system to a JSON object.
     * @returns the JSON object
     */ serialize() {
        const serializationObject = {};
        serializationObject.type = this.getClassName();
        serializationObject.direction1 = this.direction1.asArray();
        serializationObject.direction2 = this.direction2.asArray();
        serializationObject.minEmitBox = this.minEmitBox.asArray();
        serializationObject.maxEmitBox = this.maxEmitBox.asArray();
        return serializationObject;
    }
    /**
     * Parse properties from a JSON object
     * @param serializationObject defines the JSON object
     */ parse(serializationObject) {
        (0, $ha1VO.Vector3).FromArrayToRef(serializationObject.direction1, 0, this.direction1);
        (0, $ha1VO.Vector3).FromArrayToRef(serializationObject.direction2, 0, this.direction2);
        (0, $ha1VO.Vector3).FromArrayToRef(serializationObject.minEmitBox, 0, this.minEmitBox);
        (0, $ha1VO.Vector3).FromArrayToRef(serializationObject.maxEmitBox, 0, this.maxEmitBox);
    }
}

});

parcelRegister("fRkVr", function(module, exports) {

$parcel$export(module.exports, "ConeParticleEmitter", () => $b8bc099bf9944fef$export$2301fb99254f61e8);

var $fhgis = parcelRequire("fhgis");

var $ha1VO = parcelRequire("ha1VO");

var $1VEEL = parcelRequire("1VEEL");
class $b8bc099bf9944fef$export$2301fb99254f61e8 {
    /**
     * Gets or sets the radius of the emission cone
     */ get radius() {
        return this._radius;
    }
    set radius(value) {
        this._radius = value;
        this._buildHeight();
    }
    /**
     * Gets or sets the angle of the emission cone
     */ get angle() {
        return this._angle;
    }
    set angle(value) {
        this._angle = value;
        this._buildHeight();
    }
    _buildHeight() {
        if (this._angle !== 0) this._height = this._radius / Math.tan(this._angle / 2);
        else this._height = 1;
    }
    /**
     * Creates a new instance ConeParticleEmitter
     * @param radius the radius of the emission cone (1 by default)
     * @param angle the cone base angle (PI by default)
     * @param directionRandomizer defines how much to randomize the particle direction [0-1] (default is 0)
     */ constructor(radius = 1, angle = Math.PI, /** defines how much to randomize the particle direction [0-1] (default is 0) */ directionRandomizer = 0){
        this.directionRandomizer = directionRandomizer;
        /**
         * Gets or sets a value indicating where on the radius the start position should be picked (1 = everywhere, 0 = only surface)
         */ this.radiusRange = 1;
        /**
         * Gets or sets a value indicating where on the height the start position should be picked (1 = everywhere, 0 = only surface)
         */ this.heightRange = 1;
        /**
         * Gets or sets a value indicating if all the particles should be emitted from the spawn point only (the base of the cone)
         */ this.emitFromSpawnPointOnly = false;
        this.angle = angle;
        this.radius = radius;
    }
    /**
     * Called by the particle System when the direction is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param directionToUpdate is the direction vector to update with the result
     * @param particle is the particle we are computed the direction for
     * @param isLocal defines if the direction should be set in local space
     */ startDirectionFunction(worldMatrix, directionToUpdate, particle, isLocal) {
        if (isLocal) (0, $ha1VO.TmpVectors).Vector3[0].copyFrom(particle._localPosition).normalize();
        else particle.position.subtractToRef(worldMatrix.getTranslation(), (0, $ha1VO.TmpVectors).Vector3[0]).normalize();
        const randX = (0, $1VEEL.Scalar).RandomRange(0, this.directionRandomizer);
        const randY = (0, $1VEEL.Scalar).RandomRange(0, this.directionRandomizer);
        const randZ = (0, $1VEEL.Scalar).RandomRange(0, this.directionRandomizer);
        directionToUpdate.x = (0, $ha1VO.TmpVectors).Vector3[0].x + randX;
        directionToUpdate.y = (0, $ha1VO.TmpVectors).Vector3[0].y + randY;
        directionToUpdate.z = (0, $ha1VO.TmpVectors).Vector3[0].z + randZ;
        directionToUpdate.normalize();
    }
    /**
     * Called by the particle System when the position is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param positionToUpdate is the position vector to update with the result
     * @param particle is the particle we are computed the position for
     * @param isLocal defines if the position should be set in local space
     */ startPositionFunction(worldMatrix, positionToUpdate, particle, isLocal) {
        const s = (0, $1VEEL.Scalar).RandomRange(0, Math.PI * 2);
        let h;
        if (!this.emitFromSpawnPointOnly) {
            h = (0, $1VEEL.Scalar).RandomRange(0, this.heightRange);
            // Better distribution in a cone at normal angles.
            h = 1 - h * h;
        } else h = 0.0001;
        let radius = this._radius - (0, $1VEEL.Scalar).RandomRange(0, this._radius * this.radiusRange);
        radius = radius * h;
        const randX = radius * Math.sin(s);
        const randZ = radius * Math.cos(s);
        const randY = h * this._height;
        if (isLocal) {
            positionToUpdate.x = randX;
            positionToUpdate.y = randY;
            positionToUpdate.z = randZ;
            return;
        }
        (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(randX, randY, randZ, worldMatrix, positionToUpdate);
    }
    /**
     * Clones the current emitter and returns a copy of it
     * @returns the new emitter
     */ clone() {
        const newOne = new $b8bc099bf9944fef$export$2301fb99254f61e8(this._radius, this._angle, this.directionRandomizer);
        (0, $fhgis.DeepCopier).DeepCopy(this, newOne);
        return newOne;
    }
    /**
     * Called by the GPUParticleSystem to setup the update shader
     * @param uboOrEffect defines the update shader
     */ applyToShader(uboOrEffect) {
        uboOrEffect.setFloat2("radius", this._radius, this.radiusRange);
        uboOrEffect.setFloat("coneAngle", this._angle);
        uboOrEffect.setFloat2("height", this._height, this.heightRange);
        uboOrEffect.setFloat("directionRandomizer", this.directionRandomizer);
    }
    /**
     * Creates the structure of the ubo for this particle emitter
     * @param ubo ubo to create the structure for
     */ buildUniformLayout(ubo) {
        ubo.addUniform("radius", 2);
        ubo.addUniform("coneAngle", 1);
        ubo.addUniform("height", 2);
        ubo.addUniform("directionRandomizer", 1);
    }
    /**
     * Returns a string to use to update the GPU particles update shader
     * @returns a string containing the defines string
     */ getEffectDefines() {
        let defines = "#define CONEEMITTER";
        if (this.emitFromSpawnPointOnly) defines += "\n#define CONEEMITTERSPAWNPOINT";
        return defines;
    }
    /**
     * Returns the string "ConeParticleEmitter"
     * @returns a string containing the class name
     */ getClassName() {
        return "ConeParticleEmitter";
    }
    /**
     * Serializes the particle system to a JSON object.
     * @returns the JSON object
     */ serialize() {
        const serializationObject = {};
        serializationObject.type = this.getClassName();
        serializationObject.radius = this._radius;
        serializationObject.angle = this._angle;
        serializationObject.directionRandomizer = this.directionRandomizer;
        serializationObject.radiusRange = this.radiusRange;
        serializationObject.heightRange = this.heightRange;
        serializationObject.emitFromSpawnPointOnly = this.emitFromSpawnPointOnly;
        return serializationObject;
    }
    /**
     * Parse properties from a JSON object
     * @param serializationObject defines the JSON object
     */ parse(serializationObject) {
        this.radius = serializationObject.radius;
        this.angle = serializationObject.angle;
        this.directionRandomizer = serializationObject.directionRandomizer;
        this.radiusRange = serializationObject.radiusRange !== undefined ? serializationObject.radiusRange : 1;
        this.heightRange = serializationObject.radiusRange !== undefined ? serializationObject.heightRange : 1;
        this.emitFromSpawnPointOnly = serializationObject.emitFromSpawnPointOnly !== undefined ? serializationObject.emitFromSpawnPointOnly : false;
    }
}

});

parcelRegister("eHSuH", function(module, exports) {

$parcel$export(module.exports, "CylinderParticleEmitter", () => $ab4f5a3b0294b2f7$export$1749eea034ebf799);
$parcel$export(module.exports, "CylinderDirectedParticleEmitter", () => $ab4f5a3b0294b2f7$export$b8d84cf63489e8f7);

var $ha1VO = parcelRequire("ha1VO");

var $1VEEL = parcelRequire("1VEEL");

var $fhgis = parcelRequire("fhgis");
class $ab4f5a3b0294b2f7$export$1749eea034ebf799 {
    /**
     * Creates a new instance CylinderParticleEmitter
     * @param radius the radius of the emission cylinder (1 by default)
     * @param height the height of the emission cylinder (1 by default)
     * @param radiusRange the range of the emission cylinder [0-1] 0 Surface only, 1 Entire Radius (1 by default)
     * @param directionRandomizer defines how much to randomize the particle direction [0-1]
     */ constructor(/**
     * The radius of the emission cylinder.
     */ radius = 1, /**
     * The height of the emission cylinder.
     */ height = 1, /**
     * The range of emission [0-1] 0 Surface only, 1 Entire Radius.
     */ radiusRange = 1, /**
     * How much to randomize the particle direction [0-1].
     */ directionRandomizer = 0){
        this.radius = radius;
        this.height = height;
        this.radiusRange = radiusRange;
        this.directionRandomizer = directionRandomizer;
        this._tempVector = (0, $ha1VO.Vector3).Zero();
    }
    /**
     * Called by the particle System when the direction is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param directionToUpdate is the direction vector to update with the result
     * @param particle is the particle we are computed the direction for
     * @param isLocal defines if the direction should be set in local space
     * @param inverseWorldMatrix defines the inverted world matrix to use if isLocal is false
     */ startDirectionFunction(worldMatrix, directionToUpdate, particle, isLocal, inverseWorldMatrix) {
        particle.position.subtractToRef(worldMatrix.getTranslation(), this._tempVector);
        this._tempVector.normalize();
        (0, $ha1VO.Vector3).TransformNormalToRef(this._tempVector, inverseWorldMatrix, this._tempVector);
        const randY = (0, $1VEEL.Scalar).RandomRange(-this.directionRandomizer / 2, this.directionRandomizer / 2);
        let angle = Math.atan2(this._tempVector.x, this._tempVector.z);
        angle += (0, $1VEEL.Scalar).RandomRange(-Math.PI / 2, Math.PI / 2) * this.directionRandomizer;
        this._tempVector.y = randY; // set direction y to rand y to mirror normal of cylinder surface
        this._tempVector.x = Math.sin(angle);
        this._tempVector.z = Math.cos(angle);
        this._tempVector.normalize();
        if (isLocal) {
            directionToUpdate.copyFrom(this._tempVector);
            return;
        }
        (0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(this._tempVector.x, this._tempVector.y, this._tempVector.z, worldMatrix, directionToUpdate);
    }
    /**
     * Called by the particle System when the position is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param positionToUpdate is the position vector to update with the result
     * @param particle is the particle we are computed the position for
     * @param isLocal defines if the position should be set in local space
     */ startPositionFunction(worldMatrix, positionToUpdate, particle, isLocal) {
        const yPos = (0, $1VEEL.Scalar).RandomRange(-this.height / 2, this.height / 2);
        const angle = (0, $1VEEL.Scalar).RandomRange(0, 2 * Math.PI);
        // Pick a properly distributed point within the circle https://programming.guide/random-point-within-circle.html
        const radiusDistribution = (0, $1VEEL.Scalar).RandomRange((1 - this.radiusRange) * (1 - this.radiusRange), 1);
        const positionRadius = Math.sqrt(radiusDistribution) * this.radius;
        const xPos = positionRadius * Math.cos(angle);
        const zPos = positionRadius * Math.sin(angle);
        if (isLocal) {
            positionToUpdate.copyFromFloats(xPos, yPos, zPos);
            return;
        }
        (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(xPos, yPos, zPos, worldMatrix, positionToUpdate);
    }
    /**
     * Clones the current emitter and returns a copy of it
     * @returns the new emitter
     */ clone() {
        const newOne = new $ab4f5a3b0294b2f7$export$1749eea034ebf799(this.radius, this.directionRandomizer);
        (0, $fhgis.DeepCopier).DeepCopy(this, newOne);
        return newOne;
    }
    /**
     * Called by the GPUParticleSystem to setup the update shader
     * @param uboOrEffect defines the update shader
     */ applyToShader(uboOrEffect) {
        uboOrEffect.setFloat("radius", this.radius);
        uboOrEffect.setFloat("height", this.height);
        uboOrEffect.setFloat("radiusRange", this.radiusRange);
        uboOrEffect.setFloat("directionRandomizer", this.directionRandomizer);
    }
    /**
     * Creates the structure of the ubo for this particle emitter
     * @param ubo ubo to create the structure for
     */ buildUniformLayout(ubo) {
        ubo.addUniform("radius", 1);
        ubo.addUniform("height", 1);
        ubo.addUniform("radiusRange", 1);
        ubo.addUniform("directionRandomizer", 1);
    }
    /**
     * Returns a string to use to update the GPU particles update shader
     * @returns a string containing the defines string
     */ getEffectDefines() {
        return "#define CYLINDEREMITTER";
    }
    /**
     * Returns the string "CylinderParticleEmitter"
     * @returns a string containing the class name
     */ getClassName() {
        return "CylinderParticleEmitter";
    }
    /**
     * Serializes the particle system to a JSON object.
     * @returns the JSON object
     */ serialize() {
        const serializationObject = {};
        serializationObject.type = this.getClassName();
        serializationObject.radius = this.radius;
        serializationObject.height = this.height;
        serializationObject.radiusRange = this.radiusRange;
        serializationObject.directionRandomizer = this.directionRandomizer;
        return serializationObject;
    }
    /**
     * Parse properties from a JSON object
     * @param serializationObject defines the JSON object
     */ parse(serializationObject) {
        this.radius = serializationObject.radius;
        this.height = serializationObject.height;
        this.radiusRange = serializationObject.radiusRange;
        this.directionRandomizer = serializationObject.directionRandomizer;
    }
}
class $ab4f5a3b0294b2f7$export$b8d84cf63489e8f7 extends $ab4f5a3b0294b2f7$export$1749eea034ebf799 {
    /**
     * Creates a new instance CylinderDirectedParticleEmitter
     * @param radius the radius of the emission cylinder (1 by default)
     * @param height the height of the emission cylinder (1 by default)
     * @param radiusRange the range of the emission cylinder [0-1] 0 Surface only, 1 Entire Radius (1 by default)
     * @param direction1 the min limit of the emission direction (up vector by default)
     * @param direction2 the max limit of the emission direction (up vector by default)
     */ constructor(radius = 1, height = 1, radiusRange = 1, /**
     * The min limit of the emission direction.
     */ direction1 = new (0, $ha1VO.Vector3)(0, 1, 0), /**
     * The max limit of the emission direction.
     */ direction2 = new (0, $ha1VO.Vector3)(0, 1, 0)){
        super(radius, height, radiusRange);
        this.direction1 = direction1;
        this.direction2 = direction2;
    }
    /**
     * Called by the particle System when the direction is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param directionToUpdate is the direction vector to update with the result
     * @param _particle is the particle we are computed the direction for
     * @param isLocal defines if the direction should be set in local space
     */ startDirectionFunction(worldMatrix, directionToUpdate, _particle, isLocal) {
        const randX = (0, $1VEEL.Scalar).RandomRange(this.direction1.x, this.direction2.x);
        const randY = (0, $1VEEL.Scalar).RandomRange(this.direction1.y, this.direction2.y);
        const randZ = (0, $1VEEL.Scalar).RandomRange(this.direction1.z, this.direction2.z);
        if (isLocal) {
            directionToUpdate.copyFromFloats(randX, randY, randZ);
            return;
        }
        (0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(randX, randY, randZ, worldMatrix, directionToUpdate);
    }
    /**
     * Clones the current emitter and returns a copy of it
     * @returns the new emitter
     */ clone() {
        const newOne = new $ab4f5a3b0294b2f7$export$b8d84cf63489e8f7(this.radius, this.height, this.radiusRange, this.direction1, this.direction2);
        (0, $fhgis.DeepCopier).DeepCopy(this, newOne);
        return newOne;
    }
    /**
     * Called by the GPUParticleSystem to setup the update shader
     * @param uboOrEffect defines the update shader
     */ applyToShader(uboOrEffect) {
        uboOrEffect.setFloat("radius", this.radius);
        uboOrEffect.setFloat("height", this.height);
        uboOrEffect.setFloat("radiusRange", this.radiusRange);
        uboOrEffect.setVector3("direction1", this.direction1);
        uboOrEffect.setVector3("direction2", this.direction2);
    }
    /**
     * Creates the structure of the ubo for this particle emitter
     * @param ubo ubo to create the structure for
     */ buildUniformLayout(ubo) {
        ubo.addUniform("radius", 1);
        ubo.addUniform("height", 1);
        ubo.addUniform("radiusRange", 1);
        ubo.addUniform("direction1", 3);
        ubo.addUniform("direction2", 3);
    }
    /**
     * Returns a string to use to update the GPU particles update shader
     * @returns a string containing the defines string
     */ getEffectDefines() {
        return "#define CYLINDEREMITTER\n#define DIRECTEDCYLINDEREMITTER";
    }
    /**
     * Returns the string "CylinderDirectedParticleEmitter"
     * @returns a string containing the class name
     */ getClassName() {
        return "CylinderDirectedParticleEmitter";
    }
    /**
     * Serializes the particle system to a JSON object.
     * @returns the JSON object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.direction1 = this.direction1.asArray();
        serializationObject.direction2 = this.direction2.asArray();
        return serializationObject;
    }
    /**
     * Parse properties from a JSON object
     * @param serializationObject defines the JSON object
     */ parse(serializationObject) {
        super.parse(serializationObject);
        this.direction1.copyFrom(serializationObject.direction1);
        this.direction2.copyFrom(serializationObject.direction2);
    }
}

});

parcelRegister("2QOeY", function(module, exports) {

$parcel$export(module.exports, "HemisphericParticleEmitter", () => $213768d534ffed43$export$e972a65960ef3562);

var $fhgis = parcelRequire("fhgis");

var $ha1VO = parcelRequire("ha1VO");

var $1VEEL = parcelRequire("1VEEL");
class $213768d534ffed43$export$e972a65960ef3562 {
    /**
     * Creates a new instance HemisphericParticleEmitter
     * @param radius the radius of the emission hemisphere (1 by default)
     * @param radiusRange the range of the emission hemisphere [0-1] 0 Surface only, 1 Entire Radius (1 by default)
     * @param directionRandomizer defines how much to randomize the particle direction [0-1]
     */ constructor(/**
     * The radius of the emission hemisphere.
     */ radius = 1, /**
     * The range of emission [0-1] 0 Surface only, 1 Entire Radius.
     */ radiusRange = 1, /**
     * How much to randomize the particle direction [0-1].
     */ directionRandomizer = 0){
        this.radius = radius;
        this.radiusRange = radiusRange;
        this.directionRandomizer = directionRandomizer;
    }
    /**
     * Called by the particle System when the direction is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param directionToUpdate is the direction vector to update with the result
     * @param particle is the particle we are computed the direction for
     * @param isLocal defines if the direction should be set in local space
     */ startDirectionFunction(worldMatrix, directionToUpdate, particle, isLocal) {
        const direction = particle.position.subtract(worldMatrix.getTranslation()).normalize();
        const randX = (0, $1VEEL.Scalar).RandomRange(0, this.directionRandomizer);
        const randY = (0, $1VEEL.Scalar).RandomRange(0, this.directionRandomizer);
        const randZ = (0, $1VEEL.Scalar).RandomRange(0, this.directionRandomizer);
        direction.x += randX;
        direction.y += randY;
        direction.z += randZ;
        direction.normalize();
        if (isLocal) {
            directionToUpdate.copyFrom(direction);
            return;
        }
        (0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(direction.x, direction.y, direction.z, worldMatrix, directionToUpdate);
    }
    /**
     * Called by the particle System when the position is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param positionToUpdate is the position vector to update with the result
     * @param particle is the particle we are computed the position for
     * @param isLocal defines if the position should be set in local space
     */ startPositionFunction(worldMatrix, positionToUpdate, particle, isLocal) {
        const randRadius = this.radius - (0, $1VEEL.Scalar).RandomRange(0, this.radius * this.radiusRange);
        const v = (0, $1VEEL.Scalar).RandomRange(0, 1.0);
        const phi = (0, $1VEEL.Scalar).RandomRange(0, 2 * Math.PI);
        const theta = Math.acos(2 * v - 1);
        const randX = randRadius * Math.cos(phi) * Math.sin(theta);
        const randY = randRadius * Math.cos(theta);
        const randZ = randRadius * Math.sin(phi) * Math.sin(theta);
        if (isLocal) {
            positionToUpdate.copyFromFloats(randX, Math.abs(randY), randZ);
            return;
        }
        (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(randX, Math.abs(randY), randZ, worldMatrix, positionToUpdate);
    }
    /**
     * Clones the current emitter and returns a copy of it
     * @returns the new emitter
     */ clone() {
        const newOne = new $213768d534ffed43$export$e972a65960ef3562(this.radius, this.directionRandomizer);
        (0, $fhgis.DeepCopier).DeepCopy(this, newOne);
        return newOne;
    }
    /**
     * Called by the GPUParticleSystem to setup the update shader
     * @param uboOrEffect defines the update shader
     */ applyToShader(uboOrEffect) {
        uboOrEffect.setFloat("radius", this.radius);
        uboOrEffect.setFloat("radiusRange", this.radiusRange);
        uboOrEffect.setFloat("directionRandomizer", this.directionRandomizer);
    }
    /**
     * Creates the structure of the ubo for this particle emitter
     * @param ubo ubo to create the structure for
     */ buildUniformLayout(ubo) {
        ubo.addUniform("radius", 1);
        ubo.addUniform("radiusRange", 1);
        ubo.addUniform("directionRandomizer", 1);
    }
    /**
     * Returns a string to use to update the GPU particles update shader
     * @returns a string containing the defines string
     */ getEffectDefines() {
        return "#define HEMISPHERICEMITTER";
    }
    /**
     * Returns the string "HemisphericParticleEmitter"
     * @returns a string containing the class name
     */ getClassName() {
        return "HemisphericParticleEmitter";
    }
    /**
     * Serializes the particle system to a JSON object.
     * @returns the JSON object
     */ serialize() {
        const serializationObject = {};
        serializationObject.type = this.getClassName();
        serializationObject.radius = this.radius;
        serializationObject.radiusRange = this.radiusRange;
        serializationObject.directionRandomizer = this.directionRandomizer;
        return serializationObject;
    }
    /**
     * Parse properties from a JSON object
     * @param serializationObject defines the JSON object
     */ parse(serializationObject) {
        this.radius = serializationObject.radius;
        this.radiusRange = serializationObject.radiusRange;
        this.directionRandomizer = serializationObject.directionRandomizer;
    }
}

});

parcelRegister("1eUSb", function(module, exports) {

});

parcelRegister("7W4Lm", function(module, exports) {

$parcel$export(module.exports, "PointParticleEmitter", () => $5c71a4fd35120c39$export$a586d70131bc2eeb);

var $fhgis = parcelRequire("fhgis");

var $ha1VO = parcelRequire("ha1VO");

var $1VEEL = parcelRequire("1VEEL");
class $5c71a4fd35120c39$export$a586d70131bc2eeb {
    /**
     * Creates a new instance PointParticleEmitter
     */ constructor(){
        /**
         * Random direction of each particle after it has been emitted, between direction1 and direction2 vectors.
         */ this.direction1 = new (0, $ha1VO.Vector3)(0, 1.0, 0);
        /**
         * Random direction of each particle after it has been emitted, between direction1 and direction2 vectors.
         */ this.direction2 = new (0, $ha1VO.Vector3)(0, 1.0, 0);
    }
    /**
     * Called by the particle System when the direction is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param directionToUpdate is the direction vector to update with the result
     * @param particle is the particle we are computed the direction for
     * @param isLocal defines if the direction should be set in local space
     */ startDirectionFunction(worldMatrix, directionToUpdate, particle, isLocal) {
        const randX = (0, $1VEEL.Scalar).RandomRange(this.direction1.x, this.direction2.x);
        const randY = (0, $1VEEL.Scalar).RandomRange(this.direction1.y, this.direction2.y);
        const randZ = (0, $1VEEL.Scalar).RandomRange(this.direction1.z, this.direction2.z);
        if (isLocal) {
            directionToUpdate.copyFromFloats(randX, randY, randZ);
            return;
        }
        (0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(randX, randY, randZ, worldMatrix, directionToUpdate);
    }
    /**
     * Called by the particle System when the position is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param positionToUpdate is the position vector to update with the result
     * @param particle is the particle we are computed the position for
     * @param isLocal defines if the position should be set in local space
     */ startPositionFunction(worldMatrix, positionToUpdate, particle, isLocal) {
        if (isLocal) {
            positionToUpdate.copyFromFloats(0, 0, 0);
            return;
        }
        (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(0, 0, 0, worldMatrix, positionToUpdate);
    }
    /**
     * Clones the current emitter and returns a copy of it
     * @returns the new emitter
     */ clone() {
        const newOne = new $5c71a4fd35120c39$export$a586d70131bc2eeb();
        (0, $fhgis.DeepCopier).DeepCopy(this, newOne);
        return newOne;
    }
    /**
     * Called by the GPUParticleSystem to setup the update shader
     * @param uboOrEffect defines the update shader
     */ applyToShader(uboOrEffect) {
        uboOrEffect.setVector3("direction1", this.direction1);
        uboOrEffect.setVector3("direction2", this.direction2);
    }
    /**
     * Creates the structure of the ubo for this particle emitter
     * @param ubo ubo to create the structure for
     */ buildUniformLayout(ubo) {
        ubo.addUniform("direction1", 3);
        ubo.addUniform("direction2", 3);
    }
    /**
     * Returns a string to use to update the GPU particles update shader
     * @returns a string containing the defines string
     */ getEffectDefines() {
        return "#define POINTEMITTER";
    }
    /**
     * Returns the string "PointParticleEmitter"
     * @returns a string containing the class name
     */ getClassName() {
        return "PointParticleEmitter";
    }
    /**
     * Serializes the particle system to a JSON object.
     * @returns the JSON object
     */ serialize() {
        const serializationObject = {};
        serializationObject.type = this.getClassName();
        serializationObject.direction1 = this.direction1.asArray();
        serializationObject.direction2 = this.direction2.asArray();
        return serializationObject;
    }
    /**
     * Parse properties from a JSON object
     * @param serializationObject defines the JSON object
     */ parse(serializationObject) {
        (0, $ha1VO.Vector3).FromArrayToRef(serializationObject.direction1, 0, this.direction1);
        (0, $ha1VO.Vector3).FromArrayToRef(serializationObject.direction2, 0, this.direction2);
    }
}

});

parcelRegister("lqOHh", function(module, exports) {

$parcel$export(module.exports, "SphereParticleEmitter", () => $f9a35a0cd7eb9213$export$2541b18bda6a65ba);
$parcel$export(module.exports, "SphereDirectedParticleEmitter", () => $f9a35a0cd7eb9213$export$3874e23d91438769);

var $ha1VO = parcelRequire("ha1VO");

var $1VEEL = parcelRequire("1VEEL");

var $fhgis = parcelRequire("fhgis");
class $f9a35a0cd7eb9213$export$2541b18bda6a65ba {
    /**
     * Creates a new instance SphereParticleEmitter
     * @param radius the radius of the emission sphere (1 by default)
     * @param radiusRange the range of the emission sphere [0-1] 0 Surface only, 1 Entire Radius (1 by default)
     * @param directionRandomizer defines how much to randomize the particle direction [0-1]
     */ constructor(/**
     * The radius of the emission sphere.
     */ radius = 1, /**
     * The range of emission [0-1] 0 Surface only, 1 Entire Radius.
     */ radiusRange = 1, /**
     * How much to randomize the particle direction [0-1].
     */ directionRandomizer = 0){
        this.radius = radius;
        this.radiusRange = radiusRange;
        this.directionRandomizer = directionRandomizer;
    }
    /**
     * Called by the particle System when the direction is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param directionToUpdate is the direction vector to update with the result
     * @param particle is the particle we are computed the direction for
     * @param isLocal defines if the direction should be set in local space
     */ startDirectionFunction(worldMatrix, directionToUpdate, particle, isLocal) {
        const direction = particle.position.subtract(worldMatrix.getTranslation()).normalize();
        const randX = (0, $1VEEL.Scalar).RandomRange(0, this.directionRandomizer);
        const randY = (0, $1VEEL.Scalar).RandomRange(0, this.directionRandomizer);
        const randZ = (0, $1VEEL.Scalar).RandomRange(0, this.directionRandomizer);
        direction.x += randX;
        direction.y += randY;
        direction.z += randZ;
        direction.normalize();
        if (isLocal) {
            directionToUpdate.copyFrom(direction);
            return;
        }
        (0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(direction.x, direction.y, direction.z, worldMatrix, directionToUpdate);
    }
    /**
     * Called by the particle System when the position is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param positionToUpdate is the position vector to update with the result
     * @param particle is the particle we are computed the position for
     * @param isLocal defines if the position should be set in local space
     */ startPositionFunction(worldMatrix, positionToUpdate, particle, isLocal) {
        const randRadius = this.radius - (0, $1VEEL.Scalar).RandomRange(0, this.radius * this.radiusRange);
        const v = (0, $1VEEL.Scalar).RandomRange(0, 1.0);
        const phi = (0, $1VEEL.Scalar).RandomRange(0, 2 * Math.PI);
        const theta = Math.acos(2 * v - 1);
        const randX = randRadius * Math.cos(phi) * Math.sin(theta);
        const randY = randRadius * Math.cos(theta);
        const randZ = randRadius * Math.sin(phi) * Math.sin(theta);
        if (isLocal) {
            positionToUpdate.copyFromFloats(randX, randY, randZ);
            return;
        }
        (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(randX, randY, randZ, worldMatrix, positionToUpdate);
    }
    /**
     * Clones the current emitter and returns a copy of it
     * @returns the new emitter
     */ clone() {
        const newOne = new $f9a35a0cd7eb9213$export$2541b18bda6a65ba(this.radius, this.directionRandomizer);
        (0, $fhgis.DeepCopier).DeepCopy(this, newOne);
        return newOne;
    }
    /**
     * Called by the GPUParticleSystem to setup the update shader
     * @param uboOrEffect defines the update shader
     */ applyToShader(uboOrEffect) {
        uboOrEffect.setFloat("radius", this.radius);
        uboOrEffect.setFloat("radiusRange", this.radiusRange);
        uboOrEffect.setFloat("directionRandomizer", this.directionRandomizer);
    }
    /**
     * Creates the structure of the ubo for this particle emitter
     * @param ubo ubo to create the structure for
     */ buildUniformLayout(ubo) {
        ubo.addUniform("radius", 1);
        ubo.addUniform("radiusRange", 1);
        ubo.addUniform("directionRandomizer", 1);
    }
    /**
     * Returns a string to use to update the GPU particles update shader
     * @returns a string containing the defines string
     */ getEffectDefines() {
        return "#define SPHEREEMITTER";
    }
    /**
     * Returns the string "SphereParticleEmitter"
     * @returns a string containing the class name
     */ getClassName() {
        return "SphereParticleEmitter";
    }
    /**
     * Serializes the particle system to a JSON object.
     * @returns the JSON object
     */ serialize() {
        const serializationObject = {};
        serializationObject.type = this.getClassName();
        serializationObject.radius = this.radius;
        serializationObject.radiusRange = this.radiusRange;
        serializationObject.directionRandomizer = this.directionRandomizer;
        return serializationObject;
    }
    /**
     * Parse properties from a JSON object
     * @param serializationObject defines the JSON object
     */ parse(serializationObject) {
        this.radius = serializationObject.radius;
        this.radiusRange = serializationObject.radiusRange;
        this.directionRandomizer = serializationObject.directionRandomizer;
    }
}
class $f9a35a0cd7eb9213$export$3874e23d91438769 extends $f9a35a0cd7eb9213$export$2541b18bda6a65ba {
    /**
     * Creates a new instance SphereDirectedParticleEmitter
     * @param radius the radius of the emission sphere (1 by default)
     * @param direction1 the min limit of the emission direction (up vector by default)
     * @param direction2 the max limit of the emission direction (up vector by default)
     */ constructor(radius = 1, /**
     * The min limit of the emission direction.
     */ direction1 = new (0, $ha1VO.Vector3)(0, 1, 0), /**
     * The max limit of the emission direction.
     */ direction2 = new (0, $ha1VO.Vector3)(0, 1, 0)){
        super(radius);
        this.direction1 = direction1;
        this.direction2 = direction2;
    }
    /**
     * Called by the particle System when the direction is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param directionToUpdate is the direction vector to update with the result
     */ startDirectionFunction(worldMatrix, directionToUpdate) {
        const randX = (0, $1VEEL.Scalar).RandomRange(this.direction1.x, this.direction2.x);
        const randY = (0, $1VEEL.Scalar).RandomRange(this.direction1.y, this.direction2.y);
        const randZ = (0, $1VEEL.Scalar).RandomRange(this.direction1.z, this.direction2.z);
        (0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(randX, randY, randZ, worldMatrix, directionToUpdate);
    }
    /**
     * Clones the current emitter and returns a copy of it
     * @returns the new emitter
     */ clone() {
        const newOne = new $f9a35a0cd7eb9213$export$3874e23d91438769(this.radius, this.direction1, this.direction2);
        (0, $fhgis.DeepCopier).DeepCopy(this, newOne);
        return newOne;
    }
    /**
     * Called by the GPUParticleSystem to setup the update shader
     * @param uboOrEffect defines the update shader
     */ applyToShader(uboOrEffect) {
        uboOrEffect.setFloat("radius", this.radius);
        uboOrEffect.setFloat("radiusRange", this.radiusRange);
        uboOrEffect.setVector3("direction1", this.direction1);
        uboOrEffect.setVector3("direction2", this.direction2);
    }
    /**
     * Creates the structure of the ubo for this particle emitter
     * @param ubo ubo to create the structure for
     */ buildUniformLayout(ubo) {
        ubo.addUniform("radius", 1);
        ubo.addUniform("radiusRange", 1);
        ubo.addUniform("direction1", 3);
        ubo.addUniform("direction2", 3);
    }
    /**
     * Returns a string to use to update the GPU particles update shader
     * @returns a string containing the defines string
     */ getEffectDefines() {
        return "#define SPHEREEMITTER\n#define DIRECTEDSPHEREEMITTER";
    }
    /**
     * Returns the string "SphereDirectedParticleEmitter"
     * @returns a string containing the class name
     */ getClassName() {
        return "SphereDirectedParticleEmitter";
    }
    /**
     * Serializes the particle system to a JSON object.
     * @returns the JSON object
     */ serialize() {
        const serializationObject = super.serialize();
        serializationObject.direction1 = this.direction1.asArray();
        serializationObject.direction2 = this.direction2.asArray();
        return serializationObject;
    }
    /**
     * Parse properties from a JSON object
     * @param serializationObject defines the JSON object
     */ parse(serializationObject) {
        super.parse(serializationObject);
        this.direction1.copyFrom(serializationObject.direction1);
        this.direction2.copyFrom(serializationObject.direction2);
    }
}

});

parcelRegister("bnmc3", function(module, exports) {

$parcel$export(module.exports, "CustomParticleEmitter", () => $84830edb6842e99c$export$d5b809e1fb739630);

var $fhgis = parcelRequire("fhgis");

var $ha1VO = parcelRequire("ha1VO");
class $84830edb6842e99c$export$d5b809e1fb739630 {
    /**
     * Creates a new instance CustomParticleEmitter
     */ constructor(){
        /**
         * Gets or sets the position generator that will create the initial position of each particle.
         * Index will be provided when used with GPU particle. Particle will be provided when used with CPU particles
         */ this.particlePositionGenerator = ()=>{};
        /**
         * Gets or sets the destination generator that will create the final destination of each particle.
         *  * Index will be provided when used with GPU particle. Particle will be provided when used with CPU particles
         */ this.particleDestinationGenerator = ()=>{};
    }
    /**
     * Called by the particle System when the direction is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param directionToUpdate is the direction vector to update with the result
     * @param particle is the particle we are computed the direction for
     * @param isLocal defines if the direction should be set in local space
     */ startDirectionFunction(worldMatrix, directionToUpdate, particle, isLocal) {
        const tmpVector = (0, $ha1VO.TmpVectors).Vector3[0];
        if (this.particleDestinationGenerator) {
            this.particleDestinationGenerator(-1, particle, tmpVector);
            // Get direction
            const diffVector = (0, $ha1VO.TmpVectors).Vector3[1];
            tmpVector.subtractToRef(particle.position, diffVector);
            diffVector.scaleToRef(1 / particle.lifeTime, tmpVector);
        } else tmpVector.set(0, 0, 0);
        if (isLocal) {
            directionToUpdate.copyFrom(tmpVector);
            return;
        }
        (0, $ha1VO.Vector3).TransformNormalToRef(tmpVector, worldMatrix, directionToUpdate);
    }
    /**
     * Called by the particle System when the position is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param positionToUpdate is the position vector to update with the result
     * @param particle is the particle we are computed the position for
     * @param isLocal defines if the position should be set in local space
     */ startPositionFunction(worldMatrix, positionToUpdate, particle, isLocal) {
        const tmpVector = (0, $ha1VO.TmpVectors).Vector3[0];
        if (this.particlePositionGenerator) this.particlePositionGenerator(-1, particle, tmpVector);
        else tmpVector.set(0, 0, 0);
        if (isLocal) {
            positionToUpdate.copyFrom(tmpVector);
            return;
        }
        (0, $ha1VO.Vector3).TransformCoordinatesToRef(tmpVector, worldMatrix, positionToUpdate);
    }
    /**
     * Clones the current emitter and returns a copy of it
     * @returns the new emitter
     */ clone() {
        const newOne = new $84830edb6842e99c$export$d5b809e1fb739630();
        (0, $fhgis.DeepCopier).DeepCopy(this, newOne);
        return newOne;
    }
    /**
     * Called by the GPUParticleSystem to setup the update shader
     * @param uboOrEffect defines the update shader
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    applyToShader(uboOrEffect) {}
    /**
     * Creates the structure of the ubo for this particle emitter
     * @param ubo ubo to create the structure for
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    buildUniformLayout(ubo) {}
    /**
     * Returns a string to use to update the GPU particles update shader
     * @returns a string containing the defines string
     */ getEffectDefines() {
        return "#define CUSTOMEMITTER";
    }
    /**
     * Returns the string "PointParticleEmitter"
     * @returns a string containing the class name
     */ getClassName() {
        return "CustomParticleEmitter";
    }
    /**
     * Serializes the particle system to a JSON object.
     * @returns the JSON object
     */ serialize() {
        const serializationObject = {};
        serializationObject.type = this.getClassName();
        serializationObject.particlePositionGenerator = this.particlePositionGenerator;
        serializationObject.particleDestinationGenerator = this.particleDestinationGenerator;
        return serializationObject;
    }
    /**
     * Parse properties from a JSON object
     * @param serializationObject defines the JSON object
     */ parse(serializationObject) {
        if (serializationObject.particlePositionGenerator) this.particlePositionGenerator = serializationObject.particlePositionGenerator;
        if (serializationObject.particleDestinationGenerator) this.particleDestinationGenerator = serializationObject.particleDestinationGenerator;
    }
}

});

parcelRegister("i7kWk", function(module, exports) {

$parcel$export(module.exports, "MeshParticleEmitter", () => $d3091fa0938569db$export$7c52b14cab7afa0e);

var $fhgis = parcelRequire("fhgis");

var $ha1VO = parcelRequire("ha1VO");

var $1VEEL = parcelRequire("1VEEL");

var $b4i1f = parcelRequire("b4i1f");
class $d3091fa0938569db$export$7c52b14cab7afa0e {
    /** Defines the mesh to use as source */ get mesh() {
        return this._mesh;
    }
    set mesh(value) {
        if (this._mesh === value) return;
        this._mesh = value;
        if (value) {
            this._indices = value.getIndices();
            this._positions = value.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
            this._normals = value.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind);
        } else {
            this._indices = null;
            this._positions = null;
            this._normals = null;
        }
    }
    /**
     * Creates a new instance MeshParticleEmitter
     * @param mesh defines the mesh to use as source
     */ constructor(mesh = null){
        this._indices = null;
        this._positions = null;
        this._normals = null;
        this._storedNormal = (0, $ha1VO.Vector3).Zero();
        this._mesh = null;
        /**
         * Random direction of each particle after it has been emitted, between direction1 and direction2 vectors.
         */ this.direction1 = new (0, $ha1VO.Vector3)(0, 1.0, 0);
        /**
         * Random direction of each particle after it has been emitted, between direction1 and direction2 vectors.
         */ this.direction2 = new (0, $ha1VO.Vector3)(0, 1.0, 0);
        /**
         * Gets or sets a boolean indicating that particle directions must be built from mesh face normals
         */ this.useMeshNormalsForDirection = true;
        this.mesh = mesh;
    }
    /**
     * Called by the particle System when the direction is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param directionToUpdate is the direction vector to update with the result
     * @param particle is the particle we are computed the direction for
     * @param isLocal defines if the direction should be set in local space
     */ startDirectionFunction(worldMatrix, directionToUpdate, particle, isLocal) {
        if (this.useMeshNormalsForDirection && this._normals) {
            (0, $ha1VO.Vector3).TransformNormalToRef(this._storedNormal, worldMatrix, directionToUpdate);
            return;
        }
        const randX = (0, $1VEEL.Scalar).RandomRange(this.direction1.x, this.direction2.x);
        const randY = (0, $1VEEL.Scalar).RandomRange(this.direction1.y, this.direction2.y);
        const randZ = (0, $1VEEL.Scalar).RandomRange(this.direction1.z, this.direction2.z);
        if (isLocal) {
            directionToUpdate.copyFromFloats(randX, randY, randZ);
            return;
        }
        (0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(randX, randY, randZ, worldMatrix, directionToUpdate);
    }
    /**
     * Called by the particle System when the position is computed for the created particle.
     * @param worldMatrix is the world matrix of the particle system
     * @param positionToUpdate is the position vector to update with the result
     * @param particle is the particle we are computed the position for
     * @param isLocal defines if the position should be set in local space
     */ startPositionFunction(worldMatrix, positionToUpdate, particle, isLocal) {
        if (!this._indices || !this._positions) return;
        const randomFaceIndex = 3 * Math.random() * (this._indices.length / 3) | 0;
        const bu = Math.random();
        const bv = Math.random() * (1.0 - bu);
        const bw = 1.0 - bu - bv;
        const faceIndexA = this._indices[randomFaceIndex];
        const faceIndexB = this._indices[randomFaceIndex + 1];
        const faceIndexC = this._indices[randomFaceIndex + 2];
        const vertexA = (0, $ha1VO.TmpVectors).Vector3[0];
        const vertexB = (0, $ha1VO.TmpVectors).Vector3[1];
        const vertexC = (0, $ha1VO.TmpVectors).Vector3[2];
        const randomVertex = (0, $ha1VO.TmpVectors).Vector3[3];
        (0, $ha1VO.Vector3).FromArrayToRef(this._positions, faceIndexA * 3, vertexA);
        (0, $ha1VO.Vector3).FromArrayToRef(this._positions, faceIndexB * 3, vertexB);
        (0, $ha1VO.Vector3).FromArrayToRef(this._positions, faceIndexC * 3, vertexC);
        randomVertex.x = bu * vertexA.x + bv * vertexB.x + bw * vertexC.x;
        randomVertex.y = bu * vertexA.y + bv * vertexB.y + bw * vertexC.y;
        randomVertex.z = bu * vertexA.z + bv * vertexB.z + bw * vertexC.z;
        if (isLocal) positionToUpdate.copyFromFloats(randomVertex.x, randomVertex.y, randomVertex.z);
        else (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(randomVertex.x, randomVertex.y, randomVertex.z, worldMatrix, positionToUpdate);
        if (this.useMeshNormalsForDirection && this._normals) {
            (0, $ha1VO.Vector3).FromArrayToRef(this._normals, faceIndexA * 3, vertexA);
            (0, $ha1VO.Vector3).FromArrayToRef(this._normals, faceIndexB * 3, vertexB);
            (0, $ha1VO.Vector3).FromArrayToRef(this._normals, faceIndexC * 3, vertexC);
            this._storedNormal.x = bu * vertexA.x + bv * vertexB.x + bw * vertexC.x;
            this._storedNormal.y = bu * vertexA.y + bv * vertexB.y + bw * vertexC.y;
            this._storedNormal.z = bu * vertexA.z + bv * vertexB.z + bw * vertexC.z;
        }
    }
    /**
     * Clones the current emitter and returns a copy of it
     * @returns the new emitter
     */ clone() {
        const newOne = new $d3091fa0938569db$export$7c52b14cab7afa0e(this.mesh);
        (0, $fhgis.DeepCopier).DeepCopy(this, newOne);
        return newOne;
    }
    /**
     * Called by the GPUParticleSystem to setup the update shader
     * @param uboOrEffect defines the update shader
     */ applyToShader(uboOrEffect) {
        uboOrEffect.setVector3("direction1", this.direction1);
        uboOrEffect.setVector3("direction2", this.direction2);
    }
    /**
     * Creates the structure of the ubo for this particle emitter
     * @param ubo ubo to create the structure for
     */ buildUniformLayout(ubo) {
        ubo.addUniform("direction1", 3);
        ubo.addUniform("direction2", 3);
    }
    /**
     * Returns a string to use to update the GPU particles update shader
     * @returns a string containing the defines string
     */ getEffectDefines() {
        return "";
    }
    /**
     * Returns the string "BoxParticleEmitter"
     * @returns a string containing the class name
     */ getClassName() {
        return "MeshParticleEmitter";
    }
    /**
     * Serializes the particle system to a JSON object.
     * @returns the JSON object
     */ serialize() {
        const serializationObject = {};
        serializationObject.type = this.getClassName();
        serializationObject.direction1 = this.direction1.asArray();
        serializationObject.direction2 = this.direction2.asArray();
        serializationObject.meshId = this.mesh?.id;
        serializationObject.useMeshNormalsForDirection = this.useMeshNormalsForDirection;
        return serializationObject;
    }
    /**
     * Parse properties from a JSON object
     * @param serializationObject defines the JSON object
     * @param scene defines the hosting scene
     */ parse(serializationObject, scene) {
        (0, $ha1VO.Vector3).FromArrayToRef(serializationObject.direction1, 0, this.direction1);
        (0, $ha1VO.Vector3).FromArrayToRef(serializationObject.direction2, 0, this.direction2);
        if (serializationObject.meshId && scene) this.mesh = scene.getLastMeshById(serializationObject.meshId);
        this.useMeshNormalsForDirection = serializationObject.useMeshNormalsForDirection;
    }
}

});


parcelRegister("lqZqT", function(module, exports) {

$parcel$export(module.exports, "WebGL2ParticleSystem", () => $f9abadeea99a7e66$export$7c821840848e1882);

var $lUDWq = parcelRequire("lUDWq");

var $bnmc3 = parcelRequire("bnmc3");

var $eKP8e = parcelRequire("eKP8e");

var $8DoUR = parcelRequire("8DoUR");
parcelRequire("dBz5Z");
parcelRequire("4wXW6");
class $f9abadeea99a7e66$export$7c821840848e1882 {
    constructor(parent, engine){
        this._renderVAO = [];
        this._updateVAO = [];
        this.alignDataInBuffer = false;
        this._parent = parent;
        this._engine = engine;
        this._updateEffectOptions = {
            attributes: [
                "position",
                "initialPosition",
                "age",
                "life",
                "seed",
                "size",
                "color",
                "direction",
                "initialDirection",
                "angle",
                "cellIndex",
                "cellStartOffset",
                "noiseCoordinates1",
                "noiseCoordinates2"
            ],
            uniformsNames: [
                "currentCount",
                "timeDelta",
                "emitterWM",
                "lifeTime",
                "color1",
                "color2",
                "sizeRange",
                "scaleRange",
                "gravity",
                "emitPower",
                "direction1",
                "direction2",
                "minEmitBox",
                "maxEmitBox",
                "radius",
                "directionRandomizer",
                "height",
                "coneAngle",
                "stopFactor",
                "angleRange",
                "radiusRange",
                "cellInfos",
                "noiseStrength",
                "limitVelocityDamping"
            ],
            uniformBuffersNames: [],
            samplers: [
                "randomSampler",
                "randomSampler2",
                "sizeGradientSampler",
                "angularSpeedGradientSampler",
                "velocityGradientSampler",
                "limitVelocityGradientSampler",
                "noiseSampler",
                "dragGradientSampler"
            ],
            defines: "",
            fallbacks: null,
            onCompiled: null,
            onError: null,
            indexParameters: null,
            maxSimultaneousLights: 0,
            transformFeedbackVaryings: []
        };
    }
    contextLost() {
        this._updateEffect = undefined;
        this._renderVAO.length = 0;
        this._updateVAO.length = 0;
    }
    isUpdateBufferCreated() {
        return !!this._updateEffect;
    }
    isUpdateBufferReady() {
        return this._updateEffect?.isReady() ?? false;
    }
    createUpdateBuffer(defines) {
        this._updateEffectOptions.transformFeedbackVaryings = [
            "outPosition"
        ];
        this._updateEffectOptions.transformFeedbackVaryings.push("outAge");
        this._updateEffectOptions.transformFeedbackVaryings.push("outSize");
        this._updateEffectOptions.transformFeedbackVaryings.push("outLife");
        this._updateEffectOptions.transformFeedbackVaryings.push("outSeed");
        this._updateEffectOptions.transformFeedbackVaryings.push("outDirection");
        if (this._parent.particleEmitterType instanceof (0, $bnmc3.CustomParticleEmitter)) this._updateEffectOptions.transformFeedbackVaryings.push("outInitialPosition");
        if (!this._parent._colorGradientsTexture) this._updateEffectOptions.transformFeedbackVaryings.push("outColor");
        if (!this._parent._isBillboardBased) this._updateEffectOptions.transformFeedbackVaryings.push("outInitialDirection");
        if (this._parent.noiseTexture) {
            this._updateEffectOptions.transformFeedbackVaryings.push("outNoiseCoordinates1");
            this._updateEffectOptions.transformFeedbackVaryings.push("outNoiseCoordinates2");
        }
        this._updateEffectOptions.transformFeedbackVaryings.push("outAngle");
        if (this._parent.isAnimationSheetEnabled) {
            this._updateEffectOptions.transformFeedbackVaryings.push("outCellIndex");
            if (this._parent.spriteRandomStartCell) this._updateEffectOptions.transformFeedbackVaryings.push("outCellStartOffset");
        }
        this._updateEffectOptions.defines = defines;
        this._updateEffect = new (0, $lUDWq.Effect)("gpuUpdateParticles", this._updateEffectOptions, this._engine);
        return new (0, $eKP8e.UniformBufferEffectCommonAccessor)(this._updateEffect);
    }
    createVertexBuffers(updateBuffer, renderVertexBuffers) {
        this._updateVAO.push(this._createUpdateVAO(updateBuffer));
        this._renderVAO.push(this._engine.recordVertexArrayObject(renderVertexBuffers, null, this._parent._getWrapper(this._parent.blendMode).effect));
        this._engine.bindArrayBuffer(null);
        this._renderVertexBuffers = renderVertexBuffers;
    }
    createParticleBuffer(data) {
        return data;
    }
    bindDrawBuffers(index, effect, indexBuffer) {
        if (indexBuffer) this._engine.bindBuffers(this._renderVertexBuffers, indexBuffer, effect);
        else this._engine.bindVertexArrayObject(this._renderVAO[index], null);
    }
    preUpdateParticleBuffer() {
        const engine = this._engine;
        this._engine.enableEffect(this._updateEffect);
        if (!engine.setState) throw new Error("GPU particles cannot work without a full Engine. ThinEngine is not supported");
    }
    updateParticleBuffer(index, targetBuffer, currentActiveCount) {
        this._updateEffect.setTexture("randomSampler", this._parent._randomTexture);
        this._updateEffect.setTexture("randomSampler2", this._parent._randomTexture2);
        if (this._parent._sizeGradientsTexture) this._updateEffect.setTexture("sizeGradientSampler", this._parent._sizeGradientsTexture);
        if (this._parent._angularSpeedGradientsTexture) this._updateEffect.setTexture("angularSpeedGradientSampler", this._parent._angularSpeedGradientsTexture);
        if (this._parent._velocityGradientsTexture) this._updateEffect.setTexture("velocityGradientSampler", this._parent._velocityGradientsTexture);
        if (this._parent._limitVelocityGradientsTexture) this._updateEffect.setTexture("limitVelocityGradientSampler", this._parent._limitVelocityGradientsTexture);
        if (this._parent._dragGradientsTexture) this._updateEffect.setTexture("dragGradientSampler", this._parent._dragGradientsTexture);
        if (this._parent.noiseTexture) this._updateEffect.setTexture("noiseSampler", this._parent.noiseTexture);
        // Bind source VAO
        this._engine.bindVertexArrayObject(this._updateVAO[index], null);
        // Update
        const engine = this._engine;
        engine.bindTransformFeedbackBuffer(targetBuffer.getBuffer());
        engine.setRasterizerState(false);
        engine.beginTransformFeedback(true);
        engine.drawArraysType(3, 0, currentActiveCount);
        engine.endTransformFeedback();
        engine.setRasterizerState(true);
        engine.bindTransformFeedbackBuffer(null);
    }
    releaseBuffers() {}
    releaseVertexBuffers() {
        for(let index = 0; index < this._updateVAO.length; index++)this._engine.releaseVertexArrayObject(this._updateVAO[index]);
        this._updateVAO.length = 0;
        for(let index = 0; index < this._renderVAO.length; index++)this._engine.releaseVertexArrayObject(this._renderVAO[index]);
        this._renderVAO.length = 0;
    }
    _createUpdateVAO(source) {
        const updateVertexBuffers = {};
        updateVertexBuffers["position"] = source.createVertexBuffer("position", 0, 3);
        let offset = 3;
        updateVertexBuffers["age"] = source.createVertexBuffer("age", offset, 1);
        offset += 1;
        updateVertexBuffers["size"] = source.createVertexBuffer("size", offset, 3);
        offset += 3;
        updateVertexBuffers["life"] = source.createVertexBuffer("life", offset, 1);
        offset += 1;
        updateVertexBuffers["seed"] = source.createVertexBuffer("seed", offset, 4);
        offset += 4;
        updateVertexBuffers["direction"] = source.createVertexBuffer("direction", offset, 3);
        offset += 3;
        if (this._parent.particleEmitterType instanceof (0, $bnmc3.CustomParticleEmitter)) {
            updateVertexBuffers["initialPosition"] = source.createVertexBuffer("initialPosition", offset, 3);
            offset += 3;
        }
        if (!this._parent._colorGradientsTexture) {
            updateVertexBuffers["color"] = source.createVertexBuffer("color", offset, 4);
            offset += 4;
        }
        if (!this._parent._isBillboardBased) {
            updateVertexBuffers["initialDirection"] = source.createVertexBuffer("initialDirection", offset, 3);
            offset += 3;
        }
        if (this._parent.noiseTexture) {
            updateVertexBuffers["noiseCoordinates1"] = source.createVertexBuffer("noiseCoordinates1", offset, 3);
            offset += 3;
            updateVertexBuffers["noiseCoordinates2"] = source.createVertexBuffer("noiseCoordinates2", offset, 3);
            offset += 3;
        }
        if (this._parent._angularSpeedGradientsTexture) {
            updateVertexBuffers["angle"] = source.createVertexBuffer("angle", offset, 1);
            offset += 1;
        } else {
            updateVertexBuffers["angle"] = source.createVertexBuffer("angle", offset, 2);
            offset += 2;
        }
        if (this._parent._isAnimationSheetEnabled) {
            updateVertexBuffers["cellIndex"] = source.createVertexBuffer("cellIndex", offset, 1);
            offset += 1;
            if (this._parent.spriteRandomStartCell) {
                updateVertexBuffers["cellStartOffset"] = source.createVertexBuffer("cellStartOffset", offset, 1);
                offset += 1;
            }
        }
        const vao = this._engine.recordVertexArrayObject(updateVertexBuffers, null, this._updateEffect);
        this._engine.bindArrayBuffer(null);
        return vao;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.WebGL2ParticleSystem", $f9abadeea99a7e66$export$7c821840848e1882);

});
parcelRegister("eKP8e", function(module, exports) {

$parcel$export(module.exports, "UniformBufferEffectCommonAccessor", () => $abdd0642f5a47d3f$export$e49e3a99e2505dbe);
/** @internal */ class $abdd0642f5a47d3f$export$e49e3a99e2505dbe {
    _isUbo(uboOrEffect) {
        return uboOrEffect.addUniform !== undefined;
    }
    constructor(uboOrEffect){
        if (this._isUbo(uboOrEffect)) {
            this.setMatrix3x3 = uboOrEffect.updateMatrix3x3.bind(uboOrEffect);
            this.setMatrix2x2 = uboOrEffect.updateMatrix2x2.bind(uboOrEffect);
            this.setFloat = uboOrEffect.updateFloat.bind(uboOrEffect);
            this.setFloat2 = uboOrEffect.updateFloat2.bind(uboOrEffect);
            this.setFloat3 = uboOrEffect.updateFloat3.bind(uboOrEffect);
            this.setFloat4 = uboOrEffect.updateFloat4.bind(uboOrEffect);
            this.setFloatArray = uboOrEffect.updateFloatArray.bind(uboOrEffect);
            this.setArray = uboOrEffect.updateArray.bind(uboOrEffect);
            this.setIntArray = uboOrEffect.updateIntArray.bind(uboOrEffect);
            this.setMatrix = uboOrEffect.updateMatrix.bind(uboOrEffect);
            this.setMatrices = uboOrEffect.updateMatrices.bind(uboOrEffect);
            this.setVector3 = uboOrEffect.updateVector3.bind(uboOrEffect);
            this.setVector4 = uboOrEffect.updateVector4.bind(uboOrEffect);
            this.setColor3 = uboOrEffect.updateColor3.bind(uboOrEffect);
            this.setColor4 = uboOrEffect.updateColor4.bind(uboOrEffect);
            this.setDirectColor4 = uboOrEffect.updateDirectColor4.bind(uboOrEffect);
            this.setInt = uboOrEffect.updateInt.bind(uboOrEffect);
            this.setInt2 = uboOrEffect.updateInt2.bind(uboOrEffect);
            this.setInt3 = uboOrEffect.updateInt3.bind(uboOrEffect);
            this.setInt4 = uboOrEffect.updateInt4.bind(uboOrEffect);
        } else {
            this.setMatrix3x3 = uboOrEffect.setMatrix3x3.bind(uboOrEffect);
            this.setMatrix2x2 = uboOrEffect.setMatrix2x2.bind(uboOrEffect);
            this.setFloat = uboOrEffect.setFloat.bind(uboOrEffect);
            this.setFloat2 = uboOrEffect.setFloat2.bind(uboOrEffect);
            this.setFloat3 = uboOrEffect.setFloat3.bind(uboOrEffect);
            this.setFloat4 = uboOrEffect.setFloat4.bind(uboOrEffect);
            this.setFloatArray = uboOrEffect.setFloatArray.bind(uboOrEffect);
            this.setArray = uboOrEffect.setArray.bind(uboOrEffect);
            this.setIntArray = uboOrEffect.setIntArray.bind(uboOrEffect);
            this.setMatrix = uboOrEffect.setMatrix.bind(uboOrEffect);
            this.setMatrices = uboOrEffect.setMatrices.bind(uboOrEffect);
            this.setVector3 = uboOrEffect.setVector3.bind(uboOrEffect);
            this.setVector4 = uboOrEffect.setVector4.bind(uboOrEffect);
            this.setColor3 = uboOrEffect.setColor3.bind(uboOrEffect);
            this.setColor4 = uboOrEffect.setColor4.bind(uboOrEffect);
            this.setDirectColor4 = uboOrEffect.setDirectColor4.bind(uboOrEffect);
            this.setInt = uboOrEffect.setInt.bind(uboOrEffect);
            this.setInt2 = uboOrEffect.setInt2.bind(uboOrEffect);
            this.setInt3 = uboOrEffect.setInt3.bind(uboOrEffect);
            this.setInt4 = uboOrEffect.setInt4.bind(uboOrEffect);
        }
    }
}

});

parcelRegister("dBz5Z", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $9e79f456cbed0ef8$var$name = "gpuUpdateParticlesPixelShader";
const $9e79f456cbed0ef8$var$shader = `#version 300 es
void main() {discard;}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$9e79f456cbed0ef8$var$name] = $9e79f456cbed0ef8$var$shader;
const $9e79f456cbed0ef8$export$93f1e726d74279d4 = {
    name: $9e79f456cbed0ef8$var$name,
    shader: $9e79f456cbed0ef8$var$shader
};

});

parcelRegister("4wXW6", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $34c8a4a91d147003$var$name = "gpuUpdateParticlesVertexShader";
const $34c8a4a91d147003$var$shader = `#version 300 es
#define PI 3.14159
uniform float currentCount;uniform float timeDelta;uniform float stopFactor;
#ifndef LOCAL
uniform mat4 emitterWM;
#endif
uniform vec2 lifeTime;uniform vec2 emitPower;uniform vec2 sizeRange;uniform vec4 scaleRange;
#ifndef COLORGRADIENTS
uniform vec4 color1;uniform vec4 color2;
#endif
uniform vec3 gravity;uniform sampler2D randomSampler;uniform sampler2D randomSampler2;uniform vec4 angleRange;
#ifdef BOXEMITTER
uniform vec3 direction1;uniform vec3 direction2;uniform vec3 minEmitBox;uniform vec3 maxEmitBox;
#endif
#ifdef POINTEMITTER
uniform vec3 direction1;uniform vec3 direction2;
#endif
#ifdef HEMISPHERICEMITTER
uniform float radius;uniform float radiusRange;uniform float directionRandomizer;
#endif
#ifdef SPHEREEMITTER
uniform float radius;uniform float radiusRange;
#ifdef DIRECTEDSPHEREEMITTER
uniform vec3 direction1;uniform vec3 direction2;
#else
uniform float directionRandomizer;
#endif
#endif
#ifdef CYLINDEREMITTER
uniform float radius;uniform float height;uniform float radiusRange;
#ifdef DIRECTEDCYLINDEREMITTER
uniform vec3 direction1;uniform vec3 direction2;
#else
uniform float directionRandomizer;
#endif
#endif
#ifdef CONEEMITTER
uniform vec2 radius;uniform float coneAngle;uniform vec2 height;uniform float directionRandomizer;
#endif
in vec3 position;
#ifdef CUSTOMEMITTER
in vec3 initialPosition;
#endif
in float age;in float life;in vec4 seed;in vec3 size;
#ifndef COLORGRADIENTS
in vec4 color;
#endif
in vec3 direction;
#ifndef BILLBOARD
in vec3 initialDirection;
#endif
#ifdef ANGULARSPEEDGRADIENTS
in float angle;
#else
in vec2 angle;
#endif
#ifdef ANIMATESHEET
in float cellIndex;
#ifdef ANIMATESHEETRANDOMSTART
in float cellStartOffset;
#endif
#endif
#ifdef NOISE
in vec3 noiseCoordinates1;in vec3 noiseCoordinates2;
#endif
out vec3 outPosition;
#ifdef CUSTOMEMITTER
out vec3 outInitialPosition;
#endif
out float outAge;out float outLife;out vec4 outSeed;out vec3 outSize;
#ifndef COLORGRADIENTS
out vec4 outColor;
#endif
out vec3 outDirection;
#ifndef BILLBOARD
out vec3 outInitialDirection;
#endif
#ifdef ANGULARSPEEDGRADIENTS
out float outAngle;
#else
out vec2 outAngle;
#endif
#ifdef ANIMATESHEET
out float outCellIndex;
#ifdef ANIMATESHEETRANDOMSTART
out float outCellStartOffset;
#endif
#endif
#ifdef NOISE
out vec3 outNoiseCoordinates1;out vec3 outNoiseCoordinates2;
#endif
#ifdef SIZEGRADIENTS
uniform sampler2D sizeGradientSampler;
#endif 
#ifdef ANGULARSPEEDGRADIENTS
uniform sampler2D angularSpeedGradientSampler;
#endif 
#ifdef VELOCITYGRADIENTS
uniform sampler2D velocityGradientSampler;
#endif
#ifdef LIMITVELOCITYGRADIENTS
uniform sampler2D limitVelocityGradientSampler;uniform float limitVelocityDamping;
#endif
#ifdef DRAGGRADIENTS
uniform sampler2D dragGradientSampler;
#endif
#ifdef NOISE
uniform vec3 noiseStrength;uniform sampler2D noiseSampler;
#endif
#ifdef ANIMATESHEET
uniform vec4 cellInfos;
#endif
vec3 getRandomVec3(float offset) {return texture(randomSampler2,vec2(float(gl_VertexID)*offset/currentCount,0)).rgb;}
vec4 getRandomVec4(float offset) {return texture(randomSampler,vec2(float(gl_VertexID)*offset/currentCount,0));}
void main() {float newAge=age+timeDelta; 
if (newAge>=life && stopFactor != 0.) {vec3 newPosition;vec3 newDirection;vec4 randoms=getRandomVec4(seed.x);outLife=lifeTime.x+(lifeTime.y-lifeTime.x)*randoms.r;outAge=newAge-life;outSeed=seed;
#ifdef SIZEGRADIENTS 
outSize.x=texture(sizeGradientSampler,vec2(0,0)).r;
#else
outSize.x=sizeRange.x+(sizeRange.y-sizeRange.x)*randoms.g;
#endif
outSize.y=scaleRange.x+(scaleRange.y-scaleRange.x)*randoms.b;outSize.z=scaleRange.z+(scaleRange.w-scaleRange.z)*randoms.a; 
#ifndef COLORGRADIENTS
outColor=color1+(color2-color1)*randoms.b;
#endif
#ifndef ANGULARSPEEDGRADIENTS 
outAngle.y=angleRange.x+(angleRange.y-angleRange.x)*randoms.a;outAngle.x=angleRange.z+(angleRange.w-angleRange.z)*randoms.r;
#else
outAngle=angleRange.z+(angleRange.w-angleRange.z)*randoms.r;
#endif 
#ifdef POINTEMITTER
vec3 randoms2=getRandomVec3(seed.y);vec3 randoms3=getRandomVec3(seed.z);newPosition=vec3(0,0,0);newDirection=direction1+(direction2-direction1)*randoms3;
#elif defined(BOXEMITTER)
vec3 randoms2=getRandomVec3(seed.y);vec3 randoms3=getRandomVec3(seed.z);newPosition=minEmitBox+(maxEmitBox-minEmitBox)*randoms2;newDirection=direction1+(direction2-direction1)*randoms3; 
#elif defined(HEMISPHERICEMITTER)
vec3 randoms2=getRandomVec3(seed.y);vec3 randoms3=getRandomVec3(seed.z);float phi=2.0*PI*randoms2.x;float theta=acos(2.0*randoms2.y-1.0);float randX=cos(phi)*sin(theta);float randY=cos(theta);float randZ=sin(phi)*sin(theta);newPosition=(radius-(radius*radiusRange*randoms2.z))*vec3(randX,abs(randY),randZ);newDirection=newPosition+directionRandomizer*randoms3; 
#elif defined(SPHEREEMITTER)
vec3 randoms2=getRandomVec3(seed.y);vec3 randoms3=getRandomVec3(seed.z);float phi=2.0*PI*randoms2.x;float theta=acos(2.0*randoms2.y-1.0);float randX=cos(phi)*sin(theta);float randY=cos(theta);float randZ=sin(phi)*sin(theta);newPosition=(radius-(radius*radiusRange*randoms2.z))*vec3(randX,randY,randZ);
#ifdef DIRECTEDSPHEREEMITTER
newDirection=normalize(direction1+(direction2-direction1)*randoms3);
#else
newDirection=normalize(newPosition+directionRandomizer*randoms3);
#endif
#elif defined(CYLINDEREMITTER)
vec3 randoms2=getRandomVec3(seed.y);vec3 randoms3=getRandomVec3(seed.z);float yPos=(randoms2.x-0.5)*height;float angle=randoms2.y*PI*2.;float inverseRadiusRangeSquared=((1.-radiusRange)*(1.-radiusRange));float positionRadius=radius*sqrt(inverseRadiusRangeSquared+(randoms2.z*(1.-inverseRadiusRangeSquared)));float xPos=positionRadius*cos(angle);float zPos=positionRadius*sin(angle);newPosition=vec3(xPos,yPos,zPos);
#ifdef DIRECTEDCYLINDEREMITTER
newDirection=direction1+(direction2-direction1)*randoms3;
#else
angle=angle+((randoms3.x-0.5)*PI)*directionRandomizer;newDirection=vec3(cos(angle),(randoms3.y-0.5)*directionRandomizer,sin(angle));newDirection=normalize(newDirection);
#endif
#elif defined(CONEEMITTER)
vec3 randoms2=getRandomVec3(seed.y);float s=2.0*PI*randoms2.x;
#ifdef CONEEMITTERSPAWNPOINT
float h=0.0001;
#else
float h=randoms2.y*height.y;h=1.-h*h; 
#endif
float lRadius=radius.x-radius.x*randoms2.z*radius.y;lRadius=lRadius*h;float randX=lRadius*sin(s);float randZ=lRadius*cos(s);float randY=h *height.x;newPosition=vec3(randX,randY,randZ); 
if (abs(cos(coneAngle))==1.0) {newDirection=vec3(0.,1.0,0.);} else {vec3 randoms3=getRandomVec3(seed.z);newDirection=normalize(newPosition+directionRandomizer*randoms3); }
#elif defined(CUSTOMEMITTER)
newPosition=initialPosition;outInitialPosition=initialPosition;
#else 
newPosition=vec3(0.,0.,0.);newDirection=2.0*(getRandomVec3(seed.w)-vec3(0.5,0.5,0.5));
#endif
float power=emitPower.x+(emitPower.y-emitPower.x)*randoms.a;
#ifdef LOCAL
outPosition=newPosition;
#else
outPosition=(emitterWM*vec4(newPosition,1.)).xyz;
#endif
#ifdef CUSTOMEMITTER
outDirection=direction;
#ifndef BILLBOARD 
outInitialDirection=direction;
#endif
#else
#ifdef LOCAL
vec3 initial=newDirection;
#else 
vec3 initial=(emitterWM*vec4(newDirection,0.)).xyz;
#endif
outDirection=initial*power;
#ifndef BILLBOARD 
outInitialDirection=initial;
#endif
#endif
#ifdef ANIMATESHEET 
outCellIndex=cellInfos.x;
#ifdef ANIMATESHEETRANDOMSTART
outCellStartOffset=randoms.a*outLife;
#endif 
#endif
#ifdef NOISE
outNoiseCoordinates1=noiseCoordinates1;outNoiseCoordinates2=noiseCoordinates2;
#endif
} else {float directionScale=timeDelta;outAge=newAge;float ageGradient=newAge/life;
#ifdef VELOCITYGRADIENTS
directionScale*=texture(velocityGradientSampler,vec2(ageGradient,0)).r;
#endif
#ifdef DRAGGRADIENTS
directionScale*=1.0-texture(dragGradientSampler,vec2(ageGradient,0)).r;
#endif
#if defined(CUSTOMEMITTER)
outPosition=position+(direction-position)*ageGradient; 
outInitialPosition=initialPosition;
#else
outPosition=position+direction*directionScale;
#endif
outLife=life;outSeed=seed;
#ifndef COLORGRADIENTS 
outColor=color;
#endif
#ifdef SIZEGRADIENTS
outSize.x=texture(sizeGradientSampler,vec2(ageGradient,0)).r;outSize.yz=size.yz;
#else
outSize=size;
#endif 
#ifndef BILLBOARD 
outInitialDirection=initialDirection;
#endif
#ifdef CUSTOMEMITTER
outDirection=direction;
#else
vec3 updatedDirection=direction+gravity*timeDelta;
#ifdef LIMITVELOCITYGRADIENTS
float limitVelocity=texture(limitVelocityGradientSampler,vec2(ageGradient,0)).r;float currentVelocity=length(updatedDirection);if (currentVelocity>limitVelocity) {updatedDirection=updatedDirection*limitVelocityDamping;}
#endif
outDirection=updatedDirection;
#ifdef NOISE
float fetchedR=texture(noiseSampler,vec2(noiseCoordinates1.x,noiseCoordinates1.y)*vec2(0.5)+vec2(0.5)).r;float fetchedG=texture(noiseSampler,vec2(noiseCoordinates1.z,noiseCoordinates2.x)*vec2(0.5)+vec2(0.5)).r;float fetchedB=texture(noiseSampler,vec2(noiseCoordinates2.y,noiseCoordinates2.z)*vec2(0.5)+vec2(0.5)).r;vec3 force=vec3(2.*fetchedR-1.,2.*fetchedG-1.,2.*fetchedB-1.)*noiseStrength;outDirection=outDirection+force*timeDelta;outNoiseCoordinates1=noiseCoordinates1;outNoiseCoordinates2=noiseCoordinates2;
#endif 
#endif 
#ifdef ANGULARSPEEDGRADIENTS
float angularSpeed=texture(angularSpeedGradientSampler,vec2(ageGradient,0)).r;outAngle=angle+angularSpeed*timeDelta;
#else
outAngle=vec2(angle.x+angle.y*timeDelta,angle.y);
#endif
#ifdef ANIMATESHEET 
float offsetAge=outAge;float dist=cellInfos.y-cellInfos.x;
#ifdef ANIMATESHEETRANDOMSTART
outCellStartOffset=cellStartOffset;offsetAge+=cellStartOffset;
#else
float cellStartOffset=0.;
#endif 
float ratio=0.;if (cellInfos.w==1.0) {ratio=clamp(mod(cellStartOffset+cellInfos.z*offsetAge,life)/life,0.,1.0);}
else {ratio=clamp(cellStartOffset+cellInfos.z*offsetAge/life,0.,1.0);}
outCellIndex=float(int(cellInfos.x+ratio*dist));
#endif
}}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$34c8a4a91d147003$var$name] = $34c8a4a91d147003$var$shader;
const $34c8a4a91d147003$export$2c46c186495c739e = {
    name: $34c8a4a91d147003$var$name,
    shader: $34c8a4a91d147003$var$shader
};

});


parcelRegister("AAqid", function(module, exports) {

$parcel$export(module.exports, "ComputeShaderParticleSystem", () => $06df9dc5a594bd0f$export$b49e0fc664ef28f8);

var $87EOs = parcelRequire("87EOs");

var $iX4ps = parcelRequire("iX4ps");

var $ghoTi = parcelRequire("ghoTi");

var $eKP8e = parcelRequire("eKP8e");

var $8DoUR = parcelRequire("8DoUR");
parcelRequire("l5WRu");
class $06df9dc5a594bd0f$export$b49e0fc664ef28f8 {
    constructor(parent, engine){
        this._bufferComputeShader = [];
        this._renderVertexBuffers = [];
        this.alignDataInBuffer = true;
        this._parent = parent;
        this._engine = engine;
    }
    contextLost() {
        this._updateComputeShader = undefined;
        this._bufferComputeShader.length = 0;
        this._renderVertexBuffers.length = 0;
    }
    isUpdateBufferCreated() {
        return !!this._updateComputeShader;
    }
    isUpdateBufferReady() {
        return this._updateComputeShader?.isReady() ?? false;
    }
    createUpdateBuffer(defines) {
        const bindingsMapping = {
            params: {
                group: 0,
                binding: 0
            },
            particlesIn: {
                group: 0,
                binding: 1
            },
            particlesOut: {
                group: 0,
                binding: 2
            },
            randomTexture: {
                group: 0,
                binding: 3
            },
            randomTexture2: {
                group: 0,
                binding: 4
            }
        };
        if (this._parent._sizeGradientsTexture) bindingsMapping["sizeGradientTexture"] = {
            group: 1,
            binding: 1
        };
        if (this._parent._angularSpeedGradientsTexture) bindingsMapping["angularSpeedGradientTexture"] = {
            group: 1,
            binding: 3
        };
        if (this._parent._velocityGradientsTexture) bindingsMapping["velocityGradientTexture"] = {
            group: 1,
            binding: 5
        };
        if (this._parent._limitVelocityGradientsTexture) bindingsMapping["limitVelocityGradientTexture"] = {
            group: 1,
            binding: 7
        };
        if (this._parent._dragGradientsTexture) bindingsMapping["dragGradientTexture"] = {
            group: 1,
            binding: 9
        };
        if (this._parent.noiseTexture) bindingsMapping["noiseTexture"] = {
            group: 1,
            binding: 11
        };
        this._updateComputeShader = new (0, $iX4ps.ComputeShader)("updateParticles", this._engine, "gpuUpdateParticles", {
            bindingsMapping: bindingsMapping,
            defines: defines.split("\n")
        });
        this._simParamsComputeShader?.dispose();
        this._simParamsComputeShader = new (0, $ghoTi.UniformBuffer)(this._engine, undefined, undefined, "ComputeShaderParticleSystemUBO");
        this._simParamsComputeShader.addUniform("currentCount", 1);
        this._simParamsComputeShader.addUniform("timeDelta", 1);
        this._simParamsComputeShader.addUniform("stopFactor", 1);
        this._simParamsComputeShader.addUniform("randomTextureSize", 1);
        this._simParamsComputeShader.addUniform("lifeTime", 2);
        this._simParamsComputeShader.addUniform("emitPower", 2);
        if (!this._parent._colorGradientsTexture) {
            this._simParamsComputeShader.addUniform("color1", 4);
            this._simParamsComputeShader.addUniform("color2", 4);
        }
        this._simParamsComputeShader.addUniform("sizeRange", 2);
        this._simParamsComputeShader.addUniform("scaleRange", 4);
        this._simParamsComputeShader.addUniform("angleRange", 4);
        this._simParamsComputeShader.addUniform("gravity", 3);
        if (this._parent._limitVelocityGradientsTexture) this._simParamsComputeShader.addUniform("limitVelocityDamping", 1);
        if (this._parent.isAnimationSheetEnabled) this._simParamsComputeShader.addUniform("cellInfos", 4);
        if (this._parent.noiseTexture) this._simParamsComputeShader.addUniform("noiseStrength", 3);
        if (!this._parent.isLocal) this._simParamsComputeShader.addUniform("emitterWM", 16);
        if (this._parent.particleEmitterType) this._parent.particleEmitterType.buildUniformLayout(this._simParamsComputeShader);
        this._updateComputeShader.setUniformBuffer("params", this._simParamsComputeShader);
        return new (0, $eKP8e.UniformBufferEffectCommonAccessor)(this._simParamsComputeShader);
    }
    createVertexBuffers(updateBuffer, renderVertexBuffers) {
        this._renderVertexBuffers.push(renderVertexBuffers);
    }
    createParticleBuffer(data) {
        const buffer = new (0, $87EOs.StorageBuffer)(this._engine, data.length * 4, 11, "ComputeShaderParticleSystemBuffer");
        buffer.update(data);
        this._bufferComputeShader.push(buffer);
        return buffer.getBuffer();
    }
    bindDrawBuffers(index, effect, indexBuffer) {
        this._engine.bindBuffers(this._renderVertexBuffers[index], indexBuffer, effect);
    }
    preUpdateParticleBuffer() {}
    updateParticleBuffer(index, targetBuffer, currentActiveCount) {
        this._simParamsComputeShader.update();
        this._updateComputeShader.setTexture("randomTexture", this._parent._randomTexture, false);
        this._updateComputeShader.setTexture("randomTexture2", this._parent._randomTexture2, false);
        if (this._parent._sizeGradientsTexture) this._updateComputeShader.setTexture("sizeGradientTexture", this._parent._sizeGradientsTexture);
        if (this._parent._angularSpeedGradientsTexture) this._updateComputeShader.setTexture("angularSpeedGradientTexture", this._parent._angularSpeedGradientsTexture);
        if (this._parent._velocityGradientsTexture) this._updateComputeShader.setTexture("velocityGradientTexture", this._parent._velocityGradientsTexture);
        if (this._parent._limitVelocityGradientsTexture) this._updateComputeShader.setTexture("limitVelocityGradientTexture", this._parent._limitVelocityGradientsTexture);
        if (this._parent._dragGradientsTexture) this._updateComputeShader.setTexture("dragGradientTexture", this._parent._dragGradientsTexture);
        if (this._parent.noiseTexture) this._updateComputeShader.setTexture("noiseTexture", this._parent.noiseTexture);
        this._updateComputeShader.setStorageBuffer("particlesIn", this._bufferComputeShader[index]);
        this._updateComputeShader.setStorageBuffer("particlesOut", this._bufferComputeShader[index ^ 1]);
        this._updateComputeShader.dispatch(Math.ceil(currentActiveCount / 64));
    }
    releaseBuffers() {
        for(let i = 0; i < this._bufferComputeShader.length; ++i)this._bufferComputeShader[i].dispose();
        this._bufferComputeShader.length = 0;
        this._simParamsComputeShader?.dispose();
        this._simParamsComputeShader = null;
        this._updateComputeShader = null;
    }
    releaseVertexBuffers() {
        this._renderVertexBuffers.length = 0;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.ComputeShaderParticleSystem", $06df9dc5a594bd0f$export$b49e0fc664ef28f8);

});
parcelRegister("l5WRu", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $f5b7b950021dfbce$var$name = "gpuUpdateParticlesComputeShader";
const $f5b7b950021dfbce$var$shader = `struct Particle {position : vec3<f32>,
age : f32,
size : vec3<f32>,
life : f32,
seed : vec4<f32>,
direction : vec3<f32>,
dummy0: f32,
#ifdef CUSTOMEMITTER
initialPosition : vec3<f32>,
dummy1: f32,
#endif
#ifndef COLORGRADIENTS
color : vec4<f32>,
#endif
#ifndef BILLBOARD
initialDirection : vec3<f32>,
dummy2: f32,
#endif
#ifdef NOISE
noiseCoordinates1 : vec3<f32>,
dummy3: f32,
noiseCoordinates2 : vec3<f32>,
dummy4: f32,
#endif
#ifdef ANGULARSPEEDGRADIENTS
angle : f32,
#else
angle : vec2<f32>,
#endif
#ifdef ANIMATESHEET
cellIndex : f32,
#ifdef ANIMATESHEETRANDOMSTART
cellStartOffset : f32,
#endif
#endif
};struct Particles {particles : array<Particle>,};struct SimParams {currentCount : f32,
timeDelta : f32,
stopFactor : f32,
randomTextureSize: i32,
lifeTime : vec2<f32>,
emitPower : vec2<f32>,
#ifndef COLORGRADIENTS
color1 : vec4<f32>,
color2 : vec4<f32>,
#endif
sizeRange : vec2<f32>,
scaleRange : vec4<f32>,
angleRange : vec4<f32>,
gravity : vec3<f32>,
#ifdef LIMITVELOCITYGRADIENTS
limitVelocityDamping : f32,
#endif
#ifdef ANIMATESHEET
cellInfos : vec4<f32>,
#endif
#ifdef NOISE
noiseStrength : vec3<f32>,
#endif
#ifndef LOCAL
emitterWM : mat4x4<f32>,
#endif
#ifdef BOXEMITTER
direction1 : vec3<f32>,
direction2 : vec3<f32>,
minEmitBox : vec3<f32>,
maxEmitBox : vec3<f32>,
#endif
#ifdef CONEEMITTER
radius : vec2<f32>,
coneAngle : f32,
height : vec2<f32>,
directionRandomizer : f32,
#endif
#ifdef CYLINDEREMITTER
radius : f32,
height : f32,
radiusRange : f32,
#ifdef DIRECTEDCYLINDEREMITTER
direction1 : vec3<f32>,
direction2 : vec3<f32>,
#else
directionRandomizer : f32,
#endif
#endif
#ifdef HEMISPHERICEMITTER
radius : f32,
radiusRange : f32,
directionRandomizer : f32,
#endif
#ifdef POINTEMITTER
direction1 : vec3<f32>,
direction2 : vec3<f32>,
#endif
#ifdef SPHEREEMITTER
radius : f32,
radiusRange : f32,
#ifdef DIRECTEDSPHEREEMITTER
direction1 : vec3<f32>,
direction2 : vec3<f32>,
#else
directionRandomizer : f32,
#endif
#endif
};@binding(0) @group(0) var<uniform> params : SimParams;@binding(1) @group(0) var<storage,read> particlesIn : Particles;@binding(2) @group(0) var<storage,read_write> particlesOut : Particles;@binding(3) @group(0) var randomTexture : texture_2d<f32>;@binding(4) @group(0) var randomTexture2 : texture_2d<f32>;
#ifdef SIZEGRADIENTS
@binding(0) @group(1) var sizeGradientSampler : sampler;@binding(1) @group(1) var sizeGradientTexture : texture_2d<f32>;
#endif 
#ifdef ANGULARSPEEDGRADIENTS
@binding(2) @group(1) var angularSpeedGradientSampler : sampler;@binding(3) @group(1) var angularSpeedGradientTexture : texture_2d<f32>;
#endif 
#ifdef VELOCITYGRADIENTS
@binding(4) @group(1) var velocityGradientSampler : sampler;@binding(5) @group(1) var velocityGradientTexture : texture_2d<f32>;
#endif
#ifdef LIMITVELOCITYGRADIENTS
@binding(6) @group(1) var limitVelocityGradientSampler : sampler;@binding(7) @group(1) var limitVelocityGradientTexture : texture_2d<f32>;
#endif
#ifdef DRAGGRADIENTS
@binding(8) @group(1) var dragGradientSampler : sampler;@binding(9) @group(1) var dragGradientTexture : texture_2d<f32>;
#endif
#ifdef NOISE
@binding(10) @group(1) var noiseSampler : sampler;@binding(11) @group(1) var noiseTexture : texture_2d<f32>;
#endif
fn getRandomVec3(offset : f32,vertexID : f32)->vec3<f32> {return textureLoad(randomTexture2,vec2<i32>(i32(vertexID*offset/params.currentCount*f32(params.randomTextureSize)) % params.randomTextureSize,0),0).rgb;}
fn getRandomVec4(offset : f32,vertexID : f32)->vec4<f32> {return textureLoad(randomTexture,vec2<i32>(i32(vertexID*offset/params.currentCount*f32(params.randomTextureSize)) % params.randomTextureSize,0),0);}
@compute @workgroup_size(64)
fn main(@builtin(global_invocation_id) GlobalInvocationID : vec3<u32>) {let index : u32=GlobalInvocationID.x;let vertexID : f32=f32(index);if (index>=u32(params.currentCount)) {return;}
let PI : f32=3.14159;let timeDelta : f32=params.timeDelta;let newAge : f32=particlesIn.particles[index].age+timeDelta;let life : f32=particlesIn.particles[index].life;let seed : vec4<f32>=particlesIn.particles[index].seed;let direction : vec3<f32>=particlesIn.particles[index].direction;if (newAge>=life && params.stopFactor != 0.) {var newPosition : vec3<f32>;var newDirection : vec3<f32>;let randoms : vec4<f32>=getRandomVec4(seed.x,vertexID);let outLife : f32=params.lifeTime.x+(params.lifeTime.y-params.lifeTime.x)*randoms.r;particlesOut.particles[index].life=outLife;particlesOut.particles[index].age=newAge-life;particlesOut.particles[index].seed=seed;var sizex : f32;
#ifdef SIZEGRADIENTS 
sizex=textureSampleLevel(sizeGradientTexture,sizeGradientSampler,vec2<f32>(0.,0.),0.).r;
#else
sizex=params.sizeRange.x+(params.sizeRange.y-params.sizeRange.x)*randoms.g;
#endif
particlesOut.particles[index].size=vec3<f32>(
sizex,
params.scaleRange.x+(params.scaleRange.y-params.scaleRange.x)*randoms.b,
params.scaleRange.z+(params.scaleRange.w-params.scaleRange.z)*randoms.a);
#ifndef COLORGRADIENTS
particlesOut.particles[index].color=params.color1+(params.color2-params.color1)*randoms.b;
#endif
#ifndef ANGULARSPEEDGRADIENTS 
particlesOut.particles[index].angle=vec2<f32>(
params.angleRange.z+(params.angleRange.w-params.angleRange.z)*randoms.r,
params.angleRange.x+(params.angleRange.y-params.angleRange.x)*randoms.a);
#else
particlesOut.particles[index].angle=params.angleRange.z+(params.angleRange.w-params.angleRange.z)*randoms.r;
#endif 
#if defined(POINTEMITTER)
let randoms2 : vec3<f32>=getRandomVec3(seed.y,vertexID);let randoms3 : vec3<f32>=getRandomVec3(seed.z,vertexID);newPosition=vec3<f32>(0.,0.,0.);newDirection=params.direction1+(params.direction2-params.direction1)*randoms3;
#elif defined(BOXEMITTER)
let randoms2 : vec3<f32>=getRandomVec3(seed.y,vertexID);let randoms3 : vec3<f32>=getRandomVec3(seed.z,vertexID);newPosition=params.minEmitBox+(params.maxEmitBox-params.minEmitBox)*randoms2;newDirection=params.direction1+(params.direction2-params.direction1)*randoms3; 
#elif defined(HEMISPHERICEMITTER)
let randoms2 : vec3<f32>=getRandomVec3(seed.y,vertexID);let randoms3 : vec3<f32>=getRandomVec3(seed.z,vertexID);let phi : f32=2.0*PI*randoms2.x;let theta : f32=acos(-1.0+2.0*randoms2.y);let randX : f32=cos(phi)*sin(theta);let randY : f32=cos(theta);let randZ : f32=sin(phi)*sin(theta);newPosition=(params.radius-(params.radius*params.radiusRange*randoms2.z))*vec3<f32>(randX,abs(randY),randZ);newDirection=normalize(newPosition+params.directionRandomizer*randoms3);
#elif defined(SPHEREEMITTER)
let randoms2 : vec3<f32>=getRandomVec3(seed.y,vertexID);let randoms3 : vec3<f32>=getRandomVec3(seed.z,vertexID);let phi : f32=2.0*PI*randoms2.x;let theta : f32=acos(-1.0+2.0*randoms2.y);let randX : f32=cos(phi)*sin(theta);let randY : f32=cos(theta);let randZ : f32=sin(phi)*sin(theta);newPosition=(params.radius-(params.radius*params.radiusRange*randoms2.z))*vec3<f32>(randX,randY,randZ);
#ifdef DIRECTEDSPHEREEMITTER
newDirection=normalize(params.direction1+(params.direction2-params.direction1)*randoms3);
#else
newDirection=normalize(newPosition+params.directionRandomizer*randoms3);
#endif
#elif defined(CYLINDEREMITTER)
let randoms2 : vec3<f32>=getRandomVec3(seed.y,vertexID);let randoms3 : vec3<f32>=getRandomVec3(seed.z,vertexID);let yPos : f32=(-0.5+randoms2.x)*params.height;var angle : f32=randoms2.y*PI*2.;let inverseRadiusRangeSquared : f32=(1.-params.radiusRange)*(1.-params.radiusRange);let positionRadius : f32=params.radius*sqrt(inverseRadiusRangeSquared+randoms2.z*(1.-inverseRadiusRangeSquared));let xPos : f32=positionRadius*cos(angle);let zPos : f32=positionRadius*sin(angle);newPosition=vec3<f32>(xPos,yPos,zPos);
#ifdef DIRECTEDCYLINDEREMITTER
newDirection=params.direction1+(params.direction2-params.direction1)*randoms3;
#else
angle=angle+(-0.5+randoms3.x)*PI*params.directionRandomizer;newDirection=vec3<f32>(cos(angle),(-0.5+randoms3.y)*params.directionRandomizer,sin(angle));newDirection=normalize(newDirection);
#endif
#elif defined(CONEEMITTER)
let randoms2 : vec3<f32>=getRandomVec3(seed.y,vertexID);let s : f32=2.0*PI*randoms2.x;
#ifdef CONEEMITTERSPAWNPOINT
let h : f32=0.0001;
#else
var h : f32=randoms2.y*params.height.y;h=1.-h*h; 
#endif
var lRadius : f32=params.radius.x-params.radius.x*randoms2.z*params.radius.y;lRadius=lRadius*h;let randX : f32=lRadius*sin(s);let randZ : f32=lRadius*cos(s);let randY : f32=h *params.height.x;newPosition=vec3<f32>(randX,randY,randZ); 
if (abs(cos(params.coneAngle))==1.0) {newDirection=vec3<f32>(0.,1.0,0.);} else {let randoms3 : vec3<f32>=getRandomVec3(seed.z,vertexID);newDirection=normalize(newPosition+params.directionRandomizer*randoms3); }
#elif defined(CUSTOMEMITTER)
newPosition=particlesIn.particles[index].initialPosition;particlesOut.particles[index].initialPosition=newPosition;
#else 
newPosition=vec3<f32>(0.,0.,0.);newDirection=2.0*(getRandomVec3(seed.w,vertexID)-vec3<f32>(0.5,0.5,0.5));
#endif
let power : f32=params.emitPower.x+(params.emitPower.y-params.emitPower.x)*randoms.a;
#ifdef LOCAL
particlesOut.particles[index].position=newPosition;
#else
particlesOut.particles[index].position=(params.emitterWM*vec4<f32>(newPosition,1.)).xyz;
#endif
#ifdef CUSTOMEMITTER
particlesOut.particles[index].direction=direction;
#ifndef BILLBOARD 
particlesOut.particles[index].initialDirection=direction;
#endif
#else
#ifdef LOCAL
let initial : vec3<f32>=newDirection;
#else 
let initial : vec3<f32>=(params.emitterWM*vec4<f32>(newDirection,0.)).xyz;
#endif
particlesOut.particles[index].direction=initial*power;
#ifndef BILLBOARD 
particlesOut.particles[index].initialDirection=initial;
#endif
#endif
#ifdef ANIMATESHEET 
particlesOut.particles[index].cellIndex=params.cellInfos.x;
#ifdef ANIMATESHEETRANDOMSTART
particlesOut.particles[index].cellStartOffset=randoms.a*outLife;
#endif 
#endif
#ifdef NOISE
particlesOut.particles[index].noiseCoordinates1=particlesIn.particles[index].noiseCoordinates1;particlesOut.particles[index].noiseCoordinates2=particlesIn.particles[index].noiseCoordinates2;
#endif
} else {var directionScale : f32=timeDelta;particlesOut.particles[index].age=newAge;let ageGradient : f32=newAge/life;
#ifdef VELOCITYGRADIENTS
directionScale=directionScale*textureSampleLevel(velocityGradientTexture,velocityGradientSampler,vec2<f32>(ageGradient,0.),0.).r;
#endif
#ifdef DRAGGRADIENTS
directionScale=directionScale*(1.0-textureSampleLevel(dragGradientTexture,dragGradientSampler,vec2<f32>(ageGradient,0.),0.).r);
#endif
let position : vec3<f32>=particlesIn.particles[index].position;
#if defined(CUSTOMEMITTER)
particlesOut.particles[index].position=position+(direction-position)*ageGradient; 
particlesOut.particles[index].initialPosition=particlesIn.particles[index].initialPosition;
#else
particlesOut.particles[index].position=position+direction*directionScale;
#endif
particlesOut.particles[index].life=life;particlesOut.particles[index].seed=seed;
#ifndef COLORGRADIENTS 
particlesOut.particles[index].color=particlesIn.particles[index].color;
#endif
#ifdef SIZEGRADIENTS
particlesOut.particles[index].size=vec3<f32>(
textureSampleLevel(sizeGradientTexture,sizeGradientSampler,vec2<f32>(ageGradient,0.),0.).r,
particlesIn.particles[index].size.yz);
#else
particlesOut.particles[index].size=particlesIn.particles[index].size;
#endif 
#ifndef BILLBOARD 
particlesOut.particles[index].initialDirection=particlesIn.particles[index].initialDirection;
#endif
#ifdef CUSTOMEMITTER
particlesOut.particles[index].direction=direction;
#else
var updatedDirection : vec3<f32>=direction+params.gravity*timeDelta;
#ifdef LIMITVELOCITYGRADIENTS
let limitVelocity : f32=textureSampleLevel(limitVelocityGradientTexture,limitVelocityGradientSampler,vec2<f32>(ageGradient,0.),0.).r;let currentVelocity : f32=length(updatedDirection);if (currentVelocity>limitVelocity) {updatedDirection=updatedDirection*params.limitVelocityDamping;}
#endif
particlesOut.particles[index].direction=updatedDirection;
#ifdef NOISE
let noiseCoordinates1 : vec3<f32>=particlesIn.particles[index].noiseCoordinates1;let noiseCoordinates2 : vec3<f32>=particlesIn.particles[index].noiseCoordinates2;let fetchedR : f32=textureSampleLevel(noiseTexture,noiseSampler,vec2<f32>(noiseCoordinates1.x,noiseCoordinates1.y)*vec2<f32>(0.5,0.5)+vec2<f32>(0.5,0.5),0.).r;let fetchedG : f32=textureSampleLevel(noiseTexture,noiseSampler,vec2<f32>(noiseCoordinates1.z,noiseCoordinates2.x)*vec2<f32>(0.5,0.5)+vec2<f32>(0.5,0.5),0.).r;let fetchedB : f32=textureSampleLevel(noiseTexture,noiseSampler,vec2<f32>(noiseCoordinates2.y,noiseCoordinates2.z)*vec2<f32>(0.5,0.5)+vec2<f32>(0.5,0.5),0.).r;let force : vec3<f32>=vec3<f32>(-1.+2.*fetchedR,-1.+2.*fetchedG,-1.+2.*fetchedB)*params.noiseStrength;particlesOut.particles[index].direction=particlesOut.particles[index].direction+force*timeDelta;particlesOut.particles[index].noiseCoordinates1=noiseCoordinates1;particlesOut.particles[index].noiseCoordinates2=noiseCoordinates2;
#endif 
#endif 
#ifdef ANGULARSPEEDGRADIENTS
let angularSpeed : f32=textureSampleLevel(angularSpeedGradientTexture,angularSpeedGradientSampler,vec2<f32>(ageGradient,0.),0.).r;particlesOut.particles[index].angle=particlesIn.particles[index].angle+angularSpeed*timeDelta;
#else
let angle : vec2<f32>=particlesIn.particles[index].angle;particlesOut.particles[index].angle=vec2<f32>(angle.x+angle.y*timeDelta,angle.y);
#endif
#ifdef ANIMATESHEET 
var offsetAge : f32=particlesOut.particles[index].age;let dist : f32=params.cellInfos.y-params.cellInfos.x;
#ifdef ANIMATESHEETRANDOMSTART
let cellStartOffset : f32=particlesIn.particles[index].cellStartOffset;particlesOut.particles[index].cellStartOffset=cellStartOffset;offsetAge=offsetAge+cellStartOffset;
#else
let cellStartOffset : f32=0.;
#endif 
var ratio : f32;if (params.cellInfos.w==1.0) {ratio=clamp(((cellStartOffset+params.cellInfos.z*offsetAge) % life)/life,0.,1.0);}
else {ratio=clamp((cellStartOffset+params.cellInfos.z*offsetAge)/life,0.,1.0);}
particlesOut.particles[index].cellIndex=f32(i32(params.cellInfos.x+ratio*dist));
#endif
}}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStoreWGSL[$f5b7b950021dfbce$var$name] = $f5b7b950021dfbce$var$shader;
const $f5b7b950021dfbce$export$b1c7e53d089c444a = {
    name: $f5b7b950021dfbce$var$name,
    shader: $f5b7b950021dfbce$var$shader
};

});


parcelRegister("d0CRN", function(module, exports) {

$parcel$export(module.exports, "GPUParticleSystem", () => $97896c8ef8fec777$export$573e67859cf40aa7);

var $iDYnp = parcelRequire("iDYnp");

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $1VEEL = parcelRequire("1VEEL");

var $b4i1f = parcelRequire("b4i1f");

var $1iaDW = parcelRequire("1iaDW");

var $hi6ss = parcelRequire("hi6ss");

var $6V6Qz = parcelRequire("6V6Qz");

var $dG1pf = parcelRequire("dG1pf");

var $5Egpj = parcelRequire("5Egpj");

var $ejQPp = parcelRequire("ejQPp");

var $bnmc3 = parcelRequire("bnmc3");

var $2h5JR = parcelRequire("2h5JR");

var $hOyoX = parcelRequire("hOyoX");

var $8DoUR = parcelRequire("8DoUR");

var $aAFeM = parcelRequire("aAFeM");

var $gmbCk = parcelRequire("gmbCk");
parcelRequire("b843b");
parcelRequire("6WKHx");
parcelRequire("fV2PC");

var $alPCh = parcelRequire("alPCh");

var $f1bVt = parcelRequire("f1bVt");
class $97896c8ef8fec777$export$573e67859cf40aa7 extends (0, $1iaDW.BaseParticleSystem) {
    /**
     * Gets a boolean indicating if the GPU particles can be rendered on current browser
     */ static get IsSupported() {
        if (!(0, $ejQPp.EngineStore).LastCreatedEngine) return false;
        const caps = (0, $ejQPp.EngineStore).LastCreatedEngine.getCaps();
        return caps.supportTransformFeedbacks || caps.supportComputeShaders;
    }
    _createIndexBuffer() {
        this._linesIndexBufferUseInstancing = this._engine.createIndexBuffer(new Uint32Array([
            0,
            1,
            1,
            3,
            3,
            2,
            2,
            0,
            0,
            3
        ]), undefined, "GPUParticleSystemLinesIndexBuffer");
    }
    /**
     * Gets the maximum number of particles active at the same time.
     * @returns The max number of active particles.
     */ getCapacity() {
        return this._capacity;
    }
    /**
     * Gets or set the number of active particles
     * The value cannot be greater than "capacity" (if it is, it will be limited to "capacity").
     */ get maxActiveParticleCount() {
        return this._maxActiveParticleCount;
    }
    set maxActiveParticleCount(value) {
        this._maxActiveParticleCount = Math.min(value, this._capacity);
    }
    /**
     * Gets or set the number of active particles
     * @deprecated Please use maxActiveParticleCount instead.
     */ get activeParticleCount() {
        return this.maxActiveParticleCount;
    }
    set activeParticleCount(value) {
        this.maxActiveParticleCount = value;
    }
    /**
     * Creates a Point Emitter for the particle system (emits directly from the emitter position)
     * @param direction1 Particles are emitted between the direction1 and direction2 from within the box
     * @param direction2 Particles are emitted between the direction1 and direction2 from within the box
     * @returns the emitter
     */ createPointEmitter(direction1, direction2) {
        const particleEmitter = (0, $f1bVt.CreatePointEmitter)(direction1, direction2);
        this.particleEmitterType = particleEmitter;
        return particleEmitter;
    }
    /**
     * Creates a Hemisphere Emitter for the particle system (emits along the hemisphere radius)
     * @param radius The radius of the hemisphere to emit from
     * @param radiusRange The range of the hemisphere to emit from [0-1] 0 Surface Only, 1 Entire Radius
     * @returns the emitter
     */ createHemisphericEmitter(radius = 1, radiusRange = 1) {
        const particleEmitter = (0, $f1bVt.CreateHemisphericEmitter)(radius, radiusRange);
        this.particleEmitterType = particleEmitter;
        return particleEmitter;
    }
    /**
     * Creates a Sphere Emitter for the particle system (emits along the sphere radius)
     * @param radius The radius of the sphere to emit from
     * @param radiusRange The range of the sphere to emit from [0-1] 0 Surface Only, 1 Entire Radius
     * @returns the emitter
     */ createSphereEmitter(radius = 1, radiusRange = 1) {
        const particleEmitter = (0, $f1bVt.CreateSphereEmitter)(radius, radiusRange);
        this.particleEmitterType = particleEmitter;
        return particleEmitter;
    }
    /**
     * Creates a Directed Sphere Emitter for the particle system (emits between direction1 and direction2)
     * @param radius The radius of the sphere to emit from
     * @param direction1 Particles are emitted between the direction1 and direction2 from within the sphere
     * @param direction2 Particles are emitted between the direction1 and direction2 from within the sphere
     * @returns the emitter
     */ createDirectedSphereEmitter(radius = 1, direction1 = new (0, $ha1VO.Vector3)(0, 1.0, 0), direction2 = new (0, $ha1VO.Vector3)(0, 1.0, 0)) {
        const particleEmitter = (0, $f1bVt.CreateDirectedSphereEmitter)(radius, direction1, direction2);
        this.particleEmitterType = particleEmitter;
        return particleEmitter;
    }
    /**
     * Creates a Cylinder Emitter for the particle system (emits from the cylinder to the particle position)
     * @param radius The radius of the emission cylinder
     * @param height The height of the emission cylinder
     * @param radiusRange The range of emission [0-1] 0 Surface only, 1 Entire Radius
     * @param directionRandomizer How much to randomize the particle direction [0-1]
     * @returns the emitter
     */ createCylinderEmitter(radius = 1, height = 1, radiusRange = 1, directionRandomizer = 0) {
        const particleEmitter = (0, $f1bVt.CreateCylinderEmitter)(radius, height, radiusRange, directionRandomizer);
        this.particleEmitterType = particleEmitter;
        return particleEmitter;
    }
    /**
     * Creates a Directed Cylinder Emitter for the particle system (emits between direction1 and direction2)
     * @param radius The radius of the cylinder to emit from
     * @param height The height of the emission cylinder
     * @param radiusRange the range of the emission cylinder [0-1] 0 Surface only, 1 Entire Radius (1 by default)
     * @param direction1 Particles are emitted between the direction1 and direction2 from within the cylinder
     * @param direction2 Particles are emitted between the direction1 and direction2 from within the cylinder
     * @returns the emitter
     */ createDirectedCylinderEmitter(radius = 1, height = 1, radiusRange = 1, direction1 = new (0, $ha1VO.Vector3)(0, 1.0, 0), direction2 = new (0, $ha1VO.Vector3)(0, 1.0, 0)) {
        const particleEmitter = (0, $f1bVt.CreateDirectedCylinderEmitter)(radius, height, radiusRange, direction1, direction2);
        this.particleEmitterType = particleEmitter;
        return particleEmitter;
    }
    /**
     * Creates a Cone Emitter for the particle system (emits from the cone to the particle position)
     * @param radius The radius of the cone to emit from
     * @param angle The base angle of the cone
     * @returns the emitter
     */ createConeEmitter(radius = 1, angle = Math.PI / 4) {
        const particleEmitter = (0, $f1bVt.CreateConeEmitter)(radius, angle);
        this.particleEmitterType = particleEmitter;
        return particleEmitter;
    }
    /**
     * Creates a Box Emitter for the particle system. (emits between direction1 and direction2 from withing the box defined by minEmitBox and maxEmitBox)
     * @param direction1 Particles are emitted between the direction1 and direction2 from within the box
     * @param direction2 Particles are emitted between the direction1 and direction2 from within the box
     * @param minEmitBox Particles are emitted from the box between minEmitBox and maxEmitBox
     * @param maxEmitBox  Particles are emitted from the box between minEmitBox and maxEmitBox
     * @returns the emitter
     */ createBoxEmitter(direction1, direction2, minEmitBox, maxEmitBox) {
        const particleEmitter = new (0, $6V6Qz.BoxParticleEmitter)();
        this.particleEmitterType = particleEmitter;
        this.direction1 = direction1;
        this.direction2 = direction2;
        this.minEmitBox = minEmitBox;
        this.maxEmitBox = maxEmitBox;
        return particleEmitter;
    }
    /**
     * Is this system ready to be used/rendered
     * @returns true if the system is ready
     */ isReady() {
        if (!this.emitter || this._imageProcessingConfiguration && !this._imageProcessingConfiguration.isReady() || !this.particleTexture || !this.particleTexture.isReady() || this._rebuildingAfterContextLost) return false;
        if (this.blendMode !== (0, $hi6ss.ParticleSystem).BLENDMODE_MULTIPLYADD) {
            if (!this._getWrapper(this.blendMode).effect.isReady()) return false;
        } else {
            if (!this._getWrapper((0, $hi6ss.ParticleSystem).BLENDMODE_MULTIPLY).effect.isReady()) return false;
            if (!this._getWrapper((0, $hi6ss.ParticleSystem).BLENDMODE_ADD).effect.isReady()) return false;
        }
        if (!this._platform.isUpdateBufferCreated()) {
            this._recreateUpdateEffect();
            return false;
        }
        return this._platform.isUpdateBufferReady();
    }
    /**
     * Gets if the system has been started. (Note: this will still be true after stop is called)
     * @returns True if it has been started, otherwise false.
     */ isStarted() {
        return this._started;
    }
    /**
     * Gets if the system has been stopped. (Note: rendering is still happening but the system is frozen)
     * @returns True if it has been stopped, otherwise false.
     */ isStopped() {
        return this._stopped;
    }
    /**
     * Gets a boolean indicating that the system is stopping
     * @returns true if the system is currently stopping
     */ isStopping() {
        return false; // Stop is immediate on GPU
    }
    /**
     * Gets the number of particles active at the same time.
     * @returns The number of active particles.
     */ getActiveCount() {
        return this._currentActiveCount;
    }
    /**
     * Starts the particle system and begins to emit
     * @param delay defines the delay in milliseconds before starting the system (this.startDelay by default)
     */ start(delay = this.startDelay) {
        if (!this.targetStopDuration && this._hasTargetStopDurationDependantGradient()) // eslint-disable-next-line no-throw-literal
        throw "Particle system started with a targetStopDuration dependant gradient (eg. startSizeGradients) but no targetStopDuration set";
        if (delay) {
            setTimeout(()=>{
                this.start(0);
            }, delay);
            return;
        }
        this._started = true;
        this._stopped = false;
        this._preWarmDone = false;
        // Animations
        if (this.beginAnimationOnStart && this.animations && this.animations.length > 0 && this._scene) this._scene.beginAnimation(this, this.beginAnimationFrom, this.beginAnimationTo, this.beginAnimationLoop);
    }
    /**
     * Stops the particle system.
     */ stop() {
        if (this._stopped) return;
        this._stopped = true;
    }
    /**
     * Remove all active particles
     */ reset() {
        this._releaseBuffers();
        this._platform.releaseVertexBuffers();
        this._currentActiveCount = 0;
        this._targetIndex = 0;
    }
    /**
     * Returns the string "GPUParticleSystem"
     * @returns a string containing the class name
     */ getClassName() {
        return "GPUParticleSystem";
    }
    /**
     * Gets the custom effect used to render the particles
     * @param blendMode Blend mode for which the effect should be retrieved
     * @returns The effect
     */ getCustomEffect(blendMode = 0) {
        return this._customWrappers[blendMode]?.effect ?? this._customWrappers[0].effect;
    }
    _getCustomDrawWrapper(blendMode = 0) {
        return this._customWrappers[blendMode] ?? this._customWrappers[0];
    }
    /**
     * Sets the custom effect used to render the particles
     * @param effect The effect to set
     * @param blendMode Blend mode for which the effect should be set
     */ setCustomEffect(effect, blendMode = 0) {
        this._customWrappers[blendMode] = new (0, $hOyoX.DrawWrapper)(this._engine);
        this._customWrappers[blendMode].effect = effect;
    }
    /**
     * Observable that will be called just before the particles are drawn
     */ get onBeforeDrawParticlesObservable() {
        if (!this._onBeforeDrawParticlesObservable) this._onBeforeDrawParticlesObservable = new (0, $diGQf.Observable)();
        return this._onBeforeDrawParticlesObservable;
    }
    /**
     * Gets the name of the particle vertex shader
     */ get vertexShaderName() {
        return "gpuRenderParticles";
    }
    /**
     * Gets the vertex buffers used by the particle system
     * Should be called after render() has been called for the current frame so that the buffers returned are the ones that have been updated
     * in the current frame (there's a ping-pong between two sets of buffers - for a given frame, one set is used as the source and the other as the destination)
     */ get vertexBuffers() {
        // We return the other buffers than those corresponding to this._targetIndex because it is assumed vertexBuffers will be called in the current frame
        // after render() has been called, meaning that the buffers have already been swapped and this._targetIndex points to the buffers that will be updated
        // in the next frame (and which are the sources in this frame) and (this._targetIndex ^ 1) points to the buffers that have been updated this frame
        // (and that will be the source buffers in the next frame)
        return this._renderVertexBuffers[this._targetIndex ^ 1];
    }
    /**
     * Gets the index buffer used by the particle system (null for GPU particle systems)
     */ get indexBuffer() {
        return null;
    }
    _removeGradientAndTexture(gradient, gradients, texture) {
        super._removeGradientAndTexture(gradient, gradients, texture);
        this._releaseBuffers();
        return this;
    }
    /**
     * Adds a new color gradient
     * @param gradient defines the gradient to use (between 0 and 1)
     * @param color1 defines the color to affect to the specified gradient
     * @returns the current particle system
     */ addColorGradient(gradient, color1) {
        if (!this._colorGradients) this._colorGradients = [];
        const colorGradient = new (0, $iDYnp.ColorGradient)(gradient, color1);
        this._colorGradients.push(colorGradient);
        this._refreshColorGradient(true);
        this._releaseBuffers();
        return this;
    }
    _refreshColorGradient(reorder = false) {
        if (this._colorGradients) {
            if (reorder) this._colorGradients.sort((a, b)=>{
                if (a.gradient < b.gradient) return -1;
                else if (a.gradient > b.gradient) return 1;
                return 0;
            });
            if (this._colorGradientsTexture) {
                this._colorGradientsTexture.dispose();
                this._colorGradientsTexture = null;
            }
        }
    }
    /** Force the system to rebuild all gradients that need to be resync */ forceRefreshGradients() {
        this._refreshColorGradient();
        this._refreshFactorGradient(this._sizeGradients, "_sizeGradientsTexture");
        this._refreshFactorGradient(this._angularSpeedGradients, "_angularSpeedGradientsTexture");
        this._refreshFactorGradient(this._velocityGradients, "_velocityGradientsTexture");
        this._refreshFactorGradient(this._limitVelocityGradients, "_limitVelocityGradientsTexture");
        this._refreshFactorGradient(this._dragGradients, "_dragGradientsTexture");
        this.reset();
    }
    /**
     * Remove a specific color gradient
     * @param gradient defines the gradient to remove
     * @returns the current particle system
     */ removeColorGradient(gradient) {
        this._removeGradientAndTexture(gradient, this._colorGradients, this._colorGradientsTexture);
        this._colorGradientsTexture = null;
        return this;
    }
    /**
     * Resets the draw wrappers cache
     */ resetDrawCache() {
        for(const blendMode in this._drawWrappers){
            const drawWrapper = this._drawWrappers[blendMode];
            drawWrapper.drawContext?.reset();
        }
    }
    _addFactorGradient(factorGradients, gradient, factor) {
        const valueGradient = new (0, $iDYnp.FactorGradient)(gradient, factor);
        factorGradients.push(valueGradient);
        this._releaseBuffers();
    }
    /**
     * Adds a new size gradient
     * @param gradient defines the gradient to use (between 0 and 1)
     * @param factor defines the size factor to affect to the specified gradient
     * @returns the current particle system
     */ addSizeGradient(gradient, factor) {
        if (!this._sizeGradients) this._sizeGradients = [];
        this._addFactorGradient(this._sizeGradients, gradient, factor);
        this._refreshFactorGradient(this._sizeGradients, "_sizeGradientsTexture", true);
        this._releaseBuffers();
        return this;
    }
    /**
     * Remove a specific size gradient
     * @param gradient defines the gradient to remove
     * @returns the current particle system
     */ removeSizeGradient(gradient) {
        this._removeGradientAndTexture(gradient, this._sizeGradients, this._sizeGradientsTexture);
        this._sizeGradientsTexture = null;
        return this;
    }
    _refreshFactorGradient(factorGradients, textureName, reorder = false) {
        if (!factorGradients) return;
        if (reorder) factorGradients.sort((a, b)=>{
            if (a.gradient < b.gradient) return -1;
            else if (a.gradient > b.gradient) return 1;
            return 0;
        });
        const that = this;
        if (that[textureName]) {
            that[textureName].dispose();
            that[textureName] = null;
        }
    }
    /**
     * Adds a new angular speed gradient
     * @param gradient defines the gradient to use (between 0 and 1)
     * @param factor defines the angular speed to affect to the specified gradient
     * @returns the current particle system
     */ addAngularSpeedGradient(gradient, factor) {
        if (!this._angularSpeedGradients) this._angularSpeedGradients = [];
        this._addFactorGradient(this._angularSpeedGradients, gradient, factor);
        this._refreshFactorGradient(this._angularSpeedGradients, "_angularSpeedGradientsTexture", true);
        this._releaseBuffers();
        return this;
    }
    /**
     * Remove a specific angular speed gradient
     * @param gradient defines the gradient to remove
     * @returns the current particle system
     */ removeAngularSpeedGradient(gradient) {
        this._removeGradientAndTexture(gradient, this._angularSpeedGradients, this._angularSpeedGradientsTexture);
        this._angularSpeedGradientsTexture = null;
        return this;
    }
    /**
     * Adds a new velocity gradient
     * @param gradient defines the gradient to use (between 0 and 1)
     * @param factor defines the velocity to affect to the specified gradient
     * @returns the current particle system
     */ addVelocityGradient(gradient, factor) {
        if (!this._velocityGradients) this._velocityGradients = [];
        this._addFactorGradient(this._velocityGradients, gradient, factor);
        this._refreshFactorGradient(this._velocityGradients, "_velocityGradientsTexture", true);
        this._releaseBuffers();
        return this;
    }
    /**
     * Remove a specific velocity gradient
     * @param gradient defines the gradient to remove
     * @returns the current particle system
     */ removeVelocityGradient(gradient) {
        this._removeGradientAndTexture(gradient, this._velocityGradients, this._velocityGradientsTexture);
        this._velocityGradientsTexture = null;
        return this;
    }
    /**
     * Adds a new limit velocity gradient
     * @param gradient defines the gradient to use (between 0 and 1)
     * @param factor defines the limit velocity value to affect to the specified gradient
     * @returns the current particle system
     */ addLimitVelocityGradient(gradient, factor) {
        if (!this._limitVelocityGradients) this._limitVelocityGradients = [];
        this._addFactorGradient(this._limitVelocityGradients, gradient, factor);
        this._refreshFactorGradient(this._limitVelocityGradients, "_limitVelocityGradientsTexture", true);
        this._releaseBuffers();
        return this;
    }
    /**
     * Remove a specific limit velocity gradient
     * @param gradient defines the gradient to remove
     * @returns the current particle system
     */ removeLimitVelocityGradient(gradient) {
        this._removeGradientAndTexture(gradient, this._limitVelocityGradients, this._limitVelocityGradientsTexture);
        this._limitVelocityGradientsTexture = null;
        return this;
    }
    /**
     * Adds a new drag gradient
     * @param gradient defines the gradient to use (between 0 and 1)
     * @param factor defines the drag value to affect to the specified gradient
     * @returns the current particle system
     */ addDragGradient(gradient, factor) {
        if (!this._dragGradients) this._dragGradients = [];
        this._addFactorGradient(this._dragGradients, gradient, factor);
        this._refreshFactorGradient(this._dragGradients, "_dragGradientsTexture", true);
        this._releaseBuffers();
        return this;
    }
    /**
     * Remove a specific drag gradient
     * @param gradient defines the gradient to remove
     * @returns the current particle system
     */ removeDragGradient(gradient) {
        this._removeGradientAndTexture(gradient, this._dragGradients, this._dragGradientsTexture);
        this._dragGradientsTexture = null;
        return this;
    }
    /**
     * Not supported by GPUParticleSystem
     * @returns the current particle system
     */ addEmitRateGradient() {
        // Do nothing as emit rate is not supported by GPUParticleSystem
        return this;
    }
    /**
     * Not supported by GPUParticleSystem
     * @returns the current particle system
     */ removeEmitRateGradient() {
        // Do nothing as emit rate is not supported by GPUParticleSystem
        return this;
    }
    /**
     * Not supported by GPUParticleSystem
     * @returns the current particle system
     */ addStartSizeGradient() {
        // Do nothing as start size is not supported by GPUParticleSystem
        return this;
    }
    /**
     * Not supported by GPUParticleSystem
     * @returns the current particle system
     */ removeStartSizeGradient() {
        // Do nothing as start size is not supported by GPUParticleSystem
        return this;
    }
    /**
     * Not supported by GPUParticleSystem
     * @returns the current particle system
     */ addColorRemapGradient() {
        // Do nothing as start size is not supported by GPUParticleSystem
        return this;
    }
    /**
     * Not supported by GPUParticleSystem
     * @returns the current particle system
     */ removeColorRemapGradient() {
        // Do nothing as start size is not supported by GPUParticleSystem
        return this;
    }
    /**
     * Not supported by GPUParticleSystem
     * @returns the current particle system
     */ addAlphaRemapGradient() {
        // Do nothing as start size is not supported by GPUParticleSystem
        return this;
    }
    /**
     * Not supported by GPUParticleSystem
     * @returns the current particle system
     */ removeAlphaRemapGradient() {
        // Do nothing as start size is not supported by GPUParticleSystem
        return this;
    }
    /**
     * Not supported by GPUParticleSystem
     * @returns the current particle system
     */ addRampGradient() {
        //Not supported by GPUParticleSystem
        return this;
    }
    /**
     * Not supported by GPUParticleSystem
     * @returns the current particle system
     */ removeRampGradient() {
        //Not supported by GPUParticleSystem
        return this;
    }
    /**
     * Not supported by GPUParticleSystem
     * @returns the list of ramp gradients
     */ getRampGradients() {
        return null;
    }
    /**
     * Not supported by GPUParticleSystem
     * Gets or sets a boolean indicating that ramp gradients must be used
     * @see https://doc.babylonjs.com/features/featuresDeepDive/particles/particle_system/particle_system_intro#ramp-gradients
     */ get useRampGradients() {
        //Not supported by GPUParticleSystem
        return false;
    }
    set useRampGradients(value) {
    //Not supported by GPUParticleSystem
    }
    /**
     * Not supported by GPUParticleSystem
     * @returns the current particle system
     */ addLifeTimeGradient() {
        //Not supported by GPUParticleSystem
        return this;
    }
    /**
     * Not supported by GPUParticleSystem
     * @returns the current particle system
     */ removeLifeTimeGradient() {
        //Not supported by GPUParticleSystem
        return this;
    }
    /**
     * Instantiates a GPU particle system.
     * Particles are often small sprites used to simulate hard-to-reproduce phenomena like fire, smoke, water, or abstract visual effects like magic glitter and faery dust.
     * @param name The name of the particle system
     * @param options The options used to create the system
     * @param sceneOrEngine The scene the particle system belongs to or the engine to use if no scene
     * @param customEffect a custom effect used to change the way particles are rendered by default
     * @param isAnimationSheetEnabled Must be true if using a spritesheet to animate the particles texture
     */ constructor(name, options, sceneOrEngine, customEffect = null, isAnimationSheetEnabled = false){
        super(name);
        /**
         * The layer mask we are rendering the particles through.
         */ this.layerMask = 0x0fffffff;
        this._accumulatedCount = 0;
        this._renderVertexBuffers = [];
        this._targetIndex = 0;
        this._currentRenderId = -1;
        this._currentRenderingCameraUniqueId = -1;
        this._started = false;
        this._stopped = false;
        this._timeDelta = 0;
        /** Indicates that the update of particles is done in the animate function (and not in render). Default: false */ this.updateInAnimate = false;
        this._actualFrame = 0;
        this._rawTextureWidth = 256;
        this._rebuildingAfterContextLost = false;
        /**
         * An event triggered when the system is disposed.
         */ this.onDisposeObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the system is stopped
         */ this.onStoppedObservable = new (0, $diGQf.Observable)();
        /**
         * Forces the particle to write their depth information to the depth buffer. This can help preventing other draw calls
         * to override the particles.
         */ this.forceDepthWrite = false;
        this._preWarmDone = false;
        /**
         * Specifies if the particles are updated in emitter local space or world space.
         */ this.isLocal = false;
        /** Indicates that the particle system is GPU based */ this.isGPU = true;
        /** @internal */ this._onBeforeDrawParticlesObservable = null;
        if (!sceneOrEngine || sceneOrEngine.getClassName() === "Scene") {
            this._scene = sceneOrEngine || (0, $ejQPp.EngineStore).LastCreatedScene;
            this._engine = this._scene.getEngine();
            this.uniqueId = this._scene.getUniqueId();
            this._scene.particleSystems.push(this);
        } else {
            this._engine = sceneOrEngine;
            this.defaultProjectionMatrix = (0, $ha1VO.Matrix).PerspectiveFovLH(0.8, 1, 0.1, 100, this._engine.isNDCHalfZRange);
        }
        if (this._engine.getCaps().supportComputeShaders) {
            if (!(0, $8DoUR.GetClass)("BABYLON.ComputeShaderParticleSystem")) throw new Error("The ComputeShaderParticleSystem class is not available! Make sure you have imported it.");
            this._platform = new ((0, $8DoUR.GetClass)("BABYLON.ComputeShaderParticleSystem"))(this, this._engine);
        } else {
            if (!(0, $8DoUR.GetClass)("BABYLON.WebGL2ParticleSystem")) throw new Error("The WebGL2ParticleSystem class is not available! Make sure you have imported it.");
            this._platform = new ((0, $8DoUR.GetClass)("BABYLON.WebGL2ParticleSystem"))(this, this._engine);
        }
        this._customWrappers = {
            0: new (0, $hOyoX.DrawWrapper)(this._engine)
        };
        this._customWrappers[0].effect = customEffect;
        this._drawWrappers = {
            0: new (0, $hOyoX.DrawWrapper)(this._engine)
        };
        if (this._drawWrappers[0].drawContext) this._drawWrappers[0].drawContext.useInstancing = true;
        this._createIndexBuffer();
        // Setup the default processing configuration to the scene.
        this._attachImageProcessingConfiguration(null);
        options = options ?? {};
        if (!options.randomTextureSize) delete options.randomTextureSize;
        const fullOptions = {
            capacity: 50000,
            randomTextureSize: this._engine.getCaps().maxTextureSize,
            ...options
        };
        const optionsAsNumber = options;
        if (isFinite(optionsAsNumber)) fullOptions.capacity = optionsAsNumber;
        this._capacity = fullOptions.capacity;
        this._maxActiveParticleCount = fullOptions.capacity;
        this._currentActiveCount = 0;
        this._isAnimationSheetEnabled = isAnimationSheetEnabled;
        this.particleEmitterType = new (0, $6V6Qz.BoxParticleEmitter)();
        // Random data
        const maxTextureSize = Math.min(this._engine.getCaps().maxTextureSize, fullOptions.randomTextureSize);
        let d = [];
        for(let i = 0; i < maxTextureSize; ++i){
            d.push(Math.random());
            d.push(Math.random());
            d.push(Math.random());
            d.push(Math.random());
        }
        this._randomTexture = new (0, $5Egpj.RawTexture)(new Float32Array(d), maxTextureSize, 1, 5, sceneOrEngine, false, false, 1, 1);
        this._randomTexture.name = "GPUParticleSystem_random1";
        this._randomTexture.wrapU = 1;
        this._randomTexture.wrapV = 1;
        d = [];
        for(let i = 0; i < maxTextureSize; ++i){
            d.push(Math.random());
            d.push(Math.random());
            d.push(Math.random());
            d.push(Math.random());
        }
        this._randomTexture2 = new (0, $5Egpj.RawTexture)(new Float32Array(d), maxTextureSize, 1, 5, sceneOrEngine, false, false, 1, 1);
        this._randomTexture2.name = "GPUParticleSystem_random2";
        this._randomTexture2.wrapU = 1;
        this._randomTexture2.wrapV = 1;
        this._randomTextureSize = maxTextureSize;
    }
    _reset() {
        this._releaseBuffers();
    }
    _createVertexBuffers(updateBuffer, renderBuffer, spriteSource) {
        const renderVertexBuffers = {};
        renderVertexBuffers["position"] = renderBuffer.createVertexBuffer("position", 0, 3, this._attributesStrideSize, true);
        let offset = 3;
        renderVertexBuffers["age"] = renderBuffer.createVertexBuffer("age", offset, 1, this._attributesStrideSize, true);
        offset += 1;
        renderVertexBuffers["size"] = renderBuffer.createVertexBuffer("size", offset, 3, this._attributesStrideSize, true);
        offset += 3;
        renderVertexBuffers["life"] = renderBuffer.createVertexBuffer("life", offset, 1, this._attributesStrideSize, true);
        offset += 1;
        offset += 4; // seed
        if (this.billboardMode === (0, $hi6ss.ParticleSystem).BILLBOARDMODE_STRETCHED) renderVertexBuffers["direction"] = renderBuffer.createVertexBuffer("direction", offset, 3, this._attributesStrideSize, true);
        offset += 3; // direction
        if (this._platform.alignDataInBuffer) offset += 1;
        if (this.particleEmitterType instanceof (0, $bnmc3.CustomParticleEmitter)) {
            offset += 3;
            if (this._platform.alignDataInBuffer) offset += 1;
        }
        if (!this._colorGradientsTexture) {
            renderVertexBuffers["color"] = renderBuffer.createVertexBuffer("color", offset, 4, this._attributesStrideSize, true);
            offset += 4;
        }
        if (!this._isBillboardBased) {
            renderVertexBuffers["initialDirection"] = renderBuffer.createVertexBuffer("initialDirection", offset, 3, this._attributesStrideSize, true);
            offset += 3;
            if (this._platform.alignDataInBuffer) offset += 1;
        }
        if (this.noiseTexture) {
            renderVertexBuffers["noiseCoordinates1"] = renderBuffer.createVertexBuffer("noiseCoordinates1", offset, 3, this._attributesStrideSize, true);
            offset += 3;
            if (this._platform.alignDataInBuffer) offset += 1;
            renderVertexBuffers["noiseCoordinates2"] = renderBuffer.createVertexBuffer("noiseCoordinates2", offset, 3, this._attributesStrideSize, true);
            offset += 3;
            if (this._platform.alignDataInBuffer) offset += 1;
        }
        renderVertexBuffers["angle"] = renderBuffer.createVertexBuffer("angle", offset, 1, this._attributesStrideSize, true);
        if (this._angularSpeedGradientsTexture) offset++;
        else offset += 2;
        if (this._isAnimationSheetEnabled) {
            renderVertexBuffers["cellIndex"] = renderBuffer.createVertexBuffer("cellIndex", offset, 1, this._attributesStrideSize, true);
            offset += 1;
            if (this.spriteRandomStartCell) {
                renderVertexBuffers["cellStartOffset"] = renderBuffer.createVertexBuffer("cellStartOffset", offset, 1, this._attributesStrideSize, true);
                offset += 1;
            }
        }
        renderVertexBuffers["offset"] = spriteSource.createVertexBuffer("offset", 0, 2);
        renderVertexBuffers["uv"] = spriteSource.createVertexBuffer("uv", 2, 2);
        this._renderVertexBuffers.push(renderVertexBuffers);
        this._platform.createVertexBuffers(updateBuffer, renderVertexBuffers);
        this.resetDrawCache();
    }
    _initialize(force = false) {
        if (this._buffer0 && !force) return;
        const engine = this._engine;
        const data = [];
        this._attributesStrideSize = 21;
        this._targetIndex = 0;
        if (this._platform.alignDataInBuffer) this._attributesStrideSize += 1;
        if (this.particleEmitterType instanceof (0, $bnmc3.CustomParticleEmitter)) {
            this._attributesStrideSize += 3;
            if (this._platform.alignDataInBuffer) this._attributesStrideSize += 1;
        }
        if (!this.isBillboardBased) {
            this._attributesStrideSize += 3;
            if (this._platform.alignDataInBuffer) this._attributesStrideSize += 1;
        }
        if (this._colorGradientsTexture) this._attributesStrideSize -= 4;
        if (this._angularSpeedGradientsTexture) this._attributesStrideSize -= 1;
        if (this._isAnimationSheetEnabled) {
            this._attributesStrideSize += 1;
            if (this.spriteRandomStartCell) this._attributesStrideSize += 1;
        }
        if (this.noiseTexture) {
            this._attributesStrideSize += 6;
            if (this._platform.alignDataInBuffer) this._attributesStrideSize += 2;
        }
        if (this._platform.alignDataInBuffer) this._attributesStrideSize += 3 - (this._attributesStrideSize + 3 & 3); // round to multiple of 4
        const usingCustomEmitter = this.particleEmitterType instanceof (0, $bnmc3.CustomParticleEmitter);
        const tmpVector = (0, $ha1VO.TmpVectors).Vector3[0];
        let offset = 0;
        for(let particleIndex = 0; particleIndex < this._capacity; particleIndex++){
            // position
            data.push(0.0);
            data.push(0.0);
            data.push(0.0);
            // Age
            data.push(0.0); // create the particle as a dead one to create a new one at start
            // Size
            data.push(0.0);
            data.push(0.0);
            data.push(0.0);
            // life
            data.push(0.0);
            // Seed
            data.push(Math.random());
            data.push(Math.random());
            data.push(Math.random());
            data.push(Math.random());
            // direction
            if (usingCustomEmitter) {
                this.particleEmitterType.particleDestinationGenerator(particleIndex, null, tmpVector);
                data.push(tmpVector.x);
                data.push(tmpVector.y);
                data.push(tmpVector.z);
            } else {
                data.push(0.0);
                data.push(0.0);
                data.push(0.0);
            }
            if (this._platform.alignDataInBuffer) data.push(0.0); // dummy0
            offset += 16; // position, age, size, life, seed, direction, dummy0
            if (usingCustomEmitter) {
                this.particleEmitterType.particlePositionGenerator(particleIndex, null, tmpVector);
                data.push(tmpVector.x);
                data.push(tmpVector.y);
                data.push(tmpVector.z);
                if (this._platform.alignDataInBuffer) data.push(0.0); // dummy1
                offset += 4;
            }
            if (!this._colorGradientsTexture) {
                // color
                data.push(0.0);
                data.push(0.0);
                data.push(0.0);
                data.push(0.0);
                offset += 4;
            }
            if (!this.isBillboardBased) {
                // initialDirection
                data.push(0.0);
                data.push(0.0);
                data.push(0.0);
                if (this._platform.alignDataInBuffer) data.push(0.0); // dummy2
                offset += 4;
            }
            if (this.noiseTexture) {
                // Random coordinates for reading into noise texture
                data.push(Math.random());
                data.push(Math.random());
                data.push(Math.random());
                if (this._platform.alignDataInBuffer) data.push(0.0); // dummy3
                data.push(Math.random());
                data.push(Math.random());
                data.push(Math.random());
                if (this._platform.alignDataInBuffer) data.push(0.0); // dummy4
                offset += 8;
            }
            // angle
            data.push(0.0);
            offset += 1;
            if (!this._angularSpeedGradientsTexture) {
                data.push(0.0);
                offset += 1;
            }
            if (this._isAnimationSheetEnabled) {
                data.push(0.0);
                offset += 1;
                if (this.spriteRandomStartCell) {
                    data.push(0.0);
                    offset += 1;
                }
            }
            if (this._platform.alignDataInBuffer) {
                let numDummies = 3 - (offset + 3 & 3);
                offset += numDummies;
                while(numDummies-- > 0)data.push(0.0);
            }
        }
        // Sprite data
        const spriteData = new Float32Array([
            0.5,
            0.5,
            1,
            1,
            -0.5,
            0.5,
            0,
            1,
            0.5,
            -0.5,
            1,
            0,
            -0.5,
            -0.5,
            0,
            0
        ]);
        const bufferData1 = this._platform.createParticleBuffer(data);
        const bufferData2 = this._platform.createParticleBuffer(data);
        // Buffers
        this._buffer0 = new (0, $b4i1f.Buffer)(engine, bufferData1, false, this._attributesStrideSize);
        this._buffer1 = new (0, $b4i1f.Buffer)(engine, bufferData2, false, this._attributesStrideSize);
        this._spriteBuffer = new (0, $b4i1f.Buffer)(engine, spriteData, false, 4);
        // Update & Render vertex buffers
        this._renderVertexBuffers = [];
        this._createVertexBuffers(this._buffer0, this._buffer1, this._spriteBuffer);
        this._createVertexBuffers(this._buffer1, this._buffer0, this._spriteBuffer);
        // Links
        this._sourceBuffer = this._buffer0;
        this._targetBuffer = this._buffer1;
    }
    /** @internal */ _recreateUpdateEffect() {
        this._createColorGradientTexture();
        this._createSizeGradientTexture();
        this._createAngularSpeedGradientTexture();
        this._createVelocityGradientTexture();
        this._createLimitVelocityGradientTexture();
        this._createDragGradientTexture();
        let defines = this.particleEmitterType ? this.particleEmitterType.getEffectDefines() : "";
        if (this._isBillboardBased) defines += "\n#define BILLBOARD";
        if (this._colorGradientsTexture) defines += "\n#define COLORGRADIENTS";
        if (this._sizeGradientsTexture) defines += "\n#define SIZEGRADIENTS";
        if (this._angularSpeedGradientsTexture) defines += "\n#define ANGULARSPEEDGRADIENTS";
        if (this._velocityGradientsTexture) defines += "\n#define VELOCITYGRADIENTS";
        if (this._limitVelocityGradientsTexture) defines += "\n#define LIMITVELOCITYGRADIENTS";
        if (this._dragGradientsTexture) defines += "\n#define DRAGGRADIENTS";
        if (this.isAnimationSheetEnabled) {
            defines += "\n#define ANIMATESHEET";
            if (this.spriteRandomStartCell) defines += "\n#define ANIMATESHEETRANDOMSTART";
        }
        if (this.noiseTexture) defines += "\n#define NOISE";
        if (this.isLocal) defines += "\n#define LOCAL";
        if (this._platform.isUpdateBufferCreated() && this._cachedUpdateDefines === defines) return this._platform.isUpdateBufferReady();
        this._cachedUpdateDefines = defines;
        this._updateBuffer = this._platform.createUpdateBuffer(defines);
        return this._platform.isUpdateBufferReady();
    }
    /**
     * @internal
     */ _getWrapper(blendMode) {
        const customWrapper = this._getCustomDrawWrapper(blendMode);
        if (customWrapper?.effect) return customWrapper;
        const defines = [];
        this.fillDefines(defines, blendMode);
        // Effect
        let drawWrapper = this._drawWrappers[blendMode];
        if (!drawWrapper) {
            drawWrapper = new (0, $hOyoX.DrawWrapper)(this._engine);
            if (drawWrapper.drawContext) drawWrapper.drawContext.useInstancing = true;
            this._drawWrappers[blendMode] = drawWrapper;
        }
        const join = defines.join("\n");
        if (drawWrapper.defines !== join) {
            const attributes = [];
            const uniforms = [];
            const samplers = [];
            this.fillUniformsAttributesAndSamplerNames(uniforms, attributes, samplers);
            drawWrapper.setEffect(this._engine.createEffect("gpuRenderParticles", attributes, uniforms, samplers, join), join);
        }
        return drawWrapper;
    }
    /**
     * @internal
     */ static _GetAttributeNamesOrOptions(hasColorGradients = false, isAnimationSheetEnabled = false, isBillboardBased = false, isBillboardStretched = false) {
        const attributeNamesOrOptions = [
            (0, $b4i1f.VertexBuffer).PositionKind,
            "age",
            "life",
            "size",
            "angle"
        ];
        if (!hasColorGradients) attributeNamesOrOptions.push((0, $b4i1f.VertexBuffer).ColorKind);
        if (isAnimationSheetEnabled) attributeNamesOrOptions.push("cellIndex");
        if (!isBillboardBased) attributeNamesOrOptions.push("initialDirection");
        if (isBillboardStretched) attributeNamesOrOptions.push("direction");
        attributeNamesOrOptions.push("offset", (0, $b4i1f.VertexBuffer).UVKind);
        return attributeNamesOrOptions;
    }
    /**
     * @internal
     */ static _GetEffectCreationOptions(isAnimationSheetEnabled = false, useLogarithmicDepth = false, applyFog = false) {
        const effectCreationOption = [
            "emitterWM",
            "worldOffset",
            "view",
            "projection",
            "colorDead",
            "invView",
            "translationPivot",
            "eyePosition"
        ];
        (0, $aAFeM.addClipPlaneUniforms)(effectCreationOption);
        if (isAnimationSheetEnabled) effectCreationOption.push("sheetInfos");
        if (useLogarithmicDepth) effectCreationOption.push("logarithmicDepthConstant");
        if (applyFog) {
            effectCreationOption.push("vFogInfos");
            effectCreationOption.push("vFogColor");
        }
        return effectCreationOption;
    }
    /**
     * Fill the defines array according to the current settings of the particle system
     * @param defines Array to be updated
     * @param blendMode blend mode to take into account when updating the array
     */ fillDefines(defines, blendMode = 0) {
        if (this._scene) {
            (0, $aAFeM.prepareStringDefinesForClipPlanes)(this, this._scene, defines);
            if (this.applyFog && this._scene.fogEnabled && this._scene.fogMode !== (0, $gmbCk.Scene).FOGMODE_NONE) defines.push("#define FOG");
        }
        if (blendMode === (0, $hi6ss.ParticleSystem).BLENDMODE_MULTIPLY) defines.push("#define BLENDMULTIPLYMODE");
        if (this.isLocal) defines.push("#define LOCAL");
        if (this.useLogarithmicDepth) defines.push("#define LOGARITHMICDEPTH");
        if (this._isBillboardBased) {
            defines.push("#define BILLBOARD");
            switch(this.billboardMode){
                case (0, $hi6ss.ParticleSystem).BILLBOARDMODE_Y:
                    defines.push("#define BILLBOARDY");
                    break;
                case (0, $hi6ss.ParticleSystem).BILLBOARDMODE_STRETCHED:
                    defines.push("#define BILLBOARDSTRETCHED");
                    break;
                case (0, $hi6ss.ParticleSystem).BILLBOARDMODE_ALL:
                    defines.push("#define BILLBOARDMODE_ALL");
                    break;
                default:
                    break;
            }
        }
        if (this._colorGradientsTexture) defines.push("#define COLORGRADIENTS");
        if (this.isAnimationSheetEnabled) defines.push("#define ANIMATESHEET");
        if (this._imageProcessingConfiguration) {
            this._imageProcessingConfiguration.prepareDefines(this._imageProcessingConfigurationDefines);
            defines.push("" + this._imageProcessingConfigurationDefines.toString());
        }
    }
    /**
     * Fill the uniforms, attributes and samplers arrays according to the current settings of the particle system
     * @param uniforms Uniforms array to fill
     * @param attributes Attributes array to fill
     * @param samplers Samplers array to fill
     */ fillUniformsAttributesAndSamplerNames(uniforms, attributes, samplers) {
        attributes.push(...$97896c8ef8fec777$export$573e67859cf40aa7._GetAttributeNamesOrOptions(!!this._colorGradientsTexture, this._isAnimationSheetEnabled, this._isBillboardBased, this._isBillboardBased && this.billboardMode === (0, $hi6ss.ParticleSystem).BILLBOARDMODE_STRETCHED));
        uniforms.push(...$97896c8ef8fec777$export$573e67859cf40aa7._GetEffectCreationOptions(this._isAnimationSheetEnabled, this.useLogarithmicDepth, this.applyFog));
        samplers.push("diffuseSampler", "colorGradientSampler");
        if (this._imageProcessingConfiguration) {
            (0, $dG1pf.ImageProcessingConfiguration).PrepareUniforms(uniforms, this._imageProcessingConfigurationDefines);
            (0, $dG1pf.ImageProcessingConfiguration).PrepareSamplers(samplers, this._imageProcessingConfigurationDefines);
        }
    }
    /**
     * Animates the particle system for the current frame by emitting new particles and or animating the living ones.
     * @param preWarm defines if we are in the pre-warmimg phase
     */ animate(preWarm = false) {
        this._timeDelta = this.updateSpeed * (preWarm ? this.preWarmStepOffset : this._scene?.getAnimationRatio() || 1);
        this._actualFrame += this._timeDelta;
        if (!this._stopped) {
            if (this.targetStopDuration && this._actualFrame >= this.targetStopDuration) this.stop();
        }
        if (this.updateInAnimate) this._update();
    }
    _createFactorGradientTexture(factorGradients, textureName) {
        const texture = this[textureName];
        if (!factorGradients || !factorGradients.length || texture) return;
        const data = new Float32Array(this._rawTextureWidth);
        for(let x = 0; x < this._rawTextureWidth; x++){
            const ratio = x / this._rawTextureWidth;
            (0, $iDYnp.GradientHelper).GetCurrentGradient(ratio, factorGradients, (currentGradient, nextGradient, scale)=>{
                data[x] = (0, $1VEEL.Scalar).Lerp(currentGradient.factor1, nextGradient.factor1, scale);
            });
        }
        this[textureName] = (0, $5Egpj.RawTexture).CreateRTexture(data, this._rawTextureWidth, 1, this._scene || this._engine, false, false, 1);
        this[textureName].name = textureName.substring(1);
    }
    _createSizeGradientTexture() {
        this._createFactorGradientTexture(this._sizeGradients, "_sizeGradientsTexture");
    }
    _createAngularSpeedGradientTexture() {
        this._createFactorGradientTexture(this._angularSpeedGradients, "_angularSpeedGradientsTexture");
    }
    _createVelocityGradientTexture() {
        this._createFactorGradientTexture(this._velocityGradients, "_velocityGradientsTexture");
    }
    _createLimitVelocityGradientTexture() {
        this._createFactorGradientTexture(this._limitVelocityGradients, "_limitVelocityGradientsTexture");
    }
    _createDragGradientTexture() {
        this._createFactorGradientTexture(this._dragGradients, "_dragGradientsTexture");
    }
    _createColorGradientTexture() {
        if (!this._colorGradients || !this._colorGradients.length || this._colorGradientsTexture) return;
        const data = new Uint8Array(this._rawTextureWidth * 4);
        const tmpColor = (0, $7etnY.TmpColors).Color4[0];
        for(let x = 0; x < this._rawTextureWidth; x++){
            const ratio = x / this._rawTextureWidth;
            (0, $iDYnp.GradientHelper).GetCurrentGradient(ratio, this._colorGradients, (currentGradient, nextGradient, scale)=>{
                (0, $7etnY.Color4).LerpToRef(currentGradient.color1, nextGradient.color1, scale, tmpColor);
                data[x * 4] = tmpColor.r * 255;
                data[x * 4 + 1] = tmpColor.g * 255;
                data[x * 4 + 2] = tmpColor.b * 255;
                data[x * 4 + 3] = tmpColor.a * 255;
            });
        }
        this._colorGradientsTexture = (0, $5Egpj.RawTexture).CreateRGBATexture(data, this._rawTextureWidth, 1, this._scene, false, false, 1);
        this._colorGradientsTexture.name = "colorGradients";
    }
    _render(blendMode, emitterWM) {
        // Enable render effect
        const drawWrapper = this._getWrapper(blendMode);
        const effect = drawWrapper.effect;
        this._engine.enableEffect(drawWrapper);
        const viewMatrix = this._scene?.getViewMatrix() || (0, $ha1VO.Matrix).IdentityReadOnly;
        effect.setMatrix("view", viewMatrix);
        effect.setMatrix("projection", this.defaultProjectionMatrix ?? this._scene.getProjectionMatrix());
        effect.setTexture("diffuseSampler", this.particleTexture);
        effect.setVector2("translationPivot", this.translationPivot);
        effect.setVector3("worldOffset", this.worldOffset);
        if (this.isLocal) effect.setMatrix("emitterWM", emitterWM);
        if (this._colorGradientsTexture) effect.setTexture("colorGradientSampler", this._colorGradientsTexture);
        else effect.setDirectColor4("colorDead", this.colorDead);
        if (this._isAnimationSheetEnabled && this.particleTexture) {
            const baseSize = this.particleTexture.getBaseSize();
            effect.setFloat3("sheetInfos", this.spriteCellWidth / baseSize.width, this.spriteCellHeight / baseSize.height, baseSize.width / this.spriteCellWidth);
        }
        if (this._isBillboardBased && this._scene) {
            const camera = this._scene.activeCamera;
            effect.setVector3("eyePosition", camera.globalPosition);
        }
        const defines = effect.defines;
        if (this._scene) {
            (0, $aAFeM.bindClipPlane)(effect, this, this._scene);
            if (this.applyFog) (0, $alPCh.BindFogParameters)(this._scene, undefined, effect);
        }
        if (defines.indexOf("#define BILLBOARDMODE_ALL") >= 0) {
            const invView = viewMatrix.clone();
            invView.invert();
            effect.setMatrix("invView", invView);
        }
        // Log. depth
        if (this.useLogarithmicDepth && this._scene) (0, $alPCh.BindLogDepth)(defines, effect, this._scene);
        // image processing
        if (this._imageProcessingConfiguration && !this._imageProcessingConfiguration.applyByPostProcess) this._imageProcessingConfiguration.bind(effect);
        // Draw order
        switch(blendMode){
            case (0, $hi6ss.ParticleSystem).BLENDMODE_ADD:
                this._engine.setAlphaMode(1);
                break;
            case (0, $hi6ss.ParticleSystem).BLENDMODE_ONEONE:
                this._engine.setAlphaMode(6);
                break;
            case (0, $hi6ss.ParticleSystem).BLENDMODE_STANDARD:
                this._engine.setAlphaMode(2);
                break;
            case (0, $hi6ss.ParticleSystem).BLENDMODE_MULTIPLY:
                this._engine.setAlphaMode(4);
                break;
        }
        // Bind source VAO
        this._platform.bindDrawBuffers(this._targetIndex, effect, this._scene?.forceWireframe ? this._linesIndexBufferUseInstancing : null);
        if (this._onBeforeDrawParticlesObservable) this._onBeforeDrawParticlesObservable.notifyObservers(effect);
        // Render
        if (this._scene?.forceWireframe) this._engine.drawElementsType(6, 0, 10, this._currentActiveCount);
        else this._engine.drawArraysType(7, 0, 4, this._currentActiveCount);
        this._engine.setAlphaMode(0);
        if (this._scene?.forceWireframe) this._engine.unbindInstanceAttributes();
        return this._currentActiveCount;
    }
    /** @internal */ _update(emitterWM) {
        if (!this.emitter || !this._targetBuffer) return;
        if (!this._recreateUpdateEffect() || this._rebuildingAfterContextLost) return;
        if (!emitterWM) {
            if (this.emitter.position) {
                const emitterMesh = this.emitter;
                emitterWM = emitterMesh.getWorldMatrix();
            } else {
                const emitterPosition = this.emitter;
                emitterWM = (0, $ha1VO.TmpVectors).Matrix[0];
                (0, $ha1VO.Matrix).TranslationToRef(emitterPosition.x, emitterPosition.y, emitterPosition.z, emitterWM);
            }
        }
        this._platform.preUpdateParticleBuffer();
        this._updateBuffer.setFloat("currentCount", this._currentActiveCount);
        this._updateBuffer.setFloat("timeDelta", this._timeDelta);
        this._updateBuffer.setFloat("stopFactor", this._stopped ? 0 : 1);
        this._updateBuffer.setInt("randomTextureSize", this._randomTextureSize);
        this._updateBuffer.setFloat2("lifeTime", this.minLifeTime, this.maxLifeTime);
        this._updateBuffer.setFloat2("emitPower", this.minEmitPower, this.maxEmitPower);
        if (!this._colorGradientsTexture) {
            this._updateBuffer.setDirectColor4("color1", this.color1);
            this._updateBuffer.setDirectColor4("color2", this.color2);
        }
        this._updateBuffer.setFloat2("sizeRange", this.minSize, this.maxSize);
        this._updateBuffer.setFloat4("scaleRange", this.minScaleX, this.maxScaleX, this.minScaleY, this.maxScaleY);
        this._updateBuffer.setFloat4("angleRange", this.minAngularSpeed, this.maxAngularSpeed, this.minInitialRotation, this.maxInitialRotation);
        this._updateBuffer.setVector3("gravity", this.gravity);
        if (this._limitVelocityGradientsTexture) this._updateBuffer.setFloat("limitVelocityDamping", this.limitVelocityDamping);
        if (this.particleEmitterType) this.particleEmitterType.applyToShader(this._updateBuffer);
        if (this._isAnimationSheetEnabled) this._updateBuffer.setFloat4("cellInfos", this.startSpriteCellID, this.endSpriteCellID, this.spriteCellChangeSpeed, this.spriteCellLoop ? 1 : 0);
        if (this.noiseTexture) this._updateBuffer.setVector3("noiseStrength", this.noiseStrength);
        if (!this.isLocal) this._updateBuffer.setMatrix("emitterWM", emitterWM);
        this._platform.updateParticleBuffer(this._targetIndex, this._targetBuffer, this._currentActiveCount);
        // Switch VAOs
        this._targetIndex++;
        if (this._targetIndex === 2) this._targetIndex = 0;
        // Switch buffers
        const tmpBuffer = this._sourceBuffer;
        this._sourceBuffer = this._targetBuffer;
        this._targetBuffer = tmpBuffer;
    }
    /**
     * Renders the particle system in its current state
     * @param preWarm defines if the system should only update the particles but not render them
     * @param forceUpdateOnly if true, force to only update the particles and never display them (meaning, even if preWarm=false, when forceUpdateOnly=true the particles won't be displayed)
     * @returns the current number of particles
     */ render(preWarm = false, forceUpdateOnly = false) {
        if (!this._started) return 0;
        if (!this.isReady()) return 0;
        if (!preWarm && this._scene) {
            if (!this._preWarmDone && this.preWarmCycles) {
                for(let index = 0; index < this.preWarmCycles; index++){
                    this.animate(true);
                    this.render(true, true);
                }
                this._preWarmDone = true;
            }
            if (this._currentRenderId === this._scene.getRenderId() && (!this._scene.activeCamera || this._scene.activeCamera && this._currentRenderingCameraUniqueId === this._scene.activeCamera.uniqueId)) return 0;
            this._currentRenderId = this._scene.getRenderId();
            if (this._scene.activeCamera) this._currentRenderingCameraUniqueId = this._scene.activeCamera.uniqueId;
        }
        // Get everything ready to render
        this._initialize();
        this._accumulatedCount += this.emitRate * this._timeDelta;
        if (this._accumulatedCount > 1) {
            const intPart = this._accumulatedCount | 0;
            this._accumulatedCount -= intPart;
            this._currentActiveCount += intPart;
        }
        this._currentActiveCount = Math.min(this._maxActiveParticleCount, this._currentActiveCount);
        if (!this._currentActiveCount) return 0;
        // Enable update effect
        let emitterWM;
        if (this.emitter.position) {
            const emitterMesh = this.emitter;
            emitterWM = emitterMesh.getWorldMatrix();
        } else {
            const emitterPosition = this.emitter;
            emitterWM = (0, $ha1VO.TmpVectors).Matrix[0];
            (0, $ha1VO.Matrix).TranslationToRef(emitterPosition.x, emitterPosition.y, emitterPosition.z, emitterWM);
        }
        const engine = this._engine;
        if (!this.updateInAnimate) this._update(emitterWM);
        let outparticles = 0;
        if (!preWarm && !forceUpdateOnly) {
            engine.setState(false);
            if (this.forceDepthWrite) engine.setDepthWrite(true);
            if (this.blendMode === (0, $hi6ss.ParticleSystem).BLENDMODE_MULTIPLYADD) outparticles = this._render((0, $hi6ss.ParticleSystem).BLENDMODE_MULTIPLY, emitterWM) + this._render((0, $hi6ss.ParticleSystem).BLENDMODE_ADD, emitterWM);
            else outparticles = this._render(this.blendMode, emitterWM);
            this._engine.setAlphaMode(0);
        }
        return outparticles;
    }
    /**
     * Rebuilds the particle system
     */ rebuild() {
        const checkUpdateEffect = ()=>{
            if (!this._recreateUpdateEffect() || !this._platform.isUpdateBufferReady()) setTimeout(checkUpdateEffect, 10);
            else {
                this._initialize(true);
                this._rebuildingAfterContextLost = false;
            }
        };
        this._createIndexBuffer();
        this._cachedUpdateDefines = "";
        this._platform.contextLost();
        this._rebuildingAfterContextLost = true;
        checkUpdateEffect();
    }
    _releaseBuffers() {
        if (this._buffer0) {
            this._buffer0.dispose();
            this._buffer0 = null;
        }
        if (this._buffer1) {
            this._buffer1.dispose();
            this._buffer1 = null;
        }
        if (this._spriteBuffer) {
            this._spriteBuffer.dispose();
            this._spriteBuffer = null;
        }
        this._platform.releaseBuffers();
    }
    /**
     * Disposes the particle system and free the associated resources
     * @param disposeTexture defines if the particule texture must be disposed as well (true by default)
     */ dispose(disposeTexture = true) {
        for(const blendMode in this._drawWrappers){
            const drawWrapper = this._drawWrappers[blendMode];
            drawWrapper.dispose();
        }
        this._drawWrappers = {};
        if (this._scene) {
            const index = this._scene.particleSystems.indexOf(this);
            if (index > -1) this._scene.particleSystems.splice(index, 1);
        }
        this._releaseBuffers();
        this._platform.releaseVertexBuffers();
        for(let i = 0; i < this._renderVertexBuffers.length; ++i){
            const rvb = this._renderVertexBuffers[i];
            for(const key in rvb)rvb[key].dispose();
        }
        this._renderVertexBuffers = [];
        if (this._colorGradientsTexture) {
            this._colorGradientsTexture.dispose();
            this._colorGradientsTexture = null;
        }
        if (this._sizeGradientsTexture) {
            this._sizeGradientsTexture.dispose();
            this._sizeGradientsTexture = null;
        }
        if (this._angularSpeedGradientsTexture) {
            this._angularSpeedGradientsTexture.dispose();
            this._angularSpeedGradientsTexture = null;
        }
        if (this._velocityGradientsTexture) {
            this._velocityGradientsTexture.dispose();
            this._velocityGradientsTexture = null;
        }
        if (this._limitVelocityGradientsTexture) {
            this._limitVelocityGradientsTexture.dispose();
            this._limitVelocityGradientsTexture = null;
        }
        if (this._dragGradientsTexture) {
            this._dragGradientsTexture.dispose();
            this._dragGradientsTexture = null;
        }
        if (this._randomTexture) {
            this._randomTexture.dispose();
            this._randomTexture = null;
        }
        if (this._randomTexture2) {
            this._randomTexture2.dispose();
            this._randomTexture2 = null;
        }
        if (disposeTexture && this.particleTexture) {
            this.particleTexture.dispose();
            this.particleTexture = null;
        }
        if (disposeTexture && this.noiseTexture) {
            this.noiseTexture.dispose();
            this.noiseTexture = null;
        }
        // Callback
        this.onStoppedObservable.clear();
        this.onDisposeObservable.notifyObservers(this);
        this.onDisposeObservable.clear();
    }
    /**
     * Clones the particle system.
     * @param name The name of the cloned object
     * @param newEmitter The new emitter to use
     * @param cloneTexture Also clone the textures if true
     * @returns the cloned particle system
     */ clone(name, newEmitter, cloneTexture = false) {
        const custom = {
            ...this._customWrappers
        };
        let program = null;
        const engine = this._engine;
        if (engine.createEffectForParticles) {
            if (this.customShader != null) {
                program = this.customShader;
                const defines = program.shaderOptions.defines.length > 0 ? program.shaderOptions.defines.join("\n") : "";
                custom[0] = engine.createEffectForParticles(program.shaderPath.fragmentElement, program.shaderOptions.uniforms, program.shaderOptions.samplers, defines, undefined, undefined, undefined, this);
            }
        }
        const serialization = this.serialize(cloneTexture);
        const result = $97896c8ef8fec777$export$573e67859cf40aa7.Parse(serialization, this._scene || this._engine, this._rootUrl);
        result.name = name;
        result.customShader = program;
        result._customWrappers = custom;
        if (newEmitter === undefined) newEmitter = this.emitter;
        if (this.noiseTexture) result.noiseTexture = this.noiseTexture.clone();
        result.emitter = newEmitter;
        return result;
    }
    /**
     * Serializes the particle system to a JSON object
     * @param serializeTexture defines if the texture must be serialized as well
     * @returns the JSON object
     */ serialize(serializeTexture = false) {
        const serializationObject = {};
        (0, $hi6ss.ParticleSystem)._Serialize(serializationObject, this, serializeTexture);
        serializationObject.activeParticleCount = this.activeParticleCount;
        serializationObject.randomTextureSize = this._randomTextureSize;
        serializationObject.customShader = this.customShader;
        return serializationObject;
    }
    /**
     * Parses a JSON object to create a GPU particle system.
     * @param parsedParticleSystem The JSON object to parse
     * @param sceneOrEngine The scene or the engine to create the particle system in
     * @param rootUrl The root url to use to load external dependencies like texture
     * @param doNotStart Ignore the preventAutoStart attribute and does not start
     * @param capacity defines the system capacity (if null or undefined the sotred capacity will be used)
     * @returns the parsed GPU particle system
     */ static Parse(parsedParticleSystem, sceneOrEngine, rootUrl, doNotStart = false, capacity) {
        const name = parsedParticleSystem.name;
        let engine;
        let scene;
        if (sceneOrEngine instanceof (0, $2h5JR.ThinEngine)) engine = sceneOrEngine;
        else {
            scene = sceneOrEngine;
            engine = scene.getEngine();
        }
        const particleSystem = new $97896c8ef8fec777$export$573e67859cf40aa7(name, {
            capacity: capacity || parsedParticleSystem.capacity,
            randomTextureSize: parsedParticleSystem.randomTextureSize
        }, sceneOrEngine, null, parsedParticleSystem.isAnimationSheetEnabled);
        particleSystem._rootUrl = rootUrl;
        if (parsedParticleSystem.customShader && engine.createEffectForParticles) {
            const program = parsedParticleSystem.customShader;
            const defines = program.shaderOptions.defines.length > 0 ? program.shaderOptions.defines.join("\n") : "";
            const custom = engine.createEffectForParticles(program.shaderPath.fragmentElement, program.shaderOptions.uniforms, program.shaderOptions.samplers, defines, undefined, undefined, undefined, particleSystem);
            particleSystem.setCustomEffect(custom, 0);
            particleSystem.customShader = program;
        }
        if (parsedParticleSystem.id) particleSystem.id = parsedParticleSystem.id;
        if (parsedParticleSystem.activeParticleCount) particleSystem.activeParticleCount = parsedParticleSystem.activeParticleCount;
        (0, $hi6ss.ParticleSystem)._Parse(parsedParticleSystem, particleSystem, sceneOrEngine, rootUrl);
        // Auto start
        if (parsedParticleSystem.preventAutoStart) particleSystem.preventAutoStart = parsedParticleSystem.preventAutoStart;
        if (!doNotStart && !particleSystem.preventAutoStart) particleSystem.start();
        return particleSystem;
    }
}

});
parcelRegister("iDYnp", function(module, exports) {

$parcel$export(module.exports, "ColorGradient", () => $d92ab40db8c700a0$export$611a8e87a207147e);
$parcel$export(module.exports, "Color3Gradient", () => $d92ab40db8c700a0$export$9c465576c5b3fff7);
$parcel$export(module.exports, "FactorGradient", () => $d92ab40db8c700a0$export$3722161617a7d2a5);
$parcel$export(module.exports, "GradientHelper", () => $d92ab40db8c700a0$export$9547bfcc1522be4f);

var $7etnY = parcelRequire("7etnY");
class $d92ab40db8c700a0$export$611a8e87a207147e {
    /**
     * Creates a new color4 gradient
     * @param gradient gets or sets the gradient value (between 0 and 1)
     * @param color1 gets or sets first associated color
     * @param color2 gets or sets first second color
     */ constructor(/**
     * Gets or sets the gradient value (between 0 and 1)
     */ gradient, /**
     * Gets or sets first associated color
     */ color1, /**
     * Gets or sets second associated color
     */ color2){
        this.gradient = gradient;
        this.color1 = color1;
        this.color2 = color2;
    }
    /**
     * Will get a color picked randomly between color1 and color2.
     * If color2 is undefined then color1 will be used
     * @param result defines the target Color4 to store the result in
     */ getColorToRef(result) {
        if (!this.color2) {
            result.copyFrom(this.color1);
            return;
        }
        (0, $7etnY.Color4).LerpToRef(this.color1, this.color2, Math.random(), result);
    }
}
class $d92ab40db8c700a0$export$9c465576c5b3fff7 {
    /**
     * Creates a new color3 gradient
     * @param gradient gets or sets the gradient value (between 0 and 1)
     * @param color gets or sets associated color
     */ constructor(/**
     * Gets or sets the gradient value (between 0 and 1)
     */ gradient, /**
     * Gets or sets the associated color
     */ color){
        this.gradient = gradient;
        this.color = color;
    }
}
class $d92ab40db8c700a0$export$3722161617a7d2a5 {
    /**
     * Creates a new factor gradient
     * @param gradient gets or sets the gradient value (between 0 and 1)
     * @param factor1 gets or sets first associated factor
     * @param factor2 gets or sets second associated factor
     */ constructor(/**
     * Gets or sets the gradient value (between 0 and 1)
     */ gradient, /**
     * Gets or sets first associated factor
     */ factor1, /**
     * Gets or sets second associated factor
     */ factor2){
        this.gradient = gradient;
        this.factor1 = factor1;
        this.factor2 = factor2;
    }
    /**
     * Will get a number picked randomly between factor1 and factor2.
     * If factor2 is undefined then factor1 will be used
     * @returns the picked number
     */ getFactor() {
        if (this.factor2 === undefined || this.factor2 === this.factor1) return this.factor1;
        return this.factor1 + (this.factor2 - this.factor1) * Math.random();
    }
}
class $d92ab40db8c700a0$export$9547bfcc1522be4f {
    /**
     * Gets the current gradient from an array of IValueGradient
     * @param ratio defines the current ratio to get
     * @param gradients defines the array of IValueGradient
     * @param updateFunc defines the callback function used to get the final value from the selected gradients
     */ static GetCurrentGradient(ratio, gradients, updateFunc) {
        // Use last index if over
        if (gradients[0].gradient > ratio) {
            updateFunc(gradients[0], gradients[0], 1.0);
            return;
        }
        for(let gradientIndex = 0; gradientIndex < gradients.length - 1; gradientIndex++){
            const currentGradient = gradients[gradientIndex];
            const nextGradient = gradients[gradientIndex + 1];
            if (ratio >= currentGradient.gradient && ratio <= nextGradient.gradient) {
                const scale = (ratio - currentGradient.gradient) / (nextGradient.gradient - currentGradient.gradient);
                updateFunc(currentGradient, nextGradient, scale);
                return;
            }
        }
        // Use last index if over
        const lastIndex = gradients.length - 1;
        updateFunc(gradients[lastIndex], gradients[lastIndex], 1.0);
    }
}

});

parcelRegister("hi6ss", function(module, exports) {

$parcel$export(module.exports, "ParticleSystem", () => $c96920833f35da71$export$f219b6a0e4bb0b6d);

var $cOe7Z = parcelRequire("cOe7Z");

var $b2hv8 = parcelRequire("b2hv8");

var $7etnY = parcelRequire("7etnY");

var $ha1VO = parcelRequire("ha1VO");

var $2h5JR = parcelRequire("2h5JR");

var $8DoUR = parcelRequire("8DoUR");

var $6Ho1L = parcelRequire("6Ho1L");

var $i7kWk = parcelRequire("i7kWk");

var $bnmc3 = parcelRequire("bnmc3");

var $6V6Qz = parcelRequire("6V6Qz");

var $7W4Lm = parcelRequire("7W4Lm");

var $2QOeY = parcelRequire("2QOeY");

var $lqOHh = parcelRequire("lqOHh");

var $eHSuH = parcelRequire("eHSuH");

var $fRkVr = parcelRequire("fRkVr");

var $f1bVt = parcelRequire("f1bVt");
class $c96920833f35da71$export$f219b6a0e4bb0b6d extends (0, $cOe7Z.ThinParticleSystem) {
    constructor(){
        super(...arguments);
        /**
         * @internal
         * If the particle systems emitter should be disposed when the particle system is disposed
         */ this._disposeEmitterOnDispose = false;
        this._emitFromParticle = (particle)=>{
            if (!this._subEmitters || this._subEmitters.length === 0) return;
            const templateIndex = Math.floor(Math.random() * this._subEmitters.length);
            this._subEmitters[templateIndex].forEach((subEmitter)=>{
                if (subEmitter.type === (0, $b2hv8.SubEmitterType).END) {
                    const subSystem = subEmitter.clone();
                    particle._inheritParticleInfoToSubEmitter(subSystem);
                    subSystem.particleSystem._rootParticleSystem = this;
                    this.activeSubSystems.push(subSystem.particleSystem);
                    subSystem.particleSystem.start();
                }
            });
        };
    }
    /**
     * Creates a Point Emitter for the particle system (emits directly from the emitter position)
     * @param direction1 Particles are emitted between the direction1 and direction2 from within the box
     * @param direction2 Particles are emitted between the direction1 and direction2 from within the box
     * @returns the emitter
     */ createPointEmitter(direction1, direction2) {
        const particleEmitter = (0, $f1bVt.CreatePointEmitter)(direction1, direction2);
        this.particleEmitterType = particleEmitter;
        return particleEmitter;
    }
    /**
     * Creates a Hemisphere Emitter for the particle system (emits along the hemisphere radius)
     * @param radius The radius of the hemisphere to emit from
     * @param radiusRange The range of the hemisphere to emit from [0-1] 0 Surface Only, 1 Entire Radius
     * @returns the emitter
     */ createHemisphericEmitter(radius = 1, radiusRange = 1) {
        const particleEmitter = (0, $f1bVt.CreateHemisphericEmitter)(radius, radiusRange);
        this.particleEmitterType = particleEmitter;
        return particleEmitter;
    }
    /**
     * Creates a Sphere Emitter for the particle system (emits along the sphere radius)
     * @param radius The radius of the sphere to emit from
     * @param radiusRange The range of the sphere to emit from [0-1] 0 Surface Only, 1 Entire Radius
     * @returns the emitter
     */ createSphereEmitter(radius = 1, radiusRange = 1) {
        const particleEmitter = (0, $f1bVt.CreateSphereEmitter)(radius, radiusRange);
        this.particleEmitterType = particleEmitter;
        return particleEmitter;
    }
    /**
     * Creates a Directed Sphere Emitter for the particle system (emits between direction1 and direction2)
     * @param radius The radius of the sphere to emit from
     * @param direction1 Particles are emitted between the direction1 and direction2 from within the sphere
     * @param direction2 Particles are emitted between the direction1 and direction2 from within the sphere
     * @returns the emitter
     */ createDirectedSphereEmitter(radius = 1, direction1 = new (0, $ha1VO.Vector3)(0, 1.0, 0), direction2 = new (0, $ha1VO.Vector3)(0, 1.0, 0)) {
        const particleEmitter = (0, $f1bVt.CreateDirectedSphereEmitter)(radius, direction1, direction2);
        this.particleEmitterType = particleEmitter;
        return particleEmitter;
    }
    /**
     * Creates a Cylinder Emitter for the particle system (emits from the cylinder to the particle position)
     * @param radius The radius of the emission cylinder
     * @param height The height of the emission cylinder
     * @param radiusRange The range of emission [0-1] 0 Surface only, 1 Entire Radius
     * @param directionRandomizer How much to randomize the particle direction [0-1]
     * @returns the emitter
     */ createCylinderEmitter(radius = 1, height = 1, radiusRange = 1, directionRandomizer = 0) {
        const particleEmitter = (0, $f1bVt.CreateCylinderEmitter)(radius, height, radiusRange, directionRandomizer);
        this.particleEmitterType = particleEmitter;
        return particleEmitter;
    }
    /**
     * Creates a Directed Cylinder Emitter for the particle system (emits between direction1 and direction2)
     * @param radius The radius of the cylinder to emit from
     * @param height The height of the emission cylinder
     * @param radiusRange the range of the emission cylinder [0-1] 0 Surface only, 1 Entire Radius (1 by default)
     * @param direction1 Particles are emitted between the direction1 and direction2 from within the cylinder
     * @param direction2 Particles are emitted between the direction1 and direction2 from within the cylinder
     * @returns the emitter
     */ createDirectedCylinderEmitter(radius = 1, height = 1, radiusRange = 1, direction1 = new (0, $ha1VO.Vector3)(0, 1.0, 0), direction2 = new (0, $ha1VO.Vector3)(0, 1.0, 0)) {
        const particleEmitter = (0, $f1bVt.CreateDirectedCylinderEmitter)(radius, height, radiusRange, direction1, direction2);
        this.particleEmitterType = particleEmitter;
        return particleEmitter;
    }
    /**
     * Creates a Cone Emitter for the particle system (emits from the cone to the particle position)
     * @param radius The radius of the cone to emit from
     * @param angle The base angle of the cone
     * @returns the emitter
     */ createConeEmitter(radius = 1, angle = Math.PI / 4) {
        const particleEmitter = (0, $f1bVt.CreateConeEmitter)(radius, angle);
        this.particleEmitterType = particleEmitter;
        return particleEmitter;
    }
    /**
     * Creates a Box Emitter for the particle system. (emits between direction1 and direction2 from withing the box defined by minEmitBox and maxEmitBox)
     * @param direction1 Particles are emitted between the direction1 and direction2 from within the box
     * @param direction2 Particles are emitted between the direction1 and direction2 from within the box
     * @param minEmitBox Particles are emitted from the box between minEmitBox and maxEmitBox
     * @param maxEmitBox  Particles are emitted from the box between minEmitBox and maxEmitBox
     * @returns the emitter
     */ createBoxEmitter(direction1, direction2, minEmitBox, maxEmitBox) {
        const particleEmitter = new (0, $6V6Qz.BoxParticleEmitter)();
        this.particleEmitterType = particleEmitter;
        this.direction1 = direction1;
        this.direction2 = direction2;
        this.minEmitBox = minEmitBox;
        this.maxEmitBox = maxEmitBox;
        return particleEmitter;
    }
    _prepareSubEmitterInternalArray() {
        this._subEmitters = new Array();
        if (this.subEmitters) this.subEmitters.forEach((subEmitter)=>{
            if (subEmitter instanceof $c96920833f35da71$export$f219b6a0e4bb0b6d) this._subEmitters.push([
                new (0, $b2hv8.SubEmitter)(subEmitter)
            ]);
            else if (subEmitter instanceof (0, $b2hv8.SubEmitter)) this._subEmitters.push([
                subEmitter
            ]);
            else if (subEmitter instanceof Array) this._subEmitters.push(subEmitter);
        });
    }
    _stopSubEmitters() {
        if (!this.activeSubSystems) return;
        this.activeSubSystems.forEach((subSystem)=>{
            subSystem.stop(true);
        });
        this.activeSubSystems = [];
    }
    _removeFromRoot() {
        if (!this._rootParticleSystem) return;
        const index = this._rootParticleSystem.activeSubSystems.indexOf(this);
        if (index !== -1) this._rootParticleSystem.activeSubSystems.splice(index, 1);
        this._rootParticleSystem = null;
    }
    _preStart() {
        // Convert the subEmitters field to the constant type field _subEmitters
        this._prepareSubEmitterInternalArray();
        if (this._subEmitters && this._subEmitters.length != 0) this.activeSubSystems = [];
    }
    _postStop(stopSubEmitters) {
        if (stopSubEmitters) this._stopSubEmitters();
    }
    _prepareParticle(particle) {
        // Attach emitters
        if (this._subEmitters && this._subEmitters.length > 0) {
            const subEmitters = this._subEmitters[Math.floor(Math.random() * this._subEmitters.length)];
            particle._attachedSubEmitters = [];
            subEmitters.forEach((subEmitter)=>{
                if (subEmitter.type === (0, $b2hv8.SubEmitterType).ATTACHED) {
                    const newEmitter = subEmitter.clone();
                    particle._attachedSubEmitters.push(newEmitter);
                    newEmitter.particleSystem.start();
                }
            });
        }
    }
    /** @internal */ _onDispose(disposeAttachedSubEmitters = false, disposeEndSubEmitters = false) {
        this._removeFromRoot();
        if (this.subEmitters && !this._subEmitters) this._prepareSubEmitterInternalArray();
        if (disposeAttachedSubEmitters) this.particles?.forEach((particle)=>{
            if (particle._attachedSubEmitters) for(let i = particle._attachedSubEmitters.length - 1; i >= 0; i -= 1)particle._attachedSubEmitters[i].dispose();
        });
        if (disposeEndSubEmitters) {
            if (this.activeSubSystems) for(let i = this.activeSubSystems.length - 1; i >= 0; i -= 1)this.activeSubSystems[i].dispose();
        }
        if (this._subEmitters && this._subEmitters.length) {
            for(let index = 0; index < this._subEmitters.length; index++)for (const subEmitter of this._subEmitters[index])subEmitter.dispose();
            this._subEmitters = [];
            this.subEmitters = [];
        }
        if (this._disposeEmitterOnDispose && this.emitter && this.emitter.dispose) this.emitter.dispose(true);
    }
    /**
     * @internal
     */ static _Parse(parsedParticleSystem, particleSystem, sceneOrEngine, rootUrl) {
        let scene;
        if (sceneOrEngine instanceof (0, $2h5JR.ThinEngine)) scene = null;
        else scene = sceneOrEngine;
        const internalClass = (0, $8DoUR.GetClass)("BABYLON.Texture");
        if (internalClass && scene) {
            // Texture
            if (parsedParticleSystem.texture) particleSystem.particleTexture = internalClass.Parse(parsedParticleSystem.texture, scene, rootUrl);
            else if (parsedParticleSystem.textureName) {
                particleSystem.particleTexture = new internalClass(rootUrl + parsedParticleSystem.textureName, scene, false, parsedParticleSystem.invertY !== undefined ? parsedParticleSystem.invertY : true);
                particleSystem.particleTexture.name = parsedParticleSystem.textureName;
            }
        }
        // Emitter
        if (!parsedParticleSystem.emitterId && parsedParticleSystem.emitterId !== 0 && parsedParticleSystem.emitter === undefined) particleSystem.emitter = (0, $ha1VO.Vector3).Zero();
        else if (parsedParticleSystem.emitterId && scene) particleSystem.emitter = scene.getLastMeshById(parsedParticleSystem.emitterId);
        else particleSystem.emitter = (0, $ha1VO.Vector3).FromArray(parsedParticleSystem.emitter);
        particleSystem.isLocal = !!parsedParticleSystem.isLocal;
        // Misc.
        if (parsedParticleSystem.renderingGroupId !== undefined) particleSystem.renderingGroupId = parsedParticleSystem.renderingGroupId;
        if (parsedParticleSystem.isBillboardBased !== undefined) particleSystem.isBillboardBased = parsedParticleSystem.isBillboardBased;
        if (parsedParticleSystem.billboardMode !== undefined) particleSystem.billboardMode = parsedParticleSystem.billboardMode;
        if (parsedParticleSystem.useLogarithmicDepth !== undefined) particleSystem.useLogarithmicDepth = parsedParticleSystem.useLogarithmicDepth;
        // Animations
        if (parsedParticleSystem.animations) {
            for(let animationIndex = 0; animationIndex < parsedParticleSystem.animations.length; animationIndex++){
                const parsedAnimation = parsedParticleSystem.animations[animationIndex];
                const internalClass = (0, $8DoUR.GetClass)("BABYLON.Animation");
                if (internalClass) particleSystem.animations.push(internalClass.Parse(parsedAnimation));
            }
            particleSystem.beginAnimationOnStart = parsedParticleSystem.beginAnimationOnStart;
            particleSystem.beginAnimationFrom = parsedParticleSystem.beginAnimationFrom;
            particleSystem.beginAnimationTo = parsedParticleSystem.beginAnimationTo;
            particleSystem.beginAnimationLoop = parsedParticleSystem.beginAnimationLoop;
        }
        if (parsedParticleSystem.autoAnimate && scene) scene.beginAnimation(particleSystem, parsedParticleSystem.autoAnimateFrom, parsedParticleSystem.autoAnimateTo, parsedParticleSystem.autoAnimateLoop, parsedParticleSystem.autoAnimateSpeed || 1.0);
        // Particle system
        particleSystem.startDelay = parsedParticleSystem.startDelay | 0;
        particleSystem.minAngularSpeed = parsedParticleSystem.minAngularSpeed;
        particleSystem.maxAngularSpeed = parsedParticleSystem.maxAngularSpeed;
        particleSystem.minSize = parsedParticleSystem.minSize;
        particleSystem.maxSize = parsedParticleSystem.maxSize;
        if (parsedParticleSystem.minScaleX) {
            particleSystem.minScaleX = parsedParticleSystem.minScaleX;
            particleSystem.maxScaleX = parsedParticleSystem.maxScaleX;
            particleSystem.minScaleY = parsedParticleSystem.minScaleY;
            particleSystem.maxScaleY = parsedParticleSystem.maxScaleY;
        }
        if (parsedParticleSystem.preWarmCycles !== undefined) {
            particleSystem.preWarmCycles = parsedParticleSystem.preWarmCycles;
            particleSystem.preWarmStepOffset = parsedParticleSystem.preWarmStepOffset;
        }
        if (parsedParticleSystem.minInitialRotation !== undefined) {
            particleSystem.minInitialRotation = parsedParticleSystem.minInitialRotation;
            particleSystem.maxInitialRotation = parsedParticleSystem.maxInitialRotation;
        }
        particleSystem.minLifeTime = parsedParticleSystem.minLifeTime;
        particleSystem.maxLifeTime = parsedParticleSystem.maxLifeTime;
        particleSystem.minEmitPower = parsedParticleSystem.minEmitPower;
        particleSystem.maxEmitPower = parsedParticleSystem.maxEmitPower;
        particleSystem.emitRate = parsedParticleSystem.emitRate;
        particleSystem.gravity = (0, $ha1VO.Vector3).FromArray(parsedParticleSystem.gravity);
        if (parsedParticleSystem.noiseStrength) particleSystem.noiseStrength = (0, $ha1VO.Vector3).FromArray(parsedParticleSystem.noiseStrength);
        particleSystem.color1 = (0, $7etnY.Color4).FromArray(parsedParticleSystem.color1);
        particleSystem.color2 = (0, $7etnY.Color4).FromArray(parsedParticleSystem.color2);
        particleSystem.colorDead = (0, $7etnY.Color4).FromArray(parsedParticleSystem.colorDead);
        particleSystem.updateSpeed = parsedParticleSystem.updateSpeed;
        particleSystem.targetStopDuration = parsedParticleSystem.targetStopDuration;
        particleSystem.blendMode = parsedParticleSystem.blendMode;
        if (parsedParticleSystem.colorGradients) for (const colorGradient of parsedParticleSystem.colorGradients)particleSystem.addColorGradient(colorGradient.gradient, (0, $7etnY.Color4).FromArray(colorGradient.color1), colorGradient.color2 ? (0, $7etnY.Color4).FromArray(colorGradient.color2) : undefined);
        if (parsedParticleSystem.rampGradients) {
            for (const rampGradient of parsedParticleSystem.rampGradients)particleSystem.addRampGradient(rampGradient.gradient, (0, $7etnY.Color3).FromArray(rampGradient.color));
            particleSystem.useRampGradients = parsedParticleSystem.useRampGradients;
        }
        if (parsedParticleSystem.colorRemapGradients) for (const colorRemapGradient of parsedParticleSystem.colorRemapGradients)particleSystem.addColorRemapGradient(colorRemapGradient.gradient, colorRemapGradient.factor1 !== undefined ? colorRemapGradient.factor1 : colorRemapGradient.factor, colorRemapGradient.factor2);
        if (parsedParticleSystem.alphaRemapGradients) for (const alphaRemapGradient of parsedParticleSystem.alphaRemapGradients)particleSystem.addAlphaRemapGradient(alphaRemapGradient.gradient, alphaRemapGradient.factor1 !== undefined ? alphaRemapGradient.factor1 : alphaRemapGradient.factor, alphaRemapGradient.factor2);
        if (parsedParticleSystem.sizeGradients) for (const sizeGradient of parsedParticleSystem.sizeGradients)particleSystem.addSizeGradient(sizeGradient.gradient, sizeGradient.factor1 !== undefined ? sizeGradient.factor1 : sizeGradient.factor, sizeGradient.factor2);
        if (parsedParticleSystem.angularSpeedGradients) for (const angularSpeedGradient of parsedParticleSystem.angularSpeedGradients)particleSystem.addAngularSpeedGradient(angularSpeedGradient.gradient, angularSpeedGradient.factor1 !== undefined ? angularSpeedGradient.factor1 : angularSpeedGradient.factor, angularSpeedGradient.factor2);
        if (parsedParticleSystem.velocityGradients) for (const velocityGradient of parsedParticleSystem.velocityGradients)particleSystem.addVelocityGradient(velocityGradient.gradient, velocityGradient.factor1 !== undefined ? velocityGradient.factor1 : velocityGradient.factor, velocityGradient.factor2);
        if (parsedParticleSystem.dragGradients) for (const dragGradient of parsedParticleSystem.dragGradients)particleSystem.addDragGradient(dragGradient.gradient, dragGradient.factor1 !== undefined ? dragGradient.factor1 : dragGradient.factor, dragGradient.factor2);
        if (parsedParticleSystem.emitRateGradients) for (const emitRateGradient of parsedParticleSystem.emitRateGradients)particleSystem.addEmitRateGradient(emitRateGradient.gradient, emitRateGradient.factor1 !== undefined ? emitRateGradient.factor1 : emitRateGradient.factor, emitRateGradient.factor2);
        if (parsedParticleSystem.startSizeGradients) for (const startSizeGradient of parsedParticleSystem.startSizeGradients)particleSystem.addStartSizeGradient(startSizeGradient.gradient, startSizeGradient.factor1 !== undefined ? startSizeGradient.factor1 : startSizeGradient.factor, startSizeGradient.factor2);
        if (parsedParticleSystem.lifeTimeGradients) for (const lifeTimeGradient of parsedParticleSystem.lifeTimeGradients)particleSystem.addLifeTimeGradient(lifeTimeGradient.gradient, lifeTimeGradient.factor1 !== undefined ? lifeTimeGradient.factor1 : lifeTimeGradient.factor, lifeTimeGradient.factor2);
        if (parsedParticleSystem.limitVelocityGradients) {
            for (const limitVelocityGradient of parsedParticleSystem.limitVelocityGradients)particleSystem.addLimitVelocityGradient(limitVelocityGradient.gradient, limitVelocityGradient.factor1 !== undefined ? limitVelocityGradient.factor1 : limitVelocityGradient.factor, limitVelocityGradient.factor2);
            particleSystem.limitVelocityDamping = parsedParticleSystem.limitVelocityDamping;
        }
        if (parsedParticleSystem.noiseTexture && scene) {
            const internalClass = (0, $8DoUR.GetClass)("BABYLON.ProceduralTexture");
            particleSystem.noiseTexture = internalClass.Parse(parsedParticleSystem.noiseTexture, scene, rootUrl);
        }
        // Emitter
        let emitterType;
        if (parsedParticleSystem.particleEmitterType) {
            switch(parsedParticleSystem.particleEmitterType.type){
                case "SphereParticleEmitter":
                    emitterType = new (0, $lqOHh.SphereParticleEmitter)();
                    break;
                case "SphereDirectedParticleEmitter":
                    emitterType = new (0, $lqOHh.SphereDirectedParticleEmitter)();
                    break;
                case "ConeEmitter":
                case "ConeParticleEmitter":
                    emitterType = new (0, $fRkVr.ConeParticleEmitter)();
                    break;
                case "CylinderParticleEmitter":
                    emitterType = new (0, $eHSuH.CylinderParticleEmitter)();
                    break;
                case "CylinderDirectedParticleEmitter":
                    emitterType = new (0, $eHSuH.CylinderDirectedParticleEmitter)();
                    break;
                case "HemisphericParticleEmitter":
                    emitterType = new (0, $2QOeY.HemisphericParticleEmitter)();
                    break;
                case "PointParticleEmitter":
                    emitterType = new (0, $7W4Lm.PointParticleEmitter)();
                    break;
                case "MeshParticleEmitter":
                    emitterType = new (0, $i7kWk.MeshParticleEmitter)();
                    break;
                case "CustomParticleEmitter":
                    emitterType = new (0, $bnmc3.CustomParticleEmitter)();
                    break;
                case "BoxEmitter":
                case "BoxParticleEmitter":
                default:
                    emitterType = new (0, $6V6Qz.BoxParticleEmitter)();
                    break;
            }
            emitterType.parse(parsedParticleSystem.particleEmitterType, scene);
        } else {
            emitterType = new (0, $6V6Qz.BoxParticleEmitter)();
            emitterType.parse(parsedParticleSystem, scene);
        }
        particleSystem.particleEmitterType = emitterType;
        // Animation sheet
        particleSystem.startSpriteCellID = parsedParticleSystem.startSpriteCellID;
        particleSystem.endSpriteCellID = parsedParticleSystem.endSpriteCellID;
        particleSystem.spriteCellLoop = parsedParticleSystem.spriteCellLoop ?? true;
        particleSystem.spriteCellWidth = parsedParticleSystem.spriteCellWidth;
        particleSystem.spriteCellHeight = parsedParticleSystem.spriteCellHeight;
        particleSystem.spriteCellChangeSpeed = parsedParticleSystem.spriteCellChangeSpeed;
        particleSystem.spriteRandomStartCell = parsedParticleSystem.spriteRandomStartCell;
        particleSystem.disposeOnStop = parsedParticleSystem.disposeOnStop ?? false;
        particleSystem.manualEmitCount = parsedParticleSystem.manualEmitCount ?? -1;
    }
    /**
     * Parses a JSON object to create a particle system.
     * @param parsedParticleSystem The JSON object to parse
     * @param sceneOrEngine The scene or the engine to create the particle system in
     * @param rootUrl The root url to use to load external dependencies like texture
     * @param doNotStart Ignore the preventAutoStart attribute and does not start
     * @param capacity defines the system capacity (if null or undefined the sotred capacity will be used)
     * @returns the Parsed particle system
     */ static Parse(parsedParticleSystem, sceneOrEngine, rootUrl, doNotStart = false, capacity) {
        const name = parsedParticleSystem.name;
        let custom = null;
        let program = null;
        let engine;
        let scene;
        if (sceneOrEngine instanceof (0, $2h5JR.ThinEngine)) engine = sceneOrEngine;
        else {
            scene = sceneOrEngine;
            engine = scene.getEngine();
        }
        if (parsedParticleSystem.customShader && engine.createEffectForParticles) {
            program = parsedParticleSystem.customShader;
            const defines = program.shaderOptions.defines.length > 0 ? program.shaderOptions.defines.join("\n") : "";
            custom = engine.createEffectForParticles(program.shaderPath.fragmentElement, program.shaderOptions.uniforms, program.shaderOptions.samplers, defines);
        }
        const particleSystem = new $c96920833f35da71$export$f219b6a0e4bb0b6d(name, capacity || parsedParticleSystem.capacity, sceneOrEngine, custom, parsedParticleSystem.isAnimationSheetEnabled);
        particleSystem.customShader = program;
        particleSystem._rootUrl = rootUrl;
        if (parsedParticleSystem.id) particleSystem.id = parsedParticleSystem.id;
        // SubEmitters
        if (parsedParticleSystem.subEmitters) {
            particleSystem.subEmitters = [];
            for (const cell of parsedParticleSystem.subEmitters){
                const cellArray = [];
                for (const sub of cell)cellArray.push((0, $b2hv8.SubEmitter).Parse(sub, sceneOrEngine, rootUrl));
                particleSystem.subEmitters.push(cellArray);
            }
        }
        $c96920833f35da71$export$f219b6a0e4bb0b6d._Parse(parsedParticleSystem, particleSystem, sceneOrEngine, rootUrl);
        if (parsedParticleSystem.textureMask) particleSystem.textureMask = (0, $7etnY.Color4).FromArray(parsedParticleSystem.textureMask);
        if (parsedParticleSystem.worldOffset) particleSystem.worldOffset = (0, $ha1VO.Vector3).FromArray(parsedParticleSystem.worldOffset);
        // Auto start
        if (parsedParticleSystem.preventAutoStart) particleSystem.preventAutoStart = parsedParticleSystem.preventAutoStart;
        if (!doNotStart && !particleSystem.preventAutoStart) particleSystem.start();
        return particleSystem;
    }
    /**
     * Serializes the particle system to a JSON object
     * @param serializeTexture defines if the texture must be serialized as well
     * @returns the JSON object
     */ serialize(serializeTexture = false) {
        const serializationObject = {};
        $c96920833f35da71$export$f219b6a0e4bb0b6d._Serialize(serializationObject, this, serializeTexture);
        serializationObject.textureMask = this.textureMask.asArray();
        serializationObject.customShader = this.customShader;
        serializationObject.preventAutoStart = this.preventAutoStart;
        serializationObject.worldOffset = this.worldOffset.asArray();
        // SubEmitters
        if (this.subEmitters) {
            serializationObject.subEmitters = [];
            if (!this._subEmitters) this._prepareSubEmitterInternalArray();
            for (const subs of this._subEmitters){
                const cell = [];
                for (const sub of subs)cell.push(sub.serialize(serializeTexture));
                serializationObject.subEmitters.push(cell);
            }
        }
        return serializationObject;
    }
    /**
     * @internal
     */ static _Serialize(serializationObject, particleSystem, serializeTexture) {
        serializationObject.name = particleSystem.name;
        serializationObject.id = particleSystem.id;
        serializationObject.capacity = particleSystem.getCapacity();
        serializationObject.disposeOnStop = particleSystem.disposeOnStop;
        serializationObject.manualEmitCount = particleSystem.manualEmitCount;
        // Emitter
        if (particleSystem.emitter.position) {
            const emitterMesh = particleSystem.emitter;
            serializationObject.emitterId = emitterMesh.id;
        } else {
            const emitterPosition = particleSystem.emitter;
            serializationObject.emitter = emitterPosition.asArray();
        }
        // Emitter
        if (particleSystem.particleEmitterType) serializationObject.particleEmitterType = particleSystem.particleEmitterType.serialize();
        if (particleSystem.particleTexture) {
            if (serializeTexture) serializationObject.texture = particleSystem.particleTexture.serialize();
            else {
                serializationObject.textureName = particleSystem.particleTexture.name;
                serializationObject.invertY = !!particleSystem.particleTexture._invertY;
            }
        }
        serializationObject.isLocal = particleSystem.isLocal;
        // Animations
        (0, $6Ho1L.SerializationHelper).AppendSerializedAnimations(particleSystem, serializationObject);
        serializationObject.beginAnimationOnStart = particleSystem.beginAnimationOnStart;
        serializationObject.beginAnimationFrom = particleSystem.beginAnimationFrom;
        serializationObject.beginAnimationTo = particleSystem.beginAnimationTo;
        serializationObject.beginAnimationLoop = particleSystem.beginAnimationLoop;
        // Particle system
        serializationObject.startDelay = particleSystem.startDelay;
        serializationObject.renderingGroupId = particleSystem.renderingGroupId;
        serializationObject.isBillboardBased = particleSystem.isBillboardBased;
        serializationObject.billboardMode = particleSystem.billboardMode;
        serializationObject.minAngularSpeed = particleSystem.minAngularSpeed;
        serializationObject.maxAngularSpeed = particleSystem.maxAngularSpeed;
        serializationObject.minSize = particleSystem.minSize;
        serializationObject.maxSize = particleSystem.maxSize;
        serializationObject.minScaleX = particleSystem.minScaleX;
        serializationObject.maxScaleX = particleSystem.maxScaleX;
        serializationObject.minScaleY = particleSystem.minScaleY;
        serializationObject.maxScaleY = particleSystem.maxScaleY;
        serializationObject.minEmitPower = particleSystem.minEmitPower;
        serializationObject.maxEmitPower = particleSystem.maxEmitPower;
        serializationObject.minLifeTime = particleSystem.minLifeTime;
        serializationObject.maxLifeTime = particleSystem.maxLifeTime;
        serializationObject.emitRate = particleSystem.emitRate;
        serializationObject.gravity = particleSystem.gravity.asArray();
        serializationObject.noiseStrength = particleSystem.noiseStrength.asArray();
        serializationObject.color1 = particleSystem.color1.asArray();
        serializationObject.color2 = particleSystem.color2.asArray();
        serializationObject.colorDead = particleSystem.colorDead.asArray();
        serializationObject.updateSpeed = particleSystem.updateSpeed;
        serializationObject.targetStopDuration = particleSystem.targetStopDuration;
        serializationObject.blendMode = particleSystem.blendMode;
        serializationObject.preWarmCycles = particleSystem.preWarmCycles;
        serializationObject.preWarmStepOffset = particleSystem.preWarmStepOffset;
        serializationObject.minInitialRotation = particleSystem.minInitialRotation;
        serializationObject.maxInitialRotation = particleSystem.maxInitialRotation;
        serializationObject.startSpriteCellID = particleSystem.startSpriteCellID;
        serializationObject.spriteCellLoop = particleSystem.spriteCellLoop;
        serializationObject.endSpriteCellID = particleSystem.endSpriteCellID;
        serializationObject.spriteCellChangeSpeed = particleSystem.spriteCellChangeSpeed;
        serializationObject.spriteCellWidth = particleSystem.spriteCellWidth;
        serializationObject.spriteCellHeight = particleSystem.spriteCellHeight;
        serializationObject.spriteRandomStartCell = particleSystem.spriteRandomStartCell;
        serializationObject.isAnimationSheetEnabled = particleSystem.isAnimationSheetEnabled;
        serializationObject.useLogarithmicDepth = particleSystem.useLogarithmicDepth;
        const colorGradients = particleSystem.getColorGradients();
        if (colorGradients) {
            serializationObject.colorGradients = [];
            for (const colorGradient of colorGradients){
                const serializedGradient = {
                    gradient: colorGradient.gradient,
                    color1: colorGradient.color1.asArray()
                };
                if (colorGradient.color2) serializedGradient.color2 = colorGradient.color2.asArray();
                else serializedGradient.color2 = colorGradient.color1.asArray();
                serializationObject.colorGradients.push(serializedGradient);
            }
        }
        const rampGradients = particleSystem.getRampGradients();
        if (rampGradients) {
            serializationObject.rampGradients = [];
            for (const rampGradient of rampGradients){
                const serializedGradient = {
                    gradient: rampGradient.gradient,
                    color: rampGradient.color.asArray()
                };
                serializationObject.rampGradients.push(serializedGradient);
            }
            serializationObject.useRampGradients = particleSystem.useRampGradients;
        }
        const colorRemapGradients = particleSystem.getColorRemapGradients();
        if (colorRemapGradients) {
            serializationObject.colorRemapGradients = [];
            for (const colorRemapGradient of colorRemapGradients){
                const serializedGradient = {
                    gradient: colorRemapGradient.gradient,
                    factor1: colorRemapGradient.factor1
                };
                if (colorRemapGradient.factor2 !== undefined) serializedGradient.factor2 = colorRemapGradient.factor2;
                else serializedGradient.factor2 = colorRemapGradient.factor1;
                serializationObject.colorRemapGradients.push(serializedGradient);
            }
        }
        const alphaRemapGradients = particleSystem.getAlphaRemapGradients();
        if (alphaRemapGradients) {
            serializationObject.alphaRemapGradients = [];
            for (const alphaRemapGradient of alphaRemapGradients){
                const serializedGradient = {
                    gradient: alphaRemapGradient.gradient,
                    factor1: alphaRemapGradient.factor1
                };
                if (alphaRemapGradient.factor2 !== undefined) serializedGradient.factor2 = alphaRemapGradient.factor2;
                else serializedGradient.factor2 = alphaRemapGradient.factor1;
                serializationObject.alphaRemapGradients.push(serializedGradient);
            }
        }
        const sizeGradients = particleSystem.getSizeGradients();
        if (sizeGradients) {
            serializationObject.sizeGradients = [];
            for (const sizeGradient of sizeGradients){
                const serializedGradient = {
                    gradient: sizeGradient.gradient,
                    factor1: sizeGradient.factor1
                };
                if (sizeGradient.factor2 !== undefined) serializedGradient.factor2 = sizeGradient.factor2;
                else serializedGradient.factor2 = sizeGradient.factor1;
                serializationObject.sizeGradients.push(serializedGradient);
            }
        }
        const angularSpeedGradients = particleSystem.getAngularSpeedGradients();
        if (angularSpeedGradients) {
            serializationObject.angularSpeedGradients = [];
            for (const angularSpeedGradient of angularSpeedGradients){
                const serializedGradient = {
                    gradient: angularSpeedGradient.gradient,
                    factor1: angularSpeedGradient.factor1
                };
                if (angularSpeedGradient.factor2 !== undefined) serializedGradient.factor2 = angularSpeedGradient.factor2;
                else serializedGradient.factor2 = angularSpeedGradient.factor1;
                serializationObject.angularSpeedGradients.push(serializedGradient);
            }
        }
        const velocityGradients = particleSystem.getVelocityGradients();
        if (velocityGradients) {
            serializationObject.velocityGradients = [];
            for (const velocityGradient of velocityGradients){
                const serializedGradient = {
                    gradient: velocityGradient.gradient,
                    factor1: velocityGradient.factor1
                };
                if (velocityGradient.factor2 !== undefined) serializedGradient.factor2 = velocityGradient.factor2;
                else serializedGradient.factor2 = velocityGradient.factor1;
                serializationObject.velocityGradients.push(serializedGradient);
            }
        }
        const dragGradients = particleSystem.getDragGradients();
        if (dragGradients) {
            serializationObject.dragGradients = [];
            for (const dragGradient of dragGradients){
                const serializedGradient = {
                    gradient: dragGradient.gradient,
                    factor1: dragGradient.factor1
                };
                if (dragGradient.factor2 !== undefined) serializedGradient.factor2 = dragGradient.factor2;
                else serializedGradient.factor2 = dragGradient.factor1;
                serializationObject.dragGradients.push(serializedGradient);
            }
        }
        const emitRateGradients = particleSystem.getEmitRateGradients();
        if (emitRateGradients) {
            serializationObject.emitRateGradients = [];
            for (const emitRateGradient of emitRateGradients){
                const serializedGradient = {
                    gradient: emitRateGradient.gradient,
                    factor1: emitRateGradient.factor1
                };
                if (emitRateGradient.factor2 !== undefined) serializedGradient.factor2 = emitRateGradient.factor2;
                else serializedGradient.factor2 = emitRateGradient.factor1;
                serializationObject.emitRateGradients.push(serializedGradient);
            }
        }
        const startSizeGradients = particleSystem.getStartSizeGradients();
        if (startSizeGradients) {
            serializationObject.startSizeGradients = [];
            for (const startSizeGradient of startSizeGradients){
                const serializedGradient = {
                    gradient: startSizeGradient.gradient,
                    factor1: startSizeGradient.factor1
                };
                if (startSizeGradient.factor2 !== undefined) serializedGradient.factor2 = startSizeGradient.factor2;
                else serializedGradient.factor2 = startSizeGradient.factor1;
                serializationObject.startSizeGradients.push(serializedGradient);
            }
        }
        const lifeTimeGradients = particleSystem.getLifeTimeGradients();
        if (lifeTimeGradients) {
            serializationObject.lifeTimeGradients = [];
            for (const lifeTimeGradient of lifeTimeGradients){
                const serializedGradient = {
                    gradient: lifeTimeGradient.gradient,
                    factor1: lifeTimeGradient.factor1
                };
                if (lifeTimeGradient.factor2 !== undefined) serializedGradient.factor2 = lifeTimeGradient.factor2;
                else serializedGradient.factor2 = lifeTimeGradient.factor1;
                serializationObject.lifeTimeGradients.push(serializedGradient);
            }
        }
        const limitVelocityGradients = particleSystem.getLimitVelocityGradients();
        if (limitVelocityGradients) {
            serializationObject.limitVelocityGradients = [];
            for (const limitVelocityGradient of limitVelocityGradients){
                const serializedGradient = {
                    gradient: limitVelocityGradient.gradient,
                    factor1: limitVelocityGradient.factor1
                };
                if (limitVelocityGradient.factor2 !== undefined) serializedGradient.factor2 = limitVelocityGradient.factor2;
                else serializedGradient.factor2 = limitVelocityGradient.factor1;
                serializationObject.limitVelocityGradients.push(serializedGradient);
            }
            serializationObject.limitVelocityDamping = particleSystem.limitVelocityDamping;
        }
        if (particleSystem.noiseTexture) serializationObject.noiseTexture = particleSystem.noiseTexture.serialize();
    }
    // Clone
    /**
     * Clones the particle system.
     * @param name The name of the cloned object
     * @param newEmitter The new emitter to use
     * @param cloneTexture Also clone the textures if true
     * @returns the cloned particle system
     */ clone(name, newEmitter, cloneTexture = false) {
        const custom = {
            ...this._customWrappers
        };
        let program = null;
        const engine = this._engine;
        if (engine.createEffectForParticles) {
            if (this.customShader != null) {
                program = this.customShader;
                const defines = program.shaderOptions.defines.length > 0 ? program.shaderOptions.defines.join("\n") : "";
                const effect = engine.createEffectForParticles(program.shaderPath.fragmentElement, program.shaderOptions.uniforms, program.shaderOptions.samplers, defines);
                if (!custom[0]) this.setCustomEffect(effect, 0);
                else custom[0].effect = effect;
            }
        }
        const serialization = this.serialize(cloneTexture);
        const result = $c96920833f35da71$export$f219b6a0e4bb0b6d.Parse(serialization, this._scene || this._engine, this._rootUrl);
        result.name = name;
        result.customShader = program;
        result._customWrappers = custom;
        if (newEmitter === undefined) newEmitter = this.emitter;
        if (this.noiseTexture) result.noiseTexture = this.noiseTexture.clone();
        result.emitter = newEmitter;
        if (!this.preventAutoStart) result.start();
        return result;
    }
}
/**
 * Billboard mode will only apply to Y axis
 */ $c96920833f35da71$export$f219b6a0e4bb0b6d.BILLBOARDMODE_Y = 2;
/**
 * Billboard mode will apply to all axes
 */ $c96920833f35da71$export$f219b6a0e4bb0b6d.BILLBOARDMODE_ALL = 7;
/**
 * Special billboard mode where the particle will be biilboard to the camera but rotated to align with direction
 */ $c96920833f35da71$export$f219b6a0e4bb0b6d.BILLBOARDMODE_STRETCHED = 8;
/**
 * Special billboard mode where the particle will be billboard to the camera but only around the axis of the direction of particle emission
 */ $c96920833f35da71$export$f219b6a0e4bb0b6d.BILLBOARDMODE_STRETCHED_LOCAL = 9;
(0, $b2hv8.SubEmitter)._ParseParticleSystem = $c96920833f35da71$export$f219b6a0e4bb0b6d.Parse;

});
parcelRegister("cOe7Z", function(module, exports) {

$parcel$export(module.exports, "ThinParticleSystem", () => $95351d116892571a$export$b52eeadd2730cb3f);

var $iDYnp = parcelRequire("iDYnp");

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $b4i1f = parcelRequire("b4i1f");

var $5Egpj = parcelRequire("5Egpj");

var $ejQPp = parcelRequire("ejQPp");

var $1iaDW = parcelRequire("1iaDW");

var $e6EVj = parcelRequire("e6EVj");

var $hOyoX = parcelRequire("hOyoX");
parcelRequire("bBTDU");
parcelRequire("6ueFN");

var $7etnY = parcelRequire("7etnY");
parcelRequire("emm58");

var $aAFeM = parcelRequire("aAFeM");

var $alPCh = parcelRequire("alPCh");

var $6V6Qz = parcelRequire("6V6Qz");

var $iosaP = parcelRequire("iosaP");

var $ePyUi = parcelRequire("ePyUi");
class $95351d116892571a$export$b52eeadd2730cb3f extends (0, $1iaDW.BaseParticleSystem) {
    /**
     * Sets a callback that will be triggered when the system is disposed
     */ set onDispose(callback) {
        if (this._onDisposeObserver) this.onDisposeObservable.remove(this._onDisposeObserver);
        this._onDisposeObserver = this.onDisposeObservable.add(callback);
    }
    /** Gets or sets a boolean indicating that ramp gradients must be used
     * @see https://doc.babylonjs.com/features/featuresDeepDive/particles/particle_system/particle_system_intro#ramp-gradients
     */ get useRampGradients() {
        return this._useRampGradients;
    }
    set useRampGradients(value) {
        if (this._useRampGradients === value) return;
        this._useRampGradients = value;
        this._resetEffect();
    }
    /**
     * Gets the current list of active particles
     */ get particles() {
        return this._particles;
    }
    /**
     * Gets the number of particles active at the same time.
     * @returns The number of active particles.
     */ getActiveCount() {
        return this._particles.length;
    }
    /**
     * Returns the string "ParticleSystem"
     * @returns a string containing the class name
     */ getClassName() {
        return "ParticleSystem";
    }
    /**
     * Gets a boolean indicating that the system is stopping
     * @returns true if the system is currently stopping
     */ isStopping() {
        return this._stopped && this.isAlive();
    }
    /**
     * Gets the custom effect used to render the particles
     * @param blendMode Blend mode for which the effect should be retrieved
     * @returns The effect
     */ getCustomEffect(blendMode = 0) {
        return this._customWrappers[blendMode]?.effect ?? this._customWrappers[0].effect;
    }
    _getCustomDrawWrapper(blendMode = 0) {
        return this._customWrappers[blendMode] ?? this._customWrappers[0];
    }
    /**
     * Sets the custom effect used to render the particles
     * @param effect The effect to set
     * @param blendMode Blend mode for which the effect should be set
     */ setCustomEffect(effect, blendMode = 0) {
        this._customWrappers[blendMode] = new (0, $hOyoX.DrawWrapper)(this._engine);
        this._customWrappers[blendMode].effect = effect;
        if (this._customWrappers[blendMode].drawContext) this._customWrappers[blendMode].drawContext.useInstancing = this._useInstancing;
    }
    /**
     * Observable that will be called just before the particles are drawn
     */ get onBeforeDrawParticlesObservable() {
        if (!this._onBeforeDrawParticlesObservable) this._onBeforeDrawParticlesObservable = new (0, $diGQf.Observable)();
        return this._onBeforeDrawParticlesObservable;
    }
    /**
     * Gets the name of the particle vertex shader
     */ get vertexShaderName() {
        return "particles";
    }
    /**
     * Gets the vertex buffers used by the particle system
     */ get vertexBuffers() {
        return this._vertexBuffers;
    }
    /**
     * Gets the index buffer used by the particle system (or null if no index buffer is used (if _useInstancing=true))
     */ get indexBuffer() {
        return this._indexBuffer;
    }
    /**
     * Instantiates a particle system.
     * Particles are often small sprites used to simulate hard-to-reproduce phenomena like fire, smoke, water, or abstract visual effects like magic glitter and faery dust.
     * @param name The name of the particle system
     * @param capacity The max number of particles alive at the same time
     * @param sceneOrEngine The scene the particle system belongs to or the engine to use if no scene
     * @param customEffect a custom effect used to change the way particles are rendered by default
     * @param isAnimationSheetEnabled Must be true if using a spritesheet to animate the particles texture
     * @param epsilon Offset used to render the particles
     */ constructor(name, capacity, sceneOrEngine, customEffect = null, isAnimationSheetEnabled = false, epsilon = 0.01){
        super(name);
        this._emitterInverseWorldMatrix = (0, $ha1VO.Matrix).Identity();
        /**
         * @internal
         */ this._inheritedVelocityOffset = new (0, $ha1VO.Vector3)();
        /**
         * An event triggered when the system is disposed
         */ this.onDisposeObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the system is stopped
         */ this.onStoppedObservable = new (0, $diGQf.Observable)();
        this._particles = new Array();
        this._stockParticles = new Array();
        this._newPartsExcess = 0;
        this._vertexBuffers = {};
        this._scaledColorStep = new (0, $7etnY.Color4)(0, 0, 0, 0);
        this._colorDiff = new (0, $7etnY.Color4)(0, 0, 0, 0);
        this._scaledDirection = (0, $ha1VO.Vector3).Zero();
        this._scaledGravity = (0, $ha1VO.Vector3).Zero();
        this._currentRenderId = -1;
        this._useInstancing = false;
        this._started = false;
        this._stopped = false;
        this._actualFrame = 0;
        /** @internal */ this._currentEmitRate1 = 0;
        /** @internal */ this._currentEmitRate2 = 0;
        /** @internal */ this._currentStartSize1 = 0;
        /** @internal */ this._currentStartSize2 = 0;
        /** Indicates that the update of particles is done in the animate function */ this.updateInAnimate = true;
        this._rawTextureWidth = 256;
        this._useRampGradients = false;
        /**
         * Specifies if the particles are updated in emitter local space or world space
         */ this.isLocal = false;
        /** Indicates that the particle system is CPU based */ this.isGPU = false;
        /** @internal */ this._onBeforeDrawParticlesObservable = null;
        /** @internal */ this._emitFromParticle = (particle)=>{
        // Do nothing
        };
        // start of sub system methods
        /**
         * "Recycles" one of the particle by copying it back to the "stock" of particles and removing it from the active list.
         * Its lifetime will start back at 0.
         * @param particle
         */ this.recycleParticle = (particle)=>{
            // move particle from activeParticle list to stock particles
            const lastParticle = this._particles.pop();
            if (lastParticle !== particle) lastParticle.copyTo(particle);
            this._stockParticles.push(lastParticle);
        };
        this._createParticle = ()=>{
            let particle;
            if (this._stockParticles.length !== 0) {
                particle = this._stockParticles.pop();
                particle._reset();
            } else particle = new (0, $e6EVj.Particle)(this);
            this._prepareParticle(particle);
            return particle;
        };
        this._capacity = capacity;
        this._epsilon = epsilon;
        this._isAnimationSheetEnabled = isAnimationSheetEnabled;
        if (!sceneOrEngine || sceneOrEngine.getClassName() === "Scene") {
            this._scene = sceneOrEngine || (0, $ejQPp.EngineStore).LastCreatedScene;
            this._engine = this._scene.getEngine();
            this.uniqueId = this._scene.getUniqueId();
            this._scene.particleSystems.push(this);
        } else {
            this._engine = sceneOrEngine;
            this.defaultProjectionMatrix = (0, $ha1VO.Matrix).PerspectiveFovLH(0.8, 1, 0.1, 100, this._engine.isNDCHalfZRange);
        }
        if (this._engine.getCaps().vertexArrayObject) this._vertexArrayObject = null;
        // Setup the default processing configuration to the scene.
        this._attachImageProcessingConfiguration(null);
        // eslint-disable-next-line @typescript-eslint/naming-convention
        this._customWrappers = {
            0: new (0, $hOyoX.DrawWrapper)(this._engine)
        };
        this._customWrappers[0].effect = customEffect;
        this._drawWrappers = [];
        this._useInstancing = this._engine.getCaps().instancedArrays;
        this._createIndexBuffer();
        this._createVertexBuffers();
        // Default emitter type
        this.particleEmitterType = new (0, $6V6Qz.BoxParticleEmitter)();
        let noiseTextureData = null;
        // Update
        this.updateFunction = (particles)=>{
            let noiseTextureSize = null;
            if (this.noiseTexture) {
                // We need to get texture data back to CPU
                noiseTextureSize = this.noiseTexture.getSize();
                this.noiseTexture.getContent()?.then((data)=>{
                    noiseTextureData = data;
                });
            }
            const sameParticleArray = particles === this._particles;
            for(let index = 0; index < particles.length; index++){
                const particle = particles[index];
                let scaledUpdateSpeed = this._scaledUpdateSpeed;
                const previousAge = particle.age;
                particle.age += scaledUpdateSpeed;
                // Evaluate step to death
                if (particle.age > particle.lifeTime) {
                    const diff = particle.age - previousAge;
                    const oldDiff = particle.lifeTime - previousAge;
                    scaledUpdateSpeed = oldDiff * scaledUpdateSpeed / diff;
                    particle.age = particle.lifeTime;
                }
                const ratio = particle.age / particle.lifeTime;
                // Color
                if (this._colorGradients && this._colorGradients.length > 0) (0, $iDYnp.GradientHelper).GetCurrentGradient(ratio, this._colorGradients, (currentGradient, nextGradient, scale)=>{
                    if (currentGradient !== particle._currentColorGradient) {
                        particle._currentColor1.copyFrom(particle._currentColor2);
                        nextGradient.getColorToRef(particle._currentColor2);
                        particle._currentColorGradient = currentGradient;
                    }
                    (0, $7etnY.Color4).LerpToRef(particle._currentColor1, particle._currentColor2, scale, particle.color);
                });
                else {
                    particle.colorStep.scaleToRef(scaledUpdateSpeed, this._scaledColorStep);
                    particle.color.addInPlace(this._scaledColorStep);
                    if (particle.color.a < 0) particle.color.a = 0;
                }
                // Angular speed
                if (this._angularSpeedGradients && this._angularSpeedGradients.length > 0) (0, $iDYnp.GradientHelper).GetCurrentGradient(ratio, this._angularSpeedGradients, (currentGradient, nextGradient, scale)=>{
                    if (currentGradient !== particle._currentAngularSpeedGradient) {
                        particle._currentAngularSpeed1 = particle._currentAngularSpeed2;
                        particle._currentAngularSpeed2 = nextGradient.getFactor();
                        particle._currentAngularSpeedGradient = currentGradient;
                    }
                    particle.angularSpeed = (0, $iosaP.Lerp)(particle._currentAngularSpeed1, particle._currentAngularSpeed2, scale);
                });
                particle.angle += particle.angularSpeed * scaledUpdateSpeed;
                // Direction
                let directionScale = scaledUpdateSpeed;
                /// Velocity
                if (this._velocityGradients && this._velocityGradients.length > 0) (0, $iDYnp.GradientHelper).GetCurrentGradient(ratio, this._velocityGradients, (currentGradient, nextGradient, scale)=>{
                    if (currentGradient !== particle._currentVelocityGradient) {
                        particle._currentVelocity1 = particle._currentVelocity2;
                        particle._currentVelocity2 = nextGradient.getFactor();
                        particle._currentVelocityGradient = currentGradient;
                    }
                    directionScale *= (0, $iosaP.Lerp)(particle._currentVelocity1, particle._currentVelocity2, scale);
                });
                particle.direction.scaleToRef(directionScale, this._scaledDirection);
                /// Limit velocity
                if (this._limitVelocityGradients && this._limitVelocityGradients.length > 0) (0, $iDYnp.GradientHelper).GetCurrentGradient(ratio, this._limitVelocityGradients, (currentGradient, nextGradient, scale)=>{
                    if (currentGradient !== particle._currentLimitVelocityGradient) {
                        particle._currentLimitVelocity1 = particle._currentLimitVelocity2;
                        particle._currentLimitVelocity2 = nextGradient.getFactor();
                        particle._currentLimitVelocityGradient = currentGradient;
                    }
                    const limitVelocity = (0, $iosaP.Lerp)(particle._currentLimitVelocity1, particle._currentLimitVelocity2, scale);
                    const currentVelocity = particle.direction.length();
                    if (currentVelocity > limitVelocity) particle.direction.scaleInPlace(this.limitVelocityDamping);
                });
                /// Drag
                if (this._dragGradients && this._dragGradients.length > 0) (0, $iDYnp.GradientHelper).GetCurrentGradient(ratio, this._dragGradients, (currentGradient, nextGradient, scale)=>{
                    if (currentGradient !== particle._currentDragGradient) {
                        particle._currentDrag1 = particle._currentDrag2;
                        particle._currentDrag2 = nextGradient.getFactor();
                        particle._currentDragGradient = currentGradient;
                    }
                    const drag = (0, $iosaP.Lerp)(particle._currentDrag1, particle._currentDrag2, scale);
                    this._scaledDirection.scaleInPlace(1.0 - drag);
                });
                if (this.isLocal && particle._localPosition) {
                    particle._localPosition.addInPlace(this._scaledDirection);
                    (0, $ha1VO.Vector3).TransformCoordinatesToRef(particle._localPosition, this._emitterWorldMatrix, particle.position);
                } else particle.position.addInPlace(this._scaledDirection);
                // Noise
                if (noiseTextureData && noiseTextureSize && particle._randomNoiseCoordinates1) {
                    const fetchedColorR = this._fetchR(particle._randomNoiseCoordinates1.x, particle._randomNoiseCoordinates1.y, noiseTextureSize.width, noiseTextureSize.height, noiseTextureData);
                    const fetchedColorG = this._fetchR(particle._randomNoiseCoordinates1.z, particle._randomNoiseCoordinates2.x, noiseTextureSize.width, noiseTextureSize.height, noiseTextureData);
                    const fetchedColorB = this._fetchR(particle._randomNoiseCoordinates2.y, particle._randomNoiseCoordinates2.z, noiseTextureSize.width, noiseTextureSize.height, noiseTextureData);
                    const force = (0, $ha1VO.TmpVectors).Vector3[0];
                    const scaledForce = (0, $ha1VO.TmpVectors).Vector3[1];
                    force.copyFromFloats((2 * fetchedColorR - 1) * this.noiseStrength.x, (2 * fetchedColorG - 1) * this.noiseStrength.y, (2 * fetchedColorB - 1) * this.noiseStrength.z);
                    force.scaleToRef(scaledUpdateSpeed, scaledForce);
                    particle.direction.addInPlace(scaledForce);
                }
                // Gravity
                this.gravity.scaleToRef(scaledUpdateSpeed, this._scaledGravity);
                particle.direction.addInPlace(this._scaledGravity);
                // Size
                if (this._sizeGradients && this._sizeGradients.length > 0) (0, $iDYnp.GradientHelper).GetCurrentGradient(ratio, this._sizeGradients, (currentGradient, nextGradient, scale)=>{
                    if (currentGradient !== particle._currentSizeGradient) {
                        particle._currentSize1 = particle._currentSize2;
                        particle._currentSize2 = nextGradient.getFactor();
                        particle._currentSizeGradient = currentGradient;
                    }
                    particle.size = (0, $iosaP.Lerp)(particle._currentSize1, particle._currentSize2, scale);
                });
                // Remap data
                if (this._useRampGradients) {
                    if (this._colorRemapGradients && this._colorRemapGradients.length > 0) (0, $iDYnp.GradientHelper).GetCurrentGradient(ratio, this._colorRemapGradients, (currentGradient, nextGradient, scale)=>{
                        const min = (0, $iosaP.Lerp)(currentGradient.factor1, nextGradient.factor1, scale);
                        const max = (0, $iosaP.Lerp)(currentGradient.factor2, nextGradient.factor2, scale);
                        particle.remapData.x = min;
                        particle.remapData.y = max - min;
                    });
                    if (this._alphaRemapGradients && this._alphaRemapGradients.length > 0) (0, $iDYnp.GradientHelper).GetCurrentGradient(ratio, this._alphaRemapGradients, (currentGradient, nextGradient, scale)=>{
                        const min = (0, $iosaP.Lerp)(currentGradient.factor1, nextGradient.factor1, scale);
                        const max = (0, $iosaP.Lerp)(currentGradient.factor2, nextGradient.factor2, scale);
                        particle.remapData.z = min;
                        particle.remapData.w = max - min;
                    });
                }
                if (this._isAnimationSheetEnabled) particle.updateCellIndex();
                // Update the position of the attached sub-emitters to match their attached particle
                particle._inheritParticleInfoToSubEmitters();
                if (particle.age >= particle.lifeTime) {
                    // Recycle by swapping with last particle
                    this._emitFromParticle(particle);
                    if (particle._attachedSubEmitters) {
                        particle._attachedSubEmitters.forEach((subEmitter)=>{
                            subEmitter.particleSystem.disposeOnStop = true;
                            subEmitter.particleSystem.stop();
                        });
                        particle._attachedSubEmitters = null;
                    }
                    this.recycleParticle(particle);
                    if (sameParticleArray) index--;
                    continue;
                }
            }
        };
    }
    serialize(serializeTexture) {
        throw new Error("Method not implemented.");
    }
    /**
     * Clones the particle system.
     * @param name The name of the cloned object
     * @param newEmitter The new emitter to use
     * @param cloneTexture Also clone the textures if true
     */ clone(name, newEmitter, cloneTexture = false) {
        throw new Error("Method not implemented.");
    }
    _addFactorGradient(factorGradients, gradient, factor, factor2) {
        const newGradient = new (0, $iDYnp.FactorGradient)(gradient, factor, factor2);
        factorGradients.push(newGradient);
        factorGradients.sort((a, b)=>{
            if (a.gradient < b.gradient) return -1;
            else if (a.gradient > b.gradient) return 1;
            return 0;
        });
    }
    _removeFactorGradient(factorGradients, gradient) {
        if (!factorGradients) return;
        let index = 0;
        for (const factorGradient of factorGradients){
            if (factorGradient.gradient === gradient) {
                factorGradients.splice(index, 1);
                break;
            }
            index++;
        }
    }
    /**
     * Adds a new life time gradient
     * @param gradient defines the gradient to use (between 0 and 1)
     * @param factor defines the life time factor to affect to the specified gradient
     * @param factor2 defines an additional factor used to define a range ([factor, factor2]) with main value to pick the final value from
     * @returns the current particle system
     */ addLifeTimeGradient(gradient, factor, factor2) {
        if (!this._lifeTimeGradients) this._lifeTimeGradients = [];
        this._addFactorGradient(this._lifeTimeGradients, gradient, factor, factor2);
        return this;
    }
    /**
     * Remove a specific life time gradient
     * @param gradient defines the gradient to remove
     * @returns the current particle system
     */ removeLifeTimeGradient(gradient) {
        this._removeFactorGradient(this._lifeTimeGradients, gradient);
        return this;
    }
    /**
     * Adds a new size gradient
     * @param gradient defines the gradient to use (between 0 and 1)
     * @param factor defines the size factor to affect to the specified gradient
     * @param factor2 defines an additional factor used to define a range ([factor, factor2]) with main value to pick the final value from
     * @returns the current particle system
     */ addSizeGradient(gradient, factor, factor2) {
        if (!this._sizeGradients) this._sizeGradients = [];
        this._addFactorGradient(this._sizeGradients, gradient, factor, factor2);
        return this;
    }
    /**
     * Remove a specific size gradient
     * @param gradient defines the gradient to remove
     * @returns the current particle system
     */ removeSizeGradient(gradient) {
        this._removeFactorGradient(this._sizeGradients, gradient);
        return this;
    }
    /**
     * Adds a new color remap gradient
     * @param gradient defines the gradient to use (between 0 and 1)
     * @param min defines the color remap minimal range
     * @param max defines the color remap maximal range
     * @returns the current particle system
     */ addColorRemapGradient(gradient, min, max) {
        if (!this._colorRemapGradients) this._colorRemapGradients = [];
        this._addFactorGradient(this._colorRemapGradients, gradient, min, max);
        return this;
    }
    /**
     * Remove a specific color remap gradient
     * @param gradient defines the gradient to remove
     * @returns the current particle system
     */ removeColorRemapGradient(gradient) {
        this._removeFactorGradient(this._colorRemapGradients, gradient);
        return this;
    }
    /**
     * Adds a new alpha remap gradient
     * @param gradient defines the gradient to use (between 0 and 1)
     * @param min defines the alpha remap minimal range
     * @param max defines the alpha remap maximal range
     * @returns the current particle system
     */ addAlphaRemapGradient(gradient, min, max) {
        if (!this._alphaRemapGradients) this._alphaRemapGradients = [];
        this._addFactorGradient(this._alphaRemapGradients, gradient, min, max);
        return this;
    }
    /**
     * Remove a specific alpha remap gradient
     * @param gradient defines the gradient to remove
     * @returns the current particle system
     */ removeAlphaRemapGradient(gradient) {
        this._removeFactorGradient(this._alphaRemapGradients, gradient);
        return this;
    }
    /**
     * Adds a new angular speed gradient
     * @param gradient defines the gradient to use (between 0 and 1)
     * @param factor defines the angular speed  to affect to the specified gradient
     * @param factor2 defines an additional factor used to define a range ([factor, factor2]) with main value to pick the final value from
     * @returns the current particle system
     */ addAngularSpeedGradient(gradient, factor, factor2) {
        if (!this._angularSpeedGradients) this._angularSpeedGradients = [];
        this._addFactorGradient(this._angularSpeedGradients, gradient, factor, factor2);
        return this;
    }
    /**
     * Remove a specific angular speed gradient
     * @param gradient defines the gradient to remove
     * @returns the current particle system
     */ removeAngularSpeedGradient(gradient) {
        this._removeFactorGradient(this._angularSpeedGradients, gradient);
        return this;
    }
    /**
     * Adds a new velocity gradient
     * @param gradient defines the gradient to use (between 0 and 1)
     * @param factor defines the velocity to affect to the specified gradient
     * @param factor2 defines an additional factor used to define a range ([factor, factor2]) with main value to pick the final value from
     * @returns the current particle system
     */ addVelocityGradient(gradient, factor, factor2) {
        if (!this._velocityGradients) this._velocityGradients = [];
        this._addFactorGradient(this._velocityGradients, gradient, factor, factor2);
        return this;
    }
    /**
     * Remove a specific velocity gradient
     * @param gradient defines the gradient to remove
     * @returns the current particle system
     */ removeVelocityGradient(gradient) {
        this._removeFactorGradient(this._velocityGradients, gradient);
        return this;
    }
    /**
     * Adds a new limit velocity gradient
     * @param gradient defines the gradient to use (between 0 and 1)
     * @param factor defines the limit velocity value to affect to the specified gradient
     * @param factor2 defines an additional factor used to define a range ([factor, factor2]) with main value to pick the final value from
     * @returns the current particle system
     */ addLimitVelocityGradient(gradient, factor, factor2) {
        if (!this._limitVelocityGradients) this._limitVelocityGradients = [];
        this._addFactorGradient(this._limitVelocityGradients, gradient, factor, factor2);
        return this;
    }
    /**
     * Remove a specific limit velocity gradient
     * @param gradient defines the gradient to remove
     * @returns the current particle system
     */ removeLimitVelocityGradient(gradient) {
        this._removeFactorGradient(this._limitVelocityGradients, gradient);
        return this;
    }
    /**
     * Adds a new drag gradient
     * @param gradient defines the gradient to use (between 0 and 1)
     * @param factor defines the drag value to affect to the specified gradient
     * @param factor2 defines an additional factor used to define a range ([factor, factor2]) with main value to pick the final value from
     * @returns the current particle system
     */ addDragGradient(gradient, factor, factor2) {
        if (!this._dragGradients) this._dragGradients = [];
        this._addFactorGradient(this._dragGradients, gradient, factor, factor2);
        return this;
    }
    /**
     * Remove a specific drag gradient
     * @param gradient defines the gradient to remove
     * @returns the current particle system
     */ removeDragGradient(gradient) {
        this._removeFactorGradient(this._dragGradients, gradient);
        return this;
    }
    /**
     * Adds a new emit rate gradient (please note that this will only work if you set the targetStopDuration property)
     * @param gradient defines the gradient to use (between 0 and 1)
     * @param factor defines the emit rate value to affect to the specified gradient
     * @param factor2 defines an additional factor used to define a range ([factor, factor2]) with main value to pick the final value from
     * @returns the current particle system
     */ addEmitRateGradient(gradient, factor, factor2) {
        if (!this._emitRateGradients) this._emitRateGradients = [];
        this._addFactorGradient(this._emitRateGradients, gradient, factor, factor2);
        return this;
    }
    /**
     * Remove a specific emit rate gradient
     * @param gradient defines the gradient to remove
     * @returns the current particle system
     */ removeEmitRateGradient(gradient) {
        this._removeFactorGradient(this._emitRateGradients, gradient);
        return this;
    }
    /**
     * Adds a new start size gradient (please note that this will only work if you set the targetStopDuration property)
     * @param gradient defines the gradient to use (between 0 and 1)
     * @param factor defines the start size value to affect to the specified gradient
     * @param factor2 defines an additional factor used to define a range ([factor, factor2]) with main value to pick the final value from
     * @returns the current particle system
     */ addStartSizeGradient(gradient, factor, factor2) {
        if (!this._startSizeGradients) this._startSizeGradients = [];
        this._addFactorGradient(this._startSizeGradients, gradient, factor, factor2);
        return this;
    }
    /**
     * Remove a specific start size gradient
     * @param gradient defines the gradient to remove
     * @returns the current particle system
     */ removeStartSizeGradient(gradient) {
        this._removeFactorGradient(this._startSizeGradients, gradient);
        return this;
    }
    _createRampGradientTexture() {
        if (!this._rampGradients || !this._rampGradients.length || this._rampGradientsTexture || !this._scene) return;
        const data = new Uint8Array(this._rawTextureWidth * 4);
        const tmpColor = (0, $7etnY.TmpColors).Color3[0];
        for(let x = 0; x < this._rawTextureWidth; x++){
            const ratio = x / this._rawTextureWidth;
            (0, $iDYnp.GradientHelper).GetCurrentGradient(ratio, this._rampGradients, (currentGradient, nextGradient, scale)=>{
                (0, $7etnY.Color3).LerpToRef(currentGradient.color, nextGradient.color, scale, tmpColor);
                data[x * 4] = tmpColor.r * 255;
                data[x * 4 + 1] = tmpColor.g * 255;
                data[x * 4 + 2] = tmpColor.b * 255;
                data[x * 4 + 3] = 255;
            });
        }
        this._rampGradientsTexture = (0, $5Egpj.RawTexture).CreateRGBATexture(data, this._rawTextureWidth, 1, this._scene, false, false, 1);
    }
    /**
     * Gets the current list of ramp gradients.
     * You must use addRampGradient and removeRampGradient to update this list
     * @returns the list of ramp gradients
     */ getRampGradients() {
        return this._rampGradients;
    }
    /** Force the system to rebuild all gradients that need to be resync */ forceRefreshGradients() {
        this._syncRampGradientTexture();
    }
    _syncRampGradientTexture() {
        if (!this._rampGradients) return;
        this._rampGradients.sort((a, b)=>{
            if (a.gradient < b.gradient) return -1;
            else if (a.gradient > b.gradient) return 1;
            return 0;
        });
        if (this._rampGradientsTexture) {
            this._rampGradientsTexture.dispose();
            this._rampGradientsTexture = null;
        }
        this._createRampGradientTexture();
    }
    /**
     * Adds a new ramp gradient used to remap particle colors
     * @param gradient defines the gradient to use (between 0 and 1)
     * @param color defines the color to affect to the specified gradient
     * @returns the current particle system
     */ addRampGradient(gradient, color) {
        if (!this._rampGradients) this._rampGradients = [];
        const rampGradient = new (0, $iDYnp.Color3Gradient)(gradient, color);
        this._rampGradients.push(rampGradient);
        this._syncRampGradientTexture();
        return this;
    }
    /**
     * Remove a specific ramp gradient
     * @param gradient defines the gradient to remove
     * @returns the current particle system
     */ removeRampGradient(gradient) {
        this._removeGradientAndTexture(gradient, this._rampGradients, this._rampGradientsTexture);
        this._rampGradientsTexture = null;
        if (this._rampGradients && this._rampGradients.length > 0) this._createRampGradientTexture();
        return this;
    }
    /**
     * Adds a new color gradient
     * @param gradient defines the gradient to use (between 0 and 1)
     * @param color1 defines the color to affect to the specified gradient
     * @param color2 defines an additional color used to define a range ([color, color2]) with main color to pick the final color from
     * @returns this particle system
     */ addColorGradient(gradient, color1, color2) {
        if (!this._colorGradients) this._colorGradients = [];
        const colorGradient = new (0, $iDYnp.ColorGradient)(gradient, color1, color2);
        this._colorGradients.push(colorGradient);
        this._colorGradients.sort((a, b)=>{
            if (a.gradient < b.gradient) return -1;
            else if (a.gradient > b.gradient) return 1;
            return 0;
        });
        return this;
    }
    /**
     * Remove a specific color gradient
     * @param gradient defines the gradient to remove
     * @returns this particle system
     */ removeColorGradient(gradient) {
        if (!this._colorGradients) return this;
        let index = 0;
        for (const colorGradient of this._colorGradients){
            if (colorGradient.gradient === gradient) {
                this._colorGradients.splice(index, 1);
                break;
            }
            index++;
        }
        return this;
    }
    /**
     * Resets the draw wrappers cache
     */ resetDrawCache() {
        for (const drawWrappers of this._drawWrappers){
            if (drawWrappers) for (const drawWrapper of drawWrappers)drawWrapper?.dispose();
        }
        this._drawWrappers = [];
    }
    _fetchR(u, v, width, height, pixels) {
        u = Math.abs(u) * 0.5 + 0.5;
        v = Math.abs(v) * 0.5 + 0.5;
        const wrappedU = u * width % width | 0;
        const wrappedV = v * height % height | 0;
        const position = (wrappedU + wrappedV * width) * 4;
        return pixels[position] / 255;
    }
    _reset() {
        this._resetEffect();
    }
    _resetEffect() {
        if (this._vertexBuffer) {
            this._vertexBuffer.dispose();
            this._vertexBuffer = null;
        }
        if (this._spriteBuffer) {
            this._spriteBuffer.dispose();
            this._spriteBuffer = null;
        }
        if (this._vertexArrayObject) {
            this._engine.releaseVertexArrayObject(this._vertexArrayObject);
            this._vertexArrayObject = null;
        }
        this._createVertexBuffers();
    }
    _createVertexBuffers() {
        this._vertexBufferSize = this._useInstancing ? 10 : 12;
        if (this._isAnimationSheetEnabled) this._vertexBufferSize += 1;
        if (!this._isBillboardBased || this.billboardMode === 8 || this.billboardMode === 9) this._vertexBufferSize += 3;
        if (this._useRampGradients) this._vertexBufferSize += 4;
        const engine = this._engine;
        const vertexSize = this._vertexBufferSize * (this._useInstancing ? 1 : 4);
        this._vertexData = new Float32Array(this._capacity * vertexSize);
        this._vertexBuffer = new (0, $b4i1f.Buffer)(engine, this._vertexData, true, vertexSize);
        let dataOffset = 0;
        const positions = this._vertexBuffer.createVertexBuffer((0, $b4i1f.VertexBuffer).PositionKind, dataOffset, 3, this._vertexBufferSize, this._useInstancing);
        this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind] = positions;
        dataOffset += 3;
        const colors = this._vertexBuffer.createVertexBuffer((0, $b4i1f.VertexBuffer).ColorKind, dataOffset, 4, this._vertexBufferSize, this._useInstancing);
        this._vertexBuffers[(0, $b4i1f.VertexBuffer).ColorKind] = colors;
        dataOffset += 4;
        const options = this._vertexBuffer.createVertexBuffer("angle", dataOffset, 1, this._vertexBufferSize, this._useInstancing);
        this._vertexBuffers["angle"] = options;
        dataOffset += 1;
        const size = this._vertexBuffer.createVertexBuffer("size", dataOffset, 2, this._vertexBufferSize, this._useInstancing);
        this._vertexBuffers["size"] = size;
        dataOffset += 2;
        if (this._isAnimationSheetEnabled) {
            const cellIndexBuffer = this._vertexBuffer.createVertexBuffer("cellIndex", dataOffset, 1, this._vertexBufferSize, this._useInstancing);
            this._vertexBuffers["cellIndex"] = cellIndexBuffer;
            dataOffset += 1;
        }
        if (!this._isBillboardBased || this.billboardMode === 8 || this.billboardMode === 9) {
            const directionBuffer = this._vertexBuffer.createVertexBuffer("direction", dataOffset, 3, this._vertexBufferSize, this._useInstancing);
            this._vertexBuffers["direction"] = directionBuffer;
            dataOffset += 3;
        }
        if (this._useRampGradients) {
            const rampDataBuffer = this._vertexBuffer.createVertexBuffer("remapData", dataOffset, 4, this._vertexBufferSize, this._useInstancing);
            this._vertexBuffers["remapData"] = rampDataBuffer;
            dataOffset += 4;
        }
        let offsets;
        if (this._useInstancing) {
            const spriteData = new Float32Array([
                0,
                0,
                1,
                0,
                0,
                1,
                1,
                1
            ]);
            this._spriteBuffer = new (0, $b4i1f.Buffer)(engine, spriteData, false, 2);
            offsets = this._spriteBuffer.createVertexBuffer("offset", 0, 2);
        } else {
            offsets = this._vertexBuffer.createVertexBuffer("offset", dataOffset, 2, this._vertexBufferSize, this._useInstancing);
            dataOffset += 2;
        }
        this._vertexBuffers["offset"] = offsets;
        this.resetDrawCache();
    }
    _createIndexBuffer() {
        if (this._useInstancing) {
            this._linesIndexBufferUseInstancing = this._engine.createIndexBuffer(new Uint32Array([
                0,
                1,
                1,
                3,
                3,
                2,
                2,
                0,
                0,
                3
            ]));
            return;
        }
        const indices = [];
        const indicesWireframe = [];
        let index = 0;
        for(let count = 0; count < this._capacity; count++){
            indices.push(index);
            indices.push(index + 1);
            indices.push(index + 2);
            indices.push(index);
            indices.push(index + 2);
            indices.push(index + 3);
            indicesWireframe.push(index, index + 1, index + 1, index + 2, index + 2, index + 3, index + 3, index, index, index + 3);
            index += 4;
        }
        this._indexBuffer = this._engine.createIndexBuffer(indices);
        this._linesIndexBuffer = this._engine.createIndexBuffer(indicesWireframe);
    }
    /**
     * Gets the maximum number of particles active at the same time.
     * @returns The max number of active particles.
     */ getCapacity() {
        return this._capacity;
    }
    /**
     * Gets whether there are still active particles in the system.
     * @returns True if it is alive, otherwise false.
     */ isAlive() {
        return this._alive;
    }
    /**
     * Gets if the system has been started. (Note: this will still be true after stop is called)
     * @returns True if it has been started, otherwise false.
     */ isStarted() {
        return this._started;
    }
    /** @internal */ _preStart() {
    // Do nothing
    }
    /**
     * Starts the particle system and begins to emit
     * @param delay defines the delay in milliseconds before starting the system (this.startDelay by default)
     */ start(delay = this.startDelay) {
        if (!this.targetStopDuration && this._hasTargetStopDurationDependantGradient()) // eslint-disable-next-line no-throw-literal
        throw "Particle system started with a targetStopDuration dependant gradient (eg. startSizeGradients) but no targetStopDuration set";
        if (delay) {
            setTimeout(()=>{
                this.start(0);
            }, delay);
            return;
        }
        this._started = true;
        this._stopped = false;
        this._actualFrame = 0;
        this._preStart();
        // Reset emit gradient so it acts the same on every start
        if (this._emitRateGradients) {
            if (this._emitRateGradients.length > 0) {
                this._currentEmitRateGradient = this._emitRateGradients[0];
                this._currentEmitRate1 = this._currentEmitRateGradient.getFactor();
                this._currentEmitRate2 = this._currentEmitRate1;
            }
            if (this._emitRateGradients.length > 1) this._currentEmitRate2 = this._emitRateGradients[1].getFactor();
        }
        // Reset start size gradient so it acts the same on every start
        if (this._startSizeGradients) {
            if (this._startSizeGradients.length > 0) {
                this._currentStartSizeGradient = this._startSizeGradients[0];
                this._currentStartSize1 = this._currentStartSizeGradient.getFactor();
                this._currentStartSize2 = this._currentStartSize1;
            }
            if (this._startSizeGradients.length > 1) this._currentStartSize2 = this._startSizeGradients[1].getFactor();
        }
        if (this.preWarmCycles) {
            if (this.emitter?.getClassName().indexOf("Mesh") !== -1) this.emitter.computeWorldMatrix(true);
            const noiseTextureAsProcedural = this.noiseTexture;
            if (noiseTextureAsProcedural && noiseTextureAsProcedural.onGeneratedObservable) noiseTextureAsProcedural.onGeneratedObservable.addOnce(()=>{
                setTimeout(()=>{
                    for(let index = 0; index < this.preWarmCycles; index++){
                        this.animate(true);
                        noiseTextureAsProcedural.render();
                    }
                });
            });
            else for(let index = 0; index < this.preWarmCycles; index++)this.animate(true);
        }
        // Animations
        if (this.beginAnimationOnStart && this.animations && this.animations.length > 0 && this._scene) this._scene.beginAnimation(this, this.beginAnimationFrom, this.beginAnimationTo, this.beginAnimationLoop);
    }
    /**
     * Stops the particle system.
     * @param stopSubEmitters if true it will stop the current system and all created sub-Systems if false it will stop the current root system only, this param is used by the root particle system only. The default value is true.
     */ stop(stopSubEmitters = true) {
        if (this._stopped) return;
        this.onStoppedObservable.notifyObservers(this);
        this._stopped = true;
        this._postStop(stopSubEmitters);
    }
    /** @internal */ _postStop(stopSubEmitters) {
    // Do nothing
    }
    // Animation sheet
    /**
     * Remove all active particles
     */ reset() {
        this._stockParticles.length = 0;
        this._particles.length = 0;
    }
    /**
     * @internal (for internal use only)
     */ _appendParticleVertex(index, particle, offsetX, offsetY) {
        let offset = index * this._vertexBufferSize;
        this._vertexData[offset++] = particle.position.x + this.worldOffset.x;
        this._vertexData[offset++] = particle.position.y + this.worldOffset.y;
        this._vertexData[offset++] = particle.position.z + this.worldOffset.z;
        this._vertexData[offset++] = particle.color.r;
        this._vertexData[offset++] = particle.color.g;
        this._vertexData[offset++] = particle.color.b;
        this._vertexData[offset++] = particle.color.a;
        this._vertexData[offset++] = particle.angle;
        this._vertexData[offset++] = particle.scale.x * particle.size;
        this._vertexData[offset++] = particle.scale.y * particle.size;
        if (this._isAnimationSheetEnabled) this._vertexData[offset++] = particle.cellIndex;
        if (!this._isBillboardBased) {
            if (particle._initialDirection) {
                let initialDirection = particle._initialDirection;
                if (this.isLocal) {
                    (0, $ha1VO.Vector3).TransformNormalToRef(initialDirection, this._emitterWorldMatrix, (0, $ha1VO.TmpVectors).Vector3[0]);
                    initialDirection = (0, $ha1VO.TmpVectors).Vector3[0];
                }
                if (initialDirection.x === 0 && initialDirection.z === 0) initialDirection.x = 0.001;
                this._vertexData[offset++] = initialDirection.x;
                this._vertexData[offset++] = initialDirection.y;
                this._vertexData[offset++] = initialDirection.z;
            } else {
                let direction = particle.direction;
                if (this.isLocal) {
                    (0, $ha1VO.Vector3).TransformNormalToRef(direction, this._emitterWorldMatrix, (0, $ha1VO.TmpVectors).Vector3[0]);
                    direction = (0, $ha1VO.TmpVectors).Vector3[0];
                }
                if (direction.x === 0 && direction.z === 0) direction.x = 0.001;
                this._vertexData[offset++] = direction.x;
                this._vertexData[offset++] = direction.y;
                this._vertexData[offset++] = direction.z;
            }
        } else if (this.billboardMode === 8 || this.billboardMode === 9) {
            this._vertexData[offset++] = particle.direction.x;
            this._vertexData[offset++] = particle.direction.y;
            this._vertexData[offset++] = particle.direction.z;
        }
        if (this._useRampGradients && particle.remapData) {
            this._vertexData[offset++] = particle.remapData.x;
            this._vertexData[offset++] = particle.remapData.y;
            this._vertexData[offset++] = particle.remapData.z;
            this._vertexData[offset++] = particle.remapData.w;
        }
        if (!this._useInstancing) {
            if (this._isAnimationSheetEnabled) {
                if (offsetX === 0) offsetX = this._epsilon;
                else if (offsetX === 1) offsetX = 1 - this._epsilon;
                if (offsetY === 0) offsetY = this._epsilon;
                else if (offsetY === 1) offsetY = 1 - this._epsilon;
            }
            this._vertexData[offset++] = offsetX;
            this._vertexData[offset++] = offsetY;
        }
    }
    /** @internal */ _prepareParticle(particle) {
    //Do nothing
    }
    _update(newParticles) {
        // Update current
        this._alive = this._particles.length > 0;
        if (this.emitter.position) {
            const emitterMesh = this.emitter;
            this._emitterWorldMatrix = emitterMesh.getWorldMatrix();
        } else {
            const emitterPosition = this.emitter;
            this._emitterWorldMatrix = (0, $ha1VO.Matrix).Translation(emitterPosition.x, emitterPosition.y, emitterPosition.z);
        }
        this._emitterWorldMatrix.invertToRef(this._emitterInverseWorldMatrix);
        this.updateFunction(this._particles);
        // Add new ones
        let particle;
        for(let index = 0; index < newParticles; index++){
            if (this._particles.length === this._capacity) break;
            particle = this._createParticle();
            this._particles.push(particle);
            // Life time
            if (this.targetStopDuration && this._lifeTimeGradients && this._lifeTimeGradients.length > 0) {
                const ratio = (0, $iosaP.Clamp)(this._actualFrame / this.targetStopDuration);
                (0, $iDYnp.GradientHelper).GetCurrentGradient(ratio, this._lifeTimeGradients, (currentGradient, nextGradient)=>{
                    const factorGradient1 = currentGradient;
                    const factorGradient2 = nextGradient;
                    const lifeTime1 = factorGradient1.getFactor();
                    const lifeTime2 = factorGradient2.getFactor();
                    const gradient = (ratio - factorGradient1.gradient) / (factorGradient2.gradient - factorGradient1.gradient);
                    particle.lifeTime = (0, $iosaP.Lerp)(lifeTime1, lifeTime2, gradient);
                });
            } else particle.lifeTime = (0, $iosaP.RandomRange)(this.minLifeTime, this.maxLifeTime);
            // Emitter
            const emitPower = (0, $iosaP.RandomRange)(this.minEmitPower, this.maxEmitPower);
            if (this.startPositionFunction) this.startPositionFunction(this._emitterWorldMatrix, particle.position, particle, this.isLocal);
            else this.particleEmitterType.startPositionFunction(this._emitterWorldMatrix, particle.position, particle, this.isLocal);
            if (this.isLocal) {
                if (!particle._localPosition) particle._localPosition = particle.position.clone();
                else particle._localPosition.copyFrom(particle.position);
                (0, $ha1VO.Vector3).TransformCoordinatesToRef(particle._localPosition, this._emitterWorldMatrix, particle.position);
            }
            if (this.startDirectionFunction) this.startDirectionFunction(this._emitterWorldMatrix, particle.direction, particle, this.isLocal);
            else this.particleEmitterType.startDirectionFunction(this._emitterWorldMatrix, particle.direction, particle, this.isLocal, this._emitterInverseWorldMatrix);
            if (emitPower === 0) {
                if (!particle._initialDirection) particle._initialDirection = particle.direction.clone();
                else particle._initialDirection.copyFrom(particle.direction);
            } else particle._initialDirection = null;
            particle.direction.scaleInPlace(emitPower);
            // Size
            if (!this._sizeGradients || this._sizeGradients.length === 0) particle.size = (0, $iosaP.RandomRange)(this.minSize, this.maxSize);
            else {
                particle._currentSizeGradient = this._sizeGradients[0];
                particle._currentSize1 = particle._currentSizeGradient.getFactor();
                particle.size = particle._currentSize1;
                if (this._sizeGradients.length > 1) particle._currentSize2 = this._sizeGradients[1].getFactor();
                else particle._currentSize2 = particle._currentSize1;
            }
            // Size and scale
            particle.scale.copyFromFloats((0, $iosaP.RandomRange)(this.minScaleX, this.maxScaleX), (0, $iosaP.RandomRange)(this.minScaleY, this.maxScaleY));
            // Adjust scale by start size
            if (this._startSizeGradients && this._startSizeGradients[0] && this.targetStopDuration) {
                const ratio = this._actualFrame / this.targetStopDuration;
                (0, $iDYnp.GradientHelper).GetCurrentGradient(ratio, this._startSizeGradients, (currentGradient, nextGradient, scale)=>{
                    if (currentGradient !== this._currentStartSizeGradient) {
                        this._currentStartSize1 = this._currentStartSize2;
                        this._currentStartSize2 = nextGradient.getFactor();
                        this._currentStartSizeGradient = currentGradient;
                    }
                    const value = (0, $iosaP.Lerp)(this._currentStartSize1, this._currentStartSize2, scale);
                    particle.scale.scaleInPlace(value);
                });
            }
            // Angle
            if (!this._angularSpeedGradients || this._angularSpeedGradients.length === 0) particle.angularSpeed = (0, $iosaP.RandomRange)(this.minAngularSpeed, this.maxAngularSpeed);
            else {
                particle._currentAngularSpeedGradient = this._angularSpeedGradients[0];
                particle.angularSpeed = particle._currentAngularSpeedGradient.getFactor();
                particle._currentAngularSpeed1 = particle.angularSpeed;
                if (this._angularSpeedGradients.length > 1) particle._currentAngularSpeed2 = this._angularSpeedGradients[1].getFactor();
                else particle._currentAngularSpeed2 = particle._currentAngularSpeed1;
            }
            particle.angle = (0, $iosaP.RandomRange)(this.minInitialRotation, this.maxInitialRotation);
            // Velocity
            if (this._velocityGradients && this._velocityGradients.length > 0) {
                particle._currentVelocityGradient = this._velocityGradients[0];
                particle._currentVelocity1 = particle._currentVelocityGradient.getFactor();
                if (this._velocityGradients.length > 1) particle._currentVelocity2 = this._velocityGradients[1].getFactor();
                else particle._currentVelocity2 = particle._currentVelocity1;
            }
            // Limit velocity
            if (this._limitVelocityGradients && this._limitVelocityGradients.length > 0) {
                particle._currentLimitVelocityGradient = this._limitVelocityGradients[0];
                particle._currentLimitVelocity1 = particle._currentLimitVelocityGradient.getFactor();
                if (this._limitVelocityGradients.length > 1) particle._currentLimitVelocity2 = this._limitVelocityGradients[1].getFactor();
                else particle._currentLimitVelocity2 = particle._currentLimitVelocity1;
            }
            // Drag
            if (this._dragGradients && this._dragGradients.length > 0) {
                particle._currentDragGradient = this._dragGradients[0];
                particle._currentDrag1 = particle._currentDragGradient.getFactor();
                if (this._dragGradients.length > 1) particle._currentDrag2 = this._dragGradients[1].getFactor();
                else particle._currentDrag2 = particle._currentDrag1;
            }
            // Color
            if (!this._colorGradients || this._colorGradients.length === 0) {
                const step = (0, $iosaP.RandomRange)(0, 1.0);
                (0, $7etnY.Color4).LerpToRef(this.color1, this.color2, step, particle.color);
                this.colorDead.subtractToRef(particle.color, this._colorDiff);
                this._colorDiff.scaleToRef(1.0 / particle.lifeTime, particle.colorStep);
            } else {
                particle._currentColorGradient = this._colorGradients[0];
                particle._currentColorGradient.getColorToRef(particle.color);
                particle._currentColor1.copyFrom(particle.color);
                if (this._colorGradients.length > 1) this._colorGradients[1].getColorToRef(particle._currentColor2);
                else particle._currentColor2.copyFrom(particle.color);
            }
            // Sheet
            if (this._isAnimationSheetEnabled) {
                particle._initialStartSpriteCellID = this.startSpriteCellID;
                particle._initialEndSpriteCellID = this.endSpriteCellID;
                particle._initialSpriteCellLoop = this.spriteCellLoop;
            }
            // Inherited Velocity
            particle.direction.addInPlace(this._inheritedVelocityOffset);
            // Ramp
            if (this._useRampGradients) particle.remapData = new (0, $ha1VO.Vector4)(0, 1, 0, 1);
            // Noise texture coordinates
            if (this.noiseTexture) {
                if (particle._randomNoiseCoordinates1) {
                    particle._randomNoiseCoordinates1.copyFromFloats(Math.random(), Math.random(), Math.random());
                    particle._randomNoiseCoordinates2.copyFromFloats(Math.random(), Math.random(), Math.random());
                } else {
                    particle._randomNoiseCoordinates1 = new (0, $ha1VO.Vector3)(Math.random(), Math.random(), Math.random());
                    particle._randomNoiseCoordinates2 = new (0, $ha1VO.Vector3)(Math.random(), Math.random(), Math.random());
                }
            }
            // Update the position of the attached sub-emitters to match their attached particle
            particle._inheritParticleInfoToSubEmitters();
        }
    }
    /**
     * @internal
     */ static _GetAttributeNamesOrOptions(isAnimationSheetEnabled = false, isBillboardBased = false, useRampGradients = false) {
        const attributeNamesOrOptions = [
            (0, $b4i1f.VertexBuffer).PositionKind,
            (0, $b4i1f.VertexBuffer).ColorKind,
            "angle",
            "offset",
            "size"
        ];
        if (isAnimationSheetEnabled) attributeNamesOrOptions.push("cellIndex");
        if (!isBillboardBased) attributeNamesOrOptions.push("direction");
        if (useRampGradients) attributeNamesOrOptions.push("remapData");
        return attributeNamesOrOptions;
    }
    /**
     * @internal
     */ static _GetEffectCreationOptions(isAnimationSheetEnabled = false, useLogarithmicDepth = false, applyFog = false) {
        const effectCreationOption = [
            "invView",
            "view",
            "projection",
            "textureMask",
            "translationPivot",
            "eyePosition"
        ];
        (0, $aAFeM.addClipPlaneUniforms)(effectCreationOption);
        if (isAnimationSheetEnabled) effectCreationOption.push("particlesInfos");
        if (useLogarithmicDepth) effectCreationOption.push("logarithmicDepthConstant");
        if (applyFog) {
            effectCreationOption.push("vFogInfos");
            effectCreationOption.push("vFogColor");
        }
        return effectCreationOption;
    }
    /**
     * Fill the defines array according to the current settings of the particle system
     * @param defines Array to be updated
     * @param blendMode blend mode to take into account when updating the array
     */ fillDefines(defines, blendMode) {
        if (this._scene) {
            (0, $aAFeM.prepareStringDefinesForClipPlanes)(this, this._scene, defines);
            if (this.applyFog && this._scene.fogEnabled && this._scene.fogMode !== 0) defines.push("#define FOG");
        }
        if (this._isAnimationSheetEnabled) defines.push("#define ANIMATESHEET");
        if (this.useLogarithmicDepth) defines.push("#define LOGARITHMICDEPTH");
        if (blendMode === (0, $1iaDW.BaseParticleSystem).BLENDMODE_MULTIPLY) defines.push("#define BLENDMULTIPLYMODE");
        if (this._useRampGradients) defines.push("#define RAMPGRADIENT");
        if (this._isBillboardBased) {
            defines.push("#define BILLBOARD");
            switch(this.billboardMode){
                case 2:
                    defines.push("#define BILLBOARDY");
                    break;
                case 8:
                case 9:
                    defines.push("#define BILLBOARDSTRETCHED");
                    if (this.billboardMode === 9) defines.push("#define BILLBOARDSTRETCHED_LOCAL");
                    break;
                case 7:
                    defines.push("#define BILLBOARDMODE_ALL");
                    break;
                default:
                    break;
            }
        }
        if (this._imageProcessingConfiguration) {
            this._imageProcessingConfiguration.prepareDefines(this._imageProcessingConfigurationDefines);
            defines.push(this._imageProcessingConfigurationDefines.toString());
        }
    }
    /**
     * Fill the uniforms, attributes and samplers arrays according to the current settings of the particle system
     * @param uniforms Uniforms array to fill
     * @param attributes Attributes array to fill
     * @param samplers Samplers array to fill
     */ fillUniformsAttributesAndSamplerNames(uniforms, attributes, samplers) {
        attributes.push(...$95351d116892571a$export$b52eeadd2730cb3f._GetAttributeNamesOrOptions(this._isAnimationSheetEnabled, this._isBillboardBased && this.billboardMode !== 8 && this.billboardMode !== 9, this._useRampGradients));
        uniforms.push(...$95351d116892571a$export$b52eeadd2730cb3f._GetEffectCreationOptions(this._isAnimationSheetEnabled, this.useLogarithmicDepth, this.applyFog));
        samplers.push("diffuseSampler", "rampSampler");
        if (this._imageProcessingConfiguration) {
            (0, $ePyUi.PrepareUniformsForImageProcessing)(uniforms, this._imageProcessingConfigurationDefines);
            (0, $ePyUi.PrepareSamplersForImageProcessing)(samplers, this._imageProcessingConfigurationDefines);
        }
    }
    /**
     * @internal
     */ _getWrapper(blendMode) {
        const customWrapper = this._getCustomDrawWrapper(blendMode);
        if (customWrapper?.effect) return customWrapper;
        const defines = [];
        this.fillDefines(defines, blendMode);
        // Effect
        const currentRenderPassId = this._engine._features.supportRenderPasses ? this._engine.currentRenderPassId : 0;
        let drawWrappers = this._drawWrappers[currentRenderPassId];
        if (!drawWrappers) drawWrappers = this._drawWrappers[currentRenderPassId] = [];
        let drawWrapper = drawWrappers[blendMode];
        if (!drawWrapper) {
            drawWrapper = new (0, $hOyoX.DrawWrapper)(this._engine);
            if (drawWrapper.drawContext) drawWrapper.drawContext.useInstancing = this._useInstancing;
            drawWrappers[blendMode] = drawWrapper;
        }
        const join = defines.join("\n");
        if (drawWrapper.defines !== join) {
            const attributesNamesOrOptions = [];
            const effectCreationOption = [];
            const samplers = [];
            this.fillUniformsAttributesAndSamplerNames(effectCreationOption, attributesNamesOrOptions, samplers);
            drawWrapper.setEffect(this._engine.createEffect("particles", attributesNamesOrOptions, effectCreationOption, samplers, join), join);
        }
        return drawWrapper;
    }
    /**
     * Animates the particle system for the current frame by emitting new particles and or animating the living ones.
     * @param preWarmOnly will prevent the system from updating the vertex buffer (default is false)
     */ animate(preWarmOnly = false) {
        if (!this._started) return;
        if (!preWarmOnly && this._scene) {
            // Check
            if (!this.isReady()) return;
            if (this._currentRenderId === this._scene.getFrameId()) return;
            this._currentRenderId = this._scene.getFrameId();
        }
        this._scaledUpdateSpeed = this.updateSpeed * (preWarmOnly ? this.preWarmStepOffset : this._scene?.getAnimationRatio() || 1);
        // Determine the number of particles we need to create
        let newParticles;
        if (this.manualEmitCount > -1) {
            newParticles = this.manualEmitCount;
            this._newPartsExcess = 0;
            this.manualEmitCount = 0;
        } else {
            let rate = this.emitRate;
            if (this._emitRateGradients && this._emitRateGradients.length > 0 && this.targetStopDuration) {
                const ratio = this._actualFrame / this.targetStopDuration;
                (0, $iDYnp.GradientHelper).GetCurrentGradient(ratio, this._emitRateGradients, (currentGradient, nextGradient, scale)=>{
                    if (currentGradient !== this._currentEmitRateGradient) {
                        this._currentEmitRate1 = this._currentEmitRate2;
                        this._currentEmitRate2 = nextGradient.getFactor();
                        this._currentEmitRateGradient = currentGradient;
                    }
                    rate = (0, $iosaP.Lerp)(this._currentEmitRate1, this._currentEmitRate2, scale);
                });
            }
            newParticles = rate * this._scaledUpdateSpeed >> 0;
            this._newPartsExcess += rate * this._scaledUpdateSpeed - newParticles;
        }
        if (this._newPartsExcess > 1.0) {
            newParticles += this._newPartsExcess >> 0;
            this._newPartsExcess -= this._newPartsExcess >> 0;
        }
        this._alive = false;
        if (!this._stopped) {
            this._actualFrame += this._scaledUpdateSpeed;
            if (this.targetStopDuration && this._actualFrame >= this.targetStopDuration) this.stop();
        } else newParticles = 0;
        this._update(newParticles);
        // Stopped?
        if (this._stopped) {
            if (!this._alive) {
                this._started = false;
                if (this.onAnimationEnd) this.onAnimationEnd();
                if (this.disposeOnStop && this._scene) this._scene._toBeDisposed.push(this);
            }
        }
        if (!preWarmOnly) {
            // Update VBO
            let offset = 0;
            for(let index = 0; index < this._particles.length; index++){
                const particle = this._particles[index];
                this._appendParticleVertices(offset, particle);
                offset += this._useInstancing ? 1 : 4;
            }
            if (this._vertexBuffer) this._vertexBuffer.updateDirectly(this._vertexData, 0, this._particles.length);
        }
        if (this.manualEmitCount === 0 && this.disposeOnStop) this.stop();
    }
    _appendParticleVertices(offset, particle) {
        this._appendParticleVertex(offset++, particle, 0, 0);
        if (!this._useInstancing) {
            this._appendParticleVertex(offset++, particle, 1, 0);
            this._appendParticleVertex(offset++, particle, 1, 1);
            this._appendParticleVertex(offset++, particle, 0, 1);
        }
    }
    /**
     * Rebuilds the particle system.
     */ rebuild() {
        if (this._engine.getCaps().vertexArrayObject) this._vertexArrayObject = null;
        this._createIndexBuffer();
        this._spriteBuffer?._rebuild();
        this._createVertexBuffers();
        this.resetDrawCache();
    }
    /**
     * Is this system ready to be used/rendered
     * @returns true if the system is ready
     */ isReady() {
        if (!this.emitter || this._imageProcessingConfiguration && !this._imageProcessingConfiguration.isReady() || !this.particleTexture || !this.particleTexture.isReady()) return false;
        if (this.blendMode !== (0, $1iaDW.BaseParticleSystem).BLENDMODE_MULTIPLYADD) {
            if (!this._getWrapper(this.blendMode).effect.isReady()) return false;
        } else {
            if (!this._getWrapper((0, $1iaDW.BaseParticleSystem).BLENDMODE_MULTIPLY).effect.isReady()) return false;
            if (!this._getWrapper((0, $1iaDW.BaseParticleSystem).BLENDMODE_ADD).effect.isReady()) return false;
        }
        return true;
    }
    _render(blendMode) {
        const drawWrapper = this._getWrapper(blendMode);
        const effect = drawWrapper.effect;
        const engine = this._engine;
        // Render
        engine.enableEffect(drawWrapper);
        const viewMatrix = this.defaultViewMatrix ?? this._scene.getViewMatrix();
        effect.setTexture("diffuseSampler", this.particleTexture);
        effect.setMatrix("view", viewMatrix);
        effect.setMatrix("projection", this.defaultProjectionMatrix ?? this._scene.getProjectionMatrix());
        if (this._isAnimationSheetEnabled && this.particleTexture) {
            const baseSize = this.particleTexture.getBaseSize();
            effect.setFloat3("particlesInfos", this.spriteCellWidth / baseSize.width, this.spriteCellHeight / baseSize.height, this.spriteCellWidth / baseSize.width);
        }
        effect.setVector2("translationPivot", this.translationPivot);
        effect.setFloat4("textureMask", this.textureMask.r, this.textureMask.g, this.textureMask.b, this.textureMask.a);
        if (this._isBillboardBased && this._scene) {
            const camera = this._scene.activeCamera;
            effect.setVector3("eyePosition", camera.globalPosition);
        }
        if (this._rampGradientsTexture) {
            if (!this._rampGradients || !this._rampGradients.length) {
                this._rampGradientsTexture.dispose();
                this._rampGradientsTexture = null;
            }
            effect.setTexture("rampSampler", this._rampGradientsTexture);
        }
        const defines = effect.defines;
        if (this._scene) {
            (0, $aAFeM.bindClipPlane)(effect, this, this._scene);
            if (this.applyFog) (0, $alPCh.BindFogParameters)(this._scene, undefined, effect);
        }
        if (defines.indexOf("#define BILLBOARDMODE_ALL") >= 0) {
            viewMatrix.invertToRef((0, $ha1VO.TmpVectors).Matrix[0]);
            effect.setMatrix("invView", (0, $ha1VO.TmpVectors).Matrix[0]);
        }
        if (this._vertexArrayObject !== undefined) {
            if (this._scene?.forceWireframe) engine.bindBuffers(this._vertexBuffers, this._linesIndexBufferUseInstancing, effect);
            else {
                if (!this._vertexArrayObject) this._vertexArrayObject = this._engine.recordVertexArrayObject(this._vertexBuffers, null, effect);
                this._engine.bindVertexArrayObject(this._vertexArrayObject, this._scene?.forceWireframe ? this._linesIndexBufferUseInstancing : this._indexBuffer);
            }
        } else if (!this._indexBuffer) // Use instancing mode
        engine.bindBuffers(this._vertexBuffers, this._scene?.forceWireframe ? this._linesIndexBufferUseInstancing : null, effect);
        else engine.bindBuffers(this._vertexBuffers, this._scene?.forceWireframe ? this._linesIndexBuffer : this._indexBuffer, effect);
        // Log. depth
        if (this.useLogarithmicDepth && this._scene) (0, $alPCh.BindLogDepth)(defines, effect, this._scene);
        // image processing
        if (this._imageProcessingConfiguration && !this._imageProcessingConfiguration.applyByPostProcess) this._imageProcessingConfiguration.bind(effect);
        // Draw order
        switch(blendMode){
            case (0, $1iaDW.BaseParticleSystem).BLENDMODE_ADD:
                engine.setAlphaMode(1);
                break;
            case (0, $1iaDW.BaseParticleSystem).BLENDMODE_ONEONE:
                engine.setAlphaMode(6);
                break;
            case (0, $1iaDW.BaseParticleSystem).BLENDMODE_STANDARD:
                engine.setAlphaMode(2);
                break;
            case (0, $1iaDW.BaseParticleSystem).BLENDMODE_MULTIPLY:
                engine.setAlphaMode(4);
                break;
        }
        if (this._onBeforeDrawParticlesObservable) this._onBeforeDrawParticlesObservable.notifyObservers(effect);
        if (this._useInstancing) {
            if (this._scene?.forceWireframe) engine.drawElementsType(6, 0, 10, this._particles.length);
            else engine.drawArraysType(7, 0, 4, this._particles.length);
        } else if (this._scene?.forceWireframe) engine.drawElementsType(1, 0, this._particles.length * 10);
        else engine.drawElementsType(0, 0, this._particles.length * 6);
        return this._particles.length;
    }
    /**
     * Renders the particle system in its current state.
     * @returns the current number of particles
     */ render() {
        // Check
        if (!this.isReady() || !this._particles.length) return 0;
        const engine = this._engine;
        if (engine.setState) {
            engine.setState(false);
            if (this.forceDepthWrite) engine.setDepthWrite(true);
        }
        let outparticles = 0;
        if (this.blendMode === (0, $1iaDW.BaseParticleSystem).BLENDMODE_MULTIPLYADD) outparticles = this._render((0, $1iaDW.BaseParticleSystem).BLENDMODE_MULTIPLY) + this._render((0, $1iaDW.BaseParticleSystem).BLENDMODE_ADD);
        else outparticles = this._render(this.blendMode);
        this._engine.unbindInstanceAttributes();
        this._engine.setAlphaMode(0);
        return outparticles;
    }
    /** @internal */ _onDispose(disposeAttachedSubEmitters = false, disposeEndSubEmitters = false) {
    // Do Nothing
    }
    /**
     * Disposes the particle system and free the associated resources
     * @param disposeTexture defines if the particle texture must be disposed as well (true by default)
     * @param disposeAttachedSubEmitters defines if the attached sub-emitters must be disposed as well (false by default)
     * @param disposeEndSubEmitters defines if the end type sub-emitters must be disposed as well (false by default)
     */ dispose(disposeTexture = true, disposeAttachedSubEmitters = false, disposeEndSubEmitters = false) {
        this.resetDrawCache();
        if (this._vertexBuffer) {
            this._vertexBuffer.dispose();
            this._vertexBuffer = null;
        }
        if (this._spriteBuffer) {
            this._spriteBuffer.dispose();
            this._spriteBuffer = null;
        }
        if (this._indexBuffer) {
            this._engine._releaseBuffer(this._indexBuffer);
            this._indexBuffer = null;
        }
        if (this._linesIndexBuffer) {
            this._engine._releaseBuffer(this._linesIndexBuffer);
            this._linesIndexBuffer = null;
        }
        if (this._linesIndexBufferUseInstancing) {
            this._engine._releaseBuffer(this._linesIndexBufferUseInstancing);
            this._linesIndexBufferUseInstancing = null;
        }
        if (this._vertexArrayObject) {
            this._engine.releaseVertexArrayObject(this._vertexArrayObject);
            this._vertexArrayObject = null;
        }
        if (disposeTexture && this.particleTexture) {
            this.particleTexture.dispose();
            this.particleTexture = null;
        }
        if (disposeTexture && this.noiseTexture) {
            this.noiseTexture.dispose();
            this.noiseTexture = null;
        }
        if (this._rampGradientsTexture) {
            this._rampGradientsTexture.dispose();
            this._rampGradientsTexture = null;
        }
        this._onDispose(disposeAttachedSubEmitters, disposeEndSubEmitters);
        if (this._onBeforeDrawParticlesObservable) this._onBeforeDrawParticlesObservable.clear();
        // Remove from scene
        if (this._scene) {
            const index = this._scene.particleSystems.indexOf(this);
            if (index > -1) this._scene.particleSystems.splice(index, 1);
            this._scene._activeParticleSystems.dispose();
        }
        // Callback
        this.onDisposeObservable.notifyObservers(this);
        this.onDisposeObservable.clear();
        this.onStoppedObservable.clear();
        this.reset();
    }
}

});
parcelRegister("e6EVj", function(module, exports) {

$parcel$export(module.exports, "Particle", () => $a4515ec770fcd736$export$c36c68baa13912a5);

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $iosaP = parcelRequire("iosaP");
class $a4515ec770fcd736$export$c36c68baa13912a5 {
    /**
     * Creates a new instance Particle
     * @param particleSystem the particle system the particle belongs to
     */ constructor(/**
     * The particle system the particle belongs to.
     */ particleSystem){
        this.particleSystem = particleSystem;
        /**
         * The world position of the particle in the scene.
         */ this.position = (0, $ha1VO.Vector3).Zero();
        /**
         * The world direction of the particle in the scene.
         */ this.direction = (0, $ha1VO.Vector3).Zero();
        /**
         * The color of the particle.
         */ this.color = new (0, $7etnY.Color4)(0, 0, 0, 0);
        /**
         * The color change of the particle per step.
         */ this.colorStep = new (0, $7etnY.Color4)(0, 0, 0, 0);
        /**
         * Defines how long will the life of the particle be.
         */ this.lifeTime = 1.0;
        /**
         * The current age of the particle.
         */ this.age = 0;
        /**
         * The current size of the particle.
         */ this.size = 0;
        /**
         * The current scale of the particle.
         */ this.scale = new (0, $ha1VO.Vector2)(1, 1);
        /**
         * The current angle of the particle.
         */ this.angle = 0;
        /**
         * Defines how fast is the angle changing.
         */ this.angularSpeed = 0;
        /**
         * Defines the cell index used by the particle to be rendered from a sprite.
         */ this.cellIndex = 0;
        /** @internal */ this._attachedSubEmitters = null;
        /** @internal */ this._currentColor1 = new (0, $7etnY.Color4)(0, 0, 0, 0);
        /** @internal */ this._currentColor2 = new (0, $7etnY.Color4)(0, 0, 0, 0);
        /** @internal */ this._currentSize1 = 0;
        /** @internal */ this._currentSize2 = 0;
        /** @internal */ this._currentAngularSpeed1 = 0;
        /** @internal */ this._currentAngularSpeed2 = 0;
        /** @internal */ this._currentVelocity1 = 0;
        /** @internal */ this._currentVelocity2 = 0;
        /** @internal */ this._currentLimitVelocity1 = 0;
        /** @internal */ this._currentLimitVelocity2 = 0;
        /** @internal */ this._currentDrag1 = 0;
        /** @internal */ this._currentDrag2 = 0;
        this.id = $a4515ec770fcd736$export$c36c68baa13912a5._Count++;
        if (!this.particleSystem.isAnimationSheetEnabled) return;
        this._updateCellInfoFromSystem();
    }
    _updateCellInfoFromSystem() {
        this.cellIndex = this.particleSystem.startSpriteCellID;
    }
    /**
     * Defines how the sprite cell index is updated for the particle
     */ updateCellIndex() {
        let offsetAge = this.age;
        let changeSpeed = this.particleSystem.spriteCellChangeSpeed;
        if (this.particleSystem.spriteRandomStartCell) {
            if (this._randomCellOffset === undefined) this._randomCellOffset = Math.random() * this.lifeTime;
            if (changeSpeed === 0) {
                // Special case when speed = 0 meaning we want to stay on initial cell
                changeSpeed = 1;
                offsetAge = this._randomCellOffset;
            } else offsetAge += this._randomCellOffset;
        }
        const dist = this._initialEndSpriteCellID - this._initialStartSpriteCellID;
        let ratio;
        if (this._initialSpriteCellLoop) ratio = (0, $iosaP.Clamp)(offsetAge * changeSpeed % this.lifeTime / this.lifeTime);
        else ratio = (0, $iosaP.Clamp)(offsetAge * changeSpeed / this.lifeTime);
        this.cellIndex = this._initialStartSpriteCellID + ratio * dist | 0;
    }
    /**
     * @internal
     */ _inheritParticleInfoToSubEmitter(subEmitter) {
        if (subEmitter.particleSystem.emitter.position) {
            const emitterMesh = subEmitter.particleSystem.emitter;
            emitterMesh.position.copyFrom(this.position);
            if (subEmitter.inheritDirection) {
                const temp = (0, $ha1VO.TmpVectors).Vector3[0];
                this.direction.normalizeToRef(temp);
                emitterMesh.setDirection(temp, 0, Math.PI / 2);
            }
        } else {
            const emitterPosition = subEmitter.particleSystem.emitter;
            emitterPosition.copyFrom(this.position);
        }
        // Set inheritedVelocityOffset to be used when new particles are created
        this.direction.scaleToRef(subEmitter.inheritedVelocityAmount / 2, (0, $ha1VO.TmpVectors).Vector3[0]);
        subEmitter.particleSystem._inheritedVelocityOffset.copyFrom((0, $ha1VO.TmpVectors).Vector3[0]);
    }
    /** @internal */ _inheritParticleInfoToSubEmitters() {
        if (this._attachedSubEmitters && this._attachedSubEmitters.length > 0) this._attachedSubEmitters.forEach((subEmitter)=>{
            this._inheritParticleInfoToSubEmitter(subEmitter);
        });
    }
    /** @internal */ _reset() {
        this.age = 0;
        this.id = $a4515ec770fcd736$export$c36c68baa13912a5._Count++;
        this._currentColorGradient = null;
        this._currentSizeGradient = null;
        this._currentAngularSpeedGradient = null;
        this._currentVelocityGradient = null;
        this._currentLimitVelocityGradient = null;
        this._currentDragGradient = null;
        this.cellIndex = this.particleSystem.startSpriteCellID;
        this._randomCellOffset = undefined;
    }
    /**
     * Copy the properties of particle to another one.
     * @param other the particle to copy the information to.
     */ copyTo(other) {
        other.position.copyFrom(this.position);
        if (this._initialDirection) {
            if (other._initialDirection) other._initialDirection.copyFrom(this._initialDirection);
            else other._initialDirection = this._initialDirection.clone();
        } else other._initialDirection = null;
        other.direction.copyFrom(this.direction);
        if (this._localPosition) {
            if (other._localPosition) other._localPosition.copyFrom(this._localPosition);
            else other._localPosition = this._localPosition.clone();
        }
        other.color.copyFrom(this.color);
        other.colorStep.copyFrom(this.colorStep);
        other.lifeTime = this.lifeTime;
        other.age = this.age;
        other._randomCellOffset = this._randomCellOffset;
        other.size = this.size;
        other.scale.copyFrom(this.scale);
        other.angle = this.angle;
        other.angularSpeed = this.angularSpeed;
        other.particleSystem = this.particleSystem;
        other.cellIndex = this.cellIndex;
        other.id = this.id;
        other._attachedSubEmitters = this._attachedSubEmitters;
        if (this._currentColorGradient) {
            other._currentColorGradient = this._currentColorGradient;
            other._currentColor1.copyFrom(this._currentColor1);
            other._currentColor2.copyFrom(this._currentColor2);
        }
        if (this._currentSizeGradient) {
            other._currentSizeGradient = this._currentSizeGradient;
            other._currentSize1 = this._currentSize1;
            other._currentSize2 = this._currentSize2;
        }
        if (this._currentAngularSpeedGradient) {
            other._currentAngularSpeedGradient = this._currentAngularSpeedGradient;
            other._currentAngularSpeed1 = this._currentAngularSpeed1;
            other._currentAngularSpeed2 = this._currentAngularSpeed2;
        }
        if (this._currentVelocityGradient) {
            other._currentVelocityGradient = this._currentVelocityGradient;
            other._currentVelocity1 = this._currentVelocity1;
            other._currentVelocity2 = this._currentVelocity2;
        }
        if (this._currentLimitVelocityGradient) {
            other._currentLimitVelocityGradient = this._currentLimitVelocityGradient;
            other._currentLimitVelocity1 = this._currentLimitVelocity1;
            other._currentLimitVelocity2 = this._currentLimitVelocity2;
        }
        if (this._currentDragGradient) {
            other._currentDragGradient = this._currentDragGradient;
            other._currentDrag1 = this._currentDrag1;
            other._currentDrag2 = this._currentDrag2;
        }
        if (this.particleSystem.isAnimationSheetEnabled) {
            other._initialStartSpriteCellID = this._initialStartSpriteCellID;
            other._initialEndSpriteCellID = this._initialEndSpriteCellID;
            other._initialSpriteCellLoop = this._initialSpriteCellLoop;
        }
        if (this.particleSystem.useRampGradients) {
            if (other.remapData && this.remapData) other.remapData.copyFrom(this.remapData);
            else other.remapData = new (0, $ha1VO.Vector4)(0, 0, 0, 0);
        }
        if (this._randomNoiseCoordinates1) {
            if (other._randomNoiseCoordinates1) {
                other._randomNoiseCoordinates1.copyFrom(this._randomNoiseCoordinates1);
                other._randomNoiseCoordinates2.copyFrom(this._randomNoiseCoordinates2);
            } else {
                other._randomNoiseCoordinates1 = this._randomNoiseCoordinates1.clone();
                other._randomNoiseCoordinates2 = this._randomNoiseCoordinates2.clone();
            }
        }
    }
}
$a4515ec770fcd736$export$c36c68baa13912a5._Count = 0;

});

parcelRegister("bBTDU", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("82O8L");
parcelRequire("jtwq6");
parcelRequire("4kipo");
parcelRequire("7Hs3g");
parcelRequire("cRFSM");
parcelRequire("hvLF9");
parcelRequire("kg1CD");
parcelRequire("izyqw");
parcelRequire("110hr");
const $873e4fe9582f4521$var$name = "particlesPixelShader";
const $873e4fe9582f4521$var$shader = `#ifdef LOGARITHMICDEPTH
#extension GL_EXT_frag_depth : enable
#endif
varying vec2 vUV;varying vec4 vColor;uniform vec4 textureMask;uniform sampler2D diffuseSampler;
#include<clipPlaneFragmentDeclaration>
#include<imageProcessingDeclaration>
#include<logDepthDeclaration>
#include<helperFunctions>
#include<imageProcessingFunctions>
#ifdef RAMPGRADIENT
varying vec4 remapRanges;uniform sampler2D rampSampler;
#endif
#include<fogFragmentDeclaration>
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) {
#define CUSTOM_FRAGMENT_MAIN_BEGIN
#include<clipPlaneFragment>
vec4 textureColor=texture2D(diffuseSampler,vUV);vec4 baseColor=(textureColor*textureMask+(vec4(1.,1.,1.,1.)-textureMask))*vColor;
#ifdef RAMPGRADIENT
float alpha=baseColor.a;float remappedColorIndex=clamp((alpha-remapRanges.x)/remapRanges.y,0.0,1.0);vec4 rampColor=texture2D(rampSampler,vec2(1.0-remappedColorIndex,0.));baseColor.rgb*=rampColor.rgb;float finalAlpha=baseColor.a;baseColor.a=clamp((alpha*rampColor.a-remapRanges.z)/remapRanges.w,0.0,1.0);
#endif
#ifdef BLENDMULTIPLYMODE
float sourceAlpha=vColor.a*textureColor.a;baseColor.rgb=baseColor.rgb*sourceAlpha+vec3(1.0)*(1.0-sourceAlpha);
#endif
#include<logDepthFragment>
#include<fogFragment>(color,baseColor)
#ifdef IMAGEPROCESSINGPOSTPROCESS
baseColor.rgb=toLinearSpace(baseColor.rgb);
#else
#ifdef IMAGEPROCESSING
baseColor.rgb=toLinearSpace(baseColor.rgb);baseColor=applyImageProcessing(baseColor);
#endif
#endif
gl_FragColor=baseColor;
#define CUSTOM_FRAGMENT_MAIN_END
}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$873e4fe9582f4521$var$name] = $873e4fe9582f4521$var$shader;
const $873e4fe9582f4521$export$1ea4d7566be18163 = {
    name: $873e4fe9582f4521$var$name,
    shader: $873e4fe9582f4521$var$shader
};

});

parcelRegister("6ueFN", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("4A4MM");
parcelRequire("bdABV");
parcelRequire("4kipo");
parcelRequire("kqCfW");
parcelRequire("1pV7g");
parcelRequire("a111f");
const $4b90ed337eee7a4c$var$name = "particlesVertexShader";
const $4b90ed337eee7a4c$var$shader = `attribute vec3 position;attribute vec4 color;attribute float angle;attribute vec2 size;
#ifdef ANIMATESHEET
attribute float cellIndex;
#endif
#ifndef BILLBOARD
attribute vec3 direction;
#endif
#ifdef BILLBOARDSTRETCHED
attribute vec3 direction;
#endif
#ifdef RAMPGRADIENT
attribute vec4 remapData;
#endif
attribute vec2 offset;uniform mat4 view;uniform mat4 projection;uniform vec2 translationPivot;
#ifdef ANIMATESHEET
uniform vec3 particlesInfos; 
#endif
varying vec2 vUV;varying vec4 vColor;varying vec3 vPositionW;
#ifdef RAMPGRADIENT
varying vec4 remapRanges;
#endif
#if defined(BILLBOARD) && !defined(BILLBOARDY) && !defined(BILLBOARDSTRETCHED)
uniform mat4 invView;
#endif
#include<clipPlaneVertexDeclaration>
#include<fogVertexDeclaration>
#include<logDepthDeclaration>
#ifdef BILLBOARD
uniform vec3 eyePosition;
#endif
vec3 rotate(vec3 yaxis,vec3 rotatedCorner) {vec3 xaxis=normalize(cross(vec3(0.,1.0,0.),yaxis));vec3 zaxis=normalize(cross(yaxis,xaxis));vec3 row0=vec3(xaxis.x,xaxis.y,xaxis.z);vec3 row1=vec3(yaxis.x,yaxis.y,yaxis.z);vec3 row2=vec3(zaxis.x,zaxis.y,zaxis.z);mat3 rotMatrix= mat3(row0,row1,row2);vec3 alignedCorner=rotMatrix*rotatedCorner;return position+alignedCorner;}
#ifdef BILLBOARDSTRETCHED
vec3 rotateAlign(vec3 toCamera,vec3 rotatedCorner) {vec3 normalizedToCamera=normalize(toCamera);vec3 normalizedCrossDirToCamera=normalize(cross(normalize(direction),normalizedToCamera));vec3 row0=vec3(normalizedCrossDirToCamera.x,normalizedCrossDirToCamera.y,normalizedCrossDirToCamera.z);vec3 row2=vec3(normalizedToCamera.x,normalizedToCamera.y,normalizedToCamera.z);
#ifdef BILLBOARDSTRETCHED_LOCAL
vec3 row1=direction;
#else
vec3 crossProduct=normalize(cross(normalizedToCamera,normalizedCrossDirToCamera));vec3 row1=vec3(crossProduct.x,crossProduct.y,crossProduct.z);
#endif
mat3 rotMatrix= mat3(row0,row1,row2);vec3 alignedCorner=rotMatrix*rotatedCorner;return position+alignedCorner;}
#endif
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
vec2 cornerPos;cornerPos=(vec2(offset.x-0.5,offset.y -0.5)-translationPivot)*size;
#ifdef BILLBOARD
vec3 rotatedCorner;
#ifdef BILLBOARDY
rotatedCorner.x=cornerPos.x*cos(angle)-cornerPos.y*sin(angle);rotatedCorner.z=cornerPos.x*sin(angle)+cornerPos.y*cos(angle);rotatedCorner.y=0.;rotatedCorner.xz+=translationPivot;vec3 yaxis=position-eyePosition;yaxis.y=0.;vPositionW=rotate(normalize(yaxis),rotatedCorner);vec3 viewPos=(view*vec4(vPositionW,1.0)).xyz;
#elif defined(BILLBOARDSTRETCHED)
rotatedCorner.x=cornerPos.x*cos(angle)-cornerPos.y*sin(angle);rotatedCorner.y=cornerPos.x*sin(angle)+cornerPos.y*cos(angle);rotatedCorner.z=0.;rotatedCorner.xy+=translationPivot;vec3 toCamera=position-eyePosition;vPositionW=rotateAlign(toCamera,rotatedCorner);vec3 viewPos=(view*vec4(vPositionW,1.0)).xyz;
#else
rotatedCorner.x=cornerPos.x*cos(angle)-cornerPos.y*sin(angle);rotatedCorner.y=cornerPos.x*sin(angle)+cornerPos.y*cos(angle);rotatedCorner.z=0.;rotatedCorner.xy+=translationPivot;vec3 viewPos=(view*vec4(position,1.0)).xyz+rotatedCorner;vPositionW=(invView*vec4(viewPos,1)).xyz;
#endif
#ifdef RAMPGRADIENT
remapRanges=remapData;
#endif
gl_Position=projection*vec4(viewPos,1.0);
#else
vec3 rotatedCorner;rotatedCorner.x=cornerPos.x*cos(angle)-cornerPos.y*sin(angle);rotatedCorner.z=cornerPos.x*sin(angle)+cornerPos.y*cos(angle);rotatedCorner.y=0.;rotatedCorner.xz+=translationPivot;vec3 yaxis=normalize(direction);vPositionW=rotate(yaxis,rotatedCorner);gl_Position=projection*view*vec4(vPositionW,1.0);
#endif
vColor=color;
#ifdef ANIMATESHEET
float rowOffset=floor(cellIndex*particlesInfos.z);float columnOffset=cellIndex-rowOffset/particlesInfos.z;vec2 uvScale=particlesInfos.xy;vec2 uvOffset=vec2(offset.x ,1.0-offset.y);vUV=(uvOffset+vec2(columnOffset,rowOffset))*uvScale;
#else
vUV=offset;
#endif
#if defined(CLIPPLANE) || defined(CLIPPLANE2) || defined(CLIPPLANE3) || defined(CLIPPLANE4) || defined(CLIPPLANE5) || defined(CLIPPLANE6) || defined(FOG)
vec4 worldPos=vec4(vPositionW,1.0);
#endif
#include<clipPlaneVertex>
#include<fogVertex>
#include<logDepthVertex>
#define CUSTOM_VERTEX_MAIN_END
}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$4b90ed337eee7a4c$var$name] = $4b90ed337eee7a4c$var$shader;
const $4b90ed337eee7a4c$export$a224bfcdda89ce5a = {
    name: $4b90ed337eee7a4c$var$name,
    shader: $4b90ed337eee7a4c$var$shader
};

});


parcelRegister("b2hv8", function(module, exports) {

$parcel$export(module.exports, "SubEmitterType", () => $808d74f63d298c61$export$5f399ef693937290);
$parcel$export(module.exports, "SubEmitter", () => $808d74f63d298c61$export$76f56fc382618136);

var $ha1VO = parcelRequire("ha1VO");

var $dUFYy = parcelRequire("dUFYy");

var $8DoUR = parcelRequire("8DoUR");
var $808d74f63d298c61$export$5f399ef693937290;
(function(SubEmitterType) {
    /**
     * Attached to the particle over it's lifetime
     */ SubEmitterType[SubEmitterType["ATTACHED"] = 0] = "ATTACHED";
    /**
     * Created when the particle dies
     */ SubEmitterType[SubEmitterType["END"] = 1] = "END";
})($808d74f63d298c61$export$5f399ef693937290 || ($808d74f63d298c61$export$5f399ef693937290 = {}));
class $808d74f63d298c61$export$76f56fc382618136 {
    /**
     * Creates a sub emitter
     * @param particleSystem the particle system to be used by the sub emitter
     */ constructor(/**
     * the particle system to be used by the sub emitter
     */ particleSystem){
        this.particleSystem = particleSystem;
        /**
         * Type of the submitter (Default: END)
         */ this.type = $808d74f63d298c61$export$5f399ef693937290.END;
        /**
         * If the particle should inherit the direction from the particle it's attached to. (+Y will face the direction the particle is moving) (Default: false)
         * Note: This only is supported when using an emitter of type Mesh
         */ this.inheritDirection = false;
        /**
         * How much of the attached particles speed should be added to the sub emitted particle (default: 0)
         */ this.inheritedVelocityAmount = 0;
        // Create mesh as emitter to support rotation
        if (!particleSystem.emitter || !particleSystem.emitter.dispose) {
            const internalClass = (0, $8DoUR.GetClass)("BABYLON.AbstractMesh");
            particleSystem.emitter = new internalClass("SubemitterSystemEmitter", particleSystem.getScene());
            particleSystem._disposeEmitterOnDispose = true;
        }
    }
    /**
     * Clones the sub emitter
     * @returns the cloned sub emitter
     */ clone() {
        // Clone particle system
        let emitter = this.particleSystem.emitter;
        if (!emitter) emitter = new (0, $ha1VO.Vector3)();
        else if (emitter instanceof (0, $ha1VO.Vector3)) emitter = emitter.clone();
        else if (emitter.getClassName().indexOf("Mesh") !== -1) {
            const internalClass = (0, $8DoUR.GetClass)("BABYLON.Mesh");
            emitter = new internalClass("", emitter.getScene());
            emitter.isVisible = false;
        }
        const clone = new $808d74f63d298c61$export$76f56fc382618136(this.particleSystem.clone(this.particleSystem.name, emitter));
        // Clone properties
        clone.particleSystem.name += "Clone";
        clone.type = this.type;
        clone.inheritDirection = this.inheritDirection;
        clone.inheritedVelocityAmount = this.inheritedVelocityAmount;
        clone.particleSystem._disposeEmitterOnDispose = true;
        clone.particleSystem.disposeOnStop = true;
        return clone;
    }
    /**
     * Serialize current object to a JSON object
     * @param serializeTexture defines if the texture must be serialized as well
     * @returns the serialized object
     */ serialize(serializeTexture = false) {
        const serializationObject = {};
        serializationObject.type = this.type;
        serializationObject.inheritDirection = this.inheritDirection;
        serializationObject.inheritedVelocityAmount = this.inheritedVelocityAmount;
        serializationObject.particleSystem = this.particleSystem.serialize(serializeTexture);
        return serializationObject;
    }
    /**
     * @internal
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    static _ParseParticleSystem(system, sceneOrEngine, rootUrl, doNotStart = false) {
        throw (0, $dUFYy._WarnImport)("ParseParticle");
    }
    /**
     * Creates a new SubEmitter from a serialized JSON version
     * @param serializationObject defines the JSON object to read from
     * @param sceneOrEngine defines the hosting scene or the hosting engine
     * @param rootUrl defines the rootUrl for data loading
     * @returns a new SubEmitter
     */ static Parse(serializationObject, sceneOrEngine, rootUrl) {
        const system = serializationObject.particleSystem;
        const subEmitter = new $808d74f63d298c61$export$76f56fc382618136($808d74f63d298c61$export$76f56fc382618136._ParseParticleSystem(system, sceneOrEngine, rootUrl, true));
        subEmitter.type = serializationObject.type;
        subEmitter.inheritDirection = serializationObject.inheritDirection;
        subEmitter.inheritedVelocityAmount = serializationObject.inheritedVelocityAmount;
        subEmitter.particleSystem._isSubEmitter = true;
        return subEmitter;
    }
    /** Release associated resources */ dispose() {
        this.particleSystem.dispose();
    }
}

});

parcelRegister("f1bVt", function(module, exports) {

$parcel$export(module.exports, "CreatePointEmitter", () => $aef0333f21b59b40$export$acd6bf7ecae6bc7e);
$parcel$export(module.exports, "CreateHemisphericEmitter", () => $aef0333f21b59b40$export$e69bc76cba09ff3d);
$parcel$export(module.exports, "CreateSphereEmitter", () => $aef0333f21b59b40$export$61e795761517135a);
$parcel$export(module.exports, "CreateDirectedSphereEmitter", () => $aef0333f21b59b40$export$b0232d023c232833);
$parcel$export(module.exports, "CreateCylinderEmitter", () => $aef0333f21b59b40$export$5ef0f502a087f2fc);
$parcel$export(module.exports, "CreateDirectedCylinderEmitter", () => $aef0333f21b59b40$export$fa538e6bc49a5893);
$parcel$export(module.exports, "CreateConeEmitter", () => $aef0333f21b59b40$export$4b9f1899a72f369e);

var $ha1VO = parcelRequire("ha1VO");

var $7W4Lm = parcelRequire("7W4Lm");

var $2QOeY = parcelRequire("2QOeY");

var $lqOHh = parcelRequire("lqOHh");

var $eHSuH = parcelRequire("eHSuH");

var $fRkVr = parcelRequire("fRkVr");
function $aef0333f21b59b40$export$acd6bf7ecae6bc7e(direction1, direction2) {
    const particleEmitter = new (0, $7W4Lm.PointParticleEmitter)();
    particleEmitter.direction1 = direction1;
    particleEmitter.direction2 = direction2;
    return particleEmitter;
}
function $aef0333f21b59b40$export$e69bc76cba09ff3d(radius = 1, radiusRange = 1) {
    return new (0, $2QOeY.HemisphericParticleEmitter)(radius, radiusRange);
}
function $aef0333f21b59b40$export$61e795761517135a(radius = 1, radiusRange = 1) {
    return new (0, $lqOHh.SphereParticleEmitter)(radius, radiusRange);
}
function $aef0333f21b59b40$export$b0232d023c232833(radius = 1, direction1 = new (0, $ha1VO.Vector3)(0, 1.0, 0), direction2 = new (0, $ha1VO.Vector3)(0, 1.0, 0)) {
    return new (0, $lqOHh.SphereDirectedParticleEmitter)(radius, direction1, direction2);
}
function $aef0333f21b59b40$export$5ef0f502a087f2fc(radius = 1, height = 1, radiusRange = 1, directionRandomizer = 0) {
    return new (0, $eHSuH.CylinderParticleEmitter)(radius, height, radiusRange, directionRandomizer);
}
function $aef0333f21b59b40$export$fa538e6bc49a5893(radius = 1, height = 1, radiusRange = 1, direction1 = new (0, $ha1VO.Vector3)(0, 1.0, 0), direction2 = new (0, $ha1VO.Vector3)(0, 1.0, 0)) {
    return new (0, $eHSuH.CylinderDirectedParticleEmitter)(radius, height, radiusRange, direction1, direction2);
}
function $aef0333f21b59b40$export$4b9f1899a72f369e(radius = 1, angle = Math.PI / 4) {
    return new (0, $fRkVr.ConeParticleEmitter)(radius, angle);
}

});


parcelRegister("6WKHx", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("hgF4a");
parcelRequire("jtwq6");
parcelRequire("4kipo");
parcelRequire("7Hs3g");
parcelRequire("cRFSM");
parcelRequire("hvLF9");
parcelRequire("kg1CD");
parcelRequire("izyqw");
parcelRequire("110hr");
const $50ec62bc9a1f244c$var$name = "gpuRenderParticlesPixelShader";
const $50ec62bc9a1f244c$var$shader = `precision highp float;
#ifdef LOGARITHMICDEPTH
#extension GL_EXT_frag_depth : enable
#endif
uniform sampler2D diffuseSampler;varying vec2 vUV;varying vec4 vColor;
#include<clipPlaneFragmentDeclaration2> 
#include<imageProcessingDeclaration>
#include<logDepthDeclaration>
#include<helperFunctions>
#include<imageProcessingFunctions>
#include<fogFragmentDeclaration>
void main() {
#include<clipPlaneFragment> 
vec4 textureColor=texture2D(diffuseSampler,vUV);gl_FragColor=textureColor*vColor;
#ifdef BLENDMULTIPLYMODE
float alpha=vColor.a*textureColor.a;gl_FragColor.rgb=gl_FragColor.rgb*alpha+vec3(1.0)*(1.0-alpha);
#endif 
#include<logDepthFragment>
#include<fogFragment>(color,gl_FragColor)
#ifdef IMAGEPROCESSINGPOSTPROCESS
gl_FragColor.rgb=toLinearSpace(gl_FragColor.rgb);
#else
#ifdef IMAGEPROCESSING
gl_FragColor.rgb=toLinearSpace(gl_FragColor.rgb);gl_FragColor=applyImageProcessing(gl_FragColor);
#endif
#endif
}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$50ec62bc9a1f244c$var$name] = $50ec62bc9a1f244c$var$shader;
const $50ec62bc9a1f244c$export$cba1b477700f8603 = {
    name: $50ec62bc9a1f244c$var$name,
    shader: $50ec62bc9a1f244c$var$shader
};

});
parcelRegister("hgF4a", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $c923c9318089776c$var$name = "clipPlaneFragmentDeclaration2";
const $c923c9318089776c$var$shader = `#ifdef CLIPPLANE
in float fClipDistance;
#endif
#ifdef CLIPPLANE2
in float fClipDistance2;
#endif
#ifdef CLIPPLANE3
in float fClipDistance3;
#endif
#ifdef CLIPPLANE4
in float fClipDistance4;
#endif
#ifdef CLIPPLANE5
in float fClipDistance5;
#endif
#ifdef CLIPPLANE6
in float fClipDistance6;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$c923c9318089776c$var$name] = $c923c9318089776c$var$shader;
const $c923c9318089776c$export$720434973b80e3c = {
    name: $c923c9318089776c$var$name,
    shader: $c923c9318089776c$var$shader
};

});


parcelRegister("fV2PC", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("ifsAM");
parcelRequire("bdABV");
parcelRequire("4kipo");
parcelRequire("kqCfW");
parcelRequire("1pV7g");
parcelRequire("a111f");
const $b96e603053733722$var$name = "gpuRenderParticlesVertexShader";
const $b96e603053733722$var$shader = `precision highp float;uniform mat4 view;uniform mat4 projection;uniform vec2 translationPivot;uniform vec3 worldOffset;
#ifdef LOCAL
uniform mat4 emitterWM;
#endif
attribute vec3 position;attribute float age;attribute float life;attribute vec3 size;
#ifndef BILLBOARD
attribute vec3 initialDirection;
#endif
#ifdef BILLBOARDSTRETCHED
attribute vec3 direction;
#endif
attribute float angle;
#ifdef ANIMATESHEET
attribute float cellIndex;
#endif
attribute vec2 offset;attribute vec2 uv;varying vec2 vUV;varying vec4 vColor;varying vec3 vPositionW;
#if defined(BILLBOARD) && !defined(BILLBOARDY) && !defined(BILLBOARDSTRETCHED)
uniform mat4 invView;
#endif
#include<clipPlaneVertexDeclaration2>
#include<fogVertexDeclaration>
#include<logDepthDeclaration>
#ifdef COLORGRADIENTS
uniform sampler2D colorGradientSampler;
#else
uniform vec4 colorDead;attribute vec4 color;
#endif
#ifdef ANIMATESHEET
uniform vec3 sheetInfos;
#endif
#ifdef BILLBOARD
uniform vec3 eyePosition;
#endif
vec3 rotate(vec3 yaxis,vec3 rotatedCorner) {vec3 xaxis=normalize(cross(vec3(0.,1.0,0.),yaxis));vec3 zaxis=normalize(cross(yaxis,xaxis));vec3 row0=vec3(xaxis.x,xaxis.y,xaxis.z);vec3 row1=vec3(yaxis.x,yaxis.y,yaxis.z);vec3 row2=vec3(zaxis.x,zaxis.y,zaxis.z);mat3 rotMatrix= mat3(row0,row1,row2);vec3 alignedCorner=rotMatrix*rotatedCorner;
#ifdef LOCAL
return ((emitterWM*vec4(position,1.0)).xyz+worldOffset)+alignedCorner;
#else
return (position+worldOffset)+alignedCorner;
#endif
}
#ifdef BILLBOARDSTRETCHED
vec3 rotateAlign(vec3 toCamera,vec3 rotatedCorner) {vec3 normalizedToCamera=normalize(toCamera);vec3 normalizedCrossDirToCamera=normalize(cross(normalize(direction),normalizedToCamera));vec3 crossProduct=normalize(cross(normalizedToCamera,normalizedCrossDirToCamera));vec3 row0=vec3(normalizedCrossDirToCamera.x,normalizedCrossDirToCamera.y,normalizedCrossDirToCamera.z);vec3 row1=vec3(crossProduct.x,crossProduct.y,crossProduct.z);vec3 row2=vec3(normalizedToCamera.x,normalizedToCamera.y,normalizedToCamera.z);mat3 rotMatrix= mat3(row0,row1,row2);vec3 alignedCorner=rotMatrix*rotatedCorner;
#ifdef LOCAL
return ((emitterWM*vec4(position,1.0)).xyz+worldOffset)+alignedCorner;
#else
return (position+worldOffset)+alignedCorner;
#endif
}
#endif
void main() {
#ifdef ANIMATESHEET
float rowOffset=floor(cellIndex/sheetInfos.z);float columnOffset=cellIndex-rowOffset*sheetInfos.z;vec2 uvScale=sheetInfos.xy;vec2 uvOffset=vec2(uv.x ,1.0-uv.y);vUV=(uvOffset+vec2(columnOffset,rowOffset))*uvScale;
#else
vUV=uv;
#endif
float ratio=age/life;
#ifdef COLORGRADIENTS
vColor=texture2D(colorGradientSampler,vec2(ratio,0));
#else
vColor=color*vec4(1.0-ratio)+colorDead*vec4(ratio);
#endif
vec2 cornerPos=(offset-translationPivot)*size.yz*size.x;
#ifdef BILLBOARD
vec4 rotatedCorner;rotatedCorner.w=0.;
#ifdef BILLBOARDY
rotatedCorner.x=cornerPos.x*cos(angle)-cornerPos.y*sin(angle);rotatedCorner.z=cornerPos.x*sin(angle)+cornerPos.y*cos(angle);rotatedCorner.y=0.;rotatedCorner.xz+=translationPivot;vec3 yaxis=(position+worldOffset)-eyePosition;yaxis.y=0.;vPositionW=rotate(normalize(yaxis),rotatedCorner.xyz);vec4 viewPosition=(view*vec4(vPositionW,1.0));
#elif defined(BILLBOARDSTRETCHED)
rotatedCorner.x=cornerPos.x*cos(angle)-cornerPos.y*sin(angle);rotatedCorner.y=cornerPos.x*sin(angle)+cornerPos.y*cos(angle);rotatedCorner.z=0.;rotatedCorner.xy+=translationPivot;vec3 toCamera=(position+worldOffset)-eyePosition;vPositionW=rotateAlign(toCamera,rotatedCorner.xyz);vec4 viewPosition=(view*vec4(vPositionW,1.0));
#else
rotatedCorner.x=cornerPos.x*cos(angle)-cornerPos.y*sin(angle);rotatedCorner.y=cornerPos.x*sin(angle)+cornerPos.y*cos(angle);rotatedCorner.z=0.;rotatedCorner.xy+=translationPivot;
#ifdef LOCAL
vec4 viewPosition=view*vec4(((emitterWM*vec4(position,1.0)).xyz+worldOffset),1.0)+rotatedCorner;
#else
vec4 viewPosition=view*vec4((position+worldOffset),1.0)+rotatedCorner;
#endif
vPositionW=(invView*viewPosition).xyz;
#endif
#else
vec3 rotatedCorner;rotatedCorner.x=cornerPos.x*cos(angle)-cornerPos.y*sin(angle);rotatedCorner.y=0.;rotatedCorner.z=cornerPos.x*sin(angle)+cornerPos.y*cos(angle);rotatedCorner.xz+=translationPivot;vec3 yaxis=normalize(initialDirection);vPositionW=rotate(yaxis,rotatedCorner);vec4 viewPosition=view*vec4(vPositionW,1.0);
#endif
gl_Position=projection*viewPosition;
#if defined(CLIPPLANE) || defined(CLIPPLANE2) || defined(CLIPPLANE3) || defined(CLIPPLANE4) || defined(CLIPPLANE5) || defined(CLIPPLANE6) || defined(FOG)
vec4 worldPos=vec4(vPositionW,1.0);
#endif
#include<clipPlaneVertex>
#include<fogVertex>
#include<logDepthVertex>
}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$b96e603053733722$var$name] = $b96e603053733722$var$shader;
const $b96e603053733722$export$6620fdd0adb6ffa1 = {
    name: $b96e603053733722$var$name,
    shader: $b96e603053733722$var$shader
};

});
parcelRegister("ifsAM", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $d48fce847d357ed4$var$name = "clipPlaneVertexDeclaration2";
const $d48fce847d357ed4$var$shader = `#ifdef CLIPPLANE
uniform vec4 vClipPlane;out float fClipDistance;
#endif
#ifdef CLIPPLANE2
uniform vec4 vClipPlane2;out float fClipDistance2;
#endif
#ifdef CLIPPLANE3
uniform vec4 vClipPlane3;out float fClipDistance3;
#endif
#ifdef CLIPPLANE4
uniform vec4 vClipPlane4;out float fClipDistance4;
#endif
#ifdef CLIPPLANE5
uniform vec4 vClipPlane5;out float fClipDistance5;
#endif
#ifdef CLIPPLANE6
uniform vec4 vClipPlane6;out float fClipDistance6;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$d48fce847d357ed4$var$name] = $d48fce847d357ed4$var$shader;
const $d48fce847d357ed4$export$cc7eba92d5466bfd = {
    name: $d48fce847d357ed4$var$name,
    shader: $d48fce847d357ed4$var$shader
};

});



parcelRegister("94dSH", function(module, exports) {

});

parcelRegister("8ksU7", function(module, exports) {

$parcel$export(module.exports, "ParticleHelper", () => $61069cba1d3a8ddd$export$63bc6ec2ebf7ae4f);

var $bOhSV = parcelRequire("bOhSV");

var $7etnY = parcelRequire("7etnY");

var $j2mX5 = parcelRequire("j2mX5");

var $ejQPp = parcelRequire("ejQPp");

var $d0CRN = parcelRequire("d0CRN");

var $3zhnu = parcelRequire("3zhnu");

var $hi6ss = parcelRequire("hi6ss");

var $hUzEl = parcelRequire("hUzEl");
class $61069cba1d3a8ddd$export$63bc6ec2ebf7ae4f {
    /**
     * Create a default particle system that you can tweak
     * @param emitter defines the emitter to use
     * @param capacity defines the system capacity (default is 500 particles)
     * @param scene defines the hosting scene
     * @param useGPU defines if a GPUParticleSystem must be created (default is false)
     * @returns the new Particle system
     */ static CreateDefault(emitter, capacity = 500, scene, useGPU = false) {
        let system;
        if (useGPU) system = new (0, $d0CRN.GPUParticleSystem)("default system", {
            capacity: capacity
        }, scene);
        else system = new (0, $hi6ss.ParticleSystem)("default system", capacity, scene);
        system.emitter = emitter;
        system.particleTexture = new (0, $j2mX5.Texture)("https://assets.babylonjs.com/textures/flare.png", system.getScene());
        system.createConeEmitter(0.1, Math.PI / 4);
        // Particle color
        system.color1 = new (0, $7etnY.Color4)(1.0, 1.0, 1.0, 1.0);
        system.color2 = new (0, $7etnY.Color4)(1.0, 1.0, 1.0, 1.0);
        system.colorDead = new (0, $7etnY.Color4)(1.0, 1.0, 1.0, 0.0);
        // Particle Size
        system.minSize = 0.1;
        system.maxSize = 0.1;
        // Emission speed
        system.minEmitPower = 2;
        system.maxEmitPower = 2;
        // Update speed
        system.updateSpeed = 1 / 60;
        system.emitRate = 30;
        return system;
    }
    /**
     * This is the main static method (one-liner) of this helper to create different particle systems
     * @param type This string represents the type to the particle system to create
     * @param scene The scene where the particle system should live
     * @param gpu If the system will use gpu
     * @param capacity defines the system capacity (if null or undefined the sotred capacity will be used)
     * @returns the ParticleSystemSet created
     */ static CreateAsync(type, scene, gpu = false, capacity) {
        if (!scene) scene = (0, $ejQPp.EngineStore).LastCreatedScene;
        const token = {};
        scene.addPendingData(token);
        return new Promise((resolve, reject)=>{
            if (gpu && !(0, $d0CRN.GPUParticleSystem).IsSupported) {
                scene.removePendingData(token);
                return reject("Particle system with GPU is not supported.");
            }
            (0, $bOhSV.Tools).LoadFile(`${$61069cba1d3a8ddd$export$63bc6ec2ebf7ae4f.BaseAssetsUrl}/systems/${type}.json`, (data)=>{
                scene.removePendingData(token);
                const newData = JSON.parse(data.toString());
                return resolve((0, $3zhnu.ParticleSystemSet).Parse(newData, scene, gpu, capacity));
            }, undefined, undefined, undefined, ()=>{
                scene.removePendingData(token);
                return reject(`An error occurred with the creation of your particle system. Check if your type '${type}' exists.`);
            });
        });
    }
    /**
     * Static function used to export a particle system to a ParticleSystemSet variable.
     * Please note that the emitter shape is not exported
     * @param systems defines the particle systems to export
     * @returns the created particle system set
     */ static ExportSet(systems) {
        const set = new (0, $3zhnu.ParticleSystemSet)();
        for (const system of systems)set.systems.push(system);
        return set;
    }
    /**
     * Creates a particle system from a snippet saved in a remote file
     * @param name defines the name of the particle system to create (can be null or empty to use the one from the json data)
     * @param url defines the url to load from
     * @param scene defines the hosting scene
     * @param gpu If the system will use gpu
     * @param rootUrl defines the root URL to use to load textures and relative dependencies
     * @param capacity defines the system capacity (if null or undefined the sotred capacity will be used)
     * @returns a promise that will resolve to the new particle system
     */ static ParseFromFileAsync(name, url, scene, gpu = false, rootUrl = "", capacity) {
        return new Promise((resolve, reject)=>{
            const request = new (0, $hUzEl.WebRequest)();
            request.addEventListener("readystatechange", ()=>{
                if (request.readyState == 4) {
                    if (request.status == 200) {
                        const serializationObject = JSON.parse(request.responseText);
                        let output;
                        if (gpu) output = (0, $d0CRN.GPUParticleSystem).Parse(serializationObject, scene, rootUrl, false, capacity);
                        else output = (0, $hi6ss.ParticleSystem).Parse(serializationObject, scene, rootUrl, false, capacity);
                        if (name) output.name = name;
                        resolve(output);
                    } else reject("Unable to load the particle system");
                }
            });
            request.open("GET", url);
            request.send();
        });
    }
    /**
     * Creates a particle system from a snippet saved by the particle system editor
     * @param snippetId defines the snippet to load (can be set to _BLANK to create a default one)
     * @param scene defines the hosting scene
     * @param gpu If the system will use gpu
     * @param rootUrl defines the root URL to use to load textures and relative dependencies
     * @param capacity defines the system capacity (if null or undefined the sotred capacity will be used)
     * @returns a promise that will resolve to the new particle system
     */ static ParseFromSnippetAsync(snippetId, scene, gpu = false, rootUrl = "", capacity) {
        if (snippetId === "_BLANK") {
            const system = this.CreateDefault(null);
            system.start();
            return Promise.resolve(system);
        }
        return new Promise((resolve, reject)=>{
            const request = new (0, $hUzEl.WebRequest)();
            request.addEventListener("readystatechange", ()=>{
                if (request.readyState == 4) {
                    if (request.status == 200) {
                        const snippet = JSON.parse(JSON.parse(request.responseText).jsonPayload);
                        const serializationObject = JSON.parse(snippet.particleSystem);
                        let output;
                        if (gpu) output = (0, $d0CRN.GPUParticleSystem).Parse(serializationObject, scene, rootUrl, false, capacity);
                        else output = (0, $hi6ss.ParticleSystem).Parse(serializationObject, scene, rootUrl, false, capacity);
                        output.snippetId = snippetId;
                        resolve(output);
                    } else reject("Unable to load the snippet " + snippetId);
                }
            });
            request.open("GET", this.SnippetUrl + "/" + snippetId.replace(/#/g, "/"));
            request.send();
        });
    }
}
/**
 * Gets or sets base Assets URL
 */ $61069cba1d3a8ddd$export$63bc6ec2ebf7ae4f.BaseAssetsUrl = (0, $3zhnu.ParticleSystemSet).BaseAssetsUrl;
/** Define the Url to load snippets */ $61069cba1d3a8ddd$export$63bc6ec2ebf7ae4f.SnippetUrl = `https://snippet.babylonjs.com`;
/**
 * Creates a particle system from a snippet saved by the particle system editor
 * @deprecated Please use ParseFromSnippetAsync instead
 * @param snippetId defines the snippet to load (can be set to _BLANK to create a default one)
 * @param scene defines the hosting scene
 * @param gpu If the system will use gpu
 * @param rootUrl defines the root URL to use to load textures and relative dependencies
 * @param capacity defines the system capacity (if null or undefined the sotred capacity will be used)
 * @returns a promise that will resolve to the new particle system
 */ $61069cba1d3a8ddd$export$63bc6ec2ebf7ae4f.CreateFromSnippetAsync = $61069cba1d3a8ddd$export$63bc6ec2ebf7ae4f.ParseFromSnippetAsync;

});
parcelRegister("3zhnu", function(module, exports) {

$parcel$export(module.exports, "ParticleSystemSet", () => $29921ed902c96db6$export$13acc3202f4c919a);

var $7etnY = parcelRequire("7etnY");

var $8KqOo = parcelRequire("8KqOo");

var $d0CRN = parcelRequire("d0CRN");

var $ejQPp = parcelRequire("ejQPp");

var $hi6ss = parcelRequire("hi6ss");

var $gAH3H = parcelRequire("gAH3H");
/** Internal class used to store shapes for emitters */ class $29921ed902c96db6$var$ParticleSystemSetEmitterCreationOptions {
}
class $29921ed902c96db6$export$13acc3202f4c919a {
    constructor(){
        this._emitterNodeIsOwned = true;
        /**
         * Gets the particle system list
         */ this.systems = [];
    }
    /**
     * Gets or sets the emitter node used with this set
     */ get emitterNode() {
        return this._emitterNode;
    }
    set emitterNode(value) {
        if (this._emitterNodeIsOwned && this._emitterNode) {
            if (this._emitterNode.dispose) this._emitterNode.dispose();
            this._emitterNodeIsOwned = false;
        }
        for (const system of this.systems)system.emitter = value;
        this._emitterNode = value;
    }
    /**
     * Creates a new emitter mesh as a sphere
     * @param options defines the options used to create the sphere
     * @param options.diameter
     * @param options.segments
     * @param options.color
     * @param renderingGroupId defines the renderingGroupId to use for the sphere
     * @param scene defines the hosting scene
     */ setEmitterAsSphere(options, renderingGroupId, scene) {
        if (this._emitterNodeIsOwned && this._emitterNode) {
            if (this._emitterNode.dispose) this._emitterNode.dispose();
        }
        this._emitterNodeIsOwned = true;
        this._emitterCreationOptions = {
            kind: "Sphere",
            options: options,
            renderingGroupId: renderingGroupId
        };
        const emitterMesh = (0, $8KqOo.CreateSphere)("emitterSphere", {
            diameter: options.diameter,
            segments: options.segments
        }, scene);
        emitterMesh.renderingGroupId = renderingGroupId;
        const material = new (0, $gAH3H.StandardMaterial)("emitterSphereMaterial", scene);
        material.emissiveColor = options.color;
        emitterMesh.material = material;
        for (const system of this.systems)system.emitter = emitterMesh;
        this._emitterNode = emitterMesh;
    }
    /**
     * Starts all particle systems of the set
     * @param emitter defines an optional mesh to use as emitter for the particle systems
     */ start(emitter) {
        for (const system of this.systems){
            if (emitter) system.emitter = emitter;
            system.start();
        }
    }
    /**
     * Release all associated resources
     */ dispose() {
        for (const system of this.systems)system.dispose();
        this.systems.length = 0;
        if (this._emitterNode) {
            if (this._emitterNode.dispose) this._emitterNode.dispose();
            this._emitterNode = null;
        }
    }
    /**
     * Serialize the set into a JSON compatible object
     * @param serializeTexture defines if the texture must be serialized as well
     * @returns a JSON compatible representation of the set
     */ serialize(serializeTexture = false) {
        const result = {};
        result.systems = [];
        for (const system of this.systems)result.systems.push(system.serialize(serializeTexture));
        if (this._emitterNode) result.emitter = this._emitterCreationOptions;
        return result;
    }
    /**
     * Parse a new ParticleSystemSet from a serialized source
     * @param data defines a JSON compatible representation of the set
     * @param scene defines the hosting scene
     * @param gpu defines if we want GPU particles or CPU particles
     * @param capacity defines the system capacity (if null or undefined the sotred capacity will be used)
     * @returns a new ParticleSystemSet
     */ static Parse(data, scene, gpu = false, capacity) {
        const result = new $29921ed902c96db6$export$13acc3202f4c919a();
        const rootUrl = this.BaseAssetsUrl + "/textures/";
        scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        for (const system of data.systems)result.systems.push(gpu ? (0, $d0CRN.GPUParticleSystem).Parse(system, scene, rootUrl, true, capacity) : (0, $hi6ss.ParticleSystem).Parse(system, scene, rootUrl, true, capacity));
        if (data.emitter) {
            const options = data.emitter.options;
            switch(data.emitter.kind){
                case "Sphere":
                    result.setEmitterAsSphere({
                        diameter: options.diameter,
                        segments: options.segments,
                        color: (0, $7etnY.Color3).FromArray(options.color)
                    }, data.emitter.renderingGroupId, scene);
                    break;
            }
        }
        return result;
    }
}
/**
 * Gets or sets base Assets URL
 */ $29921ed902c96db6$export$13acc3202f4c919a.BaseAssetsUrl = "https://assets.babylonjs.com/particles";

});


parcelRegister("9VY7N", function(module, exports) {

var $fbuqw = parcelRequire("fbuqw");

var $d0CRN = parcelRequire("d0CRN");

var $5Tqba = parcelRequire("5Tqba");

var $5YkyR = parcelRequire("5YkyR");

var $hi6ss = parcelRequire("hi6ss");

var $bv05l = parcelRequire("bv05l");
parcelRequire("6ueFN");
// Adds the parsers to the scene parsers.
(0, $5Tqba.AbstractScene).AddParser((0, $bv05l.SceneComponentConstants).NAME_PARTICLESYSTEM, (parsedData, scene, container, rootUrl)=>{
    const individualParser = (0, $5Tqba.AbstractScene).GetIndividualParser((0, $bv05l.SceneComponentConstants).NAME_PARTICLESYSTEM);
    if (!individualParser) return;
    // Particles Systems
    if (parsedData.particleSystems !== undefined && parsedData.particleSystems !== null) for(let index = 0, cache = parsedData.particleSystems.length; index < cache; index++){
        const parsedParticleSystem = parsedData.particleSystems[index];
        container.particleSystems.push(individualParser(parsedParticleSystem, scene, rootUrl));
    }
});
(0, $5Tqba.AbstractScene).AddIndividualParser((0, $bv05l.SceneComponentConstants).NAME_PARTICLESYSTEM, (parsedParticleSystem, scene, rootUrl)=>{
    if (parsedParticleSystem.activeParticleCount) {
        const ps = (0, $d0CRN.GPUParticleSystem).Parse(parsedParticleSystem, scene, rootUrl);
        return ps;
    } else {
        const ps = (0, $hi6ss.ParticleSystem).Parse(parsedParticleSystem, scene, rootUrl);
        return ps;
    }
});
(0, $5YkyR.Engine).prototype.createEffectForParticles = function(fragmentName, uniformsNames = [], samplers = [], defines = "", fallbacks, onCompiled, onError, particleSystem) {
    let attributesNamesOrOptions = [];
    let effectCreationOption = [];
    const allSamplers = [];
    if (particleSystem) particleSystem.fillUniformsAttributesAndSamplerNames(effectCreationOption, attributesNamesOrOptions, allSamplers);
    else {
        attributesNamesOrOptions = (0, $hi6ss.ParticleSystem)._GetAttributeNamesOrOptions();
        effectCreationOption = (0, $hi6ss.ParticleSystem)._GetEffectCreationOptions();
    }
    if (defines.indexOf(" BILLBOARD") === -1) defines += "\n#define BILLBOARD\n";
    if (particleSystem?.isAnimationSheetEnabled) {
        if (defines.indexOf(" ANIMATESHEET") === -1) defines += "\n#define ANIMATESHEET\n";
    }
    if (samplers.indexOf("diffuseSampler") === -1) samplers.push("diffuseSampler");
    return this.createEffect({
        vertex: particleSystem?.vertexShaderName ?? "particles",
        fragmentElement: fragmentName
    }, attributesNamesOrOptions, effectCreationOption.concat(uniformsNames), allSamplers.concat(samplers), defines, fallbacks, onCompiled, onError);
};
(0, $fbuqw.Mesh).prototype.getEmittedParticleSystems = function() {
    const results = [];
    for(let index = 0; index < this.getScene().particleSystems.length; index++){
        const particleSystem = this.getScene().particleSystems[index];
        if (particleSystem.emitter === this) results.push(particleSystem);
    }
    return results;
};
(0, $fbuqw.Mesh).prototype.getHierarchyEmittedParticleSystems = function() {
    const results = [];
    const descendants = this.getDescendants();
    descendants.push(this);
    for(let index = 0; index < this.getScene().particleSystems.length; index++){
        const particleSystem = this.getScene().particleSystems[index];
        const emitter = particleSystem.emitter;
        if (emitter.position && descendants.indexOf(emitter) !== -1) results.push(particleSystem);
    }
    return results;
};

});

parcelRegister("8Qyhp", function(module, exports) {

$parcel$export(module.exports, "SolidParticle", () => $670dc54ba4966203$export$f36390ec6f04fb40);
$parcel$export(module.exports, "ModelShape", () => $670dc54ba4966203$export$386945e3273b8a6d);
$parcel$export(module.exports, "DepthSortedParticle", () => $670dc54ba4966203$export$dc4079ae9b984432);
$parcel$export(module.exports, "SolidParticleVertex", () => $670dc54ba4966203$export$821df4da317250ad);

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $ef012 = parcelRequire("ef012");

var $aC4Bv = parcelRequire("aC4Bv");

var $0cHNL = parcelRequire("0cHNL");
class $670dc54ba4966203$export$f36390ec6f04fb40 {
    /**
     * Particle BoundingInfo object
     * @returns a BoundingInfo
     */ getBoundingInfo() {
        return this._boundingInfo;
    }
    /**
     * Returns true if there is already a bounding info
     */ get hasBoundingInfo() {
        return this._boundingInfo !== null;
    }
    /**
     * Creates a Solid Particle object.
     * Don't create particles manually, use instead the Solid Particle System internal tools like _addParticle()
     * @param particleIndex (integer) is the particle index in the Solid Particle System pool.
     * @param particleId (integer) is the particle identifier. Unless some particles are removed from the SPS, it's the same value than the particle idx.
     * @param positionIndex (integer) is the starting index of the particle vertices in the SPS "positions" array.
     * @param indiceIndex (integer) is the starting index of the particle indices in the SPS "indices" array.
     * @param model (ModelShape) is a reference to the model shape on what the particle is designed.
     * @param shapeId (integer) is the model shape identifier in the SPS.
     * @param idxInShape (integer) is the index of the particle in the current model (ex: the 10th box of addShape(box, 30))
     * @param sps defines the sps it is associated to
     * @param modelBoundingInfo is the reference to the model BoundingInfo used for intersection computations.
     * @param materialIndex is the particle material identifier (integer) when the MultiMaterials are enabled in the SPS.
     */ constructor(particleIndex, particleId, positionIndex, indiceIndex, model, shapeId, idxInShape, sps, modelBoundingInfo = null, materialIndex = null){
        /**
         * particle global index
         */ this.idx = 0;
        /**
         * particle identifier
         */ this.id = 0;
        /**
         * The color of the particle
         */ this.color = new (0, $7etnY.Color4)(1.0, 1.0, 1.0, 1.0);
        /**
         * The world space position of the particle.
         */ this.position = (0, $ha1VO.Vector3).Zero();
        /**
         * The world space rotation of the particle. (Not use if rotationQuaternion is set)
         */ this.rotation = (0, $ha1VO.Vector3).Zero();
        /**
         * The scaling of the particle.
         */ this.scaling = (0, $ha1VO.Vector3).One();
        /**
         * The uvs of the particle.
         */ this.uvs = new (0, $ha1VO.Vector4)(0.0, 0.0, 1.0, 1.0);
        /**
         * The current speed of the particle.
         */ this.velocity = (0, $ha1VO.Vector3).Zero();
        /**
         * The pivot point in the particle local space.
         */ this.pivot = (0, $ha1VO.Vector3).Zero();
        /**
         * Must the particle be translated from its pivot point in its local space ?
         * In this case, the pivot point is set at the origin of the particle local space and the particle is translated.
         * Default : false
         */ this.translateFromPivot = false;
        /**
         * Is the particle active or not ?
         */ this.alive = true;
        /**
         * Is the particle visible or not ?
         */ this.isVisible = true;
        /**
         * Index of this particle in the global "positions" array (Internal use)
         * @internal
         */ this._pos = 0;
        /**
         * @internal Index of this particle in the global "indices" array (Internal use)
         */ this._ind = 0;
        /**
         * ModelShape id of this particle
         */ this.shapeId = 0;
        /**
         * Index of the particle in its shape id
         */ this.idxInShape = 0;
        /**
         * @internal Still set as invisible in order to skip useless computations (Internal use)
         */ this._stillInvisible = false;
        /**
         * @internal Last computed particle rotation matrix
         */ this._rotationMatrix = [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0,
            1.0
        ];
        /**
         * Parent particle Id, if any.
         * Default null.
         */ this.parentId = null;
        /**
         * The particle material identifier (integer) when MultiMaterials are enabled in the SPS.
         */ this.materialIndex = null;
        /**
         * Custom object or properties.
         */ this.props = null;
        /**
         * The culling strategy to use to check whether the solid particle must be culled or not when using isInFrustum().
         * The possible values are :
         * - AbstractMesh.CULLINGSTRATEGY_STANDARD
         * - AbstractMesh.CULLINGSTRATEGY_BOUNDINGSPHERE_ONLY
         * - AbstractMesh.CULLINGSTRATEGY_OPTIMISTIC_INCLUSION
         * - AbstractMesh.CULLINGSTRATEGY_OPTIMISTIC_INCLUSION_THEN_BSPHERE_ONLY
         * The default value for solid particles is AbstractMesh.CULLINGSTRATEGY_BOUNDINGSPHERE_ONLY
         * Please read each static variable documentation in the class AbstractMesh to get details about the culling process.
         * */ this.cullingStrategy = (0, $0cHNL.AbstractMesh).CULLINGSTRATEGY_BOUNDINGSPHERE_ONLY;
        /**
         * @internal Internal global position in the SPS.
         */ this._globalPosition = (0, $ha1VO.Vector3).Zero();
        this.idx = particleIndex;
        this.id = particleId;
        this._pos = positionIndex;
        this._ind = indiceIndex;
        this._model = model;
        this.shapeId = shapeId;
        this.idxInShape = idxInShape;
        this._sps = sps;
        if (modelBoundingInfo) {
            this._modelBoundingInfo = modelBoundingInfo;
            this._boundingInfo = new (0, $ef012.BoundingInfo)(modelBoundingInfo.minimum, modelBoundingInfo.maximum);
        }
        if (materialIndex !== null) this.materialIndex = materialIndex;
    }
    /**
     * Copies the particle property values into the existing target : position, rotation, scaling, uvs, colors, pivot, parent, visibility, alive
     * @param target the particle target
     * @returns the current particle
     */ copyToRef(target) {
        target.position.copyFrom(this.position);
        target.rotation.copyFrom(this.rotation);
        if (this.rotationQuaternion) {
            if (target.rotationQuaternion) target.rotationQuaternion.copyFrom(this.rotationQuaternion);
            else target.rotationQuaternion = this.rotationQuaternion.clone();
        }
        target.scaling.copyFrom(this.scaling);
        if (this.color) {
            if (target.color) target.color.copyFrom(this.color);
            else target.color = this.color.clone();
        }
        target.uvs.copyFrom(this.uvs);
        target.velocity.copyFrom(this.velocity);
        target.pivot.copyFrom(this.pivot);
        target.translateFromPivot = this.translateFromPivot;
        target.alive = this.alive;
        target.isVisible = this.isVisible;
        target.parentId = this.parentId;
        target.cullingStrategy = this.cullingStrategy;
        if (this.materialIndex !== null) target.materialIndex = this.materialIndex;
        return this;
    }
    /**
     * Legacy support, changed scale to scaling
     */ get scale() {
        return this.scaling;
    }
    /**
     * Legacy support, changed scale to scaling
     */ set scale(scale) {
        this.scaling = scale;
    }
    /**
     * Legacy support, changed quaternion to rotationQuaternion
     */ get quaternion() {
        return this.rotationQuaternion;
    }
    /**
     * Legacy support, changed quaternion to rotationQuaternion
     */ set quaternion(q) {
        this.rotationQuaternion = q;
    }
    /**
     * Returns a boolean. True if the particle intersects another particle or another mesh, else false.
     * The intersection is computed on the particle bounding sphere and Axis Aligned Bounding Box (AABB)
     * @param target is the object (solid particle or mesh) what the intersection is computed against.
     * @returns true if it intersects
     */ intersectsMesh(target) {
        if (!this._boundingInfo || !target.hasBoundingInfo) return false;
        if (this._sps._bSphereOnly) return (0, $aC4Bv.BoundingSphere).Intersects(this._boundingInfo.boundingSphere, target.getBoundingInfo().boundingSphere);
        return this._boundingInfo.intersects(target.getBoundingInfo(), false);
    }
    /**
     * Returns `true` if the solid particle is within the frustum defined by the passed array of planes.
     * A particle is in the frustum if its bounding box intersects the frustum
     * @param frustumPlanes defines the frustum to test
     * @returns true if the particle is in the frustum planes
     */ isInFrustum(frustumPlanes) {
        return this._boundingInfo !== null && this._boundingInfo.isInFrustum(frustumPlanes, this.cullingStrategy);
    }
    /**
     * get the rotation matrix of the particle
     * @internal
     */ getRotationMatrix(m) {
        let quaternion;
        if (this.rotationQuaternion) quaternion = this.rotationQuaternion;
        else {
            quaternion = (0, $ha1VO.TmpVectors).Quaternion[0];
            const rotation = this.rotation;
            (0, $ha1VO.Quaternion).RotationYawPitchRollToRef(rotation.y, rotation.x, rotation.z, quaternion);
        }
        quaternion.toRotationMatrix(m);
    }
}
class $670dc54ba4966203$export$386945e3273b8a6d {
    /**
     * Get or set the shapeId
     * @deprecated Please use shapeId instead
     */ get shapeID() {
        return this.shapeId;
    }
    set shapeID(shapeID) {
        this.shapeId = shapeID;
    }
    /**
     * Creates a ModelShape object. This is an internal simplified reference to a mesh used as for a model to replicate particles from by the SPS.
     * SPS internal tool, don't use it manually.
     * @internal
     */ constructor(id, shape, indices, normals, colors, shapeUV, posFunction, vtxFunction, material){
        /**
         * length of the shape in the model indices array (internal use)
         * @internal
         */ this._indicesLength = 0;
        this.shapeId = id;
        this._shape = shape;
        this._indices = indices;
        this._indicesLength = indices.length;
        this._shapeUV = shapeUV;
        this._shapeColors = colors;
        this._normals = normals;
        this._positionFunction = posFunction;
        this._vertexFunction = vtxFunction;
        this._material = material;
    }
}
class $670dc54ba4966203$export$dc4079ae9b984432 {
    /**
     * Creates a new sorted particle
     * @param idx
     * @param ind
     * @param indLength
     * @param materialIndex
     */ constructor(idx, ind, indLength, materialIndex){
        /**
         * Particle index
         */ this.idx = 0;
        /**
         * Index of the particle in the "indices" array
         */ this.ind = 0;
        /**
         * Length of the particle shape in the "indices" array
         */ this.indicesLength = 0;
        /**
         * Squared distance from the particle to the camera
         */ this.sqDistance = 0.0;
        /**
         * Material index when used with MultiMaterials
         */ this.materialIndex = 0;
        this.idx = idx;
        this.ind = ind;
        this.indicesLength = indLength;
        this.materialIndex = materialIndex;
    }
}
class $670dc54ba4966203$export$821df4da317250ad {
    /**
     * Creates a new solid particle vertex
     */ constructor(){
        this.position = (0, $ha1VO.Vector3).Zero();
        this.color = new (0, $7etnY.Color4)(1.0, 1.0, 1.0, 1.0);
        this.uv = (0, $ha1VO.Vector2).Zero();
    }
    // Getters and Setters for back-compatibility
    /** Vertex x coordinate */ get x() {
        return this.position.x;
    }
    set x(val) {
        this.position.x = val;
    }
    /** Vertex y coordinate */ get y() {
        return this.position.y;
    }
    set y(val) {
        this.position.y = val;
    }
    /** Vertex z coordinate */ get z() {
        return this.position.z;
    }
    set z(val) {
        this.position.z = val;
    }
}

});

parcelRegister("2PQbT", function(module, exports) {

$parcel$export(module.exports, "SolidParticleSystem", () => $2108d43191c7f702$export$618bf34fead51b31);

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $b4i1f = parcelRequire("b4i1f");

var $5v6ry = parcelRequire("5v6ry");

var $fbuqw = parcelRequire("fbuqw");

var $fWMvm = parcelRequire("fWMvm");

var $ejQPp = parcelRequire("ejQPp");

var $8Qyhp = parcelRequire("8Qyhp");

var $ef012 = parcelRequire("ef012");

var $dbxbu = parcelRequire("dbxbu");

var $lEBSs = parcelRequire("lEBSs");

var $gAH3H = parcelRequire("gAH3H");

var $3zFLd = parcelRequire("3zFLd");
class $2108d43191c7f702$export$618bf34fead51b31 {
    /**
     * Creates a SPS (Solid Particle System) object.
     * @param name (String) is the SPS name, this will be the underlying mesh name.
     * @param scene (Scene) is the scene in which the SPS is added.
     * @param options defines the options of the sps e.g.
     * * updatable (optional boolean, default true) : if the SPS must be updatable or immutable.
     * * isPickable (optional boolean, default false) : if the solid particles must be pickable.
     * * enableDepthSort (optional boolean, default false) : if the solid particles must be sorted in the geometry according to their distance to the camera.
     * * useModelMaterial (optional boolean, default false) : if the model materials must be used to create the SPS multimaterial. This enables the multimaterial supports of the SPS.
     * * enableMultiMaterial (optional boolean, default false) : if the solid particles can be given different materials.
     * * expandable (optional boolean, default false) : if particles can still be added after the initial SPS mesh creation.
     * * particleIntersection (optional boolean, default false) : if the solid particle intersections must be computed.
     * * boundingSphereOnly (optional boolean, default false) : if the particle intersection must be computed only with the bounding sphere (no bounding box computation, so faster).
     * * bSphereRadiusFactor (optional float, default 1.0) : a number to multiply the bounding sphere radius by in order to reduce it for instance.
     * * computeBoundingBox (optional boolean, default false): if the bounding box of the entire SPS will be computed (for occlusion detection, for example). If it is false, the bounding box will be the bounding box of the first particle.
     * * autoFixFaceOrientation (optional boolean, default false): if the particle face orientations will be flipped for transformations that change orientation (scale (-1, 1, 1), for example)
     * @param options.updatable
     * @param options.isPickable
     * @param options.enableDepthSort
     * @param options.particleIntersection
     * @param options.boundingSphereOnly
     * @param options.bSphereRadiusFactor
     * @param options.expandable
     * @param options.useModelMaterial
     * @param options.enableMultiMaterial
     * @param options.computeBoundingBox
     * @param options.autoFixFaceOrientation
     * @example bSphereRadiusFactor = 1.0 / Math.sqrt(3.0) => the bounding sphere exactly matches a spherical mesh.
     */ constructor(name, scene, options){
        /**
         *  The SPS array of Solid Particle objects. Just access each particle as with any classic array.
         *  Example : var p = SPS.particles[i];
         */ this.particles = new Array();
        /**
         * The SPS total number of particles. Read only. Use SPS.counter instead if you need to set your own value.
         */ this.nbParticles = 0;
        /**
         * If the particles must ever face the camera (default false). Useful for planar particles.
         */ this.billboard = false;
        /**
         * Recompute normals when adding a shape
         */ this.recomputeNormals = false;
        /**
         * This a counter ofr your own usage. It's not set by any SPS functions.
         */ this.counter = 0;
        /**
         * This empty object is intended to store some SPS specific or temporary values in order to lower the Garbage Collector activity.
         * Please read : https://doc.babylonjs.com/features/featuresDeepDive/particles/solid_particle_system/optimize_sps#limit-garbage-collection
         */ this.vars = {};
        /**
         * If the particle intersection must be computed only with the bounding sphere (no bounding box computation, so faster). (Internal use only)
         * @internal
         */ this._bSphereOnly = false;
        /**
         * A number to multiply the bounding sphere radius by in order to reduce it for instance. (Internal use only)
         * @internal
         */ this._bSphereRadiusFactor = 1.0;
        this._positions = new Array();
        this._indices = new Array();
        this._normals = new Array();
        this._colors = new Array();
        this._uvs = new Array();
        this._index = 0; // indices index
        this._updatable = true;
        this._pickable = false;
        this._isVisibilityBoxLocked = false;
        this._alwaysVisible = false;
        this._depthSort = false;
        this._expandable = false;
        this._shapeCounter = 0;
        this._copy = new (0, $8Qyhp.SolidParticle)(0, 0, 0, 0, null, 0, 0, this);
        this._color = new (0, $7etnY.Color4)(0, 0, 0, 0);
        this._computeParticleColor = true;
        this._computeParticleTexture = true;
        this._computeParticleRotation = true;
        this._computeParticleVertex = false;
        this._computeBoundingBox = false;
        this._autoFixFaceOrientation = false;
        this._depthSortParticles = true;
        this._mustUnrotateFixedNormals = false;
        this._particlesIntersect = false;
        this._needs32Bits = false;
        this._isNotBuilt = true;
        this._lastParticleId = 0;
        this._idxOfId = []; // array : key = particle.id / value = particle.idx
        this._multimaterialEnabled = false;
        this._useModelMaterial = false;
        this._depthSortFunction = (p1, p2)=>p2.sqDistance - p1.sqDistance;
        this._materialSortFunction = (p1, p2)=>p1.materialIndex - p2.materialIndex;
        this._autoUpdateSubMeshes = false;
        this._recomputeInvisibles = false;
        this.name = name;
        this._scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        this._camera = scene.activeCamera;
        this._pickable = options ? options.isPickable : false;
        this._depthSort = options ? options.enableDepthSort : false;
        this._multimaterialEnabled = options ? options.enableMultiMaterial : false;
        this._useModelMaterial = options ? options.useModelMaterial : false;
        this._multimaterialEnabled = this._useModelMaterial ? true : this._multimaterialEnabled;
        this._expandable = options ? options.expandable : false;
        this._particlesIntersect = options ? options.particleIntersection : false;
        this._bSphereOnly = options ? options.boundingSphereOnly : false;
        this._bSphereRadiusFactor = options && options.bSphereRadiusFactor ? options.bSphereRadiusFactor : 1.0;
        this._computeBoundingBox = options?.computeBoundingBox ? options.computeBoundingBox : false;
        this._autoFixFaceOrientation = options?.autoFixFaceOrientation ? options.autoFixFaceOrientation : false;
        if (options && options.updatable !== undefined) this._updatable = options.updatable;
        else this._updatable = true;
        if (this._pickable) {
            this.pickedBySubMesh = [
                []
            ];
            this.pickedParticles = this.pickedBySubMesh[0];
        }
        if (this._depthSort || this._multimaterialEnabled) this.depthSortedParticles = [];
        if (this._multimaterialEnabled) {
            this._multimaterial = new (0, $3zFLd.MultiMaterial)(this.name + "MultiMaterial", this._scene);
            this._materials = [];
            this._materialIndexesById = {};
        }
        this._tmpVertex = new (0, $8Qyhp.SolidParticleVertex)();
    }
    /**
     * Builds the SPS underlying mesh. Returns a standard Mesh.
     * If no model shape was added to the SPS, the returned mesh is just a single triangular plane.
     * @returns the created mesh
     */ buildMesh() {
        if (!this._isNotBuilt && this.mesh) return this.mesh;
        if (this.nbParticles === 0 && !this.mesh) {
            const triangle = (0, $fWMvm.CreateDisc)("", {
                radius: 1,
                tessellation: 3
            }, this._scene);
            this.addShape(triangle, 1);
            triangle.dispose();
        }
        this._indices32 = this._needs32Bits ? new Uint32Array(this._indices) : new Uint16Array(this._indices);
        this._positions32 = new Float32Array(this._positions);
        this._uvs32 = new Float32Array(this._uvs);
        this._colors32 = new Float32Array(this._colors);
        if (!this.mesh) {
            // in case it's already expanded
            const mesh = new (0, $fbuqw.Mesh)(this.name, this._scene);
            this.mesh = mesh;
        }
        if (!this._updatable && this._multimaterialEnabled) this._sortParticlesByMaterial(); // this may reorder the indices32
        if (this.recomputeNormals) (0, $5v6ry.VertexData).ComputeNormals(this._positions32, this._indices32, this._normals);
        this._normals32 = new Float32Array(this._normals);
        this._fixedNormal32 = new Float32Array(this._normals);
        if (this._mustUnrotateFixedNormals) // the particles could be created already rotated in the mesh with a positionFunction
        this._unrotateFixedNormals();
        const vertexData = new (0, $5v6ry.VertexData)();
        vertexData.indices = this._depthSort ? this._indices : this._indices32;
        vertexData.set(this._positions32, (0, $b4i1f.VertexBuffer).PositionKind);
        vertexData.set(this._normals32, (0, $b4i1f.VertexBuffer).NormalKind);
        if (this._uvs32.length > 0) vertexData.set(this._uvs32, (0, $b4i1f.VertexBuffer).UVKind);
        if (this._colors32.length > 0) vertexData.set(this._colors32, (0, $b4i1f.VertexBuffer).ColorKind);
        vertexData.applyToMesh(this.mesh, this._updatable);
        this.mesh.isPickable = this._pickable;
        if (this._pickable) {
            let faceId = 0;
            for(let p = 0; p < this.nbParticles; p++){
                const part = this.particles[p];
                const lind = part._model._indicesLength;
                for(let i = 0; i < lind; i++){
                    const f = i % 3;
                    if (f == 0) {
                        const pickedData = {
                            idx: part.idx,
                            faceId: faceId
                        };
                        this.pickedParticles[faceId] = pickedData;
                        faceId++;
                    }
                }
            }
        }
        if (this._multimaterialEnabled) this.setMultiMaterial(this._materials);
        if (!this._expandable) {
            // free memory
            if (!this._depthSort && !this._multimaterialEnabled && !this._autoFixFaceOrientation) this._indices = null;
            this._positions = null;
            this._normals = null;
            this._uvs = null;
            this._colors = null;
            if (!this._updatable) this.particles.length = 0;
        }
        this._isNotBuilt = false;
        this.recomputeNormals = false;
        this._recomputeInvisibles = true;
        return this.mesh;
    }
    _getUVKind(mesh, uvKind) {
        if (uvKind === -1) {
            if (mesh.material?.diffuseTexture) uvKind = mesh.material.diffuseTexture.coordinatesIndex;
            else if (mesh.material?.albedoTexture) uvKind = mesh.material.albedoTexture.coordinatesIndex;
        }
        return "uv" + (uvKind ? uvKind + 1 : "");
    }
    /**
     * Digests the mesh and generates as many solid particles in the system as wanted. Returns the SPS.
     * These particles will have the same geometry than the mesh parts and will be positioned at the same localisation than the mesh original places.
     * Thus the particles generated from `digest()` have their property `position` set yet.
     * @param mesh ( Mesh ) is the mesh to be digested
     * @param options {facetNb} (optional integer, default 1) is the number of mesh facets per particle, this parameter is overridden by the parameter `number` if any
     * {delta} (optional integer, default 0) is the random extra number of facets per particle , each particle will have between `facetNb` and `facetNb + delta` facets
     * {number} (optional positive integer) is the wanted number of particles : each particle is built with `mesh_total_facets / number` facets
     * {storage} (optional existing array) is an array where the particles will be stored for a further use instead of being inserted in the SPS.
     * {uvKind} (optional positive integer, default 0) is the kind of UV to read from. Use -1 to deduce it from the diffuse/albedo texture (if any) of the mesh material
     * @param options.facetNb
     * @param options.number
     * @param options.delta
     * @param options.storage
     * @param options.uvKind
     * @returns the current SPS
     */ digest(mesh, options) {
        let size = options && options.facetNb || 1;
        let number = options && options.number || 0;
        let delta = options && options.delta || 0;
        const meshPos = mesh.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        const meshInd = mesh.getIndices();
        const meshUV = mesh.getVerticesData(this._getUVKind(mesh, options?.uvKind ?? 0));
        const meshCol = mesh.getVerticesData((0, $b4i1f.VertexBuffer).ColorKind);
        const meshNor = mesh.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind);
        const storage = options && options.storage ? options.storage : null;
        let f = 0; // facet counter
        const totalFacets = meshInd.length / 3; // a facet is a triangle, so 3 indices
        // compute size from number
        if (number) {
            number = number > totalFacets ? totalFacets : number;
            size = Math.round(totalFacets / number);
            delta = 0;
        } else size = size > totalFacets ? totalFacets : size;
        const facetPos = []; // submesh positions
        const facetNor = [];
        const facetInd = []; // submesh indices
        const facetUV = []; // submesh UV
        const facetCol = []; // submesh colors
        const barycenter = (0, $ha1VO.Vector3).Zero();
        const sizeO = size;
        while(f < totalFacets){
            size = sizeO + Math.floor((1 + delta) * Math.random());
            if (f > totalFacets - size) size = totalFacets - f;
            // reset temp arrays
            facetPos.length = 0;
            facetNor.length = 0;
            facetInd.length = 0;
            facetUV.length = 0;
            facetCol.length = 0;
            // iterate over "size" facets
            let fi = 0;
            for(let j = f * 3; j < (f + size) * 3; j++){
                facetInd.push(fi);
                const i = meshInd[j];
                const i3 = i * 3;
                facetPos.push(meshPos[i3], meshPos[i3 + 1], meshPos[i3 + 2]);
                facetNor.push(meshNor[i3], meshNor[i3 + 1], meshNor[i3 + 2]);
                if (meshUV) {
                    const i2 = i * 2;
                    facetUV.push(meshUV[i2], meshUV[i2 + 1]);
                }
                if (meshCol) {
                    const i4 = i * 4;
                    facetCol.push(meshCol[i4], meshCol[i4 + 1], meshCol[i4 + 2], meshCol[i4 + 3]);
                }
                fi++;
            }
            // create a model shape for each single particle
            let idx = this.nbParticles;
            const shape = this._posToShape(facetPos);
            const shapeUV = this._uvsToShapeUV(facetUV);
            const shapeInd = facetInd.slice();
            const shapeCol = facetCol.slice();
            const shapeNor = facetNor.slice();
            // compute the barycenter of the shape
            barycenter.copyFromFloats(0, 0, 0);
            let v;
            for(v = 0; v < shape.length; v++)barycenter.addInPlace(shape[v]);
            barycenter.scaleInPlace(1 / shape.length);
            // shift the shape from its barycenter to the origin
            // and compute the BBox required for intersection.
            const minimum = new (0, $ha1VO.Vector3)(Infinity, Infinity, Infinity);
            const maximum = new (0, $ha1VO.Vector3)(-Infinity, -Infinity, -Infinity);
            for(v = 0; v < shape.length; v++){
                shape[v].subtractInPlace(barycenter);
                minimum.minimizeInPlaceFromFloats(shape[v].x, shape[v].y, shape[v].z);
                maximum.maximizeInPlaceFromFloats(shape[v].x, shape[v].y, shape[v].z);
            }
            let bInfo;
            if (this._particlesIntersect) bInfo = new (0, $ef012.BoundingInfo)(minimum, maximum);
            let material = null;
            if (this._useModelMaterial) material = mesh.material ? mesh.material : this._setDefaultMaterial();
            const modelShape = new (0, $8Qyhp.ModelShape)(this._shapeCounter, shape, shapeInd, shapeNor, shapeCol, shapeUV, null, null, material);
            // add the particle in the SPS
            const currentPos = this._positions.length;
            const currentInd = this._indices.length;
            this._meshBuilder(this._index, currentInd, shape, this._positions, shapeInd, this._indices, facetUV, this._uvs, shapeCol, this._colors, shapeNor, this._normals, idx, 0, null, modelShape);
            this._addParticle(idx, this._lastParticleId, currentPos, currentInd, modelShape, this._shapeCounter, 0, bInfo, storage);
            // initialize the particle position
            this.particles[this.nbParticles].position.addInPlace(barycenter);
            if (!storage) {
                this._index += shape.length;
                idx++;
                this.nbParticles++;
                this._lastParticleId++;
            }
            this._shapeCounter++;
            f += size;
        }
        this._isNotBuilt = true; // buildMesh() is now expected for setParticles() to work
        return this;
    }
    /**
     * Unrotate the fixed normals in case the mesh was built with pre-rotated particles, ex : use of positionFunction in addShape()
     * @internal
     */ _unrotateFixedNormals() {
        let index = 0;
        let idx = 0;
        const tmpNormal = (0, $ha1VO.TmpVectors).Vector3[0];
        const quaternion = (0, $ha1VO.TmpVectors).Quaternion[0];
        const invertedRotMatrix = (0, $ha1VO.TmpVectors).Matrix[0];
        for(let p = 0; p < this.particles.length; p++){
            const particle = this.particles[p];
            const shape = particle._model._shape;
            // computing the inverse of the rotation matrix from the quaternion
            // is equivalent to computing the matrix of the inverse quaternion, i.e of the conjugate quaternion
            if (particle.rotationQuaternion) particle.rotationQuaternion.conjugateToRef(quaternion);
            else {
                const rotation = particle.rotation;
                (0, $ha1VO.Quaternion).RotationYawPitchRollToRef(rotation.y, rotation.x, rotation.z, quaternion);
                quaternion.conjugateInPlace();
            }
            quaternion.toRotationMatrix(invertedRotMatrix);
            for(let pt = 0; pt < shape.length; pt++){
                idx = index + pt * 3;
                (0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(this._normals32[idx], this._normals32[idx + 1], this._normals32[idx + 2], invertedRotMatrix, tmpNormal);
                tmpNormal.toArray(this._fixedNormal32, idx);
            }
            index = idx + 3;
        }
    }
    /**
     * Resets the temporary working copy particle
     * @internal
     */ _resetCopy() {
        const copy = this._copy;
        copy.position.setAll(0);
        copy.rotation.setAll(0);
        copy.rotationQuaternion = null;
        copy.scaling.setAll(1);
        copy.uvs.copyFromFloats(0.0, 0.0, 1.0, 1.0);
        copy.color = null;
        copy.translateFromPivot = false;
        copy.shapeId = 0;
        copy.materialIndex = null;
    }
    /**
     * Inserts the shape model geometry in the global SPS mesh by updating the positions, indices, normals, colors, uvs arrays
     * @param p the current index in the positions array to be updated
     * @param ind the current index in the indices array
     * @param shape a Vector3 array, the shape geometry
     * @param positions the positions array to be updated
     * @param meshInd the shape indices array
     * @param indices the indices array to be updated
     * @param meshUV the shape uv array
     * @param uvs the uv array to be updated
     * @param meshCol the shape color array
     * @param colors the color array to be updated
     * @param meshNor the shape normals array
     * @param normals the normals array to be updated
     * @param idx the particle index
     * @param idxInShape the particle index in its shape
     * @param options the addShape() method  passed options
     * @param model
     * @model the particle model
     * @internal
     */ _meshBuilder(p, ind, shape, positions, meshInd, indices, meshUV, uvs, meshCol, colors, meshNor, normals, idx, idxInShape, options, model) {
        let i;
        let u = 0;
        let c = 0;
        let n = 0;
        this._resetCopy();
        const copy = this._copy;
        const storeApart = options && options.storage ? true : false;
        copy.idx = idx;
        copy.idxInShape = idxInShape;
        copy.shapeId = model.shapeId;
        if (this._useModelMaterial) {
            const materialId = model._material.uniqueId;
            const materialIndexesById = this._materialIndexesById;
            if (!Object.prototype.hasOwnProperty.call(materialIndexesById, materialId)) {
                materialIndexesById[materialId] = this._materials.length;
                this._materials.push(model._material);
            }
            const matIdx = materialIndexesById[materialId];
            copy.materialIndex = matIdx;
        }
        if (options && options.positionFunction) {
            // call to custom positionFunction
            options.positionFunction(copy, idx, idxInShape);
            this._mustUnrotateFixedNormals = true;
        }
        // in case the particle geometry must NOT be inserted in the SPS mesh geometry
        if (storeApart) return copy;
        const rotMatrix = (0, $ha1VO.TmpVectors).Matrix[0];
        const tmpVertex = this._tmpVertex;
        const tmpVector = tmpVertex.position;
        const tmpColor = tmpVertex.color;
        const tmpUV = tmpVertex.uv;
        const tmpRotated = (0, $ha1VO.TmpVectors).Vector3[1];
        const pivotBackTranslation = (0, $ha1VO.TmpVectors).Vector3[2];
        const scaledPivot = (0, $ha1VO.TmpVectors).Vector3[3];
        (0, $ha1VO.Matrix).IdentityToRef(rotMatrix);
        copy.getRotationMatrix(rotMatrix);
        copy.pivot.multiplyToRef(copy.scaling, scaledPivot);
        if (copy.translateFromPivot) pivotBackTranslation.setAll(0.0);
        else pivotBackTranslation.copyFrom(scaledPivot);
        const someVertexFunction = options && options.vertexFunction;
        for(i = 0; i < shape.length; i++){
            tmpVector.copyFrom(shape[i]);
            if (copy.color) tmpColor.copyFrom(copy.color);
            if (meshUV) tmpUV.copyFromFloats(meshUV[u], meshUV[u + 1]);
            if (someVertexFunction) options.vertexFunction(copy, tmpVertex, i);
            tmpVector.multiplyInPlace(copy.scaling).subtractInPlace(scaledPivot);
            (0, $ha1VO.Vector3).TransformCoordinatesToRef(tmpVector, rotMatrix, tmpRotated);
            tmpRotated.addInPlace(pivotBackTranslation).addInPlace(copy.position);
            positions.push(tmpRotated.x, tmpRotated.y, tmpRotated.z);
            if (meshUV) {
                const copyUvs = copy.uvs;
                uvs.push((copyUvs.z - copyUvs.x) * tmpUV.x + copyUvs.x, (copyUvs.w - copyUvs.y) * tmpUV.y + copyUvs.y);
                u += 2;
            }
            if (copy.color) this._color.copyFrom(tmpColor);
            else {
                const color = this._color;
                if (meshCol && meshCol[c] !== undefined) {
                    color.r = meshCol[c];
                    color.g = meshCol[c + 1];
                    color.b = meshCol[c + 2];
                    color.a = meshCol[c + 3];
                } else {
                    color.r = 1.0;
                    color.g = 1.0;
                    color.b = 1.0;
                    color.a = 1.0;
                }
            }
            colors.push(this._color.r, this._color.g, this._color.b, this._color.a);
            c += 4;
            if (!this.recomputeNormals && meshNor) {
                (0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(meshNor[n], meshNor[n + 1], meshNor[n + 2], rotMatrix, tmpVector);
                normals.push(tmpVector.x, tmpVector.y, tmpVector.z);
                n += 3;
            }
        }
        for(i = 0; i < meshInd.length; i++){
            const current_ind = p + meshInd[i];
            indices.push(current_ind);
            if (current_ind > 65535) this._needs32Bits = true;
        }
        if (this._depthSort || this._multimaterialEnabled) {
            const matIndex = copy.materialIndex !== null ? copy.materialIndex : 0;
            this.depthSortedParticles.push(new (0, $8Qyhp.DepthSortedParticle)(idx, ind, meshInd.length, matIndex));
        }
        return copy;
    }
    /**
     * Returns a shape Vector3 array from positions float array
     * @param positions float array
     * @returns a vector3 array
     * @internal
     */ _posToShape(positions) {
        const shape = [];
        for(let i = 0; i < positions.length; i += 3)shape.push((0, $ha1VO.Vector3).FromArray(positions, i));
        return shape;
    }
    /**
     * Returns a shapeUV array from a float uvs (array deep copy)
     * @param uvs as a float array
     * @returns a shapeUV array
     * @internal
     */ _uvsToShapeUV(uvs) {
        const shapeUV = [];
        if (uvs) for(let i = 0; i < uvs.length; i++)shapeUV.push(uvs[i]);
        return shapeUV;
    }
    /**
     * Adds a new particle object in the particles array
     * @param idx particle index in particles array
     * @param id particle id
     * @param idxpos positionIndex : the starting index of the particle vertices in the SPS "positions" array
     * @param idxind indiceIndex : he starting index of the particle indices in the SPS "indices" array
     * @param model particle ModelShape object
     * @param shapeId model shape identifier
     * @param idxInShape index of the particle in the current model
     * @param bInfo model bounding info object
     * @param storage target storage array, if any
     * @internal
     */ _addParticle(idx, id, idxpos, idxind, model, shapeId, idxInShape, bInfo = null, storage = null) {
        const sp = new (0, $8Qyhp.SolidParticle)(idx, id, idxpos, idxind, model, shapeId, idxInShape, this, bInfo);
        const target = storage ? storage : this.particles;
        target.push(sp);
        return sp;
    }
    /**
     * Adds some particles to the SPS from the model shape. Returns the shape id.
     * Please read the doc : https://doc.babylonjs.com/features/featuresDeepDive/particles/solid_particle_system/immutable_sps
     * @param mesh is any Mesh object that will be used as a model for the solid particles. If the mesh does not have vertex normals, it will turn on the recomputeNormals attribute.
     * @param nb (positive integer) the number of particles to be created from this model
     * @param options {positionFunction} is an optional javascript function to called for each particle on SPS creation.
     * {vertexFunction} is an optional javascript function to called for each vertex of each particle on SPS creation
     * {storage} (optional existing array) is an array where the particles will be stored for a further use instead of being inserted in the SPS.
     * @param options.positionFunction
     * @param options.vertexFunction
     * @param options.storage
     * @returns the number of shapes in the system
     */ addShape(mesh, nb, options) {
        const meshPos = mesh.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        const meshInd = mesh.getIndices();
        const meshUV = mesh.getVerticesData((0, $b4i1f.VertexBuffer).UVKind);
        const meshCol = mesh.getVerticesData((0, $b4i1f.VertexBuffer).ColorKind);
        const meshNor = mesh.getVerticesData((0, $b4i1f.VertexBuffer).NormalKind);
        this.recomputeNormals = meshNor ? false : true;
        const indices = Array.from(meshInd);
        const shapeNormals = meshNor ? Array.from(meshNor) : [];
        const shapeColors = meshCol ? Array.from(meshCol) : [];
        const storage = options && options.storage ? options.storage : null;
        let bbInfo = null;
        if (this._particlesIntersect) bbInfo = mesh.getBoundingInfo();
        const shape = this._posToShape(meshPos);
        const shapeUV = this._uvsToShapeUV(meshUV);
        const posfunc = options ? options.positionFunction : null;
        const vtxfunc = options ? options.vertexFunction : null;
        let material = null;
        if (this._useModelMaterial) material = mesh.material ? mesh.material : this._setDefaultMaterial();
        const modelShape = new (0, $8Qyhp.ModelShape)(this._shapeCounter, shape, indices, shapeNormals, shapeColors, shapeUV, posfunc, vtxfunc, material);
        // particles
        for(let i = 0; i < nb; i++)this._insertNewParticle(this.nbParticles, i, modelShape, shape, meshInd, meshUV, meshCol, meshNor, bbInfo, storage, options);
        this._shapeCounter++;
        this._isNotBuilt = true; // buildMesh() call is now expected for setParticles() to work
        return this._shapeCounter - 1;
    }
    /**
     * Rebuilds a particle back to its just built status : if needed, recomputes the custom positions and vertices
     * @internal
     */ _rebuildParticle(particle, reset = false) {
        this._resetCopy();
        const copy = this._copy;
        if (particle._model._positionFunction) // recall to stored custom positionFunction
        particle._model._positionFunction(copy, particle.idx, particle.idxInShape);
        const rotMatrix = (0, $ha1VO.TmpVectors).Matrix[0];
        const tmpVertex = (0, $ha1VO.TmpVectors).Vector3[0];
        const tmpRotated = (0, $ha1VO.TmpVectors).Vector3[1];
        const pivotBackTranslation = (0, $ha1VO.TmpVectors).Vector3[2];
        const scaledPivot = (0, $ha1VO.TmpVectors).Vector3[3];
        copy.getRotationMatrix(rotMatrix);
        particle.pivot.multiplyToRef(particle.scaling, scaledPivot);
        if (copy.translateFromPivot) pivotBackTranslation.copyFromFloats(0.0, 0.0, 0.0);
        else pivotBackTranslation.copyFrom(scaledPivot);
        const shape = particle._model._shape;
        for(let pt = 0; pt < shape.length; pt++){
            tmpVertex.copyFrom(shape[pt]);
            if (particle._model._vertexFunction) particle._model._vertexFunction(copy, tmpVertex, pt); // recall to stored vertexFunction
            tmpVertex.multiplyInPlace(copy.scaling).subtractInPlace(scaledPivot);
            (0, $ha1VO.Vector3).TransformCoordinatesToRef(tmpVertex, rotMatrix, tmpRotated);
            tmpRotated.addInPlace(pivotBackTranslation).addInPlace(copy.position).toArray(this._positions32, particle._pos + pt * 3);
        }
        if (reset) {
            particle.position.setAll(0.0);
            particle.rotation.setAll(0.0);
            particle.rotationQuaternion = null;
            particle.scaling.setAll(1.0);
            particle.uvs.setAll(0.0);
            particle.pivot.setAll(0.0);
            particle.translateFromPivot = false;
            particle.parentId = null;
        }
    }
    /**
     * Rebuilds the whole mesh and updates the VBO : custom positions and vertices are recomputed if needed.
     * @param reset boolean, default false : if the particles must be reset at position and rotation zero, scaling 1, color white, initial UVs and not parented.
     * @returns the SPS.
     */ rebuildMesh(reset = false) {
        for(let p = 0; p < this.particles.length; p++)this._rebuildParticle(this.particles[p], reset);
        this.mesh.updateVerticesData((0, $b4i1f.VertexBuffer).PositionKind, this._positions32, false, false);
        return this;
    }
    /** Removes the particles from the start-th to the end-th included from an expandable SPS (required).
     *  Returns an array with the removed particles.
     *  If the number of particles to remove is lower than zero or greater than the global remaining particle number, then an empty array is returned.
     *  The SPS can't be empty so at least one particle needs to remain in place.
     *  Under the hood, the VertexData array, so the VBO buffer, is recreated each call.
     * @param start index of the first particle to remove
     * @param end index of the last particle to remove (included)
     * @returns an array populated with the removed particles
     */ removeParticles(start, end) {
        const nb = end - start + 1;
        if (!this._expandable || nb <= 0 || nb >= this.nbParticles || !this._updatable) return [];
        const particles = this.particles;
        const currentNb = this.nbParticles;
        if (end < currentNb - 1) {
            // update the particle indexes in the positions array in case they're remaining particles after the last removed
            const firstRemaining = end + 1;
            const shiftPos = particles[firstRemaining]._pos - particles[start]._pos;
            const shifInd = particles[firstRemaining]._ind - particles[start]._ind;
            for(let i = firstRemaining; i < currentNb; i++){
                const part = particles[i];
                part._pos -= shiftPos;
                part._ind -= shifInd;
            }
        }
        const removed = particles.splice(start, nb);
        this._positions.length = 0;
        this._indices.length = 0;
        this._colors.length = 0;
        this._uvs.length = 0;
        this._normals.length = 0;
        this._index = 0;
        this._idxOfId.length = 0;
        if (this._depthSort || this._multimaterialEnabled) this.depthSortedParticles = [];
        let ind = 0;
        const particlesLength = particles.length;
        for(let p = 0; p < particlesLength; p++){
            const particle = particles[p];
            const model = particle._model;
            const shape = model._shape;
            const modelIndices = model._indices;
            const modelNormals = model._normals;
            const modelColors = model._shapeColors;
            const modelUVs = model._shapeUV;
            particle.idx = p;
            this._idxOfId[particle.id] = p;
            this._meshBuilder(this._index, ind, shape, this._positions, modelIndices, this._indices, modelUVs, this._uvs, modelColors, this._colors, modelNormals, this._normals, particle.idx, particle.idxInShape, null, model);
            this._index += shape.length;
            ind += modelIndices.length;
        }
        this.nbParticles -= nb;
        this._isNotBuilt = true; // buildMesh() call is now expected for setParticles() to work
        return removed;
    }
    /**
     * Inserts some pre-created particles in the solid particle system so that they can be managed by setParticles().
     * @param solidParticleArray an array populated with Solid Particles objects
     * @returns the SPS
     */ insertParticlesFromArray(solidParticleArray) {
        if (!this._expandable) return this;
        let idxInShape = 0;
        let currentShapeId = solidParticleArray[0].shapeId;
        const nb = solidParticleArray.length;
        for(let i = 0; i < nb; i++){
            const sp = solidParticleArray[i];
            const model = sp._model;
            const shape = model._shape;
            const meshInd = model._indices;
            const meshUV = model._shapeUV;
            const meshCol = model._shapeColors;
            const meshNor = model._normals;
            const noNor = meshNor ? false : true;
            this.recomputeNormals = noNor || this.recomputeNormals;
            const bbInfo = sp.getBoundingInfo();
            const newPart = this._insertNewParticle(this.nbParticles, idxInShape, model, shape, meshInd, meshUV, meshCol, meshNor, bbInfo, null, null);
            sp.copyToRef(newPart);
            idxInShape++;
            if (currentShapeId != sp.shapeId) {
                currentShapeId = sp.shapeId;
                idxInShape = 0;
            }
        }
        this._isNotBuilt = true; // buildMesh() call is now expected for setParticles() to work
        return this;
    }
    /**
     * Creates a new particle and modifies the SPS mesh geometry :
     * - calls _meshBuilder() to increase the SPS mesh geometry step by step
     * - calls _addParticle() to populate the particle array
     * factorized code from addShape() and insertParticlesFromArray()
     * @param idx particle index in the particles array
     * @param i particle index in its shape
     * @param modelShape particle ModelShape object
     * @param shape shape vertex array
     * @param meshInd shape indices array
     * @param meshUV shape uv array
     * @param meshCol shape color array
     * @param meshNor shape normals array
     * @param bbInfo shape bounding info
     * @param storage target particle storage
     * @param options
     * @options addShape() passed options
     * @internal
     */ _insertNewParticle(idx, i, modelShape, shape, meshInd, meshUV, meshCol, meshNor, bbInfo, storage, options) {
        const currentPos = this._positions.length;
        const currentInd = this._indices.length;
        const currentCopy = this._meshBuilder(this._index, currentInd, shape, this._positions, meshInd, this._indices, meshUV, this._uvs, meshCol, this._colors, meshNor, this._normals, idx, i, options, modelShape);
        let sp = null;
        if (this._updatable) {
            sp = this._addParticle(this.nbParticles, this._lastParticleId, currentPos, currentInd, modelShape, this._shapeCounter, i, bbInfo, storage);
            sp.position.copyFrom(currentCopy.position);
            sp.rotation.copyFrom(currentCopy.rotation);
            if (currentCopy.rotationQuaternion) {
                if (sp.rotationQuaternion) sp.rotationQuaternion.copyFrom(currentCopy.rotationQuaternion);
                else sp.rotationQuaternion = currentCopy.rotationQuaternion.clone();
            }
            if (currentCopy.color) {
                if (sp.color) sp.color.copyFrom(currentCopy.color);
                else sp.color = currentCopy.color.clone();
            }
            sp.scaling.copyFrom(currentCopy.scaling);
            sp.uvs.copyFrom(currentCopy.uvs);
            if (currentCopy.materialIndex !== null) sp.materialIndex = currentCopy.materialIndex;
            if (this.expandable) this._idxOfId[sp.id] = sp.idx;
        }
        if (!storage) {
            this._index += shape.length;
            this.nbParticles++;
            this._lastParticleId++;
        }
        return sp;
    }
    /**
     *  Sets all the particles : this method actually really updates the mesh according to the particle positions, rotations, colors, textures, etc.
     *  This method calls `updateParticle()` for each particle of the SPS.
     *  For an animated SPS, it is usually called within the render loop.
     * This methods does nothing if called on a non updatable or not yet built SPS. Example : buildMesh() not called after having added or removed particles from an expandable SPS.
     * @param start The particle index in the particle array where to start to compute the particle property values _(default 0)_
     * @param end The particle index in the particle array where to stop to compute the particle property values _(default nbParticle - 1)_
     * @param update If the mesh must be finally updated on this call after all the particle computations _(default true)_
     * @returns the SPS.
     */ setParticles(start = 0, end = this.nbParticles - 1, update = true) {
        if (!this._updatable || this._isNotBuilt) return this;
        // custom beforeUpdate
        this.beforeUpdateParticles(start, end, update);
        const rotMatrix = (0, $ha1VO.TmpVectors).Matrix[0];
        const invertedMatrix = (0, $ha1VO.TmpVectors).Matrix[1];
        const mesh = this.mesh;
        const colors32 = this._colors32;
        const positions32 = this._positions32;
        const normals32 = this._normals32;
        const uvs32 = this._uvs32;
        const indices32 = this._indices32;
        const indices = this._indices;
        const fixedNormal32 = this._fixedNormal32;
        const depthSortParticles = this._depthSort && this._depthSortParticles;
        const tempVectors = (0, $ha1VO.TmpVectors).Vector3;
        const camAxisX = tempVectors[5].copyFromFloats(1.0, 0.0, 0.0);
        const camAxisY = tempVectors[6].copyFromFloats(0.0, 1.0, 0.0);
        const camAxisZ = tempVectors[7].copyFromFloats(0.0, 0.0, 1.0);
        const minimum = tempVectors[8].setAll(Number.MAX_VALUE);
        const maximum = tempVectors[9].setAll(-Number.MAX_VALUE);
        const camInvertedPosition = tempVectors[10].setAll(0);
        const tmpVertex = this._tmpVertex;
        const tmpVector = tmpVertex.position;
        const tmpColor = tmpVertex.color;
        const tmpUV = tmpVertex.uv;
        // cases when the World Matrix is to be computed first
        if (this.billboard || this._depthSort) {
            this.mesh.computeWorldMatrix(true);
            this.mesh._worldMatrix.invertToRef(invertedMatrix);
        }
        // if the particles will always face the camera
        if (this.billboard) {
            // compute the camera position and un-rotate it by the current mesh rotation
            const tmpVector0 = tempVectors[0];
            this._camera.getDirectionToRef((0, $dbxbu.Axis).Z, tmpVector0);
            (0, $ha1VO.Vector3).TransformNormalToRef(tmpVector0, invertedMatrix, camAxisZ);
            camAxisZ.normalize();
            // same for camera up vector extracted from the cam view matrix
            const view = this._camera.getViewMatrix(true);
            (0, $ha1VO.Vector3).TransformNormalFromFloatsToRef(view.m[1], view.m[5], view.m[9], invertedMatrix, camAxisY);
            (0, $ha1VO.Vector3).CrossToRef(camAxisY, camAxisZ, camAxisX);
            camAxisY.normalize();
            camAxisX.normalize();
        }
        // if depthSort, compute the camera global position in the mesh local system
        if (this._depthSort) (0, $ha1VO.Vector3).TransformCoordinatesToRef(this._camera.globalPosition, invertedMatrix, camInvertedPosition); // then un-rotate the camera
        (0, $ha1VO.Matrix).IdentityToRef(rotMatrix);
        let idx = 0; // current position index in the global array positions32
        let index = 0; // position start index in the global array positions32 of the current particle
        let colidx = 0; // current color index in the global array colors32
        let colorIndex = 0; // color start index in the global array colors32 of the current particle
        let uvidx = 0; // current uv index in the global array uvs32
        let uvIndex = 0; // uv start index in the global array uvs32 of the current particle
        let pt = 0; // current index in the particle model shape
        if (this.mesh.isFacetDataEnabled) this._computeBoundingBox = true;
        end = end >= this.nbParticles ? this.nbParticles - 1 : end;
        if (this._computeBoundingBox) {
            if (start != 0 || end != this.nbParticles - 1) {
                // only some particles are updated, then use the current existing BBox basis. Note : it can only increase.
                const boundingInfo = this.mesh.getBoundingInfo();
                if (boundingInfo) {
                    minimum.copyFrom(boundingInfo.minimum);
                    maximum.copyFrom(boundingInfo.maximum);
                }
            }
        }
        // particle loop
        index = this.particles[start]._pos;
        const vpos = index / 3 | 0;
        colorIndex = vpos * 4;
        uvIndex = vpos * 2;
        for(let p = start; p <= end; p++){
            const particle = this.particles[p];
            // call to custom user function to update the particle properties
            this.updateParticle(particle);
            const shape = particle._model._shape;
            const shapeUV = particle._model._shapeUV;
            const particleRotationMatrix = particle._rotationMatrix;
            const particlePosition = particle.position;
            const particleRotation = particle.rotation;
            const particleScaling = particle.scaling;
            const particleGlobalPosition = particle._globalPosition;
            // camera-particle distance for depth sorting
            if (depthSortParticles) {
                const dsp = this.depthSortedParticles[p];
                dsp.idx = particle.idx;
                dsp.ind = particle._ind;
                dsp.indicesLength = particle._model._indicesLength;
                dsp.sqDistance = (0, $ha1VO.Vector3).DistanceSquared(particle.position, camInvertedPosition);
            }
            // skip the computations for inactive or already invisible particles
            if (!particle.alive || particle._stillInvisible && !particle.isVisible && !this._recomputeInvisibles) {
                // increment indexes for the next particle
                pt = shape.length;
                index += pt * 3;
                colorIndex += pt * 4;
                uvIndex += pt * 2;
                continue;
            }
            if (particle.isVisible) {
                particle._stillInvisible = false; // un-mark permanent invisibility
                const scaledPivot = tempVectors[12];
                particle.pivot.multiplyToRef(particleScaling, scaledPivot);
                // particle rotation matrix
                if (this.billboard) {
                    particleRotation.x = 0.0;
                    particleRotation.y = 0.0;
                }
                if (this._computeParticleRotation || this.billboard) particle.getRotationMatrix(rotMatrix);
                const particleHasParent = particle.parentId !== null;
                if (particleHasParent) {
                    const parent = this.getParticleById(particle.parentId);
                    if (parent) {
                        const parentRotationMatrix = parent._rotationMatrix;
                        const parentGlobalPosition = parent._globalPosition;
                        const rotatedY = particlePosition.x * parentRotationMatrix[1] + particlePosition.y * parentRotationMatrix[4] + particlePosition.z * parentRotationMatrix[7];
                        const rotatedX = particlePosition.x * parentRotationMatrix[0] + particlePosition.y * parentRotationMatrix[3] + particlePosition.z * parentRotationMatrix[6];
                        const rotatedZ = particlePosition.x * parentRotationMatrix[2] + particlePosition.y * parentRotationMatrix[5] + particlePosition.z * parentRotationMatrix[8];
                        particleGlobalPosition.x = parentGlobalPosition.x + rotatedX;
                        particleGlobalPosition.y = parentGlobalPosition.y + rotatedY;
                        particleGlobalPosition.z = parentGlobalPosition.z + rotatedZ;
                        if (this._computeParticleRotation || this.billboard) {
                            const rotMatrixValues = rotMatrix.m;
                            particleRotationMatrix[0] = rotMatrixValues[0] * parentRotationMatrix[0] + rotMatrixValues[1] * parentRotationMatrix[3] + rotMatrixValues[2] * parentRotationMatrix[6];
                            particleRotationMatrix[1] = rotMatrixValues[0] * parentRotationMatrix[1] + rotMatrixValues[1] * parentRotationMatrix[4] + rotMatrixValues[2] * parentRotationMatrix[7];
                            particleRotationMatrix[2] = rotMatrixValues[0] * parentRotationMatrix[2] + rotMatrixValues[1] * parentRotationMatrix[5] + rotMatrixValues[2] * parentRotationMatrix[8];
                            particleRotationMatrix[3] = rotMatrixValues[4] * parentRotationMatrix[0] + rotMatrixValues[5] * parentRotationMatrix[3] + rotMatrixValues[6] * parentRotationMatrix[6];
                            particleRotationMatrix[4] = rotMatrixValues[4] * parentRotationMatrix[1] + rotMatrixValues[5] * parentRotationMatrix[4] + rotMatrixValues[6] * parentRotationMatrix[7];
                            particleRotationMatrix[5] = rotMatrixValues[4] * parentRotationMatrix[2] + rotMatrixValues[5] * parentRotationMatrix[5] + rotMatrixValues[6] * parentRotationMatrix[8];
                            particleRotationMatrix[6] = rotMatrixValues[8] * parentRotationMatrix[0] + rotMatrixValues[9] * parentRotationMatrix[3] + rotMatrixValues[10] * parentRotationMatrix[6];
                            particleRotationMatrix[7] = rotMatrixValues[8] * parentRotationMatrix[1] + rotMatrixValues[9] * parentRotationMatrix[4] + rotMatrixValues[10] * parentRotationMatrix[7];
                            particleRotationMatrix[8] = rotMatrixValues[8] * parentRotationMatrix[2] + rotMatrixValues[9] * parentRotationMatrix[5] + rotMatrixValues[10] * parentRotationMatrix[8];
                        }
                    } else // in case the parent were removed at some moment
                    particle.parentId = null;
                } else {
                    particleGlobalPosition.x = particlePosition.x;
                    particleGlobalPosition.y = particlePosition.y;
                    particleGlobalPosition.z = particlePosition.z;
                    if (this._computeParticleRotation || this.billboard) {
                        const rotMatrixValues = rotMatrix.m;
                        particleRotationMatrix[0] = rotMatrixValues[0];
                        particleRotationMatrix[1] = rotMatrixValues[1];
                        particleRotationMatrix[2] = rotMatrixValues[2];
                        particleRotationMatrix[3] = rotMatrixValues[4];
                        particleRotationMatrix[4] = rotMatrixValues[5];
                        particleRotationMatrix[5] = rotMatrixValues[6];
                        particleRotationMatrix[6] = rotMatrixValues[8];
                        particleRotationMatrix[7] = rotMatrixValues[9];
                        particleRotationMatrix[8] = rotMatrixValues[10];
                    }
                }
                const pivotBackTranslation = tempVectors[11];
                if (particle.translateFromPivot) pivotBackTranslation.setAll(0.0);
                else pivotBackTranslation.copyFrom(scaledPivot);
                // particle vertex loop
                for(pt = 0; pt < shape.length; pt++){
                    idx = index + pt * 3;
                    colidx = colorIndex + pt * 4;
                    uvidx = uvIndex + pt * 2;
                    const iu = 2 * pt;
                    const iv = iu + 1;
                    tmpVector.copyFrom(shape[pt]);
                    if (this._computeParticleColor && particle.color) tmpColor.copyFrom(particle.color);
                    if (this._computeParticleTexture) tmpUV.copyFromFloats(shapeUV[iu], shapeUV[iv]);
                    if (this._computeParticleVertex) this.updateParticleVertex(particle, tmpVertex, pt);
                    // positions
                    const vertexX = tmpVector.x * particleScaling.x - scaledPivot.x;
                    const vertexY = tmpVector.y * particleScaling.y - scaledPivot.y;
                    const vertexZ = tmpVector.z * particleScaling.z - scaledPivot.z;
                    let rotatedX = vertexX * particleRotationMatrix[0] + vertexY * particleRotationMatrix[3] + vertexZ * particleRotationMatrix[6];
                    let rotatedY = vertexX * particleRotationMatrix[1] + vertexY * particleRotationMatrix[4] + vertexZ * particleRotationMatrix[7];
                    let rotatedZ = vertexX * particleRotationMatrix[2] + vertexY * particleRotationMatrix[5] + vertexZ * particleRotationMatrix[8];
                    rotatedX += pivotBackTranslation.x;
                    rotatedY += pivotBackTranslation.y;
                    rotatedZ += pivotBackTranslation.z;
                    const px = positions32[idx] = particleGlobalPosition.x + camAxisX.x * rotatedX + camAxisY.x * rotatedY + camAxisZ.x * rotatedZ;
                    const py = positions32[idx + 1] = particleGlobalPosition.y + camAxisX.y * rotatedX + camAxisY.y * rotatedY + camAxisZ.y * rotatedZ;
                    const pz = positions32[idx + 2] = particleGlobalPosition.z + camAxisX.z * rotatedX + camAxisY.z * rotatedY + camAxisZ.z * rotatedZ;
                    if (this._computeBoundingBox) {
                        minimum.minimizeInPlaceFromFloats(px, py, pz);
                        maximum.maximizeInPlaceFromFloats(px, py, pz);
                    }
                    // normals : if the particles can't be morphed then just rotate the normals, what is much more faster than ComputeNormals()
                    if (!this._computeParticleVertex) {
                        const normalx = fixedNormal32[idx];
                        const normaly = fixedNormal32[idx + 1];
                        const normalz = fixedNormal32[idx + 2];
                        const rotatedx = normalx * particleRotationMatrix[0] + normaly * particleRotationMatrix[3] + normalz * particleRotationMatrix[6];
                        const rotatedy = normalx * particleRotationMatrix[1] + normaly * particleRotationMatrix[4] + normalz * particleRotationMatrix[7];
                        const rotatedz = normalx * particleRotationMatrix[2] + normaly * particleRotationMatrix[5] + normalz * particleRotationMatrix[8];
                        normals32[idx] = camAxisX.x * rotatedx + camAxisY.x * rotatedy + camAxisZ.x * rotatedz;
                        normals32[idx + 1] = camAxisX.y * rotatedx + camAxisY.y * rotatedy + camAxisZ.y * rotatedz;
                        normals32[idx + 2] = camAxisX.z * rotatedx + camAxisY.z * rotatedy + camAxisZ.z * rotatedz;
                    }
                    if (this._computeParticleColor && particle.color) {
                        const colors32 = this._colors32;
                        colors32[colidx] = tmpColor.r;
                        colors32[colidx + 1] = tmpColor.g;
                        colors32[colidx + 2] = tmpColor.b;
                        colors32[colidx + 3] = tmpColor.a;
                    }
                    if (this._computeParticleTexture) {
                        const uvs = particle.uvs;
                        uvs32[uvidx] = tmpUV.x * (uvs.z - uvs.x) + uvs.x;
                        uvs32[uvidx + 1] = tmpUV.y * (uvs.w - uvs.y) + uvs.y;
                    }
                }
            } else {
                particle._stillInvisible = true; // mark the particle as invisible
                for(pt = 0; pt < shape.length; pt++){
                    idx = index + pt * 3;
                    colidx = colorIndex + pt * 4;
                    uvidx = uvIndex + pt * 2;
                    positions32[idx] = positions32[idx + 1] = positions32[idx + 2] = 0;
                    normals32[idx] = normals32[idx + 1] = normals32[idx + 2] = 0;
                    if (this._computeParticleColor && particle.color) {
                        const color = particle.color;
                        colors32[colidx] = color.r;
                        colors32[colidx + 1] = color.g;
                        colors32[colidx + 2] = color.b;
                        colors32[colidx + 3] = color.a;
                    }
                    if (this._computeParticleTexture) {
                        const uvs = particle.uvs;
                        uvs32[uvidx] = shapeUV[pt * 2] * (uvs.z - uvs.x) + uvs.x;
                        uvs32[uvidx + 1] = shapeUV[pt * 2 + 1] * (uvs.w - uvs.y) + uvs.y;
                    }
                }
            }
            // if the particle intersections must be computed : update the bbInfo
            if (this._particlesIntersect) {
                const bInfo = particle.getBoundingInfo();
                const bBox = bInfo.boundingBox;
                const bSphere = bInfo.boundingSphere;
                const modelBoundingInfo = particle._modelBoundingInfo;
                if (!this._bSphereOnly) {
                    // place, scale and rotate the particle bbox within the SPS local system, then update it
                    const modelBoundingInfoVectors = modelBoundingInfo.boundingBox.vectors;
                    const tempMin = tempVectors[1];
                    const tempMax = tempVectors[2];
                    tempMin.setAll(Number.MAX_VALUE);
                    tempMax.setAll(-Number.MAX_VALUE);
                    for(let b = 0; b < 8; b++){
                        const scaledX = modelBoundingInfoVectors[b].x * particleScaling.x;
                        const scaledY = modelBoundingInfoVectors[b].y * particleScaling.y;
                        const scaledZ = modelBoundingInfoVectors[b].z * particleScaling.z;
                        const rotatedX = scaledX * particleRotationMatrix[0] + scaledY * particleRotationMatrix[3] + scaledZ * particleRotationMatrix[6];
                        const rotatedY = scaledX * particleRotationMatrix[1] + scaledY * particleRotationMatrix[4] + scaledZ * particleRotationMatrix[7];
                        const rotatedZ = scaledX * particleRotationMatrix[2] + scaledY * particleRotationMatrix[5] + scaledZ * particleRotationMatrix[8];
                        const x = particlePosition.x + camAxisX.x * rotatedX + camAxisY.x * rotatedY + camAxisZ.x * rotatedZ;
                        const y = particlePosition.y + camAxisX.y * rotatedX + camAxisY.y * rotatedY + camAxisZ.y * rotatedZ;
                        const z = particlePosition.z + camAxisX.z * rotatedX + camAxisY.z * rotatedY + camAxisZ.z * rotatedZ;
                        tempMin.minimizeInPlaceFromFloats(x, y, z);
                        tempMax.maximizeInPlaceFromFloats(x, y, z);
                    }
                    bBox.reConstruct(tempMin, tempMax, mesh._worldMatrix);
                }
                // place and scale the particle bouding sphere in the SPS local system, then update it
                const minBbox = modelBoundingInfo.minimum.multiplyToRef(particleScaling, tempVectors[1]);
                const maxBbox = modelBoundingInfo.maximum.multiplyToRef(particleScaling, tempVectors[2]);
                const bSphereCenter = maxBbox.addToRef(minBbox, tempVectors[3]).scaleInPlace(0.5).addInPlace(particleGlobalPosition);
                const halfDiag = maxBbox.subtractToRef(minBbox, tempVectors[4]).scaleInPlace(0.5 * this._bSphereRadiusFactor);
                const bSphereMinBbox = bSphereCenter.subtractToRef(halfDiag, tempVectors[1]);
                const bSphereMaxBbox = bSphereCenter.addToRef(halfDiag, tempVectors[2]);
                bSphere.reConstruct(bSphereMinBbox, bSphereMaxBbox, mesh._worldMatrix);
            }
            // increment indexes for the next particle
            index = idx + 3;
            colorIndex = colidx + 4;
            uvIndex = uvidx + 2;
        }
        // if the VBO must be updated
        if (update) {
            if (this._computeParticleColor) {
                const vb = mesh.getVertexBuffer((0, $b4i1f.VertexBuffer).ColorKind);
                if (vb && !mesh.isPickable) vb.updateDirectly(colors32, 0);
                else mesh.updateVerticesData((0, $b4i1f.VertexBuffer).ColorKind, colors32, false, false);
            }
            if (this._computeParticleTexture) {
                const vb = mesh.getVertexBuffer((0, $b4i1f.VertexBuffer).UVKind);
                if (vb && !mesh.isPickable) vb.updateDirectly(uvs32, 0);
                else mesh.updateVerticesData((0, $b4i1f.VertexBuffer).UVKind, uvs32, false, false);
            }
            const vbp = mesh.getVertexBuffer((0, $b4i1f.VertexBuffer).PositionKind);
            if (vbp && !mesh.isPickable) vbp.updateDirectly(positions32, 0);
            else mesh.updateVerticesData((0, $b4i1f.VertexBuffer).PositionKind, positions32, false, false);
            if (!mesh.areNormalsFrozen || mesh.isFacetDataEnabled) {
                if (this._computeParticleVertex || mesh.isFacetDataEnabled) {
                    // recompute the normals only if the particles can be morphed, update then also the normal reference array _fixedNormal32[]
                    const params = mesh.isFacetDataEnabled ? mesh.getFacetDataParameters() : null;
                    (0, $5v6ry.VertexData).ComputeNormals(positions32, indices32, normals32, params);
                    for(let i = 0; i < normals32.length; i++)fixedNormal32[i] = normals32[i];
                }
                if (!mesh.areNormalsFrozen) {
                    const vb = mesh.getVertexBuffer((0, $b4i1f.VertexBuffer).NormalKind);
                    if (vb && !mesh.isPickable) vb.updateDirectly(normals32, 0);
                    else mesh.updateVerticesData((0, $b4i1f.VertexBuffer).NormalKind, normals32, false, false);
                }
            }
            if (depthSortParticles) {
                const depthSortedParticles = this.depthSortedParticles;
                depthSortedParticles.sort(this._depthSortFunction);
                const dspl = depthSortedParticles.length;
                let sid = 0;
                let faceId = 0;
                for(let sorted = 0; sorted < dspl; sorted++){
                    const sortedParticle = depthSortedParticles[sorted];
                    const lind = sortedParticle.indicesLength;
                    const sind = sortedParticle.ind;
                    for(let i = 0; i < lind; i++){
                        indices32[sid] = indices[sind + i];
                        sid++;
                        if (this._pickable) {
                            const f = i % 3;
                            if (f == 0) {
                                const pickedData = this.pickedParticles[faceId];
                                pickedData.idx = sortedParticle.idx;
                                pickedData.faceId = faceId;
                                faceId++;
                            }
                        }
                    }
                }
            }
            if (this._autoFixFaceOrientation) {
                let particleInd = 0;
                for(let particleIdx = 0; particleIdx < this.particles.length; particleIdx++){
                    const particle = depthSortParticles ? this.particles[this.depthSortedParticles[particleIdx].idx] : this.particles[particleIdx];
                    const flipFaces = particle.scale.x * particle.scale.y * particle.scale.z < 0;
                    if (flipFaces) for(let faceInd = 0; faceInd < particle._model._indicesLength; faceInd += 3){
                        const tmp = indices[particle._ind + faceInd];
                        indices32[particleInd + faceInd] = indices[particle._ind + faceInd + 1];
                        indices32[particleInd + faceInd + 1] = tmp;
                    }
                    particleInd += particle._model._indicesLength;
                }
            }
            if (depthSortParticles || this._autoFixFaceOrientation) mesh.updateIndices(indices32);
        }
        if (this._computeBoundingBox) {
            if (mesh.hasBoundingInfo) mesh.getBoundingInfo().reConstruct(minimum, maximum, mesh._worldMatrix);
            else mesh.buildBoundingInfo(minimum, maximum, mesh._worldMatrix);
        }
        if (this._autoUpdateSubMeshes) this.computeSubMeshes();
        this._recomputeInvisibles = false;
        this.afterUpdateParticles(start, end, update);
        return this;
    }
    /**
     * Disposes the SPS.
     */ dispose() {
        this.mesh.dispose();
        this.vars = null;
        // drop references to internal big arrays for the GC
        this._positions = null;
        this._indices = null;
        this._normals = null;
        this._uvs = null;
        this._colors = null;
        this._indices32 = null;
        this._positions32 = null;
        this._normals32 = null;
        this._fixedNormal32 = null;
        this._uvs32 = null;
        this._colors32 = null;
        this.pickedParticles = null;
        this.pickedBySubMesh = null;
        this._materials = null;
        this._materialIndexes = null;
        this._indicesByMaterial = null;
        this._idxOfId = null;
    }
    /** Returns an object {idx: number faceId: number} for the picked particle from the passed pickingInfo object.
     * idx is the particle index in the SPS
     * faceId is the picked face index counted within this particle.
     * Returns null if the pickInfo can't identify a picked particle.
     * @param pickingInfo (PickingInfo object)
     * @returns {idx: number, faceId: number} or null
     */ pickedParticle(pickingInfo) {
        if (pickingInfo.hit) {
            const subMesh = pickingInfo.subMeshId;
            const faceId = pickingInfo.faceId - this.mesh.subMeshes[subMesh].indexStart / 3;
            const picked = this.pickedBySubMesh;
            if (picked[subMesh] && picked[subMesh][faceId]) return picked[subMesh][faceId];
        }
        return null;
    }
    /**
     * Returns a SolidParticle object from its identifier : particle.id
     * @param id (integer) the particle Id
     * @returns the searched particle or null if not found in the SPS.
     */ getParticleById(id) {
        const p = this.particles[id];
        if (p && p.id == id) return p;
        const particles = this.particles;
        const idx = this._idxOfId[id];
        if (idx !== undefined) return particles[idx];
        let i = 0;
        const nb = this.nbParticles;
        while(i < nb){
            const particle = particles[i];
            if (particle.id == id) return particle;
            i++;
        }
        return null;
    }
    /**
     * Returns a new array populated with the particles having the passed shapeId.
     * @param shapeId (integer) the shape identifier
     * @returns a new solid particle array
     */ getParticlesByShapeId(shapeId) {
        const ref = [];
        this.getParticlesByShapeIdToRef(shapeId, ref);
        return ref;
    }
    /**
     * Populates the passed array "ref" with the particles having the passed shapeId.
     * @param shapeId the shape identifier
     * @param ref array to populate
     * @returns the SPS
     */ getParticlesByShapeIdToRef(shapeId, ref) {
        ref.length = 0;
        for(let i = 0; i < this.nbParticles; i++){
            const p = this.particles[i];
            if (p.shapeId == shapeId) ref.push(p);
        }
        return this;
    }
    /**
     * Computes the required SubMeshes according the materials assigned to the particles.
     * @returns the solid particle system.
     * Does nothing if called before the SPS mesh is built.
     */ computeSubMeshes() {
        if (!this.mesh || !this._multimaterialEnabled) return this;
        const depthSortedParticles = this.depthSortedParticles;
        if (this.particles.length > 0) for(let p = 0; p < this.particles.length; p++){
            const part = this.particles[p];
            if (!part.materialIndex) part.materialIndex = 0;
            const sortedPart = depthSortedParticles[p];
            sortedPart.materialIndex = part.materialIndex;
            sortedPart.ind = part._ind;
            sortedPart.indicesLength = part._model._indicesLength;
            sortedPart.idx = part.idx;
        }
        this._sortParticlesByMaterial();
        const indicesByMaterial = this._indicesByMaterial;
        const materialIndexes = this._materialIndexes;
        const mesh = this.mesh;
        mesh.subMeshes = [];
        const vcount = mesh.getTotalVertices();
        for(let m = 0; m < materialIndexes.length; m++){
            const start = indicesByMaterial[m];
            const count = indicesByMaterial[m + 1] - start;
            const matIndex = materialIndexes[m];
            new (0, $lEBSs.SubMesh)(matIndex, 0, vcount, start, count, mesh);
        }
        return this;
    }
    /**
     * Sorts the solid particles by material when MultiMaterial is enabled.
     * Updates the indices32 array.
     * Updates the indicesByMaterial array.
     * Updates the mesh indices array.
     * @returns the SPS
     * @internal
     */ _sortParticlesByMaterial() {
        const indicesByMaterial = [
            0
        ];
        this._indicesByMaterial = indicesByMaterial;
        const materialIndexes = [];
        this._materialIndexes = materialIndexes;
        const depthSortedParticles = this.depthSortedParticles;
        depthSortedParticles.sort(this._materialSortFunction);
        const length = depthSortedParticles.length;
        const indices32 = this._indices32;
        const indices = this._indices;
        let subMeshIndex = 0;
        let subMeshFaceId = 0;
        let sid = 0;
        let lastMatIndex = depthSortedParticles[0].materialIndex;
        materialIndexes.push(lastMatIndex);
        if (this._pickable) {
            this.pickedBySubMesh = [
                []
            ];
            this.pickedParticles = this.pickedBySubMesh[0];
        }
        for(let sorted = 0; sorted < length; sorted++){
            const sortedPart = depthSortedParticles[sorted];
            const lind = sortedPart.indicesLength;
            const sind = sortedPart.ind;
            if (sortedPart.materialIndex !== lastMatIndex) {
                lastMatIndex = sortedPart.materialIndex;
                indicesByMaterial.push(sid);
                materialIndexes.push(lastMatIndex);
                if (this._pickable) {
                    subMeshIndex++;
                    this.pickedBySubMesh[subMeshIndex] = [];
                    subMeshFaceId = 0;
                }
            }
            let faceId = 0;
            for(let i = 0; i < lind; i++){
                indices32[sid] = indices[sind + i];
                if (this._pickable) {
                    const f = i % 3;
                    if (f == 0) {
                        const pickedData = this.pickedBySubMesh[subMeshIndex][subMeshFaceId];
                        if (pickedData) {
                            pickedData.idx = sortedPart.idx;
                            pickedData.faceId = faceId;
                        } else this.pickedBySubMesh[subMeshIndex][subMeshFaceId] = {
                            idx: sortedPart.idx,
                            faceId: faceId
                        };
                        subMeshFaceId++;
                        faceId++;
                    }
                }
                sid++;
            }
        }
        indicesByMaterial.push(indices32.length); // add the last number to ease the indices start/count values for subMeshes creation
        if (this._updatable) this.mesh.updateIndices(indices32);
        return this;
    }
    /**
     * Sets the material indexes by id materialIndexesById[id] = materialIndex
     * @internal
     */ _setMaterialIndexesById() {
        this._materialIndexesById = {};
        for(let i = 0; i < this._materials.length; i++){
            const id = this._materials[i].uniqueId;
            this._materialIndexesById[id] = i;
        }
    }
    /**
     * Returns an array with unique values of Materials from the passed array
     * @param array the material array to be checked and filtered
     * @internal
     */ _filterUniqueMaterialId(array) {
        const filtered = array.filter(function(value, index, self) {
            return self.indexOf(value) === index;
        });
        return filtered;
    }
    /**
     * Sets a new Standard Material as _defaultMaterial if not already set.
     * @internal
     */ _setDefaultMaterial() {
        if (!this._defaultMaterial) this._defaultMaterial = new (0, $gAH3H.StandardMaterial)(this.name + "DefaultMaterial", this._scene);
        return this._defaultMaterial;
    }
    /**
     * Visibility helper : Recomputes the visible size according to the mesh bounding box
     * doc : https://doc.babylonjs.com/features/featuresDeepDive/particles/solid_particle_system/sps_visibility
     * @returns the SPS.
     */ refreshVisibleSize() {
        if (!this._isVisibilityBoxLocked) this.mesh.refreshBoundingInfo();
        return this;
    }
    /**
     * Visibility helper : Sets the size of a visibility box, this sets the underlying mesh bounding box.
     * @param size the size (float) of the visibility box
     * note : this doesn't lock the SPS mesh bounding box.
     * doc : https://doc.babylonjs.com/features/featuresDeepDive/particles/solid_particle_system/sps_visibility
     */ setVisibilityBox(size) {
        const vis = size / 2;
        this.mesh.buildBoundingInfo(new (0, $ha1VO.Vector3)(-vis, -vis, -vis), new (0, $ha1VO.Vector3)(vis, vis, vis));
    }
    /**
     * Gets whether the SPS as always visible or not
     * doc : https://doc.babylonjs.com/features/featuresDeepDive/particles/solid_particle_system/sps_visibility
     */ get isAlwaysVisible() {
        return this._alwaysVisible;
    }
    /**
     * Sets the SPS as always visible or not
     * doc : https://doc.babylonjs.com/features/featuresDeepDive/particles/solid_particle_system/sps_visibility
     */ set isAlwaysVisible(val) {
        this._alwaysVisible = val;
        this.mesh.alwaysSelectAsActiveMesh = val;
    }
    /**
     * Sets the SPS visibility box as locked or not. This enables/disables the underlying mesh bounding box updates.
     * doc : https://doc.babylonjs.com/features/featuresDeepDive/particles/solid_particle_system/sps_visibility
     */ set isVisibilityBoxLocked(val) {
        this._isVisibilityBoxLocked = val;
        const boundingInfo = this.mesh.getBoundingInfo();
        boundingInfo.isLocked = val;
    }
    /**
     * Gets if the SPS visibility box as locked or not. This enables/disables the underlying mesh bounding box updates.
     * doc : https://doc.babylonjs.com/features/featuresDeepDive/particles/solid_particle_system/sps_visibility
     */ get isVisibilityBoxLocked() {
        return this._isVisibilityBoxLocked;
    }
    /**
     * Tells to `setParticles()` to compute the particle rotations or not.
     * Default value : true. The SPS is faster when it's set to false.
     * Note : the particle rotations aren't stored values, so setting `computeParticleRotation` to false will prevents the particle to rotate.
     */ set computeParticleRotation(val) {
        this._computeParticleRotation = val;
    }
    /**
     * Tells to `setParticles()` to compute the particle colors or not.
     * Default value : true. The SPS is faster when it's set to false.
     * Note : the particle colors are stored values, so setting `computeParticleColor` to false will keep yet the last colors set.
     */ set computeParticleColor(val) {
        this._computeParticleColor = val;
    }
    set computeParticleTexture(val) {
        this._computeParticleTexture = val;
    }
    /**
     * Tells to `setParticles()` to call the vertex function for each vertex of each particle, or not.
     * Default value : false. The SPS is faster when it's set to false.
     * Note : the particle custom vertex positions aren't stored values.
     */ set computeParticleVertex(val) {
        this._computeParticleVertex = val;
    }
    /**
     * Tells to `setParticles()` to compute or not the mesh bounding box when computing the particle positions.
     */ set computeBoundingBox(val) {
        this._computeBoundingBox = val;
    }
    /**
     * Tells to `setParticles()` to sort or not the distance between each particle and the camera.
     * Skipped when `enableDepthSort` is set to `false` (default) at construction time.
     * Default : `true`
     */ set depthSortParticles(val) {
        this._depthSortParticles = val;
    }
    /**
     * Gets if `setParticles()` computes the particle rotations or not.
     * Default value : true. The SPS is faster when it's set to false.
     * Note : the particle rotations aren't stored values, so setting `computeParticleRotation` to false will prevents the particle to rotate.
     */ get computeParticleRotation() {
        return this._computeParticleRotation;
    }
    /**
     * Gets if `setParticles()` computes the particle colors or not.
     * Default value : true. The SPS is faster when it's set to false.
     * Note : the particle colors are stored values, so setting `computeParticleColor` to false will keep yet the last colors set.
     */ get computeParticleColor() {
        return this._computeParticleColor;
    }
    /**
     * Gets if `setParticles()` computes the particle textures or not.
     * Default value : true. The SPS is faster when it's set to false.
     * Note : the particle textures are stored values, so setting `computeParticleTexture` to false will keep yet the last colors set.
     */ get computeParticleTexture() {
        return this._computeParticleTexture;
    }
    /**
     * Gets if `setParticles()` calls the vertex function for each vertex of each particle, or not.
     * Default value : false. The SPS is faster when it's set to false.
     * Note : the particle custom vertex positions aren't stored values.
     */ get computeParticleVertex() {
        return this._computeParticleVertex;
    }
    /**
     * Gets if `setParticles()` computes or not the mesh bounding box when computing the particle positions.
     */ get computeBoundingBox() {
        return this._computeBoundingBox;
    }
    /**
     * Gets if `setParticles()` sorts or not the distance between each particle and the camera.
     * Skipped when `enableDepthSort` is set to `false` (default) at construction time.
     * Default : `true`
     */ get depthSortParticles() {
        return this._depthSortParticles;
    }
    /**
     * Gets if the SPS is created as expandable at construction time.
     * Default : `false`
     */ get expandable() {
        return this._expandable;
    }
    /**
     * Gets if the SPS supports the Multi Materials
     */ get multimaterialEnabled() {
        return this._multimaterialEnabled;
    }
    /**
     * Gets if the SPS uses the model materials for its own multimaterial.
     */ get useModelMaterial() {
        return this._useModelMaterial;
    }
    /**
     * The SPS used material array.
     */ get materials() {
        return this._materials;
    }
    /**
     * Sets the SPS MultiMaterial from the passed materials.
     * Note : the passed array is internally copied and not used then by reference.
     * @param materials an array of material objects. This array indexes are the materialIndex values of the particles.
     */ setMultiMaterial(materials) {
        this._materials = this._filterUniqueMaterialId(materials);
        this._setMaterialIndexesById();
        if (this._multimaterial) this._multimaterial.dispose();
        this._multimaterial = new (0, $3zFLd.MultiMaterial)(this.name + "MultiMaterial", this._scene);
        for(let m = 0; m < this._materials.length; m++)this._multimaterial.subMaterials.push(this._materials[m]);
        this.computeSubMeshes();
        this.mesh.material = this._multimaterial;
    }
    /**
     * The SPS computed multimaterial object
     */ get multimaterial() {
        return this._multimaterial;
    }
    set multimaterial(mm) {
        this._multimaterial = mm;
    }
    /**
     * If the subMeshes must be updated on the next call to setParticles()
     */ get autoUpdateSubMeshes() {
        return this._autoUpdateSubMeshes;
    }
    set autoUpdateSubMeshes(val) {
        this._autoUpdateSubMeshes = val;
    }
    // =======================================================================
    // Particle behavior logic
    // these following methods may be overwritten by the user to fit his needs
    /**
     * This function does nothing. It may be overwritten to set all the particle first values.
     * The SPS doesn't call this function, you may have to call it by your own.
     * doc : https://doc.babylonjs.com/features/featuresDeepDive/particles/solid_particle_system/manage_sps_particles
     */ initParticles() {}
    /**
     * This function does nothing. It may be overwritten to recycle a particle.
     * The SPS doesn't call this function, you may have to call it by your own.
     * doc : https://doc.babylonjs.com/features/featuresDeepDive/particles/solid_particle_system/manage_sps_particles
     * @param particle The particle to recycle
     * @returns the recycled particle
     */ recycleParticle(particle) {
        return particle;
    }
    /**
     * Updates a particle : this function should  be overwritten by the user.
     * It is called on each particle by `setParticles()`. This is the place to code each particle behavior.
     * doc : https://doc.babylonjs.com/features/featuresDeepDive/particles/solid_particle_system/manage_sps_particles
     * @example : just set a particle position or velocity and recycle conditions
     * @param particle The particle to update
     * @returns the updated particle
     */ updateParticle(particle) {
        return particle;
    }
    /**
     * Updates a vertex of a particle : it can be overwritten by the user.
     * This will be called on each vertex particle by `setParticles()` if `computeParticleVertex` is set to true only.
     * @param particle the current particle
     * @param vertex the current vertex of the current particle : a SolidParticleVertex object
     * @param pt the index of the current vertex in the particle shape
     * doc : https://doc.babylonjs.com/features/featuresDeepDive/particles/solid_particle_system/sps_vertices
     * @example : just set a vertex particle position or color
     * @returns the sps
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    updateParticleVertex(particle, vertex, pt) {
        return this;
    }
    /**
     * This will be called before any other treatment by `setParticles()` and will be passed three parameters.
     * This does nothing and may be overwritten by the user.
     * @param start the particle index in the particle array where to stop to iterate, same than the value passed to setParticle()
     * @param stop the particle index in the particle array where to stop to iterate, same than the value passed to setParticle()
     * @param update the boolean update value actually passed to setParticles()
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    beforeUpdateParticles(start, stop, update) {}
    /**
     * This will be called  by `setParticles()` after all the other treatments and just before the actual mesh update.
     * This will be passed three parameters.
     * This does nothing and may be overwritten by the user.
     * @param start the particle index in the particle array where to stop to iterate, same than the value passed to setParticle()
     * @param stop the particle index in the particle array where to stop to iterate, same than the value passed to setParticle()
     * @param update the boolean update value actually passed to setParticles()
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    afterUpdateParticles(start, stop, update) {}
}

});

parcelRegister("dkFul", function(module, exports) {

$parcel$export(module.exports, "CloudPoint", () => $9b4d53602f000f23$export$cf195f2111bb6392);
$parcel$export(module.exports, "PointsGroup", () => $9b4d53602f000f23$export$90f06773818c5a2);
parcelRequire("6rxfP");
var $7etnY = parcelRequire("7etnY");
var $ha1VO = parcelRequire("ha1VO");
class $9b4d53602f000f23$export$cf195f2111bb6392 {
    /**
     * Creates a Point Cloud object.
     * Don't create particles manually, use instead the PCS internal tools like _addParticle()
     * @param particleIndex (integer) is the particle index in the PCS pool. It's also the particle identifier.
     * @param group (PointsGroup) is the group the particle belongs to
     * @param groupId (integer) is the group identifier in the PCS.
     * @param idxInGroup (integer) is the index of the particle in the current point group (ex: the 10th point of addPoints(30))
     * @param pcs defines the PCS it is associated to
     */ constructor(particleIndex, group, groupId, idxInGroup, pcs){
        /**
         * particle global index
         */ this.idx = 0;
        /**
         * The color of the particle
         */ this.color = new (0, $7etnY.Color4)(1.0, 1.0, 1.0, 1.0);
        /**
         * The world space position of the particle.
         */ this.position = (0, $ha1VO.Vector3).Zero();
        /**
         * The world space rotation of the particle. (Not use if rotationQuaternion is set)
         */ this.rotation = (0, $ha1VO.Vector3).Zero();
        /**
         * The uv of the particle.
         */ this.uv = new (0, $ha1VO.Vector2)(0.0, 0.0);
        /**
         * The current speed of the particle.
         */ this.velocity = (0, $ha1VO.Vector3).Zero();
        /**
         * The pivot point in the particle local space.
         */ this.pivot = (0, $ha1VO.Vector3).Zero();
        /**
         * Must the particle be translated from its pivot point in its local space ?
         * In this case, the pivot point is set at the origin of the particle local space and the particle is translated.
         * Default : false
         */ this.translateFromPivot = false;
        /**
         * Index of this particle in the global "positions" array (Internal use)
         * @internal
         */ this._pos = 0;
        /**
         * @internal Index of this particle in the global "indices" array (Internal use)
         */ this._ind = 0;
        /**
         * Group id of this particle
         */ this.groupId = 0;
        /**
         * Index of the particle in its group id (Internal use)
         */ this.idxInGroup = 0;
        /**
         * @internal Still set as invisible in order to skip useless computations (Internal use)
         */ this._stillInvisible = false;
        /**
         * @internal Last computed particle rotation matrix
         */ this._rotationMatrix = [
            1.0,
            0.0,
            0.0,
            0.0,
            1.0,
            0.0,
            0.0,
            0.0,
            1.0
        ];
        /**
         * Parent particle Id, if any.
         * Default null.
         */ this.parentId = null;
        /**
         * @internal Internal global position in the PCS.
         */ this._globalPosition = (0, $ha1VO.Vector3).Zero();
        this.idx = particleIndex;
        this._group = group;
        this.groupId = groupId;
        this.idxInGroup = idxInGroup;
        this._pcs = pcs;
    }
    /**
     * get point size
     */ get size() {
        return this.size;
    }
    /**
     * Set point size
     */ set size(scale) {
        this.size = scale;
    }
    /**
     * Legacy support, changed quaternion to rotationQuaternion
     */ get quaternion() {
        return this.rotationQuaternion;
    }
    /**
     * Legacy support, changed quaternion to rotationQuaternion
     */ set quaternion(q) {
        this.rotationQuaternion = q;
    }
    /**
     * Returns a boolean. True if the particle intersects a mesh, else false
     * The intersection is computed on the particle position and Axis Aligned Bounding Box (AABB) or Sphere
     * @param target is the object (point or mesh) what the intersection is computed against
     * @param isSphere is boolean flag when false (default) bounding box of mesh is used, when true the bounding sphere is used
     * @returns true if it intersects
     */ intersectsMesh(target, isSphere) {
        if (!target.hasBoundingInfo) return false;
        if (!this._pcs.mesh) throw new Error("Point Cloud System doesnt contain the Mesh");
        if (isSphere) return target.getBoundingInfo().boundingSphere.intersectsPoint(this.position.add(this._pcs.mesh.position));
        const bbox = target.getBoundingInfo().boundingBox;
        const maxX = bbox.maximumWorld.x;
        const minX = bbox.minimumWorld.x;
        const maxY = bbox.maximumWorld.y;
        const minY = bbox.minimumWorld.y;
        const maxZ = bbox.maximumWorld.z;
        const minZ = bbox.minimumWorld.z;
        const x = this.position.x + this._pcs.mesh.position.x;
        const y = this.position.y + this._pcs.mesh.position.y;
        const z = this.position.z + this._pcs.mesh.position.z;
        return minX <= x && x <= maxX && minY <= y && y <= maxY && minZ <= z && z <= maxZ;
    }
    /**
     * get the rotation matrix of the particle
     * @internal
     */ getRotationMatrix(m) {
        let quaternion;
        if (this.rotationQuaternion) quaternion = this.rotationQuaternion;
        else {
            quaternion = (0, $ha1VO.TmpVectors).Quaternion[0];
            const rotation = this.rotation;
            (0, $ha1VO.Quaternion).RotationYawPitchRollToRef(rotation.y, rotation.x, rotation.z, quaternion);
        }
        quaternion.toRotationMatrix(m);
    }
}
class $9b4d53602f000f23$export$90f06773818c5a2 {
    /**
     * Get or set the groupId
     * @deprecated Please use groupId instead
     */ get groupID() {
        return this.groupId;
    }
    set groupID(groupID) {
        this.groupId = groupID;
    }
    /**
     * Creates a points group object. This is an internal reference to produce particles for the PCS.
     * PCS internal tool, don't use it manually.
     * @internal
     */ constructor(id, posFunction){
        this.groupId = id;
        this._positionFunction = posFunction;
    }
}

});

parcelRegister("6Q8c4", function(module, exports) {

$parcel$export(module.exports, "PointColor", () => $4fadf47ca952c6b7$export$65eab8f4ef160823);
$parcel$export(module.exports, "PointsCloudSystem", () => $4fadf47ca952c6b7$export$6da86280ebcfe44e);
parcelRequire("6rxfP");
var $7etnY = parcelRequire("7etnY");

var $ha1VO = parcelRequire("ha1VO");

var $kVtWi = parcelRequire("kVtWi");

var $b4i1f = parcelRequire("b4i1f");

var $5v6ry = parcelRequire("5v6ry");

var $fbuqw = parcelRequire("fbuqw");

var $ejQPp = parcelRequire("ejQPp");

var $dkFul = parcelRequire("dkFul");

var $3kez7 = parcelRequire("3kez7");

var $gAH3H = parcelRequire("gAH3H");

var $akOl3 = parcelRequire("akOl3");

var $1VEEL = parcelRequire("1VEEL");
var $4fadf47ca952c6b7$export$65eab8f4ef160823;
(function(PointColor) {
    /** color value */ PointColor[PointColor["Color"] = 2] = "Color";
    /** uv value */ PointColor[PointColor["UV"] = 1] = "UV";
    /** random value */ PointColor[PointColor["Random"] = 0] = "Random";
    /** stated value */ PointColor[PointColor["Stated"] = 3] = "Stated";
})($4fadf47ca952c6b7$export$65eab8f4ef160823 || ($4fadf47ca952c6b7$export$65eab8f4ef160823 = {}));
class $4fadf47ca952c6b7$export$6da86280ebcfe44e {
    /**
     * Gets the particle positions computed by the Point Cloud System
     */ get positions() {
        return this._positions32;
    }
    /**
     * Gets the particle colors computed by the Point Cloud System
     */ get colors() {
        return this._colors32;
    }
    /**
     * Gets the particle uvs computed by the Point Cloud System
     */ get uvs() {
        return this._uvs32;
    }
    /**
     * Creates a PCS (Points Cloud System) object
     * @param name (String) is the PCS name, this will be the underlying mesh name
     * @param pointSize (number) is the size for each point. Has no effect on a WebGPU engine.
     * @param scene (Scene) is the scene in which the PCS is added
     * @param options defines the options of the PCS e.g.
     * * updatable (optional boolean, default true) : if the PCS must be updatable or immutable
     * @param options.updatable
     */ constructor(name, pointSize, scene, options){
        /**
         *  The PCS array of cloud point objects. Just access each particle as with any classic array.
         *  Example : var p = SPS.particles[i];
         */ this.particles = new Array();
        /**
         * The PCS total number of particles. Read only. Use PCS.counter instead if you need to set your own value.
         */ this.nbParticles = 0;
        /**
         * This a counter for your own usage. It's not set by any SPS functions.
         */ this.counter = 0;
        /**
         * This empty object is intended to store some PCS specific or temporary values in order to lower the Garbage Collector activity.
         * Please read :
         */ this.vars = {};
        this._promises = [];
        this._positions = new Array();
        this._indices = new Array();
        this._normals = new Array();
        this._colors = new Array();
        this._uvs = new Array();
        this._updatable = true;
        this._isVisibilityBoxLocked = false;
        this._alwaysVisible = false;
        this._groups = new Array(); //start indices for each group of particles
        this._groupCounter = 0;
        this._computeParticleColor = true;
        this._computeParticleTexture = true;
        this._computeParticleRotation = true;
        this._computeBoundingBox = false;
        this._isReady = false;
        this.name = name;
        this._size = pointSize;
        this._scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        if (options && options.updatable !== undefined) this._updatable = options.updatable;
        else this._updatable = true;
    }
    /**
     * Builds the PCS underlying mesh. Returns a standard Mesh.
     * If no points were added to the PCS, the returned mesh is just a single point.
     * @param material The material to use to render the mesh. If not provided, will create a default one
     * @returns a promise for the created mesh
     */ buildMeshAsync(material) {
        return Promise.all(this._promises).then(()=>{
            this._isReady = true;
            return this._buildMesh(material);
        });
    }
    /**
     * @internal
     */ _buildMesh(material) {
        if (this.nbParticles === 0) this.addPoints(1);
        this._positions32 = new Float32Array(this._positions);
        this._uvs32 = new Float32Array(this._uvs);
        this._colors32 = new Float32Array(this._colors);
        const vertexData = new (0, $5v6ry.VertexData)();
        vertexData.set(this._positions32, (0, $b4i1f.VertexBuffer).PositionKind);
        if (this._uvs32.length > 0) vertexData.set(this._uvs32, (0, $b4i1f.VertexBuffer).UVKind);
        let ec = 0; //emissive color value 0 for UVs, 1 for color
        if (this._colors32.length > 0) {
            ec = 1;
            vertexData.set(this._colors32, (0, $b4i1f.VertexBuffer).ColorKind);
        }
        const mesh = new (0, $fbuqw.Mesh)(this.name, this._scene);
        vertexData.applyToMesh(mesh, this._updatable);
        this.mesh = mesh;
        // free memory
        this._positions = null;
        this._uvs = null;
        this._colors = null;
        if (!this._updatable) this.particles.length = 0;
        let mat = material;
        if (!mat) {
            mat = new (0, $gAH3H.StandardMaterial)("point cloud material", this._scene);
            mat.emissiveColor = new (0, $7etnY.Color3)(ec, ec, ec);
            mat.disableLighting = true;
            mat.pointsCloud = true;
            mat.pointSize = this._size;
        }
        mesh.material = mat;
        return new Promise((resolve)=>resolve(mesh));
    }
    // adds a new particle object in the particles array
    _addParticle(idx, group, groupId, idxInGroup) {
        const cp = new (0, $dkFul.CloudPoint)(idx, group, groupId, idxInGroup, this);
        this.particles.push(cp);
        return cp;
    }
    _randomUnitVector(particle) {
        particle.position = new (0, $ha1VO.Vector3)(Math.random(), Math.random(), Math.random());
        particle.color = new (0, $7etnY.Color4)(1, 1, 1, 1);
    }
    _getColorIndicesForCoord(pointsGroup, x, y, width) {
        const imageData = pointsGroup._groupImageData;
        const color = y * (width * 4) + x * 4;
        const colorIndices = [
            color,
            color + 1,
            color + 2,
            color + 3
        ];
        const redIndex = colorIndices[0];
        const greenIndex = colorIndices[1];
        const blueIndex = colorIndices[2];
        const alphaIndex = colorIndices[3];
        const redForCoord = imageData[redIndex];
        const greenForCoord = imageData[greenIndex];
        const blueForCoord = imageData[blueIndex];
        const alphaForCoord = imageData[alphaIndex];
        return new (0, $7etnY.Color4)(redForCoord / 255, greenForCoord / 255, blueForCoord / 255, alphaForCoord);
    }
    _setPointsColorOrUV(mesh, pointsGroup, isVolume, colorFromTexture, hasTexture, color, range, uvSetIndex) {
        uvSetIndex = uvSetIndex ?? 0;
        if (isVolume) mesh.updateFacetData();
        const boundInfo = mesh.getBoundingInfo();
        const diameter = 2 * boundInfo.boundingSphere.radius;
        let meshPos = mesh.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        const meshInd = mesh.getIndices();
        const meshUV = mesh.getVerticesData((0, $b4i1f.VertexBuffer).UVKind + (uvSetIndex ? uvSetIndex + 1 : ""));
        const meshCol = mesh.getVerticesData((0, $b4i1f.VertexBuffer).ColorKind);
        const place = (0, $ha1VO.Vector3).Zero();
        mesh.computeWorldMatrix();
        const meshMatrix = mesh.getWorldMatrix();
        if (!meshMatrix.isIdentity()) {
            meshPos = meshPos.slice(0);
            for(let p = 0; p < meshPos.length / 3; p++){
                (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(meshPos[3 * p], meshPos[3 * p + 1], meshPos[3 * p + 2], meshMatrix, place);
                meshPos[3 * p] = place.x;
                meshPos[3 * p + 1] = place.y;
                meshPos[3 * p + 2] = place.z;
            }
        }
        let idxPoints = 0;
        let id0 = 0;
        let id1 = 0;
        let id2 = 0;
        let v0X = 0;
        let v0Y = 0;
        let v0Z = 0;
        let v1X = 0;
        let v1Y = 0;
        let v1Z = 0;
        let v2X = 0;
        let v2Y = 0;
        let v2Z = 0;
        const vertex0 = (0, $ha1VO.Vector3).Zero();
        const vertex1 = (0, $ha1VO.Vector3).Zero();
        const vertex2 = (0, $ha1VO.Vector3).Zero();
        const vec0 = (0, $ha1VO.Vector3).Zero();
        const vec1 = (0, $ha1VO.Vector3).Zero();
        let uv0X = 0;
        let uv0Y = 0;
        let uv1X = 0;
        let uv1Y = 0;
        let uv2X = 0;
        let uv2Y = 0;
        const uv0 = (0, $ha1VO.Vector2).Zero();
        const uv1 = (0, $ha1VO.Vector2).Zero();
        const uv2 = (0, $ha1VO.Vector2).Zero();
        const uvec0 = (0, $ha1VO.Vector2).Zero();
        const uvec1 = (0, $ha1VO.Vector2).Zero();
        let col0X = 0;
        let col0Y = 0;
        let col0Z = 0;
        let col0A = 0;
        let col1X = 0;
        let col1Y = 0;
        let col1Z = 0;
        let col1A = 0;
        let col2X = 0;
        let col2Y = 0;
        let col2Z = 0;
        let col2A = 0;
        const col0 = (0, $ha1VO.Vector4).Zero();
        const col1 = (0, $ha1VO.Vector4).Zero();
        const col2 = (0, $ha1VO.Vector4).Zero();
        const colvec0 = (0, $ha1VO.Vector4).Zero();
        const colvec1 = (0, $ha1VO.Vector4).Zero();
        let lamda = 0;
        let mu = 0;
        range = range ? range : 0;
        let facetPoint;
        let uvPoint;
        let colPoint = new (0, $ha1VO.Vector4)(0, 0, 0, 0);
        let norm = (0, $ha1VO.Vector3).Zero();
        let tang = (0, $ha1VO.Vector3).Zero();
        let biNorm = (0, $ha1VO.Vector3).Zero();
        let angle = 0;
        let facetPlaneVec = (0, $ha1VO.Vector3).Zero();
        let gap = 0;
        let distance = 0;
        const ray = new (0, $3kez7.Ray)((0, $ha1VO.Vector3).Zero(), new (0, $ha1VO.Vector3)(1, 0, 0));
        let pickInfo;
        let direction = (0, $ha1VO.Vector3).Zero();
        for(let index = 0; index < meshInd.length / 3; index++){
            id0 = meshInd[3 * index];
            id1 = meshInd[3 * index + 1];
            id2 = meshInd[3 * index + 2];
            v0X = meshPos[3 * id0];
            v0Y = meshPos[3 * id0 + 1];
            v0Z = meshPos[3 * id0 + 2];
            v1X = meshPos[3 * id1];
            v1Y = meshPos[3 * id1 + 1];
            v1Z = meshPos[3 * id1 + 2];
            v2X = meshPos[3 * id2];
            v2Y = meshPos[3 * id2 + 1];
            v2Z = meshPos[3 * id2 + 2];
            vertex0.set(v0X, v0Y, v0Z);
            vertex1.set(v1X, v1Y, v1Z);
            vertex2.set(v2X, v2Y, v2Z);
            vertex1.subtractToRef(vertex0, vec0);
            vertex2.subtractToRef(vertex1, vec1);
            if (meshUV) {
                uv0X = meshUV[2 * id0];
                uv0Y = meshUV[2 * id0 + 1];
                uv1X = meshUV[2 * id1];
                uv1Y = meshUV[2 * id1 + 1];
                uv2X = meshUV[2 * id2];
                uv2Y = meshUV[2 * id2 + 1];
                uv0.set(uv0X, uv0Y);
                uv1.set(uv1X, uv1Y);
                uv2.set(uv2X, uv2Y);
                uv1.subtractToRef(uv0, uvec0);
                uv2.subtractToRef(uv1, uvec1);
            }
            if (meshCol && colorFromTexture) {
                col0X = meshCol[4 * id0];
                col0Y = meshCol[4 * id0 + 1];
                col0Z = meshCol[4 * id0 + 2];
                col0A = meshCol[4 * id0 + 3];
                col1X = meshCol[4 * id1];
                col1Y = meshCol[4 * id1 + 1];
                col1Z = meshCol[4 * id1 + 2];
                col1A = meshCol[4 * id1 + 3];
                col2X = meshCol[4 * id2];
                col2Y = meshCol[4 * id2 + 1];
                col2Z = meshCol[4 * id2 + 2];
                col2A = meshCol[4 * id2 + 3];
                col0.set(col0X, col0Y, col0Z, col0A);
                col1.set(col1X, col1Y, col1Z, col1A);
                col2.set(col2X, col2Y, col2Z, col2A);
                col1.subtractToRef(col0, colvec0);
                col2.subtractToRef(col1, colvec1);
            }
            let width;
            let height;
            let deltaS;
            let deltaV;
            let h;
            let s;
            let v;
            let hsvCol;
            const statedColor = new (0, $7etnY.Color3)(0, 0, 0);
            const colPoint3 = new (0, $7etnY.Color3)(0, 0, 0);
            let pointColors;
            let particle;
            for(let i = 0; i < pointsGroup._groupDensity[index]; i++){
                idxPoints = this.particles.length;
                this._addParticle(idxPoints, pointsGroup, this._groupCounter, index + i);
                particle = this.particles[idxPoints];
                //form a point inside the facet v0, v1, v2;
                lamda = Math.sqrt((0, $1VEEL.Scalar).RandomRange(0, 1));
                mu = (0, $1VEEL.Scalar).RandomRange(0, 1);
                facetPoint = vertex0.add(vec0.scale(lamda)).add(vec1.scale(lamda * mu));
                if (isVolume) {
                    norm = mesh.getFacetNormal(index).normalize().scale(-1);
                    tang = vec0.clone().normalize();
                    biNorm = (0, $ha1VO.Vector3).Cross(norm, tang);
                    angle = (0, $1VEEL.Scalar).RandomRange(0, 2 * Math.PI);
                    facetPlaneVec = tang.scale(Math.cos(angle)).add(biNorm.scale(Math.sin(angle)));
                    angle = (0, $1VEEL.Scalar).RandomRange(0.1, Math.PI / 2);
                    direction = facetPlaneVec.scale(Math.cos(angle)).add(norm.scale(Math.sin(angle)));
                    ray.origin = facetPoint.add(direction.scale(0.00001));
                    ray.direction = direction;
                    ray.length = diameter;
                    pickInfo = ray.intersectsMesh(mesh);
                    if (pickInfo.hit) {
                        distance = pickInfo.pickedPoint.subtract(facetPoint).length();
                        gap = (0, $1VEEL.Scalar).RandomRange(0, 1) * distance;
                        facetPoint.addInPlace(direction.scale(gap));
                    }
                }
                particle.position = facetPoint.clone();
                this._positions.push(particle.position.x, particle.position.y, particle.position.z);
                if (colorFromTexture !== undefined) {
                    if (meshUV) {
                        uvPoint = uv0.add(uvec0.scale(lamda)).add(uvec1.scale(lamda * mu));
                        if (colorFromTexture) {
                            //Set particle color to texture color
                            if (hasTexture && pointsGroup._groupImageData !== null) {
                                width = pointsGroup._groupImgWidth;
                                height = pointsGroup._groupImgHeight;
                                pointColors = this._getColorIndicesForCoord(pointsGroup, Math.round(uvPoint.x * width), Math.round(uvPoint.y * height), width);
                                particle.color = pointColors;
                                this._colors.push(pointColors.r, pointColors.g, pointColors.b, pointColors.a);
                            } else if (meshCol) {
                                //failure in texture and colors available
                                colPoint = col0.add(colvec0.scale(lamda)).add(colvec1.scale(lamda * mu));
                                particle.color = new (0, $7etnY.Color4)(colPoint.x, colPoint.y, colPoint.z, colPoint.w);
                                this._colors.push(colPoint.x, colPoint.y, colPoint.z, colPoint.w);
                            } else {
                                colPoint = col0.set(Math.random(), Math.random(), Math.random(), 1);
                                particle.color = new (0, $7etnY.Color4)(colPoint.x, colPoint.y, colPoint.z, colPoint.w);
                                this._colors.push(colPoint.x, colPoint.y, colPoint.z, colPoint.w);
                            }
                        } else {
                            //Set particle uv based on a mesh uv
                            particle.uv = uvPoint.clone();
                            this._uvs.push(particle.uv.x, particle.uv.y);
                        }
                    }
                } else {
                    if (color) {
                        statedColor.set(color.r, color.g, color.b);
                        deltaS = (0, $1VEEL.Scalar).RandomRange(-range, range);
                        deltaV = (0, $1VEEL.Scalar).RandomRange(-range, range);
                        hsvCol = statedColor.toHSV();
                        h = hsvCol.r;
                        s = hsvCol.g + deltaS;
                        v = hsvCol.b + deltaV;
                        if (s < 0) s = 0;
                        if (s > 1) s = 1;
                        if (v < 0) v = 0;
                        if (v > 1) v = 1;
                        (0, $7etnY.Color3).HSVtoRGBToRef(h, s, v, colPoint3);
                        colPoint.set(colPoint3.r, colPoint3.g, colPoint3.b, 1);
                    } else colPoint = col0.set(Math.random(), Math.random(), Math.random(), 1);
                    particle.color = new (0, $7etnY.Color4)(colPoint.x, colPoint.y, colPoint.z, colPoint.w);
                    this._colors.push(colPoint.x, colPoint.y, colPoint.z, colPoint.w);
                }
            }
        }
    }
    // stores mesh texture in dynamic texture for color pixel retrieval
    // when pointColor type is color for surface points
    _colorFromTexture(mesh, pointsGroup, isVolume) {
        if (mesh.material === null) {
            (0, $kVtWi.Logger).Warn(mesh.name + "has no material.");
            pointsGroup._groupImageData = null;
            this._setPointsColorOrUV(mesh, pointsGroup, isVolume, true, false);
            return;
        }
        const mat = mesh.material;
        const textureList = mat.getActiveTextures();
        if (textureList.length === 0) {
            (0, $kVtWi.Logger).Warn(mesh.name + "has no usable texture.");
            pointsGroup._groupImageData = null;
            this._setPointsColorOrUV(mesh, pointsGroup, isVolume, true, false);
            return;
        }
        const clone = mesh.clone();
        clone.setEnabled(false);
        this._promises.push(new Promise((resolve)=>{
            (0, $akOl3.BaseTexture).WhenAllReady(textureList, ()=>{
                let n = pointsGroup._textureNb;
                if (n < 0) n = 0;
                if (n > textureList.length - 1) n = textureList.length - 1;
                const finalize = ()=>{
                    pointsGroup._groupImgWidth = textureList[n].getSize().width;
                    pointsGroup._groupImgHeight = textureList[n].getSize().height;
                    this._setPointsColorOrUV(clone, pointsGroup, isVolume, true, true, undefined, undefined, textureList[n].coordinatesIndex);
                    clone.dispose();
                    resolve();
                };
                pointsGroup._groupImageData = null;
                const dataPromise = textureList[n].readPixels();
                if (!dataPromise) finalize();
                else dataPromise.then((data)=>{
                    pointsGroup._groupImageData = data;
                    finalize();
                });
            });
        }));
    }
    // calculates the point density per facet of a mesh for surface points
    _calculateDensity(nbPoints, positions, indices) {
        let id0;
        let id1;
        let id2;
        let v0X;
        let v0Y;
        let v0Z;
        let v1X;
        let v1Y;
        let v1Z;
        let v2X;
        let v2Y;
        let v2Z;
        const vertex0 = (0, $ha1VO.Vector3).Zero();
        const vertex1 = (0, $ha1VO.Vector3).Zero();
        const vertex2 = (0, $ha1VO.Vector3).Zero();
        const vec0 = (0, $ha1VO.Vector3).Zero();
        const vec1 = (0, $ha1VO.Vector3).Zero();
        const normal = (0, $ha1VO.Vector3).Zero();
        let area;
        const cumulativeAreas = [];
        let surfaceArea = 0;
        const nbFacets = indices.length / 3;
        //surface area
        for(let index = 0; index < nbFacets; index++){
            id0 = indices[3 * index];
            id1 = indices[3 * index + 1];
            id2 = indices[3 * index + 2];
            v0X = positions[3 * id0];
            v0Y = positions[3 * id0 + 1];
            v0Z = positions[3 * id0 + 2];
            v1X = positions[3 * id1];
            v1Y = positions[3 * id1 + 1];
            v1Z = positions[3 * id1 + 2];
            v2X = positions[3 * id2];
            v2Y = positions[3 * id2 + 1];
            v2Z = positions[3 * id2 + 2];
            vertex0.set(v0X, v0Y, v0Z);
            vertex1.set(v1X, v1Y, v1Z);
            vertex2.set(v2X, v2Y, v2Z);
            vertex1.subtractToRef(vertex0, vec0);
            vertex2.subtractToRef(vertex1, vec1);
            (0, $ha1VO.Vector3).CrossToRef(vec0, vec1, normal);
            area = 0.5 * normal.length();
            surfaceArea += area;
            cumulativeAreas[index] = surfaceArea;
        }
        const density = new Array(nbFacets);
        let remainingPoints = nbPoints;
        for(let index = nbFacets - 1; index > 0; index--){
            const cumulativeArea = cumulativeAreas[index];
            if (cumulativeArea === 0) // avoiding division by 0 upon degenerate triangles
            density[index] = 0;
            else {
                const area = cumulativeArea - cumulativeAreas[index - 1];
                const facetPointsWithFraction = area / cumulativeArea * remainingPoints;
                const floored = Math.floor(facetPointsWithFraction);
                const fraction = facetPointsWithFraction - floored;
                const extraPoint = Number(Math.random() < fraction);
                const facetPoints = floored + extraPoint;
                density[index] = facetPoints;
                remainingPoints -= facetPoints;
            }
        }
        density[0] = remainingPoints;
        return density;
    }
    /**
     * Adds points to the PCS in random positions within a unit sphere
     * @param nb (positive integer) the number of particles to be created from this model
     * @param pointFunction is an optional javascript function to be called for each particle on PCS creation
     * @returns the number of groups in the system
     */ addPoints(nb, pointFunction = this._randomUnitVector) {
        const pointsGroup = new (0, $dkFul.PointsGroup)(this._groupCounter, pointFunction);
        let cp;
        // particles
        let idx = this.nbParticles;
        for(let i = 0; i < nb; i++){
            cp = this._addParticle(idx, pointsGroup, this._groupCounter, i);
            if (pointsGroup && pointsGroup._positionFunction) pointsGroup._positionFunction(cp, idx, i);
            this._positions.push(cp.position.x, cp.position.y, cp.position.z);
            if (cp.color) this._colors.push(cp.color.r, cp.color.g, cp.color.b, cp.color.a);
            if (cp.uv) this._uvs.push(cp.uv.x, cp.uv.y);
            idx++;
        }
        this.nbParticles += nb;
        this._groupCounter++;
        return this._groupCounter;
    }
    /**
     * Adds points to the PCS from the surface of the model shape
     * @param mesh is any Mesh object that will be used as a surface model for the points
     * @param nb (positive integer) the number of particles to be created from this model
     * @param colorWith determines whether a point is colored using color (default), uv, random, stated or none (invisible)
     * @param color (color4) to be used when colorWith is stated or color (number) when used to specify texture position
     * @param range (number from 0 to 1) to determine the variation in shape and tone for a stated color
     * @returns the number of groups in the system
     */ addSurfacePoints(mesh, nb, colorWith, color, range) {
        let colored = colorWith ? colorWith : $4fadf47ca952c6b7$export$65eab8f4ef160823.Random;
        if (isNaN(colored) || colored < 0 || colored > 3) colored = $4fadf47ca952c6b7$export$65eab8f4ef160823.Random;
        const meshPos = mesh.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        const meshInd = mesh.getIndices();
        this._groups.push(this._groupCounter);
        const pointsGroup = new (0, $dkFul.PointsGroup)(this._groupCounter, null);
        pointsGroup._groupDensity = this._calculateDensity(nb, meshPos, meshInd);
        if (colored === $4fadf47ca952c6b7$export$65eab8f4ef160823.Color) pointsGroup._textureNb = color ? color : 0;
        else color = color ? color : new (0, $7etnY.Color4)(1, 1, 1, 1);
        switch(colored){
            case $4fadf47ca952c6b7$export$65eab8f4ef160823.Color:
                this._colorFromTexture(mesh, pointsGroup, false);
                break;
            case $4fadf47ca952c6b7$export$65eab8f4ef160823.UV:
                this._setPointsColorOrUV(mesh, pointsGroup, false, false, false);
                break;
            case $4fadf47ca952c6b7$export$65eab8f4ef160823.Random:
                this._setPointsColorOrUV(mesh, pointsGroup, false);
                break;
            case $4fadf47ca952c6b7$export$65eab8f4ef160823.Stated:
                this._setPointsColorOrUV(mesh, pointsGroup, false, undefined, undefined, color, range);
                break;
        }
        this.nbParticles += nb;
        this._groupCounter++;
        return this._groupCounter - 1;
    }
    /**
     * Adds points to the PCS inside the model shape
     * @param mesh is any Mesh object that will be used as a surface model for the points
     * @param nb (positive integer) the number of particles to be created from this model
     * @param colorWith determines whether a point is colored using color (default), uv, random, stated or none (invisible)
     * @param color (color4) to be used when colorWith is stated or color (number) when used to specify texture position
     * @param range (number from 0 to 1) to determine the variation in shape and tone for a stated color
     * @returns the number of groups in the system
     */ addVolumePoints(mesh, nb, colorWith, color, range) {
        let colored = colorWith ? colorWith : $4fadf47ca952c6b7$export$65eab8f4ef160823.Random;
        if (isNaN(colored) || colored < 0 || colored > 3) colored = $4fadf47ca952c6b7$export$65eab8f4ef160823.Random;
        const meshPos = mesh.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        const meshInd = mesh.getIndices();
        this._groups.push(this._groupCounter);
        const pointsGroup = new (0, $dkFul.PointsGroup)(this._groupCounter, null);
        pointsGroup._groupDensity = this._calculateDensity(nb, meshPos, meshInd);
        if (colored === $4fadf47ca952c6b7$export$65eab8f4ef160823.Color) pointsGroup._textureNb = color ? color : 0;
        else color = color ? color : new (0, $7etnY.Color4)(1, 1, 1, 1);
        switch(colored){
            case $4fadf47ca952c6b7$export$65eab8f4ef160823.Color:
                this._colorFromTexture(mesh, pointsGroup, true);
                break;
            case $4fadf47ca952c6b7$export$65eab8f4ef160823.UV:
                this._setPointsColorOrUV(mesh, pointsGroup, true, false, false);
                break;
            case $4fadf47ca952c6b7$export$65eab8f4ef160823.Random:
                this._setPointsColorOrUV(mesh, pointsGroup, true);
                break;
            case $4fadf47ca952c6b7$export$65eab8f4ef160823.Stated:
                this._setPointsColorOrUV(mesh, pointsGroup, true, undefined, undefined, color, range);
                break;
        }
        this.nbParticles += nb;
        this._groupCounter++;
        return this._groupCounter - 1;
    }
    /**
     *  Sets all the particles : this method actually really updates the mesh according to the particle positions, rotations, colors, textures, etc.
     *  This method calls `updateParticle()` for each particle of the SPS.
     *  For an animated SPS, it is usually called within the render loop.
     * @param start The particle index in the particle array where to start to compute the particle property values _(default 0)_
     * @param end The particle index in the particle array where to stop to compute the particle property values _(default nbParticle - 1)_
     * @param update If the mesh must be finally updated on this call after all the particle computations _(default true)_
     * @returns the PCS.
     */ setParticles(start = 0, end = this.nbParticles - 1, update = true) {
        if (!this._updatable || !this._isReady) return this;
        // custom beforeUpdate
        this.beforeUpdateParticles(start, end, update);
        const rotMatrix = (0, $ha1VO.TmpVectors).Matrix[0];
        const mesh = this.mesh;
        const colors32 = this._colors32;
        const positions32 = this._positions32;
        const uvs32 = this._uvs32;
        const tempVectors = (0, $ha1VO.TmpVectors).Vector3;
        const camAxisX = tempVectors[5].copyFromFloats(1.0, 0.0, 0.0);
        const camAxisY = tempVectors[6].copyFromFloats(0.0, 1.0, 0.0);
        const camAxisZ = tempVectors[7].copyFromFloats(0.0, 0.0, 1.0);
        const minimum = tempVectors[8].setAll(Number.MAX_VALUE);
        const maximum = tempVectors[9].setAll(-Number.MAX_VALUE);
        (0, $ha1VO.Matrix).IdentityToRef(rotMatrix);
        let idx = 0; // current index of the particle
        if (this.mesh?.isFacetDataEnabled) this._computeBoundingBox = true;
        end = end >= this.nbParticles ? this.nbParticles - 1 : end;
        if (this._computeBoundingBox) {
            if (start != 0 || end != this.nbParticles - 1) {
                // only some particles are updated, then use the current existing BBox basis. Note : it can only increase.
                const boundingInfo = this.mesh?.getBoundingInfo();
                if (boundingInfo) {
                    minimum.copyFrom(boundingInfo.minimum);
                    maximum.copyFrom(boundingInfo.maximum);
                }
            }
        }
        idx = 0; // particle index
        let pindex = 0; //index in positions array
        let cindex = 0; //index in color array
        let uindex = 0; //index in uv array
        // particle loop
        for(let p = start; p <= end; p++){
            const particle = this.particles[p];
            idx = particle.idx;
            pindex = 3 * idx;
            cindex = 4 * idx;
            uindex = 2 * idx;
            // call to custom user function to update the particle properties
            this.updateParticle(particle);
            const particleRotationMatrix = particle._rotationMatrix;
            const particlePosition = particle.position;
            const particleGlobalPosition = particle._globalPosition;
            if (this._computeParticleRotation) particle.getRotationMatrix(rotMatrix);
            const particleHasParent = particle.parentId !== null;
            if (particleHasParent) {
                const parent = this.particles[particle.parentId];
                const parentRotationMatrix = parent._rotationMatrix;
                const parentGlobalPosition = parent._globalPosition;
                const rotatedY = particlePosition.x * parentRotationMatrix[1] + particlePosition.y * parentRotationMatrix[4] + particlePosition.z * parentRotationMatrix[7];
                const rotatedX = particlePosition.x * parentRotationMatrix[0] + particlePosition.y * parentRotationMatrix[3] + particlePosition.z * parentRotationMatrix[6];
                const rotatedZ = particlePosition.x * parentRotationMatrix[2] + particlePosition.y * parentRotationMatrix[5] + particlePosition.z * parentRotationMatrix[8];
                particleGlobalPosition.x = parentGlobalPosition.x + rotatedX;
                particleGlobalPosition.y = parentGlobalPosition.y + rotatedY;
                particleGlobalPosition.z = parentGlobalPosition.z + rotatedZ;
                if (this._computeParticleRotation) {
                    const rotMatrixValues = rotMatrix.m;
                    particleRotationMatrix[0] = rotMatrixValues[0] * parentRotationMatrix[0] + rotMatrixValues[1] * parentRotationMatrix[3] + rotMatrixValues[2] * parentRotationMatrix[6];
                    particleRotationMatrix[1] = rotMatrixValues[0] * parentRotationMatrix[1] + rotMatrixValues[1] * parentRotationMatrix[4] + rotMatrixValues[2] * parentRotationMatrix[7];
                    particleRotationMatrix[2] = rotMatrixValues[0] * parentRotationMatrix[2] + rotMatrixValues[1] * parentRotationMatrix[5] + rotMatrixValues[2] * parentRotationMatrix[8];
                    particleRotationMatrix[3] = rotMatrixValues[4] * parentRotationMatrix[0] + rotMatrixValues[5] * parentRotationMatrix[3] + rotMatrixValues[6] * parentRotationMatrix[6];
                    particleRotationMatrix[4] = rotMatrixValues[4] * parentRotationMatrix[1] + rotMatrixValues[5] * parentRotationMatrix[4] + rotMatrixValues[6] * parentRotationMatrix[7];
                    particleRotationMatrix[5] = rotMatrixValues[4] * parentRotationMatrix[2] + rotMatrixValues[5] * parentRotationMatrix[5] + rotMatrixValues[6] * parentRotationMatrix[8];
                    particleRotationMatrix[6] = rotMatrixValues[8] * parentRotationMatrix[0] + rotMatrixValues[9] * parentRotationMatrix[3] + rotMatrixValues[10] * parentRotationMatrix[6];
                    particleRotationMatrix[7] = rotMatrixValues[8] * parentRotationMatrix[1] + rotMatrixValues[9] * parentRotationMatrix[4] + rotMatrixValues[10] * parentRotationMatrix[7];
                    particleRotationMatrix[8] = rotMatrixValues[8] * parentRotationMatrix[2] + rotMatrixValues[9] * parentRotationMatrix[5] + rotMatrixValues[10] * parentRotationMatrix[8];
                }
            } else {
                particleGlobalPosition.x = 0;
                particleGlobalPosition.y = 0;
                particleGlobalPosition.z = 0;
                if (this._computeParticleRotation) {
                    const rotMatrixValues = rotMatrix.m;
                    particleRotationMatrix[0] = rotMatrixValues[0];
                    particleRotationMatrix[1] = rotMatrixValues[1];
                    particleRotationMatrix[2] = rotMatrixValues[2];
                    particleRotationMatrix[3] = rotMatrixValues[4];
                    particleRotationMatrix[4] = rotMatrixValues[5];
                    particleRotationMatrix[5] = rotMatrixValues[6];
                    particleRotationMatrix[6] = rotMatrixValues[8];
                    particleRotationMatrix[7] = rotMatrixValues[9];
                    particleRotationMatrix[8] = rotMatrixValues[10];
                }
            }
            const pivotBackTranslation = tempVectors[11];
            if (particle.translateFromPivot) pivotBackTranslation.setAll(0.0);
            else pivotBackTranslation.copyFrom(particle.pivot);
            // positions
            const tmpVertex = tempVectors[0];
            tmpVertex.copyFrom(particle.position);
            const vertexX = tmpVertex.x - particle.pivot.x;
            const vertexY = tmpVertex.y - particle.pivot.y;
            const vertexZ = tmpVertex.z - particle.pivot.z;
            let rotatedX = vertexX * particleRotationMatrix[0] + vertexY * particleRotationMatrix[3] + vertexZ * particleRotationMatrix[6];
            let rotatedY = vertexX * particleRotationMatrix[1] + vertexY * particleRotationMatrix[4] + vertexZ * particleRotationMatrix[7];
            let rotatedZ = vertexX * particleRotationMatrix[2] + vertexY * particleRotationMatrix[5] + vertexZ * particleRotationMatrix[8];
            rotatedX += pivotBackTranslation.x;
            rotatedY += pivotBackTranslation.y;
            rotatedZ += pivotBackTranslation.z;
            const px = positions32[pindex] = particleGlobalPosition.x + camAxisX.x * rotatedX + camAxisY.x * rotatedY + camAxisZ.x * rotatedZ;
            const py = positions32[pindex + 1] = particleGlobalPosition.y + camAxisX.y * rotatedX + camAxisY.y * rotatedY + camAxisZ.y * rotatedZ;
            const pz = positions32[pindex + 2] = particleGlobalPosition.z + camAxisX.z * rotatedX + camAxisY.z * rotatedY + camAxisZ.z * rotatedZ;
            if (this._computeBoundingBox) {
                minimum.minimizeInPlaceFromFloats(px, py, pz);
                maximum.maximizeInPlaceFromFloats(px, py, pz);
            }
            if (this._computeParticleColor && particle.color) {
                const color = particle.color;
                const colors32 = this._colors32;
                colors32[cindex] = color.r;
                colors32[cindex + 1] = color.g;
                colors32[cindex + 2] = color.b;
                colors32[cindex + 3] = color.a;
            }
            if (this._computeParticleTexture && particle.uv) {
                const uv = particle.uv;
                const uvs32 = this._uvs32;
                uvs32[uindex] = uv.x;
                uvs32[uindex + 1] = uv.y;
            }
        }
        // if the VBO must be updated
        if (mesh) {
            if (update) {
                if (this._computeParticleColor) mesh.updateVerticesData((0, $b4i1f.VertexBuffer).ColorKind, colors32, false, false);
                if (this._computeParticleTexture) mesh.updateVerticesData((0, $b4i1f.VertexBuffer).UVKind, uvs32, false, false);
                mesh.updateVerticesData((0, $b4i1f.VertexBuffer).PositionKind, positions32, false, false);
            }
            if (this._computeBoundingBox) {
                if (mesh.hasBoundingInfo) mesh.getBoundingInfo().reConstruct(minimum, maximum, mesh._worldMatrix);
                else mesh.buildBoundingInfo(minimum, maximum, mesh._worldMatrix);
            }
        }
        this.afterUpdateParticles(start, end, update);
        return this;
    }
    /**
     * Disposes the PCS.
     */ dispose() {
        this.mesh?.dispose();
        this.vars = null;
        // drop references to internal big arrays for the GC
        this._positions = null;
        this._indices = null;
        this._normals = null;
        this._uvs = null;
        this._colors = null;
        this._indices32 = null;
        this._positions32 = null;
        this._uvs32 = null;
        this._colors32 = null;
    }
    /**
     * Visibility helper : Recomputes the visible size according to the mesh bounding box
     * doc :
     * @returns the PCS.
     */ refreshVisibleSize() {
        if (!this._isVisibilityBoxLocked) this.mesh?.refreshBoundingInfo();
        return this;
    }
    /**
     * Visibility helper : Sets the size of a visibility box, this sets the underlying mesh bounding box.
     * @param size the size (float) of the visibility box
     * note : this doesn't lock the PCS mesh bounding box.
     * doc :
     */ setVisibilityBox(size) {
        if (!this.mesh) return;
        const vis = size / 2;
        this.mesh.buildBoundingInfo(new (0, $ha1VO.Vector3)(-vis, -vis, -vis), new (0, $ha1VO.Vector3)(vis, vis, vis));
    }
    /**
     * Gets whether the PCS is always visible or not
     * doc :
     */ get isAlwaysVisible() {
        return this._alwaysVisible;
    }
    /**
     * Sets the PCS as always visible or not
     * doc :
     */ set isAlwaysVisible(val) {
        if (!this.mesh) return;
        this._alwaysVisible = val;
        this.mesh.alwaysSelectAsActiveMesh = val;
    }
    /**
     * Tells to `setParticles()` to compute the particle rotations or not
     * Default value : false. The PCS is faster when it's set to false
     * Note : particle rotations are only applied to parent particles
     * Note : the particle rotations aren't stored values, so setting `computeParticleRotation` to false will prevents the particle to rotate
     */ set computeParticleRotation(val) {
        this._computeParticleRotation = val;
    }
    /**
     * Tells to `setParticles()` to compute the particle colors or not.
     * Default value : true. The PCS is faster when it's set to false.
     * Note : the particle colors are stored values, so setting `computeParticleColor` to false will keep yet the last colors set.
     */ set computeParticleColor(val) {
        this._computeParticleColor = val;
    }
    set computeParticleTexture(val) {
        this._computeParticleTexture = val;
    }
    /**
     * Gets if `setParticles()` computes the particle colors or not.
     * Default value : false. The PCS is faster when it's set to false.
     * Note : the particle colors are stored values, so setting `computeParticleColor` to false will keep yet the last colors set.
     */ get computeParticleColor() {
        return this._computeParticleColor;
    }
    /**
     * Gets if `setParticles()` computes the particle textures or not.
     * Default value : false. The PCS is faster when it's set to false.
     * Note : the particle textures are stored values, so setting `computeParticleTexture` to false will keep yet the last colors set.
     */ get computeParticleTexture() {
        return this._computeParticleTexture;
    }
    /**
     * Tells to `setParticles()` to compute or not the mesh bounding box when computing the particle positions.
     */ set computeBoundingBox(val) {
        this._computeBoundingBox = val;
    }
    /**
     * Gets if `setParticles()` computes or not the mesh bounding box when computing the particle positions.
     */ get computeBoundingBox() {
        return this._computeBoundingBox;
    }
    // =======================================================================
    // Particle behavior logic
    // these following methods may be overwritten by users to fit their needs
    /**
     * This function does nothing. It may be overwritten to set all the particle first values.
     * The PCS doesn't call this function, you may have to call it by your own.
     * doc :
     */ initParticles() {}
    /**
     * This function does nothing. It may be overwritten to recycle a particle
     * The PCS doesn't call this function, you can to call it
     * doc :
     * @param particle The particle to recycle
     * @returns the recycled particle
     */ recycleParticle(particle) {
        return particle;
    }
    /**
     * Updates a particle : this function should  be overwritten by the user.
     * It is called on each particle by `setParticles()`. This is the place to code each particle behavior.
     * doc :
     * @example : just set a particle position or velocity and recycle conditions
     * @param particle The particle to update
     * @returns the updated particle
     */ updateParticle(particle) {
        return particle;
    }
    /**
     * This will be called before any other treatment by `setParticles()` and will be passed three parameters.
     * This does nothing and may be overwritten by the user.
     * @param start the particle index in the particle array where to start to iterate, same than the value passed to setParticle()
     * @param stop the particle index in the particle array where to stop to iterate, same than the value passed to setParticle()
     * @param update the boolean update value actually passed to setParticles()
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    beforeUpdateParticles(start, stop, update) {}
    /**
     * This will be called  by `setParticles()` after all the other treatments and just before the actual mesh update.
     * This will be passed three parameters.
     * This does nothing and may be overwritten by the user.
     * @param start the particle index in the particle array where to start to iterate, same than the value passed to setParticle()
     * @param stop the particle index in the particle array where to stop to iterate, same than the value passed to setParticle()
     * @param update the boolean update value actually passed to setParticles()
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    afterUpdateParticles(start, stop, update) {}
}

});


parcelRegister("4d3nY", function(module, exports) {
/* eslint-disable import/no-internal-modules */ 
var $j5sKE = parcelRequire("j5sKE");

var $j3zGf = parcelRequire("j3zGf");

var $6z2KE = parcelRequire("6z2KE");

var $4oZ5Y = parcelRequire("4oZ5Y");

var $911Bn = parcelRequire("911Bn");

var $iz1eP = parcelRequire("iz1eP");

var $jcqPJ = parcelRequire("jcqPJ");

var $kPhxB = parcelRequire("kPhxB");

var $Chscs = parcelRequire("Chscs");

var $iFPuq = parcelRequire("iFPuq");
$parcel$exportWildcard(module.exports, $j5sKE);
$parcel$exportWildcard(module.exports, $j3zGf);
$parcel$exportWildcard(module.exports, $6z2KE);
$parcel$exportWildcard(module.exports, $4oZ5Y);
$parcel$exportWildcard(module.exports, $911Bn);
$parcel$exportWildcard(module.exports, $iz1eP);
$parcel$exportWildcard(module.exports, $jcqPJ);
$parcel$exportWildcard(module.exports, $kPhxB);
$parcel$exportWildcard(module.exports, $Chscs);
$parcel$exportWildcard(module.exports, $iFPuq);

});
parcelRegister("j5sKE", function(module, exports) {
/* eslint-disable import/no-internal-modules */ 
var $2OGCp = parcelRequire("2OGCp");

var $4qQ0v = parcelRequire("4qQ0v");

var $4oZ5Y = parcelRequire("4oZ5Y");

var $iz3U8 = parcelRequire("iz3U8");

var $kGTHw = parcelRequire("kGTHw");

var $iArsL = parcelRequire("iArsL");
$parcel$exportWildcard(module.exports, $2OGCp);
$parcel$exportWildcard(module.exports, $4qQ0v);
$parcel$exportWildcard(module.exports, $4oZ5Y);
$parcel$exportWildcard(module.exports, $iz3U8);
$parcel$exportWildcard(module.exports, $kGTHw);
$parcel$exportWildcard(module.exports, $iArsL);

});
parcelRegister("2OGCp", function(module, exports) {

});

parcelRegister("4oZ5Y", function(module, exports) {

var $0cHNL = parcelRequire("0cHNL");

var $kGTHw = parcelRequire("kGTHw");
Object.defineProperty((0, $0cHNL.AbstractMesh).prototype, "physicsImpostor", {
    get: function() {
        return this._physicsImpostor;
    },
    set: function(value) {
        if (this._physicsImpostor === value) return;
        if (this._disposePhysicsObserver) this.onDisposeObservable.remove(this._disposePhysicsObserver);
        this._physicsImpostor = value;
        if (value) this._disposePhysicsObserver = this.onDisposeObservable.add(()=>{
            // Physics
            if (this.physicsImpostor) {
                this.physicsImpostor.dispose();
                this.physicsImpostor = null;
            }
        });
    },
    enumerable: true,
    configurable: true
});
/**
 * Gets the current physics impostor
 * @see https://doc.babylonjs.com/features/featuresDeepDive/physics
 * @returns a physics impostor or null
 */ (0, $0cHNL.AbstractMesh).prototype.getPhysicsImpostor = function() {
    return this.physicsImpostor;
};
/**
 * Apply a physic impulse to the mesh
 * @param force defines the force to apply
 * @param contactPoint defines where to apply the force
 * @returns the current mesh
 * @see https://doc.babylonjs.com/features/featuresDeepDive/physics/usingPhysicsEngine
 */ (0, $0cHNL.AbstractMesh).prototype.applyImpulse = function(force, contactPoint) {
    if (!this.physicsImpostor) return this;
    this.physicsImpostor.applyImpulse(force, contactPoint);
    return this;
};
/**
 * Creates a physic joint between two meshes
 * @param otherMesh defines the other mesh to use
 * @param pivot1 defines the pivot to use on this mesh
 * @param pivot2 defines the pivot to use on the other mesh
 * @param options defines additional options (can be plugin dependent)
 * @returns the current mesh
 * @see https://www.babylonjs-playground.com/#0BS5U0#0
 */ (0, $0cHNL.AbstractMesh).prototype.setPhysicsLinkWith = function(otherMesh, pivot1, pivot2, options) {
    if (!this.physicsImpostor || !otherMesh.physicsImpostor) return this;
    this.physicsImpostor.createJoint(otherMesh.physicsImpostor, (0, $kGTHw.PhysicsJoint).HingeJoint, {
        mainPivot: pivot1,
        connectedPivot: pivot2,
        nativeParams: options
    });
    return this;
};

});

parcelRegister("iArsL", function(module, exports) {

var $9l7E8 = parcelRequire("9l7E8");

var $hEg94 = parcelRequire("hEg94");

var $9o1yl = parcelRequire("9o1yl");
$parcel$exportWildcard(module.exports, $9l7E8);
$parcel$exportWildcard(module.exports, $hEg94);
$parcel$exportWildcard(module.exports, $9o1yl);

});


parcelRegister("j3zGf", function(module, exports) {

$parcel$export(module.exports, "PhysicsEngineV2", () => (parcelRequire("ku6ll")).PhysicsEngine);
/* eslint-disable import/no-internal-modules */ 
var $ku6ll = parcelRequire("ku6ll");

var $8kMw0 = parcelRequire("8kMw0");

var $1UZV7 = parcelRequire("1UZV7");

var $fQEDT = parcelRequire("fQEDT");

var $3Z9d3 = parcelRequire("3Z9d3");

var $ifBMv = parcelRequire("ifBMv");

var $bRVTG = parcelRequire("bRVTG");

var $fopmL = parcelRequire("fopmL");

var $l142r = parcelRequire("l142r");
$parcel$exportWildcard(module.exports, $8kMw0);
$parcel$exportWildcard(module.exports, $1UZV7);
$parcel$exportWildcard(module.exports, $fQEDT);
$parcel$exportWildcard(module.exports, $3Z9d3);
$parcel$exportWildcard(module.exports, $ifBMv);
$parcel$exportWildcard(module.exports, $bRVTG);
$parcel$exportWildcard(module.exports, $fopmL);
$parcel$exportWildcard(module.exports, $l142r);

});
parcelRegister("ku6ll", function(module, exports) {

$parcel$export(module.exports, "PhysicsEngine", () => $ee9b879dd6482068$export$69b1b1c72d4bbb9d);

var $ha1VO = parcelRequire("ha1VO");

var $iz1eP = parcelRequire("iz1eP");

var $dUFYy = parcelRequire("dUFYy");
class $ee9b879dd6482068$export$69b1b1c72d4bbb9d {
    /**
     *
     * @returns physics plugin version
     */ getPluginVersion() {
        return this._physicsPlugin.getPluginVersion();
    }
    // eslint-disable-next-line jsdoc/require-returns-check
    /**
     * Factory used to create the default physics plugin.
     * @returns The default physics plugin
     */ static DefaultPluginFactory() {
        throw (0, $dUFYy._WarnImport)("");
    }
    /**
     * Creates a new Physics Engine
     * @param gravity defines the gravity vector used by the simulation
     * @param _physicsPlugin defines the plugin to use (CannonJS by default)
     */ constructor(gravity, _physicsPlugin = $ee9b879dd6482068$export$69b1b1c72d4bbb9d.DefaultPluginFactory()){
        this._physicsPlugin = _physicsPlugin;
        /** @internal */ this._physicsBodies = [];
        this._subTimeStep = 0;
        gravity = gravity || new (0, $ha1VO.Vector3)(0, -9.807, 0);
        this.setGravity(gravity);
        this.setTimeStep();
    }
    /**
     * Sets the gravity vector used by the simulation
     * @param gravity defines the gravity vector to use
     */ setGravity(gravity) {
        this.gravity = gravity;
        this._physicsPlugin.setGravity(this.gravity);
    }
    /**
     * Set the time step of the physics engine.
     * Default is 1/60.
     * To slow it down, enter 1/600 for example.
     * To speed it up, 1/30
     * Unit is seconds.
     * @param newTimeStep defines the new timestep to apply to this world.
     */ setTimeStep(newTimeStep = 1 / 60) {
        this._physicsPlugin.setTimeStep(newTimeStep);
    }
    /**
     * Get the time step of the physics engine.
     * @returns the current time step
     */ getTimeStep() {
        return this._physicsPlugin.getTimeStep();
    }
    /**
     * Set the sub time step of the physics engine.
     * Default is 0 meaning there is no sub steps
     * To increase physics resolution precision, set a small value (like 1 ms)
     * @param subTimeStep defines the new sub timestep used for physics resolution.
     */ setSubTimeStep(subTimeStep = 0) {
        this._subTimeStep = subTimeStep;
    }
    /**
     * Get the sub time step of the physics engine.
     * @returns the current sub time step
     */ getSubTimeStep() {
        return this._subTimeStep;
    }
    /**
     * Release all resources
     */ dispose() {
        this._physicsPlugin.dispose();
    }
    /**
     * Gets the name of the current physics plugin
     * @returns the name of the plugin
     */ getPhysicsPluginName() {
        return this._physicsPlugin.name;
    }
    /**
     * Adding a new impostor for the impostor tracking.
     * This will be done by the impostor itself.
     * @param impostor the impostor to add
     */ /**
     * Called by the scene. No need to call it.
     * @param delta defines the timespan between frames
     */ _step(delta) {
        if (delta > 0.1) delta = 0.1;
        else if (delta <= 0) delta = 1.0 / 60.0;
        this._physicsPlugin.executeStep(delta, this._physicsBodies);
    }
    /**
     * Add a body as an active component of this engine
     * @param physicsBody The body to add
     */ addBody(physicsBody) {
        this._physicsBodies.push(physicsBody);
    }
    /**
     * Removes a particular body from this engine
     * @param physicsBody The body to remove from the simulation
     */ removeBody(physicsBody) {
        const index = this._physicsBodies.indexOf(physicsBody);
        if (index > -1) /*const removed =*/ this._physicsBodies.splice(index, 1);
    }
    /**
     * @returns an array of bodies added to this engine
     */ getBodies() {
        return this._physicsBodies;
    }
    /**
     * Gets the current plugin used to run the simulation
     * @returns current plugin
     */ getPhysicsPlugin() {
        return this._physicsPlugin;
    }
    /**
     * Does a raycast in the physics world
     * @param from when should the ray start?
     * @param to when should the ray end?
     * @param result resulting PhysicsRaycastResult
     * @param query raycast query object
     */ raycastToRef(from, to, result, query) {
        this._physicsPlugin.raycast(from, to, result, query);
    }
    /**
     * Does a raycast in the physics world
     * @param from when should the ray start?
     * @param to when should the ray end?
     * @param query raycast query object
     * @returns PhysicsRaycastResult
     */ raycast(from, to, query) {
        const result = new (0, $iz1eP.PhysicsRaycastResult)();
        this._physicsPlugin.raycast(from, to, result, query);
        return result;
    }
}

});

parcelRegister("8kMw0", function(module, exports) {

$parcel$export(module.exports, "PhysicsBody", () => $6115d31d7c33f4fc$export$8154f9fed15a9853);

var $fopmL = parcelRequire("fopmL");

var $ha1VO = parcelRequire("ha1VO");

var $dbxbu = parcelRequire("dbxbu");
class $6115d31d7c33f4fc$export$8154f9fed15a9853 {
    /**
     * Constructs a new physics body for the given node.
     * @param transformNode - The Transform Node to construct the physics body for. For better performance, it is advised that this node does not have a parent.
     * @param motionType - The motion type of the physics body. The options are:
     *  - PhysicsMotionType.STATIC - Static bodies are not moving and unaffected by forces or collisions. They are good for level boundaries or terrain.
     *  - PhysicsMotionType.DYNAMIC - Dynamic bodies are fully simulated. They can move and collide with other objects.
     *  - PhysicsMotionType.ANIMATED - They behave like dynamic bodies, but they won't be affected by other bodies, but still push other bodies out of the way.
     * @param startsAsleep - Whether the physics body should start in a sleeping state (not a guarantee). Defaults to false.
     * @param scene - The scene containing the physics engine.
     *
     * This code is useful for creating a physics body for a given Transform Node in a scene.
     * It checks the version of the physics engine and the physics plugin, and initializes the body accordingly.
     * It also sets the node's rotation quaternion if it is not already set. Finally, it adds the body to the physics engine.
     */ constructor(transformNode, motionType, startsAsleep, scene){
        /**
         * V2 Physics plugin private data for single Transform
         */ this._pluginData = undefined;
        /**
         * V2 Physics plugin private data for instances
         */ this._pluginDataInstances = [];
        /**
         * If the collision callback is enabled
         */ this._collisionCBEnabled = false;
        /**
         * If the collision ended callback is enabled
         */ this._collisionEndedCBEnabled = false;
        /**
         * Disable pre-step that consists in updating Physics Body from Transform Node Translation/Orientation.
         * True by default for maximum performance.
         */ this.disablePreStep = true;
        /**
         * Disable sync from physics to transformNode. This value is set to true at body creation when the body is not dynamic.
         */ this.disableSync = false;
        this._isDisposed = false;
        this._shape = null;
        if (!scene) return;
        const physicsEngine = scene.getPhysicsEngine();
        if (!physicsEngine) throw new Error("No Physics Engine available.");
        this._physicsEngine = physicsEngine;
        if (physicsEngine.getPluginVersion() != 2) throw new Error("Plugin version is incorrect. Expected version 2.");
        const physicsPlugin = physicsEngine.getPhysicsPlugin();
        if (!physicsPlugin) throw new Error("No Physics Plugin available.");
        this._physicsPlugin = physicsPlugin;
        if (!transformNode.rotationQuaternion) transformNode.rotationQuaternion = (0, $ha1VO.Quaternion).FromEulerAngles(transformNode.rotation.x, transformNode.rotation.y, transformNode.rotation.z);
        this.startAsleep = startsAsleep;
        this._motionType = motionType;
        // only dynamic body needs sync from physics to transformNode
        this.disableSync = motionType != (0, $fopmL.PhysicsMotionType).DYNAMIC;
        // instances?
        const m = transformNode;
        if (m.hasThinInstances) this._physicsPlugin.initBodyInstances(this, motionType, m);
        else {
            // single instance
            if (transformNode.parent) // Force computation of world matrix so that the parent transforms are correctly reflected in absolutePosition/absoluteRotationQuaternion.
            transformNode.computeWorldMatrix(true);
            this._physicsPlugin.initBody(this, motionType, transformNode.absolutePosition, transformNode.absoluteRotationQuaternion);
        }
        this.transformNode = transformNode;
        transformNode.physicsBody = this;
        physicsEngine.addBody(this);
        this._nodeDisposeObserver = transformNode.onDisposeObservable.add(()=>{
            this.dispose();
        });
    }
    /**
     * Returns the string "PhysicsBody".
     * @returns "PhysicsBody"
     */ getClassName() {
        return "PhysicsBody";
    }
    /**
     * Clone the PhysicsBody to a new body and assign it to the transformNode parameter
     * @param transformNode transformNode that will be used for the cloned PhysicsBody
     * @returns the newly cloned PhysicsBody
     */ clone(transformNode) {
        const clonedBody = new $6115d31d7c33f4fc$export$8154f9fed15a9853(transformNode, this.getMotionType(), this.startAsleep, this.transformNode.getScene());
        clonedBody.shape = this.shape;
        clonedBody.setMassProperties(this.getMassProperties());
        clonedBody.setLinearDamping(this.getLinearDamping());
        clonedBody.setAngularDamping(this.getAngularDamping());
        return clonedBody;
    }
    /**
     * If a physics body is connected to an instanced node, update the number physic instances to match the number of node instances.
     */ updateBodyInstances() {
        const m = this.transformNode;
        if (m.hasThinInstances) this._physicsPlugin.updateBodyInstances(this, m);
    }
    /**
     * This returns the number of internal instances of the physics body
     */ get numInstances() {
        return this._pluginDataInstances.length;
    }
    /**
     * Get the motion type of the physics body. Can be STATIC, DYNAMIC, or ANIMATED.
     */ get motionType() {
        return this._motionType;
    }
    /**
     * Sets the shape of the physics body.
     * @param shape - The shape of the physics body.
     *
     * This method is useful for setting the shape of the physics body, which is necessary for the physics engine to accurately simulate the body's behavior.
     * The shape is used to calculate the body's mass, inertia, and other properties.
     */ set shape(shape) {
        this._shape = shape;
        if (shape) this._physicsPlugin.setShape(this, shape);
    }
    /**
     * Retrieves the physics shape associated with this object.
     *
     * @returns The physics shape associated with this object, or `undefined` if no
     * shape is associated.
     *
     * This method is useful for retrieving the physics shape associated with this object,
     * which can be used to apply physical forces to the object or to detect collisions.
     */ get shape() {
        return this._shape;
    }
    /**
     * Sets the event mask for the physics engine.
     *
     * @param eventMask - A bitmask that determines which events will be sent to the physics engine.
     * @param instanceIndex - If this body is instanced, the index of the instance to set the event mask for.
     *
     * This method is useful for setting the event mask for the physics engine, which determines which events
     * will be sent to the physics engine. This allows the user to control which events the physics engine will respond to.
     */ setEventMask(eventMask, instanceIndex) {
        this._physicsPlugin.setEventMask(this, eventMask, instanceIndex);
    }
    /**
     * Gets the event mask of the physics engine.
     * @param instanceIndex - If this body is instanced, the index of the instance to get the event mask for.
     * @returns The event mask of the physics engine.
     *
     * This method is useful for getting the event mask of the physics engine,
     * which is used to determine which events the engine will respond to.
     * This is important for ensuring that the engine is responding to the correct events and not
     * wasting resources on unnecessary events.
     */ getEventMask(instanceIndex) {
        return this._physicsPlugin.getEventMask(this, instanceIndex);
    }
    /**
     * Sets the motion type of the physics body. Can be STATIC, DYNAMIC, or ANIMATED.
     * @param motionType - The motion type to set.
     * @param instanceIndex - If this body is instanced, the index of the instance to set the motion type for.
     */ setMotionType(motionType, instanceIndex) {
        this._physicsPlugin.setMotionType(this, motionType, instanceIndex);
    }
    /**
     * Gets the motion type of the physics body. Can be STATIC, DYNAMIC, or ANIMATED.
     * @param instanceIndex - If this body is instanced, the index of the instance to get the motion type for.
     * @returns The motion type of the physics body.
     */ getMotionType(instanceIndex) {
        return this._physicsPlugin.getMotionType(this, instanceIndex);
    }
    /**
     * Computes the mass properties of the physics object, based on the set of physics shapes this body uses.
     * This method is useful for computing the initial mass properties of a physics object, such as its mass,
     * inertia, and center of mass; these values are important for accurately simulating the physics of the
     * object in the physics engine, and computing values based on the shape will provide you with reasonable
     * initial values, which you can then customize.
     * @param instanceIndex - The index of the instance to compute the mass properties for.
     * @returns The mass properties of the object.
     */ computeMassProperties(instanceIndex) {
        return this._physicsPlugin.computeMassProperties(this, instanceIndex);
    }
    /**
     * Sets the mass properties of the physics object.
     *
     * @param massProps - The mass properties to set.
     * @param instanceIndex - The index of the instance to set the mass properties for. If not defined, the mass properties will be set for all instances.
     *
     * This method is useful for setting the mass properties of a physics object, such as its mass,
     * inertia, and center of mass. This is important for accurately simulating the physics of the object in the physics engine.
     */ setMassProperties(massProps, instanceIndex) {
        this._physicsPlugin.setMassProperties(this, massProps, instanceIndex);
    }
    /**
     * Retrieves the mass properties of the object.
     * @param instanceIndex - If this body is instanced, the index of the instance to get the mass properties for.
     * @returns The mass properties of the object.
     *
     * This method is useful for physics simulations, as it allows the user to
     * retrieve the mass properties of the object, such as its mass, center of mass,
     * and moment of inertia. This information is necessary for accurate physics
     * simulations.
     */ getMassProperties(instanceIndex) {
        return this._physicsPlugin.getMassProperties(this, instanceIndex);
    }
    /**
     * Sets the linear damping of the physics body.
     *
     * @param damping - The linear damping value.
     * @param instanceIndex - If this body is instanced, the index of the instance to set the linear damping for.
     *
     * This method is useful for controlling the linear damping of the physics body,
     * which is the rate at which the body's velocity decreases over time. This is useful for simulating
     * the effects of air resistance or other forms of friction.
     */ setLinearDamping(damping, instanceIndex) {
        this._physicsPlugin.setLinearDamping(this, damping, instanceIndex);
    }
    /**
     * Gets the linear damping of the physics body.
     * @param instanceIndex - If this body is instanced, the index of the instance to get the linear damping for.
     * @returns The linear damping of the physics body.
     *
     * This method is useful for retrieving the linear damping of the physics body, which is the amount of
     * resistance the body has to linear motion. This is useful for simulating realistic physics behavior
     * in a game.
     */ getLinearDamping(instanceIndex) {
        return this._physicsPlugin.getLinearDamping(this, instanceIndex);
    }
    /**
     * Sets the angular damping of the physics body.
     * @param damping The angular damping of the body.
     * @param instanceIndex - If this body is instanced, the index of the instance to set the angular damping for.
     *
     * This method is useful for controlling the angular velocity of a physics body.
     * By setting the damping, the body's angular velocity will be reduced over time, simulating the effect of friction.
     * This can be used to create realistic physical behavior in a physics engine.
     */ setAngularDamping(damping, instanceIndex) {
        this._physicsPlugin.setAngularDamping(this, damping, instanceIndex);
    }
    /**
     * Gets the angular damping of the physics body.
     * @param instanceIndex - If this body is instanced, the index of the instance to get the angular damping for.
     *
     * @returns The angular damping of the physics body.
     *
     * This method is useful for getting the angular damping of the physics body,
     * which is the rate of reduction of the angular velocity over time.
     * This is important for simulating realistic physics behavior in a game.
     */ getAngularDamping(instanceIndex) {
        return this._physicsPlugin.getAngularDamping(this, instanceIndex);
    }
    /**
     * Sets the linear velocity of the physics object.
     * @param linVel - The linear velocity to set.
     * @param instanceIndex - If this body is instanced, the index of the instance to set the linear velocity for.
     *
     * This method is useful for setting the linear velocity of a physics object,
     * which is necessary for simulating realistic physics in a game engine.
     * By setting the linear velocity, the physics object will move in the direction and speed specified by the vector.
     * This allows for realistic physics simulations, such as simulating the motion of a ball rolling down a hill.
     */ setLinearVelocity(linVel, instanceIndex) {
        this._physicsPlugin.setLinearVelocity(this, linVel, instanceIndex);
    }
    /**
     * Gets the linear velocity of the physics body and stores it in the given vector3.
     * @param linVel - The vector3 to store the linear velocity in.
     * @param instanceIndex - If this body is instanced, the index of the instance to get the linear velocity for.
     *
     * This method is useful for getting the linear velocity of a physics body in a physics engine.
     * This can be used to determine the speed and direction of the body, which can be used to calculate the motion of the body.
     */ getLinearVelocityToRef(linVel, instanceIndex) {
        this._physicsPlugin.getLinearVelocityToRef(this, linVel, instanceIndex);
    }
    /**
     * Gets the linear velocity of the physics body as a new vector3.
     * @param instanceIndex - If this body is instanced, the index of the instance to get the linear velocity for.
     * @returns The linear velocity of the physics body.
     *
     * This method is useful for getting the linear velocity of a physics body in a physics engine.
     * This can be used to determine the speed and direction of the body, which can be used to calculate the motion of the body.
     */ getLinearVelocity(instanceIndex) {
        const ref = new (0, $ha1VO.Vector3)();
        this.getLinearVelocityToRef(ref, instanceIndex);
        return ref;
    }
    /**
     * Sets the angular velocity of the physics object.
     * @param angVel - The angular velocity to set.
     * @param instanceIndex - If this body is instanced, the index of the instance to set the angular velocity for.
     *
     * This method is useful for setting the angular velocity of a physics object, which is necessary for
     * simulating realistic physics behavior. The angular velocity is used to determine the rate of rotation of the object,
     * which is important for simulating realistic motion.
     */ setAngularVelocity(angVel, instanceIndex) {
        this._physicsPlugin.setAngularVelocity(this, angVel, instanceIndex);
    }
    /**
     * Gets the angular velocity of the physics body and stores it in the given vector3.
     * @param angVel - The vector3 to store the angular velocity in.
     * @param instanceIndex - If this body is instanced, the index of the instance to get the angular velocity for.
     *
     * This method is useful for getting the angular velocity of a physics body, which can be used to determine the body's
     * rotational speed. This information can be used to create realistic physics simulations.
     */ getAngularVelocityToRef(angVel, instanceIndex) {
        this._physicsPlugin.getAngularVelocityToRef(this, angVel, instanceIndex);
    }
    /**
     * Gets the angular velocity of the physics body as a new vector3.
     * @param instanceIndex - If this body is instanced, the index of the instance to get the angular velocity for.
     * @returns The angular velocity of the physics body.
     *
     * This method is useful for getting the angular velocity of a physics body, which can be used to determine the body's
     * rotational speed. This information can be used to create realistic physics simulations.
     */ getAngularVelocity(instanceIndex) {
        const ref = new (0, $ha1VO.Vector3)();
        this.getAngularVelocityToRef(ref, instanceIndex);
        return ref;
    }
    /**
     * Applies an impulse to the physics object.
     *
     * @param impulse The impulse vector.
     * @param location The location of the impulse.
     * @param instanceIndex For a instanced body, the instance to where the impulse should be applied. If not specified, the impulse is applied to all instances.
     *
     * This method is useful for applying an impulse to a physics object, which can be used to simulate physical forces such as gravity,
     * collisions, and explosions. This can be used to create realistic physics simulations in a game or other application.
     */ applyImpulse(impulse, location, instanceIndex) {
        this._physicsPlugin.applyImpulse(this, impulse, location, instanceIndex);
    }
    /**
     * Applies a force to the physics object.
     *
     * @param force The force vector.
     * @param location The location of the force.
     * @param instanceIndex For a instanced body, the instance to where the force should be applied. If not specified, the force is applied to all instances.
     *
     * This method is useful for applying a force to a physics object, which can be used to simulate physical forces such as gravity,
     * collisions, and explosions. This can be used to create realistic physics simulations in a game or other application.
     */ applyForce(force, location, instanceIndex) {
        this._physicsPlugin.applyForce(this, force, location, instanceIndex);
    }
    /**
     * Retrieves the geometry of the body from the physics plugin.
     *
     * @returns The geometry of the body.
     *
     * This method is useful for retrieving the geometry of the body from the physics plugin, which can be used for various physics calculations.
     */ getGeometry() {
        return this._physicsPlugin.getBodyGeometry(this);
    }
    /**
     * Returns an observable that will be notified for when a collision starts or continues for this PhysicsBody
     * @returns Observable
     */ getCollisionObservable() {
        return this._physicsPlugin.getCollisionObservable(this);
    }
    /**
     * Returns an observable that will be notified when the body has finished colliding with another body
     * @returns
     */ getCollisionEndedObservable() {
        return this._physicsPlugin.getCollisionEndedObservable(this);
    }
    /**
     * Enable or disable collision callback for this PhysicsBody.
     * @param enabled true if PhysicsBody's collision will rise a collision event and notifies the observable
     */ setCollisionCallbackEnabled(enabled) {
        this._collisionCBEnabled = enabled;
        this._physicsPlugin.setCollisionCallbackEnabled(this, enabled);
    }
    /**
     * Enable or disable collision ended callback for this PhysicsBody.
     * @param enabled true if PhysicsBody's collision ended will rise a collision event and notifies the observable
     */ setCollisionEndedCallbackEnabled(enabled) {
        this._collisionEndedCBEnabled = enabled;
        this._physicsPlugin.setCollisionEndedCallbackEnabled(this, enabled);
    }
    /**
     * Get the center of the object in world space.
     * @param instanceIndex - If this body is instanced, the index of the instance to get the center for.
     * @returns geometric center of the associated mesh
     */ getObjectCenterWorld(instanceIndex) {
        const ref = new (0, $ha1VO.Vector3)();
        return this.getObjectCenterWorldToRef(ref, instanceIndex);
    }
    /**
     * Get the center of the object in world space.
     * @param ref - The vector3 to store the result in.
     * @param instanceIndex - If this body is instanced, the index of the instance to get the center for.
     * @returns geometric center of the associated mesh
     */ getObjectCenterWorldToRef(ref, instanceIndex) {
        if (this._pluginDataInstances?.length > 0) {
            const index = instanceIndex || 0;
            const matrixData = this.transformNode._thinInstanceDataStorage.matrixData;
            if (matrixData) ref.set(matrixData[index * 16 + 12], matrixData[index * 16 + 13], matrixData[index * 16 + 14]);
        } else ref.copyFrom(this.transformNode.position);
        return ref;
    }
    /**
     * Adds a constraint to the physics engine.
     *
     * @param childBody - The body to which the constraint will be applied.
     * @param constraint - The constraint to be applied.
     * @param instanceIndex - If this body is instanced, the index of the instance to which the constraint will be applied. If not specified, no constraint will be applied.
     * @param childInstanceIndex - If the child body is instanced, the index of the instance to which the constraint will be applied. If not specified, no constraint will be applied.
     *
     */ addConstraint(childBody, constraint, instanceIndex, childInstanceIndex) {
        this._physicsPlugin.addConstraint(this, childBody, constraint, instanceIndex, childInstanceIndex);
    }
    /**
     * Sync with a bone
     * @param bone The bone that the impostor will be synced to.
     * @param boneMesh The mesh that the bone is influencing.
     * @param jointPivot The pivot of the joint / bone in local space.
     * @param distToJoint Optional distance from the impostor to the joint.
     * @param adjustRotation Optional quaternion for adjusting the local rotation of the bone.
     * @param boneAxis Optional vector3 axis the bone is aligned with
     */ syncWithBone(bone, boneMesh, jointPivot, distToJoint, adjustRotation, boneAxis) {
        const mesh = this.transformNode;
        if (mesh.rotationQuaternion) {
            if (adjustRotation) {
                const tempQuat = (0, $ha1VO.TmpVectors).Quaternion[0];
                bone.getRotationQuaternionToRef((0, $dbxbu.Space).WORLD, boneMesh, tempQuat);
                tempQuat.multiplyToRef(adjustRotation, mesh.rotationQuaternion);
            } else bone.getRotationQuaternionToRef((0, $dbxbu.Space).WORLD, boneMesh, mesh.rotationQuaternion);
        }
        const pos = (0, $ha1VO.TmpVectors).Vector3[0];
        const boneDir = (0, $ha1VO.TmpVectors).Vector3[1];
        if (!boneAxis) {
            boneAxis = (0, $ha1VO.TmpVectors).Vector3[2];
            boneAxis.x = 0;
            boneAxis.y = 1;
            boneAxis.z = 0;
        }
        bone.getDirectionToRef(boneAxis, boneMesh, boneDir);
        bone.getAbsolutePositionToRef(boneMesh, pos);
        if ((distToJoint === undefined || distToJoint === null) && jointPivot) distToJoint = jointPivot.length();
        if (distToJoint !== undefined && distToJoint !== null) {
            pos.x += boneDir.x * distToJoint;
            pos.y += boneDir.y * distToJoint;
            pos.z += boneDir.z * distToJoint;
        }
        mesh.setAbsolutePosition(pos);
    }
    /**
     * Executes a callback on the body or all of the instances of a body
     * @param callback the callback to execute
     */ iterateOverAllInstances(callback) {
        if (this._pluginDataInstances?.length > 0) for(let i = 0; i < this._pluginDataInstances.length; i++)callback(this, i);
        else callback(this, undefined);
    }
    /**
     * Sets the gravity factor of the physics body
     * @param factor the gravity factor to set
     * @param instanceIndex the instance of the body to set, if undefined all instances will be set
     */ setGravityFactor(factor, instanceIndex) {
        this._physicsPlugin.setGravityFactor(this, factor, instanceIndex);
    }
    /**
     * Gets the gravity factor of the physics body
     * @param instanceIndex the instance of the body to get, if undefined the value of first instance will be returned
     * @returns the gravity factor
     */ getGravityFactor(instanceIndex) {
        return this._physicsPlugin.getGravityFactor(this, instanceIndex);
    }
    /**
     * Set the target transformation (position and rotation) of the body, such that the body will set its velocity to reach that target
     * @param position The target position
     * @param rotation The target rotation
     * @param instanceIndex The index of the instance in an instanced body
     */ setTargetTransform(position, rotation, instanceIndex) {
        this._physicsPlugin.setTargetTransform(this, position, rotation, instanceIndex);
    }
    /**
     * Returns if the body has been disposed.
     * @returns true if disposed, false otherwise.
     */ get isDisposed() {
        return this._isDisposed;
    }
    /**
     * Disposes the body from the physics engine.
     *
     * This method is useful for cleaning up the physics engine when a body is no longer needed. Disposing the body will free up resources and prevent memory leaks.
     */ dispose() {
        if (this._isDisposed) return;
        // Disable collisions CB so it doesn't fire when the body is disposed
        if (this._collisionCBEnabled) this.setCollisionCallbackEnabled(false);
        if (this._collisionEndedCBEnabled) this.setCollisionEndedCallbackEnabled(false);
        if (this._nodeDisposeObserver) {
            this.transformNode.onDisposeObservable.remove(this._nodeDisposeObserver);
            this._nodeDisposeObserver = null;
        }
        this._physicsEngine.removeBody(this);
        this._physicsPlugin.removeBody(this);
        this._physicsPlugin.disposeBody(this);
        this.transformNode.physicsBody = null;
        this._pluginData = null;
        this._pluginDataInstances.length = 0;
        this._isDisposed = true;
        this.shape = null;
    }
}

});
parcelRegister("fopmL", function(module, exports) {

$parcel$export(module.exports, "PhysicsConstraintAxisLimitMode", () => $b34cc61976a41e30$export$a5631d6826160d39);
$parcel$export(module.exports, "PhysicsConstraintAxis", () => $b34cc61976a41e30$export$ac7dde39cd61619e);
$parcel$export(module.exports, "PhysicsConstraintType", () => $b34cc61976a41e30$export$b6821cffb2f8d012);
$parcel$export(module.exports, "PhysicsShapeType", () => $b34cc61976a41e30$export$411538c45fa50883);
$parcel$export(module.exports, "PhysicsConstraintMotorType", () => $b34cc61976a41e30$export$44d8f28c05001fc5);
$parcel$export(module.exports, "PhysicsEventType", () => $b34cc61976a41e30$export$e9e8700afe9c5f51);
$parcel$export(module.exports, "PhysicsMotionType", () => $b34cc61976a41e30$export$d810edeb50cc1349);
$parcel$export(module.exports, "PhysicsActivationControl", () => $b34cc61976a41e30$export$2915349d04c1c61b);
/** How a specific axis can be constrained */ var $b34cc61976a41e30$export$a5631d6826160d39;
(function(PhysicsConstraintAxisLimitMode) {
    /*
     * The axis is not restricted at all
     */ PhysicsConstraintAxisLimitMode[PhysicsConstraintAxisLimitMode["FREE"] = 0] = "FREE";
    /*
     * The axis has a minimum/maximum limit
     */ PhysicsConstraintAxisLimitMode[PhysicsConstraintAxisLimitMode["LIMITED"] = 1] = "LIMITED";
    /*
     * The axis allows no relative movement of the pivots
     */ PhysicsConstraintAxisLimitMode[PhysicsConstraintAxisLimitMode["LOCKED"] = 2] = "LOCKED";
})($b34cc61976a41e30$export$a5631d6826160d39 || ($b34cc61976a41e30$export$a5631d6826160d39 = {}));
var $b34cc61976a41e30$export$ac7dde39cd61619e;
(function(PhysicsConstraintAxis) {
    /*
     * Translation along the primary axis of the constraint (i.e. the
     * direction specified by PhysicsConstraintParameters.axisA/axisB)
     */ PhysicsConstraintAxis[PhysicsConstraintAxis["LINEAR_X"] = 0] = "LINEAR_X";
    /*
     * Translation along the second axis of the constraint (i.e. the
     * direction specified by PhysicsConstraintParameters.perpAxisA/perpAxisB)
     */ PhysicsConstraintAxis[PhysicsConstraintAxis["LINEAR_Y"] = 1] = "LINEAR_Y";
    /*
     * Translation along the third axis of the constraint. This axis is
     * computed from the cross product of axisA/axisB and perpAxisA/perpAxisB)
     */ PhysicsConstraintAxis[PhysicsConstraintAxis["LINEAR_Z"] = 2] = "LINEAR_Z";
    /*
     * Rotation around the primary axis of the constraint (i.e. the
     * axis specified by PhysicsConstraintParameters.axisA/axisB)
     */ PhysicsConstraintAxis[PhysicsConstraintAxis["ANGULAR_X"] = 3] = "ANGULAR_X";
    /*
     * Rotation around the second axis of the constraint (i.e. the
     * axis specified by PhysicsConstraintParameters.perpAxisA/perpAxisB)
     */ PhysicsConstraintAxis[PhysicsConstraintAxis["ANGULAR_Y"] = 4] = "ANGULAR_Y";
    /*
     * Rotation around the third axis of the constraint. This axis is
     * computed from the cross product of axisA/axisB and perpAxisA/perpAxisB)
     */ PhysicsConstraintAxis[PhysicsConstraintAxis["ANGULAR_Z"] = 5] = "ANGULAR_Z";
    /*
     * A 3D distance limit; similar to specifying the LINEAR_X/Y/Z axes
     * individually, but the distance calculation uses all three axes
     * simultaneously, instead of individually.
     */ PhysicsConstraintAxis[PhysicsConstraintAxis["LINEAR_DISTANCE"] = 6] = "LINEAR_DISTANCE";
})($b34cc61976a41e30$export$ac7dde39cd61619e || ($b34cc61976a41e30$export$ac7dde39cd61619e = {}));
var $b34cc61976a41e30$export$b6821cffb2f8d012;
(function(PhysicsConstraintType) {
    /**
     * A ball and socket constraint will attempt to line up the pivot
     * positions in each body, and have no restrictions on rotation
     */ PhysicsConstraintType[PhysicsConstraintType["BALL_AND_SOCKET"] = 1] = "BALL_AND_SOCKET";
    /**
     * A distance constraint will attempt to keep the pivot locations
     * within a specified distance.
     */ PhysicsConstraintType[PhysicsConstraintType["DISTANCE"] = 2] = "DISTANCE";
    /**
     * A hinge constraint will keep the pivot positions aligned as well
     * as two angular axes. The remaining angular axis will be free to rotate.
     */ PhysicsConstraintType[PhysicsConstraintType["HINGE"] = 3] = "HINGE";
    /**
     * A slider constraint allows bodies to translate along one axis and
     * rotate about the same axis. The remaining two axes are locked in
     * place
     */ PhysicsConstraintType[PhysicsConstraintType["SLIDER"] = 4] = "SLIDER";
    /**
     * A lock constraint will attempt to keep the pivots completely lined
     * up between both bodies, allowing no relative movement.
     */ PhysicsConstraintType[PhysicsConstraintType["LOCK"] = 5] = "LOCK";
    /*
     * A prismatic will lock the rotations of the bodies, and allow translation
     * only along one axis
     */ PhysicsConstraintType[PhysicsConstraintType["PRISMATIC"] = 6] = "PRISMATIC";
    /*
     * A generic constraint; this starts with no limits on how the bodies can
     * move relative to each other, but limits can be added via the PhysicsConstraint
     * interfaces. This can be used to specify a large variety of constraints
     */ PhysicsConstraintType[PhysicsConstraintType["SIX_DOF"] = 7] = "SIX_DOF";
})($b34cc61976a41e30$export$b6821cffb2f8d012 || ($b34cc61976a41e30$export$b6821cffb2f8d012 = {}));
var $b34cc61976a41e30$export$411538c45fa50883;
(function(PhysicsShapeType) {
    PhysicsShapeType[PhysicsShapeType["SPHERE"] = 0] = "SPHERE";
    PhysicsShapeType[PhysicsShapeType["CAPSULE"] = 1] = "CAPSULE";
    PhysicsShapeType[PhysicsShapeType["CYLINDER"] = 2] = "CYLINDER";
    PhysicsShapeType[PhysicsShapeType["BOX"] = 3] = "BOX";
    PhysicsShapeType[PhysicsShapeType["CONVEX_HULL"] = 4] = "CONVEX_HULL";
    PhysicsShapeType[PhysicsShapeType["CONTAINER"] = 5] = "CONTAINER";
    PhysicsShapeType[PhysicsShapeType["MESH"] = 6] = "MESH";
    PhysicsShapeType[PhysicsShapeType["HEIGHTFIELD"] = 7] = "HEIGHTFIELD";
})($b34cc61976a41e30$export$411538c45fa50883 || ($b34cc61976a41e30$export$411538c45fa50883 = {}));
var $b34cc61976a41e30$export$44d8f28c05001fc5;
(function(PhysicsConstraintMotorType) {
    PhysicsConstraintMotorType[PhysicsConstraintMotorType["NONE"] = 0] = "NONE";
    PhysicsConstraintMotorType[PhysicsConstraintMotorType["VELOCITY"] = 1] = "VELOCITY";
    PhysicsConstraintMotorType[PhysicsConstraintMotorType["POSITION"] = 2] = "POSITION";
})($b34cc61976a41e30$export$44d8f28c05001fc5 || ($b34cc61976a41e30$export$44d8f28c05001fc5 = {}));
var $b34cc61976a41e30$export$e9e8700afe9c5f51;
(function(PhysicsEventType) {
    PhysicsEventType["COLLISION_STARTED"] = "COLLISION_STARTED";
    PhysicsEventType["COLLISION_CONTINUED"] = "COLLISION_CONTINUED";
    PhysicsEventType["COLLISION_FINISHED"] = "COLLISION_FINISHED";
    PhysicsEventType["TRIGGER_ENTERED"] = "TRIGGER_ENTERED";
    PhysicsEventType["TRIGGER_EXITED"] = "TRIGGER_EXITED";
})($b34cc61976a41e30$export$e9e8700afe9c5f51 || ($b34cc61976a41e30$export$e9e8700afe9c5f51 = {}));
var $b34cc61976a41e30$export$d810edeb50cc1349;
(function(PhysicsMotionType) {
    PhysicsMotionType[PhysicsMotionType["STATIC"] = 0] = "STATIC";
    PhysicsMotionType[PhysicsMotionType["ANIMATED"] = 1] = "ANIMATED";
    PhysicsMotionType[PhysicsMotionType["DYNAMIC"] = 2] = "DYNAMIC";
})($b34cc61976a41e30$export$d810edeb50cc1349 || ($b34cc61976a41e30$export$d810edeb50cc1349 = {}));
var $b34cc61976a41e30$export$2915349d04c1c61b;
(function(PhysicsActivationControl) {
    PhysicsActivationControl[PhysicsActivationControl["SIMULATION_CONTROLLED"] = 0] = "SIMULATION_CONTROLLED";
    PhysicsActivationControl[PhysicsActivationControl["ALWAYS_ACTIVE"] = 1] = "ALWAYS_ACTIVE";
    PhysicsActivationControl[PhysicsActivationControl["ALWAYS_INACTIVE"] = 2] = "ALWAYS_INACTIVE";
})($b34cc61976a41e30$export$2915349d04c1c61b || ($b34cc61976a41e30$export$2915349d04c1c61b = {}));

});


parcelRegister("1UZV7", function(module, exports) {

$parcel$export(module.exports, "PhysicsShape", () => $165b0d7bb982c2f3$export$b957c9975df360b);
$parcel$export(module.exports, "PhysicsShapeSphere", () => $165b0d7bb982c2f3$export$4beb2a72cdce01f);
$parcel$export(module.exports, "PhysicsShapeCapsule", () => $165b0d7bb982c2f3$export$70b8c8cf3ac9dcd5);
$parcel$export(module.exports, "PhysicsShapeCylinder", () => $165b0d7bb982c2f3$export$1ce4aae8548b1850);
$parcel$export(module.exports, "PhysicsShapeBox", () => $165b0d7bb982c2f3$export$8f95f5cb47dbc730);
$parcel$export(module.exports, "PhysicsShapeConvexHull", () => $165b0d7bb982c2f3$export$36d91d0b7b7fe416);
$parcel$export(module.exports, "PhysicsShapeMesh", () => $165b0d7bb982c2f3$export$887852ba33a29535);
$parcel$export(module.exports, "PhysicsShapeContainer", () => $165b0d7bb982c2f3$export$339f11cdd3836234);

var $fopmL = parcelRequire("fopmL");

var $ha1VO = parcelRequire("ha1VO");
class $165b0d7bb982c2f3$export$b957c9975df360b {
    /**
     * Constructs a new physics shape.
     * @param options The options for the physics shape. These are:
     *  * type: The type of the shape. This can be one of the following: SPHERE, BOX, CAPSULE, CYLINDER, CONVEX_HULL, MESH, HEIGHTFIELD, CONTAINER
     *  * parameters: The parameters of the shape.
     *  * pluginData: The plugin data of the shape. This is used if you already have a reference to the object on the plugin side.
     * You need to specify either type or pluginData.
     * @param scene The scene the shape belongs to.
     *
     * This code is useful for creating a new physics shape with the given type, options, and scene.
     * It also checks that the physics engine and plugin version are correct.
     * If not, it throws an error. This ensures that the shape is created with the correct parameters and is compatible with the physics engine.
     */ constructor(options, scene){
        /**
         * V2 Physics plugin private data for single shape
         */ this._pluginData = undefined;
        this._isTrigger = false;
        this._isDisposed = false;
        if (!scene) return;
        const physicsEngine = scene.getPhysicsEngine();
        if (!physicsEngine) throw new Error("No Physics Engine available.");
        if (physicsEngine.getPluginVersion() != 2) throw new Error("Plugin version is incorrect. Expected version 2.");
        const physicsPlugin = physicsEngine.getPhysicsPlugin();
        if (!physicsPlugin) throw new Error("No Physics Plugin available.");
        this._physicsPlugin = physicsPlugin;
        if (options.pluginData !== undefined && options.pluginData !== null) {
            this._pluginData = options.pluginData;
            this._type = this._physicsPlugin.getShapeType(this);
        } else if (options.type !== undefined && options.type !== null) {
            this._type = options.type;
            const parameters = options.parameters ?? {};
            this._physicsPlugin.initShape(this, options.type, parameters);
        }
    }
    /**
     * Returns the string "PhysicsShape".
     * @returns "PhysicsShape"
     */ getClassName() {
        return "PhysicsShape";
    }
    /**
     * Returns the type of the physics shape.
     * @returns The type of the physics shape.
     */ get type() {
        return this._type;
    }
    /**
     * Set the membership mask of a shape. This is a bitfield of arbitrary
     * "categories" to which the shape is a member. This is used in combination
     * with the collide mask to determine if this shape should collide with
     * another.
     *
     * @param membershipMask Bitfield of categories of this shape.
     */ set filterMembershipMask(membershipMask) {
        this._physicsPlugin.setShapeFilterMembershipMask(this, membershipMask);
    }
    /**
     * Get the membership mask of a shape.
     * @returns Bitmask of categories which this shape is a member of.
     */ get filterMembershipMask() {
        return this._physicsPlugin.getShapeFilterMembershipMask(this);
    }
    /**
     * Sets the collide mask of a shape. This is a bitfield of arbitrary
     * "categories" to which this shape collides with. Given two shapes,
     * the engine will check if the collide mask and membership overlap:
     * shapeA.filterMembershipMask & shapeB.filterCollideMask
     *
     * If this value is zero (i.e. shapeB only collides with categories
     * which shapeA is _not_ a member of) then the shapes will not collide.
     *
     * Note, the engine will also perform the same test with shapeA and
     * shapeB swapped; the shapes will not collide if either shape has
     * a collideMask which prevents collision with the other shape.
     *
     * @param collideMask Bitmask of categories this shape should collide with
     */ set filterCollideMask(collideMask) {
        this._physicsPlugin.setShapeFilterCollideMask(this, collideMask);
    }
    /**
     *
     * @returns Bitmask of categories that this shape should collide with
     */ get filterCollideMask() {
        return this._physicsPlugin.getShapeFilterCollideMask(this);
    }
    /**
     *
     * @param material
     */ set material(material) {
        this._physicsPlugin.setMaterial(this, material);
        this._material = material;
    }
    /**
     * Returns the material of the physics shape.
     * @returns The material of the physics shape.
     */ get material() {
        if (!this._material) this._material = this._physicsPlugin.getMaterial(this);
        return this._material;
    }
    /**
     * Sets the density of the physics shape.
     * @param density The density of the physics shape.
     */ set density(density) {
        this._physicsPlugin.setDensity(this, density);
    }
    /**
     * Returns the density of the physics shape.
     * @returns The density of the physics shape.
     */ get density() {
        return this._physicsPlugin.getDensity(this);
    }
    /**
     * Utility to add a child shape to this container,
     * automatically computing the relative transform between
     * the container shape and the child instance.
     *
     * @param parentTransform The transform node associated with this shape
     * @param newChild The new PhysicsShape to add
     * @param childTransform The transform node associated with the child shape
     */ addChildFromParent(parentTransform, newChild, childTransform) {
        const childToWorld = childTransform.computeWorldMatrix(true);
        const parentToWorld = parentTransform.computeWorldMatrix(true);
        const childToParent = (0, $ha1VO.TmpVectors).Matrix[0];
        childToWorld.multiplyToRef((0, $ha1VO.Matrix).Invert(parentToWorld), childToParent);
        const translation = (0, $ha1VO.TmpVectors).Vector3[0];
        const rotation = (0, $ha1VO.TmpVectors).Quaternion[0];
        const scale = (0, $ha1VO.TmpVectors).Vector3[1];
        childToParent.decompose(scale, rotation, translation);
        this._physicsPlugin.addChild(this, newChild, translation, rotation, scale);
    }
    /**
     * Adds a child shape to a container with an optional transform
     * @param newChild The new PhysicsShape to add
     * @param translation Optional position of the child shape relative to this shape
     * @param rotation Optional rotation of the child shape relative to this shape
     * @param scale Optional scale of the child shape relative to this shape
     */ addChild(newChild, translation, rotation, scale) {
        this._physicsPlugin.addChild(this, newChild, translation, rotation, scale);
    }
    /**
     * Removes a child shape from this shape.
     * @param childIndex The index of the child shape to remove
     */ removeChild(childIndex) {
        this._physicsPlugin.removeChild(this, childIndex);
    }
    /**
     * Returns the number of children of a physics shape.
     * @returns The number of children of a physics shape.
     */ getNumChildren() {
        return this._physicsPlugin.getNumChildren(this);
    }
    /**
     * Returns the bounding box of the physics shape.
     * @returns The bounding box of the physics shape.
     */ getBoundingBox() {
        return this._physicsPlugin.getBoundingBox(this);
    }
    set isTrigger(isTrigger) {
        if (this._isTrigger === isTrigger) return;
        this._isTrigger = isTrigger;
        this._physicsPlugin.setTrigger(this, isTrigger);
    }
    get isTrigger() {
        return this._isTrigger;
    }
    /**
     * Dispose the shape and release its associated resources.
     */ dispose() {
        if (this._isDisposed) return;
        this._physicsPlugin.disposeShape(this);
        this._isDisposed = true;
    }
}
class $165b0d7bb982c2f3$export$4beb2a72cdce01f extends $165b0d7bb982c2f3$export$b957c9975df360b {
    /**
     * Constructor for the Sphere Shape
     * @param center local center of the sphere
     * @param radius radius
     * @param scene scene to attach to
     */ constructor(center, radius, scene){
        super({
            type: (0, $fopmL.PhysicsShapeType).SPHERE,
            parameters: {
                center: center,
                radius: radius
            }
        }, scene);
    }
    /**
     * Derive an approximate sphere from the mesh.
     * @param mesh node from which to derive the sphere shape
     * @returns PhysicsShapeSphere
     */ static FromMesh(mesh) {
        const bounds = mesh.getBoundingInfo();
        const centerLocal = bounds.boundingSphere.center;
        const he = bounds.boundingBox.extendSize;
        const radius = Math.max(he.x, he.y, he.z);
        return new $165b0d7bb982c2f3$export$4beb2a72cdce01f(centerLocal, radius, mesh.getScene());
    }
}
class $165b0d7bb982c2f3$export$70b8c8cf3ac9dcd5 extends $165b0d7bb982c2f3$export$b957c9975df360b {
    /**
     *
     * @param pointA Starting point that defines the capsule segment
     * @param pointB ending point of that same segment
     * @param radius radius
     * @param scene scene to attach to
     */ constructor(pointA, pointB, radius, scene){
        super({
            type: (0, $fopmL.PhysicsShapeType).CAPSULE,
            parameters: {
                pointA: pointA,
                pointB: pointB,
                radius: radius
            }
        }, scene);
    }
    /**
     * Derive an approximate capsule from the mesh. Note, this is
     * not the optimal bounding capsule.
     * @param mesh Node from which to derive a cylinder shape
     * @returns Physics Shape Capsule
     */ static FromMesh(mesh) {
        const boundsLocal = mesh.getBoundingInfo();
        const radius = boundsLocal.boundingBox.extendSize.x;
        const pointFromCenter = new (0, $ha1VO.Vector3)(0, boundsLocal.boundingBox.extendSize.y - radius, 0);
        const pointA = boundsLocal.boundingBox.center.add(pointFromCenter);
        const pointB = boundsLocal.boundingBox.center.subtract(pointFromCenter);
        return new $165b0d7bb982c2f3$export$70b8c8cf3ac9dcd5(pointA, pointB, radius, mesh.getScene());
    }
}
class $165b0d7bb982c2f3$export$1ce4aae8548b1850 extends $165b0d7bb982c2f3$export$b957c9975df360b {
    /**
     *
     * @param pointA Starting point that defines the cylinder segment
     * @param pointB ending point of that same segment
     * @param radius radius
     * @param scene scene to attach to
     */ constructor(pointA, pointB, radius, scene){
        super({
            type: (0, $fopmL.PhysicsShapeType).CYLINDER,
            parameters: {
                pointA: pointA,
                pointB: pointB,
                radius: radius
            }
        }, scene);
    }
    /**
     * Derive an approximate cylinder from the mesh. Note, this is
     * not the optimal bounding cylinder.
     * @param mesh Node from which to derive a cylinder shape
     * @returns Physics Shape Cylinder
     */ static FromMesh(mesh) {
        const boundsLocal = mesh.getBoundingInfo();
        const radius = boundsLocal.boundingBox.extendSize.x;
        const pointFromCenter = new (0, $ha1VO.Vector3)(0, boundsLocal.boundingBox.extendSize.y, 0);
        const pointA = boundsLocal.boundingBox.center.add(pointFromCenter);
        const pointB = boundsLocal.boundingBox.center.subtract(pointFromCenter);
        return new $165b0d7bb982c2f3$export$1ce4aae8548b1850(pointA, pointB, radius, mesh.getScene());
    }
}
class $165b0d7bb982c2f3$export$8f95f5cb47dbc730 extends $165b0d7bb982c2f3$export$b957c9975df360b {
    /**
     *
     * @param center local center of the box
     * @param rotation local orientation
     * @param extents size of the box in each direction
     * @param scene scene to attach to
     */ constructor(center, rotation, extents, scene){
        super({
            type: (0, $fopmL.PhysicsShapeType).BOX,
            parameters: {
                center: center,
                rotation: rotation,
                extents: extents
            }
        }, scene);
    }
    /**
     *
     * @param mesh
     * @returns PhysicsShapeBox
     */ static FromMesh(mesh) {
        const bounds = mesh.getBoundingInfo();
        const centerLocal = bounds.boundingBox.center;
        const extents = bounds.boundingBox.extendSize.scale(2.0); //<todo.eoin extendSize seems to really be half-extents?
        return new $165b0d7bb982c2f3$export$8f95f5cb47dbc730(centerLocal, (0, $ha1VO.Quaternion).Identity(), extents, mesh.getScene());
    }
}
class $165b0d7bb982c2f3$export$36d91d0b7b7fe416 extends $165b0d7bb982c2f3$export$b957c9975df360b {
    /**
     *
     * @param mesh the mesh to be used as topology infos for the convex hull
     * @param scene scene to attach to
     */ constructor(mesh, scene){
        super({
            type: (0, $fopmL.PhysicsShapeType).CONVEX_HULL,
            parameters: {
                mesh: mesh
            }
        }, scene);
    }
}
class $165b0d7bb982c2f3$export$887852ba33a29535 extends $165b0d7bb982c2f3$export$b957c9975df360b {
    /**
     *
     * @param mesh the mesh topology that will be used to create the shape
     * @param scene scene to attach to
     */ constructor(mesh, scene){
        super({
            type: (0, $fopmL.PhysicsShapeType).MESH,
            parameters: {
                mesh: mesh
            }
        }, scene);
    }
}
class $165b0d7bb982c2f3$export$339f11cdd3836234 extends $165b0d7bb982c2f3$export$b957c9975df360b {
    /**
     * Constructor of the Shape container
     * @param scene scene to attach to
     */ constructor(scene){
        super({
            type: (0, $fopmL.PhysicsShapeType).CONTAINER,
            parameters: {}
        }, scene);
    }
}

});

parcelRegister("fQEDT", function(module, exports) {

$parcel$export(module.exports, "PhysicsConstraint", () => $b89b3d19a7b62dc7$export$5a60d3a36c7d9b56);
$parcel$export(module.exports, "Physics6DoFLimit", () => $b89b3d19a7b62dc7$export$3dce2449033778e9);
$parcel$export(module.exports, "Physics6DoFConstraint", () => $b89b3d19a7b62dc7$export$fa7fc86533c4a67d);
$parcel$export(module.exports, "BallAndSocketConstraint", () => $b89b3d19a7b62dc7$export$3d4ca7eb4440ba64);
$parcel$export(module.exports, "DistanceConstraint", () => $b89b3d19a7b62dc7$export$7f13e3afb2fe70fe);
$parcel$export(module.exports, "HingeConstraint", () => $b89b3d19a7b62dc7$export$18c5826321ba66b3);
$parcel$export(module.exports, "SliderConstraint", () => $b89b3d19a7b62dc7$export$4eb987fad49020a9);
$parcel$export(module.exports, "LockConstraint", () => $b89b3d19a7b62dc7$export$dd4dd491c6f7644d);
$parcel$export(module.exports, "PrismaticConstraint", () => $b89b3d19a7b62dc7$export$ace8af3ce953789f);
$parcel$export(module.exports, "SpringConstraint", () => $b89b3d19a7b62dc7$export$5581e50ef2282ef5);

var $fopmL = parcelRequire("fopmL");
class $b89b3d19a7b62dc7$export$5a60d3a36c7d9b56 {
    /**
     * Constructs a new constraint for the physics constraint.
     * @param type The type of constraint to create.
     * @param options The options for the constraint.
     * @param scene The scene the constraint belongs to.
     *
     * This code is useful for creating a new constraint for the physics engine. It checks if the scene has a physics engine, and if the plugin version is correct.
     * If all checks pass, it initializes the constraint with the given type and options.
     */ constructor(type, options, scene){
        /**
         * V2 Physics plugin private data for a physics material
         */ this._pluginData = undefined;
        if (!scene) throw new Error("Missing scene parameter for constraint constructor.");
        const physicsEngine = scene.getPhysicsEngine();
        if (!physicsEngine) throw new Error("No Physics Engine available.");
        if (physicsEngine.getPluginVersion() != 2) throw new Error("Plugin version is incorrect. Expected version 2.");
        const physicsPlugin = physicsEngine.getPhysicsPlugin();
        if (!physicsPlugin) throw new Error("No Physics Plugin available.");
        this._physicsPlugin = physicsPlugin;
        this._options = options;
        this._type = type;
    }
    /**
     * Gets the type of the constraint.
     *
     * @returns The type of the constraint.
     *
     */ get type() {
        return this._type;
    }
    /**
     * Retrieves the options of the physics constraint.
     *
     * @returns The physics constraint parameters.
     *
     */ get options() {
        return this._options;
    }
    /**
     * Enable/disable the constraint
     * @param isEnabled value for the constraint
     */ set isEnabled(isEnabled) {
        this._physicsPlugin.setEnabled(this, isEnabled);
    }
    /**
     *
     * @returns true if constraint is enabled
     */ get isEnabled() {
        return this._physicsPlugin.getEnabled(this);
    }
    /**
     * Enables or disables collisions for the physics engine.
     *
     * @param isEnabled - A boolean value indicating whether collisions should be enabled or disabled.
     *
     */ set isCollisionsEnabled(isEnabled) {
        this._physicsPlugin.setCollisionsEnabled(this, isEnabled);
    }
    /**
     * Gets whether collisions are enabled for this physics object.
     *
     * @returns `true` if collisions are enabled, `false` otherwise.
     *
     */ get isCollisionsEnabled() {
        return this._physicsPlugin.getCollisionsEnabled(this);
    }
    /**
     * Gets all bodies that are using this constraint
     * @returns
     */ getBodiesUsingConstraint() {
        return this._physicsPlugin.getBodiesUsingConstraint(this);
    }
    /**
     * Disposes the constraint from the physics engine.
     *
     * This method is useful for cleaning up the physics engine when a body is no longer needed. Disposing the body will free up resources and prevent memory leaks.
     */ dispose() {
        this._physicsPlugin.disposeConstraint(this);
    }
}
class $b89b3d19a7b62dc7$export$3dce2449033778e9 {
}
class $b89b3d19a7b62dc7$export$fa7fc86533c4a67d extends $b89b3d19a7b62dc7$export$5a60d3a36c7d9b56 {
    constructor(constraintParams, limits, scene){
        super((0, $fopmL.PhysicsConstraintType).SIX_DOF, constraintParams, scene);
        this.limits = limits;
    }
    /**
     * Sets the friction of the given axis of the physics engine.
     * @param axis - The axis of the physics engine to set the friction for.
     * @param friction - The friction to set for the given axis.
     *
     */ setAxisFriction(axis, friction) {
        this._physicsPlugin.setAxisFriction(this, axis, friction);
    }
    /**
     * Gets the friction of the given axis of the physics engine.
     * @param axis - The axis of the physics engine.
     * @returns The friction of the given axis, or null if the constraint hasn't been initialized yet.
     *
     */ getAxisFriction(axis) {
        return this._physicsPlugin.getAxisFriction(this, axis);
    }
    /**
     * Sets the limit mode for the given axis of the constraint.
     * @param axis The axis to set the limit mode for.
     * @param limitMode The limit mode to set.
     *
     * This method is useful for setting the limit mode for a given axis of the constraint. This is important for
     * controlling the behavior of the physics engine when the constraint is reached. By setting the limit mode,
     * the engine can be configured to either stop the motion of the objects, or to allow them to continue
     * moving beyond the constraint.
     */ setAxisMode(axis, limitMode) {
        this._physicsPlugin.setAxisMode(this, axis, limitMode);
    }
    /**
     * Gets the limit mode of the given axis of the constraint.
     *
     * @param axis - The axis of the constraint.
     * @returns The limit mode of the given axis, or null if the constraint hasn't been initialized yet.
     *
     */ getAxisMode(axis) {
        return this._physicsPlugin.getAxisMode(this, axis);
    }
    /**
     * Sets the minimum limit of a given axis of a constraint.
     * @param axis - The axis of the constraint.
     * @param minLimit - The minimum limit of the axis.
     *
     */ setAxisMinLimit(axis, minLimit) {
        this._physicsPlugin.setAxisMinLimit(this, axis, minLimit);
    }
    /**
     * Gets the minimum limit of the given axis of the physics engine.
     * @param axis - The axis of the physics engine.
     * @returns The minimum limit of the given axis, or null if the constraint hasn't been initialized yet.
     *
     */ getAxisMinLimit(axis) {
        return this._physicsPlugin.getAxisMinLimit(this, axis);
    }
    /**
     * Sets the maximum limit of the given axis for the physics engine.
     * @param axis - The axis to set the limit for.
     * @param limit - The maximum limit of the axis.
     *
     * This method is useful for setting the maximum limit of the given axis for the physics engine,
     * which can be used to control the movement of the physics object. This helps to ensure that the
     * physics object does not move beyond the given limit.
     */ setAxisMaxLimit(axis, limit) {
        this._physicsPlugin.setAxisMaxLimit(this, axis, limit);
    }
    /**
     * Gets the maximum limit of the given axis of the physics engine.
     * @param axis - The axis of the physics engine.
     * @returns The maximum limit of the given axis, or null if the constraint hasn't been initialized yet.
     *
     */ getAxisMaxLimit(axis) {
        return this._physicsPlugin.getAxisMaxLimit(this, axis);
    }
    /**
     * Sets the motor type of the given axis of the constraint.
     * @param axis - The axis of the constraint.
     * @param motorType - The type of motor to use.
     */ setAxisMotorType(axis, motorType) {
        this._physicsPlugin.setAxisMotorType(this, axis, motorType);
    }
    /**
     * Gets the motor type of the specified axis of the constraint.
     *
     * @param axis - The axis of the constraint.
     * @returns The motor type of the specified axis, or null if the constraint hasn't been initialized yet.
     *
     */ getAxisMotorType(axis) {
        return this._physicsPlugin.getAxisMotorType(this, axis);
    }
    /**
     * Sets the target velocity of the motor associated with the given axis of the constraint.
     * @param axis - The axis of the constraint.
     * @param target - The target velocity of the motor.
     *
     * This method is useful for setting the target velocity of the motor associated with the given axis of the constraint.
     */ setAxisMotorTarget(axis, target) {
        this._physicsPlugin.setAxisMotorTarget(this, axis, target);
    }
    /**
     * Gets the target velocity of the motor associated to the given constraint axis.
     * @param axis - The constraint axis associated to the motor.
     * @returns The target velocity of the motor, or null if the constraint hasn't been initialized yet.
     *
     */ getAxisMotorTarget(axis) {
        return this._physicsPlugin.getAxisMotorTarget(this, axis);
    }
    /**
     * Sets the maximum force of the motor of the given axis of the constraint.
     * @param axis - The axis of the constraint.
     * @param maxForce - The maximum force of the motor.
     *
     */ setAxisMotorMaxForce(axis, maxForce) {
        this._physicsPlugin.setAxisMotorMaxForce(this, axis, maxForce);
    }
    /**
     * Gets the maximum force of the motor of the given axis of the constraint.
     * @param axis - The axis of the constraint.
     * @returns The maximum force of the motor, or null if the constraint hasn't been initialized yet.
     *
     */ getAxisMotorMaxForce(axis) {
        return this._physicsPlugin.getAxisMotorMaxForce(this, axis);
    }
}
class $b89b3d19a7b62dc7$export$3d4ca7eb4440ba64 extends $b89b3d19a7b62dc7$export$5a60d3a36c7d9b56 {
    constructor(pivotA, pivotB, axisA, axisB, scene){
        super((0, $fopmL.PhysicsConstraintType).BALL_AND_SOCKET, {
            pivotA: pivotA,
            pivotB: pivotB,
            axisA: axisA,
            axisB: axisB
        }, scene);
    }
}
class $b89b3d19a7b62dc7$export$7f13e3afb2fe70fe extends $b89b3d19a7b62dc7$export$5a60d3a36c7d9b56 {
    constructor(maxDistance, scene){
        super((0, $fopmL.PhysicsConstraintType).DISTANCE, {
            maxDistance: maxDistance
        }, scene);
    }
}
class $b89b3d19a7b62dc7$export$18c5826321ba66b3 extends $b89b3d19a7b62dc7$export$5a60d3a36c7d9b56 {
    constructor(pivotA, pivotB, axisA, axisB, scene){
        super((0, $fopmL.PhysicsConstraintType).HINGE, {
            pivotA: pivotA,
            pivotB: pivotB,
            axisA: axisA,
            axisB: axisB
        }, scene);
    }
}
class $b89b3d19a7b62dc7$export$4eb987fad49020a9 extends $b89b3d19a7b62dc7$export$5a60d3a36c7d9b56 {
    constructor(pivotA, pivotB, axisA, axisB, scene){
        super((0, $fopmL.PhysicsConstraintType).SLIDER, {
            pivotA: pivotA,
            pivotB: pivotB,
            axisA: axisA,
            axisB: axisB
        }, scene);
    }
}
class $b89b3d19a7b62dc7$export$dd4dd491c6f7644d extends $b89b3d19a7b62dc7$export$5a60d3a36c7d9b56 {
    constructor(pivotA, pivotB, axisA, axisB, scene){
        super((0, $fopmL.PhysicsConstraintType).LOCK, {
            pivotA: pivotA,
            pivotB: pivotB,
            axisA: axisA,
            axisB: axisB
        }, scene);
    }
}
class $b89b3d19a7b62dc7$export$ace8af3ce953789f extends $b89b3d19a7b62dc7$export$5a60d3a36c7d9b56 {
    constructor(pivotA, pivotB, axisA, axisB, scene){
        super((0, $fopmL.PhysicsConstraintType).PRISMATIC, {
            pivotA: pivotA,
            pivotB: pivotB,
            axisA: axisA,
            axisB: axisB
        }, scene);
    }
}
class $b89b3d19a7b62dc7$export$5581e50ef2282ef5 extends $b89b3d19a7b62dc7$export$fa7fc86533c4a67d {
    constructor(pivotA, pivotB, axisA, axisB, minDistance, maxDistance, stiffness, damping, scene){
        super({
            pivotA: pivotA,
            pivotB: pivotB,
            axisA: axisA,
            axisB: axisB
        }, [
            {
                axis: (0, $fopmL.PhysicsConstraintAxis).LINEAR_DISTANCE,
                minLimit: minDistance,
                maxLimit: maxDistance,
                stiffness: stiffness,
                damping: damping
            }
        ], scene);
    }
}

});

parcelRegister("3Z9d3", function(module, exports) {

$parcel$export(module.exports, "PhysicsMaterialCombineMode", () => $2e6e3673fffa5b1e$export$962393419043495);
/**
 * Determines how values from the PhysicsMaterial are combined when
 * two objects are in contact. When each PhysicsMaterial specifies
 * a different combine mode for some property, the combine mode which
 * is used will be selected based on their order in this enum - i.e.
 * a value later in this list will be preferentially used.
 */ var $2e6e3673fffa5b1e$export$962393419043495;
(function(PhysicsMaterialCombineMode) {
    /**
     * The final value will be the geometric mean of the two values:
     * sqrt( valueA *  valueB )
     */ PhysicsMaterialCombineMode[PhysicsMaterialCombineMode["GEOMETRIC_MEAN"] = 0] = "GEOMETRIC_MEAN";
    /**
     * The final value will be the smaller of the two:
     * min( valueA , valueB )
     */ PhysicsMaterialCombineMode[PhysicsMaterialCombineMode["MINIMUM"] = 1] = "MINIMUM";
    /* The final value will be the larger of the two:
     * max( valueA , valueB )
     */ PhysicsMaterialCombineMode[PhysicsMaterialCombineMode["MAXIMUM"] = 2] = "MAXIMUM";
    /* The final value will be the arithmetic mean of the two values:
     * (valueA + valueB) / 2
     */ PhysicsMaterialCombineMode[PhysicsMaterialCombineMode["ARITHMETIC_MEAN"] = 3] = "ARITHMETIC_MEAN";
    /**
     * The final value will be the product of the two values:
     * valueA * valueB
     */ PhysicsMaterialCombineMode[PhysicsMaterialCombineMode["MULTIPLY"] = 4] = "MULTIPLY";
})($2e6e3673fffa5b1e$export$962393419043495 || ($2e6e3673fffa5b1e$export$962393419043495 = {}));

});

parcelRegister("ifBMv", function(module, exports) {

$parcel$export(module.exports, "PhysicsAggregate", () => $d496ef462bfa4f14$export$701a82be73e72b4a);

var $8kMw0 = parcelRequire("8kMw0");

var $1UZV7 = parcelRequire("1UZV7");

var $kVtWi = parcelRequire("kVtWi");

var $ha1VO = parcelRequire("ha1VO");

var $1VEEL = parcelRequire("1VEEL");

var $fopmL = parcelRequire("fopmL");

var $7iRaI = parcelRequire("7iRaI");
class $d496ef462bfa4f14$export$701a82be73e72b4a {
    constructor(/**
     * The physics-enabled object used as the physics aggregate
     */ transformNode, /**
     * The type of the physics aggregate
     */ type, _options = {
        mass: 0
    }, _scene){
        this.transformNode = transformNode;
        this.type = type;
        this._options = _options;
        this._scene = _scene;
        this._disposeShapeWhenDisposed = true;
        //sanity check!
        if (!this.transformNode) {
            (0, $kVtWi.Logger).Error("No object was provided. A physics object is obligatory");
            return;
        }
        const m = transformNode;
        if (this.transformNode.parent && this._options.mass !== 0 && m.hasThinInstances) (0, $kVtWi.Logger).Warn("A physics body has been created for an object which has a parent and thin instances. Babylon physics currently works in local space so unexpected issues may occur.");
        // Legacy support for old syntax.
        if (!this._scene && transformNode.getScene) this._scene = transformNode.getScene();
        if (!this._scene) return;
        //default options params
        this._options.mass = _options.mass === void 0 ? 0 : _options.mass;
        this._options.friction = _options.friction === void 0 ? 0.2 : _options.friction;
        this._options.restitution = _options.restitution === void 0 ? 0.2 : _options.restitution;
        const motionType = this._options.mass === 0 ? (0, $fopmL.PhysicsMotionType).STATIC : (0, $fopmL.PhysicsMotionType).DYNAMIC;
        const startAsleep = this._options.startAsleep ?? false;
        this.body = new (0, $8kMw0.PhysicsBody)(transformNode, motionType, startAsleep, this._scene);
        this._addSizeOptions();
        if (type.getClassName && type.getClassName() === "PhysicsShape") {
            this.shape = type;
            this._disposeShapeWhenDisposed = false;
        } else this.shape = new (0, $1UZV7.PhysicsShape)({
            type: type,
            parameters: this._options
        }, this._scene);
        if (this._options.isTriggerShape) this.shape.isTrigger = true;
        this.material = {
            friction: this._options.friction,
            restitution: this._options.restitution
        };
        this.body.shape = this.shape;
        this.shape.material = this.material;
        this.body.setMassProperties({
            mass: this._options.mass
        });
        this._nodeDisposeObserver = this.transformNode.onDisposeObservable.add(()=>{
            this.dispose();
        });
    }
    _getObjectBoundingBox() {
        if (this.transformNode.getRawBoundingInfo) return this.transformNode.getRawBoundingInfo().boundingBox;
        else return new (0, $7iRaI.BoundingBox)(new (0, $ha1VO.Vector3)(-0.5, -0.5, -0.5), new (0, $ha1VO.Vector3)(0.5, 0.5, 0.5));
    }
    _hasVertices(node) {
        return node?.getTotalVertices() > 0;
    }
    _addSizeOptions() {
        this.transformNode.computeWorldMatrix(true);
        const bb = this._getObjectBoundingBox();
        const extents = (0, $ha1VO.TmpVectors).Vector3[0];
        extents.copyFrom(bb.extendSize);
        extents.scaleInPlace(2);
        extents.multiplyInPlace(this.transformNode.scaling);
        // In case we had any negative scaling, we need to take the absolute value of the extents.
        extents.x = Math.abs(extents.x);
        extents.y = Math.abs(extents.y);
        extents.z = Math.abs(extents.z);
        const min = (0, $ha1VO.TmpVectors).Vector3[1];
        min.copyFrom(bb.minimum);
        min.multiplyInPlace(this.transformNode.scaling);
        if (!this._options.center) {
            const center = new (0, $ha1VO.Vector3)();
            center.copyFrom(bb.center);
            center.multiplyInPlace(this.transformNode.scaling);
            this._options.center = center;
        }
        switch(this.type){
            case (0, $fopmL.PhysicsShapeType).SPHERE:
                if (!this._options.radius && (0, $1VEEL.Scalar).WithinEpsilon(extents.x, extents.y, 0.0001) && (0, $1VEEL.Scalar).WithinEpsilon(extents.x, extents.z, 0.0001)) this._options.radius = extents.x / 2;
                else if (!this._options.radius) {
                    (0, $kVtWi.Logger).Warn("Non uniform scaling is unsupported for sphere shapes. Setting the radius to the biggest bounding box extent.");
                    this._options.radius = Math.max(extents.x, extents.y, extents.z) / 2;
                }
                break;
            case (0, $fopmL.PhysicsShapeType).CAPSULE:
                {
                    const capRadius = extents.x / 2;
                    this._options.radius = this._options.radius ?? capRadius;
                    this._options.pointA = this._options.pointA ?? new (0, $ha1VO.Vector3)(0, min.y + capRadius, 0);
                    this._options.pointB = this._options.pointB ?? new (0, $ha1VO.Vector3)(0, min.y + extents.y - capRadius, 0);
                }
                break;
            case (0, $fopmL.PhysicsShapeType).CYLINDER:
                {
                    const capRadius = extents.x / 2;
                    this._options.radius = this._options.radius ?? capRadius;
                    this._options.pointA = this._options.pointA ?? new (0, $ha1VO.Vector3)(0, min.y, 0);
                    this._options.pointB = this._options.pointB ?? new (0, $ha1VO.Vector3)(0, min.y + extents.y, 0);
                }
                break;
            case (0, $fopmL.PhysicsShapeType).MESH:
            case (0, $fopmL.PhysicsShapeType).CONVEX_HULL:
                if (!this._options.mesh && this._hasVertices(this.transformNode)) this._options.mesh = this.transformNode;
                else if (!this._options.mesh || !this._hasVertices(this._options.mesh)) throw new Error("No valid mesh was provided for mesh or convex hull shape parameter. Please provide a mesh with valid geometry (number of vertices greater than 0).");
                break;
            case (0, $fopmL.PhysicsShapeType).BOX:
                this._options.extents = this._options.extents ?? new (0, $ha1VO.Vector3)(extents.x, extents.y, extents.z);
                this._options.rotation = this._options.rotation ?? (0, $ha1VO.Quaternion).Identity();
                break;
        }
    }
    /**
     * Releases the body, shape and material
     */ dispose() {
        if (this._nodeDisposeObserver) {
            this.body.transformNode.onDisposeObservable.remove(this._nodeDisposeObserver);
            this._nodeDisposeObserver = null;
        }
        this.body.dispose();
        if (this._disposeShapeWhenDisposed) this.shape.dispose();
    }
}

});

parcelRegister("bRVTG", function(module, exports) {

$parcel$export(module.exports, "RagdollBoneProperties", () => $8a418e1f60cd084a$export$af79b3026d70ec14);
$parcel$export(module.exports, "Ragdoll", () => $8a418e1f60cd084a$export$80bc86be7488662d);

var $ha1VO = parcelRequire("ha1VO");

var $ifBMv = parcelRequire("ifBMv");

var $fQEDT = parcelRequire("fQEDT");

var $dbxbu = parcelRequire("dbxbu");

var $fopmL = parcelRequire("fopmL");

var $kVtWi = parcelRequire("kVtWi");

var $klshO = parcelRequire("klshO");
class $8a418e1f60cd084a$export$af79b3026d70ec14 {
}
class $8a418e1f60cd084a$export$80bc86be7488662d {
    /**
     * Construct a new Ragdoll object. Once ready, it can be made dynamic by calling `Ragdoll` method
     * @param skeleton The skeleton containing bones to be physicalized
     * @param rootTransformNode The mesh or its transform used by the skeleton
     * @param config an array of `RagdollBoneProperties` corresponding to bones and their properties used to instanciate physics bodies
     */ constructor(skeleton, rootTransformNode, config){
        this._boxConfigs = new Array();
        this._joints = new Array();
        this._bones = new Array();
        this._initialRotation = new Array();
        // without mesh transform, to figure out later
        this._initialRotation2 = new Array();
        this._boneNames = [];
        this._transforms = new Array();
        this._aggregates = new Array();
        this._ragdollMode = false;
        this._rootBoneName = "";
        this._rootBoneIndex = -1;
        this._mass = 10;
        this._restitution = 0;
        /**
         * Pause synchronization between physics and bone position/orientation
         */ this.pauseSync = false;
        this._defaultJoint = (0, $fopmL.PhysicsConstraintType).HINGE;
        this._defaultJointMin = -90;
        this._defaultJointMax = 90;
        this._skeleton = skeleton;
        this._scene = skeleton.getScene();
        this._rootTransformNode = rootTransformNode;
        this._config = config; // initial, user defined box configs. May have several box configs jammed into 1 index.
        this._boxConfigs = []; // final box configs. Every element is a separate box config (this.config may have several configs jammed into 1 index).
        this._putBoxesInBoneCenter = false;
        this._defaultJoint = (0, $fopmL.PhysicsConstraintType).HINGE;
        this._init();
    }
    /**
     * Returns the aggregate corresponding to the ragdoll bone index
     * @param index ragdoll bone aggregate index
     * @returns the aggregate for the bone index for the root aggregate if index is invalid
     */ getAggregate(index) {
        if (index < 0 || index >= this._aggregates.length) return this._aggregates[this._rootBoneIndex];
        return this._aggregates[index];
    }
    _createColliders() {
        this._rootTransformNode.computeWorldMatrix();
        this._skeleton.computeAbsoluteMatrices(true);
        this._skeleton.prepare(true);
        const config = this._config;
        for(let i = 0; i < config.length; i++){
            const boneNames = config[i].bone !== undefined ? [
                config[i].bone
            ] : config[i].bones;
            for(let ii = 0; ii < boneNames.length; ii++){
                const currentBone = this._skeleton.bones[this._skeleton.getBoneIndexByName(boneNames[ii])];
                if (currentBone == undefined) return;
                // First define the box dimensions, so we can then use them when calling CreateBox().
                const currentRagdollBoneProperties = {
                    width: this._config[i].width,
                    depth: this._config[i].depth,
                    height: this._config[i].height,
                    size: this._config[i].size
                };
                currentRagdollBoneProperties.width = currentRagdollBoneProperties.width ?? currentRagdollBoneProperties.size;
                currentRagdollBoneProperties.depth = currentRagdollBoneProperties.depth ?? currentRagdollBoneProperties.size;
                currentRagdollBoneProperties.height = currentRagdollBoneProperties.height ?? currentRagdollBoneProperties.size;
                const transform = new (0, $klshO.TransformNode)(boneNames[ii] + "_transform", this._scene);
                // Define the rest of the box properties.
                currentRagdollBoneProperties.joint = config[i].joint !== undefined ? config[i].joint : this._defaultJoint;
                currentRagdollBoneProperties.rotationAxis = config[i].rotationAxis !== undefined ? config[i].rotationAxis : (0, $dbxbu.Axis).X;
                currentRagdollBoneProperties.min = config[i].min !== undefined ? config[i].min : this._defaultJointMin;
                currentRagdollBoneProperties.max = config[i].max !== undefined ? config[i].max : this._defaultJointMax;
                // Offset value.
                let boxOffset = 0;
                if (config[i].putBoxInBoneCenter !== undefined && config[i].putBoxInBoneCenter || this._putBoxesInBoneCenter) {
                    if (currentBone.length === undefined) (0, $kVtWi.Logger).Log("The length property is not defined for bone " + currentBone.name);
                    boxOffset = currentBone.length / 2;
                } else if (config[i].boxOffset !== undefined) boxOffset = config[i].boxOffset;
                currentRagdollBoneProperties.boxOffset = boxOffset;
                // Offset axis.
                const boneOffsetAxis = config[i].boneOffsetAxis !== undefined ? config[i].boneOffsetAxis : (0, $dbxbu.Axis).Y;
                const boneDir = currentBone.getDirection(boneOffsetAxis, this._rootTransformNode);
                currentRagdollBoneProperties.boneOffsetAxis = boneOffsetAxis;
                transform.position = currentBone.getAbsolutePosition(this._rootTransformNode).add(boneDir.scale(boxOffset));
                const mass = config[i].mass !== undefined ? config[i].mass : this._mass;
                const restitution = config[i].restitution !== undefined ? config[i].restitution : this._restitution;
                const aggregate = new (0, $ifBMv.PhysicsAggregate)(transform, (0, $fopmL.PhysicsShapeType).BOX, {
                    mass: mass,
                    restitution: restitution,
                    friction: 0.6,
                    extents: new (0, $ha1VO.Vector3)(currentRagdollBoneProperties.width, currentRagdollBoneProperties.height, currentRagdollBoneProperties.depth)
                }, this._scene);
                aggregate.body.setCollisionCallbackEnabled(true);
                aggregate.body.disablePreStep = false;
                aggregate.body.setMotionType((0, $fopmL.PhysicsMotionType).ANIMATED);
                this._aggregates.push(aggregate);
                this._bones.push(currentBone);
                this._boneNames.push(currentBone.name);
                this._transforms.push(transform);
                this._boxConfigs.push(currentRagdollBoneProperties);
                this._initialRotation.push(currentBone.getRotationQuaternion((0, $dbxbu.Space).WORLD, this._rootTransformNode));
                this._initialRotation2.push(currentBone.getRotationQuaternion((0, $dbxbu.Space).WORLD));
            }
        }
    }
    _initJoints() {
        this._rootTransformNode.computeWorldMatrix();
        for(let i = 0; i < this._bones.length; i++){
            // The root bone has no joints.
            if (i == this._rootBoneIndex) continue;
            const nearestParent = this._findNearestParent(i);
            if (nearestParent == null) {
                (0, $kVtWi.Logger).Warn("Couldn't find a nearest parent bone in the configs for bone called " + this._boneNames[i]);
                return;
            }
            const boneParentIndex = this._boneNames.indexOf(nearestParent.name);
            let distanceFromParentBoxToBone = this._bones[i].getAbsolutePosition(this._rootTransformNode).subtract(this._transforms[boneParentIndex].position);
            const wmat = this._transforms[boneParentIndex].computeWorldMatrix();
            const invertedWorldMat = (0, $ha1VO.Matrix).Invert(wmat);
            distanceFromParentBoxToBone = (0, $ha1VO.Vector3).TransformCoordinates(this._bones[i].getAbsolutePosition(this._rootTransformNode), invertedWorldMat);
            const boneAbsPos = this._bones[i].getAbsolutePosition(this._rootTransformNode);
            const boxAbsPos = this._transforms[i].position.clone();
            const myConnectedPivot = boneAbsPos.subtract(boxAbsPos);
            const joint = new (0, $fQEDT.PhysicsConstraint)((0, $fopmL.PhysicsConstraintType).BALL_AND_SOCKET, {
                pivotA: distanceFromParentBoxToBone,
                pivotB: myConnectedPivot,
                axisA: this._boxConfigs[i].rotationAxis,
                axisB: this._boxConfigs[i].rotationAxis,
                collision: false
            }, this._scene);
            this._aggregates[boneParentIndex].body.addConstraint(this._aggregates[i].body, joint);
            joint.isEnabled = false;
            this._joints.push(joint);
        }
    }
    // set physics body orientation/position from bones
    _syncBonesToPhysics() {
        const rootMatrix = this._rootTransformNode.getWorldMatrix();
        for(let i = 0; i < this._bones.length; i++){
            // position
            const transform = this._aggregates[i].transformNode;
            const rootPos = this._bones[i].getAbsolutePosition();
            (0, $ha1VO.Vector3).TransformCoordinatesToRef(rootPos, rootMatrix, transform.position);
            // added offset
            this._bones[i].getDirectionToRef(this._boxConfigs[i].boneOffsetAxis, this._rootTransformNode, (0, $ha1VO.TmpVectors).Vector3[0]);
            (0, $ha1VO.TmpVectors).Vector3[0].scaleInPlace(this._boxConfigs[i].boxOffset ?? 0);
            transform.position.addInPlace((0, $ha1VO.TmpVectors).Vector3[0]);
            this._setBoneOrientationToBody(i);
        }
    }
    _setBoneOrientationToBody(boneIndex) {
        const transform = this._aggregates[boneIndex].transformNode;
        const bone = this._bones[boneIndex];
        this._initialRotation[boneIndex].conjugateToRef((0, $ha1VO.TmpVectors).Quaternion[0]);
        bone.getRotationQuaternionToRef((0, $dbxbu.Space).WORLD, this._rootTransformNode, (0, $ha1VO.TmpVectors).Quaternion[1]);
        (0, $ha1VO.TmpVectors).Quaternion[1].multiplyToRef((0, $ha1VO.TmpVectors).Quaternion[0], transform.rotationQuaternion);
        transform.rotationQuaternion.normalize();
    }
    _syncBonesAndBoxes() {
        if (this.pauseSync) return;
        if (this._ragdollMode) {
            this._setBodyOrientationToBone(this._rootBoneIndex);
            const rootPos = this._aggregates[this._rootBoneIndex].body.transformNode.position;
            this._rootTransformNode.getWorldMatrix().invertToRef((0, $ha1VO.TmpVectors).Matrix[0]);
            (0, $ha1VO.Vector3).TransformCoordinatesToRef(rootPos, (0, $ha1VO.TmpVectors).Matrix[0], (0, $ha1VO.TmpVectors).Vector3[0]);
            this._bones[this._rootBoneIndex].setAbsolutePosition((0, $ha1VO.TmpVectors).Vector3[0]);
            for(let i = 0; i < this._bones.length; i++){
                if (i == this._rootBoneIndex) continue;
                this._setBodyOrientationToBone(i);
            }
        } else this._syncBonesToPhysics();
    }
    _setBodyOrientationToBone(boneIndex) {
        const qmesh = this._rootTransformNode.rotationQuaternion ?? (0, $ha1VO.Quaternion).FromEulerAngles(this._rootTransformNode.rotation.x, this._rootTransformNode.rotation.y, this._rootTransformNode.rotation.z);
        const qbind = this._initialRotation2[boneIndex];
        const qphys = this._aggregates[boneIndex].body?.transformNode?.rotationQuaternion;
        qmesh.multiplyToRef(qbind, (0, $ha1VO.TmpVectors).Quaternion[1]);
        qphys.multiplyToRef((0, $ha1VO.TmpVectors).Quaternion[1], (0, $ha1VO.TmpVectors).Quaternion[0]);
        this._bones[boneIndex].setRotationQuaternion((0, $ha1VO.TmpVectors).Quaternion[0], (0, $dbxbu.Space).WORLD, this._rootTransformNode);
    }
    // Return true if root bone is valid/exists in this.bonesNames. false otherwise.
    _defineRootBone() {
        const skeletonRoots = this._skeleton.getChildren();
        if (skeletonRoots.length != 1) {
            (0, $kVtWi.Logger).Log("Ragdoll creation failed: there can only be one root in the skeleton.");
            return false;
        }
        this._rootBoneName = skeletonRoots[0].name;
        this._rootBoneIndex = this._boneNames.indexOf(this._rootBoneName);
        if (this._rootBoneIndex == -1) {
            (0, $kVtWi.Logger).Log("Ragdoll creation failed: the array boneNames doesn't have the root bone. The root bone is " + this._skeleton.getChildren());
            return false;
        }
        return true;
    }
    _findNearestParent(boneIndex) {
        let nearestParent = this._bones[boneIndex].getParent();
        do {
            if (nearestParent != null && this._boneNames.includes(nearestParent.name)) break;
            nearestParent = nearestParent?.getParent();
        }while (nearestParent != null);
        return nearestParent;
    }
    _init() {
        this._createColliders();
        // If this.defineRootBone() returns ... there is not root bone.
        if (!this._defineRootBone()) return;
        this._initJoints();
        this._scene.registerBeforeRender(()=>{
            this._syncBonesAndBoxes();
        });
        this._syncBonesToPhysics();
    }
    /**
     * Enable ragdoll mode. Create physics objects and make them dynamic.
     */ ragdoll() {
        this._ragdollMode = true;
        // detach bones with link transform to let physics have control
        this._skeleton.bones.forEach((bone)=>{
            bone.linkTransformNode(null);
        });
        for(let i = 0; i < this._joints.length; i++)this._joints[i].isEnabled = true;
        for(let i = 0; i < this._aggregates.length; i++)this._aggregates[i].body.setMotionType((0, $fopmL.PhysicsMotionType).DYNAMIC);
    }
    /**
     * Dispose resources and remove physics objects
     */ dispose() {
        this._aggregates.forEach((aggregate)=>{
            aggregate.dispose();
        });
    }
}

});

parcelRegister("l142r", function(module, exports) {

var $eQVbu = parcelRequire("eQVbu");
$parcel$exportWildcard(module.exports, $eQVbu);

});
parcelRegister("eQVbu", function(module, exports) {

$parcel$export(module.exports, "HavokPlugin", () => $ad0247a06a3c1725$export$50acb44530c1e0f2);

var $ha1VO = parcelRequire("ha1VO");

var $fopmL = parcelRequire("fopmL");

var $kVtWi = parcelRequire("kVtWi");

var $3Z9d3 = parcelRequire("3Z9d3");

var $1UZV7 = parcelRequire("1UZV7");

var $fbuqw = parcelRequire("fbuqw");

var $9Xybp = parcelRequire("9Xybp");

var $b4i1f = parcelRequire("b4i1f");

var $opFp4 = parcelRequire("opFp4");

var $diGQf = parcelRequire("diGQf");
class $ad0247a06a3c1725$var$MeshAccumulator {
    /**
     * Constructor of the mesh accumulator
     * @param mesh - The mesh used to compute the world matrix.
     * @param collectIndices - use mesh indices
     * @param scene - The scene used to determine the right handed system.
     *
     * Merge mesh and its children so whole hierarchy can be used as a mesh shape or convex hull
     */ constructor(mesh, collectIndices, scene){
        this._vertices = []; /// Vertices in body space
        this._indices = [];
        this._isRightHanded = scene.useRightHandedSystem;
        this._collectIndices = collectIndices;
    }
    /**
     * Adds a mesh to the physics engine.
     * @param mesh The mesh to add.
     * @param includeChildren Whether to include the children of the mesh.
     *
     * This method adds a mesh to the physics engine by computing the world matrix,
     * multiplying it with the body from world matrix, and then transforming the
     * coordinates of the mesh's vertices. It also adds the indices of the mesh
     * to the physics engine. If includeChildren is true, it will also add the
     * children of the mesh to the physics engine, ignoring any children which
     * have a physics impostor. This is useful for creating a physics engine
     * that accurately reflects the mesh and its children.
     */ addNodeMeshes(mesh, includeChildren) {
        // Force absoluteScaling to be computed; we're going to use that to bake
        // the scale of any parent nodes into this shape, as physics engines
        // usually use rigid transforms, so can't handle arbitrary scale.
        mesh.computeWorldMatrix(true);
        const rootScaled = (0, $ha1VO.TmpVectors).Matrix[0];
        (0, $ha1VO.Matrix).ScalingToRef(mesh.absoluteScaling.x, mesh.absoluteScaling.y, mesh.absoluteScaling.z, rootScaled);
        if (mesh instanceof (0, $fbuqw.Mesh)) this._addMesh(mesh, rootScaled);
        else if (mesh instanceof (0, $9Xybp.InstancedMesh)) this._addMesh(mesh.sourceMesh, rootScaled);
        if (includeChildren) {
            const worldToRoot = (0, $ha1VO.TmpVectors).Matrix[1];
            mesh.computeWorldMatrix().invertToRef(worldToRoot);
            const worldToRootScaled = (0, $ha1VO.TmpVectors).Matrix[2];
            worldToRoot.multiplyToRef(rootScaled, worldToRootScaled);
            const children = mesh.getChildMeshes(false);
            //  Ignore any children which have a physics body.
            //  Other plugin implementations do not have this check, which appears to be
            //  a bug, as otherwise, the mesh will have a duplicate collider
            children.filter((m)=>!m.physicsBody).forEach((m)=>{
                const childToWorld = m.computeWorldMatrix();
                const childToRootScaled = (0, $ha1VO.TmpVectors).Matrix[3];
                childToWorld.multiplyToRef(worldToRootScaled, childToRootScaled);
                if (m instanceof (0, $fbuqw.Mesh)) this._addMesh(m, childToRootScaled);
                else if (m instanceof (0, $9Xybp.InstancedMesh)) this._addMesh(m.sourceMesh, childToRootScaled);
            });
        }
    }
    _addMesh(mesh, meshToRoot) {
        const vertexData = mesh.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind) || [];
        const numVerts = vertexData.length / 3;
        const indexOffset = this._vertices.length;
        for(let v = 0; v < numVerts; v++){
            const pos = new (0, $ha1VO.Vector3)(vertexData[v * 3 + 0], vertexData[v * 3 + 1], vertexData[v * 3 + 2]);
            this._vertices.push((0, $ha1VO.Vector3).TransformCoordinates(pos, meshToRoot));
        }
        if (this._collectIndices) {
            const meshIndices = mesh.getIndices();
            if (meshIndices) {
                for(let i = 0; i < meshIndices.length; i += 3)// Havok wants the correct triangle winding to enable the interior triangle optimization
                if (this._isRightHanded) {
                    this._indices.push(meshIndices[i + 0] + indexOffset);
                    this._indices.push(meshIndices[i + 1] + indexOffset);
                    this._indices.push(meshIndices[i + 2] + indexOffset);
                } else {
                    this._indices.push(meshIndices[i + 2] + indexOffset);
                    this._indices.push(meshIndices[i + 1] + indexOffset);
                    this._indices.push(meshIndices[i + 0] + indexOffset);
                }
            }
        }
    }
    /**
     * Allocate and populate the vertex positions inside the physics plugin.
     *
     * @param plugin - The plugin to allocate the memory in.
     * @returns An array of floats, whose backing memory is inside the plugin. The array contains the
     * positions of the mesh vertices, where a position is defined by three floats. You must call
     * freeBuffer() on the returned array once you have finished with it, in order to free the
     * memory inside the plugin..
     */ getVertices(plugin) {
        const nFloats = this._vertices.length * 3;
        const bytesPerFloat = 4;
        const nBytes = nFloats * bytesPerFloat;
        const bufferBegin = plugin._malloc(nBytes);
        const ret = new Float32Array(plugin.HEAPU8.buffer, bufferBegin, nFloats);
        for(let i = 0; i < this._vertices.length; i++){
            ret[i * 3 + 0] = this._vertices[i].x;
            ret[i * 3 + 1] = this._vertices[i].y;
            ret[i * 3 + 2] = this._vertices[i].z;
        }
        return {
            offset: bufferBegin,
            numObjects: nFloats
        };
    }
    freeBuffer(plugin, arr) {
        plugin._free(arr.offset);
    }
    /**
     * Allocate and populate the triangle indices inside the physics plugin
     *
     * @param plugin - The plugin to allocate the memory in.
     * @returns A new Int32Array, whose backing memory is inside the plugin. The array contains the indices
     * of the triangle positions, where a single triangle is defined by three indices. You must call
     * freeBuffer() on this array once you have finished with it, to free the memory inside the plugin..
     */ getTriangles(plugin) {
        const bytesPerInt = 4;
        const nBytes = this._indices.length * bytesPerInt;
        const bufferBegin = plugin._malloc(nBytes);
        const ret = new Int32Array(plugin.HEAPU8.buffer, bufferBegin, this._indices.length);
        for(let i = 0; i < this._indices.length; i++)ret[i] = this._indices[i];
        return {
            offset: bufferBegin,
            numObjects: this._indices.length
        };
    }
}
class $ad0247a06a3c1725$var$BodyPluginData {
    constructor(bodyId){
        this.hpBodyId = bodyId;
        this.userMassProps = {
            centerOfMass: undefined,
            mass: undefined,
            inertia: undefined,
            inertiaOrientation: undefined
        };
    }
}
/*
class ShapePath
{
    public colliderId: number;
    public pathData: number;
}
*/ class $ad0247a06a3c1725$var$CollisionContactPoint {
    constructor(){
        this.bodyId = BigInt(0); //0,2
        //public colliderId: number = 0; //2,4
        //public shapePath: ShapePath = new ShapePath(); //4,8
        this.position = new (0, $ha1VO.Vector3)(); //8,11
        this.normal = new (0, $ha1VO.Vector3)(); //11,14
    //public triIdx: number = 0; //14,15
    }
}
class $ad0247a06a3c1725$var$CollisionEvent {
    constructor(){
        this.contactOnA = new $ad0247a06a3c1725$var$CollisionContactPoint(); //1
        this.contactOnB = new $ad0247a06a3c1725$var$CollisionContactPoint();
        this.impulseApplied = 0;
        this.type = 0;
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    static readToRef(buffer, offset, eventOut) {
        const intBuf = new Int32Array(buffer, offset);
        const floatBuf = new Float32Array(buffer, offset);
        const offA = 2;
        eventOut.contactOnA.bodyId = BigInt(intBuf[offA]); //<todo Need to get the high+low words!
        eventOut.contactOnA.position.set(floatBuf[offA + 8], floatBuf[offA + 9], floatBuf[offA + 10]);
        eventOut.contactOnA.normal.set(floatBuf[offA + 11], floatBuf[offA + 12], floatBuf[offA + 13]);
        const offB = 18;
        eventOut.contactOnB.bodyId = BigInt(intBuf[offB]);
        eventOut.contactOnB.position.set(floatBuf[offB + 8], floatBuf[offB + 9], floatBuf[offB + 10]);
        eventOut.contactOnB.normal.set(floatBuf[offB + 11], floatBuf[offB + 12], floatBuf[offB + 13]);
        eventOut.impulseApplied = floatBuf[offB + 13 + 3];
        eventOut.type = intBuf[0];
    }
}
class $ad0247a06a3c1725$var$TriggerEvent {
    constructor(){
        this.bodyIdA = BigInt(0);
        this.bodyIdB = BigInt(0);
        this.type = 0;
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    static readToRef(buffer, offset, eventOut) {
        const intBuf = new Int32Array(buffer, offset);
        eventOut.type = intBuf[0];
        eventOut.bodyIdA = BigInt(intBuf[2]);
        eventOut.bodyIdB = BigInt(intBuf[6]);
    }
}
class $ad0247a06a3c1725$export$50acb44530c1e0f2 {
    constructor(_useDeltaForWorldStep = true, hpInjection = HK){
        this._useDeltaForWorldStep = _useDeltaForWorldStep;
        /**
         * Reference to the WASM library
         */ this._hknp = {};
        /**
         * Name of the plugin
         */ this.name = "HavokPlugin";
        this._fixedTimeStep = 1 / 60;
        this._tmpVec3 = (0, $opFp4.ArrayTools).BuildArray(3, (0, $ha1VO.Vector3).Zero);
        this._bodies = new Map();
        this._shapes = new Map();
        this._bodyCollisionObservable = new Map();
        // Map from constraint id to the pair of bodies, where the first is the parent and the second is the child
        this._constraintToBodyIdPair = new Map();
        this._bodyCollisionEndedObservable = new Map();
        /**
         * Observable for collision started and collision continued events
         */ this.onCollisionObservable = new (0, $diGQf.Observable)();
        /**
         * Observable for collision ended events
         */ this.onCollisionEndedObservable = new (0, $diGQf.Observable)();
        /**
         * Observable for trigger entered and trigger exited events
         */ this.onTriggerCollisionObservable = new (0, $diGQf.Observable)();
        if (typeof hpInjection === "function") {
            (0, $kVtWi.Logger).Error("Havok is not ready. Please make sure you await HK() before using the plugin.");
            return;
        } else this._hknp = hpInjection;
        if (!this.isSupported()) {
            (0, $kVtWi.Logger).Error("Havok is not available. Please make sure you included the js file.");
            return;
        }
        this.world = this._hknp.HP_World_Create()[1];
        this._queryCollector = this._hknp.HP_QueryCollector_Create(1)[1];
    }
    /**
     * If this plugin is supported
     * @returns true if its supported
     */ isSupported() {
        return this._hknp !== undefined;
    }
    /**
     * Sets the gravity of the physics world.
     *
     * @param gravity - The gravity vector to set.
     *
     */ setGravity(gravity) {
        this._hknp.HP_World_SetGravity(this.world, this._bVecToV3(gravity));
    }
    /**
     * Sets the fixed time step for the physics engine.
     *
     * @param timeStep - The fixed time step to use for the physics engine.
     *
     */ setTimeStep(timeStep) {
        this._fixedTimeStep = timeStep;
    }
    /**
     * Gets the fixed time step used by the physics engine.
     *
     * @returns The fixed time step used by the physics engine.
     *
     */ getTimeStep() {
        return this._fixedTimeStep;
    }
    /**
     * Executes a single step of the physics engine.
     *
     * @param delta The time delta in seconds since the last step.
     * @param physicsBodies An array of physics bodies to be simulated.
     *
     * This method is useful for simulating the physics engine. It sets the physics body transformation,
     * steps the world, syncs the physics body, and notifies collisions. This allows for the physics engine
     * to accurately simulate the physics bodies in the world.
     */ executeStep(delta, physicsBodies) {
        for (const physicsBody of physicsBodies){
            if (physicsBody.disablePreStep) continue;
            this.setPhysicsBodyTransformation(physicsBody, physicsBody.transformNode);
        }
        const deltaTime = this._useDeltaForWorldStep ? delta : this._fixedTimeStep;
        this._hknp.HP_World_SetIdealStepTime(this.world, deltaTime);
        this._hknp.HP_World_Step(this.world, deltaTime);
        this._bodyBuffer = this._hknp.HP_World_GetBodyBuffer(this.world)[1];
        for (const physicsBody of physicsBodies)if (!physicsBody.disableSync) this.sync(physicsBody);
        this._notifyCollisions();
        this._notifyTriggers();
    }
    /**
     * Returns the version of the physics engine plugin.
     *
     * @returns The version of the physics engine plugin.
     *
     * This method is useful for determining the version of the physics engine plugin that is currently running.
     */ getPluginVersion() {
        return 2;
    }
    /**
     * Initializes a physics body with the given position and orientation.
     *
     * @param body - The physics body to initialize.
     * @param motionType - The motion type of the body.
     * @param position - The position of the body.
     * @param orientation - The orientation of the body.
     * This code is useful for initializing a physics body with the given position and orientation.
     * It creates a plugin data for the body and adds it to the world. It then converts the position
     * and orientation to a transform and sets the body's transform to the given values.
     */ initBody(body, motionType, position, orientation) {
        body._pluginData = new $ad0247a06a3c1725$var$BodyPluginData(this._hknp.HP_Body_Create()[1]);
        this._internalSetMotionType(body._pluginData, motionType);
        const transform = [
            this._bVecToV3(position),
            this._bQuatToV4(orientation)
        ]; //<todo temp transform?
        this._hknp.HP_Body_SetQTransform(body._pluginData.hpBodyId, transform);
        this._hknp.HP_World_AddBody(this.world, body._pluginData.hpBodyId, body.startAsleep);
        this._bodies.set(body._pluginData.hpBodyId[0], {
            body: body,
            index: 0
        });
    }
    /**
     * Removes a body from the world. To dispose of a body, it is necessary to remove it from the world first.
     *
     * @param body - The body to remove.
     */ removeBody(body) {
        if (body._pluginDataInstances && body._pluginDataInstances.length > 0) for (const instance of body._pluginDataInstances){
            this._bodyCollisionObservable.delete(instance.hpBodyId[0]);
            this._hknp.HP_World_RemoveBody(this.world, instance.hpBodyId);
            this._bodies.delete(instance.hpBodyId[0]);
        }
        if (body._pluginData) {
            this._bodyCollisionObservable.delete(body._pluginData.hpBodyId[0]);
            this._hknp.HP_World_RemoveBody(this.world, body._pluginData.hpBodyId);
            this._bodies.delete(body._pluginData.hpBodyId[0]);
        }
    }
    /**
     * Initializes the body instances for a given physics body and mesh.
     *
     * @param body - The physics body to initialize.
     * @param motionType - How the body will be handled by the engine
     * @param mesh - The mesh to initialize.
     *
     * This code is useful for creating a physics body from a mesh. It creates a
     * body instance for each instance of the mesh and adds it to the world. It also
     * sets the position of the body instance to the position of the mesh instance.
     * This allows for the physics engine to accurately simulate the mesh in the
     * world.
     */ initBodyInstances(body, motionType, mesh) {
        const instancesCount = mesh._thinInstanceDataStorage?.instancesCount ?? 0;
        const matrixData = mesh._thinInstanceDataStorage.matrixData;
        if (!matrixData) return; // TODO: error handling
        this._createOrUpdateBodyInstances(body, motionType, matrixData, 0, instancesCount, false);
        body._pluginDataInstances.forEach((bodyId, index)=>{
            this._bodies.set(bodyId.hpBodyId[0], {
                body: body,
                index: index
            });
        });
    }
    _createOrUpdateBodyInstances(body, motionType, matrixData, startIndex, endIndex, update) {
        const rotation = (0, $ha1VO.TmpVectors).Quaternion[0];
        const rotationMatrix = (0, $ha1VO.Matrix).Identity();
        for(let i = startIndex; i < endIndex; i++){
            const position = [
                matrixData[i * 16 + 12],
                matrixData[i * 16 + 13],
                matrixData[i * 16 + 14]
            ];
            let hkbody;
            if (!update) hkbody = this._hknp.HP_Body_Create()[1];
            else hkbody = body._pluginDataInstances[i].hpBodyId;
            rotationMatrix.setRowFromFloats(0, matrixData[i * 16 + 0], matrixData[i * 16 + 1], matrixData[i * 16 + 2], 0);
            rotationMatrix.setRowFromFloats(1, matrixData[i * 16 + 4], matrixData[i * 16 + 5], matrixData[i * 16 + 6], 0);
            rotationMatrix.setRowFromFloats(2, matrixData[i * 16 + 8], matrixData[i * 16 + 9], matrixData[i * 16 + 10], 0);
            (0, $ha1VO.Quaternion).FromRotationMatrixToRef(rotationMatrix, rotation);
            const transform = [
                position,
                [
                    rotation.x,
                    rotation.y,
                    rotation.z,
                    rotation.w
                ]
            ];
            this._hknp.HP_Body_SetQTransform(hkbody, transform);
            if (!update) {
                const pluginData = new $ad0247a06a3c1725$var$BodyPluginData(hkbody);
                if (body._pluginDataInstances.length) // If an instance already exists, copy any user-provided mass properties
                pluginData.userMassProps = body._pluginDataInstances[0].userMassProps;
                this._internalSetMotionType(pluginData, motionType);
                this._internalUpdateMassProperties(pluginData);
                body._pluginDataInstances.push(pluginData);
                this._hknp.HP_World_AddBody(this.world, hkbody, body.startAsleep);
                pluginData.worldTransformOffset = this._hknp.HP_Body_GetWorldTransformOffset(hkbody)[1];
            }
        }
    }
    /**
     * Update the internal body instances for a given physics body to match the instances in a mesh.
     * @param body the body that will be updated
     * @param mesh the mesh with reference instances
     */ updateBodyInstances(body, mesh) {
        const instancesCount = mesh._thinInstanceDataStorage?.instancesCount ?? 0;
        const matrixData = mesh._thinInstanceDataStorage.matrixData;
        if (!matrixData) return; // TODO: error handling
        const pluginInstancesCount = body._pluginDataInstances.length;
        const motionType = this.getMotionType(body);
        if (instancesCount > pluginInstancesCount) {
            this._createOrUpdateBodyInstances(body, motionType, matrixData, pluginInstancesCount, instancesCount, false);
            const firstBodyShape = this._hknp.HP_Body_GetShape(body._pluginDataInstances[0].hpBodyId)[1];
            for(let i = pluginInstancesCount; i < instancesCount; i++){
                this._hknp.HP_Body_SetShape(body._pluginDataInstances[i].hpBodyId, firstBodyShape);
                this._internalUpdateMassProperties(body._pluginDataInstances[i]);
                this._bodies.set(body._pluginDataInstances[i].hpBodyId[0], {
                    body: body,
                    index: i
                });
            }
        } else if (instancesCount < pluginInstancesCount) {
            const instancesToRemove = pluginInstancesCount - instancesCount;
            for(let i = 0; i < instancesToRemove; i++){
                const hkbody = body._pluginDataInstances.pop();
                this._bodies.delete(hkbody.hpBodyId[0]);
                this._hknp.HP_World_RemoveBody(this.world, hkbody.hpBodyId);
                this._hknp.HP_Body_Release(hkbody.hpBodyId);
            }
            this._createOrUpdateBodyInstances(body, motionType, matrixData, 0, instancesCount, true);
        }
    }
    /**
     * Synchronizes the transform of a physics body with its transform node.
     * @param body - The physics body to synchronize.
     *
     * This function is useful for keeping the physics body's transform in sync with its transform node.
     * This is important for ensuring that the physics body is accurately represented in the physics engine.
     */ sync(body) {
        this.syncTransform(body, body.transformNode);
    }
    /**
     * Synchronizes the transform of a physics body with the transform of its
     * corresponding transform node.
     *
     * @param body - The physics body to synchronize.
     * @param transformNode - The destination Transform Node.
     *
     * This code is useful for synchronizing the position and orientation of a
     * physics body with the position and orientation of its corresponding
     * transform node. This is important for ensuring that the physics body and
     * the transform node are in the same position and orientation in the scene.
     * This is necessary for the physics engine to accurately simulate the
     * physical behavior of the body.
     */ syncTransform(body, transformNode) {
        if (body._pluginDataInstances.length) {
            // instances
            const m = transformNode;
            const matrixData = m._thinInstanceDataStorage.matrixData;
            if (!matrixData) return; // TODO: error handling
            const instancesCount = body._pluginDataInstances.length;
            for(let i = 0; i < instancesCount; i++){
                const bufOffset = body._pluginDataInstances[i].worldTransformOffset;
                const transformBuffer = new Float32Array(this._hknp.HEAPU8.buffer, this._bodyBuffer + bufOffset, 16);
                const index = i * 16;
                for(let mi = 0; mi < 15; mi++)if ((mi & 3) != 3) matrixData[index + mi] = transformBuffer[mi];
                matrixData[index + 15] = 1;
            }
            m.thinInstanceBufferUpdated("matrix");
        } else try {
            // regular
            const bodyTransform = this._hknp.HP_Body_GetQTransform(body._pluginData.hpBodyId)[1];
            const bodyTranslation = bodyTransform[0];
            const bodyOrientation = bodyTransform[1];
            const quat = (0, $ha1VO.TmpVectors).Quaternion[0];
            quat.set(bodyOrientation[0], bodyOrientation[1], bodyOrientation[2], bodyOrientation[3]);
            const parent = transformNode.parent;
            // transform position/orientation in parent space
            if (parent && !parent.getWorldMatrix().isIdentity()) {
                parent.computeWorldMatrix(true);
                quat.normalize();
                const finalTransform = (0, $ha1VO.TmpVectors).Matrix[0];
                const finalTranslation = (0, $ha1VO.TmpVectors).Vector3[0];
                finalTranslation.copyFromFloats(bodyTranslation[0], bodyTranslation[1], bodyTranslation[2]);
                (0, $ha1VO.Matrix).ComposeToRef(transformNode.absoluteScaling, quat, finalTranslation, finalTransform);
                const parentInverseTransform = (0, $ha1VO.TmpVectors).Matrix[1];
                parent.getWorldMatrix().invertToRef(parentInverseTransform);
                const localTransform = (0, $ha1VO.TmpVectors).Matrix[2];
                finalTransform.multiplyToRef(parentInverseTransform, localTransform);
                localTransform.decomposeToTransformNode(transformNode);
                transformNode.rotationQuaternion?.normalize();
            } else {
                transformNode.position.set(bodyTranslation[0], bodyTranslation[1], bodyTranslation[2]);
                if (transformNode.rotationQuaternion) transformNode.rotationQuaternion.copyFrom(quat);
                else quat.toEulerAnglesToRef(transformNode.rotation);
            }
        } catch (e) {
            (0, $kVtWi.Logger).Error(`Syncing transform failed for node ${transformNode.name}: ${e.message}...`);
        }
    }
    /**
     * Sets the shape of a physics body.
     * @param body - The physics body to set the shape for.
     * @param shape - The physics shape to set.
     *
     * This function is used to set the shape of a physics body. It is useful for
     * creating a physics body with a specific shape, such as a box or a sphere,
     * which can then be used to simulate physical interactions in a physics engine.
     * This function is especially useful for meshes with multiple instances, as it
     * will set the shape for each instance of the mesh.
     */ setShape(body, shape) {
        const shapeHandle = shape && shape._pluginData ? shape._pluginData : BigInt(0);
        if (!(body.transformNode instanceof (0, $fbuqw.Mesh)) || !body.transformNode._thinInstanceDataStorage?.matrixData) {
            this._hknp.HP_Body_SetShape(body._pluginData.hpBodyId, shapeHandle);
            this._internalUpdateMassProperties(body._pluginData);
            return;
        }
        const m = body.transformNode;
        const instancesCount = m._thinInstanceDataStorage?.instancesCount ?? 0;
        for(let i = 0; i < instancesCount; i++){
            this._hknp.HP_Body_SetShape(body._pluginDataInstances[i].hpBodyId, shapeHandle);
            this._internalUpdateMassProperties(body._pluginDataInstances[i]);
        }
    }
    /**
     * Returns a reference to the first instance of the plugin data for a physics body.
     * @param body
     * @param instanceIndex
     * @returns a reference to the first instance
     */ _getPluginReference(body, instanceIndex) {
        return body._pluginDataInstances?.length ? body._pluginDataInstances[instanceIndex ?? 0] : body._pluginData;
    }
    /**
     * Gets the shape of a physics body. This will create a new shape object
     *
     * @param body - The physics body.
     * @returns The shape of the physics body.
     *
     */ getShape(body) {
        const pluginRef = this._getPluginReference(body);
        const shapePluginData = this._hknp.HP_Body_GetShape(pluginRef.hpBodyId)[1];
        if (shapePluginData != 0) {
            const scene = body.transformNode.getScene();
            return new (0, $1UZV7.PhysicsShape)({
                pluginData: shapePluginData
            }, scene);
        }
        return null;
    }
    /**
     * Gets the type of a physics shape.
     * @param shape - The physics shape to get the type for.
     * @returns The type of the physics shape.
     *
     */ getShapeType(shape) {
        if (shape.type) return shape.type;
        else //<todo This returns a native type!
        return this._hknp.HP_Shape_GetType(shape._pluginData);
    }
    /**
     * Sets the event mask of a physics body.
     * @param body - The physics body to set the event mask for.
     * @param eventMask - The event mask to set.
     * @param instanceIndex - The index of the instance to set the event mask for
     *
     * This function is useful for setting the event mask of a physics body, which is used to determine which events the body will respond to. This is important for ensuring that the physics engine is able to accurately simulate the behavior of the body in the game world.
     */ setEventMask(body, eventMask, instanceIndex) {
        this._applyToBodyOrInstances(body, (bodyPluginData)=>{
            this._hknp.HP_Body_SetEventMask(bodyPluginData.hpBodyId, eventMask);
        }, instanceIndex);
    }
    /**
     * Retrieves the event mask of a physics body.
     *
     * @param body - The physics body to retrieve the event mask from.
     * @param instanceIndex - The index of the instance to retrieve the event mask from.
     * @returns The event mask of the physics body.
     *
     */ getEventMask(body, instanceIndex) {
        const pluginRef = this._getPluginReference(body, instanceIndex);
        return this._hknp.HP_Body_GetEventMask(pluginRef.hpBodyId)[1];
    }
    _fromMassPropertiesTuple(massPropsTuple) {
        return {
            centerOfMass: (0, $ha1VO.Vector3).FromArray(massPropsTuple[0]),
            mass: massPropsTuple[1],
            inertia: (0, $ha1VO.Vector3).FromArray(massPropsTuple[2]),
            inertiaOrientation: (0, $ha1VO.Quaternion).FromArray(massPropsTuple[3])
        };
    }
    _internalUpdateMassProperties(pluginData) {
        // Recompute the mass based on the shape
        const newProps = this._internalComputeMassProperties(pluginData);
        const massProps = pluginData.userMassProps;
        // Override the computed values with any the user has set
        if (massProps.centerOfMass) newProps[0] = massProps.centerOfMass.asArray();
        if (massProps.mass != undefined) newProps[1] = massProps.mass;
        if (massProps.inertia) newProps[2] = massProps.inertia.asArray();
        if (massProps.inertiaOrientation) newProps[3] = massProps.inertiaOrientation.asArray();
        this._hknp.HP_Body_SetMassProperties(pluginData.hpBodyId, newProps);
    }
    _internalSetMotionType(pluginData, motionType) {
        switch(motionType){
            case (0, $fopmL.PhysicsMotionType).STATIC:
                this._hknp.HP_Body_SetMotionType(pluginData.hpBodyId, this._hknp.MotionType.STATIC);
                break;
            case (0, $fopmL.PhysicsMotionType).ANIMATED:
                this._hknp.HP_Body_SetMotionType(pluginData.hpBodyId, this._hknp.MotionType.KINEMATIC);
                break;
            case (0, $fopmL.PhysicsMotionType).DYNAMIC:
                this._hknp.HP_Body_SetMotionType(pluginData.hpBodyId, this._hknp.MotionType.DYNAMIC);
                break;
        }
    }
    /**
     * sets the motion type of a physics body.
     * @param body - The physics body to set the motion type for.
     * @param motionType - The motion type to set.
     * @param instanceIndex - The index of the instance to set the motion type for. If undefined, the motion type of all the bodies will be set.
     */ setMotionType(body, motionType, instanceIndex) {
        this._applyToBodyOrInstances(body, (pluginData)=>{
            this._internalSetMotionType(pluginData, motionType);
        }, instanceIndex);
    }
    /**
     * Gets the motion type of a physics body.
     * @param body - The physics body to get the motion type from.
     * @param instanceIndex - The index of the instance to get the motion type from. If not specified, the motion type of the first instance will be returned.
     * @returns The motion type of the physics body.
     */ getMotionType(body, instanceIndex) {
        const pluginRef = this._getPluginReference(body, instanceIndex);
        const type = this._hknp.HP_Body_GetMotionType(pluginRef.hpBodyId)[1];
        switch(type){
            case this._hknp.MotionType.STATIC:
                return (0, $fopmL.PhysicsMotionType).STATIC;
            case this._hknp.MotionType.KINEMATIC:
                return (0, $fopmL.PhysicsMotionType).ANIMATED;
            case this._hknp.MotionType.DYNAMIC:
                return (0, $fopmL.PhysicsMotionType).DYNAMIC;
        }
        throw new Error("Unknown motion type: " + type);
    }
    /**
     * sets the activation control mode of a physics body, for instance if you need the body to never sleep.
     * @param body - The physics body to set the activation control mode.
     * @param controlMode - The activation control mode.
     */ setActivationControl(body, controlMode) {
        switch(controlMode){
            case (0, $fopmL.PhysicsActivationControl).ALWAYS_ACTIVE:
                this._hknp.HP_Body_SetActivationControl(body._pluginData.hpBodyId, this._hknp.ActivationControl.ALWAYS_ACTIVE);
                break;
            case (0, $fopmL.PhysicsActivationControl).ALWAYS_INACTIVE:
                this._hknp.HP_Body_SetActivationControl(body._pluginData.hpBodyId, this._hknp.ActivationControl.ALWAYS_INACTIVE);
                break;
            case (0, $fopmL.PhysicsActivationControl).SIMULATION_CONTROLLED:
                this._hknp.HP_Body_SetActivationControl(body._pluginData.hpBodyId, this._hknp.ActivationControl.SIMULATION_CONTROLLED);
                break;
        }
    }
    _internalComputeMassProperties(pluginData) {
        const shapeRes = this._hknp.HP_Body_GetShape(pluginData.hpBodyId);
        if (shapeRes[0] == this._hknp.Result.RESULT_OK) {
            const shapeMass = this._hknp.HP_Shape_BuildMassProperties(shapeRes[1]);
            if (shapeMass[0] == this._hknp.Result.RESULT_OK) return shapeMass[1];
        }
        // Failed; return a unit inertia
        return [
            [
                0,
                0,
                0
            ],
            1,
            [
                1,
                1,
                1
            ],
            [
                0,
                0,
                0,
                1
            ]
        ];
    }
    /**
     * Computes the mass properties of a physics body, from it's shape
     *
     * @param body - The physics body to copmute the mass properties of
     * @param instanceIndex - The index of the instance to compute the mass properties of.
     * @returns The mass properties of the physics body.
     */ computeMassProperties(body, instanceIndex) {
        const pluginRef = this._getPluginReference(body, instanceIndex);
        const computed = this._internalComputeMassProperties(pluginRef);
        return this._fromMassPropertiesTuple(computed);
    }
    /**
     * Sets the mass properties of a physics body.
     *
     * @param body - The physics body to set the mass properties of.
     * @param massProps - The mass properties to set.
     * @param instanceIndex - The index of the instance to set the mass properties of. If undefined, the mass properties of all the bodies will be set.
     * This function is useful for setting the mass properties of a physics body,
     * such as its mass, inertia, and center of mass. This is important for
     * accurately simulating the physics of the body in the physics engine.
     *
     */ setMassProperties(body, massProps, instanceIndex) {
        this._applyToBodyOrInstances(body, (pluginData)=>{
            pluginData.userMassProps = massProps;
            this._internalUpdateMassProperties(pluginData);
        }, instanceIndex);
    }
    /**
     * Gets the mass properties of a physics body.
     * @param body - The physics body to get the mass properties from.
     * @param instanceIndex - The index of the instance to get the mass properties from. If not specified, the mass properties of the first instance will be returned.
     * @returns The mass properties of the physics body.
     */ getMassProperties(body, instanceIndex) {
        const pluginRef = this._getPluginReference(body, instanceIndex);
        const massPropsTuple = this._hknp.HP_Body_GetMassProperties(pluginRef.hpBodyId)[1];
        return this._fromMassPropertiesTuple(massPropsTuple);
    }
    /**
     * Sets the linear damping of the given body.
     * @param body - The body to set the linear damping for.
     * @param damping - The linear damping to set.
     * @param instanceIndex - The index of the instance to set the linear damping for. If not specified, the linear damping of the first instance will be set.
     *
     * This method is useful for controlling the linear damping of a body in a physics engine.
     * Linear damping is a force that opposes the motion of the body, and is proportional to the velocity of the body.
     * This method allows the user to set the linear damping of a body, which can be used to control the motion of the body.
     */ setLinearDamping(body, damping, instanceIndex) {
        this._applyToBodyOrInstances(body, (pluginData)=>{
            this._hknp.HP_Body_SetLinearDamping(pluginData.hpBodyId, damping);
        }, instanceIndex);
    }
    /**
     * Gets the linear damping of the given body.
     * @param body - The body to get the linear damping from.
     * @param instanceIndex - The index of the instance to get the linear damping from. If not specified, the linear damping of the first instance will be returned.
     * @returns The linear damping of the given body.
     *
     * This method is useful for getting the linear damping of a body in a physics engine.
     * Linear damping is a force that opposes the motion of the body and is proportional to the velocity of the body.
     * It is used to simulate the effects of air resistance and other forms of friction.
     */ getLinearDamping(body, instanceIndex) {
        const pluginRef = this._getPluginReference(body, instanceIndex);
        return this._hknp.HP_Body_GetLinearDamping(pluginRef.hpBodyId)[1];
    }
    /**
     * Sets the angular damping of a physics body.
     * @param body - The physics body to set the angular damping for.
     * @param damping - The angular damping value to set.
     * @param instanceIndex - The index of the instance to set the angular damping for. If not specified, the angular damping of the first instance will be set.
     *
     * This function is useful for controlling the angular velocity of a physics body.
     * By setting the angular damping, the body's angular velocity will be reduced over time, allowing for more realistic physics simulations.
     */ setAngularDamping(body, damping, instanceIndex) {
        this._applyToBodyOrInstances(body, (pluginData)=>{
            this._hknp.HP_Body_SetAngularDamping(pluginData.hpBodyId, damping);
        }, instanceIndex);
    }
    /**
     * Gets the angular damping of a physics body.
     * @param body - The physics body to get the angular damping from.
     * @param instanceIndex - The index of the instance to get the angular damping from. If not specified, the angular damping of the first instance will be returned.
     * @returns The angular damping of the body.
     *
     * This function is useful for retrieving the angular damping of a physics body,
     * which is used to control the rotational motion of the body. The angular damping is a value between 0 and 1, where 0 is no damping and 1 is full damping.
     */ getAngularDamping(body, instanceIndex) {
        const pluginRef = this._getPluginReference(body, instanceIndex);
        return this._hknp.HP_Body_GetAngularDamping(pluginRef.hpBodyId)[1];
    }
    /**
     * Sets the linear velocity of a physics body.
     * @param body - The physics body to set the linear velocity of.
     * @param linVel - The linear velocity to set.
     * @param instanceIndex - The index of the instance to set the linear velocity of. If not specified, the linear velocity of the first instance will be set.
     *
     * This function is useful for setting the linear velocity of a physics body, which is necessary for simulating
     * motion in a physics engine. The linear velocity is the speed and direction of the body's movement.
     */ setLinearVelocity(body, linVel, instanceIndex) {
        this._applyToBodyOrInstances(body, (pluginData)=>{
            this._hknp.HP_Body_SetLinearVelocity(pluginData.hpBodyId, this._bVecToV3(linVel));
        }, instanceIndex);
    }
    /**
     * Gets the linear velocity of a physics body and stores it in a given vector.
     * @param body - The physics body to get the linear velocity from.
     * @param linVel - The vector to store the linear velocity in.
     * @param instanceIndex - The index of the instance to get the linear velocity from. If not specified, the linear velocity of the first instance will be returned.
     *
     * This function is useful for retrieving the linear velocity of a physics body,
     * which can be used to determine the speed and direction of the body. This
     * information can be used to simulate realistic physics behavior in a game.
     */ getLinearVelocityToRef(body, linVel, instanceIndex) {
        const pluginRef = this._getPluginReference(body, instanceIndex);
        const lv = this._hknp.HP_Body_GetLinearVelocity(pluginRef.hpBodyId)[1];
        this._v3ToBvecRef(lv, linVel);
    }
    /*
     * Apply an operation either to all instances of a body, if instanceIndex is not specified, or to a specific instance.
     */ _applyToBodyOrInstances(body, fnToApply, instanceIndex) {
        if (body._pluginDataInstances?.length > 0 && instanceIndex === undefined) for(let i = 0; i < body._pluginDataInstances.length; i++)fnToApply(body._pluginDataInstances[i]);
        else fnToApply(this._getPluginReference(body, instanceIndex));
    }
    /**
     * Applies an impulse to a physics body at a given location.
     * @param body - The physics body to apply the impulse to.
     * @param impulse - The impulse vector to apply.
     * @param location - The location in world space to apply the impulse.
     * @param instanceIndex - The index of the instance to apply the impulse to. If not specified, the impulse will be applied to all instances.
     *
     * This method is useful for applying an impulse to a physics body at a given location.
     * This can be used to simulate physical forces such as explosions, collisions, and gravity.
     */ applyImpulse(body, impulse, location, instanceIndex) {
        this._applyToBodyOrInstances(body, (pluginRef)=>{
            this._hknp.HP_Body_ApplyImpulse(pluginRef.hpBodyId, this._bVecToV3(location), this._bVecToV3(impulse));
        }, instanceIndex);
    }
    /**
     * Applies a force to a physics body at a given location.
     * @param body - The physics body to apply the impulse to.
     * @param force - The force vector to apply.
     * @param location - The location in world space to apply the impulse.
     * @param instanceIndex - The index of the instance to apply the force to. If not specified, the force will be applied to all instances.
     *
     * This method is useful for applying a force to a physics body at a given location.
     * This can be used to simulate physical forces such as explosions, collisions, and gravity.
     */ applyForce(body, force, location, instanceIndex) {
        force.scaleToRef(this.getTimeStep(), this._tmpVec3[0]);
        this.applyImpulse(body, this._tmpVec3[0], location, instanceIndex);
    }
    /**
     * Sets the angular velocity of a physics body.
     *
     * @param body - The physics body to set the angular velocity of.
     * @param angVel - The angular velocity to set.
     * @param instanceIndex - The index of the instance to set the angular velocity of. If not specified, the angular velocity of the first instance will be set.
     *
     * This function is useful for setting the angular velocity of a physics body in a physics engine.
     * This allows for more realistic simulations of physical objects, as they can be given a rotational velocity.
     */ setAngularVelocity(body, angVel, instanceIndex) {
        this._applyToBodyOrInstances(body, (pluginRef)=>{
            this._hknp.HP_Body_SetAngularVelocity(pluginRef.hpBodyId, this._bVecToV3(angVel));
        }, instanceIndex);
    }
    /**
     * Gets the angular velocity of a body.
     * @param body - The body to get the angular velocity from.
     * @param angVel - The vector3 to store the angular velocity.
     * @param instanceIndex - The index of the instance to get the angular velocity from. If not specified, the angular velocity of the first instance will be returned.
     *
     * This method is useful for getting the angular velocity of a body in a physics engine. It
     * takes the body and a vector3 as parameters and stores the angular velocity of the body
     * in the vector3. This is useful for getting the angular velocity of a body in order to
     * calculate the motion of the body in the physics engine.
     */ getAngularVelocityToRef(body, angVel, instanceIndex) {
        const pluginRef = this._getPluginReference(body, instanceIndex);
        const av = this._hknp.HP_Body_GetAngularVelocity(pluginRef.hpBodyId)[1];
        this._v3ToBvecRef(av, angVel);
    }
    /**
     * Sets the transformation of the given physics body to the given transform node.
     * @param body The physics body to set the transformation for.
     * @param node The transform node to set the transformation from.
     * Sets the transformation of the given physics body to the given transform node.
     *
     * This function is useful for setting the transformation of a physics body to a
     * transform node, which is necessary for the physics engine to accurately simulate
     * the motion of the body. It also takes into account instances of the transform
     * node, which is necessary for accurate simulation of multiple bodies with the
     * same transformation.
     */ setPhysicsBodyTransformation(body, node) {
        const transformNode = body.transformNode;
        if (body.numInstances > 0) {
            // instances
            const m = transformNode;
            const matrixData = m._thinInstanceDataStorage.matrixData;
            if (!matrixData) return; // TODO: error handling
            const instancesCount = body.numInstances;
            this._createOrUpdateBodyInstances(body, body.getMotionType(), matrixData, 0, instancesCount, true);
        } else // regular
        this._hknp.HP_Body_SetQTransform(body._pluginData.hpBodyId, this._getTransformInfos(node));
    }
    /**
     * Set the target transformation (position and rotation) of the body, such that the body will set its velocity to reach that target
     * @param body The physics body to set the target transformation for.
     * @param position The target position
     * @param rotation The target rotation
     * @param instanceIndex The index of the instance in an instanced body
     */ setTargetTransform(body, position, rotation, instanceIndex) {
        this._applyToBodyOrInstances(body, (pluginRef)=>{
            this._hknp.HP_Body_SetTargetQTransform(pluginRef.hpBodyId, [
                this._bVecToV3(position),
                this._bQuatToV4(rotation)
            ]);
        }, instanceIndex);
    }
    /**
     * Sets the gravity factor of a body
     * @param body the physics body to set the gravity factor for
     * @param factor the gravity factor
     * @param instanceIndex the index of the instance in an instanced body
     */ setGravityFactor(body, factor, instanceIndex) {
        this._applyToBodyOrInstances(body, (pluginRef)=>{
            this._hknp.HP_Body_SetGravityFactor(pluginRef.hpBodyId, factor);
        }, instanceIndex);
    }
    /**
     * Get the gravity factor of a body
     * @param body the physics body to get the gravity factor from
     * @param instanceIndex the index of the instance in an instanced body. If not specified, the gravity factor of the first instance will be returned.
     * @returns the gravity factor
     */ getGravityFactor(body, instanceIndex) {
        const pluginRef = this._getPluginReference(body, instanceIndex);
        return this._hknp.HP_Body_GetGravityFactor(pluginRef.hpBodyId)[1];
    }
    /**
     * Disposes a physics body.
     *
     * @param body - The physics body to dispose.
     *
     * This method is useful for releasing the resources associated with a physics body when it is no longer needed.
     * This is important for avoiding memory leaks in the physics engine.
     */ disposeBody(body) {
        if (body._pluginDataInstances && body._pluginDataInstances.length > 0) for (const instance of body._pluginDataInstances){
            this._hknp.HP_Body_Release(instance.hpBodyId);
            instance.hpBodyId = undefined;
        }
        if (body._pluginData) {
            this._hknp.HP_Body_Release(body._pluginData.hpBodyId);
            body._pluginData.hpBodyId = undefined;
        }
    }
    /**
     * Initializes a physics shape with the given type and parameters.
     * @param shape - The physics shape to initialize.
     * @param type - The type of shape to initialize.
     * @param options - The parameters for the shape.
     *
     * This code is useful for initializing a physics shape with the given type and parameters.
     * It allows for the creation of a sphere, box, capsule, container, cylinder, mesh, and heightfield.
     * Depending on the type of shape, different parameters are required.
     * For example, a sphere requires a radius, while a box requires extents and a rotation.
     */ initShape(shape, type, options) {
        switch(type){
            case (0, $fopmL.PhysicsShapeType).SPHERE:
                {
                    const radius = options.radius || 1;
                    const center = options.center ? this._bVecToV3(options.center) : [
                        0,
                        0,
                        0
                    ];
                    shape._pluginData = this._hknp.HP_Shape_CreateSphere(center, radius)[1];
                }
                break;
            case (0, $fopmL.PhysicsShapeType).BOX:
                {
                    const rotation = options.rotation ? this._bQuatToV4(options.rotation) : [
                        0,
                        0,
                        0,
                        1
                    ];
                    const extent = options.extents ? this._bVecToV3(options.extents) : [
                        1,
                        1,
                        1
                    ];
                    const center = options.center ? this._bVecToV3(options.center) : [
                        0,
                        0,
                        0
                    ];
                    shape._pluginData = this._hknp.HP_Shape_CreateBox(center, rotation, extent)[1];
                }
                break;
            case (0, $fopmL.PhysicsShapeType).CAPSULE:
                {
                    const pointA = options.pointA ? this._bVecToV3(options.pointA) : [
                        0,
                        0,
                        0
                    ];
                    const pointB = options.pointB ? this._bVecToV3(options.pointB) : [
                        0,
                        1,
                        0
                    ];
                    const radius = options.radius || 0;
                    shape._pluginData = this._hknp.HP_Shape_CreateCapsule(pointA, pointB, radius)[1];
                }
                break;
            case (0, $fopmL.PhysicsShapeType).CONTAINER:
                shape._pluginData = this._hknp.HP_Shape_CreateContainer()[1];
                break;
            case (0, $fopmL.PhysicsShapeType).CYLINDER:
                {
                    const pointA = options.pointA ? this._bVecToV3(options.pointA) : [
                        0,
                        0,
                        0
                    ];
                    const pointB = options.pointB ? this._bVecToV3(options.pointB) : [
                        0,
                        1,
                        0
                    ];
                    const radius = options.radius || 0;
                    shape._pluginData = this._hknp.HP_Shape_CreateCylinder(pointA, pointB, radius)[1];
                }
                break;
            case (0, $fopmL.PhysicsShapeType).CONVEX_HULL:
            case (0, $fopmL.PhysicsShapeType).MESH:
                {
                    const mesh = options.mesh;
                    if (mesh) {
                        const includeChildMeshes = !!options.includeChildMeshes;
                        const needIndices = type != (0, $fopmL.PhysicsShapeType).CONVEX_HULL;
                        const accum = new $ad0247a06a3c1725$var$MeshAccumulator(mesh, needIndices, mesh?.getScene());
                        accum.addNodeMeshes(mesh, includeChildMeshes);
                        const positions = accum.getVertices(this._hknp);
                        const numVec3s = positions.numObjects / 3;
                        if (type == (0, $fopmL.PhysicsShapeType).CONVEX_HULL) shape._pluginData = this._hknp.HP_Shape_CreateConvexHull(positions.offset, numVec3s)[1];
                        else {
                            const triangles = accum.getTriangles(this._hknp);
                            const numTriangles = triangles.numObjects / 3;
                            shape._pluginData = this._hknp.HP_Shape_CreateMesh(positions.offset, numVec3s, triangles.offset, numTriangles)[1];
                            accum.freeBuffer(this._hknp, triangles);
                        }
                        accum.freeBuffer(this._hknp, positions);
                    } else throw new Error("No mesh provided to create physics shape.");
                }
                break;
            case (0, $fopmL.PhysicsShapeType).HEIGHTFIELD:
                if (options.numHeightFieldSamplesX && options.numHeightFieldSamplesZ && options.heightFieldSizeX && options.heightFieldSizeZ && options.heightFieldData) {
                    const totalNumHeights = options.numHeightFieldSamplesX * options.numHeightFieldSamplesZ;
                    const numBytes = totalNumHeights * 4;
                    const bufferBegin = this._hknp._malloc(numBytes);
                    const heightBuffer = new Float32Array(this._hknp.HEAPU8.buffer, bufferBegin, totalNumHeights);
                    for(let x = 0; x < options.numHeightFieldSamplesX; x++)for(let z = 0; z < options.numHeightFieldSamplesZ; z++){
                        const hkBufferIndex = z * options.numHeightFieldSamplesX + x;
                        const bjsBufferIndex = (options.numHeightFieldSamplesX - 1 - x) * options.numHeightFieldSamplesZ + z;
                        heightBuffer[hkBufferIndex] = options.heightFieldData[bjsBufferIndex];
                    }
                    const scaleX = options.heightFieldSizeX / (options.numHeightFieldSamplesX - 1);
                    const scaleZ = options.heightFieldSizeZ / (options.numHeightFieldSamplesZ - 1);
                    shape._pluginData = this._hknp.HP_Shape_CreateHeightField(options.numHeightFieldSamplesX, options.numHeightFieldSamplesZ, [
                        scaleX,
                        1,
                        scaleZ
                    ], bufferBegin)[1];
                    this._hknp._free(bufferBegin);
                } else throw new Error("Missing required heightfield parameters");
                break;
            default:
                throw new Error("Unsupported Shape Type.");
        }
        this._shapes.set(shape._pluginData[0], shape);
    }
    /**
     * Sets the shape filter membership mask of a body
     * @param shape - The physics body to set the shape filter membership mask for.
     * @param membershipMask - The shape filter membership mask to set.
     */ setShapeFilterMembershipMask(shape, membershipMask) {
        const collideWith = this._hknp.HP_Shape_GetFilterInfo(shape._pluginData)[1][1];
        this._hknp.HP_Shape_SetFilterInfo(shape._pluginData, [
            membershipMask,
            collideWith
        ]);
    }
    /**
     * Gets the shape filter membership mask of a body
     * @param shape - The physics body to get the shape filter membership mask from.
     * @returns The shape filter membership mask of the given body.
     */ getShapeFilterMembershipMask(shape) {
        return this._hknp.HP_Shape_GetFilterInfo(shape._pluginData)[1][0];
    }
    /**
     * Sets the shape filter collide mask of a body
     * @param shape - The physics body to set the shape filter collide mask for.
     * @param collideMask - The shape filter collide mask to set.
     */ setShapeFilterCollideMask(shape, collideMask) {
        const membership = this._hknp.HP_Shape_GetFilterInfo(shape._pluginData)[1][0];
        this._hknp.HP_Shape_SetFilterInfo(shape._pluginData, [
            membership,
            collideMask
        ]);
    }
    /**
     * Gets the shape filter collide mask of a body
     * @param shape - The physics body to get the shape filter collide mask from.
     * @returns The shape filter collide mask of the given body.
     */ getShapeFilterCollideMask(shape) {
        return this._hknp.HP_Shape_GetFilterInfo(shape._pluginData)[1][1];
    }
    /**
     * Sets the material of a physics shape.
     * @param shape - The physics shape to set the material of.
     * @param material - The material to set.
     *
     */ setMaterial(shape, material) {
        const dynamicFriction = material.friction ?? 0.5;
        const staticFriction = material.staticFriction ?? dynamicFriction;
        const restitution = material.restitution ?? 0.0;
        const frictionCombine = material.frictionCombine ?? (0, $3Z9d3.PhysicsMaterialCombineMode).MINIMUM;
        const restitutionCombine = material.restitutionCombine ?? (0, $3Z9d3.PhysicsMaterialCombineMode).MAXIMUM;
        const hpMaterial = [
            staticFriction,
            dynamicFriction,
            restitution,
            this._materialCombineToNative(frictionCombine),
            this._materialCombineToNative(restitutionCombine)
        ];
        this._hknp.HP_Shape_SetMaterial(shape._pluginData, hpMaterial);
    }
    /**
     * Gets the material associated with a physics shape.
     * @param shape - The shape to get the material from.
     * @returns The material associated with the shape.
     */ getMaterial(shape) {
        const hkMaterial = this._hknp.HP_Shape_GetMaterial(shape._pluginData)[1];
        return {
            staticFriction: hkMaterial[0],
            friction: hkMaterial[1],
            restitution: hkMaterial[2],
            frictionCombine: this._nativeToMaterialCombine(hkMaterial[3]),
            restitutionCombine: this._nativeToMaterialCombine(hkMaterial[4])
        };
    }
    /**
     * Sets the density of a physics shape.
     * @param shape - The physics shape to set the density of.
     * @param density - The density to set.
     *
     */ setDensity(shape, density) {
        this._hknp.HP_Shape_SetDensity(shape._pluginData, density);
    }
    /**
     * Calculates the density of a given physics shape.
     *
     * @param shape - The physics shape to calculate the density of.
     * @returns The density of the given physics shape.
     *
     */ getDensity(shape) {
        return this._hknp.HP_Shape_GetDensity(shape._pluginData)[1];
    }
    /**
     * Gets the transform infos of a given transform node.
     * This code is useful for getting the position and orientation of a given transform node.
     * It first checks if the node has a rotation quaternion, and if not, it creates one from the node's rotation.
     * It then creates an array containing the position and orientation of the node and returns it.
     * @param node - The transform node.
     * @returns An array containing the position and orientation of the node.
     */ _getTransformInfos(node) {
        if (node.parent) {
            node.computeWorldMatrix(true);
            return [
                this._bVecToV3(node.absolutePosition),
                this._bQuatToV4(node.absoluteRotationQuaternion)
            ];
        }
        let orientation = (0, $ha1VO.TmpVectors).Quaternion[0];
        if (node.rotationQuaternion) orientation = node.rotationQuaternion;
        else {
            const r = node.rotation;
            (0, $ha1VO.Quaternion).FromEulerAnglesToRef(r.x, r.y, r.z, orientation);
        }
        const transform = [
            this._bVecToV3(node.position),
            this._bQuatToV4(orientation)
        ];
        return transform;
    }
    /**
     * Adds a child shape to the given shape.
     * @param shape - The parent shape.
     * @param newChild - The child shape to add.
     * @param translation - The relative translation of the child from the parent shape
     * @param rotation - The relative rotation of the child from the parent shape
     * @param scale - The relative scale scale of the child from the parent shaep
     *
     */ addChild(shape, newChild, translation, rotation, scale) {
        const transformNative = [
            translation ? this._bVecToV3(translation) : [
                0,
                0,
                0
            ],
            rotation ? this._bQuatToV4(rotation) : [
                0,
                0,
                0,
                1
            ],
            scale ? this._bVecToV3(scale) : [
                1,
                1,
                1
            ]
        ];
        this._hknp.HP_Shape_AddChild(shape._pluginData, newChild._pluginData, transformNative);
    }
    /**
     * Removes a child shape from a parent shape.
     * @param shape - The parent shape.
     * @param childIndex - The index of the child shape to remove.
     *
     */ removeChild(shape, childIndex) {
        this._hknp.HP_Shape_RemoveChild(shape._pluginData, childIndex);
    }
    /**
     * Returns the number of children of the given shape.
     *
     * @param shape - The shape to get the number of children from.
     * @returns The number of children of the given shape.
     *
     */ getNumChildren(shape) {
        return this._hknp.HP_Shape_GetNumChildren(shape._pluginData)[1];
    }
    /**
     * Marks the shape as a trigger
     * @param shape the shape to mark as a trigger
     * @param isTrigger if the shape is a trigger
     */ setTrigger(shape, isTrigger) {
        this._hknp.HP_Shape_SetTrigger(shape._pluginData, isTrigger);
    }
    /**
     * Calculates the bounding box of a given physics shape.
     *
     * @param _shape - The physics shape to calculate the bounding box for.
     * @returns The calculated bounding box.
     *
     * This method is useful for physics engines as it allows to calculate the
     * boundaries of a given shape. Knowing the boundaries of a shape is important
     * for collision detection and other physics calculations.
     */ getBoundingBox(_shape) {
        return {};
    }
    /**
     * Gets the geometry of a physics body.
     *
     * @param body - The physics body.
     * @returns An object containing the positions and indices of the body's geometry.
     *
     */ getBodyGeometry(body) {
        const dataInfo = body._pluginDataInstances?.length > 0 ? body._pluginDataInstances[0] : body._pluginData;
        const shape = this._hknp.HP_Body_GetShape(dataInfo.hpBodyId)[1];
        const geometryRes = this._hknp.HP_Shape_CreateDebugDisplayGeometry(shape);
        if (geometryRes[0] != this._hknp.Result.RESULT_OK) return {
            positions: [],
            indices: []
        };
        const geometryInfo = this._hknp.HP_DebugGeometry_GetInfo(geometryRes[1])[1];
        const positionsInPlugin = new Float32Array(this._hknp.HEAPU8.buffer, geometryInfo[0], geometryInfo[1] * 3); // 3 floats per position
        const indicesInPlugin = new Uint32Array(this._hknp.HEAPU8.buffer, geometryInfo[2], geometryInfo[3] * 3); // 3 indices per triangle
        // HP_DebugGeometry_Release will free the buffer in the plugin. To avoid a
        // use-after-free, we need  to make a copy of the data here.
        const positions = positionsInPlugin.slice(0);
        const indices = indicesInPlugin.slice(0);
        this._hknp.HP_DebugGeometry_Release(geometryRes[1]);
        return {
            positions: positions,
            indices: indices
        };
    }
    /**
     * Releases a physics shape from the physics engine.
     *
     * @param shape - The physics shape to be released.
     *
     * This method is useful for releasing a physics shape from the physics engine, freeing up resources and preventing memory leaks.
     */ disposeShape(shape) {
        this._hknp.HP_Shape_Release(shape._pluginData);
        shape._pluginData = undefined;
    }
    // constraint
    /**
     * Initializes a physics constraint with the given parameters.
     *
     * @param constraint - The physics constraint to be initialized.
     * @param body - The main body
     * @param childBody - The child body.
     * @param instanceIndex - If this body is instanced, the index of the instance to which the constraint will be applied. If not specified, no constraint will be applied.
     * @param childInstanceIndex - If the child body is instanced, the index of the instance to which the constraint will be applied. If not specified, no constraint will be applied.
     *
     * This function is useful for setting up a physics constraint in a physics engine.
     */ initConstraint(constraint, body, childBody, instanceIndex, childInstanceIndex) {
        const type = constraint.type;
        const options = constraint.options;
        if (!type || !options) {
            (0, $kVtWi.Logger).Warn("No constraint type or options. Constraint is invalid.");
            return;
        }
        if (body._pluginDataInstances.length > 0 && instanceIndex === undefined || childBody._pluginDataInstances.length > 0 && childInstanceIndex === undefined) {
            (0, $kVtWi.Logger).Warn("Body is instanced but no instance index was specified. Constraint will not be applied.");
            return;
        }
        constraint._pluginData = constraint._pluginData ?? [];
        const jointId = this._hknp.HP_Constraint_Create()[1];
        constraint._pluginData.push(jointId);
        // body parenting
        const bodyA = this._getPluginReference(body, instanceIndex).hpBodyId;
        const bodyB = this._getPluginReference(childBody, childInstanceIndex).hpBodyId;
        this._hknp.HP_Constraint_SetParentBody(jointId, bodyA);
        this._hknp.HP_Constraint_SetChildBody(jointId, bodyB);
        this._constraintToBodyIdPair.set(jointId[0], [
            bodyA[0],
            bodyB[0]
        ]);
        // anchors
        const pivotA = options.pivotA ? this._bVecToV3(options.pivotA) : this._bVecToV3((0, $ha1VO.Vector3).Zero());
        const axisA = options.axisA ?? new (0, $ha1VO.Vector3)(1, 0, 0);
        const perpAxisA = this._tmpVec3[0];
        if (options.perpAxisA) perpAxisA.copyFrom(options.perpAxisA);
        else axisA.getNormalToRef(perpAxisA);
        this._hknp.HP_Constraint_SetAnchorInParent(jointId, pivotA, this._bVecToV3(axisA), this._bVecToV3(perpAxisA));
        const pivotB = options.pivotB ? this._bVecToV3(options.pivotB) : this._bVecToV3((0, $ha1VO.Vector3).Zero());
        const axisB = options.axisB ?? new (0, $ha1VO.Vector3)(1, 0, 0);
        const perpAxisB = this._tmpVec3[0];
        if (options.perpAxisB) perpAxisB.copyFrom(options.perpAxisB);
        else axisB.getNormalToRef(perpAxisB);
        this._hknp.HP_Constraint_SetAnchorInChild(jointId, pivotB, this._bVecToV3(axisB), this._bVecToV3(perpAxisB));
        // Save the options that were used for initializing the constraint for debugging purposes
        // Check first to avoid copying the same options multiple times
        if (!constraint._initOptions) constraint._initOptions = {
            axisA: axisA.clone(),
            axisB: axisB.clone(),
            perpAxisA: perpAxisA.clone(),
            perpAxisB: perpAxisB.clone(),
            pivotA: new (0, $ha1VO.Vector3)(pivotA[0], pivotA[1], pivotA[2]),
            pivotB: new (0, $ha1VO.Vector3)(pivotB[0], pivotB[1], pivotB[2])
        };
        if (type == (0, $fopmL.PhysicsConstraintType).LOCK) {
            this._hknp.HP_Constraint_SetAxisMode(jointId, this._hknp.ConstraintAxis.LINEAR_X, this._hknp.ConstraintAxisLimitMode.LOCKED);
            this._hknp.HP_Constraint_SetAxisMode(jointId, this._hknp.ConstraintAxis.LINEAR_Y, this._hknp.ConstraintAxisLimitMode.LOCKED);
            this._hknp.HP_Constraint_SetAxisMode(jointId, this._hknp.ConstraintAxis.LINEAR_Z, this._hknp.ConstraintAxisLimitMode.LOCKED);
            this._hknp.HP_Constraint_SetAxisMode(jointId, this._hknp.ConstraintAxis.ANGULAR_X, this._hknp.ConstraintAxisLimitMode.LOCKED);
            this._hknp.HP_Constraint_SetAxisMode(jointId, this._hknp.ConstraintAxis.ANGULAR_Y, this._hknp.ConstraintAxisLimitMode.LOCKED);
            this._hknp.HP_Constraint_SetAxisMode(jointId, this._hknp.ConstraintAxis.ANGULAR_Z, this._hknp.ConstraintAxisLimitMode.LOCKED);
        } else if (type == (0, $fopmL.PhysicsConstraintType).DISTANCE) {
            const distance = options.maxDistance || 0;
            const dist3d = this._hknp.ConstraintAxis.LINEAR_DISTANCE;
            this._hknp.HP_Constraint_SetAxisMode(jointId, dist3d, this._hknp.ConstraintAxisLimitMode.LIMITED);
            this._hknp.HP_Constraint_SetAxisMinLimit(jointId, dist3d, distance);
            this._hknp.HP_Constraint_SetAxisMaxLimit(jointId, dist3d, distance);
        } else if (type == (0, $fopmL.PhysicsConstraintType).HINGE) {
            this._hknp.HP_Constraint_SetAxisMode(jointId, this._hknp.ConstraintAxis.LINEAR_X, this._hknp.ConstraintAxisLimitMode.LOCKED);
            this._hknp.HP_Constraint_SetAxisMode(jointId, this._hknp.ConstraintAxis.LINEAR_Y, this._hknp.ConstraintAxisLimitMode.LOCKED);
            this._hknp.HP_Constraint_SetAxisMode(jointId, this._hknp.ConstraintAxis.LINEAR_Z, this._hknp.ConstraintAxisLimitMode.LOCKED);
            this._hknp.HP_Constraint_SetAxisMode(jointId, this._hknp.ConstraintAxis.ANGULAR_Y, this._hknp.ConstraintAxisLimitMode.LOCKED);
            this._hknp.HP_Constraint_SetAxisMode(jointId, this._hknp.ConstraintAxis.ANGULAR_Z, this._hknp.ConstraintAxisLimitMode.LOCKED);
        } else if (type == (0, $fopmL.PhysicsConstraintType).PRISMATIC) {
            this._hknp.HP_Constraint_SetAxisMode(jointId, this._hknp.ConstraintAxis.LINEAR_Y, this._hknp.ConstraintAxisLimitMode.LOCKED);
            this._hknp.HP_Constraint_SetAxisMode(jointId, this._hknp.ConstraintAxis.LINEAR_Z, this._hknp.ConstraintAxisLimitMode.LOCKED);
            this._hknp.HP_Constraint_SetAxisMode(jointId, this._hknp.ConstraintAxis.ANGULAR_X, this._hknp.ConstraintAxisLimitMode.LOCKED);
            this._hknp.HP_Constraint_SetAxisMode(jointId, this._hknp.ConstraintAxis.ANGULAR_Y, this._hknp.ConstraintAxisLimitMode.LOCKED);
            this._hknp.HP_Constraint_SetAxisMode(jointId, this._hknp.ConstraintAxis.ANGULAR_Z, this._hknp.ConstraintAxisLimitMode.LOCKED);
        } else if (type == (0, $fopmL.PhysicsConstraintType).SLIDER) {
            this._hknp.HP_Constraint_SetAxisMode(jointId, this._hknp.ConstraintAxis.LINEAR_Y, this._hknp.ConstraintAxisLimitMode.LOCKED);
            this._hknp.HP_Constraint_SetAxisMode(jointId, this._hknp.ConstraintAxis.LINEAR_Z, this._hknp.ConstraintAxisLimitMode.LOCKED);
            this._hknp.HP_Constraint_SetAxisMode(jointId, this._hknp.ConstraintAxis.ANGULAR_Y, this._hknp.ConstraintAxisLimitMode.LOCKED);
            this._hknp.HP_Constraint_SetAxisMode(jointId, this._hknp.ConstraintAxis.ANGULAR_Z, this._hknp.ConstraintAxisLimitMode.LOCKED);
        } else if (type == (0, $fopmL.PhysicsConstraintType).BALL_AND_SOCKET) {
            this._hknp.HP_Constraint_SetAxisMode(jointId, this._hknp.ConstraintAxis.LINEAR_X, this._hknp.ConstraintAxisLimitMode.LOCKED);
            this._hknp.HP_Constraint_SetAxisMode(jointId, this._hknp.ConstraintAxis.LINEAR_Y, this._hknp.ConstraintAxisLimitMode.LOCKED);
            this._hknp.HP_Constraint_SetAxisMode(jointId, this._hknp.ConstraintAxis.LINEAR_Z, this._hknp.ConstraintAxisLimitMode.LOCKED);
        } else if (type == (0, $fopmL.PhysicsConstraintType).SIX_DOF) {
            const sixdofData = constraint;
            for (const l of sixdofData.limits){
                const axId = this._constraintAxisToNative(l.axis);
                if ((l.minLimit ?? -1) == 0 && (l.maxLimit ?? -1) == 0) this._hknp.HP_Constraint_SetAxisMode(jointId, axId, this._hknp.ConstraintAxisLimitMode.LOCKED);
                else {
                    if (l.minLimit != undefined) {
                        this._hknp.HP_Constraint_SetAxisMode(jointId, axId, this._hknp.ConstraintAxisLimitMode.LIMITED);
                        this._hknp.HP_Constraint_SetAxisMinLimit(jointId, axId, l.minLimit);
                    }
                    if (l.maxLimit != undefined) {
                        this._hknp.HP_Constraint_SetAxisMode(jointId, axId, this._hknp.ConstraintAxisLimitMode.LIMITED);
                        this._hknp.HP_Constraint_SetAxisMaxLimit(jointId, axId, l.maxLimit);
                    }
                }
                if (l.stiffness) this._hknp.HP_Constraint_SetAxisStiffness(jointId, axId, l.stiffness);
                if (l.damping) this._hknp.HP_Constraint_SetAxisDamping(jointId, axId, l.damping);
            }
        } else throw new Error("Unsupported Constraint Type.");
        const collisionEnabled = !!options.collision;
        this._hknp.HP_Constraint_SetCollisionsEnabled(jointId, collisionEnabled);
        this._hknp.HP_Constraint_SetEnabled(jointId, true);
    }
    /**
     * Get a list of all the pairs of bodies that are connected by this constraint.
     * @param constraint the constraint to search from
     * @returns a list of parent, child pairs
     */ getBodiesUsingConstraint(constraint) {
        const pairs = [];
        for (const jointId of constraint._pluginData){
            const bodyIds = this._constraintToBodyIdPair.get(jointId[0]);
            if (bodyIds) {
                const parentBodyInfo = this._bodies.get(bodyIds[0]);
                const childBodyInfo = this._bodies.get(bodyIds[1]);
                if (parentBodyInfo && childBodyInfo) pairs.push({
                    parentBody: parentBodyInfo.body,
                    parentBodyIndex: parentBodyInfo.index,
                    childBody: childBodyInfo.body,
                    childBodyIndex: childBodyInfo.index
                });
            }
        }
        return pairs;
    }
    /**
     * Adds a constraint to the physics engine.
     *
     * @param body - The main body to which the constraint is applied.
     * @param childBody - The body to which the constraint is applied.
     * @param constraint - The constraint to be applied.
     * @param instanceIndex - If this body is instanced, the index of the instance to which the constraint will be applied. If not specified, no constraint will be applied.
     * @param childInstanceIndex - If the child body is instanced, the index of the instance to which the constraint will be applied. If not specified, no constraint will be applied.
     */ addConstraint(body, childBody, constraint, instanceIndex, childInstanceIndex) {
        //<todo It's real weird that initConstraint() is called only after adding to a body!
        this.initConstraint(constraint, body, childBody, instanceIndex, childInstanceIndex);
    }
    /**
     * Enables or disables a constraint in the physics engine.
     * @param constraint - The constraint to enable or disable.
     * @param isEnabled - Whether the constraint should be enabled or disabled.
     *
     */ setEnabled(constraint, isEnabled) {
        for (const jointId of constraint._pluginData)this._hknp.HP_Constraint_SetEnabled(jointId, isEnabled);
    }
    /**
     * Gets the enabled state of the given constraint.
     * @param constraint - The constraint to get the enabled state from.
     * @returns The enabled state of the given constraint.
     *
     */ getEnabled(constraint) {
        const firstId = constraint._pluginData && constraint._pluginData[0];
        if (firstId) return this._hknp.HP_Constraint_GetEnabled(firstId)[1];
        return false;
    }
    /**
     * Enables or disables collisions for the given constraint.
     * @param constraint - The constraint to enable or disable collisions for.
     * @param isEnabled - Whether collisions should be enabled or disabled.
     *
     */ setCollisionsEnabled(constraint, isEnabled) {
        for (const jointId of constraint._pluginData)this._hknp.HP_Constraint_SetCollisionsEnabled(jointId, isEnabled);
    }
    /**
     * Gets whether collisions are enabled for the given constraint.
     * @param constraint - The constraint to get collisions enabled for.
     * @returns Whether collisions are enabled for the given constraint.
     *
     */ getCollisionsEnabled(constraint) {
        const firstId = constraint._pluginData && constraint._pluginData[0];
        if (firstId) return this._hknp.HP_Constraint_GetCollisionsEnabled(firstId)[1];
        return false;
    }
    /**
     * Sets the friction of the given axis of the given constraint.
     *
     * @param constraint - The constraint to set the friction of.
     * @param axis - The axis of the constraint to set the friction of.
     * @param friction - The friction to set.
     *
     */ setAxisFriction(constraint, axis, friction) {
        for (const jointId of constraint._pluginData)this._hknp.HP_Constraint_SetAxisFriction(jointId, this._constraintAxisToNative(axis), friction);
    }
    /**
     * Gets the friction value of the specified axis of the given constraint.
     *
     * @param constraint - The constraint to get the axis friction from.
     * @param axis - The axis to get the friction from.
     * @returns The friction value of the specified axis.
     *
     */ getAxisFriction(constraint, axis) {
        const firstId = constraint._pluginData && constraint._pluginData[0];
        if (firstId) return this._hknp.HP_Constraint_GetAxisFriction(firstId, this._constraintAxisToNative(axis))[1];
        return null;
    }
    /**
     * Sets the limit mode of the specified axis of the given constraint.
     * @param constraint - The constraint to set the axis mode of.
     * @param axis - The axis to set the limit mode of.
     * @param limitMode - The limit mode to set.
     */ setAxisMode(constraint, axis, limitMode) {
        for (const jointId of constraint._pluginData)this._hknp.HP_Constraint_SetAxisMode(jointId, this._constraintAxisToNative(axis), this._limitModeToNative(limitMode));
    }
    /**
     * Gets the axis limit mode of the given constraint.
     *
     * @param constraint - The constraint to get the axis limit mode from.
     * @param axis - The axis to get the limit mode from.
     * @returns The axis limit mode of the given constraint.
     *
     */ getAxisMode(constraint, axis) {
        const firstId = constraint._pluginData && constraint._pluginData[0];
        if (firstId) {
            const mode = this._hknp.HP_Constraint_GetAxisMode(firstId, this._constraintAxisToNative(axis))[1];
            return this._nativeToLimitMode(mode);
        }
        return null;
    }
    /**
     * Sets the minimum limit of the given axis of the given constraint.
     * @param constraint - The constraint to set the minimum limit of.
     * @param axis - The axis to set the minimum limit of.
     * @param limit - The minimum limit to set.
     *
     */ setAxisMinLimit(constraint, axis, limit) {
        for (const jointId of constraint._pluginData)this._hknp.HP_Constraint_SetAxisMinLimit(jointId, this._constraintAxisToNative(axis), limit);
    }
    /**
     * Gets the minimum limit of the specified axis of the given constraint.
     * @param constraint - The constraint to get the minimum limit from.
     * @param axis - The axis to get the minimum limit from.
     * @returns The minimum limit of the specified axis of the given constraint.
     *
     */ getAxisMinLimit(constraint, axis) {
        const firstId = constraint._pluginData && constraint._pluginData[0];
        if (firstId) return this._hknp.HP_Constraint_GetAxisMinLimit(firstId, this._constraintAxisToNative(axis))[1];
        return null;
    }
    /**
     * Sets the maximum limit of the given axis of the given constraint.
     * @param constraint - The constraint to set the maximum limit of the given axis.
     * @param axis - The axis to set the maximum limit of.
     * @param limit - The maximum limit to set.
     *
     */ setAxisMaxLimit(constraint, axis, limit) {
        for (const jointId of constraint._pluginData)this._hknp.HP_Constraint_SetAxisMaxLimit(jointId, this._constraintAxisToNative(axis), limit);
    }
    /**
     * Gets the maximum limit of the given axis of the given constraint.
     *
     * @param constraint - The constraint to get the maximum limit from.
     * @param axis - The axis to get the maximum limit from.
     * @returns The maximum limit of the given axis of the given constraint.
     *
     */ getAxisMaxLimit(constraint, axis) {
        const firstId = constraint._pluginData && constraint._pluginData[0];
        if (firstId) return this._hknp.HP_Constraint_GetAxisMaxLimit(firstId, this._constraintAxisToNative(axis))[1];
        return null;
    }
    /**
     * Sets the motor type of the given axis of the given constraint.
     * @param constraint - The constraint to set the motor type of.
     * @param axis - The axis of the constraint to set the motor type of.
     * @param motorType - The motor type to set.
     *
     */ setAxisMotorType(constraint, axis, motorType) {
        for (const jointId of constraint._pluginData)this._hknp.HP_Constraint_SetAxisMotorType(jointId, this._constraintAxisToNative(axis), this._constraintMotorTypeToNative(motorType));
    }
    /**
     * Gets the motor type of the specified axis of the given constraint.
     * @param constraint - The constraint to get the motor type from.
     * @param axis - The axis of the constraint to get the motor type from.
     * @returns The motor type of the specified axis of the given constraint.
     *
     */ getAxisMotorType(constraint, axis) {
        const firstId = constraint._pluginData && constraint._pluginData[0];
        if (firstId) return this._nativeToMotorType(this._hknp.HP_Constraint_GetAxisMotorType(firstId, this._constraintAxisToNative(axis))[1]);
        return null;
    }
    /**
     * Sets the target of an axis motor of a constraint.
     *
     * @param constraint - The constraint to set the axis motor target of.
     * @param axis - The axis of the constraint to set the motor target of.
     * @param target - The target of the axis motor.
     *
     */ setAxisMotorTarget(constraint, axis, target) {
        for (const jointId of constraint._pluginData)this._hknp.HP_Constraint_SetAxisMotorTarget(jointId, this._constraintAxisToNative(axis), target);
    }
    /**
     * Gets the target of the motor of the given axis of the given constraint.
     *
     * @param constraint - The constraint to get the motor target from.
     * @param axis - The axis of the constraint to get the motor target from.
     * @returns The target of the motor of the given axis of the given constraint.
     *
     */ getAxisMotorTarget(constraint, axis) {
        const firstId = constraint._pluginData && constraint._pluginData[0];
        if (firstId) return this._hknp.HP_Constraint_GetAxisMotorTarget(constraint._pluginData, this._constraintAxisToNative(axis))[1];
        return null;
    }
    /**
     * Sets the maximum force that can be applied by the motor of the given constraint axis.
     * @param constraint - The constraint to set the motor max force for.
     * @param axis - The axis of the constraint to set the motor max force for.
     * @param maxForce - The maximum force that can be applied by the motor.
     *
     */ setAxisMotorMaxForce(constraint, axis, maxForce) {
        for (const jointId of constraint._pluginData)this._hknp.HP_Constraint_SetAxisMotorMaxForce(jointId, this._constraintAxisToNative(axis), maxForce);
    }
    /**
     * Gets the maximum force of the motor of the given constraint axis.
     *
     * @param constraint - The constraint to get the motor maximum force from.
     * @param axis - The axis of the constraint to get the motor maximum force from.
     * @returns The maximum force of the motor of the given constraint axis.
     *
     */ getAxisMotorMaxForce(constraint, axis) {
        const firstId = constraint._pluginData && constraint._pluginData[0];
        if (firstId) return this._hknp.HP_Constraint_GetAxisMotorMaxForce(firstId, this._constraintAxisToNative(axis))[1];
        return null;
    }
    /**
     * Disposes a physics constraint.
     *
     * @param constraint - The physics constraint to dispose.
     *
     * This method is useful for releasing the resources associated with a physics constraint, such as
     * the Havok constraint, when it is no longer needed. This is important for avoiding memory leaks.
     */ disposeConstraint(constraint) {
        for (const jointId of constraint._pluginData){
            this._hknp.HP_Constraint_SetEnabled(jointId, false);
            this._hknp.HP_Constraint_Release(jointId);
        }
        constraint._pluginData.length = 0;
    }
    _populateHitData(hitData, result) {
        const hitBody = this._bodies.get(hitData[0][0]);
        result.body = hitBody?.body;
        result.bodyIndex = hitBody?.index;
        const hitShape = this._shapes.get(hitData[1][0]);
        result.shape = hitShape;
        const hitPos = hitData[3];
        const hitNormal = hitData[4];
        const hitTriangle = hitData[5];
        result.setHitData({
            x: hitNormal[0],
            y: hitNormal[1],
            z: hitNormal[2]
        }, {
            x: hitPos[0],
            y: hitPos[1],
            z: hitPos[2]
        }, hitTriangle);
    }
    /**
     * Performs a raycast from a given start point to a given end point and stores the result in a given PhysicsRaycastResult object.
     *
     * @param from - The start point of the raycast.
     * @param to - The end point of the raycast.
     * @param result - The PhysicsRaycastResult object to store the result of the raycast.
     * @param query - The raycast query options. See [[IRaycastQuery]] for more information.
     *
     * Performs a raycast. It takes in two points, from and to, and a PhysicsRaycastResult object to store the result of the raycast.
     * It then performs the raycast and stores the hit data in the PhysicsRaycastResult object.
     */ raycast(from, to, result, query) {
        const queryMembership = query?.membership ?? -1;
        const queryCollideWith = query?.collideWith ?? -1;
        result.reset(from, to);
        const shouldHitTriggers = false;
        const bodyToIgnore = [
            BigInt(0)
        ];
        const hkQuery = [
            this._bVecToV3(from),
            this._bVecToV3(to),
            [
                queryMembership,
                queryCollideWith
            ],
            shouldHitTriggers,
            bodyToIgnore
        ];
        this._hknp.HP_World_CastRayWithCollector(this.world, this._queryCollector, hkQuery);
        if (this._hknp.HP_QueryCollector_GetNumHits(this._queryCollector)[1] > 0) {
            const [, hitData] = this._hknp.HP_QueryCollector_GetCastRayResult(this._queryCollector, 0)[1];
            this._populateHitData(hitData, result);
            result.calculateHitDistance();
        }
    }
    /**
     * Given a point, returns the closest physics
     * body to that point.
     * @param query the query to perform. @see IPhysicsPointProximityQuery
     * @param result contact point on the hit shape, in world space
     */ pointProximity(query, result) {
        const queryMembership = query?.collisionFilter?.membership ?? -1;
        const queryCollideWith = query?.collisionFilter?.collideWith ?? -1;
        result.reset();
        const bodyToIgnore = query.ignoreBody ? [
            BigInt(query.ignoreBody._pluginData.hpBodyId[0])
        ] : [
            BigInt(0)
        ];
        const hkQuery = [
            this._bVecToV3(query.position),
            query.maxDistance,
            [
                queryMembership,
                queryCollideWith
            ],
            query.shouldHitTriggers,
            bodyToIgnore
        ];
        this._hknp.HP_World_PointProximityWithCollector(this.world, this._queryCollector, hkQuery);
        if (this._hknp.HP_QueryCollector_GetNumHits(this._queryCollector)[1] > 0) {
            const [distance, hitData] = this._hknp.HP_QueryCollector_GetPointProximityResult(this._queryCollector, 0)[1];
            this._populateHitData(hitData, result);
            result.setHitDistance(distance);
        }
    }
    /**
     * Given a shape in a specific position and orientation, returns the closest point to that shape.
     * @param query the query to perform. @see IPhysicsShapeProximityCastQuery
     * @param inputShapeResult contact point on input shape, in input shape space
     * @param hitShapeResult contact point on hit shape, in world space
     */ shapeProximity(query, inputShapeResult, hitShapeResult) {
        inputShapeResult.reset();
        hitShapeResult.reset();
        const shapeId = query.shape._pluginData;
        const bodyToIgnore = query.ignoreBody ? [
            BigInt(query.ignoreBody._pluginData.hpBodyId[0])
        ] : [
            BigInt(0)
        ];
        const hkQuery = [
            shapeId,
            this._bVecToV3(query.position),
            this._bQuatToV4(query.rotation),
            query.maxDistance,
            query.shouldHitTriggers,
            bodyToIgnore
        ];
        this._hknp.HP_World_ShapeProximityWithCollector(this.world, this._queryCollector, hkQuery);
        if (this._hknp.HP_QueryCollector_GetNumHits(this._queryCollector)[1] > 0) {
            const [distance, hitInputData, hitShapeData] = this._hknp.HP_QueryCollector_GetShapeProximityResult(this._queryCollector, 0)[1];
            this._populateHitData(hitInputData, inputShapeResult);
            this._populateHitData(hitShapeData, hitShapeResult);
            inputShapeResult.setHitDistance(distance);
            hitShapeResult.setHitDistance(distance);
        }
    }
    /**
     * Given a shape in a specific orientation, cast it from the start to end position specified by the query, and return the first hit.
     * @param query the query to perform. @see IPhysicsShapeCastQuery
     * @param inputShapeResult contact point on input shape, in input shape space
     * @param hitShapeResult contact point on hit shape, in world space
     */ shapeCast(query, inputShapeResult, hitShapeResult) {
        inputShapeResult.reset();
        hitShapeResult.reset();
        const shapeId = query.shape._pluginData;
        const bodyToIgnore = query.ignoreBody ? [
            BigInt(query.ignoreBody._pluginData.hpBodyId[0])
        ] : [
            BigInt(0)
        ];
        const hkQuery = [
            shapeId,
            this._bQuatToV4(query.rotation),
            this._bVecToV3(query.startPosition),
            this._bVecToV3(query.endPosition),
            query.shouldHitTriggers,
            bodyToIgnore
        ];
        this._hknp.HP_World_ShapeCastWithCollector(this.world, this._queryCollector, hkQuery);
        if (this._hknp.HP_QueryCollector_GetNumHits(this._queryCollector)[1] > 0) {
            const [fractionAlongRay, hitInputData, hitShapeData] = this._hknp.HP_QueryCollector_GetShapeCastResult(this._queryCollector, 0)[1];
            this._populateHitData(hitInputData, inputShapeResult);
            this._populateHitData(hitShapeData, hitShapeResult);
            inputShapeResult.setHitFraction(fractionAlongRay);
            hitShapeResult.setHitFraction(fractionAlongRay);
        }
    }
    /**
     * Return the collision observable for a particular physics body.
     * @param body the physics body
     * @returns the collision observable for the body
     */ getCollisionObservable(body) {
        const bodyId = body._pluginData.hpBodyId[0];
        let observable = this._bodyCollisionObservable.get(bodyId);
        if (!observable) {
            observable = new (0, $diGQf.Observable)();
            this._bodyCollisionObservable.set(bodyId, observable);
        }
        return observable;
    }
    /**
     * Return the collision ended observable for a particular physics body.
     * @param body the physics body
     * @returns
     */ getCollisionEndedObservable(body) {
        const bodyId = body._pluginData.hpBodyId[0];
        let observable = this._bodyCollisionEndedObservable.get(bodyId);
        if (!observable) {
            observable = new (0, $diGQf.Observable)();
            this._bodyCollisionEndedObservable.set(bodyId, observable);
        }
        return observable;
    }
    /**
     * Enable collision to be reported for a body when a callback is setup on the world
     * @param body the physics body
     * @param enabled whether to enable or disable collision events
     */ setCollisionCallbackEnabled(body, enabled) {
        // Register for collide events by default
        const collideEvents = this._hknp.EventType.COLLISION_STARTED.value | this._hknp.EventType.COLLISION_CONTINUED.value | this._hknp.EventType.COLLISION_FINISHED.value;
        if (body._pluginDataInstances && body._pluginDataInstances.length) body._pluginDataInstances.forEach((bodyId)=>{
            this._hknp.HP_Body_SetEventMask(bodyId.hpBodyId, enabled ? collideEvents : 0);
        });
        else if (body._pluginData) this._hknp.HP_Body_SetEventMask(body._pluginData.hpBodyId, enabled ? collideEvents : 0);
    }
    /**
     * Enable collision ended to be reported for a body when a callback is setup on the world
     * @param body the physics body
     * @param enabled whether to enable or disable collision ended events
     */ setCollisionEndedCallbackEnabled(body, enabled) {
        // Register to collide ended events
        const pluginRef = this._getPluginReference(body);
        let currentCollideEvents = this._hknp.HP_Body_GetEventMask(pluginRef.hpBodyId)[1];
        // update with the ended mask
        currentCollideEvents = enabled ? currentCollideEvents | this._hknp.EventType.COLLISION_FINISHED.value : currentCollideEvents & ~this._hknp.EventType.COLLISION_FINISHED.value;
        if (body._pluginDataInstances && body._pluginDataInstances.length) body._pluginDataInstances.forEach((bodyId)=>{
            this._hknp.HP_Body_SetEventMask(bodyId.hpBodyId, currentCollideEvents);
        });
        else if (body._pluginData) this._hknp.HP_Body_SetEventMask(body._pluginData.hpBodyId, currentCollideEvents);
    }
    _notifyTriggers() {
        let eventAddress = this._hknp.HP_World_GetTriggerEvents(this.world)[1];
        const event = new $ad0247a06a3c1725$var$TriggerEvent();
        while(eventAddress){
            $ad0247a06a3c1725$var$TriggerEvent.readToRef(this._hknp.HEAPU8.buffer, eventAddress, event);
            const bodyInfoA = this._bodies.get(event.bodyIdA);
            const bodyInfoB = this._bodies.get(event.bodyIdB);
            // Bodies may have been disposed between events. Check both still exist.
            if (bodyInfoA && bodyInfoB) {
                const triggerCollisionInfo = {
                    collider: bodyInfoA.body,
                    colliderIndex: bodyInfoA.index,
                    collidedAgainst: bodyInfoB.body,
                    collidedAgainstIndex: bodyInfoB.index,
                    type: this._nativeTriggerCollisionValueToCollisionType(event.type)
                };
                this.onTriggerCollisionObservable.notifyObservers(triggerCollisionInfo);
            }
            eventAddress = this._hknp.HP_World_GetNextTriggerEvent(this.world, eventAddress);
        }
    }
    /**
     * Runs thru all detected collisions and filter by body
     */ _notifyCollisions() {
        let eventAddress = this._hknp.HP_World_GetCollisionEvents(this.world)[1];
        const event = new $ad0247a06a3c1725$var$CollisionEvent();
        const worldAddr = Number(this.world);
        while(eventAddress){
            $ad0247a06a3c1725$var$CollisionEvent.readToRef(this._hknp.HEAPU8.buffer, eventAddress, event);
            const bodyInfoA = this._bodies.get(event.contactOnA.bodyId);
            const bodyInfoB = this._bodies.get(event.contactOnB.bodyId);
            // Bodies may have been disposed between events. Check both still exist.
            if (bodyInfoA && bodyInfoB) {
                const collisionInfo = {
                    collider: bodyInfoA.body,
                    colliderIndex: bodyInfoA.index,
                    collidedAgainst: bodyInfoB.body,
                    collidedAgainstIndex: bodyInfoB.index,
                    type: this._nativeCollisionValueToCollisionType(event.type)
                };
                if (collisionInfo.type === (0, $fopmL.PhysicsEventType).COLLISION_FINISHED) this.onCollisionEndedObservable.notifyObservers(collisionInfo);
                else {
                    event.contactOnB.position.subtractToRef(event.contactOnA.position, this._tmpVec3[0]);
                    const distance = (0, $ha1VO.Vector3).Dot(this._tmpVec3[0], event.contactOnA.normal);
                    collisionInfo.point = event.contactOnA.position;
                    collisionInfo.distance = distance;
                    collisionInfo.impulse = event.impulseApplied;
                    collisionInfo.normal = event.contactOnA.normal;
                    this.onCollisionObservable.notifyObservers(collisionInfo);
                }
                if (this._bodyCollisionObservable.size && collisionInfo.type !== (0, $fopmL.PhysicsEventType).COLLISION_FINISHED) {
                    const observableA = this._bodyCollisionObservable.get(event.contactOnA.bodyId);
                    const observableB = this._bodyCollisionObservable.get(event.contactOnB.bodyId);
                    if (observableA) observableA.notifyObservers(collisionInfo);
                    else if (observableB) {
                        //<todo This seems like it would give unexpected results when both bodies have observers?
                        // Flip collision info:
                        collisionInfo.collider = bodyInfoB.body;
                        collisionInfo.colliderIndex = bodyInfoB.index;
                        collisionInfo.collidedAgainst = bodyInfoA.body;
                        collisionInfo.collidedAgainstIndex = bodyInfoA.index;
                        collisionInfo.normal = event.contactOnB.normal;
                        observableB.notifyObservers(collisionInfo);
                    }
                } else if (this._bodyCollisionEndedObservable.size) {
                    const observableA = this._bodyCollisionEndedObservable.get(event.contactOnA.bodyId);
                    const observableB = this._bodyCollisionEndedObservable.get(event.contactOnB.bodyId);
                    if (observableA) observableA.notifyObservers(collisionInfo);
                    else if (observableB) {
                        //<todo This seems like it would give unexpected results when both bodies have observers?
                        // Flip collision info:
                        collisionInfo.collider = bodyInfoB.body;
                        collisionInfo.colliderIndex = bodyInfoB.index;
                        collisionInfo.collidedAgainst = bodyInfoA.body;
                        collisionInfo.collidedAgainstIndex = bodyInfoA.index;
                        collisionInfo.normal = event.contactOnB.normal;
                        observableB.notifyObservers(collisionInfo);
                    }
                }
            }
            eventAddress = this._hknp.HP_World_GetNextCollisionEvent(worldAddr, eventAddress);
        }
    }
    /**
     * Gets the number of bodies in the world
     */ get numBodies() {
        return this._hknp.HP_World_GetNumBodies(this.world)[1];
    }
    /**
     * Dispose the world and free resources
     */ dispose() {
        this._hknp.HP_QueryCollector_Release(this._queryCollector);
        this._queryCollector = BigInt(0);
        this._hknp.HP_World_Release(this.world);
        this.world = undefined;
    }
    _v3ToBvecRef(v, vec3) {
        vec3.set(v[0], v[1], v[2]);
    }
    _bVecToV3(v) {
        return [
            v._x,
            v._y,
            v._z
        ];
    }
    _bQuatToV4(q) {
        return [
            q._x,
            q._y,
            q._z,
            q._w
        ];
    }
    _constraintMotorTypeToNative(motorType) {
        switch(motorType){
            case (0, $fopmL.PhysicsConstraintMotorType).POSITION:
                return this._hknp.ConstraintMotorType.POSITION;
            case (0, $fopmL.PhysicsConstraintMotorType).VELOCITY:
                return this._hknp.ConstraintMotorType.VELOCITY;
        }
        return this._hknp.ConstraintMotorType.NONE;
    }
    _nativeToMotorType(motorType) {
        switch(motorType){
            case this._hknp.ConstraintMotorType.POSITION:
                return (0, $fopmL.PhysicsConstraintMotorType).POSITION;
            case this._hknp.ConstraintMotorType.VELOCITY:
                return (0, $fopmL.PhysicsConstraintMotorType).VELOCITY;
        }
        return (0, $fopmL.PhysicsConstraintMotorType).NONE;
    }
    _materialCombineToNative(mat) {
        switch(mat){
            case (0, $3Z9d3.PhysicsMaterialCombineMode).GEOMETRIC_MEAN:
                return this._hknp.MaterialCombine.GEOMETRIC_MEAN;
            case (0, $3Z9d3.PhysicsMaterialCombineMode).MINIMUM:
                return this._hknp.MaterialCombine.MINIMUM;
            case (0, $3Z9d3.PhysicsMaterialCombineMode).MAXIMUM:
                return this._hknp.MaterialCombine.MAXIMUM;
            case (0, $3Z9d3.PhysicsMaterialCombineMode).ARITHMETIC_MEAN:
                return this._hknp.MaterialCombine.ARITHMETIC_MEAN;
            case (0, $3Z9d3.PhysicsMaterialCombineMode).MULTIPLY:
                return this._hknp.MaterialCombine.MULTIPLY;
        }
    }
    _nativeToMaterialCombine(mat) {
        switch(mat){
            case this._hknp.MaterialCombine.GEOMETRIC_MEAN:
                return (0, $3Z9d3.PhysicsMaterialCombineMode).GEOMETRIC_MEAN;
            case this._hknp.MaterialCombine.MINIMUM:
                return (0, $3Z9d3.PhysicsMaterialCombineMode).MINIMUM;
            case this._hknp.MaterialCombine.MAXIMUM:
                return (0, $3Z9d3.PhysicsMaterialCombineMode).MAXIMUM;
            case this._hknp.MaterialCombine.ARITHMETIC_MEAN:
                return (0, $3Z9d3.PhysicsMaterialCombineMode).ARITHMETIC_MEAN;
            case this._hknp.MaterialCombine.MULTIPLY:
                return (0, $3Z9d3.PhysicsMaterialCombineMode).MULTIPLY;
            default:
                return undefined;
        }
    }
    _constraintAxisToNative(axId) {
        switch(axId){
            case (0, $fopmL.PhysicsConstraintAxis).LINEAR_X:
                return this._hknp.ConstraintAxis.LINEAR_X;
            case (0, $fopmL.PhysicsConstraintAxis).LINEAR_Y:
                return this._hknp.ConstraintAxis.LINEAR_Y;
            case (0, $fopmL.PhysicsConstraintAxis).LINEAR_Z:
                return this._hknp.ConstraintAxis.LINEAR_Z;
            case (0, $fopmL.PhysicsConstraintAxis).ANGULAR_X:
                return this._hknp.ConstraintAxis.ANGULAR_X;
            case (0, $fopmL.PhysicsConstraintAxis).ANGULAR_Y:
                return this._hknp.ConstraintAxis.ANGULAR_Y;
            case (0, $fopmL.PhysicsConstraintAxis).ANGULAR_Z:
                return this._hknp.ConstraintAxis.ANGULAR_Z;
            case (0, $fopmL.PhysicsConstraintAxis).LINEAR_DISTANCE:
                return this._hknp.ConstraintAxis.LINEAR_DISTANCE;
        }
    }
    _nativeToLimitMode(mode) {
        switch(mode){
            case this._hknp.ConstraintAxisLimitMode.FREE:
                return (0, $fopmL.PhysicsConstraintAxisLimitMode).FREE;
            case this._hknp.ConstraintAxisLimitMode.LIMITED:
                return (0, $fopmL.PhysicsConstraintAxisLimitMode).LIMITED;
            case this._hknp.ConstraintAxisLimitMode.LOCKED:
                return (0, $fopmL.PhysicsConstraintAxisLimitMode).LOCKED;
        }
        return (0, $fopmL.PhysicsConstraintAxisLimitMode).FREE;
    }
    _limitModeToNative(mode) {
        switch(mode){
            case (0, $fopmL.PhysicsConstraintAxisLimitMode).FREE:
                return this._hknp.ConstraintAxisLimitMode.FREE;
            case (0, $fopmL.PhysicsConstraintAxisLimitMode).LIMITED:
                return this._hknp.ConstraintAxisLimitMode.LIMITED;
            case (0, $fopmL.PhysicsConstraintAxisLimitMode).LOCKED:
                return this._hknp.ConstraintAxisLimitMode.LOCKED;
        }
    }
    _nativeCollisionValueToCollisionType(type) {
        switch(type){
            case this._hknp.EventType.COLLISION_STARTED.value:
                return (0, $fopmL.PhysicsEventType).COLLISION_STARTED;
            case this._hknp.EventType.COLLISION_FINISHED.value:
                return (0, $fopmL.PhysicsEventType).COLLISION_FINISHED;
            case this._hknp.EventType.COLLISION_CONTINUED.value:
                return (0, $fopmL.PhysicsEventType).COLLISION_CONTINUED;
        }
        return (0, $fopmL.PhysicsEventType).COLLISION_STARTED;
    }
    _nativeTriggerCollisionValueToCollisionType(type) {
        switch(type){
            case 8:
                return (0, $fopmL.PhysicsEventType).TRIGGER_ENTERED;
            case 16:
                return (0, $fopmL.PhysicsEventType).TRIGGER_EXITED;
        }
        return (0, $fopmL.PhysicsEventType).TRIGGER_ENTERED;
    }
}

});



parcelRegister("6z2KE", function(module, exports) {
// back compat
parcelRequire("eTE7e");
parcelRequire("4oZ5Y");
parcelRequire("dctER");

});
parcelRegister("eTE7e", function(module, exports) {

var $kVtWi = parcelRequire("kVtWi");

var $diGQf = parcelRequire("diGQf");

var $bv05l = parcelRequire("bv05l");

var $gmbCk = parcelRequire("gmbCk");

var $4qQ0v = parcelRequire("4qQ0v");

var $ku6ll = parcelRequire("ku6ll");
/**
 * Gets the current physics engine
 * @returns a IPhysicsEngine or null if none attached
 */ (0, $gmbCk.Scene).prototype.getPhysicsEngine = function() {
    return this._physicsEngine;
};
/**
 * Enables physics to the current scene
 * @param gravity defines the scene's gravity for the physics engine
 * @param plugin defines the physics engine to be used. defaults to CannonJS.
 * @returns a boolean indicating if the physics engine was initialized
 */ (0, $gmbCk.Scene).prototype.enablePhysics = function(gravity = null, plugin) {
    if (this._physicsEngine) return true;
    // Register the component to the scene
    let component = this._getComponent((0, $bv05l.SceneComponentConstants).NAME_PHYSICSENGINE);
    if (!component) {
        component = new $02cc790ffab93e7b$export$36bbceef084d50e(this);
        this._addComponent(component);
    }
    try {
        if (!plugin || plugin?.getPluginVersion() === 1) this._physicsEngine = new (0, $4qQ0v.PhysicsEngine)(gravity, plugin);
        else if (plugin?.getPluginVersion() === 2) this._physicsEngine = new (0, $ku6ll.PhysicsEngine)(gravity, plugin);
        else throw new Error("Unsupported Physics plugin version.");
        this._physicsTimeAccumulator = 0;
        return true;
    } catch (e) {
        (0, $kVtWi.Logger).Error(e.message);
        return false;
    }
};
/**
 * Disables and disposes the physics engine associated with the scene
 */ (0, $gmbCk.Scene).prototype.disablePhysicsEngine = function() {
    if (!this._physicsEngine) return;
    this._physicsEngine.dispose();
    this._physicsEngine = null;
};
/**
 * Gets a boolean indicating if there is an active physics engine
 * @returns a boolean indicating if there is an active physics engine
 */ (0, $gmbCk.Scene).prototype.isPhysicsEnabled = function() {
    return this._physicsEngine !== undefined;
};
/**
 * Deletes a physics compound impostor
 * @param compound defines the compound to delete
 */ (0, $gmbCk.Scene).prototype.deleteCompoundImpostor = function(compound) {
    const mesh = compound.parts[0].mesh;
    if (mesh.physicsImpostor) {
        mesh.physicsImpostor.dispose();
        mesh.physicsImpostor = null;
    }
};
/**
 * @internal
 */ (0, $gmbCk.Scene).prototype._advancePhysicsEngineStep = function(step) {
    if (this._physicsEngine) {
        const subTime = this._physicsEngine.getSubTimeStep();
        if (subTime > 0) {
            this._physicsTimeAccumulator += step;
            while(this._physicsTimeAccumulator > subTime){
                this.onBeforePhysicsObservable.notifyObservers(this);
                this._physicsEngine._step(subTime / 1000);
                this.onAfterPhysicsObservable.notifyObservers(this);
                this._physicsTimeAccumulator -= subTime;
            }
        } else {
            this.onBeforePhysicsObservable.notifyObservers(this);
            this._physicsEngine._step(step / 1000);
            this.onAfterPhysicsObservable.notifyObservers(this);
        }
    }
};
class $02cc790ffab93e7b$export$36bbceef084d50e {
    /**
     * Creates a new instance of the component for the given scene
     * @param scene Defines the scene to register the component in
     */ constructor(scene){
        /**
         * The component name helpful to identify the component in the list of scene components.
         */ this.name = (0, $bv05l.SceneComponentConstants).NAME_PHYSICSENGINE;
        this.scene = scene;
        this.scene.onBeforePhysicsObservable = new (0, $diGQf.Observable)();
        this.scene.onAfterPhysicsObservable = new (0, $diGQf.Observable)();
        // Replace the function used to get the deterministic frame time
        this.scene.getDeterministicFrameTime = ()=>{
            if (this.scene._physicsEngine) return this.scene._physicsEngine.getTimeStep() * 1000;
            return 1000.0 / 60.0;
        };
    }
    /**
     * Registers the component in a given scene
     */ register() {}
    /**
     * Rebuilds the elements related to this component in case of
     * context lost for instance.
     */ rebuild() {
    // Nothing to do for this component
    }
    /**
     * Disposes the component and the associated resources
     */ dispose() {
        this.scene.onBeforePhysicsObservable.clear();
        this.scene.onAfterPhysicsObservable.clear();
        if (this.scene._physicsEngine) this.scene.disablePhysicsEngine();
    }
}

});

parcelRegister("dctER", function(module, exports) {

var $klshO = parcelRequire("klshO");
parcelRequire("eTE7e");
Object.defineProperty((0, $klshO.TransformNode).prototype, "physicsBody", {
    get: function() {
        return this._physicsBody;
    },
    set: function(value) {
        if (this._physicsBody === value) return;
        if (this._disposePhysicsObserver) this.onDisposeObservable.remove(this._disposePhysicsObserver);
        this._physicsBody = value;
        if (value) this._disposePhysicsObserver = this.onDisposeObservable.add(()=>{
            // Physics
            if (this.physicsBody) {
                this.physicsBody.dispose();
                this.physicsBody = null;
            }
        });
    },
    enumerable: true,
    configurable: true
});
/**
 * Gets the current physics body
 * @returns a physics body or null
 */ (0, $klshO.TransformNode).prototype.getPhysicsBody = function() {
    return this.physicsBody;
};
/**
 * Apply a physic impulse to the mesh
 * @param force defines the force to apply
 * @param contactPoint defines where to apply the force
 * @returns the current mesh
 * @see https://doc.babylonjs.com/features/featuresDeepDive/physics/usingPhysicsEngine
 */ (0, $klshO.TransformNode).prototype.applyImpulse = function(force, contactPoint) {
    if (!this.physicsBody) throw new Error("No Physics Body for TransformNode");
    this.physicsBody.applyImpulse(force, contactPoint);
    return this;
};

});


parcelRegister("911Bn", function(module, exports) {

$parcel$export(module.exports, "PhysicsHelper", () => $6905732a43459cca$export$3db5d0d2ff7b1fd5);
$parcel$export(module.exports, "PhysicsRadialExplosionEventOptions", () => $6905732a43459cca$export$20ced70c72a9c6a);
$parcel$export(module.exports, "PhysicsUpdraftEventOptions", () => $6905732a43459cca$export$a0c9ce0747fba9c0);
$parcel$export(module.exports, "PhysicsVortexEventOptions", () => $6905732a43459cca$export$8c0c251c20a27369);
$parcel$export(module.exports, "PhysicsRadialImpulseFalloff", () => $6905732a43459cca$export$3d89c3e5c9e39470);
$parcel$export(module.exports, "PhysicsUpdraftMode", () => $6905732a43459cca$export$ecd817f07cf932d9);

var $kVtWi = parcelRequire("kVtWi");

var $ha1VO = parcelRequire("ha1VO");

var $8KqOo = parcelRequire("8KqOo");

var $9zY5k = parcelRequire("9zY5k");

var $3kez7 = parcelRequire("3kez7");

var $fopmL = parcelRequire("fopmL");
class $6905732a43459cca$var$HelperTools {
    /*
     * Gets the hit contact point between a mesh and a ray. The method varies between
     * the different plugin versions; V1 uses a mesh intersection, V2 uses the physics body instance/object center (to avoid a raycast and improve perf).
     */ static GetContactPointToRef(mesh, origin, direction, result, instanceIndex) {
        const engine = mesh.getScene().getPhysicsEngine();
        const pluginVersion = engine?.getPluginVersion();
        if (pluginVersion === 1) {
            const ray = new (0, $3kez7.Ray)(origin, direction);
            const hit = ray.intersectsMesh(mesh);
            if (hit.hit && hit.pickedPoint) {
                result.copyFrom(hit.pickedPoint);
                return true;
            }
        } else if (pluginVersion === 2) {
            mesh.physicsBody.getObjectCenterWorldToRef(result, instanceIndex);
            return true;
        }
        return false;
    }
    /**
     * Checks if a body will be affected by forces
     * @param body the body to check
     * @param instanceIndex for instanced bodies, the index of the instance to check
     * @returns
     */ static HasAppliedForces(body, instanceIndex) {
        return body.getMotionType(instanceIndex) === (0, $fopmL.PhysicsMotionType).STATIC || (body.getMassProperties(instanceIndex)?.mass ?? 0) === 0 || body.transformNode?.getTotalVertices() === 0;
    }
    /**
     * Checks if a point is inside a cylinder
     * @param point point to check
     * @param origin cylinder origin on the bottom
     * @param radius cylinder radius
     * @param height cylinder height
     * @returns
     */ static IsInsideCylinder(point, origin, radius, height) {
        const distance = (0, $ha1VO.TmpVectors).Vector3[0];
        point.subtractToRef(origin, distance);
        return Math.abs(distance.x) <= radius && Math.abs(distance.z) <= radius && distance.y >= 0 && distance.y <= height;
    }
}
class $6905732a43459cca$export$3db5d0d2ff7b1fd5 {
    /**
     * Initializes the Physics helper
     * @param scene Babylon.js scene
     */ constructor(scene){
        this._hitData = {
            force: new (0, $ha1VO.Vector3)(),
            contactPoint: new (0, $ha1VO.Vector3)(),
            distanceFromOrigin: 0
        };
        this._scene = scene;
        this._physicsEngine = this._scene.getPhysicsEngine();
        if (!this._physicsEngine) {
            (0, $kVtWi.Logger).Warn("Physics engine not enabled. Please enable the physics before you can use the methods.");
            return;
        }
    }
    /**
     * Applies a radial explosion impulse
     * @param origin the origin of the explosion
     * @param radiusOrEventOptions the radius or the options of radial explosion
     * @param strength the explosion strength
     * @param falloff possible options: Constant & Linear. Defaults to Constant
     * @returns A physics radial explosion event, or null
     */ applyRadialExplosionImpulse(origin, radiusOrEventOptions, strength, falloff) {
        if (!this._physicsEngine) {
            (0, $kVtWi.Logger).Warn("Physics engine not enabled. Please enable the physics before you call this method.");
            return null;
        }
        if (this._physicsEngine.getPluginVersion() === 1 && this._physicsEngine.getImpostors().length === 0) return null;
        if (this._physicsEngine.getPluginVersion() === 2 && this._physicsEngine.getBodies().length === 0) return null;
        let useCallback = false;
        if (typeof radiusOrEventOptions === "number") {
            const r = radiusOrEventOptions;
            radiusOrEventOptions = new $6905732a43459cca$export$20ced70c72a9c6a();
            radiusOrEventOptions.radius = r;
            radiusOrEventOptions.strength = strength ?? radiusOrEventOptions.strength;
            radiusOrEventOptions.falloff = falloff ?? radiusOrEventOptions.falloff;
        } else useCallback = !!(radiusOrEventOptions.affectedImpostorsCallback || radiusOrEventOptions.affectedBodiesCallback);
        const event = new $6905732a43459cca$var$PhysicsRadialExplosionEvent(this._scene, radiusOrEventOptions);
        const hitData = this._hitData;
        if (this._physicsEngine.getPluginVersion() === 1) {
            const affectedImpostorsWithData = Array();
            const impostors = this._physicsEngine.getImpostors();
            impostors.forEach((impostor)=>{
                if (!event.getImpostorHitData(impostor, origin, hitData)) return;
                impostor.applyImpulse(hitData.force, hitData.contactPoint);
                if (useCallback) affectedImpostorsWithData.push({
                    impostor: impostor,
                    hitData: this._copyPhysicsHitData(hitData)
                });
            });
            event.triggerAffectedImpostorsCallback(affectedImpostorsWithData);
        } else this._applicationForBodies(event, origin, hitData, useCallback, (body, hitData)=>{
            body.applyImpulse(hitData.force, hitData.contactPoint, hitData.instanceIndex);
        });
        event.dispose(false);
        return event;
    }
    /**
     * Applies a radial explosion force
     * @param origin the origin of the explosion
     * @param radiusOrEventOptions the radius or the options of radial explosion
     * @param strength the explosion strength
     * @param falloff possible options: Constant & Linear. Defaults to Constant
     * @returns A physics radial explosion event, or null
     */ applyRadialExplosionForce(origin, radiusOrEventOptions, strength, falloff) {
        if (!this._physicsEngine) {
            (0, $kVtWi.Logger).Warn("Physics engine not enabled. Please enable the physics before you call the PhysicsHelper.");
            return null;
        }
        if (this._physicsEngine.getPluginVersion() === 1 && this._physicsEngine.getImpostors().length === 0) return null;
        if (this._physicsEngine.getPluginVersion() === 2 && this._physicsEngine.getBodies().length === 0) return null;
        let useCallback = false;
        if (typeof radiusOrEventOptions === "number") {
            const r = radiusOrEventOptions;
            radiusOrEventOptions = new $6905732a43459cca$export$20ced70c72a9c6a();
            radiusOrEventOptions.radius = r;
            radiusOrEventOptions.strength = strength ?? radiusOrEventOptions.strength;
            radiusOrEventOptions.falloff = falloff ?? radiusOrEventOptions.falloff;
        } else useCallback = !!(radiusOrEventOptions.affectedImpostorsCallback || radiusOrEventOptions.affectedBodiesCallback);
        const event = new $6905732a43459cca$var$PhysicsRadialExplosionEvent(this._scene, radiusOrEventOptions);
        const hitData = this._hitData;
        if (this._physicsEngine.getPluginVersion() === 1) {
            const affectedImpostorsWithData = Array();
            const impostors = this._physicsEngine.getImpostors();
            impostors.forEach((impostor)=>{
                if (!event.getImpostorHitData(impostor, origin, hitData)) return;
                impostor.applyForce(hitData.force, hitData.contactPoint);
                if (useCallback) affectedImpostorsWithData.push({
                    impostor: impostor,
                    hitData: this._copyPhysicsHitData(hitData)
                });
            });
            event.triggerAffectedImpostorsCallback(affectedImpostorsWithData);
        } else this._applicationForBodies(event, origin, hitData, useCallback, (body, hitData)=>{
            body.applyForce(hitData.force, hitData.contactPoint, hitData.instanceIndex);
        });
        event.dispose(false);
        return event;
    }
    _applicationForBodies(event, origin, hitData, useCallback, fnApplication) {
        const affectedBodiesWithData = Array();
        const bodies = this._physicsEngine.getBodies();
        for (const body of bodies)body.iterateOverAllInstances((body, instanceIndex)=>{
            if (!event.getBodyHitData(body, origin, hitData, instanceIndex)) return;
            fnApplication(body, hitData);
            if (useCallback) affectedBodiesWithData.push({
                body: body,
                hitData: this._copyPhysicsHitData(hitData)
            });
        });
        event.triggerAffectedBodiesCallback(affectedBodiesWithData);
    }
    /**
     * Creates a gravitational field
     * @param origin the origin of the gravitational field
     * @param radiusOrEventOptions the radius or the options of radial gravitational field
     * @param strength the gravitational field strength
     * @param falloff possible options: Constant & Linear. Defaults to Constant
     * @returns A physics gravitational field event, or null
     */ gravitationalField(origin, radiusOrEventOptions, strength, falloff) {
        if (!this._physicsEngine) {
            (0, $kVtWi.Logger).Warn("Physics engine not enabled. Please enable the physics before you call the PhysicsHelper.");
            return null;
        }
        if (this._physicsEngine.getPluginVersion() === 1 && this._physicsEngine.getImpostors().length === 0) return null;
        if (this._physicsEngine.getPluginVersion() === 2 && this._physicsEngine.getBodies().length === 0) return null;
        if (typeof radiusOrEventOptions === "number") {
            const r = radiusOrEventOptions;
            radiusOrEventOptions = new $6905732a43459cca$export$20ced70c72a9c6a();
            radiusOrEventOptions.radius = r;
            radiusOrEventOptions.strength = strength ?? radiusOrEventOptions.strength;
            radiusOrEventOptions.falloff = falloff ?? radiusOrEventOptions.falloff;
        }
        const event = new $6905732a43459cca$var$PhysicsGravitationalFieldEvent(this, this._scene, origin, radiusOrEventOptions);
        event.dispose(false);
        return event;
    }
    /**
     * Creates a physics updraft event
     * @param origin the origin of the updraft
     * @param radiusOrEventOptions the radius or the options of the updraft
     * @param strength the strength of the updraft
     * @param height the height of the updraft
     * @param updraftMode possible options: Center & Perpendicular. Defaults to Center
     * @returns A physics updraft event, or null
     */ updraft(origin, radiusOrEventOptions, strength, height, updraftMode) {
        if (!this._physicsEngine) {
            (0, $kVtWi.Logger).Warn("Physics engine not enabled. Please enable the physics before you call the PhysicsHelper.");
            return null;
        }
        if (this._physicsEngine.getPluginVersion() === 1 && this._physicsEngine.getImpostors().length === 0) return null;
        if (this._physicsEngine.getPluginVersion() === 2 && this._physicsEngine.getBodies().length === 0) return null;
        if (typeof radiusOrEventOptions === "number") {
            const r = radiusOrEventOptions;
            radiusOrEventOptions = new $6905732a43459cca$export$a0c9ce0747fba9c0();
            radiusOrEventOptions.radius = r;
            radiusOrEventOptions.strength = strength ?? radiusOrEventOptions.strength;
            radiusOrEventOptions.height = height ?? radiusOrEventOptions.height;
            radiusOrEventOptions.updraftMode = updraftMode ?? radiusOrEventOptions.updraftMode;
        }
        const event = new $6905732a43459cca$var$PhysicsUpdraftEvent(this._scene, origin, radiusOrEventOptions);
        event.dispose(false);
        return event;
    }
    /**
     * Creates a physics vortex event
     * @param origin the of the vortex
     * @param radiusOrEventOptions the radius or the options of the vortex
     * @param strength the strength of the vortex
     * @param height   the height of the vortex
     * @returns a Physics vortex event, or null
     * A physics vortex event or null
     */ vortex(origin, radiusOrEventOptions, strength, height) {
        if (!this._physicsEngine) {
            (0, $kVtWi.Logger).Warn("Physics engine not enabled. Please enable the physics before you call the PhysicsHelper.");
            return null;
        }
        if (this._physicsEngine.getPluginVersion() === 1 && this._physicsEngine.getImpostors().length === 0) return null;
        if (this._physicsEngine.getPluginVersion() === 2 && this._physicsEngine.getBodies().length === 0) return null;
        if (typeof radiusOrEventOptions === "number") {
            const r = radiusOrEventOptions;
            radiusOrEventOptions = new $6905732a43459cca$export$8c0c251c20a27369();
            radiusOrEventOptions.radius = r;
            radiusOrEventOptions.strength = strength ?? radiusOrEventOptions.strength;
            radiusOrEventOptions.height = height ?? radiusOrEventOptions.height;
        }
        const event = new $6905732a43459cca$var$PhysicsVortexEvent(this._scene, origin, radiusOrEventOptions);
        event.dispose(false);
        return event;
    }
    _copyPhysicsHitData(data) {
        return {
            force: data.force.clone(),
            contactPoint: data.contactPoint.clone(),
            distanceFromOrigin: data.distanceFromOrigin,
            instanceIndex: data.instanceIndex
        };
    }
}
/**
 * Represents a physics radial explosion event
 */ class $6905732a43459cca$var$PhysicsRadialExplosionEvent {
    /**
     * Initializes a radial explosion event
     * @param _scene BabylonJS scene
     * @param _options The options for the vortex event
     */ constructor(_scene, _options){
        this._scene = _scene;
        this._options = _options;
        this._dataFetched = false; // check if the data has been fetched. If not, do cleanup
        this._options = {
            ...new $6905732a43459cca$export$20ced70c72a9c6a(),
            ...this._options
        };
    }
    /**
     * Returns the data related to the radial explosion event (sphere).
     * @returns The radial explosion event data
     */ getData() {
        this._dataFetched = true;
        return {
            sphere: this._sphere
        };
    }
    _getHitData(mesh, center, origin, data) {
        const direction = (0, $ha1VO.TmpVectors).Vector3[0];
        direction.copyFrom(center).subtractInPlace(origin);
        const contactPoint = (0, $ha1VO.TmpVectors).Vector3[1];
        const hasContactPoint = $6905732a43459cca$var$HelperTools.GetContactPointToRef(mesh, origin, direction, contactPoint, data.instanceIndex);
        if (!hasContactPoint) return false;
        const distanceFromOrigin = (0, $ha1VO.Vector3).Distance(origin, contactPoint);
        if (distanceFromOrigin > this._options.radius) return false;
        const multiplier = this._options.falloff === $6905732a43459cca$export$3d89c3e5c9e39470.Constant ? this._options.strength : this._options.strength * (1 - distanceFromOrigin / this._options.radius);
        // Direction x multiplier equals force
        direction.scaleInPlace(multiplier);
        data.force.copyFrom(direction);
        data.contactPoint.copyFrom(contactPoint);
        data.distanceFromOrigin = distanceFromOrigin;
        return true;
    }
    /**
     * Returns the force and contact point of the body or false, if the body is not affected by the force/impulse.
     * @param body A physics body where the transform node is an AbstractMesh
     * @param origin the origin of the explosion
     * @param data the data of the hit
     * @param instanceIndex the instance index of the body
     * @returns if there was a hit
     */ getBodyHitData(body, origin, data, instanceIndex) {
        // No force will be applied in these cases, so we skip calculation
        if ($6905732a43459cca$var$HelperTools.HasAppliedForces(body, instanceIndex)) return false;
        const mesh = body.transformNode;
        const bodyObjectCenter = body.getObjectCenterWorld(instanceIndex);
        data.instanceIndex = instanceIndex;
        return this._getHitData(mesh, bodyObjectCenter, origin, data);
    }
    /**
     * Returns the force and contact point of the impostor or false, if the impostor is not affected by the force/impulse.
     * @param impostor A physics imposter
     * @param origin the origin of the explosion
     * @param data the data of the hit
     * @returns A physics force and contact point, or null
     */ getImpostorHitData(impostor, origin, data) {
        if (impostor.mass === 0) return false;
        if (impostor.object.getClassName() !== "Mesh" && impostor.object.getClassName() !== "InstancedMesh") return false;
        const mesh = impostor.object;
        if (!this._intersectsWithSphere(mesh, origin, this._options.radius)) return false;
        const impostorObjectCenter = impostor.getObjectCenter();
        this._getHitData(mesh, impostorObjectCenter, origin, data);
        return true;
    }
    /**
     * Triggers affected impostors callbacks
     * @param affectedImpostorsWithData defines the list of affected impostors (including associated data)
     */ triggerAffectedImpostorsCallback(affectedImpostorsWithData) {
        if (this._options.affectedImpostorsCallback) this._options.affectedImpostorsCallback(affectedImpostorsWithData);
    }
    /**
     * Triggers affected bodies callbacks
     * @param affectedBodiesWithData defines the list of affected bodies (including associated data)
     */ triggerAffectedBodiesCallback(affectedBodiesWithData) {
        if (this._options.affectedBodiesCallback) this._options.affectedBodiesCallback(affectedBodiesWithData);
    }
    /**
     * Disposes the sphere.
     * @param force Specifies if the sphere should be disposed by force
     */ dispose(force = true) {
        if (this._sphere) {
            if (force) this._sphere.dispose();
            else setTimeout(()=>{
                if (!this._dataFetched) this._sphere.dispose();
            }, 0);
        }
    }
    /*** Helpers ***/ _prepareSphere() {
        if (!this._sphere) {
            this._sphere = (0, $8KqOo.CreateSphere)("radialExplosionEventSphere", this._options.sphere, this._scene);
            this._sphere.isVisible = false;
        }
    }
    _intersectsWithSphere(mesh, origin, radius) {
        this._prepareSphere();
        this._sphere.position = origin;
        this._sphere.scaling.setAll(radius * 2);
        this._sphere._updateBoundingInfo();
        this._sphere.computeWorldMatrix(true);
        return this._sphere.intersectsMesh(mesh, true);
    }
}
/**
 * Represents a gravitational field event
 */ class $6905732a43459cca$var$PhysicsGravitationalFieldEvent {
    /**
     * Initializes the physics gravitational field event
     * @param _physicsHelper A physics helper
     * @param _scene BabylonJS scene
     * @param _origin The origin position of the gravitational field event
     * @param _options The options for the vortex event
     */ constructor(_physicsHelper, _scene, _origin, _options){
        this._physicsHelper = _physicsHelper;
        this._scene = _scene;
        this._origin = _origin;
        this._options = _options;
        this._dataFetched = false; // check if the has been fetched the data. If not, do cleanup
        this._options = {
            ...new $6905732a43459cca$export$20ced70c72a9c6a(),
            ...this._options
        };
        this._tickCallback = ()=>this._tick();
        this._options.strength = this._options.strength * -1;
    }
    /**
     * Returns the data related to the gravitational field event (sphere).
     * @returns A gravitational field event
     */ getData() {
        this._dataFetched = true;
        return {
            sphere: this._sphere
        };
    }
    /**
     * Enables the gravitational field.
     */ enable() {
        this._tickCallback.call(this);
        this._scene.registerBeforeRender(this._tickCallback);
    }
    /**
     * Disables the gravitational field.
     */ disable() {
        this._scene.unregisterBeforeRender(this._tickCallback);
    }
    /**
     * Disposes the sphere.
     * @param force The force to dispose from the gravitational field event
     */ dispose(force = true) {
        if (!this._sphere) return;
        if (force) this._sphere.dispose();
        else setTimeout(()=>{
            if (!this._dataFetched) this._sphere.dispose();
        }, 0);
    }
    _tick() {
        // Since the params won't change, we fetch the event only once
        if (this._sphere) this._physicsHelper.applyRadialExplosionForce(this._origin, this._options);
        else {
            const radialExplosionEvent = this._physicsHelper.applyRadialExplosionForce(this._origin, this._options);
            if (radialExplosionEvent) this._sphere = radialExplosionEvent.getData().sphere?.clone("radialExplosionEventSphereClone");
        }
    }
}
/**
 * Represents a physics updraft event
 */ class $6905732a43459cca$var$PhysicsUpdraftEvent {
    /**
     * Initializes the physics updraft event
     * @param _scene BabylonJS scene
     * @param _origin The origin position of the updraft
     * @param _options The options for the updraft event
     */ constructor(_scene, _origin, _options){
        this._scene = _scene;
        this._origin = _origin;
        this._options = _options;
        this._originTop = (0, $ha1VO.Vector3).Zero(); // the most upper part of the cylinder
        this._originDirection = (0, $ha1VO.Vector3).Zero(); // used if the updraftMode is perpendicular
        this._cylinderPosition = (0, $ha1VO.Vector3).Zero(); // to keep the cylinders position, because normally the origin is in the center and not on the bottom
        this._dataFetched = false; // check if the has been fetched the data. If not, do cleanup
        this._physicsEngine = this._scene.getPhysicsEngine();
        this._options = {
            ...new $6905732a43459cca$export$a0c9ce0747fba9c0(),
            ...this._options
        };
        this._origin.addToRef(new (0, $ha1VO.Vector3)(0, this._options.height / 2, 0), this._cylinderPosition);
        this._origin.addToRef(new (0, $ha1VO.Vector3)(0, this._options.height, 0), this._originTop);
        if (this._options.updraftMode === $6905732a43459cca$export$ecd817f07cf932d9.Perpendicular) this._originDirection = this._origin.subtract(this._originTop).normalize();
        this._tickCallback = ()=>this._tick();
        if (this._physicsEngine.getPluginVersion() === 1) this._prepareCylinder();
    }
    /**
     * Returns the data related to the updraft event (cylinder).
     * @returns A physics updraft event
     */ getData() {
        this._dataFetched = true;
        return {
            cylinder: this._cylinder
        };
    }
    /**
     * Enables the updraft.
     */ enable() {
        this._tickCallback.call(this);
        this._scene.registerBeforeRender(this._tickCallback);
    }
    /**
     * Disables the updraft.
     */ disable() {
        this._scene.unregisterBeforeRender(this._tickCallback);
    }
    /**
     * Disposes the cylinder.
     * @param force Specifies if the updraft should be disposed by force
     */ dispose(force = true) {
        if (!this._cylinder) return;
        if (force) {
            this._cylinder.dispose();
            this._cylinder = undefined;
        } else setTimeout(()=>{
            if (!this._dataFetched && this._cylinder) {
                this._cylinder.dispose();
                this._cylinder = undefined;
            }
        }, 0);
    }
    _getHitData(center, data) {
        let direction;
        if (this._options.updraftMode === $6905732a43459cca$export$ecd817f07cf932d9.Perpendicular) direction = this._originDirection;
        else direction = center.subtract(this._originTop);
        const distanceFromOrigin = (0, $ha1VO.Vector3).Distance(this._origin, center);
        const multiplier = this._options.strength * -1;
        const force = direction.multiplyByFloats(multiplier, multiplier, multiplier);
        data.force.copyFrom(force);
        data.contactPoint.copyFrom(center);
        data.distanceFromOrigin = distanceFromOrigin;
    }
    _getBodyHitData(body, data, instanceIndex) {
        if ($6905732a43459cca$var$HelperTools.HasAppliedForces(body)) return false;
        const center = body.getObjectCenterWorld(instanceIndex);
        if (!$6905732a43459cca$var$HelperTools.IsInsideCylinder(center, this._origin, this._options.radius, this._options.height)) return false;
        data.instanceIndex = instanceIndex;
        this._getHitData(center, data);
        return true;
    }
    _getImpostorHitData(impostor, data) {
        if (impostor.mass === 0) return false;
        const impostorObject = impostor.object;
        if (!this._intersectsWithCylinder(impostorObject)) return false;
        const center = impostor.getObjectCenter();
        this._getHitData(center, data);
        return true;
    }
    _tick() {
        const hitData = $6905732a43459cca$var$PhysicsUpdraftEvent._HitData;
        if (this._physicsEngine.getPluginVersion() === 1) this._physicsEngine.getImpostors().forEach((impostor)=>{
            if (!this._getImpostorHitData(impostor, hitData)) return;
            impostor.applyForce(hitData.force, hitData.contactPoint);
        });
        else // V2
        this._physicsEngine.getBodies().forEach((body)=>{
            body.iterateOverAllInstances((body, instanceIndex)=>{
                if (!this._getBodyHitData(body, hitData, instanceIndex)) return;
                body.applyForce(hitData.force, hitData.contactPoint, hitData.instanceIndex);
            });
        });
    }
    /*** Helpers ***/ _prepareCylinder() {
        if (!this._cylinder) {
            this._cylinder = (0, $9zY5k.CreateCylinder)("updraftEventCylinder", {
                height: this._options.height,
                diameter: this._options.radius * 2
            }, this._scene);
            this._cylinder.isVisible = false;
        }
    }
    _intersectsWithCylinder(mesh) {
        if (!this._cylinder) return false;
        this._cylinder.position = this._cylinderPosition;
        return this._cylinder.intersectsMesh(mesh, true);
    }
}
$6905732a43459cca$var$PhysicsUpdraftEvent._HitData = {
    force: new (0, $ha1VO.Vector3)(),
    contactPoint: new (0, $ha1VO.Vector3)(),
    distanceFromOrigin: 0
};
/**
 * Represents a physics vortex event
 */ class $6905732a43459cca$var$PhysicsVortexEvent {
    /**
     * Initializes the physics vortex event
     * @param _scene The BabylonJS scene
     * @param _origin The origin position of the vortex
     * @param _options The options for the vortex event
     */ constructor(_scene, _origin, _options){
        this._scene = _scene;
        this._origin = _origin;
        this._options = _options;
        this._originTop = (0, $ha1VO.Vector3).Zero(); // the most upper part of the cylinder
        this._cylinderPosition = (0, $ha1VO.Vector3).Zero(); // to keep the cylinders position, because normally the origin is in the center and not on the bottom
        this._dataFetched = false; // check if the has been fetched the data. If not, do cleanup
        this._physicsEngine = this._scene.getPhysicsEngine();
        this._options = {
            ...new $6905732a43459cca$export$8c0c251c20a27369(),
            ...this._options
        };
        this._origin.addToRef(new (0, $ha1VO.Vector3)(0, this._options.height / 2, 0), this._cylinderPosition);
        this._origin.addToRef(new (0, $ha1VO.Vector3)(0, this._options.height, 0), this._originTop);
        this._tickCallback = ()=>this._tick();
        if (this._physicsEngine.getPluginVersion() === 1) this._prepareCylinder();
    }
    /**
     * Returns the data related to the vortex event (cylinder).
     * @returns The physics vortex event data
     */ getData() {
        this._dataFetched = true;
        return {
            cylinder: this._cylinder
        };
    }
    /**
     * Enables the vortex.
     */ enable() {
        this._tickCallback.call(this);
        this._scene.registerBeforeRender(this._tickCallback);
    }
    /**
     * Disables the cortex.
     */ disable() {
        this._scene.unregisterBeforeRender(this._tickCallback);
    }
    /**
     * Disposes the sphere.
     * @param force
     */ dispose(force = true) {
        if (!this._cylinder) return;
        if (force) this._cylinder.dispose();
        else setTimeout(()=>{
            if (!this._dataFetched) this._cylinder.dispose();
        }, 0);
    }
    _getHitData(mesh, center, data) {
        const originOnPlane = $6905732a43459cca$var$PhysicsVortexEvent._OriginOnPlane;
        originOnPlane.set(this._origin.x, center.y, this._origin.z); // the distance to the origin as if both objects were on a plane (Y-axis)
        const originToImpostorDirection = (0, $ha1VO.TmpVectors).Vector3[0];
        center.subtractToRef(originOnPlane, originToImpostorDirection);
        const contactPoint = (0, $ha1VO.TmpVectors).Vector3[1];
        const hasContactPoint = $6905732a43459cca$var$HelperTools.GetContactPointToRef(mesh, originOnPlane, originToImpostorDirection, contactPoint, data.instanceIndex);
        if (!hasContactPoint) return false;
        const distance = (0, $ha1VO.Vector3).Distance(contactPoint, originOnPlane);
        const absoluteDistanceFromOrigin = distance / this._options.radius;
        const directionToOrigin = (0, $ha1VO.TmpVectors).Vector3[2];
        contactPoint.normalizeToRef(directionToOrigin);
        if (absoluteDistanceFromOrigin > this._options.centripetalForceThreshold) directionToOrigin.negateInPlace();
        let forceX;
        let forceY;
        let forceZ;
        if (absoluteDistanceFromOrigin > this._options.centripetalForceThreshold) {
            forceX = directionToOrigin.x * this._options.centripetalForceMultiplier;
            forceY = directionToOrigin.y * this._options.updraftForceMultiplier;
            forceZ = directionToOrigin.z * this._options.centripetalForceMultiplier;
        } else {
            const perpendicularDirection = (0, $ha1VO.Vector3).Cross(originOnPlane, center).normalize();
            forceX = (perpendicularDirection.x + directionToOrigin.x) * this._options.centrifugalForceMultiplier;
            forceY = this._originTop.y * this._options.updraftForceMultiplier;
            forceZ = (perpendicularDirection.z + directionToOrigin.z) * this._options.centrifugalForceMultiplier;
        }
        const force = (0, $ha1VO.TmpVectors).Vector3[3];
        force.set(forceX, forceY, forceZ);
        force.scaleInPlace(this._options.strength);
        data.force.copyFrom(force);
        data.contactPoint.copyFrom(center);
        data.distanceFromOrigin = absoluteDistanceFromOrigin;
        return true;
    }
    _getBodyHitData(body, data, instanceIndex) {
        if ($6905732a43459cca$var$HelperTools.HasAppliedForces(body, instanceIndex)) return false;
        const bodyObject = body.transformNode;
        const bodyCenter = body.getObjectCenterWorld(instanceIndex);
        if (!$6905732a43459cca$var$HelperTools.IsInsideCylinder(bodyCenter, this._origin, this._options.radius, this._options.height)) return false;
        data.instanceIndex = instanceIndex;
        return this._getHitData(bodyObject, bodyCenter, data);
    }
    _getImpostorHitData(impostor, data) {
        if (impostor.mass === 0) return false;
        if (impostor.object.getClassName() !== "Mesh" && impostor.object.getClassName() !== "InstancedMesh") return false;
        const impostorObject = impostor.object;
        if (!this._intersectsWithCylinder(impostorObject)) return false;
        const impostorObjectCenter = impostor.getObjectCenter();
        this._getHitData(impostorObject, impostorObjectCenter, data);
        return true;
    }
    _tick() {
        const hitData = $6905732a43459cca$var$PhysicsVortexEvent._HitData;
        if (this._physicsEngine.getPluginVersion() === 1) this._physicsEngine.getImpostors().forEach((impostor)=>{
            if (!this._getImpostorHitData(impostor, hitData)) return;
            impostor.applyForce(hitData.force, hitData.contactPoint);
        });
        else this._physicsEngine.getBodies().forEach((body)=>{
            body.iterateOverAllInstances((body, instanceIndex)=>{
                if (!this._getBodyHitData(body, hitData, instanceIndex)) return;
                body.applyForce(hitData.force, hitData.contactPoint, hitData.instanceIndex);
            });
        });
    }
    /*** Helpers ***/ _prepareCylinder() {
        if (!this._cylinder) {
            this._cylinder = (0, $9zY5k.CreateCylinder)("vortexEventCylinder", {
                height: this._options.height,
                diameter: this._options.radius * 2
            }, this._scene);
            this._cylinder.isVisible = false;
        }
    }
    _intersectsWithCylinder(mesh) {
        this._cylinder.position = this._cylinderPosition;
        return this._cylinder.intersectsMesh(mesh, true);
    }
}
$6905732a43459cca$var$PhysicsVortexEvent._OriginOnPlane = (0, $ha1VO.Vector3).Zero();
$6905732a43459cca$var$PhysicsVortexEvent._HitData = {
    force: new (0, $ha1VO.Vector3)(),
    contactPoint: new (0, $ha1VO.Vector3)(),
    distanceFromOrigin: 0
};
class $6905732a43459cca$export$20ced70c72a9c6a {
    constructor(){
        /**
         * The radius of the sphere for the radial explosion.
         */ this.radius = 5;
        /**
         * The strength of the explosion.
         */ this.strength = 10;
        /**
         * The strength of the force in correspondence to the distance of the affected object
         */ this.falloff = $6905732a43459cca$export$3d89c3e5c9e39470.Constant;
        /**
         * Sphere options for the radial explosion.
         */ this.sphere = {
            segments: 32,
            diameter: 1
        };
    }
}
class $6905732a43459cca$export$a0c9ce0747fba9c0 {
    constructor(){
        /**
         * The radius of the cylinder for the vortex
         */ this.radius = 5;
        /**
         * The strength of the updraft.
         */ this.strength = 10;
        /**
         * The height of the cylinder for the updraft.
         */ this.height = 10;
        /**
         * The mode for the updraft.
         */ this.updraftMode = $6905732a43459cca$export$ecd817f07cf932d9.Center;
    }
}
class $6905732a43459cca$export$8c0c251c20a27369 {
    constructor(){
        /**
         * The radius of the cylinder for the vortex
         */ this.radius = 5;
        /**
         * The strength of the vortex.
         */ this.strength = 10;
        /**
         * The height of the cylinder for the vortex.
         */ this.height = 10;
        /**
         * At which distance, relative to the radius the centripetal forces should kick in? Range: 0-1
         */ this.centripetalForceThreshold = 0.7;
        /**
         * This multiplier determines with how much force the objects will be pushed sideways/around the vortex, when below the threshold.
         */ this.centripetalForceMultiplier = 5;
        /**
         * This multiplier determines with how much force the objects will be pushed sideways/around the vortex, when above the threshold.
         */ this.centrifugalForceMultiplier = 0.5;
        /**
         * This multiplier determines with how much force the objects will be pushed upwards, when in the vortex.
         */ this.updraftForceMultiplier = 0.02;
    }
}
var $6905732a43459cca$export$3d89c3e5c9e39470;
(function(PhysicsRadialImpulseFalloff) {
    /** Defines that impulse is constant in strength across it's whole radius */ PhysicsRadialImpulseFalloff[PhysicsRadialImpulseFalloff["Constant"] = 0] = "Constant";
    /** Defines that impulse gets weaker if it's further from the origin */ PhysicsRadialImpulseFalloff[PhysicsRadialImpulseFalloff["Linear"] = 1] = "Linear";
})($6905732a43459cca$export$3d89c3e5c9e39470 || ($6905732a43459cca$export$3d89c3e5c9e39470 = {}));
var $6905732a43459cca$export$ecd817f07cf932d9;
(function(PhysicsUpdraftMode) {
    /** Defines that the upstream forces will pull towards the top center of the cylinder */ PhysicsUpdraftMode[PhysicsUpdraftMode["Center"] = 0] = "Center";
    /** Defines that once a impostor is inside the cylinder, it will shoot out perpendicular from the ground of the cylinder */ PhysicsUpdraftMode[PhysicsUpdraftMode["Perpendicular"] = 1] = "Perpendicular";
})($6905732a43459cca$export$ecd817f07cf932d9 || ($6905732a43459cca$export$ecd817f07cf932d9 = {}));

});

parcelRegister("jcqPJ", function(module, exports) {

$parcel$export(module.exports, "ProximityCastResult", () => $dfa3f3de7c95127d$export$76e79a29cdc7f934);

var $jbAke = parcelRequire("jbAke");
class $dfa3f3de7c95127d$export$76e79a29cdc7f934 extends (0, $jbAke.CastingResult) {
    constructor(){
        super(...arguments);
        this._hitDistance = 0;
    }
    /**
     * Gets the distance from the hit
     */ get hitDistance() {
        return this._hitDistance;
    }
    /**
     * Sets the distance from the start point to the hit point
     * @param distance
     */ setHitDistance(distance) {
        this._hitDistance = distance;
    }
    /**
     * Resets all the values to default
     */ reset() {
        super.reset();
        this._hitDistance = 0;
    }
}

});

parcelRegister("kPhxB", function(module, exports) {

});

parcelRegister("Chscs", function(module, exports) {

});

parcelRegister("iFPuq", function(module, exports) {

$parcel$export(module.exports, "ShapeCastResult", () => $d983ff1de98f49f8$export$4201a5cacd86b6dd);

var $jbAke = parcelRequire("jbAke");
class $d983ff1de98f49f8$export$4201a5cacd86b6dd extends (0, $jbAke.CastingResult) {
    constructor(){
        super(...arguments);
        this._hitFraction = 0;
    }
    /**
     * Gets the hit fraction along the casting ray
     */ get hitFraction() {
        return this._hitFraction;
    }
    /**
     * Sets the hit fraction along the casting ray
     * @param fraction
     */ setHitFraction(fraction) {
        this._hitFraction = fraction;
    }
}

});


parcelRegister("bZYgT", function(module, exports) {
/* eslint-disable import/no-internal-modules */ 
var $khOYP = parcelRequire("khOYP");

var $eijyS = parcelRequire("eijyS");

var $1PCeL = parcelRequire("1PCeL");

var $7yuxL = parcelRequire("7yuxL");

var $8zEq7 = parcelRequire("8zEq7");

var $cjhmh = parcelRequire("cjhmh");

var $1KBkM = parcelRequire("1KBkM");

var $chJE4 = parcelRequire("chJE4");

var $3z4Sb = parcelRequire("3z4Sb");

var $3rRRb = parcelRequire("3rRRb");

var $7Bej1 = parcelRequire("7Bej1");

var $g4LXT = parcelRequire("g4LXT");

var $4HTpT = parcelRequire("4HTpT");

var $lY80x = parcelRequire("lY80x");

var $cbylG = parcelRequire("cbylG");

var $40XEW = parcelRequire("40XEW");

var $gd6JN = parcelRequire("gd6JN");

var $aSulY = parcelRequire("aSulY");

var $ecirA = parcelRequire("ecirA");

var $Jb4JF = parcelRequire("Jb4JF");

var $c7c1r = parcelRequire("c7c1r");

var $cFdBb = parcelRequire("cFdBb");

var $8MhbJ = parcelRequire("8MhbJ");

var $hI3bE = parcelRequire("hI3bE");

var $9rdEp = parcelRequire("9rdEp");

var $4sfRU = parcelRequire("4sfRU");

var $02MSE = parcelRequire("02MSE");

var $jsEsC = parcelRequire("jsEsC");

var $g7AEA = parcelRequire("g7AEA");

var $d4vo4 = parcelRequire("d4vo4");

var $8zuLY = parcelRequire("8zuLY");

var $kMeib = parcelRequire("kMeib");

var $ivLSK = parcelRequire("ivLSK");
$parcel$exportWildcard(module.exports, $khOYP);
$parcel$exportWildcard(module.exports, $eijyS);
$parcel$exportWildcard(module.exports, $1PCeL);
$parcel$exportWildcard(module.exports, $7yuxL);
$parcel$exportWildcard(module.exports, $8zEq7);
$parcel$exportWildcard(module.exports, $cjhmh);
$parcel$exportWildcard(module.exports, $1KBkM);
$parcel$exportWildcard(module.exports, $chJE4);
$parcel$exportWildcard(module.exports, $3z4Sb);
$parcel$exportWildcard(module.exports, $3rRRb);
$parcel$exportWildcard(module.exports, $7Bej1);
$parcel$exportWildcard(module.exports, $g4LXT);
$parcel$exportWildcard(module.exports, $4HTpT);
$parcel$exportWildcard(module.exports, $lY80x);
$parcel$exportWildcard(module.exports, $cbylG);
$parcel$exportWildcard(module.exports, $40XEW);
$parcel$exportWildcard(module.exports, $gd6JN);
$parcel$exportWildcard(module.exports, $aSulY);
$parcel$exportWildcard(module.exports, $ecirA);
$parcel$exportWildcard(module.exports, $Jb4JF);
$parcel$exportWildcard(module.exports, $c7c1r);
$parcel$exportWildcard(module.exports, $cFdBb);
$parcel$exportWildcard(module.exports, $8MhbJ);
$parcel$exportWildcard(module.exports, $hI3bE);
$parcel$exportWildcard(module.exports, $9rdEp);
$parcel$exportWildcard(module.exports, $4sfRU);
$parcel$exportWildcard(module.exports, $02MSE);
$parcel$exportWildcard(module.exports, $jsEsC);
$parcel$exportWildcard(module.exports, $g7AEA);
$parcel$exportWildcard(module.exports, $d4vo4);
$parcel$exportWildcard(module.exports, $8zuLY);
$parcel$exportWildcard(module.exports, $kMeib);
$parcel$exportWildcard(module.exports, $ivLSK);

});
parcelRegister("eijyS", function(module, exports) {

$parcel$export(module.exports, "BlackAndWhitePostProcess", () => $a681eba2c07adfde$export$359e1c0449dd3922);

var $e0Suo = parcelRequire("e0Suo");

var $cFdBb = parcelRequire("cFdBb");
parcelRequire("40sdW");

var $8DoUR = parcelRequire("8DoUR");

var $ir0rz = parcelRequire("ir0rz");

var $6Ho1L = parcelRequire("6Ho1L");
class $a681eba2c07adfde$export$359e1c0449dd3922 extends (0, $cFdBb.PostProcess) {
    /**
     * Gets a string identifying the name of the class
     * @returns "BlackAndWhitePostProcess" string
     */ getClassName() {
        return "BlackAndWhitePostProcess";
    }
    /**
     * Creates a black and white post process
     * @see https://doc.babylonjs.com/features/featuresDeepDive/postProcesses/usePostProcesses#black-and-white
     * @param name The name of the effect.
     * @param options The required width/height ratio to downsize to before computing the render pass.
     * @param camera The camera to apply the render pass to.
     * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
     * @param engine The engine which the post process will be applied. (default: current engine)
     * @param reusable If the post process can be reused on the same frame. (default: false)
     */ constructor(name, options, camera, samplingMode, engine, reusable){
        super(name, "blackAndWhite", [
            "degree"
        ], null, options, camera, samplingMode, engine, reusable);
        /**
         * Linear about to convert he result to black and white (default: 1)
         */ this.degree = 1;
        this.onApplyObservable.add((effect)=>{
            effect.setFloat("degree", this.degree);
        });
    }
    /**
     * @internal
     */ static _Parse(parsedPostProcess, targetCamera, scene, rootUrl) {
        return (0, $6Ho1L.SerializationHelper).Parse(()=>{
            return new $a681eba2c07adfde$export$359e1c0449dd3922(parsedPostProcess.name, parsedPostProcess.options, targetCamera, parsedPostProcess.renderTargetSamplingMode, scene.getEngine(), parsedPostProcess.reusable);
        }, parsedPostProcess, scene, rootUrl);
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $a681eba2c07adfde$export$359e1c0449dd3922.prototype, "degree", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.BlackAndWhitePostProcess", $a681eba2c07adfde$export$359e1c0449dd3922);

});
parcelRegister("40sdW", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $2ead0e2cf5d7a2ce$var$name = "blackAndWhitePixelShader";
const $2ead0e2cf5d7a2ce$var$shader = `varying vec2 vUV;uniform sampler2D textureSampler;uniform float degree;
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) 
{vec3 color=texture2D(textureSampler,vUV).rgb;float luminance=dot(color,vec3(0.3,0.59,0.11)); 
vec3 blackAndWhite=vec3(luminance,luminance,luminance);gl_FragColor=vec4(color-((color-blackAndWhite)*degree),1.0);}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$2ead0e2cf5d7a2ce$var$name] = $2ead0e2cf5d7a2ce$var$shader;
const $2ead0e2cf5d7a2ce$export$9b8ac358659e2081 = {
    name: $2ead0e2cf5d7a2ce$var$name,
    shader: $2ead0e2cf5d7a2ce$var$shader
};

});


parcelRegister("1PCeL", function(module, exports) {

$parcel$export(module.exports, "BloomEffect", () => $155836f3714eb912$export$1e2a1743038c77d5);

var $81KKS = parcelRequire("81KKS");

var $lY80x = parcelRequire("lY80x");

var $8zEq7 = parcelRequire("8zEq7");

var $7yuxL = parcelRequire("7yuxL");

var $ha1VO = parcelRequire("ha1VO");

var $j2mX5 = parcelRequire("j2mX5");
class $155836f3714eb912$export$1e2a1743038c77d5 extends (0, $81KKS.PostProcessRenderEffect) {
    /**
     * The luminance threshold to find bright areas of the image to bloom.
     */ get threshold() {
        return this._downscale.threshold;
    }
    set threshold(value) {
        this._downscale.threshold = value;
    }
    /**
     * The strength of the bloom.
     */ get weight() {
        return this._merge.weight;
    }
    set weight(value) {
        this._merge.weight = value;
    }
    /**
     * Specifies the size of the bloom blur kernel, relative to the final output size
     */ get kernel() {
        return this._blurX.kernel / this._bloomScale;
    }
    set kernel(value) {
        this._blurX.kernel = value * this._bloomScale;
        this._blurY.kernel = value * this._bloomScale;
    }
    /**
     * Creates a new instance of @see BloomEffect
     * @param scene The scene the effect belongs to.
     * @param _bloomScale The ratio of the blur texture to the input texture that should be used to compute the bloom.
     * @param bloomWeight The strength of bloom.
     * @param bloomKernel The size of the kernel to be used when applying the blur.
     * @param pipelineTextureType The type of texture to be used when performing the post processing.
     * @param blockCompilation If compilation of the shader should not be done in the constructor. The updateEffect method can be used to compile the shader at a later time. (default: false)
     */ constructor(scene, _bloomScale, bloomWeight, bloomKernel, pipelineTextureType = 0, blockCompilation = false){
        super(scene.getEngine(), "bloom", ()=>{
            return this._effects;
        }, true);
        this._bloomScale = _bloomScale;
        /**
         * @internal Internal
         */ this._effects = [];
        this._downscale = new (0, $lY80x.ExtractHighlightsPostProcess)("highlights", 1.0, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, scene.getEngine(), false, pipelineTextureType, blockCompilation);
        this._blurX = new (0, $8zEq7.BlurPostProcess)("horizontal blur", new (0, $ha1VO.Vector2)(1.0, 0), 10.0, _bloomScale, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, scene.getEngine(), false, pipelineTextureType, undefined, blockCompilation);
        this._blurX.alwaysForcePOT = true;
        this._blurX.autoClear = false;
        this._blurY = new (0, $8zEq7.BlurPostProcess)("vertical blur", new (0, $ha1VO.Vector2)(0, 1.0), 10.0, _bloomScale, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, scene.getEngine(), false, pipelineTextureType, undefined, blockCompilation);
        this._blurY.alwaysForcePOT = true;
        this._blurY.autoClear = false;
        this.kernel = bloomKernel;
        this._effects = [
            this._downscale,
            this._blurX,
            this._blurY
        ];
        this._merge = new (0, $7yuxL.BloomMergePostProcess)("bloomMerge", this._downscale, this._blurY, bloomWeight, _bloomScale, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, scene.getEngine(), false, pipelineTextureType, blockCompilation);
        this._merge.autoClear = false;
        this._effects.push(this._merge);
    }
    /**
     * Disposes each of the internal effects for a given camera.
     * @param camera The camera to dispose the effect on.
     */ disposeEffects(camera) {
        for(let effectIndex = 0; effectIndex < this._effects.length; effectIndex++)this._effects[effectIndex].dispose(camera);
    }
    /**
     * @internal Internal
     */ _updateEffects() {
        for(let effectIndex = 0; effectIndex < this._effects.length; effectIndex++)this._effects[effectIndex].updateEffect();
    }
    /**
     * Internal
     * @returns if all the contained post processes are ready.
     * @internal
     */ _isReady() {
        for(let effectIndex = 0; effectIndex < this._effects.length; effectIndex++){
            if (!this._effects[effectIndex].isReady()) return false;
        }
        return true;
    }
}

});
parcelRegister("81KKS", function(module, exports) {

$parcel$export(module.exports, "PostProcessRenderEffect", () => $5d82af50f00ab6b8$export$bc9cd2f917fd899e);

var $bOhSV = parcelRequire("bOhSV");
class $5d82af50f00ab6b8$export$bc9cd2f917fd899e {
    /**
     * Instantiates a post process render effect.
     * A post process can be used to apply a shader to a texture after it is rendered.
     * @param engine The engine the effect is tied to
     * @param name The name of the effect
     * @param getPostProcesses A function that returns a set of post processes which the effect will run in order to be run.
     * @param singleInstance False if this post process can be run on multiple cameras. (default: true)
     */ constructor(engine, name, getPostProcesses, singleInstance){
        this._name = name;
        this._singleInstance = singleInstance || true;
        this._getPostProcesses = getPostProcesses;
        this._cameras = {};
        this._indicesForCamera = {};
        this._postProcesses = {};
    }
    /**
     * Checks if all the post processes in the effect are supported.
     */ get isSupported() {
        for(const index in this._postProcesses)if (Object.prototype.hasOwnProperty.call(this._postProcesses, index)) {
            const pps = this._postProcesses[index];
            for(let ppIndex = 0; ppIndex < pps.length; ppIndex++){
                if (!pps[ppIndex].isSupported) return false;
            }
        }
        return true;
    }
    /**
     * Updates the current state of the effect
     * @internal
     */ _update() {}
    /**
     * Attaches the effect on cameras
     * @param cameras The camera to attach to.
     * @internal
     */ _attachCameras(cameras) {
        let cameraKey;
        const cams = (0, $bOhSV.Tools).MakeArray(cameras || this._cameras);
        if (!cams) return;
        for(let i = 0; i < cams.length; i++){
            const camera = cams[i];
            if (!camera) continue;
            const cameraName = camera.name;
            if (this._singleInstance) cameraKey = 0;
            else cameraKey = cameraName;
            if (!this._postProcesses[cameraKey]) {
                const postProcess = this._getPostProcesses();
                if (postProcess) this._postProcesses[cameraKey] = Array.isArray(postProcess) ? postProcess : [
                    postProcess
                ];
            }
            if (!this._indicesForCamera[cameraName]) this._indicesForCamera[cameraName] = [];
            this._postProcesses[cameraKey].forEach((postProcess)=>{
                const index = camera.attachPostProcess(postProcess);
                this._indicesForCamera[cameraName].push(index);
            });
            if (!this._cameras[cameraName]) this._cameras[cameraName] = camera;
        }
    }
    /**
     * Detaches the effect on cameras
     * @param cameras The camera to detach from.
     * @internal
     */ _detachCameras(cameras) {
        const cams = (0, $bOhSV.Tools).MakeArray(cameras || this._cameras);
        if (!cams) return;
        for(let i = 0; i < cams.length; i++){
            const camera = cams[i];
            const cameraName = camera.name;
            const postProcesses = this._postProcesses[this._singleInstance ? 0 : cameraName];
            if (postProcesses) postProcesses.forEach((postProcess)=>{
                camera.detachPostProcess(postProcess);
            });
            if (this._cameras[cameraName]) this._cameras[cameraName] = null;
            delete this._indicesForCamera[cameraName];
        }
    }
    /**
     * Enables the effect on given cameras
     * @param cameras The camera to enable.
     * @internal
     */ _enable(cameras) {
        const cams = (0, $bOhSV.Tools).MakeArray(cameras || this._cameras);
        if (!cams) return;
        for(let i = 0; i < cams.length; i++){
            const camera = cams[i];
            const cameraName = camera.name;
            const cameraKey = this._singleInstance ? 0 : cameraName;
            for(let j = 0; j < this._indicesForCamera[cameraName].length; j++){
                const index = this._indicesForCamera[cameraName][j];
                const postProcess = camera._postProcesses[index];
                if (postProcess === undefined || postProcess === null) cams[i].attachPostProcess(this._postProcesses[cameraKey][j], index);
            }
        }
    }
    /**
     * Disables the effect on the given cameras
     * @param cameras The camera to disable.
     * @internal
     */ _disable(cameras) {
        const cams = (0, $bOhSV.Tools).MakeArray(cameras || this._cameras);
        if (!cams) return;
        for(let i = 0; i < cams.length; i++){
            const camera = cams[i];
            const cameraName = camera.name;
            this._postProcesses[this._singleInstance ? 0 : cameraName].forEach((postProcess)=>{
                camera.detachPostProcess(postProcess);
            });
        }
    }
    /**
     * Gets a list of the post processes contained in the effect.
     * @param camera The camera to get the post processes on.
     * @returns The list of the post processes in the effect.
     */ getPostProcesses(camera) {
        if (this._singleInstance) return this._postProcesses[0];
        else {
            if (!camera) return null;
            return this._postProcesses[camera.name];
        }
    }
}

});

parcelRegister("lY80x", function(module, exports) {

$parcel$export(module.exports, "ExtractHighlightsPostProcess", () => $ffe569b7dfde70f0$export$3aa467b01d7b5aa7);

var $e0Suo = parcelRequire("e0Suo");

var $cFdBb = parcelRequire("cFdBb");

var $53VPf = parcelRequire("53VPf");
parcelRequire("MtOc2");

var $ir0rz = parcelRequire("ir0rz");

var $8DoUR = parcelRequire("8DoUR");
class $ffe569b7dfde70f0$export$3aa467b01d7b5aa7 extends (0, $cFdBb.PostProcess) {
    /**
     * Gets a string identifying the name of the class
     * @returns "ExtractHighlightsPostProcess" string
     */ getClassName() {
        return "ExtractHighlightsPostProcess";
    }
    constructor(name, options, camera, samplingMode, engine, reusable, textureType = 0, blockCompilation = false){
        super(name, "extractHighlights", [
            "threshold",
            "exposure"
        ], null, options, camera, samplingMode, engine, reusable, null, textureType, undefined, null, blockCompilation);
        /**
         * The luminance threshold, pixels below this value will be set to black.
         */ this.threshold = 0.9;
        /** @internal */ this._exposure = 1;
        /**
         * Post process which has the input texture to be used when performing highlight extraction
         * @internal
         */ this._inputPostProcess = null;
        this.onApplyObservable.add((effect)=>{
            this.externalTextureSamplerBinding = !!this._inputPostProcess;
            if (this._inputPostProcess) effect.setTextureFromPostProcess("textureSampler", this._inputPostProcess);
            effect.setFloat("threshold", Math.pow(this.threshold, (0, $53VPf.ToGammaSpace)));
            effect.setFloat("exposure", this._exposure);
        });
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ffe569b7dfde70f0$export$3aa467b01d7b5aa7.prototype, "threshold", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.ExtractHighlightsPostProcess", $ffe569b7dfde70f0$export$3aa467b01d7b5aa7);

});
parcelRegister("MtOc2", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("7Hs3g");
const $091b9b2b7e915fa0$var$name = "extractHighlightsPixelShader";
const $091b9b2b7e915fa0$var$shader = `#include<helperFunctions>
varying vec2 vUV;uniform sampler2D textureSampler;uniform float threshold;uniform float exposure;
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) 
{gl_FragColor=texture2D(textureSampler,vUV);float luma=dot(LuminanceEncodeApprox,gl_FragColor.rgb*exposure);gl_FragColor.rgb=step(threshold,luma)*gl_FragColor.rgb;}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$091b9b2b7e915fa0$var$name] = $091b9b2b7e915fa0$var$shader;
const $091b9b2b7e915fa0$export$fd4b9637ad707262 = {
    name: $091b9b2b7e915fa0$var$name,
    shader: $091b9b2b7e915fa0$var$shader
};

});


parcelRegister("7yuxL", function(module, exports) {

$parcel$export(module.exports, "BloomMergePostProcess", () => $580366b3ee645e8f$export$3d0c62ebbb76f0d3);

var $e0Suo = parcelRequire("e0Suo");

var $cFdBb = parcelRequire("cFdBb");
parcelRequire("68BXS");

var $8DoUR = parcelRequire("8DoUR");

var $ir0rz = parcelRequire("ir0rz");
class $580366b3ee645e8f$export$3d0c62ebbb76f0d3 extends (0, $cFdBb.PostProcess) {
    /**
     * Gets a string identifying the name of the class
     * @returns "BloomMergePostProcess" string
     */ getClassName() {
        return "BloomMergePostProcess";
    }
    /**
     * Creates a new instance of @see BloomMergePostProcess
     * @param name The name of the effect.
     * @param originalFromInput Post process which's input will be used for the merge.
     * @param blurred Blurred highlights post process which's output will be used.
     * @param weight Weight of the bloom to be added to the original input.
     * @param options The required width/height ratio to downsize to before computing the render pass.
     * @param camera The camera to apply the render pass to.
     * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
     * @param engine The engine which the post process will be applied. (default: current engine)
     * @param reusable If the post process can be reused on the same frame. (default: false)
     * @param textureType Type of textures used when performing the post process. (default: 0)
     * @param blockCompilation If compilation of the shader should not be done in the constructor. The updateEffect method can be used to compile the shader at a later time. (default: false)
     */ constructor(name, originalFromInput, blurred, /** Weight of the bloom to be added to the original input. */ weight, options, camera, samplingMode, engine, reusable, textureType = 0, blockCompilation = false){
        super(name, "bloomMerge", [
            "bloomWeight"
        ], [
            "bloomBlur"
        ], options, camera, samplingMode, engine, reusable, null, textureType, undefined, null, true);
        /** Weight of the bloom to be added to the original input. */ this.weight = 1;
        this.weight = weight;
        this.externalTextureSamplerBinding = true;
        this.onApplyObservable.add((effect)=>{
            effect.setTextureFromPostProcess("textureSampler", originalFromInput);
            effect.setTextureFromPostProcessOutput("bloomBlur", blurred);
            effect.setFloat("bloomWeight", this.weight);
        });
        if (!blockCompilation) this.updateEffect();
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $580366b3ee645e8f$export$3d0c62ebbb76f0d3.prototype, "weight", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.BloomMergePostProcess", $580366b3ee645e8f$export$3d0c62ebbb76f0d3);

});
parcelRegister("68BXS", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $4780f07063d70d3a$var$name = "bloomMergePixelShader";
const $4780f07063d70d3a$var$shader = `uniform sampler2D textureSampler;uniform sampler2D bloomBlur;varying vec2 vUV;uniform float bloomWeight;
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{gl_FragColor=texture2D(textureSampler,vUV);vec3 blurred=texture2D(bloomBlur,vUV).rgb;gl_FragColor.rgb=gl_FragColor.rgb+(blurred.rgb*bloomWeight); }
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$4780f07063d70d3a$var$name] = $4780f07063d70d3a$var$shader;
const $4780f07063d70d3a$export$f7fc0e37372eae1b = {
    name: $4780f07063d70d3a$var$name,
    shader: $4780f07063d70d3a$var$shader
};

});



parcelRegister("cjhmh", function(module, exports) {

$parcel$export(module.exports, "ChromaticAberrationPostProcess", () => $8f64b96030f8dd63$export$868df32fbf6d7525);

var $e0Suo = parcelRequire("e0Suo");

var $ha1VO = parcelRequire("ha1VO");

var $cFdBb = parcelRequire("cFdBb");
parcelRequire("kTmJO");

var $8DoUR = parcelRequire("8DoUR");

var $ir0rz = parcelRequire("ir0rz");

var $6Ho1L = parcelRequire("6Ho1L");
class $8f64b96030f8dd63$export$868df32fbf6d7525 extends (0, $cFdBb.PostProcess) {
    /**
     * Gets a string identifying the name of the class
     * @returns "ChromaticAberrationPostProcess" string
     */ getClassName() {
        return "ChromaticAberrationPostProcess";
    }
    /**
     * Creates a new instance ChromaticAberrationPostProcess
     * @param name The name of the effect.
     * @param screenWidth The width of the screen to apply the effect on.
     * @param screenHeight The height of the screen to apply the effect on.
     * @param options The required width/height ratio to downsize to before computing the render pass.
     * @param camera The camera to apply the render pass to.
     * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
     * @param engine The engine which the post process will be applied. (default: current engine)
     * @param reusable If the post process can be reused on the same frame. (default: false)
     * @param textureType Type of textures used when performing the post process. (default: 0)
     * @param blockCompilation If compilation of the shader should not be done in the constructor. The updateEffect method can be used to compile the shader at a later time. (default: false)
     */ constructor(name, screenWidth, screenHeight, options, camera, samplingMode, engine, reusable, textureType = 0, blockCompilation = false){
        super(name, "chromaticAberration", [
            "chromatic_aberration",
            "screen_width",
            "screen_height",
            "direction",
            "radialIntensity",
            "centerPosition"
        ], [], options, camera, samplingMode, engine, reusable, null, textureType, undefined, null, blockCompilation);
        /**
         * The amount of separation of rgb channels (default: 30)
         */ this.aberrationAmount = 30;
        /**
         * The amount the effect will increase for pixels closer to the edge of the screen. (default: 0)
         */ this.radialIntensity = 0;
        /**
         * The normalized direction in which the rgb channels should be separated. If set to 0,0 radial direction will be used. (default: Vector2(0.707,0.707))
         */ this.direction = new (0, $ha1VO.Vector2)(0.707, 0.707);
        /**
         * The center position where the radialIntensity should be around. [0.5,0.5 is center of screen, 1,1 is top right corner] (default: Vector2(0.5 ,0.5))
         */ this.centerPosition = new (0, $ha1VO.Vector2)(0.5, 0.5);
        this.screenWidth = screenWidth;
        this.screenHeight = screenHeight;
        this.onApplyObservable.add((effect)=>{
            effect.setFloat("chromatic_aberration", this.aberrationAmount);
            effect.setFloat("screen_width", screenWidth);
            effect.setFloat("screen_height", screenHeight);
            effect.setFloat("radialIntensity", this.radialIntensity);
            effect.setFloat2("direction", this.direction.x, this.direction.y);
            effect.setFloat2("centerPosition", this.centerPosition.x, this.centerPosition.y);
        });
    }
    /**
     * @internal
     */ static _Parse(parsedPostProcess, targetCamera, scene, rootUrl) {
        return (0, $6Ho1L.SerializationHelper).Parse(()=>{
            return new $8f64b96030f8dd63$export$868df32fbf6d7525(parsedPostProcess.name, parsedPostProcess.screenWidth, parsedPostProcess.screenHeight, parsedPostProcess.options, targetCamera, parsedPostProcess.renderTargetSamplingMode, scene.getEngine(), parsedPostProcess.reusable, parsedPostProcess.textureType, false);
        }, parsedPostProcess, scene, rootUrl);
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $8f64b96030f8dd63$export$868df32fbf6d7525.prototype, "aberrationAmount", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $8f64b96030f8dd63$export$868df32fbf6d7525.prototype, "radialIntensity", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $8f64b96030f8dd63$export$868df32fbf6d7525.prototype, "direction", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $8f64b96030f8dd63$export$868df32fbf6d7525.prototype, "centerPosition", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $8f64b96030f8dd63$export$868df32fbf6d7525.prototype, "screenWidth", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $8f64b96030f8dd63$export$868df32fbf6d7525.prototype, "screenHeight", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.ChromaticAberrationPostProcess", $8f64b96030f8dd63$export$868df32fbf6d7525);

});
parcelRegister("kTmJO", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $f35a94f3b6554f2e$var$name = "chromaticAberrationPixelShader";
const $f35a94f3b6554f2e$var$shader = `uniform sampler2D textureSampler; 
uniform float chromatic_aberration;uniform float radialIntensity;uniform vec2 direction;uniform vec2 centerPosition;uniform float screen_width;uniform float screen_height;varying vec2 vUV;
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{vec2 centered_screen_pos=vec2(vUV.x-centerPosition.x,vUV.y-centerPosition.y);vec2 directionOfEffect=direction;if(directionOfEffect.x==0. && directionOfEffect.y==0.){directionOfEffect=normalize(centered_screen_pos);}
float radius2=centered_screen_pos.x*centered_screen_pos.x
+ centered_screen_pos.y*centered_screen_pos.y;float radius=sqrt(radius2);vec4 original=texture2D(textureSampler,vUV);vec3 ref_indices=vec3(-0.3,0.0,0.3);float ref_shiftX=chromatic_aberration*pow(radius,radialIntensity)*directionOfEffect.x/screen_width;float ref_shiftY=chromatic_aberration*pow(radius,radialIntensity)*directionOfEffect.y/screen_height;vec2 ref_coords_r=vec2(vUV.x+ref_indices.r*ref_shiftX,vUV.y+ref_indices.r*ref_shiftY*0.5);vec2 ref_coords_g=vec2(vUV.x+ref_indices.g*ref_shiftX,vUV.y+ref_indices.g*ref_shiftY*0.5);vec2 ref_coords_b=vec2(vUV.x+ref_indices.b*ref_shiftX,vUV.y+ref_indices.b*ref_shiftY*0.5);original.r=texture2D(textureSampler,ref_coords_r).r;original.g=texture2D(textureSampler,ref_coords_g).g;original.b=texture2D(textureSampler,ref_coords_b).b;original.a=clamp(texture2D(textureSampler,ref_coords_r).a+texture2D(textureSampler,ref_coords_g).a+texture2D(textureSampler,ref_coords_b).a,0.,1.);gl_FragColor=original;}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$f35a94f3b6554f2e$var$name] = $f35a94f3b6554f2e$var$shader;
const $f35a94f3b6554f2e$export$1091a38cef177f96 = {
    name: $f35a94f3b6554f2e$var$name,
    shader: $f35a94f3b6554f2e$var$shader
};

});


parcelRegister("1KBkM", function(module, exports) {

$parcel$export(module.exports, "CircleOfConfusionPostProcess", () => $14670c1e22cdb884$export$1dd54961fdfd65dc);

var $e0Suo = parcelRequire("e0Suo");

var $cFdBb = parcelRequire("cFdBb");

var $kVtWi = parcelRequire("kVtWi");
parcelRequire("lteJr");

var $8DoUR = parcelRequire("8DoUR");

var $ir0rz = parcelRequire("ir0rz");
class $14670c1e22cdb884$export$1dd54961fdfd65dc extends (0, $cFdBb.PostProcess) {
    /**
     * Gets a string identifying the name of the class
     * @returns "CircleOfConfusionPostProcess" string
     */ getClassName() {
        return "CircleOfConfusionPostProcess";
    }
    /**
     * Creates a new instance CircleOfConfusionPostProcess
     * @param name The name of the effect.
     * @param depthTexture The depth texture of the scene to compute the circle of confusion. This must be set in order for this to function but may be set after initialization if needed.
     * @param options The required width/height ratio to downsize to before computing the render pass.
     * @param camera The camera to apply the render pass to.
     * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
     * @param engine The engine which the post process will be applied. (default: current engine)
     * @param reusable If the post process can be reused on the same frame. (default: false)
     * @param textureType Type of textures used when performing the post process. (default: 0)
     * @param blockCompilation If compilation of the shader should not be done in the constructor. The updateEffect method can be used to compile the shader at a later time. (default: false)
     */ constructor(name, depthTexture, options, camera, samplingMode, engine, reusable, textureType = 0, blockCompilation = false){
        super(name, "circleOfConfusion", [
            "cameraMinMaxZ",
            "focusDistance",
            "cocPrecalculation"
        ], [
            "depthSampler"
        ], options, camera, samplingMode, engine, reusable, null, textureType, undefined, null, blockCompilation);
        /**
         * Max lens size in scene units/1000 (eg. millimeter). Standard cameras are 50mm. (default: 50) The diameter of the resulting aperture can be computed by lensSize/fStop.
         */ this.lensSize = 50;
        /**
         * F-Stop of the effect's camera. The diameter of the resulting aperture can be computed by lensSize/fStop. (default: 1.4)
         */ this.fStop = 1.4;
        /**
         * Distance away from the camera to focus on in scene units/1000 (eg. millimeter). (default: 2000)
         */ this.focusDistance = 2000;
        /**
         * Focal length of the effect's camera in scene units/1000 (eg. millimeter). (default: 50)
         */ this.focalLength = 50;
        this._depthTexture = null;
        this._depthTexture = depthTexture;
        this.onApplyObservable.add((effect)=>{
            if (!this._depthTexture) {
                (0, $kVtWi.Logger).Warn("No depth texture set on CircleOfConfusionPostProcess");
                return;
            }
            effect.setTexture("depthSampler", this._depthTexture);
            // Circle of confusion calculation, See https://developer.nvidia.com/gpugems/GPUGems/gpugems_ch23.html
            const aperture = this.lensSize / this.fStop;
            const cocPrecalculation = aperture * this.focalLength / (this.focusDistance - this.focalLength); // * ((this.focusDistance - pixelDistance)/pixelDistance) [This part is done in shader]
            effect.setFloat("focusDistance", this.focusDistance);
            effect.setFloat("cocPrecalculation", cocPrecalculation);
            const activeCamera = this._depthTexture.activeCamera;
            effect.setFloat2("cameraMinMaxZ", activeCamera.minZ, activeCamera.maxZ - activeCamera.minZ);
        });
    }
    /**
     * Depth texture to be used to compute the circle of confusion. This must be set here or in the constructor in order for the post process to function.
     */ set depthTexture(value) {
        this._depthTexture = value;
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $14670c1e22cdb884$export$1dd54961fdfd65dc.prototype, "lensSize", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $14670c1e22cdb884$export$1dd54961fdfd65dc.prototype, "fStop", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $14670c1e22cdb884$export$1dd54961fdfd65dc.prototype, "focusDistance", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $14670c1e22cdb884$export$1dd54961fdfd65dc.prototype, "focalLength", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.CircleOfConfusionPostProcess", $14670c1e22cdb884$export$1dd54961fdfd65dc);

});
parcelRegister("lteJr", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $fa17bbe2379a06e3$var$name = "circleOfConfusionPixelShader";
const $fa17bbe2379a06e3$var$shader = `uniform sampler2D depthSampler;varying vec2 vUV;uniform vec2 cameraMinMaxZ;uniform float focusDistance;uniform float cocPrecalculation;
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{float depth=texture2D(depthSampler,vUV).r;
#define CUSTOM_COC_DEPTH
float pixelDistance=(cameraMinMaxZ.x+cameraMinMaxZ.y*depth)*1000.0; 
#define CUSTOM_COC_PIXELDISTANCE
float coc=abs(cocPrecalculation*((focusDistance-pixelDistance)/pixelDistance));coc=clamp(coc,0.0,1.0);gl_FragColor=vec4(coc,coc,coc,1.0);}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$fa17bbe2379a06e3$var$name] = $fa17bbe2379a06e3$var$shader;
const $fa17bbe2379a06e3$export$7febffd31f59240d = {
    name: $fa17bbe2379a06e3$var$name,
    shader: $fa17bbe2379a06e3$var$shader
};

});


parcelRegister("chJE4", function(module, exports) {

$parcel$export(module.exports, "ColorCorrectionPostProcess", () => $8f1a7ac91ec4a8e3$export$e02dde734ab55e86);

var $e0Suo = parcelRequire("e0Suo");

var $cFdBb = parcelRequire("cFdBb");

var $j2mX5 = parcelRequire("j2mX5");
parcelRequire("glluM");

var $8DoUR = parcelRequire("8DoUR");

var $ir0rz = parcelRequire("ir0rz");

var $6Ho1L = parcelRequire("6Ho1L");
class $8f1a7ac91ec4a8e3$export$e02dde734ab55e86 extends (0, $cFdBb.PostProcess) {
    /**
     * Gets a string identifying the name of the class
     * @returns "ColorCorrectionPostProcess" string
     */ getClassName() {
        return "ColorCorrectionPostProcess";
    }
    constructor(name, colorTableUrl, options, camera, samplingMode, engine, reusable){
        super(name, "colorCorrection", null, [
            "colorTable"
        ], options, camera, samplingMode, engine, reusable);
        const scene = camera?.getScene() || null;
        this._colorTableTexture = new (0, $j2mX5.Texture)(colorTableUrl, scene, true, false, (0, $j2mX5.Texture).TRILINEAR_SAMPLINGMODE);
        this._colorTableTexture.anisotropicFilteringLevel = 1;
        this._colorTableTexture.wrapU = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        this._colorTableTexture.wrapV = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        this.colorTableUrl = colorTableUrl;
        this.onApply = (effect)=>{
            effect.setTexture("colorTable", this._colorTableTexture);
        };
    }
    /**
     * @internal
     */ static _Parse(parsedPostProcess, targetCamera, scene, rootUrl) {
        return (0, $6Ho1L.SerializationHelper).Parse(()=>{
            return new $8f1a7ac91ec4a8e3$export$e02dde734ab55e86(parsedPostProcess.name, parsedPostProcess.colorTableUrl, parsedPostProcess.options, targetCamera, parsedPostProcess.renderTargetSamplingMode, scene.getEngine(), parsedPostProcess.reusable);
        }, parsedPostProcess, scene, rootUrl);
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $8f1a7ac91ec4a8e3$export$e02dde734ab55e86.prototype, "colorTableUrl", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.ColorCorrectionPostProcess", $8f1a7ac91ec4a8e3$export$e02dde734ab55e86);

});
parcelRegister("glluM", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $be5f48121cee0f2b$var$name = "colorCorrectionPixelShader";
const $be5f48121cee0f2b$var$shader = `uniform sampler2D textureSampler; 
uniform sampler2D colorTable; 
varying vec2 vUV;const float SLICE_COUNT=16.0; 
vec4 sampleAs3DTexture(sampler2D textureSampler,vec3 uv,float width) {float sliceSize=1.0/width; 
float slicePixelSize=sliceSize/width; 
float sliceInnerSize=slicePixelSize*(width-1.0); 
float zSlice0=min(floor(uv.z*width),width-1.0);float zSlice1=min(zSlice0+1.0,width-1.0);float xOffset=slicePixelSize*0.5+uv.x*sliceInnerSize;float s0=xOffset+(zSlice0*sliceSize);float s1=xOffset+(zSlice1*sliceSize);vec4 slice0Color=texture2D(textureSampler,vec2(s0,uv.y));vec4 slice1Color=texture2D(textureSampler,vec2(s1,uv.y));float zOffset=mod(uv.z*width,1.0);vec4 result=mix(slice0Color,slice1Color,zOffset);return result;}
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{vec4 screen_color=texture2D(textureSampler,vUV);gl_FragColor=sampleAs3DTexture(colorTable,screen_color.rgb,SLICE_COUNT);}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$be5f48121cee0f2b$var$name] = $be5f48121cee0f2b$var$shader;
const $be5f48121cee0f2b$export$5556efe64639efdb = {
    name: $be5f48121cee0f2b$var$name,
    shader: $be5f48121cee0f2b$var$shader
};

});


parcelRegister("3z4Sb", function(module, exports) {

$parcel$export(module.exports, "ConvolutionPostProcess", () => $29886ba77400ae5e$export$e58ff3368620a38b);

var $e0Suo = parcelRequire("e0Suo");

var $cFdBb = parcelRequire("cFdBb");
parcelRequire("ePoQB");

var $8DoUR = parcelRequire("8DoUR");

var $ir0rz = parcelRequire("ir0rz");

var $6Ho1L = parcelRequire("6Ho1L");
class $29886ba77400ae5e$export$e58ff3368620a38b extends (0, $cFdBb.PostProcess) {
    /**
     * Gets a string identifying the name of the class
     * @returns "ConvolutionPostProcess" string
     */ getClassName() {
        return "ConvolutionPostProcess";
    }
    /**
     * Creates a new instance ConvolutionPostProcess
     * @param name The name of the effect.
     * @param kernel Array of 9 values corresponding to the 3x3 kernel to be applied
     * @param options The required width/height ratio to downsize to before computing the render pass.
     * @param camera The camera to apply the render pass to.
     * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
     * @param engine The engine which the post process will be applied. (default: current engine)
     * @param reusable If the post process can be reused on the same frame. (default: false)
     * @param textureType Type of textures used when performing the post process. (default: 0)
     */ constructor(name, kernel, options, camera, samplingMode, engine, reusable, textureType = 0){
        super(name, "convolution", [
            "kernel",
            "screenSize"
        ], null, options, camera, samplingMode, engine, reusable, null, textureType);
        this.kernel = kernel;
        this.onApply = (effect)=>{
            effect.setFloat2("screenSize", this.width, this.height);
            effect.setArray("kernel", this.kernel);
        };
    }
    /**
     * @internal
     */ static _Parse(parsedPostProcess, targetCamera, scene, rootUrl) {
        return (0, $6Ho1L.SerializationHelper).Parse(()=>{
            return new $29886ba77400ae5e$export$e58ff3368620a38b(parsedPostProcess.name, parsedPostProcess.kernel, parsedPostProcess.options, targetCamera, parsedPostProcess.renderTargetSamplingMode, scene.getEngine(), parsedPostProcess.reusable, parsedPostProcess.textureType);
        }, parsedPostProcess, scene, rootUrl);
    }
}
// Statics
/**
 * Edge detection 0 see https://en.wikipedia.org/wiki/Kernel_(image_processing)
 */ $29886ba77400ae5e$export$e58ff3368620a38b.EdgeDetect0Kernel = [
    1,
    0,
    -1,
    0,
    0,
    0,
    -1,
    0,
    1
];
/**
 * Edge detection 1 see https://en.wikipedia.org/wiki/Kernel_(image_processing)
 */ $29886ba77400ae5e$export$e58ff3368620a38b.EdgeDetect1Kernel = [
    0,
    1,
    0,
    1,
    -4,
    1,
    0,
    1,
    0
];
/**
 * Edge detection 2 see https://en.wikipedia.org/wiki/Kernel_(image_processing)
 */ $29886ba77400ae5e$export$e58ff3368620a38b.EdgeDetect2Kernel = [
    -1,
    -1,
    -1,
    -1,
    8,
    -1,
    -1,
    -1,
    -1
];
/**
 * Kernel to sharpen an image see https://en.wikipedia.org/wiki/Kernel_(image_processing)
 */ $29886ba77400ae5e$export$e58ff3368620a38b.SharpenKernel = [
    0,
    -1,
    0,
    -1,
    5,
    -1,
    0,
    -1,
    0
];
/**
 * Kernel to emboss an image see https://en.wikipedia.org/wiki/Kernel_(image_processing)
 */ $29886ba77400ae5e$export$e58ff3368620a38b.EmbossKernel = [
    -2,
    -1,
    0,
    -1,
    1,
    1,
    0,
    1,
    2
];
/**
 * Kernel to blur an image see https://en.wikipedia.org/wiki/Kernel_(image_processing)
 */ $29886ba77400ae5e$export$e58ff3368620a38b.GaussianKernel = [
    0,
    1,
    0,
    1,
    1,
    1,
    0,
    1,
    0
];
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $29886ba77400ae5e$export$e58ff3368620a38b.prototype, "kernel", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.ConvolutionPostProcess", $29886ba77400ae5e$export$e58ff3368620a38b);

});
parcelRegister("ePoQB", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $acb91a4b9fe65b3e$var$name = "convolutionPixelShader";
const $acb91a4b9fe65b3e$var$shader = `varying vec2 vUV;uniform sampler2D textureSampler;uniform vec2 screenSize;uniform float kernel[9];
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{vec2 onePixel=vec2(1.0,1.0)/screenSize;vec4 colorSum =
texture2D(textureSampler,vUV+onePixel*vec2(-1,-1))*kernel[0] +
texture2D(textureSampler,vUV+onePixel*vec2(0,-1))*kernel[1] +
texture2D(textureSampler,vUV+onePixel*vec2(1,-1))*kernel[2] +
texture2D(textureSampler,vUV+onePixel*vec2(-1,0))*kernel[3] +
texture2D(textureSampler,vUV+onePixel*vec2(0,0))*kernel[4] +
texture2D(textureSampler,vUV+onePixel*vec2(1,0))*kernel[5] +
texture2D(textureSampler,vUV+onePixel*vec2(-1,1))*kernel[6] +
texture2D(textureSampler,vUV+onePixel*vec2(0,1))*kernel[7] +
texture2D(textureSampler,vUV+onePixel*vec2(1,1))*kernel[8];float kernelWeight =
kernel[0] +
kernel[1] +
kernel[2] +
kernel[3] +
kernel[4] +
kernel[5] +
kernel[6] +
kernel[7] +
kernel[8];if (kernelWeight<=0.0) {kernelWeight=1.0;}
gl_FragColor=vec4((colorSum/kernelWeight).rgb,1);}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$acb91a4b9fe65b3e$var$name] = $acb91a4b9fe65b3e$var$shader;
const $acb91a4b9fe65b3e$export$c8b961f71adb74a6 = {
    name: $acb91a4b9fe65b3e$var$name,
    shader: $acb91a4b9fe65b3e$var$shader
};

});


parcelRegister("3rRRb", function(module, exports) {

$parcel$export(module.exports, "DepthOfFieldBlurPostProcess", () => $282dab8e8d11c44e$export$c85d361293835e5c);

var $e0Suo = parcelRequire("e0Suo");

var $j2mX5 = parcelRequire("j2mX5");

var $8zEq7 = parcelRequire("8zEq7");

var $8DoUR = parcelRequire("8DoUR");

var $ir0rz = parcelRequire("ir0rz");
class $282dab8e8d11c44e$export$c85d361293835e5c extends (0, $8zEq7.BlurPostProcess) {
    /**
     * Gets a string identifying the name of the class
     * @returns "DepthOfFieldBlurPostProcess" string
     */ getClassName() {
        return "DepthOfFieldBlurPostProcess";
    }
    /**
     * Creates a new instance DepthOfFieldBlurPostProcess
     * @param name The name of the effect.
     * @param scene The scene the effect belongs to.
     * @param direction The direction the blur should be applied.
     * @param kernel The size of the kernel used to blur.
     * @param options The required width/height ratio to downsize to before computing the render pass.
     * @param camera The camera to apply the render pass to.
     * @param circleOfConfusion The circle of confusion + depth map to be used to avoid blurring across edges
     * @param imageToBlur The image to apply the blur to (default: Current rendered frame)
     * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
     * @param engine The engine which the post process will be applied. (default: current engine)
     * @param reusable If the post process can be reused on the same frame. (default: false)
     * @param textureType Type of textures used when performing the post process. (default: 0)
     * @param blockCompilation If compilation of the shader should not be done in the constructor. The updateEffect method can be used to compile the shader at a later time. (default: false)
     * @param textureFormat Format of textures used when performing the post process. (default: TEXTUREFORMAT_RGBA)
     */ constructor(name, scene, direction, kernel, options, camera, circleOfConfusion, imageToBlur = null, samplingMode = (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, engine, reusable, textureType = 0, blockCompilation = false, textureFormat = 5){
        super(name, direction, kernel, options, camera, // eslint-disable-next-line @typescript-eslint/no-unused-vars
        samplingMode = 2, engine, reusable, textureType, `#define DOF 1\n`, blockCompilation, textureFormat);
        this.direction = direction;
        this.externalTextureSamplerBinding = !!imageToBlur;
        this.onApplyObservable.add((effect)=>{
            if (imageToBlur != null) effect.setTextureFromPostProcess("textureSampler", imageToBlur);
            effect.setTextureFromPostProcessOutput("circleOfConfusionSampler", circleOfConfusion);
        });
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $282dab8e8d11c44e$export$c85d361293835e5c.prototype, "direction", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.DepthOfFieldBlurPostProcess", $282dab8e8d11c44e$export$c85d361293835e5c);

});

parcelRegister("7Bej1", function(module, exports) {

$parcel$export(module.exports, "DepthOfFieldEffectBlurLevel", () => $588715f6763ae129$export$6999e319239b0455);
$parcel$export(module.exports, "DepthOfFieldEffect", () => $588715f6763ae129$export$a473b3aa72725315);

var $ha1VO = parcelRequire("ha1VO");

var $j2mX5 = parcelRequire("j2mX5");

var $81KKS = parcelRequire("81KKS");

var $1KBkM = parcelRequire("1KBkM");

var $3rRRb = parcelRequire("3rRRb");

var $g4LXT = parcelRequire("g4LXT");
var $588715f6763ae129$export$6999e319239b0455;
(function(DepthOfFieldEffectBlurLevel) {
    /**
     * Subtle blur
     */ DepthOfFieldEffectBlurLevel[DepthOfFieldEffectBlurLevel["Low"] = 0] = "Low";
    /**
     * Medium blur
     */ DepthOfFieldEffectBlurLevel[DepthOfFieldEffectBlurLevel["Medium"] = 1] = "Medium";
    /**
     * Large blur
     */ DepthOfFieldEffectBlurLevel[DepthOfFieldEffectBlurLevel["High"] = 2] = "High";
})($588715f6763ae129$export$6999e319239b0455 || ($588715f6763ae129$export$6999e319239b0455 = {}));
class $588715f6763ae129$export$a473b3aa72725315 extends (0, $81KKS.PostProcessRenderEffect) {
    /**
     * The focal the length of the camera used in the effect in scene units/1000 (eg. millimeter)
     */ set focalLength(value) {
        this._circleOfConfusion.focalLength = value;
    }
    get focalLength() {
        return this._circleOfConfusion.focalLength;
    }
    /**
     * F-Stop of the effect's camera. The diameter of the resulting aperture can be computed by lensSize/fStop. (default: 1.4)
     */ set fStop(value) {
        this._circleOfConfusion.fStop = value;
    }
    get fStop() {
        return this._circleOfConfusion.fStop;
    }
    /**
     * Distance away from the camera to focus on in scene units/1000 (eg. millimeter). (default: 2000)
     */ set focusDistance(value) {
        this._circleOfConfusion.focusDistance = value;
    }
    get focusDistance() {
        return this._circleOfConfusion.focusDistance;
    }
    /**
     * Max lens size in scene units/1000 (eg. millimeter). Standard cameras are 50mm. (default: 50) The diameter of the resulting aperture can be computed by lensSize/fStop.
     */ set lensSize(value) {
        this._circleOfConfusion.lensSize = value;
    }
    get lensSize() {
        return this._circleOfConfusion.lensSize;
    }
    /**
     * Creates a new instance DepthOfFieldEffect
     * @param scene The scene the effect belongs to.
     * @param depthTexture The depth texture of the scene to compute the circle of confusion.This must be set in order for this to function but may be set after initialization if needed.
     * @param blurLevel
     * @param pipelineTextureType The type of texture to be used when performing the post processing.
     * @param blockCompilation If compilation of the shader should not be done in the constructor. The updateEffect method can be used to compile the shader at a later time. (default: false)
     */ constructor(scene, depthTexture, blurLevel = $588715f6763ae129$export$6999e319239b0455.Low, pipelineTextureType = 0, blockCompilation = false){
        super(scene.getEngine(), "depth of field", ()=>{
            return this._effects;
        }, true);
        /**
         * @internal Internal post processes in depth of field effect
         */ this._effects = [];
        // Use R-only formats if supported to store the circle of confusion values.
        // This should be more space and bandwidth efficient than using RGBA.
        const engine = scene.getEngine();
        const circleOfConfusionTextureFormat = engine.isWebGPU || engine.webGLVersion > 1 ? 6 : 5;
        // Circle of confusion value for each pixel is used to determine how much to blur that pixel
        this._circleOfConfusion = new (0, $1KBkM.CircleOfConfusionPostProcess)("circleOfConfusion", depthTexture, 1, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, engine, false, pipelineTextureType, blockCompilation);
        // Create a pyramid of blurred images (eg. fullSize 1/4 blur, half size 1/2 blur, quarter size 3/4 blur, eith size 4/4 blur)
        // Blur the image but do not blur on sharp far to near distance changes to avoid bleeding artifacts
        // See section 2.6.2 http://fileadmin.cs.lth.se/cs/education/edan35/lectures/12dof.pdf
        this._depthOfFieldBlurY = [];
        this._depthOfFieldBlurX = [];
        let blurCount = 1;
        let kernelSize = 15;
        switch(blurLevel){
            case $588715f6763ae129$export$6999e319239b0455.High:
                blurCount = 3;
                kernelSize = 51;
                break;
            case $588715f6763ae129$export$6999e319239b0455.Medium:
                blurCount = 2;
                kernelSize = 31;
                break;
            default:
                kernelSize = 15;
                blurCount = 1;
                break;
        }
        const adjustedKernelSize = kernelSize / Math.pow(2, blurCount - 1);
        let ratio = 1.0;
        for(let i = 0; i < blurCount; i++){
            const blurY = new (0, $3rRRb.DepthOfFieldBlurPostProcess)("vertical blur", scene, new (0, $ha1VO.Vector2)(0, 1.0), adjustedKernelSize, ratio, null, this._circleOfConfusion, i == 0 ? this._circleOfConfusion : null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, engine, false, pipelineTextureType, blockCompilation, i == 0 ? circleOfConfusionTextureFormat : 5);
            blurY.autoClear = false;
            ratio = 0.75 / Math.pow(2, i);
            const blurX = new (0, $3rRRb.DepthOfFieldBlurPostProcess)("horizontal blur", scene, new (0, $ha1VO.Vector2)(1.0, 0), adjustedKernelSize, ratio, null, this._circleOfConfusion, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, engine, false, pipelineTextureType, blockCompilation);
            blurX.autoClear = false;
            this._depthOfFieldBlurY.push(blurY);
            this._depthOfFieldBlurX.push(blurX);
        }
        // Set all post processes on the effect.
        this._effects = [
            this._circleOfConfusion
        ];
        for(let i = 0; i < this._depthOfFieldBlurX.length; i++){
            this._effects.push(this._depthOfFieldBlurY[i]);
            this._effects.push(this._depthOfFieldBlurX[i]);
        }
        // Merge blurred images with original image based on circleOfConfusion
        this._dofMerge = new (0, $g4LXT.DepthOfFieldMergePostProcess)("dofMerge", this._circleOfConfusion, this._circleOfConfusion, this._depthOfFieldBlurX, ratio, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, engine, false, pipelineTextureType, blockCompilation);
        this._dofMerge.autoClear = false;
        this._effects.push(this._dofMerge);
    }
    /**
     * Get the current class name of the current effect
     * @returns "DepthOfFieldEffect"
     */ getClassName() {
        return "DepthOfFieldEffect";
    }
    /**
     * Depth texture to be used to compute the circle of confusion. This must be set here or in the constructor in order for the post process to function.
     */ set depthTexture(value) {
        this._circleOfConfusion.depthTexture = value;
    }
    /**
     * Disposes each of the internal effects for a given camera.
     * @param camera The camera to dispose the effect on.
     */ disposeEffects(camera) {
        for(let effectIndex = 0; effectIndex < this._effects.length; effectIndex++)this._effects[effectIndex].dispose(camera);
    }
    /**
     * @internal Internal
     */ _updateEffects() {
        for(let effectIndex = 0; effectIndex < this._effects.length; effectIndex++)this._effects[effectIndex].updateEffect();
    }
    /**
     * Internal
     * @returns if all the contained post processes are ready.
     * @internal
     */ _isReady() {
        for(let effectIndex = 0; effectIndex < this._effects.length; effectIndex++){
            if (!this._effects[effectIndex].isReady()) return false;
        }
        return true;
    }
}

});
parcelRegister("g4LXT", function(module, exports) {

$parcel$export(module.exports, "DepthOfFieldMergePostProcess", () => $bb4239e5881a16b1$export$e714e5d3c28b39e1);

var $cFdBb = parcelRequire("cFdBb");
parcelRequire("8mu4t");
class $bb4239e5881a16b1$export$e714e5d3c28b39e1 extends (0, $cFdBb.PostProcess) {
    /**
     * Gets a string identifying the name of the class
     * @returns "DepthOfFieldMergePostProcess" string
     */ getClassName() {
        return "DepthOfFieldMergePostProcess";
    }
    /**
     * Creates a new instance of DepthOfFieldMergePostProcess
     * @param name The name of the effect.
     * @param originalFromInput Post process which's input will be used for the merge.
     * @param circleOfConfusion Circle of confusion post process which's output will be used to blur each pixel.
     * @param _blurSteps Blur post processes from low to high which will be mixed with the original image.
     * @param options The required width/height ratio to downsize to before computing the render pass.
     * @param camera The camera to apply the render pass to.
     * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
     * @param engine The engine which the post process will be applied. (default: current engine)
     * @param reusable If the post process can be reused on the same frame. (default: false)
     * @param textureType Type of textures used when performing the post process. (default: 0)
     * @param blockCompilation If compilation of the shader should not be done in the constructor. The updateEffect method can be used to compile the shader at a later time. (default: false)
     */ constructor(name, originalFromInput, circleOfConfusion, _blurSteps, options, camera, samplingMode, engine, reusable, textureType = 0, blockCompilation = false){
        super(name, "depthOfFieldMerge", [], [
            "circleOfConfusionSampler",
            "blurStep0",
            "blurStep1",
            "blurStep2"
        ], options, camera, samplingMode, engine, reusable, null, textureType, undefined, null, true);
        this._blurSteps = _blurSteps;
        this.externalTextureSamplerBinding = true;
        this.onApplyObservable.add((effect)=>{
            effect.setTextureFromPostProcess("textureSampler", originalFromInput);
            effect.setTextureFromPostProcessOutput("circleOfConfusionSampler", circleOfConfusion);
            _blurSteps.forEach((step, index)=>{
                effect.setTextureFromPostProcessOutput("blurStep" + (_blurSteps.length - index - 1), step);
            });
        });
        if (!blockCompilation) this.updateEffect();
    }
    /**
     * Updates the effect with the current post process compile time values and recompiles the shader.
     * @param defines Define statements that should be added at the beginning of the shader. (default: null)
     * @param uniforms Set of uniform variables that will be passed to the shader. (default: null)
     * @param samplers Set of Texture2D variables that will be passed to the shader. (default: null)
     * @param indexParameters The index parameters to be used for babylons include syntax "#include<kernelBlurVaryingDeclaration>[0..varyingCount]". (default: undefined) See usage in babylon.blurPostProcess.ts and kernelBlur.vertex.fx
     * @param onCompiled Called when the shader has been compiled.
     * @param onError Called if there is an error when compiling a shader.
     */ updateEffect(defines = null, uniforms = null, samplers = null, indexParameters, onCompiled, onError) {
        if (!defines) {
            defines = "";
            defines += "#define BLUR_LEVEL " + (this._blurSteps.length - 1) + "\n";
        }
        super.updateEffect(defines, uniforms, samplers, indexParameters, onCompiled, onError);
    }
}

});
parcelRegister("8mu4t", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $6167b44a241b2684$var$name = "depthOfFieldMergePixelShader";
const $6167b44a241b2684$var$shader = `#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
#define TEXTUREFUNC(s,c,lod) texture2DLodEXT(s,c,lod)
#else
#define TEXTUREFUNC(s,c,bias) texture2D(s,c,bias)
#endif
uniform sampler2D textureSampler;varying vec2 vUV;uniform sampler2D circleOfConfusionSampler;uniform sampler2D blurStep0;
#if BLUR_LEVEL>0
uniform sampler2D blurStep1;
#endif
#if BLUR_LEVEL>1
uniform sampler2D blurStep2;
#endif
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{float coc=TEXTUREFUNC(circleOfConfusionSampler,vUV,0.0).r;
#if BLUR_LEVEL==0
vec4 original=TEXTUREFUNC(textureSampler,vUV,0.0);vec4 blurred0=TEXTUREFUNC(blurStep0,vUV,0.0);gl_FragColor=mix(original,blurred0,coc);
#endif
#if BLUR_LEVEL==1
if(coc<0.5){vec4 original=TEXTUREFUNC(textureSampler,vUV,0.0);vec4 blurred1=TEXTUREFUNC(blurStep1,vUV,0.0);gl_FragColor=mix(original,blurred1,coc/0.5);}else{vec4 blurred0=TEXTUREFUNC(blurStep0,vUV,0.0);vec4 blurred1=TEXTUREFUNC(blurStep1,vUV,0.0);gl_FragColor=mix(blurred1,blurred0,(coc-0.5)/0.5);}
#endif
#if BLUR_LEVEL==2
if(coc<0.33){vec4 original=TEXTUREFUNC(textureSampler,vUV,0.0);vec4 blurred2=TEXTUREFUNC(blurStep2,vUV,0.0);gl_FragColor=mix(original,blurred2,coc/0.33);}else if(coc<0.66){vec4 blurred1=TEXTUREFUNC(blurStep1,vUV,0.0);vec4 blurred2=TEXTUREFUNC(blurStep2,vUV,0.0);gl_FragColor=mix(blurred2,blurred1,(coc-0.33)/0.33);}else{vec4 blurred0=TEXTUREFUNC(blurStep0,vUV,0.0);vec4 blurred1=TEXTUREFUNC(blurStep1,vUV,0.0);gl_FragColor=mix(blurred1,blurred0,(coc-0.66)/0.34);}
#endif
}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$6167b44a241b2684$var$name] = $6167b44a241b2684$var$shader;
const $6167b44a241b2684$export$7e5bfe8d2a67c82b = {
    name: $6167b44a241b2684$var$name,
    shader: $6167b44a241b2684$var$shader
};

});



parcelRegister("4HTpT", function(module, exports) {

$parcel$export(module.exports, "DisplayPassPostProcess", () => $36d62a3013c89025$export$91fc3181cf63b752);

var $cFdBb = parcelRequire("cFdBb");
parcelRequire("jI3hU");

var $8DoUR = parcelRequire("8DoUR");

var $6Ho1L = parcelRequire("6Ho1L");
class $36d62a3013c89025$export$91fc3181cf63b752 extends (0, $cFdBb.PostProcess) {
    /**
     * Gets a string identifying the name of the class
     * @returns "DisplayPassPostProcess" string
     */ getClassName() {
        return "DisplayPassPostProcess";
    }
    /**
     * Creates the DisplayPassPostProcess
     * @param name The name of the effect.
     * @param options The required width/height ratio to downsize to before computing the render pass.
     * @param camera The camera to apply the render pass to.
     * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
     * @param engine The engine which the post process will be applied. (default: current engine)
     * @param reusable If the post process can be reused on the same frame. (default: false)
     */ constructor(name, options, camera, samplingMode, engine, reusable){
        super(name, "displayPass", [
            "passSampler"
        ], [
            "passSampler"
        ], options, camera, samplingMode, engine, reusable);
    }
    /**
     * @internal
     */ static _Parse(parsedPostProcess, targetCamera, scene, rootUrl) {
        return (0, $6Ho1L.SerializationHelper).Parse(()=>{
            return new $36d62a3013c89025$export$91fc3181cf63b752(parsedPostProcess.name, parsedPostProcess.options, targetCamera, parsedPostProcess.renderTargetSamplingMode, scene.getEngine(), parsedPostProcess.reusable);
        }, parsedPostProcess, scene, rootUrl);
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.DisplayPassPostProcess", $36d62a3013c89025$export$91fc3181cf63b752);

});
parcelRegister("jI3hU", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $e594ad4e960e7e07$var$name = "displayPassPixelShader";
const $e594ad4e960e7e07$var$shader = `varying vec2 vUV;uniform sampler2D textureSampler;uniform sampler2D passSampler;
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{gl_FragColor=texture2D(passSampler,vUV);}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$e594ad4e960e7e07$var$name] = $e594ad4e960e7e07$var$shader;
const $e594ad4e960e7e07$export$99d3b2934f4f06ef = {
    name: $e594ad4e960e7e07$var$name,
    shader: $e594ad4e960e7e07$var$shader
};

});


parcelRegister("cbylG", function(module, exports) {

$parcel$export(module.exports, "FilterPostProcess", () => $8df1280e1d2c94e9$export$7f79bc6e07acf936);

var $e0Suo = parcelRequire("e0Suo");

var $cFdBb = parcelRequire("cFdBb");
parcelRequire("eLGzf");

var $8DoUR = parcelRequire("8DoUR");

var $ir0rz = parcelRequire("ir0rz");

var $6Ho1L = parcelRequire("6Ho1L");
class $8df1280e1d2c94e9$export$7f79bc6e07acf936 extends (0, $cFdBb.PostProcess) {
    /**
     * Gets a string identifying the name of the class
     * @returns "FilterPostProcess" string
     */ getClassName() {
        return "FilterPostProcess";
    }
    /**
     *
     * @param name The name of the effect.
     * @param kernelMatrix The matrix to be applied to the image
     * @param options The required width/height ratio to downsize to before computing the render pass.
     * @param camera The camera to apply the render pass to.
     * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
     * @param engine The engine which the post process will be applied. (default: current engine)
     * @param reusable If the post process can be reused on the same frame. (default: false)
     */ constructor(name, kernelMatrix, options, camera, samplingMode, engine, reusable){
        super(name, "filter", [
            "kernelMatrix"
        ], null, options, camera, samplingMode, engine, reusable);
        this.kernelMatrix = kernelMatrix;
        this.onApply = (effect)=>{
            effect.setMatrix("kernelMatrix", this.kernelMatrix);
        };
    }
    /**
     * @internal
     */ static _Parse(parsedPostProcess, targetCamera, scene, rootUrl) {
        return (0, $6Ho1L.SerializationHelper).Parse(()=>{
            return new $8df1280e1d2c94e9$export$7f79bc6e07acf936(parsedPostProcess.name, parsedPostProcess.kernelMatrix, parsedPostProcess.options, targetCamera, parsedPostProcess.renderTargetSamplingMode, scene.getEngine(), parsedPostProcess.reusable);
        }, parsedPostProcess, scene, rootUrl);
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsMatrix)()
], $8df1280e1d2c94e9$export$7f79bc6e07acf936.prototype, "kernelMatrix", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.FilterPostProcess", $8df1280e1d2c94e9$export$7f79bc6e07acf936);

});
parcelRegister("eLGzf", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $ac06797bb5cde45d$var$name = "filterPixelShader";
const $ac06797bb5cde45d$var$shader = `varying vec2 vUV;uniform sampler2D textureSampler;uniform mat4 kernelMatrix;
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{vec3 baseColor=texture2D(textureSampler,vUV).rgb;vec3 updatedColor=(kernelMatrix*vec4(baseColor,1.0)).rgb;gl_FragColor=vec4(updatedColor,1.0);}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$ac06797bb5cde45d$var$name] = $ac06797bb5cde45d$var$shader;
const $ac06797bb5cde45d$export$162b8115448b730e = {
    name: $ac06797bb5cde45d$var$name,
    shader: $ac06797bb5cde45d$var$shader
};

});


parcelRegister("40XEW", function(module, exports) {

$parcel$export(module.exports, "FxaaPostProcess", () => $2ec5709c0d7518b7$export$6fa78e0be6fc7d17);

var $j2mX5 = parcelRequire("j2mX5");

var $cFdBb = parcelRequire("cFdBb");
parcelRequire("3Clcj");
parcelRequire("2UWnh");

var $8DoUR = parcelRequire("8DoUR");

var $6Ho1L = parcelRequire("6Ho1L");
class $2ec5709c0d7518b7$export$6fa78e0be6fc7d17 extends (0, $cFdBb.PostProcess) {
    /**
     * Gets a string identifying the name of the class
     * @returns "FxaaPostProcess" string
     */ getClassName() {
        return "FxaaPostProcess";
    }
    constructor(name, options, camera = null, samplingMode, engine, reusable, textureType = 0){
        super(name, "fxaa", [
            "texelSize"
        ], null, options, camera, samplingMode || (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, engine, reusable, null, textureType, "fxaa", undefined, true);
        const defines = this._getDefines();
        this.updateEffect(defines);
        this.onApplyObservable.add((effect)=>{
            const texelSize = this.texelSize;
            effect.setFloat2("texelSize", texelSize.x, texelSize.y);
        });
    }
    _getDefines() {
        const engine = this.getEngine();
        if (!engine) return null;
        const glInfo = engine.getGlInfo();
        if (glInfo && glInfo.renderer && glInfo.renderer.toLowerCase().indexOf("mali") > -1) return "#define MALI 1\n";
        return null;
    }
    /**
     * @internal
     */ static _Parse(parsedPostProcess, targetCamera, scene, rootUrl) {
        return (0, $6Ho1L.SerializationHelper).Parse(()=>{
            return new $2ec5709c0d7518b7$export$6fa78e0be6fc7d17(parsedPostProcess.name, parsedPostProcess.options, targetCamera, parsedPostProcess.renderTargetSamplingMode, scene.getEngine(), parsedPostProcess.reusable);
        }, parsedPostProcess, scene, rootUrl);
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.FxaaPostProcess", $2ec5709c0d7518b7$export$6fa78e0be6fc7d17);

});
parcelRegister("3Clcj", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $2a255d18d17646d1$var$name = "fxaaPixelShader";
const $2a255d18d17646d1$var$shader = `#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
#define TEXTUREFUNC(s,c,l) texture2DLodEXT(s,c,l)
#else
#define TEXTUREFUNC(s,c,b) texture2D(s,c,b)
#endif
uniform sampler2D textureSampler;uniform vec2 texelSize;varying vec2 vUV;varying vec2 sampleCoordS;varying vec2 sampleCoordE;varying vec2 sampleCoordN;varying vec2 sampleCoordW;varying vec2 sampleCoordNW;varying vec2 sampleCoordSE;varying vec2 sampleCoordNE;varying vec2 sampleCoordSW;const float fxaaQualitySubpix=1.0;const float fxaaQualityEdgeThreshold=0.166;const float fxaaQualityEdgeThresholdMin=0.0833;const vec3 kLumaCoefficients=vec3(0.2126,0.7152,0.0722);
#define FxaaLuma(rgba) dot(rgba.rgb,kLumaCoefficients)
void main(){vec2 posM;posM.x=vUV.x;posM.y=vUV.y;vec4 rgbyM=TEXTUREFUNC(textureSampler,vUV,0.0);float lumaM=FxaaLuma(rgbyM);float lumaS=FxaaLuma(TEXTUREFUNC(textureSampler,sampleCoordS,0.0));float lumaE=FxaaLuma(TEXTUREFUNC(textureSampler,sampleCoordE,0.0));float lumaN=FxaaLuma(TEXTUREFUNC(textureSampler,sampleCoordN,0.0));float lumaW=FxaaLuma(TEXTUREFUNC(textureSampler,sampleCoordW,0.0));float maxSM=max(lumaS,lumaM);float minSM=min(lumaS,lumaM);float maxESM=max(lumaE,maxSM);float minESM=min(lumaE,minSM);float maxWN=max(lumaN,lumaW);float minWN=min(lumaN,lumaW);float rangeMax=max(maxWN,maxESM);float rangeMin=min(minWN,minESM);float rangeMaxScaled=rangeMax*fxaaQualityEdgeThreshold;float range=rangeMax-rangeMin;float rangeMaxClamped=max(fxaaQualityEdgeThresholdMin,rangeMaxScaled);
#ifndef MALI
if(range<rangeMaxClamped) 
{gl_FragColor=rgbyM;return;}
#endif
float lumaNW=FxaaLuma(TEXTUREFUNC(textureSampler,sampleCoordNW,0.0));float lumaSE=FxaaLuma(TEXTUREFUNC(textureSampler,sampleCoordSE,0.0));float lumaNE=FxaaLuma(TEXTUREFUNC(textureSampler,sampleCoordNE,0.0));float lumaSW=FxaaLuma(TEXTUREFUNC(textureSampler,sampleCoordSW,0.0));float lumaNS=lumaN+lumaS;float lumaWE=lumaW+lumaE;float subpixRcpRange=1.0/range;float subpixNSWE=lumaNS+lumaWE;float edgeHorz1=(-2.0*lumaM)+lumaNS;float edgeVert1=(-2.0*lumaM)+lumaWE;float lumaNESE=lumaNE+lumaSE;float lumaNWNE=lumaNW+lumaNE;float edgeHorz2=(-2.0*lumaE)+lumaNESE;float edgeVert2=(-2.0*lumaN)+lumaNWNE;float lumaNWSW=lumaNW+lumaSW;float lumaSWSE=lumaSW+lumaSE;float edgeHorz4=(abs(edgeHorz1)*2.0)+abs(edgeHorz2);float edgeVert4=(abs(edgeVert1)*2.0)+abs(edgeVert2);float edgeHorz3=(-2.0*lumaW)+lumaNWSW;float edgeVert3=(-2.0*lumaS)+lumaSWSE;float edgeHorz=abs(edgeHorz3)+edgeHorz4;float edgeVert=abs(edgeVert3)+edgeVert4;float subpixNWSWNESE=lumaNWSW+lumaNESE;float lengthSign=texelSize.x;bool horzSpan=edgeHorz>=edgeVert;float subpixA=subpixNSWE*2.0+subpixNWSWNESE;if (!horzSpan)
{lumaN=lumaW;}
if (!horzSpan) 
{lumaS=lumaE;}
if (horzSpan) 
{lengthSign=texelSize.y;}
float subpixB=(subpixA*(1.0/12.0))-lumaM;float gradientN=lumaN-lumaM;float gradientS=lumaS-lumaM;float lumaNN=lumaN+lumaM;float lumaSS=lumaS+lumaM;bool pairN=abs(gradientN)>=abs(gradientS);float gradient=max(abs(gradientN),abs(gradientS));if (pairN)
{lengthSign=-lengthSign;}
float subpixC=clamp(abs(subpixB)*subpixRcpRange,0.0,1.0);vec2 posB;posB.x=posM.x;posB.y=posM.y;vec2 offNP;offNP.x=(!horzSpan) ? 0.0 : texelSize.x;offNP.y=(horzSpan) ? 0.0 : texelSize.y;if (!horzSpan) 
{posB.x+=lengthSign*0.5;}
if (horzSpan)
{posB.y+=lengthSign*0.5;}
vec2 posN;posN.x=posB.x-offNP.x*1.5;posN.y=posB.y-offNP.y*1.5;vec2 posP;posP.x=posB.x+offNP.x*1.5;posP.y=posB.y+offNP.y*1.5;float subpixD=((-2.0)*subpixC)+3.0;float lumaEndN=FxaaLuma(TEXTUREFUNC(textureSampler,posN,0.0));float subpixE=subpixC*subpixC;float lumaEndP=FxaaLuma(TEXTUREFUNC(textureSampler,posP,0.0));if (!pairN) 
{lumaNN=lumaSS;}
float gradientScaled=gradient*1.0/4.0;float lumaMM=lumaM-lumaNN*0.5;float subpixF=subpixD*subpixE;bool lumaMLTZero=lumaMM<0.0;lumaEndN-=lumaNN*0.5;lumaEndP-=lumaNN*0.5;bool doneN=abs(lumaEndN)>=gradientScaled;bool doneP=abs(lumaEndP)>=gradientScaled;if (!doneN) 
{posN.x-=offNP.x*3.0;}
if (!doneN) 
{posN.y-=offNP.y*3.0;}
bool doneNP=(!doneN) || (!doneP);if (!doneP) 
{posP.x+=offNP.x*3.0;}
if (!doneP)
{posP.y+=offNP.y*3.0;}
if (doneNP)
{if (!doneN) lumaEndN=FxaaLuma(TEXTUREFUNC(textureSampler,posN.xy,0.0));if (!doneP) lumaEndP=FxaaLuma(TEXTUREFUNC(textureSampler,posP.xy,0.0));if (!doneN) lumaEndN=lumaEndN-lumaNN*0.5;if (!doneP) lumaEndP=lumaEndP-lumaNN*0.5;doneN=abs(lumaEndN)>=gradientScaled;doneP=abs(lumaEndP)>=gradientScaled;if (!doneN) posN.x-=offNP.x*12.0;if (!doneN) posN.y-=offNP.y*12.0;doneNP=(!doneN) || (!doneP);if (!doneP) posP.x+=offNP.x*12.0;if (!doneP) posP.y+=offNP.y*12.0;}
float dstN=posM.x-posN.x;float dstP=posP.x-posM.x;if (!horzSpan)
{dstN=posM.y-posN.y;}
if (!horzSpan) 
{dstP=posP.y-posM.y;}
bool goodSpanN=(lumaEndN<0.0) != lumaMLTZero;float spanLength=(dstP+dstN);bool goodSpanP=(lumaEndP<0.0) != lumaMLTZero;float spanLengthRcp=1.0/spanLength;bool directionN=dstN<dstP;float dst=min(dstN,dstP);bool goodSpan=directionN ? goodSpanN : goodSpanP;float subpixG=subpixF*subpixF;float pixelOffset=(dst*(-spanLengthRcp))+0.5;float subpixH=subpixG*fxaaQualitySubpix;float pixelOffsetGood=goodSpan ? pixelOffset : 0.0;float pixelOffsetSubpix=max(pixelOffsetGood,subpixH);if (!horzSpan)
{posM.x+=pixelOffsetSubpix*lengthSign;}
if (horzSpan)
{posM.y+=pixelOffsetSubpix*lengthSign;}
#ifdef MALI
if(range<rangeMaxClamped) 
{gl_FragColor=rgbyM;}
else
{gl_FragColor=TEXTUREFUNC(textureSampler,posM,0.0);}
#else
gl_FragColor=TEXTUREFUNC(textureSampler,posM,0.0);
#endif
}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$2a255d18d17646d1$var$name] = $2a255d18d17646d1$var$shader;
const $2a255d18d17646d1$export$20884c81b859fa39 = {
    name: $2a255d18d17646d1$var$name,
    shader: $2a255d18d17646d1$var$shader
};

});

parcelRegister("2UWnh", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $21fe17ab81ec8fbe$var$name = "fxaaVertexShader";
const $21fe17ab81ec8fbe$var$shader = `attribute vec2 position;uniform vec2 texelSize;varying vec2 vUV;varying vec2 sampleCoordS;varying vec2 sampleCoordE;varying vec2 sampleCoordN;varying vec2 sampleCoordW;varying vec2 sampleCoordNW;varying vec2 sampleCoordSE;varying vec2 sampleCoordNE;varying vec2 sampleCoordSW;const vec2 madd=vec2(0.5,0.5);
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
vUV=(position*madd+madd);sampleCoordS=vUV+vec2( 0.0,1.0)*texelSize;sampleCoordE=vUV+vec2( 1.0,0.0)*texelSize;sampleCoordN=vUV+vec2( 0.0,-1.0)*texelSize;sampleCoordW=vUV+vec2(-1.0,0.0)*texelSize;sampleCoordNW=vUV+vec2(-1.0,-1.0)*texelSize;sampleCoordSE=vUV+vec2( 1.0,1.0)*texelSize;sampleCoordNE=vUV+vec2( 1.0,-1.0)*texelSize;sampleCoordSW=vUV+vec2(-1.0,1.0)*texelSize;gl_Position=vec4(position,0.0,1.0);
#define CUSTOM_VERTEX_MAIN_END
}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$21fe17ab81ec8fbe$var$name] = $21fe17ab81ec8fbe$var$shader;
const $21fe17ab81ec8fbe$export$a5ede28427563c6d = {
    name: $21fe17ab81ec8fbe$var$name,
    shader: $21fe17ab81ec8fbe$var$shader
};

});


parcelRegister("gd6JN", function(module, exports) {

$parcel$export(module.exports, "GrainPostProcess", () => $bcd316368535d775$export$d9c5e6dc917838);

var $e0Suo = parcelRequire("e0Suo");

var $cFdBb = parcelRequire("cFdBb");
parcelRequire("5SU87");

var $8DoUR = parcelRequire("8DoUR");

var $ir0rz = parcelRequire("ir0rz");

var $6Ho1L = parcelRequire("6Ho1L");
class $bcd316368535d775$export$d9c5e6dc917838 extends (0, $cFdBb.PostProcess) {
    /**
     * Gets a string identifying the name of the class
     * @returns "GrainPostProcess" string
     */ getClassName() {
        return "GrainPostProcess";
    }
    /**
     * Creates a new instance of @see GrainPostProcess
     * @param name The name of the effect.
     * @param options The required width/height ratio to downsize to before computing the render pass.
     * @param camera The camera to apply the render pass to.
     * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
     * @param engine The engine which the post process will be applied. (default: current engine)
     * @param reusable If the post process can be reused on the same frame. (default: false)
     * @param textureType Type of textures used when performing the post process. (default: 0)
     * @param blockCompilation If compilation of the shader should not be done in the constructor. The updateEffect method can be used to compile the shader at a later time. (default: false)
     */ constructor(name, options, camera, samplingMode, engine, reusable, textureType = 0, blockCompilation = false){
        super(name, "grain", [
            "intensity",
            "animatedSeed"
        ], [], options, camera, samplingMode, engine, reusable, null, textureType, undefined, null, blockCompilation);
        /**
         * The intensity of the grain added (default: 30)
         */ this.intensity = 30;
        /**
         * If the grain should be randomized on every frame
         */ this.animated = false;
        this.onApplyObservable.add((effect)=>{
            effect.setFloat("intensity", this.intensity);
            effect.setFloat("animatedSeed", this.animated ? Math.random() + 1 : 1);
        });
    }
    /**
     * @internal
     */ static _Parse(parsedPostProcess, targetCamera, scene, rootUrl) {
        return (0, $6Ho1L.SerializationHelper).Parse(()=>{
            return new $bcd316368535d775$export$d9c5e6dc917838(parsedPostProcess.name, parsedPostProcess.options, targetCamera, parsedPostProcess.renderTargetSamplingMode, scene.getEngine(), parsedPostProcess.reusable);
        }, parsedPostProcess, scene, rootUrl);
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $bcd316368535d775$export$d9c5e6dc917838.prototype, "intensity", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $bcd316368535d775$export$d9c5e6dc917838.prototype, "animated", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.GrainPostProcess", $bcd316368535d775$export$d9c5e6dc917838);

});
parcelRegister("5SU87", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("7Hs3g");
const $448d891c02305442$var$name = "grainPixelShader";
const $448d891c02305442$var$shader = `#include<helperFunctions>
uniform sampler2D textureSampler; 
uniform float intensity;uniform float animatedSeed;varying vec2 vUV;
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{gl_FragColor=texture2D(textureSampler,vUV);vec2 seed=vUV*(animatedSeed);float grain=dither(seed,intensity);float lum=getLuminance(gl_FragColor.rgb);float grainAmount=(cos(-PI+(lum*PI*2.))+1.)/2.;gl_FragColor.rgb+=grain*grainAmount;gl_FragColor.rgb=max(gl_FragColor.rgb,0.0);}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$448d891c02305442$var$name] = $448d891c02305442$var$shader;
const $448d891c02305442$export$366548140dc3f83c = {
    name: $448d891c02305442$var$name,
    shader: $448d891c02305442$var$shader
};

});


parcelRegister("aSulY", function(module, exports) {

$parcel$export(module.exports, "HighlightsPostProcess", () => $7eb67e1160bcecce$export$a62572cb7342c09e);

var $cFdBb = parcelRequire("cFdBb");
parcelRequire("4VkYR");
class $7eb67e1160bcecce$export$a62572cb7342c09e extends (0, $cFdBb.PostProcess) {
    /**
     * Gets a string identifying the name of the class
     * @returns "HighlightsPostProcess" string
     */ getClassName() {
        return "HighlightsPostProcess";
    }
    /**
     * Extracts highlights from the image
     * @see https://doc.babylonjs.com/features/featuresDeepDive/postProcesses/usePostProcesses
     * @param name The name of the effect.
     * @param options The required width/height ratio to downsize to before computing the render pass.
     * @param camera The camera to apply the render pass to.
     * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
     * @param engine The engine which the post process will be applied. (default: current engine)
     * @param reusable If the post process can be reused on the same frame. (default: false)
     * @param textureType Type of texture for the post process (default: Engine.TEXTURETYPE_UNSIGNED_INT)
     */ constructor(name, options, camera, samplingMode, engine, reusable, textureType = 0){
        super(name, "highlights", null, null, options, camera, samplingMode, engine, reusable, null, textureType);
    }
}

});
parcelRegister("4VkYR", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $395cc2976da24388$var$name = "highlightsPixelShader";
const $395cc2976da24388$var$shader = `varying vec2 vUV;uniform sampler2D textureSampler;const vec3 RGBLuminanceCoefficients=vec3(0.2126,0.7152,0.0722);
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) 
{vec4 tex=texture2D(textureSampler,vUV);vec3 c=tex.rgb;float luma=dot(c.rgb,RGBLuminanceCoefficients);gl_FragColor=vec4(pow(c,vec3(25.0-luma*15.0)),tex.a); }`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$395cc2976da24388$var$name] = $395cc2976da24388$var$shader;
const $395cc2976da24388$export$355ab91203b03908 = {
    name: $395cc2976da24388$var$name,
    shader: $395cc2976da24388$var$shader
};

});


parcelRegister("ecirA", function(module, exports) {

$parcel$export(module.exports, "ImageProcessingPostProcess", () => $a5607e3e77bdd809$export$bc751ed5a93e3d23);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $dG1pf = parcelRequire("dG1pf");

var $cFdBb = parcelRequire("cFdBb");

var $ejQPp = parcelRequire("ejQPp");
parcelRequire("7QfgW");
parcelRequire("cr88r");
class $a5607e3e77bdd809$export$bc751ed5a93e3d23 extends (0, $cFdBb.PostProcess) {
    /**
     * Gets the image processing configuration used either in this material.
     */ get imageProcessingConfiguration() {
        return this._imageProcessingConfiguration;
    }
    /**
     * Sets the Default image processing configuration used either in the this material.
     *
     * If sets to null, the scene one is in use.
     */ set imageProcessingConfiguration(value) {
        // We are almost sure it is applied by post process as
        // We are in the post process :-)
        value.applyByPostProcess = true;
        this._attachImageProcessingConfiguration(value);
    }
    /**
     * Attaches a new image processing configuration to the PBR Material.
     * @param configuration
     * @param doNotBuild
     */ _attachImageProcessingConfiguration(configuration, doNotBuild = false) {
        if (configuration === this._imageProcessingConfiguration) return;
        // Detaches observer.
        if (this._imageProcessingConfiguration && this._imageProcessingObserver) this._imageProcessingConfiguration.onUpdateParameters.remove(this._imageProcessingObserver);
        // Pick the scene configuration if needed.
        if (!configuration) {
            let scene = null;
            const engine = this.getEngine();
            const camera = this.getCamera();
            if (camera) scene = camera.getScene();
            else if (engine && engine.scenes) {
                const scenes = engine.scenes;
                scene = scenes[scenes.length - 1];
            } else scene = (0, $ejQPp.EngineStore).LastCreatedScene;
            if (scene) this._imageProcessingConfiguration = scene.imageProcessingConfiguration;
            else this._imageProcessingConfiguration = new (0, $dG1pf.ImageProcessingConfiguration)();
        } else this._imageProcessingConfiguration = configuration;
        // Attaches observer.
        if (this._imageProcessingConfiguration) this._imageProcessingObserver = this._imageProcessingConfiguration.onUpdateParameters.add(()=>{
            this._updateParameters();
        });
        // Ensure the effect will be rebuilt.
        if (!doNotBuild) this._updateParameters();
    }
    /**
     * If the post process is supported.
     */ get isSupported() {
        const effect = this.getEffect();
        return !effect || effect.isSupported;
    }
    /**
     * Gets Color curves setup used in the effect if colorCurvesEnabled is set to true .
     */ get colorCurves() {
        return this.imageProcessingConfiguration.colorCurves;
    }
    /**
     * Sets Color curves setup used in the effect if colorCurvesEnabled is set to true .
     */ set colorCurves(value) {
        this.imageProcessingConfiguration.colorCurves = value;
    }
    /**
     * Gets whether the color curves effect is enabled.
     */ get colorCurvesEnabled() {
        return this.imageProcessingConfiguration.colorCurvesEnabled;
    }
    /**
     * Sets whether the color curves effect is enabled.
     */ set colorCurvesEnabled(value) {
        this.imageProcessingConfiguration.colorCurvesEnabled = value;
    }
    /**
     * Gets Color grading LUT texture used in the effect if colorGradingEnabled is set to true.
     */ get colorGradingTexture() {
        return this.imageProcessingConfiguration.colorGradingTexture;
    }
    /**
     * Sets Color grading LUT texture used in the effect if colorGradingEnabled is set to true.
     */ set colorGradingTexture(value) {
        this.imageProcessingConfiguration.colorGradingTexture = value;
    }
    /**
     * Gets whether the color grading effect is enabled.
     */ get colorGradingEnabled() {
        return this.imageProcessingConfiguration.colorGradingEnabled;
    }
    /**
     * Gets whether the color grading effect is enabled.
     */ set colorGradingEnabled(value) {
        this.imageProcessingConfiguration.colorGradingEnabled = value;
    }
    /**
     * Gets exposure used in the effect.
     */ get exposure() {
        return this.imageProcessingConfiguration.exposure;
    }
    /**
     * Sets exposure used in the effect.
     */ set exposure(value) {
        this.imageProcessingConfiguration.exposure = value;
    }
    /**
     * Gets whether tonemapping is enabled or not.
     */ get toneMappingEnabled() {
        return this._imageProcessingConfiguration.toneMappingEnabled;
    }
    /**
     * Sets whether tonemapping is enabled or not
     */ set toneMappingEnabled(value) {
        this._imageProcessingConfiguration.toneMappingEnabled = value;
    }
    /**
     * Gets the type of tone mapping effect.
     */ get toneMappingType() {
        return this._imageProcessingConfiguration.toneMappingType;
    }
    /**
     * Sets the type of tone mapping effect.
     */ set toneMappingType(value) {
        this._imageProcessingConfiguration.toneMappingType = value;
    }
    /**
     * Gets contrast used in the effect.
     */ get contrast() {
        return this.imageProcessingConfiguration.contrast;
    }
    /**
     * Sets contrast used in the effect.
     */ set contrast(value) {
        this.imageProcessingConfiguration.contrast = value;
    }
    /**
     * Gets Vignette stretch size.
     */ get vignetteStretch() {
        return this.imageProcessingConfiguration.vignetteStretch;
    }
    /**
     * Sets Vignette stretch size.
     */ set vignetteStretch(value) {
        this.imageProcessingConfiguration.vignetteStretch = value;
    }
    /**
     * Gets Vignette center X Offset.
     * @deprecated use vignetteCenterX instead
     */ get vignetteCentreX() {
        return this.imageProcessingConfiguration.vignetteCenterX;
    }
    /**
     * Sets Vignette center X Offset.
     * @deprecated use vignetteCenterX instead
     */ set vignetteCentreX(value) {
        this.imageProcessingConfiguration.vignetteCenterX = value;
    }
    /**
     * Gets Vignette center Y Offset.
     * @deprecated use vignetteCenterY instead
     */ get vignetteCentreY() {
        return this.imageProcessingConfiguration.vignetteCenterY;
    }
    /**
     * Sets Vignette center Y Offset.
     * @deprecated use vignetteCenterY instead
     */ set vignetteCentreY(value) {
        this.imageProcessingConfiguration.vignetteCenterY = value;
    }
    /**
     * Vignette center Y Offset.
     */ get vignetteCenterY() {
        return this.imageProcessingConfiguration.vignetteCenterY;
    }
    set vignetteCenterY(value) {
        this.imageProcessingConfiguration.vignetteCenterY = value;
    }
    /**
     * Vignette center X Offset.
     */ get vignetteCenterX() {
        return this.imageProcessingConfiguration.vignetteCenterX;
    }
    set vignetteCenterX(value) {
        this.imageProcessingConfiguration.vignetteCenterX = value;
    }
    /**
     * Gets Vignette weight or intensity of the vignette effect.
     */ get vignetteWeight() {
        return this.imageProcessingConfiguration.vignetteWeight;
    }
    /**
     * Sets Vignette weight or intensity of the vignette effect.
     */ set vignetteWeight(value) {
        this.imageProcessingConfiguration.vignetteWeight = value;
    }
    /**
     * Gets Color of the vignette applied on the screen through the chosen blend mode (vignetteBlendMode)
     * if vignetteEnabled is set to true.
     */ get vignetteColor() {
        return this.imageProcessingConfiguration.vignetteColor;
    }
    /**
     * Sets Color of the vignette applied on the screen through the chosen blend mode (vignetteBlendMode)
     * if vignetteEnabled is set to true.
     */ set vignetteColor(value) {
        this.imageProcessingConfiguration.vignetteColor = value;
    }
    /**
     * Gets Camera field of view used by the Vignette effect.
     */ get vignetteCameraFov() {
        return this.imageProcessingConfiguration.vignetteCameraFov;
    }
    /**
     * Sets Camera field of view used by the Vignette effect.
     */ set vignetteCameraFov(value) {
        this.imageProcessingConfiguration.vignetteCameraFov = value;
    }
    /**
     * Gets the vignette blend mode allowing different kind of effect.
     */ get vignetteBlendMode() {
        return this.imageProcessingConfiguration.vignetteBlendMode;
    }
    /**
     * Sets the vignette blend mode allowing different kind of effect.
     */ set vignetteBlendMode(value) {
        this.imageProcessingConfiguration.vignetteBlendMode = value;
    }
    /**
     * Gets whether the vignette effect is enabled.
     */ get vignetteEnabled() {
        return this.imageProcessingConfiguration.vignetteEnabled;
    }
    /**
     * Sets whether the vignette effect is enabled.
     */ set vignetteEnabled(value) {
        this.imageProcessingConfiguration.vignetteEnabled = value;
    }
    /**
     * Gets intensity of the dithering effect.
     */ get ditheringIntensity() {
        return this.imageProcessingConfiguration.ditheringIntensity;
    }
    /**
     * Sets intensity of the dithering effect.
     */ set ditheringIntensity(value) {
        this.imageProcessingConfiguration.ditheringIntensity = value;
    }
    /**
     * Gets whether the dithering effect is enabled.
     */ get ditheringEnabled() {
        return this.imageProcessingConfiguration.ditheringEnabled;
    }
    /**
     * Sets whether the dithering effect is enabled.
     */ set ditheringEnabled(value) {
        this.imageProcessingConfiguration.ditheringEnabled = value;
    }
    /**
     * Gets whether the input of the processing is in Gamma or Linear Space.
     */ get fromLinearSpace() {
        return this._fromLinearSpace;
    }
    /**
     * Sets whether the input of the processing is in Gamma or Linear Space.
     */ set fromLinearSpace(value) {
        if (this._fromLinearSpace === value) return;
        this._fromLinearSpace = value;
        this._updateParameters();
    }
    constructor(name, options, camera = null, samplingMode, engine, reusable, textureType = 0, imageProcessingConfiguration){
        super(name, "imageProcessing", [], [], options, camera, samplingMode, engine, reusable, null, textureType, "postprocess", null, true);
        this._fromLinearSpace = true;
        /**
         * Defines cache preventing GC.
         */ this._defines = {
            IMAGEPROCESSING: false,
            VIGNETTE: false,
            VIGNETTEBLENDMODEMULTIPLY: false,
            VIGNETTEBLENDMODEOPAQUE: false,
            TONEMAPPING: false,
            TONEMAPPING_ACES: false,
            CONTRAST: false,
            COLORCURVES: false,
            COLORGRADING: false,
            COLORGRADING3D: false,
            FROMLINEARSPACE: false,
            SAMPLER3DGREENDEPTH: false,
            SAMPLER3DBGRMAP: false,
            DITHER: false,
            IMAGEPROCESSINGPOSTPROCESS: false,
            EXPOSURE: false,
            SKIPFINALCOLORCLAMP: false
        };
        // Setup the configuration as forced by the constructor. This would then not force the
        // scene materials output in linear space and let untouched the default forward pass.
        if (imageProcessingConfiguration) {
            imageProcessingConfiguration.applyByPostProcess = true;
            this._attachImageProcessingConfiguration(imageProcessingConfiguration, true);
            // This will cause the shader to be compiled
            this._updateParameters();
        } else {
            this._attachImageProcessingConfiguration(null, true);
            this.imageProcessingConfiguration.applyByPostProcess = true;
        }
        this.onApply = (effect)=>{
            this.imageProcessingConfiguration.bind(effect, this.aspectRatio);
        };
    }
    /**
     *  "ImageProcessingPostProcess"
     * @returns "ImageProcessingPostProcess"
     */ getClassName() {
        return "ImageProcessingPostProcess";
    }
    /**
     * @internal
     */ _updateParameters() {
        this._defines.FROMLINEARSPACE = this._fromLinearSpace;
        this.imageProcessingConfiguration.prepareDefines(this._defines, true);
        let defines = "";
        for(const define in this._defines)if (this._defines[define]) defines += `#define ${define};\n`;
        const samplers = [
            "textureSampler"
        ];
        const uniforms = [
            "scale"
        ];
        if (0, $dG1pf.ImageProcessingConfiguration) {
            (0, $dG1pf.ImageProcessingConfiguration).PrepareSamplers(samplers, this._defines);
            (0, $dG1pf.ImageProcessingConfiguration).PrepareUniforms(uniforms, this._defines);
        }
        this.updateEffect(defines, uniforms, samplers);
    }
    dispose(camera) {
        super.dispose(camera);
        if (this._imageProcessingConfiguration && this._imageProcessingObserver) this._imageProcessingConfiguration.onUpdateParameters.remove(this._imageProcessingObserver);
        if (this._imageProcessingConfiguration) this.imageProcessingConfiguration.applyByPostProcess = false;
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $a5607e3e77bdd809$export$bc751ed5a93e3d23.prototype, "_fromLinearSpace", void 0);

});
parcelRegister("7QfgW", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("jtwq6");
parcelRequire("7Hs3g");
parcelRequire("cRFSM");
const $5b593c7a4874aec5$var$name = "imageProcessingPixelShader";
const $5b593c7a4874aec5$var$shader = `varying vec2 vUV;uniform sampler2D textureSampler;
#include<imageProcessingDeclaration>
#include<helperFunctions>
#include<imageProcessingFunctions>
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{vec4 result=texture2D(textureSampler,vUV);
#ifdef IMAGEPROCESSING
#ifndef FROMLINEARSPACE
result.rgb=toLinearSpace(result.rgb);
#endif
result=applyImageProcessing(result);
#else
#ifdef FROMLINEARSPACE
result=applyImageProcessing(result);
#endif
#endif
gl_FragColor=result;}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$5b593c7a4874aec5$var$name] = $5b593c7a4874aec5$var$shader;
const $5b593c7a4874aec5$export$a9699ff04d0e6960 = {
    name: $5b593c7a4874aec5$var$name,
    shader: $5b593c7a4874aec5$var$shader
};

});


parcelRegister("Jb4JF", function(module, exports) {

$parcel$export(module.exports, "MotionBlurPostProcess", () => $087ccb6c95d43552$export$512056e66e9deaee);

var $e0Suo = parcelRequire("e0Suo");

var $kVtWi = parcelRequire("kVtWi");

var $ha1VO = parcelRequire("ha1VO");

var $cFdBb = parcelRequire("cFdBb");

var $gXqe5 = parcelRequire("gXqe5");

var $jFESd = parcelRequire("jFESd");
parcelRequire("aAGn3");
parcelRequire("cSqxf");
parcelRequire("2J7Zg");

var $ir0rz = parcelRequire("ir0rz");

var $6Ho1L = parcelRequire("6Ho1L");

var $8DoUR = parcelRequire("8DoUR");
class $087ccb6c95d43552$export$512056e66e9deaee extends (0, $cFdBb.PostProcess) {
    /**
     * Gets the number of iterations are used for motion blur quality. Default value is equal to 32
     */ get motionBlurSamples() {
        return this._motionBlurSamples;
    }
    /**
     * Sets the number of iterations to be used for motion blur quality
     */ set motionBlurSamples(samples) {
        this._motionBlurSamples = samples;
        this._updateEffect();
    }
    /**
     * Gets whether or not the motion blur post-process is in object based mode.
     */ get isObjectBased() {
        return this._isObjectBased;
    }
    /**
     * Sets whether or not the motion blur post-process is in object based mode.
     */ set isObjectBased(value) {
        if (this._isObjectBased === value) return;
        this._isObjectBased = value;
        this._applyMode();
    }
    get _geometryBufferRenderer() {
        if (!this._forceGeometryBuffer) return null;
        return this._scene.geometryBufferRenderer;
    }
    get _prePassRenderer() {
        if (this._forceGeometryBuffer) return null;
        return this._scene.prePassRenderer;
    }
    /**
     * Gets a string identifying the name of the class
     * @returns "MotionBlurPostProcess" string
     */ getClassName() {
        return "MotionBlurPostProcess";
    }
    /**
     * Creates a new instance MotionBlurPostProcess
     * @param name The name of the effect.
     * @param scene The scene containing the objects to blur according to their velocity.
     * @param options The required width/height ratio to downsize to before computing the render pass.
     * @param camera The camera to apply the render pass to.
     * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
     * @param engine The engine which the post process will be applied. (default: current engine)
     * @param reusable If the post process can be reused on the same frame. (default: false)
     * @param textureType Type of textures used when performing the post process. (default: 0)
     * @param blockCompilation If compilation of the shader should not be done in the constructor. The updateEffect method can be used to compile the shader at a later time. (default: true)
     * @param forceGeometryBuffer If this post process should use geometry buffer instead of prepass (default: false)
     */ constructor(name, scene, options, camera, samplingMode, engine, reusable, textureType = 0, blockCompilation = false, forceGeometryBuffer = false){
        super(name, "motionBlur", [
            "motionStrength",
            "motionScale",
            "screenSize",
            "inverseViewProjection",
            "prevViewProjection",
            "projection"
        ], [
            "velocitySampler",
            "depthSampler"
        ], options, camera, samplingMode, engine, reusable, "#define GEOMETRY_SUPPORTED\n#define SAMPLES 64.0\n#define OBJECT_BASED", textureType, undefined, null, blockCompilation);
        /**
         * Defines how much the image is blurred by the movement. Default value is equal to 1
         */ this.motionStrength = 1;
        this._motionBlurSamples = 32;
        this._isObjectBased = true;
        this._forceGeometryBuffer = false;
        this._invViewProjection = null;
        this._previousViewProjection = null;
        this._forceGeometryBuffer = forceGeometryBuffer;
        // Set up assets
        if (this._forceGeometryBuffer) {
            scene.enableGeometryBufferRenderer();
            if (this._geometryBufferRenderer) this._geometryBufferRenderer.enableVelocity = this._isObjectBased;
        } else {
            scene.enablePrePassRenderer();
            if (this._prePassRenderer) {
                this._prePassRenderer.markAsDirty();
                this._prePassEffectConfiguration = new (0, $jFESd.MotionBlurConfiguration)();
            }
        }
        this._applyMode();
    }
    /**
     * Excludes the given skinned mesh from computing bones velocities.
     * Computing bones velocities can have a cost and that cost. The cost can be saved by calling this function and by passing the skinned mesh reference to ignore.
     * @param skinnedMesh The mesh containing the skeleton to ignore when computing the velocity map.
     */ excludeSkinnedMesh(skinnedMesh) {
        if (skinnedMesh.skeleton) {
            let list;
            if (this._geometryBufferRenderer) list = this._geometryBufferRenderer.excludedSkinnedMeshesFromVelocity;
            else if (this._prePassRenderer) list = this._prePassRenderer.excludedSkinnedMesh;
            else return;
            list.push(skinnedMesh);
        }
    }
    /**
     * Removes the given skinned mesh from the excluded meshes to integrate bones velocities while rendering the velocity map.
     * @param skinnedMesh The mesh containing the skeleton that has been ignored previously.
     * @see excludeSkinnedMesh to exclude a skinned mesh from bones velocity computation.
     */ removeExcludedSkinnedMesh(skinnedMesh) {
        if (skinnedMesh.skeleton) {
            let list;
            if (this._geometryBufferRenderer) list = this._geometryBufferRenderer.excludedSkinnedMeshesFromVelocity;
            else if (this._prePassRenderer) list = this._prePassRenderer.excludedSkinnedMesh;
            else return;
            const index = list.indexOf(skinnedMesh);
            if (index !== -1) list.splice(index, 1);
        }
    }
    /**
     * Disposes the post process.
     * @param camera The camera to dispose the post process on.
     */ dispose(camera) {
        if (this._geometryBufferRenderer) {
            // Clear previous transformation matrices dictionary used to compute objects velocities
            this._geometryBufferRenderer._previousTransformationMatrices = {};
            this._geometryBufferRenderer._previousBonesTransformationMatrices = {};
            this._geometryBufferRenderer.excludedSkinnedMeshesFromVelocity = [];
        }
        super.dispose(camera);
    }
    /**
     * Called on the mode changed (object based or screen based).
     * @returns void
     */ _applyMode() {
        if (!this._geometryBufferRenderer && !this._prePassRenderer) {
            // We can't get a velocity or depth texture. So, work as a passthrough.
            (0, $kVtWi.Logger).Warn("Multiple Render Target support needed to compute object based motion blur");
            return this.updateEffect();
        }
        if (this._geometryBufferRenderer) this._geometryBufferRenderer.enableVelocity = this._isObjectBased;
        this._updateEffect();
        this._invViewProjection = null;
        this._previousViewProjection = null;
        if (this.isObjectBased) {
            if (this._prePassRenderer && this._prePassEffectConfiguration) this._prePassEffectConfiguration.texturesRequired[0] = 2;
            this.onApply = (effect)=>this._onApplyObjectBased(effect);
        } else {
            this._invViewProjection = (0, $ha1VO.Matrix).Identity();
            this._previousViewProjection = this._scene.getTransformMatrix().clone();
            if (this._prePassRenderer && this._prePassEffectConfiguration) this._prePassEffectConfiguration.texturesRequired[0] = 5;
            this.onApply = (effect)=>this._onApplyScreenBased(effect);
        }
    }
    /**
     * Called on the effect is applied when the motion blur post-process is in object based mode.
     * @param effect
     */ _onApplyObjectBased(effect) {
        effect.setVector2("screenSize", new (0, $ha1VO.Vector2)(this.width, this.height));
        effect.setFloat("motionScale", this._scene.getAnimationRatio());
        effect.setFloat("motionStrength", this.motionStrength);
        if (this._geometryBufferRenderer) {
            const velocityIndex = this._geometryBufferRenderer.getTextureIndex((0, $gXqe5.GeometryBufferRenderer).VELOCITY_TEXTURE_TYPE);
            effect.setTexture("velocitySampler", this._geometryBufferRenderer.getGBuffer().textures[velocityIndex]);
        } else if (this._prePassRenderer) {
            const velocityIndex = this._prePassRenderer.getIndex(2);
            effect.setTexture("velocitySampler", this._prePassRenderer.getRenderTarget().textures[velocityIndex]);
        }
    }
    /**
     * Called on the effect is applied when the motion blur post-process is in screen based mode.
     * @param effect
     */ _onApplyScreenBased(effect) {
        const viewProjection = (0, $ha1VO.TmpVectors).Matrix[0];
        viewProjection.copyFrom(this._scene.getTransformMatrix());
        viewProjection.invertToRef(this._invViewProjection);
        effect.setMatrix("inverseViewProjection", this._invViewProjection);
        effect.setMatrix("prevViewProjection", this._previousViewProjection);
        this._previousViewProjection.copyFrom(viewProjection);
        effect.setMatrix("projection", this._scene.getProjectionMatrix());
        effect.setVector2("screenSize", new (0, $ha1VO.Vector2)(this.width, this.height));
        effect.setFloat("motionScale", this._scene.getAnimationRatio());
        effect.setFloat("motionStrength", this.motionStrength);
        if (this._geometryBufferRenderer) {
            const depthIndex = this._geometryBufferRenderer.getTextureIndex((0, $gXqe5.GeometryBufferRenderer).DEPTH_TEXTURE_TYPE);
            effect.setTexture("depthSampler", this._geometryBufferRenderer.getGBuffer().textures[depthIndex]);
        } else if (this._prePassRenderer) {
            const depthIndex = this._prePassRenderer.getIndex(5);
            effect.setTexture("depthSampler", this._prePassRenderer.getRenderTarget().textures[depthIndex]);
        }
    }
    /**
     * Called on the effect must be updated (changed mode, samples count, etc.).
     */ _updateEffect() {
        if (this._geometryBufferRenderer || this._prePassRenderer) {
            const defines = [
                "#define GEOMETRY_SUPPORTED",
                "#define SAMPLES " + this._motionBlurSamples.toFixed(1),
                this._isObjectBased ? "#define OBJECT_BASED" : "#define SCREEN_BASED"
            ];
            this.updateEffect(defines.join("\n"));
        }
    }
    /**
     * @internal
     */ static _Parse(parsedPostProcess, targetCamera, scene, rootUrl) {
        return (0, $6Ho1L.SerializationHelper).Parse(()=>{
            return new $087ccb6c95d43552$export$512056e66e9deaee(parsedPostProcess.name, scene, parsedPostProcess.options, targetCamera, parsedPostProcess.renderTargetSamplingMode, scene.getEngine(), parsedPostProcess.reusable, parsedPostProcess.textureType, false);
        }, parsedPostProcess, scene, rootUrl);
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $087ccb6c95d43552$export$512056e66e9deaee.prototype, "motionStrength", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $087ccb6c95d43552$export$512056e66e9deaee.prototype, "motionBlurSamples", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $087ccb6c95d43552$export$512056e66e9deaee.prototype, "isObjectBased", null);
(0, $8DoUR.RegisterClass)("BABYLON.MotionBlurPostProcess", $087ccb6c95d43552$export$512056e66e9deaee);

});
parcelRegister("gXqe5", function(module, exports) {

$parcel$export(module.exports, "GeometryBufferRenderer", () => $c586800380a87410$export$8a4e79b98d630eed);

var $ha1VO = parcelRequire("ha1VO");

var $b4i1f = parcelRequire("b4i1f");

var $j2mX5 = parcelRequire("j2mX5");

var $3TXsv = parcelRequire("3TXsv");

var $7etnY = parcelRequire("7etnY");

var $dUFYy = parcelRequire("dUFYy");

var $54229 = parcelRequire("54229");
parcelRequire("Squjx");
parcelRequire("7phX0");

var $2hKx5 = parcelRequire("2hKx5");

var $aAFeM = parcelRequire("aAFeM");

var $alPCh = parcelRequire("alPCh");
/** list the uniforms used by the geometry renderer */ const $c586800380a87410$var$uniforms = [
    "world",
    "mBones",
    "viewProjection",
    "diffuseMatrix",
    "view",
    "previousWorld",
    "previousViewProjection",
    "mPreviousBones",
    "bumpMatrix",
    "reflectivityMatrix",
    "albedoMatrix",
    "reflectivityColor",
    "albedoColor",
    "metallic",
    "glossiness",
    "vTangentSpaceParams",
    "vBumpInfos",
    "morphTargetInfluences",
    "morphTargetCount",
    "morphTargetTextureInfo",
    "morphTargetTextureIndices",
    "boneTextureWidth"
];
(0, $aAFeM.addClipPlaneUniforms)($c586800380a87410$var$uniforms);
class $c586800380a87410$export$8a4e79b98d630eed {
    /**
     * Gets a boolean indicating if normals are encoded in the [0,1] range in the render target. If true, you should do `normal = normal_rt * 2.0 - 1.0` to get the right normal
     */ get normalsAreUnsigned() {
        return this._normalsAreUnsigned;
    }
    /**
     * @internal
     * Sets up internal structures to share outputs with PrePassRenderer
     * This method should only be called by the PrePassRenderer itself
     */ _linkPrePassRenderer(prePassRenderer) {
        this._linkedWithPrePass = true;
        this._prePassRenderer = prePassRenderer;
        if (this._multiRenderTarget) {
            // prevents clearing of the RT since it's done by prepass
            this._multiRenderTarget.onClearObservable.clear();
            this._multiRenderTarget.onClearObservable.add(()=>{
            // pass
            });
        }
    }
    /**
     * @internal
     * Separates internal structures from PrePassRenderer so the geometry buffer can now operate by itself.
     * This method should only be called by the PrePassRenderer itself
     */ _unlinkPrePassRenderer() {
        this._linkedWithPrePass = false;
        this._createRenderTargets();
    }
    /**
     * @internal
     * Resets the geometry buffer layout
     */ _resetLayout() {
        this._enablePosition = false;
        this._enableReflectivity = false;
        this._enableVelocity = false;
        this._attachmentsFromPrePass = [];
    }
    /**
     * @internal
     * Replaces a texture in the geometry buffer renderer
     * Useful when linking textures of the prepass renderer
     */ _forceTextureType(geometryBufferType, index) {
        if (geometryBufferType === $c586800380a87410$export$8a4e79b98d630eed.POSITION_TEXTURE_TYPE) {
            this._positionIndex = index;
            this._enablePosition = true;
        } else if (geometryBufferType === $c586800380a87410$export$8a4e79b98d630eed.VELOCITY_TEXTURE_TYPE) {
            this._velocityIndex = index;
            this._enableVelocity = true;
        } else if (geometryBufferType === $c586800380a87410$export$8a4e79b98d630eed.REFLECTIVITY_TEXTURE_TYPE) {
            this._reflectivityIndex = index;
            this._enableReflectivity = true;
        } else if (geometryBufferType === $c586800380a87410$export$8a4e79b98d630eed.DEPTH_TEXTURE_TYPE) this._depthIndex = index;
        else if (geometryBufferType === $c586800380a87410$export$8a4e79b98d630eed.NORMAL_TEXTURE_TYPE) this._normalIndex = index;
    }
    /**
     * @internal
     * Sets texture attachments
     * Useful when linking textures of the prepass renderer
     */ _setAttachments(attachments) {
        this._attachmentsFromPrePass = attachments;
    }
    /**
     * @internal
     * Replaces the first texture which is hard coded as a depth texture in the geometry buffer
     * Useful when linking textures of the prepass renderer
     */ _linkInternalTexture(internalTexture) {
        this._multiRenderTarget.setInternalTexture(internalTexture, 0, false);
    }
    /**
     * Gets the render list (meshes to be rendered) used in the G buffer.
     */ get renderList() {
        return this._multiRenderTarget.renderList;
    }
    /**
     * Set the render list (meshes to be rendered) used in the G buffer.
     */ set renderList(meshes) {
        this._multiRenderTarget.renderList = meshes;
    }
    /**
     * Gets whether or not G buffer are supported by the running hardware.
     * This requires draw buffer supports
     */ get isSupported() {
        return this._multiRenderTarget.isSupported;
    }
    /**
     * Returns the index of the given texture type in the G-Buffer textures array
     * @param textureType The texture type constant. For example GeometryBufferRenderer.POSITION_TEXTURE_INDEX
     * @returns the index of the given texture type in the G-Buffer textures array
     */ getTextureIndex(textureType) {
        switch(textureType){
            case $c586800380a87410$export$8a4e79b98d630eed.POSITION_TEXTURE_TYPE:
                return this._positionIndex;
            case $c586800380a87410$export$8a4e79b98d630eed.VELOCITY_TEXTURE_TYPE:
                return this._velocityIndex;
            case $c586800380a87410$export$8a4e79b98d630eed.REFLECTIVITY_TEXTURE_TYPE:
                return this._reflectivityIndex;
            case $c586800380a87410$export$8a4e79b98d630eed.DEPTH_TEXTURE_TYPE:
                return this._linkedWithPrePass ? this._depthIndex : 0;
            case $c586800380a87410$export$8a4e79b98d630eed.NORMAL_TEXTURE_TYPE:
                return this._linkedWithPrePass ? this._normalIndex : 1;
            default:
                return -1;
        }
    }
    /**
     * @returns a boolean indicating if objects positions are enabled for the G buffer.
     */ get enablePosition() {
        return this._enablePosition;
    }
    /**
     * Sets whether or not objects positions are enabled for the G buffer.
     */ set enablePosition(enable) {
        this._enablePosition = enable;
        // PrePass handles index and texture links
        if (!this._linkedWithPrePass) {
            this.dispose();
            this._createRenderTargets();
        }
    }
    /**
     * @returns a boolean indicating if objects velocities are enabled for the G buffer.
     */ get enableVelocity() {
        return this._enableVelocity;
    }
    /**
     * Sets whether or not objects velocities are enabled for the G buffer.
     */ set enableVelocity(enable) {
        this._enableVelocity = enable;
        if (!enable) this._previousTransformationMatrices = {};
        if (!this._linkedWithPrePass) {
            this.dispose();
            this._createRenderTargets();
        }
        this._scene.needsPreviousWorldMatrices = enable;
    }
    /**
     * Gets a boolean indicating if objects reflectivity are enabled in the G buffer.
     */ get enableReflectivity() {
        return this._enableReflectivity;
    }
    /**
     * Sets whether or not objects reflectivity are enabled for the G buffer.
     * For Metallic-Roughness workflow with ORM texture, we assume that ORM texture is defined according to the default layout:
     * pbr.useRoughnessFromMetallicTextureAlpha = false;
     * pbr.useRoughnessFromMetallicTextureGreen = true;
     * pbr.useMetallnessFromMetallicTextureBlue = true;
     */ set enableReflectivity(enable) {
        this._enableReflectivity = enable;
        if (!this._linkedWithPrePass) {
            this.dispose();
            this._createRenderTargets();
        }
    }
    /**
     * Gets the scene associated with the buffer.
     */ get scene() {
        return this._scene;
    }
    /**
     * Gets the ratio used by the buffer during its creation.
     * How big is the buffer related to the main canvas.
     */ get ratio() {
        return typeof this._ratioOrDimensions === "object" ? 1 : this._ratioOrDimensions;
    }
    /**
     * Creates a new G Buffer for the scene
     * @param scene The scene the buffer belongs to
     * @param ratioOrDimensions How big is the buffer related to the main canvas (default: 1). You can also directly pass a width and height for the generated textures
     * @param depthFormat Format of the depth texture (default: 15)
     * @param textureTypesAndFormats The types and formats of textures to create as render targets. If not provided, all textures will be RGBA and float or half float, depending on the engine capabilities.
     */ constructor(scene, ratioOrDimensions = 1, depthFormat = 15, textureTypesAndFormats){
        /**
         * Dictionary used to store the previous transformation matrices of each rendered mesh
         * in order to compute objects velocities when enableVelocity is set to "true"
         * @internal
         */ this._previousTransformationMatrices = {};
        /**
         * Dictionary used to store the previous bones transformation matrices of each rendered mesh
         * in order to compute objects velocities when enableVelocity is set to "true"
         * @internal
         */ this._previousBonesTransformationMatrices = {};
        /**
         * Array used to store the ignored skinned meshes while computing velocity map (typically used by the motion blur post-process).
         * Avoids computing bones velocities and computes only mesh's velocity itself (position, rotation, scaling).
         */ this.excludedSkinnedMeshesFromVelocity = [];
        /** Gets or sets a boolean indicating if transparent meshes should be rendered */ this.renderTransparentMeshes = true;
        /**
         * Gets or sets a boolean indicating if normals should be generated in world space (default: false, meaning normals are generated in view space)
         */ this.generateNormalsInWorldSpace = false;
        this._normalsAreUnsigned = false;
        this._resizeObserver = null;
        this._enablePosition = false;
        this._enableVelocity = false;
        this._enableReflectivity = false;
        this._clearColor = new (0, $7etnY.Color4)(0, 0, 0, 0);
        this._clearDepthColor = new (0, $7etnY.Color4)(1e8, 0, 0, 1); // "infinity" value - depth in the depth texture is view.z, not a 0..1 value!
        this._positionIndex = -1;
        this._velocityIndex = -1;
        this._reflectivityIndex = -1;
        this._depthIndex = -1;
        this._normalIndex = -1;
        this._linkedWithPrePass = false;
        /**
         * If set to true (default: false), the depth texture will be cleared with the depth value corresponding to the far plane (1 in normal mode, 0 in reverse depth buffer mode)
         * If set to false, the depth texture is always cleared with 0.
         */ this.useSpecificClearForDepthTexture = false;
        this._scene = scene;
        this._ratioOrDimensions = ratioOrDimensions;
        this._useUbo = scene.getEngine().supportsUniformBuffers;
        this._depthFormat = depthFormat;
        this._textureTypesAndFormats = textureTypesAndFormats || {};
        $c586800380a87410$export$8a4e79b98d630eed._SceneComponentInitialization(this._scene);
        // Render target
        this._createRenderTargets();
    }
    /**
     * Checks whether everything is ready to render a submesh to the G buffer.
     * @param subMesh the submesh to check readiness for
     * @param useInstances is the mesh drawn using instance or not
     * @returns true if ready otherwise false
     */ isReady(subMesh, useInstances) {
        const material = subMesh.getMaterial();
        if (material && material.disableDepthWrite) return false;
        const defines = [];
        const attribs = [
            (0, $b4i1f.VertexBuffer).PositionKind,
            (0, $b4i1f.VertexBuffer).NormalKind
        ];
        const mesh = subMesh.getMesh();
        if (material) {
            let needUv = false;
            // Alpha test
            if (material.needAlphaTesting() && material.getAlphaTestTexture()) {
                defines.push("#define ALPHATEST");
                defines.push(`#define ALPHATEST_UV${material.getAlphaTestTexture().coordinatesIndex + 1}`);
                needUv = true;
            }
            // Normal map texture
            if (material.bumpTexture && (0, $2hKx5.MaterialFlags).BumpTextureEnabled) {
                defines.push("#define BUMP");
                defines.push(`#define BUMP_UV${material.bumpTexture.coordinatesIndex + 1}`);
                needUv = true;
            }
            if (this._enableReflectivity) {
                let metallicWorkflow = false;
                // for PBR materials: cf. https://doc.babylonjs.com/features/featuresDeepDive/materials/using/masterPBR
                if (material.getClassName() === "PBRMetallicRoughnessMaterial") {
                    // if it is a PBR material in MetallicRoughness Mode:
                    if (material.metallicRoughnessTexture !== null) {
                        defines.push("#define ORMTEXTURE");
                        defines.push(`#define REFLECTIVITY_UV${material.metallicRoughnessTexture.coordinatesIndex + 1}`);
                        defines.push("#define METALLICWORKFLOW");
                        needUv = true;
                        metallicWorkflow = true;
                    }
                    if (material.metallic !== null) {
                        defines.push("#define METALLIC");
                        defines.push("#define METALLICWORKFLOW");
                        metallicWorkflow = true;
                    }
                    if (material.roughness !== null) {
                        defines.push("#define ROUGHNESS");
                        defines.push("#define METALLICWORKFLOW");
                        metallicWorkflow = true;
                    }
                    if (metallicWorkflow) {
                        if (material.baseTexture !== null) {
                            defines.push("#define ALBEDOTEXTURE");
                            defines.push(`#define ALBEDO_UV${material.baseTexture.coordinatesIndex + 1}`);
                            if (material.baseTexture.gammaSpace) defines.push("#define GAMMAALBEDO");
                            needUv = true;
                        }
                        if (material.baseColor !== null) defines.push("#define ALBEDOCOLOR");
                    }
                } else if (material.getClassName() === "PBRSpecularGlossinessMaterial") {
                    // if it is a PBR material in Specular/Glossiness Mode:
                    if (material.specularGlossinessTexture !== null) {
                        defines.push("#define SPECULARGLOSSINESSTEXTURE");
                        defines.push(`#define REFLECTIVITY_UV${material.specularGlossinessTexture.coordinatesIndex + 1}`);
                        needUv = true;
                        if (material.specularGlossinessTexture.gammaSpace) defines.push("#define GAMMAREFLECTIVITYTEXTURE");
                    } else if (material.specularColor !== null) defines.push("#define REFLECTIVITYCOLOR");
                    if (material.glossiness !== null) defines.push("#define GLOSSINESS");
                } else if (material.getClassName() === "PBRMaterial") {
                    // if it is the bigger PBRMaterial
                    if (material.metallicTexture !== null) {
                        defines.push("#define ORMTEXTURE");
                        defines.push(`#define REFLECTIVITY_UV${material.metallicTexture.coordinatesIndex + 1}`);
                        defines.push("#define METALLICWORKFLOW");
                        needUv = true;
                        metallicWorkflow = true;
                    }
                    if (material.metallic !== null) {
                        defines.push("#define METALLIC");
                        defines.push("#define METALLICWORKFLOW");
                        metallicWorkflow = true;
                    }
                    if (material.roughness !== null) {
                        defines.push("#define ROUGHNESS");
                        defines.push("#define METALLICWORKFLOW");
                        metallicWorkflow = true;
                    }
                    if (metallicWorkflow) {
                        if (material.albedoTexture !== null) {
                            defines.push("#define ALBEDOTEXTURE");
                            defines.push(`#define ALBEDO_UV${material.albedoTexture.coordinatesIndex + 1}`);
                            if (material.albedoTexture.gammaSpace) defines.push("#define GAMMAALBEDO");
                            needUv = true;
                        }
                        if (material.albedoColor !== null) defines.push("#define ALBEDOCOLOR");
                    } else {
                        // SpecularGlossiness Model
                        if (material.reflectivityTexture !== null) {
                            defines.push("#define SPECULARGLOSSINESSTEXTURE");
                            defines.push(`#define REFLECTIVITY_UV${material.reflectivityTexture.coordinatesIndex + 1}`);
                            if (material.reflectivityTexture.gammaSpace) defines.push("#define GAMMAREFLECTIVITYTEXTURE");
                            needUv = true;
                        } else if (material.reflectivityColor !== null) defines.push("#define REFLECTIVITYCOLOR");
                        if (material.microSurface !== null) defines.push("#define GLOSSINESS");
                    }
                } else if (material.getClassName() === "StandardMaterial") {
                    // if StandardMaterial:
                    if (material.specularTexture !== null) {
                        defines.push("#define REFLECTIVITYTEXTURE");
                        defines.push(`#define REFLECTIVITY_UV${material.specularTexture.coordinatesIndex + 1}`);
                        if (material.specularTexture.gammaSpace) defines.push("#define GAMMAREFLECTIVITYTEXTURE");
                        needUv = true;
                    }
                    if (material.specularColor !== null) defines.push("#define REFLECTIVITYCOLOR");
                }
            }
            if (needUv) {
                defines.push("#define NEED_UV");
                if (mesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UVKind)) {
                    attribs.push((0, $b4i1f.VertexBuffer).UVKind);
                    defines.push("#define UV1");
                }
                if (mesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UV2Kind)) {
                    attribs.push((0, $b4i1f.VertexBuffer).UV2Kind);
                    defines.push("#define UV2");
                }
            }
        }
        // PrePass
        if (this._linkedWithPrePass) {
            defines.push("#define PREPASS");
            if (this._depthIndex !== -1) {
                defines.push("#define DEPTH_INDEX " + this._depthIndex);
                defines.push("#define PREPASS_DEPTH");
            }
            if (this._normalIndex !== -1) {
                defines.push("#define NORMAL_INDEX " + this._normalIndex);
                defines.push("#define PREPASS_NORMAL");
            }
        }
        // Buffers
        if (this._enablePosition) {
            defines.push("#define POSITION");
            defines.push("#define POSITION_INDEX " + this._positionIndex);
        }
        if (this._enableVelocity) {
            defines.push("#define VELOCITY");
            defines.push("#define VELOCITY_INDEX " + this._velocityIndex);
            if (this.excludedSkinnedMeshesFromVelocity.indexOf(mesh) === -1) defines.push("#define BONES_VELOCITY_ENABLED");
        }
        if (this._enableReflectivity) {
            defines.push("#define REFLECTIVITY");
            defines.push("#define REFLECTIVITY_INDEX " + this._reflectivityIndex);
        }
        if (this.generateNormalsInWorldSpace) defines.push("#define NORMAL_WORLDSPACE");
        if (this._normalsAreUnsigned) defines.push("#define ENCODE_NORMAL");
        // Bones
        if (mesh.useBones && mesh.computeBonesUsingShaders && mesh.skeleton) {
            attribs.push((0, $b4i1f.VertexBuffer).MatricesIndicesKind);
            attribs.push((0, $b4i1f.VertexBuffer).MatricesWeightsKind);
            if (mesh.numBoneInfluencers > 4) {
                attribs.push((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind);
                attribs.push((0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind);
            }
            defines.push("#define NUM_BONE_INFLUENCERS " + mesh.numBoneInfluencers);
            defines.push("#define BONETEXTURE " + mesh.skeleton.isUsingTextureForMatrices);
            defines.push("#define BonesPerMesh " + (mesh.skeleton.bones.length + 1));
        } else {
            defines.push("#define NUM_BONE_INFLUENCERS 0");
            defines.push("#define BONETEXTURE false");
            defines.push("#define BonesPerMesh 0");
        }
        // Morph targets
        const morphTargetManager = mesh.morphTargetManager;
        let numMorphInfluencers = 0;
        if (morphTargetManager) {
            numMorphInfluencers = morphTargetManager.numMaxInfluencers || morphTargetManager.numInfluencers;
            if (numMorphInfluencers > 0) {
                defines.push("#define MORPHTARGETS");
                defines.push("#define NUM_MORPH_INFLUENCERS " + numMorphInfluencers);
                if (morphTargetManager.isUsingTextureForTargets) defines.push("#define MORPHTARGETS_TEXTURE");
                (0, $alPCh.PrepareAttributesForMorphTargetsInfluencers)(attribs, mesh, numMorphInfluencers);
            }
        }
        // Instances
        if (useInstances) {
            defines.push("#define INSTANCES");
            (0, $alPCh.PushAttributesForInstances)(attribs, this._enableVelocity);
            if (subMesh.getRenderingMesh().hasThinInstances) defines.push("#define THIN_INSTANCES");
        }
        // Setup textures count
        if (this._linkedWithPrePass) defines.push("#define RENDER_TARGET_COUNT " + this._attachmentsFromPrePass.length);
        else defines.push("#define RENDER_TARGET_COUNT " + this._multiRenderTarget.textures.length);
        (0, $aAFeM.prepareStringDefinesForClipPlanes)(material, this._scene, defines);
        // Get correct effect
        const engine = this._scene.getEngine();
        const drawWrapper = subMesh._getDrawWrapper(undefined, true);
        const cachedDefines = drawWrapper.defines;
        const join = defines.join("\n");
        if (cachedDefines !== join) drawWrapper.setEffect(engine.createEffect("geometry", {
            attributes: attribs,
            uniformsNames: $c586800380a87410$var$uniforms,
            samplers: [
                "diffuseSampler",
                "bumpSampler",
                "reflectivitySampler",
                "albedoSampler",
                "morphTargets",
                "boneSampler"
            ],
            defines: join,
            onCompiled: null,
            fallbacks: null,
            onError: null,
            uniformBuffersNames: [
                "Scene"
            ],
            indexParameters: {
                buffersCount: this._multiRenderTarget.textures.length - 1,
                maxSimultaneousMorphTargets: numMorphInfluencers
            }
        }, engine), join);
        return drawWrapper.effect.isReady();
    }
    /**
     * Gets the current underlying G Buffer.
     * @returns the buffer
     */ getGBuffer() {
        return this._multiRenderTarget;
    }
    /**
     * Gets the number of samples used to render the buffer (anti aliasing).
     */ get samples() {
        return this._multiRenderTarget.samples;
    }
    /**
     * Sets the number of samples used to render the buffer (anti aliasing).
     */ set samples(value) {
        this._multiRenderTarget.samples = value;
    }
    /**
     * Disposes the renderer and frees up associated resources.
     */ dispose() {
        if (this._resizeObserver) {
            const engine = this._scene.getEngine();
            engine.onResizeObservable.remove(this._resizeObserver);
            this._resizeObserver = null;
        }
        this.getGBuffer().dispose();
    }
    _assignRenderTargetIndices() {
        const textureNames = [];
        const textureTypesAndFormats = [];
        let count = 2;
        textureNames.push("gBuffer_Depth", "gBuffer_Normal");
        textureTypesAndFormats.push(this._textureTypesAndFormats[$c586800380a87410$export$8a4e79b98d630eed.DEPTH_TEXTURE_TYPE]);
        textureTypesAndFormats.push(this._textureTypesAndFormats[$c586800380a87410$export$8a4e79b98d630eed.NORMAL_TEXTURE_TYPE]);
        if (this._enablePosition) {
            this._positionIndex = count;
            count++;
            textureNames.push("gBuffer_Position");
            textureTypesAndFormats.push(this._textureTypesAndFormats[$c586800380a87410$export$8a4e79b98d630eed.POSITION_TEXTURE_TYPE]);
        }
        if (this._enableVelocity) {
            this._velocityIndex = count;
            count++;
            textureNames.push("gBuffer_Velocity");
            textureTypesAndFormats.push(this._textureTypesAndFormats[$c586800380a87410$export$8a4e79b98d630eed.VELOCITY_TEXTURE_TYPE]);
        }
        if (this._enableReflectivity) {
            this._reflectivityIndex = count;
            count++;
            textureNames.push("gBuffer_Reflectivity");
            textureTypesAndFormats.push(this._textureTypesAndFormats[$c586800380a87410$export$8a4e79b98d630eed.REFLECTIVITY_TEXTURE_TYPE]);
        }
        return [
            count,
            textureNames,
            textureTypesAndFormats
        ];
    }
    _createRenderTargets() {
        const engine = this._scene.getEngine();
        const [count, textureNames, textureTypesAndFormat] = this._assignRenderTargetIndices();
        let type = 0;
        if (engine._caps.textureFloat && engine._caps.textureFloatLinearFiltering) type = 1;
        else if (engine._caps.textureHalfFloat && engine._caps.textureHalfFloatLinearFiltering) type = 2;
        const dimensions = this._ratioOrDimensions.width !== undefined ? this._ratioOrDimensions : {
            width: engine.getRenderWidth() * this._ratioOrDimensions,
            height: engine.getRenderHeight() * this._ratioOrDimensions
        };
        const textureTypes = [];
        const textureFormats = [];
        for (const typeAndFormat of textureTypesAndFormat)if (typeAndFormat) {
            textureTypes.push(typeAndFormat.textureType);
            textureFormats.push(typeAndFormat.textureFormat);
        } else {
            textureTypes.push(type);
            textureFormats.push(5);
        }
        this._normalsAreUnsigned = textureTypes[$c586800380a87410$export$8a4e79b98d630eed.NORMAL_TEXTURE_TYPE] === 11 || textureTypes[$c586800380a87410$export$8a4e79b98d630eed.NORMAL_TEXTURE_TYPE] === 13;
        this._multiRenderTarget = new (0, $3TXsv.MultiRenderTarget)("gBuffer", dimensions, count, this._scene, {
            generateMipMaps: false,
            generateDepthTexture: true,
            types: textureTypes,
            formats: textureFormats,
            depthTextureFormat: this._depthFormat
        }, textureNames.concat("gBuffer_DepthBuffer"));
        if (!this.isSupported) return;
        this._multiRenderTarget.wrapU = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        this._multiRenderTarget.wrapV = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        this._multiRenderTarget.refreshRate = 1;
        this._multiRenderTarget.renderParticles = false;
        this._multiRenderTarget.renderList = null;
        // Depth is always the first texture in the geometry buffer renderer!
        const layoutAttachmentsAll = [
            true
        ];
        const layoutAttachmentsAllButDepth = [
            false
        ];
        const layoutAttachmentsDepthOnly = [
            true
        ];
        for(let i = 1; i < count; ++i){
            layoutAttachmentsAll.push(true);
            layoutAttachmentsDepthOnly.push(false);
            layoutAttachmentsAllButDepth.push(true);
        }
        const attachmentsAll = engine.buildTextureLayout(layoutAttachmentsAll);
        const attachmentsAllButDepth = engine.buildTextureLayout(layoutAttachmentsAllButDepth);
        const attachmentsDepthOnly = engine.buildTextureLayout(layoutAttachmentsDepthOnly);
        this._multiRenderTarget.onClearObservable.add((engine)=>{
            engine.bindAttachments(this.useSpecificClearForDepthTexture ? attachmentsAllButDepth : attachmentsAll);
            engine.clear(this._clearColor, true, true, true);
            if (this.useSpecificClearForDepthTexture) {
                engine.bindAttachments(attachmentsDepthOnly);
                engine.clear(this._clearDepthColor, true, true, true);
            }
            engine.bindAttachments(attachmentsAll);
        });
        this._resizeObserver = engine.onResizeObservable.add(()=>{
            if (this._multiRenderTarget) {
                const dimensions = this._ratioOrDimensions.width !== undefined ? this._ratioOrDimensions : {
                    width: engine.getRenderWidth() * this._ratioOrDimensions,
                    height: engine.getRenderHeight() * this._ratioOrDimensions
                };
                this._multiRenderTarget.resize(dimensions);
            }
        });
        // Custom render function
        const renderSubMesh = (subMesh)=>{
            const renderingMesh = subMesh.getRenderingMesh();
            const effectiveMesh = subMesh.getEffectiveMesh();
            const scene = this._scene;
            const engine = scene.getEngine();
            const material = subMesh.getMaterial();
            if (!material) return;
            effectiveMesh._internalAbstractMeshDataInfo._isActiveIntermediate = false;
            // Velocity
            if (this._enableVelocity && !this._previousTransformationMatrices[effectiveMesh.uniqueId]) {
                this._previousTransformationMatrices[effectiveMesh.uniqueId] = {
                    world: (0, $ha1VO.Matrix).Identity(),
                    viewProjection: scene.getTransformMatrix()
                };
                if (renderingMesh.skeleton) {
                    const bonesTransformations = renderingMesh.skeleton.getTransformMatrices(renderingMesh);
                    this._previousBonesTransformationMatrices[renderingMesh.uniqueId] = this._copyBonesTransformationMatrices(bonesTransformations, new Float32Array(bonesTransformations.length));
                }
            }
            // Managing instances
            const batch = renderingMesh._getInstancesRenderList(subMesh._id, !!subMesh.getReplacementMesh());
            if (batch.mustReturn) return;
            const hardwareInstancedRendering = engine.getCaps().instancedArrays && (batch.visibleInstances[subMesh._id] !== null || renderingMesh.hasThinInstances);
            const world = effectiveMesh.getWorldMatrix();
            if (this.isReady(subMesh, hardwareInstancedRendering)) {
                const drawWrapper = subMesh._getDrawWrapper();
                if (!drawWrapper) return;
                const effect = drawWrapper.effect;
                engine.enableEffect(drawWrapper);
                if (!hardwareInstancedRendering) renderingMesh._bind(subMesh, effect, material.fillMode);
                if (!this._useUbo) {
                    effect.setMatrix("viewProjection", scene.getTransformMatrix());
                    effect.setMatrix("view", scene.getViewMatrix());
                } else {
                    (0, $alPCh.BindSceneUniformBuffer)(effect, this._scene.getSceneUniformBuffer());
                    this._scene.finalizeSceneUbo();
                }
                let sideOrientation;
                const instanceDataStorage = renderingMesh._instanceDataStorage;
                if (!instanceDataStorage.isFrozen && (material.backFaceCulling || renderingMesh.overrideMaterialSideOrientation !== null)) {
                    const mainDeterminant = effectiveMesh._getWorldMatrixDeterminant();
                    sideOrientation = renderingMesh.overrideMaterialSideOrientation;
                    if (sideOrientation === null) sideOrientation = material.sideOrientation;
                    if (mainDeterminant < 0) sideOrientation = sideOrientation === (0, $54229.Material).ClockWiseSideOrientation ? (0, $54229.Material).CounterClockWiseSideOrientation : (0, $54229.Material).ClockWiseSideOrientation;
                } else sideOrientation = instanceDataStorage.sideOrientation;
                material._preBind(drawWrapper, sideOrientation);
                // Alpha test
                if (material.needAlphaTesting()) {
                    const alphaTexture = material.getAlphaTestTexture();
                    if (alphaTexture) {
                        effect.setTexture("diffuseSampler", alphaTexture);
                        effect.setMatrix("diffuseMatrix", alphaTexture.getTextureMatrix());
                    }
                }
                // Bump
                if (material.bumpTexture && scene.getEngine().getCaps().standardDerivatives && (0, $2hKx5.MaterialFlags).BumpTextureEnabled) {
                    effect.setFloat3("vBumpInfos", material.bumpTexture.coordinatesIndex, 1.0 / material.bumpTexture.level, material.parallaxScaleBias);
                    effect.setMatrix("bumpMatrix", material.bumpTexture.getTextureMatrix());
                    effect.setTexture("bumpSampler", material.bumpTexture);
                    effect.setFloat2("vTangentSpaceParams", material.invertNormalMapX ? -1 : 1.0, material.invertNormalMapY ? -1 : 1.0);
                }
                // Reflectivity
                if (this._enableReflectivity) {
                    // for PBR materials: cf. https://doc.babylonjs.com/features/featuresDeepDive/materials/using/masterPBR
                    if (material.getClassName() === "PBRMetallicRoughnessMaterial") {
                        // if it is a PBR material in MetallicRoughness Mode:
                        if (material.metallicRoughnessTexture !== null) {
                            effect.setTexture("reflectivitySampler", material.metallicRoughnessTexture);
                            effect.setMatrix("reflectivityMatrix", material.metallicRoughnessTexture.getTextureMatrix());
                        }
                        if (material.metallic !== null) effect.setFloat("metallic", material.metallic);
                        if (material.roughness !== null) effect.setFloat("glossiness", 1.0 - material.roughness);
                        if (material.baseTexture !== null) {
                            effect.setTexture("albedoSampler", material.baseTexture);
                            effect.setMatrix("albedoMatrix", material.baseTexture.getTextureMatrix());
                        }
                        if (material.baseColor !== null) effect.setColor3("albedoColor", material.baseColor);
                    } else if (material.getClassName() === "PBRSpecularGlossinessMaterial") {
                        // if it is a PBR material in Specular/Glossiness Mode:
                        if (material.specularGlossinessTexture !== null) {
                            effect.setTexture("reflectivitySampler", material.specularGlossinessTexture);
                            effect.setMatrix("reflectivityMatrix", material.specularGlossinessTexture.getTextureMatrix());
                        } else if (material.specularColor !== null) effect.setColor3("reflectivityColor", material.specularColor);
                        if (material.glossiness !== null) effect.setFloat("glossiness", material.glossiness);
                    } else if (material.getClassName() === "PBRMaterial") {
                        // if it is the bigger PBRMaterial
                        if (material.metallicTexture !== null) {
                            effect.setTexture("reflectivitySampler", material.metallicTexture);
                            effect.setMatrix("reflectivityMatrix", material.metallicTexture.getTextureMatrix());
                        }
                        if (material.metallic !== null) effect.setFloat("metallic", material.metallic);
                        if (material.roughness !== null) effect.setFloat("glossiness", 1.0 - material.roughness);
                        if (material.roughness !== null || material.metallic !== null || material.metallicTexture !== null) {
                            // MetallicRoughness Model
                            if (material.albedoTexture !== null) {
                                effect.setTexture("albedoSampler", material.albedoTexture);
                                effect.setMatrix("albedoMatrix", material.albedoTexture.getTextureMatrix());
                            }
                            if (material.albedoColor !== null) effect.setColor3("albedoColor", material.albedoColor);
                        } else {
                            // SpecularGlossiness Model
                            if (material.reflectivityTexture !== null) {
                                effect.setTexture("reflectivitySampler", material.reflectivityTexture);
                                effect.setMatrix("reflectivityMatrix", material.reflectivityTexture.getTextureMatrix());
                            } else if (material.reflectivityColor !== null) effect.setColor3("reflectivityColor", material.reflectivityColor);
                            if (material.microSurface !== null) effect.setFloat("glossiness", material.microSurface);
                        }
                    } else if (material.getClassName() === "StandardMaterial") {
                        // if StandardMaterial:
                        if (material.specularTexture !== null) {
                            effect.setTexture("reflectivitySampler", material.specularTexture);
                            effect.setMatrix("reflectivityMatrix", material.specularTexture.getTextureMatrix());
                        }
                        if (material.specularColor !== null) effect.setColor3("reflectivityColor", material.specularColor);
                    }
                }
                // Clip plane
                (0, $aAFeM.bindClipPlane)(effect, material, this._scene);
                // Bones
                if (renderingMesh.useBones && renderingMesh.computeBonesUsingShaders && renderingMesh.skeleton) {
                    const skeleton = renderingMesh.skeleton;
                    if (skeleton.isUsingTextureForMatrices && effect.getUniformIndex("boneTextureWidth") > -1) {
                        const boneTexture = skeleton.getTransformMatrixTexture(renderingMesh);
                        effect.setTexture("boneSampler", boneTexture);
                        effect.setFloat("boneTextureWidth", 4.0 * (skeleton.bones.length + 1));
                    } else effect.setMatrices("mBones", renderingMesh.skeleton.getTransformMatrices(renderingMesh));
                    if (this._enableVelocity) effect.setMatrices("mPreviousBones", this._previousBonesTransformationMatrices[renderingMesh.uniqueId]);
                }
                // Morph targets
                (0, $alPCh.BindMorphTargetParameters)(renderingMesh, effect);
                if (renderingMesh.morphTargetManager && renderingMesh.morphTargetManager.isUsingTextureForTargets) renderingMesh.morphTargetManager._bind(effect);
                // Velocity
                if (this._enableVelocity) {
                    effect.setMatrix("previousWorld", this._previousTransformationMatrices[effectiveMesh.uniqueId].world);
                    effect.setMatrix("previousViewProjection", this._previousTransformationMatrices[effectiveMesh.uniqueId].viewProjection);
                }
                if (hardwareInstancedRendering && renderingMesh.hasThinInstances) effect.setMatrix("world", world);
                // Draw
                renderingMesh._processRendering(effectiveMesh, subMesh, effect, material.fillMode, batch, hardwareInstancedRendering, (isInstance, w)=>{
                    if (!isInstance) effect.setMatrix("world", w);
                });
            }
            // Velocity
            if (this._enableVelocity) {
                this._previousTransformationMatrices[effectiveMesh.uniqueId].world = world.clone();
                this._previousTransformationMatrices[effectiveMesh.uniqueId].viewProjection = this._scene.getTransformMatrix().clone();
                if (renderingMesh.skeleton) this._copyBonesTransformationMatrices(renderingMesh.skeleton.getTransformMatrices(renderingMesh), this._previousBonesTransformationMatrices[effectiveMesh.uniqueId]);
            }
        };
        this._multiRenderTarget.customIsReadyFunction = (mesh, refreshRate, preWarm)=>{
            if ((preWarm || refreshRate === 0) && mesh.subMeshes) for(let i = 0; i < mesh.subMeshes.length; ++i){
                const subMesh = mesh.subMeshes[i];
                const material = subMesh.getMaterial();
                const renderingMesh = subMesh.getRenderingMesh();
                if (!material) continue;
                const batch = renderingMesh._getInstancesRenderList(subMesh._id, !!subMesh.getReplacementMesh());
                const hardwareInstancedRendering = engine.getCaps().instancedArrays && (batch.visibleInstances[subMesh._id] !== null || renderingMesh.hasThinInstances);
                if (!this.isReady(subMesh, hardwareInstancedRendering)) return false;
            }
            return true;
        };
        this._multiRenderTarget.customRenderFunction = (opaqueSubMeshes, alphaTestSubMeshes, transparentSubMeshes, depthOnlySubMeshes)=>{
            let index;
            if (this._linkedWithPrePass) {
                if (!this._prePassRenderer.enabled) return;
                this._scene.getEngine().bindAttachments(this._attachmentsFromPrePass);
            }
            if (depthOnlySubMeshes.length) {
                engine.setColorWrite(false);
                for(index = 0; index < depthOnlySubMeshes.length; index++)renderSubMesh(depthOnlySubMeshes.data[index]);
                engine.setColorWrite(true);
            }
            for(index = 0; index < opaqueSubMeshes.length; index++)renderSubMesh(opaqueSubMeshes.data[index]);
            engine.setDepthWrite(false);
            for(index = 0; index < alphaTestSubMeshes.length; index++)renderSubMesh(alphaTestSubMeshes.data[index]);
            if (this.renderTransparentMeshes) for(index = 0; index < transparentSubMeshes.length; index++)renderSubMesh(transparentSubMeshes.data[index]);
            engine.setDepthWrite(true);
        };
    }
    // Copies the bones transformation matrices into the target array and returns the target's reference
    _copyBonesTransformationMatrices(source, target) {
        for(let i = 0; i < source.length; i++)target[i] = source[i];
        return target;
    }
}
/**
 * Constant used to retrieve the depth texture index in the G-Buffer textures array
 * using getIndex(GeometryBufferRenderer.DEPTH_TEXTURE_INDEX)
 */ $c586800380a87410$export$8a4e79b98d630eed.DEPTH_TEXTURE_TYPE = 0;
/**
 * Constant used to retrieve the normal texture index in the G-Buffer textures array
 * using getIndex(GeometryBufferRenderer.NORMAL_TEXTURE_INDEX)
 */ $c586800380a87410$export$8a4e79b98d630eed.NORMAL_TEXTURE_TYPE = 1;
/**
 * Constant used to retrieve the position texture index in the G-Buffer textures array
 * using getIndex(GeometryBufferRenderer.POSITION_TEXTURE_INDEX)
 */ $c586800380a87410$export$8a4e79b98d630eed.POSITION_TEXTURE_TYPE = 2;
/**
 * Constant used to retrieve the velocity texture index in the G-Buffer textures array
 * using getIndex(GeometryBufferRenderer.VELOCITY_TEXTURE_INDEX)
 */ $c586800380a87410$export$8a4e79b98d630eed.VELOCITY_TEXTURE_TYPE = 3;
/**
 * Constant used to retrieve the reflectivity texture index in the G-Buffer textures array
 * using the getIndex(GeometryBufferRenderer.REFLECTIVITY_TEXTURE_TYPE)
 */ $c586800380a87410$export$8a4e79b98d630eed.REFLECTIVITY_TEXTURE_TYPE = 4;
/**
 * @internal
 */ $c586800380a87410$export$8a4e79b98d630eed._SceneComponentInitialization = (_)=>{
    throw (0, $dUFYy._WarnImport)("GeometryBufferRendererSceneComponent");
};

});
parcelRegister("Squjx", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("82O8L");
parcelRequire("cblTU");
parcelRequire("lnIOB");
parcelRequire("2KL02");
parcelRequire("7Hs3g");
parcelRequire("kg1CD");
parcelRequire("F4hvB");
const $0a3997369d1d99f4$var$name = "geometryPixelShader";
const $0a3997369d1d99f4$var$shader = `#extension GL_EXT_draw_buffers : require
#if defined(BUMP) || !defined(NORMAL)
#extension GL_OES_standard_derivatives : enable
#endif
precision highp float;
#ifdef BUMP
varying mat4 vWorldView;varying vec3 vNormalW;
#else
varying vec3 vNormalV;
#endif
varying vec4 vViewPos;
#if defined(POSITION) || defined(BUMP)
varying vec3 vPositionW;
#endif
#ifdef VELOCITY
varying vec4 vCurrentPosition;varying vec4 vPreviousPosition;
#endif
#ifdef NEED_UV
varying vec2 vUV;
#endif
#ifdef BUMP
uniform vec3 vBumpInfos;uniform vec2 vTangentSpaceParams;
#endif
#if defined(REFLECTIVITY)
#if defined(ORMTEXTURE) || defined(SPECULARGLOSSINESSTEXTURE) || defined(REFLECTIVITYTEXTURE)
uniform sampler2D reflectivitySampler;varying vec2 vReflectivityUV;
#endif
#ifdef ALBEDOTEXTURE
varying vec2 vAlbedoUV;uniform sampler2D albedoSampler;
#endif
#ifdef REFLECTIVITYCOLOR
uniform vec3 reflectivityColor;
#endif
#ifdef ALBEDOCOLOR
uniform vec3 albedoColor;
#endif
#ifdef METALLIC
uniform float metallic;
#endif
#if defined(ROUGHNESS) || defined(GLOSSINESS)
uniform float glossiness;
#endif
#endif
#if defined(ALPHATEST) && defined(NEED_UV)
uniform sampler2D diffuseSampler;
#endif
#include<clipPlaneFragmentDeclaration>
#include<mrtFragmentDeclaration>[RENDER_TARGET_COUNT]
#include<bumpFragmentMainFunctions>
#include<bumpFragmentFunctions>
#include<helperFunctions>
void main() {
#include<clipPlaneFragment>
#ifdef ALPHATEST
if (texture2D(diffuseSampler,vUV).a<0.4)
discard;
#endif
vec3 normalOutput;
#ifdef BUMP
vec3 normalW=normalize(vNormalW);
#include<bumpFragment>
#ifdef NORMAL_WORLDSPACE
normalOutput=normalW;
#else
normalOutput=normalize(vec3(vWorldView*vec4(normalW,0.0)));
#endif
#else
normalOutput=normalize(vNormalV);
#endif
#ifdef ENCODE_NORMAL
normalOutput=normalOutput*0.5+0.5;
#endif
#ifdef PREPASS
#ifdef PREPASS_DEPTH
gl_FragData[DEPTH_INDEX]=vec4(vViewPos.z/vViewPos.w,0.0,0.0,1.0);
#endif
#ifdef PREPASS_NORMAL
gl_FragData[NORMAL_INDEX]=vec4(normalOutput,1.0);
#endif
#else
gl_FragData[0]=vec4(vViewPos.z/vViewPos.w,0.0,0.0,1.0);gl_FragData[1]=vec4(normalOutput,1.0);
#endif
#ifdef POSITION
gl_FragData[POSITION_INDEX]=vec4(vPositionW,1.0);
#endif
#ifdef VELOCITY
vec2 a=(vCurrentPosition.xy/vCurrentPosition.w)*0.5+0.5;vec2 b=(vPreviousPosition.xy/vPreviousPosition.w)*0.5+0.5;vec2 velocity=abs(a-b);velocity=vec2(pow(velocity.x,1.0/3.0),pow(velocity.y,1.0/3.0))*sign(a-b)*0.5+0.5;gl_FragData[VELOCITY_INDEX]=vec4(velocity,0.0,1.0);
#endif
#ifdef REFLECTIVITY
vec4 reflectivity=vec4(0.0,0.0,0.0,1.0);
#ifdef METALLICWORKFLOW
float metal=1.0;float roughness=1.0;
#ifdef ORMTEXTURE
metal*=texture2D(reflectivitySampler,vReflectivityUV).b;roughness*=texture2D(reflectivitySampler,vReflectivityUV).g;
#endif
#ifdef METALLIC
metal*=metallic;
#endif
#ifdef ROUGHNESS
roughness*=(1.0-glossiness); 
#endif
reflectivity.a-=roughness;vec3 color=vec3(1.0);
#ifdef ALBEDOTEXTURE
color=texture2D(albedoSampler,vAlbedoUV).rgb;
#ifdef GAMMAALBEDO
color=toLinearSpace(color);
#endif
#endif
#ifdef ALBEDOCOLOR
color*=albedoColor.xyz;
#endif
reflectivity.rgb=mix(vec3(0.04),color,metal);
#else
#if defined(SPECULARGLOSSINESSTEXTURE) || defined(REFLECTIVITYTEXTURE)
reflectivity=texture2D(reflectivitySampler,vReflectivityUV);
#ifdef GAMMAREFLECTIVITYTEXTURE
reflectivity.rgb=toLinearSpace(reflectivity.rgb);
#endif
#else 
#ifdef REFLECTIVITYCOLOR
reflectivity.rgb=toLinearSpace(reflectivityColor.xyz);reflectivity.a=1.0;
#endif
#endif
#ifdef GLOSSINESSS
reflectivity.a*=glossiness; 
#endif
#endif
gl_FragData[REFLECTIVITY_INDEX]=reflectivity;
#endif
}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$0a3997369d1d99f4$var$name] = $0a3997369d1d99f4$var$shader;
const $0a3997369d1d99f4$export$d97d9a5440f7474e = {
    name: $0a3997369d1d99f4$var$name,
    shader: $0a3997369d1d99f4$var$shader
};

});
parcelRegister("cblTU", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $8de7802498fa7885$var$name = "mrtFragmentDeclaration";
const $8de7802498fa7885$var$shader = `#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
layout(location=0) out vec4 glFragData[{X}];
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$8de7802498fa7885$var$name] = $8de7802498fa7885$var$shader;
const $8de7802498fa7885$export$48c2f8813edb7710 = {
    name: $8de7802498fa7885$var$name,
    shader: $8de7802498fa7885$var$shader
};

});


parcelRegister("7phX0", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("7PW7m");
parcelRequire("8kYMw");
parcelRequire("5Eb4I");
parcelRequire("9H5jp");
parcelRequire("k3wwH");
parcelRequire("44ME7");
parcelRequire("gQ7sy");
parcelRequire("4A4MM");
parcelRequire("9ulLS");
parcelRequire("LFrAO");
parcelRequire("apKdp");
parcelRequire("4idCt");
parcelRequire("cIweX");
parcelRequire("kqCfW");
parcelRequire("4GjUR");
const $5648cad7d3ed7444$var$name = "geometryVertexShader";
const $5648cad7d3ed7444$var$shader = `precision highp float;
#include<bonesDeclaration>
#include<bakedVertexAnimationDeclaration>
#include<morphTargetsVertexGlobalDeclaration>
#include<morphTargetsVertexDeclaration>[0..maxSimultaneousMorphTargets]
#include<instancesDeclaration>
#include<__decl__geometryVertex>
#include<clipPlaneVertexDeclaration>
attribute vec3 position;attribute vec3 normal;
#ifdef NEED_UV
varying vec2 vUV;
#ifdef ALPHATEST
uniform mat4 diffuseMatrix;
#endif
#ifdef BUMP
uniform mat4 bumpMatrix;varying vec2 vBumpUV;
#endif
#ifdef REFLECTIVITY
uniform mat4 reflectivityMatrix;uniform mat4 albedoMatrix;varying vec2 vReflectivityUV;varying vec2 vAlbedoUV;
#endif
#ifdef UV1
attribute vec2 uv;
#endif
#ifdef UV2
attribute vec2 uv2;
#endif
#endif
#ifdef BUMP
varying mat4 vWorldView;
#endif
#ifdef BUMP
varying vec3 vNormalW;
#else
varying vec3 vNormalV;
#endif
varying vec4 vViewPos;
#if defined(POSITION) || defined(BUMP)
varying vec3 vPositionW;
#endif
#ifdef VELOCITY
uniform mat4 previousViewProjection;varying vec4 vCurrentPosition;varying vec4 vPreviousPosition;
#endif
#define CUSTOM_VERTEX_DEFINITIONS
void main(void)
{vec3 positionUpdated=position;vec3 normalUpdated=normal;
#ifdef UV1
vec2 uvUpdated=uv;
#endif
#include<morphTargetsVertexGlobal>
#include<morphTargetsVertex>[0..maxSimultaneousMorphTargets]
#include<instancesVertex>
#if defined(VELOCITY) && !defined(BONES_VELOCITY_ENABLED)
vCurrentPosition=viewProjection*finalWorld*vec4(positionUpdated,1.0);vPreviousPosition=previousViewProjection*finalPreviousWorld*vec4(positionUpdated,1.0);
#endif
#include<bonesVertex>
#include<bakedVertexAnimation>
vec4 worldPos=vec4(finalWorld*vec4(positionUpdated,1.0));
#ifdef BUMP
vWorldView=view*finalWorld;vNormalW=normalUpdated;
#else
#ifdef NORMAL_WORLDSPACE
vNormalV=normalize(vec3(finalWorld*vec4(normalUpdated,0.0)));
#else
vNormalV=normalize(vec3((view*finalWorld)*vec4(normalUpdated,0.0)));
#endif
#endif
vViewPos=view*worldPos;
#if defined(VELOCITY) && defined(BONES_VELOCITY_ENABLED)
vCurrentPosition=viewProjection*finalWorld*vec4(positionUpdated,1.0);
#if NUM_BONE_INFLUENCERS>0
mat4 previousInfluence;previousInfluence=mPreviousBones[int(matricesIndices[0])]*matricesWeights[0];
#if NUM_BONE_INFLUENCERS>1
previousInfluence+=mPreviousBones[int(matricesIndices[1])]*matricesWeights[1];
#endif
#if NUM_BONE_INFLUENCERS>2
previousInfluence+=mPreviousBones[int(matricesIndices[2])]*matricesWeights[2];
#endif
#if NUM_BONE_INFLUENCERS>3
previousInfluence+=mPreviousBones[int(matricesIndices[3])]*matricesWeights[3];
#endif
#if NUM_BONE_INFLUENCERS>4
previousInfluence+=mPreviousBones[int(matricesIndicesExtra[0])]*matricesWeightsExtra[0];
#endif
#if NUM_BONE_INFLUENCERS>5
previousInfluence+=mPreviousBones[int(matricesIndicesExtra[1])]*matricesWeightsExtra[1];
#endif
#if NUM_BONE_INFLUENCERS>6
previousInfluence+=mPreviousBones[int(matricesIndicesExtra[2])]*matricesWeightsExtra[2];
#endif
#if NUM_BONE_INFLUENCERS>7
previousInfluence+=mPreviousBones[int(matricesIndicesExtra[3])]*matricesWeightsExtra[3];
#endif
vPreviousPosition=previousViewProjection*finalPreviousWorld*previousInfluence*vec4(positionUpdated,1.0);
#else
vPreviousPosition=previousViewProjection*finalPreviousWorld*vec4(positionUpdated,1.0);
#endif
#endif
#if defined(POSITION) || defined(BUMP)
vPositionW=worldPos.xyz/worldPos.w;
#endif
gl_Position=viewProjection*finalWorld*vec4(positionUpdated,1.0);
#include<clipPlaneVertex>
#ifdef NEED_UV
#ifdef UV1
#if defined(ALPHATEST) && defined(ALPHATEST_UV1)
vUV=vec2(diffuseMatrix*vec4(uvUpdated,1.0,0.0));
#else
vUV=uv;
#endif
#ifdef BUMP_UV1
vBumpUV=vec2(bumpMatrix*vec4(uvUpdated,1.0,0.0));
#endif
#ifdef REFLECTIVITY_UV1
vReflectivityUV=vec2(reflectivityMatrix*vec4(uvUpdated,1.0,0.0));
#endif
#ifdef ALBEDO_UV1
vAlbedoUV=vec2(albedoMatrix*vec4(uvUpdated,1.0,0.0));
#endif
#endif
#ifdef UV2
#if defined(ALPHATEST) && defined(ALPHATEST_UV2)
vUV=vec2(diffuseMatrix*vec4(uv2,1.0,0.0));
#else
vUV=uv2;
#endif
#ifdef BUMP_UV2
vBumpUV=vec2(bumpMatrix*vec4(uv2,1.0,0.0));
#endif
#ifdef REFLECTIVITY_UV2
vReflectivityUV=vec2(reflectivityMatrix*vec4(uv2,1.0,0.0));
#endif
#ifdef ALBEDO_UV2
vAlbedoUV=vec2(albedoMatrix*vec4(uv2,1.0,0.0));
#endif
#endif
#endif
#include<bumpVertex>
}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$5648cad7d3ed7444$var$name] = $5648cad7d3ed7444$var$shader;
const $5648cad7d3ed7444$export$902a4ff66265d834 = {
    name: $5648cad7d3ed7444$var$name,
    shader: $5648cad7d3ed7444$var$shader
};

});
parcelRegister("44ME7", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $2f7d454019bc554e$var$name = "geometryVertexDeclaration";
const $2f7d454019bc554e$var$shader = `uniform mat4 viewProjection;uniform mat4 view;`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$2f7d454019bc554e$var$name] = $2f7d454019bc554e$var$shader;
const $2f7d454019bc554e$export$1ae3f777a09e01af = {
    name: $2f7d454019bc554e$var$name,
    shader: $2f7d454019bc554e$var$shader
};

});

parcelRegister("gQ7sy", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("eZlZI");
const $c42749fbc06430a7$var$name = "geometryUboDeclaration";
const $c42749fbc06430a7$var$shader = `#include<sceneUboDeclaration>
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$c42749fbc06430a7$var$name] = $c42749fbc06430a7$var$shader;
const $c42749fbc06430a7$export$313b253abf90f245 = {
    name: $c42749fbc06430a7$var$name,
    shader: $c42749fbc06430a7$var$shader
};

});



parcelRegister("jFESd", function(module, exports) {

$parcel$export(module.exports, "MotionBlurConfiguration", () => $e5218d4adbfdf478$export$4fb596d0fee3d97d);
/**
 * Contains all parameters needed for the prepass to perform
 * motion blur
 */ class $e5218d4adbfdf478$export$4fb596d0fee3d97d {
    constructor(){
        /**
         * Is motion blur enabled
         */ this.enabled = false;
        /**
         * Name of the configuration
         */ this.name = "motionBlur";
        /**
         * Textures that should be present in the MRT for this effect to work
         */ this.texturesRequired = [
            2
        ];
    }
}

});

parcelRegister("cSqxf", function(module, exports) {

$parcel$export(module.exports, "GeometryBufferRendererSceneComponent", () => $95ff1c88dc49c388$export$7d9c20398a2df1eb);

var $gmbCk = parcelRequire("gmbCk");

var $bv05l = parcelRequire("bv05l");

var $gXqe5 = parcelRequire("gXqe5");
Object.defineProperty((0, $gmbCk.Scene).prototype, "geometryBufferRenderer", {
    get: function() {
        return this._geometryBufferRenderer;
    },
    set: function(value) {
        if (value && value.isSupported) this._geometryBufferRenderer = value;
    },
    enumerable: true,
    configurable: true
});
(0, $gmbCk.Scene).prototype.enableGeometryBufferRenderer = function(ratio = 1, depthFormat = 15, textureTypesAndFormats) {
    if (this._geometryBufferRenderer) return this._geometryBufferRenderer;
    this._geometryBufferRenderer = new (0, $gXqe5.GeometryBufferRenderer)(this, ratio, depthFormat, textureTypesAndFormats);
    if (!this._geometryBufferRenderer.isSupported) this._geometryBufferRenderer = null;
    return this._geometryBufferRenderer;
};
(0, $gmbCk.Scene).prototype.disableGeometryBufferRenderer = function() {
    if (!this._geometryBufferRenderer) return;
    this._geometryBufferRenderer.dispose();
    this._geometryBufferRenderer = null;
};
class $95ff1c88dc49c388$export$7d9c20398a2df1eb {
    /**
     * Creates a new instance of the component for the given scene
     * @param scene Defines the scene to register the component in
     */ constructor(scene){
        /**
         * The component name helpful to identify the component in the list of scene components.
         */ this.name = (0, $bv05l.SceneComponentConstants).NAME_GEOMETRYBUFFERRENDERER;
        this.scene = scene;
    }
    /**
     * Registers the component in a given scene
     */ register() {
        this.scene._gatherRenderTargetsStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_GATHERRENDERTARGETS_GEOMETRYBUFFERRENDERER, this, this._gatherRenderTargets);
    }
    /**
     * Rebuilds the elements related to this component in case of
     * context lost for instance.
     */ rebuild() {
    // Nothing to do for this component
    }
    /**
     * Disposes the component and the associated resources
     */ dispose() {
    // Nothing to do for this component
    }
    _gatherRenderTargets(renderTargets) {
        if (this.scene._geometryBufferRenderer) renderTargets.push(this.scene._geometryBufferRenderer.getGBuffer());
    }
}
(0, $gXqe5.GeometryBufferRenderer)._SceneComponentInitialization = (scene)=>{
    // Register the G Buffer component to the scene.
    let component = scene._getComponent((0, $bv05l.SceneComponentConstants).NAME_GEOMETRYBUFFERRENDERER);
    if (!component) {
        component = new $95ff1c88dc49c388$export$7d9c20398a2df1eb(scene);
        scene._addComponent(component);
    }
};

});

parcelRegister("2J7Zg", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $1fc5fad26101f806$var$name = "motionBlurPixelShader";
const $1fc5fad26101f806$var$shader = `varying vec2 vUV;uniform sampler2D textureSampler;uniform float motionStrength;uniform float motionScale;uniform vec2 screenSize;
#ifdef OBJECT_BASED
uniform sampler2D velocitySampler;
#else
uniform sampler2D depthSampler;uniform mat4 inverseViewProjection;uniform mat4 prevViewProjection;uniform mat4 projection;
#endif
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{
#ifdef GEOMETRY_SUPPORTED
#ifdef OBJECT_BASED
vec2 texelSize=1.0/screenSize;vec4 velocityColor=texture2D(velocitySampler,vUV);velocityColor.rg=velocityColor.rg*2.0-vec2(1.0);vec2 velocity=vec2(pow(velocityColor.r,3.0),pow(velocityColor.g,3.0))*velocityColor.a;velocity*=motionScale*motionStrength;float speed=length(velocity/texelSize);int samplesCount=int(clamp(speed,1.0,SAMPLES));velocity=normalize(velocity)*texelSize;float hlim=float(-samplesCount)*0.5+0.5;vec4 result=texture2D(textureSampler,vUV);for (int i=1; i<int(SAMPLES); ++i)
{if (i>=samplesCount)
break;vec2 offset=vUV+velocity*(hlim+float(i));
#if defined(WEBGPU)
result+=texture2DLodEXT(textureSampler,offset,0.0);
#else
result+=texture2D(textureSampler,offset);
#endif
}
gl_FragColor=result/float(samplesCount);gl_FragColor.a=1.0;
#else
vec2 texelSize=1.0/screenSize;float depth=texture2D(depthSampler,vUV).r;depth=projection[2].z+projection[3].z/depth; 
vec4 cpos=vec4(vUV*2.0-1.0,depth,1.0);cpos=inverseViewProjection*cpos;cpos/=cpos.w;vec4 ppos=prevViewProjection*cpos;ppos/=ppos.w;ppos.xy=ppos.xy*0.5+0.5;vec2 velocity=(ppos.xy-vUV)*motionScale*motionStrength;float speed=length(velocity/texelSize);int nSamples=int(clamp(speed,1.0,SAMPLES));vec4 result=texture2D(textureSampler,vUV);for (int i=1; i<int(SAMPLES); ++i) {if (i>=nSamples)
break;vec2 offset1=vUV+velocity*(float(i)/float(nSamples-1)-0.5);
#if defined(WEBGPU)
result+=texture2DLodEXT(textureSampler,offset1,0.0);
#else
result+=texture2D(textureSampler,offset1);
#endif
}
gl_FragColor=result/float(nSamples);
#endif
#else
gl_FragColor=texture2D(textureSampler,vUV);
#endif
}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$1fc5fad26101f806$var$name] = $1fc5fad26101f806$var$shader;
const $1fc5fad26101f806$export$91ef311f21d78b42 = {
    name: $1fc5fad26101f806$var$name,
    shader: $1fc5fad26101f806$var$shader
};

});


parcelRegister("hI3bE", function(module, exports) {

$parcel$export(module.exports, "RefractionPostProcess", () => $ce49049584b64b68$export$3a0b92c66b7fdb77);

var $e0Suo = parcelRequire("e0Suo");

var $j2mX5 = parcelRequire("j2mX5");

var $cFdBb = parcelRequire("cFdBb");
parcelRequire("2AKRV");

var $8DoUR = parcelRequire("8DoUR");

var $ir0rz = parcelRequire("ir0rz");

var $6Ho1L = parcelRequire("6Ho1L");
class $ce49049584b64b68$export$3a0b92c66b7fdb77 extends (0, $cFdBb.PostProcess) {
    /**
     * Gets or sets the refraction texture
     * Please note that you are responsible for disposing the texture if you set it manually
     */ get refractionTexture() {
        return this._refTexture;
    }
    set refractionTexture(value) {
        if (this._refTexture && this._ownRefractionTexture) this._refTexture.dispose();
        this._refTexture = value;
        this._ownRefractionTexture = false;
    }
    /**
     * Gets a string identifying the name of the class
     * @returns "RefractionPostProcess" string
     */ getClassName() {
        return "RefractionPostProcess";
    }
    /**
     * Initializes the RefractionPostProcess
     * @see https://doc.babylonjs.com/features/featuresDeepDive/postProcesses/usePostProcesses#refraction
     * @param name The name of the effect.
     * @param refractionTextureUrl Url of the refraction texture to use
     * @param color the base color of the refraction (used to taint the rendering)
     * @param depth simulated refraction depth
     * @param colorLevel the coefficient of the base color (0 to remove base color tainting)
     * @param options The required width/height ratio to downsize to before computing the render pass.
     * @param camera The camera to apply the render pass to.
     * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
     * @param engine The engine which the post process will be applied. (default: current engine)
     * @param reusable If the post process can be reused on the same frame. (default: false)
     */ constructor(name, refractionTextureUrl, color, depth, colorLevel, options, camera, samplingMode, engine, reusable){
        super(name, "refraction", [
            "baseColor",
            "depth",
            "colorLevel"
        ], [
            "refractionSampler"
        ], options, camera, samplingMode, engine, reusable);
        this._ownRefractionTexture = true;
        this.color = color;
        this.depth = depth;
        this.colorLevel = colorLevel;
        this.refractionTextureUrl = refractionTextureUrl;
        this.onActivateObservable.add((cam)=>{
            this._refTexture = this._refTexture || new (0, $j2mX5.Texture)(refractionTextureUrl, cam.getScene());
        });
        this.onApplyObservable.add((effect)=>{
            effect.setColor3("baseColor", this.color);
            effect.setFloat("depth", this.depth);
            effect.setFloat("colorLevel", this.colorLevel);
            effect.setTexture("refractionSampler", this._refTexture);
        });
    }
    // Methods
    /**
     * Disposes of the post process
     * @param camera Camera to dispose post process on
     */ dispose(camera) {
        if (this._refTexture && this._ownRefractionTexture) {
            this._refTexture.dispose();
            this._refTexture = null;
        }
        super.dispose(camera);
    }
    /**
     * @internal
     */ static _Parse(parsedPostProcess, targetCamera, scene, rootUrl) {
        return (0, $6Ho1L.SerializationHelper).Parse(()=>{
            return new $ce49049584b64b68$export$3a0b92c66b7fdb77(parsedPostProcess.name, parsedPostProcess.refractionTextureUrl, parsedPostProcess.color, parsedPostProcess.depth, parsedPostProcess.colorLevel, parsedPostProcess.options, targetCamera, parsedPostProcess.renderTargetSamplingMode, scene.getEngine(), parsedPostProcess.reusable);
        }, parsedPostProcess, scene, rootUrl);
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ce49049584b64b68$export$3a0b92c66b7fdb77.prototype, "color", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ce49049584b64b68$export$3a0b92c66b7fdb77.prototype, "depth", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ce49049584b64b68$export$3a0b92c66b7fdb77.prototype, "colorLevel", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $ce49049584b64b68$export$3a0b92c66b7fdb77.prototype, "refractionTextureUrl", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.RefractionPostProcess", $ce49049584b64b68$export$3a0b92c66b7fdb77);

});
parcelRegister("2AKRV", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $1e334cbed1820bbc$var$name = "refractionPixelShader";
const $1e334cbed1820bbc$var$shader = `varying vec2 vUV;uniform sampler2D textureSampler;uniform sampler2D refractionSampler;uniform vec3 baseColor;uniform float depth;uniform float colorLevel;void main() {float ref=1.0-texture2D(refractionSampler,vUV).r;vec2 uv=vUV-vec2(0.5);vec2 offset=uv*depth*ref;vec3 sourceColor=texture2D(textureSampler,vUV-offset).rgb;gl_FragColor=vec4(sourceColor+sourceColor*ref*colorLevel,1.0);}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$1e334cbed1820bbc$var$name] = $1e334cbed1820bbc$var$shader;
const $1e334cbed1820bbc$export$f0480dddc967992f = {
    name: $1e334cbed1820bbc$var$name,
    shader: $1e334cbed1820bbc$var$shader
};

});


parcelRegister("9rdEp", function(module, exports) {
/* eslint-disable import/no-internal-modules */ 
var $dIP2Y = parcelRequire("dIP2Y");

var $81KKS = parcelRequire("81KKS");

var $goDmg = parcelRequire("goDmg");

var $itwQC = parcelRequire("itwQC");

var $hD3tI = parcelRequire("hD3tI");
$parcel$exportWildcard(module.exports, $dIP2Y);
$parcel$exportWildcard(module.exports, $81KKS);
$parcel$exportWildcard(module.exports, $goDmg);
$parcel$exportWildcard(module.exports, $itwQC);
$parcel$exportWildcard(module.exports, $hD3tI);

});
parcelRegister("dIP2Y", function(module, exports) {

var $dh5iF = parcelRequire("dh5iF");

var $jPTYQ = parcelRequire("jPTYQ");

var $w7ZD7 = parcelRequire("w7ZD7");

var $iahxV = parcelRequire("iahxV");

var $j0qom = parcelRequire("j0qom");

var $5Ply9 = parcelRequire("5Ply9");

var $i7ok5 = parcelRequire("i7ok5");
$parcel$exportWildcard(module.exports, $dh5iF);
$parcel$exportWildcard(module.exports, $jPTYQ);
$parcel$exportWildcard(module.exports, $w7ZD7);
$parcel$exportWildcard(module.exports, $iahxV);
$parcel$exportWildcard(module.exports, $j0qom);
$parcel$exportWildcard(module.exports, $5Ply9);
$parcel$exportWildcard(module.exports, $i7ok5);

});
parcelRegister("dh5iF", function(module, exports) {

$parcel$export(module.exports, "DefaultRenderingPipeline", () => $9aa0f9629319f21a$export$2448c9c819f114e1);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $6Ho1L = parcelRequire("6Ho1L");

var $diGQf = parcelRequire("diGQf");

var $kVtWi = parcelRequire("kVtWi");

var $j2mX5 = parcelRequire("j2mX5");

var $fY6Qv = parcelRequire("fY6Qv");

var $4sfRU = parcelRequire("4sfRU");

var $ecirA = parcelRequire("ecirA");

var $cjhmh = parcelRequire("cjhmh");

var $gd6JN = parcelRequire("gd6JN");

var $40XEW = parcelRequire("40XEW");

var $goDmg = parcelRequire("goDmg");

var $81KKS = parcelRequire("81KKS");

var $7Bej1 = parcelRequire("7Bej1");

var $1PCeL = parcelRequire("1PCeL");

var $8DoUR = parcelRequire("8DoUR");

var $ejQPp = parcelRequire("ejQPp");

var $bOhSV = parcelRequire("bOhSV");
parcelRequire("hD3tI");
class $9aa0f9629319f21a$export$2448c9c819f114e1 extends (0, $goDmg.PostProcessRenderPipeline) {
    /**
     * Enable or disable automatic building of the pipeline when effects are enabled and disabled.
     * If false, you will have to manually call prepare() to update the pipeline.
     */ get automaticBuild() {
        return this._buildAllowed;
    }
    set automaticBuild(value) {
        this._buildAllowed = value;
    }
    /**
     * Gets active scene
     */ get scene() {
        return this._scene;
    }
    /**
     * Enable or disable the sharpen process from the pipeline
     */ set sharpenEnabled(enabled) {
        if (this._sharpenEnabled === enabled) return;
        this._sharpenEnabled = enabled;
        this._buildPipeline();
    }
    get sharpenEnabled() {
        return this._sharpenEnabled;
    }
    /**
     * Specifies the size of the bloom blur kernel, relative to the final output size
     */ get bloomKernel() {
        return this._bloomKernel;
    }
    set bloomKernel(value) {
        this._bloomKernel = value;
        this.bloom.kernel = value / this._hardwareScaleLevel;
    }
    /**
     * The strength of the bloom.
     */ set bloomWeight(value) {
        if (this._bloomWeight === value) return;
        this.bloom.weight = value;
        this._bloomWeight = value;
    }
    get bloomWeight() {
        return this._bloomWeight;
    }
    /**
     * The luminance threshold to find bright areas of the image to bloom.
     */ set bloomThreshold(value) {
        if (this._bloomThreshold === value) return;
        this.bloom.threshold = value;
        this._bloomThreshold = value;
    }
    get bloomThreshold() {
        return this._bloomThreshold;
    }
    /**
     * The scale of the bloom, lower value will provide better performance.
     */ set bloomScale(value) {
        if (this._bloomScale === value) return;
        this._bloomScale = value;
        // recreate bloom and dispose old as this setting is not dynamic
        this._rebuildBloom();
        this._buildPipeline();
    }
    get bloomScale() {
        return this._bloomScale;
    }
    /**
     * Enable or disable the bloom from the pipeline
     */ set bloomEnabled(enabled) {
        if (this._bloomEnabled === enabled) return;
        this._bloomEnabled = enabled;
        this._buildPipeline();
    }
    get bloomEnabled() {
        return this._bloomEnabled;
    }
    _rebuildBloom() {
        // recreate bloom and dispose old as this setting is not dynamic
        const oldBloom = this.bloom;
        this.bloom = new (0, $1PCeL.BloomEffect)(this._scene, this.bloomScale, this._bloomWeight, this.bloomKernel / this._hardwareScaleLevel, this._defaultPipelineTextureType, false);
        this.bloom.threshold = oldBloom.threshold;
        for(let i = 0; i < this._cameras.length; i++)oldBloom.disposeEffects(this._cameras[i]);
    }
    /**
     * If the depth of field is enabled.
     */ get depthOfFieldEnabled() {
        return this._depthOfFieldEnabled;
    }
    set depthOfFieldEnabled(enabled) {
        if (this._depthOfFieldEnabled === enabled) return;
        this._depthOfFieldEnabled = enabled;
        this._buildPipeline();
    }
    /**
     * Blur level of the depth of field effect. (Higher blur will effect performance)
     */ get depthOfFieldBlurLevel() {
        return this._depthOfFieldBlurLevel;
    }
    set depthOfFieldBlurLevel(value) {
        if (this._depthOfFieldBlurLevel === value) return;
        this._depthOfFieldBlurLevel = value;
        // recreate dof and dispose old as this setting is not dynamic
        const oldDof = this.depthOfField;
        this.depthOfField = new (0, $7Bej1.DepthOfFieldEffect)(this._scene, null, this._depthOfFieldBlurLevel, this._defaultPipelineTextureType, false);
        this.depthOfField.focalLength = oldDof.focalLength;
        this.depthOfField.focusDistance = oldDof.focusDistance;
        this.depthOfField.fStop = oldDof.fStop;
        this.depthOfField.lensSize = oldDof.lensSize;
        for(let i = 0; i < this._cameras.length; i++)oldDof.disposeEffects(this._cameras[i]);
        this._buildPipeline();
    }
    /**
     * If the anti aliasing is enabled.
     */ set fxaaEnabled(enabled) {
        if (this._fxaaEnabled === enabled) return;
        this._fxaaEnabled = enabled;
        this._buildPipeline();
    }
    get fxaaEnabled() {
        return this._fxaaEnabled;
    }
    /**
     * MSAA sample count, setting this to 4 will provide 4x anti aliasing. (default: 1)
     */ set samples(sampleCount) {
        if (this._samples === sampleCount) return;
        this._samples = sampleCount;
        this._buildPipeline();
    }
    get samples() {
        return this._samples;
    }
    /**
     * If image processing is enabled.
     */ set imageProcessingEnabled(enabled) {
        if (this._imageProcessingEnabled === enabled) return;
        this._scene.imageProcessingConfiguration.isEnabled = enabled;
    }
    get imageProcessingEnabled() {
        return this._imageProcessingEnabled;
    }
    /**
     * If glow layer is enabled. (Adds a glow effect to emmissive materials)
     */ set glowLayerEnabled(enabled) {
        if (enabled && !this._glowLayer) this._glowLayer = new (0, $fY6Qv.GlowLayer)("", this._scene);
        else if (!enabled && this._glowLayer) {
            this._glowLayer.dispose();
            this._glowLayer = null;
        }
    }
    get glowLayerEnabled() {
        return this._glowLayer != null;
    }
    /**
     * Gets the glow layer (or null if not defined)
     */ get glowLayer() {
        return this._glowLayer;
    }
    /**
     * Enable or disable the chromaticAberration process from the pipeline
     */ set chromaticAberrationEnabled(enabled) {
        if (this._chromaticAberrationEnabled === enabled) return;
        this._chromaticAberrationEnabled = enabled;
        this._buildPipeline();
    }
    get chromaticAberrationEnabled() {
        return this._chromaticAberrationEnabled;
    }
    /**
     * Enable or disable the grain process from the pipeline
     */ set grainEnabled(enabled) {
        if (this._grainEnabled === enabled) return;
        this._grainEnabled = enabled;
        this._buildPipeline();
    }
    get grainEnabled() {
        return this._grainEnabled;
    }
    /**
     * Instantiates a DefaultRenderingPipeline.
     * @param name The rendering pipeline name (default: "")
     * @param hdr If high dynamic range textures should be used (default: true)
     * @param scene The scene linked to this pipeline (default: the last created scene)
     * @param cameras The array of cameras that the rendering pipeline will be attached to (default: scene.cameras)
     * @param automaticBuild If false, you will have to manually call prepare() to update the pipeline (default: true)
     */ constructor(name = "", hdr = true, scene = (0, $ejQPp.EngineStore).LastCreatedScene, cameras, automaticBuild = true){
        super(scene.getEngine(), name);
        this._camerasToBeAttached = [];
        /**
         * ID of the sharpen post process,
         */ this.SharpenPostProcessId = "SharpenPostProcessEffect";
        /**
         * @ignore
         * ID of the image processing post process;
         */ this.ImageProcessingPostProcessId = "ImageProcessingPostProcessEffect";
        /**
         * @ignore
         * ID of the Fast Approximate Anti-Aliasing post process;
         */ this.FxaaPostProcessId = "FxaaPostProcessEffect";
        /**
         * ID of the chromatic aberration post process,
         */ this.ChromaticAberrationPostProcessId = "ChromaticAberrationPostProcessEffect";
        /**
         * ID of the grain post process
         */ this.GrainPostProcessId = "GrainPostProcessEffect";
        /**
         * Glow post process which adds a glow to emissive areas of the image
         */ this._glowLayer = null;
        /**
         * Animations which can be used to tweak settings over a period of time
         */ this.animations = [];
        this._imageProcessingConfigurationObserver = null;
        // Values
        this._sharpenEnabled = false;
        this._bloomEnabled = false;
        this._depthOfFieldEnabled = false;
        this._depthOfFieldBlurLevel = (0, $7Bej1.DepthOfFieldEffectBlurLevel).Low;
        this._fxaaEnabled = false;
        this._imageProcessingEnabled = true;
        this._bloomScale = 0.5;
        this._chromaticAberrationEnabled = false;
        this._grainEnabled = false;
        this._buildAllowed = true;
        /**
         * This is triggered each time the pipeline has been built.
         */ this.onBuildObservable = new (0, $diGQf.Observable)();
        this._resizeObserver = null;
        this._hardwareScaleLevel = 1.0;
        this._bloomKernel = 64;
        /**
         * Specifies the weight of the bloom in the final rendering
         */ this._bloomWeight = 0.15;
        /**
         * Specifies the luma threshold for the area that will be blurred by the bloom
         */ this._bloomThreshold = 0.9;
        this._samples = 1;
        this._hasCleared = false;
        this._prevPostProcess = null;
        this._prevPrevPostProcess = null;
        this._depthOfFieldSceneObserver = null;
        this._activeCameraChangedObserver = null;
        this._activeCamerasChangedObserver = null;
        this._cameras = cameras || scene.cameras;
        this._cameras = this._cameras.slice();
        this._camerasToBeAttached = this._cameras.slice();
        this._buildAllowed = automaticBuild;
        // Initialize
        this._scene = scene;
        const caps = this._scene.getEngine().getCaps();
        this._hdr = hdr && (caps.textureHalfFloatRender || caps.textureFloatRender);
        // Misc
        if (this._hdr) {
            if (caps.textureHalfFloatRender) this._defaultPipelineTextureType = 2;
            else if (caps.textureFloatRender) this._defaultPipelineTextureType = 1;
        } else this._defaultPipelineTextureType = 0;
        // Attach
        scene.postProcessRenderPipelineManager.addPipeline(this);
        const engine = this._scene.getEngine();
        // Create post processes before hand so they can be modified before enabled.
        // Block compilation flag is set to true to avoid compilation prior to use, these will be updated on first use in build pipeline.
        this.sharpen = new (0, $4sfRU.SharpenPostProcess)("sharpen", 1.0, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, engine, false, this._defaultPipelineTextureType, true);
        this._sharpenEffect = new (0, $81KKS.PostProcessRenderEffect)(engine, this.SharpenPostProcessId, ()=>{
            return this.sharpen;
        }, true);
        this.depthOfField = new (0, $7Bej1.DepthOfFieldEffect)(this._scene, null, this._depthOfFieldBlurLevel, this._defaultPipelineTextureType, true);
        // To keep the bloom sizes consistent across different display densities, factor in the hardware scaling level.
        this._hardwareScaleLevel = engine.getHardwareScalingLevel();
        this._resizeObserver = engine.onResizeObservable.add(()=>{
            this._hardwareScaleLevel = engine.getHardwareScalingLevel();
            this.bloomKernel = this._bloomKernel;
        });
        this.bloom = new (0, $1PCeL.BloomEffect)(this._scene, this._bloomScale, this._bloomWeight, this.bloomKernel / this._hardwareScaleLevel, this._defaultPipelineTextureType, true);
        this.chromaticAberration = new (0, $cjhmh.ChromaticAberrationPostProcess)("ChromaticAberration", engine.getRenderWidth(), engine.getRenderHeight(), 1.0, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, engine, false, this._defaultPipelineTextureType, true);
        this._chromaticAberrationEffect = new (0, $81KKS.PostProcessRenderEffect)(engine, this.ChromaticAberrationPostProcessId, ()=>{
            return this.chromaticAberration;
        }, true);
        this.grain = new (0, $gd6JN.GrainPostProcess)("Grain", 1.0, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, engine, false, this._defaultPipelineTextureType, true);
        this._grainEffect = new (0, $81KKS.PostProcessRenderEffect)(engine, this.GrainPostProcessId, ()=>{
            return this.grain;
        }, true);
        let avoidReentrancyAtConstructionTime = true;
        this._imageProcessingConfigurationObserver = this._scene.imageProcessingConfiguration.onUpdateParameters.add(()=>{
            this.bloom._downscale._exposure = this._scene.imageProcessingConfiguration.exposure;
            if (this.imageProcessingEnabled !== this._scene.imageProcessingConfiguration.isEnabled) {
                this._imageProcessingEnabled = this._scene.imageProcessingConfiguration.isEnabled;
                // Avoid re-entrant problems by deferring the call to _buildPipeline because the call to _buildPipeline
                // at the end of the constructor could end up triggering imageProcessingConfiguration.onUpdateParameters!
                // Note that the pipeline could have been disposed before the deferred call was executed, but in that case
                // _buildAllowed will have been set to false, preventing _buildPipeline from being executed.
                if (avoidReentrancyAtConstructionTime) (0, $bOhSV.Tools).SetImmediate(()=>{
                    this._buildPipeline();
                });
                else this._buildPipeline();
            }
        });
        this._buildPipeline();
        avoidReentrancyAtConstructionTime = false;
    }
    /**
     * Get the class name
     * @returns "DefaultRenderingPipeline"
     */ getClassName() {
        return "DefaultRenderingPipeline";
    }
    /**
     * Force the compilation of the entire pipeline.
     */ prepare() {
        const previousState = this._buildAllowed;
        this._buildAllowed = true;
        this._buildPipeline();
        this._buildAllowed = previousState;
    }
    _setAutoClearAndTextureSharing(postProcess, skipTextureSharing = false) {
        if (this._hasCleared) postProcess.autoClear = false;
        else {
            postProcess.autoClear = true;
            this._scene.autoClear = false;
            this._hasCleared = true;
        }
        if (!skipTextureSharing) {
            if (this._prevPrevPostProcess) postProcess.shareOutputWith(this._prevPrevPostProcess);
            else postProcess.useOwnOutput();
            if (this._prevPostProcess) this._prevPrevPostProcess = this._prevPostProcess;
            this._prevPostProcess = postProcess;
        }
    }
    _buildPipeline() {
        if (!this._buildAllowed) return;
        this._scene.autoClear = true;
        const engine = this._scene.getEngine();
        this._disposePostProcesses();
        if (this._cameras !== null) {
            this._scene.postProcessRenderPipelineManager.detachCamerasFromRenderPipeline(this._name, this._cameras);
            // get back cameras to be used to reattach pipeline
            this._cameras = this._camerasToBeAttached.slice();
        }
        this._reset();
        this._prevPostProcess = null;
        this._prevPrevPostProcess = null;
        this._hasCleared = false;
        if (this.depthOfFieldEnabled) {
            // Multi camera suport
            if (this._cameras.length > 1) {
                for (const camera of this._cameras){
                    const depthRenderer = this._scene.enableDepthRenderer(camera);
                    depthRenderer.useOnlyInActiveCamera = true;
                }
                this._depthOfFieldSceneObserver = this._scene.onAfterRenderTargetsRenderObservable.add((scene)=>{
                    if (this._cameras.indexOf(scene.activeCamera) > -1) this.depthOfField.depthTexture = scene.enableDepthRenderer(scene.activeCamera).getDepthMap();
                });
            } else {
                this._scene.onAfterRenderTargetsRenderObservable.remove(this._depthOfFieldSceneObserver);
                const depthRenderer = this._scene.enableDepthRenderer(this._cameras[0]);
                this.depthOfField.depthTexture = depthRenderer.getDepthMap();
            }
            if (!this.depthOfField._isReady()) this.depthOfField._updateEffects();
            this.addEffect(this.depthOfField);
            this._setAutoClearAndTextureSharing(this.depthOfField._effects[0], true);
        } else this._scene.onAfterRenderTargetsRenderObservable.remove(this._depthOfFieldSceneObserver);
        if (this.bloomEnabled) {
            if (!this.bloom._isReady()) this.bloom._updateEffects();
            this.addEffect(this.bloom);
            this._setAutoClearAndTextureSharing(this.bloom._effects[0], true);
        }
        if (this._imageProcessingEnabled) {
            this.imageProcessing = new (0, $ecirA.ImageProcessingPostProcess)("imageProcessing", 1.0, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, engine, false, this._defaultPipelineTextureType, this.scene.imageProcessingConfiguration);
            if (this._hdr) {
                this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(engine, this.ImageProcessingPostProcessId, ()=>{
                    return this.imageProcessing;
                }, true));
                this._setAutoClearAndTextureSharing(this.imageProcessing);
            } else this._scene.imageProcessingConfiguration.applyByPostProcess = false;
            if (!this._cameras || this._cameras.length === 0) this._scene.imageProcessingConfiguration.applyByPostProcess = false;
            if (!this.imageProcessing.getEffect()) this.imageProcessing._updateParameters();
        }
        if (this.sharpenEnabled) {
            if (!this.sharpen.isReady()) this.sharpen.updateEffect();
            this.addEffect(this._sharpenEffect);
            this._setAutoClearAndTextureSharing(this.sharpen);
        }
        if (this.grainEnabled) {
            if (!this.grain.isReady()) this.grain.updateEffect();
            this.addEffect(this._grainEffect);
            this._setAutoClearAndTextureSharing(this.grain);
        }
        if (this.chromaticAberrationEnabled) {
            if (!this.chromaticAberration.isReady()) this.chromaticAberration.updateEffect();
            this.addEffect(this._chromaticAberrationEffect);
            this._setAutoClearAndTextureSharing(this.chromaticAberration);
        }
        if (this.fxaaEnabled) {
            this.fxaa = new (0, $40XEW.FxaaPostProcess)("fxaa", 1.0, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, engine, false, this._defaultPipelineTextureType);
            this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(engine, this.FxaaPostProcessId, ()=>{
                return this.fxaa;
            }, true));
            this._setAutoClearAndTextureSharing(this.fxaa, true);
        }
        if (this._cameras !== null) this._scene.postProcessRenderPipelineManager.attachCamerasToRenderPipeline(this._name, this._cameras);
        // In multicamera mode, the scene needs to autoclear in between cameras.
        if (this._scene.activeCameras && this._scene.activeCameras.length > 1 || this._scene.activeCamera && this._cameras.indexOf(this._scene.activeCamera) === -1) this._scene.autoClear = true;
        // The active camera on the scene can be changed anytime
        if (!this._activeCameraChangedObserver) this._activeCameraChangedObserver = this._scene.onActiveCameraChanged.add(()=>{
            if (this._scene.activeCamera && this._cameras.indexOf(this._scene.activeCamera) === -1) this._scene.autoClear = true;
        });
        if (!this._activeCamerasChangedObserver) this._activeCamerasChangedObserver = this._scene.onActiveCamerasChanged.add(()=>{
            if (this._scene.activeCameras && this._scene.activeCameras.length > 1) this._scene.autoClear = true;
        });
        this._adaptPostProcessesToViewPort();
        if (!this._enableMSAAOnFirstPostProcess(this.samples) && this.samples > 1) (0, $kVtWi.Logger).Warn("MSAA failed to enable, MSAA is only supported in browsers that support webGL >= 2.0");
        this.onBuildObservable.notifyObservers(this);
    }
    _disposePostProcesses(disposeNonRecreated = false) {
        for(let i = 0; i < this._cameras.length; i++){
            const camera = this._cameras[i];
            if (this.imageProcessing) this.imageProcessing.dispose(camera);
            if (this.fxaa) this.fxaa.dispose(camera);
            // These are created in the constructor and should not be disposed on every pipeline change
            if (disposeNonRecreated) {
                if (this.sharpen) this.sharpen.dispose(camera);
                if (this.depthOfField) {
                    this._scene.onAfterRenderTargetsRenderObservable.remove(this._depthOfFieldSceneObserver);
                    this.depthOfField.disposeEffects(camera);
                }
                if (this.bloom) this.bloom.disposeEffects(camera);
                if (this.chromaticAberration) this.chromaticAberration.dispose(camera);
                if (this.grain) this.grain.dispose(camera);
                if (this._glowLayer) this._glowLayer.dispose();
            }
        }
        this.imageProcessing = null;
        this.fxaa = null;
        if (disposeNonRecreated) {
            this.sharpen = null;
            this._sharpenEffect = null;
            this.depthOfField = null;
            this.bloom = null;
            this.chromaticAberration = null;
            this._chromaticAberrationEffect = null;
            this.grain = null;
            this._grainEffect = null;
            this._glowLayer = null;
        }
    }
    /**
     * Adds a camera to the pipeline
     * @param camera the camera to be added
     */ addCamera(camera) {
        this._camerasToBeAttached.push(camera);
        this._buildPipeline();
    }
    /**
     * Removes a camera from the pipeline
     * @param camera the camera to remove
     */ removeCamera(camera) {
        const index = this._camerasToBeAttached.indexOf(camera);
        this._camerasToBeAttached.splice(index, 1);
        this._buildPipeline();
    }
    /**
     * Dispose of the pipeline and stop all post processes
     */ dispose() {
        this._buildAllowed = false;
        this.onBuildObservable.clear();
        this._disposePostProcesses(true);
        this._scene.postProcessRenderPipelineManager.detachCamerasFromRenderPipeline(this._name, this._cameras);
        this._scene._postProcessRenderPipelineManager.removePipeline(this.name);
        this._scene.autoClear = true;
        if (this._resizeObserver) {
            this._scene.getEngine().onResizeObservable.remove(this._resizeObserver);
            this._resizeObserver = null;
        }
        this._scene.onActiveCameraChanged.remove(this._activeCameraChangedObserver);
        this._scene.onActiveCamerasChanged.remove(this._activeCamerasChangedObserver);
        this._scene.imageProcessingConfiguration.onUpdateParameters.remove(this._imageProcessingConfigurationObserver);
        super.dispose();
    }
    /**
     * Serialize the rendering pipeline (Used when exporting)
     * @returns the serialized object
     */ serialize() {
        const serializationObject = (0, $6Ho1L.SerializationHelper).Serialize(this);
        serializationObject.customType = "DefaultRenderingPipeline";
        return serializationObject;
    }
    /**
     * Parse the serialized pipeline
     * @param source Source pipeline.
     * @param scene The scene to load the pipeline to.
     * @param rootUrl The URL of the serialized pipeline.
     * @returns An instantiated pipeline from the serialized object.
     */ static Parse(source, scene, rootUrl) {
        return (0, $6Ho1L.SerializationHelper).Parse(()=>new $9aa0f9629319f21a$export$2448c9c819f114e1(source._name, source._name._hdr, scene), source, scene, rootUrl);
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9aa0f9629319f21a$export$2448c9c819f114e1.prototype, "sharpenEnabled", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9aa0f9629319f21a$export$2448c9c819f114e1.prototype, "bloomKernel", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9aa0f9629319f21a$export$2448c9c819f114e1.prototype, "_bloomWeight", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9aa0f9629319f21a$export$2448c9c819f114e1.prototype, "_bloomThreshold", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9aa0f9629319f21a$export$2448c9c819f114e1.prototype, "_hdr", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9aa0f9629319f21a$export$2448c9c819f114e1.prototype, "bloomWeight", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9aa0f9629319f21a$export$2448c9c819f114e1.prototype, "bloomThreshold", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9aa0f9629319f21a$export$2448c9c819f114e1.prototype, "bloomScale", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9aa0f9629319f21a$export$2448c9c819f114e1.prototype, "bloomEnabled", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9aa0f9629319f21a$export$2448c9c819f114e1.prototype, "depthOfFieldEnabled", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9aa0f9629319f21a$export$2448c9c819f114e1.prototype, "depthOfFieldBlurLevel", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9aa0f9629319f21a$export$2448c9c819f114e1.prototype, "fxaaEnabled", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9aa0f9629319f21a$export$2448c9c819f114e1.prototype, "samples", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9aa0f9629319f21a$export$2448c9c819f114e1.prototype, "imageProcessingEnabled", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9aa0f9629319f21a$export$2448c9c819f114e1.prototype, "glowLayerEnabled", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9aa0f9629319f21a$export$2448c9c819f114e1.prototype, "chromaticAberrationEnabled", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9aa0f9629319f21a$export$2448c9c819f114e1.prototype, "grainEnabled", null);
(0, $8DoUR.RegisterClass)("BABYLON.DefaultRenderingPipeline", $9aa0f9629319f21a$export$2448c9c819f114e1);

});
parcelRegister("4sfRU", function(module, exports) {

$parcel$export(module.exports, "SharpenPostProcess", () => $33e6161dd63ed0d9$export$7f00bb3f44ba2d6b);

var $e0Suo = parcelRequire("e0Suo");

var $cFdBb = parcelRequire("cFdBb");
parcelRequire("i2AEf");

var $8DoUR = parcelRequire("8DoUR");

var $ir0rz = parcelRequire("ir0rz");

var $6Ho1L = parcelRequire("6Ho1L");
class $33e6161dd63ed0d9$export$7f00bb3f44ba2d6b extends (0, $cFdBb.PostProcess) {
    /**
     * Gets a string identifying the name of the class
     * @returns "SharpenPostProcess" string
     */ getClassName() {
        return "SharpenPostProcess";
    }
    /**
     * Creates a new instance ConvolutionPostProcess
     * @param name The name of the effect.
     * @param options The required width/height ratio to downsize to before computing the render pass.
     * @param camera The camera to apply the render pass to.
     * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
     * @param engine The engine which the post process will be applied. (default: current engine)
     * @param reusable If the post process can be reused on the same frame. (default: false)
     * @param textureType Type of textures used when performing the post process. (default: 0)
     * @param blockCompilation If compilation of the shader should not be done in the constructor. The updateEffect method can be used to compile the shader at a later time. (default: false)
     */ constructor(name, options, camera, samplingMode, engine, reusable, textureType = 0, blockCompilation = false){
        super(name, "sharpen", [
            "sharpnessAmounts",
            "screenSize"
        ], null, options, camera, samplingMode, engine, reusable, null, textureType, undefined, null, blockCompilation);
        /**
         * How much of the original color should be applied. Setting this to 0 will display edge detection. (default: 1)
         */ this.colorAmount = 1.0;
        /**
         * How much sharpness should be applied (default: 0.3)
         */ this.edgeAmount = 0.3;
        this.onApply = (effect)=>{
            effect.setFloat2("screenSize", this.width, this.height);
            effect.setFloat2("sharpnessAmounts", this.edgeAmount, this.colorAmount);
        };
    }
    /**
     * @internal
     */ static _Parse(parsedPostProcess, targetCamera, scene, rootUrl) {
        return (0, $6Ho1L.SerializationHelper).Parse(()=>{
            return new $33e6161dd63ed0d9$export$7f00bb3f44ba2d6b(parsedPostProcess.name, parsedPostProcess.options, targetCamera, parsedPostProcess.renderTargetSamplingMode, scene.getEngine(), parsedPostProcess.textureType, parsedPostProcess.reusable);
        }, parsedPostProcess, scene, rootUrl);
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $33e6161dd63ed0d9$export$7f00bb3f44ba2d6b.prototype, "colorAmount", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $33e6161dd63ed0d9$export$7f00bb3f44ba2d6b.prototype, "edgeAmount", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.SharpenPostProcess", $33e6161dd63ed0d9$export$7f00bb3f44ba2d6b);

});
parcelRegister("i2AEf", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $d224d77779619ed2$var$name = "sharpenPixelShader";
const $d224d77779619ed2$var$shader = `varying vec2 vUV;uniform sampler2D textureSampler;uniform vec2 screenSize;uniform vec2 sharpnessAmounts;
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{vec2 onePixel=vec2(1.0,1.0)/screenSize;vec4 color=texture2D(textureSampler,vUV);vec4 edgeDetection=texture2D(textureSampler,vUV+onePixel*vec2(0,-1)) +
texture2D(textureSampler,vUV+onePixel*vec2(-1,0)) +
texture2D(textureSampler,vUV+onePixel*vec2(1,0)) +
texture2D(textureSampler,vUV+onePixel*vec2(0,1)) -
color*4.0;gl_FragColor=max(vec4(color.rgb*sharpnessAmounts.y,color.a)-(sharpnessAmounts.x*vec4(edgeDetection.rgb,0)),0.);}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$d224d77779619ed2$var$name] = $d224d77779619ed2$var$shader;
const $d224d77779619ed2$export$3c33a933e0499842 = {
    name: $d224d77779619ed2$var$name,
    shader: $d224d77779619ed2$var$shader
};

});


parcelRegister("goDmg", function(module, exports) {

$parcel$export(module.exports, "PostProcessRenderPipeline", () => $befd6aedd7e87a94$export$709285ca76c4f32c);

var $e0Suo = parcelRequire("e0Suo");

var $bOhSV = parcelRequire("bOhSV");

var $ir0rz = parcelRequire("ir0rz");
class $befd6aedd7e87a94$export$709285ca76c4f32c {
    /**
     * Gets pipeline name
     */ get name() {
        return this._name;
    }
    /** Gets the list of attached cameras */ get cameras() {
        return this._cameras;
    }
    /**
     * Initializes a PostProcessRenderPipeline
     * @param _engine engine to add the pipeline to
     * @param name name of the pipeline
     */ constructor(_engine, name){
        this._engine = _engine;
        this._name = name;
        this._renderEffects = {};
        this._renderEffectsForIsolatedPass = new Array();
        this._cameras = [];
    }
    /**
     * Gets the class name
     * @returns "PostProcessRenderPipeline"
     */ getClassName() {
        return "PostProcessRenderPipeline";
    }
    /**
     * If all the render effects in the pipeline are supported
     */ get isSupported() {
        for(const renderEffectName in this._renderEffects)if (Object.prototype.hasOwnProperty.call(this._renderEffects, renderEffectName)) {
            if (!this._renderEffects[renderEffectName].isSupported) return false;
        }
        return true;
    }
    /**
     * Adds an effect to the pipeline
     * @param renderEffect the effect to add
     */ addEffect(renderEffect) {
        this._renderEffects[renderEffect._name] = renderEffect;
    }
    // private
    /** @internal */ _rebuild() {}
    /**
     * @internal
     */ _enableEffect(renderEffectName, cameras) {
        const renderEffects = this._renderEffects[renderEffectName];
        if (!renderEffects) return;
        renderEffects._enable((0, $bOhSV.Tools).MakeArray(cameras || this._cameras));
    }
    /**
     * @internal
     */ _disableEffect(renderEffectName, cameras) {
        const renderEffects = this._renderEffects[renderEffectName];
        if (!renderEffects) return;
        renderEffects._disable((0, $bOhSV.Tools).MakeArray(cameras || this._cameras));
    }
    /**
     * @internal
     */ _attachCameras(cameras, unique) {
        const cams = (0, $bOhSV.Tools).MakeArray(cameras || this._cameras);
        if (!cams) return;
        const indicesToDelete = [];
        let i;
        for(i = 0; i < cams.length; i++){
            const camera = cams[i];
            if (!camera) continue;
            if (this._cameras.indexOf(camera) === -1) this._cameras.push(camera);
            else if (unique) indicesToDelete.push(i);
        }
        for(i = 0; i < indicesToDelete.length; i++)cams.splice(indicesToDelete[i], 1);
        for(const renderEffectName in this._renderEffects)if (Object.prototype.hasOwnProperty.call(this._renderEffects, renderEffectName)) this._renderEffects[renderEffectName]._attachCameras(cams);
    }
    /**
     * @internal
     */ _detachCameras(cameras) {
        const cams = (0, $bOhSV.Tools).MakeArray(cameras || this._cameras);
        if (!cams) return;
        for(const renderEffectName in this._renderEffects)if (Object.prototype.hasOwnProperty.call(this._renderEffects, renderEffectName)) this._renderEffects[renderEffectName]._detachCameras(cams);
        for(let i = 0; i < cams.length; i++)this._cameras.splice(this._cameras.indexOf(cams[i]), 1);
    }
    /** @internal */ _update() {
        for(const renderEffectName in this._renderEffects)if (Object.prototype.hasOwnProperty.call(this._renderEffects, renderEffectName)) this._renderEffects[renderEffectName]._update();
        for(let i = 0; i < this._cameras.length; i++){
            if (!this._cameras[i]) continue;
            const cameraName = this._cameras[i].name;
            if (this._renderEffectsForIsolatedPass[cameraName]) this._renderEffectsForIsolatedPass[cameraName]._update();
        }
    }
    /** @internal */ _reset() {
        this._renderEffects = {};
        this._renderEffectsForIsolatedPass = new Array();
    }
    _enableMSAAOnFirstPostProcess(sampleCount) {
        if (!this._engine._features.supportMSAA) return false;
        // Set samples of the very first post process to 4 to enable native anti-aliasing in browsers that support webGL 2.0 (See: https://github.com/BabylonJS/Babylon.js/issues/3754)
        const effectKeys = Object.keys(this._renderEffects);
        if (effectKeys.length > 0) {
            const postProcesses = this._renderEffects[effectKeys[0]].getPostProcesses();
            if (postProcesses) postProcesses[0].samples = sampleCount;
        }
        return true;
    }
    /**
     * Ensures that all post processes in the pipeline are the correct size according to the
     * the viewport's required size
     */ _adaptPostProcessesToViewPort() {
        const effectKeys = Object.keys(this._renderEffects);
        for (const effectKey of effectKeys){
            const postProcesses = this._renderEffects[effectKey].getPostProcesses();
            if (postProcesses) for (const postProcess of postProcesses)postProcess.adaptScaleToCurrentViewport = true;
        }
    }
    /**
     * Sets the required values to the prepass renderer.
     * @param prePassRenderer defines the prepass renderer to setup.
     * @returns true if the pre pass is needed.
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setPrePassRenderer(prePassRenderer) {
        // Do Nothing by default
        return false;
    }
    /**
     * Disposes of the pipeline
     */ dispose() {
    // Must be implemented by children
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $befd6aedd7e87a94$export$709285ca76c4f32c.prototype, "_name", void 0);

});

parcelRegister("hD3tI", function(module, exports) {

$parcel$export(module.exports, "PostProcessRenderPipelineManagerSceneComponent", () => $cd58c6e83b6eb739$export$fd903b0da559a9b4);

var $bv05l = parcelRequire("bv05l");

var $itwQC = parcelRequire("itwQC");

var $gmbCk = parcelRequire("gmbCk");
Object.defineProperty((0, $gmbCk.Scene).prototype, "postProcessRenderPipelineManager", {
    get: function() {
        if (!this._postProcessRenderPipelineManager) {
            // Register the G Buffer component to the scene.
            let component = this._getComponent((0, $bv05l.SceneComponentConstants).NAME_POSTPROCESSRENDERPIPELINEMANAGER);
            if (!component) {
                component = new $cd58c6e83b6eb739$export$fd903b0da559a9b4(this);
                this._addComponent(component);
            }
            this._postProcessRenderPipelineManager = new (0, $itwQC.PostProcessRenderPipelineManager)();
        }
        return this._postProcessRenderPipelineManager;
    },
    enumerable: true,
    configurable: true
});
class $cd58c6e83b6eb739$export$fd903b0da559a9b4 {
    /**
     * Creates a new instance of the component for the given scene
     * @param scene Defines the scene to register the component in
     */ constructor(scene){
        /**
         * The component name helpful to identify the component in the list of scene components.
         */ this.name = (0, $bv05l.SceneComponentConstants).NAME_POSTPROCESSRENDERPIPELINEMANAGER;
        this.scene = scene;
    }
    /**
     * Registers the component in a given scene
     */ register() {
        this.scene._gatherRenderTargetsStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_GATHERRENDERTARGETS_POSTPROCESSRENDERPIPELINEMANAGER, this, this._gatherRenderTargets);
    }
    /**
     * Rebuilds the elements related to this component in case of
     * context lost for instance.
     */ rebuild() {
        if (this.scene._postProcessRenderPipelineManager) this.scene._postProcessRenderPipelineManager._rebuild();
    }
    /**
     * Disposes the component and the associated resources
     */ dispose() {
        if (this.scene._postProcessRenderPipelineManager) this.scene._postProcessRenderPipelineManager.dispose();
    }
    _gatherRenderTargets() {
        if (this.scene._postProcessRenderPipelineManager) this.scene._postProcessRenderPipelineManager.update();
    }
}

});
parcelRegister("itwQC", function(module, exports) {

$parcel$export(module.exports, "PostProcessRenderPipelineManager", () => $d7346a4c75d6f8e8$export$a5fb9faf0fec147c);
/**
 * PostProcessRenderPipelineManager class
 * @see https://doc.babylonjs.com/features/featuresDeepDive/postProcesses/postProcessRenderPipeline
 */ class $d7346a4c75d6f8e8$export$a5fb9faf0fec147c {
    /**
     * Initializes a PostProcessRenderPipelineManager
     * @see https://doc.babylonjs.com/features/featuresDeepDive/postProcesses/postProcessRenderPipeline
     */ constructor(){
        this._renderPipelines = {};
    }
    /**
     * Gets the list of supported render pipelines
     */ get supportedPipelines() {
        const result = [];
        for(const renderPipelineName in this._renderPipelines)if (Object.prototype.hasOwnProperty.call(this._renderPipelines, renderPipelineName)) {
            const pipeline = this._renderPipelines[renderPipelineName];
            if (pipeline.isSupported) result.push(pipeline);
        }
        return result;
    }
    /**
     * Adds a pipeline to the manager
     * @param renderPipeline The pipeline to add
     */ addPipeline(renderPipeline) {
        this._renderPipelines[renderPipeline._name] = renderPipeline;
    }
    /**
     * Remove the pipeline from the manager
     * @param renderPipelineName the name of the pipeline to remove
     */ removePipeline(renderPipelineName) {
        delete this._renderPipelines[renderPipelineName];
    }
    /**
     * Attaches a camera to the pipeline
     * @param renderPipelineName The name of the pipeline to attach to
     * @param cameras the camera to attach
     * @param unique if the camera can be attached multiple times to the pipeline
     */ attachCamerasToRenderPipeline(renderPipelineName, cameras, unique = false) {
        const renderPipeline = this._renderPipelines[renderPipelineName];
        if (!renderPipeline) return;
        renderPipeline._attachCameras(cameras, unique);
    }
    /**
     * Detaches a camera from the pipeline
     * @param renderPipelineName The name of the pipeline to detach from
     * @param cameras the camera to detach
     */ detachCamerasFromRenderPipeline(renderPipelineName, cameras) {
        const renderPipeline = this._renderPipelines[renderPipelineName];
        if (!renderPipeline) return;
        renderPipeline._detachCameras(cameras);
    }
    /**
     * Enables an effect by name on a pipeline
     * @param renderPipelineName the name of the pipeline to enable the effect in
     * @param renderEffectName the name of the effect to enable
     * @param cameras the cameras that the effect should be enabled on
     */ enableEffectInPipeline(renderPipelineName, renderEffectName, cameras) {
        const renderPipeline = this._renderPipelines[renderPipelineName];
        if (!renderPipeline) return;
        renderPipeline._enableEffect(renderEffectName, cameras);
    }
    /**
     * Disables an effect by name on a pipeline
     * @param renderPipelineName the name of the pipeline to disable the effect in
     * @param renderEffectName the name of the effect to disable
     * @param cameras the cameras that the effect should be disabled on
     */ disableEffectInPipeline(renderPipelineName, renderEffectName, cameras) {
        const renderPipeline = this._renderPipelines[renderPipelineName];
        if (!renderPipeline) return;
        renderPipeline._disableEffect(renderEffectName, cameras);
    }
    /**
     * Updates the state of all contained render pipelines and disposes of any non supported pipelines
     */ update() {
        for(const renderPipelineName in this._renderPipelines)if (Object.prototype.hasOwnProperty.call(this._renderPipelines, renderPipelineName)) {
            const pipeline = this._renderPipelines[renderPipelineName];
            if (!pipeline.isSupported) {
                pipeline.dispose();
                delete this._renderPipelines[renderPipelineName];
            } else pipeline._update();
        }
    }
    /** @internal */ _rebuild() {
        for(const renderPipelineName in this._renderPipelines)if (Object.prototype.hasOwnProperty.call(this._renderPipelines, renderPipelineName)) {
            const pipeline = this._renderPipelines[renderPipelineName];
            pipeline._rebuild();
        }
    }
    /**
     * Disposes of the manager and pipelines
     */ dispose() {
        for(const renderPipelineName in this._renderPipelines)if (Object.prototype.hasOwnProperty.call(this._renderPipelines, renderPipelineName)) {
            const pipeline = this._renderPipelines[renderPipelineName];
            pipeline.dispose();
        }
    }
}

});



parcelRegister("jPTYQ", function(module, exports) {

$parcel$export(module.exports, "LensRenderingPipeline", () => $e70e3448d0563652$export$c648131629e23382);

var $j2mX5 = parcelRequire("j2mX5");

var $cFdBb = parcelRequire("cFdBb");

var $goDmg = parcelRequire("goDmg");

var $81KKS = parcelRequire("81KKS");

var $5Egpj = parcelRequire("5Egpj");
parcelRequire("hD3tI");
parcelRequire("kTmJO");
parcelRequire("fW9sU");
parcelRequire("f63QJ");

var $1VEEL = parcelRequire("1VEEL");
class $e70e3448d0563652$export$c648131629e23382 extends (0, $goDmg.PostProcessRenderPipeline) {
    /**
     * @constructor
     *
     * Effect parameters are as follow:
     * {
     *      chromatic_aberration: number;       // from 0 to x (1 for realism)
     *      edge_blur: number;                  // from 0 to x (1 for realism)
     *      distortion: number;                 // from 0 to x (1 for realism), note that this will effect the pointer position precision
     *      grain_amount: number;               // from 0 to 1
     *      grain_texture: BABYLON.Texture;     // texture to use for grain effect; if unset, use random B&W noise
     *      dof_focus_distance: number;         // depth-of-field: focus distance; unset to disable (disabled by default)
     *      dof_aperture: number;               // depth-of-field: focus blur bias (default: 1)
     *      dof_darken: number;                 // depth-of-field: darken that which is out of focus (from 0 to 1, disabled by default)
     *      dof_pentagon: boolean;              // depth-of-field: makes a pentagon-like "bokeh" effect
     *      dof_gain: number;                   // depth-of-field: highlights gain; unset to disable (disabled by default)
     *      dof_threshold: number;              // depth-of-field: highlights threshold (default: 1)
     *      blur_noise: boolean;                // add a little bit of noise to the blur (default: true)
     * }
     * Note: if an effect parameter is unset, effect is disabled
     *
     * @param name The rendering pipeline name
     * @param parameters - An object containing all parameters (see above)
     * @param scene The scene linked to this pipeline
     * @param ratio The size of the postprocesses (0.5 means that your postprocess will have a width = canvas.width 0.5 and a height = canvas.height 0.5)
     * @param cameras The array of cameras that the rendering pipeline will be attached to
     */ constructor(name, parameters, scene, ratio = 1.0, cameras){
        super(scene.getEngine(), name);
        // Lens effects can be of the following:
        // - chromatic aberration (slight shift of RGB colors)
        // - blur on the edge of the lens
        // - lens distortion
        // - depth-of-field blur & highlights enhancing
        // - depth-of-field 'bokeh' effect (shapes appearing in blurred areas)
        // - grain effect (noise or custom texture)
        // Two additional texture samplers are needed:
        // - depth map (for depth-of-field)
        // - grain texture
        /**
         * @ignore
         * The chromatic aberration PostProcess id in the pipeline
         */ this.LensChromaticAberrationEffect = "LensChromaticAberrationEffect";
        /**
         * @ignore
         * The highlights enhancing PostProcess id in the pipeline
         */ this.HighlightsEnhancingEffect = "HighlightsEnhancingEffect";
        /**
         * @ignore
         * The depth-of-field PostProcess id in the pipeline
         */ this.LensDepthOfFieldEffect = "LensDepthOfFieldEffect";
        this._pentagonBokehIsEnabled = false;
        this._scene = scene;
        // Fetch texture samplers
        this._depthTexture = scene.enableDepthRenderer().getDepthMap(); // Force depth renderer "on"
        if (parameters.grain_texture) this._grainTexture = parameters.grain_texture;
        else this._createGrainTexture();
        // save parameters
        this._edgeBlur = parameters.edge_blur ? parameters.edge_blur : 0;
        this._grainAmount = parameters.grain_amount ? parameters.grain_amount : 0;
        this._chromaticAberration = parameters.chromatic_aberration ? parameters.chromatic_aberration : 0;
        this._distortion = parameters.distortion ? parameters.distortion : 0;
        this._highlightsGain = parameters.dof_gain !== undefined ? parameters.dof_gain : -1;
        this._highlightsThreshold = parameters.dof_threshold ? parameters.dof_threshold : 1;
        this._dofDistance = parameters.dof_focus_distance !== undefined ? parameters.dof_focus_distance : -1;
        this._dofAperture = parameters.dof_aperture ? parameters.dof_aperture : 1;
        this._dofDarken = parameters.dof_darken ? parameters.dof_darken : 0;
        this._dofPentagon = parameters.dof_pentagon !== undefined ? parameters.dof_pentagon : true;
        this._blurNoise = parameters.blur_noise !== undefined ? parameters.blur_noise : true;
        // Create effects
        this._createChromaticAberrationPostProcess(ratio);
        this._createHighlightsPostProcess(ratio);
        this._createDepthOfFieldPostProcess(ratio / 4);
        // Set up pipeline
        this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(scene.getEngine(), this.LensChromaticAberrationEffect, ()=>{
            return this._chromaticAberrationPostProcess;
        }, true));
        this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(scene.getEngine(), this.HighlightsEnhancingEffect, ()=>{
            return this._highlightsPostProcess;
        }, true));
        this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(scene.getEngine(), this.LensDepthOfFieldEffect, ()=>{
            return this._depthOfFieldPostProcess;
        }, true));
        if (this._highlightsGain === -1) this._disableEffect(this.HighlightsEnhancingEffect, null);
        // Finish
        scene.postProcessRenderPipelineManager.addPipeline(this);
        if (cameras) scene.postProcessRenderPipelineManager.attachCamerasToRenderPipeline(name, cameras);
    }
    /**
     * Get the class name
     * @returns "LensRenderingPipeline"
     */ getClassName() {
        return "LensRenderingPipeline";
    }
    // Properties
    /**
     * Gets associated scene
     */ get scene() {
        return this._scene;
    }
    /**
     * Gets or sets the edge blur
     */ get edgeBlur() {
        return this._edgeBlur;
    }
    set edgeBlur(value) {
        this.setEdgeBlur(value);
    }
    /**
     * Gets or sets the grain amount
     */ get grainAmount() {
        return this._grainAmount;
    }
    set grainAmount(value) {
        this.setGrainAmount(value);
    }
    /**
     * Gets or sets the chromatic aberration amount
     */ get chromaticAberration() {
        return this._chromaticAberration;
    }
    set chromaticAberration(value) {
        this.setChromaticAberration(value);
    }
    /**
     * Gets or sets the depth of field aperture
     */ get dofAperture() {
        return this._dofAperture;
    }
    set dofAperture(value) {
        this.setAperture(value);
    }
    /**
     * Gets or sets the edge distortion
     */ get edgeDistortion() {
        return this._distortion;
    }
    set edgeDistortion(value) {
        this.setEdgeDistortion(value);
    }
    /**
     * Gets or sets the depth of field distortion
     */ get dofDistortion() {
        return this._dofDistance;
    }
    set dofDistortion(value) {
        this.setFocusDistance(value);
    }
    /**
     * Gets or sets the darken out of focus amount
     */ get darkenOutOfFocus() {
        return this._dofDarken;
    }
    set darkenOutOfFocus(value) {
        this.setDarkenOutOfFocus(value);
    }
    /**
     * Gets or sets a boolean indicating if blur noise is enabled
     */ get blurNoise() {
        return this._blurNoise;
    }
    set blurNoise(value) {
        this._blurNoise = value;
    }
    /**
     * Gets or sets a boolean indicating if pentagon bokeh is enabled
     */ get pentagonBokeh() {
        return this._pentagonBokehIsEnabled;
    }
    set pentagonBokeh(value) {
        if (value) this.enablePentagonBokeh();
        else this.disablePentagonBokeh();
    }
    /**
     * Gets or sets the highlight grain amount
     */ get highlightsGain() {
        return this._highlightsGain;
    }
    set highlightsGain(value) {
        this.setHighlightsGain(value);
    }
    /**
     * Gets or sets the highlight threshold
     */ get highlightsThreshold() {
        return this._highlightsThreshold;
    }
    set highlightsThreshold(value) {
        this.setHighlightsThreshold(value);
    }
    // public methods (self explanatory)
    /**
     * Sets the amount of blur at the edges
     * @param amount blur amount
     */ setEdgeBlur(amount) {
        this._edgeBlur = amount;
    }
    /**
     * Sets edge blur to 0
     */ disableEdgeBlur() {
        this._edgeBlur = 0;
    }
    /**
     * Sets the amount of grain
     * @param amount Amount of grain
     */ setGrainAmount(amount) {
        this._grainAmount = amount;
    }
    /**
     * Set grain amount to 0
     */ disableGrain() {
        this._grainAmount = 0;
    }
    /**
     * Sets the chromatic aberration amount
     * @param amount amount of chromatic aberration
     */ setChromaticAberration(amount) {
        this._chromaticAberration = amount;
    }
    /**
     * Sets chromatic aberration amount to 0
     */ disableChromaticAberration() {
        this._chromaticAberration = 0;
    }
    /**
     * Sets the EdgeDistortion amount
     * @param amount amount of EdgeDistortion
     */ setEdgeDistortion(amount) {
        this._distortion = amount;
    }
    /**
     * Sets edge distortion to 0
     */ disableEdgeDistortion() {
        this._distortion = 0;
    }
    /**
     * Sets the FocusDistance amount
     * @param amount amount of FocusDistance
     */ setFocusDistance(amount) {
        this._dofDistance = amount;
    }
    /**
     * Disables depth of field
     */ disableDepthOfField() {
        this._dofDistance = -1;
    }
    /**
     * Sets the Aperture amount
     * @param amount amount of Aperture
     */ setAperture(amount) {
        this._dofAperture = amount;
    }
    /**
     * Sets the DarkenOutOfFocus amount
     * @param amount amount of DarkenOutOfFocus
     */ setDarkenOutOfFocus(amount) {
        this._dofDarken = amount;
    }
    /**
     * Creates a pentagon bokeh effect
     */ enablePentagonBokeh() {
        this._highlightsPostProcess.updateEffect("#define PENTAGON\n");
        this._pentagonBokehIsEnabled = true;
    }
    /**
     * Disables the pentagon bokeh effect
     */ disablePentagonBokeh() {
        this._pentagonBokehIsEnabled = false;
        this._highlightsPostProcess.updateEffect();
    }
    /**
     * Enables noise blur
     */ enableNoiseBlur() {
        this._blurNoise = true;
    }
    /**
     * Disables noise blur
     */ disableNoiseBlur() {
        this._blurNoise = false;
    }
    /**
     * Sets the HighlightsGain amount
     * @param amount amount of HighlightsGain
     */ setHighlightsGain(amount) {
        this._highlightsGain = amount;
    }
    /**
     * Sets the HighlightsThreshold amount
     * @param amount amount of HighlightsThreshold
     */ setHighlightsThreshold(amount) {
        if (this._highlightsGain === -1) this._highlightsGain = 1.0;
        this._highlightsThreshold = amount;
    }
    /**
     * Disables highlights
     */ disableHighlights() {
        this._highlightsGain = -1;
    }
    /**
     * Removes the internal pipeline assets and detaches the pipeline from the scene cameras
     * @param disableDepthRender If the scene's depth rendering should be disabled (default: false)
     */ dispose(disableDepthRender = false) {
        this._scene.postProcessRenderPipelineManager.detachCamerasFromRenderPipeline(this._name, this._scene.cameras);
        this._chromaticAberrationPostProcess = null;
        this._highlightsPostProcess = null;
        this._depthOfFieldPostProcess = null;
        this._grainTexture.dispose();
        if (disableDepthRender) this._scene.disableDepthRenderer();
    }
    // colors shifting and distortion
    _createChromaticAberrationPostProcess(ratio) {
        this._chromaticAberrationPostProcess = new (0, $cFdBb.PostProcess)("LensChromaticAberration", "chromaticAberration", [
            "chromatic_aberration",
            "screen_width",
            "screen_height",
            "direction",
            "radialIntensity",
            "centerPosition"
        ], [], ratio, null, (0, $j2mX5.Texture).TRILINEAR_SAMPLINGMODE, this._scene.getEngine(), false);
        this._chromaticAberrationPostProcess.onApply = (effect)=>{
            effect.setFloat("chromatic_aberration", this._chromaticAberration);
            effect.setFloat("screen_width", this._scene.getEngine().getRenderWidth());
            effect.setFloat("screen_height", this._scene.getEngine().getRenderHeight());
            effect.setFloat("radialIntensity", 1);
            effect.setFloat2("direction", 17, 17);
            effect.setFloat2("centerPosition", 0.5, 0.5);
        };
    }
    // highlights enhancing
    _createHighlightsPostProcess(ratio) {
        this._highlightsPostProcess = new (0, $cFdBb.PostProcess)("LensHighlights", "lensHighlights", [
            "gain",
            "threshold",
            "screen_width",
            "screen_height"
        ], [], ratio, null, (0, $j2mX5.Texture).TRILINEAR_SAMPLINGMODE, this._scene.getEngine(), false, this._dofPentagon ? "#define PENTAGON\n" : "");
        this._highlightsPostProcess.externalTextureSamplerBinding = true;
        this._highlightsPostProcess.onApply = (effect)=>{
            effect.setFloat("gain", this._highlightsGain);
            effect.setFloat("threshold", this._highlightsThreshold);
            effect.setTextureFromPostProcess("textureSampler", this._chromaticAberrationPostProcess);
            effect.setFloat("screen_width", this._scene.getEngine().getRenderWidth());
            effect.setFloat("screen_height", this._scene.getEngine().getRenderHeight());
        };
    }
    // colors shifting and distortion
    _createDepthOfFieldPostProcess(ratio) {
        this._depthOfFieldPostProcess = new (0, $cFdBb.PostProcess)("LensDepthOfField", "depthOfField", [
            "grain_amount",
            "blur_noise",
            "screen_width",
            "screen_height",
            "distortion",
            "dof_enabled",
            "screen_distance",
            "aperture",
            "darken",
            "edge_blur",
            "highlights",
            "near",
            "far"
        ], [
            "depthSampler",
            "grainSampler",
            "highlightsSampler"
        ], ratio, null, (0, $j2mX5.Texture).TRILINEAR_SAMPLINGMODE, this._scene.getEngine(), false);
        this._depthOfFieldPostProcess.externalTextureSamplerBinding = true;
        this._depthOfFieldPostProcess.onApply = (effect)=>{
            effect.setTexture("depthSampler", this._depthTexture);
            effect.setTexture("grainSampler", this._grainTexture);
            effect.setTextureFromPostProcess("textureSampler", this._highlightsPostProcess);
            effect.setTextureFromPostProcess("highlightsSampler", this._depthOfFieldPostProcess);
            effect.setFloat("grain_amount", this._grainAmount);
            effect.setBool("blur_noise", this._blurNoise);
            effect.setFloat("screen_width", this._scene.getEngine().getRenderWidth());
            effect.setFloat("screen_height", this._scene.getEngine().getRenderHeight());
            effect.setFloat("distortion", this._distortion);
            effect.setBool("dof_enabled", this._dofDistance !== -1);
            effect.setFloat("screen_distance", 1.0 / (0.1 - 1.0 / this._dofDistance));
            effect.setFloat("aperture", this._dofAperture);
            effect.setFloat("darken", this._dofDarken);
            effect.setFloat("edge_blur", this._edgeBlur);
            effect.setBool("highlights", this._highlightsGain !== -1);
            if (this._scene.activeCamera) {
                effect.setFloat("near", this._scene.activeCamera.minZ);
                effect.setFloat("far", this._scene.activeCamera.maxZ);
            }
        };
    }
    // creates a black and white random noise texture, 512x512
    _createGrainTexture() {
        const size = 512;
        const data = new Uint8Array(size * size * 4);
        for(let index = 0; index < data.length;){
            const value = Math.floor((0, $1VEEL.Scalar).RandomRange(0.42, 0.58) * 255);
            data[index++] = value;
            data[index++] = value;
            data[index++] = value;
            data[index++] = 255;
        }
        const texture = (0, $5Egpj.RawTexture).CreateRGBATexture(data, size, size, this._scene, false, false, 2);
        texture.name = "LensNoiseTexture";
        texture.wrapU = (0, $j2mX5.Texture).WRAP_ADDRESSMODE;
        texture.wrapV = (0, $j2mX5.Texture).WRAP_ADDRESSMODE;
        this._grainTexture = texture;
    }
}

});
parcelRegister("fW9sU", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $b9a39d6b0202de98$var$name = "lensHighlightsPixelShader";
const $b9a39d6b0202de98$var$shader = `uniform sampler2D textureSampler; 
uniform float gain;uniform float threshold;uniform float screen_width;uniform float screen_height;varying vec2 vUV;vec4 highlightColor(vec4 color) {vec4 highlight=color;float luminance=dot(highlight.rgb,vec3(0.2125,0.7154,0.0721));float lum_threshold;if (threshold>1.0) { lum_threshold=0.94+0.01*threshold; }
else { lum_threshold=0.5+0.44*threshold; }
luminance=clamp((luminance-lum_threshold)*(1.0/(1.0-lum_threshold)),0.0,1.0);highlight*=luminance*gain;highlight.a=1.0;return highlight;}
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{vec4 original=texture2D(textureSampler,vUV);if (gain==-1.0) {gl_FragColor=vec4(0.0,0.0,0.0,1.0);return;}
float w=2.0/screen_width;float h=2.0/screen_height;float weight=1.0;vec4 blurred=vec4(0.0,0.0,0.0,0.0);
#ifdef PENTAGON
blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-0.84*w,0.43*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(0.48*w,-1.29*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(0.61*w,1.51*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-1.55*w,-0.74*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(1.71*w,-0.52*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-0.94*w,1.59*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-0.40*w,-1.87*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(1.62*w,1.16*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-2.09*w,0.25*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(1.46*w,-1.71*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(0.08*w,2.42*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-1.85*w,-1.89*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(2.89*w,0.16*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-2.29*w,1.88*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(0.40*w,-2.81*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(1.54*w,2.26*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-2.60*w,-0.61*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(2.31*w,-1.30*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-0.83*w,2.53*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-1.12*w,-2.48*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(2.60*w,1.11*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-2.82*w,0.99*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(1.50*w,-2.81*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(0.85*w,3.33*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-2.94*w,-1.92*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(3.27*w,-0.53*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-1.95*w,2.48*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-0.23*w,-3.04*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(2.17*w,2.05*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-2.97*w,-0.04*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(2.25*w,-2.00*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-0.31*w,3.08*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-1.94*w,-2.59*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(3.37*w,0.64*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-3.13*w,1.93*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(1.03*w,-3.65*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(1.60*w,3.17*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-3.14*w,-1.19*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(3.00*w,-1.19*h)));
#else
blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-0.85*w,0.36*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(0.52*w,-1.14*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(0.46*w,1.42*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-1.46*w,-0.83*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(1.79*w,-0.42*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-1.11*w,1.62*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-0.29*w,-2.07*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(1.69*w,1.39*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-2.28*w,0.12*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(1.65*w,-1.69*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-0.08*w,2.44*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-1.63*w,-1.90*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(2.55*w,0.31*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-2.13*w,1.52*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(0.56*w,-2.61*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(1.38*w,2.34*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-2.64*w,-0.81*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(2.53*w,-1.21*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-1.06*w,2.63*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-1.00*w,-2.69*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(2.59*w,1.32*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-2.82*w,0.78*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(1.57*w,-2.50*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(0.54*w,2.93*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-2.39*w,-1.81*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(3.01*w,-0.28*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-2.04*w,2.25*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-0.02*w,-3.05*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(2.09*w,2.25*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-3.07*w,-0.25*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(2.44*w,-1.90*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-0.52*w,3.05*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-1.68*w,-2.61*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(3.01*w,0.79*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-2.76*w,1.46*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(1.05*w,-2.94*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(1.21*w,2.88*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(-2.84*w,-1.30*h)));blurred+=highlightColor(texture2D(textureSampler,vUV+vec2(2.98*w,-0.96*h)));
#endif
blurred/=39.0;gl_FragColor=blurred;}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$b9a39d6b0202de98$var$name] = $b9a39d6b0202de98$var$shader;
const $b9a39d6b0202de98$export$119e555d893b0285 = {
    name: $b9a39d6b0202de98$var$name,
    shader: $b9a39d6b0202de98$var$shader
};

});

parcelRegister("f63QJ", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $afda66f662e32aa0$var$name = "depthOfFieldPixelShader";
const $afda66f662e32aa0$var$shader = `uniform sampler2D textureSampler;uniform sampler2D highlightsSampler;uniform sampler2D depthSampler;uniform sampler2D grainSampler;uniform float grain_amount;uniform bool blur_noise;uniform float screen_width;uniform float screen_height;uniform float distortion;uniform bool dof_enabled;uniform float screen_distance; 
uniform float aperture;uniform float darken;uniform float edge_blur;uniform bool highlights;uniform float near;uniform float far;varying vec2 vUV;
#define PI 3.14159265
#define TWOPI 6.28318530
#define inverse_focal_length 0.1 
vec2 centered_screen_pos;vec2 distorted_coords;float radius2;float radius;vec2 rand(vec2 co)
{float noise1=(fract(sin(dot(co,vec2(12.9898,78.233)))*43758.5453));float noise2=(fract(sin(dot(co,vec2(12.9898,78.233)*2.0))*43758.5453));return clamp(vec2(noise1,noise2),0.0,1.0);}
vec2 getDistortedCoords(vec2 coords) {if (distortion==0.0) { return coords; }
vec2 direction=1.0*normalize(centered_screen_pos);vec2 dist_coords=vec2(0.5,0.5);dist_coords.x=0.5+direction.x*radius2*1.0;dist_coords.y=0.5+direction.y*radius2*1.0;float dist_amount=clamp(distortion*0.23,0.0,1.0);dist_coords=mix(coords,dist_coords,dist_amount);return dist_coords;}
float sampleScreen(inout vec4 color,in vec2 offset,in float weight) {vec2 coords=distorted_coords;float angle=rand(coords*100.0).x*TWOPI;coords+=vec2(offset.x*cos(angle)-offset.y*sin(angle),offset.x*sin(angle)+offset.y*cos(angle));color+=texture2D(textureSampler,coords)*weight;return weight;}
float getBlurLevel(float size) {return min(3.0,ceil(size/1.0));}
vec4 getBlurColor(float size) {vec4 col=texture2D(textureSampler,distorted_coords);float blur_level=getBlurLevel(size);float w=(size/screen_width);float h=(size/screen_height);float total_weight=1.0;vec2 sample_coords;total_weight+=sampleScreen(col,vec2(-0.50*w,0.24*h),0.93);total_weight+=sampleScreen(col,vec2(0.30*w,-0.75*h),0.90);total_weight+=sampleScreen(col,vec2(0.36*w,0.96*h),0.87);total_weight+=sampleScreen(col,vec2(-1.08*w,-0.55*h),0.85);total_weight+=sampleScreen(col,vec2(1.33*w,-0.37*h),0.83);total_weight+=sampleScreen(col,vec2(-0.82*w,1.31*h),0.80);total_weight+=sampleScreen(col,vec2(-0.31*w,-1.67*h),0.78);total_weight+=sampleScreen(col,vec2(1.47*w,1.11*h),0.76);total_weight+=sampleScreen(col,vec2(-1.97*w,0.19*h),0.74);total_weight+=sampleScreen(col,vec2(1.42*w,-1.57*h),0.72);if (blur_level>1.0) {total_weight+=sampleScreen(col,vec2(0.01*w,2.25*h),0.70);total_weight+=sampleScreen(col,vec2(-1.62*w,-1.74*h),0.67);total_weight+=sampleScreen(col,vec2(2.49*w,0.20*h),0.65);total_weight+=sampleScreen(col,vec2(-2.07*w,1.61*h),0.63);total_weight+=sampleScreen(col,vec2(0.46*w,-2.70*h),0.61);total_weight+=sampleScreen(col,vec2(1.55*w,2.40*h),0.59);total_weight+=sampleScreen(col,vec2(-2.88*w,-0.75*h),0.56);total_weight+=sampleScreen(col,vec2(2.73*w,-1.44*h),0.54);total_weight+=sampleScreen(col,vec2(-1.08*w,3.02*h),0.52);total_weight+=sampleScreen(col,vec2(-1.28*w,-3.05*h),0.49);}
if (blur_level>2.0) {total_weight+=sampleScreen(col,vec2(3.11*w,1.43*h),0.46);total_weight+=sampleScreen(col,vec2(-3.36*w,1.08*h),0.44);total_weight+=sampleScreen(col,vec2(1.80*w,-3.16*h),0.41);total_weight+=sampleScreen(col,vec2(0.83*w,3.65*h),0.38);total_weight+=sampleScreen(col,vec2(-3.16*w,-2.19*h),0.34);total_weight+=sampleScreen(col,vec2(3.92*w,-0.53*h),0.31);total_weight+=sampleScreen(col,vec2(-2.59*w,3.12*h),0.26);total_weight+=sampleScreen(col,vec2(-0.20*w,-4.15*h),0.22);total_weight+=sampleScreen(col,vec2(3.02*w,3.00*h),0.15);}
col/=total_weight; 
if (darken>0.0) {col.rgb*=clamp(0.3,1.0,1.05-size*0.5*darken);}
return col;}
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{centered_screen_pos=vec2(vUV.x-0.5,vUV.y-0.5);radius2=centered_screen_pos.x*centered_screen_pos.x+centered_screen_pos.y*centered_screen_pos.y;radius=sqrt(radius2);distorted_coords=getDistortedCoords(vUV); 
vec2 texels_coords=vec2(vUV.x*screen_width,vUV.y*screen_height); 
float depth=texture2D(depthSampler,distorted_coords).r; 
float distance=near+(far-near)*depth; 
vec4 color=texture2D(textureSampler,vUV); 
float coc=abs(aperture*(screen_distance*(inverse_focal_length-1.0/distance)-1.0));if (dof_enabled==false || coc<0.07) { coc=0.0; }
float edge_blur_amount=0.0;if (edge_blur>0.0) {edge_blur_amount=clamp((radius*2.0-1.0+0.15*edge_blur)*1.5,0.0,1.0)*1.3;}
float blur_amount=max(edge_blur_amount,coc);if (blur_amount==0.0) {gl_FragColor=texture2D(textureSampler,distorted_coords);}
else {gl_FragColor=getBlurColor(blur_amount*1.7);if (highlights) {gl_FragColor.rgb+=clamp(coc,0.0,1.0)*texture2D(highlightsSampler,distorted_coords).rgb;}
if (blur_noise) {vec2 noise=rand(distorted_coords)*0.01*blur_amount;vec2 blurred_coord=vec2(distorted_coords.x+noise.x,distorted_coords.y+noise.y);gl_FragColor=0.04*texture2D(textureSampler,blurred_coord)+0.96*gl_FragColor;}}
if (grain_amount>0.0) {vec4 grain_color=texture2D(grainSampler,texels_coords*0.003);gl_FragColor.rgb+=(-0.5+grain_color.rgb)*0.30*grain_amount;}}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$afda66f662e32aa0$var$name] = $afda66f662e32aa0$var$shader;
const $afda66f662e32aa0$export$fd327033e885af79 = {
    name: $afda66f662e32aa0$var$name,
    shader: $afda66f662e32aa0$var$shader
};

});


parcelRegister("w7ZD7", function(module, exports) {

$parcel$export(module.exports, "SSAO2RenderingPipeline", () => $06093085d439d752$export$41d64c9b35a75539);

var $e0Suo = parcelRequire("e0Suo");

var $kVtWi = parcelRequire("kVtWi");

var $ir0rz = parcelRequire("ir0rz");

var $6Ho1L = parcelRequire("6Ho1L");

var $ha1VO = parcelRequire("ha1VO");

var $74SKQ = parcelRequire("74SKQ");

var $j2mX5 = parcelRequire("j2mX5");

var $cFdBb = parcelRequire("cFdBb");

var $goDmg = parcelRequire("goDmg");

var $81KKS = parcelRequire("81KKS");

var $c7c1r = parcelRequire("c7c1r");

var $8DoUR = parcelRequire("8DoUR");

var $ejQPp = parcelRequire("ejQPp");

var $B4NQZ = parcelRequire("B4NQZ");

var $1VEEL = parcelRequire("1VEEL");

var $5Egpj = parcelRequire("5Egpj");
parcelRequire("hD3tI");
parcelRequire("5hZaK");
parcelRequire("iwyjS");
class $06093085d439d752$export$41d64c9b35a75539 extends (0, $goDmg.PostProcessRenderPipeline) {
    /**
     * Used in SSAO calculations to compensate for accuracy issues with depth values. Default 0.02.
     *
     * Normally you do not need to change this value, but you can experiment with it if you get a lot of in false self-occlusion on flat surfaces when using fewer than 16 samples. Useful range is normally [0..0.1] but higher values is allowed.
     */ set epsilon(n) {
        this._epsilon = n;
        this._ssaoPostProcess.updateEffect(this._getDefinesForSSAO());
    }
    get epsilon() {
        return this._epsilon;
    }
    /**
     * Number of samples used for the SSAO calculations. Default value is 8.
     */ set samples(n) {
        this._samples = n;
        this._ssaoPostProcess.updateEffect(this._getDefinesForSSAO());
        this._sampleSphere = this._generateHemisphere();
    }
    get samples() {
        return this._samples;
    }
    /**
     * Number of samples to use for antialiasing.
     */ set textureSamples(n) {
        this._textureSamples = n;
        if (this._prePassRenderer) this._prePassRenderer.samples = n;
        else this._originalColorPostProcess.samples = n;
    }
    get textureSamples() {
        return this._textureSamples;
    }
    get _geometryBufferRenderer() {
        if (!this._forceGeometryBuffer) return null;
        return this._scene.geometryBufferRenderer;
    }
    get _prePassRenderer() {
        if (this._forceGeometryBuffer) return null;
        return this._scene.prePassRenderer;
    }
    /**
     * Skips the denoising (blur) stage of the SSAO calculations.
     *
     * Useful to temporarily set while experimenting with the other SSAO2 settings.
     */ set bypassBlur(b) {
        const defines = this._getDefinesForBlur(this.expensiveBlur, b);
        const samplers = this._getSamplersForBlur(b);
        this._blurHPostProcess.updateEffect(defines.h, null, samplers);
        this._blurVPostProcess.updateEffect(defines.v, null, samplers);
        this._bypassBlur = b;
    }
    get bypassBlur() {
        return this._bypassBlur;
    }
    /**
     * Enables the configurable bilateral denoising (blurring) filter. Default is true.
     * Set to false to instead use a legacy bilateral filter that can't be configured.
     *
     * The denoising filter runs after the SSAO calculations and is a very important step. Both options results in a so called bilateral being used, but the "expensive" one can be
     * configured in several ways to fit your scene.
     */ set expensiveBlur(b) {
        const defines = this._getDefinesForBlur(b, this._bypassBlur);
        this._blurHPostProcess.updateEffect(defines.h);
        this._blurVPostProcess.updateEffect(defines.v);
        this._expensiveBlur = b;
    }
    get expensiveBlur() {
        return this._expensiveBlur;
    }
    /**
     *  Support test.
     */ static get IsSupported() {
        const engine = (0, $ejQPp.EngineStore).LastCreatedEngine;
        if (!engine) return false;
        return engine._features.supportSSAO2;
    }
    /**
     * Gets active scene
     */ get scene() {
        return this._scene;
    }
    /**
     * @constructor
     * @param name The rendering pipeline name
     * @param scene The scene linked to this pipeline
     * @param ratio The size of the postprocesses. Can be a number shared between passes or an object for more precision: { ssaoRatio: 0.5, blurRatio: 1.0 }
     * @param cameras The array of cameras that the rendering pipeline will be attached to
     * @param forceGeometryBuffer Set to true if you want to use the legacy geometry buffer renderer
     * @param textureType The texture type used by the different post processes created by SSAO (default: 0)
     */ constructor(name, scene, ratio, cameras, forceGeometryBuffer = false, textureType = 0){
        super(scene.getEngine(), name);
        // Members
        /**
         * @ignore
         * The PassPostProcess id in the pipeline that contains the original scene color
         */ this.SSAOOriginalSceneColorEffect = "SSAOOriginalSceneColorEffect";
        /**
         * @ignore
         * The SSAO PostProcess id in the pipeline
         */ this.SSAORenderEffect = "SSAORenderEffect";
        /**
         * @ignore
         * The horizontal blur PostProcess id in the pipeline
         */ this.SSAOBlurHRenderEffect = "SSAOBlurHRenderEffect";
        /**
         * @ignore
         * The vertical blur PostProcess id in the pipeline
         */ this.SSAOBlurVRenderEffect = "SSAOBlurVRenderEffect";
        /**
         * @ignore
         * The PostProcess id in the pipeline that combines the SSAO-Blur output with the original scene color (SSAOOriginalSceneColorEffect)
         */ this.SSAOCombineRenderEffect = "SSAOCombineRenderEffect";
        /**
         * The output strength of the SSAO post-process. Default value is 1.0.
         */ this.totalStrength = 1.0;
        /**
         * Maximum depth value to still render AO. A smooth falloff makes the dimming more natural, so there will be no abrupt shading change.
         */ this.maxZ = 100.0;
        /**
         * In order to save performances, SSAO radius is clamped on close geometry. This ratio changes by how much.
         */ this.minZAspect = 0.2;
        this._epsilon = 0.02;
        this._samples = 8;
        this._textureSamples = 1;
        /**
         * Force rendering the geometry through geometry buffer.
         */ this._forceGeometryBuffer = false;
        /**
         * The radius around the analyzed pixel used by the SSAO post-process. Default value is 2.0
         */ this.radius = 2.0;
        /**
         * The base color of the SSAO post-process
         * The final result is "base + ssao" between [0, 1]
         */ this.base = 0;
        this._bypassBlur = false;
        this._expensiveBlur = true;
        /**
         * The number of samples the bilateral filter uses in both dimensions when denoising the SSAO calculations. Default value is 16.
         *
         * A higher value should result in smoother shadows but will use more processing time in the shaders.
         *
         * A high value can cause the shadows to get to blurry or create visible artifacts (bands) near sharp details in the geometry. The artifacts can sometimes be mitigated by increasing the bilateralSoften setting.
         */ this.bilateralSamples = 16;
        /**
         * Controls the shape of the denoising kernel used by the bilateral filter. Default value is 0.
         *
         * By default the bilateral filter acts like a box-filter, treating all samples on the same depth with equal weights. This is effective to maximize the denoising effect given a limited set of samples. However, it also often results in visible ghosting around sharp shadow regions and can spread out lines over large areas so they are no longer visible.
         *
         * Increasing this setting will make the filter pay less attention to samples further away from the center sample, reducing many artifacts but at the same time increasing noise.
         *
         * Useful value range is [0..1].
         */ this.bilateralSoften = 0;
        /**
         * How forgiving the bilateral denoiser should be when rejecting samples. Default value is 0.
         *
         * A higher value results in the bilateral filter being more forgiving and thus doing a better job at denoising slanted and curved surfaces, but can lead to shadows spreading out around corners or between objects that are close to each other depth wise.
         *
         * Useful value range is normally [0..1], but higher values are allowed.
         */ this.bilateralTolerance = 0;
        this._bits = new Uint32Array(1);
        this._scene = scene;
        this._ratio = ratio;
        this._textureType = textureType;
        this._forceGeometryBuffer = forceGeometryBuffer;
        if (!this.isSupported) {
            (0, $kVtWi.Logger).Error("The current engine does not support SSAO 2.");
            return;
        }
        const ssaoRatio = this._ratio.ssaoRatio || ratio;
        const blurRatio = this._ratio.blurRatio || ratio;
        // Set up assets
        if (this._forceGeometryBuffer) {
            scene.enableGeometryBufferRenderer();
            if (scene.geometryBufferRenderer?.generateNormalsInWorldSpace) (0, $kVtWi.Logger).Error("SSAO2RenderingPipeline does not support generateNormalsInWorldSpace=true for the geometry buffer renderer!");
        } else {
            scene.enablePrePassRenderer();
            if (scene.prePassRenderer?.generateNormalsInWorldSpace) (0, $kVtWi.Logger).Error("SSAO2RenderingPipeline does not support generateNormalsInWorldSpace=true for the prepass renderer!");
        }
        this._createRandomTexture();
        this._originalColorPostProcess = new (0, $c7c1r.PassPostProcess)("SSAOOriginalSceneColor", 1.0, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, scene.getEngine(), undefined, this._textureType);
        this._originalColorPostProcess.samples = this.textureSamples;
        this._createSSAOPostProcess(1.0, textureType);
        this._createBlurPostProcess(ssaoRatio, blurRatio, this._textureType);
        this._createSSAOCombinePostProcess(blurRatio, this._textureType);
        // Set up pipeline
        this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(scene.getEngine(), this.SSAOOriginalSceneColorEffect, ()=>{
            return this._originalColorPostProcess;
        }, true));
        this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(scene.getEngine(), this.SSAORenderEffect, ()=>{
            return this._ssaoPostProcess;
        }, true));
        this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(scene.getEngine(), this.SSAOBlurHRenderEffect, ()=>{
            return this._blurHPostProcess;
        }, true));
        this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(scene.getEngine(), this.SSAOBlurVRenderEffect, ()=>{
            return this._blurVPostProcess;
        }, true));
        this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(scene.getEngine(), this.SSAOCombineRenderEffect, ()=>{
            return this._ssaoCombinePostProcess;
        }, true));
        // Finish
        scene.postProcessRenderPipelineManager.addPipeline(this);
        if (cameras) scene.postProcessRenderPipelineManager.attachCamerasToRenderPipeline(name, cameras);
    }
    // Public Methods
    /**
     * Get the class name
     * @returns "SSAO2RenderingPipeline"
     */ getClassName() {
        return "SSAO2RenderingPipeline";
    }
    /**
     * Removes the internal pipeline assets and detaches the pipeline from the scene cameras
     * @param disableGeometryBufferRenderer Set to true if you want to disable the Geometry Buffer renderer
     */ dispose(disableGeometryBufferRenderer = false) {
        for(let i = 0; i < this._scene.cameras.length; i++){
            const camera = this._scene.cameras[i];
            this._originalColorPostProcess.dispose(camera);
            this._ssaoPostProcess.dispose(camera);
            this._blurHPostProcess.dispose(camera);
            this._blurVPostProcess.dispose(camera);
            this._ssaoCombinePostProcess.dispose(camera);
        }
        this._randomTexture.dispose();
        if (disableGeometryBufferRenderer) this._scene.disableGeometryBufferRenderer();
        this._scene.postProcessRenderPipelineManager.detachCamerasFromRenderPipeline(this._name, this._scene.cameras);
        super.dispose();
    }
    // Private Methods
    /** @internal */ _rebuild() {
        super._rebuild();
    }
    _getSamplersForBlur(disabled) {
        return disabled ? [
            "textureSampler"
        ] : [
            "textureSampler",
            "depthSampler"
        ];
    }
    _getDefinesForBlur(bilateral, disabled) {
        let define = "#define BLUR\n";
        if (disabled) define += "#define BLUR_BYPASS\n";
        if (!bilateral) define += "#define BLUR_LEGACY\n";
        return {
            h: define + "#define BLUR_H\n",
            v: define
        };
    }
    _createBlurPostProcess(ssaoRatio, blurRatio, textureType) {
        const defines = this._getDefinesForBlur(this.expensiveBlur, this.bypassBlur);
        const samplers = this._getSamplersForBlur(this.bypassBlur);
        this._blurHPostProcess = this._createBlurFilter("BlurH", samplers, ssaoRatio, defines.h, textureType, true);
        this._blurVPostProcess = this._createBlurFilter("BlurV", samplers, blurRatio, defines.v, textureType, false);
    }
    _createBlurFilter(name, samplers, ratio, defines, textureType, horizontal) {
        const blurFilter = new (0, $cFdBb.PostProcess)(name, "ssao2", [
            "outSize",
            "samples",
            "soften",
            "tolerance"
        ], samplers, ratio, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, this._scene.getEngine(), false, defines, textureType);
        blurFilter.onApply = (effect)=>{
            if (!this._scene.activeCamera) return;
            const ssaoCombineSize = horizontal ? this._ssaoCombinePostProcess.width : this._ssaoCombinePostProcess.height;
            const originalColorSize = horizontal ? this._originalColorPostProcess.width : this._originalColorPostProcess.height;
            effect.setFloat("outSize", ssaoCombineSize > 0 ? ssaoCombineSize : originalColorSize);
            effect.setInt("samples", this.bilateralSamples);
            effect.setFloat("soften", this.bilateralSoften);
            effect.setFloat("tolerance", this.bilateralTolerance);
            if (this._geometryBufferRenderer) effect.setTexture("depthSampler", this._geometryBufferRenderer.getGBuffer().textures[0]);
            else if (this._prePassRenderer) effect.setTexture("depthSampler", this._prePassRenderer.getRenderTarget().textures[this._prePassRenderer.getIndex(5)]);
        };
        blurFilter.samples = this.textureSamples;
        return blurFilter;
    }
    //Van der Corput radical inverse
    _radicalInverse_VdC(i) {
        this._bits[0] = i;
        this._bits[0] = (this._bits[0] << 16 | this._bits[0] >> 16) >>> 0;
        this._bits[0] = (this._bits[0] & 0x55555555) << 1 | (this._bits[0] & 0xaaaaaaaa) >>> 1 >>> 0;
        this._bits[0] = (this._bits[0] & 0x33333333) << 2 | (this._bits[0] & 0xcccccccc) >>> 2 >>> 0;
        this._bits[0] = (this._bits[0] & 0x0f0f0f0f) << 4 | (this._bits[0] & 0xf0f0f0f0) >>> 4 >>> 0;
        this._bits[0] = (this._bits[0] & 0x00ff00ff) << 8 | (this._bits[0] & 0xff00ff00) >>> 8 >>> 0;
        return this._bits[0] * 2.3283064365386963e-10; // / 0x100000000 or / 4294967296
    }
    _hammersley(i, n) {
        return [
            i / n,
            this._radicalInverse_VdC(i)
        ];
    }
    _hemisphereSample_uniform(u, v) {
        const phi = v * 2.0 * Math.PI;
        // rejecting samples that are close to tangent plane to avoid z-fighting artifacts
        const cosTheta = 1.0 - u * 0.85;
        const sinTheta = Math.sqrt(1.0 - cosTheta * cosTheta);
        return new (0, $ha1VO.Vector3)(Math.cos(phi) * sinTheta, Math.sin(phi) * sinTheta, cosTheta);
    }
    _generateHemisphere() {
        const numSamples = this.samples;
        const result = [];
        let vector;
        let i = 0;
        while(i < numSamples){
            if (numSamples < 16) vector = this._hemisphereSample_uniform(Math.random(), Math.random());
            else {
                const rand = this._hammersley(i, numSamples);
                vector = this._hemisphereSample_uniform(rand[0], rand[1]);
            }
            result.push(vector.x, vector.y, vector.z);
            i++;
        }
        return result;
    }
    _getDefinesForSSAO() {
        const defines = `#define SSAO\n#define SAMPLES ${this.samples}\n#define EPSILON ${this.epsilon.toFixed(4)}`;
        return defines;
    }
    _createSSAOPostProcess(ratio, textureType) {
        this._sampleSphere = this._generateHemisphere();
        const defines = this._getDefinesForSSAO();
        const samplers = [
            "randomSampler",
            "depthSampler",
            "normalSampler"
        ];
        this._ssaoPostProcess = new (0, $cFdBb.PostProcess)("ssao2", "ssao2", [
            "sampleSphere",
            "samplesFactor",
            "randTextureTiles",
            "totalStrength",
            "radius",
            "base",
            "range",
            "projection",
            "near",
            "texelSize",
            "xViewport",
            "yViewport",
            "maxZ",
            "minZAspect",
            "depthProjection"
        ], samplers, ratio, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, this._scene.getEngine(), false, defines, textureType);
        this._ssaoPostProcess.onApply = (effect)=>{
            if (!this._scene.activeCamera) return;
            effect.setArray3("sampleSphere", this._sampleSphere);
            effect.setFloat("randTextureTiles", 32.0);
            effect.setFloat("samplesFactor", 1 / this.samples);
            effect.setFloat("totalStrength", this.totalStrength);
            effect.setFloat2("texelSize", 1 / this._ssaoPostProcess.width, 1 / this._ssaoPostProcess.height);
            effect.setFloat("radius", this.radius);
            effect.setFloat("maxZ", this.maxZ);
            effect.setFloat("minZAspect", this.minZAspect);
            effect.setFloat("base", this.base);
            effect.setFloat("near", this._scene.activeCamera.minZ);
            if (this._scene.activeCamera.mode === (0, $74SKQ.Camera).PERSPECTIVE_CAMERA) {
                effect.setMatrix3x3("depthProjection", $06093085d439d752$export$41d64c9b35a75539.PERSPECTIVE_DEPTH_PROJECTION);
                effect.setFloat("xViewport", Math.tan(this._scene.activeCamera.fov / 2) * this._scene.getEngine().getAspectRatio(this._scene.activeCamera, true));
                effect.setFloat("yViewport", Math.tan(this._scene.activeCamera.fov / 2));
            } else {
                const halfWidth = this._scene.getEngine().getRenderWidth() / 2.0;
                const halfHeight = this._scene.getEngine().getRenderHeight() / 2.0;
                const orthoLeft = this._scene.activeCamera.orthoLeft ?? -halfWidth;
                const orthoRight = this._scene.activeCamera.orthoRight ?? halfWidth;
                const orthoBottom = this._scene.activeCamera.orthoBottom ?? -halfHeight;
                const orthoTop = this._scene.activeCamera.orthoTop ?? halfHeight;
                effect.setMatrix3x3("depthProjection", $06093085d439d752$export$41d64c9b35a75539.ORTHO_DEPTH_PROJECTION);
                effect.setFloat("xViewport", (orthoRight - orthoLeft) * 0.5);
                effect.setFloat("yViewport", (orthoTop - orthoBottom) * 0.5);
            }
            effect.setMatrix("projection", this._scene.getProjectionMatrix());
            if (this._geometryBufferRenderer) {
                effect.setTexture("depthSampler", this._geometryBufferRenderer.getGBuffer().textures[0]);
                effect.setTexture("normalSampler", this._geometryBufferRenderer.getGBuffer().textures[1]);
            } else if (this._prePassRenderer) {
                effect.setTexture("depthSampler", this._prePassRenderer.getRenderTarget().textures[this._prePassRenderer.getIndex(5)]);
                effect.setTexture("normalSampler", this._prePassRenderer.getRenderTarget().textures[this._prePassRenderer.getIndex(6)]);
            }
            effect.setTexture("randomSampler", this._randomTexture);
        };
        this._ssaoPostProcess.samples = this.textureSamples;
        if (!this._forceGeometryBuffer) this._ssaoPostProcess._prePassEffectConfiguration = new (0, $B4NQZ.SSAO2Configuration)();
    }
    _createSSAOCombinePostProcess(ratio, textureType) {
        this._ssaoCombinePostProcess = new (0, $cFdBb.PostProcess)("ssaoCombine", "ssaoCombine", [], [
            "originalColor",
            "viewport"
        ], ratio, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, this._scene.getEngine(), false, undefined, textureType);
        this._ssaoCombinePostProcess.onApply = (effect)=>{
            const viewport = this._scene.activeCamera.viewport;
            effect.setVector4("viewport", (0, $ha1VO.TmpVectors).Vector4[0].copyFromFloats(viewport.x, viewport.y, viewport.width, viewport.height));
            effect.setTextureFromPostProcessOutput("originalColor", this._originalColorPostProcess);
        };
        this._ssaoCombinePostProcess.samples = this.textureSamples;
    }
    _createRandomTexture() {
        const size = 128;
        const data = new Uint8Array(size * size * 4);
        const randVector = (0, $ha1VO.Vector2).Zero();
        for(let index = 0; index < data.length;){
            randVector.set((0, $1VEEL.Scalar).RandomRange(0, 1), (0, $1VEEL.Scalar).RandomRange(0, 1)).normalize().scaleInPlace(255);
            data[index++] = Math.floor(randVector.x);
            data[index++] = Math.floor(randVector.y);
            data[index++] = 0;
            data[index++] = 255;
        }
        const texture = (0, $5Egpj.RawTexture).CreateRGBATexture(data, size, size, this._scene, false, false, 2);
        texture.name = "SSAORandomTexture";
        texture.wrapU = (0, $j2mX5.Texture).WRAP_ADDRESSMODE;
        texture.wrapV = (0, $j2mX5.Texture).WRAP_ADDRESSMODE;
        this._randomTexture = texture;
    }
    /**
     * Serialize the rendering pipeline (Used when exporting)
     * @returns the serialized object
     */ serialize() {
        const serializationObject = (0, $6Ho1L.SerializationHelper).Serialize(this);
        serializationObject.customType = "SSAO2RenderingPipeline";
        return serializationObject;
    }
    /**
     * Parse the serialized pipeline
     * @param source Source pipeline.
     * @param scene The scene to load the pipeline to.
     * @param rootUrl The URL of the serialized pipeline.
     * @returns An instantiated pipeline from the serialized object.
     */ static Parse(source, scene, rootUrl) {
        return (0, $6Ho1L.SerializationHelper).Parse(()=>new $06093085d439d752$export$41d64c9b35a75539(source._name, scene, source._ratio, undefined, source._forceGeometryBuffer, source._textureType), source, scene, rootUrl);
    }
}
$06093085d439d752$export$41d64c9b35a75539.ORTHO_DEPTH_PROJECTION = [
    1,
    0,
    0,
    0,
    1,
    0,
    0,
    0,
    1
];
$06093085d439d752$export$41d64c9b35a75539.PERSPECTIVE_DEPTH_PROJECTION = [
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1
];
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $06093085d439d752$export$41d64c9b35a75539.prototype, "totalStrength", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $06093085d439d752$export$41d64c9b35a75539.prototype, "maxZ", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $06093085d439d752$export$41d64c9b35a75539.prototype, "minZAspect", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("epsilon")
], $06093085d439d752$export$41d64c9b35a75539.prototype, "_epsilon", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("samples")
], $06093085d439d752$export$41d64c9b35a75539.prototype, "_samples", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("textureSamples")
], $06093085d439d752$export$41d64c9b35a75539.prototype, "_textureSamples", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $06093085d439d752$export$41d64c9b35a75539.prototype, "_forceGeometryBuffer", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $06093085d439d752$export$41d64c9b35a75539.prototype, "_ratio", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $06093085d439d752$export$41d64c9b35a75539.prototype, "_textureType", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $06093085d439d752$export$41d64c9b35a75539.prototype, "radius", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $06093085d439d752$export$41d64c9b35a75539.prototype, "base", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("bypassBlur")
], $06093085d439d752$export$41d64c9b35a75539.prototype, "_bypassBlur", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("expensiveBlur")
], $06093085d439d752$export$41d64c9b35a75539.prototype, "_expensiveBlur", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $06093085d439d752$export$41d64c9b35a75539.prototype, "bilateralSamples", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $06093085d439d752$export$41d64c9b35a75539.prototype, "bilateralSoften", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $06093085d439d752$export$41d64c9b35a75539.prototype, "bilateralTolerance", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.SSAO2RenderingPipeline", $06093085d439d752$export$41d64c9b35a75539);

});
parcelRegister("B4NQZ", function(module, exports) {

$parcel$export(module.exports, "SSAO2Configuration", () => $06f72e9c1d5dd5b3$export$ae454a26dd80953d);
/**
 * Contains all parameters needed for the prepass to perform
 * screen space subsurface scattering
 */ class $06f72e9c1d5dd5b3$export$ae454a26dd80953d {
    constructor(){
        /**
         * Is subsurface enabled
         */ this.enabled = false;
        /**
         * Name of the configuration
         */ this.name = "ssao2";
        /**
         * Textures that should be present in the MRT for this effect to work
         */ this.texturesRequired = [
            6,
            5
        ];
    }
}

});

parcelRegister("5hZaK", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $3d9dfdd4fa138501$var$name = "ssao2PixelShader";
const $3d9dfdd4fa138501$var$shader = `precision highp float;uniform sampler2D textureSampler;varying vec2 vUV;
#ifdef SSAO
float scales[16]=float[16](
0.1,
0.11406250000000001,
0.131640625,
0.15625,
0.187890625,
0.2265625,
0.272265625,
0.325,
0.384765625,
0.4515625,
0.525390625,
0.60625,
0.694140625,
0.7890625,
0.891015625,
1.0
);uniform float near;uniform float radius;uniform sampler2D depthSampler;uniform sampler2D randomSampler;uniform sampler2D normalSampler;uniform float randTextureTiles;uniform float samplesFactor;uniform vec3 sampleSphere[SAMPLES];uniform float totalStrength;uniform float base;uniform float xViewport;uniform float yViewport;uniform mat3 depthProjection;uniform float maxZ;uniform float minZAspect;uniform vec2 texelSize;uniform mat4 projection;void main()
{vec3 random=textureLod(randomSampler,vUV*randTextureTiles,0.0).rgb;float depth=textureLod(depthSampler,vUV,0.0).r;float depthSign=depth/abs(depth);depth=depth*depthSign;vec3 normal=textureLod(normalSampler,vUV,0.0).rgb;float occlusion=0.0;float correctedRadius=min(radius,minZAspect*depth/near);vec3 vViewRay=vec3((vUV.x*2.0-1.0)*xViewport,(vUV.y*2.0-1.0)*yViewport,depthSign);vec3 vDepthFactor=depthProjection*vec3(1.0,1.0,depth);vec3 origin=vViewRay*vDepthFactor;vec3 rvec=random*2.0-1.0;rvec.z=0.0;float dotProduct=dot(rvec,normal);rvec=1.0-abs(dotProduct)>1e-2 ? rvec : vec3(-rvec.y,0.0,rvec.x);vec3 tangent=normalize(rvec-normal*dot(rvec,normal));vec3 bitangent=cross(normal,tangent);mat3 tbn=mat3(tangent,bitangent,normal);float difference;for (int i=0; i<SAMPLES; ++i) {vec3 samplePosition=scales[(i+int(random.x*16.0)) % 16]*tbn*sampleSphere[(i+int(random.y*16.0)) % 16];samplePosition=samplePosition*correctedRadius+origin;vec4 offset=vec4(samplePosition,1.0);offset=projection*offset;offset.xyz/=offset.w;offset.xy=offset.xy*0.5+0.5;if (offset.x<0.0 || offset.y<0.0 || offset.x>1.0 || offset.y>1.0) {continue;}
float sampleDepth=abs(textureLod(depthSampler,offset.xy,0.0).r);difference=depthSign*samplePosition.z-sampleDepth;float rangeCheck=1.0-smoothstep(correctedRadius*0.5,correctedRadius,difference);occlusion+=step(EPSILON,difference)*rangeCheck;}
occlusion=occlusion*(1.0-smoothstep(maxZ*0.75,maxZ,depth));float ao=1.0-totalStrength*occlusion*samplesFactor;float result=clamp(ao+base,0.0,1.0);gl_FragColor=vec4(vec3(result),1.0);}
#endif
#ifdef BLUR
uniform float outSize;uniform float soften;uniform float tolerance;uniform int samples;
#ifndef BLUR_BYPASS
uniform sampler2D depthSampler;
#ifdef BLUR_LEGACY
#define inline
float blur13Bilateral(sampler2D image,vec2 uv,vec2 step) {float result=0.0;vec2 off1=vec2(1.411764705882353)*step;vec2 off2=vec2(3.2941176470588234)*step;vec2 off3=vec2(5.176470588235294)*step;float compareDepth=abs(textureLod(depthSampler,uv,0.0).r);float sampleDepth;float weight;float weightSum=30.0;result+=textureLod(image,uv,0.0).r*30.0;sampleDepth=abs(textureLod(depthSampler,uv+off1,0.0).r);weight=clamp(1.0/( 0.003+abs(compareDepth-sampleDepth)),0.0,30.0);weightSum+= weight;result+=textureLod(image,uv+off1,0.0).r*weight;sampleDepth=abs(textureLod(depthSampler,uv-off1,0.0).r);weight=clamp(1.0/( 0.003+abs(compareDepth-sampleDepth)),0.0,30.0);weightSum+= weight;result+=textureLod(image,uv-off1,0.0).r*weight;sampleDepth=abs(textureLod(depthSampler,uv+off2,0.0).r);weight=clamp(1.0/( 0.003+abs(compareDepth-sampleDepth)),0.0,30.0);weightSum+=weight;result+=textureLod(image,uv+off2,0.0).r*weight;sampleDepth=abs(textureLod(depthSampler,uv-off2,0.0).r);weight=clamp(1.0/( 0.003+abs(compareDepth-sampleDepth)),0.0,30.0);weightSum+=weight;result+=textureLod(image,uv-off2,0.0).r*weight;sampleDepth=abs(textureLod(depthSampler,uv+off3,0.0).r);weight=clamp(1.0/( 0.003+abs(compareDepth-sampleDepth)),0.0,30.0);weightSum+=weight;result+=textureLod(image,uv+off3,0.0).r*weight;sampleDepth=abs(textureLod(depthSampler,uv-off3,0.0).r);weight=clamp(1.0/( 0.003+abs(compareDepth-sampleDepth)),0.0,30.0);weightSum+=weight;result+=textureLod(image,uv-off3,0.0).r*weight;return result/weightSum;}
#endif
#endif
void main()
{float result=0.0;
#ifdef BLUR_BYPASS
result=textureLod(textureSampler,vUV,0.0).r;
#else
#ifdef BLUR_H
vec2 step=vec2(1.0/outSize,0.0);
#else
vec2 step=vec2(0.0,1.0/outSize);
#endif
#ifdef BLUR_LEGACY
result=blur13Bilateral(textureSampler,vUV,step);
#else
float compareDepth=abs(textureLod(depthSampler,vUV,0.0).r);float weightSum=0.0;for (int i=-samples; i<samples; i+=2)
{vec2 samplePos=vUV+step*(float(i)+0.5);float sampleDepth=abs(textureLod(depthSampler,samplePos,0.0).r);float falloff=smoothstep(0.0,
float(samples),
float(samples)-abs(float(i))*soften);float minDivider=tolerance*0.5+0.003;float weight=falloff/( minDivider+abs(compareDepth-sampleDepth));result+=textureLod(textureSampler,samplePos,0.0).r*weight;weightSum+=weight;}
result/=weightSum;
#endif
#endif
gl_FragColor.rgb=vec3(result);gl_FragColor.a=1.0;}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$3d9dfdd4fa138501$var$name] = $3d9dfdd4fa138501$var$shader;
const $3d9dfdd4fa138501$export$3e520a34d0f64bae = {
    name: $3d9dfdd4fa138501$var$name,
    shader: $3d9dfdd4fa138501$var$shader
};

});

parcelRegister("iwyjS", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $d7c5d64eb1f51411$var$name = "ssaoCombinePixelShader";
const $d7c5d64eb1f51411$var$shader = `uniform sampler2D textureSampler;uniform sampler2D originalColor;uniform vec4 viewport;varying vec2 vUV;
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) {
#define CUSTOM_FRAGMENT_MAIN_BEGIN
vec4 ssaoColor=texture2D(textureSampler,viewport.xy+vUV*viewport.zw);vec4 sceneColor=texture2D(originalColor,vUV);gl_FragColor=sceneColor*ssaoColor;
#define CUSTOM_FRAGMENT_MAIN_END
}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$d7c5d64eb1f51411$var$name] = $d7c5d64eb1f51411$var$shader;
const $d7c5d64eb1f51411$export$530258768dd90999 = {
    name: $d7c5d64eb1f51411$var$name,
    shader: $d7c5d64eb1f51411$var$shader
};

});


parcelRegister("iahxV", function(module, exports) {

$parcel$export(module.exports, "SSAORenderingPipeline", () => $d396c579666463b7$export$be611301d40736a3);

var $e0Suo = parcelRequire("e0Suo");

var $ha1VO = parcelRequire("ha1VO");

var $j2mX5 = parcelRequire("j2mX5");

var $cFdBb = parcelRequire("cFdBb");

var $goDmg = parcelRequire("goDmg");

var $81KKS = parcelRequire("81KKS");

var $c7c1r = parcelRequire("c7c1r");

var $8zEq7 = parcelRequire("8zEq7");

var $ir0rz = parcelRequire("ir0rz");

var $5Egpj = parcelRequire("5Egpj");

var $1VEEL = parcelRequire("1VEEL");
parcelRequire("hD3tI");
parcelRequire("hmJmS");
parcelRequire("iwyjS");
class $d396c579666463b7$export$be611301d40736a3 extends (0, $goDmg.PostProcessRenderPipeline) {
    /**
     * Gets active scene
     */ get scene() {
        return this._scene;
    }
    /**
     * @constructor
     * @param name - The rendering pipeline name
     * @param scene - The scene linked to this pipeline
     * @param ratio - The size of the postprocesses. Can be a number shared between passes or an object for more precision: { ssaoRatio: 0.5, combineRatio: 1.0 }
     * @param cameras - The array of cameras that the rendering pipeline will be attached to
     */ constructor(name, scene, ratio, cameras){
        super(scene.getEngine(), name);
        // Members
        /**
         * @ignore
         * The PassPostProcess id in the pipeline that contains the original scene color
         */ this.SSAOOriginalSceneColorEffect = "SSAOOriginalSceneColorEffect";
        /**
         * @ignore
         * The SSAO PostProcess id in the pipeline
         */ this.SSAORenderEffect = "SSAORenderEffect";
        /**
         * @ignore
         * The horizontal blur PostProcess id in the pipeline
         */ this.SSAOBlurHRenderEffect = "SSAOBlurHRenderEffect";
        /**
         * @ignore
         * The vertical blur PostProcess id in the pipeline
         */ this.SSAOBlurVRenderEffect = "SSAOBlurVRenderEffect";
        /**
         * @ignore
         * The PostProcess id in the pipeline that combines the SSAO-Blur output with the original scene color (SSAOOriginalSceneColorEffect)
         */ this.SSAOCombineRenderEffect = "SSAOCombineRenderEffect";
        /**
         * The output strength of the SSAO post-process. Default value is 1.0.
         */ this.totalStrength = 1.0;
        /**
         * The radius around the analyzed pixel used by the SSAO post-process. Default value is 0.0006
         */ this.radius = 0.0001;
        /**
         * Related to fallOff, used to interpolate SSAO samples (first interpolate function input) based on the occlusion difference of each pixel
         * Must not be equal to fallOff and superior to fallOff.
         * Default value is 0.0075
         */ this.area = 0.0075;
        /**
         * Related to area, used to interpolate SSAO samples (second interpolate function input) based on the occlusion difference of each pixel
         * Must not be equal to area and inferior to area.
         * Default value is 0.000001
         */ this.fallOff = 0.000001;
        /**
         * The base color of the SSAO post-process
         * The final result is "base + ssao" between [0, 1]
         */ this.base = 0.5;
        this._firstUpdate = true;
        this._scene = scene;
        // Set up assets
        this._createRandomTexture();
        const ssaoRatio = ratio.ssaoRatio || ratio;
        const combineRatio = ratio.combineRatio || ratio;
        this._originalColorPostProcess = new (0, $c7c1r.PassPostProcess)("SSAOOriginalSceneColor", combineRatio, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, scene.getEngine(), false);
        this._createSSAOPostProcess(ssaoRatio);
        this._createBlurPostProcess(ssaoRatio);
        this._createSSAOCombinePostProcess(combineRatio);
        // Set up pipeline
        this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(scene.getEngine(), this.SSAOOriginalSceneColorEffect, ()=>{
            return this._originalColorPostProcess;
        }, true));
        this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(scene.getEngine(), this.SSAORenderEffect, ()=>{
            return this._ssaoPostProcess;
        }, true));
        this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(scene.getEngine(), this.SSAOBlurHRenderEffect, ()=>{
            return this._blurHPostProcess;
        }, true));
        this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(scene.getEngine(), this.SSAOBlurVRenderEffect, ()=>{
            return this._blurVPostProcess;
        }, true));
        this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(scene.getEngine(), this.SSAOCombineRenderEffect, ()=>{
            return this._ssaoCombinePostProcess;
        }, true));
        // Finish
        scene.postProcessRenderPipelineManager.addPipeline(this);
        if (cameras) scene.postProcessRenderPipelineManager.attachCamerasToRenderPipeline(name, cameras);
    }
    /**
     * @internal
     */ _attachCameras(cameras, unique) {
        super._attachCameras(cameras, unique);
        for (const camera of this._cameras)this._scene.enableDepthRenderer(camera).getDepthMap(); // Force depth renderer "on"
    }
    // Public Methods
    /**
     * Get the class name
     * @returns "SSAORenderingPipeline"
     */ getClassName() {
        return "SSAORenderingPipeline";
    }
    /**
     * Removes the internal pipeline assets and detaches the pipeline from the scene cameras
     * @param disableDepthRender - If the depth renderer should be disabled on the scene
     */ dispose(disableDepthRender = false) {
        for(let i = 0; i < this._scene.cameras.length; i++){
            const camera = this._scene.cameras[i];
            this._originalColorPostProcess.dispose(camera);
            this._ssaoPostProcess.dispose(camera);
            this._blurHPostProcess.dispose(camera);
            this._blurVPostProcess.dispose(camera);
            this._ssaoCombinePostProcess.dispose(camera);
        }
        this._randomTexture.dispose();
        if (disableDepthRender) this._scene.disableDepthRenderer();
        this._scene.postProcessRenderPipelineManager.detachCamerasFromRenderPipeline(this._name, this._scene.cameras);
        super.dispose();
    }
    // Private Methods
    _createBlurPostProcess(ratio) {
        const size = 16;
        this._blurHPostProcess = new (0, $8zEq7.BlurPostProcess)("BlurH", new (0, $ha1VO.Vector2)(1, 0), size, ratio, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, this._scene.getEngine(), false, 0);
        this._blurVPostProcess = new (0, $8zEq7.BlurPostProcess)("BlurV", new (0, $ha1VO.Vector2)(0, 1), size, ratio, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, this._scene.getEngine(), false, 0);
        this._blurHPostProcess.onActivateObservable.add(()=>{
            const dw = this._blurHPostProcess.width / this._scene.getEngine().getRenderWidth();
            this._blurHPostProcess.kernel = size * dw;
        });
        this._blurVPostProcess.onActivateObservable.add(()=>{
            const dw = this._blurVPostProcess.height / this._scene.getEngine().getRenderHeight();
            this._blurVPostProcess.kernel = size * dw;
        });
    }
    /** @internal */ _rebuild() {
        this._firstUpdate = true;
        super._rebuild();
    }
    _createSSAOPostProcess(ratio) {
        const numSamples = 16;
        const sampleSphere = [
            0.5381,
            0.1856,
            -0.4319,
            0.1379,
            0.2486,
            0.443,
            0.3371,
            0.5679,
            -0.0057,
            -0.6999,
            -0.0451,
            -0.0019,
            0.0689,
            -0.1598,
            -0.8547,
            0.056,
            0.0069,
            -0.1843,
            -0.0146,
            0.1402,
            0.0762,
            0.01,
            -0.1924,
            -0.0344,
            -0.3577,
            -0.5301,
            -0.4358,
            -0.3169,
            0.1063,
            0.0158,
            0.0103,
            -0.5869,
            0.0046,
            -0.0897,
            -0.494,
            0.3287,
            0.7119,
            -0.0154,
            -0.0918,
            -0.0533,
            0.0596,
            -0.5411,
            0.0352,
            -0.0631,
            0.546,
            -0.4776,
            0.2847,
            -0.0271
        ];
        const samplesFactor = 1.0 / numSamples;
        this._ssaoPostProcess = new (0, $cFdBb.PostProcess)("ssao", "ssao", [
            "sampleSphere",
            "samplesFactor",
            "randTextureTiles",
            "totalStrength",
            "radius",
            "area",
            "fallOff",
            "base",
            "range",
            "viewport"
        ], [
            "randomSampler"
        ], ratio, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, this._scene.getEngine(), false, "#define SAMPLES " + numSamples + "\n#define SSAO");
        this._ssaoPostProcess.externalTextureSamplerBinding = true;
        this._ssaoPostProcess.onApply = (effect)=>{
            if (this._firstUpdate) {
                effect.setArray3("sampleSphere", sampleSphere);
                effect.setFloat("samplesFactor", samplesFactor);
                effect.setFloat("randTextureTiles", 4.0);
            }
            effect.setFloat("totalStrength", this.totalStrength);
            effect.setFloat("radius", this.radius);
            effect.setFloat("area", this.area);
            effect.setFloat("fallOff", this.fallOff);
            effect.setFloat("base", this.base);
            effect.setTexture("textureSampler", this._scene.enableDepthRenderer(this._scene.activeCamera).getDepthMap());
            effect.setTexture("randomSampler", this._randomTexture);
        };
    }
    _createSSAOCombinePostProcess(ratio) {
        this._ssaoCombinePostProcess = new (0, $cFdBb.PostProcess)("ssaoCombine", "ssaoCombine", [], [
            "originalColor",
            "viewport"
        ], ratio, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, this._scene.getEngine(), false);
        this._ssaoCombinePostProcess.onApply = (effect)=>{
            effect.setVector4("viewport", (0, $ha1VO.TmpVectors).Vector4[0].copyFromFloats(0, 0, 1.0, 1.0));
            effect.setTextureFromPostProcess("originalColor", this._originalColorPostProcess);
        };
    }
    _createRandomTexture() {
        const size = 512;
        const data = new Uint8Array(size * size * 4);
        for(let index = 0; index < data.length;){
            data[index++] = Math.floor(Math.max(0.0, (0, $1VEEL.Scalar).RandomRange(-1, 1.0)) * 255);
            data[index++] = Math.floor(Math.max(0.0, (0, $1VEEL.Scalar).RandomRange(-1, 1.0)) * 255);
            data[index++] = Math.floor(Math.max(0.0, (0, $1VEEL.Scalar).RandomRange(-1, 1.0)) * 255);
            data[index++] = 255;
        }
        const texture = (0, $5Egpj.RawTexture).CreateRGBATexture(data, size, size, this._scene, false, false, 2);
        texture.name = "SSAORandomTexture";
        texture.wrapU = (0, $j2mX5.Texture).WRAP_ADDRESSMODE;
        texture.wrapV = (0, $j2mX5.Texture).WRAP_ADDRESSMODE;
        this._randomTexture = texture;
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $d396c579666463b7$export$be611301d40736a3.prototype, "totalStrength", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $d396c579666463b7$export$be611301d40736a3.prototype, "radius", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $d396c579666463b7$export$be611301d40736a3.prototype, "area", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $d396c579666463b7$export$be611301d40736a3.prototype, "fallOff", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $d396c579666463b7$export$be611301d40736a3.prototype, "base", void 0);

});
parcelRegister("hmJmS", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $ca47aee2f373258c$var$name = "ssaoPixelShader";
const $ca47aee2f373258c$var$shader = `uniform sampler2D textureSampler;varying vec2 vUV;
#ifdef SSAO
uniform sampler2D randomSampler;uniform float randTextureTiles;uniform float samplesFactor;uniform vec3 sampleSphere[SAMPLES];uniform float totalStrength;uniform float radius;uniform float area;uniform float fallOff;uniform float base;vec3 normalFromDepth(float depth,vec2 coords)
{vec2 offset1=vec2(0.0,radius);vec2 offset2=vec2(radius,0.0);float depth1=texture2D(textureSampler,coords+offset1).r;float depth2=texture2D(textureSampler,coords+offset2).r;vec3 p1=vec3(offset1,depth1-depth);vec3 p2=vec3(offset2,depth2-depth);vec3 normal=cross(p1,p2);normal.z=-normal.z;return normalize(normal);}
void main()
{vec3 random=normalize(texture2D(randomSampler,vUV*randTextureTiles).rgb);float depth=texture2D(textureSampler,vUV).r;vec3 position=vec3(vUV,depth);vec3 normal=normalFromDepth(depth,vUV);float radiusDepth=radius/depth;float occlusion=0.0;vec3 ray;vec3 hemiRay;float occlusionDepth;float difference;for (int i=0; i<SAMPLES; i++)
{ray=radiusDepth*reflect(sampleSphere[i],random);hemiRay=position+sign(dot(ray,normal))*ray;occlusionDepth=texture2D(textureSampler,clamp(hemiRay.xy,vec2(0.001,0.001),vec2(0.999,0.999))).r;difference=depth-occlusionDepth;occlusion+=step(fallOff,difference)*(1.0-smoothstep(fallOff,area,difference));}
float ao=1.0-totalStrength*occlusion*samplesFactor;float result=clamp(ao+base,0.0,1.0);gl_FragColor.r=result;gl_FragColor.g=result;gl_FragColor.b=result;gl_FragColor.a=1.0;}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$ca47aee2f373258c$var$name] = $ca47aee2f373258c$var$shader;
const $ca47aee2f373258c$export$7fea0ff0409ccdf0 = {
    name: $ca47aee2f373258c$var$name,
    shader: $ca47aee2f373258c$var$shader
};

});


parcelRegister("j0qom", function(module, exports) {

$parcel$export(module.exports, "StandardRenderingPipeline", () => $dd627d48250adc75$export$bf8511a5404ec254);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $6Ho1L = parcelRequire("6Ho1L");

var $kVtWi = parcelRequire("kVtWi");

var $ha1VO = parcelRequire("ha1VO");

var $1VEEL = parcelRequire("1VEEL");

var $j2mX5 = parcelRequire("j2mX5");

var $cFdBb = parcelRequire("cFdBb");

var $goDmg = parcelRequire("goDmg");

var $81KKS = parcelRequire("81KKS");

var $8zEq7 = parcelRequire("8zEq7");

var $40XEW = parcelRequire("40XEW");

var $8DoUR = parcelRequire("8DoUR");

var $Jb4JF = parcelRequire("Jb4JF");

var $kMeib = parcelRequire("kMeib");
parcelRequire("hD3tI");
parcelRequire("9wGIe");
class $dd627d48250adc75$export$bf8511a5404ec254 extends (0, $goDmg.PostProcessRenderPipeline) {
    /**
     * Gets the overall exposure used by the pipeline
     */ get exposure() {
        return this._fixedExposure;
    }
    /**
     * Sets the overall exposure used by the pipeline
     */ set exposure(value) {
        this._fixedExposure = value;
        this._currentExposure = value;
    }
    /**
     * Gets whether or not the exposure of the overall pipeline should be automatically adjusted by the HDR post-process
     */ get hdrAutoExposure() {
        return this._hdrAutoExposure;
    }
    /**
     * Sets whether or not the exposure of the overall pipeline should be automatically adjusted by the HDR post-process
     */ set hdrAutoExposure(value) {
        this._hdrAutoExposure = value;
        if (this.hdrPostProcess) {
            const defines = [
                "#define HDR"
            ];
            if (value) defines.push("#define AUTO_EXPOSURE");
            this.hdrPostProcess.updateEffect(defines.join("\n"));
        }
    }
    /**
     * Gets how much the image is blurred by the movement while using the motion blur post-process
     */ get motionStrength() {
        return this._motionStrength;
    }
    /**
     * Sets how much the image is blurred by the movement while using the motion blur post-process
     */ set motionStrength(strength) {
        this._motionStrength = strength;
        if (this._isObjectBasedMotionBlur && this.motionBlurPostProcess) this.motionBlurPostProcess.motionStrength = strength;
    }
    /**
     * Gets whether or not the motion blur post-process is object based or screen based.
     */ get objectBasedMotionBlur() {
        return this._isObjectBasedMotionBlur;
    }
    /**
     * Sets whether or not the motion blur post-process should be object based or screen based
     */ set objectBasedMotionBlur(value) {
        const shouldRebuild = this._isObjectBasedMotionBlur !== value;
        this._isObjectBasedMotionBlur = value;
        if (shouldRebuild) this._buildPipeline();
    }
    /**
     * @ignore
     * Specifies if the bloom pipeline is enabled
     */ get BloomEnabled() {
        return this._bloomEnabled;
    }
    set BloomEnabled(enabled) {
        if (this._bloomEnabled === enabled) return;
        this._bloomEnabled = enabled;
        this._buildPipeline();
    }
    /**
     * @ignore
     * Specifies if the depth of field pipeline is enabled
     */ get DepthOfFieldEnabled() {
        return this._depthOfFieldEnabled;
    }
    set DepthOfFieldEnabled(enabled) {
        if (this._depthOfFieldEnabled === enabled) return;
        this._depthOfFieldEnabled = enabled;
        this._buildPipeline();
    }
    /**
     * @ignore
     * Specifies if the lens flare pipeline is enabled
     */ get LensFlareEnabled() {
        return this._lensFlareEnabled;
    }
    set LensFlareEnabled(enabled) {
        if (this._lensFlareEnabled === enabled) return;
        this._lensFlareEnabled = enabled;
        this._buildPipeline();
    }
    /**
     * @ignore
     * Specifies if the HDR pipeline is enabled
     */ get HDREnabled() {
        return this._hdrEnabled;
    }
    set HDREnabled(enabled) {
        if (this._hdrEnabled === enabled) return;
        this._hdrEnabled = enabled;
        this._buildPipeline();
    }
    /**
     * @ignore
     * Specifies if the volumetric lights scattering effect is enabled
     */ get VLSEnabled() {
        return this._vlsEnabled;
    }
    // eslint-disable-next-line @typescript-eslint/naming-convention
    set VLSEnabled(enabled) {
        if (this._vlsEnabled === enabled) return;
        if (enabled) {
            const geometry = this._scene.enableGeometryBufferRenderer();
            if (!geometry) {
                (0, $kVtWi.Logger).Warn("Geometry renderer is not supported, cannot create volumetric lights in Standard Rendering Pipeline");
                return;
            }
        }
        this._vlsEnabled = enabled;
        this._buildPipeline();
    }
    /**
     * @ignore
     * Specifies if the motion blur effect is enabled
     */ get MotionBlurEnabled() {
        return this._motionBlurEnabled;
    }
    set MotionBlurEnabled(enabled) {
        if (this._motionBlurEnabled === enabled) return;
        this._motionBlurEnabled = enabled;
        this._buildPipeline();
    }
    /**
     * Specifies if anti-aliasing is enabled
     */ get fxaaEnabled() {
        return this._fxaaEnabled;
    }
    set fxaaEnabled(enabled) {
        if (this._fxaaEnabled === enabled) return;
        this._fxaaEnabled = enabled;
        this._buildPipeline();
    }
    /**
     * Specifies if screen space reflections are enabled.
     */ get screenSpaceReflectionsEnabled() {
        return this._screenSpaceReflectionsEnabled;
    }
    set screenSpaceReflectionsEnabled(enabled) {
        if (this._screenSpaceReflectionsEnabled === enabled) return;
        this._screenSpaceReflectionsEnabled = enabled;
        this._buildPipeline();
    }
    /**
     * Specifies the number of steps used to calculate the volumetric lights
     * Typically in interval [50, 200]
     */ get volumetricLightStepsCount() {
        return this._volumetricLightStepsCount;
    }
    set volumetricLightStepsCount(count) {
        if (this.volumetricLightPostProcess) this.volumetricLightPostProcess.updateEffect("#define VLS\n#define NB_STEPS " + count.toFixed(1));
        this._volumetricLightStepsCount = count;
    }
    /**
     * Specifies the number of samples used for the motion blur effect
     * Typically in interval [16, 64]
     */ get motionBlurSamples() {
        return this._motionBlurSamples;
    }
    set motionBlurSamples(samples) {
        if (this.motionBlurPostProcess) {
            if (this._isObjectBasedMotionBlur) this.motionBlurPostProcess.motionBlurSamples = samples;
            else this.motionBlurPostProcess.updateEffect("#define MOTION_BLUR\n#define MAX_MOTION_SAMPLES " + samples.toFixed(1));
        }
        this._motionBlurSamples = samples;
    }
    /**
     * Specifies MSAA sample count, setting this to 4 will provide 4x anti aliasing. (default: 1)
     */ get samples() {
        return this._samples;
    }
    set samples(sampleCount) {
        if (this._samples === sampleCount) return;
        this._samples = sampleCount;
        this._buildPipeline();
    }
    /**
     * Default pipeline should be used going forward but the standard pipeline will be kept for backwards compatibility.
     * @constructor
     * @param name The rendering pipeline name
     * @param scene The scene linked to this pipeline
     * @param ratio The size of the postprocesses (0.5 means that your postprocess will have a width = canvas.width 0.5 and a height = canvas.height 0.5)
     * @param originalPostProcess the custom original color post-process. Must be "reusable". Can be null.
     * @param cameras The array of cameras that the rendering pipeline will be attached to
     */ constructor(name, scene, ratio, originalPostProcess = null, cameras){
        super(scene.getEngine(), name);
        /**
         * Post-process used to down scale an image x4
         */ this.downSampleX4PostProcess = null;
        /**
         * Post-process used to calculate the illuminated surfaces controlled by a threshold
         */ this.brightPassPostProcess = null;
        /**
         * Post-process array storing all the horizontal blur post-processes used by the pipeline
         */ this.blurHPostProcesses = [];
        /**
         * Post-process array storing all the vertical blur post-processes used by the pipeline
         */ this.blurVPostProcesses = [];
        /**
         * Post-process used to add colors of 2 textures (typically brightness + real scene color)
         */ this.textureAdderPostProcess = null;
        /**
         * Post-process used to create volumetric lighting effect
         */ this.volumetricLightPostProcess = null;
        /**
         * Post-process used to smooth the previous volumetric light post-process on the X axis
         */ this.volumetricLightSmoothXPostProcess = null;
        /**
         * Post-process used to smooth the previous volumetric light post-process on the Y axis
         */ this.volumetricLightSmoothYPostProcess = null;
        /**
         * Post-process used to merge the volumetric light effect and the real scene color
         */ this.volumetricLightMergePostProces = null;
        /**
         * Post-process used to store the final volumetric light post-process (attach/detach for debug purpose)
         */ this.volumetricLightFinalPostProcess = null;
        /**
         * Base post-process used to calculate the average luminance of the final image for HDR
         */ this.luminancePostProcess = null;
        /**
         * Post-processes used to create down sample post-processes in order to get
         * the average luminance of the final image for HDR
         * Array of length "StandardRenderingPipeline.LuminanceSteps"
         */ this.luminanceDownSamplePostProcesses = [];
        /**
         * Post-process used to create a HDR effect (light adaptation)
         */ this.hdrPostProcess = null;
        /**
         * Post-process used to store the final texture adder post-process (attach/detach for debug purpose)
         */ this.textureAdderFinalPostProcess = null;
        /**
         * Post-process used to store the final lens flare post-process (attach/detach for debug purpose)
         */ this.lensFlareFinalPostProcess = null;
        /**
         * Post-process used to merge the final HDR post-process and the real scene color
         */ this.hdrFinalPostProcess = null;
        /**
         * Post-process used to create a lens flare effect
         */ this.lensFlarePostProcess = null;
        /**
         * Post-process that merges the result of the lens flare post-process and the real scene color
         */ this.lensFlareComposePostProcess = null;
        /**
         * Post-process used to create a motion blur effect
         */ this.motionBlurPostProcess = null;
        /**
         * Post-process used to create a depth of field effect
         */ this.depthOfFieldPostProcess = null;
        /**
         * The Fast Approximate Anti-Aliasing post process which attempts to remove aliasing from an image.
         */ this.fxaaPostProcess = null;
        /**
         * Post-process used to simulate realtime reflections using the screen space and geometry renderer.
         */ this.screenSpaceReflectionPostProcess = null;
        // Values
        /**
         * Represents the brightness threshold in order to configure the illuminated surfaces
         */ this.brightThreshold = 1.0;
        /**
         * Configures the blur intensity used for surexposed surfaces are highlighted surfaces (light halo)
         */ this.blurWidth = 512.0;
        /**
         * Sets if the blur for highlighted surfaces must be only horizontal
         */ this.horizontalBlur = false;
        /**
         * Texture used typically to simulate "dirty" on camera lens
         */ this.lensTexture = null;
        /**
         * Represents the offset coefficient based on Rayleigh principle. Typically in interval [-0.2, 0.2]
         */ this.volumetricLightCoefficient = 0.2;
        /**
         * The overall power of volumetric lights, typically in interval [0, 10] maximum
         */ this.volumetricLightPower = 4.0;
        /**
         * Used the set the blur intensity to smooth the volumetric lights
         */ this.volumetricLightBlurScale = 64.0;
        /**
         * Light (spot or directional) used to generate the volumetric lights rays
         * The source light must have a shadow generate so the pipeline can get its
         * depth map
         */ this.sourceLight = null;
        /**
         * For eye adaptation, represents the minimum luminance the eye can see
         */ this.hdrMinimumLuminance = 1.0;
        /**
         * For eye adaptation, represents the decrease luminance speed
         */ this.hdrDecreaseRate = 0.5;
        /**
         * For eye adaptation, represents the increase luminance speed
         */ this.hdrIncreaseRate = 0.5;
        /**
         * Lens color texture used by the lens flare effect. Mandatory if lens flare effect enabled
         */ this.lensColorTexture = null;
        /**
         * The overall strength for the lens flare effect
         */ this.lensFlareStrength = 20.0;
        /**
         * Dispersion coefficient for lens flare ghosts
         */ this.lensFlareGhostDispersal = 1.4;
        /**
         * Main lens flare halo width
         */ this.lensFlareHaloWidth = 0.7;
        /**
         * Based on the lens distortion effect, defines how much the lens flare result
         * is distorted
         */ this.lensFlareDistortionStrength = 16.0;
        /**
         * Configures the blur intensity used for for lens flare (halo)
         */ this.lensFlareBlurWidth = 512.0;
        /**
         * Lens star texture must be used to simulate rays on the flares and is available
         * in the documentation
         */ this.lensStarTexture = null;
        /**
         * As the "lensTexture" (can be the same texture or different), it is used to apply the lens
         * flare effect by taking account of the dirt texture
         */ this.lensFlareDirtTexture = null;
        /**
         * Represents the focal length for the depth of field effect
         */ this.depthOfFieldDistance = 10.0;
        /**
         * Represents the blur intensity for the blurred part of the depth of field effect
         */ this.depthOfFieldBlurWidth = 64.0;
        /**
         * List of animations for the pipeline (IAnimatable implementation)
         */ this.animations = [];
        this._currentDepthOfFieldSource = null;
        this._fixedExposure = 1.0;
        this._currentExposure = 1.0;
        this._hdrAutoExposure = false;
        this._hdrCurrentLuminance = 1.0;
        this._motionStrength = 1.0;
        this._isObjectBasedMotionBlur = false;
        this._camerasToBeAttached = [];
        // Getters and setters
        this._bloomEnabled = false;
        this._depthOfFieldEnabled = false;
        this._vlsEnabled = false;
        this._lensFlareEnabled = false;
        this._hdrEnabled = false;
        this._motionBlurEnabled = false;
        this._fxaaEnabled = false;
        this._screenSpaceReflectionsEnabled = false;
        this._motionBlurSamples = 64.0;
        this._volumetricLightStepsCount = 50.0;
        this._samples = 1;
        this._cameras = cameras || scene.cameras;
        this._cameras = this._cameras.slice();
        this._camerasToBeAttached = this._cameras.slice();
        // Initialize
        this._scene = scene;
        this._basePostProcess = originalPostProcess;
        this._ratio = ratio;
        // Misc
        this._floatTextureType = scene.getEngine().getCaps().textureFloatRender ? 1 : 2;
        // Finish
        scene.postProcessRenderPipelineManager.addPipeline(this);
        this._buildPipeline();
    }
    _buildPipeline() {
        const ratio = this._ratio;
        const scene = this._scene;
        this._disposePostProcesses();
        if (this._cameras !== null) {
            this._scene.postProcessRenderPipelineManager.detachCamerasFromRenderPipeline(this._name, this._cameras);
            // get back cameras to be used to reattach pipeline
            this._cameras = this._camerasToBeAttached.slice();
        }
        this._reset();
        // Create pass post-process
        if (this._screenSpaceReflectionsEnabled) {
            this.screenSpaceReflectionPostProcess = new (0, $kMeib.ScreenSpaceReflectionPostProcess)("HDRPass", scene, ratio, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, scene.getEngine(), false, this._floatTextureType);
            this.screenSpaceReflectionPostProcess.onApplyObservable.add(()=>{
                this._currentDepthOfFieldSource = this.screenSpaceReflectionPostProcess;
            });
            this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(scene.getEngine(), "HDRScreenSpaceReflections", ()=>this.screenSpaceReflectionPostProcess, true));
        }
        if (!this._basePostProcess) this.originalPostProcess = new (0, $cFdBb.PostProcess)("HDRPass", "standard", [], [], ratio, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, scene.getEngine(), false, "#define PASS_POST_PROCESS", this._floatTextureType);
        else this.originalPostProcess = this._basePostProcess;
        this.originalPostProcess.autoClear = !this.screenSpaceReflectionPostProcess;
        this.originalPostProcess.onApplyObservable.add(()=>{
            this._currentDepthOfFieldSource = this.originalPostProcess;
        });
        this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(scene.getEngine(), "HDRPassPostProcess", ()=>this.originalPostProcess, true));
        if (this._bloomEnabled) {
            // Create down sample X4 post-process
            this._createDownSampleX4PostProcess(scene, ratio / 4);
            // Create bright pass post-process
            this._createBrightPassPostProcess(scene, ratio / 4);
            // Create gaussian blur post-processes (down sampling blurs)
            this._createBlurPostProcesses(scene, ratio / 4, 1);
            // Create texture adder post-process
            this._createTextureAdderPostProcess(scene, ratio);
            // Create depth-of-field source post-process
            this.textureAdderFinalPostProcess = new (0, $cFdBb.PostProcess)("HDRDepthOfFieldSource", "standard", [], [], ratio, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, scene.getEngine(), false, "#define PASS_POST_PROCESS", 0);
            this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(scene.getEngine(), "HDRBaseDepthOfFieldSource", ()=>{
                return this.textureAdderFinalPostProcess;
            }, true));
        }
        if (this._vlsEnabled) {
            // Create volumetric light
            this._createVolumetricLightPostProcess(scene, ratio);
            // Create volumetric light final post-process
            this.volumetricLightFinalPostProcess = new (0, $cFdBb.PostProcess)("HDRVLSFinal", "standard", [], [], ratio, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, scene.getEngine(), false, "#define PASS_POST_PROCESS", 0);
            this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(scene.getEngine(), "HDRVLSFinal", ()=>{
                return this.volumetricLightFinalPostProcess;
            }, true));
        }
        if (this._lensFlareEnabled) {
            // Create lens flare post-process
            this._createLensFlarePostProcess(scene, ratio);
            // Create depth-of-field source post-process post lens-flare and disable it now
            this.lensFlareFinalPostProcess = new (0, $cFdBb.PostProcess)("HDRPostLensFlareDepthOfFieldSource", "standard", [], [], ratio, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, scene.getEngine(), false, "#define PASS_POST_PROCESS", 0);
            this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(scene.getEngine(), "HDRPostLensFlareDepthOfFieldSource", ()=>{
                return this.lensFlareFinalPostProcess;
            }, true));
        }
        if (this._hdrEnabled) {
            // Create luminance
            this._createLuminancePostProcesses(scene, this._floatTextureType);
            // Create HDR
            this._createHdrPostProcess(scene, ratio);
            // Create depth-of-field source post-process post hdr and disable it now
            this.hdrFinalPostProcess = new (0, $cFdBb.PostProcess)("HDRPostHDReDepthOfFieldSource", "standard", [], [], ratio, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, scene.getEngine(), false, "#define PASS_POST_PROCESS", 0);
            this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(scene.getEngine(), "HDRPostHDReDepthOfFieldSource", ()=>{
                return this.hdrFinalPostProcess;
            }, true));
        }
        if (this._depthOfFieldEnabled) {
            // Create gaussian blur used by depth-of-field
            this._createBlurPostProcesses(scene, ratio / 2, 3, "depthOfFieldBlurWidth");
            // Create depth-of-field post-process
            this._createDepthOfFieldPostProcess(scene, ratio);
        }
        if (this._motionBlurEnabled) // Create motion blur post-process
        this._createMotionBlurPostProcess(scene, ratio);
        if (this._fxaaEnabled) {
            // Create fxaa post-process
            this.fxaaPostProcess = new (0, $40XEW.FxaaPostProcess)("fxaa", 1.0, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, scene.getEngine(), false, 0);
            this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(scene.getEngine(), "HDRFxaa", ()=>{
                return this.fxaaPostProcess;
            }, true));
        }
        if (this._cameras !== null) this._scene.postProcessRenderPipelineManager.attachCamerasToRenderPipeline(this._name, this._cameras);
        if (!this._enableMSAAOnFirstPostProcess(this._samples) && this._samples > 1) (0, $kVtWi.Logger).Warn("MSAA failed to enable, MSAA is only supported in browsers that support webGL >= 2.0");
    }
    // Down Sample X4 Post-Process
    _createDownSampleX4PostProcess(scene, ratio) {
        const downSampleX4Offsets = new Array(32);
        this.downSampleX4PostProcess = new (0, $cFdBb.PostProcess)("HDRDownSampleX4", "standard", [
            "dsOffsets"
        ], [], ratio, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, scene.getEngine(), false, "#define DOWN_SAMPLE_X4", this._floatTextureType);
        this.downSampleX4PostProcess.onApply = (effect)=>{
            let id = 0;
            const width = this.downSampleX4PostProcess.width;
            const height = this.downSampleX4PostProcess.height;
            for(let i = -2; i < 2; i++)for(let j = -2; j < 2; j++){
                downSampleX4Offsets[id] = (i + 0.5) * (1.0 / width);
                downSampleX4Offsets[id + 1] = (j + 0.5) * (1.0 / height);
                id += 2;
            }
            effect.setArray2("dsOffsets", downSampleX4Offsets);
        };
        // Add to pipeline
        this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(scene.getEngine(), "HDRDownSampleX4", ()=>{
            return this.downSampleX4PostProcess;
        }, true));
    }
    // Brightpass Post-Process
    _createBrightPassPostProcess(scene, ratio) {
        const brightOffsets = new Array(8);
        this.brightPassPostProcess = new (0, $cFdBb.PostProcess)("HDRBrightPass", "standard", [
            "dsOffsets",
            "brightThreshold"
        ], [], ratio, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, scene.getEngine(), false, "#define BRIGHT_PASS", this._floatTextureType);
        this.brightPassPostProcess.onApply = (effect)=>{
            const sU = 1.0 / this.brightPassPostProcess.width;
            const sV = 1.0 / this.brightPassPostProcess.height;
            brightOffsets[0] = -0.5 * sU;
            brightOffsets[1] = 0.5 * sV;
            brightOffsets[2] = 0.5 * sU;
            brightOffsets[3] = 0.5 * sV;
            brightOffsets[4] = -0.5 * sU;
            brightOffsets[5] = -0.5 * sV;
            brightOffsets[6] = 0.5 * sU;
            brightOffsets[7] = -0.5 * sV;
            effect.setArray2("dsOffsets", brightOffsets);
            effect.setFloat("brightThreshold", this.brightThreshold);
        };
        // Add to pipeline
        this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(scene.getEngine(), "HDRBrightPass", ()=>{
            return this.brightPassPostProcess;
        }, true));
    }
    // Create blur H&V post-processes
    _createBlurPostProcesses(scene, ratio, indice, blurWidthKey = "blurWidth") {
        const engine = scene.getEngine();
        const blurX = new (0, $8zEq7.BlurPostProcess)("HDRBlurH_" + indice, new (0, $ha1VO.Vector2)(1, 0), this[blurWidthKey], ratio, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, scene.getEngine(), false, this._floatTextureType);
        const blurY = new (0, $8zEq7.BlurPostProcess)("HDRBlurV_" + indice, new (0, $ha1VO.Vector2)(0, 1), this[blurWidthKey], ratio, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, scene.getEngine(), false, this._floatTextureType);
        blurX.onActivateObservable.add(()=>{
            const dw = blurX.width / engine.getRenderWidth();
            blurX.kernel = this[blurWidthKey] * dw;
        });
        blurY.onActivateObservable.add(()=>{
            const dw = blurY.height / engine.getRenderHeight();
            blurY.kernel = this.horizontalBlur ? 64 * dw : this[blurWidthKey] * dw;
        });
        this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(scene.getEngine(), "HDRBlurH" + indice, ()=>{
            return blurX;
        }, true));
        this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(scene.getEngine(), "HDRBlurV" + indice, ()=>{
            return blurY;
        }, true));
        this.blurHPostProcesses.push(blurX);
        this.blurVPostProcesses.push(blurY);
    }
    // Create texture adder post-process
    _createTextureAdderPostProcess(scene, ratio) {
        this.textureAdderPostProcess = new (0, $cFdBb.PostProcess)("HDRTextureAdder", "standard", [
            "exposure"
        ], [
            "otherSampler",
            "lensSampler"
        ], ratio, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, scene.getEngine(), false, "#define TEXTURE_ADDER", this._floatTextureType);
        this.textureAdderPostProcess.onApply = (effect)=>{
            effect.setTextureFromPostProcess("otherSampler", this._vlsEnabled ? this._currentDepthOfFieldSource : this.originalPostProcess);
            effect.setTexture("lensSampler", this.lensTexture);
            effect.setFloat("exposure", this._currentExposure);
            this._currentDepthOfFieldSource = this.textureAdderFinalPostProcess;
        };
        // Add to pipeline
        this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(scene.getEngine(), "HDRTextureAdder", ()=>{
            return this.textureAdderPostProcess;
        }, true));
    }
    _createVolumetricLightPostProcess(scene, ratio) {
        const geometryRenderer = scene.enableGeometryBufferRenderer();
        geometryRenderer.enablePosition = true;
        const geometry = geometryRenderer.getGBuffer();
        // Base post-process
        this.volumetricLightPostProcess = new (0, $cFdBb.PostProcess)("HDRVLS", "standard", [
            "shadowViewProjection",
            "cameraPosition",
            "sunDirection",
            "sunColor",
            "scatteringCoefficient",
            "scatteringPower",
            "depthValues"
        ], [
            "shadowMapSampler",
            "positionSampler"
        ], ratio / 8, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, scene.getEngine(), false, "#define VLS\n#define NB_STEPS " + this._volumetricLightStepsCount.toFixed(1));
        const depthValues = (0, $ha1VO.Vector2).Zero();
        this.volumetricLightPostProcess.onApply = (effect)=>{
            if (this.sourceLight && this.sourceLight.getShadowGenerator() && this._scene.activeCamera) {
                const generator = this.sourceLight.getShadowGenerator();
                effect.setTexture("shadowMapSampler", generator.getShadowMap());
                effect.setTexture("positionSampler", geometry.textures[2]);
                effect.setColor3("sunColor", this.sourceLight.diffuse);
                effect.setVector3("sunDirection", this.sourceLight.getShadowDirection());
                effect.setVector3("cameraPosition", this._scene.activeCamera.globalPosition);
                effect.setMatrix("shadowViewProjection", generator.getTransformMatrix());
                effect.setFloat("scatteringCoefficient", this.volumetricLightCoefficient);
                effect.setFloat("scatteringPower", this.volumetricLightPower);
                depthValues.x = this.sourceLight.getDepthMinZ(this._scene.activeCamera);
                depthValues.y = this.sourceLight.getDepthMaxZ(this._scene.activeCamera);
                effect.setVector2("depthValues", depthValues);
            }
        };
        this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(scene.getEngine(), "HDRVLS", ()=>{
            return this.volumetricLightPostProcess;
        }, true));
        // Smooth
        this._createBlurPostProcesses(scene, ratio / 4, 0, "volumetricLightBlurScale");
        // Merge
        this.volumetricLightMergePostProces = new (0, $cFdBb.PostProcess)("HDRVLSMerge", "standard", [], [
            "originalSampler"
        ], ratio, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, scene.getEngine(), false, "#define VLSMERGE");
        this.volumetricLightMergePostProces.onApply = (effect)=>{
            effect.setTextureFromPostProcess("originalSampler", this._bloomEnabled ? this.textureAdderFinalPostProcess : this.originalPostProcess);
            this._currentDepthOfFieldSource = this.volumetricLightFinalPostProcess;
        };
        this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(scene.getEngine(), "HDRVLSMerge", ()=>{
            return this.volumetricLightMergePostProces;
        }, true));
    }
    // Create luminance
    _createLuminancePostProcesses(scene, textureType) {
        // Create luminance
        let size = Math.pow(3, $dd627d48250adc75$export$bf8511a5404ec254.LuminanceSteps);
        this.luminancePostProcess = new (0, $cFdBb.PostProcess)("HDRLuminance", "standard", [
            "lumOffsets"
        ], [], {
            width: size,
            height: size
        }, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, scene.getEngine(), false, "#define LUMINANCE", textureType);
        const offsets = [];
        this.luminancePostProcess.onApply = (effect)=>{
            const sU = 1.0 / this.luminancePostProcess.width;
            const sV = 1.0 / this.luminancePostProcess.height;
            offsets[0] = -0.5 * sU;
            offsets[1] = 0.5 * sV;
            offsets[2] = 0.5 * sU;
            offsets[3] = 0.5 * sV;
            offsets[4] = -0.5 * sU;
            offsets[5] = -0.5 * sV;
            offsets[6] = 0.5 * sU;
            offsets[7] = -0.5 * sV;
            effect.setArray2("lumOffsets", offsets);
        };
        // Add to pipeline
        this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(scene.getEngine(), "HDRLuminance", ()=>{
            return this.luminancePostProcess;
        }, true));
        // Create down sample luminance
        for(let i = $dd627d48250adc75$export$bf8511a5404ec254.LuminanceSteps - 1; i >= 0; i--){
            size = Math.pow(3, i);
            let defines = "#define LUMINANCE_DOWN_SAMPLE\n";
            if (i === 0) defines += "#define FINAL_DOWN_SAMPLER";
            const postProcess = new (0, $cFdBb.PostProcess)("HDRLuminanceDownSample" + i, "standard", [
                "dsOffsets",
                "halfDestPixelSize"
            ], [], {
                width: size,
                height: size
            }, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, scene.getEngine(), false, defines, textureType);
            this.luminanceDownSamplePostProcesses.push(postProcess);
        }
        // Create callbacks and add effects
        let lastLuminance = this.luminancePostProcess;
        this.luminanceDownSamplePostProcesses.forEach((pp, index)=>{
            const downSampleOffsets = new Array(18);
            pp.onApply = (effect)=>{
                if (!lastLuminance) return;
                let id = 0;
                for(let x = -1; x < 2; x++)for(let y = -1; y < 2; y++){
                    downSampleOffsets[id] = x / lastLuminance.width;
                    downSampleOffsets[id + 1] = y / lastLuminance.height;
                    id += 2;
                }
                effect.setArray2("dsOffsets", downSampleOffsets);
                effect.setFloat("halfDestPixelSize", 0.5 / lastLuminance.width);
                if (index === this.luminanceDownSamplePostProcesses.length - 1) lastLuminance = this.luminancePostProcess;
                else lastLuminance = pp;
            };
            if (index === this.luminanceDownSamplePostProcesses.length - 1) pp.onAfterRender = ()=>{
                const pixel = scene.getEngine().readPixels(0, 0, 1, 1);
                const bit_shift = new (0, $ha1VO.Vector4)(0.00000006030862941101084, 1.0 / 65025, 1.0 / 255.0, 1.0);
                pixel.then((pixel)=>{
                    const data = new Uint8Array(pixel.buffer);
                    this._hdrCurrentLuminance = (data[0] * bit_shift.x + data[1] * bit_shift.y + data[2] * bit_shift.z + data[3] * bit_shift.w) / 100.0;
                });
            };
            this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(scene.getEngine(), "HDRLuminanceDownSample" + index, ()=>{
                return pp;
            }, true));
        });
    }
    // Create HDR post-process
    _createHdrPostProcess(scene, ratio) {
        const defines = [
            "#define HDR"
        ];
        if (this._hdrAutoExposure) defines.push("#define AUTO_EXPOSURE");
        this.hdrPostProcess = new (0, $cFdBb.PostProcess)("HDR", "standard", [
            "averageLuminance"
        ], [
            "textureAdderSampler"
        ], ratio, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, scene.getEngine(), false, defines.join("\n"), 0);
        let outputLiminance = 1;
        let time = 0;
        let lastTime = 0;
        this.hdrPostProcess.onApply = (effect)=>{
            effect.setTextureFromPostProcess("textureAdderSampler", this._currentDepthOfFieldSource);
            time += scene.getEngine().getDeltaTime();
            if (outputLiminance < 0) outputLiminance = this._hdrCurrentLuminance;
            else {
                const dt = (lastTime - time) / 1000.0;
                if (this._hdrCurrentLuminance < outputLiminance + this.hdrDecreaseRate * dt) outputLiminance += this.hdrDecreaseRate * dt;
                else if (this._hdrCurrentLuminance > outputLiminance - this.hdrIncreaseRate * dt) outputLiminance -= this.hdrIncreaseRate * dt;
                else outputLiminance = this._hdrCurrentLuminance;
            }
            if (this.hdrAutoExposure) this._currentExposure = this._fixedExposure / outputLiminance;
            else {
                outputLiminance = (0, $1VEEL.Scalar).Clamp(outputLiminance, this.hdrMinimumLuminance, 1e20);
                effect.setFloat("averageLuminance", outputLiminance);
            }
            lastTime = time;
            this._currentDepthOfFieldSource = this.hdrFinalPostProcess;
        };
        this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(scene.getEngine(), "HDR", ()=>{
            return this.hdrPostProcess;
        }, true));
    }
    // Create lens flare post-process
    _createLensFlarePostProcess(scene, ratio) {
        this.lensFlarePostProcess = new (0, $cFdBb.PostProcess)("HDRLensFlare", "standard", [
            "strength",
            "ghostDispersal",
            "haloWidth",
            "resolution",
            "distortionStrength"
        ], [
            "lensColorSampler"
        ], ratio / 2, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, scene.getEngine(), false, "#define LENS_FLARE", 0);
        this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(scene.getEngine(), "HDRLensFlare", ()=>{
            return this.lensFlarePostProcess;
        }, true));
        this._createBlurPostProcesses(scene, ratio / 4, 2, "lensFlareBlurWidth");
        this.lensFlareComposePostProcess = new (0, $cFdBb.PostProcess)("HDRLensFlareCompose", "standard", [
            "lensStarMatrix"
        ], [
            "otherSampler",
            "lensDirtSampler",
            "lensStarSampler"
        ], ratio, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, scene.getEngine(), false, "#define LENS_FLARE_COMPOSE", 0);
        this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(scene.getEngine(), "HDRLensFlareCompose", ()=>{
            return this.lensFlareComposePostProcess;
        }, true));
        const resolution = new (0, $ha1VO.Vector2)(0, 0);
        // Lens flare
        this.lensFlarePostProcess.externalTextureSamplerBinding = true;
        this.lensFlarePostProcess.onApply = (effect)=>{
            effect.setTextureFromPostProcess("textureSampler", this._bloomEnabled ? this.blurHPostProcesses[0] : this.originalPostProcess);
            effect.setTexture("lensColorSampler", this.lensColorTexture);
            effect.setFloat("strength", this.lensFlareStrength);
            effect.setFloat("ghostDispersal", this.lensFlareGhostDispersal);
            effect.setFloat("haloWidth", this.lensFlareHaloWidth);
            // Shift
            resolution.x = this.lensFlarePostProcess.width;
            resolution.y = this.lensFlarePostProcess.height;
            effect.setVector2("resolution", resolution);
            effect.setFloat("distortionStrength", this.lensFlareDistortionStrength);
        };
        // Compose
        const scaleBias1 = (0, $ha1VO.Matrix).FromValues(2.0, 0.0, -1, 0.0, 0.0, 2.0, -1, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0);
        const scaleBias2 = (0, $ha1VO.Matrix).FromValues(0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0);
        this.lensFlareComposePostProcess.onApply = (effect)=>{
            if (!this._scene.activeCamera) return;
            effect.setTextureFromPostProcess("otherSampler", this.lensFlarePostProcess);
            effect.setTexture("lensDirtSampler", this.lensFlareDirtTexture);
            effect.setTexture("lensStarSampler", this.lensStarTexture);
            // Lens start rotation matrix
            const camerax = this._scene.activeCamera.getViewMatrix().getRow(0);
            const cameraz = this._scene.activeCamera.getViewMatrix().getRow(2);
            let camRot = (0, $ha1VO.Vector3).Dot(camerax.toVector3(), new (0, $ha1VO.Vector3)(1.0, 0.0, 0.0)) + (0, $ha1VO.Vector3).Dot(cameraz.toVector3(), new (0, $ha1VO.Vector3)(0.0, 0.0, 1.0));
            camRot *= 4.0;
            const starRotation = (0, $ha1VO.Matrix).FromValues(Math.cos(camRot) * 0.5, -Math.sin(camRot), 0.0, 0.0, Math.sin(camRot), Math.cos(camRot) * 0.5, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0);
            const lensStarMatrix = scaleBias2.multiply(starRotation).multiply(scaleBias1);
            effect.setMatrix("lensStarMatrix", lensStarMatrix);
            this._currentDepthOfFieldSource = this.lensFlareFinalPostProcess;
        };
    }
    // Create depth-of-field post-process
    _createDepthOfFieldPostProcess(scene, ratio) {
        this.depthOfFieldPostProcess = new (0, $cFdBb.PostProcess)("HDRDepthOfField", "standard", [
            "distance"
        ], [
            "otherSampler",
            "depthSampler"
        ], ratio, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, scene.getEngine(), false, "#define DEPTH_OF_FIELD", 0);
        this.depthOfFieldPostProcess.onApply = (effect)=>{
            effect.setTextureFromPostProcess("otherSampler", this._currentDepthOfFieldSource);
            effect.setTexture("depthSampler", this._getDepthTexture());
            effect.setFloat("distance", this.depthOfFieldDistance);
        };
        // Add to pipeline
        this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(scene.getEngine(), "HDRDepthOfField", ()=>{
            return this.depthOfFieldPostProcess;
        }, true));
    }
    // Create motion blur post-process
    _createMotionBlurPostProcess(scene, ratio) {
        if (this._isObjectBasedMotionBlur) {
            const mb = new (0, $Jb4JF.MotionBlurPostProcess)("HDRMotionBlur", scene, ratio, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, scene.getEngine(), false, 0);
            mb.motionStrength = this.motionStrength;
            mb.motionBlurSamples = this.motionBlurSamples;
            this.motionBlurPostProcess = mb;
        } else {
            this.motionBlurPostProcess = new (0, $cFdBb.PostProcess)("HDRMotionBlur", "standard", [
                "inverseViewProjection",
                "prevViewProjection",
                "screenSize",
                "motionScale",
                "motionStrength"
            ], [
                "depthSampler"
            ], ratio, null, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, scene.getEngine(), false, "#define MOTION_BLUR\n#define MAX_MOTION_SAMPLES " + this.motionBlurSamples.toFixed(1), 0);
            let motionScale = 0;
            let prevViewProjection = (0, $ha1VO.Matrix).Identity();
            const invViewProjection = (0, $ha1VO.Matrix).Identity();
            let viewProjection = (0, $ha1VO.Matrix).Identity();
            const screenSize = (0, $ha1VO.Vector2).Zero();
            this.motionBlurPostProcess.onApply = (effect)=>{
                viewProjection = scene.getProjectionMatrix().multiply(scene.getViewMatrix());
                viewProjection.invertToRef(invViewProjection);
                effect.setMatrix("inverseViewProjection", invViewProjection);
                effect.setMatrix("prevViewProjection", prevViewProjection);
                prevViewProjection = viewProjection;
                screenSize.x = this.motionBlurPostProcess.width;
                screenSize.y = this.motionBlurPostProcess.height;
                effect.setVector2("screenSize", screenSize);
                motionScale = scene.getEngine().getFps() / 60.0;
                effect.setFloat("motionScale", motionScale);
                effect.setFloat("motionStrength", this.motionStrength);
                effect.setTexture("depthSampler", this._getDepthTexture());
            };
        }
        this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(scene.getEngine(), "HDRMotionBlur", ()=>{
            return this.motionBlurPostProcess;
        }, true));
    }
    _getDepthTexture() {
        if (this._scene.getEngine().getCaps().drawBuffersExtension) {
            const renderer = this._scene.enableGeometryBufferRenderer();
            return renderer.getGBuffer().textures[0];
        }
        return this._scene.enableDepthRenderer().getDepthMap();
    }
    _disposePostProcesses() {
        for(let i = 0; i < this._cameras.length; i++){
            const camera = this._cameras[i];
            if (this.originalPostProcess) this.originalPostProcess.dispose(camera);
            if (this.screenSpaceReflectionPostProcess) this.screenSpaceReflectionPostProcess.dispose(camera);
            if (this.downSampleX4PostProcess) this.downSampleX4PostProcess.dispose(camera);
            if (this.brightPassPostProcess) this.brightPassPostProcess.dispose(camera);
            if (this.textureAdderPostProcess) this.textureAdderPostProcess.dispose(camera);
            if (this.volumetricLightPostProcess) this.volumetricLightPostProcess.dispose(camera);
            if (this.volumetricLightSmoothXPostProcess) this.volumetricLightSmoothXPostProcess.dispose(camera);
            if (this.volumetricLightSmoothYPostProcess) this.volumetricLightSmoothYPostProcess.dispose(camera);
            if (this.volumetricLightMergePostProces) this.volumetricLightMergePostProces.dispose(camera);
            if (this.volumetricLightFinalPostProcess) this.volumetricLightFinalPostProcess.dispose(camera);
            if (this.lensFlarePostProcess) this.lensFlarePostProcess.dispose(camera);
            if (this.lensFlareComposePostProcess) this.lensFlareComposePostProcess.dispose(camera);
            for(let j = 0; j < this.luminanceDownSamplePostProcesses.length; j++)this.luminanceDownSamplePostProcesses[j].dispose(camera);
            if (this.luminancePostProcess) this.luminancePostProcess.dispose(camera);
            if (this.hdrPostProcess) this.hdrPostProcess.dispose(camera);
            if (this.hdrFinalPostProcess) this.hdrFinalPostProcess.dispose(camera);
            if (this.depthOfFieldPostProcess) this.depthOfFieldPostProcess.dispose(camera);
            if (this.motionBlurPostProcess) this.motionBlurPostProcess.dispose(camera);
            if (this.fxaaPostProcess) this.fxaaPostProcess.dispose(camera);
            for(let j = 0; j < this.blurHPostProcesses.length; j++)this.blurHPostProcesses[j].dispose(camera);
            for(let j = 0; j < this.blurVPostProcesses.length; j++)this.blurVPostProcesses[j].dispose(camera);
        }
        this.originalPostProcess = null;
        this.downSampleX4PostProcess = null;
        this.brightPassPostProcess = null;
        this.textureAdderPostProcess = null;
        this.textureAdderFinalPostProcess = null;
        this.volumetricLightPostProcess = null;
        this.volumetricLightSmoothXPostProcess = null;
        this.volumetricLightSmoothYPostProcess = null;
        this.volumetricLightMergePostProces = null;
        this.volumetricLightFinalPostProcess = null;
        this.lensFlarePostProcess = null;
        this.lensFlareComposePostProcess = null;
        this.luminancePostProcess = null;
        this.hdrPostProcess = null;
        this.hdrFinalPostProcess = null;
        this.depthOfFieldPostProcess = null;
        this.motionBlurPostProcess = null;
        this.fxaaPostProcess = null;
        this.screenSpaceReflectionPostProcess = null;
        this.luminanceDownSamplePostProcesses.length = 0;
        this.blurHPostProcesses.length = 0;
        this.blurVPostProcesses.length = 0;
    }
    /**
     * Dispose of the pipeline and stop all post processes
     */ dispose() {
        this._disposePostProcesses();
        this._scene.postProcessRenderPipelineManager.detachCamerasFromRenderPipeline(this._name, this._cameras);
        super.dispose();
    }
    /**
     * Serialize the rendering pipeline (Used when exporting)
     * @returns the serialized object
     */ serialize() {
        const serializationObject = (0, $6Ho1L.SerializationHelper).Serialize(this);
        if (this.sourceLight) serializationObject.sourceLightId = this.sourceLight.id;
        if (this.screenSpaceReflectionPostProcess) serializationObject.screenSpaceReflectionPostProcess = (0, $6Ho1L.SerializationHelper).Serialize(this.screenSpaceReflectionPostProcess);
        serializationObject.customType = "StandardRenderingPipeline";
        return serializationObject;
    }
    /**
     * Parse the serialized pipeline
     * @param source Source pipeline.
     * @param scene The scene to load the pipeline to.
     * @param rootUrl The URL of the serialized pipeline.
     * @returns An instantiated pipeline from the serialized object.
     */ static Parse(source, scene, rootUrl) {
        const p = (0, $6Ho1L.SerializationHelper).Parse(()=>new $dd627d48250adc75$export$bf8511a5404ec254(source._name, scene, source._ratio), source, scene, rootUrl);
        if (source.sourceLightId) p.sourceLight = scene.getLightById(source.sourceLightId);
        if (source.screenSpaceReflectionPostProcess) (0, $6Ho1L.SerializationHelper).Parse(()=>p.screenSpaceReflectionPostProcess, source.screenSpaceReflectionPostProcess, scene, rootUrl);
        return p;
    }
}
/**
 * Luminance steps
 */ $dd627d48250adc75$export$bf8511a5404ec254.LuminanceSteps = 6;
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $dd627d48250adc75$export$bf8511a5404ec254.prototype, "brightThreshold", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $dd627d48250adc75$export$bf8511a5404ec254.prototype, "blurWidth", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $dd627d48250adc75$export$bf8511a5404ec254.prototype, "horizontalBlur", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $dd627d48250adc75$export$bf8511a5404ec254.prototype, "exposure", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)("lensTexture")
], $dd627d48250adc75$export$bf8511a5404ec254.prototype, "lensTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $dd627d48250adc75$export$bf8511a5404ec254.prototype, "volumetricLightCoefficient", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $dd627d48250adc75$export$bf8511a5404ec254.prototype, "volumetricLightPower", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $dd627d48250adc75$export$bf8511a5404ec254.prototype, "volumetricLightBlurScale", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $dd627d48250adc75$export$bf8511a5404ec254.prototype, "hdrMinimumLuminance", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $dd627d48250adc75$export$bf8511a5404ec254.prototype, "hdrDecreaseRate", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $dd627d48250adc75$export$bf8511a5404ec254.prototype, "hdrIncreaseRate", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $dd627d48250adc75$export$bf8511a5404ec254.prototype, "hdrAutoExposure", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)("lensColorTexture")
], $dd627d48250adc75$export$bf8511a5404ec254.prototype, "lensColorTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $dd627d48250adc75$export$bf8511a5404ec254.prototype, "lensFlareStrength", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $dd627d48250adc75$export$bf8511a5404ec254.prototype, "lensFlareGhostDispersal", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $dd627d48250adc75$export$bf8511a5404ec254.prototype, "lensFlareHaloWidth", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $dd627d48250adc75$export$bf8511a5404ec254.prototype, "lensFlareDistortionStrength", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $dd627d48250adc75$export$bf8511a5404ec254.prototype, "lensFlareBlurWidth", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)("lensStarTexture")
], $dd627d48250adc75$export$bf8511a5404ec254.prototype, "lensStarTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsTexture)("lensFlareDirtTexture")
], $dd627d48250adc75$export$bf8511a5404ec254.prototype, "lensFlareDirtTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $dd627d48250adc75$export$bf8511a5404ec254.prototype, "depthOfFieldDistance", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $dd627d48250adc75$export$bf8511a5404ec254.prototype, "depthOfFieldBlurWidth", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $dd627d48250adc75$export$bf8511a5404ec254.prototype, "motionStrength", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $dd627d48250adc75$export$bf8511a5404ec254.prototype, "objectBasedMotionBlur", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $dd627d48250adc75$export$bf8511a5404ec254.prototype, "_ratio", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $dd627d48250adc75$export$bf8511a5404ec254.prototype, "BloomEnabled", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $dd627d48250adc75$export$bf8511a5404ec254.prototype, "DepthOfFieldEnabled", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $dd627d48250adc75$export$bf8511a5404ec254.prototype, "LensFlareEnabled", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $dd627d48250adc75$export$bf8511a5404ec254.prototype, "HDREnabled", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $dd627d48250adc75$export$bf8511a5404ec254.prototype, "VLSEnabled", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $dd627d48250adc75$export$bf8511a5404ec254.prototype, "MotionBlurEnabled", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $dd627d48250adc75$export$bf8511a5404ec254.prototype, "fxaaEnabled", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $dd627d48250adc75$export$bf8511a5404ec254.prototype, "screenSpaceReflectionsEnabled", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $dd627d48250adc75$export$bf8511a5404ec254.prototype, "volumetricLightStepsCount", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $dd627d48250adc75$export$bf8511a5404ec254.prototype, "motionBlurSamples", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $dd627d48250adc75$export$bf8511a5404ec254.prototype, "samples", null);
(0, $8DoUR.RegisterClass)("BABYLON.StandardRenderingPipeline", $dd627d48250adc75$export$bf8511a5404ec254);

});
parcelRegister("kMeib", function(module, exports) {

$parcel$export(module.exports, "ScreenSpaceReflectionPostProcess", () => $f203607bf6355eb8$export$14b8735302e60d0d);

var $e0Suo = parcelRequire("e0Suo");

var $cFdBb = parcelRequire("cFdBb");

var $gXqe5 = parcelRequire("gXqe5");

var $ir0rz = parcelRequire("ir0rz");

var $6Ho1L = parcelRequire("6Ho1L");

var $7DSSM = parcelRequire("7DSSM");
parcelRequire("ktoGt");

var $8DoUR = parcelRequire("8DoUR");

var $kVtWi = parcelRequire("kVtWi");
class $f203607bf6355eb8$export$14b8735302e60d0d extends (0, $cFdBb.PostProcess) {
    get _geometryBufferRenderer() {
        if (!this._forceGeometryBuffer) return null;
        return this._scene.geometryBufferRenderer;
    }
    get _prePassRenderer() {
        if (this._forceGeometryBuffer) return null;
        return this._scene.prePassRenderer;
    }
    /**
     * Gets a string identifying the name of the class
     * @returns "ScreenSpaceReflectionPostProcess" string
     */ getClassName() {
        return "ScreenSpaceReflectionPostProcess";
    }
    /**
     * Creates a new instance of ScreenSpaceReflectionPostProcess.
     * @param name The name of the effect.
     * @param scene The scene containing the objects to calculate reflections.
     * @param options The required width/height ratio to downsize to before computing the render pass.
     * @param camera The camera to apply the render pass to.
     * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
     * @param engine The engine which the post process will be applied. (default: current engine)
     * @param reusable If the post process can be reused on the same frame. (default: false)
     * @param textureType Type of textures used when performing the post process. (default: 0)
     * @param blockCompilation If compilation of the shader should not be done in the constructor. The updateEffect method can be used to compile the shader at a later time. (default: true)
     * @param forceGeometryBuffer If this post process should use geometry buffer instead of prepass (default: false)
     */ constructor(name, scene, options, camera, samplingMode, engine, reusable, textureType = 0, blockCompilation = false, forceGeometryBuffer = false){
        super(name, "screenSpaceReflection", [
            "projection",
            "view",
            "threshold",
            "reflectionSpecularFalloffExponent",
            "strength",
            "stepSize",
            "roughnessFactor"
        ], [
            "textureSampler",
            "normalSampler",
            "positionSampler",
            "reflectivitySampler"
        ], options, camera, samplingMode, engine, reusable, "#define SSR_SUPPORTED\n#define REFLECTION_SAMPLES 64\n#define SMOOTH_STEPS 5\n", textureType, undefined, null, blockCompilation);
        /**
         * Gets or sets a reflection threshold mainly used to adjust the reflection's height.
         */ this.threshold = 1.2;
        /**
         * Gets or sets the current reflection strength. 1.0 is an ideal value but can be increased/decreased for particular results.
         */ this.strength = 1;
        /**
         * Gets or sets the falloff exponent used while computing fresnel. More the exponent is high, more the reflections will be discrete.
         */ this.reflectionSpecularFalloffExponent = 3;
        /**
         * Gets or sets the step size used to iterate until the effect finds the color of the reflection's pixel. Typically in interval [0.1, 1.0]
         */ this.step = 1.0;
        /**
         * Gets or sets the factor applied when computing roughness. Default value is 0.2.
         */ this.roughnessFactor = 0.2;
        this._forceGeometryBuffer = false;
        this._enableSmoothReflections = false;
        this._reflectionSamples = 64;
        this._smoothSteps = 5;
        this._forceGeometryBuffer = forceGeometryBuffer;
        if (this._forceGeometryBuffer) {
            // Get geometry buffer renderer and update effect
            const geometryBufferRenderer = scene.enableGeometryBufferRenderer();
            if (geometryBufferRenderer) {
                if (geometryBufferRenderer.isSupported) {
                    geometryBufferRenderer.enablePosition = true;
                    geometryBufferRenderer.enableReflectivity = true;
                    if (geometryBufferRenderer.generateNormalsInWorldSpace) (0, $kVtWi.Logger).Error("ScreenSpaceReflectionPostProcess does not support generateNormalsInWorldSpace=true for the geometry buffer renderer!");
                }
            }
        } else {
            const prePassRenderer = scene.enablePrePassRenderer();
            prePassRenderer?.markAsDirty();
            if (prePassRenderer?.generateNormalsInWorldSpace) (0, $kVtWi.Logger).Error("ScreenSpaceReflectionPostProcess does not support generateNormalsInWorldSpace=true for the prepass renderer!");
            this._prePassEffectConfiguration = new (0, $7DSSM.ScreenSpaceReflectionsConfiguration)();
        }
        this._updateEffectDefines();
        // On apply, send uniforms
        this.onApply = (effect)=>{
            const geometryBufferRenderer = this._geometryBufferRenderer;
            const prePassRenderer = this._prePassRenderer;
            if (!prePassRenderer && !geometryBufferRenderer) return;
            if (geometryBufferRenderer) {
                // Samplers
                const positionIndex = geometryBufferRenderer.getTextureIndex((0, $gXqe5.GeometryBufferRenderer).POSITION_TEXTURE_TYPE);
                const roughnessIndex = geometryBufferRenderer.getTextureIndex((0, $gXqe5.GeometryBufferRenderer).REFLECTIVITY_TEXTURE_TYPE);
                effect.setTexture("normalSampler", geometryBufferRenderer.getGBuffer().textures[1]);
                effect.setTexture("positionSampler", geometryBufferRenderer.getGBuffer().textures[positionIndex]);
                effect.setTexture("reflectivitySampler", geometryBufferRenderer.getGBuffer().textures[roughnessIndex]);
            } else if (prePassRenderer) {
                // Samplers
                const positionIndex = prePassRenderer.getIndex(1);
                const roughnessIndex = prePassRenderer.getIndex(3);
                const normalIndex = prePassRenderer.getIndex(6);
                effect.setTexture("normalSampler", prePassRenderer.getRenderTarget().textures[normalIndex]);
                effect.setTexture("positionSampler", prePassRenderer.getRenderTarget().textures[positionIndex]);
                effect.setTexture("reflectivitySampler", prePassRenderer.getRenderTarget().textures[roughnessIndex]);
            }
            // Uniforms
            const camera = scene.activeCamera;
            if (!camera) return;
            const viewMatrix = camera.getViewMatrix(true);
            const projectionMatrix = camera.getProjectionMatrix(true);
            effect.setMatrix("projection", projectionMatrix);
            effect.setMatrix("view", viewMatrix);
            effect.setFloat("threshold", this.threshold);
            effect.setFloat("reflectionSpecularFalloffExponent", this.reflectionSpecularFalloffExponent);
            effect.setFloat("strength", this.strength);
            effect.setFloat("stepSize", this.step);
            effect.setFloat("roughnessFactor", this.roughnessFactor);
        };
        this._isSceneRightHanded = scene.useRightHandedSystem;
    }
    /**
     * Gets whether or not smoothing reflections is enabled.
     * Enabling smoothing will require more GPU power and can generate a drop in FPS.
     */ get enableSmoothReflections() {
        return this._enableSmoothReflections;
    }
    /**
     * Sets whether or not smoothing reflections is enabled.
     * Enabling smoothing will require more GPU power and can generate a drop in FPS.
     */ set enableSmoothReflections(enabled) {
        if (enabled === this._enableSmoothReflections) return;
        this._enableSmoothReflections = enabled;
        this._updateEffectDefines();
    }
    /**
     * Gets the number of samples taken while computing reflections. More samples count is high,
     * more the post-process wil require GPU power and can generate a drop in FPS. Basically in interval [25, 100].
     */ get reflectionSamples() {
        return this._reflectionSamples;
    }
    /**
     * Sets the number of samples taken while computing reflections. More samples count is high,
     * more the post-process wil require GPU power and can generate a drop in FPS. Basically in interval [25, 100].
     */ set reflectionSamples(samples) {
        if (samples === this._reflectionSamples) return;
        this._reflectionSamples = samples;
        this._updateEffectDefines();
    }
    /**
     * Gets the number of samples taken while smoothing reflections. More samples count is high,
     * more the post-process will require GPU power and can generate a drop in FPS.
     * Default value (5.0) work pretty well in all cases but can be adjusted.
     */ get smoothSteps() {
        return this._smoothSteps;
    }
    /*
     * Sets the number of samples taken while smoothing reflections. More samples count is high,
     * more the post-process will require GPU power and can generate a drop in FPS.
     * Default value (5.0) work pretty well in all cases but can be adjusted.
     */ set smoothSteps(steps) {
        if (steps === this._smoothSteps) return;
        this._smoothSteps = steps;
        this._updateEffectDefines();
    }
    _updateEffectDefines() {
        const defines = [];
        if (this._geometryBufferRenderer || this._prePassRenderer) defines.push("#define SSR_SUPPORTED");
        if (this._enableSmoothReflections) defines.push("#define ENABLE_SMOOTH_REFLECTIONS");
        if (this._isSceneRightHanded) defines.push("#define RIGHT_HANDED_SCENE");
        defines.push("#define REFLECTION_SAMPLES " + (this._reflectionSamples >> 0));
        defines.push("#define SMOOTH_STEPS " + (this._smoothSteps >> 0));
        this.updateEffect(defines.join("\n"));
    }
    /**
     * @internal
     */ static _Parse(parsedPostProcess, targetCamera, scene, rootUrl) {
        return (0, $6Ho1L.SerializationHelper).Parse(()=>{
            return new $f203607bf6355eb8$export$14b8735302e60d0d(parsedPostProcess.name, scene, parsedPostProcess.options, targetCamera, parsedPostProcess.renderTargetSamplingMode, scene.getEngine(), parsedPostProcess.textureType, parsedPostProcess.reusable);
        }, parsedPostProcess, scene, rootUrl);
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $f203607bf6355eb8$export$14b8735302e60d0d.prototype, "threshold", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $f203607bf6355eb8$export$14b8735302e60d0d.prototype, "strength", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $f203607bf6355eb8$export$14b8735302e60d0d.prototype, "reflectionSpecularFalloffExponent", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $f203607bf6355eb8$export$14b8735302e60d0d.prototype, "step", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $f203607bf6355eb8$export$14b8735302e60d0d.prototype, "roughnessFactor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $f203607bf6355eb8$export$14b8735302e60d0d.prototype, "enableSmoothReflections", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $f203607bf6355eb8$export$14b8735302e60d0d.prototype, "reflectionSamples", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $f203607bf6355eb8$export$14b8735302e60d0d.prototype, "smoothSteps", null);
(0, $8DoUR.RegisterClass)("BABYLON.ScreenSpaceReflectionPostProcess", $f203607bf6355eb8$export$14b8735302e60d0d);

});
parcelRegister("7DSSM", function(module, exports) {

$parcel$export(module.exports, "ScreenSpaceReflectionsConfiguration", () => $5906bf7753177278$export$6ec7891464adcf6c);
/**
 * Contains all parameters needed for the prepass to perform
 * screen space reflections
 */ class $5906bf7753177278$export$6ec7891464adcf6c {
    constructor(){
        /**
         * Is ssr enabled
         */ this.enabled = false;
        /**
         * Name of the configuration
         */ this.name = "screenSpaceReflections";
        /**
         * Textures that should be present in the MRT for this effect to work
         */ this.texturesRequired = [
            6,
            3,
            1
        ];
    }
}

});

parcelRegister("ktoGt", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $ee79a9d39a1013b0$var$name = "screenSpaceReflectionPixelShader";
const $ee79a9d39a1013b0$var$shader = `uniform sampler2D textureSampler;
#ifdef SSR_SUPPORTED
uniform sampler2D reflectivitySampler;uniform sampler2D normalSampler;uniform sampler2D positionSampler;
#endif
uniform mat4 view;uniform mat4 projection;uniform float stepSize;uniform float strength;uniform float threshold;uniform float roughnessFactor;uniform float reflectionSpecularFalloffExponent;varying vec2 vUV;
#ifdef SSR_SUPPORTED
struct ReflectionInfo {vec3 color;vec4 coords;};/**
* According to specular,see https:
*/
vec3 fresnelSchlick(float cosTheta,vec3 F0)
{return F0+(1.0-F0)*pow(1.0-cosTheta,5.0);}
/**
* Once the pixel's coordinates has been found,let's adjust (smooth) a little bit
* by sampling multiple reflection pixels.
*/
ReflectionInfo smoothReflectionInfo(vec3 dir,vec3 hitCoord)
{ReflectionInfo info;info.color=vec3(0.0);vec4 projectedCoord;float sampledDepth;for(int i=0; i<SMOOTH_STEPS; i++)
{projectedCoord=projection*vec4(hitCoord,1.0);projectedCoord.xy/=projectedCoord.w;projectedCoord.xy=0.5*projectedCoord.xy+vec2(0.5);sampledDepth=(view*texture2D(positionSampler,projectedCoord.xy)).z;float depth=sampledDepth-hitCoord.z;dir*=0.5;if(depth>0.0)
hitCoord-=dir;else
hitCoord+=dir;info.color+=texture2D(textureSampler,projectedCoord.xy).rgb;}
projectedCoord=projection*vec4(hitCoord,1.0);projectedCoord.xy/=projectedCoord.w;projectedCoord.xy=0.5*projectedCoord.xy+vec2(0.5);info.coords=vec4(projectedCoord.xy,sampledDepth,1.0);info.color+=texture2D(textureSampler,projectedCoord.xy).rgb;info.color/=float(SMOOTH_STEPS+1);return info;}
/**
* Tests the given world position (hitCoord) according to the given reflection vector (dir)
* until it finds a collision (means that depth is enough close to say "it's the pixel to sample!").
*/
ReflectionInfo getReflectionInfo(vec3 dir,vec3 hitCoord)
{ReflectionInfo info;vec4 projectedCoord;float sampledDepth;dir*=stepSize;for(int i=0; i<REFLECTION_SAMPLES; i++)
{hitCoord+=dir;projectedCoord=projection*vec4(hitCoord,1.0);projectedCoord.xy/=projectedCoord.w;projectedCoord.xy=0.5*projectedCoord.xy+vec2(0.5);sampledDepth=(view*texture2D(positionSampler,projectedCoord.xy)).z;float depth=sampledDepth-hitCoord.z;
#ifdef RIGHT_HANDED_SCENE
depth*=-1.0;
#endif
if(((depth-dir.z)<threshold) && depth<=0.0)
{
#ifdef ENABLE_SMOOTH_REFLECTIONS
return smoothReflectionInfo(dir,hitCoord);
#else
info.color=texture2D(textureSampler,projectedCoord.xy).rgb;info.coords=vec4(projectedCoord.xy,sampledDepth,0.0);return info;
#endif
}}
info.color=texture2D(textureSampler,projectedCoord.xy).rgb;info.coords=vec4(projectedCoord.xy,sampledDepth,0.0);return info;}
vec3 hash(vec3 a)
{a=fract(a*0.8);a+=dot(a,a.yxz+19.19);return fract((a.xxy+a.yxx)*a.zyx);}
#endif
void main()
{
#ifdef SSR_SUPPORTED
vec4 albedoFull=texture2D(textureSampler,vUV);vec3 albedo=albedoFull.rgb;float spec=texture2D(reflectivitySampler,vUV).r;if (spec==0.0) {gl_FragColor=albedoFull;return;}
vec3 normal=(texture2D(normalSampler,vUV)).xyz;vec3 position=(view*texture2D(positionSampler,vUV)).xyz;vec3 reflected=normalize(reflect(normalize(position),normalize(normal)));float roughness=1.0-texture2D(reflectivitySampler,vUV).a;vec3 jitt=mix(vec3(0.0),hash(position),roughness)*roughnessFactor;ReflectionInfo info=getReflectionInfo(jitt+reflected,position);vec2 dCoords=smoothstep(0.2,0.6,abs(vec2(0.5,0.5)-info.coords.xy));float screenEdgefactor=clamp(1.0-(dCoords.x+dCoords.y),0.0,1.0);vec3 F0=vec3(0.04);F0 =mix(F0,albedo,spec);vec3 fresnel=fresnelSchlick(max(dot(normalize(normal),normalize(position)),0.0),F0);
#ifdef RIGHT_HANDED_SCENE
reflected.z*=-1.0;
#endif
float reflectionMultiplier=clamp(pow(spec*strength,reflectionSpecularFalloffExponent)*screenEdgefactor*reflected.z,0.0,0.9);float albedoMultiplier=1.0-reflectionMultiplier;vec3 SSR=info.color*fresnel;gl_FragColor=vec4((albedo*albedoMultiplier)+(SSR*reflectionMultiplier),albedoFull.a);
#else
gl_FragColor=texture2D(textureSampler,vUV);
#endif
}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$ee79a9d39a1013b0$var$name] = $ee79a9d39a1013b0$var$shader;
const $ee79a9d39a1013b0$export$638b2e6a10101d50 = {
    name: $ee79a9d39a1013b0$var$name,
    shader: $ee79a9d39a1013b0$var$shader
};

});


parcelRegister("9wGIe", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("SJ1ad");
const $6ef83c033ce8342d$var$name = "standardPixelShader";
const $6ef83c033ce8342d$var$shader = `uniform sampler2D textureSampler;varying vec2 vUV;
#define CUSTOM_FRAGMENT_DEFINITIONS
#if defined(PASS_POST_PROCESS)
void main(void)
{vec4 color=texture2D(textureSampler,vUV);gl_FragColor=color;}
#endif
#if defined(DOWN_SAMPLE_X4)
uniform vec2 dsOffsets[16];void main(void)
{vec4 average=vec4(0.0,0.0,0.0,0.0);average=texture2D(textureSampler,vUV+dsOffsets[0]);average+=texture2D(textureSampler,vUV+dsOffsets[1]);average+=texture2D(textureSampler,vUV+dsOffsets[2]);average+=texture2D(textureSampler,vUV+dsOffsets[3]);average+=texture2D(textureSampler,vUV+dsOffsets[4]);average+=texture2D(textureSampler,vUV+dsOffsets[5]);average+=texture2D(textureSampler,vUV+dsOffsets[6]);average+=texture2D(textureSampler,vUV+dsOffsets[7]);average+=texture2D(textureSampler,vUV+dsOffsets[8]);average+=texture2D(textureSampler,vUV+dsOffsets[9]);average+=texture2D(textureSampler,vUV+dsOffsets[10]);average+=texture2D(textureSampler,vUV+dsOffsets[11]);average+=texture2D(textureSampler,vUV+dsOffsets[12]);average+=texture2D(textureSampler,vUV+dsOffsets[13]);average+=texture2D(textureSampler,vUV+dsOffsets[14]);average+=texture2D(textureSampler,vUV+dsOffsets[15]);average/=16.0;gl_FragColor=average;}
#endif
#if defined(BRIGHT_PASS)
uniform vec2 dsOffsets[4];uniform float brightThreshold;void main(void)
{vec4 average=vec4(0.0,0.0,0.0,0.0);average=texture2D(textureSampler,vUV+vec2(dsOffsets[0].x,dsOffsets[0].y));average+=texture2D(textureSampler,vUV+vec2(dsOffsets[1].x,dsOffsets[1].y));average+=texture2D(textureSampler,vUV+vec2(dsOffsets[2].x,dsOffsets[2].y));average+=texture2D(textureSampler,vUV+vec2(dsOffsets[3].x,dsOffsets[3].y));average*=0.25;float luminance=length(average.rgb);if (luminance<brightThreshold) {average=vec4(0.0,0.0,0.0,1.0);}
gl_FragColor=average;}
#endif
#if defined(TEXTURE_ADDER)
uniform sampler2D otherSampler;uniform sampler2D lensSampler;uniform float exposure;void main(void)
{vec3 colour=texture2D(textureSampler,vUV).rgb;colour*=exposure;vec3 X=max(vec3(0.0,0.0,0.0),colour-0.004);vec3 retColor=(X*(6.2*X+0.5))/(X*(6.2*X+1.7)+0.06);colour=retColor*retColor;colour+=colour*texture2D(lensSampler,vUV).rgb;vec4 finalColor=vec4(colour.rgb,1.0)+texture2D(otherSampler,vUV);gl_FragColor=finalColor;}
#endif
#if defined(VLS)
#define PI 3.1415926535897932384626433832795
uniform mat4 shadowViewProjection;uniform mat4 lightWorld;uniform vec3 cameraPosition;uniform vec3 sunDirection;uniform vec3 sunColor;uniform vec2 depthValues;uniform float scatteringCoefficient;uniform float scatteringPower;uniform sampler2D shadowMapSampler;uniform sampler2D positionSampler;float computeScattering(float lightDotView)
{float result=1.0-scatteringCoefficient*scatteringCoefficient;result/=(4.0*PI*pow(1.0+scatteringCoefficient*scatteringCoefficient-(2.0*scatteringCoefficient)*lightDotView,1.5));return result;}
void main(void)
{vec3 worldPos=texture2D(positionSampler,vUV).rgb;vec3 startPosition=cameraPosition;vec3 rayVector=worldPos-startPosition;float rayLength=length(rayVector);vec3 rayDirection=rayVector/rayLength;float stepLength=rayLength/NB_STEPS;vec3 stepL=rayDirection*stepLength;vec3 currentPosition=startPosition;vec3 accumFog=vec3(0.0);for (int i=0; i<int(NB_STEPS); i++)
{vec4 worldInShadowCameraSpace=shadowViewProjection*vec4(currentPosition,1.0);float depthMetric= (worldInShadowCameraSpace.z+depthValues.x)/(depthValues.y);float shadowPixelDepth=clamp(depthMetric,0.0,1.0);worldInShadowCameraSpace.xyz/=worldInShadowCameraSpace.w;worldInShadowCameraSpace.xyz=0.5*worldInShadowCameraSpace.xyz+vec3(0.5);float shadowMapValue=texture2D(shadowMapSampler,worldInShadowCameraSpace.xy).r;if (shadowMapValue>shadowPixelDepth)
accumFog+=sunColor*computeScattering(dot(rayDirection,sunDirection));currentPosition+=stepL;}
accumFog/=NB_STEPS;vec3 color=accumFog*scatteringPower;gl_FragColor=vec4(color*exp(color) ,1.0);}
#endif
#if defined(VLSMERGE)
uniform sampler2D originalSampler;void main(void)
{gl_FragColor=texture2D(originalSampler,vUV)+texture2D(textureSampler,vUV);}
#endif
#if defined(LUMINANCE)
uniform vec2 lumOffsets[4];void main()
{float average=0.0;vec4 color=vec4(0.0);float maximum=-1e20;vec3 weight=vec3(0.299,0.587,0.114);for (int i=0; i<4; i++)
{color=texture2D(textureSampler,vUV+ lumOffsets[i]);float GreyValue=dot(color.rgb,vec3(0.33,0.33,0.33));
#ifdef WEIGHTED_AVERAGE
float GreyValue=dot(color.rgb,weight);
#endif
#ifdef BRIGHTNESS
float GreyValue=max(color.r,max(color.g,color.b));
#endif
#ifdef HSL_COMPONENT
float GreyValue=0.5*(max(color.r,max(color.g,color.b))+min(color.r,min(color.g,color.b)));
#endif
#ifdef MAGNITUDE
float GreyValue=length(color.rgb);
#endif
maximum=max(maximum,GreyValue);average+=(0.25*log(1e-5+GreyValue));}
average=exp(average);gl_FragColor=vec4(average,maximum,0.0,1.0);}
#endif
#if defined(LUMINANCE_DOWN_SAMPLE)
uniform vec2 dsOffsets[9];uniform float halfDestPixelSize;
#ifdef FINAL_DOWN_SAMPLER
#include<packingFunctions>
#endif
void main()
{vec4 color=vec4(0.0);float average=0.0;for (int i=0; i<9; i++)
{color=texture2D(textureSampler,vUV+vec2(halfDestPixelSize,halfDestPixelSize)+dsOffsets[i]);average+=color.r;}
average/=9.0;
#ifdef FINAL_DOWN_SAMPLER
gl_FragColor=pack(average);
#else
gl_FragColor=vec4(average,average,0.0,1.0);
#endif
}
#endif
#if defined(HDR)
uniform sampler2D textureAdderSampler;uniform float averageLuminance;void main()
{vec4 color=texture2D(textureAdderSampler,vUV);
#ifndef AUTO_EXPOSURE
vec4 adjustedColor=color/averageLuminance;color=adjustedColor;color.a=1.0;
#endif
gl_FragColor=color;}
#endif
#if defined(LENS_FLARE)
#define GHOSTS 3
uniform sampler2D lensColorSampler;uniform float strength;uniform float ghostDispersal;uniform float haloWidth;uniform vec2 resolution;uniform float distortionStrength;float hash(vec2 p)
{float h=dot(p,vec2(127.1,311.7));return -1.0+2.0*fract(sin(h)*43758.5453123);}
float noise(in vec2 p)
{vec2 i=floor(p);vec2 f=fract(p);vec2 u=f*f*(3.0-2.0*f);return mix(mix(hash(i+vec2(0.0,0.0)),
hash(i+vec2(1.0,0.0)),u.x),
mix(hash(i+vec2(0.0,1.0)),
hash(i+vec2(1.0,1.0)),u.x),u.y);}
float fbm(vec2 p)
{float f=0.0;f+=0.5000*noise(p); p*=2.02;f+=0.2500*noise(p); p*=2.03;f+=0.1250*noise(p); p*=2.01;f+=0.0625*noise(p); p*=2.04;f/=0.9375;return f;}
vec3 pattern(vec2 uv)
{vec2 p=-1.0+2.0*uv;float p2=dot(p,p);float f=fbm(vec2(15.0*p2))/2.0;float r=0.2+0.6*sin(12.5*length(uv-vec2(0.5)));float g=0.2+0.6*sin(20.5*length(uv-vec2(0.5)));float b=0.2+0.6*sin(17.2*length(uv-vec2(0.5)));return (1.0-f)*vec3(r,g,b);}
float luminance(vec3 color)
{return dot(color.rgb,vec3(0.2126,0.7152,0.0722));}
vec4 textureDistorted(sampler2D tex,vec2 texcoord,vec2 direction,vec3 distortion)
{return vec4(
texture2D(tex,texcoord+direction*distortion.r).r,
texture2D(tex,texcoord+direction*distortion.g).g,
texture2D(tex,texcoord+direction*distortion.b).b,
1.0
);}
void main(void)
{vec2 uv=-vUV+vec2(1.0);vec2 ghostDir=(vec2(0.5)-uv)*ghostDispersal;vec2 texelSize=1.0/resolution;vec3 distortion=vec3(-texelSize.x*distortionStrength,0.0,texelSize.x*distortionStrength);vec4 result=vec4(0.0);float ghostIndice=1.0;for (int i=0; i<GHOSTS; ++i)
{vec2 offset=fract(uv+ghostDir*ghostIndice);float weight=length(vec2(0.5)-offset)/length(vec2(0.5));weight=pow(1.0-weight,10.0);result+=textureDistorted(textureSampler,offset,normalize(ghostDir),distortion)*weight*strength;ghostIndice+=1.0;}
vec2 haloVec=normalize(ghostDir)*haloWidth;float weight=length(vec2(0.5)-fract(uv+haloVec))/length(vec2(0.5));weight=pow(1.0-weight,10.0);result+=textureDistorted(textureSampler,fract(uv+haloVec),normalize(ghostDir),distortion)*weight*strength;result*=texture2D(lensColorSampler,vec2(length(vec2(0.5)-uv)/length(vec2(0.5))));gl_FragColor=result;}
#endif
#if defined(LENS_FLARE_COMPOSE)
uniform sampler2D otherSampler;uniform sampler2D lensDirtSampler;uniform sampler2D lensStarSampler;uniform mat4 lensStarMatrix;void main(void)
{vec2 lensFlareCoords=(lensStarMatrix*vec4(vUV,1.0,1.0)).xy;vec4 lensMod=texture2D(lensDirtSampler,vUV);lensMod+=texture2D(lensStarSampler,vUV/*lensFlareCoords*/);vec4 result=texture2D(textureSampler,vUV)*lensMod;gl_FragColor=texture2D(otherSampler,vUV)+result;}
#endif
#if defined(DEPTH_OF_FIELD)
uniform sampler2D otherSampler;uniform sampler2D depthSampler;uniform float distance;void main(void)
{vec4 sharp=texture2D(otherSampler,vUV);vec4 blur=texture2D(textureSampler,vUV);float dist=clamp(texture2D(depthSampler,vUV).r*distance,0.0,1.0);float factor=0.0;if (dist<0.05)
factor=1.0;else if (dist<0.1)
factor=20.0*(0.1-dist);else if (dist<0.5)
factor=0.0;else
factor=2.0*(dist-0.5);factor=clamp(factor,0.0,0.90);gl_FragColor=mix(sharp,blur,factor);}
#endif
#if defined(MOTION_BLUR)
uniform mat4 inverseViewProjection;uniform mat4 prevViewProjection;uniform vec2 screenSize;uniform float motionScale;uniform float motionStrength;uniform sampler2D depthSampler;void main(void)
{vec2 texelSize=1.0/screenSize;float depth=texture2D(depthSampler,vUV).r;vec4 cpos=vec4(vUV*2.0-1.0,depth,1.0);cpos=cpos*inverseViewProjection;vec4 ppos=cpos*prevViewProjection;ppos.xyz/=ppos.w;ppos.xy=ppos.xy*0.5+0.5;vec2 velocity=(ppos.xy-vUV)*motionScale*motionStrength;float speed=length(velocity/texelSize);int nSamples=int(clamp(speed,1.0,MAX_MOTION_SAMPLES));vec4 result=texture2D(textureSampler,vUV);for (int i=1; i<int(MAX_MOTION_SAMPLES); ++i) {if (i>=nSamples)
break;vec2 offset1=vUV+velocity*(float(i)/float(nSamples-1)-0.5);result+=texture2D(textureSampler,offset1);}
gl_FragColor=result/float(nSamples);}
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$6ef83c033ce8342d$var$name] = $6ef83c033ce8342d$var$shader;
const $6ef83c033ce8342d$export$69be6136acde345 = {
    name: $6ef83c033ce8342d$var$name,
    shader: $6ef83c033ce8342d$var$shader
};

});


parcelRegister("5Ply9", function(module, exports) {

$parcel$export(module.exports, "SSRRenderingPipeline", () => $43e26e81991da7dc$export$71a96a7116530c9d);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $6Ho1L = parcelRequire("6Ho1L");

var $ha1VO = parcelRequire("ha1VO");

var $cFdBb = parcelRequire("cFdBb");

var $goDmg = parcelRequire("goDmg");

var $81KKS = parcelRequire("81KKS");

var $8DoUR = parcelRequire("8DoUR");

var $9u4N9 = parcelRequire("9u4N9");

var $gXqe5 = parcelRequire("gXqe5");

var $UZ4tK = parcelRequire("UZ4tK");
parcelRequire("hD3tI");
parcelRequire("6ri8n");
parcelRequire("lyE3I");
parcelRequire("7hy84");
const $43e26e81991da7dc$var$trs = (0, $ha1VO.Matrix).Compose(new (0, $ha1VO.Vector3)(0.5, 0.5, 0.5), (0, $ha1VO.Quaternion).Identity(), new (0, $ha1VO.Vector3)(0.5, 0.5, 0.5));
const $43e26e81991da7dc$var$trsWebGPU = (0, $ha1VO.Matrix).Compose(new (0, $ha1VO.Vector3)(0.5, 0.5, 1), (0, $ha1VO.Quaternion).Identity(), new (0, $ha1VO.Vector3)(0.5, 0.5, 0));
class $43e26e81991da7dc$export$71a96a7116530c9d extends (0, $goDmg.PostProcessRenderPipeline) {
    /**
     * MSAA sample count, setting this to 4 will provide 4x anti aliasing. (default: 1)
     */ set samples(sampleCount) {
        if (this._samples === sampleCount) return;
        this._samples = sampleCount;
        this._buildPipeline();
    }
    get samples() {
        return this._samples;
    }
    /**
     * Gets or sets the minimum value for one of the reflectivity component of the material to consider it for SSR (default: 0.04).
     * If all r/g/b components of the reflectivity is below or equal this value, the pixel will not be considered reflective and SSR won't be applied.
     */ get reflectivityThreshold() {
        return this._reflectivityThreshold;
    }
    set reflectivityThreshold(threshold) {
        if (threshold === this._reflectivityThreshold) return;
        if (threshold === 0 && this._reflectivityThreshold !== 0 || threshold !== 0 && this._reflectivityThreshold === 0) {
            this._reflectivityThreshold = threshold;
            this._buildPipeline();
        } else this._reflectivityThreshold = threshold;
    }
    /**
     * Gets or sets the downsample factor used to reduce the size of the texture used to compute the SSR contribution (default: 0).
     * Use 0 to render the SSR contribution at full resolution, 1 to render at half resolution, 2 to render at 1/3 resolution, etc.
     * Note that it is used only when blurring is enabled (blurDispersionStrength \> 0), because in that mode the SSR contribution is generated in a separate texture.
     */ get ssrDownsample() {
        return this._ssrDownsample;
    }
    set ssrDownsample(downsample) {
        if (downsample === this._ssrDownsample) return;
        this._ssrDownsample = downsample;
        this._buildPipeline();
    }
    /**
     * Gets or sets the blur dispersion strength. Set this value to 0 to disable blurring (default: 0.05)
     * The reflections are blurred based on the roughness of the surface and the distance between the pixel shaded and the reflected pixel: the higher the distance the more blurry the reflection is.
     * blurDispersionStrength allows to increase or decrease this effect.
     */ get blurDispersionStrength() {
        return this._blurDispersionStrength;
    }
    set blurDispersionStrength(strength) {
        if (strength === this._blurDispersionStrength) return;
        const rebuild = strength === 0 && this._blurDispersionStrength !== 0 || strength !== 0 && this._blurDispersionStrength === 0;
        this._blurDispersionStrength = strength;
        if (rebuild) this._buildPipeline();
    }
    _useBlur() {
        return this._blurDispersionStrength > 0;
    }
    /**
     * Gets or sets the downsample factor used to reduce the size of the textures used to blur the reflection effect (default: 0).
     * Use 0 to blur at full resolution, 1 to render at half resolution, 2 to render at 1/3 resolution, etc.
     */ get blurDownsample() {
        return this._blurDownsample;
    }
    set blurDownsample(downsample) {
        if (downsample === this._blurDownsample) return;
        this._blurDownsample = downsample;
        this._buildPipeline();
    }
    /**
     * Gets or sets whether or not smoothing reflections is enabled (default: false)
     * Enabling smoothing will require more GPU power.
     * Note that this setting has no effect if step = 1: it's only used if step \> 1.
     */ get enableSmoothReflections() {
        return this._enableSmoothReflections;
    }
    set enableSmoothReflections(enabled) {
        if (enabled === this._enableSmoothReflections) return;
        this._enableSmoothReflections = enabled;
        this._updateEffectDefines();
    }
    /**
     * Gets or sets the environment cube texture used to define the reflection when the reflected rays of SSR leave the view space or when the maxDistance/maxSteps is reached.
     */ get environmentTexture() {
        return this._environmentTexture;
    }
    set environmentTexture(texture) {
        this._environmentTexture = texture;
        this._updateEffectDefines();
    }
    /**
     * Gets or sets the boolean defining if the environment texture is a standard cubemap (false) or a probe (true). Default value is false.
     * Note: a probe cube texture is treated differently than an ordinary cube texture because the Y axis is reversed.
     */ get environmentTextureIsProbe() {
        return this._environmentTextureIsProbe;
    }
    set environmentTextureIsProbe(isProbe) {
        this._environmentTextureIsProbe = isProbe;
        this._updateEffectDefines();
    }
    /**
     * Gets or sets a boolean indicating if the reflections should be attenuated at the screen borders (default: true).
     */ get attenuateScreenBorders() {
        return this._attenuateScreenBorders;
    }
    set attenuateScreenBorders(attenuate) {
        if (this._attenuateScreenBorders === attenuate) return;
        this._attenuateScreenBorders = attenuate;
        this._updateEffectDefines();
    }
    /**
     * Gets or sets a boolean indicating if the reflections should be attenuated according to the distance of the intersection (default: true).
     */ get attenuateIntersectionDistance() {
        return this._attenuateIntersectionDistance;
    }
    set attenuateIntersectionDistance(attenuate) {
        if (this._attenuateIntersectionDistance === attenuate) return;
        this._attenuateIntersectionDistance = attenuate;
        this._updateEffectDefines();
    }
    /**
     * Gets or sets a boolean indicating if the reflections should be attenuated according to the number of iterations performed to find the intersection (default: true).
     */ get attenuateIntersectionIterations() {
        return this._attenuateIntersectionIterations;
    }
    set attenuateIntersectionIterations(attenuate) {
        if (this._attenuateIntersectionIterations === attenuate) return;
        this._attenuateIntersectionIterations = attenuate;
        this._updateEffectDefines();
    }
    /**
     * Gets or sets a boolean indicating if the reflections should be attenuated when the reflection ray is facing the camera (the view direction) (default: false).
     */ get attenuateFacingCamera() {
        return this._attenuateFacingCamera;
    }
    set attenuateFacingCamera(attenuate) {
        if (this._attenuateFacingCamera === attenuate) return;
        this._attenuateFacingCamera = attenuate;
        this._updateEffectDefines();
    }
    /**
     * Gets or sets a boolean indicating if the backface reflections should be attenuated (default: false).
     */ get attenuateBackfaceReflection() {
        return this._attenuateBackfaceReflection;
    }
    set attenuateBackfaceReflection(attenuate) {
        if (this._attenuateBackfaceReflection === attenuate) return;
        this._attenuateBackfaceReflection = attenuate;
        this._updateEffectDefines();
    }
    /**
     * Gets or sets a boolean indicating if the ray should be clipped to the frustum (default: true).
     * You can try to set this parameter to false to save some performances: it may produce some artefacts in some cases, but generally they won't really be visible
     */ get clipToFrustum() {
        return this._clipToFrustum;
    }
    set clipToFrustum(clip) {
        if (this._clipToFrustum === clip) return;
        this._clipToFrustum = clip;
        this._updateEffectDefines();
    }
    /**
     * Gets or sets a boolean indicating whether the blending between the current color pixel and the reflection color should be done with a Fresnel coefficient (default: false).
     * It is more physically accurate to use the Fresnel coefficient (otherwise it uses the reflectivity of the material for blending), but it is also more expensive when you use blur (when blurDispersionStrength \> 0).
     */ get useFresnel() {
        return this._useFresnel;
    }
    set useFresnel(fresnel) {
        if (this._useFresnel === fresnel) return;
        this._useFresnel = fresnel;
        this._buildPipeline();
    }
    /**
     * Gets or sets a boolean defining if geometry thickness should be computed automatically (default: false).
     * When enabled, a depth renderer is created which will render the back faces of the scene to a depth texture (meaning additional work for the GPU).
     * In that mode, the "thickness" property is still used as an offset to compute the ray intersection, but you can typically use a much lower
     * value than when enableAutomaticThicknessComputation is false (it's even possible to use a value of 0 when using low values for "step")
     * Note that for performance reasons, this option will only apply to the first camera to which the rendering pipeline is attached!
     */ get enableAutomaticThicknessComputation() {
        return this._enableAutomaticThicknessComputation;
    }
    set enableAutomaticThicknessComputation(automatic) {
        if (this._enableAutomaticThicknessComputation === automatic) return;
        this._enableAutomaticThicknessComputation = automatic;
        this._buildPipeline();
    }
    /**
     * Gets the depth renderer used to render the back faces of the scene to a depth texture.
     */ get backfaceDepthRenderer() {
        return this._depthRenderer;
    }
    /**
     * Gets or sets the downsample factor (default: 0) used to create the backface depth texture - used only if enableAutomaticThicknessComputation = true.
     * Use 0 to render the depth at full resolution, 1 to render at half resolution, 2 to render at 1/4 resolution, etc.
     * Note that you will get rendering artefacts when using a value different from 0: it's a tradeoff between image quality and performances.
     */ get backfaceDepthTextureDownsample() {
        return this._backfaceDepthTextureDownsample;
    }
    set backfaceDepthTextureDownsample(factor) {
        if (this._backfaceDepthTextureDownsample === factor) return;
        this._backfaceDepthTextureDownsample = factor;
        this._resizeDepthRenderer();
    }
    /**
     * Gets or sets a boolean (default: true) indicating if the depth of transparent meshes should be written to the backface depth texture (when automatic thickness computation is enabled).
     */ get backfaceForceDepthWriteTransparentMeshes() {
        return this._backfaceForceDepthWriteTransparentMeshes;
    }
    set backfaceForceDepthWriteTransparentMeshes(force) {
        if (this._backfaceForceDepthWriteTransparentMeshes === force) return;
        this._backfaceForceDepthWriteTransparentMeshes = force;
        if (this._depthRenderer) this._depthRenderer.forceDepthWriteTransparentMeshes = force;
    }
    /**
     * Gets or sets a boolean indicating if the effect is enabled (default: true).
     */ get isEnabled() {
        return this._isEnabled;
    }
    set isEnabled(value) {
        if (this._isEnabled === value) return;
        this._isEnabled = value;
        if (!value) {
            if (this._cameras !== null) {
                this._scene.postProcessRenderPipelineManager.detachCamerasFromRenderPipeline(this._name, this._cameras);
                this._cameras = this._camerasToBeAttached.slice();
            }
        } else if (value) {
            if (!this._isDirty) {
                if (this._cameras !== null) this._scene.postProcessRenderPipelineManager.attachCamerasToRenderPipeline(this._name, this._cameras);
            } else this._buildPipeline();
        }
    }
    /**
     * Gets or sets a boolean defining if the input color texture is in gamma space (default: true)
     * The SSR effect works in linear space, so if the input texture is in gamma space, we must convert the texture to linear space before applying the effect
     */ get inputTextureColorIsInGammaSpace() {
        return this._inputTextureColorIsInGammaSpace;
    }
    set inputTextureColorIsInGammaSpace(gammaSpace) {
        if (this._inputTextureColorIsInGammaSpace === gammaSpace) return;
        this._inputTextureColorIsInGammaSpace = gammaSpace;
        this._buildPipeline();
    }
    /**
     * Gets or sets a boolean defining if the output color texture generated by the SSR pipeline should be in gamma space (default: true)
     * If you have a post-process that comes after the SSR and that post-process needs the input to be in a linear space, you must disable generateOutputInGammaSpace
     */ get generateOutputInGammaSpace() {
        return this._generateOutputInGammaSpace;
    }
    set generateOutputInGammaSpace(gammaSpace) {
        if (this._generateOutputInGammaSpace === gammaSpace) return;
        this._generateOutputInGammaSpace = gammaSpace;
        this._buildPipeline();
    }
    /**
     * Gets or sets a boolean indicating if the effect should be rendered in debug mode (default: false).
     * In this mode, colors have this meaning:
     *   - blue: the ray hit the max distance (we reached maxDistance)
     *   - red: the ray ran out of steps (we reached maxSteps)
     *   - yellow: the ray went off screen
     *   - green: the ray hit a surface. The brightness of the green color is proportional to the distance between the ray origin and the intersection point: A brighter green means more computation than a darker green.
     * In the first 3 cases, the final color is calculated by mixing the skybox color with the pixel color (if environmentTexture is defined), otherwise the pixel color is not modified
     * You should try to get as few blue/red/yellow pixels as possible, as this means that the ray has gone further than if it had hit a surface.
     */ get debug() {
        return this._debug;
    }
    set debug(value) {
        if (this._debug === value) return;
        this._debug = value;
        this._buildPipeline();
    }
    /**
     * Gets the scene the effect belongs to.
     * @returns the scene the effect belongs to.
     */ getScene() {
        return this._scene;
    }
    get _geometryBufferRenderer() {
        if (!this._forceGeometryBuffer) return null;
        return this._scene.geometryBufferRenderer;
    }
    get _prePassRenderer() {
        if (this._forceGeometryBuffer) return null;
        return this._scene.prePassRenderer;
    }
    /**
     * Gets active scene
     */ get scene() {
        return this._scene;
    }
    /**
     * Returns true if SSR is supported by the running hardware
     */ get isSupported() {
        const caps = this._scene.getEngine().getCaps();
        return caps.drawBuffersExtension && caps.texelFetch;
    }
    /**
     * Constructor of the SSR rendering pipeline
     * @param name The rendering pipeline name
     * @param scene The scene linked to this pipeline
     * @param cameras The array of cameras that the rendering pipeline will be attached to (default: scene.cameras)
     * @param forceGeometryBuffer Set to true if you want to use the legacy geometry buffer renderer (default: false)
     * @param textureType The texture type used by the different post processes created by SSR (default: 0)
     */ constructor(name, scene, cameras, forceGeometryBuffer = false, textureType = 0){
        super(scene.getEngine(), name);
        /**
         * The SSR PostProcess effect id in the pipeline
         */ this.SSRRenderEffect = "SSRRenderEffect";
        /**
         * The blur PostProcess effect id in the pipeline
         */ this.SSRBlurRenderEffect = "SSRBlurRenderEffect";
        /**
         * The PostProcess effect id in the pipeline that combines the SSR-Blur output with the original scene color
         */ this.SSRCombineRenderEffect = "SSRCombineRenderEffect";
        this._samples = 1;
        /**
         * Gets or sets the maxDistance used to define how far we look for reflection during the ray-marching on the reflected ray (default: 1000).
         * Note that this value is a view (camera) space distance (not pixels!).
         */ this.maxDistance = 1000.0;
        /**
         * Gets or sets the step size used to iterate until the effect finds the color of the reflection's pixel. Should be an integer \>= 1 as it is the number of pixels we advance at each step (default: 1).
         * Use higher values to improve performances (but at the expense of quality).
         */ this.step = 1.0;
        /**
         * Gets or sets the thickness value used as tolerance when computing the intersection between the reflected ray and the scene (default: 0.5).
         * If setting "enableAutomaticThicknessComputation" to true, you can use lower values for "thickness" (even 0), as the geometry thickness
         * is automatically computed thank to the regular depth buffer + the backface depth buffer
         */ this.thickness = 0.5;
        /**
         * Gets or sets the current reflection strength. 1.0 is an ideal value but can be increased/decreased for particular results (default: 1).
         */ this.strength = 1;
        /**
         * Gets or sets the falloff exponent used to compute the reflection strength. Higher values lead to fainter reflections (default: 1).
         */ this.reflectionSpecularFalloffExponent = 1;
        /**
         * Maximum number of steps during the ray marching process after which we consider an intersection could not be found (default: 1000).
         * Should be an integer value.
         */ this.maxSteps = 1000.0;
        /**
         * Gets or sets the factor applied when computing roughness. Default value is 0.2.
         * When blurring based on roughness is enabled (meaning blurDispersionStrength \> 0), roughnessFactor is used as a global roughness factor applied on all objects.
         * If you want to disable this global roughness set it to 0.
         */ this.roughnessFactor = 0.2;
        /**
         * Number of steps to skip at start when marching the ray to avoid self collisions (default: 1)
         * 1 should normally be a good value, depending on the scene you may need to use a higher value (2 or 3)
         */ this.selfCollisionNumSkip = 1;
        this._reflectivityThreshold = 0.04;
        this._ssrDownsample = 0;
        this._blurDispersionStrength = 0.03;
        this._blurDownsample = 0;
        this._enableSmoothReflections = false;
        this._environmentTextureIsProbe = false;
        this._attenuateScreenBorders = true;
        this._attenuateIntersectionDistance = true;
        this._attenuateIntersectionIterations = true;
        this._attenuateFacingCamera = false;
        this._attenuateBackfaceReflection = false;
        this._clipToFrustum = true;
        this._useFresnel = false;
        this._enableAutomaticThicknessComputation = false;
        this._backfaceDepthTextureDownsample = 0;
        this._backfaceForceDepthWriteTransparentMeshes = true;
        this._isEnabled = true;
        this._inputTextureColorIsInGammaSpace = true;
        this._generateOutputInGammaSpace = true;
        this._debug = false;
        this._forceGeometryBuffer = false;
        this._isDirty = false;
        this._camerasToBeAttached = [];
        this._cameras = cameras || scene.cameras;
        this._cameras = this._cameras.slice();
        this._camerasToBeAttached = this._cameras.slice();
        this._scene = scene;
        this._textureType = textureType;
        this._forceGeometryBuffer = forceGeometryBuffer;
        if (this.isSupported) {
            scene.postProcessRenderPipelineManager.addPipeline(this);
            if (this._forceGeometryBuffer) {
                const geometryBufferRenderer = scene.enableGeometryBufferRenderer();
                if (geometryBufferRenderer) {
                    geometryBufferRenderer.enableReflectivity = true;
                    geometryBufferRenderer.useSpecificClearForDepthTexture = true;
                }
            } else {
                const prePassRenderer = scene.enablePrePassRenderer();
                if (prePassRenderer) {
                    prePassRenderer.useSpecificClearForDepthTexture = true;
                    prePassRenderer.markAsDirty();
                }
            }
            this._buildPipeline();
        }
    }
    /**
     * Get the class name
     * @returns "SSRRenderingPipeline"
     */ getClassName() {
        return "SSRRenderingPipeline";
    }
    /**
     * Adds a camera to the pipeline
     * @param camera the camera to be added
     */ addCamera(camera) {
        this._camerasToBeAttached.push(camera);
        this._buildPipeline();
    }
    /**
     * Removes a camera from the pipeline
     * @param camera the camera to remove
     */ removeCamera(camera) {
        const index = this._camerasToBeAttached.indexOf(camera);
        this._camerasToBeAttached.splice(index, 1);
        this._buildPipeline();
    }
    /**
     * Removes the internal pipeline assets and detaches the pipeline from the scene cameras
     * @param disableGeometryBufferRenderer if the geometry buffer renderer should be disabled
     */ dispose(disableGeometryBufferRenderer = false) {
        this._disposeDepthRenderer();
        this._disposePostProcesses();
        if (disableGeometryBufferRenderer) this._scene.disableGeometryBufferRenderer();
        this._scene.postProcessRenderPipelineManager.detachCamerasFromRenderPipeline(this._name, this._cameras);
        super.dispose();
    }
    _getTextureSize() {
        const engine = this._scene.getEngine();
        const prePassRenderer = this._prePassRenderer;
        let textureSize = {
            width: engine.getRenderWidth(),
            height: engine.getRenderHeight()
        };
        if (prePassRenderer && this._scene.activeCamera?._getFirstPostProcess() === this._ssrPostProcess) {
            const renderTarget = prePassRenderer.getRenderTarget();
            if (renderTarget && renderTarget.textures) textureSize = renderTarget.textures[prePassRenderer.getIndex(4)].getSize();
        } else if (this._ssrPostProcess?.inputTexture) {
            textureSize.width = this._ssrPostProcess.inputTexture.width;
            textureSize.height = this._ssrPostProcess.inputTexture.height;
        }
        return textureSize;
    }
    _updateEffectDefines() {
        const defines = [];
        if (this._geometryBufferRenderer || this._prePassRenderer) defines.push("#define SSR_SUPPORTED");
        if (this._enableSmoothReflections) defines.push("#define SSRAYTRACE_ENABLE_REFINEMENT");
        if (this._scene.useRightHandedSystem) defines.push("#define SSRAYTRACE_RIGHT_HANDED_SCENE");
        if (this._environmentTexture) {
            defines.push("#define SSR_USE_ENVIRONMENT_CUBE");
            if (this._environmentTexture.boundingBoxSize) defines.push("#define SSR_USE_LOCAL_REFLECTIONMAP_CUBIC");
            if (this._environmentTexture.gammaSpace) defines.push("#define SSR_ENVIRONMENT_CUBE_IS_GAMMASPACE");
        }
        if (this._environmentTextureIsProbe) defines.push("#define SSR_INVERTCUBICMAP");
        if (this._enableAutomaticThicknessComputation) defines.push("#define SSRAYTRACE_USE_BACK_DEPTHBUFFER");
        if (this._attenuateScreenBorders) defines.push("#define SSR_ATTENUATE_SCREEN_BORDERS");
        if (this._attenuateIntersectionDistance) defines.push("#define SSR_ATTENUATE_INTERSECTION_DISTANCE");
        if (this._attenuateIntersectionIterations) defines.push("#define SSR_ATTENUATE_INTERSECTION_NUMITERATIONS");
        if (this._attenuateFacingCamera) defines.push("#define SSR_ATTENUATE_FACING_CAMERA");
        if (this._attenuateBackfaceReflection) defines.push("#define SSR_ATTENUATE_BACKFACE_REFLECTION");
        if (this._clipToFrustum) defines.push("#define SSRAYTRACE_CLIP_TO_FRUSTUM");
        if (this._useBlur()) defines.push("#define SSR_USE_BLUR");
        if (this._debug) defines.push("#define SSRAYTRACE_DEBUG");
        if (this._inputTextureColorIsInGammaSpace) defines.push("#define SSR_INPUT_IS_GAMMA_SPACE");
        if (this._generateOutputInGammaSpace) defines.push("#define SSR_OUTPUT_IS_GAMMA_SPACE");
        if (this._useFresnel) defines.push("#define SSR_BLEND_WITH_FRESNEL");
        if (this._reflectivityThreshold === 0) defines.push("#define SSR_DISABLE_REFLECTIVITY_TEST");
        if (this._geometryBufferRenderer?.generateNormalsInWorldSpace ?? this._prePassRenderer?.generateNormalsInWorldSpace) defines.push("#define SSR_NORMAL_IS_IN_WORLDSPACE");
        if (this._geometryBufferRenderer?.normalsAreUnsigned) defines.push("#define SSR_DECODE_NORMAL");
        this._ssrPostProcess?.updateEffect(defines.join("\n"));
    }
    _buildPipeline() {
        if (!this.isSupported) return;
        if (!this._isEnabled) {
            this._isDirty = true;
            return;
        }
        this._isDirty = false;
        const engine = this._scene.getEngine();
        this._disposeDepthRenderer();
        this._disposePostProcesses();
        if (this._cameras !== null) {
            this._scene.postProcessRenderPipelineManager.detachCamerasFromRenderPipeline(this._name, this._cameras);
            // get back cameras to be used to reattach pipeline
            this._cameras = this._camerasToBeAttached.slice();
        }
        this._reset();
        if (this._enableAutomaticThicknessComputation) {
            const camera = this._cameras?.[0];
            if (camera) {
                this._depthRendererCamera = camera;
                this._depthRenderer = new (0, $UZ4tK.DepthRenderer)(this._scene, undefined, undefined, undefined, 1, true, "SSRBackDepth");
                this._depthRenderer.clearColor.r = 1e8; // "infinity": put a big value because we use the storeCameraSpaceZ mode
                this._depthRenderer.reverseCulling = true; // we generate depth for the back faces
                this._depthRenderer.forceDepthWriteTransparentMeshes = this._backfaceForceDepthWriteTransparentMeshes;
                this._resizeDepthRenderer();
                camera.customRenderTargets.push(this._depthRenderer.getDepthMap());
            }
        }
        this._createSSRPostProcess();
        this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(engine, this.SSRRenderEffect, ()=>{
            return this._ssrPostProcess;
        }, true));
        if (this._useBlur()) {
            this._createBlurAndCombinerPostProcesses();
            this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(engine, this.SSRBlurRenderEffect, ()=>{
                return [
                    this._blurPostProcessX,
                    this._blurPostProcessY
                ];
            }, true));
            this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(engine, this.SSRCombineRenderEffect, ()=>{
                return this._blurCombinerPostProcess;
            }, true));
        }
        if (this._cameras !== null) this._scene.postProcessRenderPipelineManager.attachCamerasToRenderPipeline(this._name, this._cameras);
    }
    _resizeDepthRenderer() {
        if (!this._depthRenderer) return;
        const textureSize = this._getTextureSize();
        const depthRendererSize = this._depthRenderer.getDepthMap().getSize();
        const width = Math.floor(textureSize.width / (this._backfaceDepthTextureDownsample + 1));
        const height = Math.floor(textureSize.height / (this._backfaceDepthTextureDownsample + 1));
        if (depthRendererSize.width !== width || depthRendererSize.height !== height) this._depthRenderer.getDepthMap().resize({
            width: width,
            height: height
        });
    }
    _disposeDepthRenderer() {
        if (this._depthRenderer) {
            if (this._depthRendererCamera) {
                const idx = this._depthRendererCamera.customRenderTargets.indexOf(this._depthRenderer.getDepthMap()) ?? -1;
                if (idx !== -1) this._depthRendererCamera.customRenderTargets.splice(idx, 1);
            }
            this._depthRendererCamera = null;
            this._depthRenderer.getDepthMap().dispose();
        }
        this._depthRenderer = null;
    }
    _disposePostProcesses() {
        for(let i = 0; i < this._cameras.length; i++){
            const camera = this._cameras[i];
            this._ssrPostProcess?.dispose(camera);
            this._blurPostProcessX?.dispose(camera);
            this._blurPostProcessY?.dispose(camera);
            this._blurCombinerPostProcess?.dispose(camera);
        }
        this._ssrPostProcess = null;
        this._blurPostProcessX = null;
        this._blurPostProcessY = null;
        this._blurCombinerPostProcess = null;
    }
    _createSSRPostProcess() {
        this._ssrPostProcess = new (0, $cFdBb.PostProcess)("ssr", "screenSpaceReflection2", [
            "projection",
            "invProjectionMatrix",
            "view",
            "invView",
            "thickness",
            "reflectionSpecularFalloffExponent",
            "strength",
            "stepSize",
            "maxSteps",
            "roughnessFactor",
            "projectionPixel",
            "nearPlaneZ",
            "maxDistance",
            "selfCollisionNumSkip",
            "vReflectionPosition",
            "vReflectionSize",
            "backSizeFactor",
            "reflectivityThreshold"
        ], [
            "textureSampler",
            "normalSampler",
            "reflectivitySampler",
            "depthSampler",
            "envCubeSampler",
            "backDepthSampler"
        ], 1.0, null, this._textureType, this._scene.getEngine(), false, "", this._textureType);
        this._updateEffectDefines();
        this._ssrPostProcess.onApply = (effect)=>{
            this._resizeDepthRenderer();
            const geometryBufferRenderer = this._geometryBufferRenderer;
            const prePassRenderer = this._prePassRenderer;
            if (!prePassRenderer && !geometryBufferRenderer) return;
            if (geometryBufferRenderer) {
                const roughnessIndex = geometryBufferRenderer.getTextureIndex((0, $gXqe5.GeometryBufferRenderer).REFLECTIVITY_TEXTURE_TYPE);
                effect.setTexture("normalSampler", geometryBufferRenderer.getGBuffer().textures[1]);
                effect.setTexture("reflectivitySampler", geometryBufferRenderer.getGBuffer().textures[roughnessIndex]);
                effect.setTexture("depthSampler", geometryBufferRenderer.getGBuffer().textures[0]);
            } else if (prePassRenderer) {
                const depthIndex = prePassRenderer.getIndex(5);
                const roughnessIndex = prePassRenderer.getIndex(3);
                const normalIndex = prePassRenderer.getIndex(6);
                effect.setTexture("normalSampler", prePassRenderer.getRenderTarget().textures[normalIndex]);
                effect.setTexture("depthSampler", prePassRenderer.getRenderTarget().textures[depthIndex]);
                effect.setTexture("reflectivitySampler", prePassRenderer.getRenderTarget().textures[roughnessIndex]);
            }
            if (this._enableAutomaticThicknessComputation && this._depthRenderer) {
                effect.setTexture("backDepthSampler", this._depthRenderer.getDepthMap());
                effect.setFloat("backSizeFactor", this._backfaceDepthTextureDownsample + 1);
            }
            const camera = this._scene.activeCamera;
            if (!camera) return;
            const viewMatrix = camera.getViewMatrix();
            const projectionMatrix = camera.getProjectionMatrix();
            projectionMatrix.invertToRef((0, $ha1VO.TmpVectors).Matrix[0]);
            viewMatrix.invertToRef((0, $ha1VO.TmpVectors).Matrix[1]);
            effect.setMatrix("projection", projectionMatrix);
            effect.setMatrix("view", viewMatrix);
            effect.setMatrix("invView", (0, $ha1VO.TmpVectors).Matrix[1]);
            effect.setMatrix("invProjectionMatrix", (0, $ha1VO.TmpVectors).Matrix[0]);
            effect.setFloat("thickness", this.thickness);
            effect.setFloat("reflectionSpecularFalloffExponent", this.reflectionSpecularFalloffExponent);
            effect.setFloat("strength", this.strength);
            effect.setFloat("stepSize", this.step);
            effect.setFloat("maxSteps", this.maxSteps);
            effect.setFloat("roughnessFactor", this.roughnessFactor);
            effect.setFloat("nearPlaneZ", camera.minZ);
            effect.setFloat("maxDistance", this.maxDistance);
            effect.setFloat("selfCollisionNumSkip", this.selfCollisionNumSkip);
            effect.setFloat("reflectivityThreshold", this._reflectivityThreshold);
            const textureSize = this._getTextureSize();
            (0, $ha1VO.Matrix).ScalingToRef(textureSize.width, textureSize.height, 1, (0, $ha1VO.TmpVectors).Matrix[2]);
            projectionMatrix.multiplyToRef(this._scene.getEngine().isWebGPU ? $43e26e81991da7dc$var$trsWebGPU : $43e26e81991da7dc$var$trs, (0, $ha1VO.TmpVectors).Matrix[3]);
            (0, $ha1VO.TmpVectors).Matrix[3].multiplyToRef((0, $ha1VO.TmpVectors).Matrix[2], (0, $ha1VO.TmpVectors).Matrix[4]);
            effect.setMatrix("projectionPixel", (0, $ha1VO.TmpVectors).Matrix[4]);
            if (this._environmentTexture) {
                effect.setTexture("envCubeSampler", this._environmentTexture);
                if (this._environmentTexture.boundingBoxSize) {
                    effect.setVector3("vReflectionPosition", this._environmentTexture.boundingBoxPosition);
                    effect.setVector3("vReflectionSize", this._environmentTexture.boundingBoxSize);
                }
            }
        };
        this._ssrPostProcess.samples = this.samples;
        if (!this._forceGeometryBuffer) this._ssrPostProcess._prePassEffectConfiguration = new (0, $9u4N9.ScreenSpaceReflections2Configuration)();
    }
    _createBlurAndCombinerPostProcesses() {
        const engine = this._scene.getEngine();
        this._blurPostProcessX = new (0, $cFdBb.PostProcess)("SSRblurX", "screenSpaceReflection2Blur", [
            "texelOffsetScale"
        ], [
            "textureSampler"
        ], this._useBlur() ? 1 / (this._ssrDownsample + 1) : 1, null, 2, engine, false, "", this._textureType);
        this._blurPostProcessX.autoClear = false;
        this._blurPostProcessX.onApplyObservable.add((effect)=>{
            const width = this._blurPostProcessX?.inputTexture.width ?? this._scene.getEngine().getRenderWidth();
            effect.setFloat2("texelOffsetScale", this._blurDispersionStrength / width, 0);
        });
        this._blurPostProcessY = new (0, $cFdBb.PostProcess)("SSRblurY", "screenSpaceReflection2Blur", [
            "texelOffsetScale"
        ], [
            "textureSampler"
        ], this._useBlur() ? 1 / (this._blurDownsample + 1) : 1, null, 2, engine, false, "", this._textureType);
        this._blurPostProcessY.autoClear = false;
        this._blurPostProcessY.onApplyObservable.add((effect)=>{
            const height = this._blurPostProcessY?.inputTexture.height ?? this._scene.getEngine().getRenderHeight();
            effect.setFloat2("texelOffsetScale", 0, this._blurDispersionStrength / height);
        });
        const uniformNames = [
            "strength",
            "reflectionSpecularFalloffExponent",
            "reflectivityThreshold"
        ];
        const samplerNames = [
            "textureSampler",
            "mainSampler",
            "reflectivitySampler"
        ];
        let defines = "";
        if (this._debug) defines += "#define SSRAYTRACE_DEBUG\n";
        if (this._inputTextureColorIsInGammaSpace) defines += "#define SSR_INPUT_IS_GAMMA_SPACE\n";
        if (this._generateOutputInGammaSpace) defines += "#define SSR_OUTPUT_IS_GAMMA_SPACE\n";
        if (this.useFresnel) {
            defines += "#define SSR_BLEND_WITH_FRESNEL\n";
            uniformNames.push("projection", "invProjectionMatrix");
            samplerNames.push("depthSampler", "normalSampler");
        }
        if (this._reflectivityThreshold === 0) defines += "#define SSR_DISABLE_REFLECTIVITY_TEST";
        this._blurCombinerPostProcess = new (0, $cFdBb.PostProcess)("SSRblurCombiner", "screenSpaceReflection2BlurCombiner", uniformNames, samplerNames, this._useBlur() ? 1 / (this._blurDownsample + 1) : 1, null, 1, engine, false, defines, this._textureType);
        this._blurCombinerPostProcess.autoClear = false;
        this._blurCombinerPostProcess.onApplyObservable.add((effect)=>{
            const geometryBufferRenderer = this._geometryBufferRenderer;
            const prePassRenderer = this._prePassRenderer;
            if (!prePassRenderer && !geometryBufferRenderer) return;
            if (prePassRenderer && this._scene.activeCamera?._getFirstPostProcess() === this._ssrPostProcess) {
                const renderTarget = prePassRenderer.getRenderTarget();
                if (renderTarget && renderTarget.textures) effect.setTexture("mainSampler", renderTarget.textures[prePassRenderer.getIndex(4)]);
            } else effect.setTextureFromPostProcess("mainSampler", this._ssrPostProcess);
            if (geometryBufferRenderer) {
                const roughnessIndex = geometryBufferRenderer.getTextureIndex((0, $gXqe5.GeometryBufferRenderer).REFLECTIVITY_TEXTURE_TYPE);
                effect.setTexture("reflectivitySampler", geometryBufferRenderer.getGBuffer().textures[roughnessIndex]);
                if (this.useFresnel) {
                    effect.setTexture("normalSampler", geometryBufferRenderer.getGBuffer().textures[1]);
                    effect.setTexture("depthSampler", geometryBufferRenderer.getGBuffer().textures[0]);
                }
            } else if (prePassRenderer) {
                const roughnessIndex = prePassRenderer.getIndex(3);
                effect.setTexture("reflectivitySampler", prePassRenderer.getRenderTarget().textures[roughnessIndex]);
                if (this.useFresnel) {
                    const depthIndex = prePassRenderer.getIndex(5);
                    const normalIndex = prePassRenderer.getIndex(6);
                    effect.setTexture("normalSampler", prePassRenderer.getRenderTarget().textures[normalIndex]);
                    effect.setTexture("depthSampler", prePassRenderer.getRenderTarget().textures[depthIndex]);
                }
            }
            effect.setFloat("strength", this.strength);
            effect.setFloat("reflectionSpecularFalloffExponent", this.reflectionSpecularFalloffExponent);
            effect.setFloat("reflectivityThreshold", this._reflectivityThreshold);
            if (this.useFresnel) {
                const camera = this._scene.activeCamera;
                if (camera) {
                    const projectionMatrix = camera.getProjectionMatrix();
                    projectionMatrix.invertToRef((0, $ha1VO.TmpVectors).Matrix[0]);
                    effect.setMatrix("projection", projectionMatrix);
                    effect.setMatrix("invProjectionMatrix", (0, $ha1VO.TmpVectors).Matrix[0]);
                }
            }
        });
    }
    /**
     * Serializes the rendering pipeline (Used when exporting)
     * @returns the serialized object
     */ serialize() {
        const serializationObject = (0, $6Ho1L.SerializationHelper).Serialize(this);
        serializationObject.customType = "SSRRenderingPipeline";
        return serializationObject;
    }
    /**
     * Parse the serialized pipeline
     * @param source Source pipeline.
     * @param scene The scene to load the pipeline to.
     * @param rootUrl The URL of the serialized pipeline.
     * @returns An instantiated pipeline from the serialized object.
     */ static Parse(source, scene, rootUrl) {
        return (0, $6Ho1L.SerializationHelper).Parse(()=>new $43e26e81991da7dc$export$71a96a7116530c9d(source._name, scene, source._ratio), source, scene, rootUrl);
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $43e26e81991da7dc$export$71a96a7116530c9d.prototype, "samples", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $43e26e81991da7dc$export$71a96a7116530c9d.prototype, "maxDistance", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $43e26e81991da7dc$export$71a96a7116530c9d.prototype, "step", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $43e26e81991da7dc$export$71a96a7116530c9d.prototype, "thickness", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $43e26e81991da7dc$export$71a96a7116530c9d.prototype, "strength", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $43e26e81991da7dc$export$71a96a7116530c9d.prototype, "reflectionSpecularFalloffExponent", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $43e26e81991da7dc$export$71a96a7116530c9d.prototype, "maxSteps", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $43e26e81991da7dc$export$71a96a7116530c9d.prototype, "roughnessFactor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $43e26e81991da7dc$export$71a96a7116530c9d.prototype, "selfCollisionNumSkip", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $43e26e81991da7dc$export$71a96a7116530c9d.prototype, "_reflectivityThreshold", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("_ssrDownsample")
], $43e26e81991da7dc$export$71a96a7116530c9d.prototype, "_ssrDownsample", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $43e26e81991da7dc$export$71a96a7116530c9d.prototype, "ssrDownsample", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("blurDispersionStrength")
], $43e26e81991da7dc$export$71a96a7116530c9d.prototype, "_blurDispersionStrength", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("blurDownsample")
], $43e26e81991da7dc$export$71a96a7116530c9d.prototype, "_blurDownsample", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("enableSmoothReflections")
], $43e26e81991da7dc$export$71a96a7116530c9d.prototype, "_enableSmoothReflections", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("environmentTexture")
], $43e26e81991da7dc$export$71a96a7116530c9d.prototype, "_environmentTexture", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("environmentTextureIsProbe")
], $43e26e81991da7dc$export$71a96a7116530c9d.prototype, "_environmentTextureIsProbe", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("attenuateScreenBorders")
], $43e26e81991da7dc$export$71a96a7116530c9d.prototype, "_attenuateScreenBorders", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("attenuateIntersectionDistance")
], $43e26e81991da7dc$export$71a96a7116530c9d.prototype, "_attenuateIntersectionDistance", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("attenuateIntersectionIterations")
], $43e26e81991da7dc$export$71a96a7116530c9d.prototype, "_attenuateIntersectionIterations", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("attenuateFacingCamera")
], $43e26e81991da7dc$export$71a96a7116530c9d.prototype, "_attenuateFacingCamera", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("attenuateBackfaceReflection")
], $43e26e81991da7dc$export$71a96a7116530c9d.prototype, "_attenuateBackfaceReflection", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("clipToFrustum")
], $43e26e81991da7dc$export$71a96a7116530c9d.prototype, "_clipToFrustum", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("useFresnel")
], $43e26e81991da7dc$export$71a96a7116530c9d.prototype, "_useFresnel", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("enableAutomaticThicknessComputation")
], $43e26e81991da7dc$export$71a96a7116530c9d.prototype, "_enableAutomaticThicknessComputation", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("backfaceDepthTextureDownsample")
], $43e26e81991da7dc$export$71a96a7116530c9d.prototype, "_backfaceDepthTextureDownsample", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("backfaceForceDepthWriteTransparentMeshes")
], $43e26e81991da7dc$export$71a96a7116530c9d.prototype, "_backfaceForceDepthWriteTransparentMeshes", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("isEnabled")
], $43e26e81991da7dc$export$71a96a7116530c9d.prototype, "_isEnabled", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("inputTextureColorIsInGammaSpace")
], $43e26e81991da7dc$export$71a96a7116530c9d.prototype, "_inputTextureColorIsInGammaSpace", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("generateOutputInGammaSpace")
], $43e26e81991da7dc$export$71a96a7116530c9d.prototype, "_generateOutputInGammaSpace", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("debug")
], $43e26e81991da7dc$export$71a96a7116530c9d.prototype, "_debug", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.SSRRenderingPipeline", $43e26e81991da7dc$export$71a96a7116530c9d);

});
parcelRegister("9u4N9", function(module, exports) {

$parcel$export(module.exports, "ScreenSpaceReflections2Configuration", () => $6e7aa1f4394abd96$export$9e89360d9550101d);
/**
 * Contains all parameters needed for the prepass to perform
 * screen space reflections
 */ class $6e7aa1f4394abd96$export$9e89360d9550101d {
    constructor(){
        /**
         * Is ssr enabled
         */ this.enabled = false;
        /**
         * Name of the configuration
         */ this.name = "screenSpaceReflections2";
        /**
         * Textures that should be present in the MRT for this effect to work
         */ this.texturesRequired = [
            6,
            3,
            5
        ];
    }
}

});

parcelRegister("6ri8n", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("7Hs3g");
parcelRequire("bzdhG");
parcelRequire("1m8DL");
const $4b0354c31f94e02b$var$name = "screenSpaceReflection2PixelShader";
const $4b0354c31f94e02b$var$shader = `#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
#define TEXTUREFUNC(s,c,lod) texture2DLodEXT(s,c,lod)
#define TEXTURECUBEFUNC(s,c,lod) textureLod(s,c,lod)
#else
#define TEXTUREFUNC(s,c,bias) texture2D(s,c,bias)
#define TEXTURECUBEFUNC(s,c,bias) textureCube(s,c,bias)
#endif
uniform sampler2D textureSampler;varying vec2 vUV;
#ifdef SSR_SUPPORTED
uniform sampler2D reflectivitySampler;uniform sampler2D normalSampler;uniform sampler2D depthSampler;
#ifdef SSRAYTRACE_USE_BACK_DEPTHBUFFER
uniform sampler2D backDepthSampler;uniform float backSizeFactor;
#endif
#ifdef SSR_USE_ENVIRONMENT_CUBE
uniform samplerCube envCubeSampler;
#ifdef SSR_USE_LOCAL_REFLECTIONMAP_CUBIC
uniform vec3 vReflectionPosition;uniform vec3 vReflectionSize;
#endif
#endif
uniform mat4 view;uniform mat4 invView;uniform mat4 projection;uniform mat4 invProjectionMatrix;uniform mat4 projectionPixel;uniform float nearPlaneZ;uniform float stepSize;uniform float maxSteps;uniform float strength;uniform float thickness;uniform float roughnessFactor;uniform float reflectionSpecularFalloffExponent;uniform float maxDistance;uniform float selfCollisionNumSkip;uniform float reflectivityThreshold;
#include<helperFunctions>
#include<pbrBRDFFunctions>
#include<screenSpaceRayTrace>
vec3 hash(vec3 a)
{a=fract(a*0.8);a+=dot(a,a.yxz+19.19);return fract((a.xxy+a.yxx)*a.zyx);}
float computeAttenuationForIntersection(ivec2 hitPixel,vec2 hitUV,vec3 vsRayOrigin,vec3 vsHitPoint,vec3 reflectionVector,float maxRayDistance,float numIterations) {float attenuation=1.0;
#ifdef SSR_ATTENUATE_SCREEN_BORDERS
vec2 dCoords=smoothstep(0.2,0.6,abs(vec2(0.5,0.5)-hitUV.xy));attenuation*=clamp(1.0-(dCoords.x+dCoords.y),0.0,1.0);
#endif
#ifdef SSR_ATTENUATE_INTERSECTION_DISTANCE
attenuation*=1.0-clamp(distance(vsRayOrigin,vsHitPoint)/maxRayDistance,0.0,1.0);
#endif
#ifdef SSR_ATTENUATE_INTERSECTION_NUMITERATIONS
attenuation*=1.0-(numIterations/maxSteps);
#endif
#ifdef SSR_ATTENUATE_BACKFACE_REFLECTION
vec3 reflectionNormal=texelFetch(normalSampler,hitPixel,0).xyz;float directionBasedAttenuation=smoothstep(-0.17,0.0,dot(reflectionNormal,-reflectionVector));attenuation*=directionBasedAttenuation;
#endif
return attenuation;}
#endif
void main()
{
#ifdef SSR_SUPPORTED
vec4 colorFull=TEXTUREFUNC(textureSampler,vUV,0.0);vec3 color=colorFull.rgb;vec4 reflectivity=TEXTUREFUNC(reflectivitySampler,vUV,0.0);
#ifndef SSR_DISABLE_REFLECTIVITY_TEST
if (max(reflectivity.r,max(reflectivity.g,reflectivity.b))<=reflectivityThreshold) {
#ifdef SSR_USE_BLUR
gl_FragColor=vec4(0.);
#else
gl_FragColor=colorFull;
#endif
return;}
#endif
#ifdef SSR_INPUT_IS_GAMMA_SPACE
color=toLinearSpace(color);
#endif
vec2 texSize=vec2(textureSize(depthSampler,0));vec3 csNormal=texelFetch(normalSampler,ivec2(vUV*texSize),0).xyz; 
#ifdef SSR_DECODE_NORMAL
csNormal=csNormal*2.0-1.0;
#endif
#ifdef SSR_NORMAL_IS_IN_WORLDSPACE
csNormal=(view*vec4(csNormal,0.0)).xyz;
#endif
float depth=texelFetch(depthSampler,ivec2(vUV*texSize),0).r;vec3 csPosition=computeViewPosFromUVDepth(vUV,depth,projection,invProjectionMatrix);vec3 csViewDirection=normalize(csPosition);vec3 csReflectedVector=reflect(csViewDirection,csNormal);
#ifdef SSR_USE_ENVIRONMENT_CUBE
vec3 wReflectedVector=vec3(invView*vec4(csReflectedVector,0.0));
#ifdef SSR_USE_LOCAL_REFLECTIONMAP_CUBIC
vec4 worldPos=invView*vec4(csPosition,1.0);wReflectedVector=parallaxCorrectNormal(worldPos.xyz,normalize(wReflectedVector),vReflectionSize,vReflectionPosition);
#endif
#ifdef SSR_INVERTCUBICMAP
wReflectedVector.y*=-1.0;
#endif
#ifdef SSRAYTRACE_RIGHT_HANDED_SCENE
wReflectedVector.z*=-1.0;
#endif
vec3 envColor=TEXTURECUBEFUNC(envCubeSampler,wReflectedVector,0.0).xyz;
#ifdef SSR_ENVIRONMENT_CUBE_IS_GAMMASPACE
envColor=toLinearSpace(envColor);
#endif
#else
vec3 envColor=color;
#endif
float reflectionAttenuation=1.0;bool rayHasHit=false;vec2 startPixel;vec2 hitPixel;vec3 hitPoint;float numIterations;
#ifdef SSRAYTRACE_DEBUG
vec3 debugColor;
#endif
#ifdef SSR_ATTENUATE_FACING_CAMERA
reflectionAttenuation*=1.0-smoothstep(0.25,0.5,dot(-csViewDirection,csReflectedVector));
#endif
if (reflectionAttenuation>0.0) {
#ifdef SSR_USE_BLUR
vec3 jitt=vec3(0.);
#else
float roughness=1.0-reflectivity.a;vec3 jitt=mix(vec3(0.0),hash(csPosition)-vec3(0.5),roughness)*roughnessFactor; 
#endif
vec2 uv2=vUV*texSize;float c=(uv2.x+uv2.y)*0.25;float jitter=mod(c,1.0); 
rayHasHit=traceScreenSpaceRay1(
csPosition,
normalize(csReflectedVector+jitt),
projectionPixel,
depthSampler,
texSize,
#ifdef SSRAYTRACE_USE_BACK_DEPTHBUFFER
backDepthSampler,
backSizeFactor,
#endif
thickness,
nearPlaneZ,
stepSize,
jitter,
maxSteps,
maxDistance,
selfCollisionNumSkip,
startPixel,
hitPixel,
hitPoint,
numIterations
#ifdef SSRAYTRACE_DEBUG
,debugColor
#endif
);}
#ifdef SSRAYTRACE_DEBUG
gl_FragColor=vec4(debugColor,1.);return;
#endif
vec3 F0=reflectivity.rgb;vec3 fresnel=fresnelSchlickGGX(max(dot(csNormal,-csViewDirection),0.0),F0,vec3(1.));vec3 SSR=envColor;if (rayHasHit) {vec3 reflectedColor=texelFetch(textureSampler,ivec2(hitPixel),0).rgb;
#ifdef SSR_INPUT_IS_GAMMA_SPACE
reflectedColor=toLinearSpace(reflectedColor);
#endif
reflectionAttenuation*=computeAttenuationForIntersection(ivec2(hitPixel),hitPixel/texSize,csPosition,hitPoint,csReflectedVector,maxDistance,numIterations);SSR=reflectedColor*reflectionAttenuation+(1.0-reflectionAttenuation)*envColor;}
#ifndef SSR_BLEND_WITH_FRESNEL
SSR*=fresnel;
#endif
#ifdef SSR_USE_BLUR
float blur_radius=0.0;float roughness=1.0-reflectivity.a*(1.0-roughnessFactor);if (roughness>0.001) {float cone_angle=min(roughness,0.999)*3.14159265*0.5;float cone_len=distance(startPixel,hitPixel);float op_len=2.0*tan(cone_angle)*cone_len; 
float a=op_len;float h=cone_len;float a2=a*a;float fh2=4.0f*h*h;blur_radius=(a*(sqrt(a2+fh2)-a))/(4.0f*h);}
gl_FragColor=vec4(SSR,blur_radius/255.0); 
#else
#ifdef SSR_BLEND_WITH_FRESNEL
vec3 reflectionMultiplier=clamp(pow(fresnel*strength,vec3(reflectionSpecularFalloffExponent)),0.0,1.0);
#else
vec3 reflectionMultiplier=clamp(pow(reflectivity.rgb*strength,vec3(reflectionSpecularFalloffExponent)),0.0,1.0);
#endif
vec3 colorMultiplier=1.0-reflectionMultiplier;vec3 finalColor=(color*colorMultiplier)+(SSR*reflectionMultiplier);
#ifdef SSR_OUTPUT_IS_GAMMA_SPACE
finalColor=toGammaSpace(finalColor);
#endif
gl_FragColor=vec4(finalColor,colorFull.a);
#endif
#else
gl_FragColor=TEXTUREFUNC(textureSampler,vUV,0.0);
#endif
}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$4b0354c31f94e02b$var$name] = $4b0354c31f94e02b$var$shader;
const $4b0354c31f94e02b$export$d4dc8e99d961dcc2 = {
    name: $4b0354c31f94e02b$var$name,
    shader: $4b0354c31f94e02b$var$shader
};

});
parcelRegister("1m8DL", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $0fce8c4e73d564e2$var$name = "screenSpaceRayTrace";
const $0fce8c4e73d564e2$var$shader = `float distanceSquared(vec2 a,vec2 b) { a-=b; return dot(a,a); }
/**
\param csOrigin Camera-space ray origin,which must be 
within the view volume and must have z>0.01 and project within the valid screen rectangle
\param csDirection Unit length camera-space ray direction
\param projectToPixelMatrix A projection matrix that maps to **pixel** coordinates 
(**not** [-1,+1] normalized device coordinates).
\param csZBuffer The camera-space Z buffer
\param csZBufferSize Dimensions of csZBuffer
\param csZThickness Camera space csZThickness to ascribe to each pixel in the depth buffer
\param nearPlaneZ Positive number. Doesn't have to be THE actual near plane,just a reasonable value
for clipping rays headed towards the camera
\param stride Step in horizontal or vertical pixels between samples. This is a float
because integer math is slow on GPUs,but should be set to an integer>=1
\param jitterFraction Number between 0 and 1 for how far to bump the ray in stride units
to conceal banding artifacts,plus the stride ray offset.
\param maxSteps Maximum number of iterations. Higher gives better images but may be slow
\param maxRayTraceDistance Maximum camera-space distance to trace before returning a miss
\param selfCollisionNumSkip Number of steps to skip at start when raytracing to avoid self collisions.
1 is a reasonable value,depending on the scene you may need to set this value to 2
\param hitPixel Pixel coordinates of the first intersection with the scene
\param numIterations number of iterations performed
\param csHitPoint Camera space location of the ray hit
*/
#define inline
bool traceScreenSpaceRay1(
vec3 csOrigin,
vec3 csDirection,
mat4 projectToPixelMatrix,
sampler2D csZBuffer,
vec2 csZBufferSize,
#ifdef SSRAYTRACE_USE_BACK_DEPTHBUFFER
sampler2D csZBackBuffer,
float csZBackSizeFactor,
#endif
float csZThickness,
float nearPlaneZ,
float stride,
float jitterFraction,
float maxSteps,
float maxRayTraceDistance,
float selfCollisionNumSkip,
out vec2 startPixel,
out vec2 hitPixel,
out vec3 csHitPoint,
out float numIterations
#ifdef SSRAYTRACE_DEBUG
,out vec3 debugColor
#endif
)
{
#ifdef SSRAYTRACE_RIGHT_HANDED_SCENE
float rayLength=(csOrigin.z+csDirection.z*maxRayTraceDistance)>-nearPlaneZ ? (-nearPlaneZ-csOrigin.z)/csDirection.z : maxRayTraceDistance;
#else
float rayLength=(csOrigin.z+csDirection.z*maxRayTraceDistance)<nearPlaneZ ? (nearPlaneZ-csOrigin.z)/csDirection.z : maxRayTraceDistance;
#endif
vec3 csEndPoint=csOrigin+csDirection*rayLength;hitPixel=vec2(-1.0,-1.0);vec4 H0=projectToPixelMatrix*vec4(csOrigin,1.0);vec4 H1=projectToPixelMatrix*vec4(csEndPoint,1.0);float k0=1.0/H0.w;float k1=1.0/H1.w;vec3 Q0=csOrigin*k0;vec3 Q1=csEndPoint*k1;vec2 P0=H0.xy*k0;vec2 P1=H1.xy*k1;
#ifdef SSRAYTRACE_CLIP_TO_FRUSTUM
float xMax=csZBufferSize.x-0.5,xMin=0.5,yMax=csZBufferSize.y-0.5,yMin=0.5;float alpha=0.0;if ((P1.y>yMax) || (P1.y<yMin)) {alpha=(P1.y-((P1.y>yMax) ? yMax : yMin))/(P1.y-P0.y);}
if ((P1.x>xMax) || (P1.x<xMin)) {alpha=max(alpha,(P1.x-((P1.x>xMax) ? xMax : xMin))/(P1.x-P0.x));}
P1=mix(P1,P0,alpha); k1=mix(k1,k0,alpha); Q1=mix(Q1,Q0,alpha);
#endif
P1+=vec2((distanceSquared(P0,P1)<0.0001) ? 0.01 : 0.0);vec2 delta=P1-P0;bool permute=false;if (abs(delta.x)<abs(delta.y)) { 
permute=true;delta=delta.yx;P0=P0.yx;P1=P1.yx; }
float stepDirection=sign(delta.x);float invdx=stepDirection/delta.x;vec2 dP=vec2(stepDirection,delta.y*invdx);vec3 dQ=(Q1-Q0)*invdx;float dk=(k1-k0)*invdx;float zMin=min(csEndPoint.z,csOrigin.z);float zMax=max(csEndPoint.z,csOrigin.z);dP*=stride; dQ*=stride; dk*=stride;P0+=dP*jitterFraction; Q0+=dQ*jitterFraction; k0+=dk*jitterFraction;vec4 pqk=vec4(P0,Q0.z,k0);vec4 dPQK=vec4(dP,dQ.z,dk);startPixel=permute ? P0.yx : P0.xy;float prevZMaxEstimate=csOrigin.z;float rayZMin=prevZMaxEstimate,rayZMax=prevZMaxEstimate;float sceneZMax=rayZMax+1e4;float end=P1.x*stepDirection;bool hit=false;float stepCount;for (stepCount=0.0;stepCount<=selfCollisionNumSkip ||
(pqk.x*stepDirection)<=end &&
stepCount<maxSteps &&
!hit &&
sceneZMax != 0.0; 
pqk+=dPQK,++stepCount)
{hitPixel=permute ? pqk.yx : pqk.xy;rayZMin=prevZMaxEstimate;rayZMax=(dPQK.z*0.5+pqk.z)/(dPQK.w*0.5+pqk.w);rayZMax=clamp(rayZMax,zMin,zMax);prevZMaxEstimate=rayZMax;if (rayZMin>rayZMax) { 
float t=rayZMin; rayZMin=rayZMax; rayZMax=t;}
sceneZMax=texelFetch(csZBuffer,ivec2(hitPixel),0).r;
#ifdef SSRAYTRACE_RIGHT_HANDED_SCENE
#ifdef SSRAYTRACE_USE_BACK_DEPTHBUFFER
float sceneBackZ=texelFetch(csZBackBuffer,ivec2(hitPixel/csZBackSizeFactor),0).r;hit=(rayZMax>=sceneBackZ-csZThickness) && (rayZMin<=sceneZMax);
#else
hit=(rayZMax>=sceneZMax-csZThickness) && (rayZMin<=sceneZMax);
#endif
#else
#ifdef SSRAYTRACE_USE_BACK_DEPTHBUFFER
float sceneBackZ=texelFetch(csZBackBuffer,ivec2(hitPixel/csZBackSizeFactor),0).r;hit=(rayZMin<=sceneBackZ+csZThickness) && (rayZMax>=sceneZMax) && (sceneZMax != 0.0);
#else
hit=(rayZMin<=sceneZMax+csZThickness) && (rayZMax>=sceneZMax);
#endif
#endif
}
pqk-=dPQK;stepCount-=1.0;if (((pqk.x+dPQK.x)*stepDirection)>end || (stepCount+1.0)>=maxSteps || sceneZMax==0.0) {hit=false;}
#ifdef SSRAYTRACE_ENABLE_REFINEMENT
if (stride>1.0 && hit) {pqk-=dPQK;stepCount-=1.0;float invStride=1.0/stride;dPQK*=invStride;float refinementStepCount=0.0;prevZMaxEstimate=pqk.z/pqk.w;rayZMax=prevZMaxEstimate;sceneZMax=rayZMax+1e7;for (;refinementStepCount<=1.0 ||
(refinementStepCount<=stride*1.4) &&
(rayZMax<sceneZMax) && (sceneZMax != 0.0);pqk+=dPQK,refinementStepCount+=1.0)
{rayZMin=prevZMaxEstimate;rayZMax=(dPQK.z*0.5+pqk.z)/(dPQK.w*0.5+pqk.w);rayZMax=clamp(rayZMax,zMin,zMax);prevZMaxEstimate=rayZMax;rayZMax=max(rayZMax,rayZMin);hitPixel=permute ? pqk.yx : pqk.xy;sceneZMax=texelFetch(csZBuffer,ivec2(hitPixel),0).r;}
pqk-=dPQK;refinementStepCount-=1.0;stepCount+=refinementStepCount/stride;}
#endif
Q0.xy+=dQ.xy*stepCount;Q0.z=pqk.z;csHitPoint=Q0/pqk.w;numIterations=stepCount+1.0;
#ifdef SSRAYTRACE_DEBUG
if (((pqk.x+dPQK.x)*stepDirection)>end) {debugColor=vec3(0,0,1);} else if ((stepCount+1.0)>=maxSteps) {debugColor=vec3(1,0,0);} else if (sceneZMax==0.0) {debugColor=vec3(1,1,0);} else {debugColor=vec3(0,stepCount/maxSteps,0);}
#endif
return hit;}
/**
texCoord: in the [0,1] range
depth: depth in view space (range [znear,zfar]])
*/
vec3 computeViewPosFromUVDepth(vec2 texCoord,float depth,mat4 projection,mat4 invProjectionMatrix) {vec4 ndc;ndc.xy=texCoord*2.0-1.0;
#ifdef SSRAYTRACE_RIGHT_HANDED_SCENE
ndc.z=-projection[2].z-projection[3].z/depth;
#else
ndc.z=projection[2].z+projection[3].z/depth;
#endif
ndc.w=1.0;vec4 eyePos=invProjectionMatrix*ndc;eyePos.xyz/=eyePos.w;return eyePos.xyz;}
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$0fce8c4e73d564e2$var$name] = $0fce8c4e73d564e2$var$shader;
const $0fce8c4e73d564e2$export$6fa884ad8277aef5 = {
    name: $0fce8c4e73d564e2$var$name,
    shader: $0fce8c4e73d564e2$var$shader
};

});


parcelRegister("lyE3I", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $fb1bd8cf35483bdb$var$name = "screenSpaceReflection2BlurPixelShader";
const $fb1bd8cf35483bdb$var$shader = `#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
#define TEXTUREFUNC(s,c,lod) texture2DLodEXT(s,c,lod)
#else
#define TEXTUREFUNC(s,c,bias) texture2D(s,c,bias)
#endif
uniform sampler2D textureSampler;varying vec2 vUV;uniform vec2 texelOffsetScale;const float weights[8]=float[8] (0.071303,0.131514,0.189879,0.321392,0.452906, 0.584419,0.715932,0.847445);void processSample(vec2 uv,float i,vec2 stepSize,inout vec4 accumulator,inout float denominator)
{vec2 offsetUV=stepSize*i+uv;float coefficient=weights[int(2.0-abs(i))];accumulator+=TEXTUREFUNC(textureSampler,offsetUV,0.0)*coefficient;denominator+=coefficient;}
void main()
{vec4 colorFull=TEXTUREFUNC(textureSampler,vUV,0.0);if (dot(colorFull,vec4(1.0))==0.0) {gl_FragColor=colorFull;return;}
float blurRadius=colorFull.a*255.0; 
vec2 stepSize=texelOffsetScale.xy*blurRadius;vec4 accumulator=TEXTUREFUNC(textureSampler,vUV,0.0)*0.214607;float denominator=0.214607;processSample(vUV,1.0,stepSize,accumulator,denominator);processSample(vUV,1.0*0.2,stepSize,accumulator,denominator);processSample(vUV,1.0*0.4,stepSize,accumulator,denominator);processSample(vUV,1.0*0.6,stepSize,accumulator,denominator);processSample(vUV,1.0*0.8,stepSize,accumulator,denominator);processSample(vUV,1.0*1.2,stepSize,accumulator,denominator);processSample(vUV,1.0*1.4,stepSize,accumulator,denominator);processSample(vUV,1.0*1.6,stepSize,accumulator,denominator);processSample(vUV,1.0*1.8,stepSize,accumulator,denominator);processSample(vUV,1.0*2.0,stepSize,accumulator,denominator);processSample(vUV,-1.0,stepSize,accumulator,denominator);processSample(vUV,-1.0*0.2,stepSize,accumulator,denominator);processSample(vUV,-1.0*0.4,stepSize,accumulator,denominator);processSample(vUV,-1.0*0.6,stepSize,accumulator,denominator);processSample(vUV,-1.0*0.8,stepSize,accumulator,denominator);processSample(vUV,-1.0*1.2,stepSize,accumulator,denominator);processSample(vUV,-1.0*1.4,stepSize,accumulator,denominator);processSample(vUV,-1.0*1.6,stepSize,accumulator,denominator);processSample(vUV,-1.0*1.8,stepSize,accumulator,denominator);processSample(vUV,-1.0*2.0,stepSize,accumulator,denominator);gl_FragColor=vec4(accumulator.rgb/denominator,colorFull.a);}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$fb1bd8cf35483bdb$var$name] = $fb1bd8cf35483bdb$var$shader;
const $fb1bd8cf35483bdb$export$c6d5be23565240b7 = {
    name: $fb1bd8cf35483bdb$var$name,
    shader: $fb1bd8cf35483bdb$var$shader
};

});

parcelRegister("7hy84", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("7Hs3g");
parcelRequire("bzdhG");
parcelRequire("1m8DL");
const $54d498454d155a3d$var$name = "screenSpaceReflection2BlurCombinerPixelShader";
const $54d498454d155a3d$var$shader = `uniform sampler2D textureSampler; 
uniform sampler2D mainSampler;uniform sampler2D reflectivitySampler;uniform float strength;uniform float reflectionSpecularFalloffExponent;uniform float reflectivityThreshold;varying vec2 vUV;
#include<helperFunctions>
#ifdef SSR_BLEND_WITH_FRESNEL
#include<pbrBRDFFunctions>
#include<screenSpaceRayTrace>
uniform mat4 projection;uniform mat4 invProjectionMatrix;uniform sampler2D normalSampler;uniform sampler2D depthSampler;
#endif
void main()
{
#ifdef SSRAYTRACE_DEBUG
gl_FragColor=texture2D(textureSampler,vUV);
#else
vec3 SSR=texture2D(textureSampler,vUV).rgb;vec4 color=texture2D(mainSampler,vUV);vec4 reflectivity=texture2D(reflectivitySampler,vUV);
#ifndef SSR_DISABLE_REFLECTIVITY_TEST
if (max(reflectivity.r,max(reflectivity.g,reflectivity.b))<=reflectivityThreshold) {gl_FragColor=color;return;}
#endif
#ifdef SSR_INPUT_IS_GAMMA_SPACE
color=toLinearSpace(color);
#endif
#ifdef SSR_BLEND_WITH_FRESNEL
vec2 texSize=vec2(textureSize(depthSampler,0));vec3 csNormal=texelFetch(normalSampler,ivec2(vUV*texSize),0).xyz;float depth=texelFetch(depthSampler,ivec2(vUV*texSize),0).r;vec3 csPosition=computeViewPosFromUVDepth(vUV,depth,projection,invProjectionMatrix);vec3 csViewDirection=normalize(csPosition);vec3 F0=reflectivity.rgb;vec3 fresnel=fresnelSchlickGGX(max(dot(csNormal,-csViewDirection),0.0),F0,vec3(1.));vec3 reflectionMultiplier=clamp(pow(fresnel*strength,vec3(reflectionSpecularFalloffExponent)),0.0,1.0);
#else
vec3 reflectionMultiplier=clamp(pow(reflectivity.rgb*strength,vec3(reflectionSpecularFalloffExponent)),0.0,1.0);
#endif
vec3 colorMultiplier=1.0-reflectionMultiplier;vec3 finalColor=(color.rgb*colorMultiplier)+(SSR*reflectionMultiplier);
#ifdef SSR_OUTPUT_IS_GAMMA_SPACE
finalColor=toGammaSpace(finalColor);
#endif
gl_FragColor=vec4(finalColor,color.a);
#endif
}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$54d498454d155a3d$var$name] = $54d498454d155a3d$var$shader;
const $54d498454d155a3d$export$af83cdf06ba9971 = {
    name: $54d498454d155a3d$var$name,
    shader: $54d498454d155a3d$var$shader
};

});


parcelRegister("i7ok5", function(module, exports) {

$parcel$export(module.exports, "TAARenderingPipeline", () => $d30bbf76f8b7e8db$export$672678794626a899);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $6Ho1L = parcelRequire("6Ho1L");

var $74SKQ = parcelRequire("74SKQ");

var $cFdBb = parcelRequire("cFdBb");

var $goDmg = parcelRequire("goDmg");

var $81KKS = parcelRequire("81KKS");

var $8DoUR = parcelRequire("8DoUR");

var $c7c1r = parcelRequire("c7c1r");

var $5V90k = parcelRequire("5V90k");
parcelRequire("hD3tI");
parcelRequire("iNCNf");
class $d30bbf76f8b7e8db$export$672678794626a899 extends (0, $goDmg.PostProcessRenderPipeline) {
    /**
     * Number of accumulated samples (default: 16)
     */ set samples(samples) {
        if (this._samples === samples) return;
        this._samples = samples;
        this._hs.regenerate(samples);
    }
    get samples() {
        return this._samples;
    }
    /**
     * MSAA samples (default: 1)
     */ set msaaSamples(samples) {
        if (this._msaaSamples === samples) return;
        this._msaaSamples = samples;
        if (this._taaPostProcess) this._taaPostProcess.samples = samples;
    }
    get msaaSamples() {
        return this._msaaSamples;
    }
    /**
     * Gets or sets a boolean indicating if the render pipeline is enabled (default: true).
     */ get isEnabled() {
        return this._isEnabled;
    }
    set isEnabled(value) {
        if (this._isEnabled === value) return;
        this._isEnabled = value;
        if (!value) {
            if (this._cameras !== null) {
                this._scene.postProcessRenderPipelineManager.detachCamerasFromRenderPipeline(this._name, this._cameras);
                this._cameras = this._camerasToBeAttached.slice();
            }
        } else if (value) {
            if (!this._isDirty) {
                if (this._cameras !== null) {
                    this._firstUpdate = true;
                    this._scene.postProcessRenderPipelineManager.attachCamerasToRenderPipeline(this._name, this._cameras);
                }
            } else this._buildPipeline();
        }
    }
    /**
     * Gets active scene
     */ get scene() {
        return this._scene;
    }
    /**
     * Returns true if TAA is supported by the running hardware
     */ get isSupported() {
        const caps = this._scene.getEngine().getCaps();
        return caps.texelFetch;
    }
    /**
     * Constructor of the TAA rendering pipeline
     * @param name The rendering pipeline name
     * @param scene The scene linked to this pipeline
     * @param cameras The array of cameras that the rendering pipeline will be attached to (default: scene.cameras)
     * @param textureType The type of texture where the scene will be rendered (default: 0)
     */ constructor(name, scene, cameras, textureType = 0){
        const engine = scene.getEngine();
        super(engine, name);
        /**
         * The TAA PostProcess effect id in the pipeline
         */ this.TAARenderEffect = "TAARenderEffect";
        /**
         * The pass PostProcess effect id in the pipeline
         */ this.TAAPassEffect = "TAAPassEffect";
        this._samples = 8;
        this._msaaSamples = 1;
        /**
         * The factor used to blend the history frame with current frame (default: 0.05)
         */ this.factor = 0.05;
        /**
         * Disable TAA on camera move (default: true).
         * You generally want to keep this enabled, otherwise you will get a ghost effect when the camera moves (but if it's what you want, go for it!)
         */ this.disableOnCameraMove = true;
        this._isEnabled = true;
        this._isDirty = false;
        this._camerasToBeAttached = [];
        this._pingpong = 0;
        this._firstUpdate = true;
        this._cameras = cameras || scene.cameras;
        this._cameras = this._cameras.slice();
        this._camerasToBeAttached = this._cameras.slice();
        this._scene = scene;
        this._textureType = textureType;
        this._hs = new (0, $5V90k.Halton2DSequence)(this.samples);
        if (this.isSupported) {
            this._createPingPongTextures(engine.getRenderWidth(), engine.getRenderHeight());
            scene.postProcessRenderPipelineManager.addPipeline(this);
            this._buildPipeline();
        }
    }
    /**
     * Get the class name
     * @returns "TAARenderingPipeline"
     */ getClassName() {
        return "TAARenderingPipeline";
    }
    /**
     * Adds a camera to the pipeline
     * @param camera the camera to be added
     */ addCamera(camera) {
        this._camerasToBeAttached.push(camera);
        this._buildPipeline();
    }
    /**
     * Removes a camera from the pipeline
     * @param camera the camera to remove
     */ removeCamera(camera) {
        const index = this._camerasToBeAttached.indexOf(camera);
        this._camerasToBeAttached.splice(index, 1);
        this._buildPipeline();
    }
    /**
     * Removes the internal pipeline assets and detaches the pipeline from the scene cameras
     */ dispose() {
        this._disposePostProcesses();
        this._scene.postProcessRenderPipelineManager.detachCamerasFromRenderPipeline(this._name, this._cameras);
        this._ping.dispose();
        this._pong.dispose();
        super.dispose();
    }
    _createPingPongTextures(width, height) {
        const engine = this._scene.getEngine();
        this._ping?.dispose();
        this._pong?.dispose();
        this._ping = engine.createRenderTargetTexture({
            width: width,
            height: height
        }, {
            generateMipMaps: false,
            generateDepthBuffer: false,
            type: 2,
            samplingMode: 1
        });
        this._pong = engine.createRenderTargetTexture({
            width: width,
            height: height
        }, {
            generateMipMaps: false,
            generateDepthBuffer: false,
            type: 2,
            samplingMode: 1
        });
        this._hs.setDimensions(width / 2, height / 2);
        this._firstUpdate = true;
    }
    _updateEffectDefines() {
        const defines = [];
        this._taaPostProcess?.updateEffect(defines.join("\n"));
    }
    _buildPipeline() {
        if (!this.isSupported) return;
        if (!this._isEnabled) {
            this._isDirty = true;
            return;
        }
        this._isDirty = false;
        const engine = this._scene.getEngine();
        this._disposePostProcesses();
        if (this._cameras !== null) {
            this._scene.postProcessRenderPipelineManager.detachCamerasFromRenderPipeline(this._name, this._cameras);
            // get back cameras to be used to reattach pipeline
            this._cameras = this._camerasToBeAttached.slice();
        }
        this._reset();
        this._createTAAPostProcess();
        this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(engine, this.TAARenderEffect, ()=>{
            return this._taaPostProcess;
        }, true));
        this._createPassPostProcess();
        this.addEffect(new (0, $81KKS.PostProcessRenderEffect)(engine, this.TAAPassEffect, ()=>{
            return this._passPostProcess;
        }, true));
        if (this._cameras !== null) this._scene.postProcessRenderPipelineManager.attachCamerasToRenderPipeline(this._name, this._cameras);
    }
    _disposePostProcesses() {
        for(let i = 0; i < this._cameras.length; i++){
            const camera = this._cameras[i];
            this._taaPostProcess?.dispose(camera);
            this._passPostProcess?.dispose(camera);
            camera.getProjectionMatrix(true); // recompute the projection matrix
        }
        this._taaPostProcess = null;
        this._passPostProcess = null;
    }
    _createTAAPostProcess() {
        this._taaPostProcess = new (0, $cFdBb.PostProcess)("TAA", "taa", {
            uniforms: [
                "factor"
            ],
            samplers: [
                "historySampler"
            ],
            size: 1.0,
            engine: this._scene.getEngine(),
            textureType: this._textureType
        });
        this._taaPostProcess.samples = this._msaaSamples;
        this._updateEffectDefines();
        this._taaPostProcess.onActivateObservable.add(()=>{
            const camera = this._scene.activeCamera;
            if (this._taaPostProcess?.width !== this._ping.width || this._taaPostProcess?.height !== this._ping.height) {
                const engine = this._scene.getEngine();
                this._createPingPongTextures(engine.getRenderWidth(), engine.getRenderHeight());
            }
            if (camera && !camera.hasMoved) {
                if (camera.mode === (0, $74SKQ.Camera).PERSPECTIVE_CAMERA) {
                    const projMat = camera.getProjectionMatrix();
                    projMat.setRowFromFloats(2, this._hs.x, this._hs.y, projMat.m[10], projMat.m[11]);
                } else {
                    // We must force the update of the projection matrix so that m[12] and m[13] are recomputed, as we modified them the previous frame
                    const projMat = camera.getProjectionMatrix(true);
                    projMat.setRowFromFloats(3, this._hs.x + projMat.m[12], this._hs.y + projMat.m[13], projMat.m[14], projMat.m[15]);
                }
            }
            if (this._passPostProcess) this._passPostProcess.inputTexture = this._pingpong ? this._ping : this._pong;
            this._pingpong = this._pingpong ^ 1;
            this._hs.next();
        });
        this._taaPostProcess.onApplyObservable.add((effect)=>{
            const camera = this._scene.activeCamera;
            effect._bindTexture("historySampler", this._pingpong ? this._ping.texture : this._pong.texture);
            effect.setFloat("factor", camera?.hasMoved && this.disableOnCameraMove || this._firstUpdate ? 1 : this.factor);
            this._firstUpdate = false;
        });
    }
    _createPassPostProcess() {
        const engine = this._scene.getEngine();
        this._passPostProcess = new (0, $c7c1r.PassPostProcess)("TAAPass", 1, null, 1, engine);
        this._passPostProcess.inputTexture = this._ping;
        this._passPostProcess.autoClear = false;
    }
    /**
     * Serializes the rendering pipeline (Used when exporting)
     * @returns the serialized object
     */ serialize() {
        const serializationObject = (0, $6Ho1L.SerializationHelper).Serialize(this);
        serializationObject.customType = "TAARenderingPipeline";
        return serializationObject;
    }
    /**
     * Parse the serialized pipeline
     * @param source Source pipeline.
     * @param scene The scene to load the pipeline to.
     * @param rootUrl The URL of the serialized pipeline.
     * @returns An instantiated pipeline from the serialized object.
     */ static Parse(source, scene, rootUrl) {
        return (0, $6Ho1L.SerializationHelper).Parse(()=>new $d30bbf76f8b7e8db$export$672678794626a899(source._name, scene, source._ratio), source, scene, rootUrl);
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("samples")
], $d30bbf76f8b7e8db$export$672678794626a899.prototype, "_samples", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("msaaSamples")
], $d30bbf76f8b7e8db$export$672678794626a899.prototype, "_msaaSamples", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $d30bbf76f8b7e8db$export$672678794626a899.prototype, "factor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $d30bbf76f8b7e8db$export$672678794626a899.prototype, "disableOnCameraMove", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)("isEnabled")
], $d30bbf76f8b7e8db$export$672678794626a899.prototype, "_isEnabled", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.TAARenderingPipeline", $d30bbf76f8b7e8db$export$672678794626a899);

});
parcelRegister("iNCNf", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $dafae52674d65e33$var$name = "taaPixelShader";
const $dafae52674d65e33$var$shader = `varying vec2 vUV;uniform sampler2D textureSampler;uniform sampler2D historySampler;uniform float factor;void main() {vec4 c=texelFetch(textureSampler,ivec2(gl_FragCoord.xy),0);vec4 h=texelFetch(historySampler,ivec2(gl_FragCoord.xy),0);gl_FragColor=mix(h,c,factor);}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$dafae52674d65e33$var$name] = $dafae52674d65e33$var$shader;
const $dafae52674d65e33$export$f5349ccef7f6e388 = {
    name: $dafae52674d65e33$var$name,
    shader: $dafae52674d65e33$var$shader
};

});




parcelRegister("jsEsC", function(module, exports) {

$parcel$export(module.exports, "TonemappingOperator", () => $e2b004804562f3b1$export$6c2a7edd77aeb791);
$parcel$export(module.exports, "TonemapPostProcess", () => $e2b004804562f3b1$export$c877b87c6f366ca4);

var $cFdBb = parcelRequire("cFdBb");
parcelRequire("cbqfO");
var $e2b004804562f3b1$export$6c2a7edd77aeb791;
(function(TonemappingOperator) {
    /** Hable */ TonemappingOperator[TonemappingOperator["Hable"] = 0] = "Hable";
    /** Reinhard */ TonemappingOperator[TonemappingOperator["Reinhard"] = 1] = "Reinhard";
    /** HejiDawson */ TonemappingOperator[TonemappingOperator["HejiDawson"] = 2] = "HejiDawson";
    /** Photographic */ TonemappingOperator[TonemappingOperator["Photographic"] = 3] = "Photographic";
})($e2b004804562f3b1$export$6c2a7edd77aeb791 || ($e2b004804562f3b1$export$6c2a7edd77aeb791 = {}));
class $e2b004804562f3b1$export$c877b87c6f366ca4 extends (0, $cFdBb.PostProcess) {
    /**
     * Gets a string identifying the name of the class
     * @returns "TonemapPostProcess" string
     */ getClassName() {
        return "TonemapPostProcess";
    }
    /**
     * Creates a new TonemapPostProcess
     * @param name defines the name of the postprocess
     * @param _operator defines the operator to use
     * @param exposureAdjustment defines the required exposure adjustment
     * @param camera defines the camera to use (can be null)
     * @param samplingMode defines the required sampling mode (BABYLON.Texture.BILINEAR_SAMPLINGMODE by default)
     * @param engine defines the hosting engine (can be ignore if camera is set)
     * @param textureFormat defines the texture format to use (BABYLON.Engine.TEXTURETYPE_UNSIGNED_INT by default)
     * @param reusable If the post process can be reused on the same frame. (default: false)
     */ constructor(name, _operator, /** Defines the required exposure adjustment */ exposureAdjustment, camera, samplingMode = 2, engine, textureFormat = 0, reusable){
        super(name, "tonemap", [
            "_ExposureAdjustment"
        ], null, 1.0, camera, samplingMode, engine, reusable, null, textureFormat);
        this._operator = _operator;
        this.exposureAdjustment = exposureAdjustment;
        let defines = "#define ";
        if (this._operator === $e2b004804562f3b1$export$6c2a7edd77aeb791.Hable) defines += "HABLE_TONEMAPPING";
        else if (this._operator === $e2b004804562f3b1$export$6c2a7edd77aeb791.Reinhard) defines += "REINHARD_TONEMAPPING";
        else if (this._operator === $e2b004804562f3b1$export$6c2a7edd77aeb791.HejiDawson) defines += "OPTIMIZED_HEJIDAWSON_TONEMAPPING";
        else if (this._operator === $e2b004804562f3b1$export$6c2a7edd77aeb791.Photographic) defines += "PHOTOGRAPHIC_TONEMAPPING";
        //sadly a second call to create the effect.
        this.updateEffect(defines);
        this.onApply = (effect)=>{
            effect.setFloat("_ExposureAdjustment", this.exposureAdjustment);
        };
    }
}

});
parcelRegister("cbqfO", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $8deae099a93e16b2$var$name = "tonemapPixelShader";
const $8deae099a93e16b2$var$shader = `varying vec2 vUV;uniform sampler2D textureSampler;uniform float _ExposureAdjustment;
#if defined(HABLE_TONEMAPPING)
const float A=0.15;const float B=0.50;const float C=0.10;const float D=0.20;const float E=0.02;const float F=0.30;const float W=11.2;
#endif
float Luminance(vec3 c)
{return dot(c,vec3(0.22,0.707,0.071));}
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) 
{vec3 colour=texture2D(textureSampler,vUV).rgb;
#if defined(REINHARD_TONEMAPPING)
float lum=Luminance(colour.rgb); 
float lumTm=lum*_ExposureAdjustment;float scale=lumTm/(1.0+lumTm); 
colour*=scale/lum;
#elif defined(HABLE_TONEMAPPING)
colour*=_ExposureAdjustment;const float ExposureBias=2.0;vec3 x=ExposureBias*colour;vec3 curr=((x*(A*x+C*B)+D*E)/(x*(A*x+B)+D*F))-E/F;x=vec3(W,W,W);vec3 whiteScale=1.0/(((x*(A*x+C*B)+D*E)/(x*(A*x+B)+D*F))-E/F);colour=curr*whiteScale;
#elif defined(OPTIMIZED_HEJIDAWSON_TONEMAPPING)
colour*=_ExposureAdjustment;vec3 X=max(vec3(0.0,0.0,0.0),colour-0.004);vec3 retColor=(X*(6.2*X+0.5))/(X*(6.2*X+1.7)+0.06);colour=retColor*retColor;
#elif defined(PHOTOGRAPHIC_TONEMAPPING)
colour= vec3(1.0,1.0,1.0)-exp2(-_ExposureAdjustment*colour);
#endif
gl_FragColor=vec4(colour.rgb,1.0);}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$8deae099a93e16b2$var$name] = $8deae099a93e16b2$var$shader;
const $8deae099a93e16b2$export$24459e2c8548b14 = {
    name: $8deae099a93e16b2$var$name,
    shader: $8deae099a93e16b2$var$shader
};

});


parcelRegister("g7AEA", function(module, exports) {

$parcel$export(module.exports, "VolumetricLightScatteringPostProcess", () => $bbc9bb7482a9bdea$export$21f42070ce8f3be4);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $kVtWi = parcelRequire("kVtWi");

var $ha1VO = parcelRequire("ha1VO");

var $b4i1f = parcelRequire("b4i1f");

var $0cHNL = parcelRequire("0cHNL");

var $54229 = parcelRequire("54229");

var $gAH3H = parcelRequire("gAH3H");

var $j2mX5 = parcelRequire("j2mX5");

var $gQtNK = parcelRequire("gQtNK");

var $cFdBb = parcelRequire("cFdBb");

var $kt6s5 = parcelRequire("kt6s5");
parcelRequire("dKvV4");
parcelRequire("lIOar");
parcelRequire("iTNwZ");
parcelRequire("3czK0");

var $7etnY = parcelRequire("7etnY");

var $191mA = parcelRequire("191mA");

var $8DoUR = parcelRequire("8DoUR");

var $alPCh = parcelRequire("alPCh");
class $bbc9bb7482a9bdea$export$21f42070ce8f3be4 extends (0, $cFdBb.PostProcess) {
    /**
     * @internal
     * VolumetricLightScatteringPostProcess.useDiffuseColor is no longer used, use the mesh material directly instead
     */ get useDiffuseColor() {
        (0, $kVtWi.Logger).Warn("VolumetricLightScatteringPostProcess.useDiffuseColor is no longer used, use the mesh material directly instead");
        return false;
    }
    set useDiffuseColor(useDiffuseColor) {
        (0, $kVtWi.Logger).Warn("VolumetricLightScatteringPostProcess.useDiffuseColor is no longer used, use the mesh material directly instead");
    }
    /**
     * @constructor
     * @param name The post-process name
     * @param ratio The size of the post-process and/or internal pass (0.5 means that your postprocess will have a width = canvas.width 0.5 and a height = canvas.height 0.5)
     * @param camera The camera that the post-process will be attached to
     * @param mesh The mesh used to create the light scattering
     * @param samples The post-process quality, default 100
     * @param samplingMode The post-process filtering mode
     * @param engine The babylon engine
     * @param reusable If the post-process is reusable
     * @param scene The constructor needs a scene reference to initialize internal components. If "camera" is null a "scene" must be provided
     */ constructor(name, ratio, camera, mesh, samples = 100, samplingMode = (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, engine, reusable, scene){
        super(name, "volumetricLightScattering", [
            "decay",
            "exposure",
            "weight",
            "meshPositionOnScreen",
            "density"
        ], [
            "lightScatteringSampler"
        ], ratio.postProcessRatio || ratio, camera, samplingMode, engine, reusable, "#define NUM_SAMPLES " + samples);
        this._screenCoordinates = (0, $ha1VO.Vector2).Zero();
        /**
         * Custom position of the mesh. Used if "useCustomMeshPosition" is set to "true"
         */ this.customMeshPosition = (0, $ha1VO.Vector3).Zero();
        /**
         * Set if the post-process should use a custom position for the light source (true) or the internal mesh position (false)
         */ this.useCustomMeshPosition = false;
        /**
         * If the post-process should inverse the light scattering direction
         */ this.invert = true;
        /**
         * Array containing the excluded meshes not rendered in the internal pass
         */ this.excludedMeshes = [];
        /**
         * Array containing the only meshes rendered in the internal pass.
         * If this array is not empty, only the meshes from this array are rendered in the internal pass
         */ this.includedMeshes = [];
        /**
         * Controls the overall intensity of the post-process
         */ this.exposure = 0.3;
        /**
         * Dissipates each sample's contribution in range [0, 1]
         */ this.decay = 0.96815;
        /**
         * Controls the overall intensity of each sample
         */ this.weight = 0.58767;
        /**
         * Controls the density of each sample
         */ this.density = 0.926;
        scene = camera?.getScene() ?? scene ?? this._scene; // parameter "scene" can be null.
        engine = scene.getEngine();
        this._viewPort = new (0, $191mA.Viewport)(0, 0, 1, 1).toGlobal(engine.getRenderWidth(), engine.getRenderHeight());
        // Configure mesh
        this.mesh = mesh ?? $bbc9bb7482a9bdea$export$21f42070ce8f3be4.CreateDefaultMesh("VolumetricLightScatteringMesh", scene);
        // Configure
        this._createPass(scene, ratio.passRatio || ratio);
        this.onActivate = (camera)=>{
            if (!this.isSupported) this.dispose(camera);
            this.onActivate = null;
        };
        this.onApplyObservable.add((effect)=>{
            this._updateMeshScreenCoordinates(scene);
            effect.setTexture("lightScatteringSampler", this._volumetricLightScatteringRTT);
            effect.setFloat("exposure", this.exposure);
            effect.setFloat("decay", this.decay);
            effect.setFloat("weight", this.weight);
            effect.setFloat("density", this.density);
            effect.setVector2("meshPositionOnScreen", this._screenCoordinates);
        });
    }
    /**
     * Returns the string "VolumetricLightScatteringPostProcess"
     * @returns "VolumetricLightScatteringPostProcess"
     */ getClassName() {
        return "VolumetricLightScatteringPostProcess";
    }
    _isReady(subMesh, useInstances) {
        const mesh = subMesh.getMesh();
        // Render this.mesh as default
        if (mesh === this.mesh && mesh.material) return mesh.material.isReady(mesh);
        const renderingMaterial = mesh._internalAbstractMeshDataInfo._materialForRenderPass?.[this._scene.getEngine().currentRenderPassId];
        if (renderingMaterial) return renderingMaterial.isReadyForSubMesh(mesh, subMesh, useInstances);
        const defines = [];
        const attribs = [
            (0, $b4i1f.VertexBuffer).PositionKind
        ];
        const material = subMesh.getMaterial();
        // Alpha test
        if (material) {
            if (material.needAlphaTesting()) defines.push("#define ALPHATEST");
            if (mesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UVKind)) {
                attribs.push((0, $b4i1f.VertexBuffer).UVKind);
                defines.push("#define UV1");
            }
            if (mesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UV2Kind)) {
                attribs.push((0, $b4i1f.VertexBuffer).UV2Kind);
                defines.push("#define UV2");
            }
        }
        // Bones
        if (mesh.useBones && mesh.computeBonesUsingShaders) {
            attribs.push((0, $b4i1f.VertexBuffer).MatricesIndicesKind);
            attribs.push((0, $b4i1f.VertexBuffer).MatricesWeightsKind);
            defines.push("#define NUM_BONE_INFLUENCERS " + mesh.numBoneInfluencers);
            defines.push("#define BonesPerMesh " + (mesh.skeleton ? mesh.skeleton.bones.length + 1 : 0));
        } else defines.push("#define NUM_BONE_INFLUENCERS 0");
        // Instances
        if (useInstances) {
            defines.push("#define INSTANCES");
            (0, $alPCh.PushAttributesForInstances)(attribs);
            if (subMesh.getRenderingMesh().hasThinInstances) defines.push("#define THIN_INSTANCES");
        }
        // Get correct effect
        const drawWrapper = subMesh._getDrawWrapper(undefined, true);
        const cachedDefines = drawWrapper.defines;
        const join = defines.join("\n");
        if (cachedDefines !== join) drawWrapper.setEffect(mesh.getScene().getEngine().createEffect("volumetricLightScatteringPass", attribs, [
            "world",
            "mBones",
            "viewProjection",
            "diffuseMatrix"
        ], [
            "diffuseSampler"
        ], join, undefined, undefined, undefined, {
            maxSimultaneousMorphTargets: mesh.numBoneInfluencers
        }), join);
        return drawWrapper.effect.isReady();
    }
    /**
     * Sets the new light position for light scattering effect
     * @param position The new custom light position
     */ setCustomMeshPosition(position) {
        this.customMeshPosition = position;
    }
    /**
     * Returns the light position for light scattering effect
     * @returns Vector3 The custom light position
     */ getCustomMeshPosition() {
        return this.customMeshPosition;
    }
    /**
     * Disposes the internal assets and detaches the post-process from the camera
     * @param camera The camera from which to detach the post-process
     */ dispose(camera) {
        const rttIndex = camera.getScene().customRenderTargets.indexOf(this._volumetricLightScatteringRTT);
        if (rttIndex !== -1) camera.getScene().customRenderTargets.splice(rttIndex, 1);
        this._volumetricLightScatteringRTT.dispose();
        super.dispose(camera);
    }
    /**
     * Returns the render target texture used by the post-process
     * @returns the render target texture used by the post-process
     */ getPass() {
        return this._volumetricLightScatteringRTT;
    }
    // Private methods
    _meshExcluded(mesh) {
        if (this.includedMeshes.length > 0 && this.includedMeshes.indexOf(mesh) === -1 || this.excludedMeshes.length > 0 && this.excludedMeshes.indexOf(mesh) !== -1) return true;
        return false;
    }
    _createPass(scene, ratio) {
        const engine = scene.getEngine();
        this._volumetricLightScatteringRTT = new (0, $gQtNK.RenderTargetTexture)("volumetricLightScatteringMap", {
            width: engine.getRenderWidth() * ratio,
            height: engine.getRenderHeight() * ratio
        }, scene, false, true, 0);
        this._volumetricLightScatteringRTT.wrapU = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        this._volumetricLightScatteringRTT.wrapV = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        this._volumetricLightScatteringRTT.renderList = null;
        this._volumetricLightScatteringRTT.renderParticles = false;
        this._volumetricLightScatteringRTT.ignoreCameraViewport = true;
        const camera = this.getCamera();
        if (camera) camera.customRenderTargets.push(this._volumetricLightScatteringRTT);
        else scene.customRenderTargets.push(this._volumetricLightScatteringRTT);
        // Custom render function for submeshes
        const renderSubMesh = (subMesh)=>{
            const renderingMesh = subMesh.getRenderingMesh();
            const effectiveMesh = subMesh.getEffectiveMesh();
            if (this._meshExcluded(renderingMesh)) return;
            effectiveMesh._internalAbstractMeshDataInfo._isActiveIntermediate = false;
            const material = subMesh.getMaterial();
            if (!material) return;
            const scene = renderingMesh.getScene();
            const engine = scene.getEngine();
            // Culling
            engine.setState(material.backFaceCulling, undefined, undefined, undefined, material.cullBackFaces);
            // Managing instances
            const batch = renderingMesh._getInstancesRenderList(subMesh._id, !!subMesh.getReplacementMesh());
            if (batch.mustReturn) return;
            const hardwareInstancedRendering = engine.getCaps().instancedArrays && (batch.visibleInstances[subMesh._id] !== null || renderingMesh.hasThinInstances);
            if (this._isReady(subMesh, hardwareInstancedRendering)) {
                const renderingMaterial = effectiveMesh._internalAbstractMeshDataInfo._materialForRenderPass?.[engine.currentRenderPassId];
                let drawWrapper = subMesh._getDrawWrapper();
                if (renderingMesh === this.mesh && !drawWrapper) drawWrapper = material._getDrawWrapper();
                if (!drawWrapper) return;
                const effect = drawWrapper.effect;
                engine.enableEffect(drawWrapper);
                if (!hardwareInstancedRendering) renderingMesh._bind(subMesh, effect, material.fillMode);
                if (renderingMesh === this.mesh) material.bind(effectiveMesh.getWorldMatrix(), renderingMesh);
                else if (renderingMaterial) renderingMaterial.bindForSubMesh(effectiveMesh.getWorldMatrix(), effectiveMesh, subMesh);
                else {
                    effect.setMatrix("viewProjection", scene.getTransformMatrix());
                    // Alpha test
                    if (material && material.needAlphaTesting()) {
                        const alphaTexture = material.getAlphaTestTexture();
                        effect.setTexture("diffuseSampler", alphaTexture);
                        if (alphaTexture) effect.setMatrix("diffuseMatrix", alphaTexture.getTextureMatrix());
                    }
                    // Bones
                    if (renderingMesh.useBones && renderingMesh.computeBonesUsingShaders && renderingMesh.skeleton) effect.setMatrices("mBones", renderingMesh.skeleton.getTransformMatrices(renderingMesh));
                }
                if (hardwareInstancedRendering && renderingMesh.hasThinInstances) effect.setMatrix("world", effectiveMesh.getWorldMatrix());
                // Draw
                renderingMesh._processRendering(effectiveMesh, subMesh, effect, (0, $54229.Material).TriangleFillMode, batch, hardwareInstancedRendering, (isInstance, world)=>{
                    if (!isInstance) effect.setMatrix("world", world);
                });
            }
        };
        // Render target texture callbacks
        let savedSceneClearColor;
        const sceneClearColor = new (0, $7etnY.Color4)(0.0, 0.0, 0.0, 1.0);
        this._volumetricLightScatteringRTT.onBeforeRenderObservable.add(()=>{
            savedSceneClearColor = scene.clearColor;
            scene.clearColor = sceneClearColor;
        });
        this._volumetricLightScatteringRTT.onAfterRenderObservable.add(()=>{
            scene.clearColor = savedSceneClearColor;
        });
        this._volumetricLightScatteringRTT.customIsReadyFunction = (mesh, refreshRate, preWarm)=>{
            if ((preWarm || refreshRate === 0) && mesh.subMeshes) for(let i = 0; i < mesh.subMeshes.length; ++i){
                const subMesh = mesh.subMeshes[i];
                const material = subMesh.getMaterial();
                const renderingMesh = subMesh.getRenderingMesh();
                if (!material) continue;
                const batch = renderingMesh._getInstancesRenderList(subMesh._id, !!subMesh.getReplacementMesh());
                const hardwareInstancedRendering = engine.getCaps().instancedArrays && (batch.visibleInstances[subMesh._id] !== null || renderingMesh.hasThinInstances);
                if (!this._isReady(subMesh, hardwareInstancedRendering)) return false;
            }
            return true;
        };
        this._volumetricLightScatteringRTT.customRenderFunction = (opaqueSubMeshes, alphaTestSubMeshes, transparentSubMeshes, depthOnlySubMeshes)=>{
            const engine = scene.getEngine();
            let index;
            if (depthOnlySubMeshes.length) {
                engine.setColorWrite(false);
                for(index = 0; index < depthOnlySubMeshes.length; index++)renderSubMesh(depthOnlySubMeshes.data[index]);
                engine.setColorWrite(true);
            }
            for(index = 0; index < opaqueSubMeshes.length; index++)renderSubMesh(opaqueSubMeshes.data[index]);
            for(index = 0; index < alphaTestSubMeshes.length; index++)renderSubMesh(alphaTestSubMeshes.data[index]);
            if (transparentSubMeshes.length) {
                // Sort sub meshes
                for(index = 0; index < transparentSubMeshes.length; index++){
                    const submesh = transparentSubMeshes.data[index];
                    const boundingInfo = submesh.getBoundingInfo();
                    if (boundingInfo && scene.activeCamera) {
                        submesh._alphaIndex = submesh.getMesh().alphaIndex;
                        submesh._distanceToCamera = boundingInfo.boundingSphere.centerWorld.subtract(scene.activeCamera.position).length();
                    }
                }
                const sortedArray = transparentSubMeshes.data.slice(0, transparentSubMeshes.length);
                sortedArray.sort((a, b)=>{
                    // Alpha index first
                    if (a._alphaIndex > b._alphaIndex) return 1;
                    if (a._alphaIndex < b._alphaIndex) return -1;
                    // Then distance to camera
                    if (a._distanceToCamera < b._distanceToCamera) return 1;
                    if (a._distanceToCamera > b._distanceToCamera) return -1;
                    return 0;
                });
                // Render sub meshes
                engine.setAlphaMode(2);
                for(index = 0; index < sortedArray.length; index++)renderSubMesh(sortedArray[index]);
                engine.setAlphaMode(0);
            }
        };
    }
    _updateMeshScreenCoordinates(scene) {
        const transform = scene.getTransformMatrix();
        let meshPosition;
        if (this.useCustomMeshPosition) meshPosition = this.customMeshPosition;
        else if (this.attachedNode) meshPosition = this.attachedNode.position;
        else meshPosition = this.mesh.parent ? this.mesh.getAbsolutePosition() : this.mesh.position;
        const pos = (0, $ha1VO.Vector3).Project(meshPosition, (0, $ha1VO.Matrix).Identity(), transform, this._viewPort);
        this._screenCoordinates.x = pos.x / this._viewPort.width;
        this._screenCoordinates.y = pos.y / this._viewPort.height;
        if (this.invert) this._screenCoordinates.y = 1.0 - this._screenCoordinates.y;
    }
    // Static methods
    /**
     * Creates a default mesh for the Volumeric Light Scattering post-process
     * @param name The mesh name
     * @param scene The scene where to create the mesh
     * @returns the default mesh
     */ static CreateDefaultMesh(name, scene) {
        const mesh = (0, $kt6s5.CreatePlane)(name, {
            size: 1
        }, scene);
        mesh.billboardMode = (0, $0cHNL.AbstractMesh).BILLBOARDMODE_ALL;
        const material = new (0, $gAH3H.StandardMaterial)(name + "Material", scene);
        material.emissiveColor = new (0, $7etnY.Color3)(1, 1, 1);
        mesh.material = material;
        return mesh;
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsVector3)()
], $bbc9bb7482a9bdea$export$21f42070ce8f3be4.prototype, "customMeshPosition", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $bbc9bb7482a9bdea$export$21f42070ce8f3be4.prototype, "useCustomMeshPosition", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $bbc9bb7482a9bdea$export$21f42070ce8f3be4.prototype, "invert", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serializeAsMeshReference)()
], $bbc9bb7482a9bdea$export$21f42070ce8f3be4.prototype, "mesh", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $bbc9bb7482a9bdea$export$21f42070ce8f3be4.prototype, "excludedMeshes", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $bbc9bb7482a9bdea$export$21f42070ce8f3be4.prototype, "includedMeshes", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $bbc9bb7482a9bdea$export$21f42070ce8f3be4.prototype, "exposure", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $bbc9bb7482a9bdea$export$21f42070ce8f3be4.prototype, "decay", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $bbc9bb7482a9bdea$export$21f42070ce8f3be4.prototype, "weight", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $bbc9bb7482a9bdea$export$21f42070ce8f3be4.prototype, "density", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.VolumetricLightScatteringPostProcess", $bbc9bb7482a9bdea$export$21f42070ce8f3be4);

});
parcelRegister("lIOar", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $fd049f38ec5bcc60$var$name = "volumetricLightScatteringPixelShader";
const $fd049f38ec5bcc60$var$shader = `uniform sampler2D textureSampler;uniform sampler2D lightScatteringSampler;uniform float decay;uniform float exposure;uniform float weight;uniform float density;uniform vec2 meshPositionOnScreen;varying vec2 vUV;
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) {
#define CUSTOM_FRAGMENT_MAIN_BEGIN
vec2 tc=vUV;vec2 deltaTexCoord=(tc-meshPositionOnScreen.xy);deltaTexCoord*=1.0/float(NUM_SAMPLES)*density;float illuminationDecay=1.0;vec4 color=texture2D(lightScatteringSampler,tc)*0.4;for(int i=0; i<NUM_SAMPLES; i++) {tc-=deltaTexCoord;vec4 dataSample=texture2D(lightScatteringSampler,tc)*0.4;dataSample*=illuminationDecay*weight;color+=dataSample;illuminationDecay*=decay;}
vec4 realColor=texture2D(textureSampler,vUV);gl_FragColor=((vec4((vec3(color.r,color.g,color.b)*exposure),1))+(realColor*(1.5-0.4)));
#define CUSTOM_FRAGMENT_MAIN_END
}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$fd049f38ec5bcc60$var$name] = $fd049f38ec5bcc60$var$shader;
const $fd049f38ec5bcc60$export$79d15bb290389a71 = {
    name: $fd049f38ec5bcc60$var$name,
    shader: $fd049f38ec5bcc60$var$shader
};

});

parcelRegister("iTNwZ", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("7PW7m");
parcelRequire("8kYMw");
parcelRequire("5Eb4I");
parcelRequire("9H5jp");
parcelRequire("k3wwH");
parcelRequire("9ulLS");
parcelRequire("LFrAO");
parcelRequire("apKdp");
parcelRequire("4idCt");
parcelRequire("cIweX");
const $dc23c8e1613633f2$var$name = "volumetricLightScatteringPassVertexShader";
const $dc23c8e1613633f2$var$shader = `attribute vec3 position;
#include<bonesDeclaration>
#include<bakedVertexAnimationDeclaration>
#include<morphTargetsVertexGlobalDeclaration>
#include<morphTargetsVertexDeclaration>[0..maxSimultaneousMorphTargets]
#include<instancesDeclaration>
uniform mat4 viewProjection;uniform vec2 depthValues;
#if defined(ALPHATEST) || defined(NEED_UV)
varying vec2 vUV;uniform mat4 diffuseMatrix;
#ifdef UV1
attribute vec2 uv;
#endif
#ifdef UV2
attribute vec2 uv2;
#endif
#endif
#define CUSTOM_VERTEX_DEFINITIONS
void main(void)
{vec3 positionUpdated=position;
#if (defined(ALPHATEST) || defined(NEED_UV)) && defined(UV1)
vec2 uvUpdated=uv;
#endif
#include<morphTargetsVertexGlobal>
#include<morphTargetsVertex>[0..maxSimultaneousMorphTargets]
#include<instancesVertex>
#include<bonesVertex>
#include<bakedVertexAnimation>
gl_Position=viewProjection*finalWorld*vec4(positionUpdated,1.0);
#if defined(ALPHATEST) || defined(BASIC_RENDER)
#ifdef UV1
vUV=vec2(diffuseMatrix*vec4(uvUpdated,1.0,0.0));
#endif
#ifdef UV2
vUV=vec2(diffuseMatrix*vec4(uv2,1.0,0.0));
#endif
#endif
}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$dc23c8e1613633f2$var$name] = $dc23c8e1613633f2$var$shader;
const $dc23c8e1613633f2$export$46550e69a17dfdc2 = {
    name: $dc23c8e1613633f2$var$name,
    shader: $dc23c8e1613633f2$var$shader
};

});

parcelRegister("3czK0", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $254e378810677654$var$name = "volumetricLightScatteringPassPixelShader";
const $254e378810677654$var$shader = `#if defined(ALPHATEST) || defined(NEED_UV)
varying vec2 vUV;
#endif
#if defined(ALPHATEST)
uniform sampler2D diffuseSampler;
#endif
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void)
{
#if defined(ALPHATEST)
vec4 diffuseColor=texture2D(diffuseSampler,vUV);if (diffuseColor.a<0.4)
discard;
#endif
gl_FragColor=vec4(0.0,0.0,0.0,1.0);}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$254e378810677654$var$name] = $254e378810677654$var$shader;
const $254e378810677654$export$afdab84d7f2fd15 = {
    name: $254e378810677654$var$name,
    shader: $254e378810677654$var$shader
};

});


parcelRegister("ivLSK", function(module, exports) {

$parcel$export(module.exports, "ScreenSpaceCurvaturePostProcess", () => $d7a0439b9be17536$export$db0cd5ce3e94dc30);

var $e0Suo = parcelRequire("e0Suo");

var $kVtWi = parcelRequire("kVtWi");

var $cFdBb = parcelRequire("cFdBb");
parcelRequire("cSqxf");
parcelRequire("b6pZc");

var $ejQPp = parcelRequire("ejQPp");

var $8DoUR = parcelRequire("8DoUR");

var $ir0rz = parcelRequire("ir0rz");

var $6Ho1L = parcelRequire("6Ho1L");
class $d7a0439b9be17536$export$db0cd5ce3e94dc30 extends (0, $cFdBb.PostProcess) {
    /**
     * Gets a string identifying the name of the class
     * @returns "ScreenSpaceCurvaturePostProcess" string
     */ getClassName() {
        return "ScreenSpaceCurvaturePostProcess";
    }
    /**
     * Creates a new instance ScreenSpaceCurvaturePostProcess
     * @param name The name of the effect.
     * @param scene The scene containing the objects to blur according to their velocity.
     * @param options The required width/height ratio to downsize to before computing the render pass.
     * @param camera The camera to apply the render pass to.
     * @param samplingMode The sampling mode to be used when computing the pass. (default: 0)
     * @param engine The engine which the post process will be applied. (default: current engine)
     * @param reusable If the post process can be reused on the same frame. (default: false)
     * @param textureType Type of textures used when performing the post process. (default: 0)
     * @param blockCompilation If compilation of the shader should not be done in the constructor. The updateEffect method can be used to compile the shader at a later time. (default: false)
     */ constructor(name, scene, options, camera, samplingMode, engine, reusable, textureType = 0, blockCompilation = false){
        super(name, "screenSpaceCurvature", [
            "curvature_ridge",
            "curvature_valley"
        ], [
            "textureSampler",
            "normalSampler"
        ], options, camera, samplingMode, engine, reusable, undefined, textureType, undefined, null, blockCompilation);
        /**
         * Defines how much ridge the curvature effect displays.
         */ this.ridge = 1;
        /**
         * Defines how much valley the curvature effect displays.
         */ this.valley = 1;
        this._geometryBufferRenderer = scene.enableGeometryBufferRenderer();
        if (!this._geometryBufferRenderer) // Geometry buffer renderer is not supported. So, work as a passthrough.
        (0, $kVtWi.Logger).Error("Multiple Render Target support needed for screen space curvature post process. Please use IsSupported test first.");
        else {
            if (this._geometryBufferRenderer.generateNormalsInWorldSpace) (0, $kVtWi.Logger).Error("ScreenSpaceCurvaturePostProcess does not support generateNormalsInWorldSpace=true for the geometry buffer renderer!");
            // Geometry buffer renderer is supported.
            this.onApply = (effect)=>{
                effect.setFloat("curvature_ridge", 0.5 / Math.max(this.ridge * this.ridge, 1e-4));
                effect.setFloat("curvature_valley", 0.7 / Math.max(this.valley * this.valley, 1e-4));
                const normalTexture = this._geometryBufferRenderer.getGBuffer().textures[1];
                effect.setTexture("normalSampler", normalTexture);
            };
        }
    }
    /**
     * Support test.
     */ static get IsSupported() {
        const engine = (0, $ejQPp.EngineStore).LastCreatedEngine;
        if (!engine) return false;
        return engine.getCaps().drawBuffersExtension;
    }
    /**
     * @internal
     */ static _Parse(parsedPostProcess, targetCamera, scene, rootUrl) {
        return (0, $6Ho1L.SerializationHelper).Parse(()=>{
            return new $d7a0439b9be17536$export$db0cd5ce3e94dc30(parsedPostProcess.name, scene, parsedPostProcess.options, targetCamera, parsedPostProcess.renderTargetSamplingMode, scene.getEngine(), parsedPostProcess.textureType, parsedPostProcess.reusable);
        }, parsedPostProcess, scene, rootUrl);
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $d7a0439b9be17536$export$db0cd5ce3e94dc30.prototype, "ridge", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $d7a0439b9be17536$export$db0cd5ce3e94dc30.prototype, "valley", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.ScreenSpaceCurvaturePostProcess", $d7a0439b9be17536$export$db0cd5ce3e94dc30);

});
parcelRegister("b6pZc", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $8154698538b26b0b$var$name = "screenSpaceCurvaturePixelShader";
const $8154698538b26b0b$var$shader = `precision highp float;varying vec2 vUV;uniform sampler2D textureSampler;uniform sampler2D normalSampler;uniform float curvature_ridge;uniform float curvature_valley;
#ifndef CURVATURE_OFFSET
#define CURVATURE_OFFSET 1
#endif
float curvature_soft_clamp(float curvature,float control)
{if (curvature<0.5/control)
return curvature*(1.0-curvature*control);return 0.25/control;}
float calculate_curvature(ivec2 texel,float ridge,float valley)
{vec2 normal_up =texelFetch(normalSampler,texel+ivec2(0, CURVATURE_OFFSET),0).rb;vec2 normal_down =texelFetch(normalSampler,texel+ivec2(0,-CURVATURE_OFFSET),0).rb;vec2 normal_left =texelFetch(normalSampler,texel+ivec2(-CURVATURE_OFFSET,0),0).rb;vec2 normal_right=texelFetch(normalSampler,texel+ivec2( CURVATURE_OFFSET,0),0).rb;float normal_diff=((normal_up.g-normal_down.g)+(normal_right.r-normal_left.r));if (normal_diff<0.0)
return -2.0*curvature_soft_clamp(-normal_diff,valley);return 2.0*curvature_soft_clamp(normal_diff,ridge);}
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) 
{ivec2 texel=ivec2(gl_FragCoord.xy);vec4 baseColor=texture2D(textureSampler,vUV);float curvature=calculate_curvature(texel,curvature_ridge,curvature_valley);baseColor.rgb*=curvature+1.0;gl_FragColor=baseColor;}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$8154698538b26b0b$var$name] = $8154698538b26b0b$var$shader;
const $8154698538b26b0b$export$e4bf486bcbfb326f = {
    name: $8154698538b26b0b$var$name,
    shader: $8154698538b26b0b$var$shader
};

});



parcelRegister("7snoU", function(module, exports) {

var $lxthF = parcelRequire("lxthF");
$parcel$exportWildcard(module.exports, $lxthF);

});

parcelRegister("0G59o", function(module, exports) {
/* eslint-disable import/no-internal-modules */ 
var $4O0Ba = parcelRequire("4O0Ba");

var $UZ4tK = parcelRequire("UZ4tK");

var $5Wo6G = parcelRequire("5Wo6G");

var $b891L = parcelRequire("b891L");

var $7bELJ = parcelRequire("7bELJ");

var $kT9d6 = parcelRequire("kT9d6");

var $gXqe5 = parcelRequire("gXqe5");

var $cSqxf = parcelRequire("cSqxf");

var $fVppw = parcelRequire("fVppw");

var $46Req = parcelRequire("46Req");

var $4dCCN = parcelRequire("4dCCN");

var $1WW1V = parcelRequire("1WW1V");

var $78VIa = parcelRequire("78VIa");

var $jJNg8 = parcelRequire("jJNg8");

var $6mCYU = parcelRequire("6mCYU");

var $ikRUe = parcelRequire("ikRUe");

var $4r8o2 = parcelRequire("4r8o2");

var $ho5tT = parcelRequire("ho5tT");
$parcel$exportWildcard(module.exports, $4O0Ba);
$parcel$exportWildcard(module.exports, $UZ4tK);
$parcel$exportWildcard(module.exports, $5Wo6G);
$parcel$exportWildcard(module.exports, $b891L);
$parcel$exportWildcard(module.exports, $7bELJ);
$parcel$exportWildcard(module.exports, $kT9d6);
$parcel$exportWildcard(module.exports, $gXqe5);
$parcel$exportWildcard(module.exports, $cSqxf);
$parcel$exportWildcard(module.exports, $fVppw);
$parcel$exportWildcard(module.exports, $46Req);
$parcel$exportWildcard(module.exports, $4dCCN);
$parcel$exportWildcard(module.exports, $1WW1V);
$parcel$exportWildcard(module.exports, $78VIa);
$parcel$exportWildcard(module.exports, $jJNg8);
$parcel$exportWildcard(module.exports, $6mCYU);
$parcel$exportWildcard(module.exports, $ikRUe);
$parcel$exportWildcard(module.exports, $4r8o2);
$parcel$exportWildcard(module.exports, $ho5tT);

});
parcelRegister("4O0Ba", function(module, exports) {

$parcel$export(module.exports, "BoundingBoxRenderer", () => $37fc4bc7b55357b0$export$99a50baacfaa5937);

var $gmbCk = parcelRequire("gmbCk");

var $b4i1f = parcelRequire("b4i1f");

var $0cHNL = parcelRequire("0cHNL");

var $ha1VO = parcelRequire("ha1VO");

var $57onU = parcelRequire("57onU");

var $bv05l = parcelRequire("bv05l");

var $54229 = parcelRequire("54229");

var $4I7rl = parcelRequire("4I7rl");

var $7etnY = parcelRequire("7etnY");

var $diGQf = parcelRequire("diGQf");

var $hOyoX = parcelRequire("hOyoX");

var $ghoTi = parcelRequire("ghoTi");

var $4C7Qm = parcelRequire("4C7Qm");
parcelRequire("irCmp");
parcelRequire("lokLS");
Object.defineProperty((0, $gmbCk.Scene).prototype, "forceShowBoundingBoxes", {
    get: function() {
        return this._forceShowBoundingBoxes || false;
    },
    set: function(value) {
        this._forceShowBoundingBoxes = value;
        // Lazyly creates a BB renderer if needed.
        if (value) this.getBoundingBoxRenderer();
    },
    enumerable: true,
    configurable: true
});
(0, $gmbCk.Scene).prototype.getBoundingBoxRenderer = function() {
    if (!this._boundingBoxRenderer) this._boundingBoxRenderer = new $37fc4bc7b55357b0$export$99a50baacfaa5937(this);
    return this._boundingBoxRenderer;
};
Object.defineProperty((0, $0cHNL.AbstractMesh).prototype, "showBoundingBox", {
    get: function() {
        return this._showBoundingBox || false;
    },
    set: function(value) {
        this._showBoundingBox = value;
        // Lazyly creates a BB renderer if needed.
        if (value) this.getScene().getBoundingBoxRenderer();
    },
    enumerable: true,
    configurable: true
});
class $37fc4bc7b55357b0$export$99a50baacfaa5937 {
    /**
     * Instantiates a new bounding box renderer in a scene.
     * @param scene the scene the  renderer renders in
     */ constructor(scene){
        /**
         * The component name helpful to identify the component in the list of scene components.
         */ this.name = (0, $bv05l.SceneComponentConstants).NAME_BOUNDINGBOXRENDERER;
        /**
         * Color of the bounding box lines placed in front of an object
         */ this.frontColor = new (0, $7etnY.Color3)(1, 1, 1);
        /**
         * Color of the bounding box lines placed behind an object
         */ this.backColor = new (0, $7etnY.Color3)(0.1, 0.1, 0.1);
        /**
         * Defines if the renderer should show the back lines or not
         */ this.showBackLines = true;
        /**
         * Observable raised before rendering a bounding box
         */ this.onBeforeBoxRenderingObservable = new (0, $diGQf.Observable)();
        /**
         * Observable raised after rendering a bounding box
         */ this.onAfterBoxRenderingObservable = new (0, $diGQf.Observable)();
        /**
         * Observable raised after resources are created
         */ this.onResourcesReadyObservable = new (0, $diGQf.Observable)();
        /**
         * When false, no bounding boxes will be rendered
         */ this.enabled = true;
        /**
         * @internal
         */ this.renderList = new (0, $57onU.SmartArray)(32);
        this._vertexBuffers = {};
        this._fillIndexBuffer = null;
        this._fillIndexData = null;
        this.scene = scene;
        scene._addComponent(this);
        this._uniformBufferFront = new (0, $ghoTi.UniformBuffer)(this.scene.getEngine(), undefined, undefined, "BoundingBoxRendererFront", !this.scene.getEngine().isWebGPU);
        this._buildUniformLayout(this._uniformBufferFront);
        this._uniformBufferBack = new (0, $ghoTi.UniformBuffer)(this.scene.getEngine(), undefined, undefined, "BoundingBoxRendererBack", !this.scene.getEngine().isWebGPU);
        this._buildUniformLayout(this._uniformBufferBack);
    }
    _buildUniformLayout(ubo) {
        ubo.addUniform("color", 4);
        ubo.addUniform("world", 16);
        ubo.addUniform("viewProjection", 16);
        ubo.addUniform("viewProjectionR", 16);
        ubo.create();
    }
    /**
     * Registers the component in a given scene
     */ register() {
        this.scene._beforeEvaluateActiveMeshStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_BEFOREEVALUATEACTIVEMESH_BOUNDINGBOXRENDERER, this, this.reset);
        this.scene._preActiveMeshStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_PREACTIVEMESH_BOUNDINGBOXRENDERER, this, this._preActiveMesh);
        this.scene._evaluateSubMeshStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_EVALUATESUBMESH_BOUNDINGBOXRENDERER, this, this._evaluateSubMesh);
        this.scene._afterRenderingGroupDrawStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_AFTERRENDERINGGROUPDRAW_BOUNDINGBOXRENDERER, this, this.render);
    }
    _evaluateSubMesh(mesh, subMesh) {
        if (mesh.showSubMeshesBoundingBox) {
            const boundingInfo = subMesh.getBoundingInfo();
            if (boundingInfo !== null && boundingInfo !== undefined) {
                boundingInfo.boundingBox._tag = mesh.renderingGroupId;
                this.renderList.push(boundingInfo.boundingBox);
            }
        }
    }
    _preActiveMesh(mesh) {
        if (mesh.showBoundingBox || this.scene.forceShowBoundingBoxes) {
            const boundingInfo = mesh.getBoundingInfo();
            boundingInfo.boundingBox._tag = mesh.renderingGroupId;
            this.renderList.push(boundingInfo.boundingBox);
        }
    }
    _prepareResources() {
        if (this._colorShader) return;
        this._colorShader = new (0, $4I7rl.ShaderMaterial)("colorShader", this.scene, "boundingBoxRenderer", {
            attributes: [
                (0, $b4i1f.VertexBuffer).PositionKind
            ],
            uniforms: [
                "world",
                "viewProjection",
                "viewProjectionR",
                "color"
            ],
            uniformBuffers: [
                "BoundingBoxRenderer"
            ]
        }, false);
        this._colorShader.doNotSerialize = true;
        this._colorShader.reservedDataStore = {
            hidden: true
        };
        this._colorShaderForOcclusionQuery = new (0, $4I7rl.ShaderMaterial)("colorShaderOccQuery", this.scene, "boundingBoxRenderer", {
            attributes: [
                (0, $b4i1f.VertexBuffer).PositionKind
            ],
            uniforms: [
                "world",
                "viewProjection",
                "viewProjectionR",
                "color"
            ],
            uniformBuffers: [
                "BoundingBoxRenderer"
            ]
        }, true);
        this._colorShaderForOcclusionQuery.doNotSerialize = true;
        this._colorShaderForOcclusionQuery.reservedDataStore = {
            hidden: true
        };
        const engine = this.scene.getEngine();
        const boxdata = (0, $4C7Qm.CreateBoxVertexData)({
            size: 1.0
        });
        this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind] = new (0, $b4i1f.VertexBuffer)(engine, boxdata.positions, (0, $b4i1f.VertexBuffer).PositionKind, false);
        this._createIndexBuffer();
        this._fillIndexData = boxdata.indices;
        this.onResourcesReadyObservable.notifyObservers(this);
    }
    _createIndexBuffer() {
        const engine = this.scene.getEngine();
        this._indexBuffer = engine.createIndexBuffer([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            7,
            1,
            6,
            2,
            5,
            3,
            4
        ]);
    }
    /**
     * Rebuilds the elements related to this component in case of
     * context lost for instance.
     */ rebuild() {
        const vb = this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind];
        if (vb) vb._rebuild();
        this._createIndexBuffer();
    }
    /**
     * @internal
     */ reset() {
        this.renderList.reset();
    }
    /**
     * Render the bounding boxes of a specific rendering group
     * @param renderingGroupId defines the rendering group to render
     */ render(renderingGroupId) {
        if (this.renderList.length === 0 || !this.enabled) return;
        this._prepareResources();
        if (!this._colorShader.isReady()) return;
        const engine = this.scene.getEngine();
        engine.setDepthWrite(false);
        const transformMatrix = this.scene.getTransformMatrix();
        for(let boundingBoxIndex = 0; boundingBoxIndex < this.renderList.length; boundingBoxIndex++){
            const boundingBox = this.renderList.data[boundingBoxIndex];
            if (boundingBox._tag !== renderingGroupId) continue;
            this._createWrappersForBoundingBox(boundingBox);
            this.onBeforeBoxRenderingObservable.notifyObservers(boundingBox);
            const min = boundingBox.minimum;
            const max = boundingBox.maximum;
            const diff = max.subtract(min);
            const median = min.add(diff.scale(0.5));
            const worldMatrix = (0, $ha1VO.Matrix).Scaling(diff.x, diff.y, diff.z).multiply((0, $ha1VO.Matrix).Translation(median.x, median.y, median.z)).multiply(boundingBox.getWorldMatrix());
            const useReverseDepthBuffer = engine.useReverseDepthBuffer;
            if (this.showBackLines) {
                const drawWrapperBack = boundingBox._drawWrapperBack ?? this._colorShader._getDrawWrapper();
                this._colorShader._preBind(drawWrapperBack);
                engine.bindBuffers(this._vertexBuffers, this._indexBuffer, this._colorShader.getEffect());
                // Back
                if (useReverseDepthBuffer) engine.setDepthFunctionToLessOrEqual();
                else engine.setDepthFunctionToGreaterOrEqual();
                this._uniformBufferBack.bindToEffect(drawWrapperBack.effect, "BoundingBoxRenderer");
                this._uniformBufferBack.updateColor4("color", this.backColor, 1);
                this._uniformBufferBack.updateMatrix("world", worldMatrix);
                this._uniformBufferBack.updateMatrix("viewProjection", transformMatrix);
                this._uniformBufferBack.update();
                // Draw order
                engine.drawElementsType((0, $54229.Material).LineListDrawMode, 0, 24);
            }
            const drawWrapperFront = boundingBox._drawWrapperFront ?? this._colorShader._getDrawWrapper();
            this._colorShader._preBind(drawWrapperFront);
            engine.bindBuffers(this._vertexBuffers, this._indexBuffer, this._colorShader.getEffect());
            // Front
            if (useReverseDepthBuffer) engine.setDepthFunctionToGreater();
            else engine.setDepthFunctionToLess();
            this._uniformBufferFront.bindToEffect(drawWrapperFront.effect, "BoundingBoxRenderer");
            this._uniformBufferFront.updateColor4("color", this.frontColor, 1);
            this._uniformBufferFront.updateMatrix("world", worldMatrix);
            this._uniformBufferFront.updateMatrix("viewProjection", transformMatrix);
            this._uniformBufferFront.update();
            // Draw order
            engine.drawElementsType((0, $54229.Material).LineListDrawMode, 0, 24);
            this.onAfterBoxRenderingObservable.notifyObservers(boundingBox);
        }
        this._colorShader.unbind();
        engine.setDepthFunctionToLessOrEqual();
        engine.setDepthWrite(true);
    }
    _createWrappersForBoundingBox(boundingBox) {
        if (!boundingBox._drawWrapperFront) {
            const engine = this.scene.getEngine();
            boundingBox._drawWrapperFront = new (0, $hOyoX.DrawWrapper)(engine);
            boundingBox._drawWrapperBack = new (0, $hOyoX.DrawWrapper)(engine);
            boundingBox._drawWrapperFront.setEffect(this._colorShader.getEffect());
            boundingBox._drawWrapperBack.setEffect(this._colorShader.getEffect());
        }
    }
    /**
     * In case of occlusion queries, we can render the occlusion bounding box through this method
     * @param mesh Define the mesh to render the occlusion bounding box for
     */ renderOcclusionBoundingBox(mesh) {
        const engine = this.scene.getEngine();
        if (this._renderPassIdForOcclusionQuery === undefined) this._renderPassIdForOcclusionQuery = engine.createRenderPassId(`Render pass for occlusion query`);
        const currentRenderPassId = engine.currentRenderPassId;
        engine.currentRenderPassId = this._renderPassIdForOcclusionQuery;
        this._prepareResources();
        const subMesh = mesh.subMeshes[0];
        if (!this._colorShaderForOcclusionQuery.isReady(mesh, undefined, subMesh) || !mesh.hasBoundingInfo) {
            engine.currentRenderPassId = currentRenderPassId;
            return;
        }
        if (!this._fillIndexBuffer) this._fillIndexBuffer = engine.createIndexBuffer(this._fillIndexData);
        const useReverseDepthBuffer = engine.useReverseDepthBuffer;
        engine.setDepthWrite(false);
        engine.setColorWrite(false);
        const boundingBox = mesh.getBoundingInfo().boundingBox;
        const min = boundingBox.minimum;
        const max = boundingBox.maximum;
        const diff = max.subtract(min);
        const median = min.add(diff.scale(0.5));
        const worldMatrix = (0, $ha1VO.Matrix).Scaling(diff.x, diff.y, diff.z).multiply((0, $ha1VO.Matrix).Translation(median.x, median.y, median.z)).multiply(boundingBox.getWorldMatrix());
        const drawWrapper = subMesh._drawWrapper;
        this._colorShaderForOcclusionQuery._preBind(drawWrapper);
        engine.bindBuffers(this._vertexBuffers, this._fillIndexBuffer, drawWrapper.effect);
        if (useReverseDepthBuffer) engine.setDepthFunctionToGreater();
        else engine.setDepthFunctionToLess();
        this.scene.resetCachedMaterial();
        this._uniformBufferFront.bindToEffect(drawWrapper.effect, "BoundingBoxRenderer");
        this._uniformBufferFront.updateMatrix("world", worldMatrix);
        this._uniformBufferFront.updateMatrix("viewProjection", this.scene.getTransformMatrix());
        this._uniformBufferFront.update();
        engine.drawElementsType((0, $54229.Material).TriangleFillMode, 0, 36);
        this._colorShaderForOcclusionQuery.unbind();
        engine.setDepthFunctionToLessOrEqual();
        engine.setDepthWrite(true);
        engine.setColorWrite(true);
        engine.currentRenderPassId = currentRenderPassId;
    }
    /**
     * Dispose and release the resources attached to this renderer.
     */ dispose() {
        if (this._renderPassIdForOcclusionQuery !== undefined) {
            this.scene.getEngine().releaseRenderPassId(this._renderPassIdForOcclusionQuery);
            this._renderPassIdForOcclusionQuery = undefined;
        }
        if (!this._colorShader) return;
        this.onBeforeBoxRenderingObservable.clear();
        this.onAfterBoxRenderingObservable.clear();
        this.onResourcesReadyObservable.clear();
        this.renderList.dispose();
        this._colorShader.dispose();
        this._colorShaderForOcclusionQuery.dispose();
        this._uniformBufferFront.dispose();
        this._uniformBufferBack.dispose();
        const buffer = this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind];
        if (buffer) {
            buffer.dispose();
            this._vertexBuffers[(0, $b4i1f.VertexBuffer).PositionKind] = null;
        }
        this.scene.getEngine()._releaseBuffer(this._indexBuffer);
        if (this._fillIndexBuffer) {
            this.scene.getEngine()._releaseBuffer(this._fillIndexBuffer);
            this._fillIndexBuffer = null;
        }
    }
}

});
parcelRegister("irCmp", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("iWbiS");
parcelRequire("4IXF5");
const $d6d8812cf8532819$var$name = "boundingBoxRendererPixelShader";
const $d6d8812cf8532819$var$shader = `#include<__decl__boundingBoxRendererFragment>
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) {
#define CUSTOM_FRAGMENT_MAIN_BEGIN
gl_FragColor=color;
#define CUSTOM_FRAGMENT_MAIN_END
}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$d6d8812cf8532819$var$name] = $d6d8812cf8532819$var$shader;
const $d6d8812cf8532819$export$161917c595a48e8c = {
    name: $d6d8812cf8532819$var$name,
    shader: $d6d8812cf8532819$var$shader
};

});
parcelRegister("iWbiS", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $dc966964cf4994de$var$name = "boundingBoxRendererFragmentDeclaration";
const $dc966964cf4994de$var$shader = `uniform vec4 color;
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$dc966964cf4994de$var$name] = $dc966964cf4994de$var$shader;
const $dc966964cf4994de$export$bc9b9a202763af77 = {
    name: $dc966964cf4994de$var$name,
    shader: $dc966964cf4994de$var$shader
};

});

parcelRegister("4IXF5", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $37098d0a795e1995$var$name = "boundingBoxRendererUboDeclaration";
const $37098d0a795e1995$var$shader = `#ifdef WEBGL2
uniform vec4 color;uniform mat4 world;uniform mat4 viewProjection;
#ifdef MULTIVIEW
uniform mat4 viewProjectionR;
#endif
#else
layout(std140,column_major) uniform;uniform BoundingBoxRenderer {vec4 color;mat4 world;mat4 viewProjection;mat4 viewProjectionR;};
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$37098d0a795e1995$var$name] = $37098d0a795e1995$var$shader;
const $37098d0a795e1995$export$87d7f1cd2cfc3252 = {
    name: $37098d0a795e1995$var$name,
    shader: $37098d0a795e1995$var$shader
};

});


parcelRegister("lokLS", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("f8WLR");
parcelRequire("4IXF5");
const $f92bf39ab8fd9588$var$name = "boundingBoxRendererVertexShader";
const $f92bf39ab8fd9588$var$shader = `attribute vec3 position;
#include<__decl__boundingBoxRendererVertex>
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
vec4 worldPos=world*vec4(position,1.0);
#ifdef MULTIVIEW
if (gl_ViewID_OVR==0u) {gl_Position=viewProjection*worldPos;} else {gl_Position=viewProjectionR*worldPos;}
#else
gl_Position=viewProjection*worldPos;
#endif
#define CUSTOM_VERTEX_MAIN_END
}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$f92bf39ab8fd9588$var$name] = $f92bf39ab8fd9588$var$shader;
const $f92bf39ab8fd9588$export$9b4e8cc302463643 = {
    name: $f92bf39ab8fd9588$var$name,
    shader: $f92bf39ab8fd9588$var$shader
};

});
parcelRegister("f8WLR", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $b0653112e2937164$var$name = "boundingBoxRendererVertexDeclaration";
const $b0653112e2937164$var$shader = `uniform mat4 world;uniform mat4 viewProjection;
#ifdef MULTIVIEW
uniform mat4 viewProjectionR;
#endif
`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$b0653112e2937164$var$name] = $b0653112e2937164$var$shader;
const $b0653112e2937164$export$872de7c54f41c266 = {
    name: $b0653112e2937164$var$name,
    shader: $b0653112e2937164$var$shader
};

});



parcelRegister("5Wo6G", function(module, exports) {

$parcel$export(module.exports, "DepthRendererSceneComponent", () => $453511a18880f8d1$export$5aa004a37fc838d4);

var $gmbCk = parcelRequire("gmbCk");

var $UZ4tK = parcelRequire("UZ4tK");

var $bv05l = parcelRequire("bv05l");
(0, $gmbCk.Scene).prototype.enableDepthRenderer = function(camera, storeNonLinearDepth = false, force32bitsFloat = false, samplingMode = 3, storeCameraSpaceZ = false) {
    camera = camera || this.activeCamera;
    if (!camera) // eslint-disable-next-line no-throw-literal
    throw "No camera available to enable depth renderer";
    if (!this._depthRenderer) this._depthRenderer = {};
    if (!this._depthRenderer[camera.id]) {
        const supportFullfloat = !!this.getEngine().getCaps().textureFloatRender;
        let textureType = 0;
        if (this.getEngine().getCaps().textureHalfFloatRender && (!force32bitsFloat || !supportFullfloat)) textureType = 2;
        else if (supportFullfloat) textureType = 1;
        else textureType = 0;
        this._depthRenderer[camera.id] = new (0, $UZ4tK.DepthRenderer)(this, textureType, camera, storeNonLinearDepth, samplingMode, storeCameraSpaceZ);
    }
    return this._depthRenderer[camera.id];
};
(0, $gmbCk.Scene).prototype.disableDepthRenderer = function(camera) {
    camera = camera || this.activeCamera;
    if (!camera || !this._depthRenderer || !this._depthRenderer[camera.id]) return;
    this._depthRenderer[camera.id].dispose();
};
class $453511a18880f8d1$export$5aa004a37fc838d4 {
    /**
     * Creates a new instance of the component for the given scene
     * @param scene Defines the scene to register the component in
     */ constructor(scene){
        /**
         * The component name helpful to identify the component in the list of scene components.
         */ this.name = (0, $bv05l.SceneComponentConstants).NAME_DEPTHRENDERER;
        this.scene = scene;
    }
    /**
     * Registers the component in a given scene
     */ register() {
        this.scene._gatherRenderTargetsStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_GATHERRENDERTARGETS_DEPTHRENDERER, this, this._gatherRenderTargets);
        this.scene._gatherActiveCameraRenderTargetsStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_GATHERACTIVECAMERARENDERTARGETS_DEPTHRENDERER, this, this._gatherActiveCameraRenderTargets);
    }
    /**
     * Rebuilds the elements related to this component in case of
     * context lost for instance.
     */ rebuild() {
    // Nothing to do for this component
    }
    /**
     * Disposes the component and the associated resources
     */ dispose() {
        for(const key in this.scene._depthRenderer)this.scene._depthRenderer[key].dispose();
    }
    _gatherRenderTargets(renderTargets) {
        if (this.scene._depthRenderer) for(const key in this.scene._depthRenderer){
            const depthRenderer = this.scene._depthRenderer[key];
            if (depthRenderer.enabled && !depthRenderer.useOnlyInActiveCamera) renderTargets.push(depthRenderer.getDepthMap());
        }
    }
    _gatherActiveCameraRenderTargets(renderTargets) {
        if (this.scene._depthRenderer) for(const key in this.scene._depthRenderer){
            const depthRenderer = this.scene._depthRenderer[key];
            if (depthRenderer.enabled && depthRenderer.useOnlyInActiveCamera && this.scene.activeCamera.id === key) renderTargets.push(depthRenderer.getDepthMap());
        }
    }
}
(0, $UZ4tK.DepthRenderer)._SceneComponentInitialization = (scene)=>{
    // Register the G Buffer component to the scene.
    let component = scene._getComponent((0, $bv05l.SceneComponentConstants).NAME_DEPTHRENDERER);
    if (!component) {
        component = new $453511a18880f8d1$export$5aa004a37fc838d4(scene);
        scene._addComponent(component);
    }
};

});

parcelRegister("b891L", function(module, exports) {

$parcel$export(module.exports, "DepthPeelingRenderer", () => $81a771ba9e8cea7c$export$85c83a954a4cc3bf);
/**
 * Implementation based on https://medium.com/@shrekshao_71662/dual-depth-peeling-implementation-in-webgl-11baa061ba4b
 */ 
var $3TXsv = parcelRequire("3TXsv");

var $7etnY = parcelRequire("7etnY");

var $57onU = parcelRequire("57onU");

var $jyMMC = parcelRequire("jyMMC");

var $iYGpr = parcelRequire("iYGpr");

var $gQtNK = parcelRequire("gQtNK");

var $kVtWi = parcelRequire("kVtWi");

var $54229 = parcelRequire("54229");
parcelRequire("cr88r");
parcelRequire("fQ2u9");
parcelRequire("hlFBC");
class $81a771ba9e8cea7c$var$DepthPeelingEffectConfiguration {
    constructor(){
        /**
         * Is this effect enabled
         */ this.enabled = true;
        /**
         * Name of the configuration
         */ this.name = "depthPeeling";
        /**
         * Textures that should be present in the MRT for this effect to work
         */ this.texturesRequired = [
            4
        ];
    }
}
class $81a771ba9e8cea7c$export$85c83a954a4cc3bf {
    /**
     * Number of depth peeling passes. As we are using dual depth peeling, each pass two levels of transparency are processed.
     */ get passCount() {
        return this._passCount;
    }
    set passCount(count) {
        if (this._passCount === count) return;
        this._passCount = count;
        this._createRenderPassIds();
    }
    /**
     * Instructs the renderer to use render passes. It is an optimization that makes the rendering faster for some engines (like WebGPU) but that consumes more memory, so it is disabled by default.
     */ get useRenderPasses() {
        return this._useRenderPasses;
    }
    set useRenderPasses(usePasses) {
        if (this._useRenderPasses === usePasses) return;
        this._useRenderPasses = usePasses;
        this._createRenderPassIds();
    }
    /**
     * Add a mesh in the exclusion list to prevent it to be handled by the depth peeling renderer
     * @param mesh The mesh to exclude from the depth peeling renderer
     */ addExcludedMesh(mesh) {
        if (this._excludedMeshes.indexOf(mesh.uniqueId) === -1) this._excludedMeshes.push(mesh.uniqueId);
    }
    /**
     * Remove a mesh from the exclusion list of the depth peeling renderer
     * @param mesh The mesh to remove
     */ removeExcludedMesh(mesh) {
        const index = this._excludedMeshes.indexOf(mesh.uniqueId);
        if (index !== -1) this._excludedMeshes.splice(index, 1);
    }
    /**
     * Instanciates the depth peeling renderer
     * @param scene Scene to attach to
     * @param passCount Number of depth layers to peel
     * @returns The depth peeling renderer
     */ constructor(scene, passCount = 5){
        this._thinTextures = [];
        this._currentPingPongState = 0;
        this._layoutCacheFormat = [
            [
                true
            ],
            [
                true,
                true
            ],
            [
                true,
                true,
                true
            ]
        ];
        this._layoutCache = [];
        this._candidateSubMeshes = new (0, $57onU.SmartArray)(10);
        this._excludedSubMeshes = new (0, $57onU.SmartArray)(10);
        this._excludedMeshes = [];
        this._colorCache = [
            new (0, $7etnY.Color4)($81a771ba9e8cea7c$export$85c83a954a4cc3bf._DEPTH_CLEAR_VALUE, $81a771ba9e8cea7c$export$85c83a954a4cc3bf._DEPTH_CLEAR_VALUE, 0, 0),
            new (0, $7etnY.Color4)(-$81a771ba9e8cea7c$export$85c83a954a4cc3bf._MIN_DEPTH, $81a771ba9e8cea7c$export$85c83a954a4cc3bf._MAX_DEPTH, 0, 0),
            new (0, $7etnY.Color4)(0, 0, 0, 0)
        ];
        this._scene = scene;
        this._engine = scene.getEngine();
        this._passCount = passCount;
        //  We need a depth texture for opaque
        if (!scene.enablePrePassRenderer()) {
            (0, $kVtWi.Logger).Warn("Depth peeling for order independant transparency could not enable PrePass, aborting.");
            return;
        }
        for(let i = 0; i < this._layoutCacheFormat.length; ++i)this._layoutCache[i] = this._engine.buildTextureLayout(this._layoutCacheFormat[i]);
        this._renderPassIds = [];
        this.useRenderPasses = false;
        this._prePassEffectConfiguration = new $81a771ba9e8cea7c$var$DepthPeelingEffectConfiguration();
        this._createTextures();
        this._createEffects();
    }
    _createRenderPassIds() {
        this._releaseRenderPassIds();
        if (this._useRenderPasses) {
            for(let i = 0; i < this._passCount + 1; ++i)if (!this._renderPassIds[i]) this._renderPassIds[i] = this._engine.createRenderPassId(`DepthPeelingRenderer - pass #${i}`);
        }
    }
    _releaseRenderPassIds() {
        for(let i = 0; i < this._renderPassIds.length; ++i)this._engine.releaseRenderPassId(this._renderPassIds[i]);
        this._renderPassIds = [];
    }
    _createTextures() {
        const size = {
            width: this._engine.getRenderWidth(),
            height: this._engine.getRenderHeight()
        };
        // 2 for ping pong
        this._depthMrts = [
            new (0, $3TXsv.MultiRenderTarget)("depthPeelingDepth0MRT", size, 3, this._scene, undefined, [
                "depthPeelingDepth0MRT_depth",
                "depthPeelingDepth0MRT_frontColor",
                "depthPeelingDepth0MRT_backColor"
            ]),
            new (0, $3TXsv.MultiRenderTarget)("depthPeelingDepth1MRT", size, 3, this._scene, undefined, [
                "depthPeelingDepth1MRT_depth",
                "depthPeelingDepth1MRT_frontColor",
                "depthPeelingDepth1MRT_backColor"
            ])
        ];
        this._colorMrts = [
            new (0, $3TXsv.MultiRenderTarget)("depthPeelingColor0MRT", size, 2, this._scene, {
                generateDepthBuffer: false
            }, [
                "depthPeelingColor0MRT_frontColor",
                "depthPeelingColor0MRT_backColor"
            ]),
            new (0, $3TXsv.MultiRenderTarget)("depthPeelingColor1MRT", size, 2, this._scene, {
                generateDepthBuffer: false
            }, [
                "depthPeelingColor1MRT_frontColor",
                "depthPeelingColor1MRT_backColor"
            ])
        ];
        this._blendBackMrt = new (0, $3TXsv.MultiRenderTarget)("depthPeelingBackMRT", size, 1, this._scene, {
            generateDepthBuffer: false
        }, [
            "depthPeelingBackMRT_blendBack"
        ]);
        this._outputRT = new (0, $gQtNK.RenderTargetTexture)("depthPeelingOutputRTT", size, this._scene, false);
        // 0 is a depth texture
        // 1 is a color texture
        const optionsArray = [
            {
                format: 7,
                samplingMode: 1,
                type: this._engine.getCaps().textureFloatLinearFiltering ? 1 : 2,
                label: "DepthPeelingRenderer-DepthTexture"
            },
            {
                format: 5,
                samplingMode: 1,
                type: 2,
                label: "DepthPeelingRenderer-ColorTexture"
            }
        ];
        for(let i = 0; i < 2; i++){
            const depthTexture = this._engine._createInternalTexture(size, optionsArray[0], false);
            const frontColorTexture = this._engine._createInternalTexture(size, optionsArray[1], false);
            const backColorTexture = this._engine._createInternalTexture(size, optionsArray[1], false);
            this._depthMrts[i].setInternalTexture(depthTexture, 0);
            this._depthMrts[i].setInternalTexture(frontColorTexture, 1);
            this._depthMrts[i].setInternalTexture(backColorTexture, 2);
            this._colorMrts[i].setInternalTexture(frontColorTexture, 0);
            this._colorMrts[i].setInternalTexture(backColorTexture, 1);
            this._thinTextures.push(new (0, $jyMMC.ThinTexture)(depthTexture), new (0, $jyMMC.ThinTexture)(frontColorTexture), new (0, $jyMMC.ThinTexture)(backColorTexture));
        }
    }
    // TODO : explore again MSAA with depth peeling when
    // we are able to fetch individual samples in a multisampled renderbuffer
    // public set samples(value: number) {
    //     for (let i = 0; i < 2; i++) {
    //         this._depthMrts[i].samples = value;
    //         this._colorMrts[i].samples = value;
    //     }
    //     this._scene.prePassRenderer!.samples = value;
    // }
    _disposeTextures() {
        for(let i = 0; i < this._thinTextures.length; i++){
            if (i === 6) continue;
            this._thinTextures[i].dispose();
        }
        for(let i = 0; i < 2; i++){
            this._depthMrts[i].dispose(true);
            this._colorMrts[i].dispose(true);
            this._blendBackMrt.dispose(true);
        }
        this._outputRT.dispose();
        this._thinTextures = [];
        this._colorMrts = [];
        this._depthMrts = [];
    }
    _updateTextures() {
        if (this._depthMrts[0].getSize().width !== this._engine.getRenderWidth() || this._depthMrts[0].getSize().height !== this._engine.getRenderHeight()) {
            this._disposeTextures();
            this._createTextures();
        }
        return this._updateTextureReferences();
    }
    _updateTextureReferences() {
        const prePassRenderer = this._scene.prePassRenderer;
        if (!prePassRenderer) return false;
        // Retrieve opaque color texture
        const textureIndex = prePassRenderer.getIndex(4);
        const prePassTexture = prePassRenderer.defaultRT.textures?.length ? prePassRenderer.defaultRT.textures[textureIndex].getInternalTexture() : null;
        if (!prePassTexture) return false;
        if (this._blendBackTexture !== prePassTexture) {
            this._blendBackTexture = prePassTexture;
            this._blendBackMrt.setInternalTexture(this._blendBackTexture, 0);
            if (this._thinTextures[6]) this._thinTextures[6].dispose();
            this._thinTextures[6] = new (0, $jyMMC.ThinTexture)(this._blendBackTexture);
            prePassRenderer.defaultRT.renderTarget._shareDepth(this._depthMrts[0].renderTarget);
        }
        return true;
    }
    _createEffects() {
        this._blendBackEffectWrapper = new (0, $iYGpr.EffectWrapper)({
            fragmentShader: "oitBackBlend",
            useShaderStore: true,
            engine: this._engine,
            samplerNames: [
                "uBackColor"
            ],
            uniformNames: []
        });
        this._blendBackEffectWrapperPingPong = new (0, $iYGpr.EffectWrapper)({
            fragmentShader: "oitBackBlend",
            useShaderStore: true,
            engine: this._engine,
            samplerNames: [
                "uBackColor"
            ],
            uniformNames: []
        });
        this._finalEffectWrapper = new (0, $iYGpr.EffectWrapper)({
            fragmentShader: "oitFinal",
            useShaderStore: true,
            engine: this._engine,
            samplerNames: [
                "uFrontColor",
                "uBackColor"
            ],
            uniformNames: []
        });
        this._effectRenderer = new (0, $iYGpr.EffectRenderer)(this._engine);
    }
    /**
     * Links to the prepass renderer
     * @param prePassRenderer The scene PrePassRenderer
     */ setPrePassRenderer(prePassRenderer) {
        prePassRenderer.addEffectConfiguration(this._prePassEffectConfiguration);
    }
    /**
     * Binds depth peeling textures on an effect
     * @param effect The effect to bind textures on
     */ bind(effect) {
        effect.setTexture("oitDepthSampler", this._thinTextures[this._currentPingPongState * 3]);
        effect.setTexture("oitFrontColorSampler", this._thinTextures[this._currentPingPongState * 3 + 1]);
    }
    _renderSubMeshes(transparentSubMeshes) {
        let mapMaterialContext;
        if (this._useRenderPasses) mapMaterialContext = {};
        for(let j = 0; j < transparentSubMeshes.length; j++){
            const material = transparentSubMeshes.data[j].getMaterial();
            let previousShaderHotSwapping = true;
            let previousBFC = false;
            const subMesh = transparentSubMeshes.data[j];
            let drawWrapper;
            let firstDraw = false;
            if (this._useRenderPasses) {
                drawWrapper = subMesh._getDrawWrapper();
                firstDraw = !drawWrapper;
            }
            if (material) {
                previousShaderHotSwapping = material.allowShaderHotSwapping;
                previousBFC = material.backFaceCulling;
                material.allowShaderHotSwapping = false;
                material.backFaceCulling = false;
            }
            subMesh.render(false);
            if (firstDraw) {
                // first time we draw this submesh: we replace the material context
                drawWrapper = subMesh._getDrawWrapper(); // we are sure it is now non empty as we just rendered the submesh
                if (drawWrapper.materialContext) {
                    let newMaterialContext = mapMaterialContext[drawWrapper.materialContext.uniqueId];
                    if (!newMaterialContext) newMaterialContext = mapMaterialContext[drawWrapper.materialContext.uniqueId] = this._engine.createMaterialContext();
                    subMesh._getDrawWrapper().materialContext = newMaterialContext;
                }
            }
            if (material) {
                material.allowShaderHotSwapping = previousShaderHotSwapping;
                material.backFaceCulling = previousBFC;
            }
        }
    }
    _finalCompose(writeId) {
        const output = this._scene.prePassRenderer?.setCustomOutput(this._outputRT);
        if (output) this._engine.bindFramebuffer(this._outputRT.renderTarget);
        else this._engine.restoreDefaultFramebuffer();
        this._engine.setAlphaMode(0);
        this._engine.applyStates();
        this._engine.enableEffect(this._finalEffectWrapper._drawWrapper);
        this._finalEffectWrapper.effect.setTexture("uFrontColor", this._thinTextures[writeId * 3 + 1]);
        this._finalEffectWrapper.effect.setTexture("uBackColor", this._thinTextures[6]);
        this._effectRenderer.render(this._finalEffectWrapper);
    }
    /**
     * Checks if the depth peeling renderer is ready to render transparent meshes
     * @returns true if the depth peeling renderer is ready to render the transparent meshes
     */ isReady() {
        return this._blendBackEffectWrapper.effect.isReady() && this._blendBackEffectWrapperPingPong.effect.isReady() && this._finalEffectWrapper.effect.isReady() && this._updateTextures();
    }
    /**
     * Renders transparent submeshes with depth peeling
     * @param transparentSubMeshes List of transparent meshes to render
     * @returns The array of submeshes that could not be handled by this renderer
     */ render(transparentSubMeshes) {
        this._candidateSubMeshes.length = 0;
        this._excludedSubMeshes.length = 0;
        if (!this.isReady()) return this._excludedSubMeshes;
        if (this._scene.activeCamera) this._engine.setViewport(this._scene.activeCamera.viewport);
        for(let i = 0; i < transparentSubMeshes.length; i++){
            const subMesh = transparentSubMeshes.data[i];
            const material = subMesh.getMaterial();
            const fillMode = material && subMesh.getRenderingMesh()._getRenderingFillMode(material.fillMode);
            if (material && (fillMode === (0, $54229.Material).TriangleFanDrawMode || fillMode === (0, $54229.Material).TriangleFillMode || fillMode === (0, $54229.Material).TriangleStripDrawMode) && this._excludedMeshes.indexOf(subMesh.getMesh().uniqueId) === -1) this._candidateSubMeshes.push(subMesh);
            else this._excludedSubMeshes.push(subMesh);
        }
        if (!this._candidateSubMeshes.length) {
            this._engine.bindFramebuffer(this._colorMrts[1].renderTarget);
            this._engine.bindAttachments(this._layoutCache[1]);
            this._engine.clear(this._colorCache[2], true, false, false);
            this._engine.unBindFramebuffer(this._colorMrts[1].renderTarget);
            this._finalCompose(1);
            return this._excludedSubMeshes;
        }
        const currentRenderPassId = this._engine.currentRenderPassId;
        this._scene.prePassRenderer._enabled = false;
        if (this._useRenderPasses) this._engine.currentRenderPassId = this._renderPassIds[0];
        // Clears
        this._engine.bindFramebuffer(this._depthMrts[0].renderTarget);
        this._engine.bindAttachments(this._layoutCache[0]);
        this._engine.clear(this._colorCache[0], true, false, false);
        this._engine.unBindFramebuffer(this._depthMrts[0].renderTarget);
        this._engine.bindFramebuffer(this._depthMrts[1].renderTarget);
        this._engine.bindAttachments(this._layoutCache[0]);
        this._engine.clear(this._colorCache[1], true, false, false);
        this._engine.unBindFramebuffer(this._depthMrts[1].renderTarget);
        this._engine.bindFramebuffer(this._colorMrts[0].renderTarget);
        this._engine.bindAttachments(this._layoutCache[1]);
        this._engine.clear(this._colorCache[2], true, false, false);
        this._engine.unBindFramebuffer(this._colorMrts[0].renderTarget);
        this._engine.bindFramebuffer(this._colorMrts[1].renderTarget);
        this._engine.bindAttachments(this._layoutCache[1]);
        this._engine.clear(this._colorCache[2], true, false, false);
        this._engine.unBindFramebuffer(this._colorMrts[1].renderTarget);
        // Draw depth for first pass
        this._engine.bindFramebuffer(this._depthMrts[0].renderTarget);
        this._engine.bindAttachments(this._layoutCache[0]);
        this._engine.setAlphaMode(11); // in WebGPU, when using MIN or MAX equation, the src / dst color factors should not use SRC_ALPHA and the src / dst alpha factors must be 1 else WebGPU will throw a validation error
        this._engine.setAlphaEquation(3);
        this._engine.depthCullingState.depthMask = false;
        this._engine.depthCullingState.depthTest = true;
        this._engine.applyStates();
        this._currentPingPongState = 1;
        // Render
        this._renderSubMeshes(this._candidateSubMeshes);
        this._engine.unBindFramebuffer(this._depthMrts[0].renderTarget);
        this._scene.resetCachedMaterial();
        // depth peeling ping-pong
        let readId = 0;
        let writeId = 0;
        for(let i = 0; i < this._passCount; i++){
            readId = i % 2;
            writeId = 1 - readId;
            this._currentPingPongState = readId;
            if (this._useRenderPasses) this._engine.currentRenderPassId = this._renderPassIds[i + 1];
            if (this._scene.activeCamera) this._engine.setViewport(this._scene.activeCamera.viewport);
            // Clears
            this._engine.bindFramebuffer(this._depthMrts[writeId].renderTarget);
            this._engine.bindAttachments(this._layoutCache[0]);
            this._engine.clear(this._colorCache[0], true, false, false);
            this._engine.unBindFramebuffer(this._depthMrts[writeId].renderTarget);
            this._engine.bindFramebuffer(this._colorMrts[writeId].renderTarget);
            this._engine.bindAttachments(this._layoutCache[1]);
            this._engine.clear(this._colorCache[2], true, false, false);
            this._engine.unBindFramebuffer(this._colorMrts[writeId].renderTarget);
            this._engine.bindFramebuffer(this._depthMrts[writeId].renderTarget);
            this._engine.bindAttachments(this._layoutCache[2]);
            this._engine.setAlphaMode(11); // the value does not matter (as MAX operation does not use them) but the src and dst color factors should not use SRC_ALPHA else WebGPU will throw a validation error
            this._engine.setAlphaEquation(3);
            this._engine.depthCullingState.depthTest = false;
            this._engine.applyStates();
            // Render
            this._renderSubMeshes(this._candidateSubMeshes);
            this._engine.unBindFramebuffer(this._depthMrts[writeId].renderTarget);
            this._scene.resetCachedMaterial();
            // Back color
            this._engine.bindFramebuffer(this._blendBackMrt.renderTarget);
            this._engine.bindAttachments(this._layoutCache[0]);
            this._engine.setAlphaEquation(0);
            this._engine.setAlphaMode(17);
            this._engine.applyStates();
            const blendBackEffectWrapper = writeId === 0 || !this._useRenderPasses ? this._blendBackEffectWrapper : this._blendBackEffectWrapperPingPong;
            this._engine.enableEffect(blendBackEffectWrapper._drawWrapper);
            blendBackEffectWrapper.effect.setTexture("uBackColor", this._thinTextures[writeId * 3 + 2]);
            this._effectRenderer.render(blendBackEffectWrapper);
            this._engine.unBindFramebuffer(this._blendBackMrt.renderTarget);
        }
        this._engine.currentRenderPassId = currentRenderPassId;
        // Final composition on default FB
        this._finalCompose(writeId);
        this._scene.prePassRenderer._enabled = true;
        this._engine.depthCullingState.depthMask = true;
        this._engine.depthCullingState.depthTest = true;
        return this._excludedSubMeshes;
    }
    /**
     * Disposes the depth peeling renderer and associated ressources
     */ dispose() {
        this._disposeTextures();
        this._blendBackEffectWrapper.dispose();
        this._finalEffectWrapper.dispose();
        this._effectRenderer.dispose();
        this._releaseRenderPassIds();
    }
}
$81a771ba9e8cea7c$export$85c83a954a4cc3bf._DEPTH_CLEAR_VALUE = -99999;
$81a771ba9e8cea7c$export$85c83a954a4cc3bf._MIN_DEPTH = 0;
$81a771ba9e8cea7c$export$85c83a954a4cc3bf._MAX_DEPTH = 1;

});
parcelRegister("fQ2u9", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $02f9c4b53f7428d3$var$name = "oitFinalPixelShader";
const $02f9c4b53f7428d3$var$shader = `precision highp float;uniform sampler2D uFrontColor;uniform sampler2D uBackColor;void main() {ivec2 fragCoord=ivec2(gl_FragCoord.xy);vec4 frontColor=texelFetch(uFrontColor,fragCoord,0);vec4 backColor=texelFetch(uBackColor,fragCoord,0);float alphaMultiplier=1.0-frontColor.a;glFragColor=vec4(
frontColor.rgb+alphaMultiplier*backColor.rgb,
frontColor.a+backColor.a
);}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$02f9c4b53f7428d3$var$name] = $02f9c4b53f7428d3$var$shader;
const $02f9c4b53f7428d3$export$de23b04cd9fab81b = {
    name: $02f9c4b53f7428d3$var$name,
    shader: $02f9c4b53f7428d3$var$shader
};

});

parcelRegister("hlFBC", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $ca14abdf98a95154$var$name = "oitBackBlendPixelShader";
const $ca14abdf98a95154$var$shader = `precision highp float;uniform sampler2D uBackColor;void main() {glFragColor=texelFetch(uBackColor,ivec2(gl_FragCoord.xy),0);if (glFragColor.a==0.0) { 
discard;}}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$ca14abdf98a95154$var$name] = $ca14abdf98a95154$var$shader;
const $ca14abdf98a95154$export$3a1367fd108cdd70 = {
    name: $ca14abdf98a95154$var$name,
    shader: $ca14abdf98a95154$var$shader
};

});


parcelRegister("7bELJ", function(module, exports) {

$parcel$export(module.exports, "DepthPeelingSceneComponent", () => $53b92f547fb240d2$export$7dc8aba405fe84ed);

var $gmbCk = parcelRequire("gmbCk");

var $bv05l = parcelRequire("bv05l");

var $b891L = parcelRequire("b891L");
Object.defineProperty((0, $gmbCk.Scene).prototype, "depthPeelingRenderer", {
    get: function() {
        if (!this._depthPeelingRenderer) {
            let component = this._getComponent((0, $bv05l.SceneComponentConstants).NAME_DEPTHPEELINGRENDERER);
            if (!component) {
                component = new $53b92f547fb240d2$export$7dc8aba405fe84ed(this);
                this._addComponent(component);
            }
        }
        return this._depthPeelingRenderer;
    },
    set: function(value) {
        this._depthPeelingRenderer = value;
    },
    enumerable: true,
    configurable: true
});
Object.defineProperty((0, $gmbCk.Scene).prototype, "useOrderIndependentTransparency", {
    get: function() {
        return this._useOrderIndependentTransparency;
    },
    set: function(value) {
        if (this._useOrderIndependentTransparency === value) return;
        this._useOrderIndependentTransparency = value;
        this.markAllMaterialsAsDirty(63);
        this.prePassRenderer?.markAsDirty();
    },
    enumerable: true,
    configurable: true
});
class $53b92f547fb240d2$export$7dc8aba405fe84ed {
    /**
     * Creates a new instance of the component for the given scene
     * @param scene Defines the scene to register the component in
     */ constructor(scene){
        /**
         * The component name helpful to identify the component in the list of scene components.
         */ this.name = (0, $bv05l.SceneComponentConstants).NAME_DEPTHPEELINGRENDERER;
        this.scene = scene;
        scene.depthPeelingRenderer = new (0, $b891L.DepthPeelingRenderer)(scene);
    }
    /**
     * Registers the component in a given scene
     */ register() {}
    /**
     * Rebuilds the elements related to this component in case of
     * context lost for instance.
     */ rebuild() {}
    /**
     * Disposes the component and the associated resources.
     */ dispose() {
        this.scene.depthPeelingRenderer?.dispose();
        this.scene.depthPeelingRenderer = null;
    }
}

});

parcelRegister("kT9d6", function(module, exports) {

$parcel$export(module.exports, "EdgesRenderer", () => $f35016ab0623318c$export$eeed9d9982da57e6);
$parcel$export(module.exports, "LineEdgesRenderer", () => $f35016ab0623318c$export$e39ff71048e9ea08);

var $b4i1f = parcelRequire("b4i1f");

var $0cHNL = parcelRequire("0cHNL");

var $abjAz = parcelRequire("abjAz");

var $ha1VO = parcelRequire("ha1VO");

var $54229 = parcelRequire("54229");

var $4I7rl = parcelRequire("4I7rl");

var $74SKQ = parcelRequire("74SKQ");
parcelRequire("lF2ES");
parcelRequire("1GzDw");

var $57onU = parcelRequire("57onU");

var $hOyoX = parcelRequire("hOyoX");
(0, $0cHNL.AbstractMesh).prototype.disableEdgesRendering = function() {
    if (this._edgesRenderer) {
        this._edgesRenderer.dispose();
        this._edgesRenderer = null;
    }
    return this;
};
(0, $0cHNL.AbstractMesh).prototype.enableEdgesRendering = function(epsilon = 0.95, checkVerticesInsteadOfIndices = false, options) {
    this.disableEdgesRendering();
    this._edgesRenderer = new $f35016ab0623318c$export$eeed9d9982da57e6(this, epsilon, checkVerticesInsteadOfIndices, true, options);
    return this;
};
Object.defineProperty((0, $0cHNL.AbstractMesh).prototype, "edgesRenderer", {
    get: function() {
        return this._edgesRenderer;
    },
    enumerable: true,
    configurable: true
});
(0, $abjAz.LinesMesh).prototype.enableEdgesRendering = function(epsilon = 0.95, checkVerticesInsteadOfIndices = false) {
    this.disableEdgesRendering();
    this._edgesRenderer = new $f35016ab0623318c$export$e39ff71048e9ea08(this, epsilon, checkVerticesInsteadOfIndices);
    return this;
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
(0, $abjAz.InstancedLinesMesh).prototype.enableEdgesRendering = function(epsilon = 0.95, checkVerticesInsteadOfIndices = false) {
    (0, $abjAz.LinesMesh).prototype.enableEdgesRendering.apply(this, arguments);
    return this;
};
/**
 * FaceAdjacencies Helper class to generate edges
 */ class $f35016ab0623318c$var$FaceAdjacencies {
    constructor(){
        this.edges = [];
        this.edgesConnectedCount = 0;
    }
}
class $f35016ab0623318c$export$eeed9d9982da57e6 {
    /** Gets the vertices generated by the edge renderer */ get linesPositions() {
        return this._linesPositions;
    }
    /** Gets the normals generated by the edge renderer */ get linesNormals() {
        return this._linesNormals;
    }
    /** Gets the indices generated by the edge renderer */ get linesIndices() {
        return this._linesIndices;
    }
    /**
     * Gets or sets the shader used to draw the lines
     */ get lineShader() {
        return this._lineShader;
    }
    set lineShader(shader) {
        this._lineShader = shader;
    }
    static _GetShader(scene) {
        if (!scene._edgeRenderLineShader) {
            const shader = new (0, $4I7rl.ShaderMaterial)("lineShader", scene, "line", {
                attributes: [
                    "position",
                    "normal"
                ],
                uniforms: [
                    "world",
                    "viewProjection",
                    "color",
                    "width",
                    "aspectRatio"
                ]
            }, false);
            shader.disableDepthWrite = true;
            shader.backFaceCulling = false;
            shader.checkReadyOnEveryCall = scene.getEngine().isWebGPU;
            scene._edgeRenderLineShader = shader;
        }
        return scene._edgeRenderLineShader;
    }
    /**
     * Creates an instance of the EdgesRenderer. It is primarily use to display edges of a mesh.
     * Beware when you use this class with complex objects as the adjacencies computation can be really long
     * @param  source Mesh used to create edges
     * @param  epsilon sum of angles in adjacency to check for edge
     * @param  checkVerticesInsteadOfIndices bases the edges detection on vertices vs indices. Note that this parameter is not used if options.useAlternateEdgeFinder = true
     * @param  generateEdgesLines - should generate Lines or only prepare resources.
     * @param  options The options to apply when generating the edges
     */ constructor(source, epsilon = 0.95, checkVerticesInsteadOfIndices = false, generateEdgesLines = true, options){
        /**
         * Define the size of the edges with an orthographic camera
         */ this.edgesWidthScalerForOrthographic = 1000.0;
        /**
         * Define the size of the edges with a perspective camera
         */ this.edgesWidthScalerForPerspective = 50.0;
        this._linesPositions = new Array();
        this._linesNormals = new Array();
        this._linesIndices = new Array();
        this._buffers = {};
        this._buffersForInstances = {};
        this._checkVerticesInsteadOfIndices = false;
        /** Gets or sets a boolean indicating if the edgesRenderer is active */ this.isEnabled = true;
        /**
         * List of instances to render in case the source mesh has instances
         */ this.customInstances = new (0, $57onU.SmartArray)(32);
        this._source = source;
        this._checkVerticesInsteadOfIndices = checkVerticesInsteadOfIndices;
        this._options = options ?? null;
        this._epsilon = epsilon;
        if (this._source.getScene().getEngine().isWebGPU) this._drawWrapper = new (0, $hOyoX.DrawWrapper)(source.getEngine());
        this._prepareRessources();
        if (generateEdgesLines) {
            if (options?.useAlternateEdgeFinder ?? true) this._generateEdgesLinesAlternate();
            else this._generateEdgesLines();
        }
        this._meshRebuildObserver = this._source.onRebuildObservable.add(()=>{
            this._rebuild();
        });
        this._meshDisposeObserver = this._source.onDisposeObservable.add(()=>{
            this.dispose();
        });
    }
    _prepareRessources() {
        if (this._lineShader) return;
        this._lineShader = $f35016ab0623318c$export$eeed9d9982da57e6._GetShader(this._source.getScene());
    }
    /** @internal */ _rebuild() {
        let buffer = this._buffers[(0, $b4i1f.VertexBuffer).PositionKind];
        if (buffer) buffer._rebuild();
        buffer = this._buffers[(0, $b4i1f.VertexBuffer).NormalKind];
        if (buffer) buffer._rebuild();
        const scene = this._source.getScene();
        const engine = scene.getEngine();
        this._ib = engine.createIndexBuffer(this._linesIndices);
    }
    /**
     * Releases the required resources for the edges renderer
     */ dispose() {
        this._source.onRebuildObservable.remove(this._meshRebuildObserver);
        this._source.onDisposeObservable.remove(this._meshDisposeObserver);
        let buffer = this._buffers[(0, $b4i1f.VertexBuffer).PositionKind];
        if (buffer) {
            buffer.dispose();
            this._buffers[(0, $b4i1f.VertexBuffer).PositionKind] = null;
        }
        buffer = this._buffers[(0, $b4i1f.VertexBuffer).NormalKind];
        if (buffer) {
            buffer.dispose();
            this._buffers[(0, $b4i1f.VertexBuffer).NormalKind] = null;
        }
        if (this._ib) this._source.getScene().getEngine()._releaseBuffer(this._ib);
        this._lineShader.dispose();
        this._drawWrapper?.dispose();
    }
    _processEdgeForAdjacencies(pa, pb, p0, p1, p2) {
        if (pa === p0 && pb === p1 || pa === p1 && pb === p0) return 0;
        if (pa === p1 && pb === p2 || pa === p2 && pb === p1) return 1;
        if (pa === p2 && pb === p0 || pa === p0 && pb === p2) return 2;
        return -1;
    }
    _processEdgeForAdjacenciesWithVertices(pa, pb, p0, p1, p2) {
        const eps = 1e-10;
        if (pa.equalsWithEpsilon(p0, eps) && pb.equalsWithEpsilon(p1, eps) || pa.equalsWithEpsilon(p1, eps) && pb.equalsWithEpsilon(p0, eps)) return 0;
        if (pa.equalsWithEpsilon(p1, eps) && pb.equalsWithEpsilon(p2, eps) || pa.equalsWithEpsilon(p2, eps) && pb.equalsWithEpsilon(p1, eps)) return 1;
        if (pa.equalsWithEpsilon(p2, eps) && pb.equalsWithEpsilon(p0, eps) || pa.equalsWithEpsilon(p0, eps) && pb.equalsWithEpsilon(p2, eps)) return 2;
        return -1;
    }
    /**
     * Checks if the pair of p0 and p1 is en edge
     * @param faceIndex
     * @param edge
     * @param faceNormals
     * @param  p0
     * @param  p1
     * @private
     */ _checkEdge(faceIndex, edge, faceNormals, p0, p1) {
        let needToCreateLine;
        if (edge === undefined) needToCreateLine = true;
        else {
            const dotProduct = (0, $ha1VO.Vector3).Dot(faceNormals[faceIndex], faceNormals[edge]);
            needToCreateLine = dotProduct < this._epsilon;
        }
        if (needToCreateLine) this.createLine(p0, p1, this._linesPositions.length / 3);
    }
    /**
     * push line into the position, normal and index buffer
     * @param p0
     * @param p1
     * @param offset
     * @protected
     */ // eslint-disable-next-line @typescript-eslint/naming-convention
    createLine(p0, p1, offset) {
        // Positions
        this._linesPositions.push(p0.x, p0.y, p0.z, p0.x, p0.y, p0.z, p1.x, p1.y, p1.z, p1.x, p1.y, p1.z);
        // Normals
        this._linesNormals.push(p1.x, p1.y, p1.z, -1, p1.x, p1.y, p1.z, 1, p0.x, p0.y, p0.z, -1, p0.x, p0.y, p0.z, 1);
        // Indices
        this._linesIndices.push(offset, offset + 1, offset + 2, offset, offset + 2, offset + 3);
    }
    /**
     * See https://playground.babylonjs.com/#R3JR6V#1 for a visual display of the algorithm
     * @param edgePoints
     * @param indexTriangle
     * @param indices
     * @param remapVertexIndices
     */ _tessellateTriangle(edgePoints, indexTriangle, indices, remapVertexIndices) {
        const makePointList = (edgePoints, pointIndices, firstIndex)=>{
            if (firstIndex >= 0) pointIndices.push(firstIndex);
            for(let i = 0; i < edgePoints.length; ++i)pointIndices.push(edgePoints[i][0]);
        };
        let startEdge = 0;
        if (edgePoints[1].length >= edgePoints[0].length && edgePoints[1].length >= edgePoints[2].length) startEdge = 1;
        else if (edgePoints[2].length >= edgePoints[0].length && edgePoints[2].length >= edgePoints[1].length) startEdge = 2;
        for(let e = 0; e < 3; ++e)if (e === startEdge) edgePoints[e].sort((a, b)=>a[1] < b[1] ? -1 : a[1] > b[1] ? 1 : 0);
        else edgePoints[e].sort((a, b)=>a[1] > b[1] ? -1 : a[1] < b[1] ? 1 : 0);
        const mainPointIndices = [], otherPointIndices = [];
        makePointList(edgePoints[startEdge], mainPointIndices, -1);
        const numMainPoints = mainPointIndices.length;
        for(let i = startEdge + 2; i >= startEdge + 1; --i)makePointList(edgePoints[i % 3], otherPointIndices, i !== startEdge + 2 ? remapVertexIndices[indices[indexTriangle + (i + 1) % 3]] : -1);
        const numOtherPoints = otherPointIndices.length;
        const idxMain = 0;
        const idxOther = 0;
        indices.push(remapVertexIndices[indices[indexTriangle + startEdge]], mainPointIndices[0], otherPointIndices[0]);
        indices.push(remapVertexIndices[indices[indexTriangle + (startEdge + 1) % 3]], otherPointIndices[numOtherPoints - 1], mainPointIndices[numMainPoints - 1]);
        const bucketIsMain = numMainPoints <= numOtherPoints;
        const bucketStep = bucketIsMain ? numMainPoints : numOtherPoints;
        const bucketLimit = bucketIsMain ? numOtherPoints : numMainPoints;
        const bucketIdxLimit = bucketIsMain ? numMainPoints - 1 : numOtherPoints - 1;
        const winding = bucketIsMain ? 0 : 1;
        let numTris = numMainPoints + numOtherPoints - 2;
        let bucketIdx = bucketIsMain ? idxMain : idxOther;
        let nbucketIdx = bucketIsMain ? idxOther : idxMain;
        const bucketPoints = bucketIsMain ? mainPointIndices : otherPointIndices;
        const nbucketPoints = bucketIsMain ? otherPointIndices : mainPointIndices;
        let bucket = 0;
        while(numTris-- > 0){
            if (winding) indices.push(bucketPoints[bucketIdx], nbucketPoints[nbucketIdx]);
            else indices.push(nbucketPoints[nbucketIdx], bucketPoints[bucketIdx]);
            bucket += bucketStep;
            let lastIdx;
            if (bucket >= bucketLimit && bucketIdx < bucketIdxLimit) {
                lastIdx = bucketPoints[++bucketIdx];
                bucket -= bucketLimit;
            } else lastIdx = nbucketPoints[++nbucketIdx];
            indices.push(lastIdx);
        }
        indices[indexTriangle + 0] = indices[indices.length - 3];
        indices[indexTriangle + 1] = indices[indices.length - 2];
        indices[indexTriangle + 2] = indices[indices.length - 1];
        indices.length = indices.length - 3;
    }
    _generateEdgesLinesAlternate() {
        const positions = this._source.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        let indices = this._source.getIndices();
        if (!indices || !positions) return;
        if (!Array.isArray(indices)) indices = Array.from(indices);
        /**
         * Find all vertices that are at the same location (with an epsilon) and remapp them on the same vertex
         */ const useFastVertexMerger = this._options?.useFastVertexMerger ?? true;
        const epsVertexMerge = useFastVertexMerger ? Math.round(-Math.log(this._options?.epsilonVertexMerge ?? 1e-6) / Math.log(10)) : this._options?.epsilonVertexMerge ?? 1e-6;
        const remapVertexIndices = [];
        const uniquePositions = []; // list of unique index of vertices - needed for tessellation
        if (useFastVertexMerger) {
            const mapVertices = {};
            for(let v1 = 0; v1 < positions.length; v1 += 3){
                const x1 = positions[v1 + 0], y1 = positions[v1 + 1], z1 = positions[v1 + 2];
                const key = x1.toFixed(epsVertexMerge) + "|" + y1.toFixed(epsVertexMerge) + "|" + z1.toFixed(epsVertexMerge);
                if (mapVertices[key] !== undefined) remapVertexIndices.push(mapVertices[key]);
                else {
                    const idx = v1 / 3;
                    mapVertices[key] = idx;
                    remapVertexIndices.push(idx);
                    uniquePositions.push(idx);
                }
            }
        } else for(let v1 = 0; v1 < positions.length; v1 += 3){
            const x1 = positions[v1 + 0], y1 = positions[v1 + 1], z1 = positions[v1 + 2];
            let found = false;
            for(let v2 = 0; v2 < v1 && !found; v2 += 3){
                const x2 = positions[v2 + 0], y2 = positions[v2 + 1], z2 = positions[v2 + 2];
                if (Math.abs(x1 - x2) < epsVertexMerge && Math.abs(y1 - y2) < epsVertexMerge && Math.abs(z1 - z2) < epsVertexMerge) {
                    remapVertexIndices.push(v2 / 3);
                    found = true;
                    break;
                }
            }
            if (!found) {
                remapVertexIndices.push(v1 / 3);
                uniquePositions.push(v1 / 3);
            }
        }
        if (this._options?.applyTessellation) {
            /**
             * Tessellate triangles if necessary:
             *
             *               A
             *               +
             *               |\
             *               | \
             *               |  \
             *             E +   \
             *              /|    \
             *             / |     \
             *            /  |      \
             *           +---+-------+ B
             *           D   C
             *
             * For the edges to be rendered correctly, the ABC triangle has to be split into ABE and BCE, else AC is considered to be an edge, whereas only AE should be.
             *
             * The tessellation process looks for the vertices like E that are in-between two other vertices making of an edge and create new triangles as necessary
             */ // First step: collect the triangles to tessellate
            const epsVertexAligned = this._options?.epsilonVertexAligned ?? 1e-6;
            const mustTesselate = []; // liste of triangles that must be tessellated
            for(let index = 0; index < indices.length; index += 3){
                // loop over all triangles
                let triangleToTessellate;
                for(let i = 0; i < 3; ++i){
                    // loop over the 3 edges of the triangle
                    const p0Index = remapVertexIndices[indices[index + i]];
                    const p1Index = remapVertexIndices[indices[index + (i + 1) % 3]];
                    const p2Index = remapVertexIndices[indices[index + (i + 2) % 3]];
                    if (p0Index === p1Index) continue;
                     // degenerated triangle - don't process
                    const p0x = positions[p0Index * 3 + 0], p0y = positions[p0Index * 3 + 1], p0z = positions[p0Index * 3 + 2];
                    const p1x = positions[p1Index * 3 + 0], p1y = positions[p1Index * 3 + 1], p1z = positions[p1Index * 3 + 2];
                    const p0p1 = Math.sqrt((p1x - p0x) * (p1x - p0x) + (p1y - p0y) * (p1y - p0y) + (p1z - p0z) * (p1z - p0z));
                    for(let v = 0; v < uniquePositions.length - 1; v++){
                        // loop over all (unique) vertices and look for the ones that would be in-between p0 and p1
                        const vIndex = uniquePositions[v];
                        if (vIndex === p0Index || vIndex === p1Index || vIndex === p2Index) continue;
                         // don't handle the vertex if it is a vertex of the current triangle
                        const x = positions[vIndex * 3 + 0], y = positions[vIndex * 3 + 1], z = positions[vIndex * 3 + 2];
                        const p0p = Math.sqrt((x - p0x) * (x - p0x) + (y - p0y) * (y - p0y) + (z - p0z) * (z - p0z));
                        const pp1 = Math.sqrt((x - p1x) * (x - p1x) + (y - p1y) * (y - p1y) + (z - p1z) * (z - p1z));
                        if (Math.abs(p0p + pp1 - p0p1) < epsVertexAligned) {
                            // vertices are aligned and p in-between p0 and p1 if distance(p0, p) + distance (p, p1) ~ distance(p0, p1)
                            if (!triangleToTessellate) {
                                triangleToTessellate = {
                                    index: index,
                                    edgesPoints: [
                                        [],
                                        [],
                                        []
                                    ]
                                };
                                mustTesselate.push(triangleToTessellate);
                            }
                            triangleToTessellate.edgesPoints[i].push([
                                vIndex,
                                p0p
                            ]);
                        }
                    }
                }
            }
            // Second step: tesselate the triangles
            for(let t = 0; t < mustTesselate.length; ++t){
                const triangle = mustTesselate[t];
                this._tessellateTriangle(triangle.edgesPoints, triangle.index, indices, remapVertexIndices);
            }
            mustTesselate.length = 0;
        }
        /**
         * Collect the edges to render
         */ const edges = {};
        for(let index = 0; index < indices.length; index += 3){
            let faceNormal;
            for(let i = 0; i < 3; ++i){
                let p0Index = remapVertexIndices[indices[index + i]];
                let p1Index = remapVertexIndices[indices[index + (i + 1) % 3]];
                const p2Index = remapVertexIndices[indices[index + (i + 2) % 3]];
                if (p0Index === p1Index || (p0Index === p2Index || p1Index === p2Index) && this._options?.removeDegeneratedTriangles) continue;
                (0, $ha1VO.TmpVectors).Vector3[0].copyFromFloats(positions[p0Index * 3 + 0], positions[p0Index * 3 + 1], positions[p0Index * 3 + 2]);
                (0, $ha1VO.TmpVectors).Vector3[1].copyFromFloats(positions[p1Index * 3 + 0], positions[p1Index * 3 + 1], positions[p1Index * 3 + 2]);
                (0, $ha1VO.TmpVectors).Vector3[2].copyFromFloats(positions[p2Index * 3 + 0], positions[p2Index * 3 + 1], positions[p2Index * 3 + 2]);
                if (!faceNormal) {
                    (0, $ha1VO.TmpVectors).Vector3[1].subtractToRef((0, $ha1VO.TmpVectors).Vector3[0], (0, $ha1VO.TmpVectors).Vector3[3]);
                    (0, $ha1VO.TmpVectors).Vector3[2].subtractToRef((0, $ha1VO.TmpVectors).Vector3[1], (0, $ha1VO.TmpVectors).Vector3[4]);
                    faceNormal = (0, $ha1VO.Vector3).Cross((0, $ha1VO.TmpVectors).Vector3[3], (0, $ha1VO.TmpVectors).Vector3[4]);
                    faceNormal.normalize();
                }
                if (p0Index > p1Index) {
                    const tmp = p0Index;
                    p0Index = p1Index;
                    p1Index = tmp;
                }
                const key = p0Index + "_" + p1Index;
                const ei = edges[key];
                if (ei) {
                    if (!ei.done) {
                        const dotProduct = (0, $ha1VO.Vector3).Dot(faceNormal, ei.normal);
                        if (dotProduct < this._epsilon) this.createLine((0, $ha1VO.TmpVectors).Vector3[0], (0, $ha1VO.TmpVectors).Vector3[1], this._linesPositions.length / 3);
                        ei.done = true;
                    }
                } else edges[key] = {
                    normal: faceNormal,
                    done: false,
                    index: index,
                    i: i
                };
            }
        }
        for(const key in edges){
            const ei = edges[key];
            if (!ei.done) {
                // Orphaned edge - we must display it
                const p0Index = remapVertexIndices[indices[ei.index + ei.i]];
                const p1Index = remapVertexIndices[indices[ei.index + (ei.i + 1) % 3]];
                (0, $ha1VO.TmpVectors).Vector3[0].copyFromFloats(positions[p0Index * 3 + 0], positions[p0Index * 3 + 1], positions[p0Index * 3 + 2]);
                (0, $ha1VO.TmpVectors).Vector3[1].copyFromFloats(positions[p1Index * 3 + 0], positions[p1Index * 3 + 1], positions[p1Index * 3 + 2]);
                this.createLine((0, $ha1VO.TmpVectors).Vector3[0], (0, $ha1VO.TmpVectors).Vector3[1], this._linesPositions.length / 3);
            }
        }
        /**
         * Merge into a single mesh
         */ const engine = this._source.getScene().getEngine();
        this._buffers[(0, $b4i1f.VertexBuffer).PositionKind] = new (0, $b4i1f.VertexBuffer)(engine, this._linesPositions, (0, $b4i1f.VertexBuffer).PositionKind, false);
        this._buffers[(0, $b4i1f.VertexBuffer).NormalKind] = new (0, $b4i1f.VertexBuffer)(engine, this._linesNormals, (0, $b4i1f.VertexBuffer).NormalKind, false, false, 4);
        this._buffersForInstances[(0, $b4i1f.VertexBuffer).PositionKind] = this._buffers[(0, $b4i1f.VertexBuffer).PositionKind];
        this._buffersForInstances[(0, $b4i1f.VertexBuffer).NormalKind] = this._buffers[(0, $b4i1f.VertexBuffer).NormalKind];
        this._ib = engine.createIndexBuffer(this._linesIndices);
        this._indicesCount = this._linesIndices.length;
    }
    /**
     * Generates lines edges from adjacencjes
     * @private
     */ _generateEdgesLines() {
        const positions = this._source.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        const indices = this._source.getIndices();
        if (!indices || !positions) return;
        // First let's find adjacencies
        const adjacencies = [];
        const faceNormals = [];
        let index;
        let faceAdjacencies;
        // Prepare faces
        for(index = 0; index < indices.length; index += 3){
            faceAdjacencies = new $f35016ab0623318c$var$FaceAdjacencies();
            const p0Index = indices[index];
            const p1Index = indices[index + 1];
            const p2Index = indices[index + 2];
            faceAdjacencies.p0 = new (0, $ha1VO.Vector3)(positions[p0Index * 3], positions[p0Index * 3 + 1], positions[p0Index * 3 + 2]);
            faceAdjacencies.p1 = new (0, $ha1VO.Vector3)(positions[p1Index * 3], positions[p1Index * 3 + 1], positions[p1Index * 3 + 2]);
            faceAdjacencies.p2 = new (0, $ha1VO.Vector3)(positions[p2Index * 3], positions[p2Index * 3 + 1], positions[p2Index * 3 + 2]);
            const faceNormal = (0, $ha1VO.Vector3).Cross(faceAdjacencies.p1.subtract(faceAdjacencies.p0), faceAdjacencies.p2.subtract(faceAdjacencies.p1));
            faceNormal.normalize();
            faceNormals.push(faceNormal);
            adjacencies.push(faceAdjacencies);
        }
        // Scan
        for(index = 0; index < adjacencies.length; index++){
            faceAdjacencies = adjacencies[index];
            for(let otherIndex = index + 1; otherIndex < adjacencies.length; otherIndex++){
                const otherFaceAdjacencies = adjacencies[otherIndex];
                if (faceAdjacencies.edgesConnectedCount === 3) break;
                if (otherFaceAdjacencies.edgesConnectedCount === 3) continue;
                const otherP0 = indices[otherIndex * 3];
                const otherP1 = indices[otherIndex * 3 + 1];
                const otherP2 = indices[otherIndex * 3 + 2];
                for(let edgeIndex = 0; edgeIndex < 3; edgeIndex++){
                    let otherEdgeIndex = 0;
                    if (faceAdjacencies.edges[edgeIndex] !== undefined) continue;
                    switch(edgeIndex){
                        case 0:
                            if (this._checkVerticesInsteadOfIndices) otherEdgeIndex = this._processEdgeForAdjacenciesWithVertices(faceAdjacencies.p0, faceAdjacencies.p1, otherFaceAdjacencies.p0, otherFaceAdjacencies.p1, otherFaceAdjacencies.p2);
                            else otherEdgeIndex = this._processEdgeForAdjacencies(indices[index * 3], indices[index * 3 + 1], otherP0, otherP1, otherP2);
                            break;
                        case 1:
                            if (this._checkVerticesInsteadOfIndices) otherEdgeIndex = this._processEdgeForAdjacenciesWithVertices(faceAdjacencies.p1, faceAdjacencies.p2, otherFaceAdjacencies.p0, otherFaceAdjacencies.p1, otherFaceAdjacencies.p2);
                            else otherEdgeIndex = this._processEdgeForAdjacencies(indices[index * 3 + 1], indices[index * 3 + 2], otherP0, otherP1, otherP2);
                            break;
                        case 2:
                            if (this._checkVerticesInsteadOfIndices) otherEdgeIndex = this._processEdgeForAdjacenciesWithVertices(faceAdjacencies.p2, faceAdjacencies.p0, otherFaceAdjacencies.p0, otherFaceAdjacencies.p1, otherFaceAdjacencies.p2);
                            else otherEdgeIndex = this._processEdgeForAdjacencies(indices[index * 3 + 2], indices[index * 3], otherP0, otherP1, otherP2);
                            break;
                    }
                    if (otherEdgeIndex === -1) continue;
                    faceAdjacencies.edges[edgeIndex] = otherIndex;
                    otherFaceAdjacencies.edges[otherEdgeIndex] = index;
                    faceAdjacencies.edgesConnectedCount++;
                    otherFaceAdjacencies.edgesConnectedCount++;
                    if (faceAdjacencies.edgesConnectedCount === 3) break;
                }
            }
        }
        // Create lines
        for(index = 0; index < adjacencies.length; index++){
            // We need a line when a face has no adjacency on a specific edge or if all the adjacencies has an angle greater than epsilon
            const current = adjacencies[index];
            this._checkEdge(index, current.edges[0], faceNormals, current.p0, current.p1);
            this._checkEdge(index, current.edges[1], faceNormals, current.p1, current.p2);
            this._checkEdge(index, current.edges[2], faceNormals, current.p2, current.p0);
        }
        // Merge into a single mesh
        const engine = this._source.getScene().getEngine();
        this._buffers[(0, $b4i1f.VertexBuffer).PositionKind] = new (0, $b4i1f.VertexBuffer)(engine, this._linesPositions, (0, $b4i1f.VertexBuffer).PositionKind, false);
        this._buffers[(0, $b4i1f.VertexBuffer).NormalKind] = new (0, $b4i1f.VertexBuffer)(engine, this._linesNormals, (0, $b4i1f.VertexBuffer).NormalKind, false, false, 4);
        this._buffersForInstances[(0, $b4i1f.VertexBuffer).PositionKind] = this._buffers[(0, $b4i1f.VertexBuffer).PositionKind];
        this._buffersForInstances[(0, $b4i1f.VertexBuffer).NormalKind] = this._buffers[(0, $b4i1f.VertexBuffer).NormalKind];
        this._ib = engine.createIndexBuffer(this._linesIndices);
        this._indicesCount = this._linesIndices.length;
    }
    /**
     * Checks whether or not the edges renderer is ready to render.
     * @returns true if ready, otherwise false.
     */ isReady() {
        return this._lineShader.isReady(this._source, this._source.hasInstances && this.customInstances.length > 0 || this._source.hasThinInstances);
    }
    /**
     * Renders the edges of the attached mesh,
     */ render() {
        const scene = this._source.getScene();
        const currentDrawWrapper = this._lineShader._getDrawWrapper();
        if (this._drawWrapper) this._lineShader._setDrawWrapper(this._drawWrapper);
        if (!this.isReady() || !scene.activeCamera) {
            this._lineShader._setDrawWrapper(currentDrawWrapper);
            return;
        }
        const hasInstances = this._source.hasInstances && this.customInstances.length > 0;
        const useBuffersWithInstances = hasInstances || this._source.hasThinInstances;
        let instanceCount = 0;
        if (useBuffersWithInstances) {
            this._buffersForInstances["world0"] = this._source.getVertexBuffer("world0");
            this._buffersForInstances["world1"] = this._source.getVertexBuffer("world1");
            this._buffersForInstances["world2"] = this._source.getVertexBuffer("world2");
            this._buffersForInstances["world3"] = this._source.getVertexBuffer("world3");
            if (hasInstances) {
                const instanceStorage = this._source._instanceDataStorage;
                instanceCount = this.customInstances.length;
                if (!instanceStorage.instancesData) {
                    if (!this._source.getScene()._activeMeshesFrozen) this.customInstances.reset();
                    return;
                }
                if (!instanceStorage.isFrozen) {
                    let offset = 0;
                    for(let i = 0; i < instanceCount; ++i){
                        this.customInstances.data[i].copyToArray(instanceStorage.instancesData, offset);
                        offset += 16;
                    }
                    instanceStorage.instancesBuffer.updateDirectly(instanceStorage.instancesData, 0, instanceCount);
                }
            } else instanceCount = this._source.thinInstanceCount;
        }
        const engine = scene.getEngine();
        this._lineShader._preBind();
        if (this._source.edgesColor.a !== 1) engine.setAlphaMode(2);
        else engine.setAlphaMode(0);
        // VBOs
        engine.bindBuffers(useBuffersWithInstances ? this._buffersForInstances : this._buffers, this._ib, this._lineShader.getEffect());
        scene.resetCachedMaterial();
        this._lineShader.setColor4("color", this._source.edgesColor);
        if (scene.activeCamera.mode === (0, $74SKQ.Camera).ORTHOGRAPHIC_CAMERA) this._lineShader.setFloat("width", this._source.edgesWidth / this.edgesWidthScalerForOrthographic);
        else this._lineShader.setFloat("width", this._source.edgesWidth / this.edgesWidthScalerForPerspective);
        this._lineShader.setFloat("aspectRatio", engine.getAspectRatio(scene.activeCamera));
        this._lineShader.bind(this._source.getWorldMatrix());
        // Draw order
        engine.drawElementsType((0, $54229.Material).TriangleFillMode, 0, this._indicesCount, instanceCount);
        this._lineShader.unbind();
        if (useBuffersWithInstances) engine.unbindInstanceAttributes();
        if (!this._source.getScene()._activeMeshesFrozen) this.customInstances.reset();
        this._lineShader._setDrawWrapper(currentDrawWrapper);
    }
}
class $f35016ab0623318c$export$e39ff71048e9ea08 extends $f35016ab0623318c$export$eeed9d9982da57e6 {
    /**
     * This constructor turns off auto generating edges line in Edges Renderer to make it here.
     * @param  source LineMesh used to generate edges
     * @param  epsilon not important (specified angle for edge detection)
     * @param  checkVerticesInsteadOfIndices not important for LineMesh
     */ constructor(source, epsilon = 0.95, checkVerticesInsteadOfIndices = false){
        super(source, epsilon, checkVerticesInsteadOfIndices, false);
        this._generateEdgesLines();
    }
    /**
     * Generate edges for each line in LinesMesh. Every Line should be rendered as edge.
     */ _generateEdgesLines() {
        const positions = this._source.getVerticesData((0, $b4i1f.VertexBuffer).PositionKind);
        const indices = this._source.getIndices();
        if (!indices || !positions) return;
        const p0 = (0, $ha1VO.TmpVectors).Vector3[0];
        const p1 = (0, $ha1VO.TmpVectors).Vector3[1];
        const len = indices.length - 1;
        for(let i = 0, offset = 0; i < len; i += 2, offset += 4){
            (0, $ha1VO.Vector3).FromArrayToRef(positions, 3 * indices[i], p0);
            (0, $ha1VO.Vector3).FromArrayToRef(positions, 3 * indices[i + 1], p1);
            this.createLine(p0, p1, offset);
        }
        // Merge into a single mesh
        const engine = this._source.getScene().getEngine();
        this._buffers[(0, $b4i1f.VertexBuffer).PositionKind] = new (0, $b4i1f.VertexBuffer)(engine, this._linesPositions, (0, $b4i1f.VertexBuffer).PositionKind, false);
        this._buffers[(0, $b4i1f.VertexBuffer).NormalKind] = new (0, $b4i1f.VertexBuffer)(engine, this._linesNormals, (0, $b4i1f.VertexBuffer).NormalKind, false, false, 4);
        this._ib = engine.createIndexBuffer(this._linesIndices);
        this._indicesCount = this._linesIndices.length;
    }
}

});
parcelRegister("lF2ES", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("82O8L");
parcelRequire("4kipo");
parcelRequire("izyqw");
parcelRequire("kg1CD");
const $fc4f7d2ffad4f80b$var$name = "linePixelShader";
const $fc4f7d2ffad4f80b$var$shader = `#include<clipPlaneFragmentDeclaration>
uniform vec4 color;
#ifdef LOGARITHMICDEPTH
#extension GL_EXT_frag_depth : enable
#endif
#include<logDepthDeclaration>
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) {
#define CUSTOM_FRAGMENT_MAIN_BEGIN
#include<logDepthFragment>
#include<clipPlaneFragment>
gl_FragColor=color;
#define CUSTOM_FRAGMENT_MAIN_END
}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$fc4f7d2ffad4f80b$var$name] = $fc4f7d2ffad4f80b$var$shader;
const $fc4f7d2ffad4f80b$export$bdcd9c0562f444d7 = {
    name: $fc4f7d2ffad4f80b$var$name,
    shader: $fc4f7d2ffad4f80b$var$shader
};

});

parcelRegister("1GzDw", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("k3wwH");
parcelRequire("4A4MM");
parcelRequire("4kipo");
parcelRequire("apKdp");
parcelRequire("kqCfW");
parcelRequire("a111f");
const $13a55b5d578563b9$var$name = "lineVertexShader";
const $13a55b5d578563b9$var$shader = `#include<instancesDeclaration>
#include<clipPlaneVertexDeclaration>
attribute vec3 position;attribute vec4 normal;uniform mat4 viewProjection;uniform float width;uniform float aspectRatio;
#include<logDepthDeclaration>
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
#include<instancesVertex>
mat4 worldViewProjection=viewProjection*finalWorld;vec4 viewPosition=worldViewProjection*vec4(position,1.0);vec4 viewPositionNext=worldViewProjection*vec4(normal.xyz,1.0);vec2 currentScreen=viewPosition.xy/viewPosition.w;vec2 nextScreen=viewPositionNext.xy/viewPositionNext.w;currentScreen.x*=aspectRatio;nextScreen.x*=aspectRatio;vec2 dir=normalize(nextScreen-currentScreen);vec2 normalDir=vec2(-dir.y,dir.x);normalDir*=width/2.0;normalDir.x/=aspectRatio;vec4 offset=vec4(normalDir*normal.w,0.0,0.0);gl_Position=viewPosition+offset;
#if defined(CLIPPLANE) || defined(CLIPPLANE2) || defined(CLIPPLANE3) || defined(CLIPPLANE4) || defined(CLIPPLANE5) || defined(CLIPPLANE6)
vec4 worldPos=finalWorld*vec4(position,1.0);
#include<clipPlaneVertex>
#endif
#include<logDepthVertex>
#define CUSTOM_VERTEX_MAIN_END
}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$13a55b5d578563b9$var$name] = $13a55b5d578563b9$var$shader;
const $13a55b5d578563b9$export$82141f82c47f7e68 = {
    name: $13a55b5d578563b9$var$name,
    shader: $13a55b5d578563b9$var$shader
};

});


parcelRegister("fVppw", function(module, exports) {

$parcel$export(module.exports, "PrePassRenderer", () => $b97fe3ee0f5fb378$export$b211103d23883ea6);

var $bBoJN = parcelRequire("bBoJN");

var $dUFYy = parcelRequire("dUFYy");

var $7etnY = parcelRequire("7etnY");

var $54229 = parcelRequire("54229");

var $gXqe5 = parcelRequire("gXqe5");
class $b97fe3ee0f5fb378$export$b211103d23883ea6 {
    /**
     * Indicates if the prepass renderer is generating normals in world space or camera space (default: camera space)
     */ get generateNormalsInWorldSpace() {
        return this._generateNormalsInWorldSpace;
    }
    set generateNormalsInWorldSpace(value) {
        if (this._generateNormalsInWorldSpace === value) return;
        this._generateNormalsInWorldSpace = value;
        this._markAllMaterialsAsPrePassDirty();
    }
    /**
     * Returns the index of a texture in the multi render target texture array.
     * @param type Texture type
     * @returns The index
     */ getIndex(type) {
        return this._textureIndices[type];
    }
    /**
     * How many samples are used for MSAA of the scene render target
     */ get samples() {
        return this.defaultRT.samples;
    }
    set samples(n) {
        this.defaultRT.samples = n;
    }
    /**
     * If set to true (default: false), the depth texture will be cleared with the depth value corresponding to the far plane (1 in normal mode, 0 in reverse depth buffer mode)
     * If set to false, the depth texture is always cleared with 0.
     */ get useSpecificClearForDepthTexture() {
        return this._useSpecificClearForDepthTexture;
    }
    set useSpecificClearForDepthTexture(value) {
        if (this._useSpecificClearForDepthTexture === value) return;
        this._useSpecificClearForDepthTexture = value;
        this._isDirty = true;
    }
    /**
     * @returns the prepass render target for the rendering pass.
     * If we are currently rendering a render target, it returns the PrePassRenderTarget
     * associated with that render target. Otherwise, it returns the scene default PrePassRenderTarget
     */ getRenderTarget() {
        return this._currentTarget;
    }
    /**
     * @internal
     * Managed by the scene component
     * @param prePassRenderTarget
     */ _setRenderTarget(prePassRenderTarget) {
        if (prePassRenderTarget) this._currentTarget = prePassRenderTarget;
        else {
            this._currentTarget = this.defaultRT;
            this._engine.currentRenderPassId = this._scene.activeCamera?.renderPassId ?? this._currentTarget.renderPassId;
        }
    }
    /**
     * Returns true if the currently rendered prePassRenderTarget is the one
     * associated with the scene.
     */ get currentRTisSceneRT() {
        return this._currentTarget === this.defaultRT;
    }
    _refreshGeometryBufferRendererLink() {
        if (!this.doNotUseGeometryRendererFallback) {
            this._geometryBuffer = this._scene.enableGeometryBufferRenderer();
            if (!this._geometryBuffer) {
                // Not supported
                this.doNotUseGeometryRendererFallback = true;
                return;
            }
            this._geometryBuffer._linkPrePassRenderer(this);
        } else {
            if (this._geometryBuffer) this._geometryBuffer._unlinkPrePassRenderer();
            this._geometryBuffer = null;
            this._scene.disableGeometryBufferRenderer();
        }
    }
    /**
     * Indicates if the prepass is enabled
     */ get enabled() {
        return this._enabled;
    }
    /**
     * Instantiates a prepass renderer
     * @param scene The scene
     */ constructor(scene){
        /**
         * To save performance, we can excluded skinned meshes from the prepass
         */ this.excludedSkinnedMesh = [];
        /**
         * Force material to be excluded from the prepass
         * Can be useful when `useGeometryBufferFallback` is set to `true`
         * and you don't want a material to show in the effect.
         */ this.excludedMaterials = [];
        /**
         * Number of textures in the multi render target texture where the scene is directly rendered
         */ this.mrtCount = 0;
        this._mrtTypes = [];
        this._mrtFormats = [];
        this._mrtLayout = [];
        this._mrtNames = [];
        this._textureIndices = [];
        this._generateNormalsInWorldSpace = false;
        this._useSpecificClearForDepthTexture = false;
        this._isDirty = true;
        /**
         * Configuration for prepass effects
         */ this._effectConfigurations = [];
        /**
         * Prevents the PrePassRenderer from using the GeometryBufferRenderer as a fallback
         */ this.doNotUseGeometryRendererFallback = true;
        /**
         * All the render targets generated by prepass
         */ this.renderTargets = [];
        this._clearColor = new (0, $7etnY.Color4)(0, 0, 0, 0);
        this._clearDepthColor = new (0, $7etnY.Color4)(1e8, 0, 0, 1); // "infinity" value - depth in the depth texture is view.z, not a 0..1 value!
        this._enabled = false;
        this._needsCompositionForThisPass = false;
        /**
         * Set to true to disable gamma transform in PrePass.
         * Can be useful in case you already proceed to gamma transform on a material level
         * and your post processes don't need to be in linear color space.
         */ this.disableGammaTransform = false;
        this._scene = scene;
        this._engine = scene.getEngine();
        let type = 0;
        if (this._engine._caps.textureFloat && this._engine._caps.textureFloatLinearFiltering) type = 1;
        else if (this._engine._caps.textureHalfFloat && this._engine._caps.textureHalfFloatLinearFiltering) type = 2;
        for(let i = 0; i < $b97fe3ee0f5fb378$export$b211103d23883ea6.TextureFormats.length; ++i){
            const format = $b97fe3ee0f5fb378$export$b211103d23883ea6.TextureFormats[i].format;
            if ($b97fe3ee0f5fb378$export$b211103d23883ea6.TextureFormats[i].type === 1) {
                $b97fe3ee0f5fb378$export$b211103d23883ea6.TextureFormats[5].type = type;
                if ((format === 6 || format === 7 || format === 5) && !this._engine._caps.supportFloatTexturesResolve) // We don't know in advance if the texture will be used as a resolve target, so we revert to half_float if the extension to resolve full float textures is not supported
                $b97fe3ee0f5fb378$export$b211103d23883ea6.TextureFormats[5].type = 2;
            }
        }
        $b97fe3ee0f5fb378$export$b211103d23883ea6._SceneComponentInitialization(this._scene);
        this.defaultRT = this._createRenderTarget("sceneprePassRT", null);
        this._currentTarget = this.defaultRT;
    }
    /**
     * Creates a new PrePassRenderTarget
     * This should be the only way to instantiate a `PrePassRenderTarget`
     * @param name Name of the `PrePassRenderTarget`
     * @param renderTargetTexture RenderTarget the `PrePassRenderTarget` will be attached to.
     * Can be `null` if the created `PrePassRenderTarget` is attached to the scene (default framebuffer).
     * @internal
     */ _createRenderTarget(name, renderTargetTexture) {
        const rt = new (0, $bBoJN.PrePassRenderTarget)(name, renderTargetTexture, {
            width: this._engine.getRenderWidth(),
            height: this._engine.getRenderHeight()
        }, 0, this._scene, {
            generateMipMaps: false,
            generateStencilBuffer: this._engine.isStencilEnable,
            defaultType: 0,
            types: [],
            drawOnlyOnFirstAttachmentByDefault: true
        });
        this.renderTargets.push(rt);
        if (this._enabled) // The pre-pass renderer is already enabled, so make sure we create the render target with the correct number of textures
        this._update();
        return rt;
    }
    /**
     * Indicates if rendering a prepass is supported
     */ get isSupported() {
        return this._scene.getEngine().getCaps().drawBuffersExtension;
    }
    /**
     * Sets the proper output textures to draw in the engine.
     * @param effect The effect that is drawn. It can be or not be compatible with drawing to several output textures.
     * @param subMesh Submesh on which the effect is applied
     */ bindAttachmentsForEffect(effect, subMesh) {
        const material = subMesh.getMaterial();
        const isPrePassCapable = material && material.isPrePassCapable;
        const excluded = material && this.excludedMaterials.indexOf(material) !== -1;
        if (this.enabled && this._currentTarget.enabled) {
            if (effect._multiTarget && isPrePassCapable && !excluded) this._engine.bindAttachments(this._multiRenderAttachments);
            else {
                if (this._engine._currentRenderTarget) this._engine.bindAttachments(this._defaultAttachments);
                else this._engine.restoreSingleAttachment();
                if (this._geometryBuffer && this.currentRTisSceneRT && !excluded) this._geometryBuffer.renderList.push(subMesh.getRenderingMesh());
            }
        }
    }
    _reinitializeAttachments() {
        const multiRenderLayout = [];
        const clearLayout = [
            false
        ];
        const clearDepthLayout = [
            false
        ];
        const defaultLayout = [
            true
        ];
        for(let i = 0; i < this.mrtCount; i++){
            multiRenderLayout.push(true);
            if (i > 0) {
                if (this._useSpecificClearForDepthTexture && this._mrtLayout[i] === 5) {
                    clearLayout.push(false);
                    clearDepthLayout.push(true);
                } else {
                    clearLayout.push(true);
                    clearDepthLayout.push(false);
                }
                defaultLayout.push(false);
            }
        }
        this._multiRenderAttachments = this._engine.buildTextureLayout(multiRenderLayout);
        this._clearAttachments = this._engine.buildTextureLayout(clearLayout);
        this._clearDepthAttachments = this._engine.buildTextureLayout(clearDepthLayout);
        this._defaultAttachments = this._engine.buildTextureLayout(defaultLayout);
    }
    _resetLayout() {
        for(let i = 0; i < $b97fe3ee0f5fb378$export$b211103d23883ea6.TextureFormats.length; i++)this._textureIndices[$b97fe3ee0f5fb378$export$b211103d23883ea6.TextureFormats[i].purpose] = -1;
        this._textureIndices[4] = 0;
        this._mrtLayout = [
            4
        ];
        this._mrtTypes = [
            $b97fe3ee0f5fb378$export$b211103d23883ea6.TextureFormats[4].type
        ];
        this._mrtFormats = [
            $b97fe3ee0f5fb378$export$b211103d23883ea6.TextureFormats[4].format
        ];
        this._mrtNames = [
            $b97fe3ee0f5fb378$export$b211103d23883ea6.TextureFormats[4].name
        ];
        this.mrtCount = 1;
    }
    _updateGeometryBufferLayout() {
        this._refreshGeometryBufferRendererLink();
        if (this._geometryBuffer) {
            this._geometryBuffer._resetLayout();
            const texturesActivated = [];
            for(let i = 0; i < this._mrtLayout.length; i++)texturesActivated.push(false);
            this._geometryBuffer._linkInternalTexture(this.defaultRT.getInternalTexture());
            const matches = [
                {
                    prePassConstant: 5,
                    geometryBufferConstant: (0, $gXqe5.GeometryBufferRenderer).DEPTH_TEXTURE_TYPE
                },
                {
                    prePassConstant: 6,
                    geometryBufferConstant: (0, $gXqe5.GeometryBufferRenderer).NORMAL_TEXTURE_TYPE
                },
                {
                    prePassConstant: 1,
                    geometryBufferConstant: (0, $gXqe5.GeometryBufferRenderer).POSITION_TEXTURE_TYPE
                },
                {
                    prePassConstant: 3,
                    geometryBufferConstant: (0, $gXqe5.GeometryBufferRenderer).REFLECTIVITY_TEXTURE_TYPE
                },
                {
                    prePassConstant: 2,
                    geometryBufferConstant: (0, $gXqe5.GeometryBufferRenderer).VELOCITY_TEXTURE_TYPE
                }
            ];
            // replace textures in the geometryBuffer RT
            for(let i = 0; i < matches.length; i++){
                const index = this._mrtLayout.indexOf(matches[i].prePassConstant);
                if (index !== -1) {
                    this._geometryBuffer._forceTextureType(matches[i].geometryBufferConstant, index);
                    texturesActivated[index] = true;
                }
            }
            this._geometryBuffer._setAttachments(this._engine.buildTextureLayout(texturesActivated));
        }
    }
    /**
     * Restores attachments for single texture draw.
     */ restoreAttachments() {
        if (this.enabled && this._currentTarget.enabled && this._defaultAttachments) {
            if (this._engine._currentRenderTarget) this._engine.bindAttachments(this._defaultAttachments);
            else this._engine.restoreSingleAttachment();
        }
    }
    /**
     * @internal
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _beforeDraw(camera, faceIndex, layer) {
        // const previousEnabled = this._enabled && this._currentTarget.enabled;
        if (this._isDirty) this._update();
        if (!this._enabled || !this._currentTarget.enabled) return;
        if (this._geometryBuffer) this._geometryBuffer.renderList = [];
        this._setupOutputForThisPass(this._currentTarget, camera);
    }
    _prepareFrame(prePassRenderTarget, faceIndex, layer) {
        if (prePassRenderTarget.renderTargetTexture) prePassRenderTarget.renderTargetTexture._prepareFrame(this._scene, faceIndex, layer, prePassRenderTarget.renderTargetTexture.useCameraPostProcesses);
        else if (this._postProcessesSourceForThisPass.length) this._scene.postProcessManager._prepareFrame();
        else this._engine.restoreDefaultFramebuffer();
    }
    /**
     * Sets an intermediary texture between prepass and postprocesses. This texture
     * will be used as input for post processes
     * @param rt The render target texture to use
     * @returns true if there are postprocesses that will use this texture,
     * false if there is no postprocesses - and the function has no effect
     */ setCustomOutput(rt) {
        const firstPP = this._postProcessesSourceForThisPass[0];
        if (!firstPP) return false;
        firstPP.inputTexture = rt.renderTarget;
        return true;
    }
    _renderPostProcesses(prePassRenderTarget, faceIndex) {
        const firstPP = this._postProcessesSourceForThisPass[0];
        const outputTexture = firstPP ? firstPP.inputTexture : prePassRenderTarget.renderTargetTexture ? prePassRenderTarget.renderTargetTexture.renderTarget : null;
        // Build post process chain for this prepass post draw
        let postProcessChain = this._currentTarget._beforeCompositionPostProcesses;
        if (this._needsCompositionForThisPass) postProcessChain = postProcessChain.concat([
            this._currentTarget.imageProcessingPostProcess
        ]);
        // Activates and renders the chain
        if (postProcessChain.length) {
            this._scene.postProcessManager._prepareFrame(this._currentTarget.renderTarget?.texture, postProcessChain);
            this._scene.postProcessManager.directRender(postProcessChain, outputTexture, false, faceIndex);
        }
    }
    /**
     * @internal
     */ _afterDraw(faceIndex, layer) {
        if (this._enabled && this._currentTarget.enabled) {
            this._prepareFrame(this._currentTarget, faceIndex, layer);
            this._renderPostProcesses(this._currentTarget, faceIndex);
        }
    }
    /**
     * Clears the current prepass render target (in the sense of settings pixels to the scene clear color value)
     * @internal
     */ _clear() {
        if (this._enabled && this._currentTarget.enabled) {
            this._bindFrameBuffer();
            // Clearing other attachment with 0 on all other attachments
            this._engine.bindAttachments(this._clearAttachments);
            this._engine.clear(this._clearColor, true, false, false);
            if (this._useSpecificClearForDepthTexture) {
                this._engine.bindAttachments(this._clearDepthAttachments);
                this._engine.clear(this._clearDepthColor, true, false, false);
            }
            // Regular clear color with the scene clear color of the 1st attachment
            this._engine.bindAttachments(this._defaultAttachments);
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _bindFrameBuffer() {
        if (this._enabled && this._currentTarget.enabled) {
            this._currentTarget._checkSize();
            const internalTexture = this._currentTarget.renderTarget;
            if (internalTexture) this._engine.bindFramebuffer(internalTexture);
        }
    }
    _setEnabled(enabled) {
        this._enabled = enabled;
    }
    _setRenderTargetEnabled(prePassRenderTarget, enabled) {
        prePassRenderTarget.enabled = enabled;
        if (!enabled) this._unlinkInternalTexture(prePassRenderTarget);
    }
    /**
     * Adds an effect configuration to the prepass render target.
     * If an effect has already been added, it won't add it twice and will return the configuration
     * already present.
     * @param cfg the effect configuration
     * @returns the effect configuration now used by the prepass
     */ addEffectConfiguration(cfg) {
        // Do not add twice
        for(let i = 0; i < this._effectConfigurations.length; i++){
            if (this._effectConfigurations[i].name === cfg.name) return this._effectConfigurations[i];
        }
        this._effectConfigurations.push(cfg);
        return cfg;
    }
    /**
     * Retrieves an effect configuration by name
     * @param name the name of the effect configuration
     * @returns the effect configuration, or null if not present
     */ getEffectConfiguration(name) {
        for(let i = 0; i < this._effectConfigurations.length; i++){
            if (this._effectConfigurations[i].name === name) return this._effectConfigurations[i];
        }
        return null;
    }
    _enable() {
        const previousMrtCount = this.mrtCount;
        for(let i = 0; i < this._effectConfigurations.length; i++)if (this._effectConfigurations[i].enabled) this._enableTextures(this._effectConfigurations[i].texturesRequired);
        for(let i = 0; i < this.renderTargets.length; i++){
            if (this.mrtCount !== previousMrtCount || this.renderTargets[i].count !== this.mrtCount) this.renderTargets[i].updateCount(this.mrtCount, {
                types: this._mrtTypes,
                formats: this._mrtFormats
            }, this._mrtNames.concat("prePass_DepthBuffer"));
            this.renderTargets[i]._resetPostProcessChain();
            for(let j = 0; j < this._effectConfigurations.length; j++)if (this._effectConfigurations[j].enabled) {
                // TODO : subsurface scattering has 1 scene-wide effect configuration
                // solution : do not stock postProcess on effectConfiguration, but in the prepassRenderTarget (hashmap configuration => postProcess)
                // And call createPostProcess whenever the post process does not exist in the RT
                if (!this._effectConfigurations[j].postProcess && this._effectConfigurations[j].createPostProcess) this._effectConfigurations[j].createPostProcess();
                if (this._effectConfigurations[j].postProcess) this.renderTargets[i]._beforeCompositionPostProcesses.push(this._effectConfigurations[j].postProcess);
            }
        }
        this._reinitializeAttachments();
        this._setEnabled(true);
        this._updateGeometryBufferLayout();
    }
    _disable() {
        this._setEnabled(false);
        for(let i = 0; i < this.renderTargets.length; i++)this._setRenderTargetEnabled(this.renderTargets[i], false);
        this._resetLayout();
        for(let i = 0; i < this._effectConfigurations.length; i++)this._effectConfigurations[i].enabled = false;
    }
    _getPostProcessesSource(prePassRenderTarget, camera) {
        if (camera) return camera._postProcesses;
        else if (prePassRenderTarget.renderTargetTexture) {
            if (prePassRenderTarget.renderTargetTexture.useCameraPostProcesses) {
                const camera = prePassRenderTarget.renderTargetTexture.activeCamera ? prePassRenderTarget.renderTargetTexture.activeCamera : this._scene.activeCamera;
                return camera ? camera._postProcesses : [];
            } else if (prePassRenderTarget.renderTargetTexture.postProcesses) return prePassRenderTarget.renderTargetTexture.postProcesses;
            else return [];
        } else return this._scene.activeCamera ? this._scene.activeCamera._postProcesses : [];
    }
    _setupOutputForThisPass(prePassRenderTarget, camera) {
        // Order is : draw ===> prePassRenderTarget._postProcesses ==> ipp ==> camera._postProcesses
        const secondaryCamera = camera && this._scene.activeCameras && !!this._scene.activeCameras.length && this._scene.activeCameras.indexOf(camera) !== 0;
        this._postProcessesSourceForThisPass = this._getPostProcessesSource(prePassRenderTarget, camera);
        this._postProcessesSourceForThisPass = this._postProcessesSourceForThisPass.filter((pp)=>{
            return pp != null;
        });
        this._scene.autoClear = true;
        const cameraHasImageProcessing = this._hasImageProcessing(this._postProcessesSourceForThisPass);
        this._needsCompositionForThisPass = !cameraHasImageProcessing && !this.disableGammaTransform && this._needsImageProcessing() && !secondaryCamera;
        const firstCameraPP = this._getFirstPostProcess(this._postProcessesSourceForThisPass);
        const firstPrePassPP = prePassRenderTarget._beforeCompositionPostProcesses && prePassRenderTarget._beforeCompositionPostProcesses[0];
        let firstPP = null;
        // Setting the scene-wide post process configuration
        this._scene.imageProcessingConfiguration.applyByPostProcess = this._needsCompositionForThisPass || cameraHasImageProcessing;
        // Create composition effect if needed
        if (this._needsCompositionForThisPass && !prePassRenderTarget.imageProcessingPostProcess) prePassRenderTarget._createCompositionEffect();
        // Setting the prePassRenderTarget as input texture of the first PP
        if (firstPrePassPP) firstPP = firstPrePassPP;
        else if (this._needsCompositionForThisPass) firstPP = prePassRenderTarget.imageProcessingPostProcess;
        else if (firstCameraPP) firstPP = firstCameraPP;
        this._bindFrameBuffer();
        this._linkInternalTexture(prePassRenderTarget, firstPP);
    }
    _linkInternalTexture(prePassRenderTarget, postProcess) {
        if (postProcess) {
            postProcess.autoClear = false;
            postProcess.inputTexture = prePassRenderTarget.renderTarget;
        }
        if (prePassRenderTarget._outputPostProcess !== postProcess) {
            if (prePassRenderTarget._outputPostProcess) this._unlinkInternalTexture(prePassRenderTarget);
            prePassRenderTarget._outputPostProcess = postProcess;
        }
        if (prePassRenderTarget._internalTextureDirty) {
            this._updateGeometryBufferLayout();
            prePassRenderTarget._internalTextureDirty = false;
        }
    }
    /**
     * @internal
     */ _unlinkInternalTexture(prePassRenderTarget) {
        if (prePassRenderTarget._outputPostProcess) {
            prePassRenderTarget._outputPostProcess.autoClear = true;
            prePassRenderTarget._outputPostProcess.restoreDefaultInputTexture();
            prePassRenderTarget._outputPostProcess = null;
        }
    }
    _needsImageProcessing() {
        for(let i = 0; i < this._effectConfigurations.length; i++){
            if (this._effectConfigurations[i].enabled && this._effectConfigurations[i].needsImageProcessing) return true;
        }
        return false;
    }
    _hasImageProcessing(postProcesses) {
        let isIPPAlreadyPresent = false;
        if (postProcesses) {
            for(let i = 0; i < postProcesses.length; i++)if (postProcesses[i]?.getClassName() === "ImageProcessingPostProcess") {
                isIPPAlreadyPresent = true;
                break;
            }
        }
        return isIPPAlreadyPresent;
    }
    /**
     * Internal, gets the first post proces.
     * @param postProcesses
     * @returns the first post process to be run on this camera.
     */ _getFirstPostProcess(postProcesses) {
        for(let ppIndex = 0; ppIndex < postProcesses.length; ppIndex++){
            if (postProcesses[ppIndex] !== null) return postProcesses[ppIndex];
        }
        return null;
    }
    /**
     * Marks the prepass renderer as dirty, triggering a check if the prepass is necessary for the next rendering.
     */ markAsDirty() {
        this._isDirty = true;
    }
    /**
     * Enables a texture on the MultiRenderTarget for prepass
     * @param types
     */ _enableTextures(types) {
        // For velocity : enable storage of previous matrices for instances
        this._scene.needsPreviousWorldMatrices = false;
        for(let i = 0; i < types.length; i++){
            const type = types[i];
            if (this._textureIndices[type] === -1) {
                this._textureIndices[type] = this._mrtLayout.length;
                this._mrtLayout.push(type);
                this._mrtTypes.push($b97fe3ee0f5fb378$export$b211103d23883ea6.TextureFormats[type].type);
                this._mrtFormats.push($b97fe3ee0f5fb378$export$b211103d23883ea6.TextureFormats[type].format);
                this._mrtNames.push($b97fe3ee0f5fb378$export$b211103d23883ea6.TextureFormats[type].name);
                this.mrtCount++;
            }
            if (type === 2) this._scene.needsPreviousWorldMatrices = true;
        }
    }
    /**
     * Makes sure that the prepass renderer is up to date if it has been dirtified.
     */ update() {
        if (this._isDirty) this._update();
    }
    _update() {
        this._disable();
        let enablePrePass = false;
        this._scene.imageProcessingConfiguration.applyByPostProcess = false;
        if (this._scene._depthPeelingRenderer && this._scene.useOrderIndependentTransparency) {
            this._scene._depthPeelingRenderer.setPrePassRenderer(this);
            enablePrePass = true;
        }
        for(let i = 0; i < this._scene.materials.length; i++)if (this._scene.materials[i].setPrePassRenderer(this)) enablePrePass = true;
        if (enablePrePass) this._setRenderTargetEnabled(this.defaultRT, true);
        let postProcesses;
        for(let i = 0; i < this.renderTargets.length; i++){
            if (this.renderTargets[i].renderTargetTexture) postProcesses = this._getPostProcessesSource(this.renderTargets[i]);
            else {
                const camera = this._scene.activeCamera;
                if (!camera) continue;
                postProcesses = camera._postProcesses;
            }
            if (!postProcesses) continue;
            postProcesses = postProcesses.filter((pp)=>{
                return pp != null;
            });
            if (postProcesses) {
                for(let j = 0; j < postProcesses.length; j++)if (postProcesses[j].setPrePassRenderer(this)) {
                    this._setRenderTargetEnabled(this.renderTargets[i], true);
                    enablePrePass = true;
                }
                if (this._hasImageProcessing(postProcesses)) this._scene.imageProcessingConfiguration.applyByPostProcess = true;
            }
        }
        this._markAllMaterialsAsPrePassDirty();
        this._isDirty = false;
        if (enablePrePass) this._enable();
    }
    _markAllMaterialsAsPrePassDirty() {
        const materials = this._scene.materials;
        for(let i = 0; i < materials.length; i++)materials[i].markAsDirty((0, $54229.Material).PrePassDirtyFlag);
    }
    /**
     * Disposes the prepass renderer.
     */ dispose() {
        for(let i = this.renderTargets.length - 1; i >= 0; i--)this.renderTargets[i].dispose();
        for(let i = 0; i < this._effectConfigurations.length; i++)if (this._effectConfigurations[i].dispose) this._effectConfigurations[i].dispose();
    }
}
/**
 * @internal
 */ $b97fe3ee0f5fb378$export$b211103d23883ea6._SceneComponentInitialization = (_)=>{
    throw (0, $dUFYy._WarnImport)("PrePassRendererSceneComponent");
};
/**
 * Describes the types and formats of the textures used by the pre-pass renderer
 */ $b97fe3ee0f5fb378$export$b211103d23883ea6.TextureFormats = [
    {
        purpose: 0,
        type: 2,
        format: 5,
        name: "prePass_Irradiance"
    },
    {
        purpose: 1,
        type: 2,
        format: 5,
        name: "prePass_Position"
    },
    {
        purpose: 2,
        type: 0,
        format: 5,
        name: "prePass_Velocity"
    },
    {
        purpose: 3,
        type: 0,
        format: 5,
        name: "prePass_Reflectivity"
    },
    {
        purpose: 4,
        type: 2,
        format: 5,
        name: "prePass_Color"
    },
    {
        purpose: 5,
        type: 1,
        format: 6,
        name: "prePass_Depth"
    },
    {
        purpose: 6,
        type: 2,
        format: 5,
        name: "prePass_Normal"
    },
    {
        purpose: 7,
        type: 0,
        format: 5,
        name: "prePass_Albedo"
    }
];

});
parcelRegister("bBoJN", function(module, exports) {

$parcel$export(module.exports, "PrePassRenderTarget", () => $872656c79ebd68ab$export$b41e293af8980c02);

var $3TXsv = parcelRequire("3TXsv");

var $ecirA = parcelRequire("ecirA");
class $872656c79ebd68ab$export$b41e293af8980c02 extends (0, $3TXsv.MultiRenderTarget) {
    constructor(name, renderTargetTexture, size, count, scene, options){
        super(name, size, count, scene, options);
        /**
         * @internal
         */ this._beforeCompositionPostProcesses = [];
        /**
         * @internal
         */ this._internalTextureDirty = false;
        /**
         * Is this render target enabled for prepass rendering
         */ this.enabled = false;
        /**
         * Render target associated with this prePassRenderTarget
         * If this is `null`, it means this prePassRenderTarget is associated with the scene
         */ this.renderTargetTexture = null;
        this.renderTargetTexture = renderTargetTexture;
    }
    /**
     * Creates a composition effect for this RT
     * @internal
     */ _createCompositionEffect() {
        this.imageProcessingPostProcess = new (0, $ecirA.ImageProcessingPostProcess)("prePassComposition", 1, null, undefined, this._engine);
        this.imageProcessingPostProcess._updateParameters();
    }
    /**
     * Checks that the size of this RT is still adapted to the desired render size.
     * @internal
     */ _checkSize() {
        const requiredWidth = this._engine.getRenderWidth(true);
        const requiredHeight = this._engine.getRenderHeight(true);
        const width = this.getRenderWidth();
        const height = this.getRenderHeight();
        if (width !== requiredWidth || height !== requiredHeight) {
            this.resize({
                width: requiredWidth,
                height: requiredHeight
            });
            this._internalTextureDirty = true;
        }
    }
    /**
     * Changes the number of render targets in this MRT
     * Be careful as it will recreate all the data in the new texture.
     * @param count new texture count
     * @param options Specifies texture types and sampling modes for new textures
     * @param textureNames Specifies the names of the textures (optional)
     */ updateCount(count, options, textureNames) {
        super.updateCount(count, options, textureNames);
        this._internalTextureDirty = true;
    }
    /**
     * Resets the post processes chains applied to this RT.
     * @internal
     */ _resetPostProcessChain() {
        this._beforeCompositionPostProcesses.length = 0;
    }
    /**
     * Diposes this render target
     */ dispose() {
        const scene = this._scene;
        super.dispose();
        if (scene && scene.prePassRenderer) {
            const index = scene.prePassRenderer.renderTargets.indexOf(this);
            if (index !== -1) scene.prePassRenderer.renderTargets.splice(index, 1);
        }
        if (this.imageProcessingPostProcess) this.imageProcessingPostProcess.dispose();
        if (this.renderTargetTexture) this.renderTargetTexture._prePassRenderTarget = null;
        if (this._outputPostProcess) {
            this._outputPostProcess.autoClear = true;
            this._outputPostProcess.restoreDefaultInputTexture();
        }
    }
}

});


parcelRegister("46Req", function(module, exports) {

$parcel$export(module.exports, "PrePassRendererSceneComponent", () => $2fe103ad296d9f2a$export$41856413c14c1264);

var $gmbCk = parcelRequire("gmbCk");

var $bv05l = parcelRequire("bv05l");

var $fVppw = parcelRequire("fVppw");

var $kVtWi = parcelRequire("kVtWi");
Object.defineProperty((0, $gmbCk.Scene).prototype, "prePassRenderer", {
    get: function() {
        return this._prePassRenderer;
    },
    set: function(value) {
        if (value && value.isSupported) this._prePassRenderer = value;
    },
    enumerable: true,
    configurable: true
});
(0, $gmbCk.Scene).prototype.enablePrePassRenderer = function() {
    if (this._prePassRenderer) return this._prePassRenderer;
    this._prePassRenderer = new (0, $fVppw.PrePassRenderer)(this);
    if (!this._prePassRenderer.isSupported) {
        this._prePassRenderer = null;
        (0, $kVtWi.Logger).Error("PrePassRenderer needs WebGL 2 support.\nMaybe you tried to use the following features that need the PrePassRenderer :\n + Subsurface Scattering");
    }
    return this._prePassRenderer;
};
(0, $gmbCk.Scene).prototype.disablePrePassRenderer = function() {
    if (!this._prePassRenderer) return;
    this._prePassRenderer.dispose();
    this._prePassRenderer = null;
};
class $2fe103ad296d9f2a$export$41856413c14c1264 {
    /**
     * Creates a new instance of the component for the given scene
     * @param scene Defines the scene to register the component in
     */ constructor(scene){
        /**
         * The component name helpful to identify the component in the list of scene components.
         */ this.name = (0, $bv05l.SceneComponentConstants).NAME_PREPASSRENDERER;
        this.scene = scene;
    }
    /**
     * Registers the component in a given scene
     */ register() {
        this.scene._beforeCameraDrawStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_BEFORECAMERADRAW_PREPASS, this, this._beforeCameraDraw);
        this.scene._afterCameraDrawStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_AFTERCAMERADRAW_PREPASS, this, this._afterCameraDraw);
        this.scene._beforeRenderTargetDrawStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_BEFORERENDERTARGETDRAW_PREPASS, this, this._beforeRenderTargetDraw);
        this.scene._afterRenderTargetDrawStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_AFTERCAMERADRAW_PREPASS, this, this._afterRenderTargetDraw);
        this.scene._beforeClearStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_BEFORECLEAR_PREPASS, this, this._beforeClearStage);
        this.scene._beforeRenderTargetClearStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_BEFORERENDERTARGETCLEAR_PREPASS, this, this._beforeRenderTargetClearStage);
        this.scene._beforeRenderingMeshStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_BEFORERENDERINGMESH_PREPASS, this, this._beforeRenderingMeshStage);
        this.scene._afterRenderingMeshStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_AFTERRENDERINGMESH_PREPASS, this, this._afterRenderingMeshStage);
    }
    _beforeRenderTargetDraw(renderTarget, faceIndex, layer) {
        if (this.scene.prePassRenderer && !renderTarget.noPrePassRenderer) {
            this.scene.prePassRenderer._setRenderTarget(renderTarget._prePassRenderTarget);
            this.scene.prePassRenderer._beforeDraw(undefined, faceIndex, layer);
        }
    }
    _afterRenderTargetDraw(renderTarget, faceIndex, layer) {
        if (this.scene.prePassRenderer && !renderTarget.noPrePassRenderer) this.scene.prePassRenderer._afterDraw(faceIndex, layer);
    }
    _beforeRenderTargetClearStage(renderTarget) {
        if (this.scene.prePassRenderer && !renderTarget.noPrePassRenderer) {
            if (!renderTarget._prePassRenderTarget) renderTarget._prePassRenderTarget = this.scene.prePassRenderer._createRenderTarget(renderTarget.name + "_prePassRTT", renderTarget);
            this.scene.prePassRenderer._setRenderTarget(renderTarget._prePassRenderTarget);
            this.scene.prePassRenderer._clear();
        }
    }
    _beforeCameraDraw(camera) {
        if (this.scene.prePassRenderer) {
            this.scene.prePassRenderer._setRenderTarget(null);
            this.scene.prePassRenderer._beforeDraw(camera);
        }
    }
    _afterCameraDraw() {
        if (this.scene.prePassRenderer) this.scene.prePassRenderer._afterDraw();
    }
    _beforeClearStage() {
        if (this.scene.prePassRenderer) {
            this.scene.prePassRenderer._setRenderTarget(null);
            this.scene.prePassRenderer._clear();
        }
    }
    _beforeRenderingMeshStage(mesh, subMesh, batch, effect) {
        if (!effect) return;
        // Render to MRT
        const scene = mesh.getScene();
        if (scene.prePassRenderer) scene.prePassRenderer.bindAttachmentsForEffect(effect, subMesh);
    }
    _afterRenderingMeshStage(mesh) {
        const scene = mesh.getScene();
        if (scene.prePassRenderer) scene.prePassRenderer.restoreAttachments();
    }
    /**
     * Rebuilds the elements related to this component in case of
     * context lost for instance.
     */ rebuild() {
    // Nothing to do for this component
    }
    /**
     * Disposes the component and the associated resources
     */ dispose() {
        this.scene.disablePrePassRenderer();
    }
}
(0, $fVppw.PrePassRenderer)._SceneComponentInitialization = (scene)=>{
    // Register the G Buffer component to the scene.
    let component = scene._getComponent((0, $bv05l.SceneComponentConstants).NAME_PREPASSRENDERER);
    if (!component) {
        component = new $2fe103ad296d9f2a$export$41856413c14c1264(scene);
        scene._addComponent(component);
    }
};

});

parcelRegister("4dCCN", function(module, exports) {

$parcel$export(module.exports, "SubSurfaceSceneComponent", () => $312656682f437f65$export$17698a48528dc572);

var $gmbCk = parcelRequire("gmbCk");

var $bv05l = parcelRequire("bv05l");

var $bNiOX = parcelRequire("bNiOX");

var $5Tqba = parcelRequire("5Tqba");

var $7etnY = parcelRequire("7etnY");
// Adds the parser to the scene parsers.
(0, $5Tqba.AbstractScene).AddParser((0, $bv05l.SceneComponentConstants).NAME_SUBSURFACE, (parsedData, scene)=>{
    // Diffusion profiles
    if (parsedData.ssDiffusionProfileColors !== undefined && parsedData.ssDiffusionProfileColors !== null) {
        scene.enableSubSurfaceForPrePass();
        if (scene.subSurfaceConfiguration) for(let index = 0, cache = parsedData.ssDiffusionProfileColors.length; index < cache; index++){
            const color = parsedData.ssDiffusionProfileColors[index];
            scene.subSurfaceConfiguration.addDiffusionProfile(new (0, $7etnY.Color3)(color.r, color.g, color.b));
        }
    }
});
Object.defineProperty((0, $gmbCk.Scene).prototype, "subSurfaceConfiguration", {
    get: function() {
        return this._subSurfaceConfiguration;
    },
    set: function(value) {
        if (value) {
            if (this.enablePrePassRenderer()) this._subSurfaceConfiguration = value;
        }
    },
    enumerable: true,
    configurable: true
});
(0, $gmbCk.Scene).prototype.enableSubSurfaceForPrePass = function() {
    if (this._subSurfaceConfiguration) return this._subSurfaceConfiguration;
    const prePassRenderer = this.enablePrePassRenderer();
    if (prePassRenderer) {
        this._subSurfaceConfiguration = new (0, $bNiOX.SubSurfaceConfiguration)(this);
        prePassRenderer.addEffectConfiguration(this._subSurfaceConfiguration);
        return this._subSurfaceConfiguration;
    }
    return null;
};
(0, $gmbCk.Scene).prototype.disableSubSurfaceForPrePass = function() {
    if (!this._subSurfaceConfiguration) return;
    this._subSurfaceConfiguration.dispose();
    this._subSurfaceConfiguration = null;
};
class $312656682f437f65$export$17698a48528dc572 {
    /**
     * Creates a new instance of the component for the given scene
     * @param scene Defines the scene to register the component in
     */ constructor(scene){
        /**
         * The component name helpful to identify the component in the list of scene components.
         */ this.name = (0, $bv05l.SceneComponentConstants).NAME_PREPASSRENDERER;
        this.scene = scene;
    }
    /**
     * Registers the component in a given scene
     */ register() {}
    /**
     * Serializes the component data to the specified json object
     * @param serializationObject The object to serialize to
     */ serialize(serializationObject) {
        if (!this.scene.subSurfaceConfiguration) return;
        const ssDiffusionProfileColors = this.scene.subSurfaceConfiguration.ssDiffusionProfileColors;
        serializationObject.ssDiffusionProfileColors = [];
        for(let i = 0; i < ssDiffusionProfileColors.length; i++)serializationObject.ssDiffusionProfileColors.push({
            r: ssDiffusionProfileColors[i].r,
            g: ssDiffusionProfileColors[i].g,
            b: ssDiffusionProfileColors[i].b
        });
    }
    /**
     * Adds all the elements from the container to the scene
     */ addFromContainer() {
    // Nothing to do
    }
    /**
     * Removes all the elements in the container from the scene
     */ removeFromContainer() {
        // Make sure nothing will be serialized
        if (!this.scene.prePassRenderer) return;
        if (this.scene.subSurfaceConfiguration) this.scene.subSurfaceConfiguration.clearAllDiffusionProfiles();
    }
    /**
     * Rebuilds the elements related to this component in case of
     * context lost for instance.
     */ rebuild() {
    // Nothing to do for this component
    }
    /**
     * Disposes the component and the associated resources
     */ dispose() {
    // Nothing to do for this component
    }
}
(0, $bNiOX.SubSurfaceConfiguration)._SceneComponentInitialization = (scene)=>{
    // Register the G Buffer component to the scene.
    let component = scene._getComponent((0, $bv05l.SceneComponentConstants).NAME_SUBSURFACE);
    if (!component) {
        component = new $312656682f437f65$export$17698a48528dc572(scene);
        scene._addComponent(component);
    }
};

});
parcelRegister("bNiOX", function(module, exports) {

$parcel$export(module.exports, "SubSurfaceConfiguration", () => $8962dec33201d4ed$export$2414fb33a3a4e32b);

var $kVtWi = parcelRequire("kVtWi");

var $7etnY = parcelRequire("7etnY");

var $cbyNs = parcelRequire("cbyNs");

var $bv05l = parcelRequire("bv05l");

var $dUFYy = parcelRequire("dUFYy");
class $8962dec33201d4ed$export$2414fb33a3a4e32b {
    /**
     * Diffusion profile color for subsurface scattering
     */ get ssDiffusionS() {
        return this._ssDiffusionS;
    }
    /**
     * Diffusion profile max color channel value for subsurface scattering
     */ get ssDiffusionD() {
        return this._ssDiffusionD;
    }
    /**
     * Diffusion profile filter radius for subsurface scattering
     */ get ssFilterRadii() {
        return this._ssFilterRadii;
    }
    /**
     * Builds a subsurface configuration object
     * @param scene The scene
     */ constructor(scene){
        this._ssDiffusionS = [];
        this._ssFilterRadii = [];
        this._ssDiffusionD = [];
        /**
         * Is subsurface enabled
         */ this.enabled = false;
        /**
         * Does the output of this prepass need to go through imageprocessing
         */ this.needsImageProcessing = true;
        /**
         * Name of the configuration
         */ this.name = (0, $bv05l.SceneComponentConstants).NAME_SUBSURFACE;
        /**
         * Diffusion profile colors for subsurface scattering
         * You can add one diffusion color using `addDiffusionProfile` on `scene.prePassRenderer`
         * See ...
         * Note that you can only store up to 5 of them
         */ this.ssDiffusionProfileColors = [];
        /**
         * Defines the ratio real world => scene units.
         * Used for subsurface scattering
         */ this.metersPerUnit = 1;
        /**
         * Textures that should be present in the MRT for this effect to work
         */ this.texturesRequired = [
            5,
            7,
            4,
            0
        ];
        // Adding default diffusion profile
        this.addDiffusionProfile(new (0, $7etnY.Color3)(1, 1, 1));
        this._scene = scene;
        $8962dec33201d4ed$export$2414fb33a3a4e32b._SceneComponentInitialization(this._scene);
    }
    /**
     * Adds a new diffusion profile.
     * Useful for more realistic subsurface scattering on diverse materials.
     * @param color The color of the diffusion profile. Should be the average color of the material.
     * @returns The index of the diffusion profile for the material subsurface configuration
     */ addDiffusionProfile(color) {
        if (this.ssDiffusionD.length >= 5) {
            // We only suppport 5 diffusion profiles
            (0, $kVtWi.Logger).Error("You already reached the maximum number of diffusion profiles.");
            return 0; // default profile
        }
        // Do not add doubles
        for(let i = 0; i < this._ssDiffusionS.length / 3; i++){
            if (this._ssDiffusionS[i * 3] === color.r && this._ssDiffusionS[i * 3 + 1] === color.g && this._ssDiffusionS[i * 3 + 2] === color.b) return i;
        }
        this._ssDiffusionS.push(color.r, color.b, color.g);
        this._ssDiffusionD.push(Math.max(Math.max(color.r, color.b), color.g));
        this._ssFilterRadii.push(this.getDiffusionProfileParameters(color));
        this.ssDiffusionProfileColors.push(color);
        return this._ssDiffusionD.length - 1;
    }
    /**
     * Creates the sss post process
     * @returns The created post process
     */ createPostProcess() {
        this.postProcess = new (0, $cbyNs.SubSurfaceScatteringPostProcess)("subSurfaceScattering", this._scene, 1, null, undefined, this._scene.getEngine());
        this.postProcess.autoClear = false;
        return this.postProcess;
    }
    /**
     * Deletes all diffusion profiles.
     * Note that in order to render subsurface scattering, you should have at least 1 diffusion profile.
     */ clearAllDiffusionProfiles() {
        this._ssDiffusionD = [];
        this._ssDiffusionS = [];
        this._ssFilterRadii = [];
        this.ssDiffusionProfileColors = [];
    }
    /**
     * Disposes this object
     */ dispose() {
        this.clearAllDiffusionProfiles();
        if (this.postProcess) this.postProcess.dispose();
    }
    /**
     * @internal
     * https://zero-radiance.github.io/post/sampling-diffusion/
     *
     * Importance sample the normalized diffuse reflectance profile for the computed value of 's'.
     * ------------------------------------------------------------------------------------
     * R[r, phi, s]   = s * (Exp[-r * s] + Exp[-r * s / 3]) / (8 * Pi * r)
     * PDF[r, phi, s] = r * R[r, phi, s]
     * CDF[r, s]      = 1 - 1/4 * Exp[-r * s] - 3/4 * Exp[-r * s / 3]
     * ------------------------------------------------------------------------------------
     * We importance sample the color channel with the widest scattering distance.
     */ getDiffusionProfileParameters(color) {
        const cdf = 0.997;
        const maxScatteringDistance = Math.max(color.r, color.g, color.b);
        return this._sampleBurleyDiffusionProfile(cdf, maxScatteringDistance);
    }
    /**
     * Performs sampling of a Normalized Burley diffusion profile in polar coordinates.
     * 'u' is the random number (the value of the CDF): [0, 1).
     * rcp(s) = 1 / ShapeParam = ScatteringDistance.
     * Returns the sampled radial distance, s.t. (u = 0 -> r = 0) and (u = 1 -> r = Inf).
     * @param u
     * @param rcpS
     * @returns The sampled radial distance
     */ _sampleBurleyDiffusionProfile(u, rcpS) {
        u = 1 - u; // Convert CDF to CCDF
        const g = 1 + 4 * u * (2 * u + Math.sqrt(1 + 4 * u * u));
        const n = Math.pow(g, -1 / 3.0); // g^(-1/3)
        const p = g * n * n; // g^(+1/3)
        const c = 1 + p + n; // 1 + g^(+1/3) + g^(-1/3)
        const x = 3 * Math.log(c / (4 * u));
        return x * rcpS;
    }
}
/**
 * @internal
 */ $8962dec33201d4ed$export$2414fb33a3a4e32b._SceneComponentInitialization = (_)=>{
    throw (0, $dUFYy._WarnImport)("SubSurfaceSceneComponent");
};

});
parcelRegister("cbyNs", function(module, exports) {

$parcel$export(module.exports, "SubSurfaceScatteringPostProcess", () => $8df1810518014947$export$35a931d200633cab);

var $j2mX5 = parcelRequire("j2mX5");

var $cFdBb = parcelRequire("cFdBb");

var $kVtWi = parcelRequire("kVtWi");
parcelRequire("7QfgW");
parcelRequire("gl3vj");
parcelRequire("cr88r");
class $8df1810518014947$export$35a931d200633cab extends (0, $cFdBb.PostProcess) {
    /**
     * Gets a string identifying the name of the class
     * @returns "SubSurfaceScatteringPostProcess" string
     */ getClassName() {
        return "SubSurfaceScatteringPostProcess";
    }
    constructor(name, scene, options, camera = null, samplingMode, engine, reusable, textureType = 0){
        super(name, "subSurfaceScattering", [
            "texelSize",
            "viewportSize",
            "metersPerUnit"
        ], [
            "diffusionS",
            "diffusionD",
            "filterRadii",
            "irradianceSampler",
            "depthSampler",
            "albedoSampler"
        ], options, camera, samplingMode || (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, engine, reusable, null, textureType, "postprocess", undefined, true);
        this._scene = scene;
        this.updateEffect();
        this.onApplyObservable.add((effect)=>{
            if (!scene.prePassRenderer || !scene.subSurfaceConfiguration) {
                (0, $kVtWi.Logger).Error("PrePass and subsurface configuration needs to be enabled for subsurface scattering.");
                return;
            }
            const texelSize = this.texelSize;
            effect.setFloat("metersPerUnit", scene.subSurfaceConfiguration.metersPerUnit);
            effect.setFloat2("texelSize", texelSize.x, texelSize.y);
            effect.setTexture("irradianceSampler", scene.prePassRenderer.getRenderTarget().textures[scene.prePassRenderer.getIndex(0)]);
            effect.setTexture("depthSampler", scene.prePassRenderer.getRenderTarget().textures[scene.prePassRenderer.getIndex(5)]);
            effect.setTexture("albedoSampler", scene.prePassRenderer.getRenderTarget().textures[scene.prePassRenderer.getIndex(7)]);
            effect.setFloat2("viewportSize", Math.tan(scene.activeCamera.fov / 2) * scene.getEngine().getAspectRatio(scene.activeCamera, true), Math.tan(scene.activeCamera.fov / 2));
            effect.setArray3("diffusionS", scene.subSurfaceConfiguration.ssDiffusionS);
            effect.setArray("diffusionD", scene.subSurfaceConfiguration.ssDiffusionD);
            effect.setArray("filterRadii", scene.subSurfaceConfiguration.ssFilterRadii);
        });
    }
}

});
parcelRegister("gl3vj", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("lIBYV");
parcelRequire("7Hs3g");
parcelRequire("OMx8e");
parcelRequire("g1Log");
const $be51535ad577a31c$var$name = "subSurfaceScatteringPixelShader";
const $be51535ad577a31c$var$shader = `#include<fibonacci>
#include<helperFunctions>
#include<subSurfaceScatteringFunctions>
#include<diffusionProfile>
varying vec2 vUV;uniform vec2 texelSize;uniform sampler2D textureSampler;uniform sampler2D irradianceSampler;uniform sampler2D depthSampler;uniform sampler2D albedoSampler;uniform vec2 viewportSize;uniform float metersPerUnit;const float LOG2_E=1.4426950408889634;const float SSS_PIXELS_PER_SAMPLE=4.;const int _SssSampleBudget=40;
#define rcp(x) 1./x
#define Sq(x) x*x
#define SSS_BILATERAL_FILTER true
vec3 EvalBurleyDiffusionProfile(float r,vec3 S)
{vec3 exp_13=exp2(((LOG2_E*(-1.0/3.0))*r)*S); 
vec3 expSum=exp_13*(1.+exp_13*exp_13); 
return (S*rcp(8.*PI))*expSum; }
vec2 SampleBurleyDiffusionProfile(float u,float rcpS)
{u=1.-u; 
float g=1.+(4.*u)*(2.*u+sqrt(1.+(4.*u)*u));float n=exp2(log2(g)*(-1.0/3.0)); 
float p=(g*n)*n; 
float c=1.+p+n; 
float d=(3./LOG2_E*2.)+(3./LOG2_E)*log2(u); 
float x=(3./LOG2_E)*log2(c)-d; 
float rcpExp=((c*c)*c)*rcp((4.*u)*((c*c)+(4.*u)*(4.*u)));float r=x*rcpS;float rcpPdf=(8.*PI*rcpS)*rcpExp; 
return vec2(r,rcpPdf);}
vec3 ComputeBilateralWeight(float xy2,float z,float mmPerUnit,vec3 S,float rcpPdf)
{
#ifndef SSS_BILATERAL_FILTER
z=0.;
#endif
float r=sqrt(xy2+(z*mmPerUnit)*(z*mmPerUnit));float area=rcpPdf;
#if SSS_CLAMP_ARTIFACT
return clamp(EvalBurleyDiffusionProfile(r,S)*area,0.0,1.0);
#else
return EvalBurleyDiffusionProfile(r,S)*area;
#endif
}
void EvaluateSample(int i,int n,vec3 S,float d,vec3 centerPosVS,float mmPerUnit,float pixelsPerMm,
float phase,inout vec3 totalIrradiance,inout vec3 totalWeight)
{float scale =rcp(float(n));float offset=rcp(float(n))*0.5;float sinPhase,cosPhase;sinPhase=sin(phase);cosPhase=cos(phase);vec2 bdp=SampleBurleyDiffusionProfile(float(i)*scale+offset,d);float r=bdp.x;float rcpPdf=bdp.y;float phi=SampleDiskGolden(i,n).y;float sinPhi,cosPhi;sinPhi=sin(phi);cosPhi=cos(phi);float sinPsi=cosPhase*sinPhi+sinPhase*cosPhi; 
float cosPsi=cosPhase*cosPhi-sinPhase*sinPhi; 
vec2 vec=r*vec2(cosPsi,sinPsi);vec2 position; 
float xy2;position=vUV+round((pixelsPerMm*r)*vec2(cosPsi,sinPsi))*texelSize;xy2 =r*r;vec4 textureSample=texture2D(irradianceSampler,position);float viewZ=texture2D(depthSampler,position).r;vec3 irradiance =textureSample.rgb;if (testLightingForSSS(textureSample.a))
{float relZ=viewZ-centerPosVS.z;vec3 weight=ComputeBilateralWeight(xy2,relZ,mmPerUnit,S,rcpPdf);totalIrradiance+=weight*irradiance;totalWeight +=weight;}
else
{}}
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) 
{vec4 irradianceAndDiffusionProfile =texture2D(irradianceSampler,vUV);vec3 centerIrradiance=irradianceAndDiffusionProfile.rgb;int diffusionProfileIndex=int(round(irradianceAndDiffusionProfile.a*255.));float centerDepth =0.;vec4 inputColor=texture2D(textureSampler,vUV);bool passedStencilTest=testLightingForSSS(irradianceAndDiffusionProfile.a);if (passedStencilTest)
{centerDepth=texture2D(depthSampler,vUV).r;}
if (!passedStencilTest) { 
gl_FragColor=inputColor;return;}
float distScale =1.;vec3 S =diffusionS[diffusionProfileIndex];float d =diffusionD[diffusionProfileIndex];float filterRadius=filterRadii[diffusionProfileIndex];vec2 centerPosNDC=vUV;vec2 cornerPosNDC=vUV+0.5*texelSize;vec3 centerPosVS =vec3(centerPosNDC*viewportSize,1.0)*centerDepth; 
vec3 cornerPosVS =vec3(cornerPosNDC*viewportSize,1.0)*centerDepth; 
float mmPerUnit =1000.*(metersPerUnit*rcp(distScale));float unitsPerMm=rcp(mmPerUnit);float unitsPerPixel=2.*abs(cornerPosVS.x-centerPosVS.x);float pixelsPerMm =rcp(unitsPerPixel)*unitsPerMm;float filterArea =PI*Sq(filterRadius*pixelsPerMm);int sampleCount =int(filterArea*rcp(SSS_PIXELS_PER_SAMPLE));int sampleBudget=_SssSampleBudget;int texturingMode=0;vec3 albedo =texture2D(albedoSampler,vUV).rgb;if (distScale==0. || sampleCount<1)
{
#ifdef DEBUG_SSS_SAMPLES
vec3 green=vec3(0.,1.,0.);gl_FragColor=vec4(green,1.0);return;
#endif
gl_FragColor=vec4(inputColor.rgb+albedo*centerIrradiance,1.0);return;}
#ifdef DEBUG_SSS_SAMPLES
vec3 red =vec3(1.,0.,0.);vec3 blue=vec3(0.,0.,1.);gl_FragColor=vec4(mix(blue,red,clamp(float(sampleCount)/float(sampleBudget),0.0,1.0)),1.0);return;
#endif
float phase=0.;int n=min(sampleCount,sampleBudget);vec3 centerWeight =vec3(0.); 
vec3 totalIrradiance=vec3(0.);vec3 totalWeight =vec3(0.);for (int i=0; i<n; i++)
{EvaluateSample(i,n,S,d,centerPosVS,mmPerUnit,pixelsPerMm,
phase,totalIrradiance,totalWeight);}
totalWeight=max(totalWeight,HALF_MIN);gl_FragColor=vec4(inputColor.rgb+albedo*max(totalIrradiance/totalWeight,vec3(0.0)),1.);}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$be51535ad577a31c$var$name] = $be51535ad577a31c$var$shader;
const $be51535ad577a31c$export$d491254d70b7fbbc = {
    name: $be51535ad577a31c$var$name,
    shader: $be51535ad577a31c$var$shader
};

});
parcelRegister("lIBYV", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $fcfb2b64a12d908b$var$name = "fibonacci";
const $fcfb2b64a12d908b$var$shader = `#define rcp(x) 1./x
#define GOLDEN_RATIO 1.618033988749895
#define TWO_PI 6.2831855
vec2 Golden2dSeq(int i,float n)
{return vec2(float(i)/n+(0.5/n),fract(float(i)*rcp(GOLDEN_RATIO)));}
vec2 SampleDiskGolden(int i,int sampleCount)
{vec2 f=Golden2dSeq(i,float(sampleCount));return vec2(sqrt(f.x),TWO_PI*f.y);}`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$fcfb2b64a12d908b$var$name] = $fcfb2b64a12d908b$var$shader;
const $fcfb2b64a12d908b$export$c5881d03e4853ba0 = {
    name: $fcfb2b64a12d908b$var$name,
    shader: $fcfb2b64a12d908b$var$shader
};

});

parcelRegister("g1Log", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $bab1800f6ea29b41$var$name = "diffusionProfile";
const $bab1800f6ea29b41$var$shader = `uniform vec3 diffusionS[5];uniform float diffusionD[5];uniform float filterRadii[5];`;
// Sideeffect
(0, $68BIi.ShaderStore).IncludesShadersStore[$bab1800f6ea29b41$var$name] = $bab1800f6ea29b41$var$shader;
const $bab1800f6ea29b41$export$96137b1c88345b02 = {
    name: $bab1800f6ea29b41$var$name,
    shader: $bab1800f6ea29b41$var$shader
};

});





parcelRegister("1WW1V", function(module, exports) {

$parcel$export(module.exports, "OutlineRenderer", () => $16b838c978f98fa5$export$66c44dd064a9033f);

var $b4i1f = parcelRequire("b4i1f");

var $fbuqw = parcelRequire("fbuqw");

var $gmbCk = parcelRequire("gmbCk");

var $bv05l = parcelRequire("bv05l");

var $hOyoX = parcelRequire("hOyoX");
parcelRequire("3H84u");
parcelRequire("bdDz2");

var $aAFeM = parcelRequire("aAFeM");

var $alPCh = parcelRequire("alPCh");
/**
 * Gets the outline renderer associated with the scene
 * @returns a OutlineRenderer
 */ (0, $gmbCk.Scene).prototype.getOutlineRenderer = function() {
    if (!this._outlineRenderer) this._outlineRenderer = new $16b838c978f98fa5$export$66c44dd064a9033f(this);
    return this._outlineRenderer;
};
Object.defineProperty((0, $fbuqw.Mesh).prototype, "renderOutline", {
    get: function() {
        return this._renderOutline;
    },
    set: function(value) {
        if (value) // Lazy Load the component.
        this.getScene().getOutlineRenderer();
        this._renderOutline = value;
    },
    enumerable: true,
    configurable: true
});
Object.defineProperty((0, $fbuqw.Mesh).prototype, "renderOverlay", {
    get: function() {
        return this._renderOverlay;
    },
    set: function(value) {
        if (value) // Lazy Load the component.
        this.getScene().getOutlineRenderer();
        this._renderOverlay = value;
    },
    enumerable: true,
    configurable: true
});
class $16b838c978f98fa5$export$66c44dd064a9033f {
    /**
     * Instantiates a new outline renderer. (There could be only one per scene).
     * @param scene Defines the scene it belongs to
     */ constructor(scene){
        /**
         * The name of the component. Each component must have a unique name.
         */ this.name = (0, $bv05l.SceneComponentConstants).NAME_OUTLINERENDERER;
        /**
         * Defines a zOffset default Factor to prevent zFighting between the overlay and the mesh.
         */ this.zOffset = 1;
        /**
         * Defines a zOffset default Unit to prevent zFighting between the overlay and the mesh.
         */ this.zOffsetUnits = 4; // 4 to account for projection a bit by default
        this.scene = scene;
        this._engine = scene.getEngine();
        this.scene._addComponent(this);
        this._passIdForDrawWrapper = [];
        for(let i = 0; i < 4; ++i)this._passIdForDrawWrapper[i] = this._engine.createRenderPassId(`Outline Renderer (${i})`);
    }
    /**
     * Register the component to one instance of a scene.
     */ register() {
        this.scene._beforeRenderingMeshStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_BEFORERENDERINGMESH_OUTLINE, this, this._beforeRenderingMesh);
        this.scene._afterRenderingMeshStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_AFTERRENDERINGMESH_OUTLINE, this, this._afterRenderingMesh);
    }
    /**
     * Rebuilds the elements related to this component in case of
     * context lost for instance.
     */ rebuild() {
    // Nothing to do here.
    }
    /**
     * Disposes the component and the associated resources.
     */ dispose() {
        for(let i = 0; i < this._passIdForDrawWrapper.length; ++i)this._engine.releaseRenderPassId(this._passIdForDrawWrapper[i]);
    }
    /**
     * Renders the outline in the canvas.
     * @param subMesh Defines the sumesh to render
     * @param batch Defines the batch of meshes in case of instances
     * @param useOverlay Defines if the rendering is for the overlay or the outline
     * @param renderPassId Render pass id to use to render the mesh
     */ render(subMesh, batch, useOverlay = false, renderPassId) {
        renderPassId = renderPassId ?? this._passIdForDrawWrapper[0];
        const scene = this.scene;
        const engine = scene.getEngine();
        const hardwareInstancedRendering = engine.getCaps().instancedArrays && (batch.visibleInstances[subMesh._id] !== null && batch.visibleInstances[subMesh._id] !== undefined || subMesh.getRenderingMesh().hasThinInstances);
        if (!this.isReady(subMesh, hardwareInstancedRendering, renderPassId)) return;
        const ownerMesh = subMesh.getMesh();
        const replacementMesh = ownerMesh._internalAbstractMeshDataInfo._actAsRegularMesh ? ownerMesh : null;
        const renderingMesh = subMesh.getRenderingMesh();
        const effectiveMesh = replacementMesh ? replacementMesh : renderingMesh;
        const material = subMesh.getMaterial();
        if (!material || !scene.activeCamera) return;
        const drawWrapper = subMesh._getDrawWrapper(renderPassId);
        const effect = (0, $hOyoX.DrawWrapper).GetEffect(drawWrapper);
        engine.enableEffect(drawWrapper);
        // Logarithmic depth
        if (material.useLogarithmicDepth) effect.setFloat("logarithmicDepthConstant", 2.0 / (Math.log(scene.activeCamera.maxZ + 1.0) / Math.LN2));
        effect.setFloat("offset", useOverlay ? 0 : renderingMesh.outlineWidth);
        effect.setColor4("color", useOverlay ? renderingMesh.overlayColor : renderingMesh.outlineColor, useOverlay ? renderingMesh.overlayAlpha : material.alpha);
        effect.setMatrix("viewProjection", scene.getTransformMatrix());
        effect.setMatrix("world", effectiveMesh.getWorldMatrix());
        // Bones
        if (renderingMesh.useBones && renderingMesh.computeBonesUsingShaders && renderingMesh.skeleton) effect.setMatrices("mBones", renderingMesh.skeleton.getTransformMatrices(renderingMesh));
        if (renderingMesh.morphTargetManager && renderingMesh.morphTargetManager.isUsingTextureForTargets) renderingMesh.morphTargetManager._bind(effect);
        // Morph targets
        (0, $alPCh.BindMorphTargetParameters)(renderingMesh, effect);
        if (!hardwareInstancedRendering) renderingMesh._bind(subMesh, effect, material.fillMode);
        // Alpha test
        if (material && material.needAlphaTesting()) {
            const alphaTexture = material.getAlphaTestTexture();
            if (alphaTexture) {
                effect.setTexture("diffuseSampler", alphaTexture);
                effect.setMatrix("diffuseMatrix", alphaTexture.getTextureMatrix());
            }
        }
        // Clip plane
        (0, $aAFeM.bindClipPlane)(effect, material, scene);
        engine.setZOffset(-this.zOffset);
        engine.setZOffsetUnits(-this.zOffsetUnits);
        renderingMesh._processRendering(effectiveMesh, subMesh, effect, material.fillMode, batch, hardwareInstancedRendering, (isInstance, world)=>{
            effect.setMatrix("world", world);
        });
        engine.setZOffset(0);
        engine.setZOffsetUnits(0);
    }
    /**
     * Returns whether or not the outline renderer is ready for a given submesh.
     * All the dependencies e.g. submeshes, texture, effect... mus be ready
     * @param subMesh Defines the submesh to check readiness for
     * @param useInstances Defines whether wee are trying to render instances or not
     * @param renderPassId Render pass id to use to render the mesh
     * @returns true if ready otherwise false
     */ isReady(subMesh, useInstances, renderPassId) {
        renderPassId = renderPassId ?? this._passIdForDrawWrapper[0];
        const defines = [];
        const attribs = [
            (0, $b4i1f.VertexBuffer).PositionKind,
            (0, $b4i1f.VertexBuffer).NormalKind
        ];
        const mesh = subMesh.getMesh();
        const material = subMesh.getMaterial();
        if (!material) return false;
        const scene = mesh.getScene();
        // Alpha test
        if (material.needAlphaTesting()) {
            defines.push("#define ALPHATEST");
            if (mesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UVKind)) {
                attribs.push((0, $b4i1f.VertexBuffer).UVKind);
                defines.push("#define UV1");
            }
            if (mesh.isVerticesDataPresent((0, $b4i1f.VertexBuffer).UV2Kind)) {
                attribs.push((0, $b4i1f.VertexBuffer).UV2Kind);
                defines.push("#define UV2");
            }
        }
        //Logarithmic depth
        if (material.useLogarithmicDepth) defines.push("#define LOGARITHMICDEPTH");
        // Clip planes
        (0, $aAFeM.prepareStringDefinesForClipPlanes)(material, scene, defines);
        // Bones
        if (mesh.useBones && mesh.computeBonesUsingShaders) {
            attribs.push((0, $b4i1f.VertexBuffer).MatricesIndicesKind);
            attribs.push((0, $b4i1f.VertexBuffer).MatricesWeightsKind);
            if (mesh.numBoneInfluencers > 4) {
                attribs.push((0, $b4i1f.VertexBuffer).MatricesIndicesExtraKind);
                attribs.push((0, $b4i1f.VertexBuffer).MatricesWeightsExtraKind);
            }
            defines.push("#define NUM_BONE_INFLUENCERS " + mesh.numBoneInfluencers);
            defines.push("#define BonesPerMesh " + (mesh.skeleton ? mesh.skeleton.bones.length + 1 : 0));
        } else defines.push("#define NUM_BONE_INFLUENCERS 0");
        // Morph targets
        const morphTargetManager = mesh.morphTargetManager;
        let numMorphInfluencers = 0;
        if (morphTargetManager) {
            numMorphInfluencers = morphTargetManager.numMaxInfluencers || morphTargetManager.numInfluencers;
            if (numMorphInfluencers > 0) {
                defines.push("#define MORPHTARGETS");
                defines.push("#define NUM_MORPH_INFLUENCERS " + numMorphInfluencers);
                if (morphTargetManager.isUsingTextureForTargets) defines.push("#define MORPHTARGETS_TEXTURE");
                (0, $alPCh.PrepareAttributesForMorphTargetsInfluencers)(attribs, mesh, numMorphInfluencers);
            }
        }
        // Instances
        if (useInstances) {
            defines.push("#define INSTANCES");
            (0, $alPCh.PushAttributesForInstances)(attribs);
            if (subMesh.getRenderingMesh().hasThinInstances) defines.push("#define THIN_INSTANCES");
        }
        // Get correct effect
        const drawWrapper = subMesh._getDrawWrapper(renderPassId, true);
        const cachedDefines = drawWrapper.defines;
        const join = defines.join("\n");
        if (cachedDefines !== join) {
            const uniforms = [
                "world",
                "mBones",
                "viewProjection",
                "diffuseMatrix",
                "offset",
                "color",
                "logarithmicDepthConstant",
                "morphTargetInfluences",
                "morphTargetCount",
                "morphTargetTextureInfo",
                "morphTargetTextureIndices"
            ];
            (0, $aAFeM.addClipPlaneUniforms)(uniforms);
            drawWrapper.setEffect(this.scene.getEngine().createEffect("outline", attribs, uniforms, [
                "diffuseSampler",
                "morphTargets"
            ], join, undefined, undefined, undefined, {
                maxSimultaneousMorphTargets: numMorphInfluencers
            }), join);
        }
        return drawWrapper.effect.isReady();
    }
    _beforeRenderingMesh(mesh, subMesh, batch) {
        // Outline - step 1
        this._savedDepthWrite = this._engine.getDepthWrite();
        if (mesh.renderOutline) {
            const material = subMesh.getMaterial();
            if (material && material.needAlphaBlendingForMesh(mesh)) {
                this._engine.cacheStencilState();
                // Draw only to stencil buffer for the original mesh
                // The resulting stencil buffer will be used so the outline is not visible inside the mesh when the mesh is transparent
                this._engine.setDepthWrite(false);
                this._engine.setColorWrite(false);
                this._engine.setStencilBuffer(true);
                this._engine.setStencilOperationPass(7681);
                this._engine.setStencilFunction(519);
                this._engine.setStencilMask($16b838c978f98fa5$export$66c44dd064a9033f._StencilReference);
                this._engine.setStencilFunctionReference($16b838c978f98fa5$export$66c44dd064a9033f._StencilReference);
                this._engine.stencilStateComposer.useStencilGlobalOnly = true;
                this.render(subMesh, batch, /* This sets offset to 0 */ true, this._passIdForDrawWrapper[1]);
                this._engine.setColorWrite(true);
                this._engine.setStencilFunction(517);
            }
            // Draw the outline using the above stencil if needed to avoid drawing within the mesh
            this._engine.setDepthWrite(false);
            this.render(subMesh, batch, false, this._passIdForDrawWrapper[0]);
            this._engine.setDepthWrite(this._savedDepthWrite);
            if (material && material.needAlphaBlendingForMesh(mesh)) {
                this._engine.stencilStateComposer.useStencilGlobalOnly = false;
                this._engine.restoreStencilState();
            }
        }
    }
    _afterRenderingMesh(mesh, subMesh, batch) {
        // Overlay
        if (mesh.renderOverlay) {
            const currentMode = this._engine.getAlphaMode();
            const alphaBlendState = this._engine.alphaState.alphaBlend;
            this._engine.setAlphaMode(2);
            this.render(subMesh, batch, true, this._passIdForDrawWrapper[3]);
            this._engine.setAlphaMode(currentMode);
            this._engine.setDepthWrite(this._savedDepthWrite);
            this._engine.alphaState.alphaBlend = alphaBlendState;
        }
        // Outline - step 2
        if (mesh.renderOutline && this._savedDepthWrite) {
            this._engine.setDepthWrite(true);
            this._engine.setColorWrite(false);
            this.render(subMesh, batch, false, this._passIdForDrawWrapper[2]);
            this._engine.setColorWrite(true);
        }
    }
}
/**
 * Stencil value used to avoid outline being seen within the mesh when the mesh is transparent
 */ $16b838c978f98fa5$export$66c44dd064a9033f._StencilReference = 0x04;

});
parcelRegister("3H84u", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("82O8L");
parcelRequire("4kipo");
parcelRequire("kg1CD");
parcelRequire("izyqw");
const $2b0ba611bf18ceea$var$name = "outlinePixelShader";
const $2b0ba611bf18ceea$var$shader = `#ifdef LOGARITHMICDEPTH
#extension GL_EXT_frag_depth : enable
#endif
uniform vec4 color;
#ifdef ALPHATEST
varying vec2 vUV;uniform sampler2D diffuseSampler;
#endif
#include<clipPlaneFragmentDeclaration>
#include<logDepthDeclaration>
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) {
#define CUSTOM_FRAGMENT_MAIN_BEGIN
#include<clipPlaneFragment>
#ifdef ALPHATEST
if (texture2D(diffuseSampler,vUV).a<0.4)
discard;
#endif
#include<logDepthFragment>
gl_FragColor=color;
#define CUSTOM_FRAGMENT_MAIN_END
}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$2b0ba611bf18ceea$var$name] = $2b0ba611bf18ceea$var$shader;
const $2b0ba611bf18ceea$export$94d49210497d1286 = {
    name: $2b0ba611bf18ceea$var$name,
    shader: $2b0ba611bf18ceea$var$shader
};

});

parcelRegister("bdDz2", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("7PW7m");
parcelRequire("8kYMw");
parcelRequire("5Eb4I");
parcelRequire("9H5jp");
parcelRequire("4A4MM");
parcelRequire("k3wwH");
parcelRequire("4kipo");
parcelRequire("9ulLS");
parcelRequire("LFrAO");
parcelRequire("apKdp");
parcelRequire("4idCt");
parcelRequire("cIweX");
parcelRequire("kqCfW");
parcelRequire("a111f");
const $82af993b5cea4830$var$name = "outlineVertexShader";
const $82af993b5cea4830$var$shader = `attribute vec3 position;attribute vec3 normal;
#include<bonesDeclaration>
#include<bakedVertexAnimationDeclaration>
#include<morphTargetsVertexGlobalDeclaration>
#include<morphTargetsVertexDeclaration>[0..maxSimultaneousMorphTargets]
#include<clipPlaneVertexDeclaration>
uniform float offset;
#include<instancesDeclaration>
uniform mat4 viewProjection;
#ifdef ALPHATEST
varying vec2 vUV;uniform mat4 diffuseMatrix;
#ifdef UV1
attribute vec2 uv;
#endif
#ifdef UV2
attribute vec2 uv2;
#endif
#endif
#include<logDepthDeclaration>
#define CUSTOM_VERTEX_DEFINITIONS
void main(void)
{vec3 positionUpdated=position;vec3 normalUpdated=normal;
#ifdef UV1
vec2 uvUpdated=uv;
#endif
#include<morphTargetsVertexGlobal>
#include<morphTargetsVertex>[0..maxSimultaneousMorphTargets]
vec3 offsetPosition=positionUpdated+(normalUpdated*offset);
#include<instancesVertex>
#include<bonesVertex>
#include<bakedVertexAnimation>
vec4 worldPos=finalWorld*vec4(offsetPosition,1.0);gl_Position=viewProjection*worldPos;
#ifdef ALPHATEST
#ifdef UV1
vUV=vec2(diffuseMatrix*vec4(uvUpdated,1.0,0.0));
#endif
#ifdef UV2
vUV=vec2(diffuseMatrix*vec4(uv2,1.0,0.0));
#endif
#endif
#include<clipPlaneVertex>
#include<logDepthVertex>
}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$82af993b5cea4830$var$name] = $82af993b5cea4830$var$shader;
const $82af993b5cea4830$export$e6c06fbcf3b180f5 = {
    name: $82af993b5cea4830$var$name,
    shader: $82af993b5cea4830$var$shader
};

});


parcelRegister("ikRUe", function(module, exports) {

var $i8Jke = parcelRequire("i8Jke");

var $dbgEa = parcelRequire("dbgEa");

var $l17Vx = parcelRequire("l17Vx");

var $5nRi8 = parcelRequire("5nRi8");

var $3ENpM = parcelRequire("3ENpM");
$parcel$exportWildcard(module.exports, $i8Jke);
$parcel$exportWildcard(module.exports, $dbgEa);
$parcel$exportWildcard(module.exports, $l17Vx);
$parcel$exportWildcard(module.exports, $5nRi8);
$parcel$exportWildcard(module.exports, $3ENpM);

});
parcelRegister("i8Jke", function(module, exports) {

$parcel$export(module.exports, "FluidRenderer", () => $d34c2203cc3ff3e4$export$28faa9dbd0733750);
$parcel$export(module.exports, "FluidRendererSceneComponent", () => $d34c2203cc3ff3e4$export$1de8adf6dd4b6cdd);

var $gmbCk = parcelRequire("gmbCk");

var $bv05l = parcelRequire("bv05l");

var $l17Vx = parcelRequire("l17Vx");

var $3ENpM = parcelRequire("3ENpM");

var $5nRi8 = parcelRequire("5nRi8");

var $dygQs = parcelRequire("dygQs");
parcelRequire("57J1X");
parcelRequire("nL5cn");
parcelRequire("sKKzI");
parcelRequire("jdVko");
parcelRequire("fBG6m");
parcelRequire("pG4ZI");
parcelRequire("7q8SE");
parcelRequire("8sISc");
parcelRequire("2lGwn");
Object.defineProperty((0, $gmbCk.Scene).prototype, "fluidRenderer", {
    get: function() {
        return this._fluidRenderer;
    },
    set: function(value) {
        this._fluidRenderer = value;
    },
    enumerable: true,
    configurable: true
});
(0, $gmbCk.Scene).prototype.enableFluidRenderer = function() {
    if (this._fluidRenderer) return this._fluidRenderer;
    this._fluidRenderer = new $d34c2203cc3ff3e4$export$28faa9dbd0733750(this);
    return this._fluidRenderer;
};
(0, $gmbCk.Scene).prototype.disableFluidRenderer = function() {
    this._fluidRenderer?.dispose();
    this._fluidRenderer = null;
};
function $d34c2203cc3ff3e4$var$IsParticleSystemObject(obj) {
    return !!obj.particleSystem;
}
function $d34c2203cc3ff3e4$var$IsCustomParticlesObject(obj) {
    return !!obj.addBuffers;
}
class $d34c2203cc3ff3e4$export$1de8adf6dd4b6cdd {
    /**
     * Creates a new instance of the component for the given scene
     * @param scene Defines the scene to register the component in
     */ constructor(scene){
        /**
         * The component name helpful to identify the component in the list of scene components.
         */ this.name = (0, $bv05l.SceneComponentConstants).NAME_FLUIDRENDERER;
        this.scene = scene;
    }
    /**
     * Registers the component in a given scene
     */ register() {
        this.scene._gatherActiveCameraRenderTargetsStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_GATHERACTIVECAMERARENDERTARGETS_FLUIDRENDERER, this, this._gatherActiveCameraRenderTargets);
        this.scene._afterCameraDrawStage.registerStep((0, $bv05l.SceneComponentConstants).STEP_AFTERCAMERADRAW_FLUIDRENDERER, this, this._afterCameraDraw);
    }
    _gatherActiveCameraRenderTargets(_renderTargets) {
        this.scene.fluidRenderer?._prepareRendering();
    }
    _afterCameraDraw(camera) {
        this.scene.fluidRenderer?._render(camera);
    }
    /**
     * Rebuilds the elements related to this component in case of
     * context lost for instance.
     */ rebuild() {
        const fluidRenderer = this.scene.fluidRenderer;
        if (!fluidRenderer) return;
        const buffers = new Set();
        for(let i = 0; i < fluidRenderer.renderObjects.length; ++i){
            const obj = fluidRenderer.renderObjects[i].object;
            if ($d34c2203cc3ff3e4$var$IsCustomParticlesObject(obj)) {
                const vbuffers = obj.vertexBuffers;
                for(const name in vbuffers)buffers.add(vbuffers[name].getWrapperBuffer());
            }
        }
        buffers.forEach((buffer)=>{
            buffer._rebuild();
        });
    }
    /**
     * Disposes the component and the associated resources
     */ dispose() {
        this.scene.disableFluidRenderer();
    }
}
class $d34c2203cc3ff3e4$export$28faa9dbd0733750 {
    /** @internal */ static _SceneComponentInitialization(scene) {
        let component = scene._getComponent((0, $bv05l.SceneComponentConstants).NAME_FLUIDRENDERER);
        if (!component) {
            component = new $d34c2203cc3ff3e4$export$1de8adf6dd4b6cdd(scene);
            scene._addComponent(component);
        }
    }
    /**
     * Initializes the class
     * @param scene Scene in which the objects are part of
     */ constructor(scene){
        this._scene = scene;
        this._engine = scene.getEngine();
        this._onEngineResizeObserver = null;
        this.renderObjects = [];
        this.targetRenderers = [];
        this._cameras = new Map();
        $d34c2203cc3ff3e4$export$28faa9dbd0733750._SceneComponentInitialization(this._scene);
        this._onEngineResizeObserver = this._engine.onResizeObservable.add(()=>{
            this._initialize();
        });
    }
    /**
     * Reinitializes the class
     * Can be used if you change the object priority (FluidRenderingObject.priority), to make sure the objects are rendered in the right order
     */ recreate() {
        this._sortRenderingObjects();
        this._initialize();
    }
    /**
     * Gets the render object corresponding to a particle system (null if the particle system is not rendered as a fluid)
     * @param ps The particle system
     * @returns the render object corresponding to this particle system if any, otherwise null
     */ getRenderObjectFromParticleSystem(ps) {
        const index = this._getParticleSystemIndex(ps);
        return index !== -1 ? this.renderObjects[index] : null;
    }
    /**
     * Adds a particle system to the fluid renderer.
     * @param ps particle system
     * @param generateDiffuseTexture True if you want to generate a diffuse texture from the particle system and use it as part of the fluid rendering (default: false)
     * @param targetRenderer The target renderer used to display the particle system as a fluid. If not provided, the method will create a new one
     * @param camera The camera used by the target renderer (if the target renderer is created by the method)
     * @returns the render object corresponding to the particle system
     */ addParticleSystem(ps, generateDiffuseTexture, targetRenderer, camera) {
        const object = new (0, $l17Vx.FluidRenderingObjectParticleSystem)(this._scene, ps);
        object.onParticleSizeChanged.add(()=>this._setParticleSizeForRenderTargets());
        if (!targetRenderer) {
            targetRenderer = new (0, $3ENpM.FluidRenderingTargetRenderer)(this._scene, camera);
            this.targetRenderers.push(targetRenderer);
        }
        if (!targetRenderer._onUseVelocityChanged.hasObservers()) targetRenderer._onUseVelocityChanged.add(()=>this._setUseVelocityForRenderObject());
        if (generateDiffuseTexture !== undefined) targetRenderer.generateDiffuseTexture = generateDiffuseTexture;
        const renderObject = {
            object: object,
            targetRenderer: targetRenderer
        };
        this.renderObjects.push(renderObject);
        this._sortRenderingObjects();
        this._setParticleSizeForRenderTargets();
        return renderObject;
    }
    /**
     * Adds a custom particle set to the fluid renderer.
     * @param buffers The list of buffers (should contain at least a "position" buffer!)
     * @param numParticles Number of particles in each buffer
     * @param generateDiffuseTexture True if you want to generate a diffuse texture from buffers and use it as part of the fluid rendering (default: false). For the texture to be generated correctly, you need a "color" buffer in the set!
     * @param targetRenderer The target renderer used to display the particle system as a fluid. If not provided, the method will create a new one
     * @param camera The camera used by the target renderer (if the target renderer is created by the method)
     * @returns the render object corresponding to the custom particle set
     */ addCustomParticles(buffers, numParticles, generateDiffuseTexture, targetRenderer, camera) {
        const object = new (0, $5nRi8.FluidRenderingObjectCustomParticles)(this._scene, buffers, numParticles);
        object.onParticleSizeChanged.add(()=>this._setParticleSizeForRenderTargets());
        if (!targetRenderer) {
            targetRenderer = new (0, $3ENpM.FluidRenderingTargetRenderer)(this._scene, camera);
            this.targetRenderers.push(targetRenderer);
        }
        if (!targetRenderer._onUseVelocityChanged.hasObservers()) targetRenderer._onUseVelocityChanged.add(()=>this._setUseVelocityForRenderObject());
        if (generateDiffuseTexture !== undefined) targetRenderer.generateDiffuseTexture = generateDiffuseTexture;
        const renderObject = {
            object: object,
            targetRenderer: targetRenderer
        };
        this.renderObjects.push(renderObject);
        this._sortRenderingObjects();
        this._setParticleSizeForRenderTargets();
        return renderObject;
    }
    /**
     * Removes a render object from the fluid renderer
     * @param renderObject the render object to remove
     * @param removeUnusedTargetRenderer True to remove/dispose of the target renderer if it's not used anymore (default: true)
     * @returns True if the render object has been found and released, else false
     */ removeRenderObject(renderObject, removeUnusedTargetRenderer = true) {
        const index = this.renderObjects.indexOf(renderObject);
        if (index === -1) return false;
        renderObject.object.dispose();
        this.renderObjects.splice(index, 1);
        if (removeUnusedTargetRenderer && this._removeUnusedTargetRenderers()) this._initialize();
        else this._setParticleSizeForRenderTargets();
        return true;
    }
    _sortRenderingObjects() {
        this.renderObjects.sort((a, b)=>{
            return a.object.priority < b.object.priority ? -1 : a.object.priority > b.object.priority ? 1 : 0;
        });
    }
    _removeUnusedTargetRenderers() {
        const indexes = {};
        for(let i = 0; i < this.renderObjects.length; ++i){
            const targetRenderer = this.renderObjects[i].targetRenderer;
            indexes[this.targetRenderers.indexOf(targetRenderer)] = true;
        }
        let removed = false;
        const newList = [];
        for(let i = 0; i < this.targetRenderers.length; ++i)if (!indexes[i]) {
            this.targetRenderers[i].dispose();
            removed = true;
        } else newList.push(this.targetRenderers[i]);
        if (removed) {
            this.targetRenderers.length = 0;
            this.targetRenderers.push(...newList);
        }
        return removed;
    }
    _getParticleSystemIndex(ps) {
        for(let i = 0; i < this.renderObjects.length; ++i){
            const obj = this.renderObjects[i].object;
            if ($d34c2203cc3ff3e4$var$IsParticleSystemObject(obj) && obj.particleSystem === ps) return i;
        }
        return -1;
    }
    _initialize() {
        for(let i = 0; i < this.targetRenderers.length; ++i)this.targetRenderers[i].dispose();
        const cameras = new Map();
        for(let i = 0; i < this.targetRenderers.length; ++i){
            const targetRenderer = this.targetRenderers[i];
            targetRenderer._initialize();
            if (targetRenderer.camera && targetRenderer._renderPostProcess) {
                let list = cameras.get(targetRenderer.camera);
                if (!list) {
                    list = [
                        [],
                        {}
                    ];
                    cameras.set(targetRenderer.camera, list);
                }
                list[0].push(targetRenderer);
                targetRenderer.camera.attachPostProcess(targetRenderer._renderPostProcess, i);
            }
        }
        let iterator = cameras.keys();
        for(let key = iterator.next(); key.done !== true; key = iterator.next()){
            const camera = key.value;
            const list = cameras.get(camera);
            const firstPostProcess = camera._getFirstPostProcess();
            if (!firstPostProcess) continue;
            const [targetRenderers, copyDepthTextures] = list;
            firstPostProcess.onSizeChangedObservable.add(()=>{
                if (!firstPostProcess.inputTexture.depthStencilTexture) firstPostProcess.inputTexture.createDepthStencilTexture(0, true, this._engine.isStencilEnable, targetRenderers[0].samples, this._engine.isStencilEnable ? 13 : 14, `PostProcessRTTDepthStencil-${firstPostProcess.name}`);
                for (const targetRenderer of targetRenderers){
                    const thicknessRT = targetRenderer._thicknessRenderTarget?.renderTarget;
                    const thicknessTexture = thicknessRT?.texture;
                    if (thicknessRT && thicknessTexture) {
                        const key = thicknessTexture.width + "_" + thicknessTexture.height;
                        let copyDepthTexture = copyDepthTextures[key];
                        if (!copyDepthTexture) copyDepthTexture = copyDepthTextures[key] = new (0, $dygQs.FluidRenderingDepthTextureCopy)(this._engine, thicknessTexture.width, thicknessTexture.height);
                        copyDepthTexture.depthRTWrapper._shareDepth(thicknessRT);
                    }
                }
            });
        }
        // Dispose the CopyDepthTexture instances that we don't need anymore
        iterator = this._cameras.keys();
        for(let key = iterator.next(); key.done !== true; key = iterator.next()){
            const camera = key.value;
            const list = this._cameras.get(camera);
            const copyDepthTextures = list[1];
            const list2 = cameras.get(camera);
            if (!list2) for(const key in copyDepthTextures)copyDepthTextures[key].dispose();
            else {
                for(const key in copyDepthTextures)if (!list2[1][key]) copyDepthTextures[key].dispose();
            }
        }
        this._cameras.clear();
        this._cameras = cameras;
        this._setParticleSizeForRenderTargets();
    }
    _setParticleSizeForRenderTargets() {
        const particleSizes = new Map();
        for(let i = 0; i < this.renderObjects.length; ++i){
            const renderingObject = this.renderObjects[i];
            let curSize = particleSizes.get(renderingObject.targetRenderer);
            if (curSize === undefined) curSize = 0;
            particleSizes.set(renderingObject.targetRenderer, Math.max(curSize, renderingObject.object.particleSize));
        }
        particleSizes.forEach((particleSize, targetRenderer)=>{
            if (targetRenderer._depthRenderTarget) targetRenderer._depthRenderTarget.particleSize = particleSize;
        });
    }
    _setUseVelocityForRenderObject() {
        for (const renderingObject of this.renderObjects)renderingObject.object.useVelocity = renderingObject.targetRenderer.useVelocity;
    }
    /** @internal */ _prepareRendering() {
        for (const renderer of this.targetRenderers)if (renderer.needInitialization) {
            this._initialize();
            return;
        }
    }
    /** @internal */ _render(forCamera) {
        for(let i = 0; i < this.targetRenderers.length; ++i)if (!forCamera || this.targetRenderers[i].camera === forCamera) this.targetRenderers[i]._clearTargets();
        const iterator = this._cameras.keys();
        for(let key = iterator.next(); key.done !== true; key = iterator.next()){
            const camera = key.value;
            const list = this._cameras.get(camera);
            if (forCamera && camera !== forCamera) continue;
            const firstPostProcess = camera._getFirstPostProcess();
            if (!firstPostProcess) continue;
            const sourceCopyDepth = firstPostProcess.inputTexture?.depthStencilTexture;
            if (sourceCopyDepth) {
                const [targetRenderers, copyDepthTextures] = list;
                for (const targetRenderer of targetRenderers)targetRenderer._bgDepthTexture = sourceCopyDepth;
                for(const key in copyDepthTextures)copyDepthTextures[key].copy(sourceCopyDepth);
            }
        }
        for(let i = 0; i < this.renderObjects.length; ++i){
            const renderingObject = this.renderObjects[i];
            if (!forCamera || renderingObject.targetRenderer.camera === forCamera) renderingObject.targetRenderer._render(renderingObject.object);
        }
    }
    /**
     * Disposes of all the ressources used by the class
     */ dispose() {
        this._engine.onResizeObservable.remove(this._onEngineResizeObserver);
        this._onEngineResizeObserver = null;
        for(let i = 0; i < this.renderObjects.length; ++i)this.renderObjects[i].object.dispose();
        for(let i = 0; i < this.targetRenderers.length; ++i)this.targetRenderers[i].dispose();
        this._cameras.forEach((list)=>{
            const copyDepthTextures = list[1];
            for(const key in copyDepthTextures)copyDepthTextures[key].dispose();
        });
        this.renderObjects = [];
        this.targetRenderers = [];
        this._cameras.clear();
    }
}

});
parcelRegister("l17Vx", function(module, exports) {

$parcel$export(module.exports, "FluidRenderingObjectParticleSystem", () => $f4cfd71c22c8465b$export$25e0164a4a938607);

var $dbgEa = parcelRequire("dbgEa");
class $f4cfd71c22c8465b$export$25e0164a4a938607 extends (0, $dbgEa.FluidRenderingObject) {
    /** Gets the particle system */ get particleSystem() {
        return this._particleSystem;
    }
    /**
     * @returns the name of the class
     */ getClassName() {
        return "FluidRenderingObjectParticleSystem";
    }
    /**
     * Gets or sets a boolean indicating that the diffuse texture should be generated based on the regular rendering of the particle system (default: true).
     * Sometimes, generating the diffuse texture this way may be sub-optimal. In that case, you can disable this property, in which case the particle system will be
     * rendered using a ALPHA_COMBINE mode instead of the one used by the particle system.
     */ get useTrueRenderingForDiffuseTexture() {
        return this._useTrueRenderingForDiffuseTexture;
    }
    set useTrueRenderingForDiffuseTexture(use) {
        if (this._useTrueRenderingForDiffuseTexture === use) return;
        this._useTrueRenderingForDiffuseTexture = use;
        if (use) {
            this._particleSystem.blendMode = this._blendMode;
            this._particleSystem.onBeforeDrawParticlesObservable.remove(this._onBeforeDrawParticleObserver);
            this._onBeforeDrawParticleObserver = null;
        } else {
            this._particleSystem.blendMode = -1;
            this._onBeforeDrawParticleObserver = this._particleSystem.onBeforeDrawParticlesObservable.add(()=>{
                this._engine.setAlphaMode(2);
            });
        }
    }
    /**
     * Gets the vertex buffers
     */ get vertexBuffers() {
        return this._particleSystem.vertexBuffers;
    }
    /**
     * Gets the index buffer (or null if the object is using instancing)
     */ get indexBuffer() {
        return this._particleSystem.indexBuffer;
    }
    /**
     * Creates a new instance of the class
     * @param scene The scene the particle system is part of
     * @param ps The particle system
     */ constructor(scene, ps){
        super(scene);
        this._useTrueRenderingForDiffuseTexture = true;
        this._particleSystem = ps;
        this._originalRender = ps.render.bind(ps);
        this._blendMode = ps.blendMode;
        this._onBeforeDrawParticleObserver = null;
        this._updateInAnimate = this._particleSystem.updateInAnimate;
        this._particleSystem.updateInAnimate = true;
        this._particleSystem.render = ()=>0;
        this.particleSize = (ps.minSize + ps.maxSize) / 2;
        this.useTrueRenderingForDiffuseTexture = false;
    }
    /**
     * Indicates if the object is ready to be rendered
     * @returns True if everything is ready for the object to be rendered, otherwise false
     */ isReady() {
        return super.isReady() && this._particleSystem.isReady();
    }
    /**
     * Gets the number of particles in this particle system
     * @returns The number of particles
     */ get numParticles() {
        return this._particleSystem.getActiveCount();
    }
    /**
     * Render the diffuse texture for this object
     */ renderDiffuseTexture() {
        this._originalRender();
    }
    /**
     * Releases the ressources used by the class
     */ dispose() {
        super.dispose();
        this._particleSystem.onBeforeDrawParticlesObservable.remove(this._onBeforeDrawParticleObserver);
        this._onBeforeDrawParticleObserver = null;
        this._particleSystem.render = this._originalRender;
        this._particleSystem.blendMode = this._blendMode;
        this._particleSystem.updateInAnimate = this._updateInAnimate;
    }
}

});
parcelRegister("dbgEa", function(module, exports) {

$parcel$export(module.exports, "FluidRenderingObject", () => $9989372972ef7c66$export$99659ef63e1fbfba);

var $iYGpr = parcelRequire("iYGpr");

var $diGQf = parcelRequire("diGQf");
class $9989372972ef7c66$export$99659ef63e1fbfba {
    /** Gets or sets the size of the particle */ get particleSize() {
        return this._particleSize;
    }
    set particleSize(size) {
        if (size === this._particleSize) return;
        this._particleSize = size;
        this.onParticleSizeChanged.notifyObservers(this);
    }
    /** Indicates if the object uses instancing or not */ get useInstancing() {
        return !this.indexBuffer;
    }
    /** Indicates if velocity of particles should be used when rendering the object. The vertex buffer set must contain a "velocity" buffer for this to work! */ get useVelocity() {
        return this._useVelocity;
    }
    set useVelocity(use) {
        if (this._useVelocity === use || !this._hasVelocity()) return;
        this._useVelocity = use;
        this._effectsAreDirty = true;
    }
    _hasVelocity() {
        return !!this.vertexBuffers?.velocity;
    }
    /**
     * Gets the index buffer (or null if the object is using instancing)
     */ get indexBuffer() {
        return null;
    }
    /**
     * @returns the name of the class
     */ getClassName() {
        return "FluidRenderingObject";
    }
    /**
     * Instantiates a fluid rendering object
     * @param scene The scene the object is part of
     */ constructor(scene){
        /** Defines the priority of the object. Objects will be rendered in ascending order of priority */ this.priority = 0;
        this._particleSize = 0.1;
        /** Observable triggered when the size of the particle is changed */ this.onParticleSizeChanged = new (0, $diGQf.Observable)();
        /** Defines the alpha value of a particle */ this.particleThicknessAlpha = 0.05;
        this._useVelocity = false;
        this._scene = scene;
        this._engine = scene.getEngine();
        this._effectsAreDirty = true;
        this._depthEffectWrapper = null;
        this._thicknessEffectWrapper = null;
    }
    _createEffects() {
        const uniformNames = [
            "view",
            "projection",
            "particleRadius",
            "size"
        ];
        const attributeNames = [
            "position",
            "offset"
        ];
        const defines = [];
        this._effectsAreDirty = false;
        if (this.useVelocity) {
            attributeNames.push("velocity");
            defines.push("#define FLUIDRENDERING_VELOCITY");
        }
        if (this._scene.useRightHandedSystem) defines.push("#define FLUIDRENDERING_RHS");
        this._depthEffectWrapper = new (0, $iYGpr.EffectWrapper)({
            engine: this._engine,
            useShaderStore: true,
            vertexShader: "fluidRenderingParticleDepth",
            fragmentShader: "fluidRenderingParticleDepth",
            attributeNames: attributeNames,
            uniformNames: uniformNames,
            samplerNames: [],
            defines: defines
        });
        uniformNames.push("particleAlpha");
        this._thicknessEffectWrapper = new (0, $iYGpr.EffectWrapper)({
            engine: this._engine,
            useShaderStore: true,
            vertexShader: "fluidRenderingParticleThickness",
            fragmentShader: "fluidRenderingParticleThickness",
            attributeNames: [
                "position",
                "offset"
            ],
            uniformNames: uniformNames,
            samplerNames: []
        });
    }
    /**
     * Indicates if the object is ready to be rendered
     * @returns True if everything is ready for the object to be rendered, otherwise false
     */ isReady() {
        if (this._effectsAreDirty) this._createEffects();
        if (!this._depthEffectWrapper || !this._thicknessEffectWrapper) return false;
        const depthEffect = this._depthEffectWrapper._drawWrapper.effect;
        const thicknessEffect = this._thicknessEffectWrapper._drawWrapper.effect;
        return depthEffect.isReady() && thicknessEffect.isReady();
    }
    /**
     * Render the depth texture for this object
     */ renderDepthTexture() {
        const numParticles = this.numParticles;
        if (!this._depthEffectWrapper || numParticles === 0) return;
        const depthDrawWrapper = this._depthEffectWrapper._drawWrapper;
        const depthEffect = depthDrawWrapper.effect;
        this._engine.enableEffect(depthDrawWrapper);
        this._engine.bindBuffers(this.vertexBuffers, this.indexBuffer, depthEffect);
        depthEffect.setMatrix("view", this._scene.getViewMatrix());
        depthEffect.setMatrix("projection", this._scene.getProjectionMatrix());
        depthEffect.setFloat2("size", this._particleSize, this._particleSize);
        depthEffect.setFloat("particleRadius", this._particleSize / 2);
        if (this.useInstancing) this._engine.drawArraysType(7, 0, 4, numParticles);
        else this._engine.drawElementsType(0, 0, numParticles);
    }
    /**
     * Render the thickness texture for this object
     */ renderThicknessTexture() {
        const numParticles = this.numParticles;
        if (!this._thicknessEffectWrapper || numParticles === 0) return;
        const thicknessDrawWrapper = this._thicknessEffectWrapper._drawWrapper;
        const thicknessEffect = thicknessDrawWrapper.effect;
        this._engine.setAlphaMode(6);
        this._engine.setDepthWrite(false);
        this._engine.enableEffect(thicknessDrawWrapper);
        this._engine.bindBuffers(this.vertexBuffers, this.indexBuffer, thicknessEffect);
        thicknessEffect.setMatrix("view", this._scene.getViewMatrix());
        thicknessEffect.setMatrix("projection", this._scene.getProjectionMatrix());
        thicknessEffect.setFloat("particleAlpha", this.particleThicknessAlpha);
        thicknessEffect.setFloat2("size", this._particleSize, this._particleSize);
        if (this.useInstancing) this._engine.drawArraysType(7, 0, 4, numParticles);
        else this._engine.drawElementsType(0, 0, numParticles);
        this._engine.setDepthWrite(true);
        this._engine.setAlphaMode(0);
    }
    /**
     * Render the diffuse texture for this object
     */ renderDiffuseTexture() {
    // do nothing by default
    }
    /**
     * Releases the ressources used by the class
     */ dispose() {
        this._depthEffectWrapper?.dispose();
        this._thicknessEffectWrapper?.dispose();
    }
}

});


parcelRegister("3ENpM", function(module, exports) {

$parcel$export(module.exports, "FluidRenderingDebug", () => $2a9b704603bf0dc0$export$b9788f5e4142aafd);
$parcel$export(module.exports, "FluidRenderingTargetRenderer", () => $2a9b704603bf0dc0$export$1dc21b3c30c9d3a2);

var $7etnY = parcelRequire("7etnY");

var $ha1VO = parcelRequire("ha1VO");

var $diGQf = parcelRequire("diGQf");

var $cFdBb = parcelRequire("cFdBb");

var $Q7RAZ = parcelRequire("Q7RAZ");
var $2a9b704603bf0dc0$export$b9788f5e4142aafd;
(function(FluidRenderingDebug) {
    FluidRenderingDebug[FluidRenderingDebug["DepthTexture"] = 0] = "DepthTexture";
    FluidRenderingDebug[FluidRenderingDebug["DepthBlurredTexture"] = 1] = "DepthBlurredTexture";
    FluidRenderingDebug[FluidRenderingDebug["ThicknessTexture"] = 2] = "ThicknessTexture";
    FluidRenderingDebug[FluidRenderingDebug["ThicknessBlurredTexture"] = 3] = "ThicknessBlurredTexture";
    FluidRenderingDebug[FluidRenderingDebug["DiffuseTexture"] = 4] = "DiffuseTexture";
    FluidRenderingDebug[FluidRenderingDebug["Normals"] = 5] = "Normals";
    FluidRenderingDebug[FluidRenderingDebug["DiffuseRendering"] = 6] = "DiffuseRendering";
})($2a9b704603bf0dc0$export$b9788f5e4142aafd || ($2a9b704603bf0dc0$export$b9788f5e4142aafd = {}));
class $2a9b704603bf0dc0$export$1dc21b3c30c9d3a2 {
    /**
     * Returns true if the class needs to be reinitialized (because of changes in parameterization)
     */ get needInitialization() {
        return this._needInitialization;
    }
    /**
     * Gets or sets a boolean indicating that the diffuse texture should be generated and used for the rendering
     */ get generateDiffuseTexture() {
        return this._generateDiffuseTexture;
    }
    set generateDiffuseTexture(generate) {
        if (this._generateDiffuseTexture === generate) return;
        this._generateDiffuseTexture = generate;
        this._needInitialization = true;
    }
    /**
     * Gets or sets the feature (texture) to be debugged. Not used if debug is false
     */ get debugFeature() {
        return this._debugFeature;
    }
    set debugFeature(feature) {
        if (this._debugFeature === feature) return;
        this._needInitialization = true;
        this._debugFeature = feature;
    }
    /**
     * Gets or sets a boolean indicating if we should display a specific texture (given by debugFeature) for debugging purpose
     */ get debug() {
        return this._debug;
    }
    set debug(debug) {
        if (this._debug === debug) return;
        this._debug = debug;
        this._needInitialization = true;
    }
    /**
     * Gets or sets the environment map used for the reflection part of the shading
     * If null, no map will be used. If undefined, the scene.environmentMap will be used (if defined)
     */ get environmentMap() {
        return this._environmentMap;
    }
    set environmentMap(map) {
        if (this._environmentMap === map) return;
        this._needInitialization = true;
        this._environmentMap = map;
    }
    /**
     * Gets or sets a boolean indicating that the depth texture should be blurred
     */ get enableBlurDepth() {
        return this._enableBlurDepth;
    }
    set enableBlurDepth(enable) {
        if (this._enableBlurDepth === enable) return;
        this._enableBlurDepth = enable;
        this._needInitialization = true;
    }
    /**
     * Gets or sets the depth size divisor (positive number, generally between 1 and 4), which is used as a divisor when creating the texture used for blurring the depth
     * For eg. if blurDepthSizeDivisor=2, the texture used to blur the depth will be half the size of the depth texture
     */ get blurDepthSizeDivisor() {
        return this._blurDepthSizeDivisor;
    }
    set blurDepthSizeDivisor(scale) {
        if (this._blurDepthSizeDivisor === scale) return;
        this._blurDepthSizeDivisor = scale;
        this._needInitialization = true;
    }
    /**
     * Size of the kernel used to filter the depth blur texture (positive number, generally between 1 and 20 - higher values will require more processing power from the GPU)
     */ get blurDepthFilterSize() {
        return this._blurDepthFilterSize;
    }
    set blurDepthFilterSize(filterSize) {
        if (this._blurDepthFilterSize === filterSize) return;
        this._blurDepthFilterSize = filterSize;
        this._setBlurParameters();
    }
    /**
     * Number of blurring iterations used to generate the depth blur texture (positive number, generally between 1 and 10 - higher values will require more processing power from the GPU)
     */ get blurDepthNumIterations() {
        return this._blurDepthNumIterations;
    }
    set blurDepthNumIterations(numIterations) {
        if (this._blurDepthNumIterations === numIterations) return;
        this._blurDepthNumIterations = numIterations;
        this._setBlurParameters();
    }
    /**
     * Maximum size of the kernel used to blur the depth texture (positive number, generally between 1 and 200 - higher values will require more processing power from the GPU when the particles are larger on screen)
     */ get blurDepthMaxFilterSize() {
        return this._blurDepthMaxFilterSize;
    }
    set blurDepthMaxFilterSize(maxFilterSize) {
        if (this._blurDepthMaxFilterSize === maxFilterSize) return;
        this._blurDepthMaxFilterSize = maxFilterSize;
        this._setBlurParameters();
    }
    /**
     * Depth weight in the calculation when applying the bilateral blur to generate the depth blur texture (positive number, generally between 0 and 100)
     */ get blurDepthDepthScale() {
        return this._blurDepthDepthScale;
    }
    set blurDepthDepthScale(scale) {
        if (this._blurDepthDepthScale === scale) return;
        this._blurDepthDepthScale = scale;
        this._setBlurParameters();
    }
    /**
     * Gets or sets a boolean indicating that the thickness texture should be blurred
     */ get enableBlurThickness() {
        return this._enableBlurThickness;
    }
    set enableBlurThickness(enable) {
        if (this._enableBlurThickness === enable) return;
        this._enableBlurThickness = enable;
        this._needInitialization = true;
    }
    /**
     * Gets or sets the thickness size divisor (positive number, generally between 1 and 4), which is used as a divisor when creating the texture used for blurring the thickness
     * For eg. if blurThicknessSizeDivisor=2, the texture used to blur the thickness will be half the size of the thickness texture
     */ get blurThicknessSizeDivisor() {
        return this._blurThicknessSizeDivisor;
    }
    set blurThicknessSizeDivisor(scale) {
        if (this._blurThicknessSizeDivisor === scale) return;
        this._blurThicknessSizeDivisor = scale;
        this._needInitialization = true;
    }
    /**
     * Size of the kernel used to filter the thickness blur texture (positive number, generally between 1 and 20 - higher values will require more processing power from the GPU)
     */ get blurThicknessFilterSize() {
        return this._blurThicknessFilterSize;
    }
    set blurThicknessFilterSize(filterSize) {
        if (this._blurThicknessFilterSize === filterSize) return;
        this._blurThicknessFilterSize = filterSize;
        this._setBlurParameters();
    }
    /**
     * Number of blurring iterations used to generate the thickness blur texture (positive number, generally between 1 and 10 - higher values will require more processing power from the GPU)
     */ get blurThicknessNumIterations() {
        return this._blurThicknessNumIterations;
    }
    set blurThicknessNumIterations(numIterations) {
        if (this._blurThicknessNumIterations === numIterations) return;
        this._blurThicknessNumIterations = numIterations;
        this._setBlurParameters();
    }
    /**
     * Gets or sets a boolean indicating that a fixed thickness should be used instead of generating a thickness texture
     */ get useFixedThickness() {
        return this._useFixedThickness;
    }
    set useFixedThickness(use) {
        if (this._useFixedThickness === use) return;
        this._useFixedThickness = use;
        this._needInitialization = true;
    }
    /**
     * Gets or sets a boolean indicating that the velocity should be used when rendering the particles as a fluid.
     * Note: the vertex buffers must contain a "velocity" buffer for this to work!
     */ get useVelocity() {
        return this._useVelocity;
    }
    set useVelocity(use) {
        if (this._useVelocity === use) return;
        this._useVelocity = use;
        this._needInitialization = true;
        this._onUseVelocityChanged.notifyObservers(this);
    }
    /**
     * Defines the size of the depth texture.
     * If null, the texture will have the size of the screen
     */ get depthMapSize() {
        return this._depthMapSize;
    }
    set depthMapSize(size) {
        if (this._depthMapSize === size) return;
        this._depthMapSize = size;
        this._needInitialization = true;
    }
    /**
     * Defines the size of the thickness texture.
     * If null, the texture will have the size of the screen
     */ get thicknessMapSize() {
        return this._thicknessMapSize;
    }
    set thicknessMapSize(size) {
        if (this._thicknessMapSize === size) return;
        this._thicknessMapSize = size;
        this._needInitialization = true;
    }
    /**
     * Defines the size of the diffuse texture.
     * If null, the texture will have the size of the screen
     */ get diffuseMapSize() {
        return this._diffuseMapSize;
    }
    set diffuseMapSize(size) {
        if (this._diffuseMapSize === size) return;
        this._diffuseMapSize = size;
        this._needInitialization = true;
    }
    /**
     * Gets or sets the number of samples used by MSAA
     * Note: changing this value in WebGL does not work because depth/stencil textures can't be created with MSAA (see https://github.com/BabylonJS/Babylon.js/issues/12444)
     */ get samples() {
        return this._samples;
    }
    set samples(samples) {
        if (this._samples === samples) return;
        this._samples = samples;
        this._needInitialization = true;
    }
    /**
     * Gets the camera used for the rendering
     */ get camera() {
        return this._camera;
    }
    /**
     * Creates an instance of the class
     * @param scene Scene used to render the fluid object into
     * @param camera Camera used to render the fluid object. If not provided, use the active camera of the scene instead
     */ constructor(scene, camera){
        this._generateDiffuseTexture = false;
        /**
         * Fluid color. Not used if generateDiffuseTexture is true
         */ this.fluidColor = new (0, $7etnY.Color3)(0.085, 0.6375, 0.765);
        /**
         * Density of the fluid (positive number). The higher the value, the more opaque the fluid.
         */ this.density = 2;
        /**
         * Strength of the refraction (positive number, but generally between 0 and 0.3).
         */ this.refractionStrength = 0.1;
        /**
         * Strength of the fresnel effect (value between 0 and 1). Lower the value if you want to soften the specular effect
         */ this.fresnelClamp = 1.0;
        /**
         * Strength of the specular power (positive number). Increase the value to make the specular effect more concentrated
         */ this.specularPower = 250;
        /**
         * Minimum thickness of the particles (positive number). If useFixedThickness is true, minimumThickness is the thickness used
         */ this.minimumThickness = 0;
        /**
         * Direction of the light. The fluid is assumed to be lit by a directional light
         */ this.dirLight = new (0, $ha1VO.Vector3)(-2, -1, 1).normalize();
        this._debugFeature = $2a9b704603bf0dc0$export$b9788f5e4142aafd.DepthBlurredTexture;
        this._debug = false;
        this._enableBlurDepth = true;
        this._blurDepthSizeDivisor = 1;
        this._blurDepthFilterSize = 7;
        this._blurDepthNumIterations = 3;
        this._blurDepthMaxFilterSize = 100;
        this._blurDepthDepthScale = 10;
        this._enableBlurThickness = true;
        this._blurThicknessSizeDivisor = 1;
        this._blurThicknessFilterSize = 5;
        this._blurThicknessNumIterations = 1;
        this._useFixedThickness = false;
        /** @internal */ this._onUseVelocityChanged = new (0, $diGQf.Observable)();
        this._useVelocity = false;
        this._depthMapSize = null;
        this._thicknessMapSize = null;
        this._diffuseMapSize = null;
        this._samples = 1;
        this._scene = scene;
        this._engine = scene.getEngine();
        this._camera = camera ?? scene.activeCamera;
        this._needInitialization = true;
        this._bgDepthTexture = null;
        this._invProjectionMatrix = new (0, $ha1VO.Matrix)();
        this._depthClearColor = new (0, $7etnY.Color4)(1e6, 1e6, 1e6, 1);
        this._thicknessClearColor = new (0, $7etnY.Color4)(0, 0, 0, 1);
        this._depthRenderTarget = null;
        this._diffuseRenderTarget = null;
        this._thicknessRenderTarget = null;
        this._renderPostProcess = null;
    }
    /** @internal */ _initialize() {
        this.dispose();
        this._needInitialization = false;
        const depthWidth = this._depthMapSize ?? this._engine.getRenderWidth();
        const depthHeight = this._depthMapSize !== null ? Math.round(this._depthMapSize * this._engine.getRenderHeight() / this._engine.getRenderWidth()) : this._engine.getRenderHeight();
        this._depthRenderTarget = new (0, $Q7RAZ.FluidRenderingTextures)("Depth", this._scene, depthWidth, depthHeight, depthWidth, depthHeight, 1, 7, 1, 7, false, this._camera, true, this._samples);
        this._initializeRenderTarget(this._depthRenderTarget);
        if (this.generateDiffuseTexture) {
            const diffuseWidth = this._diffuseMapSize ?? this._engine.getRenderWidth();
            const diffuseHeight = this._diffuseMapSize !== null ? Math.round(this._diffuseMapSize * this._engine.getRenderHeight() / this._engine.getRenderWidth()) : this._engine.getRenderHeight();
            this._diffuseRenderTarget = new (0, $Q7RAZ.FluidRenderingTextures)("Diffuse", this._scene, diffuseWidth, diffuseHeight, 0, 0, 0, 5, 0, 5, true, this._camera, true, this._samples);
            this._initializeRenderTarget(this._diffuseRenderTarget);
        }
        const thicknessWidth = this._thicknessMapSize ?? this._engine.getRenderWidth();
        const thicknessHeight = this._thicknessMapSize !== null ? Math.round(this._thicknessMapSize * this._engine.getRenderHeight() / this._engine.getRenderWidth()) : this._engine.getRenderHeight();
        if (!this._useFixedThickness) {
            this._thicknessRenderTarget = new (0, $Q7RAZ.FluidRenderingTextures)("Thickness", this._scene, thicknessWidth, thicknessHeight, thicknessWidth, thicknessHeight, 2, 6, 2, 6, true, this._camera, false, this._samples);
            this._initializeRenderTarget(this._thicknessRenderTarget);
        }
        this._createLiquidRenderingPostProcess();
    }
    _setBlurParameters(renderTarget = null) {
        if (renderTarget === null || renderTarget === this._depthRenderTarget) this._setBlurDepthParameters();
        if (renderTarget === null || renderTarget === this._thicknessRenderTarget) this._setBlurThicknessParameters();
    }
    _setBlurDepthParameters() {
        if (!this._depthRenderTarget) return;
        this._depthRenderTarget.blurFilterSize = this.blurDepthFilterSize;
        this._depthRenderTarget.blurMaxFilterSize = this.blurDepthMaxFilterSize;
        this._depthRenderTarget.blurNumIterations = this.blurDepthNumIterations;
        this._depthRenderTarget.blurDepthScale = this.blurDepthDepthScale;
    }
    _setBlurThicknessParameters() {
        if (!this._thicknessRenderTarget) return;
        this._thicknessRenderTarget.blurFilterSize = this.blurThicknessFilterSize;
        this._thicknessRenderTarget.blurNumIterations = this.blurThicknessNumIterations;
    }
    _initializeRenderTarget(renderTarget) {
        if (renderTarget !== this._diffuseRenderTarget) {
            renderTarget.enableBlur = renderTarget === this._depthRenderTarget ? this.enableBlurDepth : this.enableBlurThickness;
            renderTarget.blurSizeDivisor = renderTarget === this._depthRenderTarget ? this.blurDepthSizeDivisor : this.blurThicknessSizeDivisor;
        }
        this._setBlurParameters(renderTarget);
        renderTarget.initialize();
    }
    _createLiquidRenderingPostProcess() {
        const engine = this._scene.getEngine();
        const uniformNames = [
            "viewMatrix",
            "projectionMatrix",
            "invProjectionMatrix",
            "texelSize",
            "dirLight",
            "cameraFar",
            "density",
            "refractionStrength",
            "fresnelClamp",
            "specularPower"
        ];
        const samplerNames = [
            "depthSampler"
        ];
        const defines = [];
        this.dispose(true);
        if (!this._camera) return;
        const texture = this._depthRenderTarget.enableBlur ? this._depthRenderTarget.textureBlur : this._depthRenderTarget.texture;
        const texelSize = new (0, $ha1VO.Vector2)(1 / texture.getSize().width, 1 / texture.getSize().height);
        if (this._scene.useRightHandedSystem) defines.push("#define FLUIDRENDERING_RHS");
        if (this._environmentMap !== null) {
            const envMap = this._environmentMap ?? this._scene.environmentTexture;
            if (envMap) {
                samplerNames.push("reflectionSampler");
                defines.push("#define FLUIDRENDERING_ENVIRONMENT");
            }
        }
        if (this._diffuseRenderTarget) {
            samplerNames.push("diffuseSampler");
            defines.push("#define FLUIDRENDERING_DIFFUSETEXTURE");
        } else uniformNames.push("diffuseColor");
        if (this._useVelocity) {
            samplerNames.push("velocitySampler");
            defines.push("#define FLUIDRENDERING_VELOCITY");
        }
        if (this._useFixedThickness) {
            uniformNames.push("thickness");
            samplerNames.push("bgDepthSampler");
            defines.push("#define FLUIDRENDERING_FIXED_THICKNESS");
        } else {
            uniformNames.push("minimumThickness");
            samplerNames.push("thicknessSampler");
        }
        if (this._debug) {
            defines.push("#define FLUIDRENDERING_DEBUG");
            if (this._debugFeature === $2a9b704603bf0dc0$export$b9788f5e4142aafd.Normals) defines.push("#define FLUIDRENDERING_DEBUG_SHOWNORMAL");
            else if (this._debugFeature === $2a9b704603bf0dc0$export$b9788f5e4142aafd.DiffuseRendering) defines.push("#define FLUIDRENDERING_DEBUG_DIFFUSERENDERING");
            else {
                defines.push("#define FLUIDRENDERING_DEBUG_TEXTURE");
                samplerNames.push("debugSampler");
                if (this._debugFeature === $2a9b704603bf0dc0$export$b9788f5e4142aafd.DepthTexture || this._debugFeature === $2a9b704603bf0dc0$export$b9788f5e4142aafd.DepthBlurredTexture) defines.push("#define FLUIDRENDERING_DEBUG_DEPTH");
            }
        }
        this._renderPostProcess = new (0, $cFdBb.PostProcess)("FluidRendering", "fluidRenderingRender", uniformNames, samplerNames, 1, null, 2, engine, false, null, 0, undefined, undefined, true, undefined);
        this._renderPostProcess.updateEffect(defines.join("\n"));
        this._renderPostProcess.samples = this._samples;
        this._renderPostProcess.onApplyObservable.add((effect)=>{
            this._invProjectionMatrix.copyFrom(this._scene.getProjectionMatrix());
            this._invProjectionMatrix.invert();
            if (engine.isWebGPU) effect.setTextureSampler("textureSamplerSampler", this._renderPostProcess.inputTexture.texture);
            if (!this._depthRenderTarget.enableBlur) {
                effect.setTexture("depthSampler", this._depthRenderTarget.texture);
                if (engine.isWebGPU) effect.setTextureSampler("depthSamplerSampler", this._depthRenderTarget.texture?.getInternalTexture() ?? null);
            } else {
                effect.setTexture("depthSampler", this._depthRenderTarget.textureBlur);
                if (engine.isWebGPU) effect.setTextureSampler("depthSamplerSampler", this._depthRenderTarget.textureBlur?.getInternalTexture() ?? null);
            }
            if (this._diffuseRenderTarget) {
                if (!this._diffuseRenderTarget.enableBlur) {
                    effect.setTexture("diffuseSampler", this._diffuseRenderTarget.texture);
                    if (engine.isWebGPU) effect.setTextureSampler("diffuseSamplerSampler", this._diffuseRenderTarget.texture?.getInternalTexture() ?? null);
                } else {
                    effect.setTexture("diffuseSampler", this._diffuseRenderTarget.textureBlur);
                    if (engine.isWebGPU) effect.setTextureSampler("diffuseSamplerSampler", this._diffuseRenderTarget.textureBlur?.getInternalTexture() ?? null);
                }
            } else effect.setColor3("diffuseColor", this.fluidColor);
            if (this._useFixedThickness) {
                effect.setFloat("thickness", this.minimumThickness);
                effect._bindTexture("bgDepthSampler", this._bgDepthTexture);
                if (engine.isWebGPU) effect.setTextureSampler("bgDepthSamplerSampler", this._bgDepthTexture ?? null);
            } else {
                if (!this._thicknessRenderTarget.enableBlur) {
                    effect.setTexture("thicknessSampler", this._thicknessRenderTarget.texture);
                    if (engine.isWebGPU) effect.setTextureSampler("thicknessSamplerSampler", this._thicknessRenderTarget.texture?.getInternalTexture() ?? null);
                } else {
                    effect.setTexture("thicknessSampler", this._thicknessRenderTarget.textureBlur);
                    if (engine.isWebGPU) effect.setTextureSampler("thicknessSamplerSampler", this._thicknessRenderTarget.textureBlur?.getInternalTexture() ?? null);
                }
                effect.setFloat("minimumThickness", this.minimumThickness);
            }
            if (this._environmentMap !== null) {
                const envMap = this._environmentMap ?? this._scene.environmentTexture;
                if (envMap) {
                    effect.setTexture("reflectionSampler", envMap);
                    if (engine.isWebGPU) effect.setTextureSampler("reflectionSamplerSampler", envMap?.getInternalTexture() ?? null);
                }
            }
            effect.setMatrix("viewMatrix", this._scene.getViewMatrix());
            effect.setMatrix("invProjectionMatrix", this._invProjectionMatrix);
            effect.setMatrix("projectionMatrix", this._scene.getProjectionMatrix());
            effect.setVector2("texelSize", texelSize);
            effect.setFloat("density", this.density);
            effect.setFloat("refractionStrength", this.refractionStrength);
            effect.setFloat("fresnelClamp", this.fresnelClamp);
            effect.setFloat("specularPower", this.specularPower);
            effect.setVector3("dirLight", this.dirLight);
            effect.setFloat("cameraFar", this._camera.maxZ);
            if (this._debug) {
                let texture = null;
                switch(this._debugFeature){
                    case $2a9b704603bf0dc0$export$b9788f5e4142aafd.DepthTexture:
                        texture = this._depthRenderTarget.texture;
                        break;
                    case $2a9b704603bf0dc0$export$b9788f5e4142aafd.DepthBlurredTexture:
                        texture = this._depthRenderTarget.enableBlur ? this._depthRenderTarget.textureBlur : this._depthRenderTarget.texture;
                        break;
                    case $2a9b704603bf0dc0$export$b9788f5e4142aafd.ThicknessTexture:
                        texture = this._thicknessRenderTarget?.texture ?? null;
                        break;
                    case $2a9b704603bf0dc0$export$b9788f5e4142aafd.ThicknessBlurredTexture:
                        texture = this._thicknessRenderTarget?.enableBlur ? this._thicknessRenderTarget?.textureBlur ?? null : this._thicknessRenderTarget?.texture ?? null;
                        break;
                    case $2a9b704603bf0dc0$export$b9788f5e4142aafd.DiffuseTexture:
                        if (this._diffuseRenderTarget) texture = this._diffuseRenderTarget.texture;
                        break;
                }
                if (this._debugFeature !== $2a9b704603bf0dc0$export$b9788f5e4142aafd.Normals) {
                    effect.setTexture("debugSampler", texture);
                    if (engine.isWebGPU) effect.setTextureSampler("debugSamplerSampler", texture?.getInternalTexture() ?? null);
                }
            }
        });
    }
    /** @internal */ _clearTargets() {
        if (this._depthRenderTarget?.renderTarget) {
            this._engine.bindFramebuffer(this._depthRenderTarget.renderTarget);
            this._engine.clear(this._depthClearColor, true, true, false);
            this._engine.unBindFramebuffer(this._depthRenderTarget.renderTarget);
        }
        if (this._diffuseRenderTarget?.renderTarget) {
            this._engine.bindFramebuffer(this._diffuseRenderTarget.renderTarget);
            this._engine.clear(this._thicknessClearColor, true, true, false);
            this._engine.unBindFramebuffer(this._diffuseRenderTarget.renderTarget);
        }
        if (this._thicknessRenderTarget?.renderTarget) {
            this._engine.bindFramebuffer(this._thicknessRenderTarget.renderTarget);
            // we don't clear the depth buffer because it is the depth buffer that is coming from the scene and that we reuse in the thickness rendering pass
            this._engine.clear(this._thicknessClearColor, true, false, false);
            this._engine.unBindFramebuffer(this._thicknessRenderTarget.renderTarget);
        }
    }
    /** @internal */ _render(fluidObject) {
        if (this._needInitialization || !fluidObject.isReady()) return;
        const currentRenderTarget = this._engine._currentRenderTarget;
        this._engine.setState(false, undefined, undefined, undefined, true);
        this._engine.setDepthBuffer(true);
        this._engine.setDepthWrite(true);
        this._engine.setAlphaMode(0);
        // Render the particles in the depth texture
        if (this._depthRenderTarget?.renderTarget) {
            this._engine.bindFramebuffer(this._depthRenderTarget.renderTarget);
            fluidObject.renderDepthTexture();
            this._engine.unbindInstanceAttributes();
            this._engine.unBindFramebuffer(this._depthRenderTarget.renderTarget);
        }
        // Render the particles in the diffuse texture
        if (this._diffuseRenderTarget?.renderTarget) {
            this._engine.bindFramebuffer(this._diffuseRenderTarget.renderTarget);
            fluidObject.renderDiffuseTexture();
            this._engine.unbindInstanceAttributes();
            this._engine.unBindFramebuffer(this._diffuseRenderTarget.renderTarget);
        }
        // Render the particles in the thickness texture
        if (this._thicknessRenderTarget?.renderTarget) {
            this._engine.bindFramebuffer(this._thicknessRenderTarget.renderTarget);
            fluidObject.renderThicknessTexture();
            this._engine.unbindInstanceAttributes();
            this._engine.unBindFramebuffer(this._thicknessRenderTarget.renderTarget);
        }
        // Run the blur post processes
        this._depthRenderTarget?.applyBlurPostProcesses();
        this._diffuseRenderTarget?.applyBlurPostProcesses();
        this._thicknessRenderTarget?.applyBlurPostProcesses();
        if (currentRenderTarget) this._engine.bindFramebuffer(currentRenderTarget);
    }
    /**
     * Releases all the ressources used by the class
     * @param onlyPostProcesses If true, releases only the ressources used by the render post processes
     */ dispose(onlyPostProcesses = false) {
        if (!onlyPostProcesses) {
            this._depthRenderTarget?.dispose();
            this._depthRenderTarget = null;
            this._diffuseRenderTarget?.dispose();
            this._diffuseRenderTarget = null;
            this._thicknessRenderTarget?.dispose();
            this._thicknessRenderTarget = null;
        }
        if (this._renderPostProcess && this._camera) this._camera.detachPostProcess(this._renderPostProcess);
        this._renderPostProcess?.dispose();
        this._renderPostProcess = null;
        this._needInitialization = false;
    }
}

});
parcelRegister("Q7RAZ", function(module, exports) {

$parcel$export(module.exports, "FluidRenderingTextures", () => $09caf4f5a0de03d0$export$52284af45c28dfa);

var $j2mX5 = parcelRequire("j2mX5");

var $ha1VO = parcelRequire("ha1VO");

var $cFdBb = parcelRequire("cFdBb");

var $diGQf = parcelRequire("diGQf");
class $09caf4f5a0de03d0$export$52284af45c28dfa {
    get blurNumIterations() {
        return this._blurNumIterations;
    }
    set blurNumIterations(numIterations) {
        if (this._blurNumIterations === numIterations) return;
        this._blurNumIterations = numIterations;
        if (this._blurPostProcesses !== null) {
            const blurX = this._blurPostProcesses[0];
            const blurY = this._blurPostProcesses[1];
            this._blurPostProcesses = [];
            for(let i = 0; i < this._blurNumIterations * 2; ++i)this._blurPostProcesses[i] = i & 1 ? blurY : blurX;
        }
    }
    get renderTarget() {
        return this._rt;
    }
    get renderTargetBlur() {
        return this._rtBlur;
    }
    get texture() {
        return this._texture;
    }
    get textureBlur() {
        return this._textureBlurred;
    }
    constructor(name, scene, width, height, blurTextureSizeX, blurTextureSizeY, textureType = 1, textureFormat = 6, blurTextureType = 1, blurTextureFormat = 6, useStandardBlur = false, camera = null, generateDepthBuffer = true, samples = 1){
        this.enableBlur = true;
        this.blurSizeDivisor = 1;
        this.blurFilterSize = 7;
        this._blurNumIterations = 3;
        this.blurMaxFilterSize = 100;
        this.blurDepthScale = 10;
        this.particleSize = 0.02;
        this.onDisposeObservable = new (0, $diGQf.Observable)();
        this._name = name;
        this._scene = scene;
        this._camera = camera;
        this._engine = scene.getEngine();
        this._width = width;
        this._height = height;
        this._blurTextureSizeX = blurTextureSizeX;
        this._blurTextureSizeY = blurTextureSizeY;
        this._textureType = textureType;
        this._textureFormat = textureFormat;
        this._blurTextureType = blurTextureType;
        this._blurTextureFormat = blurTextureFormat;
        this._useStandardBlur = useStandardBlur;
        this._generateDepthBuffer = generateDepthBuffer;
        this._samples = samples;
        this._postProcessRunningIndex = 0;
        this.enableBlur = blurTextureSizeX !== 0 && blurTextureSizeY !== 0;
        this._rt = null;
        this._texture = null;
        this._rtBlur = null;
        this._textureBlurred = null;
        this._blurPostProcesses = null;
    }
    initialize() {
        this.dispose();
        this._createRenderTarget();
        if (this.enableBlur && this._texture) {
            const [rtBlur, textureBlurred, blurPostProcesses] = this._createBlurPostProcesses(this._texture, this._blurTextureType, this._blurTextureFormat, this.blurSizeDivisor, this._name, this._useStandardBlur);
            this._rtBlur = rtBlur;
            this._textureBlurred = textureBlurred;
            this._blurPostProcesses = blurPostProcesses;
        }
    }
    applyBlurPostProcesses() {
        if (this.enableBlur && this._blurPostProcesses) {
            this._postProcessRunningIndex = 0;
            this._scene.postProcessManager.directRender(this._blurPostProcesses, this._rtBlur, true);
            this._engine.unBindFramebuffer(this._rtBlur);
        }
    }
    _createRenderTarget() {
        this._rt = this._engine.createRenderTargetTexture({
            width: this._width,
            height: this._height
        }, {
            generateMipMaps: false,
            type: this._textureType,
            format: this._textureFormat,
            samplingMode: 1,
            generateDepthBuffer: this._generateDepthBuffer,
            generateStencilBuffer: false,
            samples: this._samples,
            label: `FluidRenderingRTT-${this._name}`
        });
        const renderTexture = this._rt.texture;
        renderTexture.incrementReferences();
        this._texture = new (0, $j2mX5.Texture)(null, this._scene);
        this._texture.name = "rtt" + this._name;
        this._texture._texture = renderTexture;
        this._texture.wrapU = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        this._texture.wrapV = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        this._texture.anisotropicFilteringLevel = 1;
    }
    _createBlurPostProcesses(textureBlurSource, textureType, textureFormat, blurSizeDivisor, debugName, useStandardBlur = false) {
        const engine = this._scene.getEngine();
        const targetSize = new (0, $ha1VO.Vector2)(Math.floor(this._blurTextureSizeX / blurSizeDivisor), Math.floor(this._blurTextureSizeY / blurSizeDivisor));
        const useBilinearFiltering = textureType === 1 && engine.getCaps().textureFloatLinearFiltering || textureType === 2 && engine.getCaps().textureHalfFloatLinearFiltering;
        const rtBlur = this._engine.createRenderTargetTexture({
            width: targetSize.x,
            height: targetSize.y
        }, {
            generateMipMaps: false,
            type: textureType,
            format: textureFormat,
            samplingMode: useBilinearFiltering ? 2 : 1,
            generateDepthBuffer: false,
            generateStencilBuffer: false,
            samples: this._samples,
            label: `FluidRenderingRTTBlur-${debugName}`
        });
        const renderTexture = rtBlur.texture;
        renderTexture.incrementReferences();
        const texture = new (0, $j2mX5.Texture)(null, this._scene);
        texture.name = "rttBlurred" + debugName;
        texture._texture = renderTexture;
        texture.wrapU = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        texture.wrapV = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
        texture.anisotropicFilteringLevel = 1;
        if (useStandardBlur) {
            const kernelBlurXPostprocess = new (0, $cFdBb.PostProcess)("BilateralBlurX", "fluidRenderingStandardBlur", [
                "filterSize",
                "blurDir"
            ], null, 1, null, 1, engine, true, null, textureType, undefined, undefined, undefined, textureFormat);
            kernelBlurXPostprocess.samples = this._samples;
            kernelBlurXPostprocess.externalTextureSamplerBinding = true;
            kernelBlurXPostprocess.onApplyObservable.add((effect)=>{
                if (this._postProcessRunningIndex === 0) effect.setTexture("textureSampler", textureBlurSource);
                else effect._bindTexture("textureSampler", kernelBlurXPostprocess.inputTexture.texture);
                effect.setInt("filterSize", this.blurFilterSize);
                effect.setFloat2("blurDir", 1 / this._blurTextureSizeX, 0);
                this._postProcessRunningIndex++;
            });
            kernelBlurXPostprocess.onSizeChangedObservable.add(()=>{
                kernelBlurXPostprocess._textures.forEach((rt)=>{
                    rt.texture.wrapU = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
                    rt.texture.wrapV = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
                });
            });
            this._fixReusablePostProcess(kernelBlurXPostprocess);
            const kernelBlurYPostprocess = new (0, $cFdBb.PostProcess)("BilateralBlurY", "fluidRenderingStandardBlur", [
                "filterSize",
                "blurDir"
            ], null, 1, null, 1, engine, true, null, textureType, undefined, undefined, undefined, textureFormat);
            kernelBlurYPostprocess.samples = this._samples;
            kernelBlurYPostprocess.onApplyObservable.add((effect)=>{
                effect.setInt("filterSize", this.blurFilterSize);
                effect.setFloat2("blurDir", 0, 1 / this._blurTextureSizeY);
                this._postProcessRunningIndex++;
            });
            kernelBlurYPostprocess.onSizeChangedObservable.add(()=>{
                kernelBlurYPostprocess._textures.forEach((rt)=>{
                    rt.texture.wrapU = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
                    rt.texture.wrapV = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
                });
            });
            this._fixReusablePostProcess(kernelBlurYPostprocess);
            kernelBlurXPostprocess.autoClear = false;
            kernelBlurYPostprocess.autoClear = false;
            const blurList = [];
            for(let i = 0; i < this._blurNumIterations * 2; ++i)blurList[i] = i & 1 ? kernelBlurYPostprocess : kernelBlurXPostprocess;
            return [
                rtBlur,
                texture,
                blurList
            ];
        } else {
            const uniforms = [
                "maxFilterSize",
                "blurDir",
                "projectedParticleConstant",
                "depthThreshold"
            ];
            const kernelBlurXPostprocess = new (0, $cFdBb.PostProcess)("BilateralBlurX", "fluidRenderingBilateralBlur", uniforms, null, 1, null, 1, engine, true, null, textureType, undefined, undefined, undefined, textureFormat);
            kernelBlurXPostprocess.samples = this._samples;
            kernelBlurXPostprocess.externalTextureSamplerBinding = true;
            kernelBlurXPostprocess.onApplyObservable.add((effect)=>{
                if (this._postProcessRunningIndex === 0) effect.setTexture("textureSampler", textureBlurSource);
                else effect._bindTexture("textureSampler", kernelBlurXPostprocess.inputTexture.texture);
                effect.setInt("maxFilterSize", this.blurMaxFilterSize);
                effect.setFloat2("blurDir", 1 / this._blurTextureSizeX, 0);
                effect.setFloat("projectedParticleConstant", this._getProjectedParticleConstant());
                effect.setFloat("depthThreshold", this._getDepthThreshold());
                this._postProcessRunningIndex++;
            });
            kernelBlurXPostprocess.onSizeChangedObservable.add(()=>{
                kernelBlurXPostprocess._textures.forEach((rt)=>{
                    rt.texture.wrapU = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
                    rt.texture.wrapV = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
                });
            });
            this._fixReusablePostProcess(kernelBlurXPostprocess);
            const kernelBlurYPostprocess = new (0, $cFdBb.PostProcess)("BilateralBlurY", "fluidRenderingBilateralBlur", uniforms, null, 1, null, 1, engine, true, null, textureType, undefined, undefined, undefined, textureFormat);
            kernelBlurYPostprocess.samples = this._samples;
            kernelBlurYPostprocess.onApplyObservable.add((effect)=>{
                effect.setInt("maxFilterSize", this.blurMaxFilterSize);
                effect.setFloat2("blurDir", 0, 1 / this._blurTextureSizeY);
                effect.setFloat("projectedParticleConstant", this._getProjectedParticleConstant());
                effect.setFloat("depthThreshold", this._getDepthThreshold());
                this._postProcessRunningIndex++;
            });
            kernelBlurYPostprocess.onSizeChangedObservable.add(()=>{
                kernelBlurYPostprocess._textures.forEach((rt)=>{
                    rt.texture.wrapU = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
                    rt.texture.wrapV = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
                });
            });
            this._fixReusablePostProcess(kernelBlurYPostprocess);
            kernelBlurXPostprocess.autoClear = false;
            kernelBlurYPostprocess.autoClear = false;
            const blurList = [];
            for(let i = 0; i < this._blurNumIterations * 2; ++i)blurList[i] = i & 1 ? kernelBlurYPostprocess : kernelBlurXPostprocess;
            return [
                rtBlur,
                texture,
                blurList
            ];
        }
    }
    _fixReusablePostProcess(pp) {
        if (!pp.isReusable()) return;
        pp.onActivateObservable.add(()=>{
            // undo what calling activate() does which will make sure we will retrieve the right texture when getting the input for the post process
            pp._currentRenderTextureInd = (pp._currentRenderTextureInd + 1) % 2;
        });
        pp.onApplyObservable.add(()=>{
            // now we can advance to the next texture
            pp._currentRenderTextureInd = (pp._currentRenderTextureInd + 1) % 2;
        });
    }
    _getProjectedParticleConstant() {
        return this.blurFilterSize * this.particleSize * 0.05 * (this._height / 2) / Math.tan((this._camera?.fov ?? 45 * Math.PI / 180) / 2);
    }
    _getDepthThreshold() {
        return this.particleSize / 2 * this.blurDepthScale;
    }
    dispose() {
        if (this.onDisposeObservable.hasObservers()) this.onDisposeObservable.notifyObservers(this);
        this._rt?.dispose();
        this._rt = null;
        this._texture?.dispose();
        this._texture = null;
        this._rtBlur?.dispose();
        this._rtBlur = null;
        this._textureBlurred?.dispose();
        this._textureBlurred = null;
        if (this._blurPostProcesses) {
            this._blurPostProcesses[0].dispose();
            this._blurPostProcesses[1].dispose();
        }
        this._blurPostProcesses = null;
    }
}

});


parcelRegister("5nRi8", function(module, exports) {

$parcel$export(module.exports, "FluidRenderingObjectCustomParticles", () => $3eb870516b7e6100$export$e4b3a94749b69f06);

var $b4i1f = parcelRequire("b4i1f");

var $iYGpr = parcelRequire("iYGpr");

var $dbgEa = parcelRequire("dbgEa");
class $3eb870516b7e6100$export$e4b3a94749b69f06 extends (0, $dbgEa.FluidRenderingObject) {
    /**
     * @returns the name of the class
     */ getClassName() {
        return "FluidRenderingObjectCustomParticles";
    }
    /**
     * Gets the vertex buffers
     */ get vertexBuffers() {
        return this._vertexBuffers;
    }
    /**
     * Creates a new instance of the class
     * @param scene The scene the particles should be rendered into
     * @param buffers The list of buffers (must contain at least one "position" buffer!). Note that you don't have to pass all (or any!) buffers at once in the constructor, you can use the addBuffers method to add more later.
     * @param numParticles Number of vertices to take into account from the buffers
     */ constructor(scene, buffers, numParticles){
        super(scene);
        this._numParticles = numParticles;
        this._diffuseEffectWrapper = null;
        this._vertexBuffers = {};
        this.addBuffers(buffers);
    }
    /**
     * Add some new buffers
     * @param buffers List of buffers
     */ addBuffers(buffers) {
        for(const name in buffers){
            let stride;
            let instanced = true;
            switch(name){
                case "velocity":
                    stride = 3;
                    break;
                case "offset":
                    instanced = false;
                    break;
            }
            this._vertexBuffers[name] = new (0, $b4i1f.VertexBuffer)(this._engine, buffers[name], name, true, false, stride, instanced);
        }
    }
    _createEffects() {
        super._createEffects();
        const uniformNames = [
            "view",
            "projection",
            "size"
        ];
        const attributeNames = [
            "position",
            "offset",
            "color"
        ];
        this._diffuseEffectWrapper = new (0, $iYGpr.EffectWrapper)({
            engine: this._engine,
            useShaderStore: true,
            vertexShader: "fluidRenderingParticleDiffuse",
            fragmentShader: "fluidRenderingParticleDiffuse",
            attributeNames: attributeNames,
            uniformNames: uniformNames,
            samplerNames: []
        });
    }
    /**
     * Indicates if the object is ready to be rendered
     * @returns True if everything is ready for the object to be rendered, otherwise false
     */ isReady() {
        if (!this._vertexBuffers["offset"]) this._vertexBuffers["offset"] = new (0, $b4i1f.VertexBuffer)(this._engine, [
            0,
            0,
            1,
            0,
            0,
            1,
            1,
            1
        ], "offset", false, false, 2);
        return super.isReady() && (this._diffuseEffectWrapper?.effect.isReady() ?? false);
    }
    /**
     * Gets the number of particles in this object
     * @returns The number of particles
     */ get numParticles() {
        return this._numParticles;
    }
    /**
     * Sets the number of particles in this object
     * @param num The number of particles to take into account
     */ setNumParticles(num) {
        this._numParticles = num;
    }
    /**
     * Render the diffuse texture for this object
     */ renderDiffuseTexture() {
        const numParticles = this.numParticles;
        if (!this._diffuseEffectWrapper || numParticles === 0) return;
        const diffuseDrawWrapper = this._diffuseEffectWrapper._drawWrapper;
        const diffuseEffect = diffuseDrawWrapper.effect;
        this._engine.enableEffect(diffuseDrawWrapper);
        this._engine.bindBuffers(this.vertexBuffers, this.indexBuffer, diffuseEffect);
        diffuseEffect.setMatrix("view", this._scene.getViewMatrix());
        diffuseEffect.setMatrix("projection", this._scene.getProjectionMatrix());
        if (this._particleSize !== null) diffuseEffect.setFloat2("size", this._particleSize, this._particleSize);
        if (this.useInstancing) this._engine.drawArraysType(7, 0, 4, numParticles);
        else this._engine.drawElementsType(0, 0, numParticles);
    }
    /**
     * Releases the ressources used by the class
     */ dispose() {
        super.dispose();
        this._diffuseEffectWrapper?.dispose();
        for(const name in this._vertexBuffers)this._vertexBuffers[name].dispose();
        this._vertexBuffers = {};
    }
}

});

parcelRegister("dygQs", function(module, exports) {

$parcel$export(module.exports, "FluidRenderingDepthTextureCopy", () => $028bcc755ab62785$export$2ff681cbed1739d6);

var $ieflZ = parcelRequire("ieflZ");
class $028bcc755ab62785$export$2ff681cbed1739d6 {
    get depthRTWrapper() {
        return this._depthRTWrapper;
    }
    constructor(engine, width, height, samples = 1){
        this._engine = engine;
        this._copyTextureToTexture = new (0, $ieflZ.CopyTextureToTexture)(engine, true);
        this._depthRTWrapper = this._engine.createRenderTargetTexture({
            width: width,
            height: height
        }, {
            generateMipMaps: false,
            type: 0,
            format: 6,
            samplingMode: 1,
            generateDepthBuffer: true,
            generateStencilBuffer: false,
            samples: samples,
            noColorAttachment: true,
            label: "FluidRenderingDepthTextureCopyRTT"
        });
        const depthTexture = this._depthRTWrapper.createDepthStencilTexture(0, false, false, 1, undefined, "FluidRenderingDepthTextureCopyRTTDepthStencil");
        depthTexture.label = `FluidDepthTextureCopy${width}x${height}x${samples}`;
    }
    copy(source) {
        return this._copyTextureToTexture.copy(source, this._depthRTWrapper);
    }
    dispose() {
        this._depthRTWrapper.dispose();
        this._copyTextureToTexture.dispose();
    }
}

});
parcelRegister("ieflZ", function(module, exports) {

$parcel$export(module.exports, "ConversionMode", () => $d45571ba1e1d5325$export$9b1d4baea89337a7);
$parcel$export(module.exports, "CopyTextureToTexture", () => $d45571ba1e1d5325$export$f153231c2270c318);

var $iYGpr = parcelRequire("iYGpr");
parcelRequire("d6goL");
var $d45571ba1e1d5325$export$9b1d4baea89337a7;
(function(ConversionMode) {
    ConversionMode[ConversionMode["None"] = 0] = "None";
    ConversionMode[ConversionMode["ToLinearSpace"] = 1] = "ToLinearSpace";
    ConversionMode[ConversionMode["ToGammaSpace"] = 2] = "ToGammaSpace";
})($d45571ba1e1d5325$export$9b1d4baea89337a7 || ($d45571ba1e1d5325$export$9b1d4baea89337a7 = {}));
class $d45571ba1e1d5325$export$f153231c2270c318 {
    _textureIsInternal(texture) {
        return texture.getInternalTexture === undefined;
    }
    /**
     * Constructs a new instance of the class
     * @param engine The engine to use for the copy
     * @param isDepthTexture True means that we should write (using gl_FragDepth) into the depth texture attached to the destination (default: false)
     */ constructor(engine, isDepthTexture = false){
        this._engine = engine;
        this._isDepthTexture = isDepthTexture;
        this._renderer = new (0, $iYGpr.EffectRenderer)(engine);
        this._effectWrapper = new (0, $iYGpr.EffectWrapper)({
            engine: engine,
            name: "CopyTextureToTexture",
            fragmentShader: "copyTextureToTexture",
            useShaderStore: true,
            uniformNames: [
                "conversion"
            ],
            samplerNames: [
                "textureSampler"
            ],
            defines: isDepthTexture ? [
                "#define DEPTH_TEXTURE"
            ] : []
        });
        this._effectWrapper.onApplyObservable.add(()=>{
            if (isDepthTexture) {
                engine.setState(false);
                engine.setDepthBuffer(true);
                engine.depthCullingState.depthMask = true;
                engine.depthCullingState.depthFunc = 519;
            }
            if (this._textureIsInternal(this._source)) this._effectWrapper.effect._bindTexture("textureSampler", this._source);
            else this._effectWrapper.effect.setTexture("textureSampler", this._source);
            this._effectWrapper.effect.setFloat("conversion", this._conversion);
        });
    }
    /**
     * Indicates if the effect is ready to be used for the copy
     * @returns true if "copy" can be called without delay, else false
     */ isReady() {
        return this._effectWrapper.effect.isReady();
    }
    /**
     * Copy one texture into another
     * @param source The source texture
     * @param destination The destination texture
     * @param conversion The conversion mode that should be applied when copying
     * @returns
     */ copy(source, destination, conversion = $d45571ba1e1d5325$export$9b1d4baea89337a7.None) {
        if (!this.isReady()) return false;
        this._source = source;
        this._conversion = conversion;
        const engineDepthFunc = this._engine.depthCullingState.depthFunc;
        this._renderer.render(this._effectWrapper, destination);
        if (this._isDepthTexture && engineDepthFunc) this._engine.depthCullingState.depthFunc = engineDepthFunc;
        return true;
    }
    /**
     * Releases all the resources used by the class
     */ dispose() {
        this._effectWrapper.dispose();
        this._renderer.dispose();
    }
}

});
parcelRegister("d6goL", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("7Hs3g");
const $98988e453ee1814f$var$name = "copyTextureToTexturePixelShader";
const $98988e453ee1814f$var$shader = `uniform float conversion;uniform sampler2D textureSampler;varying vec2 vUV;
#include<helperFunctions>
void main(void) 
{vec4 color=texture2D(textureSampler,vUV);
#ifdef DEPTH_TEXTURE
gl_FragDepth=color.r;
#else
if (conversion==1.) {color=toLinearSpace(color);} else if (conversion==2.) {color=toGammaSpace(color);}
gl_FragColor=color;
#endif
}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$98988e453ee1814f$var$name] = $98988e453ee1814f$var$shader;
const $98988e453ee1814f$export$bd090b159f5513a7 = {
    name: $98988e453ee1814f$var$name,
    shader: $98988e453ee1814f$var$shader
};

});



parcelRegister("57J1X", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $3bb089513756473c$var$name = "fluidRenderingParticleDepthVertexShader";
const $3bb089513756473c$var$shader = `attribute vec3 position;attribute vec2 offset;uniform mat4 view;uniform mat4 projection;uniform vec2 size;varying vec2 uv;varying vec3 viewPos;varying float sphereRadius;
#ifdef FLUIDRENDERING_VELOCITY
attribute vec3 velocity;varying float velocityNorm;
#endif
void main(void) {vec3 cornerPos;cornerPos.xy=vec2(offset.x-0.5,offset.y-0.5)*size;cornerPos.z=0.0;viewPos=(view*vec4(position,1.0)).xyz;gl_Position=projection*vec4(viewPos+cornerPos,1.0);uv=offset;sphereRadius=size.x/2.0;
#ifdef FLUIDRENDERING_VELOCITY
velocityNorm=length(velocity);
#endif
}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$3bb089513756473c$var$name] = $3bb089513756473c$var$shader;
const $3bb089513756473c$export$eab7ef0fa53530 = {
    name: $3bb089513756473c$var$name,
    shader: $3bb089513756473c$var$shader
};

});

parcelRegister("nL5cn", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $0476abc52458a7d6$var$name = "fluidRenderingParticleDepthPixelShader";
const $0476abc52458a7d6$var$shader = `uniform mat4 projection;varying vec2 uv;varying vec3 viewPos;varying float sphereRadius;
#ifdef FLUIDRENDERING_VELOCITY
varying float velocityNorm;
#endif
void main(void) {vec3 normal;normal.xy=uv*2.0-1.0;float r2=dot(normal.xy,normal.xy);if (r2>1.0) discard;normal.z=sqrt(1.0-r2);
#ifndef FLUIDRENDERING_RHS
normal.z=-normal.z;
#endif
vec4 realViewPos=vec4(viewPos+normal*sphereRadius,1.0);vec4 clipSpacePos=projection*realViewPos;
#ifdef WEBGPU
gl_FragDepth=clipSpacePos.z/clipSpacePos.w;
#else
gl_FragDepth=(clipSpacePos.z/clipSpacePos.w)*0.5+0.5;
#endif
#ifdef FLUIDRENDERING_RHS
realViewPos.z=-realViewPos.z;
#endif
#ifdef FLUIDRENDERING_VELOCITY
glFragColor=vec4(realViewPos.z,velocityNorm,0.,1.);
#else
glFragColor=vec4(realViewPos.z,0.,0.,1.);
#endif
}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$0476abc52458a7d6$var$name] = $0476abc52458a7d6$var$shader;
const $0476abc52458a7d6$export$560c328a3eb3aa15 = {
    name: $0476abc52458a7d6$var$name,
    shader: $0476abc52458a7d6$var$shader
};

});

parcelRegister("sKKzI", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $0566e141df6fe545$var$name = "fluidRenderingParticleThicknessVertexShader";
const $0566e141df6fe545$var$shader = `attribute vec3 position;attribute vec2 offset;uniform mat4 view;uniform mat4 projection;uniform vec2 size;varying vec2 uv;void main(void) {vec3 cornerPos;cornerPos.xy=vec2(offset.x-0.5,offset.y-0.5)*size;cornerPos.z=0.0;vec3 viewPos=(view*vec4(position,1.0)).xyz+cornerPos;gl_Position=projection*vec4(viewPos,1.0);uv=offset;}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$0566e141df6fe545$var$name] = $0566e141df6fe545$var$shader;
const $0566e141df6fe545$export$180515b5b1c13e7e = {
    name: $0566e141df6fe545$var$name,
    shader: $0566e141df6fe545$var$shader
};

});

parcelRegister("jdVko", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $dfebb355762782f9$var$name = "fluidRenderingParticleThicknessPixelShader";
const $dfebb355762782f9$var$shader = `uniform float particleAlpha;varying vec2 uv;void main(void) {vec3 normal;normal.xy=uv*2.0-1.0;float r2=dot(normal.xy,normal.xy);if (r2>1.0) discard;float thickness=sqrt(1.0-r2);glFragColor=vec4(vec3(particleAlpha*thickness),1.0);}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$dfebb355762782f9$var$name] = $dfebb355762782f9$var$shader;
const $dfebb355762782f9$export$1d2fa8ab5d146c4 = {
    name: $dfebb355762782f9$var$name,
    shader: $dfebb355762782f9$var$shader
};

});

parcelRegister("fBG6m", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $b5caf8362cbb4e9e$var$name = "fluidRenderingParticleDiffuseVertexShader";
const $b5caf8362cbb4e9e$var$shader = `attribute vec3 position;attribute vec2 offset;attribute vec4 color;uniform mat4 view;uniform mat4 projection;uniform vec2 size;varying vec2 uv;varying vec3 diffuseColor;void main(void) {vec3 cornerPos;cornerPos.xy=vec2(offset.x-0.5,offset.y-0.5)*size;cornerPos.z=0.0;vec3 viewPos=(view*vec4(position,1.0)).xyz+cornerPos;gl_Position=projection*vec4(viewPos,1.0);uv=offset;diffuseColor=color.rgb;}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$b5caf8362cbb4e9e$var$name] = $b5caf8362cbb4e9e$var$shader;
const $b5caf8362cbb4e9e$export$ac4d709926ff46fe = {
    name: $b5caf8362cbb4e9e$var$name,
    shader: $b5caf8362cbb4e9e$var$shader
};

});

parcelRegister("pG4ZI", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $04d2fa098a11cbca$var$name = "fluidRenderingParticleDiffusePixelShader";
const $04d2fa098a11cbca$var$shader = `uniform float particleAlpha;varying vec2 uv;varying vec3 diffuseColor;void main(void) {vec3 normal;normal.xy=uv*2.0-1.0;float r2=dot(normal.xy,normal.xy);if (r2>1.0) discard;glFragColor=vec4(diffuseColor,1.0);}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$04d2fa098a11cbca$var$name] = $04d2fa098a11cbca$var$shader;
const $04d2fa098a11cbca$export$271983468f5480aa = {
    name: $04d2fa098a11cbca$var$name,
    shader: $04d2fa098a11cbca$var$shader
};

});

parcelRegister("7q8SE", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $5671d99afbda5b08$var$name = "fluidRenderingBilateralBlurPixelShader";
const $5671d99afbda5b08$var$shader = `uniform sampler2D textureSampler;uniform int maxFilterSize;uniform vec2 blurDir;uniform float projectedParticleConstant;uniform float depthThreshold;varying vec2 vUV;void main(void) {float depth=textureLod(textureSampler,vUV,0.).x;if (depth>=1e6 || depth<=0.) {glFragColor=vec4(vec3(depth),1.);return;}
int filterSize=min(maxFilterSize,int(ceil(projectedParticleConstant/depth)));float sigma=float(filterSize)/3.0;float two_sigma2=2.0*sigma*sigma;float sigmaDepth=depthThreshold/3.0;float two_sigmaDepth2=2.0*sigmaDepth*sigmaDepth;float sum=0.;float wsum=0.;float sumVel=0.;for (int x=-filterSize; x<=filterSize; ++x) {vec2 coords=vec2(x);vec2 sampleDepthVel=textureLod(textureSampler,vUV+coords*blurDir,0.).rg;float r=dot(coords,coords);float w=exp(-r/two_sigma2);float rDepth=sampleDepthVel.r-depth;float wd=exp(-rDepth*rDepth/two_sigmaDepth2);sum+=sampleDepthVel.r*w*wd;sumVel+=sampleDepthVel.g*w*wd;wsum+=w*wd;}
glFragColor=vec4(sum/wsum,sumVel/wsum,0.,1.);}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$5671d99afbda5b08$var$name] = $5671d99afbda5b08$var$shader;
const $5671d99afbda5b08$export$214a67e4f2e016af = {
    name: $5671d99afbda5b08$var$name,
    shader: $5671d99afbda5b08$var$shader
};

});

parcelRegister("8sISc", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $6293bf1f744cc9a1$var$name = "fluidRenderingStandardBlurPixelShader";
const $6293bf1f744cc9a1$var$shader = `uniform sampler2D textureSampler;uniform int filterSize;uniform vec2 blurDir;varying vec2 vUV;void main(void) {vec4 s=textureLod(textureSampler,vUV,0.);if (s.r==0.) {glFragColor=vec4(0.,0.,0.,1.);return;}
float sigma=float(filterSize)/3.0;float twoSigma2=2.0*sigma*sigma;vec4 sum=vec4(0.);float wsum=0.;for (int x=-filterSize; x<=filterSize; ++x) {vec2 coords=vec2(x);vec4 sampl=textureLod(textureSampler,vUV+coords*blurDir,0.);float w=exp(-coords.x*coords.x/twoSigma2);sum+=sampl*w;wsum+=w;}
sum/=wsum;glFragColor=vec4(sum.rgb,1.);}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$6293bf1f744cc9a1$var$name] = $6293bf1f744cc9a1$var$shader;
const $6293bf1f744cc9a1$export$5f8e78875ae36990 = {
    name: $6293bf1f744cc9a1$var$name,
    shader: $6293bf1f744cc9a1$var$shader
};

});

parcelRegister("2lGwn", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $1b5e86c1509bfb6f$var$name = "fluidRenderingRenderPixelShader";
const $1b5e86c1509bfb6f$var$shader = `/* disable_uniformity_analysis */
#define IOR 1.333
#define ETA 1.0/IOR
#define F0 0.02
uniform sampler2D textureSampler;uniform sampler2D depthSampler;
#ifdef FLUIDRENDERING_DIFFUSETEXTURE
uniform sampler2D diffuseSampler;
#else
uniform vec3 diffuseColor;
#endif
#ifdef FLUIDRENDERING_FIXED_THICKNESS
uniform float thickness;uniform sampler2D bgDepthSampler;
#else
uniform float minimumThickness;uniform sampler2D thicknessSampler;
#endif
#ifdef FLUIDRENDERING_ENVIRONMENT
uniform samplerCube reflectionSampler;
#endif
#if defined(FLUIDRENDERING_DEBUG) && defined(FLUIDRENDERING_DEBUG_TEXTURE)
uniform sampler2D debugSampler;
#endif
uniform mat4 viewMatrix;uniform mat4 projectionMatrix;uniform mat4 invProjectionMatrix;uniform vec2 texelSize;uniform vec3 dirLight;uniform float cameraFar;uniform float density;uniform float refractionStrength;uniform float fresnelClamp;uniform float specularPower;varying vec2 vUV;vec3 computeViewPosFromUVDepth(vec2 texCoord,float depth) {vec4 ndc;ndc.xy=texCoord*2.0-1.0;
#ifdef FLUIDRENDERING_RHS
ndc.z=-projectionMatrix[2].z+projectionMatrix[3].z/depth;
#else
ndc.z=projectionMatrix[2].z+projectionMatrix[3].z/depth;
#endif
ndc.w=1.0;vec4 eyePos=invProjectionMatrix*ndc;eyePos.xyz/=eyePos.w;return eyePos.xyz;}
vec3 getViewPosFromTexCoord(vec2 texCoord) {float depth=textureLod(depthSampler,texCoord,0.).x;return computeViewPosFromUVDepth(texCoord,depth);}
void main(void) {vec2 texCoord=vUV;
#if defined(FLUIDRENDERING_DEBUG) && defined(FLUIDRENDERING_DEBUG_TEXTURE)
vec4 color=texture2D(debugSampler,texCoord);
#ifdef FLUIDRENDERING_DEBUG_DEPTH
glFragColor=vec4(color.rgb/vec3(2.0),1.);if (color.r>0.999 && color.g>0.999) {glFragColor=texture2D(textureSampler,texCoord);}
#else
glFragColor=vec4(color.rgb,1.);if (color.r<0.001 && color.g<0.001 && color.b<0.001) {glFragColor=texture2D(textureSampler,texCoord);}
#endif
return;
#endif
vec2 depthVel=textureLod(depthSampler,texCoord,0.).rg;float depth=depthVel.r;
#ifndef FLUIDRENDERING_FIXED_THICKNESS
float thickness=texture2D(thicknessSampler,texCoord).x;
#else
float bgDepth=texture2D(bgDepthSampler,texCoord).x;float depthNonLinear=projectionMatrix[2].z+projectionMatrix[3].z/depth;depthNonLinear=depthNonLinear*0.5+0.5;
#endif
vec4 backColor=texture2D(textureSampler,texCoord);
#ifndef FLUIDRENDERING_FIXED_THICKNESS
if (depth>=cameraFar || depth<=0. || thickness<=minimumThickness) {
#else
if (depth>=cameraFar || depth<=0. || bgDepth<=depthNonLinear) {
#endif
glFragColor=backColor;return;}
vec3 viewPos=computeViewPosFromUVDepth(texCoord,depth);vec3 ddx=getViewPosFromTexCoord(texCoord+vec2(texelSize.x,0.))-viewPos;vec3 ddy=getViewPosFromTexCoord(texCoord+vec2(0.,texelSize.y))-viewPos;vec3 ddx2=viewPos-getViewPosFromTexCoord(texCoord+vec2(-texelSize.x,0.));if (abs(ddx.z)>abs(ddx2.z)) {ddx=ddx2;}
vec3 ddy2=viewPos-getViewPosFromTexCoord(texCoord+vec2(0.,-texelSize.y));if (abs(ddy.z)>abs(ddy2.z)) {ddy=ddy2;}
vec3 normal=normalize(cross(ddy,ddx));
#ifdef FLUIDRENDERING_RHS
normal=-normal;
#endif
#ifndef WEBGPU
if(isnan(normal.x) || isnan(normal.y) || isnan(normal.z) || isinf(normal.x) || isinf(normal.y) || isinf(normal.z)) {normal=vec3(0.,0.,-1.);}
#endif
#if defined(FLUIDRENDERING_DEBUG) && defined(FLUIDRENDERING_DEBUG_SHOWNORMAL)
glFragColor=vec4(normal*0.5+0.5,1.0);return;
#endif
vec3 rayDir=normalize(viewPos); 
#ifdef FLUIDRENDERING_DIFFUSETEXTURE
vec3 diffuseColor=textureLod(diffuseSampler,texCoord,0.0).rgb;
#endif
vec3 lightDir=normalize(vec3(viewMatrix*vec4(-dirLight,0.)));vec3 H =normalize(lightDir-rayDir);float specular=pow(max(0.0,dot(H,normal)),specularPower);
#ifdef FLUIDRENDERING_DEBUG_DIFFUSERENDERING
float diffuse =max(0.0,dot(lightDir,normal))*1.0;glFragColor=vec4(vec3(0.1) /*ambient*/+vec3(0.42,0.50,1.00)*diffuse+vec3(0,0,0.2)+specular,1.);return;
#endif
vec3 refractionDir=refract(rayDir,normal,ETA);vec4 transmitted=textureLod(textureSampler,vec2(texCoord+refractionDir.xy*thickness*refractionStrength),0.0);vec3 transmittance=exp(-density*thickness*(1.0-diffuseColor)); 
vec3 refractionColor=transmitted.rgb*transmittance;
#ifdef FLUIDRENDERING_ENVIRONMENT
vec3 reflectionDir=reflect(rayDir,normal);vec3 reflectionColor=(textureCube(reflectionSampler,reflectionDir).rgb);float fresnel=clamp(F0+(1.0-F0)*pow(1.0-dot(normal,-rayDir),5.0),0.,fresnelClamp);vec3 finalColor=mix(refractionColor,reflectionColor,fresnel)+specular;
#else
vec3 finalColor=refractionColor+specular;
#endif
#ifdef FLUIDRENDERING_VELOCITY
float velocity=depthVel.g;finalColor=mix(finalColor,vec3(1.0),smoothstep(0.3,1.0,velocity/6.0));
#endif
glFragColor=vec4(finalColor,transmitted.a);}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$1b5e86c1509bfb6f$var$name] = $1b5e86c1509bfb6f$var$shader;
const $1b5e86c1509bfb6f$export$ef0c0142e36a8fe6 = {
    name: $1b5e86c1509bfb6f$var$name,
    shader: $1b5e86c1509bfb6f$var$shader
};

});



parcelRegister("4r8o2", function(module, exports) {

$parcel$export(module.exports, "ReflectiveShadowMap", () => $33b03070fb61f073$export$24627fd8f3716efa);
$parcel$export(module.exports, "RSMCreatePluginMaterial", () => $33b03070fb61f073$export$9c8e168e1b178486);

var $e0Suo = parcelRequire("e0Suo");

var $3TXsv = parcelRequire("3TXsv");

var $7etnY = parcelRequire("7etnY");

var $ha1VO = parcelRequire("ha1VO");

var $8XNAC = parcelRequire("8XNAC");

var $35xmP = parcelRequire("35xmP");

var $4G6Xh = parcelRequire("4G6Xh");

var $ir0rz = parcelRequire("ir0rz");

var $8DoUR = parcelRequire("8DoUR");

var $c6YWJ = parcelRequire("c6YWJ");
class $33b03070fb61f073$export$24627fd8f3716efa {
    /**
     * Enables or disables the RSM generation.
     */ get enable() {
        return this._enable;
    }
    set enable(value) {
        if (this._enable === value) return;
        this._enable = value;
        this._customRenderTarget(value);
    }
    /**
     * Gets the position texture generated by the RSM process.
     */ get positionWorldTexture() {
        return this._mrt.textures[0];
    }
    /**
     * Gets the normal texture generated by the RSM process.
     */ get normalWorldTexture() {
        return this._mrt.textures[1];
    }
    /**
     * Gets the flux texture generated by the RSM process.
     */ get fluxTexture() {
        return this._mrt.textures[2];
    }
    /**
     * Gets the render list used to generate the RSM textures.
     */ get renderList() {
        return this._mrt.renderList;
    }
    /**
     * Gets the light used to generate the RSM textures.
     */ get light() {
        return this._light;
    }
    /**
     * Creates a new RSM for the given light.
     * @param scene The scene
     * @param light The light to use to generate the RSM textures
     * @param textureDimensions The dimensions of the textures to generate. Default: \{ width: 512, height: 512 \}
     */ constructor(scene, light, textureDimensions = {
        width: 512,
        height: 512
    }){
        this._lightTransformMatrix = (0, $ha1VO.Matrix).Identity();
        this._enable = false;
        /**
         * Gets or sets a boolean indicating if the light parameters should be recomputed even if the light parameters (position, direction) did not change.
         * You should not set this value to true, except for debugging purpose (if you want to see changes from the inspector, for eg).
         * Instead, you should call updateLightParameters() explicitely at the right time (once the light parameters changed).
         */ this.forceUpdateLightParameters = false;
        this._scene = scene;
        this._light = light;
        this._textureDimensions = textureDimensions;
        this._regularMatToMatWithPlugin = new Map();
        this._counters = [
            {
                name: "RSM Generation " + light.name,
                value: 0
            }
        ];
        this._createMultiRenderTarget();
        this._recomputeLightTransformationMatrix();
        this.enable = true;
    }
    /**
     * Sets the dimensions of the textures to generate.
     * @param dimensions The dimensions of the textures to generate.
     */ setTextureDimensions(dimensions) {
        const renderList = this._mrt.renderList;
        this._textureDimensions = dimensions;
        this._disposeMultiRenderTarget();
        this._createMultiRenderTarget();
        renderList?.forEach((mesh)=>{
            this._addMeshToMRT(mesh);
        });
    }
    /**
     * Adds the given mesh to the render list used to generate the RSM textures.
     * @param mesh The mesh to add to the render list used to generate the RSM textures. If not provided, all scene meshes will be added to the render list.
     */ addMesh(mesh) {
        if (mesh) this._addMeshToMRT(mesh);
        else this._scene.meshes.forEach((mesh)=>{
            this._addMeshToMRT(mesh);
        });
        this._recomputeLightTransformationMatrix();
    }
    /**
     * Recomputes the light transformation matrix. Call this method if you manually changed the light position / direction / etc. and you want to update the RSM textures accordingly.
     * You should also call this method if you add/remove meshes to/from the render list.
     */ updateLightParameters() {
        this._recomputeLightTransformationMatrix();
    }
    /**
     * Gets the light transformation matrix used to generate the RSM textures.
     */ get lightTransformationMatrix() {
        if (this.forceUpdateLightParameters) this.updateLightParameters();
        return this._lightTransformMatrix;
    }
    /**
     * Gets the GPU time spent to generate the RSM textures.
     */ get countersGPU() {
        return this._counters;
    }
    /**
     * Disposes the RSM.
     */ dispose() {
        this._disposeMultiRenderTarget();
    }
    _createMultiRenderTarget() {
        const name = this._light.name;
        const caps = this._scene.getEngine().getCaps();
        const fluxTextureType = caps.rg11b10ufColorRenderable ? 13 : 2;
        const fluxTextureFormat = caps.rg11b10ufColorRenderable ? 4 : 5;
        this._mrt = new (0, $3TXsv.MultiRenderTarget)("RSMmrt_" + name, this._textureDimensions, 3, this._scene, {
            types: [
                2,
                11,
                fluxTextureType
            ],
            samplingModes: [
                2,
                2,
                2
            ],
            generateMipMaps: false,
            targetTypes: [
                3553,
                3553,
                3553
            ],
            formats: [
                5,
                5,
                fluxTextureFormat
            ]
        }, [
            "RSMPosition_" + name,
            "RSMNormal_" + name,
            "RSMFlux_" + name
        ]);
        this._mrt.renderList = [];
        this._mrt.clearColor = new (0, $7etnY.Color4)(0, 0, 0, 1);
        this._mrt.noPrePassRenderer = true;
        let sceneUBO;
        let currentSceneUBO;
        const useUBO = this._scene.getEngine().supportsUniformBuffers;
        if (useUBO) sceneUBO = this._scene.createSceneUniformBuffer(`Scene for RSM (light "${name}")`);
        let shadowEnabled;
        this._mrt.onBeforeBindObservable.add(()=>{
            currentSceneUBO = this._scene.getSceneUniformBuffer();
            shadowEnabled = this._light.shadowEnabled;
            this._light.shadowEnabled = false; // we render from the light point of view, so we won't have any shadow anyway!
        });
        this._mrt.onBeforeRenderObservable.add((faceIndex)=>{
            if (sceneUBO) this._scene.setSceneUniformBuffer(sceneUBO);
            const viewMatrix = this._light.getViewMatrix(faceIndex);
            const projectionMatrix = this._light.getProjectionMatrix(viewMatrix || undefined, this._mrt.renderList || undefined);
            if (viewMatrix && projectionMatrix) this._scene.setTransformMatrix(viewMatrix, projectionMatrix);
            if (useUBO) {
                this._scene.getSceneUniformBuffer().unbindEffect();
                this._scene.finalizeSceneUbo();
            }
        });
        this._mrt.onAfterUnbindObservable.add(()=>{
            if (sceneUBO) this._scene.setSceneUniformBuffer(currentSceneUBO);
            this._scene.updateTransformMatrix(); // restore the view/projection matrices of the active camera
            this._light.shadowEnabled = shadowEnabled;
            this._counters[0].value = this._mrt.renderTarget.gpuTimeInFrame?.counter.lastSecAverage ?? 0;
        });
        this._customRenderTarget(true);
    }
    _customRenderTarget(add) {
        const idx = this._scene.customRenderTargets.indexOf(this._mrt);
        if (add) {
            if (idx === -1) this._scene.customRenderTargets.push(this._mrt);
        } else if (idx !== -1) this._scene.customRenderTargets.splice(idx, 1);
    }
    _recomputeLightTransformationMatrix() {
        const viewMatrix = this._light.getViewMatrix();
        const projectionMatrix = this._light.getProjectionMatrix(viewMatrix || undefined, this._mrt.renderList || undefined);
        if (viewMatrix && projectionMatrix) viewMatrix.multiplyToRef(projectionMatrix, this._lightTransformMatrix);
    }
    _addMeshToMRT(mesh) {
        this._mrt.renderList?.push(mesh);
        const material = mesh.material;
        if (mesh.getTotalVertices() === 0 || !material) return;
        let rsmMaterial = this._regularMatToMatWithPlugin.get(material);
        if (!rsmMaterial) {
            rsmMaterial = material.clone("RSMCreate_" + material.name) || undefined;
            if (rsmMaterial) {
                // Disable the prepass renderer for this material
                Object.defineProperty(rsmMaterial, "canRenderToMRT", {
                    get: function() {
                        return false;
                    },
                    enumerable: true,
                    configurable: true
                });
                rsmMaterial.disableLighting = true;
                const rsmCreatePlugin = new $33b03070fb61f073$export$9c8e168e1b178486(rsmMaterial);
                rsmCreatePlugin.isEnabled = true;
                rsmCreatePlugin.light = this._light;
                this._regularMatToMatWithPlugin.set(material, rsmMaterial);
            }
        }
        this._mrt.setMaterialForRendering(mesh, rsmMaterial);
    }
    _disposeMultiRenderTarget() {
        this._customRenderTarget(false);
        this._mrt.dispose();
    }
}
/**
 * @internal
 */ class $33b03070fb61f073$var$MaterialRSMCreateDefines extends (0, $35xmP.MaterialDefines) {
    constructor(){
        super(...arguments);
        this.RSMCREATE = false;
        this.RSMCREATE_PROJTEXTURE = false;
        this.RSMCREATE_LIGHT_IS_SPOT = false;
    }
}
class $33b03070fb61f073$export$9c8e168e1b178486 extends (0, $8XNAC.MaterialPluginBase) {
    _markAllSubMeshesAsTexturesDirty() {
        this._enable(this._isEnabled);
        this._internalMarkAllSubMeshesAsTexturesDirty();
    }
    /**
     * Create a new RSMCreatePluginMaterial
     * @param material Parent material of the plugin
     */ constructor(material){
        super(material, $33b03070fb61f073$export$9c8e168e1b178486.Name, 300, new $33b03070fb61f073$var$MaterialRSMCreateDefines());
        this._lightColor = new (0, $7etnY.Color3)();
        this._hasProjectionTexture = false;
        this._isEnabled = false;
        /**
         * Defines if the plugin is enabled in the material.
         */ this.isEnabled = false;
        this._internalMarkAllSubMeshesAsTexturesDirty = material._dirtyCallbacks[1];
        this._varAlbedoName = material instanceof (0, $4G6Xh.PBRBaseMaterial) ? "surfaceAlbedo" : "baseColor.rgb";
    }
    prepareDefines(defines) {
        defines.RSMCREATE = this._isEnabled;
        this._hasProjectionTexture = false;
        const isSpot = this.light.getTypeID() === (0, $c6YWJ.Light).LIGHTTYPEID_SPOTLIGHT;
        if (isSpot) {
            const spot = this.light;
            this._hasProjectionTexture = spot.projectionTexture ? spot.projectionTexture.isReady() : false;
        }
        defines.RSMCREATE_PROJTEXTURE = this._hasProjectionTexture;
        defines.RSMCREATE_LIGHT_IS_SPOT = isSpot;
    }
    getClassName() {
        return "RSMCreatePluginMaterial";
    }
    getUniforms() {
        return {
            ubo: [
                {
                    name: "rsmTextureProjectionMatrix",
                    size: 16,
                    type: "mat4"
                },
                {
                    name: "rsmSpotInfo",
                    size: 4,
                    type: "vec4"
                },
                {
                    name: "rsmLightColor",
                    size: 3,
                    type: "vec3"
                },
                {
                    name: "rsmLightPosition",
                    size: 3,
                    type: "vec3"
                }
            ],
            fragment: `#ifdef RSMCREATE
                    uniform mat4 rsmTextureProjectionMatrix;
                    uniform vec4 rsmSpotInfo;
                    uniform vec3 rsmLightColor;
                    unfiorm vec3 rsmLightPosition;
                #endif`
        };
    }
    getSamplers(samplers) {
        samplers.push("rsmTextureProjectionSampler");
    }
    bindForSubMesh(uniformBuffer) {
        if (!this._isEnabled) return;
        this.light.diffuse.scaleToRef(this.light.getScaledIntensity(), this._lightColor);
        uniformBuffer.updateColor3("rsmLightColor", this._lightColor);
        if (this.light.getTypeID() === (0, $c6YWJ.Light).LIGHTTYPEID_SPOTLIGHT) {
            const spot = this.light;
            if (this._hasProjectionTexture) {
                uniformBuffer.updateMatrix("rsmTextureProjectionMatrix", spot.projectionTextureMatrix);
                uniformBuffer.setTexture("rsmTextureProjectionSampler", spot.projectionTexture);
            }
            const normalizeDirection = (0, $ha1VO.TmpVectors).Vector3[0];
            if (spot.computeTransformedInformation()) {
                uniformBuffer.updateFloat3("rsmLightPosition", this.light.transformedPosition.x, this.light.transformedPosition.y, this.light.transformedPosition.z);
                spot.transformedDirection.normalizeToRef(normalizeDirection);
            } else {
                uniformBuffer.updateFloat3("rsmLightPosition", this.light.position.x, this.light.position.y, this.light.position.z);
                spot.direction.normalizeToRef(normalizeDirection);
            }
            uniformBuffer.updateFloat4("rsmSpotInfo", normalizeDirection.x, normalizeDirection.y, normalizeDirection.z, Math.cos(spot.angle * 0.5));
        }
    }
    getCustomCode(shaderType) {
        return shaderType === "vertex" ? null : {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            CUSTOM_FRAGMENT_BEGIN: `
                #ifdef RSMCREATE
                    #extension GL_EXT_draw_buffers : require
                #endif
            `,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            CUSTOM_FRAGMENT_DEFINITIONS: `
                #ifdef RSMCREATE
                    #ifdef RSMCREATE_PROJTEXTURE
                        uniform highp sampler2D rsmTextureProjectionSampler;                    
                    #endif
                    layout(location = 0) out highp vec4 glFragData[3];
                    vec4 glFragColor;
                #endif
            `,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            CUSTOM_FRAGMENT_BEFORE_FRAGCOLOR: `
                #ifdef RSMCREATE
                    vec3 rsmColor = ${this._varAlbedoName} * rsmLightColor;
                    #ifdef RSMCREATE_PROJTEXTURE
                    {
                        vec4 strq = rsmTextureProjectionMatrix * vec4(vPositionW, 1.0);
                        strq /= strq.w;
                        rsmColor *= texture2D(rsmTextureProjectionSampler, strq.xy).rgb;
                    }
                    #endif
                    #ifdef RSMCREATE_LIGHT_IS_SPOT
                    {
                        float cosAngle = max(0., dot(rsmSpotInfo.xyz, normalize(vPositionW - rsmLightPosition)));
                        rsmColor = sign(cosAngle - rsmSpotInfo.w) * rsmColor;
                    }
                    #endif
                    glFragData[0] = vec4(vPositionW, 1.);
                    glFragData[1] = vec4(normalize(normalW) * 0.5 + 0.5, 1.);
                    glFragData[2] = vec4(rsmColor, 1.);
                #endif
            `
        };
    }
}
/**
 * Defines the name of the plugin.
 */ $33b03070fb61f073$export$9c8e168e1b178486.Name = "RSMCreate";
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $33b03070fb61f073$export$9c8e168e1b178486.prototype, "light", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $33b03070fb61f073$export$9c8e168e1b178486.prototype, "isEnabled", void 0);
(0, $8DoUR.RegisterClass)(`BABYLON.RSMCreatePluginMaterial`, $33b03070fb61f073$export$9c8e168e1b178486);

});

parcelRegister("ho5tT", function(module, exports) {

var $zww6Q = parcelRequire("zww6Q");

var $3UYDR = parcelRequire("3UYDR");
$parcel$exportWildcard(module.exports, $zww6Q);
$parcel$exportWildcard(module.exports, $3UYDR);

});
parcelRegister("zww6Q", function(module, exports) {

$parcel$export(module.exports, "GIRSM", () => $06ac7e2d2ff73321$export$2d064c822a1a8017);
/**
 * Class used to store the global illumination parameters for a reflective shadow map.
 * Instances of this class are used by the GIRSMManager class to generate global illumination for a scene.
 */ class $06ac7e2d2ff73321$export$2d064c822a1a8017 {
    /**
     * Creates a new GIRSM instance
     * @param rsm The reflective shadow map
     */ constructor(rsm){
        /**
         * The number of samples to use to generate the global illumination. Default value is 400.
         */ this.numSamples = 400;
        /**
         * Radius of the circle in the RSM flux texture to read samples from. Default value is 0.1.
         * Valid values are between 0 and 1.
         */ this.radius = 0.1;
        /**
         * Intensity of the global illumination effect. Default value is 0.1.
         */ this.intensity = 0.1;
        /**
         * value used to correct for edge artifacts when calculating the global illumination effect. Default value is 0.1.
         * Will depend on your scene.
         */ this.edgeArtifactCorrection = 0.1;
        /**
         * Defines if samples should be rotated when generating the global illumination effect. Default value is true.
         * Rotating samples will improve the quality of the global illumination effect by trading banding for noise, at the cost of a bit of performance.
         */ this.rotateSample = true;
        /**
         * Noise scale factor, only used if rotateSample is true. Default value is 100.
         * Will depend on your scene.
         */ this.noiseFactor = 100;
        /**
         * Defines if the full texture should be used when generating the global illumination effect. Default value is false.
         * If true, values for numSamples, radius, rotateSample and noiseFactor will be ignored and the full texture will be used to generate the global illumination effect.
         * Be careful to use a RSM texture size small enough to limit the number of samples! For eg. a 32x32 texture will generate 1024 samples per pixel!
         */ this.useFullTexture = false;
        this.rsm = rsm;
    }
    /**
     * Disposes the GIRSM
     */ dispose() {
        this.rsm.dispose();
    }
}

});

parcelRegister("3UYDR", function(module, exports) {

$parcel$export(module.exports, "GIRSMManager", () => $2da5a4475f90d0ce$export$2e8be5c00f6d66e2);
$parcel$export(module.exports, "GIRSMRenderPluginMaterial", () => $2da5a4475f90d0ce$export$ae2e267abaf9f1df);

var $e0Suo = parcelRequire("e0Suo");

var $5Egpj = parcelRequire("5Egpj");

var $gQtNK = parcelRequire("gQtNK");

var $cFdBb = parcelRequire("cFdBb");

var $8fwD5 = parcelRequire("8fwD5");

var $ha1VO = parcelRequire("ha1VO");

var $8XNAC = parcelRequire("8XNAC");

var $4G6Xh = parcelRequire("4G6Xh");

var $gXqe5 = parcelRequire("gXqe5");

var $akOl3 = parcelRequire("akOl3");

var $ir0rz = parcelRequire("ir0rz");

var $35xmP = parcelRequire("35xmP");

var $8DoUR = parcelRequire("8DoUR");
parcelRequire("lLKcB");
parcelRequire("1ANKK");
parcelRequire("laCjp");
parcelRequire("lURFH");
class $2da5a4475f90d0ce$export$2e8be5c00f6d66e2 {
    /**
     * Enables or disables the manager. Default is false.
     * If disabled, the global illumination won't be calculated and the scene will be rendered normally, without any global illumination contribution.
     */ get enable() {
        return this._enable;
    }
    set enable(enable) {
        if (this._giRSM.length === 0) enable = false;
        if (enable === this._enable) return;
        this._enable = enable;
        this._debugLayer.isEnabled = this._showOnlyGI && enable;
        this._materialsWithRenderPlugin.forEach((mat)=>{
            if (mat.pluginManager) {
                const plugin = mat.pluginManager.getPlugin($2da5a4475f90d0ce$export$ae2e267abaf9f1df.Name);
                plugin.isEnabled = enable;
            }
        });
        this.recreateResources(!enable);
    }
    /**
     * Defines if the global illumination contribution should be blurred or not (using a bilateral blur). Default is true.
     */ get enableBlur() {
        return this._enableBlur;
    }
    set enableBlur(enable) {
        if (enable === this._enableBlur) return;
        this._enableBlur = enable;
        this.recreateResources();
    }
    /**
     * Defines if the blur should be done with a better quality but slower or not. Default is false.
     */ get useQualityBlur() {
        return this._useQualityBlur;
    }
    set useQualityBlur(enable) {
        if (enable === this._useQualityBlur) return;
        this._useQualityBlur = enable;
        this.recreateResources();
    }
    /**
     * Defines if the blur should be done at full resolution or not. Default is false.
     * If this setting is enabled, upampling will be disabled (ignored) as it is not needed anymore.
     */ get fullSizeBlur() {
        return this._forceFullSizeBlur;
    }
    set fullSizeBlur(mode) {
        if (this._forceFullSizeBlur === mode) return;
        this._forceFullSizeBlur = mode;
        this.recreateResources();
    }
    /**
     * Defines if the upsampling should be done with a better quality but slower or not. Default is false.
     */ get useQualityUpsampling() {
        return this._useQualityUpsampling;
    }
    set useQualityUpsampling(enable) {
        if (enable === this._useQualityUpsampling) return;
        this._useQualityUpsampling = enable;
        this.recreateResources();
    }
    /**
     * Defines if the debug layer should be enabled or not. Default is false.
     * Use this setting for debugging purpose, to show the global illumination contribution only.
     */ get showOnlyGI() {
        return this._showOnlyGI;
    }
    set showOnlyGI(show) {
        if (this._showOnlyGI === show) return;
        this._showOnlyGI = show;
        this._debugLayer.isEnabled = show;
    }
    /**
     * Sets the output dimensions of the final process. It should normally be the same as the output dimensions of the screen.
     * @param dimensions The dimensions of the output texture (width and height)
     */ setOutputDimensions(dimensions) {
        this._outputDimensions = dimensions;
        this.recreateResources();
    }
    /**
     * Sets the dimensions of the GI texture. Try to use the smallest size possible for better performance.
     * @param dimensions The dimensions of the GI texture (width and height)
     */ setGITextureDimensions(dimensions) {
        this._giTextureDimensions = dimensions;
        this.recreateResources();
    }
    /**
     * Gets or sets the texture type used by the GI texture. Default is 11.
     */ get giTextureType() {
        return this._giTextureType;
    }
    set giTextureType(textureType) {
        if (this._giTextureType === textureType) return;
        this._giTextureType = textureType;
        this.recreateResources();
    }
    /**
     * Gets the list of GIRSM used by the manager.
     */ get giRSM() {
        return this._giRSM;
    }
    /**
     * Adds a (list of) GIRSM to the manager.
     * @param rsm The GIRSM (or array of GIRSM) to add to the manager
     */ addGIRSM(rsm) {
        if (Array.isArray(rsm)) this._giRSM.push(...rsm);
        else this._giRSM.push(rsm);
        this.recreateResources();
    }
    /**
     * Removes a (list of) GIRSM from the manager.
     * @param rsm The GIRSM (or array of GIRSM) to remove from the manager
     */ removeGIRSM(rsm) {
        if (Array.isArray(rsm)) for(let i = 0; i < rsm.length; ++i){
            const idx = this._giRSM.indexOf(rsm[i]);
            if (idx !== -1) this._giRSM.splice(idx, 1);
        }
        else {
            const idx = this._giRSM.indexOf(rsm);
            if (idx !== -1) this._giRSM.splice(idx, 1);
        }
        if (this._giRSM.length === 0) this.enable = false;
        else this.recreateResources();
    }
    /**
     * Add a material to the manager. This will enable the global illumination contribution for the material.
     * @param material Material that will be affected by the global illumination contribution. If not provided, all materials of the scene will be affected.
     */ addMaterial(material) {
        if (material) this._addGISupportToMaterial(material);
        else this._scene.meshes.forEach((mesh)=>{
            if (mesh.getTotalVertices() > 0 && mesh.isEnabled() && mesh.material) this._addGISupportToMaterial(mesh.material);
        });
    }
    /**
     * Gets the list of GPU counters used by the manager.
     * GPU timing measurements must be enabled for the counters to be filled (engine.enableGPUTimingMeasurements = true).
     * Only available with WebGPU. You will still get the list of counters with other engines but the values will always be 0.
     */ get countersGPU() {
        return this._counters;
    }
    /**
     * Recreates the resources used by the manager.
     * You should normally not have to call this method manually, except if you change the useFullTexture property of a GIRSM, because the manager won't track this change.
     * @param disposeGeometryBufferRenderer Defines if the geometry buffer renderer should be disposed and recreated. Default is false.
     */ recreateResources(disposeGeometryBufferRenderer = false) {
        this._disposePostProcesses(disposeGeometryBufferRenderer);
        this._createPostProcesses();
        this._setPluginParameters();
    }
    /**
     * Generates the sample texture used by the the global illumination calculation process.
     * @param maxSamples The maximum number of samples to generate in the texture. Default value is 2048. The numSamples property of the GIRSM should be less than or equal to this value!
     */ generateSampleTexture(maxSamples) {
        this._sampleTexture?.dispose();
        this._maxSamples = maxSamples;
        const data = new Float32Array(this._maxSamples * 4);
        for(let i = 0; i < this._maxSamples; i++){
            const xi1 = Math.random();
            const xi2 = Math.random();
            const x = xi1 * Math.sin(2 * Math.PI * xi2);
            const y = xi1 * Math.cos(2 * Math.PI * xi2);
            data[i * 4 + 0] = x;
            data[i * 4 + 1] = y;
            data[i * 4 + 2] = xi1 * xi1;
            data[i * 4 + 3] = 1;
        }
        this._sampleTexture = new (0, $5Egpj.RawTexture)(data, this._maxSamples, 1, 5, this._scene, false, false, 1, 1);
        this._sampleTexture.name = "GIRSMSamples";
    }
    /**
     * Disposes the manager.
     */ dispose() {
        this._disposePostProcesses(true);
        this._debugLayer.texture?.dispose();
        this._debugLayer.dispose();
        this._scene.onBeforeDrawPhaseObservable.remove(this._drawPhaseObserver);
    }
    /**
     * Creates a new GIRSMManager
     * @param scene The scene
     * @param outputDimensions The dimensions of the output texture (width and height). Should normally be the same as the output dimensions of the screen.
     * @param giTextureDimensions The dimensions of the GI texture (width and height). Try to use the smallest size possible for better performance.
     * @param maxSamples The maximum number of samples to generate in the sample texture. Default value is 2048. The numSamples property of the GIRSM should be less than or equal to this value!
     * @param giTextureType The texture type used by the GI texture. Default is 11.
     */ constructor(scene, outputDimensions, giTextureDimensions = {
        width: 256,
        height: 256
    }, maxSamples = 2048, giTextureType = 11){
        this._giRSM = [];
        this._blurRTT = null;
        this._blurPostProcesses = null;
        this._blurXPostprocess = null;
        this._blurYPostprocess = null;
        this._upsamplingXPostprocess = null;
        this._upsamplingYPostprocess = null;
        this._ppGlobalIllumination = [];
        this._firstActivation = true;
        this._geomBufferEnabled = false;
        this._geomBufferEnablePosition = false;
        this._tempMatrix = new (0, $ha1VO.Matrix)();
        this._enable = false;
        /**
         * Defines if the global illumination calculation is paused or not.
         * Use this setting to pause the global illumination calculation when you know that the scene (camera/mesh/light positions) is not changing anymore to save some GPU power.
         * The scene will still be rendered with the latest global illumination contribution.
         */ this.pause = false;
        this._enableBlur = true;
        this._useQualityBlur = false;
        /**
         * Defines the depth threshold used by the bilateral blur post-processes (also used by the upsampling, if enabled).
         * You may have to change this value, depending on your scene.
         */ this.blurDepthThreshold = 0.05;
        /**
         * Defines the normal threshold used by the bilateral blur post-processes (also used by the upsampling, if enabled).
         * You may have to change this value, depending on your scene.
         */ this.blurNormalThreshold = 0.25;
        /**
         * Defines the kernel size used by the bilateral blur post-processes. Default is 12.
         */ this.blurKernel = 12;
        this._forceFullSizeBlur = false;
        this._useQualityUpsampling = false;
        /**
         * Defines the kernel size used by the bilateral upsampling post-processes. Default is 6.
         */ this.upsamplerKernel = 6;
        this._showOnlyGI = false;
        this._scene = scene;
        this._engine = scene.getEngine();
        this._outputDimensions = outputDimensions;
        this._giTextureDimensions = giTextureDimensions;
        this._giTextureType = giTextureType;
        this._materialsWithRenderPlugin = [];
        this._maxSamples = maxSamples;
        this._debugLayer = new (0, $8fwD5.Layer)("debug layer", null, this._scene, false);
        this._debugLayer.isEnabled = false;
        this._counters = [];
        this._countersRTW = [];
        this.generateSampleTexture(maxSamples);
        this._drawPhaseObserver = this._scene.onBeforeDrawPhaseObservable.add(()=>{
            const currentRenderTarget = this._engine._currentRenderTarget;
            let rebindCurrentRenderTarget = false;
            if (this._enable) {
                if (!this.pause) {
                    this._scene.postProcessManager.directRender(this._ppGlobalIllumination, this._ppGlobalIllumination[0].inputTexture);
                    this._engine.unBindFramebuffer(this._ppGlobalIllumination[0].inputTexture, true);
                    this._engine.setAlphaMode(0);
                    rebindCurrentRenderTarget = true;
                    if (this.enableBlur && this._blurPostProcesses) {
                        this._scene.postProcessManager.directRender(this._blurPostProcesses, this._blurRTT.renderTarget, true);
                        this._engine.unBindFramebuffer(this._blurRTT.renderTarget, true);
                    }
                }
                for(let i = 0; i < this._counters.length; ++i){
                    const rtws = this._countersRTW[i];
                    for(let t = 0; t < rtws.length; ++t){
                        if (t === 0) this._counters[i].value = this.pause ? 0 : rtws[t].gpuTimeInFrame?.counter.lastSecAverage ?? 0;
                        else if (!this.pause) this._counters[i].value += rtws[t].gpuTimeInFrame?.counter.lastSecAverage ?? 0;
                    }
                }
                if (this._scene.activeCamera) this._engine.setViewport(this._scene.activeCamera.viewport);
            }
            if (rebindCurrentRenderTarget && currentRenderTarget) this._engine.bindFramebuffer(currentRenderTarget);
        });
    }
    _disposePostProcesses(disposeGeometryBufferRenderer = false) {
        this._blurRTT?.dispose();
        this._blurRTT = null;
        this._blurPostProcesses = [];
        this._blurXPostprocess?.dispose();
        this._blurXPostprocess = null;
        this._blurYPostprocess?.dispose();
        this._blurYPostprocess = null;
        this._upsamplingXPostprocess?.dispose();
        this._upsamplingXPostprocess = null;
        this._upsamplingYPostprocess?.dispose();
        this._upsamplingYPostprocess = null;
        for (const ppGlobalIllumination of this._ppGlobalIllumination)ppGlobalIllumination.dispose();
        this._ppGlobalIllumination = [];
        if (disposeGeometryBufferRenderer) {
            if (this._geomBufferEnabled) {
                this._scene.enableGeometryBufferRenderer();
                this._scene.geometryBufferRenderer.enablePosition = this._geomBufferEnablePosition;
            } else this._scene.disableGeometryBufferRenderer();
        }
        this._counters = [];
        this._countersRTW = [];
    }
    _setPluginParameters() {
        if (!this._enable) return;
        this._materialsWithRenderPlugin.forEach((mat)=>{
            if (mat.pluginManager) {
                const plugin = mat.pluginManager.getPlugin($2da5a4475f90d0ce$export$ae2e267abaf9f1df.Name);
                plugin.textureGIContrib = this.enableBlur ? this._blurRTT.renderTarget.texture : this._ppGlobalIllumination[0].inputTexture.texture;
                plugin.outputTextureWidth = this._outputDimensions.width;
                plugin.outputTextureHeight = this._outputDimensions.height;
            }
        });
    }
    _createPostProcesses() {
        if (!this._enable) return;
        const textureFormat = this._giTextureType === 13 ? 4 : 5;
        if (this._firstActivation) {
            this._firstActivation = false;
            this._geomBufferEnabled = !!this._scene.geometryBufferRenderer;
            this._geomBufferEnablePosition = this._scene.geometryBufferRenderer?.enablePosition ?? false;
        }
        if (!this._geomBufferEnabled) this._scene.disableGeometryBufferRenderer();
        const geometryBufferRenderer = this._scene.enableGeometryBufferRenderer(this._enableBlur ? this._outputDimensions : this._giTextureDimensions, 15, $2da5a4475f90d0ce$export$2e8be5c00f6d66e2.GeometryBufferTextureTypesAndFormats);
        if (!geometryBufferRenderer) throw new Error("Geometry buffer renderer is not supported but is required for GIRSMManager.");
        geometryBufferRenderer.enablePosition = true;
        if (!this._geomBufferEnabled) geometryBufferRenderer.generateNormalsInWorldSpace = true;
        const decodeGeometryBufferNormals = geometryBufferRenderer.normalsAreUnsigned;
        const normalsAreInWorldSpace = geometryBufferRenderer.generateNormalsInWorldSpace;
        this._counters.push({
            name: "Geometry buffer renderer",
            value: 0
        });
        this._countersRTW.push([
            this._scene.geometryBufferRenderer.getGBuffer().renderTarget
        ]);
        let defines = "";
        if (decodeGeometryBufferNormals) defines += "#define DECODE_NORMAL\n";
        if (!normalsAreInWorldSpace) defines += "#define TRANSFORM_NORMAL\n";
        for(let i = 0; i < this._giRSM.length; ++i){
            const giRSM = this._giRSM[i];
            const rsm = giRSM.rsm;
            const ppGlobalIllumination = new (0, $cFdBb.PostProcess)("RSMGlobalIllumination" + i, giRSM.useFullTexture ? "rsmFullGlobalIllumination" : "rsmGlobalIllumination", {
                ...this._giTextureDimensions,
                uniforms: [
                    "rsmLightMatrix",
                    "rsmInfo",
                    "rsmInfo2",
                    "invView"
                ],
                samplers: [
                    "normalSampler",
                    "rsmPositionW",
                    "rsmNormalW",
                    "rsmFlux",
                    "rsmSamples"
                ],
                defines: defines,
                samplingMode: 2,
                engine: this._engine,
                textureType: this._giTextureType,
                textureFormat: textureFormat
            });
            this._ppGlobalIllumination.push(ppGlobalIllumination);
            if (i !== 0) {
                ppGlobalIllumination.shareOutputWith(this._ppGlobalIllumination[0]);
                ppGlobalIllumination.alphaMode = 1;
            }
            ppGlobalIllumination.autoClear = false;
            ppGlobalIllumination.externalTextureSamplerBinding = true;
            ppGlobalIllumination.onApplyObservable.add((effect)=>{
                effect.setTexture("textureSampler", geometryBufferRenderer.getGBuffer().textures[geometryBufferRenderer.getTextureIndex((0, $gXqe5.GeometryBufferRenderer).POSITION_TEXTURE_TYPE)]);
                effect.setTexture("normalSampler", geometryBufferRenderer.getGBuffer().textures[geometryBufferRenderer.getTextureIndex((0, $gXqe5.GeometryBufferRenderer).NORMAL_TEXTURE_TYPE)]);
                effect.setTexture("rsmPositionW", rsm.positionWorldTexture);
                effect.setTexture("rsmNormalW", rsm.normalWorldTexture);
                effect.setTexture("rsmFlux", rsm.fluxTexture);
                effect.setMatrix("rsmLightMatrix", rsm.lightTransformationMatrix);
                if (!giRSM.useFullTexture) {
                    effect.setTexture("rsmSamples", this._sampleTexture);
                    effect.setFloat4("rsmInfo", giRSM.numSamples, giRSM.radius, giRSM.intensity, giRSM.edgeArtifactCorrection);
                    effect.setFloat4("rsmInfo2", giRSM.noiseFactor, giRSM.rotateSample ? 1 : 0, rsm.fluxTexture.getInternalTexture().width, rsm.fluxTexture.getInternalTexture().height);
                } else effect.setFloat4("rsmInfo", rsm.fluxTexture.getInternalTexture().width, rsm.fluxTexture.getInternalTexture().height, giRSM.intensity, giRSM.edgeArtifactCorrection);
                if (!normalsAreInWorldSpace) {
                    this._tempMatrix.copyFrom(this._scene.activeCamera.getViewMatrix());
                    this._tempMatrix.invert();
                    effect.setMatrix("invView", this._tempMatrix);
                }
            });
        }
        for (const ppGlobalIllumination of this._ppGlobalIllumination)if (!ppGlobalIllumination.inputTexture) ppGlobalIllumination.resize(this._giTextureDimensions.width, this._giTextureDimensions.height);
        this._counters.push({
            name: "GI generation",
            value: 0
        });
        this._countersRTW.push([
            this._ppGlobalIllumination[0].inputTexture
        ]);
        if (this._enableBlur) {
            const blurTextureSize = this._forceFullSizeBlur ? this._outputDimensions : this._giTextureDimensions;
            this._blurRTT = new (0, $gQtNK.RenderTargetTexture)("GIRSMContribution", this._outputDimensions, this._scene, {
                type: this._giTextureType,
                format: textureFormat,
                generateDepthBuffer: false
            });
            this._blurRTT.wrapU = 0;
            this._blurRTT.wrapV = 0;
            this._blurRTT.updateSamplingMode(1);
            this._blurRTT.skipInitialClear = true;
            const blurRTWs = [];
            this._counters.push({
                name: "GI blur",
                value: 0
            });
            this._countersRTW.push(blurRTWs);
            // Bilateral blur
            this._blurXPostprocess = new (0, $cFdBb.PostProcess)(this._useQualityBlur ? "BilateralBlur" : "BilateralBlurX", this._useQualityBlur ? "bilateralBlurQuality" : "bilateralBlur", {
                uniforms: [
                    "filterSize",
                    "blurDir",
                    "depthThreshold",
                    "normalThreshold"
                ],
                samplers: [
                    "depthSampler",
                    "normalSampler"
                ],
                defines: decodeGeometryBufferNormals ? "#define DECODE_NORMAL" : undefined,
                size: blurTextureSize,
                samplingMode: 2,
                engine: this._engine,
                textureType: this._giTextureType,
                textureFormat: textureFormat
            });
            this._blurXPostprocess.onApplyObservable.add((effect)=>{
                effect._bindTexture("textureSampler", this._ppGlobalIllumination[0].inputTexture.texture);
                effect.setTexture("depthSampler", geometryBufferRenderer.getGBuffer().textures[geometryBufferRenderer.getTextureIndex((0, $gXqe5.GeometryBufferRenderer).DEPTH_TEXTURE_TYPE)]);
                effect.setTexture("normalSampler", geometryBufferRenderer.getGBuffer().textures[geometryBufferRenderer.getTextureIndex((0, $gXqe5.GeometryBufferRenderer).NORMAL_TEXTURE_TYPE)]);
                effect.setInt("filterSize", this.blurKernel);
                effect.setFloat2("blurDir", 1 / this._giTextureDimensions.width, this._useQualityBlur ? 1 / this._giTextureDimensions.height : 0);
                effect.setFloat("depthThreshold", this.blurDepthThreshold);
                effect.setFloat("normalThreshold", this.blurNormalThreshold);
            });
            this._blurXPostprocess.externalTextureSamplerBinding = true;
            this._blurXPostprocess.autoClear = false;
            if (!this._useQualityBlur) {
                this._blurYPostprocess = new (0, $cFdBb.PostProcess)("BilateralBlurY", "bilateralBlur", {
                    uniforms: [
                        "filterSize",
                        "blurDir",
                        "depthThreshold",
                        "normalThreshold"
                    ],
                    samplers: [
                        "depthSampler",
                        "normalSampler"
                    ],
                    defines: decodeGeometryBufferNormals ? "#define DECODE_NORMAL" : undefined,
                    size: blurTextureSize,
                    samplingMode: 2,
                    engine: this._engine,
                    textureType: this._giTextureType,
                    textureFormat: textureFormat
                });
                this._blurYPostprocess.autoClear = false;
                this._blurYPostprocess.onApplyObservable.add((effect)=>{
                    effect.setTexture("depthSampler", geometryBufferRenderer.getGBuffer().textures[geometryBufferRenderer.getTextureIndex((0, $gXqe5.GeometryBufferRenderer).DEPTH_TEXTURE_TYPE)]);
                    effect.setTexture("normalSampler", geometryBufferRenderer.getGBuffer().textures[geometryBufferRenderer.getTextureIndex((0, $gXqe5.GeometryBufferRenderer).NORMAL_TEXTURE_TYPE)]);
                    effect.setInt("filterSize", this.blurKernel);
                    effect.setFloat2("blurDir", 0, 1 / this._giTextureDimensions.height);
                    effect.setFloat("depthThreshold", this.blurDepthThreshold);
                    effect.setFloat("normalThreshold", this.blurNormalThreshold);
                });
                this._blurYPostprocess.resize(blurTextureSize.width, blurTextureSize.height);
                blurRTWs.push(this._blurYPostprocess.inputTexture);
            }
            this._blurPostProcesses = [
                this._blurXPostprocess
            ];
            if (this._blurYPostprocess) this._blurPostProcesses.push(this._blurYPostprocess);
            // Bilateral upsampling
            const giFullDimensions = this._giTextureDimensions.width >= this._outputDimensions.width && this._giTextureDimensions.height >= this._outputDimensions.height;
            if (!giFullDimensions && !this._forceFullSizeBlur) {
                const upsamplingRTWs = [];
                this._counters.push({
                    name: "GI upsampling",
                    value: 0
                });
                this._countersRTW.push(upsamplingRTWs);
                this._upsamplingXPostprocess = new (0, $cFdBb.PostProcess)(this._useQualityUpsampling ? "BilateralUpsampling" : "BilateralUpsamplingX", this._useQualityUpsampling ? "bilateralBlurQuality" : "bilateralBlur", {
                    uniforms: [
                        "filterSize",
                        "blurDir",
                        "depthThreshold",
                        "normalThreshold"
                    ],
                    samplers: [
                        "depthSampler",
                        "normalSampler"
                    ],
                    defines: decodeGeometryBufferNormals ? "#define DECODE_NORMAL" : undefined,
                    size: blurTextureSize,
                    samplingMode: 2,
                    engine: this._engine,
                    textureType: this._giTextureType,
                    textureFormat: textureFormat
                });
                this._upsamplingXPostprocess.autoClear = false;
                this._upsamplingXPostprocess.onApplyObservable.add((effect)=>{
                    effect.setTexture("depthSampler", geometryBufferRenderer.getGBuffer().textures[geometryBufferRenderer.getTextureIndex((0, $gXqe5.GeometryBufferRenderer).DEPTH_TEXTURE_TYPE)]);
                    effect.setTexture("normalSampler", geometryBufferRenderer.getGBuffer().textures[geometryBufferRenderer.getTextureIndex((0, $gXqe5.GeometryBufferRenderer).NORMAL_TEXTURE_TYPE)]);
                    effect.setInt("filterSize", this.upsamplerKernel);
                    effect.setFloat2("blurDir", 1 / this._outputDimensions.width, this._useQualityUpsampling ? 1 / this._outputDimensions.height : 0);
                    effect.setFloat("depthThreshold", this.blurDepthThreshold);
                    effect.setFloat("normalThreshold", this.blurNormalThreshold);
                });
                this._upsamplingXPostprocess.resize(blurTextureSize.width, blurTextureSize.height);
                blurRTWs.push(this._upsamplingXPostprocess.inputTexture);
                if (!this.useQualityUpsampling) {
                    this._upsamplingYPostprocess = new (0, $cFdBb.PostProcess)("BilateralUpsamplingY", "bilateralBlur", {
                        uniforms: [
                            "filterSize",
                            "blurDir",
                            "depthThreshold",
                            "normalThreshold"
                        ],
                        samplers: [
                            "depthSampler",
                            "normalSampler"
                        ],
                        defines: decodeGeometryBufferNormals ? "#define DECODE_NORMAL" : undefined,
                        size: this._outputDimensions,
                        samplingMode: 2,
                        engine: this._engine,
                        textureType: this._giTextureType,
                        textureFormat: textureFormat
                    });
                    this._upsamplingYPostprocess.autoClear = false;
                    this._upsamplingYPostprocess.onApplyObservable.add((effect)=>{
                        effect.setTexture("depthSampler", geometryBufferRenderer.getGBuffer().textures[geometryBufferRenderer.getTextureIndex((0, $gXqe5.GeometryBufferRenderer).DEPTH_TEXTURE_TYPE)]);
                        effect.setTexture("normalSampler", geometryBufferRenderer.getGBuffer().textures[geometryBufferRenderer.getTextureIndex((0, $gXqe5.GeometryBufferRenderer).NORMAL_TEXTURE_TYPE)]);
                        effect.setInt("filterSize", this.upsamplerKernel);
                        effect.setFloat2("blurDir", 0, 1 / this._outputDimensions.height);
                        effect.setFloat("depthThreshold", this.blurDepthThreshold);
                        effect.setFloat("normalThreshold", this.blurNormalThreshold);
                    });
                    this._upsamplingYPostprocess.resize(this._outputDimensions.width, this._outputDimensions.height);
                    upsamplingRTWs.push(this._upsamplingYPostprocess.inputTexture);
                }
                upsamplingRTWs.push(this._blurRTT.renderTarget);
                this._blurPostProcesses.push(this._upsamplingXPostprocess);
                if (this._upsamplingYPostprocess) this._blurPostProcesses.push(this._upsamplingYPostprocess);
            } else blurRTWs.push(this._blurRTT.renderTarget);
        }
        this._debugLayer.texture?.dispose();
        this._debugLayer.texture = new (0, $akOl3.BaseTexture)(this._scene, this._enableBlur ? this._blurRTT.renderTarget.texture : this._ppGlobalIllumination[0].inputTexture.texture);
    }
    _addGISupportToMaterial(material) {
        if (material.pluginManager?.getPlugin($2da5a4475f90d0ce$export$ae2e267abaf9f1df.Name)) return;
        const plugin = new $2da5a4475f90d0ce$export$ae2e267abaf9f1df(material);
        if (this._enable && this._ppGlobalIllumination.length > 0) {
            plugin.textureGIContrib = this._ppGlobalIllumination[0].inputTexture.texture;
            plugin.outputTextureWidth = this._outputDimensions.width;
            plugin.outputTextureHeight = this._outputDimensions.height;
        }
        plugin.isEnabled = this._enable;
        this._materialsWithRenderPlugin.push(material);
    }
}
/**
 * Defines the default texture types and formats used by the geometry buffer renderer.
 */ $2da5a4475f90d0ce$export$2e8be5c00f6d66e2.GeometryBufferTextureTypesAndFormats = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    0: {
        textureType: 2,
        textureFormat: 6
    },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    1: {
        textureType: 11,
        textureFormat: 5
    },
    // eslint-disable-next-line @typescript-eslint/naming-convention
    2: {
        textureType: 2,
        textureFormat: 5
    }
};
/**
 * @internal
 */ class $2da5a4475f90d0ce$var$MaterialGIRSMRenderDefines extends (0, $35xmP.MaterialDefines) {
    constructor(){
        super(...arguments);
        this.RENDER_WITH_GIRSM = false;
        this.RSMCREATE_PROJTEXTURE = false;
    }
}
class $2da5a4475f90d0ce$export$ae2e267abaf9f1df extends (0, $8XNAC.MaterialPluginBase) {
    _markAllSubMeshesAsTexturesDirty() {
        this._enable(this._isEnabled);
        this._internalMarkAllSubMeshesAsTexturesDirty();
    }
    constructor(material){
        super(material, $2da5a4475f90d0ce$export$ae2e267abaf9f1df.Name, 310, new $2da5a4475f90d0ce$var$MaterialGIRSMRenderDefines());
        this._isEnabled = false;
        /**
         * Defines if the plugin is enabled in the material.
         */ this.isEnabled = false;
        this._internalMarkAllSubMeshesAsTexturesDirty = material._dirtyCallbacks[1];
        this._isPBR = material instanceof (0, $4G6Xh.PBRBaseMaterial);
    }
    prepareDefines(defines) {
        defines.RENDER_WITH_GIRSM = this._isEnabled;
    }
    getClassName() {
        return "GIRSMRenderPluginMaterial";
    }
    getUniforms() {
        return {
            ubo: [
                {
                    name: "girsmTextureOutputSize",
                    size: 2,
                    type: "vec2"
                }
            ],
            fragment: `#ifdef RENDER_WITH_GIRSM
                    uniform vec2 girsmTextureOutputSize;
                #endif`
        };
    }
    getSamplers(samplers) {
        samplers.push("girsmTextureGIContrib");
    }
    bindForSubMesh(uniformBuffer) {
        if (this._isEnabled) {
            uniformBuffer.bindTexture("girsmTextureGIContrib", this.textureGIContrib);
            uniformBuffer.updateFloat2("girsmTextureOutputSize", this.outputTextureWidth, this.outputTextureHeight);
        }
    }
    getCustomCode(shaderType) {
        const frag = {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            CUSTOM_FRAGMENT_DEFINITIONS: `
                #ifdef RENDER_WITH_GIRSM
                    uniform sampler2D girsmTextureGIContrib;

                    vec3 computeIndirect() {
                        vec2 uv = gl_FragCoord.xy / girsmTextureOutputSize;
                        return texture2D(girsmTextureGIContrib, uv).rgb;
                    }
                #endif
            `,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            CUSTOM_FRAGMENT_BEFORE_FINALCOLORCOMPOSITION: `
                #ifdef RENDER_WITH_GIRSM
                    finalDiffuse += computeIndirect() * surfaceAlbedo.rgb;
                #endif
            `
        };
        if (!this._isPBR) frag["CUSTOM_FRAGMENT_BEFORE_FRAGCOLOR"] = `
                #ifdef RENDER_WITH_GIRSM
                    color.rgb += computeIndirect() * baseColor.rgb;
                #endif
            `;
        return shaderType === "vertex" ? null : frag;
    }
}
/**
 * Defines the name of the plugin.
 */ $2da5a4475f90d0ce$export$ae2e267abaf9f1df.Name = "GIRSMRender";
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $2da5a4475f90d0ce$export$ae2e267abaf9f1df.prototype, "textureGIContrib", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $2da5a4475f90d0ce$export$ae2e267abaf9f1df.prototype, "outputTextureWidth", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $2da5a4475f90d0ce$export$ae2e267abaf9f1df.prototype, "outputTextureHeight", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)(),
    (0, $ir0rz.expandToProperty)("_markAllSubMeshesAsTexturesDirty")
], $2da5a4475f90d0ce$export$ae2e267abaf9f1df.prototype, "isEnabled", void 0);
(0, $8DoUR.RegisterClass)(`BABYLON.GIRSMRenderPluginMaterial`, $2da5a4475f90d0ce$export$ae2e267abaf9f1df);

});
parcelRegister("lLKcB", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $fd91d390598f68a5$var$name = "bilateralBlurPixelShader";
const $fd91d390598f68a5$var$shader = `uniform sampler2D textureSampler;uniform sampler2D depthSampler;uniform sampler2D normalSampler;uniform int filterSize;uniform vec2 blurDir;uniform float depthThreshold;uniform float normalThreshold;varying vec2 vUV;void main(void) {vec3 color=textureLod(textureSampler,vUV,0.).rgb;float depth=textureLod(depthSampler,vUV,0.).x;if (depth>=1e6 || depth<=0.) {glFragColor=vec4(color,1.);return;}
vec3 normal=textureLod(normalSampler,vUV,0.).rgb;
#ifdef DECODE_NORMAL
normal=normal*2.0-1.0;
#endif
float sigma=float(filterSize);float two_sigma2=2.0*sigma*sigma;float sigmaDepth=depthThreshold;float two_sigmaDepth2=2.0*sigmaDepth*sigmaDepth;float sigmaNormal=normalThreshold;float two_sigmaNormal2=2.0*sigmaNormal*sigmaNormal;vec3 sum=vec3(0.);float wsum=0.;for (int x=-filterSize; x<=filterSize; ++x) {vec2 coords=vec2(x);vec3 sampleColor=textureLod(textureSampler,vUV+coords*blurDir,0.).rgb;float sampleDepth=textureLod(depthSampler,vUV+coords*blurDir,0.).r;vec3 sampleNormal=textureLod(normalSampler,vUV+coords*blurDir,0.).rgb;
#ifdef DECODE_NORMAL
sampleNormal=sampleNormal*2.0-1.0;
#endif
float r=dot(coords,coords);float w=exp(-r/two_sigma2);float depthDelta=abs(sampleDepth-depth);float wd=step(depthDelta,depthThreshold);vec3 normalDelta=abs(sampleNormal-normal);float wn=step(normalDelta.x+normalDelta.y+normalDelta.z,normalThreshold);sum+=sampleColor*w*wd*wn;wsum+=w*wd*wn;}
glFragColor=vec4(sum/wsum,1.);}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$fd91d390598f68a5$var$name] = $fd91d390598f68a5$var$shader;
const $fd91d390598f68a5$export$af0e4b7d69a56d97 = {
    name: $fd91d390598f68a5$var$name,
    shader: $fd91d390598f68a5$var$shader
};

});

parcelRegister("1ANKK", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $128fbf22b3fd9823$var$name = "bilateralBlurQualityPixelShader";
const $128fbf22b3fd9823$var$shader = `uniform sampler2D textureSampler;uniform sampler2D depthSampler;uniform sampler2D normalSampler;uniform int filterSize;uniform vec2 blurDir;uniform float depthThreshold;uniform float normalThreshold;varying vec2 vUV;void main(void) {vec3 color=textureLod(textureSampler,vUV,0.).rgb;float depth=textureLod(depthSampler,vUV,0.).x;if (depth>=1e6 || depth<=0.) {glFragColor=vec4(color,1.);return;}
vec3 normal=textureLod(normalSampler,vUV,0.).rgb;
#ifdef DECODE_NORMAL
normal=normal*2.0-1.0;
#endif
float sigma=float(filterSize);float two_sigma2=2.0*sigma*sigma;float sigmaDepth=depthThreshold;float two_sigmaDepth2=2.0*sigmaDepth*sigmaDepth;float sigmaNormal=normalThreshold;float two_sigmaNormal2=2.0*sigmaNormal*sigmaNormal;vec3 sum=vec3(0.);float wsum=0.;for (int x=-filterSize; x<=filterSize; ++x) {for (int y=-filterSize; y<=filterSize; ++y) {vec2 coords=vec2(x,y)*blurDir;vec3 sampleColor=textureLod(textureSampler,vUV+coords,0.).rgb;float sampleDepth=textureLod(depthSampler,vUV+coords,0.).r;vec3 sampleNormal=textureLod(normalSampler,vUV+coords,0.).rgb;
#ifdef DECODE_NORMAL
sampleNormal=sampleNormal*2.0-1.0;
#endif
float r=dot(coords,coords);float w=exp(-r/two_sigma2);float rDepth=sampleDepth-depth;float wd=exp(-rDepth*rDepth/two_sigmaDepth2);float rNormal=abs(sampleNormal.x-normal.x)+abs(sampleNormal.y-normal.y)+abs(sampleNormal.z-normal.z);float wn=exp(-rNormal*rNormal/two_sigmaNormal2);sum+=sampleColor*w*wd*wn;wsum+=w*wd*wn;}}
glFragColor=vec4(sum/wsum,1.);}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$128fbf22b3fd9823$var$name] = $128fbf22b3fd9823$var$shader;
const $128fbf22b3fd9823$export$cda77439cc9f0f0e = {
    name: $128fbf22b3fd9823$var$name,
    shader: $128fbf22b3fd9823$var$shader
};

});

parcelRegister("laCjp", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $f6984022217daea3$var$name = "rsmGlobalIlluminationPixelShader";
const $f6984022217daea3$var$shader = `/**
* The implementation is an application of the formula found in http:
* For better results,it also adds a random (noise) rotation to the RSM samples (the noise artifacts are easier to remove than the banding artifacts).
*/
precision highp float;varying vec2 vUV;uniform mat4 rsmLightMatrix;uniform vec4 rsmInfo;uniform vec4 rsmInfo2;uniform sampler2D textureSampler;uniform sampler2D normalSampler;uniform sampler2D rsmPositionW;uniform sampler2D rsmNormalW;uniform sampler2D rsmFlux;uniform sampler2D rsmSamples;
#ifdef TRANSFORM_NORMAL
uniform mat4 invView;
#endif
float mod289(float x){return x-floor(x*(1.0/289.0))*289.0;}
vec4 mod289(vec4 x){return x-floor(x*(1.0/289.0))*289.0;}
vec4 perm(vec4 x){return mod289(((x*34.0)+1.0)*x);}
float noise(vec3 p){vec3 a=floor(p);vec3 d=p-a;d=d*d*(3.0-2.0*d);vec4 b=a.xxyy+vec4(0.0,1.0,0.0,1.0);vec4 k1=perm(b.xyxy);vec4 k2=perm(k1.xyxy+b.zzww);vec4 c=k2+a.zzzz;vec4 k3=perm(c);vec4 k4=perm(c+1.0);vec4 o1=fract(k3*(1.0/41.0));vec4 o2=fract(k4*(1.0/41.0));vec4 o3=o2*d.z+o1*(1.0-d.z);vec2 o4=o3.yw*d.x+o3.xz*(1.0-d.x);return o4.y*d.y+o4.x*(1.0-d.y);}
vec3 computeIndirect(vec3 p,vec3 n) {vec3 indirectDiffuse=vec3(0.);int numSamples=int(rsmInfo.x);float radius=rsmInfo.y;float intensity=rsmInfo.z;float edgeArtifactCorrection=rsmInfo.w;vec4 texRSM=rsmLightMatrix*vec4(p,1.);texRSM.xy/=texRSM.w;texRSM.xy=texRSM.xy*0.5+0.5;float angle=noise(p*rsmInfo2.x);float c=cos(angle);float s=sin(angle);for (int i=0; i<numSamples; i++) {vec3 rsmSample=texelFetch(rsmSamples,ivec2(i,0),0).xyz;float weightSquare=rsmSample.z;if (rsmInfo2.y==1.0) rsmSample.xy=vec2(rsmSample.x*c+rsmSample.y*s,-rsmSample.x*s+rsmSample.y*c);vec2 uv=texRSM.xy+rsmSample.xy*radius;if (uv.x<0. || uv.x>1. || uv.y<0. || uv.y>1.) continue;vec3 vplPositionW=textureLod(rsmPositionW,uv,0.).xyz;vec3 vplNormalW=textureLod(rsmNormalW,uv,0.).xyz*2.0-1.0;vec3 vplFlux=textureLod(rsmFlux,uv,0.).rgb;vplPositionW-=vplNormalW*edgeArtifactCorrection; 
float dist2=dot(vplPositionW-p,vplPositionW-p);indirectDiffuse+=vplFlux*weightSquare*max(0.,dot(n,vplPositionW-p))*max(0.,dot(vplNormalW,p-vplPositionW))/(dist2*dist2);}
return clamp(indirectDiffuse*intensity,0.0,1.0);}
void main(void) 
{vec3 positionW=texture2D(textureSampler,vUV).xyz;vec3 normalW=texture2D(normalSampler,vUV).xyz;
#ifdef DECODE_NORMAL
normalW=normalW*2.0-1.0;
#endif
#ifdef TRANSFORM_NORMAL
normalW=(invView*vec4(normalW,0.)).xyz;
#endif
gl_FragColor.rgb=computeIndirect(positionW,normalW);gl_FragColor.a=1.0;}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$f6984022217daea3$var$name] = $f6984022217daea3$var$shader;
const $f6984022217daea3$export$2dd4ba5e98215ec = {
    name: $f6984022217daea3$var$name,
    shader: $f6984022217daea3$var$shader
};

});

parcelRegister("lURFH", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $ff4875ff5e6d7804$var$name = "rsmFullGlobalIlluminationPixelShader";
const $ff4875ff5e6d7804$var$shader = `/**
* The implementation is a direct application of the formula found in http:
*/
precision highp float;varying vec2 vUV;uniform mat4 rsmLightMatrix;uniform vec4 rsmInfo;uniform sampler2D textureSampler;uniform sampler2D normalSampler;uniform sampler2D rsmPositionW;uniform sampler2D rsmNormalW;uniform sampler2D rsmFlux;
#ifdef TRANSFORM_NORMAL
uniform mat4 invView;
#endif
vec3 computeIndirect(vec3 p,vec3 n) {vec3 indirectDiffuse=vec3(0.);float intensity=rsmInfo.z;float edgeArtifactCorrection=rsmInfo.w;vec4 texRSM=rsmLightMatrix*vec4(p,1.);texRSM.xy/=texRSM.w;texRSM.xy=texRSM.xy*0.5+0.5;int width=int(rsmInfo.x);int height=int(rsmInfo.y);for (int j=0; j<height; j++) {for (int i=0; i<width; i++) {ivec2 uv=ivec2(i,j);vec3 vplPositionW=texelFetch(rsmPositionW,uv,0).xyz;vec3 vplNormalW=texelFetch(rsmNormalW,uv,0).xyz*2.0-1.0;vec3 vplFlux=texelFetch(rsmFlux,uv,0).rgb;vplPositionW-=vplNormalW*edgeArtifactCorrection; 
float dist2=dot(vplPositionW-p,vplPositionW-p);indirectDiffuse+=vplFlux*max(0.,dot(n,vplPositionW-p))*max(0.,dot(vplNormalW,p-vplPositionW))/(dist2*dist2);}}
return clamp(indirectDiffuse*intensity,0.0,1.0);}
void main(void) 
{vec3 positionW=texture2D(textureSampler,vUV).xyz;vec3 normalW=texture2D(normalSampler,vUV).xyz;
#ifdef DECODE_NORMAL
normalW=normalW*2.0-1.0;
#endif
#ifdef TRANSFORM_NORMAL
normalW=(invView*vec4(normalW,0.)).xyz;
#endif
gl_FragColor.rgb=computeIndirect(positionW,normalW);gl_FragColor.a=1.0;}
`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$ff4875ff5e6d7804$var$name] = $ff4875ff5e6d7804$var$shader;
const $ff4875ff5e6d7804$export$ecbf01ee511adc2f = {
    name: $ff4875ff5e6d7804$var$name,
    shader: $ff4875ff5e6d7804$var$shader
};

});




parcelRegister("4hgCb", function(module, exports) {

var $hQxeF = parcelRequire("hQxeF");

var $kmI8c = parcelRequire("kmI8c");

var $CnKcI = parcelRequire("CnKcI");

var $01Tmp = parcelRequire("01Tmp");

var $7jWht = parcelRequire("7jWht");

var $3mCyn = parcelRequire("3mCyn");
$parcel$exportWildcard(module.exports, $hQxeF);
$parcel$exportWildcard(module.exports, $kmI8c);
$parcel$exportWildcard(module.exports, $CnKcI);
$parcel$exportWildcard(module.exports, $01Tmp);
$parcel$exportWildcard(module.exports, $7jWht);
$parcel$exportWildcard(module.exports, $3mCyn);

});
parcelRegister("kmI8c", function(module, exports) {

});

parcelRegister("01Tmp", function(module, exports) {

$parcel$export(module.exports, "SpriteMap", () => $005b0988717918f6$export$16692ad30c6287ef);

var $5YkyR = parcelRequire("5YkyR");

var $ha1VO = parcelRequire("ha1VO");

var $j2mX5 = parcelRequire("j2mX5");

var $5Egpj = parcelRequire("5Egpj");

var $4I7rl = parcelRequire("4I7rl");

var $lUDWq = parcelRequire("lUDWq");

var $kt6s5 = parcelRequire("kt6s5");
parcelRequire("3y1K7");
parcelRequire("eli1y");
class $005b0988717918f6$export$16692ad30c6287ef {
    /** Returns the Number of Sprites in the System */ get spriteCount() {
        return this.sprites.length;
    }
    /** Returns the Position of Output Plane*/ get position() {
        return this._output.position;
    }
    /** Returns the Position of Output Plane*/ set position(v) {
        this._output.position = v;
    }
    /** Returns the Rotation of Output Plane*/ get rotation() {
        return this._output.rotation;
    }
    /** Returns the Rotation of Output Plane*/ set rotation(v) {
        this._output.rotation = v;
    }
    /** Sets the AnimationMap*/ get animationMap() {
        return this._animationMap;
    }
    /** Sets the AnimationMap*/ set animationMap(v) {
        const buffer = v._texture._bufferView;
        const am = this._createTileAnimationBuffer(buffer);
        this._animationMap.dispose();
        this._animationMap = am;
        this._material.setTexture("animationMap", this._animationMap);
    }
    /**
     * Creates a new SpriteMap
     * @param name defines the SpriteMaps Name
     * @param atlasJSON is the JSON file that controls the Sprites Frames and Meta
     * @param spriteSheet is the Texture that the Sprites are on.
     * @param options a basic deployment configuration
     * @param scene The Scene that the map is deployed on
     */ constructor(name, atlasJSON, spriteSheet, options, scene){
        this.name = name;
        this.sprites = [];
        this.atlasJSON = atlasJSON;
        this.sprites = this.atlasJSON["frames"];
        this.spriteSheet = spriteSheet;
        /**
         * Run through the options and set what ever defaults are needed that where not declared.
         */ this.options = options;
        options.stageSize = options.stageSize || new (0, $ha1VO.Vector2)(1, 1);
        options.outputSize = options.outputSize || options.stageSize;
        options.outputPosition = options.outputPosition || (0, $ha1VO.Vector3).Zero();
        options.outputRotation = options.outputRotation || (0, $ha1VO.Vector3).Zero();
        options.layerCount = options.layerCount || 1;
        options.maxAnimationFrames = options.maxAnimationFrames || 0;
        options.baseTile = options.baseTile || 0;
        options.flipU = options.flipU || false;
        options.colorMultiply = options.colorMultiply || new (0, $ha1VO.Vector3)(1, 1, 1);
        this._scene = scene;
        this._frameMap = this._createFrameBuffer();
        this._tileMaps = new Array();
        for(let i = 0; i < options.layerCount; i++)this._tileMaps.push(this._createTileBuffer(null, i));
        this._animationMap = this._createTileAnimationBuffer(null);
        const defines = [];
        defines.push("#define LAYERS " + options.layerCount);
        if (options.flipU) defines.push("#define FLIPU");
        defines.push(`#define MAX_ANIMATION_FRAMES ${options.maxAnimationFrames}.0`);
        const shaderString = (0, $lUDWq.Effect).ShadersStore["spriteMapPixelShader"];
        let layerSampleString;
        if (!scene.getEngine()._features.supportSwitchCaseInShader) {
            layerSampleString = "";
            for(let i = 0; i < options.layerCount; i++)layerSampleString += `if (${i} == i) { frameID = texture2D(tileMaps[${i}], (tileID + 0.5) / stageSize, 0.).x; }`;
        } else {
            layerSampleString = "switch(i) {";
            for(let i = 0; i < options.layerCount; i++){
                layerSampleString += "case " + i + " : frameID = texture(tileMaps[" + i + "], (tileID + 0.5) / stageSize, 0.).x;";
                layerSampleString += "break;";
            }
            layerSampleString += "}";
        }
        (0, $lUDWq.Effect).ShadersStore["spriteMap" + this.name + "PixelShader"] = shaderString.replace("#define LAYER_ID_SWITCH", layerSampleString);
        this._material = new (0, $4I7rl.ShaderMaterial)("spriteMap:" + this.name, this._scene, {
            vertex: "spriteMap",
            fragment: "spriteMap" + this.name
        }, {
            defines: defines,
            attributes: [
                "position",
                "normal",
                "uv"
            ],
            uniforms: [
                "worldViewProjection",
                "time",
                "stageSize",
                "outputSize",
                "spriteMapSize",
                "spriteCount",
                "time",
                "colorMul",
                "mousePosition",
                "curTile",
                "flipU"
            ],
            samplers: [
                "spriteSheet",
                "frameMap",
                "tileMaps",
                "animationMap"
            ],
            needAlphaBlending: true
        });
        this._time = 0;
        this._material.setFloat("spriteCount", this.spriteCount);
        this._material.setVector2("stageSize", options.stageSize);
        this._material.setVector2("outputSize", options.outputSize);
        this._material.setTexture("spriteSheet", this.spriteSheet);
        this._material.setVector2("spriteMapSize", new (0, $ha1VO.Vector2)(1, 1));
        this._material.setVector3("colorMul", options.colorMultiply);
        let tickSave = 0;
        const bindSpriteTexture = ()=>{
            if (this.spriteSheet && this.spriteSheet.isReady()) {
                if (this.spriteSheet._texture) {
                    this._material.setVector2("spriteMapSize", new (0, $ha1VO.Vector2)(this.spriteSheet._texture.baseWidth || 1, this.spriteSheet._texture.baseHeight || 1));
                    return;
                }
            }
            if (tickSave < 100) setTimeout(()=>{
                tickSave++;
                bindSpriteTexture();
            }, 100);
        };
        bindSpriteTexture();
        this._material.setVector3("colorMul", options.colorMultiply);
        this._material.setTexture("frameMap", this._frameMap);
        this._material.setTextureArray("tileMaps", this._tileMaps);
        this._material.setTexture("animationMap", this._animationMap);
        this._material.setFloat("time", this._time);
        this._output = (0, $kt6s5.CreatePlane)(name + ":output", {
            size: 1,
            updatable: true
        }, scene);
        this._output.scaling.x = options.outputSize.x;
        this._output.scaling.y = options.outputSize.y;
        this.position = options.outputPosition;
        this.rotation = options.outputRotation;
        const obfunction = ()=>{
            this._time += this._scene.getEngine().getDeltaTime();
            this._material.setFloat("time", this._time);
        };
        this._scene.onBeforeRenderObservable.add(obfunction);
        this._output.material = this._material;
    }
    /**
     * Returns tileID location
     * @returns Vector2 the cell position ID
     */ getTileID() {
        const p = this.getMousePosition();
        p.multiplyInPlace(this.options.stageSize || (0, $ha1VO.Vector2).Zero());
        p.x = Math.floor(p.x);
        p.y = Math.floor(p.y);
        return p;
    }
    /**
     * Gets the UV location of the mouse over the SpriteMap.
     * @returns Vector2 the UV position of the mouse interaction
     */ getMousePosition() {
        const out = this._output;
        const pickinfo = this._scene.pick(this._scene.pointerX, this._scene.pointerY, (mesh)=>{
            if (mesh !== out) return false;
            return true;
        });
        if (!pickinfo || !pickinfo.hit || !pickinfo.getTextureCoordinates) return new (0, $ha1VO.Vector2)(-1, -1);
        const coords = pickinfo.getTextureCoordinates();
        if (coords) return coords;
        return new (0, $ha1VO.Vector2)(-1, -1);
    }
    /**
     * Creates the "frame" texture Buffer
     * -------------------------------------
     * Structure of frames
     *  "filename": "Falling-Water-2.png",
     * "frame": {"x":69,"y":103,"w":24,"h":32},
     * "rotated": true,
     * "trimmed": true,
     * "spriteSourceSize": {"x":4,"y":0,"w":24,"h":32},
     * "sourceSize": {"w":32,"h":32}
     * @returns RawTexture of the frameMap
     */ _createFrameBuffer() {
        const data = [];
        //Do two Passes
        for(let i = 0; i < this.spriteCount; i++){
            data.push(0, 0, 0, 0); //frame
            data.push(0, 0, 0, 0); //spriteSourceSize
            data.push(0, 0, 0, 0); //sourceSize, rotated, trimmed
            data.push(0, 0, 0, 0); //Keep it pow2 cause I"m cool like that... it helps with sampling accuracy as well. Plus then we have 4 other parameters for future stuff.
        }
        //Second Pass
        for(let i = 0; i < this.spriteCount; i++){
            const f = this.sprites[i]["frame"];
            const sss = this.sprites[i]["spriteSourceSize"];
            const ss = this.sprites[i]["sourceSize"];
            const r = this.sprites[i]["rotated"] ? 1 : 0;
            const t = this.sprites[i]["trimmed"] ? 1 : 0;
            //frame
            data[i * 4] = f.x;
            data[i * 4 + 1] = f.y;
            data[i * 4 + 2] = f.w;
            data[i * 4 + 3] = f.h;
            //spriteSourceSize
            data[i * 4 + this.spriteCount * 4] = sss.x;
            data[i * 4 + 1 + this.spriteCount * 4] = sss.y;
            data[i * 4 + 3 + this.spriteCount * 4] = sss.h;
            //sourceSize, rotated, trimmed
            data[i * 4 + this.spriteCount * 8] = ss.w;
            data[i * 4 + 1 + this.spriteCount * 8] = ss.h;
            data[i * 4 + 2 + this.spriteCount * 8] = r;
            data[i * 4 + 3 + this.spriteCount * 8] = t;
        }
        const floatArray = new Float32Array(data);
        const t = (0, $5Egpj.RawTexture).CreateRGBATexture(floatArray, this.spriteCount, 4, this._scene, false, false, (0, $j2mX5.Texture).NEAREST_NEAREST, (0, $5YkyR.Engine).TEXTURETYPE_FLOAT);
        return t;
    }
    /**
     * Creates the tileMap texture Buffer
     * @param buffer normally and array of numbers, or a false to generate from scratch
     * @param _layer indicates what layer for a logic trigger dealing with the baseTile.  The system uses this
     * @returns RawTexture of the tileMap
     */ _createTileBuffer(buffer, _layer = 0) {
        let data = [];
        const _ty = this.options.stageSize.y || 0;
        const _tx = this.options.stageSize.x || 0;
        if (!buffer) {
            let bt = this.options.baseTile;
            if (_layer != 0) bt = 0;
            for(let y = 0; y < _ty; y++)for(let x = 0; x < _tx * 4; x += 4)data.push(bt, 0, 0, 0);
        } else data = buffer;
        const floatArray = new Float32Array(data);
        const t = (0, $5Egpj.RawTexture).CreateRGBATexture(floatArray, _tx, _ty, this._scene, false, false, (0, $j2mX5.Texture).NEAREST_NEAREST, (0, $5YkyR.Engine).TEXTURETYPE_FLOAT);
        return t;
    }
    /**
     * Modifies the data of the tileMaps
     * @param _layer is the ID of the layer you want to edit on the SpriteMap
     * @param pos is the iVector2 Coordinates of the Tile
     * @param tile The SpriteIndex of the new Tile
     */ changeTiles(_layer = 0, pos, tile = 0) {
        const buffer = this._tileMaps[_layer]._texture._bufferView;
        if (buffer === null) return;
        let p = [];
        if (pos instanceof (0, $ha1VO.Vector2)) p.push(pos);
        else p = pos;
        const _tx = this.options.stageSize.x || 0;
        for(let i = 0; i < p.length; i++){
            const _p = p[i];
            _p.x = Math.floor(_p.x);
            _p.y = Math.floor(_p.y);
            const id = _p.x * 4 + _p.y * (_tx * 4);
            buffer[id] = tile;
        }
        const t = this._createTileBuffer(buffer);
        this._tileMaps[_layer].dispose();
        this._tileMaps[_layer] = t;
        this._material.setTextureArray("tileMap", this._tileMaps);
    }
    /**
     * Creates the animationMap texture Buffer
     * @param buffer normally and array of numbers, or a false to generate from scratch
     * @returns RawTexture of the animationMap
     */ _createTileAnimationBuffer(buffer) {
        const data = [];
        let floatArray;
        if (!buffer) {
            for(let i = 0; i < this.spriteCount; i++){
                data.push(0, 0, 0, 0);
                let count = 1;
                while(count < (this.options.maxAnimationFrames || 4)){
                    data.push(0, 0, 0, 0);
                    count++;
                }
            }
            floatArray = new Float32Array(data);
        } else floatArray = buffer;
        const t = (0, $5Egpj.RawTexture).CreateRGBATexture(floatArray, this.spriteCount, this.options.maxAnimationFrames || 4, this._scene, false, false, (0, $j2mX5.Texture).NEAREST_NEAREST, (0, $5YkyR.Engine).TEXTURETYPE_FLOAT);
        return t;
    }
    /**
     * Modifies the data of the animationMap
     * @param cellID is the Index of the Sprite
     * @param _frame is the target Animation frame
     * @param toCell is the Target Index of the next frame of the animation
     * @param time is a value between 0-1 that is the trigger for when the frame should change tiles
     * @param speed is a global scalar of the time variable on the map.
     */ addAnimationToTile(cellID = 0, _frame = 0, toCell = 0, time = 0, speed = 1) {
        const buffer = this._animationMap._texture._bufferView;
        const id = cellID * 4 + this.spriteCount * 4 * _frame;
        if (!buffer) return;
        buffer[id] = toCell;
        buffer[id + 1] = time;
        buffer[id + 2] = speed;
        const t = this._createTileAnimationBuffer(buffer);
        this._animationMap.dispose();
        this._animationMap = t;
        this._material.setTexture("animationMap", this._animationMap);
    }
    /**
     * Exports the .tilemaps file
     */ saveTileMaps() {
        let maps = "";
        for(let i = 0; i < this._tileMaps.length; i++){
            if (i > 0) maps += "\n\r";
            maps += this._tileMaps[i]._texture._bufferView.toString();
        }
        const hiddenElement = document.createElement("a");
        hiddenElement.href = "data:octet/stream;charset=utf-8," + encodeURI(maps);
        hiddenElement.target = "_blank";
        hiddenElement.download = this.name + ".tilemaps";
        hiddenElement.click();
        hiddenElement.remove();
    }
    /**
     * Imports the .tilemaps file
     * @param url of the .tilemaps file
     */ loadTileMaps(url) {
        const xhr = new XMLHttpRequest();
        xhr.open("GET", url);
        const _lc = this.options.layerCount || 0;
        xhr.onload = ()=>{
            const data = xhr.response.split("\n\r");
            for(let i = 0; i < _lc; i++){
                const d = data[i].split(",").map(Number);
                const t = this._createTileBuffer(d);
                this._tileMaps[i].dispose();
                this._tileMaps[i] = t;
            }
            this._material.setTextureArray("tileMap", this._tileMaps);
        };
        xhr.send();
    }
    /**
     * Release associated resources
     */ dispose() {
        this._output.dispose();
        this._material.dispose();
        this._animationMap.dispose();
        this._tileMaps.forEach((tm)=>{
            tm.dispose();
        });
        this._frameMap.dispose();
    }
}

});
parcelRegister("3y1K7", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $2955e6307a1b9f9b$var$name = "spriteMapPixelShader";
const $2955e6307a1b9f9b$var$shader = `#if defined(WEBGL2) || defined(WEBGPU) || defined(NATIVE)
#define TEXTUREFUNC(s,c,l) texture2DLodEXT(s,c,l)
#else
#define TEXTUREFUNC(s,c,b) texture2D(s,c,b)
#endif
precision highp float;varying vec3 vPosition;varying vec2 vUV;varying vec2 tUV;uniform float time;uniform float spriteCount;uniform sampler2D spriteSheet;uniform vec2 spriteMapSize;uniform vec2 outputSize;uniform vec2 stageSize;uniform sampler2D frameMap;uniform sampler2D tileMaps[LAYERS];uniform sampler2D animationMap;uniform vec3 colorMul;float mt;const float fdStep=1./4.;const float aFrameSteps=1./MAX_ANIMATION_FRAMES;mat4 getFrameData(float frameID){float fX=frameID/spriteCount;return mat4(
texture2D(frameMap,vec2(fX,0.),0.),
texture2D(frameMap,vec2(fX,fdStep*1.),0.),
texture2D(frameMap,vec2(fX,fdStep*2.),0.),
vec4(0.)
);}
void main(){vec4 color=vec4(0.);vec2 tileUV=fract(tUV);
#ifdef FLIPU
tileUV.y=1.0-tileUV.y;
#endif
vec2 tileID=floor(tUV);vec2 sheetUnits=1./spriteMapSize;float spriteUnits=1./spriteCount;vec2 stageUnits=1./stageSize;for(int i=0; i<LAYERS; i++) {float frameID;
#define LAYER_ID_SWITCH
vec4 animationData=TEXTUREFUNC(animationMap,vec2((frameID+0.5)/spriteCount,0.),0.);if(animationData.y>0.) {mt=mod(time*animationData.z,1.0);for(float f=0.; f<MAX_ANIMATION_FRAMES; f++){if(animationData.y>mt){frameID=animationData.x;break;}
animationData=TEXTUREFUNC(animationMap,vec2((frameID+0.5)/spriteCount,aFrameSteps*f),0.);}}
mat4 frameData=getFrameData(frameID+0.5);vec2 frameSize=(frameData[0].zw)/spriteMapSize;vec2 offset=frameData[0].xy*sheetUnits;vec2 ratio=frameData[2].xy/frameData[0].zw;if (frameData[2].z==1.){tileUV.xy=tileUV.yx;}
vec4 nc=texture2D(spriteSheet,tileUV*frameSize+offset);if (i==0){color=nc;} else {float alpha=min(color.a+nc.a,1.0);vec3 mixed=mix(color.xyz,nc.xyz,nc.a);color=vec4(mixed,alpha);}}
color.xyz*=colorMul;gl_FragColor=color;}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$2955e6307a1b9f9b$var$name] = $2955e6307a1b9f9b$var$shader;
const $2955e6307a1b9f9b$export$48f32dcede49e117 = {
    name: $2955e6307a1b9f9b$var$name,
    shader: $2955e6307a1b9f9b$var$shader
};

});

parcelRegister("eli1y", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $a711020bb0eb8330$var$name = "spriteMapVertexShader";
const $a711020bb0eb8330$var$shader = `precision highp float;attribute vec3 position;attribute vec3 normal;attribute vec2 uv;varying vec3 vPosition;varying vec2 vUV;varying vec2 tUV;varying vec2 stageUnits;varying vec2 levelUnits;varying vec2 tileID;uniform float time;uniform mat4 worldViewProjection;uniform vec2 outputSize;uniform vec2 stageSize;uniform vec2 spriteMapSize;uniform float stageScale;void main() {vec4 p=vec4( position,1. );vPosition=p.xyz;vUV=uv;tUV=uv*stageSize; 
gl_Position=worldViewProjection*p;}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$a711020bb0eb8330$var$name] = $a711020bb0eb8330$var$shader;
const $a711020bb0eb8330$export$90704b2633d9c7ee = {
    name: $a711020bb0eb8330$var$name,
    shader: $a711020bb0eb8330$var$shader
};

});


parcelRegister("7jWht", function(module, exports) {

$parcel$export(module.exports, "SpritePackedManager", () => $5547841eee3a3dd0$export$23f5337b1630f4d4);

var $CnKcI = parcelRequire("CnKcI");

var $j2mX5 = parcelRequire("j2mX5");
class $5547841eee3a3dd0$export$23f5337b1630f4d4 extends (0, $CnKcI.SpriteManager) {
    /**
     * Creates a new sprite manager from a packed sprite sheet
     * @param name defines the manager's name
     * @param imgUrl defines the sprite sheet url
     * @param capacity defines the maximum allowed number of sprites
     * @param scene defines the hosting scene
     * @param spriteJSON null otherwise a JSON object defining sprite sheet data
     * @param epsilon defines the epsilon value to align texture (0.01 by default)
     * @param samplingMode defines the sampling mode to use with spritesheet
     * @param fromPacked set to true; do not alter
     */ constructor(/** defines the packed manager's name */ name, imgUrl, capacity, scene, spriteJSON = null, epsilon = 0.01, samplingMode = (0, $j2mX5.Texture).TRILINEAR_SAMPLINGMODE){
        //the cellSize parameter is not used when built from JSON which provides individual cell data, defaults to 64 if JSON load fails
        super(name, imgUrl, capacity, 64, scene, epsilon, samplingMode, true, spriteJSON);
        this.name = name;
    }
}

});


parcelRegister("lqHJJ", function(module, exports) {

var $ano9R = parcelRequire("ano9R");

var $36XJ5 = parcelRequire("36XJ5");

var $d7F9z = parcelRequire("d7F9z");

var $cyIBx = parcelRequire("cyIBx");
$parcel$exportWildcard(module.exports, $ano9R);
$parcel$exportWildcard(module.exports, $36XJ5);
$parcel$exportWildcard(module.exports, $d7F9z);
$parcel$exportWildcard(module.exports, $cyIBx);

});

parcelRegister("uyjIM", function(module, exports) {
/* eslint-disable import/no-internal-modules */ 
var $1VA7I = parcelRequire("1VA7I");

var $lJyRE = parcelRequire("lJyRE");

var $02O3B = parcelRequire("02O3B");

var $ckies = parcelRequire("ckies");

var $ir0rz = parcelRequire("ir0rz");

var $eGizc = parcelRequire("eGizc");

var $6XNeg = parcelRequire("6XNeg");

var $jRNOx = parcelRequire("jRNOx");

var $54nOI = parcelRequire("54nOI");

var $aKoM6 = parcelRequire("aKoM6");

var $ibwgz = parcelRequire("ibwgz");

var $diGQf = parcelRequire("diGQf");

var $gDIpr = parcelRequire("gDIpr");

var $aDymS = parcelRequire("aDymS");

var $lRrz0 = parcelRequire("lRrz0");

var $2sJhC = parcelRequire("2sJhC");

var $57onU = parcelRequire("57onU");

var $895IS = parcelRequire("895IS");

var $7212E = parcelRequire("7212E");

var $3a58A = parcelRequire("3a58A");

var $2TSIk = parcelRequire("2TSIk");

var $bOhSV = parcelRequire("bOhSV");

var $hGjSH = parcelRequire("hGjSH");

var $5MhAr = parcelRequire("5MhAr");

var $ib3jc = parcelRequire("ib3jc");

var $kVtWi = parcelRequire("kVtWi");

var $8DoUR = parcelRequire("8DoUR");

var $8btZm = parcelRequire("8btZm");

var $fhgis = parcelRequire("fhgis");

var $3Pok5 = parcelRequire("3Pok5");

var $blHSI = parcelRequire("blHSI");

var $g27AK = parcelRequire("g27AK");

var $hUzEl = parcelRequire("hUzEl");

var $KFA1e = parcelRequire("KFA1e");

var $gVj3s = parcelRequire("gVj3s");

var $ezAJn = parcelRequire("ezAJn");

var $iDYnp = parcelRequire("iDYnp");

var $2Fclq = parcelRequire("2Fclq");

var $6YHU0 = parcelRequire("6YHU0");

var $2GZM8 = parcelRequire("2GZM8");

var $c10Gh = parcelRequire("c10Gh");

var $kVJni = parcelRequire("kVJni");

var $2ZHg6 = parcelRequire("2ZHg6");

var $EOxw7 = parcelRequire("EOxw7");

var $eLv1o = parcelRequire("eLv1o");

var $dB08u = parcelRequire("dB08u");

var $lfM5G = parcelRequire("lfM5G");

var $ciyho = parcelRequire("ciyho");

var $j8S6I = parcelRequire("j8S6I");

var $jEKlB = parcelRequire("jEKlB");

var $c2VJL = parcelRequire("c2VJL");

var $7Nenw = parcelRequire("7Nenw");

var $2PCL1 = parcelRequire("2PCL1");

var $f2kkL = parcelRequire("f2kkL");

var $2LOE5 = parcelRequire("2LOE5");

var $jFz47 = parcelRequire("jFz47");

var $7Aolp = parcelRequire("7Aolp");

var $8ImbE = parcelRequire("8ImbE");

var $4TYUE = parcelRequire("4TYUE");

var $321Uk = parcelRequire("321Uk");

var $1FkG9 = parcelRequire("1FkG9");

var $fdSzW = parcelRequire("fdSzW");

var $ieflZ = parcelRequire("ieflZ");

var $4dKnp = parcelRequire("4dKnp");

var $btEbG = parcelRequire("btEbG");

var $dzdrg = parcelRequire("dzdrg");

var $6Ho1L = parcelRequire("6Ho1L");
$parcel$exportWildcard(module.exports, $1VA7I);
$parcel$exportWildcard(module.exports, $lJyRE);
$parcel$exportWildcard(module.exports, $02O3B);
$parcel$exportWildcard(module.exports, $ckies);
$parcel$exportWildcard(module.exports, $ir0rz);
$parcel$exportWildcard(module.exports, $eGizc);
$parcel$exportWildcard(module.exports, $6XNeg);
$parcel$exportWildcard(module.exports, $jRNOx);
$parcel$exportWildcard(module.exports, $54nOI);
$parcel$exportWildcard(module.exports, $aKoM6);
$parcel$exportWildcard(module.exports, $ibwgz);
$parcel$exportWildcard(module.exports, $diGQf);
$parcel$exportWildcard(module.exports, $gDIpr);
$parcel$exportWildcard(module.exports, $aDymS);
$parcel$exportWildcard(module.exports, $lRrz0);
$parcel$exportWildcard(module.exports, $2sJhC);
$parcel$exportWildcard(module.exports, $57onU);
$parcel$exportWildcard(module.exports, $895IS);
$parcel$exportWildcard(module.exports, $7212E);
$parcel$exportWildcard(module.exports, $3a58A);
$parcel$exportWildcard(module.exports, $2TSIk);
$parcel$exportWildcard(module.exports, $bOhSV);
$parcel$exportWildcard(module.exports, $hGjSH);
$parcel$exportWildcard(module.exports, $5MhAr);
$parcel$exportWildcard(module.exports, $ib3jc);
$parcel$exportWildcard(module.exports, $kVtWi);
$parcel$exportWildcard(module.exports, $8DoUR);
$parcel$exportWildcard(module.exports, $8btZm);
$parcel$exportWildcard(module.exports, $fhgis);
$parcel$exportWildcard(module.exports, $3Pok5);
$parcel$exportWildcard(module.exports, $blHSI);
$parcel$exportWildcard(module.exports, $g27AK);
$parcel$exportWildcard(module.exports, $hUzEl);
$parcel$exportWildcard(module.exports, $KFA1e);
$parcel$exportWildcard(module.exports, $gVj3s);
$parcel$exportWildcard(module.exports, $ezAJn);
$parcel$exportWildcard(module.exports, $iDYnp);
$parcel$exportWildcard(module.exports, $2Fclq);
$parcel$exportWildcard(module.exports, $6YHU0);
$parcel$exportWildcard(module.exports, $2GZM8);
$parcel$exportWildcard(module.exports, $c10Gh);
$parcel$exportWildcard(module.exports, $kVJni);
$parcel$exportWildcard(module.exports, $2ZHg6);
$parcel$exportWildcard(module.exports, $EOxw7);
$parcel$exportWildcard(module.exports, $eLv1o);
$parcel$exportWildcard(module.exports, $dB08u);
$parcel$exportWildcard(module.exports, $lfM5G);
$parcel$exportWildcard(module.exports, $ciyho);
$parcel$exportWildcard(module.exports, $j8S6I);
$parcel$exportWildcard(module.exports, $jEKlB);
$parcel$exportWildcard(module.exports, $c2VJL);
$parcel$exportWildcard(module.exports, $7Nenw);
$parcel$exportWildcard(module.exports, $2PCL1);
$parcel$exportWildcard(module.exports, $f2kkL);
$parcel$exportWildcard(module.exports, $2LOE5);
$parcel$exportWildcard(module.exports, $jFz47);
$parcel$exportWildcard(module.exports, $7Aolp);
$parcel$exportWildcard(module.exports, $8ImbE);
$parcel$exportWildcard(module.exports, $4TYUE);
$parcel$exportWildcard(module.exports, $321Uk);
$parcel$exportWildcard(module.exports, $1FkG9);
$parcel$exportWildcard(module.exports, $fdSzW);
$parcel$exportWildcard(module.exports, $ieflZ);
$parcel$exportWildcard(module.exports, $4dKnp);
$parcel$exportWildcard(module.exports, $btEbG);
$parcel$exportWildcard(module.exports, $dzdrg);
$parcel$exportWildcard(module.exports, $6Ho1L);

});
parcelRegister("lJyRE", function(module, exports) {

$parcel$export(module.exports, "AssetTaskState", () => $fd28d8415b206c45$export$4fa1129f29e88395);
$parcel$export(module.exports, "AbstractAssetTask", () => $fd28d8415b206c45$export$2653b587090b2358);
$parcel$export(module.exports, "AssetsProgressEvent", () => $fd28d8415b206c45$export$8f58bcbaf09b8601);
$parcel$export(module.exports, "ContainerAssetTask", () => $fd28d8415b206c45$export$f3283b11865f28c8);
$parcel$export(module.exports, "MeshAssetTask", () => $fd28d8415b206c45$export$83140e8c24fda518);
$parcel$export(module.exports, "AnimationAssetTask", () => $fd28d8415b206c45$export$194b91f0856c330d);
$parcel$export(module.exports, "TextFileAssetTask", () => $fd28d8415b206c45$export$1a169b52494227a0);
$parcel$export(module.exports, "BinaryFileAssetTask", () => $fd28d8415b206c45$export$b3f6a8b0827bd9f8);
$parcel$export(module.exports, "ImageAssetTask", () => $fd28d8415b206c45$export$35b8e6468202c265);
$parcel$export(module.exports, "TextureAssetTask", () => $fd28d8415b206c45$export$51ef945f93bdb2e6);
$parcel$export(module.exports, "CubeTextureAssetTask", () => $fd28d8415b206c45$export$edf21219cff48b39);
$parcel$export(module.exports, "HDRCubeTextureAssetTask", () => $fd28d8415b206c45$export$df743e931d80bec5);
$parcel$export(module.exports, "EquiRectangularCubeTextureAssetTask", () => $fd28d8415b206c45$export$7a4d758e7b128c6e);
$parcel$export(module.exports, "AssetsManager", () => $fd28d8415b206c45$export$c8fa52a23b3b83f4);

var $agoTA = parcelRequire("agoTA");

var $bOhSV = parcelRequire("bOhSV");

var $diGQf = parcelRequire("diGQf");

var $j2mX5 = parcelRequire("j2mX5");

var $iPQLf = parcelRequire("iPQLf");

var $6Y7JP = parcelRequire("6Y7JP");

var $1EKNO = parcelRequire("1EKNO");

var $kVtWi = parcelRequire("kVtWi");

var $ejQPp = parcelRequire("ejQPp");
var $fd28d8415b206c45$export$4fa1129f29e88395;
(function(AssetTaskState) {
    /**
     * Initialization
     */ AssetTaskState[AssetTaskState["INIT"] = 0] = "INIT";
    /**
     * Running
     */ AssetTaskState[AssetTaskState["RUNNING"] = 1] = "RUNNING";
    /**
     * Done
     */ AssetTaskState[AssetTaskState["DONE"] = 2] = "DONE";
    /**
     * Error
     */ AssetTaskState[AssetTaskState["ERROR"] = 3] = "ERROR";
})($fd28d8415b206c45$export$4fa1129f29e88395 || ($fd28d8415b206c45$export$4fa1129f29e88395 = {}));
class $fd28d8415b206c45$export$2653b587090b2358 {
    /**
     * Creates a new AssetsManager
     * @param name defines the name of the task
     */ constructor(/**
     * Task name
     */ name){
        this.name = name;
        this._isCompleted = false;
        this._taskState = $fd28d8415b206c45$export$4fa1129f29e88395.INIT;
    }
    /**
     * Get if the task is completed
     */ get isCompleted() {
        return this._isCompleted;
    }
    /**
     * Gets the current state of the task
     */ get taskState() {
        return this._taskState;
    }
    /**
     * Gets the current error object (if task is in error)
     */ get errorObject() {
        return this._errorObject;
    }
    /**
     * Internal only
     * @internal
     */ _setErrorObject(message, exception) {
        if (this._errorObject) return;
        this._errorObject = {
            message: message,
            exception: exception
        };
    }
    /**
     * Execute the current task
     * @param scene defines the scene where you want your assets to be loaded
     * @param onSuccess is a callback called when the task is successfully executed
     * @param onError is a callback called if an error occurs
     */ run(scene, onSuccess, onError) {
        this._taskState = $fd28d8415b206c45$export$4fa1129f29e88395.RUNNING;
        this.runTask(scene, ()=>{
            this._onDoneCallback(onSuccess, onError);
        }, (msg, exception)=>{
            this._onErrorCallback(onError, msg, exception);
        });
    }
    /**
     * Execute the current task
     * @param scene defines the scene where you want your assets to be loaded
     * @param onSuccess is a callback called when the task is successfully executed
     * @param onError is a callback called if an error occurs
     */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    runTask(scene, onSuccess, onError) {
        throw new Error("runTask is not implemented");
    }
    /**
     * Reset will set the task state back to INIT, so the next load call of the assets manager will execute this task again.
     * This can be used with failed tasks that have the reason for failure fixed.
     */ reset() {
        this._taskState = $fd28d8415b206c45$export$4fa1129f29e88395.INIT;
    }
    _onErrorCallback(onError, message, exception) {
        this._taskState = $fd28d8415b206c45$export$4fa1129f29e88395.ERROR;
        this._errorObject = {
            message: message,
            exception: exception
        };
        if (this.onError) this.onError(this, message, exception);
        onError();
    }
    _onDoneCallback(onSuccess, onError) {
        try {
            this._taskState = $fd28d8415b206c45$export$4fa1129f29e88395.DONE;
            this._isCompleted = true;
            if (this.onSuccess) this.onSuccess(this);
            onSuccess();
        } catch (e) {
            this._onErrorCallback(onError, "Task is done, error executing success callback(s)", e);
        }
    }
}
class $fd28d8415b206c45$export$8f58bcbaf09b8601 {
    /**
     * Creates a AssetsProgressEvent
     * @param remainingCount defines the number of remaining tasks to process
     * @param totalCount defines the total number of tasks
     * @param task defines the task that was just processed
     */ constructor(remainingCount, totalCount, task){
        this.remainingCount = remainingCount;
        this.totalCount = totalCount;
        this.task = task;
    }
}
class $fd28d8415b206c45$export$f3283b11865f28c8 extends $fd28d8415b206c45$export$2653b587090b2358 {
    /**
     * Creates a new ContainerAssetTask
     * @param name defines the name of the task
     * @param meshesNames defines the list of mesh's names you want to load
     * @param rootUrl defines the root url to use as a base to load your meshes and associated resources
     * @param sceneFilename defines the filename or File of the scene to load from
     * @param extension defines the extension to use to load the scene (if not defined, ".babylon" will be used)
     */ constructor(/**
     * Defines the name of the task
     */ name, /**
     * Defines the list of mesh's names you want to load
     */ meshesNames, /**
     * Defines the root url to use as a base to load your meshes and associated resources
     */ rootUrl, /**
     * Defines the filename or File of the scene to load from
     */ sceneFilename, /**
     * Defines the extension to use to load the scene (if not defined, ".babylon" will be used)
     */ extension){
        super(name);
        this.name = name;
        this.meshesNames = meshesNames;
        this.rootUrl = rootUrl;
        this.sceneFilename = sceneFilename;
        this.extension = extension;
    }
    /**
     * Execute the current task
     * @param scene defines the scene where you want your assets to be loaded
     * @param onSuccess is a callback called when the task is successfully executed
     * @param onError is a callback called if an error occurs
     */ runTask(scene, onSuccess, onError) {
        (0, $agoTA.SceneLoader).LoadAssetContainer(this.rootUrl, this.sceneFilename, scene, (container)=>{
            this.loadedContainer = container;
            this.loadedMeshes = container.meshes;
            this.loadedTransformNodes = container.transformNodes;
            this.loadedParticleSystems = container.particleSystems;
            this.loadedSkeletons = container.skeletons;
            this.loadedAnimationGroups = container.animationGroups;
            onSuccess();
        }, null, (scene, message, exception)=>{
            onError(message, exception);
        }, this.extension);
    }
}
class $fd28d8415b206c45$export$83140e8c24fda518 extends $fd28d8415b206c45$export$2653b587090b2358 {
    /**
     * Creates a new MeshAssetTask
     * @param name defines the name of the task
     * @param meshesNames defines the list of mesh's names you want to load
     * @param rootUrl defines the root url to use as a base to load your meshes and associated resources
     * @param sceneFilename defines the filename or File of the scene to load from
     * @param extension defines the extension to use to load the scene (if not defined, ".babylon" will be used)
     */ constructor(/**
     * Defines the name of the task
     */ name, /**
     * Defines the list of mesh's names you want to load
     */ meshesNames, /**
     * Defines the root url to use as a base to load your meshes and associated resources
     */ rootUrl, /**
     * Defines the filename or File of the scene to load from
     */ sceneFilename, /**
     * Defines the extension to use to load the scene (if not defined, ".babylon" will be used)
     */ extension){
        super(name);
        this.name = name;
        this.meshesNames = meshesNames;
        this.rootUrl = rootUrl;
        this.sceneFilename = sceneFilename;
        this.extension = extension;
    }
    /**
     * Execute the current task
     * @param scene defines the scene where you want your assets to be loaded
     * @param onSuccess is a callback called when the task is successfully executed
     * @param onError is a callback called if an error occurs
     */ runTask(scene, onSuccess, onError) {
        (0, $agoTA.SceneLoader).ImportMesh(this.meshesNames, this.rootUrl, this.sceneFilename, scene, (meshes, particleSystems, skeletons, animationGroups, transformNodes)=>{
            this.loadedMeshes = meshes;
            this.loadedTransformNodes = transformNodes;
            this.loadedParticleSystems = particleSystems;
            this.loadedSkeletons = skeletons;
            this.loadedAnimationGroups = animationGroups;
            onSuccess();
        }, null, (scene, message, exception)=>{
            onError(message, exception);
        }, this.extension);
    }
}
class $fd28d8415b206c45$export$194b91f0856c330d extends $fd28d8415b206c45$export$2653b587090b2358 {
    /**
     * Creates a new AnimationAssetTask
     * @param name defines the name of the task
     * @param rootUrl defines the root url to use as a base to load your meshes and associated resources
     * @param filename defines the filename or File of the scene to load from
     * @param targetConverter defines a function used to convert animation targets from loaded scene to current scene (default: search node by name)
     * @param extension defines the extension to use to load the scene (if not defined, ".babylon" will be used)
     */ constructor(/**
     * Defines the name of the task
     */ name, /**
     * Defines the root url to use as a base to load your meshes and associated resources
     */ rootUrl, /**
     * Defines the filename to load from
     */ filename, /**
     * Defines a function used to convert animation targets from loaded scene to current scene (default: search node by name)
     */ targetConverter, /**
     * Defines the extension to use to load the scene (if not defined, ".babylon" will be used)
     */ extension){
        super(name);
        this.name = name;
        this.rootUrl = rootUrl;
        this.filename = filename;
        this.targetConverter = targetConverter;
        this.extension = extension;
    }
    /**
     * Execute the current task
     * @param scene defines the scene where you want your assets to be loaded
     * @param onSuccess is a callback called when the task is successfully executed
     * @param onError is a callback called if an error occurs
     */ runTask(scene, onSuccess, onError) {
        const startingIndexForNewAnimatables = scene.animatables.length;
        const startingIndexForNewAnimationGroups = scene.animationGroups.length;
        this.loadedAnimatables = [];
        this.loadedAnimationGroups = [];
        (0, $agoTA.SceneLoader).ImportAnimations(this.rootUrl, this.filename, scene, false, (0, $agoTA.SceneLoaderAnimationGroupLoadingMode).NoSync, this.targetConverter, ()=>{
            this.loadedAnimatables = scene.animatables.slice(startingIndexForNewAnimatables);
            this.loadedAnimationGroups = scene.animationGroups.slice(startingIndexForNewAnimationGroups);
            onSuccess();
        }, null, (scene, message, exception)=>{
            onError(message, exception);
        }, this.extension);
    }
}
class $fd28d8415b206c45$export$1a169b52494227a0 extends $fd28d8415b206c45$export$2653b587090b2358 {
    /**
     * Creates a new TextFileAssetTask object
     * @param name defines the name of the task
     * @param url defines the location of the file to load
     */ constructor(/**
     * Defines the name of the task
     */ name, /**
     * Defines the location of the file to load
     */ url){
        super(name);
        this.name = name;
        this.url = url;
    }
    /**
     * Execute the current task
     * @param scene defines the scene where you want your assets to be loaded
     * @param onSuccess is a callback called when the task is successfully executed
     * @param onError is a callback called if an error occurs
     */ runTask(scene, onSuccess, onError) {
        scene._loadFile(this.url, (data)=>{
            this.text = data;
            onSuccess();
        }, undefined, false, false, (request, exception)=>{
            if (request) onError(request.status + " " + request.statusText, exception);
        });
    }
}
class $fd28d8415b206c45$export$b3f6a8b0827bd9f8 extends $fd28d8415b206c45$export$2653b587090b2358 {
    /**
     * Creates a new BinaryFileAssetTask object
     * @param name defines the name of the new task
     * @param url defines the location of the file to load
     */ constructor(/**
     * Defines the name of the task
     */ name, /**
     * Defines the location of the file to load
     */ url){
        super(name);
        this.name = name;
        this.url = url;
    }
    /**
     * Execute the current task
     * @param scene defines the scene where you want your assets to be loaded
     * @param onSuccess is a callback called when the task is successfully executed
     * @param onError is a callback called if an error occurs
     */ runTask(scene, onSuccess, onError) {
        scene._loadFile(this.url, (data)=>{
            this.data = data;
            onSuccess();
        }, undefined, true, true, (request, exception)=>{
            if (request) onError(request.status + " " + request.statusText, exception);
        });
    }
}
class $fd28d8415b206c45$export$35b8e6468202c265 extends $fd28d8415b206c45$export$2653b587090b2358 {
    /**
     * Creates a new ImageAssetTask
     * @param name defines the name of the task
     * @param url defines the location of the image to load
     */ constructor(/**
     * Defines the name of the task
     */ name, /**
     * Defines the location of the image to load
     */ url){
        super(name);
        this.name = name;
        this.url = url;
    }
    /**
     * Execute the current task
     * @param scene defines the scene where you want your assets to be loaded
     * @param onSuccess is a callback called when the task is successfully executed
     * @param onError is a callback called if an error occurs
     */ runTask(scene, onSuccess, onError) {
        const img = new Image();
        (0, $bOhSV.Tools).SetCorsBehavior(this.url, img);
        img.onload = ()=>{
            this.image = img;
            onSuccess();
        };
        img.onerror = (err)=>{
            onError("Error loading image", err);
        };
        img.src = this.url;
    }
}
class $fd28d8415b206c45$export$51ef945f93bdb2e6 extends $fd28d8415b206c45$export$2653b587090b2358 {
    /**
     * Creates a new TextureAssetTask object
     * @param name defines the name of the task
     * @param url defines the location of the file to load
     * @param noMipmap defines if mipmap should not be generated (default is false)
     * @param invertY defines if texture must be inverted on Y axis (default is true)
     * @param samplingMode defines the sampling mode to use (default is Texture.TRILINEAR_SAMPLINGMODE)
     */ constructor(/**
     * Defines the name of the task
     */ name, /**
     * Defines the location of the file to load
     */ url, /**
     * Defines if mipmap should not be generated (default is false)
     */ noMipmap, /**
     * Defines if texture must be inverted on Y axis (default is true)
     */ invertY = true, /**
     * Defines the sampling mode to use (default is Texture.TRILINEAR_SAMPLINGMODE)
     */ samplingMode = (0, $j2mX5.Texture).TRILINEAR_SAMPLINGMODE){
        super(name);
        this.name = name;
        this.url = url;
        this.noMipmap = noMipmap;
        this.invertY = invertY;
        this.samplingMode = samplingMode;
    }
    /**
     * Execute the current task
     * @param scene defines the scene where you want your assets to be loaded
     * @param onSuccess is a callback called when the task is successfully executed
     * @param onError is a callback called if an error occurs
     */ runTask(scene, onSuccess, onError) {
        const onload = ()=>{
            onSuccess();
        };
        const onerror = (message, exception)=>{
            onError(message, exception);
        };
        this.texture = new (0, $j2mX5.Texture)(this.url, scene, this.noMipmap, this.invertY, this.samplingMode, onload, onerror);
    }
}
class $fd28d8415b206c45$export$edf21219cff48b39 extends $fd28d8415b206c45$export$2653b587090b2358 {
    /**
     * Creates a new CubeTextureAssetTask
     * @param name defines the name of the task
     * @param url defines the location of the files to load (You have to specify the folder where the files are + filename with no extension)
     * @param extensions defines the extensions to use to load files (["_px", "_py", "_pz", "_nx", "_ny", "_nz"] by default)
     * @param noMipmap defines if mipmaps should not be generated (default is false)
     * @param files defines the explicit list of files (undefined by default)
     * @param prefiltered
     */ constructor(/**
     * Defines the name of the task
     */ name, /**
     * Defines the location of the files to load (You have to specify the folder where the files are + filename with no extension)
     */ url, /**
     * Defines the extensions to use to load files (["_px", "_py", "_pz", "_nx", "_ny", "_nz"] by default)
     */ extensions, /**
     * Defines if mipmaps should not be generated (default is false)
     */ noMipmap, /**
     * Defines the explicit list of files (undefined by default)
     */ files, /**
     * Defines the prefiltered texture option (default is false)
     */ prefiltered){
        super(name);
        this.name = name;
        this.url = url;
        this.extensions = extensions;
        this.noMipmap = noMipmap;
        this.files = files;
        this.prefiltered = prefiltered;
    }
    /**
     * Execute the current task
     * @param scene defines the scene where you want your assets to be loaded
     * @param onSuccess is a callback called when the task is successfully executed
     * @param onError is a callback called if an error occurs
     */ runTask(scene, onSuccess, onError) {
        const onload = ()=>{
            onSuccess();
        };
        const onerror = (message, exception)=>{
            onError(message, exception);
        };
        this.texture = new (0, $iPQLf.CubeTexture)(this.url, scene, this.extensions, this.noMipmap, this.files, onload, onerror, undefined, this.prefiltered);
    }
}
class $fd28d8415b206c45$export$df743e931d80bec5 extends $fd28d8415b206c45$export$2653b587090b2358 {
    /**
     * Creates a new HDRCubeTextureAssetTask object
     * @param name defines the name of the task
     * @param url defines the location of the file to load
     * @param size defines the desired size (the more it increases the longer the generation will be) If the size is omitted this implies you are using a preprocessed cubemap.
     * @param noMipmap defines if mipmaps should not be generated (default is false)
     * @param generateHarmonics specifies whether you want to extract the polynomial harmonics during the generation process (default is true)
     * @param gammaSpace specifies if the texture will be use in gamma or linear space (the PBR material requires those texture in linear space, but the standard material would require them in Gamma space) (default is false)
     * @param reserved Internal use only
     */ constructor(/**
     * Defines the name of the task
     */ name, /**
     * Defines the location of the file to load
     */ url, /**
     * Defines the desired size (the more it increases the longer the generation will be)
     */ size, /**
     * Defines if mipmaps should not be generated (default is false)
     */ noMipmap = false, /**
     * Specifies whether you want to extract the polynomial harmonics during the generation process (default is true)
     */ generateHarmonics = true, /**
     * Specifies if the texture will be use in gamma or linear space (the PBR material requires those texture in linear space, but the standard material would require them in Gamma space) (default is false)
     */ gammaSpace = false, /**
     * Internal Use Only
     */ reserved = false){
        super(name);
        this.name = name;
        this.url = url;
        this.size = size;
        this.noMipmap = noMipmap;
        this.generateHarmonics = generateHarmonics;
        this.gammaSpace = gammaSpace;
        this.reserved = reserved;
    }
    /**
     * Execute the current task
     * @param scene defines the scene where you want your assets to be loaded
     * @param onSuccess is a callback called when the task is successfully executed
     * @param onError is a callback called if an error occurs
     */ runTask(scene, onSuccess, onError) {
        const onload = ()=>{
            onSuccess();
        };
        const onerror = (message, exception)=>{
            onError(message, exception);
        };
        this.texture = new (0, $6Y7JP.HDRCubeTexture)(this.url, scene, this.size, this.noMipmap, this.generateHarmonics, this.gammaSpace, this.reserved, onload, onerror);
    }
}
class $fd28d8415b206c45$export$7a4d758e7b128c6e extends $fd28d8415b206c45$export$2653b587090b2358 {
    /**
     * Creates a new EquiRectangularCubeTextureAssetTask object
     * @param name defines the name of the task
     * @param url defines the location of the file to load
     * @param size defines the desired size (the more it increases the longer the generation will be)
     * If the size is omitted this implies you are using a preprocessed cubemap.
     * @param noMipmap defines if mipmaps should not be generated (default is false)
     * @param gammaSpace specifies if the texture will be used in gamma or linear space
     * (the PBR material requires those texture in linear space, but the standard material would require them in Gamma space)
     * (default is true)
     */ constructor(/**
     * Defines the name of the task
     */ name, /**
     * Defines the location of the file to load
     */ url, /**
     * Defines the desired size (the more it increases the longer the generation will be)
     */ size, /**
     * Defines if mipmaps should not be generated (default is false)
     */ noMipmap = false, /**
     * Specifies if the texture will be use in gamma or linear space (the PBR material requires those texture in linear space,
     * but the standard material would require them in Gamma space) (default is true)
     */ gammaSpace = true){
        super(name);
        this.name = name;
        this.url = url;
        this.size = size;
        this.noMipmap = noMipmap;
        this.gammaSpace = gammaSpace;
    }
    /**
     * Execute the current task
     * @param scene defines the scene where you want your assets to be loaded
     * @param onSuccess is a callback called when the task is successfully executed
     * @param onError is a callback called if an error occurs
     */ runTask(scene, onSuccess, onError) {
        const onload = ()=>{
            onSuccess();
        };
        const onerror = (message, exception)=>{
            onError(message, exception);
        };
        this.texture = new (0, $1EKNO.EquiRectangularCubeTexture)(this.url, scene, this.size, this.noMipmap, this.gammaSpace, onload, onerror);
    }
}
class $fd28d8415b206c45$export$c8fa52a23b3b83f4 {
    /**
     * Creates a new AssetsManager
     * @param scene defines the scene to work on
     */ constructor(scene){
        this._isLoading = false;
        this._tasks = new Array();
        this._waitingTasksCount = 0;
        this._totalTasksCount = 0;
        /**
         * Observable called when all tasks are processed
         */ this.onTaskSuccessObservable = new (0, $diGQf.Observable)();
        /**
         * Observable called when a task had an error
         */ this.onTaskErrorObservable = new (0, $diGQf.Observable)();
        /**
         * Observable called when all tasks were executed
         */ this.onTasksDoneObservable = new (0, $diGQf.Observable)();
        /**
         * Observable called when a task is done (whatever the result is)
         */ this.onProgressObservable = new (0, $diGQf.Observable)();
        /**
         * Gets or sets a boolean defining if the AssetsManager should use the default loading screen
         * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/customLoadingScreen
         */ this.useDefaultLoadingScreen = true;
        /**
         * Gets or sets a boolean defining if the AssetsManager should automatically hide the loading screen
         * when all assets have been downloaded.
         * If set to false, you need to manually call in hideLoadingUI() once your scene is ready.
         */ this.autoHideLoadingUI = true;
        this._scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
    }
    /**
     * Add a ContainerAssetTask to the list of active tasks
     * @param taskName defines the name of the new task
     * @param meshesNames defines the name of meshes to load
     * @param rootUrl defines the root url to use to locate files
     * @param sceneFilename defines the filename of the scene file or the File itself
     * @param extension defines the extension to use to load the file
     * @returns a new ContainerAssetTask object
     */ addContainerTask(taskName, meshesNames, rootUrl, sceneFilename, extension) {
        const task = new $fd28d8415b206c45$export$f3283b11865f28c8(taskName, meshesNames, rootUrl, sceneFilename, extension);
        this._tasks.push(task);
        return task;
    }
    /**
     * Add a MeshAssetTask to the list of active tasks
     * @param taskName defines the name of the new task
     * @param meshesNames defines the name of meshes to load
     * @param rootUrl defines the root url to use to locate files
     * @param sceneFilename defines the filename of the scene file or the File itself
     * @param extension defines the extension to use to load the file
     * @returns a new MeshAssetTask object
     */ addMeshTask(taskName, meshesNames, rootUrl, sceneFilename, extension) {
        const task = new $fd28d8415b206c45$export$83140e8c24fda518(taskName, meshesNames, rootUrl, sceneFilename, extension);
        this._tasks.push(task);
        return task;
    }
    /**
     * Add a TextFileAssetTask to the list of active tasks
     * @param taskName defines the name of the new task
     * @param url defines the url of the file to load
     * @returns a new TextFileAssetTask object
     */ addTextFileTask(taskName, url) {
        const task = new $fd28d8415b206c45$export$1a169b52494227a0(taskName, url);
        this._tasks.push(task);
        return task;
    }
    /**
     * Add a BinaryFileAssetTask to the list of active tasks
     * @param taskName defines the name of the new task
     * @param url defines the url of the file to load
     * @returns a new BinaryFileAssetTask object
     */ addBinaryFileTask(taskName, url) {
        const task = new $fd28d8415b206c45$export$b3f6a8b0827bd9f8(taskName, url);
        this._tasks.push(task);
        return task;
    }
    /**
     * Add a ImageAssetTask to the list of active tasks
     * @param taskName defines the name of the new task
     * @param url defines the url of the file to load
     * @returns a new ImageAssetTask object
     */ addImageTask(taskName, url) {
        const task = new $fd28d8415b206c45$export$35b8e6468202c265(taskName, url);
        this._tasks.push(task);
        return task;
    }
    /**
     * Add a TextureAssetTask to the list of active tasks
     * @param taskName defines the name of the new task
     * @param url defines the url of the file to load
     * @param noMipmap defines if the texture must not receive mipmaps (false by default)
     * @param invertY defines if you want to invert Y axis of the loaded texture (true by default)
     * @param samplingMode defines the sampling mode to use (Texture.TRILINEAR_SAMPLINGMODE by default)
     * @returns a new TextureAssetTask object
     */ addTextureTask(taskName, url, noMipmap, invertY, samplingMode = (0, $j2mX5.Texture).TRILINEAR_SAMPLINGMODE) {
        const task = new $fd28d8415b206c45$export$51ef945f93bdb2e6(taskName, url, noMipmap, invertY, samplingMode);
        this._tasks.push(task);
        return task;
    }
    /**
     * Add a CubeTextureAssetTask to the list of active tasks
     * @param taskName defines the name of the new task
     * @param url defines the url of the file to load
     * @param extensions defines the extension to use to load the cube map (can be null)
     * @param noMipmap defines if the texture must not receive mipmaps (false by default)
     * @param files defines the list of files to load (can be null)
     * @param prefiltered defines the prefiltered texture option (default is false)
     * @returns a new CubeTextureAssetTask object
     */ addCubeTextureTask(taskName, url, extensions, noMipmap, files, prefiltered) {
        const task = new $fd28d8415b206c45$export$edf21219cff48b39(taskName, url, extensions, noMipmap, files, prefiltered);
        this._tasks.push(task);
        return task;
    }
    /**
     *
     * Add a HDRCubeTextureAssetTask to the list of active tasks
     * @param taskName defines the name of the new task
     * @param url defines the url of the file to load
     * @param size defines the size you want for the cubemap (can be null)
     * @param noMipmap defines if the texture must not receive mipmaps (false by default)
     * @param generateHarmonics defines if you want to automatically generate (true by default)
     * @param gammaSpace specifies if the texture will be use in gamma or linear space (the PBR material requires those texture in linear space, but the standard material would require them in Gamma space) (default is false)
     * @param reserved Internal use only
     * @returns a new HDRCubeTextureAssetTask object
     */ addHDRCubeTextureTask(taskName, url, size, noMipmap = false, generateHarmonics = true, gammaSpace = false, reserved = false) {
        const task = new $fd28d8415b206c45$export$df743e931d80bec5(taskName, url, size, noMipmap, generateHarmonics, gammaSpace, reserved);
        this._tasks.push(task);
        return task;
    }
    /**
     *
     * Add a EquiRectangularCubeTextureAssetTask to the list of active tasks
     * @param taskName defines the name of the new task
     * @param url defines the url of the file to load
     * @param size defines the size you want for the cubemap (can be null)
     * @param noMipmap defines if the texture must not receive mipmaps (false by default)
     * @param gammaSpace Specifies if the texture will be used in gamma or linear space
     * (the PBR material requires those textures in linear space, but the standard material would require them in Gamma space)
     * @returns a new EquiRectangularCubeTextureAssetTask object
     */ addEquiRectangularCubeTextureAssetTask(taskName, url, size, noMipmap = false, gammaSpace = true) {
        const task = new $fd28d8415b206c45$export$7a4d758e7b128c6e(taskName, url, size, noMipmap, gammaSpace);
        this._tasks.push(task);
        return task;
    }
    /**
     * Remove a task from the assets manager.
     * @param task the task to remove
     */ removeTask(task) {
        const index = this._tasks.indexOf(task);
        if (index > -1) this._tasks.splice(index, 1);
    }
    _decreaseWaitingTasksCount(task) {
        this._waitingTasksCount--;
        try {
            if (this.onProgress) this.onProgress(this._waitingTasksCount, this._totalTasksCount, task);
            this.onProgressObservable.notifyObservers(new $fd28d8415b206c45$export$8f58bcbaf09b8601(this._waitingTasksCount, this._totalTasksCount, task));
        } catch (e) {
            (0, $kVtWi.Logger).Error("Error running progress callbacks.");
            (0, $kVtWi.Logger).Log(e);
        }
        if (this._waitingTasksCount === 0) {
            try {
                const currentTasks = this._tasks.slice();
                if (this.onFinish) // Calling onFinish with immutable array of tasks
                this.onFinish(currentTasks);
                // Let's remove successful tasks
                for (const task of currentTasks)if (task.taskState === $fd28d8415b206c45$export$4fa1129f29e88395.DONE) {
                    const index = this._tasks.indexOf(task);
                    if (index > -1) this._tasks.splice(index, 1);
                }
                this.onTasksDoneObservable.notifyObservers(this._tasks);
            } catch (e) {
                (0, $kVtWi.Logger).Error("Error running tasks-done callbacks.");
                (0, $kVtWi.Logger).Log(e);
            }
            this._isLoading = false;
            if (this.autoHideLoadingUI) this._scene.getEngine().hideLoadingUI();
        }
    }
    _runTask(task) {
        const done = ()=>{
            try {
                if (this.onTaskSuccess) this.onTaskSuccess(task);
                this.onTaskSuccessObservable.notifyObservers(task);
                this._decreaseWaitingTasksCount(task);
            } catch (e) {
                error("Error executing task success callbacks", e);
            }
        };
        const error = (message, exception)=>{
            task._setErrorObject(message, exception);
            if (this.onTaskError) this.onTaskError(task);
            else if (!task.onError) (0, $kVtWi.Logger).Error(this._formatTaskErrorMessage(task));
            this.onTaskErrorObservable.notifyObservers(task);
            this._decreaseWaitingTasksCount(task);
        };
        task.run(this._scene, done, error);
    }
    _formatTaskErrorMessage(task) {
        let errorMessage = "Unable to complete task " + task.name;
        if (task.errorObject.message) errorMessage += `: ${task.errorObject.message}`;
        if (task.errorObject.exception) errorMessage += `: ${task.errorObject.exception}`;
        return errorMessage;
    }
    /**
     * Reset the AssetsManager and remove all tasks
     * @returns the current instance of the AssetsManager
     */ reset() {
        this._isLoading = false;
        this._tasks = new Array();
        return this;
    }
    /**
     * Start the loading process
     * @returns the current instance of the AssetsManager
     */ load() {
        if (this._isLoading) return this;
        this._isLoading = true;
        this._waitingTasksCount = this._tasks.length;
        this._totalTasksCount = this._tasks.length;
        if (this._waitingTasksCount === 0) {
            this._isLoading = false;
            if (this.onFinish) this.onFinish(this._tasks);
            this.onTasksDoneObservable.notifyObservers(this._tasks);
            return this;
        }
        if (this.useDefaultLoadingScreen) this._scene.getEngine().displayLoadingUI();
        for(let index = 0; index < this._tasks.length; index++){
            const task = this._tasks[index];
            if (task.taskState === $fd28d8415b206c45$export$4fa1129f29e88395.INIT) this._runTask(task);
        }
        return this;
    }
    /**
     * Start the loading process as an async operation
     * @returns a promise returning the list of failed tasks
     */ loadAsync() {
        return new Promise((resolve, reject)=>{
            if (this._isLoading) {
                resolve();
                return;
            }
            this.onTasksDoneObservable.addOnce((remainingTasks)=>{
                if (remainingTasks && remainingTasks.length) reject(remainingTasks);
                else resolve();
            });
            this.load();
        });
    }
}

});

parcelRegister("eGizc", function(module, exports) {

$parcel$export(module.exports, "Deferred", () => $ab0363ea7693b123$export$85f6557964517f1a);
/**
 * Wrapper class for promise with external resolve and reject.
 */ class $ab0363ea7693b123$export$85f6557964517f1a {
    /**
     * The resolve method of the promise associated with this deferred object.
     */ get resolve() {
        return this._resolve;
    }
    /**
     * The reject method of the promise associated with this deferred object.
     */ get reject() {
        return this._reject;
    }
    /**
     * Constructor for this deferred object.
     */ constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this._resolve = resolve;
            this._reject = reject;
        });
    }
}

});

parcelRegister("jRNOx", function(module, exports) {

$parcel$export(module.exports, "MeshExploder", () => $e7699b98c9b91a58$export$441619757e53425a);

var $ha1VO = parcelRequire("ha1VO");
class $e7699b98c9b91a58$export$441619757e53425a {
    /**
     * Explodes meshes from a center mesh.
     * @param meshes The meshes to explode.
     * @param centerMesh The mesh to be center of explosion.
     */ constructor(meshes, centerMesh){
        this._meshesOrigins = [];
        this._toCenterVectors = [];
        this._scaledDirection = new (0, $ha1VO.Vector3)(1, 1, 1);
        this._newPosition = (0, $ha1VO.Vector3).Zero();
        this._centerPosition = (0, $ha1VO.Vector3).Zero();
        this._meshes = meshes.slice();
        if (centerMesh) this._centerMesh = centerMesh;
        else this._setCenterMesh();
        this._centerMesh.computeWorldMatrix(true);
        const centerMeshIndex = this._meshes.indexOf(this._centerMesh);
        if (centerMeshIndex >= 0) this._meshes.splice(centerMeshIndex, 1);
        this._centerPosition = this._centerMesh.getAbsolutePosition().clone();
        for(let index = 0; index < this._meshes.length; index++)if (this._meshes[index]) {
            const mesh = this._meshes[index];
            this._meshesOrigins[index] = mesh.getAbsolutePosition().clone();
            this._toCenterVectors[index] = (0, $ha1VO.Vector3).Zero();
            if (mesh.hasBoundingInfo && this._centerMesh.hasBoundingInfo) {
                mesh.computeWorldMatrix(true);
                mesh.getBoundingInfo().boundingBox.centerWorld.subtractToRef(this._centerMesh.getBoundingInfo().boundingBox.centerWorld, this._toCenterVectors[index]);
            }
        }
    }
    _setCenterMesh() {
        let averageCenter = (0, $ha1VO.Vector3).Zero();
        const totalCenters = (0, $ha1VO.Vector3).Zero();
        let shortestToCenter = Number.MAX_VALUE;
        for(let index = 0; index < this._meshes.length; index++)if (this._meshes[index]) {
            const mesh = this._meshes[index];
            const boundingInfo = mesh.getBoundingInfo();
            if (boundingInfo) totalCenters.addInPlace(boundingInfo.boundingBox.centerWorld);
        }
        averageCenter = totalCenters.scale(1 / this._meshes.length);
        for(let index = 0; index < this._meshes.length; index++)if (this._meshes[index]) {
            const mesh = this._meshes[index];
            const boundingInfo = mesh.getBoundingInfo();
            if (boundingInfo) {
                const distanceToCenter = boundingInfo.boundingBox.centerWorld.subtract(averageCenter).lengthSquared();
                if (distanceToCenter < shortestToCenter) {
                    this._centerMesh = mesh;
                    shortestToCenter = distanceToCenter;
                }
            }
        }
    }
    /**
     * Get class name
     * @returns "MeshExploder"
     */ getClassName() {
        return "MeshExploder";
    }
    /**
     * "Exploded meshes"
     * @returns Array of meshes with the centerMesh at index 0.
     */ getMeshes() {
        const meshArray = this._meshes.slice();
        meshArray.unshift(this._centerMesh);
        return meshArray;
    }
    /**
     * Explodes meshes giving a specific direction
     * @param direction Number to multiply distance of each mesh's origin from center. Use a negative number to implode, or zero to reset.
     */ explode(direction = 1.0) {
        for(let index = 0; index < this._meshes.length; index++)if (this._meshes[index] && this._meshesOrigins[index] && this._toCenterVectors[index]) {
            this._toCenterVectors[index].scaleToRef(direction, this._scaledDirection);
            this._meshesOrigins[index].addToRef(this._scaledDirection, this._newPosition);
            this._meshes[index].setAbsolutePosition(this._newPosition);
        }
        this._centerMesh.setAbsolutePosition(this._centerPosition);
    }
}

});

parcelRegister("54nOI", function(module, exports) {

$parcel$export(module.exports, "FilesInput", () => $3b0fcd05c425c07f$export$6a0ba89e745072eb);

var $agoTA = parcelRequire("agoTA");

var $kVtWi = parcelRequire("kVtWi");

var $8btZm = parcelRequire("8btZm");
class $3b0fcd05c425c07f$export$6a0ba89e745072eb {
    /**
     * List of files ready to be loaded
     */ static get FilesToLoad() {
        return (0, $8btZm.FilesInputStore).FilesToLoad;
    }
    /**
     * Creates a new FilesInput
     * @param engine defines the rendering engine
     * @param scene defines the hosting scene
     * @param sceneLoadedCallback callback called when scene (files provided) is loaded
     * @param progressCallback callback called to track progress
     * @param additionalRenderLoopLogicCallback callback called to add user logic to the rendering loop
     * @param textureLoadingCallback callback called when a texture is loading
     * @param startingProcessingFilesCallback callback called when the system is about to process all files
     * @param onReloadCallback callback called when a reload is requested
     * @param errorCallback callback call if an error occurs
     * @param useAppend defines if the file loaded must be appended (true) or have the scene replaced (false, default behavior)
     */ constructor(engine, scene, sceneLoadedCallback, progressCallback, additionalRenderLoopLogicCallback, textureLoadingCallback, startingProcessingFilesCallback, onReloadCallback, errorCallback, useAppend = false){
        this.useAppend = useAppend;
        /**
         * Callback called when a file is processed
         * @returns false to abort the process
         */ this.onProcessFileCallback = ()=>{
            return true;
        };
        /**
         * If a loading UI should be displayed while loading a file
         */ this.displayLoadingUI = true;
        /**
         * Function used when loading the scene file
         * @param sceneFile defines the file to load
         * @param onProgress onProgress callback called while loading the file
         * @returns a promise completing when the load is complete
         */ this.loadAsync = (sceneFile, onProgress)=>this.useAppend ? (0, $agoTA.SceneLoader).AppendAsync("file:", sceneFile, this._currentScene, onProgress) : (0, $agoTA.SceneLoader).LoadAsync("file:", sceneFile, this._engine, onProgress);
        this._engine = engine;
        this._currentScene = scene;
        this._sceneLoadedCallback = sceneLoadedCallback;
        this._progressCallback = progressCallback;
        this._additionalRenderLoopLogicCallback = additionalRenderLoopLogicCallback;
        this._textureLoadingCallback = textureLoadingCallback;
        this._startingProcessingFilesCallback = startingProcessingFilesCallback;
        this._onReloadCallback = onReloadCallback;
        this._errorCallback = errorCallback;
    }
    /**
     * Calls this function to listen to drag'n'drop events on a specific DOM element
     * @param elementToMonitor defines the DOM element to track
     */ monitorElementForDragNDrop(elementToMonitor) {
        if (elementToMonitor) {
            this._elementToMonitor = elementToMonitor;
            this._dragEnterHandler = (e)=>{
                this._drag(e);
            };
            this._dragOverHandler = (e)=>{
                this._drag(e);
            };
            this._dropHandler = (e)=>{
                this._drop(e);
            };
            this._elementToMonitor.addEventListener("dragenter", this._dragEnterHandler, false);
            this._elementToMonitor.addEventListener("dragover", this._dragOverHandler, false);
            this._elementToMonitor.addEventListener("drop", this._dropHandler, false);
        }
    }
    /** Gets the current list of files to load */ get filesToLoad() {
        return this._filesToLoad;
    }
    /**
     * Release all associated resources
     */ dispose() {
        if (!this._elementToMonitor) return;
        this._elementToMonitor.removeEventListener("dragenter", this._dragEnterHandler);
        this._elementToMonitor.removeEventListener("dragover", this._dragOverHandler);
        this._elementToMonitor.removeEventListener("drop", this._dropHandler);
    }
    _renderFunction() {
        if (this._additionalRenderLoopLogicCallback) this._additionalRenderLoopLogicCallback();
        if (this._currentScene) {
            if (this._textureLoadingCallback) {
                const remaining = this._currentScene.getWaitingItemsCount();
                if (remaining > 0) this._textureLoadingCallback(remaining);
            }
            this._currentScene.render();
        }
    }
    _drag(e) {
        e.stopPropagation();
        e.preventDefault();
    }
    _drop(eventDrop) {
        eventDrop.stopPropagation();
        eventDrop.preventDefault();
        this.loadFiles(eventDrop);
    }
    _traverseFolder(folder, files, remaining, callback) {
        const reader = folder.createReader();
        const relativePath = folder.fullPath.replace(/^\//, "").replace(/(.+?)\/?$/, "$1/");
        reader.readEntries((entries)=>{
            remaining.count += entries.length;
            for (const entry of entries){
                if (entry.isFile) entry.file((file)=>{
                    file.correctName = relativePath + file.name;
                    files.push(file);
                    if (--remaining.count === 0) callback();
                });
                else if (entry.isDirectory) this._traverseFolder(entry, files, remaining, callback);
            }
            if (--remaining.count === 0) callback();
        });
    }
    _processFiles(files) {
        for(let i = 0; i < files.length; i++){
            const name = files[i].correctName.toLowerCase();
            const extension = name.split(".").pop();
            if (!this.onProcessFileCallback(files[i], name, extension, (sceneFile)=>this._sceneFileToLoad = sceneFile)) continue;
            if ((0, $agoTA.SceneLoader).IsPluginForExtensionAvailable("." + extension)) this._sceneFileToLoad = files[i];
            $3b0fcd05c425c07f$export$6a0ba89e745072eb.FilesToLoad[name] = files[i];
        }
    }
    /**
     * Load files from a drop event
     * @param event defines the drop event to use as source
     */ loadFiles(event) {
        // Handling data transfer via drag'n'drop
        if (event && event.dataTransfer && event.dataTransfer.files) this._filesToLoad = event.dataTransfer.files;
        // Handling files from input files
        if (event && event.target && event.target.files) this._filesToLoad = event.target.files;
        if (!this._filesToLoad || this._filesToLoad.length === 0) return;
        if (this._startingProcessingFilesCallback) this._startingProcessingFilesCallback(this._filesToLoad);
        if (this._filesToLoad && this._filesToLoad.length > 0) {
            const files = [];
            const folders = [];
            const items = event.dataTransfer ? event.dataTransfer.items : null;
            for(let i = 0; i < this._filesToLoad.length; i++){
                const fileToLoad = this._filesToLoad[i];
                const name = fileToLoad.name.toLowerCase();
                let entry;
                fileToLoad.correctName = name;
                if (items) {
                    const item = items[i];
                    if (item.getAsEntry) entry = item.getAsEntry();
                    else if (item.webkitGetAsEntry) entry = item.webkitGetAsEntry();
                }
                if (!entry) files.push(fileToLoad);
                else if (entry.isDirectory) folders.push(entry);
                else files.push(fileToLoad);
            }
            if (folders.length === 0) {
                this._processFiles(files);
                this._processReload();
            } else {
                const remaining = {
                    count: folders.length
                };
                for (const folder of folders)this._traverseFolder(folder, files, remaining, ()=>{
                    this._processFiles(files);
                    if (remaining.count === 0) this._processReload();
                });
            }
        }
    }
    _processReload() {
        if (this._onReloadCallback) this._onReloadCallback(this._sceneFileToLoad);
        else this.reload();
    }
    /**
     * Reload the current scene from the loaded files
     */ reload() {
        // If a scene file has been provided
        if (this._sceneFileToLoad) {
            if (!this.useAppend) {
                if (this._currentScene) {
                    if ((0, $kVtWi.Logger).errorsCount > 0) (0, $kVtWi.Logger).ClearLogCache();
                    this._engine.stopRenderLoop();
                }
            }
            (0, $agoTA.SceneLoader).ShowLoadingScreen = false;
            if (this.displayLoadingUI) this._engine.displayLoadingUI();
            this.loadAsync(this._sceneFileToLoad, this._progressCallback).then((scene)=>{
                // if appending do nothing
                if (!this.useAppend) {
                    if (this._currentScene) this._currentScene.dispose();
                    this._currentScene = scene;
                    // Wait for textures and shaders to be ready
                    this._currentScene.executeWhenReady(()=>{
                        if (this.displayLoadingUI) this._engine.hideLoadingUI();
                        this._engine.runRenderLoop(()=>{
                            this._renderFunction();
                        });
                    });
                } else if (this.displayLoadingUI) this._engine.hideLoadingUI();
                if (this._sceneLoadedCallback && this._currentScene) this._sceneLoadedCallback(this._sceneFileToLoad, this._currentScene);
            }).catch((error)=>{
                if (this.displayLoadingUI) this._engine.hideLoadingUI();
                if (this._errorCallback) this._errorCallback(this._sceneFileToLoad, this._currentScene, error.message);
            });
        } else (0, $kVtWi.Logger).Error("Please provide a valid .babylon file.");
    }
}

});

parcelRegister("aKoM6", function(module, exports) {

var $4p0qs = parcelRequire("4p0qs");

var $jSNZm = parcelRequire("jSNZm");

var $h8zBf = parcelRequire("h8zBf");
$parcel$exportWildcard(module.exports, $4p0qs);
$parcel$exportWildcard(module.exports, $jSNZm);
$parcel$exportWildcard(module.exports, $h8zBf);

});

parcelRegister("gDIpr", function(module, exports) {

$parcel$export(module.exports, "MultiObserver", () => $c1d2bca7878fce56$export$4f4f9163fa859455);

var $diGQf = parcelRequire("diGQf");
class $c1d2bca7878fce56$export$4f4f9163fa859455 {
    /**
     * Release associated resources
     */ dispose() {
        if (this._observers && this._observables) for(let index = 0; index < this._observers.length; index++)this._observables[index].remove(this._observers[index]);
        this._observers = null;
        this._observables = null;
    }
    /**
     * Raise a callback when one of the observable will notify
     * @param observables defines a list of observables to watch
     * @param callback defines the callback to call on notification
     * @param mask defines the mask used to filter notifications
     * @param scope defines the current scope used to restore the JS context
     * @returns the new MultiObserver
     */ static Watch(observables, callback, mask = -1, scope = null) {
        const result = new $c1d2bca7878fce56$export$4f4f9163fa859455();
        result._observers = new Array();
        result._observables = observables;
        for (const observable of observables){
            const observer = observable.add(callback, mask, false, scope);
            if (observer) result._observers.push(observer);
        }
        return result;
    }
}
(0, $diGQf.Observable).prototype.notifyObserversWithPromise = async function(eventData, mask = -1, target, currentTarget, userInfo) {
    // create an empty promise
    let p = Promise.resolve(eventData);
    // no observers? return this promise.
    if (!this.observers.length) return p;
    const state = this._eventState;
    state.mask = mask;
    state.target = target;
    state.currentTarget = currentTarget;
    state.skipNextObservers = false;
    state.userInfo = userInfo;
    // execute one callback after another (not using Promise.all, the order is important)
    this.observers.forEach((obs)=>{
        if (state.skipNextObservers) return;
        if (obs._willBeUnregistered) return;
        if (obs.mask & mask) {
            if (obs.scope) p = p.then((lastReturnedValue)=>{
                state.lastReturnValue = lastReturnedValue;
                return obs.callback.apply(obs.scope, [
                    eventData,
                    state
                ]);
            });
            else p = p.then((lastReturnedValue)=>{
                state.lastReturnValue = lastReturnedValue;
                return obs.callback(eventData, state);
            });
            if (obs.unregisterOnNextCall) this._deferUnregister(obs);
        }
    });
    // return the eventData
    await p;
    return eventData;
};

});

parcelRegister("lRrz0", function(module, exports) {

$parcel$export(module.exports, "SceneOptimization", () => $fea3edc4cb18dba6$export$f35c4ade25c24126);
$parcel$export(module.exports, "TextureOptimization", () => $fea3edc4cb18dba6$export$53279043686312b);
$parcel$export(module.exports, "HardwareScalingOptimization", () => $fea3edc4cb18dba6$export$df80e52e2d5f3e48);
$parcel$export(module.exports, "ShadowsOptimization", () => $fea3edc4cb18dba6$export$f46f3c49ab6b53ed);
$parcel$export(module.exports, "PostProcessesOptimization", () => $fea3edc4cb18dba6$export$e67bd1de42c1d4ee);
$parcel$export(module.exports, "LensFlaresOptimization", () => $fea3edc4cb18dba6$export$2362229078250d41);
$parcel$export(module.exports, "CustomOptimization", () => $fea3edc4cb18dba6$export$7e5ade548a6ed1c5);
$parcel$export(module.exports, "ParticlesOptimization", () => $fea3edc4cb18dba6$export$49c192a6a3e8d27a);
$parcel$export(module.exports, "RenderTargetsOptimization", () => $fea3edc4cb18dba6$export$f94f382687d4eb19);
$parcel$export(module.exports, "MergeMeshesOptimization", () => $fea3edc4cb18dba6$export$858bd893c09f4569);
$parcel$export(module.exports, "SceneOptimizerOptions", () => $fea3edc4cb18dba6$export$a48c67869b2ff516);
$parcel$export(module.exports, "SceneOptimizer", () => $fea3edc4cb18dba6$export$69e910f1211890c1);

var $ejQPp = parcelRequire("ejQPp");

var $fbuqw = parcelRequire("fbuqw");

var $diGQf = parcelRequire("diGQf");
class $fea3edc4cb18dba6$export$f35c4ade25c24126 {
    /**
     * Gets a string describing the action executed by the current optimization
     * @returns description string
     */ getDescription() {
        return "";
    }
    /**
     * This function will be called by the SceneOptimizer when its priority is reached in order to apply the change required by the current optimization
     * @param scene defines the current scene where to apply this optimization
     * @param optimizer defines the current optimizer
     * @returns true if everything that can be done was applied
     */ apply(scene, optimizer) {
        return true;
    }
    /**
     * Creates the SceneOptimization object
     * @param priority defines the priority of this optimization (0 by default which means first in the list)
     */ constructor(/**
     * Defines the priority of this optimization (0 by default which means first in the list)
     */ priority = 0){
        this.priority = priority;
    }
}
class $fea3edc4cb18dba6$export$53279043686312b extends $fea3edc4cb18dba6$export$f35c4ade25c24126 {
    /**
     * Gets a string describing the action executed by the current optimization
     * @returns description string
     */ getDescription() {
        return "Reducing render target texture size to " + this.maximumSize;
    }
    /**
     * Creates the TextureOptimization object
     * @param priority defines the priority of this optimization (0 by default which means first in the list)
     * @param maximumSize defines the maximum sized allowed for textures (1024 is the default value). If a texture is bigger, it will be scaled down using a factor defined by the step parameter
     * @param step defines the factor (0.5 by default) used to scale down textures bigger than maximum sized allowed.
     */ constructor(/**
     * Defines the priority of this optimization (0 by default which means first in the list)
     */ priority = 0, /**
     * Defines the maximum sized allowed for textures (1024 is the default value). If a texture is bigger, it will be scaled down using a factor defined by the step parameter
     */ maximumSize = 1024, /**
     * Defines the factor (0.5 by default) used to scale down textures bigger than maximum sized allowed.
     */ step = 0.5){
        super(priority);
        this.priority = priority;
        this.maximumSize = maximumSize;
        this.step = step;
    }
    /**
     * This function will be called by the SceneOptimizer when its priority is reached in order to apply the change required by the current optimization
     * @param scene defines the current scene where to apply this optimization
     * @param optimizer defines the current optimizer
     * @returns true if everything that can be done was applied
     */ apply(scene, optimizer) {
        let allDone = true;
        for(let index = 0; index < scene.textures.length; index++){
            const texture = scene.textures[index];
            if (!texture.canRescale || texture.getContext) continue;
            const currentSize = texture.getSize();
            const maxDimension = Math.max(currentSize.width, currentSize.height);
            if (maxDimension > this.maximumSize) {
                texture.scale(this.step);
                allDone = false;
            }
        }
        return allDone;
    }
}
class $fea3edc4cb18dba6$export$df80e52e2d5f3e48 extends $fea3edc4cb18dba6$export$f35c4ade25c24126 {
    /**
     * Gets a string describing the action executed by the current optimization
     * @returns description string
     */ getDescription() {
        return "Setting hardware scaling level to " + this._currentScale;
    }
    /**
     * Creates the HardwareScalingOptimization object
     * @param priority defines the priority of this optimization (0 by default which means first in the list)
     * @param maximumScale defines the maximum scale to use (2 by default)
     * @param step defines the step to use between two passes (0.5 by default)
     */ constructor(/**
     * Defines the priority of this optimization (0 by default which means first in the list)
     */ priority = 0, /**
     * Defines the maximum scale to use (2 by default)
     */ maximumScale = 2, /**
     * Defines the step to use between two passes (0.5 by default)
     */ step = 0.25){
        super(priority);
        this.priority = priority;
        this.maximumScale = maximumScale;
        this.step = step;
        this._currentScale = -1;
        this._directionOffset = 1;
    }
    /**
     * This function will be called by the SceneOptimizer when its priority is reached in order to apply the change required by the current optimization
     * @param scene defines the current scene where to apply this optimization
     * @param optimizer defines the current optimizer
     * @returns true if everything that can be done was applied
     */ apply(scene, optimizer) {
        if (this._currentScale === -1) {
            this._currentScale = scene.getEngine().getHardwareScalingLevel();
            if (this._currentScale > this.maximumScale) this._directionOffset = -1;
        }
        this._currentScale += this._directionOffset * this.step;
        scene.getEngine().setHardwareScalingLevel(this._currentScale);
        return this._directionOffset === 1 ? this._currentScale >= this.maximumScale : this._currentScale <= this.maximumScale;
    }
}
class $fea3edc4cb18dba6$export$f46f3c49ab6b53ed extends $fea3edc4cb18dba6$export$f35c4ade25c24126 {
    /**
     * Gets a string describing the action executed by the current optimization
     * @returns description string
     */ getDescription() {
        return "Turning shadows on/off";
    }
    /**
     * This function will be called by the SceneOptimizer when its priority is reached in order to apply the change required by the current optimization
     * @param scene defines the current scene where to apply this optimization
     * @param optimizer defines the current optimizer
     * @returns true if everything that can be done was applied
     */ apply(scene, optimizer) {
        scene.shadowsEnabled = optimizer.isInImprovementMode;
        return true;
    }
}
class $fea3edc4cb18dba6$export$e67bd1de42c1d4ee extends $fea3edc4cb18dba6$export$f35c4ade25c24126 {
    /**
     * Gets a string describing the action executed by the current optimization
     * @returns description string
     */ getDescription() {
        return "Turning post-processes on/off";
    }
    /**
     * This function will be called by the SceneOptimizer when its priority is reached in order to apply the change required by the current optimization
     * @param scene defines the current scene where to apply this optimization
     * @param optimizer defines the current optimizer
     * @returns true if everything that can be done was applied
     */ apply(scene, optimizer) {
        scene.postProcessesEnabled = optimizer.isInImprovementMode;
        return true;
    }
}
class $fea3edc4cb18dba6$export$2362229078250d41 extends $fea3edc4cb18dba6$export$f35c4ade25c24126 {
    /**
     * Gets a string describing the action executed by the current optimization
     * @returns description string
     */ getDescription() {
        return "Turning lens flares on/off";
    }
    /**
     * This function will be called by the SceneOptimizer when its priority is reached in order to apply the change required by the current optimization
     * @param scene defines the current scene where to apply this optimization
     * @param optimizer defines the current optimizer
     * @returns true if everything that can be done was applied
     */ apply(scene, optimizer) {
        scene.lensFlaresEnabled = optimizer.isInImprovementMode;
        return true;
    }
}
class $fea3edc4cb18dba6$export$7e5ade548a6ed1c5 extends $fea3edc4cb18dba6$export$f35c4ade25c24126 {
    /**
     * Gets a string describing the action executed by the current optimization
     * @returns description string
     */ getDescription() {
        if (this.onGetDescription) return this.onGetDescription();
        return "Running user defined callback";
    }
    /**
     * This function will be called by the SceneOptimizer when its priority is reached in order to apply the change required by the current optimization
     * @param scene defines the current scene where to apply this optimization
     * @param optimizer defines the current optimizer
     * @returns true if everything that can be done was applied
     */ apply(scene, optimizer) {
        if (this.onApply) return this.onApply(scene, optimizer);
        return true;
    }
}
class $fea3edc4cb18dba6$export$49c192a6a3e8d27a extends $fea3edc4cb18dba6$export$f35c4ade25c24126 {
    /**
     * Gets a string describing the action executed by the current optimization
     * @returns description string
     */ getDescription() {
        return "Turning particles on/off";
    }
    /**
     * This function will be called by the SceneOptimizer when its priority is reached in order to apply the change required by the current optimization
     * @param scene defines the current scene where to apply this optimization
     * @param optimizer defines the current optimizer
     * @returns true if everything that can be done was applied
     */ apply(scene, optimizer) {
        scene.particlesEnabled = optimizer.isInImprovementMode;
        return true;
    }
}
class $fea3edc4cb18dba6$export$f94f382687d4eb19 extends $fea3edc4cb18dba6$export$f35c4ade25c24126 {
    /**
     * Gets a string describing the action executed by the current optimization
     * @returns description string
     */ getDescription() {
        return "Turning render targets off";
    }
    /**
     * This function will be called by the SceneOptimizer when its priority is reached in order to apply the change required by the current optimization
     * @param scene defines the current scene where to apply this optimization
     * @param optimizer defines the current optimizer
     * @returns true if everything that can be done was applied
     */ apply(scene, optimizer) {
        scene.renderTargetsEnabled = optimizer.isInImprovementMode;
        return true;
    }
}
class $fea3edc4cb18dba6$export$858bd893c09f4569 extends $fea3edc4cb18dba6$export$f35c4ade25c24126 {
    constructor(){
        super(...arguments);
        this._canBeMerged = (abstractMesh)=>{
            if (!(abstractMesh instanceof (0, $fbuqw.Mesh))) return false;
            const mesh = abstractMesh;
            if (mesh.isDisposed()) return false;
            if (!mesh.isVisible || !mesh.isEnabled()) return false;
            if (mesh.instances.length > 0) return false;
            if (mesh.skeleton || mesh.hasLODLevels) return false;
            if (mesh.getTotalVertices() === 0) return false;
            return true;
        };
    }
    /**
     * Gets or sets a boolean which defines if optimization octree has to be updated
     */ static get UpdateSelectionTree() {
        return $fea3edc4cb18dba6$export$858bd893c09f4569._UpdateSelectionTree;
    }
    /**
     * Gets or sets a boolean which defines if optimization octree has to be updated
     */ static set UpdateSelectionTree(value) {
        $fea3edc4cb18dba6$export$858bd893c09f4569._UpdateSelectionTree = value;
    }
    /**
     * Gets a string describing the action executed by the current optimization
     * @returns description string
     */ getDescription() {
        return "Merging similar meshes together";
    }
    /**
     * This function will be called by the SceneOptimizer when its priority is reached in order to apply the change required by the current optimization
     * @param scene defines the current scene where to apply this optimization
     * @param optimizer defines the current optimizer
     * @param updateSelectionTree defines that the selection octree has to be updated (false by default)
     * @returns true if everything that can be done was applied
     */ apply(scene, optimizer, updateSelectionTree) {
        const globalPool = scene.meshes.slice(0);
        let globalLength = globalPool.length;
        for(let index = 0; index < globalLength; index++){
            const currentPool = [];
            const current = globalPool[index];
            // Checks
            if (!this._canBeMerged(current)) continue;
            currentPool.push(current);
            // Find compatible meshes
            for(let subIndex = index + 1; subIndex < globalLength; subIndex++){
                const otherMesh = globalPool[subIndex];
                if (!this._canBeMerged(otherMesh)) continue;
                if (otherMesh.material !== current.material) continue;
                if (otherMesh.checkCollisions !== current.checkCollisions) continue;
                currentPool.push(otherMesh);
                globalLength--;
                globalPool.splice(subIndex, 1);
                subIndex--;
            }
            if (currentPool.length < 2) continue;
            // Merge meshes
            (0, $fbuqw.Mesh).MergeMeshes(currentPool, undefined, true);
        }
        // Call the octree system optimization if it is defined.
        const sceneAsAny = scene;
        if (sceneAsAny.createOrUpdateSelectionOctree) {
            if (updateSelectionTree != undefined) {
                if (updateSelectionTree) sceneAsAny.createOrUpdateSelectionOctree();
            } else if ($fea3edc4cb18dba6$export$858bd893c09f4569.UpdateSelectionTree) sceneAsAny.createOrUpdateSelectionOctree();
        }
        return true;
    }
}
$fea3edc4cb18dba6$export$858bd893c09f4569._UpdateSelectionTree = false;
class $fea3edc4cb18dba6$export$a48c67869b2ff516 {
    /**
     * Creates a new list of options used by SceneOptimizer
     * @param targetFrameRate defines the target frame rate to reach (60 by default)
     * @param trackerDuration defines the interval between two checks (2000ms by default)
     */ constructor(/**
     * Defines the target frame rate to reach (60 by default)
     */ targetFrameRate = 60, /**
     * Defines the interval between two checks (2000ms by default)
     */ trackerDuration = 2000){
        this.targetFrameRate = targetFrameRate;
        this.trackerDuration = trackerDuration;
        /**
         * Gets the list of optimizations to apply
         */ this.optimizations = [];
    }
    /**
     * Add a new optimization
     * @param optimization defines the SceneOptimization to add to the list of active optimizations
     * @returns the current SceneOptimizerOptions
     */ addOptimization(optimization) {
        this.optimizations.push(optimization);
        return this;
    }
    /**
     * Add a new custom optimization
     * @param onApply defines the callback called to apply the custom optimization (true if everything that can be done was applied)
     * @param onGetDescription defines the callback called to get the description attached with the optimization.
     * @param priority defines the priority of this optimization (0 by default which means first in the list)
     * @returns the current SceneOptimizerOptions
     */ addCustomOptimization(onApply, onGetDescription, priority = 0) {
        const optimization = new $fea3edc4cb18dba6$export$7e5ade548a6ed1c5(priority);
        optimization.onApply = onApply;
        optimization.onGetDescription = onGetDescription;
        this.optimizations.push(optimization);
        return this;
    }
    /**
     * Creates a list of pre-defined optimizations aimed to reduce the visual impact on the scene
     * @param targetFrameRate defines the target frame rate (60 by default)
     * @returns a SceneOptimizerOptions object
     */ static LowDegradationAllowed(targetFrameRate) {
        const result = new $fea3edc4cb18dba6$export$a48c67869b2ff516(targetFrameRate);
        let priority = 0;
        result.addOptimization(new $fea3edc4cb18dba6$export$858bd893c09f4569(priority));
        result.addOptimization(new $fea3edc4cb18dba6$export$f46f3c49ab6b53ed(priority));
        result.addOptimization(new $fea3edc4cb18dba6$export$2362229078250d41(priority));
        // Next priority
        priority++;
        result.addOptimization(new $fea3edc4cb18dba6$export$e67bd1de42c1d4ee(priority));
        result.addOptimization(new $fea3edc4cb18dba6$export$49c192a6a3e8d27a(priority));
        // Next priority
        priority++;
        result.addOptimization(new $fea3edc4cb18dba6$export$53279043686312b(priority, 1024));
        return result;
    }
    /**
     * Creates a list of pre-defined optimizations aimed to have a moderate impact on the scene visual
     * @param targetFrameRate defines the target frame rate (60 by default)
     * @returns a SceneOptimizerOptions object
     */ static ModerateDegradationAllowed(targetFrameRate) {
        const result = new $fea3edc4cb18dba6$export$a48c67869b2ff516(targetFrameRate);
        let priority = 0;
        result.addOptimization(new $fea3edc4cb18dba6$export$858bd893c09f4569(priority));
        result.addOptimization(new $fea3edc4cb18dba6$export$f46f3c49ab6b53ed(priority));
        result.addOptimization(new $fea3edc4cb18dba6$export$2362229078250d41(priority));
        // Next priority
        priority++;
        result.addOptimization(new $fea3edc4cb18dba6$export$e67bd1de42c1d4ee(priority));
        result.addOptimization(new $fea3edc4cb18dba6$export$49c192a6a3e8d27a(priority));
        // Next priority
        priority++;
        result.addOptimization(new $fea3edc4cb18dba6$export$53279043686312b(priority, 512));
        // Next priority
        priority++;
        result.addOptimization(new $fea3edc4cb18dba6$export$f94f382687d4eb19(priority));
        // Next priority
        priority++;
        result.addOptimization(new $fea3edc4cb18dba6$export$df80e52e2d5f3e48(priority, 2));
        return result;
    }
    /**
     * Creates a list of pre-defined optimizations aimed to have a big impact on the scene visual
     * @param targetFrameRate defines the target frame rate (60 by default)
     * @returns a SceneOptimizerOptions object
     */ static HighDegradationAllowed(targetFrameRate) {
        const result = new $fea3edc4cb18dba6$export$a48c67869b2ff516(targetFrameRate);
        let priority = 0;
        result.addOptimization(new $fea3edc4cb18dba6$export$858bd893c09f4569(priority));
        result.addOptimization(new $fea3edc4cb18dba6$export$f46f3c49ab6b53ed(priority));
        result.addOptimization(new $fea3edc4cb18dba6$export$2362229078250d41(priority));
        // Next priority
        priority++;
        result.addOptimization(new $fea3edc4cb18dba6$export$e67bd1de42c1d4ee(priority));
        result.addOptimization(new $fea3edc4cb18dba6$export$49c192a6a3e8d27a(priority));
        // Next priority
        priority++;
        result.addOptimization(new $fea3edc4cb18dba6$export$53279043686312b(priority, 256));
        // Next priority
        priority++;
        result.addOptimization(new $fea3edc4cb18dba6$export$f94f382687d4eb19(priority));
        // Next priority
        priority++;
        result.addOptimization(new $fea3edc4cb18dba6$export$df80e52e2d5f3e48(priority, 4));
        return result;
    }
}
class $fea3edc4cb18dba6$export$69e910f1211890c1 {
    /**
     * Gets or sets a boolean indicating if the optimizer is in improvement mode
     */ get isInImprovementMode() {
        return this._improvementMode;
    }
    set isInImprovementMode(value) {
        this._improvementMode = value;
    }
    /**
     * Gets the current priority level (0 at start)
     */ get currentPriorityLevel() {
        return this._currentPriorityLevel;
    }
    /**
     * Gets the current frame rate checked by the SceneOptimizer
     */ get currentFrameRate() {
        return this._currentFrameRate;
    }
    /**
     * Gets or sets the current target frame rate (60 by default)
     */ get targetFrameRate() {
        return this._targetFrameRate;
    }
    /**
     * Gets or sets the current target frame rate (60 by default)
     */ set targetFrameRate(value) {
        this._targetFrameRate = value;
    }
    /**
     * Gets or sets the current interval between two checks (every 2000ms by default)
     */ get trackerDuration() {
        return this._trackerDuration;
    }
    /**
     * Gets or sets the current interval between two checks (every 2000ms by default)
     */ set trackerDuration(value) {
        this._trackerDuration = value;
    }
    /**
     * Gets the list of active optimizations
     */ get optimizations() {
        return this._options.optimizations;
    }
    /**
     * Creates a new SceneOptimizer
     * @param scene defines the scene to work on
     * @param options defines the options to use with the SceneOptimizer
     * @param autoGeneratePriorities defines if priorities must be generated and not read from SceneOptimization property (true by default)
     * @param improvementMode defines if the scene optimizer must run the maximum optimization while staying over a target frame instead of trying to reach the target framerate (false by default)
     */ constructor(scene, options, autoGeneratePriorities = true, improvementMode = false){
        this._isRunning = false;
        this._currentPriorityLevel = 0;
        this._targetFrameRate = 60;
        this._trackerDuration = 2000;
        this._currentFrameRate = 0;
        this._improvementMode = false;
        /**
         * Defines an observable called when the optimizer reaches the target frame rate
         */ this.onSuccessObservable = new (0, $diGQf.Observable)();
        /**
         * Defines an observable called when the optimizer enables an optimization
         */ this.onNewOptimizationAppliedObservable = new (0, $diGQf.Observable)();
        /**
         * Defines an observable called when the optimizer is not able to reach the target frame rate
         */ this.onFailureObservable = new (0, $diGQf.Observable)();
        if (!options) this._options = new $fea3edc4cb18dba6$export$a48c67869b2ff516();
        else this._options = options;
        if (this._options.targetFrameRate) this._targetFrameRate = this._options.targetFrameRate;
        if (this._options.trackerDuration) this._trackerDuration = this._options.trackerDuration;
        if (autoGeneratePriorities) {
            let priority = 0;
            for (const optim of this._options.optimizations)optim.priority = priority++;
        }
        this._improvementMode = improvementMode;
        this._scene = scene || (0, $ejQPp.EngineStore).LastCreatedScene;
        this._sceneDisposeObserver = this._scene.onDisposeObservable.add(()=>{
            this._sceneDisposeObserver = null;
            this.dispose();
        });
    }
    /**
     * Stops the current optimizer
     */ stop() {
        this._isRunning = false;
    }
    /**
     * Reset the optimizer to initial step (current priority level = 0)
     */ reset() {
        this._currentPriorityLevel = 0;
    }
    /**
     * Start the optimizer. By default it will try to reach a specific framerate
     * but if the optimizer is set with improvementMode === true then it will run all optimization while frame rate is above the target frame rate
     */ start() {
        if (this._isRunning) return;
        this._isRunning = true;
        // Let's wait for the scene to be ready before running our check
        this._scene.executeWhenReady(()=>{
            setTimeout(()=>{
                this._checkCurrentState();
            }, this._trackerDuration);
        });
    }
    _checkCurrentState() {
        if (!this._isRunning) return;
        const scene = this._scene;
        const options = this._options;
        this._currentFrameRate = Math.round(scene.getEngine().getFps());
        if (this._improvementMode && this._currentFrameRate <= this._targetFrameRate || !this._improvementMode && this._currentFrameRate >= this._targetFrameRate) {
            this._isRunning = false;
            this.onSuccessObservable.notifyObservers(this);
            return;
        }
        // Apply current level of optimizations
        let allDone = true;
        let noOptimizationApplied = true;
        for(let index = 0; index < options.optimizations.length; index++){
            const optimization = options.optimizations[index];
            if (optimization.priority === this._currentPriorityLevel) {
                noOptimizationApplied = false;
                allDone = allDone && optimization.apply(scene, this);
                this.onNewOptimizationAppliedObservable.notifyObservers(optimization);
            }
        }
        // If no optimization was applied, this is a failure :(
        if (noOptimizationApplied) {
            this._isRunning = false;
            this.onFailureObservable.notifyObservers(this);
            return;
        }
        // If all optimizations were done, move to next level
        if (allDone) this._currentPriorityLevel++;
        // Let's the system running for a specific amount of time before checking FPS
        scene.executeWhenReady(()=>{
            setTimeout(()=>{
                this._checkCurrentState();
            }, this._trackerDuration);
        });
    }
    /**
     * Release all resources
     */ dispose() {
        this.stop();
        this.onSuccessObservable.clear();
        this.onFailureObservable.clear();
        this.onNewOptimizationAppliedObservable.clear();
        if (this._sceneDisposeObserver) this._scene.onDisposeObservable.remove(this._sceneDisposeObserver);
    }
    /**
     * Helper function to create a SceneOptimizer with one single line of code
     * @param scene defines the scene to work on
     * @param options defines the options to use with the SceneOptimizer
     * @param onSuccess defines a callback to call on success
     * @param onFailure defines a callback to call on failure
     * @returns the new SceneOptimizer object
     */ static OptimizeAsync(scene, options, onSuccess, onFailure) {
        const optimizer = new $fea3edc4cb18dba6$export$69e910f1211890c1(scene, options || $fea3edc4cb18dba6$export$a48c67869b2ff516.ModerateDegradationAllowed(), false);
        if (onSuccess) optimizer.onSuccessObservable.add(()=>{
            onSuccess();
        });
        if (onFailure) optimizer.onFailureObservable.add(()=>{
            onFailure();
        });
        optimizer.start();
        return optimizer;
    }
}

});

parcelRegister("2sJhC", function(module, exports) {

$parcel$export(module.exports, "SceneSerializer", () => $1cb15291050d5ca4$export$25b4f9c42fc9a49c);

var $fbuqw = parcelRequire("fbuqw");

var $3zFLd = parcelRequire("3zFLd");

var $6Ho1L = parcelRequire("6Ho1L");

var $j2mX5 = parcelRequire("j2mX5");

var $kVtWi = parcelRequire("kVtWi");
let $1cb15291050d5ca4$var$serializedGeometries = [];
const $1cb15291050d5ca4$var$SerializeGeometry = (geometry, serializationGeometries)=>{
    if (geometry.doNotSerialize) return;
    serializationGeometries.vertexData.push(geometry.serializeVerticeData());
    $1cb15291050d5ca4$var$serializedGeometries[geometry.id] = true;
};
const $1cb15291050d5ca4$var$SerializeMesh = (mesh, serializationScene)=>{
    const serializationObject = {};
    // Geometry
    const geometry = mesh._geometry;
    if (geometry) {
        if (!mesh.getScene().getGeometryById(geometry.id)) // Geometry was in the memory but not added to the scene, nevertheless it's better to serialize to be able to reload the mesh with its geometry
        $1cb15291050d5ca4$var$SerializeGeometry(geometry, serializationScene.geometries);
    }
    // Custom
    if (mesh.serialize) mesh.serialize(serializationObject);
    return serializationObject;
};
const $1cb15291050d5ca4$var$FinalizeSingleNode = (node, serializationObject)=>{
    if (node._isMesh) {
        const mesh = node;
        //only works if the mesh is already loaded
        if (mesh.delayLoadState === 1 || mesh.delayLoadState === 0) {
            const serializeMaterial = (material)=>{
                serializationObject.materials = serializationObject.materials || [];
                if (mesh.material && !serializationObject.materials.some((mat)=>mat.id === mesh.material.id)) serializationObject.materials.push(material.serialize());
            };
            //serialize material
            if (mesh.material && !mesh.material.doNotSerialize) {
                if (mesh.material instanceof (0, $3zFLd.MultiMaterial)) {
                    serializationObject.multiMaterials = serializationObject.multiMaterials || [];
                    if (!serializationObject.multiMaterials.some((mat)=>mat.id === mesh.material.id)) {
                        serializationObject.multiMaterials.push(mesh.material.serialize());
                        for (const submaterial of mesh.material.subMaterials)if (submaterial) serializeMaterial(submaterial);
                    }
                } else serializeMaterial(mesh.material);
            } else if (!mesh.material) serializeMaterial(mesh.getScene().defaultMaterial);
            //serialize geometry
            const geometry = mesh._geometry;
            if (geometry) {
                if (!serializationObject.geometries) {
                    serializationObject.geometries = {};
                    serializationObject.geometries.boxes = [];
                    serializationObject.geometries.spheres = [];
                    serializationObject.geometries.cylinders = [];
                    serializationObject.geometries.toruses = [];
                    serializationObject.geometries.grounds = [];
                    serializationObject.geometries.planes = [];
                    serializationObject.geometries.torusKnots = [];
                    serializationObject.geometries.vertexData = [];
                }
                $1cb15291050d5ca4$var$SerializeGeometry(geometry, serializationObject.geometries);
            }
            // Skeletons
            if (mesh.skeleton && !mesh.skeleton.doNotSerialize) {
                serializationObject.skeletons = serializationObject.skeletons || [];
                serializationObject.skeletons.push(mesh.skeleton.serialize());
            }
            //serialize the actual mesh
            serializationObject.meshes = serializationObject.meshes || [];
            serializationObject.meshes.push($1cb15291050d5ca4$var$SerializeMesh(mesh, serializationObject));
        }
    } else if (node.getClassName() === "TransformNode") {
        const transformNode = node;
        serializationObject.transformNodes.push(transformNode.serialize());
    } else if (node.getClassName().indexOf("Camera") !== -1) {
        const camera = node;
        serializationObject.cameras.push(camera.serialize());
    } else if (node.getClassName().indexOf("Light") !== -1) {
        const light = node;
        serializationObject.lights.push(light.serialize());
    }
};
class $1cb15291050d5ca4$export$25b4f9c42fc9a49c {
    /**
     * Clear cache used by a previous serialization
     */ static ClearCache() {
        $1cb15291050d5ca4$var$serializedGeometries = [];
    }
    /**
     * Serialize a scene into a JSON compatible object
     * Note that if the current engine does not support synchronous texture reading (like WebGPU), you should use SerializeAsync instead
     * as else you may not retrieve the proper base64 encoded texture data (when using the Texture.ForceSerializeBuffers flag)
     * @param scene defines the scene to serialize
     * @returns a JSON compatible object
     */ static Serialize(scene) {
        return $1cb15291050d5ca4$export$25b4f9c42fc9a49c._Serialize(scene);
    }
    static _Serialize(scene, checkSyncReadSupported = true) {
        const serializationObject = {};
        if (checkSyncReadSupported && !scene.getEngine()._features.supportSyncTextureRead && (0, $j2mX5.Texture).ForceSerializeBuffers) (0, $kVtWi.Logger).Warn("The serialization object may not contain the proper base64 encoded texture data! You should use the SerializeAsync method instead.");
        $1cb15291050d5ca4$export$25b4f9c42fc9a49c.ClearCache();
        // Scene
        serializationObject.useDelayedTextureLoading = scene.useDelayedTextureLoading;
        serializationObject.autoClear = scene.autoClear;
        serializationObject.clearColor = scene.clearColor.asArray();
        serializationObject.ambientColor = scene.ambientColor.asArray();
        serializationObject.gravity = scene.gravity.asArray();
        serializationObject.collisionsEnabled = scene.collisionsEnabled;
        serializationObject.useRightHandedSystem = scene.useRightHandedSystem;
        // Fog
        if (scene.fogMode && scene.fogMode !== 0) {
            serializationObject.fogMode = scene.fogMode;
            serializationObject.fogColor = scene.fogColor.asArray();
            serializationObject.fogStart = scene.fogStart;
            serializationObject.fogEnd = scene.fogEnd;
            serializationObject.fogDensity = scene.fogDensity;
        }
        //Physics
        if (scene.isPhysicsEnabled && scene.isPhysicsEnabled()) {
            const physicEngine = scene.getPhysicsEngine();
            if (physicEngine) {
                serializationObject.physicsEnabled = true;
                serializationObject.physicsGravity = physicEngine.gravity.asArray();
                serializationObject.physicsEngine = physicEngine.getPhysicsPluginName();
            }
        }
        // Metadata
        if (scene.metadata) serializationObject.metadata = scene.metadata;
        // Morph targets
        serializationObject.morphTargetManagers = [];
        for (const abstractMesh of scene.meshes){
            const manager = abstractMesh.morphTargetManager;
            if (manager) serializationObject.morphTargetManagers.push(manager.serialize());
        }
        // Lights
        serializationObject.lights = [];
        let index;
        let light;
        for(index = 0; index < scene.lights.length; index++){
            light = scene.lights[index];
            if (!light.doNotSerialize) serializationObject.lights.push(light.serialize());
        }
        // Cameras
        serializationObject.cameras = [];
        for(index = 0; index < scene.cameras.length; index++){
            const camera = scene.cameras[index];
            if (!camera.doNotSerialize) serializationObject.cameras.push(camera.serialize());
        }
        if (scene.activeCamera) serializationObject.activeCameraID = scene.activeCamera.id;
        // Animations
        (0, $6Ho1L.SerializationHelper).AppendSerializedAnimations(scene, serializationObject);
        // Animation Groups
        if (scene.animationGroups && scene.animationGroups.length > 0) {
            serializationObject.animationGroups = [];
            for(let animationGroupIndex = 0; animationGroupIndex < scene.animationGroups.length; animationGroupIndex++){
                const animationGroup = scene.animationGroups[animationGroupIndex];
                serializationObject.animationGroups.push(animationGroup.serialize());
            }
        }
        // Reflection probes
        if (scene.reflectionProbes && scene.reflectionProbes.length > 0) {
            serializationObject.reflectionProbes = [];
            for(index = 0; index < scene.reflectionProbes.length; index++){
                const reflectionProbe = scene.reflectionProbes[index];
                serializationObject.reflectionProbes.push(reflectionProbe.serialize());
            }
        }
        // Materials
        serializationObject.materials = [];
        serializationObject.multiMaterials = [];
        let material;
        for(index = 0; index < scene.materials.length; index++){
            material = scene.materials[index];
            if (!material.doNotSerialize) serializationObject.materials.push(material.serialize());
        }
        // MultiMaterials
        serializationObject.multiMaterials = [];
        for(index = 0; index < scene.multiMaterials.length; index++){
            const multiMaterial = scene.multiMaterials[index];
            serializationObject.multiMaterials.push(multiMaterial.serialize());
        }
        // Environment texture
        if (scene.environmentTexture) {
            if (scene.environmentTexture._files) serializationObject.environmentTexture = scene.environmentTexture.serialize();
            else {
                serializationObject.environmentTexture = scene.environmentTexture.name;
                serializationObject.environmentTextureRotationY = scene.environmentTexture.rotationY;
            }
        }
        // Environment Intensity
        serializationObject.environmentIntensity = scene.environmentIntensity;
        // Skeletons
        serializationObject.skeletons = [];
        for(index = 0; index < scene.skeletons.length; index++){
            const skeleton = scene.skeletons[index];
            if (!skeleton.doNotSerialize) serializationObject.skeletons.push(skeleton.serialize());
        }
        // Transform nodes
        serializationObject.transformNodes = [];
        for(index = 0; index < scene.transformNodes.length; index++)if (!scene.transformNodes[index].doNotSerialize) serializationObject.transformNodes.push(scene.transformNodes[index].serialize());
        // Geometries
        serializationObject.geometries = {};
        serializationObject.geometries.boxes = [];
        serializationObject.geometries.spheres = [];
        serializationObject.geometries.cylinders = [];
        serializationObject.geometries.toruses = [];
        serializationObject.geometries.grounds = [];
        serializationObject.geometries.planes = [];
        serializationObject.geometries.torusKnots = [];
        serializationObject.geometries.vertexData = [];
        $1cb15291050d5ca4$var$serializedGeometries = [];
        const geometries = scene.getGeometries();
        for(index = 0; index < geometries.length; index++){
            const geometry = geometries[index];
            if (geometry.isReady()) $1cb15291050d5ca4$var$SerializeGeometry(geometry, serializationObject.geometries);
        }
        // Meshes
        serializationObject.meshes = [];
        for(index = 0; index < scene.meshes.length; index++){
            const abstractMesh = scene.meshes[index];
            if (abstractMesh instanceof (0, $fbuqw.Mesh)) {
                const mesh = abstractMesh;
                if (!mesh.doNotSerialize) {
                    if (mesh.delayLoadState === 1 || mesh.delayLoadState === 0) serializationObject.meshes.push($1cb15291050d5ca4$var$SerializeMesh(mesh, serializationObject));
                }
            }
        }
        // Particles Systems
        serializationObject.particleSystems = [];
        for(index = 0; index < scene.particleSystems.length; index++)serializationObject.particleSystems.push(scene.particleSystems[index].serialize(false));
        // Post processes
        serializationObject.postProcesses = [];
        for(index = 0; index < scene.postProcesses.length; index++)serializationObject.postProcesses.push(scene.postProcesses[index].serialize());
        // Action Manager
        if (scene.actionManager) serializationObject.actions = scene.actionManager.serialize("scene");
        // Components
        for (const component of scene._serializableComponents)component.serialize(serializationObject);
        // Sprites
        if (scene.spriteManagers) {
            serializationObject.spriteManagers = [];
            for(index = 0; index < scene.spriteManagers.length; index++)serializationObject.spriteManagers.push(scene.spriteManagers[index].serialize(true));
        }
        return serializationObject;
    }
    /**
     * Serialize a scene into a JSON compatible object
     * @param scene defines the scene to serialize
     * @returns a JSON promise compatible object
     */ static SerializeAsync(scene) {
        const serializationObject = $1cb15291050d5ca4$export$25b4f9c42fc9a49c._Serialize(scene, false);
        const promises = [];
        this._CollectPromises(serializationObject, promises);
        return Promise.all(promises).then(()=>serializationObject);
    }
    static _CollectPromises(obj, promises) {
        if (Array.isArray(obj)) for(let i = 0; i < obj.length; ++i){
            const o = obj[i];
            if (o instanceof Promise) promises.push(o.then((res)=>obj[i] = res));
            else if (o instanceof Object || Array.isArray(o)) this._CollectPromises(o, promises);
        }
        else if (obj instanceof Object) {
            for(const name in obj)if (Object.prototype.hasOwnProperty.call(obj, name)) {
                const o = obj[name];
                if (o instanceof Promise) promises.push(o.then((res)=>obj[name] = res));
                else if (o instanceof Object || Array.isArray(o)) this._CollectPromises(o, promises);
            }
        }
    }
    /**
     * Serialize a mesh into a JSON compatible object
     * @param toSerialize defines the mesh to serialize
     * @param withParents defines if parents must be serialized as well
     * @param withChildren defines if children must be serialized as well
     * @returns a JSON compatible object
     */ static SerializeMesh(toSerialize /* Mesh || Mesh[] */ , withParents = false, withChildren = false) {
        const serializationObject = {};
        serializationObject.meshes = [];
        serializationObject.transformNodes = [];
        serializationObject.cameras = [];
        serializationObject.lights = [];
        $1cb15291050d5ca4$export$25b4f9c42fc9a49c.ClearCache();
        toSerialize = toSerialize instanceof Array ? toSerialize : [
            toSerialize
        ];
        if (withParents || withChildren) //deliberate for loop! not for each, appended should be processed as well.
        for(let i = 0; i < toSerialize.length; ++i){
            if (withChildren) toSerialize[i].getDescendants().forEach((node)=>{
                if (toSerialize.indexOf(node) < 0 && !node.doNotSerialize) toSerialize.push(node);
            });
            //make sure the array doesn't contain the object already
            if (withParents && toSerialize[i].parent && toSerialize.indexOf(toSerialize[i].parent) < 0 && !toSerialize[i].parent.doNotSerialize) toSerialize.push(toSerialize[i].parent);
        }
        toSerialize.forEach((mesh)=>{
            $1cb15291050d5ca4$var$FinalizeSingleNode(mesh, serializationObject);
        });
        return serializationObject;
    }
}

});

parcelRegister("hGjSH", function(module, exports) {

$parcel$export(module.exports, "VideoRecorder", () => $cdf5c7e589cdc887$export$ec9e02cabe22c790);

var $bOhSV = parcelRequire("bOhSV");
class $cdf5c7e589cdc887$export$ec9e02cabe22c790 {
    /**
     * Returns whether or not the VideoRecorder is available in your browser.
     * @param engine Defines the Babylon Engine.
     * @param canvas Defines the canvas to record. If not provided, the engine canvas will be used.
     * @returns true if supported otherwise false.
     */ static IsSupported(engine, canvas) {
        const targetCanvas = canvas ?? engine.getRenderingCanvas();
        return !!targetCanvas && typeof targetCanvas.captureStream === "function";
    }
    /**
     * True when a recording is already in progress.
     */ get isRecording() {
        return !!this._canvas && this._canvas.isRecording;
    }
    /**
     * Create a new VideoCapture object which can help converting what you see in Babylon to a video file.
     * @param engine Defines the BabylonJS Engine you wish to record.
     * @param options Defines options that can be used to customize the capture.
     */ constructor(engine, options = {}){
        if (!$cdf5c7e589cdc887$export$ec9e02cabe22c790.IsSupported(engine, options.canvas)) // eslint-disable-next-line no-throw-literal
        throw "Your browser does not support recording so far.";
        const canvas = options.canvas ?? engine.getRenderingCanvas();
        if (!canvas) // eslint-disable-next-line no-throw-literal
        throw "The babylon engine must have a canvas to be recorded";
        this._canvas = canvas;
        this._canvas.isRecording = false;
        this._options = {
            ...$cdf5c7e589cdc887$export$ec9e02cabe22c790._DefaultOptions,
            ...options
        };
        const stream = this._canvas.captureStream(this._options.fps);
        if (this._options.audioTracks) for (const track of this._options.audioTracks)stream.addTrack(track);
        this._mediaRecorder = new MediaRecorder(stream, {
            mimeType: this._options.mimeType
        });
        this._mediaRecorder.ondataavailable = (evt)=>this._handleDataAvailable(evt);
        this._mediaRecorder.onerror = (evt)=>this._handleError(evt);
        this._mediaRecorder.onstop = ()=>this._handleStop();
    }
    /**
     * Stops the current recording before the default capture timeout passed in the startRecording function.
     */ stopRecording() {
        if (!this._canvas || !this._mediaRecorder) return;
        if (!this.isRecording) return;
        this._canvas.isRecording = false;
        this._mediaRecorder.stop();
    }
    /**
     * Starts recording the canvas for a max duration specified in parameters.
     * @param fileName Defines the name of the file to be downloaded when the recording stop.
     * If null no automatic download will start and you can rely on the promise to get the data back.
     * @param maxDuration Defines the maximum recording time in seconds.
     * It defaults to 7 seconds. A value of zero will not stop automatically, you would need to call stopRecording manually.
     * @returns A promise callback at the end of the recording with the video data in Blob.
     */ startRecording(fileName = "babylonjs.webm", maxDuration = 7) {
        if (!this._canvas || !this._mediaRecorder) // eslint-disable-next-line no-throw-literal
        throw "Recorder has already been disposed";
        if (this.isRecording) // eslint-disable-next-line no-throw-literal
        throw "Recording already in progress";
        if (maxDuration > 0) setTimeout(()=>{
            this.stopRecording();
        }, maxDuration * 1000);
        this._fileName = fileName;
        this._recordedChunks = [];
        this._resolve = null;
        this._reject = null;
        this._canvas.isRecording = true;
        this._mediaRecorder.start(this._options.recordChunckSize);
        return new Promise((resolve, reject)=>{
            this._resolve = resolve;
            this._reject = reject;
        });
    }
    /**
     * Releases internal resources used during the recording.
     */ dispose() {
        this._canvas = null;
        this._mediaRecorder = null;
        this._recordedChunks = [];
        this._fileName = null;
        this._resolve = null;
        this._reject = null;
    }
    _handleDataAvailable(event) {
        if (event.data.size > 0) this._recordedChunks.push(event.data);
    }
    _handleError(event) {
        this.stopRecording();
        if (this._reject) this._reject(event.error);
        else throw new event.error();
    }
    _handleStop() {
        this.stopRecording();
        const superBuffer = new Blob(this._recordedChunks);
        if (this._resolve) this._resolve(superBuffer);
        window.URL.createObjectURL(superBuffer);
        if (this._fileName) (0, $bOhSV.Tools).Download(superBuffer, this._fileName);
    }
}
$cdf5c7e589cdc887$export$ec9e02cabe22c790._DefaultOptions = {
    mimeType: "video/webm",
    fps: 25,
    recordChunckSize: 3000
};

});

parcelRegister("g27AK", function(module, exports) {

$parcel$export(module.exports, "CreateScreenshot", () => $bac2b8cd28f60124$export$d5779474582516db);
$parcel$export(module.exports, "CreateScreenshotUsingRenderTarget", () => $bac2b8cd28f60124$export$158362977282fa41);
$parcel$export(module.exports, "CreateScreenshotAsync", () => $bac2b8cd28f60124$export$7a4b8a3b40abe8ba);
$parcel$export(module.exports, "CreateScreenshotWithResizeAsync", () => $bac2b8cd28f60124$export$a2a57aef4680153b);
$parcel$export(module.exports, "CreateScreenshotUsingRenderTargetAsync", () => $bac2b8cd28f60124$export$66ac7d5fdd8e2338);
$parcel$export(module.exports, "ScreenshotTools", () => $bac2b8cd28f60124$export$156cf1ca4edee36e);

var $j2mX5 = parcelRequire("j2mX5");

var $gQtNK = parcelRequire("gQtNK");

var $40XEW = parcelRequire("40XEW");

var $kVtWi = parcelRequire("kVtWi");

var $bOhSV = parcelRequire("bOhSV");

var $4dKnp = parcelRequire("4dKnp");

var $3a58A = parcelRequire("3a58A");
let $bac2b8cd28f60124$var$screenshotCanvas = null;
function $bac2b8cd28f60124$export$d5779474582516db(engine, camera, size, successCallback, mimeType = "image/png", forceDownload = false, quality) {
    const { height: height, width: width } = $bac2b8cd28f60124$var$_GetScreenshotSize(engine, camera, size);
    if (!(height && width)) {
        (0, $kVtWi.Logger).Error("Invalid 'size' parameter !");
        return;
    }
    if (!$bac2b8cd28f60124$var$screenshotCanvas) $bac2b8cd28f60124$var$screenshotCanvas = document.createElement("canvas");
    $bac2b8cd28f60124$var$screenshotCanvas.width = width;
    $bac2b8cd28f60124$var$screenshotCanvas.height = height;
    const renderContext = $bac2b8cd28f60124$var$screenshotCanvas.getContext("2d");
    const ratio = engine.getRenderWidth() / engine.getRenderHeight();
    let newWidth = width;
    let newHeight = newWidth / ratio;
    if (newHeight > height) {
        newHeight = height;
        newWidth = newHeight * ratio;
    }
    const offsetX = Math.max(0, width - newWidth) / 2;
    const offsetY = Math.max(0, height - newHeight) / 2;
    const scene = camera.getScene();
    if (scene.activeCamera !== camera) $bac2b8cd28f60124$export$158362977282fa41(engine, camera, size, (data)=>{
        if (forceDownload) {
            const blob = new Blob([
                data
            ]);
            (0, $bOhSV.Tools).DownloadBlob(blob);
            if (successCallback) successCallback("");
        } else if (successCallback) successCallback(data);
    }, mimeType, 1.0, engine.getCreationOptions().antialias, undefined, undefined, undefined, undefined, quality);
    else engine.onEndFrameObservable.addOnce(()=>{
        const renderingCanvas = engine.getRenderingCanvas();
        if (renderContext && renderingCanvas) renderContext.drawImage(renderingCanvas, offsetX, offsetY, newWidth, newHeight);
        if ($bac2b8cd28f60124$var$screenshotCanvas) {
            if (forceDownload) {
                (0, $bOhSV.Tools).EncodeScreenshotCanvasData($bac2b8cd28f60124$var$screenshotCanvas, undefined, mimeType, undefined, quality);
                if (successCallback) successCallback("");
            } else (0, $bOhSV.Tools).EncodeScreenshotCanvasData($bac2b8cd28f60124$var$screenshotCanvas, successCallback, mimeType, undefined, quality);
        }
    });
}
function $bac2b8cd28f60124$export$7a4b8a3b40abe8ba(engine, camera, size, mimeType = "image/png", quality) {
    return new Promise((resolve, reject)=>{
        $bac2b8cd28f60124$export$d5779474582516db(engine, camera, size, (data)=>{
            if (typeof data !== "undefined") resolve(data);
            else reject(new Error("Data is undefined"));
        }, mimeType, undefined, quality);
    });
}
function $bac2b8cd28f60124$export$a2a57aef4680153b(engine, camera, width, height, mimeType = "image/png", quality) {
    return new Promise((resolve)=>{
        $bac2b8cd28f60124$export$d5779474582516db(engine, camera, {
            width: width,
            height: height
        }, ()=>{
            resolve();
        }, mimeType, true, quality);
    });
}
function $bac2b8cd28f60124$export$158362977282fa41(engine, camera, size, successCallback, mimeType = "image/png", samples = 1, antialiasing = false, fileName, renderSprites = false, enableStencilBuffer = false, useLayerMask = true, quality, customizeTexture) {
    const { height: height, width: width, finalWidth: finalWidth, finalHeight: finalHeight } = $bac2b8cd28f60124$var$_GetScreenshotSize(engine, camera, size);
    const targetTextureSize = {
        width: width,
        height: height
    };
    if (!(height && width)) {
        (0, $kVtWi.Logger).Error("Invalid 'size' parameter !");
        return;
    }
    const originalSize = {
        width: engine.getRenderWidth(),
        height: engine.getRenderHeight()
    };
    engine.setSize(width, height); // we need this call to trigger onResizeObservable with the screenshot width/height on all the subsystems that are observing this event and that needs to (re)create some resources with the right dimensions
    const scene = camera.getScene();
    // At this point size can be a number, or an object (according to engine.prototype.createRenderTargetTexture method)
    const texture = new (0, $gQtNK.RenderTargetTexture)("screenShot", targetTextureSize, scene, false, false, 0, false, (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, undefined, enableStencilBuffer, undefined, undefined, undefined, samples);
    texture.renderList = scene.meshes.slice();
    texture.samples = samples;
    texture.renderSprites = renderSprites;
    texture.activeCamera = camera;
    texture.forceLayerMaskCheck = useLayerMask;
    customizeTexture?.(texture);
    const renderWhenReady = ()=>{
        if (texture.isReadyForRendering() && camera.isReady(true)) {
            engine.onEndFrameObservable.addOnce(()=>{
                if (finalWidth === width && finalHeight === height) texture.readPixels(undefined, undefined, undefined, false).then((data)=>{
                    (0, $4dKnp.DumpTools).DumpData(width, height, data, successCallback, mimeType, fileName, true, undefined, quality);
                    texture.dispose();
                });
                else (0, $3a58A.ApplyPostProcess)("pass", texture.getInternalTexture(), scene, undefined, undefined, undefined, finalWidth, finalHeight).then((texture)=>{
                    engine._readTexturePixels(texture, finalWidth, finalHeight, -1, 0, null, true, false, 0, 0).then((data)=>{
                        (0, $4dKnp.DumpTools).DumpData(finalWidth, finalHeight, data, successCallback, mimeType, fileName, true, undefined, quality);
                        texture.dispose();
                    });
                });
            });
            texture.render(true);
            // re-render the scene after the camera has been reset to the original camera to avoid a flicker that could occur
            // if the camera used for the RTT rendering stays in effect for the next frame (and if that camera was different from the original camera)
            scene.incrementRenderId();
            scene.resetCachedMaterial();
            engine.setSize(originalSize.width, originalSize.height);
            camera.getProjectionMatrix(true); // Force cache refresh;
            scene.render();
        } else setTimeout(renderWhenReady, 16);
    };
    const renderToTexture = ()=>{
        // render the RTT
        scene.incrementRenderId();
        scene.resetCachedMaterial();
        renderWhenReady();
    };
    if (antialiasing) {
        const fxaaPostProcess = new (0, $40XEW.FxaaPostProcess)("antialiasing", 1.0, scene.activeCamera);
        texture.addPostProcess(fxaaPostProcess);
        // Async Shader Compilation can lead to none ready effects in synchronous code
        if (!fxaaPostProcess.getEffect().isReady()) fxaaPostProcess.getEffect().onCompiled = ()=>{
            renderToTexture();
        };
        else renderToTexture();
    } else // No need to wait for extra resources to be ready
    renderToTexture();
}
function $bac2b8cd28f60124$export$66ac7d5fdd8e2338(engine, camera, size, mimeType = "image/png", samples = 1, antialiasing = false, fileName, renderSprites = false, enableStencilBuffer = false, useLayerMask = true, quality) {
    return new Promise((resolve, reject)=>{
        $bac2b8cd28f60124$export$158362977282fa41(engine, camera, size, (data)=>{
            if (typeof data !== "undefined") resolve(data);
            else reject(new Error("Data is undefined"));
        }, mimeType, samples, antialiasing, fileName, renderSprites, enableStencilBuffer, useLayerMask, quality);
    });
}
/**
 * Gets height and width for screenshot size
 * @param engine
 * @param camera
 * @param size
 * @private
 */ function $bac2b8cd28f60124$var$_GetScreenshotSize(engine, camera, size) {
    let height = 0;
    let width = 0;
    let finalWidth = 0;
    let finalHeight = 0;
    //If a size value defined as object
    if (typeof size === "object") {
        const precision = size.precision ? Math.abs(size.precision) // prevent GL_INVALID_VALUE : glViewport: negative width/height
         : 1;
        //If a width and height values is specified
        if (size.width && size.height) {
            height = size.height * precision;
            width = size.width * precision;
        } else if (size.width && !size.height) {
            width = size.width * precision;
            height = Math.round(width / engine.getAspectRatio(camera));
        } else if (size.height && !size.width) {
            height = size.height * precision;
            width = Math.round(height * engine.getAspectRatio(camera));
        } else {
            width = Math.round(engine.getRenderWidth() * precision);
            height = Math.round(width / engine.getAspectRatio(camera));
        }
        //If a finalWidth and finalHeight values is specified
        if (size.finalWidth && size.finalHeight) {
            finalHeight = size.finalHeight;
            finalWidth = size.finalWidth;
        } else if (size.finalWidth && !size.finalHeight) {
            finalWidth = size.finalWidth;
            finalHeight = Math.round(finalWidth / engine.getAspectRatio(camera));
        } else if (size.finalHeight && !size.finalWidth) {
            finalHeight = size.finalHeight;
            finalWidth = Math.round(finalHeight * engine.getAspectRatio(camera));
        } else {
            finalWidth = width;
            finalHeight = height;
        }
    } else if (!isNaN(size)) {
        height = size;
        width = size;
        finalWidth = size;
        finalHeight = size;
    }
    // When creating the image data from the CanvasRenderingContext2D, the width and height is clamped to the size of the _gl context
    // On certain GPUs, it seems as if the _gl context truncates to an integer automatically. Therefore, if a user tries to pass the width of their canvas element
    // and it happens to be a float (1000.5 x 600.5 px), the engine.readPixels will return a different size array than context.createImageData
    // to resolve this, we truncate the floats here to ensure the same size
    if (width) width = Math.floor(width);
    if (height) height = Math.floor(height);
    if (finalWidth) finalWidth = Math.floor(finalWidth);
    if (finalHeight) finalHeight = Math.floor(finalHeight);
    return {
        height: height | 0,
        width: width | 0,
        finalWidth: finalWidth | 0,
        finalHeight: finalHeight | 0
    };
}
const $bac2b8cd28f60124$export$156cf1ca4edee36e = {
    CreateScreenshot: /**
     * Captures a screenshot of the current rendering
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/renderToPNG
     * @param engine defines the rendering engine
     * @param camera defines the source camera
     * @param size This parameter can be set to a single number or to an object with the
     * following (optional) properties: precision, width, height. If a single number is passed,
     * it will be used for both width and height. If an object is passed, the screenshot size
     * will be derived from the parameters. The precision property is a multiplier allowing
     * rendering at a higher or lower resolution
     * @param successCallback defines the callback receives a single parameter which contains the
     * screenshot as a string of base64-encoded characters. This string can be assigned to the
     * src parameter of an <img> to display it
     * @param mimeType defines the MIME type of the screenshot image (default: image/png).
     * Check your browser for supported MIME types
     * @param forceDownload force the system to download the image even if a successCallback is provided
     * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
     */ $bac2b8cd28f60124$export$d5779474582516db,
    CreateScreenshotAsync: /**
     * Captures a screenshot of the current rendering
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/renderToPNG
     * @param engine defines the rendering engine
     * @param camera defines the source camera
     * @param size This parameter can be set to a single number or to an object with the
     * following (optional) properties: precision, width, height. If a single number is passed,
     * it will be used for both width and height. If an object is passed, the screenshot size
     * will be derived from the parameters. The precision property is a multiplier allowing
     * rendering at a higher or lower resolution
     * @param mimeType defines the MIME type of the screenshot image (default: image/png).
     * Check your browser for supported MIME types
     * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
     * @returns screenshot as a string of base64-encoded characters. This string can be assigned
     * to the src parameter of an <img> to display it
     */ $bac2b8cd28f60124$export$7a4b8a3b40abe8ba,
    CreateScreenshotWithResizeAsync: /**
     * Captures a screenshot of the current rendering for a specific size. This will render the entire canvas but will generate a blink (due to canvas resize)
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/renderToPNG
     * @param engine defines the rendering engine
     * @param camera defines the source camera
     * @param width defines the expected width
     * @param height defines the expected height
     * @param mimeType defines the MIME type of the screenshot image (default: image/png).
     * Check your browser for supported MIME types
     * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
     * @returns screenshot as a string of base64-encoded characters. This string can be assigned
     * to the src parameter of an <img> to display it
     */ $bac2b8cd28f60124$export$a2a57aef4680153b,
    CreateScreenshotUsingRenderTarget: /**
     * Generates an image screenshot from the specified camera.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/renderToPNG
     * @param engine The engine to use for rendering
     * @param camera The camera to use for rendering
     * @param size This parameter can be set to a single number or to an object with the
     * following (optional) properties: precision, width, height. If a single number is passed,
     * it will be used for both width and height. If an object is passed, the screenshot size
     * will be derived from the parameters. The precision property is a multiplier allowing
     * rendering at a higher or lower resolution
     * @param successCallback The callback receives a single parameter which contains the
     * screenshot as a string of base64-encoded characters. This string can be assigned to the
     * src parameter of an <img> to display it
     * @param mimeType The MIME type of the screenshot image (default: image/png).
     * Check your browser for supported MIME types
     * @param samples Texture samples (default: 1)
     * @param antialiasing Whether antialiasing should be turned on or not (default: false)
     * @param fileName A name for for the downloaded file.
     * @param renderSprites Whether the sprites should be rendered or not (default: false)
     * @param enableStencilBuffer Whether the stencil buffer should be enabled or not (default: false)
     * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
     */ $bac2b8cd28f60124$export$158362977282fa41,
    CreateScreenshotUsingRenderTargetAsync: /**
     * Generates an image screenshot from the specified camera.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/scene/renderToPNG
     * @param engine The engine to use for rendering
     * @param camera The camera to use for rendering
     * @param size This parameter can be set to a single number or to an object with the
     * following (optional) properties: precision, width, height. If a single number is passed,
     * it will be used for both width and height. If an object is passed, the screenshot size
     * will be derived from the parameters. The precision property is a multiplier allowing
     * rendering at a higher or lower resolution
     * @param mimeType The MIME type of the screenshot image (default: image/png).
     * Check your browser for supported MIME types
     * @param samples Texture samples (default: 1)
     * @param antialiasing Whether antialiasing should be turned on or not (default: false)
     * @param fileName A name for for the downloaded file.
     * @param renderSprites Whether the sprites should be rendered or not (default: false)
     * @param quality The quality of the image if lossy mimeType is used (e.g. image/jpeg, image/webp). See {@link https://developer.mozilla.org/en-US/docs/Web/API/HTMLCanvasElement/toBlob | HTMLCanvasElement.toBlob()}'s `quality` parameter.
     * @returns screenshot as a string of base64-encoded characters. This string can be assigned
     * to the src parameter of an <img> to display it
     */ $bac2b8cd28f60124$export$66ac7d5fdd8e2338
};
/**
 * This will be executed automatically for UMD and es5.
 * If esm dev wants the side effects to execute they will have to run it manually
 * Once we build native modules those need to be exported.
 * @internal
 */ const $bac2b8cd28f60124$var$initSideEffects = ()=>{
    // References the dependencies.
    (0, $bOhSV.Tools).CreateScreenshot = $bac2b8cd28f60124$export$d5779474582516db;
    (0, $bOhSV.Tools).CreateScreenshotAsync = $bac2b8cd28f60124$export$7a4b8a3b40abe8ba;
    (0, $bOhSV.Tools).CreateScreenshotUsingRenderTarget = $bac2b8cd28f60124$export$158362977282fa41;
    (0, $bOhSV.Tools).CreateScreenshotUsingRenderTargetAsync = $bac2b8cd28f60124$export$66ac7d5fdd8e2338;
};
$bac2b8cd28f60124$var$initSideEffects();

});

parcelRegister("KFA1e", function(module, exports) {

$parcel$export(module.exports, "InspectableType", () => $08c48ce793f6023b$export$52ca83a0bb5d4b9);
/**
 * Enum that determines the text-wrapping mode to use.
 */ var $08c48ce793f6023b$export$52ca83a0bb5d4b9;
(function(InspectableType) {
    /**
     * Checkbox for booleans
     */ InspectableType[InspectableType["Checkbox"] = 0] = "Checkbox";
    /**
     * Sliders for numbers
     */ InspectableType[InspectableType["Slider"] = 1] = "Slider";
    /**
     * Vector3
     */ InspectableType[InspectableType["Vector3"] = 2] = "Vector3";
    /**
     * Quaternions
     */ InspectableType[InspectableType["Quaternion"] = 3] = "Quaternion";
    /**
     * Color3
     */ InspectableType[InspectableType["Color3"] = 4] = "Color3";
    /**
     * String
     */ InspectableType[InspectableType["String"] = 5] = "String";
    /**
     * Button
     */ InspectableType[InspectableType["Button"] = 6] = "Button";
    /**
     * Options
     */ InspectableType[InspectableType["Options"] = 7] = "Options";
    /**
     * Tab
     */ InspectableType[InspectableType["Tab"] = 8] = "Tab";
    /**
     * File button
     */ InspectableType[InspectableType["FileButton"] = 9] = "FileButton";
    /**
     * Vector2
     */ InspectableType[InspectableType["Vector2"] = 10] = "Vector2";
})($08c48ce793f6023b$export$52ca83a0bb5d4b9 || ($08c48ce793f6023b$export$52ca83a0bb5d4b9 = {}));

});

parcelRegister("6YHU0", function(module, exports) {

});

parcelRegister("2GZM8", function(module, exports) {

});

parcelRegister("kVJni", function(module, exports) {

});

parcelRegister("2ZHg6", function(module, exports) {

});

parcelRegister("dB08u", function(module, exports) {

$parcel$export(module.exports, "DataReader", () => $9e5ed60d1669f6e5$export$a930ebf2173137c4);

var $eLv1o = parcelRequire("eLv1o");
class $9e5ed60d1669f6e5$export$a930ebf2173137c4 {
    /**
     * Constructor
     * @param buffer The buffer to read
     */ constructor(buffer){
        /**
         * The current byte offset from the beginning of the data buffer.
         */ this.byteOffset = 0;
        this.buffer = buffer;
    }
    /**
     * Loads the given byte length.
     * @param byteLength The byte length to load
     * @returns A promise that resolves when the load is complete
     */ loadAsync(byteLength) {
        return this.buffer.readAsync(this.byteOffset, byteLength).then((data)=>{
            this._dataView = new DataView(data.buffer, data.byteOffset, data.byteLength);
            this._dataByteOffset = 0;
        });
    }
    /**
     * Read a unsigned 32-bit integer from the currently loaded data range.
     * @returns The 32-bit integer read
     */ readUint32() {
        const value = this._dataView.getUint32(this._dataByteOffset, true);
        this._dataByteOffset += 4;
        this.byteOffset += 4;
        return value;
    }
    /**
     * Read a byte array from the currently loaded data range.
     * @param byteLength The byte length to read
     * @returns The byte array read
     */ readUint8Array(byteLength) {
        const value = new Uint8Array(this._dataView.buffer, this._dataView.byteOffset + this._dataByteOffset, byteLength);
        this._dataByteOffset += byteLength;
        this.byteOffset += byteLength;
        return value;
    }
    /**
     * Read a string from the currently loaded data range.
     * @param byteLength The byte length to read
     * @returns The string read
     */ readString(byteLength) {
        return (0, $eLv1o.Decode)(this.readUint8Array(byteLength));
    }
    /**
     * Skips the given byte length the currently loaded data range.
     * @param byteLength The byte length to skip
     */ skipBytes(byteLength) {
        this._dataByteOffset += byteLength;
        this.byteOffset += byteLength;
    }
}

});

parcelRegister("j8S6I", function(module, exports) {

$parcel$export(module.exports, "DataStorage", () => $def8bc48887bba40$export$e95767ffe2e60cec);
/**
 * Class for storing data to local storage if available or in-memory storage otherwise
 */ class $def8bc48887bba40$export$e95767ffe2e60cec {
    static _GetStorage() {
        try {
            localStorage.setItem("test", "");
            localStorage.removeItem("test");
            return localStorage;
        } catch  {
            const inMemoryStorage = {};
            return {
                getItem: (key)=>{
                    const value = inMemoryStorage[key];
                    return value === undefined ? null : value;
                },
                setItem: (key, value)=>{
                    inMemoryStorage[key] = value;
                }
            };
        }
    }
    /**
     * Reads a string from the data storage
     * @param key The key to read
     * @param defaultValue The value if the key doesn't exist
     * @returns The string value
     */ static ReadString(key, defaultValue) {
        const value = this._Storage.getItem(key);
        return value !== null ? value : defaultValue;
    }
    /**
     * Writes a string to the data storage
     * @param key The key to write
     * @param value The value to write
     */ static WriteString(key, value) {
        this._Storage.setItem(key, value);
    }
    /**
     * Reads a boolean from the data storage
     * @param key The key to read
     * @param defaultValue The value if the key doesn't exist
     * @returns The boolean value
     */ static ReadBoolean(key, defaultValue) {
        const value = this._Storage.getItem(key);
        return value !== null ? value === "true" : defaultValue;
    }
    /**
     * Writes a boolean to the data storage
     * @param key The key to write
     * @param value The value to write
     */ static WriteBoolean(key, value) {
        this._Storage.setItem(key, value ? "true" : "false");
    }
    /**
     * Reads a number from the data storage
     * @param key The key to read
     * @param defaultValue The value if the key doesn't exist
     * @returns The number value
     */ static ReadNumber(key, defaultValue) {
        const value = this._Storage.getItem(key);
        return value !== null ? parseFloat(value) : defaultValue;
    }
    /**
     * Writes a number to the data storage
     * @param key The key to write
     * @param value The value to write
     */ static WriteNumber(key, value) {
        this._Storage.setItem(key, value.toString());
    }
}
$def8bc48887bba40$export$e95767ffe2e60cec._Storage = $def8bc48887bba40$export$e95767ffe2e60cec._GetStorage();

});

parcelRegister("jEKlB", function(module, exports) {

$parcel$export(module.exports, "SceneRecorder", () => $03b161e083bb695c$export$f7bd00ba59602a94);

var $2sJhC = parcelRequire("2sJhC");

var $fbuqw = parcelRequire("fbuqw");

var $c6YWJ = parcelRequire("c6YWJ");

var $74SKQ = parcelRequire("74SKQ");

var $3RnX0 = parcelRequire("3RnX0");

var $54229 = parcelRequire("54229");

var $3zFLd = parcelRequire("3zFLd");

var $klshO = parcelRequire("klshO");

var $hi6ss = parcelRequire("hi6ss");

var $c9v5E = parcelRequire("c9v5E");

var $itc0L = parcelRequire("itc0L");

var $cFdBb = parcelRequire("cFdBb");

var $j2mX5 = parcelRequire("j2mX5");

var $6Ho1L = parcelRequire("6Ho1L");
class $03b161e083bb695c$export$f7bd00ba59602a94 {
    constructor(){
        this._trackedScene = null;
    }
    /**
     * Track a given scene. This means the current scene state will be considered the original state
     * @param scene defines the scene to track
     */ track(scene) {
        this._trackedScene = scene;
        (0, $6Ho1L.SerializationHelper).AllowLoadingUniqueId = true;
        this._savedJSON = (0, $2sJhC.SceneSerializer).Serialize(scene);
        (0, $6Ho1L.SerializationHelper).AllowLoadingUniqueId = false;
    }
    /**
     * Get the delta between current state and original state
     * @returns a any containing the delta
     */ getDelta() {
        if (!this._trackedScene) return null;
        const currentForceSerializeBuffers = (0, $j2mX5.Texture).ForceSerializeBuffers;
        (0, $j2mX5.Texture).ForceSerializeBuffers = false;
        (0, $6Ho1L.SerializationHelper).AllowLoadingUniqueId = true;
        const newJSON = (0, $2sJhC.SceneSerializer).Serialize(this._trackedScene);
        (0, $6Ho1L.SerializationHelper).AllowLoadingUniqueId = false;
        const deltaJSON = {};
        for(const node in newJSON)this._compareCollections(node, this._savedJSON[node], newJSON[node], deltaJSON);
        (0, $j2mX5.Texture).ForceSerializeBuffers = currentForceSerializeBuffers;
        return deltaJSON;
    }
    _compareArray(key, original, current, deltaJSON) {
        if (original.length === 0 && current.length === 0) return true;
        // Numbers?
        if (original.length && !isNaN(original[0]) || current.length && !isNaN(current[0])) {
            if (original.length !== current.length) return false;
            if (original.length === 0) return true;
            for(let index = 0; index < original.length; index++)if (original[index] !== current[index]) {
                deltaJSON[key] = current;
                return false;
            }
            return true;
        }
        // let's use uniqueId to find similar objects
        const originalUniqueIds = [];
        for(let index = 0; index < original.length; index++){
            const originalObject = original[index];
            const originalUniqueId = originalObject.uniqueId;
            originalUniqueIds.push(originalUniqueId);
            // Look for that object in current state
            const currentObjects = current.filter((c)=>c.uniqueId === originalUniqueId);
            if (currentObjects.length) {
                // We have a candidate
                const currentObject = currentObjects[0];
                const newObject = {};
                if (!this._compareObjects(originalObject, currentObject, newObject)) {
                    if (!deltaJSON[key]) deltaJSON[key] = [];
                    newObject.__state = {
                        id: currentObject.id || currentObject.name
                    };
                    deltaJSON[key].push(newObject);
                }
            } else {
                // We need to delete
                const newObject = {
                    __state: {
                        deleteId: originalObject.id || originalObject.name
                    }
                };
                if (!deltaJSON[key]) deltaJSON[key] = [];
                deltaJSON[key].push(newObject);
            }
        }
        // Checking for new objects
        for(let index = 0; index < current.length; index++){
            const currentObject = current[index];
            const currentUniqueId = currentObject.uniqueId;
            // Object was added
            if (originalUniqueIds.indexOf(currentUniqueId) === -1) {
                if (!deltaJSON[key]) deltaJSON[key] = [];
                deltaJSON[key].push(currentObject);
            }
        }
        return true;
    }
    _compareObjects(originalObjet, currentObject, deltaJSON) {
        let aDifferenceWasFound = false;
        for(const prop in originalObjet){
            if (!Object.prototype.hasOwnProperty.call(originalObjet, prop)) continue;
            const originalValue = originalObjet[prop];
            const currentValue = currentObject[prop];
            let diffFound = false;
            if (Array.isArray(originalValue)) diffFound = JSON.stringify(originalValue) !== JSON.stringify(currentValue);
            else if (!isNaN(originalValue) || Object.prototype.toString.call(originalValue) == "[object String]") diffFound = originalValue !== currentValue;
            else if (typeof originalValue === "object" && typeof currentValue === "object") {
                const newObject = {};
                if (!this._compareObjects(originalValue, currentValue, newObject)) {
                    deltaJSON[prop] = newObject;
                    aDifferenceWasFound = true;
                }
            }
            if (diffFound) {
                aDifferenceWasFound = true;
                deltaJSON[prop] = currentValue;
            }
        }
        return !aDifferenceWasFound;
    }
    _compareCollections(key, original, current, deltaJSON) {
        // Same ?
        if (original === current) return;
        if (original && current) {
            // Array?
            if (Array.isArray(original) && Array.isArray(current)) {
                if (this._compareArray(key, original, current, deltaJSON)) return;
            } else if (typeof original === "object" && typeof current === "object") {
                // Object
                const newObject = {};
                if (!this._compareObjects(original, current, newObject)) deltaJSON[key] = newObject;
                return;
            }
        }
    }
    static GetShadowGeneratorById(scene, id) {
        const allGenerators = scene.lights.map((l)=>l.getShadowGenerators());
        for (const generators of allGenerators)if (generators) {
            const iterator = generators.values();
            for(let key = iterator.next(); key.done !== true; key = iterator.next()){
                const generator = key.value;
                if (generator && generator.id === id) return generator;
            }
        }
        return null;
    }
    /**
     * Apply a given delta to a given scene
     * @param deltaJSON defines the JSON containing the delta
     * @param scene defines the scene to apply the delta to
     */ static ApplyDelta(deltaJSON, scene) {
        if (typeof deltaJSON === "string") deltaJSON = JSON.parse(deltaJSON);
        // Scene
        const anyScene = scene;
        for(const prop in deltaJSON){
            const source = deltaJSON[prop];
            const property = anyScene[prop];
            if (Array.isArray(property) || prop === "shadowGenerators") // Restore array
            switch(prop){
                case "cameras":
                    this._ApplyDeltaForEntity(source, scene, scene.getCameraById.bind(scene), (data)=>(0, $74SKQ.Camera).Parse(data, scene));
                    break;
                case "lights":
                    this._ApplyDeltaForEntity(source, scene, scene.getLightById.bind(scene), (data)=>(0, $c6YWJ.Light).Parse(data, scene));
                    break;
                case "shadowGenerators":
                    this._ApplyDeltaForEntity(source, scene, (id)=>this.GetShadowGeneratorById(scene, id), (data)=>(0, $itc0L.ShadowGenerator).Parse(data, scene));
                    break;
                case "meshes":
                    this._ApplyDeltaForEntity(source, scene, scene.getMeshById.bind(scene), (data)=>(0, $fbuqw.Mesh).Parse(data, scene, ""));
                    break;
                case "skeletons":
                    this._ApplyDeltaForEntity(source, scene, scene.getSkeletonById.bind(scene), (data)=>(0, $3RnX0.Skeleton).Parse(data, scene));
                    break;
                case "materials":
                    this._ApplyDeltaForEntity(source, scene, scene.getMaterialById.bind(scene), (data)=>(0, $54229.Material).Parse(data, scene, ""));
                    break;
                case "multiMaterials":
                    this._ApplyDeltaForEntity(source, scene, scene.getMaterialById.bind(scene), (data)=>(0, $3zFLd.MultiMaterial).Parse(data, scene, ""));
                    break;
                case "transformNodes":
                    this._ApplyDeltaForEntity(source, scene, scene.getTransformNodeById.bind(scene), (data)=>(0, $klshO.TransformNode).Parse(data, scene, ""));
                    break;
                case "particleSystems":
                    this._ApplyDeltaForEntity(source, scene, scene.getParticleSystemById.bind(scene), (data)=>(0, $hi6ss.ParticleSystem).Parse(data, scene, ""));
                    break;
                case "morphTargetManagers":
                    this._ApplyDeltaForEntity(source, scene, scene.getMorphTargetById.bind(scene), (data)=>(0, $c9v5E.MorphTargetManager).Parse(data, scene));
                    break;
                case "postProcesses":
                    this._ApplyDeltaForEntity(source, scene, scene.getPostProcessByName.bind(scene), (data)=>(0, $cFdBb.PostProcess).Parse(data, scene, ""));
                    break;
            }
            else if (!isNaN(property)) anyScene[prop] = source;
            else if (property.fromArray) property.fromArray(source);
        }
    }
    static _ApplyPropertiesToEntity(deltaJSON, entity) {
        for(const prop in deltaJSON){
            const source = deltaJSON[prop];
            const property = entity[prop];
            if (property === undefined) continue;
            if (!isNaN(property) || Array.isArray(property)) entity[prop] = source;
            else if (property.fromArray) property.fromArray(source);
            else if (typeof property === "object" && property !== null) this._ApplyPropertiesToEntity(source, property);
        }
    }
    static _ApplyDeltaForEntity(sources, scene, finder, addNew) {
        for (const source of sources){
            // Update
            if (source.__state && source.__state.id !== undefined) {
                const targetEntity = finder(source.__state.id);
                if (targetEntity) {
                    // This first pass applies properties that aren't on the serialization list
                    this._ApplyPropertiesToEntity(source, targetEntity);
                    // The second pass applies the serializable properties
                    (0, $6Ho1L.SerializationHelper).ParseProperties(source, targetEntity, scene, null);
                }
            } else if (source.__state && source.__state.deleteId !== undefined) {
                const target = finder(source.__state.deleteId);
                target?.dispose();
            } else // New
            addNew(source);
        }
    }
}

});

parcelRegister("7Nenw", function(module, exports) {

$parcel$export(module.exports, "Trajectory", () => $5ac8434487adced3$export$95f98b41ccd47c3b);
$parcel$export(module.exports, "TrajectoryClassifier", () => $5ac8434487adced3$export$8ab9ea6d1744c61e);

var $ha1VO = parcelRequire("ha1VO");
// This implementation was based on the original MIT-licensed TRACE repository
// from https://github.com/septagon/TRACE.
/**
 * Generic implementation of Levenshtein distance.
 */ var $5ac8434487adced3$var$Levenshtein;
(function(Levenshtein) {
    /**
     * Alphabet from which to construct sequences to be compared using Levenshtein
     * distance.
     */ class Alphabet {
        /**
         * Serialize the Alphabet to JSON string.
         * @returns JSON serialization
         */ serialize() {
            const jsonObject = {};
            const characters = new Array(this._characterToIdx.size);
            this._characterToIdx.forEach((v, k)=>{
                characters[v] = k;
            });
            jsonObject["characters"] = characters;
            jsonObject["insertionCosts"] = this._insertionCosts;
            jsonObject["deletionCosts"] = this._deletionCosts;
            jsonObject["substitutionCosts"] = this._substitutionCosts;
            return JSON.stringify(jsonObject);
        }
        /**
         * Parse an Alphabet from a JSON serialization.
         * @param json JSON string to deserialize
         * @returns deserialized Alphabet
         */ static Deserialize(json) {
            const jsonObject = JSON.parse(json);
            const alphabet = new Alphabet(jsonObject["characters"]);
            alphabet._insertionCosts = jsonObject["insertionCosts"];
            alphabet._deletionCosts = jsonObject["deletionCosts"];
            alphabet._substitutionCosts = jsonObject["substitutionCosts"];
            return alphabet;
        }
        /**
         * Create a new Alphabet.
         * @param characters characters of the alphabet
         * @param charToInsertionCost function mapping characters to insertion costs
         * @param charToDeletionCost function mapping characters to deletion costs
         * @param charsToSubstitutionCost function mapping character pairs to substitution costs
         */ constructor(characters, charToInsertionCost = null, charToDeletionCost = null, charsToSubstitutionCost = null){
            charToInsertionCost = charToInsertionCost ?? (()=>1);
            charToDeletionCost = charToDeletionCost ?? (()=>1);
            charsToSubstitutionCost = charsToSubstitutionCost ?? ((a, b)=>a === b ? 0 : 1);
            this._characterToIdx = new Map();
            this._insertionCosts = new Array(characters.length);
            this._deletionCosts = new Array(characters.length);
            this._substitutionCosts = new Array(characters.length);
            let c;
            for(let outerIdx = 0; outerIdx < characters.length; ++outerIdx){
                c = characters[outerIdx];
                this._characterToIdx.set(c, outerIdx);
                this._insertionCosts[outerIdx] = charToInsertionCost(c);
                this._deletionCosts[outerIdx] = charToDeletionCost(c);
                this._substitutionCosts[outerIdx] = new Array(characters.length);
                for(let innerIdx = outerIdx; innerIdx < characters.length; ++innerIdx)this._substitutionCosts[outerIdx][innerIdx] = charsToSubstitutionCost(c, characters[innerIdx]);
            }
        }
        /**
         * Get the index (internally-assigned number) for a character.
         * @param char character
         * @returns index
         */ getCharacterIdx(char) {
            return this._characterToIdx.get(char);
        }
        /**
         * Get the insertion cost of a character from its index.
         * @param idx character index
         * @returns insertion cost
         */ getInsertionCost(idx) {
            return this._insertionCosts[idx];
        }
        /**
         * Get the deletion cost of a character from its index.
         * @param idx character index
         * @returns deletion cost
         */ getDeletionCost(idx) {
            return this._deletionCosts[idx];
        }
        /**
         * Gets the cost to substitute two characters. NOTE: this cost is
         * required to be bi-directional, meaning it cannot matter which of
         * the provided characters is being removed and which is being inserted.
         * @param idx1 the first character index
         * @param idx2 the second character index
         * @returns substitution cost
         */ getSubstitutionCost(idx1, idx2) {
            const min = Math.min(idx1, idx2);
            const max = Math.max(idx1, idx2);
            return this._substitutionCosts[min][max];
        }
    }
    Levenshtein.Alphabet = Alphabet;
    /**
     * Character sequence intended to be compared against other Sequences created
     * with the same Alphabet in order to compute Levenshtein distance.
     */ class Sequence {
        /**
         * Serialize to JSON string. JSON representation does NOT include the Alphabet
         * from which this Sequence was created; Alphabet must be independently
         * serialized.
         * @returns JSON string
         */ serialize() {
            return JSON.stringify(this._characters);
        }
        /**
         * Deserialize from JSON string and Alphabet. This should be the same Alphabet
         * from which the Sequence was originally created, which must be serialized and
         * deserialized independently so that it can be passed in here.
         * @param json JSON string representation of Sequence
         * @param alphabet Alphabet from which Sequence was originally created
         * @returns Sequence
         */ static Deserialize(json, alphabet) {
            const sequence = new Sequence([], alphabet);
            sequence._characters = JSON.parse(json);
            return sequence;
        }
        /**
         * Create a new Sequence.
         * @param characters characters in the new Sequence
         * @param alphabet Alphabet, which must include all used characters
         */ constructor(characters, alphabet){
            if (characters.length > Sequence._MAX_SEQUENCE_LENGTH) throw new Error("Sequences longer than " + Sequence._MAX_SEQUENCE_LENGTH + " not supported.");
            this._alphabet = alphabet;
            this._characters = characters.map((c)=>this._alphabet.getCharacterIdx(c));
        }
        /**
         * Get the distance between this Sequence and another.
         * @param other sequence to compare to
         * @returns Levenshtein distance
         */ distance(other) {
            return Sequence._Distance(this, other);
        }
        /**
         * Compute the Levenshtein distance between two Sequences.
         * @param a first Sequence
         * @param b second Sequence
         * @returns Levenshtein distance
         */ static _Distance(a, b) {
            const alphabet = a._alphabet;
            if (alphabet !== b._alphabet) throw new Error("Cannot Levenshtein compare Sequences built from different alphabets.");
            const aChars = a._characters;
            const bChars = b._characters;
            const aLength = aChars.length;
            const bLength = bChars.length;
            const costMatrix = Sequence._CostMatrix;
            costMatrix[0][0] = 0;
            for(let idx = 0; idx < aLength; ++idx)costMatrix[idx + 1][0] = costMatrix[idx][0] + alphabet.getInsertionCost(aChars[idx]);
            for(let idx = 0; idx < bLength; ++idx)costMatrix[0][idx + 1] = costMatrix[0][idx] + alphabet.getInsertionCost(bChars[idx]);
            for(let aIdx = 0; aIdx < aLength; ++aIdx)for(let bIdx = 0; bIdx < bLength; ++bIdx){
                Sequence._InsertionCost = costMatrix[aIdx + 1][bIdx] + alphabet.getInsertionCost(bChars[bIdx]);
                Sequence._DeletionCost = costMatrix[aIdx][bIdx + 1] + alphabet.getDeletionCost(aChars[aIdx]);
                Sequence._SubstitutionCost = costMatrix[aIdx][bIdx] + alphabet.getSubstitutionCost(aChars[aIdx], bChars[bIdx]);
                costMatrix[aIdx + 1][bIdx + 1] = Math.min(Sequence._InsertionCost, Sequence._DeletionCost, Sequence._SubstitutionCost);
            }
            return costMatrix[aLength][bLength];
        }
    }
    // Scratch values
    Sequence._MAX_SEQUENCE_LENGTH = 256;
    Sequence._CostMatrix = [
        ...Array(Sequence._MAX_SEQUENCE_LENGTH + 1)
    ].map(()=>new Array(Sequence._MAX_SEQUENCE_LENGTH + 1));
    Levenshtein.Sequence = Sequence;
})($5ac8434487adced3$var$Levenshtein || ($5ac8434487adced3$var$Levenshtein = {}));
class $5ac8434487adced3$export$95f98b41ccd47c3b {
    /**
     * Serialize to JSON.
     * @returns serialized JSON string
     */ serialize() {
        return JSON.stringify(this);
    }
    /**
     * Deserialize from JSON.
     * @param json serialized JSON string
     * @returns deserialized Trajectory
     */ static Deserialize(json) {
        const jsonObject = JSON.parse(json);
        const trajectory = new $5ac8434487adced3$export$95f98b41ccd47c3b(jsonObject["_segmentLength"]);
        trajectory._points = jsonObject["_points"].map((pt)=>{
            return new (0, $ha1VO.Vector3)(pt["_x"], pt["_y"], pt["_z"]);
        });
        return trajectory;
    }
    /**
     * Create a new empty Trajectory.
     * @param segmentLength radius of discretization for Trajectory points
     */ constructor(segmentLength = 0.01){
        this._points = [];
        this._segmentLength = segmentLength;
    }
    /**
     * Get the length of the Trajectory.
     * @returns length of the Trajectory
     */ getLength() {
        return this._points.length * this._segmentLength;
    }
    /**
     * Append a new point to the Trajectory.
     * NOTE: This implementation has many allocations.
     * @param point point to append to the Trajectory
     */ add(point) {
        let numPoints = this._points.length;
        if (numPoints === 0) this._points.push(point.clone());
        else {
            const getT = ()=>this._segmentLength / (0, $ha1VO.Vector3).Distance(this._points[numPoints - 1], point);
            for(let t = getT(); t <= 1.0; t = getT()){
                const newPoint = this._points[numPoints - 1].scale(1.0 - t);
                point.scaleAndAddToRef(t, newPoint);
                this._points.push(newPoint);
                ++numPoints;
            }
        }
    }
    /**
     * Create a new Trajectory with a segment length chosen to make it
     * probable that the new Trajectory will have a specified number of
     * segments. This operation is imprecise.
     * @param targetResolution number of segments desired
     * @returns new Trajectory with approximately the requested number of segments
     */ resampleAtTargetResolution(targetResolution) {
        const resampled = new $5ac8434487adced3$export$95f98b41ccd47c3b(this.getLength() / targetResolution);
        this._points.forEach((pt)=>{
            resampled.add(pt);
        });
        return resampled;
    }
    /**
     * Convert Trajectory segments into tokenized representation. This
     * representation is an array of numbers where each nth number is the
     * index of the token which is most similar to the nth segment of the
     * Trajectory.
     * @param tokens list of vectors which serve as discrete tokens
     * @returns list of indices of most similar token per segment
     */ tokenize(tokens) {
        const tokenization = [];
        const segmentDir = new (0, $ha1VO.Vector3)();
        for(let idx = 2; idx < this._points.length; ++idx)if ($5ac8434487adced3$export$95f98b41ccd47c3b._TransformSegmentDirToRef(this._points[idx - 2], this._points[idx - 1], this._points[idx], segmentDir)) tokenization.push($5ac8434487adced3$export$95f98b41ccd47c3b._TokenizeSegment(segmentDir, tokens));
        return tokenization;
    }
    /**
     * Transform the rotation (i.e., direction) of a segment to isolate
     * the relative transformation represented by the segment. This operation
     * may or may not succeed due to singularities in the equations that define
     * motion relativity in this context.
     * @param priorVec the origin of the prior segment
     * @param fromVec the origin of the current segment
     * @param toVec the destination of the current segment
     * @param result reference to output variable
     * @returns whether or not transformation was successful
     */ static _TransformSegmentDirToRef(priorVec, fromVec, toVec, result) {
        const DOT_PRODUCT_SAMPLE_REJECTION_THRESHOLD = 0.98;
        fromVec.subtractToRef(priorVec, $5ac8434487adced3$export$95f98b41ccd47c3b._ForwardDir);
        $5ac8434487adced3$export$95f98b41ccd47c3b._ForwardDir.normalize();
        fromVec.scaleToRef(-1, $5ac8434487adced3$export$95f98b41ccd47c3b._InverseFromVec);
        $5ac8434487adced3$export$95f98b41ccd47c3b._InverseFromVec.normalize();
        if (Math.abs((0, $ha1VO.Vector3).Dot($5ac8434487adced3$export$95f98b41ccd47c3b._ForwardDir, $5ac8434487adced3$export$95f98b41ccd47c3b._InverseFromVec)) > DOT_PRODUCT_SAMPLE_REJECTION_THRESHOLD) return false;
        (0, $ha1VO.Vector3).CrossToRef($5ac8434487adced3$export$95f98b41ccd47c3b._ForwardDir, $5ac8434487adced3$export$95f98b41ccd47c3b._InverseFromVec, $5ac8434487adced3$export$95f98b41ccd47c3b._UpDir);
        $5ac8434487adced3$export$95f98b41ccd47c3b._UpDir.normalize();
        (0, $ha1VO.Matrix).LookAtLHToRef(priorVec, fromVec, $5ac8434487adced3$export$95f98b41ccd47c3b._UpDir, $5ac8434487adced3$export$95f98b41ccd47c3b._LookMatrix);
        toVec.subtractToRef(fromVec, $5ac8434487adced3$export$95f98b41ccd47c3b._FromToVec);
        $5ac8434487adced3$export$95f98b41ccd47c3b._FromToVec.normalize();
        (0, $ha1VO.Vector3).TransformNormalToRef($5ac8434487adced3$export$95f98b41ccd47c3b._FromToVec, $5ac8434487adced3$export$95f98b41ccd47c3b._LookMatrix, result);
        return true;
    }
    /**
     * Determine which token vector is most similar to the
     * segment vector.
     * @param segment segment vector
     * @param tokens token vector list
     * @returns index of the most similar token to the segment
     */ static _TokenizeSegment(segment, tokens) {
        $5ac8434487adced3$export$95f98b41ccd47c3b._BestMatch = 0;
        $5ac8434487adced3$export$95f98b41ccd47c3b._Score = (0, $ha1VO.Vector3).Dot(segment, tokens[0]);
        $5ac8434487adced3$export$95f98b41ccd47c3b._BestScore = $5ac8434487adced3$export$95f98b41ccd47c3b._Score;
        for(let idx = 1; idx < tokens.length; ++idx){
            $5ac8434487adced3$export$95f98b41ccd47c3b._Score = (0, $ha1VO.Vector3).Dot(segment, tokens[idx]);
            if ($5ac8434487adced3$export$95f98b41ccd47c3b._Score > $5ac8434487adced3$export$95f98b41ccd47c3b._BestScore) {
                $5ac8434487adced3$export$95f98b41ccd47c3b._BestMatch = idx;
                $5ac8434487adced3$export$95f98b41ccd47c3b._BestScore = $5ac8434487adced3$export$95f98b41ccd47c3b._Score;
            }
        }
        return $5ac8434487adced3$export$95f98b41ccd47c3b._BestMatch;
    }
}
$5ac8434487adced3$export$95f98b41ccd47c3b._ForwardDir = new (0, $ha1VO.Vector3)();
$5ac8434487adced3$export$95f98b41ccd47c3b._InverseFromVec = new (0, $ha1VO.Vector3)();
$5ac8434487adced3$export$95f98b41ccd47c3b._UpDir = new (0, $ha1VO.Vector3)();
$5ac8434487adced3$export$95f98b41ccd47c3b._FromToVec = new (0, $ha1VO.Vector3)();
$5ac8434487adced3$export$95f98b41ccd47c3b._LookMatrix = new (0, $ha1VO.Matrix)();
/**
 * Collection of vectors intended to be used as the basis of Trajectory
 * tokenization for Levenshtein distance comparison. Canonically, a
 * Vector3Alphabet will resemble a "spikeball" of vectors distributed
 * roughly evenly over the surface of the unit sphere.
 */ class $5ac8434487adced3$var$Vector3Alphabet {
    /**
     * Helper method to create new "spikeball" Vector3Alphabets. Uses a naive
     * optimize-from-random strategy to space points around the unit sphere
     * surface as a simple alternative to really doing the math to tile the
     * sphere.
     * @param alphabetSize size of the desired alphabet
     * @param iterations number of iterations over which to optimize the "spikeball"
     * @param startingStepSize distance factor to move points in early optimization iterations
     * @param endingStepSize distance factor to move points in late optimization iterations
     * @param fixedValues alphabet "characters" that are required and cannot be moved by optimization
     * @returns a new randomly generated and optimized Vector3Alphabet of the specified size
     */ static Generate(alphabetSize = 64, iterations = 256, startingStepSize = 0.1, endingStepSize = 0.001, fixedValues = []) {
        const EPSILON = 0.001;
        const EPSILON_SQUARED = EPSILON * EPSILON;
        const alphabet = new $5ac8434487adced3$var$Vector3Alphabet(alphabetSize);
        for(let idx = 0; idx < alphabetSize; ++idx){
            alphabet.chars[idx] = new (0, $ha1VO.Vector3)(Math.random() - 0.5, Math.random() - 0.5, Math.random() - 0.5);
            alphabet.chars[idx].normalize();
        }
        for(let idx = 0; idx < fixedValues.length; ++idx)alphabet.chars[idx].copyFrom(fixedValues[idx]);
        let stepSize;
        let distSq;
        const force = new (0, $ha1VO.Vector3)();
        const scratch = new (0, $ha1VO.Vector3)();
        const lerp = (l, r, t)=>(1.0 - t) * l + t * r;
        for(let iteration = 0; iteration < iterations; ++iteration){
            stepSize = lerp(startingStepSize, endingStepSize, iteration / (iterations - 1));
            for(let idx = fixedValues.length; idx < alphabet.chars.length; ++idx){
                force.copyFromFloats(0, 0, 0);
                alphabet.chars.forEach((pt)=>{
                    alphabet.chars[idx].subtractToRef(pt, scratch);
                    distSq = scratch.lengthSquared();
                    if (distSq > EPSILON_SQUARED) scratch.scaleAndAddToRef(1 / (scratch.lengthSquared() * distSq), force);
                });
                force.scaleInPlace(stepSize);
                alphabet.chars[idx].addInPlace(force);
                alphabet.chars[idx].normalize();
            }
        }
        return alphabet;
    }
    /**
     * Serialize to JSON.
     * @returns JSON serialization
     */ serialize() {
        return JSON.stringify(this.chars);
    }
    /**
     * Deserialize from JSON.
     * @param json JSON serialization
     * @returns deserialized Vector3Alphabet
     */ static Deserialize(json) {
        const jsonObject = JSON.parse(json);
        const alphabet = new $5ac8434487adced3$var$Vector3Alphabet(jsonObject.length);
        for(let idx = 0; idx < jsonObject.length; ++idx)alphabet.chars[idx] = new (0, $ha1VO.Vector3)(jsonObject[idx]["_x"], jsonObject[idx]["_y"], jsonObject[idx]["_z"]);
        return alphabet;
    }
    constructor(size){
        this.chars = new Array(size);
    }
}
/**
 * Class which formalizes the manner in which a Vector3Alphabet is used to tokenize and
 * describe a Trajectory. This class houses the functionality which determines what
 * attributes of Trajectories are and are not considered important, such as scale.
 */ class $5ac8434487adced3$var$TrajectoryDescriptor {
    /**
     * Serialize to JSON.
     * @returns JSON serialization
     */ serialize() {
        return JSON.stringify(this._sequences.map((sequence)=>sequence.serialize()));
    }
    /**
     * Deserialize from JSON string and Alphabet. This should be the same Alphabet
     * from which the descriptor was originally created, which must be serialized and
     * deserialized independently so that it can be passed in here.
     * @param json JSON serialization
     * @param alphabet Alphabet from which descriptor was originally created
     * @returns deserialized TrajectoryDescriptor
     */ static Deserialize(json, alphabet) {
        const descriptor = new $5ac8434487adced3$var$TrajectoryDescriptor();
        descriptor._sequences = JSON.parse(json).map((s)=>$5ac8434487adced3$var$Levenshtein.Sequence.Deserialize(s, alphabet));
        return descriptor;
    }
    /**
     * Create a new TrajectoryDescriptor to describe a provided Trajectory according
     * to the provided alphabets.
     * @param trajectory Trajectory to be described
     * @param vector3Alphabet Vector3Alphabet to be used to tokenize the Trajectory
     * @param levenshteinAlphabet Levenshtein.Alphabet to be used as basis for comparison with other descriptors
     * @returns TrajectoryDescriptor describing provided Trajectory
     */ static CreateFromTrajectory(trajectory, vector3Alphabet, levenshteinAlphabet) {
        return $5ac8434487adced3$var$TrajectoryDescriptor.CreateFromTokenizationPyramid($5ac8434487adced3$var$TrajectoryDescriptor._GetTokenizationPyramid(trajectory, vector3Alphabet), levenshteinAlphabet);
    }
    /**
     * Create a new TrajectoryDescriptor from a pre-existing pyramid of tokens.
     * NOTE: This function exists to support an outdated serialization mechanism and should
     * be deleted if it is no longer useful.
     * @param pyramid tokenization pyramid
     * @param levenshteinAlphabet Levenshtein.Alphabet to be uses as basis for comparison with other descriptors
     * @returns TrajectoryDescriptor describing the Trajectory from which the pyramid was built
     */ static CreateFromTokenizationPyramid(pyramid, levenshteinAlphabet) {
        const descriptor = new $5ac8434487adced3$var$TrajectoryDescriptor();
        descriptor._sequences = pyramid.map((tokens)=>new $5ac8434487adced3$var$Levenshtein.Sequence(tokens, levenshteinAlphabet));
        return descriptor;
    }
    constructor(){
        this._sequences = [];
    }
    /**
     * Create the tokenization pyramid for the provided Trajectory according to the given
     * Vector3Alphabet.
     * @param trajectory Trajectory to be tokenized
     * @param alphabet Vector3Alphabet containing tokens
     * @param targetResolution finest resolution of descriptor
     * @returns tokenization pyramid for Trajectory
     */ static _GetTokenizationPyramid(trajectory, alphabet, targetResolution = $5ac8434487adced3$var$TrajectoryDescriptor._FINEST_DESCRIPTOR_RESOLUTION) {
        const pyramid = [];
        for(let res = targetResolution; res > 4; res = Math.floor(res / 2))pyramid.push(trajectory.resampleAtTargetResolution(res).tokenize(alphabet.chars));
        return pyramid;
    }
    /**
     * Calculate a distance metric between this TrajectoryDescriptor and another. This is
     * essentially a similarity score and does not directly represent Euclidean distance,
     * edit distance, or any other formal distance metric.
     * @param other TrajectoryDescriptor from which to determine distance
     * @returns distance, a nonnegative similarity score where larger values indicate dissimilarity
     */ distance(other) {
        let totalDistance = 0;
        let weight;
        for(let idx = 0; idx < this._sequences.length; ++idx){
            weight = Math.pow(2, idx);
            totalDistance += weight * this._sequences[idx].distance(other._sequences[idx]);
        }
        return totalDistance;
    }
}
$5ac8434487adced3$var$TrajectoryDescriptor._FINEST_DESCRIPTOR_RESOLUTION = 32;
/**
 * A set of TrajectoryDescriptors defined to be "the same." This is essentially a helper
 * class to facilitate methods of Trajectory clustering.
 */ class $5ac8434487adced3$var$TrajectoryClass {
    /**
     * Serialize to JSON.
     * @returns JSON serialization
     */ serialize() {
        const jsonObject = {};
        jsonObject.descriptors = this._descriptors.map((desc)=>desc.serialize());
        jsonObject.centroidIdx = this._centroidIdx;
        jsonObject.averageDistance = this._averageDistance;
        return JSON.stringify(jsonObject);
    }
    /**
     * Deserialize from JSON string and Alphabet. This should be the same Alphabet
     * from which the descriptors were originally created, which must be serialized and
     * deserialized independently so that it can be passed in here.
     * @param json JSON string representation
     * @param alphabet Alphabet from which TrajectoryDescriptors were originally created
     * @returns deserialized TrajectoryDescriptor
     */ static Deserialize(json, alphabet) {
        const jsonObject = JSON.parse(json);
        const described = new $5ac8434487adced3$var$TrajectoryClass();
        described._descriptors = jsonObject.descriptors.map((s)=>$5ac8434487adced3$var$TrajectoryDescriptor.Deserialize(s, alphabet));
        described._centroidIdx = jsonObject.centroidIdx;
        described._averageDistance = jsonObject.averageDistance;
        return described;
    }
    /**
     * Create a new DescribedTrajectory.
     * @param descriptors currently-known TrajectoryDescriptors, if any
     */ constructor(descriptors = []){
        this._descriptors = descriptors;
        this._centroidIdx = -1;
        this._averageDistance = 0;
        this._refreshDescription();
    }
    /**
     * Add a new TrajectoryDescriptor to the list of descriptors known to describe
     * this same DescribedTrajectory.
     * @param descriptor descriptor to be added
     */ add(descriptor) {
        this._descriptors.push(descriptor);
        this._refreshDescription();
    }
    /**
     * Compute the cost, which is inversely related to the likelihood that the provided
     * TrajectoryDescriptor describes a Trajectory that is considered to be the same as
     * the class represented by this DescribedTrajectory.
     * @param descriptor the descriptor to be costed
     * @returns cost of the match, which is a nonnegative similarity metric where larger values indicate dissimilarity
     */ getMatchCost(descriptor) {
        return descriptor.distance(this._descriptors[this._centroidIdx]) / this._averageDistance;
    }
    /**
     * Compute the minimum distance between the queried TrajectoryDescriptor and a
     * descriptor which is a member of this collection. This is an alternative way of
     * conceptualizing match cost from getMatchCost(), and it serves a different function.
     * @param descriptor the descriptor to find the minimum distance to
     * @returns minimum descriptor distance to a member descriptor of this DescribedTrajectory
     */ getMatchMinimumDistance(descriptor) {
        return Math.min(...this._descriptors.map((desc)=>desc.distance(descriptor)));
    }
    /**
     * Refreshes the internal representation of this DescribedTrajectory.
     */ _refreshDescription() {
        this._centroidIdx = -1;
        let sum;
        const distances = this._descriptors.map((a)=>{
            sum = 0;
            this._descriptors.forEach((b)=>{
                sum += a.distance(b);
            });
            return sum;
        });
        for(let idx = 0; idx < distances.length; ++idx)if (this._centroidIdx < 0 || distances[idx] < distances[this._centroidIdx]) this._centroidIdx = idx;
        this._averageDistance = 0;
        this._descriptors.forEach((desc)=>{
            this._averageDistance += desc.distance(this._descriptors[this._centroidIdx]);
        });
        if (this._descriptors.length > 0) this._averageDistance = Math.max(this._averageDistance / this._descriptors.length, $5ac8434487adced3$var$TrajectoryClass._MIN_AVERAGE_DISTANCE);
    }
}
$5ac8434487adced3$var$TrajectoryClass._MIN_AVERAGE_DISTANCE = 1;
class $5ac8434487adced3$export$8ab9ea6d1744c61e {
    /**
     * Serialize to JSON.
     * @returns JSON serialization
     */ serialize() {
        const jsonObject = {};
        jsonObject.maximumAllowableMatchCost = this._maximumAllowableMatchCost;
        jsonObject.vector3Alphabet = this._vector3Alphabet.serialize();
        jsonObject.levenshteinAlphabet = this._levenshteinAlphabet.serialize();
        jsonObject.nameToDescribedTrajectory = [];
        this._nameToDescribedTrajectory.forEach((described, name)=>{
            jsonObject.nameToDescribedTrajectory.push(name);
            jsonObject.nameToDescribedTrajectory.push(described.serialize());
        });
        return JSON.stringify(jsonObject);
    }
    /**
     * Deserialize from JSON.
     * @param json JSON serialization
     * @returns deserialized TrajectorySet
     */ static Deserialize(json) {
        const jsonObject = JSON.parse(json);
        const classifier = new $5ac8434487adced3$export$8ab9ea6d1744c61e();
        classifier._maximumAllowableMatchCost = jsonObject.maximumAllowableMatchCost;
        classifier._vector3Alphabet = $5ac8434487adced3$var$Vector3Alphabet.Deserialize(jsonObject.vector3Alphabet);
        classifier._levenshteinAlphabet = $5ac8434487adced3$var$Levenshtein.Alphabet.Deserialize(jsonObject.levenshteinAlphabet);
        for(let idx = 0; idx < jsonObject.nameToDescribedTrajectory.length; idx += 2)classifier._nameToDescribedTrajectory.set(jsonObject.nameToDescribedTrajectory[idx], $5ac8434487adced3$var$TrajectoryClass.Deserialize(jsonObject.nameToDescribedTrajectory[idx + 1], classifier._levenshteinAlphabet));
        return classifier;
    }
    /**
     * Initialize a new empty TrajectorySet with auto-generated Alphabets.
     * VERY naive, need to be generating these things from known
     * sets. Better version later, probably eliminating this one.
     * @returns auto-generated TrajectorySet
     */ static Generate() {
        const vecs = $5ac8434487adced3$var$Vector3Alphabet.Generate(64, 256, 0.1, 0.001, [
            (0, $ha1VO.Vector3).Forward()
        ]);
        const charIdxs = new Array(vecs.chars.length);
        for(let idx = 0; idx < charIdxs.length; ++idx)charIdxs[idx] = idx;
        const alphabet = new $5ac8434487adced3$var$Levenshtein.Alphabet(charIdxs, (idx)=>idx === 0 ? 0 : 1, (idx)=>idx === 0 ? 0 : 1, (a, b)=>Math.min(1 - (0, $ha1VO.Vector3).Dot(vecs.chars[a], vecs.chars[b]), 1));
        const trajectorySet = new $5ac8434487adced3$export$8ab9ea6d1744c61e();
        trajectorySet._vector3Alphabet = vecs;
        trajectorySet._levenshteinAlphabet = alphabet;
        return trajectorySet;
    }
    constructor(){
        this._maximumAllowableMatchCost = 4;
        this._nameToDescribedTrajectory = new Map();
    }
    /**
     * Add a new Trajectory to the set with a given name.
     * @param trajectory new Trajectory to be added
     * @param classification name to which to add the Trajectory
     */ addTrajectoryToClassification(trajectory, classification) {
        if (!this._nameToDescribedTrajectory.has(classification)) this._nameToDescribedTrajectory.set(classification, new $5ac8434487adced3$var$TrajectoryClass());
        this._nameToDescribedTrajectory.get(classification).add($5ac8434487adced3$var$TrajectoryDescriptor.CreateFromTrajectory(trajectory, this._vector3Alphabet, this._levenshteinAlphabet));
    }
    /**
     * Remove a known named trajectory and all Trajectories associated with it.
     * @param classification name to remove
     * @returns whether anything was removed
     */ deleteClassification(classification) {
        return this._nameToDescribedTrajectory.delete(classification);
    }
    /**
     * Attempt to recognize a Trajectory from among all the classifications
     * already known to the classifier.
     * @param trajectory Trajectory to be recognized
     * @returns classification of Trajectory if recognized, null otherwise
     */ classifyTrajectory(trajectory) {
        const descriptor = $5ac8434487adced3$var$TrajectoryDescriptor.CreateFromTrajectory(trajectory, this._vector3Alphabet, this._levenshteinAlphabet);
        const allowableMatches = [];
        this._nameToDescribedTrajectory.forEach((trajectoryClass, classification)=>{
            if (trajectoryClass.getMatchCost(descriptor) < this._maximumAllowableMatchCost) allowableMatches.push(classification);
        });
        if (allowableMatches.length === 0) return null;
        let bestIdx = 0;
        let bestMatch = this._nameToDescribedTrajectory.get(allowableMatches[bestIdx]).getMatchMinimumDistance(descriptor);
        let match;
        for(let idx = 0; idx < allowableMatches.length; ++idx){
            match = this._nameToDescribedTrajectory.get(allowableMatches[idx]).getMatchMinimumDistance(descriptor);
            if (match < bestMatch) {
                bestMatch = match;
                bestIdx = idx;
            }
        }
        return allowableMatches[bestIdx];
    }
}

});

parcelRegister("2LOE5", function(module, exports) {

$parcel$export(module.exports, "Reflector", () => $204741b15d4663f0$export$edf083caefbff926);

var $kVtWi = parcelRequire("kVtWi");

var $2sJhC = parcelRequire("2sJhC");
class $204741b15d4663f0$export$edf083caefbff926 {
    /**
     * Constructs a reflector object.
     * @param scene The scene to use
     * @param hostname The hostname of the reflector bridge
     * @param port The port of the reflector bridge
     */ constructor(scene, hostname, port){
        this._scene = scene;
        (0, $kVtWi.Logger).Log(`[Reflector] Connecting to ws://${hostname}:${port}`);
        this._webSocket = new WebSocket(`ws://${hostname}:${port}`);
        this._webSocket.onmessage = (event)=>{
            const message = event.data;
            if (message.startsWith($204741b15d4663f0$export$edf083caefbff926._SERVER_PREFIX)) {
                const serverMessage = message.substr($204741b15d4663f0$export$edf083caefbff926._SERVER_PREFIX.length);
                (0, $kVtWi.Logger).Log(`[Reflector] Received server message: ${serverMessage.substr(0, 64)}`);
                this._handleServerMessage(serverMessage);
                return;
            } else {
                (0, $kVtWi.Logger).Log(`[Reflector] Received client message: ${message.substr(0, 64)}`);
                this._handleClientMessage();
            }
        };
        this._webSocket.onclose = (event)=>{
            (0, $kVtWi.Logger).Log(`[Reflector] Disconnected ${event.code} ${event.reason}`);
        };
    }
    /**
     * Closes the reflector connection
     */ close() {
        this._webSocket.close();
    }
    _handleServerMessage(message) {
        switch(message){
            case "connected":
                (0, $2sJhC.SceneSerializer).SerializeAsync(this._scene).then((serialized)=>{
                    this._webSocket.send(`load|${JSON.stringify(serialized)}`);
                });
                break;
        }
    }
    _handleClientMessage() {
    // do nothing
    }
}
$204741b15d4663f0$export$edf083caefbff926._SERVER_PREFIX = "$$";

});

parcelRegister("7Aolp", function(module, exports) {

$parcel$export(module.exports, "PressureObserverWrapper", () => $585ec772defa098b$export$b4bf6762708814df);

var $diGQf = parcelRequire("diGQf");
class $585ec772defa098b$export$b4bf6762708814df {
    /**
     * A pressure observer will call this callback, whenever these thresholds are met.
     * @param options An object containing the thresholds used to decide what value to to return for each update property (average of start and end of a threshold boundary).
     */ constructor(options){
        this._observer = null;
        this._currentState = [];
        /**
         * An event triggered when the cpu usage/speed meets certain thresholds.
         * Note: pressure is an experimental API.
         */ this.onPressureChanged = new (0, $diGQf.Observable)();
        if ($585ec772defa098b$export$b4bf6762708814df.IsAvailable) this._observer = new PressureObserver((update)=>{
            this._currentState = update;
            this.onPressureChanged.notifyObservers(update);
        }, options);
    }
    /**
     * Returns true if PressureObserver is available for use, false otherwise.
     */ static get IsAvailable() {
        return typeof PressureObserver !== "undefined" && PressureObserver.supportedSources.includes("cpu");
    }
    /**
     * Method that must be called to begin observing changes, and triggering callbacks.
     * @param source defines the source to observe
     */ observe(source) {
        try {
            this._observer?.observe(source);
            this.onPressureChanged.notifyObservers(this._currentState);
        } catch  {
        // Ignore error
        }
    }
    /**
     * Method that must be called to stop observing changes and triggering callbacks (cleanup function).
     * @param source defines the source to unobserve
     */ unobserve(source) {
        try {
            this._observer?.unobserve(source);
        } catch  {
        // Ignore error
        }
    }
    /**
     * Release the associated resources.
     */ dispose() {
        this._observer?.disconnect();
        this._observer = null;
        this.onPressureChanged.clear();
    }
}

});

parcelRegister("8ImbE", function(module, exports) {
/* eslint-disable import/export */ 
var $5TI5j = parcelRequire("5TI5j");

var $bNZOS = parcelRequire("bNZOS");

var $avzi3 = parcelRequire("avzi3");

var $84gcq = parcelRequire("84gcq");
$parcel$exportWildcard(module.exports, $5TI5j);
$parcel$exportWildcard(module.exports, $bNZOS);
$parcel$exportWildcard(module.exports, $avzi3);
$parcel$exportWildcard(module.exports, $84gcq);

});
parcelRegister("5TI5j", function(module, exports) {

$parcel$export(module.exports, "PerformanceViewerCollector", () => $44b449171b086f67$export$3f856416bc864c67);

var $diGQf = parcelRequire("diGQf");

var $blHSI = parcelRequire("blHSI");

var $bOhSV = parcelRequire("bOhSV");

var $avzi3 = parcelRequire("avzi3");
// the initial size of our array, should be a multiple of two!
const $44b449171b086f67$var$InitialArraySize = 1800;
// three octets in a hexcode. #[AA][BB][CC], i.e. 24 bits of data.
const $44b449171b086f67$var$NumberOfBitsInHexcode = 24;
// Allows single numeral hex numbers to be appended by a 0.
const $44b449171b086f67$var$HexPadding = "0";
// header for the timestamp column
const $44b449171b086f67$var$TimestampColHeader = "timestamp";
// header for the numPoints column
const $44b449171b086f67$var$NumPointsColHeader = "numPoints";
// regex to capture all carriage returns in the string.
const $44b449171b086f67$var$CarriageReturnRegex = /\r/g;
// string to use as separator when exporting extra information along with the dataset id
const $44b449171b086f67$var$ExportedDataSeparator = "@";
class $44b449171b086f67$export$3f856416bc864c67 {
    /**
     * The offset for when actual data values start appearing inside a slice.
     */ static get SliceDataOffset() {
        return 2;
    }
    /**
     * The offset for the value of the number of points inside a slice.
     */ static get NumberOfPointsOffset() {
        return 1;
    }
    /**
     * Handles the creation of a performance viewer collector.
     * @param _scene the scene to collect on.
     * @param _enabledStrategyCallbacks the list of data to collect with callbacks for initialization purposes.
     */ constructor(_scene, _enabledStrategyCallbacks){
        this._scene = _scene;
        /**
         * Collects data for every dataset by using the appropriate strategy. This is called every frame.
         * This method will then notify all observers with the latest slice.
         */ this._collectDataAtFrame = ()=>{
            const timestamp = (0, $blHSI.PrecisionDate).Now - this._startingTimestamp;
            const numPoints = this.datasets.ids.length;
            // add the starting index for the slice
            const numberOfIndices = this.datasets.startingIndices.itemLength;
            let startingIndex = 0;
            if (numberOfIndices > 0) {
                const previousStartingIndex = this.datasets.startingIndices.at(numberOfIndices - 1);
                startingIndex = previousStartingIndex + this.datasets.data.at(previousStartingIndex + $44b449171b086f67$export$3f856416bc864c67.NumberOfPointsOffset) + $44b449171b086f67$export$3f856416bc864c67.SliceDataOffset;
            }
            this.datasets.startingIndices.push(startingIndex);
            // add the first 2 items in our slice.
            this.datasets.data.push(timestamp);
            this.datasets.data.push(numPoints);
            // add the values inside the slice.
            this.datasets.ids.forEach((id)=>{
                const strategy = this._strategies.get(id);
                if (!strategy) return;
                this.datasets.data.push(strategy.getData());
            });
            if (this.datasetObservable.hasObservers()) {
                const slice = [
                    timestamp,
                    numPoints
                ];
                for(let i = 0; i < numPoints; i++)slice.push(this.datasets.data.at(startingIndex + $44b449171b086f67$export$3f856416bc864c67.SliceDataOffset + i));
                this.datasetObservable.notifyObservers(slice);
            }
        };
        this.datasets = {
            ids: [],
            data: new (0, $avzi3.DynamicFloat32Array)($44b449171b086f67$var$InitialArraySize),
            startingIndices: new (0, $avzi3.DynamicFloat32Array)($44b449171b086f67$var$InitialArraySize)
        };
        this._strategies = new Map();
        this._datasetMeta = new Map();
        this._eventRestoreSet = new Set();
        this._customEventObservable = new (0, $diGQf.Observable)();
        this.datasetObservable = new (0, $diGQf.Observable)();
        this.metadataObservable = new (0, $diGQf.Observable)((observer)=>observer.callback(this._datasetMeta, new (0, $diGQf.EventState)(0)));
        if (_enabledStrategyCallbacks) this.addCollectionStrategies(..._enabledStrategyCallbacks);
    }
    /**
     * Registers a custom string event which will be callable via sendEvent. This method returns an event object which will contain the id of the event.
     * The user can set a value optionally, which will be used in the sendEvent method. If the value is set, we will record this value at the end of each frame,
     * if not we will increment our counter and record the value of the counter at the end of each frame. The value recorded is 0 if no sendEvent method is called, within a frame.
     * @param name The name of the event to register
     * @param forceUpdate if the code should force add an event, and replace the last one.
     * @param category the category for that event
     * @returns The event registered, used in sendEvent
     */ registerEvent(name, forceUpdate, category) {
        if (this._strategies.has(name) && !forceUpdate) return;
        if (this._strategies.has(name) && forceUpdate) {
            this._strategies.get(name)?.dispose();
            this._strategies.delete(name);
        }
        const strategy = (scene)=>{
            let counter = 0;
            let value = 0;
            const afterRenderObserver = scene.onAfterRenderObservable.add(()=>{
                value = counter;
                counter = 0;
            });
            const stringObserver = this._customEventObservable.add((eventVal)=>{
                if (name !== eventVal.name) return;
                if (eventVal.value !== undefined) counter = eventVal.value;
                else counter++;
            });
            return {
                id: name,
                getData: ()=>value,
                dispose: ()=>{
                    scene.onAfterRenderObservable.remove(afterRenderObserver);
                    this._customEventObservable.remove(stringObserver);
                }
            };
        };
        const event = {
            name: name
        };
        this._eventRestoreSet.add(name);
        this.addCollectionStrategies({
            strategyCallback: strategy,
            category: category
        });
        return event;
    }
    /**
     * Lets the perf collector handle an event, occurences or event value depending on if the event.value params is set.
     * @param event the event to handle an occurence for
     */ sendEvent(event) {
        this._customEventObservable.notifyObservers(event);
    }
    /**
     * This event restores all custom string events if necessary.
     */ _restoreStringEvents() {
        if (this._eventRestoreSet.size !== this._customEventObservable.observers.length) this._eventRestoreSet.forEach((event)=>{
            this.registerEvent(event, true);
        });
    }
    /**
     * This method adds additional collection strategies for data collection purposes.
     * @param strategyCallbacks the list of data to collect with callbacks.
     */ addCollectionStrategies(...strategyCallbacks) {
        // eslint-disable-next-line prefer-const
        for (let { strategyCallback: strategyCallback, category: category, hidden: hidden } of strategyCallbacks){
            const strategy = strategyCallback(this._scene);
            if (this._strategies.has(strategy.id)) {
                strategy.dispose();
                continue;
            }
            this.datasets.ids.push(strategy.id);
            if (category) category = category.replace(new RegExp($44b449171b086f67$var$ExportedDataSeparator, "g"), "");
            this._datasetMeta.set(strategy.id, {
                color: this._getHexColorFromId(strategy.id),
                category: category,
                hidden: hidden
            });
            this._strategies.set(strategy.id, strategy);
        }
        this.metadataObservable.notifyObservers(this._datasetMeta);
    }
    /**
     * Gets a 6 character hexcode representing the colour from a passed in string.
     * @param id the string to get a hex code for.
     * @returns a hexcode hashed from the id.
     */ _getHexColorFromId(id) {
        // this first bit is just a known way of hashing a string.
        let hash = 0;
        for(let i = 0; i < id.length; i++)// (hash << 5) - hash is the same as hash * 31
        hash = id.charCodeAt(i) + ((hash << 5) - hash);
        // then we build the string octet by octet.
        let hex = "#";
        for(let i = 0; i < $44b449171b086f67$var$NumberOfBitsInHexcode; i += 8){
            const octet = hash >> i & 0xff;
            hex += ($44b449171b086f67$var$HexPadding + octet.toString(16)).substr(-2);
        }
        return hex;
    }
    /**
     * Collects and then sends the latest slice to any observers by using the appropriate strategy when the user wants.
     * The slice will be of the form [timestamp, numberOfPoints, value1, value2...]
     * This method does not add onto the collected data accessible via the datasets variable.
     */ getCurrentSlice() {
        const timestamp = (0, $blHSI.PrecisionDate).Now - this._startingTimestamp;
        const numPoints = this.datasets.ids.length;
        const slice = [
            timestamp,
            numPoints
        ];
        // add the values inside the slice.
        this.datasets.ids.forEach((id)=>{
            const strategy = this._strategies.get(id);
            if (!strategy) return;
            if (this.datasetObservable.hasObservers()) slice.push(strategy.getData());
        });
        if (this.datasetObservable.hasObservers()) this.datasetObservable.notifyObservers(slice);
    }
    /**
     * Updates a property for a dataset's metadata with the value provided.
     * @param id the id of the dataset which needs its metadata updated.
     * @param prop the property to update.
     * @param value the value to update the property with.
     */ updateMetadata(id, prop, value) {
        const meta = this._datasetMeta.get(id);
        if (!meta) return;
        meta[prop] = value;
        this.metadataObservable.notifyObservers(this._datasetMeta);
    }
    /**
     * Completely clear, data, ids, and strategies saved to this performance collector.
     * @param preserveStringEventsRestore if it should preserve the string events, by default will clear string events registered when called.
     */ clear(preserveStringEventsRestore) {
        this.datasets.data = new (0, $avzi3.DynamicFloat32Array)($44b449171b086f67$var$InitialArraySize);
        this.datasets.ids.length = 0;
        this.datasets.startingIndices = new (0, $avzi3.DynamicFloat32Array)($44b449171b086f67$var$InitialArraySize);
        this._datasetMeta.clear();
        this._strategies.forEach((strategy)=>strategy.dispose());
        this._strategies.clear();
        if (!preserveStringEventsRestore) this._eventRestoreSet.clear();
        this._hasLoadedData = false;
    }
    /**
     * Accessor which lets the caller know if the performance collector has data loaded from a file or not!
     * Call clear() to reset this value.
     * @returns true if the data is loaded from a file, false otherwise.
     */ get hasLoadedData() {
        return this._hasLoadedData;
    }
    /**
     * Given a string containing file data, this function parses the file data into the datasets object.
     * It returns a boolean to indicate if this object was successfully loaded with the data.
     * @param data string content representing the file data.
     * @param keepDatasetMeta if it should use reuse the existing dataset metadata
     * @returns true if the data was successfully loaded, false otherwise.
     */ loadFromFileData(data, keepDatasetMeta) {
        const lines = data.replace($44b449171b086f67$var$CarriageReturnRegex, "").split("\n").map((line)=>line.split(",").filter((s)=>s.length > 0)).filter((line)=>line.length > 0);
        const timestampIndex = 0;
        const numPointsIndex = $44b449171b086f67$export$3f856416bc864c67.NumberOfPointsOffset;
        if (lines.length < 2) return false;
        const parsedDatasets = {
            ids: [],
            data: new (0, $avzi3.DynamicFloat32Array)($44b449171b086f67$var$InitialArraySize),
            startingIndices: new (0, $avzi3.DynamicFloat32Array)($44b449171b086f67$var$InitialArraySize)
        };
        // parse first line separately to populate ids!
        const [firstLine, ...dataLines] = lines;
        // make sure we have the correct beginning headers
        if (firstLine.length < 2 || firstLine[timestampIndex] !== $44b449171b086f67$var$TimestampColHeader || firstLine[numPointsIndex] !== $44b449171b086f67$var$NumPointsColHeader) return false;
        const idCategoryMap = new Map();
        // populate the ids.
        for(let i = $44b449171b086f67$export$3f856416bc864c67.SliceDataOffset; i < firstLine.length; i++){
            const [id, category] = firstLine[i].split($44b449171b086f67$var$ExportedDataSeparator);
            parsedDatasets.ids.push(id);
            idCategoryMap.set(id, category);
        }
        let startingIndex = 0;
        for (const line of dataLines){
            if (line.length < 2) return false;
            const timestamp = parseFloat(line[timestampIndex]);
            const numPoints = parseInt(line[numPointsIndex]);
            if (isNaN(numPoints) || isNaN(timestamp)) return false;
            parsedDatasets.data.push(timestamp);
            parsedDatasets.data.push(numPoints);
            if (numPoints + $44b449171b086f67$export$3f856416bc864c67.SliceDataOffset !== line.length) return false;
            for(let i = $44b449171b086f67$export$3f856416bc864c67.SliceDataOffset; i < line.length; i++){
                const val = parseFloat(line[i]);
                if (isNaN(val)) return false;
                parsedDatasets.data.push(val);
            }
            parsedDatasets.startingIndices.push(startingIndex);
            startingIndex += line.length;
        }
        this.datasets.ids = parsedDatasets.ids;
        this.datasets.data = parsedDatasets.data;
        this.datasets.startingIndices = parsedDatasets.startingIndices;
        if (!keepDatasetMeta) this._datasetMeta.clear();
        this._strategies.forEach((strategy)=>strategy.dispose());
        this._strategies.clear();
        // populate metadata.
        if (!keepDatasetMeta) for (const id of this.datasets.ids){
            const category = idCategoryMap.get(id);
            this._datasetMeta.set(id, {
                category: category,
                color: this._getHexColorFromId(id)
            });
        }
        this.metadataObservable.notifyObservers(this._datasetMeta);
        this._hasLoadedData = true;
        return true;
    }
    /**
     * Exports the datasets inside of the collector to a csv.
     */ exportDataToCsv() {
        let csvContent = "";
        // create the header line.
        csvContent += `${$44b449171b086f67$var$TimestampColHeader},${$44b449171b086f67$var$NumPointsColHeader}`;
        for(let i = 0; i < this.datasets.ids.length; i++){
            csvContent += `,${this.datasets.ids[i]}`;
            if (this._datasetMeta) {
                const meta = this._datasetMeta.get(this.datasets.ids[i]);
                if (meta?.category) csvContent += `${$44b449171b086f67$var$ExportedDataSeparator}${meta.category}`;
            }
        }
        csvContent += "\n";
        // create the data lines
        for(let i = 0; i < this.datasets.startingIndices.itemLength; i++){
            const startingIndex = this.datasets.startingIndices.at(i);
            const timestamp = this.datasets.data.at(startingIndex);
            const numPoints = this.datasets.data.at(startingIndex + $44b449171b086f67$export$3f856416bc864c67.NumberOfPointsOffset);
            csvContent += `${timestamp},${numPoints}`;
            for(let offset = 0; offset < numPoints; offset++)csvContent += `,${this.datasets.data.at(startingIndex + $44b449171b086f67$export$3f856416bc864c67.SliceDataOffset + offset)}`;
            // add extra commas.
            for(let diff = 0; diff < this.datasets.ids.length - numPoints; diff++)csvContent += ",";
            csvContent += "\n";
        }
        const fileName = `${new Date().toISOString()}-perfdata.csv`;
        (0, $bOhSV.Tools).Download(new Blob([
            csvContent
        ], {
            type: "text/csv"
        }), fileName);
    }
    /**
     * Starts the realtime collection of data.
     * @param shouldPreserve optional boolean param, if set will preserve the dataset between calls of start.
     */ start(shouldPreserve) {
        if (!shouldPreserve) {
            this.datasets.data = new (0, $avzi3.DynamicFloat32Array)($44b449171b086f67$var$InitialArraySize);
            this.datasets.startingIndices = new (0, $avzi3.DynamicFloat32Array)($44b449171b086f67$var$InitialArraySize);
            this._startingTimestamp = (0, $blHSI.PrecisionDate).Now;
        } else if (this._startingTimestamp === undefined) this._startingTimestamp = (0, $blHSI.PrecisionDate).Now;
        this._scene.onAfterRenderObservable.add(this._collectDataAtFrame);
        this._restoreStringEvents();
        this._isStarted = true;
    }
    /**
     * Stops the collection of data.
     */ stop() {
        this._scene.onAfterRenderObservable.removeCallback(this._collectDataAtFrame);
        this._isStarted = false;
    }
    /**
     * Returns if the perf collector has been started or not.
     */ get isStarted() {
        return this._isStarted;
    }
    /**
     * Disposes of the object
     */ dispose() {
        this._scene.onAfterRenderObservable.removeCallback(this._collectDataAtFrame);
        this._datasetMeta.clear();
        this._strategies.forEach((strategy)=>{
            strategy.dispose();
        });
        this.datasetObservable.clear();
        this.metadataObservable.clear();
        this._isStarted = false;
        this.datasets = null;
    }
}

});
parcelRegister("avzi3", function(module, exports) {

$parcel$export(module.exports, "DynamicFloat32Array", () => $7a682c858e423799$export$771ec8318862205b);
const $7a682c858e423799$var$growthFactor = 1.5;
class $7a682c858e423799$export$771ec8318862205b {
    /**
     * Creates a new DynamicFloat32Array with the desired item capacity.
     * @param itemCapacity The initial item capacity you would like to set for the array.
     */ constructor(itemCapacity){
        this._view = new Float32Array(itemCapacity);
        this._itemLength = 0;
    }
    /**
     * The number of items currently in the array.
     */ get itemLength() {
        return this._itemLength;
    }
    /**
     * Gets value at index, NaN if no such index exists.
     * @param index the index to get the value at.
     * @returns the value at the index provided.
     */ at(index) {
        if (index < 0 || index >= this._itemLength) return NaN;
        return this._view[index];
    }
    /**
     * Gets a view of the original array from start to end (exclusive of end).
     * @param start starting index.
     * @param end ending index.
     * @returns a subarray of the original array.
     */ subarray(start, end) {
        if (start >= end || start < 0) return new Float32Array(0);
        if (end > this._itemLength) end = this._itemLength;
        return this._view.subarray(start, end);
    }
    /**
     * Pushes items to the end of the array.
     * @param item The item to push into the array.
     */ push(item) {
        this._view[this._itemLength] = item;
        this._itemLength++;
        if (this._itemLength >= this._view.length) this._growArray();
    }
    /**
     * Grows the array by the growth factor when necessary.
     */ _growArray() {
        const newCapacity = Math.floor(this._view.length * $7a682c858e423799$var$growthFactor);
        const view = new Float32Array(newCapacity);
        view.set(this._view);
        this._view = view;
    }
}

});


parcelRegister("bNZOS", function(module, exports) {

$parcel$export(module.exports, "PerfCollectionStrategy", () => $898439677a98c430$export$51933d762ebc794a);

var $k4hBS = parcelRequire("k4hBS");

var $blHSI = parcelRequire("blHSI");

var $gGWXq = parcelRequire("gGWXq");

var $7Aolp = parcelRequire("7Aolp");
// Dispose which does nothing.
const $898439677a98c430$var$defaultDisposeImpl = ()=>{};
class $898439677a98c430$export$51933d762ebc794a {
    /**
     * Gets the initializer for the strategy used for collection of fps metrics
     * @returns the initializer for the fps strategy
     */ static FpsStrategy() {
        return (scene)=>{
            const engine = scene.getEngine();
            return {
                id: "FPS",
                getData: ()=>engine.getFps(),
                dispose: $898439677a98c430$var$defaultDisposeImpl
            };
        };
    }
    /**
     * Gets the initializer for the strategy used for collection of thermal utilization metrics.
     * Needs the experimental pressure API.
     * @returns the initializer for the thermal utilization strategy
     */ static ThermalStrategy() {
        return this._PressureStrategy("Thermal utilization", "thermal");
    }
    /**
     * Gets the initializer for the strategy used for collection of power supply utilization metrics.
     * Needs the experimental pressure API.
     * @returns the initializer for the power supply utilization strategy
     */ static PowerSupplyStrategy() {
        return this._PressureStrategy("Power supply utilization", "power-supply");
    }
    /**
     * Gets the initializer for the strategy used for collection of pressure metrics.
     * Needs the experimental pressure API.
     * @returns the initializer for the pressure strategy
     */ static PressureStrategy() {
        return this._PressureStrategy("Pressure");
    }
    static _PressureStrategy(name, factor = null) {
        return ()=>{
            let value = 0;
            const wrapper = new (0, $7Aolp.PressureObserverWrapper)();
            wrapper.observe("cpu");
            wrapper.onPressureChanged.add((update)=>{
                for (const record of update)if (factor && record.factors.includes(factor) || !factor && (record.factors?.length ?? 0) === 0) // Let s consider each step being 25% of the total pressure.
                switch(record.state){
                    case "nominal":
                        value = 0;
                        break;
                    case "fair":
                        value = 0.25;
                        break;
                    case "serious":
                        value = 0.5;
                        break;
                    case "critical":
                        value = 1;
                        break;
                }
            });
            return {
                id: name,
                getData: ()=>value,
                dispose: ()=>wrapper.dispose()
            };
        };
    }
    /**
     * Gets the initializer for the strategy used for collection of total meshes metrics.
     * @returns the initializer for the total meshes strategy
     */ static TotalMeshesStrategy() {
        return (scene)=>{
            return {
                id: "Total meshes",
                getData: ()=>scene.meshes.length,
                dispose: $898439677a98c430$var$defaultDisposeImpl
            };
        };
    }
    /**
     * Gets the initializer for the strategy used for collection of active meshes metrics.
     * @returns the initializer for the active meshes strategy
     */ static ActiveMeshesStrategy() {
        return (scene)=>{
            return {
                id: "Active meshes",
                getData: ()=>scene.getActiveMeshes().length,
                dispose: $898439677a98c430$var$defaultDisposeImpl
            };
        };
    }
    /**
     * Gets the initializer for the strategy used for collection of active indices metrics.
     * @returns the initializer for the active indices strategy
     */ static ActiveIndicesStrategy() {
        return (scene)=>{
            return {
                id: "Active indices",
                getData: ()=>scene.getActiveIndices(),
                dispose: $898439677a98c430$var$defaultDisposeImpl
            };
        };
    }
    /**
     * Gets the initializer for the strategy used for collection of active faces metrics.
     * @returns the initializer for the active faces strategy
     */ static ActiveFacesStrategy() {
        return (scene)=>{
            return {
                id: "Active faces",
                getData: ()=>scene.getActiveIndices() / 3,
                dispose: $898439677a98c430$var$defaultDisposeImpl
            };
        };
    }
    /**
     * Gets the initializer for the strategy used for collection of active bones metrics.
     * @returns the initializer for the active bones strategy
     */ static ActiveBonesStrategy() {
        return (scene)=>{
            return {
                id: "Active bones",
                getData: ()=>scene.getActiveBones(),
                dispose: $898439677a98c430$var$defaultDisposeImpl
            };
        };
    }
    /**
     * Gets the initializer for the strategy used for collection of active particles metrics.
     * @returns the initializer for the active particles strategy
     */ static ActiveParticlesStrategy() {
        return (scene)=>{
            return {
                id: "Active particles",
                getData: ()=>scene.getActiveParticles(),
                dispose: $898439677a98c430$var$defaultDisposeImpl
            };
        };
    }
    /**
     * Gets the initializer for the strategy used for collection of draw calls metrics.
     * @returns the initializer for the draw calls strategy
     */ static DrawCallsStrategy() {
        return (scene)=>{
            let drawCalls = 0;
            const onBeforeAnimationsObserver = scene.onBeforeAnimationsObservable.add(()=>{
                scene.getEngine()._drawCalls.fetchNewFrame();
            });
            const onAfterRenderObserver = scene.onAfterRenderObservable.add(()=>{
                drawCalls = scene.getEngine()._drawCalls.current;
            });
            return {
                id: "Draw calls",
                getData: ()=>drawCalls,
                dispose: ()=>{
                    scene.onBeforeAnimationsObservable.remove(onBeforeAnimationsObserver);
                    scene.onAfterRenderObservable.remove(onAfterRenderObserver);
                }
            };
        };
    }
    /**
     * Gets the initializer for the strategy used for collection of total lights metrics.
     * @returns the initializer for the total lights strategy
     */ static TotalLightsStrategy() {
        return (scene)=>{
            return {
                id: "Total lights",
                getData: ()=>scene.lights.length,
                dispose: $898439677a98c430$var$defaultDisposeImpl
            };
        };
    }
    /**
     * Gets the initializer for the strategy used for collection of total vertices metrics.
     * @returns the initializer for the total vertices strategy
     */ static TotalVerticesStrategy() {
        return (scene)=>{
            return {
                id: "Total vertices",
                getData: ()=>scene.getTotalVertices(),
                dispose: $898439677a98c430$var$defaultDisposeImpl
            };
        };
    }
    /**
     * Gets the initializer for the strategy used for collection of total materials metrics.
     * @returns the initializer for the total materials strategy
     */ static TotalMaterialsStrategy() {
        return (scene)=>{
            return {
                id: "Total materials",
                getData: ()=>scene.materials.length,
                dispose: $898439677a98c430$var$defaultDisposeImpl
            };
        };
    }
    /**
     * Gets the initializer for the strategy used for collection of total textures metrics.
     * @returns the initializer for the total textures strategy
     */ static TotalTexturesStrategy() {
        return (scene)=>{
            return {
                id: "Total textures",
                getData: ()=>scene.textures.length,
                dispose: $898439677a98c430$var$defaultDisposeImpl
            };
        };
    }
    /**
     * Gets the initializer for the strategy used for collection of absolute fps metrics.
     * @returns the initializer for the absolute fps strategy
     */ static AbsoluteFpsStrategy() {
        return (scene)=>{
            const sceneInstrumentation = new (0, $gGWXq.SceneInstrumentation)(scene);
            sceneInstrumentation.captureFrameTime = true;
            return {
                id: "Absolute FPS",
                getData: ()=>{
                    return 1000.0 / sceneInstrumentation.frameTimeCounter.lastSecAverage;
                },
                dispose: $898439677a98c430$var$defaultDisposeImpl
            };
        };
    }
    /**
     * Gets the initializer for the strategy used for collection of meshes selection time metrics.
     * @returns the initializer for the meshes selection time strategy
     */ static MeshesSelectionStrategy() {
        return (scene)=>{
            let startTime = (0, $blHSI.PrecisionDate).Now;
            let timeTaken = 0;
            const onBeforeActiveMeshesObserver = scene.onBeforeActiveMeshesEvaluationObservable.add(()=>{
                startTime = (0, $blHSI.PrecisionDate).Now;
            });
            const onAfterActiveMeshesObserver = scene.onAfterActiveMeshesEvaluationObservable.add(()=>{
                timeTaken = (0, $blHSI.PrecisionDate).Now - startTime;
            });
            return {
                id: "Meshes Selection",
                getData: ()=>timeTaken,
                dispose: ()=>{
                    scene.onBeforeActiveMeshesEvaluationObservable.remove(onBeforeActiveMeshesObserver);
                    scene.onAfterActiveMeshesEvaluationObservable.remove(onAfterActiveMeshesObserver);
                }
            };
        };
    }
    /**
     * Gets the initializer for the strategy used for collection of render targets time metrics.
     * @returns the initializer for the render targets time strategy
     */ static RenderTargetsStrategy() {
        return (scene)=>{
            let startTime = (0, $blHSI.PrecisionDate).Now;
            let timeTaken = 0;
            const onBeforeRenderTargetsObserver = scene.onBeforeRenderTargetsRenderObservable.add(()=>{
                startTime = (0, $blHSI.PrecisionDate).Now;
            });
            const onAfterRenderTargetsObserver = scene.onAfterRenderTargetsRenderObservable.add(()=>{
                timeTaken = (0, $blHSI.PrecisionDate).Now - startTime;
            });
            return {
                id: "Render Targets",
                getData: ()=>timeTaken,
                dispose: ()=>{
                    scene.onBeforeRenderTargetsRenderObservable.remove(onBeforeRenderTargetsObserver);
                    scene.onAfterRenderTargetsRenderObservable.remove(onAfterRenderTargetsObserver);
                }
            };
        };
    }
    /**
     * Gets the initializer for the strategy used for collection of particles time metrics.
     * @returns the initializer for the particles time strategy
     */ static ParticlesStrategy() {
        return (scene)=>{
            let startTime = (0, $blHSI.PrecisionDate).Now;
            let timeTaken = 0;
            const onBeforeParticlesObserver = scene.onBeforeParticlesRenderingObservable.add(()=>{
                startTime = (0, $blHSI.PrecisionDate).Now;
            });
            const onAfterParticlesObserver = scene.onAfterParticlesRenderingObservable.add(()=>{
                timeTaken = (0, $blHSI.PrecisionDate).Now - startTime;
            });
            return {
                id: "Particles",
                getData: ()=>timeTaken,
                dispose: ()=>{
                    scene.onBeforeParticlesRenderingObservable.remove(onBeforeParticlesObserver);
                    scene.onAfterParticlesRenderingObservable.remove(onAfterParticlesObserver);
                }
            };
        };
    }
    /**
     * Gets the initializer for the strategy used for collection of sprites time metrics.
     * @returns the initializer for the sprites time strategy
     */ static SpritesStrategy() {
        return (scene)=>{
            let startTime = (0, $blHSI.PrecisionDate).Now;
            let timeTaken = 0;
            const onBeforeSpritesObserver = scene.onBeforeSpritesRenderingObservable?.add(()=>{
                startTime = (0, $blHSI.PrecisionDate).Now;
            });
            const onAfterSpritesObserver = scene.onAfterSpritesRenderingObservable?.add(()=>{
                timeTaken = (0, $blHSI.PrecisionDate).Now - startTime;
            });
            return {
                id: "Sprites",
                getData: ()=>timeTaken,
                dispose: ()=>{
                    scene.onBeforeSpritesRenderingObservable?.remove(onBeforeSpritesObserver);
                    scene.onAfterSpritesRenderingObservable?.remove(onAfterSpritesObserver);
                }
            };
        };
    }
    /**
     * Gets the initializer for the strategy used for collection of animations time metrics.
     * @returns the initializer for the animations time strategy
     */ static AnimationsStrategy() {
        return (scene)=>{
            let startTime = (0, $blHSI.PrecisionDate).Now;
            let timeTaken = 0;
            const onBeforeAnimationsObserver = scene.onBeforeAnimationsObservable.add(()=>{
                startTime = (0, $blHSI.PrecisionDate).Now;
            });
            const onAfterAnimationsObserver = scene.onAfterAnimationsObservable.add(()=>{
                timeTaken = (0, $blHSI.PrecisionDate).Now - startTime;
            });
            return {
                id: "Animations",
                getData: ()=>timeTaken,
                dispose: ()=>{
                    scene.onBeforeAnimationsObservable.remove(onBeforeAnimationsObserver);
                    scene.onAfterAnimationsObservable.remove(onAfterAnimationsObserver);
                }
            };
        };
    }
    /**
     * Gets the initializer for the strategy used for collection of physics time metrics.
     * @returns the initializer for the physics time strategy
     */ static PhysicsStrategy() {
        return (scene)=>{
            let startTime = (0, $blHSI.PrecisionDate).Now;
            let timeTaken = 0;
            const onBeforePhysicsObserver = scene.onBeforePhysicsObservable?.add(()=>{
                startTime = (0, $blHSI.PrecisionDate).Now;
            });
            const onAfterPhysicsObserver = scene.onAfterPhysicsObservable?.add(()=>{
                timeTaken = (0, $blHSI.PrecisionDate).Now - startTime;
            });
            return {
                id: "Physics",
                getData: ()=>timeTaken,
                dispose: ()=>{
                    scene.onBeforePhysicsObservable?.remove(onBeforePhysicsObserver);
                    scene.onAfterPhysicsObservable?.remove(onAfterPhysicsObserver);
                }
            };
        };
    }
    /**
     * Gets the initializer for the strategy used for collection of render time metrics.
     * @returns the initializer for the render time strategy
     */ static RenderStrategy() {
        return (scene)=>{
            let startTime = (0, $blHSI.PrecisionDate).Now;
            let timeTaken = 0;
            const onBeforeDrawPhaseObserver = scene.onBeforeDrawPhaseObservable.add(()=>{
                startTime = (0, $blHSI.PrecisionDate).Now;
            });
            const onAfterDrawPhaseObserver = scene.onAfterDrawPhaseObservable.add(()=>{
                timeTaken = (0, $blHSI.PrecisionDate).Now - startTime;
            });
            return {
                id: "Render",
                getData: ()=>timeTaken,
                dispose: ()=>{
                    scene.onBeforeDrawPhaseObservable.remove(onBeforeDrawPhaseObserver);
                    scene.onAfterDrawPhaseObservable.remove(onAfterDrawPhaseObserver);
                }
            };
        };
    }
    /**
     * Gets the initializer for the strategy used for collection of total frame time metrics.
     * @returns the initializer for the total frame time strategy
     */ static FrameTotalStrategy() {
        return (scene)=>{
            let startTime = (0, $blHSI.PrecisionDate).Now;
            let timeTaken = 0;
            const onBeforeAnimationsObserver = scene.onBeforeAnimationsObservable.add(()=>{
                startTime = (0, $blHSI.PrecisionDate).Now;
            });
            const onAfterRenderObserver = scene.onAfterRenderObservable.add(()=>{
                timeTaken = (0, $blHSI.PrecisionDate).Now - startTime;
            });
            return {
                id: "Frame Total",
                getData: ()=>timeTaken,
                dispose: ()=>{
                    scene.onBeforeAnimationsObservable.remove(onBeforeAnimationsObserver);
                    scene.onAfterRenderObservable.remove(onAfterRenderObserver);
                }
            };
        };
    }
    /**
     * Gets the initializer for the strategy used for collection of inter-frame time metrics.
     * @returns the initializer for the inter-frame time strategy
     */ static InterFrameStrategy() {
        return (scene)=>{
            let startTime = (0, $blHSI.PrecisionDate).Now;
            let timeTaken = 0;
            const onBeforeAnimationsObserver = scene.onBeforeAnimationsObservable.add(()=>{
                timeTaken = (0, $blHSI.PrecisionDate).Now - startTime;
            });
            const onAfterRenderObserver = scene.onAfterRenderObservable.add(()=>{
                startTime = (0, $blHSI.PrecisionDate).Now;
            });
            return {
                id: "Inter-frame",
                getData: ()=>timeTaken,
                dispose: ()=>{
                    scene.onBeforeAnimationsObservable.remove(onBeforeAnimationsObserver);
                    scene.onAfterRenderObservable.remove(onAfterRenderObserver);
                }
            };
        };
    }
    /**
     * Gets the initializer for the strategy used for collection of gpu frame time metrics.
     * @returns the initializer for the gpu frame time strategy
     */ static GpuFrameTimeStrategy() {
        return (scene)=>{
            const engineInstrumentation = new (0, $k4hBS.EngineInstrumentation)(scene.getEngine());
            engineInstrumentation.captureGPUFrameTime = true;
            return {
                id: "GPU frame time",
                getData: ()=>Math.max(engineInstrumentation.gpuFrameTimeCounter.current * 0.000001, 0),
                dispose: ()=>{
                    engineInstrumentation.dispose();
                }
            };
        };
    }
}

});

parcelRegister("84gcq", function(module, exports) {

var $gmbCk = parcelRequire("gmbCk");

var $5TI5j = parcelRequire("5TI5j");
(0, $gmbCk.Scene).prototype.getPerfCollector = function() {
    if (!this._perfCollector) this._perfCollector = new (0, $5TI5j.PerformanceViewerCollector)(this);
    return this._perfCollector;
};

});


parcelRegister("fdSzW", function(module, exports) {

var $diGQf = parcelRequire("diGQf");

var $4TYUE = parcelRequire("4TYUE");
function $b1526815a6038c5b$var$CreateObservableScheduler(observable) {
    const coroutines = new Array();
    const onSteps = new Array();
    const onErrors = new Array();
    const observer = observable.add(()=>{
        const count = coroutines.length;
        for(let i = 0; i < count; i++)(0, $4TYUE.inlineScheduler)(coroutines.shift(), onSteps.shift(), onErrors.shift());
    });
    const scheduler = (coroutine, onStep, onError)=>{
        coroutines.push(coroutine);
        onSteps.push(onStep);
        onErrors.push(onError);
    };
    return {
        scheduler: scheduler,
        dispose: ()=>{
            observable.remove(observer);
        }
    };
}
(0, $diGQf.Observable).prototype.runCoroutineAsync = function(coroutine) {
    if (!this._coroutineScheduler) {
        const schedulerAndDispose = $b1526815a6038c5b$var$CreateObservableScheduler(this);
        this._coroutineScheduler = schedulerAndDispose.scheduler;
        this._coroutineSchedulerDispose = schedulerAndDispose.dispose;
    }
    return (0, $4TYUE.runCoroutineAsync)(coroutine, this._coroutineScheduler);
};
(0, $diGQf.Observable).prototype.cancelAllCoroutines = function() {
    if (this._coroutineSchedulerDispose) this._coroutineSchedulerDispose();
    this._coroutineScheduler = undefined;
    this._coroutineSchedulerDispose = undefined;
};

});

parcelRegister("dzdrg", function(module, exports) {

$parcel$export(module.exports, "captureEquirectangularFromScene", () => $9e08f7e29ca14838$export$3bfaff62ac3c498e);

var $lxthF = parcelRequire("lxthF");

var $gQtNK = parcelRequire("gQtNK");

var $ggTip = parcelRequire("ggTip");

var $4dKnp = parcelRequire("4dKnp");
parcelRequire("ehU8S");
async function $9e08f7e29ca14838$export$3bfaff62ac3c498e(scene, options) {
    const probe = options.probe ?? new (0, $lxthF.ReflectionProbe)("tempProbe", options.size, scene);
    const wasProbeProvided = !!options.probe;
    if (!wasProbeProvided) {
        if (options.position) probe.position = options.position.clone();
        else if (scene.activeCamera) probe.position = scene.activeCamera.position.clone();
    }
    const meshesToConsider = options.meshesFilter ? scene.meshes.filter(options.meshesFilter) : scene.meshes;
    probe.renderList?.push(...meshesToConsider);
    probe.refreshRate = (0, $gQtNK.RenderTargetTexture).REFRESHRATE_RENDER_ONCE;
    probe.cubeTexture.render();
    const dumpTexture = new (0, $ggTip.CustomProceduralTexture)("tempProceduralTexture", "equirectangularPanorama", {
        width: options.size * 2,
        height: options.size
    }, scene);
    dumpTexture.setTexture("cubeMap", probe.cubeTexture);
    return new Promise((resolve, reject)=>{
        dumpTexture.onGeneratedObservable.addOnce(()=>{
            const pixelDataPromise = dumpTexture.readPixels();
            if (!pixelDataPromise) {
                reject(new Error("No Pixel Data found on procedural texture"));
                dumpTexture.dispose();
                if (!wasProbeProvided) probe.dispose();
                return;
            }
            pixelDataPromise.then((pixelData)=>{
                dumpTexture.dispose();
                if (!wasProbeProvided) probe.dispose();
                if (options.filename) {
                    (0, $4dKnp.DumpTools).DumpData(options.size * 2, options.size, pixelData, undefined, "image/png", options.filename);
                    resolve(null);
                } else resolve(pixelData);
            });
        });
    });
}

});
parcelRegister("ehU8S", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $a66e33e3edbf47e5$var$name = "equirectangularPanoramaPixelShader";
const $a66e33e3edbf47e5$var$shader = `#ifdef GL_ES
precision highp float;
#endif
#define M_PI 3.1415926535897932384626433832795
varying vec2 vUV;uniform samplerCube cubeMap;void main(void) {vec2 uv=vUV;float longitude=uv.x*2.*M_PI-M_PI+M_PI/2.;float latitude=(1.-uv.y)*M_PI;vec3 dir=vec3(
- sin( longitude )*sin( latitude ),
cos( latitude ),
- cos( longitude )*sin( latitude )
);normalize( dir );gl_FragColor=textureCube( cubeMap,dir );}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$a66e33e3edbf47e5$var$name] = $a66e33e3edbf47e5$var$shader;
const $a66e33e3edbf47e5$export$2868366ef5714e4e = {
    name: $a66e33e3edbf47e5$var$name,
    shader: $a66e33e3edbf47e5$var$shader
};

});



parcelRegister("lxDra", function(module, exports) {
/* eslint-disable import/no-internal-modules */ 
var $UghGd = parcelRequire("UghGd");

var $h2dFw = parcelRequire("h2dFw");

var $jDt6c = parcelRequire("jDt6c");

var $9zzya = parcelRequire("9zzya");

var $6KWAu = parcelRequire("6KWAu");

var $7zPjk = parcelRequire("7zPjk");

var $jknux = parcelRequire("jknux");

var $2isQc = parcelRequire("2isQc");

var $bwZgn = parcelRequire("bwZgn");

var $cJN7d = parcelRequire("cJN7d");

var $fPWhE = parcelRequire("fPWhE");

var $56xI9 = parcelRequire("56xI9");

var $d0Q8H = parcelRequire("d0Q8H");

var $6PNKl = parcelRequire("6PNKl");
$parcel$exportWildcard(module.exports, $UghGd);
$parcel$exportWildcard(module.exports, $h2dFw);
$parcel$exportWildcard(module.exports, $jDt6c);
$parcel$exportWildcard(module.exports, $9zzya);
$parcel$exportWildcard(module.exports, $6KWAu);
$parcel$exportWildcard(module.exports, $7zPjk);
$parcel$exportWildcard(module.exports, $jknux);
$parcel$exportWildcard(module.exports, $2isQc);
$parcel$exportWildcard(module.exports, $bwZgn);
$parcel$exportWildcard(module.exports, $cJN7d);
$parcel$exportWildcard(module.exports, $fPWhE);
$parcel$exportWildcard(module.exports, $56xI9);
$parcel$exportWildcard(module.exports, $d0Q8H);
$parcel$exportWildcard(module.exports, $6PNKl);

});
parcelRegister("fPWhE", function(module, exports) {

var $2YzP2 = parcelRequire("2YzP2");

var $fsfQH = parcelRequire("fsfQH");

var $7u6Ex = parcelRequire("7u6Ex");

var $exAv9 = parcelRequire("exAv9");

var $2818K = parcelRequire("2818K");

var $laic7 = parcelRequire("laic7");

var $9GdLu = parcelRequire("9GdLu");

var $fUUe2 = parcelRequire("fUUe2");

var $adMiy = parcelRequire("adMiy");

var $gCh0b = parcelRequire("gCh0b");

var $k1hzP = parcelRequire("k1hzP");

var $2IkTP = parcelRequire("2IkTP");

var $7KWwg = parcelRequire("7KWwg");

var $gw4bf = parcelRequire("gw4bf");

var $l1zzl = parcelRequire("l1zzl");

var $97flB = parcelRequire("97flB");

var $8Gdnk = parcelRequire("8Gdnk");

var $8ffOp = parcelRequire("8ffOp");

var $41STK = parcelRequire("41STK");

var $6MZq2 = parcelRequire("6MZq2");

var $31Z3E = parcelRequire("31Z3E");

var $4891F = parcelRequire("4891F");

var $1LXzc = parcelRequire("1LXzc");
$parcel$exportWildcard(module.exports, $2YzP2);
$parcel$exportWildcard(module.exports, $fsfQH);
$parcel$exportWildcard(module.exports, $7u6Ex);
$parcel$exportWildcard(module.exports, $exAv9);
$parcel$exportWildcard(module.exports, $2818K);
$parcel$exportWildcard(module.exports, $laic7);
$parcel$exportWildcard(module.exports, $9GdLu);
$parcel$exportWildcard(module.exports, $fUUe2);
$parcel$exportWildcard(module.exports, $adMiy);
$parcel$exportWildcard(module.exports, $gCh0b);
$parcel$exportWildcard(module.exports, $k1hzP);
$parcel$exportWildcard(module.exports, $2IkTP);
$parcel$exportWildcard(module.exports, $7KWwg);
$parcel$exportWildcard(module.exports, $gw4bf);
$parcel$exportWildcard(module.exports, $l1zzl);
$parcel$exportWildcard(module.exports, $97flB);
$parcel$exportWildcard(module.exports, $8Gdnk);
$parcel$exportWildcard(module.exports, $8ffOp);
$parcel$exportWildcard(module.exports, $41STK);
$parcel$exportWildcard(module.exports, $6MZq2);
$parcel$exportWildcard(module.exports, $31Z3E);
$parcel$exportWildcard(module.exports, $4891F);
$parcel$exportWildcard(module.exports, $1LXzc);

});
parcelRegister("fsfQH", function(module, exports) {

$parcel$export(module.exports, "WebXRHitTestLegacy", () => $b405c3d3fc5e692a$export$1d7376a035dce798);

var $cJN7d = parcelRequire("cJN7d");

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $2YzP2 = parcelRequire("2YzP2");

var $bOhSV = parcelRequire("bOhSV");
class $b405c3d3fc5e692a$export$1d7376a035dce798 extends (0, $2YzP2.WebXRAbstractFeature) {
    /**
     * Creates a new instance of the (legacy version) hit test feature
     * @param _xrSessionManager an instance of WebXRSessionManager
     * @param options options to use when constructing this feature
     */ constructor(_xrSessionManager, /**
     * options to use when constructing this feature
     */ options = {}){
        super(_xrSessionManager);
        this.options = options;
        // in XR space z-forward is negative
        this._direction = new (0, $ha1VO.Vector3)(0, 0, -1);
        this._mat = new (0, $ha1VO.Matrix)();
        this._onSelectEnabled = false;
        this._origin = new (0, $ha1VO.Vector3)(0, 0, 0);
        /**
         * Populated with the last native XR Hit Results
         */ this.lastNativeXRHitResults = [];
        /**
         * Triggered when new babylon (transformed) hit test results are available
         */ this.onHitTestResultObservable = new (0, $diGQf.Observable)();
        this._onHitTestResults = (xrResults)=>{
            const mats = xrResults.map((result)=>{
                const mat = (0, $ha1VO.Matrix).FromArray(result.hitMatrix);
                if (!this._xrSessionManager.scene.useRightHandedSystem) mat.toggleModelMatrixHandInPlace();
                // if (this.options.coordinatesSpace === Space.WORLD) {
                if (this.options.worldParentNode) mat.multiplyToRef(this.options.worldParentNode.getWorldMatrix(), mat);
                return {
                    xrHitResult: result,
                    transformationMatrix: mat
                };
            });
            this.lastNativeXRHitResults = xrResults;
            this.onHitTestResultObservable.notifyObservers(mats);
        };
        // can be done using pointerdown event, and xrSessionManager.currentFrame
        this._onSelect = (event)=>{
            if (!this._onSelectEnabled) return;
            $b405c3d3fc5e692a$export$1d7376a035dce798.XRHitTestWithSelectEvent(event, this._xrSessionManager.referenceSpace);
        };
        this.xrNativeFeatureName = "hit-test";
        (0, $bOhSV.Tools).Warn("A newer version of this plugin is available");
    }
    /**
     * execute a hit test with an XR Ray
     *
     * @param xrSession a native xrSession that will execute this hit test
     * @param xrRay the ray (position and direction) to use for ray-casting
     * @param referenceSpace native XR reference space to use for the hit-test
     * @param filter filter function that will filter the results
     * @returns a promise that resolves with an array of native XR hit result in xr coordinates system
     */ static XRHitTestWithRay(xrSession, xrRay, referenceSpace, filter) {
        return xrSession.requestHitTest(xrRay, referenceSpace).then((results)=>{
            const filterFunction = filter || ((result)=>!!result.hitMatrix);
            return results.filter(filterFunction);
        });
    }
    /**
     * Execute a hit test on the current running session using a select event returned from a transient input (such as touch)
     * @param event the (select) event to use to select with
     * @param referenceSpace the reference space to use for this hit test
     * @returns a promise that resolves with an array of native XR hit result in xr coordinates system
     */ static XRHitTestWithSelectEvent(event, referenceSpace) {
        const targetRayPose = event.frame.getPose(event.inputSource.targetRaySpace, referenceSpace);
        if (!targetRayPose) return Promise.resolve([]);
        const targetRay = new XRRay(targetRayPose.transform);
        return this.XRHitTestWithRay(event.frame.session, targetRay, referenceSpace);
    }
    /**
     * attach this feature
     * Will usually be called by the features manager
     *
     * @returns true if successful.
     */ attach() {
        if (!super.attach()) return false;
        if (this.options.testOnPointerDownOnly) this._xrSessionManager.session.addEventListener("select", this._onSelect, false);
        return true;
    }
    /**
     * detach this feature.
     * Will usually be called by the features manager
     *
     * @returns true if successful.
     */ detach() {
        if (!super.detach()) return false;
        // disable select
        this._onSelectEnabled = false;
        this._xrSessionManager.session.removeEventListener("select", this._onSelect);
        return true;
    }
    /**
     * Dispose this feature and all of the resources attached
     */ dispose() {
        super.dispose();
        this.onHitTestResultObservable.clear();
    }
    _onXRFrame(frame) {
        // make sure we do nothing if (async) not attached
        if (!this.attached || this.options.testOnPointerDownOnly) return;
        const pose = frame.getViewerPose(this._xrSessionManager.referenceSpace);
        if (!pose) return;
        (0, $ha1VO.Matrix).FromArrayToRef(pose.transform.matrix, 0, this._mat);
        (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(0, 0, 0, this._mat, this._origin);
        (0, $ha1VO.Vector3).TransformCoordinatesFromFloatsToRef(0, 0, -1, this._mat, this._direction);
        this._direction.subtractInPlace(this._origin);
        this._direction.normalize();
        const ray = new XRRay({
            x: this._origin.x,
            y: this._origin.y,
            z: this._origin.z,
            w: 0
        }, {
            x: this._direction.x,
            y: this._direction.y,
            z: this._direction.z,
            w: 0
        });
        $b405c3d3fc5e692a$export$1d7376a035dce798.XRHitTestWithRay(this._xrSessionManager.session, ray, this._xrSessionManager.referenceSpace).then(this._onHitTestResults);
    }
}
/**
 * The module's name
 */ $b405c3d3fc5e692a$export$1d7376a035dce798.Name = (0, $cJN7d.WebXRFeatureName).HIT_TEST;
/**
 * The (Babylon) version of this module.
 * This is an integer representing the implementation version.
 * This number does not correspond to the WebXR specs version
 */ $b405c3d3fc5e692a$export$1d7376a035dce798.Version = 1;
//register the plugin versions
(0, $cJN7d.WebXRFeaturesManager).AddWebXRFeature($b405c3d3fc5e692a$export$1d7376a035dce798.Name, (xrSessionManager, options)=>{
    return ()=>new $b405c3d3fc5e692a$export$1d7376a035dce798(xrSessionManager, options);
}, $b405c3d3fc5e692a$export$1d7376a035dce798.Version, false);

});

parcelRegister("7u6Ex", function(module, exports) {

$parcel$export(module.exports, "WebXRAnchorSystem", () => $57307edd5dc7e220$export$a78ff9bdb9871110);

var $cJN7d = parcelRequire("cJN7d");

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $2YzP2 = parcelRequire("2YzP2");

var $bOhSV = parcelRequire("bOhSV");
let $57307edd5dc7e220$var$anchorIdProvider = 0;
class $57307edd5dc7e220$export$a78ff9bdb9871110 extends (0, $2YzP2.WebXRAbstractFeature) {
    /**
     * Set the reference space to use for anchor creation, when not using a hit test.
     * Will default to the session's reference space if not defined
     */ set referenceSpaceForFrameAnchors(referenceSpace) {
        this._referenceSpaceForFrameAnchors = referenceSpace;
    }
    /**
     * constructs a new anchor system
     * @param _xrSessionManager an instance of WebXRSessionManager
     * @param _options configuration object for this feature
     */ constructor(_xrSessionManager, _options = {}){
        super(_xrSessionManager);
        this._options = _options;
        this._lastFrameDetected = new Set();
        this._trackedAnchors = [];
        this._futureAnchors = [];
        /**
         * Observers registered here will be executed when a new anchor was added to the session
         */ this.onAnchorAddedObservable = new (0, $diGQf.Observable)();
        /**
         * Observers registered here will be executed when an anchor was removed from the session
         */ this.onAnchorRemovedObservable = new (0, $diGQf.Observable)();
        /**
         * Observers registered here will be executed when an existing anchor updates
         * This can execute N times every frame
         */ this.onAnchorUpdatedObservable = new (0, $diGQf.Observable)();
        this._tmpVector = new (0, $ha1VO.Vector3)();
        this._tmpQuaternion = new (0, $ha1VO.Quaternion)();
        this.xrNativeFeatureName = "anchors";
    }
    _populateTmpTransformation(position, rotationQuaternion) {
        this._tmpVector.copyFrom(position);
        this._tmpQuaternion.copyFrom(rotationQuaternion);
        if (!this._xrSessionManager.scene.useRightHandedSystem) {
            this._tmpVector.z *= -1;
            this._tmpQuaternion.z *= -1;
            this._tmpQuaternion.w *= -1;
        }
        return {
            position: this._tmpVector,
            rotationQuaternion: this._tmpQuaternion
        };
    }
    /**
     * Create a new anchor point using a hit test result at a specific point in the scene
     * An anchor is tracked only after it is added to the trackerAnchors in xrFrame. The promise returned here does not yet guaranty that.
     * Use onAnchorAddedObservable to get newly added anchors if you require tracking guaranty.
     *
     * @param hitTestResult The hit test result to use for this anchor creation
     * @param position an optional position offset for this anchor
     * @param rotationQuaternion an optional rotation offset for this anchor
     * @returns A promise that fulfills when babylon has created the corresponding WebXRAnchor object and tracking has begun
     */ async addAnchorPointUsingHitTestResultAsync(hitTestResult, position = new (0, $ha1VO.Vector3)(), rotationQuaternion = new (0, $ha1VO.Quaternion)()) {
        // convert to XR space (right handed) if needed
        this._populateTmpTransformation(position, rotationQuaternion);
        // the matrix that we'll use
        const m = new XRRigidTransform({
            x: this._tmpVector.x,
            y: this._tmpVector.y,
            z: this._tmpVector.z
        }, {
            x: this._tmpQuaternion.x,
            y: this._tmpQuaternion.y,
            z: this._tmpQuaternion.z,
            w: this._tmpQuaternion.w
        });
        if (!hitTestResult.xrHitResult.createAnchor) {
            this.detach();
            throw new Error("Anchors not enabled in this environment/browser");
        } else try {
            const nativeAnchor = await hitTestResult.xrHitResult.createAnchor(m);
            return new Promise((resolve, reject)=>{
                this._futureAnchors.push({
                    nativeAnchor: nativeAnchor,
                    resolved: false,
                    submitted: true,
                    xrTransformation: m,
                    resolve: resolve,
                    reject: reject
                });
            });
        } catch (error) {
            throw new Error(error);
        }
    }
    /**
     * Add a new anchor at a specific position and rotation
     * This function will add a new anchor per default in the next available frame. Unless forced, the createAnchor function
     * will be called in the next xrFrame loop to make sure that the anchor can be created correctly.
     * An anchor is tracked only after it is added to the trackerAnchors in xrFrame. The promise returned here does not yet guaranty that.
     * Use onAnchorAddedObservable to get newly added anchors if you require tracking guaranty.
     *
     * @param position the position in which to add an anchor
     * @param rotationQuaternion an optional rotation for the anchor transformation
     * @param forceCreateInCurrentFrame force the creation of this anchor in the current frame. Must be called inside xrFrame loop!
     * @returns A promise that fulfills when babylon has created the corresponding WebXRAnchor object and tracking has begun
     */ async addAnchorAtPositionAndRotationAsync(position, rotationQuaternion = new (0, $ha1VO.Quaternion)(), forceCreateInCurrentFrame = false) {
        // convert to XR space (right handed) if needed
        this._populateTmpTransformation(position, rotationQuaternion);
        // the matrix that we'll use
        const xrTransformation = new XRRigidTransform({
            x: this._tmpVector.x,
            y: this._tmpVector.y,
            z: this._tmpVector.z
        }, {
            x: this._tmpQuaternion.x,
            y: this._tmpQuaternion.y,
            z: this._tmpQuaternion.z,
            w: this._tmpQuaternion.w
        });
        const xrAnchor = forceCreateInCurrentFrame && this.attached && this._xrSessionManager.currentFrame ? await this._createAnchorAtTransformation(xrTransformation, this._xrSessionManager.currentFrame) : undefined;
        // add the transformation to the future anchors list
        return new Promise((resolve, reject)=>{
            this._futureAnchors.push({
                nativeAnchor: xrAnchor,
                resolved: false,
                submitted: false,
                xrTransformation: xrTransformation,
                resolve: resolve,
                reject: reject
            });
        });
    }
    /**
     * Get the list of anchors currently being tracked by the system
     */ get anchors() {
        return this._trackedAnchors;
    }
    /**
     * detach this feature.
     * Will usually be called by the features manager
     *
     * @returns true if successful.
     */ detach() {
        if (!super.detach()) return false;
        if (!this._options.doNotRemoveAnchorsOnSessionEnded) while(this._trackedAnchors.length){
            const toRemove = this._trackedAnchors.pop();
            if (toRemove) {
                try {
                    // try to natively remove it as well
                    toRemove.remove();
                } catch (e) {
                // no-op
                }
                // as the xr frame loop is removed, we need to notify manually
                this.onAnchorRemovedObservable.notifyObservers(toRemove);
            }
        }
        return true;
    }
    /**
     * Dispose this feature and all of the resources attached
     */ dispose() {
        this._futureAnchors.length = 0;
        super.dispose();
        this.onAnchorAddedObservable.clear();
        this.onAnchorRemovedObservable.clear();
        this.onAnchorUpdatedObservable.clear();
    }
    _onXRFrame(frame) {
        if (!this.attached || !frame) return;
        const trackedAnchors = frame.trackedAnchors;
        if (trackedAnchors) {
            const toRemove = this._trackedAnchors.filter((anchor)=>!trackedAnchors.has(anchor.xrAnchor)).map((anchor)=>{
                const index = this._trackedAnchors.indexOf(anchor);
                return index;
            });
            let idxTracker = 0;
            toRemove.forEach((index)=>{
                const anchor = this._trackedAnchors.splice(index - idxTracker, 1)[0];
                this.onAnchorRemovedObservable.notifyObservers(anchor);
                idxTracker++;
            });
            // now check for new ones
            trackedAnchors.forEach((xrAnchor)=>{
                if (!this._lastFrameDetected.has(xrAnchor)) {
                    const newAnchor = {
                        id: $57307edd5dc7e220$var$anchorIdProvider++,
                        xrAnchor: xrAnchor,
                        remove: ()=>xrAnchor.delete()
                    };
                    const anchor = this._updateAnchorWithXRFrame(xrAnchor, newAnchor, frame);
                    this._trackedAnchors.push(anchor);
                    this.onAnchorAddedObservable.notifyObservers(anchor);
                    // search for the future anchor promise that matches this
                    const results = this._futureAnchors.filter((futureAnchor)=>futureAnchor.nativeAnchor === xrAnchor);
                    const result = results[0];
                    if (result) {
                        result.resolve(anchor);
                        result.resolved = true;
                    }
                } else {
                    const index = this._findIndexInAnchorArray(xrAnchor);
                    const anchor = this._trackedAnchors[index];
                    try {
                        // anchors update every frame
                        this._updateAnchorWithXRFrame(xrAnchor, anchor, frame);
                        if (anchor.attachedNode) {
                            anchor.attachedNode.rotationQuaternion = anchor.attachedNode.rotationQuaternion || new (0, $ha1VO.Quaternion)();
                            anchor.transformationMatrix.decompose(anchor.attachedNode.scaling, anchor.attachedNode.rotationQuaternion, anchor.attachedNode.position);
                        }
                        this.onAnchorUpdatedObservable.notifyObservers(anchor);
                    } catch (e) {
                        (0, $bOhSV.Tools).Warn(`Anchor could not be updated`);
                    }
                }
            });
            this._lastFrameDetected = trackedAnchors;
        }
        // process future anchors
        this._futureAnchors.forEach((futureAnchor)=>{
            if (!futureAnchor.resolved && !futureAnchor.submitted) {
                this._createAnchorAtTransformation(futureAnchor.xrTransformation, frame).then((nativeAnchor)=>{
                    futureAnchor.nativeAnchor = nativeAnchor;
                }, (error)=>{
                    futureAnchor.resolved = true;
                    futureAnchor.reject(error);
                });
                futureAnchor.submitted = true;
            }
        });
    }
    /**
     * avoiding using Array.find for global support.
     * @param xrAnchor the plane to find in the array
     * @returns the index of the anchor in the array or -1 if not found
     */ _findIndexInAnchorArray(xrAnchor) {
        for(let i = 0; i < this._trackedAnchors.length; ++i){
            if (this._trackedAnchors[i].xrAnchor === xrAnchor) return i;
        }
        return -1;
    }
    _updateAnchorWithXRFrame(xrAnchor, anchor, xrFrame) {
        // matrix
        const pose = xrFrame.getPose(xrAnchor.anchorSpace, this._xrSessionManager.referenceSpace);
        if (pose) {
            const mat = anchor.transformationMatrix || new (0, $ha1VO.Matrix)();
            (0, $ha1VO.Matrix).FromArrayToRef(pose.transform.matrix, 0, mat);
            if (!this._xrSessionManager.scene.useRightHandedSystem) mat.toggleModelMatrixHandInPlace();
            anchor.transformationMatrix = mat;
            if (!this._options.worldParentNode) ;
            else mat.multiplyToRef(this._options.worldParentNode.getWorldMatrix(), mat);
        }
        return anchor;
    }
    async _createAnchorAtTransformation(xrTransformation, xrFrame) {
        if (xrFrame.createAnchor) try {
            return xrFrame.createAnchor(xrTransformation, this._referenceSpaceForFrameAnchors ?? this._xrSessionManager.referenceSpace);
        } catch (error) {
            throw new Error(error);
        }
        else {
            this.detach();
            throw new Error("Anchors are not enabled in your browser");
        }
    }
}
/**
 * The module's name
 */ $57307edd5dc7e220$export$a78ff9bdb9871110.Name = (0, $cJN7d.WebXRFeatureName).ANCHOR_SYSTEM;
/**
 * The (Babylon) version of this module.
 * This is an integer representing the implementation version.
 * This number does not correspond to the WebXR specs version
 */ $57307edd5dc7e220$export$a78ff9bdb9871110.Version = 1;
// register the plugin
(0, $cJN7d.WebXRFeaturesManager).AddWebXRFeature($57307edd5dc7e220$export$a78ff9bdb9871110.Name, (xrSessionManager, options)=>{
    return ()=>new $57307edd5dc7e220$export$a78ff9bdb9871110(xrSessionManager, options);
}, $57307edd5dc7e220$export$a78ff9bdb9871110.Version);

});

parcelRegister("exAv9", function(module, exports) {

$parcel$export(module.exports, "WebXRPlaneDetector", () => $a960762bdc7871c3$export$6769df96be96ff51);

var $cJN7d = parcelRequire("cJN7d");

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $2YzP2 = parcelRequire("2YzP2");
let $a960762bdc7871c3$var$planeIdProvider = 0;
class $a960762bdc7871c3$export$6769df96be96ff51 extends (0, $2YzP2.WebXRAbstractFeature) {
    /**
     * construct a new Plane Detector
     * @param _xrSessionManager an instance of xr Session manager
     * @param _options configuration to use when constructing this feature
     */ constructor(_xrSessionManager, _options = {}){
        super(_xrSessionManager);
        this._options = _options;
        this._detectedPlanes = [];
        this._enabled = false;
        this._lastFrameDetected = new Set();
        /**
         * Observers registered here will be executed when a new plane was added to the session
         */ this.onPlaneAddedObservable = new (0, $diGQf.Observable)();
        /**
         * Observers registered here will be executed when a plane is no longer detected in the session
         */ this.onPlaneRemovedObservable = new (0, $diGQf.Observable)();
        /**
         * Observers registered here will be executed when an existing plane updates (for example - expanded)
         * This can execute N times every frame
         */ this.onPlaneUpdatedObservable = new (0, $diGQf.Observable)();
        this.xrNativeFeatureName = "plane-detection";
        if (this._xrSessionManager.session) this._init();
        else this._xrSessionManager.onXRSessionInit.addOnce(()=>{
            this._init();
        });
    }
    /**
     * detach this feature.
     * Will usually be called by the features manager
     *
     * @returns true if successful.
     */ detach() {
        if (!super.detach()) return false;
        if (!this._options.doNotRemovePlanesOnSessionEnded) while(this._detectedPlanes.length){
            const toRemove = this._detectedPlanes.pop();
            if (toRemove) this.onPlaneRemovedObservable.notifyObservers(toRemove);
        }
        return true;
    }
    /**
     * Dispose this feature and all of the resources attached
     */ dispose() {
        super.dispose();
        this.onPlaneAddedObservable.clear();
        this.onPlaneRemovedObservable.clear();
        this.onPlaneUpdatedObservable.clear();
    }
    /**
     * Check if the needed objects are defined.
     * This does not mean that the feature is enabled, but that the objects needed are well defined.
     * @returns true if the initial compatibility test passed
     */ isCompatible() {
        return typeof XRPlane !== "undefined";
    }
    /**
     * Enable room capture mode.
     * When enabled and supported by the system,
     * the detectedPlanes array will be populated with the detected room boundaries
     * @see https://immersive-web.github.io/real-world-geometry/plane-detection.html#dom-xrsession-initiateroomcapture
     * @returns true if plane detection is enabled and supported. Will reject if not supported.
     */ async initiateRoomCapture() {
        if (this._xrSessionManager.session.initiateRoomCapture) return this._xrSessionManager.session.initiateRoomCapture();
        return Promise.reject("initiateRoomCapture is not supported on this session");
    }
    _onXRFrame(frame) {
        if (!this.attached || !this._enabled || !frame) return;
        const detectedPlanes = frame.detectedPlanes || frame.worldInformation?.detectedPlanes;
        if (detectedPlanes) {
            // remove all planes that are not currently detected in the frame
            for(let planeIdx = 0; planeIdx < this._detectedPlanes.length; planeIdx++){
                const plane = this._detectedPlanes[planeIdx];
                if (!detectedPlanes.has(plane.xrPlane)) {
                    this._detectedPlanes.splice(planeIdx--, 1);
                    this.onPlaneRemovedObservable.notifyObservers(plane);
                }
            }
            // now check for new ones
            detectedPlanes.forEach((xrPlane)=>{
                if (!this._lastFrameDetected.has(xrPlane)) {
                    const newPlane = {
                        id: $a960762bdc7871c3$var$planeIdProvider++,
                        xrPlane: xrPlane,
                        polygonDefinition: []
                    };
                    const plane = this._updatePlaneWithXRPlane(xrPlane, newPlane, frame);
                    this._detectedPlanes.push(plane);
                    this.onPlaneAddedObservable.notifyObservers(plane);
                } else // updated?
                if (xrPlane.lastChangedTime === this._xrSessionManager.currentTimestamp) {
                    const index = this._findIndexInPlaneArray(xrPlane);
                    const plane = this._detectedPlanes[index];
                    this._updatePlaneWithXRPlane(xrPlane, plane, frame);
                    this.onPlaneUpdatedObservable.notifyObservers(plane);
                }
            });
            this._lastFrameDetected = detectedPlanes;
        }
    }
    _init() {
        const internalInit = ()=>{
            this._enabled = true;
            if (this._detectedPlanes.length) this._detectedPlanes.length = 0;
        };
        // Only supported by BabylonNative
        if (!!this._xrSessionManager.isNative && !!this._options.preferredDetectorOptions && !!this._xrSessionManager.session.trySetPreferredPlaneDetectorOptions) this._xrSessionManager.session.trySetPreferredPlaneDetectorOptions(this._options.preferredDetectorOptions);
        if (!this._xrSessionManager.session.updateWorldTrackingState) {
            internalInit();
            return;
        }
        this._xrSessionManager.session.updateWorldTrackingState({
            planeDetectionState: {
                enabled: true
            }
        });
        internalInit();
    }
    _updatePlaneWithXRPlane(xrPlane, plane, xrFrame) {
        plane.polygonDefinition = xrPlane.polygon.map((xrPoint)=>{
            const rightHandedSystem = this._xrSessionManager.scene.useRightHandedSystem ? 1 : -1;
            return new (0, $ha1VO.Vector3)(xrPoint.x, xrPoint.y, xrPoint.z * rightHandedSystem);
        });
        // matrix
        const pose = xrFrame.getPose(xrPlane.planeSpace, this._xrSessionManager.referenceSpace);
        if (pose) {
            const mat = plane.transformationMatrix || new (0, $ha1VO.Matrix)();
            (0, $ha1VO.Matrix).FromArrayToRef(pose.transform.matrix, 0, mat);
            if (!this._xrSessionManager.scene.useRightHandedSystem) mat.toggleModelMatrixHandInPlace();
            plane.transformationMatrix = mat;
            if (this._options.worldParentNode) mat.multiplyToRef(this._options.worldParentNode.getWorldMatrix(), mat);
        }
        return plane;
    }
    /**
     * avoiding using Array.find for global support.
     * @param xrPlane the plane to find in the array
     * @returns the index of the plane in the array or -1 if not found
     */ _findIndexInPlaneArray(xrPlane) {
        for(let i = 0; i < this._detectedPlanes.length; ++i){
            if (this._detectedPlanes[i].xrPlane === xrPlane) return i;
        }
        return -1;
    }
}
/**
 * The module's name
 */ $a960762bdc7871c3$export$6769df96be96ff51.Name = (0, $cJN7d.WebXRFeatureName).PLANE_DETECTION;
/**
 * The (Babylon) version of this module.
 * This is an integer representing the implementation version.
 * This number does not correspond to the WebXR specs version
 */ $a960762bdc7871c3$export$6769df96be96ff51.Version = 1;
//register the plugin
(0, $cJN7d.WebXRFeaturesManager).AddWebXRFeature($a960762bdc7871c3$export$6769df96be96ff51.Name, (xrSessionManager, options)=>{
    return ()=>new $a960762bdc7871c3$export$6769df96be96ff51(xrSessionManager, options);
}, $a960762bdc7871c3$export$6769df96be96ff51.Version);

});

parcelRegister("2818K", function(module, exports) {

$parcel$export(module.exports, "WebXRBackgroundRemover", () => $18cd3682400429ab$export$6e3854874b9bd9ba);

var $cJN7d = parcelRequire("cJN7d");

var $diGQf = parcelRequire("diGQf");

var $2YzP2 = parcelRequire("2YzP2");
class $18cd3682400429ab$export$6e3854874b9bd9ba extends (0, $2YzP2.WebXRAbstractFeature) {
    /**
     * constructs a new background remover module
     * @param _xrSessionManager the session manager for this module
     * @param options read-only options to be used in this module
     */ constructor(_xrSessionManager, /**
     * read-only options to be used in this module
     */ options = {}){
        super(_xrSessionManager);
        this.options = options;
        /**
         * registered observers will be triggered when the background state changes
         */ this.onBackgroundStateChangedObservable = new (0, $diGQf.Observable)();
    }
    /**
     * attach this feature
     * Will usually be called by the features manager
     *
     * @returns true if successful.
     */ attach() {
        this._setBackgroundState(false);
        return super.attach();
    }
    /**
     * detach this feature.
     * Will usually be called by the features manager
     *
     * @returns true if successful.
     */ detach() {
        this._setBackgroundState(true);
        return super.detach();
    }
    /**
     * Dispose this feature and all of the resources attached
     */ dispose() {
        super.dispose();
        this.onBackgroundStateChangedObservable.clear();
    }
    _onXRFrame(_xrFrame) {
    // no-op
    }
    _setBackgroundState(newState) {
        const scene = this._xrSessionManager.scene;
        if (!this.options.ignoreEnvironmentHelper) {
            if (this.options.environmentHelperRemovalFlags) {
                if (this.options.environmentHelperRemovalFlags.skyBox) {
                    const backgroundSkybox = scene.getMeshByName("BackgroundSkybox");
                    if (backgroundSkybox) backgroundSkybox.setEnabled(newState);
                }
                if (this.options.environmentHelperRemovalFlags.ground) {
                    const backgroundPlane = scene.getMeshByName("BackgroundPlane");
                    if (backgroundPlane) backgroundPlane.setEnabled(newState);
                }
            } else {
                const backgroundHelper = scene.getMeshByName("BackgroundHelper");
                if (backgroundHelper) backgroundHelper.setEnabled(newState);
            }
        }
        if (this.options.backgroundMeshes) this.options.backgroundMeshes.forEach((mesh)=>mesh.setEnabled(newState));
        this.onBackgroundStateChangedObservable.notifyObservers(newState);
    }
}
/**
 * The module's name
 */ $18cd3682400429ab$export$6e3854874b9bd9ba.Name = (0, $cJN7d.WebXRFeatureName).BACKGROUND_REMOVER;
/**
 * The (Babylon) version of this module.
 * This is an integer representing the implementation version.
 * This number does not correspond to the WebXR specs version
 */ $18cd3682400429ab$export$6e3854874b9bd9ba.Version = 1;
//register the plugin
(0, $cJN7d.WebXRFeaturesManager).AddWebXRFeature($18cd3682400429ab$export$6e3854874b9bd9ba.Name, (xrSessionManager, options)=>{
    return ()=>new $18cd3682400429ab$export$6e3854874b9bd9ba(xrSessionManager, options);
}, $18cd3682400429ab$export$6e3854874b9bd9ba.Version, true);

});

parcelRegister("fUUe2", function(module, exports) {

$parcel$export(module.exports, "IWebXRControllerPhysicsOptions", () => $b967b327731a9e24$export$89e809b91d3e1488);
$parcel$export(module.exports, "WebXRControllerPhysics", () => $b967b327731a9e24$export$41683fed620f0ca6);

var $2YzP2 = parcelRequire("2YzP2");

var $ha1VO = parcelRequire("ha1VO");

var $iz3U8 = parcelRequire("iz3U8");

var $8KqOo = parcelRequire("8KqOo");

var $cJN7d = parcelRequire("cJN7d");

var $kVtWi = parcelRequire("kVtWi");
class $b967b327731a9e24$export$89e809b91d3e1488 {
}
class $b967b327731a9e24$export$41683fed620f0ca6 extends (0, $2YzP2.WebXRAbstractFeature) {
    _createPhysicsImpostor(xrController) {
        const impostorType = this._options.physicsProperties.impostorType || (0, $iz3U8.PhysicsImpostor).SphereImpostor;
        const impostorSize = this._options.physicsProperties.impostorSize || 0.1;
        const impostorMesh = (0, $8KqOo.CreateSphere)("impostor-mesh-" + xrController.uniqueId, {
            diameterX: typeof impostorSize === "number" ? impostorSize : impostorSize.width,
            diameterY: typeof impostorSize === "number" ? impostorSize : impostorSize.height,
            diameterZ: typeof impostorSize === "number" ? impostorSize : impostorSize.depth
        });
        impostorMesh.isVisible = this._debugMode;
        impostorMesh.isPickable = false;
        impostorMesh.rotationQuaternion = new (0, $ha1VO.Quaternion)();
        const controllerMesh = xrController.grip || xrController.pointer;
        impostorMesh.position.copyFrom(controllerMesh.position);
        impostorMesh.rotationQuaternion.copyFrom(controllerMesh.rotationQuaternion);
        const impostor = new (0, $iz3U8.PhysicsImpostor)(impostorMesh, impostorType, {
            mass: 0,
            ...this._options.physicsProperties
        });
        this._controllers[xrController.uniqueId] = {
            xrController: xrController,
            impostor: impostor,
            impostorMesh: impostorMesh
        };
    }
    /**
     * Construct a new Controller Physics Feature
     * @param _xrSessionManager the corresponding xr session manager
     * @param _options options to create this feature with
     */ constructor(_xrSessionManager, _options){
        super(_xrSessionManager);
        this._options = _options;
        this._attachController = (xrController)=>{
            if (this._controllers[xrController.uniqueId]) // already attached
            return;
            if (!this._xrSessionManager.scene.isPhysicsEnabled()) (0, $kVtWi.Logger).Warn("physics engine not enabled, skipped. Please add this controller manually.");
            // if no motion controller available, create impostors!
            if (this._options.physicsProperties.useControllerMesh && xrController.inputSource.gamepad) xrController.onMotionControllerInitObservable.addOnce((motionController)=>{
                if (!motionController._doNotLoadControllerMesh) motionController.onModelLoadedObservable.addOnce(()=>{
                    const impostor = new (0, $iz3U8.PhysicsImpostor)(motionController.rootMesh, (0, $iz3U8.PhysicsImpostor).MeshImpostor, {
                        mass: 0,
                        ...this._options.physicsProperties
                    });
                    const controllerMesh = xrController.grip || xrController.pointer;
                    this._controllers[xrController.uniqueId] = {
                        xrController: xrController,
                        impostor: impostor,
                        oldPos: controllerMesh.position.clone(),
                        oldRotation: controllerMesh.rotationQuaternion.clone()
                    };
                });
                else // This controller isn't using a model, create impostors instead
                this._createPhysicsImpostor(xrController);
            });
            else this._createPhysicsImpostor(xrController);
        };
        this._controllers = {};
        this._debugMode = false;
        this._delta = 0;
        this._lastTimestamp = 0;
        this._tmpQuaternion = new (0, $ha1VO.Quaternion)();
        this._tmpVector = new (0, $ha1VO.Vector3)();
        if (!this._options.physicsProperties) this._options.physicsProperties = {};
    }
    /**
     * @internal
     * enable debugging - will show console outputs and the impostor mesh
     */ _enablePhysicsDebug() {
        this._debugMode = true;
        Object.keys(this._controllers).forEach((controllerId)=>{
            const controllerData = this._controllers[controllerId];
            if (controllerData.impostorMesh) controllerData.impostorMesh.isVisible = true;
        });
    }
    /**
     * Manually add a controller (if no xrInput was provided or physics engine was not enabled)
     * @param xrController the controller to add
     */ addController(xrController) {
        this._attachController(xrController);
    }
    /**
     * attach this feature
     * Will usually be called by the features manager
     *
     * @returns true if successful.
     */ attach() {
        if (!super.attach()) return false;
        if (!this._options.xrInput) return true;
        this._options.xrInput.controllers.forEach(this._attachController);
        this._addNewAttachObserver(this._options.xrInput.onControllerAddedObservable, this._attachController);
        this._addNewAttachObserver(this._options.xrInput.onControllerRemovedObservable, (controller)=>{
            // REMOVE the controller
            this._detachController(controller.uniqueId);
        });
        if (this._options.enableHeadsetImpostor) {
            const params = this._options.headsetImpostorParams || {
                impostorType: (0, $iz3U8.PhysicsImpostor).SphereImpostor,
                restitution: 0.8,
                impostorSize: 0.3
            };
            const impostorSize = params.impostorSize || 0.3;
            this._headsetMesh = (0, $8KqOo.CreateSphere)("headset-mesh", {
                diameterX: typeof impostorSize === "number" ? impostorSize : impostorSize.width,
                diameterY: typeof impostorSize === "number" ? impostorSize : impostorSize.height,
                diameterZ: typeof impostorSize === "number" ? impostorSize : impostorSize.depth
            });
            this._headsetMesh.rotationQuaternion = new (0, $ha1VO.Quaternion)();
            this._headsetMesh.isVisible = false;
            this._headsetImpostor = new (0, $iz3U8.PhysicsImpostor)(this._headsetMesh, params.impostorType, {
                mass: 0,
                ...params
            });
        }
        return true;
    }
    /**
     * detach this feature.
     * Will usually be called by the features manager
     *
     * @returns true if successful.
     */ detach() {
        if (!super.detach()) return false;
        Object.keys(this._controllers).forEach((controllerId)=>{
            this._detachController(controllerId);
        });
        if (this._headsetMesh) this._headsetMesh.dispose();
        return true;
    }
    /**
     * Get the headset impostor, if enabled
     * @returns the impostor
     */ getHeadsetImpostor() {
        return this._headsetImpostor;
    }
    /**
     * Get the physics impostor of a specific controller.
     * The impostor is not attached to a mesh because a mesh for each controller is not obligatory
     * @param controller the controller or the controller id of which to get the impostor
     * @returns the impostor or null
     */ getImpostorForController(controller) {
        const id = typeof controller === "string" ? controller : controller.uniqueId;
        if (this._controllers[id]) return this._controllers[id].impostor;
        else return null;
    }
    /**
     * Update the physics properties provided in the constructor
     * @param newProperties the new properties object
     * @param newProperties.impostorType
     * @param newProperties.impostorSize
     * @param newProperties.friction
     * @param newProperties.restitution
     */ setPhysicsProperties(newProperties) {
        this._options.physicsProperties = {
            ...this._options.physicsProperties,
            ...newProperties
        };
    }
    _onXRFrame(_xrFrame) {
        this._delta = this._xrSessionManager.currentTimestamp - this._lastTimestamp;
        this._lastTimestamp = this._xrSessionManager.currentTimestamp;
        if (this._headsetMesh && this._headsetImpostor) {
            this._headsetMesh.position.copyFrom(this._options.xrInput.xrCamera.globalPosition);
            this._headsetMesh.rotationQuaternion.copyFrom(this._options.xrInput.xrCamera.absoluteRotation);
            if (this._options.xrInput.xrCamera._lastXRViewerPose?.linearVelocity) {
                const lv = this._options.xrInput.xrCamera._lastXRViewerPose.linearVelocity;
                this._tmpVector.set(lv.x, lv.y, lv.z);
                this._headsetImpostor.setLinearVelocity(this._tmpVector);
            }
            if (this._options.xrInput.xrCamera._lastXRViewerPose?.angularVelocity) {
                const av = this._options.xrInput.xrCamera._lastXRViewerPose.angularVelocity;
                this._tmpVector.set(av.x, av.y, av.z);
                this._headsetImpostor.setAngularVelocity(this._tmpVector);
            }
        }
        Object.keys(this._controllers).forEach((controllerId)=>{
            const controllerData = this._controllers[controllerId];
            const controllerMesh = controllerData.xrController.grip || controllerData.xrController.pointer;
            const comparedPosition = controllerData.oldPos || controllerData.impostorMesh.position;
            if (controllerData.xrController._lastXRPose?.linearVelocity) {
                const lv = controllerData.xrController._lastXRPose.linearVelocity;
                this._tmpVector.set(lv.x, lv.y, lv.z);
                controllerData.impostor.setLinearVelocity(this._tmpVector);
            } else {
                controllerMesh.position.subtractToRef(comparedPosition, this._tmpVector);
                this._tmpVector.scaleInPlace(1000 / this._delta);
                controllerData.impostor.setLinearVelocity(this._tmpVector);
            }
            comparedPosition.copyFrom(controllerMesh.position);
            if (this._debugMode) (0, $kVtWi.Logger).Log([
                this._tmpVector,
                "linear"
            ]);
            const comparedQuaternion = controllerData.oldRotation || controllerData.impostorMesh.rotationQuaternion;
            if (controllerData.xrController._lastXRPose?.angularVelocity) {
                const av = controllerData.xrController._lastXRPose.angularVelocity;
                this._tmpVector.set(av.x, av.y, av.z);
                controllerData.impostor.setAngularVelocity(this._tmpVector);
            } else if (!comparedQuaternion.equalsWithEpsilon(controllerMesh.rotationQuaternion)) {
                // roughly based on this - https://www.gamedev.net/forums/topic/347752-quaternion-and-angular-velocity/
                comparedQuaternion.conjugateInPlace().multiplyToRef(controllerMesh.rotationQuaternion, this._tmpQuaternion);
                const len = Math.sqrt(this._tmpQuaternion.x * this._tmpQuaternion.x + this._tmpQuaternion.y * this._tmpQuaternion.y + this._tmpQuaternion.z * this._tmpQuaternion.z);
                this._tmpVector.set(this._tmpQuaternion.x, this._tmpQuaternion.y, this._tmpQuaternion.z);
                // define a better epsilon
                if (len < 0.001) this._tmpVector.scaleInPlace(2);
                else {
                    const angle = 2 * Math.atan2(len, this._tmpQuaternion.w);
                    this._tmpVector.scaleInPlace(angle / (len * (this._delta / 1000)));
                }
                controllerData.impostor.setAngularVelocity(this._tmpVector);
            }
            comparedQuaternion.copyFrom(controllerMesh.rotationQuaternion);
            if (this._debugMode) (0, $kVtWi.Logger).Log([
                this._tmpVector,
                this._tmpQuaternion,
                "angular"
            ]);
        });
    }
    _detachController(xrControllerUniqueId) {
        const controllerData = this._controllers[xrControllerUniqueId];
        if (!controllerData) return;
        if (controllerData.impostorMesh) controllerData.impostorMesh.dispose();
        // remove from the map
        delete this._controllers[xrControllerUniqueId];
    }
}
/**
 * The module's name
 */ $b967b327731a9e24$export$41683fed620f0ca6.Name = (0, $cJN7d.WebXRFeatureName).PHYSICS_CONTROLLERS;
/**
 * The (Babylon) version of this module.
 * This is an integer representing the implementation version.
 * This number does not correspond to the webxr specs version
 */ $b967b327731a9e24$export$41683fed620f0ca6.Version = 1;
//register the plugin
(0, $cJN7d.WebXRFeaturesManager).AddWebXRFeature($b967b327731a9e24$export$41683fed620f0ca6.Name, (xrSessionManager, options)=>{
    return ()=>new $b967b327731a9e24$export$41683fed620f0ca6(xrSessionManager, options);
}, $b967b327731a9e24$export$41683fed620f0ca6.Version, true);

});

parcelRegister("adMiy", function(module, exports) {

$parcel$export(module.exports, "WebXRHitTest", () => $771095497f7800d7$export$81c0ac2cfb41508b);

var $cJN7d = parcelRequire("cJN7d");

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $2YzP2 = parcelRequire("2YzP2");

var $bOhSV = parcelRequire("bOhSV");
class $771095497f7800d7$export$81c0ac2cfb41508b extends (0, $2YzP2.WebXRAbstractFeature) {
    /**
     * Creates a new instance of the hit test feature
     * @param _xrSessionManager an instance of WebXRSessionManager
     * @param options options to use when constructing this feature
     */ constructor(_xrSessionManager, /**
     * options to use when constructing this feature
     */ options = {}){
        super(_xrSessionManager);
        this.options = options;
        this._tmpMat = new (0, $ha1VO.Matrix)();
        this._tmpPos = new (0, $ha1VO.Vector3)();
        this._tmpQuat = new (0, $ha1VO.Quaternion)();
        this._initHitTestSource = (referenceSpace)=>{
            if (!referenceSpace) return;
            const offsetRay = new XRRay(this.options.offsetRay || {});
            const hitTestOptions = {
                space: this.options.useReferenceSpace ? referenceSpace : this._xrSessionManager.viewerReferenceSpace,
                offsetRay: offsetRay
            };
            if (this.options.entityTypes) hitTestOptions.entityTypes = this.options.entityTypes;
            if (!hitTestOptions.space) {
                (0, $bOhSV.Tools).Warn("waiting for viewer reference space to initialize");
                return;
            }
            this._xrSessionManager.session.requestHitTestSource(hitTestOptions).then((hitTestSource)=>{
                if (this._xrHitTestSource) this._xrHitTestSource.cancel();
                this._xrHitTestSource = hitTestSource;
            });
        };
        /**
         * When set to true, each hit test will have its own position/rotation objects
         * When set to false, position and rotation objects will be reused for each hit test. It is expected that
         * the developers will clone them or copy them as they see fit.
         */ this.autoCloneTransformation = false;
        /**
         * Triggered when new babylon (transformed) hit test results are available
         * Note - this will be called when results come back from the device. It can be an empty array!!
         */ this.onHitTestResultObservable = new (0, $diGQf.Observable)();
        /**
         * Use this to temporarily pause hit test checks.
         */ this.paused = false;
        this.xrNativeFeatureName = "hit-test";
        (0, $bOhSV.Tools).Warn("Hit test is an experimental and unstable feature.");
    }
    /**
     * attach this feature
     * Will usually be called by the features manager
     *
     * @returns true if successful.
     */ attach() {
        if (!super.attach()) return false;
        // Feature enabled, but not available
        if (!this._xrSessionManager.session.requestHitTestSource) return false;
        if (!this.options.disablePermanentHitTest) {
            if (this._xrSessionManager.referenceSpace) this._initHitTestSource(this._xrSessionManager.referenceSpace);
            this._xrSessionManager.onXRReferenceSpaceChanged.add(this._initHitTestSource);
        }
        if (this.options.enableTransientHitTest) {
            const offsetRay = new XRRay(this.options.transientOffsetRay || {});
            this._xrSessionManager.session.requestHitTestSourceForTransientInput({
                profile: this.options.transientHitTestProfile || "generic-touchscreen",
                offsetRay: offsetRay,
                entityTypes: this.options.entityTypes
            }).then((hitSource)=>{
                this._transientXrHitTestSource = hitSource;
            });
        }
        return true;
    }
    /**
     * detach this feature.
     * Will usually be called by the features manager
     *
     * @returns true if successful.
     */ detach() {
        if (!super.detach()) return false;
        if (this._xrHitTestSource) {
            this._xrHitTestSource.cancel();
            this._xrHitTestSource = null;
        }
        this._xrSessionManager.onXRReferenceSpaceChanged.removeCallback(this._initHitTestSource);
        if (this._transientXrHitTestSource) {
            this._transientXrHitTestSource.cancel();
            this._transientXrHitTestSource = null;
        }
        return true;
    }
    /**
     * Dispose this feature and all of the resources attached
     */ dispose() {
        super.dispose();
        this.onHitTestResultObservable.clear();
    }
    _onXRFrame(frame) {
        // make sure we do nothing if (async) not attached
        if (!this.attached || this.paused) return;
        if (this._xrHitTestSource) {
            const results = frame.getHitTestResults(this._xrHitTestSource);
            this._processWebXRHitTestResult(results);
        }
        if (this._transientXrHitTestSource) {
            const hitTestResultsPerInputSource = frame.getHitTestResultsForTransientInput(this._transientXrHitTestSource);
            hitTestResultsPerInputSource.forEach((resultsPerInputSource)=>{
                this._processWebXRHitTestResult(resultsPerInputSource.results, resultsPerInputSource.inputSource);
            });
        }
    }
    _processWebXRHitTestResult(hitTestResults, inputSource) {
        const results = [];
        hitTestResults.forEach((hitTestResult)=>{
            const pose = hitTestResult.getPose(this._xrSessionManager.referenceSpace);
            if (!pose) return;
            const pos = pose.transform.position;
            const quat = pose.transform.orientation;
            this._tmpPos.set(pos.x, pos.y, pos.z).scaleInPlace(this._xrSessionManager.worldScalingFactor);
            this._tmpQuat.set(quat.x, quat.y, quat.z, quat.w);
            (0, $ha1VO.Matrix).FromFloat32ArrayToRefScaled(pose.transform.matrix, 0, 1, this._tmpMat);
            if (!this._xrSessionManager.scene.useRightHandedSystem) {
                this._tmpPos.z *= -1;
                this._tmpQuat.z *= -1;
                this._tmpQuat.w *= -1;
                this._tmpMat.toggleModelMatrixHandInPlace();
            }
            const result = {
                position: this.autoCloneTransformation ? this._tmpPos.clone() : this._tmpPos,
                rotationQuaternion: this.autoCloneTransformation ? this._tmpQuat.clone() : this._tmpQuat,
                transformationMatrix: this.autoCloneTransformation ? this._tmpMat.clone() : this._tmpMat,
                inputSource: inputSource,
                isTransient: !!inputSource,
                xrHitResult: hitTestResult
            };
            results.push(result);
        });
        this.onHitTestResultObservable.notifyObservers(results);
    }
}
/**
 * The module's name
 */ $771095497f7800d7$export$81c0ac2cfb41508b.Name = (0, $cJN7d.WebXRFeatureName).HIT_TEST;
/**
 * The (Babylon) version of this module.
 * This is an integer representing the implementation version.
 * This number does not correspond to the WebXR specs version
 */ $771095497f7800d7$export$81c0ac2cfb41508b.Version = 2;
//register the plugin versions
(0, $cJN7d.WebXRFeaturesManager).AddWebXRFeature($771095497f7800d7$export$81c0ac2cfb41508b.Name, (xrSessionManager, options)=>{
    return ()=>new $771095497f7800d7$export$81c0ac2cfb41508b(xrSessionManager, options);
}, $771095497f7800d7$export$81c0ac2cfb41508b.Version, false);

});

parcelRegister("gCh0b", function(module, exports) {

$parcel$export(module.exports, "WebXRFeaturePointSystem", () => $c18d622cceef42ae$export$2d46dfbb9b4334e1);

var $cJN7d = parcelRequire("cJN7d");

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $2YzP2 = parcelRequire("2YzP2");
class $c18d622cceef42ae$export$2d46dfbb9b4334e1 extends (0, $2YzP2.WebXRAbstractFeature) {
    /**
     * The current feature point cloud maintained across frames.
     */ get featurePointCloud() {
        return this._featurePointCloud;
    }
    /**
     * construct the feature point system
     * @param _xrSessionManager an instance of xr Session manager
     */ constructor(_xrSessionManager){
        super(_xrSessionManager);
        this._enabled = false;
        this._featurePointCloud = [];
        /**
         * Observers registered here will be executed whenever new feature points are added (on XRFrame while the session is tracking).
         * Will notify the observers about which feature points have been added.
         */ this.onFeaturePointsAddedObservable = new (0, $diGQf.Observable)();
        /**
         * Observers registered here will be executed whenever a feature point has been updated (on XRFrame while the session is tracking).
         * Will notify the observers about which feature points have been updated.
         */ this.onFeaturePointsUpdatedObservable = new (0, $diGQf.Observable)();
        this.xrNativeFeatureName = "bjsfeature-points";
        if (this._xrSessionManager.session) this._init();
        else this._xrSessionManager.onXRSessionInit.addOnce(()=>{
            this._init();
        });
    }
    /**
     * Detach this feature.
     * Will usually be called by the features manager
     *
     * @returns true if successful.
     */ detach() {
        if (!super.detach()) return false;
        this.featurePointCloud.length = 0;
        return true;
    }
    /**
     * Dispose this feature and all of the resources attached
     */ dispose() {
        super.dispose();
        this._featurePointCloud.length = 0;
        this.onFeaturePointsUpdatedObservable.clear();
        this.onFeaturePointsAddedObservable.clear();
    }
    /**
     * On receiving a new XR frame if this feature is attached notify observers new feature point data is available.
     * @param frame
     */ _onXRFrame(frame) {
        if (!this.attached || !this._enabled || !frame) return;
        const featurePointRawData = frame.featurePointCloud;
        if (!featurePointRawData || featurePointRawData.length === 0) return;
        else {
            if (featurePointRawData.length % 5 !== 0) throw new Error("Received malformed feature point cloud of length: " + featurePointRawData.length);
            const numberOfFeaturePoints = featurePointRawData.length / 5;
            const updatedFeaturePoints = [];
            const addedFeaturePoints = [];
            for(let i = 0; i < numberOfFeaturePoints; i++){
                const rawIndex = i * 5;
                const id = featurePointRawData[rawIndex + 4];
                // IDs should be durable across frames and strictly increasing from 0 up, so use them as indexing into the feature point array.
                if (!this._featurePointCloud[id]) {
                    this._featurePointCloud[id] = {
                        position: new (0, $ha1VO.Vector3)(),
                        confidenceValue: 0
                    };
                    addedFeaturePoints.push(id);
                } else updatedFeaturePoints.push(id);
                // Set the feature point values.
                this._featurePointCloud[id].position.x = featurePointRawData[rawIndex];
                this._featurePointCloud[id].position.y = featurePointRawData[rawIndex + 1];
                this._featurePointCloud[id].position.z = featurePointRawData[rawIndex + 2];
                this._featurePointCloud[id].confidenceValue = featurePointRawData[rawIndex + 3];
            }
            // Signal observers that feature points have been added if necessary.
            if (addedFeaturePoints.length > 0) this.onFeaturePointsAddedObservable.notifyObservers(addedFeaturePoints);
            // Signal observers that feature points have been updated if necessary.
            if (updatedFeaturePoints.length > 0) this.onFeaturePointsUpdatedObservable.notifyObservers(updatedFeaturePoints);
        }
    }
    /**
     * Initializes the feature. If the feature point feature is not available for this environment do not mark the feature as enabled.
     */ _init() {
        if (!this._xrSessionManager.session.trySetFeaturePointCloudEnabled || !this._xrSessionManager.session.trySetFeaturePointCloudEnabled(true)) // fail silently
        return;
        this._enabled = true;
    }
}
/**
 * The module's name
 */ $c18d622cceef42ae$export$2d46dfbb9b4334e1.Name = (0, $cJN7d.WebXRFeatureName).FEATURE_POINTS;
/**
 * The (Babylon) version of this module.
 * This is an integer representing the implementation version.
 * This number does not correspond to the WebXR specs version
 */ $c18d622cceef42ae$export$2d46dfbb9b4334e1.Version = 1;
// register the plugin
(0, $cJN7d.WebXRFeaturesManager).AddWebXRFeature($c18d622cceef42ae$export$2d46dfbb9b4334e1.Name, (xrSessionManager)=>{
    return ()=>new $c18d622cceef42ae$export$2d46dfbb9b4334e1(xrSessionManager);
}, $c18d622cceef42ae$export$2d46dfbb9b4334e1.Version);

});

parcelRegister("2IkTP", function(module, exports) {

$parcel$export(module.exports, "WebXRMeshDetector", () => $1f9fe7066a421a78$export$9ccd77182f2525ba);

var $cJN7d = parcelRequire("cJN7d");

var $2YzP2 = parcelRequire("2YzP2");
parcelRequire("6rxfP");
var $ha1VO = parcelRequire("ha1VO");

var $diGQf = parcelRequire("diGQf");

var $fbuqw = parcelRequire("fbuqw");

var $b4i1f = parcelRequire("b4i1f");

var $kVtWi = parcelRequire("kVtWi");
let $1f9fe7066a421a78$var$meshIdProvider = 0;
class $1f9fe7066a421a78$export$9ccd77182f2525ba extends (0, $2YzP2.WebXRAbstractFeature) {
    constructor(_xrSessionManager, _options = {}){
        super(_xrSessionManager);
        this._options = _options;
        this._detectedMeshes = new Map();
        /**
         * Observers registered here will be executed when a new mesh was added to the session
         */ this.onMeshAddedObservable = new (0, $diGQf.Observable)();
        /**
         * Observers registered here will be executed when a mesh is no longer detected in the session
         */ this.onMeshRemovedObservable = new (0, $diGQf.Observable)();
        /**
         * Observers registered here will be executed when an existing mesh updates
         */ this.onMeshUpdatedObservable = new (0, $diGQf.Observable)();
        this.xrNativeFeatureName = "mesh-detection";
        if (this._options.generateMeshes) this._options.convertCoordinateSystems = true;
        if (this._xrSessionManager.session) this._init();
        else this._xrSessionManager.onXRSessionInit.addOnce(()=>{
            this._init();
        });
    }
    detach() {
        if (!super.detach()) return false;
        // Only supported by BabylonNative
        if (!!this._xrSessionManager.isNative && !!this._xrSessionManager.session.trySetMeshDetectorEnabled) this._xrSessionManager.session.trySetMeshDetectorEnabled(false);
        if (!this._options.doNotRemoveMeshesOnSessionEnded) {
            this._detectedMeshes.forEach((mesh)=>{
                this.onMeshRemovedObservable.notifyObservers(mesh);
            });
            this._detectedMeshes.clear();
        }
        return true;
    }
    dispose() {
        super.dispose();
        this.onMeshAddedObservable.clear();
        this.onMeshRemovedObservable.clear();
        this.onMeshUpdatedObservable.clear();
    }
    _onXRFrame(frame) {
        // TODO remove try catch
        try {
            if (!this.attached || !frame) return;
            // babylon native XR and webxr support
            const detectedMeshes = frame.detectedMeshes || frame.worldInformation?.detectedMeshes;
            if (detectedMeshes) {
                const toRemove = new Set();
                this._detectedMeshes.forEach((vertexData, xrMesh)=>{
                    if (!detectedMeshes.has(xrMesh)) toRemove.add(xrMesh);
                });
                toRemove.forEach((xrMesh)=>{
                    const vertexData = this._detectedMeshes.get(xrMesh);
                    if (vertexData) {
                        this.onMeshRemovedObservable.notifyObservers(vertexData);
                        this._detectedMeshes.delete(xrMesh);
                    }
                });
                // now check for new ones
                detectedMeshes.forEach((xrMesh)=>{
                    if (!this._detectedMeshes.has(xrMesh)) {
                        const partialVertexData = {
                            id: $1f9fe7066a421a78$var$meshIdProvider++,
                            xrMesh: xrMesh
                        };
                        const vertexData = this._updateVertexDataWithXRMesh(xrMesh, partialVertexData, frame);
                        this._detectedMeshes.set(xrMesh, vertexData);
                        this.onMeshAddedObservable.notifyObservers(vertexData);
                    } else // updated?
                    if (xrMesh.lastChangedTime === this._xrSessionManager.currentTimestamp) {
                        const vertexData = this._detectedMeshes.get(xrMesh);
                        if (vertexData) {
                            this._updateVertexDataWithXRMesh(xrMesh, vertexData, frame);
                            this.onMeshUpdatedObservable.notifyObservers(vertexData);
                        }
                    }
                });
            }
        } catch (error) {
            (0, $kVtWi.Logger).Log(error.stack);
        }
    }
    _init() {
        // Only supported by BabylonNative
        if (this._xrSessionManager.isNative) {
            if (this._xrSessionManager.session.trySetMeshDetectorEnabled) this._xrSessionManager.session.trySetMeshDetectorEnabled(true);
            if (!!this._options.preferredDetectorOptions && !!this._xrSessionManager.session.trySetPreferredMeshDetectorOptions) this._xrSessionManager.session.trySetPreferredMeshDetectorOptions(this._options.preferredDetectorOptions);
        }
    }
    _updateVertexDataWithXRMesh(xrMesh, mesh, xrFrame) {
        mesh.xrMesh = xrMesh;
        mesh.worldParentNode = this._options.worldParentNode;
        const positions = xrMesh.vertices || xrMesh.positions;
        if (this._options.convertCoordinateSystems) {
            if (!this._xrSessionManager.scene.useRightHandedSystem) {
                mesh.positions = new Float32Array(positions.length);
                for(let i = 0; i < positions.length; i += 3){
                    mesh.positions[i] = positions[i];
                    mesh.positions[i + 1] = positions[i + 1];
                    mesh.positions[i + 2] = -1 * positions[i + 2];
                }
                if (xrMesh.normals) {
                    mesh.normals = new Float32Array(xrMesh.normals.length);
                    for(let i = 0; i < xrMesh.normals.length; i += 3){
                        mesh.normals[i] = xrMesh.normals[i];
                        mesh.normals[i + 1] = xrMesh.normals[i + 1];
                        mesh.normals[i + 2] = -1 * xrMesh.normals[i + 2];
                    }
                }
            } else {
                mesh.positions = positions;
                mesh.normals = xrMesh.normals;
            }
            // WebXR should provide indices in a counterclockwise winding order regardless of coordinate system handedness
            mesh.indices = xrMesh.indices;
            // matrix
            const pose = xrFrame.getPose(xrMesh.meshSpace, this._xrSessionManager.referenceSpace);
            if (pose) {
                const mat = mesh.transformationMatrix || new (0, $ha1VO.Matrix)();
                (0, $ha1VO.Matrix).FromArrayToRef(pose.transform.matrix, 0, mat);
                if (!this._xrSessionManager.scene.useRightHandedSystem) mat.toggleModelMatrixHandInPlace();
                mesh.transformationMatrix = mat;
                if (this._options.worldParentNode) mat.multiplyToRef(this._options.worldParentNode.getWorldMatrix(), mat);
            }
            if (this._options.generateMeshes) {
                if (!mesh.mesh) {
                    const generatedMesh = new (0, $fbuqw.Mesh)("xr mesh " + mesh.id, this._xrSessionManager.scene);
                    generatedMesh.rotationQuaternion = new (0, $ha1VO.Quaternion)();
                    generatedMesh.setVerticesData((0, $b4i1f.VertexBuffer).PositionKind, mesh.positions);
                    if (mesh.normals) generatedMesh.setVerticesData((0, $b4i1f.VertexBuffer).NormalKind, mesh.normals);
                    else generatedMesh.createNormals(true);
                    generatedMesh.setIndices(mesh.indices, undefined, true);
                    mesh.mesh = generatedMesh;
                } else {
                    const generatedMesh = mesh.mesh;
                    generatedMesh.updateVerticesData((0, $b4i1f.VertexBuffer).PositionKind, mesh.positions);
                    if (mesh.normals) generatedMesh.updateVerticesData((0, $b4i1f.VertexBuffer).NormalKind, mesh.normals);
                    else generatedMesh.createNormals(true);
                    generatedMesh.updateIndices(mesh.indices);
                }
                mesh.transformationMatrix?.decompose(mesh.mesh.scaling, mesh.mesh.rotationQuaternion, mesh.mesh.position);
            }
        }
        return mesh;
    }
}
/**
 * The module's name
 */ $1f9fe7066a421a78$export$9ccd77182f2525ba.Name = (0, $cJN7d.WebXRFeatureName).MESH_DETECTION;
/**
 * The (Babylon) version of this module.
 * This is an integer representing the implementation version.
 * This number does not correspond to the WebXR specs version
 */ $1f9fe7066a421a78$export$9ccd77182f2525ba.Version = 1;
(0, $cJN7d.WebXRFeaturesManager).AddWebXRFeature($1f9fe7066a421a78$export$9ccd77182f2525ba.Name, (xrSessionManager, options)=>{
    return ()=>new $1f9fe7066a421a78$export$9ccd77182f2525ba(xrSessionManager, options);
}, $1f9fe7066a421a78$export$9ccd77182f2525ba.Version, false);

});

parcelRegister("7KWwg", function(module, exports) {

$parcel$export(module.exports, "WebXRImageTracking", () => $5a5a390558ba8109$export$28bf91e3a461309f);

var $cJN7d = parcelRequire("cJN7d");

var $diGQf = parcelRequire("diGQf");

var $2YzP2 = parcelRequire("2YzP2");

var $ha1VO = parcelRequire("ha1VO");

var $bOhSV = parcelRequire("bOhSV");
/**
 * Enum that describes the state of the image trackability score status for this session.
 */ var $5a5a390558ba8109$var$ImageTrackingScoreStatus;
(function(ImageTrackingScoreStatus) {
    // AR Session has not yet assessed image trackability scores.
    ImageTrackingScoreStatus[ImageTrackingScoreStatus["NotReceived"] = 0] = "NotReceived";
    // A request to retrieve trackability scores has been sent, but no response has been received.
    ImageTrackingScoreStatus[ImageTrackingScoreStatus["Waiting"] = 1] = "Waiting";
    // Image trackability scores have been received for this session
    ImageTrackingScoreStatus[ImageTrackingScoreStatus["Received"] = 2] = "Received";
})($5a5a390558ba8109$var$ImageTrackingScoreStatus || ($5a5a390558ba8109$var$ImageTrackingScoreStatus = {}));
class $5a5a390558ba8109$export$28bf91e3a461309f extends (0, $2YzP2.WebXRAbstractFeature) {
    /**
     * constructs the image tracking feature
     * @param _xrSessionManager the session manager for this module
     * @param options read-only options to be used in this module
     */ constructor(_xrSessionManager, /**
     * read-only options to be used in this module
     */ options){
        super(_xrSessionManager);
        this.options = options;
        /**
         * This will be triggered if the underlying system deems an image untrackable.
         * The index is the index of the image from the array used to initialize the feature.
         */ this.onUntrackableImageFoundObservable = new (0, $diGQf.Observable)();
        /**
         * An image was deemed trackable, and the system will start tracking it.
         */ this.onTrackableImageFoundObservable = new (0, $diGQf.Observable)();
        /**
         * The image was found and its state was updated.
         */ this.onTrackedImageUpdatedObservable = new (0, $diGQf.Observable)();
        this._trackableScoreStatus = $5a5a390558ba8109$var$ImageTrackingScoreStatus.NotReceived;
        this._trackedImages = [];
        this.xrNativeFeatureName = "image-tracking";
    }
    /**
     * attach this feature
     * Will usually be called by the features manager
     *
     * @returns true if successful.
     */ attach() {
        return super.attach();
    }
    /**
     * detach this feature.
     * Will usually be called by the features manager
     *
     * @returns true if successful.
     */ detach() {
        return super.detach();
    }
    /**
     * Get a tracked image by its ID.
     *
     * @param id the id of the image to load (position in the init array)
     * @returns a trackable image, if exists in this location
     */ getTrackedImageById(id) {
        return this._trackedImages[id] || null;
    }
    /**
     * Dispose this feature and all of the resources attached
     */ dispose() {
        super.dispose();
        this._trackedImages.forEach((trackedImage)=>{
            trackedImage.originalBitmap.close();
        });
        this._trackedImages.length = 0;
        this.onTrackableImageFoundObservable.clear();
        this.onUntrackableImageFoundObservable.clear();
        this.onTrackedImageUpdatedObservable.clear();
    }
    /**
     * Extends the session init object if needed
     * @returns augmentation object fo the xr session init object.
     */ async getXRSessionInitExtension() {
        if (!this.options.images || !this.options.images.length) return {};
        const promises = this.options.images.map((image)=>{
            if (typeof image.src === "string") return this._xrSessionManager.scene.getEngine()._createImageBitmapFromSource(image.src);
            else return Promise.resolve(image.src); // resolve is probably unneeded
        });
        try {
            const images = await Promise.all(promises);
            this._originalTrackingRequest = images.map((image, idx)=>{
                return {
                    image: image,
                    widthInMeters: this.options.images[idx].estimatedRealWorldWidth
                };
            });
            return {
                trackedImages: this._originalTrackingRequest
            };
        } catch (ex) {
            (0, $bOhSV.Tools).Error("Error loading images for tracking, WebXRImageTracking disabled for this session.");
            return {};
        }
    }
    _onXRFrame(_xrFrame) {
        if (!_xrFrame.getImageTrackingResults || this._trackableScoreStatus === $5a5a390558ba8109$var$ImageTrackingScoreStatus.Waiting) return;
        // Image tracking scores may be generated a few frames after the XR Session initializes.
        // If we haven't received scores yet, then kick off the task to check scores and return immediately.
        if (this._trackableScoreStatus === $5a5a390558ba8109$var$ImageTrackingScoreStatus.NotReceived) {
            this._checkScoresAsync();
            return;
        }
        const imageTrackedResults = _xrFrame.getImageTrackingResults();
        for (const result of imageTrackedResults){
            let changed = false;
            const imageIndex = result.index;
            const imageObject = this._trackedImages[imageIndex];
            if (!imageObject) continue;
            imageObject.xrTrackingResult = result;
            if (imageObject.realWorldWidth !== result.measuredWidthInMeters) {
                imageObject.realWorldWidth = result.measuredWidthInMeters;
                changed = true;
            }
            // Get the pose of the image relative to a reference space.
            const pose = _xrFrame.getPose(result.imageSpace, this._xrSessionManager.referenceSpace);
            if (pose) {
                const mat = imageObject.transformationMatrix;
                (0, $ha1VO.Matrix).FromArrayToRef(pose.transform.matrix, 0, mat);
                if (!this._xrSessionManager.scene.useRightHandedSystem) mat.toggleModelMatrixHandInPlace();
                changed = true;
            }
            const state = result.trackingState;
            const emulated = state === "emulated";
            if (imageObject.emulated !== emulated) {
                imageObject.emulated = emulated;
                changed = true;
            }
            if (changed) this.onTrackedImageUpdatedObservable.notifyObservers(imageObject);
        }
    }
    async _checkScoresAsync() {
        if (!this._xrSessionManager.session.getTrackedImageScores || this._trackableScoreStatus !== $5a5a390558ba8109$var$ImageTrackingScoreStatus.NotReceived) return;
        this._trackableScoreStatus = $5a5a390558ba8109$var$ImageTrackingScoreStatus.Waiting;
        const imageScores = await this._xrSessionManager.session.getTrackedImageScores();
        if (!imageScores || imageScores.length === 0) {
            this._trackableScoreStatus = $5a5a390558ba8109$var$ImageTrackingScoreStatus.NotReceived;
            return;
        }
        // check the scores for all
        for(let idx = 0; idx < imageScores.length; ++idx)if (imageScores[idx] == "untrackable") this.onUntrackableImageFoundObservable.notifyObservers(idx);
        else {
            const originalBitmap = this._originalTrackingRequest[idx].image;
            const imageObject = {
                id: idx,
                originalBitmap: originalBitmap,
                transformationMatrix: new (0, $ha1VO.Matrix)(),
                ratio: originalBitmap.width / originalBitmap.height
            };
            this._trackedImages[idx] = imageObject;
            this.onTrackableImageFoundObservable.notifyObservers(imageObject);
        }
        this._trackableScoreStatus = imageScores.length > 0 ? $5a5a390558ba8109$var$ImageTrackingScoreStatus.Received : $5a5a390558ba8109$var$ImageTrackingScoreStatus.NotReceived;
    }
}
/**
 * The module's name
 */ $5a5a390558ba8109$export$28bf91e3a461309f.Name = (0, $cJN7d.WebXRFeatureName).IMAGE_TRACKING;
/**
 * The (Babylon) version of this module.
 * This is an integer representing the implementation version.
 * This number does not correspond to the WebXR specs version
 */ $5a5a390558ba8109$export$28bf91e3a461309f.Version = 1;
//register the plugin
(0, $cJN7d.WebXRFeaturesManager).AddWebXRFeature($5a5a390558ba8109$export$28bf91e3a461309f.Name, (xrSessionManager, options)=>{
    return ()=>new $5a5a390558ba8109$export$28bf91e3a461309f(xrSessionManager, options);
}, $5a5a390558ba8109$export$28bf91e3a461309f.Version, false);

});

parcelRegister("l1zzl", function(module, exports) {

$parcel$export(module.exports, "WebXRDomOverlay", () => $f4e548423bceabc5$export$2421bf101702414b);

var $bOhSV = parcelRequire("bOhSV");

var $cJN7d = parcelRequire("cJN7d");

var $2YzP2 = parcelRequire("2YzP2");
class $f4e548423bceabc5$export$2421bf101702414b extends (0, $2YzP2.WebXRAbstractFeature) {
    /**
     * Creates a new instance of the dom-overlay feature
     * @param _xrSessionManager an instance of WebXRSessionManager
     * @param options options to use when constructing this feature
     */ constructor(_xrSessionManager, /**
     * options to use when constructing this feature
     */ options){
        super(_xrSessionManager);
        this.options = options;
        /**
         * Type of overlay - non-null when available
         */ this._domOverlayType = null;
        /**
         * Event Listener to supress "beforexrselect" events.
         */ this._beforeXRSelectListener = null;
        /**
         * Element used for overlay
         */ this._element = null;
        this.xrNativeFeatureName = "dom-overlay";
        // https://immersive-web.github.io/dom-overlays/
        (0, $bOhSV.Tools).Warn("dom-overlay is an experimental and unstable feature.");
    }
    /**
     * attach this feature
     * Will usually be called by the features manager
     *
     * @returns true if successful.
     */ attach() {
        if (!super.attach()) return false;
        // Feature not available
        if (!this._xrSessionManager.session.domOverlayState || this._xrSessionManager.session.domOverlayState.type === null) return false;
        this._domOverlayType = this._xrSessionManager.session.domOverlayState.type;
        if (this._element !== null && this.options.supressXRSelectEvents === true) {
            this._beforeXRSelectListener = (ev)=>{
                ev.preventDefault();
            };
            this._element.addEventListener("beforexrselect", this._beforeXRSelectListener);
        }
        return true;
    }
    /**
     * The type of DOM overlay (null when not supported).  Provided by UA and remains unchanged for duration of session.
     */ get domOverlayType() {
        return this._domOverlayType;
    }
    /**
     * Dispose this feature and all of the resources attached
     */ dispose() {
        super.dispose();
        if (this._element !== null && this._beforeXRSelectListener) this._element.removeEventListener("beforexrselect", this._beforeXRSelectListener);
    }
    _onXRFrame(_xrFrame) {
    /* empty */ }
    /**
     * Extends the session init object if needed
     * @returns augmentation object for the xr session init object.
     */ async getXRSessionInitExtension() {
        if (this.options.element === undefined) {
            (0, $bOhSV.Tools).Warn('"element" option must be provided to attach xr-dom-overlay feature.');
            return {};
        } else if (typeof this.options.element === "string") {
            const selectedElement = document.querySelector(this.options.element);
            if (selectedElement === null) {
                (0, $bOhSV.Tools).Warn(`element not found '${this.options.element}' (not requesting xr-dom-overlay)`);
                return {};
            }
            this._element = selectedElement;
        } else this._element = this.options.element;
        return {
            domOverlay: {
                root: this._element
            }
        };
    }
}
/**
 * The module's name
 */ $f4e548423bceabc5$export$2421bf101702414b.Name = (0, $cJN7d.WebXRFeatureName).DOM_OVERLAY;
/**
 * The (Babylon) version of this module.
 * This is an integer representing the implementation version.
 * This number does not correspond to the WebXR specs version
 */ $f4e548423bceabc5$export$2421bf101702414b.Version = 1;
//register the plugin
(0, $cJN7d.WebXRFeaturesManager).AddWebXRFeature($f4e548423bceabc5$export$2421bf101702414b.Name, (xrSessionManager, options)=>{
    return ()=>new $f4e548423bceabc5$export$2421bf101702414b(xrSessionManager, options);
}, $f4e548423bceabc5$export$2421bf101702414b.Version, false);

});

parcelRegister("97flB", function(module, exports) {

$parcel$export(module.exports, "WebXRControllerMovement", () => $6a30ac28c606559e$export$d72a612fd7cafafa);

var $cJN7d = parcelRequire("cJN7d");

var $f9SMB = parcelRequire("f9SMB");

var $ha1VO = parcelRequire("ha1VO");

var $2YzP2 = parcelRequire("2YzP2");

var $bOhSV = parcelRequire("bOhSV");
class $6a30ac28c606559e$export$d72a612fd7cafafa extends (0, $2YzP2.WebXRAbstractFeature) {
    /**
     * Current movement direction.  Will be null before XR Frames have been processed.
     */ get movementDirection() {
        return this._movementDirection;
    }
    /**
     * Is movement enabled
     */ get movementEnabled() {
        return this._featureContext.movementEnabled;
    }
    /**
     * Sets whether movement is enabled or not
     * @param enabled is movement enabled
     */ set movementEnabled(enabled) {
        this._featureContext.movementEnabled = enabled;
    }
    /**
     * If movement follows viewer pose
     */ get movementOrientationFollowsViewerPose() {
        return this._featureContext.movementOrientationFollowsViewerPose;
    }
    /**
     * Sets whether movement follows viewer pose
     * @param followsPose is movement should follow viewer pose
     */ set movementOrientationFollowsViewerPose(followsPose) {
        this._featureContext.movementOrientationFollowsViewerPose = followsPose;
    }
    /**
     * Gets movement speed
     */ get movementSpeed() {
        return this._featureContext.movementSpeed;
    }
    /**
     * Sets movement speed
     * @param movementSpeed movement speed
     */ set movementSpeed(movementSpeed) {
        this._featureContext.movementSpeed = movementSpeed;
    }
    /**
     * Gets minimum threshold the controller's thumbstick/touchpad must pass before being recognized for movement (avoids jitter/unintentional movement)
     */ get movementThreshold() {
        return this._featureContext.movementThreshold;
    }
    /**
     * Sets minimum threshold the controller's thumbstick/touchpad must pass before being recognized for movement (avoids jitter/unintentional movement)
     * @param movementThreshold new threshold
     */ set movementThreshold(movementThreshold) {
        this._featureContext.movementThreshold = movementThreshold;
    }
    /**
     * Is rotation enabled
     */ get rotationEnabled() {
        return this._featureContext.rotationEnabled;
    }
    /**
     * Sets whether rotation is enabled or not
     * @param enabled is rotation enabled
     */ set rotationEnabled(enabled) {
        this._featureContext.rotationEnabled = enabled;
    }
    /**
     * Gets rotation speed factor
     */ get rotationSpeed() {
        return this._featureContext.rotationSpeed;
    }
    /**
     * Sets rotation speed factor (1.0 is default)
     * @param rotationSpeed new rotation speed factor
     */ set rotationSpeed(rotationSpeed) {
        this._featureContext.rotationSpeed = rotationSpeed;
    }
    /**
     * Gets minimum threshold the controller's thumbstick/touchpad must pass before being recognized for rotation (avoids jitter/unintentional rotation)
     */ get rotationThreshold() {
        return this._featureContext.rotationThreshold;
    }
    /**
     * Sets minimum threshold the controller's thumbstick/touchpad must pass before being recognized for rotation (avoids jitter/unintentional rotation)
     * @param threshold new threshold
     */ set rotationThreshold(threshold) {
        this._featureContext.rotationThreshold = threshold;
    }
    /**
     * constructs a new movement controller system
     * @param _xrSessionManager an instance of WebXRSessionManager
     * @param options configuration object for this feature
     */ constructor(_xrSessionManager, options){
        super(_xrSessionManager);
        this._controllers = {};
        this._currentRegistrationConfigurations = [];
        // forward direction for movement, which may differ from viewer pose.
        this._movementDirection = new (0, $ha1VO.Quaternion)();
        // unused
        this._tmpRotationMatrix = (0, $ha1VO.Matrix).Identity();
        this._tmpTranslationDirection = new (0, $ha1VO.Vector3)();
        this._tmpMovementTranslation = new (0, $ha1VO.Vector3)();
        this._tempCacheQuaternion = new (0, $ha1VO.Quaternion)();
        this._attachController = (xrController)=>{
            if (this._controllers[xrController.uniqueId]) // already attached
            return;
            this._controllers[xrController.uniqueId] = {
                xrController: xrController,
                registeredComponents: []
            };
            const controllerData = this._controllers[xrController.uniqueId];
            // movement controller only available to gamepad-enabled input sources.
            if (controllerData.xrController.inputSource.targetRayMode === "tracked-pointer" && controllerData.xrController.inputSource.gamepad) {
                // motion controller support
                const initController = ()=>{
                    if (xrController.motionController) for (const registration of this._currentRegistrationConfigurations){
                        let component = null;
                        if (registration.allowedComponentTypes) for (const componentType of registration.allowedComponentTypes){
                            const componentOfType = xrController.motionController.getComponentOfType(componentType);
                            if (componentOfType !== null) {
                                component = componentOfType;
                                break;
                            }
                        }
                        if (registration.mainComponentOnly) {
                            const mainComponent = xrController.motionController.getMainComponent();
                            if (mainComponent === null) continue;
                            component = mainComponent;
                        }
                        if (typeof registration.componentSelectionPredicate === "function") // if does not match we do want to ignore a previously found component
                        component = registration.componentSelectionPredicate(xrController);
                        if (component && registration.forceHandedness) {
                            if (xrController.inputSource.handedness !== registration.forceHandedness) continue; // do not register
                        }
                        if (component === null) continue; // do not register
                        const registeredComponent = {
                            registrationConfiguration: registration,
                            component: component
                        };
                        controllerData.registeredComponents.push(registeredComponent);
                        if ("axisChangedHandler" in registration) registeredComponent.onAxisChangedObserver = component.onAxisValueChangedObservable.add((axesData)=>{
                            registration.axisChangedHandler(axesData, this._movementState, this._featureContext, this._xrInput);
                        });
                        if ("buttonChangedhandler" in registration) registeredComponent.onButtonChangedObserver = component.onButtonStateChangedObservable.add(()=>{
                            if (component.changes.pressed) registration.buttonChangedhandler(component.changes.pressed, this._movementState, this._featureContext, this._xrInput);
                        });
                    }
                };
                if (xrController.motionController) initController();
                else xrController.onMotionControllerInitObservable.addOnce(()=>{
                    initController();
                });
            }
        };
        if (!options || options.xrInput === undefined) {
            (0, $bOhSV.Tools).Error('WebXRControllerMovement feature requires "xrInput" option.');
            return;
        }
        if (Array.isArray(options.customRegistrationConfigurations)) this._currentRegistrationConfigurations = options.customRegistrationConfigurations;
        else this._currentRegistrationConfigurations = $6a30ac28c606559e$export$d72a612fd7cafafa.REGISTRATIONS.default;
        // synchronized from feature setter properties
        this._featureContext = {
            movementEnabled: options.movementEnabled || true,
            movementOrientationFollowsViewerPose: options.movementOrientationFollowsViewerPose ?? true,
            movementSpeed: options.movementSpeed ?? 1,
            movementThreshold: options.movementThreshold ?? 0.25,
            rotationEnabled: options.rotationEnabled ?? true,
            rotationSpeed: options.rotationSpeed ?? 1.0,
            rotationThreshold: options.rotationThreshold ?? 0.25
        };
        this._movementState = {
            moveX: 0,
            moveY: 0,
            rotateX: 0,
            rotateY: 0
        };
        this._xrInput = options.xrInput;
    }
    attach() {
        if (!super.attach()) return false;
        this._xrInput.controllers.forEach(this._attachController);
        this._addNewAttachObserver(this._xrInput.onControllerAddedObservable, this._attachController);
        this._addNewAttachObserver(this._xrInput.onControllerRemovedObservable, (controller)=>{
            // REMOVE the controller
            this._detachController(controller.uniqueId);
        });
        return true;
    }
    detach() {
        if (!super.detach()) return false;
        Object.keys(this._controllers).forEach((controllerId)=>{
            this._detachController(controllerId);
        });
        this._controllers = {};
        return true;
    }
    /**
     * Occurs on every XR frame.
     * @param _xrFrame
     */ _onXRFrame(_xrFrame) {
        if (!this.attached) return;
        if (this._movementState.rotateX !== 0 && this._featureContext.rotationEnabled) {
            // smooth rotation
            const deltaMillis = this._xrSessionManager.scene.getEngine().getDeltaTime();
            const rotationY = deltaMillis * 0.001 * this._featureContext.rotationSpeed * this._movementState.rotateX * (this._xrSessionManager.scene.useRightHandedSystem ? -1 : 1);
            if (this._featureContext.movementOrientationFollowsViewerPose) {
                this._xrInput.xrCamera.cameraRotation.y += rotationY;
                (0, $ha1VO.Quaternion).RotationYawPitchRollToRef(rotationY, 0, 0, this._tempCacheQuaternion);
                this._xrInput.xrCamera.rotationQuaternion.multiplyToRef(this._tempCacheQuaternion, this._movementDirection);
            } else {
                // movement orientation direction does not affect camera.  We use rotation speed multiplier
                // otherwise need to implement inertia and constraints for same feel as TargetCamera.
                (0, $ha1VO.Quaternion).RotationYawPitchRollToRef(rotationY * 3.0, 0, 0, this._tempCacheQuaternion);
                this._movementDirection.multiplyInPlace(this._tempCacheQuaternion);
            }
        } else if (this._featureContext.movementOrientationFollowsViewerPose) this._movementDirection.copyFrom(this._xrInput.xrCamera.rotationQuaternion);
        if ((this._movementState.moveX || this._movementState.moveY) && this._featureContext.movementEnabled) {
            (0, $ha1VO.Matrix).FromQuaternionToRef(this._movementDirection, this._tmpRotationMatrix);
            this._tmpTranslationDirection.set(this._movementState.moveX, 0, this._movementState.moveY * (this._xrSessionManager.scene.useRightHandedSystem ? 1.0 : -1));
            // move according to forward direction based on camera speed
            (0, $ha1VO.Vector3).TransformCoordinatesToRef(this._tmpTranslationDirection, this._tmpRotationMatrix, this._tmpMovementTranslation);
            this._tmpMovementTranslation.scaleInPlace(this._xrInput.xrCamera._computeLocalCameraSpeed() * this._featureContext.movementSpeed);
            this._xrInput.xrCamera.cameraDirection.addInPlace(this._tmpMovementTranslation);
        }
    }
    _detachController(xrControllerUniqueId) {
        const controllerData = this._controllers[xrControllerUniqueId];
        if (!controllerData) return;
        for (const registeredComponent of controllerData.registeredComponents){
            if (registeredComponent.onAxisChangedObserver) registeredComponent.component.onAxisValueChangedObservable.remove(registeredComponent.onAxisChangedObserver);
            if (registeredComponent.onButtonChangedObserver) registeredComponent.component.onButtonStateChangedObservable.remove(registeredComponent.onButtonChangedObserver);
        }
        // remove from the map
        delete this._controllers[xrControllerUniqueId];
    }
}
/**
 * The module's name
 */ $6a30ac28c606559e$export$d72a612fd7cafafa.Name = (0, $cJN7d.WebXRFeatureName).MOVEMENT;
/**
 * Standard controller configurations.
 */ $6a30ac28c606559e$export$d72a612fd7cafafa.REGISTRATIONS = {
    default: [
        {
            allowedComponentTypes: [
                (0, $f9SMB.WebXRControllerComponent).THUMBSTICK_TYPE,
                (0, $f9SMB.WebXRControllerComponent).TOUCHPAD_TYPE
            ],
            forceHandedness: "left",
            axisChangedHandler: (axes, movementState, featureContext)=>{
                movementState.rotateX = Math.abs(axes.x) > featureContext.rotationThreshold ? axes.x : 0;
                movementState.rotateY = Math.abs(axes.y) > featureContext.rotationThreshold ? axes.y : 0;
            }
        },
        {
            allowedComponentTypes: [
                (0, $f9SMB.WebXRControllerComponent).THUMBSTICK_TYPE,
                (0, $f9SMB.WebXRControllerComponent).TOUCHPAD_TYPE
            ],
            forceHandedness: "right",
            axisChangedHandler: (axes, movementState, featureContext)=>{
                movementState.moveX = Math.abs(axes.x) > featureContext.movementThreshold ? axes.x : 0;
                movementState.moveY = Math.abs(axes.y) > featureContext.movementThreshold ? axes.y : 0;
            }
        }
    ]
};
/**
 * The (Babylon) version of this module.
 * This is an integer representing the implementation version.
 * This number does not correspond to the webxr specs version
 */ $6a30ac28c606559e$export$d72a612fd7cafafa.Version = 1;
(0, $cJN7d.WebXRFeaturesManager).AddWebXRFeature($6a30ac28c606559e$export$d72a612fd7cafafa.Name, (xrSessionManager, options)=>{
    return ()=>new $6a30ac28c606559e$export$d72a612fd7cafafa(xrSessionManager, options);
}, $6a30ac28c606559e$export$d72a612fd7cafafa.Version, true);

});

parcelRegister("8Gdnk", function(module, exports) {

$parcel$export(module.exports, "WebXRLightEstimation", () => $651c9f04ae6aa160$export$97e374075269b469);

var $8ClRi = parcelRequire("8ClRi");

var $b9e4a = parcelRequire("b9e4a");

var $diGQf = parcelRequire("diGQf");

var $bOhSV = parcelRequire("bOhSV");

var $cJN7d = parcelRequire("cJN7d");

var $2YzP2 = parcelRequire("2YzP2");

var $7etnY = parcelRequire("7etnY");

var $ha1VO = parcelRequire("ha1VO");

var $btpzP = parcelRequire("btpzP");

var $akOl3 = parcelRequire("akOl3");

var $f3g09 = parcelRequire("f3g09");

var $1gEbu = parcelRequire("1gEbu");

var $9LfOV = parcelRequire("9LfOV");
class $651c9f04ae6aa160$export$97e374075269b469 extends (0, $2YzP2.WebXRAbstractFeature) {
    /**
     * Creates a new instance of the light estimation feature
     * @param _xrSessionManager an instance of WebXRSessionManager
     * @param options options to use when constructing this feature
     */ constructor(_xrSessionManager, /**
     * options to use when constructing this feature
     */ options){
        super(_xrSessionManager);
        this.options = options;
        this._canvasContext = null;
        this._reflectionCubeMap = null;
        this._xrLightEstimate = null;
        this._xrLightProbe = null;
        this._xrWebGLBinding = null;
        this._lightDirection = (0, $ha1VO.Vector3).Up().negateInPlace();
        this._lightColor = (0, $7etnY.Color3).White();
        this._intensity = 1;
        this._sphericalHarmonics = new (0, $f3g09.SphericalHarmonics)();
        this._cubeMapPollTime = Date.now();
        this._lightEstimationPollTime = Date.now();
        /**
         * ARCore's reflection cube map size is 16x16.
         * Once other systems support this feature we will need to change this to be dynamic.
         * see https://github.com/immersive-web/lighting-estimation/blob/main/lighting-estimation-explainer.md#cube-map-open-questions
         */ this._reflectionCubeMapTextureSize = 16;
        /**
         * If createDirectionalLightSource is set to true this light source will be created automatically.
         * Otherwise this can be set with an external directional light source.
         * This light will be updated whenever the light estimation values change.
         */ this.directionalLight = null;
        /**
         * This observable will notify when the reflection cube map is updated.
         */ this.onReflectionCubeMapUpdatedObservable = new (0, $diGQf.Observable)();
        /**
         * Event Listener for "reflectionchange" events.
         */ this._updateReflectionCubeMap = ()=>{
            if (!this._xrLightProbe) return;
            // check poll time, do not update if it has not been long enough
            if (this.options.cubeMapPollInterval) {
                const now = Date.now();
                if (now - this._cubeMapPollTime < this.options.cubeMapPollInterval) return;
                this._cubeMapPollTime = now;
            }
            const lp = this._getXRGLBinding().getReflectionCubeMap(this._xrLightProbe);
            if (lp && this._reflectionCubeMap) {
                if (!this._reflectionCubeMap._texture) {
                    const internalTexture = new (0, $b9e4a.InternalTexture)(this._xrSessionManager.scene.getEngine(), (0, $b9e4a.InternalTextureSource).Unknown);
                    internalTexture.isCube = true;
                    internalTexture.invertY = false;
                    internalTexture._useSRGBBuffer = this.options.reflectionFormat === "srgba8";
                    internalTexture.format = 5;
                    internalTexture.generateMipMaps = true;
                    internalTexture.type = this.options.reflectionFormat !== "srgba8" ? 2 : 0;
                    internalTexture.samplingMode = 3;
                    internalTexture.width = this._reflectionCubeMapTextureSize;
                    internalTexture.height = this._reflectionCubeMapTextureSize;
                    internalTexture._cachedWrapU = 1;
                    internalTexture._cachedWrapV = 1;
                    internalTexture._hardwareTexture = new (0, $8ClRi.WebGLHardwareTexture)(lp, this._getCanvasContext());
                    this._reflectionCubeMap._texture = internalTexture;
                } else {
                    this._reflectionCubeMap._texture._hardwareTexture?.set(lp);
                    this._reflectionCubeMap._texture.getEngine().resetTextureCache();
                }
                this._reflectionCubeMap._texture.isReady = true;
                if (!this.options.disablePreFiltering) {
                    this._xrLightProbe.removeEventListener("reflectionchange", this._updateReflectionCubeMap);
                    this._hdrFilter.prefilter(this._reflectionCubeMap).then(()=>{
                        this._xrSessionManager.scene.markAllMaterialsAsDirty(1);
                        this.onReflectionCubeMapUpdatedObservable.notifyObservers(this._reflectionCubeMap);
                        this._xrLightProbe.addEventListener("reflectionchange", this._updateReflectionCubeMap);
                    });
                } else {
                    this._xrSessionManager.scene.markAllMaterialsAsDirty(1);
                    this.onReflectionCubeMapUpdatedObservable.notifyObservers(this._reflectionCubeMap);
                }
            }
        };
        this.xrNativeFeatureName = "light-estimation";
        if (this.options.createDirectionalLightSource) {
            this.directionalLight = new (0, $btpzP.DirectionalLight)("light estimation directional", this._lightDirection, this._xrSessionManager.scene);
            this.directionalLight.position = new (0, $ha1VO.Vector3)(0, 8, 0);
            // intensity will be set later
            this.directionalLight.intensity = 0;
            this.directionalLight.falloffType = (0, $1gEbu.LightConstants).FALLOFF_GLTF;
        }
        this._hdrFilter = new (0, $9LfOV.HDRFiltering)(this._xrSessionManager.scene.getEngine());
        // https://immersive-web.github.io/lighting-estimation/
        (0, $bOhSV.Tools).Warn("light-estimation is an experimental and unstable feature.");
    }
    /**
     * While the estimated cube map is expected to update over time to better reflect the user's environment as they move around those changes are unlikely to happen with every XRFrame.
     * Since creating and processing the cube map is potentially expensive, especially if mip maps are needed, you can listen to the onReflectionCubeMapUpdatedObservable to determine
     * when it has been updated.
     */ get reflectionCubeMapTexture() {
        return this._reflectionCubeMap;
    }
    /**
     * The most recent light estimate.  Available starting on the first frame where the device provides a light probe.
     */ get xrLightingEstimate() {
        if (this._xrLightEstimate) return {
            lightColor: this._lightColor,
            lightDirection: this._lightDirection,
            lightIntensity: this._intensity,
            sphericalHarmonics: this._sphericalHarmonics
        };
        return this._xrLightEstimate;
    }
    _getCanvasContext() {
        if (this._canvasContext === null) this._canvasContext = this._xrSessionManager.scene.getEngine()._gl;
        return this._canvasContext;
    }
    _getXRGLBinding() {
        if (this._xrWebGLBinding === null) {
            const context = this._getCanvasContext();
            this._xrWebGLBinding = new XRWebGLBinding(this._xrSessionManager.session, context);
        }
        return this._xrWebGLBinding;
    }
    /**
     * attach this feature
     * Will usually be called by the features manager
     *
     * @returns true if successful.
     */ attach() {
        if (!super.attach()) return false;
        const reflectionFormat = this.options.reflectionFormat ?? (this._xrSessionManager.session.preferredReflectionFormat || "srgba8");
        this.options.reflectionFormat = reflectionFormat;
        this._xrSessionManager.session.requestLightProbe({
            reflectionFormat: reflectionFormat
        }).then((xrLightProbe)=>{
            this._xrLightProbe = xrLightProbe;
            if (!this.options.disableCubeMapReflection) {
                if (!this._reflectionCubeMap) {
                    this._reflectionCubeMap = new (0, $akOl3.BaseTexture)(this._xrSessionManager.scene);
                    this._reflectionCubeMap._isCube = true;
                    this._reflectionCubeMap.coordinatesMode = 3;
                    if (this.options.setSceneEnvironmentTexture) this._xrSessionManager.scene.environmentTexture = this._reflectionCubeMap;
                }
                this._xrLightProbe.addEventListener("reflectionchange", this._updateReflectionCubeMap);
            }
        });
        return true;
    }
    /**
     * detach this feature.
     * Will usually be called by the features manager
     *
     * @returns true if successful.
     */ detach() {
        const detached = super.detach();
        if (this._xrLightProbe !== null && !this.options.disableCubeMapReflection) {
            this._xrLightProbe.removeEventListener("reflectionchange", this._updateReflectionCubeMap);
            this._xrLightProbe = null;
        }
        this._canvasContext = null;
        this._xrLightEstimate = null;
        // When the session ends (on detach) we must clear our XRWebGLBinging instance, which references the ended session.
        this._xrWebGLBinding = null;
        return detached;
    }
    /**
     * Dispose this feature and all of the resources attached
     */ dispose() {
        super.dispose();
        this.onReflectionCubeMapUpdatedObservable.clear();
        if (this.directionalLight) {
            this.directionalLight.dispose();
            this.directionalLight = null;
        }
        if (this._reflectionCubeMap !== null) {
            if (this._reflectionCubeMap._texture) this._reflectionCubeMap._texture.dispose();
            this._reflectionCubeMap.dispose();
            this._reflectionCubeMap = null;
        }
    }
    _onXRFrame(_xrFrame) {
        if (this._xrLightProbe !== null) {
            if (this.options.lightEstimationPollInterval) {
                const now = Date.now();
                if (now - this._lightEstimationPollTime < this.options.lightEstimationPollInterval) return;
                this._lightEstimationPollTime = now;
            }
            this._xrLightEstimate = _xrFrame.getLightEstimate(this._xrLightProbe);
            if (this._xrLightEstimate) {
                this._intensity = Math.max(1.0, this._xrLightEstimate.primaryLightIntensity.x, this._xrLightEstimate.primaryLightIntensity.y, this._xrLightEstimate.primaryLightIntensity.z);
                const rhsFactor = this._xrSessionManager.scene.useRightHandedSystem ? 1.0 : -1;
                // recreate the vector caches, so that the last one provided to the user will persist
                if (this.options.disableVectorReuse) {
                    this._lightDirection = new (0, $ha1VO.Vector3)();
                    this._lightColor = new (0, $7etnY.Color3)();
                    if (this.directionalLight) {
                        this.directionalLight.direction = this._lightDirection;
                        this.directionalLight.diffuse = this._lightColor;
                    }
                }
                this._lightDirection.copyFromFloats(this._xrLightEstimate.primaryLightDirection.x, this._xrLightEstimate.primaryLightDirection.y, this._xrLightEstimate.primaryLightDirection.z * rhsFactor);
                this._lightColor.copyFromFloats(this._xrLightEstimate.primaryLightIntensity.x / this._intensity, this._xrLightEstimate.primaryLightIntensity.y / this._intensity, this._xrLightEstimate.primaryLightIntensity.z / this._intensity);
                this._sphericalHarmonics.updateFromFloatsArray(this._xrLightEstimate.sphericalHarmonicsCoefficients);
                if (this._reflectionCubeMap && !this.options.disableSphericalPolynomial) {
                    this._reflectionCubeMap.sphericalPolynomial = this._reflectionCubeMap.sphericalPolynomial || new (0, $f3g09.SphericalPolynomial)();
                    this._reflectionCubeMap.sphericalPolynomial?.updateFromHarmonics(this._sphericalHarmonics);
                }
                // direction from instead of direction to
                this._lightDirection.negateInPlace();
                // set the values after calculating them
                if (this.directionalLight) {
                    this.directionalLight.direction.copyFrom(this._lightDirection);
                    this.directionalLight.intensity = Math.min(this._intensity, 1.0);
                    this.directionalLight.diffuse.copyFrom(this._lightColor);
                }
            }
        }
    }
}
/**
 * The module's name
 */ $651c9f04ae6aa160$export$97e374075269b469.Name = (0, $cJN7d.WebXRFeatureName).LIGHT_ESTIMATION;
/**
 * The (Babylon) version of this module.
 * This is an integer representing the implementation version.
 * This number does not correspond to the WebXR specs version
 */ $651c9f04ae6aa160$export$97e374075269b469.Version = 1;
// register the plugin
(0, $cJN7d.WebXRFeaturesManager).AddWebXRFeature($651c9f04ae6aa160$export$97e374075269b469.Name, (xrSessionManager, options)=>{
    return ()=>new $651c9f04ae6aa160$export$97e374075269b469(xrSessionManager, options);
}, $651c9f04ae6aa160$export$97e374075269b469.Version, false);

});

parcelRegister("8ffOp", function(module, exports) {

$parcel$export(module.exports, "WebXREyeTracking", () => $600bfd64a7a75647$export$3b2309ec5821a158);

var $cJN7d = parcelRequire("cJN7d");

var $2YzP2 = parcelRequire("2YzP2");

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $3kez7 = parcelRequire("3kez7");
class $600bfd64a7a75647$export$3b2309ec5821a158 extends (0, $2YzP2.WebXRAbstractFeature) {
    /**
     * Creates a new instance of the XR eye tracking feature.
     * @param _xrSessionManager An instance of WebXRSessionManager.
     */ constructor(_xrSessionManager){
        super(_xrSessionManager);
        /**
         * This observable will notify registered observers when eye tracking starts
         */ this.onEyeTrackingStartedObservable = new (0, $diGQf.Observable)();
        /**
         * This observable will notify registered observers when eye tracking ends
         */ this.onEyeTrackingEndedObservable = new (0, $diGQf.Observable)();
        /**
         * This observable will notify registered observers on each frame that has valid tracking
         */ this.onEyeTrackingFrameUpdateObservable = new (0, $diGQf.Observable)();
        this._eyeTrackingStartListener = (event)=>{
            this._latestEyeSpace = event.gazeSpace;
            this._gazeRay = new (0, $3kez7.Ray)((0, $ha1VO.Vector3).Zero(), (0, $ha1VO.Vector3).Forward());
            this.onEyeTrackingStartedObservable.notifyObservers(this._gazeRay);
        };
        this._eyeTrackingEndListener = ()=>{
            this._latestEyeSpace = null;
            this._gazeRay = null;
            this.onEyeTrackingEndedObservable.notifyObservers();
        };
        this.xrNativeFeatureName = "eye-tracking";
        if (this._xrSessionManager.session) this._init();
        else this._xrSessionManager.onXRSessionInit.addOnce(()=>{
            this._init();
        });
    }
    /**
     * Dispose this feature and all of the resources attached.
     */ dispose() {
        super.dispose();
        this._xrSessionManager.session.removeEventListener("eyetrackingstart", this._eyeTrackingStartListener);
        this._xrSessionManager.session.removeEventListener("eyetrackingend", this._eyeTrackingEndListener);
        this.onEyeTrackingStartedObservable.clear();
        this.onEyeTrackingEndedObservable.clear();
        this.onEyeTrackingFrameUpdateObservable.clear();
    }
    /**
     * Returns whether the gaze data is valid or not
     * @returns true if the data is valid
     */ get isEyeGazeValid() {
        return !!this._gazeRay;
    }
    /**
     * Get a reference to the gaze ray. This data is valid while eye tracking persists, and will be set to null when gaze data is no longer available
     * @returns a reference to the gaze ray if it exists and is valid, returns null otherwise.
     */ getEyeGaze() {
        return this._gazeRay;
    }
    _onXRFrame(frame) {
        if (!this.attached || !frame) return;
        if (this._latestEyeSpace && this._gazeRay) {
            const pose = frame.getPose(this._latestEyeSpace, this._xrSessionManager.referenceSpace);
            if (pose) {
                this._gazeRay.origin.set(pose.transform.position.x, pose.transform.position.y, pose.transform.position.z).scaleInPlace(this._xrSessionManager.worldScalingFactor);
                const quat = pose.transform.orientation;
                (0, $ha1VO.TmpVectors).Quaternion[0].set(quat.x, quat.y, quat.z, quat.w);
                if (!this._xrSessionManager.scene.useRightHandedSystem) {
                    this._gazeRay.origin.z *= -1;
                    (0, $ha1VO.TmpVectors).Quaternion[0].z *= -1;
                    (0, $ha1VO.TmpVectors).Quaternion[0].w *= -1;
                    (0, $ha1VO.Vector3).LeftHandedForwardReadOnly.rotateByQuaternionToRef((0, $ha1VO.TmpVectors).Quaternion[0], this._gazeRay.direction);
                } else (0, $ha1VO.Vector3).RightHandedForwardReadOnly.rotateByQuaternionToRef((0, $ha1VO.TmpVectors).Quaternion[0], this._gazeRay.direction);
                this.onEyeTrackingFrameUpdateObservable.notifyObservers(this._gazeRay);
            }
        }
    }
    _init() {
        // Only supported by BabylonNative
        if (this._xrSessionManager.isNative) {
            this._xrSessionManager.session.addEventListener("eyetrackingstart", this._eyeTrackingStartListener);
            this._xrSessionManager.session.addEventListener("eyetrackingend", this._eyeTrackingEndListener);
        }
    }
}
/**
 * The module's name
 */ $600bfd64a7a75647$export$3b2309ec5821a158.Name = (0, $cJN7d.WebXRFeatureName).EYE_TRACKING;
/**
 * The (Babylon) version of this module.
 * This is an integer representing the implementation version.
 * This number does not correspond to the WebXR specs version
 */ $600bfd64a7a75647$export$3b2309ec5821a158.Version = 1;
(0, $cJN7d.WebXRFeaturesManager).AddWebXRFeature($600bfd64a7a75647$export$3b2309ec5821a158.Name, (xrSessionManager)=>{
    return ()=>new $600bfd64a7a75647$export$3b2309ec5821a158(xrSessionManager);
}, $600bfd64a7a75647$export$3b2309ec5821a158.Version, false);

});

parcelRegister("41STK", function(module, exports) {

$parcel$export(module.exports, "WebXRWalkingLocomotion", () => $2ef1d70ef9f8ce64$export$3c2b0affafebf5b0);

var $ha1VO = parcelRequire("ha1VO");

var $kVtWi = parcelRequire("kVtWi");

var $diGQf = parcelRequire("diGQf");

var $cJN7d = parcelRequire("cJN7d");

var $2YzP2 = parcelRequire("2YzP2");
class $2ef1d70ef9f8ce64$var$CircleBuffer {
    constructor(numSamples, initializer){
        this._samples = [];
        this._idx = 0;
        for(let idx = 0; idx < numSamples; ++idx)this._samples.push(initializer ? initializer() : (0, $ha1VO.Vector2).Zero());
    }
    get length() {
        return this._samples.length;
    }
    push(x, y) {
        this._idx = (this._idx + this._samples.length - 1) % this._samples.length;
        this.at(0).copyFromFloats(x, y);
    }
    at(idx) {
        if (idx >= this._samples.length) throw new Error("Index out of bounds");
        return this._samples[(this._idx + idx) % this._samples.length];
    }
}
class $2ef1d70ef9f8ce64$var$FirstStepDetector {
    constructor(){
        this._samples = new $2ef1d70ef9f8ce64$var$CircleBuffer(20);
        this._entropy = 0;
        this.onFirstStepDetected = new (0, $diGQf.Observable)();
    }
    update(posX, posY, forwardX, forwardY) {
        this._samples.push(posX, posY);
        const origin = this._samples.at(0);
        this._entropy *= this._entropyDecayFactor;
        this._entropy += (0, $ha1VO.Vector2).Distance(origin, this._samples.at(1));
        if (this._entropy > this._entropyThreshold) return;
        let samePointIdx;
        for(samePointIdx = this._samePointCheckStartIdx; samePointIdx < this._samples.length; ++samePointIdx){
            if ((0, $ha1VO.Vector2).DistanceSquared(origin, this._samples.at(samePointIdx)) < this._samePointSquaredDistanceThreshold) break;
        }
        if (samePointIdx === this._samples.length) return;
        let apexDistSquared = -1;
        let apexIdx = 0;
        for(let distSquared, idx = 1; idx < samePointIdx; ++idx){
            distSquared = (0, $ha1VO.Vector2).DistanceSquared(origin, this._samples.at(idx));
            if (distSquared > apexDistSquared) {
                apexIdx = idx;
                apexDistSquared = distSquared;
            }
        }
        if (apexDistSquared < this._apexSquaredDistanceThreshold) return;
        const apex = this._samples.at(apexIdx);
        const axis = apex.subtract(origin);
        axis.normalize();
        const vec = (0, $ha1VO.TmpVectors).Vector2[0];
        let dot;
        let sample;
        let sumSquaredProjectionDistances = 0;
        for(let idx = 1; idx < samePointIdx; ++idx){
            sample = this._samples.at(idx);
            sample.subtractToRef(origin, vec);
            dot = (0, $ha1VO.Vector2).Dot(axis, vec);
            sumSquaredProjectionDistances += vec.lengthSquared() - dot * dot;
        }
        if (sumSquaredProjectionDistances > samePointIdx * this._squaredProjectionDistanceThreshold) return;
        const forwardVec = (0, $ha1VO.TmpVectors).Vector3[0];
        forwardVec.set(forwardX, forwardY, 0);
        const axisVec = (0, $ha1VO.TmpVectors).Vector3[1];
        axisVec.set(axis.x, axis.y, 0);
        const isApexLeft = (0, $ha1VO.Vector3).Cross(forwardVec, axisVec).z > 0;
        const leftApex = origin.clone();
        const rightApex = origin.clone();
        apex.subtractToRef(origin, axis);
        if (isApexLeft) {
            axis.scaleAndAddToRef(this._axisToApexShrinkFactor, leftApex);
            axis.scaleAndAddToRef(this._axisToApexExtendFactor, rightApex);
        } else {
            axis.scaleAndAddToRef(this._axisToApexExtendFactor, leftApex);
            axis.scaleAndAddToRef(this._axisToApexShrinkFactor, rightApex);
        }
        this.onFirstStepDetected.notifyObservers({
            leftApex: leftApex,
            rightApex: rightApex,
            currentPosition: origin,
            currentStepDirection: isApexLeft ? "right" : "left"
        });
    }
    reset() {
        for(let idx = 0; idx < this._samples.length; ++idx)this._samples.at(idx).copyFromFloats(0, 0);
    }
    get _samePointCheckStartIdx() {
        return Math.floor(this._samples.length / 3);
    }
    get _samePointSquaredDistanceThreshold() {
        return 0.0009;
    }
    get _apexSquaredDistanceThreshold() {
        return 0.0081;
    }
    get _squaredProjectionDistanceThreshold() {
        return 0.0009;
    }
    get _axisToApexShrinkFactor() {
        return 0.8;
    }
    get _axisToApexExtendFactor() {
        return -1.6;
    }
    get _entropyDecayFactor() {
        return 0.93;
    }
    get _entropyThreshold() {
        return 0.4;
    }
}
class $2ef1d70ef9f8ce64$var$WalkingTracker {
    constructor(leftApex, rightApex, currentPosition, currentStepDirection){
        this._leftApex = new (0, $ha1VO.Vector2)();
        this._rightApex = new (0, $ha1VO.Vector2)();
        this._currentPosition = new (0, $ha1VO.Vector2)();
        this._axis = new (0, $ha1VO.Vector2)();
        this._axisLength = -1;
        this._forward = new (0, $ha1VO.Vector2)();
        this._steppingLeft = false;
        this._t = -1;
        this._maxT = -1;
        this._maxTPosition = new (0, $ha1VO.Vector2)();
        this._vitality = 0;
        this.onMovement = new (0, $diGQf.Observable)();
        this.onFootfall = new (0, $diGQf.Observable)();
        this._reset(leftApex, rightApex, currentPosition, currentStepDirection === "left");
    }
    _reset(leftApex, rightApex, currentPosition, steppingLeft) {
        this._leftApex.copyFrom(leftApex);
        this._rightApex.copyFrom(rightApex);
        this._steppingLeft = steppingLeft;
        if (this._steppingLeft) {
            this._leftApex.subtractToRef(this._rightApex, this._axis);
            this._forward.copyFromFloats(-this._axis.y, this._axis.x);
        } else {
            this._rightApex.subtractToRef(this._leftApex, this._axis);
            this._forward.copyFromFloats(this._axis.y, -this._axis.x);
        }
        this._axisLength = this._axis.length();
        this._forward.scaleInPlace(1 / this._axisLength);
        this._updateTAndVitality(currentPosition.x, currentPosition.y);
        this._maxT = this._t;
        this._maxTPosition.copyFrom(currentPosition);
        this._vitality = 1;
    }
    _updateTAndVitality(x, y) {
        this._currentPosition.copyFromFloats(x, y);
        if (this._steppingLeft) this._currentPosition.subtractInPlace(this._rightApex);
        else this._currentPosition.subtractInPlace(this._leftApex);
        const priorT = this._t;
        const dot = (0, $ha1VO.Vector2).Dot(this._currentPosition, this._axis);
        this._t = dot / (this._axisLength * this._axisLength);
        const projDistSquared = this._currentPosition.lengthSquared() - dot / this._axisLength * (dot / this._axisLength);
        // TODO: Extricate the magic.
        this._vitality *= 0.92 - 100 * Math.max(projDistSquared - 0.0016, 0) + Math.max(this._t - priorT, 0);
    }
    update(x, y) {
        if (this._vitality < this._vitalityThreshold) return false;
        const priorT = this._t;
        this._updateTAndVitality(x, y);
        if (this._t > this._maxT) {
            this._maxT = this._t;
            this._maxTPosition.copyFromFloats(x, y);
        }
        if (this._vitality < this._vitalityThreshold) return false;
        if (this._t > priorT) {
            this.onMovement.notifyObservers({
                deltaT: this._t - priorT
            });
            if (priorT < 0.5 && this._t >= 0.5) this.onFootfall.notifyObservers({
                foot: this._steppingLeft ? "left" : "right"
            });
        }
        if (this._t < 0.95 * this._maxT) {
            this._currentPosition.copyFromFloats(x, y);
            if (this._steppingLeft) this._leftApex.copyFrom(this._maxTPosition);
            else this._rightApex.copyFrom(this._maxTPosition);
            this._reset(this._leftApex, this._rightApex, this._currentPosition, !this._steppingLeft);
        }
        if (this._axisLength < 0.03) return false;
        return true;
    }
    get _vitalityThreshold() {
        return 0.1;
    }
    get forward() {
        return this._forward;
    }
}
class $2ef1d70ef9f8ce64$var$Walker {
    static get _MillisecondsPerUpdate() {
        // 15 FPS
        return 1000 / 15;
    }
    constructor(engine){
        this._detector = new $2ef1d70ef9f8ce64$var$FirstStepDetector();
        this._walker = null;
        this._movement = new (0, $ha1VO.Vector2)();
        this._millisecondsSinceLastUpdate = $2ef1d70ef9f8ce64$var$Walker._MillisecondsPerUpdate;
        this.movementThisFrame = (0, $ha1VO.Vector3).Zero();
        this._engine = engine;
        this._detector.onFirstStepDetected.add((event)=>{
            if (!this._walker) {
                this._walker = new $2ef1d70ef9f8ce64$var$WalkingTracker(event.leftApex, event.rightApex, event.currentPosition, event.currentStepDirection);
                this._walker.onFootfall.add(()=>{
                    (0, $kVtWi.Logger).Log("Footfall!");
                });
                this._walker.onMovement.add((event)=>{
                    this._walker.forward.scaleAndAddToRef(0.024 * event.deltaT, this._movement);
                });
            }
        });
    }
    update(position, forward) {
        forward.y = 0;
        forward.normalize();
        // Enforce reduced framerate
        this._millisecondsSinceLastUpdate += this._engine.getDeltaTime();
        if (this._millisecondsSinceLastUpdate >= $2ef1d70ef9f8ce64$var$Walker._MillisecondsPerUpdate) {
            this._millisecondsSinceLastUpdate -= $2ef1d70ef9f8ce64$var$Walker._MillisecondsPerUpdate;
            this._detector.update(position.x, position.z, forward.x, forward.z);
            if (this._walker) {
                const updated = this._walker.update(position.x, position.z);
                if (!updated) this._walker = null;
            }
            this._movement.scaleInPlace(0.85);
        }
        this.movementThisFrame.set(this._movement.x, 0, this._movement.y);
    }
}
class $2ef1d70ef9f8ce64$export$3c2b0affafebf5b0 extends (0, $2YzP2.WebXRAbstractFeature) {
    /**
     * The module's name.
     */ static get Name() {
        return (0, $cJN7d.WebXRFeatureName).WALKING_LOCOMOTION;
    }
    /**
     * The (Babylon) version of this module.
     * This is an integer representing the implementation version.
     * This number has no external basis.
     */ static get Version() {
        return 1;
    }
    /**
     * The target to be articulated by walking locomotion.
     * When the walking locomotion feature detects walking in place, this element's
     * X and Z coordinates will be modified to reflect locomotion. This target should
     * be either the XR space's origin (i.e., the parent node of the WebXRCamera) or
     * the WebXRCamera itself. Note that the WebXRCamera path will modify the position
     * of the WebXRCamera directly and is thus discouraged.
     */ get locomotionTarget() {
        return this._locomotionTarget;
    }
    /**
     * The target to be articulated by walking locomotion.
     * When the walking locomotion feature detects walking in place, this element's
     * X and Z coordinates will be modified to reflect locomotion. This target should
     * be either the XR space's origin (i.e., the parent node of the WebXRCamera) or
     * the WebXRCamera itself. Note that the WebXRCamera path will modify the position
     * of the WebXRCamera directly and is thus discouraged.
     */ set locomotionTarget(locomotionTarget) {
        this._locomotionTarget = locomotionTarget;
        this._isLocomotionTargetWebXRCamera = this._locomotionTarget.getClassName() === "WebXRCamera";
    }
    /**
     * Construct a new Walking Locomotion feature.
     * @param sessionManager manager for the current XR session
     * @param options creation options, prominently including the vector target for locomotion
     */ constructor(sessionManager, options){
        super(sessionManager);
        this._up = new (0, $ha1VO.Vector3)();
        this._forward = new (0, $ha1VO.Vector3)();
        this._position = new (0, $ha1VO.Vector3)();
        this._movement = new (0, $ha1VO.Vector3)();
        this._sessionManager = sessionManager;
        this.locomotionTarget = options.locomotionTarget;
        if (this._isLocomotionTargetWebXRCamera) (0, $kVtWi.Logger).Warn("Using walking locomotion directly on a WebXRCamera may have unintended interactions with other XR techniques. Using an XR space parent is highly recommended");
    }
    /**
     * Checks whether this feature is compatible with the current WebXR session.
     * Walking locomotion is only compatible with "immersive-vr" sessions.
     * @returns true if compatible, false otherwise
     */ isCompatible() {
        return this._sessionManager.sessionMode === undefined || this._sessionManager.sessionMode === "immersive-vr";
    }
    /**
     * Attaches the feature.
     * Typically called automatically by the features manager.
     * @returns true if attach succeeded, false otherwise
     */ attach() {
        if (!this.isCompatible || !super.attach()) return false;
        this._walker = new $2ef1d70ef9f8ce64$var$Walker(this._sessionManager.scene.getEngine());
        return true;
    }
    /**
     * Detaches the feature.
     * Typically called automatically by the features manager.
     * @returns true if detach succeeded, false otherwise
     */ detach() {
        if (!super.detach()) return false;
        this._walker = null;
        return true;
    }
    _onXRFrame(frame) {
        const pose = frame.getViewerPose(this._sessionManager.baseReferenceSpace);
        if (!pose) return;
        const handednessScalar = this.locomotionTarget.getScene().useRightHandedSystem ? 1 : -1;
        const m = pose.transform.matrix;
        this._up.copyFromFloats(m[4], m[5], handednessScalar * m[6]);
        this._forward.copyFromFloats(m[8], m[9], handednessScalar * m[10]);
        this._position.copyFromFloats(m[12], m[13], handednessScalar * m[14]);
        // Compute the nape position
        this._forward.scaleAndAddToRef(0.05, this._position);
        this._up.scaleAndAddToRef(-0.05, this._position);
        this._walker.update(this._position, this._forward);
        this._movement.copyFrom(this._walker.movementThisFrame);
        if (!this._isLocomotionTargetWebXRCamera) (0, $ha1VO.Vector3).TransformNormalToRef(this._movement, this.locomotionTarget.getWorldMatrix(), this._movement);
        this.locomotionTarget.position.addInPlace(this._movement);
    }
}
//register the plugin
(0, $cJN7d.WebXRFeaturesManager).AddWebXRFeature($2ef1d70ef9f8ce64$export$3c2b0affafebf5b0.Name, (xrSessionManager, options)=>{
    return ()=>new $2ef1d70ef9f8ce64$export$3c2b0affafebf5b0(xrSessionManager, options);
}, $2ef1d70ef9f8ce64$export$3c2b0affafebf5b0.Version, false);

});

parcelRegister("6MZq2", function(module, exports) {

$parcel$export(module.exports, "WebXRLayers", () => $4f16de4f1fe12f20$export$208ceddeddbbf472);

var $cJN7d = parcelRequire("cJN7d");

var $2YzP2 = parcelRequire("2YzP2");

var $3xmzr = parcelRequire("3xmzr");

var $1PpUz = parcelRequire("1PpUz");

var $gFiBy = parcelRequire("gFiBy");

var $7etnY = parcelRequire("7etnY");
const $4f16de4f1fe12f20$var$defaultXRWebGLLayerInit = {};
class $4f16de4f1fe12f20$export$208ceddeddbbf472 extends (0, $2YzP2.WebXRAbstractFeature) {
    constructor(_xrSessionManager, _options = {}){
        super(_xrSessionManager);
        this._options = _options;
        /**
         * Already-created layers
         */ this._existingLayers = [];
        this._isMultiviewEnabled = false;
        this._projectionLayerInitialized = false;
        this._compositionLayerTextureMapping = new WeakMap();
        this._layerToRTTProviderMapping = new WeakMap();
        this.xrNativeFeatureName = "layers";
    }
    /**
     * Attach this feature.
     * Will usually be called by the features manager.
     *
     * @returns true if successful.
     */ attach() {
        if (!super.attach()) return false;
        const engine = this._xrSessionManager.scene.getEngine();
        this._glContext = engine._gl;
        this._xrWebGLBinding = new XRWebGLBinding(this._xrSessionManager.session, this._glContext);
        this._existingLayers.length = 0;
        const projectionLayerInit = {
            ...(0, $1PpUz.defaultXRProjectionLayerInit),
            ...this._options.projectionLayerInit
        };
        this._isMultiviewEnabled = this._options.preferMultiviewOnInit && engine.getCaps().multiview;
        this.createProjectionLayer(projectionLayerInit /*, projectionLayerMultiview*/ );
        this._projectionLayerInitialized = true;
        return true;
    }
    detach() {
        if (!super.detach()) return false;
        this._existingLayers.forEach((layer)=>{
            layer.dispose();
        });
        this._existingLayers.length = 0;
        this._projectionLayerInitialized = false;
        return true;
    }
    /**
     * Creates a new XRWebGLLayer.
     * @param params an object providing configuration options for the new XRWebGLLayer
     * @returns the XRWebGLLayer
     */ createXRWebGLLayer(params = $4f16de4f1fe12f20$var$defaultXRWebGLLayerInit) {
        const layer = new XRWebGLLayer(this._xrSessionManager.session, this._glContext, params);
        return new (0, $3xmzr.WebXRWebGLLayerWrapper)(layer);
    }
    _validateLayerInit(params, multiview = this._isMultiviewEnabled) {
        // check if we are in session
        if (!this._xrSessionManager.inXRSession) throw new Error("Cannot create a layer outside of a WebXR session. Make sure the session has started before creating layers.");
        if (multiview && params.textureType !== "texture-array") throw new Error("Projection layers can only be made multiview if they use texture arrays. Set the textureType parameter to 'texture-array'.");
        // TODO (rgerd): Support RTT's that are bound to sub-images in the texture array.
        if (!multiview && params.textureType === "texture-array") throw new Error("We currently only support multiview rendering when the textureType parameter is set to 'texture-array'.");
    }
    _extendXRLayerInit(params, multiview = this._isMultiviewEnabled) {
        if (multiview) params.textureType = "texture-array";
        return params;
    }
    /**
     * Creates a new XRProjectionLayer.
     * @param params an object providing configuration options for the new XRProjectionLayer.
     * @param multiview whether the projection layer should render with multiview. Will be tru automatically if the extension initialized with multiview.
     * @returns the projection layer
     */ createProjectionLayer(params = (0, $1PpUz.defaultXRProjectionLayerInit), multiview = this._isMultiviewEnabled) {
        this._extendXRLayerInit(params, multiview);
        this._validateLayerInit(params, multiview);
        const projLayer = this._xrWebGLBinding.createProjectionLayer(params);
        const layer = new (0, $1PpUz.WebXRProjectionLayerWrapper)(projLayer, multiview, this._xrWebGLBinding);
        this.addXRSessionLayer(layer);
        return layer;
    }
    /**
     * Note about making it private - this function will be exposed once I decide on a proper API to support all of the XR layers' options
     * @param options an object providing configuration options for the new XRQuadLayer.
     * @param babylonTexture the texture to display in the layer
     * @returns the quad layer
     */ _createQuadLayer(options = {
        params: {}
    }, babylonTexture) {
        this._extendXRLayerInit(options.params, false);
        const width = this._existingLayers[0].layer.textureWidth;
        const height = this._existingLayers[0].layer.textureHeight;
        const populatedParams = {
            space: this._xrSessionManager.referenceSpace,
            viewPixelWidth: width,
            viewPixelHeight: height,
            clearOnAccess: true,
            ...options.params
        };
        this._validateLayerInit(populatedParams, false);
        const quadLayer = this._xrWebGLBinding.createQuadLayer(populatedParams);
        quadLayer.width = this._isMultiviewEnabled ? 1 : 2;
        quadLayer.height = 1;
        // this wrapper is not really needed, but it's here for consistency
        const wrapper = new (0, $gFiBy.WebXRCompositionLayerWrapper)(()=>quadLayer.width, ()=>quadLayer.height, quadLayer, "XRQuadLayer", false, (sessionManager)=>new (0, $gFiBy.WebXRCompositionLayerRenderTargetTextureProvider)(sessionManager, this._xrWebGLBinding, wrapper));
        if (babylonTexture) this._compositionLayerTextureMapping.set(quadLayer, babylonTexture);
        const rtt = wrapper.createRenderTargetTextureProvider(this._xrSessionManager);
        this._layerToRTTProviderMapping.set(quadLayer, rtt);
        this.addXRSessionLayer(wrapper);
        return wrapper;
    }
    /**
     * @experimental
     * This will support full screen ADT when used with WebXR Layers. This API might change in the future.
     * Note that no interaction will be available with the ADT when using this method
     * @param texture the texture to display in the layer
     * @param options optional parameters for the layer
     * @returns a composition layer containing the texture
     */ addFullscreenAdvancedDynamicTexture(texture, options = {
        distanceFromHeadset: 1.5
    }) {
        const wrapper = this._createQuadLayer({
            params: {
                space: this._xrSessionManager.viewerReferenceSpace,
                textureType: "texture",
                layout: "mono"
            }
        }, texture);
        const layer = wrapper.layer;
        const distance = Math.max(0.1, options.distanceFromHeadset);
        const pos = {
            x: 0,
            y: 0,
            z: -distance
        };
        const orient = {
            x: 0,
            y: 0,
            z: 0,
            w: 1
        };
        layer.transform = new XRRigidTransform(pos, orient);
        const rttProvider = this._layerToRTTProviderMapping.get(layer);
        if (!rttProvider) throw new Error("Could not find the RTT provider for the layer");
        const babylonLayer = this._xrSessionManager.scene.layers.find((babylonLayer)=>{
            return babylonLayer.texture === texture;
        });
        if (!babylonLayer) throw new Error("Could not find the babylon layer for the texture");
        rttProvider.onRenderTargetTextureCreatedObservable.add((data)=>{
            if (data.eye && data.eye === "right") return;
            data.texture.clearColor = new (0, $7etnY.Color4)(0, 0, 0, 0);
            babylonLayer.renderTargetTextures.push(data.texture);
            babylonLayer.renderOnlyInRenderTargetTextures = true;
            // for stereo (not for gui) it should be onBeforeCameraRenderObservable
            this._xrSessionManager.scene.onBeforeRenderObservable.add(()=>{
                data.texture.render();
            });
            babylonLayer.renderTargetTextures.push(data.texture);
            babylonLayer.renderOnlyInRenderTargetTextures = true;
            // add it back when the session ends
            this._xrSessionManager.onXRSessionEnded.addOnce(()=>{
                babylonLayer.renderTargetTextures.splice(babylonLayer.renderTargetTextures.indexOf(data.texture), 1);
                babylonLayer.renderOnlyInRenderTargetTextures = false;
            });
        });
        return wrapper;
    }
    /**
     * @experimental
     * This functions allows you to add a lens flare system to the XR scene.
     * Note - this will remove the lens flare system from the scene and add it to the XR scene.
     * This feature is experimental and might change in the future.
     * @param flareSystem the flare system to add
     * @returns a composition layer containing the flare system
     */ _addLensFlareSystem(flareSystem) {
        const wrapper = this._createQuadLayer({
            params: {
                space: this._xrSessionManager.viewerReferenceSpace,
                textureType: "texture",
                layout: "mono"
            }
        });
        const layer = wrapper.layer;
        layer.width = 2;
        layer.height = 1;
        const distance = 10;
        const pos = {
            x: 0,
            y: 0,
            z: -distance
        };
        const orient = {
            x: 0,
            y: 0,
            z: 0,
            w: 1
        };
        layer.transform = new XRRigidTransform(pos, orient);
        // get the rtt wrapper
        const rttProvider = this._layerToRTTProviderMapping.get(layer);
        if (!rttProvider) throw new Error("Could not find the RTT provider for the layer");
        // render the flare system to the rtt
        rttProvider.onRenderTargetTextureCreatedObservable.add((data)=>{
            data.texture.clearColor = new (0, $7etnY.Color4)(0, 0, 0, 0);
            data.texture.customRenderFunction = ()=>{
                flareSystem.render();
            };
        // add to the scene's render targets
        // this._xrSessionManager.scene.onBeforeCameraRenderObservable.add(() => {
        //     data.texture.render();
        // });
        });
        // remove the lens flare system from the scene
        this._xrSessionManager.onXRSessionInit.add(()=>{
            this._xrSessionManager.scene.lensFlareSystems.splice(this._xrSessionManager.scene.lensFlareSystems.indexOf(flareSystem), 1);
        });
        // add it back when the session ends
        this._xrSessionManager.onXRSessionEnded.add(()=>{
            this._xrSessionManager.scene.lensFlareSystems.push(flareSystem);
        });
        return wrapper;
    }
    /**
     * Add a new layer to the already-existing list of layers
     * @param wrappedLayer the new layer to add to the existing ones
     */ addXRSessionLayer(wrappedLayer) {
        this._existingLayers.push(wrappedLayer);
        this.setXRSessionLayers(this._existingLayers);
    }
    /**
     * Sets the layers to be used by the XR session.
     * Note that you must call this function with any layers you wish to render to
     * since it adds them to the XR session's render state
     * (replacing any layers that were added in a previous call to setXRSessionLayers or updateRenderState).
     * This method also sets up the session manager's render target texture provider
     * as the first layer in the array, which feeds the WebXR camera(s) attached to the session.
     * @param wrappedLayers An array of WebXRLayerWrapper, usually returned from the WebXRLayers createLayer functions.
     */ setXRSessionLayers(wrappedLayers = this._existingLayers) {
        // this._existingLayers = wrappedLayers;
        const renderStateInit = {
            ...this._xrSessionManager.session.renderState
        };
        // Clear out the layer-related fields.
        renderStateInit.baseLayer = undefined;
        renderStateInit.layers = wrappedLayers.map((wrappedLayer)=>wrappedLayer.layer);
        this._xrSessionManager.updateRenderState(renderStateInit);
        if (!this._projectionLayerInitialized) this._xrSessionManager._setBaseLayerWrapper(wrappedLayers.length > 0 ? wrappedLayers.at(0) : null);
    }
    isCompatible() {
        // TODO (rgerd): Add native support.
        return !this._xrSessionManager.isNative && typeof XRWebGLBinding !== "undefined" && !!XRWebGLBinding.prototype.createProjectionLayer;
    }
    /**
     * Dispose this feature and all of the resources attached.
     */ dispose() {
        super.dispose();
    }
    _onXRFrame(_xrFrame) {
        // Replace once the mapped internal texture of each available composition layer, apart from the last one, which is the projection layer that needs an RTT
        const layers = this._existingLayers;
        for(let i = 0; i < layers.length; ++i){
            const layer = layers[i];
            if (layer.layerType !== "XRProjectionLayer") {
                // get the rtt provider
                const rttProvider = this._layerToRTTProviderMapping.get(layer.layer);
                if (!rttProvider) continue;
                if (rttProvider.layerWrapper.isMultiview) {
                    // get the views, if we are in multiview
                    const pose = _xrFrame.getViewerPose(this._xrSessionManager.referenceSpace);
                    if (pose) {
                        const views = pose.views;
                        for(let j = 0; j < views.length; ++j){
                            const view = views[j];
                            rttProvider.getRenderTargetTextureForView(view);
                        }
                    }
                } else rttProvider.getRenderTargetTextureForView();
            }
        }
    }
}
/**
 * The module's name
 */ $4f16de4f1fe12f20$export$208ceddeddbbf472.Name = (0, $cJN7d.WebXRFeatureName).LAYERS;
/**
 * The (Babylon) version of this module.
 * This is an integer representing the implementation version.
 * This number does not correspond to the WebXR specs version
 */ $4f16de4f1fe12f20$export$208ceddeddbbf472.Version = 1;
//register the plugin
(0, $cJN7d.WebXRFeaturesManager).AddWebXRFeature($4f16de4f1fe12f20$export$208ceddeddbbf472.Name, (xrSessionManager, options)=>{
    return ()=>new $4f16de4f1fe12f20$export$208ceddeddbbf472(xrSessionManager, options);
}, $4f16de4f1fe12f20$export$208ceddeddbbf472.Version, false);

});
parcelRegister("1PpUz", function(module, exports) {

$parcel$export(module.exports, "WebXRProjectionLayerWrapper", () => $154ea75b72a1e1b3$export$57d540ad32d8b3a2);
$parcel$export(module.exports, "defaultXRProjectionLayerInit", () => $154ea75b72a1e1b3$export$9a0fad9bc48d7d9b);

var $gFiBy = parcelRequire("gFiBy");
class $154ea75b72a1e1b3$export$57d540ad32d8b3a2 extends (0, $gFiBy.WebXRCompositionLayerWrapper) {
    constructor(layer, isMultiview, xrGLBinding){
        super(()=>layer.textureWidth, ()=>layer.textureHeight, layer, "XRProjectionLayer", isMultiview, (sessionManager)=>new $154ea75b72a1e1b3$var$WebXRProjectionLayerRenderTargetTextureProvider(sessionManager, xrGLBinding, this));
        this.layer = layer;
    }
}
/**
 * Provides render target textures and other important rendering information for a given XRProjectionLayer.
 * @internal
 */ class $154ea75b72a1e1b3$var$WebXRProjectionLayerRenderTargetTextureProvider extends (0, $gFiBy.WebXRCompositionLayerRenderTargetTextureProvider) {
    constructor(_xrSessionManager, _xrWebGLBinding, layerWrapper){
        super(_xrSessionManager, _xrWebGLBinding, layerWrapper);
        this.layerWrapper = layerWrapper;
        this._projectionLayer = layerWrapper.layer;
    }
    _getSubImageForView(view) {
        return this._xrWebGLBinding.getViewSubImage(this._projectionLayer, view);
    }
    getRenderTargetTextureForView(view) {
        return this._getRenderTargetForSubImage(this._getSubImageForView(view), view.eye);
    }
    getRenderTargetTextureForEye(eye) {
        const lastSubImage = this._lastSubImages.get(eye);
        if (lastSubImage) return this._getRenderTargetForSubImage(lastSubImage, eye);
        return null;
    }
    trySetViewportForView(viewport, view) {
        const subImage = this._lastSubImages.get(view.eye) || this._getSubImageForView(view);
        if (subImage) {
            this._setViewportForSubImage(viewport, subImage);
            return true;
        }
        return false;
    }
}
const $154ea75b72a1e1b3$export$9a0fad9bc48d7d9b = {
    textureType: "texture",
    colorFormat: 0x1908 /* WebGLRenderingContext.RGBA */ ,
    depthFormat: 0x88f0 /* WebGLRenderingContext.DEPTH24_STENCIL8 */ ,
    scaleFactor: 1.0,
    clearOnAccess: false
};

});
parcelRegister("gFiBy", function(module, exports) {

$parcel$export(module.exports, "WebXRCompositionLayerWrapper", () => $c21ee82fb7fcc5c1$export$9422a96045435fb1);
$parcel$export(module.exports, "WebXRCompositionLayerRenderTargetTextureProvider", () => $c21ee82fb7fcc5c1$export$72cd97b93c900c47);

var $diGQf = parcelRequire("diGQf");

var $lx5nJ = parcelRequire("lx5nJ");

var $6PNKl = parcelRequire("6PNKl");
class $c21ee82fb7fcc5c1$export$9422a96045435fb1 extends (0, $lx5nJ.WebXRLayerWrapper) {
    constructor(getWidth, getHeight, layer, layerType, isMultiview, createRTTProvider, _originalInternalTexture = null){
        super(getWidth, getHeight, layer, layerType, createRTTProvider);
        this.getWidth = getWidth;
        this.getHeight = getHeight;
        this.layer = layer;
        this.layerType = layerType;
        this.isMultiview = isMultiview;
        this.createRTTProvider = createRTTProvider;
        this._originalInternalTexture = _originalInternalTexture;
    }
}
class $c21ee82fb7fcc5c1$export$72cd97b93c900c47 extends (0, $6PNKl.WebXRLayerRenderTargetTextureProvider) {
    constructor(_xrSessionManager, _xrWebGLBinding, layerWrapper){
        super(_xrSessionManager.scene, layerWrapper);
        this._xrSessionManager = _xrSessionManager;
        this._xrWebGLBinding = _xrWebGLBinding;
        this.layerWrapper = layerWrapper;
        this._lastSubImages = new Map();
        /**
         * Fires every time a new render target texture is created (either for eye, for view, or for the entire frame)
         */ this.onRenderTargetTextureCreatedObservable = new (0, $diGQf.Observable)();
        this._compositionLayer = layerWrapper.layer;
    }
    _getRenderTargetForSubImage(subImage, eye = "none") {
        const lastSubImage = this._lastSubImages.get(eye);
        const eyeIndex = eye == "right" ? 1 : 0;
        const colorTextureWidth = subImage.colorTextureWidth ?? subImage.textureWidth;
        const colorTextureHeight = subImage.colorTextureHeight ?? subImage.textureHeight;
        if (!this._renderTargetTextures[eyeIndex] || lastSubImage?.textureWidth !== colorTextureWidth || lastSubImage?.textureHeight !== colorTextureHeight) {
            let depthStencilTexture;
            const depthStencilTextureWidth = subImage.depthStencilTextureWidth ?? colorTextureWidth;
            const depthStencilTextureHeight = subImage.depthStencilTextureHeight ?? colorTextureHeight;
            if (colorTextureWidth === depthStencilTextureWidth || colorTextureHeight === depthStencilTextureHeight) depthStencilTexture = subImage.depthStencilTexture;
            this._renderTargetTextures[eyeIndex] = this._createRenderTargetTexture(colorTextureWidth, colorTextureHeight, null, subImage.colorTexture, depthStencilTexture, this.layerWrapper.isMultiview);
            this._framebufferDimensions = {
                framebufferWidth: colorTextureWidth,
                framebufferHeight: colorTextureHeight
            };
            this.onRenderTargetTextureCreatedObservable.notifyObservers({
                texture: this._renderTargetTextures[eyeIndex],
                eye: eye
            });
        }
        this._lastSubImages.set(eye, subImage);
        return this._renderTargetTextures[eyeIndex];
    }
    _getSubImageForEye(eye) {
        const currentFrame = this._xrSessionManager.currentFrame;
        if (currentFrame) return this._xrWebGLBinding.getSubImage(this._compositionLayer, currentFrame, eye);
        return null;
    }
    getRenderTargetTextureForEye(eye) {
        const subImage = this._getSubImageForEye(eye);
        if (subImage) return this._getRenderTargetForSubImage(subImage, eye);
        return null;
    }
    getRenderTargetTextureForView(view) {
        return this.getRenderTargetTextureForEye(view?.eye);
    }
    _setViewportForSubImage(viewport, subImage) {
        const textureWidth = subImage.colorTextureWidth ?? subImage.textureWidth;
        const textureHeight = subImage.colorTextureHeight ?? subImage.textureHeight;
        const xrViewport = subImage.viewport;
        viewport.x = xrViewport.x / textureWidth;
        viewport.y = xrViewport.y / textureHeight;
        viewport.width = xrViewport.width / textureWidth;
        viewport.height = xrViewport.height / textureHeight;
    }
    trySetViewportForView(viewport, view) {
        const subImage = this._lastSubImages.get(view.eye) || this._getSubImageForEye(view.eye);
        if (subImage) {
            this._setViewportForSubImage(viewport, subImage);
            return true;
        }
        return false;
    }
}

});



parcelRegister("31Z3E", function(module, exports) {

$parcel$export(module.exports, "WebXRDepthSensing", () => $2350d3efef409170$export$fd24c4b1ab9ae29a);

var $5Egpj = parcelRequire("5Egpj");

var $cJN7d = parcelRequire("cJN7d");

var $2YzP2 = parcelRequire("2YzP2");

var $bOhSV = parcelRequire("bOhSV");

var $j2mX5 = parcelRequire("j2mX5");

var $5YkyR = parcelRequire("5YkyR");

var $diGQf = parcelRequire("diGQf");

var $8ClRi = parcelRequire("8ClRi");

var $b9e4a = parcelRequire("b9e4a");
class $2350d3efef409170$export$fd24c4b1ab9ae29a extends (0, $2YzP2.WebXRAbstractFeature) {
    /**
     * Width of depth data. If depth data is not exist, returns null.
     */ get width() {
        return this._width;
    }
    /**
     * Height of depth data. If depth data is not exist, returns null.
     */ get height() {
        return this._height;
    }
    /**
     * Scale factor by which the raw depth values must be multiplied in order to get the depths in meters.
     */ get rawValueToMeters() {
        return this._rawValueToMeters;
    }
    /**
     * An XRRigidTransform that needs to be applied when indexing into the depth buffer.
     */ get normDepthBufferFromNormView() {
        return this._normDepthBufferFromNormView;
    }
    /**
     * Describes which depth-sensing usage ("cpu" or "gpu") is used.
     */ get depthUsage() {
        switch(this._xrSessionManager.session.depthUsage){
            case "cpu-optimized":
                return "cpu";
            case "gpu-optimized":
                return "gpu";
        }
    }
    /**
     * Describes which depth sensing data format ("ushort" or "float") is used.
     */ get depthDataFormat() {
        switch(this._xrSessionManager.session.depthDataFormat){
            case "luminance-alpha":
                return "ushort";
            case "float32":
                return "float";
        }
    }
    /**
     * Latest cached InternalTexture which containing depth buffer information.
     * This can be used when the depth usage is "gpu".
     */ get latestInternalTexture() {
        if (!this._cachedWebGLTexture) return null;
        const engine = this._xrSessionManager.scene.getEngine();
        const internalTexture = new (0, $b9e4a.InternalTexture)(engine, (0, $b9e4a.InternalTextureSource).Unknown);
        internalTexture.isCube = false;
        internalTexture.invertY = false;
        internalTexture._useSRGBBuffer = false;
        internalTexture.format = this.depthDataFormat === "ushort" ? 2 : 5;
        internalTexture.generateMipMaps = false;
        internalTexture.type = this.depthDataFormat === "ushort" ? 5 : 1;
        internalTexture.samplingMode = 7;
        internalTexture.width = this.width ?? 0;
        internalTexture.height = this.height ?? 0;
        internalTexture._cachedWrapU = 1;
        internalTexture._cachedWrapV = 1;
        internalTexture._hardwareTexture = new (0, $8ClRi.WebGLHardwareTexture)(this._cachedWebGLTexture, engine._gl);
        return internalTexture;
    }
    /**
     * cached depth buffer
     */ get latestDepthBuffer() {
        if (!this._cachedDepthBuffer) return null;
        return this.depthDataFormat === "ushort" ? new Uint16Array(this._cachedDepthBuffer) : new Float32Array(this._cachedDepthBuffer);
    }
    /**
     * Latest cached Texture of depth image which is made from the depth buffer data.
     */ get latestDepthImageTexture() {
        return this._cachedDepthImageTexture;
    }
    /**
     * Creates a new instance of the depth sensing feature
     * @param _xrSessionManager the WebXRSessionManager
     * @param options options for WebXR Depth Sensing Feature
     */ constructor(_xrSessionManager, options){
        super(_xrSessionManager);
        this.options = options;
        this._width = null;
        this._height = null;
        this._rawValueToMeters = null;
        this._normDepthBufferFromNormView = null;
        this._cachedDepthBuffer = null;
        this._cachedWebGLTexture = null;
        this._cachedDepthImageTexture = null;
        /**
         * Event that notify when `DepthInformation.getDepthInMeters` is available.
         * `getDepthInMeters` method needs active XRFrame (not available for cached XRFrame)
         */ this.onGetDepthInMetersAvailable = new (0, $diGQf.Observable)();
        this.xrNativeFeatureName = "depth-sensing";
        // https://immersive-web.github.io/depth-sensing/
        (0, $bOhSV.Tools).Warn("depth-sensing is an experimental and unstable feature.");
    }
    /**
     * attach this feature
     * Will usually be called by the features manager
     * @param force should attachment be forced (even when already attached)
     * @returns true if successful.
     */ attach(force) {
        if (!super.attach(force)) return false;
        const isBothDepthUsageAndFormatNull = this._xrSessionManager.session.depthDataFormat == null || this._xrSessionManager.session.depthUsage == null;
        if (isBothDepthUsageAndFormatNull) return false;
        this._glBinding = new XRWebGLBinding(this._xrSessionManager.session, this._xrSessionManager.scene.getEngine()._gl);
        return true;
    }
    /**
     * Dispose this feature and all of the resources attached
     */ dispose() {
        this._cachedDepthImageTexture?.dispose();
    }
    _onXRFrame(_xrFrame) {
        const referenceSPace = this._xrSessionManager.referenceSpace;
        const pose = _xrFrame.getViewerPose(referenceSPace);
        if (pose == null) return;
        for (const view of pose.views)switch(this.depthUsage){
            case "cpu":
                this._updateDepthInformationAndTextureCPUDepthUsage(_xrFrame, view, this.depthDataFormat);
                break;
            case "gpu":
                if (!this._glBinding) break;
                this._updateDepthInformationAndTextureWebGLDepthUsage(this._glBinding, view, this.depthDataFormat);
                break;
            default:
                (0, $bOhSV.Tools).Error("Unknown depth usage");
                this.detach();
                break;
        }
    }
    _updateDepthInformationAndTextureCPUDepthUsage(frame, view, dataFormat) {
        const depthInfo = frame.getDepthInformation(view);
        if (depthInfo === null) return;
        const { data: data, width: width, height: height, rawValueToMeters: rawValueToMeters, getDepthInMeters: getDepthInMeters } = depthInfo;
        this._width = width;
        this._height = height;
        this._rawValueToMeters = rawValueToMeters;
        this._cachedDepthBuffer = data;
        // to avoid Illegal Invocation error, bind `this`
        this.onGetDepthInMetersAvailable.notifyObservers(getDepthInMeters.bind(depthInfo));
        if (!this._cachedDepthImageTexture) this._cachedDepthImageTexture = (0, $5Egpj.RawTexture).CreateRTexture(null, width, height, this._xrSessionManager.scene, false, true, (0, $j2mX5.Texture).NEAREST_SAMPLINGMODE, (0, $5YkyR.Engine).TEXTURETYPE_FLOAT);
        switch(dataFormat){
            case "ushort":
                this._cachedDepthImageTexture.update(Float32Array.from(new Uint16Array(data)).map((value)=>value * rawValueToMeters));
                break;
            case "float":
                this._cachedDepthImageTexture.update(new Float32Array(data).map((value)=>value * rawValueToMeters));
                break;
            default:
                break;
        }
    }
    _updateDepthInformationAndTextureWebGLDepthUsage(webglBinding, view, dataFormat) {
        const depthInfo = webglBinding.getDepthInformation(view);
        if (depthInfo === null) return;
        const { texture: texture, width: width, height: height } = depthInfo;
        this._width = width;
        this._height = height;
        this._cachedWebGLTexture = texture;
        const scene = this._xrSessionManager.scene;
        const engine = scene.getEngine();
        const internalTexture = engine.wrapWebGLTexture(texture);
        if (!this._cachedDepthImageTexture) this._cachedDepthImageTexture = (0, $5Egpj.RawTexture).CreateRTexture(null, width, height, scene, false, true, (0, $j2mX5.Texture).NEAREST_SAMPLINGMODE, dataFormat === "ushort" ? (0, $5YkyR.Engine).TEXTURETYPE_UNSIGNED_BYTE : (0, $5YkyR.Engine).TEXTURETYPE_FLOAT);
        this._cachedDepthImageTexture._texture = internalTexture;
    }
    /**
     * Extends the session init object if needed
     * @returns augmentation object for the xr session init object.
     */ getXRSessionInitExtension() {
        const isDepthUsageDeclared = this.options.usagePreference != null && this.options.usagePreference.length !== 0;
        const isDataFormatDeclared = this.options.dataFormatPreference != null && this.options.dataFormatPreference.length !== 0;
        return new Promise((resolve)=>{
            if (isDepthUsageDeclared && isDataFormatDeclared) {
                const usages = this.options.usagePreference.map((usage)=>{
                    switch(usage){
                        case "cpu":
                            return "cpu-optimized";
                        case "gpu":
                            return "gpu-optimized";
                    }
                });
                const dataFormats = this.options.dataFormatPreference.map((format)=>{
                    switch(format){
                        case "ushort":
                            return "luminance-alpha";
                        case "float":
                            return "float32";
                    }
                });
                resolve({
                    depthSensing: {
                        usagePreference: usages,
                        dataFormatPreference: dataFormats
                    }
                });
            } else resolve({});
        });
    }
}
/**
 * The module's name
 */ $2350d3efef409170$export$fd24c4b1ab9ae29a.Name = (0, $cJN7d.WebXRFeatureName).DEPTH_SENSING;
/**
 * The (Babylon) version of this module.
 * This is an integer representing the implementation version.
 * This number does not correspond to the WebXR specs version
 */ $2350d3efef409170$export$fd24c4b1ab9ae29a.Version = 1;
(0, $cJN7d.WebXRFeaturesManager).AddWebXRFeature($2350d3efef409170$export$fd24c4b1ab9ae29a.Name, (xrSessionManager, options)=>{
    return ()=>new $2350d3efef409170$export$fd24c4b1ab9ae29a(xrSessionManager, options);
}, $2350d3efef409170$export$fd24c4b1ab9ae29a.Version, false);

});

parcelRegister("4891F", function(module, exports) {

$parcel$export(module.exports, "XRSpaceWarpRenderTarget", () => $301ee92068cab9ba$export$12d3ffb68582039d);
$parcel$export(module.exports, "WebXRSpaceWarpRenderTargetTextureProvider", () => $301ee92068cab9ba$export$fe43080e140de610);
$parcel$export(module.exports, "WebXRSpaceWarp", () => $301ee92068cab9ba$export$c56ce88df71f6175);

var $cJN7d = parcelRequire("cJN7d");

var $2YzP2 = parcelRequire("2YzP2");

var $ha1VO = parcelRequire("ha1VO");

var $gQtNK = parcelRequire("gQtNK");

var $4I7rl = parcelRequire("4I7rl");
parcelRequire("fNiHi");
parcelRequire("l1qWs");
class $301ee92068cab9ba$export$12d3ffb68582039d extends (0, $gQtNK.RenderTargetTexture) {
    /**
     * Creates a Space Warp render target
     * @param motionVectorTexture WebGLTexture provided by WebGLSubImage
     * @param depthStencilTexture WebGLTexture provided by WebGLSubImage
     * @param scene scene used with the render target
     * @param size the size of the render target (used for each view)
     */ constructor(motionVectorTexture, depthStencilTexture, scene, size = 512){
        super("spacewarp rtt", size, scene, false, true, 2, false, undefined, false, false, true, undefined, true);
        this._originalPairing = [];
        this._previousWorldMatrices = [];
        this._previousTransforms = [
            (0, $ha1VO.Matrix).Identity(),
            (0, $ha1VO.Matrix).Identity()
        ];
        this._renderTarget = this.getScene().getEngine().createMultiviewRenderTargetTexture(this.getRenderWidth(), this.getRenderHeight(), motionVectorTexture, depthStencilTexture);
        this._renderTarget._disposeOnlyFramebuffers = true;
        this._texture = this._renderTarget.texture;
        this._texture.isMultiview = true;
        this._texture.format = 5;
        if (scene) {
            this._velocityMaterial = new (0, $4I7rl.ShaderMaterial)("velocity shader material", scene, {
                vertex: "velocity",
                fragment: "velocity"
            }, {
                uniforms: [
                    "world",
                    "previousWorld",
                    "viewProjection",
                    "viewProjectionR",
                    "previousViewProjection",
                    "previousViewProjectionR"
                ]
            });
            this._velocityMaterial._materialHelperNeedsPreviousMatrices = true;
            this._velocityMaterial.onBindObservable.add((mesh)=>{
                // mesh. getWorldMatrix can be incorrect under rare conditions (e.g. when using a effective mesh in the render function).
                // If the case arise that will require changing it we will need to change the bind process in the material class to also provide the world matrix as a parameter
                this._previousWorldMatrices[mesh.uniqueId] = this._previousWorldMatrices[mesh.uniqueId] || mesh.getWorldMatrix();
                this._velocityMaterial.getEffect().setMatrix("previousWorld", this._previousWorldMatrices[mesh.uniqueId]);
                this._previousWorldMatrices[mesh.uniqueId] = mesh.getWorldMatrix();
                // now set the scene's previous matrix
                this._velocityMaterial.getEffect().setMatrix("previousViewProjection", this._previousTransforms[0]);
                // multiview for sure
                this._velocityMaterial.getEffect().setMatrix("previousViewProjectionR", this._previousTransforms[1]);
                // store the previous (current, to be exact) transforms
                this._previousTransforms[0].copyFrom(scene.getTransformMatrix());
                this._previousTransforms[1].copyFrom(scene._transformMatrixR);
            });
            this._velocityMaterial.freeze();
        }
    }
    render(useCameraPostProcess = false, dumpForDebug = false) {
        // Swap to use velocity material
        this._originalPairing.length = 0;
        const scene = this.getScene();
        // set the velocity material to render the velocity RTT
        if (scene && this._velocityMaterial) scene.getActiveMeshes().forEach((mesh)=>{
            this._originalPairing.push([
                mesh,
                mesh.material
            ]);
            mesh.material = this._velocityMaterial;
        });
        super.render(useCameraPostProcess, dumpForDebug);
        // Restore original materials
        this._originalPairing.forEach((tuple)=>{
            tuple[0].material = tuple[1];
        });
    }
    /**
     * @internal
     */ _bindFrameBuffer() {
        if (!this._renderTarget) return;
        this.getScene().getEngine().bindSpaceWarpFramebuffer(this._renderTarget);
    }
    /**
     * Gets the number of views the corresponding to the texture (eg. a SpaceWarpRenderTarget will have > 1)
     * @returns the view count
     */ getViewCount() {
        return 2;
    }
    dispose() {
        super.dispose();
        this._velocityMaterial.dispose();
        this._previousTransforms.length = 0;
        this._previousWorldMatrices.length = 0;
        this._originalPairing.length = 0;
    }
}
class $301ee92068cab9ba$export$fe43080e140de610 {
    constructor(_scene, _xrSessionManager, _xrWebGLBinding){
        this._scene = _scene;
        this._xrSessionManager = _xrSessionManager;
        this._xrWebGLBinding = _xrWebGLBinding;
        this._lastSubImages = new Map();
        this._renderTargetTextures = new Map();
        this._engine = _scene.getEngine();
    }
    _getSubImageForView(view) {
        const layerWrapper = this._xrSessionManager._getBaseLayerWrapper();
        if (!layerWrapper) throw new Error("For Space Warp, the base layer should be a WebXR Projection Layer.");
        if (layerWrapper.layerType !== "XRProjectionLayer") throw new Error('For Space Warp, the base layer type should "XRProjectionLayer".');
        const layer = layerWrapper.layer;
        return this._xrWebGLBinding.getViewSubImage(layer, view);
    }
    _setViewportForSubImage(viewport, subImage) {
        viewport.x = 0;
        viewport.y = 0;
        viewport.width = subImage.motionVectorTextureWidth;
        viewport.height = subImage.motionVectorTextureHeight;
    }
    _createRenderTargetTexture(width, height, framebuffer, motionVectorTexture, depthStencilTexture) {
        if (!this._engine) throw new Error("Engine is disposed");
        const textureSize = {
            width: width,
            height: height
        };
        // Create render target texture from the internal texture
        const renderTargetTexture = new $301ee92068cab9ba$export$12d3ffb68582039d(motionVectorTexture, depthStencilTexture, this._scene, textureSize);
        const renderTargetWrapper = renderTargetTexture.renderTarget;
        if (framebuffer) renderTargetWrapper._framebuffer = framebuffer;
        // Create internal texture
        renderTargetWrapper._colorTextureArray = motionVectorTexture;
        renderTargetWrapper._depthStencilTextureArray = depthStencilTexture;
        renderTargetTexture.disableRescaling();
        renderTargetTexture.renderListPredicate = ()=>true;
        return renderTargetTexture;
    }
    _getRenderTargetForSubImage(subImage, view) {
        const lastSubImage = this._lastSubImages.get(view);
        let renderTargetTexture = this._renderTargetTextures.get(view.eye);
        const width = subImage.motionVectorTextureWidth;
        const height = subImage.motionVectorTextureHeight;
        if (!renderTargetTexture || lastSubImage?.textureWidth !== width || lastSubImage?.textureHeight != height) {
            renderTargetTexture = this._createRenderTargetTexture(width, height, null, subImage.motionVectorTexture, subImage.depthStencilTexture);
            this._renderTargetTextures.set(view.eye, renderTargetTexture);
            this._framebufferDimensions = {
                framebufferWidth: width,
                framebufferHeight: height
            };
        }
        this._lastSubImages.set(view, subImage);
        return renderTargetTexture;
    }
    trySetViewportForView(viewport, view) {
        const subImage = this._lastSubImages.get(view) || this._getSubImageForView(view);
        if (subImage) {
            this._setViewportForSubImage(viewport, subImage);
            return true;
        }
        return false;
    }
    /**
     * Access the motion vector (which will turn on Space Warp)
     * @param view the view to access the motion vector texture for
     */ accessMotionVector(view) {
        const subImage = this._getSubImageForView(view);
        if (subImage) {
            // Meta Quest Browser uses accessing these textures as a sign for turning on Space Warp
            subImage.motionVectorTexture;
            subImage.depthStencilTexture;
        }
    }
    getRenderTargetTextureForEye(_eye) {
        return null;
    }
    getRenderTargetTextureForView(view) {
        const subImage = this._getSubImageForView(view);
        if (subImage) return this._getRenderTargetForSubImage(subImage, view);
        return null;
    }
    dispose() {
        this._renderTargetTextures.forEach((rtt)=>rtt.dispose());
        this._renderTargetTextures.clear();
    }
}
class $301ee92068cab9ba$export$c56ce88df71f6175 extends (0, $2YzP2.WebXRAbstractFeature) {
    /**
     * constructor for the space warp feature
     * @param _xrSessionManager the xr session manager for this feature
     */ constructor(_xrSessionManager){
        super(_xrSessionManager);
        this._onAfterRenderObserver = null;
        this.dependsOn = [
            (0, $cJN7d.WebXRFeatureName).LAYERS
        ];
        this.xrNativeFeatureName = "space-warp";
        this._xrSessionManager.scene.needsPreviousWorldMatrices = true;
    }
    /**
     * Attach this feature.
     * Will usually be called by the features manager.
     *
     * @returns true if successful.
     */ attach() {
        if (!super.attach()) return false;
        const engine = this._xrSessionManager.scene.getEngine();
        this._glContext = engine._gl;
        this._xrWebGLBinding = new XRWebGLBinding(this._xrSessionManager.session, this._glContext);
        this.spaceWarpRTTProvider = new $301ee92068cab9ba$export$fe43080e140de610(this._xrSessionManager.scene, this._xrSessionManager, this._xrWebGLBinding);
        this._onAfterRenderObserver = this._xrSessionManager.scene.onAfterRenderObservable.add(()=>this._onAfterRender());
        return true;
    }
    detach() {
        this._xrSessionManager.scene.onAfterRenderObservable.remove(this._onAfterRenderObserver);
        return super.detach();
    }
    _onAfterRender() {
        if (this.attached && this._renderTargetTexture) this._renderTargetTexture.render(false, false);
    }
    isCompatible() {
        return this._xrSessionManager.scene.getEngine().getCaps().colorBufferHalfFloat || false;
    }
    dispose() {
        super.dispose();
    }
    _onXRFrame(_xrFrame) {
        const pose = _xrFrame.getViewerPose(this._xrSessionManager.referenceSpace);
        if (!pose) return;
        // get the first view to which we will create a texture (or update it)
        const view = pose.views[0];
        this._renderTargetTexture = this._renderTargetTexture || this.spaceWarpRTTProvider.getRenderTargetTextureForView(view);
        this.spaceWarpRTTProvider.accessMotionVector(view);
    }
}
/**
 * The module's name
 */ $301ee92068cab9ba$export$c56ce88df71f6175.Name = (0, $cJN7d.WebXRFeatureName).SPACE_WARP;
/**
 * The (Babylon) version of this module.
 * This is an integer representing the implementation version.
 * This number does not correspond to the WebXR specs version
 */ $301ee92068cab9ba$export$c56ce88df71f6175.Version = 1;
//register the plugin
(0, $cJN7d.WebXRFeaturesManager).AddWebXRFeature($301ee92068cab9ba$export$c56ce88df71f6175.Name, (xrSessionManager)=>{
    return ()=>new $301ee92068cab9ba$export$c56ce88df71f6175(xrSessionManager);
}, $301ee92068cab9ba$export$c56ce88df71f6175.Version, false);

});
parcelRegister("fNiHi", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
const $b7f9ef81b702e3b9$var$name = "velocityPixelShader";
const $b7f9ef81b702e3b9$var$shader = `precision highp float;
#define CUSTOM_FRAGMENT_BEGIN
varying vec4 clipPos;varying vec4 previousClipPos;
#define CUSTOM_FRAGMENT_DEFINITIONS
void main(void) {
#define CUSTOM_FRAGMENT_MAIN_BEGIN
highp vec4 motionVector=( clipPos/clipPos.w-previousClipPos/previousClipPos.w );gl_FragColor=motionVector;
#define CUSTOM_FRAGMENT_MAIN_END
}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$b7f9ef81b702e3b9$var$name] = $b7f9ef81b702e3b9$var$shader;
const $b7f9ef81b702e3b9$export$5ddb9a2e66a13a43 = {
    name: $b7f9ef81b702e3b9$var$name,
    shader: $b7f9ef81b702e3b9$var$shader
};

});

parcelRegister("l1qWs", function(module, exports) {
// Do not edit.

var $68BIi = parcelRequire("68BIi");
parcelRequire("k3wwH");
parcelRequire("apKdp");
const $f4de970ad3014a80$var$name = "velocityVertexShader";
const $f4de970ad3014a80$var$shader = `#define CUSTOM_VERTEX_BEGIN
#define VELOCITY
attribute vec3 position;
#include<instancesDeclaration>
uniform mat4 viewProjection;uniform mat4 previousViewProjection;
#ifdef MULTIVIEW
uniform mat4 viewProjectionR;uniform mat4 previousViewProjectionR;
#endif
varying vec4 clipPos;varying vec4 previousClipPos;
#define CUSTOM_VERTEX_DEFINITIONS
void main(void) {
#define CUSTOM_VERTEX_MAIN_BEGIN
vec3 positionUpdated=position;
#include<instancesVertex>
vec4 worldPos=finalWorld*vec4(positionUpdated,1.0);vec4 previousWorldPos=finalPreviousWorld*vec4(positionUpdated,1.0);
#ifdef MULTIVIEW
if (gl_ViewID_OVR==0u) {clipPos=viewProjection*worldPos;previousClipPos=previousViewProjection*previousWorldPos;gl_Position=clipPos;} else {clipPos=viewProjectionR*worldPos;previousClipPos=previousViewProjectionR*previousWorldPos;gl_Position=clipPos;}
#elif
clipPos=viewProjection*worldPos;previousClipPos=previousViewProjection*previousWorldPos;gl_Position=clipPos;
#endif
#define CUSTOM_VERTEX_MAIN_END
}`;
// Sideeffect
(0, $68BIi.ShaderStore).ShadersStore[$f4de970ad3014a80$var$name] = $f4de970ad3014a80$var$shader;
const $f4de970ad3014a80$export$7cd7e10969b8b1f9 = {
    name: $f4de970ad3014a80$var$name,
    shader: $f4de970ad3014a80$var$shader
};

});


parcelRegister("1LXzc", function(module, exports) {

$parcel$export(module.exports, "WebXRRawCameraAccess", () => $14a862f7db197d57$export$1183c2cc1a8ba0dd);

var $cJN7d = parcelRequire("cJN7d");

var $2YzP2 = parcelRequire("2YzP2");

var $diGQf = parcelRequire("diGQf");

var $8ClRi = parcelRequire("8ClRi");

var $b9e4a = parcelRequire("b9e4a");

var $akOl3 = parcelRequire("akOl3");
class $14a862f7db197d57$export$1183c2cc1a8ba0dd extends (0, $2YzP2.WebXRAbstractFeature) {
    /**
     * Creates a new instance of the feature
     * @param _xrSessionManager the WebXRSessionManager
     * @param options options for the Feature
     */ constructor(_xrSessionManager, options = {}){
        super(_xrSessionManager);
        this.options = options;
        this._cachedInternalTextures = [];
        /**
         * This is an array of camera views
         * Note that mostly the array will contain a single view
         * If you want to know the order of the views, use the `viewIndex` array
         */ this.texturesData = [];
        /**
         * If needed, this array will contain the eye definition of each texture in `texturesArray`
         */ this.viewIndex = [];
        /**
         * If needed, this array will contain the camera's intrinsics
         * You can use this data to convert from camera space to screen space and vice versa
         */ this.cameraIntrinsics = [];
        /**
         * An observable that will notify when the camera's textures are updated
         */ this.onTexturesUpdatedObservable = new (0, $diGQf.Observable)();
        this.xrNativeFeatureName = "camera-access";
    }
    attach(force) {
        if (!super.attach(force)) return false;
        this._glContext = this._xrSessionManager.scene.getEngine()._gl;
        this._glBinding = new XRWebGLBinding(this._xrSessionManager.session, this._glContext);
        return true;
    }
    detach() {
        if (!super.detach()) return false;
        this._glBinding = undefined;
        if (!this.options.doNotDisposeOnDetach) {
            this._cachedInternalTextures.forEach((t)=>t.dispose());
            this.texturesData.forEach((t)=>t.dispose());
            this._cachedInternalTextures.length = 0;
            this.texturesData.length = 0;
            this.cameraIntrinsics.length = 0;
        }
        return true;
    }
    /**
     * Dispose this feature and all of the resources attached
     */ dispose() {
        super.dispose();
        this.onTexturesUpdatedObservable.clear();
    }
    /**
     * @see https://github.com/immersive-web/raw-camera-access/blob/main/explainer.md
     * @param view the XRView to update
     * @param index the index of the view in the views array
     */ _updateCameraIntrinsics(view, index) {
        const cameraViewport = {
            width: view.camera.width,
            height: view.camera.height,
            x: 0,
            y: 0
        };
        const p = view.projectionMatrix;
        // Principal point in pixels (typically at or near the center of the viewport)
        const u0 = (1 - p[8]) * cameraViewport.width / 2 + cameraViewport.x;
        const v0 = (1 - p[9]) * cameraViewport.height / 2 + cameraViewport.y;
        // Focal lengths in pixels (these are equal for square pixels)
        const ax = cameraViewport.width / 2 * p[0];
        const ay = cameraViewport.height / 2 * p[5];
        // Skew factor in pixels (nonzero for rhomboid pixels)
        const gamma = cameraViewport.width / 2 * p[4];
        this.cameraIntrinsics[index] = {
            u0: u0,
            v0: v0,
            ax: ax,
            ay: ay,
            gamma: gamma,
            width: cameraViewport.width,
            height: cameraViewport.height,
            viewportX: cameraViewport.x,
            viewportY: cameraViewport.y
        };
    }
    _updateInternalTextures(view, index = 0) {
        if (!view.camera) return false;
        this.viewIndex[index] = view.eye;
        const lp = this._glBinding?.getCameraImage(view.camera);
        if (!this._cachedInternalTextures[index]) {
            const internalTexture = new (0, $b9e4a.InternalTexture)(this._xrSessionManager.scene.getEngine(), (0, $b9e4a.InternalTextureSource).Unknown, true);
            internalTexture.isCube = true;
            internalTexture.invertY = false;
            // internalTexture._useSRGBBuffer = this.options.reflectionFormat === "srgba8";
            internalTexture.format = 5;
            internalTexture.generateMipMaps = true;
            internalTexture.type = 1;
            internalTexture.samplingMode = 3;
            internalTexture.width = view.camera.width;
            internalTexture.height = view.camera.height;
            internalTexture._cachedWrapU = 1;
            internalTexture._cachedWrapV = 1;
            internalTexture._hardwareTexture = new (0, $8ClRi.WebGLHardwareTexture)(lp, this._glContext);
            this._cachedInternalTextures[index] = internalTexture;
            // create the base texture
            const texture = new (0, $akOl3.BaseTexture)(this._xrSessionManager.scene);
            texture.name = `WebXR Raw Camera Access (${index})`;
            texture._texture = this._cachedInternalTextures[index];
            this.texturesData[index] = texture;
            // get the camera intrinsics
            this._updateCameraIntrinsics(view, index);
        } else // make sure the webgl texture is updated. Should happen automatically
        this._cachedInternalTextures[index]._hardwareTexture?.set(lp);
        this._cachedInternalTextures[index].isReady = true;
        return true;
    }
    _onXRFrame(_xrFrame) {
        const referenceSPace = this._xrSessionManager.referenceSpace;
        const pose = _xrFrame.getViewerPose(referenceSPace);
        if (!pose || !pose.views) return;
        let updated = true;
        pose.views.forEach((view, index)=>{
            updated = updated && this._updateInternalTextures(view, index);
        });
        if (updated) this.onTexturesUpdatedObservable.notifyObservers(this.texturesData);
    }
}
/**
 * The module's name
 */ $14a862f7db197d57$export$1183c2cc1a8ba0dd.Name = (0, $cJN7d.WebXRFeatureName).RAW_CAMERA_ACCESS;
/**
 * The (Babylon) version of this module.
 * This is an integer representing the implementation version.
 * This number does not correspond to the WebXR specs version
 */ $14a862f7db197d57$export$1183c2cc1a8ba0dd.Version = 1;
(0, $cJN7d.WebXRFeaturesManager).AddWebXRFeature($14a862f7db197d57$export$1183c2cc1a8ba0dd.Name, (xrSessionManager, options)=>{
    return ()=>new $14a862f7db197d57$export$1183c2cc1a8ba0dd(xrSessionManager, options);
}, $14a862f7db197d57$export$1183c2cc1a8ba0dd.Version, false);

});


parcelRegister("56xI9", function(module, exports) {

var $d2047 = parcelRequire("d2047");

var $f9SMB = parcelRequire("f9SMB");

var $iu8uA = parcelRequire("iu8uA");

var $ho0hq = parcelRequire("ho0hq");

var $e93f2 = parcelRequire("e93f2");

var $ebuqW = parcelRequire("ebuqW");

var $eQUcM = parcelRequire("eQUcM");

var $49OyQ = parcelRequire("49OyQ");

var $xXlMh = parcelRequire("xXlMh");
$parcel$exportWildcard(module.exports, $d2047);
$parcel$exportWildcard(module.exports, $f9SMB);
$parcel$exportWildcard(module.exports, $iu8uA);
$parcel$exportWildcard(module.exports, $ho0hq);
$parcel$exportWildcard(module.exports, $e93f2);
$parcel$exportWildcard(module.exports, $ebuqW);
$parcel$exportWildcard(module.exports, $eQUcM);
$parcel$exportWildcard(module.exports, $49OyQ);
$parcel$exportWildcard(module.exports, $xXlMh);

});
parcelRegister("iu8uA", function(module, exports) {

$parcel$export(module.exports, "WebXRGenericHandController", () => $d7519dc2886fa5b6$export$4922dc916153d1f4);

var $d2047 = parcelRequire("d2047");

var $ebuqW = parcelRequire("ebuqW");
class $d7519dc2886fa5b6$export$4922dc916153d1f4 extends (0, $d2047.WebXRAbstractMotionController) {
    /**
     * Create a new hand controller object, without loading a controller model
     * @param scene the scene to use to create this controller
     * @param gamepadObject the corresponding gamepad object
     * @param handedness the handedness of the controller
     */ constructor(scene, gamepadObject, handedness){
        // Don't load the controller model - for now, hands have no real model.
        super(scene, $d7519dc2886fa5b6$var$GenericHandSelectGraspProfile[handedness], gamepadObject, handedness, true);
        this.profileId = "generic-hand-select-grasp";
    }
    _getFilenameAndPath() {
        return {
            filename: "generic.babylon",
            path: "https://controllers.babylonjs.com/generic/"
        };
    }
    _getModelLoadingConstraints() {
        return true;
    }
    _processLoadedModel(_meshes) {
    // no-op
    }
    _setRootMesh(meshes) {
    // no-op
    }
    _updateModel() {
    // no-op
    }
}
// register the profiles
(0, $ebuqW.WebXRMotionControllerManager).RegisterController("generic-hand-select-grasp", (xrInput, scene)=>{
    return new $d7519dc2886fa5b6$export$4922dc916153d1f4(scene, xrInput.gamepad, xrInput.handedness);
});
// https://github.com/immersive-web/webxr-input-profiles/blob/main/packages/registry/profiles/generic/generic-hand-select-grasp.json
const $d7519dc2886fa5b6$var$GenericHandSelectGraspProfile = {
    left: {
        selectComponentId: "xr-standard-trigger",
        components: {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            "xr-standard-trigger": {
                type: "trigger",
                gamepadIndices: {
                    button: 0
                },
                rootNodeName: "xr-standard-trigger",
                visualResponses: {}
            },
            grasp: {
                type: "trigger",
                gamepadIndices: {
                    button: 4
                },
                rootNodeName: "grasp",
                visualResponses: {}
            }
        },
        gamepadMapping: "xr-standard",
        rootNodeName: "generic-hand-select-grasp-left",
        assetPath: "left.glb"
    },
    right: {
        selectComponentId: "xr-standard-trigger",
        components: {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            "xr-standard-trigger": {
                type: "trigger",
                gamepadIndices: {
                    button: 0
                },
                rootNodeName: "xr-standard-trigger",
                visualResponses: {}
            },
            grasp: {
                type: "trigger",
                gamepadIndices: {
                    button: 4
                },
                rootNodeName: "grasp",
                visualResponses: {}
            }
        },
        gamepadMapping: "xr-standard",
        rootNodeName: "generic-hand-select-grasp-right",
        assetPath: "right.glb"
    },
    none: {
        selectComponentId: "xr-standard-trigger",
        components: {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            "xr-standard-trigger": {
                type: "trigger",
                gamepadIndices: {
                    button: 0
                },
                rootNodeName: "xr-standard-trigger",
                visualResponses: {}
            },
            grasp: {
                type: "trigger",
                gamepadIndices: {
                    button: 4
                },
                rootNodeName: "grasp",
                visualResponses: {}
            }
        },
        gamepadMapping: "xr-standard",
        rootNodeName: "generic-hand-select-grasp-none",
        assetPath: "none.glb"
    }
};

});

parcelRegister("e93f2", function(module, exports) {

$parcel$export(module.exports, "WebXRMicrosoftMixedRealityController", () => $a4c46badb055a816$export$2ffee1e8af89d958);

var $d2047 = parcelRequire("d2047");

var $ebuqW = parcelRequire("ebuqW");

var $fbuqw = parcelRequire("fbuqw");

var $ha1VO = parcelRequire("ha1VO");

var $agoTA = parcelRequire("agoTA");

var $kVtWi = parcelRequire("kVtWi");
class $a4c46badb055a816$export$2ffee1e8af89d958 extends (0, $d2047.WebXRAbstractMotionController) {
    constructor(scene, gamepadObject, handedness){
        super(scene, $a4c46badb055a816$var$MixedRealityProfile["left-right"], gamepadObject, handedness);
        // use this in the future - https://github.com/immersive-web/webxr-input-profiles/tree/master/packages/assets/profiles/microsoft
        this._mapping = {
            defaultButton: {
                valueNodeName: "VALUE",
                unpressedNodeName: "UNPRESSED",
                pressedNodeName: "PRESSED"
            },
            defaultAxis: {
                valueNodeName: "VALUE",
                minNodeName: "MIN",
                maxNodeName: "MAX"
            },
            buttons: {
                "xr-standard-trigger": {
                    rootNodeName: "SELECT",
                    componentProperty: "button",
                    states: [
                        "default",
                        "touched",
                        "pressed"
                    ]
                },
                "xr-standard-squeeze": {
                    rootNodeName: "GRASP",
                    componentProperty: "state",
                    states: [
                        "pressed"
                    ]
                },
                "xr-standard-touchpad": {
                    rootNodeName: "TOUCHPAD_PRESS",
                    labelAnchorNodeName: "squeeze-label",
                    touchPointNodeName: "TOUCH"
                },
                "xr-standard-thumbstick": {
                    rootNodeName: "THUMBSTICK_PRESS",
                    componentProperty: "state",
                    states: [
                        "pressed"
                    ]
                }
            },
            axes: {
                "xr-standard-touchpad": {
                    "x-axis": {
                        rootNodeName: "TOUCHPAD_TOUCH_X"
                    },
                    "y-axis": {
                        rootNodeName: "TOUCHPAD_TOUCH_Y"
                    }
                },
                "xr-standard-thumbstick": {
                    "x-axis": {
                        rootNodeName: "THUMBSTICK_X"
                    },
                    "y-axis": {
                        rootNodeName: "THUMBSTICK_Y"
                    }
                }
            }
        };
        this.profileId = "microsoft-mixed-reality";
    }
    _getFilenameAndPath() {
        let filename = "";
        if (this.handedness === "left") filename = $a4c46badb055a816$export$2ffee1e8af89d958.MODEL_LEFT_FILENAME;
        else // Right is the default if no hand is specified
        filename = $a4c46badb055a816$export$2ffee1e8af89d958.MODEL_RIGHT_FILENAME;
        const device = "default";
        const path = $a4c46badb055a816$export$2ffee1e8af89d958.MODEL_BASE_URL + device + "/";
        return {
            filename: filename,
            path: path
        };
    }
    _getModelLoadingConstraints() {
        const glbLoaded = (0, $agoTA.SceneLoader).IsPluginForExtensionAvailable(".glb");
        if (!glbLoaded) (0, $kVtWi.Logger).Warn("glTF / glb loaded was not registered, using generic controller instead");
        return glbLoaded;
    }
    _processLoadedModel(_meshes) {
        if (!this.rootMesh) return;
        // Button Meshes
        this.getComponentIds().forEach((id, i)=>{
            if (this.disableAnimation) return;
            if (id && this.rootMesh) {
                const buttonMap = this._mapping.buttons[id];
                const buttonMeshName = buttonMap.rootNodeName;
                if (!buttonMeshName) {
                    (0, $kVtWi.Logger).Log("Skipping unknown button at index: " + i + " with mapped name: " + id);
                    return;
                }
                const buttonMesh = this._getChildByName(this.rootMesh, buttonMeshName);
                if (!buttonMesh) {
                    (0, $kVtWi.Logger).Warn("Missing button mesh with name: " + buttonMeshName);
                    return;
                }
                buttonMap.valueMesh = this._getImmediateChildByName(buttonMesh, this._mapping.defaultButton.valueNodeName);
                buttonMap.pressedMesh = this._getImmediateChildByName(buttonMesh, this._mapping.defaultButton.pressedNodeName);
                buttonMap.unpressedMesh = this._getImmediateChildByName(buttonMesh, this._mapping.defaultButton.unpressedNodeName);
                if (buttonMap.valueMesh && buttonMap.pressedMesh && buttonMap.unpressedMesh) {
                    const comp = this.getComponent(id);
                    if (comp) comp.onButtonStateChangedObservable.add((component)=>{
                        this._lerpTransform(buttonMap, component.value);
                    }, undefined, true);
                } else // If we didn't find the mesh, it simply means this button won't have transforms applied as mapped button value changes.
                (0, $kVtWi.Logger).Warn("Missing button submesh under mesh with name: " + buttonMeshName);
            }
        });
        // Axis Meshes
        this.getComponentIds().forEach((id)=>{
            const comp = this.getComponent(id);
            if (!comp.isAxes()) return;
            [
                "x-axis",
                "y-axis"
            ].forEach((axis)=>{
                if (!this.rootMesh) return;
                const axisMap = this._mapping.axes[id][axis];
                const axisMesh = this._getChildByName(this.rootMesh, axisMap.rootNodeName);
                if (!axisMesh) {
                    (0, $kVtWi.Logger).Warn("Missing axis mesh with name: " + axisMap.rootNodeName);
                    return;
                }
                axisMap.valueMesh = this._getImmediateChildByName(axisMesh, this._mapping.defaultAxis.valueNodeName);
                axisMap.minMesh = this._getImmediateChildByName(axisMesh, this._mapping.defaultAxis.minNodeName);
                axisMap.maxMesh = this._getImmediateChildByName(axisMesh, this._mapping.defaultAxis.maxNodeName);
                if (axisMap.valueMesh && axisMap.minMesh && axisMap.maxMesh) {
                    if (comp) comp.onAxisValueChangedObservable.add((axisValues)=>{
                        const value = axis === "x-axis" ? axisValues.x : axisValues.y;
                        this._lerpTransform(axisMap, value, true);
                    }, undefined, true);
                } else // If we didn't find the mesh, it simply means this button won't have transforms applied as mapped button value changes.
                (0, $kVtWi.Logger).Warn("Missing axis submesh under mesh with name: " + axisMap.rootNodeName);
            });
        });
    }
    _setRootMesh(meshes) {
        this.rootMesh = new (0, $fbuqw.Mesh)(this.profileId + " " + this.handedness, this.scene);
        this.rootMesh.isPickable = false;
        let rootMesh;
        // Find the root node in the loaded glTF scene, and attach it as a child of 'parentMesh'
        for(let i = 0; i < meshes.length; i++){
            const mesh = meshes[i];
            mesh.isPickable = false;
            if (!mesh.parent) // Handle root node, attach to the new parentMesh
            rootMesh = mesh;
        }
        if (rootMesh) rootMesh.setParent(this.rootMesh);
        if (!this.scene.useRightHandedSystem) this.rootMesh.rotationQuaternion = (0, $ha1VO.Quaternion).FromEulerAngles(0, Math.PI, 0);
    }
    _updateModel() {
    // no-op. model is updated using observables.
    }
}
/**
 * The base url used to load the left and right controller models
 */ $a4c46badb055a816$export$2ffee1e8af89d958.MODEL_BASE_URL = "https://controllers.babylonjs.com/microsoft/";
/**
 * The name of the left controller model file
 */ $a4c46badb055a816$export$2ffee1e8af89d958.MODEL_LEFT_FILENAME = "left.glb";
/**
 * The name of the right controller model file
 */ $a4c46badb055a816$export$2ffee1e8af89d958.MODEL_RIGHT_FILENAME = "right.glb";
// register the profile
(0, $ebuqW.WebXRMotionControllerManager).RegisterController("windows-mixed-reality", (xrInput, scene)=>{
    return new $a4c46badb055a816$export$2ffee1e8af89d958(scene, xrInput.gamepad, xrInput.handedness);
});
// https://github.com/immersive-web/webxr-input-profiles/blob/master/packages/registry/profiles/microsoft/microsoft-mixed-reality.json
const $a4c46badb055a816$var$MixedRealityProfile = {
    left: {
        selectComponentId: "xr-standard-trigger",
        components: {
            "xr-standard-trigger": {
                type: "trigger",
                gamepadIndices: {
                    button: 0
                },
                rootNodeName: "xr_standard_trigger",
                visualResponses: {
                    xr_standard_trigger_pressed: {
                        componentProperty: "button",
                        states: [
                            "default",
                            "touched",
                            "pressed"
                        ],
                        valueNodeProperty: "transform",
                        valueNodeName: "xr_standard_trigger_pressed_value",
                        minNodeName: "xr_standard_trigger_pressed_min",
                        maxNodeName: "xr_standard_trigger_pressed_max"
                    }
                }
            },
            "xr-standard-squeeze": {
                type: "squeeze",
                gamepadIndices: {
                    button: 1
                },
                rootNodeName: "xr_standard_squeeze",
                visualResponses: {
                    xr_standard_squeeze_pressed: {
                        componentProperty: "button",
                        states: [
                            "default",
                            "touched",
                            "pressed"
                        ],
                        valueNodeProperty: "transform",
                        valueNodeName: "xr_standard_squeeze_pressed_value",
                        minNodeName: "xr_standard_squeeze_pressed_min",
                        maxNodeName: "xr_standard_squeeze_pressed_max"
                    }
                }
            },
            "xr-standard-touchpad": {
                type: "touchpad",
                gamepadIndices: {
                    button: 2,
                    xAxis: 0,
                    yAxis: 1
                },
                rootNodeName: "xr_standard_touchpad",
                visualResponses: {
                    xr_standard_touchpad_pressed: {
                        componentProperty: "button",
                        states: [
                            "default",
                            "touched",
                            "pressed"
                        ],
                        valueNodeProperty: "transform",
                        valueNodeName: "xr_standard_touchpad_pressed_value",
                        minNodeName: "xr_standard_touchpad_pressed_min",
                        maxNodeName: "xr_standard_touchpad_pressed_max"
                    },
                    xr_standard_touchpad_xaxis_pressed: {
                        componentProperty: "xAxis",
                        states: [
                            "default",
                            "touched",
                            "pressed"
                        ],
                        valueNodeProperty: "transform",
                        valueNodeName: "xr_standard_touchpad_xaxis_pressed_value",
                        minNodeName: "xr_standard_touchpad_xaxis_pressed_min",
                        maxNodeName: "xr_standard_touchpad_xaxis_pressed_max"
                    },
                    xr_standard_touchpad_yaxis_pressed: {
                        componentProperty: "yAxis",
                        states: [
                            "default",
                            "touched",
                            "pressed"
                        ],
                        valueNodeProperty: "transform",
                        valueNodeName: "xr_standard_touchpad_yaxis_pressed_value",
                        minNodeName: "xr_standard_touchpad_yaxis_pressed_min",
                        maxNodeName: "xr_standard_touchpad_yaxis_pressed_max"
                    },
                    xr_standard_touchpad_xaxis_touched: {
                        componentProperty: "xAxis",
                        states: [
                            "default",
                            "touched",
                            "pressed"
                        ],
                        valueNodeProperty: "transform",
                        valueNodeName: "xr_standard_touchpad_xaxis_touched_value",
                        minNodeName: "xr_standard_touchpad_xaxis_touched_min",
                        maxNodeName: "xr_standard_touchpad_xaxis_touched_max"
                    },
                    xr_standard_touchpad_yaxis_touched: {
                        componentProperty: "yAxis",
                        states: [
                            "default",
                            "touched",
                            "pressed"
                        ],
                        valueNodeProperty: "transform",
                        valueNodeName: "xr_standard_touchpad_yaxis_touched_value",
                        minNodeName: "xr_standard_touchpad_yaxis_touched_min",
                        maxNodeName: "xr_standard_touchpad_yaxis_touched_max"
                    },
                    xr_standard_touchpad_axes_touched: {
                        componentProperty: "state",
                        states: [
                            "touched",
                            "pressed"
                        ],
                        valueNodeProperty: "visibility",
                        valueNodeName: "xr_standard_touchpad_axes_touched_value"
                    }
                },
                touchPointNodeName: "xr_standard_touchpad_axes_touched_value"
            },
            "xr-standard-thumbstick": {
                type: "thumbstick",
                gamepadIndices: {
                    button: 3,
                    xAxis: 2,
                    yAxis: 3
                },
                rootNodeName: "xr_standard_thumbstick",
                visualResponses: {
                    xr_standard_thumbstick_pressed: {
                        componentProperty: "button",
                        states: [
                            "default",
                            "touched",
                            "pressed"
                        ],
                        valueNodeProperty: "transform",
                        valueNodeName: "xr_standard_thumbstick_pressed_value",
                        minNodeName: "xr_standard_thumbstick_pressed_min",
                        maxNodeName: "xr_standard_thumbstick_pressed_max"
                    },
                    xr_standard_thumbstick_xaxis_pressed: {
                        componentProperty: "xAxis",
                        states: [
                            "default",
                            "touched",
                            "pressed"
                        ],
                        valueNodeProperty: "transform",
                        valueNodeName: "xr_standard_thumbstick_xaxis_pressed_value",
                        minNodeName: "xr_standard_thumbstick_xaxis_pressed_min",
                        maxNodeName: "xr_standard_thumbstick_xaxis_pressed_max"
                    },
                    xr_standard_thumbstick_yaxis_pressed: {
                        componentProperty: "yAxis",
                        states: [
                            "default",
                            "touched",
                            "pressed"
                        ],
                        valueNodeProperty: "transform",
                        valueNodeName: "xr_standard_thumbstick_yaxis_pressed_value",
                        minNodeName: "xr_standard_thumbstick_yaxis_pressed_min",
                        maxNodeName: "xr_standard_thumbstick_yaxis_pressed_max"
                    }
                }
            }
        },
        gamepadMapping: "xr-standard",
        rootNodeName: "microsoft-mixed-reality-left",
        assetPath: "left.glb"
    },
    right: {
        selectComponentId: "xr-standard-trigger",
        components: {
            "xr-standard-trigger": {
                type: "trigger",
                gamepadIndices: {
                    button: 0
                },
                rootNodeName: "xr_standard_trigger",
                visualResponses: {
                    xr_standard_trigger_pressed: {
                        componentProperty: "button",
                        states: [
                            "default",
                            "touched",
                            "pressed"
                        ],
                        valueNodeProperty: "transform",
                        valueNodeName: "xr_standard_trigger_pressed_value",
                        minNodeName: "xr_standard_trigger_pressed_min",
                        maxNodeName: "xr_standard_trigger_pressed_max"
                    }
                }
            },
            "xr-standard-squeeze": {
                type: "squeeze",
                gamepadIndices: {
                    button: 1
                },
                rootNodeName: "xr_standard_squeeze",
                visualResponses: {
                    xr_standard_squeeze_pressed: {
                        componentProperty: "button",
                        states: [
                            "default",
                            "touched",
                            "pressed"
                        ],
                        valueNodeProperty: "transform",
                        valueNodeName: "xr_standard_squeeze_pressed_value",
                        minNodeName: "xr_standard_squeeze_pressed_min",
                        maxNodeName: "xr_standard_squeeze_pressed_max"
                    }
                }
            },
            "xr-standard-touchpad": {
                type: "touchpad",
                gamepadIndices: {
                    button: 2,
                    xAxis: 0,
                    yAxis: 1
                },
                rootNodeName: "xr_standard_touchpad",
                visualResponses: {
                    xr_standard_touchpad_pressed: {
                        componentProperty: "button",
                        states: [
                            "default",
                            "touched",
                            "pressed"
                        ],
                        valueNodeProperty: "transform",
                        valueNodeName: "xr_standard_touchpad_pressed_value",
                        minNodeName: "xr_standard_touchpad_pressed_min",
                        maxNodeName: "xr_standard_touchpad_pressed_max"
                    },
                    xr_standard_touchpad_xaxis_pressed: {
                        componentProperty: "xAxis",
                        states: [
                            "default",
                            "touched",
                            "pressed"
                        ],
                        valueNodeProperty: "transform",
                        valueNodeName: "xr_standard_touchpad_xaxis_pressed_value",
                        minNodeName: "xr_standard_touchpad_xaxis_pressed_min",
                        maxNodeName: "xr_standard_touchpad_xaxis_pressed_max"
                    },
                    xr_standard_touchpad_yaxis_pressed: {
                        componentProperty: "yAxis",
                        states: [
                            "default",
                            "touched",
                            "pressed"
                        ],
                        valueNodeProperty: "transform",
                        valueNodeName: "xr_standard_touchpad_yaxis_pressed_value",
                        minNodeName: "xr_standard_touchpad_yaxis_pressed_min",
                        maxNodeName: "xr_standard_touchpad_yaxis_pressed_max"
                    },
                    xr_standard_touchpad_xaxis_touched: {
                        componentProperty: "xAxis",
                        states: [
                            "default",
                            "touched",
                            "pressed"
                        ],
                        valueNodeProperty: "transform",
                        valueNodeName: "xr_standard_touchpad_xaxis_touched_value",
                        minNodeName: "xr_standard_touchpad_xaxis_touched_min",
                        maxNodeName: "xr_standard_touchpad_xaxis_touched_max"
                    },
                    xr_standard_touchpad_yaxis_touched: {
                        componentProperty: "yAxis",
                        states: [
                            "default",
                            "touched",
                            "pressed"
                        ],
                        valueNodeProperty: "transform",
                        valueNodeName: "xr_standard_touchpad_yaxis_touched_value",
                        minNodeName: "xr_standard_touchpad_yaxis_touched_min",
                        maxNodeName: "xr_standard_touchpad_yaxis_touched_max"
                    },
                    xr_standard_touchpad_axes_touched: {
                        componentProperty: "state",
                        states: [
                            "touched",
                            "pressed"
                        ],
                        valueNodeProperty: "visibility",
                        valueNodeName: "xr_standard_touchpad_axes_touched_value"
                    }
                },
                touchPointNodeName: "xr_standard_touchpad_axes_touched_value"
            },
            "xr-standard-thumbstick": {
                type: "thumbstick",
                gamepadIndices: {
                    button: 3,
                    xAxis: 2,
                    yAxis: 3
                },
                rootNodeName: "xr_standard_thumbstick",
                visualResponses: {
                    xr_standard_thumbstick_pressed: {
                        componentProperty: "button",
                        states: [
                            "default",
                            "touched",
                            "pressed"
                        ],
                        valueNodeProperty: "transform",
                        valueNodeName: "xr_standard_thumbstick_pressed_value",
                        minNodeName: "xr_standard_thumbstick_pressed_min",
                        maxNodeName: "xr_standard_thumbstick_pressed_max"
                    },
                    xr_standard_thumbstick_xaxis_pressed: {
                        componentProperty: "xAxis",
                        states: [
                            "default",
                            "touched",
                            "pressed"
                        ],
                        valueNodeProperty: "transform",
                        valueNodeName: "xr_standard_thumbstick_xaxis_pressed_value",
                        minNodeName: "xr_standard_thumbstick_xaxis_pressed_min",
                        maxNodeName: "xr_standard_thumbstick_xaxis_pressed_max"
                    },
                    xr_standard_thumbstick_yaxis_pressed: {
                        componentProperty: "yAxis",
                        states: [
                            "default",
                            "touched",
                            "pressed"
                        ],
                        valueNodeProperty: "transform",
                        valueNodeName: "xr_standard_thumbstick_yaxis_pressed_value",
                        minNodeName: "xr_standard_thumbstick_yaxis_pressed_min",
                        maxNodeName: "xr_standard_thumbstick_yaxis_pressed_max"
                    }
                }
            }
        },
        gamepadMapping: "xr-standard",
        rootNodeName: "microsoft-mixed-reality-right",
        assetPath: "right.glb"
    }
};

});

parcelRegister("eQUcM", function(module, exports) {

$parcel$export(module.exports, "WebXROculusTouchMotionController", () => $ad018531d9ff012d$export$846f72246af8bbf2);

var $d2047 = parcelRequire("d2047");

var $ebuqW = parcelRequire("ebuqW");

var $fbuqw = parcelRequire("fbuqw");

var $ha1VO = parcelRequire("ha1VO");
class $ad018531d9ff012d$export$846f72246af8bbf2 extends (0, $d2047.WebXRAbstractMotionController) {
    constructor(scene, gamepadObject, handedness, _legacyMapping = false, _forceLegacyControllers = false){
        super(scene, $ad018531d9ff012d$var$OculusTouchLayouts[handedness], gamepadObject, handedness);
        this._forceLegacyControllers = _forceLegacyControllers;
        this.profileId = "oculus-touch";
    }
    _getFilenameAndPath() {
        let filename = "";
        if (this.handedness === "left") filename = $ad018531d9ff012d$export$846f72246af8bbf2.MODEL_LEFT_FILENAME;
        else // Right is the default if no hand is specified
        filename = $ad018531d9ff012d$export$846f72246af8bbf2.MODEL_RIGHT_FILENAME;
        const path = this._isQuest() ? $ad018531d9ff012d$export$846f72246af8bbf2.QUEST_MODEL_BASE_URL : $ad018531d9ff012d$export$846f72246af8bbf2.MODEL_BASE_URL;
        return {
            filename: filename,
            path: path
        };
    }
    _getModelLoadingConstraints() {
        return true;
    }
    _processLoadedModel(_meshes) {
        const isQuest = this._isQuest();
        const triggerDirection = this.handedness === "right" ? -1 : 1;
        this.getComponentIds().forEach((id)=>{
            const comp = id && this.getComponent(id);
            if (comp) comp.onButtonStateChangedObservable.add((component)=>{
                if (!this.rootMesh || this.disableAnimation) return;
                switch(id){
                    case "xr-standard-trigger":
                        if (!isQuest) {
                            this._modelRootNode.getChildren()[3].rotation.x = -component.value * 0.2;
                            this._modelRootNode.getChildren()[3].position.y = -component.value * 0.005;
                            this._modelRootNode.getChildren()[3].position.z = -component.value * 0.005;
                        }
                        return;
                    case "xr-standard-squeeze":
                        if (!isQuest) this._modelRootNode.getChildren()[4].position.x = triggerDirection * component.value * 0.0035;
                        return;
                    case "xr-standard-thumbstick":
                        return;
                    case "a-button":
                    case "x-button":
                        if (!isQuest) {
                            if (component.pressed) this._modelRootNode.getChildren()[1].position.y = -0.001;
                            else this._modelRootNode.getChildren()[1].position.y = 0;
                        }
                        return;
                    case "b-button":
                    case "y-button":
                        if (!isQuest) {
                            if (component.pressed) this._modelRootNode.getChildren()[2].position.y = -0.001;
                            else this._modelRootNode.getChildren()[2].position.y = 0;
                        }
                        return;
                }
            }, undefined, true);
        });
    }
    _setRootMesh(meshes) {
        this.rootMesh = new (0, $fbuqw.Mesh)(this.profileId + " " + this.handedness, this.scene);
        if (!this.scene.useRightHandedSystem) this.rootMesh.rotationQuaternion = (0, $ha1VO.Quaternion).FromEulerAngles(0, Math.PI, 0);
        meshes.forEach((mesh)=>{
            mesh.isPickable = false;
        });
        if (this._isQuest()) this._modelRootNode = meshes[0];
        else {
            this._modelRootNode = meshes[1];
            this.rootMesh.position.y = 0.034;
            this.rootMesh.position.z = 0.052;
        }
        this._modelRootNode.parent = this.rootMesh;
    }
    _updateModel() {
    // no-op. model is updated using observables.
    }
    /**
     * Is this the new type of oculus touch. At the moment both have the same profile and it is impossible to differentiate
     * between the touch and touch 2.
     * @returns true if this is the new type of oculus touch controllers.
     */ _isQuest() {
        // this is SADLY the only way to currently check. Until proper profiles will be available.
        return !!navigator.userAgent.match(/Quest/gi) && !this._forceLegacyControllers;
    }
}
/**
 * The base url used to load the left and right controller models
 */ $ad018531d9ff012d$export$846f72246af8bbf2.MODEL_BASE_URL = "https://controllers.babylonjs.com/oculus/";
/**
 * The name of the left controller model file
 */ $ad018531d9ff012d$export$846f72246af8bbf2.MODEL_LEFT_FILENAME = "left.babylon";
/**
 * The name of the right controller model file
 */ $ad018531d9ff012d$export$846f72246af8bbf2.MODEL_RIGHT_FILENAME = "right.babylon";
/**
 * Base Url for the Quest controller model.
 */ $ad018531d9ff012d$export$846f72246af8bbf2.QUEST_MODEL_BASE_URL = "https://controllers.babylonjs.com/oculusQuest/";
// register the profile
(0, $ebuqW.WebXRMotionControllerManager).RegisterController("oculus-touch", (xrInput, scene)=>{
    return new $ad018531d9ff012d$export$846f72246af8bbf2(scene, xrInput.gamepad, xrInput.handedness);
});
(0, $ebuqW.WebXRMotionControllerManager).RegisterController("oculus-touch-legacy", (xrInput, scene)=>{
    return new $ad018531d9ff012d$export$846f72246af8bbf2(scene, xrInput.gamepad, xrInput.handedness, true);
});
const $ad018531d9ff012d$var$OculusTouchLayouts = {
    left: {
        selectComponentId: "xr-standard-trigger",
        components: {
            "xr-standard-trigger": {
                type: "trigger",
                gamepadIndices: {
                    button: 0
                },
                rootNodeName: "xr_standard_trigger",
                visualResponses: {}
            },
            "xr-standard-squeeze": {
                type: "squeeze",
                gamepadIndices: {
                    button: 1
                },
                rootNodeName: "xr_standard_squeeze",
                visualResponses: {}
            },
            "xr-standard-thumbstick": {
                type: "thumbstick",
                gamepadIndices: {
                    button: 3,
                    xAxis: 2,
                    yAxis: 3
                },
                rootNodeName: "xr_standard_thumbstick",
                visualResponses: {}
            },
            "x-button": {
                type: "button",
                gamepadIndices: {
                    button: 4
                },
                rootNodeName: "x_button",
                visualResponses: {}
            },
            "y-button": {
                type: "button",
                gamepadIndices: {
                    button: 5
                },
                rootNodeName: "y_button",
                visualResponses: {}
            },
            thumbrest: {
                type: "button",
                gamepadIndices: {
                    button: 6
                },
                rootNodeName: "thumbrest",
                visualResponses: {}
            }
        },
        gamepadMapping: "xr-standard",
        rootNodeName: "oculus-touch-v2-left",
        assetPath: "left.glb"
    },
    right: {
        selectComponentId: "xr-standard-trigger",
        components: {
            "xr-standard-trigger": {
                type: "trigger",
                gamepadIndices: {
                    button: 0
                },
                rootNodeName: "xr_standard_trigger",
                visualResponses: {}
            },
            "xr-standard-squeeze": {
                type: "squeeze",
                gamepadIndices: {
                    button: 1
                },
                rootNodeName: "xr_standard_squeeze",
                visualResponses: {}
            },
            "xr-standard-thumbstick": {
                type: "thumbstick",
                gamepadIndices: {
                    button: 3,
                    xAxis: 2,
                    yAxis: 3
                },
                rootNodeName: "xr_standard_thumbstick",
                visualResponses: {}
            },
            "a-button": {
                type: "button",
                gamepadIndices: {
                    button: 4
                },
                rootNodeName: "a_button",
                visualResponses: {}
            },
            "b-button": {
                type: "button",
                gamepadIndices: {
                    button: 5
                },
                rootNodeName: "b_button",
                visualResponses: {}
            },
            thumbrest: {
                type: "button",
                gamepadIndices: {
                    button: 6
                },
                rootNodeName: "thumbrest",
                visualResponses: {}
            }
        },
        gamepadMapping: "xr-standard",
        rootNodeName: "oculus-touch-v2-right",
        assetPath: "right.glb"
    }
};

});

parcelRegister("49OyQ", function(module, exports) {

$parcel$export(module.exports, "WebXRHTCViveMotionController", () => $306f39075594ff8d$export$87fcb315ab122924);

var $d2047 = parcelRequire("d2047");

var $fbuqw = parcelRequire("fbuqw");

var $ha1VO = parcelRequire("ha1VO");

var $ebuqW = parcelRequire("ebuqW");
class $306f39075594ff8d$export$87fcb315ab122924 extends (0, $d2047.WebXRAbstractMotionController) {
    /**
     * Create a new Vive motion controller object
     * @param scene the scene to use to create this controller
     * @param gamepadObject the corresponding gamepad object
     * @param handedness the handedness of the controller
     */ constructor(scene, gamepadObject, handedness){
        super(scene, $306f39075594ff8d$var$HTCViveLayout[handedness], gamepadObject, handedness);
        this.profileId = "htc-vive";
    }
    _getFilenameAndPath() {
        const filename = $306f39075594ff8d$export$87fcb315ab122924.MODEL_FILENAME;
        const path = $306f39075594ff8d$export$87fcb315ab122924.MODEL_BASE_URL;
        return {
            filename: filename,
            path: path
        };
    }
    _getModelLoadingConstraints() {
        return true;
    }
    _processLoadedModel(_meshes) {
        this.getComponentIds().forEach((id)=>{
            const comp = id && this.getComponent(id);
            if (comp) comp.onButtonStateChangedObservable.add((component)=>{
                if (!this.rootMesh || this.disableAnimation) return;
                switch(id){
                    case "xr-standard-trigger":
                        this._modelRootNode.getChildren()[6].rotation.x = -component.value * 0.15;
                        return;
                    case "xr-standard-touchpad":
                        return;
                    case "xr-standard-squeeze":
                        return;
                }
            }, undefined, true);
        });
    }
    _setRootMesh(meshes) {
        this.rootMesh = new (0, $fbuqw.Mesh)(this.profileId + " " + this.handedness, this.scene);
        meshes.forEach((mesh)=>{
            mesh.isPickable = false;
        });
        this._modelRootNode = meshes[1];
        this._modelRootNode.parent = this.rootMesh;
        if (!this.scene.useRightHandedSystem) this.rootMesh.rotationQuaternion = (0, $ha1VO.Quaternion).FromEulerAngles(0, Math.PI, 0);
    }
    _updateModel() {
    // no-op. model is updated using observables.
    }
}
/**
 * The base url used to load the left and right controller models
 */ $306f39075594ff8d$export$87fcb315ab122924.MODEL_BASE_URL = "https://controllers.babylonjs.com/vive/";
/**
 * File name for the controller model.
 */ $306f39075594ff8d$export$87fcb315ab122924.MODEL_FILENAME = "wand.babylon";
// register the profile
(0, $ebuqW.WebXRMotionControllerManager).RegisterController("htc-vive", (xrInput, scene)=>{
    return new $306f39075594ff8d$export$87fcb315ab122924(scene, xrInput.gamepad, xrInput.handedness);
});
// WebXRMotionControllerManager.RegisterController("htc-vive-legacy", (xrInput: XRInputSource, scene: Scene) => {
//     return new WebXRHTCViveMotionController(scene, <any>(xrInput.gamepad), xrInput.handedness, true);
// });
const $306f39075594ff8d$var$HTCViveLayout = {
    left: {
        selectComponentId: "xr-standard-trigger",
        components: {
            "xr-standard-trigger": {
                type: "trigger",
                gamepadIndices: {
                    button: 0
                },
                rootNodeName: "xr_standard_trigger",
                visualResponses: {}
            },
            "xr-standard-squeeze": {
                type: "squeeze",
                gamepadIndices: {
                    button: 1
                },
                rootNodeName: "xr_standard_squeeze",
                visualResponses: {}
            },
            "xr-standard-touchpad": {
                type: "touchpad",
                gamepadIndices: {
                    button: 2,
                    xAxis: 0,
                    yAxis: 1
                },
                rootNodeName: "xr_standard_touchpad",
                visualResponses: {}
            },
            menu: {
                type: "button",
                gamepadIndices: {
                    button: 4
                },
                rootNodeName: "menu",
                visualResponses: {}
            }
        },
        gamepadMapping: "xr-standard",
        rootNodeName: "htc_vive_none",
        assetPath: "none.glb"
    },
    right: {
        selectComponentId: "xr-standard-trigger",
        components: {
            "xr-standard-trigger": {
                type: "trigger",
                gamepadIndices: {
                    button: 0
                },
                rootNodeName: "xr_standard_trigger",
                visualResponses: {}
            },
            "xr-standard-squeeze": {
                type: "squeeze",
                gamepadIndices: {
                    button: 1
                },
                rootNodeName: "xr_standard_squeeze",
                visualResponses: {}
            },
            "xr-standard-touchpad": {
                type: "touchpad",
                gamepadIndices: {
                    button: 2,
                    xAxis: 0,
                    yAxis: 1
                },
                rootNodeName: "xr_standard_touchpad",
                visualResponses: {}
            },
            menu: {
                type: "button",
                gamepadIndices: {
                    button: 4
                },
                rootNodeName: "menu",
                visualResponses: {}
            }
        },
        gamepadMapping: "xr-standard",
        rootNodeName: "htc_vive_none",
        assetPath: "none.glb"
    },
    none: {
        selectComponentId: "xr-standard-trigger",
        components: {
            "xr-standard-trigger": {
                type: "trigger",
                gamepadIndices: {
                    button: 0
                },
                rootNodeName: "xr_standard_trigger",
                visualResponses: {}
            },
            "xr-standard-squeeze": {
                type: "squeeze",
                gamepadIndices: {
                    button: 1
                },
                rootNodeName: "xr_standard_squeeze",
                visualResponses: {}
            },
            "xr-standard-touchpad": {
                type: "touchpad",
                gamepadIndices: {
                    button: 2,
                    xAxis: 0,
                    yAxis: 1
                },
                rootNodeName: "xr_standard_touchpad",
                visualResponses: {}
            },
            menu: {
                type: "button",
                gamepadIndices: {
                    button: 4
                },
                rootNodeName: "menu",
                visualResponses: {}
            }
        },
        gamepadMapping: "xr-standard",
        rootNodeName: "htc-vive-none",
        assetPath: "none.glb"
    }
};

});


parcelRegister("d0Q8H", function(module, exports) {

var $25QTM = parcelRequire("25QTM");

var $1lq6q = parcelRequire("1lq6q");
$parcel$exportWildcard(module.exports, $25QTM);
$parcel$exportWildcard(module.exports, $1lq6q);

});
parcelRegister("1lq6q", function(module, exports) {

$parcel$export(module.exports, "NativeXRFrame", () => $0fac0012c044e4bf$export$2634ad3ee74030f2);

var $3DmnG = parcelRequire("3DmnG");
class $0fac0012c044e4bf$export$2634ad3ee74030f2 {
    get session() {
        return this._nativeImpl.session;
    }
    constructor(_nativeImpl){
        this._nativeImpl = _nativeImpl;
        this._xrTransform = new XRRigidTransform();
        this._xrPose = {
            transform: this._xrTransform,
            emulatedPosition: false
        };
        // Enough space for position, orientation
        this._xrPoseVectorData = new Float32Array(8);
        this.fillPoses = this._nativeImpl.fillPoses.bind(this._nativeImpl);
        this.getViewerPose = this._nativeImpl.getViewerPose.bind(this._nativeImpl);
        this.getHitTestResults = this._nativeImpl.getHitTestResults.bind(this._nativeImpl);
        this.getHitTestResultsForTransientInput = ()=>{
            throw new Error("XRFrame.getHitTestResultsForTransientInput not supported on native.");
        };
        this.createAnchor = this._nativeImpl.createAnchor.bind(this._nativeImpl);
        this.getJointPose = this._nativeImpl.getJointPose.bind(this._nativeImpl);
        this.fillJointRadii = this._nativeImpl.fillJointRadii.bind(this._nativeImpl);
        this.getLightEstimate = ()=>{
            throw new Error("XRFrame.getLightEstimate not supported on native.");
        };
        this.getImageTrackingResults = ()=>{
            return this._nativeImpl._imageTrackingResults ?? [];
        };
    }
    getPose(space, baseSpace) {
        if (!this._nativeImpl.getPoseData(space, baseSpace, this._xrPoseVectorData.buffer, this._xrTransform.matrix.buffer)) return undefined;
        const position = this._xrTransform.position;
        position.x = this._xrPoseVectorData[0];
        position.y = this._xrPoseVectorData[1];
        position.z = this._xrPoseVectorData[2];
        position.w = this._xrPoseVectorData[3];
        const orientation = this._xrTransform.orientation;
        orientation.x = this._xrPoseVectorData[4];
        orientation.y = this._xrPoseVectorData[5];
        orientation.z = this._xrPoseVectorData[6];
        orientation.w = this._xrPoseVectorData[7];
        return this._xrPose;
    }
    get trackedAnchors() {
        return this._nativeImpl.trackedAnchors;
    }
    get worldInformation() {
        return this._nativeImpl.worldInformation;
    }
    get detectedPlanes() {
        return this._nativeImpl.detectedPlanes;
    }
    get featurePointCloud() {
        return this._nativeImpl.featurePointCloud;
    }
    getDepthInformation(view) {
        throw new Error("This function is not available in Babylon Native");
    // return this._nativeImpl.getDepthInformation(view);
    }
}
(0, $3DmnG.RegisterNativeTypeAsync)("NativeXRFrame", $0fac0012c044e4bf$export$2634ad3ee74030f2);

});



parcelRegister("bk2fd", function(module, exports) {

});

parcelRegister("01PXR", function(module, exports) {

var $fGXjI = parcelRequire("fGXjI");
$parcel$exportWildcard(module.exports, $fGXjI);

});

parcelRegister("7Va7p", function(module, exports) {

var $2xJ2D = parcelRequire("2xJ2D");

var $20p5a = parcelRequire("20p5a");

var $iNxm3 = parcelRequire("iNxm3");

var $jjLAB = parcelRequire("jjLAB");

var $6wT1N = parcelRequire("6wT1N");

var $icNzP = parcelRequire("icNzP");

var $jwFO1 = parcelRequire("jwFO1");

var $ej2oR = parcelRequire("ej2oR");

var $3Uc5U = parcelRequire("3Uc5U");

var $3c9Th = parcelRequire("3c9Th");

var $eOc0Z = parcelRequire("eOc0Z");

var $cALIw = parcelRequire("cALIw");

var $f8Wlz = parcelRequire("f8Wlz");
$parcel$exportWildcard(module.exports, $2xJ2D);
$parcel$exportWildcard(module.exports, $20p5a);
$parcel$exportWildcard(module.exports, $iNxm3);
$parcel$exportWildcard(module.exports, $jjLAB);
$parcel$exportWildcard(module.exports, $6wT1N);
$parcel$exportWildcard(module.exports, $icNzP);
$parcel$exportWildcard(module.exports, $jwFO1);
$parcel$exportWildcard(module.exports, $ej2oR);
$parcel$exportWildcard(module.exports, $3Uc5U);
$parcel$exportWildcard(module.exports, $3c9Th);
$parcel$exportWildcard(module.exports, $eOc0Z);
$parcel$exportWildcard(module.exports, $cALIw);
$parcel$exportWildcard(module.exports, $f8Wlz);

});
parcelRegister("2xJ2D", function(module, exports) {

$parcel$export(module.exports, "FlowGraphState", () => $1da19a234bde1b4c$export$a709e1d1d2f838eb);
$parcel$export(module.exports, "FlowGraph", () => $1da19a234bde1b4c$export$240711385f1c1076);

var $6wT1N = parcelRequire("6wT1N");

var $jwFO1 = parcelRequire("jwFO1");

var $20p5a = parcelRequire("20p5a");

var $jjLAB = parcelRequire("jjLAB");

var $iqfT6 = parcelRequire("iqfT6");

var $6unUX = parcelRequire("6unUX");

var $b7h7Q = parcelRequire("b7h7Q");
var $1da19a234bde1b4c$export$a709e1d1d2f838eb;
(function(FlowGraphState) {
    /**
     * The graph is stopped
     */ FlowGraphState[FlowGraphState["Stopped"] = 0] = "Stopped";
    /**
     * The graph is running
     */ FlowGraphState[FlowGraphState["Started"] = 1] = "Started";
})($1da19a234bde1b4c$export$a709e1d1d2f838eb || ($1da19a234bde1b4c$export$a709e1d1d2f838eb = {}));
class $1da19a234bde1b4c$export$240711385f1c1076 {
    /**
     * Construct a Flow Graph
     * @param params construction parameters. currently only the scene
     */ constructor(params){
        /** @internal */ this._eventBlocks = [];
        this._executionContexts = [];
        /**
         * The state of the graph
         */ this.state = $1da19a234bde1b4c$export$a709e1d1d2f838eb.Stopped;
        this._scene = params.scene;
        this._coordinator = params.coordinator;
        this._sceneDisposeObserver = this._scene.onDisposeObservable.add(()=>this.dispose());
    }
    /**
     * Create a context. A context represents one self contained execution for the graph, with its own variables.
     * @returns the context, where you can get and set variables
     */ createContext() {
        const context = new (0, $jwFO1.FlowGraphContext)({
            scene: this._scene,
            coordinator: this._coordinator
        });
        this._executionContexts.push(context);
        return context;
    }
    /**
     * Returns the execution context at a given index
     * @param index the index of the context
     * @returns the execution context at that index
     */ getContext(index) {
        return this._executionContexts[index];
    }
    /**
     * Add an event block. When the graph is started, it will start listening to events
     * from the block and execute the graph when they are triggered.
     * @param block the event block to be added
     */ addEventBlock(block) {
        this._eventBlocks.push(block);
    }
    /**
     * Starts the flow graph. Initializes the event blocks and starts listening to events.
     */ start() {
        if (this.state === $1da19a234bde1b4c$export$a709e1d1d2f838eb.Started) return;
        this.state = $1da19a234bde1b4c$export$a709e1d1d2f838eb.Started;
        if (this._executionContexts.length === 0) this.createContext();
        for (const context of this._executionContexts){
            const contextualOrder = this._getContextualOrder();
            for (const block of contextualOrder)block._startPendingTasks(context);
        }
    }
    _getContextualOrder() {
        const order = [];
        for (const block1 of this._eventBlocks)// If the block is a mesh pick, guarantee that picks of children meshes come before picks of parent meshes
        if (block1.getClassName() === (0, $iqfT6.FlowGraphMeshPickEventBlock).ClassName) {
            const mesh1 = block1._getReferencedMesh();
            let i = 0;
            for(; i < order.length; i++){
                const block2 = order[i];
                const mesh2 = block2._getReferencedMesh();
                if (mesh1 && mesh2 && (0, $6unUX._isADescendantOf)(mesh1, mesh2)) break;
            }
            order.splice(i, 0, block1);
        } else order.push(block1);
        return order;
    }
    /**
     * Disposes of the flow graph. Cancels any pending tasks and removes all event listeners.
     */ dispose() {
        if (this.state === $1da19a234bde1b4c$export$a709e1d1d2f838eb.Stopped) return;
        this.state = $1da19a234bde1b4c$export$a709e1d1d2f838eb.Stopped;
        for (const context of this._executionContexts)context._clearPendingBlocks();
        this._executionContexts.length = 0;
        this._eventBlocks.length = 0;
        this._scene.onDisposeObservable.remove(this._sceneDisposeObserver);
        this._sceneDisposeObserver = null;
    }
    /**
     * Executes a function in all blocks of a flow graph, starting with the event blocks.
     * @param visitor the function to execute.
     */ visitAllBlocks(visitor) {
        const visitList = [];
        const idsAddedToVisitList = new Set();
        for (const block of this._eventBlocks){
            visitList.push(block);
            idsAddedToVisitList.add(block.uniqueId);
        }
        while(visitList.length > 0){
            const block = visitList.pop();
            visitor(block);
            for (const dataIn of block.dataInputs){
                for (const connection of dataIn._connectedPoint)if (!idsAddedToVisitList.has(connection._ownerBlock.uniqueId)) {
                    visitList.push(connection._ownerBlock);
                    idsAddedToVisitList.add(connection._ownerBlock.uniqueId);
                }
            }
            if (block instanceof (0, $jjLAB.FlowGraphExecutionBlock)) for (const signalOut of block.signalOutputs){
                for (const connection of signalOut._connectedPoint)if (!idsAddedToVisitList.has(connection._ownerBlock.uniqueId)) {
                    visitList.push(connection._ownerBlock);
                    idsAddedToVisitList.add(connection._ownerBlock.uniqueId);
                }
            }
        }
    }
    /**
     * Serializes a graph
     * @param serializationObject the object to write the values in
     * @param valueSerializeFunction a function to serialize complex values
     */ serialize(serializationObject = {}, valueSerializeFunction) {
        serializationObject.allBlocks = [];
        this.visitAllBlocks((block)=>{
            const serializedBlock = {};
            block.serialize(serializedBlock);
            serializationObject.allBlocks.push(serializedBlock);
        });
        serializationObject.executionContexts = [];
        for (const context of this._executionContexts){
            const serializedContext = {};
            context.serialize(serializedContext, valueSerializeFunction);
            serializationObject.executionContexts.push(serializedContext);
        }
    }
    /**
     * Given a list of blocks, find an output data connection that has a specific unique id
     * @param blocks a list of flow graph blocks
     * @param uniqueId the unique id of a connection
     * @returns the connection that has this unique id. throws an error if none was found
     */ static GetDataOutConnectionByUniqueId(blocks, uniqueId) {
        for (const block of blocks)for (const dataOut of block.dataOutputs){
            if (dataOut.uniqueId === uniqueId) return dataOut;
        }
        throw new Error("Could not find data out connection with unique id " + uniqueId);
    }
    /**
     * Given a list of blocks, find an input signal connection that has a specific unique id
     * @param blocks a list of flow graph blocks
     * @param uniqueId the unique id of a connection
     * @returns the connection that has this unique id. throws an error if none was found
     */ static GetSignalInConnectionByUniqueId(blocks, uniqueId) {
        for (const block of blocks){
            if (block instanceof (0, $jjLAB.FlowGraphExecutionBlock)) for (const signalIn of block.signalInputs){
                if (signalIn.uniqueId === uniqueId) return signalIn;
            }
        }
        throw new Error("Could not find signal in connection with unique id " + uniqueId);
    }
    /**
     * Parses a graph from a given serialization object
     * @param serializationObject the object where the values are written
     * @param options options for parsing the graph
     * @returns the parsed graph
     */ static Parse(serializationObject, options) {
        const graph = options.coordinator.createGraph();
        const blocks = [];
        const valueParseFunction = options.valueParseFunction ?? (0, $b7h7Q.defaultValueParseFunction);
        // Parse all blocks
        for (const serializedBlock of serializationObject.allBlocks){
            const block = (0, $20p5a.FlowGraphBlock).Parse(serializedBlock, {
                scene: options.coordinator.config.scene,
                pathConverter: options.pathConverter,
                valueParseFunction: valueParseFunction
            });
            blocks.push(block);
            if (block instanceof (0, $6wT1N.FlowGraphEventBlock)) graph.addEventBlock(block);
        }
        // After parsing all blocks, connect them
        for (const block of blocks){
            for (const dataIn of block.dataInputs)for (const serializedConnection of dataIn.connectedPointIds){
                const connection = $1da19a234bde1b4c$export$240711385f1c1076.GetDataOutConnectionByUniqueId(blocks, serializedConnection);
                dataIn.connectTo(connection);
            }
            if (block instanceof (0, $jjLAB.FlowGraphExecutionBlock)) {
                for (const signalOut of block.signalOutputs)for (const serializedConnection of signalOut.connectedPointIds){
                    const connection = $1da19a234bde1b4c$export$240711385f1c1076.GetSignalInConnectionByUniqueId(blocks, serializedConnection);
                    signalOut.connectTo(connection);
                }
            }
        }
        for (const serializedContext of serializationObject.executionContexts)(0, $jwFO1.FlowGraphContext).Parse(serializedContext, {
            graph: graph,
            valueParseFunction: valueParseFunction
        });
        return graph;
    }
}

});
parcelRegister("6wT1N", function(module, exports) {

$parcel$export(module.exports, "FlowGraphEventBlock", () => $4c106aa6fbe0780e$export$19ad80f200ceac76);

var $kUWd9 = parcelRequire("kUWd9");
class $4c106aa6fbe0780e$export$19ad80f200ceac76 extends (0, $kUWd9.FlowGraphAsyncExecutionBlock) {
    /**
     * @internal
     */ _execute(context) {
        context._notifyExecuteNode(this);
        this.out._activateSignal(context);
    }
}

});
parcelRegister("kUWd9", function(module, exports) {

$parcel$export(module.exports, "FlowGraphAsyncExecutionBlock", () => $f3a6311fdc2aa3e4$export$76e33e90488b1557);

var $jjLAB = parcelRequire("jjLAB");
class $f3a6311fdc2aa3e4$export$76e33e90488b1557 extends (0, $jjLAB.FlowGraphExecutionBlock) {
    constructor(config){
        super(config);
        this.out = this._registerSignalOutput("out");
        this.done = this._registerSignalOutput("done");
    }
    /**
     * @internal
     * @param context
     */ _startPendingTasks(context) {
        this._preparePendingTasks(context);
        context._addPendingBlock(this);
    }
}

});
parcelRegister("jjLAB", function(module, exports) {

$parcel$export(module.exports, "FlowGraphExecutionBlock", () => $e104b4ec19f08069$export$7b2334d2655fe56);

var $20p5a = parcelRequire("20p5a");

var $eOc0Z = parcelRequire("eOc0Z");

var $iNxm3 = parcelRequire("iNxm3");
class $e104b4ec19f08069$export$7b2334d2655fe56 extends (0, $20p5a.FlowGraphBlock) {
    constructor(config){
        super(config);
        this.signalInputs = [];
        this.signalOutputs = [];
        this.in = this._registerSignalInput("in");
    }
    _registerSignalInput(name) {
        const input = new (0, $iNxm3.FlowGraphSignalConnection)(name, (0, $eOc0Z.FlowGraphConnectionType).Input, this);
        this.signalInputs.push(input);
        return input;
    }
    _registerSignalOutput(name) {
        const output = new (0, $iNxm3.FlowGraphSignalConnection)(name, (0, $eOc0Z.FlowGraphConnectionType).Output, this);
        this.signalOutputs.push(output);
        return output;
    }
    /**
     * Given a name of a signal input, return that input if it exists
     * @param name the name of the input
     * @returns if the input exists, the input. Otherwise, undefined.
     */ getSignalInput(name) {
        return this.signalInputs.find((input)=>input.name === name);
    }
    /**
     * Given a name of a signal output, return that input if it exists
     * @param name the name of the input
     * @returns if the input exists, the input. Otherwise, undefined.
     */ getSignalOutput(name) {
        return this.signalOutputs.find((output)=>output.name === name);
    }
    /**
     * Serializes this block
     * @param serializationObject the object to serialize in
     */ serialize(serializationObject = {}) {
        super.serialize(serializationObject);
        serializationObject.signalInputs = [];
        serializationObject.signalOutputs = [];
        for (const input of this.signalInputs){
            const serializedInput = {};
            input.serialize(serializedInput);
            serializationObject.signalInputs.push(serializedInput);
        }
        for (const output of this.signalOutputs){
            const serializedOutput = {};
            output.serialize(serializedOutput);
            serializationObject.signalOutputs.push(serializedOutput);
        }
    }
    /**
     * Deserializes from an object
     * @param serializationObject the object to deserialize from
     */ deserialize(serializationObject) {
        for(let i = 0; i < serializationObject.signalInputs.length; i++){
            const signalInput = this.getSignalInput(serializationObject.signalInputs[i].name);
            if (signalInput) signalInput.deserialize(serializationObject.signalInputs[i]);
            else throw new Error("Could not find signal input with name " + serializationObject.signalInputs[i].name + " in block " + serializationObject.className);
        }
        for(let i = 0; i < serializationObject.signalOutputs.length; i++){
            const signalOutput = this.getSignalOutput(serializationObject.signalOutputs[i].name);
            if (signalOutput) signalOutput.deserialize(serializationObject.signalOutputs[i]);
            else throw new Error("Could not find signal output with name " + serializationObject.signalOutputs[i].name + " in block " + serializationObject.className);
        }
    }
    /**
     * @returns the class name
     */ getClassName() {
        return "FGExecutionBlock";
    }
}

});
parcelRegister("20p5a", function(module, exports) {

$parcel$export(module.exports, "FlowGraphBlock", () => $175f09ae5253ee8b$export$c656057f07d5b75);

var $321Uk = parcelRequire("321Uk");

var $eOc0Z = parcelRequire("eOc0Z");

var $cALIw = parcelRequire("cALIw");

var $bOhSV = parcelRequire("bOhSV");

var $b7h7Q = parcelRequire("b7h7Q");
class $175f09ae5253ee8b$export$c656057f07d5b75 {
    /** Constructor is protected so only subclasses can be instantiated
     * @param config optional configuration for this block
     */ constructor(/**
     * the configuration of the block
     */ config){
        this.config = config;
        /**
         * A randomly generated GUID for each block.
         */ this.uniqueId = (0, $321Uk.RandomGUID)();
        this.name = this.config?.name ?? this.getClassName();
        this.dataInputs = [];
        this.dataOutputs = [];
    }
    /**
     * @internal
     */ _updateOutputs(_context) {
    // empty by default, overriden in data blocks
    }
    /**
     * Registers a data input on the block.
     * @param name the name of the input
     * @param richType the type of the input
     * @returns the created connection
     */ registerDataInput(name, richType) {
        const input = new (0, $cALIw.FlowGraphDataConnection)(name, (0, $eOc0Z.FlowGraphConnectionType).Input, this, richType);
        this.dataInputs.push(input);
        return input;
    }
    /**
     * Registers a data output on the block.
     * @param name the name of the input
     * @param richType the type of the input
     * @returns the created connection
     */ registerDataOutput(name, richType) {
        const output = new (0, $cALIw.FlowGraphDataConnection)(name, (0, $eOc0Z.FlowGraphConnectionType).Output, this, richType);
        this.dataOutputs.push(output);
        return output;
    }
    /**
     * Given the name of a data input, returns the connection if it exists
     * @param name the name of the input
     * @returns the connection if it exists, undefined otherwise
     */ getDataInput(name) {
        return this.dataInputs.find((i)=>i.name === name);
    }
    /**
     * Given the name of a data output, returns the connection if it exists
     * @param name the name of the output
     * @returns the connection if it exists, undefined otherwise
     */ getDataOutput(name) {
        return this.dataOutputs.find((i)=>i.name === name);
    }
    /**
     * Serializes this block
     * @param serializationObject the object to serialize to
     * @param _valueSerializeFunction a function that serializes a specific value
     */ serialize(serializationObject = {}, _valueSerializeFunction = (0, $b7h7Q.defaultValueSerializationFunction)) {
        serializationObject.uniqueId = this.uniqueId;
        serializationObject.config = {};
        if (this.config) serializationObject.config["name"] = this.config.name;
        serializationObject.dataInputs = [];
        serializationObject.dataOutputs = [];
        serializationObject.className = this.getClassName();
        for (const input of this.dataInputs){
            const serializedInput = {};
            input.serialize(serializedInput);
            serializationObject.dataInputs.push(serializedInput);
        }
        for (const output of this.dataOutputs){
            const serializedOutput = {};
            output.serialize(serializedOutput);
            serializationObject.dataOutputs.push(serializedOutput);
        }
    }
    /**
     * Gets the class name of this block
     * @returns the class name
     */ getClassName() {
        return "FGBlock";
    }
    /**
     * Parses a block from a serialization object
     * @param serializationObject the object to parse from
     * @param parseOptions options for parsing the block
     * @returns the parsed block
     */ static Parse(serializationObject, parseOptions) {
        const classType = (0, $bOhSV.Tools).Instantiate(serializationObject.className);
        const parsedConfig = {};
        const valueParseFunction = parseOptions.valueParseFunction ?? (0, $b7h7Q.defaultValueParseFunction);
        if (serializationObject.config) for(const key in serializationObject.config)parsedConfig[key] = valueParseFunction(key, serializationObject.config, parseOptions.scene);
        if ((0, $b7h7Q.needsPathConverter)(serializationObject.className)) parsedConfig.pathConverter = parseOptions.pathConverter;
        const obj = new classType(parsedConfig);
        obj.uniqueId = serializationObject.uniqueId;
        for(let i = 0; i < serializationObject.dataInputs.length; i++){
            const dataInput = obj.getDataInput(serializationObject.dataInputs[i].name);
            if (dataInput) dataInput.deserialize(serializationObject.dataInputs[i]);
            else throw new Error("Could not find data input with name " + serializationObject.dataInputs[i].name + " in block " + serializationObject.className);
        }
        for(let i = 0; i < serializationObject.dataOutputs.length; i++){
            const dataOutput = obj.getDataOutput(serializationObject.dataOutputs[i].name);
            if (dataOutput) dataOutput.deserialize(serializationObject.dataOutputs[i]);
            else throw new Error("Could not find data output with name " + serializationObject.dataOutputs[i].name + " in block " + serializationObject.className);
        }
        obj.metadata = serializationObject.metadata;
        obj.deserialize && obj.deserialize(serializationObject);
        return obj;
    }
}

});
parcelRegister("eOc0Z", function(module, exports) {

$parcel$export(module.exports, "FlowGraphConnectionType", () => $ac7f0e1a919221be$export$6b24243d5e2460c5);
$parcel$export(module.exports, "FlowGraphConnection", () => $ac7f0e1a919221be$export$e999fca5fd0ec3ce);

var $bOhSV = parcelRequire("bOhSV");

var $321Uk = parcelRequire("321Uk");
var $ac7f0e1a919221be$export$6b24243d5e2460c5;
(function(FlowGraphConnectionType) {
    FlowGraphConnectionType[FlowGraphConnectionType["Input"] = 0] = "Input";
    FlowGraphConnectionType[FlowGraphConnectionType["Output"] = 1] = "Output";
})($ac7f0e1a919221be$export$6b24243d5e2460c5 || ($ac7f0e1a919221be$export$6b24243d5e2460c5 = {}));
class $ac7f0e1a919221be$export$e999fca5fd0ec3ce {
    constructor(name, _connectionType, /* @internal */ _ownerBlock){
        this._ownerBlock = _ownerBlock;
        /** @internal */ this._connectedPoint = [];
        /**
         * A uniquely identifying string for the connection.
         */ this.uniqueId = (0, $321Uk.RandomGUID)();
        /**
         * Used for parsing connections.
         * @internal
         */ // disable warning as this is used for parsing
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this.connectedPointIds = [];
        this.name = name;
        this._connectionType = _connectionType;
    }
    /**
     * The type of the connection
     */ get connectionType() {
        return this._connectionType;
    }
    /**
     * @internal
     * Override this to indicate if a point can connect to more than one point.
     */ _isSingularConnection() {
        return true;
    }
    /**
     * Returns if a point is connected to any other point.
     * @returns boolean indicating if the point is connected.
     */ isConnected() {
        return this._connectedPoint.length > 0;
    }
    /**
     * Connects two connections together.
     * @param point the connection to connect to.
     */ connectTo(point) {
        if (this._connectionType === point._connectionType) throw new Error(`Cannot connect two points of type ${this.connectionType}`);
        if (this._isSingularConnection() && this._connectedPoint.length > 0 || point._isSingularConnection() && point._connectedPoint.length > 0) throw new Error("Max number of connections for point reached");
        this._connectedPoint.push(point);
        point._connectedPoint.push(this);
    }
    /**
     * Saves the connection to a JSON object.
     * @param serializationObject the object to serialize to.
     */ serialize(serializationObject = {}) {
        serializationObject.uniqueId = this.uniqueId;
        serializationObject.name = this.name;
        serializationObject._connectionType = this._connectionType;
        serializationObject.connectedPointIds = [];
        serializationObject.className = this.getClassName();
        for (const point of this._connectedPoint)serializationObject.connectedPointIds.push(point.uniqueId);
    }
    /**
     * @returns class name of the connection.
     */ getClassName() {
        return "FGConnection";
    }
    /**
     * Deserialize from a object into this
     * @param serializationObject the object to deserialize from.
     */ deserialize(serializationObject) {
        this.uniqueId = serializationObject.uniqueId;
        this.name = serializationObject.name;
        this._connectionType = serializationObject._connectionType;
        this.connectedPointIds = serializationObject.connectedPointIds;
    }
    /**
     * Parses a connection from an object
     * @param serializationObject the object to parse from.
     * @param ownerBlock the block that owns the connection.
     * @returns the parsed connection.
     */ static Parse(serializationObject = {}, ownerBlock) {
        const type = (0, $bOhSV.Tools).Instantiate(serializationObject.className);
        const connection = new type(serializationObject.name, serializationObject._connectionType, ownerBlock);
        connection.deserialize(serializationObject);
        return connection;
    }
}

});

parcelRegister("cALIw", function(module, exports) {

$parcel$export(module.exports, "FlowGraphDataConnection", () => $92addc71ae8756dc$export$78f47e3d794e9121);

var $8DoUR = parcelRequire("8DoUR");

var $eOc0Z = parcelRequire("eOc0Z");

var $icNzP = parcelRequire("icNzP");
class $92addc71ae8756dc$export$78f47e3d794e9121 extends (0, $eOc0Z.FlowGraphConnection) {
    /**
     * Create a new data connection point.
     * @param name
     * @param connectionType
     * @param ownerBlock
     * @param richType
     */ constructor(name, connectionType, ownerBlock, /**
     * the type of the data in this block
     */ richType){
        super(name, connectionType, ownerBlock);
        this.richType = richType;
    }
    /**
     * An output data block can connect to multiple input data blocks,
     * but an input data block can only connect to one output data block.
     * @returns true if the connection is singular
     */ _isSingularConnection() {
        return this.connectionType === (0, $eOc0Z.FlowGraphConnectionType).Input;
    }
    /**
     * Set the value of the connection in a specific context.
     * @param value the value to set
     * @param context the context to which the value is set
     */ setValue(value, context) {
        context._setConnectionValue(this, value);
    }
    /**
     * Connect this point to another point.
     * @param point the point to connect to.
     */ connectTo(point) {
        super.connectTo(point);
    }
    _getValueOrDefault(context) {
        if (context._hasConnectionValue(this)) return context._getConnectionValue(this);
        else return this.richType.defaultValue;
    }
    /**
     * Gets the value of the connection in a specific context.
     * @param context the context from which the value is retrieved
     * @returns the value of the connection
     */ getValue(context) {
        if (this.connectionType === (0, $eOc0Z.FlowGraphConnectionType).Output) {
            context._notifyExecuteNode(this._ownerBlock);
            this._ownerBlock._updateOutputs(context);
            return this._getValueOrDefault(context);
        }
        if (!this.isConnected()) return this._getValueOrDefault(context);
        else return this._connectedPoint[0].getValue(context);
    }
    /**
     * @returns class name of the object.
     */ getClassName() {
        return "FGDataConnection";
    }
    /**
     * Serializes this object.
     * @param serializationObject the object to serialize to
     */ serialize(serializationObject = {}) {
        super.serialize(serializationObject);
        serializationObject.richType = {};
        this.richType.serialize(serializationObject.richType);
    }
    /**
     * Parses a data connection from a serialized object.
     * @param serializationObject the object to parse from
     * @param ownerBlock the block that owns the connection
     * @returns the parsed connection
     */ static Parse(serializationObject, ownerBlock) {
        const obj = (0, $eOc0Z.FlowGraphConnection).Parse(serializationObject, ownerBlock);
        obj.richType = (0, $icNzP.RichType).Parse(serializationObject.richType);
        return obj;
    }
}
(0, $8DoUR.RegisterClass)("FGDataConnection", $92addc71ae8756dc$export$78f47e3d794e9121);

});
parcelRegister("icNzP", function(module, exports) {

$parcel$export(module.exports, "RichType", () => $d40fcde8a9aa9641$export$4b72063254db0ed1);
$parcel$export(module.exports, "RichTypeAny", () => $d40fcde8a9aa9641$export$7d96c79d44dbb13c);
$parcel$export(module.exports, "RichTypeString", () => $d40fcde8a9aa9641$export$ed9f4132724426d1);
$parcel$export(module.exports, "RichTypeNumber", () => $d40fcde8a9aa9641$export$358f83d35c9f39fc);
$parcel$export(module.exports, "RichTypeBoolean", () => $d40fcde8a9aa9641$export$b6fcf0be19afccf7);
$parcel$export(module.exports, "RichTypeVector2", () => $d40fcde8a9aa9641$export$fedc283ea2858744);
$parcel$export(module.exports, "RichTypeVector3", () => $d40fcde8a9aa9641$export$b549a1ffecf61658);
$parcel$export(module.exports, "RichTypeVector4", () => $d40fcde8a9aa9641$export$a49be889a572412e);
$parcel$export(module.exports, "RichTypeMatrix", () => $d40fcde8a9aa9641$export$e27c5f4299d70891);
$parcel$export(module.exports, "RichTypeColor3", () => $d40fcde8a9aa9641$export$dd5a1946547bcc89);
$parcel$export(module.exports, "RichTypeColor4", () => $d40fcde8a9aa9641$export$41e6b6b736e64db6);
$parcel$export(module.exports, "RichTypeQuaternion", () => $d40fcde8a9aa9641$export$276b721868a5df67);
$parcel$export(module.exports, "RichTypeFlowGraphInteger", () => $d40fcde8a9aa9641$export$9d239afa610fc5b9);
$parcel$export(module.exports, "getRichTypeFromValue", () => $d40fcde8a9aa9641$export$459140a76a01bf7b);

var $ha1VO = parcelRequire("ha1VO");

var $7etnY = parcelRequire("7etnY");

var $daZRY = parcelRequire("daZRY");
class $d40fcde8a9aa9641$export$4b72063254db0ed1 {
    constructor(/**
     * The name given to the type.
     */ typeName, /**
     * The default value of the type.
     */ defaultValue){
        this.typeName = typeName;
        this.defaultValue = defaultValue;
    }
    /**
     * Serializes this rich type into a serialization object.
     * @param serializationObject the object to serialize to
     */ serialize(serializationObject) {
        serializationObject.typeName = this.typeName;
        serializationObject.defaultValue = this.defaultValue;
    }
    /**
     * Parses a rich type from a serialization object.
     * @param serializationObject a serialization object
     * @returns the parsed rich type
     */ static Parse(serializationObject) {
        return new $d40fcde8a9aa9641$export$4b72063254db0ed1(serializationObject.typeName, serializationObject.defaultValue);
    }
}
const $d40fcde8a9aa9641$export$7d96c79d44dbb13c = new $d40fcde8a9aa9641$export$4b72063254db0ed1("any", undefined);
const $d40fcde8a9aa9641$export$ed9f4132724426d1 = new $d40fcde8a9aa9641$export$4b72063254db0ed1("string", "");
const $d40fcde8a9aa9641$export$358f83d35c9f39fc = new $d40fcde8a9aa9641$export$4b72063254db0ed1("number", 0);
const $d40fcde8a9aa9641$export$b6fcf0be19afccf7 = new $d40fcde8a9aa9641$export$4b72063254db0ed1("boolean", false);
const $d40fcde8a9aa9641$export$fedc283ea2858744 = new $d40fcde8a9aa9641$export$4b72063254db0ed1("Vector2", (0, $ha1VO.Vector2).Zero());
const $d40fcde8a9aa9641$export$b549a1ffecf61658 = new $d40fcde8a9aa9641$export$4b72063254db0ed1("Vector3", (0, $ha1VO.Vector3).Zero());
const $d40fcde8a9aa9641$export$a49be889a572412e = new $d40fcde8a9aa9641$export$4b72063254db0ed1("Vector4", (0, $ha1VO.Vector4).Zero());
const $d40fcde8a9aa9641$export$e27c5f4299d70891 = new $d40fcde8a9aa9641$export$4b72063254db0ed1("Matrix", (0, $ha1VO.Matrix).Identity());
const $d40fcde8a9aa9641$export$dd5a1946547bcc89 = new $d40fcde8a9aa9641$export$4b72063254db0ed1("Color3", (0, $7etnY.Color3).Black());
const $d40fcde8a9aa9641$export$41e6b6b736e64db6 = new $d40fcde8a9aa9641$export$4b72063254db0ed1("Color4", new (0, $7etnY.Color4)(0, 0, 0, 0));
const $d40fcde8a9aa9641$export$276b721868a5df67 = new $d40fcde8a9aa9641$export$4b72063254db0ed1("Quaternion", (0, $ha1VO.Quaternion).Identity());
const $d40fcde8a9aa9641$export$9d239afa610fc5b9 = new $d40fcde8a9aa9641$export$4b72063254db0ed1("FlowGraphInteger", new (0, $daZRY.FlowGraphInteger)(0));
function $d40fcde8a9aa9641$export$459140a76a01bf7b(value) {
    switch(typeof value){
        case "string":
            return $d40fcde8a9aa9641$export$ed9f4132724426d1;
        case "number":
            return $d40fcde8a9aa9641$export$358f83d35c9f39fc;
        case "boolean":
            return $d40fcde8a9aa9641$export$b6fcf0be19afccf7;
        case "object":
            if (value instanceof (0, $ha1VO.Vector2)) return $d40fcde8a9aa9641$export$fedc283ea2858744;
            else if (value instanceof (0, $ha1VO.Vector3)) return $d40fcde8a9aa9641$export$b549a1ffecf61658;
            else if (value instanceof (0, $ha1VO.Vector4)) return $d40fcde8a9aa9641$export$a49be889a572412e;
            else if (value instanceof (0, $7etnY.Color3)) return $d40fcde8a9aa9641$export$dd5a1946547bcc89;
            else if (value instanceof (0, $7etnY.Color4)) return $d40fcde8a9aa9641$export$41e6b6b736e64db6;
            else if (value instanceof (0, $ha1VO.Quaternion)) return $d40fcde8a9aa9641$export$276b721868a5df67;
            else if (value instanceof (0, $daZRY.FlowGraphInteger)) return $d40fcde8a9aa9641$export$9d239afa610fc5b9;
            else return $d40fcde8a9aa9641$export$7d96c79d44dbb13c;
        default:
            return $d40fcde8a9aa9641$export$7d96c79d44dbb13c;
    }
}

});
parcelRegister("daZRY", function(module, exports) {

$parcel$export(module.exports, "FlowGraphInteger", () => $997c338c8009a424$export$94910ed7d566c415);

var $8DoUR = parcelRequire("8DoUR");
class $997c338c8009a424$export$94910ed7d566c415 {
    constructor(value){
        this.value = this._toInt(value);
    }
    /**
     * Converts a float to an integer.
     * @param n the float to convert
     * @returns the result of n | 0 - converting it to a int
     */ _toInt(n) {
        return n | 0;
    }
    /**
     * Adds two integers together.
     * @param other the other integer to add
     * @returns a FlowGraphInteger with the result of the addition
     */ add(other) {
        return new $997c338c8009a424$export$94910ed7d566c415(this.value + other.value);
    }
    /**
     * Subtracts two integers.
     * @param other the other integer to subtract
     * @returns a FlowGraphInteger with the result of the subtraction
     */ subtract(other) {
        return new $997c338c8009a424$export$94910ed7d566c415(this.value - other.value);
    }
    /**
     * Multiplies two integers.
     * @param other the other integer to multiply
     * @returns a FlowGraphInteger with the result of the multiplication
     */ multiply(other) {
        return new $997c338c8009a424$export$94910ed7d566c415(Math.imul(this.value, other.value));
    }
    /**
     * Divides two integers.
     * @param other the other integer to divide
     * @returns a FlowGraphInteger with the result of the division
     */ divide(other) {
        return new $997c338c8009a424$export$94910ed7d566c415(this.value / other.value);
    }
    /**
     * The class name of this type.
     * @returns
     */ getClassName() {
        return $997c338c8009a424$export$94910ed7d566c415.ClassName;
    }
    /**
     * Compares two integers for equality.
     * @param other the other integer to compare
     * @returns
     */ equals(other) {
        return this.value === other.value;
    }
    /**
     * Parses a FlowGraphInteger from a serialization object.
     * @param serializationObject
     * @returns
     */ static Parse(serializationObject) {
        return new $997c338c8009a424$export$94910ed7d566c415(serializationObject.value);
    }
}
$997c338c8009a424$export$94910ed7d566c415.ClassName = "FlowGraphInteger";
(0, $8DoUR.RegisterClass)("FlowGraphInteger", $997c338c8009a424$export$94910ed7d566c415);

});



parcelRegister("b7h7Q", function(module, exports) {

$parcel$export(module.exports, "defaultValueSerializationFunction", () => $817da1ea14417426$export$d05bfb30eeb9dacf);
$parcel$export(module.exports, "defaultValueParseFunction", () => $817da1ea14417426$export$35ae7a69f033d7d8);
$parcel$export(module.exports, "needsPathConverter", () => $817da1ea14417426$export$216101206aad821e);

var $7etnY = parcelRequire("7etnY");

var $ha1VO = parcelRequire("ha1VO");

var $daZRY = parcelRequire("daZRY");
function $817da1ea14417426$var$isMeshClassName(className) {
    return className === "Mesh" || className === "AbstractMesh" || className === "GroundMesh" || className === "InstanceMesh" || className === "LinesMesh" || className === "GoldbergMesh" || className === "GreasedLineMesh" || className === "TrailMesh";
}
function $817da1ea14417426$var$isVectorClassName(className) {
    return className === "Vector2" || className === "Vector3" || className === "Vector4" || className === "Quaternion" || className === "Color3" || className === "Color4";
}
function $817da1ea14417426$var$parseVector(className, value) {
    if (className === "Vector2") return (0, $ha1VO.Vector2).FromArray(value);
    else if (className === "Vector3") return (0, $ha1VO.Vector3).FromArray(value);
    else if (className === "Vector4") return (0, $ha1VO.Vector4).FromArray(value);
    else if (className === "Quaternion") return (0, $ha1VO.Quaternion).FromArray(value);
    else if (className === "Color3") return new (0, $7etnY.Color3)(value[0], value[1], value[2]);
    else if (className === "Color4") return new (0, $7etnY.Color4)(value[0], value[1], value[2], value[3]);
    else throw new Error(`Unknown vector class name ${className}`);
}
function $817da1ea14417426$export$d05bfb30eeb9dacf(key, value, serializationObject) {
    const className = value?.getClassName?.() ?? "";
    if ($817da1ea14417426$var$isMeshClassName(className)) serializationObject[key] = {
        name: value.name,
        className: className
    };
    else if ($817da1ea14417426$var$isVectorClassName(className)) serializationObject[key] = {
        value: value.asArray(),
        className: className
    };
    else serializationObject[key] = value;
}
function $817da1ea14417426$export$35ae7a69f033d7d8(key, serializationObject, scene) {
    const intermediateValue = serializationObject[key];
    let finalValue;
    const className = intermediateValue?.className;
    if ($817da1ea14417426$var$isMeshClassName(className)) finalValue = scene.getMeshByName(intermediateValue.name);
    else if ($817da1ea14417426$var$isVectorClassName(className)) finalValue = $817da1ea14417426$var$parseVector(className, intermediateValue.value);
    else if (className === "Matrix") finalValue = (0, $ha1VO.Matrix).FromArray(intermediateValue.value);
    else if (className === (0, $daZRY.FlowGraphInteger).ClassName) finalValue = (0, $daZRY.FlowGraphInteger).Parse(intermediateValue);
    else if (intermediateValue && intermediateValue.value !== undefined) finalValue = intermediateValue.value;
    else finalValue = intermediateValue;
    return finalValue;
}
function $817da1ea14417426$export$216101206aad821e(className) {
    // I am not using the ClassName property here because it was causing a circular dependency
    // that jest didn't like!
    return className === "FGSetPropertyBlock" || className === "FGGetPropertyBlock" || className === "FGPlayAnimationBlock" || className === "FGMeshPickEventBlock";
}

});


parcelRegister("iNxm3", function(module, exports) {

$parcel$export(module.exports, "FlowGraphSignalConnection", () => $daf6ad252b900634$export$c62ef3f129489407);

var $eOc0Z = parcelRequire("eOc0Z");

var $8DoUR = parcelRequire("8DoUR");
class $daf6ad252b900634$export$c62ef3f129489407 extends (0, $eOc0Z.FlowGraphConnection) {
    /**
     * @internal
     * A signal input can be connected to more than one signal output,
     * but a signal output can only connect to one signal input
     * @returns true if the connection is singular
     */ _isSingularConnection() {
        return this.connectionType === (0, $eOc0Z.FlowGraphConnectionType).Output;
    }
    /**
     * @internal
     */ _activateSignal(context) {
        if (this.connectionType === (0, $eOc0Z.FlowGraphConnectionType).Input) {
            context._notifyExecuteNode(this._ownerBlock);
            this._ownerBlock._execute(context, this);
            context._increaseExecutionId();
        } else this._connectedPoint[0]?._activateSignal(context);
    }
}
(0, $8DoUR.RegisterClass)("FlowGraphSignalConnection", $daf6ad252b900634$export$c62ef3f129489407);

});




parcelRegister("jwFO1", function(module, exports) {

$parcel$export(module.exports, "FlowGraphContext", () => $e3716f3cc6cbaff1$export$8c5c6ae56576338);

var $e0Suo = parcelRequire("e0Suo");

var $ir0rz = parcelRequire("ir0rz");

var $321Uk = parcelRequire("321Uk");

var $b7h7Q = parcelRequire("b7h7Q");

var $diGQf = parcelRequire("diGQf");
class $e3716f3cc6cbaff1$export$8c5c6ae56576338 {
    constructor(params){
        /**
         * A randomly generated GUID for each context.
         */ this.uniqueId = (0, $321Uk.RandomGUID)();
        /**
         * These are the variables defined by a user.
         */ this._userVariables = {};
        /**
         * These are the variables set by the blocks.
         */ this._executionVariables = {};
        /**
         * These are the values for the data connection points
         */ this._connectionValues = {};
        /**
         * These are blocks that have currently pending tasks/listeners that need to be cleaned up.
         */ this._pendingBlocks = [];
        /**
         * A monotonically increasing ID for each execution.
         * Incremented for every block executed.
         */ this._executionId = 0;
        /**
         * Observable that is triggered when a node is executed.
         */ this.onNodeExecutedObservable = new (0, $diGQf.Observable)();
        this._configuration = params;
    }
    /**
     * Check if a user-defined variable is defined.
     * @param name the name of the variable
     * @returns true if the variable is defined
     */ hasVariable(name) {
        return name in this._userVariables;
    }
    /**
     * Set a user-defined variable.
     * @param name the name of the variable
     * @param value the value of the variable
     */ setVariable(name, value) {
        this._userVariables[name] = value;
    }
    /**
     * Get a user-defined variable.
     * @param name the name of the variable
     * @returns the value of the variable
     */ getVariable(name) {
        return this._userVariables[name];
    }
    /**
     * Gets all user variables map
     */ get userVariables() {
        return this._userVariables;
    }
    _getUniqueIdPrefixedName(obj, name) {
        return `${obj.uniqueId}_${name}`;
    }
    /**
     * Set an internal execution variable
     * @internal
     * @param name
     * @param value
     */ _setExecutionVariable(block, name, value) {
        this._executionVariables[this._getUniqueIdPrefixedName(block, name)] = value;
    }
    /**
     * Get an internal execution variable
     * @internal
     * @param name
     * @returns
     */ _getExecutionVariable(block, name, defaultValue) {
        if (this._hasExecutionVariable(block, name)) return this._executionVariables[this._getUniqueIdPrefixedName(block, name)];
        else return defaultValue;
    }
    /**
     * Delete an internal execution variable
     * @internal
     * @param block
     * @param name
     */ _deleteExecutionVariable(block, name) {
        delete this._executionVariables[this._getUniqueIdPrefixedName(block, name)];
    }
    /**
     * Check if an internal execution variable is defined
     * @internal
     * @param block
     * @param name
     * @returns
     */ _hasExecutionVariable(block, name) {
        return this._getUniqueIdPrefixedName(block, name) in this._executionVariables;
    }
    /**
     * Check if a connection value is defined
     * @internal
     * @param connectionPoint
     * @returns
     */ _hasConnectionValue(connectionPoint) {
        return connectionPoint.uniqueId in this._connectionValues;
    }
    /**
     * Set a connection value
     * @internal
     * @param connectionPoint
     * @param value
     */ _setConnectionValue(connectionPoint, value) {
        this._connectionValues[connectionPoint.uniqueId] = value;
    }
    /**
     * Get a connection value
     * @internal
     * @param connectionPoint
     * @returns
     */ _getConnectionValue(connectionPoint) {
        return this._connectionValues[connectionPoint.uniqueId];
    }
    /**
     * Get the configuration
     * @internal
     * @param name
     * @param value
     */ get configuration() {
        return this._configuration;
    }
    /**
     * Add a block to the list of blocks that have pending tasks.
     * @internal
     * @param block
     */ _addPendingBlock(block) {
        this._pendingBlocks.push(block);
    }
    /**
     * Remove a block from the list of blocks that have pending tasks.
     * @internal
     * @param block
     */ _removePendingBlock(block) {
        const index = this._pendingBlocks.indexOf(block);
        if (index !== -1) this._pendingBlocks.splice(index, 1);
    }
    /**
     * Clear all pending blocks.
     * @internal
     */ _clearPendingBlocks() {
        for (const block of this._pendingBlocks)block._cancelPendingTasks(this);
        this._pendingBlocks.length = 0;
    }
    /**
     * @internal
     * Function that notifies the node executed observable
     * @param node
     */ _notifyExecuteNode(node) {
        this.onNodeExecutedObservable.notifyObservers(node);
    }
    /**
     * @internal
     */ _increaseExecutionId() {
        this._executionId++;
    }
    /**
     * A monotonically increasing ID for each execution.
     * Incremented for every block executed.
     */ get executionId() {
        return this._executionId;
    }
    /**
     * Serializes a context
     * @param serializationObject the object to write the values in
     * @param valueSerializationFunction a function to serialize complex values
     */ serialize(serializationObject = {}, valueSerializationFunction = (0, $b7h7Q.defaultValueSerializationFunction)) {
        serializationObject.uniqueId = this.uniqueId;
        serializationObject._userVariables = {};
        for(const key in this._userVariables)valueSerializationFunction(key, this._userVariables[key], serializationObject._userVariables);
        serializationObject._connectionValues = {};
        for(const key in this._connectionValues)valueSerializationFunction(key, this._connectionValues[key], serializationObject._connectionValues);
    }
    /**
     * @returns the class name of the object.
     */ getClassName() {
        return "FGContext";
    }
    /**
     * Parses a context
     * @param serializationObject the object containing the context serialization values
     * @param options the options for parsing the context
     * @returns
     */ static Parse(serializationObject, options) {
        const result = options.graph.createContext();
        const valueParseFunction = options.valueParseFunction ?? (0, $b7h7Q.defaultValueParseFunction);
        result.uniqueId = serializationObject.uniqueId;
        for(const key in serializationObject._userVariables){
            const value = valueParseFunction(key, serializationObject._userVariables, result._configuration.scene);
            result._userVariables[key] = value;
        }
        for(const key in serializationObject._connectionValues){
            const value = valueParseFunction(key, serializationObject._connectionValues, result._configuration.scene);
            result._connectionValues[key] = value;
        }
        return result;
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e3716f3cc6cbaff1$export$8c5c6ae56576338.prototype, "uniqueId", void 0);

});

parcelRegister("iqfT6", function(module, exports) {

$parcel$export(module.exports, "FlowGraphMeshPickEventBlock", () => $d696faad8185be9c$export$ddf8eda1572d15bb);

var $0cHNL = parcelRequire("0cHNL");

var $6wT1N = parcelRequire("6wT1N");

var $cfkw4 = parcelRequire("cfkw4");

var $8DoUR = parcelRequire("8DoUR");

var $6unUX = parcelRequire("6unUX");
class $d696faad8185be9c$export$ddf8eda1572d15bb extends (0, $6wT1N.FlowGraphEventBlock) {
    constructor(/**
     * the configuration of the block
     */ config){
        super(config);
        this.config = config;
    }
    _getReferencedMesh() {
        const iAccessor = this.config.pathConverter.convert(this.config.path);
        const mesh = iAccessor.info.getObject(iAccessor.object);
        if (!mesh || !(mesh instanceof (0, $0cHNL.AbstractMesh))) throw new Error("Mesh pick event block requires a valid mesh");
        return mesh;
    }
    /**
     * @internal
     */ _preparePendingTasks(context) {
        let pickObserver = context._getExecutionVariable(this, "meshPickObserver");
        if (!pickObserver) {
            const mesh = this._getReferencedMesh();
            context._setExecutionVariable(this, "mesh", mesh);
            pickObserver = mesh.getScene().onPointerObservable.add((pointerInfo)=>{
                if (pointerInfo.type === (0, $cfkw4.PointerEventTypes).POINTERPICK && pointerInfo.pickInfo?.pickedMesh && (pointerInfo.pickInfo?.pickedMesh === mesh || (0, $6unUX._isADescendantOf)(pointerInfo.pickInfo?.pickedMesh, mesh))) this._execute(context);
            });
            const disposeObserver = mesh.onDisposeObservable.add(()=>this._onDispose);
            context._setExecutionVariable(this, "meshPickObserver", pickObserver);
            context._setExecutionVariable(this, "meshDisposeObserver", disposeObserver);
        }
    }
    _onDispose(context) {
        this._cancelPendingTasks(context);
        context._removePendingBlock(this);
    }
    /**
     * @internal
     */ _cancelPendingTasks(context) {
        const mesh = context._getExecutionVariable(this, "mesh");
        const pickObserver = context._getExecutionVariable(this, "meshPickObserver");
        const disposeObserver = context._getExecutionVariable(this, "meshDisposeObserver");
        mesh.getScene().onPointerObservable.remove(pickObserver);
        mesh.onDisposeObservable.remove(disposeObserver);
        context._deleteExecutionVariable(this, "mesh");
        context._deleteExecutionVariable(this, "meshPickObserver");
        context._deleteExecutionVariable(this, "meshDisposeObserver");
    }
    /**
     * @returns class name of the block.
     */ getClassName() {
        return $d696faad8185be9c$export$ddf8eda1572d15bb.ClassName;
    }
    /**
     * Serializes the block to a JSON object.
     * @param serializationObject the object to serialize to.
     */ serialize(serializationObject) {
        super.serialize(serializationObject);
        serializationObject.config.path = this.config.path;
    }
}
/**
 * Class name of the block.
 */ $d696faad8185be9c$export$ddf8eda1572d15bb.ClassName = "FGMeshPickEventBlock";
(0, $8DoUR.RegisterClass)($d696faad8185be9c$export$ddf8eda1572d15bb.ClassName, $d696faad8185be9c$export$ddf8eda1572d15bb);

});
parcelRegister("6unUX", function(module, exports) {

$parcel$export(module.exports, "_isADescendantOf", () => $4b9818f1e2077946$export$5f10b7091e83af07);
/**
 * @internal
 * Returns if mesh1 is a descendant of mesh2
 * @param mesh1
 * @param mesh2
 * @returns
 */ function $4b9818f1e2077946$export$5f10b7091e83af07(mesh1, mesh2) {
    return !!(mesh1.parent && (mesh1.parent === mesh2 || $4b9818f1e2077946$export$5f10b7091e83af07(mesh1.parent, mesh2)));
}

});



parcelRegister("ej2oR", function(module, exports) {

$parcel$export(module.exports, "FlowGraphCoordinator", () => $a6a4b39e22653ed3$export$2d53b77ca1b2db9c);

var $diGQf = parcelRequire("diGQf");

var $2xJ2D = parcelRequire("2xJ2D");

var $b7h7Q = parcelRequire("b7h7Q");
class $a6a4b39e22653ed3$export$2d53b77ca1b2db9c {
    constructor(/**
     * the configuration of the block
     */ config){
        this.config = config;
        this._flowGraphs = [];
        this._customEventsMap = new Map();
        // When the scene is disposed, dispose all graphs currently running on it.
        this.config.scene.onDisposeObservable.add(()=>{
            this.dispose();
        });
        // Add itself to the SceneCoordinators list for the Inspector.
        const coordinators = $a6a4b39e22653ed3$export$2d53b77ca1b2db9c.SceneCoordinators.get(this.config.scene) ?? [];
        coordinators.push(this);
    }
    /**
     * Creates a new flow graph and adds it to the list of existing flow graphs
     * @returns a new flow graph
     */ createGraph() {
        const graph = new (0, $2xJ2D.FlowGraph)({
            scene: this.config.scene,
            coordinator: this
        });
        this._flowGraphs.push(graph);
        return graph;
    }
    /**
     * Removes a flow graph from the list of existing flow graphs and disposes it
     * @param graph the graph to remove
     */ removeGraph(graph) {
        const index = this._flowGraphs.indexOf(graph);
        if (index !== -1) {
            graph.dispose();
            this._flowGraphs.splice(index, 1);
        }
    }
    /**
     * Starts all graphs
     */ start() {
        this._flowGraphs.forEach((graph)=>graph.start());
    }
    /**
     * Disposes all graphs
     */ dispose() {
        this._flowGraphs.forEach((graph)=>graph.dispose());
        this._flowGraphs.length = 0;
        // Remove itself from the SceneCoordinators list for the Inspector.
        const coordinators = $a6a4b39e22653ed3$export$2d53b77ca1b2db9c.SceneCoordinators.get(this.config.scene) ?? [];
        const index = coordinators.indexOf(this);
        if (index !== -1) coordinators.splice(index, 1);
    }
    /**
     * Serializes this coordinator to a JSON object.
     * @param serializationObject the object to serialize to
     * @param valueSerializeFunction the function to use to serialize the value
     */ serialize(serializationObject, valueSerializeFunction) {
        serializationObject._flowGraphs = [];
        this._flowGraphs.forEach((graph)=>{
            const serializedGraph = {};
            graph.serialize(serializedGraph, valueSerializeFunction);
            serializationObject._flowGraphs.push(serializedGraph);
        });
    }
    /**
     * Parses a serialized coordinator.
     * @param serializedObject the object to parse
     * @param options the options to use when parsing
     * @returns the parsed coordinator
     */ static Parse(serializedObject, options) {
        const valueParseFunction = options.valueParseFunction ?? (0, $b7h7Q.defaultValueParseFunction);
        const coordinator = new $a6a4b39e22653ed3$export$2d53b77ca1b2db9c({
            scene: options.scene
        });
        serializedObject._flowGraphs?.forEach((serializedGraph)=>{
            (0, $2xJ2D.FlowGraph).Parse(serializedGraph, {
                coordinator: coordinator,
                valueParseFunction: valueParseFunction,
                pathConverter: options.pathConverter
            });
        });
        return coordinator;
    }
    /**
     * Gets the list of flow graphs
     */ get flowGraphs() {
        return this._flowGraphs;
    }
    /**
     * Get an observable that will be notified when the event with the given id is fired.
     * @param id the id of the event
     * @returns the observable for the event
     */ getCustomEventObservable(id) {
        let observable = this._customEventsMap.get(id);
        if (!observable) {
            observable = new (0, $diGQf.Observable)();
            this._customEventsMap.set(id, observable);
        }
        return observable;
    }
    /**
     * Notifies the observable for the given event id with the given data.
     * @param id the id of the event
     * @param data the data to send with the event
     */ notifyCustomEvent(id, data) {
        const observable = this._customEventsMap.get(id);
        if (observable) observable.notifyObservers(data);
    }
}
/**
 * @internal
 * A list of all the coordinators per scene. Will be used by the inspector
 */ $a6a4b39e22653ed3$export$2d53b77ca1b2db9c.SceneCoordinators = new Map();

});

parcelRegister("3Uc5U", function(module, exports) {

});

parcelRegister("3c9Th", function(module, exports) {

$parcel$export(module.exports, "FlowGraphContextLogger", () => $253a2a2de42ae3af$export$285d3c42e381015d);

var $bOhSV = parcelRequire("bOhSV");
class $253a2a2de42ae3af$export$285d3c42e381015d {
    constructor(_context){
        this._context = _context;
        this._context.onNodeExecutedObservable.add((node)=>{
            (0, $bOhSV.Tools).Log(`Node executed: ${node.getClassName()}`);
        });
    }
}

});

parcelRegister("f8Wlz", function(module, exports) {
/* eslint-disable import/no-internal-modules */ 
var $4t2dM = parcelRequire("4t2dM");

var $1MTyq = parcelRequire("1MTyq");

var $bMtN3 = parcelRequire("bMtN3");
$parcel$exportWildcard(module.exports, $4t2dM);
$parcel$exportWildcard(module.exports, $1MTyq);
$parcel$exportWildcard(module.exports, $bMtN3);

});
parcelRegister("4t2dM", function(module, exports) {

var $6cI69 = parcelRequire("6cI69");

var $cQYki = parcelRequire("cQYki");

var $b9t2d = parcelRequire("b9t2d");

var $hgspb = parcelRequire("hgspb");

var $1Cs9y = parcelRequire("1Cs9y");

var $kIK07 = parcelRequire("kIK07");
$parcel$exportWildcard(module.exports, $6cI69);
$parcel$exportWildcard(module.exports, $cQYki);
$parcel$exportWildcard(module.exports, $b9t2d);
$parcel$exportWildcard(module.exports, $hgspb);
$parcel$exportWildcard(module.exports, $1Cs9y);
$parcel$exportWildcard(module.exports, $kIK07);

});
parcelRegister("6cI69", function(module, exports) {

$parcel$export(module.exports, "FlowGraphConsoleLogBlock", () => $4846120b3ae9ad11$export$e4521df043840fbe);

var $dSLxa = parcelRequire("dSLxa");

var $icNzP = parcelRequire("icNzP");

var $8DoUR = parcelRequire("8DoUR");

var $kVtWi = parcelRequire("kVtWi");
class $4846120b3ae9ad11$export$e4521df043840fbe extends (0, $dSLxa.FlowGraphExecutionBlockWithOutSignal) {
    constructor(config){
        super(config);
        this.message = this.registerDataInput("message", (0, $icNzP.RichTypeAny));
    }
    /**
     * @internal
     */ _execute(context) {
        const messageValue = this.message.getValue(context);
        (0, $kVtWi.Logger).Log(messageValue);
        // activate the output flow block
        this.out._activateSignal(context);
    }
    /**
     * @returns class name of the block.
     */ getClassName() {
        return $4846120b3ae9ad11$export$e4521df043840fbe.ClassName;
    }
}
/**
 * the class name of the block.
 */ $4846120b3ae9ad11$export$e4521df043840fbe.ClassName = "FGConsoleLogBlock";
(0, $8DoUR.RegisterClass)($4846120b3ae9ad11$export$e4521df043840fbe.ClassName, $4846120b3ae9ad11$export$e4521df043840fbe);

});
parcelRegister("dSLxa", function(module, exports) {

$parcel$export(module.exports, "FlowGraphExecutionBlockWithOutSignal", () => $a1b530c85042dc8a$export$3e728bbd9393f53);

var $jjLAB = parcelRequire("jjLAB");
class $a1b530c85042dc8a$export$3e728bbd9393f53 extends (0, $jjLAB.FlowGraphExecutionBlock) {
    constructor(config){
        super(config);
        this.out = this._registerSignalOutput("out");
    }
}

});


parcelRegister("cQYki", function(module, exports) {

$parcel$export(module.exports, "FlowGraphSetVariableBlock", () => $95b922e62989783f$export$8cf810175097f633);

var $icNzP = parcelRequire("icNzP");

var $dSLxa = parcelRequire("dSLxa");

var $8DoUR = parcelRequire("8DoUR");
class $95b922e62989783f$export$8cf810175097f633 extends (0, $dSLxa.FlowGraphExecutionBlockWithOutSignal) {
    constructor(/**
     * the configuration of the block
     */ config){
        super(config);
        this.config = config;
        this.input = this.registerDataInput(config.variableName, (0, $icNzP.RichTypeAny));
    }
    _execute(context) {
        const variableNameValue = this.config.variableName;
        const inputValue = this.input.getValue(context);
        context.setVariable(variableNameValue, inputValue);
        this.out._activateSignal(context);
    }
    /**
     * @returns class name of the block.
     */ getClassName() {
        return $95b922e62989783f$export$8cf810175097f633.ClassName;
    }
}
/**
 * the class name of the block.
 */ $95b922e62989783f$export$8cf810175097f633.ClassName = "FGSetVariableBlock";
(0, $8DoUR.RegisterClass)($95b922e62989783f$export$8cf810175097f633.ClassName, $95b922e62989783f$export$8cf810175097f633);

});

parcelRegister("b9t2d", function(module, exports) {

$parcel$export(module.exports, "FlowGraphSetPropertyBlock", () => $81e70eaccd2c0fca$export$b09a7abfd9409703);

var $icNzP = parcelRequire("icNzP");

var $dSLxa = parcelRequire("dSLxa");

var $8DoUR = parcelRequire("8DoUR");

var $etlry = parcelRequire("etlry");
class $81e70eaccd2c0fca$export$b09a7abfd9409703 extends (0, $dSLxa.FlowGraphExecutionBlockWithOutSignal) {
    constructor(/**
     * the configuration of the block
     */ config){
        super(config);
        this.config = config;
        this.a = this.registerDataInput("a", (0, $icNzP.RichTypeAny));
        this.templateComponent = new (0, $etlry.FlowGraphPathConverterComponent)(config.path, this);
    }
    _execute(context) {
        const value = this.a.getValue(context);
        const accessor = this.templateComponent.getAccessor(this.config.pathConverter, context);
        accessor.info.set(value, accessor.object);
        this.out._activateSignal(context);
    }
    /**
     * Serializes the block to a JSON object.
     * @param serializationObject the object to serialize to.
     */ serialize(serializationObject = {}) {
        super.serialize(serializationObject);
        serializationObject.config.path = this.config.path;
    }
    /**
     * @returns class name of the block.
     */ getClassName() {
        return $81e70eaccd2c0fca$export$b09a7abfd9409703.ClassName;
    }
}
/**
 * Class name of the block.
 */ $81e70eaccd2c0fca$export$b09a7abfd9409703.ClassName = "FGSetPropertyBlock";
(0, $8DoUR.RegisterClass)("FGSetPropertyBlock", $81e70eaccd2c0fca$export$b09a7abfd9409703);

});
parcelRegister("etlry", function(module, exports) {

$parcel$export(module.exports, "FlowGraphPathConverterComponent", () => $a8946854eecf48de$export$9cf6b37efd2ad2fb);

var $icNzP = parcelRequire("icNzP");
const $a8946854eecf48de$var$pathHasTemplatesRegex = new RegExp(/\{(\w+)\}/g);
class $a8946854eecf48de$export$9cf6b37efd2ad2fb {
    constructor(path, ownerBlock){
        this.path = path;
        this.ownerBlock = ownerBlock;
        /**
         * The templated inputs for the provided path.
         */ this.templatedInputs = [];
        let match = $a8946854eecf48de$var$pathHasTemplatesRegex.exec(path);
        while(match){
            const [, matchGroup] = match;
            this.templatedInputs.push(ownerBlock.registerDataInput(matchGroup, (0, $icNzP.RichTypeFlowGraphInteger)));
            match = $a8946854eecf48de$var$pathHasTemplatesRegex.exec(path);
        }
    }
    getAccessor(pathConverter, context) {
        let finalPath = this.path;
        for (const templatedInput of this.templatedInputs){
            const valueToReplace = templatedInput.getValue(context).value;
            finalPath = finalPath.replace(`{${templatedInput.name}}`, valueToReplace.toString());
        }
        return pathConverter.convert(finalPath);
    }
}

});


parcelRegister("hgspb", function(module, exports) {

$parcel$export(module.exports, "FlowGraphSendCustomEventBlock", () => $c919f6fc986e635f$export$d90cac2d712b1049);

var $icNzP = parcelRequire("icNzP");

var $dSLxa = parcelRequire("dSLxa");

var $8DoUR = parcelRequire("8DoUR");
class $c919f6fc986e635f$export$d90cac2d712b1049 extends (0, $dSLxa.FlowGraphExecutionBlockWithOutSignal) {
    constructor(/**
     * the configuration of the block
     */ config){
        super(config);
        this.config = config;
        for(let i = 0; i < this.config.eventData.length; i++){
            const dataName = this.config.eventData[i];
            this.registerDataInput(dataName, (0, $icNzP.RichTypeAny));
        }
    }
    _execute(context) {
        const eventId = this.config.eventId;
        const eventDatas = this.dataInputs.map((port)=>port.getValue(context));
        context.configuration.coordinator.notifyCustomEvent(eventId, eventDatas);
        this.out._activateSignal(context);
    }
    /**
     * @returns class name of the block.
     */ getClassName() {
        return $c919f6fc986e635f$export$d90cac2d712b1049.ClassName;
    }
}
/**
 * the class name of the block.
 */ $c919f6fc986e635f$export$d90cac2d712b1049.ClassName = "FGSendCustomEventBlock";
(0, $8DoUR.RegisterClass)("FGSendCustomEventBlock", $c919f6fc986e635f$export$d90cac2d712b1049);

});

parcelRegister("1Cs9y", function(module, exports) {

var $kkeV5 = parcelRequire("kkeV5");

var $lnFgw = parcelRequire("lnFgw");

var $lND3Z = parcelRequire("lND3Z");

var $4Wcr0 = parcelRequire("4Wcr0");

var $bWHLq = parcelRequire("bWHLq");

var $8HcKi = parcelRequire("8HcKi");

var $2TuEB = parcelRequire("2TuEB");

var $lzIQy = parcelRequire("lzIQy");

var $cDM0N = parcelRequire("cDM0N");

var $B5wrk = parcelRequire("B5wrk");

var $4xENA = parcelRequire("4xENA");

var $4XZiH = parcelRequire("4XZiH");

var $eIMW7 = parcelRequire("eIMW7");
$parcel$exportWildcard(module.exports, $kkeV5);
$parcel$exportWildcard(module.exports, $lnFgw);
$parcel$exportWildcard(module.exports, $lND3Z);
$parcel$exportWildcard(module.exports, $4Wcr0);
$parcel$exportWildcard(module.exports, $bWHLq);
$parcel$exportWildcard(module.exports, $8HcKi);
$parcel$exportWildcard(module.exports, $2TuEB);
$parcel$exportWildcard(module.exports, $lzIQy);
$parcel$exportWildcard(module.exports, $cDM0N);
$parcel$exportWildcard(module.exports, $B5wrk);
$parcel$exportWildcard(module.exports, $4xENA);
$parcel$exportWildcard(module.exports, $4XZiH);
$parcel$exportWildcard(module.exports, $eIMW7);

});
parcelRegister("kkeV5", function(module, exports) {

$parcel$export(module.exports, "FlowGraphBranchBlock", () => $ecc13faa9650cd6a$export$7e9c903111be6ada);

var $icNzP = parcelRequire("icNzP");

var $jjLAB = parcelRequire("jjLAB");

var $8DoUR = parcelRequire("8DoUR");
class $ecc13faa9650cd6a$export$7e9c903111be6ada extends (0, $jjLAB.FlowGraphExecutionBlock) {
    constructor(config){
        super(config);
        this.condition = this.registerDataInput("condition", (0, $icNzP.RichTypeBoolean));
        this.onTrue = this._registerSignalOutput("onTrue");
        this.onFalse = this._registerSignalOutput("onFalse");
    }
    _execute(context) {
        if (this.condition.getValue(context)) this.onTrue._activateSignal(context);
        else this.onFalse._activateSignal(context);
    }
    /**
     * @returns class name of the block.
     */ getClassName() {
        return "FGBranchBlock";
    }
}
(0, $8DoUR.RegisterClass)("FGBranchBlock", $ecc13faa9650cd6a$export$7e9c903111be6ada);

});

parcelRegister("lnFgw", function(module, exports) {

$parcel$export(module.exports, "FlowGraphDoNBlock", () => $f90bc16d08fcadc0$export$4e720df9043e49f6);

var $icNzP = parcelRequire("icNzP");

var $dSLxa = parcelRequire("dSLxa");

var $8DoUR = parcelRequire("8DoUR");

var $daZRY = parcelRequire("daZRY");
class $f90bc16d08fcadc0$export$4e720df9043e49f6 extends (0, $dSLxa.FlowGraphExecutionBlockWithOutSignal) {
    constructor(/**
     * the configuration of the block
     */ config = {
        startIndex: new (0, $daZRY.FlowGraphInteger)(0)
    }){
        super(config);
        this.config = config;
        this.reset = this._registerSignalInput("reset");
        this.n = this.registerDataInput("n", (0, $icNzP.RichTypeFlowGraphInteger));
        this.value = this.registerDataOutput("value", (0, $icNzP.RichTypeFlowGraphInteger));
    }
    _execute(context, callingSignal) {
        if (callingSignal === this.reset) this.value.setValue(this.config.startIndex, context);
        else {
            const currentCountValue = this.value.getValue(context);
            if (currentCountValue.value < this.n.getValue(context).value) {
                this.value.setValue(new (0, $daZRY.FlowGraphInteger)(currentCountValue.value + 1), context);
                this.out._activateSignal(context);
            }
        }
    }
    /**
     * @returns class name of the block.
     */ getClassName() {
        return $f90bc16d08fcadc0$export$4e720df9043e49f6.ClassName;
    }
}
/**
 * the class name of the block.
 */ $f90bc16d08fcadc0$export$4e720df9043e49f6.ClassName = "FGDoNBlock";
(0, $8DoUR.RegisterClass)($f90bc16d08fcadc0$export$4e720df9043e49f6.ClassName, $f90bc16d08fcadc0$export$4e720df9043e49f6);

});

parcelRegister("lND3Z", function(module, exports) {

$parcel$export(module.exports, "FlowGraphForLoopBlock", () => $fdec79c0d4de183a$export$78da5f6c066bc7e9);

var $dSLxa = parcelRequire("dSLxa");

var $icNzP = parcelRequire("icNzP");

var $8DoUR = parcelRequire("8DoUR");
class $fdec79c0d4de183a$export$78da5f6c066bc7e9 extends (0, $dSLxa.FlowGraphExecutionBlockWithOutSignal) {
    constructor(config){
        super(config);
        this.startIndex = this.registerDataInput("startIndex", (0, $icNzP.RichTypeNumber));
        this.endIndex = this.registerDataInput("endIndex", (0, $icNzP.RichTypeNumber));
        this.step = this.registerDataInput("step", (0, $icNzP.RichTypeNumber));
        this.index = this.registerDataOutput("index", (0, $icNzP.RichTypeNumber));
        this.onLoop = this._registerSignalOutput("onLoop");
    }
    _executeLoop(context) {
        let index = context._getExecutionVariable(this, "index");
        const endIndex = context._getExecutionVariable(this, "endIndex");
        if (index < endIndex) {
            this.index.setValue(index, context);
            this.onLoop._activateSignal(context);
            const step = context._getExecutionVariable(this, "step", 1);
            index += step;
            context._setExecutionVariable(this, "index", index);
            this._executeLoop(context);
        } else this.out._activateSignal(context);
    }
    /**
     * @internal
     */ _execute(context) {
        const index = this.startIndex.getValue(context);
        const endIndex = this.endIndex.getValue(context);
        const step = this.step.getValue(context);
        context._setExecutionVariable(this, "index", index);
        context._setExecutionVariable(this, "endIndex", endIndex);
        context._setExecutionVariable(this, "step", step);
        this._executeLoop(context);
    }
    /**
     * @returns class name of the block.
     */ getClassName() {
        return "FGForLoopBlock";
    }
}
(0, $8DoUR.RegisterClass)("FGForLoopBlock", $fdec79c0d4de183a$export$78da5f6c066bc7e9);

});

parcelRegister("4Wcr0", function(module, exports) {

$parcel$export(module.exports, "FlowGraphThrottleBlock", () => $398639769546eebc$export$a9e5661383903c6b);

var $icNzP = parcelRequire("icNzP");

var $dSLxa = parcelRequire("dSLxa");

var $8DoUR = parcelRequire("8DoUR");
class $398639769546eebc$export$a9e5661383903c6b extends (0, $dSLxa.FlowGraphExecutionBlockWithOutSignal) {
    constructor(config){
        super(config);
        this.reset = this._registerSignalInput("reset");
        this.duration = this.registerDataInput("duration", (0, $icNzP.RichTypeNumber));
        this.timeRemaining = this.registerDataOutput("timeRemaining", (0, $icNzP.RichTypeNumber));
    }
    _execute(context, callingSignal) {
        const lastExecutedTime = context._getExecutionVariable(this, "lastExecutedTime");
        const durationValue = this.duration.getValue(context);
        const currentTime = Date.now();
        if (callingSignal === this.reset || lastExecutedTime === undefined || currentTime - lastExecutedTime > durationValue) {
            //activate the output flow
            this.timeRemaining.setValue(0, context);
            this.out._activateSignal(context);
            context._setExecutionVariable(this, "lastExecutedTime", currentTime);
        } else {
            //activate the output flow after the remaining time
            const remaining = durationValue - (currentTime - lastExecutedTime);
            this.timeRemaining.setValue(remaining, context);
        }
    }
    /**
     * @returns class name of the block.
     */ getClassName() {
        return "FGThrottleBlock";
    }
}
(0, $8DoUR.RegisterClass)("FGThrottleBlock", $398639769546eebc$export$a9e5661383903c6b);

});

parcelRegister("bWHLq", function(module, exports) {

$parcel$export(module.exports, "FlowGraphTimerBlock", () => $8b270f1634fd10cc$export$f33dba367f80d1cf);

var $2PCL1 = parcelRequire("2PCL1");

var $kUWd9 = parcelRequire("kUWd9");

var $icNzP = parcelRequire("icNzP");

var $bOhSV = parcelRequire("bOhSV");

var $8DoUR = parcelRequire("8DoUR");
class $8b270f1634fd10cc$export$f33dba367f80d1cf extends (0, $kUWd9.FlowGraphAsyncExecutionBlock) {
    constructor(config){
        super(config);
        this.timeout = this.registerDataInput("timeout", (0, $icNzP.RichTypeNumber));
    }
    _preparePendingTasks(context) {
        const currentTimeout = this.timeout.getValue(context);
        if (currentTimeout !== undefined && currentTimeout >= 0) {
            const timers = context._getExecutionVariable(this, "runningTimers") || [];
            const scene = context.configuration.scene;
            const timer = new (0, $2PCL1.AdvancedTimer)({
                timeout: currentTimeout,
                contextObservable: scene.onBeforeRenderObservable,
                onEnded: ()=>this._onEnded(timer, context)
            });
            timer.start();
            timers.push(timer);
            context._setExecutionVariable(this, "runningTimers", timers);
        }
    }
    /**
     * @internal
     */ _execute(context) {
        this._startPendingTasks(context);
        this.out._activateSignal(context);
    }
    _onEnded(timer, context) {
        const timers = context._getExecutionVariable(this, "runningTimers") || [];
        const index = timers.indexOf(timer);
        if (index !== -1) timers.splice(index, 1);
        else (0, $bOhSV.Tools).Warn("FlowGraphTimerBlock: Timer ended but was not found in the running timers list");
        context._removePendingBlock(this);
        this.done._activateSignal(context);
    }
    _cancelPendingTasks(context) {
        const timers = context._getExecutionVariable(this, "runningTimers") || [];
        for (const timer of timers)timer.dispose();
        context._deleteExecutionVariable(this, "runningTimers");
    }
    /**
     * @returns class name of the block.
     */ getClassName() {
        return $8b270f1634fd10cc$export$f33dba367f80d1cf.ClassName;
    }
}
/**
 * the class name of the block.
 */ $8b270f1634fd10cc$export$f33dba367f80d1cf.ClassName = "FGTimerBlock";
(0, $8DoUR.RegisterClass)("FGTimerBlock", $8b270f1634fd10cc$export$f33dba367f80d1cf);

});

parcelRegister("8HcKi", function(module, exports) {

$parcel$export(module.exports, "FlowGraphMultiGateBlock", () => $654c39eb232958c7$export$1ca390cfeec19a5e);

var $8DoUR = parcelRequire("8DoUR");

var $jjLAB = parcelRequire("jjLAB");

var $icNzP = parcelRequire("icNzP");
class $654c39eb232958c7$export$1ca390cfeec19a5e extends (0, $jjLAB.FlowGraphExecutionBlock) {
    constructor(/**
     * the configuration of the block
     */ config){
        super(config);
        this.config = config;
        this._cachedUnusedIndexes = [];
        this.reset = this._registerSignalInput("reset");
        this.currentIndex = this.registerDataOutput("currentIndex", (0, $icNzP.RichTypeNumber));
        this.config.startIndex = this.config.startIndex !== undefined ? this.config.startIndex : 0;
        this.config.startIndex = Math.max(0, Math.min(this.config.startIndex, this.config.numberOutputFlows - 1));
        this.outFlows = [];
        for(let i = 0; i < this.config.numberOutputFlows; i++)this.outFlows.push(this._registerSignalOutput(`out${i}`));
    }
    _getUnusedIndexes(context) {
        const result = this._cachedUnusedIndexes;
        result.length = 0;
        if (!context._hasExecutionVariable(this, "unusedIndexes")) for(let i = 0; i < this.config.numberOutputFlows; i++)result.push(i);
        else {
            const contextUnusedIndexes = context._getExecutionVariable(this, "unusedIndexes");
            for(let i = 0; i < contextUnusedIndexes.length; i++)result.push(contextUnusedIndexes[i]);
        }
        return result;
    }
    _getNextOutput(currentIndex, unusedIndexes) {
        if (this.config.isRandom) {
            const nextIndex = Math.floor(Math.random() * unusedIndexes.length);
            return unusedIndexes[nextIndex];
        } else return currentIndex + 1;
    }
    _execute(context, callingSignal) {
        const currentIndex = context._getExecutionVariable(this, "currentIndex") ?? this.config.startIndex - 1;
        let unusedIndexes = this._getUnusedIndexes(context);
        if (callingSignal === this.reset) {
            context._deleteExecutionVariable(this, "currentIndex");
            context._deleteExecutionVariable(this, "unusedIndexes");
            return;
        }
        let nextIndex = this._getNextOutput(currentIndex, unusedIndexes);
        if (nextIndex >= this.config.numberOutputFlows && this.config.loop) nextIndex = 0;
        else if (nextIndex >= this.config.numberOutputFlows && !this.config.loop) return;
        unusedIndexes = unusedIndexes.filter((i)=>i !== nextIndex);
        if (unusedIndexes.length === 0) for(let i = 0; i < this.config.numberOutputFlows; i++)unusedIndexes.push(i);
        context._setExecutionVariable(this, "unusedIndexes", unusedIndexes);
        context._setExecutionVariable(this, "currentIndex", nextIndex);
        this.currentIndex.setValue(nextIndex, context);
        this.outFlows[nextIndex]._activateSignal(context);
    }
    /**
     * @returns class name of the block.
     */ getClassName() {
        return "FGMultiGateBlock";
    }
    /**
     * Serializes the block.
     * @param serializationObject the object to serialize to.
     */ serialize(serializationObject) {
        super.serialize(serializationObject);
        serializationObject.config.numberOutputFlows = this.config.numberOutputFlows;
        serializationObject.config.isRandom = this.config.isRandom;
        serializationObject.config.loop = this.config.loop;
        serializationObject.config.startIndex = this.config.startIndex;
    }
}
(0, $8DoUR.RegisterClass)("FGMultiGateBlock", $654c39eb232958c7$export$1ca390cfeec19a5e);

});

parcelRegister("2TuEB", function(module, exports) {

$parcel$export(module.exports, "FlowGraphSwitchBlock", () => $21b87f110f57c906$export$cd06570c8c3cd417);

var $jjLAB = parcelRequire("jjLAB");

var $icNzP = parcelRequire("icNzP");

var $8DoUR = parcelRequire("8DoUR");
class $21b87f110f57c906$export$cd06570c8c3cd417 extends (0, $jjLAB.FlowGraphExecutionBlock) {
    constructor(/**
     * the configuration of the block
     */ config){
        super(config);
        this.config = config;
        this.selection = this.registerDataInput("selection", (0, $icNzP.RichTypeAny));
        this.outputFlows = [];
        for(let i = 0; i <= this.config.cases.length; i++)this.outputFlows.push(this._registerSignalOutput(`out${i}`));
    }
    _execute(context, _callingSignal) {
        const selectionValue = this.selection.getValue(context);
        for(let i = 0; i < this.config.cases.length; i++)if (selectionValue === this.config.cases[i]) {
            this.outputFlows[i]._activateSignal(context);
            return;
        }
        // default case
        this.outputFlows[this.outputFlows.length - 1]._activateSignal(context);
    }
    /**
     * @returns class name of the block.
     */ getClassName() {
        return "FGSwitchBlock";
    }
    /**
     * Serialize the block to a JSON representation.
     * @param serializationObject the object to serialize to.
     */ serialize(serializationObject) {
        super.serialize(serializationObject);
        serializationObject.cases = this.config.cases;
    }
}
(0, $8DoUR.RegisterClass)("FGSwitchBlock", $21b87f110f57c906$export$cd06570c8c3cd417);

});

parcelRegister("lzIQy", function(module, exports) {

$parcel$export(module.exports, "FlowGraphWaitAllBlock", () => $fb4fa773f9e89b36$export$ecbb746f85285796);

var $dSLxa = parcelRequire("dSLxa");

var $8DoUR = parcelRequire("8DoUR");
class $fb4fa773f9e89b36$export$ecbb746f85285796 extends (0, $dSLxa.FlowGraphExecutionBlockWithOutSignal) {
    constructor(/**
     * the configuration of the block
     */ config){
        super(config);
        this.config = config;
        /**
         * Input connection: The 2nd to nth input flows (the first is named onStart)
         */ this.inFlows = [];
        this._cachedActivationState = [];
        this.reset = this._registerSignalInput("reset");
        // The first inFlow is the default input signal all execution blocks have
        for(let i = 1; i < this.config.numberInputFlows; i++)this.inFlows.push(this._registerSignalInput(`in${i}`));
    }
    _getCurrentActivationState(context) {
        const activationState = this._cachedActivationState;
        activationState.length = 0;
        if (!context._hasExecutionVariable(this, "activationState")) for(let i = 0; i < this.config.numberInputFlows; i++)activationState.push(false);
        else {
            const contextActivationState = context._getExecutionVariable(this, "activationState");
            for(let i = 0; i < contextActivationState.length; i++)activationState.push(contextActivationState[i]);
        }
        return activationState;
    }
    _execute(context, callingSignal) {
        const activationState = this._getCurrentActivationState(context);
        if (callingSignal === this.reset) for(let i = 0; i < this.config.numberInputFlows; i++)activationState[i] = false;
        else if (callingSignal === this.in) activationState[0] = true;
        else {
            const index = this.inFlows.indexOf(callingSignal);
            if (index >= 0) activationState[index + 1] = true;
        }
        context._setExecutionVariable(this, "activationState", activationState.slice());
        if (activationState.every((value)=>value)) {
            this.out._activateSignal(context);
            for(let i = 0; i < this.config.numberInputFlows; i++)activationState[i] = false;
        }
    }
    /**
     * @returns class name of the block.
     */ getClassName() {
        return "FGWaitAllBlock";
    }
    /**
     * Serializes this block into a object
     * @param serializationObject the object to serialize to
     */ serialize(serializationObject) {
        super.serialize(serializationObject);
        serializationObject.config.numberInputFlows = this.config.numberInputFlows;
    }
}
(0, $8DoUR.RegisterClass)("FGWaitAllBlock", $fb4fa773f9e89b36$export$ecbb746f85285796);

});

parcelRegister("cDM0N", function(module, exports) {

$parcel$export(module.exports, "FlowGraphCounterBlock", () => $933e5eb4d65f07c7$export$6312727ebcb6239d);

var $icNzP = parcelRequire("icNzP");

var $dSLxa = parcelRequire("dSLxa");

var $8DoUR = parcelRequire("8DoUR");
class $933e5eb4d65f07c7$export$6312727ebcb6239d extends (0, $dSLxa.FlowGraphExecutionBlockWithOutSignal) {
    constructor(config){
        super(config);
        this.count = this.registerDataOutput("count", (0, $icNzP.RichTypeNumber));
        this.reset = this._registerSignalInput("reset");
    }
    _execute(context, callingSignal) {
        if (callingSignal === this.reset) {
            context._setExecutionVariable(this, "count", 0);
            this.count.setValue(0, context);
            return;
        }
        const countValue = (context._getExecutionVariable(this, "count") ?? 0) + 1;
        context._setExecutionVariable(this, "count", countValue);
        this.count.setValue(countValue, context);
        this.out._activateSignal(context);
    }
    /**
     * @returns class name of the block.
     */ getClassName() {
        return "FGCounterBlock";
    }
}
(0, $8DoUR.RegisterClass)("FGCounterBlock", $933e5eb4d65f07c7$export$6312727ebcb6239d);

});

parcelRegister("B5wrk", function(module, exports) {

$parcel$export(module.exports, "FlowGraphWhileLoopBlock", () => $06f7bd6a01677655$export$b33eb5e127d3e68e);

var $icNzP = parcelRequire("icNzP");

var $8DoUR = parcelRequire("8DoUR");

var $dSLxa = parcelRequire("dSLxa");
class $06f7bd6a01677655$export$b33eb5e127d3e68e extends (0, $dSLxa.FlowGraphExecutionBlockWithOutSignal) {
    constructor(/**
     * the configuration of the block
     */ config){
        super(config);
        this.config = config;
        this.condition = this.registerDataInput("condition", (0, $icNzP.RichTypeBoolean));
        this.loopBody = this._registerSignalOutput("loopBody");
    }
    _execute(context, _callingSignal) {
        let conditionValue = this.condition.getValue(context);
        if (this.config?.isDo && !conditionValue) this.loopBody._activateSignal(context);
        while(conditionValue){
            this.loopBody._activateSignal(context);
            conditionValue = this.condition.getValue(context);
        }
        this.out._activateSignal(context);
    }
    /**
     * @returns class name of the block.
     */ getClassName() {
        return $06f7bd6a01677655$export$b33eb5e127d3e68e.ClassName;
    }
    /**
     * Serializes the block to a JSON object.
     * @param serializationObject the object to serialize to.
     */ serialize(serializationObject) {
        super.serialize(serializationObject);
        serializationObject.isDo = this.config?.isDo;
    }
}
/**
 * the class name of the block.
 */ $06f7bd6a01677655$export$b33eb5e127d3e68e.ClassName = "FGWhileLoopBlock";
(0, $8DoUR.RegisterClass)($06f7bd6a01677655$export$b33eb5e127d3e68e.ClassName, $06f7bd6a01677655$export$b33eb5e127d3e68e);

});

parcelRegister("4xENA", function(module, exports) {

$parcel$export(module.exports, "FlowGraphDebounceBlock", () => $34e9e4438dc3cf19$export$ed6677bfbf354e82);

var $icNzP = parcelRequire("icNzP");

var $dSLxa = parcelRequire("dSLxa");

var $8DoUR = parcelRequire("8DoUR");
class $34e9e4438dc3cf19$export$ed6677bfbf354e82 extends (0, $dSLxa.FlowGraphExecutionBlockWithOutSignal) {
    constructor(config){
        super(config);
        this.count = this.registerDataInput("count", (0, $icNzP.RichTypeNumber));
        this.reset = this._registerSignalInput("reset");
        this.currentCount = this.registerDataOutput("currentCount", (0, $icNzP.RichTypeNumber));
    }
    _execute(context, callingSignal) {
        if (callingSignal === this.reset) {
            context._setExecutionVariable(this, "debounceCount", 0);
            return;
        }
        const count = this.count.getValue(context);
        const currentCount = context._getExecutionVariable(this, "debounceCount", 0);
        const newCount = currentCount + 1;
        this.currentCount.setValue(newCount, context);
        context._setExecutionVariable(this, "debounceCount", newCount);
        if (newCount >= count) {
            this.out._activateSignal(context);
            context._setExecutionVariable(this, "debounceCount", 0);
        }
    }
    /**
     * @returns class name of the block.
     */ getClassName() {
        return "FGDebounceBlock";
    }
}
(0, $8DoUR.RegisterClass)("FGDebounceBlock", $34e9e4438dc3cf19$export$ed6677bfbf354e82);

});

parcelRegister("4XZiH", function(module, exports) {

$parcel$export(module.exports, "FlowGraphFlipFlopBlock", () => $39dc3925f3a39dd4$export$c0cc5e86e1984e3e);

var $jjLAB = parcelRequire("jjLAB");

var $icNzP = parcelRequire("icNzP");

var $8DoUR = parcelRequire("8DoUR");
class $39dc3925f3a39dd4$export$c0cc5e86e1984e3e extends (0, $jjLAB.FlowGraphExecutionBlock) {
    constructor(config){
        super(config);
        this.onOn = this._registerSignalOutput("onOn");
        this.onOff = this._registerSignalOutput("onOff");
        this.isOn = this.registerDataOutput("isOn", (0, $icNzP.RichTypeBoolean));
    }
    _execute(context, _callingSignal) {
        let value = context._getExecutionVariable(this, "value", false);
        value = !value;
        context._setExecutionVariable(this, "value", value);
        this.isOn.setValue(value, context);
        if (value) this.onOn._activateSignal(context);
        else this.onOff._activateSignal(context);
    }
    /**
     * @returns class name of the block.
     */ getClassName() {
        return "FGFlipFlopBlock";
    }
}
(0, $8DoUR.RegisterClass)("FGFlipFlopBlock", $39dc3925f3a39dd4$export$c0cc5e86e1984e3e);

});

parcelRegister("eIMW7", function(module, exports) {

$parcel$export(module.exports, "FlowGraphSequenceBlock", () => $ab7b22823d5c9b29$export$452dcdea66cd0819);

var $8DoUR = parcelRequire("8DoUR");

var $jjLAB = parcelRequire("jjLAB");
class $ab7b22823d5c9b29$export$452dcdea66cd0819 extends (0, $jjLAB.FlowGraphExecutionBlock) {
    constructor(/**
     * the configuration of the block
     */ config){
        super(config);
        this.config = config;
        this.outFlows = [];
        for(let i = 0; i < this.config.numberOutputFlows; i++)this.outFlows.push(this._registerSignalOutput(`${i}`));
    }
    _execute(context) {
        for(let i = 0; i < this.config.numberOutputFlows; i++)this.outFlows[i]._activateSignal(context);
    }
    /**
     * @returns class name of the block.
     */ getClassName() {
        return $ab7b22823d5c9b29$export$452dcdea66cd0819.ClassName;
    }
}
/**
 * the class name of the block.
 */ $ab7b22823d5c9b29$export$452dcdea66cd0819.ClassName = "FGSequenceBlock";
(0, $8DoUR.RegisterClass)($ab7b22823d5c9b29$export$452dcdea66cd0819.ClassName, $ab7b22823d5c9b29$export$452dcdea66cd0819);

});


parcelRegister("kIK07", function(module, exports) {

var $aOSES = parcelRequire("aOSES");

var $2OY9R = parcelRequire("2OY9R");

var $5MEay = parcelRequire("5MEay");
$parcel$exportWildcard(module.exports, $aOSES);
$parcel$exportWildcard(module.exports, $2OY9R);
$parcel$exportWildcard(module.exports, $5MEay);

});
parcelRegister("aOSES", function(module, exports) {

$parcel$export(module.exports, "FlowGraphPlayAnimationBlock", () => $7e08f8e7adabc7ba$export$9d7919746e08a05b);

var $kUWd9 = parcelRequire("kUWd9");

var $icNzP = parcelRequire("icNzP");

var $8DoUR = parcelRequire("8DoUR");

var $etlry = parcelRequire("etlry");
class $7e08f8e7adabc7ba$export$9d7919746e08a05b extends (0, $kUWd9.FlowGraphAsyncExecutionBlock) {
    constructor(/**
     * the configuration of the block
     */ config){
        super(config);
        this.config = config;
        this.templateTargetComponent = new (0, $etlry.FlowGraphPathConverterComponent)(config.targetPath, this);
        this.templateAnimationComponent = new (0, $etlry.FlowGraphPathConverterComponent)(config.animationPath, this);
        this.speed = this.registerDataInput("speed", (0, $icNzP.RichTypeNumber));
        this.loop = this.registerDataInput("loop", (0, $icNzP.RichTypeBoolean));
        this.from = this.registerDataInput("from", (0, $icNzP.RichTypeNumber));
        this.to = this.registerDataInput("to", (0, $icNzP.RichTypeNumber));
        this.runningAnimatable = this.registerDataOutput("runningAnimatable", (0, $icNzP.RichTypeAny));
    }
    /**
     * @internal
     * @param context
     */ _preparePendingTasks(context) {
        const targetAccessor = this.templateTargetComponent.getAccessor(this.config.pathConverter, context);
        const targetValue = targetAccessor.info.getObject(targetAccessor.object);
        const animationAccessor = this.templateAnimationComponent.getAccessor(this.config.pathConverter, context);
        const animationValue = animationAccessor.info.get(animationAccessor.object);
        if (!targetValue || !animationValue) throw new Error("Cannot play animation without target or animation");
        const contextAnimatables = context._getExecutionVariable(this, "runningAnimatables") ?? [];
        // was an animation started on this target already and was just paused? if so, we can unpause it.
        const existingAnimatable = this.runningAnimatable.getValue(context);
        if (existingAnimatable && existingAnimatable.paused) existingAnimatable.restart();
        else {
            const scene = context.configuration.scene;
            const animatable = scene.beginDirectAnimation(targetValue, [
                animationValue
            ], this.from.getValue(context), this.to.getValue(context), this.loop.getValue(context), this.speed.getValue(context), ()=>this._onAnimationEnd(animatable, context));
            this.runningAnimatable.setValue(animatable, context);
            contextAnimatables.push(animatable);
        }
        context._setExecutionVariable(this, "runningAnimatables", contextAnimatables);
    }
    _execute(context) {
        this._startPendingTasks(context);
        this.out._activateSignal(context);
    }
    _onAnimationEnd(animatable, context) {
        const contextAnims = context._getExecutionVariable(this, "runningAnimatables") ?? [];
        const index = contextAnims.indexOf(animatable);
        if (index !== -1) contextAnims.splice(index, 1);
        context._removePendingBlock(this);
        this.done._activateSignal(context);
    }
    /**
     * @internal
     * Stop any currently running animations.
     */ _cancelPendingTasks(context) {
        const contextAnims = context._getExecutionVariable(this, "runningAnimatables") ?? [];
        for (const anim of contextAnims)anim.stop();
        context._deleteExecutionVariable(this, "runningAnimatables");
    }
    /**
     * @returns class name of the block.
     */ getClassName() {
        return $7e08f8e7adabc7ba$export$9d7919746e08a05b.ClassName;
    }
    /**
     * Serializes the block to a JSON object.
     * @param serializationObject the object to serialize to.
     */ serialize(serializationObject = {}) {
        super.serialize(serializationObject);
        serializationObject.config.targetPath = this.config.targetPath;
        serializationObject.config.animationPath = this.config.animationPath;
    }
}
/**
 * Class name of the block.
 */ $7e08f8e7adabc7ba$export$9d7919746e08a05b.ClassName = "FGPlayAnimationBlock";
(0, $8DoUR.RegisterClass)($7e08f8e7adabc7ba$export$9d7919746e08a05b.ClassName, $7e08f8e7adabc7ba$export$9d7919746e08a05b);

});

parcelRegister("2OY9R", function(module, exports) {

$parcel$export(module.exports, "FlowGraphStopAnimationBlock", () => $20deea700b32de39$export$3d83cb3a0b396a58);

var $dSLxa = parcelRequire("dSLxa");

var $icNzP = parcelRequire("icNzP");

var $8DoUR = parcelRequire("8DoUR");
class $20deea700b32de39$export$3d83cb3a0b396a58 extends (0, $dSLxa.FlowGraphExecutionBlockWithOutSignal) {
    constructor(config){
        super(config);
        this.animationToStop = this.registerDataInput("animationToStop", (0, $icNzP.RichTypeAny));
    }
    _execute(context) {
        const animationToStopValue = this.animationToStop.getValue(context);
        animationToStopValue.stop();
        this.out._activateSignal(context);
    }
    /**
     * @returns class name of the block.
     */ getClassName() {
        return "FGStopAnimationBlock";
    }
}
(0, $8DoUR.RegisterClass)("FGStopAnimationBlock", $20deea700b32de39$export$3d83cb3a0b396a58);

});

parcelRegister("5MEay", function(module, exports) {

$parcel$export(module.exports, "FlowGraphPauseAnimationBlock", () => $4360983cb4091f07$export$f6ea222e60c99e77);

var $dSLxa = parcelRequire("dSLxa");

var $icNzP = parcelRequire("icNzP");

var $8DoUR = parcelRequire("8DoUR");
class $4360983cb4091f07$export$f6ea222e60c99e77 extends (0, $dSLxa.FlowGraphExecutionBlockWithOutSignal) {
    constructor(config){
        super(config);
        this.animationToPause = this.registerDataInput("animationToPause", (0, $icNzP.RichTypeAny));
    }
    _execute(context) {
        const animationToPauseValue = this.animationToPause.getValue(context);
        animationToPauseValue.pause();
        this.out._activateSignal(context);
    }
    /**
     * @returns class name of the block.
     */ getClassName() {
        return "FGPauseAnimationBlock";
    }
}
(0, $8DoUR.RegisterClass)("FGPauseAnimationBlock", $4360983cb4091f07$export$f6ea222e60c99e77);

});



parcelRegister("1MTyq", function(module, exports) {

var $7TW4s = parcelRequire("7TW4s");

var $9uH9M = parcelRequire("9uH9M");

var $6D9bk = parcelRequire("6D9bk");

var $utWLg = parcelRequire("utWLg");

var $d0YZx = parcelRequire("d0YZx");

var $X5fpu = parcelRequire("X5fpu");

var $4FCOn = parcelRequire("4FCOn");
$parcel$exportWildcard(module.exports, $7TW4s);
$parcel$exportWildcard(module.exports, $9uH9M);
$parcel$exportWildcard(module.exports, $6D9bk);
$parcel$exportWildcard(module.exports, $utWLg);
$parcel$exportWildcard(module.exports, $d0YZx);
$parcel$exportWildcard(module.exports, $X5fpu);
$parcel$exportWildcard(module.exports, $4FCOn);

});
parcelRegister("7TW4s", function(module, exports) {

$parcel$export(module.exports, "FlowGraphConditionalDataBlock", () => $5c0ab722b6d99401$export$d1b67eb8eb902e8b);

var $20p5a = parcelRequire("20p5a");

var $icNzP = parcelRequire("icNzP");

var $8DoUR = parcelRequire("8DoUR");
class $5c0ab722b6d99401$export$d1b67eb8eb902e8b extends (0, $20p5a.FlowGraphBlock) {
    constructor(config){
        super(config);
        this.condition = this.registerDataInput("condition", (0, $icNzP.RichTypeBoolean));
        this.trueValue = this.registerDataInput("trueValue", (0, $icNzP.RichTypeAny));
        this.falseValue = this.registerDataInput("falseValue", (0, $icNzP.RichTypeAny));
        this.output = this.registerDataOutput("output", (0, $icNzP.RichTypeAny));
    }
    /**
     * @internal
     */ _updateOutputs(context) {
        this.output.setValue(this.condition.getValue(context) ? this.trueValue.getValue(context) : this.falseValue.getValue(context), context);
    }
    /**
     * Gets the class name of this block
     * @returns the class name
     */ getClassName() {
        return "FGConditionalDataBlock";
    }
}
(0, $8DoUR.RegisterClass)("FGConditionalDataBlock", $5c0ab722b6d99401$export$d1b67eb8eb902e8b);

});

parcelRegister("9uH9M", function(module, exports) {

$parcel$export(module.exports, "FlowGraphGetVariableBlock", () => $6e98646e0af121d4$export$e00cac21de84b32c);

var $20p5a = parcelRequire("20p5a");

var $icNzP = parcelRequire("icNzP");

var $8DoUR = parcelRequire("8DoUR");
class $6e98646e0af121d4$export$e00cac21de84b32c extends (0, $20p5a.FlowGraphBlock) {
    /**
     * Construct a FlowGraphGetVariableBlock.
     * @param config construction parameters
     */ constructor(config){
        super(config);
        this.config = config;
        // The output connection has to have the name of the variable.
        this.output = this.registerDataOutput(config.variableName, (0, $icNzP.RichTypeAny));
    }
    /**
     * @internal
     */ _updateOutputs(context) {
        const variableNameValue = this.config.variableName;
        if (context.hasVariable(variableNameValue)) this.output.setValue(context.getVariable(variableNameValue), context);
    }
    /**
     * Gets the class name of this block
     * @returns the class name
     */ getClassName() {
        return $6e98646e0af121d4$export$e00cac21de84b32c.ClassName;
    }
    /**
     * Serializes this block
     * @param serializationObject the object to serialize to
     */ serialize(serializationObject) {
        super.serialize(serializationObject);
        serializationObject.config.variableName = this.config.variableName;
    }
}
/**
 * Class name of the block.
 */ $6e98646e0af121d4$export$e00cac21de84b32c.ClassName = "FGGetVariableBlock";
(0, $8DoUR.RegisterClass)($6e98646e0af121d4$export$e00cac21de84b32c.ClassName, $6e98646e0af121d4$export$e00cac21de84b32c);

});

parcelRegister("6D9bk", function(module, exports) {

$parcel$export(module.exports, "FlowGraphCoordinateTransformBlock", () => $4d3d81e624bad59b$export$13eac327d6ed78b2);

var $20p5a = parcelRequire("20p5a");

var $icNzP = parcelRequire("icNzP");

var $ha1VO = parcelRequire("ha1VO");

var $8DoUR = parcelRequire("8DoUR");
class $4d3d81e624bad59b$export$13eac327d6ed78b2 extends (0, $20p5a.FlowGraphBlock) {
    /**
     * Creates a new FlowGraphCoordinateTransformBlock
     * @param config optional configuration for this block
     */ constructor(config){
        super(config);
        this.sourceSystem = this.registerDataInput("sourceSystem", (0, $icNzP.RichTypeAny));
        this.destinationSystem = this.registerDataInput("destinationSystem", (0, $icNzP.RichTypeAny));
        this.inputCoordinates = this.registerDataInput("inputCoordinates", (0, $icNzP.RichTypeVector3));
        this.outputCoordinates = this.registerDataOutput("outputCoordinates", (0, $icNzP.RichTypeVector3));
    }
    _updateOutputs(_context) {
        const sourceSystemValue = this.sourceSystem.getValue(_context);
        const destinationSystemValue = this.destinationSystem.getValue(_context);
        const inputCoordinatesValue = this.inputCoordinates.getValue(_context);
        // takes coordinates from source space to world space
        const sourceWorld = sourceSystemValue.getWorldMatrix();
        // takes coordinates from destination space to world space
        const destinationWorld = destinationSystemValue.getWorldMatrix();
        const destinationWorldInverse = (0, $ha1VO.TmpVectors).Matrix[0].copyFrom(destinationWorld);
        // takes coordinates from world space to destination space
        destinationWorldInverse.invert();
        const sourceToDestination = (0, $ha1VO.TmpVectors).Matrix[1];
        // takes coordinates from source space to world space to destination space
        destinationWorldInverse.multiplyToRef(sourceWorld, sourceToDestination);
        const outputCoordinatesValue = this.outputCoordinates.getValue(_context);
        (0, $ha1VO.Vector3).TransformCoordinatesToRef(inputCoordinatesValue, sourceToDestination, outputCoordinatesValue);
    }
    /**
     * Gets the class name of this block
     * @returns the class name
     */ getClassName() {
        return "FGCoordinateTransformBlock";
    }
}
(0, $8DoUR.RegisterClass)("FGCoordinateTransformBlock", $4d3d81e624bad59b$export$13eac327d6ed78b2);

});

parcelRegister("utWLg", function(module, exports) {

$parcel$export(module.exports, "FlowGraphConstantBlock", () => $05ba0842982bdc6c$export$674ac265656c9b40);

var $20p5a = parcelRequire("20p5a");

var $icNzP = parcelRequire("icNzP");

var $8DoUR = parcelRequire("8DoUR");

var $b7h7Q = parcelRequire("b7h7Q");
class $05ba0842982bdc6c$export$674ac265656c9b40 extends (0, $20p5a.FlowGraphBlock) {
    constructor(/**
     * the configuration of the block
     */ config){
        super(config);
        this.config = config;
        this.output = this.registerDataOutput("output", (0, $icNzP.getRichTypeFromValue)(config.value));
    }
    _updateOutputs(context) {
        this.output.setValue(this.config.value, context);
    }
    /**
     * Gets the class name of this block
     * @returns the class name
     */ getClassName() {
        return "FGConstantBlock";
    }
    /**
     * Serializes this block
     * @param serializationObject the object to serialize to
     * @param valueSerializeFunction the function to use to serialize the value
     */ serialize(serializationObject = {}, valueSerializeFunction = (0, $b7h7Q.defaultValueSerializationFunction)) {
        super.serialize(serializationObject);
        valueSerializeFunction("value", this.config.value, serializationObject.config);
    }
}
(0, $8DoUR.RegisterClass)("FGConstantBlock", $05ba0842982bdc6c$export$674ac265656c9b40);

});

parcelRegister("d0YZx", function(module, exports) {

$parcel$export(module.exports, "FlowGraphGetPropertyBlock", () => $979a9620369b50d5$export$fb03b80a7e28cd9e);

var $8DoUR = parcelRequire("8DoUR");

var $20p5a = parcelRequire("20p5a");

var $icNzP = parcelRequire("icNzP");

var $etlry = parcelRequire("etlry");
class $979a9620369b50d5$export$fb03b80a7e28cd9e extends (0, $20p5a.FlowGraphBlock) {
    constructor(/**
     * the configuration of the block
     */ config){
        super(config);
        this.config = config;
        this.value = this.registerDataOutput("value", (0, $icNzP.RichTypeAny));
        this.templateComponent = new (0, $etlry.FlowGraphPathConverterComponent)(config.path, this);
    }
    _updateOutputs(context) {
        const accessorContainer = this.templateComponent.getAccessor(this.config.pathConverter, context);
        const value = accessorContainer.info.get(accessorContainer.object);
        this.value.setValue(value, context);
    }
    /**
     * Gets the class name of this block
     * @returns the class name
     */ getClassName() {
        return $979a9620369b50d5$export$fb03b80a7e28cd9e.ClassName;
    }
    /**
     * Serializes this block
     * @param serializationObject the object to serialize to
     */ serialize(serializationObject = {}) {
        super.serialize(serializationObject);
        serializationObject.config.path = this.config.path;
    }
}
/**
 * Class name of the block.
 */ $979a9620369b50d5$export$fb03b80a7e28cd9e.ClassName = "FGGetPropertyBlock";
(0, $8DoUR.RegisterClass)($979a9620369b50d5$export$fb03b80a7e28cd9e.ClassName, $979a9620369b50d5$export$fb03b80a7e28cd9e);

});

parcelRegister("X5fpu", function(module, exports) {

var $lOaXh = parcelRequire("lOaXh");
$parcel$exportWildcard(module.exports, $lOaXh);

});
parcelRegister("lOaXh", function(module, exports) {

$parcel$export(module.exports, "FlowGraphLogicAndBlock", () => $fe06c3ef94a14bbf$export$91b60e09f20cc019);
$parcel$export(module.exports, "FlowGraphLogicOrBlock", () => $fe06c3ef94a14bbf$export$8a46d2d6753d355a);
$parcel$export(module.exports, "FlowGraphLogicNotBlock", () => $fe06c3ef94a14bbf$export$691149d6b270392e);

var $icNzP = parcelRequire("icNzP");

var $dF3Zi = parcelRequire("dF3Zi");

var $exMJi = parcelRequire("exMJi");

var $8DoUR = parcelRequire("8DoUR");
const $fe06c3ef94a14bbf$var$PREFIX = "FGLogic";
const $fe06c3ef94a14bbf$var$AND = "AndBlock";
const $fe06c3ef94a14bbf$var$OR = "OrBlock";
const $fe06c3ef94a14bbf$var$NOT = "NotBlock";
class $fe06c3ef94a14bbf$export$91b60e09f20cc019 extends (0, $dF3Zi.FlowGraphBinaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeBoolean), (0, $icNzP.RichTypeBoolean), (0, $icNzP.RichTypeBoolean), (left, right)=>left && right, `${$fe06c3ef94a14bbf$var$PREFIX}${$fe06c3ef94a14bbf$var$AND}`, config);
    }
}
(0, $8DoUR.RegisterClass)(`${$fe06c3ef94a14bbf$var$PREFIX}${$fe06c3ef94a14bbf$var$AND}`, $fe06c3ef94a14bbf$export$91b60e09f20cc019);
class $fe06c3ef94a14bbf$export$8a46d2d6753d355a extends (0, $dF3Zi.FlowGraphBinaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeBoolean), (0, $icNzP.RichTypeBoolean), (0, $icNzP.RichTypeBoolean), (left, right)=>left || right, `${$fe06c3ef94a14bbf$var$PREFIX}${$fe06c3ef94a14bbf$var$OR}`, config);
    }
}
(0, $8DoUR.RegisterClass)(`${$fe06c3ef94a14bbf$var$PREFIX}${$fe06c3ef94a14bbf$var$OR}`, $fe06c3ef94a14bbf$export$8a46d2d6753d355a);
class $fe06c3ef94a14bbf$export$691149d6b270392e extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeBoolean), (0, $icNzP.RichTypeBoolean), (value)=>!value, `${$fe06c3ef94a14bbf$var$PREFIX}${$fe06c3ef94a14bbf$var$NOT}`, config);
    }
}
(0, $8DoUR.RegisterClass)(`${$fe06c3ef94a14bbf$var$PREFIX}${$fe06c3ef94a14bbf$var$NOT}`, $fe06c3ef94a14bbf$export$691149d6b270392e);

});
parcelRegister("dF3Zi", function(module, exports) {

$parcel$export(module.exports, "FlowGraphBinaryOperationBlock", () => $9f2232958f1c3029$export$1eaf4dae9dc3042);

var $djlXN = parcelRequire("djlXN");
class $9f2232958f1c3029$export$1eaf4dae9dc3042 extends (0, $djlXN.FlowGraphCachedOperationBlock) {
    constructor(leftRichType, rightRichType, resultRichType, _operation, _className, config){
        super(resultRichType, config);
        this._operation = _operation;
        this._className = _className;
        this.a = this.registerDataInput("a", leftRichType);
        this.b = this.registerDataInput("b", rightRichType);
    }
    /**
     * the operation performed by this block
     * @param context the graph context
     * @returns the result of the operation
     */ _doOperation(context) {
        return this._operation(this.a.getValue(context), this.b.getValue(context));
    }
    /**
     * Gets the class name of this block
     * @returns the class name
     */ getClassName() {
        return this._className;
    }
}

});
parcelRegister("djlXN", function(module, exports) {

$parcel$export(module.exports, "FlowGraphCachedOperationBlock", () => $9b0e162e4a56df9c$export$ff07af293d0165f8);

var $20p5a = parcelRequire("20p5a");
const $9b0e162e4a56df9c$var$cacheName = "cachedOperationValue";
const $9b0e162e4a56df9c$var$cacheExecIdName = "cachedExecutionId";
class $9b0e162e4a56df9c$export$ff07af293d0165f8 extends (0, $20p5a.FlowGraphBlock) {
    constructor(outputRichType, config){
        super(config);
        this.value = this.registerDataOutput("value", outputRichType);
    }
    _updateOutputs(context) {
        const cachedExecutionId = context._getExecutionVariable(this, $9b0e162e4a56df9c$var$cacheExecIdName);
        const cachedValue = context._getExecutionVariable(this, $9b0e162e4a56df9c$var$cacheName);
        if (cachedValue !== undefined && cachedExecutionId === context.executionId) this.value.setValue(cachedValue, context);
        else {
            const calculatedValue = this._doOperation(context);
            context._setExecutionVariable(this, $9b0e162e4a56df9c$var$cacheName, calculatedValue);
            context._setExecutionVariable(this, $9b0e162e4a56df9c$var$cacheExecIdName, context.executionId);
            this.value.setValue(calculatedValue, context);
        }
    }
}

});


parcelRegister("exMJi", function(module, exports) {

$parcel$export(module.exports, "FlowGraphUnaryOperationBlock", () => $a969f273d9980c31$export$c899f452f232d637);

var $djlXN = parcelRequire("djlXN");
class $a969f273d9980c31$export$c899f452f232d637 extends (0, $djlXN.FlowGraphCachedOperationBlock) {
    constructor(inputRichType, resultRichType, _operation, _className, config){
        super(resultRichType, config);
        this._operation = _operation;
        this._className = _className;
        this.a = this.registerDataInput("a", inputRichType);
    }
    /**
     * the operation performed by this block
     * @param context the graph context
     * @returns the result of the operation
     */ _doOperation(context) {
        return this._operation(this.a.getValue(context));
    }
    /**
     * Gets the class name of this block
     * @returns the class name
     */ getClassName() {
        return this._className;
    }
}

});



parcelRegister("4FCOn", function(module, exports) {

var $6kQCG = parcelRequire("6kQCG");
$parcel$exportWildcard(module.exports, $6kQCG);

});
parcelRegister("6kQCG", function(module, exports) {

$parcel$export(module.exports, "FlowGraphAddBlock", () => $49cd6e26642822d9$export$1c9df5407fa63eb1);
$parcel$export(module.exports, "FlowGraphSubtractBlock", () => $49cd6e26642822d9$export$f785ac4c5b6ff594);
$parcel$export(module.exports, "FlowGraphMultiplyBlock", () => $49cd6e26642822d9$export$7bad4f5befb46ff5);
$parcel$export(module.exports, "FlowGraphDivideBlock", () => $49cd6e26642822d9$export$ea9877efa53a72a7);
$parcel$export(module.exports, "FlowGraphRandomBlock", () => $49cd6e26642822d9$export$b8972610b9885af0);
$parcel$export(module.exports, "FlowGraphDotBlock", () => $49cd6e26642822d9$export$66a9fda16f53ff13);
$parcel$export(module.exports, "FlowGraphEBlock", () => $49cd6e26642822d9$export$4e08d14682ef22f4);
$parcel$export(module.exports, "FlowGraphPiBlock", () => $49cd6e26642822d9$export$9d61d2a810a358ad);
$parcel$export(module.exports, "FlowGraphInfBlock", () => $49cd6e26642822d9$export$5662445d1bc7af5b);
$parcel$export(module.exports, "FlowGraphNaNBlock", () => $49cd6e26642822d9$export$bfa84e5a0554a0d9);
$parcel$export(module.exports, "FlowGraphAbsBlock", () => $49cd6e26642822d9$export$27b656bf7fd5c63b);
$parcel$export(module.exports, "FlowGraphSignBlock", () => $49cd6e26642822d9$export$e1c80ad68024dfd6);
$parcel$export(module.exports, "FlowGraphTruncBlock", () => $49cd6e26642822d9$export$c2a82b701348baee);
$parcel$export(module.exports, "FlowGraphFloorBlock", () => $49cd6e26642822d9$export$8d1a24be70bbb60d);
$parcel$export(module.exports, "FlowGraphCeilBlock", () => $49cd6e26642822d9$export$aa9eb81f93f561ec);
$parcel$export(module.exports, "FlowGraphFractBlock", () => $49cd6e26642822d9$export$2e2fd95ecdb83b69);
$parcel$export(module.exports, "FlowGraphNegBlock", () => $49cd6e26642822d9$export$1ca588783e2bd70);
$parcel$export(module.exports, "FlowGraphRemainderBlock", () => $49cd6e26642822d9$export$23253d72b008c34a);
$parcel$export(module.exports, "FlowGraphMinBlock", () => $49cd6e26642822d9$export$36638dd4e8450dbc);
$parcel$export(module.exports, "FlowGraphMaxBlock", () => $49cd6e26642822d9$export$35333622e5f96927);
$parcel$export(module.exports, "FlowGraphClampBlock", () => $49cd6e26642822d9$export$942c407f61b903e8);
$parcel$export(module.exports, "FlowGraphSaturateBlock", () => $49cd6e26642822d9$export$768c089fcf42565e);
$parcel$export(module.exports, "FlowGraphInterpolateBlock", () => $49cd6e26642822d9$export$585d692eb527396a);
$parcel$export(module.exports, "FlowGraphEqBlock", () => $49cd6e26642822d9$export$1e5e8f70b0fbef28);
$parcel$export(module.exports, "FlowGraphLessThanBlock", () => $49cd6e26642822d9$export$899c0a6b8e7a8d11);
$parcel$export(module.exports, "FlowGraphLessThanOrEqualBlock", () => $49cd6e26642822d9$export$abfbed545f37caa6);
$parcel$export(module.exports, "FlowGraphGreaterThanBlock", () => $49cd6e26642822d9$export$c225c70437b84d44);
$parcel$export(module.exports, "FlowGraphGreaterThanOrEqualBlock", () => $49cd6e26642822d9$export$7675ce5b528f3305);
$parcel$export(module.exports, "FlowGraphIsNanBlock", () => $49cd6e26642822d9$export$979d378ff365aede);
$parcel$export(module.exports, "FlowGraphIsInfBlock", () => $49cd6e26642822d9$export$27e4181a18e6cccc);
$parcel$export(module.exports, "FlowGraphDegToRadBlock", () => $49cd6e26642822d9$export$c9fdf4115ee06aa9);
$parcel$export(module.exports, "FlowGraphRadToDegBlock", () => $49cd6e26642822d9$export$159e38831eec233);
$parcel$export(module.exports, "FlowGraphSinBlock", () => $49cd6e26642822d9$export$28fc3e81879c462c);
$parcel$export(module.exports, "FlowGraphCosBlock", () => $49cd6e26642822d9$export$b653437c98324ed);
$parcel$export(module.exports, "FlowGraphTanBlock", () => $49cd6e26642822d9$export$51aa0c7d9402210f);
$parcel$export(module.exports, "FlowGraphAsinBlock", () => $49cd6e26642822d9$export$6366496c6550e148);
$parcel$export(module.exports, "FlowGraphAcosBlock", () => $49cd6e26642822d9$export$f39d60a0924a0e63);
$parcel$export(module.exports, "FlowGraphAtanBlock", () => $49cd6e26642822d9$export$73d7d20cc3ab1cab);
$parcel$export(module.exports, "FlowGraphAtan2Block", () => $49cd6e26642822d9$export$8955ee13ce0272db);
$parcel$export(module.exports, "FlowGraphSinhBlock", () => $49cd6e26642822d9$export$551b8edbdba12487);
$parcel$export(module.exports, "FlowGraphCoshBlock", () => $49cd6e26642822d9$export$f7fc6eb8bb888068);
$parcel$export(module.exports, "FlowGraphTanhBlock", () => $49cd6e26642822d9$export$c21996949a1c62d);
$parcel$export(module.exports, "FlowGraphAsinhBlock", () => $49cd6e26642822d9$export$788a21daa3d986c1);
$parcel$export(module.exports, "FlowGraphAcoshBlock", () => $49cd6e26642822d9$export$cc4384bd65a78e70);
$parcel$export(module.exports, "FlowGraphAtanhBlock", () => $49cd6e26642822d9$export$97ae5bc0622ae992);
$parcel$export(module.exports, "FlowGraphExpBlock", () => $49cd6e26642822d9$export$ec6e00e1ba9c1c5e);
$parcel$export(module.exports, "FlowGraphLogBlock", () => $49cd6e26642822d9$export$c677b36d760a5721);
$parcel$export(module.exports, "FlowGraphLog2Block", () => $49cd6e26642822d9$export$511c2d2e1dd0777b);
$parcel$export(module.exports, "FlowGraphLog10Block", () => $49cd6e26642822d9$export$c8e355612df2e5d6);
$parcel$export(module.exports, "FlowGraphSqrtBlock", () => $49cd6e26642822d9$export$1ef92d60798c1860);
$parcel$export(module.exports, "FlowGraphCubeRootBlock", () => $49cd6e26642822d9$export$ba877de082bb5fa1);
$parcel$export(module.exports, "FlowGraphPowBlock", () => $49cd6e26642822d9$export$3924e059eeeae23);
$parcel$export(module.exports, "FlowGraphLengthBlock", () => $49cd6e26642822d9$export$53c255674fc93766);
$parcel$export(module.exports, "FlowGraphNormalizeBlock", () => $49cd6e26642822d9$export$3564e7b7c534dd99);
$parcel$export(module.exports, "FlowGraphCrossBlock", () => $49cd6e26642822d9$export$3454b1615c2e3382);
$parcel$export(module.exports, "FlowGraphRotate2DBlock", () => $49cd6e26642822d9$export$372bb687368e2bef);
$parcel$export(module.exports, "FlowGraphRotate3DBlock", () => $49cd6e26642822d9$export$5122a6dcd8bbacb4);
$parcel$export(module.exports, "FlowGraphTransposeBlock", () => $49cd6e26642822d9$export$cc3df2c2037d87ab);
$parcel$export(module.exports, "FlowGraphDeterminantBlock", () => $49cd6e26642822d9$export$6f4ad6156c3e7e76);
$parcel$export(module.exports, "FlowGraphInvertMatrixBlock", () => $49cd6e26642822d9$export$47dd52b64fd933c7);
$parcel$export(module.exports, "FlowGraphMatMulBlock", () => $49cd6e26642822d9$export$22bf98e8f373a5b4);
$parcel$export(module.exports, "FlowGraphBitwiseNotBlock", () => $49cd6e26642822d9$export$722f1060b88504c9);
$parcel$export(module.exports, "FlowGraphBitwiseAndBlock", () => $49cd6e26642822d9$export$6d5e3899048ab4e1);
$parcel$export(module.exports, "FlowGraphBitwiseOrBlock", () => $49cd6e26642822d9$export$4784bac3b250ff35);
$parcel$export(module.exports, "FlowGraphBitwiseXorBlock", () => $49cd6e26642822d9$export$3cae3cf2c2a6d59a);
$parcel$export(module.exports, "FlowGraphBitwiseLeftShiftBlock", () => $49cd6e26642822d9$export$c9577319c12f1354);
$parcel$export(module.exports, "FlowGraphBitwiseRightShiftBlock", () => $49cd6e26642822d9$export$ec05fa32852552f9);
$parcel$export(module.exports, "FlowGraphCountLeadingZerosBlock", () => $49cd6e26642822d9$export$1bcd84974a1e5a05);
$parcel$export(module.exports, "FlowGraphCountTrailingZerosBlock", () => $49cd6e26642822d9$export$eb022199b8e72f30);
$parcel$export(module.exports, "FlowGraphCountOneBitsBlock", () => $49cd6e26642822d9$export$da9702428fc8a255);

var $8DoUR = parcelRequire("8DoUR");

var $icNzP = parcelRequire("icNzP");

var $dF3Zi = parcelRequire("dF3Zi");

var $4BSN8 = parcelRequire("4BSN8");

var $ha1VO = parcelRequire("ha1VO");

var $exMJi = parcelRequire("exMJi");

var $8aupZ = parcelRequire("8aupZ");

var $daZRY = parcelRequire("daZRY");
/**
 * @internal
 */ function $49cd6e26642822d9$var$_getClassNameOf(v) {
    if (v.getClassName) return v.getClassName();
    return "";
}
/**
 * @internal
 * @returns
 */ function $49cd6e26642822d9$var$_areSameVectorClass(className, className2) {
    return className === "Vector2" && className2 === "Vector2" || className === "Vector3" && className2 === "Vector3" || className === "Vector4" && className2 === "Vector4";
}
/**
 * @internal
 * @returns
 */ function $49cd6e26642822d9$var$_areSameMatrixClass(className, className2) {
    return className === "Matrix" && className2 === "Matrix";
}
/**
 * @internal
 * @returns
 */ function $49cd6e26642822d9$var$_areSameIntegerClass(className, className2) {
    return className === "FlowGraphInteger" && className2 === "FlowGraphInteger";
}
class $49cd6e26642822d9$export$1c9df5407fa63eb1 extends (0, $dF3Zi.FlowGraphBinaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (a, b)=>this._polymorphicAdd(a, b), $49cd6e26642822d9$export$1c9df5407fa63eb1.ClassName, config);
    }
    _polymorphicAdd(a, b) {
        const aClassName = $49cd6e26642822d9$var$_getClassNameOf(a);
        const bClassName = $49cd6e26642822d9$var$_getClassNameOf(b);
        if ($49cd6e26642822d9$var$_areSameVectorClass(aClassName, bClassName) || $49cd6e26642822d9$var$_areSameMatrixClass(aClassName, bClassName) || $49cd6e26642822d9$var$_areSameIntegerClass(aClassName, bClassName)) return a.add(b);
        else return a + b;
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$1c9df5407fa63eb1.ClassName = "FGAddBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$1c9df5407fa63eb1.ClassName, $49cd6e26642822d9$export$1c9df5407fa63eb1);
class $49cd6e26642822d9$export$f785ac4c5b6ff594 extends (0, $dF3Zi.FlowGraphBinaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (a, b)=>this._polymorphicAdd(a, b), $49cd6e26642822d9$export$f785ac4c5b6ff594.ClassName, config);
    }
    _polymorphicAdd(a, b) {
        const aClassName = $49cd6e26642822d9$var$_getClassNameOf(a);
        const bClassName = $49cd6e26642822d9$var$_getClassNameOf(b);
        if ($49cd6e26642822d9$var$_areSameVectorClass(aClassName, bClassName) || $49cd6e26642822d9$var$_areSameIntegerClass(aClassName, bClassName)) return a.subtract(b);
        else if ($49cd6e26642822d9$var$_areSameMatrixClass(aClassName, bClassName)) return a.add(b.scale(-1));
        else return a - b;
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$f785ac4c5b6ff594.ClassName = "FGSubBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$f785ac4c5b6ff594.ClassName, $49cd6e26642822d9$export$f785ac4c5b6ff594);
class $49cd6e26642822d9$export$7bad4f5befb46ff5 extends (0, $dF3Zi.FlowGraphBinaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (a, b)=>this._polymorphicMultiply(a, b), $49cd6e26642822d9$export$7bad4f5befb46ff5.ClassName, config);
    }
    _polymorphicMultiply(a, b) {
        const aClassName = $49cd6e26642822d9$var$_getClassNameOf(a);
        const bClassName = $49cd6e26642822d9$var$_getClassNameOf(b);
        if ($49cd6e26642822d9$var$_areSameVectorClass(aClassName, bClassName) || $49cd6e26642822d9$var$_areSameIntegerClass(aClassName, bClassName)) return a.multiply(b);
        else if ($49cd6e26642822d9$var$_areSameMatrixClass(aClassName, bClassName)) return (0, $ha1VO.Matrix).FromValues(a.m[0] * b.m[0], a.m[4] * b.m[4], a.m[8] * b.m[8], a.m[12] * b.m[12], a.m[1] * b.m[1], a.m[5] * b.m[5], a.m[9] * b.m[9], a.m[13] * b.m[13], a.m[2] * b.m[2], a.m[6] * b.m[6], a.m[10] * b.m[10], a.m[14] * b.m[14], a.m[3] * b.m[3], a.m[7] * b.m[7], a.m[11] * b.m[11], a.m[15] * b.m[15]);
        else return a * b;
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$7bad4f5befb46ff5.ClassName = "FGMultiplyBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$7bad4f5befb46ff5.ClassName, $49cd6e26642822d9$export$7bad4f5befb46ff5);
class $49cd6e26642822d9$export$ea9877efa53a72a7 extends (0, $dF3Zi.FlowGraphBinaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (a, b)=>this._polymorphicDivide(a, b), $49cd6e26642822d9$export$ea9877efa53a72a7.ClassName, config);
    }
    _polymorphicDivide(a, b) {
        const aClassName = $49cd6e26642822d9$var$_getClassNameOf(a);
        const bClassName = $49cd6e26642822d9$var$_getClassNameOf(b);
        if ($49cd6e26642822d9$var$_areSameVectorClass(aClassName, bClassName) || $49cd6e26642822d9$var$_areSameIntegerClass(aClassName, bClassName)) return a.divide(b);
        else if ($49cd6e26642822d9$var$_areSameMatrixClass(aClassName, bClassName)) return (0, $ha1VO.Matrix).FromValues(a.m[0] / b.m[0], a.m[4] / b.m[4], a.m[8] / b.m[8], a.m[12] / b.m[12], a.m[1] / b.m[1], a.m[5] / b.m[5], a.m[9] / b.m[9], a.m[13] / b.m[13], a.m[2] / b.m[2], a.m[6] / b.m[6], a.m[10] / b.m[10], a.m[14] / b.m[14], a.m[3] / b.m[3], a.m[7] / b.m[7], a.m[11] / b.m[11], a.m[15] / b.m[15]);
        else return a / b;
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$ea9877efa53a72a7.ClassName = "FGDivideBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$ea9877efa53a72a7.ClassName, $49cd6e26642822d9$export$ea9877efa53a72a7);
class $49cd6e26642822d9$export$b8972610b9885af0 extends (0, $4BSN8.FlowGraphConstantOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeNumber), ()=>Math.random(), $49cd6e26642822d9$export$b8972610b9885af0.ClassName, config);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$b8972610b9885af0.ClassName = "FGRandomBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$b8972610b9885af0.ClassName, $49cd6e26642822d9$export$b8972610b9885af0);
class $49cd6e26642822d9$export$66a9fda16f53ff13 extends (0, $dF3Zi.FlowGraphBinaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeNumber), (a, b)=>this._polymorphicDot(a, b), $49cd6e26642822d9$export$66a9fda16f53ff13.ClassName, config);
    }
    _polymorphicDot(a, b) {
        const className = $49cd6e26642822d9$var$_getClassNameOf(a);
        switch(className){
            case "Vector2":
                return (0, $ha1VO.Vector2).Dot(a, b);
            case "Vector3":
                return (0, $ha1VO.Vector3).Dot(a, b);
            case "Vector4":
                return (0, $ha1VO.Vector4).Dot(a, b);
            default:
                throw new Error(`Cannot get dot product of ${a} and ${b}`);
        }
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$66a9fda16f53ff13.ClassName = "FGDotBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$66a9fda16f53ff13.ClassName, $49cd6e26642822d9$export$66a9fda16f53ff13);
class $49cd6e26642822d9$export$4e08d14682ef22f4 extends (0, $4BSN8.FlowGraphConstantOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeNumber), ()=>Math.E, $49cd6e26642822d9$export$4e08d14682ef22f4.ClassName, config);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$4e08d14682ef22f4.ClassName = "FGEBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$4e08d14682ef22f4.ClassName, $49cd6e26642822d9$export$4e08d14682ef22f4);
class $49cd6e26642822d9$export$9d61d2a810a358ad extends (0, $4BSN8.FlowGraphConstantOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeNumber), ()=>Math.PI, $49cd6e26642822d9$export$9d61d2a810a358ad.ClassName, config);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$9d61d2a810a358ad.ClassName = "FGPIBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$9d61d2a810a358ad.ClassName, $49cd6e26642822d9$export$9d61d2a810a358ad);
class $49cd6e26642822d9$export$5662445d1bc7af5b extends (0, $4BSN8.FlowGraphConstantOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeNumber), ()=>Number.POSITIVE_INFINITY, $49cd6e26642822d9$export$5662445d1bc7af5b.ClassName, config);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$5662445d1bc7af5b.ClassName = "FGInfBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$5662445d1bc7af5b.ClassName, $49cd6e26642822d9$export$5662445d1bc7af5b);
class $49cd6e26642822d9$export$bfa84e5a0554a0d9 extends (0, $4BSN8.FlowGraphConstantOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeNumber), ()=>Number.NaN, $49cd6e26642822d9$export$bfa84e5a0554a0d9.ClassName, config);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$bfa84e5a0554a0d9.ClassName = "FGNaNBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$bfa84e5a0554a0d9.ClassName, $49cd6e26642822d9$export$bfa84e5a0554a0d9);
function $49cd6e26642822d9$var$_componentWiseUnaryOperation(a, op) {
    const aClassName = $49cd6e26642822d9$var$_getClassNameOf(a);
    switch(aClassName){
        case "FlowGraphInteger":
            return new (0, $daZRY.FlowGraphInteger)(op(a.value));
        case "Vector2":
            return new (0, $ha1VO.Vector2)(op(a.x), op(a.y));
        case "Vector3":
            return new (0, $ha1VO.Vector3)(op(a.x), op(a.y), op(a.z));
        case "Vector4":
            return new (0, $ha1VO.Vector4)(op(a.x), op(a.y), op(a.z), op(a.w));
        case "Matrix":
            return (0, $ha1VO.Matrix).FromValues(op(a.m[0]), op(a.m[4]), op(a.m[8]), op(a.m[12]), op(a.m[1]), op(a.m[5]), op(a.m[9]), op(a.m[13]), op(a.m[2]), op(a.m[6]), op(a.m[10]), op(a.m[14]), op(a.m[3]), op(a.m[7]), op(a.m[11]), op(a.m[15]));
        default:
            return op(a);
    }
}
class $49cd6e26642822d9$export$27b656bf7fd5c63b extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (a)=>this._polymorphicAbs(a), $49cd6e26642822d9$export$27b656bf7fd5c63b.ClassName, config);
    }
    _polymorphicAbs(a) {
        return $49cd6e26642822d9$var$_componentWiseUnaryOperation(a, Math.abs);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$27b656bf7fd5c63b.ClassName = "FGAbsBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$27b656bf7fd5c63b.ClassName, $49cd6e26642822d9$export$27b656bf7fd5c63b);
class $49cd6e26642822d9$export$e1c80ad68024dfd6 extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (a)=>this._polymorphicSign(a), $49cd6e26642822d9$export$e1c80ad68024dfd6.ClassName, config);
    }
    _polymorphicSign(a) {
        return $49cd6e26642822d9$var$_componentWiseUnaryOperation(a, Math.sign);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$e1c80ad68024dfd6.ClassName = "FGSignBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$e1c80ad68024dfd6.ClassName, $49cd6e26642822d9$export$e1c80ad68024dfd6);
class $49cd6e26642822d9$export$c2a82b701348baee extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (a)=>this._polymorphicTrunc(a), $49cd6e26642822d9$export$c2a82b701348baee.ClassName, config);
    }
    _polymorphicTrunc(a) {
        return $49cd6e26642822d9$var$_componentWiseUnaryOperation(a, Math.trunc);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$c2a82b701348baee.ClassName = "FGTruncBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$c2a82b701348baee.ClassName, $49cd6e26642822d9$export$c2a82b701348baee);
class $49cd6e26642822d9$export$8d1a24be70bbb60d extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (a)=>this._polymorphicFloor(a), $49cd6e26642822d9$export$8d1a24be70bbb60d.ClassName, config);
    }
    _polymorphicFloor(a) {
        return $49cd6e26642822d9$var$_componentWiseUnaryOperation(a, Math.floor);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$8d1a24be70bbb60d.ClassName = "FGFloorBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$8d1a24be70bbb60d.ClassName, $49cd6e26642822d9$export$8d1a24be70bbb60d);
class $49cd6e26642822d9$export$aa9eb81f93f561ec extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (a)=>this._polymorphicCeiling(a), $49cd6e26642822d9$export$aa9eb81f93f561ec.ClassName, config);
    }
    _polymorphicCeiling(a) {
        return $49cd6e26642822d9$var$_componentWiseUnaryOperation(a, Math.ceil);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$aa9eb81f93f561ec.ClassName = "FGCeilBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$aa9eb81f93f561ec.ClassName, $49cd6e26642822d9$export$aa9eb81f93f561ec);
class $49cd6e26642822d9$export$2e2fd95ecdb83b69 extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (a)=>this._polymorphicFract(a), $49cd6e26642822d9$export$2e2fd95ecdb83b69.ClassName, config);
    }
    _polymorphicFract(a) {
        return $49cd6e26642822d9$var$_componentWiseUnaryOperation(a, (a)=>a - Math.floor(a));
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$2e2fd95ecdb83b69.ClassName = "FGFractBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$2e2fd95ecdb83b69.ClassName, $49cd6e26642822d9$export$2e2fd95ecdb83b69);
class $49cd6e26642822d9$export$1ca588783e2bd70 extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    /**
     * construct a new negation block.
     * @param config optional configuration
     */ constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (a)=>this._polymorphicNeg(a), $49cd6e26642822d9$export$1ca588783e2bd70.ClassName, config);
    }
    _polymorphicNeg(a) {
        return $49cd6e26642822d9$var$_componentWiseUnaryOperation(a, (a)=>-a);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$1ca588783e2bd70.ClassName = "FGNegBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$1ca588783e2bd70.ClassName, $49cd6e26642822d9$export$1ca588783e2bd70);
function $49cd6e26642822d9$var$_componentWiseBinaryOperation(a, b, op) {
    const aClassName = $49cd6e26642822d9$var$_getClassNameOf(a);
    switch(aClassName){
        case "FlowGraphInteger":
            return new (0, $daZRY.FlowGraphInteger)(op(a.value, b.value));
        case "Vector2":
            return new (0, $ha1VO.Vector2)(op(a.x, b.x), op(a.y, b.y));
        case "Vector3":
            return new (0, $ha1VO.Vector3)(op(a.x, b.x), op(a.y, b.y), op(a.z, b.z));
        case "Vector4":
            return new (0, $ha1VO.Vector4)(op(a.x, b.x), op(a.y, b.y), op(a.z, b.z), op(a.w, b.w));
        case "Matrix":
            return (0, $ha1VO.Matrix).FromValues(op(a.m[0], b.m[0]), op(a.m[4], b.m[4]), op(a.m[8], b.m[8]), op(a.m[12], b.m[12]), op(a.m[1], b.m[1]), op(a.m[5], b.m[5]), op(a.m[9], b.m[9]), op(a.m[13], b.m[13]), op(a.m[2], b.m[2]), op(a.m[6], b.m[6]), op(a.m[10], b.m[10]), op(a.m[14], b.m[14]), op(a.m[3], b.m[3]), op(a.m[7], b.m[7]), op(a.m[11], b.m[11]), op(a.m[15], b.m[15]));
        default:
            return op(a, b);
    }
}
class $49cd6e26642822d9$export$23253d72b008c34a extends (0, $dF3Zi.FlowGraphBinaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (a, b)=>this._polymorphicRemainder(a, b), $49cd6e26642822d9$export$23253d72b008c34a.ClassName, config);
    }
    _polymorphicRemainder(a, b) {
        return $49cd6e26642822d9$var$_componentWiseBinaryOperation(a, b, (a, b)=>a % b);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$23253d72b008c34a.ClassName = "FGRemainderBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$23253d72b008c34a.ClassName, $49cd6e26642822d9$export$23253d72b008c34a);
class $49cd6e26642822d9$export$36638dd4e8450dbc extends (0, $dF3Zi.FlowGraphBinaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (a, b)=>this._polymorphicMin(a, b), $49cd6e26642822d9$export$36638dd4e8450dbc.ClassName, config);
    }
    _polymorphicMin(a, b) {
        return $49cd6e26642822d9$var$_componentWiseBinaryOperation(a, b, Math.min);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$36638dd4e8450dbc.ClassName = "FGMinBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$36638dd4e8450dbc.ClassName, $49cd6e26642822d9$export$36638dd4e8450dbc);
class $49cd6e26642822d9$export$35333622e5f96927 extends (0, $dF3Zi.FlowGraphBinaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (a, b)=>this._polymorphicMax(a, b), $49cd6e26642822d9$export$35333622e5f96927.ClassName, config);
    }
    _polymorphicMax(a, b) {
        return $49cd6e26642822d9$var$_componentWiseBinaryOperation(a, b, Math.max);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$35333622e5f96927.ClassName = "FGMaxBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$35333622e5f96927.ClassName, $49cd6e26642822d9$export$35333622e5f96927);
function $49cd6e26642822d9$var$_clamp(a, b, c) {
    return Math.min(Math.max(a, Math.min(b, c)), Math.max(b, c));
}
function $49cd6e26642822d9$var$_componentWiseTernaryOperation(a, b, c, op) {
    const aClassName = $49cd6e26642822d9$var$_getClassNameOf(a);
    switch(aClassName){
        case "FlowGraphInteger":
            return new (0, $daZRY.FlowGraphInteger)(op(a.value, b.value, c.value));
        case "Vector2":
            return new (0, $ha1VO.Vector2)(op(a.x, b.x, c.x), op(a.y, b.y, c.y));
        case "Vector3":
            return new (0, $ha1VO.Vector3)(op(a.x, b.x, c.x), op(a.y, b.y, c.y), op(a.z, b.z, c.z));
        case "Vector4":
            return new (0, $ha1VO.Vector4)(op(a.x, b.x, c.x), op(a.y, b.y, c.y), op(a.z, b.z, c.z), op(a.w, b.w, c.w));
        case "Matrix":
            return (0, $ha1VO.Matrix).FromValues(op(a.m[0], b.m[0], c.m[0]), op(a.m[4], b.m[4], c.m[4]), op(a.m[8], b.m[8], c.m[8]), op(a.m[12], b.m[12], c.m[12]), op(a.m[1], b.m[1], c.m[1]), op(a.m[5], b.m[5], c.m[5]), op(a.m[9], b.m[9], c.m[9]), op(a.m[13], b.m[13], c.m[13]), op(a.m[2], b.m[2], c.m[2]), op(a.m[6], b.m[6], c.m[6]), op(a.m[10], b.m[10], c.m[10]), op(a.m[14], b.m[14], c.m[14]), op(a.m[3], b.m[3], c.m[3]), op(a.m[7], b.m[7], c.m[7]), op(a.m[11], b.m[11], c.m[11]), op(a.m[15], b.m[15], c.m[15]));
        default:
            return op(a, b, c);
    }
}
class $49cd6e26642822d9$export$942c407f61b903e8 extends (0, $8aupZ.FlowGraphTernaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (a, b, c)=>this._polymorphicClamp(a, b, c), $49cd6e26642822d9$export$942c407f61b903e8.ClassName, config);
    }
    _polymorphicClamp(a, b, c) {
        return $49cd6e26642822d9$var$_componentWiseTernaryOperation(a, b, c, $49cd6e26642822d9$var$_clamp);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$942c407f61b903e8.ClassName = "FGClampBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$942c407f61b903e8.ClassName, $49cd6e26642822d9$export$942c407f61b903e8);
function $49cd6e26642822d9$var$_saturate(a) {
    return Math.min(Math.max(a, 0), 1);
}
class $49cd6e26642822d9$export$768c089fcf42565e extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (a)=>this._polymorphicSaturate(a), $49cd6e26642822d9$export$768c089fcf42565e.ClassName, config);
    }
    _polymorphicSaturate(a) {
        return $49cd6e26642822d9$var$_componentWiseUnaryOperation(a, $49cd6e26642822d9$var$_saturate);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$768c089fcf42565e.ClassName = "FGSaturateBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$768c089fcf42565e.ClassName, $49cd6e26642822d9$export$768c089fcf42565e);
class $49cd6e26642822d9$export$585d692eb527396a extends (0, $8aupZ.FlowGraphTernaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (a, b, c)=>this._polymorphicInterpolate(a, b, c), $49cd6e26642822d9$export$585d692eb527396a.ClassName, config);
    }
    _interpolate(a, b, c) {
        return (1 - c) * a + c * b;
    }
    _polymorphicInterpolate(a, b, c) {
        return $49cd6e26642822d9$var$_componentWiseTernaryOperation(a, b, c, this._interpolate);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$585d692eb527396a.ClassName = "FGInterpolateBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$585d692eb527396a.ClassName, $49cd6e26642822d9$export$585d692eb527396a);
class $49cd6e26642822d9$export$1e5e8f70b0fbef28 extends (0, $dF3Zi.FlowGraphBinaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeBoolean), (a, b)=>this._polymorphicEq(a, b), $49cd6e26642822d9$export$1e5e8f70b0fbef28.ClassName, config);
    }
    _polymorphicEq(a, b) {
        const aClassName = $49cd6e26642822d9$var$_getClassNameOf(a);
        const bClassName = $49cd6e26642822d9$var$_getClassNameOf(b);
        if ($49cd6e26642822d9$var$_areSameVectorClass(aClassName, bClassName) || $49cd6e26642822d9$var$_areSameMatrixClass(aClassName, bClassName) || $49cd6e26642822d9$var$_areSameIntegerClass(aClassName, bClassName)) return a.equals(b);
        else return a === b;
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$1e5e8f70b0fbef28.ClassName = "FGEqBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$1e5e8f70b0fbef28.ClassName, $49cd6e26642822d9$export$1e5e8f70b0fbef28);
function $49cd6e26642822d9$var$_comparisonOperators(a, b, op) {
    const aClassName = $49cd6e26642822d9$var$_getClassNameOf(a);
    const bClassName = $49cd6e26642822d9$var$_getClassNameOf(b);
    if (aClassName === bClassName) {
        // float
        if (aClassName === "") return op(a, b);
        else if (aClassName === "FlowGraphInteger") return op(a.value, b.value);
        else throw new Error(`Cannot compare ${a} and ${b}`);
    }
    throw new Error(`${a} and ${b} are of different types.`);
}
class $49cd6e26642822d9$export$899c0a6b8e7a8d11 extends (0, $dF3Zi.FlowGraphBinaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeBoolean), (a, b)=>this._polymorphicLessThan(a, b), $49cd6e26642822d9$export$899c0a6b8e7a8d11.ClassName, config);
    }
    _polymorphicLessThan(a, b) {
        return $49cd6e26642822d9$var$_comparisonOperators(a, b, (a, b)=>a < b);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$899c0a6b8e7a8d11.ClassName = "FGLessThanBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$899c0a6b8e7a8d11.ClassName, $49cd6e26642822d9$export$899c0a6b8e7a8d11);
class $49cd6e26642822d9$export$abfbed545f37caa6 extends (0, $dF3Zi.FlowGraphBinaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeBoolean), (a, b)=>this._polymorphicLessThanOrEqual(a, b), $49cd6e26642822d9$export$abfbed545f37caa6.ClassName, config);
    }
    _polymorphicLessThanOrEqual(a, b) {
        return $49cd6e26642822d9$var$_comparisonOperators(a, b, (a, b)=>a <= b);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$abfbed545f37caa6.ClassName = "FGLessThanOrEqualBlock";
class $49cd6e26642822d9$export$c225c70437b84d44 extends (0, $dF3Zi.FlowGraphBinaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeBoolean), (a, b)=>this._polymorphicGreaterThan(a, b), $49cd6e26642822d9$export$c225c70437b84d44.ClassName, config);
    }
    _polymorphicGreaterThan(a, b) {
        return $49cd6e26642822d9$var$_comparisonOperators(a, b, (a, b)=>a > b);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$c225c70437b84d44.ClassName = "FGGreaterThanBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$c225c70437b84d44.ClassName, $49cd6e26642822d9$export$c225c70437b84d44);
class $49cd6e26642822d9$export$7675ce5b528f3305 extends (0, $dF3Zi.FlowGraphBinaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeBoolean), (a, b)=>this._polymorphicGreaterThanOrEqual(a, b), $49cd6e26642822d9$export$7675ce5b528f3305.ClassName, config);
    }
    _polymorphicGreaterThanOrEqual(a, b) {
        return $49cd6e26642822d9$var$_comparisonOperators(a, b, (a, b)=>a >= b);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$7675ce5b528f3305.ClassName = "FGGreaterThanOrEqualBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$7675ce5b528f3305.ClassName, $49cd6e26642822d9$export$7675ce5b528f3305);
class $49cd6e26642822d9$export$979d378ff365aede extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeBoolean), (a)=>this._polymorphicIsNan(a), $49cd6e26642822d9$export$979d378ff365aede.ClassName, config);
    }
    _polymorphicIsNan(a) {
        const aClassName = $49cd6e26642822d9$var$_getClassNameOf(a);
        if (aClassName === "") return isNaN(a);
        else if (aClassName === "FlowGraphInteger") return isNaN(a.value);
        else throw new Error(`Cannot get NaN of ${a}`);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$979d378ff365aede.ClassName = "FGIsNanBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$979d378ff365aede.ClassName, $49cd6e26642822d9$export$979d378ff365aede);
class $49cd6e26642822d9$export$27e4181a18e6cccc extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeBoolean), (a)=>this._polymorphicIsInf(a), $49cd6e26642822d9$export$27e4181a18e6cccc.ClassName, config);
    }
    _polymorphicIsInf(a) {
        const aClassName = $49cd6e26642822d9$var$_getClassNameOf(a);
        if (aClassName === "") return !isFinite(a);
        else if (aClassName === "FlowGraphInteger") return !isFinite(a.value);
        else throw new Error(`Cannot get isInf of ${a}`);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$27e4181a18e6cccc.ClassName = "FGIsInfBlock";
class $49cd6e26642822d9$export$c9fdf4115ee06aa9 extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (a)=>this._polymorphicDegToRad(a), $49cd6e26642822d9$export$c9fdf4115ee06aa9.ClassName, config);
    }
    _degToRad(a) {
        return a * Math.PI / 180;
    }
    _polymorphicDegToRad(a) {
        return $49cd6e26642822d9$var$_componentWiseUnaryOperation(a, this._degToRad);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$c9fdf4115ee06aa9.ClassName = "FGDegToRadBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$c9fdf4115ee06aa9.ClassName, $49cd6e26642822d9$export$c9fdf4115ee06aa9);
class $49cd6e26642822d9$export$159e38831eec233 extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (a)=>this._polymorphicRadToDeg(a), $49cd6e26642822d9$export$159e38831eec233.ClassName, config);
    }
    _radToDeg(a) {
        return a * 180 / Math.PI;
    }
    _polymorphicRadToDeg(a) {
        return $49cd6e26642822d9$var$_componentWiseUnaryOperation(a, this._radToDeg);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$159e38831eec233.ClassName = "FGRadToDegBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$159e38831eec233.ClassName, $49cd6e26642822d9$export$159e38831eec233);
class $49cd6e26642822d9$export$28fc3e81879c462c extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (a)=>this._polymorphicSin(a), $49cd6e26642822d9$export$28fc3e81879c462c.ClassName, config);
    }
    _polymorphicSin(a) {
        return $49cd6e26642822d9$var$_componentWiseUnaryOperation(a, Math.sin);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$28fc3e81879c462c.ClassName = "FGSinBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$28fc3e81879c462c.ClassName, $49cd6e26642822d9$export$28fc3e81879c462c);
class $49cd6e26642822d9$export$b653437c98324ed extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (a)=>this._polymorphicCos(a), $49cd6e26642822d9$export$b653437c98324ed.ClassName, config);
    }
    _polymorphicCos(a) {
        return $49cd6e26642822d9$var$_componentWiseUnaryOperation(a, Math.cos);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$b653437c98324ed.ClassName = "FGCosBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$b653437c98324ed.ClassName, $49cd6e26642822d9$export$b653437c98324ed);
class $49cd6e26642822d9$export$51aa0c7d9402210f extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (a)=>this._polymorphicTan(a), $49cd6e26642822d9$export$51aa0c7d9402210f.ClassName, config);
    }
    _polymorphicTan(a) {
        return $49cd6e26642822d9$var$_componentWiseUnaryOperation(a, Math.tan);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$51aa0c7d9402210f.ClassName = "FGTanBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$51aa0c7d9402210f.ClassName, $49cd6e26642822d9$export$51aa0c7d9402210f);
class $49cd6e26642822d9$export$6366496c6550e148 extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (a)=>this._polymorphicAsin(a), $49cd6e26642822d9$export$6366496c6550e148.ClassName, config);
    }
    _polymorphicAsin(a) {
        return $49cd6e26642822d9$var$_componentWiseUnaryOperation(a, Math.asin);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$6366496c6550e148.ClassName = "FGAsinBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$6366496c6550e148.ClassName, $49cd6e26642822d9$export$6366496c6550e148);
class $49cd6e26642822d9$export$f39d60a0924a0e63 extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (a)=>this._polymorphicAcos(a), $49cd6e26642822d9$export$f39d60a0924a0e63.ClassName, config);
    }
    _polymorphicAcos(a) {
        return $49cd6e26642822d9$var$_componentWiseUnaryOperation(a, Math.acos);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$f39d60a0924a0e63.ClassName = "FGAcosBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$f39d60a0924a0e63.ClassName, $49cd6e26642822d9$export$f39d60a0924a0e63);
class $49cd6e26642822d9$export$73d7d20cc3ab1cab extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (a)=>this._polymorphicAtan(a), $49cd6e26642822d9$export$73d7d20cc3ab1cab.ClassName, config);
    }
    _polymorphicAtan(a) {
        return $49cd6e26642822d9$var$_componentWiseUnaryOperation(a, Math.atan);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$73d7d20cc3ab1cab.ClassName = "FGAtanBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$73d7d20cc3ab1cab.ClassName, $49cd6e26642822d9$export$73d7d20cc3ab1cab);
class $49cd6e26642822d9$export$8955ee13ce0272db extends (0, $dF3Zi.FlowGraphBinaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (a, b)=>this._polymorphicAtan2(a, b), $49cd6e26642822d9$export$8955ee13ce0272db.ClassName, config);
    }
    _polymorphicAtan2(a, b) {
        return $49cd6e26642822d9$var$_componentWiseBinaryOperation(a, b, Math.atan2);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$8955ee13ce0272db.ClassName = "FGAtan2Block";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$8955ee13ce0272db.ClassName, $49cd6e26642822d9$export$8955ee13ce0272db);
class $49cd6e26642822d9$export$551b8edbdba12487 extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (a)=>this._polymorphicSinh(a), $49cd6e26642822d9$export$551b8edbdba12487.ClassName, config);
    }
    _polymorphicSinh(a) {
        return $49cd6e26642822d9$var$_componentWiseUnaryOperation(a, Math.sinh);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$551b8edbdba12487.ClassName = "FGSinhBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$551b8edbdba12487.ClassName, $49cd6e26642822d9$export$551b8edbdba12487);
class $49cd6e26642822d9$export$f7fc6eb8bb888068 extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (a)=>this._polymorphicCosh(a), $49cd6e26642822d9$export$f7fc6eb8bb888068.ClassName, config);
    }
    _polymorphicCosh(a) {
        return $49cd6e26642822d9$var$_componentWiseUnaryOperation(a, Math.cosh);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$f7fc6eb8bb888068.ClassName = "FGCoshBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$f7fc6eb8bb888068.ClassName, $49cd6e26642822d9$export$f7fc6eb8bb888068);
class $49cd6e26642822d9$export$c21996949a1c62d extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (a)=>this._polymorphicTanh(a), $49cd6e26642822d9$export$c21996949a1c62d.ClassName, config);
    }
    _polymorphicTanh(a) {
        return $49cd6e26642822d9$var$_componentWiseUnaryOperation(a, Math.tanh);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$c21996949a1c62d.ClassName = "FGTanhBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$c21996949a1c62d.ClassName, $49cd6e26642822d9$export$c21996949a1c62d);
class $49cd6e26642822d9$export$788a21daa3d986c1 extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeNumber), (a)=>this._polymorphicAsinh(a), $49cd6e26642822d9$export$788a21daa3d986c1.ClassName, config);
    }
    _polymorphicAsinh(a) {
        return $49cd6e26642822d9$var$_componentWiseUnaryOperation(a, Math.asinh);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$788a21daa3d986c1.ClassName = "FGAsinhBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$788a21daa3d986c1.ClassName, $49cd6e26642822d9$export$788a21daa3d986c1);
class $49cd6e26642822d9$export$cc4384bd65a78e70 extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeNumber), (a)=>this._polymorphicAcosh(a), $49cd6e26642822d9$export$cc4384bd65a78e70.ClassName, config);
    }
    _polymorphicAcosh(a) {
        return $49cd6e26642822d9$var$_componentWiseUnaryOperation(a, Math.acosh);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$cc4384bd65a78e70.ClassName = "FGAcoshBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$cc4384bd65a78e70.ClassName, $49cd6e26642822d9$export$cc4384bd65a78e70);
class $49cd6e26642822d9$export$97ae5bc0622ae992 extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeNumber), (a)=>this._polymorphicAtanh(a), $49cd6e26642822d9$export$97ae5bc0622ae992.ClassName, config);
    }
    _polymorphicAtanh(a) {
        return $49cd6e26642822d9$var$_componentWiseUnaryOperation(a, Math.atanh);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$97ae5bc0622ae992.ClassName = "FGAtanhBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$97ae5bc0622ae992.ClassName, $49cd6e26642822d9$export$97ae5bc0622ae992);
class $49cd6e26642822d9$export$ec6e00e1ba9c1c5e extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeNumber), (a)=>this._polymorphicExp(a), $49cd6e26642822d9$export$ec6e00e1ba9c1c5e.ClassName, config);
    }
    _polymorphicExp(a) {
        return $49cd6e26642822d9$var$_componentWiseUnaryOperation(a, Math.exp);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$ec6e00e1ba9c1c5e.ClassName = "FGExpBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$ec6e00e1ba9c1c5e.ClassName, $49cd6e26642822d9$export$ec6e00e1ba9c1c5e);
class $49cd6e26642822d9$export$c677b36d760a5721 extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeNumber), (a)=>this._polymorphicLog(a), $49cd6e26642822d9$export$c677b36d760a5721.ClassName, config);
    }
    _polymorphicLog(a) {
        return $49cd6e26642822d9$var$_componentWiseUnaryOperation(a, Math.log);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$c677b36d760a5721.ClassName = "FGLogBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$c677b36d760a5721.ClassName, $49cd6e26642822d9$export$c677b36d760a5721);
class $49cd6e26642822d9$export$511c2d2e1dd0777b extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeNumber), (a)=>this._polymorphicLog2(a), $49cd6e26642822d9$export$511c2d2e1dd0777b.ClassName, config);
    }
    _polymorphicLog2(a) {
        return $49cd6e26642822d9$var$_componentWiseUnaryOperation(a, Math.log2);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$511c2d2e1dd0777b.ClassName = "FGLog2Block";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$511c2d2e1dd0777b.ClassName, $49cd6e26642822d9$export$511c2d2e1dd0777b);
class $49cd6e26642822d9$export$c8e355612df2e5d6 extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeNumber), (a)=>this._polymorphicLog10(a), $49cd6e26642822d9$export$c8e355612df2e5d6.ClassName, config);
    }
    _polymorphicLog10(a) {
        return $49cd6e26642822d9$var$_componentWiseUnaryOperation(a, Math.log10);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$c8e355612df2e5d6.ClassName = "FGLog10Block";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$c8e355612df2e5d6.ClassName, $49cd6e26642822d9$export$c8e355612df2e5d6);
class $49cd6e26642822d9$export$1ef92d60798c1860 extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeNumber), (a)=>this._polymorphicSqrt(a), $49cd6e26642822d9$export$1ef92d60798c1860.ClassName, config);
    }
    _polymorphicSqrt(a) {
        return $49cd6e26642822d9$var$_componentWiseUnaryOperation(a, Math.sqrt);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$1ef92d60798c1860.ClassName = "FGSqrtBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$1ef92d60798c1860.ClassName, $49cd6e26642822d9$export$1ef92d60798c1860);
class $49cd6e26642822d9$export$ba877de082bb5fa1 extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeNumber), (a)=>this._polymorphicCubeRoot(a), $49cd6e26642822d9$export$ba877de082bb5fa1.ClassName, config);
    }
    _polymorphicCubeRoot(a) {
        return $49cd6e26642822d9$var$_componentWiseUnaryOperation(a, Math.cbrt);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$ba877de082bb5fa1.ClassName = "FGCubeRootBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$ba877de082bb5fa1.ClassName, $49cd6e26642822d9$export$ba877de082bb5fa1);
class $49cd6e26642822d9$export$3924e059eeeae23 extends (0, $dF3Zi.FlowGraphBinaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeNumber), (0, $icNzP.RichTypeNumber), (a, b)=>this._polymorphicPow(a, b), $49cd6e26642822d9$export$3924e059eeeae23.ClassName, config);
    }
    _polymorphicPow(a, b) {
        return $49cd6e26642822d9$var$_componentWiseBinaryOperation(a, b, Math.pow);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$3924e059eeeae23.ClassName = "FGPowBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$3924e059eeeae23.ClassName, $49cd6e26642822d9$export$3924e059eeeae23);
class $49cd6e26642822d9$export$53c255674fc93766 extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeNumber), (a)=>this._polymorphicLength(a), $49cd6e26642822d9$export$53c255674fc93766.ClassName, config);
    }
    _polymorphicLength(a) {
        const aClassName = $49cd6e26642822d9$var$_getClassNameOf(a);
        switch(aClassName){
            case "Vector2":
            case "Vector3":
            case "Vector4":
                return a.length();
            default:
                throw new Error(`Cannot compute length of value ${a}`);
        }
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$53c255674fc93766.ClassName = "FGLengthBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$53c255674fc93766.ClassName, $49cd6e26642822d9$export$53c255674fc93766);
class $49cd6e26642822d9$export$3564e7b7c534dd99 extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeAny), (0, $icNzP.RichTypeAny), (a)=>this._polymorphicNormalize(a), $49cd6e26642822d9$export$3564e7b7c534dd99.ClassName, config);
    }
    _polymorphicNormalize(a) {
        const aClassName = $49cd6e26642822d9$var$_getClassNameOf(a);
        switch(aClassName){
            case "Vector2":
            case "Vector3":
            case "Vector4":
                return a.normalize();
            default:
                throw new Error(`Cannot normalize value ${a}`);
        }
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$3564e7b7c534dd99.ClassName = "FGNormalizeBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$3564e7b7c534dd99.ClassName, $49cd6e26642822d9$export$3564e7b7c534dd99);
class $49cd6e26642822d9$export$3454b1615c2e3382 extends (0, $dF3Zi.FlowGraphBinaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeVector3), (0, $icNzP.RichTypeVector3), (0, $icNzP.RichTypeVector3), (a, b)=>(0, $ha1VO.Vector3).Cross(a, b), $49cd6e26642822d9$export$3454b1615c2e3382.ClassName, config);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$3454b1615c2e3382.ClassName = "FGCrossBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$3454b1615c2e3382.ClassName, $49cd6e26642822d9$export$3454b1615c2e3382);
class $49cd6e26642822d9$export$372bb687368e2bef extends (0, $dF3Zi.FlowGraphBinaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeVector2), (0, $icNzP.RichTypeNumber), (0, $icNzP.RichTypeVector2), (a, b)=>(0, $ha1VO.Vector2).Transform(a, (0, $ha1VO.Matrix).RotationZ(b)), $49cd6e26642822d9$export$372bb687368e2bef.ClassName, config);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$372bb687368e2bef.ClassName = "FGRotate2DBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$372bb687368e2bef.ClassName, $49cd6e26642822d9$export$372bb687368e2bef);
class $49cd6e26642822d9$export$5122a6dcd8bbacb4 extends (0, $8aupZ.FlowGraphTernaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeVector3), (0, $icNzP.RichTypeVector3), (0, $icNzP.RichTypeNumber), (0, $icNzP.RichTypeVector3), (a, b, c)=>(0, $ha1VO.Vector3).TransformCoordinates(a, (0, $ha1VO.Matrix).RotationAxis(b, c)), $49cd6e26642822d9$export$5122a6dcd8bbacb4.ClassName, config);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$5122a6dcd8bbacb4.ClassName = "FGRotate3DBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$5122a6dcd8bbacb4.ClassName, $49cd6e26642822d9$export$5122a6dcd8bbacb4);
class $49cd6e26642822d9$export$cc3df2c2037d87ab extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeMatrix), (0, $icNzP.RichTypeMatrix), (a)=>(0, $ha1VO.Matrix).Transpose(a), $49cd6e26642822d9$export$cc3df2c2037d87ab.ClassName, config);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$cc3df2c2037d87ab.ClassName = "FGTransposeBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$cc3df2c2037d87ab.ClassName, $49cd6e26642822d9$export$cc3df2c2037d87ab);
class $49cd6e26642822d9$export$6f4ad6156c3e7e76 extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeMatrix), (0, $icNzP.RichTypeNumber), (a)=>a.determinant(), $49cd6e26642822d9$export$6f4ad6156c3e7e76.ClassName, config);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$6f4ad6156c3e7e76.ClassName = "FGDeterminantBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$6f4ad6156c3e7e76.ClassName, $49cd6e26642822d9$export$6f4ad6156c3e7e76);
class $49cd6e26642822d9$export$47dd52b64fd933c7 extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeMatrix), (0, $icNzP.RichTypeMatrix), (a)=>(0, $ha1VO.Matrix).Invert(a), $49cd6e26642822d9$export$47dd52b64fd933c7.ClassName, config);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$47dd52b64fd933c7.ClassName = "FGInvertMatrixBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$47dd52b64fd933c7.ClassName, $49cd6e26642822d9$export$47dd52b64fd933c7);
class $49cd6e26642822d9$export$22bf98e8f373a5b4 extends (0, $dF3Zi.FlowGraphBinaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeMatrix), (0, $icNzP.RichTypeMatrix), (0, $icNzP.RichTypeMatrix), (a, b)=>b.multiply(a), $49cd6e26642822d9$export$22bf98e8f373a5b4.ClassName, config);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$22bf98e8f373a5b4.ClassName = "FGMatMulBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$22bf98e8f373a5b4.ClassName, $49cd6e26642822d9$export$22bf98e8f373a5b4);
class $49cd6e26642822d9$export$722f1060b88504c9 extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeFlowGraphInteger), (0, $icNzP.RichTypeFlowGraphInteger), (a)=>new (0, $daZRY.FlowGraphInteger)(~a.value), $49cd6e26642822d9$export$722f1060b88504c9.ClassName, config);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$722f1060b88504c9.ClassName = "FGBitwiseNotBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$722f1060b88504c9.ClassName, $49cd6e26642822d9$export$722f1060b88504c9);
class $49cd6e26642822d9$export$6d5e3899048ab4e1 extends (0, $dF3Zi.FlowGraphBinaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeFlowGraphInteger), (0, $icNzP.RichTypeFlowGraphInteger), (0, $icNzP.RichTypeFlowGraphInteger), (a, b)=>new (0, $daZRY.FlowGraphInteger)(a.value & b.value), $49cd6e26642822d9$export$6d5e3899048ab4e1.ClassName, config);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$6d5e3899048ab4e1.ClassName = "FGBitwiseAndBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$6d5e3899048ab4e1.ClassName, $49cd6e26642822d9$export$6d5e3899048ab4e1);
class $49cd6e26642822d9$export$4784bac3b250ff35 extends (0, $dF3Zi.FlowGraphBinaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeFlowGraphInteger), (0, $icNzP.RichTypeFlowGraphInteger), (0, $icNzP.RichTypeFlowGraphInteger), (a, b)=>new (0, $daZRY.FlowGraphInteger)(a.value | b.value), $49cd6e26642822d9$export$4784bac3b250ff35.ClassName, config);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$4784bac3b250ff35.ClassName = "FGBitwiseOrBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$4784bac3b250ff35.ClassName, $49cd6e26642822d9$export$4784bac3b250ff35);
class $49cd6e26642822d9$export$3cae3cf2c2a6d59a extends (0, $dF3Zi.FlowGraphBinaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeFlowGraphInteger), (0, $icNzP.RichTypeFlowGraphInteger), (0, $icNzP.RichTypeFlowGraphInteger), (a, b)=>new (0, $daZRY.FlowGraphInteger)(a.value ^ b.value), $49cd6e26642822d9$export$3cae3cf2c2a6d59a.ClassName, config);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$3cae3cf2c2a6d59a.ClassName = "FGBitwiseXorBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$3cae3cf2c2a6d59a.ClassName, $49cd6e26642822d9$export$3cae3cf2c2a6d59a);
class $49cd6e26642822d9$export$c9577319c12f1354 extends (0, $dF3Zi.FlowGraphBinaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeFlowGraphInteger), (0, $icNzP.RichTypeFlowGraphInteger), (0, $icNzP.RichTypeFlowGraphInteger), (a, b)=>new (0, $daZRY.FlowGraphInteger)(a.value << b.value), $49cd6e26642822d9$export$c9577319c12f1354.ClassName, config);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$c9577319c12f1354.ClassName = "FGBitwiseLeftShiftBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$c9577319c12f1354.ClassName, $49cd6e26642822d9$export$c9577319c12f1354);
class $49cd6e26642822d9$export$ec05fa32852552f9 extends (0, $dF3Zi.FlowGraphBinaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeFlowGraphInteger), (0, $icNzP.RichTypeFlowGraphInteger), (0, $icNzP.RichTypeFlowGraphInteger), (a, b)=>new (0, $daZRY.FlowGraphInteger)(a.value >> b.value), $49cd6e26642822d9$export$ec05fa32852552f9.ClassName, config);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$ec05fa32852552f9.ClassName = "FGBitwiseRightShiftBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$ec05fa32852552f9.ClassName, $49cd6e26642822d9$export$ec05fa32852552f9);
class $49cd6e26642822d9$export$1bcd84974a1e5a05 extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeFlowGraphInteger), (0, $icNzP.RichTypeFlowGraphInteger), (a)=>new (0, $daZRY.FlowGraphInteger)(Math.clz32(a.value)), $49cd6e26642822d9$export$1bcd84974a1e5a05.ClassName, config);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$1bcd84974a1e5a05.ClassName = "FGCountLeadingZerosBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$1bcd84974a1e5a05.ClassName, $49cd6e26642822d9$export$1bcd84974a1e5a05);
class $49cd6e26642822d9$export$eb022199b8e72f30 extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeFlowGraphInteger), (0, $icNzP.RichTypeFlowGraphInteger), (a)=>new (0, $daZRY.FlowGraphInteger)(a.value ? 31 - Math.clz32(a.value & -a.value) : 32), $49cd6e26642822d9$export$eb022199b8e72f30.ClassName, config);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$eb022199b8e72f30.ClassName = "FGCountTrailingZerosBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$eb022199b8e72f30.ClassName, $49cd6e26642822d9$export$eb022199b8e72f30);
/**
 * Given a number (which is converted to a 32-bit integer), return the
 * number of bits set to one on that number.
 * @internal
 * @param n
 */ function $49cd6e26642822d9$var$_countOnes(n) {
    let result = 0;
    while(n){
        // This zeroes out all bits except for the least significant one.
        // So if the bit is set, it will be 1, otherwise it will be 0.
        result += n & 1;
        // This shifts n's bits to the right by one
        n >>= 1;
    }
    return result;
}
class $49cd6e26642822d9$export$da9702428fc8a255 extends (0, $exMJi.FlowGraphUnaryOperationBlock) {
    constructor(config){
        super((0, $icNzP.RichTypeFlowGraphInteger), (0, $icNzP.RichTypeFlowGraphInteger), (a)=>new (0, $daZRY.FlowGraphInteger)($49cd6e26642822d9$var$_countOnes(a.value)), $49cd6e26642822d9$export$da9702428fc8a255.ClassName, config);
    }
}
/**
 * the class name of the block.
 */ $49cd6e26642822d9$export$da9702428fc8a255.ClassName = "FGCountOneBitsBlock";
(0, $8DoUR.RegisterClass)($49cd6e26642822d9$export$da9702428fc8a255.ClassName, $49cd6e26642822d9$export$da9702428fc8a255);

});
parcelRegister("4BSN8", function(module, exports) {

$parcel$export(module.exports, "FlowGraphConstantOperationBlock", () => $35b51e997d427690$export$c60019461bff8c8a);

var $djlXN = parcelRequire("djlXN");
class $35b51e997d427690$export$c60019461bff8c8a extends (0, $djlXN.FlowGraphCachedOperationBlock) {
    constructor(richType, _operation, _className, config){
        super(richType, config);
        this._operation = _operation;
        this._className = _className;
    }
    /**
     * the operation performed by this block
     * @param _context the graph context
     * @returns the result of the operation
     */ _doOperation(_context) {
        return this._operation();
    }
    /**
     * Gets the class name of this block
     * @returns the class name
     */ getClassName() {
        return this._className;
    }
}

});

parcelRegister("8aupZ", function(module, exports) {

$parcel$export(module.exports, "FlowGraphTernaryOperationBlock", () => $5f26da4fcde08a53$export$abb1b7dd6bb3cb0b);

var $djlXN = parcelRequire("djlXN");
class $5f26da4fcde08a53$export$abb1b7dd6bb3cb0b extends (0, $djlXN.FlowGraphCachedOperationBlock) {
    constructor(t1Type, t2Type, t3Type, resultRichType, _operation, _className, config){
        super(resultRichType, config);
        this._operation = _operation;
        this._className = _className;
        this.a = this.registerDataInput("a", t1Type);
        this.b = this.registerDataInput("b", t2Type);
        this.c = this.registerDataInput("c", t3Type);
    }
    /**
     * the operation performed by this block
     * @param context the graph context
     * @returns the result of the operation
     */ _doOperation(context) {
        return this._operation(this.a.getValue(context), this.b.getValue(context), this.c.getValue(context));
    }
    /**
     * Gets the class name of this block
     * @returns the class name
     */ getClassName() {
        return this._className;
    }
}

});




parcelRegister("bMtN3", function(module, exports) {

var $iqfT6 = parcelRequire("iqfT6");

var $cC86G = parcelRequire("cC86G");

var $hH5Pe = parcelRequire("hH5Pe");

var $dgCyM = parcelRequire("dgCyM");
$parcel$exportWildcard(module.exports, $iqfT6);
$parcel$exportWildcard(module.exports, $cC86G);
$parcel$exportWildcard(module.exports, $hH5Pe);
$parcel$exportWildcard(module.exports, $dgCyM);

});
parcelRegister("cC86G", function(module, exports) {

$parcel$export(module.exports, "FlowGraphSceneReadyEventBlock", () => $92ef527e5fc29f9d$export$17458c581d276c5d);

var $6wT1N = parcelRequire("6wT1N");

var $8DoUR = parcelRequire("8DoUR");
class $92ef527e5fc29f9d$export$17458c581d276c5d extends (0, $6wT1N.FlowGraphEventBlock) {
    /**
     * @internal
     */ _preparePendingTasks(context) {
        if (!context._getExecutionVariable(this, "sceneReadyObserver")) {
            const scene = context.configuration.scene;
            const contextObserver = scene.onReadyObservable.add(()=>{
                this._execute(context);
            });
            context._setExecutionVariable(this, "sceneReadyObserver", contextObserver);
        }
    }
    /**
     * @internal
     */ _cancelPendingTasks(context) {
        const contextObserver = context._getExecutionVariable(this, "sceneReadyObserver");
        const scene = context.configuration.scene;
        scene.onReadyObservable.remove(contextObserver);
        context._deleteExecutionVariable(this, "sceneReadyObserver");
    }
    /**
     * @returns class name of the block.
     */ getClassName() {
        return $92ef527e5fc29f9d$export$17458c581d276c5d.ClassName;
    }
}
/**
 * the class name of the block.
 */ $92ef527e5fc29f9d$export$17458c581d276c5d.ClassName = "FGSceneReadyEventBlock";
(0, $8DoUR.RegisterClass)("FGSceneReadyEventBlock", $92ef527e5fc29f9d$export$17458c581d276c5d);

});

parcelRegister("hH5Pe", function(module, exports) {

$parcel$export(module.exports, "FlowGraphReceiveCustomEventBlock", () => $ce1af898a3c2a896$export$95a371e4b315611b);

var $6wT1N = parcelRequire("6wT1N");

var $bOhSV = parcelRequire("bOhSV");

var $icNzP = parcelRequire("icNzP");

var $8DoUR = parcelRequire("8DoUR");
class $ce1af898a3c2a896$export$95a371e4b315611b extends (0, $6wT1N.FlowGraphEventBlock) {
    constructor(/**
     * the configuration of the block
     */ config){
        super(config);
        this.config = config;
        for(let i = 0; i < this.config.eventData.length; i++){
            const dataName = this.config.eventData[i];
            this.registerDataOutput(dataName, (0, $icNzP.RichTypeAny));
        }
    }
    _preparePendingTasks(context) {
        const observable = context.configuration.coordinator.getCustomEventObservable(this.config.eventId);
        this._eventObserver = observable.add((eventDatas)=>{
            for(let i = 0; i < eventDatas.length; i++)this.dataOutputs[i].setValue(eventDatas[i], context);
            this._execute(context);
        });
    }
    _cancelPendingTasks(context) {
        const observable = context.configuration.coordinator.getCustomEventObservable(this.config.eventId);
        if (observable) observable.remove(this._eventObserver);
        else (0, $bOhSV.Tools).Warn(`FlowGraphReceiveCustomEventBlock: Missing observable for event ${this.config.eventId}`);
    }
    /**
     * @returns class name of the block.
     */ getClassName() {
        return $ce1af898a3c2a896$export$95a371e4b315611b.ClassName;
    }
    /**
     * Serializes this block
     * @param serializationObject the object to serialize to
     */ serialize(serializationObject) {
        super.serialize(serializationObject);
        serializationObject.eventId = this.config.eventId;
        serializationObject.eventData = this.config.eventData;
    }
}
/**
 * the class name of the block.
 */ $ce1af898a3c2a896$export$95a371e4b315611b.ClassName = "FGReceiveCustomEventBlock";
(0, $8DoUR.RegisterClass)($ce1af898a3c2a896$export$95a371e4b315611b.ClassName, $ce1af898a3c2a896$export$95a371e4b315611b);

});

parcelRegister("dgCyM", function(module, exports) {

$parcel$export(module.exports, "FlowGraphSceneTickEventBlock", () => $9a8aae375498ad6b$export$a6f804a7377fbe5c);

var $6wT1N = parcelRequire("6wT1N");

var $8DoUR = parcelRequire("8DoUR");
class $9a8aae375498ad6b$export$a6f804a7377fbe5c extends (0, $6wT1N.FlowGraphEventBlock) {
    /**
     * @internal
     */ _preparePendingTasks(context) {
        if (!context._getExecutionVariable(this, "sceneBeforeRender")) {
            const scene = context.configuration.scene;
            const contextObserver = scene.onBeforeRenderObservable.add(()=>{
                this._execute(context);
            });
            context._setExecutionVariable(this, "sceneBeforeRender", contextObserver);
        }
    }
    /**
     * @internal
     */ _cancelPendingTasks(context) {
        const contextObserver = context._getExecutionVariable(this, "sceneBeforeRender");
        const scene = context.configuration.scene;
        scene.onBeforeRenderObservable.remove(contextObserver);
        context._deleteExecutionVariable(this, "sceneBeforeRender");
    }
    /**
     * @returns class name of the block.
     */ getClassName() {
        return $9a8aae375498ad6b$export$a6f804a7377fbe5c.ClassName;
    }
}
/**
 * the class name of the block.
 */ $9a8aae375498ad6b$export$a6f804a7377fbe5c.ClassName = "FGSceneTickEventBlock";
(0, $8DoUR.RegisterClass)($9a8aae375498ad6b$export$a6f804a7377fbe5c.ClassName, $9a8aae375498ad6b$export$a6f804a7377fbe5c);

});




parcelRegister("3mXOV", function(module, exports) {

var $kr5M3 = parcelRequire("kr5M3");
$parcel$exportWildcard(module.exports, $kr5M3);

});
parcelRegister("kr5M3", function(module, exports) {

});



parcelRegister("fZvDz", function(module, exports) {
$parcel$export(module.exports, "SceneFactory", () => (parcelRequire("keU3U")).SceneFactory);
parcelRequire("2qhVn");
parcelRequire("keU3U");

});
parcelRegister("2qhVn", function(module, exports) {

});

parcelRegister("keU3U", function(module, exports) {

$parcel$export(module.exports, "SceneFactory", () => $9b19a70b346fba65$export$4012b84193e1bb4d);
class $9b19a70b346fba65$export$4012b84193e1bb4d {
    static Register(ctor) {
        $9b19a70b346fba65$export$4012b84193e1bb4d._ctor = ctor;
    }
    static Create(canvas) {
        return new $9b19a70b346fba65$export$4012b84193e1bb4d._ctor(canvas);
    }
}

});


parcelRegister("a7fWI", function(module, exports) {
$parcel$export(module.exports, "AdvancedFreeCameraTouchInput", () => (parcelRequire("833Wh")).AdvancedFreeCameraTouchInput);
$parcel$export(module.exports, "AdvancedFreeCameraMouseInput", () => (parcelRequire("c8Dvh")).AdvancedFreeCameraMouseInput);
parcelRequire("2MRCP");
parcelRequire("c0RhK");
parcelRequire("9m8ks");
parcelRequire("jhgC4");
parcelRequire("gtixw");
parcelRequire("9A9WJ");
parcelRequire("8KjYx");
parcelRequire("51jh0");
parcelRequire("4GBc6");
parcelRequire("c2ImX");
parcelRequire("3A4pp");
parcelRequire("l5cba");
parcelRequire("iHRqj");
parcelRequire("6EBLR");
parcelRequire("83gFC");
parcelRequire("1jQgt");
parcelRequire("PPcK8");
parcelRequire("kXRIX");
parcelRequire("833Wh");
parcelRequire("7uWAj");
parcelRequire("lmFIW");
parcelRequire("cqnXm");
parcelRequire("ikpol");
parcelRequire("1PQEn");
parcelRequire("i0Jb4");
parcelRequire("8QJAY");
parcelRequire("fGMX5");
parcelRequire("c2m4L");
parcelRequire("aE3lw");
parcelRequire("fYuWo");
parcelRequire("l1N1P");
parcelRequire("hxmHs");
parcelRequire("cbA6Y");
parcelRequire("2y2Kf");
parcelRequire("jZmWP");
parcelRequire("c8Dvh");
parcelRequire("a67eV");
parcelRequire("gUs7h");
parcelRequire("b1o73");
parcelRequire("aNyYk");
parcelRequire("jw26v");
parcelRequire("dFcsz");
parcelRequire("9g0Cz");
parcelRequire("6rvpu");
parcelRequire("63ju2");

});
parcelRegister("2MRCP", function(module, exports) {

var $jkP6v = parcelRequire("jkP6v");

var $c0RhK = parcelRequire("c0RhK");
class $2079a9550684238f$export$80eafad46f8d7120 extends (0, $jkP6v.Button) {
    static CreateImageOnlyButton3D(name, imageUrl) {
        const result = new $2079a9550684238f$export$80eafad46f8d7120(name);
        // Adding image
        const image = new (0, $c0RhK.Image3D)(name + "_icon", imageUrl);
        // image.stretch = Image.STRETCH_FILL;
        // image.horizontalAlignment = Control.HORIZONTAL_ALIGNMENT_LEFT;
        result.addControl(image);
        // Store
        // @ts-ignore
        result._image = image;
        return result;
    }
}

});
parcelRegister("jkP6v", function(module, exports) {

$parcel$export(module.exports, "Button", () => $e13786c6252f9b33$export$353f5b6fc5456de1);

var $dwZRJ = parcelRequire("dwZRJ");

var $fCNdl = parcelRequire("fCNdl");

var $8wJXS = parcelRequire("8wJXS");

var $8puFn = parcelRequire("8puFn");

var $8DoUR = parcelRequire("8DoUR");
class $e13786c6252f9b33$export$353f5b6fc5456de1 extends (0, $dwZRJ.Rectangle) {
    /**
     * Returns the image part of the button (if any)
     */ get image() {
        return this._image;
    }
    /**
     * Returns the TextBlock part of the button (if any)
     */ get textBlock() {
        return this._textBlock;
    }
    /**
     * Creates a new Button
     * @param name defines the name of the button
     */ constructor(name){
        super(name);
        this.name = name;
        this.thickness = 1;
        this.isPointerBlocker = true;
        let alphaStore = null;
        this.pointerEnterAnimation = ()=>{
            alphaStore = this.alpha;
            this.alpha -= 0.1;
        };
        this.pointerOutAnimation = ()=>{
            if (alphaStore !== null) this.alpha = alphaStore;
        };
        this.pointerDownAnimation = ()=>{
            this.scaleX -= 0.05;
            this.scaleY -= 0.05;
        };
        this.pointerUpAnimation = ()=>{
            this.scaleX += 0.05;
            this.scaleY += 0.05;
        };
    }
    _getTypeName() {
        return "Button";
    }
    // While being a container, the button behaves like a control.
    /**
     * @internal
     */ _processPicking(x, y, pi, type, pointerId, buttonIndex, deltaX, deltaY) {
        if (!this._isEnabled || !this.isHitTestVisible || !this.isVisible || this.notRenderable) return false;
        if (!super.contains(x, y)) return false;
        if (this.delegatePickingToChildren) {
            let contains = false;
            for(let index = this._children.length - 1; index >= 0; index--){
                const child = this._children[index];
                if (child.isEnabled && child.isHitTestVisible && child.isVisible && !child.notRenderable && child.contains(x, y)) {
                    contains = true;
                    break;
                }
            }
            if (!contains) return false;
        }
        this._processObservables(type, x, y, pi, pointerId, buttonIndex, deltaX, deltaY);
        return true;
    }
    /**
     * @internal
     */ _onPointerEnter(target, pi) {
        if (!super._onPointerEnter(target, pi)) return false;
        if (!this.isReadOnly && this.pointerEnterAnimation) this.pointerEnterAnimation();
        return true;
    }
    /**
     * @internal
     */ _onPointerOut(target, pi, force = false) {
        if (!this.isReadOnly && this.pointerOutAnimation) this.pointerOutAnimation();
        super._onPointerOut(target, pi, force);
    }
    /**
     * @internal
     */ _onPointerDown(target, coordinates, pointerId, buttonIndex, pi) {
        if (!super._onPointerDown(target, coordinates, pointerId, buttonIndex, pi)) return false;
        if (!this.isReadOnly && this.pointerDownAnimation) this.pointerDownAnimation();
        return true;
    }
    _getRectangleFill(context) {
        if (this.isEnabled) return this._getBackgroundColor(context);
        else return this._disabledColor;
    }
    /**
     * @internal
     */ _onPointerUp(target, coordinates, pointerId, buttonIndex, notifyClick, pi) {
        if (!this.isReadOnly && this.pointerUpAnimation) this.pointerUpAnimation();
        super._onPointerUp(target, coordinates, pointerId, buttonIndex, notifyClick, pi);
    }
    /**
     * Serializes the current button
     * @param serializationObject defines the JSON serialized object
     * @param force force serialization even if isSerializable === false
     */ serialize(serializationObject, force) {
        super.serialize(serializationObject, force);
        if (!this.isSerializable && !force) return;
        if (this._textBlock) serializationObject.textBlockName = this._textBlock.name;
        if (this._image) serializationObject.imageName = this._image.name;
    }
    /**
     * @internal
     */ _parseFromContent(serializedObject, host) {
        super._parseFromContent(serializedObject, host);
        if (serializedObject.textBlockName) this._textBlock = this.getChildByName(serializedObject.textBlockName);
        if (serializedObject.imageName) this._image = this.getChildByName(serializedObject.imageName);
    }
    // Statics
    /**
     * Creates a new button made with an image and a text
     * @param name defines the name of the button
     * @param text defines the text of the button
     * @param imageUrl defines the url of the image
     * @returns a new Button
     */ static CreateImageButton(name, text, imageUrl) {
        const result = new this(name);
        // Adding text
        const textBlock = new (0, $8wJXS.TextBlock)(name + "_button", text);
        textBlock.textWrapping = true;
        textBlock.textHorizontalAlignment = (0, $fCNdl.Control).HORIZONTAL_ALIGNMENT_CENTER;
        textBlock.paddingLeft = "20%";
        result.addControl(textBlock);
        // Adding image
        const iconImage = new (0, $8puFn.Image)(name + "_icon", imageUrl);
        iconImage.width = "20%";
        iconImage.stretch = (0, $8puFn.Image).STRETCH_UNIFORM;
        iconImage.horizontalAlignment = (0, $fCNdl.Control).HORIZONTAL_ALIGNMENT_LEFT;
        result.addControl(iconImage);
        // Store
        result._image = iconImage;
        result._textBlock = textBlock;
        return result;
    }
    /**
     * Creates a new button made with an image
     * @param name defines the name of the button
     * @param imageUrl defines the url of the image
     * @returns a new Button
     */ static CreateImageOnlyButton(name, imageUrl) {
        const result = new this(name);
        // Adding image
        const iconImage = new (0, $8puFn.Image)(name + "_icon", imageUrl);
        iconImage.stretch = (0, $8puFn.Image).STRETCH_FILL;
        iconImage.horizontalAlignment = (0, $fCNdl.Control).HORIZONTAL_ALIGNMENT_LEFT;
        result.addControl(iconImage);
        // Store
        result._image = iconImage;
        return result;
    }
    /**
     * Creates a new button made with a text
     * @param name defines the name of the button
     * @param text defines the text of the button
     * @returns a new Button
     */ static CreateSimpleButton(name, text) {
        const result = new this(name);
        // Adding text
        const textBlock = new (0, $8wJXS.TextBlock)(name + "_button", text);
        textBlock.textWrapping = true;
        textBlock.textHorizontalAlignment = (0, $fCNdl.Control).HORIZONTAL_ALIGNMENT_CENTER;
        result.addControl(textBlock);
        // Store
        result._textBlock = textBlock;
        return result;
    }
    /**
     * Creates a new button made with an image and a centered text
     * @param name defines the name of the button
     * @param text defines the text of the button
     * @param imageUrl defines the url of the image
     * @returns a new Button
     */ static CreateImageWithCenterTextButton(name, text, imageUrl) {
        const result = new this(name);
        // Adding image
        const iconImage = new (0, $8puFn.Image)(name + "_icon", imageUrl);
        iconImage.stretch = (0, $8puFn.Image).STRETCH_FILL;
        result.addControl(iconImage);
        // Adding text
        const textBlock = new (0, $8wJXS.TextBlock)(name + "_button", text);
        textBlock.textWrapping = true;
        textBlock.textHorizontalAlignment = (0, $fCNdl.Control).HORIZONTAL_ALIGNMENT_CENTER;
        result.addControl(textBlock);
        // Store
        result._image = iconImage;
        result._textBlock = textBlock;
        return result;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.GUI.Button", $e13786c6252f9b33$export$353f5b6fc5456de1);

});
parcelRegister("dwZRJ", function(module, exports) {

$parcel$export(module.exports, "Rectangle", () => $9d9e40ba118a9f3c$export$4617fb02663045ef);

var $e0Suo = parcelRequire("e0Suo");

var $esuuG = parcelRequire("esuuG");

var $8DoUR = parcelRequire("8DoUR");

var $ir0rz = parcelRequire("ir0rz");
class $9d9e40ba118a9f3c$export$4617fb02663045ef extends (0, $esuuG.Container) {
    /** Gets or sets border thickness */ get thickness() {
        return this._thickness;
    }
    set thickness(value) {
        if (this._thickness === value) return;
        this._thickness = value;
        this._markAsDirty();
    }
    /** Gets or sets the corner radius of all angles */ get cornerRadius() {
        return this._cornerRadius[0];
    }
    set cornerRadius(value) {
        if (value < 0) value = 0;
        if (this._cornerRadius[0] === value && this._cornerRadius[1] === value && this._cornerRadius[2] === value && this._cornerRadius[3] === value) return;
        this._cornerRadius[0] = this._cornerRadius[1] = this._cornerRadius[2] = this._cornerRadius[3] = value;
        this._markAsDirty();
    }
    /** Gets or sets the corner radius top left angle */ get cornerRadiusX() {
        return this._cornerRadius[0];
    }
    set cornerRadiusX(value) {
        if (this._cornerRadius[0] === value) return;
        this._cornerRadius[0] = value;
    }
    /** Gets or sets the corner radius top right angle */ get cornerRadiusY() {
        return this._cornerRadius[1];
    }
    set cornerRadiusY(value) {
        if (this._cornerRadius[1] === value) return;
        this._cornerRadius[1] = value;
    }
    /** Gets or sets the corner radius bottom left angle */ get cornerRadiusZ() {
        return this._cornerRadius[2];
    }
    set cornerRadiusZ(value) {
        if (this._cornerRadius[2] === value) return;
        this._cornerRadius[2] = value;
    }
    /** Gets or sets the corner radius bottom right angle */ get cornerRadiusW() {
        return this._cornerRadius[3];
    }
    set cornerRadiusW(value) {
        if (this._cornerRadius[3] === value) return;
        this._cornerRadius[3] = value;
    }
    /**
     * Creates a new Rectangle
     * @param name defines the control name
     */ constructor(name){
        super(name);
        this.name = name;
        this._thickness = 1;
        this._cornerRadius = [
            0,
            0,
            0,
            0
        ];
        this._cachedRadius = [
            0,
            0,
            0,
            0
        ];
    }
    _getTypeName() {
        return "Rectangle";
    }
    /** @internal */ _computeAdditionalOffsetX() {
        let additionalWidth = 0;
        if (this._cornerRadius[0] !== 0 || this._cornerRadius[1] !== 0 || this._cornerRadius[2] !== 0 || this._cornerRadius[3] !== 0) // Take in account the aliasing
        additionalWidth += 1;
        if (this.thickness) additionalWidth += this.thickness / 2;
        return additionalWidth;
    }
    /** @internal */ _computeAdditionalOffsetY() {
        let additionalHeight = 0;
        if (this._cornerRadius[0] !== 0 || this._cornerRadius[1] !== 0 || this._cornerRadius[2] !== 0 || this._cornerRadius[3] !== 0) // Take in account the aliasing
        additionalHeight += 1;
        if (this.thickness) additionalHeight += this.thickness / 2;
        return additionalHeight;
    }
    _getRectangleFill(context) {
        return this._getBackgroundColor(context);
    }
    _localDraw(context) {
        context.save();
        if (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) {
            context.shadowColor = this.shadowColor;
            context.shadowBlur = this.shadowBlur;
            context.shadowOffsetX = this.shadowOffsetX;
            context.shadowOffsetY = this.shadowOffsetY;
        }
        if (this._background || this._backgroundGradient) {
            context.fillStyle = this._getRectangleFill(context);
            if (this._cornerRadius[0] !== 0 || this._cornerRadius[1] !== 0 || this._cornerRadius[2] !== 0 || this._cornerRadius[3] !== 0) {
                this._drawRoundedRect(context, this._thickness / 2);
                context.fill();
            } else context.fillRect(this._currentMeasure.left, this._currentMeasure.top, this._currentMeasure.width, this._currentMeasure.height);
        }
        if (this._thickness) {
            if (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) {
                context.shadowBlur = 0;
                context.shadowOffsetX = 0;
                context.shadowOffsetY = 0;
            }
            if (this.color || this.gradient) context.strokeStyle = this.gradient ? this.gradient.getCanvasGradient(context) : this.color;
            context.lineWidth = this._thickness;
            if (this._cornerRadius[0] !== 0 || this._cornerRadius[1] !== 0 || this._cornerRadius[2] !== 0 || this._cornerRadius[3] !== 0) {
                this._drawRoundedRect(context, this._thickness / 2);
                context.stroke();
            } else context.strokeRect(this._currentMeasure.left + this._thickness / 2, this._currentMeasure.top + this._thickness / 2, this._currentMeasure.width - this._thickness, this._currentMeasure.height - this._thickness);
        }
        context.restore();
    }
    _additionalProcessing(parentMeasure, context) {
        super._additionalProcessing(parentMeasure, context);
        this._measureForChildren.width -= 2 * this._thickness;
        this._measureForChildren.height -= 2 * this._thickness;
        this._measureForChildren.left += this._thickness;
        this._measureForChildren.top += this._thickness;
    }
    _drawRoundedRect(context, offset = 0) {
        const x = this._currentMeasure.left + offset;
        const y = this._currentMeasure.top + offset;
        const width = this._currentMeasure.width - offset * 2;
        const height = this._currentMeasure.height - offset * 2;
        for(let index = 0; index < this._cornerRadius.length; index++)this._cachedRadius[index] = Math.abs(Math.min(height / 2, Math.min(width / 2, this._cornerRadius[index])));
        context.beginPath();
        context.moveTo(x + this._cachedRadius[0], y);
        context.lineTo(x + width - this._cachedRadius[1], y);
        context.arc(x + width - this._cachedRadius[1], y + this._cachedRadius[1], this._cachedRadius[1], 3 * Math.PI / 2, Math.PI * 2);
        context.lineTo(x + width, y + height - this._cachedRadius[2]);
        context.arc(x + width - this._cachedRadius[2], y + height - this._cachedRadius[2], this._cachedRadius[2], 0, Math.PI / 2);
        context.lineTo(x + this._cachedRadius[3], y + height);
        context.arc(x + this._cachedRadius[3], y + height - this._cachedRadius[3], this._cachedRadius[3], Math.PI / 2, Math.PI);
        context.lineTo(x, y + this._cachedRadius[0]);
        context.arc(x + this._cachedRadius[0], y + this._cachedRadius[0], this._cachedRadius[0], Math.PI, 3 * Math.PI / 2);
        context.closePath();
    }
    _clipForChildren(context) {
        if (this._cornerRadius[0] !== 0 || this._cornerRadius[1] !== 0 || this._cornerRadius[2] !== 0 || this._cornerRadius[3] !== 0) {
            this._drawRoundedRect(context, this._thickness);
            context.clip();
        }
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9d9e40ba118a9f3c$export$4617fb02663045ef.prototype, "thickness", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9d9e40ba118a9f3c$export$4617fb02663045ef.prototype, "cornerRadius", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9d9e40ba118a9f3c$export$4617fb02663045ef.prototype, "cornerRadiusX", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9d9e40ba118a9f3c$export$4617fb02663045ef.prototype, "cornerRadiusY", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9d9e40ba118a9f3c$export$4617fb02663045ef.prototype, "cornerRadiusZ", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $9d9e40ba118a9f3c$export$4617fb02663045ef.prototype, "cornerRadiusW", null);
(0, $8DoUR.RegisterClass)("BABYLON.GUI.Rectangle", $9d9e40ba118a9f3c$export$4617fb02663045ef);

});
parcelRegister("esuuG", function(module, exports) {

$parcel$export(module.exports, "Container", () => $a86b55aad2faeec0$export$42a852a2b6b56249);

var $e0Suo = parcelRequire("e0Suo");

var $kVtWi = parcelRequire("kVtWi");

var $fCNdl = parcelRequire("fCNdl");

var $lFAVI = parcelRequire("lFAVI");

var $8DoUR = parcelRequire("8DoUR");

var $ir0rz = parcelRequire("ir0rz");

var $fJfwX = parcelRequire("fJfwX");

var $j2mX5 = parcelRequire("j2mX5");

var $gfKB2 = parcelRequire("gfKB2");

var $diGQf = parcelRequire("diGQf");

var $bOhSV = parcelRequire("bOhSV");

var $jqbkF = parcelRequire("jqbkF");
class $a86b55aad2faeec0$export$42a852a2b6b56249 extends (0, $fCNdl.Control) {
    /** Gets or sets boolean indicating if children should be rendered to an intermediate texture rather than directly to host, useful for alpha blending */ get renderToIntermediateTexture() {
        return this._renderToIntermediateTexture;
    }
    set renderToIntermediateTexture(value) {
        if (this._renderToIntermediateTexture === value) return;
        this._renderToIntermediateTexture = value;
        this._markAsDirty();
    }
    /** Gets or sets a boolean indicating if the container should try to adapt to its children height */ get adaptHeightToChildren() {
        return this._adaptHeightToChildren;
    }
    set adaptHeightToChildren(value) {
        if (this._adaptHeightToChildren === value) return;
        this._adaptHeightToChildren = value;
        if (value) this.height = "100%";
        this._markAsDirty();
    }
    /** Gets or sets a boolean indicating if the container should try to adapt to its children width */ get adaptWidthToChildren() {
        return this._adaptWidthToChildren;
    }
    set adaptWidthToChildren(value) {
        if (this._adaptWidthToChildren === value) return;
        this._adaptWidthToChildren = value;
        if (value) this.width = "100%";
        this._markAsDirty();
    }
    /** Gets or sets background color */ get background() {
        return this._background;
    }
    set background(value) {
        if (this._background === value) return;
        this._background = value;
        this._markAsDirty();
    }
    /** Gets or sets background gradient color. Takes precedence over background */ get backgroundGradient() {
        return this._backgroundGradient;
    }
    set backgroundGradient(value) {
        if (this._backgroundGradient === value) return;
        this._backgroundGradient = value;
        this._markAsDirty();
    }
    /** Gets the list of children */ get children() {
        return this._children;
    }
    get isReadOnly() {
        return this._isReadOnly;
    }
    set isReadOnly(value) {
        this._isReadOnly = value;
        for (const child of this._children)child.isReadOnly = value;
    }
    /**
     * Creates a new Container
     * @param name defines the name of the container
     */ constructor(name){
        super(name);
        this.name = name;
        /** @internal */ this._children = new Array();
        /** @internal */ this._measureForChildren = (0, $lFAVI.Measure).Empty();
        /** @internal */ this._background = "";
        /** @internal */ this._backgroundGradient = null;
        /** @internal */ this._adaptWidthToChildren = false;
        /** @internal */ this._adaptHeightToChildren = false;
        /** @internal */ this._renderToIntermediateTexture = false;
        /** @internal */ this._intermediateTexture = null;
        /**
         * Gets or sets a boolean indicating that the container will let internal controls handle picking instead of doing it directly using its bounding info
         */ this.delegatePickingToChildren = false;
        /**
         * Gets or sets a boolean indicating that layout cycle errors should be displayed on the console
         */ this.logLayoutCycleErrors = false;
        /**
         * Gets or sets the number of layout cycles (a change involved by a control while evaluating the layout) allowed
         */ this.maxLayoutCycle = 3;
        /**
         * An event triggered when any control is added to this container.
         */ this.onControlAddedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when any control is removed from this container.
         */ this.onControlRemovedObservable = new (0, $diGQf.Observable)();
        this._inverseTransformMatrix = (0, $jqbkF.Matrix2D).Identity();
        this._inverseMeasure = new (0, $lFAVI.Measure)(0, 0, 0, 0);
    }
    _getTypeName() {
        return "Container";
    }
    _flagDescendantsAsMatrixDirty() {
        for (const child of this.children){
            child._isClipped = false;
            child._markMatrixAsDirty();
        }
    }
    /**
     * Gets a child using its name
     * @param name defines the child name to look for
     * @returns the child control if found
     */ getChildByName(name) {
        for (const child of this.children){
            if (child.name === name) return child;
        }
        return null;
    }
    /**
     * Gets a child using its type and its name
     * @param name defines the child name to look for
     * @param type defines the child type to look for
     * @returns the child control if found
     */ getChildByType(name, type) {
        for (const child of this.children){
            if (child.typeName === type) return child;
        }
        return null;
    }
    /**
     * Search for a specific control in children
     * @param control defines the control to look for
     * @returns true if the control is in child list
     */ containsControl(control) {
        return this.children.indexOf(control) !== -1;
    }
    /**
     * Adds a new control to the current container
     * @param control defines the control to add
     * @returns the current container
     */ addControl(control) {
        if (!control) return this;
        const index = this._children.indexOf(control);
        if (index !== -1) return this;
        control._link(this._host);
        control._markAllAsDirty();
        this._reOrderControl(control);
        this._markAsDirty();
        this.onControlAddedObservable.notifyObservers(control);
        return this;
    }
    /**
     * Removes all controls from the current container
     * @returns the current container
     */ clearControls() {
        const children = this.children.slice();
        for (const child of children)this.removeControl(child);
        return this;
    }
    /**
     * Removes a control from the current container
     * @param control defines the control to remove
     * @returns the current container
     */ removeControl(control) {
        const index = this._children.indexOf(control);
        if (index !== -1) {
            this._children.splice(index, 1);
            control.parent = null;
        }
        control.linkWithMesh(null);
        if (this._host) this._host._cleanControlAfterRemoval(control);
        this._markAsDirty();
        this.onControlRemovedObservable.notifyObservers(control);
        return this;
    }
    /**
     * @internal
     */ _reOrderControl(control) {
        const linkedMesh = control.linkedMesh;
        this.removeControl(control);
        let wasAdded = false;
        for(let index = 0; index < this._children.length; index++)if (this._children[index].zIndex > control.zIndex) {
            this._children.splice(index, 0, control);
            wasAdded = true;
            break;
        }
        if (!wasAdded) this._children.push(control);
        control.parent = this;
        if (linkedMesh) control.linkWithMesh(linkedMesh);
        this._markAsDirty();
    }
    /**
     * @internal
     */ _offsetLeft(offset) {
        super._offsetLeft(offset);
        for (const child of this._children)child._offsetLeft(offset);
    }
    /**
     * @internal
     */ _offsetTop(offset) {
        super._offsetTop(offset);
        for (const child of this._children)child._offsetTop(offset);
    }
    /** @internal */ _markAllAsDirty() {
        super._markAllAsDirty();
        for(let index = 0; index < this._children.length; index++)this._children[index]._markAllAsDirty();
    }
    _getBackgroundColor(context) {
        return this._backgroundGradient ? this._backgroundGradient.getCanvasGradient(context) : this._background;
    }
    /**
     * @internal
     */ _localDraw(context) {
        if (this._background || this._backgroundGradient) {
            context.save();
            if (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) {
                context.shadowColor = this.shadowColor;
                context.shadowBlur = this.shadowBlur;
                context.shadowOffsetX = this.shadowOffsetX;
                context.shadowOffsetY = this.shadowOffsetY;
            }
            context.fillStyle = this._getBackgroundColor(context);
            context.fillRect(this._currentMeasure.left, this._currentMeasure.top, this._currentMeasure.width, this._currentMeasure.height);
            context.restore();
        }
    }
    /**
     * @internal
     */ _link(host) {
        super._link(host);
        for (const child of this._children)child._link(host);
    }
    /** @internal */ _beforeLayout() {
    // Do nothing
    }
    /**
     * @internal
     */ _processMeasures(parentMeasure, context) {
        if (this._isDirty || !this._cachedParentMeasure.isEqualsTo(parentMeasure)) {
            super._processMeasures(parentMeasure, context);
            this._evaluateClippingState(parentMeasure);
            if (this._renderToIntermediateTexture) {
                if (this._intermediateTexture && this._host.getScene() != this._intermediateTexture.getScene()) {
                    this._intermediateTexture.dispose();
                    this._intermediateTexture = null;
                }
                if (!this._intermediateTexture) {
                    this._intermediateTexture = new (0, $fJfwX.DynamicTexture)("", {
                        width: this._currentMeasure.width,
                        height: this._currentMeasure.height
                    }, this._host.getScene(), false, (0, $j2mX5.Texture).NEAREST_SAMPLINGMODE, (0, $gfKB2.Constants).TEXTUREFORMAT_RGBA, false);
                    this._intermediateTexture.hasAlpha = true;
                } else this._intermediateTexture.scaleTo(this._currentMeasure.width, this._currentMeasure.height);
            }
        }
    }
    /**
     * @internal
     */ _layout(parentMeasure, context) {
        if (!this.isDirty && (!this.isVisible || this.notRenderable)) return false;
        this.host._numLayoutCalls++;
        if (this._isDirty) this._currentMeasure.transformToRef(this._transformMatrix, this._prevCurrentMeasureTransformedIntoGlobalSpace);
        let rebuildCount = 0;
        context.save();
        this._applyStates(context);
        this._beforeLayout();
        do {
            let computedWidth = -1;
            let computedHeight = -1;
            this._rebuildLayout = false;
            this._processMeasures(parentMeasure, context);
            if (!this._isClipped) {
                for (const child of this._children){
                    child._tempParentMeasure.copyFrom(this._measureForChildren);
                    if (child._layout(this._measureForChildren, context)) {
                        if (child.isVisible && !child.notRenderable) {
                            if (this.adaptWidthToChildren && child._width.isPixel) computedWidth = Math.max(computedWidth, child._currentMeasure.width + child._paddingLeftInPixels + child._paddingRightInPixels);
                            if (this.adaptHeightToChildren && child._height.isPixel) computedHeight = Math.max(computedHeight, child._currentMeasure.height + child._paddingTopInPixels + child._paddingBottomInPixels);
                        }
                    }
                }
                if (this.adaptWidthToChildren && computedWidth >= 0) {
                    computedWidth += this.paddingLeftInPixels + this.paddingRightInPixels;
                    if (this.width !== computedWidth + "px") {
                        this.parent?._markAsDirty();
                        this.width = computedWidth + "px";
                        this._width.ignoreAdaptiveScaling = true;
                        this._rebuildLayout = true;
                    }
                }
                if (this.adaptHeightToChildren && computedHeight >= 0) {
                    computedHeight += this.paddingTopInPixels + this.paddingBottomInPixels;
                    if (this.height !== computedHeight + "px") {
                        this.parent?._markAsDirty();
                        this.height = computedHeight + "px";
                        this._height.ignoreAdaptiveScaling = true;
                        this._rebuildLayout = true;
                    }
                }
                this._postMeasure();
            }
            rebuildCount++;
        }while (this._rebuildLayout && rebuildCount < this.maxLayoutCycle);
        if (rebuildCount >= 3 && this.logLayoutCycleErrors) (0, $kVtWi.Logger).Error(`Layout cycle detected in GUI (Container name=${this.name}, uniqueId=${this.uniqueId})`);
        context.restore();
        if (this._isDirty) {
            this.invalidateRect();
            this._isDirty = false;
        }
        return true;
    }
    _postMeasure() {
    // Do nothing by default
    }
    /**
     * @internal
     */ _draw(context, invalidatedRectangle) {
        const renderToIntermediateTextureThisDraw = this._renderToIntermediateTexture && this._intermediateTexture;
        const contextToDrawTo = renderToIntermediateTextureThisDraw ? this._intermediateTexture.getContext() : context;
        if (renderToIntermediateTextureThisDraw) {
            contextToDrawTo.save();
            contextToDrawTo.translate(-this._currentMeasure.left, -this._currentMeasure.top);
            if (invalidatedRectangle) {
                this._transformMatrix.invertToRef(this._inverseTransformMatrix);
                invalidatedRectangle.transformToRef(this._inverseTransformMatrix, this._inverseMeasure);
                contextToDrawTo.clearRect(this._inverseMeasure.left, this._inverseMeasure.top, this._inverseMeasure.width, this._inverseMeasure.height);
            } else contextToDrawTo.clearRect(this._currentMeasure.left, this._currentMeasure.top, this._currentMeasure.width, this._currentMeasure.height);
        }
        this._localDraw(contextToDrawTo);
        context.save();
        if (this.clipChildren) this._clipForChildren(contextToDrawTo);
        for (const child of this._children){
            // Only redraw parts of the screen that are invalidated
            if (invalidatedRectangle) {
                if (!child._intersectsRect(invalidatedRectangle)) continue;
            }
            child._render(contextToDrawTo, invalidatedRectangle);
        }
        if (renderToIntermediateTextureThisDraw) {
            contextToDrawTo.restore();
            context.save();
            context.globalAlpha = this.alpha;
            context.drawImage(contextToDrawTo.canvas, this._currentMeasure.left, this._currentMeasure.top);
            context.restore();
        }
        context.restore();
    }
    getDescendantsToRef(results, directDescendantsOnly = false, predicate) {
        if (!this.children) return;
        for(let index = 0; index < this.children.length; index++){
            const item = this.children[index];
            if (!predicate || predicate(item)) results.push(item);
            if (!directDescendantsOnly) item.getDescendantsToRef(results, false, predicate);
        }
    }
    /**
     * @internal
     */ _processPicking(x, y, pi, type, pointerId, buttonIndex, deltaX, deltaY) {
        if (!this._isEnabled || !this.isVisible || this.notRenderable) return false;
        // checks if the picking position is within the container
        const contains = super.contains(x, y);
        // if clipChildren is off, we should still pass picking events to children even if we don't contain the pointer
        if (!contains && this.clipChildren) return false;
        if (this.delegatePickingToChildren) {
            let contains = false;
            for(let index = this._children.length - 1; index >= 0; index--){
                const child = this._children[index];
                if (child.isEnabled && child.isHitTestVisible && child.isVisible && !child.notRenderable && child.contains(x, y)) {
                    contains = true;
                    break;
                }
            }
            if (!contains) return false;
        }
        // Checking backwards to pick closest first
        for(let index = this._children.length - 1; index >= 0; index--){
            const child = this._children[index];
            if (child._processPicking(x, y, pi, type, pointerId, buttonIndex, deltaX, deltaY)) {
                if (child.hoverCursor) this._host._changeCursor(child.hoverCursor);
                return true;
            }
        }
        if (!contains) return false;
        if (!this.isHitTestVisible) return false;
        return this._processObservables(type, x, y, pi, pointerId, buttonIndex, deltaX, deltaY);
    }
    /**
     * @internal
     */ _additionalProcessing(parentMeasure, context) {
        super._additionalProcessing(parentMeasure, context);
        this._measureForChildren.copyFrom(this._currentMeasure);
    }
    _getAdaptDimTo(dim) {
        if (dim === "width") return this.adaptWidthToChildren;
        else return this.adaptHeightToChildren;
    }
    isDimensionFullyDefined(dim) {
        if (this._getAdaptDimTo(dim)) {
            for (const child of this.children){
                if (!child.isDimensionFullyDefined(dim)) return false;
            }
            return true;
        }
        return super.isDimensionFullyDefined(dim);
    }
    /**
     * Serializes the current control
     * @param serializationObject defined the JSON serialized object
     * @param force force serialization even if isSerializable === false
     */ serialize(serializationObject, force = false) {
        super.serialize(serializationObject, force);
        if (!this.isSerializable && !force) return;
        if (this.backgroundGradient) {
            serializationObject.backgroundGradient = {};
            this.backgroundGradient.serialize(serializationObject.backgroundGradient);
        }
        if (!this.children.length) return;
        serializationObject.children = [];
        for (const child of this.children)if (child.isSerializable || force) {
            const childSerializationObject = {};
            child.serialize(childSerializationObject);
            serializationObject.children.push(childSerializationObject);
        }
    }
    /** Releases associated resources */ dispose() {
        super.dispose();
        for(let index = this.children.length - 1; index >= 0; index--)this.children[index].dispose();
        this._intermediateTexture?.dispose();
    }
    /**
     * @internal
     */ _parseFromContent(serializedObject, host) {
        super._parseFromContent(serializedObject, host);
        this._link(host);
        // Gradient
        if (serializedObject.backgroundGradient) {
            const className = (0, $bOhSV.Tools).Instantiate("BABYLON.GUI." + serializedObject.backgroundGradient.className);
            this._backgroundGradient = new className();
            this._backgroundGradient?.parse(serializedObject.backgroundGradient);
        }
        if (!serializedObject.children) return;
        for (const childData of serializedObject.children)this.addControl((0, $fCNdl.Control).Parse(childData, host));
    }
    isReady() {
        for (const child of this.children){
            if (!child.isReady()) return false;
        }
        return true;
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $a86b55aad2faeec0$export$42a852a2b6b56249.prototype, "delegatePickingToChildren", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $a86b55aad2faeec0$export$42a852a2b6b56249.prototype, "renderToIntermediateTexture", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $a86b55aad2faeec0$export$42a852a2b6b56249.prototype, "maxLayoutCycle", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $a86b55aad2faeec0$export$42a852a2b6b56249.prototype, "adaptHeightToChildren", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $a86b55aad2faeec0$export$42a852a2b6b56249.prototype, "adaptWidthToChildren", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $a86b55aad2faeec0$export$42a852a2b6b56249.prototype, "background", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $a86b55aad2faeec0$export$42a852a2b6b56249.prototype, "backgroundGradient", null);
(0, $8DoUR.RegisterClass)("BABYLON.GUI.Container", $a86b55aad2faeec0$export$42a852a2b6b56249);

});
parcelRegister("fCNdl", function(module, exports) {

$parcel$export(module.exports, "Control", () => $b6009490051f50fb$export$7a7fa4424cb20976);

var $e0Suo = parcelRequire("e0Suo");

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $cfkw4 = parcelRequire("cfkw4");

var $kVtWi = parcelRequire("kVtWi");

var $bOhSV = parcelRequire("bOhSV");

var $dKQam = parcelRequire("dKQam");

var $lFAVI = parcelRequire("lFAVI");

var $jqbkF = parcelRequire("jqbkF");

var $8DoUR = parcelRequire("8DoUR");

var $ir0rz = parcelRequire("ir0rz");

var $6Ho1L = parcelRequire("6Ho1L");

var $ejQPp = parcelRequire("ejQPp");
class $b6009490051f50fb$export$7a7fa4424cb20976 {
    /**
     * Gets or sets a boolean indicating if the control is readonly (default: false).
     * A readonly control will still raise pointer events but will not react to them
     */ get isReadOnly() {
        return this._isReadOnly;
    }
    set isReadOnly(value) {
        this._isReadOnly = value;
    }
    /**
     * Gets the transformed measure, that is the bounding box of the control after applying all transformations
     */ get transformedMeasure() {
        return this._evaluatedMeasure;
    }
    /**
     * Sets/Gets a boolean indicating if the children are clipped to the current control bounds.
     * Please note that not clipping children may generate issues with adt.useInvalidateRectOptimization so it is recommended to turn this optimization off if you want to use unclipped children
     */ set clipChildren(value) {
        this._clipChildren = value;
    }
    get clipChildren() {
        return this._clipChildren;
    }
    /**
     * Sets/Gets a boolean indicating that control content must be clipped
     * Please note that not clipping content may generate issues with adt.useInvalidateRectOptimization so it is recommended to turn this optimization off if you want to use unclipped children
     */ set clipContent(value) {
        this._clipContent = value;
    }
    get clipContent() {
        return this._clipContent;
    }
    /** Gets or sets a value indicating the offset to apply on X axis to render the shadow */ get shadowOffsetX() {
        return this._shadowOffsetX;
    }
    set shadowOffsetX(value) {
        if (this._shadowOffsetX === value) return;
        this._shadowOffsetX = value;
        this._markAsDirty();
    }
    /** Gets or sets a value indicating the offset to apply on Y axis to render the shadow */ get shadowOffsetY() {
        return this._shadowOffsetY;
    }
    set shadowOffsetY(value) {
        if (this._shadowOffsetY === value) return;
        this._shadowOffsetY = value;
        this._markAsDirty();
    }
    /** Gets or sets a value indicating the amount of blur to use to render the shadow */ get shadowBlur() {
        return this._shadowBlur;
    }
    set shadowBlur(value) {
        if (this._shadowBlur === value) return;
        this._previousShadowBlur = this._shadowBlur;
        this._shadowBlur = value;
        this._markAsDirty();
    }
    /** Gets or sets a value indicating the color of the shadow (black by default ie. "#000") */ get shadowColor() {
        return this._shadowColor;
    }
    set shadowColor(value) {
        if (this._shadowColor === value) return;
        this._shadowColor = value;
        this._markAsDirty();
    }
    // Properties
    /** Gets the control type name */ get typeName() {
        return this._getTypeName();
    }
    /**
     * Get the current class name of the control.
     * @returns current class name
     */ getClassName() {
        return this._getTypeName();
    }
    /**
     * Gets or sets the accessibility tag to describe the control for accessibility purpose.
     * By default, GUI controls already indicate accessibility info, but one can override the info using this tag.
     */ set accessibilityTag(value) {
        this._accessibilityTag = value;
        this.onAccessibilityTagChangedObservable.notifyObservers(value);
    }
    get accessibilityTag() {
        return this._accessibilityTag;
    }
    /**
     * Get the hosting AdvancedDynamicTexture
     */ get host() {
        return this._host;
    }
    /** Gets or set information about font offsets (used to render and align text) */ get fontOffset() {
        return this._fontOffset;
    }
    set fontOffset(offset) {
        this._fontOffset = offset;
    }
    /** Gets or sets alpha value for the control (1 means opaque and 0 means entirely transparent) */ get alpha() {
        return this._alpha;
    }
    set alpha(value) {
        if (this._alpha === value) return;
        this._alphaSet = true;
        this._alpha = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets a number indicating size of stroke we want to highlight the control with (mostly for debugging purpose)
     */ get highlightLineWidth() {
        return this._highlightLineWidth;
    }
    set highlightLineWidth(value) {
        if (this._highlightLineWidth === value) return;
        this._highlightLineWidth = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets a boolean indicating that we want to highlight the control (mostly for debugging purpose)
     */ get isHighlighted() {
        return this._isHighlighted;
    }
    set isHighlighted(value) {
        if (this._isHighlighted === value) return;
        this._isHighlighted = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets a string defining the color to use for highlighting this control
     */ get highlightColor() {
        return this._highlightColor;
    }
    set highlightColor(value) {
        if (this._highlightColor === value) return;
        this._highlightColor = value;
        this._markAsDirty();
    }
    /** Gets or sets a value indicating the scale factor on X axis (1 by default)
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#rotation-and-scaling
     */ get scaleX() {
        return this._scaleX;
    }
    set scaleX(value) {
        if (this._scaleX === value) return;
        this._scaleX = value;
        this._markAsDirty();
        this._markMatrixAsDirty();
    }
    /** Gets or sets a value indicating the scale factor on Y axis (1 by default)
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#rotation-and-scaling
     */ get scaleY() {
        return this._scaleY;
    }
    set scaleY(value) {
        if (this._scaleY === value) return;
        this._scaleY = value;
        this._markAsDirty();
        this._markMatrixAsDirty();
    }
    /** Gets or sets the rotation angle (0 by default)
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#rotation-and-scaling
     */ get rotation() {
        return this._rotation;
    }
    set rotation(value) {
        if (this._rotation === value) return;
        this._rotation = value;
        this._markAsDirty();
        this._markMatrixAsDirty();
    }
    /** Gets or sets the transformation center on Y axis (0 by default)
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#rotation-and-scaling
     */ get transformCenterY() {
        return this._transformCenterY;
    }
    set transformCenterY(value) {
        if (this._transformCenterY === value) return;
        this._transformCenterY = value;
        this._markAsDirty();
        this._markMatrixAsDirty();
    }
    /** Gets or sets the transformation center on X axis (0 by default)
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#rotation-and-scaling
     */ get transformCenterX() {
        return this._transformCenterX;
    }
    set transformCenterX(value) {
        if (this._transformCenterX === value) return;
        this._transformCenterX = value;
        this._markAsDirty();
        this._markMatrixAsDirty();
    }
    /**
     * Gets or sets the horizontal alignment
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#alignments
     */ get horizontalAlignment() {
        return this._horizontalAlignment;
    }
    set horizontalAlignment(value) {
        if (this._horizontalAlignment === value) return;
        this._horizontalAlignment = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets the vertical alignment
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#alignments
     */ get verticalAlignment() {
        return this._verticalAlignment;
    }
    set verticalAlignment(value) {
        if (this._verticalAlignment === value) return;
        this._verticalAlignment = value;
        this._markAsDirty();
    }
    set fixedRatio(value) {
        if (this._fixedRatio === value) return;
        this._fixedRatio = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets a fixed ratio for this control.
     * When different from 0, the ratio is used to compute the "second" dimension.
     * The first dimension used in the computation is the last one set (by setting width / widthInPixels or height / heightInPixels), and the
     * second dimension is computed as first dimension * fixedRatio
     */ get fixedRatio() {
        return this._fixedRatio;
    }
    set fixedRatioMasterIsWidth(value) {
        if (this._fixedRatioMasterIsWidth === value) return;
        this._fixedRatioMasterIsWidth = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets a boolean indicating that the fixed ratio is set on the width instead of the height. True by default.
     * When the height of a control is set, this property is changed to false.
     */ get fixedRatioMasterIsWidth() {
        return this._fixedRatioMasterIsWidth;
    }
    /**
     * Gets or sets control width
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#position-and-size
     */ get width() {
        return this._width.toString(this._host);
    }
    set width(value) {
        this._fixedRatioMasterIsWidth = true;
        if (this._width.toString(this._host) === value) return;
        if (this._width.fromString(value)) this._markAsDirty();
    }
    /**
     * Gets or sets the control width in pixel
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#position-and-size
     */ get widthInPixels() {
        return this._width.getValueInPixel(this._host, this._cachedParentMeasure.width);
    }
    set widthInPixels(value) {
        if (isNaN(value)) return;
        this._fixedRatioMasterIsWidth = true;
        this.width = value + "px";
    }
    /**
     * Gets or sets control height
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#position-and-size
     */ get height() {
        return this._height.toString(this._host);
    }
    set height(value) {
        this._fixedRatioMasterIsWidth = false;
        if (this._height.toString(this._host) === value) return;
        if (this._height.fromString(value)) this._markAsDirty();
    }
    /**
     * Gets or sets control height in pixel
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#position-and-size
     */ get heightInPixels() {
        return this._height.getValueInPixel(this._host, this._cachedParentMeasure.height);
    }
    set heightInPixels(value) {
        if (isNaN(value)) return;
        this._fixedRatioMasterIsWidth = false;
        this.height = value + "px";
    }
    /** Gets or set font family */ get fontFamily() {
        return this._fontFamily;
    }
    set fontFamily(value) {
        if (this._fontFamily === value) return;
        this._fontFamily = value;
        this._resetFontCache();
    }
    /** Gets or sets font style */ get fontStyle() {
        return this._fontStyle;
    }
    set fontStyle(value) {
        if (this._fontStyle === value) return;
        this._fontStyle = value;
        this._resetFontCache();
    }
    /** Gets or sets font weight */ get fontWeight() {
        return this._fontWeight;
    }
    set fontWeight(value) {
        if (this._fontWeight === value) return;
        this._fontWeight = value;
        this._resetFontCache();
    }
    /**
     * Gets or sets style
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#styles
     */ get style() {
        return this._style;
    }
    set style(value) {
        if (this._style) {
            this._style.onChangedObservable.remove(this._styleObserver);
            this._styleObserver = null;
        }
        this._style = value;
        if (this._style) this._styleObserver = this._style.onChangedObservable.add(()=>{
            this._markAsDirty();
            this._resetFontCache();
        });
        this._markAsDirty();
        this._resetFontCache();
    }
    /** @internal */ get _isFontSizeInPercentage() {
        return this._fontSize.isPercentage;
    }
    /** Gets or sets font size in pixels */ get fontSizeInPixels() {
        const fontSizeToUse = this._style ? this._style._fontSize : this._fontSize;
        if (fontSizeToUse.isPixel) return fontSizeToUse.getValue(this._host);
        return fontSizeToUse.getValueInPixel(this._host, this._tempParentMeasure.height || this._cachedParentMeasure.height);
    }
    set fontSizeInPixels(value) {
        if (isNaN(value)) return;
        this.fontSize = value + "px";
    }
    /** Gets or sets font size */ get fontSize() {
        return this._fontSize.toString(this._host);
    }
    set fontSize(value) {
        if (this._fontSize.toString(this._host) === value) return;
        if (this._fontSize.fromString(value)) {
            this._markAsDirty();
            this._resetFontCache();
        }
    }
    /** Gets or sets foreground color */ get color() {
        return this._color;
    }
    set color(value) {
        if (this._color === value) return;
        this._color = value;
        this._markAsDirty();
    }
    /** Gets or sets gradient. Setting a gradient will override the color */ get gradient() {
        return this._gradient;
    }
    set gradient(value) {
        if (this._gradient === value) return;
        this._gradient = value;
        this._markAsDirty();
    }
    /** Gets or sets z index which is used to reorder controls on the z axis */ get zIndex() {
        return this._zIndex;
    }
    set zIndex(value) {
        if (this.zIndex === value) return;
        this._zIndex = value;
        if (this.parent) this.parent._reOrderControl(this);
    }
    /** Gets or sets a boolean indicating if the control can be rendered */ get notRenderable() {
        return this._doNotRender;
    }
    set notRenderable(value) {
        if (this._doNotRender === value) return;
        this._doNotRender = value;
        this._markAsDirty();
    }
    /** Gets or sets a boolean indicating if the control is visible */ get isVisible() {
        return this._isVisible;
    }
    set isVisible(value) {
        if (this._isVisible === value) return;
        this._isVisible = value;
        this._markAsDirty(true);
        this.onIsVisibleChangedObservable.notifyObservers(value);
    }
    /** Gets a boolean indicating that the control needs to update its rendering */ get isDirty() {
        return this._isDirty;
    }
    /**
     * Gets the current linked mesh (or null if none)
     */ get linkedMesh() {
        return this._linkedMesh;
    }
    /**
     * Gets or sets a value indicating the padding should work like in CSS.
     * Basically, it will add the padding amount on each side of the parent control for its children.
     */ get descendantsOnlyPadding() {
        return this._descendantsOnlyPadding;
    }
    set descendantsOnlyPadding(value) {
        if (this._descendantsOnlyPadding === value) return;
        this._descendantsOnlyPadding = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets a value indicating the padding to use on the left of the control
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#position-and-size
     */ get paddingLeft() {
        return this._paddingLeft.toString(this._host);
    }
    set paddingLeft(value) {
        if (this._paddingLeft.fromString(value)) this._markAsDirty();
    }
    /**
     * Gets or sets a value indicating the padding in pixels to use on the left of the control
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#position-and-size
     */ get paddingLeftInPixels() {
        return this._paddingLeft.getValueInPixel(this._host, this._cachedParentMeasure.width);
    }
    set paddingLeftInPixels(value) {
        if (isNaN(value)) return;
        this.paddingLeft = value + "px";
    }
    /** @internal */ get _paddingLeftInPixels() {
        if (this._descendantsOnlyPadding) return 0;
        return this.paddingLeftInPixels;
    }
    /**
     * Gets or sets a value indicating the padding to use on the right of the control
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#position-and-size
     */ get paddingRight() {
        return this._paddingRight.toString(this._host);
    }
    set paddingRight(value) {
        if (this._paddingRight.fromString(value)) this._markAsDirty();
    }
    /**
     * Gets or sets a value indicating the padding in pixels to use on the right of the control
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#position-and-size
     */ get paddingRightInPixels() {
        return this._paddingRight.getValueInPixel(this._host, this._cachedParentMeasure.width);
    }
    set paddingRightInPixels(value) {
        if (isNaN(value)) return;
        this.paddingRight = value + "px";
    }
    /** @internal */ get _paddingRightInPixels() {
        if (this._descendantsOnlyPadding) return 0;
        return this.paddingRightInPixels;
    }
    /**
     * Gets or sets a value indicating the padding to use on the top of the control
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#position-and-size
     */ get paddingTop() {
        return this._paddingTop.toString(this._host);
    }
    set paddingTop(value) {
        if (this._paddingTop.fromString(value)) this._markAsDirty();
    }
    /**
     * Gets or sets a value indicating the padding in pixels to use on the top of the control
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#position-and-size
     */ get paddingTopInPixels() {
        return this._paddingTop.getValueInPixel(this._host, this._cachedParentMeasure.height);
    }
    set paddingTopInPixels(value) {
        if (isNaN(value)) return;
        this.paddingTop = value + "px";
    }
    /** @internal */ get _paddingTopInPixels() {
        if (this._descendantsOnlyPadding) return 0;
        return this.paddingTopInPixels;
    }
    /**
     * Gets or sets a value indicating the padding to use on the bottom of the control
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#position-and-size
     */ get paddingBottom() {
        return this._paddingBottom.toString(this._host);
    }
    set paddingBottom(value) {
        if (this._paddingBottom.fromString(value)) this._markAsDirty();
    }
    /**
     * Gets or sets a value indicating the padding in pixels to use on the bottom of the control
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#position-and-size
     */ get paddingBottomInPixels() {
        return this._paddingBottom.getValueInPixel(this._host, this._cachedParentMeasure.height);
    }
    set paddingBottomInPixels(value) {
        if (isNaN(value)) return;
        this.paddingBottom = value + "px";
    }
    /** @internal */ get _paddingBottomInPixels() {
        if (this._descendantsOnlyPadding) return 0;
        return this.paddingBottomInPixels;
    }
    /**
     * Gets or sets a value indicating the left coordinate of the control
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#position-and-size
     */ get left() {
        return this._left.toString(this._host);
    }
    set left(value) {
        if (this._left.fromString(value)) this._markAsDirty();
    }
    /**
     * Gets or sets a value indicating the left coordinate in pixels of the control
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#position-and-size
     */ get leftInPixels() {
        return this._left.getValueInPixel(this._host, this._cachedParentMeasure.width);
    }
    set leftInPixels(value) {
        if (isNaN(value)) return;
        this.left = value + "px";
    }
    /**
     * Gets or sets a value indicating the top coordinate of the control
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#position-and-size
     */ get top() {
        return this._top.toString(this._host);
    }
    set top(value) {
        if (this._top.fromString(value)) this._markAsDirty();
    }
    /**
     * Gets or sets a value indicating the top coordinate in pixels of the control
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#position-and-size
     */ get topInPixels() {
        return this._top.getValueInPixel(this._host, this._cachedParentMeasure.height);
    }
    set topInPixels(value) {
        if (isNaN(value)) return;
        this.top = value + "px";
    }
    /**
     * Gets or sets a value indicating the offset on X axis to the linked mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#tracking-positions
     */ get linkOffsetX() {
        return this._linkOffsetX.toString(this._host);
    }
    set linkOffsetX(value) {
        if (this._linkOffsetX.fromString(value)) this._markAsDirty();
    }
    /**
     * Gets or sets a value indicating the offset in pixels on X axis to the linked mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#tracking-positions
     */ get linkOffsetXInPixels() {
        return this._linkOffsetX.getValueInPixel(this._host, this._cachedParentMeasure.width);
    }
    set linkOffsetXInPixels(value) {
        if (isNaN(value)) return;
        this.linkOffsetX = value + "px";
    }
    /**
     * Gets or sets a value indicating the offset on Y axis to the linked mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#tracking-positions
     */ get linkOffsetY() {
        return this._linkOffsetY.toString(this._host);
    }
    set linkOffsetY(value) {
        if (this._linkOffsetY.fromString(value)) this._markAsDirty();
    }
    /**
     * Gets or sets a value indicating the offset in pixels on Y axis to the linked mesh
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#tracking-positions
     */ get linkOffsetYInPixels() {
        return this._linkOffsetY.getValueInPixel(this._host, this._cachedParentMeasure.height);
    }
    set linkOffsetYInPixels(value) {
        if (isNaN(value)) return;
        this.linkOffsetY = value + "px";
    }
    /** Gets the center coordinate on X axis */ get centerX() {
        return this._currentMeasure.left + this._currentMeasure.width / 2;
    }
    /** Gets the center coordinate on Y axis */ get centerY() {
        return this._currentMeasure.top + this._currentMeasure.height / 2;
    }
    /** Gets or sets if control is Enabled */ get isEnabled() {
        return this._isEnabled;
    }
    set isEnabled(value) {
        if (this._isEnabled === value) return;
        this._isEnabled = value;
        this._markAsDirty();
        // if this control or any of it's descendants are under a pointer, we need to fire a pointerOut event
        const recursivelyFirePointerOut = (control)=>{
            if (!control.host) return;
            for(const pointer in control.host._lastControlOver)if (control === this.host._lastControlOver[pointer]) {
                control._onPointerOut(control, null, true);
                delete control.host._lastControlOver[pointer];
            }
            if (control.children !== undefined) control.children.forEach(recursivelyFirePointerOut);
        };
        recursivelyFirePointerOut(this);
        this.onEnabledStateChangedObservable.notifyObservers(value);
    }
    /** Gets or sets background color of control if it's disabled. Only applies to Button class. */ get disabledColor() {
        return this._disabledColor;
    }
    set disabledColor(value) {
        if (this._disabledColor === value) return;
        this._disabledColor = value;
        this._markAsDirty();
    }
    /** Gets or sets front color of control if it's disabled. Only applies to Checkbox class. */ get disabledColorItem() {
        return this._disabledColorItem;
    }
    set disabledColorItem(value) {
        if (this._disabledColorItem === value) return;
        this._disabledColorItem = value;
        this._markAsDirty();
    }
    // Functions
    /**
     * Creates a new control
     * @param name defines the name of the control
     */ constructor(/** defines the name of the control */ name){
        this.name = name;
        this._alpha = 1;
        this._alphaSet = false;
        this._zIndex = 0;
        /** @internal */ this._currentMeasure = (0, $lFAVI.Measure).Empty();
        /** @internal */ this._tempPaddingMeasure = (0, $lFAVI.Measure).Empty();
        this._fontFamily = "";
        this._fontStyle = "";
        this._fontWeight = "";
        this._fontSize = new (0, $dKQam.ValueAndUnit)(18, (0, $dKQam.ValueAndUnit).UNITMODE_PIXEL, false);
        /** @internal */ this._width = new (0, $dKQam.ValueAndUnit)(1, (0, $dKQam.ValueAndUnit).UNITMODE_PERCENTAGE, false);
        /** @internal */ this._height = new (0, $dKQam.ValueAndUnit)(1, (0, $dKQam.ValueAndUnit).UNITMODE_PERCENTAGE, false);
        this._color = "";
        this._style = null;
        /** @internal */ this._horizontalAlignment = $b6009490051f50fb$export$7a7fa4424cb20976.HORIZONTAL_ALIGNMENT_CENTER;
        /** @internal */ this._verticalAlignment = $b6009490051f50fb$export$7a7fa4424cb20976.VERTICAL_ALIGNMENT_CENTER;
        /** @internal */ this._isDirty = true;
        /** @internal */ this._wasDirty = false;
        /** @internal */ this._tempParentMeasure = (0, $lFAVI.Measure).Empty();
        /** @internal */ this._prevCurrentMeasureTransformedIntoGlobalSpace = (0, $lFAVI.Measure).Empty();
        /** @internal */ this._cachedParentMeasure = (0, $lFAVI.Measure).Empty();
        this._descendantsOnlyPadding = false;
        this._paddingLeft = new (0, $dKQam.ValueAndUnit)(0);
        this._paddingRight = new (0, $dKQam.ValueAndUnit)(0);
        this._paddingTop = new (0, $dKQam.ValueAndUnit)(0);
        this._paddingBottom = new (0, $dKQam.ValueAndUnit)(0);
        /** @internal */ this._left = new (0, $dKQam.ValueAndUnit)(0);
        /** @internal */ this._top = new (0, $dKQam.ValueAndUnit)(0);
        this._scaleX = 1.0;
        this._scaleY = 1.0;
        this._rotation = 0;
        this._transformCenterX = 0.5;
        this._transformCenterY = 0.5;
        /** @internal */ this._transformMatrix = (0, $jqbkF.Matrix2D).Identity();
        /** @internal */ this._invertTransformMatrix = (0, $jqbkF.Matrix2D).Identity();
        /** @internal */ this._transformedPosition = (0, $ha1VO.Vector2).Zero();
        this._isMatrixDirty = true;
        this._isVisible = true;
        this._isHighlighted = false;
        this._highlightColor = "#4affff";
        this._highlightLineWidth = 2;
        this._fontSet = false;
        this._dummyVector2 = (0, $ha1VO.Vector2).Zero();
        this._downCount = 0;
        this._enterCount = -1;
        this._doNotRender = false;
        this._downPointerIds = {};
        this._evaluatedMeasure = new (0, $lFAVI.Measure)(0, 0, 0, 0);
        this._evaluatedParentMeasure = new (0, $lFAVI.Measure)(0, 0, 0, 0);
        this._isEnabled = true;
        this._disabledColor = "#9a9a9a";
        this._disabledColorItem = "#6a6a6a";
        this._isReadOnly = false;
        this._gradient = null;
        /** @internal */ this._rebuildLayout = false;
        /**
         * Observable that fires when the control's enabled state changes
         */ this.onEnabledStateChangedObservable = new (0, $diGQf.Observable)();
        /** @internal */ this._customData = {};
        /** @internal */ this._isClipped = false;
        /** @internal */ this._automaticSize = false;
        /**
         * Gets or sets an object used to store user defined information for the node
         */ this.metadata = null;
        /** Gets or sets a boolean indicating if the control can be hit with pointer events */ this.isHitTestVisible = true;
        /** Gets or sets a boolean indicating if the control can block pointer events. False by default except on the following controls:
         * * Button controls (Button, RadioButton, ToggleButton)
         * * Checkbox
         * * ColorPicker
         * * InputText
         * * Slider
         */ this.isPointerBlocker = false;
        /** Gets or sets a boolean indicating if the control can be focusable */ this.isFocusInvisible = false;
        this._clipChildren = true;
        this._clipContent = true;
        /**
         * Gets or sets a boolean indicating that the current control should cache its rendering (useful when the control does not change often)
         */ this.useBitmapCache = false;
        this._shadowOffsetX = 0;
        this._shadowOffsetY = 0;
        this._shadowBlur = 0;
        this._previousShadowBlur = 0;
        this._shadowColor = "black";
        /** Gets or sets the cursor to use when the control is hovered */ this.hoverCursor = "";
        /** @internal */ this._linkOffsetX = new (0, $dKQam.ValueAndUnit)(0);
        /** @internal */ this._linkOffsetY = new (0, $dKQam.ValueAndUnit)(0);
        this._accessibilityTag = null;
        /**
         * Observable that fires whenever the accessibility event of the control has changed
         */ this.onAccessibilityTagChangedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when pointer wheel is scrolled
         */ this.onWheelObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the pointer moves over the control.
         */ this.onPointerMoveObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the pointer moves out of the control.
         */ this.onPointerOutObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the pointer taps the control
         */ this.onPointerDownObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when pointer up
         */ this.onPointerUpObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when a control is clicked on
         */ this.onPointerClickObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when pointer enters the control
         */ this.onPointerEnterObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the control is marked as dirty
         */ this.onDirtyObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered before drawing the control
         */ this.onBeforeDrawObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered after the control was drawn
         */ this.onAfterDrawObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the control has been disposed
         */ this.onDisposeObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered when the control isVisible is changed
         */ this.onIsVisibleChangedObservable = new (0, $diGQf.Observable)();
        /**
         * Indicates if the control should be serialized. Defaults to true.
         */ this.isSerializable = true;
        this._fixedRatio = 0;
        this._fixedRatioMasterIsWidth = true;
        /**
         * Array of animations
         */ this.animations = null;
        this._tmpMeasureA = new (0, $lFAVI.Measure)(0, 0, 0, 0);
    }
    /** @internal */ _getTypeName() {
        return "Control";
    }
    /**
     * Gets the first ascendant in the hierarchy of the given type
     * @param className defines the required type
     * @returns the ascendant or null if not found
     */ getAscendantOfClass(className) {
        if (!this.parent) return null;
        if (this.parent.getClassName() === className) return this.parent;
        return this.parent.getAscendantOfClass(className);
    }
    /**
     * Mark control element as dirty
     * @param force force non visible elements to be marked too
     */ markAsDirty(force = false) {
        this._markAsDirty(force);
    }
    /**
     * Mark the element and its children as dirty
     */ markAllAsDirty() {
        this._markAllAsDirty();
    }
    /** @internal */ _resetFontCache() {
        this._fontSet = true;
        this._markAsDirty();
    }
    /**
     * Determines if a container is an ascendant of the current control
     * @param container defines the container to look for
     * @returns true if the container is one of the ascendant of the control
     */ isAscendant(container) {
        if (!this.parent) return false;
        if (this.parent === container) return true;
        return this.parent.isAscendant(container);
    }
    /**
     * Gets coordinates in local control space
     * @param globalCoordinates defines the coordinates to transform
     * @returns the new coordinates in local space
     */ getLocalCoordinates(globalCoordinates) {
        const result = (0, $ha1VO.Vector2).Zero();
        this.getLocalCoordinatesToRef(globalCoordinates, result);
        return result;
    }
    /**
     * Gets coordinates in local control space
     * @param globalCoordinates defines the coordinates to transform
     * @param result defines the target vector2 where to store the result
     * @returns the current control
     */ getLocalCoordinatesToRef(globalCoordinates, result) {
        result.x = globalCoordinates.x - this._currentMeasure.left;
        result.y = globalCoordinates.y - this._currentMeasure.top;
        return this;
    }
    /**
     * Gets coordinates in parent local control space
     * @param globalCoordinates defines the coordinates to transform
     * @returns the new coordinates in parent local space
     */ getParentLocalCoordinates(globalCoordinates) {
        const result = (0, $ha1VO.Vector2).Zero();
        result.x = globalCoordinates.x - this._cachedParentMeasure.left;
        result.y = globalCoordinates.y - this._cachedParentMeasure.top;
        return result;
    }
    /**
     * Move the current control to a vector3 position projected onto the screen.
     * @param position defines the target position
     * @param scene defines the hosting scene
     */ moveToVector3(position, scene) {
        if (!this._host || this.parent !== this._host._rootContainer) {
            (0, $bOhSV.Tools).Error("Cannot move a control to a vector3 if the control is not at root level");
            return;
        }
        this.horizontalAlignment = $b6009490051f50fb$export$7a7fa4424cb20976.HORIZONTAL_ALIGNMENT_LEFT;
        this.verticalAlignment = $b6009490051f50fb$export$7a7fa4424cb20976.VERTICAL_ALIGNMENT_TOP;
        const globalViewport = this._host._getGlobalViewport();
        const projectedPosition = (0, $ha1VO.Vector3).Project(position, (0, $ha1VO.Matrix).IdentityReadOnly, scene.getTransformMatrix(), globalViewport);
        this._moveToProjectedPosition(projectedPosition);
        if (projectedPosition.z < 0 || projectedPosition.z > 1) {
            this.notRenderable = true;
            return;
        }
        this.notRenderable = false;
    }
    /**
     * Will store all controls that have this control as ascendant in a given array
     * @param results defines the array where to store the descendants
     * @param directDescendantsOnly defines if true only direct descendants of 'this' will be considered, if false direct and also indirect (children of children, an so on in a recursive manner) descendants of 'this' will be considered
     * @param predicate defines an optional predicate that will be called on every evaluated child, the predicate must return true for a given child to be part of the result, otherwise it will be ignored
     */ getDescendantsToRef(results, directDescendantsOnly = false, predicate) {
    // Do nothing by default
    }
    /**
     * Will return all controls that have this control as ascendant
     * @param directDescendantsOnly defines if true only direct descendants of 'this' will be considered, if false direct and also indirect (children of children, an so on in a recursive manner) descendants of 'this' will be considered
     * @param predicate defines an optional predicate that will be called on every evaluated child, the predicate must return true for a given child to be part of the result, otherwise it will be ignored
     * @returns all child controls
     */ getDescendants(directDescendantsOnly, predicate) {
        const results = [];
        this.getDescendantsToRef(results, directDescendantsOnly, predicate);
        return results;
    }
    /**
     * Link current control with a target mesh
     * @param mesh defines the mesh to link with
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#tracking-positions
     */ linkWithMesh(mesh) {
        if (!this._host || this.parent && this.parent !== this._host._rootContainer) {
            if (mesh) (0, $bOhSV.Tools).Error("Cannot link a control to a mesh if the control is not at root level");
            return;
        }
        const index = this._host._linkedControls.indexOf(this);
        if (index !== -1) {
            this._linkedMesh = mesh;
            if (!mesh) this._host._linkedControls.splice(index, 1);
            return;
        } else if (!mesh) return;
        this.horizontalAlignment = $b6009490051f50fb$export$7a7fa4424cb20976.HORIZONTAL_ALIGNMENT_LEFT;
        this.verticalAlignment = $b6009490051f50fb$export$7a7fa4424cb20976.VERTICAL_ALIGNMENT_TOP;
        this._linkedMesh = mesh;
        this._host._linkedControls.push(this);
    }
    /**
     * Shorthand function to set the top, right, bottom, and left padding values on the control.
     * @param { string | number} paddingTop - The value of the top padding.
     * @param { string | number} paddingRight - The value of the right padding. If omitted, top is used.
     * @param { string | number} paddingBottom - The value of the bottom padding. If omitted, top is used.
     * @param { string | number} paddingLeft - The value of the left padding. If omitted, right is used.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#position-and-size
     */ setPadding(paddingTop, paddingRight, paddingBottom, paddingLeft) {
        const top = paddingTop;
        const right = paddingRight ?? top;
        const bottom = paddingBottom ?? top;
        const left = paddingLeft ?? right;
        this.paddingTop = top;
        this.paddingRight = right;
        this.paddingBottom = bottom;
        this.paddingLeft = left;
    }
    /**
     * Shorthand funtion to set the top, right, bottom, and left padding values in pixels on the control.
     * @param { number} paddingTop - The value in pixels of the top padding.
     * @param { number} paddingRight - The value in pixels of the right padding. If omitted, top is used.
     * @param { number} paddingBottom - The value in pixels of the bottom padding. If omitted, top is used.
     * @param { number} paddingLeft - The value in pixels of the left padding. If omitted, right is used.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#position-and-size
     */ setPaddingInPixels(paddingTop, paddingRight, paddingBottom, paddingLeft) {
        const top = paddingTop;
        const right = paddingRight ?? top;
        const bottom = paddingBottom ?? top;
        const left = paddingLeft ?? right;
        this.paddingTopInPixels = top;
        this.paddingRightInPixels = right;
        this.paddingBottomInPixels = bottom;
        this.paddingLeftInPixels = left;
    }
    /**
     * @internal
     */ _moveToProjectedPosition(projectedPosition) {
        const oldLeft = this._left.getValue(this._host);
        const oldTop = this._top.getValue(this._host);
        const parentMeasure = this.parent?._currentMeasure;
        if (parentMeasure) this._processMeasures(parentMeasure, this._host.getContext());
        let newLeft = projectedPosition.x + this._linkOffsetX.getValue(this._host) - this._currentMeasure.width / 2;
        let newTop = projectedPosition.y + this._linkOffsetY.getValue(this._host) - this._currentMeasure.height / 2;
        const leftAndTopIgnoreAdaptiveScaling = this._left.ignoreAdaptiveScaling && this._top.ignoreAdaptiveScaling;
        if (leftAndTopIgnoreAdaptiveScaling) {
            if (Math.abs(newLeft - oldLeft) < 0.5) newLeft = oldLeft;
            if (Math.abs(newTop - oldTop) < 0.5) newTop = oldTop;
        }
        if (!leftAndTopIgnoreAdaptiveScaling && oldLeft === newLeft && oldTop === newTop) return;
        this.left = newLeft + "px";
        this.top = newTop + "px";
        this._left.ignoreAdaptiveScaling = true;
        this._top.ignoreAdaptiveScaling = true;
        this._markAsDirty();
    }
    /**
     * @internal
     */ _offsetLeft(offset) {
        this._isDirty = true;
        this._currentMeasure.left += offset;
    }
    /**
     * @internal
     */ _offsetTop(offset) {
        this._isDirty = true;
        this._currentMeasure.top += offset;
    }
    /** @internal */ _markMatrixAsDirty() {
        this._isMatrixDirty = true;
        this._flagDescendantsAsMatrixDirty();
    }
    /** @internal */ _flagDescendantsAsMatrixDirty() {
    // No child
    }
    /**
     * @internal
     */ _intersectsRect(rect, context) {
        // make sure we are transformed correctly before checking intersections. no-op if nothing is dirty.
        this._transform(context);
        if (this._evaluatedMeasure.left >= rect.left + rect.width) return false;
        if (this._evaluatedMeasure.top >= rect.top + rect.height) return false;
        if (this._evaluatedMeasure.left + this._evaluatedMeasure.width <= rect.left) return false;
        if (this._evaluatedMeasure.top + this._evaluatedMeasure.height <= rect.top) return false;
        return true;
    }
    /** @internal */ _computeAdditionalOffsetX() {
        return 0;
    }
    /** @internal */ _computeAdditionalOffsetY() {
        return 0;
    }
    /** @internal */ // eslint-disable-next-line @typescript-eslint/naming-convention
    invalidateRect() {
        this._transform();
        if (this.host && this.host.useInvalidateRectOptimization) {
            // Rotate by transform to get the measure transformed to global space
            this._currentMeasure.transformToRef(this._transformMatrix, this._tmpMeasureA);
            // get the boudning box of the current measure and last frames measure in global space and invalidate it
            // the previous measure is used to properly clear a control that is scaled down
            (0, $lFAVI.Measure).CombineToRef(this._tmpMeasureA, this._prevCurrentMeasureTransformedIntoGlobalSpace, this._tmpMeasureA);
            // Expand rect based on shadows
            const shadowOffsetX = this.shadowOffsetX;
            const shadowOffsetY = this.shadowOffsetY;
            const shadowBlur = Math.max(this._previousShadowBlur, this.shadowBlur);
            const leftShadowOffset = Math.min(Math.min(shadowOffsetX, 0) - shadowBlur * 2, 0);
            const rightShadowOffset = Math.max(Math.max(shadowOffsetX, 0) + shadowBlur * 2, 0);
            const topShadowOffset = Math.min(Math.min(shadowOffsetY, 0) - shadowBlur * 2, 0);
            const bottomShadowOffset = Math.max(Math.max(shadowOffsetY, 0) + shadowBlur * 2, 0);
            const offsetX = this._computeAdditionalOffsetX();
            const offsetY = this._computeAdditionalOffsetY();
            this.host.invalidateRect(Math.floor(this._tmpMeasureA.left + leftShadowOffset - offsetX), Math.floor(this._tmpMeasureA.top + topShadowOffset - offsetY), Math.ceil(this._tmpMeasureA.left + this._tmpMeasureA.width + rightShadowOffset + offsetX), Math.ceil(this._tmpMeasureA.top + this._tmpMeasureA.height + bottomShadowOffset + offsetY));
        }
    }
    /**
     * @internal
     */ _markAsDirty(force = false) {
        if (!this._isVisible && !force) return;
        this._isDirty = true;
        this._markMatrixAsDirty();
        // Redraw only this rectangle
        if (this._host) this._host.markAsDirty();
    }
    /** @internal */ _markAllAsDirty() {
        this._markAsDirty();
        if (this._font) this._prepareFont();
    }
    /**
     * @internal
     */ _link(host) {
        this._host = host;
        if (this._host) this.uniqueId = this._host.getScene().getUniqueId();
    }
    /**
     * @internal
     */ _transform(context) {
        if (!this._isMatrixDirty && this._scaleX === 1 && this._scaleY === 1 && this._rotation === 0) return;
        // postTranslate
        const offsetX = this._currentMeasure.width * this._transformCenterX + this._currentMeasure.left;
        const offsetY = this._currentMeasure.height * this._transformCenterY + this._currentMeasure.top;
        if (context) {
            context.translate(offsetX, offsetY);
            // rotate
            context.rotate(this._rotation);
            // scale
            context.scale(this._scaleX, this._scaleY);
            // preTranslate
            context.translate(-offsetX, -offsetY);
        }
        // Need to update matrices?
        if (this._isMatrixDirty || this._cachedOffsetX !== offsetX || this._cachedOffsetY !== offsetY) {
            this._cachedOffsetX = offsetX;
            this._cachedOffsetY = offsetY;
            this._isMatrixDirty = false;
            this._flagDescendantsAsMatrixDirty();
            (0, $jqbkF.Matrix2D).ComposeToRef(-offsetX, -offsetY, this._rotation, this._scaleX, this._scaleY, this.parent ? this.parent._transformMatrix : null, this._transformMatrix);
            this._transformMatrix.invertToRef(this._invertTransformMatrix);
            this._currentMeasure.transformToRef(this._transformMatrix, this._evaluatedMeasure);
        }
    }
    /**
     * @internal
     */ _renderHighlight(context) {
        if (!this.isHighlighted) return;
        context.save();
        context.strokeStyle = this._highlightColor;
        context.lineWidth = this._highlightLineWidth;
        this._renderHighlightSpecific(context);
        context.restore();
    }
    /**
     * @internal
     */ _renderHighlightSpecific(context) {
        context.strokeRect(this._currentMeasure.left, this._currentMeasure.top, this._currentMeasure.width, this._currentMeasure.height);
    }
    _getColor(context) {
        return this.gradient ? this.gradient.getCanvasGradient(context) : this.color;
    }
    /**
     * @internal
     */ _applyStates(context) {
        if (this._isFontSizeInPercentage) this._fontSet = true;
        if (this._host && this._host.useSmallestIdeal && !this._font) this._fontSet = true;
        if (this._fontSet) {
            this._prepareFont();
            this._fontSet = false;
        }
        if (this._font) context.font = this._font;
        if (this._color || this.gradient) context.fillStyle = this._getColor(context);
        if ($b6009490051f50fb$export$7a7fa4424cb20976.AllowAlphaInheritance) context.globalAlpha *= this._alpha;
        else if (this._alphaSet) context.globalAlpha = this.parent && !this.parent.renderToIntermediateTexture ? this.parent.alpha * this._alpha : this._alpha;
    }
    /**
     * @internal
     */ _layout(parentMeasure, context) {
        if (!this.isDirty && (!this.isVisible || this.notRenderable)) return false;
        if (this._isDirty || !this._cachedParentMeasure.isEqualsTo(parentMeasure)) {
            this.host._numLayoutCalls++;
            this._currentMeasure.addAndTransformToRef(this._transformMatrix, -this._paddingLeftInPixels | 0, -this._paddingTopInPixels | 0, this._paddingRightInPixels | 0, this._paddingBottomInPixels | 0, this._prevCurrentMeasureTransformedIntoGlobalSpace);
            context.save();
            this._applyStates(context);
            let rebuildCount = 0;
            do {
                this._rebuildLayout = false;
                this._processMeasures(parentMeasure, context);
                rebuildCount++;
            }while (this._rebuildLayout && rebuildCount < 3);
            if (rebuildCount >= 3) (0, $kVtWi.Logger).Error(`Layout cycle detected in GUI (Control name=${this.name}, uniqueId=${this.uniqueId})`);
            context.restore();
            this.invalidateRect();
            this._evaluateClippingState(parentMeasure);
        }
        this._wasDirty = this._isDirty;
        this._isDirty = false;
        return true;
    }
    /**
     * @internal
     */ _processMeasures(parentMeasure, context) {
        this._tempPaddingMeasure.copyFrom(parentMeasure);
        // Apply padding if in correct mode
        if (this.parent && this.parent.descendantsOnlyPadding) {
            this._tempPaddingMeasure.left += this.parent.paddingLeftInPixels;
            this._tempPaddingMeasure.top += this.parent.paddingTopInPixels;
            this._tempPaddingMeasure.width -= this.parent.paddingLeftInPixels + this.parent.paddingRightInPixels;
            this._tempPaddingMeasure.height -= this.parent.paddingTopInPixels + this.parent.paddingBottomInPixels;
        }
        this._currentMeasure.copyFrom(this._tempPaddingMeasure);
        // Let children take some pre-measurement actions
        this._preMeasure(this._tempPaddingMeasure, context);
        this._measure();
        // Let children take some post-measurement actions
        this._postMeasure(this._tempPaddingMeasure, context);
        this._computeAlignment(this._tempPaddingMeasure, context);
        // Convert to int values
        this._currentMeasure.left = this._currentMeasure.left | 0;
        this._currentMeasure.top = this._currentMeasure.top | 0;
        this._currentMeasure.width = this._currentMeasure.width | 0;
        this._currentMeasure.height = this._currentMeasure.height | 0;
        // Let children add more features
        this._additionalProcessing(this._tempPaddingMeasure, context);
        this._cachedParentMeasure.copyFrom(this._tempPaddingMeasure);
        this._currentMeasure.transformToRef(this._transformMatrix, this._evaluatedMeasure);
        if (this.onDirtyObservable.hasObservers()) this.onDirtyObservable.notifyObservers(this);
    }
    _evaluateClippingState(parentMeasure) {
        // Since transformMatrix is used here, we need to have it freshly computed
        this._transform();
        this._currentMeasure.transformToRef(this._transformMatrix, this._evaluatedMeasure);
        if (this.parent && this.parent.clipChildren) {
            parentMeasure.transformToRef(this.parent._transformMatrix, this._evaluatedParentMeasure);
            // Early clip
            if (this._evaluatedMeasure.left > this._evaluatedParentMeasure.left + this._evaluatedParentMeasure.width) {
                this._isClipped = true;
                return;
            }
            if (this._evaluatedMeasure.left + this._evaluatedMeasure.width < this._evaluatedParentMeasure.left) {
                this._isClipped = true;
                return;
            }
            if (this._evaluatedMeasure.top > this._evaluatedParentMeasure.top + this._evaluatedParentMeasure.height) {
                this._isClipped = true;
                return;
            }
            if (this._evaluatedMeasure.top + this._evaluatedMeasure.height < this._evaluatedParentMeasure.top) {
                this._isClipped = true;
                return;
            }
        }
        this._isClipped = false;
    }
    /** @internal */ _measure() {
        // Width / Height
        if (this._width.isPixel) this._currentMeasure.width = this._width.getValue(this._host);
        else this._currentMeasure.width *= this._width.getValue(this._host);
        if (this._height.isPixel) this._currentMeasure.height = this._height.getValue(this._host);
        else this._currentMeasure.height *= this._height.getValue(this._host);
        if (this._fixedRatio !== 0) {
            if (this._fixedRatioMasterIsWidth) this._currentMeasure.height = this._currentMeasure.width * this._fixedRatio;
            else this._currentMeasure.width = this._currentMeasure.height * this._fixedRatio;
        }
    }
    /**
     * @internal
     */ _computeAlignment(parentMeasure, context) {
        const width = this._currentMeasure.width;
        const height = this._currentMeasure.height;
        const parentWidth = parentMeasure.width;
        const parentHeight = parentMeasure.height;
        // Left / top
        let x = 0;
        let y = 0;
        switch(this.horizontalAlignment){
            case $b6009490051f50fb$export$7a7fa4424cb20976.HORIZONTAL_ALIGNMENT_LEFT:
                x = 0;
                break;
            case $b6009490051f50fb$export$7a7fa4424cb20976.HORIZONTAL_ALIGNMENT_RIGHT:
                x = parentWidth - width;
                break;
            case $b6009490051f50fb$export$7a7fa4424cb20976.HORIZONTAL_ALIGNMENT_CENTER:
                x = (parentWidth - width) / 2;
                break;
        }
        switch(this.verticalAlignment){
            case $b6009490051f50fb$export$7a7fa4424cb20976.VERTICAL_ALIGNMENT_TOP:
                y = 0;
                break;
            case $b6009490051f50fb$export$7a7fa4424cb20976.VERTICAL_ALIGNMENT_BOTTOM:
                y = parentHeight - height;
                break;
            case $b6009490051f50fb$export$7a7fa4424cb20976.VERTICAL_ALIGNMENT_CENTER:
                y = (parentHeight - height) / 2;
                break;
        }
        if (!this.descendantsOnlyPadding) {
            if (this._paddingLeft.isPixel) {
                this._currentMeasure.left += this._paddingLeft.getValue(this._host);
                this._currentMeasure.width -= this._paddingLeft.getValue(this._host);
            } else {
                this._currentMeasure.left += parentWidth * this._paddingLeft.getValue(this._host);
                this._currentMeasure.width -= parentWidth * this._paddingLeft.getValue(this._host);
            }
            if (this._paddingRight.isPixel) this._currentMeasure.width -= this._paddingRight.getValue(this._host);
            else this._currentMeasure.width -= parentWidth * this._paddingRight.getValue(this._host);
            if (this._paddingTop.isPixel) {
                this._currentMeasure.top += this._paddingTop.getValue(this._host);
                this._currentMeasure.height -= this._paddingTop.getValue(this._host);
            } else {
                this._currentMeasure.top += parentHeight * this._paddingTop.getValue(this._host);
                this._currentMeasure.height -= parentHeight * this._paddingTop.getValue(this._host);
            }
            if (this._paddingBottom.isPixel) this._currentMeasure.height -= this._paddingBottom.getValue(this._host);
            else this._currentMeasure.height -= parentHeight * this._paddingBottom.getValue(this._host);
        }
        if (this._left.isPixel) this._currentMeasure.left += this._left.getValue(this._host);
        else this._currentMeasure.left += parentWidth * this._left.getValue(this._host);
        if (this._top.isPixel) this._currentMeasure.top += this._top.getValue(this._host);
        else this._currentMeasure.top += parentHeight * this._top.getValue(this._host);
        this._currentMeasure.left += x;
        this._currentMeasure.top += y;
    }
    /**
     * @internal
     */ _preMeasure(parentMeasure, context) {
    // Do nothing
    }
    /**
     * @internal
     */ _postMeasure(parentMeasure, context) {
    // Do nothing
    }
    /**
     * @internal
     */ _additionalProcessing(parentMeasure, context) {
    // Do nothing
    }
    /**
     * @internal
     */ _clipForChildren(context) {
    // DO nothing
    }
    _clip(context, invalidatedRectangle) {
        context.beginPath();
        $b6009490051f50fb$export$7a7fa4424cb20976._ClipMeasure.copyFrom(this._currentMeasure);
        if (invalidatedRectangle) {
            // Rotate the invalidated rect into the control's space
            invalidatedRectangle.transformToRef(this._invertTransformMatrix, this._tmpMeasureA);
            // Get the intersection of the rect in context space and the current context
            const intersection = new (0, $lFAVI.Measure)(0, 0, 0, 0);
            intersection.left = Math.max(this._tmpMeasureA.left, this._currentMeasure.left);
            intersection.top = Math.max(this._tmpMeasureA.top, this._currentMeasure.top);
            intersection.width = Math.min(this._tmpMeasureA.left + this._tmpMeasureA.width, this._currentMeasure.left + this._currentMeasure.width) - intersection.left;
            intersection.height = Math.min(this._tmpMeasureA.top + this._tmpMeasureA.height, this._currentMeasure.top + this._currentMeasure.height) - intersection.top;
            $b6009490051f50fb$export$7a7fa4424cb20976._ClipMeasure.copyFrom(intersection);
        }
        if (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) {
            const shadowOffsetX = this.shadowOffsetX;
            const shadowOffsetY = this.shadowOffsetY;
            const shadowBlur = this.shadowBlur;
            const leftShadowOffset = Math.min(Math.min(shadowOffsetX, 0) - shadowBlur * 2, 0);
            const rightShadowOffset = Math.max(Math.max(shadowOffsetX, 0) + shadowBlur * 2, 0);
            const topShadowOffset = Math.min(Math.min(shadowOffsetY, 0) - shadowBlur * 2, 0);
            const bottomShadowOffset = Math.max(Math.max(shadowOffsetY, 0) + shadowBlur * 2, 0);
            context.rect($b6009490051f50fb$export$7a7fa4424cb20976._ClipMeasure.left + leftShadowOffset, $b6009490051f50fb$export$7a7fa4424cb20976._ClipMeasure.top + topShadowOffset, $b6009490051f50fb$export$7a7fa4424cb20976._ClipMeasure.width + rightShadowOffset - leftShadowOffset, $b6009490051f50fb$export$7a7fa4424cb20976._ClipMeasure.height + bottomShadowOffset - topShadowOffset);
        } else context.rect($b6009490051f50fb$export$7a7fa4424cb20976._ClipMeasure.left, $b6009490051f50fb$export$7a7fa4424cb20976._ClipMeasure.top, $b6009490051f50fb$export$7a7fa4424cb20976._ClipMeasure.width, $b6009490051f50fb$export$7a7fa4424cb20976._ClipMeasure.height);
        context.clip();
    }
    /**
     * @internal
     */ _render(context, invalidatedRectangle) {
        if (!this.isVisible || this.notRenderable || this._isClipped) {
            this._isDirty = false;
            return false;
        }
        this.host._numRenderCalls++;
        context.save();
        this._applyStates(context);
        // Transform
        this._transform(context);
        // Clip
        if (this.clipContent) this._clip(context, invalidatedRectangle);
        if (this.onBeforeDrawObservable.hasObservers()) this.onBeforeDrawObservable.notifyObservers(this);
        if (this.useBitmapCache && !this._wasDirty && this._cacheData) context.putImageData(this._cacheData, this._currentMeasure.left, this._currentMeasure.top);
        else this._draw(context, invalidatedRectangle);
        if (this.useBitmapCache && this._wasDirty) this._cacheData = context.getImageData(this._currentMeasure.left, this._currentMeasure.top, this._currentMeasure.width, this._currentMeasure.height);
        this._renderHighlight(context);
        if (this.onAfterDrawObservable.hasObservers()) this.onAfterDrawObservable.notifyObservers(this);
        context.restore();
        return true;
    }
    /**
     * @internal
     */ _draw(context, invalidatedRectangle) {
    // Do nothing
    }
    /**
     * Tests if a given coordinates belong to the current control
     * @param x defines x coordinate to test
     * @param y defines y coordinate to test
     * @returns true if the coordinates are inside the control
     */ contains(x, y) {
        // Invert transform
        this._invertTransformMatrix.transformCoordinates(x, y, this._transformedPosition);
        x = this._transformedPosition.x;
        y = this._transformedPosition.y;
        // Check
        if (x < this._currentMeasure.left) return false;
        if (x > this._currentMeasure.left + this._currentMeasure.width) return false;
        if (y < this._currentMeasure.top) return false;
        if (y > this._currentMeasure.top + this._currentMeasure.height) return false;
        if (this.isPointerBlocker) this._host._shouldBlockPointer = true;
        return true;
    }
    /**
     * @internal
     */ _processPicking(x, y, pi, type, pointerId, buttonIndex, deltaX, deltaY) {
        if (!this._isEnabled) return false;
        if (!this.isHitTestVisible || !this.isVisible || this._doNotRender) return false;
        if (!this.contains(x, y)) return false;
        this._processObservables(type, x, y, pi, pointerId, buttonIndex, deltaX, deltaY);
        return true;
    }
    /**
     * @internal
     */ _onPointerMove(target, coordinates, pointerId, pi) {
        const canNotify = this.onPointerMoveObservable.notifyObservers(coordinates, -1, target, this, pi);
        if (canNotify && this.parent != null && !this.isPointerBlocker) this.parent._onPointerMove(target, coordinates, pointerId, pi);
    }
    /**
     * @internal
     */ _onPointerEnter(target, pi) {
        if (!this._isEnabled) return false;
        if (this._enterCount > 0) return false;
        if (this._enterCount === -1) // -1 is for touch input, we are now sure we are with a mouse or pencil
        this._enterCount = 0;
        this._enterCount++;
        const canNotify = this.onPointerEnterObservable.notifyObservers(this, -1, target, this, pi);
        if (canNotify && this.parent != null && !this.isPointerBlocker) this.parent._onPointerEnter(target, pi);
        return true;
    }
    /**
     * @internal
     */ _onPointerOut(target, pi, force = false) {
        if (!force && (!this._isEnabled || target === this)) return;
        this._enterCount = 0;
        let canNotify = true;
        if (!target.isAscendant(this)) canNotify = this.onPointerOutObservable.notifyObservers(this, -1, target, this, pi);
        if (canNotify && this.parent != null && !this.isPointerBlocker) this.parent._onPointerOut(target, pi, force);
    }
    /**
     * @internal
     */ _onPointerDown(target, coordinates, pointerId, buttonIndex, pi) {
        // Prevent pointerout to lose control context.
        // Event redundancy is checked inside the function.
        this._onPointerEnter(this, pi);
        if (this._downCount !== 0) return false;
        this._downCount++;
        this._downPointerIds[pointerId] = true;
        const canNotify = this.onPointerDownObservable.notifyObservers(new (0, $jqbkF.Vector2WithInfo)(coordinates, buttonIndex), -1, target, this, pi);
        if (canNotify && this.parent != null && !this.isPointerBlocker) this.parent._onPointerDown(target, coordinates, pointerId, buttonIndex, pi);
        if (pi && this.uniqueId !== this._host.rootContainer.uniqueId) this._host._capturedPointerIds.add(pi.event.pointerId);
        return true;
    }
    /**
     * @internal
     */ _onPointerUp(target, coordinates, pointerId, buttonIndex, notifyClick, pi) {
        if (!this._isEnabled) return;
        this._downCount = 0;
        delete this._downPointerIds[pointerId];
        let canNotifyClick = notifyClick;
        if (notifyClick && (this._enterCount > 0 || this._enterCount === -1)) canNotifyClick = this.onPointerClickObservable.notifyObservers(new (0, $jqbkF.Vector2WithInfo)(coordinates, buttonIndex), -1, target, this, pi);
        const canNotify = this.onPointerUpObservable.notifyObservers(new (0, $jqbkF.Vector2WithInfo)(coordinates, buttonIndex), -1, target, this, pi);
        if (canNotify && this.parent != null && !this.isPointerBlocker) this.parent._onPointerUp(target, coordinates, pointerId, buttonIndex, canNotifyClick, pi);
        if (pi && this.uniqueId !== this._host.rootContainer.uniqueId) this._host._capturedPointerIds.delete(pi.event.pointerId);
    }
    /**
     * @internal
     */ _forcePointerUp(pointerId = null) {
        if (pointerId !== null) this._onPointerUp(this, (0, $ha1VO.Vector2).Zero(), pointerId, 0, true);
        else for(const key in this._downPointerIds)this._onPointerUp(this, (0, $ha1VO.Vector2).Zero(), +key, 0, true);
    }
    /**
     * @internal
     */ _onWheelScroll(deltaX, deltaY) {
        if (!this._isEnabled) return;
        const canNotify = this.onWheelObservable.notifyObservers(new (0, $ha1VO.Vector2)(deltaX, deltaY));
        if (canNotify && this.parent != null) this.parent._onWheelScroll(deltaX, deltaY);
    }
    /** @internal */ _onCanvasBlur() {}
    /**
     * @internal
     */ _processObservables(type, x, y, pi, pointerId, buttonIndex, deltaX, deltaY) {
        if (!this._isEnabled) return false;
        this._dummyVector2.copyFromFloats(x, y);
        if (type === (0, $cfkw4.PointerEventTypes).POINTERMOVE) {
            this._onPointerMove(this, this._dummyVector2, pointerId, pi);
            const previousControlOver = this._host._lastControlOver[pointerId];
            if (previousControlOver && previousControlOver !== this) previousControlOver._onPointerOut(this, pi);
            if (previousControlOver !== this) this._onPointerEnter(this, pi);
            this._host._lastControlOver[pointerId] = this;
            return true;
        }
        if (type === (0, $cfkw4.PointerEventTypes).POINTERDOWN) {
            this._onPointerDown(this, this._dummyVector2, pointerId, buttonIndex, pi);
            this._host._registerLastControlDown(this, pointerId);
            this._host._lastPickedControl = this;
            return true;
        }
        if (type === (0, $cfkw4.PointerEventTypes).POINTERUP) {
            if (this._host._lastControlDown[pointerId]) this._host._lastControlDown[pointerId]._onPointerUp(this, this._dummyVector2, pointerId, buttonIndex, true, pi);
            delete this._host._lastControlDown[pointerId];
            return true;
        }
        if (type === (0, $cfkw4.PointerEventTypes).POINTERWHEEL) {
            if (this._host._lastControlOver[pointerId]) {
                this._host._lastControlOver[pointerId]._onWheelScroll(deltaX, deltaY);
                return true;
            }
        }
        return false;
    }
    _getStyleProperty(propName, defaultValue) {
        const prop = (this._style && this._style[propName]) ?? this[propName];
        if (!prop && this.parent) return this.parent._getStyleProperty(propName, defaultValue);
        else if (!this.parent) return defaultValue;
        else return prop;
    }
    _prepareFont() {
        if (!this._font && !this._fontSet) return;
        this._font = this._getStyleProperty("fontStyle", "") + " " + this._getStyleProperty("fontWeight", "") + " " + this.fontSizeInPixels + "px " + this._getStyleProperty("fontFamily", "Arial");
        this._fontOffset = $b6009490051f50fb$export$7a7fa4424cb20976._GetFontOffset(this._font);
        //children need to be refreshed
        this.getDescendants().forEach((child)=>child._markAllAsDirty());
    }
    /**
     * A control has a dimension fully defined if that dimension doesn't depend on the parent's dimension.
     * As an example, a control that has dimensions in pixels is fully defined, while in percentage is not fully defined.
     * @param dim the dimension to check (width or height)
     * @returns if the dimension is fully defined
     */ isDimensionFullyDefined(dim) {
        return this.getDimension(dim).isPixel;
    }
    /**
     * Gets the dimension of the control along a specified axis
     * @param dim the dimension to retrieve (width or height)
     * @returns the dimension value along the specified axis
     */ getDimension(dim) {
        if (dim === "width") return this._width;
        else return this._height;
    }
    /**
     * Clones a control and its descendants
     * @param host the texture where the control will be instantiated. Can be empty, in which case the control will be created on the same texture
     * @returns the cloned control
     */ clone(host) {
        const serialization = {};
        this.serialize(serialization, true);
        const controlType = (0, $bOhSV.Tools).Instantiate("BABYLON.GUI." + serialization.className);
        const cloned = new controlType();
        cloned.parse(serialization, host);
        return cloned;
    }
    /**
     * Parses a serialized object into this control
     * @param serializedObject the object with the serialized properties
     * @param host the texture where the control will be instantiated. Can be empty, in which case the control will be created on the same texture
     * @returns this control
     */ parse(serializedObject, host) {
        (0, $6Ho1L.SerializationHelper).Parse(()=>this, serializedObject, null);
        this.name = serializedObject.name;
        this._parseFromContent(serializedObject, host ?? this._host);
        return this;
    }
    /**
     * Serializes the current control
     * @param serializationObject defined the JSON serialized object
     * @param force if the control should be serialized even if the isSerializable flag is set to false (default false)
     */ serialize(serializationObject, force = false) {
        if (!this.isSerializable && !force) return;
        (0, $6Ho1L.SerializationHelper).Serialize(this, serializationObject);
        serializationObject.name = this.name;
        serializationObject.className = this.getClassName();
        // Call prepareFont to guarantee the font is properly set before serializing
        this._prepareFont();
        if (this._font) {
            serializationObject.fontFamily = this._fontFamily;
            serializationObject.fontSize = this.fontSize;
            serializationObject.fontWeight = this.fontWeight;
            serializationObject.fontStyle = this.fontStyle;
        }
        if (this._gradient) {
            serializationObject.gradient = {};
            this._gradient.serialize(serializationObject.gradient);
        }
        // Animations
        (0, $6Ho1L.SerializationHelper).AppendSerializedAnimations(this, serializationObject);
    }
    /**
     * @internal
     */ _parseFromContent(serializedObject, host) {
        if (serializedObject.fontFamily) this.fontFamily = serializedObject.fontFamily;
        if (serializedObject.fontSize) this.fontSize = serializedObject.fontSize;
        if (serializedObject.fontWeight) this.fontWeight = serializedObject.fontWeight;
        if (serializedObject.fontStyle) this.fontStyle = serializedObject.fontStyle;
        // Gradient
        if (serializedObject.gradient) {
            const className = (0, $bOhSV.Tools).Instantiate("BABYLON.GUI." + serializedObject.gradient.className);
            this._gradient = new className();
            this._gradient?.parse(serializedObject.gradient);
        }
        // Animations
        if (serializedObject.animations) {
            this.animations = [];
            for(let animationIndex = 0; animationIndex < serializedObject.animations.length; animationIndex++){
                const parsedAnimation = serializedObject.animations[animationIndex];
                const internalClass = (0, $8DoUR.GetClass)("BABYLON.Animation");
                if (internalClass) this.animations.push(internalClass.Parse(parsedAnimation));
            }
            if (serializedObject.autoAnimate && this._host && this._host.getScene()) this._host.getScene().beginAnimation(this, serializedObject.autoAnimateFrom, serializedObject.autoAnimateTo, serializedObject.autoAnimateLoop, serializedObject.autoAnimateSpeed || 1.0);
        }
        this.fixedRatioMasterIsWidth = serializedObject.fixedRatioMasterIsWidth ?? this.fixedRatioMasterIsWidth;
    }
    /** Releases associated resources */ dispose() {
        this.onDirtyObservable.clear();
        this.onBeforeDrawObservable.clear();
        this.onAfterDrawObservable.clear();
        this.onPointerDownObservable.clear();
        this.onPointerEnterObservable.clear();
        this.onPointerMoveObservable.clear();
        this.onPointerOutObservable.clear();
        this.onPointerUpObservable.clear();
        this.onPointerClickObservable.clear();
        this.onWheelObservable.clear();
        if (this._styleObserver && this._style) {
            this._style.onChangedObservable.remove(this._styleObserver);
            this._styleObserver = null;
        }
        if (this.parent) {
            this.parent.removeControl(this);
            this.parent = null;
        }
        if (this._host) {
            const index = this._host._linkedControls.indexOf(this);
            if (index > -1) this.linkWithMesh(null);
        }
        // Callback
        this.onDisposeObservable.notifyObservers(this);
        this.onDisposeObservable.clear();
    }
    /** HORIZONTAL_ALIGNMENT_LEFT */ static get HORIZONTAL_ALIGNMENT_LEFT() {
        return $b6009490051f50fb$export$7a7fa4424cb20976._HORIZONTAL_ALIGNMENT_LEFT;
    }
    /** HORIZONTAL_ALIGNMENT_RIGHT */ static get HORIZONTAL_ALIGNMENT_RIGHT() {
        return $b6009490051f50fb$export$7a7fa4424cb20976._HORIZONTAL_ALIGNMENT_RIGHT;
    }
    /** HORIZONTAL_ALIGNMENT_CENTER */ static get HORIZONTAL_ALIGNMENT_CENTER() {
        return $b6009490051f50fb$export$7a7fa4424cb20976._HORIZONTAL_ALIGNMENT_CENTER;
    }
    /** VERTICAL_ALIGNMENT_TOP */ static get VERTICAL_ALIGNMENT_TOP() {
        return $b6009490051f50fb$export$7a7fa4424cb20976._VERTICAL_ALIGNMENT_TOP;
    }
    /** VERTICAL_ALIGNMENT_BOTTOM */ static get VERTICAL_ALIGNMENT_BOTTOM() {
        return $b6009490051f50fb$export$7a7fa4424cb20976._VERTICAL_ALIGNMENT_BOTTOM;
    }
    /** VERTICAL_ALIGNMENT_CENTER */ static get VERTICAL_ALIGNMENT_CENTER() {
        return $b6009490051f50fb$export$7a7fa4424cb20976._VERTICAL_ALIGNMENT_CENTER;
    }
    /**
     * @internal
     */ static _GetFontOffset(font) {
        if ($b6009490051f50fb$export$7a7fa4424cb20976._FontHeightSizes[font]) return $b6009490051f50fb$export$7a7fa4424cb20976._FontHeightSizes[font];
        const engine = (0, $ejQPp.EngineStore).LastCreatedEngine;
        if (!engine) throw new Error("Invalid engine. Unable to create a canvas.");
        const result = engine.getFontOffset(font);
        $b6009490051f50fb$export$7a7fa4424cb20976._FontHeightSizes[font] = result;
        return result;
    }
    /**
     * Creates a Control from parsed data
     * @param serializedObject defines parsed data
     * @param host defines the hosting AdvancedDynamicTexture
     * @returns a new Control
     */ static Parse(serializedObject, host) {
        const controlType = (0, $bOhSV.Tools).Instantiate("BABYLON.GUI." + serializedObject.className);
        const control = (0, $6Ho1L.SerializationHelper).Parse(()=>new controlType(), serializedObject, null);
        control.name = serializedObject.name;
        control._parseFromContent(serializedObject, host);
        return control;
    }
    /**
     * @internal
     */ static drawEllipse(x, y, width, height, context) {
        context.translate(x, y);
        context.scale(width, height);
        context.beginPath();
        context.arc(0, 0, 1, 0, 2 * Math.PI);
        context.closePath();
        context.scale(1 / width, 1 / height);
        context.translate(-x, -y);
    }
    /**
     * Returns true if the control is ready to be used
     * @returns
     */ isReady() {
        // Most controls are ready by default, so the default implementation is to return true
        return true;
    }
}
/**
 * Gets or sets a boolean indicating if alpha must be an inherited value (false by default)
 */ $b6009490051f50fb$export$7a7fa4424cb20976.AllowAlphaInheritance = false;
$b6009490051f50fb$export$7a7fa4424cb20976._ClipMeasure = new (0, $lFAVI.Measure)(0, 0, 0, 0);
// Statics
$b6009490051f50fb$export$7a7fa4424cb20976._HORIZONTAL_ALIGNMENT_LEFT = 0;
$b6009490051f50fb$export$7a7fa4424cb20976._HORIZONTAL_ALIGNMENT_RIGHT = 1;
$b6009490051f50fb$export$7a7fa4424cb20976._HORIZONTAL_ALIGNMENT_CENTER = 2;
$b6009490051f50fb$export$7a7fa4424cb20976._VERTICAL_ALIGNMENT_TOP = 0;
$b6009490051f50fb$export$7a7fa4424cb20976._VERTICAL_ALIGNMENT_BOTTOM = 1;
$b6009490051f50fb$export$7a7fa4424cb20976._VERTICAL_ALIGNMENT_CENTER = 2;
$b6009490051f50fb$export$7a7fa4424cb20976._FontHeightSizes = {};
$b6009490051f50fb$export$7a7fa4424cb20976.AddHeader = ()=>{};
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "metadata", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "isHitTestVisible", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "isPointerBlocker", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "isFocusInvisible", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "clipChildren", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "clipContent", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "useBitmapCache", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "shadowOffsetX", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "shadowOffsetY", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "shadowBlur", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "shadowColor", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "hoverCursor", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "fontOffset", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "alpha", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "isSerializable", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "scaleX", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "scaleY", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "rotation", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "transformCenterY", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "transformCenterX", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "horizontalAlignment", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "verticalAlignment", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "fixedRatio", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "fixedRatioMasterIsWidth", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "width", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "height", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "style", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "color", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "gradient", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "zIndex", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "notRenderable", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "isVisible", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "descendantsOnlyPadding", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "paddingLeft", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "paddingRight", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "paddingTop", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "paddingBottom", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "left", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "top", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "linkOffsetX", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "linkOffsetY", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "isEnabled", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "disabledColor", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "disabledColorItem", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "overlapGroup", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $b6009490051f50fb$export$7a7fa4424cb20976.prototype, "overlapDeltaMultiplier", void 0);
(0, $8DoUR.RegisterClass)("BABYLON.GUI.Control", $b6009490051f50fb$export$7a7fa4424cb20976);

});
parcelRegister("dKQam", function(module, exports) {

$parcel$export(module.exports, "ValueAndUnit", () => $a038095510e5ba9b$export$839f347a6ebe19f5);

var $diGQf = parcelRequire("diGQf");
class $a038095510e5ba9b$export$839f347a6ebe19f5 {
    /**
     * Creates a new ValueAndUnit
     * @param value defines the value to store
     * @param unit defines the unit to store - defaults to ValueAndUnit.UNITMODE_PIXEL
     * @param negativeValueAllowed defines a boolean indicating if the value can be negative
     */ constructor(value, /** defines the unit to store */ unit = $a038095510e5ba9b$export$839f347a6ebe19f5.UNITMODE_PIXEL, /** defines a boolean indicating if the value can be negative */ negativeValueAllowed = true){
        this.negativeValueAllowed = negativeValueAllowed;
        this._value = 1;
        this._unit = $a038095510e5ba9b$export$839f347a6ebe19f5.UNITMODE_PIXEL;
        /**
         * Gets or sets a value indicating that this value will not scale accordingly with adaptive scaling property
         * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#adaptive-scaling
         */ this.ignoreAdaptiveScaling = false;
        /**
         * Observable event triggered each time the value or unit changes
         */ this.onChangedObservable = new (0, $diGQf.Observable)();
        this._value = value;
        this._unit = unit;
        this._originalUnit = unit;
    }
    /** Gets a boolean indicating if the value is a percentage */ get isPercentage() {
        return this._unit === $a038095510e5ba9b$export$839f347a6ebe19f5.UNITMODE_PERCENTAGE;
    }
    /** Gets a boolean indicating if the value is store as pixel */ get isPixel() {
        return this._unit === $a038095510e5ba9b$export$839f347a6ebe19f5.UNITMODE_PIXEL;
    }
    /**
     * Gets value (without units)
     * @deprecated use value property instead
     */ get internalValue() {
        return this._value;
    }
    /** Gets value (without units) */ get value() {
        return this._value;
    }
    /** Sets value (without units) */ set value(value) {
        if (value !== this._value) {
            this._value = value;
            this.onChangedObservable.notifyObservers();
        }
    }
    /** Gets units (without value) */ get unit() {
        return this._unit;
    }
    /** Sets units (without value) */ set unit(value) {
        if (value !== this._unit) {
            this._unit = value;
            this.onChangedObservable.notifyObservers();
        }
    }
    /**
     * Gets value as pixel
     * @param host defines the root host
     * @param refValue defines the reference value for percentages
     * @returns the value as pixel
     */ getValueInPixel(host, refValue) {
        if (this.isPixel) return this.getValue(host);
        return this.getValue(host) * refValue;
    }
    /**
     * Update the current value and unit.
     * @param value defines the value to store
     * @param unit defines the unit to store
     * @returns the current ValueAndUnit
     */ updateInPlace(value, unit = $a038095510e5ba9b$export$839f347a6ebe19f5.UNITMODE_PIXEL) {
        if (this.value !== value || this.unit !== unit) {
            // set member variables to notify only once
            this._value = value;
            this._unit = unit;
            this.onChangedObservable.notifyObservers();
        }
        return this;
    }
    /**
     * Gets the value accordingly to its unit
     * @param host  defines the root host
     * @returns the value
     */ getValue(host) {
        if (host && !this.ignoreAdaptiveScaling && this.unit !== $a038095510e5ba9b$export$839f347a6ebe19f5.UNITMODE_PERCENTAGE) {
            let width = 0;
            let height = 0;
            if (host.idealWidth) width = Math.ceil(this._value * host.getSize().width / host.idealWidth);
            if (host.idealHeight) height = Math.ceil(this._value * host.getSize().height / host.idealHeight);
            if (host.useSmallestIdeal && host.idealWidth && host.idealHeight) return window.innerWidth < window.innerHeight ? width : height;
            if (host.idealWidth) // horizontal
            return width;
            if (host.idealHeight) // vertical
            return height;
        }
        return this._value;
    }
    /**
     * Gets a string representation of the value
     * @param host defines the root host
     * @param decimals defines an optional number of decimals to display
     * @returns a string
     */ toString(host, decimals) {
        switch(this._unit){
            case $a038095510e5ba9b$export$839f347a6ebe19f5.UNITMODE_PERCENTAGE:
                {
                    const percentage = this.getValue(host) * 100;
                    return (decimals ? percentage.toFixed(decimals) : percentage) + "%";
                }
            case $a038095510e5ba9b$export$839f347a6ebe19f5.UNITMODE_PIXEL:
                {
                    const pixels = this.getValue(host);
                    return (decimals ? pixels.toFixed(decimals) : pixels) + "px";
                }
        }
        return this._unit.toString();
    }
    /**
     * Store a value parsed from a string
     * @param source defines the source string
     * @returns true if the value was successfully parsed and updated
     */ fromString(source) {
        const match = $a038095510e5ba9b$export$839f347a6ebe19f5._Regex.exec(source.toString());
        if (!match || match.length === 0) return false;
        let sourceValue = parseFloat(match[1]);
        let sourceUnit = this._originalUnit;
        if (!this.negativeValueAllowed) {
            if (sourceValue < 0) sourceValue = 0;
        }
        if (match.length === 4) switch(match[3]){
            case "px":
                sourceUnit = $a038095510e5ba9b$export$839f347a6ebe19f5.UNITMODE_PIXEL;
                break;
            case "%":
                sourceUnit = $a038095510e5ba9b$export$839f347a6ebe19f5.UNITMODE_PERCENTAGE;
                sourceValue /= 100.0;
                break;
        }
        if (sourceValue === this._value && sourceUnit === this._unit) return false;
        this._value = sourceValue;
        this._unit = sourceUnit;
        this.onChangedObservable.notifyObservers();
        return true;
    }
    /** UNITMODE_PERCENTAGE */ static get UNITMODE_PERCENTAGE() {
        return $a038095510e5ba9b$export$839f347a6ebe19f5._UNITMODE_PERCENTAGE;
    }
    /** UNITMODE_PIXEL */ static get UNITMODE_PIXEL() {
        return $a038095510e5ba9b$export$839f347a6ebe19f5._UNITMODE_PIXEL;
    }
}
// Static
$a038095510e5ba9b$export$839f347a6ebe19f5._Regex = /(^-?\d*(\.\d+)?)(%|px)?/;
$a038095510e5ba9b$export$839f347a6ebe19f5._UNITMODE_PERCENTAGE = 0;
$a038095510e5ba9b$export$839f347a6ebe19f5._UNITMODE_PIXEL = 1;

});

parcelRegister("lFAVI", function(module, exports) {

$parcel$export(module.exports, "Measure", () => $fc6a12d4b9dc7831$export$76df7375f104822f);

var $ha1VO = parcelRequire("ha1VO");
const $fc6a12d4b9dc7831$var$tmpRect = [
    new (0, $ha1VO.Vector2)(0, 0),
    new (0, $ha1VO.Vector2)(0, 0),
    new (0, $ha1VO.Vector2)(0, 0),
    new (0, $ha1VO.Vector2)(0, 0)
];
const $fc6a12d4b9dc7831$var$tmpRect2 = [
    new (0, $ha1VO.Vector2)(0, 0),
    new (0, $ha1VO.Vector2)(0, 0),
    new (0, $ha1VO.Vector2)(0, 0),
    new (0, $ha1VO.Vector2)(0, 0)
];
const $fc6a12d4b9dc7831$var$tmpV1 = new (0, $ha1VO.Vector2)(0, 0);
const $fc6a12d4b9dc7831$var$tmpV2 = new (0, $ha1VO.Vector2)(0, 0);
class $fc6a12d4b9dc7831$export$76df7375f104822f {
    /**
     * Creates a new measure
     * @param left defines left coordinate
     * @param top defines top coordinate
     * @param width defines width dimension
     * @param height defines height dimension
     */ constructor(/** defines left coordinate */ left, /** defines top coordinate  */ top, /** defines width dimension  */ width, /** defines height dimension */ height){
        this.left = left;
        this.top = top;
        this.width = width;
        this.height = height;
    }
    /**
     * Copy from another measure
     * @param other defines the other measure to copy from
     */ copyFrom(other) {
        this.left = other.left;
        this.top = other.top;
        this.width = other.width;
        this.height = other.height;
    }
    /**
     * Copy from a group of 4 floats
     * @param left defines left coordinate
     * @param top defines top coordinate
     * @param width defines width dimension
     * @param height defines height dimension
     */ copyFromFloats(left, top, width, height) {
        this.left = left;
        this.top = top;
        this.width = width;
        this.height = height;
    }
    /**
     * Computes the axis aligned bounding box measure for two given measures
     * @param a Input measure
     * @param b Input measure
     * @param result the resulting bounding measure
     */ static CombineToRef(a, b, result) {
        const left = Math.min(a.left, b.left);
        const top = Math.min(a.top, b.top);
        const right = Math.max(a.left + a.width, b.left + b.width);
        const bottom = Math.max(a.top + a.height, b.top + b.height);
        result.left = left;
        result.top = top;
        result.width = right - left;
        result.height = bottom - top;
    }
    /**
     * Computes the axis aligned bounding box of the measure after it is modified by a given transform
     * @param transform the matrix to transform the measure before computing the AABB
     * @param addX number to add to left
     * @param addY number to add to top
     * @param addWidth number to add to width
     * @param addHeight number to add to height
     * @param result the resulting AABB
     */ addAndTransformToRef(transform, addX, addY, addWidth, addHeight, result) {
        const left = this.left + addX;
        const top = this.top + addY;
        const width = this.width + addWidth;
        const height = this.height + addHeight;
        $fc6a12d4b9dc7831$var$tmpRect[0].copyFromFloats(left, top);
        $fc6a12d4b9dc7831$var$tmpRect[1].copyFromFloats(left + width, top);
        $fc6a12d4b9dc7831$var$tmpRect[2].copyFromFloats(left + width, top + height);
        $fc6a12d4b9dc7831$var$tmpRect[3].copyFromFloats(left, top + height);
        $fc6a12d4b9dc7831$var$tmpV1.copyFromFloats(Number.MAX_VALUE, Number.MAX_VALUE);
        $fc6a12d4b9dc7831$var$tmpV2.copyFromFloats(0, 0);
        for(let i = 0; i < 4; i++){
            transform.transformCoordinates($fc6a12d4b9dc7831$var$tmpRect[i].x, $fc6a12d4b9dc7831$var$tmpRect[i].y, $fc6a12d4b9dc7831$var$tmpRect2[i]);
            $fc6a12d4b9dc7831$var$tmpV1.x = Math.floor(Math.min($fc6a12d4b9dc7831$var$tmpV1.x, $fc6a12d4b9dc7831$var$tmpRect2[i].x));
            $fc6a12d4b9dc7831$var$tmpV1.y = Math.floor(Math.min($fc6a12d4b9dc7831$var$tmpV1.y, $fc6a12d4b9dc7831$var$tmpRect2[i].y));
            $fc6a12d4b9dc7831$var$tmpV2.x = Math.ceil(Math.max($fc6a12d4b9dc7831$var$tmpV2.x, $fc6a12d4b9dc7831$var$tmpRect2[i].x));
            $fc6a12d4b9dc7831$var$tmpV2.y = Math.ceil(Math.max($fc6a12d4b9dc7831$var$tmpV2.y, $fc6a12d4b9dc7831$var$tmpRect2[i].y));
        }
        result.left = $fc6a12d4b9dc7831$var$tmpV1.x;
        result.top = $fc6a12d4b9dc7831$var$tmpV1.y;
        result.width = $fc6a12d4b9dc7831$var$tmpV2.x - $fc6a12d4b9dc7831$var$tmpV1.x;
        result.height = $fc6a12d4b9dc7831$var$tmpV2.y - $fc6a12d4b9dc7831$var$tmpV1.y;
    }
    /**
     * Computes the axis aligned bounding box of the measure after it is modified by a given transform
     * @param transform the matrix to transform the measure before computing the AABB
     * @param result the resulting AABB
     */ transformToRef(transform, result) {
        this.addAndTransformToRef(transform, 0, 0, 0, 0, result);
    }
    /**
     * Check equality between this measure and another one
     * @param other defines the other measures
     * @returns true if both measures are equals
     */ isEqualsTo(other) {
        if (this.left !== other.left) return false;
        if (this.top !== other.top) return false;
        if (this.width !== other.width) return false;
        if (this.height !== other.height) return false;
        return true;
    }
    /**
     * Creates an empty measure
     * @returns a new measure
     */ static Empty() {
        return new $fc6a12d4b9dc7831$export$76df7375f104822f(0, 0, 0, 0);
    }
}

});

parcelRegister("jqbkF", function(module, exports) {

$parcel$export(module.exports, "Vector2WithInfo", () => $e2393c5f4672a478$export$b71b64568b3d7bf8);
$parcel$export(module.exports, "Matrix2D", () => $e2393c5f4672a478$export$26e6ecd136a15474);
$parcel$export(module.exports, "MathTools", () => $e2393c5f4672a478$export$65fca0bb37409f64);

var $ha1VO = parcelRequire("ha1VO");

var $53VPf = parcelRequire("53VPf");
class $e2393c5f4672a478$export$b71b64568b3d7bf8 extends (0, $ha1VO.Vector2) {
    /**
     * Creates a new Vector2WithInfo
     * @param source defines the vector2 data to transport
     * @param buttonIndex defines the current mouse button index
     */ constructor(source, /** defines the current mouse button index */ buttonIndex = 0){
        super(source.x, source.y);
        this.buttonIndex = buttonIndex;
    }
}
class $e2393c5f4672a478$export$26e6ecd136a15474 {
    /**
     * Creates a new matrix
     * @param m00 defines value for (0, 0)
     * @param m01 defines value for (0, 1)
     * @param m10 defines value for (1, 0)
     * @param m11 defines value for (1, 1)
     * @param m20 defines value for (2, 0)
     * @param m21 defines value for (2, 1)
     */ constructor(m00, m01, m10, m11, m20, m21){
        /** Gets the internal array of 6 floats used to store matrix data */ this.m = new Float32Array(6);
        this.fromValues(m00, m01, m10, m11, m20, m21);
    }
    /**
     * Fills the matrix from direct values
     * @param m00 defines value for (0, 0)
     * @param m01 defines value for (0, 1)
     * @param m10 defines value for (1, 0)
     * @param m11 defines value for (1, 1)
     * @param m20 defines value for (2, 0)
     * @param m21 defines value for (2, 1)
     * @returns the current modified matrix
     */ fromValues(m00, m01, m10, m11, m20, m21) {
        this.m[0] = m00;
        this.m[1] = m01;
        this.m[2] = m10;
        this.m[3] = m11;
        this.m[4] = m20;
        this.m[5] = m21;
        return this;
    }
    /**
     * Gets matrix determinant
     * @returns the determinant
     */ determinant() {
        return this.m[0] * this.m[3] - this.m[1] * this.m[2];
    }
    /**
     * Inverses the matrix and stores it in a target matrix
     * @param result defines the target matrix
     * @returns the current matrix
     */ invertToRef(result) {
        const l0 = this.m[0];
        const l1 = this.m[1];
        const l2 = this.m[2];
        const l3 = this.m[3];
        const l4 = this.m[4];
        const l5 = this.m[5];
        const det = this.determinant();
        if (det < (0, $53VPf.Epsilon) * (0, $53VPf.Epsilon)) {
            result.m[0] = 0;
            result.m[1] = 0;
            result.m[2] = 0;
            result.m[3] = 0;
            result.m[4] = 0;
            result.m[5] = 0;
            return this;
        }
        const detDiv = 1 / det;
        const det4 = l2 * l5 - l3 * l4;
        const det5 = l1 * l4 - l0 * l5;
        result.m[0] = l3 * detDiv;
        result.m[1] = -l1 * detDiv;
        result.m[2] = -l2 * detDiv;
        result.m[3] = l0 * detDiv;
        result.m[4] = det4 * detDiv;
        result.m[5] = det5 * detDiv;
        return this;
    }
    /**
     * Multiplies the current matrix with another one
     * @param other defines the second operand
     * @param result defines the target matrix
     * @returns the current matrix
     */ multiplyToRef(other, result) {
        const l0 = this.m[0];
        const l1 = this.m[1];
        const l2 = this.m[2];
        const l3 = this.m[3];
        const l4 = this.m[4];
        const l5 = this.m[5];
        const r0 = other.m[0];
        const r1 = other.m[1];
        const r2 = other.m[2];
        const r3 = other.m[3];
        const r4 = other.m[4];
        const r5 = other.m[5];
        result.m[0] = l0 * r0 + l1 * r2;
        result.m[1] = l0 * r1 + l1 * r3;
        result.m[2] = l2 * r0 + l3 * r2;
        result.m[3] = l2 * r1 + l3 * r3;
        result.m[4] = l4 * r0 + l5 * r2 + r4;
        result.m[5] = l4 * r1 + l5 * r3 + r5;
        return this;
    }
    /**
     * Applies the current matrix to a set of 2 floats and stores the result in a vector2
     * @param x defines the x coordinate to transform
     * @param y defines the x coordinate to transform
     * @param result defines the target vector2
     * @returns the current matrix
     */ transformCoordinates(x, y, result) {
        result.x = x * this.m[0] + y * this.m[2] + this.m[4];
        result.y = x * this.m[1] + y * this.m[3] + this.m[5];
        return this;
    }
    // Statics
    /**
     * Creates an identity matrix
     * @returns a new matrix
     */ static Identity() {
        return new $e2393c5f4672a478$export$26e6ecd136a15474(1, 0, 0, 1, 0, 0);
    }
    /**
     * Creates an identity matrix and stores it in a target matrix
     * @param result defines the target matrix
     */ static IdentityToRef(result) {
        result.m[0] = 1;
        result.m[1] = 0;
        result.m[2] = 0;
        result.m[3] = 1;
        result.m[4] = 0;
        result.m[5] = 0;
    }
    /**
     * Creates a translation matrix and stores it in a target matrix
     * @param x defines the x coordinate of the translation
     * @param y defines the y coordinate of the translation
     * @param result defines the target matrix
     */ static TranslationToRef(x, y, result) {
        result.fromValues(1, 0, 0, 1, x, y);
    }
    /**
     * Creates a scaling matrix and stores it in a target matrix
     * @param x defines the x coordinate of the scaling
     * @param y defines the y coordinate of the scaling
     * @param result defines the target matrix
     */ static ScalingToRef(x, y, result) {
        result.fromValues(x, 0, 0, y, 0, 0);
    }
    /**
     * Creates a rotation matrix and stores it in a target matrix
     * @param angle defines the rotation angle
     * @param result defines the target matrix
     */ static RotationToRef(angle, result) {
        const s = Math.sin(angle);
        const c = Math.cos(angle);
        result.fromValues(c, s, -s, c, 0, 0);
    }
    /**
     * Composes a matrix from translation, rotation, scaling and parent matrix and stores it in a target matrix
     * @param tx defines the x coordinate of the translation
     * @param ty defines the y coordinate of the translation
     * @param angle defines the rotation angle
     * @param scaleX defines the x coordinate of the scaling
     * @param scaleY defines the y coordinate of the scaling
     * @param parentMatrix defines the parent matrix to multiply by (can be null)
     * @param result defines the target matrix
     */ static ComposeToRef(tx, ty, angle, scaleX, scaleY, parentMatrix, result) {
        $e2393c5f4672a478$export$26e6ecd136a15474.TranslationToRef(tx, ty, $e2393c5f4672a478$export$26e6ecd136a15474._TempPreTranslationMatrix);
        $e2393c5f4672a478$export$26e6ecd136a15474.ScalingToRef(scaleX, scaleY, $e2393c5f4672a478$export$26e6ecd136a15474._TempScalingMatrix);
        $e2393c5f4672a478$export$26e6ecd136a15474.RotationToRef(angle, $e2393c5f4672a478$export$26e6ecd136a15474._TempRotationMatrix);
        $e2393c5f4672a478$export$26e6ecd136a15474.TranslationToRef(-tx, -ty, $e2393c5f4672a478$export$26e6ecd136a15474._TempPostTranslationMatrix);
        $e2393c5f4672a478$export$26e6ecd136a15474._TempPreTranslationMatrix.multiplyToRef($e2393c5f4672a478$export$26e6ecd136a15474._TempScalingMatrix, $e2393c5f4672a478$export$26e6ecd136a15474._TempCompose0);
        $e2393c5f4672a478$export$26e6ecd136a15474._TempCompose0.multiplyToRef($e2393c5f4672a478$export$26e6ecd136a15474._TempRotationMatrix, $e2393c5f4672a478$export$26e6ecd136a15474._TempCompose1);
        if (parentMatrix) {
            $e2393c5f4672a478$export$26e6ecd136a15474._TempCompose1.multiplyToRef($e2393c5f4672a478$export$26e6ecd136a15474._TempPostTranslationMatrix, $e2393c5f4672a478$export$26e6ecd136a15474._TempCompose2);
            $e2393c5f4672a478$export$26e6ecd136a15474._TempCompose2.multiplyToRef(parentMatrix, result);
        } else $e2393c5f4672a478$export$26e6ecd136a15474._TempCompose1.multiplyToRef($e2393c5f4672a478$export$26e6ecd136a15474._TempPostTranslationMatrix, result);
    }
}
$e2393c5f4672a478$export$26e6ecd136a15474._TempPreTranslationMatrix = $e2393c5f4672a478$export$26e6ecd136a15474.Identity();
$e2393c5f4672a478$export$26e6ecd136a15474._TempPostTranslationMatrix = $e2393c5f4672a478$export$26e6ecd136a15474.Identity();
$e2393c5f4672a478$export$26e6ecd136a15474._TempRotationMatrix = $e2393c5f4672a478$export$26e6ecd136a15474.Identity();
$e2393c5f4672a478$export$26e6ecd136a15474._TempScalingMatrix = $e2393c5f4672a478$export$26e6ecd136a15474.Identity();
$e2393c5f4672a478$export$26e6ecd136a15474._TempCompose0 = $e2393c5f4672a478$export$26e6ecd136a15474.Identity();
$e2393c5f4672a478$export$26e6ecd136a15474._TempCompose1 = $e2393c5f4672a478$export$26e6ecd136a15474.Identity();
$e2393c5f4672a478$export$26e6ecd136a15474._TempCompose2 = $e2393c5f4672a478$export$26e6ecd136a15474.Identity();
class $e2393c5f4672a478$export$65fca0bb37409f64 {
    /**
     * Rounds a number to the nearest multiple of a given precision
     * @param value the value to be rounded
     * @param precision the multiple to which the value will be rounded. Default is 100 (2 decimal digits)
     * @returns
     */ static Round(value, precision = $e2393c5f4672a478$export$65fca0bb37409f64.DefaultRoundingPrecision) {
        return Math.round(value * precision) / precision;
    }
}
/**
 * Default rounding precision for GUI elements. It should be
 * set to a power of ten, where the exponent means the number
 * of decimal digits to round to, i.e, 100 means 2 decimal digits,
 * 1000 means 3 decimal digits, etc. Default is 100 (2 decimal digits).
 */ $e2393c5f4672a478$export$65fca0bb37409f64.DefaultRoundingPrecision = 100;

});




parcelRegister("8wJXS", function(module, exports) {

$parcel$export(module.exports, "TextWrapping", () => $6354f78219616d48$export$f3fa101e5726e5b0);
$parcel$export(module.exports, "TextBlock", () => $6354f78219616d48$export$2db84c782bfb16e2);

var $e0Suo = parcelRequire("e0Suo");

var $diGQf = parcelRequire("diGQf");

var $dKQam = parcelRequire("dKQam");

var $fCNdl = parcelRequire("fCNdl");

var $8DoUR = parcelRequire("8DoUR");

var $ir0rz = parcelRequire("ir0rz");

var $ejQPp = parcelRequire("ejQPp");
var $6354f78219616d48$export$f3fa101e5726e5b0;
(function(TextWrapping) {
    /**
     * Clip the text when it's larger than Control.width; this is the default mode.
     */ TextWrapping[TextWrapping["Clip"] = 0] = "Clip";
    /**
     * Wrap the text word-wise, i.e. try to add line-breaks at word boundary to fit within Control.width.
     */ TextWrapping[TextWrapping["WordWrap"] = 1] = "WordWrap";
    /**
     * Ellipsize the text, i.e. shrink with trailing … when text is larger than Control.width.
     */ TextWrapping[TextWrapping["Ellipsis"] = 2] = "Ellipsis";
    /**
     * Wrap the text word-wise and clip the text when the text's height is larger than the Control.height, and shrink the last line with trailing … .
     */ TextWrapping[TextWrapping["WordWrapEllipsis"] = 3] = "WordWrapEllipsis";
})($6354f78219616d48$export$f3fa101e5726e5b0 || ($6354f78219616d48$export$f3fa101e5726e5b0 = {}));
class $6354f78219616d48$export$2db84c782bfb16e2 extends (0, $fCNdl.Control) {
    /**
     * Return the line list (you may need to use the onLinesReadyObservable to make sure the list is ready)
     */ get lines() {
        return this._lines;
    }
    /**
     * Gets or sets a boolean indicating that the TextBlock will be resized to fit its content

     */ get resizeToFit() {
        return this._resizeToFit;
    }
    /**
     * Gets or sets a boolean indicating that the TextBlock will be resized to fit its content

     */ set resizeToFit(value) {
        if (this._resizeToFit === value) return;
        this._resizeToFit = value;
        if (this._resizeToFit) {
            this._width.ignoreAdaptiveScaling = true;
            this._height.ignoreAdaptiveScaling = true;
        }
        this._markAsDirty();
    }
    /**
     * Gets or sets a boolean indicating if text must be wrapped
     */ get textWrapping() {
        return this._textWrapping;
    }
    /**
     * Gets or sets a boolean indicating if text must be wrapped
     */ set textWrapping(value) {
        if (this._textWrapping === value) return;
        this._textWrapping = +value;
        this._markAsDirty();
    }
    /**
     * Gets or sets text to display
     */ get text() {
        return this._text;
    }
    /**
     * Gets or sets text to display
     */ set text(value) {
        if (this._text === value) return;
        this._text = value + ""; // Making sure it is a text
        this._markAsDirty();
        this.onTextChangedObservable.notifyObservers(this);
    }
    /**
     * Gets or sets text horizontal alignment (BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_CENTER by default)
     */ get textHorizontalAlignment() {
        return this._textHorizontalAlignment;
    }
    /**
     * Gets or sets text horizontal alignment (BABYLON.GUI.Control.HORIZONTAL_ALIGNMENT_CENTER by default)
     */ set textHorizontalAlignment(value) {
        if (this._textHorizontalAlignment === value) return;
        this._textHorizontalAlignment = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets text vertical alignment (BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER by default)
     */ get textVerticalAlignment() {
        return this._textVerticalAlignment;
    }
    /**
     * Gets or sets text vertical alignment (BABYLON.GUI.Control.VERTICAL_ALIGNMENT_CENTER by default)
     */ set textVerticalAlignment(value) {
        if (this._textVerticalAlignment === value) return;
        this._textVerticalAlignment = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets line spacing value
     */ set lineSpacing(value) {
        if (this._lineSpacing.fromString(value)) this._markAsDirty();
    }
    /**
     * Gets or sets line spacing value
     */ get lineSpacing() {
        return this._lineSpacing.toString(this._host);
    }
    /**
     * Gets or sets outlineWidth of the text to display
     */ get outlineWidth() {
        return this._outlineWidth;
    }
    /**
     * Gets or sets outlineWidth of the text to display
     */ set outlineWidth(value) {
        if (this._outlineWidth === value) return;
        this._outlineWidth = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets a boolean indicating that text must have underline
     */ get underline() {
        return this._underline;
    }
    /**
     * Gets or sets a boolean indicating that text must have underline
     */ set underline(value) {
        if (this._underline === value) return;
        this._underline = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets an boolean indicating that text must be crossed out
     */ get lineThrough() {
        return this._lineThrough;
    }
    /**
     * Gets or sets an boolean indicating that text must be crossed out
     */ set lineThrough(value) {
        if (this._lineThrough === value) return;
        this._lineThrough = value;
        this._markAsDirty();
    }
    /**
     * If the outline should be applied to the underline/strike-through too. Has different behavior in Edge/Chrome vs Firefox.
     */ get applyOutlineToUnderline() {
        return this._applyOutlineToUnderline;
    }
    set applyOutlineToUnderline(value) {
        if (this._applyOutlineToUnderline === value) return;
        this._applyOutlineToUnderline = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets outlineColor of the text to display
     */ get outlineColor() {
        return this._outlineColor;
    }
    /**
     * Gets or sets outlineColor of the text to display
     */ set outlineColor(value) {
        if (this._outlineColor === value) return;
        this._outlineColor = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets word divider
     */ get wordDivider() {
        return this._wordDivider;
    }
    /**
     * Gets or sets word divider
     */ set wordDivider(value) {
        if (this._wordDivider === value) return;
        this._wordDivider = value;
        this._markAsDirty();
    }
    /**
     * By default, if a text block has text wrapping other than Clip, its width
     * is not resized even if resizeToFit = true. This parameter forces the width
     * to be resized.
     */ get forceResizeWidth() {
        return this._forceResizeWidth;
    }
    set forceResizeWidth(value) {
        if (this._forceResizeWidth === value) return;
        this._forceResizeWidth = value;
        this._markAsDirty();
    }
    /**
     * Creates a new TextBlock object
     * @param name defines the name of the control
     * @param text defines the text to display (empty string by default)
     */ constructor(/**
     * Defines the name of the control
     */ name, text = ""){
        super(name);
        this.name = name;
        this._text = "";
        this._textWrapping = $6354f78219616d48$export$f3fa101e5726e5b0.Clip;
        this._textHorizontalAlignment = (0, $fCNdl.Control).HORIZONTAL_ALIGNMENT_CENTER;
        this._textVerticalAlignment = (0, $fCNdl.Control).VERTICAL_ALIGNMENT_CENTER;
        this._resizeToFit = false;
        this._lineSpacing = new (0, $dKQam.ValueAndUnit)(0);
        this._outlineWidth = 0;
        this._outlineColor = "white";
        this._underline = false;
        this._lineThrough = false;
        this._wordDivider = " ";
        this._forceResizeWidth = false;
        this._applyOutlineToUnderline = false;
        /**
         * An event triggered after the text is changed
         */ this.onTextChangedObservable = new (0, $diGQf.Observable)();
        /**
         * An event triggered after the text was broken up into lines
         */ this.onLinesReadyObservable = new (0, $diGQf.Observable)();
        this._linesTemp = [];
        this.text = text;
    }
    _getTypeName() {
        return "TextBlock";
    }
    _processMeasures(parentMeasure, context) {
        if (!this._fontOffset || this.isDirty) this._fontOffset = (0, $fCNdl.Control)._GetFontOffset(context.font);
        super._processMeasures(parentMeasure, context);
        // Prepare lines
        this._lines = this._breakLines(this._currentMeasure.width, this._currentMeasure.height, context);
        this.onLinesReadyObservable.notifyObservers(this);
        let maxLineWidth = 0;
        for(let i = 0; i < this._lines.length; i++){
            const line = this._lines[i];
            if (line.width > maxLineWidth) maxLineWidth = line.width;
        }
        if (this._resizeToFit) {
            if (this._textWrapping === $6354f78219616d48$export$f3fa101e5726e5b0.Clip || this._forceResizeWidth) {
                const newWidth = Math.ceil(this._paddingLeftInPixels) + Math.ceil(this._paddingRightInPixels) + Math.ceil(maxLineWidth);
                if (newWidth !== this._width.getValueInPixel(this._host, this._tempParentMeasure.width)) {
                    this._width.updateInPlace(newWidth, (0, $dKQam.ValueAndUnit).UNITMODE_PIXEL);
                    this._rebuildLayout = true;
                }
            }
            let newHeight = this._paddingTopInPixels + this._paddingBottomInPixels + this._fontOffset.height * this._lines.length | 0;
            if (this._lines.length > 0 && this._lineSpacing.internalValue !== 0) {
                let lineSpacing = 0;
                if (this._lineSpacing.isPixel) lineSpacing = this._lineSpacing.getValue(this._host);
                else lineSpacing = this._lineSpacing.getValue(this._host) * this._height.getValueInPixel(this._host, this._cachedParentMeasure.height);
                newHeight += (this._lines.length - 1) * lineSpacing;
            }
            if (newHeight !== this._height.internalValue) {
                this._height.updateInPlace(newHeight, (0, $dKQam.ValueAndUnit).UNITMODE_PIXEL);
                this._rebuildLayout = true;
            }
        }
    }
    _drawText(text, textWidth, y, context) {
        const width = this._currentMeasure.width;
        let x = 0;
        switch(this._textHorizontalAlignment){
            case (0, $fCNdl.Control).HORIZONTAL_ALIGNMENT_LEFT:
                x = 0;
                break;
            case (0, $fCNdl.Control).HORIZONTAL_ALIGNMENT_RIGHT:
                x = width - textWidth;
                break;
            case (0, $fCNdl.Control).HORIZONTAL_ALIGNMENT_CENTER:
                x = (width - textWidth) / 2;
                break;
        }
        if (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) {
            context.shadowColor = this.shadowColor;
            context.shadowBlur = this.shadowBlur;
            context.shadowOffsetX = this.shadowOffsetX;
            context.shadowOffsetY = this.shadowOffsetY;
        }
        if (this.outlineWidth) context.strokeText(text, this._currentMeasure.left + x, y);
        context.fillText(text, this._currentMeasure.left + x, y);
        if (this._underline) this._drawLine(this._currentMeasure.left + x, y + 3, this._currentMeasure.left + x + textWidth, y + 3, context);
        if (this._lineThrough) this._drawLine(this._currentMeasure.left + x, y - this.fontSizeInPixels / 3, this._currentMeasure.left + x + textWidth, y - this.fontSizeInPixels / 3, context);
    }
    _drawLine(xFrom, yFrom, xTo, yTo, context) {
        context.beginPath();
        context.lineWidth = Math.round(this.fontSizeInPixels * 0.05);
        context.moveTo(xFrom, yFrom);
        context.lineTo(xTo, yTo);
        if (this.outlineWidth && this.applyOutlineToUnderline) {
            context.stroke();
            context.fill();
        } else {
            const currentStroke = context.strokeStyle;
            context.strokeStyle = context.fillStyle;
            context.stroke();
            context.strokeStyle = currentStroke;
        }
        context.closePath();
    }
    /**
     * @internal
     */ _draw(context) {
        context.save();
        this._applyStates(context);
        // Render lines
        this._renderLines(context);
        context.restore();
    }
    _applyStates(context) {
        super._applyStates(context);
        if (this.outlineWidth) {
            context.lineWidth = this.outlineWidth;
            context.strokeStyle = this.outlineColor;
            context.lineJoin = "miter";
            context.miterLimit = 2;
        }
    }
    _breakLines(refWidth, refHeight, context) {
        this._linesTemp.length = 0;
        const _lines = this.text.split("\n");
        if (this._textWrapping === $6354f78219616d48$export$f3fa101e5726e5b0.Ellipsis) for (const _line of _lines)this._linesTemp.push(this._parseLineEllipsis(_line, refWidth, context));
        else if (this._textWrapping === $6354f78219616d48$export$f3fa101e5726e5b0.WordWrap) for (const _line of _lines)this._linesTemp.push(...this._parseLineWordWrap(_line, refWidth, context));
        else if (this._textWrapping === $6354f78219616d48$export$f3fa101e5726e5b0.WordWrapEllipsis) for (const _line of _lines)this._linesTemp.push(...this._parseLineWordWrapEllipsis(_line, refWidth, refHeight, context));
        else for (const _line of _lines)this._linesTemp.push(this._parseLine(_line, context));
        return this._linesTemp;
    }
    _parseLine(line = "", context) {
        return {
            text: line,
            width: this._getTextMetricsWidth(context.measureText(line))
        };
    }
    //Calculate how many characters approximately we need to remove
    _getCharsToRemove(lineWidth, width, lineLength) {
        const diff = lineWidth > width ? lineWidth - width : 0;
        // This isn't exact unless the font is monospaced
        const charWidth = lineWidth / lineLength;
        const removeChars = Math.max(Math.floor(diff / charWidth), 1);
        return removeChars;
    }
    _parseLineEllipsis(line = "", width, context) {
        let lineWidth = this._getTextMetricsWidth(context.measureText(line));
        let removeChars = this._getCharsToRemove(lineWidth, width, line.length);
        // unicode support. split('') does not work with unicode!
        // make sure Array.from is available
        const characters = Array.from && Array.from(line);
        if (!characters) {
            // no array.from, use the old method
            while(line.length > 2 && lineWidth > width){
                line = line.slice(0, -removeChars);
                lineWidth = this._getTextMetricsWidth(context.measureText(line + "\u2026"));
                removeChars = this._getCharsToRemove(lineWidth, width, line.length);
            }
            // Add on the end
            line += "\u2026";
        } else while(characters.length && lineWidth > width){
            characters.splice(characters.length - removeChars, removeChars);
            line = `${characters.join("")}\u{2026}`;
            lineWidth = this._getTextMetricsWidth(context.measureText(line));
            removeChars = this._getCharsToRemove(lineWidth, width, line.length);
        }
        return {
            text: line,
            width: lineWidth
        };
    }
    _getTextMetricsWidth(textMetrics) {
        if (textMetrics.actualBoundingBoxLeft !== undefined) return Math.abs(textMetrics.actualBoundingBoxLeft) + Math.abs(textMetrics.actualBoundingBoxRight);
        return textMetrics.width;
    }
    _parseLineWordWrap(line = "", width, context) {
        const lines = [];
        const words = this.wordSplittingFunction ? this.wordSplittingFunction(line) : line.split(this._wordDivider);
        let lineWidth = this._getTextMetricsWidth(context.measureText(line));
        for(let n = 0; n < words.length; n++){
            const testLine = n > 0 ? line + this._wordDivider + words[n] : words[0];
            const testWidth = this._getTextMetricsWidth(context.measureText(testLine));
            if (testWidth > width && n > 0) {
                lines.push({
                    text: line,
                    width: lineWidth
                });
                line = words[n];
                lineWidth = this._getTextMetricsWidth(context.measureText(line));
            } else {
                lineWidth = testWidth;
                line = testLine;
            }
        }
        lines.push({
            text: line,
            width: lineWidth
        });
        return lines;
    }
    _parseLineWordWrapEllipsis(line = "", width, height, context) {
        const lines = this._parseLineWordWrap(line, width, context);
        for(let n = 1; n <= lines.length; n++){
            const currentHeight = this._computeHeightForLinesOf(n);
            if (currentHeight > height && n > 1) {
                const lastLine = lines[n - 2];
                const currentLine = lines[n - 1];
                lines[n - 2] = this._parseLineEllipsis(lastLine.text + this._wordDivider + currentLine.text, width, context);
                const linesToRemove = lines.length - n + 1;
                for(let i = 0; i < linesToRemove; i++)lines.pop();
                return lines;
            }
        }
        return lines;
    }
    _renderLines(context) {
        if (!this._fontOffset || !this._lines) return;
        const height = this._currentMeasure.height;
        let rootY = 0;
        switch(this._textVerticalAlignment){
            case (0, $fCNdl.Control).VERTICAL_ALIGNMENT_TOP:
                rootY = this._fontOffset.ascent;
                break;
            case (0, $fCNdl.Control).VERTICAL_ALIGNMENT_BOTTOM:
                rootY = height - this._fontOffset.height * (this._lines.length - 1) - this._fontOffset.descent;
                break;
            case (0, $fCNdl.Control).VERTICAL_ALIGNMENT_CENTER:
                rootY = this._fontOffset.ascent + (height - this._fontOffset.height * this._lines.length) / 2;
                break;
        }
        rootY += this._currentMeasure.top;
        for(let i = 0; i < this._lines.length; i++){
            const line = this._lines[i];
            if (i !== 0 && this._lineSpacing.internalValue !== 0) {
                if (this._lineSpacing.isPixel) rootY += this._lineSpacing.getValue(this._host);
                else rootY = rootY + this._lineSpacing.getValue(this._host) * this._height.getValueInPixel(this._host, this._cachedParentMeasure.height);
            }
            this._drawText(line.text, line.width, rootY, context);
            rootY += this._fontOffset.height;
        }
    }
    _computeHeightForLinesOf(lineCount) {
        let newHeight = this._paddingTopInPixels + this._paddingBottomInPixels + this._fontOffset.height * lineCount;
        if (lineCount > 0 && this._lineSpacing.internalValue !== 0) {
            let lineSpacing = 0;
            if (this._lineSpacing.isPixel) lineSpacing = this._lineSpacing.getValue(this._host);
            else lineSpacing = this._lineSpacing.getValue(this._host) * this._height.getValueInPixel(this._host, this._cachedParentMeasure.height);
            newHeight += (lineCount - 1) * lineSpacing;
        }
        return newHeight;
    }
    isDimensionFullyDefined(dim) {
        if (this.resizeToFit) return true;
        return super.isDimensionFullyDefined(dim);
    }
    /**
     * Given a width constraint applied on the text block, find the expected height
     * @returns expected height
     */ computeExpectedHeight() {
        if (this.text && this.widthInPixels) {
            // Should abstract platform instead of using LastCreatedEngine
            const context = (0, $ejQPp.EngineStore).LastCreatedEngine?.createCanvas(0, 0).getContext("2d");
            if (context) {
                this._applyStates(context);
                if (!this._fontOffset) this._fontOffset = (0, $fCNdl.Control)._GetFontOffset(context.font);
                const lines = this._lines ? this._lines : this._breakLines(this.widthInPixels - this._paddingLeftInPixels - this._paddingRightInPixels, this.heightInPixels - this._paddingTopInPixels - this._paddingBottomInPixels, context);
                return this._computeHeightForLinesOf(lines.length);
            }
        }
        return 0;
    }
    dispose() {
        super.dispose();
        this.onTextChangedObservable.clear();
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6354f78219616d48$export$2db84c782bfb16e2.prototype, "resizeToFit", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6354f78219616d48$export$2db84c782bfb16e2.prototype, "textWrapping", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6354f78219616d48$export$2db84c782bfb16e2.prototype, "text", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6354f78219616d48$export$2db84c782bfb16e2.prototype, "textHorizontalAlignment", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6354f78219616d48$export$2db84c782bfb16e2.prototype, "textVerticalAlignment", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6354f78219616d48$export$2db84c782bfb16e2.prototype, "lineSpacing", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6354f78219616d48$export$2db84c782bfb16e2.prototype, "outlineWidth", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6354f78219616d48$export$2db84c782bfb16e2.prototype, "underline", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6354f78219616d48$export$2db84c782bfb16e2.prototype, "lineThrough", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6354f78219616d48$export$2db84c782bfb16e2.prototype, "applyOutlineToUnderline", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6354f78219616d48$export$2db84c782bfb16e2.prototype, "outlineColor", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6354f78219616d48$export$2db84c782bfb16e2.prototype, "wordDivider", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $6354f78219616d48$export$2db84c782bfb16e2.prototype, "forceResizeWidth", null);
(0, $8DoUR.RegisterClass)("BABYLON.GUI.TextBlock", $6354f78219616d48$export$2db84c782bfb16e2);

});

parcelRegister("8puFn", function(module, exports) {

$parcel$export(module.exports, "Image", () => $61f8723933a76099$export$3e431a229df88919);

var $e0Suo = parcelRequire("e0Suo");

var $diGQf = parcelRequire("diGQf");

var $bOhSV = parcelRequire("bOhSV");

var $fCNdl = parcelRequire("fCNdl");

var $8DoUR = parcelRequire("8DoUR");

var $ir0rz = parcelRequire("ir0rz");

var $ejQPp = parcelRequire("ejQPp");
class $61f8723933a76099$export$3e431a229df88919 extends (0, $fCNdl.Control) {
    /**
     * Gets a boolean indicating that the content is loaded
     */ get isLoaded() {
        return this._loaded;
    }
    isReady() {
        return this.isLoaded;
    }
    /**
     * Gets or sets a boolean indicating if pointers should only be validated on pixels with alpha > 0.
     * Beware using this as this will consume more memory as the image has to be stored twice
     */ get detectPointerOnOpaqueOnly() {
        return this._detectPointerOnOpaqueOnly;
    }
    set detectPointerOnOpaqueOnly(value) {
        if (this._detectPointerOnOpaqueOnly === value) return;
        this._detectPointerOnOpaqueOnly = value;
    }
    /**
     * Gets or sets the left value for slicing (9-patch)
     */ get sliceLeft() {
        return this._sliceLeft;
    }
    set sliceLeft(value) {
        if (this._sliceLeft === value) return;
        this._sliceLeft = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets the right value for slicing (9-patch)
     */ get sliceRight() {
        return this._sliceRight;
    }
    set sliceRight(value) {
        if (this._sliceRight === value) return;
        this._sliceRight = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets the top value for slicing (9-patch)
     */ get sliceTop() {
        return this._sliceTop;
    }
    set sliceTop(value) {
        if (this._sliceTop === value) return;
        this._sliceTop = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets the bottom value for slicing (9-patch)
     */ get sliceBottom() {
        return this._sliceBottom;
    }
    set sliceBottom(value) {
        if (this._sliceBottom === value) return;
        this._sliceBottom = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets the left coordinate in the source image
     */ get sourceLeft() {
        return this._sourceLeft;
    }
    set sourceLeft(value) {
        if (this._sourceLeft === value) return;
        this._sourceLeft = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets the top coordinate in the source image
     */ get sourceTop() {
        return this._sourceTop;
    }
    set sourceTop(value) {
        if (this._sourceTop === value) return;
        this._sourceTop = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets the width to capture in the source image
     */ get sourceWidth() {
        return this._sourceWidth;
    }
    set sourceWidth(value) {
        if (this._sourceWidth === value) return;
        this._sourceWidth = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets the height to capture in the source image
     */ get sourceHeight() {
        return this._sourceHeight;
    }
    set sourceHeight(value) {
        if (this._sourceHeight === value) return;
        this._sourceHeight = value;
        this._markAsDirty();
    }
    /**
     * Gets the image width
     */ get imageWidth() {
        return this._imageWidth;
    }
    /**
     * Gets the image height
     */ get imageHeight() {
        return this._imageHeight;
    }
    /**
     * Gets or sets a boolean indicating if nine patch slices (left, top, right, bottom) should be read from image data
     */ get populateNinePatchSlicesFromImage() {
        return this._populateNinePatchSlicesFromImage;
    }
    set populateNinePatchSlicesFromImage(value) {
        if (this._populateNinePatchSlicesFromImage === value) return;
        this._populateNinePatchSlicesFromImage = value;
        if (this._populateNinePatchSlicesFromImage && this._loaded) this._extractNinePatchSliceDataFromImage();
    }
    /** Indicates if the format of the image is SVG */ get isSVG() {
        return this._isSVG;
    }
    /** Gets the status of the SVG attributes computation (sourceLeft, sourceTop, sourceWidth, sourceHeight) */ get svgAttributesComputationCompleted() {
        return this._svgAttributesComputationCompleted;
    }
    /**
     * Gets or sets a boolean indicating if the image can force its container to adapt its size
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#image
     */ get autoScale() {
        return this._autoScale;
    }
    set autoScale(value) {
        if (this._autoScale === value) return;
        this._autoScale = value;
        if (value && this._loaded) this.synchronizeSizeWithContent();
    }
    /** Gets or sets the stretching mode used by the image */ get stretch() {
        return this._stretch;
    }
    set stretch(value) {
        if (this._stretch === value) return;
        this._stretch = value;
        this._markAsDirty();
    }
    /**
     * @internal
     */ _rotate90(n, preserveProperties = false) {
        const width = this._domImage.width;
        const height = this._domImage.height;
        // Should abstract platform instead of using LastCreatedEngine
        const engine = this._host?.getScene()?.getEngine() || (0, $ejQPp.EngineStore).LastCreatedEngine;
        if (!engine) throw new Error("Invalid engine. Unable to create a canvas.");
        const canvas = engine.createCanvas(height, width);
        const context = canvas.getContext("2d");
        context.translate(canvas.width / 2, canvas.height / 2);
        context.rotate(n * Math.PI / 2);
        context.drawImage(this._domImage, 0, 0, width, height, -width / 2, -height / 2, width, height);
        const dataUrl = canvas.toDataURL("image/jpg");
        const rotatedImage = new $61f8723933a76099$export$3e431a229df88919(this.name + "rotated", dataUrl);
        if (preserveProperties) {
            rotatedImage._stretch = this._stretch;
            rotatedImage._autoScale = this._autoScale;
            rotatedImage._cellId = this._cellId;
            rotatedImage._cellWidth = n % 1 ? this._cellHeight : this._cellWidth;
            rotatedImage._cellHeight = n % 1 ? this._cellWidth : this._cellHeight;
        }
        this._handleRotationForSVGImage(this, rotatedImage, n);
        this._imageDataCache.data = null;
        return rotatedImage;
    }
    _handleRotationForSVGImage(srcImage, dstImage, n) {
        if (!srcImage._isSVG) return;
        if (srcImage._svgAttributesComputationCompleted) {
            this._rotate90SourceProperties(srcImage, dstImage, n);
            this._markAsDirty();
        } else srcImage.onSVGAttributesComputedObservable.addOnce(()=>{
            this._rotate90SourceProperties(srcImage, dstImage, n);
            this._markAsDirty();
        });
    }
    _rotate90SourceProperties(srcImage, dstImage, n) {
        let srcLeft = srcImage.sourceLeft, srcTop = srcImage.sourceTop, srcWidth = srcImage.domImage.width, srcHeight = srcImage.domImage.height;
        let dstLeft = srcLeft, dstTop = srcTop, dstWidth = srcImage.sourceWidth, dstHeight = srcImage.sourceHeight;
        if (n != 0) {
            const mult = n < 0 ? -1 : 1;
            n = n % 4;
            for(let i = 0; i < Math.abs(n); ++i){
                dstLeft = -(srcTop - srcHeight / 2) * mult + srcHeight / 2;
                dstTop = (srcLeft - srcWidth / 2) * mult + srcWidth / 2;
                [dstWidth, dstHeight] = [
                    dstHeight,
                    dstWidth
                ];
                if (n < 0) dstTop -= dstHeight;
                else dstLeft -= dstWidth;
                srcLeft = dstLeft;
                srcTop = dstTop;
                [srcWidth, srcHeight] = [
                    srcHeight,
                    srcWidth
                ];
            }
        }
        dstImage.sourceLeft = dstLeft;
        dstImage.sourceTop = dstTop;
        dstImage.sourceWidth = dstWidth;
        dstImage.sourceHeight = dstHeight;
    }
    _extractNinePatchSliceDataFromImage() {
        const width = this._domImage.width;
        const height = this._domImage.height;
        if (!this._workingCanvas) {
            const engine = this._host?.getScene()?.getEngine() || (0, $ejQPp.EngineStore).LastCreatedEngine;
            if (!engine) throw new Error("Invalid engine. Unable to create a canvas.");
            this._workingCanvas = engine.createCanvas(width, height);
        }
        const canvas = this._workingCanvas;
        const context = canvas.getContext("2d");
        context.drawImage(this._domImage, 0, 0, width, height);
        const imageData = context.getImageData(0, 0, width, height);
        // Left and right
        this._sliceLeft = -1;
        this._sliceRight = -1;
        for(let x = 0; x < width; x++){
            const alpha = imageData.data[x * 4 + 3];
            if (alpha > 127 && this._sliceLeft === -1) {
                this._sliceLeft = x;
                continue;
            }
            if (alpha < 127 && this._sliceLeft > -1) {
                this._sliceRight = x;
                break;
            }
        }
        // top and bottom
        this._sliceTop = -1;
        this._sliceBottom = -1;
        for(let y = 0; y < height; y++){
            const alpha = imageData.data[y * width * 4 + 3];
            if (alpha > 127 && this._sliceTop === -1) {
                this._sliceTop = y;
                continue;
            }
            if (alpha < 127 && this._sliceTop > -1) {
                this._sliceBottom = y;
                break;
            }
        }
    }
    /**
     * Gets or sets the internal DOM image used to render the control
     */ set domImage(value) {
        this._domImage = value;
        this._loaded = false;
        this._imageDataCache.data = null;
        if (this._domImage.width) this._onImageLoaded();
        else this._domImage.onload = ()=>{
            this._onImageLoaded();
        };
    }
    get domImage() {
        return this._domImage;
    }
    _onImageLoaded() {
        this._imageDataCache.data = null;
        this._imageWidth = this._domImage.width;
        this._imageHeight = this._domImage.height;
        this._loaded = true;
        if (this._populateNinePatchSlicesFromImage) this._extractNinePatchSliceDataFromImage();
        if (this._autoScale) this.synchronizeSizeWithContent();
        this.onImageLoadedObservable.notifyObservers(this);
        this._markAsDirty();
    }
    /**
     * Gets the image source url
     */ get source() {
        return this._source;
    }
    /**
     * Resets the internal Image Element cache. Can reduce memory usage.
     */ static ResetImageCache() {
        $61f8723933a76099$export$3e431a229df88919.SourceImgCache.clear();
    }
    _removeCacheUsage(source) {
        const value = source && $61f8723933a76099$export$3e431a229df88919.SourceImgCache.get(source);
        if (value) {
            value.timesUsed -= 1;
            // Since the image isn't being used anymore, we can clean it from the cache
            if (value.timesUsed === 0) $61f8723933a76099$export$3e431a229df88919.SourceImgCache.delete(source);
        }
    }
    /**
     * Gets or sets image source url
     */ set source(value) {
        if (this._source === value) return;
        this._removeCacheUsage(this._source);
        this._loaded = false;
        this._source = value;
        this._imageDataCache.data = null;
        if (value) value = this._svgCheck(value);
        // Should abstract platform instead of using LastCreatedEngine
        const engine = this._host?.getScene()?.getEngine() || (0, $ejQPp.EngineStore).LastCreatedEngine;
        if (!engine) throw new Error("Invalid engine. Unable to create a canvas.");
        if (value && $61f8723933a76099$export$3e431a229df88919.SourceImgCache.has(value)) {
            const cachedData = $61f8723933a76099$export$3e431a229df88919.SourceImgCache.get(value);
            this._domImage = cachedData.img;
            cachedData.timesUsed += 1;
            if (cachedData.loaded) this._onImageLoaded();
            else cachedData.waitingForLoadCallback.push(this._onImageLoaded.bind(this));
            return;
        }
        this._domImage = engine.createCanvasImage();
        if (value) $61f8723933a76099$export$3e431a229df88919.SourceImgCache.set(value, {
            img: this._domImage,
            timesUsed: 1,
            loaded: false,
            waitingForLoadCallback: [
                this._onImageLoaded.bind(this)
            ]
        });
        this._domImage.onload = ()=>{
            if (value) {
                const cachedData = $61f8723933a76099$export$3e431a229df88919.SourceImgCache.get(value);
                if (cachedData) {
                    cachedData.loaded = true;
                    for (const waitingCallback of cachedData.waitingForLoadCallback)waitingCallback();
                    cachedData.waitingForLoadCallback.length = 0;
                    return;
                }
            }
            this._onImageLoaded();
        };
        if (value) {
            (0, $bOhSV.Tools).SetCorsBehavior(value, this._domImage);
            (0, $bOhSV.Tools).SetReferrerPolicyBehavior(this.referrerPolicy, this._domImage);
            this._domImage.src = value;
        }
    }
    /**
     * Checks for svg document with icon id present
     * @param value the source svg
     * @returns the svg
     */ _svgCheck(value) {
        if (window.SVGSVGElement && value.search(/.svg#/gi) !== -1 && value.indexOf("#") === value.lastIndexOf("#")) {
            this._isSVG = true;
            const svgsrc = value.split("#")[0];
            const elemid = value.split("#")[1];
            // check if object alr exist in document
            const svgExist = document.body.querySelector('object[data="' + svgsrc + '"]');
            if (svgExist) {
                const svgDoc = svgExist.contentDocument;
                // get viewbox width and height, get svg document width and height in px
                if (svgDoc && svgDoc.documentElement) {
                    const vb = svgDoc.documentElement.getAttribute("viewBox");
                    const docwidth = Number(svgDoc.documentElement.getAttribute("width"));
                    const docheight = Number(svgDoc.documentElement.getAttribute("height"));
                    const elem = svgDoc.getElementById(elemid);
                    if (elem && vb && docwidth && docheight) {
                        this._getSVGAttribs(svgExist, elemid);
                        return value;
                    }
                }
                // wait for object to load
                svgExist.addEventListener("load", ()=>{
                    this._getSVGAttribs(svgExist, elemid);
                });
            } else {
                // create document object
                const svgImage = document.createElement("object");
                svgImage.data = svgsrc;
                svgImage.type = "image/svg+xml";
                svgImage.width = "0%";
                svgImage.height = "0%";
                document.body.appendChild(svgImage);
                // when the object has loaded, get the element attribs
                svgImage.onload = ()=>{
                    const svgobj = document.body.querySelector('object[data="' + svgsrc + '"]');
                    if (svgobj) this._getSVGAttribs(svgobj, elemid);
                };
            }
            return svgsrc;
        } else return value;
    }
    /**
     * Sets sourceLeft, sourceTop, sourceWidth, sourceHeight automatically
     * given external svg file and icon id
     * @param svgsrc
     * @param elemid
     */ _getSVGAttribs(svgsrc, elemid) {
        const svgDoc = svgsrc.contentDocument;
        // get viewbox width and height, get svg document width and height in px
        if (svgDoc && svgDoc.documentElement) {
            const vb = svgDoc.documentElement.getAttribute("viewBox");
            const docwidth = Number(svgDoc.documentElement.getAttribute("width"));
            const docheight = Number(svgDoc.documentElement.getAttribute("height"));
            // get element bbox and matrix transform
            const elem = svgDoc.getElementById(elemid);
            if (vb && docwidth && docheight && elem) {
                const vb_width = Number(vb.split(" ")[2]);
                const vb_height = Number(vb.split(" ")[3]);
                const elem_bbox = elem.getBBox();
                let elem_matrix_a = 1;
                let elem_matrix_d = 1;
                let elem_matrix_e = 0;
                let elem_matrix_f = 0;
                const mainMatrix = elem.transform.baseVal.consolidate().matrix;
                if (elem.transform && elem.transform.baseVal.consolidate()) {
                    elem_matrix_a = mainMatrix.a;
                    elem_matrix_d = mainMatrix.d;
                    elem_matrix_e = mainMatrix.e;
                    elem_matrix_f = mainMatrix.f;
                }
                // compute source coordinates and dimensions
                this.sourceLeft = (elem_matrix_a * elem_bbox.x + elem_matrix_e) * docwidth / vb_width;
                this.sourceTop = (elem_matrix_d * elem_bbox.y + elem_matrix_f) * docheight / vb_height;
                this.sourceWidth = elem_bbox.width * elem_matrix_a * (docwidth / vb_width);
                this.sourceHeight = elem_bbox.height * elem_matrix_d * (docheight / vb_height);
                this._svgAttributesComputationCompleted = true;
                this.onSVGAttributesComputedObservable.notifyObservers(this);
            }
        }
    }
    /**
     * Gets or sets the cell width to use when animation sheet is enabled
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#image
     */ get cellWidth() {
        return this._cellWidth;
    }
    set cellWidth(value) {
        if (this._cellWidth === value) return;
        this._cellWidth = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets the cell height to use when animation sheet is enabled
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#image
     */ get cellHeight() {
        return this._cellHeight;
    }
    set cellHeight(value) {
        if (this._cellHeight === value) return;
        this._cellHeight = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets the cell id to use (this will turn on the animation sheet mode)
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#image
     */ get cellId() {
        return this._cellId;
    }
    set cellId(value) {
        if (this._cellId === value) return;
        this._cellId = value;
        this._markAsDirty();
    }
    /**
     * Creates a new Image
     * @param name defines the control name
     * @param url defines the image url
     */ constructor(name, url = null){
        super(name);
        this.name = name;
        this._workingCanvas = null;
        this._loaded = false;
        this._stretch = $61f8723933a76099$export$3e431a229df88919.STRETCH_FILL;
        this._autoScale = false;
        this._sourceLeft = 0;
        this._sourceTop = 0;
        this._sourceWidth = 0;
        this._sourceHeight = 0;
        this._svgAttributesComputationCompleted = false;
        this._isSVG = false;
        this._cellWidth = 0;
        this._cellHeight = 0;
        this._cellId = -1;
        this._populateNinePatchSlicesFromImage = false;
        this._imageDataCache = {
            data: null,
            key: ""
        };
        /**
         * Observable notified when the content is loaded
         */ this.onImageLoadedObservable = new (0, $diGQf.Observable)();
        /**
         * Observable notified when _sourceLeft, _sourceTop, _sourceWidth and _sourceHeight are computed
         */ this.onSVGAttributesComputedObservable = new (0, $diGQf.Observable)();
        this.source = url;
    }
    /**
     * Tests if a given coordinates belong to the current control
     * @param x defines x coordinate to test
     * @param y defines y coordinate to test
     * @returns true if the coordinates are inside the control
     */ contains(x, y) {
        if (!super.contains(x, y)) return false;
        if (!this._detectPointerOnOpaqueOnly || !this._workingCanvas) return true;
        const width = this._currentMeasure.width | 0;
        const height = this._currentMeasure.height | 0;
        const key = width + "_" + height;
        let imageData = this._imageDataCache.data;
        if (!imageData || this._imageDataCache.key !== key) {
            const canvas = this._workingCanvas;
            const context = canvas.getContext("2d");
            this._imageDataCache.data = imageData = context.getImageData(0, 0, width, height).data;
            this._imageDataCache.key = key;
        }
        x = x - this._currentMeasure.left | 0;
        y = y - this._currentMeasure.top | 0;
        const pickedPixel = imageData[(x + y * width) * 4 + 3];
        return pickedPixel > 0;
    }
    _getTypeName() {
        return "Image";
    }
    /** Force the control to synchronize with its content */ synchronizeSizeWithContent() {
        if (!this._loaded) return;
        this.width = this._domImage.width + "px";
        this.height = this._domImage.height + "px";
    }
    _processMeasures(parentMeasure, context) {
        if (this._loaded) switch(this._stretch){
            case $61f8723933a76099$export$3e431a229df88919.STRETCH_NONE:
                break;
            case $61f8723933a76099$export$3e431a229df88919.STRETCH_FILL:
                break;
            case $61f8723933a76099$export$3e431a229df88919.STRETCH_UNIFORM:
                break;
            case $61f8723933a76099$export$3e431a229df88919.STRETCH_NINE_PATCH:
                break;
            case $61f8723933a76099$export$3e431a229df88919.STRETCH_EXTEND:
                if (this._autoScale) this.synchronizeSizeWithContent();
                if (this.parent && this.parent.parent) {
                    // Will update root size if root is not the top root
                    this.parent.adaptWidthToChildren = true;
                    this.parent.adaptHeightToChildren = true;
                }
                break;
        }
        super._processMeasures(parentMeasure, context);
    }
    _prepareWorkingCanvasForOpaqueDetection() {
        if (!this._detectPointerOnOpaqueOnly) return;
        const width = this._currentMeasure.width;
        const height = this._currentMeasure.height;
        if (!this._workingCanvas) {
            const engine = this._host?.getScene()?.getEngine() || (0, $ejQPp.EngineStore).LastCreatedEngine;
            if (!engine) throw new Error("Invalid engine. Unable to create a canvas.");
            this._workingCanvas = engine.createCanvas(width, height);
        }
        const canvas = this._workingCanvas;
        const context = canvas.getContext("2d");
        context.clearRect(0, 0, width, height);
    }
    _drawImage(context, sx, sy, sw, sh, tx, ty, tw, th) {
        context.drawImage(this._domImage, sx, sy, sw, sh, tx, ty, tw, th);
        if (!this._detectPointerOnOpaqueOnly) return;
        const transform = context.getTransform();
        const canvas = this._workingCanvas;
        const workingCanvasContext = canvas.getContext("2d");
        workingCanvasContext.save();
        const ttx = tx - this._currentMeasure.left;
        const tty = ty - this._currentMeasure.top;
        workingCanvasContext.setTransform(transform.a, transform.b, transform.c, transform.d, (ttx + tw) / 2, (tty + th) / 2);
        workingCanvasContext.translate(-(ttx + tw) / 2, -(tty + th) / 2);
        workingCanvasContext.drawImage(this._domImage, sx, sy, sw, sh, ttx, tty, tw, th);
        workingCanvasContext.restore();
    }
    _draw(context) {
        context.save();
        if (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) {
            context.shadowColor = this.shadowColor;
            context.shadowBlur = this.shadowBlur;
            context.shadowOffsetX = this.shadowOffsetX;
            context.shadowOffsetY = this.shadowOffsetY;
        }
        let x, y, width, height;
        if (this.cellId == -1) {
            x = this._sourceLeft;
            y = this._sourceTop;
            width = this._sourceWidth ? this._sourceWidth : this._imageWidth;
            height = this._sourceHeight ? this._sourceHeight : this._imageHeight;
        } else {
            const rowCount = this._domImage.naturalWidth / this.cellWidth;
            const column = this.cellId / rowCount >> 0;
            const row = this.cellId % rowCount;
            x = this.cellWidth * row;
            y = this.cellHeight * column;
            width = this.cellWidth;
            height = this.cellHeight;
        }
        this._prepareWorkingCanvasForOpaqueDetection();
        this._applyStates(context);
        if (this._loaded) switch(this._stretch){
            case $61f8723933a76099$export$3e431a229df88919.STRETCH_NONE:
                this._drawImage(context, x, y, width, height, this._currentMeasure.left, this._currentMeasure.top, this._currentMeasure.width, this._currentMeasure.height);
                break;
            case $61f8723933a76099$export$3e431a229df88919.STRETCH_FILL:
                this._drawImage(context, x, y, width, height, this._currentMeasure.left, this._currentMeasure.top, this._currentMeasure.width, this._currentMeasure.height);
                break;
            case $61f8723933a76099$export$3e431a229df88919.STRETCH_UNIFORM:
                {
                    const hRatio = this._currentMeasure.width / width;
                    const vRatio = this._currentMeasure.height / height;
                    const ratio = Math.min(hRatio, vRatio);
                    const centerX = (this._currentMeasure.width - width * ratio) / 2;
                    const centerY = (this._currentMeasure.height - height * ratio) / 2;
                    this._drawImage(context, x, y, width, height, this._currentMeasure.left + centerX, this._currentMeasure.top + centerY, width * ratio, height * ratio);
                    break;
                }
            case $61f8723933a76099$export$3e431a229df88919.STRETCH_EXTEND:
                this._drawImage(context, x, y, width, height, this._currentMeasure.left, this._currentMeasure.top, this._currentMeasure.width, this._currentMeasure.height);
                break;
            case $61f8723933a76099$export$3e431a229df88919.STRETCH_NINE_PATCH:
                this._renderNinePatch(context, x, y, width, height);
                break;
        }
        context.restore();
    }
    _renderNinePatch(context, sx, sy, sw, sh) {
        const leftWidth = this._sliceLeft;
        const topHeight = this._sliceTop;
        const bottomHeight = sh - this._sliceBottom;
        const rightWidth = sw - this._sliceRight;
        const centerWidth = this._sliceRight - this._sliceLeft;
        const centerHeight = this._sliceBottom - this._sliceTop;
        const targetCenterWidth = this._currentMeasure.width - rightWidth - leftWidth + 2;
        const targetCenterHeight = this._currentMeasure.height - bottomHeight - topHeight + 2;
        const centerLeftOffset = this._currentMeasure.left + leftWidth - 1;
        const centerTopOffset = this._currentMeasure.top + topHeight - 1;
        const rightOffset = this._currentMeasure.left + this._currentMeasure.width - rightWidth;
        const bottomOffset = this._currentMeasure.top + this._currentMeasure.height - bottomHeight;
        //Top Left
        this._drawImage(context, sx, sy, leftWidth, topHeight, this._currentMeasure.left, this._currentMeasure.top, leftWidth, topHeight);
        //Top
        this._drawImage(context, sx + this._sliceLeft, sy, centerWidth, topHeight, centerLeftOffset + 1, this._currentMeasure.top, targetCenterWidth - 2, topHeight);
        //Top Right
        this._drawImage(context, sx + this._sliceRight, sy, rightWidth, topHeight, rightOffset, this._currentMeasure.top, rightWidth, topHeight);
        //Left
        this._drawImage(context, sx, sy + this._sliceTop, leftWidth, centerHeight, this._currentMeasure.left, centerTopOffset + 1, leftWidth, targetCenterHeight - 2);
        // Center
        this._drawImage(context, sx + this._sliceLeft, sy + this._sliceTop, centerWidth, centerHeight, centerLeftOffset, centerTopOffset, targetCenterWidth, targetCenterHeight);
        //Right
        this._drawImage(context, sx + this._sliceRight, sy + this._sliceTop, rightWidth, centerHeight, rightOffset, centerTopOffset + 1, rightWidth, targetCenterHeight - 2);
        //Bottom Left
        this._drawImage(context, sx, sy + this._sliceBottom, leftWidth, bottomHeight, this._currentMeasure.left, bottomOffset, leftWidth, bottomHeight);
        //Bottom
        this._drawImage(context, sx + this.sliceLeft, sy + this._sliceBottom, centerWidth, bottomHeight, centerLeftOffset + 1, bottomOffset, targetCenterWidth - 2, bottomHeight);
        //Bottom Right
        this._drawImage(context, sx + this._sliceRight, sy + this._sliceBottom, rightWidth, bottomHeight, rightOffset, bottomOffset, rightWidth, bottomHeight);
    }
    dispose() {
        super.dispose();
        this.onImageLoadedObservable.clear();
        this.onSVGAttributesComputedObservable.clear();
        this._removeCacheUsage(this._source);
    }
}
/**
 * Cache of images to avoid loading the same image multiple times
 */ $61f8723933a76099$export$3e431a229df88919.SourceImgCache = new Map();
// Static
/** STRETCH_NONE */ $61f8723933a76099$export$3e431a229df88919.STRETCH_NONE = 0;
/** STRETCH_FILL */ $61f8723933a76099$export$3e431a229df88919.STRETCH_FILL = 1;
/** STRETCH_UNIFORM */ $61f8723933a76099$export$3e431a229df88919.STRETCH_UNIFORM = 2;
/** STRETCH_EXTEND */ $61f8723933a76099$export$3e431a229df88919.STRETCH_EXTEND = 3;
/** NINE_PATCH */ $61f8723933a76099$export$3e431a229df88919.STRETCH_NINE_PATCH = 4;
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $61f8723933a76099$export$3e431a229df88919.prototype, "detectPointerOnOpaqueOnly", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $61f8723933a76099$export$3e431a229df88919.prototype, "sliceLeft", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $61f8723933a76099$export$3e431a229df88919.prototype, "sliceRight", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $61f8723933a76099$export$3e431a229df88919.prototype, "sliceTop", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $61f8723933a76099$export$3e431a229df88919.prototype, "sliceBottom", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $61f8723933a76099$export$3e431a229df88919.prototype, "sourceLeft", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $61f8723933a76099$export$3e431a229df88919.prototype, "sourceTop", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $61f8723933a76099$export$3e431a229df88919.prototype, "sourceWidth", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $61f8723933a76099$export$3e431a229df88919.prototype, "sourceHeight", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $61f8723933a76099$export$3e431a229df88919.prototype, "populateNinePatchSlicesFromImage", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $61f8723933a76099$export$3e431a229df88919.prototype, "autoScale", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $61f8723933a76099$export$3e431a229df88919.prototype, "stretch", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $61f8723933a76099$export$3e431a229df88919.prototype, "source", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $61f8723933a76099$export$3e431a229df88919.prototype, "cellWidth", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $61f8723933a76099$export$3e431a229df88919.prototype, "cellHeight", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $61f8723933a76099$export$3e431a229df88919.prototype, "cellId", null);
(0, $8DoUR.RegisterClass)("BABYLON.GUI.Image", $61f8723933a76099$export$3e431a229df88919);

});


parcelRegister("c0RhK", function(module, exports) {

$parcel$export(module.exports, "Image3D", () => $8beed1756397203c$export$afb15ea6f57f4859);

var $ejQPp = parcelRequire("ejQPp");

var $bOhSV = parcelRequire("bOhSV");

var $8puFn = parcelRequire("8puFn");

var $fYuWo = parcelRequire("fYuWo");

var $6rvpu = parcelRequire("6rvpu");
class $8beed1756397203c$export$afb15ea6f57f4859 extends (0, $8puFn.Image) {
    get stateController() {
        return this._stateController;
    }
    /**
     * Gets the image source url
     */ get source() {
        //@ts-ignore
        return this._source;
    }
    /**
     * Gets or sets image source url
     */ set source(value) {
        if (this.source === value) return;
        //@ts-ignore
        this._loaded = false;
        //@ts-ignore
        this._source = value;
        //@ts-ignore
        this._imageDataCache.data = null;
        if (value) //@ts-ignore
        value = this._svgCheck(value);
        // Should abstract platform instead of using LastCreatedEngine
        const engine = this._host?.getScene()?.getEngine() || (0, $ejQPp.EngineStore).LastCreatedEngine;
        if (!engine) throw new Error("Invalid engine. Unable to create a canvas.");
        if (this._useCache && value !== null && this._cachedImages.has(value)) {
            //@ts-ignore
            this._domImage = this._cachedImages.get(value);
            //@ts-ignore
            this._onImageLoaded();
        } else {
            //@ts-ignore
            this._domImage = engine.createCanvasImage();
            this.domImage.onload = ()=>{
                //@ts-ignore
                this._onImageLoaded();
            };
            if (value) {
                (0, $bOhSV.Tools).SetCorsBehavior(value, this.domImage);
                (0, $bOhSV.Tools).SetReferrerPolicyBehavior(this.referrerPolicy, this.domImage);
                this.domImage.src = value;
                this._cachedImages?.set(value, this.domImage);
            }
        }
        if (this.domImage) this.domImage.onerror = this.onError;
    }
    get useCache() {
        return this._useCache;
    }
    set useCache(value) {
        this._useCache = value;
    }
    constructor(name, url = null, useCache = true){
        super(name, url);
        this.name = name;
        this._blur = 0;
        this._useCache = true;
        this._cachedImages = new Map();
        this.onError = ()=>{
            const domImage = this.domImage;
            if (!domImage) return;
            domImage.onerror = null;
            if (this._altUrl) this.source = this._altUrl;
        };
        this._stateController = new (0, $fYuWo.StateController)(this);
        if (url !== null) this._stateController.addState((0, $6rvpu.ControlState).Common, url);
        this._useCache = useCache;
    }
    clearImageCache() {
        this._cachedImages.clear();
    }
    dispose() {
        super.dispose();
        this.stateController.dispose();
    }
    changeStyle(style, common) {
        if (this.source === (style ?? common ?? null)) return;
        this.source = style ?? common ?? null;
    }
    setSource(srcUrl, altUrl) {
        this.source = srcUrl ?? altUrl ?? null;
        this._altUrl = altUrl;
        this._stateController.updateState((0, $6rvpu.ControlState).Common, srcUrl ?? altUrl ?? "");
    }
    get blur() {
        return this._blur;
    }
    set blur(value) {
        this._blur = value;
        this._markAsDirty();
    }
    _draw(context) {
        if (this._blur !== 0 && "filter" in context) context.filter = `blur(${this._blur}px)`;
        super._draw(context);
    }
    _drawImage(context, sx, sy, sw, sh, tx, ty, tw, th) {
        try {
            //@ts-ignore
            super._drawImage(context, sx, sy, sw, sh, tx, ty, tw, th);
        } catch  {}
    }
}

});
parcelRegister("fYuWo", function(module, exports) {

$parcel$export(module.exports, "StateController", () => $ba1475cb9f3ff8c9$export$9456d357203666ac);

var $diGQf = parcelRequire("diGQf");

var $6rvpu = parcelRequire("6rvpu");

var $l1N1P = parcelRequire("l1N1P");
function $ba1475cb9f3ff8c9$var$isContainer(control) {
    return "children" in control;
}
function $ba1475cb9f3ff8c9$var$isStateChangeable(control) {
    return "stateController" in control;
}
function $ba1475cb9f3ff8c9$var$isStateChangeableContainer(control) {
    return "statePassDown" in control;
}
class $ba1475cb9f3ff8c9$export$9456d357203666ac extends (0, $l1N1P.StateControllerBase) {
    get onStateChangedObservable() {
        return this._onStateChangedObservable;
    }
    get onStateAddedObservable() {
        return this._onStateAddedObservable;
    }
    get onStateRemovedObservable() {
        return this._onStateRemovedObservable;
    }
    get onStateUpdatedObservable() {
        return this._onStateUpdatedObservable;
    }
    get currentStyle() {
        return this._stateMap.get(this.state);
    }
    get commonStyle() {
        return this._stateMap.get((0, $6rvpu.ControlState).Common);
    }
    constructor(control){
        super();
        this._stateMap = new Map();
        this._onStateChangedObservable = new (0, $diGQf.Observable)();
        this._onStateAddedObservable = new (0, $diGQf.Observable)();
        this._onStateRemovedObservable = new (0, $diGQf.Observable)();
        this._onStateUpdatedObservable = new (0, $diGQf.Observable)();
        this._control = control;
    }
    dispose() {
        this._stateMap.clear();
        this._onStateChangedObservable.clear();
        this._onStateAddedObservable.clear();
        this._onStateRemovedObservable.clear();
        this._onStateUpdatedObservable.clear();
    }
    changeState(value, force = false) {
        if (this.state === value && !force) return;
        if (value !== (0, $6rvpu.ControlState).Common) super.changeState(value);
        this._control.changeStyle(this._stateMap.get(this.state), this._stateMap.get((0, $6rvpu.ControlState).Common));
        this.onStateChangedObservable.notifyObservers(this.state);
        $ba1475cb9f3ff8c9$export$9456d357203666ac._tryChangeChildrenStates(this._control, this.state);
    }
    hasState(state) {
        return this._stateMap.has(state);
    }
    addState(state, style) {
        if (this._stateMap.has(state)) return;
        this._stateMap.set(state, style);
        this.onStateAddedObservable.notifyObservers({
            state: state,
            style: style
        });
        if (this.state === state || state === (0, $6rvpu.ControlState).Common) this.changeState(state, true);
    }
    addStates(...states) {
        for (const state of states)this.addState(state.state, state.style);
    }
    setStates(states) {
        for (const state of states)if (state.style === undefined) this.removeState(state.state);
        else if (this.hasState(state.state)) this.updateState(state.state, state.style);
        else this.addState(state.state, state.style);
        if (states.some((s)=>s.state === this.state || s.state === (0, $6rvpu.ControlState).Common)) this.changeState(this.state, true);
    }
    updateState(state, style) {
        if (!this._stateMap.has(state)) return;
        this._stateMap.set(state, style);
        this.onStateUpdatedObservable.notifyObservers({
            state: state,
            style: style
        });
        if (this.state === state || state === (0, $6rvpu.ControlState).Common) this.changeState(state, true);
    }
    removeState(state) {
        if (!this._stateMap.has(state)) return;
        this._stateMap.delete(state);
        this.onStateRemovedObservable.notifyObservers(state);
        if (this.state === state || state === (0, $6rvpu.ControlState).Common) this.changeState(state, true);
    }
    static _changeState(control, state) {
        if ($ba1475cb9f3ff8c9$var$isStateChangeable(control)) control.stateController.changeState(state);
        else $ba1475cb9f3ff8c9$export$9456d357203666ac._tryChangeChildrenStates(control, state);
    }
    static _tryChangeChildrenStates(control, state) {
        if ($ba1475cb9f3ff8c9$var$isContainer(control) && (!$ba1475cb9f3ff8c9$var$isStateChangeableContainer(control) || control.statePassDown)) control.children.forEach((c)=>$ba1475cb9f3ff8c9$export$9456d357203666ac._changeState(c, state));
    }
}

});
parcelRegister("6rvpu", function(module, exports) {

$parcel$export(module.exports, "ControlState", () => $4b0da1109b9bc1c1$export$efffd94d358f9ed);
var $4b0da1109b9bc1c1$export$efffd94d358f9ed;
(function(ControlState) {
    ControlState["Common"] = "common";
    ControlState["Normal"] = "normal";
    ControlState["Pressed"] = "pressed";
    ControlState["Hover"] = "hover";
    ControlState["Disabled"] = "disabled";
    ControlState["Toggled"] = "toggled";
    ControlState["ToggledHover"] = "toggledHover";
    ControlState["ToggledPressed"] = "toggledPressed";
})($4b0da1109b9bc1c1$export$efffd94d358f9ed || ($4b0da1109b9bc1c1$export$efffd94d358f9ed = {}));

});

parcelRegister("l1N1P", function(module, exports) {

$parcel$export(module.exports, "StateControllerBase", () => $f4efb8fed786fe96$export$3ba8bc530cf651fa);

var $6rvpu = parcelRequire("6rvpu");
class $f4efb8fed786fe96$export$3ba8bc530cf651fa {
    constructor(){
        this._state = (0, $6rvpu.ControlState).Normal;
    }
    changeState(state) {
        this._state = state;
    }
    get state() {
        return this._state;
    }
}

});




parcelRegister("9m8ks", function(module, exports) {

$parcel$export(module.exports, "ImgButton", () => $6cfca1112731a94a$export$58246462195e4d13);

var $diGQf = parcelRequire("diGQf");

var $esuuG = parcelRequire("esuuG");

var $c0RhK = parcelRequire("c0RhK");

var $7uWAj = parcelRequire("7uWAj");

var $PPcK8 = parcelRequire("PPcK8");

var $fYuWo = parcelRequire("fYuWo");

var $6rvpu = parcelRequire("6rvpu");
class $6cfca1112731a94a$export$58246462195e4d13 extends (0, $esuuG.Container) {
    get isEnabled() {
        return super.isEnabled;
    }
    set isEnabled(value) {
        super.isEnabled = value;
        this.updateState();
    }
    constructor(name, layout){
        super(name);
        this._statePassDown = true;
        this._isPointerDown = false;
        this._isPointerOver = false;
        this.onClickObserver = new (0, $diGQf.Observable)();
        if ((0, $7uWAj.isColorButtonLayout)(layout)) {
            this.image = new (0, $PPcK8.Rectangle3D)(`${this.name}_background`);
            if (layout.cornerRadiusPx !== undefined) this.image.cornerRadius = layout.cornerRadiusPx;
            if (layout.useArc !== undefined) this.image.useArc = layout.useArc;
            if (layout.states !== undefined) this.image.stateController.setStates(layout.states);
            else this.image.stateController.setStates([
                {
                    state: (0, $6rvpu.ControlState).Common,
                    style: layout.common
                },
                {
                    state: (0, $6rvpu.ControlState).Normal,
                    style: layout.normalState
                },
                {
                    state: (0, $6rvpu.ControlState).Hover,
                    style: layout.hoverState
                },
                {
                    state: (0, $6rvpu.ControlState).Pressed,
                    style: layout.pressedState
                },
                {
                    state: (0, $6rvpu.ControlState).Disabled,
                    style: layout.disabledState
                },
                {
                    state: (0, $6rvpu.ControlState).Toggled,
                    style: layout.toggledState ?? layout.pressedState
                },
                {
                    state: (0, $6rvpu.ControlState).ToggledHover,
                    style: layout.toggledHoverState ?? layout.toggledState ?? layout.pressedHoverState ?? layout.pressedState
                },
                {
                    state: (0, $6rvpu.ControlState).ToggledPressed,
                    style: layout.toggledPressedState ?? layout.toggledState ?? layout.pressedState
                }
            ]);
        } else {
            this.image = new (0, $c0RhK.Image3D)(`${this.name}_image`);
            if (layout.states !== undefined) this.image.stateController.setStates(layout.states);
            else this.image.stateController.setStates([
                {
                    state: (0, $6rvpu.ControlState).Common,
                    style: layout.normalImg
                },
                {
                    state: (0, $6rvpu.ControlState).Normal,
                    style: layout.normalImg
                },
                {
                    state: (0, $6rvpu.ControlState).Hover,
                    style: layout.hoverImg
                },
                {
                    state: (0, $6rvpu.ControlState).Pressed,
                    style: layout.pressedImg
                },
                {
                    state: (0, $6rvpu.ControlState).Disabled,
                    style: layout.disabledImg
                },
                {
                    state: (0, $6rvpu.ControlState).Toggled,
                    style: layout.toggledImg ?? layout.pressedImg
                },
                {
                    state: (0, $6rvpu.ControlState).ToggledHover,
                    style: layout.toggledHoverImg ?? layout.toggledImg ?? layout.pressedHoverImg ?? layout.pressedImg
                },
                {
                    state: (0, $6rvpu.ControlState).ToggledPressed,
                    style: layout.toggledPressedImg ?? layout.toggledImg ?? layout.pressedImg
                }
            ]);
        }
        this.addControl(this.image);
        this.color = "transparent";
        this._addObservables();
        this._stateController = new (0, $fYuWo.StateController)(this);
    }
    get isPointerDown() {
        return this._isPointerDown;
    }
    get isPointerOver() {
        return this._isPointerOver;
    }
    get stateController() {
        return this._stateController;
    }
    get statePassDown() {
        return this._statePassDown;
    }
    set statePassDown(value) {
        this._statePassDown = value;
    }
    changeStyle(_style, _common) {}
    changeLayout(layout) {
        if ((0, $7uWAj.isColorButtonLayout)(layout)) {
            const i = this.image;
            if (layout.cornerRadiusPx !== undefined) i.cornerRadius = layout.cornerRadiusPx;
            if (layout.useArc !== undefined) i.useArc = layout.useArc;
            if (layout.states !== undefined) i.stateController.setStates(layout.states);
            else i.stateController.setStates([
                {
                    state: (0, $6rvpu.ControlState).Common,
                    style: layout.common
                },
                {
                    state: (0, $6rvpu.ControlState).Normal,
                    style: layout.normalState
                },
                {
                    state: (0, $6rvpu.ControlState).Hover,
                    style: layout.hoverState
                },
                {
                    state: (0, $6rvpu.ControlState).Pressed,
                    style: layout.pressedState
                },
                {
                    state: (0, $6rvpu.ControlState).Disabled,
                    style: layout.disabledState
                },
                {
                    state: (0, $6rvpu.ControlState).Toggled,
                    style: layout.toggledState ?? layout.pressedState
                },
                {
                    state: (0, $6rvpu.ControlState).ToggledHover,
                    style: layout.toggledHoverState ?? layout.toggledState ?? layout.pressedHoverState ?? layout.pressedState
                },
                {
                    state: (0, $6rvpu.ControlState).ToggledPressed,
                    style: layout.toggledPressedState ?? layout.toggledState ?? layout.pressedState
                }
            ]);
        } else {
            const i = this.image;
            if (layout.states !== undefined) i.stateController.setStates(layout.states);
            else i.stateController.setStates([
                {
                    state: (0, $6rvpu.ControlState).Common,
                    style: layout.normalImg
                },
                {
                    state: (0, $6rvpu.ControlState).Normal,
                    style: layout.normalImg
                },
                {
                    state: (0, $6rvpu.ControlState).Hover,
                    style: layout.hoverImg
                },
                {
                    state: (0, $6rvpu.ControlState).Pressed,
                    style: layout.pressedImg
                },
                {
                    state: (0, $6rvpu.ControlState).Disabled,
                    style: layout.disabledImg
                }
            ]);
        }
    }
    dispose() {
        super.dispose();
        this.stateController.dispose();
        this.onClickObserver.clear();
    }
    _onEnter() {
        this._isPointerOver = true;
        this.updateState();
    }
    _onOut() {
        this._isPointerOver = false;
        this.updateState();
    }
    _onDown() {
        this._isPointerDown = true;
        this.updateState();
    }
    _onUp() {
        if (this.stateController.state === (0, $6rvpu.ControlState).Pressed) this.onClickObserver.notifyObservers(this);
        this._isPointerDown = false;
        this.updateState();
    }
    _addObservables() {
        this.onPointerEnterObservable.add(()=>this._onEnter());
        this.onPointerOutObservable.add(()=>this._onOut());
        this.onPointerDownObservable.add(()=>this._onDown());
        this.onPointerUpObservable.add(()=>this._onUp());
    }
    updateState() {
        if (!this.isEnabled) this.stateController.changeState((0, $6rvpu.ControlState).Disabled);
        else if (this._isPointerDown) this.stateController.changeState((0, $6rvpu.ControlState).Pressed);
        else if (this._isPointerOver) this.stateController.changeState((0, $6rvpu.ControlState).Hover);
        else this.stateController.changeState((0, $6rvpu.ControlState).Normal);
    }
}

});
parcelRegister("7uWAj", function(module, exports) {

$parcel$export(module.exports, "SelectorItemState", () => $5758c776e5965760$export$af74b750fdbdd341);
$parcel$export(module.exports, "isColorButtonLayout", () => $5758c776e5965760$export$237c845dca3c3fe8);
$parcel$export(module.exports, "RichTextGrammar", () => $5758c776e5965760$export$4c9ea48e6bf94be1);
$parcel$export(module.exports, "IsRadialGradient", () => $5758c776e5965760$export$12f264e8eafdd368);
$parcel$export(module.exports, "IsConicGradient", () => $5758c776e5965760$export$6070a80646e4a824);
$parcel$export(module.exports, "IsLinearGradient", () => $5758c776e5965760$export$7d8977e868cd9cbc);
var $5758c776e5965760$export$af74b750fdbdd341;
(function(SelectorItemState) {
    SelectorItemState["Normal"] = "Normal";
    SelectorItemState["Selected"] = "Selected";
    SelectorItemState["Hover"] = "Hover";
})($5758c776e5965760$export$af74b750fdbdd341 || ($5758c776e5965760$export$af74b750fdbdd341 = {}));
function $5758c776e5965760$export$237c845dca3c3fe8(buttonLayout) {
    return [
        "cornerRadiusPx",
        "useArc",
        "common",
        "normalState",
        "hoverState",
        "pressedState",
        "disabledState",
        "pressedHoverState",
        "toggledState",
        "toggledHoverState",
        "toggledPressedState"
    ].some((x)=>x in buttonLayout);
}
var $5758c776e5965760$export$4c9ea48e6bf94be1;
(function(RichTextGrammar) {
    RichTextGrammar[RichTextGrammar["RTTag"] = 0] = "RTTag";
})($5758c776e5965760$export$4c9ea48e6bf94be1 || ($5758c776e5965760$export$4c9ea48e6bf94be1 = {}));
function $5758c776e5965760$export$12f264e8eafdd368(value) {
    return "r" in value;
}
function $5758c776e5965760$export$6070a80646e4a824(value) {
    return "angle" in value;
}
function $5758c776e5965760$export$7d8977e868cd9cbc(value) {
    return !$5758c776e5965760$export$12f264e8eafdd368(value) && "xEnd" in value;
}

});

parcelRegister("PPcK8", function(module, exports) {

$parcel$export(module.exports, "RectangleMeasureUtils", () => $09bc7bb03a1554fa$export$f5155ec28682a659);
$parcel$export(module.exports, "CornerMeasureUtils", () => $09bc7bb03a1554fa$export$bc1b74cc8ae0383e);
$parcel$export(module.exports, "Rectangle3D", () => $09bc7bb03a1554fa$export$c5b68c67b8234d18);

var $esuuG = parcelRequire("esuuG");

var $i0Jb4 = parcelRequire("i0Jb4");

var $fYuWo = parcelRequire("fYuWo");
class $09bc7bb03a1554fa$export$f5155ec28682a659 {
    static isSingleRectangleMeasure(measure) {
        return typeof measure === "number";
    }
    static isHorVertRectangleMeasure(measure) {
        return !this.isSingleRectangleMeasure(measure) && ("horizontal" in measure || "vertical" in measure);
    }
    static isFullRectangleMeasure(measure) {
        return !this.isSingleRectangleMeasure(measure) && ("left" in measure || "top" in measure || "right" in measure || "bottom" in measure);
    }
    static getFullRectangleMeasure(measure) {
        if (this.isSingleRectangleMeasure(measure)) return {
            left: measure,
            top: measure,
            right: measure,
            bottom: measure
        };
        if (this.isHorVertRectangleMeasure(measure)) return {
            left: measure.horizontal,
            top: measure.vertical,
            right: measure.horizontal,
            bottom: measure.vertical
        };
        if (this.isFullRectangleMeasure(measure)) return measure;
        return {
            left: 0,
            top: 0,
            right: 0,
            bottom: 0
        };
    }
    static getHorVertRectangleMeasure(measure) {
        if (this.isSingleRectangleMeasure(measure)) return {
            horizontal: measure,
            vertical: measure
        };
        if (this.isHorVertRectangleMeasure(measure)) return measure;
        if (this.isFullRectangleMeasure(measure)) return {
            horizontal: ((measure.left ?? 0) + (measure.right ?? 0)) / 2,
            vertical: ((measure.top ?? 0) + (measure.bottom ?? 0)) / 2
        };
        return {
            horizontal: 0,
            vertical: 0
        };
    }
    static getSingleRectangleMeasure(measure) {
        if (this.isSingleRectangleMeasure(measure)) return measure;
        if (this.isHorVertRectangleMeasure(measure)) return ((measure.horizontal ?? 0) + (measure.vertical ?? 0)) / 2;
        if (this.isFullRectangleMeasure(measure)) return ((measure.left ?? 0) + (measure.top ?? 0) + (measure.right ?? 0) + (measure.bottom ?? 0)) / 2;
        return 0;
    }
    static multiplyMeasure(measure, multiplier) {
        if (this.isSingleRectangleMeasure(measure)) return measure * multiplier;
        if (this.isHorVertRectangleMeasure(measure)) return {
            horizontal: (measure.horizontal ?? 0) * multiplier,
            vertical: (measure.vertical ?? 0) * multiplier
        };
        if (this.isFullRectangleMeasure(measure)) return {
            left: (measure.left ?? 0) * multiplier,
            top: (measure.top ?? 0) * multiplier,
            right: (measure.right ?? 0) * multiplier,
            bottom: (measure.bottom ?? 0) * multiplier
        };
        return measure;
    }
}
class $09bc7bb03a1554fa$export$bc1b74cc8ae0383e {
    static isSingleCornerMeasure(measure) {
        return typeof measure === "number";
    }
    static isFullCornerMeasure(measure) {
        return !this.isSingleCornerMeasure(measure);
    }
    static getFullCornerMeasure(measure) {
        if (this.isFullCornerMeasure(measure)) return measure;
        return {
            topLeft: measure,
            topRight: measure,
            bottomRight: measure,
            bottomLeft: measure
        };
    }
    static multiplyMeasure(measure, multiplier) {
        if (this.isSingleCornerMeasure(measure)) return measure * multiplier;
        if (this.isFullCornerMeasure(measure)) return {
            topLeft: (measure.topLeft ?? 0) * multiplier,
            topRight: (measure.topRight ?? 0) * multiplier,
            bottomRight: (measure.bottomRight ?? 0) * multiplier,
            bottomLeft: (measure.bottomLeft ?? 0) * multiplier
        };
        return measure;
    }
}
class $09bc7bb03a1554fa$export$c5b68c67b8234d18 extends (0, $esuuG.Container) {
    /** Gets or sets border thickness */ get thickness() {
        return this._thickness;
    }
    set thickness(value) {
        if (this._thickness === value) return;
        this._thickness = value;
        this._markAsDirty();
    }
    /** Gets or sets the corner radius angle */ get cornerRadius() {
        return this._cornerRadius;
    }
    set cornerRadius(value) {
        if (typeof value === "number" && value < 0) value = 0;
        if (this._cornerRadius === value) return;
        this._cornerRadius = value;
        this._markAsDirty();
    }
    /**
     * Creates a new Rectangle
     * @param name defines the control name
     */ constructor(name){
        super(name);
        this._thickness = 0;
        this._cornerRadius = 0;
        this._statePassDown = true;
        this.useArc = false;
        this._stateController = new (0, $fYuWo.StateController)(this);
    }
    dispose() {
        super.dispose();
        this.stateController.dispose();
    }
    get statePassDown() {
        return this._statePassDown;
    }
    set statePassDown(value) {
        this._statePassDown = value;
    }
    changeStyle(style, common) {
        if ((style?.color ?? common?.color) !== undefined && this.background !== (style?.color ?? common?.color)) {
            const color = style?.color ?? common?.color;
            if (typeof color === "string") {
                this.background = color;
                this.backgroundGradient = null;
            } else {
                this.background = "";
                this.backgroundGradient = color;
            }
        }
        if ((style?.borderThickness ?? common?.borderThickness) !== undefined && this.thickness !== (style?.borderThickness ?? common?.borderThickness)) this.thickness = style?.borderThickness ?? common?.borderThickness;
        if ((style?.borderColor ?? common?.borderColor) !== undefined && this.color !== (style?.borderColor ?? common?.borderColor)) {
            const color = style?.borderColor ?? common?.borderColor;
            if (typeof color === "string") {
                this.color = color;
                this.gradient = null;
            } else {
                this.color = "";
                this.gradient = color;
            }
        }
        if ((style?.paddingLeftPx ?? common?.paddingLeftPx) !== undefined && this.paddingLeftInPixels !== (style?.paddingLeftPx ?? common?.paddingLeftPx)) this.paddingLeftInPixels = style?.paddingLeftPx ?? common?.paddingLeftPx;
        if ((style?.paddingRightPx ?? common?.paddingRightPx) !== undefined && this.paddingRightInPixels !== (style?.paddingRightPx ?? common?.paddingRightPx)) this.paddingRightInPixels = style?.paddingRightPx ?? common?.paddingRightPx;
        if ((style?.paddingTopPx ?? common?.paddingTopPx) !== undefined && this.paddingTopInPixels !== (style?.paddingTopPx ?? common?.paddingTopPx)) this.paddingTopInPixels = style?.paddingTopPx ?? common?.paddingTopPx;
        if ((style?.paddingBottomPx ?? common?.paddingBottomPx) !== undefined && this.paddingBottomInPixels !== (style?.paddingBottomPx ?? common?.paddingBottomPx)) this.paddingBottomInPixels = style?.paddingBottomPx ?? common?.paddingBottomPx;
    }
    get stateController() {
        return this._stateController;
    }
    _getTypeName() {
        return "Rectangle";
    }
    static IsLinearGradient(gradient) {
        return gradient.getClassName() === "LinearGradient";
    }
    static IsRadialGradient(gradient) {
        return gradient.getClassName() === "RadialGradient";
    }
    _getStyle(context, value) {
        if (typeof value === "string") return value;
        const x = this._currentMeasure.left;
        const y = this._currentMeasure.top;
        const width = this._currentMeasure.width;
        const height = this._currentMeasure.height;
        let grad;
        if ($09bc7bb03a1554fa$export$c5b68c67b8234d18.IsRadialGradient(value)) {
            const rMultiplier = Math.sqrt(width * width + height * height);
            grad = context.createRadialGradient(x + value.x0 * width, y + value.y0 * height, value.r0 * rMultiplier, x + value.x1 * width, y + value.y1 * height, value.r1 * rMultiplier);
        } else if ($09bc7bb03a1554fa$export$c5b68c67b8234d18.IsLinearGradient(value)) grad = context.createLinearGradient(x + value.x0 * width, y + value.y0 * height, x + value.x1 * width, y + value.y1 * height);
        for (const stop of value.colorStops)grad.addColorStop(stop.offset, stop.color);
        return grad;
    }
    _localDraw(context) {
        context.save();
        if (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) {
            context.shadowColor = this.shadowColor;
            context.shadowBlur = this.shadowBlur;
            context.shadowOffsetX = this.shadowOffsetX;
            context.shadowOffsetY = this.shadowOffsetY;
        }
        if (this._backgroundGradient || this._background) {
            let color = this._getStyle(context, this._backgroundGradient ?? this._background);
            context.fillStyle = color;
            if (this._cornerRadius) {
                this._drawRoundedRect(context, $09bc7bb03a1554fa$export$f5155ec28682a659.multiplyMeasure(this._thickness, 0.5));
                context.fill();
            } else context.fillRect(this._currentMeasure.left, this._currentMeasure.top, this._currentMeasure.width, this._currentMeasure.height);
        }
        if (this._thickness) {
            if (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) {
                context.shadowBlur = 0;
                context.shadowOffsetX = 0;
                context.shadowOffsetY = 0;
            }
            if (this.gradient || this.color) context.strokeStyle = this._getStyle(context, this.gradient ?? this.color);
            if (this._cornerRadius) (0, $i0Jb4.ContextUtils).DoInContext(context, {
                lineWidth: $09bc7bb03a1554fa$export$f5155ec28682a659.getSingleRectangleMeasure(this._thickness)
            }, (c)=>{
                this._drawRoundedRect(c, $09bc7bb03a1554fa$export$f5155ec28682a659.multiplyMeasure(this._thickness, 0.5));
                c.stroke();
            });
            else if ($09bc7bb03a1554fa$export$f5155ec28682a659.isSingleRectangleMeasure(this._thickness)) (0, $i0Jb4.ContextUtils).DoInContext(context, {
                lineWidth: this._thickness
            }, (c, args)=>{
                const thickness = args[0];
                c.strokeRect(this._currentMeasure.left + thickness / 2, this._currentMeasure.top + thickness / 2, this._currentMeasure.width - thickness, this._currentMeasure.height - thickness);
            }, this._thickness);
            else {
                const thickness = $09bc7bb03a1554fa$export$f5155ec28682a659.getFullRectangleMeasure(this.thickness);
                const x = this._currentMeasure.left + (thickness.left ?? 0) / 2;
                const y = this._currentMeasure.top + (thickness.top ?? 0) / 2;
                const w = this._currentMeasure.width - ((thickness.left ?? 0) + (thickness.right ?? 0)) / 2;
                const h = this._currentMeasure.height - ((thickness.top ?? 0) + (thickness.bottom ?? 0)) / 2;
                if (thickness.left) (0, $i0Jb4.ContextUtils).DoInContext(context, {
                    lineWidth: thickness.left
                }, (c)=>{
                    c.beginPath();
                    c.moveTo(x, y);
                    c.lineTo(x, y + h);
                    c.stroke();
                    c.closePath();
                });
                if (thickness.bottom) (0, $i0Jb4.ContextUtils).DoInContext(context, {
                    lineWidth: thickness.bottom
                }, (c)=>{
                    c.beginPath();
                    c.moveTo(x, y + h);
                    c.lineTo(x + w, y + h);
                    c.stroke();
                    c.closePath();
                });
                if (thickness.right) (0, $i0Jb4.ContextUtils).DoInContext(context, {
                    lineWidth: thickness.right
                }, (c)=>{
                    c.beginPath();
                    c.moveTo(x + w, y + h);
                    c.lineTo(x + w, y);
                    c.stroke();
                    c.closePath();
                });
                if (thickness.top) (0, $i0Jb4.ContextUtils).DoInContext(context, {
                    lineWidth: thickness.top
                }, (c)=>{
                    c.beginPath();
                    c.moveTo(x + w, y);
                    c.lineTo(x, y);
                    c.stroke();
                    c.closePath();
                });
            }
        }
        context.restore();
    }
    _additionalProcessing(parentMeasure, context) {
        super._additionalProcessing(parentMeasure, context);
        const thickness = $09bc7bb03a1554fa$export$f5155ec28682a659.getFullRectangleMeasure(this.thickness);
        this._measureForChildren.width -= (thickness.left ?? 0) + (thickness.right ?? 0);
        this._measureForChildren.height -= (thickness.top ?? 0) + (thickness.bottom ?? 0);
        this._measureForChildren.left += thickness.left ?? 0;
        this._measureForChildren.top += thickness.top ?? 0;
    }
    _drawRoundedRect(context, offset = 0) {
        const thickness = $09bc7bb03a1554fa$export$f5155ec28682a659.getFullRectangleMeasure(offset);
        const x = this._currentMeasure.left + (thickness.left ?? 0);
        const y = this._currentMeasure.top + (thickness.top ?? 0);
        const w = this._currentMeasure.width - ((thickness.left ?? 0) + (thickness.right ?? 0));
        const h = this._currentMeasure.height - ((thickness.top ?? 0) + (thickness.bottom ?? 0));
        const cornerRadius = $09bc7bb03a1554fa$export$bc1b74cc8ae0383e.getFullCornerMeasure(this._cornerRadius);
        const rTL = Math.max(Math.min(h / 2, Math.min(w / 2, cornerRadius.topLeft ?? 0)), 0);
        const rTR = Math.max(Math.min(h / 2, Math.min(w / 2, cornerRadius.topRight ?? 0)), 0);
        const rBR = Math.max(Math.min(h / 2, Math.min(w / 2, cornerRadius.bottomRight ?? 0)), 0);
        const rBL = Math.max(Math.min(h / 2, Math.min(w / 2, cornerRadius.bottomLeft ?? 0)), 0);
        context.beginPath();
        if (this.useArc) {
            context.beginPath();
            context.arc(x + w - rBR, y + h - rBR, rBR, 0, Math.PI / 2);
            context.lineTo(x + rBL, y + h);
            context.arc(x + rBL, y + h - rBL, rBL, Math.PI / 2, Math.PI);
            context.lineTo(x, y + rTL);
            context.arc(x + rTL, y + rTL, rTL, Math.PI, Math.PI * 3 / 2);
            context.lineTo(x + w - rTR, y);
            context.arc(x + w - rTR, y + rTR, rTR, Math.PI * 3 / 2, Math.PI * 2);
            context.closePath();
        } else {
            context.moveTo(x + rTL, y);
            context.lineTo(x + w - rTR, y);
            context.quadraticCurveTo(x + w, y, x + w, y + rTR);
            context.lineTo(x + w, y + h - rBR);
            context.quadraticCurveTo(x + w, y + h, x + w - rBR, y + h);
            context.lineTo(x + rBL, y + h);
            context.quadraticCurveTo(x, y + h, x, y + h - rBL);
            context.lineTo(x, y + rTL);
            context.quadraticCurveTo(x, y, x + rTL, y);
        }
        context.closePath();
    }
    _clipForChildren(context) {
        if (this._cornerRadius) {
            this._drawRoundedRect(context, this._thickness);
            context.clip();
        }
    }
}

});
parcelRegister("i0Jb4", function(module, exports) {

$parcel$export(module.exports, "ContextUtils", () => $d1cb456497576a58$export$49f8adb5ee4d7d36);
class $d1cb456497576a58$export$49f8adb5ee4d7d36 {
    static DoInContext(context, contextProperties, action, ...args) {
        context.save();
        if (contextProperties.font !== undefined) {
            const font = typeof contextProperties.font === "string" ? contextProperties.font : `${contextProperties.font.fontStyle !== undefined ? `${contextProperties.font.fontStyle} ` : ""}${contextProperties.font.fontWeight !== undefined ? `${contextProperties.font.fontWeight} ` : ""}${contextProperties.font.fontSize !== undefined ? `${contextProperties.font.fontSize}px ` : "18px "}${contextProperties.font.fontFamily !== undefined ? `${contextProperties.font.fontFamily}` : "Arial"}`;
            if (context.font !== font) context.font = typeof contextProperties.font === "string" ? contextProperties.font : `${contextProperties.font.fontStyle !== undefined ? `${contextProperties.font.fontStyle} ` : ""}${contextProperties.font.fontWeight !== undefined ? `${contextProperties.font.fontWeight} ` : ""}${contextProperties.font.fontSize !== undefined ? `${contextProperties.font.fontSize}px ` : "18px "}${contextProperties.font.fontFamily !== undefined ? `${contextProperties.font.fontFamily}` : "Arial"}`;
        }
        if (contextProperties.fillStyle !== undefined && context.fillStyle !== contextProperties.fillStyle) context.fillStyle = contextProperties.fillStyle;
        if (contextProperties.strokeStyle !== undefined && context.strokeStyle !== contextProperties.strokeStyle) context.strokeStyle = contextProperties.strokeStyle;
        if (contextProperties.lineWidth !== undefined && context.lineWidth !== contextProperties.lineWidth) context.lineWidth = contextProperties.lineWidth;
        if (contextProperties.lineJoin !== undefined && context.lineJoin !== contextProperties.lineJoin) context.lineJoin = contextProperties.lineJoin;
        if (contextProperties.miterLimit !== undefined && context.miterLimit !== contextProperties.miterLimit) context.miterLimit = contextProperties.miterLimit;
        if (contextProperties.shadowColor !== undefined && context.shadowColor !== contextProperties.shadowColor) context.shadowColor = contextProperties.shadowColor;
        if (contextProperties.shadowBlur !== undefined && context.shadowBlur !== contextProperties.shadowBlur) context.shadowBlur = contextProperties.shadowBlur;
        if (contextProperties.shadowOffsetX !== undefined && context.shadowOffsetX !== contextProperties.shadowOffsetX) context.shadowOffsetX = contextProperties.shadowOffsetX;
        if (contextProperties.shadowOffsetY !== undefined && context.shadowOffsetY !== contextProperties.shadowOffsetY) context.shadowOffsetY = contextProperties.shadowOffsetY;
        const result = action(context, args);
        context.restore();
        return result;
    }
    static MeasureText(textBlock, context) {
        return this.DoInContext(context ?? textBlock.host.getContext(), {
            font: {
                fontFamily: textBlock.fontFamily,
                fontSize: textBlock.fontSizeInPixels,
                fontStyle: textBlock.fontStyle,
                fontWeight: textBlock.fontWeight
            }
        }, (c)=>{
            return c.measureText(textBlock.text).width;
        });
    }
}

});



parcelRegister("jhgC4", function(module, exports) {

var $9m8ks = parcelRequire("9m8ks");

var $6rvpu = parcelRequire("6rvpu");

var $63ju2 = parcelRequire("63ju2");
class $e08c7ddd783e53ad$export$607646e37076bfdf extends (0, $9m8ks.ImgButton) {
    constructor(name, params){
        super(name, params.imageLayout);
        this.textBlock = (0, $63ju2.ObjectBuilder).createTextBlock3D(undefined, `${name}_text`, params.text, {});
        if (params.textLayout.states !== undefined) this.textBlock.stateController.setStates(params.textLayout.states);
        else this.textBlock.stateController.setStates([
            {
                state: (0, $6rvpu.ControlState).Common,
                style: params.textLayout.common
            },
            {
                state: (0, $6rvpu.ControlState).Normal,
                style: params.textLayout.normal
            },
            {
                state: (0, $6rvpu.ControlState).Hover,
                style: params.textLayout.hover
            },
            {
                state: (0, $6rvpu.ControlState).Pressed,
                style: params.textLayout.pressed
            },
            {
                state: (0, $6rvpu.ControlState).Disabled,
                style: params.textLayout.disabled
            }
        ]);
        this.addControl(this.textBlock);
    }
    set text(value) {
        this.textBlock.text = value ? value : "";
    }
    get text() {
        return this.textBlock.text;
    }
}

});
parcelRegister("63ju2", function(module, exports) {

$parcel$export(module.exports, "ObjectBuilder", () => $468222ec73dde4be$export$17d05159135028c2);

var $6rvpu = parcelRequire("6rvpu");

var $3A4pp = parcelRequire("3A4pp");

var $lmFIW = parcelRequire("lmFIW");

var $9A9WJ = parcelRequire("9A9WJ");
class $468222ec73dde4be$export$17d05159135028c2 {
    //todo create all TextBlock3D with this function
    static createTextBlock3D(mesh2D, name, text, params) {
        const textBlock = new (0, $9A9WJ.TextBlock3D)(name, text);
        textBlock.isHitTestVisible = false;
        textBlock.stateController.addState((0, $6rvpu.ControlState).Common, (0, $3A4pp.FontUtils).getAdjustedFontStyle(params, mesh2D));
        textBlock.stateController.changeState((0, $6rvpu.ControlState).Normal, true);
        return textBlock;
    }
    static createRichTextBlock3D(name, text, params, grammar, mesh2D) {
        const textBlock = new (0, $lmFIW.RichTextBlock3D)(grammar, name, text);
        textBlock.isHitTestVisible = false;
        textBlock.stateController.addState((0, $6rvpu.ControlState).Common, (0, $3A4pp.FontUtils).getAdjustedFontStyle(params, mesh2D));
        textBlock.stateController.changeState((0, $6rvpu.ControlState).Normal, true);
        return textBlock;
    }
}

});
parcelRegister("3A4pp", function(module, exports) {

$parcel$export(module.exports, "FontUtils", () => $29b8276868a3ec0c$export$83dd6912a1bca23c);

var $iHRqj = parcelRequire("iHRqj");
class $29b8276868a3ec0c$export$83dd6912a1bca23c {
    static get commonStyle() {
        return $29b8276868a3ec0c$export$83dd6912a1bca23c._commonStyle;
    }
    static set commonStyle(value) {
        $29b8276868a3ec0c$export$83dd6912a1bca23c._commonStyle = value;
    }
    static fontSizePx2LineHeightPx(fontSizePx) {
        return fontSizePx * 1.2;
    }
    static getAdjustedFontStyle(style, mesh2D, defaultStyle) {
        const fallbackStyle = Object.assign({}, this.commonStyle, defaultStyle);
        let adjustedStyle = Object.assign({}, this.commonStyle, style);
        adjustedStyle = (0, $iHRqj.LayoutUtils).GetLayout(style, mesh2D, fallbackStyle);
        adjustedStyle.fontFamily = (0, $iHRqj.LayoutUtils).GetValue(style?.fontFamily, mesh2D, fallbackStyle?.fontFamily);
        adjustedStyle.color = (0, $iHRqj.LayoutUtils).GetValue(style?.color, mesh2D, fallbackStyle?.color);
        adjustedStyle.fontSize = (0, $iHRqj.LayoutUtils).GetValue(style?.fontSize, mesh2D, fallbackStyle?.fontSize);
        adjustedStyle.fontWeight = (0, $iHRqj.LayoutUtils).GetValue(style?.fontWeight, mesh2D, fallbackStyle?.fontWeight);
        adjustedStyle.fontStyle = (0, $iHRqj.LayoutUtils).GetValue(style?.fontStyle, mesh2D, fallbackStyle?.fontStyle);
        adjustedStyle.lineSpacing = (0, $iHRqj.LayoutUtils).GetValue(style?.lineSpacing, mesh2D, fallbackStyle?.lineSpacing);
        adjustedStyle.textWrapping = style?.textWrapping ?? fallbackStyle?.textWrapping;
        adjustedStyle.textVerticalAlignment = style?.textVerticalAlignment ?? fallbackStyle?.textVerticalAlignment;
        adjustedStyle.textHorizontalAlignment = style?.textHorizontalAlignment ?? fallbackStyle?.textHorizontalAlignment;
        adjustedStyle.resizeToFit = (0, $iHRqj.LayoutUtils).GetValue(style?.resizeToFit, mesh2D, fallbackStyle?.resizeToFit);
        adjustedStyle.maxLines = style?.maxLines ?? fallbackStyle?.maxLines;
        adjustedStyle.enableSymbolWrap = style?.enableSymbolWrap ?? fallbackStyle?.enableSymbolWrap;
        return adjustedStyle;
    }
    static setTextBlockStyle(textBlock, style, mesh2D, defaultStyle) {
        const adjustedStyle = $29b8276868a3ec0c$export$83dd6912a1bca23c.getAdjustedFontStyle(style, mesh2D, defaultStyle);
        (0, $iHRqj.LayoutUtils).SetControlLayout(textBlock, adjustedStyle);
        if (adjustedStyle.fontFamily !== undefined && adjustedStyle.fontFamily !== textBlock.fontFamily) textBlock.fontFamily = adjustedStyle.fontFamily;
        if (adjustedStyle.color !== undefined && adjustedStyle.color !== textBlock.color) textBlock.color = adjustedStyle.color;
        if (adjustedStyle.fontSize !== undefined && adjustedStyle.fontSize !== textBlock.fontSize) textBlock.fontSize = adjustedStyle.fontSize;
        if (adjustedStyle.fontWeight !== undefined && adjustedStyle.fontWeight !== textBlock.fontWeight) textBlock.fontWeight = adjustedStyle.fontWeight;
        if (adjustedStyle.fontStyle !== undefined && adjustedStyle.fontStyle !== textBlock.fontStyle) textBlock.fontStyle = adjustedStyle.fontStyle;
        if (adjustedStyle.textWrapping !== undefined && adjustedStyle.textWrapping !== textBlock.textWrapping) textBlock.textWrapping = adjustedStyle.textWrapping;
        if (adjustedStyle.textVerticalAlignment !== undefined && adjustedStyle.textVerticalAlignment !== textBlock.textVerticalAlignment) textBlock.textVerticalAlignment = adjustedStyle.textVerticalAlignment;
        if (adjustedStyle.textHorizontalAlignment !== undefined && adjustedStyle.textHorizontalAlignment !== textBlock.textHorizontalAlignment) textBlock.textHorizontalAlignment = adjustedStyle.textHorizontalAlignment;
        if (adjustedStyle.lineSpacing !== undefined && adjustedStyle.lineSpacing !== textBlock.lineSpacing) textBlock.lineSpacing = adjustedStyle.lineSpacing;
        if (adjustedStyle.resizeToFit !== undefined && adjustedStyle.resizeToFit !== textBlock.resizeToFit) {
            textBlock.resizeToFit = adjustedStyle.resizeToFit;
            if (adjustedStyle.resizeToFit && textBlock.heightInPixels === 0 && adjustedStyle.fontSize !== undefined) {
                const height = this.fontSizePx2LineHeightPx(adjustedStyle.fontSize);
                if (textBlock.heightInPixels !== height) textBlock.heightInPixels = height;
            }
        }
        if (adjustedStyle.maxLines !== undefined && adjustedStyle.maxLines !== textBlock.maxLines) textBlock.maxLines = adjustedStyle.maxLines;
        if (adjustedStyle.enableSymbolWrap !== undefined && adjustedStyle.enableSymbolWrap !== textBlock.enableSymbolWrap) textBlock.enableSymbolWrap = adjustedStyle.enableSymbolWrap;
    }
}
$29b8276868a3ec0c$export$83dd6912a1bca23c._commonStyle = {};

});
parcelRegister("iHRqj", function(module, exports) {

$parcel$export(module.exports, "LayoutUtils", () => $d9e5aef170e10ebd$export$c1b441bf43d4739a);

var $fCNdl = parcelRequire("fCNdl");

var $7uWAj = parcelRequire("7uWAj");

var $PPcK8 = parcelRequire("PPcK8");
class $d9e5aef170e10ebd$export$c1b441bf43d4739a {
    static _getValue(value, mesh) {
        if (value === undefined) return undefined;
        if (typeof value === "string") return value;
        if (typeof value === "boolean") return value;
        if (typeof value === "number") return mesh?.m2px(value) ?? value;
        if ((0, $PPcK8.RectangleMeasureUtils).isFullRectangleMeasure(value) || (0, $PPcK8.RectangleMeasureUtils).isHorVertRectangleMeasure(value)) return Object.assign({}, (0, $PPcK8.RectangleMeasureUtils).multiplyMeasure(value, mesh?.m2px(1) ?? 1));
        if ((0, $PPcK8.CornerMeasureUtils).isFullCornerMeasure(value)) return Object.assign({}, (0, $PPcK8.CornerMeasureUtils).multiplyMeasure(value, mesh?.m2px(1) ?? 1));
        return value;
    }
    static GetValue(value, mesh, fallbackValue) {
        return this._getValue(value, mesh) ?? this._getValue(fallbackValue, mesh);
    }
    static GetLayout(layout, mesh, defaultLayout) {
        const result = Object.assign({}, layout);
        result.width = this.GetValue(layout?.width, mesh, defaultLayout?.width);
        result.height = this.GetValue(layout?.height, mesh, defaultLayout?.height);
        result.left = this.GetValue(layout?.left, mesh, defaultLayout?.left);
        result.top = this.GetValue(layout?.top, mesh, defaultLayout?.top);
        result.verticalAlignment = layout?.verticalAlignment ?? defaultLayout?.verticalAlignment;
        result.horizontalAlignment = layout?.horizontalAlignment ?? defaultLayout?.horizontalAlignment;
        result.padding = this.GetValue(layout?.padding, mesh, defaultLayout?.padding);
        result.adjustSizeByPadding = this.GetValue(layout?.adjustSizeByPadding, mesh, defaultLayout?.adjustSizeByPadding);
        return result;
    }
    static GetRectangleStyle(buttonLayoutState, mesh) {
        const result = Object.assign({}, buttonLayoutState);
        result.borderThickness = this.GetValue(buttonLayoutState?.borderThickness, mesh);
        result.paddingBottomPx = this.GetValue(buttonLayoutState?.paddingBottomPx, mesh);
        result.paddingLeftPx = this.GetValue(buttonLayoutState?.paddingLeftPx, mesh);
        result.paddingRightPx = this.GetValue(buttonLayoutState?.paddingRightPx, mesh);
        result.paddingTopPx = this.GetValue(buttonLayoutState?.paddingTopPx, mesh);
        return result;
    }
    static GetButtonLayout(buttonLayout, mesh) {
        const result = this.GetLayout(buttonLayout, mesh);
        if ((0, $7uWAj.isColorButtonLayout)(result) && (0, $7uWAj.isColorButtonLayout)(buttonLayout)) result.cornerRadiusPx = this.GetValue(buttonLayout.cornerRadiusPx, mesh);
        if (buttonLayout.states !== undefined) {
            if ((0, $7uWAj.isColorButtonLayout)(result) && (0, $7uWAj.isColorButtonLayout)(buttonLayout)) result.states = buttonLayout.states.map((s)=>{
                return {
                    state: s.state,
                    style: this.GetRectangleStyle(s.style, mesh)
                };
            });
        } else if ((0, $7uWAj.isColorButtonLayout)(result) && (0, $7uWAj.isColorButtonLayout)(buttonLayout)) {
            if (buttonLayout.common !== undefined) result.common = this.GetRectangleStyle(buttonLayout.common, mesh);
            if (buttonLayout.normalState !== undefined) result.normalState = this.GetRectangleStyle(buttonLayout.normalState, mesh);
            if (buttonLayout.hoverState !== undefined) result.hoverState = this.GetRectangleStyle(buttonLayout.hoverState, mesh);
            if (buttonLayout.pressedState !== undefined) result.pressedState = this.GetRectangleStyle(buttonLayout.pressedState, mesh);
            if (buttonLayout.disabledState !== undefined) result.disabledState = this.GetRectangleStyle(buttonLayout.disabledState, mesh);
            if (buttonLayout.pressedHoverState !== undefined) result.pressedHoverState = this.GetRectangleStyle(buttonLayout.pressedHoverState, mesh);
            if (buttonLayout.toggledState !== undefined) result.toggledState = this.GetRectangleStyle(buttonLayout.toggledState, mesh);
            if (buttonLayout.toggledHoverState !== undefined) result.toggledHoverState = this.GetRectangleStyle(buttonLayout.toggledHoverState, mesh);
            if (buttonLayout.toggledPressedState !== undefined) result.toggledPressedState = this.GetRectangleStyle(buttonLayout.toggledPressedState, mesh);
        }
        return result;
    }
    static SetControlLayout(control, layout) {
        if (layout.width !== undefined && layout.width !== control.widthInPixels) control.widthInPixels = layout.width;
        if (layout.height !== undefined && layout.height !== control.heightInPixels) control.heightInPixels = layout.height;
        if (layout.top !== undefined && layout.top !== control.topInPixels) control.topInPixels = layout.top;
        if (layout.left !== undefined && layout.left !== control.leftInPixels) control.leftInPixels = layout.left;
        if (layout.horizontalAlignment !== undefined && layout.horizontalAlignment !== control.horizontalAlignment) control.horizontalAlignment = layout.horizontalAlignment;
        if (layout.verticalAlignment !== undefined && layout.verticalAlignment !== control.verticalAlignment) control.verticalAlignment = layout.verticalAlignment;
        if (layout.padding !== undefined) {
            const padding = (0, $PPcK8.RectangleMeasureUtils).getFullRectangleMeasure(layout.padding);
            if (control.paddingLeftInPixels !== (padding.left ?? 0)) control.paddingLeftInPixels = padding.left ?? 0;
            if (control.paddingTopInPixels !== (padding.top ?? 0)) control.paddingTopInPixels = padding.top ?? 0;
            if (control.paddingRightInPixels !== (padding.right ?? 0)) control.paddingRightInPixels = padding.right ?? 0;
            if (control.paddingBottomInPixels !== (padding.bottom ?? 0)) control.paddingBottomInPixels = padding.bottom ?? 0;
        }
        if (layout.adjustSizeByPadding !== false) {
            if (control.widthInPixels !== 0 && control.paddingLeftInPixels + control.paddingRightInPixels > 0) control.widthInPixels += control.paddingLeftInPixels + control.paddingRightInPixels;
            if (control.heightInPixels !== 0 && control.paddingTopInPixels + control.paddingBottomInPixels > 0) control.heightInPixels += control.paddingTopInPixels + control.paddingBottomInPixels;
        }
    }
}
$d9e5aef170e10ebd$export$c1b441bf43d4739a.addMargin = (widthPx, heightPx, stackPanel)=>{
    const margin = new (0, $fCNdl.Control)("margin");
    margin.widthInPixels = widthPx;
    margin.heightInPixels = heightPx;
    margin.isHitTestVisible = false;
    stackPanel.addControl(margin);
    return margin;
};

});


parcelRegister("lmFIW", function(module, exports) {

$parcel$export(module.exports, "RichTextBlock3D", () => $f8dc0485feda5963$export$a75e582c9ddce934);

var $diGQf = parcelRequire("diGQf");

var $fCNdl = parcelRequire("fCNdl");

var $8wJXS = parcelRequire("8wJXS");

var $dKQam = parcelRequire("dKQam");

var $i0Jb4 = parcelRequire("i0Jb4");

var $7uWAj = parcelRequire("7uWAj");

var $PPcK8 = parcelRequire("PPcK8");

var $chwcr = parcelRequire("chwcr");

var $9A9WJ = parcelRequire("9A9WJ");
class $f8dc0485feda5963$export$a75e582c9ddce934 extends (0, $9A9WJ.TextBlock3D) {
    get onHyperlinkEnterObservable() {
        return this._onHyperlinkEnterObservable;
    }
    get onHyperlinkLeaveObservable() {
        return this._onHyperlinkLeaveObservable;
    }
    get onHyperlinkClickedObservable() {
        return this._onHyperlinkClickedObservable;
    }
    get text() {
        return this._styledLines.map((g)=>g.map((l)=>l.text).join("")).join("\n");
    }
    set text(value) {
        if (this._parser !== undefined) {
            const styledLines = this._parser.GetStyledLines(value);
            if (this._styledLines === styledLines) return;
            this._styledLines = styledLines;
            super.text = this._styledLines.map((g)=>g.map((l)=>l.text).join("")).join("\n");
        }
    }
    constructor(parserGrammar, name, text){
        super(name);
        this._styledLines = [];
        this._brokenStyledLines = [];
        this._onHyperlinkClickedObservable = new (0, $diGQf.Observable)();
        this._onHyperlinkEnterObservable = new (0, $diGQf.Observable)();
        this._onHyperlinkLeaveObservable = new (0, $diGQf.Observable)();
        this._hyperlinksCallbacks = [];
        this._parser = (0, $chwcr.RichTextParserFactory).CreateParser(parserGrammar);
        if (text) this.text = text;
    }
    _breakLines(refWidth, refHeight, context) {
        const lines = [];
        switch(this.textWrapping){
            case (0, $8wJXS.TextWrapping).Ellipsis:
                lines.push(this._parseLinesEllipsis(this._styledLines, refWidth, context));
                break;
            case (0, $8wJXS.TextWrapping).WordWrap:
                if (this.enableSymbolWrap) lines.push(...this._styledLines.flatMap((g)=>this._parseStyledLineSymbolWrap(g, refWidth, context)));
                else lines.push(...this._parseLinesWordWrap(this._styledLines, refWidth, context));
                break;
            case (0, $8wJXS.TextWrapping).WordWrapEllipsis:
                if (this.enableSymbolWrap) lines.push(...this._parseStyledLinesSymbolWrapEllipsis(this._styledLines, refWidth, refHeight, context));
                else lines.push(...this._parseStyledLinesWordWrapEllipsis(this._styledLines, refWidth, refHeight, context));
                break;
            default:
                lines.push(...this._parseLines(this._styledLines, context));
                break;
        }
        this._brokenStyledLines = lines;
        for (const c of lines)this._getLineMaxFontOffset(c, context); //Caches the offsets before the layout is built
        return lines;
    }
    _styleToContextProperties(style) {
        const contextProperties = {};
        if (style === undefined) return contextProperties;
        contextProperties.font = `${style.fontStyle ?? this.fontStyle} ${style.fontWeight ?? this.fontWeight} ${style.fontSize ?? this.fontSizeInPixels}px ${style.fontFamily ?? this.fontFamily}`;
        if (style?.shadowColor !== undefined) contextProperties.shadowColor = style.shadowColor;
        if (style?.shadowBlur !== undefined) contextProperties.shadowBlur = style.shadowBlur;
        if (style?.shadowOffsetX !== undefined) contextProperties.shadowOffsetX = style.shadowOffsetX;
        if (style?.shadowOffsetY !== undefined) contextProperties.shadowOffsetY = style.shadowOffsetY;
        if (style.outlineWidth) {
            contextProperties.lineWidth = style.outlineWidth;
            contextProperties.lineJoin = "miter";
            contextProperties.miterLimit = 2;
        }
        return contextProperties;
    }
    _parseLinesWordWrap(lines, width, context) {
        const outputLines = [];
        for (const lineGroup of lines){
            let outputLineGroup = [];
            let prevWidth = 0;
            for (const line of lineGroup)(0, $i0Jb4.ContextUtils).DoInContext(context, this._styleToContextProperties(line.style), (c)=>{
                let text = line.text;
                let lineWidth = c.measureText(text).width;
                if (lineWidth + prevWidth < width) outputLineGroup.push({
                    text: text,
                    width: lineWidth,
                    style: line.style
                });
                else {
                    const words = this.wordSplittingFunction ? this.wordSplittingFunction(text) : text.split(this.wordDivider);
                    for(let n = 0; n < words.length; n++){
                        const testLine = n > 0 ? text + this.wordDivider + words[n] : words[0];
                        const testWidth = c.measureText(testLine).width;
                        if (prevWidth + testWidth >= width) {
                            if (n > 0) outputLineGroup.push({
                                text: text,
                                width: lineWidth,
                                style: line.style
                            });
                            outputLines.push(outputLineGroup);
                            outputLineGroup = [];
                            text = words[n];
                            prevWidth = 0;
                            lineWidth = c.measureText(text).width;
                        } else {
                            lineWidth = testWidth;
                            text = testLine;
                        }
                    }
                    outputLineGroup.push({
                        text: text,
                        width: lineWidth,
                        style: line.style
                    });
                }
                prevWidth += lineWidth;
            });
            outputLines.push(outputLineGroup);
        }
        return outputLines;
    }
    _parseLinesEllipsis(lines, width, context, forceEllipsis = false) {
        if (lines.length === 0) return [];
        const lineGroup = lines[0];
        const outputLineGroup = [];
        let prevWidth = 0;
        let shouldBreak = false;
        for (const line of lineGroup){
            if (shouldBreak) break;
            const outputLine = (0, $i0Jb4.ContextUtils).DoInContext(context, this._styleToContextProperties(line.style), (c)=>{
                let text = line.text;
                const symbols = this._getSymbols(text);
                const ellipsis = "\u2026";
                for(let n = 0; n < symbols.length; n++){
                    const testLine = n > 0 ? text + symbols[n] : symbols[0];
                    const testWidth = c.measureText(testLine + ellipsis).width;
                    if (testWidth + prevWidth > width && n > 0) {
                        shouldBreak = true;
                        return {
                            text: text + ellipsis,
                            width: c.measureText(text + ellipsis).width,
                            style: line.style
                        };
                    } else text = testLine;
                }
                return {
                    text: forceEllipsis ? text + ellipsis : text,
                    width: c.measureText(forceEllipsis ? text + ellipsis : text).width,
                    style: line.style
                };
            });
            outputLineGroup.push(outputLine);
            prevWidth += outputLine.width;
        }
        return outputLineGroup;
    }
    _parseStyledLineSymbolWrap(lineGroup, width, context) {
        const outputLines = [];
        let outputLineGroup = [];
        let prevWidth = 0;
        for (const line of lineGroup){
            let text = line.text;
            (0, $i0Jb4.ContextUtils).DoInContext(context, this._styleToContextProperties(line.style), (c)=>{
                const symbols = this._getSymbols(text);
                for(let n = 0; n < symbols.length; n++){
                    const testLine = n > 0 ? text + symbols[n] : symbols[0];
                    const dash = this.addDashWhenSymbolWrapping && /[^0-9\s!'#S%&'()*+,\-./:;<=>?@[/\]^_{|}~]/.test(symbols[n]) && !this._emojiRegex.test(symbols[n]) && n < symbols.length - 1 && /[^0-9\s!'#S%&'()*+,\-./:;<=>?@[/\]^_{|}~]/.test(symbols[n - 1]) && !this._emojiRegex.test(symbols[n - 1]) ? "-" : "";
                    const testWidth = c.measureText(testLine + dash).width;
                    if (testWidth + prevWidth > width && n > 0) {
                        const w = c.measureText(text + dash).width;
                        prevWidth = 0;
                        outputLineGroup.push({
                            text: text + dash,
                            width: w,
                            style: line.style
                        });
                        outputLines.push(outputLineGroup);
                        outputLineGroup = [];
                        text = symbols[n];
                    } else text = testLine;
                }
                prevWidth += c.measureText(text).width;
                outputLineGroup.push({
                    text: text,
                    width: c.measureText(text).width,
                    style: line.style
                });
            });
        }
        outputLines.push(outputLineGroup);
        return outputLines;
    }
    _parseStyledLinesSymbolWrapEllipsis(lines, width, height, context) {
        const outputLines = this._parseLinesWordWrap(lines, width, context).flatMap((l)=>this._parseStyledLineSymbolWrap(l, width, context));
        if (this.maxLines !== undefined) outputLines.length = Math.min(outputLines.length, this.maxLines);
        if (!this.resizeToFit) for(let i = 0; i < outputLines.length; i++){
            const currentHeight = this._computeHeightForLines(i + 1, outputLines, context);
            if (currentHeight >= height) {
                outputLines.length = i;
                break;
            }
        }
        if (outputLines.length > 0) outputLines[outputLines.length - 1] = this._parseLinesEllipsis([
            outputLines[outputLines.length - 1]
        ], width, context);
        return outputLines;
    }
    _parseStyledLinesWordWrapEllipsis(lines, width, height, context) {
        const outputLines = this._parseLinesWordWrap(lines, width, context);
        if (this.maxLines !== undefined) outputLines.length = Math.min(outputLines.length, this.maxLines);
        if (!this.resizeToFit) for(let i = 0; i < outputLines.length; i++){
            const currentHeight = this._computeHeightForLines(i + 1, outputLines, context);
            if (currentHeight >= height) {
                outputLines.length = i;
                break;
            }
        }
        if (outputLines.length > 0) outputLines[outputLines.length - 1] = this._parseLinesEllipsis([
            outputLines[outputLines.length - 1]
        ], width, context);
        return outputLines;
    }
    _computeHeightForLines(lineCount, lines, context) {
        return this._paddingTopInPixels + this._paddingBottomInPixels + lines.reduce((p, c, i)=>p += i < lineCount ? this._getLineMaxFontOffset(c, context).height : 0, 0) + this.lineSpacingValue * (lineCount - 1) | 0;
    }
    _parseLines(lines, context) {
        if (lines.length === 0) return [];
        const outputLines = [];
        for (const lineGroup of lines){
            const outputLineGroup = [];
            for (const line of lineGroup){
                const outputLine = (0, $i0Jb4.ContextUtils).DoInContext(context, this._styleToContextProperties(line.style), (c)=>{
                    let text = line.text;
                    return {
                        text: line.text,
                        width: c.measureText(text).width,
                        style: line.style
                    };
                });
                outputLineGroup.push(outputLine);
            }
            outputLines.push(outputLineGroup);
        }
        return outputLines;
    }
    _getLineMaxFontOffset(line, context) {
        let maxFontOffset = {
            height: 0,
            ascent: 0,
            descent: 0
        };
        if (line === undefined) return maxFontOffset;
        for (const l of line){
            const fontOffset = this._getFontOffset(l, context);
            if (fontOffset.height > maxFontOffset.height) maxFontOffset = fontOffset;
        }
        return maxFontOffset;
    }
    _getFontOffset(line, context) {
        const style = {
            fontFamily: line.style?.fontFamily ?? this.fontFamily,
            fontSize: line.style?.fontSize ?? this.fontSizeInPixels,
            fontWeight: line.style?.fontWeight ?? this.fontWeight,
            fontStyle: line.style?.fontStyle ?? this.fontStyle,
            lineHeight: line.style?.lineHeight ?? this.lineSpacingValue
        };
        const hash = this._getStyleHash(style);
        if ($f8dc0485feda5963$export$a75e582c9ddce934._offsetMap.has(hash)) return $f8dc0485feda5963$export$a75e582c9ddce934._offsetMap.get(hash);
        return (0, $i0Jb4.ContextUtils).DoInContext(context, this._styleToContextProperties(line.style), (c)=>{
            let offset = (0, $fCNdl.Control)._GetFontOffset(c.font);
            if (line.style?.lineHeight !== undefined) {
                const lh = line.style?.lineHeight;
                const m = lh / offset.height;
                offset = {
                    ascent: offset.ascent * m,
                    descent: offset.descent * m,
                    height: lh
                };
            }
            $f8dc0485feda5963$export$a75e582c9ddce934._offsetMap.set(hash, offset);
            return offset;
        });
    }
    _getStyleHash(style) {
        return this._getHash(style.fontFamily, style.fontSize, style.fontWeight, style.fontStyle, style.lineHeight);
    }
    _getHash(...values) {
        let h1 = 0xdeadbeef, h2 = 0x41c6ce57;
        for (const v of values){
            if (v === undefined) continue;
            if (typeof v === "number") {
                h1 = Math.imul(h1 ^ v, 2654435761);
                h2 = Math.imul(h2 ^ v, 1597334677);
            } else for(let i = 0, ch; i < v.length; i++){
                ch = v.charCodeAt(i);
                h1 = Math.imul(h1 ^ ch, 2654435761);
                h2 = Math.imul(h2 ^ ch, 1597334677);
            }
        }
        h1 = Math.imul(h1 ^ h1 >>> 16, 2246822507);
        h1 ^= Math.imul(h2 ^ h2 >>> 13, 3266489909);
        h2 = Math.imul(h2 ^ h2 >>> 16, 2246822507);
        h2 ^= Math.imul(h1 ^ h1 >>> 13, 3266489909);
        return 4294967296 * (2097151 & h2) + (h1 >>> 0);
    }
    _renderLines(context) {
        if (!this._fontOffset || !this.lines) return;
        const height = this._currentMeasure.height;
        let rootY = this._currentMeasure.top;
        switch(this.textVerticalAlignment){
            case (0, $fCNdl.Control).VERTICAL_ALIGNMENT_TOP:
                rootY += this._getLineMaxFontOffset(this._brokenStyledLines[0], context).ascent;
                break;
            case (0, $fCNdl.Control).VERTICAL_ALIGNMENT_BOTTOM:
                {
                    const totalFontHeight = this._brokenStyledLines.reduce((p, c, i)=>p += i == 0 ? this._getLineMaxFontOffset(c, context).descent : this._getLineMaxFontOffset(c, context).height, 0);
                    rootY += height - totalFontHeight - this.lineSpacingValue * (this._brokenStyledLines.length - 1);
                    break;
                }
            case (0, $fCNdl.Control).VERTICAL_ALIGNMENT_CENTER:
                {
                    const maxFontOffset = this._getLineMaxFontOffset(this._brokenStyledLines[0], context);
                    const totalFontHeight = this._brokenStyledLines.reduce((p, c, i)=>p += i == 0 ? this._getLineMaxFontOffset(c, context).descent : this._getLineMaxFontOffset(c, context).height, 0);
                    rootY += (maxFontOffset.ascent + height - totalFontHeight - this.lineSpacingValue * (this._brokenStyledLines.length - 1)) / 2;
                    break;
                }
        }
        for (const callbacks of this._hyperlinksCallbacks){
            this.onPointerClickObservable.removeCallback(callbacks.onClick);
            this.onPointerMoveObservable.removeCallback(callbacks.onMove);
            this.onPointerOutObservable.removeCallback(callbacks.onOut);
        }
        for(let i = 0; i < this._brokenStyledLines.length; i++){
            const line = this._brokenStyledLines[i];
            const maxFontOffsetC = this._getLineMaxFontOffset(line, context);
            const maxFontOffsetN = i < this._brokenStyledLines.length - 1 ? this._getLineMaxFontOffset(this._brokenStyledLines[i + 1], context) : {
                height: 0,
                ascent: 0,
                descent: 0
            };
            let rootX = 0;
            const width = this._currentMeasure.width;
            switch(this.textHorizontalAlignment){
                case (0, $fCNdl.Control).HORIZONTAL_ALIGNMENT_LEFT:
                    rootX = 0;
                    break;
                case (0, $fCNdl.Control).HORIZONTAL_ALIGNMENT_RIGHT:
                    rootX = width - line.reduce((p, c)=>p += c.width, 0);
                    break;
                case (0, $fCNdl.Control).HORIZONTAL_ALIGNMENT_CENTER:
                    rootX = (width - line.reduce((p, c)=>p += c.width, 0)) / 2;
                    break;
            }
            for (const l of line)rootX = this._drawStyledText(l, rootX, rootY, context);
            rootY += maxFontOffsetC.descent + maxFontOffsetN.ascent + this.lineSpacingValue;
        }
    }
    _drawStyledText(line, x, y, originalContext) {
        return (0, $i0Jb4.ContextUtils).DoInContext(originalContext, this._styleToContextProperties(line.style), (context)=>{
            const textWidth = line.width;
            const fontOffset = this._getFontOffset(line, context);
            const fontSize = line.style?.fontSize ?? fontOffset.height;
            if (line.style?.backgroundColor !== undefined) {
                const padding = (0, $PPcK8.RectangleMeasureUtils).getFullRectangleMeasure(line.style?.backgroundPadding !== undefined ? line.style.backgroundPadding : 0);
                context.fillStyle = $f8dc0485feda5963$export$a75e582c9ddce934.GetStyle(context, x - (padding.left ?? 0), y - (padding.top ?? 0), textWidth + (padding.right ?? 0), fontOffset.height + (padding.bottom ?? 0), line.style?.backgroundColor) ?? this.color;
                const bgx = Math.round(this._currentMeasure.left + x - (padding.left ?? 0));
                const bgy = Math.round(y - fontOffset.ascent - (padding.top ?? 0));
                const bgw = Math.round(textWidth + (padding.left ?? 0) + (padding.right ?? 0));
                const bgh = Math.round(fontOffset.height + (padding.top ?? 0) + (padding.bottom ?? 0));
                if (line.style?.backgroundRadius !== undefined) {
                    const r = Math.round(Math.max(Math.min(bgh / 2, Math.min(bgw / 2, line.style.backgroundRadius)), 0));
                    context.beginPath();
                    context.moveTo(bgx + r, bgy);
                    context.lineTo(bgx + bgw - r, bgy);
                    context.quadraticCurveTo(bgx + bgw, bgy, bgx + bgw, bgy + r);
                    context.lineTo(bgx + bgw, bgy + bgh - r);
                    context.quadraticCurveTo(bgx + bgw, bgy + bgh, bgx + bgw - r, bgy + bgh);
                    context.lineTo(bgx + r, bgy + bgh);
                    context.quadraticCurveTo(bgx, bgy + bgh, bgx, bgy + bgh - r);
                    context.lineTo(bgx, bgy + r);
                    context.quadraticCurveTo(bgx, bgy, bgx + r, bgy);
                    context.closePath();
                    context.fill();
                } else context.fillRect(bgx, bgy, bgw, bgh);
            }
            context.fillStyle = $f8dc0485feda5963$export$a75e582c9ddce934.GetStyle(context, x, y, textWidth, fontOffset.height, line.style?.color) ?? this.color;
            context.strokeStyle = $f8dc0485feda5963$export$a75e582c9ddce934.GetStyle(context, x, y, textWidth, fontOffset.height, line.style?.outlineColor) ?? this.outlineColor;
            if (line.style?.outlineWidth) context.strokeText(line.text, this._currentMeasure.left + x, y);
            context.fillText(line.text, this._currentMeasure.left + x, y);
            if (line.style?.underline === true) {
                const underlineHeight = Math.round(fontSize * 0.05 * (line.style?.underlineThicknessMultiplier ?? 1));
                const underlineY = y + 3;
                if (line.style.underlineColor !== undefined) context.strokeStyle = $f8dc0485feda5963$export$a75e582c9ddce934.GetStyle(context, x, underlineY, textWidth, underlineHeight, line.style.underlineColor);
                context.beginPath();
                context.lineWidth = underlineHeight;
                context.moveTo(this._currentMeasure.left + x, underlineY);
                context.lineTo(this._currentMeasure.left + x + textWidth, underlineY);
                context.stroke();
                context.closePath();
            }
            if (line.style?.strikeThrough === true) {
                const strikeThroughHeight = Math.round(fontSize * 0.05 * (line.style?.strikeThroughThicknessMultiplier ?? 1));
                const strikeThroughY = y - fontSize / 3;
                if (line.style.strikeThroughColor !== undefined) context.strokeStyle = $f8dc0485feda5963$export$a75e582c9ddce934.GetStyle(context, x, strikeThroughY, textWidth, strikeThroughHeight, line.style.strikeThroughColor);
                context.beginPath();
                context.lineWidth = strikeThroughHeight;
                context.moveTo(this._currentMeasure.left + x, strikeThroughY);
                context.lineTo(this._currentMeasure.left + x + textWidth, strikeThroughY);
                context.stroke();
                context.closePath();
            }
            if (line.style?.hyperlink !== undefined) {
                const xStart = this._currentMeasure.left + x;
                const yStart = y;
                const xEnd = this._currentMeasure.left + x + textWidth;
                const yEnd = y - fontSize * (2 / 3);
                let isOver = false;
                const onClick = (v)=>{
                    if (v.x > xStart && v.x < xEnd && v.y > yEnd && v.y < yStart) this._onHyperlinkClickedObservable.notifyObservers(line.style.hyperlink);
                };
                const onMove = (v)=>{
                    if (!isOver && v.x > xStart && v.x < xEnd && v.y > yEnd && v.y < yStart) {
                        isOver = true;
                        this._onHyperlinkEnterObservable.notifyObservers(line.style.hyperlink);
                    } else if (isOver && !(v.x > xStart && v.x < xEnd && v.y > yEnd && v.y < yStart)) {
                        isOver = false;
                        this._onHyperlinkLeaveObservable.notifyObservers(line.style.hyperlink);
                    }
                };
                const onOut = ()=>{
                    if (isOver) {
                        isOver = false;
                        this._onHyperlinkLeaveObservable.notifyObservers(line.style.hyperlink);
                    }
                };
                this.onPointerClickObservable.add(onClick);
                this.onPointerMoveObservable.add(onMove);
                this.onPointerOutObservable.add(onOut);
                this._hyperlinksCallbacks.push({
                    onClick: onClick,
                    onMove: onMove,
                    onOut: onOut
                });
            }
            return x + textWidth;
        });
    }
    _processMeasures(parentMeasure, context) {
        if (!this._fontOffset || this.isDirty) this._fontOffset = (0, $fCNdl.Control)._GetFontOffset(context.font);
        // super._processMeasures(parentMeasure, context);
        //@ts-ignore
        (0, $fCNdl.Control).prototype._processMeasures.call(this, parentMeasure, context);
        // Prepare lines
        //@ts-ignore
        this._lines = this._breakLines(this._currentMeasure.width, this.resizeToFit ? this._cachedParentMeasure.height : this._currentMeasure.height, context);
        this.onLinesReadyObservable.notifyObservers(this);
        let maxLineWidth = 0;
        for(let i = 0; i < this._brokenStyledLines.length; i++){
            const line = this._brokenStyledLines[i];
            const lineWidth = line.reduce((p, c)=>p += c.width, 0);
            if (lineWidth > maxLineWidth) maxLineWidth = lineWidth;
        }
        if (this.resizeToFit) {
            if (this.textWrapping === (0, $8wJXS.TextWrapping).Clip) {
                const newWidth = this._paddingLeftInPixels + this._paddingRightInPixels + maxLineWidth | 0;
                if (newWidth !== this._width.value) {
                    this._width.updateInPlace(newWidth, (0, $dKQam.ValueAndUnit).UNITMODE_PIXEL);
                    this._rebuildLayout = true;
                }
            }
            const newHeight = this._paddingTopInPixels + this._paddingBottomInPixels + this._brokenStyledLines.reduce((p, c)=>p += this._getLineMaxFontOffset(c, context).height, 0) + this.lineSpacingValue * (this._brokenStyledLines.length - 1) | 0;
            if (newHeight !== this._height.value) {
                this._height.updateInPlace(newHeight, (0, $dKQam.ValueAndUnit).UNITMODE_PIXEL);
                this._rebuildLayout = true;
            }
        }
    }
    static GetStyle(context, x, y, width, height, value) {
        if (value === undefined) return undefined;
        if (typeof value === "string") return value;
        let grad;
        if ((0, $7uWAj.IsRadialGradient)(value)) {
            const rMultiplier = Math.sqrt(width * width + height * height);
            grad = context.createRadialGradient(x + value.x * width, y + value.y * height, value.r * rMultiplier, x + value.xEnd * width, y + value.yEnd * height, value.rEnd * rMultiplier);
        } else if ((0, $7uWAj.IsConicGradient)(value)) grad = context.createConicGradient(value.angle, x + value.x * width, y + value.y * height);
        else if ((0, $7uWAj.IsLinearGradient)(value)) grad = context.createLinearGradient(x + value.x * width, y + value.y * height, x + value.xEnd * width, y + value.yEnd * height);
        for (const stop of value.colorStops)grad.addColorStop(stop.offset, stop.color);
        return grad;
    }
}
$f8dc0485feda5963$export$a75e582c9ddce934._offsetMap = new Map();

});
parcelRegister("chwcr", function(module, exports) {

$parcel$export(module.exports, "RichTextParserFactory", () => $8f100cc550d72ad5$export$be5c386151ae2c9e);
class $8f100cc550d72ad5$export$be5c386151ae2c9e {
    static RegisterParser(grammar, ctor) {
        $8f100cc550d72ad5$export$be5c386151ae2c9e._parserMap.set(grammar, ctor);
    }
    static CreateParser(grammar) {
        const ctor = this._parserMap.get(grammar);
        if (ctor) return new ctor();
        return undefined;
    }
}
$8f100cc550d72ad5$export$be5c386151ae2c9e._parserMap = new Map();

});

parcelRegister("9A9WJ", function(module, exports) {

$parcel$export(module.exports, "TextBlock3D", () => $6f9f30fb9097470c$export$f6d9363bd59a967c);

var $fCNdl = parcelRequire("fCNdl");

var $8DoUR = parcelRequire("8DoUR");

var $8wJXS = parcelRequire("8wJXS");

var $dKQam = parcelRequire("dKQam");

var $8C3u9 = parcelRequire("8C3u9");

var $3A4pp = parcelRequire("3A4pp");

var $fYuWo = parcelRequire("fYuWo");
class $6f9f30fb9097470c$export$f6d9363bd59a967c extends (0, $8wJXS.TextBlock) {
    /**
     * Drawing text with right proportions.
     * @param name ID.
     * @param text Text.
     */ //@internal
    constructor(name, text){
        super(name, text);
        this._enableSymbolWrap = false;
        this._addDashWhenSymbolWrapping = false;
        this._emojiRegex = (0, $8C3u9.default)();
        this._stateController = new (0, $fYuWo.StateController)(this);
    }
    dispose() {
        super.dispose();
        this._stateController.dispose();
    }
    get stateController() {
        return this._stateController;
    }
    changeStyle(style, common) {
        (0, $3A4pp.FontUtils).setTextBlockStyle(this, style, undefined, common);
    }
    get statePassDown() {
        return false;
    }
    _getTypeName() {
        return "TextBlock3D";
    }
    get enableSymbolWrap() {
        return this._enableSymbolWrap;
    }
    set enableSymbolWrap(value) {
        this._enableSymbolWrap = value;
    }
    get addDashWhenSymbolWrapping() {
        return this._addDashWhenSymbolWrapping;
    }
    set addDashWhenSymbolWrapping(value) {
        this._addDashWhenSymbolWrapping = value;
    }
    get maxLines() {
        return this._maxLines;
    }
    set maxLines(value) {
        if (this._maxLines === value) return;
        this._maxLines = value;
        this._markAsDirty();
    }
    get maskSymbol() {
        return this._maskSymbol;
    }
    set maskSymbol(value) {
        this._maskSymbol = value;
    }
    get lineSpacingValue() {
        //@ts-ignore
        if (this._lineSpacing.isPixel) //@ts-ignore
        return this._lineSpacing.getValue(this._host);
        else //@ts-ignore
        return this._lineSpacing.getValue(this._host) * this._height.getValueInPixel(this._host, this._cachedParentMeasure.height);
    }
    get symbols() {
        return this._getSymbols(this.text);
    }
    _breakLines(refWidth, refHeight, context) {
        const outputLines = [];
        const lines = this.text.split("\n");
        if (this.textWrapping === (0, $8wJXS.TextWrapping).Ellipsis) for (const line of lines)outputLines.push(this._parseLineEllipsis(line, refWidth, context));
        else if (this.textWrapping === (0, $8wJXS.TextWrapping).WordWrap) {
            for (const line of lines)if (this.enableSymbolWrap) outputLines.push(...this._parseLineSymbolWrap(line, refWidth, context));
            else outputLines.push(...this._parseLineWordWrap(line, refWidth, context));
        } else if (this.textWrapping === (0, $8wJXS.TextWrapping).WordWrapEllipsis) {
            if (this.enableSymbolWrap) outputLines.push(...this._parseLinesSymbolWrapEllipsis(lines, refWidth, refHeight, context));
            else outputLines.push(...this._parseLinesWordWrapEllipsis(lines, refWidth, refHeight, context));
        } else for (const line of lines)outputLines.push(this._parseLine(line, context));
        return outputLines;
    }
    _getSymbols(line) {
        const emojis = line.match(this._emojiRegex);
        const nonEmojis = line.split(this._emojiRegex);
        for(let i = 0; i < nonEmojis.length; i++)if (nonEmojis[i] != "" && nonEmojis.length > i + 1) {
            nonEmojis.splice(i + 1, 0, "");
            i++;
        }
        const symbols = [];
        if (emojis !== null) {
            let i = 0;
            for (const s of nonEmojis){
                if (s !== "") symbols.push(...s.split(""));
                else if (emojis[i] !== undefined) symbols.push(emojis[i++]);
            }
        } else for (const s of nonEmojis)symbols.push(...s.split(""));
        return symbols;
    }
    _parseLineSymbolWrap(line = "", width, context) {
        const originalLines = this._parseLineWordWrap(line, width, context);
        const lines = [];
        //@ts-ignore
        let lineWidth = this._getTextMetricsWidth(context.measureText(this._getMaskedText(line)));
        const symbolLines = originalLines.map((l)=>this._getSymbols(l.text));
        for (const symbols of symbolLines){
            for(let n = 0; n < symbols.length; n++){
                const testLine = n > 0 ? line + symbols[n] : symbols[0];
                const dash = this.addDashWhenSymbolWrapping && /[^0-9\s!'#S%&'()*+,\-./:;<=>?@[/\]^_{|}~]/.test(symbols[n]) && !this._emojiRegex.test(symbols[n]) && n < symbols.length - 1 && /[^0-9\s!'#S%&'()*+,\-./:;<=>?@[/\]^_{|}~]/.test(symbols[n - 1]) && !this._emojiRegex.test(symbols[n - 1]) ? "-" : "";
                //@ts-ignore
                const testWidth = this._getTextMetricsWidth(context.measureText(this._getMaskedText(testLine + dash)));
                if (testWidth > width && n > 0) {
                    //@ts-ignore
                    lines.push({
                        text: line + dash,
                        width: this._getTextMetricsWidth(context.measureText(this._getMaskedText(line + dash)))
                    });
                    line = symbols[n];
                    //@ts-ignore
                    lineWidth = this._getTextMetricsWidth(context.measureText(this._getMaskedText(line)));
                } else {
                    lineWidth = testWidth;
                    line = testLine;
                }
            }
            lines.push({
                text: line,
                width: lineWidth
            });
        }
        return lines;
    }
    _parseLineEllipsis(line = "", width, context, forceEllipsis = false) {
        //@ts-ignore
        let lineWidth = this._getTextMetricsWidth(context.measureText(this._getMaskedText(line)));
        const symbols = this._getSymbols(line);
        const ellipsis = "\u2026";
        for(let n = 0; n < symbols.length; n++){
            const testLine = n > 0 ? line + symbols[n] : symbols[0];
            //@ts-ignore
            const testWidth = this._getTextMetricsWidth(context.measureText(this._getMaskedText(testLine + ellipsis)));
            if (testWidth > width && n > 0) //@ts-ignore
            return {
                text: line + ellipsis,
                width: this._getTextMetricsWidth(context.measureText(this._getMaskedText(line + ellipsis)))
            };
            else {
                lineWidth = testWidth;
                line = testLine;
            }
        }
        return {
            text: forceEllipsis ? line + ellipsis : line,
            width: lineWidth
        };
    }
    _parseLinesSymbolWrapEllipsis(linesOriginal = [
        ""
    ], width, height, context) {
        const lines = this._parseLineSymbolWrap(linesOriginal.join("\n"), width, context);
        const originalLinesLength = lines.length;
        if (this.maxLines !== undefined) lines.length = Math.min(originalLinesLength, this.maxLines);
        if (lines.length === 1) return [
            this._parseLineEllipsis(lines[0].text, width, context, originalLinesLength > 1)
        ];
        for(let n = 1; n <= lines.length; n++){
            //@ts-ignore
            const currentHeight = this._computeHeightForLinesOf(n);
            if (currentHeight > height && n > 1 && n !== lines.length) {
                const lastLine = lines[n - 2];
                const currentLine = lines[n - 1];
                lines[n - 2] = this._parseLineEllipsis(`${lastLine.text}${currentLine.text}`, width, context);
                const linesToRemove = lines.length - n + 1;
                for(let i = 0; i < linesToRemove; i++)lines.pop();
                return lines;
            } else if (n === lines.length) {
                const currentLine = lines[n - 1];
                lines[n - 1] = this._parseLineEllipsis(currentLine.text, width, context, originalLinesLength > n);
                const linesToRemove = lines.length - n;
                for(let i = 0; i < linesToRemove; i++)lines.pop();
                return lines;
            }
        }
        return lines;
    }
    _parseLinesWordWrapEllipsis(linesOriginal = [
        ""
    ], width, height, context) {
        const lines = this._parseLineWordWrap(linesOriginal.join("\n"), width, context);
        const originalLinesLength = lines.length;
        if (this.maxLines !== undefined) lines.length = Math.min(originalLinesLength, this.maxLines);
        if (lines.length === 1) return [
            this._parseLineEllipsis(`${lines[0].text}`, width, context, originalLinesLength > 1)
        ];
        for(let n = 1; n <= lines.length; n++){
            //@ts-ignore
            const currentHeight = this._computeHeightForLinesOf(n);
            if (currentHeight > height && n > 1 && n !== lines.length) {
                const lastLine = lines[n - 2];
                const currentLine = lines[n - 1];
                lines[n - 2] = this._parseLineEllipsis(`${lastLine.text}${currentLine.text}`, width, context);
                const linesToRemove = lines.length - n + 1;
                for(let i = 0; i < linesToRemove; i++)lines.pop();
                return lines;
            } else if (n === lines.length) {
                const currentLine = lines[n - 1];
                lines[n - 1] = this._parseLineEllipsis(currentLine.text, width, context, originalLinesLength > n);
                const linesToRemove = lines.length - n;
                for(let i = 0; i < linesToRemove; i++)lines.pop();
                return lines;
            }
        }
        return lines;
    }
    _parseLineWordWrapEllipsis(line = "", width, height, context) {
        const lines = this._parseLineWordWrap(line, width, context);
        if (lines.length === 1) return [
            this._parseLineEllipsis(`${lines[0].text}`, width, context)
        ];
        for(let n = 1; n <= lines.length; n++){
            //@ts-ignore
            const currentHeight = this._computeHeightForLinesOf(n);
            if (currentHeight > height && n > 1) {
                const lastLine = lines[n - 2];
                const currentLine = lines[n - 1];
                lines[n - 2] = this._parseLineEllipsis(`${lastLine.text + currentLine.text}`, width, context);
                const linesToRemove = lines.length - n + 1;
                for(let i = 0; i < linesToRemove; i++)lines.pop();
                return lines;
            }
        }
        return lines;
    }
    // protected _processMeasures(parentMeasure: Measure, context: ICanvasRenderingContext)
    // {
    //     super._processMeasures(parentMeasure, context);
    //     if(!this.resizeToFit)
    //         return;
    //     let maxLineWidth: number = 0;
    //     //@ts-ignore
    //     for (let i = 0; i < this._lines.length; i++) {
    //         //@ts-ignore
    //         const line = this._lines[i];
    //         if (line.width > maxLineWidth) {
    //             maxLineWidth = line.width;
    //         }
    //     }
    //     const newWidth = (this._paddingLeftInPixels + this._paddingRightInPixels + maxLineWidth) | 0;
    //     if (newWidth !== this._width.value) {
    //         this._width.updateInPlace(newWidth, ValueAndUnit.UNITMODE_PIXEL);
    //         this._rebuildLayout = true;
    //     }
    // }
    _processMeasures(parentMeasure, context) {
        if (!this._fontOffset || this.isDirty) this._fontOffset = (0, $fCNdl.Control)._GetFontOffset(context.font);
        // super._processMeasures(parentMeasure, context);
        //@ts-ignore
        (0, $fCNdl.Control).prototype._processMeasures.call(this, parentMeasure, context);
        // Prepare lines
        //@ts-ignore
        this._lines = this._breakLines(this._currentMeasure.width, this.resizeToFit ? this._cachedParentMeasure.height : this._currentMeasure.height, context);
        this.onLinesReadyObservable.notifyObservers(this);
        let maxLineWidth = 0;
        for(let i = 0; i < this.lines.length; i++){
            const line = this.lines[i];
            if (line.width > maxLineWidth) maxLineWidth = line.width;
        }
        if (this.resizeToFit) {
            if (this.textWrapping === (0, $8wJXS.TextWrapping).Clip) {
                const newWidth = this._paddingLeftInPixels + this._paddingRightInPixels + maxLineWidth | 0;
                if (newWidth !== this._width.value) {
                    this._width.updateInPlace(newWidth, (0, $dKQam.ValueAndUnit).UNITMODE_PIXEL);
                    this._rebuildLayout = true;
                }
            }
            let newHeight = this._paddingTopInPixels + this._paddingBottomInPixels + this._fontOffset.height * this.lines.length | 0;
            //@ts-ignore
            if (this.lines.length > 0 && this._lineSpacing.internalValue !== 0) {
                let lineSpacing = 0;
                //@ts-ignore
                if (this._lineSpacing.isPixel) //@ts-ignore
                lineSpacing = this._lineSpacing.getValue(this._host);
                else //@ts-ignore
                lineSpacing = this._lineSpacing.getValue(this._host) * this._height.getValueInPixel(this._host, this._cachedParentMeasure.height);
                newHeight += (this.lines.length - 1) * lineSpacing;
            }
            if (newHeight !== this._height.value) {
                this._height.updateInPlace(newHeight, (0, $dKQam.ValueAndUnit).UNITMODE_PIXEL);
                this._rebuildLayout = true;
            }
        }
    }
    _renderLines(context) {
        if (!this._fontOffset || !this.lines) return;
        const height = this._currentMeasure.height;
        let rootY = 0;
        switch(this.textVerticalAlignment){
            case (0, $fCNdl.Control).VERTICAL_ALIGNMENT_TOP:
                rootY = this._fontOffset.ascent;
                break;
            case (0, $fCNdl.Control).VERTICAL_ALIGNMENT_BOTTOM:
                rootY = height - this._fontOffset.height * (this.lines.length - 1) - this._fontOffset.descent;
                break;
            case (0, $fCNdl.Control).VERTICAL_ALIGNMENT_CENTER:
                rootY = this._fontOffset.ascent + (height - this._fontOffset.height * this.lines.length) / 2;
                break;
        }
        rootY += this._currentMeasure.top;
        for(let i = 0; i < this.lines.length; i++){
            const line = this.lines[i];
            let text = this._getMaskedText(line.text);
            rootY += this.lineSpacingValue;
            //@ts-ignore
            this._drawText(text, line.width, rootY, context);
            rootY += this._fontOffset.height;
        }
    }
    _parseLineWordWrap(line = "", width, context) {
        const lines = [];
        const words = this.wordSplittingFunction ? this.wordSplittingFunction(line) : line.split(this.wordDivider);
        const measureText = (l)=>{
            return context.measureText(this._getMaskedText(l));
        };
        //@ts-ignore
        let lineWidth = this._getTextMetricsWidth(measureText(line));
        for(let n = 0; n < words.length; n++){
            const testLine = n > 0 ? line + this.wordDivider + words[n] : words[0];
            //@ts-ignore
            const testWidth = this._getTextMetricsWidth(measureText(testLine));
            if (testWidth > width && n > 0) {
                lines.push({
                    text: line,
                    width: lineWidth
                });
                line = words[n];
                //@ts-ignore
                lineWidth = this._getTextMetricsWidth(measureText(line));
            } else {
                lineWidth = testWidth;
                line = testLine;
            }
        }
        lines.push({
            text: line,
            width: lineWidth
        });
        return lines;
    }
    _parseLine(line = "", context) {
        //@ts-ignore
        return {
            text: line,
            width: this._getTextMetricsWidth(context.measureText(this._getMaskedText(line)))
        };
    }
    _getMaskedText(text) {
        return this._maskSymbol !== undefined ? text.replaceAll(/./g, this._maskSymbol) : text;
    }
}
(0, $8DoUR.RegisterClass)("BABYLON.GUI.TextBlock3D", $6f9f30fb9097470c$export$f6d9363bd59a967c);

});
parcelRegister("8C3u9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b29f018f20818b84$export$2e2bcd8739ae039);
var $b29f018f20818b84$export$2e2bcd8739ae039 = ()=>{
    // https://mths.be/emoji
    return /[#*0-9]\uFE0F?\u20E3|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26AA\u26B0\u26B1\u26BD\u26BE\u26C4\u26C8\u26CF\u26D1\u26E9\u26F0-\u26F5\u26F7\u26F8\u26FA\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B55\u3030\u303D\u3297\u3299]\uFE0F?|[\u261D\u270C\u270D](?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?|[\u270A\u270B](?:\uD83C[\uDFFB-\uDFFF])?|[\u23E9-\u23EC\u23F0\u23F3\u25FD\u2693\u26A1\u26AB\u26C5\u26CE\u26D4\u26EA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2795-\u2797\u27B0\u27BF\u2B50]|\u26D3\uFE0F?(?:\u200D\uD83D\uDCA5)?|\u26F9(?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?(?:\u200D[\u2640\u2642]\uFE0F?)?|\u2764\uFE0F?(?:\u200D(?:\uD83D\uDD25|\uD83E\uDE79))?|\uD83C(?:[\uDC04\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]\uFE0F?|[\uDF85\uDFC2\uDFC7](?:\uD83C[\uDFFB-\uDFFF])?|[\uDFC4\uDFCA](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDFCB\uDFCC](?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF43\uDF45-\uDF4A\uDF4C-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uDDE6\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF]|\uDDE7\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF]|\uDDE8\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF7\uDDFA-\uDDFF]|\uDDE9\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF]|\uDDEA\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA]|\uDDEB\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7]|\uDDEC\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE]|\uDDED\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA]|\uDDEE\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9]|\uDDEF\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5]|\uDDF0\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF]|\uDDF1\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE]|\uDDF2\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF]|\uDDF3\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF]|\uDDF4\uD83C\uDDF2|\uDDF5\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE]|\uDDF6\uD83C\uDDE6|\uDDF7\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC]|\uDDF8\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF]|\uDDF9\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF]|\uDDFA\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF]|\uDDFB\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA]|\uDDFC\uD83C[\uDDEB\uDDF8]|\uDDFD\uD83C\uDDF0|\uDDFE\uD83C[\uDDEA\uDDF9]|\uDDFF\uD83C[\uDDE6\uDDF2\uDDFC]|\uDF44(?:\u200D\uD83D\uDFEB)?|\uDF4B(?:\u200D\uD83D\uDFE9)?|\uDFC3(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?|\uDFF3\uFE0F?(?:\u200D(?:\u26A7\uFE0F?|\uD83C\uDF08))?|\uDFF4(?:\u200D\u2620\uFE0F?|\uDB40\uDC67\uDB40\uDC62\uDB40(?:\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDC73\uDB40\uDC63\uDB40\uDC74|\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F)?)|\uD83D(?:[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3]\uFE0F?|[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC](?:\uD83C[\uDFFB-\uDFFF])?|[\uDC6E-\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4\uDEB5](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD74\uDD90](?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?|[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC25\uDC27-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE41\uDE43\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED8\uDEDC-\uDEDF\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB\uDFF0]|\uDC08(?:\u200D\u2B1B)?|\uDC15(?:\u200D\uD83E\uDDBA)?|\uDC26(?:\u200D(?:\u2B1B|\uD83D\uDD25))?|\uDC3B(?:\u200D\u2744\uFE0F?)?|\uDC41\uFE0F?(?:\u200D\uD83D\uDDE8\uFE0F?)?|\uDC68(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDC68\uDC69]\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC68\uD83C[\uDFFC-\uDFFF])|\uD83E(?:[\uDD1D\uDEEF]\u200D\uD83D\uDC68\uD83C[\uDFFC-\uDFFF]|[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83E(?:[\uDD1D\uDEEF]\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF]|[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83E(?:[\uDD1D\uDEEF]\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83E(?:[\uDD1D\uDEEF]\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF]|[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFE])|\uD83E(?:[\uDD1D\uDEEF]\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFE]|[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3])))?))?|\uDC69(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?[\uDC68\uDC69]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?|\uDC69\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?))|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC69\uD83C[\uDFFC-\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFC-\uDFFF]|\uDEEF\u200D\uD83D\uDC69\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC69\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFD-\uDFFF]|\uDEEF\u200D\uD83D\uDC69\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC69\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uDEEF\u200D\uD83D\uDC69\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC69\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFD\uDFFF]|\uDEEF\u200D\uD83D\uDC69\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC69\uD83C[\uDFFB-\uDFFE])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFE]|\uDEEF\u200D\uD83D\uDC69\uD83C[\uDFFB-\uDFFE])))?))?|\uDD75(?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDE2E(?:\u200D\uD83D\uDCA8)?|\uDE35(?:\u200D\uD83D\uDCAB)?|\uDE36(?:\u200D\uD83C\uDF2B\uFE0F?)?|\uDE42(?:\u200D[\u2194\u2195]\uFE0F?)?|\uDEB6(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?)|\uD83E(?:[\uDD0C\uDD0F\uDD18-\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5\uDEC3-\uDEC5\uDEF0\uDEF2-\uDEF8](?:\uD83C[\uDFFB-\uDFFF])?|[\uDD26\uDD35\uDD37-\uDD39\uDD3C-\uDD3E\uDDB8\uDDB9\uDDCD\uDDCF\uDDD4\uDDD6-\uDDDD](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDDDE\uDDDF](?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD0D\uDD0E\uDD10-\uDD17\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCC\uDDD0\uDDE0-\uDDFF\uDE70-\uDE7C\uDE80-\uDE8A\uDE8E-\uDEC2\uDEC6\uDEC8\uDECD-\uDEDC\uDEDF-\uDEEA\uDEEF]|\uDDCE(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?|\uDDD1(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1|\uDDD1\u200D\uD83E\uDDD2(?:\u200D\uD83E\uDDD2)?|\uDDD2(?:\u200D\uD83E\uDDD2)?))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|\uDEEF\u200D\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|\uDEEF\u200D\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|\uDEEF\u200D\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|\uDEEF\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|\uDEEF\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE])))?))?|\uDEF1(?:\uD83C(?:\uDFFB(?:\u200D\uD83E\uDEF2\uD83C[\uDFFC-\uDFFF])?|\uDFFC(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFD-\uDFFF])?|\uDFFD(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])?|\uDFFE(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFD\uDFFF])?|\uDFFF(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFE])?))?)/g;
};

});





parcelRegister("gtixw", function(module, exports) {

$parcel$export(module.exports, "Mesh2D", () => $bfddbc5de451c8ba$export$73aa659f2322b537);

var $4I7rl = parcelRequire("4I7rl");

var $j2mX5 = parcelRequire("j2mX5");

var $diGQf = parcelRequire("diGQf");

var $iTsdq = parcelRequire("iTsdq");
var $bfddbc5de451c8ba$var$Keywords;
(function(Keywords) {
    Keywords["P3ColorSpace"] = "SRGB_TO_P3";
    Keywords["Multiview"] = "MULTIVIEW";
})($bfddbc5de451c8ba$var$Keywords || ($bfddbc5de451c8ba$var$Keywords = {}));
class $bfddbc5de451c8ba$export$73aa659f2322b537 {
    get colorMultiplier() {
        return this._colorMultiplier;
    }
    set colorMultiplier(value) {
        if (this._colorMultiplier === value) return;
        this._colorMultiplier = value;
        try {
            this.mesh.material.setFloat("colorMultiplier", value);
        } catch (e) {
        //TODO Придумать как обойтись без try-catch для кастомных материалов.
        }
    }
    static get p3ColorSpace() {
        return this._p3ColorSpace;
    }
    static set p3ColorSpace(value) {
        if (this._p3ColorSpace === value) return;
        this._p3ColorSpace = value;
        try {
            for (const material of $bfddbc5de451c8ba$export$73aa659f2322b537.Meshes.map((m)=>m.mesh.mesh.material))this.setDefine(material, $bfddbc5de451c8ba$var$Keywords.P3ColorSpace, value);
        } catch (e) {
        //TODO Придумать как обойтись без try-catch для кастомных материалов.
        }
    }
    static get multiview() {
        return this._multiview;
    }
    static set multiview(value) {
        if (this._multiview === value) return;
        this._multiview = value;
        try {
            for (const material of $bfddbc5de451c8ba$export$73aa659f2322b537.Meshes.map((m)=>m.mesh.mesh.material)){
                this.setDefine(material, $bfddbc5de451c8ba$var$Keywords.Multiview, value);
                if (material && material.isMultiview !== $bfddbc5de451c8ba$export$73aa659f2322b537.multiview) material.isReady(); // hack to force effect bind
            }
        } catch (e) {
        //TODO Придумать как обойтись без try-catch для кастомных материалов.
        }
    }
    get isVisible() {
        return this.mesh.isVisible;
    }
    set isVisible(value) {
        if (this.mesh.isVisible === value) return;
        this.mesh.isVisible = value;
        this.onIsVisibleChanged.notifyObservers(value);
    }
    /**
     * Mesh2D constructor.
     * @param name - mesh name.
     * @param width - width in meters.
     * @param height - height in meters.
     * @param scene
     * @param ppm - density in pixels per meter.
     * @param generateMipMaps - true by default.
     * @param meshData
     */ constructor(name, width, height, scene, ppm, generateMipMaps = true, meshData){
        this.width = width;
        this.height = height;
        this.scene = scene;
        this.ppm = ppm;
        this.generateMipMaps = generateMipMaps;
        this.onIsVisibleChanged = new (0, $diGQf.Observable)();
        this._colorMultiplier = 1;
        this.mesh = this.createMesh(name, meshData);
        this.texture = $bfddbc5de451c8ba$export$73aa659f2322b537._createTexture(this.mesh, generateMipMaps, width * ppm, height * ppm);
        if (name != "") $bfddbc5de451c8ba$export$73aa659f2322b537.Meshes.push({
            name: name,
            mesh: this
        });
        $bfddbc5de451c8ba$export$73aa659f2322b537.multiview = this.mesh !== null && !!this.mesh.getEngine().getCaps().multiview && this.mesh.getScene().activeCamera !== null && this.mesh.getScene().activeCamera.outputRenderTarget !== null && this.mesh.getScene().activeCamera.outputRenderTarget.getViewCount() > 1;
        if ($bfddbc5de451c8ba$export$73aa659f2322b537._cameraObserver === null) $bfddbc5de451c8ba$export$73aa659f2322b537._cameraObserver = this.mesh.getScene().onBeforeRenderObservable.add((s)=>{
            $bfddbc5de451c8ba$export$73aa659f2322b537.multiview = s !== null && !!s.getEngine().getCaps().multiview && s.activeCamera !== null && s.activeCamera.outputRenderTarget !== null && s.activeCamera.outputRenderTarget.getViewCount() > 1;
        });
    }
    /**
     * Defines a passed keyword in a material.
     *
     * @param material Material to add keyword to.
     * @param keyword Keyword to define.
     */ static define(material, keyword) {
        if (!material || !material || !material.options) return;
        if (keyword == "" || material.options.defines.includes("#define " + keyword) || material.options.defines.includes(keyword)) return;
        material.options.defines.push("#define " + keyword);
    }
    /**
     * Undefines a passed keyword in a material.
     *
     * @param material Material to remove keyword from.
     * @param keyword Keyword to undefine.
     */ static undefine(material, keyword) {
        if (!material || !material || !material.options) return;
        if (keyword == "" || !material.options.defines.includes("#define " + keyword) && !material.options.defines.includes(keyword)) return;
        let idx = material.options.defines.indexOf("#define " + keyword);
        material.options.defines.splice(idx, 1);
    }
    static setDefine(material, keyword, value) {
        if (material === null) return;
        else if (value) $bfddbc5de451c8ba$export$73aa659f2322b537.define(material, keyword);
        else $bfddbc5de451c8ba$export$73aa659f2322b537.undefine(material, keyword);
    }
    dispose() {
        this.texture.dispose();
        this.scene.removeMesh(this.mesh);
        const idx = $bfddbc5de451c8ba$export$73aa659f2322b537.Meshes.findIndex((m)=>m.name === this.mesh.name);
        if (idx >= 0) $bfddbc5de451c8ba$export$73aa659f2322b537.Meshes.splice(idx, 1);
        if ($bfddbc5de451c8ba$export$73aa659f2322b537.Meshes.length === 0) {
            $bfddbc5de451c8ba$export$73aa659f2322b537._cameraObserver?.remove();
            $bfddbc5de451c8ba$export$73aa659f2322b537._cameraObserver = null;
        }
    }
    /**
     * Converts meters to pixels.
     * @param value in meters.
     */ m2px(value) {
        return Math.round(value * this.ppm);
    }
    // noinspection JSUnusedGlobalSymbols
    /**
     * Converts pixels to meters.
     * @param value in pixels.
     */ px2m(value) {
        return value / this.ppm;
    }
    // noinspection JSUnusedGlobalSymbols
    // deprecated
    textLayoutM2Px(value) {
        const common = Object.assign({}, value.common);
        const normal = Object.assign({}, value.normal);
        const hover = Object.assign({}, value.hover);
        const pressed = Object.assign({}, value.pressed);
        const disabled = Object.assign({}, value.disabled);
        if (common.fontSize) common.fontSize = this.m2px(common.fontSize);
        if (normal.fontSize) normal.fontSize = this.m2px(normal.fontSize);
        if (hover.fontSize) hover.fontSize = this.m2px(hover.fontSize);
        if (pressed.fontSize) pressed.fontSize = this.m2px(pressed.fontSize);
        if (disabled.fontSize) disabled.fontSize = this.m2px(disabled.fontSize);
        return {
            common: common,
            normal: normal,
            hover: hover,
            pressed: pressed,
            disabled: disabled
        };
    }
    // Notify PointerOut observables when mesh is no longer selected.
    notifyChildrenOnPointerOut() {
        const notifyChildren = (container)=>{
            container.children.forEach((x)=>{
                if (x.children !== undefined) notifyChildren(x);
            });
            container.onPointerOutObservable.notifyObservers(container, -1, container, container);
        };
        notifyChildren(this.texture.rootContainer);
    }
    // This code is taken from AdvancedDynamicTexture.CreateForMesh because it's the only way to disable creating mipmaps
    static _createTexture(mesh, generateMipMaps, width, height, colorMultiplier = 1) {
        const result = new (0, $iTsdq.AdvancedDynamicTexture)(mesh.name + " AdvancedDynamicTexture", width, height, mesh.getScene(), generateMipMaps, (0, $j2mX5.Texture).TRILINEAR_SAMPLINGMODE); // generateMipMaps -> false
        const material = new (0, $4I7rl.ShaderMaterial)("AdvancedDynamicTextureMaterial", mesh.getScene(), {
            vertexSource: `precision highp float;
                attribute vec3 position;
                attribute vec2 uv;
                uniform mat4 viewProjection;
                uniform mat4 world;
                #ifdef MULTIVIEW
                    uniform mat4 viewProjectionR;
                #endif
                varying vec2 vUV;
                void main(void) {
                    vec4 worldPos = world * vec4(position, 1.0);
                    #ifdef MULTIVIEW
                        if (gl_ViewID_OVR == 0u) {
                            gl_Position = viewProjection * worldPos;
                        } else {
                            gl_Position = viewProjectionR * worldPos;
                        }
                    #else
                        gl_Position = viewProjection * worldPos;
                    #endif
                    vUV = uv;
                }`,
            fragmentSource: `precision highp float;
                varying vec2 vUV;
                uniform sampler2D mainTex;
                uniform float colorMultiplier;
                void main(void) {
                    gl_FragColor = texture2D(mainTex, vUV);
                    gl_FragColor.rgb *= colorMultiplier;
                    #ifdef SRGB_TO_P3
                        gl_FragColor = vec4(mix(pow(gl_FragColor.rgb * 0.9478672986 + vec3(0.0521327014), vec3(2.4)), gl_FragColor.rgb * 0.0773993808, vec3(lessThanEqual(gl_FragColor.rgb, vec3(0.04045)))), gl_FragColor.w);
                    #endif
                }`
        }, {
            attributes: [
                "position",
                "normal",
                "uv"
            ],
            uniforms: [
                "mainTex",
                "colorMultiplier",
                "world",
                "viewProjection",
                "viewProjectionR"
            ],
            defines: [],
            needAlphaBlending: true
        });
        material.backFaceCulling = false;
        material.setTexture("mainTex", result);
        material.setFloat("colorMultiplier", colorMultiplier);
        this.setDefine(material, $bfddbc5de451c8ba$var$Keywords.P3ColorSpace, $bfddbc5de451c8ba$export$73aa659f2322b537._p3ColorSpace);
        this.setDefine(material, $bfddbc5de451c8ba$var$Keywords.Multiview, $bfddbc5de451c8ba$export$73aa659f2322b537._multiview);
        if (material && material.isMultiview !== $bfddbc5de451c8ba$export$73aa659f2322b537.multiview) material.isReady();
        mesh.material = material;
        result.attachToMesh(mesh, true);
        return result;
    }
}
$bfddbc5de451c8ba$export$73aa659f2322b537._p3ColorSpace = false;
$bfddbc5de451c8ba$export$73aa659f2322b537._multiview = false;
$bfddbc5de451c8ba$export$73aa659f2322b537._cameraObserver = null;
$bfddbc5de451c8ba$export$73aa659f2322b537.Meshes = [];

});
parcelRegister("iTsdq", function(module, exports) {

$parcel$export(module.exports, "AdvancedDynamicTexture", () => $dc13400b3dc126d8$export$f032279d572248ce);

var $diGQf = parcelRequire("diGQf");

var $ha1VO = parcelRequire("ha1VO");

var $bOhSV = parcelRequire("bOhSV");

var $cfkw4 = parcelRequire("cfkw4");

var $951mg = parcelRequire("951mg");

var $bcFoB = parcelRequire("bcFoB");

var $j2mX5 = parcelRequire("j2mX5");

var $fJfwX = parcelRequire("fJfwX");

var $8fwD5 = parcelRequire("8fwD5");

var $esuuG = parcelRequire("esuuG");

var $fCNdl = parcelRequire("fCNdl");

var $g795W = parcelRequire("g795W");

var $lFAVI = parcelRequire("lFAVI");

var $gfKB2 = parcelRequire("gfKB2");

var $191mA = parcelRequire("191mA");

var $7etnY = parcelRequire("7etnY");

var $hUzEl = parcelRequire("hUzEl");

var $321Uk = parcelRequire("321Uk");

var $8DoUR = parcelRequire("8DoUR");

var $eLv1o = parcelRequire("eLv1o");
class $dc13400b3dc126d8$export$f032279d572248ce extends (0, $fJfwX.DynamicTexture) {
    /** Gets the number of layout calls made the last time the ADT has been rendered */ get numLayoutCalls() {
        return this._numLayoutCalls;
    }
    /** Gets the number of render calls made the last time the ADT has been rendered */ get numRenderCalls() {
        return this._numRenderCalls;
    }
    /**
     * Gets or sets a number used to scale rendering size (2 means that the texture will be twice bigger).
     * Useful when you want more antialiasing
     */ get renderScale() {
        return this._renderScale;
    }
    set renderScale(value) {
        if (value === this._renderScale) return;
        this._renderScale = value;
        this._onResize();
    }
    /** Gets or sets the background color */ get background() {
        return this._background;
    }
    set background(value) {
        if (this._background === value) return;
        this._background = value;
        this.markAsDirty();
    }
    /**
     * Gets or sets the ideal width used to design controls.
     * The GUI will then rescale everything accordingly
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#adaptive-scaling
     */ get idealWidth() {
        return this._idealWidth;
    }
    set idealWidth(value) {
        if (this._idealWidth === value) return;
        this._idealWidth = value;
        this.markAsDirty();
        this._rootContainer._markAllAsDirty();
    }
    /**
     * Gets or sets the ideal height used to design controls.
     * The GUI will then rescale everything accordingly
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#adaptive-scaling
     */ get idealHeight() {
        return this._idealHeight;
    }
    set idealHeight(value) {
        if (this._idealHeight === value) return;
        this._idealHeight = value;
        this.markAsDirty();
        this._rootContainer._markAllAsDirty();
    }
    /**
     * Gets or sets a boolean indicating if the smallest ideal value must be used if idealWidth and idealHeight are both set
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#adaptive-scaling
     */ get useSmallestIdeal() {
        return this._useSmallestIdeal;
    }
    set useSmallestIdeal(value) {
        if (this._useSmallestIdeal === value) return;
        this._useSmallestIdeal = value;
        this.markAsDirty();
        this._rootContainer._markAllAsDirty();
    }
    /**
     * Gets or sets a boolean indicating if adaptive scaling must be used
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#adaptive-scaling
     */ get renderAtIdealSize() {
        return this._renderAtIdealSize;
    }
    set renderAtIdealSize(value) {
        if (this._renderAtIdealSize === value) return;
        this._renderAtIdealSize = value;
        this._onResize();
    }
    /**
     * Gets the ratio used when in "ideal mode"
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#adaptive-scaling
     * */ get idealRatio() {
        let rwidth = 0;
        let rheight = 0;
        if (this._idealWidth) rwidth = this.getSize().width / this._idealWidth;
        if (this._idealHeight) rheight = this.getSize().height / this._idealHeight;
        if (this._useSmallestIdeal && this._idealWidth && this._idealHeight) return window.innerWidth < window.innerHeight ? rwidth : rheight;
        if (this._idealWidth) // horizontal
        return rwidth;
        if (this._idealHeight) // vertical
        return rheight;
        return 1;
    }
    /**
     * Gets the underlying layer used to render the texture when in fullscreen mode
     */ get layer() {
        return this._layerToDispose;
    }
    /**
     * Gets the root container control
     */ get rootContainer() {
        return this._rootContainer;
    }
    /**
     * Returns an array containing the root container.
     * This is mostly used to let the Inspector introspects the ADT
     * @returns an array containing the rootContainer
     */ getChildren() {
        return [
            this._rootContainer
        ];
    }
    /**
     * Will return all controls that are inside this texture
     * @param directDescendantsOnly defines if true only direct descendants of 'this' will be considered, if false direct and also indirect (children of children, an so on in a recursive manner) descendants of 'this' will be considered
     * @param predicate defines an optional predicate that will be called on every evaluated child, the predicate must return true for a given child to be part of the result, otherwise it will be ignored
     * @returns all child controls
     */ getDescendants(directDescendantsOnly, predicate) {
        return this._rootContainer.getDescendants(directDescendantsOnly, predicate);
    }
    /**
     * Will return all controls with the given type name
     * @param typeName defines the type name to search for
     * @returns an array of all controls found
     */ getControlsByType(typeName) {
        return this._rootContainer.getDescendants(false, (control)=>control.typeName === typeName);
    }
    /**
     * Will return the first control with the given name
     * @param name defines the name to search for
     * @returns the first control found or null
     */ getControlByName(name) {
        return this._getControlByKey("name", name);
    }
    _getControlByKey(key, value) {
        return this._rootContainer.getDescendants().find((control)=>control[key] === value) || null;
    }
    /**
     * Gets or sets the current focused control
     */ get focusedControl() {
        return this._focusedControl;
    }
    set focusedControl(control) {
        if (this._focusedControl == control) return;
        if (this._focusedControl) this._focusedControl.onBlur();
        if (control) control.onFocus();
        this._focusedControl = control;
    }
    /**
     * Gets or sets a boolean indicating if the texture must be rendered in background or foreground when in fullscreen mode
     */ get isForeground() {
        if (!this.layer) return true;
        return !this.layer.isBackground;
    }
    set isForeground(value) {
        if (!this.layer) return;
        if (this.layer.isBackground === !value) return;
        this.layer.isBackground = !value;
    }
    /**
     * Gets or set information about clipboardData
     */ get clipboardData() {
        return this._clipboardData;
    }
    set clipboardData(value) {
        this._clipboardData = value;
    }
    /**
     * Creates a new AdvancedDynamicTexture
     * @param name defines the name of the texture
     * @param width defines the width of the texture
     * @param height defines the height of the texture
     * @param scene defines the hosting scene
     * @param generateMipMaps defines a boolean indicating if mipmaps must be generated (false by default)
     * @param samplingMode defines the texture sampling mode (Texture.NEAREST_SAMPLINGMODE by default)
     * @param invertY defines if the texture needs to be inverted on the y axis during loading (true by default)
     */ constructor(name, width = 0, height = 0, scene, generateMipMaps = false, samplingMode = (0, $j2mX5.Texture).NEAREST_SAMPLINGMODE, invertY = true){
        super(name, {
            width: width,
            height: height
        }, scene, generateMipMaps, samplingMode, (0, $gfKB2.Constants).TEXTUREFORMAT_RGBA, invertY);
        /** Observable that fires when the GUI is ready */ this.onGuiReadyObservable = new (0, $diGQf.Observable)();
        this._isDirty = false;
        /** @internal */ this._rootContainer = new (0, $esuuG.Container)("root");
        /** @internal */ this._lastControlOver = {};
        /** @internal */ this._lastControlDown = {};
        /** @internal */ this._capturingControl = {};
        /** @internal */ this._linkedControls = new Array();
        /** @internal */ this._isFullscreen = false;
        this._fullscreenViewport = new (0, $191mA.Viewport)(0, 0, 1, 1);
        this._idealWidth = 0;
        this._idealHeight = 0;
        this._useSmallestIdeal = false;
        this._renderAtIdealSize = false;
        this._blockNextFocusCheck = false;
        this._renderScale = 1;
        this._cursorChanged = false;
        this._defaultMousePointerId = 0;
        this._rootChildrenHaveChanged = false;
        /** @internal */ this._capturedPointerIds = new Set();
        /** @internal */ this._numLayoutCalls = 0;
        /** @internal */ this._numRenderCalls = 0;
        /**
         * Define type to string to ensure compatibility across browsers
         * Safari doesn't support DataTransfer constructor
         */ this._clipboardData = "";
        /**
         * Observable event triggered each time an clipboard event is received from the rendering canvas
         */ this.onClipboardObservable = new (0, $diGQf.Observable)();
        /**
         * Observable event triggered each time a pointer down is intercepted by a control
         */ this.onControlPickedObservable = new (0, $diGQf.Observable)();
        /**
         * Observable event triggered before layout is evaluated
         */ this.onBeginLayoutObservable = new (0, $diGQf.Observable)();
        /**
         * Observable event triggered after the layout was evaluated
         */ this.onEndLayoutObservable = new (0, $diGQf.Observable)();
        /**
         * Observable event triggered before the texture is rendered
         */ this.onBeginRenderObservable = new (0, $diGQf.Observable)();
        /**
         * Observable event triggered after the texture was rendered
         */ this.onEndRenderObservable = new (0, $diGQf.Observable)();
        /**
         * Gets or sets a boolean defining if alpha is stored as premultiplied
         */ this.premulAlpha = false;
        /**
         * Gets or sets a boolean indicating that the canvas must be reverted on Y when updating the texture
         */ this.applyYInversionOnUpdate = true;
        /**
         * If this is set, even when a control is pointer blocker, some events can still be passed through to the scene.
         * Options from values are PointerEventTypes
         * POINTERDOWN, POINTERUP, POINTERMOVE, POINTERWHEEL, POINTERPICK, POINTERTAP, POINTERDOUBLETAP
         */ this.skipBlockEvents = 0;
        /**
         * If set to true, every scene render will trigger a pointer event for the GUI
         * if it is linked to a mesh or has controls linked to a mesh. This will allow
         * you to catch the pointer moving around the GUI due to camera or mesh movements,
         * but it has a performance cost.
         */ this.checkPointerEveryFrame = false;
        this._useInvalidateRectOptimization = true;
        // Invalidated rectangle which is the combination of all invalidated controls after they have been rotated into absolute position
        this._invalidatedRectangle = null;
        this._clearMeasure = new (0, $lFAVI.Measure)(0, 0, 0, 0);
        /**
         * @internal
         */ this._onClipboardCopy = (rawEvt)=>{
            const evt = rawEvt;
            const ev = new (0, $951mg.ClipboardInfo)((0, $951mg.ClipboardEventTypes).COPY, evt);
            this.onClipboardObservable.notifyObservers(ev);
            evt.preventDefault();
        };
        /**
         * @internal
         */ this._onClipboardCut = (rawEvt)=>{
            const evt = rawEvt;
            const ev = new (0, $951mg.ClipboardInfo)((0, $951mg.ClipboardEventTypes).CUT, evt);
            this.onClipboardObservable.notifyObservers(ev);
            evt.preventDefault();
        };
        /**
         * @internal
         */ this._onClipboardPaste = (rawEvt)=>{
            const evt = rawEvt;
            const ev = new (0, $951mg.ClipboardInfo)((0, $951mg.ClipboardEventTypes).PASTE, evt);
            this.onClipboardObservable.notifyObservers(ev);
            evt.preventDefault();
        };
        /**
         * Recreate the content of the ADT from a JSON object
         * @param serializedObject define the JSON serialized object to restore from
         * @param scaleToSize defines whether to scale to texture to the saved size
         * @deprecated Please use parseSerializedObject instead
         */ this.parseContent = this.parseSerializedObject;
        scene = this.getScene();
        if (!scene || !this._texture) return;
        this.applyYInversionOnUpdate = invertY;
        this._rootElement = scene.getEngine().getInputElement();
        this._renderObserver = scene.onBeforeCameraRenderObservable.add((camera)=>this._checkUpdate(camera));
        /** Whenever a control is added or removed to the root, we have to recheck the camera projection as it can have changed  */ this._controlAddedObserver = this._rootContainer.onControlAddedObservable.add((control)=>{
            if (control) this._rootChildrenHaveChanged = true;
        });
        this._controlRemovedObserver = this._rootContainer.onControlRemovedObservable.add((control)=>{
            if (control) this._rootChildrenHaveChanged = true;
        });
        this._preKeyboardObserver = scene.onPreKeyboardObservable.add((info)=>{
            if (!this._focusedControl) return;
            if (info.type === (0, $bcFoB.KeyboardEventTypes).KEYDOWN) this._focusedControl.processKeyboard(info.event);
            info.skipOnPointerObservable = true;
        });
        this._rootContainer._link(this);
        this.hasAlpha = true;
        if (!width || !height) {
            this._resizeObserver = scene.getEngine().onResizeObservable.add(()=>this._onResize());
            this._onResize();
        }
        this._texture.isReady = true;
    }
    /**
     * Get the current class name of the texture useful for serialization or dynamic coding.
     * @returns "AdvancedDynamicTexture"
     */ getClassName() {
        return "AdvancedDynamicTexture";
    }
    /**
     * Function used to execute a function on all controls
     * @param func defines the function to execute
     * @param container defines the container where controls belong. If null the root container will be used
     */ executeOnAllControls(func, container) {
        if (!container) container = this._rootContainer;
        func(container);
        for (const child of container.children){
            if (child.children) {
                this.executeOnAllControls(func, child);
                continue;
            }
            func(child);
        }
    }
    /**
     * Gets or sets a boolean indicating if the InvalidateRect optimization should be turned on
     */ get useInvalidateRectOptimization() {
        return this._useInvalidateRectOptimization;
    }
    set useInvalidateRectOptimization(value) {
        this._useInvalidateRectOptimization = value;
    }
    /**
     * Invalidates a rectangle area on the gui texture
     * @param invalidMinX left most position of the rectangle to invalidate in the texture
     * @param invalidMinY top most position of the rectangle to invalidate in the texture
     * @param invalidMaxX right most position of the rectangle to invalidate in the texture
     * @param invalidMaxY bottom most position of the rectangle to invalidate in the texture
     */ invalidateRect(invalidMinX, invalidMinY, invalidMaxX, invalidMaxY) {
        if (!this._useInvalidateRectOptimization) return;
        if (!this._invalidatedRectangle) this._invalidatedRectangle = new (0, $lFAVI.Measure)(invalidMinX, invalidMinY, invalidMaxX - invalidMinX + 1, invalidMaxY - invalidMinY + 1);
        else {
            // Compute intersection
            const maxX = Math.ceil(Math.max(this._invalidatedRectangle.left + this._invalidatedRectangle.width - 1, invalidMaxX));
            const maxY = Math.ceil(Math.max(this._invalidatedRectangle.top + this._invalidatedRectangle.height - 1, invalidMaxY));
            this._invalidatedRectangle.left = Math.floor(Math.min(this._invalidatedRectangle.left, invalidMinX));
            this._invalidatedRectangle.top = Math.floor(Math.min(this._invalidatedRectangle.top, invalidMinY));
            this._invalidatedRectangle.width = maxX - this._invalidatedRectangle.left + 1;
            this._invalidatedRectangle.height = maxY - this._invalidatedRectangle.top + 1;
        }
    }
    /**
     * Marks the texture as dirty forcing a complete update
     */ markAsDirty() {
        this._isDirty = true;
    }
    /**
     * Helper function used to create a new style
     * @returns a new style
     * @see https://doc.babylonjs.com/features/featuresDeepDive/gui/gui#styles
     */ createStyle() {
        return new (0, $g795W.Style)(this);
    }
    /**
     * Adds a new control to the root container
     * @param control defines the control to add
     * @returns the current texture
     */ addControl(control) {
        this._rootContainer.addControl(control);
        return this;
    }
    /**
     * Removes a control from the root container
     * @param control defines the control to remove
     * @returns the current texture
     */ removeControl(control) {
        this._rootContainer.removeControl(control);
        return this;
    }
    /**
     * Moves overlapped controls towards a position where it is not overlapping anymore.
     * Please note that this method alters linkOffsetXInPixels and linkOffsetYInPixels.
     * @param overlapGroup the overlap group which will be processed or undefined to process all overlap groups
     * @param deltaStep the step size (speed) to reach the target non overlapping position (default 0.1)
     * @param repelFactor how much is the control repelled by other controls
     */ moveToNonOverlappedPosition(overlapGroup, deltaStep = 1, repelFactor = 1) {
        let controlsForGroup;
        if (Array.isArray(overlapGroup)) controlsForGroup = overlapGroup;
        else {
            const descendants = this.getDescendants(true);
            // get only the controls with an overlapGroup property set
            // if the overlapGroup parameter is set, filter the controls and get only the controls belonging to that overlapGroup
            controlsForGroup = overlapGroup === undefined ? descendants.filter((c)=>c.overlapGroup !== undefined) : descendants.filter((c)=>c.overlapGroup === overlapGroup);
        }
        controlsForGroup.forEach((control1)=>{
            let velocity = (0, $ha1VO.Vector2).Zero();
            const center = new (0, $ha1VO.Vector2)(control1.centerX, control1.centerY);
            controlsForGroup.forEach((control2)=>{
                if (control1 !== control2 && $dc13400b3dc126d8$export$f032279d572248ce._Overlaps(control1, control2)) {
                    // if the two controls overlaps get a direction vector from one control's center to another control's center
                    const diff = center.subtract(new (0, $ha1VO.Vector2)(control2.centerX, control2.centerY));
                    const diffLength = diff.length();
                    if (diffLength > 0) // calculate the velocity
                    velocity = velocity.add(diff.normalize().scale(repelFactor / diffLength));
                }
            });
            if (velocity.length() > 0) {
                // move the control along the direction vector away from the overlapping control
                velocity = velocity.normalize().scale(deltaStep * (control1.overlapDeltaMultiplier ?? 1));
                control1.linkOffsetXInPixels += velocity.x;
                control1.linkOffsetYInPixels += velocity.y;
            }
        });
    }
    /**
     * Release all resources
     */ dispose() {
        const scene = this.getScene();
        if (!scene) return;
        this._rootElement = null;
        scene.onBeforeCameraRenderObservable.remove(this._renderObserver);
        if (this._resizeObserver) scene.getEngine().onResizeObservable.remove(this._resizeObserver);
        if (this._prePointerObserver) scene.onPrePointerObservable.remove(this._prePointerObserver);
        if (this._sceneRenderObserver) scene.onBeforeRenderObservable.remove(this._sceneRenderObserver);
        if (this._pointerObserver) scene.onPointerObservable.remove(this._pointerObserver);
        if (this._preKeyboardObserver) scene.onPreKeyboardObservable.remove(this._preKeyboardObserver);
        if (this._canvasPointerOutObserver) scene.getEngine().onCanvasPointerOutObservable.remove(this._canvasPointerOutObserver);
        if (this._canvasBlurObserver) scene.getEngine().onCanvasBlurObservable.remove(this._canvasBlurObserver);
        if (this._controlAddedObserver) this._rootContainer.onControlAddedObservable.remove(this._controlAddedObserver);
        if (this._controlRemovedObserver) this._rootContainer.onControlRemovedObservable.remove(this._controlRemovedObserver);
        if (this._layerToDispose) {
            this._layerToDispose.texture = null;
            this._layerToDispose.dispose();
            this._layerToDispose = null;
        }
        this._rootContainer.dispose();
        this.onClipboardObservable.clear();
        this.onControlPickedObservable.clear();
        this.onBeginRenderObservable.clear();
        this.onEndRenderObservable.clear();
        this.onBeginLayoutObservable.clear();
        this.onEndLayoutObservable.clear();
        this.onGuiReadyObservable.clear();
        super.dispose();
    }
    _onResize() {
        const scene = this.getScene();
        if (!scene) return;
        // Check size
        const engine = scene.getEngine();
        const textureSize = this.getSize();
        let renderWidth = engine.getRenderWidth() * this._renderScale;
        let renderHeight = engine.getRenderHeight() * this._renderScale;
        if (this._renderAtIdealSize) {
            if (this._idealWidth) {
                renderHeight = renderHeight * this._idealWidth / renderWidth;
                renderWidth = this._idealWidth;
            } else if (this._idealHeight) {
                renderWidth = renderWidth * this._idealHeight / renderHeight;
                renderHeight = this._idealHeight;
            }
        }
        if (textureSize.width !== renderWidth || textureSize.height !== renderHeight) {
            this.scaleTo(renderWidth, renderHeight);
            this.markAsDirty();
            if (this._idealWidth || this._idealHeight) this._rootContainer._markAllAsDirty();
        }
        this.invalidateRect(0, 0, textureSize.width - 1, textureSize.height - 1);
    }
    /** @internal */ _getGlobalViewport() {
        const size = this.getSize();
        const globalViewPort = this._fullscreenViewport.toGlobal(size.width, size.height);
        const targetX = Math.round(globalViewPort.width * (1 / this.rootContainer.scaleX));
        const targetY = Math.round(globalViewPort.height * (1 / this.rootContainer.scaleY));
        globalViewPort.x += (globalViewPort.width - targetX) / 2;
        globalViewPort.y += (globalViewPort.height - targetY) / 2;
        globalViewPort.width = targetX;
        globalViewPort.height = targetY;
        return globalViewPort;
    }
    /**
     * Get screen coordinates for a vector3
     * @param position defines the position to project
     * @param worldMatrix defines the world matrix to use
     * @returns the projected position
     */ getProjectedPosition(position, worldMatrix) {
        const result = this.getProjectedPositionWithZ(position, worldMatrix);
        return new (0, $ha1VO.Vector2)(result.x, result.y);
    }
    /**
     * Get screen coordinates for a vector3
     * @param position defines the position to project
     * @param worldMatrix defines the world matrix to use
     * @returns the projected position with Z
     */ getProjectedPositionWithZ(position, worldMatrix) {
        const scene = this.getScene();
        if (!scene) return (0, $ha1VO.Vector3).Zero();
        const globalViewport = this._getGlobalViewport();
        const projectedPosition = (0, $ha1VO.Vector3).Project(position, worldMatrix, scene.getTransformMatrix(), globalViewport);
        return new (0, $ha1VO.Vector3)(projectedPosition.x, projectedPosition.y, projectedPosition.z);
    }
    _checkUpdate(camera, skipUpdate) {
        if (this._layerToDispose) {
            if ((camera.layerMask & this._layerToDispose.layerMask) === 0) return;
        }
        if (this._isFullscreen && this._linkedControls.length) {
            const scene = this.getScene();
            if (!scene) return;
            const globalViewport = this._getGlobalViewport();
            for (const control of this._linkedControls){
                if (!control.isVisible) continue;
                const mesh = control._linkedMesh;
                if (!mesh || mesh.isDisposed()) {
                    (0, $bOhSV.Tools).SetImmediate(()=>{
                        control.linkWithMesh(null);
                    });
                    continue;
                }
                const position = mesh.getBoundingInfo ? mesh.getBoundingInfo().boundingSphere.center : (0, $ha1VO.Vector3).ZeroReadOnly;
                const projectedPosition = (0, $ha1VO.Vector3).Project(position, mesh.getWorldMatrix(), scene.getTransformMatrix(), globalViewport);
                if (projectedPosition.z < 0 || projectedPosition.z > 1) {
                    control.notRenderable = true;
                    continue;
                }
                control.notRenderable = false;
                if (this.useInvalidateRectOptimization) control.invalidateRect();
                control._moveToProjectedPosition(projectedPosition);
            }
        }
        if (!this._isDirty && !this._rootContainer.isDirty) return;
        this._isDirty = false;
        this._render(skipUpdate);
        if (!skipUpdate) this.update(this.applyYInversionOnUpdate, this.premulAlpha, $dc13400b3dc126d8$export$f032279d572248ce.AllowGPUOptimizations);
    }
    _render(skipRender) {
        const textureSize = this.getSize();
        const renderWidth = textureSize.width;
        const renderHeight = textureSize.height;
        const context = this.getContext();
        context.font = "18px Arial";
        context.strokeStyle = "white";
        if (this.onGuiReadyObservable.hasObservers()) this._checkGuiIsReady();
        /** We have to recheck the camera projection in the case the root control's children have changed  */ if (this._rootChildrenHaveChanged) {
            const camera = this.getScene()?.activeCamera;
            if (camera) {
                this._rootChildrenHaveChanged = false;
                this._checkUpdate(camera, true);
            }
        }
        // Layout
        this.onBeginLayoutObservable.notifyObservers(this);
        const measure = new (0, $lFAVI.Measure)(0, 0, renderWidth, renderHeight);
        this._numLayoutCalls = 0;
        this._rootContainer._layout(measure, context);
        this.onEndLayoutObservable.notifyObservers(this);
        this._isDirty = false; // Restoring the dirty state that could have been set by controls during layout processing
        if (skipRender) return;
        // Clear
        if (this._invalidatedRectangle) this._clearMeasure.copyFrom(this._invalidatedRectangle);
        else this._clearMeasure.copyFromFloats(0, 0, renderWidth, renderHeight);
        context.clearRect(this._clearMeasure.left, this._clearMeasure.top, this._clearMeasure.width, this._clearMeasure.height);
        if (this._background) {
            context.save();
            context.fillStyle = this._background;
            context.fillRect(this._clearMeasure.left, this._clearMeasure.top, this._clearMeasure.width, this._clearMeasure.height);
            context.restore();
        }
        // Render
        this.onBeginRenderObservable.notifyObservers(this);
        this._numRenderCalls = 0;
        this._rootContainer._render(context, this._invalidatedRectangle);
        this.onEndRenderObservable.notifyObservers(this);
        this._invalidatedRectangle = null;
    }
    /**
     * @internal
     */ _changeCursor(cursor) {
        if (this._rootElement) {
            this._rootElement.style.cursor = cursor;
            this._cursorChanged = true;
        }
    }
    /**
     * @internal
     */ _registerLastControlDown(control, pointerId) {
        this._lastControlDown[pointerId] = control;
        this.onControlPickedObservable.notifyObservers(control);
    }
    _doPicking(x, y, pi, type, pointerId, buttonIndex, deltaX, deltaY) {
        const scene = this.getScene();
        if (!scene) return;
        const engine = scene.getEngine();
        const textureSize = this.getSize();
        if (this._isFullscreen) {
            const camera = scene.cameraToUseForPointers || scene.activeCamera;
            if (!camera) return;
            const viewport = camera.viewport;
            x = x * (textureSize.width / (engine.getRenderWidth() * viewport.width));
            y = y * (textureSize.height / (engine.getRenderHeight() * viewport.height));
        }
        if (this._capturingControl[pointerId]) {
            if (this._capturingControl[pointerId].isPointerBlocker) this._shouldBlockPointer = true;
            this._capturingControl[pointerId]._processObservables(type, x, y, pi, pointerId, buttonIndex);
            return;
        }
        this._cursorChanged = false;
        if (!this._rootContainer._processPicking(x, y, pi, type, pointerId, buttonIndex, deltaX, deltaY)) {
            if (!scene.doNotHandleCursors) this._changeCursor("");
            if (type === (0, $cfkw4.PointerEventTypes).POINTERMOVE) {
                if (this._lastControlOver[pointerId]) {
                    this._lastControlOver[pointerId]._onPointerOut(this._lastControlOver[pointerId], pi);
                    delete this._lastControlOver[pointerId];
                }
            }
        }
        if (!this._cursorChanged && !scene.doNotHandleCursors) this._changeCursor("");
        this._manageFocus();
    }
    /**
     * @internal
     */ _cleanControlAfterRemovalFromList(list, control) {
        for(const pointerId in list){
            if (!Object.prototype.hasOwnProperty.call(list, pointerId)) continue;
            const lastControlOver = list[pointerId];
            if (lastControlOver === control) delete list[pointerId];
        }
    }
    /**
     * @internal
     */ _cleanControlAfterRemoval(control) {
        this._cleanControlAfterRemovalFromList(this._lastControlDown, control);
        this._cleanControlAfterRemovalFromList(this._lastControlOver, control);
    }
    /**
     * This function will run a pointer event on this ADT and will trigger any pointer events on any controls
     * This will work on a fullscreen ADT only. For mesh based ADT, simulate pointer events using the scene directly.
     * @param x pointer X on the canvas for the picking
     * @param y pointer Y on the canvas for the picking
     * @param pi optional pointer information
     */ pick(x, y, pi = null) {
        if (this._isFullscreen && this._scene) this._translateToPicking(this._scene, new (0, $191mA.Viewport)(0, 0, 0, 0), pi, x, y);
    }
    _translateToPicking(scene, tempViewport, pi, x = scene.pointerX, y = scene.pointerY) {
        const camera = scene.cameraToUseForPointers || scene.activeCamera;
        const engine = scene.getEngine();
        const originalCameraToUseForPointers = scene.cameraToUseForPointers;
        if (!camera) {
            tempViewport.x = 0;
            tempViewport.y = 0;
            tempViewport.width = engine.getRenderWidth();
            tempViewport.height = engine.getRenderHeight();
        } else if (camera.rigCameras.length) {
            // rig camera - we need to find the camera to use for this event
            const rigViewport = new (0, $191mA.Viewport)(0, 0, 1, 1);
            camera.rigCameras.forEach((rigCamera)=>{
                // generate the viewport of this camera
                rigCamera.viewport.toGlobalToRef(engine.getRenderWidth(), engine.getRenderHeight(), rigViewport);
                const transformedX = x / engine.getHardwareScalingLevel() - rigViewport.x;
                const transformedY = y / engine.getHardwareScalingLevel() - (engine.getRenderHeight() - rigViewport.y - rigViewport.height);
                // check if the pointer is in the camera's viewport
                if (transformedX < 0 || transformedY < 0 || x > rigViewport.width || y > rigViewport.height) // out of viewport - don't use this camera
                return;
                // set the camera to use for pointers until this pointer loop is over
                scene.cameraToUseForPointers = rigCamera;
                // set the viewport
                tempViewport.x = rigViewport.x;
                tempViewport.y = rigViewport.y;
                tempViewport.width = rigViewport.width;
                tempViewport.height = rigViewport.height;
            });
        } else camera.viewport.toGlobalToRef(engine.getRenderWidth(), engine.getRenderHeight(), tempViewport);
        const transformedX = x / engine.getHardwareScalingLevel() - tempViewport.x;
        const transformedY = y / engine.getHardwareScalingLevel() - (engine.getRenderHeight() - tempViewport.y - tempViewport.height);
        this._shouldBlockPointer = false;
        // Do picking modifies _shouldBlockPointer
        if (pi) {
            const pointerId = pi.event.pointerId || this._defaultMousePointerId;
            this._doPicking(transformedX, transformedY, pi, pi.type, pointerId, pi.event.button, pi.event.deltaX, pi.event.deltaY);
            // Avoid overwriting a true skipOnPointerObservable to false
            if (this._shouldBlockPointer && !(pi.type & this.skipBlockEvents) || this._capturingControl[pointerId]) pi.skipOnPointerObservable = true;
        } else this._doPicking(transformedX, transformedY, null, (0, $cfkw4.PointerEventTypes).POINTERMOVE, this._defaultMousePointerId, 0);
        // if overridden by a rig camera - reset back to the original value
        scene.cameraToUseForPointers = originalCameraToUseForPointers;
    }
    /** Attach to all scene events required to support pointer events */ attach() {
        const scene = this.getScene();
        if (!scene) return;
        const tempViewport = new (0, $191mA.Viewport)(0, 0, 0, 0);
        this._prePointerObserver = scene.onPrePointerObservable.add((pi)=>{
            if (scene.isPointerCaptured(pi.event.pointerId) && pi.type === (0, $cfkw4.PointerEventTypes).POINTERUP && !this._capturedPointerIds.has(pi.event.pointerId)) return;
            if (pi.type !== (0, $cfkw4.PointerEventTypes).POINTERMOVE && pi.type !== (0, $cfkw4.PointerEventTypes).POINTERUP && pi.type !== (0, $cfkw4.PointerEventTypes).POINTERDOWN && pi.type !== (0, $cfkw4.PointerEventTypes).POINTERWHEEL) return;
            if (pi.type === (0, $cfkw4.PointerEventTypes).POINTERMOVE) {
                // Avoid pointerMove events firing while the pointer is captured by the scene
                if (scene.isPointerCaptured(pi.event.pointerId)) return;
                if (pi.event.pointerId) this._defaultMousePointerId = pi.event.pointerId; // This is required to make sure we have the correct pointer ID for wheel
            }
            this._translateToPicking(scene, tempViewport, pi);
        });
        this._attachPickingToSceneRender(scene, ()=>this._translateToPicking(scene, tempViewport, null), false);
        this._attachToOnPointerOut(scene);
        this._attachToOnBlur(scene);
    }
    /**
     * Register the clipboard Events onto the canvas
     */ registerClipboardEvents() {
        self.addEventListener("copy", this._onClipboardCopy, false);
        self.addEventListener("cut", this._onClipboardCut, false);
        self.addEventListener("paste", this._onClipboardPaste, false);
    }
    /**
     * Unregister the clipboard Events from the canvas
     */ unRegisterClipboardEvents() {
        self.removeEventListener("copy", this._onClipboardCopy);
        self.removeEventListener("cut", this._onClipboardCut);
        self.removeEventListener("paste", this._onClipboardPaste);
    }
    /**
     * Transform uvs from mesh space to texture space, taking the texture into account
     * @param uv the uvs in mesh space
     * @returns the uvs in texture space
     */ _transformUvs(uv) {
        const textureMatrix = this.getTextureMatrix();
        let result;
        if (textureMatrix.isIdentityAs3x2()) result = uv;
        else {
            const homogeneousTextureMatrix = (0, $ha1VO.TmpVectors).Matrix[0];
            textureMatrix.getRowToRef(0, (0, $ha1VO.TmpVectors).Vector4[0]);
            textureMatrix.getRowToRef(1, (0, $ha1VO.TmpVectors).Vector4[1]);
            textureMatrix.getRowToRef(2, (0, $ha1VO.TmpVectors).Vector4[2]);
            const r0 = (0, $ha1VO.TmpVectors).Vector4[0];
            const r1 = (0, $ha1VO.TmpVectors).Vector4[1];
            const r2 = (0, $ha1VO.TmpVectors).Vector4[2];
            homogeneousTextureMatrix.setRowFromFloats(0, r0.x, r0.y, 0, 0);
            homogeneousTextureMatrix.setRowFromFloats(1, r1.x, r1.y, 0, 0);
            homogeneousTextureMatrix.setRowFromFloats(2, 0, 0, 1, 0);
            homogeneousTextureMatrix.setRowFromFloats(3, r2.x, r2.y, 0, 1);
            result = (0, $ha1VO.TmpVectors).Vector2[0];
            (0, $ha1VO.Vector2).TransformToRef(uv, homogeneousTextureMatrix, result);
        }
        // In wrap and mirror mode, the texture coordinate for coordinates more than 1 is the fractional part of the coordinate
        if (this.wrapU === (0, $j2mX5.Texture).WRAP_ADDRESSMODE || this.wrapU === (0, $j2mX5.Texture).MIRROR_ADDRESSMODE) {
            if (result.x > 1) {
                let fX = result.x - Math.trunc(result.x);
                // In mirror mode, the sign of the texture coordinate depends on the integer part -
                // odd integers means it is mirrored from the original coordinate
                if (this.wrapU === (0, $j2mX5.Texture).MIRROR_ADDRESSMODE && Math.trunc(result.x) % 2 === 1) fX = 1 - fX;
                result.x = fX;
            }
        }
        if (this.wrapV === (0, $j2mX5.Texture).WRAP_ADDRESSMODE || this.wrapV === (0, $j2mX5.Texture).MIRROR_ADDRESSMODE) {
            if (result.y > 1) {
                let fY = result.y - Math.trunc(result.y);
                if (this.wrapV === (0, $j2mX5.Texture).MIRROR_ADDRESSMODE && Math.trunc(result.x) % 2 === 1) fY = 1 - fY;
                result.y = fY;
            }
        }
        return result;
    }
    /**
     * Connect the texture to a hosting mesh to enable interactions
     * @param mesh defines the mesh to attach to
     * @param supportPointerMove defines a boolean indicating if pointer move events must be catched as well
     */ attachToMesh(mesh, supportPointerMove = true) {
        const scene = this.getScene();
        if (!scene) return;
        if (this._pointerObserver) scene.onPointerObservable.remove(this._pointerObserver);
        this._pointerObserver = scene.onPointerObservable.add((pi)=>{
            if (pi.type !== (0, $cfkw4.PointerEventTypes).POINTERMOVE && pi.type !== (0, $cfkw4.PointerEventTypes).POINTERUP && pi.type !== (0, $cfkw4.PointerEventTypes).POINTERDOWN && pi.type !== (0, $cfkw4.PointerEventTypes).POINTERWHEEL) return;
            if (pi.type === (0, $cfkw4.PointerEventTypes).POINTERMOVE && pi.event.pointerId) this._defaultMousePointerId = pi.event.pointerId; // This is required to make sure we have the correct pointer ID for wheel
            const pointerId = pi.event.pointerId || this._defaultMousePointerId;
            if (pi.pickInfo && pi.pickInfo.hit && pi.pickInfo.pickedMesh === mesh) {
                let uv = pi.pickInfo.getTextureCoordinates();
                if (uv) {
                    uv = this._transformUvs(uv);
                    const size = this.getSize();
                    this._doPicking(uv.x * size.width, (this.applyYInversionOnUpdate ? 1.0 - uv.y : uv.y) * size.height, pi, pi.type, pointerId, pi.event.button, pi.event.deltaX, pi.event.deltaY);
                }
            } else if (pi.type === (0, $cfkw4.PointerEventTypes).POINTERUP) {
                if (this._lastControlDown[pointerId]) this._lastControlDown[pointerId]._forcePointerUp(pointerId);
                delete this._lastControlDown[pointerId];
                if (this.focusedControl) {
                    const friendlyControls = this.focusedControl.keepsFocusWith();
                    let canMoveFocus = true;
                    if (friendlyControls) for (const control of friendlyControls){
                        // Same host, no need to keep the focus
                        if (this === control._host) continue;
                        // Different hosts
                        const otherHost = control._host;
                        if (otherHost._lastControlOver[pointerId] && otherHost._lastControlOver[pointerId].isAscendant(control)) {
                            canMoveFocus = false;
                            break;
                        }
                    }
                    if (canMoveFocus) this.focusedControl = null;
                }
            } else if (pi.type === (0, $cfkw4.PointerEventTypes).POINTERMOVE) {
                if (this._lastControlOver[pointerId]) this._lastControlOver[pointerId]._onPointerOut(this._lastControlOver[pointerId], pi, true);
                delete this._lastControlOver[pointerId];
            }
        });
        mesh.enablePointerMoveEvents = supportPointerMove;
        this._attachPickingToSceneRender(scene, ()=>{
            const pointerId = this._defaultMousePointerId;
            const pick = scene?.pick(scene.pointerX, scene.pointerY);
            if (pick && pick.hit && pick.pickedMesh === mesh) {
                let uv = pick.getTextureCoordinates();
                if (uv) {
                    uv = this._transformUvs(uv);
                    const size = this.getSize();
                    this._doPicking(uv.x * size.width, (this.applyYInversionOnUpdate ? 1.0 - uv.y : uv.y) * size.height, null, (0, $cfkw4.PointerEventTypes).POINTERMOVE, pointerId, 0);
                }
            } else {
                if (this._lastControlOver[pointerId]) this._lastControlOver[pointerId]._onPointerOut(this._lastControlOver[pointerId], null, true);
                delete this._lastControlOver[pointerId];
            }
        }, true);
        this._attachToOnPointerOut(scene);
        this._attachToOnBlur(scene);
    }
    /**
     * Move the focus to a specific control
     * @param control defines the control which will receive the focus
     */ moveFocusToControl(control) {
        this.focusedControl = control;
        this._lastPickedControl = control;
        this._blockNextFocusCheck = true;
    }
    _manageFocus() {
        if (this._blockNextFocusCheck) {
            this._blockNextFocusCheck = false;
            this._lastPickedControl = this._focusedControl;
            return;
        }
        // Focus management
        if (this._focusedControl) {
            if (this._focusedControl !== this._lastPickedControl) {
                if (this._lastPickedControl.isFocusInvisible) return;
                this.focusedControl = null;
            }
        }
    }
    _attachPickingToSceneRender(scene, pickFunction, forcePicking) {
        this._sceneRenderObserver = scene.onBeforeRenderObservable.add(()=>{
            if (!this.checkPointerEveryFrame) return;
            if (this._linkedControls.length > 0 || forcePicking) pickFunction();
        });
    }
    _attachToOnPointerOut(scene) {
        this._canvasPointerOutObserver = scene.getEngine().onCanvasPointerOutObservable.add((pointerEvent)=>{
            if (this._lastControlOver[pointerEvent.pointerId]) this._lastControlOver[pointerEvent.pointerId]._onPointerOut(this._lastControlOver[pointerEvent.pointerId], null);
            delete this._lastControlOver[pointerEvent.pointerId];
            if (this._lastControlDown[pointerEvent.pointerId] && this._lastControlDown[pointerEvent.pointerId] !== this._capturingControl[pointerEvent.pointerId]) {
                this._lastControlDown[pointerEvent.pointerId]._forcePointerUp(pointerEvent.pointerId);
                delete this._lastControlDown[pointerEvent.pointerId];
            }
        });
    }
    _attachToOnBlur(scene) {
        this._canvasBlurObserver = scene.getEngine().onCanvasBlurObservable.add(()=>{
            Object.entries(this._lastControlDown).forEach(([, value])=>{
                value._onCanvasBlur();
            });
            this.focusedControl = null;
            this._lastControlDown = {};
        });
    }
    /**
     * Serializes the entire GUI system
     * @returns an object with the JSON serialized data
     */ serializeContent() {
        const size = this.getSize();
        const serializationObject = {
            root: {},
            width: size.width,
            height: size.height
        };
        this._rootContainer.serialize(serializationObject.root);
        return serializationObject;
    }
    /**
     * Recreate the content of the ADT from a JSON object
     * @param serializedObject define the JSON serialized object to restore from
     * @param scaleToSize defines whether to scale to texture to the saved size
     */ parseSerializedObject(serializedObject, scaleToSize) {
        this._rootContainer = (0, $fCNdl.Control).Parse(serializedObject.root, this);
        if (scaleToSize) {
            const width = serializedObject.width;
            const height = serializedObject.height;
            if (typeof width === "number" && typeof height === "number" && width >= 0 && height >= 0) this.scaleTo(width, height);
            else // scales the GUI to a default size if none was available in the serialized content
            this.scaleTo(1920, 1080);
        }
    }
    /**
     * Clones the ADT. If no mesh is defined, the GUI will be considered as a fullscreen GUI
     * @param newName defines the name of the new ADT
     * @param attachToMesh defines if the new ADT should be attached to a mesh
     * @returns the clone of the ADT
     */ clone(newName, attachToMesh) {
        const scene = this.getScene();
        if (!scene) return this;
        const size = this.getSize();
        const data = this.serializeContent();
        let clone;
        if (!this._isFullscreen) {
            if (attachToMesh) clone = $dc13400b3dc126d8$export$f032279d572248ce.CreateForMesh(attachToMesh, size.width, size.height);
            else clone = new $dc13400b3dc126d8$export$f032279d572248ce(newName ?? "Clone of " + this.name, size.width, size.height, scene, !this.noMipmap, this.samplingMode);
        } else clone = $dc13400b3dc126d8$export$f032279d572248ce.CreateFullscreenUI(newName ?? "Clone of " + this.name);
        clone.parseSerializedObject(data);
        return clone;
    }
    /**
     * Recreate the content of the ADT from a snippet saved by the GUI editor
     * @param snippetId defines the snippet to load
     * @param scaleToSize defines whether to scale to texture to the saved size
     * @param appendToAdt if provided the snippet will be appended to the adt. Otherwise a fullscreen ADT will be created.
     * @returns a promise that will resolve on success
     */ static async ParseFromSnippetAsync(snippetId, scaleToSize, appendToAdt) {
        const adt = appendToAdt ?? $dc13400b3dc126d8$export$f032279d572248ce.CreateFullscreenUI("ADT from snippet");
        if (snippetId === "_BLANK") return adt;
        const serialized = await $dc13400b3dc126d8$export$f032279d572248ce._LoadURLContentAsync($dc13400b3dc126d8$export$f032279d572248ce.SnippetUrl + "/" + snippetId.replace(/#/g, "/"), true);
        adt.parseSerializedObject(serialized, scaleToSize);
        return adt;
    }
    /**
     * Recreate the content of the ADT from a snippet saved by the GUI editor
     * @param snippetId defines the snippet to load
     * @param scaleToSize defines whether to scale to texture to the saved size
     * @returns a promise that will resolve on success
     */ parseFromSnippetAsync(snippetId, scaleToSize) {
        return $dc13400b3dc126d8$export$f032279d572248ce.ParseFromSnippetAsync(snippetId, scaleToSize, this);
    }
    /**
     * Recreate the content of the ADT from a url json
     * @param url defines the url to load
     * @param scaleToSize defines whether to scale to texture to the saved size
     * @param appendToAdt if provided the snippet will be appended to the adt. Otherwise a fullscreen ADT will be created.
     * @returns a promise that will resolve on success
     */ static async ParseFromFileAsync(url, scaleToSize, appendToAdt) {
        const adt = appendToAdt ?? $dc13400b3dc126d8$export$f032279d572248ce.CreateFullscreenUI("ADT from URL");
        const serialized = await $dc13400b3dc126d8$export$f032279d572248ce._LoadURLContentAsync(url);
        adt.parseSerializedObject(serialized, scaleToSize);
        return adt;
    }
    /**
     * Recreate the content of the ADT from a url json
     * @param url defines the url to load
     * @param scaleToSize defines whether to scale to texture to the saved size
     * @returns a promise that will resolve on success
     */ parseFromURLAsync(url, scaleToSize) {
        return $dc13400b3dc126d8$export$f032279d572248ce.ParseFromFileAsync(url, scaleToSize, this);
    }
    static _LoadURLContentAsync(url, snippet = false) {
        if (url === "") return Promise.reject("No URL provided");
        return new Promise((resolve, reject)=>{
            const request = new (0, $hUzEl.WebRequest)();
            request.addEventListener("readystatechange", ()=>{
                if (request.readyState == 4) {
                    if (request.status == 200) {
                        let gui;
                        if (snippet) {
                            const payload = JSON.parse(JSON.parse(request.responseText).jsonPayload);
                            gui = payload.encodedGui ? new TextDecoder("utf-8").decode((0, $eLv1o.DecodeBase64ToBinary)(payload.encodedGui)) : payload.gui;
                        } else gui = request.responseText;
                        const serializationObject = JSON.parse(gui);
                        resolve(serializationObject);
                    } else reject("Unable to load");
                }
            });
            request.open("GET", url);
            request.send();
        });
    }
    // Statics
    /**
     * Compares two rectangle based controls for pixel overlap
     * @param control1 The first control to compare
     * @param control2 The second control to compare
     * @returns true if overlaps, otherwise false
     */ static _Overlaps(control1, control2) {
        return !(control1.centerX > control2.centerX + control2.widthInPixels || control1.centerX + control1.widthInPixels < control2.centerX || control1.centerY + control1.heightInPixels < control2.centerY || control1.centerY > control2.centerY + control2.heightInPixels);
    }
    /**
     * Creates a new AdvancedDynamicTexture in projected mode (ie. attached to a mesh)
     * @param mesh defines the mesh which will receive the texture
     * @param width defines the texture width (1024 by default)
     * @param height defines the texture height (1024 by default)
     * @param supportPointerMove defines a boolean indicating if the texture must capture move events (true by default)
     * @param onlyAlphaTesting defines a boolean indicating that alpha blending will not be used (only alpha testing) (false by default)
     * @param invertY defines if the texture needs to be inverted on the y axis during loading (true by default)
     * @param materialSetupCallback defines a custom way of creating and setting up the material on the mesh
     * @returns a new AdvancedDynamicTexture
     */ static CreateForMesh(mesh, width = 1024, height = 1024, supportPointerMove = true, onlyAlphaTesting = false, invertY, materialSetupCallback = this._CreateMaterial) {
        // use a unique ID in name so serialization will work even if you create two ADTs for a single mesh
        const uniqueId = (0, $321Uk.RandomGUID)();
        const result = new $dc13400b3dc126d8$export$f032279d572248ce(`AdvancedDynamicTexture for ${mesh.name} [${uniqueId}]`, width, height, mesh.getScene(), true, (0, $j2mX5.Texture).TRILINEAR_SAMPLINGMODE, invertY);
        materialSetupCallback(mesh, uniqueId, result, onlyAlphaTesting);
        result.attachToMesh(mesh, supportPointerMove);
        return result;
    }
    static _CreateMaterial(mesh, uniqueId, texture, onlyAlphaTesting) {
        const internalClassType = (0, $8DoUR.GetClass)("BABYLON.StandardMaterial");
        if (!internalClassType) // eslint-disable-next-line no-throw-literal
        throw "StandardMaterial needs to be imported before as it contains a side-effect required by your code.";
        const material = new internalClassType(`AdvancedDynamicTextureMaterial for ${mesh.name} [${uniqueId}]`, mesh.getScene());
        material.backFaceCulling = false;
        material.diffuseColor = (0, $7etnY.Color3).Black();
        material.specularColor = (0, $7etnY.Color3).Black();
        if (onlyAlphaTesting) {
            material.diffuseTexture = texture;
            material.emissiveTexture = texture;
            texture.hasAlpha = true;
        } else {
            material.emissiveTexture = texture;
            material.opacityTexture = texture;
        }
        mesh.material = material;
    }
    /**
     * Creates a new AdvancedDynamicTexture in projected mode (ie. attached to a mesh) BUT do not create a new material for the mesh. You will be responsible for connecting the texture
     * @param mesh defines the mesh which will receive the texture
     * @param width defines the texture width (1024 by default)
     * @param height defines the texture height (1024 by default)
     * @param supportPointerMove defines a boolean indicating if the texture must capture move events (true by default)
     * @param invertY defines if the texture needs to be inverted on the y axis during loading (true by default)
     * @returns a new AdvancedDynamicTexture
     */ static CreateForMeshTexture(mesh, width = 1024, height = 1024, supportPointerMove = true, invertY) {
        const result = new $dc13400b3dc126d8$export$f032279d572248ce(mesh.name + " AdvancedDynamicTexture", width, height, mesh.getScene(), true, (0, $j2mX5.Texture).TRILINEAR_SAMPLINGMODE, invertY);
        result.attachToMesh(mesh, supportPointerMove);
        return result;
    }
    /**
     * Creates a new AdvancedDynamicTexture in fullscreen mode.
     * In this mode the texture will rely on a layer for its rendering.
     * This allows it to be treated like any other layer.
     * As such, if you have a multi camera setup, you can set the layerMask on the GUI as well.
     * LayerMask is set through advancedTexture.layer.layerMask
     * @param name defines name for the texture
     * @param foreground defines a boolean indicating if the texture must be rendered in foreground (default is true)
     * @param scene defines the hosting scene
     * @param sampling defines the texture sampling mode (Texture.BILINEAR_SAMPLINGMODE by default)
     * @param adaptiveScaling defines whether to automatically scale root to match hardwarescaling (false by default)
     * @returns a new AdvancedDynamicTexture
     */ static CreateFullscreenUI(name, foreground = true, scene = null, sampling = (0, $j2mX5.Texture).BILINEAR_SAMPLINGMODE, adaptiveScaling = false) {
        const result = new $dc13400b3dc126d8$export$f032279d572248ce(name, 0, 0, scene, false, sampling);
        // Display
        const resultScene = result.getScene();
        const layer = new (0, $8fwD5.Layer)(name + "_layer", null, resultScene, !foreground);
        layer.texture = result;
        result._layerToDispose = layer;
        result._isFullscreen = true;
        if (adaptiveScaling && resultScene) {
            const newScale = 1 / resultScene.getEngine().getHardwareScalingLevel();
            result._rootContainer.scaleX = newScale;
            result._rootContainer.scaleY = newScale;
        }
        // Attach
        result.attach();
        return result;
    }
    /**
     * Scales the texture
     * @param ratio the scale factor to apply to both width and height
     */ scale(ratio) {
        super.scale(ratio);
        this.markAsDirty();
    }
    /**
     * Resizes the texture
     * @param width the new width
     * @param height the new height
     */ scaleTo(width, height) {
        super.scaleTo(width, height);
        this.markAsDirty();
    }
    _checkGuiIsReady() {
        if (this.guiIsReady()) {
            this.onGuiReadyObservable.notifyObservers(this);
            this.onGuiReadyObservable.clear();
        }
    }
    /**
     * @returns true if all the GUI components are ready to render
     */ guiIsReady() {
        return this._rootContainer.isReady();
    }
}
/** Define the url to load snippets */ $dc13400b3dc126d8$export$f032279d572248ce.SnippetUrl = (0, $gfKB2.Constants).SnippetUrl;
/** Indicates if some optimizations can be performed in GUI GPU management (the downside is additional memory/GPU texture memory used) */ $dc13400b3dc126d8$export$f032279d572248ce.AllowGPUOptimizations = true;

});
parcelRegister("g795W", function(module, exports) {

$parcel$export(module.exports, "Style", () => $bbb45ad35b4d0430$export$d9e45bc13d335801);

var $diGQf = parcelRequire("diGQf");

var $dKQam = parcelRequire("dKQam");
class $bbb45ad35b4d0430$export$d9e45bc13d335801 {
    /**
     * Creates a new style object
     * @param host defines the AdvancedDynamicTexture which hosts this style
     */ constructor(host){
        this._fontFamily = "Arial";
        this._fontStyle = "";
        this._fontWeight = "";
        /** @internal */ this._fontSize = new (0, $dKQam.ValueAndUnit)(18, (0, $dKQam.ValueAndUnit).UNITMODE_PIXEL, false);
        /**
         * Observable raised when the style values are changed
         */ this.onChangedObservable = new (0, $diGQf.Observable)();
        this._host = host;
    }
    /**
     * Gets or sets the font size
     */ get fontSize() {
        return this._fontSize.toString(this._host);
    }
    set fontSize(value) {
        if (this._fontSize.toString(this._host) === value) return;
        if (this._fontSize.fromString(value)) this.onChangedObservable.notifyObservers(this);
    }
    /**
     * Gets or sets the font family
     */ get fontFamily() {
        return this._fontFamily;
    }
    set fontFamily(value) {
        if (this._fontFamily === value) return;
        this._fontFamily = value;
        this.onChangedObservable.notifyObservers(this);
    }
    /**
     * Gets or sets the font style
     */ get fontStyle() {
        return this._fontStyle;
    }
    set fontStyle(value) {
        if (this._fontStyle === value) return;
        this._fontStyle = value;
        this.onChangedObservable.notifyObservers(this);
    }
    /** Gets or sets font weight */ get fontWeight() {
        return this._fontWeight;
    }
    set fontWeight(value) {
        if (this._fontWeight === value) return;
        this._fontWeight = value;
        this.onChangedObservable.notifyObservers(this);
    }
    /** Dispose all associated resources */ dispose() {
        this.onChangedObservable.clear();
    }
}

});



parcelRegister("8KjYx", function(module, exports) {

var $fbuqw = parcelRequire("fbuqw");

var $5v6ry = parcelRequire("5v6ry");

var $gtixw = parcelRequire("gtixw");
class $65e21d4eeeb280af$export$15855a8d76cf9af7 extends (0, $gtixw.Mesh2D) {
    constructor(name, width, height, scene, ppm, generateMipMaps = true, rho = 1, verticesNumber = {
        x: 8,
        y: 8
    }){
        super(name, width, height, scene, ppm, generateMipMaps, {
            verticesNumber: verticesNumber,
            rho: rho
        });
        this.width = width;
        this.height = height;
        this.scene = scene;
        this.ppm = ppm;
    }
    // noinspection UnnecessaryLocalVariableJS
    static GenerateMesh(dimensions, verticesNumber, rho) {
        const vertices = [];
        const uvs = [];
        const center = {
            x: 0.5,
            y: 0.5
        };
        const hFovRad = dimensions.x * Math.PI / 180;
        const vFovRad = dimensions.y * Math.PI / 180;
        for(let dy = 0; dy < verticesNumber.y; dy++){
            const theta = (dy / (verticesNumber.y - 1) - center.y) * vFovRad + Math.PI / 2;
            for(let dx = 0; dx < verticesNumber.x; dx++){
                const phi = (dx / (verticesNumber.x - 1) - center.x) * hFovRad + Math.PI / 2;
                // noinspection UnnecessaryLocalVariableJS
                const psph = {
                    x: rho * Math.sin(theta) * Math.cos(phi),
                    y: rho * Math.cos(theta),
                    z: rho * Math.sin(theta) * Math.sin(phi)
                };
                vertices[dx + dy * verticesNumber.x] = psph;
                uvs[dx + dy * verticesNumber.y] = {
                    x: 1 - dx / (verticesNumber.x - 1),
                    y: 1 - dy / (verticesNumber.y - 1)
                };
            }
        }
        const nFaces = (verticesNumber.x - 1) * (verticesNumber.y - 1);
        const faces = [];
        for(let faceN = 0; faceN < nFaces; faceN++){
            const i = faceN % (verticesNumber.x - 1) + Math.floor(faceN / (verticesNumber.x - 1)) * verticesNumber.x;
            const d = i + verticesNumber.x;
            const a = i;
            const b = i + 1;
            const c = i + verticesNumber.x + 1;
            faces.push({
                x: d,
                y: a,
                z: b
            });
            faces.push({
                x: d,
                y: b,
                z: c
            });
        }
        return {
            vertices: vertices,
            uvs: uvs,
            faces: faces
        };
    }
    createMesh(name, meshData) {
        const generatedMeshData = $65e21d4eeeb280af$export$15855a8d76cf9af7.GenerateMesh({
            x: this.width,
            y: this.height
        }, meshData.verticesNumber, meshData.rho);
        const vertices = [];
        const uvs = [];
        const normals = [];
        const indices = [];
        for(let i = 0; i < generatedMeshData.vertices.length; i++){
            vertices.push(generatedMeshData.vertices[i].x, generatedMeshData.vertices[i].y, generatedMeshData.vertices[i].z);
            uvs.push(generatedMeshData.uvs[i].x, generatedMeshData.uvs[i].y);
        }
        for(let i = 0; i < generatedMeshData.faces.length; i++){
            indices.push(generatedMeshData.faces[i].x);
            indices.push(generatedMeshData.faces[i].y);
            indices.push(generatedMeshData.faces[i].z);
        }
        (0, $5v6ry.VertexData).ComputeNormals(vertices, indices, normals, {
            useRightHandedSystem: true
        });
        const mesh = new (0, $fbuqw.Mesh)(name, this.scene);
        const vertexData = new (0, $5v6ry.VertexData)();
        vertexData.positions = vertices;
        vertexData.indices = indices;
        vertexData.normals = normals;
        vertexData.uvs = uvs;
        vertexData.applyToMesh(mesh);
        return mesh;
    }
    resize(_width, _height) {
    //TODO
    }
}

});

parcelRegister("51jh0", function(module, exports) {

var $3Nsto = parcelRequire("3Nsto");

var $k44X5 = parcelRequire("k44X5");

var $4BGGM = parcelRequire("4BGGM");

var $diGQf = parcelRequire("diGQf");

var $fCNdl = parcelRequire("fCNdl");

var $cfkw4 = parcelRequire("cfkw4");

var $4GBc6 = parcelRequire("4GBc6");

var $PPcK8 = parcelRequire("PPcK8");
class $3a7bff0bb633ddb0$export$6cf7d0b164d8d351 extends (0, $PPcK8.Rectangle3D) {
    /**
     * Gets the horizontal scrollbar
     */ get horizontalBar() {
        return this._horizontalBar;
    }
    /**
     * Gets the vertical scrollbar
     */ get verticalBar() {
        return this._verticalBar;
    }
    /** Observable raised when the vertical slider value changes */ get onVerticalValueChangedObservable() {
        return this._onVerticalValueChangedObservable;
    }
    /** Observable raised when the horizontal slider value changes */ get onHorizontalValueChangedObservable() {
        return this._onHorizontalValueChangedObservable;
    }
    /**
     * Adds a new control to the current container
     * @param control defines the control to add
     * @returns the current container
     */ addControl(control) {
        if (!control) return this;
        this._window.addControl(control);
        return this;
    }
    /**
     * Removes a control from the current container
     * @param control defines the control to remove
     * @returns the current container
     */ removeControl(control) {
        this._window.removeControl(control);
        return this;
    }
    /** Gets the list of children */ get children() {
        return this._window.children;
    }
    _flagDescendantsAsMatrixDirty() {
        for (var child of this._children)child._markMatrixAsDirty();
    }
    /**
     * Freezes or unfreezes the controls in the window.
     * When controls are frozen, the scroll viewer can render a lot more quickly but updates to positions/sizes of controls
     * are not taken into account. If you want to change positions/sizes, unfreeze, perform the changes then freeze again
     */ get freezeControls() {
        return this._window.freezeControls;
    }
    set freezeControls(value) {
        this._window.freezeControls = value;
    }
    /** Gets the bucket width */ get bucketWidth() {
        return this._window.bucketWidth;
    }
    /** Gets the bucket height */ get bucketHeight() {
        return this._window.bucketHeight;
    }
    /**
     * Sets the bucket sizes.
     * When freezeControls is true, setting a non-zero bucket size will improve performances by updating only
     * controls that are visible. The bucket sizes is used to subdivide (internally) the window area to smaller areas into which
     * controls are dispatched. So, the size should be roughly equals to the mean size of all the controls of
     * the window. To disable the usage of buckets, sets either width or height (or both) to 0.
     * Please note that using this option will raise the memory usage (the higher the bucket sizes, the less memory
     * used), that's why it is not enabled by default.
     * @param width width of the bucket
     * @param height height of the bucket
     */ setBucketSizes(width, height) {
        this._window.setBucketSizes(width, height);
    }
    get rowSize() {
        return this._barSize + (this._horizontalBarPadding.top ?? 0) + (this._horizontalBarPadding.bottom ?? 0);
    }
    get columnSize() {
        return this._barSize + (this._verticalBarPadding.left ?? 0) + (this._verticalBarPadding.right ?? 0);
    }
    /**
     * Forces the horizontal scroll bar to be displayed
     */ get forceHorizontalBar() {
        return this._forceHorizontalBar;
    }
    set forceHorizontalBar(value) {
        this._grid.setRowDefinition(this._horizontalBarPosition, value ? this.rowSize : 0, (0, $4GBc6.DefinitionType).Pixel);
        if (value !== undefined) this._horizontalBar.isVisible = value;
        this._forceHorizontalBar = value;
    }
    /**
     * Forces the vertical scroll bar to be displayed
     */ get forceVerticalBar() {
        return this._forceVerticalBar;
    }
    set forceVerticalBar(value) {
        this._grid.setColumnDefinition(this._verticalBarPosition, value ? this.columnSize : 0, (0, $4GBc6.DefinitionType).Pixel);
        if (value !== undefined) this._verticalBar.isVisible = value;
        this._forceVerticalBar = value;
    }
    /** Padding for the horizontal scrollbar */ get horizontalBarPaddingInPixels() {
        return this._horizontalBarPadding;
    }
    set horizontalBarPaddingInPixels(value) {
        this._horizontalBarPadding = value;
        this._horizontalBarPaddedContainer.setColumnDefinition(0, value.left ?? 0, (0, $4GBc6.DefinitionType).Pixel);
        this._horizontalBarPaddedContainer.setColumnDefinition(2, value.right ?? 0, (0, $4GBc6.DefinitionType).Pixel);
        this._horizontalBarPaddedContainer.setRowDefinition(0, value.top ?? 0, (0, $4GBc6.DefinitionType).Pixel);
        this._horizontalBarPaddedContainer.setRowDefinition(2, value.bottom ?? 0, (0, $4GBc6.DefinitionType).Pixel);
    }
    /** Padding for the vertical scrollbar */ get verticalBarPaddingInPixels() {
        return this._verticalBarPadding;
    }
    set verticalBarPaddingInPixels(value) {
        this._verticalBarPadding = value;
        this._verticalBarPaddedContainer.setColumnDefinition(0, value.left ?? 0, (0, $4GBc6.DefinitionType).Pixel);
        this._verticalBarPaddedContainer.setColumnDefinition(2, value.right ?? 0, (0, $4GBc6.DefinitionType).Pixel);
        this._verticalBarPaddedContainer.setRowDefinition(0, value.top ?? 0, (0, $4GBc6.DefinitionType).Pixel);
        this._verticalBarPaddedContainer.setRowDefinition(2, value.bottom ?? 0, (0, $4GBc6.DefinitionType).Pixel);
    }
    /** Value of the horizontal bar */ get horizontalValue() {
        return this.horizontalBar.value;
    }
    set horizontalValue(value) {
        value = Math.min(value, 1);
        value = Math.max(value, 0);
        this.horizontalBar.value = value;
    }
    /** Value of the vertical bar */ get verticalValue() {
        return this.verticalBar.value;
    }
    set verticalValue(value) {
        value = Math.min(value, 1);
        value = Math.max(value, 0);
        this.verticalBar.value = value;
    }
    /** Bar value will change to this value when content size changes, unless it is undefined. */ get valueToScrollTo() {
        return this._scrollToPosition;
    }
    set valueToScrollTo(value) {
        if (value !== undefined) {
            value = Math.min(value, 1);
            value = Math.max(value, 0);
        }
        this._scrollToPosition = value;
    }
    /**
    * Creates a new ScrollViewer
    * @param name of ScrollViewer
    */ constructor(name, isImageBased, leftVerticalBar = false, topHorizontalBar = false){
        super(name);
        this._barColor = "";
        this._barBackground = "";
        this._barSize = 20;
        this._pointerIsOver = false;
        this._wheelPrecision = 0.05;
        this._onWheelObserver = null;
        this._clientWidth = 0;
        this._clientHeight = 0;
        this._thumbLength = 0.5;
        this._thumbHeight = 1;
        this._barImageHeight = 1;
        this._horizontalBarImageHeight = 1;
        this._verticalBarImageHeight = 1;
        this._oldWindowContentsWidth = 0;
        this._oldWindowContentsHeight = 0;
        this._autoSizeThumbs = true;
        this._attemptedThumbWidth = 0;
        this._attemptedThumbHeight = 0;
        this._verticalBarPadding = {};
        this._horizontalBarPadding = {};
        this._onVerticalValueChangedObservable = new (0, $diGQf.Observable)();
        this._onHorizontalValueChangedObservable = new (0, $diGQf.Observable)();
        this._forceHorizontalBar = undefined;
        this._forceVerticalBar = undefined;
        this._useImageBar = isImageBased ? isImageBased : false;
        this.onDirtyObservable.add(()=>{
            this._horizontalBarSpace.color = this.color;
            this._verticalBarSpace.color = this.color;
        });
        this.onPointerEnterObservable.add(()=>{
            this._pointerIsOver = true;
        });
        this.onPointerOutObservable.add(()=>{
            this._pointerIsOver = false;
        });
        this._grid = new (0, $4GBc6.Grid3D)();
        if (this._useImageBar) {
            this._horizontalBar = new (0, $3Nsto.ImageScrollBar)();
            this._verticalBar = new (0, $3Nsto.ImageScrollBar)();
        } else {
            this._horizontalBar = new (0, $k44X5.ScrollBar)();
            this._verticalBar = new (0, $k44X5.ScrollBar)();
        }
        this._window = new (0, $4BGGM._ScrollViewerWindow3D)("scrollViewer_window");
        this._window.horizontalAlignment = (0, $fCNdl.Control).HORIZONTAL_ALIGNMENT_LEFT;
        this._window.verticalAlignment = (0, $fCNdl.Control).VERTICAL_ALIGNMENT_TOP;
        this._grid.addColumnDefinition(0, (0, $4GBc6.DefinitionType).Pixel);
        this._grid.addColumnDefinition(1);
        this._grid.addColumnDefinition(0, (0, $4GBc6.DefinitionType).Pixel);
        this._grid.addRowDefinition(0, (0, $4GBc6.DefinitionType).Pixel);
        this._grid.addRowDefinition(1);
        this._grid.addRowDefinition(0, (0, $4GBc6.DefinitionType).Pixel);
        super.addControl(this._grid);
        this._grid.addControl(this._window, 0, 0, 3, 3);
        this._verticalBarSpace = new (0, $PPcK8.Rectangle3D)();
        this._verticalBarSpace.horizontalAlignment = (0, $fCNdl.Control).HORIZONTAL_ALIGNMENT_LEFT;
        this._verticalBarSpace.verticalAlignment = (0, $fCNdl.Control).VERTICAL_ALIGNMENT_TOP;
        this._verticalBarSpace.thickness = 0;
        this._verticalBarPaddedContainer = new (0, $4GBc6.Grid3D)();
        this._verticalBarPosition = leftVerticalBar ? 0 : 2;
        this._addBar(this._verticalBar, this._verticalBarSpace, true, this._verticalBarPadding, this._verticalBarPaddedContainer, 1, this._verticalBarPosition);
        this._horizontalBarSpace = new (0, $PPcK8.Rectangle3D)();
        this._horizontalBarSpace.horizontalAlignment = (0, $fCNdl.Control).HORIZONTAL_ALIGNMENT_LEFT;
        this._horizontalBarSpace.verticalAlignment = (0, $fCNdl.Control).VERTICAL_ALIGNMENT_TOP;
        this._horizontalBarSpace.thickness = 0;
        this._horizontalBarPaddedContainer = new (0, $4GBc6.Grid3D)();
        this._horizontalBarPosition = topHorizontalBar ? 0 : 2;
        this._addBar(this._horizontalBar, this._horizontalBarSpace, false, this._horizontalBarPadding, this._horizontalBarPaddedContainer, this._horizontalBarPosition, 1);
        // Colors
        if (!this._useImageBar) {
            this.barColor = "grey";
            this.barBackground = "transparent";
        }
    }
    /** Reset the scroll viewer window to initial size */ resetWindow() {
        this._window.width = "100%";
        this._window.height = "100%";
    }
    _getTypeName() {
        return "ScrollViewer";
    }
    _buildClientSizes() {
        const thickness = (0, $PPcK8.RectangleMeasureUtils).getFullRectangleMeasure(this.thickness);
        this._window.parentClientWidth = this._currentMeasure.width - ((thickness.left ?? 0) + (thickness.right ?? 0));
        this._window.parentClientHeight = this._currentMeasure.height - ((thickness.top ?? 0) + (thickness.bottom ?? 0));
        this._clientWidth = this._window.parentClientWidth;
        this._clientHeight = this._window.parentClientHeight;
    }
    _additionalProcessing(parentMeasure, context) {
        super._additionalProcessing(parentMeasure, context);
        this._buildClientSizes();
    }
    _postMeasure() {
        super._postMeasure();
        this._updateScroller();
        this._setWindowPosition(false);
    }
    /**
     * Gets or sets the mouse wheel precision
     * from 0 to 1 with a default value of 0.05
     * */ get wheelPrecision() {
        return this._wheelPrecision;
    }
    set wheelPrecision(value) {
        if (this._wheelPrecision === value) return;
        if (value < 0) value = 0;
        if (value > 1) value = 1;
        this._wheelPrecision = value;
    }
    /** Gets or sets the scroll bar container background color */ get scrollBackground() {
        return this._horizontalBarSpace.background;
    }
    set scrollBackground(color) {
        if (this._horizontalBarSpace.background === color) return;
        this._horizontalBarSpace.background = color;
        this._verticalBarSpace.background = color;
    }
    /** Gets or sets the bar color */ get barColor() {
        return this._barColor;
    }
    set barColor(color) {
        if (this._barColor === color) return;
        this._barColor = color;
        this._horizontalBar.color = color;
        this._verticalBar.color = color;
    }
    /** Gets or sets the bar color when pressed */ get pressedBarColor() {
        return this._pressedBarColor;
    }
    set pressedBarColor(value) {
        this._pressedBarColor = value;
    }
    /** Gets or sets the bar color when hovered over*/ get hoverBarColor() {
        return this._hoverBarColor;
    }
    set hoverBarColor(value) {
        this._hoverBarColor = value;
    }
    /** Gets or sets the bar image */ get thumbImage() {
        return this._barImage;
    }
    set thumbImage(value) {
        if (this._barImage === value) return;
        this._barImage = value;
        let hb = this._horizontalBar;
        let vb = this._verticalBar;
        hb.thumbImage = value;
        vb.thumbImage = value;
    }
    /** Gets or sets the horizontal bar image */ get horizontalThumbImage() {
        return this._horizontalBarImage;
    }
    set horizontalThumbImage(value) {
        if (this._horizontalBarImage === value) return;
        this._horizontalBarImage = value;
        let hb = this._horizontalBar;
        hb.thumbImage = value;
    }
    /** Gets or sets the vertical bar image */ get verticalThumbImage() {
        return this._verticalBarImage;
    }
    set verticalThumbImage(value) {
        if (this._verticalBarImage === value) return;
        this._verticalBarImage = value;
        let vb = this._verticalBar;
        vb.thumbImage = value;
    }
    /** Gets or sets the size of the bar */ get barSizeInPixels() {
        return this._barSize;
    }
    set barSizeInPixels(value) {
        if (this._barSize === value) return;
        this._barSize = value;
        this._markAsDirty();
        if (this._horizontalBar.isVisible) this._grid.setRowDefinition(this._horizontalBarPosition, this.rowSize, (0, $4GBc6.DefinitionType).Pixel);
        this._horizontalBarPaddedContainer.setRowDefinition(1, this._barSize, (0, $4GBc6.DefinitionType).Pixel);
        if (this._verticalBar.isVisible) this._grid.setColumnDefinition(this._verticalBarPosition, this.columnSize, (0, $4GBc6.DefinitionType).Pixel);
        this._verticalBarPaddedContainer.setColumnDefinition(1, this._barSize, (0, $4GBc6.DefinitionType).Pixel);
    }
    /** Enables auto sizing of thumbs depending on proprtion of content size to control size */ get autoSizeThumbs() {
        return this._autoSizeThumbs;
    }
    set autoSizeThumbs(value) {
        if (this._autoSizeThumbs === value) return;
        this._autoSizeThumbs = value;
        if (!this._autoSizeThumbs) {
            if (this._attemptedThumbWidth != 0) this.thumbLengthInPixels = this._attemptedThumbWidth;
            if (this._attemptedThumbHeight != 0) this.thumbHeightInPixels = this._attemptedThumbHeight;
        }
    }
    /** Gets or sets the length of the thumb */ get thumbLengthInPixels() {
        return this._thumbLength;
    }
    set thumbLengthInPixels(value) {
        if (this._autoSizeThumbs) {
            this._attemptedThumbWidth = value;
            return;
        }
        if (this._thumbLength === value) return;
        if (value <= 0) value = 0.1;
        if (value > 1) value = 1;
        this._thumbLength = value;
        var hb = this._horizontalBar;
        var vb = this._verticalBar;
        hb.thumbLength = value;
        vb.thumbLength = value;
        this._markAsDirty();
    }
    /** Gets or sets the height of the thumb */ get thumbHeightInPixels() {
        return this._thumbHeight;
    }
    set thumbHeightInPixels(value) {
        if (this._autoSizeThumbs) {
            this._attemptedThumbHeight = value;
            return;
        }
        if (this._thumbHeight === value) return;
        if (value <= 0) value = 0.1;
        if (value > 1) value = 1;
        this._thumbHeight = value;
        var hb = this._horizontalBar;
        var vb = this._verticalBar;
        hb.thumbHeight = value;
        vb.thumbHeight = value;
        this._markAsDirty();
    }
    /** Gets or sets the height of the bar image */ get barImageHeightInPixels() {
        return this._barImageHeight;
    }
    set barImageHeightInPixels(value) {
        if (this._barImageHeight === value) return;
        if (value <= 0) value = 0.1;
        if (value > 1) value = 1;
        this._barImageHeight = value;
        var hb = this._horizontalBar;
        var vb = this._verticalBar;
        hb.barImageHeight = value;
        vb.barImageHeight = value;
        this._markAsDirty();
    }
    /** Gets or sets the height of the horizontal bar image */ get horizontalBarImageHeightInPixels() {
        return this._horizontalBarImageHeight;
    }
    set horizontalBarImageHeightInPixels(value) {
        if (this._horizontalBarImageHeight === value) return;
        if (value <= 0) value = 0.1;
        if (value > 1) value = 1;
        this._horizontalBarImageHeight = value;
        var hb = this._horizontalBar;
        hb.barImageHeight = value;
        this._markAsDirty();
    }
    /** Gets or sets the height of the vertical bar image */ get verticalBarImageHeightInPixels() {
        return this._verticalBarImageHeight;
    }
    set verticalBarImageHeightInPixels(value) {
        if (this._verticalBarImageHeight === value) return;
        if (value <= 0) value = 0.1;
        if (value > 1) value = 1;
        this._verticalBarImageHeight = value;
        var vb = this._verticalBar;
        vb.barImageHeight = value;
        this._markAsDirty();
    }
    /** Gets or sets the bar background */ get barBackground() {
        return this._barBackground;
    }
    set barBackground(color) {
        if (this._barBackground === color) return;
        this._barBackground = color;
        let hb = this._horizontalBar;
        let vb = this._verticalBar;
        hb.background = color;
        vb.background = color;
    }
    /** Gets or sets the bar background image */ get barImage() {
        return this._barBackgroundImage;
    }
    set barImage(value) {
        this._barBackgroundImage;
        this._barBackgroundImage = value;
        let hb = this._horizontalBar;
        let vb = this._verticalBar;
        hb.backgroundImage = value;
        vb.backgroundImage = value;
    }
    /** Gets or sets the horizontal bar background image */ get horizontalBarImage() {
        return this._horizontalBarBackgroundImage;
    }
    set horizontalBarImage(value) {
        this._horizontalBarBackgroundImage;
        this._horizontalBarBackgroundImage = value;
        let hb = this._horizontalBar;
        hb.backgroundImage = value;
    }
    /** Gets or sets the vertical bar background image */ get verticalBarImage() {
        return this._verticalBarBackgroundImage;
    }
    set verticalBarImage(value) {
        this._verticalBarBackgroundImage;
        this._verticalBarBackgroundImage = value;
        let vb = this._verticalBar;
        vb.backgroundImage = value;
    }
    _setWindowPosition(force = true) {
        let ratio = this.host.idealRatio;
        let windowContentsWidth = this._window._currentMeasure.width;
        let windowContentsHeight = this._window._currentMeasure.height;
        if (!force && this._oldWindowContentsWidth === windowContentsWidth && this._oldWindowContentsHeight === windowContentsHeight) return;
        this._oldWindowContentsWidth = windowContentsWidth;
        this._oldWindowContentsHeight = windowContentsHeight;
        const _endLeft = this._clientWidth - windowContentsWidth;
        const _endTop = this._clientHeight - windowContentsHeight;
        const newLeft = this._horizontalBar.value / ratio * _endLeft + "px";
        const newTop = this._verticalBar.value / ratio * _endTop + "px";
        if (newLeft !== this._window.left) {
            this._window.left = newLeft;
            if (!this.freezeControls) this._rebuildLayout = true;
        }
        if (newTop !== this._window.top) {
            this._window.top = newTop;
            if (!this.freezeControls) this._rebuildLayout = true;
        }
    }
    /** @hidden */ _updateScroller() {
        let windowContentsWidth = this._window._currentMeasure.width;
        let windowContentsHeight = this._window._currentMeasure.height;
        if (this.forceHorizontalBar === undefined) {
            if (this._horizontalBar.isVisible && windowContentsWidth <= this._clientWidth) {
                this._grid.setRowDefinition(this._horizontalBarPosition, 0, (0, $4GBc6.DefinitionType).Pixel);
                this._horizontalBar.isVisible = false;
                this.horizontalValue = 0;
                this._rebuildLayout = true;
            } else if (!this._horizontalBar.isVisible && windowContentsWidth > this._clientWidth) {
                this._grid.setRowDefinition(this._horizontalBarPosition, this.rowSize, (0, $4GBc6.DefinitionType).Pixel);
                this._horizontalBar.isVisible = true;
                if (this._scrollToPosition !== undefined) this.horizontalValue = this._scrollToPosition;
                else this.horizontalValue = this._window._scrollbarMeasures.left;
                this._rebuildLayout = true;
            }
        }
        if (this.forceVerticalBar === undefined) {
            if (this._verticalBar.isVisible && windowContentsHeight <= this._clientHeight) {
                this._grid.setColumnDefinition(this._verticalBarPosition, 0, (0, $4GBc6.DefinitionType).Pixel);
                this._verticalBar.isVisible = false;
                this.verticalValue = 0;
                this._rebuildLayout = true;
            } else if (!this._verticalBar.isVisible && windowContentsHeight > this._clientHeight) {
                this._grid.setColumnDefinition(this._verticalBarPosition, this.columnSize, (0, $4GBc6.DefinitionType).Pixel);
                this._verticalBar.isVisible = true;
                if (this._scrollToPosition !== undefined) this.verticalValue = this._scrollToPosition;
                else this.verticalValue = this._window._scrollbarMeasures.top;
                this._rebuildLayout = true;
            }
        }
        this._buildClientSizes();
        if (this._autoSizeThumbs) {
            this._horizontalBar.thumbWidth = this._window._scrollbarMeasures.width * (this._clientWidth - (this.horizontalBarPaddingInPixels.left ?? 0) - (this.horizontalBarPaddingInPixels.right ?? 0)) + "px";
            this._verticalBar.thumbWidth = this._window._scrollbarMeasures.height * (this._clientHeight - (this.verticalBarPaddingInPixels.top ?? 0) - (this.verticalBarPaddingInPixels.bottom ?? 0)) + "px";
        } else {
            let ratio = this.host.idealRatio;
            this._horizontalBar.thumbWidth = this._thumbLength * 0.9 * (this._clientWidth / ratio) + "px";
            this._verticalBar.thumbWidth = this._thumbLength * 0.9 * (this._clientHeight / ratio) + "px";
        }
    }
    _link(host) {
        super._link(host);
        this._attachWheel();
    }
    /** @hidden */ _addBar(barControl, barContainer, isVertical, padding, paddedContainer, row, column) {
        barControl.paddingLeft = 0;
        barControl.width = "100%";
        barControl.height = "100%";
        barControl.barOffset = 0;
        barControl.value = 0;
        barControl.maximum = 1;
        barControl.horizontalAlignment = (0, $fCNdl.Control).HORIZONTAL_ALIGNMENT_CENTER;
        barControl.verticalAlignment = (0, $fCNdl.Control).VERTICAL_ALIGNMENT_CENTER;
        barControl.isVertical = isVertical;
        barControl.rotation = isVertical ? Math.PI : 0;
        barControl.isVisible = false;
        barContainer.addControl(barControl);
        barControl.onValueChangedObservable.add((value)=>{
            this._setWindowPosition();
            if (isVertical) this.onVerticalValueChangedObservable.notifyObservers(value);
            else this.onHorizontalValueChangedObservable.notifyObservers(value);
        });
        barControl.onPointerDownObservable.add(()=>{
            this.changeBarState(barControl, {
                isPressed: true
            });
        });
        barControl.onPointerUpObservable.add((e)=>{
            const coord = paddedContainer.getLocalCoordinates(e);
            if (coord.x < 0 || coord.y < 0 || coord.x > paddedContainer.widthInPixels || coord.y > paddedContainer.heightInPixels) this.changeBarState(barControl, {
                isOver: false,
                isPressed: false
            });
            else this.changeBarState(barControl, {
                isPressed: false
            });
        });
        paddedContainer.onPointerEnterObservable.add(()=>{
            this.changeBarState(barControl, {
                isOver: true
            });
        });
        paddedContainer.onPointerOutObservable.add(()=>{
            this.changeBarState(barControl, {
                isOver: false
            });
        });
        paddedContainer.onPointerDownObservable.add((e, s)=>{
            let pointerId = 0;
            if (s.userInfo instanceof (0, $cfkw4.PointerInfoBase) && s.userInfo.event instanceof PointerEvent) pointerId = s.userInfo.event.pointerId;
            barControl._onPointerDown(barControl, e, pointerId, e.buttonIndex, s.userInfo);
        });
        let lastMoveData;
        paddedContainer.onPointerMoveObservable.add((e, s)=>{
            const coord = barControl.getLocalCoordinates(e);
            if (!lastMoveData || lastMoveData.x != coord.x || lastMoveData.y != coord.y) {
                lastMoveData = coord.clone();
                let pointerId = 0;
                if (s.userInfo instanceof (0, $cfkw4.PointerInfoBase) && s.userInfo.event instanceof PointerEvent) pointerId = s.userInfo.event.pointerId;
                barControl._onPointerMove(barControl, e, pointerId, s.userInfo);
            } else lastMoveData = undefined;
        });
        let lastUpData;
        paddedContainer.onPointerUpObservable.add((e, s)=>{
            if (!lastUpData || lastUpData.x != e.x || lastUpData.y != e.y) {
                lastUpData = e.clone();
                let pointerId = 0;
                if (s.userInfo instanceof (0, $cfkw4.PointerInfoBase) && s.userInfo.event instanceof PointerEvent) pointerId = s.userInfo.event.pointerId;
                barControl._onPointerUp(barControl, e, pointerId, e.buttonIndex, false);
            } else lastUpData = undefined;
        });
        paddedContainer.addColumnDefinition(padding.left ?? 0, (0, $4GBc6.DefinitionType).Pixel);
        if (isVertical) paddedContainer.addColumnDefinition(this._barSize, (0, $4GBc6.DefinitionType).Pixel);
        else paddedContainer.addColumnDefinition(1);
        paddedContainer.addColumnDefinition(padding.right ?? 0, (0, $4GBc6.DefinitionType).Pixel);
        paddedContainer.addRowDefinition(padding.top ?? 0, (0, $4GBc6.DefinitionType).Pixel);
        if (!isVertical) paddedContainer.addRowDefinition(this._barSize, (0, $4GBc6.DefinitionType).Pixel);
        else paddedContainer.addRowDefinition(1);
        paddedContainer.addRowDefinition(padding.bottom ?? 0, (0, $4GBc6.DefinitionType).Pixel);
        paddedContainer.addControl(barContainer, 1, 1);
        this._grid.addControl(paddedContainer, row, column);
    }
    changeBarState(barControl, state) {
        if (state.isOver !== undefined) barControl.isPointerOver = state.isOver;
        if (state.isPressed !== undefined) barControl.isGrabbed = state.isPressed;
        if (barControl.isPointerOver) {
            if (barControl.isGrabbed) barControl.color = this.pressedBarColor ?? barControl.color;
            else barControl.color = this.hoverBarColor ?? barControl.color;
        } else if (barControl.isGrabbed) barControl.color = this.pressedBarColor ?? barControl.color;
        else barControl.color = this.barColor;
    }
    /** @hidden */ _attachWheel() {
        if (!this._host || this._onWheelObserver) return;
        this._onWheelObserver = this.onWheelObservable.add((pi)=>{
            if (!this._pointerIsOver) return;
            if (pi.y < 0 && this.verticalValue > 0) this.verticalValue -= this._wheelPrecision;
            else if (pi.y > 0 && this.verticalValue < this._verticalBar.maximum) this.verticalValue += this._wheelPrecision;
            if (pi.x < 0 && this.horizontalValue < this._horizontalBar.maximum) this.horizontalValue += this._wheelPrecision;
            else if (pi.x > 0 && this.horizontalValue > 0) this.horizontalValue -= this._wheelPrecision;
        });
    }
    _renderHighlightSpecific(context) {
        if (!this.isHighlighted) return;
        super._renderHighlightSpecific(context);
        this._grid._renderHighlightSpecific(context);
        context.restore();
    }
    /** Releases associated resources */ dispose() {
        this.onWheelObservable.remove(this._onWheelObserver);
        this._onWheelObserver = null;
        super.dispose();
    }
}

});
parcelRegister("3Nsto", function(module, exports) {

$parcel$export(module.exports, "ImageScrollBar", () => $2c3c08dc9cd220b9$export$e13e96cae730c69a);

var $e0Suo = parcelRequire("e0Suo");

var $cLeSo = parcelRequire("cLeSo");

var $lFAVI = parcelRequire("lFAVI");

var $ir0rz = parcelRequire("ir0rz");
class $2c3c08dc9cd220b9$export$e13e96cae730c69a extends (0, $cLeSo.BaseSlider) {
    /** Inverts the scrolling direction (default: false) */ get invertScrollDirection() {
        return this._invertScrollDirection;
    }
    set invertScrollDirection(invert) {
        this._invertScrollDirection = invert;
    }
    /**
     * Gets or sets the image used to render the background for horizontal bar
     */ get backgroundImage() {
        return this._backgroundBaseImage;
    }
    set backgroundImage(value) {
        if (this._backgroundBaseImage === value) return;
        this._backgroundBaseImage = value;
        if (this.isVertical && this.num90RotationInVerticalMode !== 0) {
            if (!value.isLoaded) value.onImageLoadedObservable.addOnce(()=>{
                const rotatedValue = value._rotate90(this.num90RotationInVerticalMode, true);
                this._backgroundImage = rotatedValue;
                if (!rotatedValue.isLoaded) rotatedValue.onImageLoadedObservable.addOnce(()=>{
                    this._markAsDirty();
                });
                this._markAsDirty();
            });
            else {
                this._backgroundImage = value._rotate90(this.num90RotationInVerticalMode, true);
                this._markAsDirty();
            }
        } else {
            this._backgroundImage = value;
            if (value && !value.isLoaded) value.onImageLoadedObservable.addOnce(()=>{
                this._markAsDirty();
            });
            this._markAsDirty();
        }
    }
    /**
     * Gets or sets the image used to render the thumb
     */ get thumbImage() {
        return this._thumbBaseImage;
    }
    set thumbImage(value) {
        if (this._thumbBaseImage === value) return;
        this._thumbBaseImage = value;
        if (this.isVertical && this.num90RotationInVerticalMode !== 0) {
            if (!value.isLoaded) value.onImageLoadedObservable.addOnce(()=>{
                const rotatedValue = value._rotate90(-this.num90RotationInVerticalMode, true);
                this._thumbImage = rotatedValue;
                if (!rotatedValue.isLoaded) rotatedValue.onImageLoadedObservable.addOnce(()=>{
                    this._markAsDirty();
                });
                this._markAsDirty();
            });
            else {
                this._thumbImage = value._rotate90(-this.num90RotationInVerticalMode, true);
                this._markAsDirty();
            }
        } else {
            this._thumbImage = value;
            if (value && !value.isLoaded) value.onImageLoadedObservable.addOnce(()=>{
                this._markAsDirty();
            });
            this._markAsDirty();
        }
    }
    /**
     * Gets or sets the length of the thumb
     */ get thumbLength() {
        return this._thumbLength;
    }
    set thumbLength(value) {
        if (this._thumbLength === value) return;
        this._thumbLength = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets the height of the thumb
     */ get thumbHeight() {
        return this._thumbHeight;
    }
    set thumbHeight(value) {
        if (this._thumbLength === value) return;
        this._thumbHeight = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets the height of the bar image
     */ get barImageHeight() {
        return this._barImageHeight;
    }
    set barImageHeight(value) {
        if (this._barImageHeight === value) return;
        this._barImageHeight = value;
        this._markAsDirty();
    }
    /**
     * Creates a new ImageScrollBar
     * @param name defines the control name
     */ constructor(name){
        super(name);
        this.name = name;
        this._thumbLength = 0.5;
        this._thumbHeight = 1;
        this._barImageHeight = 1;
        this._tempMeasure = new (0, $lFAVI.Measure)(0, 0, 0, 0);
        this._invertScrollDirection = false;
        /** Number of 90° rotation to apply on the images when in vertical mode */ this.num90RotationInVerticalMode = 1;
    }
    _getTypeName() {
        return "ImageScrollBar";
    }
    _getThumbThickness() {
        let thumbThickness = 0;
        if (this._thumbWidth.isPixel) thumbThickness = this._thumbWidth.getValue(this._host);
        else thumbThickness = this._backgroundBoxThickness * this._thumbWidth.getValue(this._host);
        return thumbThickness;
    }
    _draw(context) {
        context.save();
        this._applyStates(context);
        this._prepareRenderingData("rectangle");
        const thumbPosition = this._getThumbPosition();
        const left = this._renderLeft;
        const top = this._renderTop;
        const width = this._renderWidth;
        const height = this._renderHeight;
        // Background
        if (this._backgroundImage) {
            this._tempMeasure.copyFromFloats(left, top, width, height);
            if (this.isVertical) {
                this._tempMeasure.copyFromFloats(left + width * (1 - this._barImageHeight) * 0.5, this._currentMeasure.top, width * this._barImageHeight, height);
                this._tempMeasure.height += this._effectiveThumbThickness;
                this._backgroundImage._currentMeasure.copyFrom(this._tempMeasure);
            } else {
                this._tempMeasure.copyFromFloats(this._currentMeasure.left, top + height * (1 - this._barImageHeight) * 0.5, width, height * this._barImageHeight);
                this._tempMeasure.width += this._effectiveThumbThickness;
                this._backgroundImage._currentMeasure.copyFrom(this._tempMeasure);
            }
            this._backgroundImage._draw(context);
        }
        // Thumb
        if (this.isVertical) this._tempMeasure.copyFromFloats(left - this._effectiveBarOffset + this._currentMeasure.width * (1 - this._thumbHeight) * 0.5, this._currentMeasure.top + thumbPosition, this._currentMeasure.width * this._thumbHeight, this._effectiveThumbThickness);
        else this._tempMeasure.copyFromFloats(this._currentMeasure.left + thumbPosition, this._currentMeasure.top + this._currentMeasure.height * (1 - this._thumbHeight) * 0.5, this._effectiveThumbThickness, this._currentMeasure.height * this._thumbHeight);
        if (this._thumbImage) {
            this._thumbImage._currentMeasure.copyFrom(this._tempMeasure);
            this._thumbImage._draw(context);
        }
        context.restore();
    }
    /**
     * @internal
     */ _updateValueFromPointer(x, y) {
        if (this.rotation != 0) {
            this._invertTransformMatrix.transformCoordinates(x, y, this._transformedPosition);
            x = this._transformedPosition.x;
            y = this._transformedPosition.y;
        }
        const sign = this._invertScrollDirection ? -1 : 1;
        if (this._first) {
            this._first = false;
            this._originX = x;
            this._originY = y;
            // Check if move is required
            if (x < this._tempMeasure.left || x > this._tempMeasure.left + this._tempMeasure.width || y < this._tempMeasure.top || y > this._tempMeasure.top + this._tempMeasure.height) {
                if (this.isVertical) this.value = this.minimum + (1 - (y - this._currentMeasure.top) / this._currentMeasure.height) * (this.maximum - this.minimum);
                else this.value = this.minimum + (x - this._currentMeasure.left) / this._currentMeasure.width * (this.maximum - this.minimum);
            }
        }
        // Delta mode
        let delta = 0;
        if (this.isVertical) delta = -((y - this._originY) / (this._currentMeasure.height - this._effectiveThumbThickness));
        else delta = (x - this._originX) / (this._currentMeasure.width - this._effectiveThumbThickness);
        this.value += sign * delta * (this.maximum - this.minimum);
        this._originX = x;
        this._originY = y;
    }
    _onPointerDown(target, coordinates, pointerId, buttonIndex, pi) {
        this._first = true;
        return super._onPointerDown(target, coordinates, pointerId, buttonIndex, pi);
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $2c3c08dc9cd220b9$export$e13e96cae730c69a.prototype, "num90RotationInVerticalMode", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $2c3c08dc9cd220b9$export$e13e96cae730c69a.prototype, "invertScrollDirection", null);

});
parcelRegister("cLeSo", function(module, exports) {

$parcel$export(module.exports, "BaseSlider", () => $94a569f8a0a59399$export$b7d1bd08e2ae9af0);

var $e0Suo = parcelRequire("e0Suo");

var $diGQf = parcelRequire("diGQf");

var $fCNdl = parcelRequire("fCNdl");

var $dKQam = parcelRequire("dKQam");

var $ir0rz = parcelRequire("ir0rz");

var $kVtWi = parcelRequire("kVtWi");
class $94a569f8a0a59399$export$b7d1bd08e2ae9af0 extends (0, $fCNdl.Control) {
    /** Gets or sets a boolean indicating if the thumb must be rendered */ get displayThumb() {
        return this._displayThumb;
    }
    set displayThumb(value) {
        if (this._displayThumb === value) return;
        this._displayThumb = value;
        this._markAsDirty();
    }
    /** Gets or sets a step to apply to values (0 by default) */ get step() {
        return this._step;
    }
    set step(value) {
        if (this._step === value) return;
        this._step = value;
        this._markAsDirty();
    }
    /** Gets or sets main bar offset (ie. the margin applied to the value bar) */ get barOffset() {
        return this._barOffset.toString(this._host);
    }
    /** Gets main bar offset in pixels*/ get barOffsetInPixels() {
        return this._barOffset.getValueInPixel(this._host, this._cachedParentMeasure.width);
    }
    set barOffset(value) {
        if (this._barOffset.toString(this._host) === value) return;
        if (this._barOffset.fromString(value)) this._markAsDirty();
    }
    /** Gets or sets thumb width */ get thumbWidth() {
        return this._thumbWidth.toString(this._host);
    }
    /** Gets thumb width in pixels */ get thumbWidthInPixels() {
        return this._thumbWidth.getValueInPixel(this._host, this._cachedParentMeasure.width);
    }
    set thumbWidth(value) {
        if (this._thumbWidth.toString(this._host) === value) return;
        if (this._thumbWidth.fromString(value)) this._markAsDirty();
    }
    /** Gets or sets minimum value */ get minimum() {
        return this._minimum;
    }
    set minimum(value) {
        if (this._minimum === value) return;
        this._minimum = value;
        this._markAsDirty();
        this.value = Math.max(Math.min(this.value, this._maximum), this._minimum);
    }
    /** Gets or sets maximum value */ get maximum() {
        return this._maximum;
    }
    set maximum(value) {
        if (this._maximum === value) return;
        this._maximum = value;
        this._markAsDirty();
        this.value = Math.max(Math.min(this.value, this._maximum), this._minimum);
    }
    /** Gets or sets current value */ get value() {
        return this._value;
    }
    set value(value) {
        value = Math.max(Math.min(value, this._maximum), this._minimum);
        if (this._value === value) return;
        this._value = value;
        this._markAsDirty();
        this.onValueChangedObservable.notifyObservers(this._value);
    }
    /**Gets or sets a boolean indicating if the slider should be vertical or horizontal */ get isVertical() {
        return this._isVertical;
    }
    set isVertical(value) {
        if (this._isVertical === value) return;
        this._isVertical = value;
        this._markAsDirty();
    }
    /** Gets or sets a value indicating if the thumb can go over main bar extends */ get isThumbClamped() {
        return this._isThumbClamped;
    }
    set isThumbClamped(value) {
        if (this._isThumbClamped === value) return;
        this._isThumbClamped = value;
        this._markAsDirty();
    }
    /**
     * Creates a new BaseSlider
     * @param name defines the control name
     */ constructor(name){
        super(name);
        this.name = name;
        this._thumbWidth = new (0, $dKQam.ValueAndUnit)(20, (0, $dKQam.ValueAndUnit).UNITMODE_PIXEL, false);
        this._minimum = 0;
        this._maximum = 100;
        this._value = 50;
        this._isVertical = false;
        this._barOffset = new (0, $dKQam.ValueAndUnit)(5, (0, $dKQam.ValueAndUnit).UNITMODE_PIXEL, false);
        this._isThumbClamped = false;
        this._displayThumb = true;
        this._step = 0;
        this._lastPointerDownId = -1;
        // Shared rendering info
        this._effectiveBarOffset = 0;
        /** Observable raised when the slider value changes */ this.onValueChangedObservable = new (0, $diGQf.Observable)();
        // Events
        this._pointerIsDown = false;
        this.isPointerBlocker = true;
    }
    _getTypeName() {
        return "BaseSlider";
    }
    _getThumbPosition() {
        if (this.isVertical) return (this.maximum - this.value) / (this.maximum - this.minimum) * this._backgroundBoxLength;
        return (this.value - this.minimum) / (this.maximum - this.minimum) * this._backgroundBoxLength;
    }
    _getThumbThickness(type) {
        let thumbThickness = 0;
        switch(type){
            case "circle":
                if (this._thumbWidth.isPixel) thumbThickness = Math.max(this._thumbWidth.getValue(this._host), this._backgroundBoxThickness);
                else thumbThickness = this._backgroundBoxThickness * this._thumbWidth.getValue(this._host);
                break;
            case "rectangle":
                if (this._thumbWidth.isPixel) thumbThickness = Math.min(this._thumbWidth.getValue(this._host), this._backgroundBoxThickness);
                else thumbThickness = this._backgroundBoxThickness * this._thumbWidth.getValue(this._host);
        }
        return thumbThickness;
    }
    _prepareRenderingData(type) {
        // Main bar
        this._effectiveBarOffset = 0;
        this._renderLeft = this._currentMeasure.left;
        this._renderTop = this._currentMeasure.top;
        this._renderWidth = this._currentMeasure.width;
        this._renderHeight = this._currentMeasure.height;
        this._backgroundBoxLength = Math.max(this._currentMeasure.width, this._currentMeasure.height);
        this._backgroundBoxThickness = Math.min(this._currentMeasure.width, this._currentMeasure.height);
        this._effectiveThumbThickness = this._getThumbThickness(type);
        if (this.displayThumb) this._backgroundBoxLength -= this._effectiveThumbThickness;
        //throw error when height is less than width for vertical slider
        if (this.isVertical && this._currentMeasure.height < this._currentMeasure.width) {
            (0, $kVtWi.Logger).Error("Height should be greater than width");
            return;
        }
        if (this._barOffset.isPixel) this._effectiveBarOffset = Math.min(this._barOffset.getValue(this._host), this._backgroundBoxThickness);
        else this._effectiveBarOffset = this._backgroundBoxThickness * this._barOffset.getValue(this._host);
        this._backgroundBoxThickness -= this._effectiveBarOffset * 2;
        if (this.isVertical) {
            this._renderLeft += this._effectiveBarOffset;
            if (!this.isThumbClamped && this.displayThumb) this._renderTop += this._effectiveThumbThickness / 2;
            this._renderHeight = this._backgroundBoxLength;
            this._renderWidth = this._backgroundBoxThickness;
        } else {
            this._renderTop += this._effectiveBarOffset;
            if (!this.isThumbClamped && this.displayThumb) this._renderLeft += this._effectiveThumbThickness / 2;
            this._renderHeight = this._backgroundBoxThickness;
            this._renderWidth = this._backgroundBoxLength;
        }
    }
    /**
     * @internal
     */ _updateValueFromPointer(x, y) {
        if (this.rotation != 0) {
            this._invertTransformMatrix.transformCoordinates(x, y, this._transformedPosition);
            x = this._transformedPosition.x;
            y = this._transformedPosition.y;
        }
        let value;
        if (this._isVertical) value = this._minimum + (1 - (y - this._currentMeasure.top) / this._currentMeasure.height) * (this._maximum - this._minimum);
        else value = this._minimum + (x - this._currentMeasure.left) / this._currentMeasure.width * (this._maximum - this._minimum);
        this.value = this._step ? Math.round(value / this._step) * this._step : value;
    }
    _onPointerDown(target, coordinates, pointerId, buttonIndex, pi) {
        if (!super._onPointerDown(target, coordinates, pointerId, buttonIndex, pi)) return false;
        if (this.isReadOnly) return true;
        this._pointerIsDown = true;
        this._updateValueFromPointer(coordinates.x, coordinates.y);
        this._host._capturingControl[pointerId] = this;
        this._lastPointerDownId = pointerId;
        return true;
    }
    _onPointerMove(target, coordinates, pointerId, pi) {
        // Only listen to pointer move events coming from the last pointer to click on the element (To support dual vr controller interaction)
        if (pointerId != this._lastPointerDownId) return;
        if (this._pointerIsDown && !this.isReadOnly) this._updateValueFromPointer(coordinates.x, coordinates.y);
        super._onPointerMove(target, coordinates, pointerId, pi);
    }
    _onPointerUp(target, coordinates, pointerId, buttonIndex, notifyClick) {
        this._pointerIsDown = false;
        delete this._host._capturingControl[pointerId];
        super._onPointerUp(target, coordinates, pointerId, buttonIndex, notifyClick);
    }
    _onCanvasBlur() {
        this._forcePointerUp();
        super._onCanvasBlur();
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $94a569f8a0a59399$export$b7d1bd08e2ae9af0.prototype, "displayThumb", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $94a569f8a0a59399$export$b7d1bd08e2ae9af0.prototype, "step", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $94a569f8a0a59399$export$b7d1bd08e2ae9af0.prototype, "barOffset", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $94a569f8a0a59399$export$b7d1bd08e2ae9af0.prototype, "thumbWidth", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $94a569f8a0a59399$export$b7d1bd08e2ae9af0.prototype, "minimum", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $94a569f8a0a59399$export$b7d1bd08e2ae9af0.prototype, "maximum", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $94a569f8a0a59399$export$b7d1bd08e2ae9af0.prototype, "value", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $94a569f8a0a59399$export$b7d1bd08e2ae9af0.prototype, "isVertical", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $94a569f8a0a59399$export$b7d1bd08e2ae9af0.prototype, "isThumbClamped", null);

});


parcelRegister("k44X5", function(module, exports) {

$parcel$export(module.exports, "ScrollBar", () => $e9b805bf421ed637$export$342551df3dea21fb);

var $e0Suo = parcelRequire("e0Suo");

var $cLeSo = parcelRequire("cLeSo");

var $lFAVI = parcelRequire("lFAVI");

var $ir0rz = parcelRequire("ir0rz");

var $bOhSV = parcelRequire("bOhSV");

var $8DoUR = parcelRequire("8DoUR");
class $e9b805bf421ed637$export$342551df3dea21fb extends (0, $cLeSo.BaseSlider) {
    /** Gets or sets border color */ get borderColor() {
        return this._borderColor;
    }
    set borderColor(value) {
        if (this._borderColor === value) return;
        this._borderColor = value;
        this._markAsDirty();
    }
    /** Gets or sets background color */ get background() {
        return this._background;
    }
    set background(value) {
        if (this._background === value) return;
        this._background = value;
        this._markAsDirty();
    }
    /** Gets or sets background gradient. Takes precedence over gradient. */ get backgroundGradient() {
        return this._backgroundGradient;
    }
    set backgroundGradient(value) {
        if (this._backgroundGradient === value) return;
        this._backgroundGradient = value;
        this._markAsDirty();
    }
    /** Inverts the scrolling direction (default: false) */ get invertScrollDirection() {
        return this._invertScrollDirection;
    }
    set invertScrollDirection(invert) {
        this._invertScrollDirection = invert;
    }
    /**
     * Creates a new Slider
     * @param name defines the control name
     */ constructor(name){
        super(name);
        this.name = name;
        this._background = "black";
        this._borderColor = "white";
        this._tempMeasure = new (0, $lFAVI.Measure)(0, 0, 0, 0);
        this._invertScrollDirection = false;
        this._backgroundGradient = null;
    }
    _getTypeName() {
        return "Scrollbar";
    }
    _getThumbThickness() {
        let thumbThickness = 0;
        if (this._thumbWidth.isPixel) thumbThickness = this._thumbWidth.getValue(this._host);
        else thumbThickness = this._backgroundBoxThickness * this._thumbWidth.getValue(this._host);
        return thumbThickness;
    }
    _getBackgroundColor(context) {
        return this._backgroundGradient ? this._backgroundGradient.getCanvasGradient(context) : this._background;
    }
    _draw(context) {
        context.save();
        this._applyStates(context);
        this._prepareRenderingData("rectangle");
        const left = this._renderLeft;
        const thumbPosition = this._getThumbPosition();
        context.fillStyle = this._getBackgroundColor(context);
        context.fillRect(this._currentMeasure.left, this._currentMeasure.top, this._currentMeasure.width, this._currentMeasure.height);
        // Value bar
        context.fillStyle = this._getColor(context);
        // Thumb
        if (this.isVertical) {
            this._tempMeasure.left = left - this._effectiveBarOffset;
            this._tempMeasure.top = this._currentMeasure.top + thumbPosition;
            this._tempMeasure.width = this._currentMeasure.width;
            this._tempMeasure.height = this._effectiveThumbThickness;
        } else {
            this._tempMeasure.left = this._currentMeasure.left + thumbPosition;
            this._tempMeasure.top = this._currentMeasure.top;
            this._tempMeasure.width = this._effectiveThumbThickness;
            this._tempMeasure.height = this._currentMeasure.height;
        }
        context.fillRect(this._tempMeasure.left, this._tempMeasure.top, this._tempMeasure.width, this._tempMeasure.height);
        context.restore();
    }
    /**
     * @internal
     */ _updateValueFromPointer(x, y) {
        if (this.rotation != 0) {
            this._invertTransformMatrix.transformCoordinates(x, y, this._transformedPosition);
            x = this._transformedPosition.x;
            y = this._transformedPosition.y;
        }
        const sign = this._invertScrollDirection ? -1 : 1;
        if (this._first) {
            this._first = false;
            this._originX = x;
            this._originY = y;
            // Check if move is required
            if (x < this._tempMeasure.left || x > this._tempMeasure.left + this._tempMeasure.width || y < this._tempMeasure.top || y > this._tempMeasure.top + this._tempMeasure.height) {
                if (this.isVertical) this.value = this.minimum + (1 - (y - this._currentMeasure.top) / this._currentMeasure.height) * (this.maximum - this.minimum);
                else this.value = this.minimum + (x - this._currentMeasure.left) / this._currentMeasure.width * (this.maximum - this.minimum);
            }
        }
        // Delta mode
        let delta = 0;
        if (this.isVertical) delta = -((y - this._originY) / (this._currentMeasure.height - this._effectiveThumbThickness));
        else delta = (x - this._originX) / (this._currentMeasure.width - this._effectiveThumbThickness);
        this.value += sign * delta * (this.maximum - this.minimum);
        this._originX = x;
        this._originY = y;
    }
    _onPointerDown(target, coordinates, pointerId, buttonIndex, pi) {
        this._first = true;
        return super._onPointerDown(target, coordinates, pointerId, buttonIndex, pi);
    }
    serialize(serializationObject) {
        super.serialize(serializationObject);
        if (this.backgroundGradient) {
            serializationObject.backgroundGradient = {};
            this.backgroundGradient.serialize(serializationObject.backgroundGradient);
        }
    }
    _parseFromContent(serializationObject, host) {
        super._parseFromContent(serializationObject, host);
        if (serializationObject.backgroundGradient) {
            const className = (0, $bOhSV.Tools).Instantiate("BABYLON.GUI." + serializationObject.backgroundGradient.className);
            this.backgroundGradient = new className();
            this.backgroundGradient.parse(serializationObject.backgroundGradient);
        }
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e9b805bf421ed637$export$342551df3dea21fb.prototype, "borderColor", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e9b805bf421ed637$export$342551df3dea21fb.prototype, "background", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e9b805bf421ed637$export$342551df3dea21fb.prototype, "invertScrollDirection", null);
(0, $8DoUR.RegisterClass)("BABYLON.GUI.Scrollbar", $e9b805bf421ed637$export$342551df3dea21fb);

});

parcelRegister("4BGGM", function(module, exports) {

$parcel$export(module.exports, "_ScrollViewerWindow3D", () => $35abbb4a38a27f4f$export$608bae59c2dd7a6f);

var $esuuG = parcelRequire("esuuG");

var $fCNdl = parcelRequire("fCNdl");

var $lFAVI = parcelRequire("lFAVI");

var $dKQam = parcelRequire("dKQam");
class $35abbb4a38a27f4f$export$608bae59c2dd7a6f extends (0, $esuuG.Container) {
    get freezeControls() {
        return this._freezeControls;
    }
    set freezeControls(value) {
        if (this._freezeControls === value) return;
        if (!value) this._restoreMeasures();
        // trigger a full normal layout calculation to be sure all children have their measures up to date
        this._freezeControls = false;
        var textureSize = this.host.getSize();
        var renderWidth = textureSize.width;
        var renderHeight = textureSize.height;
        var context = this.host.getContext();
        var measure = new (0, $lFAVI.Measure)(0, 0, renderWidth, renderHeight);
        this.host._numLayoutCalls = 0;
        this.host._rootContainer._layout(measure, context);
        // in freeze mode, prepare children measures accordingly
        if (value) {
            this._updateMeasures();
            if (this._useBuckets()) this._makeBuckets();
        }
        this._freezeControls = value;
        this.host.markAsDirty(); // redraw with the (new) current settings
    }
    get bucketWidth() {
        return this._bucketWidth;
    }
    get bucketHeight() {
        return this._bucketHeight;
    }
    setBucketSizes(width, height) {
        this._bucketWidth = width;
        this._bucketHeight = height;
        if (this._useBuckets()) {
            if (this._freezeControls) this._makeBuckets();
        } else this._buckets = {};
    }
    _useBuckets() {
        return this._bucketWidth > 0 && this._bucketHeight > 0;
    }
    _makeBuckets() {
        this._buckets = {};
        this._bucketLen = Math.ceil(this.widthInPixels / this._bucketWidth);
        this._dispatchInBuckets(this._children);
        this._oldLeft = null;
        this._oldTop = null;
    }
    _dispatchInBuckets(children) {
        for(let i = 0; i < children.length; ++i){
            let child = children[i];
            let bStartX = Math.max(0, Math.floor((child._customData._origLeft - this._customData.origLeft) / this._bucketWidth)), bEndX = Math.floor((child._customData._origLeft - this._customData.origLeft + child._currentMeasure.width - 1) / this._bucketWidth), bStartY = Math.max(0, Math.floor((child._customData._origTop - this._customData.origTop) / this._bucketHeight)), bEndY = Math.floor((child._customData._origTop - this._customData.origTop + child._currentMeasure.height - 1) / this._bucketHeight);
            while(bStartY <= bEndY){
                for(let x = bStartX; x <= bEndX; ++x){
                    let bucket = bStartY * this._bucketLen + x, lstc = this._buckets[bucket];
                    if (!lstc) {
                        lstc = [];
                        this._buckets[bucket] = lstc;
                    }
                    lstc.push(child);
                }
                bStartY++;
            }
            if (child instanceof (0, $esuuG.Container) && child._children.length > 0) this._dispatchInBuckets(child._children);
        }
    }
    // reset left and top measures for the window and all its children
    _updateMeasures() {
        let left = this.leftInPixels | 0, top = this.topInPixels | 0;
        this._measureForChildren.left -= left;
        this._measureForChildren.top -= top;
        this._currentMeasure.left -= left;
        this._currentMeasure.top -= top;
        this._customData.origLeftForChildren = this._measureForChildren.left;
        this._customData.origTopForChildren = this._measureForChildren.top;
        this._customData.origLeft = this._currentMeasure.left;
        this._customData.origTop = this._currentMeasure.top;
        this._updateChildrenMeasures(this._children, left, top);
    }
    _updateChildrenMeasures(children, left, top) {
        for(let i = 0; i < children.length; ++i){
            let child = children[i];
            child._currentMeasure.left -= left;
            child._currentMeasure.top -= top;
            child._customData._origLeft = child._currentMeasure.left; // save the original left and top values for each child
            child._customData._origTop = child._currentMeasure.top;
            if (child instanceof (0, $esuuG.Container) && child._children.length > 0) this._updateChildrenMeasures(child._children, left, top);
        }
    }
    _restoreMeasures() {
        let left = this.leftInPixels | 0, top = this.topInPixels | 0;
        this._measureForChildren.left = this._customData.origLeftForChildren + left;
        this._measureForChildren.top = this._customData.origTopForChildren + top;
        this._currentMeasure.left = this._customData.origLeft + left;
        this._currentMeasure.top = this._customData.origTop + top;
    }
    /**
    * Creates a new ScrollViewerWindow
    * @param name of ScrollViewerWindow
    */ constructor(name){
        super(name);
        this.parentClientWidth = 0;
        this.parentClientHeight = 0;
        this._freezeControls = false;
        this._parentMeasure = new (0, $lFAVI.Measure)(0, 0, 0, 0);
        this._oldLeft = null;
        this._oldTop = null;
        //@hidden
        this._scrollbarMeasures = new (0, $lFAVI.Measure)(0, 0, 1, 1);
        this._bucketWidth = 0;
        this._bucketHeight = 0;
        this._buckets = {};
        this._bucketLen = 0;
    }
    _getTypeName() {
        return "ScrollViewerWindow";
    }
    /** @hidden */ _additionalProcessing(parentMeasure, context) {
        super._additionalProcessing(parentMeasure, context);
        this._parentMeasure = parentMeasure;
        this._measureForChildren.left = this._currentMeasure.left;
        this._measureForChildren.top = this._currentMeasure.top;
    // this._measureForChildren.width = parentMeasure.width;
    // this._measureForChildren.height = parentMeasure.height;
    }
    /** @hidden */ _layout(parentMeasure, context) {
        if (this._freezeControls) {
            this.invalidateRect(); // will trigger a redraw of the window
            return false;
        }
        return super._layout(parentMeasure, context);
    }
    _scrollChildren(children, left, top) {
        for(let i = 0; i < children.length; ++i){
            let child = children[i];
            child._currentMeasure.left = child._customData._origLeft + left;
            child._currentMeasure.top = child._customData._origTop + top;
            child._isClipped = false; // clipping will be handled by _draw and the call to _intersectsRect()
            if (child instanceof (0, $esuuG.Container) && child._children.length > 0) this._scrollChildren(child._children, left, top);
        }
    }
    _scrollChildrenWithBuckets(left, top, scrollLeft, scrollTop) {
        let bStartX = Math.max(0, Math.floor(-left / this._bucketWidth)), bEndX = Math.floor((-left + this._parentMeasure.width - 1) / this._bucketWidth), bStartY = Math.max(0, Math.floor(-top / this._bucketHeight)), bEndY = Math.floor((-top + this._parentMeasure.height - 1) / this._bucketHeight);
        while(bStartY <= bEndY){
            for(let x = bStartX; x <= bEndX; ++x){
                let bucket = bStartY * this._bucketLen + x, lstc = this._buckets[bucket];
                if (lstc) for(let i = 0; i < lstc.length; ++i){
                    let child = lstc[i];
                    child._currentMeasure.left = child._customData._origLeft + scrollLeft;
                    child._currentMeasure.top = child._customData._origTop + scrollTop;
                    child._isClipped = false; // clipping will be handled by _draw and the call to _intersectsRect()
                }
            }
            bStartY++;
        }
    }
    /** @hidden */ _draw(context, invalidatedRectangle) {
        if (!this._freezeControls) {
            super._draw(context, invalidatedRectangle);
            return;
        }
        this._localDraw(context);
        if (this.clipChildren) this._clipForChildren(context);
        let left = this.leftInPixels | 0, top = this.topInPixels | 0;
        if (this._useBuckets()) {
            if (this._oldLeft !== null && this._oldTop !== null) {
                this._scrollChildrenWithBuckets(this._oldLeft, this._oldTop, left, top);
                this._scrollChildrenWithBuckets(left, top, left, top);
            } else this._scrollChildren(this._children, left, top);
        } else this._scrollChildren(this._children, left, top);
        this._oldLeft = left;
        this._oldTop = top;
        for (var child of this._children){
            if (!child._intersectsRect(this._parentMeasure)) continue;
            child._render(context, this._parentMeasure);
        }
    }
    _postMeasure() {
        if (this._freezeControls) {
            super._postMeasure();
            return;
        }
        var maxWidth = this.parentClientWidth;
        var maxHeight = this.parentClientHeight;
        for (var child of this.children){
            if (!child.isVisible || child.notRenderable) continue;
            if (child.horizontalAlignment === (0, $fCNdl.Control).HORIZONTAL_ALIGNMENT_CENTER) child._offsetLeft(this._currentMeasure.left - child._currentMeasure.left);
            if (child.verticalAlignment === (0, $fCNdl.Control).VERTICAL_ALIGNMENT_CENTER) child._offsetTop(this._currentMeasure.top - child._currentMeasure.top);
            if (child.horizontalAlignment === (0, $fCNdl.Control).HORIZONTAL_ALIGNMENT_RIGHT) maxWidth = Math.max(maxWidth, child._currentMeasure.width + child.paddingLeftInPixels);
            else maxWidth = Math.max(maxWidth, child._currentMeasure.left - this._currentMeasure.left + child._currentMeasure.width + child.paddingRightInPixels);
            this._scrollbarMeasures.left = child._currentMeasure.left;
            if (child.verticalAlignment === (0, $fCNdl.Control).VERTICAL_ALIGNMENT_BOTTOM) maxHeight = Math.max(maxHeight, child._currentMeasure.height + child.paddingTopInPixels);
            else maxHeight = Math.max(maxHeight, child._currentMeasure.top - this._currentMeasure.top + child._currentMeasure.height + child.paddingBottomInPixels);
            this._scrollbarMeasures.top = child._currentMeasure.top;
        }
        this._scrollbarMeasures.width = this.parentClientWidth / maxWidth;
        this._scrollbarMeasures.height = this.parentClientHeight / maxHeight;
        this._scrollbarMeasures.left *= this._scrollbarMeasures.width;
        this._scrollbarMeasures.top *= this._scrollbarMeasures.height;
        if (this._currentMeasure.width !== maxWidth) {
            this._width.updateInPlace(maxWidth, (0, $dKQam.ValueAndUnit).UNITMODE_PIXEL);
            this._currentMeasure.width = maxWidth;
            this._rebuildLayout = true;
            this._isDirty = true;
        }
        if (this._currentMeasure.height !== maxHeight) {
            this._height.updateInPlace(maxHeight, (0, $dKQam.ValueAndUnit).UNITMODE_PIXEL);
            this._currentMeasure.height = maxHeight;
            this._rebuildLayout = true;
            this._isDirty = true;
        }
        super._postMeasure();
    }
}

});

parcelRegister("4GBc6", function(module, exports) {

$parcel$export(module.exports, "DefinitionType", () => $3697efa5ae3db110$export$4a9dbab3c849a99);
$parcel$export(module.exports, "Grid3D", () => $3697efa5ae3db110$export$bfb43f9757af6cd1);

var $bOhSV = parcelRequire("bOhSV");

var $fCNdl = parcelRequire("fCNdl");

var $dKQam = parcelRequire("dKQam");

var $PPcK8 = parcelRequire("PPcK8");

var $aNyYk = parcelRequire("aNyYk");
var $3697efa5ae3db110$export$4a9dbab3c849a99;
(function(DefinitionType) {
    DefinitionType[DefinitionType["Percentage"] = 0] = "Percentage";
    DefinitionType[DefinitionType["Pixel"] = 1] = "Pixel";
    DefinitionType[DefinitionType["Auto"] = 2] = "Auto";
})($3697efa5ae3db110$export$4a9dbab3c849a99 || ($3697efa5ae3db110$export$4a9dbab3c849a99 = {}));
class $3697efa5ae3db110$export$bfb43f9757af6cd1 extends (0, $PPcK8.Rectangle3D) {
    /**
     * Gets the number of columns
     */ get columnCount() {
        return this._columnDefinitions.length;
    }
    /**
     * Gets the number of rows
     */ get rowCount() {
        return this._rowDefinitions.length;
    }
    /** Gets the list of children */ get children() {
        return this._childControls;
    }
    /** Gets the list of cells (e.g. the containers) */ get cells() {
        return this._cells;
    }
    /**
     * Gets the definition of a specific row
     * @param index defines the index of the row
     * @returns the row definition
     */ getRowDefinition(index) {
        if (index < 0 || index >= this._rowDefinitions.length) return null;
        return this._rowDefinitions[index];
    }
    /**
     * Gets the definition of a specific column
     * @param index defines the index of the column
     * @returns the column definition
     */ getColumnDefinition(index) {
        if (index < 0 || index >= this._columnDefinitions.length) return null;
        return this._columnDefinitions[index];
    }
    /**
     * Adds a new row to the grid
     * @param height defines the height of the row (either in pixel or a value between 0 and 1)
     * @param type defines if the height is expressed in pixel, as percentage or is set to auto
     * @param min optional minimal row height
     * @param max optional maximal row height
     * @returns the current grid
     */ addRowDefinition(height, type = $3697efa5ae3db110$export$4a9dbab3c849a99.Percentage, min, max) {
        const value = new (0, $dKQam.ValueAndUnit)(height, type);
        value.min = min;
        value.max = max;
        this._rowDefinitions.push(value);
        this._markAsDirty();
        return this;
    }
    /**
     * Adds a new column to the grid
     * @param width defines the width of the column (either in pixel or a value between 0 and 1)
     * @param type defines if the width is expressed in pixel, as percentage or is set to auto
     * @param min optional minimal column width
     * @param max optional maximal column width
     * @returns the current grid
     */ addColumnDefinition(width, type = $3697efa5ae3db110$export$4a9dbab3c849a99.Percentage, min, max) {
        const value = new (0, $dKQam.ValueAndUnit)(width, type);
        value.min = min;
        value.max = max;
        this._columnDefinitions.push(value);
        this._markAsDirty();
        return this;
    }
    /**
     * Update a row definition
     * @param index defines the index of the row to update
     * @param height defines the height of the row (either in pixel or a value between 0 and 1)
     * @param type defines if the height is expressed in pixel, as percentage or is set to auto
     * @param min optional minimal row height
     * @param max optional maximal row height
     * @returns the current grid
     */ setRowDefinition(index, height, type = $3697efa5ae3db110$export$4a9dbab3c849a99.Percentage, min, max) {
        if (index < 0 || index >= this._rowDefinitions.length) return this;
        let current = this._rowDefinitions[index];
        if (current && $3697efa5ae3db110$export$bfb43f9757af6cd1.GetDefinitionType(current) === type && current.value === height && current.min === min && current.max === max) return this;
        const value = new (0, $dKQam.ValueAndUnit)(height, type);
        value.min = min;
        value.max = max;
        this._rowDefinitions[index] = value;
        this._markAsDirty();
        return this;
    }
    /**
     * Update a column definition
     * @param index defines the index of the column to update
     * @param width defines the width of the column (either in pixel or a value between 0 and 1)
     * @param type defines if the width is expressed in pixel, as percentage or is set to auto
     * @param min optional minimal column width
     * @param max optional maximal column width
     * @returns the current grid
     */ setColumnDefinition(index, width, type = $3697efa5ae3db110$export$4a9dbab3c849a99.Percentage, min, max) {
        if (index < 0 || index >= this._columnDefinitions.length) return this;
        let current = this._columnDefinitions[index];
        if (current && $3697efa5ae3db110$export$bfb43f9757af6cd1.GetDefinitionType(current) === type && current.value === width && current.min === min && current.max === max) return this;
        const value = new (0, $dKQam.ValueAndUnit)(width, type);
        value.min = min;
        value.max = max;
        this._columnDefinitions[index] = value;
        this._markAsDirty();
        return this;
    }
    /**
     * Gets the list of children stored in a specific cell
     * @param row defines the row to check
     * @param column defines the column to check
     * @param rowSpan defines the row span for cells spanning multiple rows
     * @param columnSpan defines the column span for cells spanning multiple columns
     * @returns the list of controls
     */ getChildrenAt(row, column, rowSpan = 1, columnSpan = 1) {
        const cell = this._cells[`${row}-${row + rowSpan - 1}:${column}-${column + columnSpan - 1}`];
        if (!cell) return null;
        return cell.children;
    }
    /**
     * Gets the cell container
     * @param row defines the row to check
     * @param column defines the column to check
     * @param rowSpan defines the row span for cells spanning multiple rows
     * @param columnSpan defines the column span for cells spanning multiple columns
     * @returns the list of controls
     */ getCellAt(row, column, rowSpan = 1, columnSpan = 1) {
        return this._cells[`${row}-${row + rowSpan - 1}:${column}-${column + columnSpan - 1}`];
    }
    /**
     * Gets a string representing the child cell info (row x column)
     * @param child defines the control to get info from
     * @returns a string containing the child cell info (row x column)
     */ getChildCellInfo(child) {
        return child._tag;
    }
    _removeCell(cell, key) {
        if (!cell) return;
        super.removeControl(cell);
        for (var control of cell.children){
            let childIndex = this._childControls.indexOf(control);
            if (childIndex !== -1) this._childControls.splice(childIndex, 1);
        }
        delete this._cells[key];
    }
    _offsetCell(previousKey, key) {
        if (!this._cells[key]) return;
        this._cells[previousKey] = this._cells[key];
        for (var control of this._cells[previousKey].children)control._tag = previousKey;
        delete this._cells[key];
    }
    /**
     * Remove a column definition at specified index
     * @param index defines the index of the column to remove
     * @returns the current grid
     */ removeColumnDefinition(index) {
        if (index < 0 || index >= this._columnDefinitions.length) return this;
        for(let rowStart = 0; rowStart < this._rowDefinitions.length; rowStart++){
            for(let rowEnd = rowStart; rowEnd < this._rowDefinitions.length; rowEnd++)for(let columnEnd = index; columnEnd < this._columnDefinitions.length; columnEnd++){
                const key = `${rowStart}-${rowEnd}:${index}-${columnEnd}`;
                const cell = this._cells[key];
                this._removeCell(cell, key);
            }
        }
        for(let rowStart = 0; rowStart < this._rowDefinitions.length; rowStart++)for(let rowEnd = 0; rowEnd < this._rowDefinitions.length; rowEnd++){
            for(let columnStart = index + 1; columnStart < this._columnDefinitions.length; columnStart++)for(let columnEnd = columnStart; columnEnd <= this._columnDefinitions.length; columnEnd++){
                const previousKey = `${rowStart}-${rowEnd}:${columnStart - 1}-${columnEnd}`;
                const key = `${rowStart}-${rowEnd}:${columnStart}-${columnEnd}`;
                this._offsetCell(previousKey, key);
            }
        }
        this._columnDefinitions.splice(index, 1);
        this._markAsDirty();
        return this;
    }
    /**
     * Remove a row definition at specified index
     * @param index defines the index of the row to remove
     * @returns the current grid
     */ removeRowDefinition(index) {
        if (index < 0 || index >= this._rowDefinitions.length) return this;
        for(var y = 0; y < this._columnDefinitions.length; y++)for(var x = index + 1; x < this._rowDefinitions.length; x++){
            const previousKey = `${x - 1}:${y}`;
            const key = `${x}:${y}`;
            this._offsetCell(previousKey, key);
        }
        for(let columnStart = 0; columnStart < this._columnDefinitions.length; columnStart++){
            for(let columnEnd = columnStart; columnEnd < this._columnDefinitions.length; columnEnd++)for(let rowEnd = index; rowEnd < this._rowDefinitions.length; rowEnd++){
                const key = `${index}-${rowEnd}:${columnStart}-${columnEnd}`;
                const cell = this._cells[key];
                this._removeCell(cell, key);
            }
        }
        for(let columnStart = 0; columnStart < this._columnDefinitions.length; columnStart++)for(let columnEnd = 0; columnEnd < this._columnDefinitions.length; columnEnd++){
            for(let rowStart = index + 1; rowStart < this._rowDefinitions.length; rowStart++)for(let rowEnd = rowStart; rowEnd <= this._rowDefinitions.length; rowEnd++){
                const previousKey = `${rowStart - 1}-${rowEnd}:${columnStart}-${columnEnd}`;
                const key = `${rowStart}-${rowEnd}:${columnStart}-${columnEnd}`;
                this._offsetCell(previousKey, key);
            }
        }
        this._rowDefinitions.splice(index, 1);
        this._markAsDirty();
        return this;
    }
    /**
     * Adds a new control to the current grid
     * @param control defines the control to add
     * @param row defines the row where to add the control (0 by default)
     * @param column defines the column where to add the control (0 by default)
     * @returns the current grid
     */ addControl(control, row = 0, column = 0, rowSpan = 1, columnSpan = 1) {
        if (control === null) return this;
        if (this._rowDefinitions.length === 0) // Add default row definition
        this.addRowDefinition(1);
        if (this._columnDefinitions.length === 0) // Add default column definition
        this.addColumnDefinition(1);
        if (this._childControls.indexOf(control) !== -1) {
            (0, $bOhSV.Tools).Warn(`Control (Name:${control.name}, UniqueId:${control.uniqueId}) is already associated with this grid. You must remove it before reattaching it`);
            return this;
        }
        let x = Math.min(row, this._rowDefinitions.length - 1);
        let y = Math.min(column, this._columnDefinitions.length - 1);
        let xe = Math.min(row + rowSpan - 1, this._rowDefinitions.length - 1);
        let ye = Math.min(column + columnSpan - 1, this._columnDefinitions.length - 1);
        let key = `${x}-${xe}:${y}-${ye}`;
        let goodContainer = this._cells[key];
        if (!goodContainer) {
            goodContainer = new (0, $aNyYk.SimpleContainer3D)(key);
            this._cells[key] = goodContainer;
            goodContainer.horizontalAlignment = (0, $fCNdl.Control).HORIZONTAL_ALIGNMENT_LEFT;
            goodContainer.verticalAlignment = (0, $fCNdl.Control).VERTICAL_ALIGNMENT_TOP;
            super.addControl(goodContainer);
        }
        goodContainer.addControl(control);
        this._childControls.push(control);
        control._tag = key;
        control.parent = this;
        this._markAsDirty();
        return this;
    }
    /**
     * Removes a control from the current container
     * @param control defines the control to remove
     * @returns the current container
     */ removeControl(control) {
        var index = this._childControls.indexOf(control);
        if (index !== -1) this._childControls.splice(index, 1);
        let cell = this._cells[control._tag];
        if (cell) {
            cell.removeControl(control);
            control._tag = undefined;
        }
        this._markAsDirty();
        return this;
    }
    /**
     * Creates a new Grid
     * @param name defines control name
     */ constructor(name){
        super(name);
        this.name = name;
        this._rowDefinitions = new Array();
        this._columnDefinitions = new Array();
        this._cells = {};
        this._childControls = new Array();
    }
    _getTypeName() {
        return "Grid";
    }
    _getGridDefinitions(definitionCallback) {
        const widths = [];
        const heights = [];
        const lefts = [];
        const tops = [];
        let availableWidth = this._currentMeasure.width;
        let globalWidthPercentage = 0;
        let availableHeight = this._currentMeasure.height;
        let globalHeightPercentage = 0;
        // Heights
        let index = 0;
        for (const value of this._rowDefinitions){
            switch($3697efa5ae3db110$export$bfb43f9757af6cd1.GetDefinitionType(value)){
                case $3697efa5ae3db110$export$4a9dbab3c849a99.Percentage:
                    globalHeightPercentage += value.value;
                    break;
                case $3697efa5ae3db110$export$4a9dbab3c849a99.Pixel:
                    {
                        const height = value.getValue(this._host);
                        availableHeight -= height;
                        heights[index] = height;
                        break;
                    }
                case $3697efa5ae3db110$export$4a9dbab3c849a99.Auto:
                    {
                        let height = this.GetChildrenDimension(index, "rows");
                        if (value.min !== undefined && value.min.unit === (0, $dKQam.ValueAndUnit).UNITMODE_PIXEL) height = Math.max(height, value.min.value);
                        if (value.max !== undefined && value.max.unit === (0, $dKQam.ValueAndUnit).UNITMODE_PIXEL) height = Math.min(height, value.max.value);
                        availableHeight -= height;
                        heights[index] = height;
                        break;
                    }
            }
            index++;
        }
        let top = 0;
        index = 0;
        for (const value of this._rowDefinitions){
            tops.push(top);
            switch($3697efa5ae3db110$export$bfb43f9757af6cd1.GetDefinitionType(value)){
                case $3697efa5ae3db110$export$4a9dbab3c849a99.Percentage:
                    {
                        let height = value.value / globalHeightPercentage * availableHeight;
                        top += height;
                        heights[index] = height;
                        break;
                    }
                case $3697efa5ae3db110$export$4a9dbab3c849a99.Pixel:
                    top += value.getValue(this._host);
                    break;
                case $3697efa5ae3db110$export$4a9dbab3c849a99.Auto:
                    {
                        let height = this.GetChildrenDimension(index, "rows");
                        if (value.min !== undefined && value.min.unit === (0, $dKQam.ValueAndUnit).UNITMODE_PIXEL) height = Math.max(height, value.min.value);
                        if (value.max !== undefined && value.max.unit === (0, $dKQam.ValueAndUnit).UNITMODE_PIXEL) height = Math.min(height, value.max.value);
                        top += height;
                        heights[index] = height;
                        break;
                    }
            }
            index++;
        }
        // Widths
        index = 0;
        for (const value of this._columnDefinitions){
            switch($3697efa5ae3db110$export$bfb43f9757af6cd1.GetDefinitionType(value)){
                case $3697efa5ae3db110$export$4a9dbab3c849a99.Percentage:
                    globalWidthPercentage += value.value;
                    break;
                case $3697efa5ae3db110$export$4a9dbab3c849a99.Pixel:
                    {
                        const width = value.getValue(this._host);
                        availableWidth -= width;
                        widths[index] = width;
                        break;
                    }
                case $3697efa5ae3db110$export$4a9dbab3c849a99.Auto:
                    {
                        let width = this.GetChildrenDimension(index, "columns");
                        if (value.min !== undefined && value.min.unit === (0, $dKQam.ValueAndUnit).UNITMODE_PIXEL) width = Math.max(width, value.min.value);
                        if (value.max !== undefined && value.max.unit === (0, $dKQam.ValueAndUnit).UNITMODE_PIXEL) width = Math.min(width, value.max.value);
                        availableWidth -= width;
                        widths[index] = width;
                        break;
                    }
            }
            index++;
        }
        let left = 0;
        index = 0;
        for (const value of this._columnDefinitions){
            lefts.push(left);
            switch($3697efa5ae3db110$export$bfb43f9757af6cd1.GetDefinitionType(value)){
                case $3697efa5ae3db110$export$4a9dbab3c849a99.Percentage:
                    {
                        const width = value.value / globalWidthPercentage * availableWidth;
                        left += width;
                        widths[index] = width;
                        break;
                    }
                case $3697efa5ae3db110$export$4a9dbab3c849a99.Pixel:
                    left += value.getValue(this._host);
                    break;
                case $3697efa5ae3db110$export$4a9dbab3c849a99.Auto:
                    {
                        let width = this.GetChildrenDimension(index, "columns");
                        if (value.min !== undefined && value.min.unit === (0, $dKQam.ValueAndUnit).UNITMODE_PIXEL) width = Math.max(width, value.min.value);
                        if (value.max !== undefined && value.max.unit === (0, $dKQam.ValueAndUnit).UNITMODE_PIXEL) width = Math.min(width, value.max.value);
                        left += width;
                        widths[index] = width;
                    }
            }
            index++;
        }
        definitionCallback(lefts, tops, widths, heights);
    }
    _additionalProcessing(parentMeasure, context) {
        this._getGridDefinitions((lefts, tops, widths, heights)=>{
            // Setting child sizes
            for(const key in this._cells){
                if (!this._cells.hasOwnProperty(key)) continue;
                let split = key.split(":");
                let rows = split[0].split("-");
                let columns = split[1].split("-");
                const rowStart = parseInt(rows[0]);
                const rowEnd = parseInt(rows[1]);
                const columnStart = parseInt(columns[0]);
                const columnEnd = parseInt(columns[1]);
                let cell = this._cells[key];
                let height = 0;
                for(let i = rowStart; i <= rowEnd; i++)height += heights[i];
                let width = 0;
                for(let i = columnStart; i <= columnEnd; i++)width += widths[i];
                cell.left = lefts[columnStart] + "px";
                cell.top = tops[rowStart] + "px";
                cell.width = width + "px";
                cell.height = height + "px";
                cell._left.ignoreAdaptiveScaling = true;
                cell._top.ignoreAdaptiveScaling = true;
                cell._width.ignoreAdaptiveScaling = true;
                cell._height.ignoreAdaptiveScaling = true;
            }
        });
        super._additionalProcessing(parentMeasure, context);
    }
    _flagDescendantsAsMatrixDirty() {
        for(var key in this._cells){
            if (!this._cells.hasOwnProperty(key)) continue;
            let child = this._cells[key];
            child._markMatrixAsDirty();
        }
    }
    _renderHighlightSpecific(context) {
        super._renderHighlightSpecific(context);
        this._getGridDefinitions((lefts, tops, widths, heights)=>{
            // Columns
            for(var index = 0; index < lefts.length; index++){
                const left = this._currentMeasure.left + lefts[index] + widths[index];
                context.beginPath();
                context.moveTo(left, this._currentMeasure.top);
                context.lineTo(left, this._currentMeasure.top + this._currentMeasure.height);
                context.stroke();
            }
            // Rows
            for(var index = 0; index < tops.length; index++){
                const top = this._currentMeasure.top + tops[index] + heights[index];
                context.beginPath();
                context.moveTo(this._currentMeasure.left, top);
                context.lineTo(this._currentMeasure.left + this._currentMeasure.width, top);
                context.stroke();
            }
        });
        context.restore();
    }
    /** Releases associated resources */ dispose() {
        super.dispose();
        for (var control of this._childControls)control.dispose();
        this._childControls = [];
    }
    static GetDefinitionType(value) {
        if (value.isPercentage) return $3697efa5ae3db110$export$4a9dbab3c849a99.Percentage;
        if (value.isPixel) return $3697efa5ae3db110$export$4a9dbab3c849a99.Pixel;
        return $3697efa5ae3db110$export$4a9dbab3c849a99.Auto;
    }
    GetChildrenDimension(index, dimension) {
        const children = [];
        const length = dimension === "rows" ? this._columnDefinitions.length : this._rowDefinitions.length;
        const getChildren = (i, j)=>{
            if (dimension === "rows") return this.getChildrenAt(index, i, 1, j);
            return this.getChildrenAt(i, index, j, 1);
        };
        const getSize = (control)=>{
            if (dimension === "rows") {
                // console.log("height", control.heightInPixels, control._currentMeasure.height, control._height, control._height.value, control._height.unit);
                if (control.heightInPixels !== 0) return control.heightInPixels;
                control._measure();
                return control._currentMeasure.height;
            }
            // console.log("width", control.widthInPixels, control._currentMeasure.width, control._width.value, control._width.unit);
            if (control.widthInPixels !== 0) return control.widthInPixels;
            control._measure();
            return control._currentMeasure.width;
        };
        for(let i = 0; i < length; i++)for(let j = 1; j <= length - i; j++)for (const child of getChildren(i, j) ?? [])if (!children.includes(child)) children.push(child);
        return children.map(getSize).reduce((p, c)=>p = Math.max(p, c), 0);
    }
}

});
parcelRegister("aNyYk", function(module, exports) {

$parcel$export(module.exports, "SimpleContainer3D", () => $7dc99bb51ed880eb$export$cd99cc02a0e9d9eb);

var $esuuG = parcelRequire("esuuG");
class $7dc99bb51ed880eb$export$cd99cc02a0e9d9eb extends (0, $esuuG.Container) {
    _draw(context, invalidatedRectangle) {
        for (const child of this._children){
            // Only redraw parts of the screen that are invalidated
            if (invalidatedRectangle) {
                if (!child._intersectsRect(invalidatedRectangle)) continue;
            }
            child._render(context, invalidatedRectangle);
        }
    }
}

});



parcelRegister("c2ImX", function(module, exports) {

var $diGQf = parcelRequire("diGQf");

var $esuuG = parcelRequire("esuuG");

var $jWkcb = parcelRequire("jWkcb");

var $3A4pp = parcelRequire("3A4pp");

var $c0RhK = parcelRequire("c0RhK");

var $7uWAj = parcelRequire("7uWAj");

var $63ju2 = parcelRequire("63ju2");
class $8c4816c0034529e7$export$ec8540225d9cc6a2 extends (0, $esuuG.Container) {
    constructor(name, layout, data){
        super(name);
        this.data = data;
        this.currentState = (0, $7uWAj.SelectorItemState).Normal;
        this.onClickObservable = new (0, $diGQf.Observable)();
        const createImage = (postfix)=>{
            return new (0, $c0RhK.Image3D)(`${name}_${postfix}`);
        };
        this.images = {
            [(0, $7uWAj.SelectorItemState).Normal]: createImage("_normal"),
            [(0, $7uWAj.SelectorItemState).Selected]: createImage("_selected"),
            [(0, $7uWAj.SelectorItemState).Hover]: createImage("_hover")
        };
        this.changeLayout(layout);
        Object.values(this.images).forEach((image)=>{
            image.isVisible = false;
            image.isHitTestVisible = false;
            image.detectPointerOnOpaqueOnly = false;
            this.addControl(image);
        });
        this.images.Normal.isVisible = true;
        this.color = "transparent";
        this.onPointerEnterObservable.add(()=>{
            this.changeState((0, $7uWAj.SelectorItemState).Hover, [
                (0, $7uWAj.SelectorItemState).Selected
            ]);
        });
        this.onPointerOutObservable.add(()=>{
            this.changeState((0, $7uWAj.SelectorItemState).Normal, [
                (0, $7uWAj.SelectorItemState).Selected
            ]);
        });
        this.onPointerUpObservable.add(()=>{
            this.onClickObservable.notifyObservers(this);
        });
    }
    dispose() {
        super.dispose();
        this.onClickObservable.clear();
    }
    Select(isSelected) {
        this.changeState(isSelected ? (0, $7uWAj.SelectorItemState).Selected : (0, $7uWAj.SelectorItemState).Normal);
    }
    get state() {
        return this.currentState;
    }
    changeLayout(layout) {
        this.images.Normal.source = layout.normalImg || null;
        this.images.Selected.source = layout.selectedImg || null;
        this.images.Hover.source = layout.hoverImg || null;
    }
    changeState(newState, skipStates = []) {
        if (this.currentState === newState || skipStates.includes(this.currentState)) return;
        Object.keys(this.images).forEach((state)=>{
            this.images[state].isVisible = state === newState;
        });
        this.currentState = newState;
    }
    // This method is based on Button component
    // While being a container, the selector child behaves like a control.
    /** @hidden */ _processPicking(x, y, pi, type, pointerId, buttonIndex, deltaX, deltaY) {
        if (!this._isEnabled || !this.isHitTestVisible || !this.isVisible || this.notRenderable) return false;
        if (!super.contains(x, y)) return false;
        for(let index = this._children.length - 1; index >= 0; index--){
            const child = this._children[index];
            if (child.isEnabled && /*child.isHitTestVisible && */ child.isVisible && !child.notRenderable && child.contains(x, y)) {
                // console.log(`${child.name}`);
                this._processObservables(type, x, y, pi, pointerId, buttonIndex, deltaX, deltaY);
                return true;
            }
        }
        return false;
    }
}
class $8c4816c0034529e7$export$8f3b0bd5ebece12e extends $8c4816c0034529e7$export$ec8540225d9cc6a2 {
    constructor(name, params){
        super(name, params.imageLayout);
        this.onStateChange = (state)=>{
            let style;
            if (state === (0, $7uWAj.SelectorItemState).Normal) style = this.textLayout.normal;
            else if (state === (0, $7uWAj.SelectorItemState).Selected) style = this.textLayout.selected;
            else if (state === (0, $7uWAj.SelectorItemState).Hover) style = this.textLayout.hover;
            else {
                console.error(`Unknown state: ${state}`);
                return;
            }
            // if(style.color)
            //     this.textBlock.color = style.color;
            // if(style.fontSize)
            //     this.textBlock.fontSize = style.fontSize;
            // if(style.fontWeight)
            //     this.textBlock.fontWeight = style.fontWeight;
            (0, $3A4pp.FontUtils).setTextBlockStyle(this.textBlock, style);
        };
        this.textLayout = params.textLayout;
        this.textBlock = (0, $63ju2.ObjectBuilder).createTextBlock3D(undefined, `${name}_text`, params.text, params.textLayout.normal);
        this.changeTextLayout(params.textLayout);
        this.addControl(this.textBlock);
        this.text = params.text;
    }
    changeTextLayout(textLayout) {
        this.textLayout = textLayout;
        this.onStateChange(this.state);
    }
    set text(value) {
        this.textBlock.text = value ? value : "";
    }
    get text() {
        return this.textBlock.text;
    }
}
class $8c4816c0034529e7$export$d15f4cd5286f9b1e extends (0, $jWkcb.StackPanel) {
    get sizeToFit() {
        return this._sizeToFit;
    }
    get selectedItem() {
        return this._selectedItem;
    }
    set selectedItem(item) {
        for (const c of this.children)if (c instanceof $8c4816c0034529e7$export$ec8540225d9cc6a2 && c != item) c.Select(false);
        if (item !== null) item.Select(true);
        this._selectedIndex = item !== null ? this.children.indexOf(item) : -1;
        this.onSelectionObservable.notifyObservers({
            sender: this,
            selectedItem: item,
            selectedIndex: this._selectedIndex,
            data: item !== null ? item.data : null
        });
    }
    get selectedIndex() {
        return this._selectedIndex;
    }
    set sizeToFit(value) {
        if (value === this._sizeToFit) return;
        this._sizeToFit = value;
        if (this.isVertical) this.heightInPixels = this.paddingTopInPixels + this.paddingBottomInPixels;
        else this.widthInPixels = this.paddingLeftInPixels + this.paddingRightInPixels;
        for (const child of this.children)if (this.isVertical) this.heightInPixels += child.heightInPixels;
        else this.widthInPixels += child.widthInPixels;
    }
    constructor(name){
        super(name);
        this._sizeToFit = false;
        this._selectedItem = null;
        this._selectedIndex = -1;
        this.onSelectionObservable = new (0, $diGQf.Observable)();
    }
    addControl(control) {
        let shouldSelect = true;
        if (this.children.some((x)=>x instanceof $8c4816c0034529e7$export$ec8540225d9cc6a2)) shouldSelect = false;
        super.addControl(control);
        if (control instanceof $8c4816c0034529e7$export$ec8540225d9cc6a2) {
            control.onClickObservable.add((e)=>{
                this.selectedItem = e;
            });
            if (shouldSelect) this.selectedItem = control;
        }
        if (this._sizeToFit) {
            if (this.isVertical) this.heightInPixels += control.heightInPixels;
            else this.widthInPixels += control.widthInPixels;
        }
        return this;
    }
}

});
parcelRegister("jWkcb", function(module, exports) {

$parcel$export(module.exports, "StackPanel", () => $e843197f5ed510f4$export$5296435ac66bdd7);

var $e0Suo = parcelRequire("e0Suo");

var $esuuG = parcelRequire("esuuG");

var $fCNdl = parcelRequire("fCNdl");

var $8DoUR = parcelRequire("8DoUR");

var $ir0rz = parcelRequire("ir0rz");

var $kVtWi = parcelRequire("kVtWi");
class $e843197f5ed510f4$export$5296435ac66bdd7 extends (0, $esuuG.Container) {
    /** Gets or sets a boolean indicating if the stack panel is vertical or horizontal*/ get isVertical() {
        return this._isVertical;
    }
    set isVertical(value) {
        if (this._isVertical === value) return;
        this._isVertical = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets the spacing (in pixels) between each child.
     */ get spacing() {
        return this._spacing;
    }
    set spacing(value) {
        if (this._spacing === value) return;
        this._spacing = value;
        this._markAsDirty();
    }
    /**
     * Gets or sets panel width.
     * This value should not be set when in horizontal mode as it will be computed automatically
     */ set width(value) {
        if (!this._doNotTrackManualChanges) this._manualWidth = true;
        if (this._width.toString(this._host) === value) return;
        if (this._width.fromString(value)) this._markAsDirty();
    }
    get width() {
        return this._width.toString(this._host);
    }
    /**
     * Gets or sets panel height.
     * This value should not be set when in vertical mode as it will be computed automatically
     */ set height(value) {
        if (!this._doNotTrackManualChanges) this._manualHeight = true;
        if (this._height.toString(this._host) === value) return;
        if (this._height.fromString(value)) this._markAsDirty();
    }
    get height() {
        return this._height.toString(this._host);
    }
    /**
     * Creates a new StackPanel
     * @param name defines control name
     */ constructor(name){
        super(name);
        this.name = name;
        this._isVertical = true;
        this._manualWidth = false;
        this._manualHeight = false;
        this._doNotTrackManualChanges = false;
        this._spacing = 0;
        /**
         * Gets or sets a boolean indicating that layout warnings should be ignored
         */ this.ignoreLayoutWarnings = false;
    }
    _getTypeName() {
        return "StackPanel";
    }
    /**
     * @internal
     */ _preMeasure(parentMeasure, context) {
        for (const child of this._children)if (this._isVertical) child.verticalAlignment = (0, $fCNdl.Control).VERTICAL_ALIGNMENT_TOP;
        else child.horizontalAlignment = (0, $fCNdl.Control).HORIZONTAL_ALIGNMENT_LEFT;
        super._preMeasure(parentMeasure, context);
    }
    _additionalProcessing(parentMeasure, context) {
        super._additionalProcessing(parentMeasure, context);
        this._measureForChildren.copyFrom(parentMeasure);
        this._measureForChildren.left = this._currentMeasure.left;
        this._measureForChildren.top = this._currentMeasure.top;
        if (!this.isVertical || this._manualWidth) this._measureForChildren.width = this._currentMeasure.width;
        if (this.isVertical || this._manualHeight) this._measureForChildren.height = this._currentMeasure.height;
    }
    _postMeasure() {
        let stackWidth = 0;
        let stackHeight = 0;
        const childrenCount = this._children.length;
        for(let index = 0; index < childrenCount; index++){
            const child = this._children[index];
            if (!child.isVisible || child.notRenderable) continue;
            if (this._isVertical) {
                if (child.top !== stackHeight + "px") {
                    child.top = stackHeight + "px";
                    this._rebuildLayout = true;
                    child._top.ignoreAdaptiveScaling = true;
                }
                if (!this.ignoreLayoutWarnings && !child.isDimensionFullyDefined("height")) (0, $kVtWi.Logger).Warn(`Control (Name:${child.name}, UniqueId:${child.uniqueId}) is using height in percentage mode inside a vertical StackPanel`, 1);
                else stackHeight += child._currentMeasure.height + child._paddingTopInPixels + child._paddingBottomInPixels + (index < childrenCount - 1 ? this._spacing : 0);
            } else {
                if (child.left !== stackWidth + "px") {
                    child.left = stackWidth + "px";
                    this._rebuildLayout = true;
                    child._left.ignoreAdaptiveScaling = true;
                }
                if (!this.ignoreLayoutWarnings && !child.isDimensionFullyDefined("width")) (0, $kVtWi.Logger).Warn(`Control (Name:${child.name}, UniqueId:${child.uniqueId}) is using width in percentage mode inside a horizontal StackPanel`, 1);
                else stackWidth += child._currentMeasure.width + child._paddingLeftInPixels + child._paddingRightInPixels + (index < childrenCount - 1 ? this._spacing : 0);
            }
        }
        stackWidth += this._paddingLeftInPixels + this._paddingRightInPixels;
        stackHeight += this._paddingTopInPixels + this._paddingBottomInPixels;
        this._doNotTrackManualChanges = true;
        // Let stack panel width or height default to stackHeight and stackWidth if dimensions are not specified.
        // User can now define their own height and width for stack panel.
        let panelWidthChanged = false;
        let panelHeightChanged = false;
        if ((!this._manualHeight || this.adaptHeightToChildren) && this._isVertical) {
            // do not specify height if strictly defined by user
            const previousHeight = this.height;
            this.height = stackHeight + "px";
            panelHeightChanged = previousHeight !== this.height || !this._height.ignoreAdaptiveScaling;
        }
        if ((!this._manualWidth || this.adaptWidthToChildren) && !this._isVertical) {
            // do not specify width if strictly defined by user
            const previousWidth = this.width;
            this.width = stackWidth + "px";
            panelWidthChanged = previousWidth !== this.width || !this._width.ignoreAdaptiveScaling;
        }
        if (panelHeightChanged) this._height.ignoreAdaptiveScaling = true;
        if (panelWidthChanged) this._width.ignoreAdaptiveScaling = true;
        this._doNotTrackManualChanges = false;
        if (panelWidthChanged || panelHeightChanged) this._rebuildLayout = true;
        super._postMeasure();
    }
    _getManualDim(dim) {
        if (dim === "width") return this._manualWidth;
        else return this._manualHeight;
    }
    isDimensionFullyDefined(dim) {
        if (dim === "height" ? this.isVertical : !this.isVertical && !this._getManualDim(dim)) {
            for (const child of this._children){
                if (!child.isDimensionFullyDefined(dim)) return false;
            }
            return true;
        }
        return this.getDimension(dim).isPixel || this._getAdaptDimTo(dim);
    }
    /**
     * Serializes the current control
     * @param serializationObject defined the JSON serialized object
     * @param force force serialization even if isSerializable === false
     */ serialize(serializationObject, force) {
        super.serialize(serializationObject, force);
        if (!this.isSerializable && !force) return;
        serializationObject.manualWidth = this._manualWidth;
        serializationObject.manualHeight = this._manualHeight;
    }
    /**
     * @internal
     */ _parseFromContent(serializedObject, host) {
        this._manualWidth = serializedObject.manualWidth;
        this._manualHeight = serializedObject.manualHeight;
        super._parseFromContent(serializedObject, host);
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e843197f5ed510f4$export$5296435ac66bdd7.prototype, "ignoreLayoutWarnings", void 0);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e843197f5ed510f4$export$5296435ac66bdd7.prototype, "isVertical", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e843197f5ed510f4$export$5296435ac66bdd7.prototype, "spacing", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e843197f5ed510f4$export$5296435ac66bdd7.prototype, "width", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $e843197f5ed510f4$export$5296435ac66bdd7.prototype, "height", null);
(0, $8DoUR.RegisterClass)("BABYLON.GUI.StackPanel", $e843197f5ed510f4$export$5296435ac66bdd7);

});


parcelRegister("l5cba", function(module, exports) {

var $4GBc6 = parcelRequire("4GBc6");
function $f5938320e51aeffb$var$isAutoDefinition(definition) {
    return definition === "auto";
}
function $f5938320e51aeffb$var$isComplexDefinition(definition) {
    return definition["value"] !== undefined;
}
function $f5938320e51aeffb$var$isPercentageDefinition(definition) {
    return !$f5938320e51aeffb$var$isComplexDefinition(definition) && /[\d\.]+\*/.test(definition);
}
function $f5938320e51aeffb$var$isPixelDefinition(definition) {
    return !$f5938320e51aeffb$var$isComplexDefinition(definition) && /\d+px/.test(definition);
}
function $f5938320e51aeffb$var$isMeterDefinition(definition) {
    return !$f5938320e51aeffb$var$isComplexDefinition(definition) && /[\d\.]+m/.test(definition);
}
class $f5938320e51aeffb$export$8f789b4fa09af621 {
    static CreateGrid(name, gridLayout, mesh) {
        const grid = new (0, $4GBc6.Grid3D)(name);
        for (const row of gridLayout.rows)grid.addRowDefinition(this.GetValue(row, mesh), this.GetType(row), this.GetOptionalValue(row, "min", mesh), this.GetOptionalValue(row, "max", mesh));
        for (const column of gridLayout.columns)grid.addColumnDefinition(this.GetValue(column, mesh), this.GetType(column), this.GetOptionalValue(column, "min", mesh), this.GetOptionalValue(column, "max", mesh));
        return grid;
    }
    static GetOptionalValue(definition, kind, mesh) {
        if (!$f5938320e51aeffb$var$isComplexDefinition(definition)) return undefined;
        if (kind === "min" && definition.minValue === undefined || kind === "max" && definition.maxValue === undefined) return undefined;
        return {
            value: this.GetValue(kind === "max" ? definition.maxValue : definition.minValue, mesh),
            unit: this.GetType(kind === "max" ? definition.maxValue : definition.minValue)
        };
    }
    static GetValue(definition, mesh) {
        if ($f5938320e51aeffb$var$isAutoDefinition(definition)) return 0;
        if ($f5938320e51aeffb$var$isPercentageDefinition(definition)) return Number.parseFloat(definition.substring(0, definition.length - 1));
        if ($f5938320e51aeffb$var$isMeterDefinition(definition)) return mesh?.m2px(Number.parseFloat(definition.substring(0, definition.length - 1))) ?? 0;
        if ($f5938320e51aeffb$var$isPixelDefinition(definition)) //@ts-ignore
        return Number.parseInt(definition.substring(0, definition.length - 2));
        return 0;
    }
    static GetType(definition) {
        if ($f5938320e51aeffb$var$isComplexDefinition(definition)) return this.GetType(definition.value);
        if ($f5938320e51aeffb$var$isAutoDefinition(definition)) return (0, $4GBc6.DefinitionType).Auto;
        if ($f5938320e51aeffb$var$isPercentageDefinition(definition)) return (0, $4GBc6.DefinitionType).Percentage;
        return (0, $4GBc6.DefinitionType).Pixel;
    }
}

});

parcelRegister("6EBLR", function(module, exports) {

var $d2Fyh = parcelRequire("d2Fyh");
class $4d83c70122c2246c$export$64e2a19345ec1ba4 {
    static createPlaneMesh(name, width, height, scene, parent, renderingGroupId, generateMipMaps = true, ppm = 2048) {
        const result = new (0, $d2Fyh.PlaneMesh)(name, width, height, scene, ppm, generateMipMaps);
        result.mesh.parent = parent;
        result.mesh.renderingGroupId = renderingGroupId;
        return result;
    }
    static setRenderingGroup(mesh, renderingGroupID) {
        mesh.renderingGroupId = renderingGroupID;
        mesh.getChildMeshes(false).forEach((child)=>{
            child.renderingGroupId = renderingGroupID;
        });
    }
    static hide(mesh2D) {
        mesh2D.isVisible = false;
        mesh2D.mesh.isPickable = false;
    }
    static show(mesh2D, params) {
        mesh2D.isVisible = true;
        mesh2D.mesh.isPickable = params === undefined || params.isPickable;
    }
    static isHidden(mesh2D) {
        return !mesh2D.mesh.isVisible;
    }
    static setVisibility(mesh2D, isVisible) {
        if (isVisible) $4d83c70122c2246c$export$64e2a19345ec1ba4.show(mesh2D);
        else $4d83c70122c2246c$export$64e2a19345ec1ba4.hide(mesh2D);
    }
}

});
parcelRegister("d2Fyh", function(module, exports) {

$parcel$export(module.exports, "PlaneMesh", () => $97ebb19d9d6d1a64$export$72842ea3df8e07e2);

var $ha1VO = parcelRequire("ha1VO");

var $dls1y = parcelRequire("dls1y");

var $gtixw = parcelRequire("gtixw");
class $97ebb19d9d6d1a64$export$72842ea3df8e07e2 extends (0, $gtixw.Mesh2D) {
    constructor(name, width, height, scene, ppm, generateMipMaps = true, meshData){
        super(name, width, height, scene, ppm, generateMipMaps, meshData);
        this.width = width;
        this.height = height;
        this.scene = scene;
        this.ppm = ppm;
        this.generateMipMaps = generateMipMaps;
        this._initialWidth = width;
        this._initialHeight = height;
    }
    createMesh(name, _meshData) {
        return (0, $dls1y.MeshBuilder).CreatePlane(name, {
            width: this.width,
            height: this.height
        }, this.scene);
    }
    /**
     * Resizes the mesh and recreates the texture.
     * @param width - new width.
     * @param height - new height.
     */ resize(width, height) {
        this.mesh.scaling = new (0, $ha1VO.Vector3)(width / this._initialWidth, height / this._initialHeight, 1.0);
        this.width = width;
        this.height = height;
        this.texture.dispose();
        this.texture = (0, $gtixw.Mesh2D)._createTexture(this.mesh, this.generateMipMaps, width * this.ppm, height * this.ppm, this.colorMultiplier);
    }
}

});


parcelRegister("83gFC", function(module, exports) {

$parcel$export(module.exports, "ImgToggleButton", () => $5dcb88e8be1e7eee$export$86a64a34577c4bef);

var $diGQf = parcelRequire("diGQf");

var $9m8ks = parcelRequire("9m8ks");

var $7uWAj = parcelRequire("7uWAj");

var $6rvpu = parcelRequire("6rvpu");
class $5dcb88e8be1e7eee$export$86a64a34577c4bef extends (0, $9m8ks.ImgButton) {
    get groupFilterRule() {
        return this._groupFilterRule;
    }
    set groupFilterRule(value) {
        if (this._groupFilterRule === value) return;
        this._groupFilterRule = value;
    }
    get allowEmptyGroup() {
        return this._allowEmptyGroup;
    }
    set allowEmptyGroup(value) {
        this._allowEmptyGroup = value;
    }
    get onIsToggledChangedObservable() {
        return this._onIsToggledChangedObservable;
    }
    get isToggled() {
        return this._isToggled;
    }
    set isToggled(value) {
        if (this._isToggled === value) return;
        const group = this.group === undefined ? undefined : $5dcb88e8be1e7eee$export$86a64a34577c4bef._groups.find((x)=>x.name === this.group);
        if (this.group === undefined || group !== undefined && (!this._isToggled || this._allowEmptyGroup)) {
            this._isToggled = value;
            this.updateState();
            if (group !== undefined && this._isToggled) for (const control of this.groupFilterRule(group, this)){
                control._isToggled = false;
                control.updateState();
                control._onIsToggledChangedObservable.notifyObservers(false);
            }
        }
        if (this._isToggled === value) this._onIsToggledChangedObservable.notifyObservers(this._isToggled);
    }
    get group() {
        return this._group;
    }
    set group(value) {
        if (this._group === value) return;
        if (value === undefined) {
            if ($5dcb88e8be1e7eee$export$86a64a34577c4bef._groups.some((x)=>x.name === this._group)) {
                const group = $5dcb88e8be1e7eee$export$86a64a34577c4bef._groups.find((x)=>x.name === this._group);
                group.controls.slice(group.controls.indexOf(this), 1);
                if (group.controls.length === 0) $5dcb88e8be1e7eee$export$86a64a34577c4bef._groups.slice($5dcb88e8be1e7eee$export$86a64a34577c4bef._groups.indexOf(group));
            }
        } else if (!$5dcb88e8be1e7eee$export$86a64a34577c4bef._groups.some((x)=>x.name === value)) $5dcb88e8be1e7eee$export$86a64a34577c4bef._groups.push({
            name: value,
            controls: [
                this
            ]
        });
        else {
            const group = $5dcb88e8be1e7eee$export$86a64a34577c4bef._groups.find((x)=>x.name === value);
            if (!group.controls.includes(this)) group.controls.push(this);
        }
        this._group = value;
    }
    constructor(name, imageLayout){
        super(name, imageLayout);
        this._isToggled = false;
        this._groupFilterRule = (group, control)=>group.controls.filter((x)=>x != control);
        this._allowEmptyGroup = false;
        this._onIsToggledChangedObservable = new (0, $diGQf.Observable)();
        if ((0, $7uWAj.isColorButtonLayout)(imageLayout)) {
            if (imageLayout.toggledState !== undefined) this.stateController.addState((0, $6rvpu.ControlState).Toggled, null);
            else if (imageLayout.pressedState !== undefined) this.stateController.addState((0, $6rvpu.ControlState).Toggled, null);
            if (imageLayout.toggledHoverState !== undefined) this.stateController.addState((0, $6rvpu.ControlState).ToggledHover, null);
            else if (imageLayout.pressedHoverState !== undefined) this.stateController.addState((0, $6rvpu.ControlState).ToggledHover, null);
            else if (imageLayout.pressedState !== undefined) this.stateController.addState((0, $6rvpu.ControlState).ToggledHover, null);
            if (imageLayout.toggledPressedState !== undefined) this.stateController.addState((0, $6rvpu.ControlState).ToggledPressed, null);
            else if (imageLayout.pressedState !== undefined) this.stateController.addState((0, $6rvpu.ControlState).ToggledPressed, null);
        } else {
            if (imageLayout.toggledImg !== undefined) this.stateController.addState((0, $6rvpu.ControlState).Toggled, null);
            else if (imageLayout.pressedImg) this.stateController.addState((0, $6rvpu.ControlState).Toggled, null);
            if (imageLayout.toggledHoverImg !== undefined) this.stateController.addState((0, $6rvpu.ControlState).ToggledHover, null);
            else if (imageLayout.pressedHoverImg !== undefined) this.stateController.addState((0, $6rvpu.ControlState).ToggledHover, null);
            else if (imageLayout.pressedImg !== undefined) this.stateController.addState((0, $6rvpu.ControlState).ToggledHover, null);
            if (imageLayout.toggledPressedImg !== undefined) this.stateController.addState((0, $6rvpu.ControlState).ToggledPressed, null);
            else if (imageLayout.pressedImg !== undefined) this.stateController.addState((0, $6rvpu.ControlState).ToggledPressed, null);
        }
    }
    _onUp() {
        if (this.isPointerDown) {
            this.isToggled = !this._isToggled;
            this.onClickObserver.notifyObservers(this);
        }
        this._isPointerDown = false;
        this.updateState();
    }
    updateState() {
        if (!this.isEnabled) this.stateController.changeState((0, $6rvpu.ControlState).Disabled);
        else if (this._isToggled) {
            if (this._isPointerOver) this.stateController.changeState(this._isPointerDown ? (0, $6rvpu.ControlState).ToggledPressed : (0, $6rvpu.ControlState).ToggledHover);
            else this.stateController.changeState((0, $6rvpu.ControlState).Toggled);
        } else if (this._isPointerOver) this.stateController.changeState(this._isPointerDown ? (0, $6rvpu.ControlState).Pressed : (0, $6rvpu.ControlState).Hover);
        else this.stateController.changeState((0, $6rvpu.ControlState).Normal);
    }
}
$5dcb88e8be1e7eee$export$86a64a34577c4bef._groups = [];

});

parcelRegister("1jQgt", function(module, exports) {

var $fCNdl = parcelRequire("fCNdl");

var $jWkcb = parcelRequire("jWkcb");
class $0f601b7644ba6279$export$2f3cc4b416f8710b extends (0, $jWkcb.StackPanel) {
    get childrenSpacing() {
        return this._childrenSpacing;
    }
    set childrenSpacing(value) {
        if (this._childrenSpacing === value) return;
        this._childrenSpacing = value;
        this._innerPanels.forEach((p)=>p.spacing = value);
    }
    /** Gets or sets a boolean indicating if the wrap panel is vertical or horizontal*/ get isVertical() {
        return super.isVertical;
    }
    set isVertical(value) {
        if (super.isVertical === value) return;
        super.isVertical = value;
        this._markAsDirty();
        for (const panel of this._innerPanels)panel.isVertical = !this.isVertical;
    }
    get verticalContentAlignment() {
        return this._verticalContentAlignment;
    }
    set verticalContentAlignment(value) {
        this._verticalContentAlignment = value;
        for (const panel of this._innerPanels)panel.verticalAlignment = value;
    }
    get horizontalContentAlignment() {
        return this._horizontalContentAlignment;
    }
    set horizontalContentAlignment(value) {
        this._horizontalContentAlignment = value;
        for (const panel of this._innerPanels)panel.horizontalAlignment = value;
    }
    constructor(name){
        super(name);
        this._innerPanels = [];
        this._verticalContentAlignment = (0, $fCNdl.Control).VERTICAL_ALIGNMENT_TOP;
        this._horizontalContentAlignment = (0, $fCNdl.Control).HORIZONTAL_ALIGNMENT_LEFT;
        this._childrenSpacing = 0;
    }
    addControl(control) {
        if (control === null) return this;
        let panel = this.getLastPanel(control.heightInPixels);
        if (this.isVertical) {
            if (panel.widthInPixels + (control.isVisible ? control.widthInPixels : 0) + this.childrenSpacing > this.widthInPixels) panel = this.addPanel(control.isVisible ? control.heightInPixels : 0);
        } else {
            if (panel.widthInPixels == 0) panel.widthInPixels = control.isVisible ? control.widthInPixels : 0;
            if (panel.heightInPixels + (control.isVisible ? control.heightInPixels : 0) > this.heightInPixels) {
                panel = this.addPanel(control.heightInPixels);
                panel.widthInPixels = control.isVisible ? control.widthInPixels : 0;
                this.widthInPixels += panel.widthInPixels;
            }
        }
        panel.addControl(control);
        if (this.isVertical) panel.widthInPixels += (control.isVisible ? control.widthInPixels : 0) + this.childrenSpacing;
        else panel.heightInPixels += (control.isVisible ? control.heightInPixels : 0) + this.childrenSpacing;
        return this;
    }
    resizeToFit() {
        const allControls = this._innerPanels.map((x)=>x._children).reduce((a, v)=>a.concat(v));
        this.clearControls();
        for (const control of allControls)this.addControl(control);
    }
    removeControl(control) {
        this._markAsDirty();
        for (const panel of this._innerPanels)if (panel.containsControl(control)) {
            panel.removeControl(control);
            if (panel.children.length == 0) {
                this._innerPanels.splice(this._innerPanels.indexOf(panel), 1);
                super.removeControl(panel);
            }
            break;
        }
        return this;
    }
    clearControls() {
        const innerPanels = this._innerPanels.slice();
        for (const panel of innerPanels){
            const children = panel.children.slice();
            for (const control of children){
                panel.removeControl(control);
                if (panel.children.length == 0) {
                    this._innerPanels.splice(this._innerPanels.indexOf(panel), 1);
                    super.removeControl(panel);
                }
            }
        }
        return this;
    }
    addPanel(height) {
        const panel = new (0, $jWkcb.StackPanel)(`${this.name}Inner${this._innerPanels.length}`);
        panel.isVertical = !this.isVertical;
        panel.verticalAlignment = this.verticalContentAlignment;
        panel.horizontalAlignment = this.horizontalContentAlignment;
        panel.heightInPixels = height;
        panel.spacing = this._childrenSpacing;
        this._innerPanels.push(panel);
        super.addControl(panel);
        return panel;
    }
    getLastPanel(height) {
        if (this._innerPanels.length === 0) return this.addPanel(height);
        return this._innerPanels[this._innerPanels.length - 1];
    }
}

});

parcelRegister("kXRIX", function(module, exports) {

$parcel$export(module.exports, "Input3D", () => $f432fdd09e4b50da$export$35085db314e4d5c2);

var $diGQf = parcelRequire("diGQf");

var $esuuG = parcelRequire("esuuG");

var $fCNdl = parcelRequire("fCNdl");

var $8C3u9 = parcelRequire("8C3u9");

var $i0Jb4 = parcelRequire("i0Jb4");

var $PPcK8 = parcelRequire("PPcK8");

var $6rvpu = parcelRequire("6rvpu");

var $63ju2 = parcelRequire("63ju2");

var $fYuWo = parcelRequire("fYuWo");
class $f432fdd09e4b50da$export$35085db314e4d5c2 extends (0, $esuuG.Container) {
    //#endregion
    //#region Properties
    get textBlock() {
        return this._textBlock;
    }
    get placeholderTextBlock() {
        return this._placeholderTextBlock;
    }
    get cursor() {
        return this._cursor;
    }
    get backgroundRect() {
        return this._backgroundRect;
    }
    get onFocusObservable() {
        return this._onFocusObservable;
    }
    get onBlurObservable() {
        return this._onBlurObservable;
    }
    get onTextChangedObservable() {
        return this._onTextChangedObservable;
    }
    get text() {
        return this._text;
    }
    get isFocused() {
        return this.stateController.state === "focused";
    }
    set text(value) {
        if (value === this._text) return;
        if (this._maxSymbols !== undefined && this._maxSymbols < value.length) return;
        this._text = value;
        this._textBlock.text = value;
        this._placeholderTextBlock.text = this._placeholder;
        this._placeholderTextBlock.isVisible = this._text.length === 0;
        this._textBlock.isVisible = this._text.length !== 0;
    }
    get hiddenText() {
        return this._hiddenText;
    }
    get isPassword() {
        return this._isPassword;
    }
    set isPassword(value) {
        if (this._isPassword === value) return;
        this._isPassword = value;
        this.textBlock.maskSymbol = value ? this._passwordMaskSymbol : undefined;
        this.textBlock.markAsDirty();
    }
    get passwordMaskSymbol() {
        return this._passwordMaskSymbol;
    }
    set passwordMaskSymbol(value) {
        this._passwordMaskSymbol = value;
    }
    get placeholder() {
        return this._placeholder;
    }
    set placeholder(value) {
        if (value === this._placeholder) return;
        this._placeholder = value;
        this._placeholderTextBlock.text = this._placeholder;
        this._placeholderTextBlock.isVisible = this._text.length === 0;
        this._textBlock.isVisible = this._text.length !== 0;
    }
    get isCursorEnabled() {
        return this._isCursorEnabled;
    }
    set isCursorEnabled(value) {
        if (value === this._isCursorEnabled) return;
        this._isCursorEnabled = value;
        if (value) this._blinkingInterval = setInterval(()=>{
            this._cursor.isVisible = !this._cursor.isVisible;
        }, 500);
        else {
            clearInterval(this._blinkingInterval);
            this._cursor.isVisible = false;
        }
    }
    get maxLines() {
        return this._maxLines;
    }
    set maxLines(value) {
        this._maxLines = value;
    }
    get maxSymbols() {
        return this._maxSymbols;
    }
    set maxSymbols(value) {
        this._maxSymbols = value;
    }
    get contentPadding() {
        return {
            left: this._textBlockContainer.paddingLeftInPixels,
            top: this._textBlockContainer.paddingTopInPixels,
            right: this._textBlockContainer.paddingRightInPixels,
            bottom: this._textBlockContainer.paddingBottomInPixels
        };
    }
    set contentPadding(value) {
        const fullMeasure = (0, $PPcK8.RectangleMeasureUtils).getFullRectangleMeasure(value);
        if (fullMeasure.left !== undefined) this._textBlockContainer.paddingLeftInPixels = fullMeasure.left;
        if (fullMeasure.top !== undefined) this._textBlockContainer.paddingTopInPixels = fullMeasure.top;
        if (fullMeasure.right !== undefined) this._textBlockContainer.paddingRightInPixels = fullMeasure.right;
        if (fullMeasure.bottom !== undefined) this._textBlockContainer.paddingBottomInPixels = fullMeasure.bottom;
    }
    set isEnabled(value) {
        super.isEnabled = value;
        this.stateController.changeState(value ? (0, $6rvpu.ControlState).Normal : (0, $6rvpu.ControlState).Disabled);
    }
    //#endregion
    //#region Ctor
    constructor(name){
        super(name);
        this._text = "";
        this._hiddenText = "";
        this._isCursorEnabled = true;
        this._placeholder = "";
        this._isPassword = false;
        this._passwordMaskSymbol = "\u2022";
        this._connectedControls = [];
        this._onFocusObservable = new (0, $diGQf.Observable)();
        this._onBlurObservable = new (0, $diGQf.Observable)();
        this._onTextChangedObservable = new (0, $diGQf.Observable)();
        this._cursorPosition = {
            x: 0,
            y: 0
        };
        this._lines = [
            {
                text: "",
                width: 0
            }
        ];
        this._backgroundRect = new (0, $PPcK8.Rectangle3D)(`${name}BackgroundRect`);
        this._backgroundRect.isFocusInvisible = true;
        this.addControl(this._backgroundRect);
        this._textBlockContainer = new (0, $esuuG.Container)();
        this._textBlockContainer.isFocusInvisible = true;
        this._textBlockContainer.adaptHeightToChildren = true;
        this.addControl(this._textBlockContainer);
        this._textBlock = (0, $63ju2.ObjectBuilder).createTextBlock3D(undefined, `${name}InnerTextBlock`, "", {});
        this._textBlock.isFocusInvisible = true;
        this._textBlock.isVisible = false;
        this._textBlockContainer.addControl(this._textBlock);
        this._placeholderTextBlock = (0, $63ju2.ObjectBuilder).createTextBlock3D(undefined, `${name}InnerPlaceholderTextBlock`, "", {});
        this._placeholderTextBlock.isFocusInvisible = true;
        this._textBlockContainer.addControl(this._placeholderTextBlock);
        this._cursor = new (0, $PPcK8.Rectangle3D)(`${name}Cursor`);
        this._cursor.horizontalAlignment = (0, $fCNdl.Control).HORIZONTAL_ALIGNMENT_LEFT;
        this._cursor.verticalAlignment = (0, $fCNdl.Control).VERTICAL_ALIGNMENT_TOP;
        this.addControl(this._cursor);
        this._textBlock.onLinesReadyObservable.add((t)=>{
            if (this._maxLines !== undefined && t.lines.length > this._maxLines) {
                this.text = this.text.substring(0, this.text.length - 1);
                return;
            }
            this.updateCursorPositionPx(t.lines, false);
        });
        this._textBlock.onTextChangedObservable.add(()=>this.onTextChangedObservable.notifyObservers(this));
        this._blinkingInterval = setInterval(()=>{
            this._cursor.isVisible = !this._cursor.isVisible;
        }, 500);
        this._stateController = new (0, $fYuWo.StateController)(this);
    }
    changeStyle(style, common) {
        if (this.isCursorEnabled === (style?.isCursorEnabled ?? common?.isCursorEnabled)) return;
        if (style?.isCursorEnabled !== undefined) this.isCursorEnabled = style?.isCursorEnabled;
        else if (common?.isCursorEnabled !== undefined) this.isCursorEnabled = common?.isCursorEnabled;
    }
    get stateController() {
        return this._stateController;
    }
    dispose() {
        this._textBlock.onTextChangedObservable.clear();
        this._textBlock.onLinesReadyObservable.clear();
        this._onFocusObservable.clear();
        this._onBlurObservable.clear();
        this._onTextChangedObservable.clear();
        super.dispose();
    }
    //#endregion
    //#region Methods
    focus() {
        this._host.moveFocusToControl(this);
    }
    blur() {
        this._host.focusedControl = null;
    }
    /** @hidden */ _onPointerDown(target, coordinates, pointerId, buttonIndex, pi) {
        if (!super._onPointerDown(target, coordinates, pointerId, buttonIndex, pi)) return false;
        if (!this.isEnabled) return false;
        this._host._capturingControl[pointerId] = this;
        this._host.focusedControl = this;
        const pos = this.getPositionFromCoordinates(this._textBlock.getLocalCoordinates(coordinates));
        if (this.updateCursorPositionY(pos.y) && this.updateCursorPositionX(pos.x)) this.updateCursorPositionPx(this._lines, true);
        return true;
    }
    /** @hidden */ _onPointerUp(target, coordinates, pointerId, buttonIndex, notifyClick) {
        delete this._host._capturingControl[pointerId];
        super._onPointerUp(target, coordinates, pointerId, buttonIndex, notifyClick);
    }
    /** @hidden */ onFocus() {
        this.stateController.changeState("focused");
        this._onFocusObservable.notifyObservers(this);
    }
    /** @hidden */ onBlur() {
        this.stateController.changeState((0, $6rvpu.ControlState).Normal);
        this._onBlurObservable.notifyObservers(this);
    }
    /** @hidden */ processKeyboard(evt) {
        this.processKey(evt.keyCode, evt.key, evt);
    }
    keepsFocusWith() {
        return this._connectedControls.length > 0 ? this._connectedControls : null;
    }
    /** @hidden */ processKey(keyCode, key, evt) {
        // //return if clipboard event keys (i.e -ctr/cmd + c,v,x)
        // if (evt && (evt.ctrlKey || evt.metaKey) && (keyCode === 67 || keyCode === 86 || keyCode === 88))
        // {
        //     return;
        // }
        // //select all
        // if (evt && (evt.ctrlKey || evt.metaKey) && keyCode === 65)
        // {
        //     this._selectAllText();
        //     evt.preventDefault();
        //     return;
        // }
        // Specific cases
        switch(keyCode){
            case 32:
                key = " "; //ie11 key for space is "Spacebar"
                break;
            case 191:
                if (evt) evt.preventDefault();
                break;
            case 8:
                // if (this._textWrapper.text && this._textWrapper.length > 0)
                if (this._text.length > 0) {
                    // //delete the highlighted text
                    // if (this._isTextHighlightOn)
                    // {
                    //     this._textWrapper.removePart(this._startHighlightIndex, this._endHighlightIndex);
                    //     this._textHasChanged();
                    //     this._isTextHighlightOn = false;
                    //     this._cursorOffset = this._textWrapper.length - this._startHighlightIndex;
                    //     this._blinkIsEven = false;
                    //     if (evt)
                    //     {
                    //         evt.preventDefault();
                    //     }
                    //     return;
                    // }
                    //delete single character
                    // if (this._cursorOffset === 0)
                    // {
                    // this.text = this._textWrapper.substr(0, this._textWrapper.length - 1);
                    // } else
                    // {
                    //     let deletePosition = this._textWrapper.length - this._cursorOffset;
                    //     if (deletePosition > 0)
                    //     {
                    //         this._textWrapper.removePart(deletePosition - 1, deletePosition);
                    //         this._textHasChanged();
                    //     }
                    // }
                    // this.text = this._text.substring(0, this._text.length - 1);
                    let delPos = 0;
                    for(let i = 0; i < this._cursorPosition.y; i++)delPos += this._lines[i].text.length + 1;
                    delPos += this._cursorPosition.x;
                    if (this._cursorPosition.y > 0 && this._cursorPosition.x === 0) this._nextAbsoluteCursorPosition = {
                        x: this._lines[this._cursorPosition.y - 1].text.length,
                        y: this._cursorPosition.y - 1
                    };
                    let charLength = 1;
                    for(let i = 0, j = 0; i < delPos; i++, j++)if ((0, $8C3u9.default)().test(this.textBlock.symbols[j])) {
                        i += this.textBlock.symbols[j].length - 1;
                        charLength = this.textBlock.symbols[j].length;
                    } else charLength = 1;
                    const adjustedDelPos = delPos - charLength;
                    this.text = this.removeChar(this.text, adjustedDelPos, charLength);
                }
                if (evt) evt.preventDefault();
                return;
            case 46:
                // if (this._isTextHighlightOn)
                // {
                //     this._textWrapper.removePart(this._startHighlightIndex, this._endHighlightIndex);
                //     this._textHasChanged();
                //     this._isTextHighlightOn = false;
                //     this._cursorOffset = this._textWrapper.length - this._startHighlightIndex;
                //     if (evt)
                //     {
                //         evt.preventDefault();
                //     }
                //     return;
                // }
                // if (this._textWrapper.text && this._textWrapper.length > 0 && this._cursorOffset > 0)
                // {
                //     let deletePosition = this._textWrapper.length - this._cursorOffset;
                //     this._textWrapper.removePart(deletePosition, deletePosition + 1);
                //     this._textHasChanged();
                //     this._cursorOffset--;
                // }
                // this.text = this._text.substring(0, this._text.length - 1);
                if (evt) evt.preventDefault();
                let delPos = 0;
                for(let i = 0; i < this._cursorPosition.y; i++)delPos += this._lines[i].text.length + 1;
                delPos += this._cursorPosition.x;
                let shouldUpdatePos = false;
                if (this._cursorPosition.y < this._lines.length - 1 && this._cursorPosition.x === this._lines[this._cursorPosition.y].text.length) this._nextAbsoluteCursorPosition = {
                    x: this._lines[this._cursorPosition.y].text.length,
                    y: this._cursorPosition.y
                };
                else shouldUpdatePos = true;
                this.text = this.removeChar(this.text, delPos);
                if (shouldUpdatePos) this.updateCursorPositionX(this._cursorPosition.x + 1);
                return;
            case 13:
                // this._host.focusedControl = null;
                // this._isTextHighlightOn = false;
                // return;
                key = "\n";
                break;
            case 35:
                if (this.updateCursorPositionY(this._lines.length - 1) && this.updateCursorPositionX(this._lines[this._cursorPosition.y].text.length)) this.updateCursorPositionPx(this._lines, true);
                return;
            //     this._cursorOffset = 0;
            //     this._blinkIsEven = false;
            //     this._isTextHighlightOn = false;
            //     this._markAsDirty();
            //     return;
            case 36:
                if (this.updateCursorPositionY(0) && this.updateCursorPositionX(0)) this.updateCursorPositionPx(this._lines, true);
                return;
            //     this._cursorOffset = this._textWrapper.length;
            //     this._blinkIsEven = false;
            //     this._isTextHighlightOn = false;
            //     this._markAsDirty();
            //     return;
            case 37:
                if (this.updateCursorPositionX(this._cursorPosition.x - 1)) this.updateCursorPositionPx(this._lines, true);
                break;
            case 38:
                if (this.updateCursorPositionY(this._cursorPosition.y - 1)) this.updateCursorPositionPx(this._lines, true);
                break;
            case 39:
                if (this.updateCursorPositionX(this._cursorPosition.x + 1)) this.updateCursorPositionPx(this._lines, true);
                break;
            case 40:
                if (this.updateCursorPositionY(this._cursorPosition.y + 1)) this.updateCursorPositionPx(this._lines, true);
                break;
        }
        // Printable characters
        if (key && (keyCode === -1 || // Direct access
        keyCode === 13 || // Return
        keyCode === 32 || // Space
        keyCode > 47 && keyCode < 64 || // Numbers
        keyCode > 64 && keyCode < 91 || // Letters
        keyCode > 159 && keyCode < 193 || // Special characters
        keyCode > 218 && keyCode < 223 || // Special characters
        keyCode > 95 && keyCode < 112)) // this._currentKey = key;
        // this.onBeforeKeyAddObservable.notifyObservers(this);
        // key = this._currentKey;
        // if (this._addKey)
        // {
        // if (this._isTextHighlightOn)
        // {
        //     this._textWrapper.removePart(this._startHighlightIndex, this._endHighlightIndex, key);
        //     this._textHasChanged();
        //     this._cursorOffset = this._textWrapper.length - (this._startHighlightIndex + 1);
        //     this._isTextHighlightOn = false;
        //     this._blinkIsEven = false;
        //     this._markAsDirty();
        // }
        // else if (this._cursorOffset === 0)
        // {
        //     this.text += key;
        // } else
        // {
        //     let insertPosition = this._textWrapper.length - this._cursorOffset;
        //     this._textWrapper.removePart(insertPosition, insertPosition, key);
        //     this._textHasChanged();
        // }
        // }
        this.addChar(key);
    }
    addChar(char) {
        const newLines = [];
        for(let i = 0; i < this._lines.length; i++)newLines.push(this._lines[i].text.slice());
        newLines[this._cursorPosition.y] = this.insertChar(newLines[this._cursorPosition.y], this._cursorPosition.x, char);
        this.text = newLines.join('\n');
    }
    connectControl(control) {
        if (!this._connectedControls.includes(control)) this._connectedControls.push(control);
    }
    disconnectControl(control) {
        if (this._connectedControls.includes(control)) this._connectedControls.splice(this._connectedControls.indexOf(control), 1);
    }
    updateCursorPositionX(value) {
        if (value <= this._lines[this._cursorPosition.y].text.length && value >= 0) {
            this._cursorPosition.x = value;
            return true;
        } else if (value < 0) {
            if (this._cursorPosition.y > 0) {
                if (this.updateCursorPositionY(this._cursorPosition.y - 1)) return this.updateCursorPositionX(this._lines[this._cursorPosition.y].text.length + value + 1);
                else return false;
            }
            return false;
        } else {
            if (this._cursorPosition.y < this._lines.length - 1) {
                if (this.updateCursorPositionY(this._cursorPosition.y + 1)) return this.updateCursorPositionX(value - this._cursorPosition.x - 1);
                else return false;
            }
            return false;
        }
    }
    updateCursorPositionY(value) {
        if (value >= 0 && value < this._lines.length) {
            this._cursorPosition.y = value;
            return true;
        }
        return false;
    }
    updateCursorPositionPx(lines, calledFromKeyEvent) {
        (0, $i0Jb4.ContextUtils).DoInContext(this.host.getContext(), {
            font: {
                fontSize: this._textBlock.fontSizeInPixels,
                fontFamily: this._textBlock.fontFamily,
                fontStyle: this._textBlock.fontStyle,
                fontWeight: this._textBlock.fontWeight
            }
        }, (context)=>{
            if (!this._fontOffset) this._fontOffset = (0, $fCNdl.Control)._GetFontOffset(context.font);
            if (this._nextAbsoluteCursorPosition !== undefined) {
                this._cursorPosition.x = this._nextAbsoluteCursorPosition.x;
                this._cursorPosition.y = this._nextAbsoluteCursorPosition.y;
                this._nextAbsoluteCursorPosition = undefined;
            } else {
                const yDiff = lines.length - this._lines.length;
                if (yDiff !== 0) {
                    this._cursorPosition.y += yDiff;
                    if (yDiff > 0) {
                        const totalDiff = lines.map((x)=>x.text).join('').length - this._lines.map((x)=>x.text).join('').length;
                        this._cursorPosition.x = this._cursorPosition.x + totalDiff - lines[this._cursorPosition.y - 1].text.length;
                    } else this._cursorPosition.x = lines[this._cursorPosition.y]?.text.length ?? 0;
                } else {
                    const xDiff = (lines[this._cursorPosition.y]?.text.length ?? 0) - (this._lines[this._cursorPosition.y]?.text.length ?? 0);
                    if (xDiff !== 0) this._cursorPosition.x += xDiff;
                }
            }
            const currentLine = (lines[this._cursorPosition.y]?.text ?? "").substring(0, this._cursorPosition.x);
            const width = context.measureText(this._getMaskedText(currentLine)).width;
            const fullMeasure = (0, $PPcK8.RectangleMeasureUtils).getFullRectangleMeasure(this.contentPadding);
            let rootX = fullMeasure.left ?? 0;
            switch(this.horizontalAlignment){
                case (0, $fCNdl.Control).HORIZONTAL_ALIGNMENT_RIGHT:
                    rootX = this._currentMeasure.width - width;
                    return;
                case (0, $fCNdl.Control).HORIZONTAL_ALIGNMENT_CENTER:
                    rootX = (this._currentMeasure.width - width) / 2;
            }
            this._cursor.leftInPixels = rootX + width;
            this._cursor.topInPixels = this._fontOffset.height * this._cursorPosition.y + (fullMeasure.top ?? 0);
            if (!calledFromKeyEvent) this._lines = lines;
        });
    }
    insertChar(str, index, stringToAdd) {
        return str.substring(0, index) + stringToAdd + str.substring(index, str.length);
    }
    removeChar(str, index, charLength = 1) {
        return str.substring(0, index) + str.substring(index + charLength, str.length);
    }
    getPositionFromCoordinates(coordinates) {
        const pos = {
            x: 0,
            y: 0
        };
        if (coordinates.y > 0) pos.y = Math.min(Math.floor(coordinates.y / this._fontOffset.height), this._lines.length - 1);
        if (coordinates.x > 0) (0, $i0Jb4.ContextUtils).DoInContext(this.host.getContext(), {
            font: {
                fontSize: this._textBlock.fontSizeInPixels,
                fontFamily: this._textBlock.fontFamily,
                fontStyle: this._textBlock.fontStyle,
                fontWeight: this._textBlock.fontWeight
            }
        }, (context)=>{
            if (coordinates.x > context.measureText(this._getMaskedText(this._lines[pos.y].text)).width) pos.x = this._lines[pos.y].text.length;
            else for(let i = 0; i < this._lines[pos.y].text.length; i++){
                const line = (this._lines[pos.y]?.text ?? "").substring(0, i);
                const width = context.measureText(this._getMaskedText(line)).width;
                pos.x = i;
                if (coordinates.x < width) break;
            }
        });
        return pos;
    }
    _getMaskedText(text) {
        return this.isPassword ? text.replaceAll(/./g, this._passwordMaskSymbol) : text;
    }
}

});

parcelRegister("833Wh", function(module, exports) {

$parcel$export(module.exports, "AdvancedFreeCameraTouchInput", () => $5dc1a8bc3715bd18$export$52587b9a1c1f656b);

var $29K1K = parcelRequire("29K1K");

var $cfkw4 = parcelRequire("cfkw4");

var $ha1VO = parcelRequire("ha1VO");

var $bOhSV = parcelRequire("bOhSV");
class $5dc1a8bc3715bd18$export$4ee70ab773570fb9 {
    get keys() {
        return this._keys;
    }
    get values() {
        return this._values;
    }
    constructor(){
        this._keys = [];
        this._values = [];
    }
    add(key, value) {
        if (!this._keys.includes(key)) {
            this._keys.push(key);
            this._values.push(value);
            return true;
        }
        return false;
    }
    addOrReplace(key, value) {
        if (!this.add(key, value)) {
            const idx = this._keys.indexOf(key);
            this._values[idx] = value;
        }
    }
    remove(key) {
        if (!this._keys.includes(key)) return false;
        const idx = this._keys.indexOf(key);
        this._keys.splice(idx, 1);
        this._values.splice(idx, 1);
        return true;
    }
    clear() {
        this._keys.length = 0;
        this._values.length = 0;
    }
    getValue(key) {
        if (this._keys.includes(key)) return this._values[this._keys.indexOf(key)];
        return null;
    }
    hasKey(key) {
        return this._keys.includes(key);
    }
    get length() {
        return this._keys.length;
    }
    equals(other) {
        if (this.length !== other.length) return false;
        for (const key of this._keys){
            if (!other.hasKey(key) || other.getValue(key) !== this.getValue(key)) return false;
        }
        return true;
    }
    keysEqual(other) {
        if (this.length !== other.length) return false;
        for (const key of this._keys){
            if (!other.hasKey(key)) return false;
        }
        return true;
    }
}
class $5dc1a8bc3715bd18$export$52587b9a1c1f656b {
    /**
     * Manage the touch inputs to control the movement of a free camera.
     * @see https://doc.babylonjs.com/how_to/customizing_camera_inputs
     * @param allowMouse Defines if mouse events can be treated as touch events
     */ constructor(params, allowMouse = false){
        this.allowMouse = allowMouse;
        this.moveXSensitivity = 250.0;
        this.moveYSensitivity = 250.0;
        this.zoomSensitivity = 250.0;
        this.rotationZSensitivity = 250.0;
        this.zoomEnabled = true;
        this.zoomMode = "scroll";
        this.rotationXEnabled = true;
        this.rotationYEnabled = true;
        this.rotationZEnabled = false;
        this.inverseMovementX = false;
        this.inverseMovementY = false;
        this.zoomMin = -5;
        this.zoomMax = 5;
        this.rotationXLimit = 180;
        this.rotationYLimit = 180;
        this.requireReleaseAfterZoom = false;
        this._wasReleased = true;
        this._previousPointers = new $5dc1a8bc3715bd18$export$4ee70ab773570fb9();
        this._currentPointers = new $5dc1a8bc3715bd18$export$4ee70ab773570fb9();
        this._observer = null;
        this._onLostFocus = null;
        if (params) {
            if (params.moveXSensitivity !== undefined) this.moveXSensitivity = params.moveXSensitivity;
            if (params.moveYSensitivity !== undefined) this.moveYSensitivity = params.moveYSensitivity;
            if (params.zoomSensitivity !== undefined) this.zoomSensitivity = params.zoomSensitivity;
            if (params.rotationZSensitivity !== undefined) this.rotationZSensitivity = params.rotationZSensitivity;
            if (params.zoomEnabled !== undefined) this.zoomEnabled = params.zoomEnabled;
            if (params.rotationXEnabled !== undefined) this.rotationXEnabled = params.rotationXEnabled;
            if (params.rotationYEnabled !== undefined) this.rotationYEnabled = params.rotationYEnabled;
            if (params.rotationZEnabled !== undefined) this.rotationZEnabled = params.rotationZEnabled;
            if (params.inverseMovementX !== undefined) this.inverseMovementX = params.inverseMovementX;
            if (params.inverseMovementY !== undefined) this.inverseMovementY = params.inverseMovementY;
            if (params.zoomMode !== undefined) this.zoomMode = params.zoomMode;
            if (params.zoomMin !== undefined) this.zoomMin = params.zoomMin;
            if (params.zoomMax !== undefined) this.zoomMax = params.zoomMax;
            if (params.rotationXLimit !== undefined) this.rotationXLimit = params.rotationXLimit;
            if (params.rotationYLimit !== undefined) this.rotationYLimit = params.rotationYLimit;
            if (params.requireReleaseAfterZoom !== undefined) this.requireReleaseAfterZoom = params.requireReleaseAfterZoom;
        }
    }
    _resetPointers() {
        this._previousPointers.clear();
        for (const key of this._currentPointers.keys)this._previousPointers.add(key, this._currentPointers.getValue(key));
    }
    _updatePointers(pointer) {
        if (this._currentPointers.hasKey(pointer)) this._previousPointers.addOrReplace(pointer, this._currentPointers.getValue(pointer));
        else this._previousPointers.remove(pointer);
    }
    /**
     * Attach the input controls to a specific dom element to get the input from.
     * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
     */ attachControl(noPreventDefault) {
        noPreventDefault = (0, $bOhSV.Tools).BackCompatCameraNoPreventDefault(arguments);
        if (this._pointerInput === undefined) {
            this._onLostFocus = ()=>{
                this._previousPointers.clear();
                this._currentPointers.clear();
            };
            let pointersChanged = false;
            const defaultPos = this.camera.position.clone();
            const defaultRot = this.camera.rotation.clone();
            this._pointerInput = (p)=>{
                var evt = p.event;
                let isMouseEvent = !this.camera.getEngine().hostInformation.isMobile && evt instanceof MouseEvent;
                if (!this.allowMouse && (evt.pointerType === "mouse" || isMouseEvent)) return;
                switch(p.type){
                    case (0, $cfkw4.PointerEventTypes).POINTERDOWN:
                        if (!noPreventDefault) evt.preventDefault();
                        this._updatePointers(evt.pointerId);
                        this._currentPointers.addOrReplace(evt.pointerId, new (0, $ha1VO.Vector2)(evt.clientX, evt.clientY));
                        pointersChanged = true;
                        if (this._currentPointers.length >= 2) this._wasReleased = false;
                        break;
                    case (0, $cfkw4.PointerEventTypes).POINTERUP:
                        if (!noPreventDefault) evt.preventDefault();
                        this._updatePointers(evt.pointerId);
                        this._currentPointers.remove(evt.pointerId);
                        pointersChanged = true;
                        if (this._currentPointers.length == 0) this._wasReleased = true;
                        break;
                    case (0, $cfkw4.PointerEventTypes).POINTERMOVE:
                        if (!noPreventDefault) evt.preventDefault();
                        if (pointersChanged) this._resetPointers();
                        else this._updatePointers(evt.pointerId);
                        this._currentPointers.addOrReplace(evt.pointerId, new (0, $ha1VO.Vector2)(evt.clientX, evt.clientY));
                        pointersChanged = false;
                        break;
                    case (0, $cfkw4.PointerEventTypes).POINTERDOUBLETAP:
                        if (!noPreventDefault) evt.preventDefault();
                        this.camera.position = defaultPos.clone();
                        this.camera.rotation = defaultRot.clone();
                }
            };
        }
        this._observer = this.camera.getScene().onPointerObservable.add(this._pointerInput, (0, $cfkw4.PointerEventTypes).POINTERDOWN | (0, $cfkw4.PointerEventTypes).POINTERUP | (0, $cfkw4.PointerEventTypes).POINTERMOVE | (0, $cfkw4.PointerEventTypes).POINTERDOUBLETAP);
        if (this._onLostFocus) {
            const engine = this.camera.getEngine();
            const element = engine.getInputElement();
            element && element.addEventListener("blur", this._onLostFocus);
        }
    }
    /**
     * Detach the current controls from the specified dom element.
     * @param ignored defines an ignored parameter kept for backward compatibility. If you want to define the source input element, you can set engine.inputElement before calling camera.attachControl
     */ detachControl(_ignored) {
        if (this._pointerInput) {
            if (this._observer) {
                this.camera.getScene().onPointerObservable.remove(this._observer);
                this._observer = null;
            }
            if (this._onLostFocus) {
                const engine = this.camera.getEngine();
                const element = engine.getInputElement();
                element && element.removeEventListener("blur", this._onLostFocus);
                this._onLostFocus = null;
            }
            this._currentPointers.clear();
            this._previousPointers.clear();
        }
    }
    _getQuadrant(p) {
        if (p.x >= 0 && p.y >= 0) return 1;
        if (p.x >= 0 && p.y < 0) return 2;
        if (p.x < 0 && p.y < 0) return 3;
        return 4;
    }
    _getRotationDirection(p1, p2) {
        if (p2 === p1) return "none";
        const q1 = this._getQuadrant(p1);
        const q2 = this._getQuadrant(p2);
        if (q1 === q2) switch(q1){
            case 1:
                if (p2.x > p1.x && p2.y < p1.y) return "clockwise";
                if (p2.x < p1.x && p2.y > p1.y) return "counterclockwise";
                break;
            case 2:
                if (p2.x < p1.x && p2.y < p1.y) return "clockwise";
                if (p2.x > p1.x && p2.y > p1.y) return "counterclockwise";
                break;
            case 3:
                if (p2.x < p1.x && p2.y > p1.y) return "clockwise";
                if (p2.x > p1.x && p2.y < p1.y) return "counterclockwise";
                break;
            case 4:
                if (p2.x > p1.x && p2.y > p1.y) return "clockwise";
                if (p2.x < p1.x && p2.y < p1.y) return "counterclockwise";
                break;
        }
        else {
            if (q1 === 4 && q2 === 1) return "clockwise";
            if (q1 === 1 && q2 === 4) return "counterclockwise";
            return q2 > q1 ? "clockwise" : "counterclockwise";
        }
        return "none";
    }
    zoom(value, isAbsolute = false) {
        const z = Math.min(Math.max(isAbsolute ? value : this.camera.position.z + value, this.zoomMin), this.zoomMax);
        this.camera.position.z = z;
    }
    /**
     * Update the current camera state depending on the inputs that have been used this frame.
     * This is a dynamically created lambda to avoid the performance penalty of looping for inputs in the render loop.
     */ checkInputs() {
        if (this._currentPointers.length === 0 && this._previousPointers.length === 0) return;
        if (this._currentPointers.equals(this._previousPointers)) return;
        var camera = this.camera;
        if (this._currentPointers.length === 1 && this._currentPointers.keysEqual(this._previousPointers) && (!this.requireReleaseAfterZoom || this.requireReleaseAfterZoom && this._wasReleased)) {
            const key = this._currentPointers.keys[0];
            const rotation = camera.rotation.clone();
            if (this.rotationXEnabled) {
                let offsetX = this._currentPointers.getValue(key).x - this._previousPointers.getValue(key).x;
                if (!this.inverseMovementX) offsetX *= -1;
                const limit = this.rotationXLimit / 2 / 180 * Math.PI;
                rotation.y = Math.max(Math.min(rotation.y + offsetX / this.moveXSensitivity, limit), -limit);
            }
            if (this.rotationYEnabled) {
                let offsetY = this._currentPointers.getValue(key).y - this._previousPointers.getValue(key).y;
                if (!this.inverseMovementY) offsetY *= -1;
                const limit = this.rotationYLimit / 2 / 180 * Math.PI;
                rotation.x = Math.max(Math.min(rotation.x + offsetY / this.moveYSensitivity, limit), -limit);
            }
            if (this.rotationXEnabled || this.rotationYEnabled) camera.rotation = rotation.clone();
        } else if (this._currentPointers.length === 2 && this._currentPointers.keysEqual(this._previousPointers)) {
            const key1 = this._currentPointers.keys[0];
            const key2 = this._currentPointers.keys[1];
            if (this.zoomEnabled) switch(this.zoomMode){
                case "pinch":
                    {
                        const current = this._currentPointers.getValue(key1).subtract(this._currentPointers.getValue(key2));
                        const previous = this._previousPointers.getValue(key1).subtract(this._previousPointers.getValue(key2));
                        const diff = current.lengthSquared() >= previous.lengthSquared() ? current.subtract(previous).length() : -previous.subtract(current).length();
                        this.zoom(diff / this.zoomSensitivity);
                        break;
                    }
                case "scroll":
                    {
                        const current = this._currentPointers.getValue(key1);
                        const previous = this._previousPointers.getValue(key1);
                        const diff = previous.y - current.y;
                        this.zoom(diff / this.zoomSensitivity);
                        break;
                    }
            }
            if (this.rotationZEnabled) {
                let c1 = this._currentPointers.getValue(key1);
                let c2 = this._currentPointers.getValue(key2);
                let p1 = this._previousPointers.getValue(key1);
                let p2 = this._previousPointers.getValue(key2);
                const ua = ((p2.x - p1.x) * (c1.y - p1.y) - (p2.y - p1.y) * (c1.x - p1.x)) / ((p2.y - p1.y) * (c2.x - c1.x) - (p2.x - p1.x) * (c2.y - c1.y));
                const intersection = new (0, $ha1VO.Vector2)(c1.x + ua * (c2.x - c1.x), c1.y + ua * (c2.y - c1.y));
                if (ua >= 0 && ua <= 1 && Number.isFinite(intersection.x) && Number.isFinite(intersection.y)) {
                    const dc1 = new (0, $ha1VO.Vector2)(c1.x - intersection.x, c1.y - intersection.y);
                    const dc2 = new (0, $ha1VO.Vector2)(c2.x - intersection.x, c2.y - intersection.y);
                    const dp1 = new (0, $ha1VO.Vector2)(p1.x - intersection.x, p1.y - intersection.y);
                    const dp2 = new (0, $ha1VO.Vector2)(p2.x - intersection.x, p2.y - intersection.y);
                    const rd1 = this._getRotationDirection(dc1, dp1);
                    const rd2 = this._getRotationDirection(dc2, dp2);
                    if (rd1 === rd2 || rd1 !== "none" && rd2 === "none" || rd1 === "none" && rd2 !== "none") {
                        const current = dc1.subtract(dc2);
                        const previous = dp1.subtract(dp2);
                        const dot = current.x * previous.x + current.y * previous.y;
                        const cos = dot / (current.length() * previous.length());
                        let angle = Math.acos(cos) * 180 / Math.PI;
                        if (rd1 === "counterclockwise" || rd2 === "counterclockwise") angle *= -1;
                        camera.rotation.z += angle / this.rotationZSensitivity;
                    }
                }
            }
        }
    }
    /**
     * Gets the class name of the current intput.
     * @returns the class name
     */ getClassName() {
        return "AdvancedFreeCameraTouchInput";
    }
    /**
     * Get the friendly name associated with the input class.
     * @returns the input friendly name
     */ getSimpleName() {
        return "touch";
    }
}
(0, $29K1K.CameraInputTypes)["AdvancedFreeCameraTouchInput"] = $5dc1a8bc3715bd18$export$52587b9a1c1f656b;

});

parcelRegister("cqnXm", function(module, exports) {

$parcel$export(module.exports, "Decorator", () => $90ba7efb7547a07a$export$a592b67c93d52467);
class $90ba7efb7547a07a$export$a592b67c93d52467 {
    constructor(decoratedControl, decorationFunc, decorationObservables){
        this._decoratedControl = decoratedControl;
        this._decorationFunc = decorationFunc;
        if (decorationObservables !== undefined) decorationObservables.forEach((o)=>o.add(()=>this.decorate()));
        else this._decoratedControl.onBeforeDrawObservable.add(()=>this.decorate());
    }
    decorate() {
        return this._decorationFunc !== undefined ? this._decorationFunc(this._decoratedControl) : undefined;
    }
}

});

parcelRegister("ikpol", function(module, exports) {

var $diGQf = parcelRequire("diGQf");

var $cqnXm = parcelRequire("cqnXm");
class $d57dca81fbb3d1c5$export$9eeb22c0bba4ed5e extends (0, $cqnXm.Decorator) {
    get onValidationObservable() {
        return this._onValidationObservable;
    }
    get validationResult() {
        return this._validationResult;
    }
    constructor(validatedControl, validationFunc, decorationObservables){
        super(validatedControl, validationFunc, decorationObservables);
        this._validationResult = undefined;
        this._onValidationObservable = new (0, $diGQf.Observable)();
    }
    decorate() {
        const result = super.decorate();
        this._onValidationObservable.notifyObservers(result);
        this._validationResult = result;
        return result;
    }
}

});

parcelRegister("1PQEn", function(module, exports) {

var $cqnXm = parcelRequire("cqnXm");
class $1563651d60cb4709$export$28c660c63b792dea extends (0, $cqnXm.Decorator) {
    constructor(tooltippedControl, tooltipFunc, tooltipControl, decorationObservables, tooltipPositionFunc){
        super(tooltippedControl, tooltipFunc, decorationObservables);
        this._tooltipControl = tooltipControl;
        this._tooltipPositionFunc = tooltipPositionFunc;
    }
    decorate() {
        const result = super.decorate();
        if (this._tooltipControl !== undefined && result !== undefined) {
            this._tooltipControl.isVisible = result;
            if (result && this._tooltipPositionFunc !== undefined) this._tooltipPositionFunc(this._decoratedControl, this._tooltipControl);
        }
        return result;
    }
}

});

parcelRegister("8QJAY", function(module, exports) {

var $diGQf = parcelRequire("diGQf");

var $esuuG = parcelRequire("esuuG");

var $fCNdl = parcelRequire("fCNdl");

var $hxmHs = parcelRequire("hxmHs");

var $4GBc6 = parcelRequire("4GBc6");
class $67168c51fbaa7b98$export$5e3b9a67f23f5fe6 extends (0, $esuuG.Container) {
    get currentTab() {
        return this._currentTab;
    }
    set currentTab(value) {
        if (this._currentTab === value) return;
        this._currentTab = value;
        this._buttons[value].isToggled = true;
    }
    get onTabChangedObservable() {
        return this._onTabChangedObservable;
    }
    constructor(name){
        super(name);
        this._buttons = [];
        this._contents = [];
        this._onTabChangedObservable = new (0, $diGQf.Observable)();
        this._currentTab = 0;
        this._mainGrid = new (0, $4GBc6.Grid3D)(`${name}MainGrid`);
        this._mainGrid.addColumnDefinition(1, (0, $4GBc6.DefinitionType).Percentage);
        this._mainGrid.addRowDefinition(0, (0, $4GBc6.DefinitionType).Auto);
        this._mainGrid.addRowDefinition(1, (0, $4GBc6.DefinitionType).Percentage);
        super.addControl(this._mainGrid);
        this._tabsContainer = new (0, $4GBc6.Grid3D)(`${name}TabsContainer`);
        // this._tabsContainer.adaptHeightToChildren = true;
        this._tabsContainer.verticalAlignment = (0, $fCNdl.Control).VERTICAL_ALIGNMENT_TOP;
        this._mainGrid.addControl(this._tabsContainer);
        this._contentContainer = new (0, $esuuG.Container)(`${name}ContentContainer`);
        this._mainGrid.addControl(this._contentContainer, 1);
    }
    addControl(control, tabContent = null, buttonLayout = {}, width = {
        value: 1,
        type: (0, $4GBc6.DefinitionType).Percentage
    }) {
        const tabs = this._contents.length;
        const tabButton = (0, $hxmHs.ButtonUtils).CreateImgToggleButton(`${this.name}Tab${tabs}Button`, buttonLayout);
        tabButton.group = `${this.name}TabsGroup`;
        if (tabContent !== null) {
            tabButton.addControl(tabContent);
            if (tabContent.heightInPixels !== 0 && tabContent.heightInPixels > tabButton.heightInPixels) tabButton.heightInPixels = tabContent.heightInPixels;
        }
        this._tabsContainer.heightInPixels = Math.max(this._tabsContainer.heightInPixels, tabButton.heightInPixels);
        this._tabsContainer.addColumnDefinition(width.value, width.type);
        this._tabsContainer.addControl(tabButton, 0, tabs);
        this._contents.push(control);
        this._contentContainer.addControl(control);
        if (control !== null) control.isVisible = false;
        tabButton.onIsToggledChangedObservable.add((v)=>{
            this._contents.forEach((c)=>{
                if (c !== null) c.isVisible = c === control ? v : !v;
            });
            if (v) {
                this._currentTab = tabs;
                setTimeout(()=>this._onTabChangedObservable.notifyObservers(tabs), 0);
            }
        });
        if (tabs === this._currentTab) tabButton.isToggled = true;
        this._buttons.push(tabButton);
        this._mainGrid.markAsDirty();
        return this;
    }
}

});
parcelRegister("hxmHs", function(module, exports) {

$parcel$export(module.exports, "ButtonUtils", () => $cc47207e1dad1da9$export$401415dff5647278);

var $6rvpu = parcelRequire("6rvpu");

var $3A4pp = parcelRequire("3A4pp");

var $9m8ks = parcelRequire("9m8ks");

var $83gFC = parcelRequire("83gFC");

var $iHRqj = parcelRequire("iHRqj");

var $63ju2 = parcelRequire("63ju2");
class $cc47207e1dad1da9$export$401415dff5647278 {
    static CreateImgButton(name, layout, mesh) {
        const adjustedLayout = (0, $iHRqj.LayoutUtils).GetButtonLayout(layout, mesh);
        const btn = new (0, $9m8ks.ImgButton)(name, adjustedLayout);
        (0, $iHRqj.LayoutUtils).SetControlLayout(btn, adjustedLayout);
        return btn;
    }
    static CreateImgToggleButton(name, layout, mesh) {
        const adjustedLayout = (0, $iHRqj.LayoutUtils).GetButtonLayout(layout, mesh);
        const btn = new (0, $83gFC.ImgToggleButton)(name, adjustedLayout);
        (0, $iHRqj.LayoutUtils).SetControlLayout(btn, adjustedLayout);
        return btn;
    }
    static CreateImgButtonWithText(name, params, mesh) {
        const btn = $cc47207e1dad1da9$export$401415dff5647278.CreateImgButton(name, params.imageLayout, mesh);
        const text = (0, $63ju2.ObjectBuilder).createTextBlock3D(mesh, `${name}_text`, params.text, params.textLayout.common ?? {});
        if (params.textLayout.states !== undefined) text.stateController.setStates(params.textLayout.states.map((s)=>{
            return {
                state: s.state,
                style: (0, $3A4pp.FontUtils).getAdjustedFontStyle(s.style, mesh)
            };
        }));
        else text.stateController.setStates([
            {
                state: (0, $6rvpu.ControlState).Normal,
                style: params.textLayout.normal
            },
            {
                state: (0, $6rvpu.ControlState).Hover,
                style: params.textLayout.hover
            },
            {
                state: (0, $6rvpu.ControlState).Pressed,
                style: params.textLayout.pressed
            },
            {
                state: (0, $6rvpu.ControlState).Disabled,
                style: params.textLayout.disabled
            }
        ]);
        btn.addControl(text);
        return btn;
    }
    static CreateImgToggleButtonWithText(name, params, mesh) {
        const btn = $cc47207e1dad1da9$export$401415dff5647278.CreateImgToggleButton(name, params.imageLayout, mesh);
        const text = (0, $63ju2.ObjectBuilder).createTextBlock3D(mesh, `${name}_text`, params.text, params.textLayout.common ?? {});
        if (params.textLayout.states !== undefined) text.stateController.setStates(params.textLayout.states.map((s)=>{
            return {
                state: s.state,
                style: (0, $3A4pp.FontUtils).getAdjustedFontStyle(s.style, mesh)
            };
        }));
        else text.stateController.setStates([
            {
                state: (0, $6rvpu.ControlState).Normal,
                style: (0, $3A4pp.FontUtils).getAdjustedFontStyle(params.textLayout.normal, mesh)
            },
            {
                state: (0, $6rvpu.ControlState).Hover,
                style: (0, $3A4pp.FontUtils).getAdjustedFontStyle(params.textLayout.hover, mesh)
            },
            {
                state: (0, $6rvpu.ControlState).Pressed,
                style: (0, $3A4pp.FontUtils).getAdjustedFontStyle(params.textLayout.pressed, mesh)
            },
            {
                state: (0, $6rvpu.ControlState).Disabled,
                style: (0, $3A4pp.FontUtils).getAdjustedFontStyle(params.textLayout.disabled, mesh)
            },
            {
                state: (0, $6rvpu.ControlState).Toggled,
                style: (0, $3A4pp.FontUtils).getAdjustedFontStyle(params.textLayout.toggled ?? params.textLayout.pressed, mesh)
            },
            {
                state: (0, $6rvpu.ControlState).ToggledHover,
                style: (0, $3A4pp.FontUtils).getAdjustedFontStyle(params.textLayout.toggledHover ?? params.textLayout.pressed, mesh)
            },
            {
                state: (0, $6rvpu.ControlState).ToggledPressed,
                style: (0, $3A4pp.FontUtils).getAdjustedFontStyle(params.textLayout.toggledPressed ?? params.textLayout.pressed, mesh)
            }
        ]);
        text.stateController.onStateChangedObservable.add((state)=>{
            text.text = [
                (0, $6rvpu.ControlState).Toggled,
                (0, $6rvpu.ControlState).ToggledHover,
                (0, $6rvpu.ControlState).ToggledPressed
            ].some((s)=>s === state) ? params.toggledText : params.text;
        });
        btn.addControl(text);
        return btn;
    }
}

});


parcelRegister("fGMX5", function(module, exports) {

var $7uWAj = parcelRequire("7uWAj");

var $chwcr = parcelRequire("chwcr");
var $b6c0c01ba2c30548$var$_a;
class $b6c0c01ba2c30548$var$RichTextPropertyValueTokenImpl {
    constructor(propertyToken, valueToken, valueTransformer){
        this.propertyToken = propertyToken;
        this.valueToken = valueToken;
        this.valueTransformer = valueTransformer;
    }
}
class $b6c0c01ba2c30548$var$RichTextRegexParser {
    static getGradientOrColor(value) {
        if (this.ColorStopsRegex.test(value)) {
            const stopsMatch = value.match(this.ColorStopsRegex)[0];
            const stopMatches = stopsMatch.substring(1, stopsMatch.length - 1).split(',');
            const stops = [];
            for(let i = 0; i < stopMatches.length - 1; i += 2)stops.push({
                offset: Number.parseFloat(stopMatches[i]),
                color: stopMatches[i + 1]
            });
            if (this.LinearGradientRegex.test(value)) {
                const match = value.match(this.LinearGradientRegex)[0];
                const values = match.substring(2, match.length - 1).split(',');
                return {
                    x: Number.parseFloat(values[0]),
                    y: Number.parseFloat(values[1]),
                    xEnd: Number.parseFloat(values[2]),
                    yEnd: Number.parseFloat(values[3]),
                    colorStops: stops
                };
            }
            if (this.RadialGradientRegex.test(value)) {
                const match = value.match(this.RadialGradientRegex)[0];
                const values = match.substring(2, match.length - 1).split(',');
                return {
                    x: Number.parseFloat(values[0]),
                    y: Number.parseFloat(values[1]),
                    r: Number.parseFloat(values[2]),
                    xEnd: Number.parseFloat(values[3]),
                    yEnd: Number.parseFloat(values[4]),
                    rEnd: Number.parseFloat(values[5]),
                    colorStops: stops
                };
            }
            if (this.ConicGradientRegex.test(value)) {
                const match = value.match(this.ConicGradientRegex)[0];
                const values = match.substring(2, match.length - 1).split(',');
                return {
                    angle: Number.parseFloat(values[0]),
                    x: Number.parseFloat(values[1]),
                    y: Number.parseFloat(values[2]),
                    colorStops: stops
                };
            }
        }
        return value;
    }
    static getRect(value) {
        if (this.HorVertRectRegex.test(value)) {
            value.match(this.HorVertRectRegex);
            const values = value.matchAll(this.HorVertRectRegex).next().value;
            return {
                horizontal: Number.parseFloat(values[1]),
                vertical: Number.parseFloat(values[2])
            };
        } else if (this.FullRectRegex.test(value)) {
            value.match(this.FullRectRegex);
            const values = value.matchAll(this.FullRectRegex).next().value;
            return {
                top: Number.parseFloat(values[1]),
                left: Number.parseFloat(values[2]),
                bottom: Number.parseFloat(values[3]),
                right: Number.parseFloat(values[4])
            };
        }
        return Number.parseFloat(value);
    }
    static _getStyle(line) {
        const propertyRegex = new RegExp(`(?:${this._richTextTokens.map((t)=>`(${t.propertyToken})=['\"](${t.valueToken})['\"]`).reduce((p, c)=>p = p + `|${c}`)})`, "g");
        const properties = line.style.matchAll(propertyRegex);
        const style = {};
        for (const property of properties){
            const value = property[0].match(this._valueRegex);
            if (value !== null && value.length === 3) style[value[1]] = this._richTextTokens.find((t)=>t.propertyToken === value[1])?.valueTransformer(value[2]);
        }
        return {
            text: line.text,
            style: style
        };
    }
    GetStyledLines(line) {
        const styledLines = [];
        const newLines = line.split($b6c0c01ba2c30548$var$_a._newLineRegex);
        const lines = [];
        for(let i = 0; i < newLines.length; i++){
            if ((newLines[i].match(/<rt/g)?.length ?? 0) === (newLines[i].match(/<\/rt/g)?.length ?? 0)) lines.push(newLines[i]);
            else if (newLines[i].includes("<rt")) {
                let l = newLines[i];
                i++;
                for(; i < newLines.length; i++){
                    l += newLines[i];
                    if (newLines[i].includes("</rt>")) break;
                }
                lines.push(l);
            } else lines.push(newLines[i]);
        }
        for (const line of lines){
            let splitLines = line.split($b6c0c01ba2c30548$var$_a._splitRegex);
            const splitLines2 = [];
            for(let idx = 0; idx < splitLines.length - 1; idx += 2)splitLines2.push(`${splitLines[idx]}${splitLines[idx + 1]}`);
            if (splitLines.length % 2 === 1) splitLines2.push(splitLines[splitLines.length - 1]);
            splitLines = splitLines2;
            let lineGroup = [];
            for (const l of splitLines)if ($b6c0c01ba2c30548$var$_a._tokenizerRegex.test(l)) {
                const m = l.match($b6c0c01ba2c30548$var$_a._tokenizerRegex);
                const sl = $b6c0c01ba2c30548$var$_a._getStyle({
                    text: m[3],
                    style: m[1]
                });
                if (sl.text.includes("\n")) for (const splitStyledLine of sl.text.split("\n").map((t)=>{
                    return {
                        text: t,
                        style: sl.style
                    };
                })){
                    lineGroup.push(splitStyledLine);
                    styledLines.push(lineGroup);
                    lineGroup = [];
                }
                else lineGroup.push(sl);
            } else lineGroup.push({
                text: l.startsWith('\n') && l !== '\n' ? l.substring(1) : l
            });
            styledLines.push(lineGroup);
        }
        return styledLines;
    }
}
$b6c0c01ba2c30548$var$_a = $b6c0c01ba2c30548$var$RichTextRegexParser;
$b6c0c01ba2c30548$var$RichTextRegexParser.LinearGradientRegex = /L\((?:\d+(?:\.\d+)?,?){4}\)/ig;
$b6c0c01ba2c30548$var$RichTextRegexParser.ConicGradientRegex = /C\((?:\d+(?:\.\d+)?,?){3}\)/ig;
$b6c0c01ba2c30548$var$RichTextRegexParser.RadialGradientRegex = /R\((?:\d+(?:\.\d+)?,?){6}\)/ig;
$b6c0c01ba2c30548$var$RichTextRegexParser.ColorStopsRegex = /\[(?:\d+(?:\.\d+)?,\w+,?)+\]/ig;
$b6c0c01ba2c30548$var$RichTextRegexParser.HorVertRectRegex = /H(\d+(?:\.\d+)?)V(\d+(?:\.\d+)?)/ig;
$b6c0c01ba2c30548$var$RichTextRegexParser.FullRectRegex = /T(\d+(?:\.\d+)?)L(\d+(?:\.\d+)?)B(\d+(?:\.\d+)?)R(\d+(?:\.\d+)?)/ig;
//private static readonly _tokenizerRegex = /<rt((?: \w+=['"](?:[\w\s\.\(\)\[\]\,\n\#\-]+|https?\:\/\/[\w\d\.\/\?&=_#-]+)['"]\s?)+)>(.+?)<\/rt>/is;
$b6c0c01ba2c30548$var$RichTextRegexParser._tokenizerRegex = /<rt((?: \w+=(['"])(?:[\w\s\.\(\)\[\]\,\n\#\-]+|https?\:\/\/[^'\"]+)\2\s?)+)>(.+?)<\/rt>/is;
$b6c0c01ba2c30548$var$RichTextRegexParser._newLineRegex = /(?=\n)/s;
$b6c0c01ba2c30548$var$RichTextRegexParser._valueRegex = /(\w+)=['"](.+)['"]/;
// private static readonly _splitRegex = /(?:(?<=<\/rt>)(?=.)|(?<=.)(?=<rt))/;
$b6c0c01ba2c30548$var$RichTextRegexParser._splitRegex = /((?:<\/rt>)(?=.)|(?:.)(?=<rt))/;
$b6c0c01ba2c30548$var$RichTextRegexParser._richTextTokens = [
    new $b6c0c01ba2c30548$var$RichTextPropertyValueTokenImpl("fontFamily", "[\\w\\s]+", (v)=>v),
    new $b6c0c01ba2c30548$var$RichTextPropertyValueTokenImpl("fontSize", "\\d+(?:\\.\\d+)?", Number.parseFloat),
    new $b6c0c01ba2c30548$var$RichTextPropertyValueTokenImpl("fontWeight", "lighter|normal|bold|bolder|\\d+", (v)=>/\d+/.test(v) ? Number.parseInt(v) : v),
    new $b6c0c01ba2c30548$var$RichTextPropertyValueTokenImpl("fontStyle", "normal|italic|oblique", (v)=>v),
    new $b6c0c01ba2c30548$var$RichTextPropertyValueTokenImpl("color", `#[0-9A-Fa-f]{6}|#[0-9A-Fa-f]{3}|[a-zA-Z]+|(?:${$b6c0c01ba2c30548$var$_a.LinearGradientRegex.source}|${$b6c0c01ba2c30548$var$_a.ConicGradientRegex.source}|${$b6c0c01ba2c30548$var$_a.RadialGradientRegex.source})${$b6c0c01ba2c30548$var$_a.ColorStopsRegex.source}`, (v)=>$b6c0c01ba2c30548$var$_a.getGradientOrColor(v)),
    new $b6c0c01ba2c30548$var$RichTextPropertyValueTokenImpl("outlineColor", `#[0-9A-Fa-f]{6}|#[0-9A-Fa-f]{3}|[a-zA-Z]+|(?:${$b6c0c01ba2c30548$var$_a.LinearGradientRegex.source}|${$b6c0c01ba2c30548$var$_a.ConicGradientRegex.source}|${$b6c0c01ba2c30548$var$_a.RadialGradientRegex.source})${$b6c0c01ba2c30548$var$_a.ColorStopsRegex.source}`, (v)=>$b6c0c01ba2c30548$var$_a.getGradientOrColor(v)),
    new $b6c0c01ba2c30548$var$RichTextPropertyValueTokenImpl("outlineWidth", "\\d+(?:\\.\\d+)?", Number.parseFloat),
    new $b6c0c01ba2c30548$var$RichTextPropertyValueTokenImpl("underline", "true|false", (v)=>v === "true"),
    new $b6c0c01ba2c30548$var$RichTextPropertyValueTokenImpl("strikeThrough", "true|false", (v)=>v === "true"),
    new $b6c0c01ba2c30548$var$RichTextPropertyValueTokenImpl("underlineColor", `#[0-9A-Fa-f]{6}|#[0-9A-Fa-f]{3}|[a-zA-Z]+|(?:${$b6c0c01ba2c30548$var$_a.LinearGradientRegex.source}|${$b6c0c01ba2c30548$var$_a.ConicGradientRegex.source}|${$b6c0c01ba2c30548$var$_a.RadialGradientRegex.source})${$b6c0c01ba2c30548$var$_a.ColorStopsRegex.source}`, (v)=>$b6c0c01ba2c30548$var$_a.getGradientOrColor(v)),
    new $b6c0c01ba2c30548$var$RichTextPropertyValueTokenImpl("strikeThroughColor", `#[0-9A-Fa-f]{6}|#[0-9A-Fa-f]{3}|[a-zA-Z]+|(?:${$b6c0c01ba2c30548$var$_a.LinearGradientRegex.source}|${$b6c0c01ba2c30548$var$_a.ConicGradientRegex.source}|${$b6c0c01ba2c30548$var$_a.RadialGradientRegex.source})${$b6c0c01ba2c30548$var$_a.ColorStopsRegex.source}`, (v)=>$b6c0c01ba2c30548$var$_a.getGradientOrColor(v)),
    new $b6c0c01ba2c30548$var$RichTextPropertyValueTokenImpl("underlineThicknessMultiplier", "\\d+(?:\\.\\d+)?", Number.parseFloat),
    new $b6c0c01ba2c30548$var$RichTextPropertyValueTokenImpl("strikeThroughThicknessMultiplier", "\\d+(?:\\.\\d+)?", Number.parseFloat),
    new $b6c0c01ba2c30548$var$RichTextPropertyValueTokenImpl("shadowColor", "#[0-9A-Fa-f]{6}|#[0-9A-Fa-f]{3}|[a-zA-Z]+", (v)=>v),
    new $b6c0c01ba2c30548$var$RichTextPropertyValueTokenImpl("shadowBlur", "\\d+(?:\\.\\d+)?", Number.parseFloat),
    new $b6c0c01ba2c30548$var$RichTextPropertyValueTokenImpl("shadowOffsetX", "\\d+(?:\\.\\d+)?", Number.parseFloat),
    new $b6c0c01ba2c30548$var$RichTextPropertyValueTokenImpl("shadowOffsetY", "\\d+(?:\\.\\d+)?", Number.parseFloat),
    //new RichTextPropertyValueTokenImpl("hyperlink", "https?\\:\\/\\/[\\w\\d\\.\\/\\?&=_#-]+", v => v),
    new $b6c0c01ba2c30548$var$RichTextPropertyValueTokenImpl("hyperlink", "https?\\:\\/\\/[A-Za-z0-9\\-._~:\\/\?#\\[\\]@!$&'()*+,;=%]+", (v)=>v),
    new $b6c0c01ba2c30548$var$RichTextPropertyValueTokenImpl("backgroundColor", `#[0-9A-Fa-f]{6}|#[0-9A-Fa-f]{3}|[a-zA-Z]+|(?:${$b6c0c01ba2c30548$var$_a.LinearGradientRegex.source}|${$b6c0c01ba2c30548$var$_a.ConicGradientRegex.source}|${$b6c0c01ba2c30548$var$_a.RadialGradientRegex.source})${$b6c0c01ba2c30548$var$_a.ColorStopsRegex.source}`, (v)=>$b6c0c01ba2c30548$var$_a.getGradientOrColor(v)),
    new $b6c0c01ba2c30548$var$RichTextPropertyValueTokenImpl("backgroundRadius", "\\d+(?:\\.\\d+)?", Number.parseFloat),
    new $b6c0c01ba2c30548$var$RichTextPropertyValueTokenImpl("backgroundPadding", `-?\\d+(?:\\.\\d+)?|(?:${$b6c0c01ba2c30548$var$_a.HorVertRectRegex.source}|${$b6c0c01ba2c30548$var$_a.FullRectRegex.source})`, (v)=>$b6c0c01ba2c30548$var$_a.getRect(v)),
    new $b6c0c01ba2c30548$var$RichTextPropertyValueTokenImpl("lineHeight", "\\d+(?:\\.\\d+)?", Number.parseFloat)
];
(0, $chwcr.RichTextParserFactory).RegisterParser((0, $7uWAj.RichTextGrammar).RTTag, $b6c0c01ba2c30548$var$RichTextRegexParser);

});

parcelRegister("c2m4L", function(module, exports) {

$parcel$export(module.exports, "VirtualKeyboard3D", () => $8c36cbc440742ecd$export$e75371e74b50f902);

var $diGQf = parcelRequire("diGQf");

var $fCNdl = parcelRequire("fCNdl");

var $jWkcb = parcelRequire("jWkcb");

var $i0Jb4 = parcelRequire("i0Jb4");

var $3A4pp = parcelRequire("3A4pp");

var $7uWAj = parcelRequire("7uWAj");

var $c0RhK = parcelRequire("c0RhK");

var $hxmHs = parcelRequire("hxmHs");

var $63ju2 = parcelRequire("63ju2");

var $PPcK8 = parcelRequire("PPcK8");
var $8c36cbc440742ecd$export$2e7f0ef8230afadd;
(function(ShiftState) {
    ShiftState[ShiftState["Normal"] = 0] = "Normal";
    ShiftState[ShiftState["Shift"] = 1] = "Shift";
    ShiftState[ShiftState["CapsLock"] = 2] = "CapsLock";
})($8c36cbc440742ecd$export$2e7f0ef8230afadd || ($8c36cbc440742ecd$export$2e7f0ef8230afadd = {}));
class $8c36cbc440742ecd$export$e75371e74b50f902 extends (0, $jWkcb.StackPanel) {
    static isSimpleKey(key) {
        return typeof key === "string";
    }
    static isSpecialKey(key) {
        return !$8c36cbc440742ecd$export$e75371e74b50f902.isSimpleKey(key) && "keyCode" in key;
    }
    static isCallbackKey(key) {
        return !$8c36cbc440742ecd$export$e75371e74b50f902.isSimpleKey(key) && "callback" in key;
    }
    static isTextKey(key) {
        return !$8c36cbc440742ecd$export$e75371e74b50f902.isSimpleKey(key) && "text" in key;
    }
    static isImageKey(key) {
        return !$8c36cbc440742ecd$export$e75371e74b50f902.isSimpleKey(key) && "image" in key;
    }
    get delayMax() {
        return this._delayMax;
    }
    set delayMax(value) {
        this._delayMax = value;
    }
    get delayMin() {
        return this._delayMin;
    }
    set delayMin(value) {
        this._delayMin = value;
    }
    get delayEasingFunc() {
        return this._delayEasingFunc;
    }
    set delayEasingFunc(value) {
        this._delayEasingFunc = value;
    }
    get cornerRadius() {
        return this._cornerRadius;
    }
    set cornerRadius(value) {
        this._cornerRadius = value;
    }
    get horizontalSpacing() {
        return this._horizontalSpacing;
    }
    set horizontalSpacing(value) {
        if (this._horizontalSpacing === value) return;
        this._horizontalSpacing = value;
        this._children.forEach((c)=>c.spacing = value);
    }
    get minButtonWidth() {
        return this._minButtonWidth;
    }
    set minButtonWidth(value) {
        if (this._minButtonWidth === value) return;
        this._minButtonWidth = value;
    }
    get minButtonHeight() {
        return this._minButtonHeight;
    }
    set minButtonHeight(value) {
        if (this._minButtonHeight === value) return;
        this._minButtonHeight = value;
    }
    get textLayout() {
        return this._textLayout;
    }
    set textLayout(value) {
        if (this._textLayout === value) return;
        this._textLayout = value;
        this._keys.forEach((r, i, layout)=>{
            r.forEach((v, j, row)=>{
                if (v.key.textStyle !== undefined || v.text === undefined) return;
                (0, $3A4pp.FontUtils).setTextBlockStyle(v.text, value);
                this._updateButton(v.btn, v.text, this._getButtonLayout(v.key.buttonLayout, i, j, layout.length, row.length), v.image);
            });
        });
    }
    get buttonLayout() {
        return this._buttonLayout;
    }
    set buttonLayout(value) {
        if (this._buttonLayout === value) return;
        this._buttonLayout = value;
        this._keys.forEach((r, i, layout)=>{
            r.forEach((v, j, row)=>{
                if (v.key.buttonLayout !== undefined) return;
                v.btn.changeLayout(value);
                this._updateButton(v.btn, v.text, this._getButtonLayout(v.key.buttonLayout, i, j, layout.length, row.length), v.image);
            });
        });
    }
    get onKeyPressObservable() {
        return this._onKeyPressObservable;
    }
    get shiftState() {
        return this._shiftState;
    }
    set shiftState(value) {
        if (this._shiftState === value) return;
        this._shiftState = value;
        this._keys.forEach((r, i, layout)=>{
            r.forEach((v, j, row)=>{
                if ($8c36cbc440742ecd$export$e75371e74b50f902.isSimpleKey(v.key)) {
                    if (v.text !== undefined) v.text.text = value === 0 ? v.key.toLowerCase() : v.key.toUpperCase();
                } else switch(value){
                    case $8c36cbc440742ecd$export$2e7f0ef8230afadd.Normal:
                        if (v.text !== undefined && $8c36cbc440742ecd$export$e75371e74b50f902.isTextKey(v.key)) v.text.text = v.key.text;
                        else if (v.image !== undefined && $8c36cbc440742ecd$export$e75371e74b50f902.isImageKey(v.key)) v.image.setSource(v.key.image);
                        break;
                    case $8c36cbc440742ecd$export$2e7f0ef8230afadd.Shift:
                        if (v.text !== undefined && $8c36cbc440742ecd$export$e75371e74b50f902.isTextKey(v.key)) v.text.text = v.key.shiftText ?? v.key.text.toUpperCase();
                        else if (v.image !== undefined && $8c36cbc440742ecd$export$e75371e74b50f902.isImageKey(v.key)) v.image.setSource(v.key.shiftImage, v.key.image);
                        break;
                    case $8c36cbc440742ecd$export$2e7f0ef8230afadd.CapsLock:
                        if (v.text !== undefined && $8c36cbc440742ecd$export$e75371e74b50f902.isTextKey(v.key)) v.text.text = v.key.capsText ?? v.key.text.toUpperCase();
                        else if (v.image !== undefined && $8c36cbc440742ecd$export$e75371e74b50f902.isImageKey(v.key)) v.image.setSource(v.key.capsImage, v.key.image);
                        break;
                }
                this._updateButton(v.btn, v.text, this._getButtonLayout(v.key.buttonLayout, i, j, layout.length, row.length), v.image);
            });
        });
    }
    constructor(name){
        super(name);
        this._onKeyPressObservable = new (0, $diGQf.Observable)();
        this._buttonLayout = {};
        this._textLayout = {};
        this._horizontalSpacing = 0;
        this._shiftState = $8c36cbc440742ecd$export$2e7f0ef8230afadd.Normal;
        this._keys = [];
        this._cornerRadius = 0;
        this._delayMax = 1000;
        this._delayMin = 100;
        this._delayEasingFunc = (delay)=>{
            return delay * 0.66;
        };
        this._keyDelayTimeouts = [];
        this._connectedInputs = [];
        this.onKeyPressObservable.add((key)=>{
            this._connectedInputs.forEach((i)=>i._host.focusedControl = i);
            if (typeof key === "number") switch(key){
                case 16:
                    this.shiftState = (this.shiftState + 1) % 3;
                    return;
                default:
                    this._connectedInputs.forEach((i)=>i.processKey(key));
                    return;
            }
            else this._connectedInputs.forEach((i)=>i.processKey(-1, key));
            if (this.shiftState === $8c36cbc440742ecd$export$2e7f0ef8230afadd.Shift) this.shiftState = $8c36cbc440742ecd$export$2e7f0ef8230afadd.Normal;
        });
    }
    dispose() {
        this._connectedInputs.forEach((i)=>i.disconnectControl(this));
        this._connectedInputs.length = 0;
        super.dispose();
    }
    connect(input) {
        if (this._connectedInputs.includes(input)) return;
        this._connectedInputs.push(input);
        input.connectControl(this);
    }
    disconnect(input) {
        if (!this._connectedInputs.includes(input)) return;
        this._connectedInputs.splice(this._connectedInputs.indexOf(input), 1);
        input.disconnectControl(this);
    }
    notifyKeyPressObservers(key) {
        if ($8c36cbc440742ecd$export$e75371e74b50f902.isSimpleKey(key)) this._onKeyPressObservable.notifyObservers(this.shiftState === 0 ? key.toLowerCase() : key.toUpperCase());
        else if ($8c36cbc440742ecd$export$e75371e74b50f902.isSpecialKey(key)) this._onKeyPressObservable.notifyObservers(key.keyCode);
        else if ($8c36cbc440742ecd$export$e75371e74b50f902.isCallbackKey(key)) key.callback();
    }
    holdKey(key, delay = this._delayMax) {
        this.notifyKeyPressObservers(key);
        this.releaseKey(key);
        this._keyDelayTimeouts.push({
            key: key,
            timeout: setTimeout(()=>{
                this.holdKey(key, Math.max(this._delayEasingFunc(delay), this._delayMin));
            }, delay)
        });
    }
    releaseKey(key) {
        const idx = this._keyDelayTimeouts.findIndex((x)=>x.key === key);
        if (idx !== -1) {
            clearTimeout(this._keyDelayTimeouts[idx].timeout);
            this._keyDelayTimeouts.splice(idx, 1);
        }
    }
    changeLayout(layout) {
        this._keys.length = 0;
        while(this.children.length > 0){
            const c = this.children.pop();
            if (c) {
                this.removeControl(c);
                c.dispose();
            }
        }
        let r = 0;
        for(let i = 0; i < layout.length; i++){
            const row = layout[i];
            const rowPanel = new (0, $jWkcb.StackPanel)(`${this.name}Row${r++}`);
            rowPanel.isVertical = false;
            rowPanel.horizontalAlignment = (0, $fCNdl.Control).HORIZONTAL_ALIGNMENT_CENTER;
            rowPanel.verticalAlignment = (0, $fCNdl.Control).VERTICAL_ALIGNMENT_CENTER;
            rowPanel.adaptHeightToChildren = true;
            rowPanel.spacing = this._horizontalSpacing;
            this.addControl(rowPanel);
            const keys = [];
            for(let j = 0; j < row.length; j++){
                const key = row[j];
                const keyTxt = $8c36cbc440742ecd$export$e75371e74b50f902.isSimpleKey(key) ? key : $8c36cbc440742ecd$export$e75371e74b50f902.isTextKey(key) ? key.text : key.image;
                const btnLayout = this._getButtonLayout(key.buttonLayout, i, j, layout.length, row.length);
                const keyBtn = (0, $hxmHs.ButtonUtils).CreateImgButton(`${this.name}Button${keyTxt}`, btnLayout);
                keyBtn.adaptWidthToChildren = true;
                keyBtn.adaptHeightToChildren = true;
                if ($8c36cbc440742ecd$export$e75371e74b50f902.isSimpleKey(key)) {
                    if (key.isClickKey) keyBtn.onPointerClickObservable.add(()=>this._onKeyPressObservable.notifyObservers(this.shiftState === 0 ? key.toLowerCase() : key.toUpperCase()));
                    else {
                        keyBtn.onPointerDownObservable.add(()=>{
                            this.holdKey(key);
                        });
                        keyBtn.onPointerUpObservable.add(()=>{
                            this.releaseKey(key);
                        });
                    }
                } else if ($8c36cbc440742ecd$export$e75371e74b50f902.isSpecialKey(key)) {
                    if (key.isClickKey) keyBtn.onPointerClickObservable.add(()=>{
                        this._onKeyPressObservable.notifyObservers(key.keyCode);
                    });
                    else {
                        keyBtn.onPointerDownObservable.add(()=>{
                            this.holdKey(key);
                        });
                        keyBtn.onPointerUpObservable.add(()=>{
                            this.releaseKey(key);
                        });
                    }
                } else if ($8c36cbc440742ecd$export$e75371e74b50f902.isCallbackKey(key)) {
                    if (key.isClickKey) keyBtn.onPointerClickObservable.add(()=>{
                        key.callback();
                    });
                    else {
                        keyBtn.onPointerDownObservable.add(()=>{
                            this.holdKey(key);
                        });
                        keyBtn.onPointerUpObservable.add(()=>{
                            this.releaseKey(key);
                        });
                    }
                }
                rowPanel.addControl(keyBtn);
                let keyTextBlock = undefined;
                let keyImage = undefined;
                if ($8c36cbc440742ecd$export$e75371e74b50f902.isSimpleKey(key) || $8c36cbc440742ecd$export$e75371e74b50f902.isTextKey(key)) {
                    keyTextBlock = (0, $63ju2.ObjectBuilder).createTextBlock3D(undefined, `${this.name}Button${keyTxt}Text`, keyTxt, key.textStyle ?? this._textLayout);
                    keyBtn.addControl(keyTextBlock);
                } else if ($8c36cbc440742ecd$export$e75371e74b50f902.isImageKey(key)) {
                    keyImage = new (0, $c0RhK.Image3D)(`${this.name}Button${keyTxt}Image`, key.image);
                    keyImage.widthInPixels = key.imgWidth;
                    keyImage.heightInPixels = key.imgHeight;
                    keyBtn.addControl(keyImage);
                }
                this._updateButton(keyBtn, keyTextBlock, btnLayout, keyImage);
                keys.push({
                    btn: keyBtn,
                    text: keyTextBlock,
                    image: keyImage,
                    key: key
                });
            }
            this._keys.push(keys);
        }
    }
    _getButtonLayout(buttonLayout, i, j, layoutLength, rowLength) {
        const btnLayout = Object.assign({}, buttonLayout ?? this._buttonLayout);
        if (this.cornerRadius && (0, $7uWAj.isColorButtonLayout)(btnLayout)) {
            const cornerRadius = Object.assign({}, (0, $PPcK8.CornerMeasureUtils).getFullCornerMeasure(btnLayout.cornerRadiusPx ?? 0));
            const fullMeasure = Object.assign({}, (0, $PPcK8.CornerMeasureUtils).getFullCornerMeasure(this.cornerRadius));
            if (i === 0 && j === 0) cornerRadius.topLeft = fullMeasure.topLeft;
            if (i === 0 && j === rowLength - 1) cornerRadius.topRight = fullMeasure.topRight;
            if (i === layoutLength - 1 && j === 0) cornerRadius.bottomLeft = fullMeasure.bottomLeft;
            if (i === layoutLength - 1 && j === rowLength - 1) cornerRadius.bottomRight = fullMeasure.bottomRight;
            btnLayout.cornerRadiusPx = cornerRadius;
        }
        return btnLayout;
    }
    _updateButton(btn, text, buttonLayout, image) {
        if (buttonLayout?.width !== undefined) {
            btn.adaptWidthToChildren = false;
            btn.widthInPixels = buttonLayout?.width;
        }
        if (buttonLayout?.height !== undefined) {
            btn.adaptHeightToChildren = false;
            btn.heightInPixels = buttonLayout?.height;
        }
        if (this._minButtonWidth !== undefined) {
            let width = 0;
            if (text !== undefined) width = btn.widthInPixels !== 0 ? btn.widthInPixels : (0, $i0Jb4.ContextUtils).MeasureText(text) + text.paddingLeftInPixels + text.paddingRightInPixels + btn.paddingLeftInPixels + btn.paddingRightInPixels;
            else if (image !== undefined) width = btn.widthInPixels !== 0 ? btn.widthInPixels : image.widthInPixels + btn.paddingLeftInPixels + btn.paddingRightInPixels;
            if (this._minButtonWidth > width) {
                btn.adaptWidthToChildren = false;
                btn.widthInPixels = this._minButtonWidth;
            }
        } else if (buttonLayout?.width === undefined) btn.adaptWidthToChildren = true;
        if (this._minButtonHeight !== undefined) {
            let height = 0;
            if (text !== undefined) height = btn.heightInPixels !== 0 ? btn.heightInPixels : text.fontSizeInPixels + text.paddingTopInPixels + text.paddingBottomInPixels + btn.paddingTopInPixels + btn.paddingBottomInPixels;
            else if (image !== undefined) height = btn.heightInPixels !== 0 ? btn.heightInPixels : image.heightInPixels + btn.paddingTopInPixels + btn.paddingBottomInPixels;
            if (this._minButtonHeight > height) {
                btn.adaptHeightToChildren = false;
                btn.heightInPixels = this._minButtonHeight;
            }
        } else if (buttonLayout?.height === undefined) btn.adaptHeightToChildren = true;
    }
}

});

parcelRegister("aE3lw", function(module, exports) {

var $3A4pp = parcelRequire("3A4pp");

var $7uWAj = parcelRequire("7uWAj");

var $iHRqj = parcelRequire("iHRqj");

var $c2m4L = parcelRequire("c2m4L");
class $7c003c44eb937828$export$8f1092a4777aaf73 {
    static GetAdjustedKeyboardLayout(layout, mesh) {
        const adjustedLayout = [];
        for (const row of layout){
            const adjustedRow = [];
            for (const key of row){
                if ((0, $c2m4L.VirtualKeyboard3D).isSimpleKey(key)) {
                    adjustedRow.push(key);
                    continue;
                }
                const adjustedKey = Object.assign({}, key);
                if ((0, $c2m4L.VirtualKeyboard3D).isImageKey(adjustedKey)) {
                    adjustedKey.imgWidth = mesh.m2px(adjustedKey.imgWidth);
                    adjustedKey.imgHeight = mesh.m2px(adjustedKey.imgHeight);
                }
                if (adjustedKey.textStyle !== undefined) adjustedKey.textStyle = (0, $3A4pp.FontUtils).getAdjustedFontStyle(adjustedKey.textStyle, mesh);
                if (adjustedKey.buttonLayout !== undefined && (0, $7uWAj.isColorButtonLayout)(adjustedKey.buttonLayout)) adjustedKey.buttonLayout = (0, $iHRqj.LayoutUtils).GetButtonLayout(adjustedKey.buttonLayout, mesh);
                adjustedRow.push(adjustedKey);
            }
            adjustedLayout.push(adjustedRow);
        }
        return adjustedLayout;
    }
}

});

parcelRegister("cbA6Y", function(module, exports) {

var $3A4pp = parcelRequire("3A4pp");

var $kXRIX = parcelRequire("kXRIX");

var $iHRqj = parcelRequire("iHRqj");
class $8df2861e3c95b270$export$8aed4210b4545b1a {
    static CreateInput(name, layout, mesh) {
        const input = new (0, $kXRIX.Input3D)(name);
        const adjustedLayout = (0, $iHRqj.LayoutUtils).GetLayout(layout, mesh);
        if (adjustedLayout.width !== undefined) input.widthInPixels = adjustedLayout.width;
        if (adjustedLayout.height !== undefined) input.heightInPixels = adjustedLayout.height;
        if (adjustedLayout.adaptHeightToChildren !== undefined) input.adaptHeightToChildren = adjustedLayout.adaptHeightToChildren;
        if (adjustedLayout.adaptWidthToChildren !== undefined) input.adaptWidthToChildren = adjustedLayout.adaptWidthToChildren;
        if (adjustedLayout.verticalAlignment !== undefined) input.verticalAlignment = adjustedLayout.verticalAlignment;
        if (adjustedLayout.horizontalAlignment !== undefined) input.horizontalAlignment = adjustedLayout.horizontalAlignment;
        input.maxLines = layout.maxLines;
        input.maxSymbols = layout.maxSymbols;
        input.contentPadding = (0, $iHRqj.LayoutUtils).GetValue(layout.contentPadding, mesh) ?? 0;
        if (layout.cursorLayout?.width !== undefined) input.cursor.widthInPixels = (0, $iHRqj.LayoutUtils).GetValue(layout.cursorLayout.width, mesh) ?? 0;
        if (layout.cursorLayout?.height !== undefined) input.cursor.heightInPixels = (0, $iHRqj.LayoutUtils).GetValue(layout.cursorLayout.height, mesh) ?? 0;
        if (layout.backgroundLayout?.cornerRadius !== undefined) input.backgroundRect.cornerRadius = (0, $iHRqj.LayoutUtils).GetValue(layout.backgroundLayout.cornerRadius, mesh) ?? 0;
        if (layout.backgroundLayout?.useArc !== undefined) input.backgroundRect.useArc = layout.backgroundLayout.useArc;
        if (layout.states !== undefined) {
            input.stateController.setStates(layout.states);
            input.textBlock.stateController.setStates(layout.states.map((s)=>{
                return {
                    state: s.state,
                    style: (0, $3A4pp.FontUtils).getAdjustedFontStyle(s.style.textStyle, mesh)
                };
            }));
            input.placeholderTextBlock.stateController.setStates(layout.states.map((s)=>{
                return {
                    state: s.state,
                    style: (0, $3A4pp.FontUtils).getAdjustedFontStyle(s.style.placeholderStyle, mesh)
                };
            }));
            input.backgroundRect.stateController.setStates(layout.states.map((s)=>{
                return {
                    state: s.state,
                    style: (0, $iHRqj.LayoutUtils).GetRectangleStyle(s.style.backgroundStyle, mesh)
                };
            }));
            input.cursor.stateController.setStates(layout.states.map((s)=>{
                return {
                    state: s.state,
                    style: (0, $iHRqj.LayoutUtils).GetRectangleStyle(s.style.cursorStyle, mesh)
                };
            }));
        }
        return input;
    }
}

});

parcelRegister("2y2Kf", function(module, exports) {

var $cfkw4 = parcelRequire("cfkw4");

var $ha1VO = parcelRequire("ha1VO");

var $diGQf = parcelRequire("diGQf");
class $1db0e2cf85020cb2$export$5400b37ccdc0910f {
    constructor(){
        this._target = null;
        this._scene = null;
        this._pointerObserver = null;
        this._draggableMeshes = null;
        this._isDragging = false;
        this._pointerId = null;
        this._previousPointerId = null;
        this._lastRayVector = null;
        this._speedMultiplier = 1;
        this._totalRotation = 0;
        this._pivotPoint = (0, $ha1VO.Vector3).Zero();
        /**
         * Fires each time a drag starts
         */ this._onDragStartObservable = new (0, $diGQf.Observable)();
        /**
         * Fires each time a drag happens
         */ this._onDragObservable = new (0, $diGQf.Observable)();
        /**
         *  Fires each time a drag ends (eg. mouse release after drag)
         */ this._onDragEndObservable = new (0, $diGQf.Observable)();
    }
    get pivotPoint() {
        return this._pivotPoint;
    }
    set pivotPoint(value) {
        this._pivotPoint = value;
    }
    get speedMultiplier() {
        return this._speedMultiplier;
    }
    set speedMultiplier(value) {
        this._speedMultiplier = value;
    }
    get lastRotation() {
        return this._totalRotation;
    }
    get onDragStartObservable() {
        return this._onDragStartObservable;
    }
    get onDragObservable() {
        return this._onDragObservable;
    }
    get onDragEndObservable() {
        return this._onDragEndObservable;
    }
    /**
     * In the case of multiple active cameras, the cameraToUseForPointers should be used if set instead of active camera
     */ get _pointerCamera() {
        if (this._scene?.cameraToUseForPointers) return this._scene.cameraToUseForPointers;
        else return this._scene?.activeCamera ?? null;
    }
    get name() {
        return "SixDofDragRotate";
    }
    get draggableMeshes() {
        return this._draggableMeshes;
    }
    set draggableMeshes(value) {
        this._draggableMeshes = value;
    }
    init() {}
    attach(target) {
        this._target = target;
        this._scene = this._target.getScene();
        this._pointerObserver = this._scene.onPointerObservable.add((pointerInfo)=>{
            const pointerId = pointerInfo.event.pointerId;
            switch(pointerInfo.type){
                case (0, $cfkw4.PointerEventTypes).POINTERDOWN:
                    {
                        if (this._isDragging) return;
                        if (this._target === null || this._pointerCamera === null) return;
                        const hasPickData = pointerInfo.pickInfo !== null && pointerInfo.pickInfo.pickedPoint !== null && pointerInfo.pickInfo.pickedMesh !== null && pointerInfo.pickInfo.hit !== null && pointerInfo.pickInfo.ray !== null;
                        if (!hasPickData) return;
                        this._pointerId = pointerId;
                        const mesh = pointerInfo.pickInfo.pickedMesh;
                        if (mesh === this._target || mesh.isDescendantOf(this._target) && (this._draggableMeshes === null || this._draggableMeshes.includes(mesh))) {
                            this._isDragging = true;
                            this._pointerCamera.detachControl();
                            this._totalRotation = 0;
                            if (this._pointerId !== this._previousPointerId) this._lastRayVector = null;
                            this._onDragStartObservable.notifyObservers({});
                        }
                        return;
                    }
                case (0, $cfkw4.PointerEventTypes).POINTERMOVE:
                    {
                        if (!this._isDragging || pointerId !== this._pointerId) return;
                        if (this._target === null || this._pointerCamera === null) return;
                        const hasPickData = pointerInfo.pickInfo !== null && pointerInfo.pickInfo.ray !== null;
                        if (!hasPickData) return;
                        const ray = pointerInfo.pickInfo.ray;
                        const rayVector = ray.direction.subtract(this.pivotPoint);
                        if (this._lastRayVector === null) {
                            this._lastRayVector = rayVector;
                            return;
                        }
                        // const theta = Math.asin(rayVector.cross(this._lastRayVector).length() / (rayVector.length() * this._lastRayVector.length()));
                        const theta = Math.atan2(rayVector.x * this._lastRayVector.z - rayVector.z * this._lastRayVector.x, rayVector.x * this._lastRayVector.x + rayVector.z * this._lastRayVector.z);
                        this._lastRayVector = rayVector;
                        this._target.rotateAround(this.pivotPoint, (0, $ha1VO.Vector3).Up(), theta * this.speedMultiplier);
                        this._totalRotation += theta * this.speedMultiplier;
                        this._onDragObservable.notifyObservers({
                            delta: theta
                        });
                        return;
                    }
                case (0, $cfkw4.PointerEventTypes).POINTERUP:
                    if (!this._isDragging || pointerId !== this._pointerId) return;
                    if (this._target === null || this._pointerCamera === null) return;
                    this._isDragging = false;
                    this._lastRayVector = null;
                    this._previousPointerId = this._pointerId;
                    this._pointerId = null;
                    this._pointerCamera.attachControl();
                    this._onDragEndObservable.notifyObservers({
                        totalRotation: this._totalRotation
                    });
            }
        });
    }
    detach() {
        this._scene?.onPointerObservable.remove(this._pointerObserver);
        this._target = null;
        this._scene = null;
    }
    reset() {
        if (this._target === null) return;
        const target = this._target;
        this.detach();
        this._isDragging = false;
        this._pointerCamera?.attachControl(true);
        this.attach(target);
    }
}

});

parcelRegister("jZmWP", function(module, exports) {
class $e8d583c770759bbd$export$cc85ae03dd8b482a {
    constructor(){
        this.name = "PositioningBehaviour";
        this._mesh = null;
        this._observedItem = null;
        this._positioningFunction = null;
        this._observables = null;
    }
    init() {}
    attach(target) {
        this._mesh = target;
    }
    detach() {
        this._mesh = null;
    }
    setPositioningParams(item, observables, positioningFunction) {
        this._observedItem = item;
        this._positioningFunction = positioningFunction;
        this._observables = observables;
        this._observables.forEach((o)=>o.add(()=>{
                if (this._mesh && this._positioningFunction && this._observedItem) this._mesh.mesh.position = this._positioningFunction(this._observedItem);
            }));
    }
}

});

parcelRegister("c8Dvh", function(module, exports) {

$parcel$export(module.exports, "AdvancedFreeCameraMouseInput", () => $8d64dffca580ce7a$export$fc6cb8e71a2420e3);

var $29K1K = parcelRequire("29K1K");

var $cfkw4 = parcelRequire("cfkw4");

var $diGQf = parcelRequire("diGQf");

var $bOhSV = parcelRequire("bOhSV");
class $8d64dffca580ce7a$export$fc6cb8e71a2420e3 {
    /**
     * Manage the mouse inputs to control the movement of a free camera.
     * @see https://doc.babylonjs.com/how_to/customizing_camera_inputs
     */ constructor(params){
        /**
         * Defines the buttons associated with the input to handle camera move.
         */ this.buttons = [
            0,
            1,
            2
        ];
        this.moveXSensitivity = 250.0;
        this.moveYSensitivity = 250.0;
        this.rotationXEnabled = true;
        this.rotationYEnabled = true;
        this.rotationXLimit = 180;
        this.rotationYLimit = 180;
        this._pointerInput = null;
        this._onMouseMove = null;
        this._observer = null;
        this._previousPosition = null;
        /**
         * Observable for when a pointer move event occurs containing the move offset
         */ this.onPointerMovedObservable = new (0, $diGQf.Observable)();
        this._currentActiveButton = -1;
        this._contextMenuBind = null;
        if (params !== undefined) {
            if (params.moveXSensitivity !== undefined) this.moveXSensitivity = params.moveXSensitivity;
            if (params.moveYSensitivity !== undefined) this.moveYSensitivity = params.moveYSensitivity;
            if (params.rotationXEnabled !== undefined) this.rotationXEnabled = params.rotationXEnabled;
            if (params.rotationYEnabled !== undefined) this.rotationYEnabled = params.rotationYEnabled;
            if (params.rotationXLimit !== undefined) this.rotationXLimit = params.rotationXLimit;
            if (params.rotationYLimit !== undefined) this.rotationYLimit = params.rotationYLimit;
        }
    }
    /**
     * Attach the input controls to a specific dom element to get the input from.
     * @param noPreventDefault Defines whether event caught by the controls should call preventdefault() (https://developer.mozilla.org/en-US/docs/Web/API/Event/preventDefault)
     */ attachControl(noPreventDefault) {
        // eslint-disable-next-line prefer-rest-params
        noPreventDefault = (0, $bOhSV.Tools).BackCompatCameraNoPreventDefault(arguments);
        const engine = this.camera.getEngine();
        const element = engine.getInputElement();
        if (!this._pointerInput) this._pointerInput = (p)=>{
            const evt = p.event;
            if (engine.isInVRExclusivePointerMode) return;
            if (evt.pointerType === "touch") return;
            if (p.type !== (0, $cfkw4.PointerEventTypes).POINTERMOVE && this.buttons.indexOf(evt.button) === -1) return;
            const srcElement = evt.target;
            if (p.type === (0, $cfkw4.PointerEventTypes).POINTERDOWN && this._currentActiveButton === -1) {
                try {
                    srcElement?.setPointerCapture(evt.pointerId);
                } catch (e) {
                //Nothing to do with the error. Execution will continue.
                }
                if (this._currentActiveButton === -1) this._currentActiveButton = evt.button;
                this._previousPosition = {
                    x: evt.clientX,
                    y: evt.clientY
                };
                if (!noPreventDefault) {
                    evt.preventDefault();
                    element && element.focus();
                }
                // This is required to move while pointer button is down
                if (engine.isPointerLock && this._onMouseMove) this._onMouseMove(p.event);
            } else if (p.type === (0, $cfkw4.PointerEventTypes).POINTERUP && this._currentActiveButton === evt.button) {
                try {
                    srcElement?.releasePointerCapture(evt.pointerId);
                } catch (e) {
                //Nothing to do with the error.
                }
                this._currentActiveButton = -1;
                this._previousPosition = null;
                if (!noPreventDefault) evt.preventDefault();
            } else if (p.type === (0, $cfkw4.PointerEventTypes).POINTERMOVE) {
                if (engine.isPointerLock && this._onMouseMove) this._onMouseMove(p.event);
                else if (this._previousPosition) {
                    let offsetX = evt.clientX - this._previousPosition.x;
                    const offsetY = evt.clientY - this._previousPosition.y;
                    if (this.camera.getScene().useRightHandedSystem) offsetX *= -1;
                    if (this.camera.parent && this.camera.parent._getWorldMatrixDeterminant() < 0) offsetX *= -1;
                    const rotation = this.camera.cameraRotation.clone();
                    if (this.rotationYEnabled) {
                        const limit = this.rotationYLimit / 2 / 180 * Math.PI;
                        rotation.x = rotation.x + offsetY / this.moveYSensitivity;
                        if (!(this.camera.rotation.x > limit && rotation.x < 0 || this.camera.rotation.x < -limit && rotation.x > 0) && Math.abs(this.camera.rotation.x + rotation.x) > limit) rotation.x = 0;
                    }
                    if (this.rotationXEnabled) {
                        const limit = this.rotationXLimit / 2 / 180 * Math.PI;
                        rotation.y = rotation.y + offsetX / this.moveXSensitivity;
                        if (!(this.camera.rotation.y > limit && rotation.y < 0 || this.camera.rotation.y < -limit && rotation.y > 0) && Math.abs(this.camera.rotation.y + rotation.y) > limit) rotation.y = 0;
                    }
                    if (this.rotationXEnabled || this.rotationYEnabled) this.camera.cameraRotation = rotation.clone();
                    this.onPointerMovedObservable.notifyObservers({
                        offsetX: offsetX,
                        offsetY: offsetY
                    });
                    this._previousPosition = {
                        x: evt.clientX,
                        y: evt.clientY
                    };
                    if (!noPreventDefault) evt.preventDefault();
                }
            }
        };
        this._onMouseMove = (evt)=>{
            if (!engine.isPointerLock) return;
            if (engine.isInVRExclusivePointerMode) return;
            let offsetX = evt.movementX;
            if (this.camera.getScene().useRightHandedSystem) offsetX *= -1;
            if (this.camera.parent && this.camera.parent._getWorldMatrixDeterminant() < 0) offsetX *= -1;
            const offsetY = evt.movementY;
            const rotation = this.camera.cameraRotation.clone();
            if (this.rotationYEnabled) {
                const limit = this.rotationYLimit / 2 / 180 * Math.PI;
                rotation.x = Math.max(Math.min(rotation.x + offsetY / this.moveYSensitivity, limit), -limit);
            }
            if (this.rotationXEnabled) {
                const limit = this.rotationXLimit / 2 / 180 * Math.PI;
                rotation.y = Math.max(Math.min(rotation.y + offsetX / this.moveXSensitivity, limit), -limit);
            }
            if (this.rotationXEnabled || this.rotationYEnabled) this.camera.cameraRotation = rotation.clone();
            this._previousPosition = null;
            if (!noPreventDefault) evt.preventDefault();
        };
        this._observer = this.camera.getScene().onPointerObservable.add(this._pointerInput, (0, $cfkw4.PointerEventTypes).POINTERDOWN | (0, $cfkw4.PointerEventTypes).POINTERUP | (0, $cfkw4.PointerEventTypes).POINTERMOVE);
        if (element) {
            this._contextMenuBind = this.onContextMenu.bind(this);
            element.addEventListener("contextmenu", this._contextMenuBind, false); // TODO: We need to figure out how to handle this for Native
        }
    }
    /**
     * Called on JS contextmenu event.
     * Override this method to provide functionality.
     * @param evt
     */ onContextMenu(evt) {
        evt.preventDefault();
    }
    /**
     * Detach the current controls from the specified dom element.
     */ detachControl() {
        if (this._observer) {
            this.camera.getScene().onPointerObservable.remove(this._observer);
            if (this._contextMenuBind) {
                const engine = this.camera.getEngine();
                const element = engine.getInputElement();
                element && element.removeEventListener("contextmenu", this._contextMenuBind);
            }
            if (this.onPointerMovedObservable) this.onPointerMovedObservable.clear();
            this._observer = null;
            this._onMouseMove = null;
            this._previousPosition = null;
        }
        this._currentActiveButton = -1;
    }
    /**
     * Gets the class name of the current input.
     * @returns the class name
     */ getClassName() {
        return "AdvancedFreeCameraMouseInput";
    }
    /**
     * Get the friendly name associated with the input class.
     * @returns the input friendly name
     */ getSimpleName() {
        return "mouse";
    }
}
(0, $29K1K.CameraInputTypes)["AdvancedFreeCameraMouseInput"] = $8d64dffca580ce7a$export$fc6cb8e71a2420e3;

});

parcelRegister("a67eV", function(module, exports) {

var $lOrBZ = parcelRequire("lOrBZ");
class $75a0149040d7c0e5$export$87c4ba90878c6a18 extends (0, $lOrBZ.Slider) {
    get cornerRadius() {
        return this._cornerRadius;
    }
    set cornerRadius(value) {
        this._cornerRadius = value;
    }
    _draw(context) {
        context.save();
        this._applyStates(context);
        this._prepareRenderingData(this.isThumbCircle ? "circle" : "rectangle");
        let left = this._renderLeft;
        let top = this._renderTop;
        const width = this._renderWidth;
        const height = this._renderHeight;
        let radius = 0;
        if (this.isThumbClamped && this.isThumbCircle) {
            if (this.isVertical) top += this._effectiveThumbThickness / 2;
            else left += this._effectiveThumbThickness / 2;
            radius = this._backgroundBoxThickness / 2;
        } else radius = (this._effectiveThumbThickness - this._effectiveBarOffset) / 2;
        if (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) {
            context.shadowColor = this.shadowColor;
            context.shadowBlur = this.shadowBlur;
            context.shadowOffsetX = this.shadowOffsetX;
            context.shadowOffsetY = this.shadowOffsetY;
        }
        const thumbPosition = this._getThumbPosition();
        context.fillStyle = this.background;
        if (this.isVertical) {
            if (this.cornerRadius !== undefined) {
                context.beginPath();
                context.arc(left + this._backgroundBoxThickness / 2, top, this.cornerRadius, Math.PI, 2 * Math.PI);
                context.fill();
                context.fillRect(left, top, width, height);
            } else if (this.isThumbClamped) {
                if (this.isThumbCircle) {
                    context.beginPath();
                    context.arc(left + this._backgroundBoxThickness / 2, top, radius, Math.PI, 2 * Math.PI);
                    context.fill();
                    context.fillRect(left, top, width, height);
                } else context.fillRect(left, top, width, height + this._effectiveThumbThickness);
            } else context.fillRect(left, top, width, height);
        } else {
            if (this.cornerRadius !== undefined) {
                context.beginPath();
                context.arc(left + this._backgroundBoxLength, top + this._backgroundBoxThickness / 2, this.cornerRadius, 0, 2 * Math.PI);
                context.fill();
                context.fillRect(left, top, width, height);
            } else if (this.isThumbClamped) {
                if (this.isThumbCircle) {
                    context.beginPath();
                    context.arc(left + this._backgroundBoxLength, top + this._backgroundBoxThickness / 2, radius, 0, 2 * Math.PI);
                    context.fill();
                    context.fillRect(left, top, width, height);
                } else context.fillRect(left, top, width + this._effectiveThumbThickness, height);
            } else context.fillRect(left, top, width, height);
        }
        if (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) {
            context.shadowBlur = 0;
            context.shadowOffsetX = 0;
            context.shadowOffsetY = 0;
        }
        // Value bar
        context.fillStyle = this.color;
        if (this._displayValueBar) {
            if (this.isVertical) {
                if (this.cornerRadius !== undefined) {
                    context.beginPath();
                    context.arc(left + this._backgroundBoxThickness / 2, top + this._backgroundBoxLength, this.cornerRadius, 0, 2 * Math.PI);
                    context.fill();
                    context.fillRect(left, top + thumbPosition, width, height - thumbPosition);
                } else if (this.isThumbClamped) {
                    if (this.isThumbCircle) {
                        context.beginPath();
                        context.arc(left + this._backgroundBoxThickness / 2, top + this._backgroundBoxLength, radius, 0, 2 * Math.PI);
                        context.fill();
                        context.fillRect(left, top + thumbPosition, width, height - thumbPosition);
                    } else context.fillRect(left, top + thumbPosition, width, height - thumbPosition + this._effectiveThumbThickness);
                } else context.fillRect(left, top + thumbPosition, width, height - thumbPosition);
            } else {
                if (this.cornerRadius !== undefined) {
                    context.beginPath();
                    context.arc(left, top + this._backgroundBoxThickness / 2, this.cornerRadius, 0, 2 * Math.PI);
                    context.fill();
                    context.fillRect(left, top, thumbPosition, height);
                }
                if (this.isThumbClamped) {
                    if (this.isThumbCircle) {
                        context.beginPath();
                        context.arc(left, top + this._backgroundBoxThickness / 2, radius, 0, 2 * Math.PI);
                        context.fill();
                        context.fillRect(left, top, thumbPosition, height);
                    } else context.fillRect(left, top, thumbPosition, height);
                } else context.fillRect(left, top, thumbPosition, height);
            }
        }
        // Thumb
        context.fillStyle = this.thumbColor || this.color;
        if (this.displayThumb) {
            if (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) {
                context.shadowColor = this.shadowColor;
                context.shadowBlur = this.shadowBlur;
                context.shadowOffsetX = this.shadowOffsetX;
                context.shadowOffsetY = this.shadowOffsetY;
            }
            if (this.isThumbCircle) {
                context.beginPath();
                if (this.isVertical) context.arc(left + this._backgroundBoxThickness / 2, top + thumbPosition, radius, 0, 2 * Math.PI);
                else context.arc(left + thumbPosition, top + this._backgroundBoxThickness / 2, radius, 0, 2 * Math.PI);
                context.fill();
                if (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) {
                    context.shadowBlur = 0;
                    context.shadowOffsetX = 0;
                    context.shadowOffsetY = 0;
                }
                context.strokeStyle = this.borderColor;
                context.stroke();
            } else {
                if (this.isVertical) context.fillRect(left - this._effectiveBarOffset, this._currentMeasure.top + thumbPosition, this._currentMeasure.width, this._effectiveThumbThickness);
                else context.fillRect(this._currentMeasure.left + thumbPosition, this._currentMeasure.top, this._effectiveThumbThickness, this._currentMeasure.height);
                if (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) {
                    context.shadowBlur = 0;
                    context.shadowOffsetX = 0;
                    context.shadowOffsetY = 0;
                }
                context.strokeStyle = this.borderColor;
                if (this.isVertical) context.strokeRect(left - this._effectiveBarOffset, this._currentMeasure.top + thumbPosition, this._currentMeasure.width, this._effectiveThumbThickness);
                else context.strokeRect(this._currentMeasure.left + thumbPosition, this._currentMeasure.top, this._effectiveThumbThickness, this._currentMeasure.height);
            }
        }
        context.restore();
    }
}

});
parcelRegister("lOrBZ", function(module, exports) {

$parcel$export(module.exports, "Slider", () => $fe13af99de6aaa78$export$472062a354075cee);

var $e0Suo = parcelRequire("e0Suo");

var $cLeSo = parcelRequire("cLeSo");

var $8DoUR = parcelRequire("8DoUR");

var $ir0rz = parcelRequire("ir0rz");

var $bOhSV = parcelRequire("bOhSV");
class $fe13af99de6aaa78$export$472062a354075cee extends (0, $cLeSo.BaseSlider) {
    /** Gets or sets a boolean indicating if the value bar must be rendered */ get displayValueBar() {
        return this._displayValueBar;
    }
    set displayValueBar(value) {
        if (this._displayValueBar === value) return;
        this._displayValueBar = value;
        this._markAsDirty();
    }
    /** Gets or sets border color */ get borderColor() {
        return this._borderColor;
    }
    set borderColor(value) {
        if (this._borderColor === value) return;
        this._borderColor = value;
        this._markAsDirty();
    }
    /** Gets or sets background color */ get background() {
        return this._background;
    }
    set background(value) {
        if (this._background === value) return;
        this._background = value;
        this._markAsDirty();
    }
    /** Gets or sets background gradient */ get backgroundGradient() {
        return this._backgroundGradient;
    }
    set backgroundGradient(value) {
        if (this._backgroundGradient === value) return;
        this._backgroundGradient = value;
        this._markAsDirty();
    }
    /** Gets or sets thumb's color */ get thumbColor() {
        return this._thumbColor;
    }
    set thumbColor(value) {
        if (this._thumbColor === value) return;
        this._thumbColor = value;
        this._markAsDirty();
    }
    /** Gets or sets a boolean indicating if the thumb should be round or square */ get isThumbCircle() {
        return this._isThumbCircle;
    }
    set isThumbCircle(value) {
        if (this._isThumbCircle === value) return;
        this._isThumbCircle = value;
        this._markAsDirty();
    }
    /**
     * Creates a new Slider
     * @param name defines the control name
     */ constructor(name){
        super(name);
        this.name = name;
        this._background = "black";
        this._borderColor = "white";
        this._thumbColor = "";
        this._isThumbCircle = false;
        this._displayValueBar = true;
        this._backgroundGradient = null;
    }
    _getTypeName() {
        return "Slider";
    }
    _getBackgroundColor(context) {
        return this._backgroundGradient ? this._backgroundGradient.getCanvasGradient(context) : this._background;
    }
    _draw(context) {
        context.save();
        this._applyStates(context);
        this._prepareRenderingData(this.isThumbCircle ? "circle" : "rectangle");
        let left = this._renderLeft;
        let top = this._renderTop;
        const width = this._renderWidth;
        const height = this._renderHeight;
        let radius = 0;
        if (this.isThumbClamped && this.isThumbCircle) {
            if (this.isVertical) top += this._effectiveThumbThickness / 2;
            else left += this._effectiveThumbThickness / 2;
            radius = this._backgroundBoxThickness / 2;
        } else radius = (this._effectiveThumbThickness - this._effectiveBarOffset) / 2;
        if (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) {
            context.shadowColor = this.shadowColor;
            context.shadowBlur = this.shadowBlur;
            context.shadowOffsetX = this.shadowOffsetX;
            context.shadowOffsetY = this.shadowOffsetY;
        }
        const thumbPosition = this._getThumbPosition();
        context.fillStyle = this._getBackgroundColor(context);
        if (this.isVertical) {
            if (this.isThumbClamped) {
                if (this.isThumbCircle) {
                    context.beginPath();
                    context.arc(left + this._backgroundBoxThickness / 2, top, radius, Math.PI, 2 * Math.PI);
                    context.fill();
                    context.fillRect(left, top, width, height);
                } else context.fillRect(left, top, width, height + this._effectiveThumbThickness);
            } else context.fillRect(left, top, width, height);
        } else if (this.isThumbClamped) {
            if (this.isThumbCircle) {
                context.beginPath();
                context.arc(left + this._backgroundBoxLength, top + this._backgroundBoxThickness / 2, radius, 0, 2 * Math.PI);
                context.fill();
                context.fillRect(left, top, width, height);
            } else context.fillRect(left, top, width + this._effectiveThumbThickness, height);
        } else context.fillRect(left, top, width, height);
        if (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) {
            context.shadowBlur = 0;
            context.shadowOffsetX = 0;
            context.shadowOffsetY = 0;
        }
        // Value bar
        context.fillStyle = this._getColor(context);
        if (this._displayValueBar) {
            if (this.isVertical) {
                if (this.isThumbClamped) {
                    if (this.isThumbCircle) {
                        context.beginPath();
                        context.arc(left + this._backgroundBoxThickness / 2, top + this._backgroundBoxLength, radius, 0, 2 * Math.PI);
                        context.fill();
                        context.fillRect(left, top + thumbPosition, width, height - thumbPosition);
                    } else context.fillRect(left, top + thumbPosition, width, height - thumbPosition + this._effectiveThumbThickness);
                } else context.fillRect(left, top + thumbPosition, width, height - thumbPosition);
            } else if (this.isThumbClamped) {
                if (this.isThumbCircle) {
                    context.beginPath();
                    context.arc(left, top + this._backgroundBoxThickness / 2, radius, 0, 2 * Math.PI);
                    context.fill();
                    context.fillRect(left, top, thumbPosition, height);
                } else context.fillRect(left, top, thumbPosition, height);
            } else context.fillRect(left, top, thumbPosition, height);
        }
        // Thumb
        context.fillStyle = this._thumbColor || this._getColor(context);
        if (this.displayThumb) {
            if (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) {
                context.shadowColor = this.shadowColor;
                context.shadowBlur = this.shadowBlur;
                context.shadowOffsetX = this.shadowOffsetX;
                context.shadowOffsetY = this.shadowOffsetY;
            }
            if (this._isThumbCircle) {
                context.beginPath();
                if (this.isVertical) context.arc(left + this._backgroundBoxThickness / 2, top + thumbPosition, radius, 0, 2 * Math.PI);
                else context.arc(left + thumbPosition, top + this._backgroundBoxThickness / 2, radius, 0, 2 * Math.PI);
                context.fill();
                if (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) {
                    context.shadowBlur = 0;
                    context.shadowOffsetX = 0;
                    context.shadowOffsetY = 0;
                }
                context.strokeStyle = this._borderColor;
                context.stroke();
            } else {
                if (this.isVertical) context.fillRect(left - this._effectiveBarOffset, this._currentMeasure.top + thumbPosition, this._currentMeasure.width, this._effectiveThumbThickness);
                else context.fillRect(this._currentMeasure.left + thumbPosition, this._currentMeasure.top, this._effectiveThumbThickness, this._currentMeasure.height);
                if (this.shadowBlur || this.shadowOffsetX || this.shadowOffsetY) {
                    context.shadowBlur = 0;
                    context.shadowOffsetX = 0;
                    context.shadowOffsetY = 0;
                }
                context.strokeStyle = this._borderColor;
                if (this.isVertical) context.strokeRect(left - this._effectiveBarOffset, this._currentMeasure.top + thumbPosition, this._currentMeasure.width, this._effectiveThumbThickness);
                else context.strokeRect(this._currentMeasure.left + thumbPosition, this._currentMeasure.top, this._effectiveThumbThickness, this._currentMeasure.height);
            }
        }
        context.restore();
    }
    serialize(serializationObject) {
        super.serialize(serializationObject);
        if (this.backgroundGradient) {
            serializationObject.backgroundGradient = {};
            this.backgroundGradient.serialize(serializationObject.backgroundGradient);
        }
    }
    /** @internal */ _parseFromContent(serializedObject, host) {
        super._parseFromContent(serializedObject, host);
        if (serializedObject.backgroundGradient) {
            const className = (0, $bOhSV.Tools).Instantiate("BABYLON.GUI." + serializedObject.backgroundGradient.className);
            this.backgroundGradient = new className();
            this.backgroundGradient.parse(serializedObject.backgroundGradient);
        }
    }
}
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $fe13af99de6aaa78$export$472062a354075cee.prototype, "displayValueBar", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $fe13af99de6aaa78$export$472062a354075cee.prototype, "borderColor", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $fe13af99de6aaa78$export$472062a354075cee.prototype, "background", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $fe13af99de6aaa78$export$472062a354075cee.prototype, "thumbColor", null);
(0, $e0Suo.__decorate)([
    (0, $ir0rz.serialize)()
], $fe13af99de6aaa78$export$472062a354075cee.prototype, "isThumbCircle", null);
(0, $8DoUR.RegisterClass)("BABYLON.GUI.Slider", $fe13af99de6aaa78$export$472062a354075cee);

});


parcelRegister("gUs7h", function(module, exports) {

var $PPcK8 = parcelRequire("PPcK8");
class $c4f7afa795fa2d7f$export$910df0218e42102c extends (0, $PPcK8.Rectangle3D) {
    constructor(){
        super(...arguments);
        this._value = 0;
        this._progressBarColor = "#FFFFFF";
        this._orientation = "horizontal";
    }
    get orientation() {
        return this._orientation;
    }
    set orientation(value) {
        if (this._orientation === value) return;
        this._orientation = value;
        this._markAsDirty();
    }
    get value() {
        return this._value;
    }
    set value(value) {
        if (this._value === value) return;
        this._value = value;
        this._markAsDirty();
    }
    get progressBarColor() {
        return this._progressBarColor;
    }
    set progressBarColor(value) {
        if (this._progressBarColor === value) return;
        this._progressBarColor = value;
        this._markAsDirty();
    }
    _draw(context, invalidatedRectangle) {
        this._localDraw(context);
        this._clipForChildren(context);
        context.save();
        context.fillStyle = this._progressBarColor;
        context.fillRect(this._currentMeasure.left, this._currentMeasure.top, this.orientation === "horizontal" ? this._currentMeasure.width * this.value : this._currentMeasure.width, this._orientation === "vertical" ? this._currentMeasure.height * this.value : this._currentMeasure.height);
        context.restore();
        for (var child of this._children)child._render(context, invalidatedRectangle);
    }
}

});

parcelRegister("b1o73", function(module, exports) {
var $02121ace5914ef79$export$94806efd9890932f;
(function(PointerEvent) {
    PointerEvent[PointerEvent["PointerEnter"] = 0] = "PointerEnter";
    PointerEvent[PointerEvent["PointerMove"] = 1] = "PointerMove";
    PointerEvent[PointerEvent["PointerLeave"] = 2] = "PointerLeave";
    PointerEvent[PointerEvent["PointerDown"] = 3] = "PointerDown";
    PointerEvent[PointerEvent["PointerUp"] = 4] = "PointerUp";
})($02121ace5914ef79$export$94806efd9890932f || ($02121ace5914ef79$export$94806efd9890932f = {}));
class $02121ace5914ef79$export$59687f9f87bf6f9d {
    static disablePointerEvents(control, events = null, includeChildren = false) {
        const savedEventsMap = new Map();
        if (events === null || events.includes($02121ace5914ef79$export$94806efd9890932f.PointerDown)) {
            savedEventsMap.set($02121ace5914ef79$export$94806efd9890932f.PointerDown, control._onPointerDown);
            control._onPointerDown = ()=>{
                return false;
            };
        }
        if (events === null || events.includes($02121ace5914ef79$export$94806efd9890932f.PointerUp)) {
            savedEventsMap.set($02121ace5914ef79$export$94806efd9890932f.PointerUp, control._onPointerUp);
            control._onPointerUp = ()=>{};
        }
        if (events === null || events.includes($02121ace5914ef79$export$94806efd9890932f.PointerEnter)) {
            savedEventsMap.set($02121ace5914ef79$export$94806efd9890932f.PointerEnter, control._onPointerEnter);
            control._onPointerEnter = ()=>{
                return false;
            };
        }
        if (events === null || events.includes($02121ace5914ef79$export$94806efd9890932f.PointerMove)) {
            savedEventsMap.set($02121ace5914ef79$export$94806efd9890932f.PointerMove, control._onPointerMove);
            control._onPointerMove = ()=>{};
        }
        if (events === null || events.includes($02121ace5914ef79$export$94806efd9890932f.PointerLeave)) {
            savedEventsMap.set($02121ace5914ef79$export$94806efd9890932f.PointerLeave, control._onPointerOut);
            control._onPointerOut = ()=>{};
        }
        $02121ace5914ef79$export$59687f9f87bf6f9d._disabledEvents.set(control.uniqueId, savedEventsMap);
        if (includeChildren) control.children?.forEach((c)=>$02121ace5914ef79$export$59687f9f87bf6f9d.disablePointerEvents(c, events, includeChildren));
    }
    static enableEvents(control, events = null, includeChildren = false) {
        if ($02121ace5914ef79$export$59687f9f87bf6f9d._disabledEvents.has(control.uniqueId)) {
            const savedEvents = $02121ace5914ef79$export$59687f9f87bf6f9d._disabledEvents.get(control.uniqueId);
            savedEvents?.forEach((v, k)=>{
                if (events === null || events.includes(k)) {
                    if (k === $02121ace5914ef79$export$94806efd9890932f.PointerEnter) control._onPointerEnter = v.bind(control);
                    else if (k === $02121ace5914ef79$export$94806efd9890932f.PointerMove) control._onPointerMove = v.bind(control);
                    else if (k === $02121ace5914ef79$export$94806efd9890932f.PointerLeave) control._onPointerOut = v.bind(control);
                    else if (k === $02121ace5914ef79$export$94806efd9890932f.PointerDown) control._onPointerDown = v.bind(control);
                    else if (k === $02121ace5914ef79$export$94806efd9890932f.PointerUp) control._onPointerUp = v.bind(control);
                }
            });
            $02121ace5914ef79$export$59687f9f87bf6f9d._disabledEvents.delete(control.uniqueId);
        }
        if (includeChildren) control.children?.forEach((c)=>$02121ace5914ef79$export$59687f9f87bf6f9d.enableEvents(c, events, includeChildren));
    }
}
$02121ace5914ef79$export$59687f9f87bf6f9d._disabledEvents = new Map();

});

parcelRegister("jw26v", function(module, exports) {

var $fCNdl = parcelRequire("fCNdl");
class $e352a349343dce4c$export$ed8dbf0c088db1aa {
    get overflowType() {
        return this._overflowType;
    }
    set overflowType(value) {
        this._overflowType = value;
    }
    get animationSpeed() {
        return this._animationSpeed;
    }
    set animationSpeed(value) {
        this._animationSpeed = value;
    }
    get overtravel() {
        return this._overtravel;
    }
    set overtravel(value) {
        this._overtravel = value;
    }
    /**
     *
     */ constructor(control){
        this._animationInterval = null;
        this._animationSpeed = 0.01;
        this._overtravel = 0;
        this._overflowType = "none";
        this._control = control;
    }
    _shouldAnimate() {
        if (this._animationInterval !== null) return false;
        const parent = this._control.parent;
        if (parent === null) return false;
        const children = parent.children;
        const widthFit = parent._currentMeasure.width > children.map((c)=>c._currentMeasure.width).reduce((p, c)=>p += c);
        const heightFit = parent._currentMeasure.height > children.map((c)=>c._currentMeasure.height).reduce((p, c)=>p += c);
        if (!widthFit && (this.overflowType === "both" || this.overflowType === "width") || !heightFit && (this.overflowType === "both" || this.overflowType === "height")) return true;
        return false;
    }
    _getAlignmentAdjustment(type) {
        const parent = this._control.parent;
        if (parent === null) return 0;
        if (type === "hor") switch(this._control.horizontalAlignment){
            case (0, $fCNdl.Control).HORIZONTAL_ALIGNMENT_LEFT:
                return 0;
            case (0, $fCNdl.Control).HORIZONTAL_ALIGNMENT_CENTER:
                return (this._control._currentMeasure.width - parent._currentMeasure.width) / 2;
            case (0, $fCNdl.Control).HORIZONTAL_ALIGNMENT_RIGHT:
                return this._control._currentMeasure.width - parent._currentMeasure.width;
        }
        else switch(this._control.verticalAlignment){
            case (0, $fCNdl.Control).VERTICAL_ALIGNMENT_TOP:
                return 0;
            case (0, $fCNdl.Control).VERTICAL_ALIGNMENT_CENTER:
                return (this._control._currentMeasure.height - parent._currentMeasure.height) / 2;
            case (0, $fCNdl.Control).VERTICAL_ALIGNMENT_BOTTOM:
                return this._control._currentMeasure.height - parent._currentMeasure.height;
        }
        return 0;
    }
    stopAnimation() {
        if (this.overflowType === "width" || this.overflowType === "both") this._control.leftInPixels = 0;
        if (this.overflowType === "height" || this.overflowType === "both") this._control.topInPixels = 0;
        if (this._animationInterval !== null) clearInterval(this._animationInterval);
        this._animationInterval = null;
    }
    startAnimation() {
        if (!this._shouldAnimate()) return false;
        const parent = this._control.parent;
        if (parent === null) return false;
        const children = parent.children;
        const widthDiff = children.map((c)=>c._currentMeasure.width).reduce((p, c)=>p += c) - parent._currentMeasure.width;
        const heightDiff = children.map((c)=>c._currentMeasure.height).reduce((p, c)=>p += c) - parent._currentMeasure.height;
        if (widthDiff < 0 && heightDiff < 0) return false;
        const updateInterval = 50;
        const horSpeed = widthDiff * this._animationSpeed;
        const vertSpeed = heightDiff * this._animationSpeed;
        const horTarget = this._control._currentMeasure.left - widthDiff;
        const vertTarget = this._control._currentMeasure.top - heightDiff;
        let isLeft = this._control.horizontalAlignment === (0, $fCNdl.Control).HORIZONTAL_ALIGNMENT_LEFT;
        let isUp = this._control.verticalAlignment === (0, $fCNdl.Control).VERTICAL_ALIGNMENT_TOP;
        const originalLeft = this._control._currentMeasure.left + this._getAlignmentAdjustment("hor");
        const originalTop = this._control._currentMeasure.top + this._getAlignmentAdjustment("vert");
        this._animationInterval = setInterval(()=>{
            if (widthDiff > 0 && (this.overflowType === "width" || this.overflowType === "both")) {
                if (this._control._currentMeasure.left - this._getAlignmentAdjustment("hor") > horTarget - this.overtravel && isLeft) this._control.leftInPixels -= horSpeed;
                else if (this._control._currentMeasure.left < originalLeft + this.overtravel && !isLeft) this._control.leftInPixels += horSpeed;
                else isLeft = !isLeft;
            }
            if (heightDiff > 0 && (this.overflowType === "height" || this.overflowType === "both")) {
                if (this._control._currentMeasure.top - this._getAlignmentAdjustment("vert") > vertTarget - this.overtravel && isUp) this._control.topInPixels -= vertSpeed;
                else if (this._control._currentMeasure.top < originalTop + this.overtravel && !isUp) this._control.topInPixels += vertSpeed;
                else isUp = !isUp;
            }
        }, updateInterval);
        return true;
    }
}

});

parcelRegister("dFcsz", function(module, exports) {
const $9f28c4eec23830b4$export$83d89fbfd8236492 = "2.0.5";

});

parcelRegister("9g0Cz", function(module, exports) {

var $kVtWi = parcelRequire("kVtWi");

var $jDt6c = parcelRequire("jDt6c");

var $cJN7d = parcelRequire("cJN7d");

var $2isQc = parcelRequire("2isQc");

var $jknux = parcelRequire("jknux");
(0, $2isQc.WebXRSessionManager).prototype.offerSession = function(xrSessionMode = "immersive-vr", xrSessionInit = {}) {
    //@ts-expect-error
    return this._xrNavigator.xr.offerSession(xrSessionMode, xrSessionInit).then((session)=>{
        this.session = session;
        //@ts-expect-error
        this._sessionMode = xrSessionMode;
        this.inXRSession = true;
        this.onXRSessionInit.notifyObservers(session);
        // handle when the session is ended (By calling session.end or device ends its own session eg. pressing home button on phone)
        this.session.addEventListener("end", ()=>{
            this.inXRSession = false;
            // Notify frame observers
            this.onXRSessionEnded.notifyObservers(null);
            //@ts-expect-error
            if (this._engine) {
                //@ts-expect-error
                // make sure dimensions object is restored
                this._engine.framebufferDimensionsObject = null;
                //@ts-expect-error
                // Restore frame buffer to avoid clear on xr framebuffer after session end
                this._engine.restoreDefaultFramebuffer();
                //@ts-expect-error
                // Need to restart render loop as after the session is ended the last request for new frame will never call callback
                this._engine.customAnimationFrameRequester = null;
                //@ts-expect-error
                this._engine._renderLoop();
            }
            // Dispose render target textures.
            // Only dispose on native because we can't destroy opaque textures on browser.
            if (this.isNative) //@ts-expect-error
            this._baseLayerRTTProvider?.dispose();
            //@ts-expect-error
            this._baseLayerRTTProvider = null;
            //@ts-expect-error
            this._baseLayerWrapper = null;
        }, {
            once: true
        });
        return this.session;
    });
};
(0, $jDt6c.WebXRExperienceHelper).prototype.hasOfferedSession = false;
(0, $jDt6c.WebXRExperienceHelper).prototype.offerXRSession = async function(sessionMode, referenceSpaceType, renderTarget = this.sessionManager.getWebXRRenderTarget(), sessionCreationOptions = {}) {
    //@ts-expect-error
    if (!this._supported) // eslint-disable-next-line no-throw-literal
    throw "WebXR not supported in this browser or environment";
    //@ts-expect-error
    if (navigator?.xr?.offerSession === undefined) throw "OfferSession not supported in this browser or environment";
    if (referenceSpaceType !== "viewer" && referenceSpaceType !== "local") {
        sessionCreationOptions.optionalFeatures = sessionCreationOptions.optionalFeatures || [];
        sessionCreationOptions.optionalFeatures.push(referenceSpaceType);
    }
    sessionCreationOptions = await this.featuresManager._extendXRSessionInitObject(sessionCreationOptions);
    // we currently recommend "unbounded" space in AR (#7959)
    if (sessionMode === "immersive-ar" && referenceSpaceType !== "unbounded") (0, $kVtWi.Logger).Warn("We recommend using 'unbounded' reference space type when using 'immersive-ar' session mode");
    // make sure that the session mode is supported
    try {
        if (!this.hasOfferedSession) {
            this.sessionManager.offerSession(sessionMode, sessionCreationOptions).then(async ()=>{
                this.hasOfferedSession = false;
                //@ts-expect-error
                this._setState((0, $jknux.WebXRState).ENTERING_XR);
                await this.sessionManager.setReferenceSpaceTypeAsync(referenceSpaceType);
                const xrRenderState = {
                    // if maxZ is 0 it should be "Infinity", but it doesn't work with the WebXR API. Setting to a large number.
                    depthFar: this.camera.maxZ || 10000,
                    depthNear: this.camera.minZ
                };
                // The layers feature will have already initialized the xr session's layers on session init.
                if (!this.featuresManager.getEnabledFeature((0, $cJN7d.WebXRFeatureName).LAYERS)) {
                    const baseLayer = await renderTarget.initializeXRLayerAsync(this.sessionManager.session);
                    xrRenderState.baseLayer = baseLayer;
                }
                this.sessionManager.updateRenderState(xrRenderState);
                // run the render loop
                this.sessionManager.runXRRenderLoop();
                // Cache pre xr scene settings
                //@ts-expect-error
                this._originalSceneAutoClear = this._scene.autoClear;
                //@ts-expect-error
                this._nonVRCamera = this._scene.activeCamera;
                //@ts-expect-error
                this._attachedToElement = !!this._nonVRCamera?.inputs?.attachedToElement;
                //@ts-expect-error
                this._nonVRCamera?.detachControl();
                //@ts-expect-error
                this._scene.activeCamera = this.camera;
                // do not compensate when AR session is used
                if (sessionMode !== "immersive-ar") //@ts-expect-error
                this._nonXRToXRCamera();
                else {
                    // Kept here, TODO - check if needed
                    //@ts-expect-error
                    this._scene.autoClear = false;
                    this.camera.compensateOnFirstFrame = false;
                    // reset the camera's position to the origin
                    this.camera.position.set(0, 0, 0);
                    this.camera.rotationQuaternion.set(0, 0, 0, 1);
                    this.onInitialXRPoseSetObservable.notifyObservers(this.camera);
                }
                this.sessionManager.onXRSessionEnded.addOnce(()=>{
                    // when using the back button and not the exit button (default on mobile), the session is ending but the EXITING state was not set
                    if (this.state !== (0, $jknux.WebXRState).EXITING_XR) //@ts-expect-error
                    this._setState((0, $jknux.WebXRState).EXITING_XR);
                    // Reset camera rigs output render target to ensure sessions render target is not drawn after it ends
                    this.camera.rigCameras.forEach((c)=>{
                        c.outputRenderTarget = null;
                    });
                    // Restore scene settings
                    //@ts-expect-error
                    this._scene.autoClear = this._originalSceneAutoClear;
                    //@ts-expect-error
                    this._scene.activeCamera = this._nonVRCamera;
                    //@ts-expect-error
                    if (this._attachedToElement && this._nonVRCamera) //@ts-expect-error
                    this._nonVRCamera.attachControl(!!this._nonVRCamera.inputs.noPreventDefault);
                    if (sessionMode !== "immersive-ar" && this.camera.compensateOnFirstFrame) {
                        //@ts-expect-error
                        if (this._nonVRCamera.setPosition) //@ts-expect-error
                        this._nonVRCamera.setPosition(this.camera.position);
                        else //@ts-expect-error
                        this._nonVRCamera.position.copyFrom(this.camera.position);
                    }
                    //@ts-expect-error
                    this._setState((0, $jknux.WebXRState).NOT_IN_XR);
                });
                // Wait until the first frame arrives before setting state to in xr
                this.sessionManager.onXRFrameObservable.addOnce(()=>{
                    //@ts-expect-error
                    this._setState((0, $jknux.WebXRState).IN_XR);
                });
            });
            this.hasOfferedSession = true;
        }
        return this.sessionManager;
    } catch (e) {
        (0, $kVtWi.Logger).Log(e);
        (0, $kVtWi.Logger).Log(e.message);
        //@ts-expect-error
        this._setState((0, $jknux.WebXRState).NOT_IN_XR);
        throw e;
    }
};

});


parcelRegister("jbmOc", function(module, exports) {
$parcel$export(module.exports, "Projection", () => (parcelRequire("52Ze3")).Projection);
$parcel$export(module.exports, "ProjectionMeshBabylonJS", () => (parcelRequire("euqMi")).ProjectionMeshBabylonJS);
parcelRequire("4FeII");
parcelRequire("bDaCE");
parcelRequire("euqMi");

var $8Qv4V = parcelRequire("8Qv4V");

});
parcelRegister("4FeII", function(module, exports) {
$parcel$export(module.exports, "MeshType", () => (parcelRequire("52Ze3")).MeshType);
$parcel$export(module.exports, "Projection", () => (parcelRequire("52Ze3")).Projection);
$parcel$export(module.exports, "StereoTargetEye", () => (parcelRequire("52Ze3")).StereoTargetEye);
$parcel$export(module.exports, "ProjectionShaderKeyword", () => (parcelRequire("jZM2N")).ProjectionShaderKeyword);
$parcel$export(module.exports, "ProjectionShaderUniform", () => (parcelRequire("jZM2N")).ProjectionShaderUniform);
$parcel$export(module.exports, "Utils", () => (parcelRequire("jZM2N")).Utils);
parcelRequire("52Ze3");
parcelRequire("7yfRl");
parcelRequire("jZM2N");
const $365668df94097be0$export$682c179f50ab847d = "2.9.0-rc.0";

});
parcelRegister("52Ze3", function(module, exports) {

$parcel$export(module.exports, "MeshType", () => $3acca1c730f69494$export$687b8c3c7a7e038d);
$parcel$export(module.exports, "StereoMode", () => $3acca1c730f69494$export$ec20dfa68810b176);
$parcel$export(module.exports, "StereoTargetEye", () => $3acca1c730f69494$export$846b10b2b43336e0);
$parcel$export(module.exports, "Projection", () => $3acca1c730f69494$export$dfa3a012bb2ef2e1);
/**
 * Mesh type.
 */ var $3acca1c730f69494$export$687b8c3c7a7e038d;
(function(MeshType) {
    /**Flat.*/ MeshType[MeshType["Flat"] = 0] = "Flat";
    /**Sphere.*/ MeshType[MeshType["Sphere"] = 1] = "Sphere";
    /**Fisheye.*/ MeshType[MeshType["Fisheye"] = 2] = "Fisheye";
    /**Cylinder */ MeshType[MeshType["Cylinder"] = 3] = "Cylinder";
})($3acca1c730f69494$export$687b8c3c7a7e038d || ($3acca1c730f69494$export$687b8c3c7a7e038d = {}));
var $3acca1c730f69494$export$ec20dfa68810b176;
(function(StereoMode) {
    /**None.*/ StereoMode[StereoMode["None"] = 0] = "None";
    /**Top-Bottom (Over-Under).*/ StereoMode[StereoMode["TopBottom"] = 1] = "TopBottom";
    /**Left-Right (Side-By-Side).*/ StereoMode[StereoMode["LeftRight"] = 2] = "LeftRight";
})($3acca1c730f69494$export$ec20dfa68810b176 || ($3acca1c730f69494$export$ec20dfa68810b176 = {}));
var $3acca1c730f69494$export$846b10b2b43336e0;
(function(StereoTargetEye) {
    /**Both eyes. */ StereoTargetEye[StereoTargetEye["Both"] = 0] = "Both";
    /**Left eye. */ StereoTargetEye[StereoTargetEye["First"] = 1] = "First";
    /**Right eye. */ StereoTargetEye[StereoTargetEye["Second"] = 2] = "Second";
})($3acca1c730f69494$export$846b10b2b43336e0 || ($3acca1c730f69494$export$846b10b2b43336e0 = {}));
/**@private */ const $3acca1c730f69494$var$_H_FOV_MIN = 1;
/**@private */ const $3acca1c730f69494$var$_H_FOV_MAX = 360;
/**@private */ const $3acca1c730f69494$var$_V_FOV_MIN = 1;
/**@private */ const $3acca1c730f69494$var$_V_FOV_MAX = 180;
/**@private */ const $3acca1c730f69494$var$_TILT_MIN = -90;
/**@private */ const $3acca1c730f69494$var$_TILT_MAX = 90;
/**@private */ const $3acca1c730f69494$var$_MESH_OFFSET_MAX = 1;
/**@private */ const $3acca1c730f69494$var$_MESH_OFFSET_MIN = -1;
/**@private */ const $3acca1c730f69494$var$_ZOOM_MAX = 1;
/**@private */ const $3acca1c730f69494$var$_ZOOM_MIN = -1;
/**
 * Clamps passed value between the min and max values.
 *
 * @param value Original value.
 * @param min Minimal value.
 * @param max Maximal value.
 * @returns Clamped value.
 * @private
 */ const $3acca1c730f69494$var$Clamp = function(value, min, max) {
    if (value < min) return min;
    if (value > max) return max;
    return value;
};
class $3acca1c730f69494$export$dfa3a012bb2ef2e1 {
    _stereoMode;
    _meshType;
    _fov;
    _verticalMeshOffset;
    _tilt;
    _distL;
    _distR;
    _focalLength;
    _isRotated;
    _circularCropRadiusLeft;
    _circularCropRadiusRight;
    _zoom;
    _chromaKeyColor;
    _chromaKeyDistance;
    _chromaKeySmoothness;
    /**
     * Constructor.
     *
     * @param stereoMode Stereo mode: None, Top-Bottom or Left-Right.
     * @param meshType Mesh type: Fisheye, Sphere or Flat (default).
     * @param hFov Horizontal FOV in degrees. Valid values range from 1 to 360.
     * @param vFov Vertical FOV in degrees. Valid values range from 1 to 180.
     * @param verticalMeshOffset Vertical offset due to asymmetrical vertical crop. Valid values range from -1 to 1.
     * @param tilt Vertical rotation in degrees. Valid values range from -90 to 90.
     * @param distL Left camera distortion data.
     * @param distR Right camera distortion data.
     * @param focalLength Focal length in pixels.
     * @param isRotated 90 degrees rotation flag.
     */ constructor(stereoMode, meshType, hFov, vFov, verticalMeshOffset, tilt, distL, distR, focalLength, isRotated, circularCropRadiusLeft, circularCropRadiusRight, zoom, chromaKeyColor, chromaKeyDistance, chromaKeySmoothness){
        this._stereoMode = stereoMode ?? $3acca1c730f69494$export$ec20dfa68810b176.None;
        this._meshType = meshType ?? $3acca1c730f69494$export$687b8c3c7a7e038d.Flat;
        this._fov = {
            x: hFov ?? 0,
            y: vFov ?? 0
        };
        this._verticalMeshOffset = verticalMeshOffset ?? 0;
        this._tilt = tilt ?? 0;
        this._distL = distL ?? {
            centerOffset: {
                x: 0,
                y: 0
            },
            coefficients: {
                x: 0,
                y: 0,
                z: 0,
                w: 0
            }
        };
        this._distR = distR ?? {
            centerOffset: {
                x: 0,
                y: 0
            },
            coefficients: {
                x: 0,
                y: 0,
                z: 0,
                w: 0
            }
        };
        this._focalLength = focalLength ?? 0;
        this._isRotated = isRotated ?? false;
        this._circularCropRadiusLeft = circularCropRadiusLeft ?? 0;
        this._circularCropRadiusRight = circularCropRadiusRight ?? 0;
        this._zoom = zoom ?? 0;
        this._chromaKeyColor = chromaKeyColor ?? "00FF00";
        this._chromaKeyDistance = chromaKeyDistance ?? 0;
        this._chromaKeySmoothness = chromaKeySmoothness ?? 0;
        this.Validate();
    }
    /**
     * Stereo mode: None, Top-Bottom or Left-Right.
     */ get StereoMode() {
        return this._stereoMode;
    }
    set StereoMode(stereoMode) {
        this._stereoMode = stereoMode;
    }
    /**
     * Mesh type: Fisheye, Sphere or Flat (default).
     */ get MeshType() {
        return this._meshType;
    }
    set MeshType(meshType) {
        this._meshType = meshType;
    }
    /**
     * FOVs in degrees.
     */ get Fov() {
        return this._fov;
    }
    set Fov(fov) {
        this._fov = {
            x: $3acca1c730f69494$var$Clamp(fov.x, $3acca1c730f69494$var$_H_FOV_MIN, $3acca1c730f69494$var$_H_FOV_MAX),
            y: $3acca1c730f69494$var$Clamp(fov.y, $3acca1c730f69494$var$_V_FOV_MIN, $3acca1c730f69494$var$_V_FOV_MAX)
        };
    }
    /**
     * Vertical offset due to asymmetrical vertical crop. Valid values range from -1 to 1.
     */ get VerticalMeshOffset() {
        return this._verticalMeshOffset;
    }
    set VerticalMeshOffset(verticalMeshOffset) {
        this._verticalMeshOffset = $3acca1c730f69494$var$Clamp(verticalMeshOffset, $3acca1c730f69494$var$_MESH_OFFSET_MIN, $3acca1c730f69494$var$_MESH_OFFSET_MAX);
    }
    /**
     * Vertical rotation in degrees. Valid values range from -90 to 90.
     */ get Tilt() {
        return this._tilt;
    }
    set Tilt(tilt) {
        this._tilt = $3acca1c730f69494$var$Clamp(tilt, $3acca1c730f69494$var$_TILT_MIN, $3acca1c730f69494$var$_TILT_MAX);
    }
    /**
     * Left camera distortion data.
     */ get DistL() {
        return this._distL;
    }
    set DistL(distL) {
        this._distL = distL;
    }
    /**
     * Right camera distortion data.
     */ get DistR() {
        return this._distR;
    }
    set DistR(distR) {
        this._distR = distR;
    }
    /**
     * Focal length in pixels.
     */ get FocalLength() {
        return this._focalLength;
    }
    set FocalLength(focalLength) {
        this._focalLength = focalLength;
    }
    /**
     * 90 degrees rotation flag.
     */ get IsRotated() {
        return this._isRotated;
    }
    set IsRotated(isRotated) {
        this._isRotated = isRotated;
    }
    /**
     * Left circular crop radius.
     */ get CircularCropRadiusLeft() {
        return this._circularCropRadiusLeft;
    }
    set CircularCropRadiusLeft(circularCropRadiusLeft) {
        this._circularCropRadiusLeft = circularCropRadiusLeft;
    }
    /**
     * Right circular crop radius.
     */ get CircularCropRadiusRight() {
        return this._circularCropRadiusRight;
    }
    set CircularCropRadiusRight(circularCropRadiusRight) {
        this._circularCropRadiusRight = circularCropRadiusRight;
    }
    /**
     * Zoom modifier. Valid values range from -1 to 1;
     */ get Zoom() {
        return this._zoom;
    }
    set Zoom(zoom) {
        this._zoom = zoom;
    }
    /**
     * Chroma key color.
     */ get ChromaKeyColor() {
        return this._chromaKeyColor;
    }
    set ChromaKeyColor(value) {
        this._chromaKeyColor = value;
    }
    /**
     * Color space distance for the chroma keying.
     */ get ChromaKeyDistance() {
        return this._chromaKeyDistance;
    }
    set ChromaKeyDistance(value) {
        this._chromaKeyDistance = value;
    }
    /**
     * Chroma key smoothness.
     */ get ChromaKeySmoothness() {
        return this._chromaKeySmoothness;
    }
    set ChromaKeySmoothness(value) {
        this._chromaKeySmoothness = value;
    }
    /**
     * Clamps HFov, VFov, Tilt, VerticalMeshOffset to the their valid values ranges.
     */ Validate() {
        this._fov.x = $3acca1c730f69494$var$Clamp(this._fov.x, $3acca1c730f69494$var$_H_FOV_MIN, $3acca1c730f69494$var$_H_FOV_MAX);
        this._fov.y = $3acca1c730f69494$var$Clamp(this._fov.y, $3acca1c730f69494$var$_V_FOV_MIN, $3acca1c730f69494$var$_V_FOV_MAX);
        this._tilt = $3acca1c730f69494$var$Clamp(this._tilt, $3acca1c730f69494$var$_TILT_MIN, $3acca1c730f69494$var$_TILT_MAX);
        this._verticalMeshOffset = $3acca1c730f69494$var$Clamp(this._verticalMeshOffset, $3acca1c730f69494$var$_MESH_OFFSET_MIN, $3acca1c730f69494$var$_MESH_OFFSET_MAX);
        this._zoom = $3acca1c730f69494$var$Clamp(this._zoom, $3acca1c730f69494$var$_ZOOM_MIN, $3acca1c730f69494$var$_ZOOM_MAX);
    }
    /**
     * Parse a query.
     *
     * @param url - URL.
     * @returns Map of parsed results.
     */ static ParseQuery(url) {
        const result = new Map();
        if (!url) return result;
        const question = url.indexOf("?");
        let hash = url.indexOf("#");
        if (hash == -1 && question == -1) hash = 0;
        if (hash == -1) hash = url.length;
        const query = question == -1 || hash == question + 1 ? url.substring(hash) : url.substring(question + 1, hash);
        query.split("&").forEach((part)=>{
            if (!part) return;
            part = part.split("+").join(" "); // replace every + with space, regexp-free version ?asd=foo&qwe[zxc]=bar
            let eq = part.indexOf("=");
            let key = eq > -1 ? part.substring(0, eq) : part;
            let val = eq > -1 ? decodeURIComponent(part.substring(eq + 1)) : "";
            let from = key.indexOf("[");
            if (from == -1) result.set(decodeURIComponent(key), val);
            else {
                let to = key.indexOf("]", from);
                let index = parseInt(decodeURIComponent(key.substring(from + 1, to)));
                key = decodeURIComponent(key.substring(0, from));
                if (!result.has(key)) result.set(key, []);
                if (!index) result.get(key).push(val);
                else result.get(key)[index] = val;
            }
        });
        return result;
    }
    /**
     * Parse projection params.
     *
     * @param url - Stream url.
     * @returns Projection parameters.
     */ static FromString(url) {
        const params = $3acca1c730f69494$export$dfa3a012bb2ef2e1.ParseQuery(url);
        const readFloat = (name)=>params.get(name) ? parseFloat(params.get(name)) : 0;
        const readBoolean = (name)=>params.get(name) ? params.get(name).toLowerCase() == 'true' : false;
        const readString = (name)=>params.get(name) || "";
        const stereoMode = readString("stereoPacking");
        const meshType = readString("frameFormat");
        let sm = $3acca1c730f69494$export$ec20dfa68810b176.None;
        switch(stereoMode.toUpperCase()){
            case "LR":
            case "SBS":
                sm = $3acca1c730f69494$export$ec20dfa68810b176.LeftRight;
                break;
            case "TB":
            case "OU":
                sm = $3acca1c730f69494$export$ec20dfa68810b176.TopBottom;
                break;
            case "NONE":
                sm = $3acca1c730f69494$export$ec20dfa68810b176.None;
                break;
        }
        let mt = $3acca1c730f69494$export$687b8c3c7a7e038d.Flat;
        switch(meshType.toUpperCase()){
            case "FISHEYE":
                mt = $3acca1c730f69494$export$687b8c3c7a7e038d.Fisheye;
                break;
            case "SPHERE":
                mt = $3acca1c730f69494$export$687b8c3c7a7e038d.Sphere;
                break;
            case "CYLINDER":
                mt = $3acca1c730f69494$export$687b8c3c7a7e038d.Cylinder;
                break;
            case "FLAT":
                mt = $3acca1c730f69494$export$687b8c3c7a7e038d.Flat;
                break;
        }
        const projection = new $3acca1c730f69494$export$dfa3a012bb2ef2e1(sm, mt, readFloat("horizontalAngle"), readFloat("verticalAngle"), readFloat("fisheyeCenterY"), readFloat("verticalTilt"), {
            centerOffset: {
                x: readFloat("lcx"),
                y: readFloat("lcy")
            },
            coefficients: {
                x: readFloat("lkx"),
                y: readFloat("lky"),
                z: readFloat("lkz"),
                w: readFloat("lkw")
            }
        }, {
            centerOffset: {
                x: readFloat("rcx"),
                y: readFloat("rcy")
            },
            coefficients: {
                x: readFloat("rkx"),
                y: readFloat("rky"),
                z: readFloat("rkz"),
                w: readFloat("rkw")
            }
        }, readFloat("fl"), readBoolean("isRotated"), readFloat("cropLeft"), readFloat("cropRight"), readFloat("zoom"), readString("keyColor"), readFloat("keyDist"), readFloat("keySmooth"));
        return projection;
    }
    /**
     * Builds URI string based on projection params.
     *
     * @param projection Projection to use.
     *
     * @returns URI.
     */ static ToString(projection) {
        let stereoMode = "NONE";
        switch(projection.StereoMode){
            case $3acca1c730f69494$export$ec20dfa68810b176.LeftRight:
                stereoMode = "LR";
                break;
            case $3acca1c730f69494$export$ec20dfa68810b176.TopBottom:
                stereoMode = "TB";
                break;
            case $3acca1c730f69494$export$ec20dfa68810b176.None:
                stereoMode = "NONE";
                break;
        }
        let meshType = "FLAT";
        switch(projection.MeshType){
            case $3acca1c730f69494$export$687b8c3c7a7e038d.Fisheye:
                meshType = "FISHEYE";
                break;
            case $3acca1c730f69494$export$687b8c3c7a7e038d.Sphere:
                meshType = "SPHERE";
                break;
            case $3acca1c730f69494$export$687b8c3c7a7e038d.Cylinder:
                meshType = "CYLINDER";
                break;
            case $3acca1c730f69494$export$687b8c3c7a7e038d.Flat:
                meshType = "FLAT";
                break;
        }
        const paramOrEmpty = (paramName, value)=>{
            if (value == 0 || value == undefined) return "";
            return `&${paramName}=${value}`;
        };
        const vector2ToString = (v, prefix)=>{
            return `${paramOrEmpty(prefix + "x", v.x)}${paramOrEmpty(prefix + "y", v.y)}`;
        };
        const vector4ToString = (v, prefix)=>{
            return `${paramOrEmpty(prefix + "x", v.x)}${paramOrEmpty(prefix + "y", v.y)}${paramOrEmpty(prefix + "z", v.z)}${paramOrEmpty(prefix + "w", v.w)}`;
        };
        const distortionDataToString = function(d, prefix) {
            return `${vector2ToString(d.centerOffset, prefix + "c")}${vector4ToString(d.coefficients, prefix + "k")}`;
        };
        return `stereoPacking=${stereoMode}&frameFormat=${meshType}&horizontalAngle=${projection.Fov.x}&verticalAngle=${projection.Fov.y}&fisheyeCenterY=${projection.VerticalMeshOffset}&verticalTilt=${projection.Tilt}${distortionDataToString(projection.DistL, "l")}${distortionDataToString(projection.DistR, "r")}&fl=${projection.FocalLength}&cropLeft=${projection.CircularCropRadiusLeft}&cropRight=${projection.CircularCropRadiusRight}&zoom=${projection.Zoom}${projection.IsRotated ? "&isRotated=True" : ""}&keyColor=${projection.ChromaKeyColor}&keyDist=${projection.ChromaKeyDistance}&keySmooth=${projection.ChromaKeySmoothness}`;
    }
    /**
     * Builds URI string based on projection params.
     *
     * @returns URI.
     */ ToString() {
        return $3acca1c730f69494$export$dfa3a012bb2ef2e1.ToString(this);
    }
}

});

parcelRegister("7yfRl", function(module, exports) {

});

parcelRegister("jZM2N", function(module, exports) {

$parcel$export(module.exports, "ProjectionShaderKeyword", () => $e8e8fb61d388b945$export$897931a6b43971d4);
$parcel$export(module.exports, "ProjectionShaderUniform", () => $e8e8fb61d388b945$export$72e97c28153c5fa2);
$parcel$export(module.exports, "Utils", () => $e8e8fb61d388b945$export$d2ca453b913dcdea);

var $52Ze3 = parcelRequire("52Ze3");

var $eEhAj = parcelRequire("eEhAj");

var $Cf2PW = parcelRequire("Cf2PW");
var $e8e8fb61d388b945$export$897931a6b43971d4;
(function(ProjectionShaderKeyword) {
    ProjectionShaderKeyword["None"] = "";
    ProjectionShaderKeyword["ApplyGamma"] = "APPLY_GAMMA";
    ProjectionShaderKeyword["DistortedImage"] = "DISTORTED_IMAGE";
    ProjectionShaderKeyword["StereoConvergence"] = "STEREO_CONVERGENCE";
    ProjectionShaderKeyword["StereoVideoTopBottom"] = "STEREOVIDEO_TOP_BOTTOM";
    ProjectionShaderKeyword["StereoVideoLeftRight"] = "STEREOVIDEO_LEFT_RIGHT";
    ProjectionShaderKeyword["EyesFirst"] = "EYES_FIRST";
    ProjectionShaderKeyword["EyesSecond"] = "EYES_SECOND";
    ProjectionShaderKeyword["StereoEyeLeft"] = "STEREO_EYE_LEFT";
    ProjectionShaderKeyword["Grayscale"] = "GRAYSCALE";
    ProjectionShaderKeyword["ImageSettingsEnabled"] = "IMAGE_SETTINGS_ENABLED";
    ProjectionShaderKeyword["CutCorners"] = "CUT_CORNERS";
    ProjectionShaderKeyword["FlipEyes"] = "FLIP_EYES";
    ProjectionShaderKeyword["CircularCrop"] = "CIRCULAR_CROP";
    ProjectionShaderKeyword["Multiview"] = "MULTIVIEW";
    ProjectionShaderKeyword["ChromaKey"] = "CHROMA_KEY";
    ProjectionShaderKeyword["Blur"] = "BLUR";
    ProjectionShaderKeyword["GradualBlur"] = "GRADUAL_BLUR";
    ProjectionShaderKeyword["ColorMultiplier"] = "COLOR_MULTIPLIER";
    ProjectionShaderKeyword["BlendStereo"] = "BLEND_STEREO";
    ProjectionShaderKeyword["Zoom"] = "ZOOM";
    ProjectionShaderKeyword["MaskDeo"] = "MASK_DEO";
})($e8e8fb61d388b945$export$897931a6b43971d4 || ($e8e8fb61d388b945$export$897931a6b43971d4 = {}));
var $e8e8fb61d388b945$export$72e97c28153c5fa2;
(function(ProjectionShaderUniform) {
    ProjectionShaderUniform["StereoVideo"] = "_StereoVideo";
    ProjectionShaderUniform["StereoConvergence"] = "_StereoConvergence";
    ProjectionShaderUniform["CameraRotation"] = "_CameraRotation";
    ProjectionShaderUniform["ApplyGamma"] = "_ApplyGamma";
    ProjectionShaderUniform["DistortedImage"] = "_DistortedImage";
    ProjectionShaderUniform["FocalLengths"] = "_FocalLengths";
    ProjectionShaderUniform["BlendStereo"] = "_BlendStereo";
    ProjectionShaderUniform["DistortionCenterOffsetLeft"] = "_DistortionCenterOffsetLeft";
    ProjectionShaderUniform["DistortionCenterOffsetRight"] = "_DistortionCenterOffsetRight";
    ProjectionShaderUniform["DistortionCoefficientsLeft"] = "_DistortionCoefficientsLeft";
    ProjectionShaderUniform["DistortionCoefficientsRight"] = "_DistortionCoefficientsRight";
    ProjectionShaderUniform["FovToResolutionRatio"] = "_FovToResolutionRatio";
    ProjectionShaderUniform["MeshScale"] = "_MeshScale";
    ProjectionShaderUniform["MainTex"] = "_MainTex";
    ProjectionShaderUniform["MainTexST"] = "_MainTex_ST";
    ProjectionShaderUniform["PixelSize"] = "_PixelSize";
    ProjectionShaderUniform["Brightness"] = "_Brightness";
    ProjectionShaderUniform["Contrast"] = "_Contrast";
    ProjectionShaderUniform["HueDelta"] = "_HueDelta";
    ProjectionShaderUniform["SatDelta"] = "_SatDelta";
    ProjectionShaderUniform["SharpenStrength"] = "_SharpenStrength";
    ProjectionShaderUniform["CornerDistance"] = "_CornerDistance";
    ProjectionShaderUniform["StereoOffset"] = "_StereoOffset";
    ProjectionShaderUniform["CircularCropRadiusLeft"] = "_CircularCropRadiusLeft";
    ProjectionShaderUniform["CircularCropRadiusRight"] = "_CircularCropRadiusRight";
    ProjectionShaderUniform["Zoom"] = "_Zoom";
    ProjectionShaderUniform["ChromaKeyColor"] = "_ChromaKeyColor";
    ProjectionShaderUniform["ChromaKeyDistance"] = "_ChromaKeyDistance";
    ProjectionShaderUniform["ChromaKeySmoothness"] = "_ChromaKeySmoothness";
    ProjectionShaderUniform["BlurEdgeDistance"] = "_BlurEdgeDistance";
    ProjectionShaderUniform["BlurKernel"] = "_BlurKernel";
    ProjectionShaderUniform["ColorMultiplier"] = "_ColorMultiplier";
})($e8e8fb61d388b945$export$72e97c28153c5fa2 || ($e8e8fb61d388b945$export$72e97c28153c5fa2 = {}));
class $e8e8fb61d388b945$export$d2ca453b913dcdea {
    static _DIM_X = 32;
    static _DIM_Y = 32;
    static _degToRad = Math.PI / 180;
    static _stereoModeKeywords = [
        $e8e8fb61d388b945$export$897931a6b43971d4.None,
        $e8e8fb61d388b945$export$897931a6b43971d4.StereoVideoTopBottom,
        $e8e8fb61d388b945$export$897931a6b43971d4.StereoVideoLeftRight
    ];
    static _eyesActiveKeywords = [
        $e8e8fb61d388b945$export$897931a6b43971d4.None,
        $e8e8fb61d388b945$export$897931a6b43971d4.EyesFirst,
        $e8e8fb61d388b945$export$897931a6b43971d4.EyesSecond
    ];
    /**Horizontal dimension.*/ static get DIM_X() {
        return $e8e8fb61d388b945$export$d2ca453b913dcdea._DIM_X;
    }
    /**Vertical dimension.*/ static get DIM_Y() {
        return $e8e8fb61d388b945$export$d2ca453b913dcdea._DIM_Y;
    }
    /**Degrees to radians multiplier.*/ static get DegToRad() {
        return $e8e8fb61d388b945$export$d2ca453b913dcdea._degToRad;
    }
    /**Vertex shader.*/ static get Vert() {
        return 0, $Cf2PW.value;
    }
    /**Fragment shader */ static get Frag() {
        return 0, $eEhAj.value;
    }
    /**Shader stereo mode keywords.*/ static get StereoModeKeywords() {
        return $e8e8fb61d388b945$export$d2ca453b913dcdea._stereoModeKeywords;
    }
    /**Shader eyes active keywords.*/ static get EyesActiveKeywords() {
        return $e8e8fb61d388b945$export$d2ca453b913dcdea._eyesActiveKeywords;
    }
    /**
     * Approximate comparison of two numbers.
     *
     * @param l Left number.
     * @param r Right number.
     *
     * @returns True if numbers are approximately equal.
     */ static Approximately(l, r = 0) {
        return Math.abs(l - r) <= Number.EPSILON;
    }
    /**
     * Check if an object implements IVector2 interface
     *
     * @param v Object to check.
     */ static IsIVector2(v) {
        return "x" in v && "y" in v;
    }
    /**
     * Check if an object implements IVector3 interface
     *
     * @param v Object to check.
     */ static IsIVector3(v) {
        return $e8e8fb61d388b945$export$d2ca453b913dcdea.IsIVector2(v) && "z" in v;
    }
    /**
     * Check if an object implements IVector4 interface
     *
     * @param v Object to check.
     */ static IsIVector4(v) {
        return $e8e8fb61d388b945$export$d2ca453b913dcdea.IsIVector3(v) && "w" in v;
    }
    /**
     * Check if all components of two vectors are equals.
     * @param l Left vector
     * @param r Right vector
     * @returns True if all components are equal
     */ static VectorEquals(l, r) {
        if (this.IsIVector2(l) !== this.IsIVector2(r) || this.IsIVector3(l) !== this.IsIVector3(r) || this.IsIVector4(l) !== this.IsIVector4(r)) return false;
        let retVal = $e8e8fb61d388b945$export$d2ca453b913dcdea.Approximately(l.x, r.x) && $e8e8fb61d388b945$export$d2ca453b913dcdea.Approximately(l.y, r.x);
        if (this.IsIVector3(l) && this.IsIVector3(r)) retVal = retVal && $e8e8fb61d388b945$export$d2ca453b913dcdea.Approximately(l.z, r.z);
        if (this.IsIVector4(l) && this.IsIVector4(r)) retVal = retVal && $e8e8fb61d388b945$export$d2ca453b913dcdea.Approximately(l.w, r.w);
        return retVal;
    }
    /**
     * Checks if all components of a vector are zero.
     *
     * @param v Vector to check
     *
     * @returns True if all components are zero.
     */ static VectorIsZero(v) {
        if (this.IsIVector2(v)) return this.VectorEquals(v, {
            x: 0,
            y: 0
        });
        if (this.IsIVector3(v)) return this.VectorEquals(v, {
            x: 0,
            y: 0,
            z: 0
        });
        if (this.IsIVector4(v)) return this.VectorEquals(v, {
            x: 0,
            y: 0,
            z: 0,
            w: 0
        });
        return false;
    }
    /**
     * Converts a vector into an array.
     *
     * @param v Vector.
     *
     * @returns Array.
     */ static VectorToArray(v) {
        let retVal = [
            v.x,
            v.y
        ];
        if (this.IsIVector3(v)) {
            retVal.push(v.z);
            if (this.IsIVector4(v)) retVal.push(v.w);
        }
        return retVal;
    }
    /**
     * Linear interpolation.
     *
     * @param from Number to interpolate from.
     * @param to Number to interpolate to.
     * @param step Interpolation step.
     */ static Lerp(from, to, step) {
        return from * (1 - step) + to * step;
    }
    /**
     * Applies passed function with arguments to all passed objects.
     *
     * @param func Function.
     * @param arg Arguments.
     * @param obj Objects to apply function to.
     */ static ApplyToMultiple(func, arg, ...obj) {
        for (const o of obj)if (o) func.apply(o, [
            arg
        ]);
    }
    /**
     * Calculates mesh scale at the point.
     *
     * @param point Point to check.
     * @param coefficients Distortion coefficients.
     * @param centerOffset Distortion center offsets.
     * @param focalLengths Horizontal and vertical focal lengths.
     * @param fovToResolutionRatio Ratio of fov ratio to resolution ratio (e.g. 128/111 to 2160/1920).
     */ static GetScale(point, coefficients, centerOffset, focalLengths, fovToResolutionRatio) {
        const center = {
            x: 0.5 + centerOffset.x,
            y: 0.5 + centerOffset.y
        };
        const delta = {
            x: (point.x - center.x) / focalLengths.x * fovToResolutionRatio.x,
            y: (point.y - center.y) / focalLengths.y * fovToResolutionRatio.y
        };
        const r = Math.sqrt(Math.pow(delta.x, 2) + Math.pow(delta.y, 2));
        const theta = Math.atan(r);
        const theta_d = theta * (1 + coefficients.x * Math.pow(theta, 2) + coefficients.y * Math.pow(theta, 4) + coefficients.z * Math.pow(theta, 6) + coefficients.w * Math.pow(theta, 8));
        const scale = $e8e8fb61d388b945$export$d2ca453b913dcdea.Approximately(r, 0) ? 1.0 : theta_d / r;
        const res = {
            x: scale * delta.x,
            y: scale * delta.y
        };
        let x = focalLengths.x * res.x + center.x;
        let y = focalLengths.y * res.y + center.y;
        if (x < center.x) x = 1 - x;
        if (y < center.y) y = 1 - y;
        return {
            x: x > 0 ? 1 / x : 1,
            y: y > 0 ? 1 / y : 1
        };
    }
    static CalculateFov(projection, imageSize) {
        if (projection.Fov.x <= 1 && projection.Fov.y <= 1 && imageSize !== undefined && imageSize.x > 0 && imageSize.y > 0 && (projection.MeshType === (0, $52Ze3.MeshType).Flat || projection.MeshType === (0, $52Ze3.MeshType).Cylinder)) {
            let viewSize = {
                x: imageSize.x,
                y: imageSize.y
            };
            if (projection.StereoMode === (0, $52Ze3.StereoMode).LeftRight) viewSize.x /= 2;
            else if (projection.StereoMode === (0, $52Ze3.StereoMode).TopBottom) viewSize.y /= 2;
            const digits = Math.floor(Math.max(Math.log10(viewSize.x), Math.log10(viewSize.y)));
            const ratio = viewSize.x / viewSize.y;
            let x = viewSize.x / Math.pow(10, digits) * 100;
            let y = x / ratio;
            if (x >= y && x > 180) {
                x = 180;
                y = x / ratio;
            } else if (y >= x && y > 180) {
                y = 180;
                x = y * ratio;
            }
            return {
                x: x,
                y: y
            };
        }
        return projection.Fov;
    }
    /**
     * Generates a mesh vertices and uvs based on the projection.
     *
     * @param projection Projection to use when generating the mesh.
     *
     * @returns Generated mesh.
     */ static GenerateMesh(projection, imageSize) {
        const vertices = [];
        const uvs = [];
        const fov = this.CalculateFov(projection, imageSize);
        switch(projection.MeshType){
            case (0, $52Ze3.MeshType).Sphere:
                {
                    const center = {
                        x: 0.5,
                        y: 0.5 + projection.VerticalMeshOffset
                    };
                    const hFovRad = fov.x * $e8e8fb61d388b945$export$d2ca453b913dcdea.DegToRad;
                    const vFovRad = fov.y * $e8e8fb61d388b945$export$d2ca453b913dcdea.DegToRad;
                    for(let dy = 0; dy < $e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_Y; dy++)for(let dx = 0; dx < $e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_X; dx++){
                        const theta = -(dx / ($e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_X - 1) - center.x) * hFovRad;
                        const phi = -(dy / ($e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_Y - 1) - center.y) * vFovRad;
                        const psph = {
                            x: Math.cos(phi) * Math.sin(theta),
                            y: -Math.sin(phi),
                            z: Math.cos(phi) * Math.cos(theta)
                        };
                        vertices[dx + dy * $e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_X] = psph;
                        uvs[dx + dy * $e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_X] = projection.IsRotated ? {
                            x: 1 - dy / ($e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_Y - 1),
                            y: dx / ($e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_X - 1)
                        } : {
                            x: 1 - dx / ($e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_X - 1),
                            y: dy / ($e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_Y - 1)
                        };
                    }
                    break;
                }
            case (0, $52Ze3.MeshType).Fisheye:
                {
                    const fisheye = function(p, fov, offset) {
                        const phiMax = fov.x > fov.y ? fov.x : fov.y;
                        p.y += 2 * offset;
                        p.x *= fov.x / phiMax;
                        p.y *= fov.y / phiMax;
                        const r = Math.sqrt(Math.pow(p.x, 2) + Math.pow(p.y, 2));
                        const theta = Math.atan2(p.y, p.x);
                        const phi = r * phiMax / 2 - Math.PI / 2;
                        return {
                            x: Math.cos(phi) * Math.cos(theta),
                            y: -Math.cos(phi) * Math.sin(theta),
                            z: -Math.sin(phi)
                        };
                    };
                    let idx = 0;
                    const fovRad = {
                        x: fov.x * $e8e8fb61d388b945$export$d2ca453b913dcdea.DegToRad,
                        y: fov.y * $e8e8fb61d388b945$export$d2ca453b913dcdea.DegToRad
                    };
                    for(let y = -$e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_Y / 2; y < $e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_Y / 2 + $e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_Y / ($e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_Y - 1) / 2; y += $e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_Y / ($e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_Y - 1))for(let x = -$e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_X / 2; x < $e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_X / 2 + $e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_X / ($e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_X - 1) / 2; x += $e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_X / ($e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_X - 1)){
                        vertices[idx] = fisheye({
                            x: x / ($e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_X / 2),
                            y: y / ($e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_Y / 2)
                        }, fovRad, projection.VerticalMeshOffset);
                        uvs[idx] = projection.IsRotated ? {
                            x: 0.5 + y / $e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_Y,
                            y: 0.5 - x / $e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_X
                        } : {
                            x: 0.5 + x / $e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_X,
                            y: 0.5 - y / $e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_Y
                        };
                        idx++;
                    }
                    break;
                }
            case (0, $52Ze3.MeshType).Cylinder:
                {
                    const center = {
                        x: 0.5,
                        y: 0.5 + projection.VerticalMeshOffset
                    };
                    const hFovRad = fov.x * $e8e8fb61d388b945$export$d2ca453b913dcdea.DegToRad;
                    const vFovRad = fov.y / 100;
                    for(let dy = 0; dy < $e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_Y; dy++)for(let dx = 0; dx < $e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_X; dx++){
                        const theta = -(dx / ($e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_X - 1) - center.x) * hFovRad + Math.PI / 2;
                        const y = -(dy / ($e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_Y - 1) - center.y) * vFovRad;
                        const pcyl = {
                            x: Math.cos(theta),
                            y: y,
                            z: Math.sin(theta)
                        };
                        vertices[dx + dy * $e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_X] = pcyl;
                        uvs[dx + dy * $e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_X] = projection.IsRotated ? {
                            x: dy / ($e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_Y - 1),
                            y: 1 - dx / ($e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_X - 1)
                        } : {
                            x: dx / ($e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_X - 1),
                            y: 1 - dy / ($e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_Y - 1)
                        };
                    }
                    break;
                }
            case (0, $52Ze3.MeshType).Flat:
                {
                    const center = {
                        x: 0.5,
                        y: 0.5 + projection.VerticalMeshOffset
                    };
                    const tanH = fov.x / 100;
                    const tanV = fov.y / 100;
                    for(let dy = 0; dy < $e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_Y; dy++)for(let dx = 0; dx < $e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_X; dx++){
                        const x = -(dx / ($e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_X - 1) - center.x) * tanH;
                        const y = (dy / ($e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_Y - 1) - center.y) * tanV;
                        vertices[dx + dy * $e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_X] = {
                            x: x,
                            y: y,
                            z: 1
                        };
                        uvs[dx + dy * $e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_X] = projection.IsRotated ? {
                            x: 1 - dy / ($e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_Y - 1),
                            y: dx / ($e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_X - 1)
                        } : {
                            x: 1 - dx / ($e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_X - 1),
                            y: dy / ($e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_Y - 1)
                        };
                    }
                    break;
                }
        }
        const nFaces = ($e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_X - 1) * ($e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_Y - 1);
        const faces = [];
        for(let faceN = 0; faceN < nFaces; faceN++){
            const i = faceN % ($e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_X - 1) + Math.floor(faceN / ($e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_X - 1)) * $e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_X;
            const d = i + $e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_X;
            const a = i;
            const b = i + 1;
            const c = i + $e8e8fb61d388b945$export$d2ca453b913dcdea.DIM_X + 1;
            faces.push({
                x: d,
                y: a,
                z: b
            });
            faces.push({
                x: d,
                y: b,
                z: c
            });
        }
        return {
            vertices: vertices,
            uvs: uvs,
            faces: faces
        };
    }
    static getColor(hex) {
        const col = {
            x: 0,
            y: 0,
            z: 0,
            w: 1
        };
        if (hex.startsWith('#')) hex = hex.substring(1);
        if (hex == "" || hex.length !== 6 && hex.length !== 8) return col;
        const alphaShift = hex.length === 8 ? 8 : 0;
        const rgb = parseInt(hex, 16);
        col.x = (rgb >> 16 + alphaShift & 0xFF) / 255;
        col.y = (rgb >> 8 + alphaShift & 0xFF) / 255;
        col.z = (rgb >> alphaShift & 0xFF) / 255;
        if (alphaShift !== 0) col.w = (rgb & 0xFF) / 255;
        return col;
    }
    static normPdf(x, y, sigma) {
        return 0.39894 * Math.exp(-0.5 * x * y / (sigma * sigma)) / sigma;
    }
    /**
     * Sets up shader for the mesh.
     *
     * @param params : Projection, image size and target eye index
     */ static SetupShader(params) {
        const material = params.matSelector(this);
        const setEnum = (keywords, idx, ...affectingVars)=>{
            if (params.updatedShaderVars === undefined || keywords.some((k)=>params.updatedShaderVars.includes(k)) || affectingVars.some((v)=>params.updatedShaderVars === undefined || params.updatedShaderVars.includes(v))) {
                for (const keyword of keywords)params.undefineFunc(material, keyword);
                params.defineFunc(material, keywords[idx]);
            }
        };
        const setKeyword = (keyword, enabled, ...affectingVars)=>{
            if (params.updatedShaderVars === undefined || params.updatedShaderVars.includes(keyword) || affectingVars.some((v)=>params.updatedShaderVars === undefined || params.updatedShaderVars.includes(v))) {
                if (enabled) params.defineFunc(material, keyword);
                else params.undefineFunc(material, keyword);
            }
        };
        const setUniform = (uniform, value, ...affectingVars)=>{
            if (params.updatedShaderVars === undefined || params.updatedShaderVars.includes(uniform) || affectingVars.some((v)=>params.updatedShaderVars === undefined || params.updatedShaderVars.includes(v))) params.setValueFunc(material, uniform, value);
        };
        setEnum($e8e8fb61d388b945$export$d2ca453b913dcdea.StereoModeKeywords, params.projectionMesh.Projection.StereoMode);
        setEnum($e8e8fb61d388b945$export$d2ca453b913dcdea.EyesActiveKeywords, params.projectionMesh.StereoTargetEye);
        setKeyword($e8e8fb61d388b945$export$897931a6b43971d4.ApplyGamma, params.projectionMesh.ApplyGamma === true);
        setKeyword($e8e8fb61d388b945$export$897931a6b43971d4.Multiview, params.projectionMesh.Multiview === true);
        setKeyword($e8e8fb61d388b945$export$897931a6b43971d4.StereoConvergence, params.projectionMesh.StereoConvergence === true);
        const dist = [
            params.projectionMesh.Projection.DistL
        ];
        setUniform($e8e8fb61d388b945$export$72e97c28153c5fa2.DistortionCoefficientsLeft, dist[0].coefficients);
        setUniform($e8e8fb61d388b945$export$72e97c28153c5fa2.DistortionCenterOffsetLeft, dist[0].centerOffset);
        if (params.projectionMesh.Projection.StereoMode != (0, $52Ze3.StereoMode).None) {
            dist.push({
                centerOffset: {
                    x: params.projectionMesh.Projection.DistR.centerOffset.x,
                    y: params.projectionMesh.Projection.DistR.centerOffset.y
                },
                coefficients: {
                    x: params.projectionMesh.Projection.DistR.coefficients.x,
                    y: params.projectionMesh.Projection.DistR.coefficients.y,
                    z: params.projectionMesh.Projection.DistR.coefficients.z,
                    w: params.projectionMesh.Projection.DistR.coefficients.w
                }
            });
            dist[1].centerOffset.x = $e8e8fb61d388b945$export$d2ca453b913dcdea.Lerp(dist[1].centerOffset.x, dist[0].centerOffset.x, params.projectionMesh.BlendStereo);
            dist[1].centerOffset.y = $e8e8fb61d388b945$export$d2ca453b913dcdea.Lerp(dist[1].centerOffset.y, dist[0].centerOffset.y, params.projectionMesh.BlendStereo);
            dist[1].coefficients.x = $e8e8fb61d388b945$export$d2ca453b913dcdea.Lerp(dist[1].coefficients.x, dist[0].coefficients.x, params.projectionMesh.BlendStereo);
            dist[1].coefficients.y = $e8e8fb61d388b945$export$d2ca453b913dcdea.Lerp(dist[1].coefficients.y, dist[0].coefficients.y, params.projectionMesh.BlendStereo);
            dist[1].coefficients.z = $e8e8fb61d388b945$export$d2ca453b913dcdea.Lerp(dist[1].coefficients.z, dist[0].coefficients.z, params.projectionMesh.BlendStereo);
            dist[1].coefficients.w = $e8e8fb61d388b945$export$d2ca453b913dcdea.Lerp(dist[1].coefficients.w, dist[0].coefficients.w, params.projectionMesh.BlendStereo);
            setUniform($e8e8fb61d388b945$export$72e97c28153c5fa2.DistortionCoefficientsRight, dist[1].coefficients);
            setUniform($e8e8fb61d388b945$export$72e97c28153c5fa2.DistortionCenterOffsetRight, dist[1].centerOffset);
        }
        setKeyword($e8e8fb61d388b945$export$897931a6b43971d4.Zoom, !$e8e8fb61d388b945$export$d2ca453b913dcdea.Approximately(params.projectionMesh.Projection.Zoom), $e8e8fb61d388b945$export$72e97c28153c5fa2.Zoom);
        setUniform($e8e8fb61d388b945$export$72e97c28153c5fa2.Zoom, params.projectionMesh.Projection.Zoom);
        let viewSize = {
            x: params.projectionMesh.ImageSize.x,
            y: params.projectionMesh.ImageSize.y
        };
        const pixelSize = {
            x: 1 / viewSize.x,
            y: 1 / viewSize.y
        };
        switch(params.projectionMesh.Projection.StereoMode){
            case (0, $52Ze3.StereoMode).LeftRight:
                viewSize.x /= 2;
                break;
            case (0, $52Ze3.StereoMode).TopBottom:
                viewSize.y /= 2;
                break;
        }
        if (params.projectionMesh.Projection.IsRotated) viewSize = {
            x: viewSize.y,
            y: viewSize.x
        };
        setUniform($e8e8fb61d388b945$export$72e97c28153c5fa2.PixelSize, pixelSize);
        setKeyword($e8e8fb61d388b945$export$897931a6b43971d4.CircularCrop, params.projectionMesh.Projection.CircularCropRadiusLeft > 0 || params.projectionMesh.Projection.CircularCropRadiusRight > 0);
        setUniform($e8e8fb61d388b945$export$72e97c28153c5fa2.CircularCropRadiusLeft, {
            x: params.projectionMesh.Projection.CircularCropRadiusLeft / viewSize.x,
            y: params.projectionMesh.Projection.CircularCropRadiusLeft / viewSize.y
        });
        setUniform($e8e8fb61d388b945$export$72e97c28153c5fa2.CircularCropRadiusRight, {
            x: params.projectionMesh.Projection.CircularCropRadiusRight / viewSize.x,
            y: params.projectionMesh.Projection.CircularCropRadiusRight / viewSize.y
        });
        setUniform($e8e8fb61d388b945$export$72e97c28153c5fa2.StereoOffset, params.projectionMesh.StereoOffset ?? {
            x: 0,
            y: 0
        });
        let focalLengths = {
            x: 0,
            y: 0
        };
        if (params.projectionMesh.Projection.FocalLength > 10) {
            const fl = {
                x: params.projectionMesh.Projection.FocalLength / (viewSize.x / 2),
                y: params.projectionMesh.Projection.FocalLength / (viewSize.y / 2)
            };
            focalLengths = params.projectionMesh.Projection.IsRotated ? {
                x: fl.y,
                y: fl.x
            } : {
                x: fl.x,
                y: fl.y
            };
        } else focalLengths = {
            x: params.projectionMesh.Projection.FocalLength,
            y: params.projectionMesh.Projection.FocalLength
        };
        const fov = $e8e8fb61d388b945$export$d2ca453b913dcdea.CalculateFov(params.projectionMesh.Projection, params.projectionMesh.ImageSize);
        const ftr = fov.x / fov.y / (viewSize.x / viewSize.y);
        const fovToResolutionRatio = params.projectionMesh.Projection.IsRotated ? {
            x: 1,
            y: ftr
        } : {
            x: ftr,
            y: 1
        };
        setUniform($e8e8fb61d388b945$export$72e97c28153c5fa2.FocalLengths, focalLengths);
        setUniform($e8e8fb61d388b945$export$72e97c28153c5fa2.FovToResolutionRatio, fovToResolutionRatio);
        const corners = [
            {
                x: 0,
                y: 0
            },
            {
                x: 0,
                y: 1
            },
            {
                x: 1,
                y: 0
            },
            {
                x: 1,
                y: 1
            }
        ];
        const max = {
            x: 0,
            y: 0
        };
        for (const corner of corners)for (const d of dist){
            const s = $e8e8fb61d388b945$export$d2ca453b913dcdea.GetScale(corner, d.coefficients, d.centerOffset, focalLengths, fovToResolutionRatio);
            if (s.x > max.x) max.x = s.x;
            if (s.y > max.y) max.y = s.y;
        }
        if (!max.x || !max.y) {
            max.x = 1;
            max.y = 1;
        }
        setUniform($e8e8fb61d388b945$export$72e97c28153c5fa2.MeshScale, {
            x: max.x,
            y: max.y
        });
        setKeyword($e8e8fb61d388b945$export$897931a6b43971d4.BlendStereo, params.projectionMesh.BlendStereo > 0, $e8e8fb61d388b945$export$72e97c28153c5fa2.BlendStereo);
        setUniform($e8e8fb61d388b945$export$72e97c28153c5fa2.BlendStereo, params.projectionMesh.BlendStereo);
        setKeyword($e8e8fb61d388b945$export$897931a6b43971d4.Blur, params.projectionMesh.IsBlurred === true);
        setUniform($e8e8fb61d388b945$export$72e97c28153c5fa2.BlurEdgeDistance, params.projectionMesh.BlurEdgeDistance);
        const blurKernel = [];
        for(let x = -3; x <= 3; x++)for(let y = -3; y <= 3; y++)blurKernel.push($e8e8fb61d388b945$export$d2ca453b913dcdea.normPdf(x, y, 3));
        setUniform($e8e8fb61d388b945$export$72e97c28153c5fa2.BlurKernel, blurKernel);
        setKeyword($e8e8fb61d388b945$export$897931a6b43971d4.GradualBlur, params.projectionMesh.GradualBlur === true);
        setKeyword($e8e8fb61d388b945$export$897931a6b43971d4.Grayscale, params.projectionMesh.IsGrayscale === true);
        setKeyword($e8e8fb61d388b945$export$897931a6b43971d4.FlipEyes, params.projectionMesh.FlipEyes === true);
        setKeyword($e8e8fb61d388b945$export$897931a6b43971d4.ImageSettingsEnabled, params.projectionMesh.ImageSettings === true);
        setUniform($e8e8fb61d388b945$export$72e97c28153c5fa2.Brightness, params.projectionMesh.Brightness);
        setUniform($e8e8fb61d388b945$export$72e97c28153c5fa2.Contrast, params.projectionMesh.Contrast);
        setUniform($e8e8fb61d388b945$export$72e97c28153c5fa2.HueDelta, params.projectionMesh.Hue);
        setUniform($e8e8fb61d388b945$export$72e97c28153c5fa2.SatDelta, params.projectionMesh.Saturation);
        setUniform($e8e8fb61d388b945$export$72e97c28153c5fa2.SharpenStrength, params.projectionMesh.SharpenStrength);
        setKeyword($e8e8fb61d388b945$export$897931a6b43971d4.CutCorners, params.projectionMesh.CutCorners === true);
        setUniform($e8e8fb61d388b945$export$72e97c28153c5fa2.CornerDistance, params.projectionMesh.CornerDistance);
        setKeyword($e8e8fb61d388b945$export$897931a6b43971d4.ColorMultiplier, !$e8e8fb61d388b945$export$d2ca453b913dcdea.Approximately(params.projectionMesh.ColorMultiplier, 1));
        setUniform($e8e8fb61d388b945$export$72e97c28153c5fa2.ColorMultiplier, params.projectionMesh.ColorMultiplier);
        setKeyword($e8e8fb61d388b945$export$897931a6b43971d4.ApplyGamma, params.projectionMesh.ApplyGamma);
        setKeyword($e8e8fb61d388b945$export$897931a6b43971d4.ChromaKey, params.projectionMesh.ChromaKey === true);
        setUniform($e8e8fb61d388b945$export$72e97c28153c5fa2.ChromaKeyColor, $e8e8fb61d388b945$export$d2ca453b913dcdea.getColor(params.projectionMesh.Projection.ChromaKeyColor));
        setUniform($e8e8fb61d388b945$export$72e97c28153c5fa2.ChromaKeyDistance, params.projectionMesh.Projection.ChromaKeyDistance);
        setUniform($e8e8fb61d388b945$export$72e97c28153c5fa2.ChromaKeySmoothness, params.projectionMesh.Projection.ChromaKeySmoothness);
        setKeyword($e8e8fb61d388b945$export$897931a6b43971d4.MaskDeo, params.projectionMesh.MaskDeo);
        setKeyword($e8e8fb61d388b945$export$897931a6b43971d4.DistortedImage, !(dist.map((d)=>$e8e8fb61d388b945$export$d2ca453b913dcdea.VectorIsZero(d.centerOffset) && $e8e8fb61d388b945$export$d2ca453b913dcdea.VectorIsZero(d.coefficients)).reduce((prev, cur)=>prev && cur) || $e8e8fb61d388b945$export$d2ca453b913dcdea.Approximately(params.projectionMesh.Projection.FocalLength) || $e8e8fb61d388b945$export$d2ca453b913dcdea.Approximately(params.projectionMesh.ImageSize.x) || $e8e8fb61d388b945$export$d2ca453b913dcdea.Approximately(params.projectionMesh.ImageSize.y)));
    }
}

});
parcelRegister("eEhAj", function(module, exports) {

$parcel$export(module.exports, "value", () => $aaa27112e02fc4b6$export$2ab9a8f9f1186f14);
const $aaa27112e02fc4b6$export$2ab9a8f9f1186f14 = `#version 300 es
precision highp float;
in vec2 v_uv;
#ifdef BLEND_STEREO
    in vec2 v_uvLeft;
#endif
#ifdef MASK_DEO
    in vec2 v_maskUV;
#endif
in float v_isStereoEyeLeft;
out vec4 color;

uniform vec4 _MainTex_ST;
uniform sampler2D _MainTex;
uniform vec2 _CameraRotation;

#ifdef BLEND_STEREO
    uniform float _BlendStereo;
#endif

#ifdef CIRCULAR_CROP
    uniform highp vec2 _CircularCropRadiusLeft;
    uniform highp vec2 _CircularCropRadiusRight;
#endif

#ifdef DISTORTED_IMAGE
    uniform vec2 _DistortionCenterOffsetLeft;
    uniform vec2 _DistortionCenterOffsetRight;
#endif

#ifdef IMAGE_SETTINGS_ENABLED
    uniform float _Brightness;
    uniform float _Contrast;
    uniform float _HueDelta; // 0 -> 360
    uniform float _SatDelta; // 0 -> 1
    uniform float _SharpenStrength;
#endif

#if defined(IMAGE_SETTINGS_ENABLED) || defined(BLUR) || defined(CHROMA_KEY)
    uniform vec2 _PixelSize;
#endif

#ifdef BLUR
    uniform float _BlurEdgeDistance;
    uniform float[49] _BlurKernel;
#endif

#ifdef CUT_CORNERS
    uniform float _CornerDistance;
#endif

#ifdef COLOR_MULTIPLIER 
    uniform float _ColorMultiplier;
#endif

#if defined(STEREOVIDEO_LEFT_RIGHT) || defined(STEREOVIDEO_TOP_BOTTOM)
    struct StereoData
    {
        vec2 imageTranslation;
        bool isStereoEyeLeft;
        bool isYFlipped;
    };
#endif

#ifdef DISTORTED_IMAGE
    struct DistortionData
    {
        vec2 uv;
        vec2 centerOffset;
        vec4 radialCoefficients;
        vec2 focalLengths;
        vec2 fovToResolutionRatio;
        vec2 meshScale;
    };
#endif

#ifdef CHROMA_KEY
    uniform vec4 _ChromaKeyColor;
    uniform lowp float _ChromaKeyDistance;
    uniform lowp float _ChromaKeySmoothness;
#endif

struct ClipData
{
    vec2 uv;
    #if defined(STEREOVIDEO_LEFT_RIGHT) || defined(STEREOVIDEO_TOP_BOTTOM)
        bool isStereoEyeLeft;
    #endif
};

bool IsStereoEyeLeft()
{
    return v_isStereoEyeLeft > 0.0;    
}

vec2 Center()
{
    vec2 center = vec2(0.5,0.5);
    #ifdef DISTORTED_IMAGE
        if(IsStereoEyeLeft())
            center -= _DistortionCenterOffsetLeft;
        else
            center -= _DistortionCenterOffsetRight;
    #endif
    #if !defined(EYES_FIRST) && !defined(EYES_SECOND)
        #ifdef STEREOVIDEO_TOP_BOTTOM
            if(IsStereoEyeLeft())
                center.y += 1.0;
        #elif defined(STEREOVIDEO_LEFT_RIGHT)
            if(!IsStereoEyeLeft())
                center.x += 1.0;
        #endif
    #elif defined(EYES_SECOND)
        #ifdef STEREOVIDEO_TOP_BOTTOM
            center.y += 1.0;
        #elif defined(STEREOVIDEO_LEFT_RIGHT)
            center.x += 1.0;
        #endif
    #endif
    return center;
}

vec2 UV(vec2 uv)
{
    #if !defined(EYES_FIRST) && !defined(EYES_SECOND)
        #ifdef STEREOVIDEO_TOP_BOTTOM
            uv *= vec2(1.0, 2.0);
        #elif defined(STEREOVIDEO_LEFT_RIGHT)
            uv *= vec2(2.0, 1.0);
        #endif
    #elif defined(EYES_FIRST)
        #ifdef STEREOVIDEO_TOP_BOTTOM
            uv *= vec2(1.0, 2.0);
        #elif defined(STEREOVIDEO_LEFT_RIGHT)
            uv *= vec2(2.0, 1.0);
        #endif
    #else
        #ifdef STEREOVIDEO_TOP_BOTTOM
            uv *= vec2(1.0, 2.0);
        #elif defined(STEREOVIDEO_LEFT_RIGHT)
            uv *= vec2(2.0, 1.0);
        #endif
    #endif
    return uv - Center();
}

#ifdef APPLY_GAMMA
    //http://entropymine.com/imageworsener/srgbformula/
    vec3 GammaToLinear(vec3 col)
    {
        return mix(pow(col.rgb * 0.9478672986 + vec3(0.0521327014), vec3(2.4)), col.rgb * 0.0773993808, vec3(lessThanEqual(col.rgb, vec3(0.04045))));
    }
#endif

#ifdef IMAGE_SETTINGS_ENABLED
    vec3 ApplyContrast(vec3 v, float contrast)
    {
        //float f = (1.0157 * (contrast + 1.0)) / (1.0157 - contrast);

        float f = max(contrast + 1.0, 0.0); // this only doubles contrast when position but looks more like avpro	
        return  f * (v - 0.5) + 0.5;
    }

    vec3 RgbToHsv(vec3 rgb)
    {
        float maxChannel = max(max(rgb.x, rgb.y), rgb.z);
        float minChannel = min(min(rgb.x, rgb.y), rgb.z);
        float delta = maxChannel - minChannel;

        float val = maxChannel;

        if (delta == 0.0)
            return vec3(0.0, 0.0, val);

        float sat = delta / maxChannel;

        float hue = 0.0;
        if (maxChannel == rgb.x)
            hue = 60.0 * ((rgb.y - rgb.z) / delta);
        else if (maxChannel == rgb.y)
            hue = 60.0 * (((rgb.z - rgb.x) / delta) + 2.0);
        else if (maxChannel == rgb.z)
            hue = 60.0 * (((rgb.x - rgb.y) / delta) + 4.0);

        return vec3(hue, sat, val);
    }

    vec3 HsvToRgb(vec3 hsv)
    {
        float C = hsv.y * hsv.z;
        float m = hsv.z - C;

        float isSegmentEvenOrOdd = abs(mod(hsv.x / 60.0, 2.0) - 1.0);
        float X = C * (1.0 - isSegmentEvenOrOdd);

        vec3 rgbTemp = vec3(0.0, 0.0, 0.0);

        if (hsv.x <= 60.0)
            rgbTemp = vec3(C, X, 0.0);
        else if (hsv.x <= 120.0)
            rgbTemp = vec3(X, C, 0.0);
        else if (hsv.x <= 180.0)
            rgbTemp = vec3(0.0, C, X);
        else if (hsv.x <= 240.0)
            rgbTemp = vec3(0.0, X, C);
        else if (hsv.x <= 300.0)
            rgbTemp = vec3(X, 0.0, C);
        else if (hsv.x <= 360.0)
            rgbTemp = vec3(C, 0.0, X);

        return vec3(rgbTemp.r + m, rgbTemp.g + m, rgbTemp.b + m);
    }

    vec3 RgbToHsl(vec3 rgb)
    {
        float maxChannel = max(max(rgb.x, rgb.y), rgb.z);
        float minChannel = min(min(rgb.x, rgb.y), rgb.z);
        float delta = maxChannel - minChannel;

        float light = (maxChannel + minChannel) * 0.5;

        float sat;
        if (delta <= 0.0)
            sat = 0.0;
        else
            sat = delta / (1.0 - abs(2.0 * light - 1.0));

        float hue = 0.0;
        if (maxChannel <= rgb.r)
            hue = 60.0 * ((rgb.g - rgb.b) / delta);
        else if (maxChannel <= rgb.g)
            hue = 60.0 * (((rgb.b - rgb.r) / delta) + 2.0);
        else if (maxChannel <= rgb.b)
            hue = 60.0 * (((rgb.r - rgb.g) / delta) + 4.0);
        return vec3(mod(hue + 360.0, 360.0), clamp(sat, 0.0, 1.0), clamp(light, 0.0, 1.0));
    }

    vec3 HslToRgb(vec3 hsl)
    {
        float C = (1.0 - abs(2.0 * hsl.z - 1.0)) * hsl.y;
        float m = hsl.z - C * 0.5;

        float isSegmentEvenOrOdd = abs(mod(hsl.x / 60.0, 2.0) - 1.0);
        
        float X = C * (1.0 - isSegmentEvenOrOdd);

        vec3 rgbTemp = vec3(0.0, 0.0, 0.0);

        if (hsl.x <= 60.0)
            rgbTemp = vec3(C, X, 0.0);
        else if (hsl.x <= 120.0)
            rgbTemp = vec3(X, C, 0.0);
        else if (hsl.x <= 180.0)
            rgbTemp = vec3(0.0, C, X);
        else if (hsl.x <= 240.0)
            rgbTemp = vec3(0.0, X, C);
        else if (hsl.x <= 300.0)
            rgbTemp = vec3(X, 0.0, C);
        else if (hsl.x <= 360.0)
            rgbTemp = vec3(C, 0.0, X);

        return vec3(rgbTemp.r + m, rgbTemp.g + m, rgbTemp.b + m);
    }
#endif

#ifdef BLUR
    // float normpdf(float x, float y, float sigma)
    // {
    //     return 0.39894 * exp(-0.5 * x * y / (sigma * sigma)) / sigma;
    // }
    float normpdf(int x, int y)
    {
        return _BlurKernel[(y + 3) * 7 + x + 3];
    }
#endif

#ifdef CHROMA_KEY
    vec2 RgbToUV(vec3 rgb)
    {
        return vec2(
            rgb.r * -0.169 + rgb.g * -0.331 + rgb.b * 0.5 + 0.5,
            rgb.r * 0.5 + rgb.g * -0.419 + rgb.b * -0.081 + 0.5);
    }

    float desaturate(vec3 col)
    {
        return clamp(col.r * 0.2126 + col.g * 0.7152 + col.b * 0.0722, 0., 1.);
    }

    vec3 spill(vec3 col)
    {
        vec3 res = col;
        res.g = min(col.g, (col.r + 2.0 * col.b) * 0.333);
        vec3 diff = col - res;
        float desat = desaturate(diff);
        return res + desat;
    }

    float getBoxChromaDist(vec3 rgb, vec2 uv)
    {
        vec2 halfPixel = _PixelSize * 0.5;
        vec2 point0 = vec2(_PixelSize.x, halfPixel.y);
        vec2 point1 = vec2(halfPixel.x, _PixelSize.y);
        vec2 chromaUV = RgbToUV(_ChromaKeyColor.rgb);
        float chromaDist = distance(chromaUV, RgbToUV(texture(_MainTex, uv + point0).rgb));
        chromaDist += distance(chromaUV, RgbToUV(texture(_MainTex, uv - point0).rgb));
        chromaDist += distance(chromaUV, RgbToUV(texture(_MainTex, uv - point1).rgb));
        chromaDist += distance(chromaUV, RgbToUV(texture(_MainTex, uv + point1).rgb));
        chromaDist *= 2.0;
        chromaDist += distance(chromaUV, RgbToUV(rgb));
        return chromaDist / 9.0;
    }
#endif

vec4 getCol(vec2 uv, vec2 offset)
{
    vec4 col = texture(_MainTex,uv + offset);
    #ifdef CHROMA_KEY
        float chromaDist = getBoxChromaDist(col.rgb, uv);
        float baseMask = chromaDist - _ChromaKeyDistance;
        float fullMask = pow(clamp(baseMask / _ChromaKeySmoothness, 0.0, 1.0), 1.5);
        col.a = fullMask;
        col.rgb = spill(col.rgb);
    #endif
    #ifdef BLEND_STEREO
        #if !defined(EYES_FIRST) && !defined(EYES_SECOND) && defined(STEREOVIDEO_TOP_BOTTOM) || !defined(EYES_FIRST) && !defined(EYES_SECOND) && defined(STEREOVIDEO_LEFT_RIGHT) && !defined(CHROMA_KEY)
            if (!IsStereoEyeLeft())
            {
                vec4 col2 = texture(_MainTex, v_uvLeft + offset);
                col.rgb = mix(col.rgb, col2.rgb, _BlendStereo);
            }
        #endif
    #endif
    #ifdef IMAGE_SETTINGS_ENABLED
        if (_HueDelta != 0.0 || _SatDelta != 0.0)
        {
            vec3 hslColor = RgbToHsl(col.rgb);

            hslColor.x = mod(hslColor.x + _HueDelta + 360.0, 360.0);
            hslColor.y = clamp(hslColor.y + _SatDelta, 0.0, 1.0);
            col.rgb = HslToRgb(hslColor);
        }

        if (_Contrast != 0.0)
            col.rgb = ApplyContrast(col.rgb, _Contrast);
        if (_Brightness != 0.0)
            col.rgb += _Brightness;
    #endif
    #ifdef APPLY_GAMMA
        col.rgb = GammaToLinear(col.rgb);
    #endif
    return col;
}

#ifdef CIRCULAR_CROP
    void Crop(vec2 uv)
    {
        vec2 cropUV = UV(uv);
        if (sqrt(cropUV.x * cropUV.x + cropUV.y * cropUV.y) > 0.25)
            discard;            
    }            
#endif

void main()
{
    vec2 uv = v_uv;
    #ifdef MASK_DEO
        if(length(UV(uv)) > 0.5)
            discard;
    #endif
    #ifdef BLEND_STEREO
        vec2 uvLeft = v_uvLeft;
    #endif
    #ifdef CUT_CORNERS
        vec2 cutUV = UV(uv);
        if (sqrt(cutUV.x * cutUV.x + cutUV.y * cutUV.y) > _CornerDistance)
            discard;
    #endif

    #ifdef CIRCULAR_CROP
        Crop(uv);
    #endif

    vec4 col = vec4(0.0,0.0,0.0,0.0);
    #ifdef BLUR
        vec2 edgeUV = UV(uv);
        float blurDist = sqrt(edgeUV.x * edgeUV.x + edgeUV.y * edgeUV.y) - _BlurEdgeDistance;
        if (blurDist > 0.0)
        {
            vec4 blurRes = vec4(0.0, 0.0, 0.0, 0.0);
            for (int i = -3; i <= 3; ++i)
            {
                for (int j = -3; j <= 3; ++j)
                {
                    blurRes += getCol(uv, vec2(float(i) * _PixelSize.x, float(j) * _PixelSize.y)) * normpdf(i, j);
                }
            }
            vec4 blur =  blurRes * 0.14285714; // == blurRes / 7
            #ifdef GRADUAL_BLUR
                blurDist /= (0.70710678 - _BlurEdgeDistance); // sqrt(0.5)
                col = blurDist * blur + (1.0 - blurDist) * getCol(uv, vec2(0.0,0.0));
            #else
                col = blur;
            #endif
        }
        else
        {
            #ifdef IMAGE_SETTINGS_ENABLED
                if(_SharpenStrength != 0.0)
                {
                    vec4 res = vec4(0.0, 0.0, 0.0, 0.0);
                    res -= getCol(uv,vec2(0.0, -_PixelSize.y)) * _SharpenStrength;
                    res -= getCol(uv,vec2(- _PixelSize.x, 0.0)) * _SharpenStrength;
                    res += getCol(uv,vec2(0.0, 0.0)) * (4.0 * _SharpenStrength + 1.0);
                    res -= getCol(uv,vec2(_PixelSize.x, 0.0)) * _SharpenStrength;
                    res -= getCol(uv,vec2(0.0, _PixelSize.y)) * _SharpenStrength;
                    col = res;
                }
                else
                {
                    col = getCol(uv,vec2(0.0, 0.0));
                }
            #else
                col = getCol(uv,vec2(0.0, 0.0));
            #endif
        }
    #elif defined(IMAGE_SETTINGS_ENABLED)
        if(_SharpenStrength != 0.0)
        {
            vec4 res = vec4(0.0, 0.0, 0.0, 0.0);
            res -= getCol(uv,vec2(0.0, -_PixelSize.y)) * _SharpenStrength;
            res -= getCol(uv,vec2(- _PixelSize.x, 0.0)) * _SharpenStrength;
            res += getCol(uv,vec2(0.0, 0.0)) * (4.0 * _SharpenStrength + 1.0);
            res -= getCol(uv,vec2(_PixelSize.x, 0.0)) * _SharpenStrength;
            res -= getCol(uv,vec2(0.0, _PixelSize.y)) * _SharpenStrength;
            col = res;
        }
        else
        {
            col = getCol(uv,vec2(0.0, 0.0));
        }
    #else
        col = getCol(uv,vec2(0.0, 0.0));
    #endif
    #ifdef COLOR_MULTIPLIER
        col.rgb = col.rgb * _ColorMultiplier;
    #endif
    #ifdef GRAYSCALE
        float gray = dot(col.rgb, vec3(0.299, 0.587, 0.114));
        col.rgb = vec3(gray);
    #endif
    // gl_FragColor = col;
    #ifdef MASK_DEO
        // col = texture(_MainTex,v_uv);
        // col = texture(_MainTex,v_maskUV);
        col.a = texture(_MainTex,v_maskUV).r;
    #endif
    color = col;
}`;

});

parcelRegister("Cf2PW", function(module, exports) {

$parcel$export(module.exports, "value", () => $072f384c97efd10e$export$2ab9a8f9f1186f14);
const $072f384c97efd10e$export$2ab9a8f9f1186f14 = `#version 300 es
#if defined(MULTIVIEW)
    #extension OCULUS_multiview : enable
    #if !defined(OCULUS_multiview)
        #extension GL_OVR_multiview2 : enable
    #endif
#endif
precision highp float;
#if !defined(OCULUS_multiview) && !defined(GL_OVR_multiview2)
    #undef MULTIVIEW
#endif
#if defined(MULTIVIEW)
    layout(num_views=2) in;
#endif
#ifdef BABYLON
    in vec2 uv;
    in vec3 position;
    uniform mat4 worldViewProjection;
#endif

#if defined(STEREOVIDEO_LEFT_RIGHT) || defined(STEREOVIDEO_TOP_BOTTOM)
    struct StereoData
    {
        vec2 imageTranslation;
        bool isStereoEyeLeft;
        bool isYFlipped;
    };
#endif

#ifdef DISTORTED_IMAGE
    struct DistortionData
    {
        vec2 uv;
        vec2 centerOffset;
        vec4 radialCoefficients;
        vec2 focalLengths;
        vec2 fovToResolutionRatio;
        vec2 meshScale;
    };
#endif

uniform highp vec4 _MainTex_ST;
#if defined(STEREOVIDEO_TOP_BOTTOM) || defined(STEREOVIDEO_LEFT_RIGHT)
    uniform vec2 _StereoOffset;
#endif
#ifdef BLEND_STEREO
    uniform float _BlendStereo;
#endif
#ifdef DISTORTED_IMAGE
    uniform vec2 _DistortionCenterOffsetLeft;
    uniform vec4 _DistortionCoefficientsLeft;
    uniform vec2 _DistortionCenterOffsetRight;
    uniform vec4 _DistortionCoefficientsRight;
    uniform vec2 _FocalLengths;
    uniform vec2 _FovToResolutionRatio;
    uniform vec2 _MeshScale;
#endif
#ifdef CIRCULAR_CROP
    uniform highp vec2 _CircularCropRadiusLeft;
    uniform highp vec2 _CircularCropRadiusRight;
#endif
#ifdef ZOOM
    uniform float _Zoom;
#endif

#ifdef MASK_DEO
    const float _MaskScale = 0.4;
    const float _MaskOffset = 0.5;
#endif

out vec2 v_uv;
#ifdef BLEND_STEREO
    out vec2 v_uvLeft;
#endif
#ifdef MASK_DEO
    out vec2 v_maskUV;
#endif
out float v_isStereoEyeLeft;

#ifdef DISTORTED_IMAGE
    vec2 CorrectRadialDistortion(DistortionData data)
    {
        vec2 c = vec2(0.5, 0.5) + data.centerOffset;
        vec4 k = data.radialCoefficients;
        vec2 d = data.uv;
        vec2 delta = (d - c) / data.focalLengths * data.meshScale * data.fovToResolutionRatio;
        float r = sqrt(delta.x * delta.x + delta.y * delta.y);
        float theta = atan(r);
        float theta_2 = theta * theta;
        float theta_4 = theta_2 * theta_2;
        float theta_d = theta * (1.0 + k.x * theta_2 + k.y * theta_4 + k.z * theta_4 * theta_2 + k.w * theta_4 * theta_4);
        float scale = (r == 0.0) ? 1.0 : theta_d / r;
        vec2 res = scale * delta;
        return data.focalLengths * res + c;
    }
#endif

#if defined(STEREOVIDEO_TOP_BOTTOM) || defined(STEREOVIDEO_LEFT_RIGHT)
    vec4 GetStereoVideoScaleOffset(StereoData data)
    {
        vec2 scale = vec2(1.0, 1.0);
        vec2 offset = vec2(data.imageTranslation.x, data.imageTranslation.y);

        // Top-Bottom
        #if defined(STEREOVIDEO_TOP_BOTTOM)

            scale.y = 0.5;

            if (data.isStereoEyeLeft)
            {
                offset.x = -data.imageTranslation.x;
                offset.y = 0.5 - data.imageTranslation.y;
            }

        // Left-Right 
        #elif defined(STEREOVIDEO_LEFT_RIGHT)

            scale.x = 0.5;

            if (!data.isStereoEyeLeft)
            {
                offset.x = 0.5 - data.imageTranslation.x;
                offset.y = -data.imageTranslation.y;
            }

        #endif
        
        return vec4(scale, offset);
    }
#endif

bool IsStereoEyeLeft()
{
    #if !defined(STEREOVIDEO_TOP_BOTTOM) && !defined(STEREOVIDEO_LEFT_RIGHT)
        return true;
    #endif
    #ifdef EYES_FIRST
        return true;
    #elif defined(EYES_SECOND)
        return false;
    #else
        #ifdef FLIP_EYES            
            #ifdef MULTIVIEW
                return gl_ViewID_OVR == 1u;
            #endif
            #ifdef STEREO_EYE_LEFT
                return false;
            #else
                return true;
            #endif
        #else            
            #ifdef MULTIVIEW
                return gl_ViewID_OVR == 0u;
            #endif
            #ifdef STEREO_EYE_LEFT
                return true;
            #else
                return false;
            #endif
        #endif
    #endif
}

#ifdef CIRCULAR_CROP
    vec2 Crop(vec2 uv, bool isLeft)
    {
        vec2 center = vec2(0.5, 0.5);
        #if  !defined(STEREOVIDEO_TOP_BOTTOM) && !defined(STEREOVIDEO_LEFT_RIGHT)
            #ifdef DISTORTED_IMAGE
                center += _DistortionCenterOffsetLeft;
            #endif
            uv = (uv - center) / (_CircularCropRadiusLeft * 2.0) + center;
        #else
            if (isLeft)
            {
                #ifdef STEREOVIDEO_LEFT_RIGHT
                    center.x = 0.25;
                #else
                    center.y = 0.75;
                #endif
                #ifdef DISTORTED_IMAGE
                    center += _DistortionCenterOffsetLeft;
                #endif
                uv = (uv - center) / (_CircularCropRadiusLeft * 2.0) + center;
            }
            else
            {
                #ifdef STEREOVIDEO_LEFT_RIGHT
                    center.x = 0.75;
                #else
                    center.y = 0.25;
                #endif
                #ifdef DISTORTED_IMAGE
                    center += _DistortionCenterOffsetRight;
                #endif
                uv = (uv - center) / (_CircularCropRadiusRight * 2.0) + center;
            }
        #endif
        return uv;
    }
#endif

#ifdef ZOOM
    vec2 Zoom(vec2 uv, bool isLeft)
    {
        vec2 center = vec2(0.5, 0.5);
        #if defined(STEREOVIDEO_TOP_BOTTOM) || defined(STEREOVIDEO_LEFT_RIGHT)
            if (isLeft)
            {
                #if defined(STEREOVIDEO_LEFT_RIGHT)
                    center.x = 0.25;
                #elif defined(STEREOVIDEO_TOP_BOTTOM)
                    center.y = 0.75;
                #endif
                #ifdef DISTORTED_IMAGE
                    center += _DistortionCenterOffsetLeft;
                #endif
            }
            else
            {
                #if defined(STEREOVIDEO_LEFT_RIGHT)
                    center.x = 0.75;
                #elif defined(STEREOVIDEO_TOP_BOTTOM)
                    center.y = 0.25;
                #endif
                #ifdef DISTORTED_IMAGE
                    center += _DistortionCenterOffsetRight;
                #endif
            }
        #else
            #ifdef DISTORTED_IMAGE
                center += _DistortionCenterOffsetLeft;
            #endif
        #endif
        uv = (uv - center) * (1.0 - _Zoom) + center;
        return uv;
    }
#endif

vec2 adjustUV(vec2 l_uv, bool isStereoEyeLeft)
{
    #if defined(DISTORTED_IMAGE) && !defined(STEREOVIDEO_TOP_BOTTOM) && !defined(STEREOVIDEO_LEFT_RIGHT)
        DistortionData distortion;
        distortion.uv = l_uv * _MainTex_ST.xy;
        distortion.focalLengths = _FocalLengths;
        distortion.centerOffset = _DistortionCenterOffsetLeft;
        distortion.radialCoefficients = _DistortionCoefficientsLeft;
        distortion.fovToResolutionRatio = _FovToResolutionRatio;
        distortion.meshScale = _MeshScale;
        l_uv = CorrectRadialDistortion(distortion) * _MainTex_ST.xy;
    #elif defined(STEREOVIDEO_TOP_BOTTOM) || defined(STEREOVIDEO_LEFT_RIGHT)
        float hit = _StereoOffset.x;
        float vit = _StereoOffset.y;
        #if !defined(EYES_FIRST) && !defined(EYES_SECOND)
            #ifdef STEREO_CONVERGENCE
                hit = _CameraRotation.x * (l_uv.y - 0.5) * (0.5 - l_uv.x);
                vit = _CameraRotation.y * (l_uv.x - 0.5) * (0.5 - l_uv.y);
            #endif
        #else
            hit = 0.0;
            vit = 0.0;
        #endif
        StereoData stereo;
        stereo.isStereoEyeLeft = isStereoEyeLeft;
        stereo.imageTranslation = vec2(hit, vit);
        stereo.isYFlipped = _MainTex_ST.y < 0.0;
        vec4 scaleOffsetVideo = GetStereoVideoScaleOffset(stereo);
        #ifdef DISTORTED_IMAGE
            DistortionData distortion;
            distortion.uv = l_uv * _MainTex_ST.xy;
            distortion.focalLengths = _FocalLengths;
            distortion.fovToResolutionRatio = _FovToResolutionRatio;
            distortion.meshScale = _MeshScale;
            if (isStereoEyeLeft)
            {
                distortion.centerOffset = _DistortionCenterOffsetLeft;
                distortion.radialCoefficients = _DistortionCoefficientsLeft;
            }
            else
            {
                distortion.centerOffset = _DistortionCenterOffsetRight;
                distortion.radialCoefficients = _DistortionCoefficientsRight;
            }

            l_uv = CorrectRadialDistortion(distortion) * _MainTex_ST.xy;
        #endif

        l_uv *= scaleOffsetVideo.xy;
        l_uv += scaleOffsetVideo.zw;
    #endif
    #ifdef CIRCULAR_CROP
        l_uv = Crop(l_uv, isStereoEyeLeft);
    #endif
    #ifdef ZOOM
        l_uv = Zoom(l_uv, isStereoEyeLeft);
    #endif
    return l_uv;
}


void main()
{
    #ifdef BABYLON
        gl_Position = worldViewProjection * vec4( position, 1.0 );
    #else
        gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
    #endif

    vec2 l_uv = uv;

    bool isStereoEyeLeft = IsStereoEyeLeft();
    v_isStereoEyeLeft = isStereoEyeLeft ? 1.0 : 0.0;

    v_uv = adjustUV(l_uv, isStereoEyeLeft);
    #ifdef BLEND_STEREO
        v_uvLeft = adjustUV(uv, true);
    #endif
    #ifdef MASK_DEO
        vec2 cs = vec2(_MaskOffset);
        vec2 cd = vec2(1.);  
        vec2 s = vec2(_MaskScale);      
        vec2 ds = vec2(1.);
        #ifdef STEREOMODE_LEFT_RIGHT
            cs.x *= 0.5;
            cd.x *= 0.5;
            s.x *= 0.5;
            ds.x *= 2.;
            cs.x += 0.5 * (1.0 - v_isStereoEyeLeft);
            cd.x += 0.5 * (1.0 - v_isStereoEyeLeft);
        #elif defined(STEREOMODE_TOP_BOTTOM)
            cs.y *= 0.5;
            cd.y *= 0.5;
            s.y *= 0.5;
            ds.y *= 2.;
            cs.y += 0.5 * (1.0 - v_isStereoEyeLeft);
            cd.y += 0.5 * (1.0 - v_isStereoEyeLeft);
        #endif
        vec2 d = l_uv*ds - cs;
        v_maskUV = adjustUV(cd + d * s,isStereoEyeLeft); 
    #endif
}`;

});



parcelRegister("bDaCE", function(module, exports) {
parcelRequire("2xip6");
var $gfKB2 = parcelRequire("gfKB2");
var $2h5JR = parcelRequire("2h5JR");
(0, $2h5JR.ThinEngine).prototype.updateWebPlayerTexture = function(texture, video, invertY) {
    if (!texture || texture._isDisabled) return;
    const glformat = this._getInternalFormat(texture.format);
    const internalFormat = this._getRGBABufferInternalSizedFormat((0, $gfKB2.Constants).TEXTURETYPE_UNSIGNED_BYTE, texture.format);
    const wasPreviouslyBound = this._bindTextureDirectly(this._gl.TEXTURE_2D, texture, true);
    this._unpackFlipY(!invertY); // Video are upside down by default
    try {
        if (video.texture !== null) this._gl.texImage2D(this._gl.TEXTURE_2D, 0, internalFormat, glformat, this._gl.UNSIGNED_BYTE, video.texture);
        if (!wasPreviouslyBound) this._bindTextureDirectly(this._gl.TEXTURE_2D, null);
        //    this.resetTextureCache();
        texture.isReady = true;
    } catch (ex) {
        // Something unexpected
        // Let's disable the texture
        texture._isDisabled = true;
    }
};

});

parcelRegister("euqMi", function(module, exports) {

$parcel$export(module.exports, "ProjectionMeshBabylonJS", () => $a8c8a3916117b7eb$export$7dd56118d20eff60);

var $2h5JR = parcelRequire("2h5JR");

var $54229 = parcelRequire("54229");

var $4I7rl = parcelRequire("4I7rl");

var $fJfwX = parcelRequire("fJfwX");

var $j2mX5 = parcelRequire("j2mX5");

var $6Hwnm = parcelRequire("6Hwnm");

var $ha1VO = parcelRequire("ha1VO");

var $fbuqw = parcelRequire("fbuqw");

var $5v6ry = parcelRequire("5v6ry");

var $klshO = parcelRequire("klshO");

var $gfKB2 = parcelRequire("gfKB2");
parcelRequire("4FeII");
var $52Ze3 = parcelRequire("52Ze3");
var $jZM2N = parcelRequire("jZM2N");

var $5K1C2 = parcelRequire("5K1C2");
class $a8c8a3916117b7eb$export$7dd56118d20eff60 extends (0, $klshO.TransformNode) {
    //#region Fields
    _mesh = null;
    _meshR = null;
    _texture = null;
    _imageSize;
    _scale;
    _projection;
    _stereoTargetEye;
    _isMeshBuilt = false;
    _meshScene;
    _blendStereo = 0;
    _layers = {
        x: 0x10000000,
        y: 0x20000000
    };
    _meshUpdateRequired = false;
    _shaderUpdateRequired = false;
    _isVREnabled = false;
    _isVisible = false;
    _isGrayscale = false;
    _isBlurred = false;
    _blurEdgeDistance = 0;
    _gradualBlur = false;
    _isPickable = true;
    // private _shouldFreezeMat: boolean = true;
    _stereoOffset = {
        x: 0,
        y: 0
    };
    _sharpenStrength = 0;
    _imageSettings = false;
    _brightness = 0;
    _contrast = 0;
    _saturation = 0;
    _hue = 0;
    _cutCorners = false;
    _cornerDistance = 0;
    _flipEyes = false;
    _chromaKey = false;
    _multiview = false;
    _applyGamma = false;
    _stereoConvergence = false;
    _colorMultiplier = 1;
    _maskDeo = false;
    _propertiesToUpdate = undefined;
    _onBeforeSceneRender = null;
    //#endregion
    //#region Constructors
    /**
     * Sets up mesh generetaion parameters and builds the mesh based on them.
     *
     * @param projection Projection to use when generating the mesh.
     * @param scale Object scale.
     * @param scene Scene to add object to.
     */ constructor(projection, scale, scene){
        super("Projection Mesh", scene, true);
        this._imageSize = new (0, $ha1VO.Vector2)(0, 0);
        this._scale = scale;
        this._stereoTargetEye = (0, $52Ze3.StereoTargetEye).Both;
        this._meshScene = scene;
        this._projection = projection;
        const target = scene.activeCamera?.outputRenderTarget ?? null;
        this._multiview = !!scene.getEngine().getCaps().multiview && target !== null && target.getViewCount() > 1;
        this.BuildMesh();
        this.SetupShader();
    }
    //#endregion
    //#region Properties 
    /**
     * Image resolution in pixels.
     */ get ImageSize() {
        return this._imageSize;
    }
    set ImageSize(value) {
        this._imageSize = this._updateProperty(this._imageSize, value, [
            (0, $jZM2N.ProjectionShaderUniform).PixelSize,
            (0, $jZM2N.ProjectionShaderUniform).FocalLengths,
            (0, $jZM2N.ProjectionShaderUniform).CircularCropRadiusLeft,
            (0, $jZM2N.ProjectionShaderUniform).CircularCropRadiusRight
        ], true, this.Projection.Fov.x <= 1 && this.Projection.Fov.y <= 1 && value.x !== 0 && value.y !== 0 && (this.Projection.MeshType === (0, $52Ze3.MeshType).Flat || this.Projection.MeshType === (0, $52Ze3.MeshType).Cylinder) || Math.max(value.x, value.y) > this.getEngine().getCaps().maxTextureSize || Math.max(value.x, value.y) < this.getEngine().getCaps().maxTextureSize && Math.max(this._imageSize.x, this._imageSize.y) > this.getEngine().getCaps().maxTextureSize);
    }
    /**
     * Layers id for left and right mesh.
     */ get Layers() {
        return this._layers;
    }
    set Layers(value) {
        if ((0, $jZM2N.Utils).VectorEquals(this._layers, value)) return;
        this._layers = value;
        if (this._mesh) this._mesh.layerMask = value.x;
        if (this._meshR) this._meshR.layerMask = value.y;
    }
    /**
     * Mesh scale.
     */ get MeshScale() {
        return this._scale;
    }
    set MeshScale(value) {
        if ((0, $jZM2N.Utils).Approximately(this._scale, value)) return;
        this._scale = value;
        (0, $jZM2N.Utils).ApplyToMultiple(function(v) {
            this.scaling = new (0, $ha1VO.Vector3)(v, v, v);
        }, value, this._mesh, this._meshR);
    }
    /**
     * Sets APPLY_GAMMA keyword to the material.
     */ get ApplyGamma() {
        return this._applyGamma;
    }
    set ApplyGamma(value) {
        this._applyGamma = this._updateProperty(this._applyGamma, value, [
            (0, $jZM2N.ProjectionShaderKeyword).ApplyGamma
        ]);
    }
    /**
     * Projection used to build the mesh.
     */ get Projection() {
        return this._projection;
    }
    set Projection(value) {
        if ((0, $52Ze3.Projection).FromString((0, $52Ze3.Projection).ToString(value)) === this._projection) return;
        this._projection = value;
        this._meshUpdateRequired = true;
        this._shaderUpdateRequired = true;
        if (this._propertiesToUpdate === undefined) this._propertiesToUpdate = [];
        for (const keyword of Object.values((0, $jZM2N.ProjectionShaderKeyword)))if (!this._propertiesToUpdate.includes(keyword)) this._propertiesToUpdate.push(keyword);
        for (const uniform of Object.values((0, $jZM2N.ProjectionShaderUniform)))if (!this._propertiesToUpdate.includes(uniform)) this._propertiesToUpdate.push(uniform);
    }
    /**
     * Dynamic stereo convergence, based on the camera angles.
     */ get StereoConvergence() {
        return this._stereoConvergence;
    }
    set StereoConvergence(value) {
        this._stereoConvergence = this._updateProperty(this._stereoConvergence, value, [
            (0, $jZM2N.ProjectionShaderKeyword).StereoConvergence
        ]);
    }
    /**
     * Stereo mode to use.
     */ get StereoMode() {
        return this._projection.StereoMode;
    }
    set StereoMode(value) {
        this._projection.StereoMode = this._updateProperty(this._projection.StereoMode, value, [
            (0, $jZM2N.ProjectionShaderKeyword).None,
            (0, $jZM2N.ProjectionShaderKeyword).StereoVideoLeftRight,
            (0, $jZM2N.ProjectionShaderKeyword).StereoVideoTopBottom
        ]);
    }
    /**
     * Which images from the stereo pair to show.
     */ get StereoTargetEye() {
        return this._stereoTargetEye;
    }
    set StereoTargetEye(value) {
        this._stereoTargetEye = this._updateProperty(this._stereoTargetEye, value, [
            (0, $jZM2N.ProjectionShaderKeyword).None,
            (0, $jZM2N.ProjectionShaderKeyword).EyesFirst,
            (0, $jZM2N.ProjectionShaderKeyword).EyesSecond
        ]);
    }
    /**
     * Transforms the right image into the left one through linear interpolation.
     */ get BlendStereo() {
        return this._blendStereo;
    }
    set BlendStereo(value) {
        this._blendStereo = this._updateProperty(this._blendStereo, value, [
            (0, $jZM2N.ProjectionShaderKeyword).BlendStereo,
            (0, $jZM2N.ProjectionShaderUniform).BlendStereo
        ], true, true);
    }
    /**
     * @deprecated No longer used.
     * Enables VR mode.
     */ get IsVREnabled() {
        return this._isVREnabled;
    }
    set IsVREnabled(value) {
        // this._isVREnabled = value;
        this._isVREnabled = this._updateProperty(this._isVREnabled, value, [], true, true);
    // const target = this._meshScene.activeCamera?.outputRenderTarget ?? null;
    // this.Multiview = !!this._meshScene.getEngine().getCaps().multiview && target !== null && target.getViewCount() > 1;
    }
    /**
    * Shows or hides the mesh.
    */ get IsVisible() {
        return this._isVisible;
    }
    set IsVisible(value) {
        if (this._isVisible === value) return;
        this._isVisible = value;
        (0, $jZM2N.Utils).ApplyToMultiple(function(v) {
            this.isVisible = v;
        }, value, this._mesh, this._meshR);
    }
    /**
     * Controls whether the image is displayed in full color or grayscale.
     */ get IsGrayscale() {
        return this._isGrayscale;
    }
    set IsGrayscale(value) {
        this._isGrayscale = this._updateProperty(this._isGrayscale, value, [
            (0, $jZM2N.ProjectionShaderKeyword).Grayscale
        ]);
    }
    /**
     * Sets horizontal and vertical offsets for stereo images.
     */ get StereoOffset() {
        return this._stereoOffset;
    }
    set StereoOffset(value) {
        this._stereoOffset = this._updateProperty(this._stereoOffset, value, [
            (0, $jZM2N.ProjectionShaderUniform).StereoOffset
        ]);
    }
    /**
     * Sets sharpness strength. Requires setting SetSharpen to true.
     */ get SharpenStrength() {
        return this._sharpenStrength;
    }
    set SharpenStrength(value) {
        this._sharpenStrength = this._updateProperty(this._sharpenStrength, value, [
            (0, $jZM2N.ProjectionShaderUniform).SharpenStrength
        ]);
    }
    /**
     * Enables image settings.
     */ get ImageSettings() {
        return this._imageSettings;
    }
    set ImageSettings(value) {
        this._imageSettings = this._updateProperty(this._imageSettings, value, [
            (0, $jZM2N.ProjectionShaderKeyword).ImageSettingsEnabled
        ]);
    }
    /**
     * Sets image brightness. Requires setting ImageSettings to true.
     */ get Brightness() {
        return this._brightness;
    }
    set Brightness(value) {
        this._brightness = this._updateProperty(this._brightness, value, [
            (0, $jZM2N.ProjectionShaderUniform).Brightness
        ]);
    }
    /**
     * Sets image contrast. Requires setting ImageSettings to true.
     */ get Contrast() {
        return this._contrast;
    }
    set Contrast(value) {
        this._contrast = this._updateProperty(this._contrast, value, [
            (0, $jZM2N.ProjectionShaderUniform).Contrast
        ]);
    }
    /**
     * Sets image saturation delta. Requires setting SetImageSettings to true.
     */ get Saturation() {
        return this._saturation;
    }
    set Saturation(value) {
        this._saturation = this._updateProperty(this._saturation, value, [
            (0, $jZM2N.ProjectionShaderUniform).SatDelta
        ]);
    }
    /**
     * Sets image hue delta. Requires setting SetImageSettings to true.
     */ get Hue() {
        return this._hue;
    }
    set Hue(value) {
        this._hue = this._updateProperty(this._hue, value, [
            (0, $jZM2N.ProjectionShaderUniform).HueDelta
        ]);
    }
    /**
     *  Discards pixels farther from the center then SetCornerDistance.
     */ get CutCorners() {
        return this._cutCorners;
    }
    set CutCorners(value) {
        this._cutCorners = this._updateProperty(this._cutCorners, value, [
            (0, $jZM2N.ProjectionShaderKeyword).CutCorners
        ]);
    }
    /**
     * Sets corner distance for corner cutting. Requires setting SetCutCorners to true.
     */ get CornerDistance() {
        return this._cornerDistance;
    }
    set CornerDistance(value) {
        this._cornerDistance = this._updateProperty(this._cornerDistance, value, [
            (0, $jZM2N.ProjectionShaderUniform).CornerDistance
        ]);
    }
    /**
     * Flips eyes.
     */ get FlipEyes() {
        return this._flipEyes;
    }
    set FlipEyes(value) {
        this._flipEyes = this._updateProperty(this._flipEyes, value, [
            (0, $jZM2N.ProjectionShaderKeyword).FlipEyes
        ]);
    }
    /*
     * Multiplies the final color by this value.
     */ get ColorMultiplier() {
        return this._colorMultiplier;
    }
    set ColorMultiplier(value) {
        this._colorMultiplier = this._updateProperty(this._colorMultiplier, value, [
            (0, $jZM2N.ProjectionShaderKeyword).ColorMultiplier,
            (0, $jZM2N.ProjectionShaderUniform).ColorMultiplier
        ]);
    }
    /**
     * Enables chroma keying according to the projection params.
     */ get ChromaKey() {
        return this._chromaKey;
    }
    set ChromaKey(value) {
        this._chromaKey = this._updateProperty(this._chromaKey, value, [
            (0, $jZM2N.ProjectionShaderKeyword).ChromaKey
        ]);
    }
    /**
     * @deprecated Made automatic based on the engine properties.
     * Enables multiview if supported.
     */ get Multiview() {
        return this._multiview;
    }
    set Multiview(value) {
        this._multiview = this._updateProperty(this._multiview, value, [
            (0, $jZM2N.ProjectionShaderKeyword).Multiview
        ], true, true);
    }
    /**
     * Enables gaussian blur.
     */ get IsBlurred() {
        return this._isBlurred;
    }
    set IsBlurred(value) {
        this._isBlurred = this._updateProperty(this._isBlurred, value, [
            (0, $jZM2N.ProjectionShaderKeyword).Blur
        ]);
    }
    get BlurEdgeDistance() {
        return this._blurEdgeDistance;
    }
    /**
     * Distance from the center of the image at which blur starts (0 to 1).
     */ set BlurEdgeDistance(value) {
        this._blurEdgeDistance = this._updateProperty(this._blurEdgeDistance, value, [
            (0, $jZM2N.ProjectionShaderUniform).BlurEdgeDistance
        ]);
    }
    /**
     * Smoothed edge blur.
     */ get GradualBlur() {
        return this._gradualBlur;
    }
    set GradualBlur(value) {
        this._gradualBlur = this._updateProperty(this._gradualBlur, value, [
            (0, $jZM2N.ProjectionShaderKeyword).GradualBlur
        ]);
    }
    /**
    * Enables mesh interactions.
    */ get IsPickable() {
        return this._isPickable;
    }
    set IsPickable(value) {
        if (this._isPickable === value) return;
        this._isPickable = value;
        (0, $jZM2N.Utils).ApplyToMultiple(function(v) {
            this.isPickable = v;
        }, value, this._mesh, this._meshR);
    }
    get MaskDeo() {
        return this._maskDeo;
    }
    set MaskDeo(value) {
        this._maskDeo = this._updateProperty(this._maskDeo, value, [
            (0, $jZM2N.ProjectionShaderKeyword).MaskDeo
        ]);
    }
    get mainCamera() {
        return this._meshScene.activeCamera?.isRigCamera && this._meshScene.activeCamera.rigParent ? this._meshScene.activeCamera.rigParent : this._meshScene.activeCamera;
    }
    //#endregion
    //#region Methods
    _updateProperty(oldValue, newValue, shaderProp = [], updateShader = true, updateMesh = false, equals) {
        if (equals === undefined) {
            if (typeof oldValue === "boolean") equals = (l, r)=>l === r;
            else if (typeof oldValue === "number") equals = (l, r)=>(0, $jZM2N.Utils).Approximately(l, r);
            else equals = (l, r)=>(0, $jZM2N.Utils).VectorEquals(l, r);
        }
        if (equals(oldValue, newValue)) return oldValue;
        if (this._propertiesToUpdate === undefined) this._propertiesToUpdate = [];
        for (const prop of shaderProp)if (!this._propertiesToUpdate.includes(prop)) this._propertiesToUpdate.push(prop);
        if (updateShader) this._shaderUpdateRequired = true;
        if (updateMesh) this._meshUpdateRequired = true;
        return newValue;
    }
    /**
     * Sets mesh texture.
     *
     * @param {Texture} texture Texture to use.
     */ SetTextureInternal(texture) {
        if (this._texture && this._texture != texture) {
            this._texture.dispose();
            this._texture = null;
        }
        this._texture = texture;
        (0, $jZM2N.Utils).ApplyToMultiple(function(t) {
            $a8c8a3916117b7eb$export$7dd56118d20eff60.SetTexture(this.material, (0, $jZM2N.ProjectionShaderUniform).MainTex, t);
        }, this._texture, this._mesh, this._meshR);
        (0, $jZM2N.Utils).ApplyToMultiple(function(t) {
            $a8c8a3916117b7eb$export$7dd56118d20eff60.SetArray(this.material, (0, $jZM2N.ProjectionShaderUniform).MainTexST, [
                t.uScale,
                t.vScale,
                t.uOffset,
                t.vOffset
            ]);
        }, texture, this._mesh, this._meshR);
    }
    /**
     * Sets mesh texture from video or image element.
     *
     * @param {HTMLVideoElement | HTMLImageElement} source Source element.
     */ SetTexture(source) {
        let texture = null;
        const max = this.getEngine().getCaps().maxTextureSize;
        if (source.nodeName !== "WEB-PLAYER") {
            const size = source.nodeName == "VIDEO" ? {
                width: source.videoWidth,
                height: source.videoHeight
            } : {
                width: source.naturalWidth,
                height: source.naturalHeight
            };
            if (size.width > max || size.height > max) {
                const maxRatio = Math.max(size.width / max, size.height / max);
                const scaledSize = {
                    x: Math.floor(size.width / maxRatio),
                    y: Math.floor(size.height / maxRatio)
                };
                let canvas = document.createElement("canvas");
                canvas.width = scaledSize.x;
                canvas.height = scaledSize.y;
                let ctx = canvas.getContext("2d");
                if (ctx) {
                    ctx.drawImage(source, 0, 0, scaledSize.x, scaledSize.y);
                    texture = new (0, $fJfwX.DynamicTexture)("ProjectionMeshTexture", canvas, this._meshScene, false);
                    let textureExists = true;
                    texture.onDisposeObservable.add(()=>{
                        ctx = null;
                        canvas?.remove();
                        canvas = null;
                        textureExists = false;
                    });
                    if (source.nodeName == "VIDEO") {
                        const videoSource = source;
                        const requestFrame = videoSource.requestVideoFrameCallback !== undefined ? (update)=>videoSource.requestVideoFrameCallback(update) : (update)=>(0, $2h5JR.ThinEngine).QueueNewFrame(update);
                        const update = ()=>{
                            if (!textureExists && videoSource === null || videoSource.src == "" && videoSource.srcObject == null || ctx === null || canvas === null || this._texture !== texture) {
                                ctx = null;
                                canvas?.remove();
                                canvas = null;
                                return;
                            }
                            ctx.drawImage(videoSource, 0, 0, scaledSize.x, scaledSize.y);
                            if (texture !== null && "update" in texture) texture?.update();
                            requestFrame(update);
                        };
                        requestFrame(update);
                    }
                }
            } else texture = source.nodeName == "VIDEO" ? new (0, $6Hwnm.VideoTexture)("ProjectionMeshTexture", source, this._meshScene, false, false, (0, $j2mX5.Texture).TRILINEAR_SAMPLINGMODE, {
                autoUpdateTexture: true,
                independentVideoSource: true
            }) : new (0, $j2mX5.Texture)(source.src, this._meshScene);
            if (texture) texture.hasAlpha = false;
        } else texture = new (0, $5K1C2.WebPlayerTexture)("ProjectionMeshTexture", source, this._meshScene, false, false, (0, $j2mX5.Texture).TRILINEAR_SAMPLINGMODE, {
            autoUpdateTexture: true,
            independentVideoSource: true
        });
        if (texture) {
            texture.anisotropicFilteringLevel = 16;
            texture.hasAlpha = true;
            texture.wrapU = 1;
            texture.wrapV = 1;
            this.SetTextureInternal(texture);
        }
    }
    /**
     * Destroys inner mesh objects.
     */ DestroyAllMeshes() {
        if (this._mesh) this._mesh.parent = null;
        if (this._meshR) this._meshR.parent = null;
        this._meshScene.onBeforeRenderObservable.remove(this._onBeforeSceneRender);
        this._onBeforeSceneRender = null;
        this._mesh?.material?.dispose();
        this._meshR?.material?.dispose();
        this._mesh?.dispose();
        this._meshR?.dispose();
        this._mesh = null;
        this._meshR = null;
        this._isMeshBuilt = false;
    }
    /**
     * Frees all used resources.
     */ Dispose() {
        this.DestroyAllMeshes();
        this._texture?.dispose();
        this._texture = null;
    }
    /**
     * Generates mesh based on the projection.
     */ BuildMesh() {
        this._meshUpdateRequired = false;
        if (this._isMeshBuilt) this.DestroyAllMeshes();
        this._mesh = $a8c8a3916117b7eb$export$7dd56118d20eff60.GenerateMesh(this._projection, this._scale, this._meshScene, this, this.ImageSize);
        this._mesh.isPickable = this.IsPickable;
        this._mesh.addRotation(this._projection.Tilt * (0, $jZM2N.Utils).DegToRad, 0, 0);
        if (this.mainCamera?.rigCameras.length == 2 && !this.Multiview) {
            this._mesh.layerMask = this.Layers.x;
            this._meshR = this._mesh.clone("ProjectionMeshRight", this);
            if (this._meshR) {
                this._meshR.material = this._mesh.material?.clone("ProjectionMaterialRight");
                this._meshR.layerMask = this.Layers.y;
                $a8c8a3916117b7eb$export$7dd56118d20eff60.Undefine(this._meshR.material, (0, $jZM2N.ProjectionShaderKeyword).StereoEyeLeft);
            }
        }
        if (this._texture != null) this.SetTextureInternal(this._texture);
        (0, $jZM2N.Utils).ApplyToMultiple(function(v) {
            this.isVisible = v;
        }, this.IsVisible, this._mesh, this._meshR);
        this._onBeforeSceneRender = this._meshScene.onBeforeRenderObservable.add(()=>{
            if (this._texture) {
                const size = this._texture.getSize();
                if (size.width != 0 && size.height != 0) {
                    if (this.ImageSize.x != size.width || this.ImageSize.y != size.height) this.ImageSize = new (0, $ha1VO.Vector2)(size.width, size.height);
                }
            }
            this.IsVREnabled = this.mainCamera?.rigCameras.length == 2;
            if (this._meshUpdateRequired) {
                this.BuildMesh();
                if (this._propertiesToUpdate === undefined) this._propertiesToUpdate = [];
                for (const keyword of Object.values((0, $jZM2N.ProjectionShaderKeyword)))if (!this._propertiesToUpdate.includes(keyword)) this._propertiesToUpdate.push(keyword);
                for (const uniform of Object.values((0, $jZM2N.ProjectionShaderUniform)))if (!this._propertiesToUpdate.includes(uniform)) this._propertiesToUpdate.push(uniform);
                this._shaderUpdateRequired = true;
            }
            if (this._shaderUpdateRequired) this.SetupShader();
            const target = this._meshScene.activeCamera?.outputRenderTarget ?? null;
            const multiview = !!this._meshScene.getEngine().getCaps().multiview && target !== null && target.getViewCount() > 1;
            if (this.Multiview !== multiview) this.Multiview = multiview;
            if (!this.Multiview) {
                if (this.mainCamera && this.mainCamera.leftCamera !== null && this.mainCamera.rightCamera !== null) {
                    this.mainCamera.leftCamera.layerMask |= this.Layers.x;
                    if ((this.mainCamera.rightCamera.layerMask & this.Layers.x) == this.Layers.x) this.mainCamera.rightCamera.layerMask ^= this.Layers.x;
                    this.mainCamera.rightCamera.layerMask |= this.Layers.y;
                }
            }
        });
        this._isMeshBuilt = true;
    }
    /**
     * Sets up shader keywords and uniforms.
     */ SetupShader() {
        this._shaderUpdateRequired = false;
        this._mesh?.material?.unfreeze();
        this._meshR?.material?.unfreeze();
        if (this._mesh) {
            (0, $jZM2N.Utils).ApplyToMultiple((0, $jZM2N.Utils).SetupShader, {
                projectionMesh: this,
                matSelector: (mesh)=>{
                    return mesh.material;
                },
                defineFunc: $a8c8a3916117b7eb$export$7dd56118d20eff60.Define,
                undefineFunc: $a8c8a3916117b7eb$export$7dd56118d20eff60.Undefine,
                setValueFunc: (mat, u, v)=>{
                    if (typeof v === "number") $a8c8a3916117b7eb$export$7dd56118d20eff60.SetFloat(mat, u, v);
                    else if ((0, $jZM2N.Utils).IsIVector2(v)) $a8c8a3916117b7eb$export$7dd56118d20eff60.SetVector(mat, u, v);
                    else if ("length" in v) $a8c8a3916117b7eb$export$7dd56118d20eff60.SetArray(mat, u, v);
                },
                updatedShaderVars: this._propertiesToUpdate
            }, this._mesh, this._meshR);
            this._propertiesToUpdate = undefined;
        }
        this._scene.resetCachedMaterial();
    // if (this._mesh)
    // {
    //     this._mesh.freezeWorldMatrix();
    //     this._mesh.doNotSyncBoundingInfo = true;
    // }
    // if (this._meshR)
    // {
    //     this._meshR.freezeWorldMatrix();
    //     this._meshR.doNotSyncBoundingInfo = true;
    // }
    // this._shouldFreezeMat = true;
    }
    /**
     * Defines a passed keyword in a material.
     *
     * @param material Material to add keyword to.
     * @param keyword Keyword to define.
     */ static Define(material, keyword) {
        const shaderMaterial = material;
        if (!material || !shaderMaterial || !shaderMaterial.options) return;
        if (keyword == "" || shaderMaterial.options.defines.includes("#define " + keyword) || shaderMaterial.options.defines.includes(keyword)) return;
        shaderMaterial.options.defines.push("#define " + keyword);
    }
    /**
     * Undefines a passed keyword in a material.
     *
     * @param material Material to remove keyword from.
     * @param keyword Keyword to undefine.
     */ static Undefine(material, keyword) {
        const shaderMaterial = material;
        if (!material || !shaderMaterial || !shaderMaterial.options) return;
        if (keyword == "" || !shaderMaterial.options.defines.includes("#define " + keyword) || shaderMaterial.options.defines.includes(keyword)) return;
        let idx = shaderMaterial.options.defines.indexOf("#define " + keyword);
        if (idx === -1) idx = shaderMaterial.options.defines.indexOf(keyword);
        shaderMaterial.options.defines.splice(idx, 1);
    }
    // /**
    //  * Checks if the keyword is defined in the material.
    //  * 
    //  * @param material Material to check.
    //  * @param keyword Keyword to check.
    //  */
    // private static CheckDefine(material: Nullable<Material>, keyword: ProjectionShaderKeyword): boolean
    // {
    //     if (!(material as ShaderMaterial) || !(material as ShaderMaterial).options)
    //         return false;
    //     return (material as ShaderMaterial).options.defines.includes("#define " + keyword);
    // }
    /**
     * Updates a uniform vec2, vec3 or vec4 value from IVector.
     *
     * @param material Material to update.
     * @param uniform Uniform to set.
     * @param vector Value.
     */ static SetVector(material, uniform, vector) {
        $a8c8a3916117b7eb$export$7dd56118d20eff60.SetArray(material, uniform, (0, $jZM2N.Utils).VectorToArray(vector));
    }
    /**
     * Updates a uniform float, vec2, vec3 or vec4 value from an array.
     *
     * @param material Material to update.
     * @param uniform Uniform to set.
     * @param value Value.
     */ static SetArray(material, uniform, value) {
        const shaderMaterial = material;
        if (!shaderMaterial) return;
        switch(value.length){
            case 1:
                $a8c8a3916117b7eb$export$7dd56118d20eff60.SetFloat(material, uniform, value[0]);
                break;
            case 2:
                shaderMaterial.setArray2(uniform, value);
                break;
            case 3:
                shaderMaterial.setArray3(uniform, value);
                break;
            case 4:
                shaderMaterial.setArray4(uniform, value);
                break;
            default:
                shaderMaterial.setFloats(uniform, value);
                break;
        }
    }
    /**
     * Updates a uniform sampler2d from a texture.
     *
     * @param material Material to update.
     * @param uniform Uniform to set.
     * @param texture Value.
     */ static SetTexture(material, uniform, texture) {
        if (!material || !material) return;
        material.setTexture(uniform, texture);
    }
    /**
     * Updates a uniform float.
     *
     * @param material Material to update.
     * @param uniform Uniform to set.
     * @param value Value.
     */ static SetFloat(material, uniform, value) {
        if (!material || !material) return;
        material.setFloat(uniform, value);
    }
    // /**
    //  * Updates a uniform int.
    //  * 
    //  * @param material Material to update.
    //  * @param uniform Uniform to set.
    //  * @param value Value.
    //  */
    // private static SetInt(material: Nullable<Material>, uniform: ProjectionShaderUniform, value: number)
    // {
    //     if (!material || !(material as ShaderMaterial))
    //         return;
    //     (material as ShaderMaterial).setInt(uniform, Math.round(value));
    // }
    // /**
    //  * Defines or undefines a keyword based on a value.
    //  * 
    //  * @param material Material to update.
    //  * @param keyword Keyword to check.
    //  * @param value Value to set.
    //  */
    // private static ToggleDefine(material: Nullable<Material>, keyword: ProjectionShaderKeyword, value: boolean): void
    // {
    //     if (!material || !(material as ShaderMaterial) || !(material as ShaderMaterial).options)
    //         return;
    //     let hasDefine = (material as ShaderMaterial).options.defines.includes("#define " + keyword);
    //     if (hasDefine == value)
    //         return;
    //     if (value)
    //         this.Define(material, keyword);
    //     else
    //         this.Undefine(material, keyword);
    // }
    /**
     * Generates a mesh based on the projection.
     *
     * @param projection Projection to use when generating the mesh.
     * @param scale Mesh scale.
     *
     * @returns Generated mesh.
     */ static GenerateMesh(projection, scale, scene, parent, imageSize) {
        let meshData = (0, $jZM2N.Utils).GenerateMesh(projection, imageSize);
        let vertices = [];
        let uvs = [];
        let normals = [];
        let indices = [];
        for(let i = 0; i < meshData.vertices.length; i++){
            vertices.push(meshData.vertices[i].x, meshData.vertices[i].y, meshData.vertices[i].z);
            uvs.push(meshData.uvs[i].x, meshData.uvs[i].y);
        }
        for(let i = 0; i < meshData.faces.length; i++){
            indices.push(meshData.faces[i].x);
            indices.push(meshData.faces[i].y);
            indices.push(meshData.faces[i].z);
        }
        (0, $5v6ry.VertexData).ComputeNormals(vertices, indices, normals, {
            useRightHandedSystem: true
        });
        let mesh = new (0, $fbuqw.Mesh)("ProjectionMeshLeft", scene, parent);
        let vertexData = new (0, $5v6ry.VertexData)();
        vertexData.positions = vertices;
        vertexData.indices = indices;
        vertexData.normals = normals;
        vertexData.uvs = uvs;
        vertexData.applyToMesh(mesh);
        let material = new (0, $4I7rl.ShaderMaterial)("ProjectionMaterial", scene, {
            vertexSource: (0, $jZM2N.Utils).Vert,
            fragmentSource: (0, $jZM2N.Utils).Frag
        }, {
            attributes: [
                "position",
                "uv"
            ],
            uniforms: [
                "worldViewProjection"
            ],
            defines: [
                "#define BABYLON"
            ],
            needAlphaTesting: true,
            needAlphaBlending: true
        });
        material.alphaMode = (0, $gfKB2.Constants).ALPHA_COMBINE;
        material.transparencyMode = (0, $54229.Material).MATERIAL_ALPHATESTANDBLEND;
        this.Define(material, (0, $jZM2N.ProjectionShaderKeyword).StereoEyeLeft);
        material.sideOrientation = (0, $54229.Material).ClockWiseSideOrientation;
        mesh.material = material;
        mesh.scaling = new (0, $ha1VO.Vector3)(scale, scale, scale);
        // mesh.material.alphaMode = Constants.ALPHA_DISABLE;
        return mesh;
    }
}

});
parcelRegister("5K1C2", function(module, exports) {

$parcel$export(module.exports, "WebPlayerTexture", () => $42e27fdae7b284bd$export$b6931e857cf90608);
parcelRequire("2xip6");
var $gfKB2 = parcelRequire("gfKB2");
var $8DoUR = parcelRequire("8DoUR");
var $j2mX5 = parcelRequire("j2mX5");
var $2h5JR = parcelRequire("2h5JR");
var $bOhSV = parcelRequire("bOhSV");
parcelRequire("bDaCE");
class $42e27fdae7b284bd$export$b6931e857cf90608 extends (0, $j2mX5.Texture) {
    /**
     * Tells whether textures will be updated automatically or user is required to call `updateTexture` manually
     */ autoUpdateTexture;
    /**
     * The video instance used by the texture internally
     */ video;
    _generateMipMaps;
    _stillImageCaptured = false;
    _displayingPosterTexture = false;
    _settings;
    _createInternalTextureOnEvent;
    _frameId = -1;
    _currentSrc = null;
    isVideo = true;
    /**
     * Creates a video texture.
     * If you want to display a video in your scene, this is the special texture for that.
     * This special texture works similar to other textures, with the exception of a few parameters.
     * @see https://doc.babylonjs.com/features/featuresDeepDive/materials/using/videoTexture
     * @param name optional name, will detect from video source, if not defined
     * @param src can be used to provide an url, array of urls or an already setup HTML video element.
     * @param scene is obviously the current scene.
     * @param generateMipMaps can be used to turn on mipmaps (Can be expensive for videoTextures because they are often updated).
     * @param invertY is false by default but can be used to invert video on Y axis
     * @param samplingMode controls the sampling method and is set to TRILINEAR_SAMPLINGMODE by default
     * @param settings allows finer control over video usage
     * @param onError defines a callback triggered when an error occurred during the loading session
     * @param format defines the texture format to use (Engine.TEXTUREFORMAT_RGBA by default)
     */ constructor(name, src, scene, generateMipMaps = false, invertY = false, samplingMode = (0, $j2mX5.Texture).TRILINEAR_SAMPLINGMODE, settings = {}, format = (0, $gfKB2.Constants).TEXTUREFORMAT_RGBA){
        super(null, scene, !generateMipMaps, invertY);
        this._settings = {
            autoPlay: true,
            loop: true,
            autoUpdateTexture: true,
            ...settings
        };
        this._generateMipMaps = generateMipMaps;
        this._initialSamplingMode = samplingMode;
        this.autoUpdateTexture = this._settings.autoUpdateTexture;
        this._currentSrc = src;
        this.name = name || src.currentSrc;
        this.video = src;
        this._createInternalTextureOnEvent = this._settings.poster && !this._settings.autoPlay ? "play" : "canplay";
        this.video.addEventListener(this._createInternalTextureOnEvent, this._createInternalTexture);
        this._format = format;
        const videoHasEnoughData = this.video.readyState >= this.video.HAVE_CURRENT_DATA;
        if (this._settings.poster && (!this._settings.autoPlay || !videoHasEnoughData)) {
            this._texture = this._getEngine().createTexture(this._settings.poster, false, !this.invertY, scene);
            this._displayingPosterTexture = true;
        } else if (videoHasEnoughData) this._createInternalTexture();
    }
    /**
     * Get the current class name of the video texture useful for serialization or dynamic coding.
     * @returns "WebPlayerTexture"
     */ getClassName() {
        return "WebPlayerTexture";
    }
    _resizeInternalTexture = ()=>{
        // Cleanup the old texture before replacing it
        if (this._texture != null) this._texture.dispose();
        if (!this._getEngine().needPOTTextures || (0, $bOhSV.Tools).IsExponentOfTwo(this.video.videoWidth) && (0, $bOhSV.Tools).IsExponentOfTwo(this.video.videoHeight)) {
            this.wrapU = (0, $j2mX5.Texture).WRAP_ADDRESSMODE;
            this.wrapV = (0, $j2mX5.Texture).WRAP_ADDRESSMODE;
        } else {
            this.wrapU = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
            this.wrapV = (0, $j2mX5.Texture).CLAMP_ADDRESSMODE;
            this._generateMipMaps = false;
        }
        this._texture = this._getEngine().createDynamicTexture(this.video.videoWidth, this.video.videoHeight, this._generateMipMaps, this.samplingMode);
        this._texture.format = this._format ?? (0, $gfKB2.Constants).TEXTUREFORMAT_RGBA;
        // Reset the frame ID and update the new texture to ensure it pulls in the current video frame
        this._frameId = -1;
        this._updateInternalTexture();
    };
    _createInternalTexture = ()=>{
        if (this._texture != null) {
            if (this._displayingPosterTexture) this._displayingPosterTexture = false;
            else return;
        }
        this.video.addEventListener("resize", this._resizeInternalTexture);
        this._resizeInternalTexture();
        this._updateInternalTexture();
        if (this.onLoadObservable.hasObservers()) this.onLoadObservable.notifyObservers(this);
    };
    /**
     * @internal Internal method to initiate `update`.
     */ _rebuild() {
        this.update();
    }
    /**
     * Update Texture in the `auto` mode. Does not do anything if `settings.autoUpdateTexture` is false.
     */ update() {
        if (!this.autoUpdateTexture) // Expecting user to call `updateTexture` manually
        return;
        this.updateTexture(true);
    }
    /**
     * Update Texture in `manual` mode. Does not do anything if not visible or paused.
     * @param isVisible Visibility state, detected by user using `scene.getActiveMeshes()` or otherwise.
     */ updateTexture(isVisible) {
        if (!isVisible) return;
        if (this.video.paused && this._stillImageCaptured) return;
        this._stillImageCaptured = true;
        this._updateInternalTexture();
    }
    _updateInternalTexture = ()=>{
        if (this._texture == null) return;
        if (this.video.readyState < this.video.HAVE_CURRENT_DATA) return;
        if (this._displayingPosterTexture) return;
        const scene = this.getScene();
        if (scene) {
            const frameId = this.getScene().getFrameId();
            if (this._frameId === frameId) return;
            this._frameId = frameId;
            const engine = this._getEngine();
            // updateWebPlayerTexture.apply(engine, [this._texture, this.video, this._invertY]);
            if (engine.updateWebPlayerTexture === undefined) engine.updateWebPlayerTexture = (0, $2h5JR.ThinEngine).prototype.updateWebPlayerTexture;
            engine.updateWebPlayerTexture(this._texture, this.video, this._invertY);
        }
    };
    /**
     * Change video content. Changing video instance or setting multiple urls (as in constructor) is not supported.
     * @param url New url.
     */ updateURL(url) {
        this.video.src = url;
        this._currentSrc = this.video;
    }
    /**
     * Clones the texture.
     * @returns the cloned texture
     */ clone() {
        return new $42e27fdae7b284bd$export$b6931e857cf90608(this.name, this._currentSrc, this.getScene(), this._generateMipMaps, this.invertY, this.samplingMode, this._settings);
    }
    /**
     * Dispose the texture and release its associated resources.
     */ dispose() {
        super.dispose();
        this._currentSrc = null;
        this.video.removeEventListener(this._createInternalTextureOnEvent, this._createInternalTexture);
    }
}
// Some exporters relies on Tools.Instantiate
(0, $8DoUR.RegisterClass)("BABYLON.WebPlayerTexture", $42e27fdae7b284bd$export$b6931e857cf90608);

});


parcelRegister("8Qv4V", function(module, exports) {
const $670b499409ba2f8f$export$682c179f50ab847d = "2.9.0-rc.0";

});



parcelRegister("gBcGT", function(module, exports) {
parcelRequire("fZvDz");
parcelRequire("1bTMs");
const $0204dbe1318ce8ce$export$682c179f50ab847d = "1.0.0-rc.1";

});
parcelRegister("1bTMs", function(module, exports) {
parcelRequire("4FeII");
var $52Ze3 = parcelRequire("52Ze3");

var $jW02B = parcelRequire("jW02B");

var $3ztn0 = parcelRequire("3ztn0");
parcelRequire("fZvDz");
var $keU3U = parcelRequire("keU3U");
class $f8c5856bf9fbe13e$export$21d36b0a75596519 extends HTMLElement {
    //#region Static methods
    static Register() {
        (0, $3ztn0.WebPlayerElement).Register();
        if (customElements.get($f8c5856bf9fbe13e$export$21d36b0a75596519.elementName) === undefined) customElements.define($f8c5856bf9fbe13e$export$21d36b0a75596519.elementName, $f8c5856bf9fbe13e$export$21d36b0a75596519);
    }
    static{
        //#endregion
        //#region Consts
        this.elementName = "all-in-one-player";
    }
    static{
        this.observedAttributes = [
            ...(0, $3ztn0.WebPlayerElement).observedAttributes,
            "scenecolor",
            "zoomsensitivity",
            "touchmovexsensitivity",
            "touchmoveysensitivity",
            "zoommin",
            "zoommax",
            "touchzoommode",
            "requirereleaseafterzoom",
            "mousemovexsensitivity",
            "mousemoveysensitivity",
            "rotationxlimit",
            "rotationylimit",
            "currentzoom",
            "zoomstep",
            "mode",
            "masksrc",
            "projection",
            "hardcodedmask"
        ];
    }
    static{
        this.propertyPairs = [];
    }
    static{
        this._template = null;
    }
    static get template() {
        if (this._template !== null) return this._template;
        this._template = document.createElement("template");
        this._template.innerHTML = `
        <style id="all_in_one_player_style">        
            :host {
                display: block;
            }
            :host([hidden]) {
                display: none;
            }
            web-player, canvas {
                width: 100%;
                height: 100%;
            }
        </style>
        <web-player id="player" hidden></web-player>
        <canvas id="canvas"></canvas>`;
        return this._template;
    }
    get scene() {
        if (this._scene === null) this._scene = (0, $keU3U.SceneFactory).Create(this.canvas);
        return this._scene;
    }
    get observedAttributes() {
        return $f8c5856bf9fbe13e$export$21d36b0a75596519.observedAttributes;
    }
    //#endregion
    //#region Public Properties
    get player() {
        if (this._player === null) this._player = this.shadowRoot.getElementById("player");
        return this._player;
    }
    get canvas() {
        if (this._canvas === null) this._canvas = this.shadowRoot.getElementById("canvas");
        return this._canvas;
    }
    get projectionMesh() {
        return this.scene.projectionMesh;
    }
    get engine() {
        return this.scene.engine;
    }
    /**
     * Gets the current player state.
     */ get state() {
        return this.player.state;
    }
    /**
     * Gets the current engine type. 
     */ get currentEngine() {
        return this.player.currentEngine;
    }
    /**
     * Gets the Internal id of the player instance.
     */ get playerId() {
        return this.player.playerId;
    }
    /**
     * Gets a TexImageSource that can be used for rendering the player in another renderer.
     */ get texture() {
        return this.player.texture;
    }
    /**
     * Gets the rendering width. It may differ from `videoWidth` if the device isn't capable of rendering the video at full resolution.
     */ get renderingWidth() {
        return this.player.renderingWidth;
    }
    /**
     * Gets the rendering height. It may differ from `videoHeight` if the device isn't capable of rendering the video at full resolution.
     */ get renderingHeight() {
        return this.player.renderingHeight;
    }
    /**
     * Gets the current stream type
     * [Proposal Reference](https://github.com/video-dev/media-ui-extensions/blob/main/proposals/0010-stream-type.md)
     */ get streamType() {
        return this.player.streamType;
    }
    /**
     * Gets the video tracks present in the stream.
     * [WHATWG Reference](https://html.spec.whatwg.org/multipage/media.html#media-resources-with-multiple-media-tracks)
     */ get videoTracks() {
        return this.player.videoTracks;
    }
    /**
     * Gets all registered engines.
     */ get allEngines() {
        return this.player.allEngines;
    }
    /**
     * Gets all registered engines, supported by the device.
     */ get supportedEngines() {
        return this.player.supportedEngines;
    }
    /**
     * Gets all enabled registered engines.
     */ get enabledEngines() {
        return this.player.enabledEngines;
    }
    /**
     * Gets all supported and enabled engines.
     */ get usedEngines() {
        return this.player.usedEngines;
    }
    get disablePictureInPicture() {
        return this.player.disablePictureInPicture;
    }
    set disablePictureInPicture(value) {
        if (value === this.disablePictureInPicture) return;
        this.setAttributeValue("disablePictureInPicture", value);
        this.player.disablePictureInPicture = value;
    }
    get height() {
        return this.player.height;
    }
    set height(value) {
        if (value === this.height) return;
        this.setAttributeValue("height", value);
        this.player.height = value;
    }
    get playsInline() {
        return this.player.playsInline;
    }
    set playsInline(value) {
        if (value === this.playsInline) return;
        this.setAttributeValue("playsInline", value);
        this.player.playsInline = value;
    }
    get poster() {
        return this.player.poster;
    }
    set poster(value) {
        if (value === this.poster) return;
        this.setAttributeValue("poster", value);
        this.player.poster = value;
    }
    get videoHeight() {
        return this.player.videoHeight;
    }
    get videoWidth() {
        return this.player.videoWidth;
    }
    get width() {
        return this.player.width;
    }
    set width(value) {
        if (value === this.width) return;
        this.setAttributeValue("width", value);
        this.player.width = value;
    }
    get autoplay() {
        return this.player.autoplay;
    }
    set autoplay(value) {
        if (value === this.autoplay) return;
        this.setAttributeValue("autoplay", value);
        this.player.autoplay = value;
    }
    get buffered() {
        return this.player.buffered;
    }
    get controls() {
        return this.player.controls;
    }
    set controls(value) {
        if (value === this.controls) return;
        this.setAttributeValue("controls", value);
        this.player.controls = value;
    }
    get crossOrigin() {
        return this.player.crossOrigin;
    }
    set crossOrigin(value) {
        if (value === this.crossOrigin) return;
        this.setAttributeValue("crossOrigin", value);
        this.player.crossOrigin = value;
    }
    get currentSrc() {
        return this.player.currentSrc;
    }
    get currentTime() {
        return this.player.currentTime;
    }
    set currentTime(value) {
        if (value === this.currentTime) return;
        this.setAttributeValue("currentTime", value);
        this.player.currentTime = value;
    }
    get defaultMuted() {
        return this.player.defaultMuted;
    }
    set defaultMuted(value) {
        if (value === this.defaultMuted) return;
        this.setAttributeValue("defaultMuted", value);
        this.player.defaultMuted = value;
    }
    get defaultPlaybackRate() {
        return this.player.defaultPlaybackRate;
    }
    set defaultPlaybackRate(value) {
        if (value === this.defaultPlaybackRate) return;
        this.setAttributeValue("defaultPlaybackRate", value);
        this.player.defaultPlaybackRate = value;
    }
    get disableRemotePlayback() {
        return this.player.disableRemotePlayback;
    }
    set disableRemotePlayback(value) {
        if (value === this.disableRemotePlayback) return;
        this.setAttributeValue("disableRemotePlayback", value);
        this.player.disableRemotePlayback = value;
    }
    get duration() {
        return this.player.duration;
    }
    get ended() {
        return this.player.ended;
    }
    get error() {
        return this.player.error;
    }
    get hardcodedMask() {
        return this._hardcodedMask;
    }
    set hardcodedMask(value) {
        if (this.hardcodedMask === value) return;
        this.setAttributeValue("hardcodedMask", value);
        this._hardcodedMask = value;
        this.updateMask();
    }
    get loop() {
        return this.player.loop;
    }
    set loop(value) {
        if (value === this.player.loop) return;
        this.setAttributeValue("loop", value);
        this.player.loop = value;
    }
    get maskSrc() {
        return this._maskSrc;
    }
    set maskSrc(value) {
        if (this._maskSrc === value) return;
        this.setAttributeValue("maskSrc", value);
        this._maskSrc = value;
        this.updateSrc(this._src, this._maskSrc);
    }
    get mediaKeys() {
        return this.player.mediaKeys;
    }
    get muted() {
        return this.player.muted;
    }
    set muted(value) {
        if (value === this.muted) return;
        this.setAttributeValue("muted", value);
        this.player.muted = value;
    }
    get networkState() {
        return this.player.networkState;
    }
    get paused() {
        return this.player.paused;
    }
    get playbackRate() {
        return this.player.playbackRate;
    }
    set playbackRate(value) {
        if (value === this.playbackRate) return;
        this.setAttributeValue("playbackRate", value);
        this.player.playbackRate = value;
    }
    get played() {
        return this.player.played;
    }
    get preload() {
        return this.player.preload;
    }
    set preload(value) {
        if (value === this.preload) return;
        this.setAttributeValue("preload", value);
        this.player.preload = value;
    }
    get preservesPitch() {
        return this.player.preservesPitch;
    }
    set preservesPitch(value) {
        if (value === this.preservesPitch) return;
        this.setAttributeValue("preservesPitch", value);
        this.player.preservesPitch = value;
    }
    get projection() {
        return this._projection;
    }
    set projection(value) {
        if (this.projection === value) return;
        this.setAttributeValue("projection", value);
        this._projection = value;
        this.updateProjectionMesh();
    }
    get readyState() {
        return this.player.readyState;
    }
    get remote() {
        return this.player.remote;
    }
    get seekable() {
        return this.player.seekable;
    }
    get seeking() {
        return this.player.seeking;
    }
    get sinkId() {
        return this.player.sinkId;
    }
    get src() {
        return this._src;
    }
    set src(value) {
        if (value === this.src) return;
        this.setAttributeValue("src", value);
        this._src = value;
        this.updateSrc(this._src, this._maskSrc);
    }
    get srcObject() {
        return this.player.srcObject;
    }
    set srcObject(value) {
        if (value === this.srcObject) return;
        this.player.srcObject = value;
    }
    get textTracks() {
        return this.player.textTracks;
    }
    get volume() {
        return this.player.volume;
    }
    set volume(value) {
        if (value === this.volume) return;
        this.setAttributeValue("volume", value);
        this.player.volume = value;
    }
    get lowLatency() {
        return this.player.lowLatency;
    }
    set lowLatency(value) {
        if (value === this.lowLatency) return;
        this.setAttributeValue("lowLatency", value);
        this.player.lowLatency = value;
    }
    get passthroughToken() {
        return this.player.passthroughToken;
    }
    set passthroughToken(value) {
        if (value === this.passthroughToken) return;
        this.setAttributeValue("passthroughToken", value);
        this.player.passthroughToken = value;
    }
    get includeMask() {
        return this._includeMask;
    }
    set includeMask(value) {
        if (value === this.includeMask) return;
        this.setAttributeValue("includeMask", value);
        this._includeMask = value;
        this.updateMask();
    }
    get enginesList() {
        return this.player.enginesList;
    }
    set enginesList(value) {
        if (value === this.enginesList) return;
        this.setAttributeValue("enginesList", value);
        this.player.enginesList = value;
    }
    get connectionTimeout() {
        return this.player.connectionTimeout;
    }
    set connectionTimeout(value) {
        if (value === this.connectionTimeout) return;
        this.setAttributeValue("connectionTimeout", value);
        this.player.connectionTimeout = value;
    }
    get externalRenderer() {
        return this.player.externalRenderer;
    }
    set externalRenderer(value) {
        if (value === this.externalRenderer) return;
        this.setAttributeValue("externalRenderer", value);
        this.player.externalRenderer = value;
    }
    get stallWindow() {
        return this.player.stallWindow;
    }
    set stallWindow(value) {
        if (value === this.stallWindow) return;
        this.setAttributeValue("stallWindow", value);
        this.player.stallWindow = value;
    }
    get maxStallEvents() {
        return this.player.maxStallEvents;
    }
    set maxStallEvents(value) {
        if (value === this.maxStallEvents) return;
        this.setAttributeValue("maxStallEvents", value);
        this.player.maxStallEvents = value;
    }
    get fmp4ProtocolVersion() {
        return this.player.fmp4ProtocolVersion;
    }
    set fmp4ProtocolVersion(value) {
        if (value === this.fmp4ProtocolVersion) return;
        this.setAttributeValue("fmp4ProtocolVersion", value);
        this.player.fmp4ProtocolVersion = value;
    }
    get sceneColor() {
        return this.scene.sceneColor;
    }
    set sceneColor(value) {
        if (this.sceneColor === value) return;
        this.setAttributeValue("sceneColor", value);
        this.scene.sceneColor = value;
    }
    get zoomSensitivity() {
        return this.scene.zoomSensitivity;
    }
    set zoomSensitivity(value) {
        if (this.zoomSensitivity === value) return;
        this.setAttributeValue("zoomSensitivity", value);
        this.scene.zoomSensitivity = value;
    }
    get touchMoveXSensitivity() {
        return this.scene.touchMoveXSensitivity;
    }
    set touchMoveXSensitivity(value) {
        if (this.touchMoveXSensitivity === value) return;
        this.setAttributeValue("touchMoveXSensitivity", value);
        this.scene.touchMoveXSensitivity = value;
    }
    get touchMoveYSensitivity() {
        return this.scene.touchMoveYSensitivity;
    }
    set touchMoveYSensitivity(value) {
        if (this.touchMoveYSensitivity === value) return;
        this.setAttributeValue("touchMoveYSensitivity", value);
        this.scene.touchMoveYSensitivity = value;
    }
    get zoomMin() {
        return this.scene.zoomMin;
    }
    set zoomMin(value) {
        if (this.zoomMin === value) return;
        this.setAttributeValue("zoomMin", value);
        this.scene.zoomMin = value;
    }
    get zoomMax() {
        return this.scene.zoomMax;
    }
    set zoomMax(value) {
        if (this.zoomMax === value) return;
        this.setAttributeValue("zoomMax", value);
        this.scene.zoomMax = value;
    }
    get touchZoomMode() {
        return this.scene.touchZoomMode;
    }
    set touchZoomMode(value) {
        if (this.touchZoomMode === value) return;
        this.setAttributeValue("touchZoomMode", value);
        this.scene.touchZoomMode = value;
    }
    get requireReleaseAfterZoom() {
        return this.scene.requireReleaseAfterZoom;
    }
    set requireReleaseAfterZoom(value) {
        if (this.requireReleaseAfterZoom === value) return;
        this.setAttributeValue("requireReleaseAfterZoom", value);
        this.scene.requireReleaseAfterZoom = value;
    }
    get mouseMoveXSensitivity() {
        return this.scene.mouseMoveXSensitivity;
    }
    set mouseMoveXSensitivity(value) {
        if (this.mouseMoveXSensitivity === value) return;
        this.setAttributeValue("mouseMoveXSensitivity", value);
        this.scene.mouseMoveXSensitivity = value;
    }
    get mouseMoveYSensitivity() {
        return this.scene.mouseMoveYSensitivity;
    }
    set mouseMoveYSensitivity(value) {
        if (this.mouseMoveYSensitivity === value) return;
        this.setAttributeValue("mouseMoveYSensitivity", value);
        this.scene.mouseMoveYSensitivity = value;
    }
    get rotationXLimit() {
        return this.scene.rotationXLimit;
    }
    set rotationXLimit(value) {
        if (this.rotationXLimit === value) return;
        this.setAttributeValue("rotationXLimit", value);
        this.scene.rotationXLimit = value;
    }
    get rotationYLimit() {
        return this.scene.rotationYLimit;
    }
    set rotationYLimit(value) {
        if (this.rotationYLimit === value) return;
        this.setAttributeValue("rotationYLimit", value);
        this.scene.rotationYLimit = value;
    }
    get currentZoom() {
        return this.scene.currentZoom;
    }
    set currentZoom(value) {
        if (this.currentZoom === value) return;
        this.setAttributeValue("currentZoom", value);
        this.scene.currentZoom = value;
    }
    get zoomStep() {
        return this._zoomStep;
    }
    set zoomStep(value) {
        if (this.zoomStep === value) return;
        this.setAttributeValue("zoomStep", value);
        this._zoomStep = value;
    }
    get mode() {
        return this._mode;
    }
    set mode(value) {
        if (!value) value = "auto";
        if (this.mode === value) return;
        this.setAttributeValue("mode", value);
        this._mode = value;
        this.updateDisplay(value);
    }
    get onstatechanged() {
        return this.player.onstatechanged;
    }
    set onstatechanged(value) {
        if (value === this.player.onstatechanged) return;
        this.player.onstatechanged = value;
    }
    get onwarning() {
        return this.player.onwarning;
    }
    set onwarning(value) {
        if (value === this.player.onwarning) return;
        this.player.onwarning = value;
    }
    get onpositionchanged() {
        return this.player.onpositionchanged;
    }
    set onpositionchanged(value) {
        if (value === this.player.onpositionchanged) return;
        this.player.onpositionchanged = value;
    }
    get onframeready() {
        return this.player.onframeready;
    }
    set onframeready(value) {
        if (value === this.player.onframeready) return;
        this.player.onframeready = value;
    }
    get oninvalidpassthroughtoken() {
        return this.player.oninvalidpassthroughtoken;
    }
    set oninvalidpassthroughtoken(value) {
        if (value === this.player.oninvalidpassthroughtoken) return;
        this.player.oninvalidpassthroughtoken = value;
    }
    get onmaskdecodingerror() {
        return this.player.onmaskdecodingerror;
    }
    set onmaskdecodingerror(value) {
        if (value === this.player.onmaskdecodingerror) return;
        this.player.onmaskdecodingerror = value;
    }
    get onstreamtypechange() {
        return this.player.onstreamtypechange;
    }
    set onstreamtypechange(value) {
        if (value === this.player.onstreamtypechange) return;
        this.player.onstreamtypechange = value;
    }
    get onaddvideotrack() {
        return this.player.onaddvideotrack;
    }
    set onaddvideotrack(value) {
        if (value === this.player.onaddvideotrack) return;
        this.player.onaddvideotrack = value;
    }
    get onremovevideotrack() {
        return this.player.onremovevideotrack;
    }
    set onremovevideotrack(value) {
        if (value === this.player.onremovevideotrack) return;
        this.player.onremovevideotrack = value;
    }
    get onvideotrackchange() {
        return this.player.onvideotrackchange;
    }
    set onvideotrackchange(value) {
        if (value === this.player.onvideotrackchange) return;
        this.player.onvideotrackchange = value;
    }
    get onengineschange() {
        return this.player.onengineschange;
    }
    set onengineschange(value) {
        if (value === this.player.onengineschange) return;
        this.player.onengineschange = value;
    }
    get onenterpictureinpicture() {
        return this.player.onenterpictureinpicture;
    }
    set onenterpictureinpicture(value) {
        if (value === this.player.onenterpictureinpicture) return;
        this.player.onenterpictureinpicture = value;
    }
    get onleavepictureinpicture() {
        return this.player.onleavepictureinpicture;
    }
    set onleavepictureinpicture(value) {
        if (value === this.player.onleavepictureinpicture) return;
        this.player.onleavepictureinpicture = value;
    }
    get onencrypted() {
        return this.player.onencrypted;
    }
    set onencrypted(value) {
        if (value === this.player.onencrypted) return;
        this.player.onencrypted = value;
    }
    get onwaitingforkey() {
        return this.player.onwaitingforkey;
    }
    set onwaitingforkey(value) {
        if (value === this.player.onwaitingforkey) return;
        this.player.onwaitingforkey = value;
    }
    //#endregion
    //#region Constructor
    constructor(){
        super(), this.NETWORK_EMPTY = 0, this.NETWORK_IDLE = 1, this.NETWORK_LOADING = 2, this.NETWORK_NO_SOURCE = 3, this.HAVE_NOTHING = 0, this.HAVE_METADATA = 1, this.HAVE_CURRENT_DATA = 2, this.HAVE_FUTURE_DATA = 3, this.HAVE_ENOUGH_DATA = 4, //#endregion
        //#region Private Fields
        this._player = null, this._canvas = null, this._scene = null, this._mutationObserver = null, this._zoomStep = 1, this._mode = "auto", this._src = "", this._maskSrc = "", this._projection = "", this._includeMask = false, this._hardcodedMask = false;
        this.attachShadow({
            mode: "open"
        });
        $f8c5856bf9fbe13e$export$21d36b0a75596519.Register();
        this.shadowRoot?.appendChild($f8c5856bf9fbe13e$export$21d36b0a75596519.template.content.cloneNode(true));
        if (customElements.get("web-player") !== undefined) this.upgrade();
        else customElements.whenDefined("web-player").then(()=>this.upgrade());
        this._mutationObserver = new MutationObserver((m)=>{
            m.forEach((r)=>{
                if (r.type === "attributes" && r.target === this.player) {
                    if (r.attributeName !== null && this.observedAttributes.includes(r.attributeName.toLowerCase())) {
                        if (r.attributeName === "src") {
                            const value = this.player.getAttribute(r.attributeName);
                            if (value && value.startsWith("mask://")) {
                                const parts = value.substring(7).split('+');
                                this.setAttribute("src", decodeURIComponent(parts[0]));
                                this.setAttribute("masksrc", decodeURIComponent(parts[1]));
                            } else this.updateAttribute(r.attributeName);
                            return;
                        } else if (r.attributeName === "includemask" && this.hardcodedMask) {
                            const value = this.player.getAttribute(r.attributeName) ?? false;
                            const ownValue = this.includeMask;
                            if (ownValue !== value) return;
                        }
                        this.updateAttribute(r.attributeName);
                    }
                }
            });
        });
        this._mutationObserver.observe(this.player, {
            attributes: true
        });
        this.canvas.addEventListener('wheel', (event)=>{
            const delta = Math.sign(event.deltaY) * this.zoomStep;
            if (this.currentZoom + delta <= this.zoomMax && this.currentZoom + delta >= this.zoomMin) {
                this.scene.zoom(delta / this.zoomSensitivity);
                this.currentZoom += delta;
            }
            event.preventDefault();
        }, false);
    }
    connectedCallback() {
        (0, $jW02B.LogInternal).info(`[${this.tagName}] Custom element added to page.`);
        this.upgradeProperty("mode");
        this.upgradeProperty("src");
        this.upgradeProperty("maskSrc");
        this.upgradeProperty("autoplay");
        this.upgradeProperty("controls");
        this.upgradeProperty("lowLatency");
        this.upgradeProperty("muted");
        this.upgradeProperty("volume");
        this.upgradeProperty("loop");
        this.upgradeProperty("width");
        this.upgradeProperty("height");
        this.upgradeProperty("disablePictureInPicture");
        this.upgradeProperty("passthroughToken");
        this.upgradeProperty("includeMask");
        this.upgradeProperty("enginesList");
        this.upgradeProperty("hardcodedMask");
        this.upgradeProperty("connectionTimeout");
        this.upgradeProperty("poster");
        this.upgradeProperty("crossOrigin");
        this.upgradeProperty("externalRenderer");
        this.upgradeProperty("stallWindow");
        this.upgradeProperty("maxStallEvents");
        this.upgradeProperty("fmp4ProtocolVersion");
        this.upgradeProperty("zoomMax");
        this.upgradeProperty("zoomMin");
        this.upgradeProperty("zoomSensitivity");
        this.upgradeProperty("zoomStep");
        this.upgradeProperty("touchZoomMode");
        this.upgradeProperty("currentZoom");
        this.upgradeProperty("requireReleaseAfterZoom");
        this.upgradeProperty("sceneColor");
        this.upgradeProperty("mouseMoveXSensitivity");
        this.upgradeProperty("mouseMoveYSensitivity");
        this.upgradeProperty("touchMoveXSensitivity");
        this.upgradeProperty("touchMoveYSensitivity");
        this.upgradeProperty("rotationXLimit");
        this.upgradeProperty("rotationYLimit");
        this.upgradeProperty("projection");
        this.upgradeProperty("onstatechanged");
        this.upgradeProperty("onwarning");
        this.upgradeProperty("onpositionchanged");
        this.upgradeProperty("onerror");
        this.upgradeProperty("onframeready");
        this.upgradeProperty("oninvalidpassthroughtoken");
        this.upgradeProperty("onmaskdecodingerror");
        this.upgradeProperty("ondurationchange");
        this.upgradeProperty("onstreamtypechange");
        this.upgradeProperty("onended");
        this.upgradeProperty("onaddvideotrack");
        this.upgradeProperty("onremovevideotrack");
        this.upgradeProperty("onvideotrackchange");
        this.upgradeProperty("onenterpictureinpicture");
        this.upgradeProperty("onleavepictureinpicture");
        this.upgradeProperty("onengineschange");
        this.projectionMesh.SetTexture(this.player);
        this.player.addEventListener("playing", ()=>this.projectionMesh.SetTexture(this.player));
    }
    disconnectedCallback() {
        (0, $jW02B.LogInternal).info(`[${this.tagName}] Custom element removed from page.`);
    }
    adoptedCallback() {
        (0, $jW02B.LogInternal).info(`[${this.tagName}] Custom element moved to new page.`);
    }
    //#endregion
    //#region Public Methods
    cancelVideoFrameCallback(handle) {
        this.player.cancelVideoFrameCallback(handle);
    }
    getVideoPlaybackQuality() {
        return this.player.getVideoPlaybackQuality();
    }
    async requestPictureInPicture() {
        return await this.player.requestPictureInPicture();
    }
    requestVideoFrameCallback(callback) {
        return this.player.requestVideoFrameCallback(callback);
    }
    addTextTrack(kind, label, language) {
        return this.player.addTextTrack(kind, label, language);
    }
    canPlayType(type) {
        return this.player.canPlayType(type);
    }
    async fastSeek(time) {
        await this.player.fastSeek(time);
    }
    async load() {
        await this.player.load();
    }
    async pause() {
        await this.player.pause();
    }
    async play() {
        await this.player.play();
        this.updateProjectionMesh();
    }
    async stop() {
        await this.player.stop();
    }
    async togglePause() {
        await this.player.togglePause();
    }
    async seek(time) {
        await this.player.seek(time);
    }
    exitPictureInPicture() {
        this.player.exitPictureInPicture();
    }
    async setSinkId(sinkId) {
        await this.player.setSinkId(sinkId);
    }
    render() {
        this.player.render();
    }
    async setMediaKeys(mediaKeys) {
        this.player.setMediaKeys(mediaKeys);
    }
    captureStream() {
        return this.player.captureStream();
    }
    //#endregion
    //#region Private Methods
    updateSrc(src, maskSrc) {
        if (!maskSrc) this.player.src = src;
        else this.player.src = `mask://${encodeURIComponent(src)}+${encodeURIComponent(maskSrc)}`;
    }
    updateProjectionMesh() {
        this.projectionMesh.Projection = (0, $52Ze3.Projection).FromString(!!this.projection ? this.projection : this.src);
        this.updateDisplay(this.mode);
    }
    updateMask() {
        this.player.includeMask = this.includeMask && !this.hardcodedMask;
        this.projectionMesh.MaskDeo = this.hardcodedMask && this.includeMask;
    }
    updateDisplay(mode) {
        switch(mode){
            case "2d":
                this.canvas.hidden = true;
                break;
            case "3d":
                this.canvas.hidden = false;
                break;
            case "auto":
                this.canvas.hidden = this.projectionMesh.Projection.MeshType === (0, $52Ze3.MeshType).Flat;
                break;
        }
        this.player.hidden = !this.canvas.hidden;
    }
    updateAttribute(name) {
        const ownAttr = this.getAttribute(name);
        const childAttr = this.player.getAttribute(name);
        if (ownAttr !== childAttr) {
            if (childAttr !== null) this.setAttribute(name, childAttr);
            else this.removeAttribute(name);
        }
    }
    //#endregion
    //#region Helper Functions
    setAttributeValue(name, value) {
        const lowercase = name.toLowerCase();
        if (!this.observedAttributes.includes(lowercase)) return;
        if (value === null && this.getAttribute(lowercase) !== null) this.removeAttribute(lowercase);
        else if (typeof value === "object" && value instanceof (0, $3ztn0.DOMTokenListLike)) this.setAttribute(lowercase, value.value);
        else if (typeof value === "object" && Array.isArray(value)) {
            const join = value.length > 0 ? value.join(' ') : "";
            if (this.getAttribute(lowercase) !== join) this.setAttribute(lowercase, join);
        } else if (typeof value === "string" && this.getAttribute(lowercase) !== value) {
            if (value !== "") this.setAttribute(lowercase, value);
            else this.removeAttribute(lowercase);
        } else if (typeof value === "number" && this.getAttribute(lowercase) !== value.toString()) this.setAttribute(lowercase, value.toString());
        else if (typeof value === "boolean" && value && this.getAttribute(lowercase) === null) this.setAttribute(lowercase, "");
        else if (typeof value === "boolean" && !value && this.getAttribute(lowercase) !== null) this.removeAttribute(lowercase);
    }
    static setPropertyValue(obj, name) {
        const value = obj.getAttribute(name);
        if (value === null) return;
        const currentValue = obj[name];
        if (typeof currentValue === "string") obj[name] = value;
        else if (typeof currentValue === "number") obj[name] = Number.parseFloat(value);
        else if (typeof currentValue === "boolean") obj[name] = value !== null;
        else if (typeof currentValue === "object" && currentValue instanceof (0, $3ztn0.DOMTokenListLike)) currentValue.setValue(value);
        else if (typeof currentValue === "object" && Array.isArray(currentValue)) obj[name] = value.includes(' ') ? value.split(' ') : [
            value
        ];
    }
    static upgradeProperty(obj, prop) {
        $f8c5856bf9fbe13e$export$21d36b0a75596519.propertyPairs.push({
            property: prop,
            attribute: prop.toLowerCase()
        });
        if (obj.hasOwnProperty(prop)) {
            const value = obj[prop];
            delete obj[prop];
            obj[prop] = value;
        } else if (prop in obj) $f8c5856bf9fbe13e$export$21d36b0a75596519.setPropertyValue(obj, prop);
    }
    upgradeProperty(prop) {
        $f8c5856bf9fbe13e$export$21d36b0a75596519.upgradeProperty(this, prop);
    }
    attributeChangedCallback(name, oldValue, newValue) {
        const propName = $f8c5856bf9fbe13e$export$21d36b0a75596519.propertyPairs.find((p)=>p.attribute === name)?.property ?? "";
        const propertyValue = JSON.stringify(this[propName]);
        if (propName in this) {
            if (typeof this[propName] === typeof newValue) this[propName] = newValue;
            else if (typeof this[propName] === "number" && typeof newValue === "string") this[propName] = Number.parseFloat(newValue);
            else if (typeof this[propName] === "number" && newValue === null) this[propName] = 0;
            else if (typeof this[propName] === "boolean" && newValue === null) this[propName] = false;
            else if (typeof this[propName] === "string" && newValue === null) this[propName] = "";
            else if (typeof this[propName] === "boolean" && typeof newValue === "string") this[propName] = true;
            else if (typeof this[propName] === "object" && Array.isArray(this[propName]) && typeof newValue === "string") this[propName] = newValue.split(' ');
            else if (typeof this[propName] === "object" && Array.isArray(this[propName]) && newValue === null) this[propName] = [];
            else if (typeof this[propName] === "object" && this[propName] instanceof (0, $3ztn0.DOMTokenListLike) && typeof newValue === "string") this[propName].setValue(newValue);
            else typeof this[propName] === "object" && this[propName];
        }
        (0, $jW02B.LogInternal).debug(`[${this.tagName}] Attribute '${name}' (property: '${propName}') changed, old value: ${oldValue}, new value: ${newValue}, old property value: ${propertyValue}, new property value: ${JSON.stringify(this[propName])}`);
    }
    upgrade() {
        if (customElements && customElements.upgrade) customElements.upgrade(this.player);
    }
}
//#region Registration
$f8c5856bf9fbe13e$export$21d36b0a75596519.Register();
 //#endregion

});



parcelRegister("ab2A8", function(module, exports) {

$parcel$export(module.exports, "Version", () => $04f4f946165db02e$export$682c179f50ab847d);
parcelRequire("4QvUx");
parcelRequire("fhic1");
const $04f4f946165db02e$export$682c179f50ab847d = "1.0.0-rc.1";

});
parcelRegister("4QvUx", function(module, exports) {
$parcel$export(module.exports, "SceneFactory", () => (parcelRequire("8P5Y9")).SceneFactory);
parcelRequire("jrmg8");
parcelRequire("8P5Y9");

});
parcelRegister("jrmg8", function(module, exports) {

});

parcelRegister("8P5Y9", function(module, exports) {

$parcel$export(module.exports, "SceneFactory", () => $8c1998f4c5af5302$export$4012b84193e1bb4d);
class $8c1998f4c5af5302$export$4012b84193e1bb4d {
    static Register(ctor) {
        $8c1998f4c5af5302$export$4012b84193e1bb4d._ctor = ctor;
    }
    static Create(canvas) {
        return new $8c1998f4c5af5302$export$4012b84193e1bb4d._ctor(canvas);
    }
}

});


parcelRegister("fhic1", function(module, exports) {
parcelRequire("4FeII");
var $52Ze3 = parcelRequire("52Ze3");

var $jW02B = parcelRequire("jW02B");

var $3ztn0 = parcelRequire("3ztn0");
parcelRequire("4QvUx");
var $8P5Y9 = parcelRequire("8P5Y9");
class $9e6a501ef5869680$export$21d36b0a75596519 extends HTMLElement {
    //#region Static methods
    static Register() {
        (0, $3ztn0.WebPlayerElement).Register();
        if (customElements.get($9e6a501ef5869680$export$21d36b0a75596519.elementName) === undefined) customElements.define($9e6a501ef5869680$export$21d36b0a75596519.elementName, $9e6a501ef5869680$export$21d36b0a75596519);
    }
    static{
        //#endregion
        //#region Consts
        this.elementName = "all-in-one-player";
    }
    static{
        this.observedAttributes = [
            ...(0, $3ztn0.WebPlayerElement).observedAttributes,
            "scenecolor",
            "zoomsensitivity",
            "touchmovexsensitivity",
            "touchmoveysensitivity",
            "zoommin",
            "zoommax",
            "touchzoommode",
            "requirereleaseafterzoom",
            "mousemovexsensitivity",
            "mousemoveysensitivity",
            "rotationxlimit",
            "rotationylimit",
            "currentzoom",
            "zoomstep",
            "mode",
            "masksrc",
            "projection",
            "hardcodedmask"
        ];
    }
    static{
        this.propertyPairs = [];
    }
    static{
        this._template = null;
    }
    static get template() {
        if (this._template !== null) return this._template;
        this._template = document.createElement("template");
        this._template.innerHTML = `
        <style id="all_in_one_player_style">        
            :host {
                display: block;
            }
            :host([hidden]) {
                display: none;
            }
            web-player, canvas {
                width: 100%;
                height: 100%;
            }
        </style>
        <web-player id="player" hidden></web-player>
        <canvas id="canvas"></canvas>`;
        return this._template;
    }
    get scene() {
        if (this._scene === null) this._scene = (0, $8P5Y9.SceneFactory).Create(this.canvas);
        return this._scene;
    }
    get observedAttributes() {
        return $9e6a501ef5869680$export$21d36b0a75596519.observedAttributes;
    }
    //#endregion
    //#region Public Properties
    get player() {
        if (this._player === null) this._player = this.shadowRoot.getElementById("player");
        return this._player;
    }
    get canvas() {
        if (this._canvas === null) this._canvas = this.shadowRoot.getElementById("canvas");
        return this._canvas;
    }
    get projectionMesh() {
        return this.scene.projectionMesh;
    }
    get engine() {
        return this.scene.engine;
    }
    /**
     * Gets the current player state.
     */ get state() {
        return this.player.state;
    }
    /**
     * Gets the current engine type. 
     */ get currentEngine() {
        return this.player.currentEngine;
    }
    /**
     * Gets the Internal id of the player instance.
     */ get playerId() {
        return this.player.playerId;
    }
    /**
     * Gets a TexImageSource that can be used for rendering the player in another renderer.
     */ get texture() {
        return this.player.texture;
    }
    /**
     * Gets the rendering width. It may differ from `videoWidth` if the device isn't capable of rendering the video at full resolution.
     */ get renderingWidth() {
        return this.player.renderingWidth;
    }
    /**
     * Gets the rendering height. It may differ from `videoHeight` if the device isn't capable of rendering the video at full resolution.
     */ get renderingHeight() {
        return this.player.renderingHeight;
    }
    /**
     * Gets the current stream type
     * [Proposal Reference](https://github.com/video-dev/media-ui-extensions/blob/main/proposals/0010-stream-type.md)
     */ get streamType() {
        return this.player.streamType;
    }
    /**
     * Gets the video tracks present in the stream.
     * [WHATWG Reference](https://html.spec.whatwg.org/multipage/media.html#media-resources-with-multiple-media-tracks)
     */ get videoTracks() {
        return this.player.videoTracks;
    }
    /**
     * Gets all registered engines.
     */ get allEngines() {
        return this.player.allEngines;
    }
    /**
     * Gets all registered engines, supported by the device.
     */ get supportedEngines() {
        return this.player.supportedEngines;
    }
    /**
     * Gets all enabled registered engines.
     */ get enabledEngines() {
        return this.player.enabledEngines;
    }
    /**
     * Gets all supported and enabled engines.
     */ get usedEngines() {
        return this.player.usedEngines;
    }
    get disablePictureInPicture() {
        return this.player.disablePictureInPicture;
    }
    set disablePictureInPicture(value) {
        if (value === this.disablePictureInPicture) return;
        this.setAttributeValue("disablePictureInPicture", value);
        this.player.disablePictureInPicture = value;
    }
    get height() {
        return this.player.height;
    }
    set height(value) {
        if (value === this.height) return;
        this.setAttributeValue("height", value);
        this.player.height = value;
    }
    get playsInline() {
        return this.player.playsInline;
    }
    set playsInline(value) {
        if (value === this.playsInline) return;
        this.setAttributeValue("playsInline", value);
        this.player.playsInline = value;
    }
    get poster() {
        return this.player.poster;
    }
    set poster(value) {
        if (value === this.poster) return;
        this.setAttributeValue("poster", value);
        this.player.poster = value;
    }
    get videoHeight() {
        return this.player.videoHeight;
    }
    get videoWidth() {
        return this.player.videoWidth;
    }
    get width() {
        return this.player.width;
    }
    set width(value) {
        if (value === this.width) return;
        this.setAttributeValue("width", value);
        this.player.width = value;
    }
    get autoplay() {
        return this.player.autoplay;
    }
    set autoplay(value) {
        if (value === this.autoplay) return;
        this.setAttributeValue("autoplay", value);
        this.player.autoplay = value;
    }
    get buffered() {
        return this.player.buffered;
    }
    get controls() {
        return this.player.controls;
    }
    set controls(value) {
        if (value === this.controls) return;
        this.setAttributeValue("controls", value);
        this.player.controls = value;
    }
    get crossOrigin() {
        return this.player.crossOrigin;
    }
    set crossOrigin(value) {
        if (value === this.crossOrigin) return;
        this.setAttributeValue("crossOrigin", value);
        this.player.crossOrigin = value;
    }
    get currentSrc() {
        return this.player.currentSrc;
    }
    get currentTime() {
        return this.player.currentTime;
    }
    set currentTime(value) {
        if (value === this.currentTime) return;
        this.setAttributeValue("currentTime", value);
        this.player.currentTime = value;
    }
    get defaultMuted() {
        return this.player.defaultMuted;
    }
    set defaultMuted(value) {
        if (value === this.defaultMuted) return;
        this.setAttributeValue("defaultMuted", value);
        this.player.defaultMuted = value;
    }
    get defaultPlaybackRate() {
        return this.player.defaultPlaybackRate;
    }
    set defaultPlaybackRate(value) {
        if (value === this.defaultPlaybackRate) return;
        this.setAttributeValue("defaultPlaybackRate", value);
        this.player.defaultPlaybackRate = value;
    }
    get disableRemotePlayback() {
        return this.player.disableRemotePlayback;
    }
    set disableRemotePlayback(value) {
        if (value === this.disableRemotePlayback) return;
        this.setAttributeValue("disableRemotePlayback", value);
        this.player.disableRemotePlayback = value;
    }
    get duration() {
        return this.player.duration;
    }
    get ended() {
        return this.player.ended;
    }
    get error() {
        return this.player.error;
    }
    get hardcodedMask() {
        return this._hardcodedMask;
    }
    set hardcodedMask(value) {
        if (this.hardcodedMask === value) return;
        this.setAttributeValue("hardcodedMask", value);
        this._hardcodedMask = value;
        this.updateMask();
    }
    get loop() {
        return this.player.loop;
    }
    set loop(value) {
        if (value === this.player.loop) return;
        this.setAttributeValue("loop", value);
        this.player.loop = value;
    }
    get maskSrc() {
        return this._maskSrc;
    }
    set maskSrc(value) {
        if (this._maskSrc === value) return;
        this.setAttributeValue("maskSrc", value);
        this._maskSrc = value;
        this.updateSrc(this._src, this._maskSrc);
    }
    get mediaKeys() {
        return this.player.mediaKeys;
    }
    get muted() {
        return this.player.muted;
    }
    set muted(value) {
        if (value === this.muted) return;
        this.setAttributeValue("muted", value);
        this.player.muted = value;
    }
    get networkState() {
        return this.player.networkState;
    }
    get paused() {
        return this.player.paused;
    }
    get playbackRate() {
        return this.player.playbackRate;
    }
    set playbackRate(value) {
        if (value === this.playbackRate) return;
        this.setAttributeValue("playbackRate", value);
        this.player.playbackRate = value;
    }
    get played() {
        return this.player.played;
    }
    get preload() {
        return this.player.preload;
    }
    set preload(value) {
        if (value === this.preload) return;
        this.setAttributeValue("preload", value);
        this.player.preload = value;
    }
    get preservesPitch() {
        return this.player.preservesPitch;
    }
    set preservesPitch(value) {
        if (value === this.preservesPitch) return;
        this.setAttributeValue("preservesPitch", value);
        this.player.preservesPitch = value;
    }
    get projection() {
        return this._projection;
    }
    set projection(value) {
        if (this.projection === value) return;
        this.setAttributeValue("projection", value);
        this._projection = value;
        this.updateProjectionMesh();
    }
    get readyState() {
        return this.player.readyState;
    }
    get remote() {
        return this.player.remote;
    }
    get seekable() {
        return this.player.seekable;
    }
    get seeking() {
        return this.player.seeking;
    }
    get sinkId() {
        return this.player.sinkId;
    }
    get src() {
        return this._src;
    }
    set src(value) {
        if (value === this.src) return;
        this.setAttributeValue("src", value);
        this._src = value;
        this.updateSrc(this._src, this._maskSrc);
    }
    get srcObject() {
        return this.player.srcObject;
    }
    set srcObject(value) {
        if (value === this.srcObject) return;
        this.player.srcObject = value;
    }
    get textTracks() {
        return this.player.textTracks;
    }
    get volume() {
        return this.player.volume;
    }
    set volume(value) {
        if (value === this.volume) return;
        this.setAttributeValue("volume", value);
        this.player.volume = value;
    }
    get lowLatency() {
        return this.player.lowLatency;
    }
    set lowLatency(value) {
        if (value === this.lowLatency) return;
        this.setAttributeValue("lowLatency", value);
        this.player.lowLatency = value;
    }
    get passthroughToken() {
        return this.player.passthroughToken;
    }
    set passthroughToken(value) {
        if (value === this.passthroughToken) return;
        this.setAttributeValue("passthroughToken", value);
        this.player.passthroughToken = value;
    }
    get includeMask() {
        return this._includeMask;
    }
    set includeMask(value) {
        if (value === this.includeMask) return;
        this.setAttributeValue("includeMask", value);
        this._includeMask = value;
        this.updateMask();
    }
    get enginesList() {
        return this.player.enginesList;
    }
    set enginesList(value) {
        if (value === this.enginesList) return;
        this.setAttributeValue("enginesList", value);
        this.player.enginesList = value;
    }
    get connectionTimeout() {
        return this.player.connectionTimeout;
    }
    set connectionTimeout(value) {
        if (value === this.connectionTimeout) return;
        this.setAttributeValue("connectionTimeout", value);
        this.player.connectionTimeout = value;
    }
    get externalRenderer() {
        return this.player.externalRenderer;
    }
    set externalRenderer(value) {
        if (value === this.externalRenderer) return;
        this.setAttributeValue("externalRenderer", value);
        this.player.externalRenderer = value;
    }
    get stallWindow() {
        return this.player.stallWindow;
    }
    set stallWindow(value) {
        if (value === this.stallWindow) return;
        this.setAttributeValue("stallWindow", value);
        this.player.stallWindow = value;
    }
    get maxStallEvents() {
        return this.player.maxStallEvents;
    }
    set maxStallEvents(value) {
        if (value === this.maxStallEvents) return;
        this.setAttributeValue("maxStallEvents", value);
        this.player.maxStallEvents = value;
    }
    get fmp4ProtocolVersion() {
        return this.player.fmp4ProtocolVersion;
    }
    set fmp4ProtocolVersion(value) {
        if (value === this.fmp4ProtocolVersion) return;
        this.setAttributeValue("fmp4ProtocolVersion", value);
        this.player.fmp4ProtocolVersion = value;
    }
    get sceneColor() {
        return this.scene.sceneColor;
    }
    set sceneColor(value) {
        if (this.sceneColor === value) return;
        this.setAttributeValue("sceneColor", value);
        this.scene.sceneColor = value;
    }
    get zoomSensitivity() {
        return this.scene.zoomSensitivity;
    }
    set zoomSensitivity(value) {
        if (this.zoomSensitivity === value) return;
        this.setAttributeValue("zoomSensitivity", value);
        this.scene.zoomSensitivity = value;
    }
    get touchMoveXSensitivity() {
        return this.scene.touchMoveXSensitivity;
    }
    set touchMoveXSensitivity(value) {
        if (this.touchMoveXSensitivity === value) return;
        this.setAttributeValue("touchMoveXSensitivity", value);
        this.scene.touchMoveXSensitivity = value;
    }
    get touchMoveYSensitivity() {
        return this.scene.touchMoveYSensitivity;
    }
    set touchMoveYSensitivity(value) {
        if (this.touchMoveYSensitivity === value) return;
        this.setAttributeValue("touchMoveYSensitivity", value);
        this.scene.touchMoveYSensitivity = value;
    }
    get zoomMin() {
        return this.scene.zoomMin;
    }
    set zoomMin(value) {
        if (this.zoomMin === value) return;
        this.setAttributeValue("zoomMin", value);
        this.scene.zoomMin = value;
    }
    get zoomMax() {
        return this.scene.zoomMax;
    }
    set zoomMax(value) {
        if (this.zoomMax === value) return;
        this.setAttributeValue("zoomMax", value);
        this.scene.zoomMax = value;
    }
    get touchZoomMode() {
        return this.scene.touchZoomMode;
    }
    set touchZoomMode(value) {
        if (this.touchZoomMode === value) return;
        this.setAttributeValue("touchZoomMode", value);
        this.scene.touchZoomMode = value;
    }
    get requireReleaseAfterZoom() {
        return this.scene.requireReleaseAfterZoom;
    }
    set requireReleaseAfterZoom(value) {
        if (this.requireReleaseAfterZoom === value) return;
        this.setAttributeValue("requireReleaseAfterZoom", value);
        this.scene.requireReleaseAfterZoom = value;
    }
    get mouseMoveXSensitivity() {
        return this.scene.mouseMoveXSensitivity;
    }
    set mouseMoveXSensitivity(value) {
        if (this.mouseMoveXSensitivity === value) return;
        this.setAttributeValue("mouseMoveXSensitivity", value);
        this.scene.mouseMoveXSensitivity = value;
    }
    get mouseMoveYSensitivity() {
        return this.scene.mouseMoveYSensitivity;
    }
    set mouseMoveYSensitivity(value) {
        if (this.mouseMoveYSensitivity === value) return;
        this.setAttributeValue("mouseMoveYSensitivity", value);
        this.scene.mouseMoveYSensitivity = value;
    }
    get rotationXLimit() {
        return this.scene.rotationXLimit;
    }
    set rotationXLimit(value) {
        if (this.rotationXLimit === value) return;
        this.setAttributeValue("rotationXLimit", value);
        this.scene.rotationXLimit = value;
    }
    get rotationYLimit() {
        return this.scene.rotationYLimit;
    }
    set rotationYLimit(value) {
        if (this.rotationYLimit === value) return;
        this.setAttributeValue("rotationYLimit", value);
        this.scene.rotationYLimit = value;
    }
    get currentZoom() {
        return this.scene.currentZoom;
    }
    set currentZoom(value) {
        if (this.currentZoom === value) return;
        this.setAttributeValue("currentZoom", value);
        this.scene.currentZoom = value;
    }
    get zoomStep() {
        return this._zoomStep;
    }
    set zoomStep(value) {
        if (this.zoomStep === value) return;
        this.setAttributeValue("zoomStep", value);
        this._zoomStep = value;
    }
    get mode() {
        return this._mode;
    }
    set mode(value) {
        if (!value) value = "auto";
        if (this.mode === value) return;
        this.setAttributeValue("mode", value);
        this._mode = value;
        this.updateDisplay(value);
    }
    get onstatechanged() {
        return this.player.onstatechanged;
    }
    set onstatechanged(value) {
        if (value === this.player.onstatechanged) return;
        this.player.onstatechanged = value;
    }
    get onwarning() {
        return this.player.onwarning;
    }
    set onwarning(value) {
        if (value === this.player.onwarning) return;
        this.player.onwarning = value;
    }
    get onpositionchanged() {
        return this.player.onpositionchanged;
    }
    set onpositionchanged(value) {
        if (value === this.player.onpositionchanged) return;
        this.player.onpositionchanged = value;
    }
    get onframeready() {
        return this.player.onframeready;
    }
    set onframeready(value) {
        if (value === this.player.onframeready) return;
        this.player.onframeready = value;
    }
    get oninvalidpassthroughtoken() {
        return this.player.oninvalidpassthroughtoken;
    }
    set oninvalidpassthroughtoken(value) {
        if (value === this.player.oninvalidpassthroughtoken) return;
        this.player.oninvalidpassthroughtoken = value;
    }
    get onmaskdecodingerror() {
        return this.player.onmaskdecodingerror;
    }
    set onmaskdecodingerror(value) {
        if (value === this.player.onmaskdecodingerror) return;
        this.player.onmaskdecodingerror = value;
    }
    get onstreamtypechange() {
        return this.player.onstreamtypechange;
    }
    set onstreamtypechange(value) {
        if (value === this.player.onstreamtypechange) return;
        this.player.onstreamtypechange = value;
    }
    get onaddvideotrack() {
        return this.player.onaddvideotrack;
    }
    set onaddvideotrack(value) {
        if (value === this.player.onaddvideotrack) return;
        this.player.onaddvideotrack = value;
    }
    get onremovevideotrack() {
        return this.player.onremovevideotrack;
    }
    set onremovevideotrack(value) {
        if (value === this.player.onremovevideotrack) return;
        this.player.onremovevideotrack = value;
    }
    get onvideotrackchange() {
        return this.player.onvideotrackchange;
    }
    set onvideotrackchange(value) {
        if (value === this.player.onvideotrackchange) return;
        this.player.onvideotrackchange = value;
    }
    get onengineschange() {
        return this.player.onengineschange;
    }
    set onengineschange(value) {
        if (value === this.player.onengineschange) return;
        this.player.onengineschange = value;
    }
    get onenterpictureinpicture() {
        return this.player.onenterpictureinpicture;
    }
    set onenterpictureinpicture(value) {
        if (value === this.player.onenterpictureinpicture) return;
        this.player.onenterpictureinpicture = value;
    }
    get onleavepictureinpicture() {
        return this.player.onleavepictureinpicture;
    }
    set onleavepictureinpicture(value) {
        if (value === this.player.onleavepictureinpicture) return;
        this.player.onleavepictureinpicture = value;
    }
    get onencrypted() {
        return this.player.onencrypted;
    }
    set onencrypted(value) {
        if (value === this.player.onencrypted) return;
        this.player.onencrypted = value;
    }
    get onwaitingforkey() {
        return this.player.onwaitingforkey;
    }
    set onwaitingforkey(value) {
        if (value === this.player.onwaitingforkey) return;
        this.player.onwaitingforkey = value;
    }
    //#endregion
    //#region Constructor
    constructor(){
        super(), this.NETWORK_EMPTY = 0, this.NETWORK_IDLE = 1, this.NETWORK_LOADING = 2, this.NETWORK_NO_SOURCE = 3, this.HAVE_NOTHING = 0, this.HAVE_METADATA = 1, this.HAVE_CURRENT_DATA = 2, this.HAVE_FUTURE_DATA = 3, this.HAVE_ENOUGH_DATA = 4, //#endregion
        //#region Private Fields
        this._player = null, this._canvas = null, this._scene = null, this._mutationObserver = null, this._zoomStep = 1, this._mode = "auto", this._src = "", this._maskSrc = "", this._projection = "", this._includeMask = false, this._hardcodedMask = false;
        this.attachShadow({
            mode: "open"
        });
        $9e6a501ef5869680$export$21d36b0a75596519.Register();
        this.shadowRoot?.appendChild($9e6a501ef5869680$export$21d36b0a75596519.template.content.cloneNode(true));
        if (customElements.get("web-player") !== undefined) this.upgrade();
        else customElements.whenDefined("web-player").then(()=>this.upgrade());
        this._mutationObserver = new MutationObserver((m)=>{
            m.forEach((r)=>{
                if (r.type === "attributes" && r.target === this.player) {
                    if (r.attributeName !== null && this.observedAttributes.includes(r.attributeName.toLowerCase())) {
                        if (r.attributeName === "src") {
                            const value = this.player.getAttribute(r.attributeName);
                            if (value && value.startsWith("mask://")) {
                                const parts = value.substring(7).split('+');
                                this.setAttribute("src", decodeURIComponent(parts[0]));
                                this.setAttribute("masksrc", decodeURIComponent(parts[1]));
                            } else this.updateAttribute(r.attributeName);
                            return;
                        } else if (r.attributeName === "includemask" && this.hardcodedMask) {
                            const value = this.player.getAttribute(r.attributeName) ?? false;
                            const ownValue = this.includeMask;
                            if (ownValue !== value) return;
                        }
                        this.updateAttribute(r.attributeName);
                    }
                }
            });
        });
        this._mutationObserver.observe(this.player, {
            attributes: true
        });
        this.canvas.addEventListener('wheel', (event)=>{
            const delta = Math.sign(event.deltaY) * this.zoomStep;
            if (this.currentZoom + delta <= this.zoomMax && this.currentZoom + delta >= this.zoomMin) {
                this.scene.zoom(delta / this.zoomSensitivity);
                this.currentZoom += delta;
            }
            event.preventDefault();
        }, false);
    }
    connectedCallback() {
        (0, $jW02B.LogInternal).info(`[${this.tagName}] Custom element added to page.`);
        this.upgradeProperty("mode");
        this.upgradeProperty("src");
        this.upgradeProperty("maskSrc");
        this.upgradeProperty("autoplay");
        this.upgradeProperty("controls");
        this.upgradeProperty("lowLatency");
        this.upgradeProperty("muted");
        this.upgradeProperty("volume");
        this.upgradeProperty("loop");
        this.upgradeProperty("width");
        this.upgradeProperty("height");
        this.upgradeProperty("disablePictureInPicture");
        this.upgradeProperty("passthroughToken");
        this.upgradeProperty("includeMask");
        this.upgradeProperty("enginesList");
        this.upgradeProperty("hardcodedMask");
        this.upgradeProperty("connectionTimeout");
        this.upgradeProperty("poster");
        this.upgradeProperty("crossOrigin");
        this.upgradeProperty("externalRenderer");
        this.upgradeProperty("stallWindow");
        this.upgradeProperty("maxStallEvents");
        this.upgradeProperty("fmp4ProtocolVersion");
        this.upgradeProperty("zoomMax");
        this.upgradeProperty("zoomMin");
        this.upgradeProperty("zoomSensitivity");
        this.upgradeProperty("zoomStep");
        this.upgradeProperty("touchZoomMode");
        this.upgradeProperty("currentZoom");
        this.upgradeProperty("requireReleaseAfterZoom");
        this.upgradeProperty("sceneColor");
        this.upgradeProperty("mouseMoveXSensitivity");
        this.upgradeProperty("mouseMoveYSensitivity");
        this.upgradeProperty("touchMoveXSensitivity");
        this.upgradeProperty("touchMoveYSensitivity");
        this.upgradeProperty("rotationXLimit");
        this.upgradeProperty("rotationYLimit");
        this.upgradeProperty("projection");
        this.upgradeProperty("onstatechanged");
        this.upgradeProperty("onwarning");
        this.upgradeProperty("onpositionchanged");
        this.upgradeProperty("onerror");
        this.upgradeProperty("onframeready");
        this.upgradeProperty("oninvalidpassthroughtoken");
        this.upgradeProperty("onmaskdecodingerror");
        this.upgradeProperty("ondurationchange");
        this.upgradeProperty("onstreamtypechange");
        this.upgradeProperty("onended");
        this.upgradeProperty("onaddvideotrack");
        this.upgradeProperty("onremovevideotrack");
        this.upgradeProperty("onvideotrackchange");
        this.upgradeProperty("onenterpictureinpicture");
        this.upgradeProperty("onleavepictureinpicture");
        this.upgradeProperty("onengineschange");
        this.projectionMesh.SetTexture(this.player);
        this.player.addEventListener("playing", ()=>this.projectionMesh.SetTexture(this.player));
    }
    disconnectedCallback() {
        (0, $jW02B.LogInternal).info(`[${this.tagName}] Custom element removed from page.`);
    }
    adoptedCallback() {
        (0, $jW02B.LogInternal).info(`[${this.tagName}] Custom element moved to new page.`);
    }
    //#endregion
    //#region Public Methods
    cancelVideoFrameCallback(handle) {
        this.player.cancelVideoFrameCallback(handle);
    }
    getVideoPlaybackQuality() {
        return this.player.getVideoPlaybackQuality();
    }
    async requestPictureInPicture() {
        return await this.player.requestPictureInPicture();
    }
    requestVideoFrameCallback(callback) {
        return this.player.requestVideoFrameCallback(callback);
    }
    addTextTrack(kind, label, language) {
        return this.player.addTextTrack(kind, label, language);
    }
    canPlayType(type) {
        return this.player.canPlayType(type);
    }
    async fastSeek(time) {
        await this.player.fastSeek(time);
    }
    async load() {
        await this.player.load();
    }
    async pause() {
        await this.player.pause();
    }
    async play() {
        await this.player.play();
        this.updateProjectionMesh();
    }
    async stop() {
        await this.player.stop();
    }
    async togglePause() {
        await this.player.togglePause();
    }
    async seek(time) {
        await this.player.seek(time);
    }
    exitPictureInPicture() {
        this.player.exitPictureInPicture();
    }
    async setSinkId(sinkId) {
        await this.player.setSinkId(sinkId);
    }
    render() {
        this.player.render();
    }
    async setMediaKeys(mediaKeys) {
        this.player.setMediaKeys(mediaKeys);
    }
    captureStream() {
        return this.player.captureStream();
    }
    //#endregion
    //#region Private Methods
    updateSrc(src, maskSrc) {
        if (!maskSrc) this.player.src = src;
        else this.player.src = `mask://${encodeURIComponent(src)}+${encodeURIComponent(maskSrc)}`;
    }
    updateProjectionMesh() {
        this.projectionMesh.Projection = (0, $52Ze3.Projection).FromString(!!this.projection ? this.projection : this.src);
        this.updateDisplay(this.mode);
    }
    updateMask() {
        this.player.includeMask = this.includeMask && !this.hardcodedMask;
        this.projectionMesh.MaskDeo = this.hardcodedMask && this.includeMask;
    }
    updateDisplay(mode) {
        switch(mode){
            case "2d":
                this.canvas.hidden = true;
                break;
            case "3d":
                this.canvas.hidden = false;
                break;
            case "auto":
                this.canvas.hidden = this.projectionMesh.Projection.MeshType === (0, $52Ze3.MeshType).Flat;
                break;
        }
        this.player.hidden = !this.canvas.hidden;
    }
    updateAttribute(name) {
        const ownAttr = this.getAttribute(name);
        const childAttr = this.player.getAttribute(name);
        if (ownAttr !== childAttr) {
            if (childAttr !== null) this.setAttribute(name, childAttr);
            else this.removeAttribute(name);
        }
    }
    //#endregion
    //#region Helper Functions
    setAttributeValue(name, value) {
        const lowercase = name.toLowerCase();
        if (!this.observedAttributes.includes(lowercase)) return;
        if (value === null && this.getAttribute(lowercase) !== null) this.removeAttribute(lowercase);
        else if (typeof value === "object" && value instanceof (0, $3ztn0.DOMTokenListLike)) this.setAttribute(lowercase, value.value);
        else if (typeof value === "object" && Array.isArray(value)) {
            const join = value.length > 0 ? value.join(' ') : "";
            if (this.getAttribute(lowercase) !== join) this.setAttribute(lowercase, join);
        } else if (typeof value === "string" && this.getAttribute(lowercase) !== value) {
            if (value !== "") this.setAttribute(lowercase, value);
            else this.removeAttribute(lowercase);
        } else if (typeof value === "number" && this.getAttribute(lowercase) !== value.toString()) this.setAttribute(lowercase, value.toString());
        else if (typeof value === "boolean" && value && this.getAttribute(lowercase) === null) this.setAttribute(lowercase, "");
        else if (typeof value === "boolean" && !value && this.getAttribute(lowercase) !== null) this.removeAttribute(lowercase);
    }
    static setPropertyValue(obj, name) {
        const value = obj.getAttribute(name);
        if (value === null) return;
        const currentValue = obj[name];
        if (typeof currentValue === "string") obj[name] = value;
        else if (typeof currentValue === "number") obj[name] = Number.parseFloat(value);
        else if (typeof currentValue === "boolean") obj[name] = value !== null;
        else if (typeof currentValue === "object" && currentValue instanceof (0, $3ztn0.DOMTokenListLike)) currentValue.setValue(value);
        else if (typeof currentValue === "object" && Array.isArray(currentValue)) obj[name] = value.includes(' ') ? value.split(' ') : [
            value
        ];
    }
    static upgradeProperty(obj, prop) {
        $9e6a501ef5869680$export$21d36b0a75596519.propertyPairs.push({
            property: prop,
            attribute: prop.toLowerCase()
        });
        if (obj.hasOwnProperty(prop)) {
            const value = obj[prop];
            delete obj[prop];
            obj[prop] = value;
        } else if (prop in obj) $9e6a501ef5869680$export$21d36b0a75596519.setPropertyValue(obj, prop);
    }
    upgradeProperty(prop) {
        $9e6a501ef5869680$export$21d36b0a75596519.upgradeProperty(this, prop);
    }
    attributeChangedCallback(name, oldValue, newValue) {
        const propName = $9e6a501ef5869680$export$21d36b0a75596519.propertyPairs.find((p)=>p.attribute === name)?.property ?? "";
        const propertyValue = JSON.stringify(this[propName]);
        if (propName in this) {
            if (typeof this[propName] === typeof newValue) this[propName] = newValue;
            else if (typeof this[propName] === "number" && typeof newValue === "string") this[propName] = Number.parseFloat(newValue);
            else if (typeof this[propName] === "number" && newValue === null) this[propName] = 0;
            else if (typeof this[propName] === "boolean" && newValue === null) this[propName] = false;
            else if (typeof this[propName] === "string" && newValue === null) this[propName] = "";
            else if (typeof this[propName] === "boolean" && typeof newValue === "string") this[propName] = true;
            else if (typeof this[propName] === "object" && Array.isArray(this[propName]) && typeof newValue === "string") this[propName] = newValue.split(' ');
            else if (typeof this[propName] === "object" && Array.isArray(this[propName]) && newValue === null) this[propName] = [];
            else if (typeof this[propName] === "object" && this[propName] instanceof (0, $3ztn0.DOMTokenListLike) && typeof newValue === "string") this[propName].setValue(newValue);
            else typeof this[propName] === "object" && this[propName];
        }
        (0, $jW02B.LogInternal).debug(`[${this.tagName}] Attribute '${name}' (property: '${propName}') changed, old value: ${oldValue}, new value: ${newValue}, old property value: ${propertyValue}, new property value: ${JSON.stringify(this[propName])}`);
    }
    upgrade() {
        if (customElements && customElements.upgrade) customElements.upgrade(this.player);
    }
}
//#region Registration
$9e6a501ef5869680$export$21d36b0a75596519.Register();
 //#endregion

});


parcelRegister("cKy8N", function(module, exports) {
module.exports = import("f8SVh").then(()=>parcelRequire('4Gxcj'));

});



parcelRequire("6gsYs");

//# sourceMappingURL=Demo.34be4126.js.map
